(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire136b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire136b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bhfvP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $835d50b1b0b1438e$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $835d50b1b0b1438e$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $835d50b1b0b1438e$export$25062201e9e25d76; });

var $3pI8R = parcelRequire("3pI8R");

var $8kMfp = parcelRequire("8kMfp");
parcelRequire("eZVvM");
parcelRequire("hUOrI");
parcelRequire("65o8X");
parcelRequire("c2U8l");

parcelRequire("28Dco");
parcelRequire("geJaG");
parcelRequire("2mRmw");
parcelRequire("8JgfY");
var $835d50b1b0b1438e$export$ffb0004e005737fa = $3pI8R.Fragment;
function $835d50b1b0b1438e$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $8kMfp.h).call(props, "css")) return $3pI8R.jsx(type, props, key);
    return $3pI8R.jsx((0, $8kMfp.E), (0, $8kMfp.c)(type, props), key);
}
function $835d50b1b0b1438e$export$25062201e9e25d76(type, props, key) {
    if (!(0, $8kMfp.h).call(props, "css")) return $3pI8R.jsxs(type, props, key);
    return $3pI8R.jsxs((0, $8kMfp.E), (0, $8kMfp.c)(type, props), key);
}

});
parcelRegister("3pI8R", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8V93A"));

});
parcelRegister("8V93A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $67eaac1ef0310ec9$export$ffb0004e005737fa; }, function (v) { return $67eaac1ef0310ec9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $67eaac1ef0310ec9$export$34b9dba7ce09269b; }, function (v) { return $67eaac1ef0310ec9$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $67eaac1ef0310ec9$export$25062201e9e25d76; }, function (v) { return $67eaac1ef0310ec9$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67eaac1ef0310ec9$export$ffb0004e005737fa;
var $67eaac1ef0310ec9$export$34b9dba7ce09269b;
var $67eaac1ef0310ec9$export$25062201e9e25d76;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
var $67eaac1ef0310ec9$var$k = Symbol.for("react.element"), $67eaac1ef0310ec9$var$l = Symbol.for("react.fragment"), $67eaac1ef0310ec9$var$m = Object.prototype.hasOwnProperty, $67eaac1ef0310ec9$var$n = $eZVvM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $67eaac1ef0310ec9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $67eaac1ef0310ec9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$67eaac1ef0310ec9$var$m.call(a, b) && !$67eaac1ef0310ec9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $67eaac1ef0310ec9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $67eaac1ef0310ec9$var$n.current
    };
}
$67eaac1ef0310ec9$export$ffb0004e005737fa = $67eaac1ef0310ec9$var$l;
$67eaac1ef0310ec9$export$34b9dba7ce09269b = $67eaac1ef0310ec9$var$q;
$67eaac1ef0310ec9$export$25062201e9e25d76 = $67eaac1ef0310ec9$var$q;

});
parcelRegister("eZVvM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4hPUh"));

});
parcelRegister("4hPUh", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $31f1038d8b9efe40$export$dca3b0875bd9a954; }, function (v) { return $31f1038d8b9efe40$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $31f1038d8b9efe40$export$16fa2f45be04daa8; }, function (v) { return $31f1038d8b9efe40$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $31f1038d8b9efe40$export$ffb0004e005737fa; }, function (v) { return $31f1038d8b9efe40$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $31f1038d8b9efe40$export$e2c29f18771995cb; }, function (v) { return $31f1038d8b9efe40$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $31f1038d8b9efe40$export$221d75b3f55bb0bd; }, function (v) { return $31f1038d8b9efe40$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $31f1038d8b9efe40$export$5f8d39834fd61797; }, function (v) { return $31f1038d8b9efe40$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $31f1038d8b9efe40$export$74bf444e3cd11ea5; }, function (v) { return $31f1038d8b9efe40$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $31f1038d8b9efe40$export$ae55be85d98224ed; }, function (v) { return $31f1038d8b9efe40$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $31f1038d8b9efe40$export$3ba232387fd5d6dd; }, function (v) { return $31f1038d8b9efe40$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $31f1038d8b9efe40$export$e530037191fcd5d7; }, function (v) { return $31f1038d8b9efe40$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $31f1038d8b9efe40$export$fd42f52fd3ae1109; }, function (v) { return $31f1038d8b9efe40$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $31f1038d8b9efe40$export$c8a8987d4410bf2d; }, function (v) { return $31f1038d8b9efe40$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $31f1038d8b9efe40$export$d38cd72104c1f0e9; }, function (v) { return $31f1038d8b9efe40$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $31f1038d8b9efe40$export$7d1e3a5e95ceca43; }, function (v) { return $31f1038d8b9efe40$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $31f1038d8b9efe40$export$257a8862b851cb5b; }, function (v) { return $31f1038d8b9efe40$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $31f1038d8b9efe40$export$a8257692ac88316c; }, function (v) { return $31f1038d8b9efe40$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $31f1038d8b9efe40$export$488013bae63b21da; }, function (v) { return $31f1038d8b9efe40$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $31f1038d8b9efe40$export$7c73462e0d25e514; }, function (v) { return $31f1038d8b9efe40$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $31f1038d8b9efe40$export$7568632d0d33d16d; }, function (v) { return $31f1038d8b9efe40$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $31f1038d8b9efe40$export$88948ce120ea2619; }, function (v) { return $31f1038d8b9efe40$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $31f1038d8b9efe40$export$35808ee640e87ca7; }, function (v) { return $31f1038d8b9efe40$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $31f1038d8b9efe40$export$fae74005e78b1a27; }, function (v) { return $31f1038d8b9efe40$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $31f1038d8b9efe40$export$dc8fbce3eb94dc1e; }, function (v) { return $31f1038d8b9efe40$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $31f1038d8b9efe40$export$6a7bc4e911dc01cf; }, function (v) { return $31f1038d8b9efe40$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $31f1038d8b9efe40$export$6d9c69b0de29b591; }, function (v) { return $31f1038d8b9efe40$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $31f1038d8b9efe40$export$f680877a34711e37; }, function (v) { return $31f1038d8b9efe40$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $31f1038d8b9efe40$export$d5a552a76deda3c2; }, function (v) { return $31f1038d8b9efe40$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $31f1038d8b9efe40$export$aaabe4eda9ed9969; }, function (v) { return $31f1038d8b9efe40$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $31f1038d8b9efe40$export$e5c5a5f917a5871c; }, function (v) { return $31f1038d8b9efe40$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $31f1038d8b9efe40$export$1538c33de8887b59; }, function (v) { return $31f1038d8b9efe40$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $31f1038d8b9efe40$export$13e3392192263954; }, function (v) { return $31f1038d8b9efe40$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $31f1038d8b9efe40$export$b8f5890fc79d6aca; }, function (v) { return $31f1038d8b9efe40$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $31f1038d8b9efe40$export$60241385465d0a34; }, function (v) { return $31f1038d8b9efe40$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $31f1038d8b9efe40$export$306c0aa65ff9ec16; }, function (v) { return $31f1038d8b9efe40$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $31f1038d8b9efe40$export$7b286972b8d8ccbf; }, function (v) { return $31f1038d8b9efe40$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $31f1038d8b9efe40$export$83d89fbfd8236492; }, function (v) { return $31f1038d8b9efe40$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $31f1038d8b9efe40$export$dca3b0875bd9a954;
var $31f1038d8b9efe40$export$16fa2f45be04daa8;
var $31f1038d8b9efe40$export$ffb0004e005737fa;
var $31f1038d8b9efe40$export$e2c29f18771995cb;
var $31f1038d8b9efe40$export$221d75b3f55bb0bd;
var $31f1038d8b9efe40$export$5f8d39834fd61797;
var $31f1038d8b9efe40$export$74bf444e3cd11ea5;
var $31f1038d8b9efe40$export$ae55be85d98224ed;
var $31f1038d8b9efe40$export$3ba232387fd5d6dd;
var $31f1038d8b9efe40$export$e530037191fcd5d7;
var $31f1038d8b9efe40$export$fd42f52fd3ae1109;
var $31f1038d8b9efe40$export$c8a8987d4410bf2d;
var $31f1038d8b9efe40$export$d38cd72104c1f0e9;
var $31f1038d8b9efe40$export$7d1e3a5e95ceca43;
var $31f1038d8b9efe40$export$257a8862b851cb5b;
var $31f1038d8b9efe40$export$a8257692ac88316c;
var $31f1038d8b9efe40$export$488013bae63b21da;
var $31f1038d8b9efe40$export$7c73462e0d25e514;
var $31f1038d8b9efe40$export$7568632d0d33d16d;
var $31f1038d8b9efe40$export$88948ce120ea2619;
var $31f1038d8b9efe40$export$35808ee640e87ca7;
var $31f1038d8b9efe40$export$fae74005e78b1a27;
var $31f1038d8b9efe40$export$dc8fbce3eb94dc1e;
var $31f1038d8b9efe40$export$6a7bc4e911dc01cf;
var $31f1038d8b9efe40$export$6d9c69b0de29b591;
var $31f1038d8b9efe40$export$f680877a34711e37;
var $31f1038d8b9efe40$export$d5a552a76deda3c2;
var $31f1038d8b9efe40$export$aaabe4eda9ed9969;
var $31f1038d8b9efe40$export$e5c5a5f917a5871c;
var $31f1038d8b9efe40$export$1538c33de8887b59;
var $31f1038d8b9efe40$export$13e3392192263954;
var $31f1038d8b9efe40$export$b8f5890fc79d6aca;
var $31f1038d8b9efe40$export$60241385465d0a34;
var $31f1038d8b9efe40$export$306c0aa65ff9ec16;
var $31f1038d8b9efe40$export$7b286972b8d8ccbf;
var $31f1038d8b9efe40$export$83d89fbfd8236492;
"use strict";
var $31f1038d8b9efe40$var$l = Symbol.for("react.element"), $31f1038d8b9efe40$var$n = Symbol.for("react.portal"), $31f1038d8b9efe40$var$p = Symbol.for("react.fragment"), $31f1038d8b9efe40$var$q = Symbol.for("react.strict_mode"), $31f1038d8b9efe40$var$r = Symbol.for("react.profiler"), $31f1038d8b9efe40$var$t = Symbol.for("react.provider"), $31f1038d8b9efe40$var$u = Symbol.for("react.context"), $31f1038d8b9efe40$var$v = Symbol.for("react.forward_ref"), $31f1038d8b9efe40$var$w = Symbol.for("react.suspense"), $31f1038d8b9efe40$var$x = Symbol.for("react.memo"), $31f1038d8b9efe40$var$y = Symbol.for("react.lazy"), $31f1038d8b9efe40$var$z = Symbol.iterator;
function $31f1038d8b9efe40$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $31f1038d8b9efe40$var$z && a[$31f1038d8b9efe40$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $31f1038d8b9efe40$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $31f1038d8b9efe40$var$C = Object.assign, $31f1038d8b9efe40$var$D = {};
function $31f1038d8b9efe40$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $31f1038d8b9efe40$var$D;
    this.updater = e || $31f1038d8b9efe40$var$B;
}
$31f1038d8b9efe40$var$E.prototype.isReactComponent = {};
$31f1038d8b9efe40$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$31f1038d8b9efe40$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $31f1038d8b9efe40$var$F() {}
$31f1038d8b9efe40$var$F.prototype = $31f1038d8b9efe40$var$E.prototype;
function $31f1038d8b9efe40$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $31f1038d8b9efe40$var$D;
    this.updater = e || $31f1038d8b9efe40$var$B;
}
var $31f1038d8b9efe40$var$H = $31f1038d8b9efe40$var$G.prototype = new $31f1038d8b9efe40$var$F;
$31f1038d8b9efe40$var$H.constructor = $31f1038d8b9efe40$var$G;
$31f1038d8b9efe40$var$C($31f1038d8b9efe40$var$H, $31f1038d8b9efe40$var$E.prototype);
$31f1038d8b9efe40$var$H.isPureReactComponent = !0;
var $31f1038d8b9efe40$var$I = Array.isArray, $31f1038d8b9efe40$var$J = Object.prototype.hasOwnProperty, $31f1038d8b9efe40$var$K = {
    current: null
}, $31f1038d8b9efe40$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $31f1038d8b9efe40$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$31f1038d8b9efe40$var$J.call(b, d) && !$31f1038d8b9efe40$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $31f1038d8b9efe40$var$K.current
    };
}
function $31f1038d8b9efe40$var$N(a, b) {
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $31f1038d8b9efe40$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $31f1038d8b9efe40$var$l;
}
function $31f1038d8b9efe40$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $31f1038d8b9efe40$var$P = /\/+/g;
function $31f1038d8b9efe40$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $31f1038d8b9efe40$var$escape("" + a.key) : b.toString(36);
}
function $31f1038d8b9efe40$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $31f1038d8b9efe40$var$l:
                case $31f1038d8b9efe40$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $31f1038d8b9efe40$var$Q(h, 0) : d, $31f1038d8b9efe40$var$I(c) ? (e = "", null != a && (e = a.replace($31f1038d8b9efe40$var$P, "$&/") + "/"), $31f1038d8b9efe40$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($31f1038d8b9efe40$var$O(c) && (c = $31f1038d8b9efe40$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($31f1038d8b9efe40$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($31f1038d8b9efe40$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $31f1038d8b9efe40$var$Q(k, g);
        h += $31f1038d8b9efe40$var$R(k, b, e, f, c);
    }
    else if (f = $31f1038d8b9efe40$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $31f1038d8b9efe40$var$Q(k, g++), h += $31f1038d8b9efe40$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $31f1038d8b9efe40$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $31f1038d8b9efe40$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $31f1038d8b9efe40$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $31f1038d8b9efe40$var$U = {
    current: null
}, $31f1038d8b9efe40$var$V = {
    transition: null
}, $31f1038d8b9efe40$var$W = {
    ReactCurrentDispatcher: $31f1038d8b9efe40$var$U,
    ReactCurrentBatchConfig: $31f1038d8b9efe40$var$V,
    ReactCurrentOwner: $31f1038d8b9efe40$var$K
};
function $31f1038d8b9efe40$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$31f1038d8b9efe40$export$dca3b0875bd9a954 = {
    map: $31f1038d8b9efe40$var$S,
    forEach: function(a, b, e) {
        $31f1038d8b9efe40$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $31f1038d8b9efe40$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $31f1038d8b9efe40$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$31f1038d8b9efe40$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$31f1038d8b9efe40$export$16fa2f45be04daa8 = $31f1038d8b9efe40$var$E;
$31f1038d8b9efe40$export$ffb0004e005737fa = $31f1038d8b9efe40$var$p;
$31f1038d8b9efe40$export$e2c29f18771995cb = $31f1038d8b9efe40$var$r;
$31f1038d8b9efe40$export$221d75b3f55bb0bd = $31f1038d8b9efe40$var$G;
$31f1038d8b9efe40$export$5f8d39834fd61797 = $31f1038d8b9efe40$var$q;
$31f1038d8b9efe40$export$74bf444e3cd11ea5 = $31f1038d8b9efe40$var$w;
$31f1038d8b9efe40$export$ae55be85d98224ed = $31f1038d8b9efe40$var$W;
$31f1038d8b9efe40$export$3ba232387fd5d6dd = $31f1038d8b9efe40$var$X;
$31f1038d8b9efe40$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $31f1038d8b9efe40$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $31f1038d8b9efe40$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$31f1038d8b9efe40$var$J.call(b, f) && !$31f1038d8b9efe40$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $31f1038d8b9efe40$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$31f1038d8b9efe40$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $31f1038d8b9efe40$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $31f1038d8b9efe40$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$31f1038d8b9efe40$export$c8a8987d4410bf2d = $31f1038d8b9efe40$var$M;
$31f1038d8b9efe40$export$d38cd72104c1f0e9 = function(a) {
    var b = $31f1038d8b9efe40$var$M.bind(null, a);
    b.type = a;
    return b;
};
$31f1038d8b9efe40$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$31f1038d8b9efe40$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $31f1038d8b9efe40$var$v,
        render: a
    };
};
$31f1038d8b9efe40$export$a8257692ac88316c = $31f1038d8b9efe40$var$O;
$31f1038d8b9efe40$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $31f1038d8b9efe40$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $31f1038d8b9efe40$var$T
    };
};
$31f1038d8b9efe40$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $31f1038d8b9efe40$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$31f1038d8b9efe40$export$7568632d0d33d16d = function(a) {
    var b = $31f1038d8b9efe40$var$V.transition;
    $31f1038d8b9efe40$var$V.transition = {};
    try {
        a();
    } finally{
        $31f1038d8b9efe40$var$V.transition = b;
    }
};
$31f1038d8b9efe40$export$88948ce120ea2619 = $31f1038d8b9efe40$var$X;
$31f1038d8b9efe40$export$35808ee640e87ca7 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useCallback(a, b);
};
$31f1038d8b9efe40$export$fae74005e78b1a27 = function(a) {
    return $31f1038d8b9efe40$var$U.current.useContext(a);
};
$31f1038d8b9efe40$export$dc8fbce3eb94dc1e = function() {};
$31f1038d8b9efe40$export$6a7bc4e911dc01cf = function(a) {
    return $31f1038d8b9efe40$var$U.current.useDeferredValue(a);
};
$31f1038d8b9efe40$export$6d9c69b0de29b591 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useEffect(a, b);
};
$31f1038d8b9efe40$export$f680877a34711e37 = function() {
    return $31f1038d8b9efe40$var$U.current.useId();
};
$31f1038d8b9efe40$export$d5a552a76deda3c2 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useImperativeHandle(a, b, e);
};
$31f1038d8b9efe40$export$aaabe4eda9ed9969 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useInsertionEffect(a, b);
};
$31f1038d8b9efe40$export$e5c5a5f917a5871c = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useLayoutEffect(a, b);
};
$31f1038d8b9efe40$export$1538c33de8887b59 = function(a, b) {
    return $31f1038d8b9efe40$var$U.current.useMemo(a, b);
};
$31f1038d8b9efe40$export$13e3392192263954 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useReducer(a, b, e);
};
$31f1038d8b9efe40$export$b8f5890fc79d6aca = function(a) {
    return $31f1038d8b9efe40$var$U.current.useRef(a);
};
$31f1038d8b9efe40$export$60241385465d0a34 = function(a) {
    return $31f1038d8b9efe40$var$U.current.useState(a);
};
$31f1038d8b9efe40$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $31f1038d8b9efe40$var$U.current.useSyncExternalStore(a, b, e);
};
$31f1038d8b9efe40$export$7b286972b8d8ccbf = function() {
    return $31f1038d8b9efe40$var$U.current.useTransition();
};
$31f1038d8b9efe40$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("8kMfp", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $61159df79facf28e$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $61159df79facf28e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $61159df79facf28e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $61159df79facf28e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $61159df79facf28e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $61159df79facf28e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $61159df79facf28e$export$a9c23c6ac3fc3eca; });

var $eZVvM = parcelRequire("eZVvM");

var $hUOrI = parcelRequire("hUOrI");

var $65o8X = parcelRequire("65o8X");

var $c2U8l = parcelRequire("c2U8l");

var $bSAjr = parcelRequire("bSAjr");

var $geJaG = parcelRequire("geJaG");

var $2mRmw = parcelRequire("2mRmw");

var $8JgfY = parcelRequire("8JgfY");
var $61159df79facf28e$export$23f2a1d2818174ef = false;
/* import { type EmotionCache } from '@emotion/utils' */ var $61159df79facf28e$var$EmotionCacheContext = /* #__PURE__ */ $eZVvM.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $hUOrI.default)({
    key: "css"
}) : null);
var $61159df79facf28e$export$e7094788287c5e9b = $61159df79facf28e$var$EmotionCacheContext.Provider;
var $61159df79facf28e$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $eZVvM.useContext)($61159df79facf28e$var$EmotionCacheContext);
};
var $61159df79facf28e$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $eZVvM.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eZVvM.useContext)($61159df79facf28e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $61159df79facf28e$export$971d5caa766a69d7 = /* #__PURE__ */ $eZVvM.createContext({});
var $61159df79facf28e$export$3b14a55fb2447963 = function useTheme() {
    return $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
};
var $61159df79facf28e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $65o8X.default)({}, outerTheme, theme);
};
var $61159df79facf28e$var$createCacheWithTheme = /* #__PURE__ */ (0, $c2U8l.default)(function(outerTheme) {
    return (0, $c2U8l.default)(function(theme) {
        return $61159df79facf28e$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $61159df79facf28e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $61159df79facf28e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eZVvM.createElement($61159df79facf28e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $61159df79facf28e$export$8b22cf2602fb60ce(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eZVvM.createElement(Component, (0, $65o8X.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $eZVvM.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $bSAjr.default)(WithTheme, Component);
}
var $61159df79facf28e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $61159df79facf28e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $61159df79facf28e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($61159df79facf28e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$61159df79facf28e$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $61159df79facf28e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $geJaG.registerStyles)(cache, serialized, isStringTag);
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $geJaG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $61159df79facf28e$var$Emotion = /* #__PURE__ */ $61159df79facf28e$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$61159df79facf28e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $geJaG.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2mRmw.serializeStyles)(registeredStyles, undefined, $eZVvM.useContext($61159df79facf28e$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($61159df79facf28e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $61159df79facf28e$var$typePropName && !$61159df79facf28e$export$23f2a1d2818174ef) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($61159df79facf28e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $eZVvM.createElement(WrappedComponent, newProps));
});
var $61159df79facf28e$export$a9c23c6ac3fc3eca = $61159df79facf28e$var$Emotion;

});
parcelRegister("hUOrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0aecc2f01744a2d$export$2e2bcd8739ae039; });

var $7Z4I8 = parcelRequire("7Z4I8");

var $kALlb = parcelRequire("kALlb");
var $fvohN = parcelRequire("fvohN");
var $iNPmF = parcelRequire("iNPmF");
var $lPlJK = parcelRequire("lPlJK");
var $dWdee = parcelRequire("dWdee");
var $lyqja = parcelRequire("lyqja");
parcelRequire("c2U8l");
parcelRequire("4vbT5");
var $d0aecc2f01744a2d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $kALlb.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $kALlb.token)(character)) break;
        (0, $kALlb.next)();
    }
    return (0, $kALlb.slice)(begin, (0, $kALlb.position));
};
var $d0aecc2f01744a2d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $kALlb.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $kALlb.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d0aecc2f01744a2d$var$identifierWithPointTracking((0, $kALlb.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $kALlb.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $kALlb.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fvohN.from)(character);
    }
    while (character = (0, $kALlb.next)());
    return parsed;
};
var $d0aecc2f01744a2d$var$getRules = function getRules(value, points) {
    return (0, $kALlb.dealloc)($d0aecc2f01744a2d$var$toRules((0, $kALlb.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d0aecc2f01744a2d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d0aecc2f01744a2d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d0aecc2f01744a2d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d0aecc2f01744a2d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d0aecc2f01744a2d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d0aecc2f01744a2d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $d0aecc2f01744a2d$var$prefix(value, length) {
    switch((0, $fvohN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lPlJK.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lPlJK.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MOZ) + value + (0, $lPlJK.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
        // order
        case 6165:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $lPlJK.WEBKIT) + value + (0, $fvohN.replace)(value, /(\w+).+(:[^]+)/, (0, $lPlJK.WEBKIT) + "box-$1$2" + (0, $lPlJK.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-item-" + (0, $fvohN.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-line-pack" + (0, $fvohN.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $lPlJK.WEBKIT) + "box-" + (0, $fvohN.replace)(value, "-grow", "") + (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $lPlJK.WEBKIT) + (0, $fvohN.replace)(value, /([^-])(transform)/g, "$1" + (0, $lPlJK.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fvohN.replace)((0, $fvohN.replace)((0, $fvohN.replace)(value, /(zoom-|grab)/, (0, $lPlJK.WEBKIT) + "$1"), /(image-set)/, (0, $lPlJK.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fvohN.replace)(value, /(image-set\([^]*)/, (0, $lPlJK.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fvohN.replace)((0, $fvohN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lPlJK.WEBKIT) + "box-pack:$3" + (0, $lPlJK.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $lPlJK.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fvohN.replace)(value, /(.+)-inline(.+)/, (0, $lPlJK.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fvohN.strlen)(value) - 1 - length > 6) switch((0, $fvohN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fvohN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fvohN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $lPlJK.WEBKIT) + "$2-$3" + "$1" + (0, $lPlJK.MOZ) + ((0, $fvohN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fvohN.indexof)(value, "stretch") ? $d0aecc2f01744a2d$var$prefix((0, $fvohN.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fvohN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fvohN.charat)(value, (0, $fvohN.strlen)(value) - 3 - (~(0, $fvohN.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fvohN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $lPlJK.WEBKIT) + ((0, $fvohN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $lPlJK.WEBKIT) + "$2$3" + "$1" + (0, $lPlJK.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fvohN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
    }
    return value;
}
var $d0aecc2f01744a2d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $lPlJK.DECLARATION:
                element["return"] = $d0aecc2f01744a2d$var$prefix(element.value, element.length);
                break;
            case 0, $lPlJK.KEYFRAMES:
                return (0, $lyqja.serialize)([
                    (0, $kALlb.copy)(element, {
                        value: (0, $fvohN.replace)(element.value, "@", "@" + (0, $lPlJK.WEBKIT))
                    })
                ], callback);
            case 0, $lPlJK.RULESET:
                if (element.length) return (0, $fvohN.combine)(element.props, function(value) {
                    switch((0, $fvohN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(read-\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, (0, $lPlJK.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $d0aecc2f01744a2d$var$defaultStylisPlugins = [
    $d0aecc2f01744a2d$var$prefixer
];
var $d0aecc2f01744a2d$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $d0aecc2f01744a2d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" ");
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $d0aecc2f01744a2d$var$compat,
        $d0aecc2f01744a2d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $lyqja.stringify),
        (0, $dWdee.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $dWdee.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $lyqja.serialize)((0, $iNPmF.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7Z4I8.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7Z4I8", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $5d01e26819e97aad$export$9d753cd7ae895cce; });
var $5d01e26819e97aad$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $5d01e26819e97aad$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $5d01e26819e97aad$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $5d01e26819e97aad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$5d01e26819e97aad$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($5d01e26819e97aad$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $5d01e26819e97aad$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("kALlb", function(module, exports) {

$parcel$export(module.exports, "position", function () { return $efdbe4523f606a7a$export$5880b8b5730aff45; });
$parcel$export(module.exports, "node", function () { return $efdbe4523f606a7a$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $efdbe4523f606a7a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "char", function () { return $efdbe4523f606a7a$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $efdbe4523f606a7a$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $efdbe4523f606a7a$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $efdbe4523f606a7a$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $efdbe4523f606a7a$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "slice", function () { return $efdbe4523f606a7a$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $efdbe4523f606a7a$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $efdbe4523f606a7a$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $efdbe4523f606a7a$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $efdbe4523f606a7a$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $efdbe4523f606a7a$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $efdbe4523f606a7a$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $efdbe4523f606a7a$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $efdbe4523f606a7a$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $efdbe4523f606a7a$export$4254d4e2b3745c4c; });

var $fvohN = parcelRequire("fvohN");
var $efdbe4523f606a7a$export$53f1d5ea8de3d7c = 1;
var $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1;
var $efdbe4523f606a7a$export$f24224f1c91d8156 = 0;
var $efdbe4523f606a7a$export$5880b8b5730aff45 = 0;
var $efdbe4523f606a7a$export$c0306caf338ac095 = 0;
var $efdbe4523f606a7a$export$30a86d91af8ff6e6 = "";
function $efdbe4523f606a7a$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $efdbe4523f606a7a$export$53f1d5ea8de3d7c,
        column: $efdbe4523f606a7a$export$4e0c71f277ca26b3,
        length: length,
        return: ""
    };
}
function $efdbe4523f606a7a$export$784d13d8ee351f07(root, props) {
    return (0, $fvohN.assign)($efdbe4523f606a7a$export$35059013cd4a06db("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function $efdbe4523f606a7a$export$eba6f6f03b0a92e7() {
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$232faf9add678146() {
    $efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$5880b8b5730aff45 > 0 ? (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, --$efdbe4523f606a7a$export$5880b8b5730aff45) : 0;
    if ($efdbe4523f606a7a$export$4e0c71f277ca26b3--, $efdbe4523f606a7a$export$c0306caf338ac095 === 10) $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$53f1d5ea8de3d7c--;
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$48cfd1e771a65c4f() {
    $efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$5880b8b5730aff45 < $efdbe4523f606a7a$export$f24224f1c91d8156 ? (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, $efdbe4523f606a7a$export$5880b8b5730aff45++) : 0;
    if ($efdbe4523f606a7a$export$4e0c71f277ca26b3++, $efdbe4523f606a7a$export$c0306caf338ac095 === 10) $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$53f1d5ea8de3d7c++;
    return $efdbe4523f606a7a$export$c0306caf338ac095;
}
function $efdbe4523f606a7a$export$4d3fb11e950abb9e() {
    return (0, $fvohN.charat)($efdbe4523f606a7a$export$30a86d91af8ff6e6, $efdbe4523f606a7a$export$5880b8b5730aff45);
}
function $efdbe4523f606a7a$export$e88cb2efb12ae807() {
    return $efdbe4523f606a7a$export$5880b8b5730aff45;
}
function $efdbe4523f606a7a$export$58adb3bec8346d0f(begin, end) {
    return (0, $fvohN.substr)($efdbe4523f606a7a$export$30a86d91af8ff6e6, begin, end);
}
function $efdbe4523f606a7a$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $efdbe4523f606a7a$export$2de70f21292aac9e(value) {
    return $efdbe4523f606a7a$export$53f1d5ea8de3d7c = $efdbe4523f606a7a$export$4e0c71f277ca26b3 = 1, $efdbe4523f606a7a$export$f24224f1c91d8156 = (0, $fvohN.strlen)($efdbe4523f606a7a$export$30a86d91af8ff6e6 = value), $efdbe4523f606a7a$export$5880b8b5730aff45 = 0, [];
}
function $efdbe4523f606a7a$export$45918ac1574455b1(value) {
    return $efdbe4523f606a7a$export$30a86d91af8ff6e6 = "", value;
}
function $efdbe4523f606a7a$export$410ac95b9ec204b8(type) {
    return (0, $fvohN.trim)($efdbe4523f606a7a$export$58adb3bec8346d0f($efdbe4523f606a7a$export$5880b8b5730aff45 - 1, $efdbe4523f606a7a$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $efdbe4523f606a7a$export$660b2ee2d4fb4eff(value) {
    return $efdbe4523f606a7a$export$45918ac1574455b1($efdbe4523f606a7a$export$5f8c09e3ae6f64e1($efdbe4523f606a7a$export$2de70f21292aac9e(value)));
}
function $efdbe4523f606a7a$export$7af1228ff777d175(type) {
    while($efdbe4523f606a7a$export$c0306caf338ac095 = $efdbe4523f606a7a$export$4d3fb11e950abb9e())if ($efdbe4523f606a7a$export$c0306caf338ac095 < 33) $efdbe4523f606a7a$export$48cfd1e771a65c4f();
    else break;
    return $efdbe4523f606a7a$export$9e1725a4cfeada27(type) > 2 || $efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $efdbe4523f606a7a$export$5f8c09e3ae6f64e1(children) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())switch($efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$c0306caf338ac095)){
        case 0:
            (0, $fvohN.append)($efdbe4523f606a7a$export$c2ab62c7bf24634($efdbe4523f606a7a$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $fvohN.append)($efdbe4523f606a7a$export$410ac95b9ec204b8($efdbe4523f606a7a$export$c0306caf338ac095), children);
            break;
        default:
            (0, $fvohN.append)((0, $fvohN.from)($efdbe4523f606a7a$export$c0306caf338ac095), children);
    }
    return children;
}
function $efdbe4523f606a7a$export$955ba06d119e085e(index, count) {
    while(--count && $efdbe4523f606a7a$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($efdbe4523f606a7a$export$c0306caf338ac095 < 48 || $efdbe4523f606a7a$export$c0306caf338ac095 > 102 || $efdbe4523f606a7a$export$c0306caf338ac095 > 57 && $efdbe4523f606a7a$export$c0306caf338ac095 < 65 || $efdbe4523f606a7a$export$c0306caf338ac095 > 70 && $efdbe4523f606a7a$export$c0306caf338ac095 < 97) break;
    return $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$e88cb2efb12ae807() + (count < 6 && $efdbe4523f606a7a$export$4d3fb11e950abb9e() == 32 && $efdbe4523f606a7a$export$48cfd1e771a65c4f() == 32));
}
function $efdbe4523f606a7a$export$c889f2fcc19dbf12(type) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())switch($efdbe4523f606a7a$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $efdbe4523f606a7a$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $efdbe4523f606a7a$export$c889f2fcc19dbf12($efdbe4523f606a7a$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $efdbe4523f606a7a$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $efdbe4523f606a7a$export$48cfd1e771a65c4f();
            break;
    }
    return $efdbe4523f606a7a$export$5880b8b5730aff45;
}
function $efdbe4523f606a7a$export$4254d4e2b3745c4c(type, index) {
    while($efdbe4523f606a7a$export$48cfd1e771a65c4f())// //
    if (type + $efdbe4523f606a7a$export$c0306caf338ac095 === 57) break;
    else if (type + $efdbe4523f606a7a$export$c0306caf338ac095 === 84 && $efdbe4523f606a7a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$5880b8b5730aff45 - 1) + "*" + (0, $fvohN.from)(type === 47 ? type : $efdbe4523f606a7a$export$48cfd1e771a65c4f());
}
function $efdbe4523f606a7a$export$c2ab62c7bf24634(index) {
    while(!$efdbe4523f606a7a$export$9e1725a4cfeada27($efdbe4523f606a7a$export$4d3fb11e950abb9e()))$efdbe4523f606a7a$export$48cfd1e771a65c4f();
    return $efdbe4523f606a7a$export$58adb3bec8346d0f(index, $efdbe4523f606a7a$export$5880b8b5730aff45);
}

});
parcelRegister("fvohN", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $b49c96fd4bfe2527$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $b49c96fd4bfe2527$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $b49c96fd4bfe2527$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $b49c96fd4bfe2527$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $b49c96fd4bfe2527$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $b49c96fd4bfe2527$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $b49c96fd4bfe2527$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $b49c96fd4bfe2527$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $b49c96fd4bfe2527$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $b49c96fd4bfe2527$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $b49c96fd4bfe2527$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $b49c96fd4bfe2527$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $b49c96fd4bfe2527$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $b49c96fd4bfe2527$export$1be1fc439b849fdf; });
/**
 * @param {number}
 * @return {number}
 */ var $b49c96fd4bfe2527$export$2335f513bbd82c6d = Math.abs;
var $b49c96fd4bfe2527$export$6788812c4e6611e6 = String.fromCharCode;
var $b49c96fd4bfe2527$export$e6e34fd1f2686227 = Object.assign;
function $b49c96fd4bfe2527$export$d6af199866bfb566(value, length) {
    return $b49c96fd4bfe2527$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 0)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 1)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 2)) << 2 ^ $b49c96fd4bfe2527$export$a9db5e087081082d(value, 3) : 0;
}
function $b49c96fd4bfe2527$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $b49c96fd4bfe2527$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $b49c96fd4bfe2527$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $b49c96fd4bfe2527$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $b49c96fd4bfe2527$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $b49c96fd4bfe2527$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $b49c96fd4bfe2527$export$36776f635604f274(value) {
    return value.length;
}
function $b49c96fd4bfe2527$export$f9084667e487ed46(value) {
    return value.length;
}
function $b49c96fd4bfe2527$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $b49c96fd4bfe2527$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}

});


parcelRegister("iNPmF", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $db04a589ffd10751$export$ef7acd7185315e22; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");

var $kALlb = parcelRequire("kALlb");
function $db04a589ffd10751$export$ef7acd7185315e22(value) {
    return (0, $kALlb.dealloc)($db04a589ffd10751$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $kALlb.alloc)(value), 0, [
        0
    ], value));
}
function $db04a589ffd10751$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $kALlb.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $fvohN.charat)(characters, length - 1) == 58) {
                if ((0, $fvohN.indexof)(characters += (0, $fvohN.replace)((0, $kALlb.delimit)(character), "&", "&\f"), "&\f") != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $kALlb.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $kALlb.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $kALlb.escaping)((0, $kALlb.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $kALlb.peek)()){
                case 42:
                case 47:
                    (0, $fvohN.append)($db04a589ffd10751$export$4a34f930e789283c((0, $kALlb.commenter)((0, $kALlb.next)(), (0, $kALlb.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $fvohN.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $fvohN.replace)(characters, /\f/g, "");
                    if (property > 0 && (0, $fvohN.strlen)(characters) - length) (0, $fvohN.append)(property > 32 ? $db04a589ffd10751$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1) : $db04a589ffd10751$export$f8483753829ec8f3((0, $fvohN.replace)(characters, " ", "") + ";", rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $fvohN.append)(reference = $db04a589ffd10751$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $db04a589ffd10751$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $fvohN.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $db04a589ffd10751$export$98e6a39c04603d36(value, reference, reference, rule && (0, $fvohN.append)($db04a589ffd10751$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $db04a589ffd10751$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $fvohN.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $kALlb.prev)() == 125) continue;
            }
            switch(characters += (0, $fvohN.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $fvohN.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $kALlb.peek)() === 45) characters += (0, $kALlb.delimit)((0, $kALlb.next)());
                    atrule = (0, $kALlb.peek)(), offset = length = (0, $fvohN.strlen)(type = characters += (0, $kALlb.identifier)((0, $kALlb.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $fvohN.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $db04a589ffd10751$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $fvohN.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $fvohN.substr)(value, post + 1, post = (0, $fvohN.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $fvohN.trim)(j > 0 ? rule[x] + " " + y : (0, $fvohN.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $kALlb.node)(value, root, parent, offset === 0 ? (0, $lPlJK.RULESET) : type, props, children, length);
}
function $db04a589ffd10751$export$4a34f930e789283c(value, root, parent) {
    return (0, $kALlb.node)(value, root, parent, (0, $lPlJK.COMMENT), (0, $fvohN.from)((0, $kALlb.char)()), (0, $fvohN.substr)(value, 2, -2), 0);
}
function $db04a589ffd10751$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $kALlb.node)(value, root, parent, (0, $lPlJK.DECLARATION), (0, $fvohN.substr)(value, 0, length), (0, $fvohN.substr)(value, length + 1, -1), length);
}

});
parcelRegister("lPlJK", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $fe3f38e75c5de6c7$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $fe3f38e75c5de6c7$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $fe3f38e75c5de6c7$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $fe3f38e75c5de6c7$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $fe3f38e75c5de6c7$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $fe3f38e75c5de6c7$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $fe3f38e75c5de6c7$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $fe3f38e75c5de6c7$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $fe3f38e75c5de6c7$export$d773506282b3cfe6; });
var $fe3f38e75c5de6c7$export$71ad59f2e432cfe8 = "-ms-";
var $fe3f38e75c5de6c7$export$2c0f367103c8d01c = "-moz-";
var $fe3f38e75c5de6c7$export$39dfd62a25e0fe93 = "-webkit-";
var $fe3f38e75c5de6c7$export$a29989082612d0d9 = "comm";
var $fe3f38e75c5de6c7$export$aa3a2e812ca8570d = "rule";
var $fe3f38e75c5de6c7$export$527d108ccf083c2b = "decl";
var $fe3f38e75c5de6c7$export$d3d35020fa5b54f0 = "@page";
var $fe3f38e75c5de6c7$export$500415a86c544f73 = "@media";
var $fe3f38e75c5de6c7$export$a763edbf796b780a = "@import";
var $fe3f38e75c5de6c7$export$2790aeb8b4e5c826 = "@charset";
var $fe3f38e75c5de6c7$export$1cc683e23b84b133 = "@viewport";
var $fe3f38e75c5de6c7$export$9447a5efea57e862 = "@supports";
var $fe3f38e75c5de6c7$export$ef011b4e114b1fba = "@document";
var $fe3f38e75c5de6c7$export$6aad947bda0f3f46 = "@namespace";
var $fe3f38e75c5de6c7$export$b44a8529a35fcb60 = "@keyframes";
var $fe3f38e75c5de6c7$export$2c16de31893252e6 = "@font-face";
var $fe3f38e75c5de6c7$export$3d846dd52e150c6f = "@counter-style";
var $fe3f38e75c5de6c7$export$22314bfbb57653fe = "@font-feature-values";
var $fe3f38e75c5de6c7$export$d773506282b3cfe6 = "@layer";

});


parcelRegister("dWdee", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $a25af40beae40c51$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $a25af40beae40c51$export$38bcb760f1d4871c; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");

var $kALlb = parcelRequire("kALlb");

var $lyqja = parcelRequire("lyqja");

var $j9jEI = parcelRequire("j9jEI");
function $a25af40beae40c51$export$5a7767152ae0305f(collection) {
    var length = (0, $fvohN.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $a25af40beae40c51$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $a25af40beae40c51$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $lPlJK.DECLARATION:
                element.return = (0, $j9jEI.prefix)(element.value, element.length, children);
                return;
            case 0, $lPlJK.KEYFRAMES:
                return (0, $lyqja.serialize)([
                    (0, $kALlb.copy)(element, {
                        value: (0, $fvohN.replace)(element.value, "@", "@" + (0, $lPlJK.WEBKIT))
                    })
                ], callback);
            case 0, $lPlJK.RULESET:
                if (element.length) return (0, $fvohN.combine)(element.props, function(value) {
                    switch((0, $fvohN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(read-\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $lyqja.serialize)([
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, ":" + (0, $lPlJK.MOZ) + "$1")
                                    ]
                                }),
                                (0, $kALlb.copy)(element, {
                                    props: [
                                        (0, $fvohN.replace)(value, /:(plac\w+)/, (0, $lPlJK.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
}
function $a25af40beae40c51$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $lPlJK.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $fvohN.combine)((0, $kALlb.tokenize)(value), function(value, index, children) {
                    switch((0, $fvohN.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $fvohN.substr)(value, 1, (0, $fvohN.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $fvohN.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $fvohN.sizeof)(children) > 1 ? "" : value;
                                case index = (0, $fvohN.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("lyqja", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $fb112e37b38a47f3$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $fb112e37b38a47f3$export$fac44ee5b035f737; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");
function $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    var length = (0, $fvohN.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $fb112e37b38a47f3$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $lPlJK.LAYER:
            if (element.children.length) break;
        case 0, $lPlJK.IMPORT:
        case 0, $lPlJK.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $lPlJK.COMMENT:
            return "";
        case 0, $lPlJK.KEYFRAMES:
            return element.return = element.value + "{" + $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $lPlJK.RULESET:
            element.value = element.props.join(",");
    }
    return (0, $fvohN.strlen)(children = $fb112e37b38a47f3$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

});

parcelRegister("j9jEI", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $df0e1ac8cf3763b0$export$82e9f45cca5ba907; });

var $lPlJK = parcelRequire("lPlJK");

var $fvohN = parcelRequire("fvohN");
function $df0e1ac8cf3763b0$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $fvohN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $lPlJK.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $lPlJK.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $lPlJK.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MOZ) + value + (0, $lPlJK.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $fvohN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + value + value;
        // order
        case 6165:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $lPlJK.WEBKIT) + value + (0, $fvohN.replace)(value, /(\w+).+(:[^]+)/, (0, $lPlJK.WEBKIT) + "box-$1$2" + (0, $lPlJK.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-item-" + (0, $fvohN.replace)(value, /flex-|-self/g, "") + (!(0, $fvohN.match)(value, /flex-|baseline/) ? (0, $lPlJK.MS) + "grid-row-" + (0, $fvohN.replace)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + "flex-line-pack" + (0, $fvohN.replace)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $lPlJK.WEBKIT) + "box-" + (0, $fvohN.replace)(value, "-grow", "") + (0, $lPlJK.WEBKIT) + value + (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $lPlJK.WEBKIT) + (0, $fvohN.replace)(value, /([^-])(transform)/g, "$1" + (0, $lPlJK.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $fvohN.replace)((0, $fvohN.replace)((0, $fvohN.replace)(value, /(zoom-|grab)/, (0, $lPlJK.WEBKIT) + "$1"), /(image-set)/, (0, $lPlJK.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fvohN.replace)(value, /(image-set\([^]*)/, (0, $lPlJK.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $fvohN.replace)((0, $fvohN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $lPlJK.WEBKIT) + "box-pack:$3" + (0, $lPlJK.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $lPlJK.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $fvohN.match)(value, /flex-|baseline/)) return (0, $lPlJK.MS) + "grid-column-align" + (0, $fvohN.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $fvohN.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $fvohN.indexof)(value + (children = children[length].value), "span") ? value : (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "-start", "") + value + (0, $lPlJK.MS) + "grid-row-span:" + (~(0, $fvohN.indexof)(children, "span") ? (0, $fvohN.match)(children, /\d+/) : +(0, $fvohN.match)(children, /\d+/) - +(0, $fvohN.match)(value, /\d+/)) + ";";
            return (0, $lPlJK.MS) + (0, $fvohN.replace)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $fvohN.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $lPlJK.MS) + (0, $fvohN.replace)((0, $fvohN.replace)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fvohN.replace)(value, /(.+)-inline(.+)/, (0, $lPlJK.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fvohN.strlen)(value) - 1 - length > 6) switch((0, $fvohN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fvohN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fvohN.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $lPlJK.WEBKIT) + "$2-$3" + "$1" + (0, $lPlJK.MOZ) + ((0, $fvohN.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fvohN.indexof)(value, "stretch") ? $df0e1ac8cf3763b0$export$82e9f45cca5ba907((0, $fvohN.replace)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $fvohN.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $lPlJK.MS) + a + ":" + b + f + (c ? (0, $lPlJK.MS) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $fvohN.charat)(value, length + 6) === 121) return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $fvohN.charat)(value, (0, $fvohN.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $fvohN.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $lPlJK.WEBKIT) + ((0, $fvohN.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $lPlJK.WEBKIT) + "$2$3" + "$1" + (0, $lPlJK.MS) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $fvohN.replace)(value, ":", ":" + (0, $lPlJK.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $fvohN.replace)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}

});


parcelRegister("c2U8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c5136e092954a76$export$2e2bcd8739ae039; });
var $8c5136e092954a76$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4vbT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3473474772d4527d$export$2e2bcd8739ae039; });
function $3473474772d4527d$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("65o8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46e5f016cb65863b$export$2e2bcd8739ae039; });
function $46e5f016cb65863b$export$2e2bcd8739ae039() {
    return $46e5f016cb65863b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $46e5f016cb65863b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("bSAjr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a60e7caca6e701b$export$2e2bcd8739ae039; });

var $28Dco = parcelRequire("28Dco");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $8a60e7caca6e701b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($28Dco)))(targetComponent, sourceComponent);
};

});
parcelRegister("28Dco", function(module, exports) {
"use strict";

var $kqafl = parcelRequire("kqafl");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $18eabc32537a5bde$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $18eabc32537a5bde$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $18eabc32537a5bde$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $18eabc32537a5bde$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $18eabc32537a5bde$var$TYPE_STATICS = {};
$18eabc32537a5bde$var$TYPE_STATICS[$kqafl.ForwardRef] = $18eabc32537a5bde$var$FORWARD_REF_STATICS;
$18eabc32537a5bde$var$TYPE_STATICS[$kqafl.Memo] = $18eabc32537a5bde$var$MEMO_STATICS;
function $18eabc32537a5bde$var$getStatics(component) {
    // React v16.11 and below
    if ($kqafl.isMemo(component)) return $18eabc32537a5bde$var$MEMO_STATICS;
     // React v16.12 and above
    return $18eabc32537a5bde$var$TYPE_STATICS[component["$$typeof"]] || $18eabc32537a5bde$var$REACT_STATICS;
}
var $18eabc32537a5bde$var$defineProperty = Object.defineProperty;
var $18eabc32537a5bde$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $18eabc32537a5bde$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $18eabc32537a5bde$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $18eabc32537a5bde$var$getPrototypeOf = Object.getPrototypeOf;
var $18eabc32537a5bde$var$objectPrototype = Object.prototype;
function $18eabc32537a5bde$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($18eabc32537a5bde$var$objectPrototype) {
            var inheritedComponent = $18eabc32537a5bde$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $18eabc32537a5bde$var$objectPrototype) $18eabc32537a5bde$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $18eabc32537a5bde$var$getOwnPropertyNames(sourceComponent);
        if ($18eabc32537a5bde$var$getOwnPropertySymbols) keys = keys.concat($18eabc32537a5bde$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $18eabc32537a5bde$var$getStatics(targetComponent);
        var sourceStatics = $18eabc32537a5bde$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$18eabc32537a5bde$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $18eabc32537a5bde$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $18eabc32537a5bde$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $18eabc32537a5bde$var$hoistNonReactStatics;

});
parcelRegister("kqafl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("f9CY9"));

});
parcelRegister("f9CY9", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b085ecc2efba6e3a$export$2b8d127b894957b9; }, function (v) { return $b085ecc2efba6e3a$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b085ecc2efba6e3a$export$cea3a54a6425200c; }, function (v) { return $b085ecc2efba6e3a$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b085ecc2efba6e3a$export$a7c73072b1a182ae; }, function (v) { return $b085ecc2efba6e3a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b085ecc2efba6e3a$export$9f27bc3417b4524d; }, function (v) { return $b085ecc2efba6e3a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b085ecc2efba6e3a$export$db77ccec0bb4ccac; }, function (v) { return $b085ecc2efba6e3a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b085ecc2efba6e3a$export$8392c0c9d3dcbd35; }, function (v) { return $b085ecc2efba6e3a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b085ecc2efba6e3a$export$ffb0004e005737fa; }, function (v) { return $b085ecc2efba6e3a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b085ecc2efba6e3a$export$b624eff549462981; }, function (v) { return $b085ecc2efba6e3a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b085ecc2efba6e3a$export$7897aa7841a5380c; }, function (v) { return $b085ecc2efba6e3a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b085ecc2efba6e3a$export$602eac185826482c; }, function (v) { return $b085ecc2efba6e3a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b085ecc2efba6e3a$export$e2c29f18771995cb; }, function (v) { return $b085ecc2efba6e3a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b085ecc2efba6e3a$export$5f8d39834fd61797; }, function (v) { return $b085ecc2efba6e3a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b085ecc2efba6e3a$export$74bf444e3cd11ea5; }, function (v) { return $b085ecc2efba6e3a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b085ecc2efba6e3a$export$92387174baf9b227; }, function (v) { return $b085ecc2efba6e3a$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b085ecc2efba6e3a$export$ec112efeb987d9c6; }, function (v) { return $b085ecc2efba6e3a$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b085ecc2efba6e3a$export$b706b080d889d2c9; }, function (v) { return $b085ecc2efba6e3a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b085ecc2efba6e3a$export$5be5a87408f70ddc; }, function (v) { return $b085ecc2efba6e3a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b085ecc2efba6e3a$export$45a5e7f76e0caa8d; }, function (v) { return $b085ecc2efba6e3a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b085ecc2efba6e3a$export$455c2e768291efa6; }, function (v) { return $b085ecc2efba6e3a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b085ecc2efba6e3a$export$9522e17588c12572; }, function (v) { return $b085ecc2efba6e3a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b085ecc2efba6e3a$export$2110ac352bb060b9; }, function (v) { return $b085ecc2efba6e3a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b085ecc2efba6e3a$export$56885ab8b9c456ab; }, function (v) { return $b085ecc2efba6e3a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b085ecc2efba6e3a$export$d927fcb6adf8f9de; }, function (v) { return $b085ecc2efba6e3a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b085ecc2efba6e3a$export$b82d16f27459e05a; }, function (v) { return $b085ecc2efba6e3a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b085ecc2efba6e3a$export$522c17b4f5e123e8; }, function (v) { return $b085ecc2efba6e3a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b085ecc2efba6e3a$export$1aabd8a0274ecfd6; }, function (v) { return $b085ecc2efba6e3a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b085ecc2efba6e3a$export$9b621391a187a31a; }, function (v) { return $b085ecc2efba6e3a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b085ecc2efba6e3a$export$f5bbd400c2f4426f; }, function (v) { return $b085ecc2efba6e3a$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b085ecc2efba6e3a$export$2b8d127b894957b9;
var $b085ecc2efba6e3a$export$cea3a54a6425200c;
var $b085ecc2efba6e3a$export$a7c73072b1a182ae;
var $b085ecc2efba6e3a$export$9f27bc3417b4524d;
var $b085ecc2efba6e3a$export$db77ccec0bb4ccac;
var $b085ecc2efba6e3a$export$8392c0c9d3dcbd35;
var $b085ecc2efba6e3a$export$ffb0004e005737fa;
var $b085ecc2efba6e3a$export$b624eff549462981;
var $b085ecc2efba6e3a$export$7897aa7841a5380c;
var $b085ecc2efba6e3a$export$602eac185826482c;
var $b085ecc2efba6e3a$export$e2c29f18771995cb;
var $b085ecc2efba6e3a$export$5f8d39834fd61797;
var $b085ecc2efba6e3a$export$74bf444e3cd11ea5;
var $b085ecc2efba6e3a$export$92387174baf9b227;
var $b085ecc2efba6e3a$export$ec112efeb987d9c6;
var $b085ecc2efba6e3a$export$b706b080d889d2c9;
var $b085ecc2efba6e3a$export$5be5a87408f70ddc;
var $b085ecc2efba6e3a$export$45a5e7f76e0caa8d;
var $b085ecc2efba6e3a$export$455c2e768291efa6;
var $b085ecc2efba6e3a$export$9522e17588c12572;
var $b085ecc2efba6e3a$export$2110ac352bb060b9;
var $b085ecc2efba6e3a$export$56885ab8b9c456ab;
var $b085ecc2efba6e3a$export$d927fcb6adf8f9de;
var $b085ecc2efba6e3a$export$b82d16f27459e05a;
var $b085ecc2efba6e3a$export$522c17b4f5e123e8;
var $b085ecc2efba6e3a$export$1aabd8a0274ecfd6;
var $b085ecc2efba6e3a$export$9b621391a187a31a;
var $b085ecc2efba6e3a$export$f5bbd400c2f4426f;
"use strict";
var $b085ecc2efba6e3a$var$b = "function" === typeof Symbol && Symbol.for, $b085ecc2efba6e3a$var$c = $b085ecc2efba6e3a$var$b ? Symbol.for("react.element") : 60103, $b085ecc2efba6e3a$var$d = $b085ecc2efba6e3a$var$b ? Symbol.for("react.portal") : 60106, $b085ecc2efba6e3a$var$e = $b085ecc2efba6e3a$var$b ? Symbol.for("react.fragment") : 60107, $b085ecc2efba6e3a$var$f = $b085ecc2efba6e3a$var$b ? Symbol.for("react.strict_mode") : 60108, $b085ecc2efba6e3a$var$g = $b085ecc2efba6e3a$var$b ? Symbol.for("react.profiler") : 60114, $b085ecc2efba6e3a$var$h = $b085ecc2efba6e3a$var$b ? Symbol.for("react.provider") : 60109, $b085ecc2efba6e3a$var$k = $b085ecc2efba6e3a$var$b ? Symbol.for("react.context") : 60110, $b085ecc2efba6e3a$var$l = $b085ecc2efba6e3a$var$b ? Symbol.for("react.async_mode") : 60111, $b085ecc2efba6e3a$var$m = $b085ecc2efba6e3a$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b085ecc2efba6e3a$var$n = $b085ecc2efba6e3a$var$b ? Symbol.for("react.forward_ref") : 60112, $b085ecc2efba6e3a$var$p = $b085ecc2efba6e3a$var$b ? Symbol.for("react.suspense") : 60113, $b085ecc2efba6e3a$var$q = $b085ecc2efba6e3a$var$b ? Symbol.for("react.suspense_list") : 60120, $b085ecc2efba6e3a$var$r = $b085ecc2efba6e3a$var$b ? Symbol.for("react.memo") : 60115, $b085ecc2efba6e3a$var$t = $b085ecc2efba6e3a$var$b ? Symbol.for("react.lazy") : 60116, $b085ecc2efba6e3a$var$v = $b085ecc2efba6e3a$var$b ? Symbol.for("react.block") : 60121, $b085ecc2efba6e3a$var$w = $b085ecc2efba6e3a$var$b ? Symbol.for("react.fundamental") : 60117, $b085ecc2efba6e3a$var$x = $b085ecc2efba6e3a$var$b ? Symbol.for("react.responder") : 60118, $b085ecc2efba6e3a$var$y = $b085ecc2efba6e3a$var$b ? Symbol.for("react.scope") : 60119;
function $b085ecc2efba6e3a$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b085ecc2efba6e3a$var$c:
                switch(a = a.type, a){
                    case $b085ecc2efba6e3a$var$l:
                    case $b085ecc2efba6e3a$var$m:
                    case $b085ecc2efba6e3a$var$e:
                    case $b085ecc2efba6e3a$var$g:
                    case $b085ecc2efba6e3a$var$f:
                    case $b085ecc2efba6e3a$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b085ecc2efba6e3a$var$k:
                            case $b085ecc2efba6e3a$var$n:
                            case $b085ecc2efba6e3a$var$t:
                            case $b085ecc2efba6e3a$var$r:
                            case $b085ecc2efba6e3a$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b085ecc2efba6e3a$var$d:
                return u;
        }
    }
}
function $b085ecc2efba6e3a$var$A(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$m;
}
$b085ecc2efba6e3a$export$2b8d127b894957b9 = $b085ecc2efba6e3a$var$l;
$b085ecc2efba6e3a$export$cea3a54a6425200c = $b085ecc2efba6e3a$var$m;
$b085ecc2efba6e3a$export$a7c73072b1a182ae = $b085ecc2efba6e3a$var$k;
$b085ecc2efba6e3a$export$9f27bc3417b4524d = $b085ecc2efba6e3a$var$h;
$b085ecc2efba6e3a$export$db77ccec0bb4ccac = $b085ecc2efba6e3a$var$c;
$b085ecc2efba6e3a$export$8392c0c9d3dcbd35 = $b085ecc2efba6e3a$var$n;
$b085ecc2efba6e3a$export$ffb0004e005737fa = $b085ecc2efba6e3a$var$e;
$b085ecc2efba6e3a$export$b624eff549462981 = $b085ecc2efba6e3a$var$t;
$b085ecc2efba6e3a$export$7897aa7841a5380c = $b085ecc2efba6e3a$var$r;
$b085ecc2efba6e3a$export$602eac185826482c = $b085ecc2efba6e3a$var$d;
$b085ecc2efba6e3a$export$e2c29f18771995cb = $b085ecc2efba6e3a$var$g;
$b085ecc2efba6e3a$export$5f8d39834fd61797 = $b085ecc2efba6e3a$var$f;
$b085ecc2efba6e3a$export$74bf444e3cd11ea5 = $b085ecc2efba6e3a$var$p;
$b085ecc2efba6e3a$export$92387174baf9b227 = function(a) {
    return $b085ecc2efba6e3a$var$A(a) || $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$l;
};
$b085ecc2efba6e3a$export$ec112efeb987d9c6 = $b085ecc2efba6e3a$var$A;
$b085ecc2efba6e3a$export$b706b080d889d2c9 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$k;
};
$b085ecc2efba6e3a$export$5be5a87408f70ddc = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$h;
};
$b085ecc2efba6e3a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b085ecc2efba6e3a$var$c;
};
$b085ecc2efba6e3a$export$455c2e768291efa6 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$n;
};
$b085ecc2efba6e3a$export$9522e17588c12572 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$e;
};
$b085ecc2efba6e3a$export$2110ac352bb060b9 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$t;
};
$b085ecc2efba6e3a$export$56885ab8b9c456ab = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$r;
};
$b085ecc2efba6e3a$export$d927fcb6adf8f9de = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$d;
};
$b085ecc2efba6e3a$export$b82d16f27459e05a = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$g;
};
$b085ecc2efba6e3a$export$522c17b4f5e123e8 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$f;
};
$b085ecc2efba6e3a$export$1aabd8a0274ecfd6 = function(a) {
    return $b085ecc2efba6e3a$var$z(a) === $b085ecc2efba6e3a$var$p;
};
$b085ecc2efba6e3a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b085ecc2efba6e3a$var$e || a === $b085ecc2efba6e3a$var$m || a === $b085ecc2efba6e3a$var$g || a === $b085ecc2efba6e3a$var$f || a === $b085ecc2efba6e3a$var$p || a === $b085ecc2efba6e3a$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b085ecc2efba6e3a$var$t || a.$$typeof === $b085ecc2efba6e3a$var$r || a.$$typeof === $b085ecc2efba6e3a$var$h || a.$$typeof === $b085ecc2efba6e3a$var$k || a.$$typeof === $b085ecc2efba6e3a$var$n || a.$$typeof === $b085ecc2efba6e3a$var$w || a.$$typeof === $b085ecc2efba6e3a$var$x || a.$$typeof === $b085ecc2efba6e3a$var$y || a.$$typeof === $b085ecc2efba6e3a$var$v);
};
$b085ecc2efba6e3a$export$f5bbd400c2f4426f = $b085ecc2efba6e3a$var$z;

});




parcelRegister("geJaG", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $bd20fe35b785fff3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $bd20fe35b785fff3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $bd20fe35b785fff3$export$6f077d94b33a01aa; });
var $bd20fe35b785fff3$var$isBrowser = true;
function $bd20fe35b785fff3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $bd20fe35b785fff3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $bd20fe35b785fff3$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $bd20fe35b785fff3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $bd20fe35b785fff3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("2mRmw", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $1b97077e6288ffb1$export$6321afa313b251b5; });

var $ilnGl = parcelRequire("ilnGl");

var $8sqzb = parcelRequire("8sqzb");

var $4vbT5 = parcelRequire("4vbT5");
var $1b97077e6288ffb1$var$isDevelopment = false;
var $1b97077e6288ffb1$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1b97077e6288ffb1$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1b97077e6288ffb1$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1b97077e6288ffb1$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $1b97077e6288ffb1$var$processStyleName = /* #__PURE__ */ (0, $4vbT5.default)(function(styleName) {
    return $1b97077e6288ffb1$var$isCustomProperty(styleName) ? styleName : styleName.replace($1b97077e6288ffb1$var$hyphenateRegex, "-$&").toLowerCase();
});
var $1b97077e6288ffb1$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($1b97077e6288ffb1$var$animationRegex, function(match, p1, p2) {
                $1b97077e6288ffb1$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1b97077e6288ffb1$var$cursor
                };
                return p1;
            });
    }
    if ((0, $8sqzb.default)[key] !== 1 && !$1b97077e6288ffb1$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $1b97077e6288ffb1$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $1b97077e6288ffb1$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $1b97077e6288ffb1$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1b97077e6288ffb1$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1b97077e6288ffb1$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $1b97077e6288ffb1$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $1b97077e6288ffb1$var$cursor;
                var result = interpolation(mergedProps);
                $1b97077e6288ffb1$var$cursor = previousCursor;
                return $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $1b97077e6288ffb1$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($1b97077e6288ffb1$var$isProcessableValue(asString)) string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + $1b97077e6288ffb1$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $1b97077e6288ffb1$var$isDevelopment) throw new Error($1b97077e6288ffb1$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($1b97077e6288ffb1$var$isProcessableValue(value[_i])) string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + $1b97077e6288ffb1$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $1b97077e6288ffb1$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $1b97077e6288ffb1$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $1b97077e6288ffb1$var$cursor;
function $1b97077e6288ffb1$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $1b97077e6288ffb1$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1b97077e6288ffb1$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $1b97077e6288ffb1$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1b97077e6288ffb1$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $ilnGl.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $1b97077e6288ffb1$var$cursor
    };
}

});
parcelRegister("ilnGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5ac8ee7b734a93a$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $d5ac8ee7b734a93a$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("8sqzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62858bd1b394830f$export$2e2bcd8739ae039; });
var $62858bd1b394830f$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("8JgfY", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $65af22ef74f8f817$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $65af22ef74f8f817$export$811a713a7276cb9d; });

var $eZVvM = parcelRequire("eZVvM");
var $65af22ef74f8f817$var$syncFallback = function syncFallback(create) {
    return create();
};
var $65af22ef74f8f817$var$useInsertionEffect = $eZVvM.useInsertionEffect ? $eZVvM.useInsertionEffect : false;
var $65af22ef74f8f817$export$db21c7ffa21794e7 = $65af22ef74f8f817$var$useInsertionEffect || $65af22ef74f8f817$var$syncFallback;
var $65af22ef74f8f817$export$811a713a7276cb9d = $65af22ef74f8f817$var$useInsertionEffect || $eZVvM.useLayoutEffect;

});



parcelRegister("59jpj", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3bfcd8e655c52d03$export$ae55be85d98224ed; }, function (v) { return $3bfcd8e655c52d03$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $3bfcd8e655c52d03$export$d39a5bbd09211389; }, function (v) { return $3bfcd8e655c52d03$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $3bfcd8e655c52d03$export$882461b6382ed46c; }, function (v) { return $3bfcd8e655c52d03$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $3bfcd8e655c52d03$export$466bfc07425424d5; }, function (v) { return $3bfcd8e655c52d03$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $3bfcd8e655c52d03$export$cd75ccfd720a3cd4; }, function (v) { return $3bfcd8e655c52d03$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $3bfcd8e655c52d03$export$fa8d919ba61d84db; }, function (v) { return $3bfcd8e655c52d03$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3bfcd8e655c52d03$export$757ceba2d55c277e; }, function (v) { return $3bfcd8e655c52d03$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $3bfcd8e655c52d03$export$b3890eb0ae9dca99; }, function (v) { return $3bfcd8e655c52d03$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $3bfcd8e655c52d03$export$502457920280e6be; }, function (v) { return $3bfcd8e655c52d03$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $3bfcd8e655c52d03$export$c78a37762a8d58e1; }, function (v) { return $3bfcd8e655c52d03$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $3bfcd8e655c52d03$export$dc54d992c10e8a18; }, function (v) { return $3bfcd8e655c52d03$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $3bfcd8e655c52d03$export$83d89fbfd8236492; }, function (v) { return $3bfcd8e655c52d03$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3bfcd8e655c52d03$export$ae55be85d98224ed;
var $3bfcd8e655c52d03$export$d39a5bbd09211389;
var $3bfcd8e655c52d03$export$882461b6382ed46c;
var $3bfcd8e655c52d03$export$466bfc07425424d5;
var $3bfcd8e655c52d03$export$cd75ccfd720a3cd4;
var $3bfcd8e655c52d03$export$fa8d919ba61d84db;
var $3bfcd8e655c52d03$export$757ceba2d55c277e;
var $3bfcd8e655c52d03$export$b3890eb0ae9dca99;
var $3bfcd8e655c52d03$export$502457920280e6be;
var $3bfcd8e655c52d03$export$c78a37762a8d58e1;
var $3bfcd8e655c52d03$export$dc54d992c10e8a18;
var $3bfcd8e655c52d03$export$83d89fbfd8236492;
"use strict";

var $eZVvM = parcelRequire("eZVvM");

var $9kLo3 = parcelRequire("9kLo3");
function $3bfcd8e655c52d03$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $3bfcd8e655c52d03$var$da = new Set, $3bfcd8e655c52d03$var$ea = {};
function $3bfcd8e655c52d03$var$fa(a, b) {
    $3bfcd8e655c52d03$var$ha(a, b);
    $3bfcd8e655c52d03$var$ha(a + "Capture", b);
}
function $3bfcd8e655c52d03$var$ha(a, b) {
    $3bfcd8e655c52d03$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$3bfcd8e655c52d03$var$da.add(b[a]);
}
var $3bfcd8e655c52d03$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3bfcd8e655c52d03$var$ja = Object.prototype.hasOwnProperty, $3bfcd8e655c52d03$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $3bfcd8e655c52d03$var$la = {}, $3bfcd8e655c52d03$var$ma = {};
function $3bfcd8e655c52d03$var$oa(a) {
    if ($3bfcd8e655c52d03$var$ja.call($3bfcd8e655c52d03$var$ma, a)) return !0;
    if ($3bfcd8e655c52d03$var$ja.call($3bfcd8e655c52d03$var$la, a)) return !1;
    if ($3bfcd8e655c52d03$var$ka.test(a)) return $3bfcd8e655c52d03$var$ma[a] = !0;
    $3bfcd8e655c52d03$var$la[a] = !0;
    return !1;
}
function $3bfcd8e655c52d03$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $3bfcd8e655c52d03$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $3bfcd8e655c52d03$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $3bfcd8e655c52d03$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $3bfcd8e655c52d03$var$ra = /[\-:]([a-z])/g;
function $3bfcd8e655c52d03$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($3bfcd8e655c52d03$var$ra, $3bfcd8e655c52d03$var$sa);
    $3bfcd8e655c52d03$var$z[b] = new $3bfcd8e655c52d03$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$3bfcd8e655c52d03$var$z.xlinkHref = new $3bfcd8e655c52d03$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $3bfcd8e655c52d03$var$z[a] = new $3bfcd8e655c52d03$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $3bfcd8e655c52d03$var$ta(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$z.hasOwnProperty(b) ? $3bfcd8e655c52d03$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $3bfcd8e655c52d03$var$qa(b, c, e, d) && (c = null), d || null === e ? $3bfcd8e655c52d03$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $3bfcd8e655c52d03$var$ua = $eZVvM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $3bfcd8e655c52d03$var$va = Symbol.for("react.element"), $3bfcd8e655c52d03$var$wa = Symbol.for("react.portal"), $3bfcd8e655c52d03$var$ya = Symbol.for("react.fragment"), $3bfcd8e655c52d03$var$za = Symbol.for("react.strict_mode"), $3bfcd8e655c52d03$var$Aa = Symbol.for("react.profiler"), $3bfcd8e655c52d03$var$Ba = Symbol.for("react.provider"), $3bfcd8e655c52d03$var$Ca = Symbol.for("react.context"), $3bfcd8e655c52d03$var$Da = Symbol.for("react.forward_ref"), $3bfcd8e655c52d03$var$Ea = Symbol.for("react.suspense"), $3bfcd8e655c52d03$var$Fa = Symbol.for("react.suspense_list"), $3bfcd8e655c52d03$var$Ga = Symbol.for("react.memo"), $3bfcd8e655c52d03$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $3bfcd8e655c52d03$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $3bfcd8e655c52d03$var$Ja = Symbol.iterator;
function $3bfcd8e655c52d03$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3bfcd8e655c52d03$var$Ja && a[$3bfcd8e655c52d03$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3bfcd8e655c52d03$var$A = Object.assign, $3bfcd8e655c52d03$var$La;
function $3bfcd8e655c52d03$var$Ma(a) {
    if (void 0 === $3bfcd8e655c52d03$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $3bfcd8e655c52d03$var$La = b && b[1] || "";
    }
    return "\n" + $3bfcd8e655c52d03$var$La + a;
}
var $3bfcd8e655c52d03$var$Na = !1;
function $3bfcd8e655c52d03$var$Oa(a, b) {
    if (!a || $3bfcd8e655c52d03$var$Na) return "";
    $3bfcd8e655c52d03$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $3bfcd8e655c52d03$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $3bfcd8e655c52d03$var$Ma(a) : "";
}
function $3bfcd8e655c52d03$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $3bfcd8e655c52d03$var$Ma(a.type);
        case 16:
            return $3bfcd8e655c52d03$var$Ma("Lazy");
        case 13:
            return $3bfcd8e655c52d03$var$Ma("Suspense");
        case 19:
            return $3bfcd8e655c52d03$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $3bfcd8e655c52d03$var$Oa(a.type, !1), a;
        case 11:
            return a = $3bfcd8e655c52d03$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $3bfcd8e655c52d03$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $3bfcd8e655c52d03$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $3bfcd8e655c52d03$var$ya:
            return "Fragment";
        case $3bfcd8e655c52d03$var$wa:
            return "Portal";
        case $3bfcd8e655c52d03$var$Aa:
            return "Profiler";
        case $3bfcd8e655c52d03$var$za:
            return "StrictMode";
        case $3bfcd8e655c52d03$var$Ea:
            return "Suspense";
        case $3bfcd8e655c52d03$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $3bfcd8e655c52d03$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $3bfcd8e655c52d03$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $3bfcd8e655c52d03$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $3bfcd8e655c52d03$var$Ga:
            return b = a.displayName || null, null !== b ? b : $3bfcd8e655c52d03$var$Qa(a.type) || "Memo";
        case $3bfcd8e655c52d03$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $3bfcd8e655c52d03$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $3bfcd8e655c52d03$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $3bfcd8e655c52d03$var$Qa(b);
        case 8:
            return b === $3bfcd8e655c52d03$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $3bfcd8e655c52d03$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $3bfcd8e655c52d03$var$Ua(a) {
    var b = $3bfcd8e655c52d03$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $3bfcd8e655c52d03$var$Va(a) {
    a._valueTracker || (a._valueTracker = $3bfcd8e655c52d03$var$Ua(a));
}
function $3bfcd8e655c52d03$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $3bfcd8e655c52d03$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $3bfcd8e655c52d03$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $3bfcd8e655c52d03$var$Ya(a, b) {
    var c = b.checked;
    return $3bfcd8e655c52d03$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $3bfcd8e655c52d03$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $3bfcd8e655c52d03$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $3bfcd8e655c52d03$var$ab(a, b) {
    b = b.checked;
    null != b && $3bfcd8e655c52d03$var$ta(a, "checked", b, !1);
}
function $3bfcd8e655c52d03$var$bb(a, b) {
    $3bfcd8e655c52d03$var$ab(a, b);
    var c = $3bfcd8e655c52d03$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $3bfcd8e655c52d03$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $3bfcd8e655c52d03$var$cb(a, b.type, $3bfcd8e655c52d03$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $3bfcd8e655c52d03$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $3bfcd8e655c52d03$var$cb(a, b, c) {
    if ("number" !== b || $3bfcd8e655c52d03$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $3bfcd8e655c52d03$var$eb = Array.isArray;
function $3bfcd8e655c52d03$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $3bfcd8e655c52d03$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $3bfcd8e655c52d03$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($3bfcd8e655c52d03$var$p(91));
    return $3bfcd8e655c52d03$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $3bfcd8e655c52d03$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($3bfcd8e655c52d03$var$p(92));
            if ($3bfcd8e655c52d03$var$eb(c)) {
                if (1 < c.length) throw Error($3bfcd8e655c52d03$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $3bfcd8e655c52d03$var$Sa(c)
    };
}
function $3bfcd8e655c52d03$var$ib(a, b) {
    var c = $3bfcd8e655c52d03$var$Sa(b.value), d = $3bfcd8e655c52d03$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $3bfcd8e655c52d03$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $3bfcd8e655c52d03$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $3bfcd8e655c52d03$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $3bfcd8e655c52d03$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $3bfcd8e655c52d03$var$mb, $3bfcd8e655c52d03$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $3bfcd8e655c52d03$var$mb = $3bfcd8e655c52d03$var$mb || document.createElement("div");
        $3bfcd8e655c52d03$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $3bfcd8e655c52d03$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $3bfcd8e655c52d03$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $3bfcd8e655c52d03$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $3bfcd8e655c52d03$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($3bfcd8e655c52d03$var$pb).forEach(function(a) {
    $3bfcd8e655c52d03$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $3bfcd8e655c52d03$var$pb[b] = $3bfcd8e655c52d03$var$pb[a];
    });
});
function $3bfcd8e655c52d03$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $3bfcd8e655c52d03$var$pb.hasOwnProperty(a) && $3bfcd8e655c52d03$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $3bfcd8e655c52d03$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $3bfcd8e655c52d03$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $3bfcd8e655c52d03$var$tb = $3bfcd8e655c52d03$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $3bfcd8e655c52d03$var$ub(a, b) {
    if (b) {
        if ($3bfcd8e655c52d03$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($3bfcd8e655c52d03$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($3bfcd8e655c52d03$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($3bfcd8e655c52d03$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($3bfcd8e655c52d03$var$p(62));
    }
}
function $3bfcd8e655c52d03$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3bfcd8e655c52d03$var$wb = null;
function $3bfcd8e655c52d03$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $3bfcd8e655c52d03$var$yb = null, $3bfcd8e655c52d03$var$zb = null, $3bfcd8e655c52d03$var$Ab = null;
function $3bfcd8e655c52d03$var$Bb(a) {
    if (a = $3bfcd8e655c52d03$var$Cb(a)) {
        if ("function" !== typeof $3bfcd8e655c52d03$var$yb) throw Error($3bfcd8e655c52d03$var$p(280));
        var b = a.stateNode;
        b && (b = $3bfcd8e655c52d03$var$Db(b), $3bfcd8e655c52d03$var$yb(a.stateNode, a.type, b));
    }
}
function $3bfcd8e655c52d03$var$Eb(a) {
    $3bfcd8e655c52d03$var$zb ? $3bfcd8e655c52d03$var$Ab ? $3bfcd8e655c52d03$var$Ab.push(a) : $3bfcd8e655c52d03$var$Ab = [
        a
    ] : $3bfcd8e655c52d03$var$zb = a;
}
function $3bfcd8e655c52d03$var$Fb() {
    if ($3bfcd8e655c52d03$var$zb) {
        var a = $3bfcd8e655c52d03$var$zb, b = $3bfcd8e655c52d03$var$Ab;
        $3bfcd8e655c52d03$var$Ab = $3bfcd8e655c52d03$var$zb = null;
        $3bfcd8e655c52d03$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$3bfcd8e655c52d03$var$Bb(b[a]);
    }
}
function $3bfcd8e655c52d03$var$Gb(a, b) {
    return a(b);
}
function $3bfcd8e655c52d03$var$Hb() {}
var $3bfcd8e655c52d03$var$Ib = !1;
function $3bfcd8e655c52d03$var$Jb(a, b, c) {
    if ($3bfcd8e655c52d03$var$Ib) return a(b, c);
    $3bfcd8e655c52d03$var$Ib = !0;
    try {
        return $3bfcd8e655c52d03$var$Gb(a, b, c);
    } finally{
        if ($3bfcd8e655c52d03$var$Ib = !1, null !== $3bfcd8e655c52d03$var$zb || null !== $3bfcd8e655c52d03$var$Ab) $3bfcd8e655c52d03$var$Hb(), $3bfcd8e655c52d03$var$Fb();
    }
}
function $3bfcd8e655c52d03$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $3bfcd8e655c52d03$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($3bfcd8e655c52d03$var$p(231, b, typeof c));
    return c;
}
var $3bfcd8e655c52d03$var$Lb = !1;
if ($3bfcd8e655c52d03$var$ia) try {
    var $3bfcd8e655c52d03$var$Mb = {};
    Object.defineProperty($3bfcd8e655c52d03$var$Mb, "passive", {
        get: function() {
            $3bfcd8e655c52d03$var$Lb = !0;
        }
    });
    window.addEventListener("test", $3bfcd8e655c52d03$var$Mb, $3bfcd8e655c52d03$var$Mb);
    window.removeEventListener("test", $3bfcd8e655c52d03$var$Mb, $3bfcd8e655c52d03$var$Mb);
} catch (a) {
    $3bfcd8e655c52d03$var$Lb = !1;
}
function $3bfcd8e655c52d03$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $3bfcd8e655c52d03$var$Ob = !1, $3bfcd8e655c52d03$var$Pb = null, $3bfcd8e655c52d03$var$Qb = !1, $3bfcd8e655c52d03$var$Rb = null, $3bfcd8e655c52d03$var$Sb = {
    onError: function(a) {
        $3bfcd8e655c52d03$var$Ob = !0;
        $3bfcd8e655c52d03$var$Pb = a;
    }
};
function $3bfcd8e655c52d03$var$Tb(a, b, c, d, e, f, g, h, k) {
    $3bfcd8e655c52d03$var$Ob = !1;
    $3bfcd8e655c52d03$var$Pb = null;
    $3bfcd8e655c52d03$var$Nb.apply($3bfcd8e655c52d03$var$Sb, arguments);
}
function $3bfcd8e655c52d03$var$Ub(a, b, c, d, e, f, g, h, k) {
    $3bfcd8e655c52d03$var$Tb.apply(this, arguments);
    if ($3bfcd8e655c52d03$var$Ob) {
        if ($3bfcd8e655c52d03$var$Ob) {
            var l = $3bfcd8e655c52d03$var$Pb;
            $3bfcd8e655c52d03$var$Ob = !1;
            $3bfcd8e655c52d03$var$Pb = null;
        } else throw Error($3bfcd8e655c52d03$var$p(198));
        $3bfcd8e655c52d03$var$Qb || ($3bfcd8e655c52d03$var$Qb = !0, $3bfcd8e655c52d03$var$Rb = l);
    }
}
function $3bfcd8e655c52d03$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $3bfcd8e655c52d03$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Xb(a) {
    if ($3bfcd8e655c52d03$var$Vb(a) !== a) throw Error($3bfcd8e655c52d03$var$p(188));
}
function $3bfcd8e655c52d03$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $3bfcd8e655c52d03$var$Vb(a);
        if (null === b) throw Error($3bfcd8e655c52d03$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $3bfcd8e655c52d03$var$Xb(e), a;
                if (f === d) return $3bfcd8e655c52d03$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($3bfcd8e655c52d03$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($3bfcd8e655c52d03$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($3bfcd8e655c52d03$var$p(190));
    }
    if (3 !== c.tag) throw Error($3bfcd8e655c52d03$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $3bfcd8e655c52d03$var$Zb(a) {
    a = $3bfcd8e655c52d03$var$Yb(a);
    return null !== a ? $3bfcd8e655c52d03$var$$b(a) : null;
}
function $3bfcd8e655c52d03$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $3bfcd8e655c52d03$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$ac = $9kLo3.unstable_scheduleCallback, $3bfcd8e655c52d03$var$bc = $9kLo3.unstable_cancelCallback, $3bfcd8e655c52d03$var$cc = $9kLo3.unstable_shouldYield, $3bfcd8e655c52d03$var$dc = $9kLo3.unstable_requestPaint, $3bfcd8e655c52d03$var$B = $9kLo3.unstable_now, $3bfcd8e655c52d03$var$ec = $9kLo3.unstable_getCurrentPriorityLevel, $3bfcd8e655c52d03$var$fc = $9kLo3.unstable_ImmediatePriority, $3bfcd8e655c52d03$var$gc = $9kLo3.unstable_UserBlockingPriority, $3bfcd8e655c52d03$var$hc = $9kLo3.unstable_NormalPriority, $3bfcd8e655c52d03$var$ic = $9kLo3.unstable_LowPriority, $3bfcd8e655c52d03$var$jc = $9kLo3.unstable_IdlePriority, $3bfcd8e655c52d03$var$kc = null, $3bfcd8e655c52d03$var$lc = null;
function $3bfcd8e655c52d03$var$mc(a) {
    if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onCommitFiberRoot) try {
        $3bfcd8e655c52d03$var$lc.onCommitFiberRoot($3bfcd8e655c52d03$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $3bfcd8e655c52d03$var$oc = Math.clz32 ? Math.clz32 : $3bfcd8e655c52d03$var$nc, $3bfcd8e655c52d03$var$pc = Math.log, $3bfcd8e655c52d03$var$qc = Math.LN2;
function $3bfcd8e655c52d03$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($3bfcd8e655c52d03$var$pc(a) / $3bfcd8e655c52d03$var$qc | 0) | 0;
}
var $3bfcd8e655c52d03$var$rc = 64, $3bfcd8e655c52d03$var$sc = 4194304;
function $3bfcd8e655c52d03$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $3bfcd8e655c52d03$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $3bfcd8e655c52d03$var$tc(h) : (f &= g, 0 !== f && (d = $3bfcd8e655c52d03$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $3bfcd8e655c52d03$var$tc(g) : 0 !== f && (d = $3bfcd8e655c52d03$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $3bfcd8e655c52d03$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $3bfcd8e655c52d03$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3bfcd8e655c52d03$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $3bfcd8e655c52d03$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $3bfcd8e655c52d03$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $3bfcd8e655c52d03$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $3bfcd8e655c52d03$var$yc() {
    var a = $3bfcd8e655c52d03$var$rc;
    $3bfcd8e655c52d03$var$rc <<= 1;
    0 === ($3bfcd8e655c52d03$var$rc & 4194240) && ($3bfcd8e655c52d03$var$rc = 64);
    return a;
}
function $3bfcd8e655c52d03$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $3bfcd8e655c52d03$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $3bfcd8e655c52d03$var$oc(b);
    a[b] = c;
}
function $3bfcd8e655c52d03$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $3bfcd8e655c52d03$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $3bfcd8e655c52d03$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $3bfcd8e655c52d03$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $3bfcd8e655c52d03$var$C = 0;
function $3bfcd8e655c52d03$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $3bfcd8e655c52d03$var$Ec, $3bfcd8e655c52d03$var$Fc, $3bfcd8e655c52d03$var$Gc, $3bfcd8e655c52d03$var$Hc, $3bfcd8e655c52d03$var$Ic, $3bfcd8e655c52d03$var$Jc = !1, $3bfcd8e655c52d03$var$Kc = [], $3bfcd8e655c52d03$var$Lc = null, $3bfcd8e655c52d03$var$Mc = null, $3bfcd8e655c52d03$var$Nc = null, $3bfcd8e655c52d03$var$Oc = new Map, $3bfcd8e655c52d03$var$Pc = new Map, $3bfcd8e655c52d03$var$Qc = [], $3bfcd8e655c52d03$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $3bfcd8e655c52d03$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $3bfcd8e655c52d03$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $3bfcd8e655c52d03$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $3bfcd8e655c52d03$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $3bfcd8e655c52d03$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3bfcd8e655c52d03$var$Pc.delete(b.pointerId);
    }
}
function $3bfcd8e655c52d03$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $3bfcd8e655c52d03$var$Cb(b), null !== b && $3bfcd8e655c52d03$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $3bfcd8e655c52d03$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $3bfcd8e655c52d03$var$Lc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $3bfcd8e655c52d03$var$Mc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $3bfcd8e655c52d03$var$Nc = $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $3bfcd8e655c52d03$var$Oc.set(f, $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $3bfcd8e655c52d03$var$Pc.set(f, $3bfcd8e655c52d03$var$Tc($3bfcd8e655c52d03$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $3bfcd8e655c52d03$var$Vc(a) {
    var b = $3bfcd8e655c52d03$var$Wc(a.target);
    if (null !== b) {
        var c = $3bfcd8e655c52d03$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $3bfcd8e655c52d03$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $3bfcd8e655c52d03$var$Ic(a.priority, function() {
                        $3bfcd8e655c52d03$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $3bfcd8e655c52d03$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $3bfcd8e655c52d03$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $3bfcd8e655c52d03$var$wb = d;
            c.target.dispatchEvent(d);
            $3bfcd8e655c52d03$var$wb = null;
        } else return b = $3bfcd8e655c52d03$var$Cb(c), null !== b && $3bfcd8e655c52d03$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Zc(a, b, c) {
    $3bfcd8e655c52d03$var$Xc(a) && c.delete(b);
}
function $3bfcd8e655c52d03$var$$c() {
    $3bfcd8e655c52d03$var$Jc = !1;
    null !== $3bfcd8e655c52d03$var$Lc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Lc) && ($3bfcd8e655c52d03$var$Lc = null);
    null !== $3bfcd8e655c52d03$var$Mc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Mc) && ($3bfcd8e655c52d03$var$Mc = null);
    null !== $3bfcd8e655c52d03$var$Nc && $3bfcd8e655c52d03$var$Xc($3bfcd8e655c52d03$var$Nc) && ($3bfcd8e655c52d03$var$Nc = null);
    $3bfcd8e655c52d03$var$Oc.forEach($3bfcd8e655c52d03$var$Zc);
    $3bfcd8e655c52d03$var$Pc.forEach($3bfcd8e655c52d03$var$Zc);
}
function $3bfcd8e655c52d03$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $3bfcd8e655c52d03$var$Jc || ($3bfcd8e655c52d03$var$Jc = !0, $9kLo3.unstable_scheduleCallback($9kLo3.unstable_NormalPriority, $3bfcd8e655c52d03$var$$c)));
}
function $3bfcd8e655c52d03$var$bd(a) {
    function b(b) {
        return $3bfcd8e655c52d03$var$ad(b, a);
    }
    if (0 < $3bfcd8e655c52d03$var$Kc.length) {
        $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Kc[0], a);
        for(var c = 1; c < $3bfcd8e655c52d03$var$Kc.length; c++){
            var d = $3bfcd8e655c52d03$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $3bfcd8e655c52d03$var$Lc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Lc, a);
    null !== $3bfcd8e655c52d03$var$Mc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Mc, a);
    null !== $3bfcd8e655c52d03$var$Nc && $3bfcd8e655c52d03$var$ad($3bfcd8e655c52d03$var$Nc, a);
    $3bfcd8e655c52d03$var$Oc.forEach(b);
    $3bfcd8e655c52d03$var$Pc.forEach(b);
    for(c = 0; c < $3bfcd8e655c52d03$var$Qc.length; c++)d = $3bfcd8e655c52d03$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $3bfcd8e655c52d03$var$Qc.length && (c = $3bfcd8e655c52d03$var$Qc[0], null === c.blockedOn);)$3bfcd8e655c52d03$var$Vc(c), null === c.blockedOn && $3bfcd8e655c52d03$var$Qc.shift();
}
var $3bfcd8e655c52d03$var$cd = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$dd = !0;
function $3bfcd8e655c52d03$var$ed(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$C, f = $3bfcd8e655c52d03$var$cd.transition;
    $3bfcd8e655c52d03$var$cd.transition = null;
    try {
        $3bfcd8e655c52d03$var$C = 1, $3bfcd8e655c52d03$var$fd(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$C = e, $3bfcd8e655c52d03$var$cd.transition = f;
    }
}
function $3bfcd8e655c52d03$var$gd(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$C, f = $3bfcd8e655c52d03$var$cd.transition;
    $3bfcd8e655c52d03$var$cd.transition = null;
    try {
        $3bfcd8e655c52d03$var$C = 4, $3bfcd8e655c52d03$var$fd(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$C = e, $3bfcd8e655c52d03$var$cd.transition = f;
    }
}
function $3bfcd8e655c52d03$var$fd(a, b, c, d) {
    if ($3bfcd8e655c52d03$var$dd) {
        var e = $3bfcd8e655c52d03$var$Yc(a, b, c, d);
        if (null === e) $3bfcd8e655c52d03$var$hd(a, b, d, $3bfcd8e655c52d03$var$id, c), $3bfcd8e655c52d03$var$Sc(a, d);
        else if ($3bfcd8e655c52d03$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($3bfcd8e655c52d03$var$Sc(a, d), b & 4 && -1 < $3bfcd8e655c52d03$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $3bfcd8e655c52d03$var$Cb(e);
                null !== f && $3bfcd8e655c52d03$var$Ec(f);
                f = $3bfcd8e655c52d03$var$Yc(a, b, c, d);
                null === f && $3bfcd8e655c52d03$var$hd(a, b, d, $3bfcd8e655c52d03$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $3bfcd8e655c52d03$var$hd(a, b, d, null, c);
    }
}
var $3bfcd8e655c52d03$var$id = null;
function $3bfcd8e655c52d03$var$Yc(a, b, c, d) {
    $3bfcd8e655c52d03$var$id = null;
    a = $3bfcd8e655c52d03$var$xb(d);
    a = $3bfcd8e655c52d03$var$Wc(a);
    if (null !== a) {
        if (b = $3bfcd8e655c52d03$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $3bfcd8e655c52d03$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $3bfcd8e655c52d03$var$id = a;
    return null;
}
function $3bfcd8e655c52d03$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($3bfcd8e655c52d03$var$ec()){
                case $3bfcd8e655c52d03$var$fc:
                    return 1;
                case $3bfcd8e655c52d03$var$gc:
                    return 4;
                case $3bfcd8e655c52d03$var$hc:
                case $3bfcd8e655c52d03$var$ic:
                    return 16;
                case $3bfcd8e655c52d03$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $3bfcd8e655c52d03$var$kd = null, $3bfcd8e655c52d03$var$ld = null, $3bfcd8e655c52d03$var$md = null;
function $3bfcd8e655c52d03$var$nd() {
    if ($3bfcd8e655c52d03$var$md) return $3bfcd8e655c52d03$var$md;
    var a, b = $3bfcd8e655c52d03$var$ld, c = b.length, d, e = "value" in $3bfcd8e655c52d03$var$kd ? $3bfcd8e655c52d03$var$kd.value : $3bfcd8e655c52d03$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $3bfcd8e655c52d03$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $3bfcd8e655c52d03$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $3bfcd8e655c52d03$var$pd() {
    return !0;
}
function $3bfcd8e655c52d03$var$qd() {
    return !1;
}
function $3bfcd8e655c52d03$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $3bfcd8e655c52d03$var$pd : $3bfcd8e655c52d03$var$qd;
        this.isPropagationStopped = $3bfcd8e655c52d03$var$qd;
        return this;
    }
    $3bfcd8e655c52d03$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $3bfcd8e655c52d03$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $3bfcd8e655c52d03$var$pd);
        },
        persist: function() {},
        isPersistent: $3bfcd8e655c52d03$var$pd
    });
    return b;
}
var $3bfcd8e655c52d03$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3bfcd8e655c52d03$var$td = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$sd), $3bfcd8e655c52d03$var$ud = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    view: 0,
    detail: 0
}), $3bfcd8e655c52d03$var$vd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$ud), $3bfcd8e655c52d03$var$wd, $3bfcd8e655c52d03$var$xd, $3bfcd8e655c52d03$var$yd, $3bfcd8e655c52d03$var$Ad = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $3bfcd8e655c52d03$var$yd && ($3bfcd8e655c52d03$var$yd && "mousemove" === a.type ? ($3bfcd8e655c52d03$var$wd = a.screenX - $3bfcd8e655c52d03$var$yd.screenX, $3bfcd8e655c52d03$var$xd = a.screenY - $3bfcd8e655c52d03$var$yd.screenY) : $3bfcd8e655c52d03$var$xd = $3bfcd8e655c52d03$var$wd = 0, $3bfcd8e655c52d03$var$yd = a);
        return $3bfcd8e655c52d03$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $3bfcd8e655c52d03$var$xd;
    }
}), $3bfcd8e655c52d03$var$Bd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ad), $3bfcd8e655c52d03$var$Cd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    dataTransfer: 0
}), $3bfcd8e655c52d03$var$Dd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Cd), $3bfcd8e655c52d03$var$Ed = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    relatedTarget: 0
}), $3bfcd8e655c52d03$var$Fd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ed), $3bfcd8e655c52d03$var$Gd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bfcd8e655c52d03$var$Hd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Gd), $3bfcd8e655c52d03$var$Id = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $3bfcd8e655c52d03$var$Jd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Id), $3bfcd8e655c52d03$var$Kd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    data: 0
}), $3bfcd8e655c52d03$var$Ld = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Kd), $3bfcd8e655c52d03$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3bfcd8e655c52d03$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3bfcd8e655c52d03$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3bfcd8e655c52d03$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $3bfcd8e655c52d03$var$Od[a]) ? !!b[a] : !1;
}
function $3bfcd8e655c52d03$var$zd() {
    return $3bfcd8e655c52d03$var$Pd;
}
var $3bfcd8e655c52d03$var$Qd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $3bfcd8e655c52d03$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $3bfcd8e655c52d03$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $3bfcd8e655c52d03$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $3bfcd8e655c52d03$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $3bfcd8e655c52d03$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $3bfcd8e655c52d03$var$Rd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Qd), $3bfcd8e655c52d03$var$Sd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3bfcd8e655c52d03$var$Td = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Sd), $3bfcd8e655c52d03$var$Ud = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3bfcd8e655c52d03$var$zd
}), $3bfcd8e655c52d03$var$Vd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Ud), $3bfcd8e655c52d03$var$Wd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3bfcd8e655c52d03$var$Xd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Wd), $3bfcd8e655c52d03$var$Yd = $3bfcd8e655c52d03$var$A({}, $3bfcd8e655c52d03$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3bfcd8e655c52d03$var$Zd = $3bfcd8e655c52d03$var$rd($3bfcd8e655c52d03$var$Yd), $3bfcd8e655c52d03$var$$d = [
    9,
    13,
    27,
    32
], $3bfcd8e655c52d03$var$ae = $3bfcd8e655c52d03$var$ia && "CompositionEvent" in window, $3bfcd8e655c52d03$var$be = null;
$3bfcd8e655c52d03$var$ia && "documentMode" in document && ($3bfcd8e655c52d03$var$be = document.documentMode);
var $3bfcd8e655c52d03$var$ce = $3bfcd8e655c52d03$var$ia && "TextEvent" in window && !$3bfcd8e655c52d03$var$be, $3bfcd8e655c52d03$var$de = $3bfcd8e655c52d03$var$ia && (!$3bfcd8e655c52d03$var$ae || $3bfcd8e655c52d03$var$be && 8 < $3bfcd8e655c52d03$var$be && 11 >= $3bfcd8e655c52d03$var$be), $3bfcd8e655c52d03$var$ee = String.fromCharCode(32), $3bfcd8e655c52d03$var$fe = !1;
function $3bfcd8e655c52d03$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $3bfcd8e655c52d03$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $3bfcd8e655c52d03$var$ie = !1;
function $3bfcd8e655c52d03$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $3bfcd8e655c52d03$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $3bfcd8e655c52d03$var$fe = !0;
            return $3bfcd8e655c52d03$var$ee;
        case "textInput":
            return a = b.data, a === $3bfcd8e655c52d03$var$ee && $3bfcd8e655c52d03$var$fe ? null : a;
        default:
            return null;
    }
}
function $3bfcd8e655c52d03$var$ke(a, b) {
    if ($3bfcd8e655c52d03$var$ie) return "compositionend" === a || !$3bfcd8e655c52d03$var$ae && $3bfcd8e655c52d03$var$ge(a, b) ? (a = $3bfcd8e655c52d03$var$nd(), $3bfcd8e655c52d03$var$md = $3bfcd8e655c52d03$var$ld = $3bfcd8e655c52d03$var$kd = null, $3bfcd8e655c52d03$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $3bfcd8e655c52d03$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $3bfcd8e655c52d03$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3bfcd8e655c52d03$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$3bfcd8e655c52d03$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $3bfcd8e655c52d03$var$ne(a, b, c, d) {
    $3bfcd8e655c52d03$var$Eb(d);
    b = $3bfcd8e655c52d03$var$oe(b, "onChange");
    0 < b.length && (c = new $3bfcd8e655c52d03$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $3bfcd8e655c52d03$var$pe = null, $3bfcd8e655c52d03$var$qe = null;
function $3bfcd8e655c52d03$var$re(a) {
    $3bfcd8e655c52d03$var$se(a, 0);
}
function $3bfcd8e655c52d03$var$te(a) {
    var b = $3bfcd8e655c52d03$var$ue(a);
    if ($3bfcd8e655c52d03$var$Wa(b)) return a;
}
function $3bfcd8e655c52d03$var$ve(a, b) {
    if ("change" === a) return b;
}
var $3bfcd8e655c52d03$var$we = !1;
if ($3bfcd8e655c52d03$var$ia) {
    var $3bfcd8e655c52d03$var$xe;
    if ($3bfcd8e655c52d03$var$ia) {
        var $3bfcd8e655c52d03$var$ye = "oninput" in document;
        if (!$3bfcd8e655c52d03$var$ye) {
            var $3bfcd8e655c52d03$var$ze = document.createElement("div");
            $3bfcd8e655c52d03$var$ze.setAttribute("oninput", "return;");
            $3bfcd8e655c52d03$var$ye = "function" === typeof $3bfcd8e655c52d03$var$ze.oninput;
        }
        $3bfcd8e655c52d03$var$xe = $3bfcd8e655c52d03$var$ye;
    } else $3bfcd8e655c52d03$var$xe = !1;
    $3bfcd8e655c52d03$var$we = $3bfcd8e655c52d03$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $3bfcd8e655c52d03$var$Ae() {
    $3bfcd8e655c52d03$var$pe && ($3bfcd8e655c52d03$var$pe.detachEvent("onpropertychange", $3bfcd8e655c52d03$var$Be), $3bfcd8e655c52d03$var$qe = $3bfcd8e655c52d03$var$pe = null);
}
function $3bfcd8e655c52d03$var$Be(a) {
    if ("value" === a.propertyName && $3bfcd8e655c52d03$var$te($3bfcd8e655c52d03$var$qe)) {
        var b = [];
        $3bfcd8e655c52d03$var$ne(b, $3bfcd8e655c52d03$var$qe, a, $3bfcd8e655c52d03$var$xb(a));
        $3bfcd8e655c52d03$var$Jb($3bfcd8e655c52d03$var$re, b);
    }
}
function $3bfcd8e655c52d03$var$Ce(a, b, c) {
    "focusin" === a ? ($3bfcd8e655c52d03$var$Ae(), $3bfcd8e655c52d03$var$pe = b, $3bfcd8e655c52d03$var$qe = c, $3bfcd8e655c52d03$var$pe.attachEvent("onpropertychange", $3bfcd8e655c52d03$var$Be)) : "focusout" === a && $3bfcd8e655c52d03$var$Ae();
}
function $3bfcd8e655c52d03$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $3bfcd8e655c52d03$var$te($3bfcd8e655c52d03$var$qe);
}
function $3bfcd8e655c52d03$var$Ee(a, b) {
    if ("click" === a) return $3bfcd8e655c52d03$var$te(b);
}
function $3bfcd8e655c52d03$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $3bfcd8e655c52d03$var$te(b);
}
function $3bfcd8e655c52d03$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $3bfcd8e655c52d03$var$He = "function" === typeof Object.is ? Object.is : $3bfcd8e655c52d03$var$Ge;
function $3bfcd8e655c52d03$var$Ie(a, b) {
    if ($3bfcd8e655c52d03$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$3bfcd8e655c52d03$var$ja.call(b, e) || !$3bfcd8e655c52d03$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $3bfcd8e655c52d03$var$Ke(a, b) {
    var c = $3bfcd8e655c52d03$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $3bfcd8e655c52d03$var$Je(c);
    }
}
function $3bfcd8e655c52d03$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $3bfcd8e655c52d03$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $3bfcd8e655c52d03$var$Me() {
    for(var a = window, b = $3bfcd8e655c52d03$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $3bfcd8e655c52d03$var$Xa(a.document);
    }
    return b;
}
function $3bfcd8e655c52d03$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $3bfcd8e655c52d03$var$Oe(a) {
    var b = $3bfcd8e655c52d03$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $3bfcd8e655c52d03$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $3bfcd8e655c52d03$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $3bfcd8e655c52d03$var$Ke(c, f);
                var g = $3bfcd8e655c52d03$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $3bfcd8e655c52d03$var$Pe = $3bfcd8e655c52d03$var$ia && "documentMode" in document && 11 >= document.documentMode, $3bfcd8e655c52d03$var$Qe = null, $3bfcd8e655c52d03$var$Re = null, $3bfcd8e655c52d03$var$Se = null, $3bfcd8e655c52d03$var$Te = !1;
function $3bfcd8e655c52d03$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $3bfcd8e655c52d03$var$Te || null == $3bfcd8e655c52d03$var$Qe || $3bfcd8e655c52d03$var$Qe !== $3bfcd8e655c52d03$var$Xa(d) || (d = $3bfcd8e655c52d03$var$Qe, "selectionStart" in d && $3bfcd8e655c52d03$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $3bfcd8e655c52d03$var$Se && $3bfcd8e655c52d03$var$Ie($3bfcd8e655c52d03$var$Se, d) || ($3bfcd8e655c52d03$var$Se = d, d = $3bfcd8e655c52d03$var$oe($3bfcd8e655c52d03$var$Re, "onSelect"), 0 < d.length && (b = new $3bfcd8e655c52d03$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $3bfcd8e655c52d03$var$Qe)));
}
function $3bfcd8e655c52d03$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $3bfcd8e655c52d03$var$We = {
    animationend: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationIteration"),
    animationstart: $3bfcd8e655c52d03$var$Ve("Animation", "AnimationStart"),
    transitionend: $3bfcd8e655c52d03$var$Ve("Transition", "TransitionEnd")
}, $3bfcd8e655c52d03$var$Xe = {}, $3bfcd8e655c52d03$var$Ye = {};
$3bfcd8e655c52d03$var$ia && ($3bfcd8e655c52d03$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $3bfcd8e655c52d03$var$We.animationend.animation, delete $3bfcd8e655c52d03$var$We.animationiteration.animation, delete $3bfcd8e655c52d03$var$We.animationstart.animation), "TransitionEvent" in window || delete $3bfcd8e655c52d03$var$We.transitionend.transition);
function $3bfcd8e655c52d03$var$Ze(a) {
    if ($3bfcd8e655c52d03$var$Xe[a]) return $3bfcd8e655c52d03$var$Xe[a];
    if (!$3bfcd8e655c52d03$var$We[a]) return a;
    var b = $3bfcd8e655c52d03$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $3bfcd8e655c52d03$var$Ye) return $3bfcd8e655c52d03$var$Xe[a] = b[c];
    return a;
}
var $3bfcd8e655c52d03$var$$e = $3bfcd8e655c52d03$var$Ze("animationend"), $3bfcd8e655c52d03$var$af = $3bfcd8e655c52d03$var$Ze("animationiteration"), $3bfcd8e655c52d03$var$bf = $3bfcd8e655c52d03$var$Ze("animationstart"), $3bfcd8e655c52d03$var$cf = $3bfcd8e655c52d03$var$Ze("transitionend"), $3bfcd8e655c52d03$var$df = new Map, $3bfcd8e655c52d03$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $3bfcd8e655c52d03$var$ff(a, b) {
    $3bfcd8e655c52d03$var$df.set(a, b);
    $3bfcd8e655c52d03$var$fa(b, [
        a
    ]);
}
for(var $3bfcd8e655c52d03$var$gf = 0; $3bfcd8e655c52d03$var$gf < $3bfcd8e655c52d03$var$ef.length; $3bfcd8e655c52d03$var$gf++){
    var $3bfcd8e655c52d03$var$hf = $3bfcd8e655c52d03$var$ef[$3bfcd8e655c52d03$var$gf], $3bfcd8e655c52d03$var$jf = $3bfcd8e655c52d03$var$hf.toLowerCase(), $3bfcd8e655c52d03$var$kf = $3bfcd8e655c52d03$var$hf[0].toUpperCase() + $3bfcd8e655c52d03$var$hf.slice(1);
    $3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$jf, "on" + $3bfcd8e655c52d03$var$kf);
}
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$$e, "onAnimationEnd");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$af, "onAnimationIteration");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$bf, "onAnimationStart");
$3bfcd8e655c52d03$var$ff("dblclick", "onDoubleClick");
$3bfcd8e655c52d03$var$ff("focusin", "onFocus");
$3bfcd8e655c52d03$var$ff("focusout", "onBlur");
$3bfcd8e655c52d03$var$ff($3bfcd8e655c52d03$var$cf, "onTransitionEnd");
$3bfcd8e655c52d03$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3bfcd8e655c52d03$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3bfcd8e655c52d03$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3bfcd8e655c52d03$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3bfcd8e655c52d03$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3bfcd8e655c52d03$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3bfcd8e655c52d03$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3bfcd8e655c52d03$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3bfcd8e655c52d03$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3bfcd8e655c52d03$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3bfcd8e655c52d03$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3bfcd8e655c52d03$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($3bfcd8e655c52d03$var$lf));
function $3bfcd8e655c52d03$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $3bfcd8e655c52d03$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $3bfcd8e655c52d03$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bfcd8e655c52d03$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $3bfcd8e655c52d03$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($3bfcd8e655c52d03$var$Qb) throw a = $3bfcd8e655c52d03$var$Rb, $3bfcd8e655c52d03$var$Qb = !1, $3bfcd8e655c52d03$var$Rb = null, a;
}
function $3bfcd8e655c52d03$var$D(a, b) {
    var c = b[$3bfcd8e655c52d03$var$of];
    void 0 === c && (c = b[$3bfcd8e655c52d03$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($3bfcd8e655c52d03$var$pf(b, a, 2, !1), c.add(d));
}
function $3bfcd8e655c52d03$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $3bfcd8e655c52d03$var$pf(c, a, d, b);
}
var $3bfcd8e655c52d03$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $3bfcd8e655c52d03$var$sf(a) {
    if (!a[$3bfcd8e655c52d03$var$rf]) {
        a[$3bfcd8e655c52d03$var$rf] = !0;
        $3bfcd8e655c52d03$var$da.forEach(function(b) {
            "selectionchange" !== b && ($3bfcd8e655c52d03$var$mf.has(b) || $3bfcd8e655c52d03$var$qf(b, !1, a), $3bfcd8e655c52d03$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$3bfcd8e655c52d03$var$rf] || (b[$3bfcd8e655c52d03$var$rf] = !0, $3bfcd8e655c52d03$var$qf("selectionchange", !1, b));
    }
}
function $3bfcd8e655c52d03$var$pf(a, b, c, d) {
    switch($3bfcd8e655c52d03$var$jd(b)){
        case 1:
            var e = $3bfcd8e655c52d03$var$ed;
            break;
        case 4:
            e = $3bfcd8e655c52d03$var$gd;
            break;
        default:
            e = $3bfcd8e655c52d03$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$3bfcd8e655c52d03$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $3bfcd8e655c52d03$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $3bfcd8e655c52d03$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $3bfcd8e655c52d03$var$Jb(function() {
        var d = f, e = $3bfcd8e655c52d03$var$xb(c), g = [];
        a: {
            var h = $3bfcd8e655c52d03$var$df.get(a);
            if (void 0 !== h) {
                var k = $3bfcd8e655c52d03$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $3bfcd8e655c52d03$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $3bfcd8e655c52d03$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $3bfcd8e655c52d03$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $3bfcd8e655c52d03$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $3bfcd8e655c52d03$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $3bfcd8e655c52d03$var$Vd;
                        break;
                    case $3bfcd8e655c52d03$var$$e:
                    case $3bfcd8e655c52d03$var$af:
                    case $3bfcd8e655c52d03$var$bf:
                        k = $3bfcd8e655c52d03$var$Hd;
                        break;
                    case $3bfcd8e655c52d03$var$cf:
                        k = $3bfcd8e655c52d03$var$Xd;
                        break;
                    case "scroll":
                        k = $3bfcd8e655c52d03$var$vd;
                        break;
                    case "wheel":
                        k = $3bfcd8e655c52d03$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $3bfcd8e655c52d03$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $3bfcd8e655c52d03$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $3bfcd8e655c52d03$var$Kb(w, x), null != F && t.push($3bfcd8e655c52d03$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $3bfcd8e655c52d03$var$wb && (n = c.relatedTarget || c.fromElement) && ($3bfcd8e655c52d03$var$Wc(n) || n[$3bfcd8e655c52d03$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $3bfcd8e655c52d03$var$Wc(n) : null, null !== n && (J = $3bfcd8e655c52d03$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $3bfcd8e655c52d03$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $3bfcd8e655c52d03$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $3bfcd8e655c52d03$var$ue(k);
                        u = null == n ? h : $3bfcd8e655c52d03$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $3bfcd8e655c52d03$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $3bfcd8e655c52d03$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $3bfcd8e655c52d03$var$vf(F))u++;
                            for(; 0 < w - u;)t = $3bfcd8e655c52d03$var$vf(t), w--;
                            for(; 0 < u - w;)x = $3bfcd8e655c52d03$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $3bfcd8e655c52d03$var$vf(t);
                                x = $3bfcd8e655c52d03$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $3bfcd8e655c52d03$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $3bfcd8e655c52d03$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $3bfcd8e655c52d03$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $3bfcd8e655c52d03$var$ve;
                else if ($3bfcd8e655c52d03$var$me(h)) {
                    if ($3bfcd8e655c52d03$var$we) na = $3bfcd8e655c52d03$var$Fe;
                    else {
                        na = $3bfcd8e655c52d03$var$De;
                        var xa = $3bfcd8e655c52d03$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $3bfcd8e655c52d03$var$Ee);
                if (na && (na = na(a, d))) {
                    $3bfcd8e655c52d03$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $3bfcd8e655c52d03$var$cb(h, "number", h.value);
            }
            xa = d ? $3bfcd8e655c52d03$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($3bfcd8e655c52d03$var$me(xa) || "true" === xa.contentEditable) $3bfcd8e655c52d03$var$Qe = xa, $3bfcd8e655c52d03$var$Re = d, $3bfcd8e655c52d03$var$Se = null;
                    break;
                case "focusout":
                    $3bfcd8e655c52d03$var$Se = $3bfcd8e655c52d03$var$Re = $3bfcd8e655c52d03$var$Qe = null;
                    break;
                case "mousedown":
                    $3bfcd8e655c52d03$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3bfcd8e655c52d03$var$Te = !1;
                    $3bfcd8e655c52d03$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($3bfcd8e655c52d03$var$Pe) break;
                case "keydown":
                case "keyup":
                    $3bfcd8e655c52d03$var$Ue(g, c, e);
            }
            var $a;
            if ($3bfcd8e655c52d03$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $3bfcd8e655c52d03$var$ie ? $3bfcd8e655c52d03$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($3bfcd8e655c52d03$var$de && "ko" !== c.locale && ($3bfcd8e655c52d03$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $3bfcd8e655c52d03$var$ie && ($a = $3bfcd8e655c52d03$var$nd()) : ($3bfcd8e655c52d03$var$kd = e, $3bfcd8e655c52d03$var$ld = "value" in $3bfcd8e655c52d03$var$kd ? $3bfcd8e655c52d03$var$kd.value : $3bfcd8e655c52d03$var$kd.textContent, $3bfcd8e655c52d03$var$ie = !0)), xa = $3bfcd8e655c52d03$var$oe(d, ba), 0 < xa.length && (ba = new $3bfcd8e655c52d03$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $3bfcd8e655c52d03$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $3bfcd8e655c52d03$var$ce ? $3bfcd8e655c52d03$var$je(a, c) : $3bfcd8e655c52d03$var$ke(a, c)) d = $3bfcd8e655c52d03$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $3bfcd8e655c52d03$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $3bfcd8e655c52d03$var$se(g, b);
    });
}
function $3bfcd8e655c52d03$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $3bfcd8e655c52d03$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $3bfcd8e655c52d03$var$Kb(a, c), null != f && d.unshift($3bfcd8e655c52d03$var$tf(a, f, e)), f = $3bfcd8e655c52d03$var$Kb(a, b), null != f && d.push($3bfcd8e655c52d03$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $3bfcd8e655c52d03$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $3bfcd8e655c52d03$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $3bfcd8e655c52d03$var$Kb(c, f), null != k && g.unshift($3bfcd8e655c52d03$var$tf(c, k, h))) : e || (k = $3bfcd8e655c52d03$var$Kb(c, f), null != k && g.push($3bfcd8e655c52d03$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $3bfcd8e655c52d03$var$xf = /\r\n?/g, $3bfcd8e655c52d03$var$yf = /\u0000|\uFFFD/g;
function $3bfcd8e655c52d03$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($3bfcd8e655c52d03$var$xf, "\n").replace($3bfcd8e655c52d03$var$yf, "");
}
function $3bfcd8e655c52d03$var$Af(a, b, c) {
    b = $3bfcd8e655c52d03$var$zf(b);
    if ($3bfcd8e655c52d03$var$zf(a) !== b && c) throw Error($3bfcd8e655c52d03$var$p(425));
}
function $3bfcd8e655c52d03$var$Bf() {}
var $3bfcd8e655c52d03$var$Cf = null, $3bfcd8e655c52d03$var$Df = null;
function $3bfcd8e655c52d03$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $3bfcd8e655c52d03$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $3bfcd8e655c52d03$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $3bfcd8e655c52d03$var$Hf = "function" === typeof Promise ? Promise : void 0, $3bfcd8e655c52d03$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3bfcd8e655c52d03$var$Hf ? function(a) {
    return $3bfcd8e655c52d03$var$Hf.resolve(null).then(a).catch($3bfcd8e655c52d03$var$If);
} : $3bfcd8e655c52d03$var$Ff;
function $3bfcd8e655c52d03$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $3bfcd8e655c52d03$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $3bfcd8e655c52d03$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $3bfcd8e655c52d03$var$bd(b);
}
function $3bfcd8e655c52d03$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$Nf = Math.random().toString(36).slice(2), $3bfcd8e655c52d03$var$Of = "__reactFiber$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Pf = "__reactProps$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$uf = "__reactContainer$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$of = "__reactEvents$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Qf = "__reactListeners$" + $3bfcd8e655c52d03$var$Nf, $3bfcd8e655c52d03$var$Rf = "__reactHandles$" + $3bfcd8e655c52d03$var$Nf;
function $3bfcd8e655c52d03$var$Wc(a) {
    var b = a[$3bfcd8e655c52d03$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$3bfcd8e655c52d03$var$uf] || c[$3bfcd8e655c52d03$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $3bfcd8e655c52d03$var$Mf(a); null !== a;){
                if (c = a[$3bfcd8e655c52d03$var$Of]) return c;
                a = $3bfcd8e655c52d03$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Cb(a) {
    a = a[$3bfcd8e655c52d03$var$Of] || a[$3bfcd8e655c52d03$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $3bfcd8e655c52d03$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($3bfcd8e655c52d03$var$p(33));
}
function $3bfcd8e655c52d03$var$Db(a) {
    return a[$3bfcd8e655c52d03$var$Pf] || null;
}
var $3bfcd8e655c52d03$var$Sf = [], $3bfcd8e655c52d03$var$Tf = -1;
function $3bfcd8e655c52d03$var$Uf(a) {
    return {
        current: a
    };
}
function $3bfcd8e655c52d03$var$E(a) {
    0 > $3bfcd8e655c52d03$var$Tf || (a.current = $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf], $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf] = null, $3bfcd8e655c52d03$var$Tf--);
}
function $3bfcd8e655c52d03$var$G(a, b) {
    $3bfcd8e655c52d03$var$Tf++;
    $3bfcd8e655c52d03$var$Sf[$3bfcd8e655c52d03$var$Tf] = a.current;
    a.current = b;
}
var $3bfcd8e655c52d03$var$Vf = {}, $3bfcd8e655c52d03$var$H = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$Vf), $3bfcd8e655c52d03$var$Wf = $3bfcd8e655c52d03$var$Uf(!1), $3bfcd8e655c52d03$var$Xf = $3bfcd8e655c52d03$var$Vf;
function $3bfcd8e655c52d03$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $3bfcd8e655c52d03$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $3bfcd8e655c52d03$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $3bfcd8e655c52d03$var$$f() {
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
}
function $3bfcd8e655c52d03$var$ag(a, b, c) {
    if ($3bfcd8e655c52d03$var$H.current !== $3bfcd8e655c52d03$var$Vf) throw Error($3bfcd8e655c52d03$var$p(168));
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, b);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, c);
}
function $3bfcd8e655c52d03$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($3bfcd8e655c52d03$var$p(108, $3bfcd8e655c52d03$var$Ra(a) || "Unknown", e));
    return $3bfcd8e655c52d03$var$A({}, c, d);
}
function $3bfcd8e655c52d03$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $3bfcd8e655c52d03$var$Vf;
    $3bfcd8e655c52d03$var$Xf = $3bfcd8e655c52d03$var$H.current;
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, a);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, $3bfcd8e655c52d03$var$Wf.current);
    return !0;
}
function $3bfcd8e655c52d03$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($3bfcd8e655c52d03$var$p(169));
    c ? (a = $3bfcd8e655c52d03$var$bg(a, b, $3bfcd8e655c52d03$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H), $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$H, a)) : $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wf, c);
}
var $3bfcd8e655c52d03$var$eg = null, $3bfcd8e655c52d03$var$fg = !1, $3bfcd8e655c52d03$var$gg = !1;
function $3bfcd8e655c52d03$var$hg(a) {
    null === $3bfcd8e655c52d03$var$eg ? $3bfcd8e655c52d03$var$eg = [
        a
    ] : $3bfcd8e655c52d03$var$eg.push(a);
}
function $3bfcd8e655c52d03$var$ig(a) {
    $3bfcd8e655c52d03$var$fg = !0;
    $3bfcd8e655c52d03$var$hg(a);
}
function $3bfcd8e655c52d03$var$jg() {
    if (!$3bfcd8e655c52d03$var$gg && null !== $3bfcd8e655c52d03$var$eg) {
        $3bfcd8e655c52d03$var$gg = !0;
        var a = 0, b = $3bfcd8e655c52d03$var$C;
        try {
            var c = $3bfcd8e655c52d03$var$eg;
            for($3bfcd8e655c52d03$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $3bfcd8e655c52d03$var$eg = null;
            $3bfcd8e655c52d03$var$fg = !1;
        } catch (e) {
            throw null !== $3bfcd8e655c52d03$var$eg && ($3bfcd8e655c52d03$var$eg = $3bfcd8e655c52d03$var$eg.slice(a + 1)), $3bfcd8e655c52d03$var$ac($3bfcd8e655c52d03$var$fc, $3bfcd8e655c52d03$var$jg), e;
        } finally{
            $3bfcd8e655c52d03$var$C = b, $3bfcd8e655c52d03$var$gg = !1;
        }
    }
    return null;
}
var $3bfcd8e655c52d03$var$kg = [], $3bfcd8e655c52d03$var$lg = 0, $3bfcd8e655c52d03$var$mg = null, $3bfcd8e655c52d03$var$ng = 0, $3bfcd8e655c52d03$var$og = [], $3bfcd8e655c52d03$var$pg = 0, $3bfcd8e655c52d03$var$qg = null, $3bfcd8e655c52d03$var$rg = 1, $3bfcd8e655c52d03$var$sg = "";
function $3bfcd8e655c52d03$var$tg(a, b) {
    $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg++] = $3bfcd8e655c52d03$var$ng;
    $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg++] = $3bfcd8e655c52d03$var$mg;
    $3bfcd8e655c52d03$var$mg = a;
    $3bfcd8e655c52d03$var$ng = b;
}
function $3bfcd8e655c52d03$var$ug(a, b, c) {
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$rg;
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$sg;
    $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$qg;
    $3bfcd8e655c52d03$var$qg = a;
    var d = $3bfcd8e655c52d03$var$rg;
    a = $3bfcd8e655c52d03$var$sg;
    var e = 32 - $3bfcd8e655c52d03$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $3bfcd8e655c52d03$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $3bfcd8e655c52d03$var$rg = 1 << 32 - $3bfcd8e655c52d03$var$oc(b) + e | c << e | d;
        $3bfcd8e655c52d03$var$sg = f + a;
    } else $3bfcd8e655c52d03$var$rg = 1 << f | c << e | d, $3bfcd8e655c52d03$var$sg = a;
}
function $3bfcd8e655c52d03$var$vg(a) {
    null !== a.return && ($3bfcd8e655c52d03$var$tg(a, 1), $3bfcd8e655c52d03$var$ug(a, 1, 0));
}
function $3bfcd8e655c52d03$var$wg(a) {
    for(; a === $3bfcd8e655c52d03$var$mg;)$3bfcd8e655c52d03$var$mg = $3bfcd8e655c52d03$var$kg[--$3bfcd8e655c52d03$var$lg], $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg] = null, $3bfcd8e655c52d03$var$ng = $3bfcd8e655c52d03$var$kg[--$3bfcd8e655c52d03$var$lg], $3bfcd8e655c52d03$var$kg[$3bfcd8e655c52d03$var$lg] = null;
    for(; a === $3bfcd8e655c52d03$var$qg;)$3bfcd8e655c52d03$var$qg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null, $3bfcd8e655c52d03$var$sg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null, $3bfcd8e655c52d03$var$rg = $3bfcd8e655c52d03$var$og[--$3bfcd8e655c52d03$var$pg], $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg] = null;
}
var $3bfcd8e655c52d03$var$xg = null, $3bfcd8e655c52d03$var$yg = null, $3bfcd8e655c52d03$var$I = !1, $3bfcd8e655c52d03$var$zg = null;
function $3bfcd8e655c52d03$var$Ag(a, b) {
    var c = $3bfcd8e655c52d03$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $3bfcd8e655c52d03$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $3bfcd8e655c52d03$var$qg ? {
                id: $3bfcd8e655c52d03$var$rg,
                overflow: $3bfcd8e655c52d03$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $3bfcd8e655c52d03$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $3bfcd8e655c52d03$var$xg = a, $3bfcd8e655c52d03$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $3bfcd8e655c52d03$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $3bfcd8e655c52d03$var$Eg(a) {
    if ($3bfcd8e655c52d03$var$I) {
        var b = $3bfcd8e655c52d03$var$yg;
        if (b) {
            var c = b;
            if (!$3bfcd8e655c52d03$var$Cg(a, b)) {
                if ($3bfcd8e655c52d03$var$Dg(a)) throw Error($3bfcd8e655c52d03$var$p(418));
                b = $3bfcd8e655c52d03$var$Lf(c.nextSibling);
                var d = $3bfcd8e655c52d03$var$xg;
                b && $3bfcd8e655c52d03$var$Cg(a, b) ? $3bfcd8e655c52d03$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $3bfcd8e655c52d03$var$I = !1, $3bfcd8e655c52d03$var$xg = a);
            }
        } else {
            if ($3bfcd8e655c52d03$var$Dg(a)) throw Error($3bfcd8e655c52d03$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $3bfcd8e655c52d03$var$I = !1;
            $3bfcd8e655c52d03$var$xg = a;
        }
    }
}
function $3bfcd8e655c52d03$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $3bfcd8e655c52d03$var$xg = a;
}
function $3bfcd8e655c52d03$var$Gg(a) {
    if (a !== $3bfcd8e655c52d03$var$xg) return !1;
    if (!$3bfcd8e655c52d03$var$I) return $3bfcd8e655c52d03$var$Fg(a), $3bfcd8e655c52d03$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$3bfcd8e655c52d03$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $3bfcd8e655c52d03$var$yg)) {
        if ($3bfcd8e655c52d03$var$Dg(a)) throw $3bfcd8e655c52d03$var$Hg(), Error($3bfcd8e655c52d03$var$p(418));
        for(; b;)$3bfcd8e655c52d03$var$Ag(a, b), b = $3bfcd8e655c52d03$var$Lf(b.nextSibling);
    }
    $3bfcd8e655c52d03$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($3bfcd8e655c52d03$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $3bfcd8e655c52d03$var$yg = null;
        }
    } else $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$xg ? $3bfcd8e655c52d03$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $3bfcd8e655c52d03$var$Hg() {
    for(var a = $3bfcd8e655c52d03$var$yg; a;)a = $3bfcd8e655c52d03$var$Lf(a.nextSibling);
}
function $3bfcd8e655c52d03$var$Ig() {
    $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$xg = null;
    $3bfcd8e655c52d03$var$I = !1;
}
function $3bfcd8e655c52d03$var$Jg(a) {
    null === $3bfcd8e655c52d03$var$zg ? $3bfcd8e655c52d03$var$zg = [
        a
    ] : $3bfcd8e655c52d03$var$zg.push(a);
}
var $3bfcd8e655c52d03$var$Kg = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig;
function $3bfcd8e655c52d03$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($3bfcd8e655c52d03$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($3bfcd8e655c52d03$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($3bfcd8e655c52d03$var$p(284));
        if (!c._owner) throw Error($3bfcd8e655c52d03$var$p(290, a));
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($3bfcd8e655c52d03$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $3bfcd8e655c52d03$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $3bfcd8e655c52d03$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $3bfcd8e655c52d03$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $3bfcd8e655c52d03$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $3bfcd8e655c52d03$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $3bfcd8e655c52d03$var$Ha && $3bfcd8e655c52d03$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $3bfcd8e655c52d03$var$Lg(a, b, c), d.return = a, d;
        d = $3bfcd8e655c52d03$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $3bfcd8e655c52d03$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $3bfcd8e655c52d03$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $3bfcd8e655c52d03$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $3bfcd8e655c52d03$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return c = $3bfcd8e655c52d03$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $3bfcd8e655c52d03$var$Lg(a, null, b), c.return = a, c;
                case $3bfcd8e655c52d03$var$wa:
                    return b = $3bfcd8e655c52d03$var$Sg(b, a.mode, c), b.return = a, b;
                case $3bfcd8e655c52d03$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($3bfcd8e655c52d03$var$eb(b) || $3bfcd8e655c52d03$var$Ka(b)) return b = $3bfcd8e655c52d03$var$Tg(b, a.mode, c, null), b.return = a, b;
            $3bfcd8e655c52d03$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $3bfcd8e655c52d03$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $3bfcd8e655c52d03$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($3bfcd8e655c52d03$var$eb(c) || $3bfcd8e655c52d03$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $3bfcd8e655c52d03$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $3bfcd8e655c52d03$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $3bfcd8e655c52d03$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($3bfcd8e655c52d03$var$eb(d) || $3bfcd8e655c52d03$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $3bfcd8e655c52d03$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $3bfcd8e655c52d03$var$Ka(h);
        if ("function" !== typeof l) throw Error($3bfcd8e655c52d03$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($3bfcd8e655c52d03$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $3bfcd8e655c52d03$var$I && $3bfcd8e655c52d03$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $3bfcd8e655c52d03$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $3bfcd8e655c52d03$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $3bfcd8e655c52d03$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $3bfcd8e655c52d03$var$Ha && $3bfcd8e655c52d03$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $3bfcd8e655c52d03$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $3bfcd8e655c52d03$var$ya ? (d = $3bfcd8e655c52d03$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $3bfcd8e655c52d03$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $3bfcd8e655c52d03$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $3bfcd8e655c52d03$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $3bfcd8e655c52d03$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $3bfcd8e655c52d03$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($3bfcd8e655c52d03$var$eb(f)) return n(a, d, f, h);
            if ($3bfcd8e655c52d03$var$Ka(f)) return t(a, d, f, h);
            $3bfcd8e655c52d03$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $3bfcd8e655c52d03$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $3bfcd8e655c52d03$var$Ug = $3bfcd8e655c52d03$var$Og(!0), $3bfcd8e655c52d03$var$Vg = $3bfcd8e655c52d03$var$Og(!1), $3bfcd8e655c52d03$var$Wg = $3bfcd8e655c52d03$var$Uf(null), $3bfcd8e655c52d03$var$Xg = null, $3bfcd8e655c52d03$var$Yg = null, $3bfcd8e655c52d03$var$Zg = null;
function $3bfcd8e655c52d03$var$$g() {
    $3bfcd8e655c52d03$var$Zg = $3bfcd8e655c52d03$var$Yg = $3bfcd8e655c52d03$var$Xg = null;
}
function $3bfcd8e655c52d03$var$ah(a) {
    var b = $3bfcd8e655c52d03$var$Wg.current;
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wg);
    a._currentValue = b;
}
function $3bfcd8e655c52d03$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $3bfcd8e655c52d03$var$ch(a, b) {
    $3bfcd8e655c52d03$var$Xg = a;
    $3bfcd8e655c52d03$var$Zg = $3bfcd8e655c52d03$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($3bfcd8e655c52d03$var$dh = !0), a.firstContext = null);
}
function $3bfcd8e655c52d03$var$eh(a) {
    var b = a._currentValue;
    if ($3bfcd8e655c52d03$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $3bfcd8e655c52d03$var$Yg) {
            if (null === $3bfcd8e655c52d03$var$Xg) throw Error($3bfcd8e655c52d03$var$p(308));
            $3bfcd8e655c52d03$var$Yg = a;
            $3bfcd8e655c52d03$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $3bfcd8e655c52d03$var$Yg = $3bfcd8e655c52d03$var$Yg.next = a;
    }
    return b;
}
var $3bfcd8e655c52d03$var$fh = null;
function $3bfcd8e655c52d03$var$gh(a) {
    null === $3bfcd8e655c52d03$var$fh ? $3bfcd8e655c52d03$var$fh = [
        a
    ] : $3bfcd8e655c52d03$var$fh.push(a);
}
function $3bfcd8e655c52d03$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $3bfcd8e655c52d03$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $3bfcd8e655c52d03$var$ih(a, d);
}
function $3bfcd8e655c52d03$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $3bfcd8e655c52d03$var$jh = !1;
function $3bfcd8e655c52d03$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $3bfcd8e655c52d03$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $3bfcd8e655c52d03$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3bfcd8e655c52d03$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($3bfcd8e655c52d03$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $3bfcd8e655c52d03$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $3bfcd8e655c52d03$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $3bfcd8e655c52d03$var$ih(a, c);
}
function $3bfcd8e655c52d03$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bfcd8e655c52d03$var$Cc(a, c);
    }
}
function $3bfcd8e655c52d03$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $3bfcd8e655c52d03$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $3bfcd8e655c52d03$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $3bfcd8e655c52d03$var$A({}, q, r);
                            break a;
                        case 2:
                            $3bfcd8e655c52d03$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $3bfcd8e655c52d03$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $3bfcd8e655c52d03$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($3bfcd8e655c52d03$var$p(191, e));
            e.call(d);
        }
    }
}
var $3bfcd8e655c52d03$var$th = {}, $3bfcd8e655c52d03$var$uh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th), $3bfcd8e655c52d03$var$vh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th), $3bfcd8e655c52d03$var$wh = $3bfcd8e655c52d03$var$Uf($3bfcd8e655c52d03$var$th);
function $3bfcd8e655c52d03$var$xh(a) {
    if (a === $3bfcd8e655c52d03$var$th) throw Error($3bfcd8e655c52d03$var$p(174));
    return a;
}
function $3bfcd8e655c52d03$var$yh(a, b) {
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$wh, b);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$vh, a);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, $3bfcd8e655c52d03$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $3bfcd8e655c52d03$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $3bfcd8e655c52d03$var$lb(b, a);
    }
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh);
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, b);
}
function $3bfcd8e655c52d03$var$zh() {
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$vh);
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$wh);
}
function $3bfcd8e655c52d03$var$Ah(a) {
    $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
    var b = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
    var c = $3bfcd8e655c52d03$var$lb(b, a.type);
    b !== c && ($3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$vh, a), $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$uh, c));
}
function $3bfcd8e655c52d03$var$Bh(a) {
    $3bfcd8e655c52d03$var$vh.current === a && ($3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$uh), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$vh));
}
var $3bfcd8e655c52d03$var$L = $3bfcd8e655c52d03$var$Uf(0);
function $3bfcd8e655c52d03$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $3bfcd8e655c52d03$var$Dh = [];
function $3bfcd8e655c52d03$var$Eh() {
    for(var a = 0; a < $3bfcd8e655c52d03$var$Dh.length; a++)$3bfcd8e655c52d03$var$Dh[a]._workInProgressVersionPrimary = null;
    $3bfcd8e655c52d03$var$Dh.length = 0;
}
var $3bfcd8e655c52d03$var$Fh = $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher, $3bfcd8e655c52d03$var$Gh = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$Hh = 0, $3bfcd8e655c52d03$var$M = null, $3bfcd8e655c52d03$var$N = null, $3bfcd8e655c52d03$var$O = null, $3bfcd8e655c52d03$var$Ih = !1, $3bfcd8e655c52d03$var$Jh = !1, $3bfcd8e655c52d03$var$Kh = 0, $3bfcd8e655c52d03$var$Lh = 0;
function $3bfcd8e655c52d03$var$P() {
    throw Error($3bfcd8e655c52d03$var$p(321));
}
function $3bfcd8e655c52d03$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$3bfcd8e655c52d03$var$He(a[c], b[c])) return !1;
    return !0;
}
function $3bfcd8e655c52d03$var$Nh(a, b, c, d, e, f) {
    $3bfcd8e655c52d03$var$Hh = f;
    $3bfcd8e655c52d03$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $3bfcd8e655c52d03$var$Fh.current = null === a || null === a.memoizedState ? $3bfcd8e655c52d03$var$Oh : $3bfcd8e655c52d03$var$Ph;
    a = c(d, e);
    if ($3bfcd8e655c52d03$var$Jh) {
        f = 0;
        do {
            $3bfcd8e655c52d03$var$Jh = !1;
            $3bfcd8e655c52d03$var$Kh = 0;
            if (25 <= f) throw Error($3bfcd8e655c52d03$var$p(301));
            f += 1;
            $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = null;
            b.updateQueue = null;
            $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Qh;
            a = c(d, e);
        }while ($3bfcd8e655c52d03$var$Jh);
    }
    $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Rh;
    b = null !== $3bfcd8e655c52d03$var$N && null !== $3bfcd8e655c52d03$var$N.next;
    $3bfcd8e655c52d03$var$Hh = 0;
    $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = $3bfcd8e655c52d03$var$M = null;
    $3bfcd8e655c52d03$var$Ih = !1;
    if (b) throw Error($3bfcd8e655c52d03$var$p(300));
    return a;
}
function $3bfcd8e655c52d03$var$Sh() {
    var a = 0 !== $3bfcd8e655c52d03$var$Kh;
    $3bfcd8e655c52d03$var$Kh = 0;
    return a;
}
function $3bfcd8e655c52d03$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState = $3bfcd8e655c52d03$var$O = a : $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$O.next = a;
    return $3bfcd8e655c52d03$var$O;
}
function $3bfcd8e655c52d03$var$Uh() {
    if (null === $3bfcd8e655c52d03$var$N) {
        var a = $3bfcd8e655c52d03$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $3bfcd8e655c52d03$var$N.next;
    var b = null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState : $3bfcd8e655c52d03$var$O.next;
    if (null !== b) $3bfcd8e655c52d03$var$O = b, $3bfcd8e655c52d03$var$N = a;
    else {
        if (null === a) throw Error($3bfcd8e655c52d03$var$p(310));
        $3bfcd8e655c52d03$var$N = a;
        a = {
            memoizedState: $3bfcd8e655c52d03$var$N.memoizedState,
            baseState: $3bfcd8e655c52d03$var$N.baseState,
            baseQueue: $3bfcd8e655c52d03$var$N.baseQueue,
            queue: $3bfcd8e655c52d03$var$N.queue,
            next: null
        };
        null === $3bfcd8e655c52d03$var$O ? $3bfcd8e655c52d03$var$M.memoizedState = $3bfcd8e655c52d03$var$O = a : $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$O.next = a;
    }
    return $3bfcd8e655c52d03$var$O;
}
function $3bfcd8e655c52d03$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $3bfcd8e655c52d03$var$Wh(a) {
    var b = $3bfcd8e655c52d03$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bfcd8e655c52d03$var$p(311));
    c.lastRenderedReducer = a;
    var d = $3bfcd8e655c52d03$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($3bfcd8e655c52d03$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $3bfcd8e655c52d03$var$M.lanes |= m;
                $3bfcd8e655c52d03$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $3bfcd8e655c52d03$var$He(d, b.memoizedState) || ($3bfcd8e655c52d03$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $3bfcd8e655c52d03$var$M.lanes |= f, $3bfcd8e655c52d03$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $3bfcd8e655c52d03$var$Xh(a) {
    var b = $3bfcd8e655c52d03$var$Uh(), c = b.queue;
    if (null === c) throw Error($3bfcd8e655c52d03$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $3bfcd8e655c52d03$var$He(f, b.memoizedState) || ($3bfcd8e655c52d03$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $3bfcd8e655c52d03$var$Yh() {}
function $3bfcd8e655c52d03$var$Zh(a, b) {
    var c = $3bfcd8e655c52d03$var$M, d = $3bfcd8e655c52d03$var$Uh(), e = b(), f = !$3bfcd8e655c52d03$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $3bfcd8e655c52d03$var$dh = !0);
    d = d.queue;
    $3bfcd8e655c52d03$var$$h($3bfcd8e655c52d03$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $3bfcd8e655c52d03$var$O && $3bfcd8e655c52d03$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $3bfcd8e655c52d03$var$bi(9, $3bfcd8e655c52d03$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $3bfcd8e655c52d03$var$Q) throw Error($3bfcd8e655c52d03$var$p(349));
        0 !== ($3bfcd8e655c52d03$var$Hh & 30) || $3bfcd8e655c52d03$var$di(c, b, e);
    }
    return e;
}
function $3bfcd8e655c52d03$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $3bfcd8e655c52d03$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bfcd8e655c52d03$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $3bfcd8e655c52d03$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $3bfcd8e655c52d03$var$ei(b) && $3bfcd8e655c52d03$var$fi(a);
}
function $3bfcd8e655c52d03$var$ai(a, b, c) {
    return c(function() {
        $3bfcd8e655c52d03$var$ei(b) && $3bfcd8e655c52d03$var$fi(a);
    });
}
function $3bfcd8e655c52d03$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$3bfcd8e655c52d03$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $3bfcd8e655c52d03$var$fi(a) {
    var b = $3bfcd8e655c52d03$var$ih(a, 1);
    null !== b && $3bfcd8e655c52d03$var$gi(b, a, 1, -1);
}
function $3bfcd8e655c52d03$var$hi(a) {
    var b = $3bfcd8e655c52d03$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3bfcd8e655c52d03$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $3bfcd8e655c52d03$var$ii.bind(null, $3bfcd8e655c52d03$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $3bfcd8e655c52d03$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $3bfcd8e655c52d03$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $3bfcd8e655c52d03$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $3bfcd8e655c52d03$var$ji() {
    return $3bfcd8e655c52d03$var$Uh().memoizedState;
}
function $3bfcd8e655c52d03$var$ki(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$Th();
    $3bfcd8e655c52d03$var$M.flags |= a;
    e.memoizedState = $3bfcd8e655c52d03$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $3bfcd8e655c52d03$var$li(a, b, c, d) {
    var e = $3bfcd8e655c52d03$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $3bfcd8e655c52d03$var$N) {
        var g = $3bfcd8e655c52d03$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $3bfcd8e655c52d03$var$Mh(d, g.deps)) {
            e.memoizedState = $3bfcd8e655c52d03$var$bi(b, c, f, d);
            return;
        }
    }
    $3bfcd8e655c52d03$var$M.flags |= a;
    e.memoizedState = $3bfcd8e655c52d03$var$bi(1 | b, c, f, d);
}
function $3bfcd8e655c52d03$var$mi(a, b) {
    return $3bfcd8e655c52d03$var$ki(8390656, 8, a, b);
}
function $3bfcd8e655c52d03$var$$h(a, b) {
    return $3bfcd8e655c52d03$var$li(2048, 8, a, b);
}
function $3bfcd8e655c52d03$var$ni(a, b) {
    return $3bfcd8e655c52d03$var$li(4, 2, a, b);
}
function $3bfcd8e655c52d03$var$oi(a, b) {
    return $3bfcd8e655c52d03$var$li(4, 4, a, b);
}
function $3bfcd8e655c52d03$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $3bfcd8e655c52d03$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $3bfcd8e655c52d03$var$li(4, 4, $3bfcd8e655c52d03$var$pi.bind(null, b, a), c);
}
function $3bfcd8e655c52d03$var$ri() {}
function $3bfcd8e655c52d03$var$si(a, b) {
    var c = $3bfcd8e655c52d03$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bfcd8e655c52d03$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bfcd8e655c52d03$var$ti(a, b) {
    var c = $3bfcd8e655c52d03$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $3bfcd8e655c52d03$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $3bfcd8e655c52d03$var$ui(a, b, c) {
    if (0 === ($3bfcd8e655c52d03$var$Hh & 21)) return a.baseState && (a.baseState = !1, $3bfcd8e655c52d03$var$dh = !0), a.memoizedState = c;
    $3bfcd8e655c52d03$var$He(c, b) || (c = $3bfcd8e655c52d03$var$yc(), $3bfcd8e655c52d03$var$M.lanes |= c, $3bfcd8e655c52d03$var$rh |= c, a.baseState = !0);
    return b;
}
function $3bfcd8e655c52d03$var$vi(a, b) {
    var c = $3bfcd8e655c52d03$var$C;
    $3bfcd8e655c52d03$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $3bfcd8e655c52d03$var$Gh.transition;
    $3bfcd8e655c52d03$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $3bfcd8e655c52d03$var$C = c, $3bfcd8e655c52d03$var$Gh.transition = d;
    }
}
function $3bfcd8e655c52d03$var$wi() {
    return $3bfcd8e655c52d03$var$Uh().memoizedState;
}
function $3bfcd8e655c52d03$var$xi(a, b, c) {
    var d = $3bfcd8e655c52d03$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bfcd8e655c52d03$var$zi(a)) $3bfcd8e655c52d03$var$Ai(b, c);
    else if (c = $3bfcd8e655c52d03$var$hh(a, b, c, d), null !== c) {
        var e = $3bfcd8e655c52d03$var$R();
        $3bfcd8e655c52d03$var$gi(c, a, d, e);
        $3bfcd8e655c52d03$var$Bi(c, b, d);
    }
}
function $3bfcd8e655c52d03$var$ii(a, b, c) {
    var d = $3bfcd8e655c52d03$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3bfcd8e655c52d03$var$zi(a)) $3bfcd8e655c52d03$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($3bfcd8e655c52d03$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $3bfcd8e655c52d03$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $3bfcd8e655c52d03$var$hh(a, b, e, d);
        null !== c && (e = $3bfcd8e655c52d03$var$R(), $3bfcd8e655c52d03$var$gi(c, a, d, e), $3bfcd8e655c52d03$var$Bi(c, b, d));
    }
}
function $3bfcd8e655c52d03$var$zi(a) {
    var b = a.alternate;
    return a === $3bfcd8e655c52d03$var$M || null !== b && b === $3bfcd8e655c52d03$var$M;
}
function $3bfcd8e655c52d03$var$Ai(a, b) {
    $3bfcd8e655c52d03$var$Jh = $3bfcd8e655c52d03$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $3bfcd8e655c52d03$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $3bfcd8e655c52d03$var$Cc(a, c);
    }
}
var $3bfcd8e655c52d03$var$Rh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$P,
    useContext: $3bfcd8e655c52d03$var$P,
    useEffect: $3bfcd8e655c52d03$var$P,
    useImperativeHandle: $3bfcd8e655c52d03$var$P,
    useInsertionEffect: $3bfcd8e655c52d03$var$P,
    useLayoutEffect: $3bfcd8e655c52d03$var$P,
    useMemo: $3bfcd8e655c52d03$var$P,
    useReducer: $3bfcd8e655c52d03$var$P,
    useRef: $3bfcd8e655c52d03$var$P,
    useState: $3bfcd8e655c52d03$var$P,
    useDebugValue: $3bfcd8e655c52d03$var$P,
    useDeferredValue: $3bfcd8e655c52d03$var$P,
    useTransition: $3bfcd8e655c52d03$var$P,
    useMutableSource: $3bfcd8e655c52d03$var$P,
    useSyncExternalStore: $3bfcd8e655c52d03$var$P,
    useId: $3bfcd8e655c52d03$var$P,
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Oh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: function(a, b) {
        $3bfcd8e655c52d03$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $3bfcd8e655c52d03$var$ki(4194308, 4, $3bfcd8e655c52d03$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $3bfcd8e655c52d03$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $3bfcd8e655c52d03$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $3bfcd8e655c52d03$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $3bfcd8e655c52d03$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $3bfcd8e655c52d03$var$xi.bind(null, $3bfcd8e655c52d03$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $3bfcd8e655c52d03$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $3bfcd8e655c52d03$var$hi,
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        return $3bfcd8e655c52d03$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$hi(!1), b = a[0];
        a = $3bfcd8e655c52d03$var$vi.bind(null, a[1]);
        $3bfcd8e655c52d03$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $3bfcd8e655c52d03$var$M, e = $3bfcd8e655c52d03$var$Th();
        if ($3bfcd8e655c52d03$var$I) {
            if (void 0 === c) throw Error($3bfcd8e655c52d03$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $3bfcd8e655c52d03$var$Q) throw Error($3bfcd8e655c52d03$var$p(349));
            0 !== ($3bfcd8e655c52d03$var$Hh & 30) || $3bfcd8e655c52d03$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $3bfcd8e655c52d03$var$mi($3bfcd8e655c52d03$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $3bfcd8e655c52d03$var$bi(9, $3bfcd8e655c52d03$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $3bfcd8e655c52d03$var$Th(), b = $3bfcd8e655c52d03$var$Q.identifierPrefix;
        if ($3bfcd8e655c52d03$var$I) {
            var c = $3bfcd8e655c52d03$var$sg;
            var d = $3bfcd8e655c52d03$var$rg;
            c = (d & ~(1 << 32 - $3bfcd8e655c52d03$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $3bfcd8e655c52d03$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $3bfcd8e655c52d03$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Ph = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$si,
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$$h,
    useImperativeHandle: $3bfcd8e655c52d03$var$qi,
    useInsertionEffect: $3bfcd8e655c52d03$var$ni,
    useLayoutEffect: $3bfcd8e655c52d03$var$oi,
    useMemo: $3bfcd8e655c52d03$var$ti,
    useReducer: $3bfcd8e655c52d03$var$Wh,
    useRef: $3bfcd8e655c52d03$var$ji,
    useState: function() {
        return $3bfcd8e655c52d03$var$Wh($3bfcd8e655c52d03$var$Vh);
    },
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        var b = $3bfcd8e655c52d03$var$Uh();
        return $3bfcd8e655c52d03$var$ui(b, $3bfcd8e655c52d03$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$Wh($3bfcd8e655c52d03$var$Vh)[0], b = $3bfcd8e655c52d03$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bfcd8e655c52d03$var$Yh,
    useSyncExternalStore: $3bfcd8e655c52d03$var$Zh,
    useId: $3bfcd8e655c52d03$var$wi,
    unstable_isNewReconciler: !1
}, $3bfcd8e655c52d03$var$Qh = {
    readContext: $3bfcd8e655c52d03$var$eh,
    useCallback: $3bfcd8e655c52d03$var$si,
    useContext: $3bfcd8e655c52d03$var$eh,
    useEffect: $3bfcd8e655c52d03$var$$h,
    useImperativeHandle: $3bfcd8e655c52d03$var$qi,
    useInsertionEffect: $3bfcd8e655c52d03$var$ni,
    useLayoutEffect: $3bfcd8e655c52d03$var$oi,
    useMemo: $3bfcd8e655c52d03$var$ti,
    useReducer: $3bfcd8e655c52d03$var$Xh,
    useRef: $3bfcd8e655c52d03$var$ji,
    useState: function() {
        return $3bfcd8e655c52d03$var$Xh($3bfcd8e655c52d03$var$Vh);
    },
    useDebugValue: $3bfcd8e655c52d03$var$ri,
    useDeferredValue: function(a) {
        var b = $3bfcd8e655c52d03$var$Uh();
        return null === $3bfcd8e655c52d03$var$N ? b.memoizedState = a : $3bfcd8e655c52d03$var$ui(b, $3bfcd8e655c52d03$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $3bfcd8e655c52d03$var$Xh($3bfcd8e655c52d03$var$Vh)[0], b = $3bfcd8e655c52d03$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $3bfcd8e655c52d03$var$Yh,
    useSyncExternalStore: $3bfcd8e655c52d03$var$Zh,
    useId: $3bfcd8e655c52d03$var$wi,
    unstable_isNewReconciler: !1
};
function $3bfcd8e655c52d03$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $3bfcd8e655c52d03$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $3bfcd8e655c52d03$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $3bfcd8e655c52d03$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $3bfcd8e655c52d03$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $3bfcd8e655c52d03$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bfcd8e655c52d03$var$R(), e = $3bfcd8e655c52d03$var$yi(a), f = $3bfcd8e655c52d03$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bfcd8e655c52d03$var$nh(a, f, e);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, e, d), $3bfcd8e655c52d03$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $3bfcd8e655c52d03$var$R(), e = $3bfcd8e655c52d03$var$yi(a), f = $3bfcd8e655c52d03$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $3bfcd8e655c52d03$var$nh(a, f, e);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, e, d), $3bfcd8e655c52d03$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $3bfcd8e655c52d03$var$R(), d = $3bfcd8e655c52d03$var$yi(a), e = $3bfcd8e655c52d03$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $3bfcd8e655c52d03$var$nh(a, e, d);
        null !== b && ($3bfcd8e655c52d03$var$gi(b, a, d, c), $3bfcd8e655c52d03$var$oh(b, a, d));
    }
};
function $3bfcd8e655c52d03$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$3bfcd8e655c52d03$var$Ie(c, d) || !$3bfcd8e655c52d03$var$Ie(e, f) : !0;
}
function $3bfcd8e655c52d03$var$Gi(a, b, c) {
    var d = !1, e = $3bfcd8e655c52d03$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $3bfcd8e655c52d03$var$eh(f) : (e = $3bfcd8e655c52d03$var$Zf(b) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $3bfcd8e655c52d03$var$Yf(a, e) : $3bfcd8e655c52d03$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $3bfcd8e655c52d03$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $3bfcd8e655c52d03$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $3bfcd8e655c52d03$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $3bfcd8e655c52d03$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $3bfcd8e655c52d03$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $3bfcd8e655c52d03$var$eh(f) : (f = $3bfcd8e655c52d03$var$Zf(b) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, e.context = $3bfcd8e655c52d03$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($3bfcd8e655c52d03$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $3bfcd8e655c52d03$var$Ei.enqueueReplaceState(e, e.state, null), $3bfcd8e655c52d03$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $3bfcd8e655c52d03$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $3bfcd8e655c52d03$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $3bfcd8e655c52d03$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $3bfcd8e655c52d03$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $3bfcd8e655c52d03$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $3bfcd8e655c52d03$var$Ni(a, b, c) {
    c = $3bfcd8e655c52d03$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $3bfcd8e655c52d03$var$Oi || ($3bfcd8e655c52d03$var$Oi = !0, $3bfcd8e655c52d03$var$Pi = d);
        $3bfcd8e655c52d03$var$Li(a, b);
    };
    return c;
}
function $3bfcd8e655c52d03$var$Qi(a, b, c) {
    c = $3bfcd8e655c52d03$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $3bfcd8e655c52d03$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $3bfcd8e655c52d03$var$Li(a, b);
        "function" !== typeof d && (null === $3bfcd8e655c52d03$var$Ri ? $3bfcd8e655c52d03$var$Ri = new Set([
            this
        ]) : $3bfcd8e655c52d03$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $3bfcd8e655c52d03$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $3bfcd8e655c52d03$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $3bfcd8e655c52d03$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $3bfcd8e655c52d03$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $3bfcd8e655c52d03$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $3bfcd8e655c52d03$var$mh(-1, 1), b.tag = 2, $3bfcd8e655c52d03$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $3bfcd8e655c52d03$var$Wi = $3bfcd8e655c52d03$var$ua.ReactCurrentOwner, $3bfcd8e655c52d03$var$dh = !1;
function $3bfcd8e655c52d03$var$Xi(a, b, c, d) {
    b.child = null === a ? $3bfcd8e655c52d03$var$Vg(b, null, c, d) : $3bfcd8e655c52d03$var$Ug(b, a.child, c, d);
}
function $3bfcd8e655c52d03$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $3bfcd8e655c52d03$var$ch(b, e);
    d = $3bfcd8e655c52d03$var$Nh(a, b, c, d, f, e);
    c = $3bfcd8e655c52d03$var$Sh();
    if (null !== a && !$3bfcd8e655c52d03$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bfcd8e655c52d03$var$Zi(a, b, e);
    $3bfcd8e655c52d03$var$I && c && $3bfcd8e655c52d03$var$vg(b);
    b.flags |= 1;
    $3bfcd8e655c52d03$var$Xi(a, b, d, e);
    return b.child;
}
function $3bfcd8e655c52d03$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$3bfcd8e655c52d03$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $3bfcd8e655c52d03$var$bj(a, b, f, d, e);
        a = $3bfcd8e655c52d03$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $3bfcd8e655c52d03$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $3bfcd8e655c52d03$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $3bfcd8e655c52d03$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $3bfcd8e655c52d03$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($3bfcd8e655c52d03$var$Ie(f, d) && a.ref === b.ref) {
            if ($3bfcd8e655c52d03$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($3bfcd8e655c52d03$var$dh = !0);
            else return b.lanes = a.lanes, $3bfcd8e655c52d03$var$Zi(a, b, e);
        }
    }
    return $3bfcd8e655c52d03$var$cj(a, b, c, d, e);
}
function $3bfcd8e655c52d03$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj);
            $3bfcd8e655c52d03$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$ej, $3bfcd8e655c52d03$var$fj), $3bfcd8e655c52d03$var$fj |= d;
    $3bfcd8e655c52d03$var$Xi(a, b, e, c);
    return b.child;
}
function $3bfcd8e655c52d03$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $3bfcd8e655c52d03$var$cj(a, b, c, d, e) {
    var f = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current;
    f = $3bfcd8e655c52d03$var$Yf(b, f);
    $3bfcd8e655c52d03$var$ch(b, e);
    c = $3bfcd8e655c52d03$var$Nh(a, b, c, d, f, e);
    d = $3bfcd8e655c52d03$var$Sh();
    if (null !== a && !$3bfcd8e655c52d03$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $3bfcd8e655c52d03$var$Zi(a, b, e);
    $3bfcd8e655c52d03$var$I && d && $3bfcd8e655c52d03$var$vg(b);
    b.flags |= 1;
    $3bfcd8e655c52d03$var$Xi(a, b, c, e);
    return b.child;
}
function $3bfcd8e655c52d03$var$hj(a, b, c, d, e) {
    if ($3bfcd8e655c52d03$var$Zf(c)) {
        var f = !0;
        $3bfcd8e655c52d03$var$cg(b);
    } else f = !1;
    $3bfcd8e655c52d03$var$ch(b, e);
    if (null === b.stateNode) $3bfcd8e655c52d03$var$ij(a, b), $3bfcd8e655c52d03$var$Gi(b, c, d), $3bfcd8e655c52d03$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $3bfcd8e655c52d03$var$eh(l) : (l = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, l = $3bfcd8e655c52d03$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $3bfcd8e655c52d03$var$Hi(b, g, d, l);
        $3bfcd8e655c52d03$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $3bfcd8e655c52d03$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $3bfcd8e655c52d03$var$Wf.current || $3bfcd8e655c52d03$var$jh ? ("function" === typeof m && ($3bfcd8e655c52d03$var$Di(b, c, m, d), k = b.memoizedState), (h = $3bfcd8e655c52d03$var$jh || $3bfcd8e655c52d03$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $3bfcd8e655c52d03$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $3bfcd8e655c52d03$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $3bfcd8e655c52d03$var$eh(k) : (k = $3bfcd8e655c52d03$var$Zf(c) ? $3bfcd8e655c52d03$var$Xf : $3bfcd8e655c52d03$var$H.current, k = $3bfcd8e655c52d03$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $3bfcd8e655c52d03$var$Hi(b, g, d, k);
        $3bfcd8e655c52d03$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $3bfcd8e655c52d03$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $3bfcd8e655c52d03$var$Wf.current || $3bfcd8e655c52d03$var$jh ? ("function" === typeof y && ($3bfcd8e655c52d03$var$Di(b, c, y, d), n = b.memoizedState), (l = $3bfcd8e655c52d03$var$jh || $3bfcd8e655c52d03$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $3bfcd8e655c52d03$var$jj(a, b, c, d, f, e);
}
function $3bfcd8e655c52d03$var$jj(a, b, c, d, e, f) {
    $3bfcd8e655c52d03$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $3bfcd8e655c52d03$var$dg(b, c, !1), $3bfcd8e655c52d03$var$Zi(a, b, f);
    d = b.stateNode;
    $3bfcd8e655c52d03$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $3bfcd8e655c52d03$var$Ug(b, a.child, null, f), b.child = $3bfcd8e655c52d03$var$Ug(b, null, h, f)) : $3bfcd8e655c52d03$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $3bfcd8e655c52d03$var$dg(b, c, !0);
    return b.child;
}
function $3bfcd8e655c52d03$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $3bfcd8e655c52d03$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $3bfcd8e655c52d03$var$ag(a, b.context, !1);
    $3bfcd8e655c52d03$var$yh(a, b.containerInfo);
}
function $3bfcd8e655c52d03$var$lj(a, b, c, d, e) {
    $3bfcd8e655c52d03$var$Ig();
    $3bfcd8e655c52d03$var$Jg(e);
    b.flags |= 256;
    $3bfcd8e655c52d03$var$Xi(a, b, c, d);
    return b.child;
}
var $3bfcd8e655c52d03$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $3bfcd8e655c52d03$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $3bfcd8e655c52d03$var$oj(a, b, c) {
    var d = b.pendingProps, e = $3bfcd8e655c52d03$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, e & 1);
    if (null === a) {
        $3bfcd8e655c52d03$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $3bfcd8e655c52d03$var$pj(g, d, 0, null), a = $3bfcd8e655c52d03$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $3bfcd8e655c52d03$var$nj(c), b.memoizedState = $3bfcd8e655c52d03$var$mj, a) : $3bfcd8e655c52d03$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $3bfcd8e655c52d03$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $3bfcd8e655c52d03$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $3bfcd8e655c52d03$var$Pg(h, f) : (f = $3bfcd8e655c52d03$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $3bfcd8e655c52d03$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $3bfcd8e655c52d03$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $3bfcd8e655c52d03$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $3bfcd8e655c52d03$var$qj(a, b) {
    b = $3bfcd8e655c52d03$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $3bfcd8e655c52d03$var$sj(a, b, c, d) {
    null !== d && $3bfcd8e655c52d03$var$Jg(d);
    $3bfcd8e655c52d03$var$Ug(b, a.child, null, c);
    a = $3bfcd8e655c52d03$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $3bfcd8e655c52d03$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $3bfcd8e655c52d03$var$Ki(Error($3bfcd8e655c52d03$var$p(422))), $3bfcd8e655c52d03$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $3bfcd8e655c52d03$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $3bfcd8e655c52d03$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $3bfcd8e655c52d03$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $3bfcd8e655c52d03$var$nj(g);
        b.memoizedState = $3bfcd8e655c52d03$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $3bfcd8e655c52d03$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($3bfcd8e655c52d03$var$p(419));
        d = $3bfcd8e655c52d03$var$Ki(f, d, void 0);
        return $3bfcd8e655c52d03$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($3bfcd8e655c52d03$var$dh || h) {
        d = $3bfcd8e655c52d03$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $3bfcd8e655c52d03$var$ih(a, e), $3bfcd8e655c52d03$var$gi(d, a, e, -1));
        }
        $3bfcd8e655c52d03$var$tj();
        d = $3bfcd8e655c52d03$var$Ki(Error($3bfcd8e655c52d03$var$p(421)));
        return $3bfcd8e655c52d03$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $3bfcd8e655c52d03$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(e.nextSibling);
    $3bfcd8e655c52d03$var$xg = b;
    $3bfcd8e655c52d03$var$I = !0;
    $3bfcd8e655c52d03$var$zg = null;
    null !== a && ($3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$rg, $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$sg, $3bfcd8e655c52d03$var$og[$3bfcd8e655c52d03$var$pg++] = $3bfcd8e655c52d03$var$qg, $3bfcd8e655c52d03$var$rg = a.id, $3bfcd8e655c52d03$var$sg = a.overflow, $3bfcd8e655c52d03$var$qg = b);
    b = $3bfcd8e655c52d03$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $3bfcd8e655c52d03$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $3bfcd8e655c52d03$var$bh(a.return, b, c);
}
function $3bfcd8e655c52d03$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $3bfcd8e655c52d03$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $3bfcd8e655c52d03$var$Xi(a, b, d.children, c);
    d = $3bfcd8e655c52d03$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $3bfcd8e655c52d03$var$vj(a, c, b);
            else if (19 === a.tag) $3bfcd8e655c52d03$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $3bfcd8e655c52d03$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $3bfcd8e655c52d03$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $3bfcd8e655c52d03$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $3bfcd8e655c52d03$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $3bfcd8e655c52d03$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $3bfcd8e655c52d03$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $3bfcd8e655c52d03$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $3bfcd8e655c52d03$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($3bfcd8e655c52d03$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $3bfcd8e655c52d03$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $3bfcd8e655c52d03$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $3bfcd8e655c52d03$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $3bfcd8e655c52d03$var$kj(b);
            $3bfcd8e655c52d03$var$Ig();
            break;
        case 5:
            $3bfcd8e655c52d03$var$Ah(b);
            break;
        case 1:
            $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$cg(b);
            break;
        case 4:
            $3bfcd8e655c52d03$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $3bfcd8e655c52d03$var$oj(a, b, c);
                $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1);
                a = $3bfcd8e655c52d03$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $3bfcd8e655c52d03$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $3bfcd8e655c52d03$var$dj(a, b, c);
    }
    return $3bfcd8e655c52d03$var$Zi(a, b, c);
}
var $3bfcd8e655c52d03$var$zj, $3bfcd8e655c52d03$var$Aj, $3bfcd8e655c52d03$var$Bj, $3bfcd8e655c52d03$var$Cj;
$3bfcd8e655c52d03$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$3bfcd8e655c52d03$var$Aj = function() {};
$3bfcd8e655c52d03$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $3bfcd8e655c52d03$var$Ya(a, e);
                d = $3bfcd8e655c52d03$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $3bfcd8e655c52d03$var$A({}, e, {
                    value: void 0
                });
                d = $3bfcd8e655c52d03$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $3bfcd8e655c52d03$var$gb(a, e);
                d = $3bfcd8e655c52d03$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $3bfcd8e655c52d03$var$Bf);
        }
        $3bfcd8e655c52d03$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $3bfcd8e655c52d03$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$3bfcd8e655c52d03$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $3bfcd8e655c52d03$var$Dj(a, b) {
    if (!$3bfcd8e655c52d03$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $3bfcd8e655c52d03$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $3bfcd8e655c52d03$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $3bfcd8e655c52d03$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3bfcd8e655c52d03$var$S(b), null;
        case 1:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), $3bfcd8e655c52d03$var$S(b), null;
        case 3:
            d = b.stateNode;
            $3bfcd8e655c52d03$var$zh();
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
            $3bfcd8e655c52d03$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $3bfcd8e655c52d03$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $3bfcd8e655c52d03$var$zg && ($3bfcd8e655c52d03$var$Fj($3bfcd8e655c52d03$var$zg), $3bfcd8e655c52d03$var$zg = null));
            $3bfcd8e655c52d03$var$Aj(a, b);
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 5:
            $3bfcd8e655c52d03$var$Bh(b);
            var e = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $3bfcd8e655c52d03$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($3bfcd8e655c52d03$var$p(166));
                    $3bfcd8e655c52d03$var$S(b);
                    return null;
                }
                a = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
                if ($3bfcd8e655c52d03$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$3bfcd8e655c52d03$var$Of] = b;
                    d[$3bfcd8e655c52d03$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $3bfcd8e655c52d03$var$D("cancel", d);
                            $3bfcd8e655c52d03$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $3bfcd8e655c52d03$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $3bfcd8e655c52d03$var$lf.length; e++)$3bfcd8e655c52d03$var$D($3bfcd8e655c52d03$var$lf[e], d);
                            break;
                        case "source":
                            $3bfcd8e655c52d03$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $3bfcd8e655c52d03$var$D("error", d);
                            $3bfcd8e655c52d03$var$D("load", d);
                            break;
                        case "details":
                            $3bfcd8e655c52d03$var$D("toggle", d);
                            break;
                        case "input":
                            $3bfcd8e655c52d03$var$Za(d, f);
                            $3bfcd8e655c52d03$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $3bfcd8e655c52d03$var$D("invalid", d);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$hb(d, f), $3bfcd8e655c52d03$var$D("invalid", d);
                    }
                    $3bfcd8e655c52d03$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $3bfcd8e655c52d03$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $3bfcd8e655c52d03$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $3bfcd8e655c52d03$var$Va(d);
                            $3bfcd8e655c52d03$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$Va(d);
                            $3bfcd8e655c52d03$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $3bfcd8e655c52d03$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $3bfcd8e655c52d03$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$3bfcd8e655c52d03$var$Of] = b;
                    a[$3bfcd8e655c52d03$var$Pf] = d;
                    $3bfcd8e655c52d03$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $3bfcd8e655c52d03$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $3bfcd8e655c52d03$var$D("cancel", a);
                                $3bfcd8e655c52d03$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $3bfcd8e655c52d03$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $3bfcd8e655c52d03$var$lf.length; e++)$3bfcd8e655c52d03$var$D($3bfcd8e655c52d03$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $3bfcd8e655c52d03$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $3bfcd8e655c52d03$var$D("error", a);
                                $3bfcd8e655c52d03$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $3bfcd8e655c52d03$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $3bfcd8e655c52d03$var$Za(a, d);
                                e = $3bfcd8e655c52d03$var$Ya(a, d);
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $3bfcd8e655c52d03$var$A({}, d, {
                                    value: void 0
                                });
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            case "textarea":
                                $3bfcd8e655c52d03$var$hb(a, d);
                                e = $3bfcd8e655c52d03$var$gb(a, d);
                                $3bfcd8e655c52d03$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $3bfcd8e655c52d03$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $3bfcd8e655c52d03$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $3bfcd8e655c52d03$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $3bfcd8e655c52d03$var$ob(a, k) : "number" === typeof k && $3bfcd8e655c52d03$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($3bfcd8e655c52d03$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $3bfcd8e655c52d03$var$D("scroll", a) : null != k && $3bfcd8e655c52d03$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $3bfcd8e655c52d03$var$Va(a);
                                $3bfcd8e655c52d03$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $3bfcd8e655c52d03$var$Va(a);
                                $3bfcd8e655c52d03$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $3bfcd8e655c52d03$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $3bfcd8e655c52d03$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $3bfcd8e655c52d03$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $3bfcd8e655c52d03$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $3bfcd8e655c52d03$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($3bfcd8e655c52d03$var$p(166));
                c = $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$wh.current);
                $3bfcd8e655c52d03$var$xh($3bfcd8e655c52d03$var$uh.current);
                if ($3bfcd8e655c52d03$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$3bfcd8e655c52d03$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $3bfcd8e655c52d03$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $3bfcd8e655c52d03$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $3bfcd8e655c52d03$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$3bfcd8e655c52d03$var$Of] = b, b.stateNode = d;
            }
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 13:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($3bfcd8e655c52d03$var$I && null !== $3bfcd8e655c52d03$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $3bfcd8e655c52d03$var$Hg(), $3bfcd8e655c52d03$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $3bfcd8e655c52d03$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($3bfcd8e655c52d03$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($3bfcd8e655c52d03$var$p(317));
                        f[$3bfcd8e655c52d03$var$Of] = b;
                    } else $3bfcd8e655c52d03$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $3bfcd8e655c52d03$var$S(b);
                    f = !1;
                } else null !== $3bfcd8e655c52d03$var$zg && ($3bfcd8e655c52d03$var$Fj($3bfcd8e655c52d03$var$zg), $3bfcd8e655c52d03$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($3bfcd8e655c52d03$var$L.current & 1) ? 0 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 3) : $3bfcd8e655c52d03$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 4:
            return $3bfcd8e655c52d03$var$zh(), $3bfcd8e655c52d03$var$Aj(a, b), null === a && $3bfcd8e655c52d03$var$sf(b.stateNode.containerInfo), $3bfcd8e655c52d03$var$S(b), null;
        case 10:
            return $3bfcd8e655c52d03$var$ah(b.type._context), $3bfcd8e655c52d03$var$S(b), null;
        case 17:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), $3bfcd8e655c52d03$var$S(b), null;
        case 19:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            f = b.memoizedState;
            if (null === f) return $3bfcd8e655c52d03$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $3bfcd8e655c52d03$var$Dj(f, !1);
                else {
                    if (0 !== $3bfcd8e655c52d03$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $3bfcd8e655c52d03$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $3bfcd8e655c52d03$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, $3bfcd8e655c52d03$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $3bfcd8e655c52d03$var$B() > $3bfcd8e655c52d03$var$Gj && (b.flags |= 128, d = !0, $3bfcd8e655c52d03$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $3bfcd8e655c52d03$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $3bfcd8e655c52d03$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$3bfcd8e655c52d03$var$I) return $3bfcd8e655c52d03$var$S(b), null;
                    } else 2 * $3bfcd8e655c52d03$var$B() - f.renderingStartTime > $3bfcd8e655c52d03$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $3bfcd8e655c52d03$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $3bfcd8e655c52d03$var$B(), b.sibling = null, c = $3bfcd8e655c52d03$var$L.current, $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$L, d ? c & 1 | 2 : c & 1), b;
            $3bfcd8e655c52d03$var$S(b);
            return null;
        case 22:
        case 23:
            return $3bfcd8e655c52d03$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($3bfcd8e655c52d03$var$fj & 1073741824) && ($3bfcd8e655c52d03$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $3bfcd8e655c52d03$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($3bfcd8e655c52d03$var$p(156, b.tag));
}
function $3bfcd8e655c52d03$var$Ij(a, b) {
    $3bfcd8e655c52d03$var$wg(b);
    switch(b.tag){
        case 1:
            return $3bfcd8e655c52d03$var$Zf(b.type) && $3bfcd8e655c52d03$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $3bfcd8e655c52d03$var$zh(), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf), $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H), $3bfcd8e655c52d03$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $3bfcd8e655c52d03$var$Bh(b), null;
        case 13:
            $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($3bfcd8e655c52d03$var$p(340));
                $3bfcd8e655c52d03$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L), null;
        case 4:
            return $3bfcd8e655c52d03$var$zh(), null;
        case 10:
            return $3bfcd8e655c52d03$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $3bfcd8e655c52d03$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $3bfcd8e655c52d03$var$Jj = !1, $3bfcd8e655c52d03$var$U = !1, $3bfcd8e655c52d03$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $3bfcd8e655c52d03$var$V = null;
function $3bfcd8e655c52d03$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $3bfcd8e655c52d03$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $3bfcd8e655c52d03$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $3bfcd8e655c52d03$var$W(a, b, d);
    }
}
var $3bfcd8e655c52d03$var$Nj = !1;
function $3bfcd8e655c52d03$var$Oj(a, b) {
    $3bfcd8e655c52d03$var$Cf = $3bfcd8e655c52d03$var$dd;
    a = $3bfcd8e655c52d03$var$Me();
    if ($3bfcd8e655c52d03$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $3bfcd8e655c52d03$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $3bfcd8e655c52d03$var$dd = !1;
    for($3bfcd8e655c52d03$var$V = b; null !== $3bfcd8e655c52d03$var$V;)if (b = $3bfcd8e655c52d03$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $3bfcd8e655c52d03$var$V = a;
    else for(; null !== $3bfcd8e655c52d03$var$V;){
        b = $3bfcd8e655c52d03$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $3bfcd8e655c52d03$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(163));
            }
        } catch (F) {
            $3bfcd8e655c52d03$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $3bfcd8e655c52d03$var$V = a;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
    n = $3bfcd8e655c52d03$var$Nj;
    $3bfcd8e655c52d03$var$Nj = !1;
    return n;
}
function $3bfcd8e655c52d03$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $3bfcd8e655c52d03$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $3bfcd8e655c52d03$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $3bfcd8e655c52d03$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $3bfcd8e655c52d03$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $3bfcd8e655c52d03$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$3bfcd8e655c52d03$var$Of], delete b[$3bfcd8e655c52d03$var$Pf], delete b[$3bfcd8e655c52d03$var$of], delete b[$3bfcd8e655c52d03$var$Qf], delete b[$3bfcd8e655c52d03$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $3bfcd8e655c52d03$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $3bfcd8e655c52d03$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $3bfcd8e655c52d03$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $3bfcd8e655c52d03$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $3bfcd8e655c52d03$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($3bfcd8e655c52d03$var$Vj(a, b, c), a = a.sibling; null !== a;)$3bfcd8e655c52d03$var$Vj(a, b, c), a = a.sibling;
}
function $3bfcd8e655c52d03$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($3bfcd8e655c52d03$var$Wj(a, b, c), a = a.sibling; null !== a;)$3bfcd8e655c52d03$var$Wj(a, b, c), a = a.sibling;
}
var $3bfcd8e655c52d03$var$X = null, $3bfcd8e655c52d03$var$Xj = !1;
function $3bfcd8e655c52d03$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$3bfcd8e655c52d03$var$Zj(a, b, c), c = c.sibling;
}
function $3bfcd8e655c52d03$var$Zj(a, b, c) {
    if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onCommitFiberUnmount) try {
        $3bfcd8e655c52d03$var$lc.onCommitFiberUnmount($3bfcd8e655c52d03$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $3bfcd8e655c52d03$var$U || $3bfcd8e655c52d03$var$Lj(c, b);
        case 6:
            var d = $3bfcd8e655c52d03$var$X, e = $3bfcd8e655c52d03$var$Xj;
            $3bfcd8e655c52d03$var$X = null;
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            $3bfcd8e655c52d03$var$X = d;
            $3bfcd8e655c52d03$var$Xj = e;
            null !== $3bfcd8e655c52d03$var$X && ($3bfcd8e655c52d03$var$Xj ? (a = $3bfcd8e655c52d03$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $3bfcd8e655c52d03$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $3bfcd8e655c52d03$var$X && ($3bfcd8e655c52d03$var$Xj ? (a = $3bfcd8e655c52d03$var$X, c = c.stateNode, 8 === a.nodeType ? $3bfcd8e655c52d03$var$Kf(a.parentNode, c) : 1 === a.nodeType && $3bfcd8e655c52d03$var$Kf(a, c), $3bfcd8e655c52d03$var$bd(a)) : $3bfcd8e655c52d03$var$Kf($3bfcd8e655c52d03$var$X, c.stateNode));
            break;
        case 4:
            d = $3bfcd8e655c52d03$var$X;
            e = $3bfcd8e655c52d03$var$Xj;
            $3bfcd8e655c52d03$var$X = c.stateNode.containerInfo;
            $3bfcd8e655c52d03$var$Xj = !0;
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            $3bfcd8e655c52d03$var$X = d;
            $3bfcd8e655c52d03$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$3bfcd8e655c52d03$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $3bfcd8e655c52d03$var$Mj(c, b, g) : 0 !== (f & 4) && $3bfcd8e655c52d03$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 1:
            if (!$3bfcd8e655c52d03$var$U && ($3bfcd8e655c52d03$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $3bfcd8e655c52d03$var$W(c, b, h);
            }
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 21:
            $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($3bfcd8e655c52d03$var$U = (d = $3bfcd8e655c52d03$var$U) || null !== c.memoizedState, $3bfcd8e655c52d03$var$Yj(a, b, c), $3bfcd8e655c52d03$var$U = d) : $3bfcd8e655c52d03$var$Yj(a, b, c);
            break;
        default:
            $3bfcd8e655c52d03$var$Yj(a, b, c);
    }
}
function $3bfcd8e655c52d03$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $3bfcd8e655c52d03$var$Kj);
        b.forEach(function(b) {
            var d = $3bfcd8e655c52d03$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $3bfcd8e655c52d03$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $3bfcd8e655c52d03$var$X = h.stateNode;
                        $3bfcd8e655c52d03$var$Xj = !1;
                        break a;
                    case 3:
                        $3bfcd8e655c52d03$var$X = h.stateNode.containerInfo;
                        $3bfcd8e655c52d03$var$Xj = !0;
                        break a;
                    case 4:
                        $3bfcd8e655c52d03$var$X = h.stateNode.containerInfo;
                        $3bfcd8e655c52d03$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $3bfcd8e655c52d03$var$X) throw Error($3bfcd8e655c52d03$var$p(160));
            $3bfcd8e655c52d03$var$Zj(f, g, e);
            $3bfcd8e655c52d03$var$X = null;
            $3bfcd8e655c52d03$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $3bfcd8e655c52d03$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$3bfcd8e655c52d03$var$dk(b, a), b = b.sibling;
}
function $3bfcd8e655c52d03$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4) {
                try {
                    $3bfcd8e655c52d03$var$Pj(3, a, a.return), $3bfcd8e655c52d03$var$Qj(3, a);
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
                try {
                    $3bfcd8e655c52d03$var$Pj(5, a, a.return);
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 512 && null !== c && $3bfcd8e655c52d03$var$Lj(c, c.return);
            break;
        case 5:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 512 && null !== c && $3bfcd8e655c52d03$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $3bfcd8e655c52d03$var$ob(e, "");
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $3bfcd8e655c52d03$var$ab(e, f);
                    $3bfcd8e655c52d03$var$vb(h, g);
                    var l = $3bfcd8e655c52d03$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $3bfcd8e655c52d03$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $3bfcd8e655c52d03$var$nb(e, q) : "children" === m ? $3bfcd8e655c52d03$var$ob(e, q) : $3bfcd8e655c52d03$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $3bfcd8e655c52d03$var$bb(e, f);
                            break;
                        case "textarea":
                            $3bfcd8e655c52d03$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $3bfcd8e655c52d03$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $3bfcd8e655c52d03$var$fb(e, !!f.multiple, f.defaultValue, !0) : $3bfcd8e655c52d03$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$3bfcd8e655c52d03$var$Pf] = f;
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($3bfcd8e655c52d03$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $3bfcd8e655c52d03$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $3bfcd8e655c52d03$var$bd(b.containerInfo);
            } catch (t) {
                $3bfcd8e655c52d03$var$W(a, a.return, t);
            }
            break;
        case 4:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            break;
        case 13:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($3bfcd8e655c52d03$var$fk = $3bfcd8e655c52d03$var$B()));
            d & 4 && $3bfcd8e655c52d03$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($3bfcd8e655c52d03$var$U = (l = $3bfcd8e655c52d03$var$U) || m, $3bfcd8e655c52d03$var$ck(b, a), $3bfcd8e655c52d03$var$U = l) : $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($3bfcd8e655c52d03$var$V = a, m = a.child; null !== m;){
                    for(q = $3bfcd8e655c52d03$var$V = m; null !== $3bfcd8e655c52d03$var$V;){
                        r = $3bfcd8e655c52d03$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $3bfcd8e655c52d03$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $3bfcd8e655c52d03$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $3bfcd8e655c52d03$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $3bfcd8e655c52d03$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $3bfcd8e655c52d03$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $3bfcd8e655c52d03$var$V = y) : $3bfcd8e655c52d03$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $3bfcd8e655c52d03$var$rb("display", g));
                            } catch (t) {
                                $3bfcd8e655c52d03$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $3bfcd8e655c52d03$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $3bfcd8e655c52d03$var$ck(b, a);
            $3bfcd8e655c52d03$var$ek(a);
            d & 4 && $3bfcd8e655c52d03$var$ak(a);
            break;
        case 21:
            break;
        default:
            $3bfcd8e655c52d03$var$ck(b, a), $3bfcd8e655c52d03$var$ek(a);
    }
}
function $3bfcd8e655c52d03$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($3bfcd8e655c52d03$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($3bfcd8e655c52d03$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($3bfcd8e655c52d03$var$ob(e, ""), d.flags &= -33);
                    var f = $3bfcd8e655c52d03$var$Uj(a);
                    $3bfcd8e655c52d03$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $3bfcd8e655c52d03$var$Uj(a);
                    $3bfcd8e655c52d03$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(161));
            }
        } catch (k) {
            $3bfcd8e655c52d03$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $3bfcd8e655c52d03$var$hk(a, b, c) {
    $3bfcd8e655c52d03$var$V = a;
    $3bfcd8e655c52d03$var$ik(a, b, c);
}
function $3bfcd8e655c52d03$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $3bfcd8e655c52d03$var$V;){
        var e = $3bfcd8e655c52d03$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $3bfcd8e655c52d03$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $3bfcd8e655c52d03$var$U;
                h = $3bfcd8e655c52d03$var$Jj;
                var l = $3bfcd8e655c52d03$var$U;
                $3bfcd8e655c52d03$var$Jj = g;
                if (($3bfcd8e655c52d03$var$U = k) && !l) for($3bfcd8e655c52d03$var$V = e; null !== $3bfcd8e655c52d03$var$V;)g = $3bfcd8e655c52d03$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $3bfcd8e655c52d03$var$jk(e) : null !== k ? (k.return = g, $3bfcd8e655c52d03$var$V = k) : $3bfcd8e655c52d03$var$jk(e);
                for(; null !== f;)$3bfcd8e655c52d03$var$V = f, $3bfcd8e655c52d03$var$ik(f, b, c), f = f.sibling;
                $3bfcd8e655c52d03$var$V = e;
                $3bfcd8e655c52d03$var$Jj = h;
                $3bfcd8e655c52d03$var$U = l;
            }
            $3bfcd8e655c52d03$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $3bfcd8e655c52d03$var$V = f) : $3bfcd8e655c52d03$var$kk(a, b, c);
    }
}
function $3bfcd8e655c52d03$var$kk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $3bfcd8e655c52d03$var$U || $3bfcd8e655c52d03$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$3bfcd8e655c52d03$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $3bfcd8e655c52d03$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $3bfcd8e655c52d03$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $3bfcd8e655c52d03$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $3bfcd8e655c52d03$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($3bfcd8e655c52d03$var$p(163));
                }
                $3bfcd8e655c52d03$var$U || b.flags & 512 && $3bfcd8e655c52d03$var$Rj(b);
            } catch (r) {
                $3bfcd8e655c52d03$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bfcd8e655c52d03$var$V = c;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
function $3bfcd8e655c52d03$var$gk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $3bfcd8e655c52d03$var$V = c;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
function $3bfcd8e655c52d03$var$jk(a) {
    for(; null !== $3bfcd8e655c52d03$var$V;){
        var b = $3bfcd8e655c52d03$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Qj(4, b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $3bfcd8e655c52d03$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Rj(b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $3bfcd8e655c52d03$var$Rj(b);
                    } catch (k) {
                        $3bfcd8e655c52d03$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $3bfcd8e655c52d03$var$W(b, b.return, k);
        }
        if (b === a) {
            $3bfcd8e655c52d03$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $3bfcd8e655c52d03$var$V = h;
            break;
        }
        $3bfcd8e655c52d03$var$V = b.return;
    }
}
var $3bfcd8e655c52d03$var$lk = Math.ceil, $3bfcd8e655c52d03$var$mk = $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher, $3bfcd8e655c52d03$var$nk = $3bfcd8e655c52d03$var$ua.ReactCurrentOwner, $3bfcd8e655c52d03$var$ok = $3bfcd8e655c52d03$var$ua.ReactCurrentBatchConfig, $3bfcd8e655c52d03$var$K = 0, $3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Y = null, $3bfcd8e655c52d03$var$Z = 0, $3bfcd8e655c52d03$var$fj = 0, $3bfcd8e655c52d03$var$ej = $3bfcd8e655c52d03$var$Uf(0), $3bfcd8e655c52d03$var$T = 0, $3bfcd8e655c52d03$var$pk = null, $3bfcd8e655c52d03$var$rh = 0, $3bfcd8e655c52d03$var$qk = 0, $3bfcd8e655c52d03$var$rk = 0, $3bfcd8e655c52d03$var$sk = null, $3bfcd8e655c52d03$var$tk = null, $3bfcd8e655c52d03$var$fk = 0, $3bfcd8e655c52d03$var$Gj = Infinity, $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Oi = !1, $3bfcd8e655c52d03$var$Pi = null, $3bfcd8e655c52d03$var$Ri = null, $3bfcd8e655c52d03$var$vk = !1, $3bfcd8e655c52d03$var$wk = null, $3bfcd8e655c52d03$var$xk = 0, $3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = null, $3bfcd8e655c52d03$var$Ak = -1, $3bfcd8e655c52d03$var$Bk = 0;
function $3bfcd8e655c52d03$var$R() {
    return 0 !== ($3bfcd8e655c52d03$var$K & 6) ? $3bfcd8e655c52d03$var$B() : -1 !== $3bfcd8e655c52d03$var$Ak ? $3bfcd8e655c52d03$var$Ak : $3bfcd8e655c52d03$var$Ak = $3bfcd8e655c52d03$var$B();
}
function $3bfcd8e655c52d03$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($3bfcd8e655c52d03$var$K & 2) && 0 !== $3bfcd8e655c52d03$var$Z) return $3bfcd8e655c52d03$var$Z & -$3bfcd8e655c52d03$var$Z;
    if (null !== $3bfcd8e655c52d03$var$Kg.transition) return 0 === $3bfcd8e655c52d03$var$Bk && ($3bfcd8e655c52d03$var$Bk = $3bfcd8e655c52d03$var$yc()), $3bfcd8e655c52d03$var$Bk;
    a = $3bfcd8e655c52d03$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $3bfcd8e655c52d03$var$jd(a.type);
    return a;
}
function $3bfcd8e655c52d03$var$gi(a, b, c, d) {
    if (50 < $3bfcd8e655c52d03$var$yk) throw $3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = null, Error($3bfcd8e655c52d03$var$p(185));
    $3bfcd8e655c52d03$var$Ac(a, c, d);
    if (0 === ($3bfcd8e655c52d03$var$K & 2) || a !== $3bfcd8e655c52d03$var$Q) a === $3bfcd8e655c52d03$var$Q && (0 === ($3bfcd8e655c52d03$var$K & 2) && ($3bfcd8e655c52d03$var$qk |= c), 4 === $3bfcd8e655c52d03$var$T && $3bfcd8e655c52d03$var$Ck(a, $3bfcd8e655c52d03$var$Z)), $3bfcd8e655c52d03$var$Dk(a, d), 1 === c && 0 === $3bfcd8e655c52d03$var$K && 0 === (b.mode & 1) && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$fg && $3bfcd8e655c52d03$var$jg());
}
function $3bfcd8e655c52d03$var$Dk(a, b) {
    var c = a.callbackNode;
    $3bfcd8e655c52d03$var$wc(a, b);
    var d = $3bfcd8e655c52d03$var$uc(a, a === $3bfcd8e655c52d03$var$Q ? $3bfcd8e655c52d03$var$Z : 0);
    if (0 === d) null !== c && $3bfcd8e655c52d03$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $3bfcd8e655c52d03$var$bc(c);
        if (1 === b) 0 === a.tag ? $3bfcd8e655c52d03$var$ig($3bfcd8e655c52d03$var$Ek.bind(null, a)) : $3bfcd8e655c52d03$var$hg($3bfcd8e655c52d03$var$Ek.bind(null, a)), $3bfcd8e655c52d03$var$Jf(function() {
            0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$jg();
        }), c = null;
        else {
            switch($3bfcd8e655c52d03$var$Dc(d)){
                case 1:
                    c = $3bfcd8e655c52d03$var$fc;
                    break;
                case 4:
                    c = $3bfcd8e655c52d03$var$gc;
                    break;
                case 16:
                    c = $3bfcd8e655c52d03$var$hc;
                    break;
                case 536870912:
                    c = $3bfcd8e655c52d03$var$jc;
                    break;
                default:
                    c = $3bfcd8e655c52d03$var$hc;
            }
            c = $3bfcd8e655c52d03$var$Fk(c, $3bfcd8e655c52d03$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $3bfcd8e655c52d03$var$Gk(a, b) {
    $3bfcd8e655c52d03$var$Ak = -1;
    $3bfcd8e655c52d03$var$Bk = 0;
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    var c = a.callbackNode;
    if ($3bfcd8e655c52d03$var$Hk() && a.callbackNode !== c) return null;
    var d = $3bfcd8e655c52d03$var$uc(a, a === $3bfcd8e655c52d03$var$Q ? $3bfcd8e655c52d03$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $3bfcd8e655c52d03$var$Ik(a, d);
    else {
        b = d;
        var e = $3bfcd8e655c52d03$var$K;
        $3bfcd8e655c52d03$var$K |= 2;
        var f = $3bfcd8e655c52d03$var$Jk();
        if ($3bfcd8e655c52d03$var$Q !== a || $3bfcd8e655c52d03$var$Z !== b) $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$Kk(a, b);
        for(;;)try {
            $3bfcd8e655c52d03$var$Lk();
            break;
        } catch (h) {
            $3bfcd8e655c52d03$var$Mk(a, h);
        }
        $3bfcd8e655c52d03$var$$g();
        $3bfcd8e655c52d03$var$mk.current = f;
        $3bfcd8e655c52d03$var$K = e;
        null !== $3bfcd8e655c52d03$var$Y ? b = 0 : ($3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Z = 0, b = $3bfcd8e655c52d03$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $3bfcd8e655c52d03$var$xc(a), 0 !== e && (d = e, b = $3bfcd8e655c52d03$var$Nk(a, e)));
        if (1 === b) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, d), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
        if (6 === b) $3bfcd8e655c52d03$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$3bfcd8e655c52d03$var$Ok(e) && (b = $3bfcd8e655c52d03$var$Ik(a, d), 2 === b && (f = $3bfcd8e655c52d03$var$xc(a), 0 !== f && (d = f, b = $3bfcd8e655c52d03$var$Nk(a, f))), 1 === b)) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, d), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($3bfcd8e655c52d03$var$p(345));
                case 2:
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 3:
                    $3bfcd8e655c52d03$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $3bfcd8e655c52d03$var$fk + 500 - $3bfcd8e655c52d03$var$B(), 10 < b)) {
                        if (0 !== $3bfcd8e655c52d03$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $3bfcd8e655c52d03$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $3bfcd8e655c52d03$var$Ff($3bfcd8e655c52d03$var$Pk.bind(null, a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk), b);
                        break;
                    }
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 4:
                    $3bfcd8e655c52d03$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $3bfcd8e655c52d03$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $3bfcd8e655c52d03$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $3bfcd8e655c52d03$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $3bfcd8e655c52d03$var$Ff($3bfcd8e655c52d03$var$Pk.bind(null, a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk), d);
                        break;
                    }
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                case 5:
                    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
                    break;
                default:
                    throw Error($3bfcd8e655c52d03$var$p(329));
            }
        }
    }
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    return a.callbackNode === c ? $3bfcd8e655c52d03$var$Gk.bind(null, a) : null;
}
function $3bfcd8e655c52d03$var$Nk(a, b) {
    var c = $3bfcd8e655c52d03$var$sk;
    a.current.memoizedState.isDehydrated && ($3bfcd8e655c52d03$var$Kk(a, b).flags |= 256);
    a = $3bfcd8e655c52d03$var$Ik(a, b);
    2 !== a && (b = $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$tk = c, null !== b && $3bfcd8e655c52d03$var$Fj(b));
    return a;
}
function $3bfcd8e655c52d03$var$Fj(a) {
    null === $3bfcd8e655c52d03$var$tk ? $3bfcd8e655c52d03$var$tk = a : $3bfcd8e655c52d03$var$tk.push.apply($3bfcd8e655c52d03$var$tk, a);
}
function $3bfcd8e655c52d03$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$3bfcd8e655c52d03$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $3bfcd8e655c52d03$var$Ck(a, b) {
    b &= ~$3bfcd8e655c52d03$var$rk;
    b &= ~$3bfcd8e655c52d03$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $3bfcd8e655c52d03$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $3bfcd8e655c52d03$var$Ek(a) {
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    $3bfcd8e655c52d03$var$Hk();
    var b = $3bfcd8e655c52d03$var$uc(a, 0);
    if (0 === (b & 1)) return $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), null;
    var c = $3bfcd8e655c52d03$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $3bfcd8e655c52d03$var$xc(a);
        0 !== d && (b = d, c = $3bfcd8e655c52d03$var$Nk(a, d));
    }
    if (1 === c) throw c = $3bfcd8e655c52d03$var$pk, $3bfcd8e655c52d03$var$Kk(a, 0), $3bfcd8e655c52d03$var$Ck(a, b), $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B()), c;
    if (6 === c) throw Error($3bfcd8e655c52d03$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $3bfcd8e655c52d03$var$Pk(a, $3bfcd8e655c52d03$var$tk, $3bfcd8e655c52d03$var$uk);
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    return null;
}
function $3bfcd8e655c52d03$var$Qk(a, b) {
    var c = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 1;
    try {
        return a(b);
    } finally{
        $3bfcd8e655c52d03$var$K = c, 0 === $3bfcd8e655c52d03$var$K && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$fg && $3bfcd8e655c52d03$var$jg());
    }
}
function $3bfcd8e655c52d03$var$Rk(a) {
    null !== $3bfcd8e655c52d03$var$wk && 0 === $3bfcd8e655c52d03$var$wk.tag && 0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$Hk();
    var b = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 1;
    var c = $3bfcd8e655c52d03$var$ok.transition, d = $3bfcd8e655c52d03$var$C;
    try {
        if ($3bfcd8e655c52d03$var$ok.transition = null, $3bfcd8e655c52d03$var$C = 1, a) return a();
    } finally{
        $3bfcd8e655c52d03$var$C = d, $3bfcd8e655c52d03$var$ok.transition = c, $3bfcd8e655c52d03$var$K = b, 0 === ($3bfcd8e655c52d03$var$K & 6) && $3bfcd8e655c52d03$var$jg();
    }
}
function $3bfcd8e655c52d03$var$Hj() {
    $3bfcd8e655c52d03$var$fj = $3bfcd8e655c52d03$var$ej.current;
    $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$ej);
}
function $3bfcd8e655c52d03$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $3bfcd8e655c52d03$var$Gf(c));
    if (null !== $3bfcd8e655c52d03$var$Y) for(c = $3bfcd8e655c52d03$var$Y.return; null !== c;){
        var d = c;
        $3bfcd8e655c52d03$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $3bfcd8e655c52d03$var$$f();
                break;
            case 3:
                $3bfcd8e655c52d03$var$zh();
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$Wf);
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$H);
                $3bfcd8e655c52d03$var$Eh();
                break;
            case 5:
                $3bfcd8e655c52d03$var$Bh(d);
                break;
            case 4:
                $3bfcd8e655c52d03$var$zh();
                break;
            case 13:
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
                break;
            case 19:
                $3bfcd8e655c52d03$var$E($3bfcd8e655c52d03$var$L);
                break;
            case 10:
                $3bfcd8e655c52d03$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $3bfcd8e655c52d03$var$Hj();
        }
        c = c.return;
    }
    $3bfcd8e655c52d03$var$Q = a;
    $3bfcd8e655c52d03$var$Y = a = $3bfcd8e655c52d03$var$Pg(a.current, null);
    $3bfcd8e655c52d03$var$Z = $3bfcd8e655c52d03$var$fj = b;
    $3bfcd8e655c52d03$var$T = 0;
    $3bfcd8e655c52d03$var$pk = null;
    $3bfcd8e655c52d03$var$rk = $3bfcd8e655c52d03$var$qk = $3bfcd8e655c52d03$var$rh = 0;
    $3bfcd8e655c52d03$var$tk = $3bfcd8e655c52d03$var$sk = null;
    if (null !== $3bfcd8e655c52d03$var$fh) {
        for(b = 0; b < $3bfcd8e655c52d03$var$fh.length; b++)if (c = $3bfcd8e655c52d03$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $3bfcd8e655c52d03$var$fh = null;
    }
    return a;
}
function $3bfcd8e655c52d03$var$Mk(a, b) {
    do {
        var c = $3bfcd8e655c52d03$var$Y;
        try {
            $3bfcd8e655c52d03$var$$g();
            $3bfcd8e655c52d03$var$Fh.current = $3bfcd8e655c52d03$var$Rh;
            if ($3bfcd8e655c52d03$var$Ih) {
                for(var d = $3bfcd8e655c52d03$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $3bfcd8e655c52d03$var$Ih = !1;
            }
            $3bfcd8e655c52d03$var$Hh = 0;
            $3bfcd8e655c52d03$var$O = $3bfcd8e655c52d03$var$N = $3bfcd8e655c52d03$var$M = null;
            $3bfcd8e655c52d03$var$Jh = !1;
            $3bfcd8e655c52d03$var$Kh = 0;
            $3bfcd8e655c52d03$var$nk.current = null;
            if (null === c || null === c.return) {
                $3bfcd8e655c52d03$var$T = 1;
                $3bfcd8e655c52d03$var$pk = b;
                $3bfcd8e655c52d03$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $3bfcd8e655c52d03$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $3bfcd8e655c52d03$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $3bfcd8e655c52d03$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $3bfcd8e655c52d03$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $3bfcd8e655c52d03$var$Si(f, l, b);
                            $3bfcd8e655c52d03$var$tj();
                            break a;
                        }
                        k = Error($3bfcd8e655c52d03$var$p(426));
                    }
                } else if ($3bfcd8e655c52d03$var$I && h.mode & 1) {
                    var J = $3bfcd8e655c52d03$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $3bfcd8e655c52d03$var$Vi(J, g, h, f, b);
                        $3bfcd8e655c52d03$var$Jg($3bfcd8e655c52d03$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $3bfcd8e655c52d03$var$Ji(k, h);
                4 !== $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 2);
                null === $3bfcd8e655c52d03$var$sk ? $3bfcd8e655c52d03$var$sk = [
                    f
                ] : $3bfcd8e655c52d03$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $3bfcd8e655c52d03$var$Ni(f, k, b);
                            $3bfcd8e655c52d03$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $3bfcd8e655c52d03$var$Ri || !$3bfcd8e655c52d03$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $3bfcd8e655c52d03$var$Qi(f, h, b);
                                $3bfcd8e655c52d03$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $3bfcd8e655c52d03$var$Sk(c);
        } catch (na) {
            b = na;
            $3bfcd8e655c52d03$var$Y === c && null !== c && ($3bfcd8e655c52d03$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $3bfcd8e655c52d03$var$Jk() {
    var a = $3bfcd8e655c52d03$var$mk.current;
    $3bfcd8e655c52d03$var$mk.current = $3bfcd8e655c52d03$var$Rh;
    return null === a ? $3bfcd8e655c52d03$var$Rh : a;
}
function $3bfcd8e655c52d03$var$tj() {
    if (0 === $3bfcd8e655c52d03$var$T || 3 === $3bfcd8e655c52d03$var$T || 2 === $3bfcd8e655c52d03$var$T) $3bfcd8e655c52d03$var$T = 4;
    null === $3bfcd8e655c52d03$var$Q || 0 === ($3bfcd8e655c52d03$var$rh & 268435455) && 0 === ($3bfcd8e655c52d03$var$qk & 268435455) || $3bfcd8e655c52d03$var$Ck($3bfcd8e655c52d03$var$Q, $3bfcd8e655c52d03$var$Z);
}
function $3bfcd8e655c52d03$var$Ik(a, b) {
    var c = $3bfcd8e655c52d03$var$K;
    $3bfcd8e655c52d03$var$K |= 2;
    var d = $3bfcd8e655c52d03$var$Jk();
    if ($3bfcd8e655c52d03$var$Q !== a || $3bfcd8e655c52d03$var$Z !== b) $3bfcd8e655c52d03$var$uk = null, $3bfcd8e655c52d03$var$Kk(a, b);
    for(;;)try {
        $3bfcd8e655c52d03$var$Tk();
        break;
    } catch (e) {
        $3bfcd8e655c52d03$var$Mk(a, e);
    }
    $3bfcd8e655c52d03$var$$g();
    $3bfcd8e655c52d03$var$K = c;
    $3bfcd8e655c52d03$var$mk.current = d;
    if (null !== $3bfcd8e655c52d03$var$Y) throw Error($3bfcd8e655c52d03$var$p(261));
    $3bfcd8e655c52d03$var$Q = null;
    $3bfcd8e655c52d03$var$Z = 0;
    return $3bfcd8e655c52d03$var$T;
}
function $3bfcd8e655c52d03$var$Tk() {
    for(; null !== $3bfcd8e655c52d03$var$Y;)$3bfcd8e655c52d03$var$Uk($3bfcd8e655c52d03$var$Y);
}
function $3bfcd8e655c52d03$var$Lk() {
    for(; null !== $3bfcd8e655c52d03$var$Y && !$3bfcd8e655c52d03$var$cc();)$3bfcd8e655c52d03$var$Uk($3bfcd8e655c52d03$var$Y);
}
function $3bfcd8e655c52d03$var$Uk(a) {
    var b = $3bfcd8e655c52d03$var$Vk(a.alternate, a, $3bfcd8e655c52d03$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $3bfcd8e655c52d03$var$Sk(a) : $3bfcd8e655c52d03$var$Y = b;
    $3bfcd8e655c52d03$var$nk.current = null;
}
function $3bfcd8e655c52d03$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $3bfcd8e655c52d03$var$Ej(c, b, $3bfcd8e655c52d03$var$fj), null !== c) {
                $3bfcd8e655c52d03$var$Y = c;
                return;
            }
        } else {
            c = $3bfcd8e655c52d03$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $3bfcd8e655c52d03$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $3bfcd8e655c52d03$var$T = 6;
                $3bfcd8e655c52d03$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $3bfcd8e655c52d03$var$Y = b;
            return;
        }
        $3bfcd8e655c52d03$var$Y = b = a;
    }while (null !== b);
    0 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$T = 5);
}
function $3bfcd8e655c52d03$var$Pk(a, b, c) {
    var d = $3bfcd8e655c52d03$var$C, e = $3bfcd8e655c52d03$var$ok.transition;
    try {
        $3bfcd8e655c52d03$var$ok.transition = null, $3bfcd8e655c52d03$var$C = 1, $3bfcd8e655c52d03$var$Wk(a, b, c, d);
    } finally{
        $3bfcd8e655c52d03$var$ok.transition = e, $3bfcd8e655c52d03$var$C = d;
    }
    return null;
}
function $3bfcd8e655c52d03$var$Wk(a, b, c, d) {
    do $3bfcd8e655c52d03$var$Hk();
    while (null !== $3bfcd8e655c52d03$var$wk);
    if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($3bfcd8e655c52d03$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $3bfcd8e655c52d03$var$Bc(a, f);
    a === $3bfcd8e655c52d03$var$Q && ($3bfcd8e655c52d03$var$Y = $3bfcd8e655c52d03$var$Q = null, $3bfcd8e655c52d03$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $3bfcd8e655c52d03$var$vk || ($3bfcd8e655c52d03$var$vk = !0, $3bfcd8e655c52d03$var$Fk($3bfcd8e655c52d03$var$hc, function() {
        $3bfcd8e655c52d03$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $3bfcd8e655c52d03$var$ok.transition;
        $3bfcd8e655c52d03$var$ok.transition = null;
        var g = $3bfcd8e655c52d03$var$C;
        $3bfcd8e655c52d03$var$C = 1;
        var h = $3bfcd8e655c52d03$var$K;
        $3bfcd8e655c52d03$var$K |= 4;
        $3bfcd8e655c52d03$var$nk.current = null;
        $3bfcd8e655c52d03$var$Oj(a, c);
        $3bfcd8e655c52d03$var$dk(c, a);
        $3bfcd8e655c52d03$var$Oe($3bfcd8e655c52d03$var$Df);
        $3bfcd8e655c52d03$var$dd = !!$3bfcd8e655c52d03$var$Cf;
        $3bfcd8e655c52d03$var$Df = $3bfcd8e655c52d03$var$Cf = null;
        a.current = c;
        $3bfcd8e655c52d03$var$hk(c, a, e);
        $3bfcd8e655c52d03$var$dc();
        $3bfcd8e655c52d03$var$K = h;
        $3bfcd8e655c52d03$var$C = g;
        $3bfcd8e655c52d03$var$ok.transition = f;
    } else a.current = c;
    $3bfcd8e655c52d03$var$vk && ($3bfcd8e655c52d03$var$vk = !1, $3bfcd8e655c52d03$var$wk = a, $3bfcd8e655c52d03$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($3bfcd8e655c52d03$var$Ri = null);
    $3bfcd8e655c52d03$var$mc(c.stateNode, d);
    $3bfcd8e655c52d03$var$Dk(a, $3bfcd8e655c52d03$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($3bfcd8e655c52d03$var$Oi) throw $3bfcd8e655c52d03$var$Oi = !1, a = $3bfcd8e655c52d03$var$Pi, $3bfcd8e655c52d03$var$Pi = null, a;
    0 !== ($3bfcd8e655c52d03$var$xk & 1) && 0 !== a.tag && $3bfcd8e655c52d03$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $3bfcd8e655c52d03$var$zk ? $3bfcd8e655c52d03$var$yk++ : ($3bfcd8e655c52d03$var$yk = 0, $3bfcd8e655c52d03$var$zk = a) : $3bfcd8e655c52d03$var$yk = 0;
    $3bfcd8e655c52d03$var$jg();
    return null;
}
function $3bfcd8e655c52d03$var$Hk() {
    if (null !== $3bfcd8e655c52d03$var$wk) {
        var a = $3bfcd8e655c52d03$var$Dc($3bfcd8e655c52d03$var$xk), b = $3bfcd8e655c52d03$var$ok.transition, c = $3bfcd8e655c52d03$var$C;
        try {
            $3bfcd8e655c52d03$var$ok.transition = null;
            $3bfcd8e655c52d03$var$C = 16 > a ? 16 : a;
            if (null === $3bfcd8e655c52d03$var$wk) var d = !1;
            else {
                a = $3bfcd8e655c52d03$var$wk;
                $3bfcd8e655c52d03$var$wk = null;
                $3bfcd8e655c52d03$var$xk = 0;
                if (0 !== ($3bfcd8e655c52d03$var$K & 6)) throw Error($3bfcd8e655c52d03$var$p(331));
                var e = $3bfcd8e655c52d03$var$K;
                $3bfcd8e655c52d03$var$K |= 4;
                for($3bfcd8e655c52d03$var$V = a.current; null !== $3bfcd8e655c52d03$var$V;){
                    var f = $3bfcd8e655c52d03$var$V, g = f.child;
                    if (0 !== ($3bfcd8e655c52d03$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($3bfcd8e655c52d03$var$V = l; null !== $3bfcd8e655c52d03$var$V;){
                                    var m = $3bfcd8e655c52d03$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $3bfcd8e655c52d03$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $3bfcd8e655c52d03$var$V = q;
                                    else for(; null !== $3bfcd8e655c52d03$var$V;){
                                        m = $3bfcd8e655c52d03$var$V;
                                        var r = m.sibling, y = m.return;
                                        $3bfcd8e655c52d03$var$Sj(m);
                                        if (m === l) {
                                            $3bfcd8e655c52d03$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $3bfcd8e655c52d03$var$V = r;
                                            break;
                                        }
                                        $3bfcd8e655c52d03$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $3bfcd8e655c52d03$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $3bfcd8e655c52d03$var$V = g;
                    else b: for(; null !== $3bfcd8e655c52d03$var$V;){
                        f = $3bfcd8e655c52d03$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $3bfcd8e655c52d03$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $3bfcd8e655c52d03$var$V = x;
                            break b;
                        }
                        $3bfcd8e655c52d03$var$V = f.return;
                    }
                }
                var w = a.current;
                for($3bfcd8e655c52d03$var$V = w; null !== $3bfcd8e655c52d03$var$V;){
                    g = $3bfcd8e655c52d03$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $3bfcd8e655c52d03$var$V = u;
                    else b: for(g = w; null !== $3bfcd8e655c52d03$var$V;){
                        h = $3bfcd8e655c52d03$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $3bfcd8e655c52d03$var$Qj(9, h);
                            }
                        } catch (na) {
                            $3bfcd8e655c52d03$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $3bfcd8e655c52d03$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $3bfcd8e655c52d03$var$V = F;
                            break b;
                        }
                        $3bfcd8e655c52d03$var$V = h.return;
                    }
                }
                $3bfcd8e655c52d03$var$K = e;
                $3bfcd8e655c52d03$var$jg();
                if ($3bfcd8e655c52d03$var$lc && "function" === typeof $3bfcd8e655c52d03$var$lc.onPostCommitFiberRoot) try {
                    $3bfcd8e655c52d03$var$lc.onPostCommitFiberRoot($3bfcd8e655c52d03$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $3bfcd8e655c52d03$var$C = c, $3bfcd8e655c52d03$var$ok.transition = b;
        }
    }
    return !1;
}
function $3bfcd8e655c52d03$var$Xk(a, b, c) {
    b = $3bfcd8e655c52d03$var$Ji(c, b);
    b = $3bfcd8e655c52d03$var$Ni(a, b, 1);
    a = $3bfcd8e655c52d03$var$nh(a, b, 1);
    b = $3bfcd8e655c52d03$var$R();
    null !== a && ($3bfcd8e655c52d03$var$Ac(a, 1, b), $3bfcd8e655c52d03$var$Dk(a, b));
}
function $3bfcd8e655c52d03$var$W(a, b, c) {
    if (3 === a.tag) $3bfcd8e655c52d03$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $3bfcd8e655c52d03$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $3bfcd8e655c52d03$var$Ri || !$3bfcd8e655c52d03$var$Ri.has(d))) {
                a = $3bfcd8e655c52d03$var$Ji(c, a);
                a = $3bfcd8e655c52d03$var$Qi(b, a, 1);
                b = $3bfcd8e655c52d03$var$nh(b, a, 1);
                a = $3bfcd8e655c52d03$var$R();
                null !== b && ($3bfcd8e655c52d03$var$Ac(b, 1, a), $3bfcd8e655c52d03$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $3bfcd8e655c52d03$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $3bfcd8e655c52d03$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $3bfcd8e655c52d03$var$Q === a && ($3bfcd8e655c52d03$var$Z & c) === c && (4 === $3bfcd8e655c52d03$var$T || 3 === $3bfcd8e655c52d03$var$T && ($3bfcd8e655c52d03$var$Z & 130023424) === $3bfcd8e655c52d03$var$Z && 500 > $3bfcd8e655c52d03$var$B() - $3bfcd8e655c52d03$var$fk ? $3bfcd8e655c52d03$var$Kk(a, 0) : $3bfcd8e655c52d03$var$rk |= c);
    $3bfcd8e655c52d03$var$Dk(a, b);
}
function $3bfcd8e655c52d03$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $3bfcd8e655c52d03$var$sc, $3bfcd8e655c52d03$var$sc <<= 1, 0 === ($3bfcd8e655c52d03$var$sc & 130023424) && ($3bfcd8e655c52d03$var$sc = 4194304)));
    var c = $3bfcd8e655c52d03$var$R();
    a = $3bfcd8e655c52d03$var$ih(a, b);
    null !== a && ($3bfcd8e655c52d03$var$Ac(a, b, c), $3bfcd8e655c52d03$var$Dk(a, c));
}
function $3bfcd8e655c52d03$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $3bfcd8e655c52d03$var$Yk(a, c);
}
function $3bfcd8e655c52d03$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($3bfcd8e655c52d03$var$p(314));
    }
    null !== d && d.delete(b);
    $3bfcd8e655c52d03$var$Yk(a, c);
}
var $3bfcd8e655c52d03$var$Vk;
$3bfcd8e655c52d03$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $3bfcd8e655c52d03$var$Wf.current) $3bfcd8e655c52d03$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $3bfcd8e655c52d03$var$dh = !1, $3bfcd8e655c52d03$var$yj(a, b, c);
            $3bfcd8e655c52d03$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $3bfcd8e655c52d03$var$dh = !1, $3bfcd8e655c52d03$var$I && 0 !== (b.flags & 1048576) && $3bfcd8e655c52d03$var$ug(b, $3bfcd8e655c52d03$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $3bfcd8e655c52d03$var$ij(a, b);
            a = b.pendingProps;
            var e = $3bfcd8e655c52d03$var$Yf(b, $3bfcd8e655c52d03$var$H.current);
            $3bfcd8e655c52d03$var$ch(b, c);
            e = $3bfcd8e655c52d03$var$Nh(null, b, d, a, e, c);
            var f = $3bfcd8e655c52d03$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $3bfcd8e655c52d03$var$Zf(d) ? (f = !0, $3bfcd8e655c52d03$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $3bfcd8e655c52d03$var$kh(b), e.updater = $3bfcd8e655c52d03$var$Ei, b.stateNode = e, e._reactInternals = b, $3bfcd8e655c52d03$var$Ii(b, d, a, c), b = $3bfcd8e655c52d03$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $3bfcd8e655c52d03$var$I && f && $3bfcd8e655c52d03$var$vg(b), $3bfcd8e655c52d03$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $3bfcd8e655c52d03$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $3bfcd8e655c52d03$var$Zk(d);
                a = $3bfcd8e655c52d03$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $3bfcd8e655c52d03$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $3bfcd8e655c52d03$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $3bfcd8e655c52d03$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $3bfcd8e655c52d03$var$$i(null, b, d, $3bfcd8e655c52d03$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($3bfcd8e655c52d03$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $3bfcd8e655c52d03$var$kj(b);
                if (null === a) throw Error($3bfcd8e655c52d03$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $3bfcd8e655c52d03$var$lh(a, b);
                $3bfcd8e655c52d03$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $3bfcd8e655c52d03$var$Ji(Error($3bfcd8e655c52d03$var$p(423)), b);
                        b = $3bfcd8e655c52d03$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $3bfcd8e655c52d03$var$Ji(Error($3bfcd8e655c52d03$var$p(424)), b);
                        b = $3bfcd8e655c52d03$var$lj(a, b, d, c, e);
                        break a;
                    } else for($3bfcd8e655c52d03$var$yg = $3bfcd8e655c52d03$var$Lf(b.stateNode.containerInfo.firstChild), $3bfcd8e655c52d03$var$xg = b, $3bfcd8e655c52d03$var$I = !0, $3bfcd8e655c52d03$var$zg = null, c = $3bfcd8e655c52d03$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $3bfcd8e655c52d03$var$Ig();
                    if (d === e) {
                        b = $3bfcd8e655c52d03$var$Zi(a, b, c);
                        break a;
                    }
                    $3bfcd8e655c52d03$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $3bfcd8e655c52d03$var$Ah(b), null === a && $3bfcd8e655c52d03$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $3bfcd8e655c52d03$var$Ef(d, e) ? g = null : null !== f && $3bfcd8e655c52d03$var$Ef(d, f) && (b.flags |= 32), $3bfcd8e655c52d03$var$gj(a, b), $3bfcd8e655c52d03$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $3bfcd8e655c52d03$var$Eg(b), null;
        case 13:
            return $3bfcd8e655c52d03$var$oj(a, b, c);
        case 4:
            return $3bfcd8e655c52d03$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $3bfcd8e655c52d03$var$Ug(b, null, d, c) : $3bfcd8e655c52d03$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$Yi(a, b, d, e, c);
        case 7:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $3bfcd8e655c52d03$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $3bfcd8e655c52d03$var$G($3bfcd8e655c52d03$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($3bfcd8e655c52d03$var$He(f.value, g)) {
                        if (f.children === e.children && !$3bfcd8e655c52d03$var$Wf.current) {
                            b = $3bfcd8e655c52d03$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $3bfcd8e655c52d03$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $3bfcd8e655c52d03$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($3bfcd8e655c52d03$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $3bfcd8e655c52d03$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $3bfcd8e655c52d03$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $3bfcd8e655c52d03$var$ch(b, c), e = $3bfcd8e655c52d03$var$eh(e), d = d(e), b.flags |= 1, $3bfcd8e655c52d03$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $3bfcd8e655c52d03$var$Ci(d, b.pendingProps), e = $3bfcd8e655c52d03$var$Ci(d.type, e), $3bfcd8e655c52d03$var$$i(a, b, d, e, c);
        case 15:
            return $3bfcd8e655c52d03$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $3bfcd8e655c52d03$var$Ci(d, e), $3bfcd8e655c52d03$var$ij(a, b), b.tag = 1, $3bfcd8e655c52d03$var$Zf(d) ? (a = !0, $3bfcd8e655c52d03$var$cg(b)) : a = !1, $3bfcd8e655c52d03$var$ch(b, c), $3bfcd8e655c52d03$var$Gi(b, d, e), $3bfcd8e655c52d03$var$Ii(b, d, e, c), $3bfcd8e655c52d03$var$jj(null, b, d, !0, a, c);
        case 19:
            return $3bfcd8e655c52d03$var$xj(a, b, c);
        case 22:
            return $3bfcd8e655c52d03$var$dj(a, b, c);
    }
    throw Error($3bfcd8e655c52d03$var$p(156, b.tag));
};
function $3bfcd8e655c52d03$var$Fk(a, b) {
    return $3bfcd8e655c52d03$var$ac(a, b);
}
function $3bfcd8e655c52d03$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3bfcd8e655c52d03$var$Bg(a, b, c, d) {
    return new $3bfcd8e655c52d03$var$$k(a, b, c, d);
}
function $3bfcd8e655c52d03$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $3bfcd8e655c52d03$var$Zk(a) {
    if ("function" === typeof a) return $3bfcd8e655c52d03$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $3bfcd8e655c52d03$var$Da) return 11;
        if (a === $3bfcd8e655c52d03$var$Ga) return 14;
    }
    return 2;
}
function $3bfcd8e655c52d03$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $3bfcd8e655c52d03$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $3bfcd8e655c52d03$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $3bfcd8e655c52d03$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $3bfcd8e655c52d03$var$ya:
            return $3bfcd8e655c52d03$var$Tg(c.children, e, f, b);
        case $3bfcd8e655c52d03$var$za:
            g = 8;
            e |= 8;
            break;
        case $3bfcd8e655c52d03$var$Aa:
            return a = $3bfcd8e655c52d03$var$Bg(12, c, b, e | 2), a.elementType = $3bfcd8e655c52d03$var$Aa, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Ea:
            return a = $3bfcd8e655c52d03$var$Bg(13, c, b, e), a.elementType = $3bfcd8e655c52d03$var$Ea, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Fa:
            return a = $3bfcd8e655c52d03$var$Bg(19, c, b, e), a.elementType = $3bfcd8e655c52d03$var$Fa, a.lanes = f, a;
        case $3bfcd8e655c52d03$var$Ia:
            return $3bfcd8e655c52d03$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $3bfcd8e655c52d03$var$Ba:
                    g = 10;
                    break a;
                case $3bfcd8e655c52d03$var$Ca:
                    g = 9;
                    break a;
                case $3bfcd8e655c52d03$var$Da:
                    g = 11;
                    break a;
                case $3bfcd8e655c52d03$var$Ga:
                    g = 14;
                    break a;
                case $3bfcd8e655c52d03$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($3bfcd8e655c52d03$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $3bfcd8e655c52d03$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $3bfcd8e655c52d03$var$Tg(a, b, c, d) {
    a = $3bfcd8e655c52d03$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $3bfcd8e655c52d03$var$pj(a, b, c, d) {
    a = $3bfcd8e655c52d03$var$Bg(22, a, d, b);
    a.elementType = $3bfcd8e655c52d03$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $3bfcd8e655c52d03$var$Qg(a, b, c) {
    a = $3bfcd8e655c52d03$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $3bfcd8e655c52d03$var$Sg(a, b, c) {
    b = $3bfcd8e655c52d03$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $3bfcd8e655c52d03$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $3bfcd8e655c52d03$var$zc(0);
    this.expirationTimes = $3bfcd8e655c52d03$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3bfcd8e655c52d03$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $3bfcd8e655c52d03$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $3bfcd8e655c52d03$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $3bfcd8e655c52d03$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $3bfcd8e655c52d03$var$kh(f);
    return a;
}
function $3bfcd8e655c52d03$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3bfcd8e655c52d03$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $3bfcd8e655c52d03$var$dl(a) {
    if (!a) return $3bfcd8e655c52d03$var$Vf;
    a = a._reactInternals;
    a: {
        if ($3bfcd8e655c52d03$var$Vb(a) !== a || 1 !== a.tag) throw Error($3bfcd8e655c52d03$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($3bfcd8e655c52d03$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($3bfcd8e655c52d03$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($3bfcd8e655c52d03$var$Zf(c)) return $3bfcd8e655c52d03$var$bg(a, c, b);
    }
    return b;
}
function $3bfcd8e655c52d03$var$el(a, b, c, d, e, f, g, h, k) {
    a = $3bfcd8e655c52d03$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $3bfcd8e655c52d03$var$dl(null);
    c = a.current;
    d = $3bfcd8e655c52d03$var$R();
    e = $3bfcd8e655c52d03$var$yi(c);
    f = $3bfcd8e655c52d03$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $3bfcd8e655c52d03$var$nh(c, f, e);
    a.current.lanes = e;
    $3bfcd8e655c52d03$var$Ac(a, e, d);
    $3bfcd8e655c52d03$var$Dk(a, d);
    return a;
}
function $3bfcd8e655c52d03$var$fl(a, b, c, d) {
    var e = b.current, f = $3bfcd8e655c52d03$var$R(), g = $3bfcd8e655c52d03$var$yi(e);
    c = $3bfcd8e655c52d03$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $3bfcd8e655c52d03$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $3bfcd8e655c52d03$var$nh(e, b, g);
    null !== a && ($3bfcd8e655c52d03$var$gi(a, e, g, f), $3bfcd8e655c52d03$var$oh(a, e, g));
    return g;
}
function $3bfcd8e655c52d03$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $3bfcd8e655c52d03$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $3bfcd8e655c52d03$var$il(a, b) {
    $3bfcd8e655c52d03$var$hl(a, b);
    (a = a.alternate) && $3bfcd8e655c52d03$var$hl(a, b);
}
function $3bfcd8e655c52d03$var$jl() {
    return null;
}
var $3bfcd8e655c52d03$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $3bfcd8e655c52d03$var$ll(a) {
    this._internalRoot = a;
}
$3bfcd8e655c52d03$var$ml.prototype.render = $3bfcd8e655c52d03$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($3bfcd8e655c52d03$var$p(409));
    $3bfcd8e655c52d03$var$fl(a, b, null, null);
};
$3bfcd8e655c52d03$var$ml.prototype.unmount = $3bfcd8e655c52d03$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $3bfcd8e655c52d03$var$Rk(function() {
            $3bfcd8e655c52d03$var$fl(null, a, null, null);
        });
        b[$3bfcd8e655c52d03$var$uf] = null;
    }
};
function $3bfcd8e655c52d03$var$ml(a) {
    this._internalRoot = a;
}
$3bfcd8e655c52d03$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $3bfcd8e655c52d03$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $3bfcd8e655c52d03$var$Qc.length && 0 !== b && b < $3bfcd8e655c52d03$var$Qc[c].priority; c++);
        $3bfcd8e655c52d03$var$Qc.splice(c, 0, a);
        0 === c && $3bfcd8e655c52d03$var$Vc(a);
    }
};
function $3bfcd8e655c52d03$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $3bfcd8e655c52d03$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $3bfcd8e655c52d03$var$pl() {}
function $3bfcd8e655c52d03$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $3bfcd8e655c52d03$var$gl(g);
                f.call(a);
            };
        }
        var g = $3bfcd8e655c52d03$var$el(b, d, a, 0, null, !1, !1, "", $3bfcd8e655c52d03$var$pl);
        a._reactRootContainer = g;
        a[$3bfcd8e655c52d03$var$uf] = g.current;
        $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
        $3bfcd8e655c52d03$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $3bfcd8e655c52d03$var$gl(k);
            h.call(a);
        };
    }
    var k = $3bfcd8e655c52d03$var$bl(a, 0, !1, null, null, !1, !1, "", $3bfcd8e655c52d03$var$pl);
    a._reactRootContainer = k;
    a[$3bfcd8e655c52d03$var$uf] = k.current;
    $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
    $3bfcd8e655c52d03$var$Rk(function() {
        $3bfcd8e655c52d03$var$fl(b, k, c, d);
    });
    return k;
}
function $3bfcd8e655c52d03$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $3bfcd8e655c52d03$var$gl(g);
                h.call(a);
            };
        }
        $3bfcd8e655c52d03$var$fl(b, g, a, e);
    } else g = $3bfcd8e655c52d03$var$ql(c, b, a, e, d);
    return $3bfcd8e655c52d03$var$gl(g);
}
$3bfcd8e655c52d03$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $3bfcd8e655c52d03$var$tc(b.pendingLanes);
                0 !== c && ($3bfcd8e655c52d03$var$Cc(b, c | 1), $3bfcd8e655c52d03$var$Dk(b, $3bfcd8e655c52d03$var$B()), 0 === ($3bfcd8e655c52d03$var$K & 6) && ($3bfcd8e655c52d03$var$Gj = $3bfcd8e655c52d03$var$B() + 500, $3bfcd8e655c52d03$var$jg()));
            }
            break;
        case 13:
            $3bfcd8e655c52d03$var$Rk(function() {
                var b = $3bfcd8e655c52d03$var$ih(a, 1);
                if (null !== b) {
                    var c = $3bfcd8e655c52d03$var$R();
                    $3bfcd8e655c52d03$var$gi(b, a, 1, c);
                }
            }), $3bfcd8e655c52d03$var$il(a, 1);
    }
};
$3bfcd8e655c52d03$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $3bfcd8e655c52d03$var$ih(a, 134217728);
        if (null !== b) {
            var c = $3bfcd8e655c52d03$var$R();
            $3bfcd8e655c52d03$var$gi(b, a, 134217728, c);
        }
        $3bfcd8e655c52d03$var$il(a, 134217728);
    }
};
$3bfcd8e655c52d03$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $3bfcd8e655c52d03$var$yi(a), c = $3bfcd8e655c52d03$var$ih(a, b);
        if (null !== c) {
            var d = $3bfcd8e655c52d03$var$R();
            $3bfcd8e655c52d03$var$gi(c, a, b, d);
        }
        $3bfcd8e655c52d03$var$il(a, b);
    }
};
$3bfcd8e655c52d03$var$Hc = function() {
    return $3bfcd8e655c52d03$var$C;
};
$3bfcd8e655c52d03$var$Ic = function(a, b) {
    var c = $3bfcd8e655c52d03$var$C;
    try {
        return $3bfcd8e655c52d03$var$C = a, b();
    } finally{
        $3bfcd8e655c52d03$var$C = c;
    }
};
$3bfcd8e655c52d03$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $3bfcd8e655c52d03$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $3bfcd8e655c52d03$var$Db(d);
                        if (!e) throw Error($3bfcd8e655c52d03$var$p(90));
                        $3bfcd8e655c52d03$var$Wa(d);
                        $3bfcd8e655c52d03$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $3bfcd8e655c52d03$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $3bfcd8e655c52d03$var$fb(a, !!c.multiple, b, !1);
    }
};
$3bfcd8e655c52d03$var$Gb = $3bfcd8e655c52d03$var$Qk;
$3bfcd8e655c52d03$var$Hb = $3bfcd8e655c52d03$var$Rk;
var $3bfcd8e655c52d03$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $3bfcd8e655c52d03$var$Cb,
        $3bfcd8e655c52d03$var$ue,
        $3bfcd8e655c52d03$var$Db,
        $3bfcd8e655c52d03$var$Eb,
        $3bfcd8e655c52d03$var$Fb,
        $3bfcd8e655c52d03$var$Qk
    ]
}, $3bfcd8e655c52d03$var$tl = {
    findFiberByHostInstance: $3bfcd8e655c52d03$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $3bfcd8e655c52d03$var$ul = {
    bundleType: $3bfcd8e655c52d03$var$tl.bundleType,
    version: $3bfcd8e655c52d03$var$tl.version,
    rendererPackageName: $3bfcd8e655c52d03$var$tl.rendererPackageName,
    rendererConfig: $3bfcd8e655c52d03$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $3bfcd8e655c52d03$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $3bfcd8e655c52d03$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $3bfcd8e655c52d03$var$tl.findFiberByHostInstance || $3bfcd8e655c52d03$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3bfcd8e655c52d03$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3bfcd8e655c52d03$var$vl.isDisabled && $3bfcd8e655c52d03$var$vl.supportsFiber) try {
        $3bfcd8e655c52d03$var$kc = $3bfcd8e655c52d03$var$vl.inject($3bfcd8e655c52d03$var$ul), $3bfcd8e655c52d03$var$lc = $3bfcd8e655c52d03$var$vl;
    } catch (a) {}
}
$3bfcd8e655c52d03$export$ae55be85d98224ed = $3bfcd8e655c52d03$var$sl;
$3bfcd8e655c52d03$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$3bfcd8e655c52d03$var$nl(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$cl(a, b, null, c);
};
$3bfcd8e655c52d03$export$882461b6382ed46c = function(a, b) {
    if (!$3bfcd8e655c52d03$var$nl(a)) throw Error($3bfcd8e655c52d03$var$p(299));
    var c = !1, d = "", e = $3bfcd8e655c52d03$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $3bfcd8e655c52d03$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$3bfcd8e655c52d03$var$uf] = b.current;
    $3bfcd8e655c52d03$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $3bfcd8e655c52d03$var$ll(b);
};
$3bfcd8e655c52d03$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($3bfcd8e655c52d03$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($3bfcd8e655c52d03$var$p(268, a));
    }
    a = $3bfcd8e655c52d03$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$3bfcd8e655c52d03$export$cd75ccfd720a3cd4 = function(a) {
    return $3bfcd8e655c52d03$var$Rk(a);
};
$3bfcd8e655c52d03$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$ol(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$rl(null, a, b, !0, c);
};
$3bfcd8e655c52d03$export$757ceba2d55c277e = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$nl(a)) throw Error($3bfcd8e655c52d03$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $3bfcd8e655c52d03$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $3bfcd8e655c52d03$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$3bfcd8e655c52d03$var$uf] = b.current;
    $3bfcd8e655c52d03$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $3bfcd8e655c52d03$var$ml(b);
};
$3bfcd8e655c52d03$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$3bfcd8e655c52d03$var$ol(b)) throw Error($3bfcd8e655c52d03$var$p(200));
    return $3bfcd8e655c52d03$var$rl(null, a, b, !1, c);
};
$3bfcd8e655c52d03$export$502457920280e6be = function(a) {
    if (!$3bfcd8e655c52d03$var$ol(a)) throw Error($3bfcd8e655c52d03$var$p(40));
    return a._reactRootContainer ? ($3bfcd8e655c52d03$var$Rk(function() {
        $3bfcd8e655c52d03$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$3bfcd8e655c52d03$var$uf] = null;
        });
    }), !0) : !1;
};
$3bfcd8e655c52d03$export$c78a37762a8d58e1 = $3bfcd8e655c52d03$var$Qk;
$3bfcd8e655c52d03$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$3bfcd8e655c52d03$var$ol(c)) throw Error($3bfcd8e655c52d03$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($3bfcd8e655c52d03$var$p(38));
    return $3bfcd8e655c52d03$var$rl(a, b, c, !1, d);
};
$3bfcd8e655c52d03$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("9kLo3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6gNJm"));

});
parcelRegister("6gNJm", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $490ad02655eeb816$export$c4744153514ff05d; }, function (v) { return $490ad02655eeb816$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $490ad02655eeb816$export$3e506c1ccc9cc1a7; }, function (v) { return $490ad02655eeb816$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $490ad02655eeb816$export$e26fe2ed2fa76875; }, function (v) { return $490ad02655eeb816$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $490ad02655eeb816$export$502329bbf4b505b1; }, function (v) { return $490ad02655eeb816$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $490ad02655eeb816$export$6e3807111c4874c4; }, function (v) { return $490ad02655eeb816$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $490ad02655eeb816$export$c27134553091fb3a; }, function (v) { return $490ad02655eeb816$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $490ad02655eeb816$export$33ee1acdc04fd2a2; }, function (v) { return $490ad02655eeb816$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $490ad02655eeb816$export$b00a404bbd5edef2; }, function (v) { return $490ad02655eeb816$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $490ad02655eeb816$export$8352ce38b91d0c62; }, function (v) { return $490ad02655eeb816$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $490ad02655eeb816$export$d66a1c1c77bd778b; }, function (v) { return $490ad02655eeb816$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $490ad02655eeb816$export$d3dfb8e4810cb555; }, function (v) { return $490ad02655eeb816$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $490ad02655eeb816$export$839f9183b0465a69; }, function (v) { return $490ad02655eeb816$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $490ad02655eeb816$export$72fdf0e06517287b; }, function (v) { return $490ad02655eeb816$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $490ad02655eeb816$export$4b844e58a3e414b4; }, function (v) { return $490ad02655eeb816$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $490ad02655eeb816$export$816d2913ae6b83b1; }, function (v) { return $490ad02655eeb816$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $490ad02655eeb816$export$61bcfe829111a1d0; }, function (v) { return $490ad02655eeb816$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $490ad02655eeb816$export$7ee8c9beb337bc3f; }, function (v) { return $490ad02655eeb816$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $490ad02655eeb816$export$b5836b71941fa3ed; }, function (v) { return $490ad02655eeb816$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $490ad02655eeb816$export$cf845f2c119da08a; }, function (v) { return $490ad02655eeb816$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $490ad02655eeb816$export$c4744153514ff05d;
var $490ad02655eeb816$export$3e506c1ccc9cc1a7;
var $490ad02655eeb816$export$e26fe2ed2fa76875;
var $490ad02655eeb816$export$502329bbf4b505b1;
var $490ad02655eeb816$export$6e3807111c4874c4;
var $490ad02655eeb816$export$c27134553091fb3a;
var $490ad02655eeb816$export$33ee1acdc04fd2a2;
var $490ad02655eeb816$export$b00a404bbd5edef2;
var $490ad02655eeb816$export$8352ce38b91d0c62;
var $490ad02655eeb816$export$d66a1c1c77bd778b;
var $490ad02655eeb816$export$d3dfb8e4810cb555;
var $490ad02655eeb816$export$839f9183b0465a69;
var $490ad02655eeb816$export$72fdf0e06517287b;
var $490ad02655eeb816$export$4b844e58a3e414b4;
var $490ad02655eeb816$export$816d2913ae6b83b1;
var $490ad02655eeb816$export$61bcfe829111a1d0;
var $490ad02655eeb816$export$7ee8c9beb337bc3f;
var $490ad02655eeb816$export$b5836b71941fa3ed;
var $490ad02655eeb816$export$cf845f2c119da08a;
"use strict";
function $490ad02655eeb816$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $490ad02655eeb816$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $490ad02655eeb816$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $490ad02655eeb816$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $490ad02655eeb816$var$g(C, c)) n < e && 0 > $490ad02655eeb816$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $490ad02655eeb816$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $490ad02655eeb816$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $490ad02655eeb816$var$l = performance;
    $490ad02655eeb816$export$c4744153514ff05d = function() {
        return $490ad02655eeb816$var$l.now();
    };
} else {
    var $490ad02655eeb816$var$p = Date, $490ad02655eeb816$var$q = $490ad02655eeb816$var$p.now();
    $490ad02655eeb816$export$c4744153514ff05d = function() {
        return $490ad02655eeb816$var$p.now() - $490ad02655eeb816$var$q;
    };
}
var $490ad02655eeb816$var$r = [], $490ad02655eeb816$var$t = [], $490ad02655eeb816$var$u = 1, $490ad02655eeb816$var$v = null, $490ad02655eeb816$var$y = 3, $490ad02655eeb816$var$z = !1, $490ad02655eeb816$var$A = !1, $490ad02655eeb816$var$B = !1, $490ad02655eeb816$var$D = "function" === typeof setTimeout ? setTimeout : null, $490ad02655eeb816$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $490ad02655eeb816$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $490ad02655eeb816$var$G(a) {
    for(var b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t); null !== b;){
        if (null === b.callback) $490ad02655eeb816$var$k($490ad02655eeb816$var$t);
        else if (b.startTime <= a) $490ad02655eeb816$var$k($490ad02655eeb816$var$t), b.sortIndex = b.expirationTime, $490ad02655eeb816$var$f($490ad02655eeb816$var$r, b);
        else break;
        b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
    }
}
function $490ad02655eeb816$var$H(a) {
    $490ad02655eeb816$var$B = !1;
    $490ad02655eeb816$var$G(a);
    if (!$490ad02655eeb816$var$A) {
        if (null !== $490ad02655eeb816$var$h($490ad02655eeb816$var$r)) $490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J);
        else {
            var b = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
            null !== b && $490ad02655eeb816$var$K($490ad02655eeb816$var$H, b.startTime - a);
        }
    }
}
function $490ad02655eeb816$var$J(a, b) {
    $490ad02655eeb816$var$A = !1;
    $490ad02655eeb816$var$B && ($490ad02655eeb816$var$B = !1, $490ad02655eeb816$var$E($490ad02655eeb816$var$L), $490ad02655eeb816$var$L = -1);
    $490ad02655eeb816$var$z = !0;
    var c = $490ad02655eeb816$var$y;
    try {
        $490ad02655eeb816$var$G(b);
        for($490ad02655eeb816$var$v = $490ad02655eeb816$var$h($490ad02655eeb816$var$r); null !== $490ad02655eeb816$var$v && (!($490ad02655eeb816$var$v.expirationTime > b) || a && !$490ad02655eeb816$var$M());){
            var d = $490ad02655eeb816$var$v.callback;
            if ("function" === typeof d) {
                $490ad02655eeb816$var$v.callback = null;
                $490ad02655eeb816$var$y = $490ad02655eeb816$var$v.priorityLevel;
                var e = d($490ad02655eeb816$var$v.expirationTime <= b);
                b = $490ad02655eeb816$export$c4744153514ff05d();
                "function" === typeof e ? $490ad02655eeb816$var$v.callback = e : $490ad02655eeb816$var$v === $490ad02655eeb816$var$h($490ad02655eeb816$var$r) && $490ad02655eeb816$var$k($490ad02655eeb816$var$r);
                $490ad02655eeb816$var$G(b);
            } else $490ad02655eeb816$var$k($490ad02655eeb816$var$r);
            $490ad02655eeb816$var$v = $490ad02655eeb816$var$h($490ad02655eeb816$var$r);
        }
        if (null !== $490ad02655eeb816$var$v) var w = !0;
        else {
            var m = $490ad02655eeb816$var$h($490ad02655eeb816$var$t);
            null !== m && $490ad02655eeb816$var$K($490ad02655eeb816$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $490ad02655eeb816$var$v = null, $490ad02655eeb816$var$y = c, $490ad02655eeb816$var$z = !1;
    }
}
var $490ad02655eeb816$var$N = !1, $490ad02655eeb816$var$O = null, $490ad02655eeb816$var$L = -1, $490ad02655eeb816$var$P = 5, $490ad02655eeb816$var$Q = -1;
function $490ad02655eeb816$var$M() {
    return $490ad02655eeb816$export$c4744153514ff05d() - $490ad02655eeb816$var$Q < $490ad02655eeb816$var$P ? !1 : !0;
}
function $490ad02655eeb816$var$R() {
    if (null !== $490ad02655eeb816$var$O) {
        var a = $490ad02655eeb816$export$c4744153514ff05d();
        $490ad02655eeb816$var$Q = a;
        var b = !0;
        try {
            b = $490ad02655eeb816$var$O(!0, a);
        } finally{
            b ? $490ad02655eeb816$var$S() : ($490ad02655eeb816$var$N = !1, $490ad02655eeb816$var$O = null);
        }
    } else $490ad02655eeb816$var$N = !1;
}
var $490ad02655eeb816$var$S;
if ("function" === typeof $490ad02655eeb816$var$F) $490ad02655eeb816$var$S = function() {
    $490ad02655eeb816$var$F($490ad02655eeb816$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $490ad02655eeb816$var$T = new MessageChannel, $490ad02655eeb816$var$U = $490ad02655eeb816$var$T.port2;
    $490ad02655eeb816$var$T.port1.onmessage = $490ad02655eeb816$var$R;
    $490ad02655eeb816$var$S = function() {
        $490ad02655eeb816$var$U.postMessage(null);
    };
} else $490ad02655eeb816$var$S = function() {
    $490ad02655eeb816$var$D($490ad02655eeb816$var$R, 0);
};
function $490ad02655eeb816$var$I(a) {
    $490ad02655eeb816$var$O = a;
    $490ad02655eeb816$var$N || ($490ad02655eeb816$var$N = !0, $490ad02655eeb816$var$S());
}
function $490ad02655eeb816$var$K(a, b) {
    $490ad02655eeb816$var$L = $490ad02655eeb816$var$D(function() {
        a($490ad02655eeb816$export$c4744153514ff05d());
    }, b);
}
$490ad02655eeb816$export$3e506c1ccc9cc1a7 = 5;
$490ad02655eeb816$export$e26fe2ed2fa76875 = 1;
$490ad02655eeb816$export$502329bbf4b505b1 = 4;
$490ad02655eeb816$export$6e3807111c4874c4 = 3;
$490ad02655eeb816$export$c27134553091fb3a = null;
$490ad02655eeb816$export$33ee1acdc04fd2a2 = 2;
$490ad02655eeb816$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$490ad02655eeb816$export$8352ce38b91d0c62 = function() {
    $490ad02655eeb816$var$A || $490ad02655eeb816$var$z || ($490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J));
};
$490ad02655eeb816$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $490ad02655eeb816$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$490ad02655eeb816$export$d3dfb8e4810cb555 = function() {
    return $490ad02655eeb816$var$y;
};
$490ad02655eeb816$export$839f9183b0465a69 = function() {
    return $490ad02655eeb816$var$h($490ad02655eeb816$var$r);
};
$490ad02655eeb816$export$72fdf0e06517287b = function(a) {
    switch($490ad02655eeb816$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $490ad02655eeb816$var$y;
    }
    var c = $490ad02655eeb816$var$y;
    $490ad02655eeb816$var$y = b;
    try {
        return a();
    } finally{
        $490ad02655eeb816$var$y = c;
    }
};
$490ad02655eeb816$export$4b844e58a3e414b4 = function() {};
$490ad02655eeb816$export$816d2913ae6b83b1 = function() {};
$490ad02655eeb816$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $490ad02655eeb816$var$y;
    $490ad02655eeb816$var$y = a;
    try {
        return b();
    } finally{
        $490ad02655eeb816$var$y = c;
    }
};
$490ad02655eeb816$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $490ad02655eeb816$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $490ad02655eeb816$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $490ad02655eeb816$var$f($490ad02655eeb816$var$t, a), null === $490ad02655eeb816$var$h($490ad02655eeb816$var$r) && a === $490ad02655eeb816$var$h($490ad02655eeb816$var$t) && ($490ad02655eeb816$var$B ? ($490ad02655eeb816$var$E($490ad02655eeb816$var$L), $490ad02655eeb816$var$L = -1) : $490ad02655eeb816$var$B = !0, $490ad02655eeb816$var$K($490ad02655eeb816$var$H, c - d))) : (a.sortIndex = e, $490ad02655eeb816$var$f($490ad02655eeb816$var$r, a), $490ad02655eeb816$var$A || $490ad02655eeb816$var$z || ($490ad02655eeb816$var$A = !0, $490ad02655eeb816$var$I($490ad02655eeb816$var$J)));
    return a;
};
$490ad02655eeb816$export$b5836b71941fa3ed = $490ad02655eeb816$var$M;
$490ad02655eeb816$export$cf845f2c119da08a = function(a) {
    var b = $490ad02655eeb816$var$y;
    return function() {
        var c = $490ad02655eeb816$var$y;
        $490ad02655eeb816$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $490ad02655eeb816$var$y = c;
        }
    };
};

});



parcelRegister("9H773", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $70eda5aa689a1ed0$export$bf730a2d8bf68b42; }, function (v) { return $70eda5aa689a1ed0$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $70eda5aa689a1ed0$export$bf730a2d8bf68b42;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
function $70eda5aa689a1ed0$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $70eda5aa689a1ed0$var$p = "function" === typeof Object.is ? Object.is : $70eda5aa689a1ed0$var$n, $70eda5aa689a1ed0$var$q = $eZVvM.useSyncExternalStore, $70eda5aa689a1ed0$var$r = $eZVvM.useRef, $70eda5aa689a1ed0$var$t = $eZVvM.useEffect, $70eda5aa689a1ed0$var$u = $eZVvM.useMemo, $70eda5aa689a1ed0$var$v = $eZVvM.useDebugValue;
$70eda5aa689a1ed0$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $70eda5aa689a1ed0$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $70eda5aa689a1ed0$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($70eda5aa689a1ed0$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $70eda5aa689a1ed0$var$q(a, c[0], c[1]);
    $70eda5aa689a1ed0$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $70eda5aa689a1ed0$var$v(d);
    return d;
};

});

parcelRegister("8pLEx", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $lUPho = parcelRequire("lUPho");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $lUPho !== "undefined" && "env" in $lUPho) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("eGpRj"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("lUPho", function(module, exports) {
// shim for using process in browser
var $ff469b01375caf06$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $ff469b01375caf06$var$cachedSetTimeout;
var $ff469b01375caf06$var$cachedClearTimeout;
function $ff469b01375caf06$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $ff469b01375caf06$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $ff469b01375caf06$var$cachedSetTimeout = setTimeout;
        else $ff469b01375caf06$var$cachedSetTimeout = $ff469b01375caf06$var$defaultSetTimout;
    } catch (e) {
        $ff469b01375caf06$var$cachedSetTimeout = $ff469b01375caf06$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $ff469b01375caf06$var$cachedClearTimeout = clearTimeout;
        else $ff469b01375caf06$var$cachedClearTimeout = $ff469b01375caf06$var$defaultClearTimeout;
    } catch (e) {
        $ff469b01375caf06$var$cachedClearTimeout = $ff469b01375caf06$var$defaultClearTimeout;
    }
})();
function $ff469b01375caf06$var$runTimeout(fun) {
    if ($ff469b01375caf06$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($ff469b01375caf06$var$cachedSetTimeout === $ff469b01375caf06$var$defaultSetTimout || !$ff469b01375caf06$var$cachedSetTimeout) && setTimeout) {
        $ff469b01375caf06$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ff469b01375caf06$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $ff469b01375caf06$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $ff469b01375caf06$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $ff469b01375caf06$var$runClearTimeout(marker) {
    if ($ff469b01375caf06$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($ff469b01375caf06$var$cachedClearTimeout === $ff469b01375caf06$var$defaultClearTimeout || !$ff469b01375caf06$var$cachedClearTimeout) && clearTimeout) {
        $ff469b01375caf06$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $ff469b01375caf06$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $ff469b01375caf06$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $ff469b01375caf06$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $ff469b01375caf06$var$queue = [];
var $ff469b01375caf06$var$draining = false;
var $ff469b01375caf06$var$currentQueue;
var $ff469b01375caf06$var$queueIndex = -1;
function $ff469b01375caf06$var$cleanUpNextTick() {
    if (!$ff469b01375caf06$var$draining || !$ff469b01375caf06$var$currentQueue) return;
    $ff469b01375caf06$var$draining = false;
    if ($ff469b01375caf06$var$currentQueue.length) $ff469b01375caf06$var$queue = $ff469b01375caf06$var$currentQueue.concat($ff469b01375caf06$var$queue);
    else $ff469b01375caf06$var$queueIndex = -1;
    if ($ff469b01375caf06$var$queue.length) $ff469b01375caf06$var$drainQueue();
}
function $ff469b01375caf06$var$drainQueue() {
    if ($ff469b01375caf06$var$draining) return;
    var timeout = $ff469b01375caf06$var$runTimeout($ff469b01375caf06$var$cleanUpNextTick);
    $ff469b01375caf06$var$draining = true;
    var len = $ff469b01375caf06$var$queue.length;
    while(len){
        $ff469b01375caf06$var$currentQueue = $ff469b01375caf06$var$queue;
        $ff469b01375caf06$var$queue = [];
        while(++$ff469b01375caf06$var$queueIndex < len)if ($ff469b01375caf06$var$currentQueue) $ff469b01375caf06$var$currentQueue[$ff469b01375caf06$var$queueIndex].run();
        $ff469b01375caf06$var$queueIndex = -1;
        len = $ff469b01375caf06$var$queue.length;
    }
    $ff469b01375caf06$var$currentQueue = null;
    $ff469b01375caf06$var$draining = false;
    $ff469b01375caf06$var$runClearTimeout(timeout);
}
$ff469b01375caf06$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $ff469b01375caf06$var$queue.push(new $ff469b01375caf06$var$Item(fun, args));
    if ($ff469b01375caf06$var$queue.length === 1 && !$ff469b01375caf06$var$draining) $ff469b01375caf06$var$runTimeout($ff469b01375caf06$var$drainQueue);
};
// v8 likes predictible objects
function $ff469b01375caf06$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$ff469b01375caf06$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$ff469b01375caf06$var$process.title = "browser";
$ff469b01375caf06$var$process.browser = true;
$ff469b01375caf06$var$process.env = {};
$ff469b01375caf06$var$process.argv = [];
$ff469b01375caf06$var$process.version = ""; // empty string to avoid regexp issues
$ff469b01375caf06$var$process.versions = {};
function $ff469b01375caf06$var$noop() {}
$ff469b01375caf06$var$process.on = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.addListener = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.once = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.off = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.removeListener = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.removeAllListeners = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.emit = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.prependListener = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.prependOnceListener = $ff469b01375caf06$var$noop;
$ff469b01375caf06$var$process.listeners = function(name) {
    return [];
};
$ff469b01375caf06$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$ff469b01375caf06$var$process.cwd = function() {
    return "/";
};
$ff469b01375caf06$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$ff469b01375caf06$var$process.umask = function() {
    return 0;
};

});

parcelRegister("eGpRj", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $ab090bfb89b623de$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("7Fd0f"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $ab090bfb89b623de$var$setup;

});
parcelRegister("7Fd0f", function(module, exports) {
/**
 * Helpers.
 */ var $594672e3509bf904$var$s = 1000;
var $594672e3509bf904$var$m = $594672e3509bf904$var$s * 60;
var $594672e3509bf904$var$h = $594672e3509bf904$var$m * 60;
var $594672e3509bf904$var$d = $594672e3509bf904$var$h * 24;
var $594672e3509bf904$var$w = $594672e3509bf904$var$d * 7;
var $594672e3509bf904$var$y = $594672e3509bf904$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $594672e3509bf904$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $594672e3509bf904$var$fmtLong(val) : $594672e3509bf904$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $594672e3509bf904$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $594672e3509bf904$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $594672e3509bf904$var$w;
        case "days":
        case "day":
        case "d":
            return n * $594672e3509bf904$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $594672e3509bf904$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $594672e3509bf904$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $594672e3509bf904$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $594672e3509bf904$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $594672e3509bf904$var$d) return Math.round(ms / $594672e3509bf904$var$d) + "d";
    if (msAbs >= $594672e3509bf904$var$h) return Math.round(ms / $594672e3509bf904$var$h) + "h";
    if (msAbs >= $594672e3509bf904$var$m) return Math.round(ms / $594672e3509bf904$var$m) + "m";
    if (msAbs >= $594672e3509bf904$var$s) return Math.round(ms / $594672e3509bf904$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $594672e3509bf904$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $594672e3509bf904$var$d) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$d, "day");
    if (msAbs >= $594672e3509bf904$var$h) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$h, "hour");
    if (msAbs >= $594672e3509bf904$var$m) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$m, "minute");
    if (msAbs >= $594672e3509bf904$var$s) return $594672e3509bf904$var$plural(ms, msAbs, $594672e3509bf904$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $594672e3509bf904$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});



parcelRegister("46xMb", function(module, exports) {
"use strict";
var $2fd1ec2e40671a2b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2fd1ec2e40671a2b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2fd1ec2e40671a2b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2fd1ec2e40671a2b$var$__createBinding(result, mod, k);
    }
    $2fd1ec2e40671a2b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Device = void 0;
module.exports.detectDevice = $2fd1ec2e40671a2b$var$detectDevice;

var $kCoWz = parcelRequire("kCoWz");

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");

const $2fd1ec2e40671a2b$var$utils = $2fd1ec2e40671a2b$var$__importStar((parcelRequire("lghrF")));

const $2fd1ec2e40671a2b$var$ortc = $2fd1ec2e40671a2b$var$__importStar((parcelRequire("5Mq2W")));

var $7Whb6 = parcelRequire("7Whb6");

var $4ZvCd = parcelRequire("4ZvCd");

var $3TLmn = parcelRequire("3TLmn");

var $8vSu0 = parcelRequire("8vSu0");

var $jTGls = parcelRequire("jTGls");

var $6oohh = parcelRequire("6oohh");

var $l1Nf1 = parcelRequire("l1Nf1");

var $a2Xk2 = parcelRequire("a2Xk2");

var $cqkQU = parcelRequire("cqkQU");

var $5TVIx = parcelRequire("5TVIx");

var $3HogQ = parcelRequire("3HogQ");

var $bcHUy = parcelRequire("bcHUy");

var $5GCJE = parcelRequire("5GCJE");
const $2fd1ec2e40671a2b$var$logger = new $24uNv.Logger("Device");
function $2fd1ec2e40671a2b$var$detectDevice() {
    // React-Native.
    // NOTE: react-native-webrtc >= 1.75.0 is required.
    // NOTE: react-native-webrtc with Unified Plan requires version >= 106.0.0.
    if (typeof navigator === "object" && navigator.product === "ReactNative") {
        $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | React-Native detected");
        if (typeof RTCPeerConnection === "undefined") {
            $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | unsupported react-native-webrtc without RTCPeerConnection, forgot to call registerGlobals()?");
            return undefined;
        }
        if (typeof RTCRtpTransceiver !== "undefined") {
            $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | ReactNative UnifiedPlan handler chosen");
            return "ReactNativeUnifiedPlan";
        } else {
            $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | ReactNative PlanB handler chosen");
            return "ReactNative";
        }
    } else if (typeof navigator === "object" && typeof navigator.userAgent === "string") {
        var _browser_name, _engine_name, _os_name, _device_model;
        const ua = navigator.userAgent;
        const uaParser = new $kCoWz.UAParser(ua);
        $2fd1ec2e40671a2b$var$logger.debug("detectDevice() | browser detected [ua:%s, parsed:%o]", ua, uaParser.getResult());
        const browser = uaParser.getBrowser();
        const browserName = (_browser_name = browser.name) === null || _browser_name === void 0 ? void 0 : _browser_name.toLowerCase();
        var _browser_major;
        const browserVersion = parseInt((_browser_major = browser.major) !== null && _browser_major !== void 0 ? _browser_major : "0");
        const engine = uaParser.getEngine();
        const engineName = (_engine_name = engine.name) === null || _engine_name === void 0 ? void 0 : _engine_name.toLowerCase();
        const os = uaParser.getOS();
        const osName = (_os_name = os.name) === null || _os_name === void 0 ? void 0 : _os_name.toLowerCase();
        var _os_version;
        const osVersion = parseFloat((_os_version = os.version) !== null && _os_version !== void 0 ? _os_version : "0");
        const device = uaParser.getDevice();
        const deviceModel = (_device_model = device.model) === null || _device_model === void 0 ? void 0 : _device_model.toLowerCase();
        const isIOS = osName === "ios" || deviceModel === "ipad";
        const isChrome = browserName && [
            "chrome",
            "chromium",
            "mobile chrome",
            "chrome webview",
            "chrome headless"
        ].includes(browserName);
        const isFirefox = browserName && [
            "firefox",
            "mobile firefox",
            "mobile focus"
        ].includes(browserName);
        const isSafari = browserName && [
            "safari",
            "mobile safari"
        ].includes(browserName);
        const isEdge = browserName && [
            "edge"
        ].includes(browserName);
        // Chrome, Chromium, and Edge.
        if ((isChrome || isEdge) && !isIOS && browserVersion >= 111) return "Chrome111";
        else if (isChrome && !isIOS && browserVersion >= 74 || isEdge && !isIOS && browserVersion >= 88) return "Chrome74";
        else if (isChrome && !isIOS && browserVersion >= 70) return "Chrome70";
        else if (isChrome && !isIOS && browserVersion >= 67) return "Chrome67";
        else if (isChrome && !isIOS && browserVersion >= 55) return "Chrome55";
        else if (isFirefox && !isIOS && browserVersion >= 120) return "Firefox120";
        else if (isFirefox && !isIOS && browserVersion >= 60) return "Firefox60";
        else if (isFirefox && isIOS && osVersion >= 14.3) return "Safari12";
        else if (isSafari && browserVersion >= 12 && typeof RTCRtpTransceiver !== "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
        else if (isSafari && browserVersion >= 11) return "Safari11";
        else if (isEdge && !isIOS && browserVersion >= 11 && browserVersion <= 18) return "Edge11";
        else if (engineName === "webkit" && isIOS && typeof RTCRtpTransceiver !== "undefined" && RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection")) return "Safari12";
        else if (engineName === "blink") {
            const match = ua.match(/(?:(?:Chrome|Chromium))[ /](\w+)/i);
            if (match) {
                const version = Number(match[1]);
                if (version >= 111) return "Chrome111";
                else if (version >= 74) return "Chrome74";
                else if (version >= 70) return "Chrome70";
                else if (version >= 67) return "Chrome67";
                else return "Chrome55";
            } else return "Chrome111";
        } else {
            $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | browser not supported [name:%s, version:%s]", browserName, browserVersion);
            return undefined;
        }
    } else {
        $2fd1ec2e40671a2b$var$logger.warn("detectDevice() | unknown device");
        return undefined;
    }
}
class $2fd1ec2e40671a2b$var$Device {
    /**
     * The RTC handler name.
     */ get handlerName() {
        return this._handlerName;
    }
    /**
     * Whether the Device is loaded.
     */ get loaded() {
        return this._loaded;
    }
    /**
     * RTP capabilities of the Device for receiving media.
     *
     * @throws {InvalidStateError} if not loaded.
     */ get rtpCapabilities() {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        return this._recvRtpCapabilities;
    }
    /**
     * SCTP capabilities of the Device.
     *
     * @throws {InvalidStateError} if not loaded.
     */ get sctpCapabilities() {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        return this._sctpCapabilities;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Initialize the Device.
     */ async load({ routerRtpCapabilities: routerRtpCapabilities }) {
        $2fd1ec2e40671a2b$var$logger.debug("load() [routerRtpCapabilities:%o]", routerRtpCapabilities);
        // Temporal handler to get its capabilities.
        let handler;
        try {
            if (this._loaded) throw new $roix3.InvalidStateError("already loaded");
            // Clone given router RTP capabilities to not modify input data.
            const clonedRouterRtpCapabilities = $2fd1ec2e40671a2b$var$utils.clone(routerRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(clonedRouterRtpCapabilities);
            handler = this._handlerFactory();
            const nativeRtpCapabilities = await handler.getNativeRtpCapabilities();
            $2fd1ec2e40671a2b$var$logger.debug("load() | got native RTP capabilities:%o", nativeRtpCapabilities);
            // Clone obtained native RTP capabilities to not modify input data.
            const clonedNativeRtpCapabilities = $2fd1ec2e40671a2b$var$utils.clone(nativeRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(clonedNativeRtpCapabilities);
            // Get extended RTP capabilities.
            this._extendedRtpCapabilities = $2fd1ec2e40671a2b$var$ortc.getExtendedRtpCapabilities(clonedNativeRtpCapabilities, clonedRouterRtpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() | got extended RTP capabilities:%o", this._extendedRtpCapabilities);
            // Check whether we can produce audio/video.
            this._canProduceByKind.audio = $2fd1ec2e40671a2b$var$ortc.canSend("audio", this._extendedRtpCapabilities);
            this._canProduceByKind.video = $2fd1ec2e40671a2b$var$ortc.canSend("video", this._extendedRtpCapabilities);
            // Generate our receiving RTP capabilities for receiving media.
            this._recvRtpCapabilities = $2fd1ec2e40671a2b$var$ortc.getRecvRtpCapabilities(this._extendedRtpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateRtpCapabilities(this._recvRtpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() | got receiving RTP capabilities:%o", this._recvRtpCapabilities);
            // Generate our SCTP capabilities.
            this._sctpCapabilities = await handler.getNativeSctpCapabilities();
            $2fd1ec2e40671a2b$var$logger.debug("load() | got native SCTP capabilities:%o", this._sctpCapabilities);
            // This may throw.
            $2fd1ec2e40671a2b$var$ortc.validateSctpCapabilities(this._sctpCapabilities);
            $2fd1ec2e40671a2b$var$logger.debug("load() succeeded");
            this._loaded = true;
            handler.close();
        } catch (error) {
            if (handler) handler.close();
            throw error;
        }
    }
    /**
     * Whether we can produce audio/video.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ canProduce(kind) {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        else if (kind !== "audio" && kind !== "video") throw new TypeError(`invalid kind "${kind}"`);
        return this._canProduceByKind[kind];
    }
    /**
     * Creates a Transport for sending media.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ createSendTransport({ id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        $2fd1ec2e40671a2b$var$logger.debug("createSendTransport()");
        return this.createTransport({
            direction: "send",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData
        });
    }
    /**
     * Creates a Transport for receiving media.
     *
     * @throws {InvalidStateError} if not loaded.
     * @throws {TypeError} if wrong arguments.
     */ createRecvTransport({ id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        $2fd1ec2e40671a2b$var$logger.debug("createRecvTransport()");
        return this.createTransport({
            direction: "recv",
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData
        });
    }
    createTransport({ direction: direction, id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData }) {
        if (!this._loaded) throw new $roix3.InvalidStateError("not loaded");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof iceParameters !== "object") throw new TypeError("missing iceParameters");
        else if (!Array.isArray(iceCandidates)) throw new TypeError("missing iceCandidates");
        else if (typeof dtlsParameters !== "object") throw new TypeError("missing dtlsParameters");
        else if (sctpParameters && typeof sctpParameters !== "object") throw new TypeError("wrong sctpParameters");
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Create a new Transport.
        const transport = new $7Whb6.Transport({
            direction: direction,
            id: id,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: additionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            appData: appData,
            handlerFactory: this._handlerFactory,
            extendedRtpCapabilities: this._extendedRtpCapabilities,
            canProduceByKind: this._canProduceByKind
        });
        // Emit observer event.
        this._observer.safeEmit("newtransport", transport);
        return transport;
    }
    /**
     * Create a new Device to connect to mediasoup server.
     *
     * @throws {UnsupportedError} if device is not supported.
     */ constructor({ handlerName: handlerName, handlerFactory: handlerFactory, Handler: Handler } = {}){
        // Loaded flag.
        this._loaded = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $2fd1ec2e40671a2b$var$logger.debug("constructor()");
        // Handle deprecated option.
        if (Handler) {
            $2fd1ec2e40671a2b$var$logger.warn("constructor() | Handler option is DEPRECATED, use handlerName or handlerFactory instead");
            if (typeof Handler === "string") handlerName = Handler;
            else throw new TypeError("non string Handler option no longer supported, use handlerFactory instead");
        }
        if (handlerName && handlerFactory) throw new TypeError("just one of handlerName or handlerInterface can be given");
        if (handlerFactory) this._handlerFactory = handlerFactory;
        else {
            if (handlerName) $2fd1ec2e40671a2b$var$logger.debug("constructor() | handler given: %s", handlerName);
            else {
                handlerName = $2fd1ec2e40671a2b$var$detectDevice();
                if (handlerName) $2fd1ec2e40671a2b$var$logger.debug("constructor() | detected handler: %s", handlerName);
                else throw new $roix3.UnsupportedError("device not supported");
            }
            switch(handlerName){
                case "Chrome111":
                    this._handlerFactory = $4ZvCd.Chrome111.createFactory();
                    break;
                case "Chrome74":
                    this._handlerFactory = $3TLmn.Chrome74.createFactory();
                    break;
                case "Chrome70":
                    this._handlerFactory = $8vSu0.Chrome70.createFactory();
                    break;
                case "Chrome67":
                    this._handlerFactory = $jTGls.Chrome67.createFactory();
                    break;
                case "Chrome55":
                    this._handlerFactory = $6oohh.Chrome55.createFactory();
                    break;
                case "Firefox120":
                    this._handlerFactory = $l1Nf1.Firefox120.createFactory();
                    break;
                case "Firefox60":
                    this._handlerFactory = $a2Xk2.Firefox60.createFactory();
                    break;
                case "Safari12":
                    this._handlerFactory = $cqkQU.Safari12.createFactory();
                    break;
                case "Safari11":
                    this._handlerFactory = $5TVIx.Safari11.createFactory();
                    break;
                case "Edge11":
                    this._handlerFactory = $3HogQ.Edge11.createFactory();
                    break;
                case "ReactNativeUnifiedPlan":
                    this._handlerFactory = $bcHUy.ReactNativeUnifiedPlan.createFactory();
                    break;
                case "ReactNative":
                    this._handlerFactory = $5GCJE.ReactNative.createFactory();
                    break;
                default:
                    throw new TypeError(`unknown handlerName "${handlerName}"`);
            }
        }
        // Create a temporal handler to get its name.
        const handler = this._handlerFactory();
        this._handlerName = handler.name;
        handler.close();
        this._extendedRtpCapabilities = undefined;
        this._recvRtpCapabilities = undefined;
        this._canProduceByKind = {
            audio: false,
            video: false
        };
        this._sctpCapabilities = undefined;
    }
}
module.exports.Device = $2fd1ec2e40671a2b$var$Device;

});
parcelRegister("kCoWz", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.39
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.39", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty("*") ? map["*"] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    "Quark"
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360" + SUFFIX_BROWSER
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1Browser"
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1" + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /(wolvic)\/([\w\.]+)/i // Wolvic
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "TCL"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        "tablet": [
                            "p10001l",
                            "w7001"
                        ],
                        "*": "mobile"
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nothing"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("24uNv", function(module, exports) {
"use strict";
var $1823d83dc217d87a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

const $1823d83dc217d87a$var$debug_1 = $1823d83dc217d87a$var$__importDefault((parcelRequire("8pLEx")));
const $1823d83dc217d87a$var$APP_NAME = "mediasoup-client";
class $1823d83dc217d87a$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:${prefix}`);
            this._warn = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:WARN:${prefix}`);
            this._error = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $1823d83dc217d87a$var$debug_1.default)($1823d83dc217d87a$var$APP_NAME);
            this._warn = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:WARN`);
            this._error = (0, $1823d83dc217d87a$var$debug_1.default)(`${$1823d83dc217d87a$var$APP_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $1823d83dc217d87a$var$Logger;

});

parcelRegister("bwd9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnhancedEventEmitter = void 0;

var $evB0H = parcelRequire("evB0H");

var $24uNv = parcelRequire("24uNv");
const $862ce27f66a74ba3$var$logger = new $24uNv.Logger("EnhancedEventEmitter");
class $862ce27f66a74ba3$var$EnhancedEventEmitter extends $evB0H.EventEmitter {
    emit(eventName, ...args) {
        return super.emit(eventName, ...args);
    }
    /**
     * Special addition to the EventEmitter API.
     */ safeEmit(eventName, ...args) {
        const numListeners = super.listenerCount(eventName);
        try {
            return super.emit(eventName, ...args);
        } catch (error) {
            $862ce27f66a74ba3$var$logger.error("safeEmit() | event listener threw an error [eventName:%s]:%o", eventName, error);
            return Boolean(numListeners);
        }
    }
    on(eventName, listener) {
        super.on(eventName, listener);
        return this;
    }
    off(eventName, listener) {
        super.off(eventName, listener);
        return this;
    }
    addListener(eventName, listener) {
        super.on(eventName, listener);
        return this;
    }
    prependListener(eventName, listener) {
        super.prependListener(eventName, listener);
        return this;
    }
    once(eventName, listener) {
        super.once(eventName, listener);
        return this;
    }
    prependOnceListener(eventName, listener) {
        super.prependOnceListener(eventName, listener);
        return this;
    }
    removeListener(eventName, listener) {
        super.off(eventName, listener);
        return this;
    }
    removeAllListeners(eventName) {
        super.removeAllListeners(eventName);
        return this;
    }
    listenerCount(eventName) {
        return super.listenerCount(eventName);
    }
    listeners(eventName) {
        return super.listeners(eventName);
    }
    rawListeners(eventName) {
        return super.rawListeners(eventName);
    }
    constructor(){
        super();
        this.setMaxListeners(Infinity);
    }
}
module.exports.EnhancedEventEmitter = $862ce27f66a74ba3$var$EnhancedEventEmitter;

});
parcelRegister("evB0H", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $a900ab6e8c8f61fb$var$R = typeof Reflect === "object" ? Reflect : null;
var $a900ab6e8c8f61fb$var$ReflectApply = $a900ab6e8c8f61fb$var$R && typeof $a900ab6e8c8f61fb$var$R.apply === "function" ? $a900ab6e8c8f61fb$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $a900ab6e8c8f61fb$var$ReflectOwnKeys;
if ($a900ab6e8c8f61fb$var$R && typeof $a900ab6e8c8f61fb$var$R.ownKeys === "function") $a900ab6e8c8f61fb$var$ReflectOwnKeys = $a900ab6e8c8f61fb$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $a900ab6e8c8f61fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $a900ab6e8c8f61fb$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $a900ab6e8c8f61fb$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $a900ab6e8c8f61fb$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $a900ab6e8c8f61fb$var$EventEmitter() {
    $a900ab6e8c8f61fb$var$EventEmitter.init.call(this);
}
module.exports = $a900ab6e8c8f61fb$var$EventEmitter;
module.exports.once = $a900ab6e8c8f61fb$var$once;
// Backwards-compat with node 0.10.x
$a900ab6e8c8f61fb$var$EventEmitter.EventEmitter = $a900ab6e8c8f61fb$var$EventEmitter;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._events = undefined;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._eventsCount = 0;
$a900ab6e8c8f61fb$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $a900ab6e8c8f61fb$var$defaultMaxListeners = 10;
function $a900ab6e8c8f61fb$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($a900ab6e8c8f61fb$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $a900ab6e8c8f61fb$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $a900ab6e8c8f61fb$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $a900ab6e8c8f61fb$var$defaultMaxListeners = arg;
    }
});
$a900ab6e8c8f61fb$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$a900ab6e8c8f61fb$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $a900ab6e8c8f61fb$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $a900ab6e8c8f61fb$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $a900ab6e8c8f61fb$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $a900ab6e8c8f61fb$var$_getMaxListeners(this);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $a900ab6e8c8f61fb$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $a900ab6e8c8f61fb$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$a900ab6e8c8f61fb$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $a900ab6e8c8f61fb$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $a900ab6e8c8f61fb$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $a900ab6e8c8f61fb$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $a900ab6e8c8f61fb$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $a900ab6e8c8f61fb$var$_addListener(this, type, listener, false);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.on = $a900ab6e8c8f61fb$var$EventEmitter.prototype.addListener;
$a900ab6e8c8f61fb$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $a900ab6e8c8f61fb$var$_addListener(this, type, listener, true);
};
function $a900ab6e8c8f61fb$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $a900ab6e8c8f61fb$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $a900ab6e8c8f61fb$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.once = function once(type, listener) {
    $a900ab6e8c8f61fb$var$checkListener(listener);
    this.on(type, $a900ab6e8c8f61fb$var$_onceWrap(this, type, listener));
    return this;
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $a900ab6e8c8f61fb$var$checkListener(listener);
    this.prependListener(type, $a900ab6e8c8f61fb$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$a900ab6e8c8f61fb$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $a900ab6e8c8f61fb$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $a900ab6e8c8f61fb$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.off = $a900ab6e8c8f61fb$var$EventEmitter.prototype.removeListener;
$a900ab6e8c8f61fb$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $a900ab6e8c8f61fb$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $a900ab6e8c8f61fb$var$unwrapListeners(evlistener) : $a900ab6e8c8f61fb$var$arrayClone(evlistener, evlistener.length);
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $a900ab6e8c8f61fb$var$_listeners(this, type, true);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $a900ab6e8c8f61fb$var$_listeners(this, type, false);
};
$a900ab6e8c8f61fb$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $a900ab6e8c8f61fb$var$listenerCount.call(emitter, type);
};
$a900ab6e8c8f61fb$var$EventEmitter.prototype.listenerCount = $a900ab6e8c8f61fb$var$listenerCount;
function $a900ab6e8c8f61fb$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$a900ab6e8c8f61fb$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $a900ab6e8c8f61fb$var$ReflectOwnKeys(this._events) : [];
};
function $a900ab6e8c8f61fb$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $a900ab6e8c8f61fb$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $a900ab6e8c8f61fb$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $a900ab6e8c8f61fb$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $a900ab6e8c8f61fb$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $a900ab6e8c8f61fb$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $a900ab6e8c8f61fb$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("roix3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidStateError = module.exports.UnsupportedError = void 0;
/**
 * Error indicating not support for something.
 */ class $05255eca12580f09$var$UnsupportedError extends Error {
    constructor(message){
        super(message);
        this.name = "UnsupportedError";
        if (Error.hasOwnProperty("captureStackTrace")) // Just in V8.
        // @ts-ignore
        Error.captureStackTrace(this, $05255eca12580f09$var$UnsupportedError);
        else this.stack = new Error(message).stack;
    }
}
module.exports.UnsupportedError = $05255eca12580f09$var$UnsupportedError;
/**
 * Error produced when calling a method in an invalid state.
 */ class $05255eca12580f09$var$InvalidStateError extends Error {
    constructor(message){
        super(message);
        this.name = "InvalidStateError";
        if (Error.hasOwnProperty("captureStackTrace")) // Just in V8.
        // @ts-ignore
        Error.captureStackTrace(this, $05255eca12580f09$var$InvalidStateError);
        else this.stack = new Error(message).stack;
    }
}
module.exports.InvalidStateError = $05255eca12580f09$var$InvalidStateError;

});

parcelRegister("lghrF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clone = $f7a89fe13fce6649$var$clone;
module.exports.generateRandomNumber = $f7a89fe13fce6649$var$generateRandomNumber;
module.exports.deepFreeze = $f7a89fe13fce6649$var$deepFreeze;
/**
 * Clones the given value.
 */ function $f7a89fe13fce6649$var$clone(value) {
    if (value === undefined) return undefined;
    else if (Number.isNaN(value)) return NaN;
    else if (typeof structuredClone === "function") // Available in Node >= 18.
    return structuredClone(value);
    else return JSON.parse(JSON.stringify(value));
}
/**
 * Generates a random positive integer.
 */ function $f7a89fe13fce6649$var$generateRandomNumber() {
    return Math.round(Math.random() * 10000000);
}
/**
 * Make an object or array recursively immutable.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze.
 */ function $f7a89fe13fce6649$var$deepFreeze(object) {
    // Retrieve the property names defined on object.
    const propNames = Reflect.ownKeys(object);
    // Freeze properties before freezing self.
    for (const name of propNames){
        const value = object[name];
        if (value && typeof value === "object" || typeof value === "function") $f7a89fe13fce6649$var$deepFreeze(value);
    }
    return Object.freeze(object);
}

});

parcelRegister("5Mq2W", function(module, exports) {
"use strict";
var $4355a3b9dc9f6c65$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4355a3b9dc9f6c65$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4355a3b9dc9f6c65$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4355a3b9dc9f6c65$var$__createBinding(result, mod, k);
    }
    $4355a3b9dc9f6c65$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateRtpCapabilities = $4355a3b9dc9f6c65$var$validateRtpCapabilities;
module.exports.validateRtpParameters = $4355a3b9dc9f6c65$var$validateRtpParameters;
module.exports.validateSctpStreamParameters = $4355a3b9dc9f6c65$var$validateSctpStreamParameters;
module.exports.validateSctpCapabilities = $4355a3b9dc9f6c65$var$validateSctpCapabilities;
module.exports.getExtendedRtpCapabilities = $4355a3b9dc9f6c65$var$getExtendedRtpCapabilities;
module.exports.getRecvRtpCapabilities = $4355a3b9dc9f6c65$var$getRecvRtpCapabilities;
module.exports.getSendingRtpParameters = $4355a3b9dc9f6c65$var$getSendingRtpParameters;
module.exports.getSendingRemoteRtpParameters = $4355a3b9dc9f6c65$var$getSendingRemoteRtpParameters;
module.exports.reduceCodecs = $4355a3b9dc9f6c65$var$reduceCodecs;
module.exports.generateProbatorRtpParameters = $4355a3b9dc9f6c65$var$generateProbatorRtpParameters;
module.exports.canSend = $4355a3b9dc9f6c65$var$canSend;
module.exports.canReceive = $4355a3b9dc9f6c65$var$canReceive;

const $4355a3b9dc9f6c65$var$h264 = $4355a3b9dc9f6c65$var$__importStar((parcelRequire("irnzV")));

const $4355a3b9dc9f6c65$var$utils = $4355a3b9dc9f6c65$var$__importStar((parcelRequire("lghrF")));
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_MID = "probator";
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_SSRC = 1234;
const $4355a3b9dc9f6c65$var$RTP_PROBATOR_CODEC_PAYLOAD_TYPE = 127;
/**
 * Validates RtpCapabilities. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCapabilities(caps) {
    if (typeof caps !== "object") throw new TypeError("caps is not an object");
    // codecs is optional. If unset, fill with an empty array.
    if (caps.codecs && !Array.isArray(caps.codecs)) throw new TypeError("caps.codecs is not an array");
    else if (!caps.codecs) caps.codecs = [];
    for (const codec of caps.codecs)$4355a3b9dc9f6c65$var$validateRtpCodecCapability(codec);
    // headerExtensions is optional. If unset, fill with an empty array.
    if (caps.headerExtensions && !Array.isArray(caps.headerExtensions)) throw new TypeError("caps.headerExtensions is not an array");
    else if (!caps.headerExtensions) caps.headerExtensions = [];
    for (const ext of caps.headerExtensions)$4355a3b9dc9f6c65$var$validateRtpHeaderExtension(ext);
}
/**
 * Validates RtpParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpParameters(params) {
    if (typeof params !== "object") throw new TypeError("params is not an object");
    // mid is optional.
    if (params.mid && typeof params.mid !== "string") throw new TypeError("params.mid is not a string");
    // codecs is mandatory.
    if (!Array.isArray(params.codecs)) throw new TypeError("missing params.codecs");
    for (const codec of params.codecs)$4355a3b9dc9f6c65$var$validateRtpCodecParameters(codec);
    // headerExtensions is optional. If unset, fill with an empty array.
    if (params.headerExtensions && !Array.isArray(params.headerExtensions)) throw new TypeError("params.headerExtensions is not an array");
    else if (!params.headerExtensions) params.headerExtensions = [];
    for (const ext of params.headerExtensions)$4355a3b9dc9f6c65$var$validateRtpHeaderExtensionParameters(ext);
    // encodings is optional. If unset, fill with an empty array.
    if (params.encodings && !Array.isArray(params.encodings)) throw new TypeError("params.encodings is not an array");
    else if (!params.encodings) params.encodings = [];
    for (const encoding of params.encodings)$4355a3b9dc9f6c65$var$validateRtpEncodingParameters(encoding);
    // rtcp is optional. If unset, fill with an empty object.
    if (params.rtcp && typeof params.rtcp !== "object") throw new TypeError("params.rtcp is not an object");
    else if (!params.rtcp) params.rtcp = {};
    $4355a3b9dc9f6c65$var$validateRtcpParameters(params.rtcp);
}
/**
 * Validates SctpStreamParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateSctpStreamParameters(params) {
    if (typeof params !== "object") throw new TypeError("params is not an object");
    // streamId is mandatory.
    if (typeof params.streamId !== "number") throw new TypeError("missing params.streamId");
    // ordered is optional.
    let orderedGiven = false;
    if (typeof params.ordered === "boolean") orderedGiven = true;
    else params.ordered = true;
    // maxPacketLifeTime is optional.
    if (params.maxPacketLifeTime && typeof params.maxPacketLifeTime !== "number") throw new TypeError("invalid params.maxPacketLifeTime");
    // maxRetransmits is optional.
    if (params.maxRetransmits && typeof params.maxRetransmits !== "number") throw new TypeError("invalid params.maxRetransmits");
    if (params.maxPacketLifeTime && params.maxRetransmits) throw new TypeError("cannot provide both maxPacketLifeTime and maxRetransmits");
    if (orderedGiven && params.ordered && (params.maxPacketLifeTime || params.maxRetransmits)) throw new TypeError("cannot be ordered with maxPacketLifeTime or maxRetransmits");
    else if (!orderedGiven && (params.maxPacketLifeTime || params.maxRetransmits)) params.ordered = false;
    // label is optional.
    if (params.label && typeof params.label !== "string") throw new TypeError("invalid params.label");
    // protocol is optional.
    if (params.protocol && typeof params.protocol !== "string") throw new TypeError("invalid params.protocol");
}
/**
 * Validates SctpCapabilities. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateSctpCapabilities(caps) {
    if (typeof caps !== "object") throw new TypeError("caps is not an object");
    // numStreams is mandatory.
    if (!caps.numStreams || typeof caps.numStreams !== "object") throw new TypeError("missing caps.numStreams");
    $4355a3b9dc9f6c65$var$validateNumSctpStreams(caps.numStreams);
}
/**
 * Generate extended RTP capabilities for sending and receiving.
 */ function $4355a3b9dc9f6c65$var$getExtendedRtpCapabilities(localCaps, remoteCaps) {
    const extendedRtpCapabilities = {
        codecs: [],
        headerExtensions: []
    };
    // Match media codecs and keep the order preferred by remoteCaps.
    for (const remoteCodec of remoteCaps.codecs || []){
        if ($4355a3b9dc9f6c65$var$isRtxCodec(remoteCodec)) continue;
        const matchingLocalCodec = (localCaps.codecs || []).find((localCodec)=>$4355a3b9dc9f6c65$var$matchCodecs(localCodec, remoteCodec, {
                strict: true,
                modify: true
            }));
        if (!matchingLocalCodec) continue;
        const extendedCodec = {
            mimeType: matchingLocalCodec.mimeType,
            kind: matchingLocalCodec.kind,
            clockRate: matchingLocalCodec.clockRate,
            channels: matchingLocalCodec.channels,
            localPayloadType: matchingLocalCodec.preferredPayloadType,
            localRtxPayloadType: undefined,
            remotePayloadType: remoteCodec.preferredPayloadType,
            remoteRtxPayloadType: undefined,
            localParameters: matchingLocalCodec.parameters,
            remoteParameters: remoteCodec.parameters,
            rtcpFeedback: $4355a3b9dc9f6c65$var$reduceRtcpFeedback(matchingLocalCodec, remoteCodec)
        };
        extendedRtpCapabilities.codecs.push(extendedCodec);
    }
    // Match RTX codecs.
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        const matchingLocalRtxCodec = localCaps.codecs.find((localCodec)=>$4355a3b9dc9f6c65$var$isRtxCodec(localCodec) && localCodec.parameters.apt === extendedCodec.localPayloadType);
        const matchingRemoteRtxCodec = remoteCaps.codecs.find((remoteCodec)=>$4355a3b9dc9f6c65$var$isRtxCodec(remoteCodec) && remoteCodec.parameters.apt === extendedCodec.remotePayloadType);
        if (matchingLocalRtxCodec && matchingRemoteRtxCodec) {
            extendedCodec.localRtxPayloadType = matchingLocalRtxCodec.preferredPayloadType;
            extendedCodec.remoteRtxPayloadType = matchingRemoteRtxCodec.preferredPayloadType;
        }
    }
    // Match header extensions.
    for (const remoteExt of remoteCaps.headerExtensions){
        const matchingLocalExt = localCaps.headerExtensions.find((localExt)=>$4355a3b9dc9f6c65$var$matchHeaderExtensions(localExt, remoteExt));
        if (!matchingLocalExt) continue;
        const extendedExt = {
            kind: remoteExt.kind,
            uri: remoteExt.uri,
            sendId: matchingLocalExt.preferredId,
            recvId: remoteExt.preferredId,
            encrypt: matchingLocalExt.preferredEncrypt,
            direction: "sendrecv"
        };
        switch(remoteExt.direction){
            case "sendrecv":
                extendedExt.direction = "sendrecv";
                break;
            case "recvonly":
                extendedExt.direction = "sendonly";
                break;
            case "sendonly":
                extendedExt.direction = "recvonly";
                break;
            case "inactive":
                extendedExt.direction = "inactive";
                break;
        }
        extendedRtpCapabilities.headerExtensions.push(extendedExt);
    }
    return extendedRtpCapabilities;
}
/**
 * Generate RTP capabilities for receiving media based on the given extended
 * RTP capabilities.
 */ function $4355a3b9dc9f6c65$var$getRecvRtpCapabilities(extendedRtpCapabilities) {
    const rtpCapabilities = {
        codecs: [],
        headerExtensions: []
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        const codec = {
            mimeType: extendedCodec.mimeType,
            kind: extendedCodec.kind,
            preferredPayloadType: extendedCodec.remotePayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.localParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpCapabilities.codecs.push(codec);
        // Add RTX codec.
        if (!extendedCodec.remoteRtxPayloadType) continue;
        const rtxCodec = {
            mimeType: `${extendedCodec.kind}/rtx`,
            kind: extendedCodec.kind,
            preferredPayloadType: extendedCodec.remoteRtxPayloadType,
            clockRate: extendedCodec.clockRate,
            parameters: {
                apt: extendedCodec.remotePayloadType
            },
            rtcpFeedback: []
        };
        rtpCapabilities.codecs.push(rtxCodec);
    // TODO: In the future, we need to add FEC, CN, etc, codecs.
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions not valid for receiving.
        if (extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "recvonly") continue;
        const ext = {
            kind: extendedExtension.kind,
            uri: extendedExtension.uri,
            preferredId: extendedExtension.recvId,
            preferredEncrypt: extendedExtension.encrypt,
            direction: extendedExtension.direction
        };
        rtpCapabilities.headerExtensions.push(ext);
    }
    return rtpCapabilities;
}
/**
 * Generate RTP parameters of the given kind for sending media.
 * NOTE: mid, encodings and rtcp fields are left empty.
 */ function $4355a3b9dc9f6c65$var$getSendingRtpParameters(kind, extendedRtpCapabilities) {
    const rtpParameters = {
        mid: undefined,
        codecs: [],
        headerExtensions: [],
        encodings: [],
        rtcp: {}
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        if (extendedCodec.kind !== kind) continue;
        const codec = {
            mimeType: extendedCodec.mimeType,
            payloadType: extendedCodec.localPayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.localParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpParameters.codecs.push(codec);
        // Add RTX codec.
        if (extendedCodec.localRtxPayloadType) {
            const rtxCodec = {
                mimeType: `${extendedCodec.kind}/rtx`,
                payloadType: extendedCodec.localRtxPayloadType,
                clockRate: extendedCodec.clockRate,
                parameters: {
                    apt: extendedCodec.localPayloadType
                },
                rtcpFeedback: []
            };
            rtpParameters.codecs.push(rtxCodec);
        }
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions of a different kind and those not valid for sending.
        if (extendedExtension.kind && extendedExtension.kind !== kind || extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "sendonly") continue;
        const ext = {
            uri: extendedExtension.uri,
            id: extendedExtension.sendId,
            encrypt: extendedExtension.encrypt,
            parameters: {}
        };
        rtpParameters.headerExtensions.push(ext);
    }
    return rtpParameters;
}
/**
 * Generate RTP parameters of the given kind suitable for the remote SDP answer.
 */ function $4355a3b9dc9f6c65$var$getSendingRemoteRtpParameters(kind, extendedRtpCapabilities) {
    const rtpParameters = {
        mid: undefined,
        codecs: [],
        headerExtensions: [],
        encodings: [],
        rtcp: {}
    };
    for (const extendedCodec of extendedRtpCapabilities.codecs){
        if (extendedCodec.kind !== kind) continue;
        const codec = {
            mimeType: extendedCodec.mimeType,
            payloadType: extendedCodec.localPayloadType,
            clockRate: extendedCodec.clockRate,
            channels: extendedCodec.channels,
            parameters: extendedCodec.remoteParameters,
            rtcpFeedback: extendedCodec.rtcpFeedback
        };
        rtpParameters.codecs.push(codec);
        // Add RTX codec.
        if (extendedCodec.localRtxPayloadType) {
            const rtxCodec = {
                mimeType: `${extendedCodec.kind}/rtx`,
                payloadType: extendedCodec.localRtxPayloadType,
                clockRate: extendedCodec.clockRate,
                parameters: {
                    apt: extendedCodec.localPayloadType
                },
                rtcpFeedback: []
            };
            rtpParameters.codecs.push(rtxCodec);
        }
    }
    for (const extendedExtension of extendedRtpCapabilities.headerExtensions){
        // Ignore RTP extensions of a different kind and those not valid for sending.
        if (extendedExtension.kind && extendedExtension.kind !== kind || extendedExtension.direction !== "sendrecv" && extendedExtension.direction !== "sendonly") continue;
        const ext = {
            uri: extendedExtension.uri,
            id: extendedExtension.sendId,
            encrypt: extendedExtension.encrypt,
            parameters: {}
        };
        rtpParameters.headerExtensions.push(ext);
    }
    // Reduce codecs' RTCP feedback. Use Transport-CC if available, REMB otherwise.
    if (rtpParameters.headerExtensions.some((ext)=>ext.uri === "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01")) for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "goog-remb");
    else if (rtpParameters.headerExtensions.some((ext)=>ext.uri === "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time")) for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "transport-cc");
    else for (const codec of rtpParameters.codecs)codec.rtcpFeedback = (codec.rtcpFeedback || []).filter((fb)=>fb.type !== "transport-cc" && fb.type !== "goog-remb");
    return rtpParameters;
}
/**
 * Reduce given codecs by returning an array of codecs "compatible" with the
 * given capability codec. If no capability codec is given, take the first
 * one(s).
 *
 * Given codecs must be generated by ortc.getSendingRtpParameters() or
 * ortc.getSendingRemoteRtpParameters().
 *
 * The returned array of codecs also include a RTX codec if available.
 */ function $4355a3b9dc9f6c65$var$reduceCodecs(codecs, capCodec) {
    const filteredCodecs = [];
    // If no capability codec is given, take the first one (and RTX).
    if (!capCodec) {
        filteredCodecs.push(codecs[0]);
        if ($4355a3b9dc9f6c65$var$isRtxCodec(codecs[1])) filteredCodecs.push(codecs[1]);
    } else {
        for(let idx = 0; idx < codecs.length; ++idx)if ($4355a3b9dc9f6c65$var$matchCodecs(codecs[idx], capCodec, {
            strict: true
        })) {
            filteredCodecs.push(codecs[idx]);
            if ($4355a3b9dc9f6c65$var$isRtxCodec(codecs[idx + 1])) filteredCodecs.push(codecs[idx + 1]);
            break;
        }
        if (filteredCodecs.length === 0) throw new TypeError("no matching codec found");
    }
    return filteredCodecs;
}
/**
 * Create RTP parameters for a Consumer for the RTP probator.
 */ function $4355a3b9dc9f6c65$var$generateProbatorRtpParameters(videoRtpParameters) {
    // Clone given reference video RTP parameters.
    videoRtpParameters = $4355a3b9dc9f6c65$var$utils.clone(videoRtpParameters);
    // This may throw.
    $4355a3b9dc9f6c65$var$validateRtpParameters(videoRtpParameters);
    const rtpParameters = {
        mid: $4355a3b9dc9f6c65$var$RTP_PROBATOR_MID,
        codecs: [],
        headerExtensions: [],
        encodings: [
            {
                ssrc: $4355a3b9dc9f6c65$var$RTP_PROBATOR_SSRC
            }
        ],
        rtcp: {
            cname: "probator"
        }
    };
    rtpParameters.codecs.push(videoRtpParameters.codecs[0]);
    rtpParameters.codecs[0].payloadType = $4355a3b9dc9f6c65$var$RTP_PROBATOR_CODEC_PAYLOAD_TYPE;
    rtpParameters.headerExtensions = videoRtpParameters.headerExtensions;
    return rtpParameters;
}
/**
 * Whether media can be sent based on the given RTP capabilities.
 */ function $4355a3b9dc9f6c65$var$canSend(kind, extendedRtpCapabilities) {
    return extendedRtpCapabilities.codecs.some((codec)=>codec.kind === kind);
}
/**
 * Whether the given RTP parameters can be received with the given RTP
 * capabilities.
 */ function $4355a3b9dc9f6c65$var$canReceive(rtpParameters, extendedRtpCapabilities) {
    // This may throw.
    $4355a3b9dc9f6c65$var$validateRtpParameters(rtpParameters);
    if (rtpParameters.codecs.length === 0) return false;
    const firstMediaCodec = rtpParameters.codecs[0];
    return extendedRtpCapabilities.codecs.some((codec)=>codec.remotePayloadType === firstMediaCodec.payloadType);
}
/**
 * Validates RtpCodecCapability. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCodecCapability(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    if (typeof codec !== "object") throw new TypeError("codec is not an object");
    // mimeType is mandatory.
    if (!codec.mimeType || typeof codec.mimeType !== "string") throw new TypeError("missing codec.mimeType");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    // Just override kind with media component of mimeType.
    codec.kind = mimeTypeMatch[1].toLowerCase();
    // preferredPayloadType is optional.
    if (codec.preferredPayloadType && typeof codec.preferredPayloadType !== "number") throw new TypeError("invalid codec.preferredPayloadType");
    // clockRate is mandatory.
    if (typeof codec.clockRate !== "number") throw new TypeError("missing codec.clockRate");
    // channels is optional. If unset, set it to 1 (just if audio).
    if (codec.kind === "audio") {
        if (typeof codec.channels !== "number") codec.channels = 1;
    } else delete codec.channels;
    // parameters is optional. If unset, set it to an empty object.
    if (!codec.parameters || typeof codec.parameters !== "object") codec.parameters = {};
    for (const key of Object.keys(codec.parameters)){
        let value = codec.parameters[key];
        if (value === undefined) {
            codec.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError(`invalid codec parameter [key:${key}s, value:${value}]`);
        // Specific parameters validation.
        if (key === "apt") {
            if (typeof value !== "number") throw new TypeError("invalid codec apt parameter");
        }
    }
    // rtcpFeedback is optional. If unset, set it to an empty array.
    if (!codec.rtcpFeedback || !Array.isArray(codec.rtcpFeedback)) codec.rtcpFeedback = [];
    for (const fb of codec.rtcpFeedback)$4355a3b9dc9f6c65$var$validateRtcpFeedback(fb);
}
/**
 * Validates RtcpFeedback. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtcpFeedback(fb) {
    if (typeof fb !== "object") throw new TypeError("fb is not an object");
    // type is mandatory.
    if (!fb.type || typeof fb.type !== "string") throw new TypeError("missing fb.type");
    // parameter is optional. If unset set it to an empty string.
    if (!fb.parameter || typeof fb.parameter !== "string") fb.parameter = "";
}
/**
 * Validates RtpHeaderExtension. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpHeaderExtension(ext) {
    if (typeof ext !== "object") throw new TypeError("ext is not an object");
    // kind is mandatory.
    if (ext.kind !== "audio" && ext.kind !== "video") throw new TypeError("invalid ext.kind");
    // uri is mandatory.
    if (!ext.uri || typeof ext.uri !== "string") throw new TypeError("missing ext.uri");
    // preferredId is mandatory.
    if (typeof ext.preferredId !== "number") throw new TypeError("missing ext.preferredId");
    // preferredEncrypt is optional. If unset set it to false.
    if (ext.preferredEncrypt && typeof ext.preferredEncrypt !== "boolean") throw new TypeError("invalid ext.preferredEncrypt");
    else if (!ext.preferredEncrypt) ext.preferredEncrypt = false;
    // direction is optional. If unset set it to sendrecv.
    if (ext.direction && typeof ext.direction !== "string") throw new TypeError("invalid ext.direction");
    else if (!ext.direction) ext.direction = "sendrecv";
}
/**
 * Validates RtpCodecParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpCodecParameters(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    if (typeof codec !== "object") throw new TypeError("codec is not an object");
    // mimeType is mandatory.
    if (!codec.mimeType || typeof codec.mimeType !== "string") throw new TypeError("missing codec.mimeType");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    // payloadType is mandatory.
    if (typeof codec.payloadType !== "number") throw new TypeError("missing codec.payloadType");
    // clockRate is mandatory.
    if (typeof codec.clockRate !== "number") throw new TypeError("missing codec.clockRate");
    const kind = mimeTypeMatch[1].toLowerCase();
    // channels is optional. If unset, set it to 1 (just if audio).
    if (kind === "audio") {
        if (typeof codec.channels !== "number") codec.channels = 1;
    } else delete codec.channels;
    // parameters is optional. If unset, set it to an empty object.
    if (!codec.parameters || typeof codec.parameters !== "object") codec.parameters = {};
    for (const key of Object.keys(codec.parameters)){
        let value = codec.parameters[key];
        if (value === undefined) {
            codec.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError(`invalid codec parameter [key:${key}s, value:${value}]`);
        // Specific parameters validation.
        if (key === "apt") {
            if (typeof value !== "number") throw new TypeError("invalid codec apt parameter");
        }
    }
    // rtcpFeedback is optional. If unset, set it to an empty array.
    if (!codec.rtcpFeedback || !Array.isArray(codec.rtcpFeedback)) codec.rtcpFeedback = [];
    for (const fb of codec.rtcpFeedback)$4355a3b9dc9f6c65$var$validateRtcpFeedback(fb);
}
/**
 * Validates RtpHeaderExtensionParameteters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpHeaderExtensionParameters(ext) {
    if (typeof ext !== "object") throw new TypeError("ext is not an object");
    // uri is mandatory.
    if (!ext.uri || typeof ext.uri !== "string") throw new TypeError("missing ext.uri");
    // id is mandatory.
    if (typeof ext.id !== "number") throw new TypeError("missing ext.id");
    // encrypt is optional. If unset set it to false.
    if (ext.encrypt && typeof ext.encrypt !== "boolean") throw new TypeError("invalid ext.encrypt");
    else if (!ext.encrypt) ext.encrypt = false;
    // parameters is optional. If unset, set it to an empty object.
    if (!ext.parameters || typeof ext.parameters !== "object") ext.parameters = {};
    for (const key of Object.keys(ext.parameters)){
        let value = ext.parameters[key];
        if (value === undefined) {
            ext.parameters[key] = "";
            value = "";
        }
        if (typeof value !== "string" && typeof value !== "number") throw new TypeError("invalid header extension parameter");
    }
}
/**
 * Validates RtpEncodingParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtpEncodingParameters(encoding) {
    if (typeof encoding !== "object") throw new TypeError("encoding is not an object");
    // ssrc is optional.
    if (encoding.ssrc && typeof encoding.ssrc !== "number") throw new TypeError("invalid encoding.ssrc");
    // rid is optional.
    if (encoding.rid && typeof encoding.rid !== "string") throw new TypeError("invalid encoding.rid");
    // rtx is optional.
    if (encoding.rtx && typeof encoding.rtx !== "object") throw new TypeError("invalid encoding.rtx");
    else if (encoding.rtx) {
        // RTX ssrc is mandatory if rtx is present.
        if (typeof encoding.rtx.ssrc !== "number") throw new TypeError("missing encoding.rtx.ssrc");
    }
    // dtx is optional. If unset set it to false.
    if (!encoding.dtx || typeof encoding.dtx !== "boolean") encoding.dtx = false;
    // scalabilityMode is optional.
    if (encoding.scalabilityMode && typeof encoding.scalabilityMode !== "string") throw new TypeError("invalid encoding.scalabilityMode");
}
/**
 * Validates RtcpParameters. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateRtcpParameters(rtcp) {
    if (typeof rtcp !== "object") throw new TypeError("rtcp is not an object");
    // cname is optional.
    if (rtcp.cname && typeof rtcp.cname !== "string") throw new TypeError("invalid rtcp.cname");
    // reducedSize is optional. If unset set it to true.
    if (!rtcp.reducedSize || typeof rtcp.reducedSize !== "boolean") rtcp.reducedSize = true;
}
/**
 * Validates NumSctpStreams. It may modify given data by adding missing
 * fields with default values.
 * It throws if invalid.
 */ function $4355a3b9dc9f6c65$var$validateNumSctpStreams(numStreams) {
    if (typeof numStreams !== "object") throw new TypeError("numStreams is not an object");
    // OS is mandatory.
    if (typeof numStreams.OS !== "number") throw new TypeError("missing numStreams.OS");
    // MIS is mandatory.
    if (typeof numStreams.MIS !== "number") throw new TypeError("missing numStreams.MIS");
}
function $4355a3b9dc9f6c65$var$isRtxCodec(codec) {
    if (!codec) return false;
    return /.+\/rtx$/i.test(codec.mimeType);
}
function $4355a3b9dc9f6c65$var$matchCodecs(aCodec, bCodec, { strict: strict = false, modify: modify = false } = {}) {
    const aMimeType = aCodec.mimeType.toLowerCase();
    const bMimeType = bCodec.mimeType.toLowerCase();
    if (aMimeType !== bMimeType) return false;
    if (aCodec.clockRate !== bCodec.clockRate) return false;
    if (aCodec.channels !== bCodec.channels) return false;
    // Per codec special checks.
    switch(aMimeType){
        case "video/h264":
            if (strict) {
                const aPacketizationMode = aCodec.parameters["packetization-mode"] || 0;
                const bPacketizationMode = bCodec.parameters["packetization-mode"] || 0;
                if (aPacketizationMode !== bPacketizationMode) return false;
                if (!$4355a3b9dc9f6c65$var$h264.isSameProfile(aCodec.parameters, bCodec.parameters)) return false;
                let selectedProfileLevelId;
                try {
                    selectedProfileLevelId = $4355a3b9dc9f6c65$var$h264.generateProfileLevelIdStringForAnswer(aCodec.parameters, bCodec.parameters);
                } catch (error) {
                    return false;
                }
                if (modify) {
                    if (selectedProfileLevelId) {
                        aCodec.parameters["profile-level-id"] = selectedProfileLevelId;
                        bCodec.parameters["profile-level-id"] = selectedProfileLevelId;
                    } else {
                        delete aCodec.parameters["profile-level-id"];
                        delete bCodec.parameters["profile-level-id"];
                    }
                }
            }
            break;
        case "video/vp9":
            if (strict) {
                const aProfileId = aCodec.parameters["profile-id"] || 0;
                const bProfileId = bCodec.parameters["profile-id"] || 0;
                if (aProfileId !== bProfileId) return false;
            }
            break;
    }
    return true;
}
function $4355a3b9dc9f6c65$var$matchHeaderExtensions(aExt, bExt) {
    if (aExt.kind && bExt.kind && aExt.kind !== bExt.kind) return false;
    if (aExt.uri !== bExt.uri) return false;
    return true;
}
function $4355a3b9dc9f6c65$var$reduceRtcpFeedback(codecA, codecB) {
    const reducedRtcpFeedback = [];
    for (const aFb of codecA.rtcpFeedback || []){
        const matchingBFb = (codecB.rtcpFeedback || []).find((bFb)=>bFb.type === aFb.type && (bFb.parameter === aFb.parameter || !bFb.parameter && !aFb.parameter));
        if (matchingBFb) reducedRtcpFeedback.push(matchingBFb);
    }
    return reducedRtcpFeedback;
}

});
parcelRegister("irnzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateProfileLevelIdStringForAnswer = module.exports.isSameProfile = module.exports.parseSdpProfileLevelId = module.exports.levelToString = module.exports.profileToString = module.exports.profileLevelIdToString = module.exports.parseProfileLevelId = module.exports.ProfileLevelId = module.exports.Level = module.exports.Profile = void 0;

var $7wuvv = parcelRequire("7wuvv");
const $d6cd09c9dd62c7a3$var$logger = new $7wuvv.Logger();
/**
 * Supported profiles.
 */ // ESLint absurdly complains about "'Profile' is already declared in
// the upper scope".
// eslint-disable-next-line no-shadow
var $d6cd09c9dd62c7a3$var$Profile;
(function(Profile) {
    Profile[Profile["ConstrainedBaseline"] = 1] = "ConstrainedBaseline";
    Profile[Profile["Baseline"] = 2] = "Baseline";
    Profile[Profile["Main"] = 3] = "Main";
    Profile[Profile["ConstrainedHigh"] = 4] = "ConstrainedHigh";
    Profile[Profile["High"] = 5] = "High";
    Profile[Profile["PredictiveHigh444"] = 6] = "PredictiveHigh444";
})($d6cd09c9dd62c7a3$var$Profile || (module.exports.Profile = $d6cd09c9dd62c7a3$var$Profile = {}));
/**
 * Supported levels.
 */ // ESLint absurdly complains about "'Level' is already declared in
// the upper scope".
// eslint-disable-next-line no-shadow
var $d6cd09c9dd62c7a3$var$Level;
(function(Level) {
    Level[Level["L1_b"] = 0] = "L1_b";
    Level[Level["L1"] = 10] = "L1";
    Level[Level["L1_1"] = 11] = "L1_1";
    Level[Level["L1_2"] = 12] = "L1_2";
    Level[Level["L1_3"] = 13] = "L1_3";
    Level[Level["L2"] = 20] = "L2";
    Level[Level["L2_1"] = 21] = "L2_1";
    Level[Level["L2_2"] = 22] = "L2_2";
    Level[Level["L3"] = 30] = "L3";
    Level[Level["L3_1"] = 31] = "L3_1";
    Level[Level["L3_2"] = 32] = "L3_2";
    Level[Level["L4"] = 40] = "L4";
    Level[Level["L4_1"] = 41] = "L4_1";
    Level[Level["L4_2"] = 42] = "L4_2";
    Level[Level["L5"] = 50] = "L5";
    Level[Level["L5_1"] = 51] = "L5_1";
    Level[Level["L5_2"] = 52] = "L5_2";
})($d6cd09c9dd62c7a3$var$Level || (module.exports.Level = $d6cd09c9dd62c7a3$var$Level = {}));
/**
 * Represents a parsed h264 profile-level-id value.
 */ class $d6cd09c9dd62c7a3$var$ProfileLevelId {
    constructor(profile, level){
        this.profile = profile;
        this.level = level;
    }
}
module.exports.ProfileLevelId = $d6cd09c9dd62c7a3$var$ProfileLevelId;
// Default ProfileLevelId.
//
// TODO: The default should really be profile Baseline and level 1 according to
// the spec: https://tools.ietf.org/html/rfc6184#section-8.1. In order to not
// break backwards compatibility with older versions of WebRTC where external
// codecs don't have any parameters, use profile ConstrainedBaseline level 3_1
// instead. This workaround will only be done in an interim period to allow
// external clients to update their code.
//
// http://crbug/webrtc/6337.
const $d6cd09c9dd62c7a3$var$DefaultProfileLevelId = new $d6cd09c9dd62c7a3$var$ProfileLevelId($d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline, $d6cd09c9dd62c7a3$var$Level.L3_1);
/**
 * Class for matching bit patterns such as "x1xx0000" where 'x' is allowed to
 * be either 0 or 1.
 */ class $d6cd09c9dd62c7a3$var$BitPattern {
    isMatch(value) {
        return this.masked_value === (value & this.mask);
    }
    constructor(str){
        this.mask = ~$d6cd09c9dd62c7a3$var$byteMaskString("x", str);
        this.masked_value = $d6cd09c9dd62c7a3$var$byteMaskString("1", str);
    }
}
/**
 * Class for converting between profile_idc/profile_iop to Profile.
 */ class $d6cd09c9dd62c7a3$var$ProfilePattern {
    constructor(profile_idc, profile_iop, profile){
        this.profile_idc = profile_idc;
        this.profile_iop = profile_iop;
        this.profile = profile;
    }
}
// This is from https://tools.ietf.org/html/rfc6184#section-8.1.
const $d6cd09c9dd62c7a3$var$ProfilePatterns = [
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x42, new $d6cd09c9dd62c7a3$var$BitPattern("x1xx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x4D, new $d6cd09c9dd62c7a3$var$BitPattern("1xxx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x58, new $d6cd09c9dd62c7a3$var$BitPattern("11xx0000"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x42, new $d6cd09c9dd62c7a3$var$BitPattern("x0xx0000"), $d6cd09c9dd62c7a3$var$Profile.Baseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x58, new $d6cd09c9dd62c7a3$var$BitPattern("10xx0000"), $d6cd09c9dd62c7a3$var$Profile.Baseline),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x4D, new $d6cd09c9dd62c7a3$var$BitPattern("0x0x0000"), $d6cd09c9dd62c7a3$var$Profile.Main),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x64, new $d6cd09c9dd62c7a3$var$BitPattern("00000000"), $d6cd09c9dd62c7a3$var$Profile.High),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0x64, new $d6cd09c9dd62c7a3$var$BitPattern("00001100"), $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh),
    new $d6cd09c9dd62c7a3$var$ProfilePattern(0xF4, new $d6cd09c9dd62c7a3$var$BitPattern("00000000"), $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444)
];
/**
 * Parse profile level id that is represented as a string of 3 hex bytes.
 * Nothing will be returned if the string is not a recognized H264 profile
 * level id.
 */ function $d6cd09c9dd62c7a3$var$parseProfileLevelId(str) {
    // For level_idc=11 and profile_idc=0x42, 0x4D, or 0x58, the constraint set3
    // flag specifies if level 1b or level 1.1 is used.
    const ConstraintSet3Flag = 0x10;
    // The string should consist of 3 bytes in hexadecimal format.
    if (typeof str !== "string" || str.length !== 6) return undefined;
    const profile_level_id_numeric = parseInt(str, 16);
    if (profile_level_id_numeric === 0) return undefined;
    // Separate into three bytes.
    const level_idc = profile_level_id_numeric & 0xFF;
    const profile_iop = profile_level_id_numeric >> 8 & 0xFF;
    const profile_idc = profile_level_id_numeric >> 16 & 0xFF;
    // Parse level based on level_idc and constraint set 3 flag.
    let level;
    switch(level_idc){
        case $d6cd09c9dd62c7a3$var$Level.L1_1:
            level = (profile_iop & ConstraintSet3Flag) !== 0 ? $d6cd09c9dd62c7a3$var$Level.L1_b : $d6cd09c9dd62c7a3$var$Level.L1_1;
            break;
        case $d6cd09c9dd62c7a3$var$Level.L1:
        case $d6cd09c9dd62c7a3$var$Level.L1_2:
        case $d6cd09c9dd62c7a3$var$Level.L1_3:
        case $d6cd09c9dd62c7a3$var$Level.L2:
        case $d6cd09c9dd62c7a3$var$Level.L2_1:
        case $d6cd09c9dd62c7a3$var$Level.L2_2:
        case $d6cd09c9dd62c7a3$var$Level.L3:
        case $d6cd09c9dd62c7a3$var$Level.L3_1:
        case $d6cd09c9dd62c7a3$var$Level.L3_2:
        case $d6cd09c9dd62c7a3$var$Level.L4:
        case $d6cd09c9dd62c7a3$var$Level.L4_1:
        case $d6cd09c9dd62c7a3$var$Level.L4_2:
        case $d6cd09c9dd62c7a3$var$Level.L5:
        case $d6cd09c9dd62c7a3$var$Level.L5_1:
        case $d6cd09c9dd62c7a3$var$Level.L5_2:
            level = level_idc;
            break;
        // Unrecognized level_idc.
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`parseProfileLevelId() | unrecognized level_idc [str:${str}, level_idc:${level_idc}]`);
            return undefined;
    }
    // Parse profile_idc/profile_iop into a Profile enum.
    for (const pattern of $d6cd09c9dd62c7a3$var$ProfilePatterns){
        if (profile_idc === pattern.profile_idc && pattern.profile_iop.isMatch(profile_iop)) return new $d6cd09c9dd62c7a3$var$ProfileLevelId(pattern.profile, level);
    }
    $d6cd09c9dd62c7a3$var$logger.warn(`parseProfileLevelId() | unrecognized profile_idc/profile_iop combination [str:${str}, profile_idc:${profile_idc}, profile_iop:${profile_iop}]`);
    return undefined;
}
module.exports.parseProfileLevelId = $d6cd09c9dd62c7a3$var$parseProfileLevelId;
/**
 * Returns canonical string representation as three hex bytes of the profile
 * level id, or returns nothing for invalid profile level ids.
 */ function $d6cd09c9dd62c7a3$var$profileLevelIdToString(profile_level_id) {
    // Handle special case level == 1b.
    if (profile_level_id.level == $d6cd09c9dd62c7a3$var$Level.L1_b) switch(profile_level_id.profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            return "42f00b";
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            return "42100b";
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            return "4d100b";
        // Level 1_b is not allowed for other profiles.
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileLevelIdToString() | Level 1_b not is allowed for profile ${profile_level_id.profile}`);
            return undefined;
    }
    let profile_idc_iop_string;
    switch(profile_level_id.profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            profile_idc_iop_string = "42e0";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            profile_idc_iop_string = "4200";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            profile_idc_iop_string = "4d00";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh:
            profile_idc_iop_string = "640c";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.High:
            profile_idc_iop_string = "6400";
            break;
        case $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444:
            profile_idc_iop_string = "f400";
            break;
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileLevelIdToString() | unrecognized profile ${profile_level_id.profile}`);
            return undefined;
    }
    let levelStr = profile_level_id.level.toString(16);
    if (levelStr.length === 1) levelStr = `0${levelStr}`;
    return `${profile_idc_iop_string}${levelStr}`;
}
module.exports.profileLevelIdToString = $d6cd09c9dd62c7a3$var$profileLevelIdToString;
/**
 * Returns a human friendly name for the given profile.
 */ function $d6cd09c9dd62c7a3$var$profileToString(profile) {
    switch(profile){
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedBaseline:
            return "ConstrainedBaseline";
        case $d6cd09c9dd62c7a3$var$Profile.Baseline:
            return "Baseline";
        case $d6cd09c9dd62c7a3$var$Profile.Main:
            return "Main";
        case $d6cd09c9dd62c7a3$var$Profile.ConstrainedHigh:
            return "ConstrainedHigh";
        case $d6cd09c9dd62c7a3$var$Profile.High:
            return "High";
        case $d6cd09c9dd62c7a3$var$Profile.PredictiveHigh444:
            return "PredictiveHigh444";
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`profileToString() | unrecognized profile ${profile}`);
            return undefined;
    }
}
module.exports.profileToString = $d6cd09c9dd62c7a3$var$profileToString;
/**
 * Returns a human friendly name for the given level.
 */ function $d6cd09c9dd62c7a3$var$levelToString(level) {
    switch(level){
        case $d6cd09c9dd62c7a3$var$Level.L1_b:
            return "1b";
        case $d6cd09c9dd62c7a3$var$Level.L1:
            return "1";
        case $d6cd09c9dd62c7a3$var$Level.L1_1:
            return "1.1";
        case $d6cd09c9dd62c7a3$var$Level.L1_2:
            return "1.2";
        case $d6cd09c9dd62c7a3$var$Level.L1_3:
            return "1.3";
        case $d6cd09c9dd62c7a3$var$Level.L2:
            return "2";
        case $d6cd09c9dd62c7a3$var$Level.L2_1:
            return "2.1";
        case $d6cd09c9dd62c7a3$var$Level.L2_2:
            return "2.2";
        case $d6cd09c9dd62c7a3$var$Level.L3:
            return "3";
        case $d6cd09c9dd62c7a3$var$Level.L3_1:
            return "3.1";
        case $d6cd09c9dd62c7a3$var$Level.L3_2:
            return "3.2";
        case $d6cd09c9dd62c7a3$var$Level.L4:
            return "4";
        case $d6cd09c9dd62c7a3$var$Level.L4_1:
            return "4.1";
        case $d6cd09c9dd62c7a3$var$Level.L4_2:
            return "4.2";
        case $d6cd09c9dd62c7a3$var$Level.L5:
            return "5";
        case $d6cd09c9dd62c7a3$var$Level.L5_1:
            return "5.1";
        case $d6cd09c9dd62c7a3$var$Level.L5_2:
            return "5.2";
        default:
            $d6cd09c9dd62c7a3$var$logger.warn(`levelToString() | unrecognized level ${level}`);
            return undefined;
    }
}
module.exports.levelToString = $d6cd09c9dd62c7a3$var$levelToString;
/**
 * Parse profile level id that is represented as a string of 3 hex bytes
 * contained in an SDP key-value map. A default profile level id will be
 * returned if the profile-level-id key is missing. Nothing will be returned
 * if the key is present but the string is invalid.
 */ function $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params = {}) {
    const profile_level_id = params["profile-level-id"];
    return profile_level_id ? $d6cd09c9dd62c7a3$var$parseProfileLevelId(profile_level_id) : $d6cd09c9dd62c7a3$var$DefaultProfileLevelId;
}
module.exports.parseSdpProfileLevelId = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId;
/**
 * Returns true if the parameters have the same H264 profile, i.e. the same
 * H264 profile (Baseline, High, etc).
 */ function $d6cd09c9dd62c7a3$var$isSameProfile(params1 = {}, params2 = {}) {
    const profile_level_id_1 = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params1);
    const profile_level_id_2 = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(params2);
    // Compare H264 profiles, but not levels.
    return Boolean(profile_level_id_1 && profile_level_id_2 && profile_level_id_1.profile === profile_level_id_2.profile);
}
module.exports.isSameProfile = $d6cd09c9dd62c7a3$var$isSameProfile;
/**
 * Generate codec parameters that will be used as answer in an SDP negotiation
 * based on local supported parameters and remote offered parameters. Both
 * local_supported_params and remote_offered_params represent sendrecv media
 * descriptions, i.e they are a mix of both encode and decode capabilities. In
 * theory, when the profile in local_supported_params represent a strict
 * superset of the profile in remote_offered_params, we could limit the profile
 * in the answer to the profile in remote_offered_params.
 *
 * However, to simplify the code, each supported H264 profile should be listed
 * explicitly in the list of local supported codecs, even if they are redundant.
 * Then each local codec in the list should be tested one at a time against the
 * remote codec, and only when the profiles are equal should this function be
 * called. Therefore, this function does not need to handle profile intersection,
 * and the profile of local_supported_params and remote_offered_params must be
 * equal before calling this function. The parameters that are used when
 * negotiating are the level part of profile-level-id and
 * level-asymmetry-allowed.
 */ function $d6cd09c9dd62c7a3$var$generateProfileLevelIdStringForAnswer(local_supported_params = {}, remote_offered_params = {}) {
    // If both local and remote params do not contain profile-level-id, they are
    // both using the default profile. In this case, don't return anything.
    if (!local_supported_params["profile-level-id"] && !remote_offered_params["profile-level-id"]) {
        $d6cd09c9dd62c7a3$var$logger.warn("generateProfileLevelIdStringForAnswer() | profile-level-id missing in local and remote params");
        return undefined;
    }
    // Parse profile-level-ids.
    const local_profile_level_id = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(local_supported_params);
    const remote_profile_level_id = $d6cd09c9dd62c7a3$var$parseSdpProfileLevelId(remote_offered_params);
    // The local and remote codec must have valid and equal H264 Profiles.
    if (!local_profile_level_id) throw new TypeError("invalid local_profile_level_id");
    if (!remote_profile_level_id) throw new TypeError("invalid remote_profile_level_id");
    if (local_profile_level_id.profile !== remote_profile_level_id.profile) throw new TypeError("H264 Profile mismatch");
    // Parse level information.
    const level_asymmetry_allowed = $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(local_supported_params) && $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(remote_offered_params);
    const local_level = local_profile_level_id.level;
    const remote_level = remote_profile_level_id.level;
    const min_level = $d6cd09c9dd62c7a3$var$minLevel(local_level, remote_level);
    // Determine answer level. When level asymmetry is not allowed, level upgrade
    // is not allowed, i.e., the level in the answer must be equal to or lower
    // than the level in the offer.
    const answer_level = level_asymmetry_allowed ? local_level : min_level;
    $d6cd09c9dd62c7a3$var$logger.debug(`generateProfileLevelIdStringForAnswer() | result [profile:${local_profile_level_id.profile}, level:${answer_level}]`);
    // Return the resulting profile-level-id for the answer parameters.
    return $d6cd09c9dd62c7a3$var$profileLevelIdToString(new $d6cd09c9dd62c7a3$var$ProfileLevelId(local_profile_level_id.profile, answer_level));
}
module.exports.generateProfileLevelIdStringForAnswer = $d6cd09c9dd62c7a3$var$generateProfileLevelIdStringForAnswer;
/**
 * Convert a string of 8 characters into a byte where the positions containing
 * character c will have their bit set. For example, c = 'x', str = "x1xx0000"
 * will return 0b10110000.
 */ function $d6cd09c9dd62c7a3$var$byteMaskString(c, str) {
    return Number(str[0] === c) << 7 | Number(str[1] === c) << 6 | Number(str[2] === c) << 5 | Number(str[3] === c) << 4 | Number(str[4] === c) << 3 | Number(str[5] === c) << 2 | Number(str[6] === c) << 1 | Number(str[7] === c) << 0;
}
// Compare H264 levels and handle the level 1b case.
function $d6cd09c9dd62c7a3$var$isLessLevel(a, b) {
    if (a === $d6cd09c9dd62c7a3$var$Level.L1_b) return b !== $d6cd09c9dd62c7a3$var$Level.L1 && b !== $d6cd09c9dd62c7a3$var$Level.L1_b;
    if (b === $d6cd09c9dd62c7a3$var$Level.L1_b) return a !== $d6cd09c9dd62c7a3$var$Level.L1;
    return a < b;
}
function $d6cd09c9dd62c7a3$var$minLevel(a, b) {
    return $d6cd09c9dd62c7a3$var$isLessLevel(a, b) ? a : b;
}
function $d6cd09c9dd62c7a3$var$isLevelAsymmetryAllowed(params = {}) {
    const level_asymmetry_allowed = params["level-asymmetry-allowed"];
    return level_asymmetry_allowed === true || level_asymmetry_allowed === 1 || level_asymmetry_allowed === "1";
}

});
parcelRegister("7wuvv", function(module, exports) {
"use strict";
var $57a32f9f887c155a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

const $57a32f9f887c155a$var$debug_1 = $57a32f9f887c155a$var$__importDefault((parcelRequire("8pLEx")));
const $57a32f9f887c155a$var$APP_NAME = "h264-profile-level-id";
class $57a32f9f887c155a$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:${prefix}`);
            this._warn = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:WARN:${prefix}`);
            this._error = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $57a32f9f887c155a$var$debug_1.default)($57a32f9f887c155a$var$APP_NAME);
            this._warn = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:WARN`);
            this._error = (0, $57a32f9f887c155a$var$debug_1.default)(`${$57a32f9f887c155a$var$APP_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $57a32f9f887c155a$var$Logger;

});



parcelRegister("7Whb6", function(module, exports) {
"use strict";
var $5c7b465ef60ea1c9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5c7b465ef60ea1c9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5c7b465ef60ea1c9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c7b465ef60ea1c9$var$__createBinding(result, mod, k);
    }
    $5c7b465ef60ea1c9$var$__setModuleDefault(result, mod);
    return result;
};
var $5c7b465ef60ea1c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transport = void 0;

var $2ico7 = parcelRequire("2ico7");

const $5c7b465ef60ea1c9$var$queue_microtask_1 = $5c7b465ef60ea1c9$var$__importDefault((parcelRequire("53epZ")));

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");

const $5c7b465ef60ea1c9$var$utils = $5c7b465ef60ea1c9$var$__importStar((parcelRequire("lghrF")));

const $5c7b465ef60ea1c9$var$ortc = $5c7b465ef60ea1c9$var$__importStar((parcelRequire("5Mq2W")));

var $ckNpk = parcelRequire("ckNpk");

var $kYlAk = parcelRequire("kYlAk");

var $7caxm = parcelRequire("7caxm");

var $9SUdt = parcelRequire("9SUdt");
const $5c7b465ef60ea1c9$var$logger = new $24uNv.Logger("Transport");
class $5c7b465ef60ea1c9$var$ConsumerCreationTask {
    constructor(consumerOptions){
        this.consumerOptions = consumerOptions;
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
class $5c7b465ef60ea1c9$var$Transport extends $bwd9s.EnhancedEventEmitter {
    /**
     * Transport id.
     */ get id() {
        return this._id;
    }
    /**
     * Whether the Transport is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Transport direction.
     */ get direction() {
        return this._direction;
    }
    /**
     * RTC handler instance.
     */ get handler() {
        return this._handler;
    }
    /**
     * ICE gathering state.
     */ get iceGatheringState() {
        return this._iceGatheringState;
    }
    /**
     * Connection state.
     */ get connectionState() {
        return this._connectionState;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Close the Transport.
     */ close() {
        if (this._closed) return;
        $5c7b465ef60ea1c9$var$logger.debug("close()");
        this._closed = true;
        // Stop the AwaitQueue.
        this._awaitQueue.stop();
        // Close the handler.
        this._handler.close();
        // Change connection state to 'closed' since the handler may not emit
        // '@connectionstatechange' event.
        this._connectionState = "closed";
        // Close all Producers.
        for (const producer of this._producers.values())producer.transportClosed();
        this._producers.clear();
        // Close all Consumers.
        for (const consumer of this._consumers.values())consumer.transportClosed();
        this._consumers.clear();
        // Close all DataProducers.
        for (const dataProducer of this._dataProducers.values())dataProducer.transportClosed();
        this._dataProducers.clear();
        // Close all DataConsumers.
        for (const dataConsumer of this._dataConsumers.values())dataConsumer.transportClosed();
        this._dataConsumers.clear();
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated Transport (RTCPeerConnection) stats.
     *
     * @returns {RTCStatsReport}
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return this._handler.getTransportStats();
    }
    /**
     * Restart ICE connection.
     */ async restartIce({ iceParameters: iceParameters }) {
        $5c7b465ef60ea1c9$var$logger.debug("restartIce()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!iceParameters) throw new TypeError("missing iceParameters");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>await this._handler.restartIce(iceParameters), "transport.restartIce()");
    }
    /**
     * Update ICE servers.
     */ async updateIceServers({ iceServers: iceServers } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("updateIceServers()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!Array.isArray(iceServers)) throw new TypeError("missing iceServers");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>this._handler.updateIceServers(iceServers), "transport.updateIceServers()");
    }
    /**
     * Create a Producer.
     */ async produce({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, stopTracks: stopTracks = true, disableTrackOnPause: disableTrackOnPause = true, zeroRtpOnPause: zeroRtpOnPause = false, onRtpSender: onRtpSender, appData: appData = {} } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("produce() [track:%o]", track);
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (!track) throw new TypeError("missing track");
        else if (this._direction !== "send") throw new $roix3.UnsupportedError("not a sending Transport");
        else if (!this._canProduceByKind[track.kind]) throw new $roix3.UnsupportedError(`cannot produce ${track.kind}`);
        else if (track.readyState === "ended") throw new $roix3.InvalidStateError("track ended");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (this.listenerCount("produce") === 0) throw new TypeError('no "produce" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            let normalizedEncodings;
            if (encodings && !Array.isArray(encodings)) throw TypeError("encodings must be an array");
            else if (encodings && encodings.length === 0) normalizedEncodings = undefined;
            else if (encodings) normalizedEncodings = encodings.map((encoding)=>{
                const normalizedEncoding = {
                    active: true
                };
                if (encoding.active === false) normalizedEncoding.active = false;
                if (typeof encoding.dtx === "boolean") normalizedEncoding.dtx = encoding.dtx;
                if (typeof encoding.scalabilityMode === "string") normalizedEncoding.scalabilityMode = encoding.scalabilityMode;
                if (typeof encoding.scaleResolutionDownBy === "number") normalizedEncoding.scaleResolutionDownBy = encoding.scaleResolutionDownBy;
                if (typeof encoding.maxBitrate === "number") normalizedEncoding.maxBitrate = encoding.maxBitrate;
                if (typeof encoding.maxFramerate === "number") normalizedEncoding.maxFramerate = encoding.maxFramerate;
                if (typeof encoding.adaptivePtime === "boolean") normalizedEncoding.adaptivePtime = encoding.adaptivePtime;
                if (typeof encoding.priority === "string") normalizedEncoding.priority = encoding.priority;
                if (typeof encoding.networkPriority === "string") normalizedEncoding.networkPriority = encoding.networkPriority;
                return normalizedEncoding;
            });
            const { localId: localId, rtpParameters: rtpParameters, rtpSender: rtpSender } = await this._handler.send({
                track: track,
                encodings: normalizedEncodings,
                codecOptions: codecOptions,
                codec: codec,
                onRtpSender: onRtpSender
            });
            try {
                // This will fill rtpParameters's missing fields with default values.
                $5c7b465ef60ea1c9$var$ortc.validateRtpParameters(rtpParameters);
                const { id: id } = await new Promise((resolve, reject)=>{
                    this.safeEmit("produce", {
                        kind: track.kind,
                        rtpParameters: rtpParameters,
                        appData: appData
                    }, resolve, reject);
                });
                const producer = new $ckNpk.Producer({
                    id: id,
                    localId: localId,
                    rtpSender: rtpSender,
                    track: track,
                    rtpParameters: rtpParameters,
                    stopTracks: stopTracks,
                    disableTrackOnPause: disableTrackOnPause,
                    zeroRtpOnPause: zeroRtpOnPause,
                    appData: appData
                });
                this._producers.set(producer.id, producer);
                this.handleProducer(producer);
                // Emit observer event.
                this._observer.safeEmit("newproducer", producer);
                return producer;
            } catch (error) {
                this._handler.stopSending(localId).catch(()=>{});
                throw error;
            }
        }, "transport.produce()")// This catch is needed to stop the given track if the command above
        // failed due to closed Transport.
        .catch((error)=>{
            if (stopTracks) try {
                track.stop();
            } catch (error2) {}
            throw error;
        });
    }
    /**
     * Create a Consumer to consume a remote Producer.
     */ async consume({ id: id, producerId: producerId, kind: kind, rtpParameters: rtpParameters, streamId: streamId, onRtpReceiver: onRtpReceiver, appData: appData = {} }) {
        $5c7b465ef60ea1c9$var$logger.debug("consume()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "recv") throw new $roix3.UnsupportedError("not a receiving Transport");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof producerId !== "string") throw new TypeError("missing producerId");
        else if (kind !== "audio" && kind !== "video") throw new TypeError(`invalid kind '${kind}'`);
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Clone given RTP parameters to not modify input data.
        const clonedRtpParameters = $5c7b465ef60ea1c9$var$utils.clone(rtpParameters);
        // Ensure the device can consume it.
        const canConsume = $5c7b465ef60ea1c9$var$ortc.canReceive(clonedRtpParameters, this._extendedRtpCapabilities);
        if (!canConsume) throw new $roix3.UnsupportedError("cannot consume this Producer");
        const consumerCreationTask = new $5c7b465ef60ea1c9$var$ConsumerCreationTask({
            id: id,
            producerId: producerId,
            kind: kind,
            rtpParameters: clonedRtpParameters,
            streamId: streamId,
            onRtpReceiver: onRtpReceiver,
            appData: appData
        });
        // Store the Consumer creation task.
        this._pendingConsumerTasks.push(consumerCreationTask);
        // There is no Consumer creation in progress, create it now.
        (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
            if (this._closed) return;
            if (this._consumerCreationInProgress === false) this.createPendingConsumers();
        });
        return consumerCreationTask.promise;
    }
    /**
     * Create a DataProducer
     */ async produceData({ ordered: ordered = true, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label = "", protocol: protocol = "", appData: appData = {} } = {}) {
        $5c7b465ef60ea1c9$var$logger.debug("produceData()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "send") throw new $roix3.UnsupportedError("not a sending Transport");
        else if (!this._maxSctpMessageSize) throw new $roix3.UnsupportedError("SCTP not enabled by remote Transport");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (this.listenerCount("producedata") === 0) throw new TypeError('no "producedata" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        if (maxPacketLifeTime || maxRetransmits) ordered = false;
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            const { dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters } = await this._handler.sendDataChannel({
                ordered: ordered,
                maxPacketLifeTime: maxPacketLifeTime,
                maxRetransmits: maxRetransmits,
                label: label,
                protocol: protocol
            });
            // This will fill sctpStreamParameters's missing fields with default values.
            $5c7b465ef60ea1c9$var$ortc.validateSctpStreamParameters(sctpStreamParameters);
            const { id: id } = await new Promise((resolve, reject)=>{
                this.safeEmit("producedata", {
                    sctpStreamParameters: sctpStreamParameters,
                    label: label,
                    protocol: protocol,
                    appData: appData
                }, resolve, reject);
            });
            const dataProducer = new $7caxm.DataProducer({
                id: id,
                dataChannel: dataChannel,
                sctpStreamParameters: sctpStreamParameters,
                appData: appData
            });
            this._dataProducers.set(dataProducer.id, dataProducer);
            this.handleDataProducer(dataProducer);
            // Emit observer event.
            this._observer.safeEmit("newdataproducer", dataProducer);
            return dataProducer;
        }, "transport.produceData()");
    }
    /**
     * Create a DataConsumer
     */ async consumeData({ id: id, dataProducerId: dataProducerId, sctpStreamParameters: sctpStreamParameters, label: label = "", protocol: protocol = "", appData: appData = {} }) {
        $5c7b465ef60ea1c9$var$logger.debug("consumeData()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._direction !== "recv") throw new $roix3.UnsupportedError("not a receiving Transport");
        else if (!this._maxSctpMessageSize) throw new $roix3.UnsupportedError("SCTP not enabled by remote Transport");
        else if (typeof id !== "string") throw new TypeError("missing id");
        else if (typeof dataProducerId !== "string") throw new TypeError("missing dataProducerId");
        else if (this.listenerCount("connect") === 0 && this._connectionState === "new") throw new TypeError('no "connect" listener set into this transport');
        else if (appData && typeof appData !== "object") throw new TypeError("if given, appData must be an object");
        // Clone given SCTP stream parameters to not modify input data.
        const clonedSctpStreamParameters = $5c7b465ef60ea1c9$var$utils.clone(sctpStreamParameters);
        // This may throw.
        $5c7b465ef60ea1c9$var$ortc.validateSctpStreamParameters(clonedSctpStreamParameters);
        // Enqueue command.
        return this._awaitQueue.push(async ()=>{
            const { dataChannel: dataChannel } = await this._handler.receiveDataChannel({
                sctpStreamParameters: clonedSctpStreamParameters,
                label: label,
                protocol: protocol
            });
            const dataConsumer = new $9SUdt.DataConsumer({
                id: id,
                dataProducerId: dataProducerId,
                dataChannel: dataChannel,
                sctpStreamParameters: clonedSctpStreamParameters,
                appData: appData
            });
            this._dataConsumers.set(dataConsumer.id, dataConsumer);
            this.handleDataConsumer(dataConsumer);
            // Emit observer event.
            this._observer.safeEmit("newdataconsumer", dataConsumer);
            return dataConsumer;
        }, "transport.consumeData()");
    }
    // This method is guaranteed to never throw.
    async createPendingConsumers() {
        this._consumerCreationInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingConsumerTasks.length === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("createPendingConsumers() | there is no Consumer to be created");
                return;
            }
            const pendingConsumerTasks = [
                ...this._pendingConsumerTasks
            ];
            // Clear pending Consumer tasks.
            this._pendingConsumerTasks = [];
            // Video Consumer in order to create the probator.
            let videoConsumerForProbator = undefined;
            // Fill options list.
            const optionsList = [];
            for (const task of pendingConsumerTasks){
                const { id: id, kind: kind, rtpParameters: rtpParameters, streamId: streamId, onRtpReceiver: onRtpReceiver } = task.consumerOptions;
                optionsList.push({
                    trackId: id,
                    kind: kind,
                    rtpParameters: rtpParameters,
                    streamId: streamId,
                    onRtpReceiver: onRtpReceiver
                });
            }
            try {
                const results = await this._handler.receive(optionsList);
                for(let idx = 0; idx < results.length; ++idx){
                    const task = pendingConsumerTasks[idx];
                    const result = results[idx];
                    const { id: id, producerId: producerId, kind: kind, rtpParameters: rtpParameters, appData: appData } = task.consumerOptions;
                    const { localId: localId, rtpReceiver: rtpReceiver, track: track } = result;
                    const consumer = new $kYlAk.Consumer({
                        id: id,
                        localId: localId,
                        producerId: producerId,
                        rtpReceiver: rtpReceiver,
                        track: track,
                        rtpParameters: rtpParameters,
                        appData: appData
                    });
                    this._consumers.set(consumer.id, consumer);
                    this.handleConsumer(consumer);
                    // If this is the first video Consumer and the Consumer for RTP probation
                    // has not yet been created, it's time to create it.
                    if (!this._probatorConsumerCreated && !videoConsumerForProbator && kind === "video") videoConsumerForProbator = consumer;
                    // Emit observer event.
                    this._observer.safeEmit("newconsumer", consumer);
                    task.resolve(consumer);
                }
            } catch (error) {
                for (const task of pendingConsumerTasks)task.reject(error);
            }
            // If RTP probation must be handled, do it now.
            if (videoConsumerForProbator) try {
                const probatorRtpParameters = $5c7b465ef60ea1c9$var$ortc.generateProbatorRtpParameters(videoConsumerForProbator.rtpParameters);
                await this._handler.receive([
                    {
                        trackId: "probator",
                        kind: "video",
                        rtpParameters: probatorRtpParameters
                    }
                ]);
                $5c7b465ef60ea1c9$var$logger.debug("createPendingConsumers() | Consumer for RTP probation created");
                this._probatorConsumerCreated = true;
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("createPendingConsumers() | failed to create Consumer for RTP probation:%o", error);
            }
        }, "transport.createPendingConsumers()").then(()=>{
            this._consumerCreationInProgress = false;
            // There are pending Consumer tasks, enqueue their creation.
            if (this._pendingConsumerTasks.length > 0) this.createPendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    pausePendingConsumers() {
        this._consumerPauseInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingPauseConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("pausePendingConsumers() | there is no Consumer to be paused");
                return;
            }
            const pendingPauseConsumers = Array.from(this._pendingPauseConsumers.values());
            // Clear pending pause Consumer map.
            this._pendingPauseConsumers.clear();
            try {
                const localIds = pendingPauseConsumers.map((consumer)=>consumer.localId);
                await this._handler.pauseReceiving(localIds);
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("pausePendingConsumers() | failed to pause Consumers:", error);
            }
        }, "transport.pausePendingConsumers").then(()=>{
            this._consumerPauseInProgress = false;
            // There are pending Consumers to be paused, do it.
            if (this._pendingPauseConsumers.size > 0) this.pausePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    resumePendingConsumers() {
        this._consumerResumeInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingResumeConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("resumePendingConsumers() | there is no Consumer to be resumed");
                return;
            }
            const pendingResumeConsumers = Array.from(this._pendingResumeConsumers.values());
            // Clear pending resume Consumer map.
            this._pendingResumeConsumers.clear();
            try {
                const localIds = pendingResumeConsumers.map((consumer)=>consumer.localId);
                await this._handler.resumeReceiving(localIds);
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("resumePendingConsumers() | failed to resume Consumers:", error);
            }
        }, "transport.resumePendingConsumers").then(()=>{
            this._consumerResumeInProgress = false;
            // There are pending Consumer to be resumed, do it.
            if (this._pendingResumeConsumers.size > 0) this.resumePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    closePendingConsumers() {
        this._consumerCloseInProgress = true;
        this._awaitQueue.push(async ()=>{
            if (this._pendingCloseConsumers.size === 0) {
                $5c7b465ef60ea1c9$var$logger.debug("closePendingConsumers() | there is no Consumer to be closed");
                return;
            }
            const pendingCloseConsumers = Array.from(this._pendingCloseConsumers.values());
            // Clear pending close Consumer map.
            this._pendingCloseConsumers.clear();
            try {
                await this._handler.stopReceiving(pendingCloseConsumers.map((consumer)=>consumer.localId));
            } catch (error) {
                $5c7b465ef60ea1c9$var$logger.error("closePendingConsumers() | failed to close Consumers:", error);
            }
        }, "transport.closePendingConsumers").then(()=>{
            this._consumerCloseInProgress = false;
            // There are pending Consumer to be resumed, do it.
            if (this._pendingCloseConsumers.size > 0) this.closePendingConsumers();
        })// NOTE: We only get here when the await queue is closed.
        .catch(()=>{});
    }
    handleHandler() {
        const handler = this._handler;
        handler.on("@connect", ({ dtlsParameters: dtlsParameters }, callback, errback)=>{
            if (this._closed) {
                errback(new $roix3.InvalidStateError("closed"));
                return;
            }
            this.safeEmit("connect", {
                dtlsParameters: dtlsParameters
            }, callback, errback);
        });
        handler.on("@icegatheringstatechange", (iceGatheringState)=>{
            if (iceGatheringState === this._iceGatheringState) return;
            $5c7b465ef60ea1c9$var$logger.debug("ICE gathering state changed to %s", iceGatheringState);
            this._iceGatheringState = iceGatheringState;
            if (!this._closed) this.safeEmit("icegatheringstatechange", iceGatheringState);
        });
        handler.on("@connectionstatechange", (connectionState)=>{
            if (connectionState === this._connectionState) return;
            $5c7b465ef60ea1c9$var$logger.debug("connection state changed to %s", connectionState);
            this._connectionState = connectionState;
            if (!this._closed) this.safeEmit("connectionstatechange", connectionState);
        });
    }
    handleProducer(producer) {
        producer.on("@close", ()=>{
            this._producers.delete(producer.id);
            if (this._closed) return;
            this._awaitQueue.push(async ()=>await this._handler.stopSending(producer.localId), "producer @close event").catch((error)=>$5c7b465ef60ea1c9$var$logger.warn("producer.close() failed:%o", error));
        });
        producer.on("@pause", (callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.pauseSending(producer.localId), "producer @pause event").then(callback).catch(errback);
        });
        producer.on("@resume", (callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.resumeSending(producer.localId), "producer @resume event").then(callback).catch(errback);
        });
        producer.on("@replacetrack", (track, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.replaceTrack(producer.localId, track), "producer @replacetrack event").then(callback).catch(errback);
        });
        producer.on("@setmaxspatiallayer", (spatialLayer, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.setMaxSpatialLayer(producer.localId, spatialLayer), "producer @setmaxspatiallayer event").then(callback).catch(errback);
        });
        producer.on("@setrtpencodingparameters", (params, callback, errback)=>{
            this._awaitQueue.push(async ()=>await this._handler.setRtpEncodingParameters(producer.localId, params), "producer @setrtpencodingparameters event").then(callback).catch(errback);
        });
        producer.on("@getstats", (callback, errback)=>{
            if (this._closed) return errback(new $roix3.InvalidStateError("closed"));
            this._handler.getSenderStats(producer.localId).then(callback).catch(errback);
        });
    }
    handleConsumer(consumer) {
        consumer.on("@close", ()=>{
            this._consumers.delete(consumer.id);
            this._pendingPauseConsumers.delete(consumer.id);
            this._pendingResumeConsumers.delete(consumer.id);
            if (this._closed) return;
            // Store the Consumer into the close list.
            this._pendingCloseConsumers.set(consumer.id, consumer);
            // There is no Consumer close in progress, do it now.
            if (this._consumerCloseInProgress === false) this.closePendingConsumers();
        });
        consumer.on("@pause", ()=>{
            // If Consumer is pending to be resumed, remove from pending resume list.
            if (this._pendingResumeConsumers.has(consumer.id)) this._pendingResumeConsumers.delete(consumer.id);
            // Store the Consumer into the pending list.
            this._pendingPauseConsumers.set(consumer.id, consumer);
            // There is no Consumer pause in progress, do it now.
            (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
                if (this._closed) return;
                if (this._consumerPauseInProgress === false) this.pausePendingConsumers();
            });
        });
        consumer.on("@resume", ()=>{
            // If Consumer is pending to be paused, remove from pending pause list.
            if (this._pendingPauseConsumers.has(consumer.id)) this._pendingPauseConsumers.delete(consumer.id);
            // Store the Consumer into the pending list.
            this._pendingResumeConsumers.set(consumer.id, consumer);
            // There is no Consumer resume in progress, do it now.
            (0, $5c7b465ef60ea1c9$var$queue_microtask_1.default)(()=>{
                if (this._closed) return;
                if (this._consumerResumeInProgress === false) this.resumePendingConsumers();
            });
        });
        consumer.on("@getstats", (callback, errback)=>{
            if (this._closed) return errback(new $roix3.InvalidStateError("closed"));
            this._handler.getReceiverStats(consumer.localId).then(callback).catch(errback);
        });
    }
    handleDataProducer(dataProducer) {
        dataProducer.on("@close", ()=>{
            this._dataProducers.delete(dataProducer.id);
        });
    }
    handleDataConsumer(dataConsumer) {
        dataConsumer.on("@close", ()=>{
            this._dataConsumers.delete(dataConsumer.id);
        });
    }
    constructor({ direction: direction, id: id, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, appData: appData, handlerFactory: handlerFactory, extendedRtpCapabilities: extendedRtpCapabilities, canProduceByKind: canProduceByKind }){
        super();
        // Closed flag.
        this._closed = false;
        // Transport ICE gathering state.
        this._iceGatheringState = "new";
        // Transport connection state.
        this._connectionState = "new";
        // Map of Producers indexed by id.
        this._producers = new Map();
        // Map of Consumers indexed by id.
        this._consumers = new Map();
        // Map of DataProducers indexed by id.
        this._dataProducers = new Map();
        // Map of DataConsumers indexed by id.
        this._dataConsumers = new Map();
        // Whether the Consumer for RTP probation has been created.
        this._probatorConsumerCreated = false;
        // AwaitQueue instance to make async tasks happen sequentially.
        this._awaitQueue = new $2ico7.AwaitQueue();
        // Consumer creation tasks awaiting to be processed.
        this._pendingConsumerTasks = [];
        // Consumer creation in progress flag.
        this._consumerCreationInProgress = false;
        // Consumers pending to be paused.
        this._pendingPauseConsumers = new Map();
        // Consumer pause in progress flag.
        this._consumerPauseInProgress = false;
        // Consumers pending to be resumed.
        this._pendingResumeConsumers = new Map();
        // Consumer resume in progress flag.
        this._consumerResumeInProgress = false;
        // Consumers pending to be closed.
        this._pendingCloseConsumers = new Map();
        // Consumer close in progress flag.
        this._consumerCloseInProgress = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $5c7b465ef60ea1c9$var$logger.debug("constructor() [id:%s, direction:%s]", id, direction);
        this._id = id;
        this._direction = direction;
        this._extendedRtpCapabilities = extendedRtpCapabilities;
        this._canProduceByKind = canProduceByKind;
        this._maxSctpMessageSize = sctpParameters ? sctpParameters.maxMessageSize : null;
        // Clone and sanitize additionalSettings.
        const clonedAdditionalSettings = $5c7b465ef60ea1c9$var$utils.clone(additionalSettings) || {};
        delete clonedAdditionalSettings.iceServers;
        delete clonedAdditionalSettings.iceTransportPolicy;
        delete clonedAdditionalSettings.bundlePolicy;
        delete clonedAdditionalSettings.rtcpMuxPolicy;
        delete clonedAdditionalSettings.sdpSemantics;
        this._handler = handlerFactory();
        this._handler.run({
            direction: direction,
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            additionalSettings: clonedAdditionalSettings,
            proprietaryConstraints: proprietaryConstraints,
            extendedRtpCapabilities: extendedRtpCapabilities
        });
        this._appData = appData || {};
        this.handleHandler();
    }
}
module.exports.Transport = $5c7b465ef60ea1c9$var$Transport;

});
parcelRegister("2ico7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AwaitQueue = module.exports.AwaitQueueRemovedTaskError = module.exports.AwaitQueueStoppedError = void 0;

var $86d5L = parcelRequire("86d5L");
const $1ab6df368975d2f5$var$logger = new $86d5L.Logger();
/**
 * Custom Error derived class used to reject pending tasks once stop() method
 * has been called.
 */ class $1ab6df368975d2f5$var$AwaitQueueStoppedError extends Error {
    constructor(message){
        super(message !== null && message !== void 0 ? message : "AwaitQueue stopped");
        this.name = "AwaitQueueStoppedError";
        // @ts-ignore
        if (typeof Error.captureStackTrace === "function") // @ts-ignore
        Error.captureStackTrace(this, $1ab6df368975d2f5$var$AwaitQueueStoppedError);
    }
}
module.exports.AwaitQueueStoppedError = $1ab6df368975d2f5$var$AwaitQueueStoppedError;
/**
 * Custom Error derived class used to reject pending tasks once removeTask()
 * method has been called.
 */ class $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError extends Error {
    constructor(message){
        super(message !== null && message !== void 0 ? message : "AwaitQueue task removed");
        this.name = "AwaitQueueRemovedTaskError";
        // @ts-ignore
        if (typeof Error.captureStackTrace === "function") // @ts-ignore
        Error.captureStackTrace(this, $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError);
    }
}
module.exports.AwaitQueueRemovedTaskError = $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError;
class $1ab6df368975d2f5$var$AwaitQueue {
    get size() {
        return this.pendingTasks.size;
    }
    async push(task, name) {
        name = name !== null && name !== void 0 ? name : task.name;
        $1ab6df368975d2f5$var$logger.debug(`push() [name:${name}]`);
        if (typeof task !== "function") throw new TypeError("given task is not a function");
        if (name) try {
            Object.defineProperty(task, "name", {
                value: name
            });
        } catch (error) {}
        return new Promise((resolve, reject)=>{
            const pendingTask = {
                id: this.nextTaskId++,
                task: task,
                name: name,
                enqueuedAt: Date.now(),
                executedAt: undefined,
                completed: false,
                resolve: (result)=>{
                    // pendingTask.resolve() can only be called in execute() method. Since
                    // resolve() was called it means that the task successfully completed.
                    // However the task may have been stopped before it completed (via
                    // stop() or remove()) so its completed flag was already set. If this
                    // is the case, abort here since next task (if any) is already being
                    // executed.
                    if (pendingTask.completed) return;
                    pendingTask.completed = true;
                    // Remove the task from the queue.
                    this.pendingTasks.delete(pendingTask.id);
                    $1ab6df368975d2f5$var$logger.debug(`resolving task [name:${pendingTask.name}]`);
                    // Resolve the task with the obtained result.
                    resolve(result);
                    // Execute the next pending task (if any).
                    const [nextPendingTask] = this.pendingTasks.values();
                    // NOTE: During the resolve() callback the user app may have interacted
                    // with the queue. For instance, the app may have pushed a task while
                    // the queue was empty so such a task is already being executed. If so,
                    // don't execute it twice.
                    if (nextPendingTask && !nextPendingTask.executedAt) this.execute(nextPendingTask);
                },
                reject: (error)=>{
                    // pendingTask.reject() can be called within execute() method if the
                    // task completed with error. However it may have also been called in
                    // stop() or remove() methods (before or while being executed) so its
                    // completed flag was already set. If so, abort here since next task
                    // (if any) is already being executed.
                    if (pendingTask.completed) return;
                    pendingTask.completed = true;
                    // Remove the task from the queue.
                    this.pendingTasks.delete(pendingTask.id);
                    $1ab6df368975d2f5$var$logger.debug(`rejecting task [name:${pendingTask.name}]: %s`, String(error));
                    // Reject the task with the obtained error.
                    reject(error);
                    // Execute the next pending task (if any) unless stop() is running.
                    if (!this.stopping) {
                        const [nextPendingTask] = this.pendingTasks.values();
                        // NOTE: During the reject() callback the user app may have interacted
                        // with the queue. For instance, the app may have pushed a task while
                        // the queue was empty so such a task is already being executed. If so,
                        // don't execute it twice.
                        if (nextPendingTask && !nextPendingTask.executedAt) this.execute(nextPendingTask);
                    }
                }
            };
            // Append task to the queue.
            this.pendingTasks.set(pendingTask.id, pendingTask);
            // And execute it if this is the only task in the queue.
            if (this.pendingTasks.size === 1) this.execute(pendingTask);
        });
    }
    stop() {
        $1ab6df368975d2f5$var$logger.debug("stop()");
        this.stopping = true;
        for (const pendingTask of this.pendingTasks.values()){
            $1ab6df368975d2f5$var$logger.debug(`stop() | stopping task [name:${pendingTask.name}]`);
            pendingTask.reject(new $1ab6df368975d2f5$var$AwaitQueueStoppedError());
        }
        this.stopping = false;
    }
    remove(taskIdx) {
        $1ab6df368975d2f5$var$logger.debug(`remove() [taskIdx:${taskIdx}]`);
        const pendingTask = Array.from(this.pendingTasks.values())[taskIdx];
        if (!pendingTask) {
            $1ab6df368975d2f5$var$logger.debug(`stop() | no task with given idx [taskIdx:${taskIdx}]`);
            return;
        }
        pendingTask.reject(new $1ab6df368975d2f5$var$AwaitQueueRemovedTaskError());
    }
    dump() {
        const now = Date.now();
        let idx = 0;
        return Array.from(this.pendingTasks.values()).map((pendingTask)=>({
                idx: idx++,
                task: pendingTask.task,
                name: pendingTask.name,
                enqueuedTime: pendingTask.executedAt ? pendingTask.executedAt - pendingTask.enqueuedAt : now - pendingTask.enqueuedAt,
                executionTime: pendingTask.executedAt ? now - pendingTask.executedAt : 0
            }));
    }
    async execute(pendingTask) {
        $1ab6df368975d2f5$var$logger.debug(`execute() [name:${pendingTask.name}]`);
        if (pendingTask.executedAt) throw new Error("task already being executed");
        pendingTask.executedAt = Date.now();
        try {
            const result = await pendingTask.task();
            // Resolve the task with its resolved result (if any).
            pendingTask.resolve(result);
        } catch (error) {
            // Reject the task with its rejected error.
            pendingTask.reject(error);
        }
    }
    constructor(){
        // Queue of pending tasks (map of PendingTasks indexed by id).
        this.pendingTasks = new Map();
        // Incrementing PendingTask id.
        this.nextTaskId = 0;
        // Whether stop() method is stopping all pending tasks.
        this.stopping = false;
    }
}
module.exports.AwaitQueue = $1ab6df368975d2f5$var$AwaitQueue;

});
parcelRegister("86d5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $8pLEx = parcelRequire("8pLEx");
const $5e590a0a8787efd3$var$LIB_NAME = "awaitqueue";
class $5e590a0a8787efd3$var$Logger {
    get debug() {
        return this._debug;
    }
    get warn() {
        return this._warn;
    }
    get error() {
        return this._error;
    }
    constructor(prefix){
        if (prefix) {
            this._debug = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:${prefix}`);
            this._warn = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:WARN:${prefix}`);
            this._error = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:ERROR:${prefix}`);
        } else {
            this._debug = (0, $8pLEx.default)($5e590a0a8787efd3$var$LIB_NAME);
            this._warn = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:WARN`);
            this._error = (0, $8pLEx.default)(`${$5e590a0a8787efd3$var$LIB_NAME}:ERROR`);
        }
        /* eslint-disable no-console */ this._debug.log = console.info.bind(console);
        this._warn.log = console.warn.bind(console);
        this._error.log = console.error.bind(console);
    /* eslint-enable no-console */ }
}
module.exports.Logger = $5e590a0a8787efd3$var$Logger;

});


parcelRegister("53epZ", function(module, exports) {
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $3ad86ab5cd139a90$var$promise;
module.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($3ad86ab5cd139a90$var$promise || ($3ad86ab5cd139a90$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));

});

parcelRegister("ckNpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Producer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $8fadad93d4ad3e47$var$logger = new $24uNv.Logger("Producer");
class $8fadad93d4ad3e47$var$Producer extends $bwd9s.EnhancedEventEmitter {
    /**
     * Producer id.
     */ get id() {
        return this._id;
    }
    /**
     * Local id.
     */ get localId() {
        return this._localId;
    }
    /**
     * Whether the Producer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Media kind.
     */ get kind() {
        return this._kind;
    }
    /**
     * Associated RTCRtpSender.
     */ get rtpSender() {
        return this._rtpSender;
    }
    /**
     * The associated track.
     */ get track() {
        return this._track;
    }
    /**
     * RTP parameters.
     */ get rtpParameters() {
        return this._rtpParameters;
    }
    /**
     * Whether the Producer is paused.
     */ get paused() {
        return this._paused;
    }
    /**
     * Max spatial layer.
     *
     * @type {Number | undefined}
     */ get maxSpatialLayer() {
        return this._maxSpatialLayer;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the Producer.
     */ close() {
        if (this._closed) return;
        $8fadad93d4ad3e47$var$logger.debug("close()");
        this._closed = true;
        this.destroyTrack();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $8fadad93d4ad3e47$var$logger.debug("transportClosed()");
        this._closed = true;
        this.destroyTrack();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated RTCRtpSender stats.
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return new Promise((resolve, reject)=>{
            this.safeEmit("@getstats", resolve, reject);
        });
    }
    /**
     * Pauses sending media.
     */ pause() {
        $8fadad93d4ad3e47$var$logger.debug("pause()");
        if (this._closed) {
            $8fadad93d4ad3e47$var$logger.error("pause() | Producer closed");
            return;
        }
        this._paused = true;
        if (this._track && this._disableTrackOnPause) this._track.enabled = false;
        if (this._zeroRtpOnPause) new Promise((resolve, reject)=>{
            this.safeEmit("@pause", resolve, reject);
        }).catch(()=>{});
        // Emit observer event.
        this._observer.safeEmit("pause");
    }
    /**
     * Resumes sending media.
     */ resume() {
        $8fadad93d4ad3e47$var$logger.debug("resume()");
        if (this._closed) {
            $8fadad93d4ad3e47$var$logger.error("resume() | Producer closed");
            return;
        }
        this._paused = false;
        if (this._track && this._disableTrackOnPause) this._track.enabled = true;
        if (this._zeroRtpOnPause) new Promise((resolve, reject)=>{
            this.safeEmit("@resume", resolve, reject);
        }).catch(()=>{});
        // Emit observer event.
        this._observer.safeEmit("resume");
    }
    /**
     * Replaces the current track with a new one or null.
     */ async replaceTrack({ track: track }) {
        $8fadad93d4ad3e47$var$logger.debug("replaceTrack() [track:%o]", track);
        if (this._closed) {
            // This must be done here. Otherwise there is no chance to stop the given
            // track.
            if (track && this._stopTracks) try {
                track.stop();
            } catch (error) {}
            throw new $roix3.InvalidStateError("closed");
        } else if (track && track.readyState === "ended") throw new $roix3.InvalidStateError("track ended");
        // Do nothing if this is the same track as the current handled one.
        if (track === this._track) {
            $8fadad93d4ad3e47$var$logger.debug("replaceTrack() | same track, ignored");
            return;
        }
        await new Promise((resolve, reject)=>{
            this.safeEmit("@replacetrack", track, resolve, reject);
        });
        // Destroy the previous track.
        this.destroyTrack();
        // Set the new track.
        this._track = track;
        // If this Producer was paused/resumed and the state of the new
        // track does not match, fix it.
        if (this._track && this._disableTrackOnPause) {
            if (!this._paused) this._track.enabled = true;
            else if (this._paused) this._track.enabled = false;
        }
        // Handle the effective track.
        this.handleTrack();
    }
    /**
     * Sets the video max spatial layer to be sent.
     */ async setMaxSpatialLayer(spatialLayer) {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (this._kind !== "video") throw new $roix3.UnsupportedError("not a video Producer");
        else if (typeof spatialLayer !== "number") throw new TypeError("invalid spatialLayer");
        if (spatialLayer === this._maxSpatialLayer) return;
        await new Promise((resolve, reject)=>{
            this.safeEmit("@setmaxspatiallayer", spatialLayer, resolve, reject);
        }).catch(()=>{});
        this._maxSpatialLayer = spatialLayer;
    }
    async setRtpEncodingParameters(params) {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        else if (typeof params !== "object") throw new TypeError("invalid params");
        await new Promise((resolve, reject)=>{
            this.safeEmit("@setrtpencodingparameters", params, resolve, reject);
        });
    }
    onTrackEnded() {
        $8fadad93d4ad3e47$var$logger.debug('track "ended" event');
        this.safeEmit("trackended");
        // Emit observer event.
        this._observer.safeEmit("trackended");
    }
    handleTrack() {
        if (!this._track) return;
        this._track.addEventListener("ended", this.onTrackEnded);
    }
    destroyTrack() {
        if (!this._track) return;
        try {
            this._track.removeEventListener("ended", this.onTrackEnded);
            // Just stop the track unless the app set stopTracks: false.
            if (this._stopTracks) this._track.stop();
        } catch (error) {}
    }
    constructor({ id: id, localId: localId, rtpSender: rtpSender, track: track, rtpParameters: rtpParameters, stopTracks: stopTracks, disableTrackOnPause: disableTrackOnPause, zeroRtpOnPause: zeroRtpOnPause, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $8fadad93d4ad3e47$var$logger.debug("constructor()");
        this._id = id;
        this._localId = localId;
        this._rtpSender = rtpSender;
        this._track = track;
        this._kind = track.kind;
        this._rtpParameters = rtpParameters;
        this._paused = disableTrackOnPause ? !track.enabled : false;
        this._maxSpatialLayer = undefined;
        this._stopTracks = stopTracks;
        this._disableTrackOnPause = disableTrackOnPause;
        this._zeroRtpOnPause = zeroRtpOnPause;
        this._appData = appData || {};
        this.onTrackEnded = this.onTrackEnded.bind(this);
        // NOTE: Minor issue. If zeroRtpOnPause is true, we cannot emit the
        // '@replacetrack' event here, so RTCRtpSender.track won't be null.
        this.handleTrack();
    }
}
module.exports.Producer = $8fadad93d4ad3e47$var$Producer;

});

parcelRegister("kYlAk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consumer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $f44a278bf79cbd61$var$logger = new $24uNv.Logger("Consumer");
class $f44a278bf79cbd61$var$Consumer extends $bwd9s.EnhancedEventEmitter {
    /**
     * Consumer id.
     */ get id() {
        return this._id;
    }
    /**
     * Local id.
     */ get localId() {
        return this._localId;
    }
    /**
     * Associated Producer id.
     */ get producerId() {
        return this._producerId;
    }
    /**
     * Whether the Consumer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * Media kind.
     */ get kind() {
        return this._track.kind;
    }
    /**
     * Associated RTCRtpReceiver.
     */ get rtpReceiver() {
        return this._rtpReceiver;
    }
    /**
     * The associated track.
     */ get track() {
        return this._track;
    }
    /**
     * RTP parameters.
     */ get rtpParameters() {
        return this._rtpParameters;
    }
    /**
     * Whether the Consumer is paused.
     */ get paused() {
        return this._paused;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the Consumer.
     */ close() {
        if (this._closed) return;
        $f44a278bf79cbd61$var$logger.debug("close()");
        this._closed = true;
        this.destroyTrack();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $f44a278bf79cbd61$var$logger.debug("transportClosed()");
        this._closed = true;
        this.destroyTrack();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Get associated RTCRtpReceiver stats.
     */ async getStats() {
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        return new Promise((resolve, reject)=>{
            this.safeEmit("@getstats", resolve, reject);
        });
    }
    /**
     * Pauses receiving media.
     */ pause() {
        $f44a278bf79cbd61$var$logger.debug("pause()");
        if (this._closed) {
            $f44a278bf79cbd61$var$logger.error("pause() | Consumer closed");
            return;
        }
        if (this._paused) {
            $f44a278bf79cbd61$var$logger.debug("pause() | Consumer is already paused");
            return;
        }
        this._paused = true;
        this._track.enabled = false;
        this.emit("@pause");
        // Emit observer event.
        this._observer.safeEmit("pause");
    }
    /**
     * Resumes receiving media.
     */ resume() {
        $f44a278bf79cbd61$var$logger.debug("resume()");
        if (this._closed) {
            $f44a278bf79cbd61$var$logger.error("resume() | Consumer closed");
            return;
        }
        if (!this._paused) {
            $f44a278bf79cbd61$var$logger.debug("resume() | Consumer is already resumed");
            return;
        }
        this._paused = false;
        this._track.enabled = true;
        this.emit("@resume");
        // Emit observer event.
        this._observer.safeEmit("resume");
    }
    onTrackEnded() {
        $f44a278bf79cbd61$var$logger.debug('track "ended" event');
        this.safeEmit("trackended");
        // Emit observer event.
        this._observer.safeEmit("trackended");
    }
    handleTrack() {
        this._track.addEventListener("ended", this.onTrackEnded);
    }
    destroyTrack() {
        try {
            this._track.removeEventListener("ended", this.onTrackEnded);
            this._track.stop();
        } catch (error) {}
    }
    constructor({ id: id, localId: localId, producerId: producerId, rtpReceiver: rtpReceiver, track: track, rtpParameters: rtpParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $f44a278bf79cbd61$var$logger.debug("constructor()");
        this._id = id;
        this._localId = localId;
        this._producerId = producerId;
        this._rtpReceiver = rtpReceiver;
        this._track = track;
        this._rtpParameters = rtpParameters;
        this._paused = !track.enabled;
        this._appData = appData || {};
        this.onTrackEnded = this.onTrackEnded.bind(this);
        this.handleTrack();
    }
}
module.exports.Consumer = $f44a278bf79cbd61$var$Consumer;

});

parcelRegister("7caxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataProducer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");

var $roix3 = parcelRequire("roix3");
const $53d1d3d9cc30e8ad$var$logger = new $24uNv.Logger("DataProducer");
class $53d1d3d9cc30e8ad$var$DataProducer extends $bwd9s.EnhancedEventEmitter {
    /**
     * DataProducer id.
     */ get id() {
        return this._id;
    }
    /**
     * Whether the DataProducer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * SCTP stream parameters.
     */ get sctpStreamParameters() {
        return this._sctpStreamParameters;
    }
    /**
     * DataChannel readyState.
     */ get readyState() {
        return this._dataChannel.readyState;
    }
    /**
     * DataChannel label.
     */ get label() {
        return this._dataChannel.label;
    }
    /**
     * DataChannel protocol.
     */ get protocol() {
        return this._dataChannel.protocol;
    }
    /**
     * DataChannel bufferedAmount.
     */ get bufferedAmount() {
        return this._dataChannel.bufferedAmount;
    }
    /**
     * DataChannel bufferedAmountLowThreshold.
     */ get bufferedAmountLowThreshold() {
        return this._dataChannel.bufferedAmountLowThreshold;
    }
    /**
     * Set DataChannel bufferedAmountLowThreshold.
     */ set bufferedAmountLowThreshold(bufferedAmountLowThreshold) {
        this._dataChannel.bufferedAmountLowThreshold = bufferedAmountLowThreshold;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the DataProducer.
     */ close() {
        if (this._closed) return;
        $53d1d3d9cc30e8ad$var$logger.debug("close()");
        this._closed = true;
        this._dataChannel.close();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $53d1d3d9cc30e8ad$var$logger.debug("transportClosed()");
        this._closed = true;
        this._dataChannel.close();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Send a message.
     *
     * @param {String|Blob|ArrayBuffer|ArrayBufferView} data.
     */ send(data) {
        $53d1d3d9cc30e8ad$var$logger.debug("send()");
        if (this._closed) throw new $roix3.InvalidStateError("closed");
        this._dataChannel.send(data);
    }
    handleDataChannel() {
        this._dataChannel.addEventListener("open", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.debug('DataChannel "open" event');
            this.safeEmit("open");
        });
        this._dataChannel.addEventListener("error", (event)=>{
            if (this._closed) return;
            let { error: error } = event;
            if (!error) error = new Error("unknown DataChannel error");
            if (error.errorDetail === "sctp-failure") $53d1d3d9cc30e8ad$var$logger.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", error.sctpCauseCode, error.message);
            else $53d1d3d9cc30e8ad$var$logger.error('DataChannel "error" event: %o', error);
            this.safeEmit("error", error);
        });
        this._dataChannel.addEventListener("close", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.warn('DataChannel "close" event');
            this._closed = true;
            this.emit("@close");
            this.safeEmit("close");
            // Emit observer event.
            this._observer.safeEmit("close");
        });
        this._dataChannel.addEventListener("message", ()=>{
            if (this._closed) return;
            $53d1d3d9cc30e8ad$var$logger.warn('DataChannel "message" event in a DataProducer, message discarded');
        });
        this._dataChannel.addEventListener("bufferedamountlow", ()=>{
            if (this._closed) return;
            this.safeEmit("bufferedamountlow");
        });
    }
    constructor({ id: id, dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $53d1d3d9cc30e8ad$var$logger.debug("constructor()");
        this._id = id;
        this._dataChannel = dataChannel;
        this._sctpStreamParameters = sctpStreamParameters;
        this._appData = appData || {};
        this.handleDataChannel();
    }
}
module.exports.DataProducer = $53d1d3d9cc30e8ad$var$DataProducer;

});

parcelRegister("9SUdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataConsumer = void 0;

var $24uNv = parcelRequire("24uNv");

var $bwd9s = parcelRequire("bwd9s");
const $7324c39726fac176$var$logger = new $24uNv.Logger("DataConsumer");
class $7324c39726fac176$var$DataConsumer extends $bwd9s.EnhancedEventEmitter {
    /**
     * DataConsumer id.
     */ get id() {
        return this._id;
    }
    /**
     * Associated DataProducer id.
     */ get dataProducerId() {
        return this._dataProducerId;
    }
    /**
     * Whether the DataConsumer is closed.
     */ get closed() {
        return this._closed;
    }
    /**
     * SCTP stream parameters.
     */ get sctpStreamParameters() {
        return this._sctpStreamParameters;
    }
    /**
     * DataChannel readyState.
     */ get readyState() {
        return this._dataChannel.readyState;
    }
    /**
     * DataChannel label.
     */ get label() {
        return this._dataChannel.label;
    }
    /**
     * DataChannel protocol.
     */ get protocol() {
        return this._dataChannel.protocol;
    }
    /**
     * DataChannel binaryType.
     */ get binaryType() {
        return this._dataChannel.binaryType;
    }
    /**
     * Set DataChannel binaryType.
     */ set binaryType(binaryType) {
        this._dataChannel.binaryType = binaryType;
    }
    /**
     * App custom data.
     */ get appData() {
        return this._appData;
    }
    /**
     * App custom data setter.
     */ set appData(appData) {
        this._appData = appData;
    }
    get observer() {
        return this._observer;
    }
    /**
     * Closes the DataConsumer.
     */ close() {
        if (this._closed) return;
        $7324c39726fac176$var$logger.debug("close()");
        this._closed = true;
        this._dataChannel.close();
        this.emit("@close");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    /**
     * Transport was closed.
     */ transportClosed() {
        if (this._closed) return;
        $7324c39726fac176$var$logger.debug("transportClosed()");
        this._closed = true;
        this._dataChannel.close();
        this.safeEmit("transportclose");
        // Emit observer event.
        this._observer.safeEmit("close");
    }
    handleDataChannel() {
        this._dataChannel.addEventListener("open", ()=>{
            if (this._closed) return;
            $7324c39726fac176$var$logger.debug('DataChannel "open" event');
            this.safeEmit("open");
        });
        this._dataChannel.addEventListener("error", (event)=>{
            if (this._closed) return;
            let { error: error } = event;
            if (!error) error = new Error("unknown DataChannel error");
            if (error.errorDetail === "sctp-failure") $7324c39726fac176$var$logger.error("DataChannel SCTP error [sctpCauseCode:%s]: %s", error.sctpCauseCode, error.message);
            else $7324c39726fac176$var$logger.error('DataChannel "error" event: %o', error);
            this.safeEmit("error", error);
        });
        this._dataChannel.addEventListener("close", ()=>{
            if (this._closed) return;
            $7324c39726fac176$var$logger.warn('DataChannel "close" event');
            this._closed = true;
            this.emit("@close");
            this.safeEmit("close");
            // Emit observer event.
            this._observer.safeEmit("close");
        });
        this._dataChannel.addEventListener("message", (event)=>{
            if (this._closed) return;
            this.safeEmit("message", event.data);
        });
    }
    constructor({ id: id, dataProducerId: dataProducerId, dataChannel: dataChannel, sctpStreamParameters: sctpStreamParameters, appData: appData }){
        super();
        // Closed flag.
        this._closed = false;
        // Observer instance.
        this._observer = new $bwd9s.EnhancedEventEmitter();
        $7324c39726fac176$var$logger.debug("constructor()");
        this._id = id;
        this._dataProducerId = dataProducerId;
        this._dataChannel = dataChannel;
        this._sctpStreamParameters = sctpStreamParameters;
        this._appData = appData || {};
        this.handleDataChannel();
    }
}
module.exports.DataConsumer = $7324c39726fac176$var$DataConsumer;

});


parcelRegister("4ZvCd", function(module, exports) {
"use strict";
var $3a2562182f54bdd8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3a2562182f54bdd8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3a2562182f54bdd8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3a2562182f54bdd8$var$__createBinding(result, mod, k);
    }
    $3a2562182f54bdd8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome111 = void 0;

const $3a2562182f54bdd8$var$sdpTransform = $3a2562182f54bdd8$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $3a2562182f54bdd8$var$utils = $3a2562182f54bdd8$var$__importStar((parcelRequire("lghrF")));

const $3a2562182f54bdd8$var$ortc = $3a2562182f54bdd8$var$__importStar((parcelRequire("5Mq2W")));

const $3a2562182f54bdd8$var$sdpCommonUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("a2dIr")));

const $3a2562182f54bdd8$var$sdpUnifiedPlanUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("ghGMB")));

const $3a2562182f54bdd8$var$ortcUtils = $3a2562182f54bdd8$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $3a2562182f54bdd8$var$logger = new $24uNv.Logger("Chrome111");
const $3a2562182f54bdd8$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $3a2562182f54bdd8$var$Chrome111 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $3a2562182f54bdd8$var$Chrome111();
    }
    get name() {
        return "Chrome111";
    }
    close() {
        $3a2562182f54bdd8$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $3a2562182f54bdd8$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $3a2562182f54bdd8$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $3a2562182f54bdd8$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $3a2562182f54bdd8$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $3a2562182f54bdd8$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $3a2562182f54bdd8$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $3a2562182f54bdd8$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $3a2562182f54bdd8$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $3a2562182f54bdd8$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else {
            $3a2562182f54bdd8$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            this._pc.addEventListener("iceconnectionstatechange", ()=>{
                switch(this._pc.iceConnectionState){
                    case "checking":
                        this.emit("@connectionstatechange", "connecting");
                        break;
                    case "connected":
                    case "completed":
                        this.emit("@connectionstatechange", "connected");
                        break;
                    case "failed":
                        this.emit("@connectionstatechange", "failed");
                        break;
                    case "disconnected":
                        this.emit("@connectionstatechange", "disconnected");
                        break;
                    case "closed":
                        this.emit("@connectionstatechange", "closed");
                        break;
                }
            });
        }
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $3a2562182f54bdd8$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $3a2562182f54bdd8$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) {
            // Set rid and verify scalabilityMode in each encoding.
            // NOTE: Even if WebRTC allows different scalabilityMode (different number
            // of temporal layers) per simulcast stream, we need that those are the
            // same in all them, so let's pick up the highest value.
            // NOTE: If scalabilityMode is not given, Chrome will use L1T3.
            let maxTemporalLayers = 1;
            for (const encoding of encodings){
                const temporalLayers = encoding.scalabilityMode ? (0, $2VyLC.parse)(encoding.scalabilityMode).temporalLayers : 3;
                if (temporalLayers > maxTemporalLayers) maxTemporalLayers = temporalLayers;
            }
            encodings.forEach((encoding, idx)=>{
                encoding.rid = `r${idx}`;
                encoding.scalabilityMode = `L1T${maxTemporalLayers}`;
            });
        }
        const sendingRtpParameters = $3a2562182f54bdd8$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $3a2562182f54bdd8$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $3a2562182f54bdd8$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $3a2562182f54bdd8$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        const offer = await this._pc.createOffer();
        let localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $3a2562182f54bdd8$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $3a2562182f54bdd8$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $3a2562182f54bdd8$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $3a2562182f54bdd8$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $3a2562182f54bdd8$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $3a2562182f54bdd8$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $3a2562182f54bdd8$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $3a2562182f54bdd8$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $3a2562182f54bdd8$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $3a2562182f54bdd8$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $3a2562182f54bdd8$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $3a2562182f54bdd8$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $3a2562182f54bdd8$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $3a2562182f54bdd8$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $3a2562182f54bdd8$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $3a2562182f54bdd8$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $3a2562182f54bdd8$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $3a2562182f54bdd8$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $3a2562182f54bdd8$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome111 = $3a2562182f54bdd8$var$Chrome111;

});
parcelRegister("8j7qr", function(module, exports) {

$parcel$export(module.exports, "write", function () { return $60c5dba4668e0873$export$68d8715fc104d294; }, function (v) { return $60c5dba4668e0873$export$68d8715fc104d294 = v; });
$parcel$export(module.exports, "parse", function () { return $60c5dba4668e0873$export$98e6a39c04603d36; }, function (v) { return $60c5dba4668e0873$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "parseParams", function () { return $60c5dba4668e0873$export$ef804106d1571703; }, function (v) { return $60c5dba4668e0873$export$ef804106d1571703 = v; });
$parcel$export(module.exports, "parseFmtpConfig", function () { return $60c5dba4668e0873$export$dfeb1045bffe1ff8; }, function (v) { return $60c5dba4668e0873$export$dfeb1045bffe1ff8 = v; });
$parcel$export(module.exports, "parsePayloads", function () { return $60c5dba4668e0873$export$326874e595fb968b; }, function (v) { return $60c5dba4668e0873$export$326874e595fb968b = v; });
$parcel$export(module.exports, "parseRemoteCandidates", function () { return $60c5dba4668e0873$export$705b3971a35c200; }, function (v) { return $60c5dba4668e0873$export$705b3971a35c200 = v; });
$parcel$export(module.exports, "parseImageAttributes", function () { return $60c5dba4668e0873$export$1ca60456d3287987; }, function (v) { return $60c5dba4668e0873$export$1ca60456d3287987 = v; });
$parcel$export(module.exports, "parseSimulcastStreamList", function () { return $60c5dba4668e0873$export$c61d0126da4c310f; }, function (v) { return $60c5dba4668e0873$export$c61d0126da4c310f = v; });
var $60c5dba4668e0873$export$68d8715fc104d294;
var $60c5dba4668e0873$export$98e6a39c04603d36;
var $60c5dba4668e0873$export$ef804106d1571703;
var $60c5dba4668e0873$export$dfeb1045bffe1ff8;
var $60c5dba4668e0873$export$326874e595fb968b;
var $60c5dba4668e0873$export$705b3971a35c200;
var $60c5dba4668e0873$export$1ca60456d3287987;
var $60c5dba4668e0873$export$c61d0126da4c310f;

var $kH1X5 = parcelRequire("kH1X5");

var $6SdWi = parcelRequire("6SdWi");
$60c5dba4668e0873$export$68d8715fc104d294 = $6SdWi;
$60c5dba4668e0873$export$98e6a39c04603d36 = $kH1X5.parse;
$60c5dba4668e0873$export$ef804106d1571703 = $kH1X5.parseParams;
$60c5dba4668e0873$export$dfeb1045bffe1ff8 = $kH1X5.parseFmtpConfig; // Alias of parseParams().
$60c5dba4668e0873$export$326874e595fb968b = $kH1X5.parsePayloads;
$60c5dba4668e0873$export$705b3971a35c200 = $kH1X5.parseRemoteCandidates;
$60c5dba4668e0873$export$1ca60456d3287987 = $kH1X5.parseImageAttributes;
$60c5dba4668e0873$export$c61d0126da4c310f = $kH1X5.parseSimulcastStreamList;

});
parcelRegister("kH1X5", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $f1095667a9bba766$export$98e6a39c04603d36; }, function (v) { return $f1095667a9bba766$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "parseParams", function () { return $f1095667a9bba766$export$ef804106d1571703; }, function (v) { return $f1095667a9bba766$export$ef804106d1571703 = v; });
$parcel$export(module.exports, "parseFmtpConfig", function () { return $f1095667a9bba766$export$dfeb1045bffe1ff8; }, function (v) { return $f1095667a9bba766$export$dfeb1045bffe1ff8 = v; });
$parcel$export(module.exports, "parsePayloads", function () { return $f1095667a9bba766$export$326874e595fb968b; }, function (v) { return $f1095667a9bba766$export$326874e595fb968b = v; });
$parcel$export(module.exports, "parseRemoteCandidates", function () { return $f1095667a9bba766$export$705b3971a35c200; }, function (v) { return $f1095667a9bba766$export$705b3971a35c200 = v; });
$parcel$export(module.exports, "parseImageAttributes", function () { return $f1095667a9bba766$export$1ca60456d3287987; }, function (v) { return $f1095667a9bba766$export$1ca60456d3287987 = v; });
$parcel$export(module.exports, "parseSimulcastStreamList", function () { return $f1095667a9bba766$export$c61d0126da4c310f; }, function (v) { return $f1095667a9bba766$export$c61d0126da4c310f = v; });
var $f1095667a9bba766$export$98e6a39c04603d36;
var $f1095667a9bba766$export$ef804106d1571703;
// For backward compatibility - alias will be removed in 3.0.0
var $f1095667a9bba766$export$dfeb1045bffe1ff8;
var $f1095667a9bba766$export$326874e595fb968b;
var $f1095667a9bba766$export$705b3971a35c200;
var $f1095667a9bba766$export$1ca60456d3287987;
var $f1095667a9bba766$export$c61d0126da4c310f;
var $f1095667a9bba766$var$toIntIfInt = function(v) {
    return String(Number(v)) === v ? Number(v) : v;
};
var $f1095667a9bba766$var$attachProperties = function(match, location, names, rawName) {
    if (rawName && !names) location[rawName] = $f1095667a9bba766$var$toIntIfInt(match[1]);
    else {
        for(var i = 0; i < names.length; i += 1)if (match[i + 1] != null) location[names[i]] = $f1095667a9bba766$var$toIntIfInt(match[i + 1]);
    }
};
var $f1095667a9bba766$var$parseReg = function(obj, location, content) {
    var needsBlank = obj.name && obj.names;
    if (obj.push && !location[obj.push]) location[obj.push] = [];
    else if (needsBlank && !location[obj.name]) location[obj.name] = {};
    var keyLocation = obj.push ? {} : needsBlank ? location[obj.name] : location; // otherwise, named location or root
    $f1095667a9bba766$var$attachProperties(content.match(obj.reg), keyLocation, obj.names, obj.name);
    if (obj.push) location[obj.push].push(keyLocation);
};

var $h9s6v = parcelRequire("h9s6v");
var $f1095667a9bba766$var$validLine = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
$f1095667a9bba766$export$98e6a39c04603d36 = function(sdp) {
    var session = {}, media = [], location = session; // points at where properties go under (one of the above)
    // parse lines we understand
    sdp.split(/(\r\n|\r|\n)/).filter($f1095667a9bba766$var$validLine).forEach(function(l) {
        var type = l[0];
        var content = l.slice(2);
        if (type === "m") {
            media.push({
                rtp: [],
                fmtp: []
            });
            location = media[media.length - 1]; // point at latest media line
        }
        for(var j = 0; j < ($h9s6v[type] || []).length; j += 1){
            var obj = $h9s6v[type][j];
            if (obj.reg.test(content)) return $f1095667a9bba766$var$parseReg(obj, location, content);
        }
    });
    session.media = media; // link it up
    return session;
};
var $f1095667a9bba766$var$paramReducer = function(acc, expr) {
    var s = expr.split(/=(.+)/, 2);
    if (s.length === 2) acc[s[0]] = $f1095667a9bba766$var$toIntIfInt(s[1]);
    else if (s.length === 1 && expr.length > 1) acc[s[0]] = undefined;
    return acc;
};
$f1095667a9bba766$export$ef804106d1571703 = function(str) {
    return str.split(/;\s?/).reduce($f1095667a9bba766$var$paramReducer, {});
};
$f1095667a9bba766$export$dfeb1045bffe1ff8 = $f1095667a9bba766$export$ef804106d1571703;
$f1095667a9bba766$export$326874e595fb968b = function(str) {
    return str.toString().split(" ").map(Number);
};
$f1095667a9bba766$export$705b3971a35c200 = function(str) {
    var candidates = [];
    var parts = str.split(" ").map($f1095667a9bba766$var$toIntIfInt);
    for(var i = 0; i < parts.length; i += 3)candidates.push({
        component: parts[i],
        ip: parts[i + 1],
        port: parts[i + 2]
    });
    return candidates;
};
$f1095667a9bba766$export$1ca60456d3287987 = function(str) {
    return str.split(" ").map(function(item) {
        return item.substring(1, item.length - 1).split(",").reduce($f1095667a9bba766$var$paramReducer, {});
    });
};
$f1095667a9bba766$export$c61d0126da4c310f = function(str) {
    return str.split(";").map(function(stream) {
        return stream.split(",").map(function(format) {
            var scid, paused = false;
            if (format[0] !== "~") scid = $f1095667a9bba766$var$toIntIfInt(format);
            else {
                scid = $f1095667a9bba766$var$toIntIfInt(format.substring(1, format.length));
                paused = true;
            }
            return {
                scid: scid,
                paused: paused
            };
        });
    });
};

});
parcelRegister("h9s6v", function(module, exports) {
var $c7c913c804974e64$var$grammar = module.exports = {
    v: [
        {
            name: "version",
            reg: /^(\d*)$/
        }
    ],
    o: [
        {
            // o=- 20518 0 IN IP4 203.0.113.1
            // NB: sessionId will be a String in most cases because it is huge
            name: "origin",
            reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
            names: [
                "username",
                "sessionId",
                "sessionVersion",
                "netType",
                "ipVer",
                "address"
            ],
            format: "%s %s %d %s IP%d %s"
        }
    ],
    // default parsing of these only (though some of these feel outdated)
    s: [
        {
            name: "name"
        }
    ],
    i: [
        {
            name: "description"
        }
    ],
    u: [
        {
            name: "uri"
        }
    ],
    e: [
        {
            name: "email"
        }
    ],
    p: [
        {
            name: "phone"
        }
    ],
    z: [
        {
            name: "timezones"
        }
    ],
    r: [
        {
            name: "repeats"
        }
    ],
    // k: [{}], // outdated thing ignored
    t: [
        {
            // t=0 0
            name: "timing",
            reg: /^(\d*) (\d*)/,
            names: [
                "start",
                "stop"
            ],
            format: "%d %d"
        }
    ],
    c: [
        {
            // c=IN IP4 10.47.197.26
            name: "connection",
            reg: /^IN IP(\d) (\S*)/,
            names: [
                "version",
                "ip"
            ],
            format: "IN IP%d %s"
        }
    ],
    b: [
        {
            // b=AS:4000
            push: "bandwidth",
            reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
            names: [
                "type",
                "limit"
            ],
            format: "%s:%s"
        }
    ],
    m: [
        {
            // m=video 51744 RTP/AVP 126 97 98 34 31
            // NB: special - pushes to session
            // TODO: rtp/fmtp should be filtered by the payloads found here?
            reg: /^(\w*) (\d*) ([\w/]*)(?: (.*))?/,
            names: [
                "type",
                "port",
                "protocol",
                "payloads"
            ],
            format: "%s %d %s %s"
        }
    ],
    a: [
        {
            // a=rtpmap:110 opus/48000/2
            push: "rtp",
            reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
            names: [
                "payload",
                "codec",
                "rate",
                "encoding"
            ],
            format: function(o) {
                return o.encoding ? "rtpmap:%d %s/%s/%s" : o.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
            }
        },
        {
            // a=fmtp:108 profile-level-id=24;object=23;bitrate=64000
            // a=fmtp:111 minptime=10; useinbandfec=1
            push: "fmtp",
            reg: /^fmtp:(\d*) ([\S| ]*)/,
            names: [
                "payload",
                "config"
            ],
            format: "fmtp:%d %s"
        },
        {
            // a=control:streamid=0
            name: "control",
            reg: /^control:(.*)/,
            format: "control:%s"
        },
        {
            // a=rtcp:65179 IN IP4 193.84.77.194
            name: "rtcp",
            reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
            names: [
                "port",
                "netType",
                "ipVer",
                "address"
            ],
            format: function(o) {
                return o.address != null ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
            }
        },
        {
            // a=rtcp-fb:98 trr-int 100
            push: "rtcpFbTrrInt",
            reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
            names: [
                "payload",
                "value"
            ],
            format: "rtcp-fb:%s trr-int %d"
        },
        {
            // a=rtcp-fb:98 nack rpsi
            push: "rtcpFb",
            reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
            names: [
                "payload",
                "type",
                "subtype"
            ],
            format: function(o) {
                return o.subtype != null ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
            }
        },
        {
            // a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
            // a=extmap:1/recvonly URI-gps-string
            // a=extmap:3 urn:ietf:params:rtp-hdrext:encrypt urn:ietf:params:rtp-hdrext:smpte-tc 25@600/24
            push: "ext",
            reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
            names: [
                "value",
                "direction",
                "encrypt-uri",
                "uri",
                "config"
            ],
            format: function(o) {
                return "extmap:%d" + (o.direction ? "/%s" : "%v") + (o["encrypt-uri"] ? " %s" : "%v") + " %s" + (o.config ? " %s" : "");
            }
        },
        {
            // a=extmap-allow-mixed
            name: "extmapAllowMixed",
            reg: /^(extmap-allow-mixed)/
        },
        {
            // a=crypto:1 AES_CM_128_HMAC_SHA1_80 inline:PS1uQCVeeCFCanVmcjkpPywjNWhcYD0mXXtxaVBR|2^20|1:32
            push: "crypto",
            reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
            names: [
                "id",
                "suite",
                "config",
                "sessionConfig"
            ],
            format: function(o) {
                return o.sessionConfig != null ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
            }
        },
        {
            // a=setup:actpass
            name: "setup",
            reg: /^setup:(\w*)/,
            format: "setup:%s"
        },
        {
            // a=connection:new
            name: "connectionType",
            reg: /^connection:(new|existing)/,
            format: "connection:%s"
        },
        {
            // a=mid:1
            name: "mid",
            reg: /^mid:([^\s]*)/,
            format: "mid:%s"
        },
        {
            // a=msid:0c8b064d-d807-43b4-b434-f92a889d8587 98178685-d409-46e0-8e16-7ef0db0db64a
            name: "msid",
            reg: /^msid:(.*)/,
            format: "msid:%s"
        },
        {
            // a=ptime:20
            name: "ptime",
            reg: /^ptime:(\d*(?:\.\d*)*)/,
            format: "ptime:%d"
        },
        {
            // a=maxptime:60
            name: "maxptime",
            reg: /^maxptime:(\d*(?:\.\d*)*)/,
            format: "maxptime:%d"
        },
        {
            // a=sendrecv
            name: "direction",
            reg: /^(sendrecv|recvonly|sendonly|inactive)/
        },
        {
            // a=ice-lite
            name: "icelite",
            reg: /^(ice-lite)/
        },
        {
            // a=ice-ufrag:F7gI
            name: "iceUfrag",
            reg: /^ice-ufrag:(\S*)/,
            format: "ice-ufrag:%s"
        },
        {
            // a=ice-pwd:x9cml/YzichV2+XlhiMu8g
            name: "icePwd",
            reg: /^ice-pwd:(\S*)/,
            format: "ice-pwd:%s"
        },
        {
            // a=fingerprint:SHA-1 00:11:22:33:44:55:66:77:88:99:AA:BB:CC:DD:EE:FF:00:11:22:33
            name: "fingerprint",
            reg: /^fingerprint:(\S*) (\S*)/,
            names: [
                "type",
                "hash"
            ],
            format: "fingerprint:%s %s"
        },
        {
            // a=candidate:0 1 UDP 2113667327 203.0.113.1 54400 typ host
            // a=candidate:1162875081 1 udp 2113937151 192.168.34.75 60017 typ host generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 udp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 generation 0 network-id 3 network-cost 10
            // a=candidate:229815620 1 tcp 1518280447 192.168.150.19 60017 typ host tcptype active generation 0 network-id 3 network-cost 10
            // a=candidate:3289912957 2 tcp 1845501695 193.84.77.194 60017 typ srflx raddr 192.168.34.75 rport 60017 tcptype passive generation 0 network-id 3 network-cost 10
            push: "candidates",
            reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
            names: [
                "foundation",
                "component",
                "transport",
                "priority",
                "ip",
                "port",
                "type",
                "raddr",
                "rport",
                "tcptype",
                "generation",
                "network-id",
                "network-cost"
            ],
            format: function(o) {
                var str = "candidate:%s %d %s %d %s %d typ %s";
                str += o.raddr != null ? " raddr %s rport %d" : "%v%v";
                // NB: candidate has three optional chunks, so %void middles one if it's missing
                str += o.tcptype != null ? " tcptype %s" : "%v";
                if (o.generation != null) str += " generation %d";
                str += o["network-id"] != null ? " network-id %d" : "%v";
                str += o["network-cost"] != null ? " network-cost %d" : "%v";
                return str;
            }
        },
        {
            // a=end-of-candidates (keep after the candidates line for readability)
            name: "endOfCandidates",
            reg: /^(end-of-candidates)/
        },
        {
            // a=remote-candidates:1 203.0.113.1 54400 2 203.0.113.1 54401 ...
            name: "remoteCandidates",
            reg: /^remote-candidates:(.*)/,
            format: "remote-candidates:%s"
        },
        {
            // a=ice-options:google-ice
            name: "iceOptions",
            reg: /^ice-options:(\S*)/,
            format: "ice-options:%s"
        },
        {
            // a=ssrc:2566107569 cname:t9YU8M1UxTF8Y1A1
            push: "ssrcs",
            reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
            names: [
                "id",
                "attribute",
                "value"
            ],
            format: function(o) {
                var str = "ssrc:%d";
                if (o.attribute != null) {
                    str += " %s";
                    if (o.value != null) str += ":%s";
                }
                return str;
            }
        },
        {
            // a=ssrc-group:FEC 1 2
            // a=ssrc-group:FEC-FR 3004364195 1080772241
            push: "ssrcGroups",
            // token-char = %x21 / %x23-27 / %x2A-2B / %x2D-2E / %x30-39 / %x41-5A / %x5E-7E
            reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
            names: [
                "semantics",
                "ssrcs"
            ],
            format: "ssrc-group:%s %s"
        },
        {
            // a=msid-semantic: WMS Jvlam5X3SX1OP6pn20zWogvaKJz5Hjf9OnlV
            name: "msidSemantic",
            reg: /^msid-semantic:\s?(\w*) (\S*)/,
            names: [
                "semantic",
                "token"
            ],
            format: "msid-semantic: %s %s" // space after ':' is not accidental
        },
        {
            // a=group:BUNDLE audio video
            push: "groups",
            reg: /^group:(\w*) (.*)/,
            names: [
                "type",
                "mids"
            ],
            format: "group:%s %s"
        },
        {
            // a=rtcp-mux
            name: "rtcpMux",
            reg: /^(rtcp-mux)/
        },
        {
            // a=rtcp-rsize
            name: "rtcpRsize",
            reg: /^(rtcp-rsize)/
        },
        {
            // a=sctpmap:5000 webrtc-datachannel 1024
            name: "sctpmap",
            reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
            names: [
                "sctpmapNumber",
                "app",
                "maxMessageSize"
            ],
            format: function(o) {
                return o.maxMessageSize != null ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
            }
        },
        {
            // a=x-google-flag:conference
            name: "xGoogleFlag",
            reg: /^x-google-flag:([^\s]*)/,
            format: "x-google-flag:%s"
        },
        {
            // a=rid:1 send max-width=1280;max-height=720;max-fps=30;depend=0
            push: "rids",
            reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
            names: [
                "id",
                "direction",
                "params"
            ],
            format: function(o) {
                return o.params ? "rid:%s %s %s" : "rid:%s %s";
            }
        },
        {
            // a=imageattr:97 send [x=800,y=640,sar=1.1,q=0.6] [x=480,y=320] recv [x=330,y=250]
            // a=imageattr:* send [x=800,y=640] recv *
            // a=imageattr:100 recv [x=320,y=240]
            push: "imageattrs",
            reg: new RegExp(// a=imageattr:97
            "^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
            names: [
                "pt",
                "dir1",
                "attrs1",
                "dir2",
                "attrs2"
            ],
            format: function(o) {
                return "imageattr:%s %s %s" + (o.dir2 ? " %s %s" : "");
            }
        },
        {
            // a=simulcast:send 1,2,3;~4,~5 recv 6;~7,~8
            // a=simulcast:recv 1;4,5 send 6;7
            name: "simulcast",
            reg: new RegExp(// a=simulcast:
            "^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
            names: [
                "dir1",
                "list1",
                "dir2",
                "list2"
            ],
            format: function(o) {
                return "simulcast:%s %s" + (o.dir2 ? " %s %s" : "");
            }
        },
        {
            // old simulcast draft 03 (implemented by Firefox)
            //   https://tools.ietf.org/html/draft-ietf-mmusic-sdp-simulcast-03
            // a=simulcast: recv pt=97;98 send pt=97
            // a=simulcast: send rid=5;6;7 paused=6,7
            name: "simulcast_03",
            reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
            names: [
                "value"
            ],
            format: "simulcast: %s"
        },
        {
            // a=framerate:25
            // a=framerate:29.97
            name: "framerate",
            reg: /^framerate:(\d+(?:$|\.\d+))/,
            format: "framerate:%s"
        },
        {
            // RFC4570
            // a=source-filter: incl IN IP4 239.5.2.31 10.1.15.5
            name: "sourceFilter",
            reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
            names: [
                "filterMode",
                "netType",
                "addressTypes",
                "destAddress",
                "srcList"
            ],
            format: "source-filter: %s %s %s %s %s"
        },
        {
            // a=bundle-only
            name: "bundleOnly",
            reg: /^(bundle-only)/
        },
        {
            // a=label:1
            name: "label",
            reg: /^label:(.+)/,
            format: "label:%s"
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-5
            name: "sctpPort",
            reg: /^sctp-port:(\d+)$/,
            format: "sctp-port:%s"
        },
        {
            // RFC version 26 for SCTP over DTLS
            // https://tools.ietf.org/html/draft-ietf-mmusic-sctp-sdp-26#section-6
            name: "maxMessageSize",
            reg: /^max-message-size:(\d+)$/,
            format: "max-message-size:%s"
        },
        {
            // RFC7273
            // a=ts-refclk:ptp=IEEE1588-2008:39-A7-94-FF-FE-07-CB-D0:37
            push: "tsRefClocks",
            reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
            names: [
                "clksrc",
                "clksrcExt"
            ],
            format: function(o) {
                return "ts-refclk:%s" + (o.clksrcExt != null ? "=%s" : "");
            }
        },
        {
            // RFC7273
            // a=mediaclk:direct=963214424
            name: "mediaClk",
            reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
            names: [
                "id",
                "mediaClockName",
                "mediaClockValue",
                "rateNumerator",
                "rateDenominator"
            ],
            format: function(o) {
                var str = "mediaclk:";
                str += o.id != null ? "id=%s %s" : "%v%s";
                str += o.mediaClockValue != null ? "=%s" : "";
                str += o.rateNumerator != null ? " rate=%s" : "";
                str += o.rateDenominator != null ? "/%s" : "";
                return str;
            }
        },
        {
            // a=keywds:keywords
            name: "keywords",
            reg: /^keywds:(.+)$/,
            format: "keywds:%s"
        },
        {
            // a=content:main
            name: "content",
            reg: /^content:(.+)/,
            format: "content:%s"
        },
        // BFCP https://tools.ietf.org/html/rfc4583
        {
            // a=floorctrl:c-s
            name: "bfcpFloorCtrl",
            reg: /^floorctrl:(c-only|s-only|c-s)/,
            format: "floorctrl:%s"
        },
        {
            // a=confid:1
            name: "bfcpConfId",
            reg: /^confid:(\d+)/,
            format: "confid:%s"
        },
        {
            // a=userid:1
            name: "bfcpUserId",
            reg: /^userid:(\d+)/,
            format: "userid:%s"
        },
        {
            // a=floorid:1
            name: "bfcpFloorId",
            reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
            names: [
                "id",
                "mStream"
            ],
            format: "floorid:%s mstrm:%s"
        },
        {
            // any a= that we don't understand is kept verbatim on media.invalid
            push: "invalid",
            names: [
                "value"
            ]
        }
    ]
};
// set sensible defaults to avoid polluting the grammar with boring details
Object.keys($c7c913c804974e64$var$grammar).forEach(function(key) {
    var objs = $c7c913c804974e64$var$grammar[key];
    objs.forEach(function(obj) {
        if (!obj.reg) obj.reg = /(.*)/;
        if (!obj.format) obj.format = "%s";
    });
});

});


parcelRegister("6SdWi", function(module, exports) {

var $h9s6v = parcelRequire("h9s6v");
// customized util.format - discards excess arguments and can void middle ones
var $50129943ef123419$var$formatRegExp = /%[sdv%]/g;
var $50129943ef123419$var$format = function(formatStr) {
    var i = 1;
    var args = arguments;
    var len = args.length;
    return formatStr.replace($50129943ef123419$var$formatRegExp, function(x) {
        if (i >= len) return x; // missing argument
        var arg = args[i];
        i += 1;
        switch(x){
            case "%%":
                return "%";
            case "%s":
                return String(arg);
            case "%d":
                return Number(arg);
            case "%v":
                return "";
        }
    });
// NB: we discard excess arguments - they are typically undefined from makeLine
};
var $50129943ef123419$var$makeLine = function(type, obj, location) {
    var str = obj.format instanceof Function ? obj.format(obj.push ? location : location[obj.name]) : obj.format;
    var args = [
        type + "=" + str
    ];
    if (obj.names) for(var i = 0; i < obj.names.length; i += 1){
        var n = obj.names[i];
        if (obj.name) args.push(location[obj.name][n]);
        else args.push(location[obj.names[i]]);
    }
    else args.push(location[obj.name]);
    return $50129943ef123419$var$format.apply(null, args);
};
// RFC specified order
// TODO: extend this with all the rest
var $50129943ef123419$var$defaultOuterOrder = [
    "v",
    "o",
    "s",
    "i",
    "u",
    "e",
    "p",
    "c",
    "b",
    "t",
    "r",
    "z",
    "a"
];
var $50129943ef123419$var$defaultInnerOrder = [
    "i",
    "c",
    "b",
    "a"
];
module.exports = function(session, opts) {
    opts = opts || {};
    // ensure certain properties exist
    if (session.version == null) session.version = 0; // 'v=0' must be there (only defined version atm)
    if (session.name == null) session.name = " "; // 's= ' must be there if no meaningful name set
    session.media.forEach(function(mLine) {
        if (mLine.payloads == null) mLine.payloads = "";
    });
    var outerOrder = opts.outerOrder || $50129943ef123419$var$defaultOuterOrder;
    var innerOrder = opts.innerOrder || $50129943ef123419$var$defaultInnerOrder;
    var sdp = [];
    // loop through outerOrder for matching properties on session
    outerOrder.forEach(function(type) {
        $h9s6v[type].forEach(function(obj) {
            if (obj.name in session && session[obj.name] != null) sdp.push($50129943ef123419$var$makeLine(type, obj, session));
            else if (obj.push in session && session[obj.push] != null) session[obj.push].forEach(function(el) {
                sdp.push($50129943ef123419$var$makeLine(type, obj, el));
            });
        });
    });
    // then for each media line, follow the innerOrder
    session.media.forEach(function(mLine) {
        sdp.push($50129943ef123419$var$makeLine("m", $h9s6v.m[0], mLine));
        innerOrder.forEach(function(type) {
            $h9s6v[type].forEach(function(obj) {
                if (obj.name in mLine && mLine[obj.name] != null) sdp.push($50129943ef123419$var$makeLine(type, obj, mLine));
                else if (obj.push in mLine && mLine[obj.push] != null) mLine[obj.push].forEach(function(el) {
                    sdp.push($50129943ef123419$var$makeLine(type, obj, el));
                });
            });
        });
    });
    return sdp.join("\r\n") + "\r\n";
};

});


parcelRegister("a2dIr", function(module, exports) {
"use strict";
var $74e4baf47efe9a17$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $74e4baf47efe9a17$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $74e4baf47efe9a17$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $74e4baf47efe9a17$var$__createBinding(result, mod, k);
    }
    $74e4baf47efe9a17$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractRtpCapabilities = $74e4baf47efe9a17$var$extractRtpCapabilities;
module.exports.extractDtlsParameters = $74e4baf47efe9a17$var$extractDtlsParameters;
module.exports.getCname = $74e4baf47efe9a17$var$getCname;
module.exports.applyCodecParameters = $74e4baf47efe9a17$var$applyCodecParameters;

const $74e4baf47efe9a17$var$sdpTransform = $74e4baf47efe9a17$var$__importStar((parcelRequire("8j7qr")));
/**
 * This function must be called with an SDP with 1 m=audio and 1 m=video
 * sections.
 */ function $74e4baf47efe9a17$var$extractRtpCapabilities({ sdpObject: sdpObject }) {
    // Map of RtpCodecParameters indexed by payload type.
    const codecsMap = new Map();
    // Array of RtpHeaderExtensions.
    const headerExtensions = [];
    // Whether a m=audio/video section has been already found.
    let gotAudio = false;
    let gotVideo = false;
    for (const m of sdpObject.media){
        const kind = m.type;
        switch(kind){
            case "audio":
                if (gotAudio) continue;
                gotAudio = true;
                break;
            case "video":
                if (gotVideo) continue;
                gotVideo = true;
                break;
            default:
                continue;
        }
        // Get codecs.
        for (const rtp of m.rtp){
            const codec = {
                kind: kind,
                mimeType: `${kind}/${rtp.codec}`,
                preferredPayloadType: rtp.payload,
                clockRate: rtp.rate,
                channels: rtp.encoding,
                parameters: {},
                rtcpFeedback: []
            };
            codecsMap.set(codec.preferredPayloadType, codec);
        }
        // Get codec parameters.
        for (const fmtp of m.fmtp || []){
            const parameters = $74e4baf47efe9a17$var$sdpTransform.parseParams(fmtp.config);
            const codec = codecsMap.get(fmtp.payload);
            if (!codec) continue;
            // Specials case to convert parameter value to string.
            if (parameters && parameters.hasOwnProperty("profile-level-id")) parameters["profile-level-id"] = String(parameters["profile-level-id"]);
            codec.parameters = parameters;
        }
        // Get RTCP feedback for each codec.
        for (const fb of m.rtcpFb || []){
            const feedback = {
                type: fb.type,
                parameter: fb.subtype
            };
            if (!feedback.parameter) delete feedback.parameter;
            // rtcp-fb payload is not '*', so just apply it to its corresponding
            // codec.
            if (fb.payload !== "*") {
                const codec = codecsMap.get(fb.payload);
                if (!codec) continue;
                codec.rtcpFeedback.push(feedback);
            } else {
                for (const codec of codecsMap.values())if (codec.kind === kind && !/.+\/rtx$/i.test(codec.mimeType)) codec.rtcpFeedback.push(feedback);
            }
        }
        // Get RTP header extensions.
        for (const ext of m.ext || []){
            // Ignore encrypted extensions (not yet supported in mediasoup).
            if (ext["encrypt-uri"]) continue;
            const headerExtension = {
                kind: kind,
                uri: ext.uri,
                preferredId: ext.value
            };
            headerExtensions.push(headerExtension);
        }
    }
    const rtpCapabilities = {
        codecs: Array.from(codecsMap.values()),
        headerExtensions: headerExtensions
    };
    return rtpCapabilities;
}
function $74e4baf47efe9a17$var$extractDtlsParameters({ sdpObject: sdpObject }) {
    let setup = sdpObject.setup;
    let fingerprint = sdpObject.fingerprint;
    if (!setup || !fingerprint) {
        const mediaObject = (sdpObject.media || []).find((m)=>m.port !== 0);
        if (mediaObject) {
            setup !== null && setup !== void 0 ? setup : setup = mediaObject.setup;
            fingerprint !== null && fingerprint !== void 0 ? fingerprint : fingerprint = mediaObject.fingerprint;
        }
    }
    if (!setup) throw new Error("no a=setup found at SDP session or media level");
    else if (!fingerprint) throw new Error("no a=fingerprint found at SDP session or media level");
    let role;
    switch(setup){
        case "active":
            role = "client";
            break;
        case "passive":
            role = "server";
            break;
        case "actpass":
            role = "auto";
            break;
    }
    const dtlsParameters = {
        role: role,
        fingerprints: [
            {
                algorithm: fingerprint.type,
                value: fingerprint.hash
            }
        ]
    };
    return dtlsParameters;
}
function $74e4baf47efe9a17$var$getCname({ offerMediaObject: offerMediaObject }) {
    const ssrcCnameLine = (offerMediaObject.ssrcs || []).find((line)=>line.attribute === "cname");
    if (!ssrcCnameLine) return "";
    return ssrcCnameLine.value;
}
/**
 * Apply codec parameters in the given SDP m= section answer based on the
 * given RTP parameters of an offer.
 */ function $74e4baf47efe9a17$var$applyCodecParameters({ offerRtpParameters: offerRtpParameters, answerMediaObject: answerMediaObject }) {
    for (const codec of offerRtpParameters.codecs){
        const mimeType = codec.mimeType.toLowerCase();
        // Avoid parsing codec parameters for unhandled codecs.
        if (mimeType !== "audio/opus") continue;
        const rtp = (answerMediaObject.rtp || []).find((r)=>r.payload === codec.payloadType);
        if (!rtp) continue;
        // Just in case.
        answerMediaObject.fmtp = answerMediaObject.fmtp || [];
        let fmtp = answerMediaObject.fmtp.find((f)=>f.payload === codec.payloadType);
        if (!fmtp) {
            fmtp = {
                payload: codec.payloadType,
                config: ""
            };
            answerMediaObject.fmtp.push(fmtp);
        }
        const parameters = $74e4baf47efe9a17$var$sdpTransform.parseParams(fmtp.config);
        switch(mimeType){
            case "audio/opus":
                {
                    const spropStereo = codec.parameters["sprop-stereo"];
                    if (spropStereo !== undefined) parameters.stereo = spropStereo ? 1 : 0;
                    break;
                }
        }
        // Write the codec fmtp.config back.
        fmtp.config = "";
        for (const key of Object.keys(parameters)){
            if (fmtp.config) fmtp.config += ";";
            fmtp.config += `${key}=${parameters[key]}`;
        }
    }
}

});

parcelRegister("ghGMB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRtpEncodings = $bdaf6ba95b3a5f06$var$getRtpEncodings;
module.exports.addLegacySimulcast = $bdaf6ba95b3a5f06$var$addLegacySimulcast;
function $bdaf6ba95b3a5f06$var$getRtpEncodings({ offerMediaObject: offerMediaObject }) {
    const ssrcs = new Set();
    for (const line of offerMediaObject.ssrcs || []){
        const ssrc = line.id;
        ssrcs.add(ssrc);
    }
    if (ssrcs.size === 0) throw new Error("no a=ssrc lines found");
    const ssrcToRtxSsrc = new Map();
    // First assume RTX is used.
    for (const line of offerMediaObject.ssrcGroups || []){
        if (line.semantics !== "FID") continue;
        let [ssrc, rtxSsrc] = line.ssrcs.split(/\s+/);
        ssrc = Number(ssrc);
        rtxSsrc = Number(rtxSsrc);
        if (ssrcs.has(ssrc)) {
            // Remove both the SSRC and RTX SSRC from the set so later we know
            // that they are already handled.
            ssrcs.delete(ssrc);
            ssrcs.delete(rtxSsrc);
            // Add to the map.
            ssrcToRtxSsrc.set(ssrc, rtxSsrc);
        }
    }
    // If the set of SSRCs is not empty it means that RTX is not being used, so
    // take media SSRCs from there.
    for (const ssrc of ssrcs)// Add to the map.
    ssrcToRtxSsrc.set(ssrc, null);
    const encodings = [];
    for (const [ssrc, rtxSsrc] of ssrcToRtxSsrc){
        const encoding = {
            ssrc: ssrc
        };
        if (rtxSsrc) encoding.rtx = {
            ssrc: rtxSsrc
        };
        encodings.push(encoding);
    }
    return encodings;
}
/**
 * Adds multi-ssrc based simulcast into the given SDP media section offer.
 */ function $bdaf6ba95b3a5f06$var$addLegacySimulcast({ offerMediaObject: offerMediaObject, numStreams: numStreams }) {
    if (numStreams <= 1) throw new TypeError("numStreams must be greater than 1");
    // Get the SSRC.
    const ssrcMsidLine = (offerMediaObject.ssrcs || []).find((line)=>line.attribute === "msid");
    if (!ssrcMsidLine) throw new Error("a=ssrc line with msid information not found");
    const [streamId, trackId] = ssrcMsidLine.value.split(" ");
    const firstSsrc = ssrcMsidLine.id;
    let firstRtxSsrc;
    // Get the SSRC for RTX.
    (offerMediaObject.ssrcGroups || []).some((line)=>{
        if (line.semantics !== "FID") return false;
        const ssrcs = line.ssrcs.split(/\s+/);
        if (Number(ssrcs[0]) === firstSsrc) {
            firstRtxSsrc = Number(ssrcs[1]);
            return true;
        } else return false;
    });
    const ssrcCnameLine = offerMediaObject.ssrcs.find((line)=>line.attribute === "cname");
    if (!ssrcCnameLine) throw new Error("a=ssrc line with cname information not found");
    const cname = ssrcCnameLine.value;
    const ssrcs = [];
    const rtxSsrcs = [];
    for(let i = 0; i < numStreams; ++i){
        ssrcs.push(firstSsrc + i);
        if (firstRtxSsrc) rtxSsrcs.push(firstRtxSsrc + i);
    }
    offerMediaObject.ssrcGroups = [];
    offerMediaObject.ssrcs = [];
    offerMediaObject.ssrcGroups.push({
        semantics: "SIM",
        ssrcs: ssrcs.join(" ")
    });
    for(let i = 0; i < ssrcs.length; ++i){
        const ssrc = ssrcs[i];
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId} ${trackId}`
        });
    }
    for(let i = 0; i < rtxSsrcs.length; ++i){
        const ssrc = ssrcs[i];
        const rtxSsrc = rtxSsrcs[i];
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "msid",
            value: `${streamId} ${trackId}`
        });
        offerMediaObject.ssrcGroups.push({
            semantics: "FID",
            ssrcs: `${ssrc} ${rtxSsrc}`
        });
    }
}

});

parcelRegister("eoJVX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addNackSuppportForOpus = $a7b6f0140d985963$var$addNackSuppportForOpus;
/**
 * This function adds RTCP NACK support for OPUS codec in given capabilities.
 */ function $a7b6f0140d985963$var$addNackSuppportForOpus(rtpCapabilities) {
    var _codec_rtcpFeedback;
    for (const codec of rtpCapabilities.codecs || [])if ((codec.mimeType.toLowerCase() === "audio/opus" || codec.mimeType.toLowerCase() === "audio/multiopus") && !((_codec_rtcpFeedback = codec.rtcpFeedback) === null || _codec_rtcpFeedback === void 0 ? void 0 : _codec_rtcpFeedback.some((fb)=>fb.type === "nack" && !fb.parameter))) {
        if (!codec.rtcpFeedback) codec.rtcpFeedback = [];
        codec.rtcpFeedback.push({
            type: "nack"
        });
    }
}

});

parcelRegister("2ptPl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HandlerInterface = void 0;

var $bwd9s = parcelRequire("bwd9s");
class $1c150d9d3b627d37$var$HandlerInterface extends $bwd9s.EnhancedEventEmitter {
    constructor(){
        super();
    }
}
module.exports.HandlerInterface = $1c150d9d3b627d37$var$HandlerInterface;

});

parcelRegister("bqKhs", function(module, exports) {
"use strict";
var $852605c9611c3c84$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $852605c9611c3c84$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $852605c9611c3c84$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $852605c9611c3c84$var$__createBinding(result, mod, k);
    }
    $852605c9611c3c84$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoteSdp = void 0;

const $852605c9611c3c84$var$sdpTransform = $852605c9611c3c84$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $3sZKt = parcelRequire("3sZKt");
const $852605c9611c3c84$var$logger = new $24uNv.Logger("RemoteSdp");
class $852605c9611c3c84$var$RemoteSdp {
    updateIceParameters(iceParameters) {
        $852605c9611c3c84$var$logger.debug("updateIceParameters() [iceParameters:%o]", iceParameters);
        this._iceParameters = iceParameters;
        this._sdpObject.icelite = iceParameters.iceLite ? "ice-lite" : undefined;
        for (const mediaSection of this._mediaSections)mediaSection.setIceParameters(iceParameters);
    }
    updateDtlsRole(role) {
        $852605c9611c3c84$var$logger.debug("updateDtlsRole() [role:%s]", role);
        this._dtlsParameters.role = role;
        for (const mediaSection of this._mediaSections)mediaSection.setDtlsRole(role);
    }
    getNextMediaSectionIdx() {
        // If a closed media section is found, return its index.
        for(let idx = 0; idx < this._mediaSections.length; ++idx){
            const mediaSection = this._mediaSections[idx];
            if (mediaSection.closed) return {
                idx: idx,
                reuseMid: mediaSection.mid
            };
        }
        // If no closed media section is found, return next one.
        return {
            idx: this._mediaSections.length
        };
    }
    send({ offerMediaObject: offerMediaObject, reuseMid: reuseMid, offerRtpParameters: offerRtpParameters, answerRtpParameters: answerRtpParameters, codecOptions: codecOptions, extmapAllowMixed: extmapAllowMixed = false }) {
        const mediaSection = new $3sZKt.AnswerMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            plainRtpParameters: this._plainRtpParameters,
            planB: this._planB,
            offerMediaObject: offerMediaObject,
            offerRtpParameters: offerRtpParameters,
            answerRtpParameters: answerRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: extmapAllowMixed
        });
        // Unified-Plan with closed media section replacement.
        if (reuseMid) this._replaceMediaSection(mediaSection, reuseMid);
        else if (!this._midToIndex.has(mediaSection.mid)) this._addMediaSection(mediaSection);
        else this._replaceMediaSection(mediaSection);
    }
    receive({ mid: mid, kind: kind, offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId }) {
        const idx = this._midToIndex.get(mid);
        let mediaSection;
        if (idx !== undefined) mediaSection = this._mediaSections[idx];
        // Unified-Plan or different media kind.
        if (!mediaSection) {
            mediaSection = new $3sZKt.OfferMediaSection({
                iceParameters: this._iceParameters,
                iceCandidates: this._iceCandidates,
                dtlsParameters: this._dtlsParameters,
                plainRtpParameters: this._plainRtpParameters,
                planB: this._planB,
                mid: mid,
                kind: kind,
                offerRtpParameters: offerRtpParameters,
                streamId: streamId,
                trackId: trackId
            });
            // Let's try to recycle a closed media section (if any).
            // NOTE: Yes, we can recycle a closed m=audio section with a new m=video.
            const oldMediaSection = this._mediaSections.find((m)=>m.closed);
            if (oldMediaSection) this._replaceMediaSection(mediaSection, oldMediaSection.mid);
            else this._addMediaSection(mediaSection);
        } else {
            mediaSection.planBReceive({
                offerRtpParameters: offerRtpParameters,
                streamId: streamId,
                trackId: trackId
            });
            this._replaceMediaSection(mediaSection);
        }
    }
    pauseMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.pause();
    }
    resumeSendingMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.resume();
    }
    resumeReceivingMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.resume();
    }
    disableMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.disable();
    }
    /**
     * Closes media section. Returns true if the given MID corresponds to a m
     * section that has been indeed closed. False otherwise.
     *
     * NOTE: Closing the first m section is a pain since it invalidates the bundled
     * transport, so instead closing it we just disable it.
     */ closeMediaSection(mid) {
        const mediaSection = this._findMediaSection(mid);
        // NOTE: Closing the first m section is a pain since it invalidates the
        // bundled transport, so let's avoid it.
        if (mid === this._firstMid) {
            $852605c9611c3c84$var$logger.debug("closeMediaSection() | cannot close first media section, disabling it instead [mid:%s]", mid);
            this.disableMediaSection(mid);
            return false;
        }
        mediaSection.close();
        // Regenerate BUNDLE mids.
        this._regenerateBundleMids();
        return true;
    }
    muxMediaSectionSimulcast(mid, encodings) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.muxSimulcastStreams(encodings);
        this._replaceMediaSection(mediaSection);
    }
    planBStopReceiving({ mid: mid, offerRtpParameters: offerRtpParameters }) {
        const mediaSection = this._findMediaSection(mid);
        mediaSection.planBStopReceiving({
            offerRtpParameters: offerRtpParameters
        });
        this._replaceMediaSection(mediaSection);
    }
    sendSctpAssociation({ offerMediaObject: offerMediaObject }) {
        const mediaSection = new $3sZKt.AnswerMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            sctpParameters: this._sctpParameters,
            plainRtpParameters: this._plainRtpParameters,
            offerMediaObject: offerMediaObject
        });
        this._addMediaSection(mediaSection);
    }
    receiveSctpAssociation({ oldDataChannelSpec: oldDataChannelSpec = false } = {}) {
        const mediaSection = new $3sZKt.OfferMediaSection({
            iceParameters: this._iceParameters,
            iceCandidates: this._iceCandidates,
            dtlsParameters: this._dtlsParameters,
            sctpParameters: this._sctpParameters,
            plainRtpParameters: this._plainRtpParameters,
            mid: "datachannel",
            kind: "application",
            oldDataChannelSpec: oldDataChannelSpec
        });
        this._addMediaSection(mediaSection);
    }
    getSdp() {
        // Increase SDP version.
        this._sdpObject.origin.sessionVersion++;
        return $852605c9611c3c84$var$sdpTransform.write(this._sdpObject);
    }
    _addMediaSection(newMediaSection) {
        if (!this._firstMid) this._firstMid = newMediaSection.mid;
        // Add to the vector.
        this._mediaSections.push(newMediaSection);
        // Add to the map.
        this._midToIndex.set(newMediaSection.mid, this._mediaSections.length - 1);
        // Add to the SDP object.
        this._sdpObject.media.push(newMediaSection.getObject());
        // Regenerate BUNDLE mids.
        this._regenerateBundleMids();
    }
    _replaceMediaSection(newMediaSection, reuseMid) {
        // Store it in the map.
        if (typeof reuseMid === "string") {
            const idx = this._midToIndex.get(reuseMid);
            if (idx === undefined) throw new Error(`no media section found for reuseMid '${reuseMid}'`);
            const oldMediaSection = this._mediaSections[idx];
            // Replace the index in the vector with the new media section.
            this._mediaSections[idx] = newMediaSection;
            // Update the map.
            this._midToIndex.delete(oldMediaSection.mid);
            this._midToIndex.set(newMediaSection.mid, idx);
            // Update the SDP object.
            this._sdpObject.media[idx] = newMediaSection.getObject();
            // Regenerate BUNDLE mids.
            this._regenerateBundleMids();
        } else {
            const idx = this._midToIndex.get(newMediaSection.mid);
            if (idx === undefined) throw new Error(`no media section found with mid '${newMediaSection.mid}'`);
            // Replace the index in the vector with the new media section.
            this._mediaSections[idx] = newMediaSection;
            // Update the SDP object.
            this._sdpObject.media[idx] = newMediaSection.getObject();
        }
    }
    _findMediaSection(mid) {
        const idx = this._midToIndex.get(mid);
        if (idx === undefined) throw new Error(`no media section found with mid '${mid}'`);
        return this._mediaSections[idx];
    }
    _regenerateBundleMids() {
        if (!this._dtlsParameters) return;
        this._sdpObject.groups[0].mids = this._mediaSections.filter((mediaSection)=>!mediaSection.closed).map((mediaSection)=>mediaSection.mid).join(" ");
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false }){
        // MediaSection instances with same order as in the SDP.
        this._mediaSections = [];
        // MediaSection indices indexed by MID.
        this._midToIndex = new Map();
        this._iceParameters = iceParameters;
        this._iceCandidates = iceCandidates;
        this._dtlsParameters = dtlsParameters;
        this._sctpParameters = sctpParameters;
        this._plainRtpParameters = plainRtpParameters;
        this._planB = planB;
        this._sdpObject = {
            version: 0,
            origin: {
                address: "0.0.0.0",
                ipVer: 4,
                netType: "IN",
                sessionId: 10000,
                sessionVersion: 0,
                username: "mediasoup-client"
            },
            name: "-",
            timing: {
                start: 0,
                stop: 0
            },
            media: []
        };
        // If ICE parameters are given, add ICE-Lite indicator.
        if (iceParameters && iceParameters.iceLite) this._sdpObject.icelite = "ice-lite";
        // If DTLS parameters are given, assume WebRTC and BUNDLE.
        if (dtlsParameters) {
            this._sdpObject.msidSemantic = {
                semantic: "WMS",
                token: "*"
            };
            // NOTE: We take the latest fingerprint.
            const numFingerprints = this._dtlsParameters.fingerprints.length;
            this._sdpObject.fingerprint = {
                type: dtlsParameters.fingerprints[numFingerprints - 1].algorithm,
                hash: dtlsParameters.fingerprints[numFingerprints - 1].value
            };
            this._sdpObject.groups = [
                {
                    type: "BUNDLE",
                    mids: ""
                }
            ];
        }
        // If there are plain RPT parameters, override SDP origin.
        if (plainRtpParameters) {
            this._sdpObject.origin.address = plainRtpParameters.ip;
            this._sdpObject.origin.ipVer = plainRtpParameters.ipVersion;
        }
    }
}
module.exports.RemoteSdp = $852605c9611c3c84$var$RemoteSdp;

});
parcelRegister("3sZKt", function(module, exports) {
"use strict";
var $2863e29a87d8438f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2863e29a87d8438f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2863e29a87d8438f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2863e29a87d8438f$var$__createBinding(result, mod, k);
    }
    $2863e29a87d8438f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OfferMediaSection = module.exports.AnswerMediaSection = module.exports.MediaSection = void 0;

const $2863e29a87d8438f$var$sdpTransform = $2863e29a87d8438f$var$__importStar((parcelRequire("8j7qr")));

const $2863e29a87d8438f$var$utils = $2863e29a87d8438f$var$__importStar((parcelRequire("lghrF")));
class $2863e29a87d8438f$var$MediaSection {
    get mid() {
        return String(this._mediaObject.mid);
    }
    get closed() {
        return this._mediaObject.port === 0;
    }
    getObject() {
        return this._mediaObject;
    }
    setIceParameters(iceParameters) {
        this._mediaObject.iceUfrag = iceParameters.usernameFragment;
        this._mediaObject.icePwd = iceParameters.password;
    }
    pause() {
        this._mediaObject.direction = "inactive";
    }
    disable() {
        this.pause();
        delete this._mediaObject.ext;
        delete this._mediaObject.ssrcs;
        delete this._mediaObject.ssrcGroups;
        delete this._mediaObject.simulcast;
        delete this._mediaObject.simulcast_03;
        delete this._mediaObject.rids;
        delete this._mediaObject.extmapAllowMixed;
    }
    close() {
        this.disable();
        this._mediaObject.port = 0;
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, planB: planB = false }){
        this._mediaObject = {};
        this._planB = planB;
        if (iceParameters) this.setIceParameters(iceParameters);
        if (iceCandidates) {
            this._mediaObject.candidates = [];
            for (const candidate of iceCandidates){
                const candidateObject = {};
                // mediasoup does mandates rtcp-mux so candidates component is always
                // RTP (1).
                candidateObject.component = 1;
                candidateObject.foundation = candidate.foundation;
                var _candidate_address;
                // Be ready for new candidate.address field in mediasoup server side
                // field and keep backward compatibility with deprecated candidate.ip.
                candidateObject.ip = (_candidate_address = candidate.address) !== null && _candidate_address !== void 0 ? _candidate_address : candidate.ip;
                candidateObject.port = candidate.port;
                candidateObject.priority = candidate.priority;
                candidateObject.transport = candidate.protocol;
                candidateObject.type = candidate.type;
                if (candidate.tcpType) candidateObject.tcptype = candidate.tcpType;
                this._mediaObject.candidates.push(candidateObject);
            }
            this._mediaObject.endOfCandidates = "end-of-candidates";
            this._mediaObject.iceOptions = "renomination";
        }
        if (dtlsParameters) this.setDtlsRole(dtlsParameters.role);
    }
}
module.exports.MediaSection = $2863e29a87d8438f$var$MediaSection;
class $2863e29a87d8438f$var$AnswerMediaSection extends $2863e29a87d8438f$var$MediaSection {
    setDtlsRole(role) {
        switch(role){
            case "client":
                this._mediaObject.setup = "active";
                break;
            case "server":
                this._mediaObject.setup = "passive";
                break;
            case "auto":
                this._mediaObject.setup = "actpass";
                break;
        }
    }
    resume() {
        this._mediaObject.direction = "recvonly";
    }
    muxSimulcastStreams(encodings) {
        var _layers_simulcastFormat_scid;
        if (!this._mediaObject.simulcast || !this._mediaObject.simulcast.list1) return;
        const layers = {};
        for (const encoding of encodings)if (encoding.rid) layers[encoding.rid] = encoding;
        const raw = this._mediaObject.simulcast.list1;
        const simulcastStreams = $2863e29a87d8438f$var$sdpTransform.parseSimulcastStreamList(raw);
        for (const simulcastStream of simulcastStreams)for (const simulcastFormat of simulcastStream)simulcastFormat.paused = !((_layers_simulcastFormat_scid = layers[simulcastFormat.scid]) === null || _layers_simulcastFormat_scid === void 0 ? void 0 : _layers_simulcastFormat_scid.active);
        this._mediaObject.simulcast.list1 = simulcastStreams.map((simulcastFormats)=>simulcastFormats.map((f)=>`${f.paused ? "~" : ""}${f.scid}`).join(",")).join(";");
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false, offerMediaObject: offerMediaObject, offerRtpParameters: offerRtpParameters, answerRtpParameters: answerRtpParameters, codecOptions: codecOptions, extmapAllowMixed: extmapAllowMixed = false }){
        super({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            planB: planB
        });
        this._mediaObject.mid = String(offerMediaObject.mid);
        this._mediaObject.type = offerMediaObject.type;
        this._mediaObject.protocol = offerMediaObject.protocol;
        if (!plainRtpParameters) {
            this._mediaObject.connection = {
                ip: "127.0.0.1",
                version: 4
            };
            this._mediaObject.port = 7;
        } else {
            this._mediaObject.connection = {
                ip: plainRtpParameters.ip,
                version: plainRtpParameters.ipVersion
            };
            this._mediaObject.port = plainRtpParameters.port;
        }
        switch(offerMediaObject.type){
            case "audio":
            case "video":
                this._mediaObject.direction = "recvonly";
                this._mediaObject.rtp = [];
                this._mediaObject.rtcpFb = [];
                this._mediaObject.fmtp = [];
                for (const codec of answerRtpParameters.codecs){
                    const rtp = {
                        payload: codec.payloadType,
                        codec: $2863e29a87d8438f$var$getCodecName(codec),
                        rate: codec.clockRate
                    };
                    if (codec.channels > 1) rtp.encoding = codec.channels;
                    this._mediaObject.rtp.push(rtp);
                    var _utils_clone;
                    const codecParameters = (_utils_clone = $2863e29a87d8438f$var$utils.clone(codec.parameters)) !== null && _utils_clone !== void 0 ? _utils_clone : {};
                    var _utils_clone1;
                    let codecRtcpFeedback = (_utils_clone1 = $2863e29a87d8438f$var$utils.clone(codec.rtcpFeedback)) !== null && _utils_clone1 !== void 0 ? _utils_clone1 : [];
                    if (codecOptions) {
                        const { opusStereo: opusStereo, opusFec: opusFec, opusDtx: opusDtx, opusMaxPlaybackRate: opusMaxPlaybackRate, opusMaxAverageBitrate: opusMaxAverageBitrate, opusPtime: opusPtime, opusNack: opusNack, videoGoogleStartBitrate: videoGoogleStartBitrate, videoGoogleMaxBitrate: videoGoogleMaxBitrate, videoGoogleMinBitrate: videoGoogleMinBitrate } = codecOptions;
                        const offerCodec = offerRtpParameters.codecs.find((c)=>c.payloadType === codec.payloadType);
                        switch(codec.mimeType.toLowerCase()){
                            case "audio/opus":
                            case "audio/multiopus":
                                if (opusStereo !== undefined) {
                                    offerCodec.parameters["sprop-stereo"] = opusStereo ? 1 : 0;
                                    codecParameters.stereo = opusStereo ? 1 : 0;
                                }
                                if (opusFec !== undefined) {
                                    offerCodec.parameters.useinbandfec = opusFec ? 1 : 0;
                                    codecParameters.useinbandfec = opusFec ? 1 : 0;
                                }
                                if (opusDtx !== undefined) {
                                    offerCodec.parameters.usedtx = opusDtx ? 1 : 0;
                                    codecParameters.usedtx = opusDtx ? 1 : 0;
                                }
                                if (opusMaxPlaybackRate !== undefined) codecParameters.maxplaybackrate = opusMaxPlaybackRate;
                                if (opusMaxAverageBitrate !== undefined) codecParameters.maxaveragebitrate = opusMaxAverageBitrate;
                                if (opusPtime !== undefined) {
                                    offerCodec.parameters.ptime = opusPtime;
                                    codecParameters.ptime = opusPtime;
                                }
                                // If opusNack is not set, we must remove NACK support for OPUS.
                                // Otherwise it would be enabled for those handlers that artificially
                                // announce it in their RTP capabilities.
                                if (!opusNack) {
                                    offerCodec.rtcpFeedback = offerCodec.rtcpFeedback.filter((fb)=>fb.type !== "nack" || fb.parameter);
                                    codecRtcpFeedback = codecRtcpFeedback.filter((fb)=>fb.type !== "nack" || fb.parameter);
                                }
                                break;
                            case "video/vp8":
                            case "video/vp9":
                            case "video/h264":
                            case "video/h265":
                                if (videoGoogleStartBitrate !== undefined) codecParameters["x-google-start-bitrate"] = videoGoogleStartBitrate;
                                if (videoGoogleMaxBitrate !== undefined) codecParameters["x-google-max-bitrate"] = videoGoogleMaxBitrate;
                                if (videoGoogleMinBitrate !== undefined) codecParameters["x-google-min-bitrate"] = videoGoogleMinBitrate;
                                break;
                        }
                    }
                    const fmtp = {
                        payload: codec.payloadType,
                        config: ""
                    };
                    for (const key of Object.keys(codecParameters)){
                        if (fmtp.config) fmtp.config += ";";
                        fmtp.config += `${key}=${codecParameters[key]}`;
                    }
                    if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
                    for (const fb of codecRtcpFeedback)this._mediaObject.rtcpFb.push({
                        payload: codec.payloadType,
                        type: fb.type,
                        subtype: fb.parameter
                    });
                }
                this._mediaObject.payloads = answerRtpParameters.codecs.map((codec)=>codec.payloadType).join(" ");
                this._mediaObject.ext = [];
                for (const ext of answerRtpParameters.headerExtensions){
                    // Don't add a header extension if not present in the offer.
                    const found = (offerMediaObject.ext || []).some((localExt)=>localExt.uri === ext.uri);
                    if (!found) continue;
                    this._mediaObject.ext.push({
                        uri: ext.uri,
                        value: ext.id
                    });
                }
                // Allow both 1 byte and 2 bytes length header extensions.
                if (extmapAllowMixed && offerMediaObject.extmapAllowMixed === "extmap-allow-mixed") this._mediaObject.extmapAllowMixed = "extmap-allow-mixed";
                // Simulcast.
                if (offerMediaObject.simulcast) {
                    this._mediaObject.simulcast = {
                        dir1: "recv",
                        list1: offerMediaObject.simulcast.list1
                    };
                    this._mediaObject.rids = [];
                    for (const rid of offerMediaObject.rids || []){
                        if (rid.direction !== "send") continue;
                        this._mediaObject.rids.push({
                            id: rid.id,
                            direction: "recv"
                        });
                    }
                } else if (offerMediaObject.simulcast_03) {
                    // eslint-disable-next-line camelcase
                    this._mediaObject.simulcast_03 = {
                        value: offerMediaObject.simulcast_03.value.replace(/send/g, "recv")
                    };
                    this._mediaObject.rids = [];
                    for (const rid of offerMediaObject.rids || []){
                        if (rid.direction !== "send") continue;
                        this._mediaObject.rids.push({
                            id: rid.id,
                            direction: "recv"
                        });
                    }
                }
                this._mediaObject.rtcpMux = "rtcp-mux";
                this._mediaObject.rtcpRsize = "rtcp-rsize";
                if (this._planB && this._mediaObject.type === "video") this._mediaObject.xGoogleFlag = "conference";
                break;
            case "application":
                // New spec.
                if (typeof offerMediaObject.sctpPort === "number") {
                    this._mediaObject.payloads = "webrtc-datachannel";
                    this._mediaObject.sctpPort = sctpParameters.port;
                    this._mediaObject.maxMessageSize = sctpParameters.maxMessageSize;
                } else if (offerMediaObject.sctpmap) {
                    this._mediaObject.payloads = sctpParameters.port;
                    this._mediaObject.sctpmap = {
                        app: "webrtc-datachannel",
                        sctpmapNumber: sctpParameters.port,
                        maxMessageSize: sctpParameters.maxMessageSize
                    };
                }
                break;
        }
    }
}
module.exports.AnswerMediaSection = $2863e29a87d8438f$var$AnswerMediaSection;
class $2863e29a87d8438f$var$OfferMediaSection extends $2863e29a87d8438f$var$MediaSection {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setDtlsRole(role) {
        // Always 'actpass'.
        this._mediaObject.setup = "actpass";
    }
    resume() {
        this._mediaObject.direction = "sendonly";
    }
    planBReceive({ offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId }) {
        const encoding = offerRtpParameters.encodings[0];
        const ssrc = encoding.ssrc;
        const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
        const payloads = this._mediaObject.payloads.split(" ");
        for (const codec of offerRtpParameters.codecs){
            if (payloads.includes(String(codec.payloadType))) continue;
            const rtp = {
                payload: codec.payloadType,
                codec: $2863e29a87d8438f$var$getCodecName(codec),
                rate: codec.clockRate
            };
            if (codec.channels > 1) rtp.encoding = codec.channels;
            this._mediaObject.rtp.push(rtp);
            const fmtp = {
                payload: codec.payloadType,
                config: ""
            };
            for (const key of Object.keys(codec.parameters)){
                if (fmtp.config) fmtp.config += ";";
                fmtp.config += `${key}=${codec.parameters[key]}`;
            }
            if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
            for (const fb of codec.rtcpFeedback)this._mediaObject.rtcpFb.push({
                payload: codec.payloadType,
                type: fb.type,
                subtype: fb.parameter
            });
        }
        this._mediaObject.payloads += ` ${offerRtpParameters.codecs.filter((codec)=>!this._mediaObject.payloads.includes(codec.payloadType)).map((codec)=>codec.payloadType).join(" ")}`;
        this._mediaObject.payloads = this._mediaObject.payloads.trim();
        if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: offerRtpParameters.rtcp.cname
        });
        this._mediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId || "-"} ${trackId}`
        });
        if (rtxSsrc) {
            if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                id: rtxSsrc,
                attribute: "cname",
                value: offerRtpParameters.rtcp.cname
            });
            this._mediaObject.ssrcs.push({
                id: rtxSsrc,
                attribute: "msid",
                value: `${streamId || "-"} ${trackId}`
            });
            // Associate original and retransmission SSRCs.
            this._mediaObject.ssrcGroups.push({
                semantics: "FID",
                ssrcs: `${ssrc} ${rtxSsrc}`
            });
        }
    }
    planBStopReceiving({ offerRtpParameters: offerRtpParameters }) {
        const encoding = offerRtpParameters.encodings[0];
        const ssrc = encoding.ssrc;
        const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
        this._mediaObject.ssrcs = this._mediaObject.ssrcs.filter((s)=>s.id !== ssrc && s.id !== rtxSsrc);
        if (rtxSsrc) this._mediaObject.ssrcGroups = this._mediaObject.ssrcGroups.filter((group)=>group.ssrcs !== `${ssrc} ${rtxSsrc}`);
    }
    constructor({ iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, plainRtpParameters: plainRtpParameters, planB: planB = false, mid: mid, kind: kind, offerRtpParameters: offerRtpParameters, streamId: streamId, trackId: trackId, oldDataChannelSpec: oldDataChannelSpec = false }){
        super({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            planB: planB
        });
        this._mediaObject.mid = String(mid);
        this._mediaObject.type = kind;
        if (!plainRtpParameters) {
            this._mediaObject.connection = {
                ip: "127.0.0.1",
                version: 4
            };
            if (!sctpParameters) this._mediaObject.protocol = "UDP/TLS/RTP/SAVPF";
            else this._mediaObject.protocol = "UDP/DTLS/SCTP";
            this._mediaObject.port = 7;
        } else {
            this._mediaObject.connection = {
                ip: plainRtpParameters.ip,
                version: plainRtpParameters.ipVersion
            };
            this._mediaObject.protocol = "RTP/AVP";
            this._mediaObject.port = plainRtpParameters.port;
        }
        switch(kind){
            case "audio":
            case "video":
                {
                    this._mediaObject.direction = "sendonly";
                    this._mediaObject.rtp = [];
                    this._mediaObject.rtcpFb = [];
                    this._mediaObject.fmtp = [];
                    if (!this._planB) this._mediaObject.msid = `${streamId || "-"} ${trackId}`;
                    for (const codec of offerRtpParameters.codecs){
                        const rtp = {
                            payload: codec.payloadType,
                            codec: $2863e29a87d8438f$var$getCodecName(codec),
                            rate: codec.clockRate
                        };
                        if (codec.channels > 1) rtp.encoding = codec.channels;
                        this._mediaObject.rtp.push(rtp);
                        const fmtp = {
                            payload: codec.payloadType,
                            config: ""
                        };
                        for (const key of Object.keys(codec.parameters)){
                            if (fmtp.config) fmtp.config += ";";
                            fmtp.config += `${key}=${codec.parameters[key]}`;
                        }
                        if (fmtp.config) this._mediaObject.fmtp.push(fmtp);
                        for (const fb of codec.rtcpFeedback)this._mediaObject.rtcpFb.push({
                            payload: codec.payloadType,
                            type: fb.type,
                            subtype: fb.parameter
                        });
                    }
                    this._mediaObject.payloads = offerRtpParameters.codecs.map((codec)=>codec.payloadType).join(" ");
                    this._mediaObject.ext = [];
                    for (const ext of offerRtpParameters.headerExtensions)this._mediaObject.ext.push({
                        uri: ext.uri,
                        value: ext.id
                    });
                    this._mediaObject.rtcpMux = "rtcp-mux";
                    this._mediaObject.rtcpRsize = "rtcp-rsize";
                    const encoding = offerRtpParameters.encodings[0];
                    const ssrc = encoding.ssrc;
                    const rtxSsrc = encoding.rtx && encoding.rtx.ssrc ? encoding.rtx.ssrc : undefined;
                    this._mediaObject.ssrcs = [];
                    this._mediaObject.ssrcGroups = [];
                    if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                        id: ssrc,
                        attribute: "cname",
                        value: offerRtpParameters.rtcp.cname
                    });
                    if (this._planB) this._mediaObject.ssrcs.push({
                        id: ssrc,
                        attribute: "msid",
                        value: `${streamId || "-"} ${trackId}`
                    });
                    if (rtxSsrc) {
                        if (offerRtpParameters.rtcp.cname) this._mediaObject.ssrcs.push({
                            id: rtxSsrc,
                            attribute: "cname",
                            value: offerRtpParameters.rtcp.cname
                        });
                        if (this._planB) this._mediaObject.ssrcs.push({
                            id: rtxSsrc,
                            attribute: "msid",
                            value: `${streamId || "-"} ${trackId}`
                        });
                        // Associate original and retransmission SSRCs.
                        this._mediaObject.ssrcGroups.push({
                            semantics: "FID",
                            ssrcs: `${ssrc} ${rtxSsrc}`
                        });
                    }
                    break;
                }
            case "application":
                // New spec.
                if (!oldDataChannelSpec) {
                    this._mediaObject.payloads = "webrtc-datachannel";
                    this._mediaObject.sctpPort = sctpParameters.port;
                    this._mediaObject.maxMessageSize = sctpParameters.maxMessageSize;
                } else {
                    this._mediaObject.payloads = sctpParameters.port;
                    this._mediaObject.sctpmap = {
                        app: "webrtc-datachannel",
                        sctpmapNumber: sctpParameters.port,
                        maxMessageSize: sctpParameters.maxMessageSize
                    };
                }
                break;
        }
    }
}
module.exports.OfferMediaSection = $2863e29a87d8438f$var$OfferMediaSection;
function $2863e29a87d8438f$var$getCodecName(codec) {
    const MimeTypeRegex = new RegExp("^(audio|video)/(.+)", "i");
    const mimeTypeMatch = MimeTypeRegex.exec(codec.mimeType);
    if (!mimeTypeMatch) throw new TypeError("invalid codec.mimeType");
    return mimeTypeMatch[2];
}

});


parcelRegister("2VyLC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parse = $221bdfa450ca37de$var$parse;
const $221bdfa450ca37de$var$ScalabilityModeRegex = new RegExp("^[LS]([1-9]\\d{0,1})T([1-9]\\d{0,1})");
function $221bdfa450ca37de$var$parse(scalabilityMode) {
    const match = $221bdfa450ca37de$var$ScalabilityModeRegex.exec(scalabilityMode || "");
    if (match) return {
        spatialLayers: Number(match[1]),
        temporalLayers: Number(match[2])
    };
    else return {
        spatialLayers: 1,
        temporalLayers: 1
    };
}

});


parcelRegister("3TLmn", function(module, exports) {
"use strict";
var $2d6b3edc827220e6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2d6b3edc827220e6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2d6b3edc827220e6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2d6b3edc827220e6$var$__createBinding(result, mod, k);
    }
    $2d6b3edc827220e6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome74 = void 0;

const $2d6b3edc827220e6$var$sdpTransform = $2d6b3edc827220e6$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $2d6b3edc827220e6$var$utils = $2d6b3edc827220e6$var$__importStar((parcelRequire("lghrF")));

const $2d6b3edc827220e6$var$ortc = $2d6b3edc827220e6$var$__importStar((parcelRequire("5Mq2W")));

const $2d6b3edc827220e6$var$sdpCommonUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("a2dIr")));

const $2d6b3edc827220e6$var$sdpUnifiedPlanUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("ghGMB")));

const $2d6b3edc827220e6$var$ortcUtils = $2d6b3edc827220e6$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $2d6b3edc827220e6$var$logger = new $24uNv.Logger("Chrome74");
const $2d6b3edc827220e6$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $2d6b3edc827220e6$var$Chrome74 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $2d6b3edc827220e6$var$Chrome74();
    }
    get name() {
        return "Chrome74";
    }
    close() {
        $2d6b3edc827220e6$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $2d6b3edc827220e6$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $2d6b3edc827220e6$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $2d6b3edc827220e6$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $2d6b3edc827220e6$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $2d6b3edc827220e6$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $2d6b3edc827220e6$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $2d6b3edc827220e6$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $2d6b3edc827220e6$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $2d6b3edc827220e6$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $2d6b3edc827220e6$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else {
            $2d6b3edc827220e6$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            this._pc.addEventListener("iceconnectionstatechange", ()=>{
                switch(this._pc.iceConnectionState){
                    case "checking":
                        this.emit("@connectionstatechange", "connecting");
                        break;
                    case "connected":
                    case "completed":
                        this.emit("@connectionstatechange", "connected");
                        break;
                    case "failed":
                        this.emit("@connectionstatechange", "failed");
                        break;
                    case "disconnected":
                        this.emit("@connectionstatechange", "disconnected");
                        break;
                    case "closed":
                        this.emit("@connectionstatechange", "closed");
                        break;
                }
            });
        }
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $2d6b3edc827220e6$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $2d6b3edc827220e6$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $2d6b3edc827220e6$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $2d6b3edc827220e6$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $2d6b3edc827220e6$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $2d6b3edc827220e6$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $2d6b3edc827220e6$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        let offer = await this._pc.createOffer();
        let localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $2d6b3edc827220e6$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $2d6b3edc827220e6$var$sdpTransform.write(localSdpObject)
            };
        }
        $2d6b3edc827220e6$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $2d6b3edc827220e6$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            let newEncodings = $2d6b3edc827220e6$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            // Hack for VP9 SVC.
            if (hackVp9Svc) newEncodings = [
                newEncodings[0]
            ];
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $2d6b3edc827220e6$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $2d6b3edc827220e6$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $2d6b3edc827220e6$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $2d6b3edc827220e6$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $2d6b3edc827220e6$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $2d6b3edc827220e6$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $2d6b3edc827220e6$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $2d6b3edc827220e6$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $2d6b3edc827220e6$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $2d6b3edc827220e6$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $2d6b3edc827220e6$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $2d6b3edc827220e6$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $2d6b3edc827220e6$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $2d6b3edc827220e6$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $2d6b3edc827220e6$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome74 = $2d6b3edc827220e6$var$Chrome74;

});

parcelRegister("8vSu0", function(module, exports) {
"use strict";
var $632b7b2896c8ff16$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $632b7b2896c8ff16$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $632b7b2896c8ff16$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $632b7b2896c8ff16$var$__createBinding(result, mod, k);
    }
    $632b7b2896c8ff16$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome70 = void 0;

const $632b7b2896c8ff16$var$sdpTransform = $632b7b2896c8ff16$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $632b7b2896c8ff16$var$utils = $632b7b2896c8ff16$var$__importStar((parcelRequire("lghrF")));

const $632b7b2896c8ff16$var$ortc = $632b7b2896c8ff16$var$__importStar((parcelRequire("5Mq2W")));

const $632b7b2896c8ff16$var$sdpCommonUtils = $632b7b2896c8ff16$var$__importStar((parcelRequire("a2dIr")));

const $632b7b2896c8ff16$var$sdpUnifiedPlanUtils = $632b7b2896c8ff16$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $632b7b2896c8ff16$var$logger = new $24uNv.Logger("Chrome70");
const $632b7b2896c8ff16$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $632b7b2896c8ff16$var$Chrome70 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $632b7b2896c8ff16$var$Chrome70();
    }
    get name() {
        return "Chrome70";
    }
    close() {
        $632b7b2896c8ff16$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $632b7b2896c8ff16$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $632b7b2896c8ff16$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $632b7b2896c8ff16$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $632b7b2896c8ff16$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $632b7b2896c8ff16$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $632b7b2896c8ff16$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $632b7b2896c8ff16$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $632b7b2896c8ff16$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $632b7b2896c8ff16$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $632b7b2896c8ff16$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $632b7b2896c8ff16$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $632b7b2896c8ff16$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $632b7b2896c8ff16$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        const sendingRtpParameters = $632b7b2896c8ff16$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $632b7b2896c8ff16$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $632b7b2896c8ff16$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $632b7b2896c8ff16$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        let offer = await this._pc.createOffer();
        let localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (encodings && encodings.length > 1) {
            $632b7b2896c8ff16$var$logger.debug("send() | enabling legacy simulcast");
            localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
            };
        }
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $632b7b2896c8ff16$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
            };
        }
        $632b7b2896c8ff16$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // If encodings are given, apply them now.
        if (encodings) {
            $632b7b2896c8ff16$var$logger.debug("send() | applying given encodings");
            const parameters = transceiver.sender.getParameters();
            for(let idx = 0; idx < (parameters.encodings || []).length; ++idx){
                const encoding = parameters.encodings[idx];
                const desiredEncoding = encodings[idx];
                // Should not happen but just in case.
                if (!desiredEncoding) break;
                parameters.encodings[idx] = Object.assign(encoding, desiredEncoding);
            }
            await transceiver.sender.setParameters(parameters);
        }
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $632b7b2896c8ff16$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $632b7b2896c8ff16$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // Hack for VP9 SVC.
        if (hackVp9Svc) sendingRtpParameters.encodings = [
            sendingRtpParameters.encodings[0]
        ];
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $632b7b2896c8ff16$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $632b7b2896c8ff16$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $632b7b2896c8ff16$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $632b7b2896c8ff16$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $632b7b2896c8ff16$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $632b7b2896c8ff16$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $632b7b2896c8ff16$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $632b7b2896c8ff16$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $632b7b2896c8ff16$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $632b7b2896c8ff16$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $632b7b2896c8ff16$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $632b7b2896c8ff16$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $632b7b2896c8ff16$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $632b7b2896c8ff16$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $632b7b2896c8ff16$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome70 = $632b7b2896c8ff16$var$Chrome70;

});

parcelRegister("jTGls", function(module, exports) {
"use strict";
var $e7c40033e829def9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7c40033e829def9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7c40033e829def9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7c40033e829def9$var$__createBinding(result, mod, k);
    }
    $e7c40033e829def9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome67 = void 0;

const $e7c40033e829def9$var$sdpTransform = $e7c40033e829def9$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $e7c40033e829def9$var$utils = $e7c40033e829def9$var$__importStar((parcelRequire("lghrF")));

const $e7c40033e829def9$var$ortc = $e7c40033e829def9$var$__importStar((parcelRequire("5Mq2W")));

const $e7c40033e829def9$var$sdpCommonUtils = $e7c40033e829def9$var$__importStar((parcelRequire("a2dIr")));

const $e7c40033e829def9$var$sdpPlanBUtils = $e7c40033e829def9$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $e7c40033e829def9$var$logger = new $24uNv.Logger("Chrome67");
const $e7c40033e829def9$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $e7c40033e829def9$var$Chrome67 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $e7c40033e829def9$var$Chrome67();
    }
    get name() {
        return "Chrome67";
    }
    close() {
        $e7c40033e829def9$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $e7c40033e829def9$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $e7c40033e829def9$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $e7c40033e829def9$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $e7c40033e829def9$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $e7c40033e829def9$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $e7c40033e829def9$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $e7c40033e829def9$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $e7c40033e829def9$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $e7c40033e829def9$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $e7c40033e829def9$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $e7c40033e829def9$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $e7c40033e829def9$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $e7c40033e829def9$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $e7c40033e829def9$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addTrack(track, this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $e7c40033e829def9$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $e7c40033e829def9$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $e7c40033e829def9$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $e7c40033e829def9$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $e7c40033e829def9$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $e7c40033e829def9$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $e7c40033e829def9$var$sdpTransform.write(localSdpObject)
            };
        }
        $e7c40033e829def9$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $e7c40033e829def9$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $e7c40033e829def9$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        const rtpSender = this._pc.getSenders().find((s)=>s.track === track);
        // Insert into the map.
        this._mapSendLocalIdRtpSender.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("stopSending() [localId:%s]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        this._pc.removeTrack(rtpSender);
        if (rtpSender.track) this._sendStream.removeTrack(rtpSender.track);
        this._mapSendLocalIdRtpSender.delete(localId);
        const offer = await this._pc.createOffer();
        $e7c40033e829def9$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $e7c40033e829def9$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $e7c40033e829def9$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $e7c40033e829def9$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const oldTrack = rtpSender.track;
        await rtpSender.replaceTrack(track);
        // Remove the old track from the local stream.
        if (oldTrack) this._sendStream.removeTrack(oldTrack);
        // Add the new track to the local stream.
        if (track) this._sendStream.addTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $e7c40033e829def9$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $e7c40033e829def9$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $e7c40033e829def9$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $e7c40033e829def9$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $e7c40033e829def9$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $e7c40033e829def9$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $e7c40033e829def9$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $e7c40033e829def9$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = trackId;
            const mid = kind;
            const rtpReceiver = this._pc.getReceivers().find((r)=>r.track && r.track.id === localId);
            if (!rtpReceiver) throw new Error("new RTCRtpReceiver not");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters,
                rtpReceiver: rtpReceiver
            });
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $e7c40033e829def9$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $e7c40033e829def9$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $e7c40033e829def9$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const { rtpReceiver: rtpReceiver } = this._mapRecvLocalIdInfo.get(localId) || {};
        if (!rtpReceiver) throw new Error("associated RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $e7c40033e829def9$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $e7c40033e829def9$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $e7c40033e829def9$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $e7c40033e829def9$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $e7c40033e829def9$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of RTCRtpSender indexed by localId.
        this._mapSendLocalIdRtpSender = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome67 = $e7c40033e829def9$var$Chrome67;

});
parcelRegister("gWHYI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRtpEncodings = $c5642d4c0e9422d6$var$getRtpEncodings;
module.exports.addLegacySimulcast = $c5642d4c0e9422d6$var$addLegacySimulcast;
function $c5642d4c0e9422d6$var$getRtpEncodings({ offerMediaObject: offerMediaObject, track: track }) {
    // First media SSRC (or the only one).
    let firstSsrc;
    const ssrcs = new Set();
    for (const line of offerMediaObject.ssrcs || []){
        if (line.attribute !== "msid") continue;
        const trackId = line.value.split(" ")[1];
        if (trackId === track.id) {
            const ssrc = line.id;
            ssrcs.add(ssrc);
            if (!firstSsrc) firstSsrc = ssrc;
        }
    }
    if (ssrcs.size === 0) throw new Error(`a=ssrc line with msid information not found [track.id:${track.id}]`);
    const ssrcToRtxSsrc = new Map();
    // First assume RTX is used.
    for (const line of offerMediaObject.ssrcGroups || []){
        if (line.semantics !== "FID") continue;
        let [ssrc, rtxSsrc] = line.ssrcs.split(/\s+/);
        ssrc = Number(ssrc);
        rtxSsrc = Number(rtxSsrc);
        if (ssrcs.has(ssrc)) {
            // Remove both the SSRC and RTX SSRC from the set so later we know that they
            // are already handled.
            ssrcs.delete(ssrc);
            ssrcs.delete(rtxSsrc);
            // Add to the map.
            ssrcToRtxSsrc.set(ssrc, rtxSsrc);
        }
    }
    // If the set of SSRCs is not empty it means that RTX is not being used, so take
    // media SSRCs from there.
    for (const ssrc of ssrcs)// Add to the map.
    ssrcToRtxSsrc.set(ssrc, null);
    const encodings = [];
    for (const [ssrc, rtxSsrc] of ssrcToRtxSsrc){
        const encoding = {
            ssrc: ssrc
        };
        if (rtxSsrc) encoding.rtx = {
            ssrc: rtxSsrc
        };
        encodings.push(encoding);
    }
    return encodings;
}
/**
 * Adds multi-ssrc based simulcast into the given SDP media section offer.
 */ function $c5642d4c0e9422d6$var$addLegacySimulcast({ offerMediaObject: offerMediaObject, track: track, numStreams: numStreams }) {
    if (numStreams <= 1) throw new TypeError("numStreams must be greater than 1");
    let firstSsrc;
    let firstRtxSsrc;
    let streamId;
    // Get the SSRC.
    const ssrcMsidLine = (offerMediaObject.ssrcs || []).find((line)=>{
        if (line.attribute !== "msid") return false;
        const trackId = line.value.split(" ")[1];
        if (trackId === track.id) {
            firstSsrc = line.id;
            streamId = line.value.split(" ")[0];
            return true;
        } else return false;
    });
    if (!ssrcMsidLine) throw new Error(`a=ssrc line with msid information not found [track.id:${track.id}]`);
    // Get the SSRC for RTX.
    (offerMediaObject.ssrcGroups || []).some((line)=>{
        if (line.semantics !== "FID") return false;
        const ssrcs = line.ssrcs.split(/\s+/);
        if (Number(ssrcs[0]) === firstSsrc) {
            firstRtxSsrc = Number(ssrcs[1]);
            return true;
        } else return false;
    });
    const ssrcCnameLine = offerMediaObject.ssrcs.find((line)=>line.attribute === "cname" && line.id === firstSsrc);
    if (!ssrcCnameLine) throw new Error(`a=ssrc line with cname information not found [track.id:${track.id}]`);
    const cname = ssrcCnameLine.value;
    const ssrcs = [];
    const rtxSsrcs = [];
    for(let i = 0; i < numStreams; ++i){
        ssrcs.push(firstSsrc + i);
        if (firstRtxSsrc) rtxSsrcs.push(firstRtxSsrc + i);
    }
    offerMediaObject.ssrcGroups = offerMediaObject.ssrcGroups || [];
    offerMediaObject.ssrcs = offerMediaObject.ssrcs || [];
    offerMediaObject.ssrcGroups.push({
        semantics: "SIM",
        ssrcs: ssrcs.join(" ")
    });
    for(let i = 0; i < ssrcs.length; ++i){
        const ssrc = ssrcs[i];
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: ssrc,
            attribute: "msid",
            value: `${streamId} ${track.id}`
        });
    }
    for(let i = 0; i < rtxSsrcs.length; ++i){
        const ssrc = ssrcs[i];
        const rtxSsrc = rtxSsrcs[i];
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "cname",
            value: cname
        });
        offerMediaObject.ssrcs.push({
            id: rtxSsrc,
            attribute: "msid",
            value: `${streamId} ${track.id}`
        });
        offerMediaObject.ssrcGroups.push({
            semantics: "FID",
            ssrcs: `${ssrc} ${rtxSsrc}`
        });
    }
}

});


parcelRegister("6oohh", function(module, exports) {
"use strict";
var $4a77d10083b62993$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4a77d10083b62993$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4a77d10083b62993$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4a77d10083b62993$var$__createBinding(result, mod, k);
    }
    $4a77d10083b62993$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Chrome55 = void 0;

const $4a77d10083b62993$var$sdpTransform = $4a77d10083b62993$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $4a77d10083b62993$var$utils = $4a77d10083b62993$var$__importStar((parcelRequire("lghrF")));

const $4a77d10083b62993$var$ortc = $4a77d10083b62993$var$__importStar((parcelRequire("5Mq2W")));

const $4a77d10083b62993$var$sdpCommonUtils = $4a77d10083b62993$var$__importStar((parcelRequire("a2dIr")));

const $4a77d10083b62993$var$sdpPlanBUtils = $4a77d10083b62993$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $4a77d10083b62993$var$logger = new $24uNv.Logger("Chrome55");
const $4a77d10083b62993$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $4a77d10083b62993$var$Chrome55 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $4a77d10083b62993$var$Chrome55();
    }
    get name() {
        return "Chrome55";
    }
    close() {
        $4a77d10083b62993$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $4a77d10083b62993$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $4a77d10083b62993$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $4a77d10083b62993$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $4a77d10083b62993$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $4a77d10083b62993$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $4a77d10083b62993$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $4a77d10083b62993$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $4a77d10083b62993$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $4a77d10083b62993$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $4a77d10083b62993$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $4a77d10083b62993$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $4a77d10083b62993$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $4a77d10083b62993$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $4a77d10083b62993$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $4a77d10083b62993$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addStream(this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $4a77d10083b62993$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $4a77d10083b62993$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $4a77d10083b62993$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $4a77d10083b62993$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $4a77d10083b62993$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $4a77d10083b62993$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $4a77d10083b62993$var$sdpTransform.write(localSdpObject)
            };
        }
        $4a77d10083b62993$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $4a77d10083b62993$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $4a77d10083b62993$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Insert into the map.
        this._mapSendLocalIdTrack.set(localId, track);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $4a77d10083b62993$var$logger.debug("stopSending() [localId:%s]", localId);
        const track = this._mapSendLocalIdTrack.get(localId);
        if (!track) throw new Error("track not found");
        this._mapSendLocalIdTrack.delete(localId);
        this._sendStream.removeTrack(track);
        this._pc.addStream(this._sendStream);
        const offer = await this._pc.createOffer();
        $4a77d10083b62993$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $4a77d10083b62993$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    track) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async setMaxSpatialLayer(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    spatialLayer) {
        throw new $roix3.UnsupportedError(" not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setRtpEncodingParameters(localId, params) {
        throw new $roix3.UnsupportedError("not supported");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getSenderStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $4a77d10083b62993$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $4a77d10083b62993$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $4a77d10083b62993$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $4a77d10083b62993$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $4a77d10083b62993$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $4a77d10083b62993$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $4a77d10083b62993$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const localId = trackId;
            const streamId = options.streamId || rtpParameters.rtcp.cname;
            const stream = this._pc.getRemoteStreams().find((s)=>s.id === streamId);
            const track = stream.getTrackById(localId);
            if (!track) throw new Error("remote track not found");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters
            });
            results.push({
                localId: localId,
                track: track
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $4a77d10083b62993$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $4a77d10083b62993$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $4a77d10083b62993$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getReceiverStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $4a77d10083b62993$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $4a77d10083b62993$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $4a77d10083b62993$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $4a77d10083b62993$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $4a77d10083b62993$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of sending MediaStreamTracks indexed by localId.
        this._mapSendLocalIdTrack = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Chrome55 = $4a77d10083b62993$var$Chrome55;

});

parcelRegister("l1Nf1", function(module, exports) {
"use strict";
var $f4efe33e5949c95a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4efe33e5949c95a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f4efe33e5949c95a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f4efe33e5949c95a$var$__createBinding(result, mod, k);
    }
    $f4efe33e5949c95a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Firefox120 = void 0;

const $f4efe33e5949c95a$var$sdpTransform = $f4efe33e5949c95a$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $f4efe33e5949c95a$var$utils = $f4efe33e5949c95a$var$__importStar((parcelRequire("lghrF")));

const $f4efe33e5949c95a$var$ortc = $f4efe33e5949c95a$var$__importStar((parcelRequire("5Mq2W")));

const $f4efe33e5949c95a$var$sdpCommonUtils = $f4efe33e5949c95a$var$__importStar((parcelRequire("a2dIr")));

const $f4efe33e5949c95a$var$sdpUnifiedPlanUtils = $f4efe33e5949c95a$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $f4efe33e5949c95a$var$logger = new $24uNv.Logger("Firefox120");
const $f4efe33e5949c95a$var$SCTP_NUM_STREAMS = {
    OS: 16,
    MIS: 2048
};
class $f4efe33e5949c95a$var$Firefox120 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $f4efe33e5949c95a$var$Firefox120();
    }
    get name() {
        return "Firefox120";
    }
    close() {
        $f4efe33e5949c95a$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $f4efe33e5949c95a$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        // NOTE: We need to add a real video track to get the RID extension mapping,
        // otherwiser Firefox doesn't include it in the SDP.
        const canvas = document.createElement("canvas");
        // NOTE: Otherwise Firefox fails in next line.
        canvas.getContext("2d");
        const fakeStream = canvas.captureStream();
        const fakeVideoTrack = fakeStream.getVideoTracks()[0];
        try {
            pc.addTransceiver("audio", {
                direction: "sendrecv"
            });
            pc.addTransceiver(fakeVideoTrack, {
                direction: "sendrecv",
                sendEncodings: [
                    {
                        rid: "r0",
                        maxBitrate: 100000
                    },
                    {
                        rid: "r1",
                        maxBitrate: 500000
                    }
                ]
            });
            const offer = await pc.createOffer();
            try {
                canvas.remove();
            } catch (error) {}
            try {
                fakeVideoTrack.stop();
            } catch (error) {}
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $f4efe33e5949c95a$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                canvas.remove();
            } catch (error2) {}
            try {
                fakeVideoTrack.stop();
            } catch (error2) {}
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $f4efe33e5949c95a$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $f4efe33e5949c95a$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $f4efe33e5949c95a$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $f4efe33e5949c95a$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $f4efe33e5949c95a$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $f4efe33e5949c95a$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $f4efe33e5949c95a$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $f4efe33e5949c95a$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        // NOTE: Firefox does not implement pc.setConfiguration().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $f4efe33e5949c95a$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $f4efe33e5949c95a$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $f4efe33e5949c95a$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $f4efe33e5949c95a$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $f4efe33e5949c95a$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $f4efe33e5949c95a$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        // NOTE: Firefox fails sometimes to properly anticipate the closed media
        // section that it should use, so don't reuse closed media sections.
        //   https://github.com/versatica/mediasoup-client/issues/104
        //
        // const mediaSectionIdx = this._remoteSdp!.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        const offer = await this._pc.createOffer();
        let localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
        // In Firefox use DTLS role client even if we are the "offerer" since
        // Firefox does not respect ICE-Lite.
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        $f4efe33e5949c95a$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[localSdpObject.media.length - 1];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $f4efe33e5949c95a$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $f4efe33e5949c95a$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $f4efe33e5949c95a$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        transceiver.sender.replaceTrack(null);
        // NOTE: Cannot use stop() the transceiver due to the the note above in
        // send() method.
        // try
        // {
        // 	transceiver.stop();
        // }
        // catch (error)
        // {}
        this._pc.removeTrack(transceiver.sender);
        // NOTE: Cannot use closeMediaSection() due to the the note above in send()
        // method.
        // this._remoteSdp!.closeMediaSection(transceiver.mid);
        this._remoteSdp.disableMediaSection(transceiver.mid);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $f4efe33e5949c95a$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $f4efe33e5949c95a$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $f4efe33e5949c95a$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $f4efe33e5949c95a$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: "client",
                localSdpObject: localSdpObject
            });
            $f4efe33e5949c95a$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $f4efe33e5949c95a$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $f4efe33e5949c95a$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
            answer = {
                type: "answer",
                sdp: $f4efe33e5949c95a$var$sdpTransform.write(localSdpObject)
            };
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        $f4efe33e5949c95a$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $f4efe33e5949c95a$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $f4efe33e5949c95a$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $f4efe33e5949c95a$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(answer.sdp);
                await this.setupTransport({
                    localDtlsRole: "client",
                    localSdpObject: localSdpObject
                });
            }
            $f4efe33e5949c95a$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $f4efe33e5949c95a$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $f4efe33e5949c95a$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Firefox120 = $f4efe33e5949c95a$var$Firefox120;

});

parcelRegister("a2Xk2", function(module, exports) {
"use strict";
var $75081b6b137db910$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75081b6b137db910$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $75081b6b137db910$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75081b6b137db910$var$__createBinding(result, mod, k);
    }
    $75081b6b137db910$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Firefox60 = void 0;

const $75081b6b137db910$var$sdpTransform = $75081b6b137db910$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $75081b6b137db910$var$utils = $75081b6b137db910$var$__importStar((parcelRequire("lghrF")));

const $75081b6b137db910$var$ortc = $75081b6b137db910$var$__importStar((parcelRequire("5Mq2W")));

const $75081b6b137db910$var$sdpCommonUtils = $75081b6b137db910$var$__importStar((parcelRequire("a2dIr")));

const $75081b6b137db910$var$sdpUnifiedPlanUtils = $75081b6b137db910$var$__importStar((parcelRequire("ghGMB")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $75081b6b137db910$var$logger = new $24uNv.Logger("Firefox60");
const $75081b6b137db910$var$SCTP_NUM_STREAMS = {
    OS: 16,
    MIS: 2048
};
class $75081b6b137db910$var$Firefox60 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $75081b6b137db910$var$Firefox60();
    }
    get name() {
        return "Firefox60";
    }
    close() {
        $75081b6b137db910$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $75081b6b137db910$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        // NOTE: We need to add a real video track to get the RID extension mapping.
        const canvas = document.createElement("canvas");
        // NOTE: Otherwise Firefox fails in next line.
        canvas.getContext("2d");
        const fakeStream = canvas.captureStream();
        const fakeVideoTrack = fakeStream.getVideoTracks()[0];
        try {
            pc.addTransceiver("audio", {
                direction: "sendrecv"
            });
            const videoTransceiver = pc.addTransceiver(fakeVideoTrack, {
                direction: "sendrecv"
            });
            const parameters = videoTransceiver.sender.getParameters();
            const encodings = [
                {
                    rid: "r0",
                    maxBitrate: 100000
                },
                {
                    rid: "r1",
                    maxBitrate: 500000
                }
            ];
            parameters.encodings = encodings;
            await videoTransceiver.sender.setParameters(parameters);
            const offer = await pc.createOffer();
            try {
                canvas.remove();
            } catch (error) {}
            try {
                fakeVideoTrack.stop();
            } catch (error) {}
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $75081b6b137db910$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                canvas.remove();
            } catch (error2) {}
            try {
                fakeVideoTrack.stop();
            } catch (error2) {}
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $75081b6b137db910$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $75081b6b137db910$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $75081b6b137db910$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $75081b6b137db910$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $75081b6b137db910$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $75081b6b137db910$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $75081b6b137db910$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $75081b6b137db910$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        // NOTE: Firefox does not implement pc.setConfiguration().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $75081b6b137db910$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $75081b6b137db910$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings) {
            encodings = $75081b6b137db910$var$utils.clone(encodings);
            if (encodings.length > 1) {
                encodings.forEach((encoding, idx)=>{
                    encoding.rid = `r${idx}`;
                });
                // Clone the encodings and reverse them because Firefox likes them
                // from high to low.
                encodings.reverse();
            }
        }
        const sendingRtpParameters = $75081b6b137db910$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $75081b6b137db910$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $75081b6b137db910$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $75081b6b137db910$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        // NOTE: Firefox fails sometimes to properly anticipate the closed media
        // section that it should use, so don't reuse closed media sections.
        //   https://github.com/versatica/mediasoup-client/issues/104
        //
        // const mediaSectionIdx = this._remoteSdp!.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        // NOTE: This is not spec compliants. Encodings should be given in addTransceiver
        // second argument, but Firefox does not support it.
        if (encodings) {
            const parameters = transceiver.sender.getParameters();
            parameters.encodings = encodings;
            await transceiver.sender.setParameters(parameters);
        }
        const offer = await this._pc.createOffer();
        let localSdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
        // In Firefox use DTLS role client even if we are the "offerer" since
        // Firefox does not respect ICE-Lite.
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        $75081b6b137db910$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $75081b6b137db910$var$sdpTransform.parse(this._pc.localDescription.sdp);
        const offerMediaObject = localSdpObject.media[localSdpObject.media.length - 1];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $75081b6b137db910$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $75081b6b137db910$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            const newEncodings = $75081b6b137db910$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings.reverse();
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("stopSending() [localId:%s]", localId);
        if (this._closed) return;
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        transceiver.sender.replaceTrack(null);
        // NOTE: Cannot use stop() the transceiver due to the the note above in
        // send() method.
        // try
        // {
        // 	transceiver.stop();
        // }
        // catch (error)
        // {}
        this._pc.removeTrack(transceiver.sender);
        // NOTE: Cannot use closeMediaSection() due to the the note above in send()
        // method.
        // this._remoteSdp!.closeMediaSection(transceiver.mid);
        this._remoteSdp.disableMediaSection(transceiver.mid);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $75081b6b137db910$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $75081b6b137db910$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated transceiver not found");
        const parameters = transceiver.sender.getParameters();
        // NOTE: We require encodings given from low to high, however Firefox
        // requires them in reverse order, so do magic here.
        spatialLayer = parameters.encodings.length - 1 - spatialLayer;
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx >= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $75081b6b137db910$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $75081b6b137db910$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: "client",
                localSdpObject: localSdpObject
            });
            $75081b6b137db910$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $75081b6b137db910$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $75081b6b137db910$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
            answer = {
                type: "answer",
                sdp: $75081b6b137db910$var$sdpTransform.write(localSdpObject)
            };
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "client",
            localSdpObject: localSdpObject
        });
        $75081b6b137db910$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $75081b6b137db910$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $75081b6b137db910$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $75081b6b137db910$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $75081b6b137db910$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $75081b6b137db910$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $75081b6b137db910$var$sdpTransform.parse(answer.sdp);
                await this.setupTransport({
                    localDtlsRole: "client",
                    localSdpObject: localSdpObject
                });
            }
            $75081b6b137db910$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $75081b6b137db910$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $75081b6b137db910$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Firefox60 = $75081b6b137db910$var$Firefox60;

});

parcelRegister("cqkQU", function(module, exports) {
"use strict";
var $90b816944fb0be26$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $90b816944fb0be26$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $90b816944fb0be26$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $90b816944fb0be26$var$__createBinding(result, mod, k);
    }
    $90b816944fb0be26$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safari12 = void 0;

const $90b816944fb0be26$var$sdpTransform = $90b816944fb0be26$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $90b816944fb0be26$var$utils = $90b816944fb0be26$var$__importStar((parcelRequire("lghrF")));

const $90b816944fb0be26$var$ortc = $90b816944fb0be26$var$__importStar((parcelRequire("5Mq2W")));

const $90b816944fb0be26$var$sdpCommonUtils = $90b816944fb0be26$var$__importStar((parcelRequire("a2dIr")));

const $90b816944fb0be26$var$sdpUnifiedPlanUtils = $90b816944fb0be26$var$__importStar((parcelRequire("ghGMB")));

const $90b816944fb0be26$var$ortcUtils = $90b816944fb0be26$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $90b816944fb0be26$var$logger = new $24uNv.Logger("Safari12");
const $90b816944fb0be26$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $90b816944fb0be26$var$Safari12 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $90b816944fb0be26$var$Safari12();
    }
    get name() {
        return "Safari12";
    }
    close() {
        $90b816944fb0be26$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $90b816944fb0be26$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $90b816944fb0be26$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $90b816944fb0be26$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $90b816944fb0be26$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $90b816944fb0be26$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $90b816944fb0be26$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $90b816944fb0be26$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $90b816944fb0be26$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $90b816944fb0be26$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $90b816944fb0be26$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $90b816944fb0be26$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $90b816944fb0be26$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        const sendingRtpParameters = $90b816944fb0be26$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $90b816944fb0be26$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $90b816944fb0be26$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $90b816944fb0be26$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ]
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        let offer = await this._pc.createOffer();
        let localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length > 1) {
            $90b816944fb0be26$var$logger.debug("send() | enabling legacy simulcast");
            localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $90b816944fb0be26$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $90b816944fb0be26$var$sdpTransform.write(localSdpObject)
            };
        }
        $90b816944fb0be26$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        // We can now get the transceiver.mid.
        const localId = transceiver.mid;
        // Set MID.
        sendingRtpParameters.mid = localId;
        localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $90b816944fb0be26$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $90b816944fb0be26$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        if (this._closed) return;
        $90b816944fb0be26$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        this._remoteSdp.resumeSendingMediaSection(localId);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $90b816944fb0be26$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $90b816944fb0be26$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $90b816944fb0be26$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $90b816944fb0be26$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $90b816944fb0be26$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $90b816944fb0be26$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $90b816944fb0be26$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $90b816944fb0be26$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $90b816944fb0be26$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            // Store in the map.
            this._mapMidTransceiver.set(localId, transceiver);
            results.push({
                localId: localId,
                track: transceiver.receiver.track,
                rtpReceiver: transceiver.receiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $90b816944fb0be26$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $90b816944fb0be26$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $90b816944fb0be26$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $90b816944fb0be26$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $90b816944fb0be26$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $90b816944fb0be26$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $90b816944fb0be26$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $90b816944fb0be26$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Safari12 = $90b816944fb0be26$var$Safari12;

});

parcelRegister("5TVIx", function(module, exports) {
"use strict";
var $44bedc4536a2ac68$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44bedc4536a2ac68$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $44bedc4536a2ac68$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $44bedc4536a2ac68$var$__createBinding(result, mod, k);
    }
    $44bedc4536a2ac68$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Safari11 = void 0;

const $44bedc4536a2ac68$var$sdpTransform = $44bedc4536a2ac68$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $44bedc4536a2ac68$var$utils = $44bedc4536a2ac68$var$__importStar((parcelRequire("lghrF")));

const $44bedc4536a2ac68$var$ortc = $44bedc4536a2ac68$var$__importStar((parcelRequire("5Mq2W")));

const $44bedc4536a2ac68$var$sdpCommonUtils = $44bedc4536a2ac68$var$__importStar((parcelRequire("a2dIr")));

const $44bedc4536a2ac68$var$sdpPlanBUtils = $44bedc4536a2ac68$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $44bedc4536a2ac68$var$logger = new $24uNv.Logger("Safari11");
const $44bedc4536a2ac68$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $44bedc4536a2ac68$var$Safari11 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $44bedc4536a2ac68$var$Safari11();
    }
    get name() {
        return "Safari11";
    }
    close() {
        $44bedc4536a2ac68$var$logger.debug("close()");
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $44bedc4536a2ac68$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $44bedc4536a2ac68$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $44bedc4536a2ac68$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $44bedc4536a2ac68$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $44bedc4536a2ac68$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $44bedc4536a2ac68$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $44bedc4536a2ac68$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $44bedc4536a2ac68$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $44bedc4536a2ac68$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $44bedc4536a2ac68$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $44bedc4536a2ac68$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $44bedc4536a2ac68$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $44bedc4536a2ac68$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $44bedc4536a2ac68$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addTrack(track, this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $44bedc4536a2ac68$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $44bedc4536a2ac68$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $44bedc4536a2ac68$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $44bedc4536a2ac68$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $44bedc4536a2ac68$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $44bedc4536a2ac68$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $44bedc4536a2ac68$var$sdpTransform.write(localSdpObject)
            };
        }
        $44bedc4536a2ac68$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $44bedc4536a2ac68$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $44bedc4536a2ac68$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 and there is effective simulcast, add scalabilityMode to each
        // encoding.
        if (sendingRtpParameters.encodings.length > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8") for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        const rtpSender = this._pc.getSenders().find((s)=>s.track === track);
        // Insert into the map.
        this._mapSendLocalIdRtpSender.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        if (rtpSender.track) this._sendStream.removeTrack(rtpSender.track);
        this._mapSendLocalIdRtpSender.delete(localId);
        const offer = await this._pc.createOffer();
        $44bedc4536a2ac68$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $44bedc4536a2ac68$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        this.assertSendDirection();
        if (track) $44bedc4536a2ac68$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $44bedc4536a2ac68$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const oldTrack = rtpSender.track;
        await rtpSender.replaceTrack(track);
        // Remove the old track from the local stream.
        if (oldTrack) this._sendStream.removeTrack(oldTrack);
        // Add the new track to the local stream.
        if (track) this._sendStream.addTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertSendDirection();
        $44bedc4536a2ac68$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        this.assertSendDirection();
        const rtpSender = this._mapSendLocalIdRtpSender.get(localId);
        if (!rtpSender) throw new Error("associated RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $44bedc4536a2ac68$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $44bedc4536a2ac68$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $44bedc4536a2ac68$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $44bedc4536a2ac68$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $44bedc4536a2ac68$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $44bedc4536a2ac68$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $44bedc4536a2ac68$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const localId = trackId;
            const rtpReceiver = this._pc.getReceivers().find((r)=>r.track && r.track.id === localId);
            if (!rtpReceiver) throw new Error("new RTCRtpReceiver not");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters,
                rtpReceiver: rtpReceiver
            });
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $44bedc4536a2ac68$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $44bedc4536a2ac68$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $44bedc4536a2ac68$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertRecvDirection();
        const { rtpReceiver: rtpReceiver } = this._mapRecvLocalIdInfo.get(localId) || {};
        if (!rtpReceiver) throw new Error("associated RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $44bedc4536a2ac68$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $44bedc4536a2ac68$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $44bedc4536a2ac68$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of RTCRtpSender indexed by localId.
        this._mapSendLocalIdRtpSender = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Safari11 = $44bedc4536a2ac68$var$Safari11;

});

parcelRegister("3HogQ", function(module, exports) {
"use strict";
var $2b1836e0c9c002fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b1836e0c9c002fc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2b1836e0c9c002fc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2b1836e0c9c002fc$var$__createBinding(result, mod, k);
    }
    $2b1836e0c9c002fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Edge11 = void 0;

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $2b1836e0c9c002fc$var$utils = $2b1836e0c9c002fc$var$__importStar((parcelRequire("lghrF")));

const $2b1836e0c9c002fc$var$ortc = $2b1836e0c9c002fc$var$__importStar((parcelRequire("5Mq2W")));

const $2b1836e0c9c002fc$var$edgeUtils = $2b1836e0c9c002fc$var$__importStar((parcelRequire("gqu15")));

var $2ptPl = parcelRequire("2ptPl");
const $2b1836e0c9c002fc$var$logger = new $24uNv.Logger("Edge11");
class $2b1836e0c9c002fc$var$Edge11 extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $2b1836e0c9c002fc$var$Edge11();
    }
    get name() {
        return "Edge11";
    }
    close() {
        $2b1836e0c9c002fc$var$logger.debug("close()");
        // Close the ICE gatherer.
        // NOTE: Not yet implemented by Edge.
        try {
            this._iceGatherer.close();
        } catch (error) {}
        // Close the ICE transport.
        try {
            this._iceTransport.stop();
        } catch (error) {}
        // Close the DTLS transport.
        try {
            this._dtlsTransport.stop();
        } catch (error) {}
        // Close RTCRtpSenders.
        for (const rtpSender of this._rtpSenders.values())try {
            rtpSender.stop();
        } catch (error) {}
        // Close RTCRtpReceivers.
        for (const rtpReceiver of this._rtpReceivers.values())try {
            rtpReceiver.stop();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $2b1836e0c9c002fc$var$logger.debug("getNativeRtpCapabilities()");
        return $2b1836e0c9c002fc$var$edgeUtils.getCapabilities();
    }
    async getNativeSctpCapabilities() {
        $2b1836e0c9c002fc$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: {
                OS: 0,
                MIS: 0
            }
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $2b1836e0c9c002fc$var$logger.debug("run()");
        this._sendingRtpParametersByKind = {
            audio: $2b1836e0c9c002fc$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $2b1836e0c9c002fc$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._remoteIceParameters = iceParameters;
        this._remoteIceCandidates = iceCandidates;
        this._remoteDtlsParameters = dtlsParameters;
        this._cname = `CNAME-${$2b1836e0c9c002fc$var$utils.generateRandomNumber()}`;
        this.setIceGatherer({
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy
        });
        this.setIceTransport();
        this.setDtlsTransport();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async updateIceServers(iceServers) {
        // NOTE: Edge 11 does not implement iceGatherer.gater().
        throw new $roix3.UnsupportedError("not supported");
    }
    async restartIce(iceParameters) {
        $2b1836e0c9c002fc$var$logger.debug("restartIce()");
        this._remoteIceParameters = iceParameters;
        if (!this._transportReady) return;
        $2b1836e0c9c002fc$var$logger.debug("restartIce() | calling iceTransport.start()");
        this._iceTransport.start(this._iceGatherer, iceParameters, "controlling");
        for (const candidate of this._remoteIceCandidates)this._iceTransport.addRemoteCandidate(candidate);
        this._iceTransport.addRemoteCandidate({});
    }
    async getTransportStats() {
        return this._iceTransport.getStats();
    }
    async send(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    { track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        $2b1836e0c9c002fc$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "server"
        });
        $2b1836e0c9c002fc$var$logger.debug("send() | calling new RTCRtpSender()");
        const rtpSender = new RTCRtpSender(track, this._dtlsTransport);
        const rtpParameters = $2b1836e0c9c002fc$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        rtpParameters.codecs = $2b1836e0c9c002fc$var$ortc.reduceCodecs(rtpParameters.codecs, codec);
        const useRtx = rtpParameters.codecs.some((_codec)=>/.+\/rtx$/i.test(_codec.mimeType));
        if (!encodings) encodings = [
            {}
        ];
        for (const encoding of encodings){
            encoding.ssrc = $2b1836e0c9c002fc$var$utils.generateRandomNumber();
            if (useRtx) encoding.rtx = {
                ssrc: $2b1836e0c9c002fc$var$utils.generateRandomNumber()
            };
        }
        rtpParameters.encodings = encodings;
        // Fill RTCRtpParameters.rtcp.
        rtpParameters.rtcp = {
            cname: this._cname,
            reducedSize: true,
            mux: true
        };
        // NOTE: Convert our standard RTCRtpParameters into those that Edge
        // expects.
        const edgeRtpParameters = $2b1836e0c9c002fc$var$edgeUtils.mangleRtpParameters(rtpParameters);
        $2b1836e0c9c002fc$var$logger.debug("send() | calling rtpSender.send() [params:%o]", edgeRtpParameters);
        await rtpSender.send(edgeRtpParameters);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Store it.
        this._rtpSenders.set(localId, rtpSender);
        return {
            localId: localId,
            rtpParameters: rtpParameters,
            rtpSender: rtpSender
        };
    }
    async stopSending(localId) {
        $2b1836e0c9c002fc$var$logger.debug("stopSending() [localId:%s]", localId);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        this._rtpSenders.delete(localId);
        try {
            $2b1836e0c9c002fc$var$logger.debug("stopSending() | calling rtpSender.stop()");
            rtpSender.stop();
        } catch (error) {
            $2b1836e0c9c002fc$var$logger.warn("stopSending() | rtpSender.stop() failed:%o", error);
            throw error;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(localId, track) {
        if (track) $2b1836e0c9c002fc$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $2b1836e0c9c002fc$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        rtpSender.setTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        $2b1836e0c9c002fc$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await rtpSender.setParameters(parameters);
    }
    async setRtpEncodingParameters(localId, params) {
        $2b1836e0c9c002fc$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        const parameters = rtpSender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await rtpSender.setParameters(parameters);
    }
    async getSenderStats(localId) {
        const rtpSender = this._rtpSenders.get(localId);
        if (!rtpSender) throw new Error("RTCRtpSender not found");
        return rtpSender.getStats();
    }
    async sendDataChannel(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    options) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receive(optionsList) {
        const results = [];
        for (const options of optionsList){
            const { trackId: trackId, kind: kind } = options;
            $2b1836e0c9c002fc$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
        }
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: "server"
        });
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters } = options;
            $2b1836e0c9c002fc$var$logger.debug("receive() | calling new RTCRtpReceiver()");
            const rtpReceiver = new RTCRtpReceiver(this._dtlsTransport, kind);
            rtpReceiver.addEventListener("error", (event)=>{
                $2b1836e0c9c002fc$var$logger.error('rtpReceiver "error" event [event:%o]', event);
            });
            // NOTE: Convert our standard RTCRtpParameters into those that Edge
            // expects.
            const edgeRtpParameters = $2b1836e0c9c002fc$var$edgeUtils.mangleRtpParameters(rtpParameters);
            $2b1836e0c9c002fc$var$logger.debug("receive() | calling rtpReceiver.receive() [params:%o]", edgeRtpParameters);
            await rtpReceiver.receive(edgeRtpParameters);
            const localId = trackId;
            // Store it.
            this._rtpReceivers.set(localId, rtpReceiver);
            results.push({
                localId: localId,
                track: rtpReceiver.track,
                rtpReceiver: rtpReceiver
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        for (const localId of localIds){
            $2b1836e0c9c002fc$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const rtpReceiver = this._rtpReceivers.get(localId);
            if (!rtpReceiver) throw new Error("RTCRtpReceiver not found");
            this._rtpReceivers.delete(localId);
            try {
                $2b1836e0c9c002fc$var$logger.debug("stopReceiving() | calling rtpReceiver.stop()");
                rtpReceiver.stop();
            } catch (error) {
                $2b1836e0c9c002fc$var$logger.warn("stopReceiving() | rtpReceiver.stop() failed:%o", error);
            }
        }
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async getReceiverStats(localId) {
        const rtpReceiver = this._rtpReceivers.get(localId);
        if (!rtpReceiver) throw new Error("RTCRtpReceiver not found");
        return rtpReceiver.getStats();
    }
    async receiveDataChannel(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    options) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    setIceGatherer({ iceServers: iceServers, iceTransportPolicy: iceTransportPolicy }) {
        // @ts-ignore
        const iceGatherer = new RTCIceGatherer({
            iceServers: iceServers || [],
            gatherPolicy: iceTransportPolicy || "all"
        });
        iceGatherer.addEventListener("error", (event)=>{
            $2b1836e0c9c002fc$var$logger.error('iceGatherer "error" event [event:%o]', event);
        });
        // NOTE: Not yet implemented by Edge, which starts gathering automatically.
        try {
            iceGatherer.gather();
        } catch (error) {
            $2b1836e0c9c002fc$var$logger.debug("setIceGatherer() | iceGatherer.gather() failed: %s", error.toString());
        }
        this._iceGatherer = iceGatherer;
    }
    setIceTransport() {
        const iceTransport = new RTCIceTransport(this._iceGatherer);
        // NOTE: Not yet implemented by Edge.
        iceTransport.addEventListener("statechange", ()=>{
            switch(iceTransport.state){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
        // NOTE: Not standard, but implemented by Edge.
        iceTransport.addEventListener("icestatechange", ()=>{
            switch(iceTransport.state){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
        iceTransport.addEventListener("candidatepairchange", (event)=>{
            $2b1836e0c9c002fc$var$logger.debug('iceTransport "candidatepairchange" event [pair:%o]', event.pair);
        });
        this._iceTransport = iceTransport;
    }
    setDtlsTransport() {
        const dtlsTransport = new RTCDtlsTransport(this._iceTransport);
        // NOTE: Not yet implemented by Edge.
        dtlsTransport.addEventListener("statechange", ()=>{
            $2b1836e0c9c002fc$var$logger.debug('dtlsTransport "statechange" event [state:%s]', dtlsTransport.state);
        });
        // NOTE: Not standard, but implemented by Edge.
        dtlsTransport.addEventListener("dtlsstatechange", ()=>{
            $2b1836e0c9c002fc$var$logger.debug('dtlsTransport "dtlsstatechange" event [state:%s]', dtlsTransport.state);
            if (dtlsTransport.state === "closed") this.emit("@connectionstatechange", "closed");
        });
        dtlsTransport.addEventListener("error", (event)=>{
            $2b1836e0c9c002fc$var$logger.error('dtlsTransport "error" event [event:%o]', event);
        });
        this._dtlsTransport = dtlsTransport;
    }
    async setupTransport({ localDtlsRole: localDtlsRole }) {
        $2b1836e0c9c002fc$var$logger.debug("setupTransport()");
        // Get our local DTLS parameters.
        const dtlsParameters = this._dtlsTransport.getLocalParameters();
        dtlsParameters.role = localDtlsRole;
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        // Start the RTCIceTransport.
        this._iceTransport.start(this._iceGatherer, this._remoteIceParameters, "controlling");
        // Add remote ICE candidates.
        for (const candidate of this._remoteIceCandidates)this._iceTransport.addRemoteCandidate(candidate);
        // Also signal a 'complete' candidate as per spec.
        // NOTE: It should be {complete: true} but Edge prefers {}.
        // NOTE: If we don't signal end of candidates, the Edge RTCIceTransport
        // won't enter the 'completed' state.
        this._iceTransport.addRemoteCandidate({});
        // NOTE: Edge does not like SHA less than 256.
        this._remoteDtlsParameters.fingerprints = this._remoteDtlsParameters.fingerprints.filter((fingerprint)=>{
            return fingerprint.algorithm === "sha-256" || fingerprint.algorithm === "sha-384" || fingerprint.algorithm === "sha-512";
        });
        // Start the RTCDtlsTransport.
        this._dtlsTransport.start(this._remoteDtlsParameters);
        this._transportReady = true;
    }
    constructor(){
        super();
        // Map of RTCRtpSenders indexed by id.
        this._rtpSenders = new Map();
        // Map of RTCRtpReceivers indexed by id.
        this._rtpReceivers = new Map();
        // Next localId for sending tracks.
        this._nextSendLocalId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.Edge11 = $2b1836e0c9c002fc$var$Edge11;

});
parcelRegister("gqu15", function(module, exports) {
"use strict";
var $bf565bafd617b619$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf565bafd617b619$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bf565bafd617b619$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bf565bafd617b619$var$__createBinding(result, mod, k);
    }
    $bf565bafd617b619$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCapabilities = $bf565bafd617b619$var$getCapabilities;
module.exports.mangleRtpParameters = $bf565bafd617b619$var$mangleRtpParameters;

const $bf565bafd617b619$var$utils = $bf565bafd617b619$var$__importStar((parcelRequire("lghrF")));
/**
 * Normalize ORTC based Edge's RTCRtpReceiver.getCapabilities() to produce a full
 * compliant ORTC RTCRtpCapabilities.
 */ function $bf565bafd617b619$var$getCapabilities() {
    const nativeCaps = RTCRtpReceiver.getCapabilities();
    const caps = $bf565bafd617b619$var$utils.clone(nativeCaps);
    var _caps_codecs;
    for (const codec of (_caps_codecs = caps.codecs) !== null && _caps_codecs !== void 0 ? _caps_codecs : []){
        // Rename numChannels to channels.
        // @ts-ignore
        codec.channels = codec.numChannels;
        // @ts-ignore
        delete codec.numChannels;
        // Add mimeType.
        // @ts-ignore (due to codec.name).
        codec.mimeType = codec.mimeType || `${codec.kind}/${codec.name}`;
        // NOTE: Edge sets some numeric parameters as string rather than number. Fix them.
        if (codec.parameters) {
            const parameters = codec.parameters;
            if (parameters.apt) parameters.apt = Number(parameters.apt);
            if (parameters["packetization-mode"]) parameters["packetization-mode"] = Number(parameters["packetization-mode"]);
        }
        // Delete emty parameter String in rtcpFeedback.
        for (const feedback of codec.rtcpFeedback || [])if (!feedback.parameter) feedback.parameter = "";
    }
    return caps;
}
/**
 * Generate RTCRtpParameters as ORTC based Edge likes.
 */ function $bf565bafd617b619$var$mangleRtpParameters(rtpParameters) {
    const params = $bf565bafd617b619$var$utils.clone(rtpParameters);
    // Rename mid to muxId.
    if (params.mid) {
        // @ts-ignore (due to muxId).
        params.muxId = params.mid;
        delete params.mid;
    }
    for (const codec of params.codecs){
        // Rename channels to numChannels.
        if (codec.channels) {
            // @ts-ignore.
            codec.numChannels = codec.channels;
            delete codec.channels;
        }
        // Add codec.name (requried by Edge).
        // @ts-ignore (due to name).
        if (codec.mimeType && !codec.name) // @ts-ignore (due to name).
        codec.name = codec.mimeType.split("/")[1];
        // Remove mimeType.
        // @ts-ignore
        delete codec.mimeType;
    }
    return params;
}

});


parcelRegister("bcHUy", function(module, exports) {
"use strict";
var $8282e08bfb18d5fc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8282e08bfb18d5fc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8282e08bfb18d5fc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8282e08bfb18d5fc$var$__createBinding(result, mod, k);
    }
    $8282e08bfb18d5fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactNativeUnifiedPlan = void 0;

const $8282e08bfb18d5fc$var$sdpTransform = $8282e08bfb18d5fc$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

const $8282e08bfb18d5fc$var$utils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("lghrF")));

const $8282e08bfb18d5fc$var$ortc = $8282e08bfb18d5fc$var$__importStar((parcelRequire("5Mq2W")));

const $8282e08bfb18d5fc$var$sdpCommonUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("a2dIr")));

const $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("ghGMB")));

const $8282e08bfb18d5fc$var$ortcUtils = $8282e08bfb18d5fc$var$__importStar((parcelRequire("eoJVX")));

var $roix3 = parcelRequire("roix3");

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");

var $2VyLC = parcelRequire("2VyLC");
const $8282e08bfb18d5fc$var$logger = new $24uNv.Logger("ReactNativeUnifiedPlan");
const $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan();
    }
    get name() {
        return "ReactNativeUnifiedPlan";
    }
    close() {
        $8282e08bfb18d5fc$var$logger.debug("close()");
        if (this._closed) return;
        this._closed = true;
        // Free/dispose native MediaStream but DO NOT free/dispose native
        // MediaStreamTracks (that is parent's business).
        // @ts-ignore (proprietary API in react-native-webrtc).
        this._sendStream.release(/* releaseTracks */ false);
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $8282e08bfb18d5fc$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan"
        });
        try {
            pc.addTransceiver("audio");
            pc.addTransceiver("video");
            const offer = await pc.createOffer();
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $8282e08bfb18d5fc$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            // libwebrtc supports NACK for OPUS but doesn't announce it.
            $8282e08bfb18d5fc$var$ortcUtils.addNackSuppportForOpus(nativeRtpCapabilities);
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $8282e08bfb18d5fc$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters
        });
        this._sendingRtpParametersByKind = {
            audio: $8282e08bfb18d5fc$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $8282e08bfb18d5fc$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $8282e08bfb18d5fc$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $8282e08bfb18d5fc$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "unified-plan",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $8282e08bfb18d5fc$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        this.assertNotClosed();
        $8282e08bfb18d5fc$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $8282e08bfb18d5fc$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        this.assertNotClosed();
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec, onRtpSender: onRtpSender }) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (encodings && encodings.length > 1) encodings.forEach((encoding, idx)=>{
            encoding.rid = `r${idx}`;
        });
        const sendingRtpParameters = $8282e08bfb18d5fc$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRtpParameters.codecs = $8282e08bfb18d5fc$var$ortc.reduceCodecs(sendingRtpParameters.codecs, codec);
        const sendingRemoteRtpParameters = $8282e08bfb18d5fc$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        // This may throw.
        sendingRemoteRtpParameters.codecs = $8282e08bfb18d5fc$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs, codec);
        const mediaSectionIdx = this._remoteSdp.getNextMediaSectionIdx();
        const transceiver = this._pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                this._sendStream
            ],
            sendEncodings: encodings
        });
        if (onRtpSender) onRtpSender(transceiver.sender);
        let offer = await this._pc.createOffer();
        let localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        // Special case for VP9 with SVC.
        let hackVp9Svc = false;
        const layers = (0, $2VyLC.parse)((encodings || [
            {}
        ])[0].scalabilityMode);
        if (encodings && encodings.length === 1 && layers.spatialLayers > 1 && sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp9") {
            $8282e08bfb18d5fc$var$logger.debug("send() | enabling legacy simulcast for VP9 SVC");
            hackVp9Svc = true;
            localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
            $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                numStreams: layers.spatialLayers
            });
            offer = {
                type: "offer",
                sdp: $8282e08bfb18d5fc$var$sdpTransform.write(localSdpObject)
            };
        }
        $8282e08bfb18d5fc$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        var _transceiver_mid;
        // We can now get the transceiver.mid.
        // NOTE: We cannot read generated MID on iOS react-native-webrtc 111.0.0
        // because transceiver.mid is not available until setRemoteDescription()
        // is called, so this is best effort.
        // Issue: https://github.com/react-native-webrtc/react-native-webrtc/issues/1404
        // NOTE: So let's fill MID in sendingRtpParameters later.
        // NOTE: This is fixed in react-native-webrtc 111.0.3.
        let localId = (_transceiver_mid = transceiver.mid) !== null && _transceiver_mid !== void 0 ? _transceiver_mid : undefined;
        if (!localId) $8282e08bfb18d5fc$var$logger.warn("send() | missing transceiver.mid (bug in react-native-webrtc, using a workaround");
        // Set MID.
        // NOTE: As per above, it could be unset yet.
        sendingRtpParameters.mid = localId;
        localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media[mediaSectionIdx.idx];
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $8282e08bfb18d5fc$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings by parsing the SDP offer if no encodings are given.
        if (!encodings) sendingRtpParameters.encodings = $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject
        });
        else if (encodings.length === 1) {
            let newEncodings = $8282e08bfb18d5fc$var$sdpUnifiedPlanUtils.getRtpEncodings({
                offerMediaObject: offerMediaObject
            });
            Object.assign(newEncodings[0], encodings[0]);
            // Hack for VP9 SVC.
            if (hackVp9Svc) newEncodings = [
                newEncodings[0]
            ];
            sendingRtpParameters.encodings = newEncodings;
        } else sendingRtpParameters.encodings = encodings;
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) {
            for (const encoding of sendingRtpParameters.encodings)if (encoding.scalabilityMode) encoding.scalabilityMode = `L1T${layers.temporalLayers}`;
            else encoding.scalabilityMode = "L1T3";
        }
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            reuseMid: mediaSectionIdx.reuseMid,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions,
            extmapAllowMixed: true
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        // Follow up of iOS react-native-webrtc 111.0.0 issue told above. Now yes,
        // we can read generated MID (if not done above) and fill sendingRtpParameters.
        // NOTE: This is fixed in react-native-webrtc 111.0.3 so this block isn't
        // needed starting from that version.
        if (!localId) {
            localId = transceiver.mid;
            sendingRtpParameters.mid = localId;
        }
        // Store in the map.
        this._mapMidTransceiver.set(localId, transceiver);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters,
            rtpSender: transceiver.sender
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        if (this._closed) return;
        $8282e08bfb18d5fc$var$logger.debug("stopSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.sender.replaceTrack(null);
        this._pc.removeTrack(transceiver.sender);
        const mediaSectionClosed = this._remoteSdp.closeMediaSection(transceiver.mid);
        if (mediaSectionClosed) try {
            transceiver.stop();
        } catch (error) {}
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        this._mapMidTransceiver.delete(localId);
    }
    async pauseSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "inactive";
        this._remoteSdp.pauseMediaSection(localId);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("pauseSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async resumeSending(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() [localId:%s]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        this._remoteSdp.resumeSendingMediaSection(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        transceiver.direction = "sendonly";
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("resumeSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async replaceTrack(localId, track) {
        this.assertNotClosed();
        this.assertSendDirection();
        if (track) $8282e08bfb18d5fc$var$logger.debug("replaceTrack() [localId:%s, track.id:%s]", localId, track.id);
        else $8282e08bfb18d5fc$var$logger.debug("replaceTrack() [localId:%s, no track]", localId);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        await transceiver.sender.replaceTrack(track);
    }
    async setMaxSpatialLayer(localId, spatialLayer) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() [localId:%s, spatialLayer:%s]", localId, spatialLayer);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            if (idx <= spatialLayer) encoding.active = true;
            else encoding.active = false;
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("setMaxSpatialLayer() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async setRtpEncodingParameters(localId, params) {
        this.assertNotClosed();
        this.assertSendDirection();
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() [localId:%s, params:%o]", localId, params);
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        const parameters = transceiver.sender.getParameters();
        parameters.encodings.forEach((encoding, idx)=>{
            parameters.encodings[idx] = {
                ...encoding,
                ...params
            };
        });
        await transceiver.sender.setParameters(parameters);
        this._remoteSdp.muxMediaSectionSimulcast(localId, parameters.encodings);
        const offer = await this._pc.createOffer();
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("setRtpEncodingParameters() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    async getSenderStats(localId) {
        this.assertNotClosed();
        this.assertSendDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.sender.getStats();
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $8282e08bfb18d5fc$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const results = [];
        const mapLocalId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters, streamId: streamId } = options;
            $8282e08bfb18d5fc$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const localId = rtpParameters.mid || String(this._mapMidTransceiver.size);
            mapLocalId.set(trackId, localId);
            this._remoteSdp.receive({
                mid: localId,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId || rtpParameters.rtcp.cname,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        for (const options of optionsList){
            const { trackId: trackId, onRtpReceiver: onRtpReceiver } = options;
            if (onRtpReceiver) {
                const localId = mapLocalId.get(trackId);
                const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
                if (!transceiver) throw new Error("transceiver not found");
                onRtpReceiver(transceiver.receiver);
            }
        }
        let answer = await this._pc.createAnswer();
        const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = mapLocalId.get(trackId);
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === localId);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $8282e08bfb18d5fc$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $8282e08bfb18d5fc$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $8282e08bfb18d5fc$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { trackId: trackId } = options;
            const localId = mapLocalId.get(trackId);
            const transceiver = this._pc.getTransceivers().find((t)=>t.mid === localId);
            if (!transceiver) throw new Error("new RTCRtpTransceiver not found");
            else {
                // Store in the map.
                this._mapMidTransceiver.set(localId, transceiver);
                results.push({
                    localId: localId,
                    track: transceiver.receiver.track,
                    rtpReceiver: transceiver.receiver
                });
            }
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        if (this._closed) return;
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            this._remoteSdp.closeMediaSection(transceiver.mid);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const localId of localIds)this._mapMidTransceiver.delete(localId);
    }
    async pauseReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "inactive";
            this._remoteSdp.pauseMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("pauseReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async resumeReceiving(localIds) {
        this.assertNotClosed();
        this.assertRecvDirection();
        for (const localId of localIds){
            $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() [localId:%s]", localId);
            const transceiver = this._mapMidTransceiver.get(localId);
            if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
            transceiver.direction = "recvonly";
            this._remoteSdp.resumeReceivingMediaSection(localId);
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $8282e08bfb18d5fc$var$logger.debug("resumeReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async getReceiverStats(localId) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const transceiver = this._mapMidTransceiver.get(localId);
        if (!transceiver) throw new Error("associated RTCRtpTransceiver not found");
        return transceiver.receiver.getStats();
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertNotClosed();
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation();
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $8282e08bfb18d5fc$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $8282e08bfb18d5fc$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $8282e08bfb18d5fc$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertNotClosed() {
        if (this._closed) throw new $roix3.InvalidStateError("method called in a closed handler");
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Closed flag.
        this._closed = false;
        // Map of RTCTransceivers indexed by MID.
        this._mapMidTransceiver = new Map();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.ReactNativeUnifiedPlan = $8282e08bfb18d5fc$var$ReactNativeUnifiedPlan;

});

parcelRegister("5GCJE", function(module, exports) {
"use strict";
var $423eec07d95d6603$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $423eec07d95d6603$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $423eec07d95d6603$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $423eec07d95d6603$var$__createBinding(result, mod, k);
    }
    $423eec07d95d6603$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactNative = void 0;

const $423eec07d95d6603$var$sdpTransform = $423eec07d95d6603$var$__importStar((parcelRequire("8j7qr")));

var $24uNv = parcelRequire("24uNv");

var $roix3 = parcelRequire("roix3");

const $423eec07d95d6603$var$utils = $423eec07d95d6603$var$__importStar((parcelRequire("lghrF")));

const $423eec07d95d6603$var$ortc = $423eec07d95d6603$var$__importStar((parcelRequire("5Mq2W")));

const $423eec07d95d6603$var$sdpCommonUtils = $423eec07d95d6603$var$__importStar((parcelRequire("a2dIr")));

const $423eec07d95d6603$var$sdpPlanBUtils = $423eec07d95d6603$var$__importStar((parcelRequire("gWHYI")));

var $2ptPl = parcelRequire("2ptPl");

var $bqKhs = parcelRequire("bqKhs");
const $423eec07d95d6603$var$logger = new $24uNv.Logger("ReactNative");
const $423eec07d95d6603$var$SCTP_NUM_STREAMS = {
    OS: 1024,
    MIS: 1024
};
class $423eec07d95d6603$var$ReactNative extends $2ptPl.HandlerInterface {
    /**
     * Creates a factory function.
     */ static createFactory() {
        return ()=>new $423eec07d95d6603$var$ReactNative();
    }
    get name() {
        return "ReactNative";
    }
    close() {
        $423eec07d95d6603$var$logger.debug("close()");
        // Free/dispose native MediaStream but DO NOT free/dispose native
        // MediaStreamTracks (that is parent's business).
        // @ts-ignore (proprietary API in react-native-webrtc).
        this._sendStream.release(/* releaseTracks */ false);
        // Close RTCPeerConnection.
        if (this._pc) try {
            this._pc.close();
        } catch (error) {}
        this.emit("@close");
    }
    async getNativeRtpCapabilities() {
        $423eec07d95d6603$var$logger.debug("getNativeRtpCapabilities()");
        const pc = new RTCPeerConnection({
            iceServers: [],
            iceTransportPolicy: "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b"
        });
        try {
            const offer = await pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            });
            try {
                pc.close();
            } catch (error) {}
            const sdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            const nativeRtpCapabilities = $423eec07d95d6603$var$sdpCommonUtils.extractRtpCapabilities({
                sdpObject: sdpObject
            });
            return nativeRtpCapabilities;
        } catch (error) {
            try {
                pc.close();
            } catch (error2) {}
            throw error;
        }
    }
    async getNativeSctpCapabilities() {
        $423eec07d95d6603$var$logger.debug("getNativeSctpCapabilities()");
        return {
            numStreams: $423eec07d95d6603$var$SCTP_NUM_STREAMS
        };
    }
    run({ direction: direction, iceParameters: iceParameters, iceCandidates: iceCandidates, dtlsParameters: dtlsParameters, sctpParameters: sctpParameters, iceServers: iceServers, iceTransportPolicy: iceTransportPolicy, additionalSettings: additionalSettings, proprietaryConstraints: proprietaryConstraints, extendedRtpCapabilities: extendedRtpCapabilities }) {
        $423eec07d95d6603$var$logger.debug("run()");
        this._direction = direction;
        this._remoteSdp = new $bqKhs.RemoteSdp({
            iceParameters: iceParameters,
            iceCandidates: iceCandidates,
            dtlsParameters: dtlsParameters,
            sctpParameters: sctpParameters,
            planB: true
        });
        this._sendingRtpParametersByKind = {
            audio: $423eec07d95d6603$var$ortc.getSendingRtpParameters("audio", extendedRtpCapabilities),
            video: $423eec07d95d6603$var$ortc.getSendingRtpParameters("video", extendedRtpCapabilities)
        };
        this._sendingRemoteRtpParametersByKind = {
            audio: $423eec07d95d6603$var$ortc.getSendingRemoteRtpParameters("audio", extendedRtpCapabilities),
            video: $423eec07d95d6603$var$ortc.getSendingRemoteRtpParameters("video", extendedRtpCapabilities)
        };
        if (dtlsParameters.role && dtlsParameters.role !== "auto") this._forcedLocalDtlsRole = dtlsParameters.role === "server" ? "client" : "server";
        this._pc = new RTCPeerConnection({
            iceServers: iceServers || [],
            iceTransportPolicy: iceTransportPolicy || "all",
            bundlePolicy: "max-bundle",
            rtcpMuxPolicy: "require",
            sdpSemantics: "plan-b",
            ...additionalSettings
        }, proprietaryConstraints);
        this._pc.addEventListener("icegatheringstatechange", ()=>{
            this.emit("@icegatheringstatechange", this._pc.iceGatheringState);
        });
        if (this._pc.connectionState) this._pc.addEventListener("connectionstatechange", ()=>{
            this.emit("@connectionstatechange", this._pc.connectionState);
        });
        else this._pc.addEventListener("iceconnectionstatechange", ()=>{
            $423eec07d95d6603$var$logger.warn("run() | pc.connectionState not supported, using pc.iceConnectionState");
            switch(this._pc.iceConnectionState){
                case "checking":
                    this.emit("@connectionstatechange", "connecting");
                    break;
                case "connected":
                case "completed":
                    this.emit("@connectionstatechange", "connected");
                    break;
                case "failed":
                    this.emit("@connectionstatechange", "failed");
                    break;
                case "disconnected":
                    this.emit("@connectionstatechange", "disconnected");
                    break;
                case "closed":
                    this.emit("@connectionstatechange", "closed");
                    break;
            }
        });
    }
    async updateIceServers(iceServers) {
        $423eec07d95d6603$var$logger.debug("updateIceServers()");
        const configuration = this._pc.getConfiguration();
        configuration.iceServers = iceServers;
        this._pc.setConfiguration(configuration);
    }
    async restartIce(iceParameters) {
        $423eec07d95d6603$var$logger.debug("restartIce()");
        // Provide the remote SDP handler with new remote ICE parameters.
        this._remoteSdp.updateIceParameters(iceParameters);
        if (!this._transportReady) return;
        if (this._direction === "send") {
            const offer = await this._pc.createOffer({
                iceRestart: true
            });
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
        } else {
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            $423eec07d95d6603$var$logger.debug("restartIce() | calling pc.setLocalDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
        }
    }
    async getTransportStats() {
        return this._pc.getStats();
    }
    async send({ track: track, encodings: encodings, codecOptions: codecOptions, codec: codec }) {
        this.assertSendDirection();
        $423eec07d95d6603$var$logger.debug("send() [kind:%s, track.id:%s]", track.kind, track.id);
        if (codec) $423eec07d95d6603$var$logger.warn("send() | codec selection is not available in %s handler", this.name);
        this._sendStream.addTrack(track);
        this._pc.addStream(this._sendStream);
        let offer = await this._pc.createOffer();
        let localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
        let offerMediaObject;
        const sendingRtpParameters = $423eec07d95d6603$var$utils.clone(this._sendingRtpParametersByKind[track.kind]);
        sendingRtpParameters.codecs = $423eec07d95d6603$var$ortc.reduceCodecs(sendingRtpParameters.codecs);
        const sendingRemoteRtpParameters = $423eec07d95d6603$var$utils.clone(this._sendingRemoteRtpParametersByKind[track.kind]);
        sendingRemoteRtpParameters.codecs = $423eec07d95d6603$var$ortc.reduceCodecs(sendingRemoteRtpParameters.codecs);
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        if (track.kind === "video" && encodings && encodings.length > 1) {
            $423eec07d95d6603$var$logger.debug("send() | enabling simulcast");
            localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            offerMediaObject = localSdpObject.media.find((m)=>m.type === "video");
            $423eec07d95d6603$var$sdpPlanBUtils.addLegacySimulcast({
                offerMediaObject: offerMediaObject,
                track: track,
                numStreams: encodings.length
            });
            offer = {
                type: "offer",
                sdp: $423eec07d95d6603$var$sdpTransform.write(localSdpObject)
            };
        }
        $423eec07d95d6603$var$logger.debug("send() | calling pc.setLocalDescription() [offer:%o]", offer);
        await this._pc.setLocalDescription(offer);
        localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(this._pc.localDescription.sdp);
        offerMediaObject = localSdpObject.media.find((m)=>m.type === track.kind);
        // Set RTCP CNAME.
        sendingRtpParameters.rtcp.cname = $423eec07d95d6603$var$sdpCommonUtils.getCname({
            offerMediaObject: offerMediaObject
        });
        // Set RTP encodings.
        sendingRtpParameters.encodings = $423eec07d95d6603$var$sdpPlanBUtils.getRtpEncodings({
            offerMediaObject: offerMediaObject,
            track: track
        });
        // Complete encodings with given values.
        if (encodings) {
            for(let idx = 0; idx < sendingRtpParameters.encodings.length; ++idx)if (encodings[idx]) Object.assign(sendingRtpParameters.encodings[idx], encodings[idx]);
        }
        // If VP8 or H264 and there is effective simulcast, add scalabilityMode to
        // each encoding.
        if (sendingRtpParameters.encodings.length > 1 && (sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/vp8" || sendingRtpParameters.codecs[0].mimeType.toLowerCase() === "video/h264")) for (const encoding of sendingRtpParameters.encodings)encoding.scalabilityMode = "L1T3";
        this._remoteSdp.send({
            offerMediaObject: offerMediaObject,
            offerRtpParameters: sendingRtpParameters,
            answerRtpParameters: sendingRemoteRtpParameters,
            codecOptions: codecOptions
        });
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("send() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
        const localId = String(this._nextSendLocalId);
        this._nextSendLocalId++;
        // Insert into the map.
        this._mapSendLocalIdTrack.set(localId, track);
        return {
            localId: localId,
            rtpParameters: sendingRtpParameters
        };
    }
    async stopSending(localId) {
        this.assertSendDirection();
        $423eec07d95d6603$var$logger.debug("stopSending() [localId:%s]", localId);
        const track = this._mapSendLocalIdTrack.get(localId);
        if (!track) throw new Error("track not found");
        this._mapSendLocalIdTrack.delete(localId);
        this._sendStream.removeTrack(track);
        this._pc.addStream(this._sendStream);
        const offer = await this._pc.createOffer();
        $423eec07d95d6603$var$logger.debug("stopSending() | calling pc.setLocalDescription() [offer:%o]", offer);
        try {
            await this._pc.setLocalDescription(offer);
        } catch (error) {
            // NOTE: If there are no sending tracks, setLocalDescription() will fail with
            // "Failed to create channels". If so, ignore it.
            if (this._sendStream.getTracks().length === 0) {
                $423eec07d95d6603$var$logger.warn("stopSending() | ignoring expected error due no sending tracks: %s", error.toString());
                return;
            }
            throw error;
        }
        if (this._pc.signalingState === "stable") return;
        const answer = {
            type: "answer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("stopSending() | calling pc.setRemoteDescription() [answer:%o]", answer);
        await this._pc.setRemoteDescription(answer);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async pauseSending(localId) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async resumeSending(localId) {
    // Unimplemented.
    }
    async replaceTrack(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    track) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async setMaxSpatialLayer(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    spatialLayer) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setRtpEncodingParameters(localId, params) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getSenderStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async sendDataChannel({ ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits, label: label, protocol: protocol }) {
        this.assertSendDirection();
        const options = {
            negotiated: true,
            id: this._nextSendSctpStreamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $423eec07d95d6603$var$logger.debug("sendDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // Increase next id.
        this._nextSendSctpStreamId = ++this._nextSendSctpStreamId % $423eec07d95d6603$var$SCTP_NUM_STREAMS.MIS;
        // If this is the first DataChannel we need to create the SDP answer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            const offer = await this._pc.createOffer();
            const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(offer.sdp);
            const offerMediaObject = localSdpObject.media.find((m)=>m.type === "application");
            var _this__forcedLocalDtlsRole;
            if (!this._transportReady) await this.setupTransport({
                localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                localSdpObject: localSdpObject
            });
            $423eec07d95d6603$var$logger.debug("sendDataChannel() | calling pc.setLocalDescription() [offer:%o]", offer);
            await this._pc.setLocalDescription(offer);
            this._remoteSdp.sendSctpAssociation({
                offerMediaObject: offerMediaObject
            });
            const answer = {
                type: "answer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("sendDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setRemoteDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        const sctpStreamParameters = {
            streamId: options.id,
            ordered: options.ordered,
            maxPacketLifeTime: options.maxPacketLifeTime,
            maxRetransmits: options.maxRetransmits
        };
        return {
            dataChannel: dataChannel,
            sctpStreamParameters: sctpStreamParameters
        };
    }
    async receive(optionsList) {
        this.assertRecvDirection();
        const results = [];
        const mapStreamId = new Map();
        for (const options of optionsList){
            const { trackId: trackId, kind: kind, rtpParameters: rtpParameters } = options;
            $423eec07d95d6603$var$logger.debug("receive() [trackId:%s, kind:%s]", trackId, kind);
            const mid = kind;
            let streamId = options.streamId || rtpParameters.rtcp.cname;
            // NOTE: In React-Native we cannot reuse the same remote MediaStream for new
            // remote tracks. This is because react-native-webrtc does not react on new
            // tracks generated within already existing streams, so force the streamId
            // to be different. See:
            // https://github.com/react-native-webrtc/react-native-webrtc/issues/401
            $423eec07d95d6603$var$logger.debug("receive() | forcing a random remote streamId to avoid well known bug in react-native-webrtc");
            streamId += `-hack-${$423eec07d95d6603$var$utils.generateRandomNumber()}`;
            mapStreamId.set(trackId, streamId);
            this._remoteSdp.receive({
                mid: mid,
                kind: kind,
                offerRtpParameters: rtpParameters,
                streamId: streamId,
                trackId: trackId
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("receive() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        let answer = await this._pc.createAnswer();
        const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(answer.sdp);
        for (const options of optionsList){
            const { kind: kind, rtpParameters: rtpParameters } = options;
            const mid = kind;
            const answerMediaObject = localSdpObject.media.find((m)=>String(m.mid) === mid);
            // May need to modify codec parameters in the answer based on codec
            // parameters in the offer.
            $423eec07d95d6603$var$sdpCommonUtils.applyCodecParameters({
                offerRtpParameters: rtpParameters,
                answerMediaObject: answerMediaObject
            });
        }
        answer = {
            type: "answer",
            sdp: $423eec07d95d6603$var$sdpTransform.write(localSdpObject)
        };
        var _this__forcedLocalDtlsRole;
        if (!this._transportReady) await this.setupTransport({
            localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
            localSdpObject: localSdpObject
        });
        $423eec07d95d6603$var$logger.debug("receive() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
        for (const options of optionsList){
            const { kind: kind, trackId: trackId, rtpParameters: rtpParameters } = options;
            const localId = trackId;
            const mid = kind;
            const streamId = mapStreamId.get(trackId);
            const stream = this._pc.getRemoteStreams().find((s)=>s.id === streamId);
            const track = stream.getTrackById(localId);
            if (!track) throw new Error("remote track not found");
            // Insert into the map.
            this._mapRecvLocalIdInfo.set(localId, {
                mid: mid,
                rtpParameters: rtpParameters
            });
            results.push({
                localId: localId,
                track: track
            });
        }
        return results;
    }
    async stopReceiving(localIds) {
        this.assertRecvDirection();
        for (const localId of localIds){
            $423eec07d95d6603$var$logger.debug("stopReceiving() [localId:%s]", localId);
            const { mid: mid, rtpParameters: rtpParameters } = this._mapRecvLocalIdInfo.get(localId) || {};
            // Remove from the map.
            this._mapRecvLocalIdInfo.delete(localId);
            this._remoteSdp.planBStopReceiving({
                mid: mid,
                offerRtpParameters: rtpParameters
            });
        }
        const offer = {
            type: "offer",
            sdp: this._remoteSdp.getSdp()
        };
        $423eec07d95d6603$var$logger.debug("stopReceiving() | calling pc.setRemoteDescription() [offer:%o]", offer);
        await this._pc.setRemoteDescription(offer);
        const answer = await this._pc.createAnswer();
        $423eec07d95d6603$var$logger.debug("stopReceiving() | calling pc.setLocalDescription() [answer:%o]", answer);
        await this._pc.setLocalDescription(answer);
    }
    async pauseReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    async resumeReceiving(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    localIds) {
    // Unimplemented.
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getReceiverStats(localId) {
        throw new $roix3.UnsupportedError("not implemented");
    }
    async receiveDataChannel({ sctpStreamParameters: sctpStreamParameters, label: label, protocol: protocol }) {
        this.assertRecvDirection();
        const { streamId: streamId, ordered: ordered, maxPacketLifeTime: maxPacketLifeTime, maxRetransmits: maxRetransmits } = sctpStreamParameters;
        const options = {
            negotiated: true,
            id: streamId,
            ordered: ordered,
            maxPacketLifeTime: maxPacketLifeTime,
            maxRetransmitTime: maxPacketLifeTime,
            maxRetransmits: maxRetransmits,
            protocol: protocol
        };
        $423eec07d95d6603$var$logger.debug("receiveDataChannel() [options:%o]", options);
        const dataChannel = this._pc.createDataChannel(label, options);
        // If this is the first DataChannel we need to create the SDP offer with
        // m=application section.
        if (!this._hasDataChannelMediaSection) {
            this._remoteSdp.receiveSctpAssociation({
                oldDataChannelSpec: true
            });
            const offer = {
                type: "offer",
                sdp: this._remoteSdp.getSdp()
            };
            $423eec07d95d6603$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [offer:%o]", offer);
            await this._pc.setRemoteDescription(offer);
            const answer = await this._pc.createAnswer();
            if (!this._transportReady) {
                const localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(answer.sdp);
                var _this__forcedLocalDtlsRole;
                await this.setupTransport({
                    localDtlsRole: (_this__forcedLocalDtlsRole = this._forcedLocalDtlsRole) !== null && _this__forcedLocalDtlsRole !== void 0 ? _this__forcedLocalDtlsRole : "client",
                    localSdpObject: localSdpObject
                });
            }
            $423eec07d95d6603$var$logger.debug("receiveDataChannel() | calling pc.setRemoteDescription() [answer:%o]", answer);
            await this._pc.setLocalDescription(answer);
            this._hasDataChannelMediaSection = true;
        }
        return {
            dataChannel: dataChannel
        };
    }
    async setupTransport({ localDtlsRole: localDtlsRole, localSdpObject: localSdpObject }) {
        if (!localSdpObject) localSdpObject = $423eec07d95d6603$var$sdpTransform.parse(this._pc.localDescription.sdp);
        // Get our local DTLS parameters.
        const dtlsParameters = $423eec07d95d6603$var$sdpCommonUtils.extractDtlsParameters({
            sdpObject: localSdpObject
        });
        // Set our DTLS role.
        dtlsParameters.role = localDtlsRole;
        // Update the remote DTLS role in the SDP.
        this._remoteSdp.updateDtlsRole(localDtlsRole === "client" ? "server" : "client");
        // Need to tell the remote transport about our parameters.
        await new Promise((resolve, reject)=>{
            this.safeEmit("@connect", {
                dtlsParameters: dtlsParameters
            }, resolve, reject);
        });
        this._transportReady = true;
    }
    assertSendDirection() {
        if (this._direction !== "send") throw new Error('method can just be called for handlers with "send" direction');
    }
    assertRecvDirection() {
        if (this._direction !== "recv") throw new Error('method can just be called for handlers with "recv" direction');
    }
    constructor(){
        super();
        // Local stream for sending.
        this._sendStream = new MediaStream();
        // Map of sending MediaStreamTracks indexed by localId.
        this._mapSendLocalIdTrack = new Map();
        // Next sending localId.
        this._nextSendLocalId = 0;
        // Map of MID, RTP parameters and RTCRtpReceiver indexed by local id.
        // Value is an Object with mid, rtpParameters and rtpReceiver.
        this._mapRecvLocalIdInfo = new Map();
        // Whether a DataChannel m=application section has been created.
        this._hasDataChannelMediaSection = false;
        // Sending DataChannel id value counter. Incremented for each new DataChannel.
        this._nextSendSctpStreamId = 0;
        // Got transport local and remote parameters.
        this._transportReady = false;
    }
}
module.exports.ReactNative = $423eec07d95d6603$var$ReactNative;

});


parcelRegister("5Mrx3", function(module, exports) {
"use strict";
var $4356cabd4d4b59f8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4356cabd4d4b59f8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4356cabd4d4b59f8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("46xMb")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("7Whb6")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("ckNpk")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("kYlAk")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("7caxm")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("9SUdt")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("5AoGB")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("cMUWc")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("2ptPl")), module.exports);

$4356cabd4d4b59f8$var$__exportStar((parcelRequire("roix3")), module.exports);

});
parcelRegister("5AoGB", function(module, exports) {
"use strict";
/**
 * The RTP capabilities define what mediasoup or an endpoint can receive at
 * media level.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cMUWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("23jSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isCorrect = module.exports.isInSubnet = void 0;
function $17eb48748986953c$var$isInSubnet(address) {
    if (this.subnetMask < address.subnetMask) return false;
    if (this.mask(address.subnetMask) === address.mask()) return true;
    return false;
}
module.exports.isInSubnet = $17eb48748986953c$var$isInSubnet;
function $17eb48748986953c$var$isCorrect(defaultBits) {
    return function() {
        if (this.addressMinusSuffix !== this.correctForm()) return false;
        if (this.subnetMask === defaultBits && !this.parsedSubnet) return true;
        return this.parsedSubnet === String(this.subnetMask);
    };
}
module.exports.isCorrect = $17eb48748986953c$var$isCorrect;

});

parcelRegister("i0ccS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_SUBNET_STRING = module.exports.RE_ADDRESS = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 32;
module.exports.GROUPS = 4;
module.exports.RE_ADDRESS = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
module.exports.RE_SUBNET_STRING = /\/\d{1,2}$/;

});

parcelRegister("cqjLs", function(module, exports) {
(function() {
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (inBrowser && j_lm && navigator.appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Random number generator - requires a PRNG backend, e.g. prng4.js
    // For best results, put code like
    // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
    // in your main HTML document.
    var rng_state;
    var rng_pool;
    var rng_pptr;
    // Mix in a 32-bit integer into the pool
    function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= x >> 8 & 255;
        rng_pool[rng_pptr++] ^= x >> 16 & 255;
        rng_pool[rng_pptr++] ^= x >> 24 & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
    }
    // Mix in the current time (w/milliseconds) into the pool
    function rng_seed_time() {
        rng_seed_int(new Date().getTime());
    }
    // Initialize the pool with junk if needed.
    if (rng_pool == null) {
        rng_pool = new Array();
        rng_pptr = 0;
        var t;
        if (typeof window !== "undefined" && window.crypto) {
            if (window.crypto.getRandomValues) {
                // Use webcrypto if available
                var ua = new Uint8Array(32);
                window.crypto.getRandomValues(ua);
                for(t = 0; t < 32; ++t)rng_pool[rng_pptr++] = ua[t];
            } else if (navigator.appName == "Netscape" && navigator.appVersion < "5") {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
        }
        while(rng_pptr < rng_psize){
            t = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = t >>> 8;
            rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
    //rng_seed_int(window.screenX);
    //rng_seed_int(window.screenY);
    }
    function rng_get_byte() {
        if (rng_state == null) {
            rng_seed_time();
            rng_state = prng_newstate();
            rng_state.init(rng_pool);
            for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)rng_pool[rng_pptr] = 0;
            rng_pptr = 0;
        //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
    }
    function rng_get_bytes(ba) {
        var i;
        for(i = 0; i < ba.length; ++i)ba[i] = rng_get_byte();
    }
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = rng_get_bytes;
    // prng4.js - uses Arcfour as a PRNG
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = new Array();
    }
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    function ARC4init(key) {
        var i, j, t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    }
    function ARC4next() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    }
    Arcfour.prototype.init = ARC4init;
    Arcfour.prototype.next = ARC4next;
    // Plug in your RNG constructor here
    function prng_newstate() {
        return new Arcfour();
    }
    // Pool size must be a multiple of 4 and greater than 32.
    // An array of bytes the size of the pool will be passed to init()
    var rng_psize = 256;
    exports = module.exports = {
        default: BigInteger,
        BigInteger: BigInteger,
        SecureRandom: SecureRandom
    };
}).call(this);

});

parcelRegister("oXAYb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_URL_WITH_PORT = module.exports.RE_URL = module.exports.RE_ZONE_STRING = module.exports.RE_SUBNET_STRING = module.exports.RE_BAD_ADDRESS = module.exports.RE_BAD_CHARACTERS = module.exports.TYPES = module.exports.SCOPES = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 128;
module.exports.GROUPS = 8;
/**
 * Represents IPv6 address scopes
 * @memberof Address6
 * @static
 */ module.exports.SCOPES = {
    0: "Reserved",
    1: "Interface local",
    2: "Link local",
    4: "Admin local",
    5: "Site local",
    8: "Organization local",
    14: "Global",
    15: "Reserved"
};
/**
 * Represents IPv6 address types
 * @memberof Address6
 * @static
 */ module.exports.TYPES = {
    "ff01::1/128": "Multicast (All nodes on this interface)",
    "ff01::2/128": "Multicast (All routers on this interface)",
    "ff02::1/128": "Multicast (All nodes on this link)",
    "ff02::2/128": "Multicast (All routers on this link)",
    "ff05::2/128": "Multicast (All routers in this site)",
    "ff02::5/128": "Multicast (OSPFv3 AllSPF routers)",
    "ff02::6/128": "Multicast (OSPFv3 AllDR routers)",
    "ff02::9/128": "Multicast (RIP routers)",
    "ff02::a/128": "Multicast (EIGRP routers)",
    "ff02::d/128": "Multicast (PIM routers)",
    "ff02::16/128": "Multicast (MLDv2 reports)",
    "ff01::fb/128": "Multicast (mDNSv6)",
    "ff02::fb/128": "Multicast (mDNSv6)",
    "ff05::fb/128": "Multicast (mDNSv6)",
    "ff02::1:2/128": "Multicast (All DHCP servers and relay agents on this link)",
    "ff05::1:2/128": "Multicast (All DHCP servers and relay agents in this site)",
    "ff02::1:3/128": "Multicast (All DHCP servers on this link)",
    "ff05::1:3/128": "Multicast (All DHCP servers in this site)",
    "::/128": "Unspecified",
    "::1/128": "Loopback",
    "ff00::/8": "Multicast",
    "fe80::/10": "Link-local unicast"
};
/**
 * A regular expression that matches bad characters in an IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_CHARACTERS = /([^0-9a-f:/%])/gi;
/**
 * A regular expression that matches an incorrect IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_ADDRESS = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/gi;
/**
 * A regular expression that matches an IPv6 subnet
 * @memberof Address6
 * @static
 */ module.exports.RE_SUBNET_STRING = /\/\d{1,3}(?=%|$)/;
/**
 * A regular expression that matches an IPv6 zone
 * @memberof Address6
 * @static
 */ module.exports.RE_ZONE_STRING = /%.*$/;
module.exports.RE_URL = new RegExp(/^\[{0,1}([0-9a-f:]+)\]{0,1}/);
module.exports.RE_URL_WITH_PORT = new RegExp(/\[([0-9a-f:]+)\]:([0-9]{1,5})/);

});

parcelRegister("1Q0Pv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleGroup = module.exports.spanLeadingZeroes = module.exports.spanAll = module.exports.spanAllZeroes = void 0;

var $krCXC = parcelRequire("krCXC");
/**
 * @returns {String} the string with all zeroes contained in a <span>
 */ function $156b4a8789e90775$var$spanAllZeroes(s) {
    return s.replace(/(0+)/g, '<span class="zero">$1</span>');
}
module.exports.spanAllZeroes = $156b4a8789e90775$var$spanAllZeroes;
/**
 * @returns {String} the string with each character contained in a <span>
 */ function $156b4a8789e90775$var$spanAll(s, offset = 0) {
    const letters = s.split("");
    return letters.map((n, i)=>(0, $krCXC.sprintf)('<span class="digit value-%s position-%d">%s</span>', n, i + offset, $156b4a8789e90775$var$spanAllZeroes(n)) // XXX Use #base-2 .value-0 instead?
    ).join("");
}
module.exports.spanAll = $156b4a8789e90775$var$spanAll;
function $156b4a8789e90775$var$spanLeadingZeroesSimple(group) {
    return group.replace(/^(0+)/, '<span class="zero">$1</span>');
}
/**
 * @returns {String} the string with leading zeroes contained in a <span>
 */ function $156b4a8789e90775$var$spanLeadingZeroes(address) {
    const groups = address.split(":");
    return groups.map((g)=>$156b4a8789e90775$var$spanLeadingZeroesSimple(g)).join(":");
}
module.exports.spanLeadingZeroes = $156b4a8789e90775$var$spanLeadingZeroes;
/**
 * Groups an address
 * @returns {String} a grouped address
 */ function $156b4a8789e90775$var$simpleGroup(addressString, offset = 0) {
    const groups = addressString.split(":");
    return groups.map((g, i)=>{
        if (/group-v4/.test(g)) return g;
        return (0, $krCXC.sprintf)('<span class="hover-group group-%d">%s</span>', i + offset, $156b4a8789e90775$var$spanLeadingZeroesSimple(g));
    });
}
module.exports.simpleGroup = $156b4a8789e90775$var$simpleGroup;

});
parcelRegister("krCXC", function(module, exports) {

$parcel$export(module.exports, "sprintf", function () { return $ee248d0b2aaa6262$export$63151d8bb18a49f9; }, function (v) { return $ee248d0b2aaa6262$export$63151d8bb18a49f9 = v; });
/* global window, exports, define */ var $ee248d0b2aaa6262$export$63151d8bb18a49f9;
var $ee248d0b2aaa6262$export$790fb69b1a2884f9;
!function() {
    "use strict";
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = "", i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === "string") output += parse_tree[i];
            else if (typeof parse_tree[i] === "object") {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== "number" && isNaN(arg)) throw new TypeError(sprintf("[sprintf] expecting number but found %T", arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case "b":
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case "c":
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case "d":
                    case "i":
                        arg = parseInt(arg, 10);
                        break;
                    case "j":
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case "e":
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case "f":
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case "g":
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case "o":
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case "s":
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "t":
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "T":
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "u":
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case "v":
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case "x":
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case "X":
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? "+" : "-";
                        arg = arg.toString().replace(re.sign, "");
                    } else sign = "";
                    pad_character = ph.pad_char ? ph.pad_char === "0" ? "0" : ph.pad_char.charAt(1) : " ";
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : "" : "";
                    output += ph.align ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push("%");
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ""){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                        }
                    } else throw new SyntaxError("[sprintf] failed to parse named argument key");
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError("[sprintf] unexpected placeholder");
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $ee248d0b2aaa6262$export$63151d8bb18a49f9 = sprintf;
    $ee248d0b2aaa6262$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== "undefined") {
        window["sprintf"] = sprintf;
        window["vsprintf"] = vsprintf;
        if (typeof define === "function" && define["amd"]) define(function() {
            return {
                "sprintf": sprintf,
                "vsprintf": vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

});


parcelRegister("1nZXs", function(module, exports) {
(function() {
    var expandIPv6, ipaddr, ipv4Part, ipv4Regexes, ipv6Part, ipv6Regexes, matchCIDR, root, zoneIndex;
    ipaddr = {};
    root = this;
    if (module !== null && module.exports) module.exports = ipaddr;
    else root["ipaddr"] = ipaddr;
    matchCIDR = function(first, second, partSize, cidrBits) {
        var part, shift;
        if (first.length !== second.length) throw new Error("ipaddr: cannot match CIDR for objects with different lengths");
        part = 0;
        while(cidrBits > 0){
            shift = partSize - cidrBits;
            if (shift < 0) shift = 0;
            if (first[part] >> shift !== second[part] >> shift) return false;
            cidrBits -= partSize;
            part += 1;
        }
        return true;
    };
    ipaddr.subnetMatch = function(address, rangeList, defaultName) {
        var k, len, rangeName, rangeSubnets, subnet;
        if (defaultName == null) defaultName = "unicast";
        for(rangeName in rangeList){
            rangeSubnets = rangeList[rangeName];
            if (rangeSubnets[0] && !(rangeSubnets[0] instanceof Array)) rangeSubnets = [
                rangeSubnets
            ];
            for(k = 0, len = rangeSubnets.length; k < len; k++){
                subnet = rangeSubnets[k];
                if (address.kind() === subnet[0].kind()) {
                    if (address.match.apply(address, subnet)) return rangeName;
                }
            }
        }
        return defaultName;
    };
    ipaddr.IPv4 = function() {
        function IPv4(octets) {
            var k, len, octet;
            if (octets.length !== 4) throw new Error("ipaddr: ipv4 octet count should be 4");
            for(k = 0, len = octets.length; k < len; k++){
                octet = octets[k];
                if (!(0 <= octet && octet <= 255)) throw new Error("ipaddr: ipv4 octet should fit in 8 bits");
            }
            this.octets = octets;
        }
        IPv4.prototype.kind = function() {
            return "ipv4";
        };
        IPv4.prototype.toString = function() {
            return this.octets.join(".");
        };
        IPv4.prototype.toNormalizedString = function() {
            return this.toString();
        };
        IPv4.prototype.toByteArray = function() {
            return this.octets.slice(0);
        };
        IPv4.prototype.match = function(other, cidrRange) {
            var ref;
            if (cidrRange === void 0) ref = other, other = ref[0], cidrRange = ref[1];
            if (other.kind() !== "ipv4") throw new Error("ipaddr: cannot match ipv4 address with non-ipv4 one");
            return matchCIDR(this.octets, other.octets, 8, cidrRange);
        };
        IPv4.prototype.SpecialRanges = {
            unspecified: [
                [
                    new IPv4([
                        0,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            broadcast: [
                [
                    new IPv4([
                        255,
                        255,
                        255,
                        255
                    ]),
                    32
                ]
            ],
            multicast: [
                [
                    new IPv4([
                        224,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ],
            linkLocal: [
                [
                    new IPv4([
                        169,
                        254,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            loopback: [
                [
                    new IPv4([
                        127,
                        0,
                        0,
                        0
                    ]),
                    8
                ]
            ],
            carrierGradeNat: [
                [
                    new IPv4([
                        100,
                        64,
                        0,
                        0
                    ]),
                    10
                ]
            ],
            "private": [
                [
                    new IPv4([
                        10,
                        0,
                        0,
                        0
                    ]),
                    8
                ],
                [
                    new IPv4([
                        172,
                        16,
                        0,
                        0
                    ]),
                    12
                ],
                [
                    new IPv4([
                        192,
                        168,
                        0,
                        0
                    ]),
                    16
                ]
            ],
            reserved: [
                [
                    new IPv4([
                        192,
                        0,
                        0,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        0,
                        2,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        192,
                        88,
                        99,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        198,
                        51,
                        100,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        203,
                        0,
                        113,
                        0
                    ]),
                    24
                ],
                [
                    new IPv4([
                        240,
                        0,
                        0,
                        0
                    ]),
                    4
                ]
            ]
        };
        IPv4.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        IPv4.prototype.toIPv4MappedAddress = function() {
            return ipaddr.IPv6.parse("::ffff:" + this.toString());
        };
        IPv4.prototype.prefixLengthFromSubnetMask = function() {
            var cidr, i, k, octet, stop, zeros, zerotable;
            zerotable = {
                0: 8,
                128: 7,
                192: 6,
                224: 5,
                240: 4,
                248: 3,
                252: 2,
                254: 1,
                255: 0
            };
            cidr = 0;
            stop = false;
            for(i = k = 3; k >= 0; i = k += -1){
                octet = this.octets[i];
                if (octet in zerotable) {
                    zeros = zerotable[octet];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 8) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 32 - cidr;
        };
        return IPv4;
    }();
    ipv4Part = "(0?\\d+|0x[a-f0-9]+)";
    ipv4Regexes = {
        fourOctet: new RegExp("^" + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "$", "i"),
        longValue: new RegExp("^" + ipv4Part + "$", "i")
    };
    ipaddr.IPv4.parser = function(string) {
        var match, parseIntAuto, part, shift, value;
        parseIntAuto = function(string) {
            if (string[0] === "0" && string[1] !== "x") return parseInt(string, 8);
            else return parseInt(string);
        };
        if (match = string.match(ipv4Regexes.fourOctet)) return function() {
            var k, len, ref, results;
            ref = match.slice(1, 6);
            results = [];
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                results.push(parseIntAuto(part));
            }
            return results;
        }();
        else if (match = string.match(ipv4Regexes.longValue)) {
            value = parseIntAuto(match[1]);
            if (value > 0xffffffff || value < 0) throw new Error("ipaddr: address outside defined range");
            return (function() {
                var k, results;
                results = [];
                for(shift = k = 0; k <= 24; shift = k += 8)results.push(value >> shift & 0xff);
                return results;
            })().reverse();
        } else return null;
    };
    ipaddr.IPv6 = function() {
        function IPv6(parts, zoneId) {
            var i, k, l, len, part, ref;
            if (parts.length === 16) {
                this.parts = [];
                for(i = k = 0; k <= 14; i = k += 2)this.parts.push(parts[i] << 8 | parts[i + 1]);
            } else if (parts.length === 8) this.parts = parts;
            else throw new Error("ipaddr: ipv6 part count should be 8 or 16");
            ref = this.parts;
            for(l = 0, len = ref.length; l < len; l++){
                part = ref[l];
                if (!(0 <= part && part <= 0xffff)) throw new Error("ipaddr: ipv6 part should fit in 16 bits");
            }
            if (zoneId) this.zoneId = zoneId;
        }
        IPv6.prototype.kind = function() {
            return "ipv6";
        };
        IPv6.prototype.toString = function() {
            return this.toNormalizedString().replace(/((^|:)(0(:|$))+)/, "::");
        };
        IPv6.prototype.toRFC5952String = function() {
            var bestMatchIndex, bestMatchLength, match, regex, string;
            regex = /((^|:)(0(:|$)){2,})/g;
            string = this.toNormalizedString();
            bestMatchIndex = 0;
            bestMatchLength = -1;
            while(match = regex.exec(string))if (match[0].length > bestMatchLength) {
                bestMatchIndex = match.index;
                bestMatchLength = match[0].length;
            }
            if (bestMatchLength < 0) return string;
            return string.substring(0, bestMatchIndex) + "::" + string.substring(bestMatchIndex + bestMatchLength);
        };
        IPv6.prototype.toByteArray = function() {
            var bytes, k, len, part, ref;
            bytes = [];
            ref = this.parts;
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                bytes.push(part >> 8);
                bytes.push(part & 0xff);
            }
            return bytes;
        };
        IPv6.prototype.toNormalizedString = function() {
            var addr, part, suffix;
            addr = (function() {
                var k, len, ref, results;
                ref = this.parts;
                results = [];
                for(k = 0, len = ref.length; k < len; k++){
                    part = ref[k];
                    results.push(part.toString(16));
                }
                return results;
            }).call(this).join(":");
            suffix = "";
            if (this.zoneId) suffix = "%" + this.zoneId;
            return addr + suffix;
        };
        IPv6.prototype.toFixedLengthString = function() {
            var addr, part, suffix;
            addr = (function() {
                var k, len, ref, results;
                ref = this.parts;
                results = [];
                for(k = 0, len = ref.length; k < len; k++){
                    part = ref[k];
                    results.push(part.toString(16).padStart(4, "0"));
                }
                return results;
            }).call(this).join(":");
            suffix = "";
            if (this.zoneId) suffix = "%" + this.zoneId;
            return addr + suffix;
        };
        IPv6.prototype.match = function(other, cidrRange) {
            var ref;
            if (cidrRange === void 0) ref = other, other = ref[0], cidrRange = ref[1];
            if (other.kind() !== "ipv6") throw new Error("ipaddr: cannot match ipv6 address with non-ipv6 one");
            return matchCIDR(this.parts, other.parts, 16, cidrRange);
        };
        IPv6.prototype.SpecialRanges = {
            unspecified: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                128
            ],
            linkLocal: [
                new IPv6([
                    0xfe80,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                10
            ],
            multicast: [
                new IPv6([
                    0xff00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                8
            ],
            loopback: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ]),
                128
            ],
            uniqueLocal: [
                new IPv6([
                    0xfc00,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                7
            ],
            ipv4Mapped: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0
                ]),
                96
            ],
            rfc6145: [
                new IPv6([
                    0,
                    0,
                    0,
                    0,
                    0xffff,
                    0,
                    0,
                    0
                ]),
                96
            ],
            rfc6052: [
                new IPv6([
                    0x64,
                    0xff9b,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                96
            ],
            "6to4": [
                new IPv6([
                    0x2002,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                16
            ],
            teredo: [
                new IPv6([
                    0x2001,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]),
                32
            ],
            reserved: [
                [
                    new IPv6([
                        0x2001,
                        0xdb8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ]),
                    32
                ]
            ]
        };
        IPv6.prototype.range = function() {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };
        IPv6.prototype.isIPv4MappedAddress = function() {
            return this.range() === "ipv4Mapped";
        };
        IPv6.prototype.toIPv4Address = function() {
            var high, low, ref;
            if (!this.isIPv4MappedAddress()) throw new Error("ipaddr: trying to convert a generic ipv6 address to ipv4");
            ref = this.parts.slice(-2), high = ref[0], low = ref[1];
            return new ipaddr.IPv4([
                high >> 8,
                high & 0xff,
                low >> 8,
                low & 0xff
            ]);
        };
        IPv6.prototype.prefixLengthFromSubnetMask = function() {
            var cidr, i, k, part, stop, zeros, zerotable;
            zerotable = {
                0: 16,
                32768: 15,
                49152: 14,
                57344: 13,
                61440: 12,
                63488: 11,
                64512: 10,
                65024: 9,
                65280: 8,
                65408: 7,
                65472: 6,
                65504: 5,
                65520: 4,
                65528: 3,
                65532: 2,
                65534: 1,
                65535: 0
            };
            cidr = 0;
            stop = false;
            for(i = k = 7; k >= 0; i = k += -1){
                part = this.parts[i];
                if (part in zerotable) {
                    zeros = zerotable[part];
                    if (stop && zeros !== 0) return null;
                    if (zeros !== 16) stop = true;
                    cidr += zeros;
                } else return null;
            }
            return 128 - cidr;
        };
        return IPv6;
    }();
    ipv6Part = "(?:[0-9a-f]+::?)+";
    zoneIndex = "%[0-9a-z]{1,}";
    ipv6Regexes = {
        zoneIndex: new RegExp(zoneIndex, "i"),
        "native": new RegExp("^(::)?(" + ipv6Part + ")?([0-9a-f]+)?(::)?(" + zoneIndex + ")?$", "i"),
        transitional: new RegExp("^((?:" + ipv6Part + ")|(?:::)(?:" + ipv6Part + ")?)" + (ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part + "\\." + ipv4Part) + ("(" + zoneIndex + ")?$"), "i")
    };
    expandIPv6 = function(string, parts) {
        var colonCount, lastColon, part, replacement, replacementCount, zoneId;
        if (string.indexOf("::") !== string.lastIndexOf("::")) return null;
        zoneId = (string.match(ipv6Regexes["zoneIndex"]) || [])[0];
        if (zoneId) {
            zoneId = zoneId.substring(1);
            string = string.replace(/%.+$/, "");
        }
        colonCount = 0;
        lastColon = -1;
        while((lastColon = string.indexOf(":", lastColon + 1)) >= 0)colonCount++;
        if (string.substr(0, 2) === "::") colonCount--;
        if (string.substr(-2, 2) === "::") colonCount--;
        if (colonCount > parts) return null;
        replacementCount = parts - colonCount;
        replacement = ":";
        while(replacementCount--)replacement += "0:";
        string = string.replace("::", replacement);
        if (string[0] === ":") string = string.slice(1);
        if (string[string.length - 1] === ":") string = string.slice(0, -1);
        parts = function() {
            var k, len, ref, results;
            ref = string.split(":");
            results = [];
            for(k = 0, len = ref.length; k < len; k++){
                part = ref[k];
                results.push(parseInt(part, 16));
            }
            return results;
        }();
        return {
            parts: parts,
            zoneId: zoneId
        };
    };
    ipaddr.IPv6.parser = function(string) {
        var addr, k, len, match, octet, octets, zoneId;
        if (ipv6Regexes["native"].test(string)) return expandIPv6(string, 8);
        else if (match = string.match(ipv6Regexes["transitional"])) {
            zoneId = match[6] || "";
            addr = expandIPv6(match[1].slice(0, -1) + zoneId, 6);
            if (addr.parts) {
                octets = [
                    parseInt(match[2]),
                    parseInt(match[3]),
                    parseInt(match[4]),
                    parseInt(match[5])
                ];
                for(k = 0, len = octets.length; k < len; k++){
                    octet = octets[k];
                    if (!(0 <= octet && octet <= 255)) return null;
                }
                addr.parts.push(octets[0] << 8 | octets[1]);
                addr.parts.push(octets[2] << 8 | octets[3]);
                return {
                    parts: addr.parts,
                    zoneId: addr.zoneId
                };
            }
        }
        return null;
    };
    ipaddr.IPv4.isIPv4 = ipaddr.IPv6.isIPv6 = function(string) {
        return this.parser(string) !== null;
    };
    ipaddr.IPv4.isValid = function(string) {
        var e;
        try {
            new this(this.parser(string));
            return true;
        } catch (error1) {
            e = error1;
            return false;
        }
    };
    ipaddr.IPv4.isValidFourPartDecimal = function(string) {
        if (ipaddr.IPv4.isValid(string) && string.match(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){3}$/)) return true;
        else return false;
    };
    ipaddr.IPv6.isValid = function(string) {
        var addr, e;
        if (typeof string === "string" && string.indexOf(":") === -1) return false;
        try {
            addr = this.parser(string);
            new this(addr.parts, addr.zoneId);
            return true;
        } catch (error1) {
            e = error1;
            return false;
        }
    };
    ipaddr.IPv4.parse = function(string) {
        var parts;
        parts = this.parser(string);
        if (parts === null) throw new Error("ipaddr: string is not formatted like ip address");
        return new this(parts);
    };
    ipaddr.IPv6.parse = function(string) {
        var addr;
        addr = this.parser(string);
        if (addr.parts === null) throw new Error("ipaddr: string is not formatted like ip address");
        return new this(addr.parts, addr.zoneId);
    };
    ipaddr.IPv4.parseCIDR = function(string) {
        var maskLength, match, parsed;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 32) {
                parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv4 CIDR range");
    };
    ipaddr.IPv4.subnetMaskFromPrefixLength = function(prefix) {
        var filledOctetCount, j, octets;
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 32) throw new Error("ipaddr: invalid IPv4 prefix length");
        octets = [
            0,
            0,
            0,
            0
        ];
        j = 0;
        filledOctetCount = Math.floor(prefix / 8);
        while(j < filledOctetCount){
            octets[j] = 255;
            j++;
        }
        if (filledOctetCount < 4) octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - prefix % 8;
        return new this(octets);
    };
    ipaddr.IPv4.broadcastAddressFromCIDR = function(string) {
        var cidr, error, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 4){
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }
            return new this(octets);
        } catch (error1) {
            error = error1;
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    ipaddr.IPv4.networkAddressFromCIDR = function(string) {
        var cidr, error, i, ipInterfaceOctets, octets, subnetMaskOctets;
        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while(i < 4){
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }
            return new this(octets);
        } catch (error1) {
            error = error1;
            throw new Error("ipaddr: the address does not have IPv4 CIDR format");
        }
    };
    ipaddr.IPv6.parseCIDR = function(string) {
        var maskLength, match, parsed;
        if (match = string.match(/^(.+)\/(\d+)$/)) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 128) {
                parsed = [
                    this.parse(match[1]),
                    maskLength
                ];
                Object.defineProperty(parsed, "toString", {
                    value: function() {
                        return this.join("/");
                    }
                });
                return parsed;
            }
        }
        throw new Error("ipaddr: string is not formatted like an IPv6 CIDR range");
    };
    ipaddr.isValid = function(string) {
        return ipaddr.IPv6.isValid(string) || ipaddr.IPv4.isValid(string);
    };
    ipaddr.parse = function(string) {
        if (ipaddr.IPv6.isValid(string)) return ipaddr.IPv6.parse(string);
        else if (ipaddr.IPv4.isValid(string)) return ipaddr.IPv4.parse(string);
        else throw new Error("ipaddr: the address has neither IPv6 nor IPv4 format");
    };
    ipaddr.parseCIDR = function(string) {
        var e;
        try {
            return ipaddr.IPv6.parseCIDR(string);
        } catch (error1) {
            e = error1;
            try {
                return ipaddr.IPv4.parseCIDR(string);
            } catch (error1) {
                e = error1;
                throw new Error("ipaddr: the address has neither IPv6 nor IPv4 CIDR format");
            }
        }
    };
    ipaddr.fromByteArray = function(bytes) {
        var length;
        length = bytes.length;
        if (length === 4) return new ipaddr.IPv4(bytes);
        else if (length === 16) return new ipaddr.IPv6(bytes);
        else throw new Error("ipaddr: the binary input is neither an IPv6 nor IPv4 address");
    };
    ipaddr.process = function(string) {
        var addr;
        addr = this.parse(string);
        if (addr.kind() === "ipv6" && addr.isIPv4MappedAddress()) return addr.toIPv4Address();
        else return addr;
    };
}).call(this);

});

parcelRegister("frncS", function(module, exports) {
function $b3db60feabacccd5$var$_extends() {
    return module.exports = $b3db60feabacccd5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b3db60feabacccd5$var$_extends.apply(null, arguments);
}
module.exports = $b3db60feabacccd5$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("37KYO", function(module, exports) {
function $246677c56c45e428$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $246677c56c45e428$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cgitS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ed55096fbb69da0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $8ed55096fbb69da0$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8kMfp")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("aNuUP")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("aNuUP")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("aSyh5")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("jDDa9")).default; });
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $9Gy1A = parcelRequire("9Gy1A");

var $aNuUP = parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");

var $aSyh5 = parcelRequire("aSyh5");

var $jDDa9 = parcelRequire("jDDa9");
"use client";
function $8ed55096fbb69da0$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $9Gy1A.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $8ed55096fbb69da0$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("9Gy1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70d26de1666ea60b$export$2e2bcd8739ae039; });

var $fTKeB = parcelRequire("fTKeB");
parcelRequire("65o8X");
parcelRequire("eZVvM");
parcelRequire("hMzFq");

parcelRequire("geJaG");
parcelRequire("2mRmw");
parcelRequire("8JgfY");
var $70d26de1666ea60b$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $70d26de1666ea60b$export$2e2bcd8739ae039 = (0, $fTKeB.default).bind();
$70d26de1666ea60b$var$tags.forEach(function(tagName) {
    $70d26de1666ea60b$export$2e2bcd8739ae039[tagName] = $70d26de1666ea60b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("fTKeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92fdb4d9636797d$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $hMzFq = parcelRequire("hMzFq");
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");

var $geJaG = parcelRequire("geJaG");

var $2mRmw = parcelRequire("2mRmw");

var $8JgfY = parcelRequire("8JgfY");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $b92fdb4d9636797d$var$testOmitPropsOnStringTag = (0, $hMzFq.default);
var $b92fdb4d9636797d$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $b92fdb4d9636797d$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $b92fdb4d9636797d$var$testOmitPropsOnStringTag : $b92fdb4d9636797d$var$testOmitPropsOnComponent;
};
var $b92fdb4d9636797d$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $b92fdb4d9636797d$var$isDevelopment = false;
var $b92fdb4d9636797d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $geJaG.registerStyles)(cache, serialized, isStringTag);
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $geJaG.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $b92fdb4d9636797d$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $b92fdb4d9636797d$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $b92fdb4d9636797d$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $8kMfp.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $eZVvM.useContext((0, $8kMfp.T));
            }
            if (typeof props.className === "string") className = (0, $geJaG.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2mRmw.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $b92fdb4d9636797d$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($b92fdb4d9636797d$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $eZVvM.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $b92fdb4d9636797d$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $65o8X.default)({}, options, nextOptions, {
                shouldForwardProp: $b92fdb4d9636797d$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("hMzFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf22961bb12ad7a3$export$2e2bcd8739ae039; });

var $4vbT5 = parcelRequire("4vbT5");
// eslint-disable-next-line no-undef
var $cf22961bb12ad7a3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $cf22961bb12ad7a3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4vbT5.default)(function(prop) {
    return $cf22961bb12ad7a3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("aNuUP", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $7dc6762720818f23$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $7dc6762720818f23$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $7dc6762720818f23$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $7dc6762720818f23$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("8kMfp")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("8kMfp")).w; });

var $8kMfp = parcelRequire("8kMfp");

var $eZVvM = parcelRequire("eZVvM");

var $geJaG = parcelRequire("geJaG");

var $8JgfY = parcelRequire("8JgfY");

var $2mRmw = parcelRequire("2mRmw");
parcelRequire("hUOrI");
parcelRequire("65o8X");
parcelRequire("c2U8l");

parcelRequire("28Dco");
var $7dc6762720818f23$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $8kMfp.h).call(props, "css")) return $eZVvM.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $8kMfp.E);
    createElementArgArray[1] = (0, $8kMfp.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $eZVvM.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7dc6762720818f23$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $8kMfp.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2mRmw.serializeStyles)([
        styles
    ], undefined, $eZVvM.useContext((0, $8kMfp.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eZVvM.useRef();
    (0, $8JgfY.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $8JgfY.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $geJaG.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $7dc6762720818f23$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2mRmw.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $7dc6762720818f23$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $7dc6762720818f23$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $7dc6762720818f23$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $7dc6762720818f23$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $geJaG.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7dc6762720818f23$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $8JgfY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $geJaG.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $7dc6762720818f23$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $8kMfp.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $8kMfp.i)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2mRmw.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $geJaG.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $8kMfp.i)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7dc6762720818f23$var$merge(cache.registered, css, $7dc6762720818f23$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eZVvM.useContext((0, $8kMfp.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($7dc6762720818f23$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});



parcelRegister("aSyh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb988c305824bed$export$2e2bcd8739ae039; });
parcelRequire("eZVvM");


var $8kMfp = parcelRequire("8kMfp");

var $hUOrI = parcelRequire("hUOrI");

var $3pI8R = parcelRequire("3pI8R");
"use client";
let $7eb988c305824bed$var$cache;
if (typeof document === "object") $7eb988c305824bed$var$cache = (0, $hUOrI.default)({
    key: "css",
    prepend: true
});
function $7eb988c305824bed$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $7eb988c305824bed$var$cache ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8kMfp.C), {
        value: $7eb988c305824bed$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("jDDa9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c009b989499b2e$export$2e2bcd8739ae039; });
parcelRequire("eZVvM");


var $aNuUP = parcelRequire("aNuUP");

var $3pI8R = parcelRequire("3pI8R");
"use client";
function $e4c009b989499b2e$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $e4c009b989499b2e$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($e4c009b989499b2e$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $aNuUP.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("booPO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hojpr")).default; });

var $hojpr = parcelRequire("hojpr");

});
parcelRegister("hojpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca93bbd8bf8829f1$export$2e2bcd8739ae039; });

var $9u6aw = parcelRequire("9u6aw");
function $ca93bbd8bf8829f1$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $9u6aw.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("9u6aw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e7bb36299a100a0$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $6e7bb36299a100a0$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("iH2bF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("hYwJR")).default; });

var $hYwJR = parcelRequire("hYwJR");
$parcel$exportWildcard(module.exports, $hYwJR);

});
parcelRegister("hYwJR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $d1616f7ca43a9fa0$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $d1616f7ca43a9fa0$export$2e2bcd8739ae039; });

var $2ZVAX = parcelRequire("2ZVAX");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $d1616f7ca43a9fa0$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $d1616f7ca43a9fa0$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($d1616f7ca43a9fa0$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $d1616f7ca43a9fa0$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $d1616f7ca43a9fa0$export$aad197c7121a6651(Component) || fallback;
}
function $d1616f7ca43a9fa0$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $d1616f7ca43a9fa0$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $d1616f7ca43a9fa0$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $d1616f7ca43a9fa0$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $2ZVAX.ForwardRef:
            return $d1616f7ca43a9fa0$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $2ZVAX.Memo:
            return $d1616f7ca43a9fa0$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("2ZVAX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9HOh3"));

});
parcelRegister("9HOh3", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $710f209320be5e38$export$a7c73072b1a182ae; }, function (v) { return $710f209320be5e38$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $710f209320be5e38$export$9f27bc3417b4524d; }, function (v) { return $710f209320be5e38$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $710f209320be5e38$export$db77ccec0bb4ccac; }, function (v) { return $710f209320be5e38$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $710f209320be5e38$export$8392c0c9d3dcbd35; }, function (v) { return $710f209320be5e38$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $710f209320be5e38$export$ffb0004e005737fa; }, function (v) { return $710f209320be5e38$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $710f209320be5e38$export$b624eff549462981; }, function (v) { return $710f209320be5e38$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $710f209320be5e38$export$7897aa7841a5380c; }, function (v) { return $710f209320be5e38$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $710f209320be5e38$export$602eac185826482c; }, function (v) { return $710f209320be5e38$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $710f209320be5e38$export$e2c29f18771995cb; }, function (v) { return $710f209320be5e38$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $710f209320be5e38$export$5f8d39834fd61797; }, function (v) { return $710f209320be5e38$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $710f209320be5e38$export$74bf444e3cd11ea5; }, function (v) { return $710f209320be5e38$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $710f209320be5e38$export$998bcd577473dd93; }, function (v) { return $710f209320be5e38$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $710f209320be5e38$export$92387174baf9b227; }, function (v) { return $710f209320be5e38$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $710f209320be5e38$export$ec112efeb987d9c6; }, function (v) { return $710f209320be5e38$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $710f209320be5e38$export$b706b080d889d2c9; }, function (v) { return $710f209320be5e38$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $710f209320be5e38$export$5be5a87408f70ddc; }, function (v) { return $710f209320be5e38$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $710f209320be5e38$export$45a5e7f76e0caa8d; }, function (v) { return $710f209320be5e38$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $710f209320be5e38$export$455c2e768291efa6; }, function (v) { return $710f209320be5e38$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $710f209320be5e38$export$9522e17588c12572; }, function (v) { return $710f209320be5e38$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $710f209320be5e38$export$2110ac352bb060b9; }, function (v) { return $710f209320be5e38$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $710f209320be5e38$export$56885ab8b9c456ab; }, function (v) { return $710f209320be5e38$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $710f209320be5e38$export$d927fcb6adf8f9de; }, function (v) { return $710f209320be5e38$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $710f209320be5e38$export$b82d16f27459e05a; }, function (v) { return $710f209320be5e38$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $710f209320be5e38$export$522c17b4f5e123e8; }, function (v) { return $710f209320be5e38$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $710f209320be5e38$export$1aabd8a0274ecfd6; }, function (v) { return $710f209320be5e38$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $710f209320be5e38$export$3d6c20d97e46b957; }, function (v) { return $710f209320be5e38$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $710f209320be5e38$export$9b621391a187a31a; }, function (v) { return $710f209320be5e38$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $710f209320be5e38$export$f5bbd400c2f4426f; }, function (v) { return $710f209320be5e38$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $710f209320be5e38$export$a7c73072b1a182ae;
var $710f209320be5e38$export$9f27bc3417b4524d;
var $710f209320be5e38$export$db77ccec0bb4ccac;
var $710f209320be5e38$export$8392c0c9d3dcbd35;
var $710f209320be5e38$export$ffb0004e005737fa;
var $710f209320be5e38$export$b624eff549462981;
var $710f209320be5e38$export$7897aa7841a5380c;
var $710f209320be5e38$export$602eac185826482c;
var $710f209320be5e38$export$e2c29f18771995cb;
var $710f209320be5e38$export$5f8d39834fd61797;
var $710f209320be5e38$export$74bf444e3cd11ea5;
var $710f209320be5e38$export$998bcd577473dd93;
var $710f209320be5e38$export$92387174baf9b227;
var $710f209320be5e38$export$ec112efeb987d9c6;
var $710f209320be5e38$export$b706b080d889d2c9;
var $710f209320be5e38$export$5be5a87408f70ddc;
var $710f209320be5e38$export$45a5e7f76e0caa8d;
var $710f209320be5e38$export$455c2e768291efa6;
var $710f209320be5e38$export$9522e17588c12572;
var $710f209320be5e38$export$2110ac352bb060b9;
var $710f209320be5e38$export$56885ab8b9c456ab;
var $710f209320be5e38$export$d927fcb6adf8f9de;
var $710f209320be5e38$export$b82d16f27459e05a;
var $710f209320be5e38$export$522c17b4f5e123e8;
var $710f209320be5e38$export$1aabd8a0274ecfd6;
var $710f209320be5e38$export$3d6c20d97e46b957;
var $710f209320be5e38$export$9b621391a187a31a;
var $710f209320be5e38$export$f5bbd400c2f4426f;
"use strict";
var $710f209320be5e38$var$b = Symbol.for("react.element"), $710f209320be5e38$var$c = Symbol.for("react.portal"), $710f209320be5e38$var$d = Symbol.for("react.fragment"), $710f209320be5e38$var$e = Symbol.for("react.strict_mode"), $710f209320be5e38$var$f = Symbol.for("react.profiler"), $710f209320be5e38$var$g = Symbol.for("react.provider"), $710f209320be5e38$var$h = Symbol.for("react.context"), $710f209320be5e38$var$k = Symbol.for("react.server_context"), $710f209320be5e38$var$l = Symbol.for("react.forward_ref"), $710f209320be5e38$var$m = Symbol.for("react.suspense"), $710f209320be5e38$var$n = Symbol.for("react.suspense_list"), $710f209320be5e38$var$p = Symbol.for("react.memo"), $710f209320be5e38$var$q = Symbol.for("react.lazy"), $710f209320be5e38$var$t = Symbol.for("react.offscreen"), $710f209320be5e38$var$u;
$710f209320be5e38$var$u = Symbol.for("react.module.reference");
function $710f209320be5e38$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $710f209320be5e38$var$b:
                switch(a = a.type, a){
                    case $710f209320be5e38$var$d:
                    case $710f209320be5e38$var$f:
                    case $710f209320be5e38$var$e:
                    case $710f209320be5e38$var$m:
                    case $710f209320be5e38$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $710f209320be5e38$var$k:
                            case $710f209320be5e38$var$h:
                            case $710f209320be5e38$var$l:
                            case $710f209320be5e38$var$q:
                            case $710f209320be5e38$var$p:
                            case $710f209320be5e38$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $710f209320be5e38$var$c:
                return r;
        }
    }
}
$710f209320be5e38$export$a7c73072b1a182ae = $710f209320be5e38$var$h;
$710f209320be5e38$export$9f27bc3417b4524d = $710f209320be5e38$var$g;
$710f209320be5e38$export$db77ccec0bb4ccac = $710f209320be5e38$var$b;
$710f209320be5e38$export$8392c0c9d3dcbd35 = $710f209320be5e38$var$l;
$710f209320be5e38$export$ffb0004e005737fa = $710f209320be5e38$var$d;
$710f209320be5e38$export$b624eff549462981 = $710f209320be5e38$var$q;
$710f209320be5e38$export$7897aa7841a5380c = $710f209320be5e38$var$p;
$710f209320be5e38$export$602eac185826482c = $710f209320be5e38$var$c;
$710f209320be5e38$export$e2c29f18771995cb = $710f209320be5e38$var$f;
$710f209320be5e38$export$5f8d39834fd61797 = $710f209320be5e38$var$e;
$710f209320be5e38$export$74bf444e3cd11ea5 = $710f209320be5e38$var$m;
$710f209320be5e38$export$998bcd577473dd93 = $710f209320be5e38$var$n;
$710f209320be5e38$export$92387174baf9b227 = function() {
    return !1;
};
$710f209320be5e38$export$ec112efeb987d9c6 = function() {
    return !1;
};
$710f209320be5e38$export$b706b080d889d2c9 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$h;
};
$710f209320be5e38$export$5be5a87408f70ddc = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$g;
};
$710f209320be5e38$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $710f209320be5e38$var$b;
};
$710f209320be5e38$export$455c2e768291efa6 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$l;
};
$710f209320be5e38$export$9522e17588c12572 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$d;
};
$710f209320be5e38$export$2110ac352bb060b9 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$q;
};
$710f209320be5e38$export$56885ab8b9c456ab = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$p;
};
$710f209320be5e38$export$d927fcb6adf8f9de = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$c;
};
$710f209320be5e38$export$b82d16f27459e05a = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$f;
};
$710f209320be5e38$export$522c17b4f5e123e8 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$e;
};
$710f209320be5e38$export$1aabd8a0274ecfd6 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$m;
};
$710f209320be5e38$export$3d6c20d97e46b957 = function(a) {
    return $710f209320be5e38$var$v(a) === $710f209320be5e38$var$n;
};
$710f209320be5e38$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $710f209320be5e38$var$d || a === $710f209320be5e38$var$f || a === $710f209320be5e38$var$e || a === $710f209320be5e38$var$m || a === $710f209320be5e38$var$n || a === $710f209320be5e38$var$t || "object" === typeof a && null !== a && (a.$$typeof === $710f209320be5e38$var$q || a.$$typeof === $710f209320be5e38$var$p || a.$$typeof === $710f209320be5e38$var$g || a.$$typeof === $710f209320be5e38$var$h || a.$$typeof === $710f209320be5e38$var$l || a.$$typeof === $710f209320be5e38$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$710f209320be5e38$export$f5bbd400c2f4426f = $710f209320be5e38$var$v;

});




parcelRegister("lEj5y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gnWEo")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("gf69n")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("2XQzx")).default; });

var $gnWEo = parcelRequire("gnWEo");

var $gf69n = parcelRequire("gf69n");

var $2XQzx = parcelRequire("2XQzx");

});
parcelRegister("gnWEo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bedc4a15c73da3aa$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");

var $gf69n = parcelRequire("gf69n");

var $2nHCk = parcelRequire("2nHCk");

var $ktoFS = parcelRequire("ktoFS");

var $34Ozv = parcelRequire("34Ozv");

var $jHIoy = parcelRequire("jHIoy");

var $2XQzx = parcelRequire("2XQzx");
const $bedc4a15c73da3aa$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $bedc4a15c73da3aa$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $7Z8DW.default)(options, $bedc4a15c73da3aa$var$_excluded);
    const breakpoints = (0, $gf69n.default)(breakpointsInput);
    const spacing = (0, $ktoFS.default)(spacingInput);
    let muiTheme = (0, $hWP8m.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $65o8X.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $65o8X.default)({}, (0, $2nHCk.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $2XQzx.default);
    muiTheme = args.reduce((acc, argument)=>(0, $hWP8m.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $65o8X.default)({}, (0, $jHIoy.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $34Ozv.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $bedc4a15c73da3aa$export$2e2bcd8739ae039 = $bedc4a15c73da3aa$var$createTheme;

});
parcelRegister("7Z8DW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d04ef4777db1668$export$2e2bcd8739ae039; });
function $5d04ef4777db1668$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("hWP8m", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $035f37d0c7040a9c$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $035f37d0c7040a9c$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");
function $035f37d0c7040a9c$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $035f37d0c7040a9c$var$deepClone(source) {
    if (!$035f37d0c7040a9c$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $035f37d0c7040a9c$var$deepClone(source[key]);
    });
    return output;
}
function $035f37d0c7040a9c$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $65o8X.default)({}, target) : target;
    if ($035f37d0c7040a9c$export$53b83ca8eaab0383(target) && $035f37d0c7040a9c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($035f37d0c7040a9c$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $035f37d0c7040a9c$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $035f37d0c7040a9c$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $035f37d0c7040a9c$export$53b83ca8eaab0383(source[key]) ? $035f37d0c7040a9c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("gf69n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd32d16147a79a70$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
const $bd32d16147a79a70$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $bd32d16147a79a70$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $bd32d16147a79a70$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $65o8X.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $bd32d16147a79a70$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $7Z8DW.default)(breakpoints, $bd32d16147a79a70$var$_excluded);
    const sortedValues = $bd32d16147a79a70$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $65o8X.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("2nHCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bbf9039396b40fa$export$2e2bcd8739ae039; });
const $1bbf9039396b40fa$var$shape = {
    borderRadius: 4
};
var $1bbf9039396b40fa$export$2e2bcd8739ae039 = $1bbf9039396b40fa$var$shape;

});

parcelRegister("ktoFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee79a7e86c1f806b$export$2e2bcd8739ae039; });

var $fwBcG = parcelRequire("fwBcG");
function $ee79a7e86c1f806b$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $fwBcG.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("fwBcG", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $b4d6b40d7c00ec9c$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $b4d6b40d7c00ec9c$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $b4d6b40d7c00ec9c$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $b4d6b40d7c00ec9c$export$6f98e8eaf0be1996; });


var $ivlTt = parcelRequire("ivlTt");

var $ce1Wd = parcelRequire("ce1Wd");

var $7ZfQq = parcelRequire("7ZfQq");

var $73RwQ = parcelRequire("73RwQ");
const $b4d6b40d7c00ec9c$var$properties = {
    m: "margin",
    p: "padding"
};
const $b4d6b40d7c00ec9c$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $b4d6b40d7c00ec9c$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $b4d6b40d7c00ec9c$var$getCssProperties = (0, $73RwQ.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($b4d6b40d7c00ec9c$var$aliases[prop]) prop = $b4d6b40d7c00ec9c$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $b4d6b40d7c00ec9c$var$properties[a];
    const direction = $b4d6b40d7c00ec9c$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $b4d6b40d7c00ec9c$var$spacingKeys = [
    ...$b4d6b40d7c00ec9c$export$aab52a0dde05ad8a,
    ...$b4d6b40d7c00ec9c$export$f8397d44f03ab6ad
];
function $b4d6b40d7c00ec9c$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $ce1Wd.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $b4d6b40d7c00ec9c$export$1def6f833384e3d1(theme) {
    return $b4d6b40d7c00ec9c$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $b4d6b40d7c00ec9c$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $b4d6b40d7c00ec9c$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $b4d6b40d7c00ec9c$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $b4d6b40d7c00ec9c$var$getCssProperties(prop);
    const styleFromPropValue = $b4d6b40d7c00ec9c$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $ivlTt.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $b4d6b40d7c00ec9c$var$style(props, keys) {
    const transformer = $b4d6b40d7c00ec9c$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$b4d6b40d7c00ec9c$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7ZfQq.default), {});
}
function $b4d6b40d7c00ec9c$export$7ede87f9b603dd3c(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a);
}
$b4d6b40d7c00ec9c$export$7ede87f9b603dd3c.propTypes = {};
$b4d6b40d7c00ec9c$export$7ede87f9b603dd3c.filterProps = $b4d6b40d7c00ec9c$export$aab52a0dde05ad8a;
function $b4d6b40d7c00ec9c$export$6f98e8eaf0be1996(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad);
}
$b4d6b40d7c00ec9c$export$6f98e8eaf0be1996.propTypes = {};
$b4d6b40d7c00ec9c$export$6f98e8eaf0be1996.filterProps = $b4d6b40d7c00ec9c$export$f8397d44f03ab6ad;
function $b4d6b40d7c00ec9c$var$spacing(props) {
    return $b4d6b40d7c00ec9c$var$style(props, $b4d6b40d7c00ec9c$var$spacingKeys);
}
$b4d6b40d7c00ec9c$var$spacing.propTypes = {};
$b4d6b40d7c00ec9c$var$spacing.filterProps = $b4d6b40d7c00ec9c$var$spacingKeys;
var $b4d6b40d7c00ec9c$export$2e2bcd8739ae039 = $b4d6b40d7c00ec9c$var$spacing;

});
parcelRegister("ivlTt", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $d78c1ae28d5effac$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $d78c1ae28d5effac$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $d78c1ae28d5effac$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $d78c1ae28d5effac$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $d78c1ae28d5effac$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $d78c1ae28d5effac$export$980e6a259d807490; });

var $65o8X = parcelRequire("65o8X");


var $hWP8m = parcelRequire("hWP8m");

var $7ZfQq = parcelRequire("7ZfQq");
const $d78c1ae28d5effac$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $d78c1ae28d5effac$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$d78c1ae28d5effac$export$68c286be0e7e55b7[key]}px)`
};
function $d78c1ae28d5effac$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $d78c1ae28d5effac$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $d78c1ae28d5effac$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $d78c1ae28d5effac$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $65o8X.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7ZfQq.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $d78c1ae28d5effac$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $d78c1ae28d5effac$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $d78c1ae28d5effac$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $d78c1ae28d5effac$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $hWP8m.default)(prev, next), {});
    return $d78c1ae28d5effac$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $d78c1ae28d5effac$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $d78c1ae28d5effac$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $d78c1ae28d5effac$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $d78c1ae28d5effac$export$2e2bcd8739ae039 = $d78c1ae28d5effac$var$breakpoints;

});
parcelRegister("7ZfQq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0a85539df49e43$export$2e2bcd8739ae039; });

var $hWP8m = parcelRequire("hWP8m");
function $5d0a85539df49e43$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $hWP8m.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $5d0a85539df49e43$export$2e2bcd8739ae039 = $5d0a85539df49e43$var$merge;

});


parcelRegister("ce1Wd", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $8e684bab4b6464fb$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $8e684bab4b6464fb$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $8e684bab4b6464fb$export$2e2bcd8739ae039; });

var $hojpr = parcelRequire("hojpr");


var $ivlTt = parcelRequire("ivlTt");
function $8e684bab4b6464fb$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $8e684bab4b6464fb$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $8e684bab4b6464fb$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $8e684bab4b6464fb$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $8e684bab4b6464fb$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $hojpr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $8e684bab4b6464fb$export$2e2bcd8739ae039 = $8e684bab4b6464fb$var$style;

});

parcelRegister("73RwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524255e38f674b8f$export$2e2bcd8739ae039; });
function $524255e38f674b8f$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("34Ozv", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $23d8f94f0a23bd3b$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $23d8f94f0a23bd3b$export$2e2bcd8739ae039; });

var $hojpr = parcelRequire("hojpr");

var $7ZfQq = parcelRequire("7ZfQq");

var $ce1Wd = parcelRequire("ce1Wd");

var $ivlTt = parcelRequire("ivlTt");

var $jHIoy = parcelRequire("jHIoy");
function $23d8f94f0a23bd3b$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $23d8f94f0a23bd3b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $23d8f94f0a23bd3b$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $ce1Wd.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ce1Wd.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $ce1Wd.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $hojpr.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $jHIoy.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $ivlTt.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $23d8f94f0a23bd3b$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $7ZfQq.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $ivlTt.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($23d8f94f0a23bd3b$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7ZfQq.default)(css, breakpointsValues);
                        }
                    } else css = (0, $7ZfQq.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $ivlTt.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $23d8f94f0a23bd3b$var$styleFunctionSx = $23d8f94f0a23bd3b$export$7d53d8bf2911e013();
$23d8f94f0a23bd3b$var$styleFunctionSx.filterProps = [
    "sx"
];
var $23d8f94f0a23bd3b$export$2e2bcd8739ae039 = $23d8f94f0a23bd3b$var$styleFunctionSx;

});
parcelRegister("jHIoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e58478679467ccff$export$2e2bcd8739ae039; });

var $fwBcG = parcelRequire("fwBcG");

var $dOJmG = parcelRequire("dOJmG");

var $d6drG = parcelRequire("d6drG");

var $eQnSg = parcelRequire("eQnSg");

var $fTpbm = parcelRequire("fTpbm");
const $e58478679467ccff$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $dOJmG.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $dOJmG.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $eQnSg.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $eQnSg.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $eQnSg.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $fwBcG.padding)
    },
    pt: {
        style: (0, $fwBcG.padding)
    },
    pr: {
        style: (0, $fwBcG.padding)
    },
    pb: {
        style: (0, $fwBcG.padding)
    },
    pl: {
        style: (0, $fwBcG.padding)
    },
    px: {
        style: (0, $fwBcG.padding)
    },
    py: {
        style: (0, $fwBcG.padding)
    },
    padding: {
        style: (0, $fwBcG.padding)
    },
    paddingTop: {
        style: (0, $fwBcG.padding)
    },
    paddingRight: {
        style: (0, $fwBcG.padding)
    },
    paddingBottom: {
        style: (0, $fwBcG.padding)
    },
    paddingLeft: {
        style: (0, $fwBcG.padding)
    },
    paddingX: {
        style: (0, $fwBcG.padding)
    },
    paddingY: {
        style: (0, $fwBcG.padding)
    },
    paddingInline: {
        style: (0, $fwBcG.padding)
    },
    paddingInlineStart: {
        style: (0, $fwBcG.padding)
    },
    paddingInlineEnd: {
        style: (0, $fwBcG.padding)
    },
    paddingBlock: {
        style: (0, $fwBcG.padding)
    },
    paddingBlockStart: {
        style: (0, $fwBcG.padding)
    },
    paddingBlockEnd: {
        style: (0, $fwBcG.padding)
    },
    m: {
        style: (0, $fwBcG.margin)
    },
    mt: {
        style: (0, $fwBcG.margin)
    },
    mr: {
        style: (0, $fwBcG.margin)
    },
    mb: {
        style: (0, $fwBcG.margin)
    },
    ml: {
        style: (0, $fwBcG.margin)
    },
    mx: {
        style: (0, $fwBcG.margin)
    },
    my: {
        style: (0, $fwBcG.margin)
    },
    margin: {
        style: (0, $fwBcG.margin)
    },
    marginTop: {
        style: (0, $fwBcG.margin)
    },
    marginRight: {
        style: (0, $fwBcG.margin)
    },
    marginBottom: {
        style: (0, $fwBcG.margin)
    },
    marginLeft: {
        style: (0, $fwBcG.margin)
    },
    marginX: {
        style: (0, $fwBcG.margin)
    },
    marginY: {
        style: (0, $fwBcG.margin)
    },
    marginInline: {
        style: (0, $fwBcG.margin)
    },
    marginInlineStart: {
        style: (0, $fwBcG.margin)
    },
    marginInlineEnd: {
        style: (0, $fwBcG.margin)
    },
    marginBlock: {
        style: (0, $fwBcG.margin)
    },
    marginBlockStart: {
        style: (0, $fwBcG.margin)
    },
    marginBlockEnd: {
        style: (0, $fwBcG.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $d6drG.gap)
    },
    rowGap: {
        style: (0, $d6drG.rowGap)
    },
    columnGap: {
        style: (0, $d6drG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $fTpbm.sizingTransform)
    },
    maxWidth: {
        style: (0, $fTpbm.maxWidth)
    },
    minWidth: {
        transform: (0, $fTpbm.sizingTransform)
    },
    height: {
        transform: (0, $fTpbm.sizingTransform)
    },
    maxHeight: {
        transform: (0, $fTpbm.sizingTransform)
    },
    minHeight: {
        transform: (0, $fTpbm.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $e58478679467ccff$export$2e2bcd8739ae039 = $e58478679467ccff$var$defaultSxConfig;

});
parcelRegister("dOJmG", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $a0f3226839926fa3$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $a0f3226839926fa3$export$7a57f79000377ca2; });


var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $fwBcG = parcelRequire("fwBcG");

var $ivlTt = parcelRequire("ivlTt");
function $a0f3226839926fa3$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $a0f3226839926fa3$var$createBorderStyle(prop, transform) {
    return (0, $ce1Wd.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $a0f3226839926fa3$export$1edee58a52776cd9 = $a0f3226839926fa3$var$createBorderStyle("border", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$f9a7b6bd24892946 = $a0f3226839926fa3$var$createBorderStyle("borderTop", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$5abca33e6be905d2 = $a0f3226839926fa3$var$createBorderStyle("borderRight", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$e2ce9f12a980a822 = $a0f3226839926fa3$var$createBorderStyle("borderBottom", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$47658cca1a909427 = $a0f3226839926fa3$var$createBorderStyle("borderLeft", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$e7fb0694ba2404fc = $a0f3226839926fa3$var$createBorderStyle("borderColor");
const $a0f3226839926fa3$export$126a92c968acdb85 = $a0f3226839926fa3$var$createBorderStyle("borderTopColor");
const $a0f3226839926fa3$export$85cc51cb8fbb8c0e = $a0f3226839926fa3$var$createBorderStyle("borderRightColor");
const $a0f3226839926fa3$export$340b0327727f6d1a = $a0f3226839926fa3$var$createBorderStyle("borderBottomColor");
const $a0f3226839926fa3$export$60beef91a985b4bf = $a0f3226839926fa3$var$createBorderStyle("borderLeftColor");
const $a0f3226839926fa3$export$f9258c55612cbed7 = $a0f3226839926fa3$var$createBorderStyle("outline", $a0f3226839926fa3$export$34e2febe53ae29cc);
const $a0f3226839926fa3$export$621fe586efeb64b9 = $a0f3226839926fa3$var$createBorderStyle("outlineColor");
const $a0f3226839926fa3$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$a0f3226839926fa3$export$7a57f79000377ca2.propTypes = {};
$a0f3226839926fa3$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $a0f3226839926fa3$var$borders = (0, $2AzUI.default)($a0f3226839926fa3$export$1edee58a52776cd9, $a0f3226839926fa3$export$f9a7b6bd24892946, $a0f3226839926fa3$export$5abca33e6be905d2, $a0f3226839926fa3$export$e2ce9f12a980a822, $a0f3226839926fa3$export$47658cca1a909427, $a0f3226839926fa3$export$e7fb0694ba2404fc, $a0f3226839926fa3$export$126a92c968acdb85, $a0f3226839926fa3$export$85cc51cb8fbb8c0e, $a0f3226839926fa3$export$340b0327727f6d1a, $a0f3226839926fa3$export$60beef91a985b4bf, $a0f3226839926fa3$export$7a57f79000377ca2, $a0f3226839926fa3$export$f9258c55612cbed7, $a0f3226839926fa3$export$621fe586efeb64b9);
var $a0f3226839926fa3$export$2e2bcd8739ae039 = $a0f3226839926fa3$var$borders;

});
parcelRegister("2AzUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e2acd4951a2ccdd$export$2e2bcd8739ae039; });

var $7ZfQq = parcelRequire("7ZfQq");
function $1e2acd4951a2ccdd$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7ZfQq.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $1e2acd4951a2ccdd$export$2e2bcd8739ae039 = $1e2acd4951a2ccdd$var$compose;

});


parcelRegister("d6drG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $989643e16a850b36$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $989643e16a850b36$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $989643e16a850b36$export$8a833ffa5f5dbeda; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $fwBcG = parcelRequire("fwBcG");

var $ivlTt = parcelRequire("ivlTt");

const $989643e16a850b36$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$5df9adcb0db95e1e.propTypes = {};
$989643e16a850b36$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $989643e16a850b36$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$ec60d70ff941a580.propTypes = {};
$989643e16a850b36$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $989643e16a850b36$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $fwBcG.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $fwBcG.getValue)(transformer, propValue)
            });
        return (0, $ivlTt.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$989643e16a850b36$export$8a833ffa5f5dbeda.propTypes = {};
$989643e16a850b36$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $989643e16a850b36$export$baf44164ca3a34e8 = (0, $ce1Wd.default)({
    prop: "gridColumn"
});
const $989643e16a850b36$export$8f7213a1cd01e832 = (0, $ce1Wd.default)({
    prop: "gridRow"
});
const $989643e16a850b36$export$b0e0abbc49ba668 = (0, $ce1Wd.default)({
    prop: "gridAutoFlow"
});
const $989643e16a850b36$export$bcd8b929d4b4142 = (0, $ce1Wd.default)({
    prop: "gridAutoColumns"
});
const $989643e16a850b36$export$e5039a674e14c828 = (0, $ce1Wd.default)({
    prop: "gridAutoRows"
});
const $989643e16a850b36$export$42bd9088661ffb03 = (0, $ce1Wd.default)({
    prop: "gridTemplateColumns"
});
const $989643e16a850b36$export$920682ae05b999bc = (0, $ce1Wd.default)({
    prop: "gridTemplateRows"
});
const $989643e16a850b36$export$1b88fbdd482fd33a = (0, $ce1Wd.default)({
    prop: "gridTemplateAreas"
});
const $989643e16a850b36$export$bdb486e40d52d26f = (0, $ce1Wd.default)({
    prop: "gridArea"
});
const $989643e16a850b36$var$grid = (0, $2AzUI.default)($989643e16a850b36$export$5df9adcb0db95e1e, $989643e16a850b36$export$ec60d70ff941a580, $989643e16a850b36$export$8a833ffa5f5dbeda, $989643e16a850b36$export$baf44164ca3a34e8, $989643e16a850b36$export$8f7213a1cd01e832, $989643e16a850b36$export$b0e0abbc49ba668, $989643e16a850b36$export$bcd8b929d4b4142, $989643e16a850b36$export$e5039a674e14c828, $989643e16a850b36$export$42bd9088661ffb03, $989643e16a850b36$export$920682ae05b999bc, $989643e16a850b36$export$1b88fbdd482fd33a, $989643e16a850b36$export$bdb486e40d52d26f);
var $989643e16a850b36$export$2e2bcd8739ae039 = $989643e16a850b36$var$grid;

});

parcelRegister("eQnSg", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $ace870f25fe00eeb$export$dbaffd4420ea0ac6; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");
function $ace870f25fe00eeb$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $ace870f25fe00eeb$export$35e9368ef982300f = (0, $ce1Wd.default)({
    prop: "color",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$export$2506f56c10355b33 = (0, $ce1Wd.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$export$8c5a050822fd698c = (0, $ce1Wd.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $ace870f25fe00eeb$export$dbaffd4420ea0ac6
});
const $ace870f25fe00eeb$var$palette = (0, $2AzUI.default)($ace870f25fe00eeb$export$35e9368ef982300f, $ace870f25fe00eeb$export$2506f56c10355b33, $ace870f25fe00eeb$export$8c5a050822fd698c);
var $ace870f25fe00eeb$export$2e2bcd8739ae039 = $ace870f25fe00eeb$var$palette;

});

parcelRegister("fTpbm", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $b91f86bf58963db2$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $b91f86bf58963db2$export$488fda99655ff65a; });

var $ce1Wd = parcelRequire("ce1Wd");

var $2AzUI = parcelRequire("2AzUI");

var $ivlTt = parcelRequire("ivlTt");
function $b91f86bf58963db2$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $b91f86bf58963db2$export$7e3df82ee760448c = (0, $ce1Wd.default)({
    prop: "width",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $ivlTt.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $b91f86bf58963db2$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $ivlTt.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$b91f86bf58963db2$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $b91f86bf58963db2$export$ee148fbbe8357dd2 = (0, $ce1Wd.default)({
    prop: "minWidth",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$ac607276a8fe9f0a = (0, $ce1Wd.default)({
    prop: "height",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$dc0d8bd0b94f8570 = (0, $ce1Wd.default)({
    prop: "maxHeight",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$a43cf604e12f3b17 = (0, $ce1Wd.default)({
    prop: "minHeight",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$ffed9f14fb65e276 = (0, $ce1Wd.default)({
    prop: "size",
    cssProperty: "width",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$905076ed6620e671 = (0, $ce1Wd.default)({
    prop: "size",
    cssProperty: "height",
    transform: $b91f86bf58963db2$export$8afece71750ec241
});
const $b91f86bf58963db2$export$6ccc93f785106a58 = (0, $ce1Wd.default)({
    prop: "boxSizing"
});
const $b91f86bf58963db2$var$sizing = (0, $2AzUI.default)($b91f86bf58963db2$export$7e3df82ee760448c, $b91f86bf58963db2$export$488fda99655ff65a, $b91f86bf58963db2$export$ee148fbbe8357dd2, $b91f86bf58963db2$export$ac607276a8fe9f0a, $b91f86bf58963db2$export$dc0d8bd0b94f8570, $b91f86bf58963db2$export$a43cf604e12f3b17, $b91f86bf58963db2$export$6ccc93f785106a58);
var $b91f86bf58963db2$export$2e2bcd8739ae039 = $b91f86bf58963db2$var$sizing;

});



parcelRegister("2XQzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2289df3a0cc6ad38$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $2289df3a0cc6ad38$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("k2gEs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("34Ozv")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("34Ozv")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("bU7jb")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("jHIoy")).default; });

var $34Ozv = parcelRequire("34Ozv");

var $bU7jb = parcelRequire("bU7jb");

var $jHIoy = parcelRequire("jHIoy");

});
parcelRegister("bU7jb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aaa97f9bb9ae172$export$2e2bcd8739ae039; });

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");

var $jHIoy = parcelRequire("jHIoy");
const $8aaa97f9bb9ae172$var$_excluded = [
    "sx"
];
const $8aaa97f9bb9ae172$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $jHIoy.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $8aaa97f9bb9ae172$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $7Z8DW.default)(props, $8aaa97f9bb9ae172$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $8aaa97f9bb9ae172$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $hWP8m.isPlainObject)(result)) return systemProps;
        return (0, $65o8X.default)({}, systemProps, result);
    };
    else finalSx = (0, $65o8X.default)({}, systemProps, inSx);
    return (0, $65o8X.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("1yFU7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9u6aw")).default; });

var $9u6aw = parcelRequire("9u6aw");

});

parcelRegister("6Gv37", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3WZeB")).default; });

var $3WZeB = parcelRequire("3WZeB");

});
parcelRegister("3WZeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e0649cc841e6e7e$export$2e2bcd8739ae039; });
function $2e0649cc841e6e7e$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $2e0649cc841e6e7e$export$2e2bcd8739ae039 = $2e0649cc841e6e7e$var$clamp;

});


parcelRegister("kvR7a", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("aZjGj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $d48On = parcelRequire("d48On");

var $rPxMG = parcelRequire("rPxMG");

var $cZMUv = parcelRequire("cZMUv");

var $3Vxa5 = parcelRequire("3Vxa5");

var $4ocSv = parcelRequire("4ocSv");

var $94t7D = parcelRequire("94t7D");

var $dYOPi = parcelRequire("dYOPi");

var $d4P6P = parcelRequire("d4P6P");

var $lDsJN = parcelRequire("lDsJN");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $cZMUv.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $rPxMG.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $cZMUv.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var _entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ResourceStore = function(_EventEmitter) {
    (0, $4ocSv.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $rPxMG.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $cZMUv.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $4ocSv.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $3Vxa5.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = baseLogger.create("translator");
        return _this;
    }
    (0, $cZMUv.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $d48On.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $d48On.default)(options) === "object") options = _objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $rPxMG.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create("languageUtils");
    }
    (0, $cZMUv.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $rPxMG.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = createRules();
    }
    (0, $cZMUv.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $rPxMG.default)(this, Interpolator);
        this.logger = baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $cZMUv.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $lDsJN.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $rPxMG.default)(this, Formatter);
        this.logger = baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $cZMUv.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $4ocSv.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $rPxMG.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $cZMUv.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $d48On.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $d48On.default)(args[2]) === "object" || (0, $d48On.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $dYOPi.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dYOPi.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $94t7D.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $4ocSv.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $rPxMG.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3Vxa5.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $3Vxa5.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $94t7D.default)(_this, (0, $3Vxa5.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $cZMUv.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $d48On.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $d4P6P.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("d48On", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98327be4adf32d0d$export$2e2bcd8739ae039; });
function $98327be4adf32d0d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $98327be4adf32d0d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98327be4adf32d0d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("rPxMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $053a81471954ae9a$export$2e2bcd8739ae039; });
function $053a81471954ae9a$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cZMUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97611f1a65b321a7$export$2e2bcd8739ae039; });

var $2afrY = parcelRequire("2afrY");
function $97611f1a65b321a7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $2afrY.default)(o.key), o);
    }
}
function $97611f1a65b321a7$export$2e2bcd8739ae039(e, r, t) {
    return r && $97611f1a65b321a7$var$_defineProperties(e.prototype, r), t && $97611f1a65b321a7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("2afrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19388003cddb44ed$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");

var $8ZEVp = parcelRequire("8ZEVp");
function $19388003cddb44ed$export$2e2bcd8739ae039(t) {
    var i = (0, $8ZEVp.default)(t, "string");
    return "symbol" == (0, $d48On.default)(i) ? i : i + "";
}

});
parcelRegister("8ZEVp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68c3c41270c5bd65$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");
function $68c3c41270c5bd65$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $d48On.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $d48On.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3Vxa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dc06b2edb5373b2$export$2e2bcd8739ae039; });
function $2dc06b2edb5373b2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("4ocSv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $332364a567063cf8$export$2e2bcd8739ae039; });

var $3XZxQ = parcelRequire("3XZxQ");
function $332364a567063cf8$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3XZxQ.default)(t, e);
}

});
parcelRegister("3XZxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e369f5411378101$export$2e2bcd8739ae039; });
function $2e369f5411378101$export$2e2bcd8739ae039(t, e) {
    return $2e369f5411378101$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2e369f5411378101$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("94t7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69ab13d4363a362b$export$2e2bcd8739ae039; });

var $d48On = parcelRequire("d48On");

var $3Vxa5 = parcelRequire("3Vxa5");
function $69ab13d4363a362b$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $d48On.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3Vxa5.default)(t);
}

});

parcelRegister("dYOPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2d84e01f7e64413$export$2e2bcd8739ae039; });
function $a2d84e01f7e64413$export$2e2bcd8739ae039(t) {
    return $a2d84e01f7e64413$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $a2d84e01f7e64413$export$2e2bcd8739ae039(t);
}

});

parcelRegister("d4P6P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98534b50fcf80561$export$2e2bcd8739ae039; });

var $2afrY = parcelRequire("2afrY");
function $98534b50fcf80561$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $2afrY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("lDsJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc038837611b900a$export$2e2bcd8739ae039; });

var $luw9G = parcelRequire("luw9G");

var $7aanC = parcelRequire("7aanC");

var $8boX5 = parcelRequire("8boX5");

var $8KBa0 = parcelRequire("8KBa0");
function $fc038837611b900a$export$2e2bcd8739ae039(r) {
    return (0, $luw9G.default)(r) || (0, $7aanC.default)(r) || (0, $8boX5.default)(r) || (0, $8KBa0.default)();
}

});
parcelRegister("luw9G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5557aeb35eafe0$export$2e2bcd8739ae039; });
function $fa5557aeb35eafe0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("7aanC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $537184d2ba980709$export$2e2bcd8739ae039; });
function $537184d2ba980709$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8boX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f52b4bf04904cc7$export$2e2bcd8739ae039; });

var $78tUI = parcelRequire("78tUI");
function $5f52b4bf04904cc7$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $78tUI.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $78tUI.default)(r, a) : void 0;
    }
}

});
parcelRegister("78tUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53207bfe34db9cd5$export$2e2bcd8739ae039; });
function $53207bfe34db9cd5$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("8KBa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65ef71dd7acb5292$export$2e2bcd8739ae039; });
function $65ef71dd7acb5292$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("brkeu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $8541e91a69b79b55$export$306c0aa65ff9ec16; }, function (v) { return $8541e91a69b79b55$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8541e91a69b79b55$export$306c0aa65ff9ec16;
"use strict";

var $eZVvM = parcelRequire("eZVvM");
function $8541e91a69b79b55$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8541e91a69b79b55$var$k = "function" === typeof Object.is ? Object.is : $8541e91a69b79b55$var$h, $8541e91a69b79b55$var$l = $eZVvM.useState, $8541e91a69b79b55$var$m = $eZVvM.useEffect, $8541e91a69b79b55$var$n = $eZVvM.useLayoutEffect, $8541e91a69b79b55$var$p = $eZVvM.useDebugValue;
function $8541e91a69b79b55$var$q(a, b) {
    var d = b(), f = $8541e91a69b79b55$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $8541e91a69b79b55$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $8541e91a69b79b55$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $8541e91a69b79b55$var$m(function() {
        $8541e91a69b79b55$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $8541e91a69b79b55$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $8541e91a69b79b55$var$p(d);
    return d;
}
function $8541e91a69b79b55$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$8541e91a69b79b55$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $8541e91a69b79b55$var$t(a, b) {
    return b();
}
var $8541e91a69b79b55$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8541e91a69b79b55$var$t : $8541e91a69b79b55$var$q;
$8541e91a69b79b55$export$306c0aa65ff9ec16 = void 0 !== $eZVvM.useSyncExternalStore ? $eZVvM.useSyncExternalStore : $8541e91a69b79b55$var$u;

});

parcelRegister("aCYKL", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1sHSN.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("1sHSN", function(module, exports) {

var $gGNqj = parcelRequire("gGNqj");
/** Detect free variable `self`. */ var $110a722a72d260f8$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $110a722a72d260f8$var$root = $gGNqj || $110a722a72d260f8$var$freeSelf || Function("return this")();
module.exports = $110a722a72d260f8$var$root;

});
parcelRegister("gGNqj", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $c266e80d4ef72cab$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $c266e80d4ef72cab$var$freeGlobal;

});



parcelRegister("hLa8L", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");

var $6jS5F = parcelRequire("6jS5F");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $1sHSN.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6jS5F;
module.exports = isBuffer;

});
parcelRegister("6jS5F", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $499e79a7d4850767$var$stubFalse() {
    return false;
}
module.exports = $499e79a7d4850767$var$stubFalse;

});


parcelRegister("1sJ0x", function(module, exports) {

var $gGNqj = parcelRequire("gGNqj");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gGNqj.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("99QKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
var $6aadde4af300d5e0$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $6aadde4af300d5e0$var$useCustomCompareEffect = function(effect, deps, depsEqual) {
    var ref = $eZVvM.useRef(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
    $eZVvM.useEffect(effect, ref.current);
};
module.exports.default = $6aadde4af300d5e0$var$useCustomCompareEffect;

});

parcelRegister("aqTHk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUWBZ = parcelRequire("iUWBZ");

var $79878983e3495663$var$react_1 = $iUWBZ.__importDefault((parcelRequire("2AWxB")));
module.exports.default = $79878983e3495663$var$react_1.default;

});
parcelRegister("iUWBZ", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $587e592597a56e11$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $587e592597a56e11$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $587e592597a56e11$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importDefault", function () { return $587e592597a56e11$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $587e592597a56e11$var$extendStatics = function(d, b) {
    $587e592597a56e11$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $587e592597a56e11$var$extendStatics(d, b);
};
function $587e592597a56e11$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $587e592597a56e11$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $587e592597a56e11$export$18ce0697a983be9b = function() {
    $587e592597a56e11$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $587e592597a56e11$export$18ce0697a983be9b.apply(this, arguments);
};
function $587e592597a56e11$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $587e592597a56e11$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $587e592597a56e11$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $587e592597a56e11$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $587e592597a56e11$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $587e592597a56e11$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $587e592597a56e11$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $587e592597a56e11$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $587e592597a56e11$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $587e592597a56e11$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $587e592597a56e11$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $587e592597a56e11$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $587e592597a56e11$export$45d3717a4c69092e(o, m, p);
}
function $587e592597a56e11$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $587e592597a56e11$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $587e592597a56e11$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($587e592597a56e11$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $587e592597a56e11$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $587e592597a56e11$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $587e592597a56e11$export$10c90e4f7922046c(v) {
    return this instanceof $587e592597a56e11$export$10c90e4f7922046c ? (this.v = v, this) : new $587e592597a56e11$export$10c90e4f7922046c(v);
}
function $587e592597a56e11$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $587e592597a56e11$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $587e592597a56e11$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $587e592597a56e11$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $587e592597a56e11$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $587e592597a56e11$export$19a8beecd37a4c45 === "function" ? $587e592597a56e11$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $587e592597a56e11$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $587e592597a56e11$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $587e592597a56e11$var$ownKeys = function(o) {
    $587e592597a56e11$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $587e592597a56e11$var$ownKeys(o);
};
function $587e592597a56e11$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $587e592597a56e11$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $587e592597a56e11$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $587e592597a56e11$var$__setModuleDefault(result, mod);
    return result;
}
function $587e592597a56e11$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $587e592597a56e11$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $587e592597a56e11$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $587e592597a56e11$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $587e592597a56e11$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $587e592597a56e11$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $587e592597a56e11$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $587e592597a56e11$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $587e592597a56e11$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $587e592597a56e11$export$2e2bcd8739ae039 = {
    __extends: $587e592597a56e11$export$a8ba968b8961cb8a,
    __assign: $587e592597a56e11$export$18ce0697a983be9b,
    __rest: $587e592597a56e11$export$3c9a16f847548506,
    __decorate: $587e592597a56e11$export$29e00dfd3077644b,
    __param: $587e592597a56e11$export$d5ad3fd78186038f,
    __esDecorate: $587e592597a56e11$export$3a84e1ae4e97e9b0,
    __runInitializers: $587e592597a56e11$export$d831c04e792af3d,
    __propKey: $587e592597a56e11$export$6a2a36740a146cb8,
    __setFunctionName: $587e592597a56e11$export$d1a06452d3489bc7,
    __metadata: $587e592597a56e11$export$f1db080c865becb9,
    __awaiter: $587e592597a56e11$export$1050f835b63b671e,
    __generator: $587e592597a56e11$export$67ebef60e6f28a6,
    __createBinding: $587e592597a56e11$export$45d3717a4c69092e,
    __exportStar: $587e592597a56e11$export$f33643c0debef087,
    __values: $587e592597a56e11$export$19a8beecd37a4c45,
    __read: $587e592597a56e11$export$8d051b38c9118094,
    __spread: $587e592597a56e11$export$afc72e2116322959,
    __spreadArrays: $587e592597a56e11$export$6388937ca91ccae8,
    __spreadArray: $587e592597a56e11$export$1216008129fb82ed,
    __await: $587e592597a56e11$export$10c90e4f7922046c,
    __asyncGenerator: $587e592597a56e11$export$e427f37a30a4de9b,
    __asyncDelegator: $587e592597a56e11$export$bbd80228419bb833,
    __asyncValues: $587e592597a56e11$export$e3b29a3d6162315f,
    __makeTemplateObject: $587e592597a56e11$export$4fb47efe1390b86f,
    __importStar: $587e592597a56e11$export$c21735bcef00d192,
    __importDefault: $587e592597a56e11$export$da59b14a69baef04,
    __classPrivateFieldGet: $587e592597a56e11$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $587e592597a56e11$export$d40a35129aaff81f,
    __classPrivateFieldIn: $587e592597a56e11$export$81fdc39f203e4e04,
    __addDisposableResource: $587e592597a56e11$export$88ac25d8e944e405,
    __disposeResources: $587e592597a56e11$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $587e592597a56e11$export$889dfb5d17574b0b
};

});

parcelRegister("2AWxB", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});


parcelRegister("jXblK", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("1urwW", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("jJBzg", function(module, exports) {
"use strict";
var $e5df5c7963016d05$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Wsxr = parcelRequire("7Wsxr");

var $e5df5c7963016d05$var$form_data_1 = $e5df5c7963016d05$var$__importDefault((parcelRequire("gGodY")));

var $kQznX = parcelRequire("kQznX");
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */ var $e5df5c7963016d05$var$isExtractableFileEnhanced = function(value) {
    return (0, $7Wsxr.isExtractableFile)(value) || value !== null && typeof value === "object" && typeof value.pipe === "function";
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */ function $e5df5c7963016d05$var$createRequestBody(query, variables, operationName, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $kQznX.defaultJsonSerializer;
    var _a = (0, $7Wsxr.extractFiles)({
        query: query,
        variables: variables,
        operationName: operationName
    }, "", $e5df5c7963016d05$var$isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) return jsonSerializer.stringify(clone);
        if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create request body with given variable type, array expected");
        // Batch support
        var payload = query.reduce(function(accu, currentQuery, index) {
            accu.push({
                query: currentQuery,
                variables: variables ? variables[index] : undefined
            });
            return accu;
        }, []);
        return jsonSerializer.stringify(payload);
    }
    var Form = typeof FormData === "undefined" ? $e5df5c7963016d05$var$form_data_1.default : FormData;
    var form = new Form();
    form.append("operations", jsonSerializer.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function(paths) {
        map[++i] = paths;
    });
    form.append("map", jsonSerializer.stringify(map));
    i = 0;
    files.forEach(function(paths, file) {
        form.append("".concat(++i), file);
    });
    return form;
}
module.exports.default = $e5df5c7963016d05$var$createRequestBody;

});
parcelRegister("7Wsxr", function(module, exports) {

$parcel$export(module.exports, "extractFiles", function () { return $017e005c1a243415$export$f5544efc2684376b; }, function (v) { return $017e005c1a243415$export$f5544efc2684376b = v; });
$parcel$export(module.exports, "isExtractableFile", function () { return $017e005c1a243415$export$f892d0f8e65523c3; }, function (v) { return $017e005c1a243415$export$f892d0f8e65523c3 = v; });
var $017e005c1a243415$export$5fcafa2ee375e60a;
var $017e005c1a243415$export$f5544efc2684376b;
var $017e005c1a243415$export$f892d0f8e65523c3;
"use strict";

$017e005c1a243415$export$5fcafa2ee375e60a = (parcelRequire("ceUxG"));

$017e005c1a243415$export$f5544efc2684376b = (parcelRequire("3kqQK"));

$017e005c1a243415$export$f892d0f8e65523c3 = (parcelRequire("1TebU"));

});
parcelRegister("ceUxG", function(module, exports) {
"use strict";
module.exports = function ReactNativeFile(_ref) {
    var uri = _ref.uri, name = _ref.name, type = _ref.type;
    this.uri = uri;
    this.name = name;
    this.type = type;
};

});

parcelRegister("3kqQK", function(module, exports) {
"use strict";

var $1TebU = parcelRequire("1TebU");
module.exports = function extractFiles(value, path, isExtractableFile) {
    if (path === void 0) path = "";
    if (isExtractableFile === void 0) isExtractableFile = $1TebU;
    var clone;
    var files = new Map();
    function addFile(paths, file) {
        var storedPaths = files.get(file);
        if (storedPaths) storedPaths.push.apply(storedPaths, paths);
        else files.set(file, paths);
    }
    if (isExtractableFile(value)) {
        clone = null;
        addFile([
            path
        ], value);
    } else {
        var prefix = path ? path + "." : "";
        if (typeof FileList !== "undefined" && value instanceof FileList) clone = Array.prototype.map.call(value, function(file, i) {
            addFile([
                "" + prefix + i
            ], file);
            return null;
        });
        else if (Array.isArray(value)) clone = value.map(function(child, i) {
            var result = extractFiles(child, "" + prefix + i, isExtractableFile);
            result.files.forEach(addFile);
            return result.clone;
        });
        else if (value && value.constructor === Object) {
            clone = {};
            for(var i in value){
                var result = extractFiles(value[i], "" + prefix + i, isExtractableFile);
                result.files.forEach(addFile);
                clone[i] = result.clone;
            }
        } else clone = value;
    }
    return {
        clone: clone,
        files: files
    };
};

});
parcelRegister("1TebU", function(module, exports) {
"use strict";

var $ceUxG = parcelRequire("ceUxG");
module.exports = function isExtractableFile(value) {
    return typeof File !== "undefined" && value instanceof File || typeof Blob !== "undefined" && value instanceof Blob || value instanceof $ceUxG;
};

});



parcelRegister("gGodY", function(module, exports) {
/* eslint-env browser */ module.exports = typeof self == "object" ? self.FormData : window.FormData;

});

parcelRegister("kQznX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultJsonSerializer = void 0;
module.exports.defaultJsonSerializer = {
    parse: JSON.parse,
    stringify: JSON.stringify
};

});


parcelRegister("iUPDz", function(module, exports) {
"use strict";
var $dc55830b9f296012$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $e9dLG = parcelRequire("e9dLG");
module.exports = function hasNativeSymbols() {
    if (typeof $dc55830b9f296012$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $dc55830b9f296012$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $e9dLG();
};

});
parcelRegister("e9dLG", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("ev4d3", function(module, exports) {
"use strict";
var $a8e739dcd1ce8602$var$test = {
    __proto__: null,
    foo: {}
};
var $a8e739dcd1ce8602$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a8e739dcd1ce8602$var$test
    }).foo === $a8e739dcd1ce8602$var$test.foo && !($a8e739dcd1ce8602$var$test instanceof $a8e739dcd1ce8602$var$$Object);
};

});

parcelRegister("g83Bu", function(module, exports) {
"use strict";

var $32FwR = parcelRequire("32FwR");
var $bbe03051f7a8bcdb$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$32FwR;
};
$bbe03051f7a8bcdb$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$32FwR) return null;
    try {
        return $32FwR([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $bbe03051f7a8bcdb$var$hasPropertyDescriptors;

});
parcelRegister("32FwR", function(module, exports) {
"use strict";

var $9Jpsw = parcelRequire("9Jpsw");
/** @type {import('.')} */ var $2371c5d12f6dea3b$var$$defineProperty = $9Jpsw("%Object.defineProperty%", true) || false;
if ($2371c5d12f6dea3b$var$$defineProperty) try {
    $2371c5d12f6dea3b$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $2371c5d12f6dea3b$var$$defineProperty = false;
}
module.exports = $2371c5d12f6dea3b$var$$defineProperty;

});
parcelRegister("9Jpsw", function(module, exports) {
"use strict";
var $715c10aae9ddb624$var$undefined1;

var $jfz5u = parcelRequire("jfz5u");

var $8cJld = parcelRequire("8cJld");

var $s6Age = parcelRequire("s6Age");

var $hBCJm = parcelRequire("hBCJm");

var $73Rnx = parcelRequire("73Rnx");

var $lC2xF = parcelRequire("lC2xF");

var $26Jqe = parcelRequire("26Jqe");
var $715c10aae9ddb624$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $715c10aae9ddb624$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $715c10aae9ddb624$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $715c10aae9ddb624$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($715c10aae9ddb624$var$$gOPD) try {
    $715c10aae9ddb624$var$$gOPD({}, "");
} catch (e) {
    $715c10aae9ddb624$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $715c10aae9ddb624$var$throwTypeError = function() {
    throw new $lC2xF();
};
var $715c10aae9ddb624$var$ThrowTypeError = $715c10aae9ddb624$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $715c10aae9ddb624$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $715c10aae9ddb624$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $715c10aae9ddb624$var$throwTypeError;
        }
    }
}() : $715c10aae9ddb624$var$throwTypeError;

var $715c10aae9ddb624$var$hasSymbols = (parcelRequire("iUPDz"))();

var $715c10aae9ddb624$var$hasProto = (parcelRequire("ev4d3"))();
var $715c10aae9ddb624$var$getProto = Object.getPrototypeOf || ($715c10aae9ddb624$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $715c10aae9ddb624$var$needsEval = {};
var $715c10aae9ddb624$var$TypedArray = typeof Uint8Array === "undefined" || !$715c10aae9ddb624$var$getProto ? undefined : $715c10aae9ddb624$var$getProto(Uint8Array);
var $715c10aae9ddb624$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $715c10aae9ddb624$var$hasSymbols && $715c10aae9ddb624$var$getProto ? $715c10aae9ddb624$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $715c10aae9ddb624$var$needsEval,
    "%AsyncGenerator%": $715c10aae9ddb624$var$needsEval,
    "%AsyncGeneratorFunction%": $715c10aae9ddb624$var$needsEval,
    "%AsyncIteratorPrototype%": $715c10aae9ddb624$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $jfz5u,
    "%eval%": eval,
    "%EvalError%": $8cJld,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $715c10aae9ddb624$var$$Function,
    "%GeneratorFunction%": $715c10aae9ddb624$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $715c10aae9ddb624$var$hasSymbols && $715c10aae9ddb624$var$getProto ? $715c10aae9ddb624$var$getProto($715c10aae9ddb624$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$715c10aae9ddb624$var$hasSymbols || !$715c10aae9ddb624$var$getProto ? undefined : $715c10aae9ddb624$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $s6Age,
    "%ReferenceError%": $hBCJm,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$715c10aae9ddb624$var$hasSymbols || !$715c10aae9ddb624$var$getProto ? undefined : $715c10aae9ddb624$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $715c10aae9ddb624$var$hasSymbols && $715c10aae9ddb624$var$getProto ? $715c10aae9ddb624$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $715c10aae9ddb624$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $73Rnx,
    "%ThrowTypeError%": $715c10aae9ddb624$var$ThrowTypeError,
    "%TypedArray%": $715c10aae9ddb624$var$TypedArray,
    "%TypeError%": $lC2xF,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $26Jqe,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($715c10aae9ddb624$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $715c10aae9ddb624$var$errorProto = $715c10aae9ddb624$var$getProto($715c10aae9ddb624$var$getProto(e));
    $715c10aae9ddb624$var$INTRINSICS["%Error.prototype%"] = $715c10aae9ddb624$var$errorProto;
}
var $715c10aae9ddb624$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $715c10aae9ddb624$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $715c10aae9ddb624$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $715c10aae9ddb624$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $715c10aae9ddb624$var$getProto) value = $715c10aae9ddb624$var$getProto(gen.prototype);
    }
    $715c10aae9ddb624$var$INTRINSICS[name] = value;
    return value;
};
var $715c10aae9ddb624$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $49cgi = parcelRequire("49cgi");

var $3wL0R = parcelRequire("3wL0R");
var $715c10aae9ddb624$var$$concat = $49cgi.call(Function.call, Array.prototype.concat);
var $715c10aae9ddb624$var$$spliceApply = $49cgi.call(Function.apply, Array.prototype.splice);
var $715c10aae9ddb624$var$$replace = $49cgi.call(Function.call, String.prototype.replace);
var $715c10aae9ddb624$var$$strSlice = $49cgi.call(Function.call, String.prototype.slice);
var $715c10aae9ddb624$var$$exec = $49cgi.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $715c10aae9ddb624$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $715c10aae9ddb624$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $715c10aae9ddb624$var$stringToPath = function stringToPath(string) {
    var first = $715c10aae9ddb624$var$$strSlice(string, 0, 1);
    var last = $715c10aae9ddb624$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $73Rnx("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $73Rnx("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $715c10aae9ddb624$var$$replace(string, $715c10aae9ddb624$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $715c10aae9ddb624$var$$replace(subString, $715c10aae9ddb624$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $715c10aae9ddb624$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($3wL0R($715c10aae9ddb624$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $715c10aae9ddb624$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($3wL0R($715c10aae9ddb624$var$INTRINSICS, intrinsicName)) {
        var value = $715c10aae9ddb624$var$INTRINSICS[intrinsicName];
        if (value === $715c10aae9ddb624$var$needsEval) value = $715c10aae9ddb624$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $lC2xF("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $73Rnx("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $lC2xF("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $lC2xF('"allowMissing" argument must be a boolean');
    if ($715c10aae9ddb624$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $73Rnx("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $715c10aae9ddb624$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $715c10aae9ddb624$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $715c10aae9ddb624$var$$spliceApply(parts, $715c10aae9ddb624$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $715c10aae9ddb624$var$$strSlice(part, 0, 1);
        var last = $715c10aae9ddb624$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $73Rnx("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($3wL0R($715c10aae9ddb624$var$INTRINSICS, intrinsicRealName)) value = $715c10aae9ddb624$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $lC2xF("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($715c10aae9ddb624$var$$gOPD && i + 1 >= parts.length) {
                var desc = $715c10aae9ddb624$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $3wL0R(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $715c10aae9ddb624$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("jfz5u", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("8cJld", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("s6Age", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("hBCJm", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("73Rnx", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("lC2xF", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("26Jqe", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("49cgi", function(module, exports) {
"use strict";

var $lXjci = parcelRequire("lXjci");
module.exports = Function.prototype.bind || $lXjci;

});
parcelRegister("lXjci", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $ffbdffd53e4ff286$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $ffbdffd53e4ff286$var$toStr = Object.prototype.toString;
var $ffbdffd53e4ff286$var$max = Math.max;
var $ffbdffd53e4ff286$var$funcType = "[object Function]";
var $ffbdffd53e4ff286$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ffbdffd53e4ff286$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ffbdffd53e4ff286$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $ffbdffd53e4ff286$var$toStr.apply(target) !== $ffbdffd53e4ff286$var$funcType) throw new TypeError($ffbdffd53e4ff286$var$ERROR_MESSAGE + target);
    var args = $ffbdffd53e4ff286$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ffbdffd53e4ff286$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ffbdffd53e4ff286$var$concatty(args, arguments));
    };
    var boundLength = $ffbdffd53e4ff286$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $ffbdffd53e4ff286$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("3wL0R", function(module, exports) {
"use strict";
var $2918d4043b666958$var$call = Function.prototype.call;
var $2918d4043b666958$var$$hasOwn = Object.prototype.hasOwnProperty;

var $49cgi = parcelRequire("49cgi");
/** @type {import('.')} */ module.exports = $49cgi.call($2918d4043b666958$var$call, $2918d4043b666958$var$$hasOwn);

});




parcelRegister("aSeg7", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("719I9")).then(()=>parcelRequire("7Veeh"));

});
parcelRegister("irxbj", function(module, exports) {
"use strict";

var $iCvWv = parcelRequire("iCvWv");
module.exports = $iCvWv(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("iCvWv", function(module, exports) {
"use strict";
var $d8e48db9b2a0b275$var$cachedBundles = {};
var $d8e48db9b2a0b275$var$cachedPreloads = {};
var $d8e48db9b2a0b275$var$cachedPrefetches = {};
function $d8e48db9b2a0b275$var$getCache(type) {
    switch(type){
        case "preload":
            return $d8e48db9b2a0b275$var$cachedPreloads;
        case "prefetch":
            return $d8e48db9b2a0b275$var$cachedPrefetches;
        default:
            return $d8e48db9b2a0b275$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d8e48db9b2a0b275$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lt98C", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("54tP5")).then(()=>parcelRequire("7Xwd1"));

});

parcelRegister("iT6wj", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("lc03K")).then(()=>parcelRequire("f12km"));

});

parcelRegister("4Uyh8", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("kbbmQ")).then(()=>parcelRequire("iIaFn"));

});

parcelRegister("l3WBs", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("ktj6O")).then(()=>parcelRequire("lCdwY"));

});

parcelRegister("gDYCL", function(module, exports) {


module.exports = (parcelRequire("irxbj"))((parcelRequire("j92NM")).resolve("11IM3")).then(()=>parcelRequire("2c7Uc"));

});

parcelRegister("g9V0c", function(module, exports) {
"use strict";
var $bc39b40df96437f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bc39b40df96437f2$var$HTMLDOMParser;

var $bc39b40df96437f2$var$domparser_1 = $bc39b40df96437f2$var$__importDefault((parcelRequire("kEStH")));

var $fULlC = parcelRequire("fULlC");
var $bc39b40df96437f2$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
/**
 * Parses HTML string to DOM nodes in browser.
 *
 * @param html - HTML markup.
 * @returns - DOM elements.
 */ function $bc39b40df96437f2$var$HTMLDOMParser(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    // match directive
    var match = html.match($bc39b40df96437f2$var$DIRECTIVE_REGEX);
    var directive = match ? match[1] : undefined;
    return (0, $fULlC.formatDOM)((0, $bc39b40df96437f2$var$domparser_1.default)(html), null, directive);
}

});
parcelRegister("kEStH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0a1cd46f9b64204$var$domparser;

var $fULlC = parcelRequire("fULlC");
// constants
var $f0a1cd46f9b64204$var$HTML = "html";
var $f0a1cd46f9b64204$var$HEAD = "head";
var $f0a1cd46f9b64204$var$BODY = "body";
var $f0a1cd46f9b64204$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var $f0a1cd46f9b64204$var$HEAD_TAG_REGEX = /<head[^]*>/i;
var $f0a1cd46f9b64204$var$BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $f0a1cd46f9b64204$var$parseFromDocument = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var $f0a1cd46f9b64204$var$parseFromString = function(html, tagName) {
    /* istanbul ignore next */ throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var $f0a1cd46f9b64204$var$DOMParser = typeof window === "object" && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof $f0a1cd46f9b64204$var$DOMParser === "function") {
    var $f0a1cd46f9b64204$var$domParser_1 = new $f0a1cd46f9b64204$var$DOMParser();
    var $f0a1cd46f9b64204$var$mimeType_1 = "text/html";
    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document.
     */ $f0a1cd46f9b64204$var$parseFromString = function(html, tagName) {
        if (tagName) /* istanbul ignore next */ html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
        return $f0a1cd46f9b64204$var$domParser_1.parseFromString(html, $f0a1cd46f9b64204$var$mimeType_1);
    };
    $f0a1cd46f9b64204$var$parseFromDocument = $f0a1cd46f9b64204$var$parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (typeof document === "object" && document.implementation) {
    var $f0a1cd46f9b64204$var$htmlDocument_1 = document.implementation.createHTMLDocument();
    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param html - The HTML string.
     * @param tagName - The element to render the HTML (with 'body' as fallback).
     * @returns - Document
     */ $f0a1cd46f9b64204$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            var element = $f0a1cd46f9b64204$var$htmlDocument_1.documentElement.querySelector(tagName);
            if (element) element.innerHTML = html;
            return $f0a1cd46f9b64204$var$htmlDocument_1;
        }
        $f0a1cd46f9b64204$var$htmlDocument_1.documentElement.innerHTML = html;
        return $f0a1cd46f9b64204$var$htmlDocument_1;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $f0a1cd46f9b64204$var$template = typeof document === "object" && document.createElement("template");
var $f0a1cd46f9b64204$var$parseFromTemplate;
if ($f0a1cd46f9b64204$var$template && $f0a1cd46f9b64204$var$template.content) /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param html - HTML string.
     * @returns - Nodes.
     */ $f0a1cd46f9b64204$var$parseFromTemplate = function(html) {
    $f0a1cd46f9b64204$var$template.innerHTML = html;
    return $f0a1cd46f9b64204$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param html - HTML markup.
 * @returns - DOM nodes.
 */ function $f0a1cd46f9b64204$var$domparser(html) {
    var _a, _b;
    // Escape special characters before parsing
    html = (0, $fULlC.escapeSpecialCharacters)(html);
    var match = html.match($f0a1cd46f9b64204$var$FIRST_TAG_REGEX);
    var firstTagName = match && match[1] ? match[1].toLowerCase() : "";
    switch(firstTagName){
        case $f0a1cd46f9b64204$var$HTML:
            var doc = $f0a1cd46f9b64204$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$f0a1cd46f9b64204$var$HEAD_TAG_REGEX.test(html)) {
                var element = doc.querySelector($f0a1cd46f9b64204$var$HEAD);
                (_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 || _a.removeChild(element);
            }
            if (!$f0a1cd46f9b64204$var$BODY_TAG_REGEX.test(html)) {
                var element = doc.querySelector($f0a1cd46f9b64204$var$BODY);
                (_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 || _b.removeChild(element);
            }
            return doc.querySelectorAll($f0a1cd46f9b64204$var$HTML);
        case $f0a1cd46f9b64204$var$HEAD:
        case $f0a1cd46f9b64204$var$BODY:
            var elements = $f0a1cd46f9b64204$var$parseFromDocument(html).querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if ($f0a1cd46f9b64204$var$BODY_TAG_REGEX.test(html) && $f0a1cd46f9b64204$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($f0a1cd46f9b64204$var$parseFromTemplate) return $f0a1cd46f9b64204$var$parseFromTemplate(html);
            var element = $f0a1cd46f9b64204$var$parseFromDocument(html, $f0a1cd46f9b64204$var$BODY).querySelector($f0a1cd46f9b64204$var$BODY);
            return element.childNodes;
    }
}

});
parcelRegister("fULlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatAttributes = $b960d03f1e403c91$var$formatAttributes;
module.exports.escapeSpecialCharacters = $b960d03f1e403c91$var$escapeSpecialCharacters;
module.exports.revertEscapedCharacters = $b960d03f1e403c91$var$revertEscapedCharacters;
module.exports.formatDOM = $b960d03f1e403c91$var$formatDOM;

var $1SGOC = parcelRequire("1SGOC");

var $bgcwB = parcelRequire("bgcwB");
/**
 * Gets case-sensitive tag name.
 *
 * @param tagName - Tag name in lowercase.
 * @returns - Case-sensitive tag name.
 */ function $b960d03f1e403c91$var$getCaseSensitiveTagName(tagName) {
    return $bgcwB.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param attributes - List of attributes.
 * @returns - Map of attribute name to value.
 */ function $b960d03f1e403c91$var$formatAttributes(attributes) {
    var map = {};
    var index = 0;
    var attributesLength = attributes.length;
    // `NamedNodeMap` is array-like
    for(; index < attributesLength; index++){
        var attribute = attributes[index];
        map[attribute.name] = attribute.value;
    }
    return map;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param tagName - Lowercase tag name.
 * @returns - Formatted tag name.
 */ function $b960d03f1e403c91$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $b960d03f1e403c91$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Escapes special characters before parsing.
 *
 * @param html - The HTML string.
 * @returns - HTML string with escaped special characters.
 */ function $b960d03f1e403c91$var$escapeSpecialCharacters(html) {
    return html.replace($bgcwB.CARRIAGE_RETURN_REGEX, $bgcwB.CARRIAGE_RETURN_PLACEHOLDER);
}
/**
 * Reverts escaped special characters back to actual characters.
 *
 * @param text - The text with escaped characters.
 * @returns - Text with escaped characters reverted.
 */ function $b960d03f1e403c91$var$revertEscapedCharacters(text) {
    return text.replace($bgcwB.CARRIAGE_RETURN_PLACEHOLDER_REGEX, $bgcwB.CARRIAGE_RETURN);
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param nodes - DOM nodes.
 * @param parent - Parent node.
 * @param directive - Directive.
 * @returns - Nodes.
 */ function $b960d03f1e403c91$var$formatDOM(nodes, parent, directive) {
    if (parent === void 0) parent = null;
    var domNodes = [];
    var current;
    var index = 0;
    var nodesLength = nodes.length;
    for(; index < nodesLength; index++){
        var node = nodes[index];
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                var tagName = $b960d03f1e403c91$var$formatTagName(node.nodeName);
                // script, style, or tag
                current = new $1SGOC.Element(tagName, $b960d03f1e403c91$var$formatAttributes(node.attributes));
                current.children = $b960d03f1e403c91$var$formatDOM(// template children are on content
                tagName === "template" ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new $1SGOC.Text($b960d03f1e403c91$var$revertEscapedCharacters(node.nodeValue));
                break;
            case 8:
                current = new $1SGOC.Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = domNodes[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        domNodes.push(current);
    }
    if (directive) {
        current = new $1SGOC.ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = domNodes[0] || null;
        current.parent = parent;
        domNodes.unshift(current);
        if (domNodes[1]) domNodes[1].prev = domNodes[0];
    }
    return domNodes;
}

});
parcelRegister("1SGOC", function(module, exports) {
"use strict";
var $15ec0bd3486615ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $15ec0bd3486615ae$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $15ec0bd3486615ae$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $eqgYf = parcelRequire("eqgYf");


$15ec0bd3486615ae$var$__exportStar((parcelRequire("dgaKt")), module.exports);
// Default options
var $15ec0bd3486615ae$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $15ec0bd3486615ae$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("dgaKt")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $15ec0bd3486615ae$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $15ec0bd3486615ae$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("dgaKt")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $eqgYf.ElementType.Tag : undefined;
        var element = new (parcelRequire("dgaKt")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $eqgYf.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            var node = new (parcelRequire("dgaKt")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $eqgYf.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("dgaKt")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("dgaKt")).Text("");
        var node = new (parcelRequire("dgaKt")).CDATA([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("dgaKt")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $15ec0bd3486615ae$var$DomHandler;
module.exports.default = $15ec0bd3486615ae$var$DomHandler;

});
parcelRegister("eqgYf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $a800a86eb35e71d8$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($a800a86eb35e71d8$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $a800a86eb35e71d8$var$isTag(elem) {
    return elem.type === $a800a86eb35e71d8$var$ElementType.Tag || elem.type === $a800a86eb35e71d8$var$ElementType.Script || elem.type === $a800a86eb35e71d8$var$ElementType.Style;
}
module.exports.isTag = $a800a86eb35e71d8$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $a800a86eb35e71d8$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $a800a86eb35e71d8$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $a800a86eb35e71d8$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $a800a86eb35e71d8$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $a800a86eb35e71d8$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $a800a86eb35e71d8$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $a800a86eb35e71d8$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $a800a86eb35e71d8$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $a800a86eb35e71d8$var$ElementType.Doctype;

});

parcelRegister("dgaKt", function(module, exports) {
"use strict";
var $9a751b6fb040ec67$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9a751b6fb040ec67$var$__assign = module.exports && module.exports.__assign || function() {
    $9a751b6fb040ec67$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9a751b6fb040ec67$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.CDATA = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $eqgYf = parcelRequire("eqgYf");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $9a751b6fb040ec67$var$Node = /** @class */ function() {
    function Node() {
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $9a751b6fb040ec67$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $9a751b6fb040ec67$var$Node;
/**
 * A node that contains some data.
 */ var $9a751b6fb040ec67$var$DataNode = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */ function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($9a751b6fb040ec67$var$Node);
module.exports.DataNode = $9a751b6fb040ec67$var$DataNode;
/**
 * Text within the document.
 */ var $9a751b6fb040ec67$var$Text = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function() {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}($9a751b6fb040ec67$var$DataNode);
module.exports.Text = $9a751b6fb040ec67$var$Text;
/**
 * Comments within the document.
 */ var $9a751b6fb040ec67$var$Comment = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function() {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}($9a751b6fb040ec67$var$DataNode);
module.exports.Comment = $9a751b6fb040ec67$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $9a751b6fb040ec67$var$ProcessingInstruction = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = $eqgYf.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}($9a751b6fb040ec67$var$DataNode);
module.exports.ProcessingInstruction = $9a751b6fb040ec67$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $9a751b6fb040ec67$var$NodeWithChildren = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($9a751b6fb040ec67$var$Node);
module.exports.NodeWithChildren = $9a751b6fb040ec67$var$NodeWithChildren;
var $9a751b6fb040ec67$var$CDATA = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function() {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}($9a751b6fb040ec67$var$NodeWithChildren);
module.exports.CDATA = $9a751b6fb040ec67$var$CDATA;
/**
 * The root node of the document.
 */ var $9a751b6fb040ec67$var$Document = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function() {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}($9a751b6fb040ec67$var$NodeWithChildren);
module.exports.Document = $9a751b6fb040ec67$var$Document;
/**
 * An element within the DOM.
 */ var $9a751b6fb040ec67$var$Element = /** @class */ function(_super) {
    $9a751b6fb040ec67$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $eqgYf.ElementType.Script : name === "style" ? $eqgYf.ElementType.Style : $eqgYf.ElementType.Tag;
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($9a751b6fb040ec67$var$NodeWithChildren);
module.exports.Element = $9a751b6fb040ec67$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isTag(node) {
    return (0, $eqgYf.isTag)(node);
}
module.exports.isTag = $9a751b6fb040ec67$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isCDATA(node) {
    return node.type === $eqgYf.ElementType.CDATA;
}
module.exports.isCDATA = $9a751b6fb040ec67$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isText(node) {
    return node.type === $eqgYf.ElementType.Text;
}
module.exports.isText = $9a751b6fb040ec67$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isComment(node) {
    return node.type === $eqgYf.ElementType.Comment;
}
module.exports.isComment = $9a751b6fb040ec67$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isDirective(node) {
    return node.type === $eqgYf.ElementType.Directive;
}
module.exports.isDirective = $9a751b6fb040ec67$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $9a751b6fb040ec67$var$isDocument(node) {
    return node.type === $eqgYf.ElementType.Root;
}
module.exports.isDocument = $9a751b6fb040ec67$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ function $9a751b6fb040ec67$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $9a751b6fb040ec67$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $9a751b6fb040ec67$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($9a751b6fb040ec67$var$isText(node)) result = new $9a751b6fb040ec67$var$Text(node.data);
    else if ($9a751b6fb040ec67$var$isComment(node)) result = new $9a751b6fb040ec67$var$Comment(node.data);
    else if ($9a751b6fb040ec67$var$isTag(node)) {
        var children = recursive ? $9a751b6fb040ec67$var$cloneChildren(node.children) : [];
        var clone_1 = new $9a751b6fb040ec67$var$Element(node.name, $9a751b6fb040ec67$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $9a751b6fb040ec67$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $9a751b6fb040ec67$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($9a751b6fb040ec67$var$isCDATA(node)) {
        var children = recursive ? $9a751b6fb040ec67$var$cloneChildren(node.children) : [];
        var clone_2 = new $9a751b6fb040ec67$var$CDATA(children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($9a751b6fb040ec67$var$isDocument(node)) {
        var children = recursive ? $9a751b6fb040ec67$var$cloneChildren(node.children) : [];
        var clone_3 = new $9a751b6fb040ec67$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($9a751b6fb040ec67$var$isDirective(node)) {
        var instruction = new $9a751b6fb040ec67$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $9a751b6fb040ec67$var$cloneNode;
function $9a751b6fb040ec67$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $9a751b6fb040ec67$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});


parcelRegister("bgcwB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = module.exports.CARRIAGE_RETURN_PLACEHOLDER = module.exports.CARRIAGE_RETURN_REGEX = module.exports.CARRIAGE_RETURN = module.exports.CASE_SENSITIVE_TAG_NAMES_MAP = module.exports.CASE_SENSITIVE_TAG_NAMES = void 0;
/**
 * SVG elements are case-sensitive.
 *
 * @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
 */ module.exports.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];
module.exports.CASE_SENSITIVE_TAG_NAMES_MAP = module.exports.CASE_SENSITIVE_TAG_NAMES.reduce(function(accumulator, tagName) {
    accumulator[tagName.toLowerCase()] = tagName;
    return accumulator;
}, {});
module.exports.CARRIAGE_RETURN = "\r";
module.exports.CARRIAGE_RETURN_REGEX = new RegExp(module.exports.CARRIAGE_RETURN, "g");
module.exports.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__");
module.exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(module.exports.CARRIAGE_RETURN_PLACEHOLDER, "g");

});




parcelRegister("6wuhd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4bfd378ef61d9e23$var$attributesToProps;

var $kXGrl = parcelRequire("kXGrl");

var $jCRx8 = parcelRequire("jCRx8");
// https://react.dev/learn/sharing-state-between-components#controlled-and-uncontrolled-components
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var $4bfd378ef61d9e23$var$UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    "checked",
    "value"
];
var $4bfd378ef61d9e23$var$UNCONTROLLED_COMPONENT_NAMES = [
    "input",
    "select",
    "textarea"
];
var $4bfd378ef61d9e23$var$valueOnlyInputs = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param attributes - HTML/SVG DOM attributes.
 * @param nodeName - DOM node name.
 * @returns - React props.
 */ function $4bfd378ef61d9e23$var$attributesToProps(attributes, nodeName) {
    if (attributes === void 0) attributes = {};
    var props = {};
    var isInputValueOnly = Boolean(attributes.type && $4bfd378ef61d9e23$var$valueOnlyInputs[attributes.type]);
    for(var attributeName in attributes){
        var attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ((0, $kXGrl.isCustomAttribute)(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        var attributeNameLowerCased = attributeName.toLowerCase();
        var propName = $4bfd378ef61d9e23$var$getPropName(attributeNameLowerCased);
        if (propName) {
            var propertyInfo = (0, $kXGrl.getPropertyInfo)(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if ($4bfd378ef61d9e23$var$UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && $4bfd378ef61d9e23$var$UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) propName = $4bfd378ef61d9e23$var$getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $kXGrl.BOOLEAN:
                    props[propName] = true;
                    break;
                case $kXGrl.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($jCRx8.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    (0, $jCRx8.setStyleProp)(attributes.style, props);
    return props;
}
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $4bfd378ef61d9e23$var$getPropName(attributeName) {
    return $kXGrl.possibleStandardNames[attributeName];
}

});
parcelRegister("kXGrl", function(module, exports) {

$parcel$export(module.exports, "BOOLEAN", function () { return $f42a3d0569f39095$export$428cfe48a69a3b4f; }, function (v) { return $f42a3d0569f39095$export$428cfe48a69a3b4f = v; });
$parcel$export(module.exports, "OVERLOADED_BOOLEAN", function () { return $f42a3d0569f39095$export$91da4d9e9b612643; }, function (v) { return $f42a3d0569f39095$export$91da4d9e9b612643 = v; });
$parcel$export(module.exports, "getPropertyInfo", function () { return $f42a3d0569f39095$export$fd64a1f33de3651a; }, function (v) { return $f42a3d0569f39095$export$fd64a1f33de3651a = v; });
$parcel$export(module.exports, "isCustomAttribute", function () { return $f42a3d0569f39095$export$d89f61ed80c87270; }, function (v) { return $f42a3d0569f39095$export$d89f61ed80c87270 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $f42a3d0569f39095$export$bbecfff5ecf65cd8; }, function (v) { return $f42a3d0569f39095$export$bbecfff5ecf65cd8 = v; });
var $f42a3d0569f39095$export$428cfe48a69a3b4f;
var $f42a3d0569f39095$export$d7e6493a7bfdb8c1;
var $f42a3d0569f39095$export$4d318981b5a83836;
var $f42a3d0569f39095$export$91da4d9e9b612643;
var $f42a3d0569f39095$export$39307127151c9810;
var $f42a3d0569f39095$export$75032a190741fbaf;
var $f42a3d0569f39095$export$a0e01ba2ebef17f2;
var $f42a3d0569f39095$export$fd64a1f33de3651a;
var $f42a3d0569f39095$export$d89f61ed80c87270;
var $f42a3d0569f39095$export$bbecfff5ecf65cd8;
"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
const $f42a3d0569f39095$var$RESERVED = 0;
// A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
const $f42a3d0569f39095$var$STRING = 1;
// A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
const $f42a3d0569f39095$var$BOOLEANISH_STRING = 2;
// A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
const $f42a3d0569f39095$var$BOOLEAN = 3;
// An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
const $f42a3d0569f39095$var$OVERLOADED_BOOLEAN = 4;
// An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
const $f42a3d0569f39095$var$NUMERIC = 5;
// An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
const $f42a3d0569f39095$var$POSITIVE_NUMERIC = 6;
function $f42a3d0569f39095$var$getPropertyInfo(name) {
    return $f42a3d0569f39095$var$properties.hasOwnProperty(name) ? $f42a3d0569f39095$var$properties[name] : null;
}
function $f42a3d0569f39095$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $f42a3d0569f39095$var$BOOLEANISH_STRING || type === $f42a3d0569f39095$var$BOOLEAN || type === $f42a3d0569f39095$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
}
// When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
const $f42a3d0569f39095$var$properties = {};
// These props are reserved by React. They shouldn't be written to the DOM.
const $f42a3d0569f39095$var$reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // TODO: This prevents the assignment of defaultValue to regular
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
$f42a3d0569f39095$var$reservedProps.forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$RESERVED, false, name, null, false, false);
});
// A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(([name, attributeName])=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$STRING, false, attributeName, null, false, false);
});
// These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
});
// These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$BOOLEANISH_STRING, false, name, null, false, false);
});
// These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // Note: there is a special case that prevents it from being written to the DOM
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    // Microdata
    "itemScope"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
});
// These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // Note: `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$BOOLEAN, true, name, null, false, false);
});
// These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
});
// These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$POSITIVE_NUMERIC, false, name, null, false, false);
});
// These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach((name)=>{
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
const $f42a3d0569f39095$var$CAMELIZE = /[\-\:]([a-z])/g;
const $f42a3d0569f39095$var$capitalize = (token)=>token[1].toUpperCase();
// This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height"
].forEach((attributeName)=>{
    const name = attributeName.replace($f42a3d0569f39095$var$CAMELIZE, $f42a3d0569f39095$var$capitalize);
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$STRING, false, attributeName, null, false, false);
});
// String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type"
].forEach((attributeName)=>{
    const name = attributeName.replace($f42a3d0569f39095$var$CAMELIZE, $f42a3d0569f39095$var$capitalize);
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
});
// String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach((attributeName)=>{
    const name = attributeName.replace($f42a3d0569f39095$var$CAMELIZE, $f42a3d0569f39095$var$capitalize);
    $f42a3d0569f39095$var$properties[name] = new $f42a3d0569f39095$var$PropertyInfoRecord(name, $f42a3d0569f39095$var$STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
});
// These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach((attributeName)=>{
    $f42a3d0569f39095$var$properties[attributeName] = new $f42a3d0569f39095$var$PropertyInfoRecord(attributeName, $f42a3d0569f39095$var$STRING, false, attributeName.toLowerCase(), null, false, false);
});
// These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
const $f42a3d0569f39095$var$xlinkHref = "xlinkHref";
$f42a3d0569f39095$var$properties[$f42a3d0569f39095$var$xlinkHref] = new $f42a3d0569f39095$var$PropertyInfoRecord("xlinkHref", $f42a3d0569f39095$var$STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach((attributeName)=>{
    $f42a3d0569f39095$var$properties[attributeName] = new $f42a3d0569f39095$var$PropertyInfoRecord(attributeName, $f42a3d0569f39095$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});

var $hLVbZ = parcelRequire("hLVbZ");
var $f42a3d0569f39095$require$CAMELCASE = $hLVbZ.CAMELCASE;
var $f42a3d0569f39095$require$SAME = $hLVbZ.SAME;
var $f42a3d0569f39095$require$possibleStandardNamesOptimized = $hLVbZ.possibleStandardNames;
const $f42a3d0569f39095$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
const $f42a3d0569f39095$var$ATTRIBUTE_NAME_CHAR = $f42a3d0569f39095$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
 *
 * @type {(attribute: string) => boolean}
 */ const $f42a3d0569f39095$var$isCustomAttribute = RegExp.prototype.test.bind(// eslint-disable-next-line no-misleading-character-class
new RegExp("^(data|aria)-[" + $f42a3d0569f39095$var$ATTRIBUTE_NAME_CHAR + "]*$"));
/**
 * @type {Record<string, string>}
 */ const $f42a3d0569f39095$var$possibleStandardNames = Object.keys($f42a3d0569f39095$require$possibleStandardNamesOptimized).reduce((accumulator, standardName)=>{
    const propName = $f42a3d0569f39095$require$possibleStandardNamesOptimized[standardName];
    if (propName === $f42a3d0569f39095$require$SAME) accumulator[standardName] = standardName;
    else if (propName === $f42a3d0569f39095$require$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$f42a3d0569f39095$export$428cfe48a69a3b4f = $f42a3d0569f39095$var$BOOLEAN;
$f42a3d0569f39095$export$d7e6493a7bfdb8c1 = $f42a3d0569f39095$var$BOOLEANISH_STRING;
$f42a3d0569f39095$export$4d318981b5a83836 = $f42a3d0569f39095$var$NUMERIC;
$f42a3d0569f39095$export$91da4d9e9b612643 = $f42a3d0569f39095$var$OVERLOADED_BOOLEAN;
$f42a3d0569f39095$export$39307127151c9810 = $f42a3d0569f39095$var$POSITIVE_NUMERIC;
$f42a3d0569f39095$export$75032a190741fbaf = $f42a3d0569f39095$var$RESERVED;
$f42a3d0569f39095$export$a0e01ba2ebef17f2 = $f42a3d0569f39095$var$STRING;
$f42a3d0569f39095$export$fd64a1f33de3651a = $f42a3d0569f39095$var$getPropertyInfo;
$f42a3d0569f39095$export$d89f61ed80c87270 = $f42a3d0569f39095$var$isCustomAttribute;
$f42a3d0569f39095$export$bbecfff5ecf65cd8 = $f42a3d0569f39095$var$possibleStandardNames;

});
parcelRegister("hLVbZ", function(module, exports) {

$parcel$export(module.exports, "SAME", function () { return $cf0330aff7f3e65b$export$7359a57b3ac1f378; }, function (v) { return $cf0330aff7f3e65b$export$7359a57b3ac1f378 = v; });
$parcel$export(module.exports, "CAMELCASE", function () { return $cf0330aff7f3e65b$export$5ab28d07cff57c11; }, function (v) { return $cf0330aff7f3e65b$export$5ab28d07cff57c11 = v; });
$parcel$export(module.exports, "possibleStandardNames", function () { return $cf0330aff7f3e65b$export$bbecfff5ecf65cd8; }, function (v) { return $cf0330aff7f3e65b$export$bbecfff5ecf65cd8 = v; });
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $cf0330aff7f3e65b$export$7359a57b3ac1f378;
var $cf0330aff7f3e65b$export$5ab28d07cff57c11;
var $cf0330aff7f3e65b$export$bbecfff5ecf65cd8;
var $cf0330aff7f3e65b$var$SAME = 0;
$cf0330aff7f3e65b$export$7359a57b3ac1f378 = $cf0330aff7f3e65b$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $cf0330aff7f3e65b$var$CAMELCASE = 1;
$cf0330aff7f3e65b$export$5ab28d07cff57c11 = $cf0330aff7f3e65b$var$CAMELCASE;
$cf0330aff7f3e65b$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};

});


parcelRegister("jCRx8", function(module, exports) {
"use strict";
var $e49b1793caa8cba9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.returnFirstArg = module.exports.canTextBeChildOfNode = module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = module.exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
module.exports.isCustomComponent = $e49b1793caa8cba9$var$isCustomComponent;
module.exports.setStyleProp = $e49b1793caa8cba9$var$setStyleProp;

var $eZVvM = parcelRequire("eZVvM");

var $e49b1793caa8cba9$var$style_to_js_1 = $e49b1793caa8cba9$var$__importDefault((parcelRequire("f3er4")));
var $e49b1793caa8cba9$var$RESERVED_SVG_MATHML_ELEMENTS = new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
]);
/**
 * Check if a tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param tagName - Tag name.
 * @param props - Props passed to the element.
 * @returns - Whether the tag is custom component.
 */ function $e49b1793caa8cba9$var$isCustomComponent(tagName, props) {
    if (!tagName.includes("-")) return Boolean(props && typeof props.is === "string");
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    if ($e49b1793caa8cba9$var$RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
    return true;
}
var $e49b1793caa8cba9$var$styleOptions = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param style - Inline style.
 * @param props - Props object.
 */ function $e49b1793caa8cba9$var$setStyleProp(style, props) {
    if (typeof style !== "string") return;
    if (!style.trim()) {
        props.style = {};
        return;
    }
    try {
        props.style = (0, $e49b1793caa8cba9$var$style_to_js_1.default)(style, $e49b1793caa8cba9$var$styleOptions);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        props.style = {};
    }
}
/**
 * @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
 */ module.exports.PRESERVE_CUSTOM_ATTRIBUTES = Number($eZVvM.version.split(".")[0]) >= 16;
/**
 * @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
 */ module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param node - Element node.
 * @returns - Whether the node can contain text nodes.
 */ var $e49b1793caa8cba9$var$canTextBeChildOfNode = function(node) {
    return !module.exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
};
module.exports.canTextBeChildOfNode = $e49b1793caa8cba9$var$canTextBeChildOfNode;
/**
 * Returns the first argument as is.
 *
 * @param arg - The argument to be returned.
 * @returns - The input argument `arg`.
 */ var $e49b1793caa8cba9$var$returnFirstArg = function(arg) {
    return arg;
};
module.exports.returnFirstArg = $e49b1793caa8cba9$var$returnFirstArg;

});
parcelRegister("f3er4", function(module, exports) {
"use strict";
var $af52557773bcc4b4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $af52557773bcc4b4$var$style_to_object_1 = $af52557773bcc4b4$var$__importDefault((parcelRequire("dg43g")));

var $k2JMr = parcelRequire("k2JMr");
/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $af52557773bcc4b4$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, $af52557773bcc4b4$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $k2JMr.camelCase)(property, options)] = value;
    });
    return output;
}
$af52557773bcc4b4$var$StyleToJS.default = $af52557773bcc4b4$var$StyleToJS;
module.exports = $af52557773bcc4b4$var$StyleToJS;

});
parcelRegister("dg43g", function(module, exports) {
"use strict";
var $9a6fe98a3b547b16$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a6fe98a3b547b16$var$StyleToObject;

var $9a6fe98a3b547b16$var$inline_style_parser_1 = $9a6fe98a3b547b16$var$__importDefault((parcelRequire("jm2wZ")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $9a6fe98a3b547b16$var$StyleToObject(style, iterator) {
    var styleObject = null;
    if (!style || typeof style !== "string") return styleObject;
    var declarations = (0, $9a6fe98a3b547b16$var$inline_style_parser_1.default)(style);
    var hasIterator = typeof iterator === "function";
    declarations.forEach(function(declaration) {
        if (declaration.type !== "declaration") return;
        var property = declaration.property, value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("jm2wZ", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $e172090372f0e482$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $e172090372f0e482$var$NEWLINE_REGEX = /\n/g;
var $e172090372f0e482$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $e172090372f0e482$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $e172090372f0e482$var$COLON_REGEX = /^:\s*/;
var $e172090372f0e482$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $e172090372f0e482$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $e172090372f0e482$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $e172090372f0e482$var$NEWLINE = "\n";
var $e172090372f0e482$var$FORWARD_SLASH = "/";
var $e172090372f0e482$var$ASTERISK = "*";
var $e172090372f0e482$var$EMPTY_STRING = "";
// types
var $e172090372f0e482$var$TYPE_COMMENT = "comment";
var $e172090372f0e482$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($e172090372f0e482$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($e172090372f0e482$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($e172090372f0e482$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($e172090372f0e482$var$FORWARD_SLASH != style.charAt(0) || $e172090372f0e482$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($e172090372f0e482$var$EMPTY_STRING != style.charAt(i) && ($e172090372f0e482$var$ASTERISK != style.charAt(i) || $e172090372f0e482$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($e172090372f0e482$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $e172090372f0e482$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($e172090372f0e482$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($e172090372f0e482$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($e172090372f0e482$var$VALUE_REGEX);
        var ret = pos({
            type: $e172090372f0e482$var$TYPE_DECLARATION,
            property: $e172090372f0e482$var$trim(prop[0].replace($e172090372f0e482$var$COMMENT_REGEX, $e172090372f0e482$var$EMPTY_STRING)),
            value: val ? $e172090372f0e482$var$trim(val[0].replace($e172090372f0e482$var$COMMENT_REGEX, $e172090372f0e482$var$EMPTY_STRING)) : $e172090372f0e482$var$EMPTY_STRING
        });
        // ;
        match($e172090372f0e482$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $e172090372f0e482$var$trim(str) {
    return str ? str.replace($e172090372f0e482$var$TRIM_REGEX, $e172090372f0e482$var$EMPTY_STRING) : $e172090372f0e482$var$EMPTY_STRING;
}

});


parcelRegister("k2JMr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camelCase = void 0;
var $e97781980c5a0d86$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $e97781980c5a0d86$var$HYPHEN_REGEX = /-([a-z])/g;
var $e97781980c5a0d86$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $e97781980c5a0d86$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $e97781980c5a0d86$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $e97781980c5a0d86$var$skipCamelCase = function(property) {
    return !property || $e97781980c5a0d86$var$NO_HYPHEN_REGEX.test(property) || $e97781980c5a0d86$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $e97781980c5a0d86$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $e97781980c5a0d86$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $e97781980c5a0d86$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($e97781980c5a0d86$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($e97781980c5a0d86$var$MS_VENDOR_PREFIX_REGEX, $e97781980c5a0d86$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($e97781980c5a0d86$var$VENDOR_PREFIX_REGEX, $e97781980c5a0d86$var$trimHyphen);
    return property.replace($e97781980c5a0d86$var$HYPHEN_REGEX, $e97781980c5a0d86$var$capitalize);
};
module.exports.camelCase = $e97781980c5a0d86$var$camelCase;

});




parcelRegister("65rH0", function(module, exports) {
"use strict";
var $46e8b0e1db0e5d60$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46e8b0e1db0e5d60$var$domToReact;

var $eZVvM = parcelRequire("eZVvM");

var $46e8b0e1db0e5d60$var$attributes_to_props_1 = $46e8b0e1db0e5d60$var$__importDefault((parcelRequire("6wuhd")));

var $jCRx8 = parcelRequire("jCRx8");
var $46e8b0e1db0e5d60$var$React = {
    cloneElement: $eZVvM.cloneElement,
    createElement: $eZVvM.createElement,
    isValidElement: $eZVvM.isValidElement
};
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param nodes - DOM nodes.
 * @param options - Options.
 * @returns - String or JSX element(s).
 */ function $46e8b0e1db0e5d60$var$domToReact(nodes, options) {
    if (options === void 0) options = {};
    var reactElements = [];
    var hasReplace = typeof options.replace === "function";
    var transform = options.transform || $jCRx8.returnFirstArg;
    var _a = options.library || $46e8b0e1db0e5d60$var$React, cloneElement = _a.cloneElement, createElement = _a.createElement, isValidElement = _a.isValidElement;
    var nodesLength = nodes.length;
    for(var index = 0; index < nodesLength; index++){
        var node = nodes[index];
        // replace with custom React element (if present)
        if (hasReplace) {
            var replaceElement = options.replace(node, index);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://react.dev/learn/rendering-lists#rules-of-keys
                if (nodesLength > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || index
                });
                reactElements.push(transform(replaceElement, node, index));
                continue;
            }
        }
        if (node.type === "text") {
            var isWhitespace = !node.data.trim().length;
            // We have a whitespace node that can't be nested in its parent
            // so skip it
            if (isWhitespace && node.parent && !(0, $jCRx8.canTextBeChildOfNode)(node.parent)) continue;
            // Trim is enabled and we have a whitespace node
            // so skip it
            if (options.trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            reactElements.push(transform(node.data, node, index));
            continue;
        }
        var element = node;
        var props = {};
        if ($46e8b0e1db0e5d60$var$skipAttributesToProps(element)) {
            (0, $jCRx8.setStyleProp)(element.attribs.style, element.attribs);
            props = element.attribs;
        } else if (element.attribs) props = (0, $46e8b0e1db0e5d60$var$attributes_to_props_1.default)(element.attribs, element.name);
        var children = void 0;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://react.dev/reference/react-dom/components/textarea#caveats
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $46e8b0e1db0e5d60$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://react.dev/learn/rendering-lists#rules-of-keys
        if (nodesLength > 1) props.key = index;
        reactElements.push(transform(createElement(node.name, props, children), node, index));
    }
    return reactElements.length === 1 ? reactElements[0] : reactElements;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param node - Element node.
 * @returns - Whether the node attributes should be converted to props.
 */ function $46e8b0e1db0e5d60$var$skipAttributesToProps(node) {
    return $jCRx8.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && (0, $jCRx8.isCustomComponent)(node.name, node.attribs);
}

});

parcelRegister("cGDDh", function(module, exports) {
"use strict";
var $93c8267ce1dab8bb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $93c8267ce1dab8bb$var$__assign = module.exports && module.exports.__assign || function() {
    $93c8267ce1dab8bb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $93c8267ce1dab8bb$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.CDATA = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $eqgYf = parcelRequire("eqgYf");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $93c8267ce1dab8bb$var$Node = /** @class */ function() {
    function Node() {
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $93c8267ce1dab8bb$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $93c8267ce1dab8bb$var$Node;
/**
 * A node that contains some data.
 */ var $93c8267ce1dab8bb$var$DataNode = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */ function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($93c8267ce1dab8bb$var$Node);
module.exports.DataNode = $93c8267ce1dab8bb$var$DataNode;
/**
 * Text within the document.
 */ var $93c8267ce1dab8bb$var$Text = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function() {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}($93c8267ce1dab8bb$var$DataNode);
module.exports.Text = $93c8267ce1dab8bb$var$Text;
/**
 * Comments within the document.
 */ var $93c8267ce1dab8bb$var$Comment = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function() {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}($93c8267ce1dab8bb$var$DataNode);
module.exports.Comment = $93c8267ce1dab8bb$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $93c8267ce1dab8bb$var$ProcessingInstruction = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = $eqgYf.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}($93c8267ce1dab8bb$var$DataNode);
module.exports.ProcessingInstruction = $93c8267ce1dab8bb$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $93c8267ce1dab8bb$var$NodeWithChildren = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($93c8267ce1dab8bb$var$Node);
module.exports.NodeWithChildren = $93c8267ce1dab8bb$var$NodeWithChildren;
var $93c8267ce1dab8bb$var$CDATA = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function() {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}($93c8267ce1dab8bb$var$NodeWithChildren);
module.exports.CDATA = $93c8267ce1dab8bb$var$CDATA;
/**
 * The root node of the document.
 */ var $93c8267ce1dab8bb$var$Document = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $eqgYf.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function() {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}($93c8267ce1dab8bb$var$NodeWithChildren);
module.exports.Document = $93c8267ce1dab8bb$var$Document;
/**
 * An element within the DOM.
 */ var $93c8267ce1dab8bb$var$Element = /** @class */ function(_super) {
    $93c8267ce1dab8bb$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $eqgYf.ElementType.Script : name === "style" ? $eqgYf.ElementType.Style : $eqgYf.ElementType.Tag;
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($93c8267ce1dab8bb$var$NodeWithChildren);
module.exports.Element = $93c8267ce1dab8bb$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isTag(node) {
    return (0, $eqgYf.isTag)(node);
}
module.exports.isTag = $93c8267ce1dab8bb$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isCDATA(node) {
    return node.type === $eqgYf.ElementType.CDATA;
}
module.exports.isCDATA = $93c8267ce1dab8bb$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isText(node) {
    return node.type === $eqgYf.ElementType.Text;
}
module.exports.isText = $93c8267ce1dab8bb$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isComment(node) {
    return node.type === $eqgYf.ElementType.Comment;
}
module.exports.isComment = $93c8267ce1dab8bb$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isDirective(node) {
    return node.type === $eqgYf.ElementType.Directive;
}
module.exports.isDirective = $93c8267ce1dab8bb$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$isDocument(node) {
    return node.type === $eqgYf.ElementType.Root;
}
module.exports.isDocument = $93c8267ce1dab8bb$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ function $93c8267ce1dab8bb$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $93c8267ce1dab8bb$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $93c8267ce1dab8bb$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($93c8267ce1dab8bb$var$isText(node)) result = new $93c8267ce1dab8bb$var$Text(node.data);
    else if ($93c8267ce1dab8bb$var$isComment(node)) result = new $93c8267ce1dab8bb$var$Comment(node.data);
    else if ($93c8267ce1dab8bb$var$isTag(node)) {
        var children = recursive ? $93c8267ce1dab8bb$var$cloneChildren(node.children) : [];
        var clone_1 = new $93c8267ce1dab8bb$var$Element(node.name, $93c8267ce1dab8bb$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $93c8267ce1dab8bb$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $93c8267ce1dab8bb$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($93c8267ce1dab8bb$var$isCDATA(node)) {
        var children = recursive ? $93c8267ce1dab8bb$var$cloneChildren(node.children) : [];
        var clone_2 = new $93c8267ce1dab8bb$var$CDATA(children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($93c8267ce1dab8bb$var$isDocument(node)) {
        var children = recursive ? $93c8267ce1dab8bb$var$cloneChildren(node.children) : [];
        var clone_3 = new $93c8267ce1dab8bb$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($93c8267ce1dab8bb$var$isDirective(node)) {
        var instruction = new $93c8267ce1dab8bb$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $93c8267ce1dab8bb$var$cloneNode;
function $93c8267ce1dab8bb$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $93c8267ce1dab8bb$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});

parcelRegister("3QSuJ", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", function () { return NonFullScreenPageMode; });
$parcel$export(module.exports, "ReadingDirection", function () { return ReadingDirection; });
$parcel$export(module.exports, "PrintScaling", function () { return PrintScaling; });
$parcel$export(module.exports, "Duplex", function () { return Duplex; });
$parcel$export(module.exports, "default", function () { return $2ce07ff438934df7$export$2e2bcd8739ae039; });

var $joN8z = parcelRequire("joN8z");

var $aeaZ4 = parcelRequire("aeaZ4");

var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $iqqIy.default).of(key));
        if (returnObj instanceof (0, $aeaZ4.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $iqqIy.default).of(key));
        if (returnObj instanceof (0, $iqqIy.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool("HideToolbar");
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool("HideMenubar");
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool("HideWindowUI");
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool("FitWindow");
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool("CenterWindow");
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool("DisplayDocTitle");
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName("NonFullScreenPageMode");
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName("Direction");
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName("PrintScaling");
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName("Duplex");
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool("PickTrayByPDFSize");
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $iqqIy.default).of("PrintPageRange"));
        if (PrintPageRange instanceof (0, $joN8z.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $iqqIy.default).of("NumCopies"));
        if (NumCopies instanceof (0, $3vNQK.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $3vNQK.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $3vNQK.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $iqqIy.default).of("HideToolbar"), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $iqqIy.default).of("HideMenubar"), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $iqqIy.default).of("HideWindowUI"), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $iqqIy.default).of("FitWindow"), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $iqqIy.default).of("CenterWindow"), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $iqqIy.default).of("DisplayDocTitle"), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $kqiuD.assertIsOneOf)(nonFullScreenPageMode, "nonFullScreenPageMode", NonFullScreenPageMode);
        var mode = (0, $iqqIy.default).of(nonFullScreenPageMode);
        this.dict.set((0, $iqqIy.default).of("NonFullScreenPageMode"), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $kqiuD.assertIsOneOf)(readingDirection, "readingDirection", ReadingDirection);
        var direction = (0, $iqqIy.default).of(readingDirection);
        this.dict.set((0, $iqqIy.default).of("Direction"), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $kqiuD.assertIsOneOf)(printScaling, "printScaling", PrintScaling);
        var scaling = (0, $iqqIy.default).of(printScaling);
        this.dict.set((0, $iqqIy.default).of("PrintScaling"), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $kqiuD.assertIsOneOf)(duplex, "duplex", Duplex);
        var dup = (0, $iqqIy.default).of(duplex);
        this.dict.set((0, $iqqIy.default).of("Duplex"), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $iqqIy.default).of("PickTrayByPDFSize"), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $kqiuD.assertEachIs)(flatRange, "printPageRange", [
            "number"
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $iqqIy.default).of("PrintPageRange"), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $kqiuD.assertRange)(numCopies, "numCopies", 1, Number.MAX_VALUE);
        (0, $kqiuD.assertInteger)(numCopies, "numCopies");
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $iqqIy.default).of("NumCopies"), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $2ce07ff438934df7$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("joN8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1f65fd688d1aa2b$export$2e2bcd8739ae039; });

var $1RwW5 = parcelRequire("1RwW5");

var $3vNQK = parcelRequire("3vNQK");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");

var $dJvqn = parcelRequire("dJvqn");
var $e1f65fd688d1aa2b$var$PDFArray = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $1RwW5.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $1RwW5.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $dJvqn.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $3vNQK.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $3vNQK.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $3vNQK.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $3vNQK.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = "[ ";
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += " ";
        }
        arrayString += "]";
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).LeftSquareBracket;
        buffer[offset++] = (0, $aGkK2.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
        }
        buffer[offset++] = (0, $aGkK2.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $3vNQK.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $3vNQK.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $fi0fX.default));
var $e1f65fd688d1aa2b$export$2e2bcd8739ae039 = $e1f65fd688d1aa2b$var$PDFArray;

});
parcelRegister("1RwW5", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $15b44a13ecb16a73$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $15b44a13ecb16a73$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $15b44a13ecb16a73$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $15b44a13ecb16a73$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $15b44a13ecb16a73$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $15b44a13ecb16a73$export$6388937ca91ccae8; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $15b44a13ecb16a73$var$extendStatics = function(d, b) {
    $15b44a13ecb16a73$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $15b44a13ecb16a73$var$extendStatics(d, b);
};
function $15b44a13ecb16a73$export$a8ba968b8961cb8a(d, b) {
    $15b44a13ecb16a73$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $15b44a13ecb16a73$export$18ce0697a983be9b = function() {
    $15b44a13ecb16a73$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $15b44a13ecb16a73$export$18ce0697a983be9b.apply(this, arguments);
};
function $15b44a13ecb16a73$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $15b44a13ecb16a73$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $15b44a13ecb16a73$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $15b44a13ecb16a73$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $15b44a13ecb16a73$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $15b44a13ecb16a73$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $15b44a13ecb16a73$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $15b44a13ecb16a73$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $15b44a13ecb16a73$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $15b44a13ecb16a73$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $15b44a13ecb16a73$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($15b44a13ecb16a73$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $15b44a13ecb16a73$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $15b44a13ecb16a73$export$10c90e4f7922046c(v) {
    return this instanceof $15b44a13ecb16a73$export$10c90e4f7922046c ? (this.v = v, this) : new $15b44a13ecb16a73$export$10c90e4f7922046c(v);
}
function $15b44a13ecb16a73$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $15b44a13ecb16a73$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $15b44a13ecb16a73$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $15b44a13ecb16a73$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $15b44a13ecb16a73$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $15b44a13ecb16a73$export$19a8beecd37a4c45 === "function" ? $15b44a13ecb16a73$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $15b44a13ecb16a73$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $15b44a13ecb16a73$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $15b44a13ecb16a73$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $15b44a13ecb16a73$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $15b44a13ecb16a73$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("3vNQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28eaef7bd4934d5b$export$2e2bcd8739ae039; });

var $1RwW5 = parcelRequire("1RwW5");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $j8ZLl = parcelRequire("j8ZLl");

var $fi0fX = parcelRequire("fi0fX");
var $28eaef7bd4934d5b$var$PDFNumber = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $j8ZLl.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $equxL.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $fi0fX.default));
var $28eaef7bd4934d5b$export$2e2bcd8739ae039 = $28eaef7bd4934d5b$var$PDFNumber;

});
parcelRegister("3Iuzo", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", function () { return (parcelRequire("hOX8d")).arrayAsString; });
$parcel$export(module.exports, "byAscendingId", function () { return (parcelRequire("hOX8d")).byAscendingId; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return (parcelRequire("hOX8d")).canBeConvertedToUint8Array; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("hOX8d")).last; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return (parcelRequire("hOX8d")).mergeIntoTypedArray; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return (parcelRequire("hOX8d")).mergeUint8Arrays; });
$parcel$export(module.exports, "pluckIndices", function () { return (parcelRequire("hOX8d")).pluckIndices; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("hOX8d")).range; });
$parcel$export(module.exports, "reverseArray", function () { return (parcelRequire("hOX8d")).reverseArray; });
$parcel$export(module.exports, "sortedUniq", function () { return (parcelRequire("hOX8d")).sortedUniq; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("hOX8d")).sum; });
$parcel$export(module.exports, "toUint8Array", function () { return (parcelRequire("hOX8d")).toUint8Array; });
$parcel$export(module.exports, "typedArrayFor", function () { return (parcelRequire("hOX8d")).typedArrayFor; });
$parcel$export(module.exports, "waitForTick", function () { return (parcelRequire("2O2jP")).waitForTick; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return (parcelRequire("equxL")).breakTextIntoLines; });
$parcel$export(module.exports, "charAtIndex", function () { return (parcelRequire("equxL")).charAtIndex; });
$parcel$export(module.exports, "charFromCode", function () { return (parcelRequire("equxL")).charFromCode; });
$parcel$export(module.exports, "charFromHexCode", function () { return (parcelRequire("equxL")).charFromHexCode; });
$parcel$export(module.exports, "charSplit", function () { return (parcelRequire("equxL")).charSplit; });
$parcel$export(module.exports, "cleanText", function () { return (parcelRequire("equxL")).cleanText; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return (parcelRequire("equxL")).copyStringIntoBuffer; });
$parcel$export(module.exports, "findLastMatch", function () { return (parcelRequire("equxL")).findLastMatch; });
$parcel$export(module.exports, "lineSplit", function () { return (parcelRequire("equxL")).lineSplit; });
$parcel$export(module.exports, "mergeLines", function () { return (parcelRequire("equxL")).mergeLines; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("equxL")).padStart; });
$parcel$export(module.exports, "parseDate", function () { return (parcelRequire("equxL")).parseDate; });
$parcel$export(module.exports, "toCharCode", function () { return (parcelRequire("equxL")).toCharCode; });
$parcel$export(module.exports, "toCodePoint", function () { return (parcelRequire("equxL")).toCodePoint; });
$parcel$export(module.exports, "toHexString", function () { return (parcelRequire("equxL")).toHexString; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return (parcelRequire("equxL")).toHexStringOfMinLength; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return (parcelRequire("720Bx")).hasUtf16BOM; });
$parcel$export(module.exports, "utf16Decode", function () { return (parcelRequire("720Bx")).utf16Decode; });
$parcel$export(module.exports, "utf16Encode", function () { return (parcelRequire("720Bx")).utf16Encode; });
$parcel$export(module.exports, "bytesFor", function () { return (parcelRequire("j8ZLl")).bytesFor; });
$parcel$export(module.exports, "numberToString", function () { return (parcelRequire("j8ZLl")).numberToString; });
$parcel$export(module.exports, "sizeInBytes", function () { return (parcelRequire("j8ZLl")).sizeInBytes; });
$parcel$export(module.exports, "error", function () { return (parcelRequire("kMOPh")).error; });
$parcel$export(module.exports, "encodeToBase64", function () { return (parcelRequire("6dc53")).encodeToBase64; });
$parcel$export(module.exports, "isStandardFont", function () { return (parcelRequire("dhfaG")).isStandardFont; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return (parcelRequire("dhfaG")).rectanglesAreEqual; });
$parcel$export(module.exports, "assertEachIs", function () { return (parcelRequire("kqiuD")).assertEachIs; });
$parcel$export(module.exports, "assertInteger", function () { return (parcelRequire("kqiuD")).assertInteger; });
$parcel$export(module.exports, "assertIs", function () { return (parcelRequire("kqiuD")).assertIs; });
$parcel$export(module.exports, "assertIsOneOf", function () { return (parcelRequire("kqiuD")).assertIsOneOf; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return (parcelRequire("kqiuD")).assertIsOneOfOrUndefined; });
$parcel$export(module.exports, "assertIsSubset", function () { return (parcelRequire("kqiuD")).assertIsSubset; });
$parcel$export(module.exports, "assertMultiple", function () { return (parcelRequire("kqiuD")).assertMultiple; });
$parcel$export(module.exports, "assertOrUndefined", function () { return (parcelRequire("kqiuD")).assertOrUndefined; });
$parcel$export(module.exports, "assertPositive", function () { return (parcelRequire("kqiuD")).assertPositive; });
$parcel$export(module.exports, "assertRange", function () { return (parcelRequire("kqiuD")).assertRange; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return (parcelRequire("kqiuD")).assertRangeOrUndefined; });
$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return (parcelRequire("axUYF")).pdfDocEncodingDecode; });

$parcel$export(module.exports, "Cache", function () { return (parcelRequire("k9ooy")).default; });
parcelRequire("hOX8d");
parcelRequire("2O2jP");
parcelRequire("equxL");
parcelRequire("720Bx");
parcelRequire("j8ZLl");
parcelRequire("kMOPh");
parcelRequire("6dc53");
parcelRequire("dhfaG");
parcelRequire("kqiuD");
parcelRequire("axUYF");

var $k9ooy = parcelRequire("k9ooy");

});
parcelRegister("hOX8d", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $cf94f97d98d26c34$export$4c7897fafd92b108; });
$parcel$export(module.exports, "typedArrayFor", function () { return $cf94f97d98d26c34$export$98b44e66722b6f4d; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return $cf94f97d98d26c34$export$8907b5381cbcd9a7; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return $cf94f97d98d26c34$export$99cee7ee2de7e6e4; });
$parcel$export(module.exports, "arrayAsString", function () { return $cf94f97d98d26c34$export$5f8f9664fe5c5f14; });
$parcel$export(module.exports, "byAscendingId", function () { return $cf94f97d98d26c34$export$55b6b1f56c6e1ba5; });
$parcel$export(module.exports, "sortedUniq", function () { return $cf94f97d98d26c34$export$720e3b5aefb27114; });
$parcel$export(module.exports, "reverseArray", function () { return $cf94f97d98d26c34$export$c9b97e771c4a8302; });
$parcel$export(module.exports, "sum", function () { return $cf94f97d98d26c34$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "range", function () { return $cf94f97d98d26c34$export$d02631cccf789723; });
$parcel$export(module.exports, "pluckIndices", function () { return $cf94f97d98d26c34$export$279d041ff3481d88; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return $cf94f97d98d26c34$export$20e9c5ed92218c4b; });
$parcel$export(module.exports, "toUint8Array", function () { return $cf94f97d98d26c34$export$73470fd2221e6aef; });

var $6dc53 = parcelRequire("6dc53");

var $equxL = parcelRequire("equxL");
var $cf94f97d98d26c34$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $cf94f97d98d26c34$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $cf94f97d98d26c34$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $cf94f97d98d26c34$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $cf94f97d98d26c34$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $cf94f97d98d26c34$export$5f8f9664fe5c5f14 = function(array) {
    var str = "";
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $equxL.charFromCode)(array[idx]);
    return str;
};
var $cf94f97d98d26c34$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $cf94f97d98d26c34$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $cf94f97d98d26c34$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $cf94f97d98d26c34$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $cf94f97d98d26c34$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $cf94f97d98d26c34$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $cf94f97d98d26c34$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === "string";
};
var $cf94f97d98d26c34$export$73470fd2221e6aef = function(input) {
    if (typeof input === "string") return (0, $6dc53.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError("`input` must be one of `string | ArrayBuffer | Uint8Array`");
};

});
parcelRegister("6dc53", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", function () { return $485d53e51feb4076$export$373f4c3083978ffd; });
$parcel$export(module.exports, "decodeFromBase64DataUri", function () { return $485d53e51feb4076$export$f6810f5086699d73; });
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $485d53e51feb4076$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $485d53e51feb4076$var$lookup = new Uint8Array(256);
for(var $485d53e51feb4076$var$i = 0; $485d53e51feb4076$var$i < $485d53e51feb4076$var$chars.length; $485d53e51feb4076$var$i++)$485d53e51feb4076$var$lookup[$485d53e51feb4076$var$chars.charCodeAt($485d53e51feb4076$var$i)] = $485d53e51feb4076$var$i;
var $485d53e51feb4076$export$373f4c3083978ffd = function(bytes) {
    var base64 = "";
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $485d53e51feb4076$var$chars[bytes[i] >> 2];
        base64 += $485d53e51feb4076$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $485d53e51feb4076$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $485d53e51feb4076$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
var $485d53e51feb4076$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $485d53e51feb4076$var$lookup[base64.charCodeAt(i)];
        encoded2 = $485d53e51feb4076$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $485d53e51feb4076$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $485d53e51feb4076$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $485d53e51feb4076$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $485d53e51feb4076$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($485d53e51feb4076$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $485d53e51feb4076$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $485d53e51feb4076$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("equxL", function(module, exports) {

$parcel$export(module.exports, "toCharCode", function () { return $a80b2fb9031c6a6c$export$d90166409dd04e85; });
$parcel$export(module.exports, "toCodePoint", function () { return $a80b2fb9031c6a6c$export$93bf578f015d73f0; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return $a80b2fb9031c6a6c$export$6ac97d2d1bf41f39; });
$parcel$export(module.exports, "padStart", function () { return $a80b2fb9031c6a6c$export$36cf564d487b5178; });
$parcel$export(module.exports, "toHexString", function () { return $a80b2fb9031c6a6c$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "charFromCode", function () { return $a80b2fb9031c6a6c$export$207031940e6950ad; });
$parcel$export(module.exports, "charFromHexCode", function () { return $a80b2fb9031c6a6c$export$ceedd1b69dcde7a5; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return $a80b2fb9031c6a6c$export$c41a03555c37a984; });
$parcel$export(module.exports, "cleanText", function () { return $a80b2fb9031c6a6c$export$6b5e57d20078142b; });
$parcel$export(module.exports, "lineSplit", function () { return $a80b2fb9031c6a6c$export$4f60280859794d8c; });
$parcel$export(module.exports, "mergeLines", function () { return $a80b2fb9031c6a6c$export$b5bf5e120f07cbe; });
$parcel$export(module.exports, "charAtIndex", function () { return $a80b2fb9031c6a6c$export$1a93fc5af577aa5c; });
$parcel$export(module.exports, "charSplit", function () { return $a80b2fb9031c6a6c$export$78f5a8ab9b5e7f1e; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return $a80b2fb9031c6a6c$export$38936f7739928807; });
$parcel$export(module.exports, "parseDate", function () { return $a80b2fb9031c6a6c$export$6b862160d295c8e; });
$parcel$export(module.exports, "findLastMatch", function () { return $a80b2fb9031c6a6c$export$dc1d7d42f51764e3; });
var $a80b2fb9031c6a6c$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $a80b2fb9031c6a6c$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $a80b2fb9031c6a6c$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $a80b2fb9031c6a6c$export$36cf564d487b5178(num.toString(16), minLength, "0").toUpperCase();
};
var $a80b2fb9031c6a6c$export$f4915efbb94d4d01 = function(num) {
    return $a80b2fb9031c6a6c$export$6ac97d2d1bf41f39(num, 2);
};
var $a80b2fb9031c6a6c$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $a80b2fb9031c6a6c$export$ceedd1b69dcde7a5 = function(hex) {
    return $a80b2fb9031c6a6c$export$207031940e6950ad(parseInt(hex, 16));
};
var $a80b2fb9031c6a6c$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = "";
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $a80b2fb9031c6a6c$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $a80b2fb9031c6a6c$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $a80b2fb9031c6a6c$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var $a80b2fb9031c6a6c$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, "    ").replace(/[\b\v]/g, "");
};
var $a80b2fb9031c6a6c$export$60bd2eb6e5a75df0 = [
    "\\n",
    "\\f",
    "\\r",
    "\\u000B"
];
var $a80b2fb9031c6a6c$export$634cc0013ed0f624 = [
    "\n",
    "\f",
    "\r",
    "\v"
];
var $a80b2fb9031c6a6c$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $a80b2fb9031c6a6c$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $a80b2fb9031c6a6c$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, " ");
};
var $a80b2fb9031c6a6c$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $a80b2fb9031c6a6c$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $a80b2fb9031c6a6c$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $a80b2fb9031c6a6c$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $a80b2fb9031c6a6c$export$60bd2eb6e5a75df0.join("|");
    var escapedRules = [
        "$"
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($a80b2fb9031c6a6c$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === "" ? "." : $a80b2fb9031c6a6c$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join("|");
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", "gm");
};
var $a80b2fb9031c6a6c$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $a80b2fb9031c6a6c$var$buildWordBreakRegex(wordBreaks);
    var words = $a80b2fb9031c6a6c$export$6b5e57d20078142b(text).match(regex);
    var currLine = "";
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== "") lines.push(currLine);
        currLine = "";
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($a80b2fb9031c6a6c$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $a80b2fb9031c6a6c$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $a80b2fb9031c6a6c$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($a80b2fb9031c6a6c$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? "01" : _a, _b = match[3], day = _b === void 0 ? "01" : _b, _c = match[4], hours = _c === void 0 ? "00" : _c, _d = match[5], mins = _d === void 0 ? "00" : _d, _e = match[6], secs = _e === void 0 ? "00" : _e, _f = match[7], offsetSign = _f === void 0 ? "Z" : _f, _g = match[8], offsetHours = _g === void 0 ? "00" : _g, _h = match[9], offsetMins = _h === void 0 ? "00" : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === "Z" ? "Z" : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $a80b2fb9031c6a6c$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("2O2jP", function(module, exports) {

$parcel$export(module.exports, "waitForTick", function () { return $20b20cbab17708a7$export$3b7198a3beef1a5f; });
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $20b20cbab17708a7$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("720Bx", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", function () { return $51e930509adeb208$export$73704d2337848c8e; });
$parcel$export(module.exports, "highSurrogate", function () { return $51e930509adeb208$export$8d3bd4086f36eaeb; });
$parcel$export(module.exports, "lowSurrogate", function () { return $51e930509adeb208$export$382051c72943492d; });
$parcel$export(module.exports, "isWithinBMP", function () { return $51e930509adeb208$export$919ae47c3852aa15; });
$parcel$export(module.exports, "hasSurrogates", function () { return $51e930509adeb208$export$d5ab89e7561b44ab; });
$parcel$export(module.exports, "utf16Decode", function () { return $51e930509adeb208$export$b89f54f9db637f79; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return $51e930509adeb208$export$41e7c15c75b1b24d; });

var $equxL = parcelRequire("equxL");
var $51e930509adeb208$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $equxL.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $51e930509adeb208$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($51e930509adeb208$export$8d3bd4086f36eaeb(codePoint), $51e930509adeb208$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $equxL.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $51e930509adeb208$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $51e930509adeb208$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $51e930509adeb208$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $51e930509adeb208$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $51e930509adeb208$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($51e930509adeb208$var$ByteOrder || ($51e930509adeb208$var$ByteOrder = {}));
var $51e930509adeb208$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $51e930509adeb208$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($51e930509adeb208$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $51e930509adeb208$var$readBOM(input) : $51e930509adeb208$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $51e930509adeb208$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($51e930509adeb208$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($51e930509adeb208$var$REPLACEMENT);
            else {
                var second = $51e930509adeb208$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($51e930509adeb208$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($51e930509adeb208$var$REPLACEMENT);
            }
        } else if ($51e930509adeb208$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($51e930509adeb208$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($51e930509adeb208$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $51e930509adeb208$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $51e930509adeb208$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $51e930509adeb208$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $51e930509adeb208$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $51e930509adeb208$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $51e930509adeb208$var$readBOM = function(bytes) {
    return $51e930509adeb208$var$hasUtf16BigEndianBOM(bytes) ? $51e930509adeb208$var$ByteOrder.BigEndian : $51e930509adeb208$var$hasUtf16LittleEndianBOM(bytes) ? $51e930509adeb208$var$ByteOrder.LittleEndian : $51e930509adeb208$var$ByteOrder.BigEndian;
};
var $51e930509adeb208$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $51e930509adeb208$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $51e930509adeb208$export$41e7c15c75b1b24d = function(bytes) {
    return $51e930509adeb208$var$hasUtf16BigEndianBOM(bytes) || $51e930509adeb208$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("j8ZLl", function(module, exports) {

$parcel$export(module.exports, "numberToString", function () { return $defeac76548abfea$export$f67be9d9b0e25d7b; });
$parcel$export(module.exports, "sizeInBytes", function () { return $defeac76548abfea$export$cc6acfd7a782614d; });
$parcel$export(module.exports, "bytesFor", function () { return $defeac76548abfea$export$3c7962b7d5fa4e42; });
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $defeac76548abfea$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split("e-")[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = "0." + new Array(e).join("0") + num.toString().substring(2);
            if (negative) numStr = "-" + numStr;
        }
    } else {
        var e = parseInt(num.toString().split("+")[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join("0");
        }
    }
    return numStr;
};
var $defeac76548abfea$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $defeac76548abfea$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($defeac76548abfea$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("kMOPh", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $f21fb75ae44e9a76$export$a3bc9b8ed74fc; });
var $f21fb75ae44e9a76$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("dhfaG", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $9aa8a19478a61ee3$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "isStandardFont", function () { return $9aa8a19478a61ee3$export$f2950432a4491977; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return $9aa8a19478a61ee3$export$93263d7e9f52c023; });
parcelRequire("dFOCr");
var $fsila = parcelRequire("fsila");
var $9aa8a19478a61ee3$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $9aa8a19478a61ee3$export$59252e21bbb61725 = $9aa8a19478a61ee3$export$68c286be0e7e55b7((0, $fsila.FontNames));
var $9aa8a19478a61ee3$export$f2950432a4491977 = function(input) {
    return $9aa8a19478a61ee3$export$59252e21bbb61725.includes(input);
};
var $9aa8a19478a61ee3$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("dFOCr", function(module, exports) {
$parcel$export(module.exports, "Font", function () { return (parcelRequire("fsila")).Font; });
$parcel$export(module.exports, "FontNames", function () { return (parcelRequire("fsila")).FontNames; });
$parcel$export(module.exports, "Encodings", function () { return (parcelRequire("l6GEW")).Encodings; });
parcelRequire("fsila");
parcelRequire("l6GEW");

});
parcelRegister("fsila", function(module, exports) {

$parcel$export(module.exports, "FontNames", function () { return $b407b28acadf2f80$export$a1e7b970f5a14844; });
$parcel$export(module.exports, "Font", function () { return $b407b28acadf2f80$export$89abf52a030e56ee; });

var $69IVx = parcelRequire("69IVx");

var $2xKCP = parcelRequire("2xKCP");

var $36mCs = parcelRequire("36mCs");

var $kaKzg = parcelRequire("kaKzg");

var $973Ht = parcelRequire("973Ht");

var $9TzLx = parcelRequire("9TzLx");

var $4uwvn = parcelRequire("4uwvn");

var $66yJn = parcelRequire("66yJn");

var $fATNF = parcelRequire("fATNF");

var $1MHeu = parcelRequire("1MHeu");

var $1qoDV = parcelRequire("1qoDV");

var $b5aGF = parcelRequire("b5aGF");

var $8wrOX = parcelRequire("8wrOX");

var $hqNKc = parcelRequire("hqNKc");

var $4eh0m = parcelRequire("4eh0m");
// prettier-ignore
var $b407b28acadf2f80$var$compressedJsonForFontName = {
    "Courier": (0, (/*@__PURE__*/$parcel$interopDefault($973Ht))),
    "Courier-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($2xKCP))),
    "Courier-Oblique": (0, (/*@__PURE__*/$parcel$interopDefault($kaKzg))),
    "Courier-BoldOblique": (0, (/*@__PURE__*/$parcel$interopDefault($36mCs))),
    "Helvetica": (0, (/*@__PURE__*/$parcel$interopDefault($fATNF))),
    "Helvetica-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($9TzLx))),
    "Helvetica-Oblique": (0, (/*@__PURE__*/$parcel$interopDefault($66yJn))),
    "Helvetica-BoldOblique": (0, (/*@__PURE__*/$parcel$interopDefault($4uwvn))),
    "Times-Roman": (0, (/*@__PURE__*/$parcel$interopDefault($8wrOX))),
    "Times-Bold": (0, (/*@__PURE__*/$parcel$interopDefault($1MHeu))),
    "Times-Italic": (0, (/*@__PURE__*/$parcel$interopDefault($b5aGF))),
    "Times-BoldItalic": (0, (/*@__PURE__*/$parcel$interopDefault($1qoDV))),
    "Symbol": (0, (/*@__PURE__*/$parcel$interopDefault($hqNKc))),
    "ZapfDingbats": (0, (/*@__PURE__*/$parcel$interopDefault($4eh0m)))
};
var $b407b28acadf2f80$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($b407b28acadf2f80$export$a1e7b970f5a14844 || ($b407b28acadf2f80$export$a1e7b970f5a14844 = {}));
var $b407b28acadf2f80$var$fontCache = {};
var $b407b28acadf2f80$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $b407b28acadf2f80$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $69IVx.decompressJson)($b407b28acadf2f80$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $b407b28acadf2f80$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("69IVx", function(module, exports) {

$parcel$export(module.exports, "decompressJson", function () { return $47b66eece216c413$export$134b8d792d6efd14; });
$parcel$export(module.exports, "padStart", function () { return $47b66eece216c413$export$36cf564d487b5178; });
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $jjzmO = parcelRequire("jjzmO");
var $47b66eece216c413$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $47b66eece216c413$var$lookup = new Uint8Array(256);
for(var $47b66eece216c413$var$i = 0; $47b66eece216c413$var$i < $47b66eece216c413$var$chars.length; $47b66eece216c413$var$i++)$47b66eece216c413$var$lookup[$47b66eece216c413$var$chars.charCodeAt($47b66eece216c413$var$i)] = $47b66eece216c413$var$i;
var $47b66eece216c413$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $47b66eece216c413$var$lookup[base64.charCodeAt(i)];
        encoded2 = $47b66eece216c413$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $47b66eece216c413$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $47b66eece216c413$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $47b66eece216c413$var$arrayToString = function(array) {
    var str = "";
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $47b66eece216c413$export$134b8d792d6efd14 = function(compressedJson) {
    return $47b66eece216c413$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($jjzmO))).inflate($47b66eece216c413$export$83edfd8fcc66ec17(compressedJson)));
};
var $47b66eece216c413$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = "";
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("jjzmO", function(module, exports) {
// Top level file is just a mixin of submodules & constants
"use strict";

var $bXtz7 = parcelRequire("bXtz7");
var $e0fb39cf22e84878$require$assign = $bXtz7.assign;

var $2eJxS = parcelRequire("2eJxS");

var $e6DzP = parcelRequire("e6DzP");

var $ebefm = parcelRequire("ebefm");
var $e0fb39cf22e84878$var$pako = {};
$e0fb39cf22e84878$require$assign($e0fb39cf22e84878$var$pako, $2eJxS, $e6DzP, $ebefm);
module.exports = $e0fb39cf22e84878$var$pako;

});
parcelRegister("bXtz7", function(module, exports) {
"use strict";
var $8b4c2378368b04f5$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $8b4c2378368b04f5$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($8b4c2378368b04f5$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $8b4c2378368b04f5$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $8b4c2378368b04f5$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $8b4c2378368b04f5$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $8b4c2378368b04f5$var$fnUntyped);
    }
};
module.exports.setTyped($8b4c2378368b04f5$var$TYPED_OK);

});

parcelRegister("2eJxS", function(module, exports) {

$parcel$export(module.exports, "Deflate", function () { return $1a1037f0617cc74b$export$ae157b6234afe138; }, function (v) { return $1a1037f0617cc74b$export$ae157b6234afe138 = v; });
$parcel$export(module.exports, "deflate", function () { return $1a1037f0617cc74b$export$2316623ecd1285ab; }, function (v) { return $1a1037f0617cc74b$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateRaw", function () { return $1a1037f0617cc74b$export$e95d6a8f69fb340a; }, function (v) { return $1a1037f0617cc74b$export$e95d6a8f69fb340a = v; });
$parcel$export(module.exports, "gzip", function () { return $1a1037f0617cc74b$export$69f0ea7cf3a331a8; }, function (v) { return $1a1037f0617cc74b$export$69f0ea7cf3a331a8 = v; });
var $1a1037f0617cc74b$export$ae157b6234afe138;
var $1a1037f0617cc74b$export$2316623ecd1285ab;
var $1a1037f0617cc74b$export$e95d6a8f69fb340a;
var $1a1037f0617cc74b$export$69f0ea7cf3a331a8;
"use strict";

var $e82jE = parcelRequire("e82jE");

var $bXtz7 = parcelRequire("bXtz7");

var $3pcji = parcelRequire("3pcji");

var $1wUiP = parcelRequire("1wUiP");

var $bPHz5 = parcelRequire("bPHz5");
var $1a1037f0617cc74b$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1a1037f0617cc74b$var$Z_NO_FLUSH = 0;
var $1a1037f0617cc74b$var$Z_FINISH = 4;
var $1a1037f0617cc74b$var$Z_OK = 0;
var $1a1037f0617cc74b$var$Z_STREAM_END = 1;
var $1a1037f0617cc74b$var$Z_SYNC_FLUSH = 2;
var $1a1037f0617cc74b$var$Z_DEFAULT_COMPRESSION = -1;
var $1a1037f0617cc74b$var$Z_DEFAULT_STRATEGY = 0;
var $1a1037f0617cc74b$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1a1037f0617cc74b$var$Deflate(options) {
    if (!(this instanceof $1a1037f0617cc74b$var$Deflate)) return new $1a1037f0617cc74b$var$Deflate(options);
    this.options = $bXtz7.assign({
        level: $1a1037f0617cc74b$var$Z_DEFAULT_COMPRESSION,
        method: $1a1037f0617cc74b$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1a1037f0617cc74b$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $bPHz5();
    this.strm.avail_out = 0;
    var status = $e82jE.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1a1037f0617cc74b$var$Z_OK) throw new Error($1wUiP[status]);
    if (opt.header) $e82jE.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $3pcji.string2buf(opt.dictionary);
        else if ($1a1037f0617cc74b$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $e82jE.deflateSetDictionary(this.strm, dict);
        if (status !== $1a1037f0617cc74b$var$Z_OK) throw new Error($1wUiP[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1a1037f0617cc74b$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1a1037f0617cc74b$var$Z_FINISH : $1a1037f0617cc74b$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $3pcji.string2buf(data);
    else if ($1a1037f0617cc74b$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $bXtz7.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $e82jE.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $1a1037f0617cc74b$var$Z_STREAM_END && status !== $1a1037f0617cc74b$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1a1037f0617cc74b$var$Z_FINISH || _mode === $1a1037f0617cc74b$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($3pcji.buf2binstring($bXtz7.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($bXtz7.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1a1037f0617cc74b$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1a1037f0617cc74b$var$Z_FINISH) {
        status = $e82jE.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1a1037f0617cc74b$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1a1037f0617cc74b$var$Z_SYNC_FLUSH) {
        this.onEnd($1a1037f0617cc74b$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1a1037f0617cc74b$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1a1037f0617cc74b$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1a1037f0617cc74b$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $bXtz7.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1a1037f0617cc74b$var$deflate(input, options) {
    var deflator = new $1a1037f0617cc74b$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $1wUiP[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1a1037f0617cc74b$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1a1037f0617cc74b$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1a1037f0617cc74b$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1a1037f0617cc74b$var$deflate(input, options);
}
$1a1037f0617cc74b$export$ae157b6234afe138 = $1a1037f0617cc74b$var$Deflate;
$1a1037f0617cc74b$export$2316623ecd1285ab = $1a1037f0617cc74b$var$deflate;
$1a1037f0617cc74b$export$e95d6a8f69fb340a = $1a1037f0617cc74b$var$deflateRaw;
$1a1037f0617cc74b$export$69f0ea7cf3a331a8 = $1a1037f0617cc74b$var$gzip;

});
parcelRegister("e82jE", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $a4939bf33993f94f$export$a65c7b2bde87cb70; }, function (v) { return $a4939bf33993f94f$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateSetHeader", function () { return $a4939bf33993f94f$export$1cd50f7b2515ba19; }, function (v) { return $a4939bf33993f94f$export$1cd50f7b2515ba19 = v; });
$parcel$export(module.exports, "deflate", function () { return $a4939bf33993f94f$export$2316623ecd1285ab; }, function (v) { return $a4939bf33993f94f$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $a4939bf33993f94f$export$599854fa319a815f; }, function (v) { return $a4939bf33993f94f$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $a4939bf33993f94f$export$f55e0b3ab66b5d46; }, function (v) { return $a4939bf33993f94f$export$f55e0b3ab66b5d46 = v; });
var $a4939bf33993f94f$export$72b35d618fb8ad9b;
var $a4939bf33993f94f$export$a65c7b2bde87cb70;
var $a4939bf33993f94f$export$8f99f0e30bc7dd53;
var $a4939bf33993f94f$export$e78fab288549509;
var $a4939bf33993f94f$export$1cd50f7b2515ba19;
var $a4939bf33993f94f$export$2316623ecd1285ab;
var $a4939bf33993f94f$export$599854fa319a815f;
var $a4939bf33993f94f$export$f55e0b3ab66b5d46;
var $a4939bf33993f94f$export$12b6e1fcadea22f9;
"use strict";

var $bXtz7 = parcelRequire("bXtz7");

var $ibAA4 = parcelRequire("ibAA4");

var $jL1va = parcelRequire("jL1va");

var $gX4kb = parcelRequire("gX4kb");

var $1wUiP = parcelRequire("1wUiP");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $a4939bf33993f94f$var$Z_NO_FLUSH = 0;
var $a4939bf33993f94f$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $a4939bf33993f94f$var$Z_FULL_FLUSH = 3;
var $a4939bf33993f94f$var$Z_FINISH = 4;
var $a4939bf33993f94f$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $a4939bf33993f94f$var$Z_OK = 0;
var $a4939bf33993f94f$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $a4939bf33993f94f$var$Z_STREAM_ERROR = -2;
var $a4939bf33993f94f$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $a4939bf33993f94f$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $a4939bf33993f94f$var$Z_DEFAULT_COMPRESSION = -1;
var $a4939bf33993f94f$var$Z_FILTERED = 1;
var $a4939bf33993f94f$var$Z_HUFFMAN_ONLY = 2;
var $a4939bf33993f94f$var$Z_RLE = 3;
var $a4939bf33993f94f$var$Z_FIXED = 4;
var $a4939bf33993f94f$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $a4939bf33993f94f$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $a4939bf33993f94f$var$Z_DEFLATED = 8;
/*============================================================================*/ var $a4939bf33993f94f$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $a4939bf33993f94f$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $a4939bf33993f94f$var$DEF_MEM_LEVEL = 8;
var $a4939bf33993f94f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $a4939bf33993f94f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $a4939bf33993f94f$var$L_CODES = $a4939bf33993f94f$var$LITERALS + 1 + $a4939bf33993f94f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $a4939bf33993f94f$var$D_CODES = 30;
/* number of distance codes */ var $a4939bf33993f94f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $a4939bf33993f94f$var$HEAP_SIZE = 2 * $a4939bf33993f94f$var$L_CODES + 1;
/* maximum heap size */ var $a4939bf33993f94f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $a4939bf33993f94f$var$MIN_MATCH = 3;
var $a4939bf33993f94f$var$MAX_MATCH = 258;
var $a4939bf33993f94f$var$MIN_LOOKAHEAD = $a4939bf33993f94f$var$MAX_MATCH + $a4939bf33993f94f$var$MIN_MATCH + 1;
var $a4939bf33993f94f$var$PRESET_DICT = 0x20;
var $a4939bf33993f94f$var$INIT_STATE = 42;
var $a4939bf33993f94f$var$EXTRA_STATE = 69;
var $a4939bf33993f94f$var$NAME_STATE = 73;
var $a4939bf33993f94f$var$COMMENT_STATE = 91;
var $a4939bf33993f94f$var$HCRC_STATE = 103;
var $a4939bf33993f94f$var$BUSY_STATE = 113;
var $a4939bf33993f94f$var$FINISH_STATE = 666;
var $a4939bf33993f94f$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $a4939bf33993f94f$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $a4939bf33993f94f$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $a4939bf33993f94f$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $a4939bf33993f94f$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $a4939bf33993f94f$var$err(strm, errorCode) {
    strm.msg = $1wUiP[errorCode];
    return errorCode;
}
function $a4939bf33993f94f$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $a4939bf33993f94f$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $a4939bf33993f94f$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $bXtz7.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $a4939bf33993f94f$var$flush_block_only(s, last) {
    $ibAA4._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $a4939bf33993f94f$var$flush_pending(s.strm);
}
function $a4939bf33993f94f$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $a4939bf33993f94f$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $a4939bf33993f94f$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $bXtz7.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $jL1va(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $gX4kb(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $a4939bf33993f94f$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $a4939bf33993f94f$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $a4939bf33993f94f$var$MAX_MATCH - (strend - scan);
        scan = strend - $a4939bf33993f94f$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $a4939bf33993f94f$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD)) {
            $bXtz7.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $a4939bf33993f94f$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $a4939bf33993f94f$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $a4939bf33993f94f$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $a4939bf33993f94f$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $a4939bf33993f94f$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $a4939bf33993f94f$var$fill_window(s);
            if (s.lookahead === 0 && flush === $a4939bf33993f94f$var$Z_NO_FLUSH) return $a4939bf33993f94f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $a4939bf33993f94f$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a4939bf33993f94f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_FINISH_STARTED;
        /***/ return $a4939bf33993f94f$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
    /***/ }
    return $a4939bf33993f94f$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $a4939bf33993f94f$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $a4939bf33993f94f$var$MIN_LOOKAHEAD) {
            $a4939bf33993f94f$var$fill_window(s);
            if (s.lookahead < $a4939bf33993f94f$var$MIN_LOOKAHEAD && flush === $a4939bf33993f94f$var$Z_NO_FLUSH) return $a4939bf33993f94f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $a4939bf33993f94f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $a4939bf33993f94f$var$longest_match(s, hash_head);
        if (s.match_length >= $a4939bf33993f94f$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $ibAA4._tr_tally(s, s.strstart - s.match_start, s.match_length - $a4939bf33993f94f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $a4939bf33993f94f$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ibAA4._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $a4939bf33993f94f$var$MIN_MATCH - 1 ? s.strstart : $a4939bf33993f94f$var$MIN_MATCH - 1;
    if (flush === $a4939bf33993f94f$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a4939bf33993f94f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_FINISH_STARTED;
        /***/ return $a4939bf33993f94f$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
    /***/ }
    return $a4939bf33993f94f$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $a4939bf33993f94f$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $a4939bf33993f94f$var$MIN_LOOKAHEAD) {
            $a4939bf33993f94f$var$fill_window(s);
            if (s.lookahead < $a4939bf33993f94f$var$MIN_LOOKAHEAD && flush === $a4939bf33993f94f$var$Z_NO_FLUSH) return $a4939bf33993f94f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $a4939bf33993f94f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $a4939bf33993f94f$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $a4939bf33993f94f$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $a4939bf33993f94f$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $a4939bf33993f94f$var$Z_FILTERED || s.match_length === $a4939bf33993f94f$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $a4939bf33993f94f$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $a4939bf33993f94f$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $a4939bf33993f94f$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $ibAA4._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $a4939bf33993f94f$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $a4939bf33993f94f$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ibAA4._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ibAA4._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $a4939bf33993f94f$var$MIN_MATCH - 1 ? s.strstart : $a4939bf33993f94f$var$MIN_MATCH - 1;
    if (flush === $a4939bf33993f94f$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a4939bf33993f94f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_FINISH_STARTED;
        /***/ return $a4939bf33993f94f$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
    /***/ }
    return $a4939bf33993f94f$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $a4939bf33993f94f$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $a4939bf33993f94f$var$MAX_MATCH) {
            $a4939bf33993f94f$var$fill_window(s);
            if (s.lookahead <= $a4939bf33993f94f$var$MAX_MATCH && flush === $a4939bf33993f94f$var$Z_NO_FLUSH) return $a4939bf33993f94f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $a4939bf33993f94f$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $a4939bf33993f94f$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $a4939bf33993f94f$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $a4939bf33993f94f$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $ibAA4._tr_tally(s, 1, s.match_length - $a4939bf33993f94f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ibAA4._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $a4939bf33993f94f$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a4939bf33993f94f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_FINISH_STARTED;
        /***/ return $a4939bf33993f94f$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
    /***/ }
    return $a4939bf33993f94f$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $a4939bf33993f94f$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $a4939bf33993f94f$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $a4939bf33993f94f$var$Z_NO_FLUSH) return $a4939bf33993f94f$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ibAA4._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $a4939bf33993f94f$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $a4939bf33993f94f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_FINISH_STARTED;
        /***/ return $a4939bf33993f94f$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $a4939bf33993f94f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $a4939bf33993f94f$var$BS_NEED_MORE;
    /***/ }
    return $a4939bf33993f94f$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $a4939bf33993f94f$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $a4939bf33993f94f$var$configuration_table;
$a4939bf33993f94f$var$configuration_table = [
    /*      good lazy nice chain */ new $a4939bf33993f94f$var$Config(0, 0, 0, 0, $a4939bf33993f94f$var$deflate_stored),
    /* 0 store only */ new $a4939bf33993f94f$var$Config(4, 4, 8, 4, $a4939bf33993f94f$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $a4939bf33993f94f$var$Config(4, 5, 16, 8, $a4939bf33993f94f$var$deflate_fast),
    /* 2 */ new $a4939bf33993f94f$var$Config(4, 6, 32, 32, $a4939bf33993f94f$var$deflate_fast),
    /* 3 */ new $a4939bf33993f94f$var$Config(4, 4, 16, 16, $a4939bf33993f94f$var$deflate_slow),
    /* 4 lazy matches */ new $a4939bf33993f94f$var$Config(8, 16, 32, 32, $a4939bf33993f94f$var$deflate_slow),
    /* 5 */ new $a4939bf33993f94f$var$Config(8, 16, 128, 128, $a4939bf33993f94f$var$deflate_slow),
    /* 6 */ new $a4939bf33993f94f$var$Config(8, 32, 128, 256, $a4939bf33993f94f$var$deflate_slow),
    /* 7 */ new $a4939bf33993f94f$var$Config(32, 128, 258, 1024, $a4939bf33993f94f$var$deflate_slow),
    /* 8 */ new $a4939bf33993f94f$var$Config(32, 258, 258, 4096, $a4939bf33993f94f$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $a4939bf33993f94f$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $a4939bf33993f94f$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $a4939bf33993f94f$var$configuration_table[s.level].max_lazy;
    s.good_match = $a4939bf33993f94f$var$configuration_table[s.level].good_length;
    s.nice_match = $a4939bf33993f94f$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $a4939bf33993f94f$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $a4939bf33993f94f$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $a4939bf33993f94f$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $a4939bf33993f94f$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $bXtz7.Buf16($a4939bf33993f94f$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $bXtz7.Buf16((2 * $a4939bf33993f94f$var$D_CODES + 1) * 2);
    this.bl_tree = new $bXtz7.Buf16((2 * $a4939bf33993f94f$var$BL_CODES + 1) * 2);
    $a4939bf33993f94f$var$zero(this.dyn_ltree);
    $a4939bf33993f94f$var$zero(this.dyn_dtree);
    $a4939bf33993f94f$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $bXtz7.Buf16($a4939bf33993f94f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $bXtz7.Buf16(2 * $a4939bf33993f94f$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $a4939bf33993f94f$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $bXtz7.Buf16(2 * $a4939bf33993f94f$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $a4939bf33993f94f$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $a4939bf33993f94f$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $a4939bf33993f94f$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $a4939bf33993f94f$var$INIT_STATE : $a4939bf33993f94f$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $a4939bf33993f94f$var$Z_NO_FLUSH;
    $ibAA4._tr_init(s);
    return $a4939bf33993f94f$var$Z_OK;
}
function $a4939bf33993f94f$var$deflateReset(strm) {
    var ret = $a4939bf33993f94f$var$deflateResetKeep(strm);
    if (ret === $a4939bf33993f94f$var$Z_OK) $a4939bf33993f94f$var$lm_init(strm.state);
    return ret;
}
function $a4939bf33993f94f$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $a4939bf33993f94f$var$Z_OK;
}
function $a4939bf33993f94f$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $a4939bf33993f94f$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $a4939bf33993f94f$var$MAX_MEM_LEVEL || method !== $a4939bf33993f94f$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $a4939bf33993f94f$var$Z_FIXED) return $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $a4939bf33993f94f$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $a4939bf33993f94f$var$MIN_MATCH - 1) / $a4939bf33993f94f$var$MIN_MATCH);
    s.window = new $bXtz7.Buf8(s.w_size * 2);
    s.head = new $bXtz7.Buf16(s.hash_size);
    s.prev = new $bXtz7.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $bXtz7.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $a4939bf33993f94f$var$deflateReset(strm);
}
function $a4939bf33993f94f$var$deflateInit(strm, level) {
    return $a4939bf33993f94f$var$deflateInit2(strm, level, $a4939bf33993f94f$var$Z_DEFLATED, $a4939bf33993f94f$var$MAX_WBITS, $a4939bf33993f94f$var$DEF_MEM_LEVEL, $a4939bf33993f94f$var$Z_DEFAULT_STRATEGY);
}
function $a4939bf33993f94f$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $a4939bf33993f94f$var$Z_BLOCK || flush < 0) return strm ? $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_STREAM_ERROR) : $a4939bf33993f94f$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $a4939bf33993f94f$var$FINISH_STATE && flush !== $a4939bf33993f94f$var$Z_FINISH) return $a4939bf33993f94f$var$err(strm, strm.avail_out === 0 ? $a4939bf33993f94f$var$Z_BUF_ERROR : $a4939bf33993f94f$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $a4939bf33993f94f$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $a4939bf33993f94f$var$put_byte(s, 31);
            $a4939bf33993f94f$var$put_byte(s, 139);
            $a4939bf33993f94f$var$put_byte(s, 8);
            if (!s.gzhead) {
                $a4939bf33993f94f$var$put_byte(s, 0);
                $a4939bf33993f94f$var$put_byte(s, 0);
                $a4939bf33993f94f$var$put_byte(s, 0);
                $a4939bf33993f94f$var$put_byte(s, 0);
                $a4939bf33993f94f$var$put_byte(s, 0);
                $a4939bf33993f94f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $a4939bf33993f94f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $a4939bf33993f94f$var$put_byte(s, $a4939bf33993f94f$var$OS_CODE);
                s.status = $a4939bf33993f94f$var$BUSY_STATE;
            } else {
                $a4939bf33993f94f$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.time & 0xff);
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $a4939bf33993f94f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $a4939bf33993f94f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $a4939bf33993f94f$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $a4939bf33993f94f$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $a4939bf33993f94f$var$EXTRA_STATE;
            }
        } else {
            var header = $a4939bf33993f94f$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $a4939bf33993f94f$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $a4939bf33993f94f$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $a4939bf33993f94f$var$BUSY_STATE;
            $a4939bf33993f94f$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $a4939bf33993f94f$var$putShortMSB(s, strm.adler >>> 16);
                $a4939bf33993f94f$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $a4939bf33993f94f$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $a4939bf33993f94f$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $a4939bf33993f94f$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $a4939bf33993f94f$var$NAME_STATE;
            }
        } else s.status = $a4939bf33993f94f$var$NAME_STATE;
    }
    if (s.status === $a4939bf33993f94f$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $a4939bf33993f94f$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $a4939bf33993f94f$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $a4939bf33993f94f$var$COMMENT_STATE;
            }
        } else s.status = $a4939bf33993f94f$var$COMMENT_STATE;
    }
    if (s.status === $a4939bf33993f94f$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $a4939bf33993f94f$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $a4939bf33993f94f$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $gX4kb(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $a4939bf33993f94f$var$HCRC_STATE;
        } else s.status = $a4939bf33993f94f$var$HCRC_STATE;
    }
    if (s.status === $a4939bf33993f94f$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $a4939bf33993f94f$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $a4939bf33993f94f$var$put_byte(s, strm.adler & 0xff);
                $a4939bf33993f94f$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $a4939bf33993f94f$var$BUSY_STATE;
            }
        } else s.status = $a4939bf33993f94f$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $a4939bf33993f94f$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $a4939bf33993f94f$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $a4939bf33993f94f$var$rank(flush) <= $a4939bf33993f94f$var$rank(old_flush) && flush !== $a4939bf33993f94f$var$Z_FINISH) return $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $a4939bf33993f94f$var$FINISH_STATE && strm.avail_in !== 0) return $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $a4939bf33993f94f$var$Z_NO_FLUSH && s.status !== $a4939bf33993f94f$var$FINISH_STATE) {
        var bstate = s.strategy === $a4939bf33993f94f$var$Z_HUFFMAN_ONLY ? $a4939bf33993f94f$var$deflate_huff(s, flush) : s.strategy === $a4939bf33993f94f$var$Z_RLE ? $a4939bf33993f94f$var$deflate_rle(s, flush) : $a4939bf33993f94f$var$configuration_table[s.level].func(s, flush);
        if (bstate === $a4939bf33993f94f$var$BS_FINISH_STARTED || bstate === $a4939bf33993f94f$var$BS_FINISH_DONE) s.status = $a4939bf33993f94f$var$FINISH_STATE;
        if (bstate === $a4939bf33993f94f$var$BS_NEED_MORE || bstate === $a4939bf33993f94f$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $a4939bf33993f94f$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $a4939bf33993f94f$var$BS_BLOCK_DONE) {
            if (flush === $a4939bf33993f94f$var$Z_PARTIAL_FLUSH) $ibAA4._tr_align(s);
            else if (flush !== $a4939bf33993f94f$var$Z_BLOCK) {
                $ibAA4._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $a4939bf33993f94f$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $a4939bf33993f94f$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $a4939bf33993f94f$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $a4939bf33993f94f$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $a4939bf33993f94f$var$Z_FINISH) return $a4939bf33993f94f$var$Z_OK;
    if (s.wrap <= 0) return $a4939bf33993f94f$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $a4939bf33993f94f$var$put_byte(s, strm.adler & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.adler >> 8 & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.adler >> 16 & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.adler >> 24 & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.total_in & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $a4939bf33993f94f$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $a4939bf33993f94f$var$putShortMSB(s, strm.adler >>> 16);
        $a4939bf33993f94f$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $a4939bf33993f94f$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $a4939bf33993f94f$var$Z_OK : $a4939bf33993f94f$var$Z_STREAM_END;
}
function $a4939bf33993f94f$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $a4939bf33993f94f$var$INIT_STATE && status !== $a4939bf33993f94f$var$EXTRA_STATE && status !== $a4939bf33993f94f$var$NAME_STATE && status !== $a4939bf33993f94f$var$COMMENT_STATE && status !== $a4939bf33993f94f$var$HCRC_STATE && status !== $a4939bf33993f94f$var$BUSY_STATE && status !== $a4939bf33993f94f$var$FINISH_STATE) return $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $a4939bf33993f94f$var$BUSY_STATE ? $a4939bf33993f94f$var$err(strm, $a4939bf33993f94f$var$Z_DATA_ERROR) : $a4939bf33993f94f$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $a4939bf33993f94f$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $a4939bf33993f94f$var$INIT_STATE || s.lookahead) return $a4939bf33993f94f$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $jL1va(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $a4939bf33993f94f$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $bXtz7.Buf8(s.w_size);
        $bXtz7.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $a4939bf33993f94f$var$fill_window(s);
    while(s.lookahead >= $a4939bf33993f94f$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($a4939bf33993f94f$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $a4939bf33993f94f$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $a4939bf33993f94f$var$MIN_MATCH - 1;
        $a4939bf33993f94f$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $a4939bf33993f94f$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $a4939bf33993f94f$var$Z_OK;
}
$a4939bf33993f94f$export$72b35d618fb8ad9b = $a4939bf33993f94f$var$deflateInit;
$a4939bf33993f94f$export$a65c7b2bde87cb70 = $a4939bf33993f94f$var$deflateInit2;
$a4939bf33993f94f$export$8f99f0e30bc7dd53 = $a4939bf33993f94f$var$deflateReset;
$a4939bf33993f94f$export$e78fab288549509 = $a4939bf33993f94f$var$deflateResetKeep;
$a4939bf33993f94f$export$1cd50f7b2515ba19 = $a4939bf33993f94f$var$deflateSetHeader;
$a4939bf33993f94f$export$2316623ecd1285ab = $a4939bf33993f94f$var$deflate;
$a4939bf33993f94f$export$599854fa319a815f = $a4939bf33993f94f$var$deflateEnd;
$a4939bf33993f94f$export$f55e0b3ab66b5d46 = $a4939bf33993f94f$var$deflateSetDictionary;
$a4939bf33993f94f$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("ibAA4", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $d3d5a13fafd1c708$export$4e4fc0157c3cd14d; }, function (v) { return $d3d5a13fafd1c708$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $d3d5a13fafd1c708$export$8959e34c5e020172; }, function (v) { return $d3d5a13fafd1c708$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $d3d5a13fafd1c708$export$44f15b52eef0cf41; }, function (v) { return $d3d5a13fafd1c708$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $d3d5a13fafd1c708$export$b3cbce147289408f; }, function (v) { return $d3d5a13fafd1c708$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $d3d5a13fafd1c708$export$bfb360e02ee9b403; }, function (v) { return $d3d5a13fafd1c708$export$bfb360e02ee9b403 = v; });
var $d3d5a13fafd1c708$export$4e4fc0157c3cd14d;
var $d3d5a13fafd1c708$export$8959e34c5e020172;
var $d3d5a13fafd1c708$export$44f15b52eef0cf41;
var $d3d5a13fafd1c708$export$b3cbce147289408f;
var $d3d5a13fafd1c708$export$bfb360e02ee9b403;
"use strict";

var $bXtz7 = parcelRequire("bXtz7");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $d3d5a13fafd1c708$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $d3d5a13fafd1c708$var$Z_BINARY = 0;
var $d3d5a13fafd1c708$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $d3d5a13fafd1c708$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $d3d5a13fafd1c708$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $d3d5a13fafd1c708$var$STORED_BLOCK = 0;
var $d3d5a13fafd1c708$var$STATIC_TREES = 1;
var $d3d5a13fafd1c708$var$DYN_TREES = 2;
/* The three kinds of block type */ var $d3d5a13fafd1c708$var$MIN_MATCH = 3;
var $d3d5a13fafd1c708$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $d3d5a13fafd1c708$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $d3d5a13fafd1c708$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $d3d5a13fafd1c708$var$L_CODES = $d3d5a13fafd1c708$var$LITERALS + 1 + $d3d5a13fafd1c708$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $d3d5a13fafd1c708$var$D_CODES = 30;
/* number of distance codes */ var $d3d5a13fafd1c708$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $d3d5a13fafd1c708$var$HEAP_SIZE = 2 * $d3d5a13fafd1c708$var$L_CODES + 1;
/* maximum heap size */ var $d3d5a13fafd1c708$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $d3d5a13fafd1c708$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $d3d5a13fafd1c708$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $d3d5a13fafd1c708$var$END_BLOCK = 256;
/* end of block literal code */ var $d3d5a13fafd1c708$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $d3d5a13fafd1c708$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $d3d5a13fafd1c708$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $d3d5a13fafd1c708$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $d3d5a13fafd1c708$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $d3d5a13fafd1c708$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $d3d5a13fafd1c708$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $d3d5a13fafd1c708$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $d3d5a13fafd1c708$var$static_ltree = new Array(($d3d5a13fafd1c708$var$L_CODES + 2) * 2);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $d3d5a13fafd1c708$var$static_dtree = new Array($d3d5a13fafd1c708$var$D_CODES * 2);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $d3d5a13fafd1c708$var$_dist_code = new Array($d3d5a13fafd1c708$var$DIST_CODE_LEN);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $d3d5a13fafd1c708$var$_length_code = new Array($d3d5a13fafd1c708$var$MAX_MATCH - $d3d5a13fafd1c708$var$MIN_MATCH + 1);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $d3d5a13fafd1c708$var$base_length = new Array($d3d5a13fafd1c708$var$LENGTH_CODES);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $d3d5a13fafd1c708$var$base_dist = new Array($d3d5a13fafd1c708$var$D_CODES);
$d3d5a13fafd1c708$var$zero($d3d5a13fafd1c708$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $d3d5a13fafd1c708$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $d3d5a13fafd1c708$var$static_l_desc;
var $d3d5a13fafd1c708$var$static_d_desc;
var $d3d5a13fafd1c708$var$static_bl_desc;
function $d3d5a13fafd1c708$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $d3d5a13fafd1c708$var$d_code(dist) {
    return dist < 256 ? $d3d5a13fafd1c708$var$_dist_code[dist] : $d3d5a13fafd1c708$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $d3d5a13fafd1c708$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $d3d5a13fafd1c708$var$send_bits(s, value, length) {
    if (s.bi_valid > $d3d5a13fafd1c708$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $d3d5a13fafd1c708$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $d3d5a13fafd1c708$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $d3d5a13fafd1c708$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $d3d5a13fafd1c708$var$send_code(s, c, tree) {
    $d3d5a13fafd1c708$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $d3d5a13fafd1c708$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $d3d5a13fafd1c708$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $d3d5a13fafd1c708$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $d3d5a13fafd1c708$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $d3d5a13fafd1c708$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $d3d5a13fafd1c708$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $d3d5a13fafd1c708$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($d3d5a13fafd1c708$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $d3d5a13fafd1c708$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $d3d5a13fafd1c708$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $d3d5a13fafd1c708$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($d3d5a13fafd1c708$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $d3d5a13fafd1c708$var$LENGTH_CODES - 1; code++){
        $d3d5a13fafd1c708$var$base_length[code] = length;
        for(n = 0; n < 1 << $d3d5a13fafd1c708$var$extra_lbits[code]; n++)$d3d5a13fafd1c708$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $d3d5a13fafd1c708$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $d3d5a13fafd1c708$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $d3d5a13fafd1c708$var$extra_dbits[code]; n++)$d3d5a13fafd1c708$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $d3d5a13fafd1c708$var$D_CODES; code++){
        $d3d5a13fafd1c708$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $d3d5a13fafd1c708$var$extra_dbits[code] - 7; n++)$d3d5a13fafd1c708$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $d3d5a13fafd1c708$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $d3d5a13fafd1c708$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $d3d5a13fafd1c708$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $d3d5a13fafd1c708$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $d3d5a13fafd1c708$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $d3d5a13fafd1c708$var$gen_codes($d3d5a13fafd1c708$var$static_ltree, $d3d5a13fafd1c708$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $d3d5a13fafd1c708$var$D_CODES; n++){
        $d3d5a13fafd1c708$var$static_dtree[n * 2 + 1] = 5;
        $d3d5a13fafd1c708$var$static_dtree[n * 2] = $d3d5a13fafd1c708$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $d3d5a13fafd1c708$var$static_l_desc = new $d3d5a13fafd1c708$var$StaticTreeDesc($d3d5a13fafd1c708$var$static_ltree, $d3d5a13fafd1c708$var$extra_lbits, $d3d5a13fafd1c708$var$LITERALS + 1, $d3d5a13fafd1c708$var$L_CODES, $d3d5a13fafd1c708$var$MAX_BITS);
    $d3d5a13fafd1c708$var$static_d_desc = new $d3d5a13fafd1c708$var$StaticTreeDesc($d3d5a13fafd1c708$var$static_dtree, $d3d5a13fafd1c708$var$extra_dbits, 0, $d3d5a13fafd1c708$var$D_CODES, $d3d5a13fafd1c708$var$MAX_BITS);
    $d3d5a13fafd1c708$var$static_bl_desc = new $d3d5a13fafd1c708$var$StaticTreeDesc(new Array(0), $d3d5a13fafd1c708$var$extra_blbits, 0, $d3d5a13fafd1c708$var$BL_CODES, $d3d5a13fafd1c708$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $d3d5a13fafd1c708$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $d3d5a13fafd1c708$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $d3d5a13fafd1c708$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $d3d5a13fafd1c708$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$d3d5a13fafd1c708$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $d3d5a13fafd1c708$var$bi_windup(s) {
    if (s.bi_valid > 8) $d3d5a13fafd1c708$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $d3d5a13fafd1c708$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $d3d5a13fafd1c708$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $d3d5a13fafd1c708$var$put_short(s, len);
        $d3d5a13fafd1c708$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $bXtz7.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $d3d5a13fafd1c708$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $d3d5a13fafd1c708$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $d3d5a13fafd1c708$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($d3d5a13fafd1c708$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $d3d5a13fafd1c708$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $d3d5a13fafd1c708$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $d3d5a13fafd1c708$var$_length_code[lc];
            $d3d5a13fafd1c708$var$send_code(s, code + $d3d5a13fafd1c708$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $d3d5a13fafd1c708$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $d3d5a13fafd1c708$var$base_length[code];
                $d3d5a13fafd1c708$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $d3d5a13fafd1c708$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $d3d5a13fafd1c708$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $d3d5a13fafd1c708$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $d3d5a13fafd1c708$var$base_dist[code];
                $d3d5a13fafd1c708$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $d3d5a13fafd1c708$var$send_code(s, $d3d5a13fafd1c708$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $d3d5a13fafd1c708$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $d3d5a13fafd1c708$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$d3d5a13fafd1c708$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $d3d5a13fafd1c708$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $d3d5a13fafd1c708$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $d3d5a13fafd1c708$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $d3d5a13fafd1c708$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $d3d5a13fafd1c708$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$d3d5a13fafd1c708$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$d3d5a13fafd1c708$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$d3d5a13fafd1c708$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $d3d5a13fafd1c708$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $d3d5a13fafd1c708$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $d3d5a13fafd1c708$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $d3d5a13fafd1c708$var$send_code(s, $d3d5a13fafd1c708$var$REP_3_6, s.bl_tree);
            $d3d5a13fafd1c708$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $d3d5a13fafd1c708$var$send_code(s, $d3d5a13fafd1c708$var$REPZ_3_10, s.bl_tree);
            $d3d5a13fafd1c708$var$send_bits(s, count - 3, 3);
        } else {
            $d3d5a13fafd1c708$var$send_code(s, $d3d5a13fafd1c708$var$REPZ_11_138, s.bl_tree);
            $d3d5a13fafd1c708$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $d3d5a13fafd1c708$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $d3d5a13fafd1c708$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $d3d5a13fafd1c708$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $d3d5a13fafd1c708$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $d3d5a13fafd1c708$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$d3d5a13fafd1c708$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $d3d5a13fafd1c708$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $d3d5a13fafd1c708$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $d3d5a13fafd1c708$var$send_bits(s, dcodes - 1, 5);
    $d3d5a13fafd1c708$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $d3d5a13fafd1c708$var$send_bits(s, s.bl_tree[$d3d5a13fafd1c708$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $d3d5a13fafd1c708$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $d3d5a13fafd1c708$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $d3d5a13fafd1c708$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $d3d5a13fafd1c708$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $d3d5a13fafd1c708$var$Z_TEXT;
    for(n = 32; n < $d3d5a13fafd1c708$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $d3d5a13fafd1c708$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $d3d5a13fafd1c708$var$Z_BINARY;
}
var $d3d5a13fafd1c708$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $d3d5a13fafd1c708$var$_tr_init(s) {
    if (!$d3d5a13fafd1c708$var$static_init_done) {
        $d3d5a13fafd1c708$var$tr_static_init();
        $d3d5a13fafd1c708$var$static_init_done = true;
    }
    s.l_desc = new $d3d5a13fafd1c708$var$TreeDesc(s.dyn_ltree, $d3d5a13fafd1c708$var$static_l_desc);
    s.d_desc = new $d3d5a13fafd1c708$var$TreeDesc(s.dyn_dtree, $d3d5a13fafd1c708$var$static_d_desc);
    s.bl_desc = new $d3d5a13fafd1c708$var$TreeDesc(s.bl_tree, $d3d5a13fafd1c708$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $d3d5a13fafd1c708$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $d3d5a13fafd1c708$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $d3d5a13fafd1c708$var$send_bits(s, ($d3d5a13fafd1c708$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $d3d5a13fafd1c708$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $d3d5a13fafd1c708$var$_tr_align(s) {
    $d3d5a13fafd1c708$var$send_bits(s, $d3d5a13fafd1c708$var$STATIC_TREES << 1, 3);
    $d3d5a13fafd1c708$var$send_code(s, $d3d5a13fafd1c708$var$END_BLOCK, $d3d5a13fafd1c708$var$static_ltree);
    $d3d5a13fafd1c708$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $d3d5a13fafd1c708$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $d3d5a13fafd1c708$var$Z_UNKNOWN) s.strm.data_type = $d3d5a13fafd1c708$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $d3d5a13fafd1c708$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $d3d5a13fafd1c708$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $d3d5a13fafd1c708$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $d3d5a13fafd1c708$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $d3d5a13fafd1c708$var$Z_FIXED || static_lenb === opt_lenb) {
        $d3d5a13fafd1c708$var$send_bits(s, ($d3d5a13fafd1c708$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $d3d5a13fafd1c708$var$compress_block(s, $d3d5a13fafd1c708$var$static_ltree, $d3d5a13fafd1c708$var$static_dtree);
    } else {
        $d3d5a13fafd1c708$var$send_bits(s, ($d3d5a13fafd1c708$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $d3d5a13fafd1c708$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $d3d5a13fafd1c708$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $d3d5a13fafd1c708$var$init_block(s);
    if (last) $d3d5a13fafd1c708$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $d3d5a13fafd1c708$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($d3d5a13fafd1c708$var$_length_code[lc] + $d3d5a13fafd1c708$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$d3d5a13fafd1c708$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$d3d5a13fafd1c708$export$4e4fc0157c3cd14d = $d3d5a13fafd1c708$var$_tr_init;
$d3d5a13fafd1c708$export$8959e34c5e020172 = $d3d5a13fafd1c708$var$_tr_stored_block;
$d3d5a13fafd1c708$export$44f15b52eef0cf41 = $d3d5a13fafd1c708$var$_tr_flush_block;
$d3d5a13fafd1c708$export$b3cbce147289408f = $d3d5a13fafd1c708$var$_tr_tally;
$d3d5a13fafd1c708$export$bfb360e02ee9b403 = $d3d5a13fafd1c708$var$_tr_align;

});

parcelRegister("jL1va", function(module, exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $e623924f6dcc6902$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $e623924f6dcc6902$var$adler32;

});

parcelRegister("gX4kb", function(module, exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $c57582cb380cb6c3$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $c57582cb380cb6c3$var$crcTable = $c57582cb380cb6c3$var$makeTable();
function $c57582cb380cb6c3$var$crc32(crc, buf, len, pos) {
    var t = $c57582cb380cb6c3$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $c57582cb380cb6c3$var$crc32;

});

parcelRegister("1wUiP", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("3pcji", function(module, exports) {

$parcel$export(module.exports, "string2buf", function () { return $27ad41742fdfcac9$export$7a4c1b2f775b5a9f; }, function (v) { return $27ad41742fdfcac9$export$7a4c1b2f775b5a9f = v; });
$parcel$export(module.exports, "buf2binstring", function () { return $27ad41742fdfcac9$export$a751fe64af8a9a51; }, function (v) { return $27ad41742fdfcac9$export$a751fe64af8a9a51 = v; });
$parcel$export(module.exports, "binstring2buf", function () { return $27ad41742fdfcac9$export$1d1a7119601ff18c; }, function (v) { return $27ad41742fdfcac9$export$1d1a7119601ff18c = v; });
$parcel$export(module.exports, "buf2string", function () { return $27ad41742fdfcac9$export$49a50563f377746; }, function (v) { return $27ad41742fdfcac9$export$49a50563f377746 = v; });
$parcel$export(module.exports, "utf8border", function () { return $27ad41742fdfcac9$export$53dee3f58a714214; }, function (v) { return $27ad41742fdfcac9$export$53dee3f58a714214 = v; });
// String encode/decode helpers
// convert string to array (typed, when possible)
var $27ad41742fdfcac9$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $27ad41742fdfcac9$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $27ad41742fdfcac9$export$1d1a7119601ff18c;
// convert array to string
var $27ad41742fdfcac9$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $27ad41742fdfcac9$export$53dee3f58a714214;
"use strict";

var $bXtz7 = parcelRequire("bXtz7");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $27ad41742fdfcac9$var$STR_APPLY_OK = true;
var $27ad41742fdfcac9$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $27ad41742fdfcac9$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $27ad41742fdfcac9$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $27ad41742fdfcac9$var$_utf8len = new $bXtz7.Buf8(256);
for(var $27ad41742fdfcac9$var$q = 0; $27ad41742fdfcac9$var$q < 256; $27ad41742fdfcac9$var$q++)$27ad41742fdfcac9$var$_utf8len[$27ad41742fdfcac9$var$q] = $27ad41742fdfcac9$var$q >= 252 ? 6 : $27ad41742fdfcac9$var$q >= 248 ? 5 : $27ad41742fdfcac9$var$q >= 240 ? 4 : $27ad41742fdfcac9$var$q >= 224 ? 3 : $27ad41742fdfcac9$var$q >= 192 ? 2 : 1;
$27ad41742fdfcac9$var$_utf8len[254] = $27ad41742fdfcac9$var$_utf8len[254] = 1; // Invalid sequence start
$27ad41742fdfcac9$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $bXtz7.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $27ad41742fdfcac9$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $27ad41742fdfcac9$var$STR_APPLY_UIA_OK || !buf.subarray && $27ad41742fdfcac9$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $bXtz7.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$27ad41742fdfcac9$export$a751fe64af8a9a51 = function(buf) {
    return $27ad41742fdfcac9$var$buf2binstring(buf, buf.length);
};
$27ad41742fdfcac9$export$1d1a7119601ff18c = function(str) {
    var buf = new $bXtz7.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$27ad41742fdfcac9$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $27ad41742fdfcac9$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $27ad41742fdfcac9$var$buf2binstring(utf16buf, out);
};
$27ad41742fdfcac9$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $27ad41742fdfcac9$var$_utf8len[buf[pos]] > max ? pos : max;
};

});

parcelRegister("bPHz5", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $89d6403255f75205$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $89d6403255f75205$var$ZStream;

});


parcelRegister("e6DzP", function(module, exports) {

$parcel$export(module.exports, "Inflate", function () { return $a450535c7847f10d$export$d1de70a877d6e43c; }, function (v) { return $a450535c7847f10d$export$d1de70a877d6e43c = v; });
$parcel$export(module.exports, "inflate", function () { return $a450535c7847f10d$export$cae1ce83fe4a1782; }, function (v) { return $a450535c7847f10d$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateRaw", function () { return $a450535c7847f10d$export$d0f0aa2d05c905c5; }, function (v) { return $a450535c7847f10d$export$d0f0aa2d05c905c5 = v; });
$parcel$export(module.exports, "ungzip", function () { return $a450535c7847f10d$export$95adf9d270383091; }, function (v) { return $a450535c7847f10d$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $a450535c7847f10d$export$d1de70a877d6e43c;
var $a450535c7847f10d$export$cae1ce83fe4a1782;
var $a450535c7847f10d$export$d0f0aa2d05c905c5;
var $a450535c7847f10d$export$95adf9d270383091;
"use strict";

var $jdT3I = parcelRequire("jdT3I");

var $bXtz7 = parcelRequire("bXtz7");

var $3pcji = parcelRequire("3pcji");

var $ebefm = parcelRequire("ebefm");

var $1wUiP = parcelRequire("1wUiP");

var $bPHz5 = parcelRequire("bPHz5");

var $bFmEU = parcelRequire("bFmEU");
var $a450535c7847f10d$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $a450535c7847f10d$var$Inflate(options) {
    if (!(this instanceof $a450535c7847f10d$var$Inflate)) return new $a450535c7847f10d$var$Inflate(options);
    this.options = $bXtz7.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $bPHz5();
    this.strm.avail_out = 0;
    var status = $jdT3I.inflateInit2(this.strm, opt.windowBits);
    if (status !== $ebefm.Z_OK) throw new Error($1wUiP[status]);
    this.header = new $bFmEU();
    $jdT3I.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $3pcji.string2buf(opt.dictionary);
        else if ($a450535c7847f10d$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $jdT3I.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $ebefm.Z_OK) throw new Error($1wUiP[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $a450535c7847f10d$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $ebefm.Z_FINISH : $ebefm.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $3pcji.binstring2buf(data);
    else if ($a450535c7847f10d$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $bXtz7.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $jdT3I.inflate(strm, $ebefm.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $ebefm.Z_NEED_DICT && dictionary) status = $jdT3I.inflateSetDictionary(this.strm, dictionary);
        if (status === $ebefm.Z_BUF_ERROR && allowBufError === true) {
            status = $ebefm.Z_OK;
            allowBufError = false;
        }
        if (status !== $ebefm.Z_STREAM_END && status !== $ebefm.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $ebefm.Z_STREAM_END || strm.avail_in === 0 && (_mode === $ebefm.Z_FINISH || _mode === $ebefm.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $3pcji.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $3pcji.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $bXtz7.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($bXtz7.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $ebefm.Z_STREAM_END);
    if (status === $ebefm.Z_STREAM_END) _mode = $ebefm.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $ebefm.Z_FINISH) {
        status = $jdT3I.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $ebefm.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $ebefm.Z_SYNC_FLUSH) {
        this.onEnd($ebefm.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $a450535c7847f10d$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $a450535c7847f10d$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ebefm.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $bXtz7.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $a450535c7847f10d$var$inflate(input, options) {
    var inflator = new $a450535c7847f10d$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $1wUiP[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $a450535c7847f10d$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $a450535c7847f10d$var$inflate(input, options);
}
$a450535c7847f10d$export$d1de70a877d6e43c = $a450535c7847f10d$var$Inflate;
$a450535c7847f10d$export$cae1ce83fe4a1782 = $a450535c7847f10d$var$inflate;
$a450535c7847f10d$export$d0f0aa2d05c905c5 = $a450535c7847f10d$var$inflateRaw;
$a450535c7847f10d$export$95adf9d270383091 = $a450535c7847f10d$var$inflate;

});
parcelRegister("jdT3I", function(module, exports) {

$parcel$export(module.exports, "inflateInit2", function () { return $dfe9f0ca1a5e35a3$export$6792d92addc5c8a0; }, function (v) { return $dfe9f0ca1a5e35a3$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $dfe9f0ca1a5e35a3$export$cae1ce83fe4a1782; }, function (v) { return $dfe9f0ca1a5e35a3$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $dfe9f0ca1a5e35a3$export$224e1a443c3fba76; }, function (v) { return $dfe9f0ca1a5e35a3$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateGetHeader", function () { return $dfe9f0ca1a5e35a3$export$6d4647cb9e1c75fc; }, function (v) { return $dfe9f0ca1a5e35a3$export$6d4647cb9e1c75fc = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $dfe9f0ca1a5e35a3$export$60da749bed98ccf8; }, function (v) { return $dfe9f0ca1a5e35a3$export$60da749bed98ccf8 = v; });
var $dfe9f0ca1a5e35a3$export$42de45683a92ba94;
var $dfe9f0ca1a5e35a3$export$7633ac2cd30f9650;
var $dfe9f0ca1a5e35a3$export$6710ea52c4ec9d6a;
var $dfe9f0ca1a5e35a3$export$9c140b25e26874f9;
var $dfe9f0ca1a5e35a3$export$6792d92addc5c8a0;
var $dfe9f0ca1a5e35a3$export$cae1ce83fe4a1782;
var $dfe9f0ca1a5e35a3$export$224e1a443c3fba76;
var $dfe9f0ca1a5e35a3$export$6d4647cb9e1c75fc;
var $dfe9f0ca1a5e35a3$export$60da749bed98ccf8;
var $dfe9f0ca1a5e35a3$export$220f6291ca35fd71;
"use strict";

var $bXtz7 = parcelRequire("bXtz7");

var $jL1va = parcelRequire("jL1va");

var $gX4kb = parcelRequire("gX4kb");

var $dQ2Xc = parcelRequire("dQ2Xc");

var $fxF9l = parcelRequire("fxF9l");
var $dfe9f0ca1a5e35a3$var$CODES = 0;
var $dfe9f0ca1a5e35a3$var$LENS = 1;
var $dfe9f0ca1a5e35a3$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $dfe9f0ca1a5e35a3$var$Z_FINISH = 4;
var $dfe9f0ca1a5e35a3$var$Z_BLOCK = 5;
var $dfe9f0ca1a5e35a3$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $dfe9f0ca1a5e35a3$var$Z_OK = 0;
var $dfe9f0ca1a5e35a3$var$Z_STREAM_END = 1;
var $dfe9f0ca1a5e35a3$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR = -2;
var $dfe9f0ca1a5e35a3$var$Z_DATA_ERROR = -3;
var $dfe9f0ca1a5e35a3$var$Z_MEM_ERROR = -4;
var $dfe9f0ca1a5e35a3$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $dfe9f0ca1a5e35a3$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $dfe9f0ca1a5e35a3$var$HEAD = 1; /* i: waiting for magic header */ 
var $dfe9f0ca1a5e35a3$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $dfe9f0ca1a5e35a3$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $dfe9f0ca1a5e35a3$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $dfe9f0ca1a5e35a3$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $dfe9f0ca1a5e35a3$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $dfe9f0ca1a5e35a3$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $dfe9f0ca1a5e35a3$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $dfe9f0ca1a5e35a3$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $dfe9f0ca1a5e35a3$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $dfe9f0ca1a5e35a3$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $dfe9f0ca1a5e35a3$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $dfe9f0ca1a5e35a3$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $dfe9f0ca1a5e35a3$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $dfe9f0ca1a5e35a3$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $dfe9f0ca1a5e35a3$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $dfe9f0ca1a5e35a3$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $dfe9f0ca1a5e35a3$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $dfe9f0ca1a5e35a3$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $dfe9f0ca1a5e35a3$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $dfe9f0ca1a5e35a3$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $dfe9f0ca1a5e35a3$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $dfe9f0ca1a5e35a3$var$DIST = 23; /* i: waiting for distance code */ 
var $dfe9f0ca1a5e35a3$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $dfe9f0ca1a5e35a3$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $dfe9f0ca1a5e35a3$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $dfe9f0ca1a5e35a3$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $dfe9f0ca1a5e35a3$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $dfe9f0ca1a5e35a3$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $dfe9f0ca1a5e35a3$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $dfe9f0ca1a5e35a3$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $dfe9f0ca1a5e35a3$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $dfe9f0ca1a5e35a3$var$ENOUGH_LENS = 852;
var $dfe9f0ca1a5e35a3$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $dfe9f0ca1a5e35a3$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $dfe9f0ca1a5e35a3$var$DEF_WBITS = $dfe9f0ca1a5e35a3$var$MAX_WBITS;
function $dfe9f0ca1a5e35a3$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $dfe9f0ca1a5e35a3$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $bXtz7.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $bXtz7.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $dfe9f0ca1a5e35a3$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $dfe9f0ca1a5e35a3$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $bXtz7.Buf32($dfe9f0ca1a5e35a3$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $bXtz7.Buf32($dfe9f0ca1a5e35a3$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $dfe9f0ca1a5e35a3$var$Z_OK;
}
function $dfe9f0ca1a5e35a3$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $dfe9f0ca1a5e35a3$var$inflateResetKeep(strm);
}
function $dfe9f0ca1a5e35a3$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $dfe9f0ca1a5e35a3$var$inflateReset(strm);
}
function $dfe9f0ca1a5e35a3$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $dfe9f0ca1a5e35a3$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $dfe9f0ca1a5e35a3$var$inflateReset2(strm, windowBits);
    if (ret !== $dfe9f0ca1a5e35a3$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $dfe9f0ca1a5e35a3$var$inflateInit(strm) {
    return $dfe9f0ca1a5e35a3$var$inflateInit2(strm, $dfe9f0ca1a5e35a3$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $dfe9f0ca1a5e35a3$var$virgin = true;
var $dfe9f0ca1a5e35a3$var$lenfix, $dfe9f0ca1a5e35a3$var$distfix; // We have no pointers in JS, so keep tables separate
function $dfe9f0ca1a5e35a3$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($dfe9f0ca1a5e35a3$var$virgin) {
        var sym;
        $dfe9f0ca1a5e35a3$var$lenfix = new $bXtz7.Buf32(512);
        $dfe9f0ca1a5e35a3$var$distfix = new $bXtz7.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $fxF9l($dfe9f0ca1a5e35a3$var$LENS, state.lens, 0, 288, $dfe9f0ca1a5e35a3$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $fxF9l($dfe9f0ca1a5e35a3$var$DISTS, state.lens, 0, 32, $dfe9f0ca1a5e35a3$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $dfe9f0ca1a5e35a3$var$virgin = false;
    }
    state.lencode = $dfe9f0ca1a5e35a3$var$lenfix;
    state.lenbits = 9;
    state.distcode = $dfe9f0ca1a5e35a3$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $dfe9f0ca1a5e35a3$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $bXtz7.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $bXtz7.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $bXtz7.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $bXtz7.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $dfe9f0ca1a5e35a3$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $bXtz7.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $dfe9f0ca1a5e35a3$var$TYPE) state.mode = $dfe9f0ca1a5e35a3$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $dfe9f0ca1a5e35a3$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $dfe9f0ca1a5e35a3$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $dfe9f0ca1a5e35a3$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gX4kb(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $dfe9f0ca1a5e35a3$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $dfe9f0ca1a5e35a3$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $dfe9f0ca1a5e35a3$var$DICTID : $dfe9f0ca1a5e35a3$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $dfe9f0ca1a5e35a3$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $dfe9f0ca1a5e35a3$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gX4kb(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $dfe9f0ca1a5e35a3$var$TIME;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $gX4kb(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $dfe9f0ca1a5e35a3$var$OS;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $gX4kb(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $dfe9f0ca1a5e35a3$var$EXLEN;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $gX4kb(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $dfe9f0ca1a5e35a3$var$EXTRA;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $bXtz7.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $gX4kb(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $dfe9f0ca1a5e35a3$var$NAME;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $gX4kb(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $dfe9f0ca1a5e35a3$var$COMMENT;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $gX4kb(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $dfe9f0ca1a5e35a3$var$HCRC;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $dfe9f0ca1a5e35a3$var$TYPE;
            break;
        case $dfe9f0ca1a5e35a3$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $dfe9f0ca1a5e35a3$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $dfe9f0ca1a5e35a3$var$DICT;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $dfe9f0ca1a5e35a3$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $dfe9f0ca1a5e35a3$var$TYPE;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$TYPE:
            if (flush === $dfe9f0ca1a5e35a3$var$Z_BLOCK || flush === $dfe9f0ca1a5e35a3$var$Z_TREES) break inf_leave;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $dfe9f0ca1a5e35a3$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $dfe9f0ca1a5e35a3$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $dfe9f0ca1a5e35a3$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $dfe9f0ca1a5e35a3$var$LEN_; /* decode codes */ 
                    if (flush === $dfe9f0ca1a5e35a3$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $dfe9f0ca1a5e35a3$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $dfe9f0ca1a5e35a3$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $dfe9f0ca1a5e35a3$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $dfe9f0ca1a5e35a3$var$COPY_;
            if (flush === $dfe9f0ca1a5e35a3$var$Z_TREES) break inf_leave;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$COPY_:
            state.mode = $dfe9f0ca1a5e35a3$var$COPY;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $bXtz7.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $dfe9f0ca1a5e35a3$var$TYPE;
            break;
        case $dfe9f0ca1a5e35a3$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $dfe9f0ca1a5e35a3$var$LENLENS;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $fxF9l($dfe9f0ca1a5e35a3$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $dfe9f0ca1a5e35a3$var$CODELENS;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $dfe9f0ca1a5e35a3$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $fxF9l($dfe9f0ca1a5e35a3$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $fxF9l($dfe9f0ca1a5e35a3$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $dfe9f0ca1a5e35a3$var$LEN_;
            if (flush === $dfe9f0ca1a5e35a3$var$Z_TREES) break inf_leave;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$LEN_:
            state.mode = $dfe9f0ca1a5e35a3$var$LEN;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $dQ2Xc(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $dfe9f0ca1a5e35a3$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $dfe9f0ca1a5e35a3$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $dfe9f0ca1a5e35a3$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $dfe9f0ca1a5e35a3$var$LENEXT;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $dfe9f0ca1a5e35a3$var$DIST;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $dfe9f0ca1a5e35a3$var$DISTEXT;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $dfe9f0ca1a5e35a3$var$MATCH;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $dfe9f0ca1a5e35a3$var$LEN;
            break;
        case $dfe9f0ca1a5e35a3$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $dfe9f0ca1a5e35a3$var$LEN;
            break;
        case $dfe9f0ca1a5e35a3$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $gX4kb(state.check, output, _out, put - _out) : $jL1va(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $dfe9f0ca1a5e35a3$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $dfe9f0ca1a5e35a3$var$LENGTH;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $dfe9f0ca1a5e35a3$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $dfe9f0ca1a5e35a3$var$DONE;
        /* falls through */ case $dfe9f0ca1a5e35a3$var$DONE:
            ret = $dfe9f0ca1a5e35a3$var$Z_STREAM_END;
            break inf_leave;
        case $dfe9f0ca1a5e35a3$var$BAD:
            ret = $dfe9f0ca1a5e35a3$var$Z_DATA_ERROR;
            break inf_leave;
        case $dfe9f0ca1a5e35a3$var$MEM:
            return $dfe9f0ca1a5e35a3$var$Z_MEM_ERROR;
        case $dfe9f0ca1a5e35a3$var$SYNC:
        /* falls through */ default:
            return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $dfe9f0ca1a5e35a3$var$BAD && (state.mode < $dfe9f0ca1a5e35a3$var$CHECK || flush !== $dfe9f0ca1a5e35a3$var$Z_FINISH)) {
        if ($dfe9f0ca1a5e35a3$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $dfe9f0ca1a5e35a3$var$MEM;
            return $dfe9f0ca1a5e35a3$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $gX4kb(state.check, output, _out, strm.next_out - _out) : $jL1va(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $dfe9f0ca1a5e35a3$var$TYPE ? 128 : 0) + (state.mode === $dfe9f0ca1a5e35a3$var$LEN_ || state.mode === $dfe9f0ca1a5e35a3$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $dfe9f0ca1a5e35a3$var$Z_FINISH) && ret === $dfe9f0ca1a5e35a3$var$Z_OK) ret = $dfe9f0ca1a5e35a3$var$Z_BUF_ERROR;
    return ret;
}
function $dfe9f0ca1a5e35a3$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $dfe9f0ca1a5e35a3$var$Z_OK;
}
function $dfe9f0ca1a5e35a3$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $dfe9f0ca1a5e35a3$var$Z_OK;
}
function $dfe9f0ca1a5e35a3$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $dfe9f0ca1a5e35a3$var$DICT) return $dfe9f0ca1a5e35a3$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $dfe9f0ca1a5e35a3$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $jL1va(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $dfe9f0ca1a5e35a3$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $dfe9f0ca1a5e35a3$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $dfe9f0ca1a5e35a3$var$MEM;
        return $dfe9f0ca1a5e35a3$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $dfe9f0ca1a5e35a3$var$Z_OK;
}
$dfe9f0ca1a5e35a3$export$42de45683a92ba94 = $dfe9f0ca1a5e35a3$var$inflateReset;
$dfe9f0ca1a5e35a3$export$7633ac2cd30f9650 = $dfe9f0ca1a5e35a3$var$inflateReset2;
$dfe9f0ca1a5e35a3$export$6710ea52c4ec9d6a = $dfe9f0ca1a5e35a3$var$inflateResetKeep;
$dfe9f0ca1a5e35a3$export$9c140b25e26874f9 = $dfe9f0ca1a5e35a3$var$inflateInit;
$dfe9f0ca1a5e35a3$export$6792d92addc5c8a0 = $dfe9f0ca1a5e35a3$var$inflateInit2;
$dfe9f0ca1a5e35a3$export$cae1ce83fe4a1782 = $dfe9f0ca1a5e35a3$var$inflate;
$dfe9f0ca1a5e35a3$export$224e1a443c3fba76 = $dfe9f0ca1a5e35a3$var$inflateEnd;
$dfe9f0ca1a5e35a3$export$6d4647cb9e1c75fc = $dfe9f0ca1a5e35a3$var$inflateGetHeader;
$dfe9f0ca1a5e35a3$export$60da749bed98ccf8 = $dfe9f0ca1a5e35a3$var$inflateSetDictionary;
$dfe9f0ca1a5e35a3$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("dQ2Xc", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $a1326c446e4bc463$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $a1326c446e4bc463$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $a1326c446e4bc463$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $a1326c446e4bc463$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $a1326c446e4bc463$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $a1326c446e4bc463$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $a1326c446e4bc463$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("fxF9l", function(module, exports) {
"use strict";

var $bXtz7 = parcelRequire("bXtz7");
var $b509db8c5403296a$var$MAXBITS = 15;
var $b509db8c5403296a$var$ENOUGH_LENS = 852;
var $b509db8c5403296a$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $b509db8c5403296a$var$CODES = 0;
var $b509db8c5403296a$var$LENS = 1;
var $b509db8c5403296a$var$DISTS = 2;
var $b509db8c5403296a$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $b509db8c5403296a$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $b509db8c5403296a$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $b509db8c5403296a$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $bXtz7.Buf16($b509db8c5403296a$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $bXtz7.Buf16($b509db8c5403296a$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $b509db8c5403296a$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $b509db8c5403296a$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $b509db8c5403296a$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $b509db8c5403296a$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $b509db8c5403296a$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $b509db8c5403296a$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $b509db8c5403296a$var$LENS) {
        base = $b509db8c5403296a$var$lbase;
        base_index -= 257;
        extra = $b509db8c5403296a$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $b509db8c5403296a$var$dbase;
        extra = $b509db8c5403296a$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $b509db8c5403296a$var$LENS && used > $b509db8c5403296a$var$ENOUGH_LENS || type === $b509db8c5403296a$var$DISTS && used > $b509db8c5403296a$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $b509db8c5403296a$var$LENS && used > $b509db8c5403296a$var$ENOUGH_LENS || type === $b509db8c5403296a$var$DISTS && used > $b509db8c5403296a$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("ebefm", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});

parcelRegister("bFmEU", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $87e519975dce01d4$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $87e519975dce01d4$var$GZheader;

});




parcelRegister("2xKCP", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("36mCs", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("kaKzg", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("973Ht", function(module, exports) {
module.exports = JSON.parse('"eJyFWdtSGzkQ/RXXPO1WmZSBEAJvjnESb8AmGENCKg+ypj3Wohk5ugAmlX9fzUCyW6s+ysuUfVqXvh61Zr4XI1PX1PjiuLg6C05U1Ns/Ojx42TsYHB4eFf3irWn8VNQUB4xMsIpsCwatU1DUSm8T+JpUtW7XP6NShToiEy+0ksOm0nHkIP53b9UDlefKy3Vx7G2gfjFaCyukJzundu74wVNTUnlhatE8a/XmjXkojr/s7O33d/YOBv3D3YP+68HB136xiEOtVg2dG6e8Mk1xvLM7GPxHcLlW8rYh54rjOLO4Iuu6YcVgsP9iMBjELabGK/lkymZrWxt6f8g/e7tHr4/68Xk06J673XOve+53z8PesDRL6s23zlPtepNGGrsxVngqX/R6Q617F+1qrndBjuxdRONu4ziqVE01l2vqHNgtMveiKYUtf0rjwJHYvH/26MGrvX7x6ee/l3uv+sXQydZPtjh+tXfUL07o1/+d3YPDfjH35fvrOHO3+3n1/LN19hl5q2T0x5fvxfWnOL/11zQq4jYiuuFH/38wPUgt6hT/Fkw0dKlTSRPqZevnqkllpdFa2BTfkJVtdiYCUUeRi94BGnQBY9YTlhpNKyQC04RrV3S3zCwdXIrKWFQihdfbzZoY66MpyjCWOC3cOoUfyZoUNQ0TJX/PjPRrS8zYVSxZBlV3zFinHhiQ7jjriPdpoziFpdGGWcNRrYBIt1WcbvotCCYHK0uxDhkzvwVyHVOksWd0H6bQmxQapdBJCo1T6G0KvUuh9yk0SaG/UuhDCp2m0FkKTVNolkLnKfQxhS5SaJ5Clym0SKGrFLpOoU8p9DmFblJoGU+iW/I8bSyjDNTp8zzIKVIpqawMDIuGlrRdPDiYEun4jVeG4ZwlU2MM/zIVxHABU1AMy6WQSqG/U4ihV6aEGW8xVcvQ3oZxZQox3MDQC+P7kEJ3KXSfQgyTbhnS5/MLJMKSO0y78bls9EqX8KgvzT3jZ/50bo9L3fYraQq1XR3Ls1vu7FhpYxV7HoBVZLDxGJeMA7uycarrOmHXwnuzCipKagMooBV3C/9GDFy/YqpjxSR+bORYmilFVXFH2hPOtmJPDUcbO7LE1H7shURlxYYjtdj6E2PFv+5dCpfxcF4KXPQrAEBOWquNU0yhRkv92gTUKT4d+nxqRwdwrY+QwXONS8fkK01MOYO6qoW0XA4vLXEbl8YLyddbGa9axNpv2SqU8SoWG26Gu0NTCRtqLQKzjalik8mwtBSsHVTzCTtkWh5jy1Xs8fim8BQcsDOE8xvUkeSCZncQvL/b3pKpTg32NQhnVo+lGa+yMeWZoE1wPAmknwBJE/IRJRC6z1iDUt0pLps/A82GucoQYNIiN2kLJrnu2oVqhHJLLvg6WWA3CFQMC6BdQBPGeJOTSBDc/SNrqPz5voLZClGOBHkgeL9MswpolKOAUS+zq43QaoBVxxmedMBMBwlRgd21eaSmYgQXYIt3WSNDtkhywiEKqQWKSGjrTcZzl2tjmcVmaPcL4Lc5wEug7QJtEPjM7N5tuNA1OExPNAMpOEQ4oNU6aK82mmkzAzDwEhgYWy2vhC7VirldbTE1TME+Kpcs42yaZU4dLJJAjwbRIAroFDhoAhZq37zFhoF7/ba05pYa9g5kqVIOdL3vQLAnOUYJsar5q8gY5JQFBhnkmRsw4QZ47PklF3gFNvZMhzKCpKCzvOVR6wdPRyQYovYhk5XAwY+oNNDeMxQRdPSgSDm0MzZilm1LgIUnpD0TK8+TtL83GUbEqtXMKw0FNDL5PnOMXF+CDqfj8ZjANiYyo9o8k698Rn7I5vEpCJy3oqRaWEZzyrDCBHhpghLnFGgdnbYWmjkZ2psJKHCTy6gGdE2L38QP+IeQQRXg0mjQc1S5oPJOmGdDN8trXkaW4L52GBCiEVAiQDYvleTCcAIWsllrpiA+BuAX+bTOSodgzSHkaL7nmoF1HjMVMkanPdr7NmsKaAQm2VIAKvj85cZUbbwbw70fwVwasCguhb5W5S+03EH+CIxqsktFl+MTQqEaH4f2O+TXfvGBbHMulG2/Hn/98Q/b2xEO"');

});

parcelRegister("9TzLx", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("4uwvn", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("66yJn", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("fATNF", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("1MHeu", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("1qoDV", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("b5aGF", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("8wrOX", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("hqNKc", function(module, exports) {
module.exports = JSON.parse('"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"');

});

parcelRegister("4eh0m", function(module, exports) {
module.exports = JSON.parse('"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w=="');

});


parcelRegister("l6GEW", function(module, exports) {

$parcel$export(module.exports, "Encodings", function () { return $f5db3fc93c0b490f$export$c85030bb86979d84; });
/* tslint:disable max-classes-per-file */ 
var $69IVx = parcelRequire("69IVx");

var $2kiRy = parcelRequire("2kiRy");
var $f5db3fc93c0b490f$var$decompressedEncodings = (0, $69IVx.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($2kiRy))));
var $f5db3fc93c0b490f$var$allUnicodeMappings = JSON.parse($f5db3fc93c0b490f$var$decompressedEncodings);
var $f5db3fc93c0b490f$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $69IVx.padStart)(codePoint.toString(16), 4, "0");
                var msg = _this.name + ' cannot encode "' + str + '" (' + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $f5db3fc93c0b490f$export$c85030bb86979d84 = {
    Symbol: new $f5db3fc93c0b490f$var$Encoding("Symbol", $f5db3fc93c0b490f$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $f5db3fc93c0b490f$var$Encoding("ZapfDingbats", $f5db3fc93c0b490f$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $f5db3fc93c0b490f$var$Encoding("WinAnsi", $f5db3fc93c0b490f$var$allUnicodeMappings.win1252)
};

});
parcelRegister("2kiRy", function(module, exports) {
module.exports = JSON.parse('"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"');

});




parcelRegister("kqiuD", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", function () { return $ede494b97c22922c$export$8883a3014ee46cd1; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return $ede494b97c22922c$export$846079600c50354e; });
$parcel$export(module.exports, "assertIsSubset", function () { return $ede494b97c22922c$export$dce66947695c582f; });
$parcel$export(module.exports, "assertIs", function () { return $ede494b97c22922c$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertOrUndefined", function () { return $ede494b97c22922c$export$92143017cb173fb0; });
$parcel$export(module.exports, "assertEachIs", function () { return $ede494b97c22922c$export$47fbce961905bcd0; });
$parcel$export(module.exports, "assertRange", function () { return $ede494b97c22922c$export$6698b6d148bc9b0c; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return $ede494b97c22922c$export$bce4080186be486; });
$parcel$export(module.exports, "assertMultiple", function () { return $ede494b97c22922c$export$c9f5acf8e31d1a2e; });
$parcel$export(module.exports, "assertInteger", function () { return $ede494b97c22922c$export$a59e49f1e2708383; });
$parcel$export(module.exports, "assertPositive", function () { return $ede494b97c22922c$export$2cad8b74f3cf13dd; });
/* tslint:disable:ban-types */ 
var $dhfaG = parcelRequire("dhfaG");
var $ede494b97c22922c$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $ede494b97c22922c$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $ede494b97c22922c$var$formatValue = function(value) {
    var type = typeof value;
    if (type === "string") return $ede494b97c22922c$export$1909b7b8a28995a9(value);
    else if (type === "undefined") return $ede494b97c22922c$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $ede494b97c22922c$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $ede494b97c22922c$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(" or ");
    // prettier-ignore
    return $ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $ede494b97c22922c$var$formatValue(value);
};
var $ede494b97c22922c$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $dhfaG.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($ede494b97c22922c$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $ede494b97c22922c$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $dhfaG.values)(allowedValues);
    $ede494b97c22922c$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $ede494b97c22922c$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $dhfaG.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$ede494b97c22922c$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $ede494b97c22922c$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return "null";
    if (val === undefined) return "undefined";
    if (typeof val === "string") return "string";
    if (isNaN(val)) return "NaN";
    if (typeof val === "number") return "number";
    if (typeof val === "boolean") return "boolean";
    if (typeof val === "symbol") return "symbol";
    if (typeof val === "bigint") return "bigint";
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $ede494b97c22922c$export$26b9f946b448f23e = function(value, type) {
    if (type === "null") return value === null;
    if (type === "undefined") return value === undefined;
    if (type === "string") return typeof value === "string";
    if (type === "number") return typeof value === "number" && !isNaN(value);
    if (type === "boolean") return typeof value === "boolean";
    if (type === "symbol") return typeof value === "symbol";
    if (type === "bigint") return typeof value === "bigint";
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $ede494b97c22922c$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === "null") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("null");
        if (type === "undefined") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("undefined");
        if (type === "string") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("string");
        else if (type === "number") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("number");
        else if (type === "boolean") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("boolean");
        else if (type === "symbol") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("symbol");
        else if (type === "bigint") allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("bigint");
        else if (type === Array) allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("Array");
        else if (type === Uint8Array) allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("Uint8Array");
        else if (type === ArrayBuffer) allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8("ArrayBuffer");
        else allowedTypes[idx] = $ede494b97c22922c$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(" or ");
    // prettier-ignore
    return $ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $ede494b97c22922c$export$c7ce26e85cccb3a8($ede494b97c22922c$export$e2b5c5db9e2009fd(value));
};
var $ede494b97c22922c$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($ede494b97c22922c$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($ede494b97c22922c$export$6e3e1e6304e79984(value, valueName, types));
};
var $ede494b97c22922c$export$92143017cb173fb0 = function(value, valueName, types) {
    $ede494b97c22922c$export$6fee1f82edcf4a03(value, valueName, types.concat("undefined"));
};
var $ede494b97c22922c$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$ede494b97c22922c$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $ede494b97c22922c$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $ede494b97c22922c$export$6fee1f82edcf4a03(value, valueName, [
        "number"
    ]);
    $ede494b97c22922c$export$6fee1f82edcf4a03(min, "min", [
        "number"
    ]);
    $ede494b97c22922c$export$6fee1f82edcf4a03(max, "max", [
        "number"
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $ede494b97c22922c$export$bce4080186be486 = function(value, valueName, min, max) {
    $ede494b97c22922c$export$6fee1f82edcf4a03(value, valueName, [
        "number",
        "undefined"
    ]);
    if (typeof value === "number") $ede494b97c22922c$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $ede494b97c22922c$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $ede494b97c22922c$export$6fee1f82edcf4a03(value, valueName, [
        "number"
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $ede494b97c22922c$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $ede494b97c22922c$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($ede494b97c22922c$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("axUYF", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return $7ad92efc49f94cdd$export$ea426b9c784ba215; });

var $equxL = parcelRequire("equxL");
// Mapping from PDFDocEncoding to Unicode code point
var $7ad92efc49f94cdd$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $7ad92efc49f94cdd$var$idx = 0; $7ad92efc49f94cdd$var$idx < 256; $7ad92efc49f94cdd$var$idx++)$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[$7ad92efc49f94cdd$var$idx] = $7ad92efc49f94cdd$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x16] = (0, $equxL.toCharCode)("\x17"); // SYNCRONOUS IDLE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x18] = (0, $equxL.toCharCode)("\u02D8"); // BREVE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x19] = (0, $equxL.toCharCode)("\u02C7"); // CARON
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1a] = (0, $equxL.toCharCode)("\u02C6"); // MODIFIER LETTER CIRCUMFLEX ACCENT
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1b] = (0, $equxL.toCharCode)("\u02D9"); // DOT ABOVE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1c] = (0, $equxL.toCharCode)("\u02DD"); // DOUBLE ACUTE ACCENT
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1d] = (0, $equxL.toCharCode)("\u02DB"); // OGONEK
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1e] = (0, $equxL.toCharCode)("\u02DA"); // RING ABOVE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x1f] = (0, $equxL.toCharCode)("\u02DC"); // SMALL TILDE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x7f] = (0, $equxL.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x80] = (0, $equxL.toCharCode)("\u2022"); // BULLET
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x81] = (0, $equxL.toCharCode)("\u2020"); // DAGGER
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x82] = (0, $equxL.toCharCode)("\u2021"); // DOUBLE DAGGER
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x83] = (0, $equxL.toCharCode)("\u2026"); // HORIZONTAL ELLIPSIS
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x84] = (0, $equxL.toCharCode)("\u2014"); // EM DASH
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x85] = (0, $equxL.toCharCode)("\u2013"); // EN DASH
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x86] = (0, $equxL.toCharCode)("\u0192"); // LATIN SMALL LETTER SCRIPT F
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x87] = (0, $equxL.toCharCode)("\u2044"); // FRACTION SLASH (solidus)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x88] = (0, $equxL.toCharCode)("\u2039"); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x89] = (0, $equxL.toCharCode)("\u203A"); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8a] = (0, $equxL.toCharCode)("\u2212"); // MINUS SIGN
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8b] = (0, $equxL.toCharCode)("\u2030"); // PER MILLE SIGN
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8c] = (0, $equxL.toCharCode)("\u201E"); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8d] = (0, $equxL.toCharCode)("\u201C"); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8e] = (0, $equxL.toCharCode)("\u201D"); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x8f] = (0, $equxL.toCharCode)("\u2018"); // LEFT SINGLE QUOTATION MARK (quoteleft)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x90] = (0, $equxL.toCharCode)("\u2019"); // RIGHT SINGLE QUOTATION MARK (quoteright)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x91] = (0, $equxL.toCharCode)("\u201A"); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x92] = (0, $equxL.toCharCode)("\u2122"); // TRADE MARK SIGN
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x93] = (0, $equxL.toCharCode)("\uFB01"); // LATIN SMALL LIGATURE FI
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x94] = (0, $equxL.toCharCode)("\uFB02"); // LATIN SMALL LIGATURE FL
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x95] = (0, $equxL.toCharCode)("\u0141"); // LATIN CAPITAL LETTER L WITH STROKE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x96] = (0, $equxL.toCharCode)("\u0152"); // LATIN CAPITAL LIGATURE OE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x97] = (0, $equxL.toCharCode)("\u0160"); // LATIN CAPITAL LETTER S WITH CARON
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x98] = (0, $equxL.toCharCode)("\u0178"); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x99] = (0, $equxL.toCharCode)("\u017D"); // LATIN CAPITAL LETTER Z WITH CARON
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9a] = (0, $equxL.toCharCode)("\u0131"); // LATIN SMALL LETTER DOTLESS I
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9b] = (0, $equxL.toCharCode)("\u0142"); // LATIN SMALL LETTER L WITH STROKE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9c] = (0, $equxL.toCharCode)("\u0153"); // LATIN SMALL LIGATURE OE
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9d] = (0, $equxL.toCharCode)("\u0161"); // LATIN SMALL LETTER S WITH CARON
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9e] = (0, $equxL.toCharCode)("\u017E"); // LATIN SMALL LETTER Z WITH CARON
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0x9f] = (0, $equxL.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0xa0] = (0, $equxL.toCharCode)("\u20AC"); // EURO SIGN
$7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[0xad] = (0, $equxL.toCharCode)("\uFFFD"); // REPLACEMENT CHARACTER (box with questionmark)
var $7ad92efc49f94cdd$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $7ad92efc49f94cdd$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("k9ooy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eab79245b27551cb$export$2e2bcd8739ae039; });
var $eab79245b27551cb$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $eab79245b27551cb$export$2e2bcd8739ae039 = $eab79245b27551cb$var$Cache;

});


parcelRegister("fi0fX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b218bc59ec61ebad$export$2e2bcd8739ae039; });

var $dJvqn = parcelRequire("dJvqn");
var $b218bc59ec61ebad$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "clone");
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "toString");
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "sizeInBytes");
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "copyBytesInto");
    };
    return PDFObject;
}();
var $b218bc59ec61ebad$export$2e2bcd8739ae039 = $b218bc59ec61ebad$var$PDFObject;

});
parcelRegister("dJvqn", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", function () { return $9ff7da95d6ae09ea$export$b549a6777be1bc17; });
$parcel$export(module.exports, "PrivateConstructorError", function () { return $9ff7da95d6ae09ea$export$20e18464cd4b43a; });
$parcel$export(module.exports, "UnexpectedObjectTypeError", function () { return $9ff7da95d6ae09ea$export$ab03f98a62c22159; });
$parcel$export(module.exports, "UnsupportedEncodingError", function () { return $9ff7da95d6ae09ea$export$5de8fe8a6031fb92; });
$parcel$export(module.exports, "ReparseError", function () { return $9ff7da95d6ae09ea$export$df523155c7c35e23; });
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", function () { return $9ff7da95d6ae09ea$export$48e9be38307e3c37; });
$parcel$export(module.exports, "UnrecognizedStreamTypeError", function () { return $9ff7da95d6ae09ea$export$f8343077e7fd3a86; });
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", function () { return $9ff7da95d6ae09ea$export$22c55e00f6509a2c; });
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", function () { return $9ff7da95d6ae09ea$export$a76bae7761f3d760; });
$parcel$export(module.exports, "InvalidPDFDateStringError", function () { return $9ff7da95d6ae09ea$export$8638e3ad1edceac8; });
$parcel$export(module.exports, "InvalidTargetIndexError", function () { return $9ff7da95d6ae09ea$export$845c01ec1ddb8877; });
$parcel$export(module.exports, "CorruptPageTreeError", function () { return $9ff7da95d6ae09ea$export$1012d63cae1523f8; });
$parcel$export(module.exports, "IndexOutOfBoundsError", function () { return $9ff7da95d6ae09ea$export$19a77d83c7473130; });
$parcel$export(module.exports, "InvalidAcroFieldValueError", function () { return $9ff7da95d6ae09ea$export$d39c49ea9be644ec; });
$parcel$export(module.exports, "MultiSelectValueError", function () { return $9ff7da95d6ae09ea$export$6606fe23b6c4542c; });
$parcel$export(module.exports, "MissingDAEntryError", function () { return $9ff7da95d6ae09ea$export$dfa101de065b3cc2; });
$parcel$export(module.exports, "MissingTfOperatorError", function () { return $9ff7da95d6ae09ea$export$b5ee390f1267b133; });
$parcel$export(module.exports, "NumberParsingError", function () { return $9ff7da95d6ae09ea$export$81adf4c464255546; });
$parcel$export(module.exports, "NextByteAssertionError", function () { return $9ff7da95d6ae09ea$export$fda6cb3cf0fe0c76; });
$parcel$export(module.exports, "PDFObjectParsingError", function () { return $9ff7da95d6ae09ea$export$b8907968b8d7f502; });
$parcel$export(module.exports, "PDFInvalidObjectParsingError", function () { return $9ff7da95d6ae09ea$export$72474f06fb3a1c6b; });
$parcel$export(module.exports, "PDFStreamParsingError", function () { return $9ff7da95d6ae09ea$export$b1a91b84397f50d6; });
$parcel$export(module.exports, "UnbalancedParenthesisError", function () { return $9ff7da95d6ae09ea$export$92803ff0e03167f9; });
$parcel$export(module.exports, "StalledParserError", function () { return $9ff7da95d6ae09ea$export$b934c61834236c8; });
$parcel$export(module.exports, "MissingPDFHeaderError", function () { return $9ff7da95d6ae09ea$export$cf6bd1b11dd05d74; });
$parcel$export(module.exports, "MissingKeywordError", function () { return $9ff7da95d6ae09ea$export$bc024c15c94be864; });

var $1RwW5 = parcelRequire("1RwW5");
parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
var $9ff7da95d6ae09ea$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $9ff7da95d6ae09ea$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $9ff7da95d6ae09ea$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(" or ") + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $9ff7da95d6ae09ea$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $9ff7da95d6ae09ea$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $9ff7da95d6ae09ea$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $9ff7da95d6ae09ea$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $9ff7da95d6ae09ea$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $9ff7da95d6ae09ea$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $9ff7da95d6ae09ea$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $9ff7da95d6ae09ea$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = 'Attempted to convert "' + value + '" to a date, but it does not match the PDF date string format.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $9ff7da95d6ae09ea$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $9ff7da95d6ae09ea$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $9ff7da95d6ae09ea$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $9ff7da95d6ae09ea$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $9ff7da95d6ae09ea$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $9ff7da95d6ae09ea$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $9ff7da95d6ae09ea$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $9ff7da95d6ae09ea$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + '): "' + value + '"');
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $9ff7da95d6ae09ea$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $9ff7da95d6ae09ea$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);
var $9ff7da95d6ae09ea$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $hOX8d.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($9ff7da95d6ae09ea$export$fd202455a19cb700);

});



parcelRegister("aGkK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c6dea757f2d6f2c$export$2e2bcd8739ae039; });
var $7c6dea757f2d6f2c$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($7c6dea757f2d6f2c$var$CharCodes || ($7c6dea757f2d6f2c$var$CharCodes = {}));
var $7c6dea757f2d6f2c$export$2e2bcd8739ae039 = $7c6dea757f2d6f2c$var$CharCodes;

});


parcelRegister("aeaZ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7723bb6222dfeb45$export$2e2bcd8739ae039; });

var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
var $7723bb6222dfeb45$var$ENFORCER = {};
var $7723bb6222dfeb45$var$PDFBool = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $7723bb6222dfeb45$var$ENFORCER) throw new (0, $dJvqn.PrivateConstructorError)("PDFBool");
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $aGkK2.default).t;
            buffer[offset++] = (0, $aGkK2.default).r;
            buffer[offset++] = (0, $aGkK2.default).u;
            buffer[offset++] = (0, $aGkK2.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $aGkK2.default).f;
            buffer[offset++] = (0, $aGkK2.default).a;
            buffer[offset++] = (0, $aGkK2.default).l;
            buffer[offset++] = (0, $aGkK2.default).s;
            buffer[offset++] = (0, $aGkK2.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($7723bb6222dfeb45$var$ENFORCER, true);
    PDFBool.False = new PDFBool($7723bb6222dfeb45$var$ENFORCER, false);
    return PDFBool;
}((0, $fi0fX.default));
var $7723bb6222dfeb45$export$2e2bcd8739ae039 = $7723bb6222dfeb45$var$PDFBool;

});

parcelRegister("iqqIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d69f613f5fc29032$export$2e2bcd8739ae039; });

var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");

var $4Pi0W = parcelRequire("4Pi0W");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $d69f613f5fc29032$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $equxL.charFromHexCode)(hex);
    });
};
var $d69f613f5fc29032$var$isRegularChar = function(charCode) {
    return charCode >= (0, $aGkK2.default).ExclamationPoint && charCode <= (0, $aGkK2.default).Tilde && !(0, $4Pi0W.IsIrregular)[charCode];
};
var $d69f613f5fc29032$var$ENFORCER = {};
var $d69f613f5fc29032$var$pool = new Map();
var $d69f613f5fc29032$var$PDFName = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $d69f613f5fc29032$var$ENFORCER) throw new (0, $dJvqn.PrivateConstructorError)("PDFName");
        _this = _super.call(this) || this;
        var encodedName = "/";
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $equxL.toCharCode)(character);
            encodedName += $d69f613f5fc29032$var$isRegularChar(code) ? character : "#" + (0, $equxL.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = "";
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $equxL.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $aGkK2.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $aGkK2.default).Zero && byte <= (0, $aGkK2.default).Nine || byte >= (0, $aGkK2.default).a && byte <= (0, $aGkK2.default).f || byte >= (0, $aGkK2.default).A && byte <= (0, $aGkK2.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= "0" && nextChar <= "9" || nextChar >= "a" && nextChar <= "f" || nextChar >= "A" && nextChar <= "F")) {
                    pushByte(parseInt(hex, 16));
                    hex = "";
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $equxL.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $d69f613f5fc29032$var$decodeName(name);
        var instance = $d69f613f5fc29032$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($d69f613f5fc29032$var$ENFORCER, decodedValue);
            $d69f613f5fc29032$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of("Length");
    PDFName.FlateDecode = PDFName.of("FlateDecode");
    PDFName.Resources = PDFName.of("Resources");
    PDFName.Font = PDFName.of("Font");
    PDFName.XObject = PDFName.of("XObject");
    PDFName.ExtGState = PDFName.of("ExtGState");
    PDFName.Contents = PDFName.of("Contents");
    PDFName.Type = PDFName.of("Type");
    PDFName.Parent = PDFName.of("Parent");
    PDFName.MediaBox = PDFName.of("MediaBox");
    PDFName.Page = PDFName.of("Page");
    PDFName.Annots = PDFName.of("Annots");
    PDFName.TrimBox = PDFName.of("TrimBox");
    PDFName.ArtBox = PDFName.of("ArtBox");
    PDFName.BleedBox = PDFName.of("BleedBox");
    PDFName.CropBox = PDFName.of("CropBox");
    PDFName.Rotate = PDFName.of("Rotate");
    PDFName.Title = PDFName.of("Title");
    PDFName.Author = PDFName.of("Author");
    PDFName.Subject = PDFName.of("Subject");
    PDFName.Creator = PDFName.of("Creator");
    PDFName.Keywords = PDFName.of("Keywords");
    PDFName.Producer = PDFName.of("Producer");
    PDFName.CreationDate = PDFName.of("CreationDate");
    PDFName.ModDate = PDFName.of("ModDate");
    return PDFName;
}((0, $fi0fX.default));
var $d69f613f5fc29032$export$2e2bcd8739ae039 = $d69f613f5fc29032$var$PDFName;

});
parcelRegister("4Pi0W", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", function () { return $3839e61a1085c214$export$5a447e10c710a69b; });

var $aGkK2 = parcelRequire("aGkK2");

var $gmw8F = parcelRequire("gmw8F");

var $1Ian3 = parcelRequire("1Ian3");
var $3839e61a1085c214$export$5a447e10c710a69b = new Uint8Array(256);
for(var $3839e61a1085c214$var$idx = 0, $3839e61a1085c214$var$len = 256; $3839e61a1085c214$var$idx < $3839e61a1085c214$var$len; $3839e61a1085c214$var$idx++)$3839e61a1085c214$export$5a447e10c710a69b[$3839e61a1085c214$var$idx] = (0, $1Ian3.IsWhitespace)[$3839e61a1085c214$var$idx] || (0, $gmw8F.IsDelimiter)[$3839e61a1085c214$var$idx] ? 1 : 0;
$3839e61a1085c214$export$5a447e10c710a69b[(0, $aGkK2.default).Hash] = 1;

});
parcelRegister("gmw8F", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", function () { return $be97a180d3e73f1c$export$30620680eaa3becd; });

var $aGkK2 = parcelRequire("aGkK2");
var $be97a180d3e73f1c$export$30620680eaa3becd = new Uint8Array(256);
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).LeftParen] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).RightParen] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).LessThan] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).GreaterThan] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).LeftSquareBracket] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).RightSquareBracket] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).LeftCurly] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).RightCurly] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).ForwardSlash] = 1;
$be97a180d3e73f1c$export$30620680eaa3becd[(0, $aGkK2.default).Percent] = 1;

});

parcelRegister("1Ian3", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", function () { return $13f1f1f67260dfad$export$38c4de915d0e2c37; });

var $aGkK2 = parcelRequire("aGkK2");
var $13f1f1f67260dfad$export$38c4de915d0e2c37 = new Uint8Array(256);
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).Null] = 1;
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).Tab] = 1;
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).Newline] = 1;
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).FormFeed] = 1;
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).CarriageReturn] = 1;
$13f1f1f67260dfad$export$38c4de915d0e2c37[(0, $aGkK2.default).Space] = 1;

});




parcelRegister("4vAM8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useScannerContext", function () { return $2cfbcfc5093f75f9$export$19cfdef80a78cbe7; });
$parcel$export(module.exports, "ScannerProvider", function () { return $2cfbcfc5093f75f9$export$13a77a278469e4f2; });
$parcel$export(module.exports, "default", function () { return $2cfbcfc5093f75f9$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $fUW2W = parcelRequire("fUW2W");

var $1BSKa = parcelRequire("1BSKa");

var $cD0nt = parcelRequire("cD0nt");
const $2cfbcfc5093f75f9$var$ScannerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext({
    qrSocket: null,
    nfcSocket: null
});
const $2cfbcfc5093f75f9$export$19cfdef80a78cbe7 = ()=>(0, $eZVvM.useContext)($2cfbcfc5093f75f9$var$ScannerContext);
const $2cfbcfc5093f75f9$var$createSocket = (url, path = "/server/")=>{
    return (0, $fUW2W.io)(url, {
        path: path,
        reconnectionDelay: 5000,
        transports: [
            "websocket",
            "polling"
        ],
        autoConnect: false
    });
};
const $2cfbcfc5093f75f9$var$setupSocketListeners = (socket, type, handlers = {})=>{
    const prefix = `[${type}-socket]`;
    socket.on("connect", ()=>{
        var _handlers_connect;
        (0, $1BSKa.default).debug(`${prefix} Connected`);
        (_handlers_connect = handlers.connect) === null || _handlers_connect === void 0 ? void 0 : _handlers_connect.call(handlers);
    });
    socket.on("connect_error", (err)=>{
        var _handlers_error;
        (0, $1BSKa.default).error(`${prefix} Connection error:`, err);
        (_handlers_error = handlers.error) === null || _handlers_error === void 0 ? void 0 : _handlers_error.call(handlers, err);
        setTimeout(()=>socket.connect(), 5000);
    });
    socket.on("disconnect", (reason)=>{
        var _handlers_disconnect;
        (0, $1BSKa.default).debug(`${prefix} Disconnected:`, reason);
        (_handlers_disconnect = handlers.disconnect) === null || _handlers_disconnect === void 0 ? void 0 : _handlers_disconnect.call(handlers, reason);
    });
    socket.io.on("reconnect", (attempt)=>(0, $1BSKa.default).debug(`${prefix} Reconnected attempt: ${attempt}`));
    socket.io.on("reconnect_attempt", (attempt)=>(0, $1BSKa.default).debug(`${prefix} Reconnecting... attempt ${attempt}`));
};
const $2cfbcfc5093f75f9$export$13a77a278469e4f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { isSocketScannerActive: isSocketScannerActive, socketUrl: qrScannerSocketUrl, isSocketScannerAllowedForCheckin: isQrScannerAllowedForCheckin, isSocketScannerAllowedForCheckout: isQrScannerAllowedForCheckout } = (0, $cD0nt.useSocketScannerSettings)();
    const { isNfcScannerActive: isNfcScannerActive, nfcScannerSocketUrl: nfcScannerSocketUrl } = (0, $cD0nt.useNfcScannerSettings)();
    const navigate = (0, $9B9bN.useNavigate)();
    const socketMapRef = (0, $eZVvM.useRef)(new Map());
    const getSocket = (url)=>{
        if (!url) return null;
        if (!socketMapRef.current.has(url)) socketMapRef.current.set(url, $2cfbcfc5093f75f9$var$createSocket(url));
        return socketMapRef.current.get(url);
    };
    const qrSocket = isSocketScannerActive ? getSocket(qrScannerSocketUrl) : null;
    const nfcSocket = isNfcScannerActive && nfcScannerSocketUrl ? getSocket(nfcScannerSocketUrl) : null;
    (0, $eZVvM.useEffect)(()=>{
        if (!qrSocket) return;
        if (!qrSocket.connected && !qrSocket.connecting) {
            qrSocket.connecting = true;
            qrSocket.connect();
        }
        $2cfbcfc5093f75f9$var$setupSocketListeners(qrSocket, "qr");
        const onScan = ({ code: code })=>{
            (0, $1BSKa.default).debug(`[qr-socket] QR scanned: ${code}`);
            if (!(/^\d+$/.test(code) && code.length === 6)) {
                qrSocket.emit("scan-result", {
                    result: "bad"
                });
                return;
            }
            let pathname = `/scan/${code}`;
            if (isQrScannerAllowedForCheckin && !isQrScannerAllowedForCheckout) pathname = `/scan/${code}/checkin`;
            else if (!isQrScannerAllowedForCheckin && isQrScannerAllowedForCheckout) pathname = `/scan/${code}/checkout`;
            navigate(pathname);
        };
        qrSocket.on("scan", onScan);
        return ()=>{
            qrSocket.off("scan", onScan);
        };
    }, [
        qrSocket,
        isQrScannerAllowedForCheckin,
        isQrScannerAllowedForCheckout,
        navigate
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (!nfcSocket) return;
        if (!nfcSocket.connected && !nfcSocket.connecting) {
            nfcSocket.connecting = true;
            nfcSocket.connect();
        }
        $2cfbcfc5093f75f9$var$setupSocketListeners(nfcSocket, "nfc");
        const onNfc = ({ uid: uid })=>{
            (0, $1BSKa.default).debug(`[nfc-socket] NFC UID: ${uid}`);
            navigate(`/scan/${uid}?isNFC=true`);
        };
        nfcSocket.on("nfc-read", onNfc);
        return ()=>{
            nfcSocket.off("nfc-read", onNfc);
        };
    }, [
        nfcSocket,
        navigate
    ]);
    const value = (0, $eZVvM.useMemo)(()=>({
            qrSocket: qrSocket,
            nfcSocket: nfcSocket
        }), [
        qrSocket,
        nfcSocket
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($2cfbcfc5093f75f9$var$ScannerContext.Provider, {
        value: value,
        children: children
    });
});
var $2cfbcfc5093f75f9$export$2e2bcd8739ae039 = $2cfbcfc5093f75f9$export$13a77a278469e4f2;

});
parcelRegister("1PAIo", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $155708affa38be82$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $155708affa38be82$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $155708affa38be82$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useBeforeUnload", function () { return $155708affa38be82$export$c0a586b329cae57d; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("9B9bN")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("9B9bN")).useNavigate; });
/**
 * React Router DOM v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");

var $lMGip = parcelRequire("lMGip");
var $9B9bN = parcelRequire("9B9bN");

var $lMGip = parcelRequire("lMGip");
function $155708affa38be82$var$_extends() {
    $155708affa38be82$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $155708affa38be82$var$_extends.apply(this, arguments);
}
function $155708affa38be82$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $155708affa38be82$var$defaultMethod = "get";
const $155708affa38be82$var$defaultEncType = "application/x-www-form-urlencoded";
function $155708affa38be82$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $155708affa38be82$var$isButtonElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $155708affa38be82$var$isFormElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $155708affa38be82$var$isInputElement(object) {
    return $155708affa38be82$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $155708affa38be82$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $155708affa38be82$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$155708affa38be82$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $155708affa38be82$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $155708affa38be82$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $155708affa38be82$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $155708affa38be82$var$_formDataSupportsSubmitter = null;
function $155708affa38be82$var$isFormDataSubmitterSupported() {
    if ($155708affa38be82$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $155708affa38be82$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $155708affa38be82$var$_formDataSupportsSubmitter = true;
    }
    return $155708affa38be82$var$_formDataSupportsSubmitter;
}
const $155708affa38be82$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $155708affa38be82$var$getFormEncType(encType) {
    if (encType != null && !$155708affa38be82$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $155708affa38be82$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($155708affa38be82$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $lMGip.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $155708affa38be82$var$defaultMethod;
        encType = $155708affa38be82$var$getFormEncType(target.getAttribute("enctype")) || $155708affa38be82$var$defaultEncType;
        formData = new FormData(target);
    } else if ($155708affa38be82$var$isButtonElement(target) || $155708affa38be82$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $lMGip.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $155708affa38be82$var$defaultMethod;
        encType = $155708affa38be82$var$getFormEncType(target.getAttribute("formenctype")) || $155708affa38be82$var$getFormEncType(form.getAttribute("enctype")) || $155708affa38be82$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$155708affa38be82$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($155708affa38be82$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $155708affa38be82$var$defaultMethod;
        action = null;
        encType = $155708affa38be82$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $155708affa38be82$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $155708affa38be82$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $155708affa38be82$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $155708affa38be82$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $155708affa38be82$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $155708affa38be82$export$1f3f55432a00e06d(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $155708affa38be82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $155708affa38be82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9B9bN.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $155708affa38be82$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $155708affa38be82$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $155708affa38be82$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9B9bN.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $155708affa38be82$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $155708affa38be82$var$_extends({}, state, {
        errors: $155708affa38be82$var$deserializeErrors(state.errors)
    });
    return state;
}
function $155708affa38be82$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $lMGip.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $155708affa38be82$export$7ad602f0e94e62d1 = /*#__PURE__*/ $eZVvM.createContext({
    isTransitioning: false
});
const $155708affa38be82$export$148fd98d095596d4 = /*#__PURE__*/ $eZVvM.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $155708affa38be82$var$START_TRANSITION = "startTransition";
const $155708affa38be82$var$startTransitionImpl = $eZVvM[$155708affa38be82$var$START_TRANSITION];
const $155708affa38be82$var$FLUSH_SYNC = "flushSync";
const $155708affa38be82$var$flushSyncImpl = $e4ZGj[$155708affa38be82$var$FLUSH_SYNC];
const $155708affa38be82$var$USE_ID = "useId";
const $155708affa38be82$var$useIdImpl = $eZVvM[$155708affa38be82$var$USE_ID];
function $155708affa38be82$var$startTransitionSafe(cb) {
    if ($155708affa38be82$var$startTransitionImpl) $155708affa38be82$var$startTransitionImpl(cb);
    else cb();
}
function $155708affa38be82$var$flushSyncSafe(cb) {
    if ($155708affa38be82$var$flushSyncImpl) $155708affa38be82$var$flushSyncImpl(cb);
    else cb();
}
class $155708affa38be82$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $155708affa38be82$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eZVvM.useState(router.state);
    let [pendingState, setPendingState] = $eZVvM.useState();
    let [vtContext, setVtContext] = $eZVvM.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eZVvM.useState();
    let [transition, setTransition] = $eZVvM.useState();
    let [interruption, setInterruption] = $eZVvM.useState();
    let fetcherData = $eZVvM.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $eZVvM.useCallback((cb)=>{
        if (v7_startTransition) $155708affa38be82$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $eZVvM.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $155708affa38be82$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $155708affa38be82$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $155708affa38be82$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $155708affa38be82$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $155708affa38be82$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eZVvM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $eZVvM.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $155708affa38be82$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $eZVvM.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $eZVvM.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $eZVvM.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $eZVvM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eZVvM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eZVvM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $eZVvM.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $155708affa38be82$var$MemoizedDataRoutes = /*#__PURE__*/ $eZVvM.memo($155708affa38be82$var$DataRoutes);
function $155708affa38be82$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $9B9bN.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $155708affa38be82$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $155708affa38be82$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $155708affa38be82$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $155708affa38be82$var$startTransitionImpl ? $155708affa38be82$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>(0, $9B9bN.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement((0, $9B9bN.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $155708affa38be82$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $155708affa38be82$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $155708affa38be82$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eZVvM.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref7, $155708affa38be82$var$_excluded);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $155708affa38be82$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($155708affa38be82$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $lMGip.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $9B9bN.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $155708affa38be82$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eZVvM.createElement("a", $155708affa38be82$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $155708affa38be82$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eZVvM.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref8, $155708affa38be82$var$_excluded2);
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $9B9bN.useLocation)();
    let routerState = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $155708affa38be82$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $lMGip.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$a6c7ac8248d6e38a, $155708affa38be82$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $155708affa38be82$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eZVvM.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $155708affa38be82$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $155708affa38be82$var$_objectWithoutPropertiesLoose(_ref9, $155708affa38be82$var$_excluded3);
    let submit = $155708affa38be82$export$47c85c6e3a081d3();
    let formAction = $155708affa38be82$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $eZVvM.createElement("form", $155708affa38be82$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $155708affa38be82$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $155708affa38be82$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $155708affa38be82$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($155708affa38be82$var$DataRouterHook || ($155708affa38be82$var$DataRouterHook = {}));
var $155708affa38be82$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($155708affa38be82$var$DataRouterStateHook || ($155708affa38be82$var$DataRouterStateHook = {}));
// Internal hooks
function $155708affa38be82$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $155708affa38be82$var$useDataRouterContext(hookName) {
    let ctx = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterContext));
    !ctx && (0, $lMGip.UNSAFE_invariant)(false);
    return ctx;
}
function $155708affa38be82$var$useDataRouterState(hookName) {
    let state = $eZVvM.useContext((0, $9B9bN.UNSAFE_DataRouterStateContext));
    !state && (0, $lMGip.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $155708affa38be82$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9B9bN.useNavigate)();
    let location = (0, $9B9bN.useLocation)();
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: relative
    });
    return $eZVvM.useCallback((event)=>{
        if ($155708affa38be82$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $lMGip.createPath)(location) === (0, $lMGip.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $155708affa38be82$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eZVvM.useRef($155708affa38be82$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eZVvM.useRef(false);
    let location = (0, $9B9bN.useLocation)();
    let searchParams = $eZVvM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $155708affa38be82$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9B9bN.useNavigate)();
    let setSearchParams = $eZVvM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $155708affa38be82$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $155708affa38be82$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $155708affa38be82$var$fetcherId = 0;
let $155708affa38be82$var$getUniqueFetcherId = ()=>"__" + String(++$155708affa38be82$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $155708affa38be82$export$47c85c6e3a081d3() {
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let currentRouteId = (0, $9B9bN.UNSAFE_useRouteId)();
    return $eZVvM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $155708affa38be82$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $155708affa38be82$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $155708affa38be82$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $155708affa38be82$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let routeContext = $eZVvM.useContext((0, $9B9bN.UNSAFE_RouteContext));
    !routeContext && (0, $lMGip.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $155708affa38be82$var$_extends({}, (0, $9B9bN.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9B9bN.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $lMGip.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $lMGip.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $155708affa38be82$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseFetcher);
    let state = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $eZVvM.useContext($155708affa38be82$export$148fd98d095596d4);
    let route = $eZVvM.useContext((0, $9B9bN.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $lMGip.UNSAFE_invariant)(false);
    !route && (0, $lMGip.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $lMGip.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $155708affa38be82$var$useIdImpl ? $155708affa38be82$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $eZVvM.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($155708affa38be82$var$getUniqueFetcherId());
    // Registration/cleanup
    $eZVvM.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $eZVvM.useCallback((href, opts)=>{
        !routeId && (0, $lMGip.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $155708affa38be82$export$47c85c6e3a081d3();
    let submit = $eZVvM.useCallback((target, opts)=>{
        submitImpl(target, $155708affa38be82$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $eZVvM.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $eZVvM.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $eZVvM.createElement($155708affa38be82$export$a7fed597f4b8afd8, $155708affa38be82$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $lMGip.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eZVvM.useMemo(()=>$155708affa38be82$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $155708affa38be82$export$fa996778a3a31087() {
    let state = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $155708affa38be82$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $155708affa38be82$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $155708affa38be82$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $155708affa38be82$var$useDataRouterState($155708affa38be82$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $eZVvM.useContext((0, $9B9bN.UNSAFE_NavigationContext));
    let location = (0, $9B9bN.useLocation)();
    let matches = (0, $9B9bN.useMatches)();
    let navigation = (0, $9B9bN.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $eZVvM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $155708affa38be82$var$usePageHide($eZVvM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $155708affa38be82$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($155708affa38be82$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $155708affa38be82$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $155708affa38be82$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($155708affa38be82$var$_extends({}, location, {
                    pathname: (0, $lMGip.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($155708affa38be82$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eZVvM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $155708affa38be82$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eZVvM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $155708affa38be82$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eZVvM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $155708affa38be82$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $9B9bN.useBlocker)(when);
    $eZVvM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eZVvM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $155708affa38be82$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $eZVvM.useContext($155708affa38be82$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $lMGip.UNSAFE_invariant)(false);
    let { basename: basename } = $155708affa38be82$var$useDataRouterContext($155708affa38be82$var$DataRouterHook.useViewTransitionState);
    let path = (0, $9B9bN.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $lMGip.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $lMGip.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $lMGip.matchPath)(path.pathname, nextPath) != null || (0, $lMGip.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("e4ZGj", function(module, exports) {
"use strict";
function $a401490b67f1055b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a401490b67f1055b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a401490b67f1055b$var$checkDCE();

module.exports = (parcelRequire("59jpj"));

});

parcelRegister("lMGip", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $fdbee3c530e2e75a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $fdbee3c530e2e75a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $fdbee3c530e2e75a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $fdbee3c530e2e75a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $fdbee3c530e2e75a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $fdbee3c530e2e75a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $fdbee3c530e2e75a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $fdbee3c530e2e75a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $fdbee3c530e2e75a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $fdbee3c530e2e75a$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $fdbee3c530e2e75a$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $fdbee3c530e2e75a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $fdbee3c530e2e75a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $fdbee3c530e2e75a$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $fdbee3c530e2e75a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $fdbee3c530e2e75a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $fdbee3c530e2e75a$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $fdbee3c530e2e75a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $fdbee3c530e2e75a$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $fdbee3c530e2e75a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $fdbee3c530e2e75a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.21.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $fdbee3c530e2e75a$var$_extends() {
    $fdbee3c530e2e75a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fdbee3c530e2e75a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $fdbee3c530e2e75a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($fdbee3c530e2e75a$export$e19cd5f9376f8cee || ($fdbee3c530e2e75a$export$e19cd5f9376f8cee = {}));
const $fdbee3c530e2e75a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $fdbee3c530e2e75a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $fdbee3c530e2e75a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $fdbee3c530e2e75a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $fdbee3c530e2e75a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $fdbee3c530e2e75a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
    }
    return $fdbee3c530e2e75a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $fdbee3c530e2e75a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $fdbee3c530e2e75a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $fdbee3c530e2e75a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $fdbee3c530e2e75a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $fdbee3c530e2e75a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $fdbee3c530e2e75a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $fdbee3c530e2e75a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $fdbee3c530e2e75a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $fdbee3c530e2e75a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $fdbee3c530e2e75a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $fdbee3c530e2e75a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $fdbee3c530e2e75a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($fdbee3c530e2e75a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        let location = $fdbee3c530e2e75a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $fdbee3c530e2e75a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        let location = $fdbee3c530e2e75a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $fdbee3c530e2e75a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $fdbee3c530e2e75a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($fdbee3c530e2e75a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($fdbee3c530e2e75a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $fdbee3c530e2e75a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($fdbee3c530e2e75a$var$ResultType || ($fdbee3c530e2e75a$var$ResultType = {}));
const $fdbee3c530e2e75a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $fdbee3c530e2e75a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $fdbee3c530e2e75a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($fdbee3c530e2e75a$var$isIndexRoute(route)) {
            let indexRoute = $fdbee3c530e2e75a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $fdbee3c530e2e75a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $fdbee3c530e2e75a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $fdbee3c530e2e75a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $fdbee3c530e2e75a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $fdbee3c530e2e75a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $fdbee3c530e2e75a$var$flattenRoutes(routes);
    $fdbee3c530e2e75a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $fdbee3c530e2e75a$export$30d21fd6d7295f52(pathname);
        matches = $fdbee3c530e2e75a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $fdbee3c530e2e75a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $fdbee3c530e2e75a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $fdbee3c530e2e75a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $fdbee3c530e2e75a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $fdbee3c530e2e75a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $fdbee3c530e2e75a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $fdbee3c530e2e75a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $fdbee3c530e2e75a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $fdbee3c530e2e75a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $fdbee3c530e2e75a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $fdbee3c530e2e75a$var$paramRe = /^:[\w-]+$/;
const $fdbee3c530e2e75a$var$dynamicSegmentValue = 3;
const $fdbee3c530e2e75a$var$indexRouteValue = 2;
const $fdbee3c530e2e75a$var$emptySegmentValue = 1;
const $fdbee3c530e2e75a$var$staticSegmentValue = 10;
const $fdbee3c530e2e75a$var$splatPenalty = -2;
const $fdbee3c530e2e75a$var$isSplat = (s)=>s === "*";
function $fdbee3c530e2e75a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($fdbee3c530e2e75a$var$isSplat)) initialScore += $fdbee3c530e2e75a$var$splatPenalty;
    if (index) initialScore += $fdbee3c530e2e75a$var$indexRouteValue;
    return segments.filter((s)=>!$fdbee3c530e2e75a$var$isSplat(s)).reduce((score, segment)=>score + ($fdbee3c530e2e75a$var$paramRe.test(segment) ? $fdbee3c530e2e75a$var$dynamicSegmentValue : segment === "" ? $fdbee3c530e2e75a$var$emptySegmentValue : $fdbee3c530e2e75a$var$staticSegmentValue), initialScore);
}
function $fdbee3c530e2e75a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $fdbee3c530e2e75a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $fdbee3c530e2e75a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $fdbee3c530e2e75a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $fdbee3c530e2e75a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $fdbee3c530e2e75a$export$a5c6d149b50c1d86($fdbee3c530e2e75a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $fdbee3c530e2e75a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $fdbee3c530e2e75a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $fdbee3c530e2e75a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $fdbee3c530e2e75a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $fdbee3c530e2e75a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $fdbee3c530e2e75a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $fdbee3c530e2e75a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $fdbee3c530e2e75a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $fdbee3c530e2e75a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $fdbee3c530e2e75a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $fdbee3c530e2e75a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $fdbee3c530e2e75a$var$normalizeSearch(search),
        hash: $fdbee3c530e2e75a$var$normalizeHash(hash)
    };
}
function $fdbee3c530e2e75a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $fdbee3c530e2e75a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $fdbee3c530e2e75a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $fdbee3c530e2e75a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $fdbee3c530e2e75a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $fdbee3c530e2e75a$var$_extends({}, toArg);
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $fdbee3c530e2e75a$var$getInvalidPathError("?", "pathname", "search", to));
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $fdbee3c530e2e75a$var$getInvalidPathError("#", "pathname", "hash", to));
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $fdbee3c530e2e75a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $fdbee3c530e2e75a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $fdbee3c530e2e75a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $fdbee3c530e2e75a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $fdbee3c530e2e75a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $fdbee3c530e2e75a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $fdbee3c530e2e75a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $fdbee3c530e2e75a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $fdbee3c530e2e75a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $fdbee3c530e2e75a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $fdbee3c530e2e75a$export$4051a07651545597(data, init) {
    return new $fdbee3c530e2e75a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $fdbee3c530e2e75a$export$42a99a7a4bc0e76a extends Error {
}
class $fdbee3c530e2e75a$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $fdbee3c530e2e75a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $fdbee3c530e2e75a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $fdbee3c530e2e75a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $fdbee3c530e2e75a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $fdbee3c530e2e75a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $fdbee3c530e2e75a$var$unwrapTrackedPromise(value) {
    if (!$fdbee3c530e2e75a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $fdbee3c530e2e75a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $fdbee3c530e2e75a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $fdbee3c530e2e75a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $fdbee3c530e2e75a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $fdbee3c530e2e75a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $fdbee3c530e2e75a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $fdbee3c530e2e75a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $fdbee3c530e2e75a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $fdbee3c530e2e75a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $fdbee3c530e2e75a$var$validMutationMethods = new Set($fdbee3c530e2e75a$var$validMutationMethodsArr);
const $fdbee3c530e2e75a$var$validRequestMethodsArr = [
    "get",
    ...$fdbee3c530e2e75a$var$validMutationMethodsArr
];
const $fdbee3c530e2e75a$var$validRequestMethods = new Set($fdbee3c530e2e75a$var$validRequestMethodsArr);
const $fdbee3c530e2e75a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $fdbee3c530e2e75a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $fdbee3c530e2e75a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdbee3c530e2e75a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $fdbee3c530e2e75a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $fdbee3c530e2e75a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $fdbee3c530e2e75a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $fdbee3c530e2e75a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdbee3c530e2e75a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $fdbee3c530e2e75a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $fdbee3c530e2e75a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $fdbee3c530e2e75a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $fdbee3c530e2e75a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $fdbee3c530e2e75a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $fdbee3c530e2e75a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$fdbee3c530e2e75a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $fdbee3c530e2e75a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $fdbee3c530e2e75a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $fdbee3c530e2e75a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $fdbee3c530e2e75a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $fdbee3c530e2e75a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($fdbee3c530e2e75a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $fdbee3c530e2e75a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $fdbee3c530e2e75a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $fdbee3c530e2e75a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $fdbee3c530e2e75a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $fdbee3c530e2e75a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $fdbee3c530e2e75a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $fdbee3c530e2e75a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $fdbee3c530e2e75a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $fdbee3c530e2e75a$var$findNearestBoundary(matches).route.id,
            {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $fdbee3c530e2e75a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($fdbee3c530e2e75a$var$isErrorResult(result) && $fdbee3c530e2e75a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $fdbee3c530e2e75a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $fdbee3c530e2e75a$var$_extends({
            matches: updatedMatches || matches
        }, $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $fdbee3c530e2e75a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdbee3c530e2e75a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $fdbee3c530e2e75a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $fdbee3c530e2e75a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $fdbee3c530e2e75a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $fdbee3c530e2e75a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $fdbee3c530e2e75a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $fdbee3c530e2e75a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($fdbee3c530e2e75a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $fdbee3c530e2e75a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $fdbee3c530e2e75a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $fdbee3c530e2e75a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $fdbee3c530e2e75a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $fdbee3c530e2e75a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $fdbee3c530e2e75a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $fdbee3c530e2e75a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $fdbee3c530e2e75a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $fdbee3c530e2e75a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $fdbee3c530e2e75a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdbee3c530e2e75a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $fdbee3c530e2e75a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($fdbee3c530e2e75a$var$isRedirectResult(actionResult) || $fdbee3c530e2e75a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($fdbee3c530e2e75a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $fdbee3c530e2e75a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($fdbee3c530e2e75a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($fdbee3c530e2e75a$var$isDeferredResult(actionResult)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $fdbee3c530e2e75a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $fdbee3c530e2e75a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $fdbee3c530e2e75a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $fdbee3c530e2e75a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $fdbee3c530e2e75a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $fdbee3c530e2e75a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $fdbee3c530e2e75a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $fdbee3c530e2e75a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $fdbee3c530e2e75a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $fdbee3c530e2e75a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) result = await $fdbee3c530e2e75a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!$fdbee3c530e2e75a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $fdbee3c530e2e75a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $fdbee3c530e2e75a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $fdbee3c530e2e75a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $fdbee3c530e2e75a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $fdbee3c530e2e75a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Replace : $fdbee3c530e2e75a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $fdbee3c530e2e75a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($fdbee3c530e2e75a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $fdbee3c530e2e75a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $fdbee3c530e2e75a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $fdbee3c530e2e75a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $fdbee3c530e2e75a$var$ResultType.redirect,
                response: $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $fdbee3c530e2e75a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $fdbee3c530e2e75a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $fdbee3c530e2e75a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $fdbee3c530e2e75a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $fdbee3c530e2e75a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $fdbee3c530e2e75a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $fdbee3c530e2e75a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $fdbee3c530e2e75a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $fdbee3c530e2e75a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $fdbee3c530e2e75a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $fdbee3c530e2e75a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$fdbee3c530e2e75a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $fdbee3c530e2e75a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $fdbee3c530e2e75a$export$4d0306f8f6a4585b = Symbol("deferred");
function $fdbee3c530e2e75a$export$3336b097a6fbc59a(routes, opts) {
    $fdbee3c530e2e75a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $fdbee3c530e2e75a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $fdbee3c530e2e75a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdbee3c530e2e75a$var$createLocation("", $fdbee3c530e2e75a$export$fe53371bee54353d(url), null, "default");
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdbee3c530e2e75a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $fdbee3c530e2e75a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($fdbee3c530e2e75a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $fdbee3c530e2e75a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $fdbee3c530e2e75a$var$createLocation("", $fdbee3c530e2e75a$export$fe53371bee54353d(url), null, "default");
        let matches = $fdbee3c530e2e75a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$fdbee3c530e2e75a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $fdbee3c530e2e75a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $fdbee3c530e2e75a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $fdbee3c530e2e75a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($fdbee3c530e2e75a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$fdbee3c530e2e75a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $fdbee3c530e2e75a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($fdbee3c530e2e75a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $fdbee3c530e2e75a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $fdbee3c530e2e75a$var$isResponse(result) ? result : $fdbee3c530e2e75a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($fdbee3c530e2e75a$var$isDataStrategyResult(e) && $fdbee3c530e2e75a$var$isResponse(e.result)) {
                if (e.type === $fdbee3c530e2e75a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($fdbee3c530e2e75a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            let error = $fdbee3c530e2e75a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($fdbee3c530e2e75a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $fdbee3c530e2e75a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $fdbee3c530e2e75a$var$_extends({}, context, {
                statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $fdbee3c530e2e75a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $fdbee3c530e2e75a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $fdbee3c530e2e75a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $fdbee3c530e2e75a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategy || $fdbee3c530e2e75a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($fdbee3c530e2e75a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $fdbee3c530e2e75a$export$fec11da027c70692(routes, context, error) {
    let newContext = $fdbee3c530e2e75a$var$_extends({}, context, {
        statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $fdbee3c530e2e75a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $fdbee3c530e2e75a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $fdbee3c530e2e75a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $fdbee3c530e2e75a$export$cae722b0cc860f13(to ? to : ".", $fdbee3c530e2e75a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $fdbee3c530e2e75a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $fdbee3c530e2e75a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $fdbee3c530e2e75a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $fdbee3c530e2e75a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $fdbee3c530e2e75a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$fdbee3c530e2e75a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$fdbee3c530e2e75a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $fdbee3c530e2e75a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $fdbee3c530e2e75a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $fdbee3c530e2e75a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$fdbee3c530e2e75a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$fdbee3c530e2e75a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $fdbee3c530e2e75a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $fdbee3c530e2e75a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $fdbee3c530e2e75a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $fdbee3c530e2e75a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $fdbee3c530e2e75a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($fdbee3c530e2e75a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $fdbee3c530e2e75a$var$shouldRevalidateLoader(match, $fdbee3c530e2e75a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $fdbee3c530e2e75a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $fdbee3c530e2e75a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $fdbee3c530e2e75a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $fdbee3c530e2e75a$var$shouldRevalidateLoader(fetcherMatch, $fdbee3c530e2e75a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $fdbee3c530e2e75a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $fdbee3c530e2e75a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $fdbee3c530e2e75a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $fdbee3c530e2e75a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $fdbee3c530e2e75a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$fdbee3c530e2e75a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $fdbee3c530e2e75a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $fdbee3c530e2e75a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$fdbee3c530e2e75a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $fdbee3c530e2e75a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $fdbee3c530e2e75a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $fdbee3c530e2e75a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$fdbee3c530e2e75a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $fdbee3c530e2e75a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $fdbee3c530e2e75a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $fdbee3c530e2e75a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $fdbee3c530e2e75a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $fdbee3c530e2e75a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $fdbee3c530e2e75a$var$ResultType.data,
                result: undefined
            });
        };
        return $fdbee3c530e2e75a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $fdbee3c530e2e75a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $fdbee3c530e2e75a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $fdbee3c530e2e75a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $fdbee3c530e2e75a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $fdbee3c530e2e75a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $fdbee3c530e2e75a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($fdbee3c530e2e75a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $fdbee3c530e2e75a$var$ResultType.error,
                error: e
            };
        }
        if (type === $fdbee3c530e2e75a$var$ResultType.error) return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: new $fdbee3c530e2e75a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $fdbee3c530e2e75a$var$ResultType.error) {
        if ($fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $fdbee3c530e2e75a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $fdbee3c530e2e75a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: result,
            statusCode: $fdbee3c530e2e75a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($fdbee3c530e2e75a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $fdbee3c530e2e75a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $fdbee3c530e2e75a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $fdbee3c530e2e75a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $fdbee3c530e2e75a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $fdbee3c530e2e75a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $fdbee3c530e2e75a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($fdbee3c530e2e75a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $fdbee3c530e2e75a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $fdbee3c530e2e75a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($fdbee3c530e2e75a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $fdbee3c530e2e75a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $fdbee3c530e2e75a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $fdbee3c530e2e75a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $fdbee3c530e2e75a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(!$fdbee3c530e2e75a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $fdbee3c530e2e75a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $fdbee3c530e2e75a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $fdbee3c530e2e75a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $fdbee3c530e2e75a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($fdbee3c530e2e75a$var$isErrorResult(result)) {
            let boundaryMatch = $fdbee3c530e2e75a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $fdbee3c530e2e75a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($fdbee3c530e2e75a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $fdbee3c530e2e75a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($fdbee3c530e2e75a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $fdbee3c530e2e75a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $fdbee3c530e2e75a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $fdbee3c530e2e75a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $fdbee3c530e2e75a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $fdbee3c530e2e75a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $fdbee3c530e2e75a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $fdbee3c530e2e75a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $fdbee3c530e2e75a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $fdbee3c530e2e75a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $fdbee3c530e2e75a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $fdbee3c530e2e75a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($fdbee3c530e2e75a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $fdbee3c530e2e75a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(path) : path;
    return $fdbee3c530e2e75a$export$fe53371bee54353d($fdbee3c530e2e75a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $fdbee3c530e2e75a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $fdbee3c530e2e75a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $fdbee3c530e2e75a$var$ResultType.data || result.type === $fdbee3c530e2e75a$var$ResultType.error);
}
function $fdbee3c530e2e75a$var$isRedirectDataStrategyResultResult(result) {
    return $fdbee3c530e2e75a$var$isResponse(result.result) && $fdbee3c530e2e75a$var$redirectStatusCodes.has(result.result.status);
}
function $fdbee3c530e2e75a$var$isDeferredResult(result) {
    return result.type === $fdbee3c530e2e75a$var$ResultType.deferred;
}
function $fdbee3c530e2e75a$var$isErrorResult(result) {
    return result.type === $fdbee3c530e2e75a$var$ResultType.error;
}
function $fdbee3c530e2e75a$var$isRedirectResult(result) {
    return (result && result.type) === $fdbee3c530e2e75a$var$ResultType.redirect;
}
function $fdbee3c530e2e75a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $fdbee3c530e2e75a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $fdbee3c530e2e75a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $fdbee3c530e2e75a$var$isRedirectResponse(result) {
    if (!$fdbee3c530e2e75a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $fdbee3c530e2e75a$var$isValidMethod(method) {
    return $fdbee3c530e2e75a$var$validRequestMethods.has(method.toLowerCase());
}
function $fdbee3c530e2e75a$var$isMutationMethod(method) {
    return $fdbee3c530e2e75a$var$validMutationMethods.has(method.toLowerCase());
}
async function $fdbee3c530e2e75a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$fdbee3c530e2e75a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($fdbee3c530e2e75a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $fdbee3c530e2e75a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $fdbee3c530e2e75a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($fdbee3c530e2e75a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $fdbee3c530e2e75a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $fdbee3c530e2e75a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $fdbee3c530e2e75a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $fdbee3c530e2e75a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $fdbee3c530e2e75a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $fdbee3c530e2e75a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $fdbee3c530e2e75a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $fdbee3c530e2e75a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $fdbee3c530e2e75a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $fdbee3c530e2e75a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $fdbee3c530e2e75a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $fdbee3c530e2e75a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $fdbee3c530e2e75a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $fdbee3c530e2e75a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $fdbee3c530e2e75a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $fdbee3c530e2e75a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $fdbee3c530e2e75a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $fdbee3c530e2e75a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $fdbee3c530e2e75a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($fdbee3c530e2e75a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $fdbee3c530e2e75a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("9B9bN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6fceb28f277b924b$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6fceb28f277b924b$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6fceb28f277b924b$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6fceb28f277b924b$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6fceb28f277b924b$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6fceb28f277b924b$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6fceb28f277b924b$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $6fceb28f277b924b$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $6fceb28f277b924b$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $6fceb28f277b924b$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6fceb28f277b924b$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6fceb28f277b924b$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6fceb28f277b924b$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6fceb28f277b924b$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $6fceb28f277b924b$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $6fceb28f277b924b$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $6fceb28f277b924b$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $6fceb28f277b924b$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $6fceb28f277b924b$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $6fceb28f277b924b$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6fceb28f277b924b$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6fceb28f277b924b$export$52b333d321859367; });
/**
 * React Router v6.28.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eZVvM = parcelRequire("eZVvM");

var $lMGip = parcelRequire("lMGip");
function $6fceb28f277b924b$var$_extends() {
    $6fceb28f277b924b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6fceb28f277b924b$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6fceb28f277b924b$export$3add0d5dce533e2e = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$145dfa71566a64dc = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$var$AwaitContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6fceb28f277b924b$export$26749e8557646306 = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$c7914228fb69b0f5 = /*#__PURE__*/ $eZVvM.createContext(null);
const $6fceb28f277b924b$export$9072aa6dd1f93057 = /*#__PURE__*/ $eZVvM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6fceb28f277b924b$var$RouteErrorContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $6fceb28f277b924b$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6fceb28f277b924b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $lMGip.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $6fceb28f277b924b$export$9c954a9d03d32f4a() {
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $6fceb28f277b924b$export$45d76561a5302f2b() {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $6fceb28f277b924b$export$1b3f31771c5d07c() {
    return $eZVvM.useContext($6fceb28f277b924b$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $6fceb28f277b924b$export$6c330e8992e8a295(pattern) {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    return $eZVvM.useMemo(()=>(0, $lMGip.matchPath)(pattern, (0, $lMGip.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6fceb28f277b924b$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6fceb28f277b924b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $eZVvM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $6fceb28f277b924b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6fceb28f277b924b$var$useNavigateStable() : $6fceb28f277b924b$var$useNavigateUnstable();
}
function $6fceb28f277b924b$var$useNavigateUnstable() {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let dataRouterContext = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $eZVvM.useRef(false);
    $6fceb28f277b924b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eZVvM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $lMGip.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $lMGip.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6fceb28f277b924b$var$OutletContext = /*#__PURE__*/ $eZVvM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $6fceb28f277b924b$export$4138103a3ae699cc() {
    return $eZVvM.useContext($6fceb28f277b924b$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $6fceb28f277b924b$export$a3be3530d8e40d0b(context) {
    let outlet = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $6fceb28f277b924b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $6fceb28f277b924b$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $eZVvM.useMemo(()=>(0, $lMGip.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $6fceb28f277b924b$export$5d3fca4a98652595(routes, locationArg) {
    return $6fceb28f277b924b$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6fceb28f277b924b$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: parentMatches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6fceb28f277b924b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $lMGip.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $lMGip.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $lMGip.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6fceb28f277b924b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $lMGip.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $lMGip.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6fceb28f277b924b$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $lMGip.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6fceb28f277b924b$var$DefaultErrorComponent() {
    let error = $6fceb28f277b924b$export$ed527bf60f6e05f2();
    let message = (0, $lMGip.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eZVvM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eZVvM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6fceb28f277b924b$var$defaultErrorElement = /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$DefaultErrorComponent, null);
class $6fceb28f277b924b$var$RenderErrorBoundary extends $eZVvM.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $6fceb28f277b924b$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6fceb28f277b924b$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $lMGip.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6fceb28f277b924b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6fceb28f277b924b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $eZVvM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6fceb28f277b924b$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6fceb28f277b924b$var$DataRouterHook || {});
var $6fceb28f277b924b$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6fceb28f277b924b$var$DataRouterStateHook || {});
function $6fceb28f277b924b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $6fceb28f277b924b$var$useDataRouterContext(hookName) {
    let ctx = $eZVvM.useContext($6fceb28f277b924b$export$3add0d5dce533e2e);
    !ctx && (0, $lMGip.UNSAFE_invariant)(false);
    return ctx;
}
function $6fceb28f277b924b$var$useDataRouterState(hookName) {
    let state = $eZVvM.useContext($6fceb28f277b924b$export$145dfa71566a64dc);
    !state && (0, $lMGip.UNSAFE_invariant)(false);
    return state;
}
function $6fceb28f277b924b$var$useRouteContext(hookName) {
    let route = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    !route && (0, $lMGip.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6fceb28f277b924b$var$useCurrentRouteId(hookName) {
    let route = $6fceb28f277b924b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $lMGip.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6fceb28f277b924b$export$5fc8298006ad9e58() {
    return $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6fceb28f277b924b$export$d0fd4b7106de2769() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6fceb28f277b924b$export$600dc272ed516c15() {
    let dataRouterContext = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseRevalidator);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRevalidator);
    return $eZVvM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6fceb28f277b924b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseMatches);
    return $eZVvM.useMemo(()=>matches.map((m)=>(0, $lMGip.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6fceb28f277b924b$export$1448a5050d252c4d() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6fceb28f277b924b$export$fd5d37484eab868d(routeId) {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6fceb28f277b924b$export$fdc00f3f26066d5e() {
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseActionData);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6fceb28f277b924b$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eZVvM.useContext($6fceb28f277b924b$var$RouteErrorContext);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseRouteError);
    let routeId = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6fceb28f277b924b$export$78a72ddb39bdd145() {
    let value = $eZVvM.useContext($6fceb28f277b924b$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6fceb28f277b924b$export$17f53340677d5831() {
    let value = $eZVvM.useContext($6fceb28f277b924b$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6fceb28f277b924b$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6fceb28f277b924b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseBlocker);
    let state = $6fceb28f277b924b$var$useDataRouterState($6fceb28f277b924b$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $eZVvM.useState("");
    let blockerFunction = $eZVvM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6fceb28f277b924b$var$_extends({}, currentLocation, {
                pathname: (0, $lMGip.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6fceb28f277b924b$var$_extends({}, nextLocation, {
                pathname: (0, $lMGip.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $eZVvM.useEffect(()=>{
        let key = String(++$6fceb28f277b924b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $eZVvM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $lMGip.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6fceb28f277b924b$var$useNavigateStable() {
    let { router: router } = $6fceb28f277b924b$var$useDataRouterContext($6fceb28f277b924b$var$DataRouterHook.UseNavigateStable);
    let id = $6fceb28f277b924b$var$useCurrentRouteId($6fceb28f277b924b$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $eZVvM.useRef(false);
    $6fceb28f277b924b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eZVvM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6fceb28f277b924b$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6fceb28f277b924b$var$alreadyWarned$1 = {};
function $6fceb28f277b924b$var$warningOnce(key, cond, message) {
    if (!cond && !$6fceb28f277b924b$var$alreadyWarned$1[key]) $6fceb28f277b924b$var$alreadyWarned$1[key] = true;
}
const $6fceb28f277b924b$var$alreadyWarned = {};
function $6fceb28f277b924b$var$warnOnce(key, message) {
    if (!$6fceb28f277b924b$var$alreadyWarned[message]) {
        $6fceb28f277b924b$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $6fceb28f277b924b$var$logDeprecation = (flag, msg, link)=>$6fceb28f277b924b$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $6fceb28f277b924b$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if (!(renderFuture != null && renderFuture.v7_startTransition)) $6fceb28f277b924b$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if (!(renderFuture != null && renderFuture.v7_relativeSplatPath) && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $6fceb28f277b924b$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (!routerFuture.v7_fetcherPersist) $6fceb28f277b924b$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (!routerFuture.v7_normalizeFormMethod) $6fceb28f277b924b$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (!routerFuture.v7_partialHydration) $6fceb28f277b924b$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (!routerFuture.v7_skipActionErrorRevalidation) $6fceb28f277b924b$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6fceb28f277b924b$var$START_TRANSITION = "startTransition";
const $6fceb28f277b924b$var$startTransitionImpl = $eZVvM[$6fceb28f277b924b$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6fceb28f277b924b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $eZVvM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        if (v7_startTransition && $6fceb28f277b924b$var$startTransitionImpl) $6fceb28f277b924b$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $eZVvM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eZVvM.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $eZVvM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eZVvM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $eZVvM.useEffect(()=>$6fceb28f277b924b$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6fceb28f277b924b$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6fceb28f277b924b$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $6fceb28f277b924b$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $eZVvM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $lMGip.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eZVvM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $eZVvM.useCallback((newState)=>{
        v7_startTransition && $6fceb28f277b924b$var$startTransitionImpl ? $6fceb28f277b924b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $eZVvM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $eZVvM.useEffect(()=>$6fceb28f277b924b$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $6fceb28f277b924b$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $eZVvM.useContext($6fceb28f277b924b$export$26749e8557646306);
    let { matches: matches } = $eZVvM.useContext($6fceb28f277b924b$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6fceb28f277b924b$export$45d76561a5302f2b();
    let navigate = $6fceb28f277b924b$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $lMGip.resolveTo)(to, (0, $lMGip.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eZVvM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $6fceb28f277b924b$export$910ae8079b2c2852(props) {
    return $6fceb28f277b924b$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $6fceb28f277b924b$export$e7b0ac011bb776c6(_props) {
    (0, $lMGip.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $6fceb28f277b924b$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $lMGip.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6fceb28f277b924b$export$9c954a9d03d32f4a() && (0, $lMGip.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eZVvM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6fceb28f277b924b$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $lMGip.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eZVvM.useMemo(()=>{
        let trailingPathname = (0, $lMGip.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $6fceb28f277b924b$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6fceb28f277b924b$export$5d3fca4a98652595($6fceb28f277b924b$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6fceb28f277b924b$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$ResolveAwait, null, children));
}
var $6fceb28f277b924b$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6fceb28f277b924b$var$AwaitRenderStatus || {});
const $6fceb28f277b924b$var$neverSettledPromise = new Promise(()=>{});
class $6fceb28f277b924b$var$AwaitErrorBoundary extends $eZVvM.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6fceb28f277b924b$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6fceb28f277b924b$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6fceb28f277b924b$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6fceb28f277b924b$var$AwaitRenderStatus.error : "_data" in promise ? $6fceb28f277b924b$var$AwaitRenderStatus.success : $6fceb28f277b924b$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6fceb28f277b924b$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error && promise._error instanceof (0, $lMGip.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6fceb28f277b924b$var$neverSettledPromise;
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6fceb28f277b924b$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eZVvM.createElement($6fceb28f277b924b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6fceb28f277b924b$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6fceb28f277b924b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eZVvM.createElement($eZVvM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $6fceb28f277b924b$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eZVvM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eZVvM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6fceb28f277b924b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6fceb28f277b924b$export$e7b0ac011bb776c6) && (0, $lMGip.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $lMGip.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6fceb28f277b924b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6fceb28f277b924b$export$daf73786167a7f72(matches) {
    return $6fceb28f277b924b$var$_renderMatches(matches);
}
function $6fceb28f277b924b$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $eZVvM.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $eZVvM.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $eZVvM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6fceb28f277b924b$export$f30f7e456d254e83(routes, opts) {
    return (0, $lMGip.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6fceb28f277b924b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $lMGip.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6fceb28f277b924b$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("fUW2W", function(module, exports) {

$parcel$export(module.exports, "io", function () { return $b9691cc82f083758$export$841407ceb083bd74; });

var $fM8XA = parcelRequire("fM8XA");

var $j6lCW = parcelRequire("j6lCW");

var $hQz12 = parcelRequire("hQz12");

var $7zQLO = parcelRequire("7zQLO");
parcelRequire("5MSFm");
var $2jJk0 = parcelRequire("2jJk0");
var $2XI7J = parcelRequire("2XI7J");
var $eVvwZ = parcelRequire("eVvwZ");
var $bB1Kk = parcelRequire("bB1Kk");
/**
 * Managers cache.
 */ const $b9691cc82f083758$var$cache = {};
function $b9691cc82f083758$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $fM8XA.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $b9691cc82f083758$var$cache[id] && path in $b9691cc82f083758$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $j6lCW.Manager)(source, opts);
    else {
        if (!$b9691cc82f083758$var$cache[id]) $b9691cc82f083758$var$cache[id] = new (0, $j6lCW.Manager)(source, opts);
        io = $b9691cc82f083758$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($b9691cc82f083758$export$841407ceb083bd74, {
    Manager: $j6lCW.Manager,
    Socket: $hQz12.Socket,
    io: $b9691cc82f083758$export$841407ceb083bd74,
    connect: $b9691cc82f083758$export$841407ceb083bd74
});

});
parcelRegister("fM8XA", function(module, exports) {

$parcel$export(module.exports, "url", function () { return $b7c24a049dc16881$export$128fa18b7194ef; });
parcelRequire("5MSFm");
var $egmnf = parcelRequire("egmnf");
function $b7c24a049dc16881$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $egmnf.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("5MSFm", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return (parcelRequire("1VA9C")).Socket; });
$parcel$export(module.exports, "installTimerFunctions", function () { return (parcelRequire("1Wyoy")).installTimerFunctions; });
$parcel$export(module.exports, "parse", function () { return (parcelRequire("egmnf")).parse; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("6HCd1")).nextTick; });

var $1VA9C = parcelRequire("1VA9C");

var $d4sQT = parcelRequire("d4sQT");

var $Ax1y9 = parcelRequire("Ax1y9");

var $1Wyoy = parcelRequire("1Wyoy");

var $egmnf = parcelRequire("egmnf");

var $6HCd1 = parcelRequire("6HCd1");

var $2jJk0 = parcelRequire("2jJk0");

var $2XI7J = parcelRequire("2XI7J");

var $2XI7J = parcelRequire("2XI7J");

var $eVvwZ = parcelRequire("eVvwZ");

var $eVvwZ = parcelRequire("eVvwZ");

var $bB1Kk = parcelRequire("bB1Kk");
const $436bd701a331d5db$export$a51d6b395ff4c65a = (0, $1VA9C.Socket).protocol;

});
parcelRegister("1VA9C", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $167728c3cc772821$export$4798917dbf149b79; });

var $Ax1y9 = parcelRequire("Ax1y9");

var $1Wyoy = parcelRequire("1Wyoy");

var $6DedF = parcelRequire("6DedF");

var $egmnf = parcelRequire("egmnf");

var $fbuXh = parcelRequire("fbuXh");

var $9KvBE = parcelRequire("9KvBE");

var $6HCd1 = parcelRequire("6HCd1");
const $167728c3cc772821$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $167728c3cc772821$var$OFFLINE_EVENT_LISTENERS = [];
if ($167728c3cc772821$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $167728c3cc772821$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $167728c3cc772821$export$3874118029a0ee0d extends (0, $fbuXh.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $9KvBE.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $167728c3cc772821$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $167728c3cc772821$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $1Wyoy.byteLength)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $6HCd1.nextTick)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $167728c3cc772821$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($167728c3cc772821$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $167728c3cc772821$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $167728c3cc772821$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $6HCd1.defaultBinaryType);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $egmnf.parse)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $egmnf.parse)(opts.host).host;
        (0, $1Wyoy.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $6DedF.decode)(this.opts.query);
        if ($167728c3cc772821$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $167728c3cc772821$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $6HCd1.createCookieJar)();
        this._open();
    }
}
$167728c3cc772821$export$3874118029a0ee0d.protocol = (0, $9KvBE.protocol);
class $167728c3cc772821$export$cc521fcb1004e85c extends $167728c3cc772821$export$3874118029a0ee0d {
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $167728c3cc772821$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $167728c3cc772821$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
}
class $167728c3cc772821$export$4798917dbf149b79 extends $167728c3cc772821$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $Ax1y9.transports)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}

});
parcelRegister("Ax1y9", function(module, exports) {

$parcel$export(module.exports, "transports", function () { return $06dcfac90c14c230$export$46dec00755c1153b; });

var $2XI7J = parcelRequire("2XI7J");

var $eVvwZ = parcelRequire("eVvwZ");

var $bB1Kk = parcelRequire("bB1Kk");
const $06dcfac90c14c230$export$46dec00755c1153b = {
    websocket: (0, $eVvwZ.WS),
    webtransport: (0, $bB1Kk.WT),
    polling: (0, $2XI7J.XHR)
};

});
parcelRegister("2XI7J", function(module, exports) {

$parcel$export(module.exports, "XHR", function () { return $228351887071ab2f$export$a2d42eb087c10497; });

var $khvc5 = parcelRequire("khvc5");

var $fbuXh = parcelRequire("fbuXh");

var $1Wyoy = parcelRequire("1Wyoy");

var $6HCd1 = parcelRequire("6HCd1");

var $dfvm7 = parcelRequire("dfvm7");
function $228351887071ab2f$var$empty() {}
class $228351887071ab2f$export$c959f2344155d309 extends (0, $khvc5.Polling) {
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
}
class $228351887071ab2f$export$7fa6c5b6f8193917 extends (0, $fbuXh.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $1Wyoy.pick)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $228351887071ab2f$export$7fa6c5b6f8193917.requestsCount++;
            $228351887071ab2f$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $228351887071ab2f$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $228351887071ab2f$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $1Wyoy.installTimerFunctions)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
}
$228351887071ab2f$export$7fa6c5b6f8193917.requestsCount = 0;
$228351887071ab2f$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $228351887071ab2f$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $6HCd1.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $228351887071ab2f$var$unloadHandler, false);
    }
}
function $228351887071ab2f$var$unloadHandler() {
    for(let i in $228351887071ab2f$export$7fa6c5b6f8193917.requests)if ($228351887071ab2f$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $228351887071ab2f$export$7fa6c5b6f8193917.requests[i].abort();
}
const $228351887071ab2f$var$hasXHR2 = function() {
    const xhr = $228351887071ab2f$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $228351887071ab2f$export$a2d42eb087c10497 extends $228351887071ab2f$export$c959f2344155d309 {
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $228351887071ab2f$export$7fa6c5b6f8193917($228351887071ab2f$var$newRequest, this.uri(), opts);
    }
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $228351887071ab2f$var$hasXHR2 && !forceBase64;
    }
}
function $228351887071ab2f$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $dfvm7.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $6HCd1.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("khvc5", function(module, exports) {

$parcel$export(module.exports, "Polling", function () { return $ec3d97a7623696ba$export$265ee5eefd4c309b; });

var $d4sQT = parcelRequire("d4sQT");

var $1Wyoy = parcelRequire("1Wyoy");

var $9KvBE = parcelRequire("9KvBE");
class $ec3d97a7623696ba$export$265ee5eefd4c309b extends (0, $d4sQT.Transport) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $9KvBE.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $9KvBE.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $1Wyoy.randomString)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    constructor(){
        super(...arguments);
        this._polling = false;
    }
}

});
parcelRegister("d4sQT", function(module, exports) {

$parcel$export(module.exports, "Transport", function () { return $984207854057f90f$export$86495b081fef8e52; });
parcelRequire("9KvBE");
var $35Pvm = parcelRequire("35Pvm");

var $fbuXh = parcelRequire("fbuXh");

var $1Wyoy = parcelRequire("1Wyoy");

var $6DedF = parcelRequire("6DedF");
class $984207854057f90f$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $984207854057f90f$export$86495b081fef8e52 extends (0, $fbuXh.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $984207854057f90f$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $35Pvm.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $6DedF.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $1Wyoy.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
}

});
parcelRegister("9KvBE", function(module, exports) {

$parcel$export(module.exports, "encodePayload", function () { return $7190ed43dfcac9b8$export$144d64fe58dad441; });
$parcel$export(module.exports, "decodePayload", function () { return $7190ed43dfcac9b8$export$d10cc2e7f7566a2d; });
$parcel$export(module.exports, "createPacketEncoderStream", function () { return $7190ed43dfcac9b8$export$a525fb718e9c623a; });
$parcel$export(module.exports, "createPacketDecoderStream", function () { return $7190ed43dfcac9b8$export$552d20aac7500f47; });
$parcel$export(module.exports, "protocol", function () { return $7190ed43dfcac9b8$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "encodePacket", function () { return (parcelRequire("eB3mK")).encodePacket; });
$parcel$export(module.exports, "decodePacket", function () { return (parcelRequire("35Pvm")).decodePacket; });

var $eB3mK = parcelRequire("eB3mK");

var $35Pvm = parcelRequire("35Pvm");

var $5uu6L = parcelRequire("5uu6L");
const $7190ed43dfcac9b8$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $7190ed43dfcac9b8$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $eB3mK.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($7190ed43dfcac9b8$var$SEPARATOR));
        });
    });
};
const $7190ed43dfcac9b8$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($7190ed43dfcac9b8$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $35Pvm.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $7190ed43dfcac9b8$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $eB3mK.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $7190ed43dfcac9b8$var$TEXT_DECODER;
function $7190ed43dfcac9b8$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $7190ed43dfcac9b8$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $7190ed43dfcac9b8$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$7190ed43dfcac9b8$var$TEXT_DECODER) $7190ed43dfcac9b8$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 1) break;
                    const header = $7190ed43dfcac9b8$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 2) break;
                    const headerArray = $7190ed43dfcac9b8$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < 8) break;
                    const headerArray = $7190ed43dfcac9b8$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $5uu6L.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($7190ed43dfcac9b8$var$totalLength(chunks) < expectedLength) break;
                    const data = $7190ed43dfcac9b8$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $35Pvm.decodePacket)(isBinary ? data : $7190ed43dfcac9b8$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $5uu6L.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $7190ed43dfcac9b8$export$a51d6b395ff4c65a = 4;

});
parcelRegister("eB3mK", function(module, exports) {

$parcel$export(module.exports, "encodePacket", function () { return $aa0721c76827b58b$export$57852049361a8e62; });
$parcel$export(module.exports, "encodePacketToBinary", function () { return $aa0721c76827b58b$export$ec0c9b9013ee0ef5; });

var $5uu6L = parcelRequire("5uu6L");
const $aa0721c76827b58b$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $aa0721c76827b58b$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $aa0721c76827b58b$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $aa0721c76827b58b$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($aa0721c76827b58b$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $aa0721c76827b58b$var$encodeBlobAsBase64(data, callback);
    } else if ($aa0721c76827b58b$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $aa0721c76827b58b$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $aa0721c76827b58b$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $5uu6L.PACKET_TYPES)[type] + (data || ""));
};
const $aa0721c76827b58b$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $aa0721c76827b58b$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $aa0721c76827b58b$var$TEXT_ENCODER;
function $aa0721c76827b58b$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($aa0721c76827b58b$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($aa0721c76827b58b$var$toArray).then(callback);
    else if ($aa0721c76827b58b$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $aa0721c76827b58b$var$isView(packet.data))) return callback($aa0721c76827b58b$var$toArray(packet.data));
    $aa0721c76827b58b$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$aa0721c76827b58b$var$TEXT_ENCODER) $aa0721c76827b58b$var$TEXT_ENCODER = new TextEncoder();
        callback($aa0721c76827b58b$var$TEXT_ENCODER.encode(encoded));
    });
}

});
parcelRegister("5uu6L", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", function () { return $3ff71bed8ee045e7$export$c169aefb7330cccb; });
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", function () { return $3ff71bed8ee045e7$export$47791e8004edd485; });
$parcel$export(module.exports, "ERROR_PACKET", function () { return $3ff71bed8ee045e7$export$c718b5840781f8a7; });
const $3ff71bed8ee045e7$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$3ff71bed8ee045e7$export$c169aefb7330cccb["open"] = "0";
$3ff71bed8ee045e7$export$c169aefb7330cccb["close"] = "1";
$3ff71bed8ee045e7$export$c169aefb7330cccb["ping"] = "2";
$3ff71bed8ee045e7$export$c169aefb7330cccb["pong"] = "3";
$3ff71bed8ee045e7$export$c169aefb7330cccb["message"] = "4";
$3ff71bed8ee045e7$export$c169aefb7330cccb["upgrade"] = "5";
$3ff71bed8ee045e7$export$c169aefb7330cccb["noop"] = "6";
const $3ff71bed8ee045e7$export$47791e8004edd485 = Object.create(null);
Object.keys($3ff71bed8ee045e7$export$c169aefb7330cccb).forEach((key)=>{
    $3ff71bed8ee045e7$export$47791e8004edd485[$3ff71bed8ee045e7$export$c169aefb7330cccb[key]] = key;
});
const $3ff71bed8ee045e7$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("35Pvm", function(module, exports) {

$parcel$export(module.exports, "decodePacket", function () { return $2409ca8159bcb19c$export$4647901878f33f31; });

var $5uu6L = parcelRequire("5uu6L");

var $4efFz = parcelRequire("4efFz");
const $2409ca8159bcb19c$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $2409ca8159bcb19c$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $2409ca8159bcb19c$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $2409ca8159bcb19c$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $5uu6L.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $5uu6L.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $5uu6L.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $5uu6L.PACKET_TYPES_REVERSE)[type]
    };
};
const $2409ca8159bcb19c$var$decodeBase64Packet = (data, binaryType)=>{
    if ($2409ca8159bcb19c$var$withNativeArrayBuffer) {
        const decoded = (0, $4efFz.decode)(data);
        return $2409ca8159bcb19c$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $2409ca8159bcb19c$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};

});
parcelRegister("4efFz", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $31449fde0ba50558$export$2f872c0f2117be69; });
// imported from https://github.com/socketio/base64-arraybuffer
const $31449fde0ba50558$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
const $31449fde0ba50558$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(let i = 0; i < $31449fde0ba50558$var$chars.length; i++)$31449fde0ba50558$var$lookup[$31449fde0ba50558$var$chars.charCodeAt(i)] = i;
const $31449fde0ba50558$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $31449fde0ba50558$var$chars[bytes[i] >> 2];
        base64 += $31449fde0ba50558$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $31449fde0ba50558$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $31449fde0ba50558$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $31449fde0ba50558$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === "=") {
        bufferLength--;
        if (base64[base64.length - 2] === "=") bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i)];
        encoded2 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $31449fde0ba50558$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("fbuXh", function(module, exports) {

$parcel$export(module.exports, "Emitter", function () { return $b0dfe52829d5f01f$export$4293555f241ae35a; });
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $b0dfe52829d5f01f$export$4293555f241ae35a(obj) {
    if (obj) return $b0dfe52829d5f01f$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $b0dfe52829d5f01f$var$mixin(obj) {
    for(var key in $b0dfe52829d5f01f$export$4293555f241ae35a.prototype)obj[key] = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.on = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.off = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeListener = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeAllListeners = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks["$" + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks["$" + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks["$" + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emitReserved = $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $b0dfe52829d5f01f$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("1Wyoy", function(module, exports) {

$parcel$export(module.exports, "pick", function () { return $16a5e3576046ec1f$export$357523c63a2253b9; });
$parcel$export(module.exports, "installTimerFunctions", function () { return $16a5e3576046ec1f$export$2f67576668b97183; });
$parcel$export(module.exports, "byteLength", function () { return $16a5e3576046ec1f$export$a48f0734ac7c2329; });
$parcel$export(module.exports, "randomString", function () { return $16a5e3576046ec1f$export$7fa8378418b4411e; });

var $6HCd1 = parcelRequire("6HCd1");
function $16a5e3576046ec1f$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $16a5e3576046ec1f$var$NATIVE_SET_TIMEOUT = (0, $6HCd1.globalThisShim).setTimeout;
const $16a5e3576046ec1f$var$NATIVE_CLEAR_TIMEOUT = (0, $6HCd1.globalThisShim).clearTimeout;
function $16a5e3576046ec1f$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $16a5e3576046ec1f$var$NATIVE_SET_TIMEOUT.bind((0, $6HCd1.globalThisShim));
        obj.clearTimeoutFn = $16a5e3576046ec1f$var$NATIVE_CLEAR_TIMEOUT.bind((0, $6HCd1.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $6HCd1.globalThisShim).setTimeout.bind((0, $6HCd1.globalThisShim));
        obj.clearTimeoutFn = (0, $6HCd1.globalThisShim).clearTimeout.bind((0, $6HCd1.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $16a5e3576046ec1f$var$BASE64_OVERHEAD = 1.33;
function $16a5e3576046ec1f$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $16a5e3576046ec1f$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $16a5e3576046ec1f$var$BASE64_OVERHEAD);
}
function $16a5e3576046ec1f$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $16a5e3576046ec1f$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}

});
parcelRegister("6HCd1", function(module, exports) {

$parcel$export(module.exports, "nextTick", function () { return $4e1465c4d954c142$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "globalThisShim", function () { return $4e1465c4d954c142$export$394f9358f6231289; });
$parcel$export(module.exports, "defaultBinaryType", function () { return $4e1465c4d954c142$export$790dcbc41e2d75d5; });
$parcel$export(module.exports, "createCookieJar", function () { return $4e1465c4d954c142$export$19413efcf2fac759; });
const $4e1465c4d954c142$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $4e1465c4d954c142$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $4e1465c4d954c142$export$790dcbc41e2d75d5 = "arraybuffer";
function $4e1465c4d954c142$export$19413efcf2fac759() {}

});


parcelRegister("6DedF", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $4d416a4c00ba2341$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $4d416a4c00ba2341$export$2f872c0f2117be69; });
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $4d416a4c00ba2341$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $4d416a4c00ba2341$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});



parcelRegister("dfvm7", function(module, exports) {

$parcel$export(module.exports, "hasCORS", function () { return $9a54ffa9931c515f$export$5235bbd4a1ef06e; });
// imported from https://github.com/component/has-cors
let $9a54ffa9931c515f$var$value = false;
try {
    $9a54ffa9931c515f$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $9a54ffa9931c515f$export$5235bbd4a1ef06e = $9a54ffa9931c515f$var$value;

});


parcelRegister("eVvwZ", function(module, exports) {

$parcel$export(module.exports, "WS", function () { return $added8f687f296c6$export$911baa0677ac404c; });

var $d4sQT = parcelRequire("d4sQT");

var $1Wyoy = parcelRequire("1Wyoy");
parcelRequire("9KvBE");
var $eB3mK = parcelRequire("eB3mK");

var $6HCd1 = parcelRequire("6HCd1");
// detect ReactNative environment
const $added8f687f296c6$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $added8f687f296c6$export$570bf71d2367e261 extends (0, $d4sQT.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $added8f687f296c6$var$isReactNative ? {} : (0, $1Wyoy.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eB3mK.encodePacket)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $6HCd1.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $1Wyoy.randomString)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $added8f687f296c6$var$WebSocketCtor = (0, $6HCd1.globalThisShim).WebSocket || (0, $6HCd1.globalThisShim).MozWebSocket;
class $added8f687f296c6$export$911baa0677ac404c extends $added8f687f296c6$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$added8f687f296c6$var$isReactNative ? protocols ? new $added8f687f296c6$var$WebSocketCtor(uri, protocols) : new $added8f687f296c6$var$WebSocketCtor(uri) : new $added8f687f296c6$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

});

parcelRegister("bB1Kk", function(module, exports) {

$parcel$export(module.exports, "WT", function () { return $8714812b5ec52987$export$961c930859384407; });

var $d4sQT = parcelRequire("d4sQT");

var $6HCd1 = parcelRequire("6HCd1");

var $9KvBE = parcelRequire("9KvBE");
class $8714812b5ec52987$export$961c930859384407 extends (0, $d4sQT.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $9KvBE.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $9KvBE.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $6HCd1.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}

});


parcelRegister("egmnf", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $a623ea4ca3a2c731$export$98e6a39c04603d36; });
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $a623ea4ca3a2c731$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $a623ea4ca3a2c731$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $a623ea4ca3a2c731$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $a623ea4ca3a2c731$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$a623ea4ca3a2c731$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $a623ea4ca3a2c731$var$pathNames(uri, uri["path"]);
    uri.queryKey = $a623ea4ca3a2c731$var$queryKey(uri, uri["query"]);
    return uri;
}
function $a623ea4ca3a2c731$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $a623ea4ca3a2c731$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});


parcelRegister("2jJk0", function(module, exports) {

var $khvc5 = parcelRequire("khvc5");
class $1b00830eb722d560$export$1e7deca84b429035 extends (0, $khvc5.Polling) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}

});



parcelRegister("j6lCW", function(module, exports) {

$parcel$export(module.exports, "Manager", function () { return $de7f5a8fa909d1f0$export$d0d38e7dec7a1a61; });
parcelRequire("5MSFm");
var $1Wyoy = parcelRequire("1Wyoy");
var $6HCd1 = parcelRequire("6HCd1");
var $1VA9C = parcelRequire("1VA9C");

var $hQz12 = parcelRequire("hQz12");

var $7zQLO = parcelRequire("7zQLO");

var $fVTp8 = parcelRequire("fVTp8");

var $3YqOc = parcelRequire("3YqOc");

var $fbuXh = parcelRequire("fbuXh");
class $de7f5a8fa909d1f0$export$d0d38e7dec7a1a61 extends (0, $fbuXh.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $1VA9C.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $fVTp8.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $fVTp8.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $fVTp8.on)(socket, "ping", this.onping.bind(this)), (0, $fVTp8.on)(socket, "data", this.ondata.bind(this)), (0, $fVTp8.on)(socket, "error", this.onerror.bind(this)), (0, $fVTp8.on)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $fVTp8.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $6HCd1.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $hQz12.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $1Wyoy.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3YqOc.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $7zQLO;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}

});
parcelRegister("hQz12", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $cfe274603fb87f04$export$4798917dbf149b79; });

var $7zQLO = parcelRequire("7zQLO");

var $fVTp8 = parcelRequire("fVTp8");

var $fbuXh = parcelRequire("fbuXh");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $cfe274603fb87f04$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $cfe274603fb87f04$export$4798917dbf149b79 extends (0, $fbuXh.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $fVTp8.on)(io, "open", this.onopen.bind(this)),
            (0, $fVTp8.on)(io, "packet", this.onpacket.bind(this)),
            (0, $fVTp8.on)(io, "error", this.onerror.bind(this)),
            (0, $fVTp8.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($cfe274603fb87f04$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $7zQLO.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $7zQLO.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $7zQLO.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $7zQLO.PacketType).EVENT:
            case (0, $7zQLO.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $7zQLO.PacketType).ACK:
            case (0, $7zQLO.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $7zQLO.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $7zQLO.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $7zQLO.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $7zQLO.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}

});
parcelRegister("7zQLO", function(module, exports) {

$parcel$export(module.exports, "protocol", function () { return $5844bc5b363a789e$export$a51d6b395ff4c65a; });
$parcel$export(module.exports, "PacketType", function () { return $5844bc5b363a789e$export$84d4095e16c6fc19; });
$parcel$export(module.exports, "Encoder", function () { return $5844bc5b363a789e$export$a50aceb0e02a00aa; });
$parcel$export(module.exports, "Decoder", function () { return $5844bc5b363a789e$export$f9de6ca0bc043724; });

var $fbuXh = parcelRequire("fbuXh");

var $f2OZx = parcelRequire("f2OZx");

var $3g4Gz = parcelRequire("3g4Gz");
/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $5844bc5b363a789e$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $5844bc5b363a789e$export$a51d6b395ff4c65a = 5;
var $5844bc5b363a789e$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($5844bc5b363a789e$export$84d4095e16c6fc19 || ($5844bc5b363a789e$export$84d4095e16c6fc19 = {}));
class $5844bc5b363a789e$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT || obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.ACK) {
            if ((0, $3g4Gz.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT ? $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT : $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $f2OZx.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $5844bc5b363a789e$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $5844bc5b363a789e$export$f9de6ca0bc043724 extends (0, $fbuXh.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT : $5844bc5b363a789e$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $5844bc5b363a789e$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $3g4Gz.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($5844bc5b363a789e$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($5844bc5b363a789e$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $5844bc5b363a789e$export$84d4095e16c6fc19.CONNECT:
                return $5844bc5b363a789e$var$isObject(payload);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $5844bc5b363a789e$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $5844bc5b363a789e$var$isObject(payload);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.EVENT:
            case $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $5844bc5b363a789e$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $5844bc5b363a789e$export$84d4095e16c6fc19.ACK:
            case $5844bc5b363a789e$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $5844bc5b363a789e$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $f2OZx.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}

});
parcelRegister("f2OZx", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", function () { return $af3e98c77f2a1d1e$export$ac2edb9eb7af56f6; });
$parcel$export(module.exports, "reconstructPacket", function () { return $af3e98c77f2a1d1e$export$a00da3b1ec037a04; });

var $3g4Gz = parcelRequire("3g4Gz");
function $af3e98c77f2a1d1e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $af3e98c77f2a1d1e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $af3e98c77f2a1d1e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $3g4Gz.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $af3e98c77f2a1d1e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $af3e98c77f2a1d1e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $af3e98c77f2a1d1e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $af3e98c77f2a1d1e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $af3e98c77f2a1d1e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $af3e98c77f2a1d1e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $af3e98c77f2a1d1e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("3g4Gz", function(module, exports) {

$parcel$export(module.exports, "isBinary", function () { return $25f6802f9284f641$export$37488ff1135b1696; });
$parcel$export(module.exports, "hasBinary", function () { return $25f6802f9284f641$export$5234c529abdb5610; });
const $25f6802f9284f641$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $25f6802f9284f641$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $25f6802f9284f641$var$toString = Object.prototype.toString;
const $25f6802f9284f641$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $25f6802f9284f641$var$toString.call(Blob) === "[object BlobConstructor]";
const $25f6802f9284f641$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $25f6802f9284f641$var$toString.call(File) === "[object FileConstructor]";
function $25f6802f9284f641$export$37488ff1135b1696(obj) {
    return $25f6802f9284f641$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $25f6802f9284f641$var$isView(obj)) || $25f6802f9284f641$var$withNativeBlob && obj instanceof Blob || $25f6802f9284f641$var$withNativeFile && obj instanceof File;
}
function $25f6802f9284f641$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($25f6802f9284f641$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($25f6802f9284f641$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $25f6802f9284f641$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $25f6802f9284f641$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("fVTp8", function(module, exports) {

$parcel$export(module.exports, "on", function () { return $b9972807fd510e38$export$af631764ddc44097; });
function $b9972807fd510e38$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("3YqOc", function(module, exports) {

$parcel$export(module.exports, "Backoff", function () { return $2e4bc5530d48d8c1$export$2d38012449449c89; });
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $2e4bc5530d48d8c1$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $2e4bc5530d48d8c1$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $2e4bc5530d48d8c1$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $2e4bc5530d48d8c1$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $2e4bc5530d48d8c1$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $2e4bc5530d48d8c1$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});



parcelRegister("1BSKa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $350594c7996bc1f4$export$2e2bcd8739ae039; });
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");

var $k9qks = parcelRequire("k9qks");
const $350594c7996bc1f4$var$postLog = (data = {
    level: "debug",
    message: "",
    data: {}
})=>{
    if (!(0, $k9qks.isInPlayer)) return;
    (0, $a7H8f.default).post("http://localhost:134/log", data, {
        headers: {
            "Content-Type": "application/json"
        }
    }).catch(console.log);
};
const $350594c7996bc1f4$var$Logger = {
    log: (message, data)=>$350594c7996bc1f4$var$postLog({
            level: "info",
            message: message,
            data: data
        }),
    info: (message, data)=>$350594c7996bc1f4$var$postLog({
            level: "info",
            message: message,
            data: data
        }),
    warn: (message, data)=>$350594c7996bc1f4$var$postLog({
            level: "warn",
            message: message,
            data: data
        }),
    debug: (message, data)=>$350594c7996bc1f4$var$postLog({
            level: "debug",
            message: message,
            data: data
        }),
    error: (message, data)=>$350594c7996bc1f4$var$postLog({
            level: "error",
            message: message,
            data: data
        })
};
var $350594c7996bc1f4$export$2e2bcd8739ae039 = $350594c7996bc1f4$var$Logger;

});
parcelRegister("WCAkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("a7H8f")).default; });

var $a7H8f = parcelRequire("a7H8f");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $0b035914f4106136$export$1c00760e9e5a4e95, AxiosError: $0b035914f4106136$export$c1fbed17c2f6a328, CanceledError: $0b035914f4106136$export$1ab0c6b20d94fa14, isCancel: $0b035914f4106136$export$3b22524397b493c6, CancelToken: $0b035914f4106136$export$fd08e3cb425f0d61, VERSION: $0b035914f4106136$export$a4ad2735b021c132, all: $0b035914f4106136$export$84bf76cd7afc7469, Cancel: $0b035914f4106136$export$848c9b7ead0df967, isAxiosError: $0b035914f4106136$export$fbafdbe06a5b5a9a, spread: $0b035914f4106136$export$3ae0fd4797ed47c8, toFormData: $0b035914f4106136$export$10ae0d317ea97f8b, AxiosHeaders: $0b035914f4106136$export$4e7d6ff0f3e6520, HttpStatusCode: $0b035914f4106136$export$a972f69c851492b3, formToJSON: $0b035914f4106136$export$86d7c59254d6a2c9, getAdapter: $0b035914f4106136$export$17ddc20a97d669e2, mergeConfig: $0b035914f4106136$export$7ec1ebcfa9d8bd6a } = (0, $a7H8f.default);

});
parcelRegister("a7H8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ec03f3f42b7c3c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $g57dZ = parcelRequire("g57dZ");

var $6TkId = parcelRequire("6TkId");

var $8FHSN = parcelRequire("8FHSN");

var $kXg7s = parcelRequire("kXg7s");

var $kKGuv = parcelRequire("kKGuv");

var $lMpcA = parcelRequire("lMpcA");

var $5zLKY = parcelRequire("5zLKY");

var $kBQOk = parcelRequire("kBQOk");

var $ie3yz = parcelRequire("ie3yz");

var $DThbK = parcelRequire("DThbK");

var $9NE6H = parcelRequire("9NE6H");

var $dyoH1 = parcelRequire("dyoH1");

var $c7TGZ = parcelRequire("c7TGZ");

var $hdRGz = parcelRequire("hdRGz");

var $u7vyD = parcelRequire("u7vyD");

var $fTG9u = parcelRequire("fTG9u");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $75ec03f3f42b7c3c$var$createInstance(defaultConfig) {
    const context = new (0, $6TkId.default)(defaultConfig);
    const instance = (0, $g57dZ.default)((0, $6TkId.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $3v50U.default).extend(instance, (0, $6TkId.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $3v50U.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $75ec03f3f42b7c3c$var$createInstance((0, $8FHSN.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $75ec03f3f42b7c3c$var$axios = $75ec03f3f42b7c3c$var$createInstance((0, $kXg7s.default));
// Expose Axios class to allow class inheritance
$75ec03f3f42b7c3c$var$axios.Axios = (0, $6TkId.default);
// Expose Cancel & CancelToken
$75ec03f3f42b7c3c$var$axios.CanceledError = (0, $lMpcA.default);
$75ec03f3f42b7c3c$var$axios.CancelToken = (0, $5zLKY.default);
$75ec03f3f42b7c3c$var$axios.isCancel = (0, $kBQOk.default);
$75ec03f3f42b7c3c$var$axios.VERSION = (0, $ie3yz.VERSION);
$75ec03f3f42b7c3c$var$axios.toFormData = (0, $DThbK.default);
// Expose AxiosError class
$75ec03f3f42b7c3c$var$axios.AxiosError = (0, $9NE6H.default);
// alias for CanceledError for backward compatibility
$75ec03f3f42b7c3c$var$axios.Cancel = $75ec03f3f42b7c3c$var$axios.CanceledError;
// Expose all/spread
$75ec03f3f42b7c3c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$75ec03f3f42b7c3c$var$axios.spread = (0, $dyoH1.default);
// Expose isAxiosError
$75ec03f3f42b7c3c$var$axios.isAxiosError = (0, $c7TGZ.default);
// Expose mergeConfig
$75ec03f3f42b7c3c$var$axios.mergeConfig = (0, $8FHSN.default);
$75ec03f3f42b7c3c$var$axios.AxiosHeaders = (0, $hdRGz.default);
$75ec03f3f42b7c3c$var$axios.formToJSON = (thing)=>(0, $kKGuv.default)((0, $3v50U.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$75ec03f3f42b7c3c$var$axios.getAdapter = (0, $u7vyD.default).getAdapter;
$75ec03f3f42b7c3c$var$axios.HttpStatusCode = (0, $fTG9u.default);
$75ec03f3f42b7c3c$var$axios.default = $75ec03f3f42b7c3c$var$axios;
var // this module should only have a default export
$75ec03f3f42b7c3c$export$2e2bcd8739ae039 = $75ec03f3f42b7c3c$var$axios;

});
parcelRegister("3v50U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c827f505a43dbf$export$2e2bcd8739ae039; });

var $g57dZ = parcelRequire("g57dZ");

var $lUPho = parcelRequire("lUPho");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $28c827f505a43dbf$var$toString } = Object.prototype;
const { getPrototypeOf: $28c827f505a43dbf$var$getPrototypeOf } = Object;
const $28c827f505a43dbf$var$kindOf = ((cache)=>(thing)=>{
        const str = $28c827f505a43dbf$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $28c827f505a43dbf$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$28c827f505a43dbf$var$kindOf(thing) === type;
};
const $28c827f505a43dbf$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $28c827f505a43dbf$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $28c827f505a43dbf$var$isUndefined = $28c827f505a43dbf$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $28c827f505a43dbf$var$isBuffer(val) {
    return val !== null && !$28c827f505a43dbf$var$isUndefined(val) && val.constructor !== null && !$28c827f505a43dbf$var$isUndefined(val.constructor) && $28c827f505a43dbf$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $28c827f505a43dbf$var$isArrayBuffer = $28c827f505a43dbf$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $28c827f505a43dbf$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $28c827f505a43dbf$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $28c827f505a43dbf$var$isString = $28c827f505a43dbf$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $28c827f505a43dbf$var$isFunction = $28c827f505a43dbf$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $28c827f505a43dbf$var$isNumber = $28c827f505a43dbf$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $28c827f505a43dbf$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $28c827f505a43dbf$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $28c827f505a43dbf$var$isPlainObject = (val)=>{
    if ($28c827f505a43dbf$var$kindOf(val) !== "object") return false;
    const prototype = $28c827f505a43dbf$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $28c827f505a43dbf$var$isDate = $28c827f505a43dbf$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $28c827f505a43dbf$var$isFile = $28c827f505a43dbf$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $28c827f505a43dbf$var$isBlob = $28c827f505a43dbf$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $28c827f505a43dbf$var$isFileList = $28c827f505a43dbf$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $28c827f505a43dbf$var$isStream = (val)=>$28c827f505a43dbf$var$isObject(val) && $28c827f505a43dbf$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $28c827f505a43dbf$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $28c827f505a43dbf$var$isFunction(thing.append) && ((kind = $28c827f505a43dbf$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $28c827f505a43dbf$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $28c827f505a43dbf$var$isURLSearchParams = $28c827f505a43dbf$var$kindOfTest("URLSearchParams");
const [$28c827f505a43dbf$var$isReadableStream, $28c827f505a43dbf$var$isRequest, $28c827f505a43dbf$var$isResponse, $28c827f505a43dbf$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($28c827f505a43dbf$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $28c827f505a43dbf$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $28c827f505a43dbf$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($28c827f505a43dbf$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $28c827f505a43dbf$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $28c827f505a43dbf$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $28c827f505a43dbf$var$isContextDefined = (context)=>!$28c827f505a43dbf$var$isUndefined(context) && context !== $28c827f505a43dbf$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $28c827f505a43dbf$var$merge() {
    const { caseless: caseless } = $28c827f505a43dbf$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $28c827f505a43dbf$var$findKey(result, key) || key;
        if ($28c827f505a43dbf$var$isPlainObject(result[targetKey]) && $28c827f505a43dbf$var$isPlainObject(val)) result[targetKey] = $28c827f505a43dbf$var$merge(result[targetKey], val);
        else if ($28c827f505a43dbf$var$isPlainObject(val)) result[targetKey] = $28c827f505a43dbf$var$merge({}, val);
        else if ($28c827f505a43dbf$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $28c827f505a43dbf$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $28c827f505a43dbf$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $28c827f505a43dbf$var$forEach(b, (val, key)=>{
        if (thisArg && $28c827f505a43dbf$var$isFunction(val)) a[key] = (0, $g57dZ.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $28c827f505a43dbf$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $28c827f505a43dbf$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $28c827f505a43dbf$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $28c827f505a43dbf$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $28c827f505a43dbf$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $28c827f505a43dbf$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($28c827f505a43dbf$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$28c827f505a43dbf$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $28c827f505a43dbf$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $28c827f505a43dbf$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $28c827f505a43dbf$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $28c827f505a43dbf$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $28c827f505a43dbf$var$isHTMLForm = $28c827f505a43dbf$var$kindOfTest("HTMLFormElement");
const $28c827f505a43dbf$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $28c827f505a43dbf$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $28c827f505a43dbf$var$isRegExp = $28c827f505a43dbf$var$kindOfTest("RegExp");
const $28c827f505a43dbf$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $28c827f505a43dbf$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $28c827f505a43dbf$var$freezeMethods = (obj)=>{
    $28c827f505a43dbf$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($28c827f505a43dbf$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$28c827f505a43dbf$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $28c827f505a43dbf$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $28c827f505a43dbf$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $28c827f505a43dbf$var$noop = ()=>{};
const $28c827f505a43dbf$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $28c827f505a43dbf$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $28c827f505a43dbf$var$DIGIT = "0123456789";
const $28c827f505a43dbf$var$ALPHABET = {
    DIGIT: $28c827f505a43dbf$var$DIGIT,
    ALPHA: $28c827f505a43dbf$var$ALPHA,
    ALPHA_DIGIT: $28c827f505a43dbf$var$ALPHA + $28c827f505a43dbf$var$ALPHA.toUpperCase() + $28c827f505a43dbf$var$DIGIT
};
const $28c827f505a43dbf$var$generateString = (size = 16, alphabet = $28c827f505a43dbf$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $28c827f505a43dbf$var$isSpecCompliantForm(thing) {
    return !!(thing && $28c827f505a43dbf$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $28c827f505a43dbf$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($28c827f505a43dbf$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $28c827f505a43dbf$var$isArray(source) ? [] : {};
                $28c827f505a43dbf$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$28c827f505a43dbf$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $28c827f505a43dbf$var$isAsyncFn = $28c827f505a43dbf$var$kindOfTest("AsyncFunction");
const $28c827f505a43dbf$var$isThenable = (thing)=>thing && ($28c827f505a43dbf$var$isObject(thing) || $28c827f505a43dbf$var$isFunction(thing)) && $28c827f505a43dbf$var$isFunction(thing.then) && $28c827f505a43dbf$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $28c827f505a43dbf$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $28c827f505a43dbf$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $28c827f505a43dbf$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $28c827f505a43dbf$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $28c827f505a43dbf$var$isFunction($28c827f505a43dbf$var$_global.postMessage));
const $28c827f505a43dbf$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($28c827f505a43dbf$var$_global) : typeof $lUPho !== "undefined" && $lUPho.nextTick || $28c827f505a43dbf$var$_setImmediate;
var // *********************
$28c827f505a43dbf$export$2e2bcd8739ae039 = {
    isArray: $28c827f505a43dbf$var$isArray,
    isArrayBuffer: $28c827f505a43dbf$var$isArrayBuffer,
    isBuffer: $28c827f505a43dbf$var$isBuffer,
    isFormData: $28c827f505a43dbf$var$isFormData,
    isArrayBufferView: $28c827f505a43dbf$var$isArrayBufferView,
    isString: $28c827f505a43dbf$var$isString,
    isNumber: $28c827f505a43dbf$var$isNumber,
    isBoolean: $28c827f505a43dbf$var$isBoolean,
    isObject: $28c827f505a43dbf$var$isObject,
    isPlainObject: $28c827f505a43dbf$var$isPlainObject,
    isReadableStream: $28c827f505a43dbf$var$isReadableStream,
    isRequest: $28c827f505a43dbf$var$isRequest,
    isResponse: $28c827f505a43dbf$var$isResponse,
    isHeaders: $28c827f505a43dbf$var$isHeaders,
    isUndefined: $28c827f505a43dbf$var$isUndefined,
    isDate: $28c827f505a43dbf$var$isDate,
    isFile: $28c827f505a43dbf$var$isFile,
    isBlob: $28c827f505a43dbf$var$isBlob,
    isRegExp: $28c827f505a43dbf$var$isRegExp,
    isFunction: $28c827f505a43dbf$var$isFunction,
    isStream: $28c827f505a43dbf$var$isStream,
    isURLSearchParams: $28c827f505a43dbf$var$isURLSearchParams,
    isTypedArray: $28c827f505a43dbf$var$isTypedArray,
    isFileList: $28c827f505a43dbf$var$isFileList,
    forEach: $28c827f505a43dbf$var$forEach,
    merge: $28c827f505a43dbf$var$merge,
    extend: $28c827f505a43dbf$var$extend,
    trim: $28c827f505a43dbf$var$trim,
    stripBOM: $28c827f505a43dbf$var$stripBOM,
    inherits: $28c827f505a43dbf$var$inherits,
    toFlatObject: $28c827f505a43dbf$var$toFlatObject,
    kindOf: $28c827f505a43dbf$var$kindOf,
    kindOfTest: $28c827f505a43dbf$var$kindOfTest,
    endsWith: $28c827f505a43dbf$var$endsWith,
    toArray: $28c827f505a43dbf$var$toArray,
    forEachEntry: $28c827f505a43dbf$var$forEachEntry,
    matchAll: $28c827f505a43dbf$var$matchAll,
    isHTMLForm: $28c827f505a43dbf$var$isHTMLForm,
    hasOwnProperty: $28c827f505a43dbf$var$hasOwnProperty,
    hasOwnProp: $28c827f505a43dbf$var$hasOwnProperty,
    reduceDescriptors: $28c827f505a43dbf$var$reduceDescriptors,
    freezeMethods: $28c827f505a43dbf$var$freezeMethods,
    toObjectSet: $28c827f505a43dbf$var$toObjectSet,
    toCamelCase: $28c827f505a43dbf$var$toCamelCase,
    noop: $28c827f505a43dbf$var$noop,
    toFiniteNumber: $28c827f505a43dbf$var$toFiniteNumber,
    findKey: $28c827f505a43dbf$var$findKey,
    global: $28c827f505a43dbf$var$_global,
    isContextDefined: $28c827f505a43dbf$var$isContextDefined,
    ALPHABET: $28c827f505a43dbf$var$ALPHABET,
    generateString: $28c827f505a43dbf$var$generateString,
    isSpecCompliantForm: $28c827f505a43dbf$var$isSpecCompliantForm,
    toJSONObject: $28c827f505a43dbf$var$toJSONObject,
    isAsyncFn: $28c827f505a43dbf$var$isAsyncFn,
    isThenable: $28c827f505a43dbf$var$isThenable,
    setImmediate: $28c827f505a43dbf$var$_setImmediate,
    asap: $28c827f505a43dbf$var$asap
};

});
parcelRegister("g57dZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb52b79c31554adc$export$2e2bcd8739ae039; });
"use strict";
function $bb52b79c31554adc$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("6TkId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5047f21c521b531d$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $flOXD = parcelRequire("flOXD");

var $3oXSf = parcelRequire("3oXSf");

var $9aMTC = parcelRequire("9aMTC");

var $8FHSN = parcelRequire("8FHSN");

var $kSWF8 = parcelRequire("kSWF8");

var $2wmIW = parcelRequire("2wmIW");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
const $5047f21c521b531d$var$validators = (0, $2wmIW.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $5047f21c521b531d$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $8FHSN.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2wmIW.default).assertOptions(transitional, {
            silentJSONParsing: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean),
            forcedJSONParsing: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean),
            clarifyTimeoutError: $5047f21c521b531d$var$validators.transitional($5047f21c521b531d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $3v50U.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2wmIW.default).assertOptions(paramsSerializer, {
                encode: $5047f21c521b531d$var$validators.function,
                serialize: $5047f21c521b531d$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $3v50U.default).merge(headers.common, headers[config.method]);
        headers && (0, $3v50U.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $hdRGz.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9aMTC.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9aMTC.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $8FHSN.default)(this.defaults, config);
        const fullPath = (0, $kSWF8.default)(config.baseURL, config.url);
        return (0, $flOXD.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $3oXSf.default)(),
            response: new (0, $3oXSf.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $3v50U.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $5047f21c521b531d$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $8FHSN.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $3v50U.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $8FHSN.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $5047f21c521b531d$var$Axios.prototype[method] = generateHTTPMethod();
    $5047f21c521b531d$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $5047f21c521b531d$export$2e2bcd8739ae039 = $5047f21c521b531d$var$Axios;

});
parcelRegister("flOXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2d058ef59ec0625$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $kivv9 = parcelRequire("kivv9");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $b2d058ef59ec0625$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $b2d058ef59ec0625$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $b2d058ef59ec0625$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $3v50U.default).isURLSearchParams(params) ? params.toString() : new (0, $kivv9.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("kivv9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6deca3f04bff0a$export$2e2bcd8739ae039; });

var $DThbK = parcelRequire("DThbK");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $ec6deca3f04bff0a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $ec6deca3f04bff0a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $DThbK.default)(params, this, options);
}
const $ec6deca3f04bff0a$var$prototype = $ec6deca3f04bff0a$var$AxiosURLSearchParams.prototype;
$ec6deca3f04bff0a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$ec6deca3f04bff0a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $ec6deca3f04bff0a$var$encode);
    } : $ec6deca3f04bff0a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $ec6deca3f04bff0a$export$2e2bcd8739ae039 = $ec6deca3f04bff0a$var$AxiosURLSearchParams;

});
parcelRegister("DThbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $077e855763e662bb$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $9ZtKp = parcelRequire("9ZtKp");

var $dVJB2 = parcelRequire("dVJB2");
var $077e855763e662bb$require$Buffer = $dVJB2.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $077e855763e662bb$var$isVisitable(thing) {
    return (0, $3v50U.default).isPlainObject(thing) || (0, $3v50U.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $077e855763e662bb$var$removeBrackets(key) {
    return (0, $3v50U.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $077e855763e662bb$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $077e855763e662bb$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $077e855763e662bb$var$isFlatArray(arr) {
    return (0, $3v50U.default).isArray(arr) && !arr.some($077e855763e662bb$var$isVisitable);
}
const $077e855763e662bb$var$predicates = (0, $3v50U.default).toFlatObject((0, $3v50U.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $077e855763e662bb$var$toFormData(obj, formData, options) {
    if (!(0, $3v50U.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $9ZtKp.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $3v50U.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $3v50U.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $3v50U.default).isSpecCompliantForm(formData);
    if (!(0, $3v50U.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $3v50U.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $3v50U.default).isBlob(value)) throw new (0, $9NE6H.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $3v50U.default).isArrayBuffer(value) || (0, $3v50U.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $077e855763e662bb$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $3v50U.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $3v50U.default).isArray(value) && $077e855763e662bb$var$isFlatArray(value) || ((0, $3v50U.default).isFileList(value) || (0, $3v50U.default).endsWith(key, "[]")) && (arr = (0, $3v50U.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $077e855763e662bb$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $3v50U.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $077e855763e662bb$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($077e855763e662bb$var$isVisitable(value)) return true;
        formData.append($077e855763e662bb$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($077e855763e662bb$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $077e855763e662bb$var$isVisitable
    });
    function build(value, path) {
        if ((0, $3v50U.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $3v50U.default).forEach(value, function each(el, key) {
            const result = !((0, $3v50U.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $3v50U.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $3v50U.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $077e855763e662bb$export$2e2bcd8739ae039 = $077e855763e662bb$var$toFormData;

});
parcelRegister("9NE6H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7227cd0fd7e0dd2c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $7227cd0fd7e0dd2c$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $3v50U.default).inherits($7227cd0fd7e0dd2c$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $3v50U.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $7227cd0fd7e0dd2c$var$prototype = $7227cd0fd7e0dd2c$var$AxiosError.prototype;
const $7227cd0fd7e0dd2c$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $7227cd0fd7e0dd2c$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($7227cd0fd7e0dd2c$var$AxiosError, $7227cd0fd7e0dd2c$var$descriptors);
Object.defineProperty($7227cd0fd7e0dd2c$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$7227cd0fd7e0dd2c$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($7227cd0fd7e0dd2c$var$prototype);
    (0, $3v50U.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $7227cd0fd7e0dd2c$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $7227cd0fd7e0dd2c$export$2e2bcd8739ae039 = $7227cd0fd7e0dd2c$var$AxiosError;

});

parcelRegister("9ZtKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7460e2c89bd4d79e$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $7460e2c89bd4d79e$export$2e2bcd8739ae039 = null;

});

parcelRegister("dVJB2", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $a243f7be14c7f298$export$a143d493d941bafc; }, function (v) { return $a243f7be14c7f298$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $a243f7be14c7f298$export$f99ded8fe4b79145; }, function (v) { return $a243f7be14c7f298$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a243f7be14c7f298$export$a143d493d941bafc;
var $a243f7be14c7f298$export$e4cf37d7f6fb9e0a;
var $a243f7be14c7f298$export$f99ded8fe4b79145;
var $a243f7be14c7f298$export$599f31c3813fae4d;
"use strict";

var $6S7ok = parcelRequire("6S7ok");

var $e4FQO = parcelRequire("e4FQO");
var $a243f7be14c7f298$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$a243f7be14c7f298$export$a143d493d941bafc = $a243f7be14c7f298$var$Buffer;
$a243f7be14c7f298$export$e4cf37d7f6fb9e0a = $a243f7be14c7f298$var$SlowBuffer;
$a243f7be14c7f298$export$f99ded8fe4b79145 = 50;
var $a243f7be14c7f298$var$K_MAX_LENGTH = 0x7fffffff;
$a243f7be14c7f298$export$599f31c3813fae4d = $a243f7be14c7f298$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a243f7be14c7f298$var$Buffer.TYPED_ARRAY_SUPPORT = $a243f7be14c7f298$var$typedArraySupport();
if (!$a243f7be14c7f298$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a243f7be14c7f298$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a243f7be14c7f298$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$a243f7be14c7f298$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a243f7be14c7f298$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$a243f7be14c7f298$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a243f7be14c7f298$var$createBuffer(length) {
    if (length > $a243f7be14c7f298$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a243f7be14c7f298$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a243f7be14c7f298$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a243f7be14c7f298$var$allocUnsafe(arg);
    }
    return $a243f7be14c7f298$var$from(arg, encodingOrOffset, length);
}
$a243f7be14c7f298$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a243f7be14c7f298$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $a243f7be14c7f298$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a243f7be14c7f298$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a243f7be14c7f298$var$isInstance(value, ArrayBuffer) || value && $a243f7be14c7f298$var$isInstance(value.buffer, ArrayBuffer)) return $a243f7be14c7f298$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($a243f7be14c7f298$var$isInstance(value, SharedArrayBuffer) || value && $a243f7be14c7f298$var$isInstance(value.buffer, SharedArrayBuffer))) return $a243f7be14c7f298$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a243f7be14c7f298$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $a243f7be14c7f298$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $a243f7be14c7f298$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a243f7be14c7f298$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a243f7be14c7f298$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a243f7be14c7f298$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a243f7be14c7f298$var$Buffer, Uint8Array);
function $a243f7be14c7f298$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a243f7be14c7f298$var$alloc(size, fill, encoding) {
    $a243f7be14c7f298$var$assertSize(size);
    if (size <= 0) return $a243f7be14c7f298$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $a243f7be14c7f298$var$createBuffer(size).fill(fill, encoding) : $a243f7be14c7f298$var$createBuffer(size).fill(fill);
    return $a243f7be14c7f298$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a243f7be14c7f298$var$Buffer.alloc = function(size, fill, encoding) {
    return $a243f7be14c7f298$var$alloc(size, fill, encoding);
};
function $a243f7be14c7f298$var$allocUnsafe(size) {
    $a243f7be14c7f298$var$assertSize(size);
    return $a243f7be14c7f298$var$createBuffer(size < 0 ? 0 : $a243f7be14c7f298$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a243f7be14c7f298$var$Buffer.allocUnsafe = function(size) {
    return $a243f7be14c7f298$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a243f7be14c7f298$var$Buffer.allocUnsafeSlow = function(size) {
    return $a243f7be14c7f298$var$allocUnsafe(size);
};
function $a243f7be14c7f298$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$a243f7be14c7f298$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $a243f7be14c7f298$var$byteLength(string, encoding) | 0;
    var buf = $a243f7be14c7f298$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a243f7be14c7f298$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $a243f7be14c7f298$var$checked(array.length) | 0;
    var buf = $a243f7be14c7f298$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a243f7be14c7f298$var$fromArrayView(arrayView) {
    if ($a243f7be14c7f298$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $a243f7be14c7f298$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a243f7be14c7f298$var$fromArrayLike(arrayView);
}
function $a243f7be14c7f298$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a243f7be14c7f298$var$Buffer.prototype);
    return buf;
}
function $a243f7be14c7f298$var$fromObject(obj) {
    if ($a243f7be14c7f298$var$Buffer.isBuffer(obj)) {
        var len = $a243f7be14c7f298$var$checked(obj.length) | 0;
        var buf = $a243f7be14c7f298$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $a243f7be14c7f298$var$numberIsNaN(obj.length)) return $a243f7be14c7f298$var$createBuffer(0);
        return $a243f7be14c7f298$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $a243f7be14c7f298$var$fromArrayLike(obj.data);
}
function $a243f7be14c7f298$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a243f7be14c7f298$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a243f7be14c7f298$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $a243f7be14c7f298$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a243f7be14c7f298$var$Buffer.alloc(+length);
}
$a243f7be14c7f298$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a243f7be14c7f298$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a243f7be14c7f298$var$Buffer.compare = function compare(a, b) {
    if ($a243f7be14c7f298$var$isInstance(a, Uint8Array)) a = $a243f7be14c7f298$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a243f7be14c7f298$var$isInstance(b, Uint8Array)) b = $a243f7be14c7f298$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a243f7be14c7f298$var$Buffer.isBuffer(a) || !$a243f7be14c7f298$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a243f7be14c7f298$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$a243f7be14c7f298$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a243f7be14c7f298$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $a243f7be14c7f298$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($a243f7be14c7f298$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $a243f7be14c7f298$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a243f7be14c7f298$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a243f7be14c7f298$var$byteLength(string, encoding) {
    if ($a243f7be14c7f298$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a243f7be14c7f298$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $a243f7be14c7f298$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $a243f7be14c7f298$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a243f7be14c7f298$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a243f7be14c7f298$var$Buffer.byteLength = $a243f7be14c7f298$var$byteLength;
function $a243f7be14c7f298$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $a243f7be14c7f298$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $a243f7be14c7f298$var$utf8Slice(this, start, end);
        case "ascii":
            return $a243f7be14c7f298$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $a243f7be14c7f298$var$latin1Slice(this, start, end);
        case "base64":
            return $a243f7be14c7f298$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a243f7be14c7f298$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a243f7be14c7f298$var$Buffer.prototype._isBuffer = true;
function $a243f7be14c7f298$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a243f7be14c7f298$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$a243f7be14c7f298$var$swap(this, i, i + 1);
    return this;
};
$a243f7be14c7f298$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $a243f7be14c7f298$var$swap(this, i, i + 3);
        $a243f7be14c7f298$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a243f7be14c7f298$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $a243f7be14c7f298$var$swap(this, i, i + 7);
        $a243f7be14c7f298$var$swap(this, i + 1, i + 6);
        $a243f7be14c7f298$var$swap(this, i + 2, i + 5);
        $a243f7be14c7f298$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a243f7be14c7f298$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $a243f7be14c7f298$var$utf8Slice(this, 0, length);
    return $a243f7be14c7f298$var$slowToString.apply(this, arguments);
};
$a243f7be14c7f298$var$Buffer.prototype.toLocaleString = $a243f7be14c7f298$var$Buffer.prototype.toString;
$a243f7be14c7f298$var$Buffer.prototype.equals = function equals(b) {
    if (!$a243f7be14c7f298$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $a243f7be14c7f298$var$Buffer.compare(this, b) === 0;
};
$a243f7be14c7f298$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $a243f7be14c7f298$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($a243f7be14c7f298$var$customInspectSymbol) $a243f7be14c7f298$var$Buffer.prototype[$a243f7be14c7f298$var$customInspectSymbol] = $a243f7be14c7f298$var$Buffer.prototype.inspect;
$a243f7be14c7f298$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a243f7be14c7f298$var$isInstance(target, Uint8Array)) target = $a243f7be14c7f298$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a243f7be14c7f298$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a243f7be14c7f298$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a243f7be14c7f298$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $a243f7be14c7f298$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a243f7be14c7f298$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a243f7be14c7f298$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a243f7be14c7f298$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $a243f7be14c7f298$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a243f7be14c7f298$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a243f7be14c7f298$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a243f7be14c7f298$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a243f7be14c7f298$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a243f7be14c7f298$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a243f7be14c7f298$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a243f7be14c7f298$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a243f7be14c7f298$var$utf8Write(buf, string, offset, length) {
    return $a243f7be14c7f298$var$blitBuffer($a243f7be14c7f298$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a243f7be14c7f298$var$asciiWrite(buf, string, offset, length) {
    return $a243f7be14c7f298$var$blitBuffer($a243f7be14c7f298$var$asciiToBytes(string), buf, offset, length);
}
function $a243f7be14c7f298$var$base64Write(buf, string, offset, length) {
    return $a243f7be14c7f298$var$blitBuffer($a243f7be14c7f298$var$base64ToBytes(string), buf, offset, length);
}
function $a243f7be14c7f298$var$ucs2Write(buf, string, offset, length) {
    return $a243f7be14c7f298$var$blitBuffer($a243f7be14c7f298$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a243f7be14c7f298$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $a243f7be14c7f298$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $a243f7be14c7f298$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $a243f7be14c7f298$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $a243f7be14c7f298$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a243f7be14c7f298$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a243f7be14c7f298$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a243f7be14c7f298$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6S7ok.fromByteArray(buf);
    else return $6S7ok.fromByteArray(buf.slice(start, end));
}
function $a243f7be14c7f298$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a243f7be14c7f298$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $a243f7be14c7f298$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a243f7be14c7f298$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $a243f7be14c7f298$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a243f7be14c7f298$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a243f7be14c7f298$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a243f7be14c7f298$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a243f7be14c7f298$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $a243f7be14c7f298$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a243f7be14c7f298$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a243f7be14c7f298$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a243f7be14c7f298$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a243f7be14c7f298$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$a243f7be14c7f298$var$Buffer.prototype.readUintLE = $a243f7be14c7f298$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a243f7be14c7f298$var$Buffer.prototype.readUintBE = $a243f7be14c7f298$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a243f7be14c7f298$var$Buffer.prototype.readUint8 = $a243f7be14c7f298$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a243f7be14c7f298$var$Buffer.prototype.readUint16LE = $a243f7be14c7f298$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a243f7be14c7f298$var$Buffer.prototype.readUint16BE = $a243f7be14c7f298$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a243f7be14c7f298$var$Buffer.prototype.readUint32LE = $a243f7be14c7f298$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a243f7be14c7f298$var$Buffer.prototype.readUint32BE = $a243f7be14c7f298$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a243f7be14c7f298$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a243f7be14c7f298$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a243f7be14c7f298$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a243f7be14c7f298$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a243f7be14c7f298$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a243f7be14c7f298$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a243f7be14c7f298$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a243f7be14c7f298$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return $e4FQO.read(this, offset, true, 23, 4);
};
$a243f7be14c7f298$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 4, this.length);
    return $e4FQO.read(this, offset, false, 23, 4);
};
$a243f7be14c7f298$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 8, this.length);
    return $e4FQO.read(this, offset, true, 52, 8);
};
$a243f7be14c7f298$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkOffset(offset, 8, this.length);
    return $e4FQO.read(this, offset, false, 52, 8);
};
function $a243f7be14c7f298$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a243f7be14c7f298$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$a243f7be14c7f298$var$Buffer.prototype.writeUintLE = $a243f7be14c7f298$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a243f7be14c7f298$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUintBE = $a243f7be14c7f298$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a243f7be14c7f298$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUint8 = $a243f7be14c7f298$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUint16LE = $a243f7be14c7f298$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUint16BE = $a243f7be14c7f298$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUint32LE = $a243f7be14c7f298$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a243f7be14c7f298$var$Buffer.prototype.writeUint32BE = $a243f7be14c7f298$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a243f7be14c7f298$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a243f7be14c7f298$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a243f7be14c7f298$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $a243f7be14c7f298$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a243f7be14c7f298$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a243f7be14c7f298$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a243f7be14c7f298$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a243f7be14c7f298$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a243f7be14c7f298$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a243f7be14c7f298$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $a243f7be14c7f298$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $e4FQO.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a243f7be14c7f298$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a243f7be14c7f298$var$writeFloat(this, value, offset, true, noAssert);
};
$a243f7be14c7f298$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a243f7be14c7f298$var$writeFloat(this, value, offset, false, noAssert);
};
function $a243f7be14c7f298$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a243f7be14c7f298$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $e4FQO.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a243f7be14c7f298$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a243f7be14c7f298$var$writeDouble(this, value, offset, true, noAssert);
};
$a243f7be14c7f298$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a243f7be14c7f298$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a243f7be14c7f298$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a243f7be14c7f298$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a243f7be14c7f298$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$a243f7be14c7f298$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $a243f7be14c7f298$var$Buffer.isBuffer(val) ? val : $a243f7be14c7f298$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $a243f7be14c7f298$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a243f7be14c7f298$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a243f7be14c7f298$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $a243f7be14c7f298$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $a243f7be14c7f298$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a243f7be14c7f298$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a243f7be14c7f298$var$base64ToBytes(str) {
    return $6S7ok.toByteArray($a243f7be14c7f298$var$base64clean(str));
}
function $a243f7be14c7f298$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a243f7be14c7f298$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a243f7be14c7f298$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $a243f7be14c7f298$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("6S7ok", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $500d85059318f61f$export$d622b2ad8d90c771; }, function (v) { return $500d85059318f61f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $500d85059318f61f$export$6100ba28696e12de; }, function (v) { return $500d85059318f61f$export$6100ba28696e12de = v; });
var $500d85059318f61f$export$a48f0734ac7c2329;
var $500d85059318f61f$export$d622b2ad8d90c771;
var $500d85059318f61f$export$6100ba28696e12de;
"use strict";
$500d85059318f61f$export$a48f0734ac7c2329 = $500d85059318f61f$var$byteLength;
$500d85059318f61f$export$d622b2ad8d90c771 = $500d85059318f61f$var$toByteArray;
$500d85059318f61f$export$6100ba28696e12de = $500d85059318f61f$var$fromByteArray;
var $500d85059318f61f$var$lookup = [];
var $500d85059318f61f$var$revLookup = [];
var $500d85059318f61f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $500d85059318f61f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $500d85059318f61f$var$i = 0, $500d85059318f61f$var$len = $500d85059318f61f$var$code.length; $500d85059318f61f$var$i < $500d85059318f61f$var$len; ++$500d85059318f61f$var$i){
    $500d85059318f61f$var$lookup[$500d85059318f61f$var$i] = $500d85059318f61f$var$code[$500d85059318f61f$var$i];
    $500d85059318f61f$var$revLookup[$500d85059318f61f$var$code.charCodeAt($500d85059318f61f$var$i)] = $500d85059318f61f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$500d85059318f61f$var$revLookup["-".charCodeAt(0)] = 62;
$500d85059318f61f$var$revLookup["_".charCodeAt(0)] = 63;
function $500d85059318f61f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $500d85059318f61f$var$byteLength(b64) {
    var lens = $500d85059318f61f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $500d85059318f61f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $500d85059318f61f$var$toByteArray(b64) {
    var tmp;
    var lens = $500d85059318f61f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $500d85059318f61f$var$Arr($500d85059318f61f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $500d85059318f61f$var$revLookup[b64.charCodeAt(i)] << 18 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $500d85059318f61f$var$revLookup[b64.charCodeAt(i)] << 2 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $500d85059318f61f$var$revLookup[b64.charCodeAt(i)] << 10 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $500d85059318f61f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $500d85059318f61f$var$tripletToBase64(num) {
    return $500d85059318f61f$var$lookup[num >> 18 & 0x3F] + $500d85059318f61f$var$lookup[num >> 12 & 0x3F] + $500d85059318f61f$var$lookup[num >> 6 & 0x3F] + $500d85059318f61f$var$lookup[num & 0x3F];
}
function $500d85059318f61f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($500d85059318f61f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $500d85059318f61f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($500d85059318f61f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($500d85059318f61f$var$lookup[tmp >> 2] + $500d85059318f61f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($500d85059318f61f$var$lookup[tmp >> 10] + $500d85059318f61f$var$lookup[tmp >> 4 & 0x3F] + $500d85059318f61f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("e4FQO", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $a3f1e720dc03c2f6$export$aafa59e2e03f2942; }, function (v) { return $a3f1e720dc03c2f6$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $a3f1e720dc03c2f6$export$68d8715fc104d294; }, function (v) { return $a3f1e720dc03c2f6$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a3f1e720dc03c2f6$export$aafa59e2e03f2942;
var $a3f1e720dc03c2f6$export$68d8715fc104d294;
$a3f1e720dc03c2f6$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a3f1e720dc03c2f6$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("3oXSf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a20eb58aa5e62a$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
class $27a20eb58aa5e62a$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $3v50U.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $27a20eb58aa5e62a$export$2e2bcd8739ae039 = $27a20eb58aa5e62a$var$InterceptorManager;

});

parcelRegister("9aMTC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6adaf9f3d041815a$export$2e2bcd8739ae039; });

var $3V8y5 = parcelRequire("3V8y5");

var $kBQOk = parcelRequire("kBQOk");

var $kXg7s = parcelRequire("kXg7s");

var $lMpcA = parcelRequire("lMpcA");

var $hdRGz = parcelRequire("hdRGz");

var $u7vyD = parcelRequire("u7vyD");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $6adaf9f3d041815a$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $lMpcA.default)(null, config);
}
function $6adaf9f3d041815a$export$2e2bcd8739ae039(config) {
    $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
    config.headers = (0, $hdRGz.default).from(config.headers);
    // Transform request data
    config.data = (0, $3V8y5.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $u7vyD.default).getAdapter(config.adapter || (0, $kXg7s.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $3V8y5.default).call(config, config.transformResponse, response);
        response.headers = (0, $hdRGz.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $kBQOk.default)(reason)) {
            $6adaf9f3d041815a$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $3V8y5.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $hdRGz.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("3V8y5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dad5395bbfc09d9$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $kXg7s = parcelRequire("kXg7s");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
function $2dad5395bbfc09d9$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $kXg7s.default);
    const context = response || config;
    const headers = (0, $hdRGz.default).from(context.headers);
    let data = context.data;
    (0, $3v50U.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("kXg7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f415d24cc60d6449$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $i6Q6y = parcelRequire("i6Q6y");

var $DThbK = parcelRequire("DThbK");

var $5DJ2h = parcelRequire("5DJ2h");

var $7d3hU = parcelRequire("7d3hU");

var $kKGuv = parcelRequire("kKGuv");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f415d24cc60d6449$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $3v50U.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $3v50U.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f415d24cc60d6449$var$defaults = {
    transitional: (0, $i6Q6y.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $3v50U.default).isObject(data);
            if (isObjectPayload && (0, $3v50U.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $3v50U.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $kKGuv.default)(data)) : data;
            if ((0, $3v50U.default).isArrayBuffer(data) || (0, $3v50U.default).isBuffer(data) || (0, $3v50U.default).isStream(data) || (0, $3v50U.default).isFile(data) || (0, $3v50U.default).isBlob(data) || (0, $3v50U.default).isReadableStream(data)) return data;
            if ((0, $3v50U.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $3v50U.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $5DJ2h.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $3v50U.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $DThbK.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f415d24cc60d6449$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f415d24cc60d6449$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $3v50U.default).isResponse(data) || (0, $3v50U.default).isReadableStream(data)) return data;
            if (data && (0, $3v50U.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $9NE6H.default).from(e, (0, $9NE6H.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7d3hU.default).classes.FormData,
        Blob: (0, $7d3hU.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $3v50U.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f415d24cc60d6449$var$defaults.headers[method] = {};
});
var $f415d24cc60d6449$export$2e2bcd8739ae039 = $f415d24cc60d6449$var$defaults;

});
parcelRegister("i6Q6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2f1346fa5b7b03b$export$2e2bcd8739ae039; });
"use strict";
var $d2f1346fa5b7b03b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("5DJ2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b38772a4e1a80a$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $DThbK = parcelRequire("DThbK");

var $7d3hU = parcelRequire("7d3hU");
"use strict";
function $41b38772a4e1a80a$export$2e2bcd8739ae039(data, options) {
    return (0, $DThbK.default)(data, new (0, $7d3hU.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7d3hU.default).isNode && (0, $3v50U.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("7d3hU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53fc4c36fbcb255f$export$2e2bcd8739ae039; });

var $jCEAt = parcelRequire("jCEAt");

var $apNCA = parcelRequire("apNCA");
var $53fc4c36fbcb255f$export$2e2bcd8739ae039 = {
    ...$apNCA,
    ...(0, $jCEAt.default)
};

});
parcelRegister("jCEAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4910cb750aa2caa$export$2e2bcd8739ae039; });

var $2ft8D = parcelRequire("2ft8D");

var $12SIP = parcelRequire("12SIP");

var $bd05w = parcelRequire("bd05w");
var $e4910cb750aa2caa$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $2ft8D.default,
        FormData: $12SIP.default,
        Blob: $bd05w.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("2ft8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3395c1f6b69cf4$export$2e2bcd8739ae039; });

var $kivv9 = parcelRequire("kivv9");
"use strict";
var $1a3395c1f6b69cf4$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $kivv9.default);

});

parcelRegister("12SIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c306d026dd009a7$export$2e2bcd8739ae039; });
"use strict";
var $0c306d026dd009a7$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("bd05w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8290fa15a267d616$export$2e2bcd8739ae039; });
"use strict";
var $8290fa15a267d616$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("apNCA", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $7952baef442d2e59$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $7952baef442d2e59$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $7952baef442d2e59$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $7952baef442d2e59$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $7952baef442d2e59$export$f710a83a91838a36; });
const $7952baef442d2e59$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $7952baef442d2e59$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $7952baef442d2e59$export$c0bcc9250309d66 = $7952baef442d2e59$export$c4996c4b7b93b0bf && (!$7952baef442d2e59$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($7952baef442d2e59$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $7952baef442d2e59$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $7952baef442d2e59$export$f710a83a91838a36 = $7952baef442d2e59$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("kKGuv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1b9105b11fc0a07$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $f1b9105b11fc0a07$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $3v50U.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $f1b9105b11fc0a07$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $f1b9105b11fc0a07$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $3v50U.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $3v50U.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $3v50U.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $3v50U.default).isArray(target[name])) target[name] = $f1b9105b11fc0a07$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $3v50U.default).isFormData(formData) && (0, $3v50U.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $3v50U.default).forEachEntry(formData, (name, value)=>{
            buildPath($f1b9105b11fc0a07$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $f1b9105b11fc0a07$export$2e2bcd8739ae039 = $f1b9105b11fc0a07$var$formDataToJSON;

});


parcelRegister("hdRGz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c89d4b6c235d293e$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $jtNGc = parcelRequire("jtNGc");
"use strict";
const $c89d4b6c235d293e$var$$internals = Symbol("internals");
function $c89d4b6c235d293e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c89d4b6c235d293e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $3v50U.default).isArray(value) ? value.map($c89d4b6c235d293e$var$normalizeValue) : String(value);
}
function $c89d4b6c235d293e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c89d4b6c235d293e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c89d4b6c235d293e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $3v50U.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $3v50U.default).isString(value)) return;
    if ((0, $3v50U.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $3v50U.default).isRegExp(filter)) return filter.test(value);
}
function $c89d4b6c235d293e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c89d4b6c235d293e$var$buildAccessors(obj, header) {
    const accessorName = (0, $3v50U.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c89d4b6c235d293e$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $3v50U.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c89d4b6c235d293e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $3v50U.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $3v50U.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $3v50U.default).isString(header) && (header = header.trim()) && !$c89d4b6c235d293e$var$isValidHeaderName(header)) setHeaders((0, $jtNGc.default)(header), valueOrRewrite);
        else if ((0, $3v50U.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c89d4b6c235d293e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3v50U.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c89d4b6c235d293e$var$parseTokens(value);
                if ((0, $3v50U.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $3v50U.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c89d4b6c235d293e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $3v50U.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $3v50U.default).findKey(self, _header);
                if (key && (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $3v50U.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c89d4b6c235d293e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $3v50U.default).forEach(this, (value, header)=>{
            const key = (0, $3v50U.default).findKey(headers, header);
            if (key) {
                self[key] = $c89d4b6c235d293e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c89d4b6c235d293e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c89d4b6c235d293e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $3v50U.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $3v50U.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c89d4b6c235d293e$var$$internals] = this[$c89d4b6c235d293e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c89d4b6c235d293e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c89d4b6c235d293e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $3v50U.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$c89d4b6c235d293e$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $3v50U.default).reduceDescriptors($c89d4b6c235d293e$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $3v50U.default).freezeMethods($c89d4b6c235d293e$var$AxiosHeaders);
var $c89d4b6c235d293e$export$2e2bcd8739ae039 = $c89d4b6c235d293e$var$AxiosHeaders;

});
parcelRegister("jtNGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2e7431247a6cf7c$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $e2e7431247a6cf7c$var$ignoreDuplicateOf = (0, $3v50U.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $e2e7431247a6cf7c$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $e2e7431247a6cf7c$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("kBQOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0103a75c7439fbd$export$2e2bcd8739ae039; });
"use strict";
function $f0103a75c7439fbd$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("lMpcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb1a13da6a986b4$export$2e2bcd8739ae039; });

var $9NE6H = parcelRequire("9NE6H");

var $3v50U = parcelRequire("3v50U");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $fdb1a13da6a986b4$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $9NE6H.default).call(this, message == null ? "canceled" : message, (0, $9NE6H.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $3v50U.default).inherits($fdb1a13da6a986b4$var$CanceledError, (0, $9NE6H.default), {
    __CANCEL__: true
});
var $fdb1a13da6a986b4$export$2e2bcd8739ae039 = $fdb1a13da6a986b4$var$CanceledError;

});

parcelRegister("u7vyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a8a0634cdb1446$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $9ZtKp = parcelRequire("9ZtKp");

var $kE5AP = parcelRequire("kE5AP");

var $hYrZb = parcelRequire("hYrZb");

var $9NE6H = parcelRequire("9NE6H");
const $05a8a0634cdb1446$var$knownAdapters = {
    http: (0, $9ZtKp.default),
    xhr: (0, $kE5AP.default),
    fetch: (0, $hYrZb.default)
};
(0, $3v50U.default).forEach($05a8a0634cdb1446$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $05a8a0634cdb1446$var$renderReason = (reason)=>`- ${reason}`;
const $05a8a0634cdb1446$var$isResolvedHandle = (adapter)=>(0, $3v50U.default).isFunction(adapter) || adapter === null || adapter === false;
var $05a8a0634cdb1446$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $3v50U.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$05a8a0634cdb1446$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $05a8a0634cdb1446$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $9NE6H.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($05a8a0634cdb1446$var$renderReason).join("\n") : " " + $05a8a0634cdb1446$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $9NE6H.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $05a8a0634cdb1446$var$knownAdapters
};

});
parcelRegister("kE5AP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f07be1c0aa864c09$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $gn43Q = parcelRequire("gn43Q");

var $i6Q6y = parcelRequire("i6Q6y");

var $9NE6H = parcelRequire("9NE6H");

var $lMpcA = parcelRequire("lMpcA");

var $goOIP = parcelRequire("goOIP");

var $7d3hU = parcelRequire("7d3hU");

var $hdRGz = parcelRequire("hdRGz");

var $5Unwm = parcelRequire("5Unwm");

var $l5Miv = parcelRequire("l5Miv");
const $f07be1c0aa864c09$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $f07be1c0aa864c09$export$2e2bcd8739ae039 = $f07be1c0aa864c09$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $l5Miv.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $hdRGz.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $hdRGz.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $gn43Q.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $9NE6H.default)("Request aborted", (0, $9NE6H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $9NE6H.default)("Network Error", (0, $9NE6H.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $i6Q6y.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $9NE6H.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $9NE6H.default).ETIMEDOUT : (0, $9NE6H.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $3v50U.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $3v50U.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $5Unwm.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $5Unwm.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $lMpcA.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $goOIP.default)(_config.url);
        if (protocol && (0, $7d3hU.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $9NE6H.default)("Unsupported protocol " + protocol + ":", (0, $9NE6H.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("gn43Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $beb1f1c215096f3a$export$2e2bcd8739ae039; });

var $9NE6H = parcelRequire("9NE6H");
"use strict";
function $beb1f1c215096f3a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $9NE6H.default)("Request failed with status code " + response.status, [
        (0, $9NE6H.default).ERR_BAD_REQUEST,
        (0, $9NE6H.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("goOIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf063b8e669a2e39$export$2e2bcd8739ae039; });
"use strict";
function $bf063b8e669a2e39$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("5Unwm", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $44d46d7c6f14494c$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $44d46d7c6f14494c$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $44d46d7c6f14494c$export$5d35863c355a22a9; });

var $ewQkV = parcelRequire("ewQkV");

var $7T2Jh = parcelRequire("7T2Jh");

var $3v50U = parcelRequire("3v50U");
const $44d46d7c6f14494c$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $ewQkV.default)(50, 250);
    return (0, $7T2Jh.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $44d46d7c6f14494c$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $44d46d7c6f14494c$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $3v50U.default).asap(()=>fn(...args));

});
parcelRegister("ewQkV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a93ca6c3363686fc$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a93ca6c3363686fc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a93ca6c3363686fc$export$2e2bcd8739ae039 = $a93ca6c3363686fc$var$speedometer;

});

parcelRegister("7T2Jh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bdfc973d1d99d71$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $5bdfc973d1d99d71$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $5bdfc973d1d99d71$export$2e2bcd8739ae039 = $5bdfc973d1d99d71$var$throttle;

});


parcelRegister("l5Miv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5af87764c538378$export$2e2bcd8739ae039; });

var $7d3hU = parcelRequire("7d3hU");

var $3v50U = parcelRequire("3v50U");

var $i9umf = parcelRequire("i9umf");

var $4aeNs = parcelRequire("4aeNs");

var $kSWF8 = parcelRequire("kSWF8");

var $8FHSN = parcelRequire("8FHSN");

var $hdRGz = parcelRequire("hdRGz");

var $flOXD = parcelRequire("flOXD");
var $f5af87764c538378$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $8FHSN.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $hdRGz.default).from(headers);
    newConfig.url = (0, $flOXD.default)((0, $kSWF8.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $3v50U.default).isFormData(data)) {
        if ((0, $7d3hU.default).hasStandardBrowserEnv || (0, $7d3hU.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7d3hU.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $3v50U.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $i9umf.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4aeNs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("i9umf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3709dafab5b3d77$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $7d3hU = parcelRequire("7d3hU");
"use strict";
var $d3709dafab5b3d77$export$2e2bcd8739ae039 = (0, $7d3hU.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = (0, $7d3hU.default).navigator && /(msie|trident)/i.test((0, $7d3hU.default).navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $3v50U.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("4aeNs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308392efe60e2164$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $7d3hU = parcelRequire("7d3hU");
var $308392efe60e2164$export$2e2bcd8739ae039 = (0, $7d3hU.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $3v50U.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $3v50U.default).isString(path) && cookie.push("path=" + path);
        (0, $3v50U.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("kSWF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3465af50e9c02a0$export$2e2bcd8739ae039; });

var $fS9SV = parcelRequire("fS9SV");

var $18LNB = parcelRequire("18LNB");
"use strict";
function $f3465af50e9c02a0$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $fS9SV.default)(requestedURL)) return (0, $18LNB.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("fS9SV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8e3911595ee8d46$export$2e2bcd8739ae039; });
"use strict";
function $b8e3911595ee8d46$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("18LNB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d4b9db04d517e80$export$2e2bcd8739ae039; });
"use strict";
function $0d4b9db04d517e80$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("8FHSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65043143de50ffea$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");

var $hdRGz = parcelRequire("hdRGz");
"use strict";
const $65043143de50ffea$var$headersToObject = (thing)=>thing instanceof (0, $hdRGz.default) ? {
        ...thing
    } : thing;
function $65043143de50ffea$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $3v50U.default).isPlainObject(target) && (0, $3v50U.default).isPlainObject(source)) return (0, $3v50U.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $3v50U.default).isPlainObject(source)) return (0, $3v50U.default).merge({}, source);
        else if ((0, $3v50U.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $3v50U.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $3v50U.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $3v50U.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($65043143de50ffea$var$headersToObject(a), $65043143de50ffea$var$headersToObject(b), true)
    };
    (0, $3v50U.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $3v50U.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("hYrZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d15dbfa5975cd945$export$2e2bcd8739ae039; });

var $7d3hU = parcelRequire("7d3hU");

var $3v50U = parcelRequire("3v50U");

var $9NE6H = parcelRequire("9NE6H");

var $8dHIy = parcelRequire("8dHIy");

var $gtTC9 = parcelRequire("gtTC9");

var $hdRGz = parcelRequire("hdRGz");

var $5Unwm = parcelRequire("5Unwm");

var $l5Miv = parcelRequire("l5Miv");

var $gn43Q = parcelRequire("gn43Q");
const $d15dbfa5975cd945$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $d15dbfa5975cd945$var$isReadableStreamSupported = $d15dbfa5975cd945$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $d15dbfa5975cd945$var$encodeText = $d15dbfa5975cd945$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $d15dbfa5975cd945$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $d15dbfa5975cd945$var$supportsRequestStream = $d15dbfa5975cd945$var$isReadableStreamSupported && $d15dbfa5975cd945$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $7d3hU.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE = 65536;
const $d15dbfa5975cd945$var$supportsResponseStream = $d15dbfa5975cd945$var$isReadableStreamSupported && $d15dbfa5975cd945$var$test(()=>(0, $3v50U.default).isReadableStream(new Response("").body));
const $d15dbfa5975cd945$var$resolvers = {
    stream: $d15dbfa5975cd945$var$supportsResponseStream && ((res)=>res.body)
};
$d15dbfa5975cd945$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$d15dbfa5975cd945$var$resolvers[type] && ($d15dbfa5975cd945$var$resolvers[type] = (0, $3v50U.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $9NE6H.default)(`Response type '${type}' is not supported`, (0, $9NE6H.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $d15dbfa5975cd945$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $3v50U.default).isBlob(body)) return body.size;
    if ((0, $3v50U.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $7d3hU.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $3v50U.default).isArrayBufferView(body) || (0, $3v50U.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $3v50U.default).isURLSearchParams(body)) body = body + "";
    if ((0, $3v50U.default).isString(body)) return (await $d15dbfa5975cd945$var$encodeText(body)).byteLength;
};
const $d15dbfa5975cd945$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $3v50U.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $d15dbfa5975cd945$var$getBodyLength(body) : length;
};
var $d15dbfa5975cd945$export$2e2bcd8739ae039 = $d15dbfa5975cd945$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $l5Miv.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $8dHIy.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $d15dbfa5975cd945$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $d15dbfa5975cd945$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $3v50U.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $5Unwm.progressEventDecorator)(requestContentLength, (0, $5Unwm.progressEventReducer)((0, $5Unwm.asyncDecorator)(onUploadProgress)));
                data = (0, $gtTC9.trackStream)(_request.body, $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $3v50U.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $d15dbfa5975cd945$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($d15dbfa5975cd945$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $3v50U.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $5Unwm.progressEventDecorator)(responseContentLength, (0, $5Unwm.progressEventReducer)((0, $5Unwm.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $gtTC9.trackStream)(response.body, $d15dbfa5975cd945$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $d15dbfa5975cd945$var$resolvers[(0, $3v50U.default).findKey($d15dbfa5975cd945$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $gn43Q.default)(resolve, reject, {
                data: responseData,
                headers: (0, $hdRGz.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $9NE6H.default)("Network Error", (0, $9NE6H.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $9NE6H.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("8dHIy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc1730af4ed7d42$export$2e2bcd8739ae039; });

var $lMpcA = parcelRequire("lMpcA");

var $9NE6H = parcelRequire("9NE6H");

var $3v50U = parcelRequire("3v50U");
const $5fc1730af4ed7d42$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $9NE6H.default) ? err : new (0, $lMpcA.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $9NE6H.default)(`timeout ${timeout} of ms exceeded`, (0, $9NE6H.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $3v50U.default).asap(unsubscribe);
        return signal;
    }
};
var $5fc1730af4ed7d42$export$2e2bcd8739ae039 = $5fc1730af4ed7d42$var$composeSignals;

});

parcelRegister("gtTC9", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $bffa7e9c613844aa$export$b0119225647bd83; });
const $bffa7e9c613844aa$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $bffa7e9c613844aa$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $bffa7e9c613844aa$var$readStream(iterable))yield* $bffa7e9c613844aa$export$71b051935044bd5d(chunk, chunkSize);
};
const $bffa7e9c613844aa$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $bffa7e9c613844aa$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $bffa7e9c613844aa$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("2wmIW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d60326b81386a4f$export$2e2bcd8739ae039; });

var $ie3yz = parcelRequire("ie3yz");

var $9NE6H = parcelRequire("9NE6H");
"use strict";
const $1d60326b81386a4f$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $1d60326b81386a4f$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $1d60326b81386a4f$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1d60326b81386a4f$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $ie3yz.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $9NE6H.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $9NE6H.default).ERR_DEPRECATED);
        if (version && !$1d60326b81386a4f$var$deprecatedWarnings[opt]) {
            $1d60326b81386a4f$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1d60326b81386a4f$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $9NE6H.default)("options must be an object", (0, $9NE6H.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $9NE6H.default)("option " + opt + " must be " + result, (0, $9NE6H.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $9NE6H.default)("Unknown option " + opt, (0, $9NE6H.default).ERR_BAD_OPTION);
    }
}
var $1d60326b81386a4f$export$2e2bcd8739ae039 = {
    assertOptions: $1d60326b81386a4f$var$assertOptions,
    validators: $1d60326b81386a4f$var$validators
};

});
parcelRegister("ie3yz", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $d44c4b0d5eb593bb$export$a4ad2735b021c132; });
const $d44c4b0d5eb593bb$export$a4ad2735b021c132 = "1.7.7";

});



parcelRegister("5zLKY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f544163c01037c$export$2e2bcd8739ae039; });

var $lMpcA = parcelRequire("lMpcA");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $40f544163c01037c$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $40f544163c01037c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $lMpcA.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $40f544163c01037c$export$2e2bcd8739ae039 = $40f544163c01037c$var$CancelToken;

});

parcelRegister("dyoH1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9de19ad8955d98a8$export$2e2bcd8739ae039; });
"use strict";
function $9de19ad8955d98a8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("c7TGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d4156daca8bc0cb$export$2e2bcd8739ae039; });

var $3v50U = parcelRequire("3v50U");
"use strict";
function $8d4156daca8bc0cb$export$2e2bcd8739ae039(payload) {
    return (0, $3v50U.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("fTG9u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b92cb099b93a4235$export$2e2bcd8739ae039; });
const $b92cb099b93a4235$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($b92cb099b93a4235$var$HttpStatusCode).forEach(([key, value])=>{
    $b92cb099b93a4235$var$HttpStatusCode[value] = key;
});
var $b92cb099b93a4235$export$2e2bcd8739ae039 = $b92cb099b93a4235$var$HttpStatusCode;

});



parcelRegister("k9qks", function(module, exports) {

$parcel$export(module.exports, "isInWebView", function () { return $470196b361e9f525$export$b3fd30c977a64b95; });
$parcel$export(module.exports, "isInPlayer", function () { return $470196b361e9f525$export$bdc0eb7bf5752345; });
$parcel$export(module.exports, "isPWA", function () { return $470196b361e9f525$export$fd1f485a98885089; });
$parcel$export(module.exports, "isVirtualKeyboardEnabled", function () { return $470196b361e9f525$export$895047d75a8eda04; });
var $470196b361e9f525$var$_window_matchMedia, $470196b361e9f525$var$_window;
const $470196b361e9f525$export$b3fd30c977a64b95 = "ReactNativeWebView" in window;
const $470196b361e9f525$export$bdc0eb7bf5752345 = navigator && navigator.userAgent && navigator.userAgent.includes("Castit");
const $470196b361e9f525$export$fd1f485a98885089 = !!(($470196b361e9f525$var$_window = window) === null || $470196b361e9f525$var$_window === void 0 ? void 0 : ($470196b361e9f525$var$_window_matchMedia = $470196b361e9f525$var$_window.matchMedia("(display-mode: fullscreen)")) === null || $470196b361e9f525$var$_window_matchMedia === void 0 ? void 0 : $470196b361e9f525$var$_window_matchMedia.matches);
const $470196b361e9f525$export$895047d75a8eda04 = !$470196b361e9f525$export$b3fd30c977a64b95;

});


parcelRegister("cD0nt", function(module, exports) {

$parcel$export(module.exports, "useClientPlan", function () { return $284bd66a1dd98c56$export$81371f8c31556ab1; });
$parcel$export(module.exports, "useLogoUrl", function () { return $284bd66a1dd98c56$export$85ed839e6898dc60; });
$parcel$export(module.exports, "useLayout", function () { return $284bd66a1dd98c56$export$f47430f7ffdcc134; });
$parcel$export(module.exports, "useReceptionistPhone", function () { return $284bd66a1dd98c56$export$9f30821ab9eba6a3; });
$parcel$export(module.exports, "useReceptionistTeamsEmail", function () { return $284bd66a1dd98c56$export$62ca977f860de9c7; });
$parcel$export(module.exports, "useDeliveryReceiver", function () { return $284bd66a1dd98c56$export$2cd5f299e15b85fc; });
$parcel$export(module.exports, "useOverview", function () { return $284bd66a1dd98c56$export$626541a5c6f2cfa1; });
$parcel$export(module.exports, "useAnimationsEnabled", function () { return $284bd66a1dd98c56$export$765324f4cccd6e12; });
$parcel$export(module.exports, "usePrintingEnabled", function () { return $284bd66a1dd98c56$export$c206a6020e5e0cc8; });
$parcel$export(module.exports, "usePrinter", function () { return $284bd66a1dd98c56$export$dfbb4c7cd62d88d3; });
$parcel$export(module.exports, "usePrintingLabel", function () { return $284bd66a1dd98c56$export$2f7da685ae073b68; });
$parcel$export(module.exports, "useWifiQrCode", function () { return $284bd66a1dd98c56$export$43b49132ff30c8a3; });
$parcel$export(module.exports, "useCallSettings", function () { return $284bd66a1dd98c56$export$4db579901265d63c; });
$parcel$export(module.exports, "useClock", function () { return $284bd66a1dd98c56$export$ebd4152617a83c60; });
$parcel$export(module.exports, "useDigitalReceptionCountry", function () { return $284bd66a1dd98c56$export$ea9c10744d0b37bf; });
$parcel$export(module.exports, "useIdentificationCode", function () { return $284bd66a1dd98c56$export$9da223f01d1173b2; });
$parcel$export(module.exports, "useDigitalReceptionMetadata", function () { return $284bd66a1dd98c56$export$217413e8ac4616d5; });
$parcel$export(module.exports, "useCheckFlowExtraButtons", function () { return $284bd66a1dd98c56$export$ef690ddae334daf8; });
$parcel$export(module.exports, "useTeams", function () { return $284bd66a1dd98c56$export$6fe02dcc2001dcb0; });
$parcel$export(module.exports, "useGoogleChat", function () { return $284bd66a1dd98c56$export$b9860d4c881dec49; });
$parcel$export(module.exports, "usePhotoCaptureSettings", function () { return $284bd66a1dd98c56$export$51a6f7090a10ba7b; });
$parcel$export(module.exports, "useContactPreviewEnabled", function () { return $284bd66a1dd98c56$export$829d946e99f8d268; });
$parcel$export(module.exports, "useCommunicationProvider", function () { return $284bd66a1dd98c56$export$ba091297bf0eae5b; });
$parcel$export(module.exports, "useTeamsVideoCallEnabled", function () { return $284bd66a1dd98c56$export$269361b4830f2dc8; });
$parcel$export(module.exports, "useAccessSettings", function () { return $284bd66a1dd98c56$export$8101ba2cbec55e2b; });
$parcel$export(module.exports, "useHidScannerSettings", function () { return $284bd66a1dd98c56$export$2352626cd3b3bbb4; });
$parcel$export(module.exports, "useSocketScannerSettings", function () { return $284bd66a1dd98c56$export$872df4c3b321bd72; });
$parcel$export(module.exports, "useDocumentScannerSettings", function () { return $284bd66a1dd98c56$export$c602d8befffd9f50; });
$parcel$export(module.exports, "useNfcScannerSettings", function () { return $284bd66a1dd98c56$export$ca4897d23e28f7a5; });
$parcel$export(module.exports, "default", function () { return $284bd66a1dd98c56$export$2e2bcd8739ae039; });
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");

var $jXblK = parcelRequire("jXblK");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $jnPOB = parcelRequire("jnPOB");

var $cwDEq = parcelRequire("cwDEq");

var $kCXUJ = parcelRequire("kCXUJ");

var $219y6 = parcelRequire("219y6");
const $284bd66a1dd98c56$var$BOARD_POLL_MINUTES = 5;
const $284bd66a1dd98c56$var$METERED_BOARD_POLL_MINUTES = 30;
const $284bd66a1dd98c56$export$5118ea9943f64521 = ()=>{
    var _cached_digitalReception_metadata_network, _cached_digitalReception_metadata, _cached_digitalReception;
    const { screenId: screenId } = (0, $cwDEq.useAppContext)();
    const [, { language: language }] = (0, $9GLBV.useTranslation)();
    const { online: online, storeData: storeData, getData: getData } = (0, $219y6.useOfflineContext)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const queryKey = [
        "digitalReception",
        {
            id: screenId,
            language: language,
            online: online
        }
    ];
    const cached = queryClient.getQueryData(queryKey);
    const pollMs = ((cached === null || cached === void 0 ? void 0 : (_cached_digitalReception = cached.digitalReception) === null || _cached_digitalReception === void 0 ? void 0 : (_cached_digitalReception_metadata = _cached_digitalReception.metadata) === null || _cached_digitalReception_metadata === void 0 ? void 0 : (_cached_digitalReception_metadata_network = _cached_digitalReception_metadata.network) === null || _cached_digitalReception_metadata_network === void 0 ? void 0 : _cached_digitalReception_metadata_network.metered) ? $284bd66a1dd98c56$var$METERED_BOARD_POLL_MINUTES : $284bd66a1dd98c56$var$BOARD_POLL_MINUTES) * 60000;
    return (0, $dMu0R.useQuery)(queryKey, async ()=>{
        try {
            const data = await (0, $jnPOB.client).request((0, $kCXUJ.QUERY_DIGITAL_RECEPTION), {
                id: screenId,
                language: language
            });
            await storeData(`/app/config/${language}`, data);
            return data;
        } catch (error) {
            const config = await getData(`/app/config/${language}`);
            return config;
        }
    }, {
        enabled: !!screenId,
        staleTime: pollMs,
        refetchInterval: pollMs,
        keepPreviousData: true
    });
};
function $284bd66a1dd98c56$export$81371f8c31556ab1() {
    var _data_digitalReception_client, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_client = _data_digitalReception.client) === null || _data_digitalReception_client === void 0 ? void 0 : _data_digitalReception_client.plan;
}
function $284bd66a1dd98c56$export$85ed839e6898dc60() {
    var _data_digitalReception_theme_images_logo, _data_digitalReception_theme_images, _data_digitalReception_theme, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_theme = _data_digitalReception.theme) === null || _data_digitalReception_theme === void 0 ? void 0 : (_data_digitalReception_theme_images = _data_digitalReception_theme.images) === null || _data_digitalReception_theme_images === void 0 ? void 0 : (_data_digitalReception_theme_images_logo = _data_digitalReception_theme_images.logo) === null || _data_digitalReception_theme_images_logo === void 0 ? void 0 : _data_digitalReception_theme_images_logo.absolutePath;
}
function $284bd66a1dd98c56$export$f47430f7ffdcc134() {
    const { data: data, dataUpdatedAt: dataUpdatedAt } = $284bd66a1dd98c56$export$5118ea9943f64521();
    // added to react to re-render when data is updated
    // this needs to be here for the preview to work in the CMS
    // dataUpdatedAt;
    return {
        welcomeMessage: (0, $jXblK.get)(data, `digitalReception.settings.layout.welcomeMessage`),
        checkin: (0, $jXblK.get)(data, "digitalReception.settings.layout.checkin"),
        integratedManualCheckin: (0, $jXblK.get)(data, "digitalReception.settings.layout.integratedManualCheckin"),
        independentManualCheckin: (0, $jXblK.get)(data, "digitalReception.settings.layout.independentManualCheckin"),
        checkout: (0, $jXblK.get)(data, "digitalReception.settings.layout.checkout"),
        manualCheckout: (0, $jXblK.get)(data, "digitalReception.settings.layout.manualCheckout"),
        packageDelivery: (0, $jXblK.get)(data, "digitalReception.settings.layout.package"),
        foodDelivery: (0, $jXblK.get)(data, "digitalReception.settings.layout.food"),
        callReception: (0, $jXblK.get)(data, "digitalReception.settings.layout.callReception"),
        overview: (0, $jXblK.get)(data, "digitalReception.settings.layout.overview"),
        wifi: (0, $jXblK.get)(data, "digitalReception.settings.layout.wifi"),
        wayfinding: (0, $jXblK.get)(data, "digitalReception.settings.layout.wayfinding"),
        multiWayfinding: (0, $jXblK.get)(data, "digitalReception.settings.layout.multiWayfinding"),
        bell: (0, $jXblK.get)(data, "digitalReception.settings.layout.bell")
    };
}
function $284bd66a1dd98c56$export$9f30821ab9eba6a3() {
    var _data_digitalReception_settings_receptionistPhone, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_receptionistPhone = _data_digitalReception_settings.receptionistPhone) === null || _data_digitalReception_settings_receptionistPhone === void 0 ? void 0 : _data_digitalReception_settings_receptionistPhone.primary;
}
function $284bd66a1dd98c56$export$62ca977f860de9c7() {
    var _data_digitalReception_settings_receptionistTeams, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_receptionistTeams = _data_digitalReception_settings.receptionistTeams) === null || _data_digitalReception_settings_receptionistTeams === void 0 ? void 0 : _data_digitalReception_settings_receptionistTeams.email;
}
const $284bd66a1dd98c56$export$2cd5f299e15b85fc = ()=>{
    var _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : _data_digitalReception_settings.deliveryReceiver;
};
const $284bd66a1dd98c56$export$626541a5c6f2cfa1 = ()=>{
    var _data_digitalReception_settings_overview, _data_digitalReception_settings, _data_digitalReception, _data_digitalReception_settings_overview1, _data_digitalReception_settings1, _data_digitalReception1, _data_digitalReception_settings_overview2, _data_digitalReception_settings2, _data_digitalReception2;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return {
        code: data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_overview = _data_digitalReception_settings.overview) === null || _data_digitalReception_settings_overview === void 0 ? void 0 : _data_digitalReception_settings_overview.code,
        openWithoutCode: (data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : (_data_digitalReception_settings1 = _data_digitalReception1.settings) === null || _data_digitalReception_settings1 === void 0 ? void 0 : (_data_digitalReception_settings_overview1 = _data_digitalReception_settings1.overview) === null || _data_digitalReception_settings_overview1 === void 0 ? void 0 : _data_digitalReception_settings_overview1.openWithoutCode) === true,
        fields: data === null || data === void 0 ? void 0 : (_data_digitalReception2 = data.digitalReception) === null || _data_digitalReception2 === void 0 ? void 0 : (_data_digitalReception_settings2 = _data_digitalReception2.settings) === null || _data_digitalReception_settings2 === void 0 ? void 0 : (_data_digitalReception_settings_overview2 = _data_digitalReception_settings2.overview) === null || _data_digitalReception_settings_overview2 === void 0 ? void 0 : _data_digitalReception_settings_overview2.fields
    };
};
const $284bd66a1dd98c56$export$765324f4cccd6e12 = ()=>{
    var _data_digitalReception_settings_animations, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_animations = _data_digitalReception_settings.animations) === null || _data_digitalReception_settings_animations === void 0 ? void 0 : _data_digitalReception_settings_animations.enabled;
};
const $284bd66a1dd98c56$export$c206a6020e5e0cc8 = ()=>{
    var _data_digitalReception_settings_printing, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return !!(data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_printing = _data_digitalReception_settings.printing) === null || _data_digitalReception_settings_printing === void 0 ? void 0 : _data_digitalReception_settings_printing.enabled);
};
const $284bd66a1dd98c56$export$dfbb4c7cd62d88d3 = ()=>{
    var _data_digitalReception_settings_printing, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_printing = _data_digitalReception_settings.printing) === null || _data_digitalReception_settings_printing === void 0 ? void 0 : _data_digitalReception_settings_printing.printer;
};
const $284bd66a1dd98c56$export$2f7da685ae073b68 = ()=>{
    var _data_digitalReception_settings_printing, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_printing = _data_digitalReception_settings.printing) === null || _data_digitalReception_settings_printing === void 0 ? void 0 : _data_digitalReception_settings_printing.label;
};
const $284bd66a1dd98c56$export$43b49132ff30c8a3 = ()=>{
    var _data_digitalReception_settings_wifi, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_wifi = _data_digitalReception_settings.wifi) === null || _data_digitalReception_settings_wifi === void 0 ? void 0 : _data_digitalReception_settings_wifi.qrCode;
};
const $284bd66a1dd98c56$export$4db579901265d63c = ()=>{
    var _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const call = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : _data_digitalReception_settings.call;
    return {
        ringDuration: (call === null || call === void 0 ? void 0 : call.ringDuration) || 30,
        maxDuration: (call === null || call === void 0 ? void 0 : call.maxDuration) || null
    };
};
const $284bd66a1dd98c56$export$ebd4152617a83c60 = ()=>{
    var _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : _data_digitalReception_settings.clock;
};
const $284bd66a1dd98c56$export$ea9c10744d0b37bf = ()=>{
    var _data_digitalReception_building, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_building = _data_digitalReception.building) === null || _data_digitalReception_building === void 0 ? void 0 : _data_digitalReception_building.country;
};
const $284bd66a1dd98c56$export$9da223f01d1173b2 = ()=>{
    var _integratedManualCheckin_registration_fields_find, _integratedManualCheckin_registration, _independentManualCheckin_registration_fields_find, _independentManualCheckin_registration;
    const { integratedManualCheckin: integratedManualCheckin, independentManualCheckin: independentManualCheckin } = $284bd66a1dd98c56$export$f47430f7ffdcc134();
    let manualCheckoutGuestCode = "";
    if (!!(integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled)) manualCheckoutGuestCode = ((_integratedManualCheckin_registration = integratedManualCheckin.registration) === null || _integratedManualCheckin_registration === void 0 ? void 0 : (_integratedManualCheckin_registration_fields_find = _integratedManualCheckin_registration.fields.find((field)=>!!field.manualCheckoutIdentifier)) === null || _integratedManualCheckin_registration_fields_find === void 0 ? void 0 : _integratedManualCheckin_registration_fields_find.code) || "";
    if (!!(independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled)) manualCheckoutGuestCode = ((_independentManualCheckin_registration = independentManualCheckin.registration) === null || _independentManualCheckin_registration === void 0 ? void 0 : (_independentManualCheckin_registration_fields_find = _independentManualCheckin_registration.fields.find((field)=>!!field.manualCheckoutIdentifier)) === null || _independentManualCheckin_registration_fields_find === void 0 ? void 0 : _independentManualCheckin_registration_fields_find.code) || "";
    return manualCheckoutGuestCode;
};
const $284bd66a1dd98c56$export$217413e8ac4616d5 = ()=>{
    var _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.metadata) || {};
};
const $284bd66a1dd98c56$export$ef690ddae334daf8 = (action)=>{
    const metadata = $284bd66a1dd98c56$export$217413e8ac4616d5();
    return (0, $eZVvM.useMemo)(()=>{
        var _metadata_uiOverrides_home, _metadata_uiOverrides;
        const flows = (metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides = metadata.uiOverrides) === null || _metadata_uiOverrides === void 0 ? void 0 : (_metadata_uiOverrides_home = _metadata_uiOverrides.home) === null || _metadata_uiOverrides_home === void 0 ? void 0 : _metadata_uiOverrides_home.flows) || {};
        const actions = action ? [
            action
        ] : Object.keys(flows);
        return actions.flatMap((key)=>{
            var _flows_key;
            return ((_flows_key = flows[key]) === null || _flows_key === void 0 ? void 0 : _flows_key.extraButtons) || [];
        }).filter((button)=>!!(button === null || button === void 0 ? void 0 : button.id) && button.enabled !== false && (button.action || "call") === "call");
    }, [
        metadata,
        action
    ]);
};
function $284bd66a1dd98c56$export$6fe02dcc2001dcb0() {
    var _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.teams;
}
function $284bd66a1dd98c56$export$b9860d4c881dec49() {
    var _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.googleChat;
}
const $284bd66a1dd98c56$export$51a6f7090a10ba7b = ()=>{
    var _data_digitalReception_settings_photoCapture, _data_digitalReception_settings, _data_digitalReception, _data_digitalReception_settings_photoCapture_employee, _data_digitalReception_settings_photoCapture1, _data_digitalReception_settings1, _data_digitalReception1, _data_digitalReception_settings_photoCapture_employee1, _data_digitalReception_settings_photoCapture2, _data_digitalReception_settings2, _data_digitalReception2, _data_digitalReception_settings_photoCapture_visitor, _data_digitalReception_settings_photoCapture3, _data_digitalReception_settings3, _data_digitalReception3, _data_digitalReception_settings_photoCapture_visitor1, _data_digitalReception_settings_photoCapture4, _data_digitalReception_settings4, _data_digitalReception4, _data_digitalReception_settings_photoCapture_meetingAttendee, _data_digitalReception_settings_photoCapture5, _data_digitalReception_settings5, _data_digitalReception5, _data_digitalReception_settings_photoCapture_meetingAttendee1, _data_digitalReception_settings_photoCapture6, _data_digitalReception_settings6, _data_digitalReception6;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const isPhotoCaptureEnabled = (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture = _data_digitalReception_settings.photoCapture) === null || _data_digitalReception_settings_photoCapture === void 0 ? void 0 : _data_digitalReception_settings_photoCapture.enabled) || false;
    return {
        isPhotoCaptureEnabled: isPhotoCaptureEnabled,
        isPhotoCaptureAllowedForEmployees: isPhotoCaptureEnabled && (data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : (_data_digitalReception_settings1 = _data_digitalReception1.settings) === null || _data_digitalReception_settings1 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture1 = _data_digitalReception_settings1.photoCapture) === null || _data_digitalReception_settings_photoCapture1 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_employee = _data_digitalReception_settings_photoCapture1.employee) === null || _data_digitalReception_settings_photoCapture_employee === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_employee.enabled) || false,
        isPhotoCaptureRequiredForEmployees: (data === null || data === void 0 ? void 0 : (_data_digitalReception2 = data.digitalReception) === null || _data_digitalReception2 === void 0 ? void 0 : (_data_digitalReception_settings2 = _data_digitalReception2.settings) === null || _data_digitalReception_settings2 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture2 = _data_digitalReception_settings2.photoCapture) === null || _data_digitalReception_settings_photoCapture2 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_employee1 = _data_digitalReception_settings_photoCapture2.employee) === null || _data_digitalReception_settings_photoCapture_employee1 === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_employee1.required) || false,
        isPhotoCaptureAllowedForVisitors: isPhotoCaptureEnabled && (data === null || data === void 0 ? void 0 : (_data_digitalReception3 = data.digitalReception) === null || _data_digitalReception3 === void 0 ? void 0 : (_data_digitalReception_settings3 = _data_digitalReception3.settings) === null || _data_digitalReception_settings3 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture3 = _data_digitalReception_settings3.photoCapture) === null || _data_digitalReception_settings_photoCapture3 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_visitor = _data_digitalReception_settings_photoCapture3.visitor) === null || _data_digitalReception_settings_photoCapture_visitor === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_visitor.enabled) || false,
        isPhotoCaptureRequiredForVisitors: (data === null || data === void 0 ? void 0 : (_data_digitalReception4 = data.digitalReception) === null || _data_digitalReception4 === void 0 ? void 0 : (_data_digitalReception_settings4 = _data_digitalReception4.settings) === null || _data_digitalReception_settings4 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture4 = _data_digitalReception_settings4.photoCapture) === null || _data_digitalReception_settings_photoCapture4 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_visitor1 = _data_digitalReception_settings_photoCapture4.visitor) === null || _data_digitalReception_settings_photoCapture_visitor1 === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_visitor1.required) || false,
        isPhotoCaptureAllowedForMeetingAttendees: isPhotoCaptureEnabled && (data === null || data === void 0 ? void 0 : (_data_digitalReception5 = data.digitalReception) === null || _data_digitalReception5 === void 0 ? void 0 : (_data_digitalReception_settings5 = _data_digitalReception5.settings) === null || _data_digitalReception_settings5 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture5 = _data_digitalReception_settings5.photoCapture) === null || _data_digitalReception_settings_photoCapture5 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_meetingAttendee = _data_digitalReception_settings_photoCapture5.meetingAttendee) === null || _data_digitalReception_settings_photoCapture_meetingAttendee === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_meetingAttendee.enabled) || false,
        isPhotoCaptureRequiredForMeetingAttendees: (data === null || data === void 0 ? void 0 : (_data_digitalReception6 = data.digitalReception) === null || _data_digitalReception6 === void 0 ? void 0 : (_data_digitalReception_settings6 = _data_digitalReception6.settings) === null || _data_digitalReception_settings6 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture6 = _data_digitalReception_settings6.photoCapture) === null || _data_digitalReception_settings_photoCapture6 === void 0 ? void 0 : (_data_digitalReception_settings_photoCapture_meetingAttendee1 = _data_digitalReception_settings_photoCapture6.meetingAttendee) === null || _data_digitalReception_settings_photoCapture_meetingAttendee1 === void 0 ? void 0 : _data_digitalReception_settings_photoCapture_meetingAttendee1.required) || false
    };
};
const $284bd66a1dd98c56$export$829d946e99f8d268 = ()=>{
    var _data_digitalReception_settings_contactPreview, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_contactPreview = _data_digitalReception_settings.contactPreview) === null || _data_digitalReception_settings_contactPreview === void 0 ? void 0 : _data_digitalReception_settings_contactPreview.enabled;
};
function $284bd66a1dd98c56$export$ba091297bf0eae5b() {
    var _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.communicationProvider) || "twilio";
}
const $284bd66a1dd98c56$export$269361b4830f2dc8 = ()=>{
    var _data_digitalReception_settings_teamsVideoCall, _data_digitalReception_settings, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_teamsVideoCall = _data_digitalReception_settings.teamsVideoCall) === null || _data_digitalReception_settings_teamsVideoCall === void 0 ? void 0 : _data_digitalReception_settings_teamsVideoCall.enabled) || false;
};
function $284bd66a1dd98c56$export$a2b328c88e72739f() {
    var _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.code) || "";
}
const $284bd66a1dd98c56$export$8101ba2cbec55e2b = ()=>{
    var _data_digitalReception_client_preferences, _data_digitalReception, _data_digitalReception_settings, _data_digitalReception1, _data_digitalReception_client_preferences1, _data_digitalReception2, _data_digitalReception_settings1, _data_digitalReception3, _settings_checkin, _settings_checkout, _settings_checkin1, _settings_checkout1;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const shellyPrefs = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_client_preferences = _data_digitalReception.client.preferences) === null || _data_digitalReception_client_preferences === void 0 ? void 0 : _data_digitalReception_client_preferences.shelly;
    const shellySettings = data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception1.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : _data_digitalReception_settings.shelly;
    const tuyaPrefs = data === null || data === void 0 ? void 0 : (_data_digitalReception2 = data.digitalReception) === null || _data_digitalReception2 === void 0 ? void 0 : (_data_digitalReception_client_preferences1 = _data_digitalReception2.client.preferences) === null || _data_digitalReception_client_preferences1 === void 0 ? void 0 : _data_digitalReception_client_preferences1.tuya;
    const tuyaSettings = data === null || data === void 0 ? void 0 : (_data_digitalReception3 = data.digitalReception) === null || _data_digitalReception3 === void 0 ? void 0 : (_data_digitalReception_settings1 = _data_digitalReception3.settings) === null || _data_digitalReception_settings1 === void 0 ? void 0 : _data_digitalReception_settings1.tuya;
    const isShellyEnabled = !!((shellyPrefs === null || shellyPrefs === void 0 ? void 0 : shellyPrefs.enabled) && (shellySettings === null || shellySettings === void 0 ? void 0 : shellySettings.enabled) && (shellySettings === null || shellySettings === void 0 ? void 0 : shellySettings.controller));
    const isTuyaEnabled = !!((tuyaPrefs === null || tuyaPrefs === void 0 ? void 0 : tuyaPrefs.enabled) && (tuyaSettings === null || tuyaSettings === void 0 ? void 0 : tuyaSettings.enabled) && (tuyaSettings === null || tuyaSettings === void 0 ? void 0 : tuyaSettings.controller));
    let activeAccess = null;
    if (isShellyEnabled) activeAccess = "shelly";
    else if (isTuyaEnabled) activeAccess = "tuya";
    const settingsMap = {
        shelly: shellySettings,
        tuya: tuyaSettings
    };
    const settings = activeAccess ? settingsMap[activeAccess] : null;
    const isAccessEnabled = !!activeAccess;
    const isAccessEnabledForCheckin = !!(isAccessEnabled && (settings === null || settings === void 0 ? void 0 : (_settings_checkin = settings.checkin) === null || _settings_checkin === void 0 ? void 0 : _settings_checkin.enabled));
    const isAccessEnabledForCheckout = !!(isAccessEnabled && (settings === null || settings === void 0 ? void 0 : (_settings_checkout = settings.checkout) === null || _settings_checkout === void 0 ? void 0 : _settings_checkout.enabled));
    const allowedFor = (flow, role)=>{
        var _settings_flow, _settings_flow_role, _settings_flow1;
        return !!(isAccessEnabled && (settings === null || settings === void 0 ? void 0 : (_settings_flow = settings[flow]) === null || _settings_flow === void 0 ? void 0 : _settings_flow.enabled) && (settings === null || settings === void 0 ? void 0 : (_settings_flow1 = settings[flow]) === null || _settings_flow1 === void 0 ? void 0 : (_settings_flow_role = _settings_flow1[role]) === null || _settings_flow_role === void 0 ? void 0 : _settings_flow_role.enabled));
    };
    return {
        isAccessEnabled: isAccessEnabled,
        activeAccess: activeAccess,
        accessController: settings === null || settings === void 0 ? void 0 : settings.controller,
        isAccessEnabledForCheckin: // check-in
        isAccessEnabledForCheckin,
        isAccessEnabledForAutoOpenForCheckin: isAccessEnabledForCheckin && (settings === null || settings === void 0 ? void 0 : (_settings_checkin1 = settings.checkin) === null || _settings_checkin1 === void 0 ? void 0 : _settings_checkin1.autoSwitch),
        isAccessAllowedForEmployeesForCheckin: allowedFor("checkin", "employee"),
        isAccessAllowedForVisitorsForCheckin: allowedFor("checkin", "visitor"),
        isAccessAllowedForGuestsForCheckin: allowedFor("checkin", "guest"),
        isAccessAllowedForMeetingAttendeesForCheckin: allowedFor("checkin", "meetingAttendee"),
        isAccessEnabledForCheckout: // check-out
        isAccessEnabledForCheckout,
        isAccessEnabledForAutoOpenForCheckout: isAccessEnabledForCheckout && (settings === null || settings === void 0 ? void 0 : (_settings_checkout1 = settings.checkout) === null || _settings_checkout1 === void 0 ? void 0 : _settings_checkout1.autoSwitch),
        isAccessAllowedForEmployeesForCheckout: allowedFor("checkout", "employee"),
        isAccessAllowedForVisitorsForCheckout: allowedFor("checkout", "visitor"),
        isAccessAllowedForGuestsForCheckout: allowedFor("checkout", "guest"),
        isAccessAllowedForMeetingAttendeesForCheckout: allowedFor("checkout", "meetingAttendee")
    };
};
const $284bd66a1dd98c56$export$2352626cd3b3bbb4 = ()=>{
    var _data_digitalReception_settings, _data_digitalReception, _scanner_autoScan, _scanner_autoScan1, _scanner_autoScan2;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const scanner = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : _data_digitalReception_settings.scanner;
    const isHidScannerActive = (scanner === null || scanner === void 0 ? void 0 : scanner.enabled) || false;
    const isHidAutoScanEnabled = (scanner === null || scanner === void 0 ? void 0 : (_scanner_autoScan = scanner.autoScan) === null || _scanner_autoScan === void 0 ? void 0 : _scanner_autoScan.enabled) || false;
    const hidAutoScanType = (scanner === null || scanner === void 0 ? void 0 : (_scanner_autoScan1 = scanner.autoScan) === null || _scanner_autoScan1 === void 0 ? void 0 : _scanner_autoScan1.type) || "CHECKIN_AND_CHECKOUT";
    const isOnlyQrScannerMode = isHidAutoScanEnabled && ((scanner === null || scanner === void 0 ? void 0 : (_scanner_autoScan2 = scanner.autoScan) === null || _scanner_autoScan2 === void 0 ? void 0 : _scanner_autoScan2.onlyQrScanner) || false);
    return {
        isHidScannerActive: isHidScannerActive,
        isHidAutoScanEnabled: isHidAutoScanEnabled,
        hidAutoScanType: hidAutoScanType,
        isOnlyQrScannerMode: isOnlyQrScannerMode
    };
};
const $284bd66a1dd98c56$export$872df4c3b321bd72 = ()=>{
    var _data_digitalReception_metadata, _data_digitalReception;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const config = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_metadata = _data_digitalReception.metadata) === null || _data_digitalReception_metadata === void 0 ? void 0 : _data_digitalReception_metadata.socketScanner;
    const socketUrl = config === null || config === void 0 ? void 0 : config.socketUrl;
    const isSocketScannerAllowedForCheckin = !!(config === null || config === void 0 ? void 0 : config.checkinEnabled);
    const isSocketScannerAllowedForCheckout = !!(config === null || config === void 0 ? void 0 : config.checkoutEnabled);
    const isSocketScannerActive = !!socketUrl && (isSocketScannerAllowedForCheckin || isSocketScannerAllowedForCheckout);
    return {
        socketUrl: socketUrl,
        isSocketScannerAllowedForCheckin: isSocketScannerAllowedForCheckin,
        isSocketScannerAllowedForCheckout: isSocketScannerAllowedForCheckout,
        isSocketScannerActive: isSocketScannerActive
    };
};
const $284bd66a1dd98c56$export$c602d8befffd9f50 = ()=>{
    var _data_digitalReception_client_preferences_documentScanner, _data_digitalReception_client_preferences, _data_digitalReception_client, _data_digitalReception, _data_digitalReception_settings_documentScanner, _data_digitalReception_settings, _data_digitalReception1, _data_digitalReception_settings1, _data_digitalReception2;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const isDocumentScannerEnabled = !!((data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_client = _data_digitalReception.client) === null || _data_digitalReception_client === void 0 ? void 0 : (_data_digitalReception_client_preferences = _data_digitalReception_client.preferences) === null || _data_digitalReception_client_preferences === void 0 ? void 0 : (_data_digitalReception_client_preferences_documentScanner = _data_digitalReception_client_preferences.documentScanner) === null || _data_digitalReception_client_preferences_documentScanner === void 0 ? void 0 : _data_digitalReception_client_preferences_documentScanner.enabled) && (data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception1.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_documentScanner = _data_digitalReception_settings.documentScanner) === null || _data_digitalReception_settings_documentScanner === void 0 ? void 0 : _data_digitalReception_settings_documentScanner.enabled));
    const { enabled: enabled, ...fields } = (data === null || data === void 0 ? void 0 : (_data_digitalReception2 = data.digitalReception) === null || _data_digitalReception2 === void 0 ? void 0 : (_data_digitalReception_settings1 = _data_digitalReception2.settings) === null || _data_digitalReception_settings1 === void 0 ? void 0 : _data_digitalReception_settings1.documentScanner) || {};
    return {
        isDocumentScannerEnabled: isDocumentScannerEnabled,
        fields: fields
    };
};
const $284bd66a1dd98c56$export$ca4897d23e28f7a5 = ()=>{
    var _data_digitalReception_settings_nfc, _data_digitalReception_settings, _data_digitalReception, _data_digitalReception_settings_nfc1, _data_digitalReception_settings1, _data_digitalReception1;
    const { data: data } = $284bd66a1dd98c56$export$5118ea9943f64521();
    const isNfcScannerEnabled = (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_settings = _data_digitalReception.settings) === null || _data_digitalReception_settings === void 0 ? void 0 : (_data_digitalReception_settings_nfc = _data_digitalReception_settings.nfc) === null || _data_digitalReception_settings_nfc === void 0 ? void 0 : _data_digitalReception_settings_nfc.enabled) || false;
    const nfcScannerSocketUrl = data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : (_data_digitalReception_settings1 = _data_digitalReception1.settings) === null || _data_digitalReception_settings1 === void 0 ? void 0 : (_data_digitalReception_settings_nfc1 = _data_digitalReception_settings1.nfc) === null || _data_digitalReception_settings_nfc1 === void 0 ? void 0 : _data_digitalReception_settings_nfc1.socketUrl;
    const isNfcScannerActive = isNfcScannerEnabled && !!nfcScannerSocketUrl;
    return {
        isNfcScannerEnabled: isNfcScannerEnabled,
        nfcScannerSocketUrl: nfcScannerSocketUrl,
        isNfcScannerActive: isNfcScannerActive
    };
};
var $284bd66a1dd98c56$export$2e2bcd8739ae039 = $284bd66a1dd98c56$export$5118ea9943f64521;

});
parcelRegister("dMu0R", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $f3477643ab9132fd$export$dd0a697e1782aedd; });

var $g3yHX = parcelRequire("g3yHX");
var $fM1qe = parcelRequire("fM1qe");

var $1DNFb = parcelRequire("1DNFb");
"use client";
function $f3477643ab9132fd$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $1DNFb.useBaseQuery)(parsedOptions, (0, $fM1qe.QueryObserver));
}

});
parcelRegister("g3yHX", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $ba1711d24f3cec9f$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $ba1711d24f3cec9f$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $ba1711d24f3cec9f$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $ba1711d24f3cec9f$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $ba1711d24f3cec9f$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $ba1711d24f3cec9f$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $ba1711d24f3cec9f$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $ba1711d24f3cec9f$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $ba1711d24f3cec9f$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $ba1711d24f3cec9f$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $ba1711d24f3cec9f$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $ba1711d24f3cec9f$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $ba1711d24f3cec9f$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $ba1711d24f3cec9f$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $ba1711d24f3cec9f$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $ba1711d24f3cec9f$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $ba1711d24f3cec9f$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $ba1711d24f3cec9f$export$17619bac5b909b23; });
// TYPES
// UTILS
const $ba1711d24f3cec9f$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $ba1711d24f3cec9f$export$8793edee2d425525() {
    return undefined;
}
function $ba1711d24f3cec9f$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $ba1711d24f3cec9f$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $ba1711d24f3cec9f$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $ba1711d24f3cec9f$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $ba1711d24f3cec9f$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $ba1711d24f3cec9f$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $ba1711d24f3cec9f$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $ba1711d24f3cec9f$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $ba1711d24f3cec9f$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $ba1711d24f3cec9f$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $ba1711d24f3cec9f$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $ba1711d24f3cec9f$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$ba1711d24f3cec9f$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $ba1711d24f3cec9f$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($ba1711d24f3cec9f$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($ba1711d24f3cec9f$export$5fcb678681417b54(mutation.options.mutationKey) !== $ba1711d24f3cec9f$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$ba1711d24f3cec9f$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $ba1711d24f3cec9f$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $ba1711d24f3cec9f$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $ba1711d24f3cec9f$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$ba1711d24f3cec9f$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $ba1711d24f3cec9f$export$2f07189bb9fa26a7(a, b) {
    return $ba1711d24f3cec9f$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $ba1711d24f3cec9f$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$ba1711d24f3cec9f$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $ba1711d24f3cec9f$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $ba1711d24f3cec9f$export$7a8558113332b71e(a) && $ba1711d24f3cec9f$export$7a8558113332b71e(b);
    if (array || $ba1711d24f3cec9f$export$53b83ca8eaab0383(a) && $ba1711d24f3cec9f$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $ba1711d24f3cec9f$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $ba1711d24f3cec9f$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $ba1711d24f3cec9f$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $ba1711d24f3cec9f$export$53b83ca8eaab0383(o) {
    if (!$ba1711d24f3cec9f$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$ba1711d24f3cec9f$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $ba1711d24f3cec9f$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $ba1711d24f3cec9f$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $ba1711d24f3cec9f$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $ba1711d24f3cec9f$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $ba1711d24f3cec9f$export$4304cb76768ca134(callback) {
    $ba1711d24f3cec9f$export$e772c8ff12451969(0).then(callback);
}
function $ba1711d24f3cec9f$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $ba1711d24f3cec9f$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $ba1711d24f3cec9f$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("fM1qe", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $e9731b8b751e5a7c$export$a06cf8c0066f0d4c; });

var $g3yHX = parcelRequire("g3yHX");

var $bq3DV = parcelRequire("bq3DV");

var $aQMrm = parcelRequire("aQMrm");

var $4QcTI = parcelRequire("4QcTI");

var $lodjx = parcelRequire("lodjx");
class $e9731b8b751e5a7c$export$a06cf8c0066f0d4c extends (0, $4QcTI.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($e9731b8b751e5a7c$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $e9731b8b751e5a7c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $e9731b8b751e5a7c$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $g3yHX.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $e9731b8b751e5a7c$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($e9731b8b751e5a7c$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $g3yHX.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $g3yHX.isServer) || this.currentResult.isStale || !(0, $g3yHX.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $g3yHX.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $g3yHX.isServer) || this.options.enabled === false || !(0, $g3yHX.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $aQMrm.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $e9731b8b751e5a7c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $e9731b8b751e5a7c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $lodjx.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $g3yHX.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $g3yHX.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $e9731b8b751e5a7c$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $g3yHX.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $lodjx.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $bq3DV.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $e9731b8b751e5a7c$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $e9731b8b751e5a7c$var$shouldFetchOnMount(query, options) {
    return $e9731b8b751e5a7c$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $e9731b8b751e5a7c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $e9731b8b751e5a7c$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $e9731b8b751e5a7c$var$isStale(query, options);
    }
    return false;
}
function $e9731b8b751e5a7c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $e9731b8b751e5a7c$var$isStale(query, options);
}
function $e9731b8b751e5a7c$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $e9731b8b751e5a7c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $g3yHX.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});
parcelRegister("bq3DV", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $b0290676e0263165$export$520687f44db6e1ab; });

var $g3yHX = parcelRequire("g3yHX");
function $b0290676e0263165$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $g3yHX.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $g3yHX.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $b0290676e0263165$export$520687f44db6e1ab = $b0290676e0263165$export$316a8efd03cd1458();

});

parcelRegister("aQMrm", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $c3a85528c3e1f733$export$6bf54661be5b02cf; });

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
class $c3a85528c3e1f733$export$86f1af424b2ca4de extends (0, $4QcTI.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $g3yHX.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
}
const $c3a85528c3e1f733$export$6bf54661be5b02cf = new $c3a85528c3e1f733$export$86f1af424b2ca4de();

});
parcelRegister("4QcTI", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $ae7fab194a0bd0f0$export$d26086b469ecdbcc; });
class $ae7fab194a0bd0f0$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

});


parcelRegister("lodjx", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $b44fbc2359bc526e$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $b44fbc2359bc526e$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $b44fbc2359bc526e$export$2cbd00fe8a2c8d85; });

var $aQMrm = parcelRequire("aQMrm");

var $6lhov = parcelRequire("6lhov");

var $g3yHX = parcelRequire("g3yHX");
function $b44fbc2359bc526e$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $b44fbc2359bc526e$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $6lhov.onlineManager).isOnline() : true;
}
class $b44fbc2359bc526e$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $b44fbc2359bc526e$export$986cc6445c1d323(value) {
    return value instanceof $b44fbc2359bc526e$export$a8430ed4188f35a9;
}
function $b44fbc2359bc526e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $b44fbc2359bc526e$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $aQMrm.focusManager).isFocused() || config.networkMode !== "always" && !(0, $6lhov.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $b44fbc2359bc526e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $g3yHX.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($b44fbc2359bc526e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("6lhov", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $e7b8d779d24bc673$export$b113e788b2dd3fdc; });

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
const $e7b8d779d24bc673$var$onlineEvents = [
    "online",
    "offline"
];
class $e7b8d779d24bc673$export$58774fb55d5ff7fc extends (0, $4QcTI.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $g3yHX.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $e7b8d779d24bc673$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $e7b8d779d24bc673$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $e7b8d779d24bc673$export$b113e788b2dd3fdc = new $e7b8d779d24bc673$export$58774fb55d5ff7fc();

});



parcelRegister("1DNFb", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $d5da050c930796de$export$fff0865807e996c5; });

var $eZVvM = parcelRequire("eZVvM");

var $bq3DV = parcelRequire("bq3DV");

var $l7YCt = parcelRequire("l7YCt");

var $2bmJH = parcelRequire("2bmJH");

var $gdPnm = parcelRequire("gdPnm");

var $j2xBj = parcelRequire("j2xBj");

var $2rBQf = parcelRequire("2rBQf");

var $9g6md = parcelRequire("9g6md");
"use client";
function $d5da050c930796de$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $gdPnm.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $j2xBj.useIsRestoring)();
    const errorResetBoundary = (0, $2bmJH.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $bq3DV.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $9g6md.ensureStaleTime)(defaultedOptions);
    (0, $2rBQf.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2rBQf.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $eZVvM.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $l7YCt.useSyncExternalStore)($eZVvM.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $bq3DV.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $eZVvM.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $9g6md.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $9g6md.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2rBQf.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("l7YCt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $774bf12fc2dddcb2$export$306c0aa65ff9ec16; });

var $7Vn1d = parcelRequire("7Vn1d");
"use client";
const $774bf12fc2dddcb2$export$306c0aa65ff9ec16 = (0, $7Vn1d.useSyncExternalStore);

});
parcelRegister("7Vn1d", function(module, exports) {
"use strict";

module.exports = (parcelRequire("brkeu"));

});


parcelRegister("2bmJH", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $4b19e984a279dd74$export$50dfac555130cafd; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
function $4b19e984a279dd74$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $4b19e984a279dd74$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $eZVvM.createContext($4b19e984a279dd74$var$createValue()); // HOOK
const $4b19e984a279dd74$export$50dfac555130cafd = ()=>$eZVvM.useContext($4b19e984a279dd74$var$QueryErrorResetBoundaryContext); // COMPONENT
const $4b19e984a279dd74$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $eZVvM.useState(()=>$4b19e984a279dd74$var$createValue());
    return /*#__PURE__*/ $eZVvM.createElement($4b19e984a279dd74$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRegister("gdPnm", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $f811184975d3f387$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $f811184975d3f387$export$45604f0cc8ae667b; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $f811184975d3f387$export$2fba198b5b2e37fa = /*#__PURE__*/ $eZVvM.createContext(undefined);
const $f811184975d3f387$var$QueryClientSharingContext = /*#__PURE__*/ $eZVvM.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $f811184975d3f387$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $f811184975d3f387$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $f811184975d3f387$export$2fba198b5b2e37fa;
}
const $f811184975d3f387$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $eZVvM.useContext($f811184975d3f387$var$getQueryClientContext(context, $eZVvM.useContext($f811184975d3f387$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $f811184975d3f387$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $eZVvM.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $f811184975d3f387$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $eZVvM.createElement($f811184975d3f387$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $eZVvM.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("j2xBj", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $49487944b51be185$export$4da0178d6b5f553; });

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $49487944b51be185$var$IsRestoringContext = /*#__PURE__*/ $eZVvM.createContext(false);
const $49487944b51be185$export$4da0178d6b5f553 = ()=>$eZVvM.useContext($49487944b51be185$var$IsRestoringContext);
const $49487944b51be185$export$593807d4e94f9621 = $49487944b51be185$var$IsRestoringContext.Provider;

});

parcelRegister("2rBQf", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $461ec4f7a42e2a45$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $461ec4f7a42e2a45$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $461ec4f7a42e2a45$export$1fbcf724762d607; });

var $eZVvM = parcelRequire("eZVvM");

var $gCLDX = parcelRequire("gCLDX");
"use client";
const $461ec4f7a42e2a45$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $461ec4f7a42e2a45$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $eZVvM.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $461ec4f7a42e2a45$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $gCLDX.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("gCLDX", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $cc480274c2f0a0dc$export$2072f68e6c3507cf; });
function $cc480274c2f0a0dc$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("9g6md", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $9250632acfb0dd13$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $9250632acfb0dd13$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $9250632acfb0dd13$export$defdc11a9c9acfcf; });
const $9250632acfb0dd13$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $9250632acfb0dd13$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $9250632acfb0dd13$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $9250632acfb0dd13$export$e0a3f29513afe430(result, isRestoring);
const $9250632acfb0dd13$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("4NAAR", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("iUQ9M")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("9GLBV")).useTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("9yd0C")).initReactI18next; });

var $iUQ9M = parcelRequire("iUQ9M");

var $93vPE = parcelRequire("93vPE");

var $9GLBV = parcelRequire("9GLBV");

var $kyRf9 = parcelRequire("kyRf9");

var $fJ8IM = parcelRequire("fJ8IM");

var $jAKxm = parcelRequire("jAKxm");

var $8jA9R = parcelRequire("8jA9R");

var $6X3fC = parcelRequire("6X3fC");

var $9yd0C = parcelRequire("9yd0C");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");

var $kntWR = parcelRequire("kntWR");
var $37e81fbe123e81d5$export$324d90190a8b822a = function date() {
    return "";
};
var $37e81fbe123e81d5$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $37e81fbe123e81d5$export$98e628dec113755e = function number() {
    return "";
};
var $37e81fbe123e81d5$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $37e81fbe123e81d5$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $37e81fbe123e81d5$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};

});
parcelRegister("iUQ9M", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $dc55ea30a4790efa$export$8d6a9236f2e3f2ce; });

var $d4P6P = parcelRequire("d4P6P");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $93vPE = parcelRequire("93vPE");
parcelRequire("kntWR");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");
var $dc55ea30a4790efa$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $dc55ea30a4790efa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc55ea30a4790efa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc55ea30a4790efa$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc55ea30a4790efa$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc55ea30a4790efa$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $5ZjiC.default)(_ref, $dc55ea30a4790efa$var$_excluded);
    var _ref2 = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $93vPE.Trans)($dc55ea30a4790efa$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}

});
parcelRegister("5ZjiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45c19eaf785d6b06$export$2e2bcd8739ae039; });

var $7Z8DW = parcelRequire("7Z8DW");
function $45c19eaf785d6b06$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $7Z8DW.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("93vPE", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $697d1610cfaf9539$export$8d6a9236f2e3f2ce; });

var $5ZjiC = parcelRequire("5ZjiC");

var $d48On = parcelRequire("d48On");

var $d4P6P = parcelRequire("d4P6P");

var $eZVvM = parcelRequire("eZVvM");

var $2iXoq = parcelRequire("2iXoq");

var $2vBHm = parcelRequire("2vBHm");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");
var $697d1610cfaf9539$var$_excluded = [
    "format"
], $697d1610cfaf9539$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $697d1610cfaf9539$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $697d1610cfaf9539$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $697d1610cfaf9539$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $697d1610cfaf9539$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $697d1610cfaf9539$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $697d1610cfaf9539$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $697d1610cfaf9539$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $eZVvM.isValidElement)(child);
    });
}
function $697d1610cfaf9539$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $697d1610cfaf9539$var$mergeProps(source, target) {
    var newTarget = $697d1610cfaf9539$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $697d1610cfaf9539$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $697d1610cfaf9539$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $eZVvM.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $697d1610cfaf9539$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $2vBHm.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $d48On.default)(child) === "object") {
            var format = child.format, clone = (0, $5ZjiC.default)(child, $697d1610cfaf9539$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $2vBHm.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $2vBHm.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $697d1610cfaf9539$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $697d1610cfaf9539$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($697d1610cfaf9539$var$hasChildren(child)) getData($697d1610cfaf9539$var$getChildren(child));
            else if ((0, $d48On.default)(child) === "object" && !(0, $eZVvM.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $2iXoq.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $697d1610cfaf9539$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $697d1610cfaf9539$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $697d1610cfaf9539$var$getAsArray(reactNode);
        var astNodes = $697d1610cfaf9539$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $697d1610cfaf9539$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $eZVvM.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $697d1610cfaf9539$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $d48On.default)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $d48On.default)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($697d1610cfaf9539$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $eZVvM.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $eZVvM.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $d48On.default)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $eZVvM.cloneElement)(child, $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $eZVvM.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $697d1610cfaf9539$var$getAsArray(children || []));
    return $697d1610cfaf9539$var$getChildren(result[0]);
}
function $697d1610cfaf9539$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $5ZjiC.default)(_ref, $697d1610cfaf9539$var$_excluded2);
    var i18n = i18nFromProps || (0, $fGjmH.getI18n)();
    if (!i18n) {
        (0, $2vBHm.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, (0, $bcyLK.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $697d1610cfaf9539$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread($697d1610cfaf9539$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $697d1610cfaf9539$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $eZVvM.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRegister("2iXoq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1adb5566e5d8b266$export$2e2bcd8739ae039; });

var $1b5eE = parcelRequire("1b5eE");
var $1adb5566e5d8b266$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $1adb5566e5d8b266$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($1b5eE)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($1adb5566e5d8b266$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $1adb5566e5d8b266$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $1adb5566e5d8b266$var$i = /^\s*$/, $1adb5566e5d8b266$var$s = Object.create(null);
function $1adb5566e5d8b266$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($1adb5566e5d8b266$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $1adb5566e5d8b266$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $1adb5566e5d8b266$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($1adb5566e5d8b266$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $1adb5566e5d8b266$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $1adb5566e5d8b266$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $1adb5566e5d8b266$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $1adb5566e5d8b266$var$a("", t);
        }, "");
    }
};
var $1adb5566e5d8b266$export$2e2bcd8739ae039 = $1adb5566e5d8b266$var$c;

});
parcelRegister("1b5eE", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRegister("2vBHm", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $1d3bb823911155af$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $1d3bb823911155af$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $1d3bb823911155af$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $1d3bb823911155af$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $1d3bb823911155af$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $1d3bb823911155af$export$be63e0664592e141; });
function $1d3bb823911155af$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $1d3bb823911155af$var$alreadyWarned = {};
function $1d3bb823911155af$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $1d3bb823911155af$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $1d3bb823911155af$var$alreadyWarned[args[0]] = new Date();
    $1d3bb823911155af$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $1d3bb823911155af$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $1d3bb823911155af$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $1d3bb823911155af$var$loadedClb(i18n, cb));
}
function $1d3bb823911155af$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $1d3bb823911155af$var$loadedClb(i18n, cb));
}
function $1d3bb823911155af$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $1d3bb823911155af$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $1d3bb823911155af$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $1d3bb823911155af$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $1d3bb823911155af$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRegister("bcyLK", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $827bc923f0c9e9c0$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $827bc923f0c9e9c0$export$212bb2fc580a90a8; });

var $d4P6P = parcelRequire("d4P6P");

var $7x6uV = parcelRequire("7x6uV");
function $827bc923f0c9e9c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $827bc923f0c9e9c0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $827bc923f0c9e9c0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $827bc923f0c9e9c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $827bc923f0c9e9c0$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $7x6uV.unescape)
};
function $827bc923f0c9e9c0$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $827bc923f0c9e9c0$var$defaultOptions = $827bc923f0c9e9c0$var$_objectSpread($827bc923f0c9e9c0$var$_objectSpread({}, $827bc923f0c9e9c0$var$defaultOptions), options);
}
function $827bc923f0c9e9c0$export$212bb2fc580a90a8() {
    return $827bc923f0c9e9c0$var$defaultOptions;
}

});
parcelRegister("7x6uV", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $57c0a7c77a42674b$export$e8bacd2802a88316; });
var $57c0a7c77a42674b$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $57c0a7c77a42674b$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $57c0a7c77a42674b$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $57c0a7c77a42674b$var$htmlEntities[m];
};
var $57c0a7c77a42674b$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($57c0a7c77a42674b$var$matchHtmlEntity, $57c0a7c77a42674b$var$unescapeHtmlEntity);
};

});


parcelRegister("fGjmH", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $b6a9ccbe65d47561$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $b6a9ccbe65d47561$export$64af334f494c2f47; });
var $b6a9ccbe65d47561$var$i18nInstance;
function $b6a9ccbe65d47561$export$a039134f2fc7e0(instance) {
    $b6a9ccbe65d47561$var$i18nInstance = instance;
}
function $b6a9ccbe65d47561$export$64af334f494c2f47() {
    return $b6a9ccbe65d47561$var$i18nInstance;
}

});


parcelRegister("kntWR", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $ed5d2fc36c8008df$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $ed5d2fc36c8008df$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $ed5d2fc36c8008df$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("bcyLK")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("fGjmH")).getI18n; });

var $d4P6P = parcelRequire("d4P6P");

var $rPxMG = parcelRequire("rPxMG");

var $cZMUv = parcelRequire("cZMUv");

var $eZVvM = parcelRequire("eZVvM");

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");

var $9yd0C = parcelRequire("9yd0C");
function $ed5d2fc36c8008df$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ed5d2fc36c8008df$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ed5d2fc36c8008df$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ed5d2fc36c8008df$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ed5d2fc36c8008df$export$5603ab5ced17ce64 = (0, $eZVvM.createContext)();
var $ed5d2fc36c8008df$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $rPxMG.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $cZMUv.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $ed5d2fc36c8008df$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $ed5d2fc36c8008df$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($ed5d2fc36c8008df$var$_objectSpread($ed5d2fc36c8008df$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $ed5d2fc36c8008df$export$704200e5d0b9e8f() {
    var i18n = (0, $fGjmH.getI18n)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRegister("9yd0C", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $6f416155aab8c75e$export$ae7e14d40d89f296; });

var $bcyLK = parcelRequire("bcyLK");

var $fGjmH = parcelRequire("fGjmH");
var $6f416155aab8c75e$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $bcyLK.setDefaults)(instance.options.react);
        (0, $fGjmH.setI18n)(instance);
    }
};

});



parcelRegister("9GLBV", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $70dcf7cd96e44425$export$9fc83ad70ead8663; });

var $eq5hl = parcelRequire("eq5hl");

var $d4P6P = parcelRequire("d4P6P");

var $d48On = parcelRequire("d48On");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("kntWR");
var $bcyLK = parcelRequire("bcyLK");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");

var $2vBHm = parcelRequire("2vBHm");
function $70dcf7cd96e44425$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70dcf7cd96e44425$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70dcf7cd96e44425$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70dcf7cd96e44425$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $70dcf7cd96e44425$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $eZVvM.useRef)();
    (0, $eZVvM.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $70dcf7cd96e44425$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $kntWR.ReportNamespaces)();
    if (!i18n) {
        (0, $2vBHm.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $d48On.default)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $2vBHm.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $70dcf7cd96e44425$var$_objectSpread($70dcf7cd96e44425$var$_objectSpread($70dcf7cd96e44425$var$_objectSpread({}, (0, $bcyLK.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $2vBHm.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $eZVvM.useState)(getT), _useState2 = (0, $eq5hl.default)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $70dcf7cd96e44425$var$usePrevious(joinedNS);
    var isMounted = (0, $eZVvM.useRef)(true);
    (0, $eZVvM.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $2vBHm.loadLanguages)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $2vBHm.loadNamespaces)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $eZVvM.useRef)(true);
    (0, $eZVvM.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $2vBHm.loadLanguages)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $2vBHm.loadNamespaces)(i18n, namespaces, function() {
            return resolve();
        });
    });
}

});
parcelRegister("eq5hl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f796a78370f597$export$2e2bcd8739ae039; });

var $luw9G = parcelRequire("luw9G");

var $lulrr = parcelRequire("lulrr");

var $8boX5 = parcelRequire("8boX5");

var $8KBa0 = parcelRequire("8KBa0");
function $a7f796a78370f597$export$2e2bcd8739ae039(r, e) {
    return (0, $luw9G.default)(r) || (0, $lulrr.default)(r, e) || (0, $8boX5.default)(r, e) || (0, $8KBa0.default)();
}

});
parcelRegister("lulrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa4d0831f718cbeb$export$2e2bcd8739ae039; });
function $fa4d0831f718cbeb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});



parcelRegister("kyRf9", function(module, exports) {

var $d4P6P = parcelRequire("d4P6P");

var $eq5hl = parcelRequire("eq5hl");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $9GLBV = parcelRequire("9GLBV");

var $2vBHm = parcelRequire("2vBHm");
var $ef8048ab007a8ed4$var$_excluded = [
    "forwardedRef"
];
function $ef8048ab007a8ed4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ef8048ab007a8ed4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ef8048ab007a8ed4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ef8048ab007a8ed4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ef8048ab007a8ed4$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $5ZjiC.default)(_ref, $ef8048ab007a8ed4$var$_excluded);
            var _useTranslation = (0, $9GLBV.useTranslation)(ns, $ef8048ab007a8ed4$var$_objectSpread($ef8048ab007a8ed4$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $eq5hl.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $ef8048ab007a8ed4$var$_objectSpread($ef8048ab007a8ed4$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $eZVvM.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $2vBHm.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $eZVvM.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $eZVvM.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRegister("fJ8IM", function(module, exports) {

var $eq5hl = parcelRequire("eq5hl");

var $5ZjiC = parcelRequire("5ZjiC");

var $9GLBV = parcelRequire("9GLBV");
var $b731d2d624026f9e$var$_excluded = [
    "ns",
    "children"
];
function $b731d2d624026f9e$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $5ZjiC.default)(props, $b731d2d624026f9e$var$_excluded);
    var _useTranslation = (0, $9GLBV.useTranslation)(ns, options), _useTranslation2 = (0, $eq5hl.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRegister("jAKxm", function(module, exports) {

var $eZVvM = parcelRequire("eZVvM");

var $kntWR = parcelRequire("kntWR");
function $e4357a66f8dcac4e$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $eZVvM.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $eZVvM.createElement)((0, $kntWR.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRegister("8jA9R", function(module, exports) {

var $d4P6P = parcelRequire("d4P6P");

var $5ZjiC = parcelRequire("5ZjiC");

var $eZVvM = parcelRequire("eZVvM");

var $6X3fC = parcelRequire("6X3fC");

var $kntWR = parcelRequire("kntWR");

var $2vBHm = parcelRequire("2vBHm");
var $60dc25562a3fb5a0$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $60dc25562a3fb5a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $60dc25562a3fb5a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $60dc25562a3fb5a0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d4P6P.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $60dc25562a3fb5a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $60dc25562a3fb5a0$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $5ZjiC.default)(_ref, $60dc25562a3fb5a0$var$_excluded);
            (0, $6X3fC.useSSR)(initialI18nStore, initialLanguage);
            return (0, $eZVvM.createElement)(WrappedComponent, $60dc25562a3fb5a0$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $kntWR.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $2vBHm.getDisplayName)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRegister("6X3fC", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $50fac64f6d0abc9e$export$3526fb65ade8d8b7; });

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("kntWR");
var $fGjmH = parcelRequire("fGjmH");
var $kntWR = parcelRequire("kntWR");
function $50fac64f6d0abc9e$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eZVvM.useContext)((0, $kntWR.I18nContext)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $fGjmH.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRegister("jnPOB", function(module, exports) {

$parcel$export(module.exports, "client", function () { return $bf2ddb1635937889$export$388e0302ca0d9a41; });
$parcel$export(module.exports, "gql", function () { return (parcelRequire("g6uH4")).gql; });

var $aZjGj = parcelRequire("aZjGj");

var $g6uH4 = parcelRequire("g6uH4");

var $eOD8X = parcelRequire("eOD8X");
const $bf2ddb1635937889$var$apiUrl = (0, $eOD8X.getApiUrl)();
const $bf2ddb1635937889$var$CLIENT_TOKEN = (0, window.location.pathname.split("/")[2]);
const $bf2ddb1635937889$export$388e0302ca0d9a41 = new (0, $g6uH4.GraphQLClient)(`${$bf2ddb1635937889$var$apiUrl}/graphql`, {
    headers: ()=>({
            "Client-Token": $bf2ddb1635937889$var$CLIENT_TOKEN,
            "Accept-Language": (0, $aZjGj.default).language
        })
});

});
parcelRegister("g6uH4", function(module, exports) {
"use strict";
var $bb9504011f8acb95$var$__assign = module.exports && module.exports.__assign || function() {
    $bb9504011f8acb95$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bb9504011f8acb95$var$__assign.apply(this, arguments);
};
var $bb9504011f8acb95$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bb9504011f8acb95$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bb9504011f8acb95$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bb9504011f8acb95$var$__createBinding(result, mod, k);
    }
    $bb9504011f8acb95$var$__setModuleDefault(result, mod);
    return result;
};
var $bb9504011f8acb95$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bb9504011f8acb95$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $bb9504011f8acb95$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bb9504011f8acb95$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $bb9504011f8acb95$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = module.exports.GraphQLWebSocketClient = module.exports.gql = module.exports.batchRequests = module.exports.request = module.exports.rawRequest = module.exports.GraphQLClient = module.exports.ClientError = void 0;

var $bb9504011f8acb95$var$cross_fetch_1 = $bb9504011f8acb95$var$__importStar((parcelRequire("1urwW"))), $bb9504011f8acb95$var$CrossFetch = $bb9504011f8acb95$var$cross_fetch_1;

var $bb9504011f8acb95$var$createRequestBody_1 = $bb9504011f8acb95$var$__importDefault((parcelRequire("jJBzg")));

var $kQznX = parcelRequire("kQznX");

var $hyytw = parcelRequire("hyytw");

var $iaMvf = parcelRequire("iaMvf");
Object.defineProperty(module.exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $iaMvf.ClientError;
    }
});

var $gfzLa = parcelRequire("gfzLa");
/**
 * Convert the given headers configuration into a plain object.
 */ var $bb9504011f8acb95$var$resolveHeaders = function(headers) {
    var oHeaders = {};
    if (headers) {
        if (typeof Headers !== "undefined" && headers instanceof Headers || $bb9504011f8acb95$var$CrossFetch && $bb9504011f8acb95$var$CrossFetch.Headers && headers instanceof $bb9504011f8acb95$var$CrossFetch.Headers) oHeaders = $bb9504011f8acb95$var$HeadersInstanceToPlainObject(headers);
        else if (Array.isArray(headers)) headers.forEach(function(_a) {
            var name = _a[0], value = _a[1];
            oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */ var $bb9504011f8acb95$var$queryCleanner = function(str) {
    return str.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim();
};
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */ var $bb9504011f8acb95$var$buildGetQueryParams = function(_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName, jsonSerializer = _a.jsonSerializer;
    if (!Array.isArray(query)) {
        var search = [
            "query=".concat(encodeURIComponent($bb9504011f8acb95$var$queryCleanner(query)))
        ];
        if (variables) search.push("variables=".concat(encodeURIComponent(jsonSerializer.stringify(variables))));
        if (operationName) search.push("operationName=".concat(encodeURIComponent(operationName)));
        return search.join("&");
    }
    if (typeof variables !== "undefined" && !Array.isArray(variables)) throw new Error("Cannot create query with given variable type, array expected");
    // Batch support
    var payload = query.reduce(function(accu, currentQuery, index) {
        accu.push({
            query: $bb9504011f8acb95$var$queryCleanner(currentQuery),
            variables: variables ? jsonSerializer.stringify(variables[index]) : undefined
        });
        return accu;
    }, []);
    return "query=".concat(encodeURIComponent(jsonSerializer.stringify(payload)));
};
/**
 * Fetch data using POST method
 */ var $bb9504011f8acb95$var$post = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(void 0, void 0, void 0, function() {
        var body, init;
        var _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    body = (0, $bb9504011f8acb95$var$createRequestBody_1.default)(query, variables, operationName, fetchOptions.jsonSerializer);
                    init = $bb9504011f8acb95$var$__assign({
                        method: "POST",
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, typeof body === "string" ? {
                            "Content-Type": "application/json"
                        } : {}), headers),
                        body: body
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $bb9504011f8acb95$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch(url, init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */ var $bb9504011f8acb95$var$get = function(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(void 0, void 0, void 0, function() {
        var queryParams, init;
        var _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    queryParams = $bb9504011f8acb95$var$buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                        jsonSerializer: fetchOptions.jsonSerializer
                    });
                    init = $bb9504011f8acb95$var$__assign({
                        method: "GET",
                        headers: headers
                    }, fetchOptions);
                    if (!middleware) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.resolve(middleware($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, init), {
                            url: url,
                            operationName: operationName,
                            variables: variables
                        })))
                    ];
                case 1:
                    _b = _c.sent(), url = _b.url, init = $bb9504011f8acb95$var$__rest(_b, [
                        "url"
                    ]);
                    _c.label = 2;
                case 2:
                    return [
                        4 /*yield*/ ,
                        fetch("".concat(url, "?").concat(queryParams), init)
                    ];
                case 3:
                    return [
                        2 /*return*/ ,
                        _c.sent()
                    ];
            }
        });
    });
};
/**
 * GraphQL Client.
 */ var $bb9504011f8acb95$var$GraphQLClient = /** @class */ function() {
    function GraphQLClient(url, options) {
        if (options === void 0) options = {};
        this.url = url;
        this.options = options;
    }
    GraphQLClient.prototype.rawRequest = function(queryOrOptions, variables, requestHeaders) {
        return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
            var rawRequestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, operationName;
            return $bb9504011f8acb95$var$__generator(this, function(_d) {
                rawRequestOptions = (0, $hyytw.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
                operationName = (0, $gfzLa.resolveRequestDocument)(rawRequestOptions.query).operationName;
                return [
                    2 /*return*/ ,
                    $bb9504011f8acb95$var$makeRequest({
                        url: url,
                        query: rawRequestOptions.query,
                        variables: rawRequestOptions.variables,
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(rawRequestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.request = function(documentOrOptions) {
        var variablesAndRequestHeaders = [];
        for(var _i = 1; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 1] = arguments[_i];
        return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
            var variables, requestHeaders, requestOptions, _a, headers, _b, fetch, _c, method, requestMiddleware, responseMiddleware, fetchOptions, url, _d, query, operationName;
            return $bb9504011f8acb95$var$__generator(this, function(_e) {
                variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
                requestOptions = (0, $hyytw.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
                _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
                    "headers",
                    "fetch",
                    "method",
                    "requestMiddleware",
                    "responseMiddleware"
                ]);
                url = this.url;
                if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
                _d = (0, $gfzLa.resolveRequestDocument)(requestOptions.document), query = _d.query, operationName = _d.operationName;
                return [
                    2 /*return*/ ,
                    $bb9504011f8acb95$var$makeRequest({
                        url: url,
                        query: query,
                        variables: requestOptions.variables,
                        headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(requestOptions.requestHeaders)),
                        operationName: operationName,
                        fetch: fetch,
                        method: method,
                        fetchOptions: fetchOptions,
                        middleware: requestMiddleware
                    }).then(function(response) {
                        if (responseMiddleware) responseMiddleware(response);
                        return response.data;
                    }).catch(function(error) {
                        if (responseMiddleware) responseMiddleware(error);
                        throw error;
                    })
                ];
            });
        });
    };
    GraphQLClient.prototype.batchRequests = function(documentsOrOptions, requestHeaders) {
        var batchRequestOptions = (0, $hyytw.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? $bb9504011f8acb95$var$cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? "POST" : _c, requestMiddleware = _a.requestMiddleware, responseMiddleware = _a.responseMiddleware, fetchOptions = $bb9504011f8acb95$var$__rest(_a, [
            "headers",
            "fetch",
            "method",
            "requestMiddleware",
            "responseMiddleware"
        ]);
        var url = this.url;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        var queries = batchRequestOptions.documents.map(function(_a) {
            var document = _a.document;
            return (0, $gfzLa.resolveRequestDocument)(document).query;
        });
        var variables = batchRequestOptions.documents.map(function(_a) {
            var variables = _a.variables;
            return variables;
        });
        return $bb9504011f8acb95$var$makeRequest({
            url: url,
            query: queries,
            variables: variables,
            headers: $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, $bb9504011f8acb95$var$resolveHeaders($bb9504011f8acb95$var$callOrIdentity(headers))), $bb9504011f8acb95$var$resolveHeaders(batchRequestOptions.requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then(function(response) {
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch(function(error) {
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    };
    GraphQLClient.prototype.setHeaders = function(headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ GraphQLClient.prototype.setHeader = function(key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-ignore
        headers[key] = value;
        else this.options.headers = (_a = {}, _a[key] = value, _a);
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ GraphQLClient.prototype.setEndpoint = function(value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}();
module.exports.GraphQLClient = $bb9504011f8acb95$var$GraphQLClient;
function $bb9504011f8acb95$var$makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? "POST" : _b, fetchOptions = _a.fetchOptions, middleware = _a.middleware;
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, successfullyPassedErrorPolicy, headers_1, status_1, errors, rest, data, errorResult;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    fetcher = method.toUpperCase() === "POST" ? $bb9504011f8acb95$var$post : $bb9504011f8acb95$var$get;
                    isBathchingQuery = Array.isArray(query);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions,
                            middleware: middleware
                        })
                    ];
                case 1:
                    response = _c.sent();
                    return [
                        4 /*yield*/ ,
                        $bb9504011f8acb95$var$getResult(response, fetchOptions.jsonSerializer)
                    ];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function(_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    successfullyPassedErrorPolicy = !result.errors || fetchOptions.errorPolicy === "all" || fetchOptions.errorPolicy === "ignore";
                    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        errors = result.errors, rest = $bb9504011f8acb95$var$__rest(result, [
                            "errors"
                        ]);
                        data = fetchOptions.errorPolicy === "ignore" ? rest : result;
                        return [
                            2 /*return*/ ,
                            $bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, isBathchingQuery ? {
                                data: data
                            } : data), {
                                headers: headers_1,
                                status: status_1
                            })
                        ];
                    } else {
                        errorResult = typeof result === "string" ? {
                            error: result
                        } : result;
                        throw new $iaMvf.ClientError($bb9504011f8acb95$var$__assign($bb9504011f8acb95$var$__assign({}, errorResult), {
                            status: response.status,
                            headers: response.headers
                        }), {
                            query: query,
                            variables: variables
                        });
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $bb9504011f8acb95$var$rawRequest(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = $hyytw.parseRawRequestExtendedArgs.apply(void 0, $bb9504011f8acb95$var$__spreadArray([
                urlOrOptions,
                query
            ], variablesAndRequestHeaders, false));
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.rawRequest($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.rawRequest = $bb9504011f8acb95$var$rawRequest;
function $bb9504011f8acb95$var$request(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = $hyytw.parseRequestExtendedArgs.apply(void 0, $bb9504011f8acb95$var$__spreadArray([
                urlOrOptions,
                document
            ], variablesAndRequestHeaders, false));
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.request($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.request = $bb9504011f8acb95$var$request;
function $bb9504011f8acb95$var$batchRequests(urlOrOptions, documents, requestHeaders) {
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var requestOptions, client;
        return $bb9504011f8acb95$var$__generator(this, function(_a) {
            requestOptions = (0, $hyytw.parseBatchRequestsExtendedArgs)(urlOrOptions, documents, requestHeaders);
            client = new $bb9504011f8acb95$var$GraphQLClient(requestOptions.url);
            return [
                2 /*return*/ ,
                client.batchRequests($bb9504011f8acb95$var$__assign({}, requestOptions))
            ];
        });
    });
}
module.exports.batchRequests = $bb9504011f8acb95$var$batchRequests;
module.exports.default = $bb9504011f8acb95$var$request;
/**
 * todo
 */ function $bb9504011f8acb95$var$getResult(response, jsonSerializer) {
    if (jsonSerializer === void 0) jsonSerializer = $kQznX.defaultJsonSerializer;
    return $bb9504011f8acb95$var$__awaiter(this, void 0, void 0, function() {
        var contentType, _a, _b;
        return $bb9504011f8acb95$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    response.headers.forEach(function(value, key) {
                        if (key.toLowerCase() === "content-type") contentType = value;
                    });
                    if (!(contentType && (contentType.toLowerCase().startsWith("application/json") || contentType.toLowerCase().startsWith("application/graphql+json") || contentType.toLowerCase().startsWith("application/graphql-response+json")))) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = (_a = jsonSerializer).parse;
                    return [
                        4 /*yield*/ ,
                        response.text()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(_a, [
                            _c.sent()
                        ])
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        response.text()
                    ];
            }
        });
    });
}
function $bb9504011f8acb95$var$callOrIdentity(value) {
    return typeof value === "function" ? value() : value;
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ function $bb9504011f8acb95$var$gql(chunks) {
    var variables = [];
    for(var _i = 1; _i < arguments.length; _i++)variables[_i - 1] = arguments[_i];
    return chunks.reduce(function(accumulator, chunk, index) {
        return "".concat(accumulator).concat(chunk).concat(index in variables ? variables[index] : "");
    }, "");
}
module.exports.gql = $bb9504011f8acb95$var$gql;
/**
 * Convert Headers instance into regular object
 */ function $bb9504011f8acb95$var$HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}

var $kE4VN = parcelRequire("kE4VN");
Object.defineProperty(module.exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $kE4VN.GraphQLWebSocketClient;
    }
});

var $gfzLa = parcelRequire("gfzLa");
Object.defineProperty(module.exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $gfzLa.resolveRequestDocument;
    }
});

});
parcelRegister("hyytw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseBatchRequestsExtendedArgs = module.exports.parseRawRequestExtendedArgs = module.exports.parseRequestExtendedArgs = module.exports.parseBatchRequestArgs = module.exports.parseRawRequestArgs = module.exports.parseRequestArgs = void 0;
function $cc805aab0d0d149a$var$parseRequestArgs(documentOrOptions, variables, requestHeaders) {
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestArgs = $cc805aab0d0d149a$var$parseRequestArgs;
function $cc805aab0d0d149a$var$parseRawRequestArgs(queryOrOptions, variables, requestHeaders) {
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestArgs = $cc805aab0d0d149a$var$parseRawRequestArgs;
function $cc805aab0d0d149a$var$parseBatchRequestArgs(documentsOrOptions, requestHeaders) {
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestArgs = $cc805aab0d0d149a$var$parseBatchRequestArgs;
function $cc805aab0d0d149a$var$parseRequestExtendedArgs(urlOrOptions, document) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRequestExtendedArgs = $cc805aab0d0d149a$var$parseRequestExtendedArgs;
function $cc805aab0d0d149a$var$parseRawRequestExtendedArgs(urlOrOptions, query) {
    var variablesAndRequestHeaders = [];
    for(var _i = 2; _i < arguments.length; _i++)variablesAndRequestHeaders[_i - 2] = arguments[_i];
    var variables = variablesAndRequestHeaders[0], requestHeaders = variablesAndRequestHeaders[1];
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseRawRequestExtendedArgs = $cc805aab0d0d149a$var$parseRawRequestExtendedArgs;
function $cc805aab0d0d149a$var$parseBatchRequestsExtendedArgs(urlOrOptions, documents, requestHeaders) {
    return urlOrOptions.documents ? urlOrOptions : {
        url: urlOrOptions,
        documents: documents,
        requestHeaders: requestHeaders,
        signal: undefined
    };
}
module.exports.parseBatchRequestsExtendedArgs = $cc805aab0d0d149a$var$parseBatchRequestsExtendedArgs;

});

parcelRegister("iaMvf", function(module, exports) {
"use strict";
var $d3aec8d42d5ea32e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientError = void 0;
var $d3aec8d42d5ea32e$var$ClientError = /** @class */ function(_super) {
    $d3aec8d42d5ea32e$var$__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = "".concat(ClientError.extractMessage(response), ": ").concat(JSON.stringify({
            response: response,
            request: request
        }));
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, ClientError);
        return _this;
    }
    ClientError.extractMessage = function(response) {
        try {
            return response.errors[0].message;
        } catch (e) {
            return "GraphQL Error (Code: ".concat(response.status, ")");
        }
    };
    return ClientError;
}(Error);
module.exports.ClientError = $d3aec8d42d5ea32e$var$ClientError;

});

parcelRegister("gfzLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = void 0;

var $4IiQ0 = parcelRequire("4IiQ0");
var $ab57Y = parcelRequire("ab57Y");
/**
 * helpers
 */ function $bd49c92f1faac39c$var$extractOperationName(document) {
    var _a;
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    });
    if (operationDefinitions.length === 1) operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    return operationName;
}
function $bd49c92f1faac39c$var$resolveRequestDocument(document) {
    if (typeof document === "string") {
        var operationName_1 = undefined;
        try {
            var parsedDocument = (0, $4IiQ0.parse)(document);
            operationName_1 = $bd49c92f1faac39c$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName_1
        };
    }
    var operationName = $bd49c92f1faac39c$var$extractOperationName(document);
    return {
        query: (0, $ab57Y.print)(document),
        operationName: operationName
    };
}
module.exports.resolveRequestDocument = $bd49c92f1faac39c$var$resolveRequestDocument;

});
parcelRegister("4IiQ0", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $42a373b4d2407b14$export$98e6a39c04603d36; });

var $2iMOi = parcelRequire("2iMOi");

var $4yHPB = parcelRequire("4yHPB");

var $5FyIR = parcelRequire("5FyIR");

var $2lT1M = parcelRequire("2lT1M");

var $dzBoV = parcelRequire("dzBoV");

var $hZAON = parcelRequire("hZAON");

var $7GP8Q = parcelRequire("7GP8Q");

var $6xHWd = parcelRequire("6xHWd");

var $9viVd = parcelRequire("9viVd");
function $42a373b4d2407b14$export$98e6a39c04603d36(source, options) {
    var parser = new $42a373b4d2407b14$var$Parser(source, options);
    return parser.parseDocument();
}
function $42a373b4d2407b14$export$5303528d1070ff6f(source, options) {
    var parser = new $42a373b4d2407b14$var$Parser(source, options);
    parser.expectToken((0, $7GP8Q.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $7GP8Q.TokenKind).EOF);
    return value;
}
function $42a373b4d2407b14$export$28b8f402ccc88182(source, options) {
    var parser = new $42a373b4d2407b14$var$Parser(source, options);
    parser.expectToken((0, $7GP8Q.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $7GP8Q.TokenKind).EOF);
    return type;
}
var $42a373b4d2407b14$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = typeof source === "string" ? new (0, $hZAON.Source)(source) : source;
        sourceObj instanceof (0, $hZAON.Source) || (0, $4yHPB.default)(0, "Must provide Source. Received: ".concat((0, $2iMOi.default)(sourceObj), "."));
        this._lexer = new (0, $9viVd.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $7GP8Q.TokenKind).NAME);
        return {
            kind: (0, $2lT1M.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $2lT1M.Kind).DOCUMENT,
            definitions: this.many((0, $7GP8Q.TokenKind).SOF, this.parseDefinition, (0, $7GP8Q.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $7GP8Q.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $7GP8Q.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $7GP8Q.TokenKind).BRACE_L)) return {
            kind: (0, $2lT1M.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $7GP8Q.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $2lT1M.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $7GP8Q.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $7GP8Q.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $7GP8Q.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $2lT1M.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $7GP8Q.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $7GP8Q.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $7GP8Q.TokenKind).DOLLAR);
        return {
            kind: (0, $2lT1M.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $2lT1M.Kind).SELECTION_SET,
            selections: this.many((0, $7GP8Q.TokenKind).BRACE_L, this.parseSelection, (0, $7GP8Q.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $7GP8Q.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $7GP8Q.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $2lT1M.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $7GP8Q.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $7GP8Q.TokenKind).PAREN_L, item, (0, $7GP8Q.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $7GP8Q.TokenKind).COLON);
        return {
            kind: (0, $2lT1M.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $2lT1M.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $7GP8Q.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $7GP8Q.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $7GP8Q.TokenKind).NAME)) return {
            kind: (0, $2lT1M.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $2lT1M.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $2lT1M.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $2lT1M.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $7GP8Q.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $7GP8Q.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $7GP8Q.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $2lT1M.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $7GP8Q.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $2lT1M.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $7GP8Q.TokenKind).STRING:
            case (0, $7GP8Q.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $7GP8Q.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case "true":
                        return {
                            kind: (0, $2lT1M.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case "false":
                        return {
                            kind: (0, $2lT1M.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case "null":
                        return {
                            kind: (0, $2lT1M.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $2lT1M.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $7GP8Q.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $2lT1M.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $7GP8Q.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $2lT1M.Kind).LIST,
            values: this.any((0, $7GP8Q.TokenKind).BRACKET_L, item, (0, $7GP8Q.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $2lT1M.Kind).OBJECT,
            fields: this.any((0, $7GP8Q.TokenKind).BRACE_L, item, (0, $7GP8Q.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $7GP8Q.TokenKind).COLON);
        return {
            kind: (0, $2lT1M.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $7GP8Q.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $7GP8Q.TokenKind).AT);
        return {
            kind: (0, $2lT1M.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $7GP8Q.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $7GP8Q.TokenKind).BRACKET_R);
            type = {
                kind: (0, $2lT1M.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $7GP8Q.TokenKind).BANG)) return {
            kind: (0, $2lT1M.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $2lT1M.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $7GP8Q.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $7GP8Q.TokenKind).STRING) || this.peek((0, $7GP8Q.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $7GP8Q.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $7GP8Q.TokenKind).BRACE_R);
        return {
            kind: (0, $2lT1M.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $7GP8Q.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $2lT1M.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $2lT1M.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $2lT1M.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var types = [];
        if (this.expectOptionalKeyword("implements")) {
            // Optional leading ampersand
            this.expectOptionalToken((0, $7GP8Q.TokenKind).AMP);
            do {
                var _this$_options2;
                types.push(this.parseNamedType());
            }while (this.expectOptionalToken((0, $7GP8Q.TokenKind).AMP) || // Legacy support for the SDL?
            ((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true && this.peek((0, $7GP8Q.TokenKind).NAME));
        }
        return types;
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $7GP8Q.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $7GP8Q.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $7GP8Q.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $7GP8Q.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $7GP8Q.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $2lT1M.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $7GP8Q.TokenKind).PAREN_L, this.parseInputValueDef, (0, $7GP8Q.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $7GP8Q.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $7GP8Q.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $2lT1M.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $2lT1M.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $2lT1M.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        var types = [];
        if (this.expectOptionalToken((0, $7GP8Q.TokenKind).EQUALS)) {
            // Optional leading pipe
            this.expectOptionalToken((0, $7GP8Q.TokenKind).PIPE);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $7GP8Q.TokenKind).PIPE));
        }
        return types;
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $2lT1M.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $7GP8Q.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $7GP8Q.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $2lT1M.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $2lT1M.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $7GP8Q.TokenKind).BRACE_L, this.parseInputValueDef, (0, $7GP8Q.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $7GP8Q.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $7GP8Q.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $7GP8Q.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $2lT1M.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $7GP8Q.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $2lT1M.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        // Optional leading pipe
        this.expectOptionalToken((0, $7GP8Q.TokenKind).PIPE);
        var locations = [];
        do locations.push(this.parseDirectiveLocation());
        while (this.expectOptionalToken((0, $7GP8Q.TokenKind).PIPE));
        return locations;
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $6xHWd.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $dzBoV.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $5FyIR.syntaxError)(this._lexer.source, token.start, "Expected ".concat($42a373b4d2407b14$var$getTokenKindDesc(kind), ", found ").concat($42a373b4d2407b14$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $7GP8Q.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $5FyIR.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($42a373b4d2407b14$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $7GP8Q.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $5FyIR.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($42a373b4d2407b14$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging
 */ function $42a373b4d2407b14$var$getTokenDesc(token) {
    var value = token.value;
    return $42a373b4d2407b14$var$getTokenKindDesc(token.kind) + (value != null ? ' "'.concat(value, '"') : "");
}
/**
 * A helper function to describe a token kind as a string for debugging
 */ function $42a373b4d2407b14$var$getTokenKindDesc(kind) {
    return (0, $9viVd.isPunctuatorTokenKind)(kind) ? '"'.concat(kind, '"') : kind;
}

});
parcelRegister("2iMOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de35d4357d606f3f$export$2e2bcd8739ae039; });

var $2FXCE = parcelRequire("2FXCE");
function $de35d4357d606f3f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $de35d4357d606f3f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $de35d4357d606f3f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $de35d4357d606f3f$var$_typeof(obj);
}
var $de35d4357d606f3f$var$MAX_ARRAY_LENGTH = 10;
var $de35d4357d606f3f$var$MAX_RECURSIVE_DEPTH = 2;
function $de35d4357d606f3f$export$2e2bcd8739ae039(value) {
    return $de35d4357d606f3f$var$formatValue(value, []);
}
function $de35d4357d606f3f$var$formatValue(value, seenValues) {
    switch($de35d4357d606f3f$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $de35d4357d606f3f$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $de35d4357d606f3f$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $de35d4357d606f3f$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $de35d4357d606f3f$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $de35d4357d606f3f$var$formatArray(value, seenValues);
    return $de35d4357d606f3f$var$formatObject(value, seenValues);
}
function $de35d4357d606f3f$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $de35d4357d606f3f$var$MAX_RECURSIVE_DEPTH) return "[" + $de35d4357d606f3f$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $de35d4357d606f3f$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $de35d4357d606f3f$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $de35d4357d606f3f$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($de35d4357d606f3f$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($de35d4357d606f3f$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $de35d4357d606f3f$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $2FXCE.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $de35d4357d606f3f$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});
parcelRegister("2FXCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a69787cd23e2bea$export$2e2bcd8739ae039; });
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $0a69787cd23e2bea$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $0a69787cd23e2bea$export$2e2bcd8739ae039 = $0a69787cd23e2bea$var$nodejsCustomInspectSymbol;

});


parcelRegister("4yHPB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cffe8387d644fe66$export$2e2bcd8739ae039; });
function $cffe8387d644fe66$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("5FyIR", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $e588e2490e93a6fb$export$bbee0c6176c019d4; });

var $4CJjR = parcelRequire("4CJjR");
function $e588e2490e93a6fb$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $4CJjR.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("4CJjR", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $e1fd4bede35568e9$export$92d6ed0888e7cb7f; });

var $hZRf1 = parcelRequire("hZRf1");

var $iAhSL = parcelRequire("iAhSL");

var $6G5nq = parcelRequire("6G5nq");

var $b3GTa = parcelRequire("b3GTa");
function $e1fd4bede35568e9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e1fd4bede35568e9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e1fd4bede35568e9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e1fd4bede35568e9$var$_typeof(obj);
}
function $e1fd4bede35568e9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1fd4bede35568e9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e1fd4bede35568e9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e1fd4bede35568e9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e1fd4bede35568e9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e1fd4bede35568e9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e1fd4bede35568e9$var$_setPrototypeOf(subClass, superClass);
}
function $e1fd4bede35568e9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e1fd4bede35568e9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e1fd4bede35568e9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e1fd4bede35568e9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e1fd4bede35568e9$var$_possibleConstructorReturn(this, result);
    };
}
function $e1fd4bede35568e9$var$_possibleConstructorReturn(self, call) {
    if (call && ($e1fd4bede35568e9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e1fd4bede35568e9$var$_assertThisInitialized(self);
}
function $e1fd4bede35568e9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e1fd4bede35568e9$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e1fd4bede35568e9$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e1fd4bede35568e9$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e1fd4bede35568e9$var$_construct(Class, arguments, $e1fd4bede35568e9$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e1fd4bede35568e9$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e1fd4bede35568e9$var$_wrapNativeSuper(Class);
}
function $e1fd4bede35568e9$var$_construct(Parent, args, Class) {
    if ($e1fd4bede35568e9$var$_isNativeReflectConstruct()) $e1fd4bede35568e9$var$_construct = Reflect.construct;
    else $e1fd4bede35568e9$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e1fd4bede35568e9$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e1fd4bede35568e9$var$_construct.apply(null, arguments);
}
function $e1fd4bede35568e9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e1fd4bede35568e9$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e1fd4bede35568e9$var$_setPrototypeOf(o, p) {
    $e1fd4bede35568e9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e1fd4bede35568e9$var$_setPrototypeOf(o, p);
}
function $e1fd4bede35568e9$var$_getPrototypeOf(o) {
    $e1fd4bede35568e9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e1fd4bede35568e9$var$_getPrototypeOf(o);
}
var $e1fd4bede35568e9$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $e1fd4bede35568e9$var$_inherits(GraphQLError, _Error);
    var _super = $e1fd4bede35568e9$var$_createSuper(GraphQLError);
    /**
   * A message describing the Error for debugging purposes.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   *
   * Note: should be treated as readonly, despite invariant usage.
   */ /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _locations2, _source2, _positions2, _extensions2;
        var _this;
        $e1fd4bede35568e9$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message); // Compute list of blame nodes.
        var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
            nodes
        ] : undefined; // Compute locations in the source for the given nodes/positions.
        var _source = source;
        if (!_source && _nodes) {
            var _nodes$0$loc;
            _source = (_nodes$0$loc = _nodes[0].loc) === null || _nodes$0$loc === void 0 ? void 0 : _nodes$0$loc.source;
        }
        var _positions = positions;
        if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
            if (node.loc) list.push(node.loc.start);
            return list;
        }, []);
        if (_positions && _positions.length === 0) _positions = undefined;
        var _locations;
        if (positions && source) _locations = positions.map(function(pos) {
            return (0, $6G5nq.getLocation)(source, pos);
        });
        else if (_nodes) _locations = _nodes.reduce(function(list, node) {
            if (node.loc) list.push((0, $6G5nq.getLocation)(node.loc.source, node.loc.start));
            return list;
        }, []);
        var _extensions = extensions;
        if (_extensions == null && originalError != null) {
            var originalExtensions = originalError.extensions;
            if ((0, $hZRf1.default)(originalExtensions)) _extensions = originalExtensions;
        }
        Object.defineProperties($e1fd4bede35568e9$var$_assertThisInitialized(_this), {
            name: {
                value: "GraphQLError"
            },
            message: {
                value: message,
                // By being enumerable, JSON.stringify will include `message` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: true,
                writable: true
            },
            locations: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_locations2 = _locations) !== null && _locations2 !== void 0 ? _locations2 : undefined,
                // By being enumerable, JSON.stringify will include `locations` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _locations != null
            },
            path: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: path !== null && path !== void 0 ? path : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: path != null
            },
            nodes: {
                value: _nodes !== null && _nodes !== void 0 ? _nodes : undefined
            },
            source: {
                value: (_source2 = _source) !== null && _source2 !== void 0 ? _source2 : undefined
            },
            positions: {
                value: (_positions2 = _positions) !== null && _positions2 !== void 0 ? _positions2 : undefined
            },
            originalError: {
                value: originalError
            },
            extensions: {
                // Coercing falsy values to undefined ensures they will not be included
                // in JSON.stringify() when not provided.
                value: (_extensions2 = _extensions) !== null && _extensions2 !== void 0 ? _extensions2 : undefined,
                // By being enumerable, JSON.stringify will include `path` in the
                // resulting output. This ensures that the simplest possible GraphQL
                // service adheres to the spec.
                enumerable: _extensions != null
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError === null || originalError === void 0 ? void 0 : originalError.stack) {
            Object.defineProperty($e1fd4bede35568e9$var$_assertThisInitialized(_this), "stack", {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $e1fd4bede35568e9$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($e1fd4bede35568e9$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($e1fd4bede35568e9$var$_assertThisInitialized(_this), "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $e1fd4bede35568e9$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $e1fd4bede35568e9$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $iAhSL.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Object";
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $e1fd4bede35568e9$var$_wrapNativeSuper(Error));
function $e1fd4bede35568e9$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += "\n\n" + (0, $b3GTa.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += "\n\n" + (0, $b3GTa.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("hZRf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85bf228207fc0bf1$export$2e2bcd8739ae039; });
function $85bf228207fc0bf1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $85bf228207fc0bf1$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $85bf228207fc0bf1$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $85bf228207fc0bf1$var$_typeof(obj);
}
function $85bf228207fc0bf1$export$2e2bcd8739ae039(value) {
    return $85bf228207fc0bf1$var$_typeof(value) == "object" && value !== null;
}

});

parcelRegister("iAhSL", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", function () { return $3e914a5e562039b9$export$5deadc579ccc7c9c; });
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $3e914a5e562039b9$export$f6cdee3c26d6da57 = typeof Symbol === "function" ? Symbol.iterator : "@@iterator"; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $3e914a5e562039b9$export$8d0083df0471478e = typeof Symbol === "function" ? Symbol.asyncIterator : "@@asyncIterator"; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $3e914a5e562039b9$export$5deadc579ccc7c9c = typeof Symbol === "function" ? Symbol.toStringTag : "@@toStringTag";

});

parcelRegister("6G5nq", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $2cb1a3fa51c40e9e$export$e7fd20fad3cf4b5f; });
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $2cb1a3fa51c40e9e$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("b3GTa", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $f26be73e0900ede9$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $f26be73e0900ede9$export$867940333fd9f869; });

var $6G5nq = parcelRequire("6G5nq");
function $f26be73e0900ede9$export$96a9681e539deed(location) {
    return $f26be73e0900ede9$export$867940333fd9f869(location.source, (0, $6G5nq.getLocation)(location.source, location.start));
}
function $f26be73e0900ede9$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $f26be73e0900ede9$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $f26be73e0900ede9$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                "",
                subLine
            ];
        }), [
            [
                " ",
                $f26be73e0900ede9$var$whitespace(subLineColumnNum - 1) + "^"
            ],
            [
                "",
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $f26be73e0900ede9$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $f26be73e0900ede9$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $f26be73e0900ede9$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $f26be73e0900ede9$var$leftPad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $f26be73e0900ede9$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $f26be73e0900ede9$var$leftPad(len, str) {
    return $f26be73e0900ede9$var$whitespace(len - str.length) + str;
}

});



parcelRegister("2lT1M", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $65a83b34b1cbb272$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $65a83b34b1cbb272$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("dzBoV", function(module, exports) {

$parcel$export(module.exports, "Location", function () { return $ad5ac872144b413d$export$18a2be9195644f38; });
$parcel$export(module.exports, "Token", function () { return $ad5ac872144b413d$export$50792b0e93539fde; });
$parcel$export(module.exports, "isNode", function () { return $ad5ac872144b413d$export$8ee0fc9ee280b4ee; });

var $1ft57 = parcelRequire("1ft57");
var $ad5ac872144b413d$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $1ft57.default)($ad5ac872144b413d$export$18a2be9195644f38);
var $ad5ac872144b413d$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $1ft57.default)($ad5ac872144b413d$export$50792b0e93539fde);
function $ad5ac872144b413d$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === "string";
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("1ft57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f40b217ebe02497$export$2e2bcd8739ae039; });

var $2U7W1 = parcelRequire("2U7W1");

var $2FXCE = parcelRequire("2FXCE");
function $1f40b217ebe02497$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === "function" || (0, $2U7W1.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $2FXCE.default) classObject.prototype[0, $2FXCE.default] = fn;
}

});
parcelRegister("2U7W1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41ee37b1882e2736$export$2e2bcd8739ae039; });
function $41ee37b1882e2736$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}

});



parcelRegister("hZAON", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $bd238ab54f58ee0d$export$1d2df86270c81ecb; });

var $iAhSL = parcelRequire("iAhSL");

var $4yHPB = parcelRequire("4yHPB");
function $bd238ab54f58ee0d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bd238ab54f58ee0d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bd238ab54f58ee0d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bd238ab54f58ee0d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $bd238ab54f58ee0d$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "GraphQL request";
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $4yHPB.default)(0, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $4yHPB.default)(0, "column in locationOffset is 1-indexed and must be positive.");
    } // $FlowFixMe Flow doesn't support computed properties yet
    $bd238ab54f58ee0d$var$_createClass(Source, [
        {
            key: (0, $iAhSL.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return "Source";
            }
        }
    ]);
    return Source;
}();

});

parcelRegister("7GP8Q", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $2316c8e80c375869$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $2316c8e80c375869$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("6xHWd", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $4b4390782485a0c0$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $4b4390782485a0c0$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("9viVd", function(module, exports) {

$parcel$export(module.exports, "Lexer", function () { return $22c8e17b5ed49457$export$6168dc8908a6c652; });
$parcel$export(module.exports, "isPunctuatorTokenKind", function () { return $22c8e17b5ed49457$export$59ac0f4da287406a; });

var $5FyIR = parcelRequire("5FyIR");

var $dzBoV = parcelRequire("dzBoV");

var $7GP8Q = parcelRequire("7GP8Q");

var $jA4dn = parcelRequire("jA4dn");
var $22c8e17b5ed49457$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $7GP8Q.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $22c8e17b5ed49457$var$readToken(this, token);
        }while (token.kind === (0, $7GP8Q.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $22c8e17b5ed49457$export$59ac0f4da287406a(kind) {
    return kind === (0, $7GP8Q.TokenKind).BANG || kind === (0, $7GP8Q.TokenKind).DOLLAR || kind === (0, $7GP8Q.TokenKind).AMP || kind === (0, $7GP8Q.TokenKind).PAREN_L || kind === (0, $7GP8Q.TokenKind).PAREN_R || kind === (0, $7GP8Q.TokenKind).SPREAD || kind === (0, $7GP8Q.TokenKind).COLON || kind === (0, $7GP8Q.TokenKind).EQUALS || kind === (0, $7GP8Q.TokenKind).AT || kind === (0, $7GP8Q.TokenKind).BRACKET_L || kind === (0, $7GP8Q.TokenKind).BRACKET_R || kind === (0, $7GP8Q.TokenKind).BRACE_L || kind === (0, $7GP8Q.TokenKind).PIPE || kind === (0, $7GP8Q.TokenKind).BRACE_R;
}
function $22c8e17b5ed49457$var$printCharCode(code) {
    return isNaN(code) ? (0, $7GP8Q.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $22c8e17b5ed49457$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $22c8e17b5ed49457$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
    var code = body.charCodeAt(pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $22c8e17b5ed49457$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $22c8e17b5ed49457$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $22c8e17b5ed49457$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $22c8e17b5ed49457$var$readBlockString(source, pos, line, col, prev, lexer);
            return $22c8e17b5ed49457$var$readString(source, pos, line, col, prev);
    }
    throw (0, $5FyIR.syntaxError)(source, pos, $22c8e17b5ed49457$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $22c8e17b5ed49457$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($22c8e17b5ed49457$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($22c8e17b5ed49457$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */ function $22c8e17b5ed49457$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $22c8e17b5ed49457$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $22c8e17b5ed49457$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $5FyIR.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($22c8e17b5ed49457$var$printCharCode(code), "."));
    } else {
        position = $22c8e17b5ed49457$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $22c8e17b5ed49457$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $22c8e17b5ed49457$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $22c8e17b5ed49457$var$isNameStart(code)) throw (0, $5FyIR.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($22c8e17b5ed49457$var$printCharCode(code), "."));
    return new (0, $dzBoV.Token)(isFloat ? (0, $7GP8Q.TokenKind).FLOAT : (0, $7GP8Q.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $22c8e17b5ed49457$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $5FyIR.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($22c8e17b5ed49457$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $22c8e17b5ed49457$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $5FyIR.syntaxError)(source, position, "Invalid character within String: ".concat($22c8e17b5ed49457$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $22c8e17b5ed49457$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $5FyIR.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $5FyIR.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $5FyIR.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $22c8e17b5ed49457$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $jA4dn.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $5FyIR.syntaxError)(source, position, "Invalid character within String: ".concat($22c8e17b5ed49457$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $5FyIR.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $22c8e17b5ed49457$var$uniCharCode(a, b, c, d) {
    return $22c8e17b5ed49457$var$char2hex(a) << 12 | $22c8e17b5ed49457$var$char2hex(b) << 8 | $22c8e17b5ed49457$var$char2hex(c) << 4 | $22c8e17b5ed49457$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $22c8e17b5ed49457$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $22c8e17b5ed49457$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $dzBoV.Token)((0, $7GP8Q.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $22c8e17b5ed49457$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});
parcelRegister("jA4dn", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", function () { return $f48aca8a0569d927$export$fd88c0b652c46ccc; });
$parcel$export(module.exports, "printBlockString", function () { return $f48aca8a0569d927$export$adb6ca997eeb1f45; });
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $f48aca8a0569d927$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $f48aca8a0569d927$export$3c95bfdc680af0c(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $f48aca8a0569d927$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $f48aca8a0569d927$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join("\n");
}
function $f48aca8a0569d927$export$3c95bfdc680af0c(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $f48aca8a0569d927$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $f48aca8a0569d927$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === " " || str[i] === "	"))i++;
    return i;
}
function $f48aca8a0569d927$var$isBlank(str) {
    return $f48aca8a0569d927$var$leadingWhitespace(str) === str.length;
}
function $f48aca8a0569d927$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === "\\";
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});



parcelRegister("ab57Y", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $ed5f8c56abe99f70$export$c2d084dc44961371; });

var $7oeqK = parcelRequire("7oeqK");

var $jA4dn = parcelRequire("jA4dn");
function $ed5f8c56abe99f70$export$c2d084dc44961371(ast) {
    return (0, $7oeqK.visit)(ast, {
        leave: $ed5f8c56abe99f70$var$printDocASTReducer
    });
} // TODO: provide better type coverage in future
var $ed5f8c56abe99f70$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $ed5f8c56abe99f70$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(node.variableDefinitions, ", "), ")");
        var directives = $ed5f8c56abe99f70$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $ed5f8c56abe99f70$var$join([
            op,
            $ed5f8c56abe99f70$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $ed5f8c56abe99f70$var$wrap(" = ", defaultValue) + $ed5f8c56abe99f70$var$wrap(" ", $ed5f8c56abe99f70$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $ed5f8c56abe99f70$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $ed5f8c56abe99f70$var$join([
            $ed5f8c56abe99f70$var$wrap("", alias, ": ") + name + $ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(args, ", "), ")"),
            $ed5f8c56abe99f70$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $ed5f8c56abe99f70$var$wrap(" ", $ed5f8c56abe99f70$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $ed5f8c56abe99f70$var$join([
            "...",
            $ed5f8c56abe99f70$var$wrap("on ", typeCondition),
            $ed5f8c56abe99f70$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($ed5f8c56abe99f70$var$wrap("", $ed5f8c56abe99f70$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $jA4dn.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $ed5f8c56abe99f70$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $ed5f8c56abe99f70$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $ed5f8c56abe99f70$var$join([
            "schema",
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(operationTypes)
        ], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $ed5f8c56abe99f70$var$join([
            "scalar",
            name,
            $ed5f8c56abe99f70$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $ed5f8c56abe99f70$var$join([
            "type",
            name,
            $ed5f8c56abe99f70$var$wrap("implements ", $ed5f8c56abe99f70$var$join(interfaces, " & ")),
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($ed5f8c56abe99f70$var$hasMultilineItems(args) ? $ed5f8c56abe99f70$var$wrap("(\n", $ed5f8c56abe99f70$var$indent($ed5f8c56abe99f70$var$join(args, "\n")), "\n)") : $ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(args, ", "), ")")) + ": " + type + $ed5f8c56abe99f70$var$wrap(" ", $ed5f8c56abe99f70$var$join(directives, " "));
    }),
    InputValueDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $ed5f8c56abe99f70$var$join([
            name + ": " + type,
            $ed5f8c56abe99f70$var$wrap("= ", defaultValue),
            $ed5f8c56abe99f70$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $ed5f8c56abe99f70$var$join([
            "interface",
            name,
            $ed5f8c56abe99f70$var$wrap("implements ", $ed5f8c56abe99f70$var$join(interfaces, " & ")),
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $ed5f8c56abe99f70$var$join([
            "union",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $ed5f8c56abe99f70$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $ed5f8c56abe99f70$var$join([
            "enum",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $ed5f8c56abe99f70$var$join([
            name,
            $ed5f8c56abe99f70$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $ed5f8c56abe99f70$var$join([
            "input",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $ed5f8c56abe99f70$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($ed5f8c56abe99f70$var$hasMultilineItems(args) ? $ed5f8c56abe99f70$var$wrap("(\n", $ed5f8c56abe99f70$var$indent($ed5f8c56abe99f70$var$join(args, "\n")), "\n)") : $ed5f8c56abe99f70$var$wrap("(", $ed5f8c56abe99f70$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $ed5f8c56abe99f70$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $ed5f8c56abe99f70$var$join([
            "extend schema",
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $ed5f8c56abe99f70$var$join([
            "extend scalar",
            name,
            $ed5f8c56abe99f70$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $ed5f8c56abe99f70$var$join([
            "extend type",
            name,
            $ed5f8c56abe99f70$var$wrap("implements ", $ed5f8c56abe99f70$var$join(interfaces, " & ")),
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $ed5f8c56abe99f70$var$join([
            "extend interface",
            name,
            $ed5f8c56abe99f70$var$wrap("implements ", $ed5f8c56abe99f70$var$join(interfaces, " & ")),
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $ed5f8c56abe99f70$var$join([
            "extend union",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $ed5f8c56abe99f70$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $ed5f8c56abe99f70$var$join([
            "extend enum",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $ed5f8c56abe99f70$var$join([
            "extend input",
            name,
            $ed5f8c56abe99f70$var$join(directives, " "),
            $ed5f8c56abe99f70$var$block(fields)
        ], " ");
    }
};
function $ed5f8c56abe99f70$var$addDescription(cb) {
    return function(node) {
        return $ed5f8c56abe99f70$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $ed5f8c56abe99f70$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $ed5f8c56abe99f70$var$block(array) {
    return array && array.length !== 0 ? "{\n" + $ed5f8c56abe99f70$var$indent($ed5f8c56abe99f70$var$join(array, "\n")) + "\n}" : "";
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $ed5f8c56abe99f70$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    return maybeString ? start + maybeString + end : "";
}
function $ed5f8c56abe99f70$var$indent(maybeString) {
    return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
}
function $ed5f8c56abe99f70$var$isMultiline(string) {
    return string.indexOf("\n") !== -1;
}
function $ed5f8c56abe99f70$var$hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some($ed5f8c56abe99f70$var$isMultiline);
}

});
parcelRegister("7oeqK", function(module, exports) {

$parcel$export(module.exports, "visit", function () { return $f072bc00804dc1c7$export$bf638b60ea8b89b7; });

var $2iMOi = parcelRequire("2iMOi");

var $dzBoV = parcelRequire("dzBoV");
var $f072bc00804dc1c7$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $f072bc00804dc1c7$export$a89c95c098ac2a58 = Object.freeze({});
function $f072bc00804dc1c7$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f072bc00804dc1c7$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $dzBoV.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $2iMOi.default)(node), "."));
            var visitFn = $f072bc00804dc1c7$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $f072bc00804dc1c7$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $dzBoV.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $f072bc00804dc1c7$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $f072bc00804dc1c7$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $f072bc00804dc1c7$export$a89c95c098ac2a58) skipping[i] = $f072bc00804dc1c7$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $f072bc00804dc1c7$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $f072bc00804dc1c7$export$a89c95c098ac2a58) skipping[i] = $f072bc00804dc1c7$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $f072bc00804dc1c7$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});



parcelRegister("kE4VN", function(module, exports) {
"use strict";
var $f07b5e54d9bdca7e$var$__assign = module.exports && module.exports.__assign || function() {
    $f07b5e54d9bdca7e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f07b5e54d9bdca7e$var$__assign.apply(this, arguments);
};
var $f07b5e54d9bdca7e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f07b5e54d9bdca7e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLWebSocketClient = void 0;

var $iaMvf = parcelRequire("iaMvf");

var $gfzLa = parcelRequire("gfzLa");
var $f07b5e54d9bdca7e$var$CONNECTION_INIT = "connection_init";
var $f07b5e54d9bdca7e$var$CONNECTION_ACK = "connection_ack";
var $f07b5e54d9bdca7e$var$PING = "ping";
var $f07b5e54d9bdca7e$var$PONG = "pong";
var $f07b5e54d9bdca7e$var$SUBSCRIBE = "subscribe";
var $f07b5e54d9bdca7e$var$NEXT = "next";
var $f07b5e54d9bdca7e$var$ERROR = "error";
var $f07b5e54d9bdca7e$var$COMPLETE = "complete";
var $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage = /** @class */ function() {
    function GraphQLWebSocketMessage(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "type", {
        get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "id", {
        get: function() {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "payload", {
        get: function() {
            return this._payload;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphQLWebSocketMessage.prototype, "text", {
        get: function() {
            var result = {
                type: this.type
            };
            if (this.id != null && this.id != undefined) result.id = this.id;
            if (this.payload != null && this.payload != undefined) result.payload = this.payload;
            return JSON.stringify(result);
        },
        enumerable: false,
        configurable: true
    });
    GraphQLWebSocketMessage.parse = function(data, f) {
        var _a = JSON.parse(data), type = _a.type, payload = _a.payload, id = _a.id;
        return new GraphQLWebSocketMessage(type, f(payload), id);
    };
    return GraphQLWebSocketMessage;
}();
var $f07b5e54d9bdca7e$var$GraphQLWebSocketClient = /** @class */ function() {
    function GraphQLWebSocketClient(socket, _a) {
        var onInit = _a.onInit, onAcknowledged = _a.onAcknowledged, onPing = _a.onPing, onPong = _a.onPong;
        var _this = this;
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.onopen = function(e) {
            return $f07b5e54d9bdca7e$var$__awaiter(_this, void 0, void 0, function() {
                var _a, _b, _c, _d;
                return $f07b5e54d9bdca7e$var$__generator(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            this.socketState.acknowledged = false;
                            this.socketState.subscriptions = {};
                            _b = (_a = socket).send;
                            _c = $f07b5e54d9bdca7e$var$ConnectionInit;
                            if (!onInit) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                onInit()
                            ];
                        case 1:
                            _d = _e.sent();
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 2:
                            _d = null;
                            _e.label = 3;
                        case 3:
                            _b.apply(_a, [
                                _c.apply(void 0, [
                                    _d
                                ]).text
                            ]);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        socket.onclose = function(e) {
            _this.socketState.acknowledged = false;
            _this.socketState.subscriptions = {};
        };
        socket.onerror = function(e) {
            console.error(e);
        };
        socket.onmessage = function(e) {
            try {
                var message = $f07b5e54d9bdca7e$var$parseMessage(e.data);
                switch(message.type){
                    case $f07b5e54d9bdca7e$var$CONNECTION_ACK:
                        if (_this.socketState.acknowledged) console.warn("Duplicate CONNECTION_ACK message ignored");
                        else {
                            _this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $f07b5e54d9bdca7e$var$PING:
                        if (onPing) onPing(message.payload).then(function(r) {
                            return socket.send($f07b5e54d9bdca7e$var$Pong(r).text);
                        });
                        else socket.send($f07b5e54d9bdca7e$var$Pong(null).text);
                        return;
                    case $f07b5e54d9bdca7e$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!_this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !_this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                var _a = _this.socketState.subscriptions[message.id], query = _a.query, variables = _a.variables, subscriber = _a.subscriber;
                switch(message.type){
                    case $f07b5e54d9bdca7e$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $iaMvf.ClientError($f07b5e54d9bdca7e$var$__assign($f07b5e54d9bdca7e$var$__assign({}, message.payload), {
                            status: 200
                        }), {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $f07b5e54d9bdca7e$var$ERROR:
                        subscriber.error && subscriber.error(new $iaMvf.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $f07b5e54d9bdca7e$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete _this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, "Unknown graphql-ws message.");
        };
    }
    GraphQLWebSocketClient.prototype.makeSubscribe = function(query, operationName, subscriber, variables) {
        var _this = this;
        var subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($f07b5e54d9bdca7e$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return function() {
            _this.socket.send($f07b5e54d9bdca7e$var$Complete(subscriptionId).text);
            delete _this.socketState.subscriptions[subscriptionId];
        };
    };
    GraphQLWebSocketClient.prototype.rawRequest = function(query, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.rawSubscribe(query, {
                next: function(data, extensions) {
                    return result = {
                        data: data,
                        extensions: extensions
                    };
                },
                error: reject,
                complete: function() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.request = function(document, variables) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var result;
            _this.subscribe(document, {
                next: function(data) {
                    return result = data;
                },
                error: reject,
                complete: function() {
                    return resolve(result);
                }
            }, variables);
        });
    };
    GraphQLWebSocketClient.prototype.subscribe = function(document, subscriber, variables) {
        var _a = (0, $gfzLa.resolveRequestDocument)(document), query = _a.query, operationName = _a.operationName;
        return this.makeSubscribe(query, operationName, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.rawSubscribe = function(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    };
    GraphQLWebSocketClient.prototype.ping = function(payload) {
        this.socket.send($f07b5e54d9bdca7e$var$Ping(payload).text);
    };
    GraphQLWebSocketClient.prototype.close = function() {
        this.socket.close(1000);
    };
    GraphQLWebSocketClient.PROTOCOL = "graphql-transport-ws";
    return GraphQLWebSocketClient;
}();
module.exports.GraphQLWebSocketClient = $f07b5e54d9bdca7e$var$GraphQLWebSocketClient;
// Helper functions
function $f07b5e54d9bdca7e$var$parseMessage(data, f) {
    if (f === void 0) f = function(a) {
        return a;
    };
    var m = $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $f07b5e54d9bdca7e$var$ConnectionInit(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$CONNECTION_INIT, payload);
}
function $f07b5e54d9bdca7e$var$Ping(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$PING, payload, undefined);
}
function $f07b5e54d9bdca7e$var$Pong(payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$PONG, payload, undefined);
}
function $f07b5e54d9bdca7e$var$Subscribe(id, payload) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$SUBSCRIBE, payload, id);
}
function $f07b5e54d9bdca7e$var$Complete(id) {
    return new $f07b5e54d9bdca7e$var$GraphQLWebSocketMessage($f07b5e54d9bdca7e$var$COMPLETE, undefined, id);
}

});


parcelRegister("eOD8X", function(module, exports) {

$parcel$export(module.exports, "getApiUrl", function () { return $0ce47a71e031104c$export$1b98eaf73d37f034; });

var $d0LOX = parcelRequire("d0LOX");
const $0ce47a71e031104c$export$1b98eaf73d37f034 = ()=>{
    const domain = (0, $d0LOX.getDomain)();
    let apiUrl = "https://api.digitalreception.app";
    if (domain === "frontassist.eu") apiUrl = "https://api.frontassist.eu";
    return apiUrl;
};

});
parcelRegister("d0LOX", function(module, exports) {

$parcel$export(module.exports, "getDomain", function () { return $c1468d5f64b1e5e0$export$3e8733322718eb9; });
const $c1468d5f64b1e5e0$export$3e8733322718eb9 = ()=>{
    const { hostname: hostname } = window.location;
    const parts = hostname.split(".");
    if (parts.length > 2) return parts.slice(-2).join(".");
    return hostname;
};

});



parcelRegister("cwDEq", function(module, exports) {

$parcel$export(module.exports, "useAppContext", function () { return $63b6a33c60cc732c$export$fdc397e486fa83e7; });
$parcel$export(module.exports, "useAppConfig", function () { return $63b6a33c60cc732c$export$a3e0ece8c3f698d7; });
$parcel$export(module.exports, "default", function () { return $63b6a33c60cc732c$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1PAIo = parcelRequire("1PAIo");

var $gcLBF = parcelRequire("gcLBF");
var $gdPnm = parcelRequire("gdPnm");

var $e31rn = parcelRequire("e31rn");

var $5fmC2 = parcelRequire("5fmC2");
const $63b6a33c60cc732c$var$isDev = false;
const $63b6a33c60cc732c$var$Status = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    (0, $e31rn.default)();
    return null;
});
const $63b6a33c60cc732c$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(undefined);
const { Provider: $63b6a33c60cc732c$var$Provider } = $63b6a33c60cc732c$var$AppContext;
const $63b6a33c60cc732c$export$fdc397e486fa83e7 = ()=>(0, $eZVvM.useContext)($63b6a33c60cc732c$var$AppContext);
const $63b6a33c60cc732c$export$a3e0ece8c3f698d7 = ()=>$63b6a33c60cc732c$export$fdc397e486fa83e7().config;
const $63b6a33c60cc732c$var$App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ children: children })=>{
    const query = (0, $5fmC2.usePersistentQuery)();
    const basename = (0, $eZVvM.useMemo)(()=>{
        if ($63b6a33c60cc732c$var$isDev) return "/";
        return window.location.pathname.split("/").filter(Boolean).slice(0, 4).join("/");
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>{
        const { location: { pathname: pathname } } = window;
        const paths = pathname.split("/");
        const screenId = $63b6a33c60cc732c$var$isDev ? "1" : paths[4];
        const clientId = $63b6a33c60cc732c$var$isDev ? "1" : paths[2];
        return {
            screenId: screenId,
            clientId: clientId,
            config: {
                connect: !((query === null || query === void 0 ? void 0 : query.connect) === "false"),
                preview: !!(query === null || query === void 0 ? void 0 : query.preview)
            }
        };
    }, [
        query
    ]);
    const client = (0, $eZVvM.useMemo)(()=>{
        const options = {
            refetchInterval: 300000
        };
        const client = new (0, $gcLBF.QueryClient)({
            defaultOptions: {
                queries: options
            }
        });
        return client;
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($63b6a33c60cc732c$var$Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $gdPnm.QueryClientProvider), {
            client: client,
            children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $1PAIo.BrowserRouter), {
                basename: basename,
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)($63b6a33c60cc732c$var$Status, {}),
                    children
                ]
            })
        })
    });
});
var $63b6a33c60cc732c$export$2e2bcd8739ae039 = $63b6a33c60cc732c$var$App;

});
parcelRegister("gcLBF", function(module, exports) {

$parcel$export(module.exports, "QueryClient", function () { return $11566bfa4ceb3c13$export$405d0624ed55a03f; });

var $g3yHX = parcelRequire("g3yHX");

var $lbL00 = parcelRequire("lbL00");

var $1AR2H = parcelRequire("1AR2H");

var $aQMrm = parcelRequire("aQMrm");

var $6lhov = parcelRequire("6lhov");

var $bq3DV = parcelRequire("bq3DV");

var $4dUyM = parcelRequire("4dUyM");

var $8Zibu = parcelRequire("8Zibu");
// CLASS
class $11566bfa4ceb3c13$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $aQMrm.focusManager).subscribe(()=>{
            if ((0, $aQMrm.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6lhov.onlineManager).subscribe(()=>{
            if ((0, $6lhov.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $g3yHX.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $bq3DV.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $bq3DV.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $bq3DV.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $bq3DV.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $bq3DV.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $g3yHX.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $bq3DV.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $g3yHX.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $g3yHX.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $g3yHX.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $4dUyM.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $g3yHX.noop)).catch((0, $g3yHX.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $g3yHX.hashQueryKey)(queryKey) === (0, $g3yHX.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $g3yHX.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $g3yHX.hashQueryKey)(mutationKey) === (0, $g3yHX.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $g3yHX.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $g3yHX.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $lbL00.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $1AR2H.MutationCache)();
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}

});
parcelRegister("lbL00", function(module, exports) {

$parcel$export(module.exports, "QueryCache", function () { return $d62e30f4f1b95e54$export$5dde0cd941da8468; });

var $g3yHX = parcelRequire("g3yHX");

var $2pAwp = parcelRequire("2pAwp");

var $bq3DV = parcelRequire("bq3DV");

var $4QcTI = parcelRequire("4QcTI");
// CLASS
class $d62e30f4f1b95e54$export$5dde0cd941da8468 extends (0, $4QcTI.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $g3yHX.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $2pAwp.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $g3yHX.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $g3yHX.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $g3yHX.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}

});
parcelRegister("2pAwp", function(module, exports) {

$parcel$export(module.exports, "Query", function () { return $d931235dae4e7ac4$export$62297b13309008b2; });

var $g3yHX = parcelRequire("g3yHX");

var $8Zibu = parcelRequire("8Zibu");

var $bq3DV = parcelRequire("bq3DV");

var $lodjx = parcelRequire("lodjx");

var $6817H = parcelRequire("6817H");
// CLASS
class $d931235dae4e7ac4$export$62297b13309008b2 extends (0, $6817H.Removable) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $g3yHX.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $g3yHX.noop)).catch((0, $g3yHX.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $g3yHX.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $g3yHX.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $lodjx.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $lodjx.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $lodjx.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $lodjx.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $lodjx.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $bq3DV.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $d931235dae4e7ac4$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $d931235dae4e7ac4$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}

});
parcelRegister("8Zibu", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $89b4e3aacb76f2c9$export$1cf3d545f2d4635c; });
const $89b4e3aacb76f2c9$export$1cf3d545f2d4635c = console;

});

parcelRegister("6817H", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $8726b2c54d7df87a$export$e09608847fcc8c59; });

var $g3yHX = parcelRequire("g3yHX");
class $8726b2c54d7df87a$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $g3yHX.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $g3yHX.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});



parcelRegister("1AR2H", function(module, exports) {

$parcel$export(module.exports, "MutationCache", function () { return $4200bcb0fd468ff4$export$1fcfd9a244434844; });

var $bq3DV = parcelRequire("bq3DV");

var $30Kai = parcelRequire("30Kai");

var $g3yHX = parcelRequire("g3yHX");

var $4QcTI = parcelRequire("4QcTI");
// CLASS
class $4200bcb0fd468ff4$export$1fcfd9a244434844 extends (0, $4QcTI.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $30Kai.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $g3yHX.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $g3yHX.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $bq3DV.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $bq3DV.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $g3yHX.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}

});
parcelRegister("30Kai", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $4b158c2694492c68$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $4b158c2694492c68$export$a1659b54bac3252a; });

var $8Zibu = parcelRequire("8Zibu");

var $bq3DV = parcelRequire("bq3DV");

var $6817H = parcelRequire("6817H");

var $lodjx = parcelRequire("lodjx");
// CLASS
class $4b158c2694492c68$export$17b8b19c814bcf56 extends (0, $6817H.Removable) {
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $lodjx.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $lodjx.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $bq3DV.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $8Zibu.defaultLogger);
        this.observers = [];
        this.state = config.state || $4b158c2694492c68$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $4b158c2694492c68$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

});


parcelRegister("4dUyM", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", function () { return $74ae56171a5adfe6$export$84470d1367601e8d; });
function $74ae56171a5adfe6$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $74ae56171a5adfe6$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $74ae56171a5adfe6$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $74ae56171a5adfe6$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $74ae56171a5adfe6$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $74ae56171a5adfe6$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $74ae56171a5adfe6$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $74ae56171a5adfe6$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $74ae56171a5adfe6$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $74ae56171a5adfe6$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

});


parcelRegister("e31rn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bd17f7e07228354$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");

var $f19az = parcelRequire("f19az");

var $jJnsE = parcelRequire("jJnsE");

var $bIHE3 = parcelRequire("bIHE3");

var $ghHeQ = parcelRequire("ghHeQ");

var $cwDEq = parcelRequire("cwDEq");

var $l4qYG = parcelRequire("l4qYG");

var $eOD8X = parcelRequire("eOD8X");
const $8bd17f7e07228354$var$useBoardStatus = ()=>{
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { screenId: screenId, clientId: clientId, config: config } = (0, $cwDEq.useAppContext)();
    const { scheduleScreensaver: scheduleScreensaver } = (0, $l4qYG.useSchedulesContext)();
    const navigate = (0, $9B9bN.useNavigate)();
    const socketRef = (0, $eZVvM.useRef)(null);
    const onMessage = (0, $eZVvM.useCallback)(async (event)=>{
        const { data: rawMessage } = event;
        try {
            const message = JSON.parse(rawMessage);
            if (!(message && message.action)) return;
            const predicate = ({ queryKey: queryKey })=>{
                if (!(Array.isArray(queryKey) && queryKey.length)) return false;
                const [key, params] = queryKey;
                if (key !== "digitalReception") return false;
                return "id" in params && params.id === screenId;
            };
            switch(message.action){
                case "restart":
                    window.location.href = (0, $f19az.default).stringifyUrl({
                        url: `${window.location.origin}/client/${clientId}/board/${screenId}`,
                        query: config
                    });
                    break;
                case "refresh":
                    {
                        const { digitalReception: digitalReception } = await queryClient.fetchQuery([
                            "digitalReception",
                            {
                                id: screenId
                            }
                        ]);
                        if (config.preview) break;
                        const sleepSchedules = (0, (/*@__PURE__*/$parcel$interopDefault($bIHE3)))(digitalReception === null || digitalReception === void 0 ? void 0 : digitalReception.schedules, (item)=>item.type === "sleep" && !item.schedule.disabled);
                        if (sleepSchedules.length > 0) scheduleScreensaver(sleepSchedules);
                        break;
                    }
                case "update-digitalReception":
                    {
                        const { data: data } = message;
                        queryClient.setQueriesData({
                            predicate: predicate
                        }, (prev)=>{
                            var _partialDigitalReception_settings_layout_multiWayfinding, _partialDigitalReception_settings_layout, _partialDigitalReception_settings, _updated_settings, _updated_settings_layout, _updated_settings1, _sanitizedPartial_settings_layout_multiWayfinding, _sanitizedPartial_settings_layout, _sanitizedPartial_settings;
                            // prettier-ignore
                            if (!(prev && prev.digitalReception && data && data.digitalReception)) return data;
                            const { digitalReception: prevDigitalReception, ...rest } = prev;
                            const { digitalReception: partialDigitalReception } = data;
                            const newOptions = partialDigitalReception === null || partialDigitalReception === void 0 ? void 0 : (_partialDigitalReception_settings = partialDigitalReception.settings) === null || _partialDigitalReception_settings === void 0 ? void 0 : (_partialDigitalReception_settings_layout = _partialDigitalReception_settings.layout) === null || _partialDigitalReception_settings_layout === void 0 ? void 0 : (_partialDigitalReception_settings_layout_multiWayfinding = _partialDigitalReception_settings_layout.multiWayfinding) === null || _partialDigitalReception_settings_layout_multiWayfinding === void 0 ? void 0 : _partialDigitalReception_settings_layout_multiWayfinding.wayfindingOptions;
                            const updated = structuredClone(prevDigitalReception);
                            var _updated_settings2, _updated_settings_layout1, _updated_settings_layout_multiWayfinding;
                            if (Array.isArray(newOptions)) updated.settings = {
                                ...(_updated_settings2 = updated.settings) !== null && _updated_settings2 !== void 0 ? _updated_settings2 : {},
                                layout: {
                                    ...(_updated_settings_layout1 = (_updated_settings = updated.settings) === null || _updated_settings === void 0 ? void 0 : _updated_settings.layout) !== null && _updated_settings_layout1 !== void 0 ? _updated_settings_layout1 : {},
                                    // @ts-ignore
                                    multiWayfinding: {
                                        ...(_updated_settings_layout_multiWayfinding = (_updated_settings1 = updated.settings) === null || _updated_settings1 === void 0 ? void 0 : (_updated_settings_layout = _updated_settings1.layout) === null || _updated_settings_layout === void 0 ? void 0 : _updated_settings_layout.multiWayfinding) !== null && _updated_settings_layout_multiWayfinding !== void 0 ? _updated_settings_layout_multiWayfinding : {},
                                        wayfindingOptions: newOptions
                                    }
                                }
                            };
                            const sanitizedPartial = structuredClone(partialDigitalReception);
                            if (sanitizedPartial === null || sanitizedPartial === void 0 ? void 0 : (_sanitizedPartial_settings = sanitizedPartial.settings) === null || _sanitizedPartial_settings === void 0 ? void 0 : (_sanitizedPartial_settings_layout = _sanitizedPartial_settings.layout) === null || _sanitizedPartial_settings_layout === void 0 ? void 0 : (_sanitizedPartial_settings_layout_multiWayfinding = _sanitizedPartial_settings_layout.multiWayfinding) === null || _sanitizedPartial_settings_layout_multiWayfinding === void 0 ? void 0 : _sanitizedPartial_settings_layout_multiWayfinding.wayfindingOptions) {
                                delete sanitizedPartial.settings.layout.multiWayfinding.wayfindingOptions;
                                if (Object.keys(sanitizedPartial.settings.layout.multiWayfinding).length === 0) delete sanitizedPartial.settings.layout.multiWayfinding;
                                if (Object.keys(sanitizedPartial.settings.layout).length === 0) delete sanitizedPartial.settings.layout;
                                if (Object.keys(sanitizedPartial.settings).length === 0) delete sanitizedPartial.settings;
                            }
                            const digitalReception = (0, (/*@__PURE__*/$parcel$interopDefault($jJnsE)))(updated, sanitizedPartial, (obj, src)=>{
                                if (Array.isArray(obj)) return src;
                                if ((0, (/*@__PURE__*/$parcel$interopDefault($ghHeQ)))(obj)) return (0, (/*@__PURE__*/$parcel$interopDefault($jJnsE)))(obj, src);
                                return src;
                            });
                            return {
                                ...rest,
                                digitalReception: digitalReception
                            };
                        });
                        break;
                    }
                case "document-scan":
                    {
                        const { data: data } = message;
                        if (!data) return;
                        if (data.status !== "valid") {
                            navigate("/access/checkin/manual", {
                                state: {
                                    documentScanStatus: "invalid"
                                }
                            });
                            break;
                        }
                        const state = {};
                        if (data.fullName) state.fullname = {
                            id: data.fullName.id,
                            value: data.fullName.value
                        };
                        if (data.documentNumber) state.documentNumber = {
                            id: data.documentNumber.id,
                            value: data.documentNumber.value
                        };
                        if (data.nationality) state.nationality = {
                            id: data.nationality.id,
                            value: data.nationality.value
                        };
                        if (data.gender) state.gender = {
                            id: data.gender.id,
                            value: data.gender.value
                        };
                        if (data.personalNumber) state.personalNumber = {
                            id: data.personalNumber.id,
                            value: data.personalNumber.value
                        };
                        if (Object.keys(state).length > 0) navigate("/access/checkin/manual", {
                            state: state
                        });
                        break;
                    }
                case "get-printers":
                    {
                        var _socketRef_current;
                        const { requestId: requestId } = message.data || {};
                        let printers = [];
                        try {
                            var _nw;
                            // @ts-ignore
                            if ((_nw = nw) === null || _nw === void 0 ? void 0 : _nw.Window) {
                                // @ts-ignore
                                const win = nw.Window.get();
                                win.getPrinters((list)=>{
                                    var _socketRef_current;
                                    printers = list.map((p)=>p.printerName);
                                    (_socketRef_current = socketRef.current) === null || _socketRef_current === void 0 ? void 0 : _socketRef_current.send(JSON.stringify({
                                        action: "printers-response",
                                        data: {
                                            requestId: requestId,
                                            printers: printers
                                        }
                                    }));
                                });
                                return;
                            }
                        } catch (e) {
                        //
                        }
                        (_socketRef_current = socketRef.current) === null || _socketRef_current === void 0 ? void 0 : _socketRef_current.send(JSON.stringify({
                            action: "printers-response",
                            data: {
                                requestId: requestId,
                                printers: []
                            }
                        }));
                        break;
                    }
                default:
                    break;
            }
        } catch (e) {
        //
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, []);
    return (0, $dMu0R.useQuery)([
        `network/board/${screenId}`
    ], ({ queryKey: [url] })=>{
        return new Promise((resolve, reject)=>{
            const apiUrl = (0, $eOD8X.getApiUrl)();
            const baseURL = apiUrl.replace(/(http)(s)?\:\/\//, "ws$2://");
            const socket = new WebSocket(`${baseURL}/${url}/`);
            if (socket.readyState === WebSocket.OPEN) {
                socketRef.current = socket;
                resolve(true);
                return;
            }
            socket.onopen = function(e) {
                const previous = socketRef.current;
                socketRef.current = socket;
                if (previous && previous !== socket) {
                    previous.onclose = null;
                    previous.onerror = null;
                    previous.onmessage = null;
                    previous.close();
                }
                return resolve(e);
            };
            socket.onerror = function(error) {
                queryClient.invalidateQueries([
                    url
                ], {
                    exact: true
                });
                return reject(error);
            };
            socket.onmessage = function(event) {
                onMessage(event);
            };
            socket.onclose = ()=>{
                queryClient.invalidateQueries([
                    url
                ], {
                    exact: true
                });
                return reject(new Error("Socket close. Retry"));
            };
        });
    }, {
        retry: true,
        retryDelay: 5000,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        enabled: (config === null || config === void 0 ? void 0 : config.connect) && !!screenId
    });
};
var $8bd17f7e07228354$export$2e2bcd8739ae039 = $8bd17f7e07228354$var$useBoardStatus;

});
parcelRegister("f19az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeee0fdc8238e58f$export$2e2bcd8739ae039; });

var $aeDS2 = parcelRequire("aeDS2");
var $aeee0fdc8238e58f$export$2e2bcd8739ae039 = $aeDS2;

});
parcelRegister("aeDS2", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $773a23ad4506684d$export$f9380c9a627682d3; });
$parcel$export(module.exports, "parse", function () { return $773a23ad4506684d$export$98e6a39c04603d36; });
$parcel$export(module.exports, "stringify", function () { return $773a23ad4506684d$export$fac44ee5b035f737; });
$parcel$export(module.exports, "parseUrl", function () { return $773a23ad4506684d$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "stringifyUrl", function () { return $773a23ad4506684d$export$a8c1621ea79325d3; });
$parcel$export(module.exports, "pick", function () { return $773a23ad4506684d$export$357523c63a2253b9; });
$parcel$export(module.exports, "exclude", function () { return $773a23ad4506684d$export$44c361b8ec72ef7f; });

var $6RNQN = parcelRequire("6RNQN");

var $dnsI4 = parcelRequire("dnsI4");

var $9Zy2X = parcelRequire("9Zy2X");
const $773a23ad4506684d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $773a23ad4506684d$var$strictUriEncode = (string)=>encodeURIComponent(string).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $773a23ad4506684d$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $773a23ad4506684d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[",
                            $773a23ad4506684d$var$encode(index, options),
                            "]=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "[]=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            ":list=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $773a23ad4506684d$var$encode(key, options),
                                keyValueSep,
                                $773a23ad4506684d$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $773a23ad4506684d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $773a23ad4506684d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $773a23ad4506684d$var$encode(key, options),
                            "=",
                            $773a23ad4506684d$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $773a23ad4506684d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $773a23ad4506684d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $773a23ad4506684d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$773a23ad4506684d$var$decode(item, options)) : value === null ? value : $773a23ad4506684d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $773a23ad4506684d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$773a23ad4506684d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $773a23ad4506684d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $773a23ad4506684d$var$encode(value, options) {
    if (options.encode) return options.strict ? $773a23ad4506684d$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $773a23ad4506684d$var$decode(value, options) {
    if (options.decode) return (0, $6RNQN.default)(value);
    return value;
}
function $773a23ad4506684d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $773a23ad4506684d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $773a23ad4506684d$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $773a23ad4506684d$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $773a23ad4506684d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $773a23ad4506684d$export$f9380c9a627682d3(input) {
    input = $773a23ad4506684d$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $773a23ad4506684d$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false,
        ...options
    };
    $773a23ad4506684d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $773a23ad4506684d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== "string") return returnValue;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return returnValue;
    for (const parameter of query.split("&")){
        if (parameter === "") continue;
        const parameter_ = options.decode ? parameter.replace(/\+/g, " ") : parameter;
        let [key, value] = (0, $dnsI4.default)(parameter_, "=");
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $773a23ad4506684d$var$decode(value, options);
        formatter($773a23ad4506684d$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === "object" && value !== null) for (const [key2, value2] of Object.entries(value))value[key2] = $773a23ad4506684d$var$parseValue(value2, options);
        else returnValue[key] = $773a23ad4506684d$var$parseValue(value, options);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === "object" && !Array.isArray(value) ? $773a23ad4506684d$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $773a23ad4506684d$export$fac44ee5b035f737(object, options) {
    if (!object) return "";
    options = {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        ...options
    };
    $773a23ad4506684d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $773a23ad4506684d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $773a23ad4506684d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $773a23ad4506684d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $773a23ad4506684d$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $773a23ad4506684d$var$encode(key, options) + "=" + $773a23ad4506684d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
}
function $773a23ad4506684d$export$7a5253c0f62e0150(url, options) {
    var _url__split;
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $dnsI4.default)(url, "#");
    if (url_ === undefined) url_ = url;
    var _url__split_;
    return {
        url: (_url__split_ = url_ === null || url_ === void 0 ? void 0 : (_url__split = url_.split("?")) === null || _url__split === void 0 ? void 0 : _url__split[0]) !== null && _url__split_ !== void 0 ? _url__split_ : "",
        query: $773a23ad4506684d$export$98e6a39c04603d36($773a23ad4506684d$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $773a23ad4506684d$var$decode(hash, options)
        } : {}
    };
}
function $773a23ad4506684d$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$773a23ad4506684d$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $773a23ad4506684d$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $773a23ad4506684d$export$f9380c9a627682d3(object.url);
    const query = {
        ...$773a23ad4506684d$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $773a23ad4506684d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $773a23ad4506684d$var$getHash(object.url);
    if (object.fragmentIdentifier) {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$773a23ad4506684d$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $773a23ad4506684d$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$773a23ad4506684d$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $773a23ad4506684d$export$7a5253c0f62e0150(input, options);
    return $773a23ad4506684d$export$a8c1621ea79325d3({
        url: url,
        query: (0, $9Zy2X.includeKeys)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $773a23ad4506684d$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $773a23ad4506684d$export$357523c63a2253b9(input, exclusionFilter, options);
}

});
parcelRegister("6RNQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ffe5c9845671cef$export$2e2bcd8739ae039; });
const $4ffe5c9845671cef$var$token = "%[a-f0-9]{2}";
const $4ffe5c9845671cef$var$singleMatcher = new RegExp("(" + $4ffe5c9845671cef$var$token + ")|([^%]+?)", "gi");
const $4ffe5c9845671cef$var$multiMatcher = new RegExp("(" + $4ffe5c9845671cef$var$token + ")+", "gi");
function $4ffe5c9845671cef$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (e) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $4ffe5c9845671cef$var$decodeComponents(left), $4ffe5c9845671cef$var$decodeComponents(right));
}
function $4ffe5c9845671cef$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (e) {
        let tokens = input.match($4ffe5c9845671cef$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $4ffe5c9845671cef$var$decodeComponents(tokens, i).join("");
            tokens = input.match($4ffe5c9845671cef$var$singleMatcher) || [];
        }
        return input;
    }
}
function $4ffe5c9845671cef$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    let match = $4ffe5c9845671cef$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (e) {
            const result = $4ffe5c9845671cef$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $4ffe5c9845671cef$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    return input;
}
function $4ffe5c9845671cef$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (e) {
        // Fallback to a more advanced decoder
        return $4ffe5c9845671cef$var$customDecodeURIComponent(encodedURI);
    }
}

});

parcelRegister("dnsI4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bd3b180673dda83$export$2e2bcd8739ae039; });
function $9bd3b180673dda83$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (string === "" || separator === "") return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}

});

parcelRegister("9Zy2X", function(module, exports) {

$parcel$export(module.exports, "includeKeys", function () { return $7464388b703ff115$export$ff05df6c2df24b52; });
function $7464388b703ff115$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $7464388b703ff115$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $7464388b703ff115$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $7464388b703ff115$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}

});



parcelRegister("jJnsE", function(module, exports) {

var $2zZZr = parcelRequire("2zZZr");

var $87EVA = parcelRequire("87EVA");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $e5d46b276d2f04f7$var$mergeWith = $87EVA(function(object, source, srcIndex, customizer) {
    $2zZZr(object, source, srcIndex, customizer);
});
module.exports = $e5d46b276d2f04f7$var$mergeWith;

});
parcelRegister("2zZZr", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $7PCa6 = parcelRequire("7PCa6");

var $hIy2P = parcelRequire("hIy2P");

var $6khZu = parcelRequire("6khZu");

var $ghHeQ = parcelRequire("ghHeQ");

var $gG7av = parcelRequire("gG7av");

var $7zKJO = parcelRequire("7zKJO");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $1e0eef8f3d27fcc7$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $hIy2P(source, function(srcValue, key) {
        stack || (stack = new $29kQd);
        if ($ghHeQ(srcValue)) $6khZu(object, source, key, srcIndex, $1e0eef8f3d27fcc7$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($7zKJO(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7PCa6(object, key, newValue);
        }
    }, $gG7av);
}
module.exports = $1e0eef8f3d27fcc7$var$baseMerge;

});
parcelRegister("29kQd", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");

var $40Drz = parcelRequire("40Drz");

var $1juPT = parcelRequire("1juPT");

var $1hWlM = parcelRequire("1hWlM");

var $iZe0I = parcelRequire("iZe0I");

var $3PQst = parcelRequire("3PQst");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $190c96a43ace7fa1$var$Stack(entries) {
    var data = this.__data__ = new $RaYJF(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$190c96a43ace7fa1$var$Stack.prototype.clear = $40Drz;
$190c96a43ace7fa1$var$Stack.prototype["delete"] = $1juPT;
$190c96a43ace7fa1$var$Stack.prototype.get = $1hWlM;
$190c96a43ace7fa1$var$Stack.prototype.has = $iZe0I;
$190c96a43ace7fa1$var$Stack.prototype.set = $3PQst;
module.exports = $190c96a43ace7fa1$var$Stack;

});
parcelRegister("RaYJF", function(module, exports) {

var $1wSTR = parcelRequire("1wSTR");

var $i2a4T = parcelRequire("i2a4T");

var $iX798 = parcelRequire("iX798");

var $6yIzX = parcelRequire("6yIzX");

var $apJYE = parcelRequire("apJYE");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $09fd77796af7d56f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$09fd77796af7d56f$var$ListCache.prototype.clear = $1wSTR;
$09fd77796af7d56f$var$ListCache.prototype["delete"] = $i2a4T;
$09fd77796af7d56f$var$ListCache.prototype.get = $iX798;
$09fd77796af7d56f$var$ListCache.prototype.has = $6yIzX;
$09fd77796af7d56f$var$ListCache.prototype.set = $apJYE;
module.exports = $09fd77796af7d56f$var$ListCache;

});
parcelRegister("1wSTR", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $11d35d9ae7bbb9d6$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $11d35d9ae7bbb9d6$var$listCacheClear;

});

parcelRegister("i2a4T", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/** Used for built-in method references. */ var $d2103b2e36e7943b$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d2103b2e36e7943b$var$splice = $d2103b2e36e7943b$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d2103b2e36e7943b$var$listCacheDelete(key) {
    var data = this.__data__, index = $4xB6E(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d2103b2e36e7943b$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d2103b2e36e7943b$var$listCacheDelete;

});
parcelRegister("4xB6E", function(module, exports) {

var $8z8Gw = parcelRequire("8z8Gw");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $34e7070bbc939c9d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($8z8Gw(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $34e7070bbc939c9d$var$assocIndexOf;

});
parcelRegister("8z8Gw", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $63c85442e636aa60$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $63c85442e636aa60$var$eq;

});



parcelRegister("iX798", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dcc347c91c14deb0$var$listCacheGet(key) {
    var data = this.__data__, index = $4xB6E(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $dcc347c91c14deb0$var$listCacheGet;

});

parcelRegister("6yIzX", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4c687f7bb715a15c$var$listCacheHas(key) {
    return $4xB6E(this.__data__, key) > -1;
}
module.exports = $4c687f7bb715a15c$var$listCacheHas;

});

parcelRegister("apJYE", function(module, exports) {

var $4xB6E = parcelRequire("4xB6E");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $794fe74ebac1ae7e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4xB6E(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $794fe74ebac1ae7e$var$listCacheSet;

});


parcelRegister("40Drz", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2eb5c2363f13d634$var$stackClear() {
    this.__data__ = new $RaYJF;
    this.size = 0;
}
module.exports = $2eb5c2363f13d634$var$stackClear;

});

parcelRegister("1juPT", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0f4f7c29d1b71fd1$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $0f4f7c29d1b71fd1$var$stackDelete;

});

parcelRegister("1hWlM", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0f04a42152cc55ca$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $0f04a42152cc55ca$var$stackGet;

});

parcelRegister("iZe0I", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $03912c8f432f9172$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $03912c8f432f9172$var$stackHas;

});

parcelRegister("3PQst", function(module, exports) {

var $RaYJF = parcelRequire("RaYJF");

var $kbZZK = parcelRequire("kbZZK");

var $dtBcs = parcelRequire("dtBcs");
/** Used as the size to enable large array optimizations. */ var $2caed3a103a9951a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $2caed3a103a9951a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $RaYJF) {
        var pairs = data.__data__;
        if (!$kbZZK || pairs.length < $2caed3a103a9951a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $dtBcs(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $2caed3a103a9951a$var$stackSet;

});
parcelRegister("kbZZK", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $eb34eca7f622df2a$var$Map = $llv3Q($1sHSN, "Map");
module.exports = $eb34eca7f622df2a$var$Map;

});
parcelRegister("llv3Q", function(module, exports) {

var $1Rvpy = parcelRequire("1Rvpy");

var $nfEOY = parcelRequire("nfEOY");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f8a3a73a62185d7a$var$getNative(object, key) {
    var value = $nfEOY(object, key);
    return $1Rvpy(value) ? value : undefined;
}
module.exports = $f8a3a73a62185d7a$var$getNative;

});
parcelRegister("1Rvpy", function(module, exports) {

var $2MN1q = parcelRequire("2MN1q");

var $2A0QU = parcelRequire("2A0QU");

var $ghHeQ = parcelRequire("ghHeQ");

var $kpFqz = parcelRequire("kpFqz");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $15b31b4ee095c0a2$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $15b31b4ee095c0a2$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $15b31b4ee095c0a2$var$funcProto = Function.prototype, $15b31b4ee095c0a2$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $15b31b4ee095c0a2$var$funcToString = $15b31b4ee095c0a2$var$funcProto.toString;
/** Used to check objects for own properties. */ var $15b31b4ee095c0a2$var$hasOwnProperty = $15b31b4ee095c0a2$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $15b31b4ee095c0a2$var$reIsNative = RegExp("^" + $15b31b4ee095c0a2$var$funcToString.call($15b31b4ee095c0a2$var$hasOwnProperty).replace($15b31b4ee095c0a2$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $15b31b4ee095c0a2$var$baseIsNative(value) {
    if (!$ghHeQ(value) || $2A0QU(value)) return false;
    var pattern = $2MN1q(value) ? $15b31b4ee095c0a2$var$reIsNative : $15b31b4ee095c0a2$var$reIsHostCtor;
    return pattern.test($kpFqz(value));
}
module.exports = $15b31b4ee095c0a2$var$baseIsNative;

});
parcelRegister("2MN1q", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $ghHeQ = parcelRequire("ghHeQ");
/** `Object#toString` result references. */ var $2076173ac570d4ec$var$asyncTag = "[object AsyncFunction]", $2076173ac570d4ec$var$funcTag = "[object Function]", $2076173ac570d4ec$var$genTag = "[object GeneratorFunction]", $2076173ac570d4ec$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $2076173ac570d4ec$var$isFunction(value) {
    if (!$ghHeQ(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $jasl7(value);
    return tag == $2076173ac570d4ec$var$funcTag || tag == $2076173ac570d4ec$var$genTag || tag == $2076173ac570d4ec$var$asyncTag || tag == $2076173ac570d4ec$var$proxyTag;
}
module.exports = $2076173ac570d4ec$var$isFunction;

});
parcelRegister("jasl7", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $4YJwg = parcelRequire("4YJwg");

var $fsmmK = parcelRequire("fsmmK");
/** `Object#toString` result references. */ var $df44ef2cb3a51367$var$nullTag = "[object Null]", $df44ef2cb3a51367$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $df44ef2cb3a51367$var$symToStringTag = $lLnMZ ? $lLnMZ.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $df44ef2cb3a51367$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $df44ef2cb3a51367$var$undefinedTag : $df44ef2cb3a51367$var$nullTag;
    return $df44ef2cb3a51367$var$symToStringTag && $df44ef2cb3a51367$var$symToStringTag in Object(value) ? $4YJwg(value) : $fsmmK(value);
}
module.exports = $df44ef2cb3a51367$var$baseGetTag;

});
parcelRegister("lLnMZ", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Built-in value references. */ var $fd8070c4f2debf93$var$Symbol = $1sHSN.Symbol;
module.exports = $fd8070c4f2debf93$var$Symbol;

});

parcelRegister("4YJwg", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");
/** Used for built-in method references. */ var $3a0013353adbd6d6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3a0013353adbd6d6$var$hasOwnProperty = $3a0013353adbd6d6$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3a0013353adbd6d6$var$nativeObjectToString = $3a0013353adbd6d6$var$objectProto.toString;
/** Built-in value references. */ var $3a0013353adbd6d6$var$symToStringTag = $lLnMZ ? $lLnMZ.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3a0013353adbd6d6$var$getRawTag(value) {
    var isOwn = $3a0013353adbd6d6$var$hasOwnProperty.call(value, $3a0013353adbd6d6$var$symToStringTag), tag = value[$3a0013353adbd6d6$var$symToStringTag];
    try {
        value[$3a0013353adbd6d6$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3a0013353adbd6d6$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3a0013353adbd6d6$var$symToStringTag] = tag;
        else delete value[$3a0013353adbd6d6$var$symToStringTag];
    }
    return result;
}
module.exports = $3a0013353adbd6d6$var$getRawTag;

});

parcelRegister("fsmmK", function(module, exports) {
/** Used for built-in method references. */ var $b40ad1ee8d75fecf$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b40ad1ee8d75fecf$var$nativeObjectToString = $b40ad1ee8d75fecf$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b40ad1ee8d75fecf$var$objectToString(value) {
    return $b40ad1ee8d75fecf$var$nativeObjectToString.call(value);
}
module.exports = $b40ad1ee8d75fecf$var$objectToString;

});


parcelRegister("ghHeQ", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $bdafc62116ece13d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $bdafc62116ece13d$var$isObject;

});


parcelRegister("2A0QU", function(module, exports) {

var $Mbrn4 = parcelRequire("Mbrn4");
/** Used to detect methods masquerading as native. */ var $1e0f9ad0ce4f66eb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($Mbrn4 && $Mbrn4.keys && $Mbrn4.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1e0f9ad0ce4f66eb$var$isMasked(func) {
    return !!$1e0f9ad0ce4f66eb$var$maskSrcKey && $1e0f9ad0ce4f66eb$var$maskSrcKey in func;
}
module.exports = $1e0f9ad0ce4f66eb$var$isMasked;

});
parcelRegister("Mbrn4", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Used to detect overreaching core-js shims. */ var $090d5ba5f6231071$var$coreJsData = $1sHSN["__core-js_shared__"];
module.exports = $090d5ba5f6231071$var$coreJsData;

});


parcelRegister("kpFqz", function(module, exports) {
/** Used for built-in method references. */ var $edc647193fc6f96d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $edc647193fc6f96d$var$funcToString = $edc647193fc6f96d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $edc647193fc6f96d$var$toSource(func) {
    if (func != null) {
        try {
            return $edc647193fc6f96d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $edc647193fc6f96d$var$toSource;

});


parcelRegister("nfEOY", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $045e4b54e42a7211$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $045e4b54e42a7211$var$getValue;

});



parcelRegister("dtBcs", function(module, exports) {

var $5ZqWy = parcelRequire("5ZqWy");

var $8ifhw = parcelRequire("8ifhw");

var $7T0sg = parcelRequire("7T0sg");

var $kD65d = parcelRequire("kD65d");

var $3DJK7 = parcelRequire("3DJK7");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9cfad6ea037af1c6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9cfad6ea037af1c6$var$MapCache.prototype.clear = $5ZqWy;
$9cfad6ea037af1c6$var$MapCache.prototype["delete"] = $8ifhw;
$9cfad6ea037af1c6$var$MapCache.prototype.get = $7T0sg;
$9cfad6ea037af1c6$var$MapCache.prototype.has = $kD65d;
$9cfad6ea037af1c6$var$MapCache.prototype.set = $3DJK7;
module.exports = $9cfad6ea037af1c6$var$MapCache;

});
parcelRegister("5ZqWy", function(module, exports) {

var $3TJBn = parcelRequire("3TJBn");

var $RaYJF = parcelRequire("RaYJF");

var $kbZZK = parcelRequire("kbZZK");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $45c78ca228d84e27$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $3TJBn,
        "map": new ($kbZZK || $RaYJF),
        "string": new $3TJBn
    };
}
module.exports = $45c78ca228d84e27$var$mapCacheClear;

});
parcelRegister("3TJBn", function(module, exports) {

var $85tAc = parcelRequire("85tAc");

var $jaCOP = parcelRequire("jaCOP");

var $9blWi = parcelRequire("9blWi");

var $cr0fb = parcelRequire("cr0fb");

var $2Cioi = parcelRequire("2Cioi");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2d69e1b5bf1157cd$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$2d69e1b5bf1157cd$var$Hash.prototype.clear = $85tAc;
$2d69e1b5bf1157cd$var$Hash.prototype["delete"] = $jaCOP;
$2d69e1b5bf1157cd$var$Hash.prototype.get = $9blWi;
$2d69e1b5bf1157cd$var$Hash.prototype.has = $cr0fb;
$2d69e1b5bf1157cd$var$Hash.prototype.set = $2Cioi;
module.exports = $2d69e1b5bf1157cd$var$Hash;

});
parcelRegister("85tAc", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $5e35bce9957dee8c$var$hashClear() {
    this.__data__ = $5hhyA ? $5hhyA(null) : {};
    this.size = 0;
}
module.exports = $5e35bce9957dee8c$var$hashClear;

});
parcelRegister("5hhyA", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");
/* Built-in method references that are verified to be native. */ var $3d7c28b200d1a20d$var$nativeCreate = $llv3Q(Object, "create");
module.exports = $3d7c28b200d1a20d$var$nativeCreate;

});


parcelRegister("jaCOP", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df4d101f5b9fcd2d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $df4d101f5b9fcd2d$var$hashDelete;

});

parcelRegister("9blWi", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used to stand-in for `undefined` hash values. */ var $6af628cf22c60ed8$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $6af628cf22c60ed8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6af628cf22c60ed8$var$hasOwnProperty = $6af628cf22c60ed8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6af628cf22c60ed8$var$hashGet(key) {
    var data = this.__data__;
    if ($5hhyA) {
        var result = data[key];
        return result === $6af628cf22c60ed8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6af628cf22c60ed8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $6af628cf22c60ed8$var$hashGet;

});

parcelRegister("cr0fb", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used for built-in method references. */ var $90d83216985d9829$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $90d83216985d9829$var$hasOwnProperty = $90d83216985d9829$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $90d83216985d9829$var$hashHas(key) {
    var data = this.__data__;
    return $5hhyA ? data[key] !== undefined : $90d83216985d9829$var$hasOwnProperty.call(data, key);
}
module.exports = $90d83216985d9829$var$hashHas;

});

parcelRegister("2Cioi", function(module, exports) {

var $5hhyA = parcelRequire("5hhyA");
/** Used to stand-in for `undefined` hash values. */ var $1e7d6571ccd0dc1d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $1e7d6571ccd0dc1d$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $5hhyA && value === undefined ? $1e7d6571ccd0dc1d$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $1e7d6571ccd0dc1d$var$hashSet;

});



parcelRegister("8ifhw", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $609bdbca109826bf$var$mapCacheDelete(key) {
    var result = $i9hnu(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $609bdbca109826bf$var$mapCacheDelete;

});
parcelRegister("i9hnu", function(module, exports) {

var $aikhR = parcelRequire("aikhR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $d3668c2526d990b3$var$getMapData(map, key) {
    var data = map.__data__;
    return $aikhR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $d3668c2526d990b3$var$getMapData;

});
parcelRegister("aikhR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $77eb526782a6fe33$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $77eb526782a6fe33$var$isKeyable;

});



parcelRegister("7T0sg", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5bde05c8b6704c1a$var$mapCacheGet(key) {
    return $i9hnu(this, key).get(key);
}
module.exports = $5bde05c8b6704c1a$var$mapCacheGet;

});

parcelRegister("kD65d", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f04c2b247c8c21b7$var$mapCacheHas(key) {
    return $i9hnu(this, key).has(key);
}
module.exports = $f04c2b247c8c21b7$var$mapCacheHas;

});

parcelRegister("3DJK7", function(module, exports) {

var $i9hnu = parcelRequire("i9hnu");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2a687f2e91804320$var$mapCacheSet(key, value) {
    var data = $i9hnu(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $2a687f2e91804320$var$mapCacheSet;

});




parcelRegister("7PCa6", function(module, exports) {

var $4b5Hj = parcelRequire("4b5Hj");

var $8z8Gw = parcelRequire("8z8Gw");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5b3ae600168d081d$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$8z8Gw(object[key], value) || value === undefined && !(key in object)) $4b5Hj(object, key, value);
}
module.exports = $5b3ae600168d081d$var$assignMergeValue;

});
parcelRegister("4b5Hj", function(module, exports) {

var $6l5GV = parcelRequire("6l5GV");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $30ac9bf0fb60a701$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $6l5GV) $6l5GV(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $30ac9bf0fb60a701$var$baseAssignValue;

});
parcelRegister("6l5GV", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");
var $49d91e69d437debb$var$defineProperty = function() {
    try {
        var func = $llv3Q(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $49d91e69d437debb$var$defineProperty;

});



parcelRegister("hIy2P", function(module, exports) {

var $j0K2P = parcelRequire("j0K2P");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ce60f4436d142a26$var$baseFor = $j0K2P();
module.exports = $ce60f4436d142a26$var$baseFor;

});
parcelRegister("j0K2P", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dd71bbe508c3fe5f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $dd71bbe508c3fe5f$var$createBaseFor;

});


parcelRegister("6khZu", function(module, exports) {

var $7PCa6 = parcelRequire("7PCa6");

var $aCYKL = parcelRequire("aCYKL");

var $I3BGa = parcelRequire("I3BGa");

var $2JrPW = parcelRequire("2JrPW");

var $8NITN = parcelRequire("8NITN");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $hOxVQ = parcelRequire("hOxVQ");

var $hLa8L = parcelRequire("hLa8L");

var $2MN1q = parcelRequire("2MN1q");

var $ghHeQ = parcelRequire("ghHeQ");

var $8fzzn = parcelRequire("8fzzn");

var $1OdLr = parcelRequire("1OdLr");

var $7zKJO = parcelRequire("7zKJO");

var $eBjvb = parcelRequire("eBjvb");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $49b290ea3e1ddf15$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $7zKJO(object, key), srcValue = $7zKJO(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7PCa6(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $3hHqY(srcValue), isBuff = !isArr && $hLa8L(srcValue), isTyped = !isArr && !isBuff && $1OdLr(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($3hHqY(objValue)) newValue = objValue;
            else if ($hOxVQ(objValue)) newValue = $2JrPW(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $aCYKL(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $I3BGa(srcValue, true);
            } else newValue = [];
        } else if ($8fzzn(srcValue) || $17tLN(srcValue)) {
            newValue = objValue;
            if ($17tLN(objValue)) newValue = $eBjvb(objValue);
            else if (!$ghHeQ(objValue) || $2MN1q(objValue)) newValue = $8NITN(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $7PCa6(object, key, newValue);
}
module.exports = $49b290ea3e1ddf15$var$baseMergeDeep;

});
parcelRegister("I3BGa", function(module, exports) {

var $bJemi = parcelRequire("bJemi");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $0846e865934f10f8$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $bJemi(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $0846e865934f10f8$var$cloneTypedArray;

});
parcelRegister("bJemi", function(module, exports) {

var $7OcN3 = parcelRequire("7OcN3");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $889f08ff2fbd1a83$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $7OcN3(result).set(new $7OcN3(arrayBuffer));
    return result;
}
module.exports = $889f08ff2fbd1a83$var$cloneArrayBuffer;

});
parcelRegister("7OcN3", function(module, exports) {

var $1sHSN = parcelRequire("1sHSN");
/** Built-in value references. */ var $5af71fc4b4055af4$var$Uint8Array = $1sHSN.Uint8Array;
module.exports = $5af71fc4b4055af4$var$Uint8Array;

});



parcelRegister("2JrPW", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1fd560858a42b95d$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $1fd560858a42b95d$var$copyArray;

});

parcelRegister("8NITN", function(module, exports) {

var $91gPb = parcelRequire("91gPb");

var $cnQD5 = parcelRequire("cnQD5");

var $757xh = parcelRequire("757xh");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6685ba537310abab$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$757xh(object) ? $91gPb($cnQD5(object)) : {};
}
module.exports = $6685ba537310abab$var$initCloneObject;

});
parcelRegister("91gPb", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");
/** Built-in value references. */ var $6911421007ee03ec$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $6911421007ee03ec$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$ghHeQ(proto)) return {};
        if ($6911421007ee03ec$var$objectCreate) return $6911421007ee03ec$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $6911421007ee03ec$var$baseCreate;

});

parcelRegister("cnQD5", function(module, exports) {

var $4zjLY = parcelRequire("4zjLY");
/** Built-in value references. */ var $9040751b3cb0bf30$var$getPrototype = $4zjLY(Object.getPrototypeOf, Object);
module.exports = $9040751b3cb0bf30$var$getPrototype;

});
parcelRegister("4zjLY", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3539c4bfd0e647e3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $3539c4bfd0e647e3$var$overArg;

});


parcelRegister("757xh", function(module, exports) {
/** Used for built-in method references. */ var $527ed8819dc7b019$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $527ed8819dc7b019$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $527ed8819dc7b019$var$objectProto;
    return value === proto;
}
module.exports = $527ed8819dc7b019$var$isPrototype;

});


parcelRegister("17tLN", function(module, exports) {

var $cm4QR = parcelRequire("cm4QR");

var $iK9OP = parcelRequire("iK9OP");
/** Used for built-in method references. */ var $0d0d8993478cd3b0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d0d8993478cd3b0$var$hasOwnProperty = $0d0d8993478cd3b0$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $0d0d8993478cd3b0$var$propertyIsEnumerable = $0d0d8993478cd3b0$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $0d0d8993478cd3b0$var$isArguments = $cm4QR(function() {
    return arguments;
}()) ? $cm4QR : function(value) {
    return $iK9OP(value) && $0d0d8993478cd3b0$var$hasOwnProperty.call(value, "callee") && !$0d0d8993478cd3b0$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $0d0d8993478cd3b0$var$isArguments;

});
parcelRegister("cm4QR", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $8feb4d8605aba269$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8feb4d8605aba269$var$baseIsArguments(value) {
    return $iK9OP(value) && $jasl7(value) == $8feb4d8605aba269$var$argsTag;
}
module.exports = $8feb4d8605aba269$var$baseIsArguments;

});
parcelRegister("iK9OP", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $da5423b30b8d5d35$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $da5423b30b8d5d35$var$isObjectLike;

});



parcelRegister("3hHqY", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2644a6beee24c4cd$var$isArray = Array.isArray;
module.exports = $2644a6beee24c4cd$var$isArray;

});

parcelRegister("hOxVQ", function(module, exports) {

var $gyLmc = parcelRequire("gyLmc");

var $iK9OP = parcelRequire("iK9OP");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $cf816d5991d9f97e$var$isArrayLikeObject(value) {
    return $iK9OP(value) && $gyLmc(value);
}
module.exports = $cf816d5991d9f97e$var$isArrayLikeObject;

});
parcelRegister("gyLmc", function(module, exports) {

var $2MN1q = parcelRequire("2MN1q");

var $kpNNN = parcelRequire("kpNNN");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $c0e48e74e7951d24$var$isArrayLike(value) {
    return value != null && $kpNNN(value.length) && !$2MN1q(value);
}
module.exports = $c0e48e74e7951d24$var$isArrayLike;

});
parcelRegister("kpNNN", function(module, exports) {
/** Used as references for various `Number` constants. */ var $edccc6223fac6bf2$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $edccc6223fac6bf2$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $edccc6223fac6bf2$var$MAX_SAFE_INTEGER;
}
module.exports = $edccc6223fac6bf2$var$isLength;

});



parcelRegister("8fzzn", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $cnQD5 = parcelRequire("cnQD5");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $601b50d99805b4be$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $601b50d99805b4be$var$funcProto = Function.prototype, $601b50d99805b4be$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $601b50d99805b4be$var$funcToString = $601b50d99805b4be$var$funcProto.toString;
/** Used to check objects for own properties. */ var $601b50d99805b4be$var$hasOwnProperty = $601b50d99805b4be$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $601b50d99805b4be$var$objectCtorString = $601b50d99805b4be$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $601b50d99805b4be$var$isPlainObject(value) {
    if (!$iK9OP(value) || $jasl7(value) != $601b50d99805b4be$var$objectTag) return false;
    var proto = $cnQD5(value);
    if (proto === null) return true;
    var Ctor = $601b50d99805b4be$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $601b50d99805b4be$var$funcToString.call(Ctor) == $601b50d99805b4be$var$objectCtorString;
}
module.exports = $601b50d99805b4be$var$isPlainObject;

});

parcelRegister("1OdLr", function(module, exports) {

var $7qBU4 = parcelRequire("7qBU4");

var $6REps = parcelRequire("6REps");

var $1sJ0x = parcelRequire("1sJ0x");
/* Node.js helper references. */ var $15152340a0cf668a$var$nodeIsTypedArray = $1sJ0x && $1sJ0x.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $15152340a0cf668a$var$isTypedArray = $15152340a0cf668a$var$nodeIsTypedArray ? $6REps($15152340a0cf668a$var$nodeIsTypedArray) : $7qBU4;
module.exports = $15152340a0cf668a$var$isTypedArray;

});
parcelRegister("7qBU4", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $kpNNN = parcelRequire("kpNNN");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $56885ced9908a55e$var$argsTag = "[object Arguments]", $56885ced9908a55e$var$arrayTag = "[object Array]", $56885ced9908a55e$var$boolTag = "[object Boolean]", $56885ced9908a55e$var$dateTag = "[object Date]", $56885ced9908a55e$var$errorTag = "[object Error]", $56885ced9908a55e$var$funcTag = "[object Function]", $56885ced9908a55e$var$mapTag = "[object Map]", $56885ced9908a55e$var$numberTag = "[object Number]", $56885ced9908a55e$var$objectTag = "[object Object]", $56885ced9908a55e$var$regexpTag = "[object RegExp]", $56885ced9908a55e$var$setTag = "[object Set]", $56885ced9908a55e$var$stringTag = "[object String]", $56885ced9908a55e$var$weakMapTag = "[object WeakMap]";
var $56885ced9908a55e$var$arrayBufferTag = "[object ArrayBuffer]", $56885ced9908a55e$var$dataViewTag = "[object DataView]", $56885ced9908a55e$var$float32Tag = "[object Float32Array]", $56885ced9908a55e$var$float64Tag = "[object Float64Array]", $56885ced9908a55e$var$int8Tag = "[object Int8Array]", $56885ced9908a55e$var$int16Tag = "[object Int16Array]", $56885ced9908a55e$var$int32Tag = "[object Int32Array]", $56885ced9908a55e$var$uint8Tag = "[object Uint8Array]", $56885ced9908a55e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $56885ced9908a55e$var$uint16Tag = "[object Uint16Array]", $56885ced9908a55e$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $56885ced9908a55e$var$typedArrayTags = {};
$56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$float32Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$float64Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int8Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int16Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$int32Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint8Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint8ClampedTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint16Tag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$uint32Tag] = true;
$56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$argsTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$arrayTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$arrayBufferTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$boolTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$dataViewTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$dateTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$errorTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$funcTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$mapTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$numberTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$objectTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$regexpTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$setTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$stringTag] = $56885ced9908a55e$var$typedArrayTags[$56885ced9908a55e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $56885ced9908a55e$var$baseIsTypedArray(value) {
    return $iK9OP(value) && $kpNNN(value.length) && !!$56885ced9908a55e$var$typedArrayTags[$jasl7(value)];
}
module.exports = $56885ced9908a55e$var$baseIsTypedArray;

});

parcelRegister("6REps", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4ff709cd0ee61334$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $4ff709cd0ee61334$var$baseUnary;

});


parcelRegister("7zKJO", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $58400e70064b05f6$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $58400e70064b05f6$var$safeGet;

});

parcelRegister("eBjvb", function(module, exports) {

var $59vT0 = parcelRequire("59vT0");

var $gG7av = parcelRequire("gG7av");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $aa13a615a6fde3ce$var$toPlainObject(value) {
    return $59vT0(value, $gG7av(value));
}
module.exports = $aa13a615a6fde3ce$var$toPlainObject;

});
parcelRegister("59vT0", function(module, exports) {

var $8uute = parcelRequire("8uute");

var $4b5Hj = parcelRequire("4b5Hj");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3c0686ee04ac7826$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $4b5Hj(object, key, newValue);
        else $8uute(object, key, newValue);
    }
    return object;
}
module.exports = $3c0686ee04ac7826$var$copyObject;

});
parcelRegister("8uute", function(module, exports) {

var $4b5Hj = parcelRequire("4b5Hj");

var $8z8Gw = parcelRequire("8z8Gw");
/** Used for built-in method references. */ var $62e8c2dc2549acb7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $62e8c2dc2549acb7$var$hasOwnProperty = $62e8c2dc2549acb7$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $62e8c2dc2549acb7$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($62e8c2dc2549acb7$var$hasOwnProperty.call(object, key) && $8z8Gw(objValue, value)) || value === undefined && !(key in object)) $4b5Hj(object, key, value);
}
module.exports = $62e8c2dc2549acb7$var$assignValue;

});


parcelRegister("gG7av", function(module, exports) {

var $4pYGV = parcelRequire("4pYGV");

var $g1hXR = parcelRequire("g1hXR");

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $c246211643b1ea2a$var$keysIn(object) {
    return $gyLmc(object) ? $4pYGV(object, true) : $g1hXR(object);
}
module.exports = $c246211643b1ea2a$var$keysIn;

});
parcelRegister("4pYGV", function(module, exports) {

var $j65fp = parcelRequire("j65fp");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $hLa8L = parcelRequire("hLa8L");

var $kNhZg = parcelRequire("kNhZg");

var $1OdLr = parcelRequire("1OdLr");
/** Used for built-in method references. */ var $33789342229d1f99$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $33789342229d1f99$var$hasOwnProperty = $33789342229d1f99$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $33789342229d1f99$var$arrayLikeKeys(value, inherited) {
    var isArr = $3hHqY(value), isArg = !isArr && $17tLN(value), isBuff = !isArr && !isArg && $hLa8L(value), isType = !isArr && !isArg && !isBuff && $1OdLr(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $j65fp(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $33789342229d1f99$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $kNhZg(key, length)))) result.push(key);
    return result;
}
module.exports = $33789342229d1f99$var$arrayLikeKeys;

});
parcelRegister("j65fp", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $de72a5e683ee52dc$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $de72a5e683ee52dc$var$baseTimes;

});

parcelRegister("kNhZg", function(module, exports) {
/** Used as references for various `Number` constants. */ var $03e81a29ce5f05a1$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $03e81a29ce5f05a1$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $03e81a29ce5f05a1$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $03e81a29ce5f05a1$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $03e81a29ce5f05a1$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $03e81a29ce5f05a1$var$isIndex;

});


parcelRegister("g1hXR", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");

var $757xh = parcelRequire("757xh");

var $iTx9g = parcelRequire("iTx9g");
/** Used for built-in method references. */ var $ba9aacb805de176e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba9aacb805de176e$var$hasOwnProperty = $ba9aacb805de176e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ba9aacb805de176e$var$baseKeysIn(object) {
    if (!$ghHeQ(object)) return $iTx9g(object);
    var isProto = $757xh(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$ba9aacb805de176e$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $ba9aacb805de176e$var$baseKeysIn;

});
parcelRegister("iTx9g", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $dc1713a6a7009e20$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $dc1713a6a7009e20$var$nativeKeysIn;

});






parcelRegister("87EVA", function(module, exports) {

var $63hoU = parcelRequire("63hoU");

var $2bHYF = parcelRequire("2bHYF");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $5e9eb99b9243c3d0$var$createAssigner(assigner) {
    return $63hoU(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $2bHYF(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $5e9eb99b9243c3d0$var$createAssigner;

});
parcelRegister("63hoU", function(module, exports) {

var $hrfQh = parcelRequire("hrfQh");

var $57Xx2 = parcelRequire("57Xx2");

var $9o1BV = parcelRequire("9o1BV");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $4680854cd8f2123d$var$baseRest(func, start) {
    return $9o1BV($57Xx2(func, start, $hrfQh), func + "");
}
module.exports = $4680854cd8f2123d$var$baseRest;

});
parcelRegister("hrfQh", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $cb213f323a674370$var$identity(value) {
    return value;
}
module.exports = $cb213f323a674370$var$identity;

});

parcelRegister("57Xx2", function(module, exports) {

var $kPXrV = parcelRequire("kPXrV");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3bbbc8f79e522a29$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $3bbbc8f79e522a29$var$overRest(func, start, transform) {
    start = $3bbbc8f79e522a29$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $3bbbc8f79e522a29$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $kPXrV(func, this, otherArgs);
    };
}
module.exports = $3bbbc8f79e522a29$var$overRest;

});
parcelRegister("kPXrV", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f2b6af8161d5d5b7$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $f2b6af8161d5d5b7$var$apply;

});


parcelRegister("9o1BV", function(module, exports) {

var $4nrw9 = parcelRequire("4nrw9");

var $7llC9 = parcelRequire("7llC9");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6d579ac686b8b6b3$var$setToString = $7llC9($4nrw9);
module.exports = $6d579ac686b8b6b3$var$setToString;

});
parcelRegister("4nrw9", function(module, exports) {

var $jVgXn = parcelRequire("jVgXn");

var $6l5GV = parcelRequire("6l5GV");

var $hrfQh = parcelRequire("hrfQh");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $32fea7ce67ef9053$var$baseSetToString = !$6l5GV ? $hrfQh : function(func, string) {
    return $6l5GV(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $jVgXn(string),
        "writable": true
    });
};
module.exports = $32fea7ce67ef9053$var$baseSetToString;

});
parcelRegister("jVgXn", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $e8107e7163ddcdd1$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $e8107e7163ddcdd1$var$constant;

});


parcelRegister("7llC9", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $558b42bcae1d010a$var$HOT_COUNT = 800, $558b42bcae1d010a$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $558b42bcae1d010a$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $558b42bcae1d010a$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $558b42bcae1d010a$var$nativeNow(), remaining = $558b42bcae1d010a$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $558b42bcae1d010a$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $558b42bcae1d010a$var$shortOut;

});



parcelRegister("2bHYF", function(module, exports) {

var $8z8Gw = parcelRequire("8z8Gw");

var $gyLmc = parcelRequire("gyLmc");

var $kNhZg = parcelRequire("kNhZg");

var $ghHeQ = parcelRequire("ghHeQ");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $197eb8dc757049ae$var$isIterateeCall(value, index, object) {
    if (!$ghHeQ(object)) return false;
    var type = typeof index;
    if (type == "number" ? $gyLmc(object) && $kNhZg(index, object.length) : type == "string" && index in object) return $8z8Gw(object[index], value);
    return false;
}
module.exports = $197eb8dc757049ae$var$isIterateeCall;

});



parcelRegister("bIHE3", function(module, exports) {

var $laHY0 = parcelRequire("laHY0");

var $8Gn6t = parcelRequire("8Gn6t");

var $9PmZ6 = parcelRequire("9PmZ6");

var $3hHqY = parcelRequire("3hHqY");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $8885a8be14d38304$var$filter(collection, predicate) {
    var func = $3hHqY(collection) ? $laHY0 : $8Gn6t;
    return func(collection, $9PmZ6(predicate, 3));
}
module.exports = $8885a8be14d38304$var$filter;

});
parcelRegister("laHY0", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $f69ca30aaa17c7a3$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $f69ca30aaa17c7a3$var$arrayFilter;

});

parcelRegister("8Gn6t", function(module, exports) {

var $erFZL = parcelRequire("erFZL");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $65242ad6a10a5316$var$baseFilter(collection, predicate) {
    var result = [];
    $erFZL(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $65242ad6a10a5316$var$baseFilter;

});
parcelRegister("erFZL", function(module, exports) {

var $dd9cd = parcelRequire("dd9cd");

var $c4ClI = parcelRequire("c4ClI");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a84429a7aa05d2b0$var$baseEach = $c4ClI($dd9cd);
module.exports = $a84429a7aa05d2b0$var$baseEach;

});
parcelRegister("dd9cd", function(module, exports) {

var $hIy2P = parcelRequire("hIy2P");

var $4MkDT = parcelRequire("4MkDT");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $99e39f636e05d6bf$var$baseForOwn(object, iteratee) {
    return object && $hIy2P(object, iteratee, $4MkDT);
}
module.exports = $99e39f636e05d6bf$var$baseForOwn;

});
parcelRegister("4MkDT", function(module, exports) {

var $4pYGV = parcelRequire("4pYGV");

var $3ERlS = parcelRequire("3ERlS");

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $37aba8405f912a95$var$keys(object) {
    return $gyLmc(object) ? $4pYGV(object) : $3ERlS(object);
}
module.exports = $37aba8405f912a95$var$keys;

});
parcelRegister("3ERlS", function(module, exports) {

var $757xh = parcelRequire("757xh");

var $gIutM = parcelRequire("gIutM");
/** Used for built-in method references. */ var $2a9e7e1700f9e886$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2a9e7e1700f9e886$var$hasOwnProperty = $2a9e7e1700f9e886$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2a9e7e1700f9e886$var$baseKeys(object) {
    if (!$757xh(object)) return $gIutM(object);
    var result = [];
    for(var key in Object(object))if ($2a9e7e1700f9e886$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $2a9e7e1700f9e886$var$baseKeys;

});
parcelRegister("gIutM", function(module, exports) {

var $4zjLY = parcelRequire("4zjLY");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2b865eff48146fb$var$nativeKeys = $4zjLY(Object.keys, Object);
module.exports = $c2b865eff48146fb$var$nativeKeys;

});




parcelRegister("c4ClI", function(module, exports) {

var $gyLmc = parcelRequire("gyLmc");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $8ca39b189116e38e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$gyLmc(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $8ca39b189116e38e$var$createBaseEach;

});



parcelRegister("9PmZ6", function(module, exports) {

var $4V6fX = parcelRequire("4V6fX");

var $icPnl = parcelRequire("icPnl");

var $hrfQh = parcelRequire("hrfQh");

var $3hHqY = parcelRequire("3hHqY");

var $6luml = parcelRequire("6luml");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $727ab4bc49e27fdf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $hrfQh;
    if (typeof value == "object") return $3hHqY(value) ? $icPnl(value[0], value[1]) : $4V6fX(value);
    return $6luml(value);
}
module.exports = $727ab4bc49e27fdf$var$baseIteratee;

});
parcelRegister("4V6fX", function(module, exports) {

var $2yf2n = parcelRequire("2yf2n");

var $aKQmx = parcelRequire("aKQmx");

var $7DyzG = parcelRequire("7DyzG");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $395156b5014c4edd$var$baseMatches(source) {
    var matchData = $aKQmx(source);
    if (matchData.length == 1 && matchData[0][2]) return $7DyzG(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2yf2n(object, source, matchData);
    };
}
module.exports = $395156b5014c4edd$var$baseMatches;

});
parcelRegister("2yf2n", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $c2d0B = parcelRequire("c2d0B");
/** Used to compose bitmasks for value comparisons. */ var $1dba6bdee42845ae$var$COMPARE_PARTIAL_FLAG = 1, $1dba6bdee42845ae$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $1dba6bdee42845ae$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $29kQd;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $c2d0B(srcValue, objValue, $1dba6bdee42845ae$var$COMPARE_PARTIAL_FLAG | $1dba6bdee42845ae$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $1dba6bdee42845ae$var$baseIsMatch;

});
parcelRegister("c2d0B", function(module, exports) {

var $ljWXo = parcelRequire("ljWXo");

var $iK9OP = parcelRequire("iK9OP");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8c2fc32ff0e1a287$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$iK9OP(value) && !$iK9OP(other)) return value !== value && other !== other;
    return $ljWXo(value, other, bitmask, customizer, $8c2fc32ff0e1a287$var$baseIsEqual, stack);
}
module.exports = $8c2fc32ff0e1a287$var$baseIsEqual;

});
parcelRegister("ljWXo", function(module, exports) {

var $29kQd = parcelRequire("29kQd");

var $cBpu1 = parcelRequire("cBpu1");

var $2JZFE = parcelRequire("2JZFE");

var $bI9Va = parcelRequire("bI9Va");

var $8J52P = parcelRequire("8J52P");

var $3hHqY = parcelRequire("3hHqY");

var $hLa8L = parcelRequire("hLa8L");

var $1OdLr = parcelRequire("1OdLr");
/** Used to compose bitmasks for value comparisons. */ var $f8591af7cf050940$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $f8591af7cf050940$var$argsTag = "[object Arguments]", $f8591af7cf050940$var$arrayTag = "[object Array]", $f8591af7cf050940$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f8591af7cf050940$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f8591af7cf050940$var$hasOwnProperty = $f8591af7cf050940$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f8591af7cf050940$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3hHqY(object), othIsArr = $3hHqY(other), objTag = objIsArr ? $f8591af7cf050940$var$arrayTag : $8J52P(object), othTag = othIsArr ? $f8591af7cf050940$var$arrayTag : $8J52P(other);
    objTag = objTag == $f8591af7cf050940$var$argsTag ? $f8591af7cf050940$var$objectTag : objTag;
    othTag = othTag == $f8591af7cf050940$var$argsTag ? $f8591af7cf050940$var$objectTag : othTag;
    var objIsObj = objTag == $f8591af7cf050940$var$objectTag, othIsObj = othTag == $f8591af7cf050940$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hLa8L(object)) {
        if (!$hLa8L(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $29kQd);
        return objIsArr || $1OdLr(object) ? $cBpu1(object, other, bitmask, customizer, equalFunc, stack) : $2JZFE(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $f8591af7cf050940$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $f8591af7cf050940$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $f8591af7cf050940$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $29kQd);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $29kQd);
    return $bI9Va(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $f8591af7cf050940$var$baseIsEqualDeep;

});
parcelRegister("cBpu1", function(module, exports) {

var $7TzSp = parcelRequire("7TzSp");

var $akGgj = parcelRequire("akGgj");

var $2oKLN = parcelRequire("2oKLN");
/** Used to compose bitmasks for value comparisons. */ var $92ccb52c2796c52a$var$COMPARE_PARTIAL_FLAG = 1, $92ccb52c2796c52a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $92ccb52c2796c52a$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $92ccb52c2796c52a$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $92ccb52c2796c52a$var$COMPARE_UNORDERED_FLAG ? new $7TzSp : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$akGgj(other, function(othValue, othIndex) {
                if (!$2oKLN(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $92ccb52c2796c52a$var$equalArrays;

});
parcelRegister("7TzSp", function(module, exports) {

var $dtBcs = parcelRequire("dtBcs");

var $kdtOH = parcelRequire("kdtOH");

var $gORv3 = parcelRequire("gORv3");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5bf97fd087bcc0a1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $dtBcs;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5bf97fd087bcc0a1$var$SetCache.prototype.add = $5bf97fd087bcc0a1$var$SetCache.prototype.push = $kdtOH;
$5bf97fd087bcc0a1$var$SetCache.prototype.has = $gORv3;
module.exports = $5bf97fd087bcc0a1$var$SetCache;

});
parcelRegister("kdtOH", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $eb7c268d76906ea4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $eb7c268d76906ea4$var$setCacheAdd(value) {
    this.__data__.set(value, $eb7c268d76906ea4$var$HASH_UNDEFINED);
    return this;
}
module.exports = $eb7c268d76906ea4$var$setCacheAdd;

});

parcelRegister("gORv3", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $c3ead0d15bdb1ea3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $c3ead0d15bdb1ea3$var$setCacheHas;

});


parcelRegister("akGgj", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $785c8e06039eed99$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $785c8e06039eed99$var$arraySome;

});

parcelRegister("2oKLN", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1bf21a2b54b87e0f$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1bf21a2b54b87e0f$var$cacheHas;

});


parcelRegister("2JZFE", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $7OcN3 = parcelRequire("7OcN3");

var $8z8Gw = parcelRequire("8z8Gw");

var $cBpu1 = parcelRequire("cBpu1");

var $4rhSW = parcelRequire("4rhSW");

var $8uHoR = parcelRequire("8uHoR");
/** Used to compose bitmasks for value comparisons. */ var $1fef9f4ce4d836ab$var$COMPARE_PARTIAL_FLAG = 1, $1fef9f4ce4d836ab$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $1fef9f4ce4d836ab$var$boolTag = "[object Boolean]", $1fef9f4ce4d836ab$var$dateTag = "[object Date]", $1fef9f4ce4d836ab$var$errorTag = "[object Error]", $1fef9f4ce4d836ab$var$mapTag = "[object Map]", $1fef9f4ce4d836ab$var$numberTag = "[object Number]", $1fef9f4ce4d836ab$var$regexpTag = "[object RegExp]", $1fef9f4ce4d836ab$var$setTag = "[object Set]", $1fef9f4ce4d836ab$var$stringTag = "[object String]", $1fef9f4ce4d836ab$var$symbolTag = "[object Symbol]";
var $1fef9f4ce4d836ab$var$arrayBufferTag = "[object ArrayBuffer]", $1fef9f4ce4d836ab$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $1fef9f4ce4d836ab$var$symbolProto = $lLnMZ ? $lLnMZ.prototype : undefined, $1fef9f4ce4d836ab$var$symbolValueOf = $1fef9f4ce4d836ab$var$symbolProto ? $1fef9f4ce4d836ab$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1fef9f4ce4d836ab$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $1fef9f4ce4d836ab$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $1fef9f4ce4d836ab$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $7OcN3(object), new $7OcN3(other))) return false;
            return true;
        case $1fef9f4ce4d836ab$var$boolTag:
        case $1fef9f4ce4d836ab$var$dateTag:
        case $1fef9f4ce4d836ab$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $8z8Gw(+object, +other);
        case $1fef9f4ce4d836ab$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $1fef9f4ce4d836ab$var$regexpTag:
        case $1fef9f4ce4d836ab$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $1fef9f4ce4d836ab$var$mapTag:
            var convert = $4rhSW;
        case $1fef9f4ce4d836ab$var$setTag:
            var isPartial = bitmask & $1fef9f4ce4d836ab$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $8uHoR);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $1fef9f4ce4d836ab$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $cBpu1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $1fef9f4ce4d836ab$var$symbolTag:
            if ($1fef9f4ce4d836ab$var$symbolValueOf) return $1fef9f4ce4d836ab$var$symbolValueOf.call(object) == $1fef9f4ce4d836ab$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $1fef9f4ce4d836ab$var$equalByTag;

});
parcelRegister("4rhSW", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $33b78eaa4d121274$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $33b78eaa4d121274$var$mapToArray;

});

parcelRegister("8uHoR", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $62f2ca6c96117213$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $62f2ca6c96117213$var$setToArray;

});


parcelRegister("bI9Va", function(module, exports) {

var $cUoIl = parcelRequire("cUoIl");
/** Used to compose bitmasks for value comparisons. */ var $886b7fe1ec262c8f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $886b7fe1ec262c8f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $886b7fe1ec262c8f$var$hasOwnProperty = $886b7fe1ec262c8f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $886b7fe1ec262c8f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $886b7fe1ec262c8f$var$COMPARE_PARTIAL_FLAG, objProps = $cUoIl(object), objLength = objProps.length, othProps = $cUoIl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $886b7fe1ec262c8f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $886b7fe1ec262c8f$var$equalObjects;

});
parcelRegister("cUoIl", function(module, exports) {

var $jWJlU = parcelRequire("jWJlU");

var $hU878 = parcelRequire("hU878");

var $4MkDT = parcelRequire("4MkDT");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $965de2b6e3d9ea9c$var$getAllKeys(object) {
    return $jWJlU(object, $4MkDT, $hU878);
}
module.exports = $965de2b6e3d9ea9c$var$getAllKeys;

});
parcelRegister("jWJlU", function(module, exports) {

var $bhYL1 = parcelRequire("bhYL1");

var $3hHqY = parcelRequire("3hHqY");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e8569d209a3a13e5$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3hHqY(object) ? result : $bhYL1(result, symbolsFunc(object));
}
module.exports = $e8569d209a3a13e5$var$baseGetAllKeys;

});
parcelRegister("bhYL1", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $83806965a49037ae$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $83806965a49037ae$var$arrayPush;

});


parcelRegister("hU878", function(module, exports) {

var $laHY0 = parcelRequire("laHY0");

var $cVsbW = parcelRequire("cVsbW");
/** Used for built-in method references. */ var $d08df5eb5ec69d8f$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d08df5eb5ec69d8f$var$propertyIsEnumerable = $d08df5eb5ec69d8f$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d08df5eb5ec69d8f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d08df5eb5ec69d8f$var$getSymbols = !$d08df5eb5ec69d8f$var$nativeGetSymbols ? $cVsbW : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $laHY0($d08df5eb5ec69d8f$var$nativeGetSymbols(object), function(symbol) {
        return $d08df5eb5ec69d8f$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $d08df5eb5ec69d8f$var$getSymbols;

});
parcelRegister("cVsbW", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $9690ad2cd475fe68$var$stubArray() {
    return [];
}
module.exports = $9690ad2cd475fe68$var$stubArray;

});




parcelRegister("8J52P", function(module, exports) {

var $jopuT = parcelRequire("jopuT");

var $kbZZK = parcelRequire("kbZZK");

var $grM1S = parcelRequire("grM1S");

var $g4dZN = parcelRequire("g4dZN");

var $e0uiv = parcelRequire("e0uiv");

var $jasl7 = parcelRequire("jasl7");

var $kpFqz = parcelRequire("kpFqz");
/** `Object#toString` result references. */ var $65a67076761a57df$var$mapTag = "[object Map]", $65a67076761a57df$var$objectTag = "[object Object]", $65a67076761a57df$var$promiseTag = "[object Promise]", $65a67076761a57df$var$setTag = "[object Set]", $65a67076761a57df$var$weakMapTag = "[object WeakMap]";
var $65a67076761a57df$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $65a67076761a57df$var$dataViewCtorString = $kpFqz($jopuT), $65a67076761a57df$var$mapCtorString = $kpFqz($kbZZK), $65a67076761a57df$var$promiseCtorString = $kpFqz($grM1S), $65a67076761a57df$var$setCtorString = $kpFqz($g4dZN), $65a67076761a57df$var$weakMapCtorString = $kpFqz($e0uiv);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $65a67076761a57df$var$getTag = $jasl7;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($jopuT && $65a67076761a57df$var$getTag(new $jopuT(new ArrayBuffer(1))) != $65a67076761a57df$var$dataViewTag || $kbZZK && $65a67076761a57df$var$getTag(new $kbZZK) != $65a67076761a57df$var$mapTag || $grM1S && $65a67076761a57df$var$getTag($grM1S.resolve()) != $65a67076761a57df$var$promiseTag || $g4dZN && $65a67076761a57df$var$getTag(new $g4dZN) != $65a67076761a57df$var$setTag || $e0uiv && $65a67076761a57df$var$getTag(new $e0uiv) != $65a67076761a57df$var$weakMapTag) $65a67076761a57df$var$getTag = function(value) {
    var result = $jasl7(value), Ctor = result == $65a67076761a57df$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kpFqz(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $65a67076761a57df$var$dataViewCtorString:
            return $65a67076761a57df$var$dataViewTag;
        case $65a67076761a57df$var$mapCtorString:
            return $65a67076761a57df$var$mapTag;
        case $65a67076761a57df$var$promiseCtorString:
            return $65a67076761a57df$var$promiseTag;
        case $65a67076761a57df$var$setCtorString:
            return $65a67076761a57df$var$setTag;
        case $65a67076761a57df$var$weakMapCtorString:
            return $65a67076761a57df$var$weakMapTag;
    }
    return result;
};
module.exports = $65a67076761a57df$var$getTag;

});
parcelRegister("jopuT", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $e1e4096a2f7ca93a$var$DataView = $llv3Q($1sHSN, "DataView");
module.exports = $e1e4096a2f7ca93a$var$DataView;

});

parcelRegister("grM1S", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $bf946c8c43bd10a8$var$Promise = $llv3Q($1sHSN, "Promise");
module.exports = $bf946c8c43bd10a8$var$Promise;

});

parcelRegister("g4dZN", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $bb27e0553eb394e5$var$Set = $llv3Q($1sHSN, "Set");
module.exports = $bb27e0553eb394e5$var$Set;

});

parcelRegister("e0uiv", function(module, exports) {

var $llv3Q = parcelRequire("llv3Q");

var $1sHSN = parcelRequire("1sHSN");
/* Built-in method references that are verified to be native. */ var $a328913a32963c19$var$WeakMap = $llv3Q($1sHSN, "WeakMap");
module.exports = $a328913a32963c19$var$WeakMap;

});





parcelRegister("aKQmx", function(module, exports) {

var $4hwVJ = parcelRequire("4hwVJ");

var $4MkDT = parcelRequire("4MkDT");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $7d46d1611abe2efd$var$getMatchData(object) {
    var result = $4MkDT(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $4hwVJ(value)
        ];
    }
    return result;
}
module.exports = $7d46d1611abe2efd$var$getMatchData;

});
parcelRegister("4hwVJ", function(module, exports) {

var $ghHeQ = parcelRequire("ghHeQ");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $31e24b2e633a030c$var$isStrictComparable(value) {
    return value === value && !$ghHeQ(value);
}
module.exports = $31e24b2e633a030c$var$isStrictComparable;

});


parcelRegister("7DyzG", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $58f6feb6c3f4718c$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $58f6feb6c3f4718c$var$matchesStrictComparable;

});


parcelRegister("icPnl", function(module, exports) {

var $c2d0B = parcelRequire("c2d0B");

var $8TMnn = parcelRequire("8TMnn");

var $e3hfa = parcelRequire("e3hfa");

var $9Janb = parcelRequire("9Janb");

var $4hwVJ = parcelRequire("4hwVJ");

var $7DyzG = parcelRequire("7DyzG");

var $12Xds = parcelRequire("12Xds");
/** Used to compose bitmasks for value comparisons. */ var $d411331bd61e149b$var$COMPARE_PARTIAL_FLAG = 1, $d411331bd61e149b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d411331bd61e149b$var$baseMatchesProperty(path, srcValue) {
    if ($9Janb(path) && $4hwVJ(srcValue)) return $7DyzG($12Xds(path), srcValue);
    return function(object) {
        var objValue = $8TMnn(object, path);
        return objValue === undefined && objValue === srcValue ? $e3hfa(object, path) : $c2d0B(srcValue, objValue, $d411331bd61e149b$var$COMPARE_PARTIAL_FLAG | $d411331bd61e149b$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d411331bd61e149b$var$baseMatchesProperty;

});
parcelRegister("8TMnn", function(module, exports) {

var $knGp7 = parcelRequire("knGp7");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $67a8fc45e37aaa81$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $knGp7(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $67a8fc45e37aaa81$var$get;

});
parcelRegister("knGp7", function(module, exports) {

var $8yBOT = parcelRequire("8yBOT");

var $12Xds = parcelRequire("12Xds");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $ed66d9325016cf13$var$baseGet(object, path) {
    path = $8yBOT(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$12Xds(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $ed66d9325016cf13$var$baseGet;

});
parcelRegister("8yBOT", function(module, exports) {

var $3hHqY = parcelRequire("3hHqY");

var $9Janb = parcelRequire("9Janb");

var $b5fom = parcelRequire("b5fom");

var $bvRke = parcelRequire("bvRke");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $63aed5ec56776805$var$castPath(value, object) {
    if ($3hHqY(value)) return value;
    return $9Janb(value, object) ? [
        value
    ] : $b5fom($bvRke(value));
}
module.exports = $63aed5ec56776805$var$castPath;

});
parcelRegister("9Janb", function(module, exports) {

var $3hHqY = parcelRequire("3hHqY");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used to match property names within property paths. */ var $71505cdc3090c042$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $71505cdc3090c042$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $71505cdc3090c042$var$isKey(value, object) {
    if ($3hHqY(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $jc3qQ(value)) return true;
    return $71505cdc3090c042$var$reIsPlainProp.test(value) || !$71505cdc3090c042$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $71505cdc3090c042$var$isKey;

});
parcelRegister("jc3qQ", function(module, exports) {

var $jasl7 = parcelRequire("jasl7");

var $iK9OP = parcelRequire("iK9OP");
/** `Object#toString` result references. */ var $df91ccd8442d8c6d$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $df91ccd8442d8c6d$var$isSymbol(value) {
    return typeof value == "symbol" || $iK9OP(value) && $jasl7(value) == $df91ccd8442d8c6d$var$symbolTag;
}
module.exports = $df91ccd8442d8c6d$var$isSymbol;

});


parcelRegister("b5fom", function(module, exports) {

var $2YpWy = parcelRequire("2YpWy");
/** Used to match property names within property paths. */ var $021519310294ba0c$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $021519310294ba0c$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $021519310294ba0c$var$stringToPath = $2YpWy(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($021519310294ba0c$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($021519310294ba0c$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $021519310294ba0c$var$stringToPath;

});
parcelRegister("2YpWy", function(module, exports) {

var $bYTRT = parcelRequire("bYTRT");
/** Used as the maximum memoize cache size. */ var $22a54f347b7679c9$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $22a54f347b7679c9$var$memoizeCapped(func) {
    var result = $bYTRT(func, function(key) {
        if (cache.size === $22a54f347b7679c9$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $22a54f347b7679c9$var$memoizeCapped;

});
parcelRegister("bYTRT", function(module, exports) {

var $dtBcs = parcelRequire("dtBcs");
/** Error message constants. */ var $8b90a292802686aa$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $8b90a292802686aa$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($8b90a292802686aa$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($8b90a292802686aa$var$memoize.Cache || $dtBcs);
    return memoized;
}
// Expose `MapCache`.
$8b90a292802686aa$var$memoize.Cache = $dtBcs;
module.exports = $8b90a292802686aa$var$memoize;

});



parcelRegister("bvRke", function(module, exports) {

var $kx9Gl = parcelRequire("kx9Gl");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $861bf4447806334f$var$toString(value) {
    return value == null ? "" : $kx9Gl(value);
}
module.exports = $861bf4447806334f$var$toString;

});
parcelRegister("kx9Gl", function(module, exports) {

var $lLnMZ = parcelRequire("lLnMZ");

var $l4rgt = parcelRequire("l4rgt");

var $3hHqY = parcelRequire("3hHqY");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $ef2e665be0814403$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ef2e665be0814403$var$symbolProto = $lLnMZ ? $lLnMZ.prototype : undefined, $ef2e665be0814403$var$symbolToString = $ef2e665be0814403$var$symbolProto ? $ef2e665be0814403$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ef2e665be0814403$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($3hHqY(value)) // Recursively convert values (susceptible to call stack limits).
    return $l4rgt(value, $ef2e665be0814403$var$baseToString) + "";
    if ($jc3qQ(value)) return $ef2e665be0814403$var$symbolToString ? $ef2e665be0814403$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$ef2e665be0814403$var$INFINITY ? "-0" : result;
}
module.exports = $ef2e665be0814403$var$baseToString;

});
parcelRegister("l4rgt", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f56f1ee0fb8bb3c6$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $f56f1ee0fb8bb3c6$var$arrayMap;

});




parcelRegister("12Xds", function(module, exports) {

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $0c33e96a40b9e8d1$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0c33e96a40b9e8d1$var$toKey(value) {
    if (typeof value == "string" || $jc3qQ(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$0c33e96a40b9e8d1$var$INFINITY ? "-0" : result;
}
module.exports = $0c33e96a40b9e8d1$var$toKey;

});



parcelRegister("e3hfa", function(module, exports) {

var $kGnvI = parcelRequire("kGnvI");

var $fZcU0 = parcelRequire("fZcU0");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a3aeb8b62c81a9af$var$hasIn(object, path) {
    return object != null && $fZcU0(object, path, $kGnvI);
}
module.exports = $a3aeb8b62c81a9af$var$hasIn;

});
parcelRegister("kGnvI", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $f0e9f799458b3e31$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $f0e9f799458b3e31$var$baseHasIn;

});

parcelRegister("fZcU0", function(module, exports) {

var $8yBOT = parcelRequire("8yBOT");

var $17tLN = parcelRequire("17tLN");

var $3hHqY = parcelRequire("3hHqY");

var $kNhZg = parcelRequire("kNhZg");

var $kpNNN = parcelRequire("kpNNN");

var $12Xds = parcelRequire("12Xds");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $ba368fa4f88a3445$var$hasPath(object, path, hasFunc) {
    path = $8yBOT(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $12Xds(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $kpNNN(length) && $kNhZg(key, length) && ($3hHqY(object) || $17tLN(object));
}
module.exports = $ba368fa4f88a3445$var$hasPath;

});



parcelRegister("6luml", function(module, exports) {

var $1tLeC = parcelRequire("1tLeC");

var $bmKii = parcelRequire("bmKii");

var $9Janb = parcelRequire("9Janb");

var $12Xds = parcelRequire("12Xds");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $49ec40f7192cef59$var$property(path) {
    return $9Janb(path) ? $1tLeC($12Xds(path)) : $bmKii(path);
}
module.exports = $49ec40f7192cef59$var$property;

});
parcelRegister("1tLeC", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $113d23b2b588ad64$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $113d23b2b588ad64$var$baseProperty;

});

parcelRegister("bmKii", function(module, exports) {

var $knGp7 = parcelRequire("knGp7");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $8465a8d3738c173a$var$basePropertyDeep(path) {
    return function(object) {
        return $knGp7(object, path);
    };
}
module.exports = $8465a8d3738c173a$var$basePropertyDeep;

});




parcelRegister("l4qYG", function(module, exports) {

$parcel$export(module.exports, "useSchedulesContext", function () { return $db2792baa37c8f0d$export$aa97cecf807fd79e; });
$parcel$export(module.exports, "ScreensaverRouter", function () { return $db2792baa37c8f0d$export$f64fa00073e069b2; });
$parcel$export(module.exports, "SchedulesProvider", function () { return $db2792baa37c8f0d$export$82e0b5cdd710a9bb; });
// import ReactDOM from "react-dom";

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $kvR7a = parcelRequire("kvR7a");

var $bIHE3 = parcelRequire("bIHE3");

var $lHglF = parcelRequire("lHglF");

var $38fbh = parcelRequire("38fbh");

var $j0zqp = parcelRequire("j0zqp");

var $49Iup = parcelRequire("49Iup");

var $9zEpM = parcelRequire("9zEpM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $70E8R = parcelRequire("70E8R");

var $cD0nt = parcelRequire("cD0nt");

var $cwDEq = parcelRequire("cwDEq");
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($38fbh))));
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($j0zqp))));
(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($49Iup))));
const $db2792baa37c8f0d$var$SchedulesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const { Provider: $db2792baa37c8f0d$var$Provider } = $db2792baa37c8f0d$var$SchedulesContext;
function $db2792baa37c8f0d$var$isNowInSchedule(start, end, now) {
    if (end.isAfter(start)) return now.isAfter(start) && now.isBefore(end);
    return now.isAfter(start) || now.isBefore(end);
}
function $db2792baa37c8f0d$var$createCron(schedule) {
    const cron = [
        "*",
        "*",
        "*",
        "*",
        "*"
    ];
    const { weekdays: weekdays, date: date, time: time } = schedule;
    if (time) {
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(time, "HH:mm");
        cron[0] = `${start.get("minute")}`;
        cron[1] = `${start.get("hour")}`;
    }
    if (date) {
        const start = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(date, "YYYY-MM-DD");
        cron[2] = `${start.get("date")}`;
        cron[3] = `${start.get("month") + 1}`;
    }
    if (Array.isArray(weekdays) && weekdays.length > 0) cron[4] = weekdays.join(",");
    return cron.join(" ");
}
function $db2792baa37c8f0d$var$scheduleToCron(schedule) {
    const { weekdays: weekdays, startDate: startDate, startTime: startTime, endDate: endDate, endTime: endTime } = schedule;
    const start = $db2792baa37c8f0d$var$createCron({
        weekdays: weekdays,
        date: startDate,
        time: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(startDate, "YYYY-MM-DD").startOf("day").format("HH:mm") : startTime
    });
    const end = $db2792baa37c8f0d$var$createCron({
        weekdays: weekdays,
        date: endDate,
        time: startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(endDate, "YYYY-MM-DD").endOf("day").format("HH:mm") : endTime
    });
    return [
        start,
        end
    ];
}
const $db2792baa37c8f0d$export$aa97cecf807fd79e = ()=>(0, $eZVvM.useContext)($db2792baa37c8f0d$var$SchedulesContext);
const $db2792baa37c8f0d$var$RESET_DURATION_MS = 600000;
const $db2792baa37c8f0d$var$INACTIVITY_DURATION_MS = 300000;
const $db2792baa37c8f0d$export$1b4374354aaa3b05 = ()=>{
    const { screensaver: screensaver, paused: paused, setPaused: setPaused, touchDisabled: touchDisabled } = (0, $eZVvM.useContext)($db2792baa37c8f0d$var$SchedulesContext);
    const visible = screensaver && !paused;
    if (!visible) return null;
    // return ReactDOM.createPortal(
    //   <div
    //     className="position-absolute top-0 bottom-0 right-0 left-0 d-flex h-100 w-100"
    //     style={{ background: "#000" }}
    //     onClick={() => setPaused(true)}
    //   />,
    //   document.getElementById("root")!,
    // );
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        className: "position-absolute top-0 bottom-0 right-0 left-0 d-flex h-100 w-100",
        style: {
            background: "#010101",
            transform: "translateZ(0)",
            backfaceVisibility: "hidden",
            pointerEvents: screensaver && !paused ? "auto" : "none"
        },
        onClick: touchDisabled ? undefined : ()=>setPaused(true)
    });
};
const $db2792baa37c8f0d$export$f64fa00073e069b2 = ()=>{
    var _data_digitalReception;
    const { screensaver: screensaver, setPaused: setPaused, scheduleScreensaver: scheduleScreensaver, touchDisabled: touchDisabled } = $db2792baa37c8f0d$export$aa97cecf807fd79e();
    const { data: data } = (0, $cD0nt.default)();
    const { preview: preview } = (0, $cwDEq.useAppConfig)();
    const navigation = (0, $9B9bN.useNavigate)();
    const sleepSchedules = (0, (/*@__PURE__*/$parcel$interopDefault($bIHE3)))(data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.schedules, (item)=>item.type === "sleep" && !item.schedule.disabled);
    (0, (/*@__PURE__*/$parcel$interopDefault($lHglF)))(()=>{
        if (preview) return;
        scheduleScreensaver(sleepSchedules);
    }, [
        sleepSchedules,
        scheduleScreensaver
    ]);
    const onInteractionStateChange = (0, $eZVvM.useCallback)((state)=>{
        if (!screensaver) return;
        if (touchDisabled) {
            setPaused(false);
            return;
        }
        if (state === "active") setPaused(true);
        if (state === "idle") setPaused(false);
    }, [
        setPaused,
        screensaver,
        touchDisabled
    ]);
    (0, $70E8R.default)((state)=>{
        if (touchDisabled) return;
        if (state === "idle") navigation("/", {
            replace: true
        });
    }, $db2792baa37c8f0d$var$RESET_DURATION_MS);
    (0, $70E8R.default)(onInteractionStateChange, $db2792baa37c8f0d$var$INACTIVITY_DURATION_MS);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $bhfvP.jsx)($db2792baa37c8f0d$export$1b4374354aaa3b05, {})
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                path: "*",
                element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {})
            })
        ]
    });
};
const $db2792baa37c8f0d$export$82e0b5cdd710a9bb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const [paused, setPaused] = (0, $eZVvM.useState)(false);
    const [screensaver, setScreensaver] = (0, $eZVvM.useState)(false);
    const [touchDisabled, setTouchDisabled] = (0, $eZVvM.useState)(false);
    const clearSchedule = (0, $eZVvM.useCallback)(()=>{
        (0, $9zEpM.Cron).scheduledJobs.forEach((job)=>job.stop());
    }, []);
    const scheduleScreensaver = (0, $eZVvM.useCallback)((schedules)=>{
        // console.log("[scheduleScreensaver]: ", schedules);
        clearSchedule();
        let nextScreensaver = false;
        let nextTouchDisabled = false;
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))();
        const dateStart = now.startOf("day").toDate();
        schedules.forEach((item)=>{
            const { schedule: schedule } = item;
            const weekday = now.day();
            if (Array.isArray(schedule.weekdays) && schedule.weekdays.length > 0) {
                if (!schedule.weekdays.includes(weekday)) return;
            }
            const [startCronTab, endCronTab] = $db2792baa37c8f0d$var$scheduleToCron(schedule);
            const startCron = (0, $9zEpM.Cron)(startCronTab);
            const endCron = (0, $9zEpM.Cron)(endCronTab);
            const start = startCron.nextRun(dateStart);
            const end = endCron.nextRun(dateStart);
            if (start && end && $db2792baa37c8f0d$var$isNowInSchedule((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(start), (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(end), now)) {
                nextScreensaver = true;
                nextTouchDisabled = !!schedule.touchDisabled;
            }
            startCron.schedule(()=>{
                setScreensaver(true);
                setTouchDisabled(!!schedule.touchDisabled);
            });
            endCron.schedule(()=>{
                setScreensaver(false);
                setTouchDisabled(false);
            });
        });
        setScreensaver(nextScreensaver);
        setTouchDisabled(nextTouchDisabled);
    }, [
        clearSchedule
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eZVvM.useEffect)(()=>clearSchedule, []);
    // useEffect(() => {
    //   postMessage({
    //     method: "brightness:change",
    //     value: screensaver ? 0 : 1,
    //   });
    // }, [screensaver]);
    const value = (0, $eZVvM.useMemo)(()=>({
            paused: paused,
            setPaused: setPaused,
            screensaver: screensaver,
            scheduleScreensaver: scheduleScreensaver,
            touchDisabled: touchDisabled
        }), [
        paused,
        screensaver,
        scheduleScreensaver,
        touchDisabled
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($db2792baa37c8f0d$var$Provider, {
        value: value,
        children: children
    });
});

});
parcelRegister("lHglF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $iUWBZ = parcelRequire("iUWBZ");

var $fcba4b9d88687877$var$useCustomCompareEffect_1 = $iUWBZ.__importDefault((parcelRequire("99QKe")));

var $fcba4b9d88687877$var$isDeepEqual_1 = $iUWBZ.__importDefault((parcelRequire("aqTHk")));
var $fcba4b9d88687877$var$isPrimitive = function(val) {
    return val !== Object(val);
};
var $fcba4b9d88687877$var$useDeepCompareEffect = function(effect, deps) {
    $fcba4b9d88687877$var$useCustomCompareEffect_1.default(effect, deps, $fcba4b9d88687877$var$isDeepEqual_1.default);
};
module.exports.default = $fcba4b9d88687877$var$useDeepCompareEffect;

});

parcelRegister("38fbh", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

});

parcelRegister("j0zqp", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

});

parcelRegister("49Iup", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("9zEpM", function(module, exports) {

$parcel$export(module.exports, "Cron", function () { return $6f86bb74ef2ac9fd$export$96f87a56bc1c6511; });
function $6f86bb74ef2ac9fd$var$minitz(y, m, d, h, i, s, tz, throwOnInvalid) {
    return $6f86bb74ef2ac9fd$var$minitz.fromTZ($6f86bb74ef2ac9fd$var$minitz.tp(y, m, d, h, i, s, tz), throwOnInvalid);
}
$6f86bb74ef2ac9fd$var$minitz.fromTZISO = (localTimeStr, tz, throwOnInvalid)=>{
    return $6f86bb74ef2ac9fd$var$minitz.fromTZ($6f86bb74ef2ac9fd$var$parseISOLocal(localTimeStr, tz), throwOnInvalid);
};
$6f86bb74ef2ac9fd$var$minitz.fromTZ = function(tp, throwOnInvalid) {
    const inDate = new Date(Date.UTC(tp.y, tp.m - 1, tp.d, tp.h, tp.i, tp.s)), offset = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, inDate), dateGuess = new Date(inDate.getTime() - offset), dateOffsGuess = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, dateGuess);
    if (dateOffsGuess - offset === 0) return dateGuess;
    else {
        const dateGuess2 = new Date(inDate.getTime() - dateOffsGuess), dateOffsGuess2 = $6f86bb74ef2ac9fd$var$getTimezoneOffset(tp.tz, dateGuess2);
        if (dateOffsGuess2 - dateOffsGuess === 0) return dateGuess2;
        else if (!throwOnInvalid && dateOffsGuess2 - dateOffsGuess > 0) return dateGuess2;
        else if (!throwOnInvalid) return dateGuess;
        else throw new Error("Invalid date passed to fromTZ()");
    }
};
$6f86bb74ef2ac9fd$var$minitz.toTZ = function(d, tzStr) {
    const localDateString = d.toLocaleString("en-US", {
        timeZone: tzStr
    }).replace(/[\u202f]/, " ");
    const td = new Date(localDateString);
    return {
        y: td.getFullYear(),
        m: td.getMonth() + 1,
        d: td.getDate(),
        h: td.getHours(),
        i: td.getMinutes(),
        s: td.getSeconds(),
        tz: tzStr
    };
};
$6f86bb74ef2ac9fd$var$minitz.tp = (y, m, d, h, i, s, tz)=>{
    return {
        y: y,
        m: m,
        d: d,
        h: h,
        i: i,
        s: s,
        tz: tz
    };
};
function $6f86bb74ef2ac9fd$var$getTimezoneOffset(timeZone, date = new Date) {
    const tz = date.toLocaleString("en-US", {
        timeZone: timeZone,
        timeZoneName: "short"
    }).split(" ").slice(-1)[0];
    const dateString = date.toLocaleString("en-US").replace(/[\u202f]/, " ");
    return Date.parse(`${dateString} GMT`) - Date.parse(`${dateString} ${tz}`);
}
function $6f86bb74ef2ac9fd$var$parseISOLocal(dtStr, tz) {
    const pd = new Date(Date.parse(dtStr));
    if (isNaN(pd)) throw new Error("minitz: Invalid ISO8601 passed to parser.");
    const stringEnd = dtStr.substring(9);
    if (dtStr.includes("Z") || stringEnd.includes("-") || stringEnd.includes("+")) return $6f86bb74ef2ac9fd$var$minitz.tp(pd.getUTCFullYear(), pd.getUTCMonth() + 1, pd.getUTCDate(), pd.getUTCHours(), pd.getUTCMinutes(), pd.getUTCSeconds(), "Etc/UTC");
    else return $6f86bb74ef2ac9fd$var$minitz.tp(pd.getFullYear(), pd.getMonth() + 1, pd.getDate(), pd.getHours(), pd.getMinutes(), pd.getSeconds(), tz);
}
$6f86bb74ef2ac9fd$var$minitz.minitz = $6f86bb74ef2ac9fd$var$minitz;
function $6f86bb74ef2ac9fd$var$CronOptions(options) {
    if (options === void 0) options = {};
    delete options.name;
    options.legacyMode = options.legacyMode === void 0 ? true : options.legacyMode;
    options.paused = options.paused === void 0 ? false : options.paused;
    options.maxRuns = options.maxRuns === void 0 ? Infinity : options.maxRuns;
    options.catch = options.catch === void 0 ? false : options.catch;
    options.interval = options.interval === void 0 ? 0 : parseInt(options.interval, 10);
    options.utcOffset = options.utcOffset === void 0 ? void 0 : parseInt(options.utcOffset, 10);
    options.unref = options.unref === void 0 ? false : options.unref;
    if (options.startAt) options.startAt = new $6f86bb74ef2ac9fd$var$CronDate(options.startAt, options.timezone);
    if (options.stopAt) options.stopAt = new $6f86bb74ef2ac9fd$var$CronDate(options.stopAt, options.timezone);
    if (options.interval !== null) {
        if (isNaN(options.interval)) throw new Error("CronOptions: Supplied value for interval is not a number");
        else if (options.interval < 0) throw new Error("CronOptions: Supplied value for interval can not be negative");
    }
    if (options.utcOffset !== void 0) {
        if (isNaN(options.utcOffset)) throw new Error("CronOptions: Invalid value passed for utcOffset, should be number representing minutes offset from UTC.");
        else if (options.utcOffset < -870 || options.utcOffset > 870) throw new Error("CronOptions: utcOffset out of bounds.");
        if (options.utcOffset !== void 0 && options.timezone) throw new Error("CronOptions: Combining 'utcOffset' with 'timezone' is not allowed.");
    }
    if (options.unref !== true && options.unref !== false) throw new Error("CronOptions: Unref should be either true, false or undefined(false).");
    return options;
}
const $6f86bb74ef2ac9fd$var$DaysOfMonth = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $6f86bb74ef2ac9fd$var$RecursionSteps = [
    [
        "month",
        "year",
        0
    ],
    [
        "day",
        "month",
        -1
    ],
    [
        "hour",
        "day",
        0
    ],
    [
        "minute",
        "hour",
        0
    ],
    [
        "second",
        "minute",
        0
    ]
];
function $6f86bb74ef2ac9fd$var$CronDate(d, tz) {
    this.tz = tz;
    if (d && d instanceof Date) {
        if (!isNaN(d)) this.fromDate(d);
        else throw new TypeError("CronDate: Invalid date passed to CronDate constructor");
    } else if (d === void 0) this.fromDate(new Date);
    else if (d && typeof d === "string") this.fromString(d);
    else if (d instanceof $6f86bb74ef2ac9fd$var$CronDate) this.fromCronDate(d);
    else throw new TypeError("CronDate: Invalid type (" + typeof d + ") passed to CronDate constructor");
}
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromDate = function(inDate) {
    if (this.tz !== void 0) {
        if (typeof this.tz === "number") {
            this.ms = inDate.getUTCMilliseconds();
            this.second = inDate.getUTCSeconds();
            this.minute = inDate.getUTCMinutes() + this.tz;
            this.hour = inDate.getUTCHours();
            this.day = inDate.getUTCDate();
            this.month = inDate.getUTCMonth();
            this.year = inDate.getUTCFullYear();
            this.apply();
        } else {
            const d = $6f86bb74ef2ac9fd$var$minitz.toTZ(inDate, this.tz);
            this.ms = inDate.getMilliseconds();
            this.second = d.s;
            this.minute = d.i;
            this.hour = d.h;
            this.day = d.d;
            this.month = d.m - 1;
            this.year = d.y;
        }
    } else {
        this.ms = inDate.getMilliseconds();
        this.second = inDate.getSeconds();
        this.minute = inDate.getMinutes();
        this.hour = inDate.getHours();
        this.day = inDate.getDate();
        this.month = inDate.getMonth();
        this.year = inDate.getFullYear();
    }
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromCronDate = function(d) {
    this.tz = d.tz;
    this.year = d.year;
    this.month = d.month;
    this.day = d.day;
    this.hour = d.hour;
    this.minute = d.minute;
    this.second = d.second;
    this.ms = d.ms;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.apply = function() {
    if (this.month > 11 || this.day > $6f86bb74ef2ac9fd$var$DaysOfMonth[this.month] || this.hour > 59 || this.minute > 59 || this.second > 59 || this.hour < 0 || this.minute < 0 || this.second < 0) {
        const d = new Date(Date.UTC(this.year, this.month, this.day, this.hour, this.minute, this.second, this.ms));
        this.ms = d.getUTCMilliseconds();
        this.second = d.getUTCSeconds();
        this.minute = d.getUTCMinutes();
        this.hour = d.getUTCHours();
        this.day = d.getUTCDate();
        this.month = d.getUTCMonth();
        this.year = d.getUTCFullYear();
        return true;
    } else return false;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.fromString = function(str) {
    return this.fromDate($6f86bb74ef2ac9fd$var$minitz.fromTZISO(str, this.tz));
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.findNext = function(options, target, pattern, offset) {
    const originalTarget = this[target];
    let lastDayOfMonth;
    if (pattern.lastDayOfMonth || pattern.lastWeekdayOfMonth) {
        if (this.month !== 1) lastDayOfMonth = $6f86bb74ef2ac9fd$var$DaysOfMonth[this.month];
        else lastDayOfMonth = new Date(Date.UTC(this.year, this.month + 1, 0, 0, 0, 0, 0)).getUTCDate();
    }
    const fDomWeekDay = !pattern.starDOW && target == "day" ? new Date(Date.UTC(this.year, this.month, 1, 0, 0, 0, 0)).getUTCDay() : undefined;
    for(let i = this[target] + offset; i < pattern[target].length; i++){
        let match = pattern[target][i];
        if (target === "day" && pattern.lastDayOfMonth && i - offset == lastDayOfMonth) match = true;
        if (target === "day" && !pattern.starDOW) {
            let dowMatch = pattern.dayOfWeek[(fDomWeekDay + (i - offset - 1)) % 7];
            if (dowMatch && pattern.lastWeekdayOfMonth) dowMatch = dowMatch && i - offset > lastDayOfMonth - 7;
            if (options.legacyMode && !pattern.starDOM) match = match || dowMatch;
            else match = match && dowMatch;
        }
        if (match) {
            this[target] = i - offset;
            return originalTarget !== this[target] ? 2 : 1;
        }
    }
    return 3;
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.recurse = function(pattern, options, doing) {
    const res = this.findNext(options, $6f86bb74ef2ac9fd$var$RecursionSteps[doing][0], pattern, $6f86bb74ef2ac9fd$var$RecursionSteps[doing][2]);
    if (res > 1) {
        let resetLevel = doing + 1;
        while(resetLevel < $6f86bb74ef2ac9fd$var$RecursionSteps.length){
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[resetLevel][0]] = -$6f86bb74ef2ac9fd$var$RecursionSteps[resetLevel][2];
            resetLevel++;
        }
        if (res === 3) {
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[doing][1]]++;
            this[$6f86bb74ef2ac9fd$var$RecursionSteps[doing][0]] = -$6f86bb74ef2ac9fd$var$RecursionSteps[doing][2];
            this.apply();
            return this.recurse(pattern, options, 0);
        } else if (this.apply()) return this.recurse(pattern, options, doing - 1);
    }
    doing += 1;
    if (doing >= $6f86bb74ef2ac9fd$var$RecursionSteps.length) return this;
    else if (this.year >= 3e3) return null;
    else return this.recurse(pattern, options, doing);
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.increment = function(pattern, options, hasPreviousRun) {
    this.second += options.interval > 1 && hasPreviousRun ? options.interval : 1;
    this.ms = 0;
    this.apply();
    return this.recurse(pattern, options, 0);
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.getDate = function(internal) {
    if (internal || this.tz === void 0) return new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.ms);
    else {
        if (typeof this.tz === "number") return new Date(Date.UTC(this.year, this.month, this.day, this.hour, this.minute - this.tz, this.second, this.ms));
        else return $6f86bb74ef2ac9fd$var$minitz(this.year, this.month + 1, this.day, this.hour, this.minute, this.second, this.tz);
    }
};
$6f86bb74ef2ac9fd$var$CronDate.prototype.getTime = function() {
    return this.getDate().getTime();
};
function $6f86bb74ef2ac9fd$var$CronPattern(pattern, timezone) {
    this.pattern = pattern;
    this.timezone = timezone;
    this.second = Array(60).fill(0);
    this.minute = Array(60).fill(0);
    this.hour = Array(24).fill(0);
    this.day = Array(31).fill(0);
    this.month = Array(12).fill(0);
    this.dayOfWeek = Array(8).fill(0);
    this.lastDayOfMonth = false;
    this.lastWeekdayOfMonth = false;
    this.starDOM = false;
    this.starDOW = false;
    this.parse();
}
$6f86bb74ef2ac9fd$var$CronPattern.prototype.parse = function() {
    if (!(typeof this.pattern === "string" || this.pattern.constructor === String)) throw new TypeError("CronPattern: Pattern has to be of type string.");
    if (this.pattern.indexOf("@") >= 0) this.pattern = this.handleNicknames(this.pattern).trim();
    const parts = this.pattern.replace(/\s+/g, " ").split(" ");
    if (parts.length < 5 || parts.length > 6) throw new TypeError("CronPattern: invalid configuration format ('" + this.pattern + "'), exacly five or six space separated parts required.");
    if (parts.length === 5) parts.unshift("0");
    if (parts[3].indexOf("L") >= 0) {
        parts[3] = parts[3].replace("L", "");
        this.lastDayOfMonth = true;
    }
    if (parts[5].indexOf("L") >= 0) {
        parts[5] = parts[5].replace("L", "");
        this.lastWeekdayOfMonth = true;
    }
    if (parts[3] == "*") this.starDOM = true;
    if (parts[4].length >= 3) parts[4] = this.replaceAlphaMonths(parts[4]);
    if (parts[5].length >= 3) parts[5] = this.replaceAlphaDays(parts[5]);
    if (parts[5] == "*") this.starDOW = true;
    if (this.pattern.indexOf("?") >= 0) {
        const initDate = new $6f86bb74ef2ac9fd$var$CronDate(new Date, this.timezone).getDate(true);
        parts[0] = parts[0].replace("?", initDate.getSeconds());
        parts[1] = parts[1].replace("?", initDate.getMinutes());
        parts[2] = parts[2].replace("?", initDate.getHours());
        if (!this.starDOM) parts[3] = parts[3].replace("?", initDate.getDate());
        parts[4] = parts[4].replace("?", initDate.getMonth() + 1);
        if (!this.starDOW) parts[5] = parts[5].replace("?", initDate.getDay());
    }
    this.throwAtIllegalCharacters(parts);
    this.partToArray("second", parts[0], 0);
    this.partToArray("minute", parts[1], 0);
    this.partToArray("hour", parts[2], 0);
    this.partToArray("day", parts[3], -1);
    this.partToArray("month", parts[4], -1);
    this.partToArray("dayOfWeek", parts[5], 0);
    if (this.dayOfWeek[7]) this.dayOfWeek[0] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.partToArray = function(type, conf, valueIndexOffset) {
    const arr = this[type];
    if (conf === "*") return arr.fill(1);
    const split = conf.split(",");
    if (split.length > 1) for(let i = 0; i < split.length; i++)this.partToArray(type, split[i], valueIndexOffset);
    else if (conf.indexOf("-") !== -1 && conf.indexOf("/") !== -1) this.handleRangeWithStepping(conf, type, valueIndexOffset);
    else if (conf.indexOf("-") !== -1) this.handleRange(conf, type, valueIndexOffset);
    else if (conf.indexOf("/") !== -1) this.handleStepping(conf, type, valueIndexOffset);
    else if (conf !== "") this.handleNumber(conf, type, valueIndexOffset);
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.throwAtIllegalCharacters = function(parts) {
    const reValidCron = /[^/*0-9,-]+/;
    for(let i = 0; i < parts.length; i++){
        if (reValidCron.test(parts[i])) throw new TypeError("CronPattern: configuration entry " + i + " (" + parts[i] + ") contains illegal characters.");
    }
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleNumber = function(conf, type, valueIndexOffset) {
    const i = parseInt(conf, 10) + valueIndexOffset;
    if (isNaN(i)) throw new TypeError("CronPattern: " + type + " is not a number: '" + conf + "'");
    if (i < 0 || i >= this[type].length) throw new TypeError("CronPattern: " + type + " value out of range: '" + conf + "'");
    this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleRangeWithStepping = function(conf, type, valueIndexOffset) {
    const matches = conf.match(/^(\d+)-(\d+)\/(\d+)$/);
    if (matches === null) throw new TypeError("CronPattern: Syntax error, illegal range with stepping: '" + conf + "'");
    let [, lower, upper, steps] = matches;
    lower = parseInt(lower, 10) + valueIndexOffset;
    upper = parseInt(upper, 10) + valueIndexOffset;
    steps = parseInt(steps, 10);
    if (isNaN(lower)) throw new TypeError("CronPattern: Syntax error, illegal lower range (NaN)");
    if (isNaN(upper)) throw new TypeError("CronPattern: Syntax error, illegal upper range (NaN)");
    if (isNaN(steps)) throw new TypeError("CronPattern: Syntax error, illegal stepping: (NaN)");
    if (steps === 0) throw new TypeError("CronPattern: Syntax error, illegal stepping: 0");
    if (steps > this[type].length) throw new TypeError("CronPattern: Syntax error, steps cannot be greater than maximum value of part (" + this[type].length + ")");
    if (lower < 0 || upper >= this[type].length) throw new TypeError("CronPattern: Value out of range: '" + conf + "'");
    if (lower > upper) throw new TypeError("CronPattern: From value is larger than to value: '" + conf + "'");
    for(let i = lower; i <= upper; i += steps)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleRange = function(conf, type, valueIndexOffset) {
    const split = conf.split("-");
    if (split.length !== 2) throw new TypeError("CronPattern: Syntax error, illegal range: '" + conf + "'");
    const lower = parseInt(split[0], 10) + valueIndexOffset, upper = parseInt(split[1], 10) + valueIndexOffset;
    if (isNaN(lower)) throw new TypeError("CronPattern: Syntax error, illegal lower range (NaN)");
    else if (isNaN(upper)) throw new TypeError("CronPattern: Syntax error, illegal upper range (NaN)");
    if (lower < 0 || upper >= this[type].length) throw new TypeError("CronPattern: Value out of range: '" + conf + "'");
    if (lower > upper) throw new TypeError("CronPattern: From value is larger than to value: '" + conf + "'");
    for(let i = lower; i <= upper; i++)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleStepping = function(conf, type) {
    const split = conf.split("/");
    if (split.length !== 2) throw new TypeError("CronPattern: Syntax error, illegal stepping: '" + conf + "'");
    let start = 0;
    if (split[0] !== "*") start = parseInt(split[0], 10);
    const steps = parseInt(split[1], 10);
    if (isNaN(steps)) throw new TypeError("CronPattern: Syntax error, illegal stepping: (NaN)");
    if (steps === 0) throw new TypeError("CronPattern: Syntax error, illegal stepping: 0");
    if (steps > this[type].length) throw new TypeError("CronPattern: Syntax error, max steps for part is (" + this[type].length + ")");
    for(let i = start; i < this[type].length; i += steps)this[type][i] = 1;
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.replaceAlphaDays = function(conf) {
    return conf.replace(/-sun/gi, "-7").replace(/sun/gi, "0").replace(/mon/gi, "1").replace(/tue/gi, "2").replace(/wed/gi, "3").replace(/thu/gi, "4").replace(/fri/gi, "5").replace(/sat/gi, "6");
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.replaceAlphaMonths = function(conf) {
    return conf.replace(/jan/gi, "1").replace(/feb/gi, "2").replace(/mar/gi, "3").replace(/apr/gi, "4").replace(/may/gi, "5").replace(/jun/gi, "6").replace(/jul/gi, "7").replace(/aug/gi, "8").replace(/sep/gi, "9").replace(/oct/gi, "10").replace(/nov/gi, "11").replace(/dec/gi, "12");
};
$6f86bb74ef2ac9fd$var$CronPattern.prototype.handleNicknames = function(pattern) {
    const cleanPattern = pattern.trim().toLowerCase();
    if (cleanPattern === "@yearly" || cleanPattern === "@annually") return "0 0 1 1 *";
    else if (cleanPattern === "@monthly") return "0 0 1 * *";
    else if (cleanPattern === "@weekly") return "0 0 * * 0";
    else if (cleanPattern === "@daily") return "0 0 * * *";
    else if (cleanPattern === "@hourly") return "0 * * * *";
    else return pattern;
};
function $6f86bb74ef2ac9fd$var$isFunction(v) {
    return Object.prototype.toString.call(v) === "[object Function]" || "function" === typeof v || v instanceof Function;
}
function $6f86bb74ef2ac9fd$var$unrefTimer(timer) {
    if (typeof Deno !== "undefined" && typeof Deno.unrefTimer !== "undefined") Deno.unrefTimer(timer);
    else if (timer && typeof timer.unref !== "undefined") timer.unref();
}
const $6f86bb74ef2ac9fd$var$maxDelay = 30000;
const $6f86bb74ef2ac9fd$export$1dd82c9021421bb2 = [];
function $6f86bb74ef2ac9fd$export$96f87a56bc1c6511(pattern, fnOrOptions1, fnOrOptions2) {
    if (!(this instanceof $6f86bb74ef2ac9fd$export$96f87a56bc1c6511)) return new $6f86bb74ef2ac9fd$export$96f87a56bc1c6511(pattern, fnOrOptions1, fnOrOptions2);
    let options, func;
    if ($6f86bb74ef2ac9fd$var$isFunction(fnOrOptions1)) func = fnOrOptions1;
    else if (typeof fnOrOptions1 === "object") options = fnOrOptions1;
    else if (fnOrOptions1 !== void 0) throw new Error("Cron: Invalid argument passed for optionsIn. Should be one of function, or object (options).");
    if ($6f86bb74ef2ac9fd$var$isFunction(fnOrOptions2)) func = fnOrOptions2;
    else if (typeof fnOrOptions2 === "object") options = fnOrOptions2;
    else if (fnOrOptions2 !== void 0) throw new Error("Cron: Invalid argument passed for funcIn. Should be one of function, or object (options).");
    this.name = options ? options.name : void 0;
    this.options = $6f86bb74ef2ac9fd$var$CronOptions(options);
    this._states = {
        kill: false,
        blocking: false,
        previousRun: void 0,
        currentRun: void 0,
        once: void 0,
        currentTimeout: void 0,
        maxRuns: options ? options.maxRuns : void 0,
        paused: options ? options.paused : false,
        pattern: void 0
    };
    if (pattern && (pattern instanceof Date || typeof pattern === "string" && pattern.indexOf(":") > 0)) this._states.once = new $6f86bb74ef2ac9fd$var$CronDate(pattern, this.options.timezone || this.options.utcOffset);
    else this._states.pattern = new $6f86bb74ef2ac9fd$var$CronPattern(pattern, this.options.timezone);
    if (this.name) {
        const existing = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.find((j)=>j.name === this.name);
        if (existing) throw new Error("Cron: Tried to initialize new named job '" + this.name + "', but name already taken.");
        else $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.push(this);
    }
    if (func !== void 0) {
        this.fn = func;
        this.schedule();
    }
    return this;
}
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.nextRun = function(prev) {
    const next = this._next(prev);
    return next ? next.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.nextRuns = function(n, previous) {
    if (n > this._states.maxRuns) n = this._states.maxRuns;
    const enumeration = [];
    let prev = previous || this._states.currentRun;
    while(n-- && (prev = this.nextRun(prev)))enumeration.push(prev);
    return enumeration;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.getPattern = function() {
    return this._states.pattern ? this._states.pattern.pattern : void 0;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isRunning = function() {
    const msLeft = this.msToNext(this._states.currentRun);
    const isRunning = !this._states.paused;
    const isScheduled = this.fn !== void 0;
    const notIsKilled = !this._states.kill;
    return isRunning && isScheduled && notIsKilled && msLeft !== null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isStopped = function() {
    return this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.isBusy = function() {
    return this._states.blocking;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.currentRun = function() {
    return this._states.currentRun ? this._states.currentRun.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.previousRun = function() {
    return this._states.previousRun ? this._states.previousRun.getDate() : null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.msToNext = function(prev) {
    const next = this._next(prev);
    prev = new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset);
    if (next) return next.getTime(true) - prev.getTime(true);
    else return null;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.stop = function() {
    this._states.kill = true;
    if (this._states.currentTimeout) clearTimeout(this._states.currentTimeout);
    const jobIndex = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.indexOf(this);
    if (jobIndex >= 0) $6f86bb74ef2ac9fd$export$1dd82c9021421bb2.splice(jobIndex, 1);
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.pause = function() {
    this._states.paused = true;
    return !this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.resume = function() {
    this._states.paused = false;
    return !this._states.kill;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.schedule = function(func, partial) {
    if (func && this.fn) throw new Error("Cron: It is not allowed to schedule two functions using the same Croner instance.");
    else if (func) this.fn = func;
    let waitMs = this.msToNext(partial ? partial : this._states.currentRun);
    const target = this.nextRun(partial ? partial : this._states.currentRun);
    if (waitMs === null || target === null) return this;
    if (waitMs > $6f86bb74ef2ac9fd$var$maxDelay) waitMs = $6f86bb74ef2ac9fd$var$maxDelay;
    this._states.currentTimeout = setTimeout(()=>this._checkTrigger(target), waitMs);
    if (this._states.currentTimeout && this.options.unref) $6f86bb74ef2ac9fd$var$unrefTimer(this._states.currentTimeout);
    return this;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._trigger = async function(initiationDate) {
    this._states.blocking = true;
    this._states.currentRun = new $6f86bb74ef2ac9fd$var$CronDate(void 0, this.options.timezone || this.options.utcOffset);
    if (this.options.catch) try {
        await this.fn(this, this.options.context);
    } catch (_e) {
        if ($6f86bb74ef2ac9fd$var$isFunction(this.options.catch)) this.options.catch(_e, this);
    }
    else await this.fn(this, this.options.context);
    this._states.previousRun = new $6f86bb74ef2ac9fd$var$CronDate(initiationDate, this.options.timezone || this.options.utcOffset);
    this._states.blocking = false;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype.trigger = async function() {
    await this._trigger();
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._checkTrigger = function(target) {
    const now = new Date, shouldRun = !this._states.paused && now.getTime() >= target, isBlocked = this._states.blocking && this.options.protect;
    if (shouldRun && !isBlocked) {
        this._states.maxRuns--;
        this._trigger();
    } else if (shouldRun && isBlocked && $6f86bb74ef2ac9fd$var$isFunction(this.options.protect)) setTimeout(()=>this.options.protect(this), 0);
    this.schedule(undefined, now);
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.prototype._next = function(prev) {
    const hasPreviousRun = prev || this._states.currentRun ? true : false;
    prev = new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset);
    if (this.options.startAt && prev && prev.getTime() < this.options.startAt.getTime()) prev = this.options.startAt;
    const nextRun = this._states.once || new $6f86bb74ef2ac9fd$var$CronDate(prev, this.options.timezone || this.options.utcOffset).increment(this._states.pattern, this.options, hasPreviousRun);
    if (this._states.once && this._states.once.getTime() <= prev.getTime()) return null;
    else if (nextRun === null || this._states.maxRuns <= 0 || this._states.kill || this.options.stopAt && nextRun.getTime() >= this.options.stopAt.getTime()) return null;
    else return nextRun;
};
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.Cron = $6f86bb74ef2ac9fd$export$96f87a56bc1c6511;
$6f86bb74ef2ac9fd$export$96f87a56bc1c6511.scheduledJobs = $6f86bb74ef2ac9fd$export$1dd82c9021421bb2;

});

parcelRegister("70E8R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e6ed51d2445ab6c$export$2e2bcd8739ae039; });

var $eZVvM = parcelRequire("eZVvM");

var $k55lg = parcelRequire("k55lg");

var $8xLkR = parcelRequire("8xLkR");
const $1e6ed51d2445ab6c$var$useInteraction = (callback, timeout = 180000)=>{
    const idle = (0, (/*@__PURE__*/$parcel$interopDefault($k55lg)))(timeout, false);
    const prevIdle = (0, (/*@__PURE__*/$parcel$interopDefault($8xLkR)))(idle);
    (0, $eZVvM.useEffect)(()=>{
        if (!prevIdle && idle) callback("idle");
        if (prevIdle && !idle) callback("active");
    }, [
        idle,
        prevIdle,
        callback
    ]);
};
var $1e6ed51d2445ab6c$export$2e2bcd8739ae039 = $1e6ed51d2445ab6c$var$useInteraction;

});
parcelRegister("k55lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $6nbhO = parcelRequire("6nbhO");

var $5rwF9 = parcelRequire("5rwF9");
var $03c5d02dd7efa52a$var$defaultEvents = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
var $03c5d02dd7efa52a$var$oneMinute = 60e3;
var $03c5d02dd7efa52a$var$useIdle = function(ms, initialState, events) {
    if (ms === void 0) ms = $03c5d02dd7efa52a$var$oneMinute;
    if (initialState === void 0) initialState = false;
    if (events === void 0) events = $03c5d02dd7efa52a$var$defaultEvents;
    var _a = $eZVvM.useState(initialState), state = _a[0], setState = _a[1];
    $eZVvM.useEffect(function() {
        var mounted = true;
        var timeout;
        var localState = state;
        var set = function(newState) {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        var onEvent = $6nbhO.throttle(50, function() {
            if (localState) set(false);
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                return set(true);
            }, ms);
        });
        var onVisibility = function() {
            if (!document.hidden) onEvent();
        };
        for(var i = 0; i < events.length; i++)$5rwF9.on(window, events[i], onEvent);
        $5rwF9.on(document, "visibilitychange", onVisibility);
        timeout = setTimeout(function() {
            return set(true);
        }, ms);
        return function() {
            mounted = false;
            for(var i = 0; i < events.length; i++)$5rwF9.off(window, events[i], onEvent);
            $5rwF9.off(document, "visibilitychange", onVisibility);
        };
    }, [
        ms,
        events
    ]);
    return state;
};
module.exports.default = $03c5d02dd7efa52a$var$useIdle;

});
parcelRegister("6nbhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */ function $4a3da5460727821c$var$throttle(delay, noTrailing, callback, debounceMode) {
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    } // `noTrailing` defaults to falsy.
    if (typeof noTrailing !== "boolean") {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */ exec();
        else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function $4a3da5460727821c$var$debounce(delay, atBegin, callback) {
    return callback === undefined ? $4a3da5460727821c$var$throttle(delay, atBegin, false) : $4a3da5460727821c$var$throttle(delay, callback, atBegin !== false);
}
module.exports.debounce = $4a3da5460727821c$var$debounce;
module.exports.throttle = $4a3da5460727821c$var$throttle;

});

parcelRegister("5rwF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNavigator = module.exports.isBrowser = module.exports.off = module.exports.on = module.exports.noop = void 0;
var $3f68cf7be4ebe020$var$noop = function() {};
module.exports.noop = $3f68cf7be4ebe020$var$noop;
function $3f68cf7be4ebe020$var$on(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
module.exports.on = $3f68cf7be4ebe020$var$on;
function $3f68cf7be4ebe020$var$off(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
module.exports.off = $3f68cf7be4ebe020$var$off;
module.exports.isBrowser = typeof window !== "undefined";
module.exports.isNavigator = typeof navigator !== "undefined";

});


parcelRegister("8xLkR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $6OqFv = parcelRequire("6OqFv");
var $63861fa5f07d4f8c$var$strictEquals = function(prev, next) {
    return prev === next;
};
function $63861fa5f07d4f8c$var$usePreviousDistinct(value, compare) {
    if (compare === void 0) compare = $63861fa5f07d4f8c$var$strictEquals;
    var prevRef = $eZVvM.useRef();
    var curRef = $eZVvM.useRef(value);
    var isFirstMount = $6OqFv.useFirstMountState();
    if (!isFirstMount && !compare(curRef.current, value)) {
        prevRef.current = curRef.current;
        curRef.current = value;
    }
    return prevRef.current;
}
module.exports.default = $63861fa5f07d4f8c$var$usePreviousDistinct;

});
parcelRegister("6OqFv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useFirstMountState = void 0;

var $eZVvM = parcelRequire("eZVvM");
function $4f5c195ed174124c$var$useFirstMountState() {
    var isFirst = $eZVvM.useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
module.exports.useFirstMountState = $4f5c195ed174124c$var$useFirstMountState;

});





parcelRegister("5fmC2", function(module, exports) {

$parcel$export(module.exports, "usePersistentQuery", function () { return $308fcde48482489f$export$baf12180f07dea6c; });

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
function $308fcde48482489f$var$getStorageKey() {
    if (!window.name) window.name = `tab_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    return `__persistent_query__${window.name}`;
}
function $308fcde48482489f$export$baf12180f07dea6c() {
    return (0, $eZVvM.useMemo)(()=>{
        const { search: search } = window.location;
        const key = $308fcde48482489f$var$getStorageKey();
        if (search) {
            const parsed = (0, $f19az.default).parse(search);
            try {
                localStorage.setItem(key, JSON.stringify(parsed));
            } catch (error) {
                console.log("[usePersistentQuery] Failed to save query to localStorage:", error);
            }
            return parsed;
        }
        const saved = localStorage.getItem(key);
        if (saved) try {
            return JSON.parse(saved);
        } catch (e) {
            return {};
        }
        return {};
    }, []);
}

});


parcelRegister("kCXUJ", function(module, exports) {

$parcel$export(module.exports, "QUERY_ACCESS_EVENT", function () { return $ebb0843a0d28e175$export$cf0a2c204733fec0; });
$parcel$export(module.exports, "QUERY_EMPLOYEES", function () { return $ebb0843a0d28e175$export$77575dde1010e853; });
$parcel$export(module.exports, "QUERY_DIGITAL_RECEPTION", function () { return $ebb0843a0d28e175$export$e8f50cecae62c891; });
$parcel$export(module.exports, "QUERY_CURRENTLY_CHECKED_IN", function () { return $ebb0843a0d28e175$export$d31fe08ab069cda5; });
$parcel$export(module.exports, "QUERY_DIGITAL_RECEPTION_PUBLIC", function () { return $ebb0843a0d28e175$export$d908ec64cd7e661a; });
$parcel$export(module.exports, "QUERY_MEMBER_CODE_CHECK", function () { return $ebb0843a0d28e175$export$53cb9efb56f11ca0; });

var $g6uH4 = parcelRequire("g6uH4");

var $fQgQB = parcelRequire("fQgQB");
const $ebb0843a0d28e175$export$cf0a2c204733fec0 = (0, $g6uH4.gql)`
  query accessEvent($id: ID!) {
    accessEvent(id: $id) {
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      customReceiver {
        phone
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $ebb0843a0d28e175$export$77575dde1010e853 = (0, $g6uH4.gql)`
  query employees(
    $filter: EmployeeFilterType
    $sort: EmployeeSortType
    $pagination: Pagination
  ) {
    employees(filter: $filter, sort: $sort, pagination: $pagination) {
      id
      fullName
      email
      phone
    }
  }
`;
const $ebb0843a0d28e175$export$e8f50cecae62c891 = (0, $g6uH4.gql)`
  query digitalReception($id: ID!, $language: String) {
    digitalReception(id: $id, language: $language) {
      id
      client {
        id
        plan
        preferences {
          ...FragmentClientPreferences
        }
      }
      metadata
      language
      languages
      theme {
        ...FragmentDigitalReceptionTheme
      }
      schedules {
        ...FragmentScreenSchedule
      }
      entranceAgreement {
        ...FragmentEntranceAgreement
      }
      settings {
        ...FragmentDigitalReceptionSettings
      }
      building {
        title
        address
        city
        zipCode
        country
      }
      code
      communicationProvider
      teams {
        id
      }
      googleChat {
        id
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_SCREEN_SCHEDULE)}
  ${(0, $fQgQB.FRAGMENT_CLIENT_PREFERENCES)}
  ${(0, $fQgQB.FRAGMENT_DIGITAL_RECEPTION_THEME)}
  ${(0, $fQgQB.FRAGMENT_ENTRANCE_AGREEMENT)}
  ${(0, $fQgQB.FRAGMENT_DIGITAL_RECEPTION_SETTINGS)}
`;
const $ebb0843a0d28e175$export$d31fe08ab069cda5 = (0, $g6uH4.gql)`
  query currentlyCheckedIn(
    $companyId: ID
    $filter: AccessEventFilterType
    $pagination: Pagination
  ) {
    currentlyCheckedIn(
      companyId: $companyId
      filter: $filter
      pagination: $pagination
    ) {
      events {
        type
        owner {
          ...FragmentAccessEventOwner
        }
        receiver {
          fullName
        }
        metadata
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $ebb0843a0d28e175$export$d908ec64cd7e661a = (0, $g6uH4.gql)`
  query digitalReception($input: InputDigitalReceptionPublic!) {
    digitalReceptionPublic(input: $input) {
      playerUrl
    }
  }
`;
const $ebb0843a0d28e175$export$53cb9efb56f11ca0 = (0, $g6uH4.gql)`
  query getMemberTypeAndPhotoStatusByCode($code: String!) {
    getMemberTypeAndPhotoStatusByCode(code: $code) {
      type
      hasPhoto
    }
  }
`;

});
parcelRegister("fQgQB", function(module, exports) {

$parcel$export(module.exports, "FRAGMENT_DIGITAL_RECEPTION_THEME", function () { return $a47aa5113f86a115$export$20b1cd0db2ebb3d4; });
$parcel$export(module.exports, "FRAGMENT_SCREEN_SCHEDULE", function () { return $a47aa5113f86a115$export$9a588ab82ba66959; });
$parcel$export(module.exports, "FRAGMENT_EMPLOYEE_PREFERENCES", function () { return $a47aa5113f86a115$export$b494824c1c2817cb; });
$parcel$export(module.exports, "FRAGMENT_CLIENT_PREFERENCES", function () { return $a47aa5113f86a115$export$c65ed6fe6a38c1e6; });
$parcel$export(module.exports, "FRAGMENT_OWNER", function () { return $a47aa5113f86a115$export$95933c24682aa981; });
$parcel$export(module.exports, "FRAGMENT_ENTRANCE_AGREEMENT", function () { return $a47aa5113f86a115$export$c6c01953d2fddc54; });
$parcel$export(module.exports, "FRAGMENT_DIGITAL_RECEPTION_SETTINGS", function () { return $a47aa5113f86a115$export$bb363c7221836f3c; });

var $g6uH4 = parcelRequire("g6uH4");
const $a47aa5113f86a115$export$20b1cd0db2ebb3d4 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionTheme on DigitalReceptionTheme {
    colors {
      primary
      background
      textPrimary
    }
    images {
      hero {
        id
        filename
        absolutePath
      }
      logo {
        id
        filename
        absolutePath
      }
    }
  }
`;
const $a47aa5113f86a115$export$c6ac7e71bcb9167c = (0, $g6uH4.gql)`
  fragment FragmentSchedule on Schedule {
    id

    weekdays

    startDate
    startTime

    endDate
    endTime

    disabled
    touchDisabled
  }
`;
const $a47aa5113f86a115$export$9a588ab82ba66959 = (0, $g6uH4.gql)`
  fragment FragmentScreenSchedule on ScreenSchedule {
    id
    type
    schedule {
      ...FragmentSchedule
    }
  }
  ${$a47aa5113f86a115$export$c6ac7e71bcb9167c}
`;
const $a47aa5113f86a115$export$6a8f18d8ea593ef6 = (0, $g6uH4.gql)`
  fragment FragmentPreferenceChannels on MemberGroupPreferenceChannels {
    sms
    call
    ping
    videoCall
    teamsCall
    teamsMessage
    googleChatMessage
  }
`;
const $a47aa5113f86a115$export$560f90d339047c88 = (0, $g6uH4.gql)`
  fragment FragmentPreferenceAutoChannels on MemberGroupPreferenceAutoChannels {
    email
    sms
    call
    ping
    videoCall
    teamsCall
    teamsMessage
    googleChatMessage
  }
`;
const $a47aa5113f86a115$export$91aaef8c1a4379e5 = (0, $g6uH4.gql)`
  fragment FragmentPreference on MemberGroupPreference {
    enabled
    channel {
      ...FragmentPreferenceChannels
    }
    autoChannel {
      ...FragmentPreferenceAutoChannels
    }
  }
  ${$a47aa5113f86a115$export$6a8f18d8ea593ef6}
  ${$a47aa5113f86a115$export$560f90d339047c88}
`;
const $a47aa5113f86a115$export$b494824c1c2817cb = (0, $g6uH4.gql)`
  fragment FragmentEmployeePreferences on MemberGroupPreferences {
    visitor {
      ...FragmentPreference
    }
    meetingAttendee {
      ...FragmentPreference
    }
    foodDelivery {
      ...FragmentPreference
    }
    packageDelivery {
      ...FragmentPreference
    }
  }
  ${$a47aa5113f86a115$export$91aaef8c1a4379e5}
`;
const $a47aa5113f86a115$export$7ca79fdf9789341e = (0, $g6uH4.gql)`
  fragment FragmentClientCompanyPreferences on ClientCompanyPreferences {
    employee {
      ...FragmentEmployeePreferences
    }
  }
  ${$a47aa5113f86a115$export$b494824c1c2817cb}
`;
const $a47aa5113f86a115$export$c65ed6fe6a38c1e6 = (0, $g6uH4.gql)`
  fragment FragmentClientPreferences on ClientPreferences {
    company {
      ...FragmentClientCompanyPreferences
    }
    shelly {
      enabled
    }
    documentScanner {
      enabled
    }
    tuya {
      enabled
    }
  }
  ${$a47aa5113f86a115$export$7ca79fdf9789341e}
`;
const $a47aa5113f86a115$export$95933c24682aa981 = (0, $g6uH4.gql)`
  fragment FragmentAccessEventOwner on AccessEventOwner {
    ... on Visitor {
      id
      type
      email
      fullName
    }
    ... on Employee {
      id
      type
      email
      fullName
      availablePreferences {
        ...FragmentEmployeePreferences
      }
    }
    ... on MeetingAttendee {
      id
      email
      fullName
      member {
        type
        email
        fullName
      }
    }
    ... on Guest {
      id
      fields {
        name
        value
      }
    }
  }
  ${$a47aa5113f86a115$export$b494824c1c2817cb}
`;
const $a47aa5113f86a115$export$675138ff75242c9b = (0, $g6uH4.gql)`
  fragment FragmentEntranceAgreementFile on EntranceAgreementFile {
    id
    title
    text
    file {
      id
      absolutePath
      pages {
        id
        absolutePath
      }
    }

    approvalRequired
    disabled

    audience {
      employee {
        enabled
      }
      visitor {
        enabled
      }
      guest {
        enabled
      }
      meetingAttendee {
        enabled
      }
    }

    validFrom
    validUntil
  }
`;
const $a47aa5113f86a115$export$c6c01953d2fddc54 = (0, $g6uH4.gql)`
  fragment FragmentEntranceAgreement on EntranceAgreement {
    id
    showFirst
    disabled
    validFrom
    validUntil
    files {
      ...FragmentEntranceAgreementFile
    }
  }
  ${$a47aa5113f86a115$export$675138ff75242c9b}
`;
const $a47aa5113f86a115$export$78412636be0d2636 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionLayoutOption on DigitalReceptionLayoutOption {
    enabled
    text
    registration {
      id
      fields {
        id
        type
        label
        required
        code
        name
        manualCheckoutIdentifier
        dropdownOptions {
          label
          value
        }
        checkbox {
          description {
            title
            text
          }
          label
        }
        radioButtons {
          buttons {
            label
            value
          }
          hasOther
        }
      }
    }
    isCustom
    instruction
    svg
    callMenu {
      enabled
      options {
        label
        phone
        email
      }
    }
    wayfindingOptions {
      label
      instructionLabel
      svg
      colors {
        background
        text
      }
    }
    bellController {
      id
      timeout
    }
  }
`;
const $a47aa5113f86a115$export$18fc043402fabde6 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionLayout on DigitalReceptionLayout {
    welcomeMessage {
      ...FragmentDigitalReceptionLayoutOption
    }
    checkin {
      ...FragmentDigitalReceptionLayoutOption
    }
    integratedManualCheckin {
      ...FragmentDigitalReceptionLayoutOption
    }
    independentManualCheckin {
      ...FragmentDigitalReceptionLayoutOption
    }
    checkout {
      ...FragmentDigitalReceptionLayoutOption
    }
    manualCheckout {
      ...FragmentDigitalReceptionLayoutOption
    }
    package {
      ...FragmentDigitalReceptionLayoutOption
    }
    food {
      ...FragmentDigitalReceptionLayoutOption
    }
    callReception {
      ...FragmentDigitalReceptionLayoutOption
    }
    overview {
      ...FragmentDigitalReceptionLayoutOption
    }
    wifi {
      ...FragmentDigitalReceptionLayoutOption
    }
    wayfinding {
      ...FragmentDigitalReceptionLayoutOption
    }
    multiWayfinding {
      ...FragmentDigitalReceptionLayoutOption
    }
    bell {
      ...FragmentDigitalReceptionLayoutOption
    }
  }
  ${$a47aa5113f86a115$export$78412636be0d2636}
`;
const $a47aa5113f86a115$export$4fc3d79097492f77 = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionAccess on DigitalReceptionAccess {
    enabled
    controller
    checkin {
      enabled
      autoSwitch
      employee {
        enabled
      }
      visitor {
        enabled
      }
      guest {
        enabled
      }
      meetingAttendee {
        enabled
      }
    }
    checkout {
      enabled
      autoSwitch
      employee {
        enabled
      }
      visitor {
        enabled
      }
      guest {
        enabled
      }
      meetingAttendee {
        enabled
      }
    }
  }
`;
const $a47aa5113f86a115$export$bb363c7221836f3c = (0, $g6uH4.gql)`
  fragment FragmentDigitalReceptionSettings on DigitalReceptionSettings {
    support {
      phone
      email
    }
    layout {
      ...FragmentDigitalReceptionLayout
    }
    animations {
      enabled
    }
    printing {
      enabled
      printer
      label {
        width
        height
      }
    }
    receptionistPhone {
      primary
      backup
    }
    receptionistTeams {
      email
      groupId
    }
    call {
      ringDuration
      maxDuration
    }
    deliveryReceiver {
      fullName
      email
      phone
    }
    overview {
      code
      openWithoutCode
      fields
    }
    wifi {
      qrCode
    }
    clock {
      enabled
      opacity
    }
    photoCapture {
      enabled
      employee {
        enabled
        required
      }
      visitor {
        enabled
        required
      }
      meetingAttendee {
        enabled
        required
      }
    }
    contactPreview {
      enabled
    }
    teamsVideoCall {
      enabled
    }
    shelly {
      ...FragmentDigitalReceptionAccess
    }
    scanner {
      enabled
      autoScan {
        enabled
        type
        onlyQrScanner
      }
    }
    nfc {
      enabled
      socketUrl
    }
    documentScanner {
      enabled
      fullName {
        enabled
        allowManualInput
        field
      }
      documentNumber {
        enabled
        allowManualInput
        field
      }
      nationality {
        enabled
        allowManualInput
        field
      }
      gender {
        enabled
        allowManualInput
        field
      }
      expirationDate {
        enabled
        allowManualInput
        field
      }
      personalNumber {
        enabled
        allowManualInput
        field
      }
    }
    tuya {
      ...FragmentDigitalReceptionAccess
    }
  }
  ${$a47aa5113f86a115$export$18fc043402fabde6}
  ${$a47aa5113f86a115$export$4fc3d79097492f77}
`;

});


parcelRegister("219y6", function(module, exports) {

$parcel$export(module.exports, "useOfflineContext", function () { return $b10355302a504c8a$export$a2fa15de55d14150; });
$parcel$export(module.exports, "default", function () { return $b10355302a504c8a$export$2e2bcd8739ae039; });

var $bhfvP = parcelRequire("bhfvP");

var $6lhov = parcelRequire("6lhov");

var $eZVvM = parcelRequire("eZVvM");

var $1PAIo = parcelRequire("1PAIo");

var $dsl2s = parcelRequire("dsl2s");

var $eOD8X = parcelRequire("eOD8X");
const $b10355302a504c8a$export$46814dd5412c611c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $b10355302a504c8a$export$a2fa15de55d14150 = ()=>(0, $eZVvM.useContext)($b10355302a504c8a$export$46814dd5412c611c);
const $b10355302a504c8a$export$5256df5912efd519 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const [online, setOnline] = (0, $eZVvM.useState)(true);
    const [locationHref, setLocationHref] = (0, $eZVvM.useState)();
    (0, $6lhov.onlineManager).setOnline(true);
    (0, $eZVvM.useEffect)(()=>{
        // service worker needs to be registered on a path
        // with a trailing slash because of scope issues
        // https://github.com/w3c/ServiceWorker/issues/1272
        //
        // This is a workaround to redirect the user to the
        // correct path for sw registration
        if (window.location.pathname.endsWith("/")) {
            (0, $dsl2s.registerServiceWorker)();
            return;
        }
        window.location.href = window.location.pathname + "/";
    }, []);
    const handleBeforeUnload = (0, $eZVvM.useCallback)((e)=>{
        // on beforeunload, check if the location is valid
        // (ends with a trailing slash and is not the root)
        // if not, redirect to the correct location saved in
        // locationHref otherwise redirect to the
        // [referer](https://developer.mozilla.org/en-US/docs/Web/API/Document/referrer)
        // (in case of manual refresh, referer is the url
        // that was in the address bar before the refresh)
        const locationValid = window.location.pathname.length > 2 && window.location.pathname.endsWith("/");
        if (locationValid) return;
        if (locationHref) window.location.href = window.location.pathname + "/";
        window.location.href = document.referrer + (document.referrer.endsWith("/") ? "" : "/");
    }, []);
    (0, $1PAIo.useBeforeUnload)(handleBeforeUnload);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("online", checkOnline);
        window.addEventListener("offline", checkOnline);
        checkOnline();
        return ()=>{
            window.removeEventListener("online", checkOnline);
            window.removeEventListener("offline", checkOnline);
        };
    }, []);
    const checkOnline = (0, $eZVvM.useCallback)(async ()=>{
        setLocationHref(()=>{
            var _window_location;
            return (_window_location = window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
        });
        try {
            const apiUrl = (0, $eOD8X.getApiUrl)();
            const apiServer = fetch(`${apiUrl}/favicon.ico`);
            const appServer = fetch("/app-server/healthcheck");
            const response = await Promise.all([
                apiServer,
                appServer
            ]);
            if (response.some(({ status: status })=>status !== 200)) throw new Error("Network not available");
            // const response = await fetch(apiUrl + "/favicon.ico");
            // if (!response.ok || response.status === 503) {
            //   throw new Error('Network not available');
            // }
            setOnline(()=>true);
        } catch (error) {
            setOnline(()=>false);
        }
    }, []);
    const storeData = (0, $eZVvM.useCallback)(async (key, data)=>{
        if (!("caches" in window)) return new Promise((_, reject)=>{
            reject();
        });
        const cache = await caches.open("digitalreception-v1");
        await cache.put(key, new Response(JSON.stringify(data)));
    }, []);
    const getData = (0, $eZVvM.useCallback)(async (key)=>{
        if (!("caches" in window)) return new Promise((_, reject)=>{
            reject();
        });
        const cache = await caches.open("digitalreception-v1");
        const cacheData = await cache.match(key);
        const data = await (cacheData === null || cacheData === void 0 ? void 0 : cacheData.text());
        if (data) return JSON.parse(data);
        return undefined;
    }, []);
    /**
   * Refresh the page until a specific mark is found in localStorage
   * @param mark The mark to look for in localStorage
   * @param duration The duration to wait before refreshing the page again, default is 2000ms
   *
   */ const refreshUntilMark = (0, $eZVvM.useCallback)((mark, duration = 2000)=>{
        setTimeout(()=>{
            if (!Boolean(localStorage.getItem(mark))) window.location.reload();
            localStorage.setItem(mark, "true");
        }, duration);
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            online: online,
            storeData: storeData,
            getData: getData,
            setOnline: setOnline,
            checkOnline: checkOnline,
            refreshUntilMark: refreshUntilMark
        }), [
        online,
        storeData
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($b10355302a504c8a$export$46814dd5412c611c.Provider, {
        value: value,
        children: children
    });
});
var $b10355302a504c8a$export$2e2bcd8739ae039 = $b10355302a504c8a$export$5256df5912efd519;

});
parcelRegister("dsl2s", function(module, exports) {

$parcel$export(module.exports, "registerServiceWorker", function () { return $35d7a1122a829cdc$export$c6245babf0c60892; });

const $35d7a1122a829cdc$var$serviceWorkerPath = new URL((parcelRequire("hNSY9")));
const $35d7a1122a829cdc$var$serviceWorkerFilename = ($35d7a1122a829cdc$var$serviceWorkerPath + "").split("/").pop();
const $35d7a1122a829cdc$var$pathname = window.location.pathname;
const $35d7a1122a829cdc$var$isDev = false;
const $35d7a1122a829cdc$var$fullPath = $35d7a1122a829cdc$var$pathname[$35d7a1122a829cdc$var$pathname.length - 1] === "/" ? $35d7a1122a829cdc$var$pathname.slice(0, $35d7a1122a829cdc$var$pathname.length - 1) : $35d7a1122a829cdc$var$pathname;
const $35d7a1122a829cdc$var$isSwInstalled = localStorage.getItem(`sw-installed-${"digitalreception-v1"}`) === "true";
async function $35d7a1122a829cdc$export$c6245babf0c60892() {
    if (!("serviceWorker" in navigator) || window.top !== window.self || !$35d7a1122a829cdc$var$serviceWorkerFilename || $35d7a1122a829cdc$var$isDev) // don't instantiate service worker:
    // [1] if service worker isn't supported
    // [2] in iframes
    // [3] if there is no service worker file
    // [4] in development mode
    return;
    try {
        const registration = await navigator.serviceWorker.register($35d7a1122a829cdc$var$fullPath + "/" + $35d7a1122a829cdc$var$serviceWorkerFilename, {
            // type: "module",
            scope: $35d7a1122a829cdc$var$fullPath + "/"
        });
        // Force an update check
        await registration.update();
        // Listen for updates to the service worker
        registration.onupdatefound = ()=>{
            console.log("Service worker update found...");
            const newWorker = registration.installing;
            if (newWorker) {
                console.log("A new service worker is being installed...");
                newWorker.onstatechange = ()=>{
                    if (newWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            // New update available
                            console.log("New service worker installed. Activating...");
                            newWorker.postMessage({
                                action: "skipWaiting"
                            });
                        } else console.log("Service worker installed for the first time.");
                    }
                };
            } else console.log("No new service worker found...");
        };
        // Automatically reload the page when the new service worker takes over
        navigator.serviceWorker.addEventListener("controllerchange", ()=>{
            console.log("New service worker activated. Reloading the page...");
            window.location.reload();
        });
    } catch (error) {
        console.error(`Registration failed with ${error}`);
    }
}

});
parcelRegister("hNSY9", function(module, exports) {

module.exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "sw.84df6f78.js";

});





parcelRegister("1dirW", function(module, exports) {
(function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join("");
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push("=");
            }
            return base64.join("");
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("2uhSt", function(module, exports) {
var $1cfc403e6bd31422$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $1cfc403e6bd31422$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($1cfc403e6bd31422$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join("");
        }
    }
};
module.exports = $1cfc403e6bd31422$var$charenc;

});

parcelRegister("bGeEO", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($880efc96c81d3d2c$var$isBuffer(obj) || $880efc96c81d3d2c$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $880efc96c81d3d2c$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $880efc96c81d3d2c$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === "function" && typeof obj.slice === "function" && $880efc96c81d3d2c$var$isBuffer(obj.slice(0, 0));
}

});

parcelRegister("bBnY4", function(module, exports) {

$parcel$export(module.exports, "AzureLogger", function () { return $8725bdeae134045e$export$e8fb5f2ce3b591d; });
$parcel$export(module.exports, "setLogLevel", function () { return $8725bdeae134045e$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "getLogLevel", function () { return $8725bdeae134045e$export$12dbaabc76fb091a; });
$parcel$export(module.exports, "createClientLogger", function () { return $8725bdeae134045e$export$6817aa89e2fe44fd; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $1lRM4 = parcelRequire("1lRM4");

var $lUPho = parcelRequire("lUPho");
const $8725bdeae134045e$var$registeredLoggers = new Set();
const $8725bdeae134045e$var$logLevelFromEnv = (typeof $lUPho !== "undefined" && $lUPho.env && undefined, undefined);
let $8725bdeae134045e$var$azureLogLevel;
const $8725bdeae134045e$export$e8fb5f2ce3b591d = (0, $1lRM4.default)("azure");
$8725bdeae134045e$export$e8fb5f2ce3b591d.log = (...args)=>{
    (0, $1lRM4.default).log(...args);
};
const $8725bdeae134045e$var$AZURE_LOG_LEVELS = [
    "verbose",
    "info",
    "warning",
    "error"
];
if ($8725bdeae134045e$var$logLevelFromEnv) {
    // avoid calling setLogLevel because we don't want a mis-set environment variable to crash
    if ($8725bdeae134045e$var$isAzureLogLevel($8725bdeae134045e$var$logLevelFromEnv)) $8725bdeae134045e$export$c622e99c0ce7b1c9($8725bdeae134045e$var$logLevelFromEnv);
    else console.error(`AZURE_LOG_LEVEL set to unknown log level '${$8725bdeae134045e$var$logLevelFromEnv}'; logging is not enabled. Acceptable values: ${$8725bdeae134045e$var$AZURE_LOG_LEVELS.join(", ")}.`);
}
function $8725bdeae134045e$export$c622e99c0ce7b1c9(level) {
    if (level && !$8725bdeae134045e$var$isAzureLogLevel(level)) throw new Error(`Unknown log level '${level}'. Acceptable values: ${$8725bdeae134045e$var$AZURE_LOG_LEVELS.join(",")}`);
    $8725bdeae134045e$var$azureLogLevel = level;
    const enabledNamespaces = [];
    for (const logger of $8725bdeae134045e$var$registeredLoggers)if ($8725bdeae134045e$var$shouldEnable(logger)) enabledNamespaces.push(logger.namespace);
    (0, $1lRM4.default).enable(enabledNamespaces.join(","));
}
function $8725bdeae134045e$export$12dbaabc76fb091a() {
    return $8725bdeae134045e$var$azureLogLevel;
}
const $8725bdeae134045e$var$levelMap = {
    verbose: 400,
    info: 300,
    warning: 200,
    error: 100
};
function $8725bdeae134045e$export$6817aa89e2fe44fd(namespace) {
    const clientRootLogger = $8725bdeae134045e$export$e8fb5f2ce3b591d.extend(namespace);
    $8725bdeae134045e$var$patchLogMethod($8725bdeae134045e$export$e8fb5f2ce3b591d, clientRootLogger);
    return {
        error: $8725bdeae134045e$var$createLogger(clientRootLogger, "error"),
        warning: $8725bdeae134045e$var$createLogger(clientRootLogger, "warning"),
        info: $8725bdeae134045e$var$createLogger(clientRootLogger, "info"),
        verbose: $8725bdeae134045e$var$createLogger(clientRootLogger, "verbose")
    };
}
function $8725bdeae134045e$var$patchLogMethod(parent, child) {
    child.log = (...args)=>{
        parent.log(...args);
    };
}
function $8725bdeae134045e$var$createLogger(parent, level) {
    const logger = Object.assign(parent.extend(level), {
        level: level
    });
    $8725bdeae134045e$var$patchLogMethod(parent, logger);
    if ($8725bdeae134045e$var$shouldEnable(logger)) {
        const enabledNamespaces = (0, $1lRM4.default).disable();
        (0, $1lRM4.default).enable(enabledNamespaces + "," + logger.namespace);
    }
    $8725bdeae134045e$var$registeredLoggers.add(logger);
    return logger;
}
function $8725bdeae134045e$var$shouldEnable(logger) {
    return Boolean($8725bdeae134045e$var$azureLogLevel && $8725bdeae134045e$var$levelMap[logger.level] <= $8725bdeae134045e$var$levelMap[$8725bdeae134045e$var$azureLogLevel]);
}
function $8725bdeae134045e$var$isAzureLogLevel(logLevel) {
    return $8725bdeae134045e$var$AZURE_LOG_LEVELS.includes(logLevel);
}

});
parcelRegister("1lRM4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fc1770c87b638c0$export$2e2bcd8739ae039; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
parcelRequire("b1Nke");
var $g2iRg = parcelRequire("g2iRg");

var $lUPho = parcelRequire("lUPho");
const $0fc1770c87b638c0$var$debugEnvVariable = (typeof $lUPho !== "undefined" && $lUPho.env && undefined, undefined);
let $0fc1770c87b638c0$var$enabledString;
let $0fc1770c87b638c0$var$enabledNamespaces = [];
let $0fc1770c87b638c0$var$skippedNamespaces = [];
const $0fc1770c87b638c0$var$debuggers = [];
if ($0fc1770c87b638c0$var$debugEnvVariable) $0fc1770c87b638c0$var$enable($0fc1770c87b638c0$var$debugEnvVariable);
const $0fc1770c87b638c0$var$debugObj = Object.assign((namespace)=>{
    return $0fc1770c87b638c0$var$createDebugger(namespace);
}, {
    enable: $0fc1770c87b638c0$var$enable,
    enabled: $0fc1770c87b638c0$var$enabled,
    disable: $0fc1770c87b638c0$var$disable,
    log: $g2iRg.log
});
function $0fc1770c87b638c0$var$enable(namespaces) {
    $0fc1770c87b638c0$var$enabledString = namespaces;
    $0fc1770c87b638c0$var$enabledNamespaces = [];
    $0fc1770c87b638c0$var$skippedNamespaces = [];
    const wildcard = /\*/g;
    const namespaceList = namespaces.split(",").map((ns)=>ns.trim().replace(wildcard, ".*?"));
    for (const ns of namespaceList)if (ns.startsWith("-")) $0fc1770c87b638c0$var$skippedNamespaces.push(new RegExp(`^${ns.substr(1)}$`));
    else $0fc1770c87b638c0$var$enabledNamespaces.push(new RegExp(`^${ns}$`));
    for (const instance of $0fc1770c87b638c0$var$debuggers)instance.enabled = $0fc1770c87b638c0$var$enabled(instance.namespace);
}
function $0fc1770c87b638c0$var$enabled(namespace) {
    if (namespace.endsWith("*")) return true;
    for (const skipped of $0fc1770c87b638c0$var$skippedNamespaces){
        if (skipped.test(namespace)) return false;
    }
    for (const enabledNamespace of $0fc1770c87b638c0$var$enabledNamespaces){
        if (enabledNamespace.test(namespace)) return true;
    }
    return false;
}
function $0fc1770c87b638c0$var$disable() {
    const result = $0fc1770c87b638c0$var$enabledString || "";
    $0fc1770c87b638c0$var$enable("");
    return result;
}
function $0fc1770c87b638c0$var$createDebugger(namespace) {
    const newDebugger = Object.assign(debug, {
        enabled: $0fc1770c87b638c0$var$enabled(namespace),
        destroy: $0fc1770c87b638c0$var$destroy,
        log: $0fc1770c87b638c0$var$debugObj.log,
        namespace: namespace,
        extend: $0fc1770c87b638c0$var$extend
    });
    function debug(...args) {
        if (!newDebugger.enabled) return;
        if (args.length > 0) args[0] = `${namespace} ${args[0]}`;
        newDebugger.log(...args);
    }
    $0fc1770c87b638c0$var$debuggers.push(newDebugger);
    return newDebugger;
}
function $0fc1770c87b638c0$var$destroy() {
    const index = $0fc1770c87b638c0$var$debuggers.indexOf(this);
    if (index >= 0) {
        $0fc1770c87b638c0$var$debuggers.splice(index, 1);
        return true;
    }
    return false;
}
function $0fc1770c87b638c0$var$extend(namespace) {
    const newDebugger = $0fc1770c87b638c0$var$createDebugger(`${this.namespace}:${namespace}`);
    newDebugger.log = this.log;
    return newDebugger;
}
var $0fc1770c87b638c0$export$2e2bcd8739ae039 = $0fc1770c87b638c0$var$debugObj;

});
parcelRegister("b1Nke", function(module, exports) {

$parcel$export(module.exports, "log", function () { return (parcelRequire("g2iRg")).log; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $g2iRg = parcelRequire("g2iRg");

});
parcelRegister("g2iRg", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $bacb76166446ac60$export$bef1f36f5486a6a3; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
function $bacb76166446ac60$export$bef1f36f5486a6a3(...args) {
    if (args.length > 0) {
        const firstArg = String(args[0]);
        if (firstArg.includes(":error")) console.error(...args);
        else if (firstArg.includes(":warning")) console.warn(...args);
        else if (firstArg.includes(":info")) console.info(...args);
        else if (firstArg.includes(":verbose")) console.debug(...args);
        else console.debug(...args);
    }
}

});




parcelRegister("eTmRH", function(module, exports) {

$parcel$export(module.exports, "AzureCommunicationTokenCredential", function () { return (parcelRequire("6rUEX")).AzureCommunicationTokenCredential; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $6rUEX = parcelRequire("6rUEX");

var $lnkHB = parcelRequire("lnkHB");

var $jYWbT = parcelRequire("jYWbT");

var $eDFD7 = parcelRequire("eDFD7");
$parcel$exportWildcard(module.exports, $lnkHB);
$parcel$exportWildcard(module.exports, $jYWbT);
$parcel$exportWildcard(module.exports, $eDFD7);

});
parcelRegister("6rUEX", function(module, exports) {

$parcel$export(module.exports, "AzureCommunicationTokenCredential", function () { return $4b213720a7912d90$export$5940203451f1b30a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $4xItX = parcelRequire("4xItX");

var $clhYv = parcelRequire("clhYv");

var $1sZSg = parcelRequire("1sZSg");
class $4b213720a7912d90$export$5940203451f1b30a {
    /**
     * Gets an `AccessToken` for the user. Throws if already disposed.
     * @param abortSignal - An implementation of `AbortSignalLike` to cancel the operation.
     */ async getToken(options) {
        this.throwIfDisposed();
        const token = await this.tokenCredential.getToken(options);
        this.throwIfDisposed();
        return token;
    }
    /**
     * Disposes the CommunicationTokenCredential and cancels any internal auto-refresh operation.
     */ dispose() {
        this.disposed = true;
        this.tokenCredential.dispose();
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error("User credential is disposed");
    }
    constructor(tokenOrRefreshOptions){
        this.disposed = false;
        if (typeof tokenOrRefreshOptions === "string") this.tokenCredential = new (0, $clhYv.StaticTokenCredential)((0, $1sZSg.parseToken)(tokenOrRefreshOptions));
        else this.tokenCredential = new (0, $4xItX.AutoRefreshTokenCredential)(tokenOrRefreshOptions);
    }
}

});
parcelRegister("4xItX", function(module, exports) {

$parcel$export(module.exports, "AutoRefreshTokenCredential", function () { return $34ecbfb57f72bb94$export$7313fe50010a7ef8; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $1sZSg = parcelRequire("1sZSg");
const $34ecbfb57f72bb94$var$expiredToken = {
    token: "",
    expiresOnTimestamp: -10
};
const $34ecbfb57f72bb94$var$minutesToMs = (minutes)=>minutes * 60000;
const $34ecbfb57f72bb94$var$defaultExpiringSoonInterval = $34ecbfb57f72bb94$var$minutesToMs(10);
const $34ecbfb57f72bb94$var$defaultRefreshAfterLifetimePercentage = 0.5;
class $34ecbfb57f72bb94$export$7313fe50010a7ef8 {
    async getToken(options) {
        if (!this.isTokenExpiringSoon(this.currentToken)) return this.currentToken;
        if (!this.isTokenValid(this.currentToken)) {
            const updatePromise = this.updateTokenAndReschedule(options === null || options === void 0 ? void 0 : options.abortSignal);
            await updatePromise;
        }
        return this.currentToken;
    }
    dispose() {
        this.disposed = true;
        this.activeTokenFetching = null;
        this.activeTokenUpdating = null;
        this.currentToken = $34ecbfb57f72bb94$var$expiredToken;
        if (this.activeTimeout) clearTimeout(this.activeTimeout);
    }
    async updateTokenAndReschedule(abortSignal) {
        if (this.activeTokenUpdating) return this.activeTokenUpdating;
        this.activeTokenUpdating = this.refreshTokenAndReschedule(abortSignal);
        try {
            await this.activeTokenUpdating;
        } finally{
            this.activeTokenUpdating = null;
        }
    }
    async refreshTokenAndReschedule(abortSignal) {
        const newToken = await this.refreshToken(abortSignal);
        if (!this.isTokenValid(newToken)) throw new Error("The token returned from the tokenRefresher is expired.");
        this.currentToken = newToken;
        if (this.refreshProactively) this.scheduleRefresh();
    }
    async refreshToken(abortSignal) {
        try {
            if (!this.activeTokenFetching) this.activeTokenFetching = this.refresh(abortSignal);
            return (0, $1sZSg.parseToken)(await this.activeTokenFetching);
        } finally{
            this.activeTokenFetching = null;
        }
    }
    scheduleRefresh() {
        if (this.disposed) return;
        if (this.activeTimeout) clearTimeout(this.activeTimeout);
        const tokenTtlInMs = this.currentToken.expiresOnTimestamp - Date.now();
        let timespanInMs = null;
        if (this.isTokenExpiringSoon(this.currentToken)) // Schedule the next refresh for when it reaches a certain percentage of the remaining lifetime.
        timespanInMs = tokenTtlInMs * this.refreshAfterLifetimePercentage;
        else // Schedule the next refresh for when it gets in to the soon-to-expire window.
        timespanInMs = tokenTtlInMs - this.expiringSoonIntervalInMs;
        this.activeTimeout = setTimeout(()=>this.updateTokenAndReschedule(), timespanInMs);
    }
    isTokenValid(token) {
        return token && Date.now() < token.expiresOnTimestamp;
    }
    isTokenExpiringSoon(token) {
        return !token || Date.now() >= token.expiresOnTimestamp - this.expiringSoonIntervalInMs;
    }
    constructor(refreshArgs){
        this.expiringSoonIntervalInMs = $34ecbfb57f72bb94$var$defaultExpiringSoonInterval;
        this.refreshAfterLifetimePercentage = $34ecbfb57f72bb94$var$defaultRefreshAfterLifetimePercentage;
        this.activeTokenFetching = null;
        this.activeTokenUpdating = null;
        this.disposed = false;
        const { tokenRefresher: tokenRefresher, token: token, refreshProactively: refreshProactively } = refreshArgs;
        this.refresh = tokenRefresher;
        this.currentToken = token ? (0, $1sZSg.parseToken)(token) : $34ecbfb57f72bb94$var$expiredToken;
        this.refreshProactively = refreshProactively !== null && refreshProactively !== void 0 ? refreshProactively : false;
        if (this.refreshProactively) this.scheduleRefresh();
    }
}

});
parcelRegister("1sZSg", function(module, exports) {

$parcel$export(module.exports, "parseToken", function () { return $111866e0fdbcbda5$export$af8f4e8328578827; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $bPejo = parcelRequire("bPejo");
const $111866e0fdbcbda5$export$af8f4e8328578827 = (token)=>{
    const { exp: exp } = (0, $bPejo.jwtDecode)(token);
    return {
        token: token,
        expiresOnTimestamp: exp * 1000
    };
};

});
parcelRegister("bPejo", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", function () { return $89bf8f25fafe086a$export$fa1e2fb699b7861e; });
class $89bf8f25fafe086a$export$b9721ef022f71a68 extends Error {
}
$89bf8f25fafe086a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $89bf8f25fafe086a$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $89bf8f25fafe086a$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $89bf8f25fafe086a$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $89bf8f25fafe086a$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $89bf8f25fafe086a$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $89bf8f25fafe086a$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $89bf8f25fafe086a$var$base64UrlDecode(part);
    } catch (e) {
        throw new $89bf8f25fafe086a$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $89bf8f25fafe086a$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});



parcelRegister("clhYv", function(module, exports) {

$parcel$export(module.exports, "StaticTokenCredential", function () { return $8fc563a19668bc0a$export$f6e1a0230c35b6a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * StaticTokenCredential
 */ class $8fc563a19668bc0a$export$f6e1a0230c35b6a {
    async getToken() {
        return this.token;
    }
    dispose() {
    /* intentionally empty */ }
    constructor(token){
        this.token = token;
    }
}

});


parcelRegister("lnkHB", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $aOpio = parcelRequire("aOpio");

var $cyDIb = parcelRequire("cyDIb");

var $iq7xE = parcelRequire("iq7xE");

var $cyqTy = parcelRequire("cyqTy");
$parcel$exportWildcard(module.exports, $aOpio);
$parcel$exportWildcard(module.exports, $cyDIb);
$parcel$exportWildcard(module.exports, $iq7xE);
$parcel$exportWildcard(module.exports, $cyqTy);

});
parcelRegister("aOpio", function(module, exports) {

$parcel$export(module.exports, "createCommunicationAccessKeyCredentialPolicy", function () { return $7df23214a479ccaf$export$f9dc17af907f7d36; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $bLbkQ = parcelRequire("bLbkQ");
parcelRequire("bE3zB");
var $gtuTr = parcelRequire("gtuTr");
/**
 * CommunicationKeyCredentialPolicy provides a means of signing requests made through
 * the SmsClient.
 */ const $7df23214a479ccaf$var$communicationAccessKeyCredentialPolicy = "CommunicationAccessKeyCredentialPolicy";
function $7df23214a479ccaf$export$f9dc17af907f7d36(credential) {
    return {
        name: $7df23214a479ccaf$var$communicationAccessKeyCredentialPolicy,
        async sendRequest (request, next) {
            var _a;
            const verb = request.method.toUpperCase();
            const utcNow = new Date().toUTCString();
            const contentHash = await (0, $bLbkQ.shaHash)(((_a = request.body) === null || _a === void 0 ? void 0 : _a.toString()) || "");
            const dateHeader = "x-ms-date";
            const signedHeaders = `${dateHeader};host;x-ms-content-sha256`;
            const url = new URL(request.url);
            const query = url.searchParams.toString();
            const urlPathAndQuery = query ? `${url.pathname}?${query}` : url.pathname;
            const port = url.port;
            const hostAndPort = port ? `${url.host}:${port}` : url.host;
            const stringToSign = `${verb}\n${urlPathAndQuery}\n${utcNow};${hostAndPort};${contentHash}`;
            const signature = await (0, $bLbkQ.shaHMAC)(credential.key, stringToSign);
            if (0, $gtuTr.isNode) request.headers.set("Host", hostAndPort || "");
            request.headers.set(dateHeader, utcNow);
            request.headers.set("x-ms-content-sha256", contentHash);
            request.headers.set("Authorization", `HMAC-SHA256 SignedHeaders=${signedHeaders}&Signature=${signature}`);
            return next(request);
        }
    };
}

});
parcelRegister("bLbkQ", function(module, exports) {

$parcel$export(module.exports, "shaHash", function () { return $88fce06cd31902a1$export$ffda21838eb8645; });
$parcel$export(module.exports, "shaHMAC", function () { return $88fce06cd31902a1$export$6b15539996a79bda; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $ane2C = parcelRequire("ane2C");
var $88fce06cd31902a1$var$_a;
const $88fce06cd31902a1$var$subtle = ($88fce06cd31902a1$var$_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || $88fce06cd31902a1$var$_a === void 0 ? void 0 : $88fce06cd31902a1$var$_a.subtle;
const $88fce06cd31902a1$export$ffda21838eb8645 = async (content)=>{
    const data = (0, $ane2C.encodeUTF8)(content);
    const hash = await $88fce06cd31902a1$var$subtle.digest("SHA-256", data);
    return (0, $ane2C.encodeBase64)(hash);
};
const $88fce06cd31902a1$export$6b15539996a79bda = async (secret, content)=>{
    const importParams = {
        name: "HMAC",
        hash: {
            name: "SHA-256"
        }
    };
    const encodedMessage = (0, $ane2C.encodeUTF8)(content);
    const encodedKey = (0, $ane2C.encodeUTF8fromBase64)(secret);
    const crypto = $88fce06cd31902a1$var$subtle;
    const cryptoKey = await crypto.importKey("raw", encodedKey, importParams, false, [
        "sign"
    ]);
    const signature = await crypto.sign(importParams, cryptoKey, encodedMessage);
    return (0, $ane2C.encodeBase64)(signature);
};

});
parcelRegister("ane2C", function(module, exports) {

$parcel$export(module.exports, "encodeUTF8", function () { return $78d6f1aa1cf3050b$export$fcabffea81927cf1; });
$parcel$export(module.exports, "encodeUTF8fromBase64", function () { return $78d6f1aa1cf3050b$export$19f0657e4a1fed42; });
$parcel$export(module.exports, "encodeBase64", function () { return $78d6f1aa1cf3050b$export$8fb536984ec8b4d7; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const $78d6f1aa1cf3050b$export$fcabffea81927cf1 = (str)=>new TextEncoder().encode(str);
function $78d6f1aa1cf3050b$export$19f0657e4a1fed42(str) {
    if (typeof atob !== "function") throw new Error("Your browser environment is missing the global `atob` function");
    const binary = atob(str);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
}
function $78d6f1aa1cf3050b$export$8fb536984ec8b4d7(value) {
    if (typeof btoa !== "function") throw new Error("Your browser environment is missing the global `btoa` function");
    const bytes = new Uint8Array(value);
    let binary = "";
    for (const byte of bytes)binary += String.fromCharCode(byte);
    return btoa(binary);
}

});


parcelRegister("bE3zB", function(module, exports) {

$parcel$export(module.exports, "calculateRetryDelay", function () { return (parcelRequire("9Ubx8")).calculateRetryDelay; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("1sZvc")).isObject; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("clFsF")).isError; });
$parcel$export(module.exports, "getErrorMessage", function () { return (parcelRequire("clFsF")).getErrorMessage; });
$parcel$export(module.exports, "isObjectWithProperties", function () { return (parcelRequire("64Qq6")).isObjectWithProperties; });
$parcel$export(module.exports, "randomUUID", function () { return (parcelRequire("hlqzV")).randomUUID; });
$parcel$export(module.exports, "isNode", function () { return (parcelRequire("gtuTr")).isNode; });
$parcel$export(module.exports, "isNodeLike", function () { return (parcelRequire("gtuTr")).isNodeLike; });
$parcel$export(module.exports, "stringToUint8Array", function () { return (parcelRequire("FIiXD")).stringToUint8Array; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $9Ubx8 = parcelRequire("9Ubx8");

var $m8TDg = parcelRequire("m8TDg");

var $8oAM5 = parcelRequire("8oAM5");

var $g2tUH = parcelRequire("g2tUH");

var $1sZvc = parcelRequire("1sZvc");

var $clFsF = parcelRequire("clFsF");
parcelRequire("6HoBu");
var $5l0sc = parcelRequire("5l0sc");

var $64Qq6 = parcelRequire("64Qq6");

var $hlqzV = parcelRequire("hlqzV");

var $gtuTr = parcelRequire("gtuTr");
parcelRequire("gKqZb");
var $FIiXD = parcelRequire("FIiXD");

});
parcelRegister("9Ubx8", function(module, exports) {

$parcel$export(module.exports, "calculateRetryDelay", function () { return $73624a4dccfe6a28$export$8f49adf3b8bd0a57; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $8oAM5 = parcelRequire("8oAM5");

var $g2tUH = parcelRequire("g2tUH");
const $73624a4dccfe6a28$var$StandardAbortMessage = "The delay was aborted.";
function $73624a4dccfe6a28$export$1391212d75b2ee65(timeInMs, options) {
    let token;
    const { abortSignal: abortSignal, abortErrorMsg: abortErrorMsg } = options !== null && options !== void 0 ? options : {};
    return (0, $8oAM5.createAbortablePromise)((resolve)=>{
        token = setTimeout(resolve, timeInMs);
    }, {
        cleanupBeforeAbort: ()=>clearTimeout(token),
        abortSignal: abortSignal,
        abortErrorMsg: abortErrorMsg !== null && abortErrorMsg !== void 0 ? abortErrorMsg : $73624a4dccfe6a28$var$StandardAbortMessage
    });
}
function $73624a4dccfe6a28$export$8f49adf3b8bd0a57(retryAttempt, config) {
    // Exponentially increase the delay each time
    const exponentialDelay = config.retryDelayInMs * Math.pow(2, retryAttempt);
    // Don't let the delay exceed the maximum
    const clampedDelay = Math.min(config.maxRetryDelayInMs, exponentialDelay);
    // Allow the final value to have some "jitter" (within 50% of the delay size) so
    // that retries across multiple clients don't occur simultaneously.
    const retryAfterInMs = clampedDelay / 2 + (0, $g2tUH.getRandomIntegerInclusive)(0, clampedDelay / 2);
    return {
        retryAfterInMs: retryAfterInMs
    };
}

});
parcelRegister("8oAM5", function(module, exports) {

$parcel$export(module.exports, "createAbortablePromise", function () { return $61cd1750297278c8$export$53e76b8cf0bad4c1; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("67uCy");
var $k0hjZ = parcelRequire("k0hjZ");
function $61cd1750297278c8$export$53e76b8cf0bad4c1(buildPromise, options) {
    const { cleanupBeforeAbort: cleanupBeforeAbort, abortSignal: abortSignal, abortErrorMsg: abortErrorMsg } = options !== null && options !== void 0 ? options : {};
    return new Promise((resolve, reject)=>{
        function rejectOnAbort() {
            reject(new (0, $k0hjZ.AbortError)(abortErrorMsg !== null && abortErrorMsg !== void 0 ? abortErrorMsg : "The operation was aborted."));
        }
        function removeListeners() {
            abortSignal === null || abortSignal === void 0 || abortSignal.removeEventListener("abort", onAbort);
        }
        function onAbort() {
            cleanupBeforeAbort === null || cleanupBeforeAbort === void 0 || cleanupBeforeAbort();
            removeListeners();
            rejectOnAbort();
        }
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) return rejectOnAbort();
        try {
            buildPromise((x)=>{
                removeListeners();
                resolve(x);
            }, (x)=>{
                removeListeners();
                reject(x);
            });
        } catch (err) {
            reject(err);
        }
        abortSignal === null || abortSignal === void 0 || abortSignal.addEventListener("abort", onAbort);
    });
}

});
parcelRegister("67uCy", function(module, exports) {

$parcel$export(module.exports, "AbortError", function () { return (parcelRequire("k0hjZ")).AbortError; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $k0hjZ = parcelRequire("k0hjZ");

});
parcelRegister("k0hjZ", function(module, exports) {

$parcel$export(module.exports, "AbortError", function () { return $03c215a6ea85a813$export$18b052ffd8c84d7; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * This error is thrown when an asynchronous operation has been aborted.
 * Check for this error by testing the `name` that the name property of the
 * error matches `"AbortError"`.
 *
 * @example
 * ```ts
 * const controller = new AbortController();
 * controller.abort();
 * try {
 *   doAsyncWork(controller.signal)
 * } catch (e) {
 *   if (e.name === 'AbortError') {
 *     // handle abort error here.
 *   }
 * }
 * ```
 */ class $03c215a6ea85a813$export$18b052ffd8c84d7 extends Error {
    constructor(message){
        super(message);
        this.name = "AbortError";
    }
}

});



parcelRegister("g2tUH", function(module, exports) {

$parcel$export(module.exports, "getRandomIntegerInclusive", function () { return $bad4096e5da88148$export$d35777cbac4821b; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Returns a random integer value between a lower and upper bound,
 * inclusive of both bounds.
 * Note that this uses Math.random and isn't secure. If you need to use
 * this for any kind of security purpose, find a better source of random.
 * @param min - The smallest integer value allowed.
 * @param max - The largest integer value allowed.
 */ function $bad4096e5da88148$export$d35777cbac4821b(min, max) {
    // Make sure inputs are integers.
    min = Math.ceil(min);
    max = Math.floor(max);
    // Pick a random offset from zero to the size of the range.
    // Since Math.random() can never return 1, we have to make the range one larger
    // in order to be inclusive of the maximum value after we take the floor.
    const offset = Math.floor(Math.random() * (max - min + 1));
    return offset + min;
}

});


parcelRegister("m8TDg", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * promise.race() wrapper that aborts rest of promises as soon as the first promise settles.
 */ async function $0428f4ceb41675ee$export$43b8f4db166dd96(abortablePromiseBuilders, options) {
    var _a, _b;
    const aborter = new AbortController();
    function abortHandler() {
        aborter.abort();
    }
    (_a = options === null || options === void 0 ? void 0 : options.abortSignal) === null || _a === void 0 || _a.addEventListener("abort", abortHandler);
    try {
        return await Promise.race(abortablePromiseBuilders.map((p)=>p({
                abortSignal: aborter.signal
            })));
    } finally{
        aborter.abort();
        (_b = options === null || options === void 0 ? void 0 : options.abortSignal) === null || _b === void 0 || _b.removeEventListener("abort", abortHandler);
    }
}

});

parcelRegister("1sZvc", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $11181d094ada78dd$export$a6cdc56e425d0d0a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Helper to determine when an input is a generic JS object.
 * @returns true when input is an object type that is not null, Array, RegExp, or Date.
 */ function $11181d094ada78dd$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object" && input !== null && !Array.isArray(input) && !(input instanceof RegExp) && !(input instanceof Date);
}

});

parcelRegister("clFsF", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $8fd79b9418f4bf84$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "getErrorMessage", function () { return $8fd79b9418f4bf84$export$82f46aa4e6535a45; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $1sZvc = parcelRequire("1sZvc");
function $8fd79b9418f4bf84$export$e6127cc7fe7395c3(e) {
    if ((0, $1sZvc.isObject)(e)) {
        const hasName = typeof e.name === "string";
        const hasMessage = typeof e.message === "string";
        return hasName && hasMessage;
    }
    return false;
}
function $8fd79b9418f4bf84$export$82f46aa4e6535a45(e) {
    if ($8fd79b9418f4bf84$export$e6127cc7fe7395c3(e)) return e.message;
    else {
        let stringified;
        try {
            if (typeof e === "object" && e) stringified = JSON.stringify(e);
            else stringified = String(e);
        } catch (err) {
            stringified = "[unable to stringify input]";
        }
        return `Unknown error ${stringified}`;
    }
}

});

parcelRegister("6HoBu", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("5l0sc");

});
parcelRegister("5l0sc", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("gKqZb");
var $FIiXD = parcelRequire("FIiXD");
let $0100c3295f46aaa7$var$subtleCrypto;
/**
 * Returns a cached reference to the Web API crypto.subtle object.
 * @internal
 */ function $0100c3295f46aaa7$var$getCrypto() {
    if ($0100c3295f46aaa7$var$subtleCrypto) return $0100c3295f46aaa7$var$subtleCrypto;
    if (!self.crypto || !self.crypto.subtle) throw new Error("Your browser environment does not support cryptography functions.");
    $0100c3295f46aaa7$var$subtleCrypto = self.crypto.subtle;
    return $0100c3295f46aaa7$var$subtleCrypto;
}
async function $0100c3295f46aaa7$export$abf7af97e0119290(key, stringToSign, encoding) {
    const crypto = $0100c3295f46aaa7$var$getCrypto();
    const keyBytes = (0, $FIiXD.stringToUint8Array)(key, "base64");
    const stringToSignBytes = (0, $FIiXD.stringToUint8Array)(stringToSign, "utf-8");
    const cryptoKey = await crypto.importKey("raw", keyBytes, {
        name: "HMAC",
        hash: {
            name: "SHA-256"
        }
    }, false, [
        "sign"
    ]);
    const signature = await crypto.sign({
        name: "HMAC",
        hash: {
            name: "SHA-256"
        }
    }, cryptoKey, stringToSignBytes);
    return (0, $FIiXD.uint8ArrayToString)(new Uint8Array(signature), encoding);
}
async function $0100c3295f46aaa7$export$21b3334e594a00dc(content, encoding) {
    const contentBytes = (0, $FIiXD.stringToUint8Array)(content, "utf-8");
    const digest = await $0100c3295f46aaa7$var$getCrypto().digest({
        name: "SHA-256"
    }, contentBytes);
    return (0, $FIiXD.uint8ArrayToString)(new Uint8Array(digest), encoding);
}

});
parcelRegister("gKqZb", function(module, exports) {
$parcel$export(module.exports, "stringToUint8Array", function () { return (parcelRequire("FIiXD")).stringToUint8Array; });
$parcel$export(module.exports, "uint8ArrayToString", function () { return (parcelRequire("FIiXD")).uint8ArrayToString; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("FIiXD");

});
parcelRegister("FIiXD", function(module, exports) {

$parcel$export(module.exports, "uint8ArrayToString", function () { return $07d63276d09e75ba$export$f3924c82a04770ee; });
$parcel$export(module.exports, "stringToUint8Array", function () { return $07d63276d09e75ba$export$a098e7b533f96db3; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * The helper that transforms bytes with specific character encoding into string
 * @param bytes - the uint8array bytes
 * @param format - the format we use to encode the byte
 * @returns a string of the encoded string
 */ function $07d63276d09e75ba$export$f3924c82a04770ee(bytes, format) {
    switch(format){
        case "utf-8":
            return $07d63276d09e75ba$export$3807c75897ecb40c(bytes);
        case "base64":
            return $07d63276d09e75ba$export$36bac84b1c2da9c7(bytes);
        case "base64url":
            return $07d63276d09e75ba$export$cfdb27877af538fc(bytes);
        case "hex":
            return $07d63276d09e75ba$export$d4d5806f7c45a793(bytes);
    }
}
function $07d63276d09e75ba$export$a098e7b533f96db3(value, format) {
    switch(format){
        case "utf-8":
            return $07d63276d09e75ba$export$1b311cdb1847a34(value);
        case "base64":
            return $07d63276d09e75ba$export$f01069a3c307e50e(value);
        case "base64url":
            return $07d63276d09e75ba$export$9cae2cd6076b8fb6(value);
        case "hex":
            return $07d63276d09e75ba$export$e0b70b88274897fe(value);
    }
}
function $07d63276d09e75ba$export$36bac84b1c2da9c7(bytes) {
    return btoa([
        ...bytes
    ].map((x)=>String.fromCharCode(x)).join(""));
}
function $07d63276d09e75ba$export$cfdb27877af538fc(bytes) {
    return $07d63276d09e75ba$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $07d63276d09e75ba$export$3807c75897ecb40c(bytes) {
    const decoder = new TextDecoder();
    const dataString = decoder.decode(bytes);
    return dataString;
}
function $07d63276d09e75ba$export$d4d5806f7c45a793(bytes) {
    return [
        ...bytes
    ].map((x)=>x.toString(16).padStart(2, "0")).join("");
}
function $07d63276d09e75ba$export$1b311cdb1847a34(value) {
    return new TextEncoder().encode(value);
}
function $07d63276d09e75ba$export$f01069a3c307e50e(value) {
    return new Uint8Array([
        ...atob(value)
    ].map((x)=>x.charCodeAt(0)));
}
function $07d63276d09e75ba$export$9cae2cd6076b8fb6(value) {
    const base64String = value.replace(/-/g, "+").replace(/_/g, "/");
    return $07d63276d09e75ba$export$f01069a3c307e50e(base64String);
}
const $07d63276d09e75ba$var$hexDigits = new Set("0123456789abcdefABCDEF");
function $07d63276d09e75ba$export$e0b70b88274897fe(value) {
    // If value has odd length, the last character will be ignored, consistent with NodeJS Buffer behavior
    const bytes = new Uint8Array(value.length / 2);
    for(let i = 0; i < value.length / 2; ++i){
        const highNibble = value[2 * i];
        const lowNibble = value[2 * i + 1];
        if (!$07d63276d09e75ba$var$hexDigits.has(highNibble) || !$07d63276d09e75ba$var$hexDigits.has(lowNibble)) // Replicate Node Buffer behavior by exiting early when we encounter an invalid byte
        return bytes.slice(0, i);
        bytes[i] = parseInt(`${highNibble}${lowNibble}`, 16);
    }
    return bytes;
}

});




parcelRegister("64Qq6", function(module, exports) {

$parcel$export(module.exports, "isObjectWithProperties", function () { return $46cbc7589ec7960f$export$44aa3a8a1abdb9b6; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Helper TypeGuard that checks if something is defined or not.
 * @param thing - Anything
 */ function $46cbc7589ec7960f$export$4e62c701997796c1(thing) {
    return typeof thing !== "undefined" && thing !== null;
}
function $46cbc7589ec7960f$export$44aa3a8a1abdb9b6(thing, properties) {
    if (!$46cbc7589ec7960f$export$4e62c701997796c1(thing) || typeof thing !== "object") return false;
    for (const property of properties){
        if (!$46cbc7589ec7960f$export$48d753fb7585d4bb(thing, property)) return false;
    }
    return true;
}
function $46cbc7589ec7960f$export$48d753fb7585d4bb(thing, property) {
    return $46cbc7589ec7960f$export$4e62c701997796c1(thing) && typeof thing === "object" && property in thing;
}

});

parcelRegister("hlqzV", function(module, exports) {

$parcel$export(module.exports, "randomUUID", function () { return $ca0903c1fb396db5$export$f15387b9ab8915bf; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $k6Tjs = parcelRequire("k6Tjs");
var $ca0903c1fb396db5$var$_a;
// NOTE: This could be undefined if not used in a secure context
const $ca0903c1fb396db5$var$uuidFunction = typeof (($ca0903c1fb396db5$var$_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.crypto) === null || $ca0903c1fb396db5$var$_a === void 0 ? void 0 : $ca0903c1fb396db5$var$_a.randomUUID) === "function" ? globalThis.crypto.randomUUID.bind(globalThis.crypto) : (0, $k6Tjs.generateUUID);
function $ca0903c1fb396db5$export$f15387b9ab8915bf() {
    return $ca0903c1fb396db5$var$uuidFunction();
}

});
parcelRegister("k6Tjs", function(module, exports) {

$parcel$export(module.exports, "generateUUID", function () { return $ea3f4627b23e720e$export$e73c8bd0f20705a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Generated Universally Unique Identifier
 *
 * @returns RFC4122 v4 UUID.
 */ function $ea3f4627b23e720e$export$e73c8bd0f20705a() {
    let uuid = "";
    for(let i = 0; i < 32; i++){
        // Generate a random number between 0 and 15
        const randomNumber = Math.floor(Math.random() * 16);
        // Set the UUID version to 4 in the 13th position
        if (i === 12) uuid += "4";
        else if (i === 16) // Set the UUID variant to "10" in the 17th position
        uuid += randomNumber & 0x3 | 0x8;
        else // Add a random hexadecimal digit to the UUID string
        uuid += randomNumber.toString(16);
        // Add hyphens to the UUID string at the appropriate positions
        if (i === 7 || i === 11 || i === 15 || i === 19) uuid += "-";
    }
    return uuid;
}
function $ea3f4627b23e720e$export$f15387b9ab8915bf() {
    return $ea3f4627b23e720e$export$e73c8bd0f20705a();
}

});


parcelRegister("gtuTr", function(module, exports) {

$parcel$export(module.exports, "isNodeLike", function () { return $bfe751842f31d605$export$bb3e3c6770ba97a2; });
$parcel$export(module.exports, "isNode", function () { return $bfe751842f31d605$export$8ee0fc9ee280b4ee; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
var $bfe751842f31d605$var$_a, $bfe751842f31d605$var$_b, $bfe751842f31d605$var$_c, $bfe751842f31d605$var$_d;
const $bfe751842f31d605$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined";
const $bfe751842f31d605$export$97b87b8868ff7a3c = typeof self === "object" && typeof (self === null || self === void 0 ? void 0 : self.importScripts) === "function" && ((($bfe751842f31d605$var$_a = self.constructor) === null || $bfe751842f31d605$var$_a === void 0 ? void 0 : $bfe751842f31d605$var$_a.name) === "DedicatedWorkerGlobalScope" || (($bfe751842f31d605$var$_b = self.constructor) === null || $bfe751842f31d605$var$_b === void 0 ? void 0 : $bfe751842f31d605$var$_b.name) === "ServiceWorkerGlobalScope" || (($bfe751842f31d605$var$_c = self.constructor) === null || $bfe751842f31d605$var$_c === void 0 ? void 0 : $bfe751842f31d605$var$_c.name) === "SharedWorkerGlobalScope");
const $bfe751842f31d605$export$8b9ca1d592a8e4c6 = typeof Deno !== "undefined" && typeof Deno.version !== "undefined" && typeof Deno.version.deno !== "undefined";
const $bfe751842f31d605$export$2b1fb834b82e1884 = typeof Bun !== "undefined" && typeof Bun.version !== "undefined";
const $bfe751842f31d605$export$bb3e3c6770ba97a2 = typeof globalThis.process !== "undefined" && Boolean(globalThis.process.version) && Boolean(($bfe751842f31d605$var$_d = globalThis.process.versions) === null || $bfe751842f31d605$var$_d === void 0 ? void 0 : $bfe751842f31d605$var$_d.node);
const $bfe751842f31d605$export$8ee0fc9ee280b4ee = $bfe751842f31d605$export$bb3e3c6770ba97a2;
const $bfe751842f31d605$export$2143c86cd782d436 = $bfe751842f31d605$export$bb3e3c6770ba97a2 && !$bfe751842f31d605$export$2b1fb834b82e1884 && !$bfe751842f31d605$export$8b9ca1d592a8e4c6;
const $bfe751842f31d605$export$f7a1e23e542d38e3 = typeof navigator !== "undefined" && (navigator === null || navigator === void 0 ? void 0 : navigator.product) === "ReactNative";

});



parcelRegister("cyDIb", function(module, exports) {

$parcel$export(module.exports, "createCommunicationAuthPolicy", function () { return $924776f0451f1e89$export$2abca855e13c835e; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
parcelRequire("2nom1");
var $hm3aq = parcelRequire("hm3aq");
parcelRequire("lcjrn");
var $8oaPc = parcelRequire("8oaPc");

var $aOpio = parcelRequire("aOpio");
function $924776f0451f1e89$export$2abca855e13c835e(credential) {
    if ((0, $8oaPc.isTokenCredential)(credential)) {
        const policyOptions = {
            credential: credential,
            scopes: [
                "https://communication.azure.com//.default"
            ]
        };
        return (0, $hm3aq.bearerTokenAuthenticationPolicy)(policyOptions);
    } else return (0, $aOpio.createCommunicationAccessKeyCredentialPolicy)(credential);
}

});
parcelRegister("2nom1", function(module, exports) {

$parcel$export(module.exports, "bearerTokenAuthenticationPolicy", function () { return (parcelRequire("hm3aq")).bearerTokenAuthenticationPolicy; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $031Y6 = parcelRequire("031Y6");

var $9kpjT = parcelRequire("9kpjT");

var $2Xcv2 = parcelRequire("2Xcv2");

var $dTHTy = parcelRequire("dTHTy");

var $kp5rE = parcelRequire("kp5rE");

var $hWNsE = parcelRequire("hWNsE");

var $5cAex = parcelRequire("5cAex");

var $6dZRZ = parcelRequire("6dZRZ");

var $1solD = parcelRequire("1solD");

var $9ByDs = parcelRequire("9ByDs");

var $kbnkW = parcelRequire("kbnkW");
parcelRequire("Pm1ym");
var $6yXud = parcelRequire("6yXud");

var $hME2D = parcelRequire("hME2D");

var $bbWo5 = parcelRequire("bbWo5");

var $e5urd = parcelRequire("e5urd");

var $icUco = parcelRequire("icUco");

var $kBVEb = parcelRequire("kBVEb");

var $eS5vG = parcelRequire("eS5vG");

var $gyjf0 = parcelRequire("gyjf0");

var $9NSNm = parcelRequire("9NSNm");

var $afsMq = parcelRequire("afsMq");

var $hm3aq = parcelRequire("hm3aq");

var $3Ie3S = parcelRequire("3Ie3S");

var $cBfCi = parcelRequire("cBfCi");

var $hT8Vt = parcelRequire("hT8Vt");

});
parcelRegister("031Y6", function(module, exports) {

$parcel$export(module.exports, "createEmptyPipeline", function () { return $0091ced366a43134$export$d1727d948a2aa6e7; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const $0091ced366a43134$var$ValidPhaseNames = new Set([
    "Deserialize",
    "Serialize",
    "Retry",
    "Sign"
]);
/**
 * A private implementation of Pipeline.
 * Do not export this class from the package.
 * @internal
 */ class $0091ced366a43134$var$HttpPipeline {
    addPolicy(policy, options = {}) {
        if (options.phase && options.afterPhase) throw new Error("Policies inside a phase cannot specify afterPhase.");
        if (options.phase && !$0091ced366a43134$var$ValidPhaseNames.has(options.phase)) throw new Error(`Invalid phase name: ${options.phase}`);
        if (options.afterPhase && !$0091ced366a43134$var$ValidPhaseNames.has(options.afterPhase)) throw new Error(`Invalid afterPhase name: ${options.afterPhase}`);
        this._policies.push({
            policy: policy,
            options: options
        });
        this._orderedPolicies = undefined;
    }
    removePolicy(options) {
        const removedPolicies = [];
        this._policies = this._policies.filter((policyDescriptor)=>{
            if (options.name && policyDescriptor.policy.name === options.name || options.phase && policyDescriptor.options.phase === options.phase) {
                removedPolicies.push(policyDescriptor.policy);
                return false;
            } else return true;
        });
        this._orderedPolicies = undefined;
        return removedPolicies;
    }
    sendRequest(httpClient, request) {
        const policies = this.getOrderedPolicies();
        const pipeline = policies.reduceRight((next, policy)=>{
            return (req)=>{
                return policy.sendRequest(req, next);
            };
        }, (req)=>httpClient.sendRequest(req));
        return pipeline(request);
    }
    getOrderedPolicies() {
        if (!this._orderedPolicies) this._orderedPolicies = this.orderPolicies();
        return this._orderedPolicies;
    }
    clone() {
        return new $0091ced366a43134$var$HttpPipeline(this._policies);
    }
    static create() {
        return new $0091ced366a43134$var$HttpPipeline();
    }
    orderPolicies() {
        /**
         * The goal of this method is to reliably order pipeline policies
         * based on their declared requirements when they were added.
         *
         * Order is first determined by phase:
         *
         * 1. Serialize Phase
         * 2. Policies not in a phase
         * 3. Deserialize Phase
         * 4. Retry Phase
         * 5. Sign Phase
         *
         * Within each phase, policies are executed in the order
         * they were added unless they were specified to execute
         * before/after other policies or after a particular phase.
         *
         * To determine the final order, we will walk the policy list
         * in phase order multiple times until all dependencies are
         * satisfied.
         *
         * `afterPolicies` are the set of policies that must be
         * executed before a given policy. This requirement is
         * considered satisfied when each of the listed policies
         * have been scheduled.
         *
         * `beforePolicies` are the set of policies that must be
         * executed after a given policy. Since this dependency
         * can be expressed by converting it into a equivalent
         * `afterPolicies` declarations, they are normalized
         * into that form for simplicity.
         *
         * An `afterPhase` dependency is considered satisfied when all
         * policies in that phase have scheduled.
         *
         */ const result = [];
        // Track all policies we know about.
        const policyMap = new Map();
        function createPhase(name) {
            return {
                name: name,
                policies: new Set(),
                hasRun: false,
                hasAfterPolicies: false
            };
        }
        // Track policies for each phase.
        const serializePhase = createPhase("Serialize");
        const noPhase = createPhase("None");
        const deserializePhase = createPhase("Deserialize");
        const retryPhase = createPhase("Retry");
        const signPhase = createPhase("Sign");
        // a list of phases in order
        const orderedPhases = [
            serializePhase,
            noPhase,
            deserializePhase,
            retryPhase,
            signPhase
        ];
        // Small helper function to map phase name to each Phase
        function getPhase(phase) {
            if (phase === "Retry") return retryPhase;
            else if (phase === "Serialize") return serializePhase;
            else if (phase === "Deserialize") return deserializePhase;
            else if (phase === "Sign") return signPhase;
            else return noPhase;
        }
        // First walk each policy and create a node to track metadata.
        for (const descriptor of this._policies){
            const policy = descriptor.policy;
            const options = descriptor.options;
            const policyName = policy.name;
            if (policyMap.has(policyName)) throw new Error("Duplicate policy names not allowed in pipeline");
            const node = {
                policy: policy,
                dependsOn: new Set(),
                dependants: new Set()
            };
            if (options.afterPhase) {
                node.afterPhase = getPhase(options.afterPhase);
                node.afterPhase.hasAfterPolicies = true;
            }
            policyMap.set(policyName, node);
            const phase = getPhase(options.phase);
            phase.policies.add(node);
        }
        // Now that each policy has a node, connect dependency references.
        for (const descriptor of this._policies){
            const { policy: policy, options: options } = descriptor;
            const policyName = policy.name;
            const node = policyMap.get(policyName);
            if (!node) throw new Error(`Missing node for policy ${policyName}`);
            if (options.afterPolicies) for (const afterPolicyName of options.afterPolicies){
                const afterNode = policyMap.get(afterPolicyName);
                if (afterNode) {
                    // Linking in both directions helps later
                    // when we want to notify dependants.
                    node.dependsOn.add(afterNode);
                    afterNode.dependants.add(node);
                }
            }
            if (options.beforePolicies) for (const beforePolicyName of options.beforePolicies){
                const beforeNode = policyMap.get(beforePolicyName);
                if (beforeNode) {
                    // To execute before another node, make it
                    // depend on the current node.
                    beforeNode.dependsOn.add(node);
                    node.dependants.add(beforeNode);
                }
            }
        }
        function walkPhase(phase) {
            phase.hasRun = true;
            // Sets iterate in insertion order
            for (const node of phase.policies){
                if (node.afterPhase && (!node.afterPhase.hasRun || node.afterPhase.policies.size)) continue;
                if (node.dependsOn.size === 0) {
                    // If there's nothing else we're waiting for, we can
                    // add this policy to the result list.
                    result.push(node.policy);
                    // Notify anything that depends on this policy that
                    // the policy has been scheduled.
                    for (const dependant of node.dependants)dependant.dependsOn.delete(node);
                    policyMap.delete(node.policy.name);
                    phase.policies.delete(node);
                }
            }
        }
        function walkPhases() {
            for (const phase of orderedPhases){
                walkPhase(phase);
                // if the phase isn't complete
                if (phase.policies.size > 0 && phase !== noPhase) {
                    if (!noPhase.hasRun) // Try running noPhase to see if that unblocks this phase next tick.
                    // This can happen if a phase that happens before noPhase
                    // is waiting on a noPhase policy to complete.
                    walkPhase(noPhase);
                    // Don't proceed to the next phase until this phase finishes.
                    return;
                }
                if (phase.hasAfterPolicies) // Run any policies unblocked by this phase
                walkPhase(noPhase);
            }
        }
        // Iterate until we've put every node in the result list.
        let iteration = 0;
        while(policyMap.size > 0){
            iteration++;
            const initialResultLength = result.length;
            // Keep walking each phase in order until we can order every node.
            walkPhases();
            // The result list *should* get at least one larger each time
            // after the first full pass.
            // Otherwise, we're going to loop forever.
            if (result.length <= initialResultLength && iteration > 1) throw new Error("Cannot satisfy policy dependencies due to requirements cycle.");
        }
        return result;
    }
    constructor(policies){
        var _a;
        this._policies = [];
        this._policies = (_a = policies === null || policies === void 0 ? void 0 : policies.slice(0)) !== null && _a !== void 0 ? _a : [];
        this._orderedPolicies = undefined;
    }
}
function $0091ced366a43134$export$d1727d948a2aa6e7() {
    return $0091ced366a43134$var$HttpPipeline.create();
}

});

parcelRegister("9kpjT", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $9ByDs = parcelRequire("9ByDs");

var $031Y6 = parcelRequire("031Y6");

var $hME2D = parcelRequire("hME2D");

var $gyjf0 = parcelRequire("gyjf0");

var $kbnkW = parcelRequire("kbnkW");

var $5cAex = parcelRequire("5cAex");

var $eS5vG = parcelRequire("eS5vG");

var $afsMq = parcelRequire("afsMq");
parcelRequire("bE3zB");
var $gtuTr = parcelRequire("gtuTr");
parcelRequire("Pm1ym");
var $6yXud = parcelRequire("6yXud");

var $1solD = parcelRequire("1solD");

var $9NSNm = parcelRequire("9NSNm");

var $kBVEb = parcelRequire("kBVEb");
function $6ca99f4c52d9df66$export$79e143a6bb5a0b5c(options) {
    var _a;
    const pipeline = (0, $031Y6.createEmptyPipeline)();
    if (0, $gtuTr.isNodeLike) {
        if (options.tlsOptions) pipeline.addPolicy((0, $9NSNm.tlsPolicy)(options.tlsOptions));
        pipeline.addPolicy((0, $6yXud.proxyPolicy)(options.proxyOptions));
        pipeline.addPolicy((0, $5cAex.decompressResponsePolicy)());
    }
    pipeline.addPolicy((0, $afsMq.formDataPolicy)(), {
        beforePolicies: [
            (0, $kbnkW.multipartPolicyName)
        ]
    });
    pipeline.addPolicy((0, $gyjf0.userAgentPolicy)(options.userAgentOptions));
    pipeline.addPolicy((0, $1solD.setClientRequestIdPolicy)((_a = options.telemetryOptions) === null || _a === void 0 ? void 0 : _a.clientRequestIdHeaderName));
    // The multipart policy is added after policies with no phase, so that
    // policies can be added between it and formDataPolicy to modify
    // properties (e.g., making the boundary constant in recorded tests).
    pipeline.addPolicy((0, $kbnkW.multipartPolicy)(), {
        afterPhase: "Deserialize"
    });
    pipeline.addPolicy((0, $eS5vG.defaultRetryPolicy)(options.retryOptions), {
        phase: "Retry"
    });
    pipeline.addPolicy((0, $kBVEb.tracingPolicy)(Object.assign(Object.assign({}, options.userAgentOptions), options.loggingOptions)), {
        afterPhase: "Retry"
    });
    if (0, $gtuTr.isNodeLike) // Both XHR and Fetch expect to handle redirects automatically,
    // so only include this policy when we're in Node.
    pipeline.addPolicy((0, $hME2D.redirectPolicy)(options.redirectOptions), {
        afterPhase: "Retry"
    });
    pipeline.addPolicy((0, $9ByDs.logPolicy)(options.loggingOptions), {
        afterPhase: "Sign"
    });
    return pipeline;
}

});
parcelRegister("9ByDs", function(module, exports) {

$parcel$export(module.exports, "logPolicy", function () { return $6fe26fa60fb2cede$export$c96ba9e66d66ee29; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $lyjCj = parcelRequire("lyjCj");

var $6DfW9 = parcelRequire("6DfW9");
const $6fe26fa60fb2cede$export$162cd7b3c39e4c57 = "logPolicy";
function $6fe26fa60fb2cede$export$c96ba9e66d66ee29(options = {}) {
    var _a;
    const logger = (_a = options.logger) !== null && _a !== void 0 ? _a : (0, $lyjCj.logger).info;
    const sanitizer = new (0, $6DfW9.Sanitizer)({
        additionalAllowedHeaderNames: options.additionalAllowedHeaderNames,
        additionalAllowedQueryParameters: options.additionalAllowedQueryParameters
    });
    return {
        name: $6fe26fa60fb2cede$export$162cd7b3c39e4c57,
        async sendRequest (request, next) {
            if (!logger.enabled) return next(request);
            logger(`Request: ${sanitizer.sanitize(request)}`);
            const response = await next(request);
            logger(`Response status code: ${response.status}`);
            logger(`Headers: ${sanitizer.sanitize(response.headers)}`);
            return response;
        }
    };
}

});
parcelRegister("lyjCj", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $fb0bfd7b77acea4e$export$af88d00dbe7f521; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $bBnY4 = parcelRequire("bBnY4");
const $fb0bfd7b77acea4e$export$af88d00dbe7f521 = (0, $bBnY4.createClientLogger)("core-rest-pipeline");

});

parcelRegister("6DfW9", function(module, exports) {

$parcel$export(module.exports, "Sanitizer", function () { return $4d42bf52f3b449b1$export$a6cec3dfaf45e6ac; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $1sZvc = parcelRequire("1sZvc");
const $4d42bf52f3b449b1$var$RedactedString = "REDACTED";
// Make sure this list is up-to-date with the one under core/logger/Readme#Keyconcepts
const $4d42bf52f3b449b1$var$defaultAllowedHeaderNames = [
    "x-ms-client-request-id",
    "x-ms-return-client-request-id",
    "x-ms-useragent",
    "x-ms-correlation-request-id",
    "x-ms-request-id",
    "client-request-id",
    "ms-cv",
    "return-client-request-id",
    "traceparent",
    "Access-Control-Allow-Credentials",
    "Access-Control-Allow-Headers",
    "Access-Control-Allow-Methods",
    "Access-Control-Allow-Origin",
    "Access-Control-Expose-Headers",
    "Access-Control-Max-Age",
    "Access-Control-Request-Headers",
    "Access-Control-Request-Method",
    "Origin",
    "Accept",
    "Accept-Encoding",
    "Cache-Control",
    "Connection",
    "Content-Length",
    "Content-Type",
    "Date",
    "ETag",
    "Expires",
    "If-Match",
    "If-Modified-Since",
    "If-None-Match",
    "If-Unmodified-Since",
    "Last-Modified",
    "Pragma",
    "Request-Id",
    "Retry-After",
    "Server",
    "Transfer-Encoding",
    "User-Agent",
    "WWW-Authenticate"
];
const $4d42bf52f3b449b1$var$defaultAllowedQueryParameters = [
    "api-version"
];
class $4d42bf52f3b449b1$export$a6cec3dfaf45e6ac {
    sanitize(obj) {
        const seen = new Set();
        return JSON.stringify(obj, (key, value)=>{
            // Ensure Errors include their interesting non-enumerable members
            if (value instanceof Error) return Object.assign(Object.assign({}, value), {
                name: value.name,
                message: value.message
            });
            if (key === "headers") return this.sanitizeHeaders(value);
            else if (key === "url") return this.sanitizeUrl(value);
            else if (key === "query") return this.sanitizeQuery(value);
            else if (key === "body") // Don't log the request body
            return undefined;
            else if (key === "response") // Don't log response again
            return undefined;
            else if (key === "operationSpec") // When using sendOperationRequest, the request carries a massive
            // field with the autorest spec. No need to log it.
            return undefined;
            else if (Array.isArray(value) || (0, $1sZvc.isObject)(value)) {
                if (seen.has(value)) return "[Circular]";
                seen.add(value);
            }
            return value;
        }, 2);
    }
    sanitizeUrl(value) {
        if (typeof value !== "string" || value === null || value === "") return value;
        const url = new URL(value);
        if (!url.search) return value;
        for (const [key] of url.searchParams)if (!this.allowedQueryParameters.has(key.toLowerCase())) url.searchParams.set(key, $4d42bf52f3b449b1$var$RedactedString);
        return url.toString();
    }
    sanitizeHeaders(obj) {
        const sanitized = {};
        for (const key of Object.keys(obj))if (this.allowedHeaderNames.has(key.toLowerCase())) sanitized[key] = obj[key];
        else sanitized[key] = $4d42bf52f3b449b1$var$RedactedString;
        return sanitized;
    }
    sanitizeQuery(value) {
        if (typeof value !== "object" || value === null) return value;
        const sanitized = {};
        for (const k of Object.keys(value))if (this.allowedQueryParameters.has(k.toLowerCase())) sanitized[k] = value[k];
        else sanitized[k] = $4d42bf52f3b449b1$var$RedactedString;
        return sanitized;
    }
    constructor({ additionalAllowedHeaderNames: allowedHeaderNames = [], additionalAllowedQueryParameters: allowedQueryParameters = [] } = {}){
        allowedHeaderNames = $4d42bf52f3b449b1$var$defaultAllowedHeaderNames.concat(allowedHeaderNames);
        allowedQueryParameters = $4d42bf52f3b449b1$var$defaultAllowedQueryParameters.concat(allowedQueryParameters);
        this.allowedHeaderNames = new Set(allowedHeaderNames.map((n)=>n.toLowerCase()));
        this.allowedQueryParameters = new Set(allowedQueryParameters.map((p)=>p.toLowerCase()));
    }
}

});


parcelRegister("hME2D", function(module, exports) {

$parcel$export(module.exports, "redirectPolicy", function () { return $cf25fac187e45a27$export$aec739cfb985bd48; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * The programmatic identifier of the redirectPolicy.
 */ const $cf25fac187e45a27$export$2bb09fba19b91286 = "redirectPolicy";
/**
 * Methods that are allowed to follow redirects 301 and 302
 */ const $cf25fac187e45a27$var$allowedRedirect = [
    "GET",
    "HEAD"
];
function $cf25fac187e45a27$export$aec739cfb985bd48(options = {}) {
    const { maxRetries: maxRetries = 20 } = options;
    return {
        name: $cf25fac187e45a27$export$2bb09fba19b91286,
        async sendRequest (request, next) {
            const response = await next(request);
            return $cf25fac187e45a27$var$handleRedirect(next, response, maxRetries);
        }
    };
}
async function $cf25fac187e45a27$var$handleRedirect(next, response, maxRetries, currentRetries = 0) {
    const { request: request, status: status, headers: headers } = response;
    const locationHeader = headers.get("location");
    if (locationHeader && (status === 300 || status === 301 && $cf25fac187e45a27$var$allowedRedirect.includes(request.method) || status === 302 && $cf25fac187e45a27$var$allowedRedirect.includes(request.method) || status === 303 && request.method === "POST" || status === 307) && currentRetries < maxRetries) {
        const url = new URL(locationHeader, request.url);
        request.url = url.toString();
        // POST request with Status code 303 should be converted into a
        // redirected GET request if the redirect url is present in the location header
        if (status === 303) {
            request.method = "GET";
            request.headers.delete("Content-Length");
            delete request.body;
        }
        request.headers.delete("Authorization");
        const res = await next(request);
        return $cf25fac187e45a27$var$handleRedirect(next, res, maxRetries, currentRetries + 1);
    }
    return response;
}

});

parcelRegister("gyjf0", function(module, exports) {

$parcel$export(module.exports, "userAgentPolicy", function () { return $c0cebf2b7418ff46$export$df2ab2ef63bad35a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $hz2yJ = parcelRequire("hz2yJ");
const $c0cebf2b7418ff46$var$UserAgentHeaderName = (0, $hz2yJ.getUserAgentHeaderName)();
const $c0cebf2b7418ff46$export$5bf0c6ccddee0872 = "userAgentPolicy";
function $c0cebf2b7418ff46$export$df2ab2ef63bad35a(options = {}) {
    const userAgentValue = (0, $hz2yJ.getUserAgentValue)(options.userAgentPrefix);
    return {
        name: $c0cebf2b7418ff46$export$5bf0c6ccddee0872,
        async sendRequest (request, next) {
            if (!request.headers.has($c0cebf2b7418ff46$var$UserAgentHeaderName)) request.headers.set($c0cebf2b7418ff46$var$UserAgentHeaderName, await userAgentValue);
            return next(request);
        }
    };
}

});
parcelRegister("hz2yJ", function(module, exports) {

$parcel$export(module.exports, "getUserAgentHeaderName", function () { return $cc97b0c455fd9fd6$export$f9841484781380f9; });
$parcel$export(module.exports, "getUserAgentValue", function () { return $cc97b0c455fd9fd6$export$221b71a1214c5f7a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $dBIgB = parcelRequire("dBIgB");

var $bcDl2 = parcelRequire("bcDl2");
function $cc97b0c455fd9fd6$var$getUserAgentString(telemetryInfo) {
    const parts = [];
    for (const [key, value] of telemetryInfo){
        const token = value ? `${key}/${value}` : key;
        parts.push(token);
    }
    return parts.join(" ");
}
function $cc97b0c455fd9fd6$export$f9841484781380f9() {
    return (0, $dBIgB.getHeaderName)();
}
async function $cc97b0c455fd9fd6$export$221b71a1214c5f7a(prefix) {
    const runtimeInfo = new Map();
    runtimeInfo.set("core-rest-pipeline", (0, $bcDl2.SDK_VERSION));
    await (0, $dBIgB.setPlatformSpecificData)(runtimeInfo);
    const defaultAgent = $cc97b0c455fd9fd6$var$getUserAgentString(runtimeInfo);
    const userAgentValue = prefix ? `${prefix} ${defaultAgent}` : defaultAgent;
    return userAgentValue;
}

});
parcelRegister("dBIgB", function(module, exports) {

$parcel$export(module.exports, "getHeaderName", function () { return $9e8111806d3a6ef0$export$87e37b6916dc901a; });
$parcel$export(module.exports, "setPlatformSpecificData", function () { return $9e8111806d3a6ef0$export$3e6b862a73a0e567; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * @internal
 */ function $9e8111806d3a6ef0$export$87e37b6916dc901a() {
    return "x-ms-useragent";
}
function $9e8111806d3a6ef0$var$getBrowserInfo(userAgent) {
    const browserRegexes = [
        {
            name: "Firefox",
            regex: /Firefox\/([\d.]+)/
        },
        {
            name: "Safari",
            regex: /Version\/([\d.]+).*Safari/
        }
    ];
    for (const browser of browserRegexes){
        const match = userAgent.match(browser.regex);
        if (match) return {
            brand: browser.name,
            version: match[1]
        };
    }
    return undefined;
}
function $9e8111806d3a6ef0$var$getBrandVersionString(brands) {
    const brandOrder = [
        "Google Chrome",
        "Microsoft Edge",
        "Opera",
        "Brave",
        "Chromium"
    ];
    for (const brand of brandOrder){
        const foundBrand = brands.find((b)=>b.brand === brand);
        if (foundBrand) return foundBrand;
    }
    return undefined;
}
async function $9e8111806d3a6ef0$export$3e6b862a73a0e567(map) {
    const localNavigator = globalThis.navigator;
    let osPlatform = "unknown";
    if (localNavigator === null || localNavigator === void 0 ? void 0 : localNavigator.userAgentData) {
        const entropyValues = await localNavigator.userAgentData.getHighEntropyValues([
            "architecture",
            "platformVersion"
        ]);
        osPlatform = `${entropyValues.architecture}-${entropyValues.platform}-${entropyValues.platformVersion}`;
        // Get the brand and version
        const brand = $9e8111806d3a6ef0$var$getBrandVersionString(localNavigator.userAgentData.brands);
        if (brand) map.set(brand.brand, brand.version);
    } else if (localNavigator === null || localNavigator === void 0 ? void 0 : localNavigator.platform) {
        osPlatform = localNavigator.platform;
        const brand = $9e8111806d3a6ef0$var$getBrowserInfo(localNavigator.userAgent);
        if (brand) map.set(brand.brand, brand.version);
    } else if (typeof globalThis.EdgeRuntime === "string") map.set("EdgeRuntime", globalThis.EdgeRuntime);
    map.set("OS", osPlatform);
}

});

parcelRegister("bcDl2", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $827f547d5eb5f1a5$export$31499a9cd224b78c; });
$parcel$export(module.exports, "DEFAULT_RETRY_POLICY_COUNT", function () { return $827f547d5eb5f1a5$export$e3758b282b1c2dcb; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const $827f547d5eb5f1a5$export$31499a9cd224b78c = "1.18.1";
const $827f547d5eb5f1a5$export$e3758b282b1c2dcb = 3;

});



parcelRegister("kbnkW", function(module, exports) {

$parcel$export(module.exports, "multipartPolicyName", function () { return $eb16eff15cbf7138$export$45727809134cc21e; });
$parcel$export(module.exports, "multipartPolicy", function () { return $eb16eff15cbf7138$export$5b3d05101322c3af; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $hlqzV = parcelRequire("hlqzV");
var $FIiXD = parcelRequire("FIiXD");
parcelRequire("2OQFo");
var $lzpFH = parcelRequire("lzpFH");

var $gVaZI = parcelRequire("gVaZI");
function $eb16eff15cbf7138$var$generateBoundary() {
    return `----AzSDKFormBoundary${(0, $hlqzV.randomUUID)()}`;
}
function $eb16eff15cbf7138$var$encodeHeaders(headers) {
    let result = "";
    for (const [key, value] of headers)result += `${key}: ${value}\r\n`;
    return result;
}
function $eb16eff15cbf7138$var$getLength(source) {
    if (source instanceof Uint8Array) return source.byteLength;
    else if ((0, $gVaZI.isBlob)(source)) // if was created using createFile then -1 means we have an unknown size
    return source.size === -1 ? undefined : source.size;
    else return undefined;
}
function $eb16eff15cbf7138$var$getTotalLength(sources) {
    let total = 0;
    for (const source of sources){
        const partLength = $eb16eff15cbf7138$var$getLength(source);
        if (partLength === undefined) return undefined;
        else total += partLength;
    }
    return total;
}
async function $eb16eff15cbf7138$var$buildRequestBody(request, parts, boundary) {
    const sources = [
        (0, $FIiXD.stringToUint8Array)(`--${boundary}`, "utf-8"),
        ...parts.flatMap((part)=>[
                (0, $FIiXD.stringToUint8Array)("\r\n", "utf-8"),
                (0, $FIiXD.stringToUint8Array)($eb16eff15cbf7138$var$encodeHeaders(part.headers), "utf-8"),
                (0, $FIiXD.stringToUint8Array)("\r\n", "utf-8"),
                part.body,
                (0, $FIiXD.stringToUint8Array)(`\r\n--${boundary}`, "utf-8")
            ]),
        (0, $FIiXD.stringToUint8Array)("--\r\n\r\n", "utf-8")
    ];
    const contentLength = $eb16eff15cbf7138$var$getTotalLength(sources);
    if (contentLength) request.headers.set("Content-Length", contentLength);
    request.body = await (0, $lzpFH.concat)(sources);
}
const $eb16eff15cbf7138$export$45727809134cc21e = "multipartPolicy";
const $eb16eff15cbf7138$var$maxBoundaryLength = 70;
const $eb16eff15cbf7138$var$validBoundaryCharacters = new Set(`abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'()+,-./:=?`);
function $eb16eff15cbf7138$var$assertValidBoundary(boundary) {
    if (boundary.length > $eb16eff15cbf7138$var$maxBoundaryLength) throw new Error(`Multipart boundary "${boundary}" exceeds maximum length of 70 characters`);
    if (Array.from(boundary).some((x)=>!$eb16eff15cbf7138$var$validBoundaryCharacters.has(x))) throw new Error(`Multipart boundary "${boundary}" contains invalid characters`);
}
function $eb16eff15cbf7138$export$5b3d05101322c3af() {
    return {
        name: $eb16eff15cbf7138$export$45727809134cc21e,
        async sendRequest (request, next) {
            var _a;
            if (!request.multipartBody) return next(request);
            if (request.body) throw new Error("multipartBody and regular body cannot be set at the same time");
            let boundary = request.multipartBody.boundary;
            const contentTypeHeader = (_a = request.headers.get("Content-Type")) !== null && _a !== void 0 ? _a : "multipart/mixed";
            const parsedHeader = contentTypeHeader.match(/^(multipart\/[^ ;]+)(?:; *boundary=(.+))?$/);
            if (!parsedHeader) throw new Error(`Got multipart request body, but content-type header was not multipart: ${contentTypeHeader}`);
            const [, contentType, parsedBoundary] = parsedHeader;
            if (parsedBoundary && boundary && parsedBoundary !== boundary) throw new Error(`Multipart boundary was specified as ${parsedBoundary} in the header, but got ${boundary} in the request body`);
            boundary !== null && boundary !== void 0 ? boundary : boundary = parsedBoundary;
            if (boundary) $eb16eff15cbf7138$var$assertValidBoundary(boundary);
            else boundary = $eb16eff15cbf7138$var$generateBoundary();
            request.headers.set("Content-Type", `${contentType}; boundary=${boundary}`);
            await $eb16eff15cbf7138$var$buildRequestBody(request, request.multipartBody.parts, boundary);
            request.multipartBody = undefined;
            return next(request);
        }
    };
}

});
parcelRegister("2OQFo", function(module, exports) {
$parcel$export(module.exports, "concat", function () { return (parcelRequire("lzpFH")).concat; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("lzpFH");

});
parcelRegister("lzpFH", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $fb40c7adb75bde29$export$ee1b3e54f0441b22; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $hT8Vt = parcelRequire("hT8Vt");

var $gVaZI = parcelRequire("gVaZI");
/**
 * Drain the content of the given ReadableStream into a Blob.
 * The blob's content may end up in memory or on disk dependent on size.
 */ function $fb40c7adb75bde29$var$drain(stream) {
    return new Response(stream).blob();
}
async function $fb40c7adb75bde29$var$toBlobPart(source) {
    if (source instanceof Blob || source instanceof Uint8Array) return source;
    if ((0, $gVaZI.isWebReadableStream)(source)) return $fb40c7adb75bde29$var$drain(source);
    // If it's not a true Blob, and it's not a Uint8Array, we can assume the source
    // is a fake File created by createFileFromStream and we can get the original stream
    // using getRawContent.
    const rawContent = (0, $hT8Vt.getRawContent)(source);
    // Shouldn't happen but guard for it anyway
    if ((0, $gVaZI.isNodeReadableStream)(rawContent)) throw new Error("Encountered unexpected type. In the browser, `concat` supports Web ReadableStream, Blob, Uint8Array, and files created using `createFile` only.");
    return $fb40c7adb75bde29$var$toBlobPart(rawContent);
}
async function $fb40c7adb75bde29$export$ee1b3e54f0441b22(sources) {
    const parts = [];
    for (const source of sources)parts.push(await $fb40c7adb75bde29$var$toBlobPart(typeof source === "function" ? source() : source));
    return new Blob(parts);
}

});
parcelRegister("hT8Vt", function(module, exports) {

$parcel$export(module.exports, "getRawContent", function () { return $d05e7f421a9c749b$export$b4595122821492b; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $gtuTr = parcelRequire("gtuTr");

var $gVaZI = parcelRequire("gVaZI");
const $d05e7f421a9c749b$var$unimplementedMethods = {
    arrayBuffer: ()=>{
        throw new Error("Not implemented");
    },
    slice: ()=>{
        throw new Error("Not implemented");
    },
    text: ()=>{
        throw new Error("Not implemented");
    }
};
/**
 * Private symbol used as key on objects created using createFile containing the
 * original source of the file object.
 *
 * This is used in Node to access the original Node stream without using Blob#stream, which
 * returns a web stream. This is done to avoid a couple of bugs to do with Blob#stream and
 * Readable#to/fromWeb in Node versions we support:
 * - https://github.com/nodejs/node/issues/42694 (fixed in Node 18.14)
 * - https://github.com/nodejs/node/issues/48916 (fixed in Node 20.6)
 *
 * Once these versions are no longer supported, we may be able to stop doing this.
 *
 * @internal
 */ const $d05e7f421a9c749b$var$rawContent = Symbol("rawContent");
function $d05e7f421a9c749b$var$hasRawContent(x) {
    return typeof x[$d05e7f421a9c749b$var$rawContent] === "function";
}
function $d05e7f421a9c749b$export$b4595122821492b(blob) {
    if ($d05e7f421a9c749b$var$hasRawContent(blob)) return blob[$d05e7f421a9c749b$var$rawContent]();
    else return blob.stream();
}
function $d05e7f421a9c749b$export$a2afb2620694249f(stream, name, options = {}) {
    var _a, _b, _c, _d;
    return Object.assign(Object.assign({}, $d05e7f421a9c749b$var$unimplementedMethods), {
        type: (_a = options.type) !== null && _a !== void 0 ? _a : "",
        lastModified: (_b = options.lastModified) !== null && _b !== void 0 ? _b : new Date().getTime(),
        webkitRelativePath: (_c = options.webkitRelativePath) !== null && _c !== void 0 ? _c : "",
        size: (_d = options.size) !== null && _d !== void 0 ? _d : -1,
        name: name,
        stream: ()=>{
            const s = stream();
            if ((0, $gVaZI.isNodeReadableStream)(s)) throw new Error("Not supported: a Node stream was provided as input to createFileFromStream.");
            return s;
        },
        [$d05e7f421a9c749b$var$rawContent]: stream
    });
}
function $d05e7f421a9c749b$export$982c3a0b9a5cde94(content, name, options = {}) {
    var _a, _b, _c;
    if (0, $gtuTr.isNodeLike) return Object.assign(Object.assign({}, $d05e7f421a9c749b$var$unimplementedMethods), {
        type: (_a = options.type) !== null && _a !== void 0 ? _a : "",
        lastModified: (_b = options.lastModified) !== null && _b !== void 0 ? _b : new Date().getTime(),
        webkitRelativePath: (_c = options.webkitRelativePath) !== null && _c !== void 0 ? _c : "",
        size: content.byteLength,
        name: name,
        arrayBuffer: async ()=>content.buffer,
        stream: ()=>new Blob([
                content
            ]).stream(),
        [$d05e7f421a9c749b$var$rawContent]: ()=>content
    });
    else return new File([
        content
    ], name, options);
}

});
parcelRegister("gVaZI", function(module, exports) {

$parcel$export(module.exports, "isNodeReadableStream", function () { return $c51a7f7c2e91f7cd$export$530196473208426f; });
$parcel$export(module.exports, "isWebReadableStream", function () { return $c51a7f7c2e91f7cd$export$bc95ddda6357be26; });
$parcel$export(module.exports, "isBlob", function () { return $c51a7f7c2e91f7cd$export$5bcd6e94ed871c88; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
function $c51a7f7c2e91f7cd$export$530196473208426f(x) {
    return Boolean(x && typeof x["pipe"] === "function");
}
function $c51a7f7c2e91f7cd$export$bc95ddda6357be26(x) {
    return Boolean(x && typeof x.getReader === "function" && typeof x.tee === "function");
}
function $c51a7f7c2e91f7cd$export$ac613ff475b69d05(x) {
    return $c51a7f7c2e91f7cd$export$530196473208426f(x) || $c51a7f7c2e91f7cd$export$bc95ddda6357be26(x);
}
function $c51a7f7c2e91f7cd$export$5bcd6e94ed871c88(x) {
    return typeof x.stream === "function";
}

});





parcelRegister("5cAex", function(module, exports) {

$parcel$export(module.exports, "decompressResponsePolicy", function () { return $3c9a2df627757520$export$a07d3565d8e03af5; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/*
 * NOTE: When moving this file, please update "browser" section in package.json
 */ const $3c9a2df627757520$export$71b15ae52e40e9b9 = "decompressResponsePolicy";
function $3c9a2df627757520$export$a07d3565d8e03af5() {
    throw new Error("decompressResponsePolicy is not supported in browser environment");
}

});

parcelRegister("eS5vG", function(module, exports) {

$parcel$export(module.exports, "defaultRetryPolicy", function () { return $ad3a61ff8662a746$export$2797ac0c742a895c; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $4hN9n = parcelRequire("4hN9n");

var $7KZDQ = parcelRequire("7KZDQ");

var $icUco = parcelRequire("icUco");

var $bcDl2 = parcelRequire("bcDl2");
const $ad3a61ff8662a746$export$8e84dd420dfc05b3 = "defaultRetryPolicy";
function $ad3a61ff8662a746$export$2797ac0c742a895c(options = {}) {
    var _a;
    return {
        name: $ad3a61ff8662a746$export$8e84dd420dfc05b3,
        sendRequest: (0, $icUco.retryPolicy)([
            (0, $7KZDQ.throttlingRetryStrategy)(),
            (0, $4hN9n.exponentialRetryStrategy)(options)
        ], {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT)
        }).sendRequest
    };
}

});
parcelRegister("4hN9n", function(module, exports) {

$parcel$export(module.exports, "exponentialRetryStrategy", function () { return $31eee030f17a39d9$export$32df8c45a4e0ceb; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $9Ubx8 = parcelRequire("9Ubx8");

var $7KZDQ = parcelRequire("7KZDQ");
// intervals are in milliseconds
const $31eee030f17a39d9$var$DEFAULT_CLIENT_RETRY_INTERVAL = 1000;
const $31eee030f17a39d9$var$DEFAULT_CLIENT_MAX_RETRY_INTERVAL = 64000;
function $31eee030f17a39d9$export$32df8c45a4e0ceb(options = {}) {
    var _a, _b;
    const retryInterval = (_a = options.retryDelayInMs) !== null && _a !== void 0 ? _a : $31eee030f17a39d9$var$DEFAULT_CLIENT_RETRY_INTERVAL;
    const maxRetryInterval = (_b = options.maxRetryDelayInMs) !== null && _b !== void 0 ? _b : $31eee030f17a39d9$var$DEFAULT_CLIENT_MAX_RETRY_INTERVAL;
    return {
        name: "exponentialRetryStrategy",
        retry ({ retryCount: retryCount, response: response, responseError: responseError }) {
            const matchedSystemError = $31eee030f17a39d9$export$4963f644aa8940e5(responseError);
            const ignoreSystemErrors = matchedSystemError && options.ignoreSystemErrors;
            const isExponential = $31eee030f17a39d9$export$8f4e838352aae1f9(response);
            const ignoreExponentialResponse = isExponential && options.ignoreHttpStatusCodes;
            const unknownResponse = response && ((0, $7KZDQ.isThrottlingRetryResponse)(response) || !isExponential);
            if (unknownResponse || ignoreExponentialResponse || ignoreSystemErrors) return {
                skipStrategy: true
            };
            if (responseError && !matchedSystemError && !isExponential) return {
                errorToThrow: responseError
            };
            return (0, $9Ubx8.calculateRetryDelay)(retryCount, {
                retryDelayInMs: retryInterval,
                maxRetryDelayInMs: maxRetryInterval
            });
        }
    };
}
function $31eee030f17a39d9$export$8f4e838352aae1f9(response) {
    return Boolean(response && response.status !== undefined && (response.status >= 500 || response.status === 408) && response.status !== 501 && response.status !== 505);
}
function $31eee030f17a39d9$export$4963f644aa8940e5(err) {
    if (!err) return false;
    return err.code === "ETIMEDOUT" || err.code === "ESOCKETTIMEDOUT" || err.code === "ECONNREFUSED" || err.code === "ECONNRESET" || err.code === "ENOENT" || err.code === "ENOTFOUND";
}

});
parcelRegister("7KZDQ", function(module, exports) {

$parcel$export(module.exports, "isThrottlingRetryResponse", function () { return $5a5ca508bf44c782$export$48a74a1c26461af; });
$parcel$export(module.exports, "throttlingRetryStrategy", function () { return $5a5ca508bf44c782$export$3d2fd7f8042e755a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $i7WyN = parcelRequire("i7WyN");
/**
 * The header that comes back from Azure services representing
 * the amount of time (minimum) to wait to retry (in seconds or timestamp after which we can retry).
 */ const $5a5ca508bf44c782$var$RetryAfterHeader = "Retry-After";
/**
 * The headers that come back from Azure services representing
 * the amount of time (minimum) to wait to retry.
 *
 * "retry-after-ms", "x-ms-retry-after-ms" : milliseconds
 * "Retry-After" : seconds or timestamp
 */ const $5a5ca508bf44c782$var$AllRetryAfterHeaders = [
    "retry-after-ms",
    "x-ms-retry-after-ms",
    $5a5ca508bf44c782$var$RetryAfterHeader
];
/**
 * A response is a throttling retry response if it has a throttling status code (429 or 503),
 * as long as one of the [ "Retry-After" or "retry-after-ms" or "x-ms-retry-after-ms" ] headers has a valid value.
 *
 * Returns the `retryAfterInMs` value if the response is a throttling retry response.
 * If not throttling retry response, returns `undefined`.
 *
 * @internal
 */ function $5a5ca508bf44c782$var$getRetryAfterInMs(response) {
    if (!(response && [
        429,
        503
    ].includes(response.status))) return undefined;
    try {
        // Headers: "retry-after-ms", "x-ms-retry-after-ms", "Retry-After"
        for (const header of $5a5ca508bf44c782$var$AllRetryAfterHeaders){
            const retryAfterValue = (0, $i7WyN.parseHeaderValueAsNumber)(response, header);
            if (retryAfterValue === 0 || retryAfterValue) {
                // "Retry-After" header ==> seconds
                // "retry-after-ms", "x-ms-retry-after-ms" headers ==> milli-seconds
                const multiplyingFactor = header === $5a5ca508bf44c782$var$RetryAfterHeader ? 1000 : 1;
                return retryAfterValue * multiplyingFactor; // in milli-seconds
            }
        }
        // RetryAfterHeader ("Retry-After") has a special case where it might be formatted as a date instead of a number of seconds
        const retryAfterHeader = response.headers.get($5a5ca508bf44c782$var$RetryAfterHeader);
        if (!retryAfterHeader) return;
        const date = Date.parse(retryAfterHeader);
        const diff = date - Date.now();
        // negative diff would mean a date in the past, so retry asap with 0 milliseconds
        return Number.isFinite(diff) ? Math.max(0, diff) : undefined;
    } catch (_a) {
        return undefined;
    }
}
function $5a5ca508bf44c782$export$48a74a1c26461af(response) {
    return Number.isFinite($5a5ca508bf44c782$var$getRetryAfterInMs(response));
}
function $5a5ca508bf44c782$export$3d2fd7f8042e755a() {
    return {
        name: "throttlingRetryStrategy",
        retry ({ response: response }) {
            const retryAfterInMs = $5a5ca508bf44c782$var$getRetryAfterInMs(response);
            if (!Number.isFinite(retryAfterInMs)) return {
                skipStrategy: true
            };
            return {
                retryAfterInMs: retryAfterInMs
            };
        }
    };
}

});
parcelRegister("i7WyN", function(module, exports) {

$parcel$export(module.exports, "delay", function () { return $d3264e486acb8eb8$export$1391212d75b2ee65; });
$parcel$export(module.exports, "parseHeaderValueAsNumber", function () { return $d3264e486acb8eb8$export$e72e490e94da6f8f; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("67uCy");
var $k0hjZ = parcelRequire("k0hjZ");
const $d3264e486acb8eb8$var$StandardAbortMessage = "The operation was aborted.";
function $d3264e486acb8eb8$export$1391212d75b2ee65(delayInMs, value, options) {
    return new Promise((resolve, reject)=>{
        let timer = undefined;
        let onAborted = undefined;
        const rejectOnAbort = ()=>{
            return reject(new (0, $k0hjZ.AbortError)((options === null || options === void 0 ? void 0 : options.abortErrorMsg) ? options === null || options === void 0 ? void 0 : options.abortErrorMsg : $d3264e486acb8eb8$var$StandardAbortMessage));
        };
        const removeListeners = ()=>{
            if ((options === null || options === void 0 ? void 0 : options.abortSignal) && onAborted) options.abortSignal.removeEventListener("abort", onAborted);
        };
        onAborted = ()=>{
            if (timer) clearTimeout(timer);
            removeListeners();
            return rejectOnAbort();
        };
        if ((options === null || options === void 0 ? void 0 : options.abortSignal) && options.abortSignal.aborted) return rejectOnAbort();
        timer = setTimeout(()=>{
            removeListeners();
            resolve(value);
        }, delayInMs);
        if (options === null || options === void 0 ? void 0 : options.abortSignal) options.abortSignal.addEventListener("abort", onAborted);
    });
}
function $d3264e486acb8eb8$export$e72e490e94da6f8f(response, headerName) {
    const value = response.headers.get(headerName);
    if (!value) return;
    const valueAsNum = Number(value);
    if (Number.isNaN(valueAsNum)) return;
    return valueAsNum;
}

});



parcelRegister("icUco", function(module, exports) {

$parcel$export(module.exports, "retryPolicy", function () { return $d414f0e2fb3a4efe$export$37db893101ba8efb; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $i7WyN = parcelRequire("i7WyN");

var $bBnY4 = parcelRequire("bBnY4");
parcelRequire("67uCy");
var $k0hjZ = parcelRequire("k0hjZ");

var $bcDl2 = parcelRequire("bcDl2");
const $d414f0e2fb3a4efe$var$retryPolicyLogger = (0, $bBnY4.createClientLogger)("core-rest-pipeline retryPolicy");
/**
 * The programmatic identifier of the retryPolicy.
 */ const $d414f0e2fb3a4efe$var$retryPolicyName = "retryPolicy";
function $d414f0e2fb3a4efe$export$37db893101ba8efb(strategies, options = {
    maxRetries: (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT)
}) {
    const logger = options.logger || $d414f0e2fb3a4efe$var$retryPolicyLogger;
    return {
        name: $d414f0e2fb3a4efe$var$retryPolicyName,
        async sendRequest (request, next) {
            var _a, _b;
            let response;
            let responseError;
            let retryCount = -1;
            // eslint-disable-next-line no-constant-condition
            retryRequest: while(true){
                retryCount += 1;
                response = undefined;
                responseError = undefined;
                try {
                    logger.info(`Retry ${retryCount}: Attempting to send request`, request.requestId);
                    response = await next(request);
                    logger.info(`Retry ${retryCount}: Received a response from request`, request.requestId);
                } catch (e) {
                    logger.error(`Retry ${retryCount}: Received an error from request`, request.requestId);
                    // RestErrors are valid targets for the retry strategies.
                    // If none of the retry strategies can work with them, they will be thrown later in this policy.
                    // If the received error is not a RestError, it is immediately thrown.
                    responseError = e;
                    if (!e || responseError.name !== "RestError") throw e;
                    response = responseError.response;
                }
                if ((_a = request.abortSignal) === null || _a === void 0 ? void 0 : _a.aborted) {
                    logger.error(`Retry ${retryCount}: Request aborted.`);
                    const abortError = new (0, $k0hjZ.AbortError)();
                    throw abortError;
                }
                if (retryCount >= ((_b = options.maxRetries) !== null && _b !== void 0 ? _b : (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT))) {
                    logger.info(`Retry ${retryCount}: Maximum retries reached. Returning the last received response, or throwing the last received error.`);
                    if (responseError) throw responseError;
                    else if (response) return response;
                    else throw new Error("Maximum retries reached with no response or error to throw");
                }
                logger.info(`Retry ${retryCount}: Processing ${strategies.length} retry strategies.`);
                strategiesLoop: for (const strategy of strategies){
                    const strategyLogger = strategy.logger || $d414f0e2fb3a4efe$var$retryPolicyLogger;
                    strategyLogger.info(`Retry ${retryCount}: Processing retry strategy ${strategy.name}.`);
                    const modifiers = strategy.retry({
                        retryCount: retryCount,
                        response: response,
                        responseError: responseError
                    });
                    if (modifiers.skipStrategy) {
                        strategyLogger.info(`Retry ${retryCount}: Skipped.`);
                        continue strategiesLoop;
                    }
                    const { errorToThrow: errorToThrow, retryAfterInMs: retryAfterInMs, redirectTo: redirectTo } = modifiers;
                    if (errorToThrow) {
                        strategyLogger.error(`Retry ${retryCount}: Retry strategy ${strategy.name} throws error:`, errorToThrow);
                        throw errorToThrow;
                    }
                    if (retryAfterInMs || retryAfterInMs === 0) {
                        strategyLogger.info(`Retry ${retryCount}: Retry strategy ${strategy.name} retries after ${retryAfterInMs}`);
                        await (0, $i7WyN.delay)(retryAfterInMs, undefined, {
                            abortSignal: request.abortSignal
                        });
                        continue retryRequest;
                    }
                    if (redirectTo) {
                        strategyLogger.info(`Retry ${retryCount}: Retry strategy ${strategy.name} redirects to ${redirectTo}`);
                        request.url = redirectTo;
                        continue retryRequest;
                    }
                }
                if (responseError) {
                    logger.info(`None of the retry strategies could work with the received error. Throwing it.`);
                    throw responseError;
                }
                if (response) {
                    logger.info(`None of the retry strategies could work with the received response. Returning it.`);
                    return response;
                }
            // If all the retries skip and there's no response,
            // we're still in the retry loop, so a new request will be sent
            // until `maxRetries` is reached.
            }
        }
    };
}

});


parcelRegister("afsMq", function(module, exports) {

$parcel$export(module.exports, "formDataPolicy", function () { return $7761a137dba629aa$export$605ab7ff664094f0; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $gtuTr = parcelRequire("gtuTr");
var $FIiXD = parcelRequire("FIiXD");

var $dTHTy = parcelRequire("dTHTy");
const $7761a137dba629aa$export$17a6717f6759c6c6 = "formDataPolicy";
function $7761a137dba629aa$var$formDataToFormDataMap(formData) {
    var _a;
    const formDataMap = {};
    for (const [key, value] of formData.entries()){
        (_a = formDataMap[key]) !== null && _a !== void 0 ? _a : formDataMap[key] = [];
        formDataMap[key].push(value);
    }
    return formDataMap;
}
function $7761a137dba629aa$export$605ab7ff664094f0() {
    return {
        name: $7761a137dba629aa$export$17a6717f6759c6c6,
        async sendRequest (request, next) {
            if ((0, $gtuTr.isNodeLike) && typeof FormData !== "undefined" && request.body instanceof FormData) {
                request.formData = $7761a137dba629aa$var$formDataToFormDataMap(request.body);
                request.body = undefined;
            }
            if (request.formData) {
                const contentType = request.headers.get("Content-Type");
                if (contentType && contentType.indexOf("application/x-www-form-urlencoded") !== -1) request.body = $7761a137dba629aa$var$wwwFormUrlEncode(request.formData);
                else await $7761a137dba629aa$var$prepareFormData(request.formData, request);
                request.formData = undefined;
            }
            return next(request);
        }
    };
}
function $7761a137dba629aa$var$wwwFormUrlEncode(formData) {
    const urlSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(formData)){
        if (Array.isArray(value)) for (const subValue of value)urlSearchParams.append(key, subValue.toString());
        else urlSearchParams.append(key, value.toString());
    }
    return urlSearchParams.toString();
}
async function $7761a137dba629aa$var$prepareFormData(formData, request) {
    // validate content type (multipart/form-data)
    const contentType = request.headers.get("Content-Type");
    if (contentType && !contentType.startsWith("multipart/form-data")) // content type is specified and is not multipart/form-data. Exit.
    return;
    request.headers.set("Content-Type", contentType !== null && contentType !== void 0 ? contentType : "multipart/form-data");
    // set body to MultipartRequestBody using content from FormDataMap
    const parts = [];
    for (const [fieldName, values] of Object.entries(formData))for (const value of Array.isArray(values) ? values : [
        values
    ]){
        if (typeof value === "string") parts.push({
            headers: (0, $dTHTy.createHttpHeaders)({
                "Content-Disposition": `form-data; name="${fieldName}"`
            }),
            body: (0, $FIiXD.stringToUint8Array)(value, "utf-8")
        });
        else if (value === undefined || value === null || typeof value !== "object") throw new Error(`Unexpected value for key ${fieldName}: ${value}. Value should be serialized to string first.`);
        else {
            // using || instead of ?? here since if value.name is empty we should create a file name
            const fileName = value.name || "blob";
            const headers = (0, $dTHTy.createHttpHeaders)();
            headers.set("Content-Disposition", `form-data; name="${fieldName}"; filename="${fileName}"`);
            // again, || is used since an empty value.type means the content type is unset
            headers.set("Content-Type", value.type || "application/octet-stream");
            parts.push({
                headers: headers,
                body: value
            });
        }
    }
    request.multipartBody = {
        parts: parts
    };
}

});
parcelRegister("dTHTy", function(module, exports) {

$parcel$export(module.exports, "createHttpHeaders", function () { return $029c6d42461d6110$export$4c8e967a76f3c947; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
function $029c6d42461d6110$var$normalizeName(name) {
    return name.toLowerCase();
}
function* $029c6d42461d6110$var$headerIterator(map) {
    for (const entry of map.values())yield [
        entry.name,
        entry.value
    ];
}
class $029c6d42461d6110$var$HttpHeadersImpl {
    /**
     * Set a header in this collection with the provided name and value. The name is
     * case-insensitive.
     * @param name - The name of the header to set. This value is case-insensitive.
     * @param value - The value of the header to set.
     */ set(name, value) {
        this._headersMap.set($029c6d42461d6110$var$normalizeName(name), {
            name: name,
            value: String(value).trim()
        });
    }
    /**
     * Get the header value for the provided header name, or undefined if no header exists in this
     * collection with the provided name.
     * @param name - The name of the header. This value is case-insensitive.
     */ get(name) {
        var _a;
        return (_a = this._headersMap.get($029c6d42461d6110$var$normalizeName(name))) === null || _a === void 0 ? void 0 : _a.value;
    }
    /**
     * Get whether or not this header collection contains a header entry for the provided header name.
     * @param name - The name of the header to set. This value is case-insensitive.
     */ has(name) {
        return this._headersMap.has($029c6d42461d6110$var$normalizeName(name));
    }
    /**
     * Remove the header with the provided headerName.
     * @param name - The name of the header to remove.
     */ delete(name) {
        this._headersMap.delete($029c6d42461d6110$var$normalizeName(name));
    }
    /**
     * Get the JSON object representation of this HTTP header collection.
     */ toJSON(options = {}) {
        const result = {};
        if (options.preserveCase) for (const entry of this._headersMap.values())result[entry.name] = entry.value;
        else for (const [normalizedName, entry] of this._headersMap)result[normalizedName] = entry.value;
        return result;
    }
    /**
     * Get the string representation of this HTTP header collection.
     */ toString() {
        return JSON.stringify(this.toJSON({
            preserveCase: true
        }));
    }
    /**
     * Iterate over tuples of header [name, value] pairs.
     */ [Symbol.iterator]() {
        return $029c6d42461d6110$var$headerIterator(this._headersMap);
    }
    constructor(rawHeaders){
        this._headersMap = new Map();
        if (rawHeaders) for (const headerName of Object.keys(rawHeaders))this.set(headerName, rawHeaders[headerName]);
    }
}
function $029c6d42461d6110$export$4c8e967a76f3c947(rawHeaders) {
    return new $029c6d42461d6110$var$HttpHeadersImpl(rawHeaders);
}

});


parcelRegister("Pm1ym", function(module, exports) {
$parcel$export(module.exports, "proxyPolicy", function () { return (parcelRequire("6yXud")).proxyPolicy; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("6yXud");

});
parcelRegister("6yXud", function(module, exports) {

$parcel$export(module.exports, "proxyPolicy", function () { return $4c740fcf0e6246d1$export$c8ba111c8b5cde39; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const $4c740fcf0e6246d1$export$da40def3840f10fb = "proxyPolicy";
const $4c740fcf0e6246d1$var$errorMessage = "proxyPolicy is not supported in browser environment";
function $4c740fcf0e6246d1$export$a59f045a6868232f() {
    throw new Error($4c740fcf0e6246d1$var$errorMessage);
}
function $4c740fcf0e6246d1$export$c8ba111c8b5cde39() {
    throw new Error($4c740fcf0e6246d1$var$errorMessage);
}
function $4c740fcf0e6246d1$export$c0bf6e840aff75d1() {
    throw new Error($4c740fcf0e6246d1$var$errorMessage);
}

});


parcelRegister("1solD", function(module, exports) {

$parcel$export(module.exports, "setClientRequestIdPolicy", function () { return $10fb4af9239c3b6c$export$89a9abde4287c015; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * The programmatic identifier of the setClientRequestIdPolicy.
 */ const $10fb4af9239c3b6c$export$b96f0a399433e783 = "setClientRequestIdPolicy";
function $10fb4af9239c3b6c$export$89a9abde4287c015(requestIdHeaderName = "x-ms-client-request-id") {
    return {
        name: $10fb4af9239c3b6c$export$b96f0a399433e783,
        async sendRequest (request, next) {
            if (!request.headers.has(requestIdHeaderName)) request.headers.set(requestIdHeaderName, request.requestId);
            return next(request);
        }
    };
}

});

parcelRegister("9NSNm", function(module, exports) {

$parcel$export(module.exports, "tlsPolicy", function () { return $723331d021998678$export$6f1cb49a51acb2b0; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Name of the TLS Policy
 */ const $723331d021998678$export$de2418bd56fd77e7 = "tlsPolicy";
function $723331d021998678$export$6f1cb49a51acb2b0(tlsSettings) {
    return {
        name: $723331d021998678$export$de2418bd56fd77e7,
        sendRequest: async (req, next)=>{
            // Users may define a request tlsSettings, honor those over the client level one
            if (!req.tlsSettings) req.tlsSettings = tlsSettings;
            return next(req);
        }
    };
}

});

parcelRegister("kBVEb", function(module, exports) {

$parcel$export(module.exports, "tracingPolicy", function () { return $f013fad9dbcce35f$export$3ac4e45166506a4b; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("fYr8S");
var $aI0Y1 = parcelRequire("aI0Y1");

var $bcDl2 = parcelRequire("bcDl2");

var $hz2yJ = parcelRequire("hz2yJ");

var $lyjCj = parcelRequire("lyjCj");
parcelRequire("bE3zB");
var $clFsF = parcelRequire("clFsF");

var $hWNsE = parcelRequire("hWNsE");

var $6DfW9 = parcelRequire("6DfW9");
const $f013fad9dbcce35f$export$95e79aa245a9e403 = "tracingPolicy";
function $f013fad9dbcce35f$export$3ac4e45166506a4b(options = {}) {
    const userAgentPromise = (0, $hz2yJ.getUserAgentValue)(options.userAgentPrefix);
    const sanitizer = new (0, $6DfW9.Sanitizer)({
        additionalAllowedQueryParameters: options.additionalAllowedQueryParameters
    });
    const tracingClient = $f013fad9dbcce35f$var$tryCreateTracingClient();
    return {
        name: $f013fad9dbcce35f$export$95e79aa245a9e403,
        async sendRequest (request, next) {
            var _a;
            if (!tracingClient) return next(request);
            const userAgent = await userAgentPromise;
            const spanAttributes = {
                "http.url": sanitizer.sanitizeUrl(request.url),
                "http.method": request.method,
                "http.user_agent": userAgent,
                requestId: request.requestId
            };
            if (userAgent) spanAttributes["http.user_agent"] = userAgent;
            const { span: span, tracingContext: tracingContext } = (_a = $f013fad9dbcce35f$var$tryCreateSpan(tracingClient, request, spanAttributes)) !== null && _a !== void 0 ? _a : {};
            if (!span || !tracingContext) return next(request);
            try {
                const response = await tracingClient.withContext(tracingContext, next, request);
                $f013fad9dbcce35f$var$tryProcessResponse(span, response);
                return response;
            } catch (err) {
                $f013fad9dbcce35f$var$tryProcessError(span, err);
                throw err;
            }
        }
    };
}
function $f013fad9dbcce35f$var$tryCreateTracingClient() {
    try {
        return (0, $aI0Y1.createTracingClient)({
            namespace: "",
            packageName: "@azure/core-rest-pipeline",
            packageVersion: (0, $bcDl2.SDK_VERSION)
        });
    } catch (e) {
        (0, $lyjCj.logger).warning(`Error when creating the TracingClient: ${(0, $clFsF.getErrorMessage)(e)}`);
        return undefined;
    }
}
function $f013fad9dbcce35f$var$tryCreateSpan(tracingClient, request, spanAttributes) {
    try {
        // As per spec, we do not need to differentiate between HTTP and HTTPS in span name.
        const { span: span, updatedOptions: updatedOptions } = tracingClient.startSpan(`HTTP ${request.method}`, {
            tracingOptions: request.tracingOptions
        }, {
            spanKind: "client",
            spanAttributes: spanAttributes
        });
        // If the span is not recording, don't do any more work.
        if (!span.isRecording()) {
            span.end();
            return undefined;
        }
        // set headers
        const headers = tracingClient.createRequestHeaders(updatedOptions.tracingOptions.tracingContext);
        for (const [key, value] of Object.entries(headers))request.headers.set(key, value);
        return {
            span: span,
            tracingContext: updatedOptions.tracingOptions.tracingContext
        };
    } catch (e) {
        (0, $lyjCj.logger).warning(`Skipping creating a tracing span due to an error: ${(0, $clFsF.getErrorMessage)(e)}`);
        return undefined;
    }
}
function $f013fad9dbcce35f$var$tryProcessError(span, error) {
    try {
        span.setStatus({
            status: "error",
            error: (0, $clFsF.isError)(error) ? error : undefined
        });
        if ((0, $hWNsE.isRestError)(error) && error.statusCode) span.setAttribute("http.status_code", error.statusCode);
        span.end();
    } catch (e) {
        (0, $lyjCj.logger).warning(`Skipping tracing span processing due to an error: ${(0, $clFsF.getErrorMessage)(e)}`);
    }
}
function $f013fad9dbcce35f$var$tryProcessResponse(span, response) {
    try {
        span.setAttribute("http.status_code", response.status);
        const serviceRequestId = response.headers.get("x-ms-request-id");
        if (serviceRequestId) span.setAttribute("serviceRequestId", serviceRequestId);
        span.setStatus({
            status: "success"
        });
        span.end();
    } catch (e) {
        (0, $lyjCj.logger).warning(`Skipping tracing span processing due to an error: ${(0, $clFsF.getErrorMessage)(e)}`);
    }
}

});
parcelRegister("fYr8S", function(module, exports) {

$parcel$export(module.exports, "createTracingClient", function () { return (parcelRequire("aI0Y1")).createTracingClient; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $3VXAf = parcelRequire("3VXAf");

var $aI0Y1 = parcelRequire("aI0Y1");

});
parcelRegister("3VXAf", function(module, exports) {

$parcel$export(module.exports, "getInstrumenter", function () { return $2dd4ea09b9b1303b$export$4b530bf07734fa4c; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $f9Lo0 = parcelRequire("f9Lo0");

var $dEL55 = parcelRequire("dEL55");
function $2dd4ea09b9b1303b$export$587b9db4b7c4a6ca() {
    return {
        end: ()=>{
        // noop
        },
        isRecording: ()=>false,
        recordException: ()=>{
        // noop
        },
        setAttribute: ()=>{
        // noop
        },
        setStatus: ()=>{
        // noop
        },
        addEvent: ()=>{
        // noop
        }
    };
}
function $2dd4ea09b9b1303b$export$d5a1a4534f47a56c() {
    return {
        createRequestHeaders: ()=>{
            return {};
        },
        parseTraceparentHeader: ()=>{
            return undefined;
        },
        startSpan: (_name, spanOptions)=>{
            return {
                span: $2dd4ea09b9b1303b$export$587b9db4b7c4a6ca(),
                tracingContext: (0, $f9Lo0.createTracingContext)({
                    parentContext: spanOptions.tracingContext
                })
            };
        },
        withContext (_context, callback, ...callbackArgs) {
            return callback(...callbackArgs);
        }
    };
}
function $2dd4ea09b9b1303b$export$98309c408aedd7b9(instrumenter) {
    (0, $dEL55.state).instrumenterImplementation = instrumenter;
}
function $2dd4ea09b9b1303b$export$4b530bf07734fa4c() {
    if (!(0, $dEL55.state).instrumenterImplementation) (0, $dEL55.state).instrumenterImplementation = $2dd4ea09b9b1303b$export$d5a1a4534f47a56c();
    return (0, $dEL55.state).instrumenterImplementation;
}

});
parcelRegister("f9Lo0", function(module, exports) {

$parcel$export(module.exports, "knownContextKeys", function () { return $b08c742ab1558111$export$49bcd6db97664b30; });
$parcel$export(module.exports, "createTracingContext", function () { return $b08c742ab1558111$export$adc0ba9c4c5a984d; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/** @internal */ const $b08c742ab1558111$export$49bcd6db97664b30 = {
    span: Symbol.for("@azure/core-tracing span"),
    namespace: Symbol.for("@azure/core-tracing namespace")
};
function $b08c742ab1558111$export$adc0ba9c4c5a984d(options = {}) {
    let context = new $b08c742ab1558111$export$ea437edda9257640(options.parentContext);
    if (options.span) context = context.setValue($b08c742ab1558111$export$49bcd6db97664b30.span, options.span);
    if (options.namespace) context = context.setValue($b08c742ab1558111$export$49bcd6db97664b30.namespace, options.namespace);
    return context;
}
class $b08c742ab1558111$export$ea437edda9257640 {
    setValue(key, value) {
        const newContext = new $b08c742ab1558111$export$ea437edda9257640(this);
        newContext._contextMap.set(key, value);
        return newContext;
    }
    getValue(key) {
        return this._contextMap.get(key);
    }
    deleteValue(key) {
        const newContext = new $b08c742ab1558111$export$ea437edda9257640(this);
        newContext._contextMap.delete(key);
        return newContext;
    }
    constructor(initialContext){
        this._contextMap = initialContext instanceof $b08c742ab1558111$export$ea437edda9257640 ? new Map(initialContext._contextMap) : new Map();
    }
}

});

parcelRegister("dEL55", function(module, exports) {

$parcel$export(module.exports, "state", function () { return $9f138820d2bf5e92$export$ca000e230c0caa3e; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Browser-only implementation of the module's state. The browser esm variant will not load the commonjs state, so we do not need to share state between the two.
 */ const $9f138820d2bf5e92$export$ca000e230c0caa3e = {
    instrumenterImplementation: undefined
};

});


parcelRegister("aI0Y1", function(module, exports) {

$parcel$export(module.exports, "createTracingClient", function () { return $7cbec38199791d07$export$3bcb12d844328c5c; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $3VXAf = parcelRequire("3VXAf");

var $f9Lo0 = parcelRequire("f9Lo0");
function $7cbec38199791d07$export$3bcb12d844328c5c(options) {
    const { namespace: namespace, packageName: packageName, packageVersion: packageVersion } = options;
    function startSpan(name, operationOptions, spanOptions) {
        var _a;
        const startSpanResult = (0, $3VXAf.getInstrumenter)().startSpan(name, Object.assign(Object.assign({}, spanOptions), {
            packageName: packageName,
            packageVersion: packageVersion,
            tracingContext: (_a = operationOptions === null || operationOptions === void 0 ? void 0 : operationOptions.tracingOptions) === null || _a === void 0 ? void 0 : _a.tracingContext
        }));
        let tracingContext = startSpanResult.tracingContext;
        const span = startSpanResult.span;
        if (!tracingContext.getValue((0, $f9Lo0.knownContextKeys).namespace)) tracingContext = tracingContext.setValue((0, $f9Lo0.knownContextKeys).namespace, namespace);
        span.setAttribute("az.namespace", tracingContext.getValue((0, $f9Lo0.knownContextKeys).namespace));
        const updatedOptions = Object.assign({}, operationOptions, {
            tracingOptions: Object.assign(Object.assign({}, operationOptions === null || operationOptions === void 0 ? void 0 : operationOptions.tracingOptions), {
                tracingContext: tracingContext
            })
        });
        return {
            span: span,
            updatedOptions: updatedOptions
        };
    }
    async function withSpan(name, operationOptions, callback, spanOptions) {
        const { span: span, updatedOptions: updatedOptions } = startSpan(name, operationOptions, spanOptions);
        try {
            const result = await withContext(updatedOptions.tracingOptions.tracingContext, ()=>Promise.resolve(callback(updatedOptions, span)));
            span.setStatus({
                status: "success"
            });
            return result;
        } catch (err) {
            span.setStatus({
                status: "error",
                error: err
            });
            throw err;
        } finally{
            span.end();
        }
    }
    function withContext(context, callback, ...callbackArgs) {
        return (0, $3VXAf.getInstrumenter)().withContext(context, callback, ...callbackArgs);
    }
    /**
     * Parses a traceparent header value into a span identifier.
     *
     * @param traceparentHeader - The traceparent header to parse.
     * @returns An implementation-specific identifier for the span.
     */ function parseTraceparentHeader(traceparentHeader) {
        return (0, $3VXAf.getInstrumenter)().parseTraceparentHeader(traceparentHeader);
    }
    /**
     * Creates a set of request headers to propagate tracing information to a backend.
     *
     * @param tracingContext - The context containing the span to serialize.
     * @returns The set of headers to add to a request.
     */ function createRequestHeaders(tracingContext) {
        return (0, $3VXAf.getInstrumenter)().createRequestHeaders(tracingContext);
    }
    return {
        startSpan: startSpan,
        withSpan: withSpan,
        withContext: withContext,
        parseTraceparentHeader: parseTraceparentHeader,
        createRequestHeaders: createRequestHeaders
    };
}

});


parcelRegister("hWNsE", function(module, exports) {

$parcel$export(module.exports, "RestError", function () { return $d10e3865eadf846a$export$dc24566375af80f3; });
$parcel$export(module.exports, "isRestError", function () { return $d10e3865eadf846a$export$d5d5fe2886ccec3c; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $clFsF = parcelRequire("clFsF");
parcelRequire("liajr");
var $7L2oc = parcelRequire("7L2oc");

var $6DfW9 = parcelRequire("6DfW9");
const $d10e3865eadf846a$var$errorSanitizer = new (0, $6DfW9.Sanitizer)();
class $d10e3865eadf846a$export$dc24566375af80f3 extends Error {
    /**
     * Logging method for util.inspect in Node
     */ [(0, $7L2oc.custom)]() {
        // Extract non-enumerable properties and add them back. This is OK since in this output the request and
        // response get sanitized.
        return `RestError: ${this.message} \n ${$d10e3865eadf846a$var$errorSanitizer.sanitize(Object.assign(Object.assign({}, this), {
            request: this.request,
            response: this.response
        }))}`;
    }
    constructor(message, options = {}){
        super(message);
        this.name = "RestError";
        this.code = options.code;
        this.statusCode = options.statusCode;
        // The request and response may contain sensitive information in the headers or body.
        // To help prevent this sensitive information being accidentally logged, the request and response
        // properties are marked as non-enumerable here. This prevents them showing up in the output of
        // JSON.stringify and console.log.
        Object.defineProperty(this, "request", {
            value: options.request,
            enumerable: false
        });
        Object.defineProperty(this, "response", {
            value: options.response,
            enumerable: false
        });
        Object.setPrototypeOf(this, $d10e3865eadf846a$export$dc24566375af80f3.prototype);
    }
}
/**
 * Something went wrong when making the request.
 * This means the actual request failed for some reason,
 * such as a DNS issue or the connection being lost.
 */ $d10e3865eadf846a$export$dc24566375af80f3.REQUEST_SEND_ERROR = "REQUEST_SEND_ERROR";
/**
 * This means that parsing the response from the server failed.
 * It may have been malformed.
 */ $d10e3865eadf846a$export$dc24566375af80f3.PARSE_ERROR = "PARSE_ERROR";
function $d10e3865eadf846a$export$d5d5fe2886ccec3c(e) {
    if (e instanceof $d10e3865eadf846a$export$dc24566375af80f3) return true;
    return (0, $clFsF.isError)(e) && e.name === "RestError";
}

});
parcelRegister("liajr", function(module, exports) {
$parcel$export(module.exports, "custom", function () { return (parcelRequire("7L2oc")).custom; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("7L2oc");

});
parcelRegister("7L2oc", function(module, exports) {

$parcel$export(module.exports, "custom", function () { return $5a5ec6abc4a3f32b$export$4c00f665f0d4b443; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
const $5a5ec6abc4a3f32b$export$4c00f665f0d4b443 = {};

});





parcelRegister("2Xcv2", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $jdkRV = parcelRequire("jdkRV");
function $226ac9a5dd8eced9$export$e2b0f951cdeb69f4() {
    return (0, $jdkRV.createFetchHttpClient)();
}

});
parcelRegister("jdkRV", function(module, exports) {

$parcel$export(module.exports, "createFetchHttpClient", function () { return $dfcf6b56711c5fff$export$a30ee91d3082b1b0; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("67uCy");
var $k0hjZ = parcelRequire("k0hjZ");

var $hWNsE = parcelRequire("hWNsE");

var $dTHTy = parcelRequire("dTHTy");

var $gVaZI = parcelRequire("gVaZI");
/**
 * Checks if the body is a Blob or Blob-like
 */ function $dfcf6b56711c5fff$var$isBlob(body) {
    // File objects count as a type of Blob, so we want to use instanceof explicitly
    return (typeof Blob === "function" || typeof Blob === "object") && body instanceof Blob;
}
/**
 * A HttpClient implementation that uses window.fetch to send HTTP requests.
 * @internal
 */ class $dfcf6b56711c5fff$var$FetchHttpClient {
    /**
     * Makes a request over an underlying transport layer and returns the response.
     * @param request - The request to be made.
     */ async sendRequest(request) {
        const url = new URL(request.url);
        const isInsecure = url.protocol !== "https:";
        if (isInsecure && !request.allowInsecureConnection) throw new Error(`Cannot connect to ${request.url} while allowInsecureConnection is false.`);
        if (request.proxySettings) throw new Error("HTTP proxy is not supported in browser environment");
        try {
            return await $dfcf6b56711c5fff$var$makeRequest(request);
        } catch (e) {
            throw $dfcf6b56711c5fff$var$getError(e, request);
        }
    }
}
/**
 * Sends a request
 */ async function $dfcf6b56711c5fff$var$makeRequest(request) {
    const { abortController: abortController, abortControllerCleanup: abortControllerCleanup } = $dfcf6b56711c5fff$var$setupAbortSignal(request);
    try {
        const headers = $dfcf6b56711c5fff$var$buildFetchHeaders(request.headers);
        const { streaming: streaming, body: requestBody } = $dfcf6b56711c5fff$var$buildRequestBody(request);
        const requestInit = Object.assign(Object.assign({
            body: requestBody,
            method: request.method,
            headers: headers,
            signal: abortController.signal
        }, "credentials" in Request.prototype ? {
            credentials: request.withCredentials ? "include" : "same-origin"
        } : {}), "cache" in Request.prototype ? {
            cache: "no-store"
        } : {});
        // According to https://fetch.spec.whatwg.org/#fetch-method,
        // init.duplex must be set when body is a ReadableStream object.
        // currently "half" is the only valid value.
        if (streaming) requestInit.duplex = "half";
        /**
         * Developers of the future:
         * Do not set redirect: "manual" as part
         * of request options.
         * It will not work as you expect.
         */ const response = await fetch(request.url, requestInit);
        // If we're uploading a blob, we need to fire the progress event manually
        if ($dfcf6b56711c5fff$var$isBlob(request.body) && request.onUploadProgress) request.onUploadProgress({
            loadedBytes: request.body.size
        });
        return $dfcf6b56711c5fff$var$buildPipelineResponse(response, request, abortControllerCleanup);
    } catch (e) {
        abortControllerCleanup === null || abortControllerCleanup === void 0 || abortControllerCleanup();
        throw e;
    }
}
/**
 * Creates a pipeline response from a Fetch response;
 */ async function $dfcf6b56711c5fff$var$buildPipelineResponse(httpResponse, request, abortControllerCleanup) {
    var _a, _b;
    const headers = $dfcf6b56711c5fff$var$buildPipelineHeaders(httpResponse);
    const response = {
        request: request,
        headers: headers,
        status: httpResponse.status
    };
    const bodyStream = (0, $gVaZI.isWebReadableStream)(httpResponse.body) ? $dfcf6b56711c5fff$var$buildBodyStream(httpResponse.body, {
        onProgress: request.onDownloadProgress,
        onEnd: abortControllerCleanup
    }) : httpResponse.body;
    if (// Value of POSITIVE_INFINITY in streamResponseStatusCodes is considered as any status code
    ((_a = request.streamResponseStatusCodes) === null || _a === void 0 ? void 0 : _a.has(Number.POSITIVE_INFINITY)) || ((_b = request.streamResponseStatusCodes) === null || _b === void 0 ? void 0 : _b.has(response.status))) {
        if (request.enableBrowserStreams) response.browserStreamBody = bodyStream !== null && bodyStream !== void 0 ? bodyStream : undefined;
        else {
            const responseStream = new Response(bodyStream);
            response.blobBody = responseStream.blob();
            abortControllerCleanup === null || abortControllerCleanup === void 0 || abortControllerCleanup();
        }
    } else {
        const responseStream = new Response(bodyStream);
        response.bodyAsText = await responseStream.text();
        abortControllerCleanup === null || abortControllerCleanup === void 0 || abortControllerCleanup();
    }
    return response;
}
function $dfcf6b56711c5fff$var$setupAbortSignal(request) {
    const abortController = new AbortController();
    // Cleanup function
    let abortControllerCleanup;
    /**
     * Attach an abort listener to the request
     */ let abortListener;
    if (request.abortSignal) {
        if (request.abortSignal.aborted) throw new (0, $k0hjZ.AbortError)("The operation was aborted.");
        abortListener = (event)=>{
            if (event.type === "abort") abortController.abort();
        };
        request.abortSignal.addEventListener("abort", abortListener);
        abortControllerCleanup = ()=>{
            var _a;
            if (abortListener) (_a = request.abortSignal) === null || _a === void 0 || _a.removeEventListener("abort", abortListener);
        };
    }
    // If a timeout was passed, call the abort signal once the time elapses
    if (request.timeout > 0) setTimeout(()=>{
        abortController.abort();
    }, request.timeout);
    return {
        abortController: abortController,
        abortControllerCleanup: abortControllerCleanup
    };
}
/**
 * Gets the specific error
 */ // eslint-disable-next-line @azure/azure-sdk/ts-use-interface-parameters
function $dfcf6b56711c5fff$var$getError(e, request) {
    var _a;
    if (e && (e === null || e === void 0 ? void 0 : e.name) === "AbortError") return e;
    else return new (0, $hWNsE.RestError)(`Error sending request: ${e.message}`, {
        code: (_a = e === null || e === void 0 ? void 0 : e.code) !== null && _a !== void 0 ? _a : (0, $hWNsE.RestError).REQUEST_SEND_ERROR,
        request: request
    });
}
/**
 * Converts PipelineRequest headers to Fetch headers
 */ function $dfcf6b56711c5fff$var$buildFetchHeaders(pipelineHeaders) {
    const headers = new Headers();
    for (const [name, value] of pipelineHeaders)headers.append(name, value);
    return headers;
}
function $dfcf6b56711c5fff$var$buildPipelineHeaders(httpResponse) {
    const responseHeaders = (0, $dTHTy.createHttpHeaders)();
    for (const [name, value] of httpResponse.headers)responseHeaders.set(name, value);
    return responseHeaders;
}
function $dfcf6b56711c5fff$var$buildRequestBody(request) {
    const body = typeof request.body === "function" ? request.body() : request.body;
    if ((0, $gVaZI.isNodeReadableStream)(body)) throw new Error("Node streams are not supported in browser environment.");
    return (0, $gVaZI.isWebReadableStream)(body) ? {
        streaming: true,
        body: $dfcf6b56711c5fff$var$buildBodyStream(body, {
            onProgress: request.onUploadProgress
        })
    } : {
        streaming: false,
        body: body
    };
}
/**
 * Reads the request/response original stream and stream it through a new
 * ReadableStream, this is done to be able to report progress in a way that
 * all modern browsers support. TransformStreams would be an alternative,
 * however they are not yet supported by all browsers i.e Firefox
 */ function $dfcf6b56711c5fff$var$buildBodyStream(readableStream, options = {}) {
    let loadedBytes = 0;
    const { onProgress: onProgress, onEnd: onEnd } = options;
    // If the current browser supports pipeThrough we use a TransformStream
    // to report progress
    if ($dfcf6b56711c5fff$var$isTransformStreamSupported(readableStream)) return readableStream.pipeThrough(new TransformStream({
        transform (chunk, controller) {
            if (chunk === null) {
                controller.terminate();
                return;
            }
            controller.enqueue(chunk);
            loadedBytes += chunk.length;
            if (onProgress) onProgress({
                loadedBytes: loadedBytes
            });
        },
        flush () {
            onEnd === null || onEnd === void 0 || onEnd();
        }
    }));
    else {
        // If we can't use transform streams, wrap the original stream in a new readable stream
        // and use pull to enqueue each chunk and report progress.
        const reader = readableStream.getReader();
        return new ReadableStream({
            async pull (controller) {
                var _a;
                const { done: done, value: value } = await reader.read();
                // When no more data needs to be consumed, break the reading
                if (done || !value) {
                    onEnd === null || onEnd === void 0 || onEnd();
                    // Close the stream
                    controller.close();
                    reader.releaseLock();
                    return;
                }
                loadedBytes += (_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0;
                // Enqueue the next data chunk into our target stream
                controller.enqueue(value);
                if (onProgress) onProgress({
                    loadedBytes: loadedBytes
                });
            },
            cancel (reason) {
                onEnd === null || onEnd === void 0 || onEnd();
                return reader.cancel(reason);
            }
        });
    }
}
function $dfcf6b56711c5fff$export$a30ee91d3082b1b0() {
    return new $dfcf6b56711c5fff$var$FetchHttpClient();
}
function $dfcf6b56711c5fff$var$isTransformStreamSupported(readableStream) {
    return readableStream.pipeThrough !== undefined && self.TransformStream !== undefined;
}

});


parcelRegister("kp5rE", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $dTHTy = parcelRequire("dTHTy");
parcelRequire("bE3zB");
var $hlqzV = parcelRequire("hlqzV");
class $edaa5db7c20b845a$var$PipelineRequestImpl {
    constructor(options){
        var _a, _b, _c, _d, _e, _f, _g;
        this.url = options.url;
        this.body = options.body;
        this.headers = (_a = options.headers) !== null && _a !== void 0 ? _a : (0, $dTHTy.createHttpHeaders)();
        this.method = (_b = options.method) !== null && _b !== void 0 ? _b : "GET";
        this.timeout = (_c = options.timeout) !== null && _c !== void 0 ? _c : 0;
        this.multipartBody = options.multipartBody;
        this.formData = options.formData;
        this.disableKeepAlive = (_d = options.disableKeepAlive) !== null && _d !== void 0 ? _d : false;
        this.proxySettings = options.proxySettings;
        this.streamResponseStatusCodes = options.streamResponseStatusCodes;
        this.withCredentials = (_e = options.withCredentials) !== null && _e !== void 0 ? _e : false;
        this.abortSignal = options.abortSignal;
        this.tracingOptions = options.tracingOptions;
        this.onUploadProgress = options.onUploadProgress;
        this.onDownloadProgress = options.onDownloadProgress;
        this.requestId = options.requestId || (0, $hlqzV.randomUUID)();
        this.allowInsecureConnection = (_f = options.allowInsecureConnection) !== null && _f !== void 0 ? _f : false;
        this.enableBrowserStreams = (_g = options.enableBrowserStreams) !== null && _g !== void 0 ? _g : false;
    }
}
function $edaa5db7c20b845a$export$7a9cd74b232af14e(options) {
    return new $edaa5db7c20b845a$var$PipelineRequestImpl(options);
}

});

parcelRegister("6dZRZ", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $4hN9n = parcelRequire("4hN9n");

var $icUco = parcelRequire("icUco");

var $bcDl2 = parcelRequire("bcDl2");
const $4883f30b64594b46$export$e7b54b771a3962d4 = "exponentialRetryPolicy";
function $4883f30b64594b46$export$ea4ad9056bda1d5f(options = {}) {
    var _a;
    return (0, $icUco.retryPolicy)([
        (0, $4hN9n.exponentialRetryStrategy)(Object.assign(Object.assign({}, options), {
            ignoreSystemErrors: true
        }))
    ], {
        maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT)
    });
}

});

parcelRegister("bbWo5", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $4hN9n = parcelRequire("4hN9n");

var $icUco = parcelRequire("icUco");

var $bcDl2 = parcelRequire("bcDl2");
const $825e035015c99e06$export$ac4948ec3d0d15be = "systemErrorRetryPolicy";
function $825e035015c99e06$export$e41bcf10d1f4d64(options = {}) {
    var _a;
    return {
        name: $825e035015c99e06$export$ac4948ec3d0d15be,
        sendRequest: (0, $icUco.retryPolicy)([
            (0, $4hN9n.exponentialRetryStrategy)(Object.assign(Object.assign({}, options), {
                ignoreHttpStatusCodes: true
            }))
        ], {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT)
        }).sendRequest
    };
}

});

parcelRegister("e5urd", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $7KZDQ = parcelRequire("7KZDQ");

var $icUco = parcelRequire("icUco");

var $bcDl2 = parcelRequire("bcDl2");
const $a41924b00ed516a5$export$c5e6cfdf5d4c923f = "throttlingRetryPolicy";
function $a41924b00ed516a5$export$e497b744d0faff7c(options = {}) {
    var _a;
    return {
        name: $a41924b00ed516a5$export$c5e6cfdf5d4c923f,
        sendRequest: (0, $icUco.retryPolicy)([
            (0, $7KZDQ.throttlingRetryStrategy)()
        ], {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : (0, $bcDl2.DEFAULT_RETRY_POLICY_COUNT)
        }).sendRequest
    };
}

});

parcelRegister("hm3aq", function(module, exports) {

$parcel$export(module.exports, "bearerTokenAuthenticationPolicy", function () { return $ca26f2a5d0fae1fa$export$e5acbbd47d7d0b35; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $o89KP = parcelRequire("o89KP");

var $lyjCj = parcelRequire("lyjCj");

var $hWNsE = parcelRequire("hWNsE");
const $ca26f2a5d0fae1fa$export$2f6555b1e4373019 = "bearerTokenAuthenticationPolicy";
/**
 * Try to send the given request.
 *
 * When a response is received, returns a tuple of the response received and, if the response was received
 * inside a thrown RestError, the RestError that was thrown.
 *
 * Otherwise, if an error was thrown while sending the request that did not provide an underlying response, it
 * will be rethrown.
 */ async function $ca26f2a5d0fae1fa$var$trySendRequest(request, next) {
    try {
        return [
            await next(request),
            undefined
        ];
    } catch (e) {
        if ((0, $hWNsE.isRestError)(e) && e.response) return [
            e.response,
            e
        ];
        else throw e;
    }
}
/**
 * Default authorize request handler
 */ async function $ca26f2a5d0fae1fa$var$defaultAuthorizeRequest(options) {
    const { scopes: scopes, getAccessToken: getAccessToken, request: request } = options;
    // Enable CAE true by default
    const getTokenOptions = {
        abortSignal: request.abortSignal,
        tracingOptions: request.tracingOptions,
        enableCae: true
    };
    const accessToken = await getAccessToken(scopes, getTokenOptions);
    if (accessToken) options.request.headers.set("Authorization", `Bearer ${accessToken.token}`);
}
/**
 * We will retrieve the challenge only if the response status code was 401,
 * and if the response contained the header "WWW-Authenticate" with a non-empty value.
 */ function $ca26f2a5d0fae1fa$var$isChallengeResponse(response) {
    return response.status === 401 && response.headers.has("WWW-Authenticate");
}
/**
 * Re-authorize the request for CAE challenge.
 * The response containing the challenge is `options.response`.
 * If this method returns true, the underlying request will be sent once again.
 */ async function $ca26f2a5d0fae1fa$var$authorizeRequestOnCaeChallenge(onChallengeOptions, caeClaims) {
    var _a;
    const { scopes: scopes } = onChallengeOptions;
    const accessToken = await onChallengeOptions.getAccessToken(scopes, {
        enableCae: true,
        claims: caeClaims
    });
    if (!accessToken) return false;
    onChallengeOptions.request.headers.set("Authorization", `${(_a = accessToken.tokenType) !== null && _a !== void 0 ? _a : "Bearer"} ${accessToken.token}`);
    return true;
}
function $ca26f2a5d0fae1fa$export$e5acbbd47d7d0b35(options) {
    var _a, _b, _c;
    const { credential: credential, scopes: scopes, challengeCallbacks: challengeCallbacks } = options;
    const logger = options.logger || (0, $lyjCj.logger);
    const callbacks = {
        authorizeRequest: (_b = (_a = challengeCallbacks === null || challengeCallbacks === void 0 ? void 0 : challengeCallbacks.authorizeRequest) === null || _a === void 0 ? void 0 : _a.bind(challengeCallbacks)) !== null && _b !== void 0 ? _b : $ca26f2a5d0fae1fa$var$defaultAuthorizeRequest,
        authorizeRequestOnChallenge: (_c = challengeCallbacks === null || challengeCallbacks === void 0 ? void 0 : challengeCallbacks.authorizeRequestOnChallenge) === null || _c === void 0 ? void 0 : _c.bind(challengeCallbacks)
    };
    // This function encapsulates the entire process of reliably retrieving the token
    // The options are left out of the public API until there's demand to configure this.
    // Remember to extend `BearerTokenAuthenticationPolicyOptions` with `TokenCyclerOptions`
    // in order to pass through the `options` object.
    const getAccessToken = credential ? (0, $o89KP.createTokenCycler)(credential /* , options */ ) : ()=>Promise.resolve(null);
    return {
        name: $ca26f2a5d0fae1fa$export$2f6555b1e4373019,
        /**
         * If there's no challenge parameter:
         * - It will try to retrieve the token using the cache, or the credential's getToken.
         * - Then it will try the next policy with or without the retrieved token.
         *
         * It uses the challenge parameters to:
         * - Skip a first attempt to get the token from the credential if there's no cached token,
         *   since it expects the token to be retrievable only after the challenge.
         * - Prepare the outgoing request if the `prepareRequest` method has been provided.
         * - Send an initial request to receive the challenge if it fails.
         * - Process a challenge if the response contains it.
         * - Retrieve a token with the challenge information, then re-send the request.
         */ async sendRequest (request, next) {
            if (!request.url.toLowerCase().startsWith("https://")) throw new Error("Bearer token authentication is not permitted for non-TLS protected (non-https) URLs.");
            await callbacks.authorizeRequest({
                scopes: Array.isArray(scopes) ? scopes : [
                    scopes
                ],
                request: request,
                getAccessToken: getAccessToken,
                logger: logger
            });
            let response;
            let error;
            let shouldSendRequest;
            [response, error] = await $ca26f2a5d0fae1fa$var$trySendRequest(request, next);
            if ($ca26f2a5d0fae1fa$var$isChallengeResponse(response)) {
                let claims = $ca26f2a5d0fae1fa$var$getCaeChallengeClaims(response.headers.get("WWW-Authenticate"));
                // Handle CAE by default when receive CAE claim
                if (claims) {
                    let parsedClaim;
                    // Return the response immediately if claims is not a valid base64 encoded string
                    try {
                        parsedClaim = atob(claims);
                    } catch (e) {
                        logger.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${claims}`);
                        return response;
                    }
                    shouldSendRequest = await $ca26f2a5d0fae1fa$var$authorizeRequestOnCaeChallenge({
                        scopes: Array.isArray(scopes) ? scopes : [
                            scopes
                        ],
                        response: response,
                        request: request,
                        getAccessToken: getAccessToken,
                        logger: logger
                    }, parsedClaim);
                    // Send updated request and handle response for RestError
                    if (shouldSendRequest) [response, error] = await $ca26f2a5d0fae1fa$var$trySendRequest(request, next);
                } else if (callbacks.authorizeRequestOnChallenge) {
                    // Handle custom challenges when client provides custom callback
                    shouldSendRequest = await callbacks.authorizeRequestOnChallenge({
                        scopes: Array.isArray(scopes) ? scopes : [
                            scopes
                        ],
                        request: request,
                        response: response,
                        getAccessToken: getAccessToken,
                        logger: logger
                    });
                    // Send updated request and handle response for RestError
                    if (shouldSendRequest) [response, error] = await $ca26f2a5d0fae1fa$var$trySendRequest(request, next);
                    // If we get another CAE Claim, we will handle it by default and return whatever value we receive for this
                    if ($ca26f2a5d0fae1fa$var$isChallengeResponse(response)) {
                        claims = $ca26f2a5d0fae1fa$var$getCaeChallengeClaims(response.headers.get("WWW-Authenticate"));
                        if (claims) {
                            let parsedClaim;
                            try {
                                parsedClaim = atob(claims);
                            } catch (e) {
                                logger.warning(`The WWW-Authenticate header contains "claims" that cannot be parsed. Unable to perform the Continuous Access Evaluation authentication flow. Unparsable claims: ${claims}`);
                                return response;
                            }
                            shouldSendRequest = await $ca26f2a5d0fae1fa$var$authorizeRequestOnCaeChallenge({
                                scopes: Array.isArray(scopes) ? scopes : [
                                    scopes
                                ],
                                response: response,
                                request: request,
                                getAccessToken: getAccessToken,
                                logger: logger
                            }, parsedClaim);
                            // Send updated request and handle response for RestError
                            if (shouldSendRequest) [response, error] = await $ca26f2a5d0fae1fa$var$trySendRequest(request, next);
                        }
                    }
                }
            }
            if (error) throw error;
            else return response;
        }
    };
}
function $ca26f2a5d0fae1fa$export$196b61f4919b632(challenges) {
    // Challenge regex seperates the string to individual challenges with different schemes in the format `Scheme a="b", c=d`
    // The challenge regex captures parameteres with either quotes values or unquoted values
    const challengeRegex = /(\w+)\s+((?:\w+=(?:"[^"]*"|[^,]*),?\s*)+)/g;
    // Parameter regex captures the claims group removed from the scheme in the format `a="b"` and `c="d"`
    // CAE challenge always have quoted parameters. For more reference, https://learn.microsoft.com/entra/identity-platform/claims-challenge
    const paramRegex = /(\w+)="([^"]*)"/g;
    const parsedChallenges = [];
    let match;
    // Iterate over each challenge match
    while((match = challengeRegex.exec(challenges)) !== null){
        const scheme = match[1];
        const paramsString = match[2];
        const params = {};
        let paramMatch;
        // Iterate over each parameter match
        while((paramMatch = paramRegex.exec(paramsString)) !== null)params[paramMatch[1]] = paramMatch[2];
        parsedChallenges.push({
            scheme: scheme,
            params: params
        });
    }
    return parsedChallenges;
}
/**
 * Parse a pipeline response and look for a CAE challenge with "Bearer" scheme
 * Return the value in the header without parsing the challenge
 * @internal
 */ function $ca26f2a5d0fae1fa$var$getCaeChallengeClaims(challenges) {
    var _a;
    if (!challenges) return;
    // Find all challenges present in the header
    const parsedChallenges = $ca26f2a5d0fae1fa$export$196b61f4919b632(challenges);
    return (_a = parsedChallenges.find((x)=>x.scheme === "Bearer" && x.params.claims && x.params.error === "insufficient_claims")) === null || _a === void 0 ? void 0 : _a.params.claims;
}

});
parcelRegister("o89KP", function(module, exports) {

$parcel$export(module.exports, "createTokenCycler", function () { return $048891aeb2ef1f5f$export$95b8567f1f70eca; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $i7WyN = parcelRequire("i7WyN");
const $048891aeb2ef1f5f$export$52bca39539a4d010 = {
    forcedRefreshWindowInMs: 1000,
    retryIntervalInMs: 3000,
    refreshWindowInMs: 120000
};
/**
 * Converts an an unreliable access token getter (which may resolve with null)
 * into an AccessTokenGetter by retrying the unreliable getter in a regular
 * interval.
 *
 * @param getAccessToken - A function that produces a promise of an access token that may fail by returning null.
 * @param retryIntervalInMs - The time (in milliseconds) to wait between retry attempts.
 * @param refreshTimeout - The timestamp after which the refresh attempt will fail, throwing an exception.
 * @returns - A promise that, if it resolves, will resolve with an access token.
 */ async function $048891aeb2ef1f5f$var$beginRefresh(getAccessToken, retryIntervalInMs, refreshTimeout) {
    // This wrapper handles exceptions gracefully as long as we haven't exceeded
    // the timeout.
    async function tryGetAccessToken() {
        if (Date.now() < refreshTimeout) try {
            return await getAccessToken();
        } catch (_a) {
            return null;
        }
        else {
            const finalToken = await getAccessToken();
            // Timeout is up, so throw if it's still null
            if (finalToken === null) throw new Error("Failed to refresh access token.");
            return finalToken;
        }
    }
    let token = await tryGetAccessToken();
    while(token === null){
        await (0, $i7WyN.delay)(retryIntervalInMs);
        token = await tryGetAccessToken();
    }
    return token;
}
function $048891aeb2ef1f5f$export$95b8567f1f70eca(credential, tokenCyclerOptions) {
    let refreshWorker = null;
    let token = null;
    let tenantId;
    const options = Object.assign(Object.assign({}, $048891aeb2ef1f5f$export$52bca39539a4d010), tokenCyclerOptions);
    /**
     * This little holder defines several predicates that we use to construct
     * the rules of refreshing the token.
     */ const cycler = {
        /**
         * Produces true if a refresh job is currently in progress.
         */ get isRefreshing () {
            return refreshWorker !== null;
        },
        /**
         * Produces true if the cycler SHOULD refresh (we are within the refresh
         * window and not already refreshing)
         */ get shouldRefresh () {
            var _a;
            if (cycler.isRefreshing) return false;
            if ((token === null || token === void 0 ? void 0 : token.refreshAfterTimestamp) && token.refreshAfterTimestamp < Date.now()) return true;
            return ((_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : 0) - options.refreshWindowInMs < Date.now();
        },
        /**
         * Produces true if the cycler MUST refresh (null or nearly-expired
         * token).
         */ get mustRefresh () {
            return token === null || token.expiresOnTimestamp - options.forcedRefreshWindowInMs < Date.now();
        }
    };
    /**
     * Starts a refresh job or returns the existing job if one is already
     * running.
     */ function refresh(scopes, getTokenOptions) {
        var _a;
        if (!cycler.isRefreshing) {
            // We bind `scopes` here to avoid passing it around a lot
            const tryGetAccessToken = ()=>credential.getToken(scopes, getTokenOptions);
            // Take advantage of promise chaining to insert an assignment to `token`
            // before the refresh can be considered done.
            refreshWorker = $048891aeb2ef1f5f$var$beginRefresh(tryGetAccessToken, options.retryIntervalInMs, // If we don't have a token, then we should timeout immediately
            (_a = token === null || token === void 0 ? void 0 : token.expiresOnTimestamp) !== null && _a !== void 0 ? _a : Date.now()).then((_token)=>{
                refreshWorker = null;
                token = _token;
                tenantId = getTokenOptions.tenantId;
                return token;
            }).catch((reason)=>{
                // We also should reset the refresher if we enter a failed state.  All
                // existing awaiters will throw, but subsequent requests will start a
                // new retry chain.
                refreshWorker = null;
                token = null;
                tenantId = undefined;
                throw reason;
            });
        }
        return refreshWorker;
    }
    return async (scopes, tokenOptions)=>{
        //
        // Simple rules:
        // - If we MUST refresh, then return the refresh task, blocking
        //   the pipeline until a token is available.
        // - If we SHOULD refresh, then run refresh but don't return it
        //   (we can still use the cached token).
        // - Return the token, since it's fine if we didn't return in
        //   step 1.
        //
        const hasClaimChallenge = Boolean(tokenOptions.claims);
        const tenantIdChanged = tenantId !== tokenOptions.tenantId;
        if (hasClaimChallenge) // If we've received a claim, we know the existing token isn't valid
        // We want to clear it so that that refresh worker won't use the old expiration time as a timeout
        token = null;
        // If the tenantId passed in token options is different to the one we have
        // Or if we are in claim challenge and the token was rejected and a new access token need to be issued, we need to
        // refresh the token with the new tenantId or token.
        const mustRefresh = tenantIdChanged || hasClaimChallenge || cycler.mustRefresh;
        if (mustRefresh) return refresh(scopes, tokenOptions);
        if (cycler.shouldRefresh) refresh(scopes, tokenOptions);
        return token;
    };
}

});


parcelRegister("3Ie3S", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * The programmatic identifier of the ndJsonPolicy.
 */ const $2b40637612191782$export$c027970a93d19ddb = "ndJsonPolicy";
function $2b40637612191782$export$fb7e2fcfb4c00771() {
    return {
        name: $2b40637612191782$export$c027970a93d19ddb,
        async sendRequest (request, next) {
            // There currently isn't a good way to bypass the serializer
            if (typeof request.body === "string" && request.body.startsWith("[")) {
                const body = JSON.parse(request.body);
                if (Array.isArray(body)) request.body = body.map((item)=>JSON.stringify(item) + "\n").join("");
            }
            return next(request);
        }
    };
}

});

parcelRegister("cBfCi", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

var $o89KP = parcelRequire("o89KP");

var $lyjCj = parcelRequire("lyjCj");
const $92c50de522ec4c89$export$346034fd5ab68f49 = "auxiliaryAuthenticationHeaderPolicy";
const $92c50de522ec4c89$var$AUTHORIZATION_AUXILIARY_HEADER = "x-ms-authorization-auxiliary";
async function $92c50de522ec4c89$var$sendAuthorizeRequest(options) {
    var _a, _b;
    const { scopes: scopes, getAccessToken: getAccessToken, request: request } = options;
    const getTokenOptions = {
        abortSignal: request.abortSignal,
        tracingOptions: request.tracingOptions
    };
    return (_b = (_a = await getAccessToken(scopes, getTokenOptions)) === null || _a === void 0 ? void 0 : _a.token) !== null && _b !== void 0 ? _b : "";
}
function $92c50de522ec4c89$export$9b68b9528118c959(options) {
    const { credentials: credentials, scopes: scopes } = options;
    const logger = options.logger || (0, $lyjCj.logger);
    const tokenCyclerMap = new WeakMap();
    return {
        name: $92c50de522ec4c89$export$346034fd5ab68f49,
        async sendRequest (request, next) {
            if (!request.url.toLowerCase().startsWith("https://")) throw new Error("Bearer token authentication for auxiliary header is not permitted for non-TLS protected (non-https) URLs.");
            if (!credentials || credentials.length === 0) {
                logger.info(`${$92c50de522ec4c89$export$346034fd5ab68f49} header will not be set due to empty credentials.`);
                return next(request);
            }
            const tokenPromises = [];
            for (const credential of credentials){
                let getAccessToken = tokenCyclerMap.get(credential);
                if (!getAccessToken) {
                    getAccessToken = (0, $o89KP.createTokenCycler)(credential);
                    tokenCyclerMap.set(credential, getAccessToken);
                }
                tokenPromises.push($92c50de522ec4c89$var$sendAuthorizeRequest({
                    scopes: Array.isArray(scopes) ? scopes : [
                        scopes
                    ],
                    request: request,
                    getAccessToken: getAccessToken,
                    logger: logger
                }));
            }
            const auxiliaryTokens = (await Promise.all(tokenPromises)).filter((token)=>Boolean(token));
            if (auxiliaryTokens.length === 0) {
                logger.warning(`None of the auxiliary tokens are valid. ${$92c50de522ec4c89$var$AUTHORIZATION_AUXILIARY_HEADER} header will not be set.`);
                return next(request);
            }
            request.headers.set($92c50de522ec4c89$var$AUTHORIZATION_AUXILIARY_HEADER, auxiliaryTokens.map((token)=>`Bearer ${token}`).join(", "));
            return next(request);
        }
    };
}

});


parcelRegister("lcjrn", function(module, exports) {

$parcel$export(module.exports, "AzureKeyCredential", function () { return (parcelRequire("aBc7N")).AzureKeyCredential; });
$parcel$export(module.exports, "isTokenCredential", function () { return (parcelRequire("8oaPc")).isTokenCredential; });

var $aBc7N = parcelRequire("aBc7N");

var $fib7G = parcelRequire("fib7G");

var $hNCzN = parcelRequire("hNCzN");

var $5MCLS = parcelRequire("5MCLS");

var $8oaPc = parcelRequire("8oaPc");

});
parcelRegister("aBc7N", function(module, exports) {

$parcel$export(module.exports, "AzureKeyCredential", function () { return $7b76c3d02e64d936$export$e7599249a400e127; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * A static-key-based credential that supports updating
 * the underlying key value.
 */ class $7b76c3d02e64d936$export$e7599249a400e127 {
    /**
     * The value of the key to be used in authentication
     */ get key() {
        return this._key;
    }
    /**
     * Change the value of the key.
     *
     * Updates will take effect upon the next request after
     * updating the key value.
     *
     * @param newKey - The new key value to be used
     */ update(newKey) {
        this._key = newKey;
    }
    /**
     * Create an instance of an AzureKeyCredential for use
     * with a service client.
     *
     * @param key - The initial value of the key to use in authentication
     */ constructor(key){
        if (!key) throw new Error("key must be a non-empty string");
        this._key = key;
    }
}

});

parcelRegister("fib7G", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $64Qq6 = parcelRequire("64Qq6");
function $b2212a38ac0dd9c0$export$93db782c5b7ac3a(credential) {
    return (0, $64Qq6.isObjectWithProperties)(credential, [
        "key"
    ]) && typeof credential.key === "string";
}

});

parcelRegister("hNCzN", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $64Qq6 = parcelRequire("64Qq6");
class $cf54efbe1aedfcfa$export$f435da19f94fed78 {
    /**
     * The value of the key to be used in authentication.
     */ get key() {
        return this._key;
    }
    /**
     * The value of the name to be used in authentication.
     */ get name() {
        return this._name;
    }
    /**
     * Change the value of the key.
     *
     * Updates will take effect upon the next request after
     * updating the key value.
     *
     * @param newName - The new name value to be used.
     * @param newKey - The new key value to be used.
     */ update(newName, newKey) {
        if (!newName || !newKey) throw new TypeError("newName and newKey must be non-empty strings");
        this._name = newName;
        this._key = newKey;
    }
    /**
     * Create an instance of an AzureNamedKeyCredential for use
     * with a service client.
     *
     * @param name - The initial value of the name to use in authentication.
     * @param key - The initial value of the key to use in authentication.
     */ constructor(name, key){
        if (!name || !key) throw new TypeError("name and key must be non-empty strings");
        this._name = name;
        this._key = key;
    }
}
function $cf54efbe1aedfcfa$export$9117b72f7d656ea5(credential) {
    return (0, $64Qq6.isObjectWithProperties)(credential, [
        "name",
        "key"
    ]) && typeof credential.key === "string" && typeof credential.name === "string";
}

});

parcelRegister("5MCLS", function(module, exports) {
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
parcelRequire("bE3zB");
var $64Qq6 = parcelRequire("64Qq6");
class $435f829926494c96$export$144d569f55afc767 {
    /**
     * The value of the shared access signature to be used in authentication
     */ get signature() {
        return this._signature;
    }
    /**
     * Change the value of the signature.
     *
     * Updates will take effect upon the next request after
     * updating the signature value.
     *
     * @param newSignature - The new shared access signature value to be used
     */ update(newSignature) {
        if (!newSignature) throw new Error("shared access signature must be a non-empty string");
        this._signature = newSignature;
    }
    /**
     * Create an instance of an AzureSASCredential for use
     * with a service client.
     *
     * @param signature - The initial value of the shared access signature to use in authentication
     */ constructor(signature){
        if (!signature) throw new Error("shared access signature must be a non-empty string");
        this._signature = signature;
    }
}
function $435f829926494c96$export$3b616d4df4414a6e(credential) {
    return (0, $64Qq6.isObjectWithProperties)(credential, [
        "signature"
    ]) && typeof credential.signature === "string";
}

});

parcelRegister("8oaPc", function(module, exports) {

$parcel$export(module.exports, "isTokenCredential", function () { return $61b8f637b854bbee$export$59ba6af2e517603a; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * @internal
 * @param accessToken - Access token
 * @returns Whether a token is bearer type or not
 */ function $61b8f637b854bbee$export$5ce6dad1a9b7e63a(accessToken) {
    return !accessToken.tokenType || accessToken.tokenType === "Bearer";
}
function $61b8f637b854bbee$export$7bc0db98fbe3be86(accessToken) {
    return accessToken.tokenType === "pop";
}
function $61b8f637b854bbee$export$59ba6af2e517603a(credential) {
    // Check for an object with a 'getToken' function and possibly with
    // a 'signRequest' function.  We do this check to make sure that
    // a ServiceClientCredentials implementor (like TokenClientCredentials
    // in ms-rest-nodeauth) doesn't get mistaken for a TokenCredential if
    // it doesn't actually implement TokenCredential also.
    const castCredential = credential;
    return castCredential && typeof castCredential.getToken === "function" && (castCredential.signRequest === undefined || castCredential.getToken.length > 0);
}

});



parcelRegister("iq7xE", function(module, exports) {

$parcel$export(module.exports, "isKeyCredential", function () { return $d69081558b561717$export$93db782c5b7ac3a; });
$parcel$export(module.exports, "parseClientArguments", function () { return $d69081558b561717$export$bd3001b1c66d2920; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
parcelRequire("lcjrn");
var $8oaPc = parcelRequire("8oaPc");

var $cyqTy = parcelRequire("cyqTy");
const $d69081558b561717$var$isValidEndpoint = (host)=>{
    var _a;
    const url = new URL(host);
    return !!((_a = url.protocol) === null || _a === void 0 ? void 0 : _a.match(/^http[s]?/)) && url.host !== undefined && url.host !== "" && (url.pathname === undefined || url.pathname === "" || url.pathname === "/");
};
const $d69081558b561717$var$assertValidEndpoint = (host)=>{
    if (!$d69081558b561717$var$isValidEndpoint(host)) throw new Error(`Invalid endpoint url ${host}`);
};
const $d69081558b561717$export$93db782c5b7ac3a = (credential)=>{
    const castCredential = credential;
    return castCredential && typeof castCredential.key === "string" && castCredential.getToken === undefined;
};
const $d69081558b561717$export$bd3001b1c66d2920 = (connectionStringOrUrl, credentialOrOptions)=>{
    if ($d69081558b561717$export$93db782c5b7ac3a(credentialOrOptions) || (0, $8oaPc.isTokenCredential)(credentialOrOptions)) {
        $d69081558b561717$var$assertValidEndpoint(connectionStringOrUrl);
        return {
            url: connectionStringOrUrl,
            credential: credentialOrOptions
        };
    } else {
        const { endpoint: host, credential: credential } = (0, $cyqTy.parseConnectionString)(connectionStringOrUrl);
        $d69081558b561717$var$assertValidEndpoint(host);
        return {
            url: host,
            credential: credential
        };
    }
};

});
parcelRegister("cyqTy", function(module, exports) {

$parcel$export(module.exports, "parseConnectionString", function () { return $923d85cff95fdae2$export$6369f286b474466d; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
parcelRequire("lcjrn");
var $aBc7N = parcelRequire("aBc7N");
// TODO: update when connection string format is finalized
const $923d85cff95fdae2$var$CONNECTION_STRING_REGEX = /endpoint=(.*);accesskey=(.*)/i;
const $923d85cff95fdae2$var$tryParseConnectionString = (s)=>{
    const match = s.match($923d85cff95fdae2$var$CONNECTION_STRING_REGEX);
    if ((match === null || match === void 0 ? void 0 : match[1]) && match[2]) return {
        endpoint: match[1],
        credential: new (0, $aBc7N.AzureKeyCredential)(match[2])
    };
    return undefined;
};
const $923d85cff95fdae2$export$6369f286b474466d = (connectionString)=>{
    const parsedConnectionString = $923d85cff95fdae2$var$tryParseConnectionString(connectionString);
    if (parsedConnectionString) return parsedConnectionString;
    else throw new Error(`Invalid connection string ${connectionString}`);
};

});



parcelRegister("jYWbT", function(module, exports) {

$parcel$export(module.exports, "isCommunicationUserIdentifier", function () { return $e8c0c269cd28a991$export$ed0a5d450cf32a88; });
$parcel$export(module.exports, "isPhoneNumberIdentifier", function () { return $e8c0c269cd28a991$export$39731aad52bd869e; });
$parcel$export(module.exports, "isMicrosoftTeamsUserIdentifier", function () { return $e8c0c269cd28a991$export$f752f7373263f6ad; });
$parcel$export(module.exports, "isMicrosoftTeamsAppIdentifier", function () { return $e8c0c269cd28a991$export$e599bb3a2104862c; });
$parcel$export(module.exports, "isUnknownIdentifier", function () { return $e8c0c269cd28a991$export$c79864de434f1ab5; });
$parcel$export(module.exports, "getIdentifierKind", function () { return $e8c0c269cd28a991$export$fa8b44b3b2112e4b; });
$parcel$export(module.exports, "getIdentifierRawId", function () { return $e8c0c269cd28a991$export$a4be3d7030994150; });
$parcel$export(module.exports, "createIdentifierFromRawId", function () { return $e8c0c269cd28a991$export$ed7ba09f189aff30; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Tests an Identifier to determine whether it implements CommunicationUserIdentifier.
 *
 * @param identifier - The assumed CommunicationUserIdentifier to be tested.
 */ const $e8c0c269cd28a991$export$ed0a5d450cf32a88 = (identifier)=>{
    return typeof identifier.communicationUserId === "string";
};
const $e8c0c269cd28a991$export$39731aad52bd869e = (identifier)=>{
    return typeof identifier.phoneNumber === "string";
};
const $e8c0c269cd28a991$export$f752f7373263f6ad = (identifier)=>{
    return typeof identifier.microsoftTeamsUserId === "string";
};
const $e8c0c269cd28a991$export$e599bb3a2104862c = (identifier)=>{
    return typeof identifier.teamsAppId === "string";
};
const $e8c0c269cd28a991$export$c79864de434f1ab5 = (identifier)=>{
    return typeof identifier.id === "string";
};
const $e8c0c269cd28a991$export$fa8b44b3b2112e4b = (identifier)=>{
    if ($e8c0c269cd28a991$export$ed0a5d450cf32a88(identifier)) return Object.assign(Object.assign({}, identifier), {
        kind: "communicationUser"
    });
    if ($e8c0c269cd28a991$export$39731aad52bd869e(identifier)) return Object.assign(Object.assign({}, identifier), {
        kind: "phoneNumber"
    });
    if ($e8c0c269cd28a991$export$f752f7373263f6ad(identifier)) return Object.assign(Object.assign({}, identifier), {
        kind: "microsoftTeamsUser"
    });
    if ($e8c0c269cd28a991$export$e599bb3a2104862c(identifier)) return Object.assign(Object.assign({}, identifier), {
        kind: "microsoftTeamsApp"
    });
    return Object.assign(Object.assign({}, identifier), {
        kind: "unknown"
    });
};
const $e8c0c269cd28a991$export$a4be3d7030994150 = (identifier)=>{
    const identifierKind = $e8c0c269cd28a991$export$fa8b44b3b2112e4b(identifier);
    switch(identifierKind.kind){
        case "communicationUser":
            return identifierKind.communicationUserId;
        case "microsoftTeamsUser":
            {
                const { microsoftTeamsUserId: microsoftTeamsUserId, rawId: rawId, cloud: cloud, isAnonymous: isAnonymous } = identifierKind;
                if (rawId) return rawId;
                if (isAnonymous) return `8:teamsvisitor:${microsoftTeamsUserId}`;
                switch(cloud){
                    case "dod":
                        return `8:dod:${microsoftTeamsUserId}`;
                    case "gcch":
                        return `8:gcch:${microsoftTeamsUserId}`;
                    case "public":
                        return `8:orgid:${microsoftTeamsUserId}`;
                }
                return `8:orgid:${microsoftTeamsUserId}`;
            }
        case "microsoftTeamsApp":
            {
                const { teamsAppId: teamsAppId, rawId: rawId, cloud: cloud } = identifierKind;
                if (rawId) return rawId;
                switch(cloud){
                    case "dod":
                        return `28:dod:${teamsAppId}`;
                    case "gcch":
                        return `28:gcch:${teamsAppId}`;
                }
                return `28:orgid:${teamsAppId}`;
            }
        case "phoneNumber":
            {
                const { phoneNumber: phoneNumber, rawId: rawId } = identifierKind;
                if (rawId) return rawId;
                return `4:${phoneNumber}`;
            }
        case "unknown":
            return identifierKind.id;
    }
};
const $e8c0c269cd28a991$var$buildMicrosoftTeamsAppIdentifier = (teamsAppId, cloud)=>{
    return {
        kind: "microsoftTeamsApp",
        teamsAppId: teamsAppId,
        cloud: cloud
    };
};
const $e8c0c269cd28a991$var$buildMicrosoftTeamsUserIdentifier = (id, cloud, isAnonymous)=>{
    return {
        kind: "microsoftTeamsUser",
        microsoftTeamsUserId: id,
        isAnonymous: isAnonymous,
        cloud: cloud
    };
};
const $e8c0c269cd28a991$export$ed7ba09f189aff30 = (rawId)=>{
    if (rawId.startsWith("4:")) return {
        kind: "phoneNumber",
        phoneNumber: `${rawId.substring(2)}`
    };
    const segments = rawId.split(":");
    if (segments.length !== 3) return {
        kind: "unknown",
        id: rawId
    };
    const prefix = `${segments[0]}:${segments[1]}:`;
    const suffix = segments[2];
    switch(prefix){
        case "8:teamsvisitor:":
            return {
                kind: "microsoftTeamsUser",
                microsoftTeamsUserId: suffix,
                isAnonymous: true
            };
        case "8:orgid:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsUserIdentifier(suffix, "public", false);
        case "8:dod:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsUserIdentifier(suffix, "dod", false);
        case "8:gcch:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsUserIdentifier(suffix, "gcch", false);
        case "8:acs:":
        case "8:spool:":
        case "8:dod-acs:":
        case "8:gcch-acs:":
            return {
                kind: "communicationUser",
                communicationUserId: rawId
            };
        case "28:orgid:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsAppIdentifier(suffix, "public");
        case "28:gcch:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsAppIdentifier(suffix, "gcch");
        case "28:dod:":
            return $e8c0c269cd28a991$var$buildMicrosoftTeamsAppIdentifier(suffix, "dod");
    }
    return {
        kind: "unknown",
        id: rawId
    };
};

});

parcelRegister("eDFD7", function(module, exports) {

$parcel$export(module.exports, "serializeCommunicationIdentifier", function () { return $aa850011cd6bdb64$export$d2fd9cf4e1907ae2; });
$parcel$export(module.exports, "deserializeCommunicationIdentifier", function () { return $aa850011cd6bdb64$export$43f9cc38b242210c; });
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

var $jYWbT = parcelRequire("jYWbT");
const $aa850011cd6bdb64$var$assertNotNullOrUndefined = (obj, prop)=>{
    const subObjName = Object.keys(obj)[0];
    const subObj = obj[subObjName];
    if (prop in subObj) return subObj[prop];
    throw new Error(`Property ${prop} is required for identifier of type ${subObjName}.`);
};
const $aa850011cd6bdb64$var$assertMaximumOneNestedModel = (identifier)=>{
    const presentProperties = [];
    if (identifier.communicationUser !== undefined) presentProperties.push("communicationUser");
    if (identifier.microsoftTeamsUser !== undefined) presentProperties.push("microsoftTeamsUser");
    if (identifier.microsoftTeamsApp !== undefined) presentProperties.push("microsoftTeamsApp");
    if (identifier.phoneNumber !== undefined) presentProperties.push("phoneNumber");
    if (presentProperties.length > 1) throw new Error(`Only one of the properties in ${JSON.stringify(presentProperties)} should be present.`);
};
const $aa850011cd6bdb64$export$d2fd9cf4e1907ae2 = (identifier)=>{
    var _a, _b, _c, _d, _e, _f;
    const identifierKind = (0, $jYWbT.getIdentifierKind)(identifier);
    switch(identifierKind.kind){
        case "communicationUser":
            return {
                rawId: (0, $jYWbT.getIdentifierRawId)(identifierKind),
                communicationUser: {
                    id: identifierKind.communicationUserId
                }
            };
        case "phoneNumber":
            return {
                rawId: (_a = identifierKind.rawId) !== null && _a !== void 0 ? _a : (0, $jYWbT.getIdentifierRawId)(identifierKind),
                phoneNumber: {
                    value: identifierKind.phoneNumber
                }
            };
        case "microsoftTeamsUser":
            return {
                rawId: (_b = identifierKind.rawId) !== null && _b !== void 0 ? _b : (0, $jYWbT.getIdentifierRawId)(identifierKind),
                microsoftTeamsUser: {
                    userId: identifierKind.microsoftTeamsUserId,
                    isAnonymous: (_c = identifierKind.isAnonymous) !== null && _c !== void 0 ? _c : false,
                    cloud: (_d = identifierKind.cloud) !== null && _d !== void 0 ? _d : "public"
                }
            };
        case "microsoftTeamsApp":
            return {
                rawId: (_e = identifierKind.rawId) !== null && _e !== void 0 ? _e : (0, $jYWbT.getIdentifierRawId)(identifierKind),
                microsoftTeamsApp: {
                    appId: identifierKind.teamsAppId,
                    cloud: (_f = identifierKind.cloud) !== null && _f !== void 0 ? _f : "public"
                }
            };
        case "unknown":
            return {
                rawId: identifierKind.id
            };
        default:
            throw new Error(`Can't serialize an identifier with kind ${identifierKind.kind}`);
    }
};
const $aa850011cd6bdb64$var$getKind = (serializedIdentifier)=>{
    if (serializedIdentifier.communicationUser) return "communicationUser";
    if (serializedIdentifier.phoneNumber) return "phoneNumber";
    if (serializedIdentifier.microsoftTeamsUser) return "microsoftTeamsUser";
    if (serializedIdentifier.microsoftTeamsApp) return "microsoftTeamsApp";
    return "unknown";
};
const $aa850011cd6bdb64$export$43f9cc38b242210c = (serializedIdentifier)=>{
    var _a;
    $aa850011cd6bdb64$var$assertMaximumOneNestedModel(serializedIdentifier);
    const { communicationUser: communicationUser, microsoftTeamsUser: microsoftTeamsUser, microsoftTeamsApp: microsoftTeamsApp, phoneNumber: phoneNumber } = serializedIdentifier;
    const kind = (_a = serializedIdentifier.kind) !== null && _a !== void 0 ? _a : $aa850011cd6bdb64$var$getKind(serializedIdentifier);
    if (kind === "communicationUser" && communicationUser) return {
        kind: "communicationUser",
        communicationUserId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            communicationUser: communicationUser
        }, "id")
    };
    if (kind === "phoneNumber" && phoneNumber) return {
        kind: "phoneNumber",
        phoneNumber: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            phoneNumber: phoneNumber
        }, "value"),
        rawId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            phoneNumber: serializedIdentifier
        }, "rawId")
    };
    if (kind === "microsoftTeamsUser" && microsoftTeamsUser) return {
        kind: "microsoftTeamsUser",
        microsoftTeamsUserId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsUser: microsoftTeamsUser
        }, "userId"),
        isAnonymous: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsUser: microsoftTeamsUser
        }, "isAnonymous"),
        cloud: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsUser: microsoftTeamsUser
        }, "cloud"),
        rawId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsUser: serializedIdentifier
        }, "rawId")
    };
    if (kind === "microsoftTeamsApp" && microsoftTeamsApp) return {
        kind: "microsoftTeamsApp",
        teamsAppId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsApp: microsoftTeamsApp
        }, "appId"),
        cloud: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsApp: microsoftTeamsApp
        }, "cloud"),
        rawId: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            microsoftTeamsApp: serializedIdentifier
        }, "rawId")
    };
    return {
        kind: "unknown",
        id: $aa850011cd6bdb64$var$assertNotNullOrUndefined({
            unknown: serializedIdentifier
        }, "rawId")
    };
};

});



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
var $5644a0fb91926e5b$export$882461b6382ed46c;
var $5644a0fb91926e5b$export$757ceba2d55c277e;
"use strict";

var $e4ZGj = parcelRequire("e4ZGj");
var $5644a0fb91926e5b$var$i;
$5644a0fb91926e5b$export$882461b6382ed46c = $e4ZGj.createRoot;
$5644a0fb91926e5b$export$757ceba2d55c277e = $e4ZGj.hydrateRoot;



var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $eZVvM = parcelRequire("eZVvM");
// src/index.ts

var $eZVvM = parcelRequire("eZVvM");
var $65cdbf7f8217658a$exports = {};
"use strict";

$65cdbf7f8217658a$exports = (parcelRequire("9H773"));


var $e2346a360d18792d$var$React = // prettier-ignore
// @ts-ignore
"default" in $eZVvM ? $eZVvM["default"] : $eZVvM;
// src/components/Context.ts
var $e2346a360d18792d$var$ContextKey = Symbol.for(`react-redux-context`);
var $e2346a360d18792d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $e2346a360d18792d$var$getContext() {
    if (!$e2346a360d18792d$var$React.createContext) return {};
    var _gT_ContextKey;
    const contextMap = (_gT_ContextKey = $e2346a360d18792d$var$gT[$e2346a360d18792d$var$ContextKey]) !== null && _gT_ContextKey !== void 0 ? _gT_ContextKey : $e2346a360d18792d$var$gT[$e2346a360d18792d$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($e2346a360d18792d$var$React.createContext);
    if (!realContext) {
        realContext = $e2346a360d18792d$var$React.createContext(null);
        contextMap.set($e2346a360d18792d$var$React.createContext, realContext);
    }
    return realContext;
}
var $e2346a360d18792d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $e2346a360d18792d$var$getContext();
// src/utils/useSyncExternalStore.ts
var $e2346a360d18792d$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $e2346a360d18792d$var$createReduxContextHook(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $e2346a360d18792d$var$React.useContext(context);
        return contextValue;
    };
}
var $e2346a360d18792d$var$useReduxContext = /* @__PURE__ */ $e2346a360d18792d$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $e2346a360d18792d$var$useSyncExternalStoreWithSelector = $e2346a360d18792d$var$notInitialized;
var $e2346a360d18792d$var$initializeUseSelector = (fn)=>{
    $e2346a360d18792d$var$useSyncExternalStoreWithSelector = fn;
};
var $e2346a360d18792d$var$refEquality = (a, b)=>a === b;
function $e2346a360d18792d$export$2b53f90d2bd1cbfb(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$var$useReduxContext : $e2346a360d18792d$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $e2346a360d18792d$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $e2346a360d18792d$var$React.useRef(true);
        const wrappedSelector = $e2346a360d18792d$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $e2346a360d18792d$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $e2346a360d18792d$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $e2346a360d18792d$export$2105062e25df4afe = /* @__PURE__ */ $e2346a360d18792d$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $e2346a360d18792d$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $e2346a360d18792d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $e2346a360d18792d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $e2346a360d18792d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $e2346a360d18792d$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $e2346a360d18792d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $e2346a360d18792d$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $e2346a360d18792d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $e2346a360d18792d$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $e2346a360d18792d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $e2346a360d18792d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $e2346a360d18792d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $e2346a360d18792d$var$ForwardRef = $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE;
var $e2346a360d18792d$var$Memo = $e2346a360d18792d$var$REACT_MEMO_TYPE;
function $e2346a360d18792d$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $e2346a360d18792d$var$REACT_FRAGMENT_TYPE || type === $e2346a360d18792d$var$REACT_PROFILER_TYPE || type === $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE || type === $e2346a360d18792d$var$REACT_SUSPENSE_TYPE || type === $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE || type === $e2346a360d18792d$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $e2346a360d18792d$var$REACT_LAZY_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_MEMO_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_PROVIDER_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_CONTEXT_TYPE || type.$$typeof === $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $e2346a360d18792d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $e2346a360d18792d$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $e2346a360d18792d$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $e2346a360d18792d$var$REACT_FRAGMENT_TYPE:
                        case $e2346a360d18792d$var$REACT_PROFILER_TYPE:
                        case $e2346a360d18792d$var$REACT_STRICT_MODE_TYPE:
                        case $e2346a360d18792d$var$REACT_SUSPENSE_TYPE:
                        case $e2346a360d18792d$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $e2346a360d18792d$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $e2346a360d18792d$var$REACT_CONTEXT_TYPE:
                                    case $e2346a360d18792d$var$REACT_FORWARD_REF_TYPE:
                                    case $e2346a360d18792d$var$REACT_LAZY_TYPE:
                                    case $e2346a360d18792d$var$REACT_MEMO_TYPE:
                                    case $e2346a360d18792d$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $e2346a360d18792d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $e2346a360d18792d$var$isContextConsumer(object) {
    return $e2346a360d18792d$var$typeOf(object) === $e2346a360d18792d$var$REACT_CONTEXT_TYPE;
}
function $e2346a360d18792d$var$isMemo(object) {
    return $e2346a360d18792d$var$typeOf(object) === $e2346a360d18792d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $e2346a360d18792d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $e2346a360d18792d$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $e2346a360d18792d$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $e2346a360d18792d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $e2346a360d18792d$var$verify(mapStateToProps, "mapStateToProps");
    $e2346a360d18792d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $e2346a360d18792d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $e2346a360d18792d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $e2346a360d18792d$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $e2346a360d18792d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $e2346a360d18792d$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $e2346a360d18792d$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $e2346a360d18792d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$e2346a360d18792d$var$isPlainObject(value)) $e2346a360d18792d$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $e2346a360d18792d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $e2346a360d18792d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $e2346a360d18792d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $e2346a360d18792d$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $e2346a360d18792d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $e2346a360d18792d$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $e2346a360d18792d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $e2346a360d18792d$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $e2346a360d18792d$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $e2346a360d18792d$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $e2346a360d18792d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $e2346a360d18792d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $e2346a360d18792d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $e2346a360d18792d$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $e2346a360d18792d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $e2346a360d18792d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $e2346a360d18792d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $e2346a360d18792d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $e2346a360d18792d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$e2346a360d18792d$var$defaultMergeProps : typeof mergeProps === "function" ? $e2346a360d18792d$var$wrapMergePropsFunc(mergeProps) : $e2346a360d18792d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $e2346a360d18792d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $e2346a360d18792d$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $e2346a360d18792d$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $e2346a360d18792d$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $e2346a360d18792d$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $e2346a360d18792d$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $e2346a360d18792d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $e2346a360d18792d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $e2346a360d18792d$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $e2346a360d18792d$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $e2346a360d18792d$var$useIsomorphicLayoutEffect = $e2346a360d18792d$var$canUseDOM || $e2346a360d18792d$var$isReactNative ? $e2346a360d18792d$var$React.useLayoutEffect : $e2346a360d18792d$var$React.useEffect;
// src/utils/shallowEqual.ts
function $e2346a360d18792d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e2346a360d18792d$export$d36bdfa510afb180(objA, objB) {
    if ($e2346a360d18792d$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e2346a360d18792d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $e2346a360d18792d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e2346a360d18792d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e2346a360d18792d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e2346a360d18792d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e2346a360d18792d$var$TYPE_STATICS = {
    [$e2346a360d18792d$var$ForwardRef]: $e2346a360d18792d$var$FORWARD_REF_STATICS,
    [$e2346a360d18792d$var$Memo]: $e2346a360d18792d$var$MEMO_STATICS
};
function $e2346a360d18792d$var$getStatics(component) {
    if ($e2346a360d18792d$var$isMemo(component)) return $e2346a360d18792d$var$MEMO_STATICS;
    return $e2346a360d18792d$var$TYPE_STATICS[component["$$typeof"]] || $e2346a360d18792d$var$REACT_STATICS;
}
var $e2346a360d18792d$var$defineProperty = Object.defineProperty;
var $e2346a360d18792d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e2346a360d18792d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e2346a360d18792d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e2346a360d18792d$var$getPrototypeOf = Object.getPrototypeOf;
var $e2346a360d18792d$var$objectPrototype = Object.prototype;
function $e2346a360d18792d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($e2346a360d18792d$var$objectPrototype) {
            const inheritedComponent = $e2346a360d18792d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e2346a360d18792d$var$objectPrototype) $e2346a360d18792d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $e2346a360d18792d$var$getOwnPropertyNames(sourceComponent);
        if ($e2346a360d18792d$var$getOwnPropertySymbols) keys = keys.concat($e2346a360d18792d$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $e2346a360d18792d$var$getStatics(targetComponent);
        const sourceStatics = $e2346a360d18792d$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$e2346a360d18792d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $e2346a360d18792d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $e2346a360d18792d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $e2346a360d18792d$var$useSyncExternalStore = $e2346a360d18792d$var$notInitialized;
var $e2346a360d18792d$var$initializeConnect = (fn)=>{
    $e2346a360d18792d$var$useSyncExternalStore = fn;
};
var $e2346a360d18792d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $e2346a360d18792d$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $e2346a360d18792d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $e2346a360d18792d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $e2346a360d18792d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $e2346a360d18792d$var$strictEqual(a, b) {
    return a === b;
}
var $e2346a360d18792d$var$hasWarnedAboutDeprecatedPureOption = false;
function $e2346a360d18792d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $e2346a360d18792d$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $e2346a360d18792d$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $e2346a360d18792d$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $e2346a360d18792d$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $e2346a360d18792d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $e2346a360d18792d$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $e2346a360d18792d$var$React.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $e2346a360d18792d$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext === null || propsContext === void 0 ? void 0 : propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $e2346a360d18792d$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $e2346a360d18792d$var$React.useMemo(()=>{
                return $e2346a360d18792d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $e2346a360d18792d$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $e2346a360d18792d$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $e2346a360d18792d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $e2346a360d18792d$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $e2346a360d18792d$var$React.useRef(void 0);
            const lastWrapperProps = $e2346a360d18792d$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $e2346a360d18792d$var$React.useRef(void 0);
            const renderIsScheduled = $e2346a360d18792d$var$React.useRef(false);
            const isMounted = $e2346a360d18792d$var$React.useRef(false);
            const latestSubscriptionCallbackError = $e2346a360d18792d$var$React.useRef(void 0);
            $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $e2346a360d18792d$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $e2346a360d18792d$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $e2346a360d18792d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $e2346a360d18792d$var$useIsomorphicLayoutEffectWithArgs($e2346a360d18792d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $e2346a360d18792d$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $e2346a360d18792d$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $e2346a360d18792d$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $e2346a360d18792d$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $e2346a360d18792d$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $e2346a360d18792d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $e2346a360d18792d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $e2346a360d18792d$export$64605811ab45167f = $e2346a360d18792d$var$connect;
// src/components/Provider.tsx
function $e2346a360d18792d$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $e2346a360d18792d$var$React.useMemo(()=>{
        const subscription = $e2346a360d18792d$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $e2346a360d18792d$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $e2346a360d18792d$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $e2346a360d18792d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $e2346a360d18792d$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $e2346a360d18792d$export$2881499e37b75b9a = $e2346a360d18792d$var$Provider;
// src/hooks/useStore.ts
function $e2346a360d18792d$export$671dba69185d0304(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$var$useReduxContext : // @ts-ignore
    $e2346a360d18792d$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $e2346a360d18792d$export$6ccbb43953eebf8 = /* @__PURE__ */ $e2346a360d18792d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $e2346a360d18792d$export$bc9b55530897c558(context = $e2346a360d18792d$export$cc80c08dc91f1c00) {
    const useStore2 = context === $e2346a360d18792d$export$cc80c08dc91f1c00 ? $e2346a360d18792d$export$6ccbb43953eebf8 : $e2346a360d18792d$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $e2346a360d18792d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $e2346a360d18792d$export$bc9b55530897c558();
// src/exports.ts
var $e2346a360d18792d$export$712ea50be43a7858 = $e2346a360d18792d$var$defaultNoopBatch;
// src/index.ts
$e2346a360d18792d$var$initializeUseSelector((0, $65cdbf7f8217658a$exports.useSyncExternalStoreWithSelector));
$e2346a360d18792d$var$initializeConnect($eZVvM.useSyncExternalStore);


// src/index.ts
function $3714350acbe00f73$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


// src/utils/formatProdErrorMessage.ts
function $ac44486100bacc69$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $ac44486100bacc69$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $ac44486100bacc69$var$symbol_observable_default = $ac44486100bacc69$var$$$observable;
// src/utils/actionTypes.ts
var $ac44486100bacc69$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $ac44486100bacc69$var$ActionTypes = {
    INIT: `@@redux/INIT${$ac44486100bacc69$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$ac44486100bacc69$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$ac44486100bacc69$var$randomString()}`
};
var $ac44486100bacc69$export$4219e499db7ca678 = $ac44486100bacc69$var$ActionTypes;
// src/utils/isPlainObject.ts
function $ac44486100bacc69$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $ac44486100bacc69$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ac44486100bacc69$var$isDate(val)) return "date";
    if ($ac44486100bacc69$var$isError(val)) return "error";
    const constructorName = $ac44486100bacc69$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ac44486100bacc69$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ac44486100bacc69$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ac44486100bacc69$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ac44486100bacc69$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $ac44486100bacc69$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(1));
        return enhancer($ac44486100bacc69$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$ac44486100bacc69$export$53b83ca8eaab0383(action)) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $ac44486100bacc69$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$ac44486100bacc69$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $ac44486100bacc69$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$ac44486100bacc69$var$symbol_observable_default]: observable
    };
    return store;
}
function $ac44486100bacc69$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $ac44486100bacc69$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $ac44486100bacc69$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $ac44486100bacc69$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $ac44486100bacc69$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ac44486100bacc69$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$ac44486100bacc69$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ac44486100bacc69$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $ac44486100bacc69$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $ac44486100bacc69$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $ac44486100bacc69$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ac44486100bacc69$var$formatProdErrorMessage(13));
    });
}
function $ac44486100bacc69$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $ac44486100bacc69$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($ac44486100bacc69$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $ac44486100bacc69$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $ac44486100bacc69$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ac44486100bacc69$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ac44486100bacc69$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ac44486100bacc69$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $ac44486100bacc69$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $ac44486100bacc69$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($ac44486100bacc69$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $ac44486100bacc69$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $ac44486100bacc69$export$b956e38827fca970(action) {
    return $ac44486100bacc69$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


// src/utils/env.ts
var $7b8b56f7aa848e1e$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7b8b56f7aa848e1e$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7b8b56f7aa848e1e$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7b8b56f7aa848e1e$var$errors = [];
function $7b8b56f7aa848e1e$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7b8b56f7aa848e1e$var$getPrototypeOf = Object.getPrototypeOf;
function $7b8b56f7aa848e1e$export$541ac630993a4c84(value) {
    return !!value && !!value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
}
function $7b8b56f7aa848e1e$export$16e3aed3edb85946(value) {
    var _value_constructor;
    if (!value) return false;
    return $7b8b56f7aa848e1e$var$isPlainObject(value) || Array.isArray(value) || !!value[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee] || !!((_value_constructor = value.constructor) === null || _value_constructor === void 0 ? void 0 : _value_constructor[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee]) || $7b8b56f7aa848e1e$var$isMap(value) || $7b8b56f7aa848e1e$var$isSet(value);
}
var $7b8b56f7aa848e1e$var$objectCtorString = Object.prototype.constructor.toString();
function $7b8b56f7aa848e1e$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $7b8b56f7aa848e1e$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $7b8b56f7aa848e1e$var$objectCtorString;
}
function $7b8b56f7aa848e1e$export$22e8af3f75a010e3(value) {
    if (!$7b8b56f7aa848e1e$export$541ac630993a4c84(value)) $7b8b56f7aa848e1e$var$die(15, value);
    return value[$7b8b56f7aa848e1e$var$DRAFT_STATE].base_;
}
function $7b8b56f7aa848e1e$var$each(obj, iter) {
    if ($7b8b56f7aa848e1e$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7b8b56f7aa848e1e$var$getArchtype(thing) {
    const state = thing[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $7b8b56f7aa848e1e$var$isMap(thing) ? 2 /* Map */  : $7b8b56f7aa848e1e$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $7b8b56f7aa848e1e$var$has(thing, prop) {
    return $7b8b56f7aa848e1e$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $7b8b56f7aa848e1e$var$get(thing, prop) {
    return $7b8b56f7aa848e1e$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $7b8b56f7aa848e1e$var$set(thing, propOrOldValue, value) {
    const t = $7b8b56f7aa848e1e$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $7b8b56f7aa848e1e$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $7b8b56f7aa848e1e$var$isMap(target) {
    return target instanceof Map;
}
function $7b8b56f7aa848e1e$var$isSet(target) {
    return target instanceof Set;
}
function $7b8b56f7aa848e1e$var$latest(state) {
    return state.copy_ || state.base_;
}
function $7b8b56f7aa848e1e$var$shallowCopy(base, strict) {
    if ($7b8b56f7aa848e1e$var$isMap(base)) return new Map(base);
    if ($7b8b56f7aa848e1e$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $7b8b56f7aa848e1e$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$7b8b56f7aa848e1e$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($7b8b56f7aa848e1e$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7b8b56f7aa848e1e$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $7b8b56f7aa848e1e$export$792f3d81ea979f55(obj, deep = false) {
    if ($7b8b56f7aa848e1e$var$isFrozen(obj) || $7b8b56f7aa848e1e$export$541ac630993a4c84(obj) || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(obj)) return obj;
    if ($7b8b56f7aa848e1e$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $7b8b56f7aa848e1e$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$7b8b56f7aa848e1e$export$792f3d81ea979f55(value, true));
    return obj;
}
function $7b8b56f7aa848e1e$var$dontMutateFrozenCollections() {
    $7b8b56f7aa848e1e$var$die(2);
}
function $7b8b56f7aa848e1e$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $7b8b56f7aa848e1e$var$plugins = {};
function $7b8b56f7aa848e1e$var$getPlugin(pluginKey) {
    const plugin = $7b8b56f7aa848e1e$var$plugins[pluginKey];
    if (!plugin) $7b8b56f7aa848e1e$var$die(0, pluginKey);
    return plugin;
}
function $7b8b56f7aa848e1e$var$loadPlugin(pluginKey, implementation) {
    if (!$7b8b56f7aa848e1e$var$plugins[pluginKey]) $7b8b56f7aa848e1e$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7b8b56f7aa848e1e$var$currentScope;
function $7b8b56f7aa848e1e$var$getCurrentScope() {
    return $7b8b56f7aa848e1e$var$currentScope;
}
function $7b8b56f7aa848e1e$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $7b8b56f7aa848e1e$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7b8b56f7aa848e1e$var$revokeScope(scope) {
    $7b8b56f7aa848e1e$var$leaveScope(scope);
    scope.drafts_.forEach($7b8b56f7aa848e1e$var$revokeDraft);
    scope.drafts_ = null;
}
function $7b8b56f7aa848e1e$var$leaveScope(scope) {
    if (scope === $7b8b56f7aa848e1e$var$currentScope) $7b8b56f7aa848e1e$var$currentScope = scope.parent_;
}
function $7b8b56f7aa848e1e$var$enterScope(immer2) {
    return $7b8b56f7aa848e1e$var$currentScope = $7b8b56f7aa848e1e$var$createScope($7b8b56f7aa848e1e$var$currentScope, immer2);
}
function $7b8b56f7aa848e1e$var$revokeDraft(draft) {
    const state = draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7b8b56f7aa848e1e$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7b8b56f7aa848e1e$var$DRAFT_STATE].modified_) {
            $7b8b56f7aa848e1e$var$revokeScope(scope);
            $7b8b56f7aa848e1e$var$die(4);
        }
        if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(result)) {
            result = $7b8b56f7aa848e1e$var$finalize(scope, result);
            if (!scope.parent_) $7b8b56f7aa848e1e$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $7b8b56f7aa848e1e$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$7b8b56f7aa848e1e$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $7b8b56f7aa848e1e$var$finalize(scope, baseDraft, []);
    $7b8b56f7aa848e1e$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7b8b56f7aa848e1e$export$45b790e32b2810ee ? result : void 0;
}
function $7b8b56f7aa848e1e$var$finalize(rootScope, value, path) {
    if ($7b8b56f7aa848e1e$var$isFrozen(value)) return value;
    const state = value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    if (!state) {
        $7b8b56f7aa848e1e$var$each(value, (key, childValue)=>$7b8b56f7aa848e1e$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $7b8b56f7aa848e1e$var$each(resultEach, (key, childValue)=>$7b8b56f7aa848e1e$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $7b8b56f7aa848e1e$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $7b8b56f7aa848e1e$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($7b8b56f7aa848e1e$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$7b8b56f7aa848e1e$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $7b8b56f7aa848e1e$var$finalize(rootScope, childValue, path);
        $7b8b56f7aa848e1e$var$set(targetObject, prop, res);
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(childValue) && !$7b8b56f7aa848e1e$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $7b8b56f7aa848e1e$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $7b8b56f7aa848e1e$var$maybeFreeze(rootScope, childValue);
    }
}
function $7b8b56f7aa848e1e$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7b8b56f7aa848e1e$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $7b8b56f7aa848e1e$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $7b8b56f7aa848e1e$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $7b8b56f7aa848e1e$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $7b8b56f7aa848e1e$var$objectTraps = {
    get (state, prop) {
        if (prop === $7b8b56f7aa848e1e$var$DRAFT_STATE) return state;
        const source = $7b8b56f7aa848e1e$var$latest(state);
        if (!$7b8b56f7aa848e1e$var$has(source, prop)) return $7b8b56f7aa848e1e$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) return value;
        if (value === $7b8b56f7aa848e1e$var$peek(state.base_, prop)) {
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            return state.copy_[prop] = $7b8b56f7aa848e1e$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $7b8b56f7aa848e1e$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7b8b56f7aa848e1e$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7b8b56f7aa848e1e$var$getDescriptorFromProto($7b8b56f7aa848e1e$var$latest(state), prop);
        if (desc === null || desc === void 0 ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7b8b56f7aa848e1e$var$peek($7b8b56f7aa848e1e$var$latest(state), prop);
            const currentState = current2 === null || current2 === void 0 ? void 0 : current2[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($7b8b56f7aa848e1e$var$is(value, current2) && (value !== void 0 || $7b8b56f7aa848e1e$var$has(state.base_, prop))) return true;
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($7b8b56f7aa848e1e$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $7b8b56f7aa848e1e$var$prepareCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7b8b56f7aa848e1e$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $7b8b56f7aa848e1e$var$die(11);
    },
    getPrototypeOf (state) {
        return $7b8b56f7aa848e1e$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7b8b56f7aa848e1e$var$die(12);
    }
};
var $7b8b56f7aa848e1e$var$arrayTraps = {};
$7b8b56f7aa848e1e$var$each($7b8b56f7aa848e1e$var$objectTraps, (key, fn)=>{
    $7b8b56f7aa848e1e$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$7b8b56f7aa848e1e$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7b8b56f7aa848e1e$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7b8b56f7aa848e1e$var$arrayTraps.set = function(state, prop, value) {
    return $7b8b56f7aa848e1e$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7b8b56f7aa848e1e$var$peek(draft, prop) {
    const state = draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    const source = state ? $7b8b56f7aa848e1e$var$latest(state) : draft;
    return source[prop];
}
function $7b8b56f7aa848e1e$var$readPropFromProto(state, source, prop) {
    var // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    _desc_get;
    const desc = $7b8b56f7aa848e1e$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : (_desc_get = desc.get) === null || _desc_get === void 0 ? void 0 : _desc_get.call(state.draft_) : void 0;
}
function $7b8b56f7aa848e1e$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7b8b56f7aa848e1e$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7b8b56f7aa848e1e$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7b8b56f7aa848e1e$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7b8b56f7aa848e1e$var$markChanged(state.parent_);
    }
}
function $7b8b56f7aa848e1e$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $7b8b56f7aa848e1e$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $7b8b56f7aa848e1e$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(base)) $7b8b56f7aa848e1e$var$die(8);
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(base)) base = $7b8b56f7aa848e1e$export$97aac956da55dae9(base);
        const scope = $7b8b56f7aa848e1e$var$enterScope(this);
        const proxy = $7b8b56f7aa848e1e$var$createProxy(base, void 0);
        proxy[$7b8b56f7aa848e1e$var$DRAFT_STATE].isManual_ = true;
        $7b8b56f7aa848e1e$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7b8b56f7aa848e1e$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7b8b56f7aa848e1e$var$die(9);
        const { scope_: scope } = state;
        $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener);
        return $7b8b56f7aa848e1e$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7b8b56f7aa848e1e$var$getPlugin("Patches").applyPatches_;
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $7b8b56f7aa848e1e$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $7b8b56f7aa848e1e$var$die(7);
            let result;
            if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(base)) {
                const scope = $7b8b56f7aa848e1e$var$enterScope(this);
                const proxy = $7b8b56f7aa848e1e$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7b8b56f7aa848e1e$var$revokeScope(scope);
                    else $7b8b56f7aa848e1e$var$leaveScope(scope);
                }
                $7b8b56f7aa848e1e$var$usePatchesInScope(scope, patchListener);
                return $7b8b56f7aa848e1e$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7b8b56f7aa848e1e$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7b8b56f7aa848e1e$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7b8b56f7aa848e1e$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $7b8b56f7aa848e1e$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config === null || config === void 0 ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config === null || config === void 0 ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
};
function $7b8b56f7aa848e1e$var$createProxy(value, parent) {
    const draft = $7b8b56f7aa848e1e$var$isMap(value) ? $7b8b56f7aa848e1e$var$getPlugin("MapSet").proxyMap_(value, parent) : $7b8b56f7aa848e1e$var$isSet(value) ? $7b8b56f7aa848e1e$var$getPlugin("MapSet").proxySet_(value, parent) : $7b8b56f7aa848e1e$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $7b8b56f7aa848e1e$export$97aac956da55dae9(value) {
    if (!$7b8b56f7aa848e1e$export$541ac630993a4c84(value)) $7b8b56f7aa848e1e$var$die(10, value);
    return $7b8b56f7aa848e1e$var$currentImpl(value);
}
function $7b8b56f7aa848e1e$var$currentImpl(value) {
    if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(value) || $7b8b56f7aa848e1e$var$isFrozen(value)) return value;
    const state = value[$7b8b56f7aa848e1e$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7b8b56f7aa848e1e$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $7b8b56f7aa848e1e$var$shallowCopy(value, true);
    $7b8b56f7aa848e1e$var$each(copy, (key, childValue)=>{
        $7b8b56f7aa848e1e$var$set(copy, key, $7b8b56f7aa848e1e$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7b8b56f7aa848e1e$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $7b8b56f7aa848e1e$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7b8b56f7aa848e1e$var$get(base_, key);
            const value = $7b8b56f7aa848e1e$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $7b8b56f7aa848e1e$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $7b8b56f7aa848e1e$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7b8b56f7aa848e1e$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $7b8b56f7aa848e1e$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $7b8b56f7aa848e1e$var$die(errorOffset + 3);
                base = $7b8b56f7aa848e1e$var$get(base, p);
                if (typeof base !== "object") $7b8b56f7aa848e1e$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7b8b56f7aa848e1e$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7b8b56f7aa848e1e$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7b8b56f7aa848e1e$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7b8b56f7aa848e1e$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7b8b56f7aa848e1e$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7b8b56f7aa848e1e$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7b8b56f7aa848e1e$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7b8b56f7aa848e1e$var$has(obj, $7b8b56f7aa848e1e$export$6ee2082928bcb0ee)) cloned[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee] = obj[$7b8b56f7aa848e1e$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7b8b56f7aa848e1e$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7b8b56f7aa848e1e$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $7b8b56f7aa848e1e$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7b8b56f7aa848e1e$var$latest(state).has(key) || $7b8b56f7aa848e1e$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7b8b56f7aa848e1e$var$latest(state).size) {
                prepareMapCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7b8b56f7aa848e1e$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            $7b8b56f7aa848e1e$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7b8b56f7aa848e1e$var$latest(state).get(key);
            if (state.finalized_ || !$7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7b8b56f7aa848e1e$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7b8b56f7aa848e1e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$7b8b56f7aa848e1e$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $7b8b56f7aa848e1e$var$latest(this[$7b8b56f7aa848e1e$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7b8b56f7aa848e1e$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7b8b56f7aa848e1e$var$latest(state).size) {
                prepareSetCopy(state);
                $7b8b56f7aa848e1e$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7b8b56f7aa848e1e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7b8b56f7aa848e1e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$7b8b56f7aa848e1e$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7b8b56f7aa848e1e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7b8b56f7aa848e1e$export$16e3aed3edb85946(value)) {
                    const draft = $7b8b56f7aa848e1e$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7b8b56f7aa848e1e$var$die(3, JSON.stringify($7b8b56f7aa848e1e$var$latest(state)));
    }
    $7b8b56f7aa848e1e$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $7b8b56f7aa848e1e$var$immer = new $7b8b56f7aa848e1e$export$aaadc6ff0f822719();
var $7b8b56f7aa848e1e$export$b46cabe22e78bc00 = $7b8b56f7aa848e1e$var$immer.produce;
var $7b8b56f7aa848e1e$export$4da66d41c9492c78 = $7b8b56f7aa848e1e$var$immer.produceWithPatches.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$573f26f60825c493 = $7b8b56f7aa848e1e$var$immer.setAutoFreeze.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$333ce65961cbe047 = $7b8b56f7aa848e1e$var$immer.setUseStrictShallowCopy.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$a8b8e03e6bbe5473 = $7b8b56f7aa848e1e$var$immer.applyPatches.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$3c3214997190395f = $7b8b56f7aa848e1e$var$immer.createDraft.bind($7b8b56f7aa848e1e$var$immer);
var $7b8b56f7aa848e1e$export$c60f5e69c521b528 = $7b8b56f7aa848e1e$var$immer.finishDraft.bind($7b8b56f7aa848e1e$var$immer);
function $7b8b56f7aa848e1e$export$c05b21e3257751e5(value) {
    return value;
}
function $7b8b56f7aa848e1e$export$20f911b3f8cf0b74(value) {
    return value;
}


// src/devModeChecks/identityFunctionCheck.ts

var $f3a2896bcea9aa5e$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $f3a2896bcea9aa5e$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $f3a2896bcea9aa5e$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $f3a2896bcea9aa5e$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($f3a2896bcea9aa5e$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $f3a2896bcea9aa5e$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $f3a2896bcea9aa5e$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $f3a2896bcea9aa5e$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $f3a2896bcea9aa5e$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $f3a2896bcea9aa5e$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $f3a2896bcea9aa5e$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $f3a2896bcea9aa5e$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $f3a2896bcea9aa5e$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $f3a2896bcea9aa5e$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$f3a2896bcea9aa5e$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $f3a2896bcea9aa5e$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $f3a2896bcea9aa5e$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $f3a2896bcea9aa5e$var$$REVISION = 0;
var $f3a2896bcea9aa5e$var$CURRENT_TRACKER = null;
var $f3a2896bcea9aa5e$var$Cell = class {
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $f3a2896bcea9aa5e$var$CURRENT_TRACKER === null || $f3a2896bcea9aa5e$var$CURRENT_TRACKER === void 0 ? void 0 : $f3a2896bcea9aa5e$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$f3a2896bcea9aa5e$var$$REVISION;
    }
    constructor(initialValue, isEqual = $f3a2896bcea9aa5e$var$tripleEq){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "revision", $f3a2896bcea9aa5e$var$$REVISION);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_value", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_lastValue", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_isEqual", $f3a2896bcea9aa5e$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
};
function $f3a2896bcea9aa5e$var$tripleEq(a, b) {
    return a === b;
}
var $f3a2896bcea9aa5e$var$TrackingCache = class {
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $f3a2896bcea9aa5e$var$CURRENT_TRACKER;
            $f3a2896bcea9aa5e$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $f3a2896bcea9aa5e$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $f3a2896bcea9aa5e$var$CURRENT_TRACKER === null || $f3a2896bcea9aa5e$var$CURRENT_TRACKER === void 0 ? void 0 : $f3a2896bcea9aa5e$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
    constructor(fn){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_cachedValue", void 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_cachedRevision", -1);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_deps", []);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "hits", 0);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "fn", void 0);
        this.fn = fn;
    }
};
function $f3a2896bcea9aa5e$var$getValue(cell) {
    if (!(cell instanceof $f3a2896bcea9aa5e$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $f3a2896bcea9aa5e$var$setValue(storage, value) {
    if (!(storage instanceof $f3a2896bcea9aa5e$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $f3a2896bcea9aa5e$var$createCell(initialValue, isEqual = $f3a2896bcea9aa5e$var$tripleEq) {
    return new $f3a2896bcea9aa5e$var$Cell(initialValue, isEqual);
}
function $f3a2896bcea9aa5e$var$createCache(fn) {
    $f3a2896bcea9aa5e$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $f3a2896bcea9aa5e$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $f3a2896bcea9aa5e$var$neverEq = (a, b)=>false;
function $f3a2896bcea9aa5e$var$createTag() {
    return $f3a2896bcea9aa5e$var$createCell(null, $f3a2896bcea9aa5e$var$neverEq);
}
function $f3a2896bcea9aa5e$var$dirtyTag(tag, value) {
    $f3a2896bcea9aa5e$var$setValue(tag, value);
}
var $f3a2896bcea9aa5e$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $f3a2896bcea9aa5e$var$createTag();
    $f3a2896bcea9aa5e$var$getValue(tag);
};
var $f3a2896bcea9aa5e$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $f3a2896bcea9aa5e$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $f3a2896bcea9aa5e$var$REDUX_PROXY_LABEL = Symbol();
var $f3a2896bcea9aa5e$var$nextId = 0;
var $f3a2896bcea9aa5e$var$proto = Object.getPrototypeOf({});
var $f3a2896bcea9aa5e$var$ObjectTreeNode = class {
    constructor(value){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "proxy", new Proxy(this, $f3a2896bcea9aa5e$var$objectProxyHandler));
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tag", $f3a2896bcea9aa5e$var$createTag());
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tags", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "children", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "collectionTag", null);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "id", $f3a2896bcea9aa5e$var$nextId++);
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
};
var $f3a2896bcea9aa5e$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $f3a2896bcea9aa5e$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $f3a2896bcea9aa5e$var$createNode(childValue);
                if (childNode.tag) $f3a2896bcea9aa5e$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $f3a2896bcea9aa5e$var$createTag();
                    tag.value = childValue;
                }
                $f3a2896bcea9aa5e$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $f3a2896bcea9aa5e$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $f3a2896bcea9aa5e$var$ArrayTreeNode = class {
    constructor(value){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "proxy", new Proxy([
            this
        ], $f3a2896bcea9aa5e$var$arrayProxyHandler));
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tag", $f3a2896bcea9aa5e$var$createTag());
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "tags", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "children", {});
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "collectionTag", null);
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "id", $f3a2896bcea9aa5e$var$nextId++);
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
};
var $f3a2896bcea9aa5e$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $f3a2896bcea9aa5e$var$consumeCollection(node);
        return $f3a2896bcea9aa5e$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $f3a2896bcea9aa5e$var$objectProxyHandler.has(node, prop);
    }
};
function $f3a2896bcea9aa5e$var$createNode(value) {
    if (Array.isArray(value)) return new $f3a2896bcea9aa5e$var$ArrayTreeNode(value);
    return new $f3a2896bcea9aa5e$var$ObjectTreeNode(value);
}
function $f3a2896bcea9aa5e$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $f3a2896bcea9aa5e$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $f3a2896bcea9aa5e$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $f3a2896bcea9aa5e$var$dirtyCollection(node);
            $f3a2896bcea9aa5e$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $f3a2896bcea9aa5e$var$updateNode(childNode, newChildValue);
        else {
            $f3a2896bcea9aa5e$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $f3a2896bcea9aa5e$var$deleteNode(node) {
    if (node.tag) $f3a2896bcea9aa5e$var$dirtyTag(node.tag, null);
    $f3a2896bcea9aa5e$var$dirtyCollection(node);
    for(const key in node.tags)$f3a2896bcea9aa5e$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$f3a2896bcea9aa5e$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $f3a2896bcea9aa5e$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f3a2896bcea9aa5e$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $f3a2896bcea9aa5e$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $f3a2896bcea9aa5e$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f3a2896bcea9aa5e$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f3a2896bcea9aa5e$export$3f025202a230c6dd = (a, b)=>a === b;
function $f3a2896bcea9aa5e$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f3a2896bcea9aa5e$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $f3a2896bcea9aa5e$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $f3a2896bcea9aa5e$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $f3a2896bcea9aa5e$var$createSingletonCache(comparator) : $f3a2896bcea9aa5e$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $f3a2896bcea9aa5e$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $f3a2896bcea9aa5e$export$c8f9cf88d9fdee55(func) {
    const node = $f3a2896bcea9aa5e$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $f3a2896bcea9aa5e$var$createCacheKeyComparator($f3a2896bcea9aa5e$export$3f025202a230c6dd);
    const cache = $f3a2896bcea9aa5e$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $f3a2896bcea9aa5e$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $f3a2896bcea9aa5e$var$StrongRef = class {
    deref() {
        return this.value;
    }
    constructor(value){
        this.value = value;
    }
};
var $f3a2896bcea9aa5e$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $f3a2896bcea9aa5e$var$StrongRef;
var $f3a2896bcea9aa5e$var$UNTERMINATED = 0;
var $f3a2896bcea9aa5e$var$TERMINATED = 1;
function $f3a2896bcea9aa5e$var$createCacheNode() {
    return {
        s: $f3a2896bcea9aa5e$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $f3a2896bcea9aa5e$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $f3a2896bcea9aa5e$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $f3a2896bcea9aa5e$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $f3a2896bcea9aa5e$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $f3a2896bcea9aa5e$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var _lastResult_deref;
                var _lastResult_deref1;
                const lastResultValue = (_lastResult_deref1 = lastResult === null || lastResult === void 0 ? void 0 : (_lastResult_deref = lastResult.deref) === null || _lastResult_deref === void 0 ? void 0 : _lastResult_deref.call(lastResult)) !== null && _lastResult_deref1 !== void 0 ? _lastResult_deref1 : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $f3a2896bcea9aa5e$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $f3a2896bcea9aa5e$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $f3a2896bcea9aa5e$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $f3a2896bcea9aa5e$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $f3a2896bcea9aa5e$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $f3a2896bcea9aa5e$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $f3a2896bcea9aa5e$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $f3a2896bcea9aa5e$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $f3a2896bcea9aa5e$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $f3a2896bcea9aa5e$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $f3a2896bcea9aa5e$export$595d22ed68ca2841 = /* @__PURE__ */ $f3a2896bcea9aa5e$export$5943f4447f6ef248($f3a2896bcea9aa5e$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $f3a2896bcea9aa5e$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $f3a2896bcea9aa5e$export$595d22ed68ca2841)=>{
    $f3a2896bcea9aa5e$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$f3a2896bcea9aa5e$export$75979cfcd91bf38f
});


// src/index.ts
function $66e767ba7acb4f78$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $66e767ba7acb4f78$export$dd164f5517779f15 = $66e767ba7acb4f78$var$createThunkMiddleware();
var $66e767ba7acb4f78$export$16d06542a1949d9e = $66e767ba7acb4f78$var$createThunkMiddleware;



var $lUPho = parcelRequire("lUPho");
var $58dad493bd6ec980$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $f3a2896bcea9aa5e$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(value) ? (0, $7b8b56f7aa848e1e$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $58dad493bd6ec980$export$a5d3c27355e35910 = /* @__PURE__ */ $58dad493bd6ec980$export$aab6de9e3dbb1473((0, $f3a2896bcea9aa5e$export$8402dc26d96f6902));
var $58dad493bd6ec980$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $ac44486100bacc69$export$f672e0b6f7222cd7;
    return (0, $ac44486100bacc69$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $58dad493bd6ec980$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $58dad493bd6ec980$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $58dad493bd6ec980$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $ac44486100bacc69$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $58dad493bd6ec980$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $58dad493bd6ec980$var$hasMatchFunction(action);
}
function $58dad493bd6ec980$export$ebd532f9034651f3(action) {
    return (0, $ac44486100bacc69$export$b956e38827fca970)(action) && Object.keys(action).every($58dad493bd6ec980$var$isValidKey);
}
function $58dad493bd6ec980$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $58dad493bd6ec980$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $58dad493bd6ec980$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $58dad493bd6ec980$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $58dad493bd6ec980$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $58dad493bd6ec980$export$1908877435b1d5e9 = class _Tuple extends Array {
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
};
function $58dad493bd6ec980$var$freezeDraftable(val) {
    return (0, $7b8b56f7aa848e1e$export$16e3aed3edb85946)(val) ? (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $58dad493bd6ec980$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $58dad493bd6ec980$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $58dad493bd6ec980$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $58dad493bd6ec980$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $58dad493bd6ec980$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $58dad493bd6ec980$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $58dad493bd6ec980$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $58dad493bd6ec980$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $58dad493bd6ec980$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $ac44486100bacc69$export$53b83ca8eaab0383)(val);
}
function $58dad493bd6ec980$export$ada5dca0b571bc7(value, path = "", isSerializable = $58dad493bd6ec980$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $58dad493bd6ec980$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $58dad493bd6ec980$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $58dad493bd6ec980$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$58dad493bd6ec980$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $58dad493bd6ec980$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $58dad493bd6ec980$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $58dad493bd6ec980$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options !== null && options !== void 0 ? options : {};
        let middlewareArray = new $58dad493bd6ec980$export$1908877435b1d5e9();
        if (thunk) {
            if ($58dad493bd6ec980$var$isBoolean(thunk)) middlewareArray.push((0, $66e767ba7acb4f78$export$dd164f5517779f15));
            else middlewareArray.push((0, $66e767ba7acb4f78$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $58dad493bd6ec980$export$8fb31c0f05df007b = "RTK_autoBatch";
var $58dad493bd6ec980$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$58dad493bd6ec980$export$8fb31c0f05df007b]: true
            }
        });
var $58dad493bd6ec980$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $58dad493bd6ec980$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $58dad493bd6ec980$var$createQueueWithTimer(10);
var $58dad493bd6ec980$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $58dad493bd6ec980$var$rAF : options.type === "callback" ? options.queueNotification : $58dad493bd6ec980$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        var _action_meta;
                        notifying = !(action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta[$58dad493bd6ec980$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $58dad493bd6ec980$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options !== null && options !== void 0 ? options : {};
        let enhancerArray = new $58dad493bd6ec980$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($58dad493bd6ec980$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $58dad493bd6ec980$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $58dad493bd6ec980$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $ac44486100bacc69$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $ac44486100bacc69$export$66e4520cdb265d18)(reducer);
    else throw new Error($58dad493bd6ec980$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $ac44486100bacc69$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $58dad493bd6ec980$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $ac44486100bacc69$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $58dad493bd6ec980$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $ac44486100bacc69$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $58dad493bd6ec980$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $58dad493bd6ec980$var$isStateFunction(x) {
    return typeof x === "function";
}
function $58dad493bd6ec980$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $58dad493bd6ec980$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($58dad493bd6ec980$var$isStateFunction(initialState)) getInitialState = ()=>$58dad493bd6ec980$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $58dad493bd6ec980$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7b8b56f7aa848e1e$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $58dad493bd6ec980$var$matches = (matcher, action)=>{
    if ($58dad493bd6ec980$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $58dad493bd6ec980$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$58dad493bd6ec980$var$matches(matcher, action));
    };
}
function $58dad493bd6ec980$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$58dad493bd6ec980$var$matches(matcher, action));
    };
}
function $58dad493bd6ec980$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $58dad493bd6ec980$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $58dad493bd6ec980$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$872dec21e9a69476()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $58dad493bd6ec980$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $58dad493bd6ec980$export$9dd1fb32974da385($58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$fcc3388fb56de601()(asyncThunks[0]);
    return $58dad493bd6ec980$export$9dd1fb32974da385($58dad493bd6ec980$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $58dad493bd6ec980$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$1da80a6ef1307441()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $58dad493bd6ec980$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$58dad493bd6ec980$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$58dad493bd6ec980$var$isAsyncThunkArray(asyncThunks)) return $58dad493bd6ec980$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $58dad493bd6ec980$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $58dad493bd6ec980$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $58dad493bd6ec980$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $58dad493bd6ec980$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $58dad493bd6ec980$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $58dad493bd6ec980$var$RejectWithValue = class {
    constructor(payload, meta){
        /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_type", void 0);
        this.payload = payload;
        this.meta = meta;
    }
};
var $58dad493bd6ec980$var$FulfillWithMeta = class {
    constructor(payload, meta){
        /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $3714350acbe00f73$export$71511d61b312f219)(this, "_type", void 0);
        this.payload = payload;
        this.meta = meta;
    }
};
var $58dad493bd6ec980$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $58dad493bd6ec980$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $58dad493bd6ec980$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $58dad493bd6ec980$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $58dad493bd6ec980$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $58dad493bd6ec980$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        var _options_condition, _options_getPendingMeta;
                        let conditionResult = options === null || options === void 0 ? void 0 : (_options_condition = options.condition) === null || _options_condition === void 0 ? void 0 : _options_condition.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($58dad493bd6ec980$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options === null || options === void 0 ? void 0 : (_options_getPendingMeta = options.getPendingMeta) === null || _options_getPendingMeta === void 0 ? void 0 : _options_getPendingMeta.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $58dad493bd6ec980$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $58dad493bd6ec980$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $58dad493bd6ec980$var$RejectWithValue) throw result;
                                if (result instanceof $58dad493bd6ec980$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $58dad493bd6ec980$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($58dad493bd6ec980$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $58dad493bd6ec980$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $58dad493bd6ec980$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $58dad493bd6ec980$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $58dad493bd6ec980$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $58dad493bd6ec980$export$343355ed40c51c46 = {
    [$58dad493bd6ec980$var$asyncThunkSymbol]: $58dad493bd6ec980$export$6abd22dc03e5063f
};
var $58dad493bd6ec980$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($58dad493bd6ec980$export$23a094319a4b586 || {});
function $58dad493bd6ec980$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $58dad493bd6ec980$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _creators_asyncThunk;
    const cAT = creators === null || creators === void 0 ? void 0 : (_creators_asyncThunk = creators.asyncThunk) === null || _creators_asyncThunk === void 0 ? void 0 : _creators_asyncThunk[$58dad493bd6ec980$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(11));
        typeof $lUPho;
        const reducers = (typeof options.reducers === "function" ? options.reducers($58dad493bd6ec980$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $58dad493bd6ec980$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($58dad493bd6ec980$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $58dad493bd6ec980$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $58dad493bd6ec980$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $58dad493bd6ec980$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $58dad493bd6ec980$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $58dad493bd6ec980$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $58dad493bd6ec980$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        var _options_selectors;
                        for (const [name2, selector] of Object.entries((_options_selectors = options.selectors) !== null && _options_selectors !== void 0 ? _options_selectors : {}))map[name2] = $58dad493bd6ec980$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $58dad493bd6ec980$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $58dad493bd6ec980$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $58dad493bd6ec980$export$affdea4146de9cf5();
function $58dad493bd6ec980$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $58dad493bd6ec980$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$58dad493bd6ec980$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $58dad493bd6ec980$export$309c7a02b0b0bc62(type, prepareCallback) : $58dad493bd6ec980$export$309c7a02b0b0bc62(type));
}
function $58dad493bd6ec980$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $58dad493bd6ec980$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $58dad493bd6ec980$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $58dad493bd6ec980$var$noop,
        pending: pending || $58dad493bd6ec980$var$noop,
        rejected: rejected || $58dad493bd6ec980$var$noop,
        settled: settled || $58dad493bd6ec980$var$noop
    });
}
function $58dad493bd6ec980$var$noop() {}
// src/entities/entity_state.ts
function $58dad493bd6ec980$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $58dad493bd6ec980$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($58dad493bd6ec980$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $58dad493bd6ec980$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $58dad493bd6ec980$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $58dad493bd6ec980$var$isDraftTyped = (0, $7b8b56f7aa848e1e$export$541ac630993a4c84);
function $58dad493bd6ec980$var$createSingleArgumentStateOperator(mutator) {
    const operator = $58dad493bd6ec980$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $58dad493bd6ec980$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $58dad493bd6ec980$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($58dad493bd6ec980$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7b8b56f7aa848e1e$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $58dad493bd6ec980$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $58dad493bd6ec980$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $58dad493bd6ec980$var$getCurrent(value) {
    return (0, $7b8b56f7aa848e1e$export$541ac630993a4c84)(value) ? (0, $7b8b56f7aa848e1e$export$97aac956da55dae9)(value) : value;
}
function $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $58dad493bd6ec980$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $58dad493bd6ec980$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $58dad493bd6ec980$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _updatesPerEntity_update_id;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...(_updatesPerEntity_update_id = updatesPerEntity[update.id]) === null || _updatesPerEntity_update_id === void 0 ? void 0 : _updatesPerEntity_update_id.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$58dad493bd6ec980$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $58dad493bd6ec980$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $58dad493bd6ec980$var$createStateOperator(addOneMutably),
        addMany: $58dad493bd6ec980$var$createStateOperator(addManyMutably),
        setOne: $58dad493bd6ec980$var$createStateOperator(setOneMutably),
        setMany: $58dad493bd6ec980$var$createStateOperator(setManyMutably),
        setAll: $58dad493bd6ec980$var$createStateOperator(setAllMutably),
        updateOne: $58dad493bd6ec980$var$createStateOperator(updateOneMutably),
        updateMany: $58dad493bd6ec980$var$createStateOperator(updateManyMutably),
        upsertOne: $58dad493bd6ec980$var$createStateOperator(upsertOneMutably),
        upsertMany: $58dad493bd6ec980$var$createStateOperator(upsertManyMutably),
        removeOne: $58dad493bd6ec980$var$createStateOperator(removeOneMutably),
        removeMany: $58dad493bd6ec980$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $58dad493bd6ec980$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $58dad493bd6ec980$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $58dad493bd6ec980$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $58dad493bd6ec980$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds !== null && existingIds !== void 0 ? existingIds : $58dad493bd6ec980$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($58dad493bd6ec980$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $58dad493bd6ec980$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $58dad493bd6ec980$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $58dad493bd6ec980$var$getCurrent(state.entities);
        const currentIds = $58dad493bd6ec980$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $58dad493bd6ec980$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $58dad493bd6ec980$var$createStateOperator(addOneMutably),
        updateOne: $58dad493bd6ec980$var$createStateOperator(updateOneMutably),
        upsertOne: $58dad493bd6ec980$var$createStateOperator(upsertOneMutably),
        setOne: $58dad493bd6ec980$var$createStateOperator(setOneMutably),
        setMany: $58dad493bd6ec980$var$createStateOperator(setManyMutably),
        setAll: $58dad493bd6ec980$var$createStateOperator(setAllMutably),
        addMany: $58dad493bd6ec980$var$createStateOperator(addManyMutably),
        updateMany: $58dad493bd6ec980$var$createStateOperator(updateManyMutably),
        upsertMany: $58dad493bd6ec980$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $58dad493bd6ec980$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $58dad493bd6ec980$var$createSortedStateAdapter(selectId, sortComparer) : $58dad493bd6ec980$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $58dad493bd6ec980$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $58dad493bd6ec980$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $58dad493bd6ec980$var$task = "task";
var $58dad493bd6ec980$var$listener = "listener";
var $58dad493bd6ec980$var$completed = "completed";
var $58dad493bd6ec980$var$cancelled = "cancelled";
var $58dad493bd6ec980$var$taskCancelled = `task-${$58dad493bd6ec980$var$cancelled}`;
var $58dad493bd6ec980$var$taskCompleted = `task-${$58dad493bd6ec980$var$completed}`;
var $58dad493bd6ec980$var$listenerCancelled = `${$58dad493bd6ec980$var$listener}-${$58dad493bd6ec980$var$cancelled}`;
var $58dad493bd6ec980$var$listenerCompleted = `${$58dad493bd6ec980$var$listener}-${$58dad493bd6ec980$var$completed}`;
var $58dad493bd6ec980$export$cb1bdac908fed7f = class {
    constructor(code){
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "name", "TaskAbortError");
        (0, $3714350acbe00f73$export$71511d61b312f219)(this, "message", void 0);
        this.code = code;
        this.message = `${$58dad493bd6ec980$var$task} ${$58dad493bd6ec980$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $58dad493bd6ec980$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($58dad493bd6ec980$export$378fa86b259c0280(32));
};
var $58dad493bd6ec980$var$noop2 = ()=>{};
var $58dad493bd6ec980$var$catchRejection = (promise, onError = $58dad493bd6ec980$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $58dad493bd6ec980$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $58dad493bd6ec980$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $58dad493bd6ec980$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $58dad493bd6ec980$export$cb1bdac908fed7f(reason);
    }
};
function $58dad493bd6ec980$var$raceWithSignal(signal, promise) {
    let cleanup = $58dad493bd6ec980$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $58dad493bd6ec980$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $58dad493bd6ec980$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $58dad493bd6ec980$var$noop2;
    });
}
var $58dad493bd6ec980$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $58dad493bd6ec980$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp === null || cleanUp === void 0 ? void 0 : cleanUp();
    }
};
var $58dad493bd6ec980$var$createPause = (signal)=>{
    return (promise)=>{
        return $58dad493bd6ec980$var$catchRejection($58dad493bd6ec980$var$raceWithSignal(signal, promise).then((output)=>{
            $58dad493bd6ec980$var$validateActive(signal);
            return output;
        }));
    };
};
var $58dad493bd6ec980$var$createDelay = (signal)=>{
    const pause = $58dad493bd6ec980$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $58dad493bd6ec980$var$assign } = Object;
var $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN = {};
var $58dad493bd6ec980$var$alm = "listenerMiddleware";
var $58dad493bd6ec980$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$58dad493bd6ec980$var$addAbortSignalListener(parentAbortSignal, ()=>$58dad493bd6ec980$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $58dad493bd6ec980$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $58dad493bd6ec980$var$runTask(async ()=>{
            $58dad493bd6ec980$var$validateActive(parentAbortSignal);
            $58dad493bd6ec980$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $58dad493bd6ec980$var$createPause(childAbortController.signal),
                delay: $58dad493bd6ec980$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $58dad493bd6ec980$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$58dad493bd6ec980$var$abortControllerWithReason(childAbortController, $58dad493bd6ec980$var$taskCompleted));
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($58dad493bd6ec980$var$noop2));
        return {
            result: $58dad493bd6ec980$var$createPause(parentAbortSignal)(result),
            cancel () {
                $58dad493bd6ec980$var$abortControllerWithReason(childAbortController, $58dad493bd6ec980$var$taskCancelled);
            }
        };
    };
};
var $58dad493bd6ec980$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $58dad493bd6ec980$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $58dad493bd6ec980$var$raceWithSignal(signal, Promise.race(promises));
            $58dad493bd6ec980$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$58dad493bd6ec980$var$catchRejection(take(predicate, timeout));
};
var $58dad493bd6ec980$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $58dad493bd6ec980$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($58dad493bd6ec980$export$378fa86b259c0280(21));
    $58dad493bd6ec980$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $58dad493bd6ec980$var$createListenerEntry = /* @__PURE__ */ $58dad493bd6ec980$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $58dad493bd6ec980$var$getListenerEntryPropsFrom(options);
    const id = $58dad493bd6ec980$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($58dad493bd6ec980$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$58dad493bd6ec980$var$createListenerEntry
});
var $58dad493bd6ec980$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $58dad493bd6ec980$var$abortControllerWithReason(controller, $58dad493bd6ec980$var$listenerCancelled);
    });
};
var $58dad493bd6ec980$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($58dad493bd6ec980$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $58dad493bd6ec980$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $58dad493bd6ec980$export$f03a6b845d3fb58b = /* @__PURE__ */ $58dad493bd6ec980$var$assign(/* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/add`), {
    withTypes: ()=>$58dad493bd6ec980$export$f03a6b845d3fb58b
});
var $58dad493bd6ec980$export$b1b8022855fb2b71 = /* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/removeAll`);
var $58dad493bd6ec980$export$b03e9483f936dccb = /* @__PURE__ */ $58dad493bd6ec980$var$assign(/* @__PURE__ */ $58dad493bd6ec980$export$309c7a02b0b0bc62(`${$58dad493bd6ec980$var$alm}/remove`), {
    withTypes: ()=>$58dad493bd6ec980$export$b03e9483f936dccb
});
var $58dad493bd6ec980$var$defaultErrorHandler = (...args)=>{
    console.error(`${$58dad493bd6ec980$var$alm}/error`, ...args);
};
var $58dad493bd6ec980$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $58dad493bd6ec980$var$defaultErrorHandler } = middlewareOptions;
    $58dad493bd6ec980$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $58dad493bd6ec980$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $58dad493bd6ec980$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $58dad493bd6ec980$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $58dad493bd6ec980$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $58dad493bd6ec980$var$getListenerEntryPropsFrom(options);
        const entry = $58dad493bd6ec980$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $58dad493bd6ec980$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $58dad493bd6ec980$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $58dad493bd6ec980$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $58dad493bd6ec980$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $58dad493bd6ec980$var$createDelay(internalTaskController.signal),
                pause: $58dad493bd6ec980$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $58dad493bd6ec980$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $58dad493bd6ec980$var$abortControllerWithReason(controller, $58dad493bd6ec980$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $58dad493bd6ec980$var$abortControllerWithReason(internalTaskController, $58dad493bd6ec980$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $58dad493bd6ec980$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $58dad493bd6ec980$export$cb1bdac908fed7f)) $58dad493bd6ec980$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $58dad493bd6ec980$var$abortControllerWithReason(internalTaskController, $58dad493bd6ec980$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $58dad493bd6ec980$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $ac44486100bacc69$export$b956e38827fca970)(action)) return next(action);
                if ($58dad493bd6ec980$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($58dad493bd6ec980$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($58dad493bd6ec980$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $58dad493bd6ec980$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $58dad493bd6ec980$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $58dad493bd6ec980$var$createMiddlewareEntry = (middleware)=>({
        id: $58dad493bd6ec980$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $58dad493bd6ec980$var$matchInstance = (instanceId)=>(action)=>{
        var _action_meta;
        return (action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta.instanceId) === instanceId;
    };
var $58dad493bd6ec980$export$4bb1606a79445586 = ()=>{
    const instanceId = $58dad493bd6ec980$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($58dad493bd6ec980$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $58dad493bd6ec980$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $58dad493bd6ec980$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$58dad493bd6ec980$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $ac44486100bacc69$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $58dad493bd6ec980$export$9dd1fb32974da385(withMiddleware, $58dad493bd6ec980$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $58dad493bd6ec980$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $58dad493bd6ec980$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$58dad493bd6ec980$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $58dad493bd6ec980$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $58dad493bd6ec980$var$isStateProxy = (value)=>!!value && !!value[$58dad493bd6ec980$var$ORIGINAL_STATE];
var $58dad493bd6ec980$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $58dad493bd6ec980$var$createStateProxy = (state, reducerMap)=>$58dad493bd6ec980$var$emplace($58dad493bd6ec980$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $58dad493bd6ec980$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $58dad493bd6ec980$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($58dad493bd6ec980$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $58dad493bd6ec980$var$original = (state)=>{
    if (!$58dad493bd6ec980$var$isStateProxy(state)) throw new Error($58dad493bd6ec980$export$378fa86b259c0280(25));
    return state[$58dad493bd6ec980$var$ORIGINAL_STATE];
};
var $58dad493bd6ec980$var$noopReducer = (state = {})=>state;
function $58dad493bd6ec980$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($58dad493bd6ec980$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $ac44486100bacc69$export$66e4520cdb265d18)(reducerMap) : $58dad493bd6ec980$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $lUPho;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($58dad493bd6ec980$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $58dad493bd6ec980$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $58dad493bd6ec980$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


var $0bfd6a77e39eae31$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $0bfd6a77e39eae31$var$R = typeof Reflect === "object" ? Reflect : null;
var $0bfd6a77e39eae31$var$ReflectApply = $0bfd6a77e39eae31$var$R && typeof $0bfd6a77e39eae31$var$R.apply === "function" ? $0bfd6a77e39eae31$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $0bfd6a77e39eae31$var$ReflectOwnKeys;
if ($0bfd6a77e39eae31$var$R && typeof $0bfd6a77e39eae31$var$R.ownKeys === "function") $0bfd6a77e39eae31$var$ReflectOwnKeys = $0bfd6a77e39eae31$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $0bfd6a77e39eae31$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $0bfd6a77e39eae31$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $0bfd6a77e39eae31$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $0bfd6a77e39eae31$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $0bfd6a77e39eae31$var$EventEmitter() {
    $0bfd6a77e39eae31$var$EventEmitter.init.call(this);
}
$0bfd6a77e39eae31$exports = $0bfd6a77e39eae31$var$EventEmitter;
$0bfd6a77e39eae31$exports.once = $0bfd6a77e39eae31$var$once;
// Backwards-compat with node 0.10.x
$0bfd6a77e39eae31$var$EventEmitter.EventEmitter = $0bfd6a77e39eae31$var$EventEmitter;
$0bfd6a77e39eae31$var$EventEmitter.prototype._events = undefined;
$0bfd6a77e39eae31$var$EventEmitter.prototype._eventsCount = 0;
$0bfd6a77e39eae31$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $0bfd6a77e39eae31$var$defaultMaxListeners = 10;
function $0bfd6a77e39eae31$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($0bfd6a77e39eae31$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $0bfd6a77e39eae31$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $0bfd6a77e39eae31$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $0bfd6a77e39eae31$var$defaultMaxListeners = arg;
    }
});
$0bfd6a77e39eae31$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$0bfd6a77e39eae31$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $0bfd6a77e39eae31$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $0bfd6a77e39eae31$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $0bfd6a77e39eae31$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $0bfd6a77e39eae31$var$_getMaxListeners(this);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $0bfd6a77e39eae31$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $0bfd6a77e39eae31$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$0bfd6a77e39eae31$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $0bfd6a77e39eae31$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $0bfd6a77e39eae31$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $0bfd6a77e39eae31$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $0bfd6a77e39eae31$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $0bfd6a77e39eae31$var$_addListener(this, type, listener, false);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.on = $0bfd6a77e39eae31$var$EventEmitter.prototype.addListener;
$0bfd6a77e39eae31$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $0bfd6a77e39eae31$var$_addListener(this, type, listener, true);
};
function $0bfd6a77e39eae31$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $0bfd6a77e39eae31$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $0bfd6a77e39eae31$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.once = function once(type, listener) {
    $0bfd6a77e39eae31$var$checkListener(listener);
    this.on(type, $0bfd6a77e39eae31$var$_onceWrap(this, type, listener));
    return this;
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $0bfd6a77e39eae31$var$checkListener(listener);
    this.prependListener(type, $0bfd6a77e39eae31$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$0bfd6a77e39eae31$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $0bfd6a77e39eae31$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $0bfd6a77e39eae31$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.off = $0bfd6a77e39eae31$var$EventEmitter.prototype.removeListener;
$0bfd6a77e39eae31$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $0bfd6a77e39eae31$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $0bfd6a77e39eae31$var$unwrapListeners(evlistener) : $0bfd6a77e39eae31$var$arrayClone(evlistener, evlistener.length);
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $0bfd6a77e39eae31$var$_listeners(this, type, true);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $0bfd6a77e39eae31$var$_listeners(this, type, false);
};
$0bfd6a77e39eae31$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $0bfd6a77e39eae31$var$listenerCount.call(emitter, type);
};
$0bfd6a77e39eae31$var$EventEmitter.prototype.listenerCount = $0bfd6a77e39eae31$var$listenerCount;
function $0bfd6a77e39eae31$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$0bfd6a77e39eae31$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $0bfd6a77e39eae31$var$ReflectOwnKeys(this._events) : [];
};
function $0bfd6a77e39eae31$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $0bfd6a77e39eae31$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $0bfd6a77e39eae31$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $0bfd6a77e39eae31$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $0bfd6a77e39eae31$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $0bfd6a77e39eae31$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $0bfd6a77e39eae31$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $92a5db02d3c83225$exports = {};
"use strict";
var $92a5db02d3c83225$var$__createBinding = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $92a5db02d3c83225$var$__setModuleDefault = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $92a5db02d3c83225$var$__importStar = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $92a5db02d3c83225$var$__createBinding(result, mod, k);
    }
    $92a5db02d3c83225$var$__setModuleDefault(result, mod);
    return result;
};
var $92a5db02d3c83225$var$__importDefault = $92a5db02d3c83225$exports && $92a5db02d3c83225$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($92a5db02d3c83225$exports, "__esModule", {
    value: true
});
$92a5db02d3c83225$exports.debug = $92a5db02d3c83225$exports.parseScalabilityMode = $92a5db02d3c83225$exports.detectDevice = $92a5db02d3c83225$exports.Device = $92a5db02d3c83225$exports.version = $92a5db02d3c83225$exports.types = void 0;

const $92a5db02d3c83225$var$debug_1 = $92a5db02d3c83225$var$__importDefault((parcelRequire("8pLEx")));
$92a5db02d3c83225$exports.debug = $92a5db02d3c83225$var$debug_1.default;

var $46xMb = parcelRequire("46xMb");
Object.defineProperty($92a5db02d3c83225$exports, "Device", {
    enumerable: true,
    get: function() {
        return $46xMb.Device;
    }
});
Object.defineProperty($92a5db02d3c83225$exports, "detectDevice", {
    enumerable: true,
    get: function() {
        return $46xMb.detectDevice;
    }
});

const $92a5db02d3c83225$var$types = $92a5db02d3c83225$var$__importStar((parcelRequire("5Mrx3")));
$92a5db02d3c83225$exports.types = $92a5db02d3c83225$var$types;
/**
 * Expose mediasoup-client version.
 */ $92a5db02d3c83225$exports.version = "3.7.12";

var $2VyLC = parcelRequire("2VyLC");
Object.defineProperty($92a5db02d3c83225$exports, "parseScalabilityMode", {
    enumerable: true,
    get: function() {
        return $2VyLC.parse;
    }
});


/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
let $24d6efb1dadd4b9f$var$logDisabled_ = true;
let $24d6efb1dadd4b9f$var$deprecationWarnings_ = true;
function $24d6efb1dadd4b9f$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $24d6efb1dadd4b9f$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $24d6efb1dadd4b9f$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $24d6efb1dadd4b9f$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function $24d6efb1dadd4b9f$export$51516be4b019e41e(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $24d6efb1dadd4b9f$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $24d6efb1dadd4b9f$export$bef1f36f5486a6a3() {
    if (typeof window === "object") {
        if ($24d6efb1dadd4b9f$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
function $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$24d6efb1dadd4b9f$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function $24d6efb1dadd4b9f$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = "firefox";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = "safari";
        result.version = $24d6efb1dadd4b9f$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $24d6efb1dadd4b9f$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $24d6efb1dadd4b9f$export$15384eac40dc88c8(data) {
    if (!$24d6efb1dadd4b9f$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $24d6efb1dadd4b9f$var$isObject(data[key]);
        const value = isObj ? $24d6efb1dadd4b9f$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $24d6efb1dadd4b9f$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $24d6efb1dadd4b9f$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $24d6efb1dadd4b9f$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $24d6efb1dadd4b9f$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $24d6efb1dadd4b9f$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $0f5f96d4bc674de6$exports = {};

$parcel$export($0f5f96d4bc674de6$exports, "shimMediaStream", function () { return $0f5f96d4bc674de6$export$33ee24e7a300bcd1; });
$parcel$export($0f5f96d4bc674de6$exports, "shimOnTrack", function () { return $0f5f96d4bc674de6$export$f358708f68ab068; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetSendersWithDtmf", function () { return $0f5f96d4bc674de6$export$a41a030a2842f5d6; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetStats", function () { return $0f5f96d4bc674de6$export$90608323826f0b17; });
$parcel$export($0f5f96d4bc674de6$exports, "shimSenderReceiverGetStats", function () { return $0f5f96d4bc674de6$export$f2f0f2338114eb4b; });
$parcel$export($0f5f96d4bc674de6$exports, "shimAddTrackRemoveTrackWithNative", function () { return $0f5f96d4bc674de6$export$30e3cdd46f8d5100; });
$parcel$export($0f5f96d4bc674de6$exports, "shimAddTrackRemoveTrack", function () { return $0f5f96d4bc674de6$export$9588259fcf4ebc91; });
$parcel$export($0f5f96d4bc674de6$exports, "shimPeerConnection", function () { return $0f5f96d4bc674de6$export$852a08dda9a55ea7; });
$parcel$export($0f5f96d4bc674de6$exports, "fixNegotiationNeeded", function () { return $0f5f96d4bc674de6$export$341293bbeaae37cb; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetUserMedia", function () { return $9a24537987145037$export$1ed4910f4d37dc5e; });
$parcel$export($0f5f96d4bc674de6$exports, "shimGetDisplayMedia", function () { return $924ae67a9c2d1ee2$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
const $9a24537987145037$var$logging = $24d6efb1dadd4b9f$export$bef1f36f5486a6a3;
function $9a24537987145037$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $9a24537987145037$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $9a24537987145037$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $924ae67a9c2d1ee2$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== "function") {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


"use strict";
function $0f5f96d4bc674de6$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $0f5f96d4bc674de6$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCPeerConnection && !("ontrack" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $0f5f96d4bc674de6$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === "object" && window.RTCPeerConnection && !("getSenders" in window.RTCPeerConnection.prototype) && "createDTMFSender" in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === "object" && window.RTCPeerConnection && "getSenders" in window.RTCPeerConnection.prototype && "createDTMFSender" in window.RTCPeerConnection.prototype && window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $0f5f96d4bc674de6$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === "function") return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: "local-candidate",
                        remotecandidate: "remote-candidate"
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $0f5f96d4bc674de6$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $24d6efb1dadd4b9f$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$24d6efb1dadd4b9f$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!("getStats" in window.RTCRtpSender.prototype && "getStats" in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $0f5f96d4bc674de6$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $0f5f96d4bc674de6$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $0f5f96d4bc674de6$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $0f5f96d4bc674de6$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $0f5f96d4bc674de6$export$341293bbeaae37cb(window, browserDetails) {
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}


var $c394a215b7aa1c4a$exports = {};

$parcel$export($c394a215b7aa1c4a$exports, "shimOnTrack", function () { return $c394a215b7aa1c4a$export$f358708f68ab068; });
$parcel$export($c394a215b7aa1c4a$exports, "shimPeerConnection", function () { return $c394a215b7aa1c4a$export$852a08dda9a55ea7; });
$parcel$export($c394a215b7aa1c4a$exports, "shimSenderGetStats", function () { return $c394a215b7aa1c4a$export$f0525502095c04ef; });
$parcel$export($c394a215b7aa1c4a$exports, "shimReceiverGetStats", function () { return $c394a215b7aa1c4a$export$83d69126527b1171; });
$parcel$export($c394a215b7aa1c4a$exports, "shimRemoveStream", function () { return $c394a215b7aa1c4a$export$825e523ef749bd8c; });
$parcel$export($c394a215b7aa1c4a$exports, "shimRTCDataChannel", function () { return $c394a215b7aa1c4a$export$ff9cb3bc8990e8f7; });
$parcel$export($c394a215b7aa1c4a$exports, "shimAddTransceiver", function () { return $c394a215b7aa1c4a$export$70c77533b6e9908d; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetParameters", function () { return $c394a215b7aa1c4a$export$66238223c298fbaa; });
$parcel$export($c394a215b7aa1c4a$exports, "shimCreateOffer", function () { return $c394a215b7aa1c4a$export$51beccf0e777b843; });
$parcel$export($c394a215b7aa1c4a$exports, "shimCreateAnswer", function () { return $c394a215b7aa1c4a$export$df0b46e7cef08150; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetUserMedia", function () { return $4f6e77f21e9dcaca$export$1ed4910f4d37dc5e; });
$parcel$export($c394a215b7aa1c4a$exports, "shimGetDisplayMedia", function () { return $575d447985d506b6$export$97270b87351d9c04; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
"use strict";
function $4f6e77f21e9dcaca$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $575d447985d506b6$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


"use strict";
function $c394a215b7aa1c4a$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c394a215b7aa1c4a$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== "object" || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c394a215b7aa1c4a$export$f0525502095c04ef(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c394a215b7aa1c4a$export$83d69126527b1171(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c394a215b7aa1c4a$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || "removeStream" in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c394a215b7aa1c4a$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $c394a215b7aa1c4a$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c394a215b7aa1c4a$export$66238223c298fbaa(window) {
    if (!(typeof window === "object" && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c394a215b7aa1c4a$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c394a215b7aa1c4a$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $beb18f76628524f9$exports = {};

$parcel$export($beb18f76628524f9$exports, "shimLocalStreamsAPI", function () { return $beb18f76628524f9$export$8df41282f4fdcea2; });
$parcel$export($beb18f76628524f9$exports, "shimRemoteStreamsAPI", function () { return $beb18f76628524f9$export$762aa4cbb4f2f857; });
$parcel$export($beb18f76628524f9$exports, "shimCallbacksAPI", function () { return $beb18f76628524f9$export$da31df245debdd3; });
$parcel$export($beb18f76628524f9$exports, "shimGetUserMedia", function () { return $beb18f76628524f9$export$1ed4910f4d37dc5e; });
$parcel$export($beb18f76628524f9$exports, "shimConstraints", function () { return $beb18f76628524f9$export$494a01ac68ba81ac; });
$parcel$export($beb18f76628524f9$exports, "shimRTCIceServerUrls", function () { return $beb18f76628524f9$export$671a8b47b41b6f41; });
$parcel$export($beb18f76628524f9$exports, "shimTrackEventTransceiver", function () { return $beb18f76628524f9$export$85d53da088cb1b14; });
$parcel$export($beb18f76628524f9$exports, "shimCreateOfferLegacy", function () { return $beb18f76628524f9$export$d444266503fdd2d4; });
$parcel$export($beb18f76628524f9$exports, "shimAudioContext", function () { return $beb18f76628524f9$export$857cd739a7b795d2; });
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
"use strict";
function $beb18f76628524f9$export$8df41282f4fdcea2(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getLocalStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $beb18f76628524f9$export$762aa4cbb4f2f857(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $beb18f76628524f9$export$da31df245debdd3(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $beb18f76628524f9$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($beb18f76628524f9$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $beb18f76628524f9$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $24d6efb1dadd4b9f$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $beb18f76628524f9$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $24d6efb1dadd4b9f$export$cdd73fc4100a6ef4("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $beb18f76628524f9$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $beb18f76628524f9$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio", {
                direction: "recvonly"
            });
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video", {
                direction: "recvonly"
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $beb18f76628524f9$export$857cd739a7b795d2(window) {
    if (typeof window !== "object" || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $73c182a18afe8a0b$exports = {};

$parcel$export($73c182a18afe8a0b$exports, "shimRTCIceCandidate", function () { return $73c182a18afe8a0b$export$cf133661e444ccfe; });
$parcel$export($73c182a18afe8a0b$exports, "shimRTCIceCandidateRelayProtocol", function () { return $73c182a18afe8a0b$export$fdafb8d8280e29b5; });
$parcel$export($73c182a18afe8a0b$exports, "shimMaxMessageSize", function () { return $73c182a18afe8a0b$export$a99147c78a56edc4; });
$parcel$export($73c182a18afe8a0b$exports, "shimSendThrowTypeError", function () { return $73c182a18afe8a0b$export$d461c8d5c5db5da7; });
$parcel$export($73c182a18afe8a0b$exports, "shimConnectionState", function () { return $73c182a18afe8a0b$export$63bb816cc75460; });
$parcel$export($73c182a18afe8a0b$exports, "removeExtmapAllowMixed", function () { return $73c182a18afe8a0b$export$a57d114344295149; });
$parcel$export($73c182a18afe8a0b$exports, "shimAddIceCandidateNullOrEmpty", function () { return $73c182a18afe8a0b$export$51d5e40b48c771c7; });
$parcel$export($73c182a18afe8a0b$exports, "shimParameterlessSetLocalDescription", function () { return $73c182a18afe8a0b$export$7170d04e59f9d553; });
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $7457294ed7ab71f3$exports = {};
/* eslint-env node */ "use strict";
// SDP helpers.
const $7457294ed7ab71f3$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$7457294ed7ab71f3$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$7457294ed7ab71f3$var$SDPUtils.localCName = $7457294ed7ab71f3$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$7457294ed7ab71f3$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$7457294ed7ab71f3$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split("\nm=");
    return parts.map((part, index)=>(index > 0 ? "m=" + part : part).trim() + "\r\n");
};
// Returns the session description.
$7457294ed7ab71f3$var$SDPUtils.getDescription = function(blob) {
    const sections = $7457294ed7ab71f3$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$7457294ed7ab71f3$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $7457294ed7ab71f3$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$7457294ed7ab71f3$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $7457294ed7ab71f3$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$7457294ed7ab71f3$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    const candidate = {
        foundation: parts[0],
        component: {
            1: "rtp",
            2: "rtcp"
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$7457294ed7ab71f3$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === "rtp") sdp.push(1);
    else if (component === "rtcp") sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$7457294ed7ab71f3$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(" ");
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$7457294ed7ab71f3$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(" ");
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$7457294ed7ab71f3$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1],
        attributes: parts.slice(2).join(" ")
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$7457294ed7ab71f3$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + (headerExtension.attributes ? " " + headerExtension.attributes : "") + "\r\n";
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$7457294ed7ab71f3$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(" ") + 1).split(";");
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeFmtp = function(codec) {
    let line = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$7457294ed7ab71f3$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = "";
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(" ");
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$7457294ed7ab71f3$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$7457294ed7ab71f3$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$7457294ed7ab71f3$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$7457294ed7ab71f3$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($7457294ed7ab71f3$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$7457294ed7ab71f3$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach((fp)=>{
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$7457294ed7ab71f3$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$7457294ed7ab71f3$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $7457294ed7ab71f3$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$7457294ed7ab71f3$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    const parts = keyParams.substring(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$7457294ed7ab71f3$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES parameters.
$7457294ed7ab71f3$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($7457294ed7ab71f3$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$7457294ed7ab71f3$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    const pwd = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$7457294ed7ab71f3$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
    if (params.iceLite) sdp += "a=ice-lite\r\n";
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$7457294ed7ab71f3$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            const codec = $7457294ed7ab71f3$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $7457294ed7ab71f3$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($7457294ed7ab71f3$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach((line)=>{
        description.headerExtensions.push($7457294ed7ab71f3$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:* ").map($7457294ed7ab71f3$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$7457294ed7ab71f3$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " " + (caps.profile || "UDP/TLS/RTP/SAVPF") + " ";
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeRtpMap(codec);
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeFmtp(codec);
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $7457294ed7ab71f3$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$7457294ed7ab71f3$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $7457294ed7ab71f3$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === "cname");
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map((line)=>{
        const parts = line.substring(17).split(" ");
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$7457294ed7ab71f3$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === "cname")[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$7457294ed7ab71f3$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = "";
    if (rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
    if (rtcpParameters.mux) sdp += "a=rtcp-mux\r\n";
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += "a=ssrc:" + rtcpParameters.ssrc + " cname:" + rtcpParameters.cname + "\r\n";
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$7457294ed7ab71f3$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map((line)=>$7457294ed7ab71f3$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === "msid");
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$7457294ed7ab71f3$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $7457294ed7ab71f3$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$7457294ed7ab71f3$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$7457294ed7ab71f3$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$7457294ed7ab71f3$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $7457294ed7ab71f3$var$SDPUtils.generateSessionId();
    const user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
// Gets the direction from the mediaSection or the sessionpart.
$7457294ed7ab71f3$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $7457294ed7ab71f3$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$7457294ed7ab71f3$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(" ");
    return mline[0].substring(2);
};
$7457294ed7ab71f3$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$7457294ed7ab71f3$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$7457294ed7ab71f3$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $7457294ed7ab71f3$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    const parts = line.substring(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$7457294ed7ab71f3$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    const lines = $7457294ed7ab71f3$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$7457294ed7ab71f3$exports = $7457294ed7ab71f3$var$SDPUtils;



"use strict";
function $73c182a18afe8a0b$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "foundation" in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $73c182a18afe8a0b$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "relayProtocol" in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "icecandidate", (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === "relay") // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: "tls",
                1: "tcp",
                2: "udp"
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!("sctp" in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && "createDataChannel" in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $24d6efb1dadd4b9f$export$1f48841962b828b1(window, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $73c182a18afe8a0b$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || "connectionState" in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== "object" || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case "stable":
            case "have-local-offer":
            case "have-remote-pranswer":
                desc.type = "offer";
                break;
            default:
                desc.type = "answer";
                break;
        }
        if (desc.sdp || desc.type !== "offer" && desc.type !== "answer") return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === "offer" ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $eda9b19400c11783$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $24d6efb1dadd4b9f$export$bef1f36f5486a6a3;
    const browserDetails = $24d6efb1dadd4b9f$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $73c182a18afe8a0b$exports,
        extractVersion: $24d6efb1dadd4b9f$export$e3c02be309be1f23,
        disableLog: $24d6efb1dadd4b9f$export$afbfee8cc06fd3e4,
        disableWarnings: $24d6efb1dadd4b9f$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $7457294ed7ab71f3$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$0f5f96d4bc674de6$exports || !$0f5f96d4bc674de6$exports.shimPeerConnection || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $0f5f96d4bc674de6$exports;
            // Must be called before shimPeerConnection.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetUserMedia(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimMediaStream(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimPeerConnection(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimOnTrack(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetSendersWithDtmf(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimGetStats(window, browserDetails);
            $0f5f96d4bc674de6$exports.shimSenderReceiverGetStats(window, browserDetails);
            $0f5f96d4bc674de6$exports.fixNegotiationNeeded(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$fdafb8d8280e29b5(window, browserDetails);
            $73c182a18afe8a0b$export$63bb816cc75460(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails);
            break;
        case "firefox":
            if (!$c394a215b7aa1c4a$exports || !$c394a215b7aa1c4a$exports.shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c394a215b7aa1c4a$exports;
            // Must be called before shimPeerConnection.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimGetUserMedia(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimPeerConnection(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimOnTrack(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimRemoveStream(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimSenderGetStats(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimReceiverGetStats(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimRTCDataChannel(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimAddTransceiver(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimGetParameters(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimCreateOffer(window, browserDetails);
            $c394a215b7aa1c4a$exports.shimCreateAnswer(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$63bb816cc75460(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case "safari":
            if (!$beb18f76628524f9$exports || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $beb18f76628524f9$exports;
            // Must be called before shimCallbackAPI.
            $73c182a18afe8a0b$export$51d5e40b48c771c7(window, browserDetails);
            $73c182a18afe8a0b$export$7170d04e59f9d553(window, browserDetails);
            $beb18f76628524f9$exports.shimRTCIceServerUrls(window, browserDetails);
            $beb18f76628524f9$exports.shimCreateOfferLegacy(window, browserDetails);
            $beb18f76628524f9$exports.shimCallbacksAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimLocalStreamsAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimRemoteStreamsAPI(window, browserDetails);
            $beb18f76628524f9$exports.shimTrackEventTransceiver(window, browserDetails);
            $beb18f76628524f9$exports.shimGetUserMedia(window, browserDetails);
            $beb18f76628524f9$exports.shimAudioContext(window, browserDetails);
            $73c182a18afe8a0b$export$cf133661e444ccfe(window, browserDetails);
            $73c182a18afe8a0b$export$fdafb8d8280e29b5(window, browserDetails);
            $73c182a18afe8a0b$export$a99147c78a56edc4(window, browserDetails);
            $73c182a18afe8a0b$export$d461c8d5c5db5da7(window, browserDetails);
            $73c182a18afe8a0b$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}


"use strict";
const $c1c5c7a85a539550$var$adapter = (0, $eda9b19400c11783$export$e77bf46c04ac7d12)({
    window: typeof window === "undefined" ? undefined : window
});
var $c1c5c7a85a539550$export$2e2bcd8739ae039 = $c1c5c7a85a539550$var$adapter;


var $695e2205f7548c7a$exports = {};
"use strict";
// transforms a maplike to an object. Mostly for getStats +
// JSON.parse(JSON.stringify())
function $695e2205f7548c7a$var$map2obj(m) {
    if (!m.entries) return m;
    var o = {};
    m.forEach(function(v, k) {
        o[k] = v;
    });
    return o;
}
// apply a delta compression to the stats report. Reduces size by ~90%.
// To reduce further, report keys could be compressed.
function $695e2205f7548c7a$var$deltaCompression(oldStats, newStats) {
    newStats = JSON.parse(JSON.stringify(newStats));
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        delete report.id;
        if (!oldStats[id]) return;
        Object.keys(report).forEach(function(name) {
            if (report[name] === oldStats[id][name]) delete newStats[id][name];
            if (Object.keys(report).length === 0) delete newStats[id];
            else if (Object.keys(report).length === 1 && report.timestamp) delete newStats[id];
        });
    });
    var timestamp = -Infinity;
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        if (report.timestamp > timestamp) timestamp = report.timestamp;
    });
    Object.keys(newStats).forEach(function(id) {
        var report = newStats[id];
        if (report.timestamp === timestamp) report.timestamp = 0;
    });
    newStats.timestamp = timestamp;
    return newStats;
}
function $695e2205f7548c7a$var$dumpStream(stream) {
    return {
        id: stream.id,
        tracks: stream.getTracks().map(function(track) {
            return {
                id: track.id,
                kind: track.kind,
                label: track.label,
                enabled: track.enabled,
                muted: track.muted,
                readyState: track.readyState
            };
        })
    };
}
/*
function filterBoringStats(results) {
  Object.keys(results).forEach(function(id) {
    switch (results[id].type) {
      case 'certificate':
      case 'codec':
        delete results[id];
        break;
      default:
        // noop
    }
  });
  return results;
}

function removeTimestamps(results) {
  // FIXME: does not work in FF since the timestamp can't be deleted.
  Object.keys(results).forEach(function(id) {
    delete results[id].timestamp;
  });
  return results;
}
*/ $695e2205f7548c7a$exports = function(trace, getStatsInterval, prefixesToWrap) {
    var peerconnectioncounter = 0;
    var isFirefox = !!window.mozRTCPeerConnection;
    var isEdge = !!window.RTCIceGatherer;
    var prevById = {};
    prefixesToWrap.forEach(function(prefix) {
        if (!window[prefix + "RTCPeerConnection"]) return;
        if (prefix === "webkit" && isEdge) // dont wrap webkitRTCPeerconnection in Edge.
        return;
        var origPeerConnection = window[prefix + "RTCPeerConnection"];
        var peerconnection = function(config, constraints) {
            var pc = new origPeerConnection(config, constraints);
            var id = "PC_" + peerconnectioncounter++;
            pc.__rtcStatsId = id;
            if (!config) config = {
                nullConfig: true
            };
            config = JSON.parse(JSON.stringify(config)); // deepcopy
            // don't log credentials
            (config && config.iceServers || []).forEach(function(server) {
                delete server.credential;
            });
            if (isFirefox) config.browserType = "moz";
            else if (isEdge) config.browserType = "edge";
            else config.browserType = "webkit";
            trace("create", id, config);
            // TODO: do we want to log constraints here? They are chrome-proprietary.
            // http://stackoverflow.com/questions/31003928/what-do-each-of-these-experimental-goog-rtcpeerconnectionconstraints-do
            if (constraints) trace("constraints", id, constraints);
            pc.addEventListener("icecandidate", function(e) {
                trace("onicecandidate", id, e.candidate);
            });
            pc.addEventListener("addstream", function(e) {
                trace("onaddstream", id, e.stream.id + " " + e.stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }));
            });
            pc.addEventListener("track", function(e) {
                trace("ontrack", id, e.track.kind + ":" + e.track.id + " " + e.streams.map(function(stream) {
                    return "stream:" + stream.id;
                }));
            });
            pc.addEventListener("removestream", function(e) {
                trace("onremovestream", id, e.stream.id + " " + e.stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }));
            });
            pc.addEventListener("signalingstatechange", function() {
                trace("onsignalingstatechange", id, pc.signalingState);
            });
            pc.addEventListener("iceconnectionstatechange", function() {
                trace("oniceconnectionstatechange", id, pc.iceConnectionState);
            });
            pc.addEventListener("icegatheringstatechange", function() {
                trace("onicegatheringstatechange", id, pc.iceGatheringState);
            });
            pc.addEventListener("connectionstatechange", function() {
                trace("onconnectionstatechange", id, pc.connectionState);
            });
            pc.addEventListener("negotiationneeded", function() {
                trace("onnegotiationneeded", id, undefined);
            });
            pc.addEventListener("datachannel", function(event) {
                trace("ondatachannel", id, [
                    event.channel.id,
                    event.channel.label
                ]);
            });
            var getStats = function() {
                pc.getStats(null).then(function(res) {
                    var now = $695e2205f7548c7a$var$map2obj(res);
                    var base = JSON.parse(JSON.stringify(now)); // our new prev
                    trace("getstats", id, $695e2205f7548c7a$var$deltaCompression(prevById[id] || {}, now));
                    prevById[id] = base;
                });
            };
            // TODO: do we want one big interval and all peerconnections
            //    queried in that or one setInterval per PC?
            //    we have to collect results anyway so...
            if (!isEdge && getStatsInterval) var interval = window.setInterval(function() {
                if (pc.signalingState === "closed") {
                    window.clearInterval(interval);
                    return;
                }
                getStats();
            }, getStatsInterval);
            if (!isEdge) pc.addEventListener("connectionstatechange", function() {
                if (pc.connectionState === "connected" || pc.connectionState === "failed") getStats();
            });
            return pc;
        };
        [
            "createDataChannel",
            "close"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                trace(method, this.__rtcStatsId, arguments);
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "addStream",
            "removeStream"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var stream = arguments[0];
                var streamInfo = stream.getTracks().map(function(t) {
                    return t.kind + ":" + t.id;
                }).join(",");
                trace(method, this.__rtcStatsId, stream.id + " " + streamInfo);
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "addTrack"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var track = arguments[0];
                var streams = [].slice.call(arguments, 1);
                trace(method, this.__rtcStatsId, track.kind + ":" + track.id + " " + (streams.map(function(s) {
                    return "stream:" + s.id;
                }).join(";") || "-"));
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "removeTrack"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var track = arguments[0].track;
                trace(method, this.__rtcStatsId, track ? track.kind + ":" + track.id : "null");
                return nativeMethod.apply(this, arguments);
            };
        });
        [
            "createOffer",
            "createAnswer"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var rtcStatsId = this.__rtcStatsId;
                var args = arguments;
                var opts;
                if (arguments.length === 1 && typeof arguments[0] === "object") opts = arguments[0];
                else if (arguments.length === 3 && typeof arguments[2] === "object") opts = arguments[2];
                trace(method, this.__rtcStatsId, opts);
                return nativeMethod.apply(this, opts ? [
                    opts
                ] : undefined).then(function(description) {
                    trace(method + "OnSuccess", rtcStatsId, description);
                    if (args.length > 0 && typeof args[0] === "function") {
                        args[0].apply(null, [
                            description
                        ]);
                        return undefined;
                    }
                    return description;
                }, function(err) {
                    trace(method + "OnFailure", rtcStatsId, err.toString());
                    if (args.length > 1 && typeof args[1] === "function") {
                        args[1].apply(null, [
                            err
                        ]);
                        return;
                    }
                    throw err;
                });
            };
        });
        [
            "setLocalDescription",
            "setRemoteDescription",
            "addIceCandidate"
        ].forEach(function(method) {
            var nativeMethod = origPeerConnection.prototype[method];
            if (nativeMethod) origPeerConnection.prototype[method] = function() {
                var rtcStatsId = this.__rtcStatsId;
                var args = arguments;
                trace(method, this.__rtcStatsId, args[0]);
                return nativeMethod.apply(this, [
                    args[0]
                ]).then(function() {
                    trace(method + "OnSuccess", rtcStatsId, undefined);
                    if (args.length >= 2 && typeof args[1] === "function") {
                        args[1].apply(null, []);
                        return undefined;
                    }
                    return undefined;
                }, function(err) {
                    trace(method + "OnFailure", rtcStatsId, err.toString());
                    if (args.length >= 3 && typeof args[2] === "function") {
                        args[2].apply(null, [
                            err
                        ]);
                        return undefined;
                    }
                    throw err;
                });
            };
        });
        // wrap static methods. Currently just generateCertificate.
        if (origPeerConnection.generateCertificate) Object.defineProperty(peerconnection, "generateCertificate", {
            get: function() {
                return arguments.length ? origPeerConnection.generateCertificate.apply(null, arguments) : origPeerConnection.generateCertificate;
            }
        });
        window[prefix + "RTCPeerConnection"] = peerconnection;
        window[prefix + "RTCPeerConnection"].prototype = origPeerConnection.prototype;
    });
    // getUserMedia wrappers
    prefixesToWrap.forEach(function(prefix) {
        var name = prefix + (prefix.length ? "GetUserMedia" : "getUserMedia");
        if (!navigator[name]) return;
        var origGetUserMedia = navigator[name].bind(navigator);
        var gum = function() {
            trace("getUserMedia", null, arguments[0]);
            var cb = arguments[1];
            var eb = arguments[2];
            origGetUserMedia(arguments[0], function(stream) {
                // we log the stream id, track ids and tracks readystate since that is ended GUM fails
                // to acquire the cam (in chrome)
                trace("getUserMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                if (cb) cb(stream);
            }, function(err) {
                trace("getUserMediaOnFailure", null, err.name);
                if (eb) eb(err);
            });
        };
        navigator[name] = gum.bind(navigator);
    });
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        var gum = function() {
            trace("navigator.mediaDevices.getUserMedia", null, arguments[0]);
            return origGetUserMedia.apply(navigator.mediaDevices, arguments).then(function(stream) {
                trace("navigator.mediaDevices.getUserMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                return stream;
            }, function(err) {
                trace("navigator.mediaDevices.getUserMediaOnFailure", null, err.name);
                return Promise.reject(err);
            });
        };
        navigator.mediaDevices.getUserMedia = gum.bind(navigator.mediaDevices);
    }
    // getDisplayMedia
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) {
        var origGetDisplayMedia = navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);
        var gdm = function() {
            trace("navigator.mediaDevices.getDisplayMedia", null, arguments[0]);
            return origGetDisplayMedia.apply(navigator.mediaDevices, arguments).then(function(stream) {
                trace("navigator.mediaDevices.getDisplayMediaOnSuccess", null, $695e2205f7548c7a$var$dumpStream(stream));
                return stream;
            }, function(err) {
                trace("navigator.mediaDevices.getDisplayMediaOnFailure", null, err.name);
                return Promise.reject(err);
            });
        };
        navigator.mediaDevices.getDisplayMedia = gdm.bind(navigator.mediaDevices);
    }
    // TODO: are there events defined on MST that would allow us to listen when enabled was set?
    //    no :-(
    /*
  Object.defineProperty(MediaStreamTrack.prototype, 'enabled', {
    set: function(value) {
      trace('MediaStreamTrackEnable', this, value);
    }
  });
  */ return {
        resetDelta () {
            prevById = {};
        }
    };
};


const $742fefc0f61b4bae$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $742fefc0f61b4bae$export$2e2bcd8739ae039 = {
    randomUUID: $742fefc0f61b4bae$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $f70786181090564b$var$getRandomValues;
const $f70786181090564b$var$rnds8 = new Uint8Array(16);
function $f70786181090564b$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$f70786181090564b$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $f70786181090564b$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$f70786181090564b$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $f70786181090564b$var$getRandomValues($f70786181090564b$var$rnds8);
}


var $bba49c18feaefd33$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $ea12533c10c1a23d$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bba49c18feaefd33$export$2e2bcd8739ae039).test(uuid);
}
var $ea12533c10c1a23d$export$2e2bcd8739ae039 = $ea12533c10c1a23d$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $5b80c61add9baf5e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$5b80c61add9baf5e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $5b80c61add9baf5e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $5b80c61add9baf5e$var$byteToHex[arr[offset + 0]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 1]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 2]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 3]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 4]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 5]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 6]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 7]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 8]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 9]] + "-" + $5b80c61add9baf5e$var$byteToHex[arr[offset + 10]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 11]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 12]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 13]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 14]] + $5b80c61add9baf5e$var$byteToHex[arr[offset + 15]];
}
function $5b80c61add9baf5e$var$stringify(arr, offset = 0) {
    const uuid = $5b80c61add9baf5e$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $ea12533c10c1a23d$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5b80c61add9baf5e$export$2e2bcd8739ae039 = $5b80c61add9baf5e$var$stringify;


function $e247db96f48d686a$var$v4(options, buf, offset) {
    if ((0, $742fefc0f61b4bae$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $742fefc0f61b4bae$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $f70786181090564b$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5b80c61add9baf5e$export$8fb373d660548968)(rnds);
}
var $e247db96f48d686a$export$2e2bcd8739ae039 = $e247db96f48d686a$var$v4;




var $8j7qr = parcelRequire("8j7qr");
var $fcb6503f150ed464$exports = {};
"use strict";
var $fcb6503f150ed464$var$__createBinding = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fcb6503f150ed464$var$__setModuleDefault = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fcb6503f150ed464$var$__importStar = $fcb6503f150ed464$exports && $fcb6503f150ed464$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fcb6503f150ed464$var$__createBinding(result, mod, k);
    }
    $fcb6503f150ed464$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fcb6503f150ed464$exports, "__esModule", {
    value: true
});
$fcb6503f150ed464$exports.v6 = $fcb6503f150ed464$exports.AddressError = $fcb6503f150ed464$exports.Address6 = $fcb6503f150ed464$exports.Address4 = void 0;
var $c27123c5c1023f74$exports = {};
"use strict";
/* eslint-disable no-param-reassign */ var $c27123c5c1023f74$var$__createBinding = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c27123c5c1023f74$var$__setModuleDefault = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c27123c5c1023f74$var$__importStar = $c27123c5c1023f74$exports && $c27123c5c1023f74$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c27123c5c1023f74$var$__createBinding(result, mod, k);
    }
    $c27123c5c1023f74$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c27123c5c1023f74$exports, "__esModule", {
    value: true
});
$c27123c5c1023f74$exports.Address4 = void 0;

const $c27123c5c1023f74$var$common = $c27123c5c1023f74$var$__importStar((parcelRequire("23jSE")));

const $c27123c5c1023f74$var$constants = $c27123c5c1023f74$var$__importStar((parcelRequire("i0ccS")));
var $6a3bc47ac964004c$exports = {};
"use strict";
Object.defineProperty($6a3bc47ac964004c$exports, "__esModule", {
    value: true
});
$6a3bc47ac964004c$exports.AddressError = void 0;
class $6a3bc47ac964004c$var$AddressError extends Error {
    constructor(message, parseMessage){
        super(message);
        this.name = "AddressError";
        if (parseMessage !== null) this.parseMessage = parseMessage;
    }
}
$6a3bc47ac964004c$exports.AddressError = $6a3bc47ac964004c$var$AddressError;



var $cqjLs = parcelRequire("cqjLs");

var $krCXC = parcelRequire("krCXC");
/**
 * Represents an IPv4 address
 * @class Address4
 * @param {string} address - An IPv4 address string
 */ class $c27123c5c1023f74$var$Address4 {
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $c27123c5c1023f74$var$Address4(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /*
     * Parses a v4 address
     */ parse(address) {
        const groups = address.split(".");
        if (!address.match($c27123c5c1023f74$var$constants.RE_ADDRESS)) throw new $6a3bc47ac964004c$exports.AddressError("Invalid IPv4 address.");
        return groups;
    }
    /**
     * Returns the correct form of an address
     * @memberof Address4
     * @instance
     * @returns {String}
     */ correctForm() {
        return this.parsedAddress.map((part)=>parseInt(part, 10)).join(".");
    }
    /**
     * Converts a hex string to an IPv4 address object
     * @memberof Address4
     * @static
     * @param {string} hex - a hex string to convert
     * @returns {Address4}
     */ static fromHex(hex) {
        const padded = hex.replace(/:/g, "").padStart(8, "0");
        const groups = [];
        let i;
        for(i = 0; i < 8; i += 2){
            const h = padded.slice(i, i + 2);
            groups.push(parseInt(h, 16));
        }
        return new $c27123c5c1023f74$var$Address4(groups.join("."));
    }
    /**
     * Converts an integer into a IPv4 address object
     * @memberof Address4
     * @static
     * @param {integer} integer - a number to convert
     * @returns {Address4}
     */ static fromInteger(integer) {
        return $c27123c5c1023f74$var$Address4.fromHex(integer.toString(16));
    }
    /**
     * Return an address from in-addr.arpa form
     * @memberof Address4
     * @static
     * @param {string} arpaFormAddress - an 'in-addr.arpa' form ipv4 address
     * @returns {Adress4}
     * @example
     * var address = Address4.fromArpa(42.2.0.192.in-addr.arpa.)
     * address.correctForm(); // '192.0.2.42'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".in-addr.arpa." or just "."
        const leader = arpaFormAddress.replace(/(\.in-addr\.arpa)?\.$/, "");
        const address = leader.split(".").reverse().join(".");
        return new $c27123c5c1023f74$var$Address4(address);
    }
    /**
     * Converts an IPv4 address object to a hex string
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toHex() {
        return this.parsedAddress.map((part)=>(0, $krCXC.sprintf)("%02x", parseInt(part, 10))).join(":");
    }
    /**
     * Converts an IPv4 address object to an array of bytes
     * @memberof Address4
     * @instance
     * @returns {Array}
     */ toArray() {
        return this.parsedAddress.map((part)=>parseInt(part, 10));
    }
    /**
     * Converts an IPv4 address object to an IPv6 address group
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toGroup6() {
        const output = [];
        let i;
        for(i = 0; i < $c27123c5c1023f74$var$constants.GROUPS; i += 2){
            const hex = (0, $krCXC.sprintf)("%02x%02x", parseInt(this.parsedAddress[i], 10), parseInt(this.parsedAddress[i + 1], 10));
            output.push((0, $krCXC.sprintf)("%x", parseInt(hex, 16)));
        }
        return output.join(":");
    }
    /**
     * Returns the address as a BigInteger
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new $cqjLs.BigInteger(this.parsedAddress.map((n)=>(0, $krCXC.sprintf)("%02x", parseInt(n, 10))).join(""), 16);
    }
    /**
     * Helper function getting start address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new $cqjLs.BigInteger(this.mask() + "0".repeat($c27123c5c1023f74$var$constants.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet.
     * Often referred to as the Network Address.
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddress() {
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address4
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new $cqjLs.BigInteger(this.mask() + "1".repeat($c27123c5c1023f74$var$constants.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddress() {
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $c27123c5c1023f74$var$Address4.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Converts a BigInteger to a v4 address object
     * @memberof Address4
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address4}
     */ static fromBigInteger(bigInteger) {
        return $c27123c5c1023f74$var$Address4.fromInteger(parseInt(bigInteger.toString(), 10));
    }
    /**
     * Returns the first n bits of the address, defaulting to the
     * subnet mask
     * @memberof Address4
     * @instance
     * @returns {String}
     */ mask(mask) {
        if (mask === undefined) mask = this.subnetMask;
        return this.getBitsBase2(0, mask);
    }
    /**
     * Returns the bits in the given range as a base-2 string
     * @memberof Address4
     * @instance
     * @returns {string}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address4
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "in-addr.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const reversed = this.correctForm().split(".").reverse().join(".");
        if (options.omitSuffix) return reversed;
        return (0, $krCXC.sprintf)("%s.in-addr.arpa.", reversed);
    }
    /**
     * Returns true if the given address is a multicast address
     * @memberof Address4
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.isInSubnet(new $c27123c5c1023f74$var$Address4("224.0.0.0/4"));
    }
    /**
     * Returns a zero-padded base-2 string representation of the address
     * @memberof Address4
     * @instance
     * @returns {string}
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($c27123c5c1023f74$var$constants.BITS, "0");
    }
    /**
     * Groups an IPv4 address for inclusion at the end of an IPv6 address
     * @returns {String}
     */ groupForV6() {
        const segments = this.parsedAddress;
        return this.address.replace($c27123c5c1023f74$var$constants.RE_ADDRESS, (0, $krCXC.sprintf)('<span class="hover-group group-v4 group-6">%s</span>.<span class="hover-group group-v4 group-7">%s</span>', segments.slice(0, 2).join("."), segments.slice(2, 4).join(".")));
    }
    constructor(address){
        this.groups = $c27123c5c1023f74$var$constants.GROUPS;
        this.parsedAddress = [];
        this.parsedSubnet = "";
        this.subnet = "/32";
        this.subnetMask = 32;
        this.v4 = true;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address4
         * @instance
         * @returns {Boolean}
         */ this.isCorrect = $c27123c5c1023f74$var$common.isCorrect($c27123c5c1023f74$var$constants.BITS);
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address4
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $c27123c5c1023f74$var$common.isInSubnet;
        this.address = address;
        const subnet = $c27123c5c1023f74$var$constants.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (this.subnetMask < 0 || this.subnetMask > $c27123c5c1023f74$var$constants.BITS) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
            address = address.replace($c27123c5c1023f74$var$constants.RE_SUBNET_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(address);
    }
}
$c27123c5c1023f74$exports.Address4 = $c27123c5c1023f74$var$Address4;


Object.defineProperty($fcb6503f150ed464$exports, "Address4", {
    enumerable: true,
    get: function() {
        return $c27123c5c1023f74$exports.Address4;
    }
});
var $2c67d28ffe370a60$exports = {};
"use strict";
/* eslint-disable prefer-destructuring */ /* eslint-disable no-param-reassign */ var $2c67d28ffe370a60$var$__createBinding = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c67d28ffe370a60$var$__setModuleDefault = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2c67d28ffe370a60$var$__importStar = $2c67d28ffe370a60$exports && $2c67d28ffe370a60$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c67d28ffe370a60$var$__createBinding(result, mod, k);
    }
    $2c67d28ffe370a60$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2c67d28ffe370a60$exports, "__esModule", {
    value: true
});
$2c67d28ffe370a60$exports.Address6 = void 0;

const $2c67d28ffe370a60$var$common = $2c67d28ffe370a60$var$__importStar((parcelRequire("23jSE")));

const $2c67d28ffe370a60$var$constants4 = $2c67d28ffe370a60$var$__importStar((parcelRequire("i0ccS")));

const $2c67d28ffe370a60$var$constants6 = $2c67d28ffe370a60$var$__importStar((parcelRequire("oXAYb")));

const $2c67d28ffe370a60$var$helpers = $2c67d28ffe370a60$var$__importStar((parcelRequire("1Q0Pv")));

var $f28c18019c39fdf0$exports = {};
"use strict";
var $f28c18019c39fdf0$var$__createBinding = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f28c18019c39fdf0$var$__setModuleDefault = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f28c18019c39fdf0$var$__importStar = $f28c18019c39fdf0$exports && $f28c18019c39fdf0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f28c18019c39fdf0$var$__createBinding(result, mod, k);
    }
    $f28c18019c39fdf0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f28c18019c39fdf0$exports, "__esModule", {
    value: true
});
$f28c18019c39fdf0$exports.possibleElisions = $f28c18019c39fdf0$exports.simpleRegularExpression = $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY = $f28c18019c39fdf0$exports.padGroup = $f28c18019c39fdf0$exports.groupPossibilities = void 0;

const $f28c18019c39fdf0$var$v6 = $f28c18019c39fdf0$var$__importStar((parcelRequire("oXAYb")));

var $krCXC = parcelRequire("krCXC");
function $f28c18019c39fdf0$var$groupPossibilities(possibilities) {
    return (0, $krCXC.sprintf)("(%s)", possibilities.join("|"));
}
$f28c18019c39fdf0$exports.groupPossibilities = $f28c18019c39fdf0$var$groupPossibilities;
function $f28c18019c39fdf0$var$padGroup(group) {
    if (group.length < 4) return (0, $krCXC.sprintf)("0{0,%d}%s", 4 - group.length, group);
    return group;
}
$f28c18019c39fdf0$exports.padGroup = $f28c18019c39fdf0$var$padGroup;
$f28c18019c39fdf0$exports.ADDRESS_BOUNDARY = "[^A-Fa-f0-9:]";
function $f28c18019c39fdf0$var$simpleRegularExpression(groups) {
    const zeroIndexes = [];
    groups.forEach((group, i)=>{
        const groupInteger = parseInt(group, 16);
        if (groupInteger === 0) zeroIndexes.push(i);
    });
    // You can technically elide a single 0, this creates the regular expressions
    // to match that eventuality
    const possibilities = zeroIndexes.map((zeroIndex)=>groups.map((group, i)=>{
            if (i === zeroIndex) {
                const elision = i === 0 || i === $f28c18019c39fdf0$var$v6.GROUPS - 1 ? ":" : "";
                return $f28c18019c39fdf0$var$groupPossibilities([
                    $f28c18019c39fdf0$var$padGroup(group),
                    elision
                ]);
            }
            return $f28c18019c39fdf0$var$padGroup(group);
        }).join(":"));
    // The simplest case
    possibilities.push(groups.map($f28c18019c39fdf0$var$padGroup).join(":"));
    return $f28c18019c39fdf0$var$groupPossibilities(possibilities);
}
$f28c18019c39fdf0$exports.simpleRegularExpression = $f28c18019c39fdf0$var$simpleRegularExpression;
function $f28c18019c39fdf0$var$possibleElisions(elidedGroups, moreLeft, moreRight) {
    const left = moreLeft ? "" : ":";
    const right = moreRight ? "" : ":";
    const possibilities = [];
    // 1. elision of everything (::)
    if (!moreLeft && !moreRight) possibilities.push("::");
    // 2. complete elision of the middle
    if (moreLeft && moreRight) possibilities.push("");
    if (moreRight && !moreLeft || !moreRight && moreLeft) // 3. complete elision of one side
    possibilities.push(":");
    // 4. elision from the left side
    possibilities.push((0, $krCXC.sprintf)("%s(:0{1,4}){1,%d}", left, elidedGroups - 1));
    // 5. elision from the right side
    possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){1,%d}%s", elidedGroups - 1, right));
    // 6. no elision
    possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){%d}0{1,4}", elidedGroups - 1));
    // 7. elision (including sloppy elision) from the middle
    for(let groups = 1; groups < elidedGroups - 1; groups++)for(let position = 1; position < elidedGroups - groups; position++)possibilities.push((0, $krCXC.sprintf)("(0{1,4}:){%d}:(0{1,4}:){%d}0{1,4}", position, elidedGroups - position - groups - 1));
    return $f28c18019c39fdf0$var$groupPossibilities(possibilities);
}
$f28c18019c39fdf0$exports.possibleElisions = $f28c18019c39fdf0$var$possibleElisions;




var $cqjLs = parcelRequire("cqjLs");

var $krCXC = parcelRequire("krCXC");
function $2c67d28ffe370a60$var$assert(condition) {
    if (!condition) throw new Error("Assertion failed.");
}
function $2c67d28ffe370a60$var$addCommas(number) {
    const r = /(\d+)(\d{3})/;
    while(r.test(number))number = number.replace(r, "$1,$2");
    return number;
}
function $2c67d28ffe370a60$var$spanLeadingZeroes4(n) {
    n = n.replace(/^(0{1,})([1-9]+)$/, '<span class="parse-error">$1</span>$2');
    n = n.replace(/^(0{1,})(0)$/, '<span class="parse-error">$1</span>$2');
    return n;
}
/*
 * A helper function to compact an array
 */ function $2c67d28ffe370a60$var$compact(address, slice) {
    const s1 = [];
    const s2 = [];
    let i;
    for(i = 0; i < address.length; i++){
        if (i < slice[0]) s1.push(address[i]);
        else if (i > slice[1]) s2.push(address[i]);
    }
    return s1.concat([
        "compact"
    ]).concat(s2);
}
function $2c67d28ffe370a60$var$paddedHex(octet) {
    return (0, $krCXC.sprintf)("%04x", parseInt(octet, 16));
}
function $2c67d28ffe370a60$var$unsignByte(b) {
    // eslint-disable-next-line no-bitwise
    return b & 0xff;
}
/**
 * Represents an IPv6 address
 * @class Address6
 * @param {string} address - An IPv6 address string
 * @param {number} [groups=8] - How many octets to parse
 * @example
 * var address = new Address6('2001::/32');
 */ class $2c67d28ffe370a60$var$Address6 {
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $2c67d28ffe370a60$var$Address6(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
     * Convert a BigInteger to a v6 address object
     * @memberof Address6
     * @static
     * @param {BigInteger} bigInteger - a BigInteger to convert
     * @returns {Address6}
     * @example
     * var bigInteger = new BigInteger('1000000000000');
     * var address = Address6.fromBigInteger(bigInteger);
     * address.correctForm(); // '::e8:d4a5:1000'
     */ static fromBigInteger(bigInteger) {
        const hex = bigInteger.toString(16).padStart(32, "0");
        const groups = [];
        let i;
        for(i = 0; i < $2c67d28ffe370a60$var$constants6.GROUPS; i++)groups.push(hex.slice(i * 4, (i + 1) * 4));
        return new $2c67d28ffe370a60$var$Address6(groups.join(":"));
    }
    /**
     * Convert a URL (with optional port number) to an address object
     * @memberof Address6
     * @static
     * @param {string} url - a URL with optional port number
     * @example
     * var addressAndPort = Address6.fromURL('http://[ffff::]:8080/foo/');
     * addressAndPort.address.correctForm(); // 'ffff::'
     * addressAndPort.port; // 8080
     */ static fromURL(url) {
        let host;
        let port = null;
        let result;
        // If we have brackets parse them and find a port
        if (url.indexOf("[") !== -1 && url.indexOf("]:") !== -1) {
            result = $2c67d28ffe370a60$var$constants6.RE_URL_WITH_PORT.exec(url);
            if (result === null) return {
                error: "failed to parse address with port",
                address: null,
                port: null
            };
            host = result[1];
            port = result[2];
        // If there's a URL extract the address
        } else if (url.indexOf("/") !== -1) {
            // Remove the protocol prefix
            url = url.replace(/^[a-z0-9]+:\/\//, "");
            // Parse the address
            result = $2c67d28ffe370a60$var$constants6.RE_URL.exec(url);
            if (result === null) return {
                error: "failed to parse address from URL",
                address: null,
                port: null
            };
            host = result[1];
        // Otherwise just assign the URL to the host and let the library parse it
        } else host = url;
        // If there's a port convert it to an integer
        if (port) {
            port = parseInt(port, 10);
            // squelch out of range ports
            if (port < 0 || port > 65536) port = null;
        } else // Standardize `undefined` to `null`
        port = null;
        return {
            address: new $2c67d28ffe370a60$var$Address6(host),
            port: port
        };
    }
    /**
     * Create an IPv6-mapped address given an IPv4 address
     * @memberof Address6
     * @static
     * @param {string} address - An IPv4 address string
     * @returns {Address6}
     * @example
     * var address = Address6.fromAddress4('192.168.0.1');
     * address.correctForm(); // '::ffff:c0a8:1'
     * address.to4in6(); // '::ffff:192.168.0.1'
     */ static fromAddress4(address) {
        const address4 = new $c27123c5c1023f74$exports.Address4(address);
        const mask6 = $2c67d28ffe370a60$var$constants6.BITS - ($2c67d28ffe370a60$var$constants4.BITS - address4.subnetMask);
        return new $2c67d28ffe370a60$var$Address6(`::ffff:${address4.correctForm()}/${mask6}`);
    }
    /**
     * Return an address from ip6.arpa form
     * @memberof Address6
     * @static
     * @param {string} arpaFormAddress - an 'ip6.arpa' form address
     * @returns {Adress6}
     * @example
     * var address = Address6.fromArpa(e.f.f.f.3.c.2.6.f.f.f.e.6.6.8.e.1.0.6.7.9.4.e.c.0.0.0.0.1.0.0.2.ip6.arpa.)
     * address.correctForm(); // '2001:0:ce49:7601:e866:efff:62c3:fffe'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".ip6.arpa." or just "."
        let address = arpaFormAddress.replace(/(\.ip6\.arpa)?\.$/, "");
        const semicolonAmount = 7;
        // correct ip6.arpa form with ending removed will be 63 characters
        if (address.length !== 63) throw new $6a3bc47ac964004c$exports.AddressError("Invalid 'ip6.arpa' form.");
        const parts = address.split(".").reverse();
        for(let i = semicolonAmount; i > 0; i--){
            const insertIndex = i * 4;
            parts.splice(insertIndex, 0, ":");
        }
        address = parts.join("");
        return new $2c67d28ffe370a60$var$Address6(address);
    }
    /**
     * Return the Microsoft UNC transcription of the address
     * @memberof Address6
     * @instance
     * @returns {String} the Microsoft UNC transcription of the address
     */ microsoftTranscription() {
        return (0, $krCXC.sprintf)("%s.ipv6-literal.net", this.correctForm().replace(/:/g, "-"));
    }
    /**
     * Return the first n bits of the address, defaulting to the subnet mask
     * @memberof Address6
     * @instance
     * @param {number} [mask=subnet] - the number of bits to mask
     * @returns {String} the first n bits of the address as a string
     */ mask(mask = this.subnetMask) {
        return this.getBitsBase2(0, mask);
    }
    /**
     * Return the number of possible subnets of a given size in the address
     * @memberof Address6
     * @instance
     * @param {number} [size=128] - the subnet size
     * @returns {String}
     */ // TODO: probably useful to have a numeric version of this too
    possibleSubnets(subnetSize = 128) {
        const availableBits = $2c67d28ffe370a60$var$constants6.BITS - this.subnetMask;
        const subnetBits = Math.abs(subnetSize - $2c67d28ffe370a60$var$constants6.BITS);
        const subnetPowers = availableBits - subnetBits;
        if (subnetPowers < 0) return "0";
        return $2c67d28ffe370a60$var$addCommas(new $cqjLs.BigInteger("2", 10).pow(subnetPowers).toString(10));
    }
    /**
     * Helper function getting start address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _startAddress() {
        return new $cqjLs.BigInteger(this.mask() + "0".repeat($2c67d28ffe370a60$var$constants6.BITS - this.subnetMask), 2);
    }
    /**
     * The first address in the range given by this address' subnet
     * Often referred to as the Network Address.
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddress() {
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._startAddress().add(adjust));
    }
    /**
     * Helper function getting end address.
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ _endAddress() {
        return new $cqjLs.BigInteger(this.mask() + "1".repeat($2c67d28ffe370a60$var$constants6.BITS - this.subnetMask), 2);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddress() {
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddressExclusive() {
        const adjust = new $cqjLs.BigInteger("1");
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(this._endAddress().subtract(adjust));
    }
    /**
     * Return the scope of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getScope() {
        let scope = $2c67d28ffe370a60$var$constants6.SCOPES[this.getBits(12, 16).intValue()];
        if (this.getType() === "Global unicast" && scope !== "Link local") scope = "Global";
        return scope || "Unknown";
    }
    /**
     * Return the type of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getType() {
        for (const subnet of Object.keys($2c67d28ffe370a60$var$constants6.TYPES)){
            if (this.isInSubnet(new $2c67d28ffe370a60$var$Address6(subnet))) return $2c67d28ffe370a60$var$constants6.TYPES[subnet];
        }
        return "Global unicast";
    }
    /**
     * Return the bits in the given range as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ getBits(start, end) {
        return new $cqjLs.BigInteger(this.getBitsBase2(start, end), 2);
    }
    /**
     * Return the bits in the given range as a base-2 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the bits in the given range as a base-16 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase16(start, end) {
        const length = end - start;
        if (length % 4 !== 0) throw new Error("Length of bits to retrieve must be divisible by four");
        return this.getBits(start, end).toString(16).padStart(length / 4, "0");
    }
    /**
     * Return the bits that are set past the subnet mask length
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsPastSubnet() {
        return this.getBitsBase2(this.subnetMask, $2c67d28ffe370a60$var$constants6.BITS);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address6
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "ip6.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const characters = Math.floor(this.subnetMask / 4);
        const reversed = this.canonicalForm().replace(/:/g, "").split("").slice(0, characters).reverse().join(".");
        if (characters > 0) {
            if (options.omitSuffix) return reversed;
            return (0, $krCXC.sprintf)("%s.ip6.arpa.", reversed);
        }
        if (options.omitSuffix) return "";
        return "ip6.arpa.";
    }
    /**
     * Return the correct form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ correctForm() {
        let i;
        let groups = [];
        let zeroCounter = 0;
        const zeroes = [];
        for(i = 0; i < this.parsedAddress.length; i++){
            const value = parseInt(this.parsedAddress[i], 16);
            if (value === 0) zeroCounter++;
            if (value !== 0 && zeroCounter > 0) {
                if (zeroCounter > 1) zeroes.push([
                    i - zeroCounter,
                    i - 1
                ]);
                zeroCounter = 0;
            }
        }
        // Do we end with a string of zeroes?
        if (zeroCounter > 1) zeroes.push([
            this.parsedAddress.length - zeroCounter,
            this.parsedAddress.length - 1
        ]);
        const zeroLengths = zeroes.map((n)=>n[1] - n[0] + 1);
        if (zeroes.length > 0) {
            const index = zeroLengths.indexOf(Math.max(...zeroLengths));
            groups = $2c67d28ffe370a60$var$compact(this.parsedAddress, zeroes[index]);
        } else groups = this.parsedAddress;
        for(i = 0; i < groups.length; i++)if (groups[i] !== "compact") groups[i] = parseInt(groups[i], 16).toString(16);
        let correct = groups.join(":");
        correct = correct.replace(/^compact$/, "::");
        correct = correct.replace(/^compact|compact$/, ":");
        correct = correct.replace(/compact/, "");
        return correct;
    }
    /**
     * Return a zero-padded base-2 string representation of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     * @example
     * var address = new Address6('2001:4860:4001:803::1011');
     * address.binaryZeroPad();
     * // '0010000000000001010010000110000001000000000000010000100000000011
     * //  0000000000000000000000000000000000000000000000000001000000010001'
     */ binaryZeroPad() {
        return this.bigInteger().toString(2).padStart($2c67d28ffe370a60$var$constants6.BITS, "0");
    }
    // TODO: Improve the semantics of this helper function
    parse4in6(address) {
        const groups = address.split(":");
        const lastGroup = groups.slice(-1)[0];
        const address4 = lastGroup.match($2c67d28ffe370a60$var$constants4.RE_ADDRESS);
        if (address4) {
            this.parsedAddress4 = address4[0];
            this.address4 = new $c27123c5c1023f74$exports.Address4(this.parsedAddress4);
            for(let i = 0; i < this.address4.groups; i++){
                if (/^0[0-9]+/.test(this.address4.parsedAddress[i])) throw new $6a3bc47ac964004c$exports.AddressError("IPv4 addresses can't have leading zeroes.", address.replace($2c67d28ffe370a60$var$constants4.RE_ADDRESS, this.address4.parsedAddress.map($2c67d28ffe370a60$var$spanLeadingZeroes4).join(".")));
            }
            this.v4 = true;
            groups[groups.length - 1] = this.address4.toGroup6();
            address = groups.join(":");
        }
        return address;
    }
    // TODO: Make private?
    parse(address) {
        address = this.parse4in6(address);
        const badCharacters = address.match($2c67d28ffe370a60$var$constants6.RE_BAD_CHARACTERS);
        if (badCharacters) throw new $6a3bc47ac964004c$exports.AddressError((0, $krCXC.sprintf)("Bad character%s detected in address: %s", badCharacters.length > 1 ? "s" : "", badCharacters.join("")), address.replace($2c67d28ffe370a60$var$constants6.RE_BAD_CHARACTERS, '<span class="parse-error">$1</span>'));
        const badAddress = address.match($2c67d28ffe370a60$var$constants6.RE_BAD_ADDRESS);
        if (badAddress) throw new $6a3bc47ac964004c$exports.AddressError((0, $krCXC.sprintf)("Address failed regex: %s", badAddress.join("")), address.replace($2c67d28ffe370a60$var$constants6.RE_BAD_ADDRESS, '<span class="parse-error">$1</span>'));
        let groups = [];
        const halves = address.split("::");
        if (halves.length === 2) {
            let first = halves[0].split(":");
            let last = halves[1].split(":");
            if (first.length === 1 && first[0] === "") first = [];
            if (last.length === 1 && last[0] === "") last = [];
            const remaining = this.groups - (first.length + last.length);
            if (!remaining) throw new $6a3bc47ac964004c$exports.AddressError("Error parsing groups");
            this.elidedGroups = remaining;
            this.elisionBegin = first.length;
            this.elisionEnd = first.length + this.elidedGroups;
            groups = groups.concat(first);
            for(let i = 0; i < remaining; i++)groups.push("0");
            groups = groups.concat(last);
        } else if (halves.length === 1) {
            groups = address.split(":");
            this.elidedGroups = 0;
        } else throw new $6a3bc47ac964004c$exports.AddressError("Too many :: groups found");
        groups = groups.map((group)=>(0, $krCXC.sprintf)("%x", parseInt(group, 16)));
        if (groups.length !== this.groups) throw new $6a3bc47ac964004c$exports.AddressError("Incorrect number of groups found");
        return groups;
    }
    /**
     * Return the canonical form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ canonicalForm() {
        return this.parsedAddress.map($2c67d28ffe370a60$var$paddedHex).join(":");
    }
    /**
     * Return the decimal form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ decimal() {
        return this.parsedAddress.map((n)=>(0, $krCXC.sprintf)("%05d", parseInt(n, 16))).join(":");
    }
    /**
     * Return the address as a BigInteger
     * @memberof Address6
     * @instance
     * @returns {BigInteger}
     */ bigInteger() {
        return new $cqjLs.BigInteger(this.parsedAddress.map($2c67d28ffe370a60$var$paddedHex).join(""), 16);
    }
    /**
     * Return the last two groups of this address as an IPv4 address string
     * @memberof Address6
     * @instance
     * @returns {Address4}
     * @example
     * var address = new Address6('2001:4860:4001::1825:bf11');
     * address.to4().correctForm(); // '24.37.191.17'
     */ to4() {
        const binary = this.binaryZeroPad().split("");
        return $c27123c5c1023f74$exports.Address4.fromHex(new $cqjLs.BigInteger(binary.slice(96, 128).join(""), 2).toString(16));
    }
    /**
     * Return the v4-in-v6 form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ to4in6() {
        const address4 = this.to4();
        const address6 = new $2c67d28ffe370a60$var$Address6(this.parsedAddress.slice(0, 6).join(":"), 6);
        const correct = address6.correctForm();
        let infix = "";
        if (!/:$/.test(correct)) infix = ":";
        return correct + infix + address4.address;
    }
    /**
     * Return an object containing the Teredo properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspectTeredo() {
        /*
        - Bits 0 to 31 are set to the Teredo prefix (normally 2001:0000::/32).
        - Bits 32 to 63 embed the primary IPv4 address of the Teredo server that
          is used.
        - Bits 64 to 79 can be used to define some flags. Currently only the
          higher order bit is used; it is set to 1 if the Teredo client is
          located behind a cone NAT, 0 otherwise. For Microsoft's Windows Vista
          and Windows Server 2008 implementations, more bits are used. In those
          implementations, the format for these 16 bits is "CRAAAAUG AAAAAAAA",
          where "C" remains the "Cone" flag. The "R" bit is reserved for future
          use. The "U" bit is for the Universal/Local flag (set to 0). The "G" bit
          is Individual/Group flag (set to 0). The A bits are set to a 12-bit
          randomly generated number chosen by the Teredo client to introduce
          additional protection for the Teredo node against IPv6-based scanning
          attacks.
        - Bits 80 to 95 contains the obfuscated UDP port number. This is the
          port number that is mapped by the NAT to the Teredo client with all
          bits inverted.
        - Bits 96 to 127 contains the obfuscated IPv4 address. This is the
          public IPv4 address of the NAT with all bits inverted.
        */ const prefix = this.getBitsBase16(0, 32);
        const udpPort = this.getBits(80, 96).xor(new $cqjLs.BigInteger("ffff", 16)).toString();
        const server4 = $c27123c5c1023f74$exports.Address4.fromHex(this.getBitsBase16(32, 64));
        const client4 = $c27123c5c1023f74$exports.Address4.fromHex(this.getBits(96, 128).xor(new $cqjLs.BigInteger("ffffffff", 16)).toString(16));
        const flags = this.getBits(64, 80);
        const flagsBase2 = this.getBitsBase2(64, 80);
        const coneNat = flags.testBit(15);
        const reserved = flags.testBit(14);
        const groupIndividual = flags.testBit(8);
        const universalLocal = flags.testBit(9);
        const nonce = new $cqjLs.BigInteger(flagsBase2.slice(2, 6) + flagsBase2.slice(8, 16), 2).toString(10);
        return {
            prefix: (0, $krCXC.sprintf)("%s:%s", prefix.slice(0, 4), prefix.slice(4, 8)),
            server4: server4.address,
            client4: client4.address,
            flags: flagsBase2,
            coneNat: coneNat,
            microsoft: {
                reserved: reserved,
                universalLocal: universalLocal,
                groupIndividual: groupIndividual,
                nonce: nonce
            },
            udpPort: udpPort
        };
    }
    /**
     * Return an object containing the 6to4 properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspect6to4() {
        /*
        - Bits 0 to 15 are set to the 6to4 prefix (2002::/16).
        - Bits 16 to 48 embed the IPv4 address of the 6to4 gateway that is used.
        */ const prefix = this.getBitsBase16(0, 16);
        const gateway = $c27123c5c1023f74$exports.Address4.fromHex(this.getBitsBase16(16, 48));
        return {
            prefix: (0, $krCXC.sprintf)("%s", prefix.slice(0, 4)),
            gateway: gateway.address
        };
    }
    /**
     * Return a v6 6to4 address from a v6 v4inv6 address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ to6to4() {
        if (!this.is4()) return null;
        const addr6to4 = [
            "2002",
            this.getBitsBase16(96, 112),
            this.getBitsBase16(112, 128),
            "",
            "/16"
        ].join(":");
        return new $2c67d28ffe370a60$var$Address6(addr6to4);
    }
    /**
     * Return a byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toByteArray() {
        const byteArray = this.bigInteger().toByteArray();
        // work around issue where `toByteArray` returns a leading 0 element
        if (byteArray.length === 17 && byteArray[0] === 0) return byteArray.slice(1);
        return byteArray;
    }
    /**
     * Return an unsigned byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toUnsignedByteArray() {
        return this.toByteArray().map($2c67d28ffe370a60$var$unsignByte);
    }
    /**
     * Convert a byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromByteArray(bytes) {
        return this.fromUnsignedByteArray(bytes.map($2c67d28ffe370a60$var$unsignByte));
    }
    /**
     * Convert an unsigned byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromUnsignedByteArray(bytes) {
        const BYTE_MAX = new $cqjLs.BigInteger("256", 10);
        let result = new $cqjLs.BigInteger("0", 10);
        let multiplier = new $cqjLs.BigInteger("1", 10);
        for(let i = bytes.length - 1; i >= 0; i--){
            result = result.add(multiplier.multiply(new $cqjLs.BigInteger(bytes[i].toString(10), 10)));
            multiplier = multiplier.multiply(BYTE_MAX);
        }
        return $2c67d28ffe370a60$var$Address6.fromBigInteger(result);
    }
    /**
     * Returns true if the address is in the canonical form, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isCanonical() {
        return this.addressMinusSuffix === this.canonicalForm();
    }
    /**
     * Returns true if the address is a link local address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLinkLocal() {
        // Zeroes are required, i.e. we can't check isInSubnet with 'fe80::/10'
        if (this.getBitsBase2(0, 64) === "1111111010000000000000000000000000000000000000000000000000000000") return true;
        return false;
    }
    /**
     * Returns true if the address is a multicast address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.getType() === "Multicast";
    }
    /**
     * Returns true if the address is a v4-in-v6 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is4() {
        return this.v4;
    }
    /**
     * Returns true if the address is a Teredo address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isTeredo() {
        return this.isInSubnet(new $2c67d28ffe370a60$var$Address6("2001::/32"));
    }
    /**
     * Returns true if the address is a 6to4 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is6to4() {
        return this.isInSubnet(new $2c67d28ffe370a60$var$Address6("2002::/16"));
    }
    /**
     * Returns true if the address is a loopback address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLoopback() {
        return this.getType() === "Loopback";
    }
    // #endregion
    // #region HTML
    /**
     * @returns {String} the address in link form with a default port of 80
     */ href(optionalPort) {
        if (optionalPort === undefined) optionalPort = "";
        else optionalPort = (0, $krCXC.sprintf)(":%s", optionalPort);
        return (0, $krCXC.sprintf)("http://[%s]%s/", this.correctForm(), optionalPort);
    }
    /**
     * @returns {String} a link suitable for conveying the address via a URL hash
     */ link(options) {
        if (!options) options = {};
        if (options.className === undefined) options.className = "";
        if (options.prefix === undefined) options.prefix = "/#address=";
        if (options.v4 === undefined) options.v4 = false;
        let formFunction = this.correctForm;
        if (options.v4) formFunction = this.to4in6;
        if (options.className) return (0, $krCXC.sprintf)('<a href="%1$s%2$s" class="%3$s">%2$s</a>', options.prefix, formFunction.call(this), options.className);
        return (0, $krCXC.sprintf)('<a href="%1$s%2$s">%2$s</a>', options.prefix, formFunction.call(this));
    }
    /**
     * Groups an address
     * @returns {String}
     */ group() {
        if (this.elidedGroups === 0) // The simple case
        return $2c67d28ffe370a60$var$helpers.simpleGroup(this.address).join(":");
        $2c67d28ffe370a60$var$assert(typeof this.elidedGroups === "number");
        $2c67d28ffe370a60$var$assert(typeof this.elisionBegin === "number");
        // The elided case
        const output = [];
        const [left, right] = this.address.split("::");
        if (left.length) output.push(...$2c67d28ffe370a60$var$helpers.simpleGroup(left));
        else output.push("");
        const classes = [
            "hover-group"
        ];
        for(let i = this.elisionBegin; i < this.elisionBegin + this.elidedGroups; i++)classes.push((0, $krCXC.sprintf)("group-%d", i));
        output.push((0, $krCXC.sprintf)('<span class="%s"></span>', classes.join(" ")));
        if (right.length) output.push(...$2c67d28ffe370a60$var$helpers.simpleGroup(right, this.elisionEnd));
        else output.push("");
        if (this.is4()) {
            $2c67d28ffe370a60$var$assert(this.address4 instanceof $c27123c5c1023f74$exports.Address4);
            output.pop();
            output.push(this.address4.groupForV6());
        }
        return output.join(":");
    }
    // #endregion
    // #region Regular expressions
    /**
     * Generate a regular expression string that can be used to find or validate
     * all variations of this address
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {string}
     */ regularExpressionString(substringSearch = false) {
        let output = [];
        // TODO: revisit why this is necessary
        const address6 = new $2c67d28ffe370a60$var$Address6(this.correctForm());
        if (address6.elidedGroups === 0) // The simple case
        output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(address6.parsedAddress));
        else if (address6.elidedGroups === $2c67d28ffe370a60$var$constants6.GROUPS) // A completely elided address
        output.push((0, $f28c18019c39fdf0$exports.possibleElisions)($2c67d28ffe370a60$var$constants6.GROUPS));
        else {
            // A partially elided address
            const halves = address6.address.split("::");
            if (halves[0].length) output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(halves[0].split(":")));
            $2c67d28ffe370a60$var$assert(typeof address6.elidedGroups === "number");
            output.push((0, $f28c18019c39fdf0$exports.possibleElisions)(address6.elidedGroups, halves[0].length !== 0, halves[1].length !== 0));
            if (halves[1].length) output.push((0, $f28c18019c39fdf0$exports.simpleRegularExpression)(halves[1].split(":")));
            output = [
                output.join(":")
            ];
        }
        if (!substringSearch) output = [
            "(?=^|",
            $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY,
            "|[^\\w\\:])(",
            ...output,
            ")(?=[^\\w\\:]|",
            $f28c18019c39fdf0$exports.ADDRESS_BOUNDARY,
            "|$)"
        ];
        return output.join("");
    }
    /**
     * Generate a regular expression that can be used to find or validate all
     * variations of this address.
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {RegExp}
     */ regularExpression(substringSearch = false) {
        return new RegExp(this.regularExpressionString(substringSearch), "i");
    }
    constructor(address, optionalGroups){
        this.addressMinusSuffix = "";
        this.parsedSubnet = "";
        this.subnet = "/128";
        this.subnetMask = 128;
        this.v4 = false;
        this.zone = "";
        // #region Attributes
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $2c67d28ffe370a60$var$common.isInSubnet;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isCorrect = $2c67d28ffe370a60$var$common.isCorrect($2c67d28ffe370a60$var$constants6.BITS);
        if (optionalGroups === undefined) this.groups = $2c67d28ffe370a60$var$constants6.GROUPS;
        else this.groups = optionalGroups;
        this.address = address;
        const subnet = $2c67d28ffe370a60$var$constants6.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (Number.isNaN(this.subnetMask) || this.subnetMask < 0 || this.subnetMask > $2c67d28ffe370a60$var$constants6.BITS) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
            address = address.replace($2c67d28ffe370a60$var$constants6.RE_SUBNET_STRING, "");
        } else if (/\//.test(address)) throw new $6a3bc47ac964004c$exports.AddressError("Invalid subnet mask.");
        const zone = $2c67d28ffe370a60$var$constants6.RE_ZONE_STRING.exec(address);
        if (zone) {
            this.zone = zone[0];
            address = address.replace($2c67d28ffe370a60$var$constants6.RE_ZONE_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(this.addressMinusSuffix);
    }
}
$2c67d28ffe370a60$exports.Address6 = $2c67d28ffe370a60$var$Address6;


Object.defineProperty($fcb6503f150ed464$exports, "Address6", {
    enumerable: true,
    get: function() {
        return $2c67d28ffe370a60$exports.Address6;
    }
});

Object.defineProperty($fcb6503f150ed464$exports, "AddressError", {
    enumerable: true,
    get: function() {
        return $6a3bc47ac964004c$exports.AddressError;
    }
});

const $fcb6503f150ed464$var$helpers = $fcb6503f150ed464$var$__importStar((parcelRequire("1Q0Pv")));
$fcb6503f150ed464$exports.v6 = {
    helpers: $fcb6503f150ed464$var$helpers
};


var $1ecbb2f73dbf2ce4$exports = {};
// Validation tool for IP addresses
var $36e3ec6447eae890$exports = {};

var $1nZXs = parcelRequire("1nZXs");
$36e3ec6447eae890$exports = $36e3ec6447eae890$var$check_many_cidrs;
function $36e3ec6447eae890$var$check_many_cidrs(addr, range) {
    if (typeof range === "string") return $36e3ec6447eae890$var$check_single_cidr(addr, range);
    else if (typeof range === "object") {
        var ip_is_in_range = false;
        for(var i = 0; i < range.length; i++)if ($36e3ec6447eae890$var$check_single_cidr(addr, range[i])) {
            ip_is_in_range = true;
            break;
        }
        return ip_is_in_range;
    }
}
function $36e3ec6447eae890$var$check_single_cidr(addr, cidr) {
    try {
        var parsed_addr = $1nZXs.process(addr);
        if (cidr.indexOf("/") === -1) {
            var parsed_cidr_as_ip = $1nZXs.process(cidr);
            if (parsed_addr.kind() === "ipv6" && parsed_cidr_as_ip.kind() === "ipv6") return parsed_addr.toNormalizedString() === parsed_cidr_as_ip.toNormalizedString();
            return parsed_addr.toString() == parsed_cidr_as_ip.toString();
        } else {
            var parsed_range = $1nZXs.parseCIDR(cidr);
            return parsed_addr.match(parsed_range);
        }
    } catch (e) {
        return false;
    }
}


var $1ecbb2f73dbf2ce4$var$validRegEx = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
// Bogons list from http://www.team-cymru.org/bogon-reference.html
var $1ecbb2f73dbf2ce4$var$bogonsArray = [
    "0.0.0.0/8",
    "10.0.0.0/8",
    "100.64.0.0/10",
    "127.0.0.0/8",
    "169.254.0.0/16",
    "172.16.0.0/12",
    "192.0.0.0/24",
    "192.0.2.0/24",
    "192.168.0.0/16",
    "198.18.0.0/15",
    "198.51.100.0/24",
    "203.0.113.0/24",
    "224.0.0.0/3"
];
// Private IP list.  Common RFC1918 IP addresses from https://tools.ietf.org/html/rfc1918
var $1ecbb2f73dbf2ce4$var$privateIpArray = [
    "10.0.0.0/8",
    "172.16.0.0/12",
    "192.168.0.0/16"
];
function $1ecbb2f73dbf2ce4$var$checkIp(ip) {
    // Set originalIp and reset other properties of answer.
    var boiledArray = [];
    var answer = {
        originalIp: ip,
        boiledIp: false,
        isValid: false,
        isBogon: false,
        isApipa: false,
        isMulticast: false,
        isRfc1918: false,
        isPublicIp: false
    };
    // Check to see if it is valid as per RegEx.
    if ($1ecbb2f73dbf2ce4$var$validRegEx.test(ip)) {
        answer.isValid = true;
        // Boil off any leading zeros in each octet.
        var octet = ip.split(".");
        for(var i = 0; i < 4; i++)boiledArray.push(parseInt(octet[i], 10));
        answer.boiledIp = boiledArray.join(".");
        // Check to see if it is on the bogons list.
        if ($36e3ec6447eae890$exports(answer.boiledIp, $1ecbb2f73dbf2ce4$var$bogonsArray)) answer.isBogon = true;
        // Check to see if IP address is an Automatic Private IP Addressing (APIPA aka auto-IP) IP.
        if ($36e3ec6447eae890$exports(answer.boiledIp, "169.254.0.0/16")) answer.isApipa = true;
        // Check to see if the IP address is a Multicast IP.
        if ($36e3ec6447eae890$exports(answer.boiledIp, "224.0.0.0/4")) answer.isMulticast = true;
        // Check to see if it is a public IP or private IP (RFC 1918).
        if ($36e3ec6447eae890$exports(answer.boiledIp, $1ecbb2f73dbf2ce4$var$privateIpArray)) answer.isRfc1918 = true;
        else if (answer.isBogon === false) answer.isPublicIp = true;
    }
    return answer;
}
$1ecbb2f73dbf2ce4$exports = $1ecbb2f73dbf2ce4$var$checkIp;


var $8c12fcb2a8b6be0e$exports = {};
// Regular expression used for basic parsing of the uuid.

var $dVJB2 = parcelRequire("dVJB2");
var $8c12fcb2a8b6be0e$require$Buffer = $dVJB2.Buffer;
var $8c12fcb2a8b6be0e$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8c12fcb2a8b6be0e$var$_byteToHex = [];
for(var $8c12fcb2a8b6be0e$var$i = 0; $8c12fcb2a8b6be0e$var$i < 256; $8c12fcb2a8b6be0e$var$i++)$8c12fcb2a8b6be0e$var$_byteToHex[$8c12fcb2a8b6be0e$var$i] = ($8c12fcb2a8b6be0e$var$i + 0x100).toString(16).substr(1);
function $8c12fcb2a8b6be0e$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8c12fcb2a8b6be0e$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + "-" + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ $8c12fcb2a8b6be0e$exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8c12fcb2a8b6be0e$require$Buffer.isBuffer(uuid)) parsedUuid = $8c12fcb2a8b6be0e$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === "[object String]") parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8c12fcb2a8b6be0e$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8c12fcb2a8b6be0e$var$extractVersion(parsedUuid);
    else if ($8c12fcb2a8b6be0e$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                "8",
                "9",
                "a",
                "b"
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error("Invalid version provided.");
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8c12fcb2a8b6be0e$var$extractVersion = $8c12fcb2a8b6be0e$exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};


parcelRequire("9KvBE");
var $35Pvm = parcelRequire("35Pvm");

var $fbuXh = parcelRequire("fbuXh");
const $9a1c38584fe7f3e8$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();


function $0f4dd0cd5703ae1b$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $0f4dd0cd5703ae1b$var$NATIVE_SET_TIMEOUT = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).setTimeout;
const $0f4dd0cd5703ae1b$var$NATIVE_CLEAR_TIMEOUT = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).clearTimeout;
function $0f4dd0cd5703ae1b$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $0f4dd0cd5703ae1b$var$NATIVE_SET_TIMEOUT.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
        obj.clearTimeoutFn = $0f4dd0cd5703ae1b$var$NATIVE_CLEAR_TIMEOUT.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).setTimeout.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).clearTimeout.bind((0, $9a1c38584fe7f3e8$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $0f4dd0cd5703ae1b$var$BASE64_OVERHEAD = 1.33;
function $0f4dd0cd5703ae1b$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $0f4dd0cd5703ae1b$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $0f4dd0cd5703ae1b$var$BASE64_OVERHEAD);
}
function $0f4dd0cd5703ae1b$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $e01fce6500821742$export$c564cdbbe6da493(obj) {
    let str = "";
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += "&";
        str += encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]);
    }
    return str;
}
function $e01fce6500821742$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split("&");
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split("=");
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $cefdafcabb98fcd0$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $cefdafcabb98fcd0$export$86495b081fef8e52 extends (0, $fbuXh.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $cefdafcabb98fcd0$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $35Pvm.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $e01fce6500821742$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}


// imported from https://github.com/unshiftio/yeast
"use strict";
const $0d4d25cab9a512e7$var$alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $0d4d25cab9a512e7$var$length = 64, $0d4d25cab9a512e7$var$map = {};
let $0d4d25cab9a512e7$var$seed = 0, $0d4d25cab9a512e7$var$i = 0, $0d4d25cab9a512e7$var$prev;
function $0d4d25cab9a512e7$export$c564cdbbe6da493(num) {
    let encoded = "";
    do {
        encoded = $0d4d25cab9a512e7$var$alphabet[num % $0d4d25cab9a512e7$var$length] + encoded;
        num = Math.floor(num / $0d4d25cab9a512e7$var$length);
    }while (num > 0);
    return encoded;
}
function $0d4d25cab9a512e7$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($0d4d25cab9a512e7$var$i = 0; $0d4d25cab9a512e7$var$i < str.length; $0d4d25cab9a512e7$var$i++)decoded = decoded * $0d4d25cab9a512e7$var$length + $0d4d25cab9a512e7$var$map[str.charAt($0d4d25cab9a512e7$var$i)];
    return decoded;
}
function $0d4d25cab9a512e7$export$5bb64b92cb4135a() {
    const now = $0d4d25cab9a512e7$export$c564cdbbe6da493(+new Date());
    if (now !== $0d4d25cab9a512e7$var$prev) return $0d4d25cab9a512e7$var$seed = 0, $0d4d25cab9a512e7$var$prev = now;
    return now + "." + $0d4d25cab9a512e7$export$c564cdbbe6da493($0d4d25cab9a512e7$var$seed++);
}
//
// Map each character to its index.
//
for(; $0d4d25cab9a512e7$var$i < $0d4d25cab9a512e7$var$length; $0d4d25cab9a512e7$var$i++)$0d4d25cab9a512e7$var$map[$0d4d25cab9a512e7$var$alphabet[$0d4d25cab9a512e7$var$i]] = $0d4d25cab9a512e7$var$i;



var $9KvBE = parcelRequire("9KvBE");
// browser shim for xmlhttprequest module
// imported from https://github.com/component/has-cors
let $10a6ce9dbae11e7c$var$value = false;
try {
    $10a6ce9dbae11e7c$var$value = typeof XMLHttpRequest !== "undefined" && "withCredentials" in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $10a6ce9dbae11e7c$export$5235bbd4a1ef06e = $10a6ce9dbae11e7c$var$value;



function $9488728f5c331e33$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $10a6ce9dbae11e7c$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $9a1c38584fe7f3e8$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $9488728f5c331e33$export$19413efcf2fac759() {}



var $fbuXh = parcelRequire("fbuXh");


function $804e4955c9378a4f$var$empty() {}
const $804e4955c9378a4f$var$hasXHR2 = function() {
    const xhr = new (0, $9488728f5c331e33$export$a2d42eb087c10497)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $804e4955c9378a4f$export$265ee5eefd4c309b extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $9KvBE.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $9KvBE.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $0d4d25cab9a512e7$export$5bb64b92cb4135a)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $804e4955c9378a4f$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $804e4955c9378a4f$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $9488728f5c331e33$export$19413efcf2fac759)();
    }
}
class $804e4955c9378a4f$export$7fa6c5b6f8193917 extends (0, $fbuXh.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $0f4dd0cd5703ae1b$export$357523c63a2253b9)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $9488728f5c331e33$export$a2d42eb087c10497)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $804e4955c9378a4f$export$7fa6c5b6f8193917.requestsCount++;
            $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $804e4955c9378a4f$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$804e4955c9378a4f$export$7fa6c5b6f8193917.requestsCount = 0;
$804e4955c9378a4f$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $804e4955c9378a4f$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $9a1c38584fe7f3e8$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $804e4955c9378a4f$var$unloadHandler, false);
    }
}
function $804e4955c9378a4f$var$unloadHandler() {
    for(let i in $804e4955c9378a4f$export$7fa6c5b6f8193917.requests)if ($804e4955c9378a4f$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $804e4955c9378a4f$export$7fa6c5b6f8193917.requests[i].abort();
}






const $0eaf8a89e59b3e47$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $0eaf8a89e59b3e47$export$3909fb301d3dc8c9 = (0, $9a1c38584fe7f3e8$export$394f9358f6231289).WebSocket || (0, $9a1c38584fe7f3e8$export$394f9358f6231289).MozWebSocket;
const $0eaf8a89e59b3e47$export$3407ba5dfb7a683d = true;
const $0eaf8a89e59b3e47$export$790dcbc41e2d75d5 = "arraybuffer";


parcelRequire("9KvBE");
var $eB3mK = parcelRequire("eB3mK");

var $dVJB2 = parcelRequire("dVJB2");
var $c63f89971b2ce9c8$require$Buffer = $dVJB2.Buffer;
// detect ReactNative environment
const $c63f89971b2ce9c8$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $c63f89971b2ce9c8$export$911baa0677ac404c extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $c63f89971b2ce9c8$var$isReactNative ? {} : (0, $0f4dd0cd5703ae1b$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d) && !$c63f89971b2ce9c8$var$isReactNative ? protocols ? new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri, protocols) : new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri) : new (0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $eB3mK.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $c63f89971b2ce9c8$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $0eaf8a89e59b3e47$export$3407ba5dfb7a683d) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $0d4d25cab9a512e7$export$5bb64b92cb4135a)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $0eaf8a89e59b3e47$export$3909fb301d3dc8c9);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}





var $9KvBE = parcelRequire("9KvBE");
class $81251642ec6d652f$export$961c930859384407 extends (0, $cefdafcabb98fcd0$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $9KvBE.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $9KvBE.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}


const $9f93f040f63ed139$export$46dec00755c1153b = {
    websocket: (0, $c63f89971b2ce9c8$export$911baa0677ac404c),
    webtransport: (0, $81251642ec6d652f$export$961c930859384407),
    polling: (0, $804e4955c9378a4f$export$265ee5eefd4c309b)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $e71afb3c28816696$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $e71afb3c28816696$var$parts = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
function $e71afb3c28816696$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf("["), e = str.indexOf("]");
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ";") + str.substring(e, str.length);
    let m = $e71afb3c28816696$var$re.exec(str || ""), uri = {}, i = 14;
    while(i--)uri[$e71afb3c28816696$var$parts[i]] = m[i] || "";
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ":");
        uri.authority = uri.authority.replace("[", "").replace("]", "").replace(/;/g, ":");
        uri.ipv6uri = true;
    }
    uri.pathNames = $e71afb3c28816696$var$pathNames(uri, uri["path"]);
    uri.queryKey = $e71afb3c28816696$var$queryKey(uri, uri["query"]);
    return uri;
}
function $e71afb3c28816696$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == "/" || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == "/") names.splice(names.length - 1, 1);
    return names;
}
function $e71afb3c28816696$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}



var $fbuXh = parcelRequire("fbuXh");

var $9KvBE = parcelRequire("9KvBE");

class $515dcfe1978ff794$export$4798917dbf149b79 extends (0, $fbuXh.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $9KvBE.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $9f93f040f63ed139$export$46dec00755c1153b)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $0f4dd0cd5703ae1b$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $515dcfe1978ff794$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $0eaf8a89e59b3e47$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $e71afb3c28816696$export$98e6a39c04603d36)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $e71afb3c28816696$export$98e6a39c04603d36)(opts.host).host;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $e01fce6500821742$export$2f872c0f2117be69)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$515dcfe1978ff794$export$4798917dbf149b79.protocol = (0, $9KvBE.protocol);







const $8df64043f3ed4d36$export$a51d6b395ff4c65a = (0, $515dcfe1978ff794$export$4798917dbf149b79).protocol;


function $b460b4e322b56074$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $e71afb3c28816696$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}




var $7zQLO = parcelRequire("7zQLO");
function $16188adeaa79efa6$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



var $fbuXh = parcelRequire("fbuXh");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $4728d6e983c9cda4$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $4728d6e983c9cda4$export$4798917dbf149b79 extends (0, $fbuXh.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $16188adeaa79efa6$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($4728d6e983c9cda4$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $7zQLO.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $7zQLO.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $7zQLO.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $7zQLO.PacketType).EVENT:
            case (0, $7zQLO.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $7zQLO.PacketType).ACK:
            case (0, $7zQLO.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $7zQLO.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $7zQLO.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $7zQLO.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $7zQLO.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}



var $7zQLO = parcelRequire("7zQLO");

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3765b2853d7f821b$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3765b2853d7f821b$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



var $fbuXh = parcelRequire("fbuXh");
class $fbeb246c7e550d2d$export$d0d38e7dec7a1a61 extends (0, $fbuXh.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $515dcfe1978ff794$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), (0, $16188adeaa79efa6$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $0eaf8a89e59b3e47$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $4728d6e983c9cda4$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $0f4dd0cd5703ae1b$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3765b2853d7f821b$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $7zQLO;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}




var $7zQLO = parcelRequire("7zQLO");
/**
 * Managers cache.
 */ const $3e27f9daa0204a44$var$cache = {};
function $3e27f9daa0204a44$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $b460b4e322b56074$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $3e27f9daa0204a44$var$cache[id] && path in $3e27f9daa0204a44$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fbeb246c7e550d2d$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$3e27f9daa0204a44$var$cache[id]) $3e27f9daa0204a44$var$cache[id] = new (0, $fbeb246c7e550d2d$export$d0d38e7dec7a1a61)(source, opts);
        io = $3e27f9daa0204a44$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($3e27f9daa0204a44$export$841407ceb083bd74, {
    Manager: $fbeb246c7e550d2d$export$d0d38e7dec7a1a61,
    Socket: $4728d6e983c9cda4$export$4798917dbf149b79,
    io: $3e27f9daa0204a44$export$841407ceb083bd74,
    connect: $3e27f9daa0204a44$export$841407ceb083bd74
});


const $1622be301bae0161$var$debugOn = new URLSearchParams(window.location.search).has("debug");
class $1622be301bae0161$export$efa9a398d6368992 {
    isEnabled() {
        return this._isEnabled;
    }
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    info(...params) {
        if (!this._isEnabled) return;
        return console.info(...params);
    }
    warn(...params) {
        if (!this._isEnabled) return;
        return console.warn(...params);
    }
    error(...params) {
        if (!this._isEnabled) return;
        return console.error(...params);
    }
    withDebugLogger(myDebugger = null) {
        this._debugger = myDebugger;
        return this;
    }
    debug(...params) {
        if (!this._isEnabled || !this._debugger) return;
        const suppliedParams = [];
        params.forEach((param)=>{
            if (typeof param === "function") {
                const suppliedParam = param();
                suppliedParams.push(suppliedParam);
            } else suppliedParams.push(param);
        });
        this._debugger.print(...suppliedParams);
    }
    constructor(){
        this._isEnabled = false;
        this._debugger = null;
        this._isEnabled = $1622be301bae0161$var$debugOn;
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $1622be301bae0161$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $1622be301bae0161$export$e0d9ca86534ab48(cpMetrics, currentCptats, prevCptats, timeDiff, report) {
    const bytesReceivedDiff = currentCptats.bytesReceived - ((prevCptats === null || prevCptats === void 0 ? void 0 : prevCptats.bytesReceived) || 0);
    const bytesSentDiff = currentCptats.bytesSent - ((prevCptats === null || prevCptats === void 0 ? void 0 : prevCptats.bytesSent) || 0);
    cpMetrics.bitrateIn = 8000 * bytesReceivedDiff / timeDiff;
    cpMetrics.bitrateOut = 8000 * bytesSentDiff / timeDiff;
    cpMetrics.state = currentCptats.state;
    cpMetrics.roundTripTime = currentCptats.currentRoundTripTime;
    cpMetrics.requestsSent = currentCptats.requestsSent;
    cpMetrics.responsesReceived = currentCptats.responsesReceived;
    cpMetrics.requestsReceived = currentCptats.requestsReceived;
    cpMetrics.responsesSent = currentCptats.responsesSent;
    cpMetrics.availableOutgoingBitrate = currentCptats.availableOutgoingBitrate;
    cpMetrics.availableIncomingBitrate = currentCptats.availableIncomingBitrate;
    const remote = report.get(currentCptats.remoteCandidateId);
    const local = report.get(currentCptats.localCandidateId);
    cpMetrics.usingTurn = false;
    if (local) {
        if (/relay/i.test(local.candidateType || "")) {
            cpMetrics.usingTurn = true;
            cpMetrics.turnProtocol = local.relayProtocol;
        }
    }
    if (remote && local) {
        cpMetrics.localEp = `${local.protocol}:${local.address || local.ip}:${local.port} ${local.candidateType} (${local.networkType})`;
        cpMetrics.remoteEp = `${remote.protocol}:${remote.address || remote.ip}:${remote.port} ${remote.candidateType}`;
    }
}
function $1622be301bae0161$export$16f2e79b3a5401ad(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    if (ssrcMetrics.codec) return;
    ssrcMetrics.kind = currentSsrcStats.kind || currentSsrcStats.mediaType;
    ssrcMetrics.ssrc = currentSsrcStats.ssrc;
    ssrcMetrics.direction = currentSsrcStats.type === "inbound-rtp" ? "in" : "out";
    const codecStats = currentSsrcStats.codecId && report.get(currentSsrcStats.codecId);
    ssrcMetrics.codec = codecStats && [
        codecStats.mimeType,
        codecStats.channels && `${codecStats.channels}ch`,
        codecStats.clockRate,
        codecStats.payloadType,
        currentSsrcStats.encoderImplementation || currentSsrcStats.decoderImplementation,
        codecStats.sdpFmtpLine
    ].filter(Boolean).join(" ");
    ssrcMetrics.mid = currentSsrcStats.mid;
    ssrcMetrics.rid = currentSsrcStats.rid;
}
function $1622be301bae0161$export$68cf3afdddf059e2(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    const nackCountDiff = (currentSsrcStats.nackCount || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.nackCount) || 0);
    ssrcMetrics.nackCount = (ssrcMetrics.nackCount || 0) + nackCountDiff;
    ssrcMetrics.nackRate = 1000 * nackCountDiff / timeDiff;
    if (ssrcMetrics.direction === "in") {
        const packetCountDiff = currentSsrcStats.packetsReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsReceived) || 0);
        ssrcMetrics.packetCount = (ssrcMetrics.packetCount || 0) + packetCountDiff;
        ssrcMetrics.packetRate = 1000 * packetCountDiff / timeDiff;
        const packetLossCountDiff = currentSsrcStats.packetsLost - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsLost) || 0);
        ssrcMetrics.packetLossCount = (ssrcMetrics.packetLossCount || 0) + packetLossCountDiff;
        ssrcMetrics.packetLossRate = 1000 * packetLossCountDiff / timeDiff;
        ssrcMetrics.lossRatio = 1000 * (packetLossCountDiff / (packetLossCountDiff + packetCountDiff)) / timeDiff;
        const byteCountDiff = currentSsrcStats.bytesReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.bytesReceived) || 0);
        ssrcMetrics.byteCount = (ssrcMetrics.byteCount || 0) + byteCountDiff;
        let headerByteCountDiff = 0;
        if (currentSsrcStats.headerBytesReceived) {
            headerByteCountDiff = currentSsrcStats.headerBytesReceived - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.headerBytesReceived) || 0);
            ssrcMetrics.headerByteCount = (ssrcMetrics.headerByteCount || 0) + headerByteCountDiff;
        }
        const totalBytesDiff = byteCountDiff + headerByteCountDiff;
        ssrcMetrics.bitrate = 8000 * totalBytesDiff / timeDiff;
        ssrcMetrics.mediaRatio = byteCountDiff / totalBytesDiff;
        if (currentSsrcStats.kind === "audio") {
            const fecBytesDiff = (currentSsrcStats.fecBytesReceived || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.fecBytesReceived) || 0);
            ssrcMetrics.fecRatio = fecBytesDiff / byteCountDiff;
        }
        const jitterBufferDelayDiff = (currentSsrcStats.jitterBufferDelay || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.jitterBufferDelay) || 0);
        const jitterBufferEmittedDiff = (currentSsrcStats.jitterBufferEmittedCount || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.jitterBufferEmittedCount) || 0);
        ssrcMetrics.jitter = jitterBufferEmittedDiff ? jitterBufferDelayDiff / jitterBufferEmittedDiff : 0;
    } else {
        const packetCountDiff = currentSsrcStats.packetsSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsSent) || 0);
        ssrcMetrics.packetCount = (ssrcMetrics.packetCount || 0) + packetCountDiff;
        ssrcMetrics.packetRate = 1000 * packetCountDiff / timeDiff;
        const byteCountDiff = currentSsrcStats.bytesSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.bytesSent) || 0);
        ssrcMetrics.byteCount = (ssrcMetrics.byteCount || 0) + byteCountDiff;
        let headerByteCountDiff = 0;
        if (currentSsrcStats.headerBytesSent) {
            headerByteCountDiff = currentSsrcStats.headerBytesSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.headerBytesSent) || 0);
            ssrcMetrics.headerByteCount = (ssrcMetrics.headerByteCount || 0) + headerByteCountDiff;
        }
        const totalBytesDiff = byteCountDiff + headerByteCountDiff;
        ssrcMetrics.bitrate = 8000 * totalBytesDiff / timeDiff;
        ssrcMetrics.mediaRatio = byteCountDiff / totalBytesDiff;
        const sendDelayDiff = currentSsrcStats.totalPacketSendDelay - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalPacketSendDelay) || 0);
        ssrcMetrics.sendDelay = sendDelayDiff / packetCountDiff;
        const retransDiff = currentSsrcStats.retransmittedPacketsSent - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.retransmittedPacketsSent) || 0);
        ssrcMetrics.retransRatio = 1000 * (retransDiff / packetCountDiff) / timeDiff;
        if (currentSsrcStats.remoteId) {
            const remoteReport = report.get(currentSsrcStats.remoteId);
            if (remoteReport) {
                ssrcMetrics.roundTripTime = remoteReport.roundTripTime || 0;
                ssrcMetrics.jitter = remoteReport.jitter || 0;
                ssrcMetrics.fractionLost = remoteReport.fractionLost || 0;
            }
        }
    }
}
function $1622be301bae0161$export$ae7525495638aed5(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    const packetsDiscardedDiff = currentSsrcStats.packetsDiscarded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.packetsDiscarded) || 0);
    ssrcMetrics.packetsDiscarded = (ssrcMetrics.packetsDiscarded || 0) + packetsDiscardedDiff;
    if (ssrcMetrics.direction === "in") {
        const totalAudioEnergyDiff = currentSsrcStats.totalAudioEnergy - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalAudioEnergy) || 0);
        const totalSamplesDurationDiff = currentSsrcStats.totalSamplesDuration - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalSamplesDuration) || 0);
        ssrcMetrics.audioLevel = Math.sqrt(totalAudioEnergyDiff / totalSamplesDurationDiff);
        const samples = currentSsrcStats.totalSamplesReceived || 0;
        const concealmentEvents = currentSsrcStats.concealmentEvents || 0;
        const samplesDiff = samples - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalSamplesReceived) || 0);
        const concealedSamples = currentSsrcStats.concealedSamples || 0;
        const concealedDiff = concealedSamples - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.concealedSamples) || 0);
        const silentConcealedDiff = (currentSsrcStats.silentConcealedSamples || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.silentConcealedSamples) || 0);
        const insDiff = (currentSsrcStats.insertedSamplesForDeceleration || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.insertedSamplesForDeceleration) || 0);
        const remDiff = (currentSsrcStats.removedSamplesForAcceleration || 0) - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.removedSamplesForAcceleration) || 0);
        ssrcMetrics.audioSamples = samples;
        ssrcMetrics.audioConcealmentEvents = concealmentEvents;
        ssrcMetrics.audioConcealedSamples = concealedSamples;
        ssrcMetrics.audioConcealment = concealedDiff ? concealedDiff / samplesDiff : 0;
        ssrcMetrics.audioSilentConcealment = silentConcealedDiff ? silentConcealedDiff / samplesDiff : 0;
        ssrcMetrics.audioAcceleration = remDiff ? remDiff / samplesDiff : 0;
        ssrcMetrics.audioDeceleration = insDiff ? insDiff / samplesDiff : 0;
    }
}
function $1622be301bae0161$export$6f8e63161a499169(ssrcMetrics, currentSsrcStats, prevSsrcStats, timeDiff, report) {
    ssrcMetrics.width = currentSsrcStats.frameWidth;
    ssrcMetrics.height = currentSsrcStats.frameHeight;
    ssrcMetrics.qualityLimitationReason = currentSsrcStats.qualityLimitationReason || "";
    const pliCountDiff = currentSsrcStats.pliCount - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.pliCount) || 0);
    ssrcMetrics.pliCount = (ssrcMetrics.pliCount || 0) + pliCountDiff;
    ssrcMetrics.pliRate = 1000 * pliCountDiff / timeDiff;
    const firCountDiff = currentSsrcStats.firCount - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.firCount) || 0);
    ssrcMetrics.firCount = (ssrcMetrics.firCount || 0) + firCountDiff;
    ssrcMetrics.firRate = 1000 * firCountDiff / timeDiff;
    if (ssrcMetrics.direction === "in") {
        const kfCountDiff = currentSsrcStats.keyFramesDecoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.keyFramesDecoded) || 0);
        ssrcMetrics.kfCount = (ssrcMetrics.kfCount || 0) + kfCountDiff;
        ssrcMetrics.kfRate = 1000 * kfCountDiff / timeDiff;
        const frameCountDiff = currentSsrcStats.framesDecoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.framesDecoded) || 0);
        ssrcMetrics.frameCount = (ssrcMetrics.frameCount || 0) + frameCountDiff;
        const qpsumDiff = currentSsrcStats.qpSum - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.qpSum) || 0);
        ssrcMetrics.qpf = qpsumDiff / frameCountDiff;
        ssrcMetrics.fps = frameCountDiff * 1000 / timeDiff;
    } else {
        const kfCountDiff = currentSsrcStats.keyFramesEncoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.keyFramesEncoded) || 0);
        ssrcMetrics.kfCount = (ssrcMetrics.kfCount || 0) + kfCountDiff;
        ssrcMetrics.kfRate = 1000 * kfCountDiff / timeDiff;
        const frameCountDiff = currentSsrcStats.framesEncoded - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.framesEncoded) || 0);
        ssrcMetrics.frameCount = (ssrcMetrics.frameCount || 0) + frameCountDiff;
        const qpsumDiff = currentSsrcStats.qpSum - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.qpSum) || 0);
        ssrcMetrics.qpf = qpsumDiff / frameCountDiff;
        ssrcMetrics.fps = frameCountDiff * 1000 / timeDiff;
        const encodeTimeDiff = currentSsrcStats.totalEncodeTime - ((prevSsrcStats === null || prevSsrcStats === void 0 ? void 0 : prevSsrcStats.totalEncodeTime) || 0);
        ssrcMetrics.encodeTime = encodeTimeDiff / frameCountDiff;
        if (currentSsrcStats.mediaSourceId) {
            const mediaSourceReport = report.get(currentSsrcStats.mediaSourceId);
            if (mediaSourceReport) {
                ssrcMetrics.sourceWidth = mediaSourceReport.width || 0;
                ssrcMetrics.sourceHeight = mediaSourceReport.height || 0;
                ssrcMetrics.sourceFps = mediaSourceReport.framesPerSecond || 0;
            }
        }
    }
}
let $1622be301bae0161$var$peerConnections = [];
let $1622be301bae0161$var$peerConnectionCounter = 0;
const $1622be301bae0161$var$peerConnectionData = new WeakMap();
const $1622be301bae0161$export$b1f10c3e96f6558d = (pc)=>{
    $1622be301bae0161$var$peerConnections = $1622be301bae0161$var$peerConnections.filter((old)=>old !== pc);
};
if (window.RTCPeerConnection) {
    const OriginalRTCPeerConnection = window.RTCPeerConnection;
    function PatchedRTCPeerConnection(rtcConfig) {
        const pc = new OriginalRTCPeerConnection(rtcConfig);
        $1622be301bae0161$var$peerConnections.push(pc);
        $1622be301bae0161$var$peerConnectionData.set(pc, {
            index: $1622be301bae0161$var$peerConnectionCounter++
        });
        const onConnectionStateChange = ()=>{
            if (pc.connectionState === "closed") {
                $1622be301bae0161$export$b1f10c3e96f6558d(pc);
                pc.removeEventListener("connectionstatechange", onConnectionStateChange);
            }
        };
        pc.addEventListener("connectionstatechange", onConnectionStateChange);
        return pc;
    }
    PatchedRTCPeerConnection.prototype = OriginalRTCPeerConnection.prototype;
    window.RTCPeerConnection = PatchedRTCPeerConnection;
}
const $1622be301bae0161$export$7ebad8aba6d694ee = ()=>$1622be301bae0161$var$peerConnections;
const $1622be301bae0161$export$56866cc07fc6e61f = (pc)=>{
    var _a;
    return (_a = $1622be301bae0161$var$peerConnectionData.get(pc)) === null || _a === void 0 ? void 0 : _a.index;
};
const $1622be301bae0161$export$f0701262c33e50fa = (pcs)=>$1622be301bae0161$var$peerConnections = pcs;
const $1622be301bae0161$var$pcDataByPc = new WeakMap();
const $1622be301bae0161$var$getPeerConnectionsWithStatsReports = ()=>Promise.all($1622be301bae0161$export$7ebad8aba6d694ee().map((pc)=>$1622be301bae0161$var$__awaiter(void 0, void 0, void 0, function*() {
            let pcData = $1622be301bae0161$var$pcDataByPc.get(pc);
            if (!pcData) {
                pcData = {
                    ssrcToTrackId: {}
                };
                $1622be301bae0161$var$pcDataByPc.set(pc, pcData);
            }
            try {
                const report = yield pc.getStats();
                let missingSsrcs = null;
                report.forEach((stats)=>{
                    if (stats.type === "inbound-rtp" || stats.type === "outbound-rtp") {
                        if (!stats.trackIdentifier && !pcData.ssrcToTrackId[stats.ssrc]) {
                            if (stats.mediaSourceId) {
                                const mediaSourceStats = report.get(stats.mediaSourceId);
                                if (mediaSourceStats) {
                                    if (mediaSourceStats.trackIdentifier) pcData.ssrcToTrackId[stats.ssrc] = mediaSourceStats.trackIdentifier;
                                }
                            }
                            if (!pcData.ssrcToTrackId[stats.ssrc] && stats.trackId) {
                                const deprecatedTrackStats = report.get(stats.trackId);
                                if (deprecatedTrackStats) {
                                    if (deprecatedTrackStats.trackIdentifier) pcData.ssrcToTrackId[stats.ssrc] = deprecatedTrackStats.trackIdentifier;
                                }
                            }
                            if (!pcData.ssrcToTrackId[stats.ssrc]) {
                                if (!missingSsrcs) missingSsrcs = [];
                                missingSsrcs.push(stats.ssrc);
                            }
                        }
                    }
                });
                if (missingSsrcs) {
                    const sendersAndReceivers = [
                        ...pc.getSenders(),
                        ...pc.getReceivers()
                    ];
                    const reports = yield Promise.all(sendersAndReceivers.map((o)=>o.getStats()));
                    reports.forEach((tReport, index)=>{
                        tReport.forEach((stats)=>{
                            if (stats.type === "inbound-rtp" || stats.type === "outbound-rtp") pcData.ssrcToTrackId[stats.ssrc] = sendersAndReceivers[index].track.id;
                        });
                    });
                    missingSsrcs.forEach((ssrc)=>{
                        if (!pcData.ssrcToTrackId[ssrc]) pcData.ssrcToTrackId[ssrc] = "?" + ssrc;
                    });
                }
                return [
                    pc,
                    report,
                    pcData
                ];
            } catch (ex) {
                return [
                    pc,
                    [],
                    pcData
                ];
            }
        })));
const $1622be301bae0161$var$getOrCreateSsrcMetricsContainer = (statsByView, time, pcIndex, clientId, trackId, ssrc)=>{
    let viewStats = statsByView[clientId];
    if (!viewStats) {
        viewStats = {
            tracks: {},
            startTime: time,
            updated: time
        };
        statsByView[clientId] = viewStats;
    }
    viewStats.updated = time;
    let trackStats = viewStats.tracks[trackId];
    if (!trackStats) {
        trackStats = {
            ssrcs: {},
            startTime: time,
            updated: time
        };
        viewStats.tracks[trackId] = trackStats;
    }
    trackStats.updated = time;
    let ssrcStats = trackStats.ssrcs[ssrc];
    if (!ssrcStats) {
        ssrcStats = {
            startTime: time,
            updated: time,
            pcIndex: pcIndex
        };
        trackStats.ssrcs[ssrc] = ssrcStats;
    }
    ssrcStats.updated = time;
    return ssrcStats;
};
const $1622be301bae0161$var$removeNonUpdatedStats = (statsByView, time)=>{
    Object.entries(statsByView).forEach(([viewId, viewStats])=>{
        if (viewStats.updated < time) delete statsByView[viewId];
        else Object.entries(viewStats.tracks).forEach(([trackId, trackStats])=>{
            if (trackStats.updated < time) delete viewStats.tracks[trackId];
            else Object.entries(trackStats.ssrcs).forEach(([ssrc, ssrcStats])=>{
                if (ssrcStats.updated < time) delete trackStats.ssrcs[ssrc];
            });
        });
    });
};
function $1622be301bae0161$var$collectStats(state, { logger: logger, interval: interval }, immediate) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const collectStatsBound = $1622be301bae0161$var$collectStats.bind(null, state, {
            interval: interval,
            logger: logger
        });
        try {
            const clients = state.getClients();
            const defaultClient = clients.find((c)=>c.isLocalClient && !c.isPresentation) || {
                id: "unknown"
            };
            let defaultViewStats = state.statsByView[defaultClient.id];
            if (!defaultViewStats) {
                defaultViewStats = {
                    tracks: {},
                    candidatePairs: {},
                    pressure: null
                };
                state.statsByView[defaultClient.id] = defaultViewStats;
            }
            defaultViewStats.pressure = state.lastPressureObserverRecord;
            const timeSinceLastUpdate = Date.now() - state.lastUpdateTime;
            if (timeSinceLastUpdate < 400) {
                if (immediate) return state.statsByView;
                state.subscriptions.forEach((subscription)=>{
                    var _a;
                    return (_a = subscription.onUpdatedStats) === null || _a === void 0 ? void 0 : _a.call(subscription, state.statsByView, clients);
                });
                state.nextTimeout = setTimeout(collectStatsBound, interval);
                return;
            }
            state.lastUpdateTime = Date.now();
            (yield $1622be301bae0161$var$getPeerConnectionsWithStatsReports()).forEach(([pc, report, pcData])=>{
                const pcIndex = $1622be301bae0161$export$56866cc07fc6e61f(pc);
                if (pc.connectionState === "closed") {
                    report = new Map();
                    $1622be301bae0161$export$b1f10c3e96f6558d(pc);
                }
                pcData.previousSSRCs = pcData.currentSSRCs || {};
                pcData.currentSSRCs = {};
                report.forEach((currentRtcStats)=>{
                    var _a, _b, _c;
                    if (currentRtcStats.type === "candidate-pair" && /inprogress|succeeded/.test(currentRtcStats.state)) {
                        const prevRtcStats = (_a = pcData._oldReport) === null || _a === void 0 ? void 0 : _a.get(currentRtcStats.id);
                        const timeDiff = prevRtcStats ? currentRtcStats.timestamp - prevRtcStats.timestamp : interval;
                        const cpId = pcIndex + ":" + currentRtcStats.id;
                        let cpMetrics = defaultViewStats.candidatePairs[cpId];
                        if (!cpMetrics) {
                            cpMetrics = {
                                startTime: state.lastUpdateTime,
                                id: cpId
                            };
                            defaultViewStats.candidatePairs[cpId] = cpMetrics;
                        }
                        $1622be301bae0161$export$e0d9ca86534ab48(cpMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        cpMetrics.lastRtcStatsTime = state.lastUpdateTime;
                    }
                    if (currentRtcStats.type === "inbound-rtp" || currentRtcStats.type === "outbound-rtp") {
                        const kind = currentRtcStats.mediaType || currentRtcStats.kind;
                        const ssrc = currentRtcStats.ssrc;
                        let trackId = currentRtcStats.trackIdentifier || pcData.ssrcToTrackId[ssrc];
                        let prevRtcStats = (_b = pcData._oldReport) === null || _b === void 0 ? void 0 : _b.get(currentRtcStats.id);
                        if (prevRtcStats && prevRtcStats.mediaSourceId !== currentRtcStats.mediaSourceId) {
                            const mediaSourceStats = report.get(currentRtcStats.mediaSourceId);
                            if (mediaSourceStats && mediaSourceStats.trackIdentifier) {
                                trackId = mediaSourceStats.trackIdentifier;
                                pcData.ssrcToTrackId[ssrc] = trackId;
                            }
                        }
                        const client = clients.find((c)=>{
                            var _a;
                            return ((_a = c[kind].track) === null || _a === void 0 ? void 0 : _a.id) === trackId;
                        }) || defaultClient;
                        if (!currentRtcStats.trackIdentifier && pcData.ssrcToTrackId[ssrc] && ((_c = client[kind].track) === null || _c === void 0 ? void 0 : _c.id) && client[kind].track.id !== pcData.ssrcToTrackId[ssrc]) {
                            trackId = client[kind].track.id;
                            pcData.ssrcToTrackId[ssrc] = client[kind].track.id;
                        }
                        pcData.currentSSRCs[ssrc] = client.id;
                        if (prevRtcStats) {
                            const newTransport = report.get(currentRtcStats.transportId);
                            const oldTransport = pcData._oldReport.get(prevRtcStats.transportId);
                            if (oldTransport && (newTransport === null || newTransport === void 0 ? void 0 : newTransport.selectedCandidatePairId) !== oldTransport.selectedCandidatePairId) prevRtcStats = null;
                            else if (currentRtcStats.bytesReceived < prevRtcStats.bytesReceived || currentRtcStats.bytesSent < prevRtcStats.bytesSent) prevRtcStats = null;
                        }
                        const timeDiff = prevRtcStats ? currentRtcStats.timestamp - prevRtcStats.timestamp : interval;
                        const ssrcMetrics = $1622be301bae0161$var$getOrCreateSsrcMetricsContainer(state.statsByView, state.lastUpdateTime, pcIndex, client.id, trackId, ssrc);
                        $1622be301bae0161$export$16f2e79b3a5401ad(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        $1622be301bae0161$export$68cf3afdddf059e2(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        if (kind === "video") $1622be301bae0161$export$6f8e63161a499169(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                        if (kind === "audio") $1622be301bae0161$export$ae7525495638aed5(ssrcMetrics, currentRtcStats, prevRtcStats, timeDiff, report);
                    }
                });
                pcData._oldReport = report;
                Object.keys(pcData.previousSSRCs).filter((ssrc)=>!pcData.currentSSRCs[ssrc]).forEach((ssrc)=>{
                    const clientId = pcData.previousSSRCs[ssrc];
                    if (clientId) {
                        const clientView = state.statsByView[clientId];
                        if (clientView) Object.values(clientView.tracks).forEach((trackStats)=>{
                            if (trackStats.ssrcs[ssrc]) delete trackStats.ssrcs[ssrc];
                        });
                    }
                });
            });
            $1622be301bae0161$var$removeNonUpdatedStats(state.statsByView, state.lastUpdateTime);
            Object.entries(defaultViewStats.candidatePairs).forEach(([cpKey, cp])=>{
                const active = cp.lastRtcStatsTime === state.lastUpdateTime;
                cp.active = active;
                if (!active) {
                    cp.state = "old/inactive";
                    if (!cp.inactiveFromTime) cp.inactiveFromTime = state.lastUpdateTime;
                    else if (state.lastUpdateTime - cp.inactiveFromTime > 4000) delete defaultViewStats.candidatePairs[cpKey];
                }
            });
            if (immediate) return state.statsByView;
            else state.subscriptions.forEach((subscription)=>{
                var _a;
                return (_a = subscription.onUpdatedStats) === null || _a === void 0 ? void 0 : _a.call(subscription, state.statsByView, clients);
            });
        } catch (ex) {
            logger.warn(ex);
        }
        state.nextTimeout = setTimeout(collectStatsBound, interval);
    });
}
const $1622be301bae0161$var$REGISTERED_TRIALS = {};
function $1622be301bae0161$var$registerOriginTrials(trials, registeredTrials = $1622be301bae0161$var$REGISTERED_TRIALS, document1 = window.document) {
    trials.forEach(({ hostnamePattern: hostnamePattern, token: token })=>{
        const key = `${hostnamePattern}-${token}`;
        if (registeredTrials[key]) return;
        if (hostnamePattern.test(document1.location.hostname)) {
            const otMeta = document1.createElement("meta");
            otMeta.httpEquiv = "origin-trial";
            otMeta.content = token;
            document1.head.append(otMeta);
            registeredTrials[key] = true;
        }
    });
}
const $1622be301bae0161$var$CPU_OBSERVER_OPTIONS = {
    sampleRate: 1,
    originTrials: [
        {
            hostnamePattern: /hereby\.dev/,
            token: "AkSNPHJw6EK08X0QU7kORnK9NABzRLAC7dqfXOwk5JwFAQG4Ey7WxLXxsnhieCgC1QHUdevE2EFICy7uBGDANwUAAABqeyJvcmlnaW4iOiJodHRwczovL2hlcmVieS5kZXY6NDQ0MyIsImZlYXR1cmUiOiJDb21wdXRlUHJlc3N1cmVfdjIiLCJleHBpcnkiOjE3MTY5NDA3OTksImlzU3ViZG9tYWluIjp0cnVlfQ=="
        },
        {
            hostnamePattern: /whereby\.com/,
            token: "Asc2wu8KpSx648i932NICteQDFcB05yl2QUUSHD7AQo8JGP2Fp6FF91TvYVJBsKGzLMH349rysPw5q9tqPC/PAUAAABqeyJvcmlnaW4iOiJodHRwczovL3doZXJlYnkuY29tOjQ0MyIsImZlYXR1cmUiOiJDb21wdXRlUHJlc3N1cmVfdjIiLCJleHBpcnkiOjE3MTY5NDA3OTksImlzU3ViZG9tYWluIjp0cnVlfQ=="
        }
    ]
};
function $1622be301bae0161$var$startCpuObserver(cb, { sampleRate: sampleRate, originTrials: originTrials } = $1622be301bae0161$var$CPU_OBSERVER_OPTIONS, window1 = globalThis.window) {
    $1622be301bae0161$var$registerOriginTrials(originTrials);
    let pressureObserver;
    if ("PressureObserver" in window1) {
        pressureObserver = new window1.PressureObserver(cb, {
            sampleRate: sampleRate
        });
        pressureObserver.observe("cpu", {
            sampleInterval: sampleRate * 1000
        });
        return {
            stop: ()=>{
                pressureObserver.unobserve("cpu");
            }
        };
    }
}
const $1622be301bae0161$var$STATE = {
    currentMonitor: null,
    getClients: ()=>[],
    lastUpdateTime: 0,
    statsByView: {},
    subscriptions: []
};
const $1622be301bae0161$var$OPTIONS = {
    interval: 2000,
    logger: new $1622be301bae0161$export$efa9a398d6368992()
};
const $1622be301bae0161$export$432f698644f45d1 = ()=>{
    return Object.assign({}, $1622be301bae0161$var$STATE.statsByView);
};
const $1622be301bae0161$export$a95105d8b2471e00 = ()=>{
    var _a;
    return (_a = $1622be301bae0161$var$STATE.currentMonitor) === null || _a === void 0 ? void 0 : _a.getUpdatedStats();
};
const $1622be301bae0161$export$591e741f8b7f4720 = (provider)=>$1622be301bae0161$var$STATE.getClients = provider;
function $1622be301bae0161$var$startStatsMonitor(state, { interval: interval, logger: logger }) {
    const collectStatsBound = $1622be301bae0161$var$collectStats.bind(null, state, {
        interval: interval,
        logger: logger
    });
    let cpuObserver;
    try {
        cpuObserver = $1622be301bae0161$var$startCpuObserver((records)=>state.lastPressureObserverRecord = records.pop());
    } catch (ex) {
        logger.warn("Failed to observe CPU pressure", ex);
    }
    setTimeout(collectStatsBound, interval);
    return {
        getUpdatedStats: ()=>{
            return collectStatsBound(true);
        },
        stop: ()=>{
            clearTimeout(state.nextTimeout);
            if (cpuObserver) cpuObserver.stop();
        }
    };
}
function $1622be301bae0161$export$446568135c9b26ef(subscription, options = $1622be301bae0161$var$OPTIONS, state = $1622be301bae0161$var$STATE) {
    state.subscriptions.push(subscription);
    if (!state.currentMonitor) state.currentMonitor = $1622be301bae0161$var$startStatsMonitor(state, options);
    return {
        stop () {
            var _a;
            state.subscriptions = state.subscriptions.filter((s)=>s !== subscription);
            if (!state.subscriptions.length) {
                (_a = state.currentMonitor) === null || _a === void 0 || _a.stop();
                state.currentMonitor = null;
            }
        }
    };
}
const $1622be301bae0161$var$badNetworkIssueDetector = {
    id: "bad-network",
    enabled: ({ hasLiveTrack: hasLiveTrack, ssrcs: ssrcs })=>hasLiveTrack && ssrcs.length > 0,
    check: ({ client: client, clients: clients, kind: kind, ssrcs: ssrcs })=>{
        const hasPositiveBitrate = ssrcs.some((ssrc)=>ssrc.bitrate > 0);
        if (!hasPositiveBitrate && client.isLocalClient && kind === "video") {
            const remoteClients = clients.filter((c)=>!c.isLocalClient);
            if (remoteClients.length > 0) return !remoteClients.every((c)=>c.isAudioOnlyModeEnabled);
        }
        const ssrc0 = ssrcs[0];
        if (!ssrc0) return false;
        return ssrc0.bitrate === 0 || ssrc0.lossRatio > 0.03 || (ssrc0.fractionLost || 0) > 0.03 || !client.isPresentation && kind === "video" && ssrc0.bitrate < 30000 || ssrc0.direction === "in" && ssrc0.pliRate > 2;
    }
};
const $1622be301bae0161$var$dryTrackIssueDetector = {
    id: "dry-track",
    enabled: ({ hasLiveTrack: hasLiveTrack, ssrcs: ssrcs })=>!!(hasLiveTrack && ssrcs),
    check: ({ client: client, clients: clients, ssrcs: ssrcs })=>{
        let hasPositiveBitrate = false;
        ssrcs.forEach((ssrc)=>{
            hasPositiveBitrate = hasPositiveBitrate || ssrc.bitrate > 0;
        });
        if (!hasPositiveBitrate && client.isLocalClient) {
            const remoteClients = clients.filter((c)=>!c.isLocalClient);
            if (remoteClients.length > 0) return !remoteClients.every((c)=>c.isAudioOnlyModeEnabled);
        }
        return !hasPositiveBitrate;
    }
};
const $1622be301bae0161$var$noTrackIssueDetector = {
    id: "no-track",
    enabled: ()=>true,
    check: ({ client: client, clients: clients, kind: kind, track: track })=>{
        if (!track && !client.isLocalClient && kind === "video") {
            const localClient = clients.find((c)=>c.isLocalClient);
            if (localClient) return !localClient.isAudioOnlyModeEnabled;
        }
        return !track;
    }
};
const $1622be301bae0161$var$noTrackStatsIssueDetector = {
    id: "no-track-stats",
    enabled: ({ hasLiveTrack: hasLiveTrack })=>hasLiveTrack,
    check: ({ client: client, clients: clients, kind: kind, ssrcs: ssrcs })=>{
        if (ssrcs.length === 0 && !client.isLocalClient && kind === "video") {
            const localClient = clients.find((c)=>c.isLocalClient);
            if (localClient) return !localClient.isAudioOnlyModeEnabled;
        }
        return ssrcs.length === 0;
    }
};
const $1622be301bae0161$var$issueDetectors = [
    {
        id: "desync",
        enabled: ({ client: client, track: track, stats: stats })=>{
            return !client.isLocalClient && (track === null || track === void 0 ? void 0 : track.kind) === "audio" && typeof (stats === null || stats === void 0 ? void 0 : stats.tracks) === "object" && Object.keys(stats.tracks).length > 1;
        },
        check: ({ stats: { tracks: tracks } })=>{
            const jitter = {
                audio: 0,
                video: 0
            };
            Object.values(tracks).flatMap((t)=>Object.values(t.ssrcs)).forEach((ssrc)=>{
                if (ssrc.kind === "audio" && ssrc.jitter > jitter.audio) jitter.audio = ssrc.jitter;
                if (ssrc.kind === "video" && ssrc.jitter > jitter.video) jitter.video = ssrc.jitter;
            });
            const diff = Math.abs(jitter.audio * 1000 - jitter.video * 1000);
            return diff > 500;
        }
    },
    $1622be301bae0161$var$noTrackIssueDetector,
    {
        id: "ended-track",
        enabled: ({ track: track })=>!!track,
        check: ({ track: track })=>(track === null || track === void 0 ? void 0 : track.readyState) === "ended"
    },
    $1622be301bae0161$var$noTrackStatsIssueDetector,
    $1622be301bae0161$var$dryTrackIssueDetector,
    {
        id: "low-layer0-bitrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && kind === "video" && ssrc0 && ssrc0.height && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.height < 200 && ssrc0.bitrate < 30000
    },
    {
        id: "quality-limitation-bw",
        enabled: ({ hasLiveTrack: hasLiveTrack, stats: stats, client: client, kind: kind })=>hasLiveTrack && client.isLocalClient && kind === "video" && stats,
        check: ({ stats: stats })=>!!Object.values(stats.tracks).find((track)=>Object.values(track.ssrcs).find((ssrc)=>ssrc.qualityLimitationReason === "bandwidth"))
    },
    {
        id: "quality-limitation-cpu",
        enabled: ({ hasLiveTrack: hasLiveTrack, stats: stats, client: client, kind: kind })=>hasLiveTrack && client.isLocalClient && kind === "video" && stats,
        check: ({ stats: stats })=>!!Object.values(stats.tracks).find((track)=>Object.values(track.ssrcs).find((ssrc)=>ssrc.qualityLimitationReason === "cpu"))
    },
    {
        id: "high-plirate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.height,
        check: ({ ssrc0: ssrc0 })=>ssrc0.pliRate > 2
    },
    {
        id: "extreme-plirate",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.height,
        check: ({ ssrc0: ssrc0 })=>ssrc0.pliRate > 5
    },
    {
        id: "high-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "in",
        check: ({ ssrc0: ssrc0 })=>ssrc0.lossRatio > 0.02
    },
    {
        id: "extreme-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "in",
        check: ({ ssrc0: ssrc0 })=>ssrc0.lossRatio > 0.1
    },
    {
        id: "high-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "out",
        check: ({ ssrc0: ssrc0 })=>(ssrc0.fractionLost || 0) > 0.02
    },
    {
        id: "extreme-packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.direction === "out",
        check: ({ ssrc0: ssrc0 })=>(ssrc0.fractionLost || 0) > 0.1
    },
    {
        id: "fps-below-20",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && ssrc0 && ssrc0.height && kind === "video" && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.height > 180 && ssrc0.fps < 20
    },
    {
        id: "fps-below-10",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind, client: client })=>hasLiveTrack && ssrc0 && ssrc0.height && kind === "video" && !client.isPresentation,
        check: ({ ssrc0: ssrc0 })=>ssrc0.fps < 10
    },
    $1622be301bae0161$var$badNetworkIssueDetector,
    {
        id: "cpu-pressure-serious",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        check: ({ stats: stats })=>stats.pressure.state === "serious"
    },
    {
        id: "cpu-pressure-critical",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        check: ({ stats: stats })=>stats.pressure.state === "critical"
    },
    {
        id: "concealed",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioConcealment >= 0.1
    },
    {
        id: "decelerated",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioDeceleration >= 0.1
    },
    {
        id: "accelerated",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && kind === "audio",
        check: ({ ssrc0: ssrc0 })=>ssrc0.bitrate && ssrc0.direction === "in" && ssrc0.audioLevel >= 0.001 && ssrc0.audioAcceleration >= 0.1
    }
];
let $1622be301bae0161$var$subscriptions = [];
let $1622be301bae0161$var$stopStats = null;
const $1622be301bae0161$var$metrics = [
    {
        id: "bitrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0 })=>hasLiveTrack && track && ssrc0,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + ssrc.bitrate, 0)
    },
    {
        id: "pixelrate",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + (ssrc.fps || 0) * (ssrc.width || 0) * (ssrc.height || 0), 0)
    },
    {
        id: "height",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((max, ssrc)=>Math.max(max, ssrc.fps > 0 ? ssrc.height : 0), 0)
    },
    {
        id: "sourceHeight",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.sourceHeight && ssrc0.direction === "out",
        value: ({ ssrc0: ssrc0 })=>ssrc0.sourceHeight
    },
    {
        id: "packetloss",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate,
        value: ({ ssrc0: ssrc0 })=>(ssrc0.direction === "in" ? ssrc0.lossRatio : ssrc0.fractionLost) || 0
    },
    {
        id: "jitter",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in",
        value: ({ ssrc0: ssrc0 })=>ssrc0.jitter
    },
    {
        id: "mos",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0 })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "out",
        value: ({ ssrc0: ssrc0 })=>{
            const averageLatency = ssrc0.roundTripTime || 0;
            const jitter = ssrc0.jitter || 0;
            const packetLoss = (ssrc0.fractionLost || 0) * 100;
            const effectiveLatency = averageLatency + jitter * 2 + 10;
            let r = effectiveLatency < 160 ? 93.2 - effectiveLatency / 40 : 93.2 - (effectiveLatency - 120) / 10;
            r = r - packetLoss * 2.5;
            const mos = 1 + 0.035 * r + 0.000007 * r * (r - 60) * (100 - r);
            return mos;
        }
    },
    {
        id: "rendered",
        value: ()=>1
    },
    {
        id: "active",
        value: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0 })=>hasLiveTrack && track && ssrc0 ? 1 : 0
    },
    {
        id: "cpu-pressure",
        global: true,
        enabled: ({ stats: stats })=>{
            var _a;
            return ((_a = stats === null || stats === void 0 ? void 0 : stats.pressure) === null || _a === void 0 ? void 0 : _a.source) === "cpu";
        },
        value: ({ stats: stats })=>({
                nominal: 0.25,
                fair: 0.5,
                serious: 0.75,
                critical: 1
            })[stats.pressure.state] || 0
    },
    {
        id: "turn-usage",
        global: true,
        enabled: ({ stats: stats })=>!!Object.values(stats.candidatePairs).length,
        value: ({ stats: stats })=>Object.values(stats.candidatePairs).some((cp)=>cp.usingTurn)
    },
    {
        id: "turn-tls-usage",
        global: true,
        enabled: ({ stats: stats })=>!!Object.values(stats.candidatePairs).length,
        value: ({ stats: stats })=>Object.values(stats.candidatePairs).some((cp)=>cp.turnProtocol === "tls")
    },
    {
        id: "concealment",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioConcealment
    },
    {
        id: "deceleration",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioDeceleration
    },
    {
        id: "acceleration",
        enabled: ({ hasLiveTrack: hasLiveTrack, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && ssrc0 && ssrc0.bitrate && ssrc0.direction === "in" && kind === "audio" && ssrc0.audioLevel >= 0.001,
        value: ({ ssrc0: ssrc0 })=>ssrc0.audioAcceleration
    },
    {
        id: "qpf",
        enabled: ({ hasLiveTrack: hasLiveTrack, track: track, ssrc0: ssrc0, kind: kind })=>hasLiveTrack && kind === "video" && track && ssrc0 && ssrc0.height,
        value: ({ trackStats: trackStats })=>Object.values(trackStats.ssrcs).reduce((sum, ssrc)=>sum + (ssrc.qpf || 0), 0)
    }
];
let $1622be301bae0161$var$aggregatedMetrics;
let $1622be301bae0161$var$aggregatedIssues;
let $1622be301bae0161$var$issuesAndMetricsByView;
const $1622be301bae0161$var$initIssuesAndMetricsByView = ()=>{
    $1622be301bae0161$var$aggregatedMetrics = {};
    $1622be301bae0161$var$aggregatedIssues = {};
    $1622be301bae0161$var$issuesAndMetricsByView = {
        aggregated: {
            issues: $1622be301bae0161$var$aggregatedIssues,
            metrics: $1622be301bae0161$var$aggregatedMetrics
        }
    };
};
$1622be301bae0161$var$initIssuesAndMetricsByView();
const $1622be301bae0161$export$429e50c97404ad34 = ()=>{
    return Object.assign({}, $1622be301bae0161$var$issuesAndMetricsByView);
};
function $1622be301bae0161$var$onUpdatedStats(statsByView, clients) {
    Object.values($1622be301bae0161$var$aggregatedMetrics).forEach((metricData)=>{
        metricData.curTicks = 0;
        metricData.curSum = 0;
        metricData.curMax = 0;
        metricData.curMin = 0;
        metricData.curAvg = 0;
    });
    Object.values($1622be301bae0161$var$aggregatedIssues).forEach((issueData)=>{
        issueData.curTicks = 0;
        issueData.curRegistered = 0;
        issueData.active = false;
    });
    if (!clients.find((client)=>!client.isLocalClient)) return;
    clients.forEach((client)=>{
        const stats = statsByView[client.id];
        [
            "video",
            "audio",
            "global"
        ].forEach((kind)=>{
            var _a, _b;
            if (!(kind === "global" && !client.isPresentation) && !((_a = client[kind]) === null || _a === void 0 ? void 0 : _a.enabled)) return;
            if (kind === "global" && !client.isLocalClient) return;
            let issuesAndMetrics = $1622be301bae0161$var$issuesAndMetricsByView[client.id];
            if (!issuesAndMetrics) {
                issuesAndMetrics = {
                    issues: {},
                    metrics: {}
                };
                $1622be301bae0161$var$issuesAndMetricsByView[client.id] = issuesAndMetrics;
            }
            const track = (_b = client[kind]) === null || _b === void 0 ? void 0 : _b.track;
            const hasLiveTrack = !!track && track.readyState !== "ended";
            const trackStats = track && stats && stats.tracks[track.id];
            const ssrcs = trackStats ? Object.values(trackStats.ssrcs).sort((a, b)=>(a.height || Number.MAX_SAFE_INTEGER) - (b.height || Number.MAX_SAFE_INTEGER)) : [];
            const ssrc0 = ssrcs[0];
            const checkData = {
                client: client,
                clients: clients,
                kind: kind,
                track: track,
                trackStats: trackStats,
                stats: stats,
                hasLiveTrack: hasLiveTrack,
                ssrc0: ssrc0,
                ssrcs: ssrcs,
                issues: issuesAndMetrics.issues,
                metrics: issuesAndMetrics.metrics
            };
            const qualifierString = kind === "global" ? "global" : `${client.isLocalClient ? "loc" : "rem"}-${client.isPresentation ? "pres" : "cam"}-${kind}`;
            $1622be301bae0161$var$metrics.forEach((metric)=>{
                if (metric.global && kind !== "global") return;
                if (!metric.global && kind === "global") return;
                const enabled = metric.enabled ? metric.enabled(checkData) : true;
                if (enabled) {
                    const metricKey = `${qualifierString}-${metric.id}`;
                    let metricData = issuesAndMetrics.metrics[metricKey];
                    const value = metric.value(checkData);
                    if (!metricData) {
                        metricData = {
                            ticks: 0,
                            sum: 0,
                            avg: 0,
                            min: value,
                            max: value
                        };
                        issuesAndMetrics.metrics[metricKey] = metricData;
                    }
                    metricData.ticks++;
                    metricData.sum += value;
                    metricData.min = Math.min(metricData.min, value);
                    metricData.max = Math.max(metricData.max, value);
                    metricData.avg = metricData.sum / metricData.ticks;
                    let aggregatedMetricData = $1622be301bae0161$var$aggregatedMetrics[metricKey];
                    if (!aggregatedMetricData) {
                        aggregatedMetricData = {
                            ticks: 0,
                            sum: 0,
                            min: value,
                            max: value,
                            avg: 0,
                            curTicks: 0,
                            curMin: 0,
                            curMax: 0,
                            curAvg: 0,
                            curSum: 0,
                            totTicks: 0,
                            totMin: 0,
                            totMax: 0,
                            totAvg: 0,
                            totSum: 0
                        };
                        $1622be301bae0161$var$aggregatedMetrics[metricKey] = aggregatedMetricData;
                    }
                    aggregatedMetricData.ticks++;
                    aggregatedMetricData.sum += value;
                    aggregatedMetricData.min = Math.min(aggregatedMetricData.min, value);
                    aggregatedMetricData.max = Math.max(aggregatedMetricData.max, value);
                    aggregatedMetricData.avg = aggregatedMetricData.sum / aggregatedMetricData.ticks;
                    if (aggregatedMetricData.curTicks === 0) {
                        aggregatedMetricData.curMax = value;
                        aggregatedMetricData.curMin = value;
                        aggregatedMetricData.curSum = value;
                    } else {
                        aggregatedMetricData.curMax = Math.max(aggregatedMetricData.curMax, value);
                        aggregatedMetricData.curMin = Math.min(aggregatedMetricData.curMin, value);
                        aggregatedMetricData.curSum += value;
                    }
                    aggregatedMetricData.curTicks++;
                }
            });
            $1622be301bae0161$var$issueDetectors.forEach((issueDetector)=>{
                if (issueDetector.global && kind !== "global") return;
                if (!issueDetector.global && kind === "global") return;
                const issueKey = `${qualifierString}-${issueDetector.id}`;
                const enabled = issueDetector.enabled(checkData);
                let issueData = issuesAndMetrics.issues[issueKey];
                let aggregatedIssueData = $1622be301bae0161$var$aggregatedIssues[issueKey];
                if (enabled) {
                    if (!issueData) {
                        issueData = {
                            active: false,
                            ticks: 0,
                            registered: 0,
                            initial: 0,
                            periods: 0,
                            current: 0,
                            longest: 0
                        };
                        issuesAndMetrics.issues[issueKey] = issueData;
                    }
                    issueData.ticks++;
                    if (!aggregatedIssueData) {
                        aggregatedIssueData = {
                            active: false,
                            ticks: 0,
                            registered: 0,
                            initial: 0,
                            curTicks: 0,
                            curRegistered: 0
                        };
                        $1622be301bae0161$var$aggregatedIssues[issueKey] = aggregatedIssueData;
                    }
                    aggregatedIssueData.ticks++;
                    aggregatedIssueData.curTicks++;
                    const issueDetected = issueDetector.check(checkData);
                    if (issueDetected) {
                        issueData.registered++;
                        issueData.current++;
                        if (!issueData.active) {
                            issueData.active = true;
                            issueData.periods++;
                        }
                        if (issueData.ticks === issueData.initial + 1) {
                            issueData.initial++;
                            aggregatedIssueData.initial++;
                        }
                        if (issueData.current > issueData.longest) issueData.longest = issueData.current;
                        aggregatedIssueData.active = true;
                        aggregatedIssueData.registered++;
                        aggregatedIssueData.curRegistered++;
                    } else {
                        issueData.active = false;
                        issueData.current = 0;
                    }
                } else if (issueData) {
                    issueData.active = false;
                    issueData.current = 0;
                }
            });
        });
    });
    Object.values($1622be301bae0161$var$aggregatedMetrics).forEach((aggregatedMetricData)=>{
        if (aggregatedMetricData.curTicks) {
            aggregatedMetricData.curAvg = aggregatedMetricData.curSum / aggregatedMetricData.curTicks;
            if (aggregatedMetricData.totTicks === 0) {
                aggregatedMetricData.totMin = aggregatedMetricData.curSum;
                aggregatedMetricData.totMax = aggregatedMetricData.curSum;
            }
            aggregatedMetricData.totTicks++;
            aggregatedMetricData.totSum += aggregatedMetricData.curSum;
            aggregatedMetricData.totMin = Math.min(aggregatedMetricData.totMin, aggregatedMetricData.curSum);
            aggregatedMetricData.totMax = Math.max(aggregatedMetricData.totMax, aggregatedMetricData.curSum);
            aggregatedMetricData.totAvg = aggregatedMetricData.totSum / aggregatedMetricData.totTicks;
        }
    });
    Object.values($1622be301bae0161$var$aggregatedIssues).forEach((aggregateIssueData)=>{
        aggregateIssueData.curTicks;
    });
    $1622be301bae0161$var$subscriptions.forEach((subscription)=>{
        var _a;
        return (_a = subscription.onUpdatedIssues) === null || _a === void 0 ? void 0 : _a.call(subscription, $1622be301bae0161$var$issuesAndMetricsByView, statsByView, clients);
    });
}
function $1622be301bae0161$export$d2b2fe7aff003090(subscription) {
    $1622be301bae0161$var$subscriptions.push(subscription);
    if (!$1622be301bae0161$var$stopStats) $1622be301bae0161$var$stopStats = $1622be301bae0161$export$446568135c9b26ef({
        onUpdatedStats: $1622be301bae0161$var$onUpdatedStats
    }).stop;
    return {
        stop () {
            $1622be301bae0161$var$subscriptions = $1622be301bae0161$var$subscriptions.filter((s)=>s !== subscription);
            if (!$1622be301bae0161$var$subscriptions.length) {
                $1622be301bae0161$var$stopStats === null || $1622be301bae0161$var$stopStats === void 0 || $1622be301bae0161$var$stopStats();
                $1622be301bae0161$var$stopStats = null;
                $1622be301bae0161$var$initIssuesAndMetricsByView();
            }
        }
    };
}
const $1622be301bae0161$var$WINDOW_SIZE = 10;
const $1622be301bae0161$var$SET_TIMEOUT_INTERVAL = 500;
const $1622be301bae0161$var$RIC_TIMEOUT = 500;
const $1622be301bae0161$var$REPORTING_INTERVAL = 1000;
const $1622be301bae0161$var$buckets = [
    {
        name: "all",
        test: ({ avc: avc })=>avc >= 1
    },
    {
        name: "1",
        test: ({ avc: avc })=>avc === 1
    },
    {
        name: "2to4",
        test: ({ avc: avc })=>avc >= 2 && avc <= 4
    },
    {
        name: "5plus",
        test: ({ avc: avc })=>avc >= 5
    }
];
function $1622be301bae0161$export$a1839315f66842d4({ onMetricsUpdated: onMetricsUpdated, onTerminated: onTerminated, isHidden: isHidden }) {
    const decodedFpsSamplesByTrack = {};
    let currentMetrics = {};
    const aggregatedMetrics = {};
    let wasHidden = false;
    const reportingInterval = setInterval(()=>{
        if (wasHidden) {
            wasHidden = isHidden();
            return;
        }
        $1622be301bae0161$var$buckets.filter((bucket)=>bucket.test(currentMetrics)).forEach((bucket)=>{
            const bucketData = aggregatedMetrics[bucket.name] = aggregatedMetrics[bucket.name] || {};
            Object.entries(currentMetrics).forEach(([metric, value])=>{
                if (!bucketData[metric]) bucketData[metric] = {
                    min: value,
                    max: value,
                    avg: value,
                    sum: value,
                    cur: value,
                    count: 1
                };
                else {
                    const old = bucketData[metric];
                    bucketData[metric] = {
                        min: Math.min(old.min, value),
                        max: Math.max(old.max, value),
                        avg: (old.sum + value) / (old.count + 1),
                        sum: old.sum + value,
                        cur: value,
                        count: old.count + 1
                    };
                }
            });
        });
        onMetricsUpdated === null || onMetricsUpdated === void 0 || onMetricsUpdated(aggregatedMetrics);
    }, $1622be301bae0161$var$REPORTING_INTERVAL);
    let stHandle = 0;
    let ricHandle = 0;
    const measureScheduling = ()=>{
        const before = performance.now();
        stHandle = setTimeout(()=>{
            const delayed = Math.max(0, performance.now() - (before + $1622be301bae0161$var$SET_TIMEOUT_INTERVAL));
            currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                stLag: delayed
            });
            if (window.requestIdleCallback) {
                const beforeRic = performance.now();
                ricHandle = requestIdleCallback((idleDeadline)=>{
                    if (idleDeadline.didTimeout) currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                        ricLag: $1622be301bae0161$var$RIC_TIMEOUT
                    });
                    else currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                        ricLag: performance.now() - beforeRic
                    });
                }, {
                    timeout: $1622be301bae0161$var$RIC_TIMEOUT
                });
            }
            measureScheduling();
        }, $1622be301bae0161$var$SET_TIMEOUT_INTERVAL);
    };
    measureScheduling();
    return {
        registerDecodedFps: (fpsData)=>{
            if (wasHidden) return;
            const volatilityScores = fpsData.map(({ trackId: trackId, fps: fps })=>{
                const samples = decodedFpsSamplesByTrack[trackId] = decodedFpsSamplesByTrack[trackId] || [];
                samples.push(fps) > $1622be301bae0161$var$WINDOW_SIZE && samples.shift();
                const mean = samples.reduce((acc, val)=>acc + val, 0) / samples.length;
                const volatility = samples.reduce((acc, val)=>acc + Math.abs(val - mean), 0) / (samples.length * mean);
                return volatility;
            });
            if (volatilityScores.length) {
                const maxVolatility = Math.max(...volatilityScores);
                currentMetrics = Object.assign(Object.assign({}, currentMetrics), {
                    rrVol: maxVolatility,
                    avc: volatilityScores.length
                });
            }
        },
        terminate: ()=>{
            clearInterval(reportingInterval);
            clearTimeout(stHandle);
            if (ricHandle) cancelIdleCallback(ricHandle);
            onTerminated === null || onTerminated === void 0 || onTerminated();
        },
        updateHidden: ()=>{
            if (isHidden()) wasHidden = true;
        }
    };
}
class $1622be301bae0161$export$caeffa2537001230 {
    static parse(raw) {
        let object;
        try {
            object = JSON.parse(raw);
        } catch (error) {
            return;
        }
        if (typeof object !== "object" || Array.isArray(object)) return;
        if (object.request) return $1622be301bae0161$export$caeffa2537001230._handleRequest(object);
        else if (object.response) return $1622be301bae0161$export$caeffa2537001230._handleResponse(object);
        else if (object.message) return $1622be301bae0161$export$caeffa2537001230._handleMessage(object);
        else return;
    }
    static _handleRequest(rawMessage) {
        const message = {};
        message.request = true;
        if (typeof rawMessage.method !== "string") return;
        if (typeof rawMessage.id !== "number") return;
        message.id = rawMessage.id;
        message.method = rawMessage.method;
        message.data = rawMessage.data || {};
        return message;
    }
    static _handleResponse(rawMessage) {
        const message = {};
        message.response = true;
        if (typeof rawMessage.id !== "number") return;
        message.id = rawMessage.id;
        if (rawMessage.ok) {
            message.ok = true;
            message.data = rawMessage.data || {};
        } else {
            message.ok = false;
            message.errorCode = rawMessage.errorCode;
            message.errorReason = rawMessage.errorReason;
        }
        return message;
    }
    static _handleMessage(rawMessage) {
        const message = {};
        message.message = true;
        if (typeof rawMessage.method !== "string") return;
        message.method = rawMessage.method;
        message.data = rawMessage.data || {};
        return message;
    }
    static createRequest(method, data) {
        return {
            request: true,
            id: Math.round(Math.random() * 10000000),
            method: method,
            data: data || {}
        };
    }
    static createSuccessResponse(request, data) {
        return {
            response: true,
            id: request.id,
            ok: true,
            data: data || {}
        };
    }
    static createErrorResponse(request, errorCode, errorReason) {
        return {
            response: true,
            id: request.id,
            errorCode: errorCode,
            errorReason: errorReason
        };
    }
    static createMessage(method, data) {
        return {
            message: true,
            method: method,
            data: data || {}
        };
    }
}
const $1622be301bae0161$var$logger$9 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$b281e2872ffa0a70 extends (0, $0bfd6a77e39eae31$exports.EventEmitter) {
    _setupSocket() {
        this.socket = new WebSocket(this.wsUrl, this.protocol);
        this.socket.onopen = this._onOpen.bind(this);
        this.socket.onmessage = this._onMessage.bind(this);
        this.socket.onclose = this._onClose.bind(this);
        this.socket.onerror = this._onError.bind(this);
    }
    _tearDown() {
        if (this.socket === null) return;
        this.socket.onopen = null;
        this.socket.onmessage = null;
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket = null;
        this.sents.forEach((sent)=>sent.close());
        this.emit("close");
    }
    close() {
        var _a;
        (_a = this.socket) === null || _a === void 0 || _a.close();
    }
    _onOpen() {
        $1622be301bae0161$var$logger$9.info("Connected");
        this.emit("open");
    }
    _onMessage(event) {
        const socketMessage = $1622be301bae0161$export$caeffa2537001230.parse(event.data);
        $1622be301bae0161$var$logger$9.info("Received message", socketMessage);
        if (socketMessage === null || socketMessage === void 0 ? void 0 : socketMessage.response) this._handleResponse(socketMessage);
        else if (socketMessage === null || socketMessage === void 0 ? void 0 : socketMessage.message) this.emit("message", socketMessage);
    }
    _onClose() {
        $1622be301bae0161$var$logger$9.info("Disconnected");
        this._tearDown();
    }
    _onError(error) {
        $1622be301bae0161$var$logger$9.info("Error", error);
    }
    _handleResponse(socketMessage) {
        const sent = this.sents.get(socketMessage.id);
        if (socketMessage.ok) sent.resolve(socketMessage.data);
        else {
            const error = new Error(socketMessage.errorReason);
            sent.reject(error);
        }
    }
    send(message) {
        try {
            if (this.socket) this.socket.send(JSON.stringify(message));
        } catch (error) {}
    }
    message(method, data = {}) {
        const message = $1622be301bae0161$export$caeffa2537001230.createMessage(method, data);
        this.send(message);
    }
    request(method, data = {}, timeout = 1500 * (15 + 0.1 * this.sents.size)) {
        const request = $1622be301bae0161$export$caeffa2537001230.createRequest(method, data);
        this.send(request);
        return new Promise((pResolve, pReject)=>{
            const sent = {
                id: request.id,
                method: request.method,
                resolve: (data2)=>{
                    if (!this.sents.delete(request.id)) return;
                    clearTimeout(sent.timer);
                    pResolve(data2);
                },
                reject: (error)=>{
                    if (!this.sents.delete(request.id)) return;
                    clearTimeout(sent.timer);
                    pReject(error);
                },
                timer: setTimeout(()=>{
                    if (!this.sents.delete(request.id)) return;
                    pReject(new Error("request timeout"));
                }, timeout),
                close: ()=>{
                    clearTimeout(sent.timer);
                    pReject(new Error("transport closed"));
                }
            };
            this.sents.set(request.id, sent);
        });
    }
    constructor(wsUrl, protocol = "whereby-sfu#v4"){
        super();
        this.socket = null;
        this.wsUrl = wsUrl;
        this.protocol = protocol;
        this.sents = new Map();
        this._setupSocket();
    }
}
const $1622be301bae0161$var$AUDIO_SETTINGS = {
    codecOptions: {
        opusDtx: true,
        opusFec: true
    },
    encodings: [
        {
            dtx: true
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_HD = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scaleResolutionDownBy: 4,
            maxBitrate: 150000
        },
        {
            scaleResolutionDownBy: 2,
            maxBitrate: 500000
        },
        {
            scaleResolutionDownBy: 1,
            maxBitrate: 1000000
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_SD = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scaleResolutionDownBy: 2,
            maxBitrate: 150000
        },
        {
            scaleResolutionDownBy: 1,
            maxBitrate: 500000
        }
    ]
};
const $1622be301bae0161$var$VIDEO_SETTINGS_VP9 = {
    codecOptions: {
        videoGoogleStartBitrate: 500
    },
    encodings: [
        {
            scalabilityMode: "L3T2_KEY"
        }
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SETTINGS = {
    encodings: [
        {}
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SIMULCAST_SETTINGS = {
    encodings: [
        {
            scaleResolutionDownBy: 2,
            dtx: true,
            maxBitrate: 500000
        },
        {
            scaleResolutionDownBy: 1,
            dtx: true,
            maxBitrate: 1500000
        }
    ]
};
const $1622be301bae0161$var$SCREEN_SHARE_SETTINGS_VP9 = {
    encodings: [
        {
            dtx: true
        }
    ]
};
const $1622be301bae0161$export$71f7c171c9088ed4 = (kind, isScreenShare, features)=>{
    const { lowDataModeEnabled: lowDataModeEnabled, simulcastScreenshareOn: simulcastScreenshareOn, vp9On: vp9On } = features;
    if (kind === "audio") return $1622be301bae0161$var$AUDIO_SETTINGS;
    if (isScreenShare) {
        if (vp9On) return $1622be301bae0161$var$SCREEN_SHARE_SETTINGS_VP9;
        if (simulcastScreenshareOn) return $1622be301bae0161$var$SCREEN_SHARE_SIMULCAST_SETTINGS;
        return $1622be301bae0161$var$SCREEN_SHARE_SETTINGS;
    } else {
        if (vp9On) return $1622be301bae0161$var$VIDEO_SETTINGS_VP9;
        if (lowDataModeEnabled) return $1622be301bae0161$var$VIDEO_SETTINGS_SD;
        return $1622be301bae0161$var$VIDEO_SETTINGS_HD;
    }
};
const $1622be301bae0161$export$1cbfd4deae6f916f = (routerRtpCapabilities, features)=>{
    const { vp9On: vp9On, h264On: h264On } = features;
    if (vp9On) {
        const { preferredPayloadType: preferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/vp9");
        const { preferredPayloadType: aptPreferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/rtx" && codec.parameters.apt === preferredPayloadType);
        routerRtpCapabilities.codecs = routerRtpCapabilities.codecs.filter((codec)=>codec.kind === "audio" || codec.preferredPayloadType === preferredPayloadType || codec.preferredPayloadType === aptPreferredPayloadType);
    } else if (h264On) {
        const { preferredPayloadType: preferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/h264");
        const { preferredPayloadType: aptPreferredPayloadType } = routerRtpCapabilities.codecs.find((codec)=>codec.mimeType.toLowerCase() === "video/rtx" && codec.parameters.apt === preferredPayloadType);
        routerRtpCapabilities.codecs = routerRtpCapabilities.codecs.filter((codec)=>codec.kind === "audio" || codec.preferredPayloadType === preferredPayloadType || codec.preferredPayloadType === aptPreferredPayloadType);
    }
};
const $1622be301bae0161$export$30afcaff46935060 = ()=>{
    let handlerName = (0, $92a5db02d3c83225$exports.detectDevice)() || (/applecoremedia|applewebkit|safari/i.test(navigator.userAgent) ? "Safari12" : undefined);
    if (/iphone|ipad/i.test(navigator.userAgent)) handlerName = "Safari12";
    return handlerName;
};
const $1622be301bae0161$var$logger$8 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$fc97fdee86457200 extends (0, (/*@__PURE__*/$parcel$interopDefault($0bfd6a77e39eae31$exports))) {
    start(runTime = 15) {
        if (this.closed) return;
        if (runTime < 10) {
            this.emit("result", {
                error: true,
                details: {
                    timeout: true
                }
            });
            return this.close();
        }
        this._runTime = runTime;
        this._startTime = Date.now();
        const host = this._features.sfuServerOverrideHost || "any.sfu.whereby.com";
        const wsUrl = `wss://${host}`;
        this._vegaConnection = new $1622be301bae0161$export$b281e2872ffa0a70(wsUrl, "whereby-sfu#bw-test-v1");
        this._vegaConnection.on("open", ()=>this._start());
        this._vegaConnection.on("close", ()=>this.close());
        this._vegaConnection.on("message", (message)=>this._onMessage(message));
        this._startTimeout();
    }
    close() {
        $1622be301bae0161$var$logger$8.info("close()");
        this.closed = true;
        this._clearTimeouts();
        clearInterval(this._drawInterval);
        this._drawInterval = null;
        if (this._sendTransport) {
            this._sendTransport.removeAllListeners();
            this._sendTransport.close();
        }
        this._sendTransport = null;
        if (this._receiveTransport) {
            this._receiveTransport.removeAllListeners();
            this._receiveTransport.close();
        }
        this._receiveTransport = null;
        this._mediasoupDevice = null;
        if (this._vegaConnection) {
            this._vegaConnection.removeAllListeners();
            this._vegaConnection.close();
        }
        this._vegaConnection = null;
        this.emit("close");
    }
    _start() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$8.info("_start()");
            this._connectTime = Date.now() - this._startTime;
            if (this._connectTime > 5000) {
                this.emit("result", {
                    error: true,
                    details: {
                        timeout: true
                    }
                });
                return this.close();
            }
            this._clearTimeouts();
            try {
                const { routerRtpCapabilities: routerRtpCapabilities } = yield this._vegaConnection.request("getCapabilities");
                if (!this._routerRtpCapabilities) {
                    $1622be301bae0161$export$1cbfd4deae6f916f(routerRtpCapabilities, this._features);
                    this._routerRtpCapabilities = routerRtpCapabilities;
                    yield this._mediasoupDevice.load({
                        routerRtpCapabilities: routerRtpCapabilities
                    });
                }
                this._vegaConnection.message("setCapabilities", {
                    rtpCapabilities: this._mediasoupDevice.rtpCapabilities
                });
                yield Promise.all([
                    this._createTransport(true),
                    this._createTransport(false)
                ]);
                yield this._createProducer();
                this._mediaEstablishedTime = Date.now() - this._startTime;
                if (this._mediaEstablishedTime > 5000) {
                    this.emit("result", {
                        error: true,
                        details: {
                            timeout: true
                        }
                    });
                    return this.close();
                }
                this._resultTimeout = setTimeout(()=>{
                    this._reportResults();
                }, this._runTime * 1000 - this._mediaEstablishedTime);
            } catch (error) {
                $1622be301bae0161$var$logger$8.error("_start() [error:%o]", error);
                this.emit("result", {
                    error: true,
                    details: {
                        timeout: true
                    }
                });
                this.close();
            }
        });
    }
    _createTransport(send) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const creator = send ? "createSendTransport" : "createRecvTransport";
            const transportOptions = yield this._vegaConnection.request("createTransport", {
                producing: send,
                consuming: !send,
                enableTcp: true,
                enableUdp: true,
                preferUdp: true
            });
            transportOptions.iceServers = [
                {
                    urls: "stun:any.turn.whereby.com"
                }
            ];
            const transport = this._mediasoupDevice[creator](transportOptions);
            transport.on("connect", ({ dtlsParameters: dtlsParameters }, callback)=>{
                this._vegaConnection.message("connectTransport", {
                    transportId: transport.id,
                    dtlsParameters: dtlsParameters
                });
                callback();
            });
            if (send) {
                transport.on("produce", ({ kind: kind, rtpParameters: rtpParameters, appData: appData }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        try {
                            const { paused: paused } = appData;
                            const { id: id } = yield this._vegaConnection.request("produce", {
                                transportId: transport.id,
                                kind: kind,
                                rtpParameters: rtpParameters,
                                paused: paused,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                this._sendTransport = transport;
            } else this._receiveTransport = transport;
        });
    }
    _getTestTrack() {
        this._canvas = document.createElement("canvas");
        this._canvas.width = 1280;
        this._canvas.height = 720;
        document.body.appendChild(this._canvas);
        this._canvas.style.position = "absolute";
        this._canvas.style.right = "0";
        this._canvas.style.bottom = "0";
        this._canvas.style.width = "1px";
        this._canvas.style.height = "1px";
        this._canvas.style.opacity = "0";
        const context = this._canvas.getContext("2d");
        const ball = {
            x: 150,
            y: 150
        };
        const velocity = 50;
        const startingAngle = 70;
        const rad = 100;
        let moveX = Math.cos(Math.PI / 180 * startingAngle) * velocity;
        let moveY = Math.sin(Math.PI / 180 * startingAngle) * velocity;
        const draw = ()=>{
            if (this.closed) return;
            const now = Date.now();
            context.fillStyle = `rgb(
                ${Math.floor(255 - 0.35 * ball.y)},
                ${Math.floor(255 - 0.18 * ball.x)},
                0)`;
            context.fillRect(0, 0, this._canvas.width, this._canvas.height);
            context.fillStyle = "white";
            context.font = "30px Arial";
            context.fillText("Whereby", 10, 50);
            context.font = "20px Arial";
            context.fillText("Test", 10, 80);
            context.font = "20px Arial";
            context.fillText(`Time: ${now - this._startTime}ms`, 10, 110);
            context.font = "20px Arial";
            if (this._connectTime) context.fillText(`Connect: ${this._connectTime}ms`, 10, 140);
            if (this._mediaEstablishedTime) context.fillText(`Media: ${this._mediaEstablishedTime}ms`, 10, 170);
            if (ball.x > this._canvas.width - rad || ball.x < rad) moveX = -moveX;
            if (ball.y > this._canvas.height - rad || ball.y < rad) moveY = -moveY;
            ball.x += moveX;
            ball.y += moveY;
            context.beginPath();
            context.fillStyle = `rgb(
                ${Math.floor(255 - 0.18 * ball.x)},
                ${Math.floor(255 - 0.35 * ball.y)},
                0)`;
            context.arc(ball.x, ball.y, rad, 0, Math.PI * 2);
            context.fill();
            context.closePath();
        };
        this._drawInterval = setInterval(draw, 33);
        const fakeStream = this._canvas.captureStream(30);
        const [fakeVideoTrack] = fakeStream.getVideoTracks();
        return fakeVideoTrack;
    }
    _createProducer() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const track = this._getTestTrack();
            const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                track: track
            }, $1622be301bae0161$export$71f7c171c9088ed4("video", false, this._features)), {
                appData: {
                    paused: false
                }
            }));
            this._producer = producer;
            producer.observer.once("close", ()=>{
                $1622be301bae0161$var$logger$8.info('producer "close" event');
                this._producer = null;
            });
        });
    }
    _onMessage(message) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { method: method, data: data } = message;
            return Promise.resolve().then(()=>{
                switch(method){
                    case "consumerReady":
                        return this._onConsumerReady(data);
                    case "consumerClosed":
                        return this._onConsumerClosed(data);
                    default:
                        $1622be301bae0161$var$logger$8.info(`unknown message method "${method}"`);
                        return;
                }
            }).catch((error)=>{
                $1622be301bae0161$var$logger$8.error('"message" failed [error:%o]', error);
            });
        });
    }
    _onConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const consumer = yield this._receiveTransport.consume(options);
            consumer.once("close", ()=>{
                this._consumers.delete(consumer.id);
            });
            this._consumers.set(consumer.id, consumer);
            this._vegaConnection.message("resumeConsumers", {
                consumerIds: [
                    consumer.id
                ]
            });
        });
    }
    _onConsumerClosed({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$8.info("_onConsumerClosed()");
        const consumer = this._consumers.get(consumerId);
        if (consumer) consumer.close();
    }
    _reportResults() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const [localSendStats, localRecvStats] = yield Promise.all([
                this._sendTransport.getStats(),
                this._receiveTransport.getStats()
            ]);
            const { recvStats: [remoteRecvStats = null] = [] } = yield this._vegaConnection.request("getTransportStats");
            const { availableOutgoingBitrate: availableOutgoingBitrate = 5000000 } = remoteRecvStats || {};
            let outboundPackets = 0;
            let remotePacketsLost = 0;
            localSendStats.forEach((localSendStat)=>{
                if (localSendStat.type === "outbound-rtp" && typeof localSendStat.packetsSent === "number") outboundPackets += localSendStat.packetsSent;
                else if (localSendStat.type === "remote-inbound-rtp" && typeof localSendStat.packetsLost === "number") remotePacketsLost += localSendStat.packetsLost;
            });
            let inboundPackets = 0;
            let packetsLost = 0;
            localRecvStats.forEach((localRecvStat)=>{
                if (localRecvStat.type === "inbound-rtp" && typeof localRecvStat.packetsReceived === "number" && typeof localRecvStat.packetsLost === "number") {
                    inboundPackets += localRecvStat.packetsReceived;
                    packetsLost += localRecvStat.packetsLost;
                }
            });
            const recvAvailableBitrate = availableOutgoingBitrate / 1000000.0;
            const lowRecvAvailableBitrate = recvAvailableBitrate < 1.5;
            const sendLoss = remotePacketsLost / outboundPackets;
            const recvLoss = packetsLost / inboundPackets;
            const highSendLoss = sendLoss > 0.03;
            const highRecvLoss = recvLoss > 0.03;
            const testTime = Date.now() - this._startTime;
            const warning = lowRecvAvailableBitrate || highRecvLoss || highSendLoss;
            const success = !warning;
            this.emit("result", {
                warning: warning,
                success: success,
                details: {
                    testTime: testTime,
                    recvAvailableBitrate: recvAvailableBitrate,
                    lowRecvAvailableBitrate: lowRecvAvailableBitrate,
                    highSendLoss: highSendLoss,
                    highRecvLoss: highRecvLoss,
                    sendLoss: sendLoss,
                    recvLoss: recvLoss
                }
            });
            this.close();
        });
    }
    _startTimeout(seconds = 5) {
        this._timeout = setTimeout(()=>{
            this.emit("result", {
                error: true,
                details: {
                    timeout: true
                }
            });
            this.close();
        }, seconds * 1000);
    }
    _clearTimeouts() {
        clearTimeout(this._timeout);
        this._timeout = null;
        clearTimeout(this._reportTimeout);
        this._reportTimeout = null;
    }
    constructor({ features: features } = {}){
        super();
        this.closed = false;
        this._features = features || {};
        this._vegaConnection = null;
        this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerName: $1622be301bae0161$export$30afcaff46935060()
        });
        this._routerRtpCapabilities = null;
        this._sendTransport = null;
        this._receiveTransport = null;
        this._producer = null;
        this._consumers = new Map();
        this._startTime = null;
        this._connectTime = null;
        this._mediaEstablishedTime = null;
        this._runTime = null;
        this._endTime = null;
        this._timeout = null;
        this._canvas = null;
        this._drawInterval = null;
        this._resultTimeout = null;
    }
}
var $1622be301bae0161$var$_a$7;
const $1622be301bae0161$var$adapter$6 = ($1622be301bae0161$var$_a$7 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$7 !== void 0 ? $1622be301bae0161$var$_a$7 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
function $1622be301bae0161$export$60abf66a104f71b0(pc) {
    if ($1622be301bae0161$var$adapter$6.browserDetails.browser !== "chrome" || $1622be301bae0161$var$adapter$6.browserDetails.browser < 58 || pc.signalingState === "closed") return Promise.resolve(false);
    const sendingAudio = pc.getSenders().some((sender)=>sender.track && sender.track.kind === "audio");
    const receivingAudio = pc.getReceivers().some((receiver)=>receiver.track && receiver.track.kind === "audio");
    return pc.getStats(null).then((result)=>{
        let microphoneFailed = false;
        result.forEach((report)=>{
            if (report.type === "outbound-rtp" && (report.kind === "audio" || report.mediaType === "audio") && sendingAudio) {
                if (report.bytesSent === 0) microphoneFailed = "outbound";
            } else if (report.type === "inbound-rtp" && (report.kind === "audio" || report.mediaType === "audio") && receivingAudio) {
                if (report.bytesReceived === 0) microphoneFailed = "inbound";
            }
        });
        return microphoneFailed;
    });
}
const $1622be301bae0161$export$737bc7bda2eb5bf5 = 1280;
const $1622be301bae0161$export$6bb71afef3ab9ece = -1;
const $1622be301bae0161$export$87d0694e432db510 = 400;
var $1622be301bae0161$var$_a$6;
const $1622be301bae0161$var$adapter$5 = ($1622be301bae0161$var$_a$6 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$6 !== void 0 ? $1622be301bae0161$var$_a$6 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$isSafari = $1622be301bae0161$var$adapter$5.browserDetails.browser === "safari";
const $1622be301bae0161$var$parseResolution = (res)=>res.split(/[^\d]/g).map((n)=>parseInt(n, 10));
function $1622be301bae0161$export$f9017448876882a4({ disableAEC: disableAEC, disableAGC: disableAGC, hd: hd, lax: lax, lowDataMode: lowDataMode, preferredDeviceIds: preferredDeviceIds, resolution: resolution, simulcast: simulcast, widescreen: widescreen }) {
    var _a, _b;
    let HIGH_HEIGHT = 480;
    let LOW_HEIGHT = 240;
    if (hd) HIGH_HEIGHT = lax || $1622be301bae0161$var$isSafari ? 720 : {
        min: 360,
        ideal: 720
    };
    if (simulcast) {
        if (hd === false) {
            HIGH_HEIGHT = 360;
            LOW_HEIGHT = 270;
        } else LOW_HEIGHT = 360;
    }
    const constraints = {
        audio: Object.assign({}, preferredDeviceIds.audioId && {
            deviceId: preferredDeviceIds.audioId
        }),
        video: Object.assign(Object.assign({}, preferredDeviceIds.videoId ? {
            deviceId: preferredDeviceIds.videoId
        } : {
            facingMode: "user"
        }), {
            height: lowDataMode ? LOW_HEIGHT : HIGH_HEIGHT,
            frameRate: lowDataMode && !simulcast ? 15 : 24
        })
    };
    if (lax) {
        if (!((_a = constraints.audio) === null || _a === void 0 ? void 0 : _a.deviceId)) constraints.audio = true;
        (_b = constraints.video) === null || _b === void 0 || delete _b.facingMode;
        return constraints;
    }
    if (resolution) {
        const [w, h, fps] = $1622be301bae0161$var$parseResolution(resolution);
        if (w) constraints.video.width = {
            exact: w
        };
        if (h) constraints.video.height = {
            exact: h
        };
        if (fps) constraints.video.frameRate = {
            exact: fps
        };
        delete constraints.video.facingMode;
    } else constraints.video.aspectRatio = widescreen ? 16 / 9 : 4 / 3;
    if (disableAGC) constraints.audio.autoGainControl = false;
    if (disableAEC) constraints.audio.echoCancellation = false;
    return constraints;
}
function $1622be301bae0161$export$86f10caa3f7697c2({ devices: devices, videoId: videoId, audioId: audioId, options: options, type: type = "ideal" }) {
    const audioDevices = devices.filter((d)=>d.kind === "audioinput");
    const videoDevices = devices.filter((d)=>d.kind === "videoinput");
    const useDefaultAudio = !audioId || !audioDevices.some((d)=>d.deviceId === audioId);
    const useDefaultVideo = !videoId || !videoDevices.some((d)=>d.deviceId === videoId);
    const constraints = $1622be301bae0161$export$f9017448876882a4(Object.assign({
        preferredDeviceIds: {
            audioId: useDefaultAudio ? null : {
                [type]: audioId
            },
            videoId: useDefaultVideo ? null : {
                [type]: videoId
            }
        }
    }, options));
    if (audioId === false || !audioDevices.length) delete constraints.audio;
    if (videoId === false || !videoDevices.length) delete constraints.video;
    return constraints;
}
const $1622be301bae0161$var$logger$7 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$export$d0a8044dce8ff2fc = /mobi/i.test(navigator.userAgent);
class $1622be301bae0161$export$fbb4d6e7253c7ce9 extends Error {
    constructor(...args){
        super(...args);
        this.name = "nodevices";
    }
}
function $1622be301bae0161$var$removeDuplicates(devices) {
    return devices.filter((device, i, self)=>i === self.findIndex((d)=>d.deviceId === device.deviceId && d.kind === device.kind));
}
function $1622be301bae0161$export$45a3175d55604f4() {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const devices = yield navigator.mediaDevices.enumerateDevices();
        const filteredDevices = $1622be301bae0161$var$removeDuplicates(devices);
        return filteredDevices;
    });
}
const $1622be301bae0161$var$idFieldsByKind = {
    audioinput: "audioId",
    videoinput: "videoId",
    audiooutput: "speakerId"
};
function $1622be301bae0161$export$8c4ae462a632eefd({ busyDeviceIds: busyDeviceIds, devices: devices, kind: kind }) {
    const deviceList = devices && devices.length && devices.filter((d)=>d.kind === kind).map((d)=>({
            [$1622be301bae0161$var$idFieldsByKind[kind]]: d.deviceId,
            label: `${busyDeviceIds.includes(d.deviceId) ? "(busy) " : ""}${d.label || d.deviceId.slice(0, 5)}`,
            busy: busyDeviceIds.includes(d.deviceId)
        }));
    return deviceList && deviceList.length !== 0 ? deviceList : [
        {
            [$1622be301bae0161$var$idFieldsByKind[kind]]: "",
            label: "Default"
        }
    ];
}
function $1622be301bae0161$export$c396324ce11e3eef(constraints) {
    if (!constraints.audio && !constraints.video) return Promise.reject(new $1622be301bae0161$export$fbb4d6e7253c7ce9("No provided devices"));
    return navigator.mediaDevices.getUserMedia(constraints).catch((error)=>{
        const message = `${error}, ${JSON.stringify(constraints, null, 2)}`;
        $1622be301bae0161$var$logger$7.error(`getUserMedia ${message}`);
        throw error;
    });
}
function $1622be301bae0161$var$getSettingsFromTrack(kind, track, devices, lastUsedId) {
    var _a, _b, _c;
    let settings = {
        deviceId: null
    };
    if (!track) {
        if (lastUsedId && devices) settings.deviceId = (_a = devices.find((d)=>d.deviceId === lastUsedId && d.kind === kind)) === null || _a === void 0 ? void 0 : _a.deviceId;
        return settings;
    }
    settings.label = track.label;
    if (track.getSettings) settings = Object.assign(Object.assign({}, settings), track.getSettings());
    if (settings.deviceId) return settings;
    if (track.getCapabilities) settings.deviceId = track.getCapabilities().deviceId;
    if (settings.deviceId) return settings;
    if (track.label && devices) settings.deviceId = (_b = devices.find((d)=>track.label === d.label && d.kind === kind)) === null || _b === void 0 ? void 0 : _b.deviceId;
    if (settings.deviceId) return settings;
    settings.deviceId = (_c = track.getConstraints()) === null || _c === void 0 ? void 0 : _c.deviceId;
    settings.broken = 1;
    return settings;
}
function $1622be301bae0161$export$fb9ff29788bfaf04({ audioTrack: audioTrack, videoTrack: videoTrack, devices: devices, stoppedVideoTrack: stoppedVideoTrack, lastAudioId: lastAudioId, lastVideoId: lastVideoId }) {
    const usable = (d)=>(d === null || d === void 0 ? void 0 : d.readyState) === "live" ? d : null;
    videoTrack = usable(videoTrack) || stoppedVideoTrack;
    audioTrack = usable(audioTrack);
    const video = $1622be301bae0161$var$getSettingsFromTrack("videoinput", videoTrack, devices, lastVideoId);
    const audio = $1622be301bae0161$var$getSettingsFromTrack("audioinput", audioTrack, devices, lastAudioId);
    return {
        video: video,
        audio: audio
    };
}
function $1622be301bae0161$export$c9e077842bfa3912(stream, only) {
    if (!only || only === "audio") stream.getAudioTracks().forEach((t)=>t.stop());
    if (!only || only === "video") stream.getVideoTracks().forEach((t)=>t.stop());
}
function $1622be301bae0161$export$f0e52ad0c2c2903e(stream, newStream, only) {
    const replacedTracks = [];
    if (!only || only === "audio") {
        replacedTracks.push(...stream.getAudioTracks());
        newStream.getAudioTracks().forEach((track)=>{
            track.replacement = true;
            stream.addTrack(track);
        });
    }
    if (!only || only === "video") {
        replacedTracks.push(...stream.getVideoTracks());
        newStream.getVideoTracks().forEach((track)=>{
            track.replacement = true;
            stream.addTrack(track);
        });
    }
    replacedTracks.forEach((track)=>{
        track.replaced = true;
        stream.removeTrack(track);
    });
    return replacedTracks;
}
function $1622be301bae0161$var$getTrack({ kind: kind, deviceId: deviceId, type: type, fallback: fallback = true, primerTrack: primerTrack }) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const devId = (deviceId)=>type === "exact" ? {
                deviceId: {
                    exact: deviceId
                }
            } : {
                deviceId: deviceId
            };
        const constraints = {
            [kind]: deviceId ? devId(deviceId) : kind === "video" ? {
                facingMode: "user"
            } : true
        };
        let stream;
        try {
            stream = yield $1622be301bae0161$export$c396324ce11e3eef(constraints);
        } catch (e) {
            if (!fallback) {
                e.details = {
                    constraints: constraints,
                    constraint: e.constraint
                };
                throw e;
            }
            if (primerTrack) return primerTrack;
            stream = yield $1622be301bae0161$export$c396324ce11e3eef({
                [kind]: true
            });
        }
        return stream.getTracks()[0];
    });
}
function $1622be301bae0161$var$constrainTrack(track, constraints) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        while(constraints.length)try {
            yield track.applyConstraints(Object.assign({}, ...constraints));
            break;
        } catch (e) {
            const c = constraints.pop();
            $1622be301bae0161$var$logger$7.warn(`unable to apply ${JSON.stringify(c)}`, e);
        }
    });
}
function $1622be301bae0161$export$c598f98c12f8be34(constraintOpt, additionalOpts = {}) {
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        const { audioId: audioId, videoId: videoId, devices: devices, type: type, options: options } = constraintOpt;
        const { replaceStream: replaceStream, fallback: fallback } = additionalOpts;
        const hasGrantedPermissions = !!devices.find((d)=>d.label !== "");
        let audioPrimerTrack;
        let videoPrimerTrack;
        if (!hasGrantedPermissions) try {
            const primerStream = yield $1622be301bae0161$export$c396324ce11e3eef({
                audio: constraintOpt.audioId !== false,
                video: constraintOpt.videoId !== false
            });
            audioPrimerTrack = primerStream.getAudioTracks()[0];
            videoPrimerTrack = primerStream.getVideoTracks()[0];
        } catch (err) {
            if (err.name === "NotAllowedError") throw err;
        }
        const getAudio = ()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                if (audioId === false) return false;
                if (replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, "audio");
                const audioTrack = yield $1622be301bae0161$var$getTrack({
                    deviceId: audioId,
                    type: type,
                    kind: "audio",
                    fallback: fallback,
                    primerTrack: audioPrimerTrack
                });
                if (audioPrimerTrack && audioTrack !== audioPrimerTrack) audioPrimerTrack.stop();
                const { disableAEC: disableAEC, disableAGC: disableAGC } = options;
                const changes = [];
                if (disableAGC) changes.push({
                    autoGainControl: false
                });
                if (disableAEC) changes.push({
                    echoCancellation: false
                });
                yield $1622be301bae0161$var$constrainTrack(audioTrack, changes);
                return audioTrack;
            });
        const getVideo = ()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                if (videoId === false) return false;
                if (replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, "video");
                const videoTrack = yield $1622be301bae0161$var$getTrack({
                    deviceId: videoId,
                    type: type,
                    kind: "video",
                    fallback: fallback,
                    primerTrack: videoPrimerTrack
                });
                if (videoPrimerTrack && videoTrack !== videoPrimerTrack) videoPrimerTrack.stop();
                const { lowDataMode: lowDataMode, simulcast: simulcast, usingAspectRatio16x9: usingAspectRatio16x9 } = options;
                const changes = [];
                if (lowDataMode) changes.push({
                    frameRate: simulcast ? 30 : 15
                });
                if (usingAspectRatio16x9) changes.push({
                    aspectRatio: 16 / 9
                });
                if (lowDataMode) changes.push({
                    width: {
                        max: simulcast ? 640 : 320
                    }
                });
                else changes.push({
                    width: {
                        max: 1280
                    }
                });
                yield $1622be301bae0161$var$constrainTrack(videoTrack, changes);
                return videoTrack;
            });
        const audioPromise = getAudio();
        const videoPromise = getVideo();
        let audioTrack;
        let videoTrack;
        let error;
        try {
            audioTrack = yield audioPromise;
        } catch (e) {
            error = e;
            if (type === "exact") throw e;
        }
        try {
            videoTrack = yield videoPromise;
        } catch (e) {
            error = e;
            if (type === "exact") throw e;
        }
        const newStream = new MediaStream([
            audioTrack,
            videoTrack
        ].filter(Boolean));
        let replacedTracks;
        if (replaceStream) {
            const only = audioId === false && "video" || videoId === false && "audio" || "audio";
            replacedTracks = $1622be301bae0161$export$f0e52ad0c2c2903e(replaceStream, newStream, only);
        }
        return {
            stream: replaceStream || newStream,
            error: error,
            replacedTracks: replacedTracks
        };
    });
}
function $1622be301bae0161$export$747191980cdf43e8(constraintOpt, { replaceStream: replaceStream, fallback: fallback = true } = {}) {
    var _a;
    return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
        let error;
        let newConstraints;
        let retryConstraintOpt;
        let stream = null;
        const only = constraintOpt.audioId === false && "video" || constraintOpt.videoId === false && "audio";
        const stopTracks = $1622be301bae0161$export$d0a8044dce8ff2fc || only !== "video";
        const constraints = $1622be301bae0161$export$86f10caa3f7697c2(constraintOpt);
        const addDetails = (err, orgErr)=>{
            err.details = Object.assign({
                constraints: constraints,
                constraint: err.constraint || (orgErr === null || orgErr === void 0 ? void 0 : orgErr.constraint),
                newConstraints: newConstraints,
                fallback: fallback,
                stopTracks: stopTracks
            }, err !== error && {
                error: String(error)
            });
            return err;
        };
        if (stopTracks && replaceStream) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
        try {
            stream = yield $1622be301bae0161$export$c396324ce11e3eef(constraints);
        } catch (e) {
            error = e;
            if (!fallback) throw addDetails(e);
            if (e.name === "OverconstrainedError") {
                const laxConstraints = {
                    deviceId: {
                        videoId: null,
                        audioId: null
                    },
                    width: {
                        lax: true
                    },
                    height: {
                        lax: true
                    },
                    "": {
                        audioId: null,
                        videoId: null,
                        lax: true
                    }
                };
                retryConstraintOpt = laxConstraints[e.constraint || ""];
            } else if (e.name === "NotFoundError") {
                if (constraints.audio && constraints.video) {
                    try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            audioId: false
                        })));
                    } catch (e2) {
                        if (e2.name !== "NotFoundError") throw addDetails(e2, e);
                    }
                    try {
                        if (!stream) stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            videoId: false
                        })));
                    } catch (e2) {
                        throw addDetails(e2, e);
                    }
                }
            } else if (e.name === "NotAllowedError" || e.name === "NotReadableError" || e.name === "AbortError") {
                if (replaceStream && !stopTracks) {
                    $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
                    retryConstraintOpt = constraintOpt;
                } else if (e.name !== "NotAllowedError") {
                    try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            options: Object.assign(Object.assign({}, constraintOpt.options), {
                                lax: true
                            })
                        })));
                    } catch (e2) {
                        $1622be301bae0161$var$logger$7.warn(`Tried getting stream again with laxer constraints, but failed: ${"" + e2}`);
                    }
                    const errMsg = ("" + e).toLowerCase();
                    const problemWith = {
                        audio: "audioId",
                        video: "videoId"
                    }[((_a = /(video|audio)/.exec(errMsg)) === null || _a === void 0 ? void 0 : _a[0]) || only || ""];
                    if (!stream && problemWith) try {
                        stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                            [problemWith]: null
                        })));
                    } catch (e2) {
                        $1622be301bae0161$var$logger$7.warn(`Re-tried ${problemWith} with no constraints, but failed: ${"" + e2}`);
                    }
                    if (!stream) {
                        const tryOnly = problemWith ? [
                            problemWith
                        ] : [
                            "videoId",
                            "audioId"
                        ];
                        for (const kind of tryOnly){
                            try {
                                stream = yield $1622be301bae0161$export$c396324ce11e3eef($1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign({}, constraintOpt), {
                                    [kind]: false
                                })));
                            } catch (e2) {
                                $1622be301bae0161$var$logger$7.warn(`Re-tried without ${kind}, but failed: ${"" + e2}`);
                            }
                            if (stream) break;
                        }
                    }
                }
            }
        }
        if (retryConstraintOpt) {
            const onlyConstraints = only ? ({
                audio: {
                    videoId: false
                },
                video: {
                    audioId: false
                }
            })[only] : {};
            newConstraints = $1622be301bae0161$export$86f10caa3f7697c2(Object.assign(Object.assign(Object.assign(Object.assign({}, constraintOpt), retryConstraintOpt), {
                options: Object.assign(Object.assign({}, constraintOpt.options), {
                    lax: retryConstraintOpt.lax
                })
            }), onlyConstraints));
            try {
                stream = yield $1622be301bae0161$export$c396324ce11e3eef(newConstraints);
            } catch (e) {
                throw addDetails(e, error);
            }
        }
        if (!stream) throw addDetails(error);
        let replacedTracks;
        if (replaceStream) {
            if (!stopTracks) $1622be301bae0161$export$c9e077842bfa3912(replaceStream, only);
            replacedTracks = $1622be301bae0161$export$f0e52ad0c2c2903e(replaceStream, stream, only);
            stream = replaceStream;
        }
        return {
            error: error && addDetails(error),
            stream: stream,
            replacedTracks: replacedTracks
        };
    });
}
function $1622be301bae0161$export$ec692da3ca415072() {
    if ($parcel$global.navigator.userAgent.includes("Android")) return false;
    return !!($parcel$global.navigator.mediaDevices || {}).getDisplayMedia;
}
const $1622be301bae0161$var$defaultDisplayMediaConstraints = {
    video: {
        width: {
            max: window.screen.width
        },
        height: {
            max: window.screen.height
        }
    }
};
function $1622be301bae0161$export$251c1161688ff522(constraints = $1622be301bae0161$var$defaultDisplayMediaConstraints, contentHint = "detail") {
    return navigator.mediaDevices.getDisplayMedia(constraints).then((stream)=>{
        stream.getVideoTracks().forEach((t)=>{
            if ("contentHint" in t) t.contentHint = contentHint;
        });
        return stream;
    });
}
function $1622be301bae0161$export$47595e93b87b07e9(before, after) {
    const [beforeByKind, afterByKind] = [
        before,
        after
    ].map((list)=>list.filter((device)=>device.kind && device.deviceId).reduce((result, device)=>Object.assign(Object.assign({}, result), {
                [device.kind]: Object.assign(Object.assign({}, result[device.kind]), {
                    [device.deviceId]: device
                })
            }), {}));
    const changesByKind = {};
    before.forEach((device)=>{
        if (!device.kind || !device.deviceId) return;
        if (!changesByKind[device.kind]) changesByKind[device.kind] = {
            added: {},
            removed: {},
            changed: {}
        };
        if (!afterByKind[device.kind] || !afterByKind[device.kind][device.deviceId]) changesByKind[device.kind].removed[device.deviceId] = device;
    });
    after.forEach((device)=>{
        if (!device.kind || !device.deviceId) return;
        if (!changesByKind[device.kind]) changesByKind[device.kind] = {
            added: {},
            removed: {},
            changed: {}
        };
        if (!beforeByKind[device.kind] || !beforeByKind[device.kind][device.deviceId]) changesByKind[device.kind].added[device.deviceId] = device;
        else if (beforeByKind[device.kind][device.deviceId].label && beforeByKind[device.kind][device.deviceId].label !== device.label) changesByKind[device.kind].changed[device.deviceId] = device;
    });
    return changesByKind;
}
function $1622be301bae0161$export$be9584734485c5e8({ oldDevices: oldDevices, newDevices: newDevices, currentAudioId: currentAudioId, currentVideoId: currentVideoId, currentSpeakerId: currentSpeakerId }) {
    const changesByKind = $1622be301bae0161$export$47595e93b87b07e9(oldDevices, newDevices);
    const changedDevices = {};
    const addedDevices = {};
    [
        [
            "audioinput",
            currentAudioId
        ],
        [
            "videoinput",
            currentVideoId
        ],
        [
            "audiooutput",
            currentSpeakerId
        ]
    ].forEach(([kind, currentDeviceId])=>{
        kind = kind || "";
        const changes = changesByKind[kind];
        if (!changes) return;
        if (currentDeviceId) {
            if (changes.removed[currentDeviceId]) {
                changedDevices[kind] = {
                    deviceId: null
                };
                if (kind === "audiooutput") {
                    const fallbackSpeakerDevice = newDevices.find((d)=>d.kind === "audiooutput");
                    changedDevices[kind] = {
                        deviceId: fallbackSpeakerDevice === null || fallbackSpeakerDevice === void 0 ? void 0 : fallbackSpeakerDevice.deviceId
                    };
                }
            }
            if (changes.changed[currentDeviceId]) changedDevices[kind] = {
                deviceId: currentDeviceId
            };
        }
        if (Object.keys(changes.added).length) {
            const [deviceAdded] = Object.keys(changes.added).slice(0, 1);
            const add = changes.added[deviceAdded];
            addedDevices[kind] = {
                deviceId: add.deviceId,
                label: add.label,
                kind: add.kind
            };
        }
    });
    return {
        addedDevices: addedDevices,
        changedDevices: changedDevices
    };
}
var $1622be301bae0161$var$_a$5;
($1622be301bae0161$var$_a$5 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$5 !== void 0 ? $1622be301bae0161$var$_a$5 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$RTCSTATS_PROTOCOL_VERSION = "1.0";
const $1622be301bae0161$var$GETSTATS_BUFFER_SIZE = 20;
const $1622be301bae0161$var$clientInfo = {
    id: (0, $e247db96f48d686a$export$2e2bcd8739ae039)(),
    connectionNumber: 0
};
const $1622be301bae0161$var$noop = ()=>{};
let $1622be301bae0161$var$resetDelta = $1622be301bae0161$var$noop;
function $1622be301bae0161$var$rtcStatsConnection(wsURL, logger = console) {
    const buffer = [];
    let ws;
    let organizationId;
    let clientId;
    let displayName;
    let userRole;
    let roomSessionId;
    let connectionShouldBeOpen;
    let connectionAttempt = 0;
    let hasPassedOnRoomSessionId = false;
    let getStatsBufferUsed = 0;
    let deviceId;
    let roomProduct;
    let roomMode;
    let sfuServer;
    let featureFlags;
    const connection = {
        connected: false,
        trace: (...args)=>{
            args.push(Date.now());
            if (args[0] === "customEvent" && args[2].type === "roomSessionId") {
                const oldRoomSessionIdValue = roomSessionId && roomSessionId[2].value.roomSessionId;
                const newRoomSessionIdValue = args[2].value.roomSessionId;
                roomSessionId = args;
                if (hasPassedOnRoomSessionId && newRoomSessionIdValue && newRoomSessionIdValue !== oldRoomSessionIdValue) ws === null || ws === void 0 || ws.close();
                if (newRoomSessionIdValue) hasPassedOnRoomSessionId = true;
            } else if (args[0] === "customEvent" && args[2].type === "clientId") clientId = args;
            else if (args[0] === "customEvent" && args[2].type === "organizationId") organizationId = args;
            else if (args[0] === "customEvent" && args[2].type === "displayName") displayName = args;
            else if (args[0] === "customEvent" && args[2].type === "userRole") userRole = args;
            else if (args[0] === "customEvent" && args[2].type === "deviceId") deviceId = args;
            else if (args[0] === "customEvent" && args[2].type === "roomProduct") roomProduct = args;
            else if (args[0] === "customEvent" && args[2].type === "roomMode") roomMode = args;
            else if (args[0] === "customEvent" && args[2].type === "sfuServer") sfuServer = args;
            else if (args[0] === "customEvent" && args[2].type === "featureFlags") featureFlags = args;
            if ((ws === null || ws === void 0 ? void 0 : ws.readyState) === WebSocket.OPEN) {
                connectionAttempt = 0;
                ws.send(JSON.stringify(args));
            } else if (args[0] === "getstats") {
                if (getStatsBufferUsed < $1622be301bae0161$var$GETSTATS_BUFFER_SIZE) {
                    getStatsBufferUsed++;
                    buffer.push(args);
                }
            } else if (args[0] === "customEvent" && args[2].type === "insightsStats") ;
            else buffer.push(args);
            if ((ws === null || ws === void 0 ? void 0 : ws.readyState) === WebSocket.CLOSED && connectionShouldBeOpen) setTimeout(()=>{
                if (ws.readyState === WebSocket.CLOSED && connectionShouldBeOpen) connection.connect();
            }, 1000 * connectionAttempt);
        },
        close: ()=>{
            connectionShouldBeOpen = false;
            ws === null || ws === void 0 || ws.close();
        },
        connect: ()=>{
            connectionShouldBeOpen = true;
            connectionAttempt += 1;
            ws === null || ws === void 0 || ws.close();
            connection.connected = true;
            ws = new WebSocket(wsURL + window.location.pathname, $1622be301bae0161$var$RTCSTATS_PROTOCOL_VERSION);
            ws.onerror = (e)=>{
                connection.connected = false;
                logger.warn(`[RTCSTATS] WebSocket error`, e);
            };
            ws.onclose = (e)=>{
                connection.connected = false;
                logger.info(`[RTCSTATS] Closed ${e.code}`);
                $1622be301bae0161$var$resetDelta();
            };
            ws.onopen = ()=>{
                $1622be301bae0161$var$clientInfo.connectionNumber++;
                ws.send(JSON.stringify([
                    "clientInfo",
                    null,
                    $1622be301bae0161$var$clientInfo
                ]));
                if (organizationId) ws.send(JSON.stringify(organizationId));
                if (clientId) ws.send(JSON.stringify(clientId));
                if (roomSessionId) ws.send(JSON.stringify(roomSessionId));
                if (displayName) ws.send(JSON.stringify(displayName));
                if (userRole) ws.send(JSON.stringify(userRole));
                if (deviceId) ws.send(JSON.stringify(deviceId));
                if (roomMode) ws.send(JSON.stringify(roomMode));
                if (roomProduct) ws.send(JSON.stringify(roomProduct));
                if (sfuServer) ws.send(JSON.stringify(sfuServer));
                if (featureFlags) ws.send(JSON.stringify(featureFlags));
                while(buffer.length)ws.send(JSON.stringify(buffer.shift()));
                getStatsBufferUsed = 0;
            };
        }
    };
    return connection;
}
const $1622be301bae0161$var$server = $1622be301bae0161$var$rtcStatsConnection("wss://rtcstats.srv.whereby.com");
const $1622be301bae0161$var$stats = (0, (/*@__PURE__*/$parcel$interopDefault($695e2205f7548c7a$exports)))($1622be301bae0161$var$server.trace, 10000, [
    ""
]);
$1622be301bae0161$var$resetDelta = ($1622be301bae0161$var$stats === null || $1622be301bae0161$var$stats === void 0 ? void 0 : $1622be301bae0161$var$stats.resetDelta) || $1622be301bae0161$var$noop;
const $1622be301bae0161$export$6e1a0bfe9f2f0cbe = {
    sendEvent: (type, value)=>{
        $1622be301bae0161$var$server.trace("customEvent", null, {
            type: type,
            value: value
        });
    },
    sendAudioMuted: (muted)=>{
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    },
    sendVideoMuted: (muted)=>{
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    },
    server: $1622be301bae0161$var$server
};
var $1622be301bae0161$var$_a$4;
const $1622be301bae0161$var$adapter$4 = ($1622be301bae0161$var$_a$4 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$4 !== void 0 ? $1622be301bae0161$var$_a$4 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$6 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$browserName$2 = $1622be301bae0161$var$adapter$4.browserDetails.browser;
const $1622be301bae0161$var$browserVersion$1 = $1622be301bae0161$var$adapter$4.browserDetails.version;
function $1622be301bae0161$export$e6fb7443cbdf2b8b(sdp, vp9On, redOn) {
    var _a, _b;
    try {
        const sdpObject = $8j7qr.parse(sdp);
        if (Array.isArray(sdpObject === null || sdpObject === void 0 ? void 0 : sdpObject.media)) {
            const mediaAudio = sdpObject.media.find((m)=>m.type === "audio");
            if (Array.isArray(mediaAudio === null || mediaAudio === void 0 ? void 0 : mediaAudio.rtp)) {
                const rtp = mediaAudio.rtp;
                for(let i = 0; i < rtp.length; i++)if (redOn && rtp[i].codec === "red") {
                    const payloads = (_a = mediaAudio.payloads) === null || _a === void 0 ? void 0 : _a.split(" ");
                    const pt = payloads === null || payloads === void 0 ? void 0 : payloads.indexOf("" + rtp[i].payload);
                    if (pt && pt !== -1 && pt >= 0) {
                        payloads === null || payloads === void 0 || payloads.unshift(payloads.splice(pt, 1)[0]);
                        mediaAudio.payloads = payloads === null || payloads === void 0 ? void 0 : payloads.join(" ");
                    }
                }
            }
            const mediaVideo = sdpObject.media.find((m)=>m.type === "video");
            if (Array.isArray(mediaVideo === null || mediaVideo === void 0 ? void 0 : mediaVideo.rtp)) {
                const rtp = mediaVideo.rtp;
                for(let i = 0; i < rtp.length; i++)if (vp9On && rtp[i].codec === "VP9") {
                    const payloads = (_b = mediaVideo.payloads) === null || _b === void 0 ? void 0 : _b.split(" ");
                    const pt = payloads === null || payloads === void 0 ? void 0 : payloads.indexOf("" + rtp[i].payload);
                    if (pt && pt !== -1 && pt >= 0) {
                        payloads === null || payloads === void 0 || payloads.unshift(payloads.splice(pt, 1)[0]);
                        mediaVideo.payloads = payloads === null || payloads === void 0 ? void 0 : payloads.join(" ");
                    }
                }
            }
        }
        const newSdp = $8j7qr.write(sdpObject);
        return newSdp;
    } catch (error) {
        $1622be301bae0161$var$logger$6.error("setCodecPreferenceSDP error:", error);
    }
}
function $1622be301bae0161$export$529db98703a04dea(sdp) {
    try {
        const sdpObject = $8j7qr.parse(sdp);
        sdpObject.media.forEach((mediaObject)=>{
            const usedPayloads = {};
            if (mediaObject.payloads) mediaObject.payloads = ("" + mediaObject.payloads).split(" ").filter((p)=>!usedPayloads[p] && (usedPayloads[p] = true)).join(" ");
            const usedRtps = {};
            mediaObject.rtp = mediaObject.rtp.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedRtps[p.payload] && (usedRtps[p.payload] = true));
            const usedFmtps = {};
            if (mediaObject.fmtp) mediaObject.fmtp = mediaObject.fmtp.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedFmtps[p.payload] && (usedFmtps[p.payload] = true));
            const usedRtcpFb = {};
            if (mediaObject.rtcpFb) mediaObject.rtcpFb = mediaObject.rtcpFb.filter((p)=>!p.payload || usedPayloads[p.payload] && !usedRtcpFb[p.payload + p.type] && (usedRtcpFb[p.payload + p.type] = true));
        });
        return $8j7qr.write(sdpObject);
    } catch (_) {}
    return sdp;
}
function $1622be301bae0161$export$cd6d02be03104b8d(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "safari") return sdp;
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp);
    for(let i = 1; i < sections.length; i++){
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(sections[i]) !== "video") continue;
        const codecs = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(sections[i], "a=rtpmap:").map((line)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseRtpMap(line);
        }).map((codec)=>{
            return codec.name.toUpperCase();
        });
        if (codecs.indexOf("H264") === -1 && sections[i][8] === "9") sections[i] = sections[i].replace("m=video 9 ", "m=video 0 ");
    }
    return sections.join("");
}
function $1622be301bae0161$export$aabefb65e8880783(sdp) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp).map((section)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(section) !== "video") return section;
        const h264payloadTypes = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(section, "a=rtpmap:").map((line)=>(0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseRtpMap(line)).filter((codec)=>/h264/i.test(codec.name)).map((codec)=>"" + codec.payloadType);
        if (!h264payloadTypes.length) return section;
        const mline = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).matchPrefix(section, "m=video")[0];
        const mlinePayloadsSectionExec = /(\s\d+)+$/i.exec(mline);
        const mlinePayloadsSection = mlinePayloadsSectionExec ? mlinePayloadsSectionExec[0] : "";
        const mlinePayloadsNonH264 = mlinePayloadsSection.split(" ").filter((payloadType)=>payloadType && !h264payloadTypes.includes(payloadType));
        const reorderedPayloads = [
            ...mlinePayloadsNonH264,
            ...h264payloadTypes
        ].join(" ");
        const newmline = mline.replace(mlinePayloadsSection, " " + reorderedPayloads);
        return section.replace(mline, newmline);
    }).join("");
}
function $1622be301bae0161$export$6cd2554db6b94584(currentDescription, newDescription) {
    let ssrcs = currentDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
    let newssrcs = newDescription.match(/a=ssrc-group:FID (\d+) (\d+)\r\n/);
    if (!ssrcs) {
        ssrcs = currentDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
        newssrcs = newDescription.match(/a=ssrc:(\d+) cname:(.*)\r\n/g)[1].match(/a=ssrc:(\d+)/);
    }
    for(let i = 1; i < ssrcs.length; i++)newDescription = newDescription.replace(new RegExp(newssrcs[i], "g"), ssrcs[i]);
    return newDescription;
}
function $1622be301bae0161$export$5ac3fc986856d28f(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "safari" && ($1622be301bae0161$var$browserName$2 !== "firefox" || $1622be301bae0161$var$browserVersion$1 && $1622be301bae0161$var$browserVersion$1 >= 63 || $1622be301bae0161$var$browserVersion$1 === 60)) return sdp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitLines(sdp.trim()).filter((line)=>{
        if (!line.startsWith("a=extmap:")) return true;
        const extmap = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).parseExtmap(line);
        return extmap.uri !== "urn:ietf:params:rtp-hdrext:sdes:mid";
    }).join("\r\n") + "\r\n";
}
function $1622be301bae0161$export$29fb476286719545(sdp) {
    if ($1622be301bae0161$var$browserName$2 !== "firefox") return sdp;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitLines(sdp.trim()).map((line)=>line.startsWith("a=msid-semantic:") ? "a=msid-semantic: WMS *" : line).join("\r\n") + "\r\n";
}
function $1622be301bae0161$export$e3830f4bcec0e79f(sdp, active) {
    const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).splitSections(sdp);
    return sections.shift() + sections.map((section)=>{
        const currentDirection = (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getDirection(section, (0, (/*@__PURE__*/$parcel$interopDefault($7457294ed7ab71f3$exports))).getKind(section));
        return section.replace("a=" + currentDirection, "a=" + (active ? "recvonly" : "inactive"));
    }).join("");
}
function $1622be301bae0161$export$b7ea0cdabf789ea3(sdp, extmapUri, modifyAudio = false, modifyVideo = false) {
    var _a, _b;
    try {
        const sdpObj = $8j7qr.parse(sdp);
        if (((_a = sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.ext) === null || _a === void 0 ? void 0 : _a.length) && sdpObj.ext.length > 0) return sdp;
        if ((sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.media.length) < 1) return sdp;
        const allHeaderExtensions = sdpObj === null || sdpObj === void 0 ? void 0 : sdpObj.media.flatMap((section)=>section.ext || []);
        const extmapId = ((_b = allHeaderExtensions.find((ext)=>ext.uri === extmapUri)) === null || _b === void 0 ? void 0 : _b.value) || [
            ...new Set([
                0,
                15,
                ...allHeaderExtensions.map((ext)=>ext.value)
            ])
        ].sort((a, b)=>a - b).find((n, i, arr)=>n + 1 !== arr[i + 1]) + 1;
        sdpObj.media.forEach((mediaSection)=>{
            var _a;
            if (modifyAudio && mediaSection.type === "audio" || modifyVideo && mediaSection.type === "video") {
                if (!((_a = mediaSection.ext) === null || _a === void 0 ? void 0 : _a.find((e)=>e.uri === extmapUri))) {
                    if (Array.isArray(mediaSection.ext)) mediaSection["ext"].push({
                        value: extmapId,
                        uri: extmapUri
                    });
                    else mediaSection["ext"] = [
                        {
                            value: extmapId,
                            uri: extmapUri
                        }
                    ];
                }
            }
        });
        return $8j7qr.write(sdpObj);
    } catch (error) {
        console.error("Error during addAbsCaptureTimeExtMap: ", error);
    }
    return sdp;
}
function $1622be301bae0161$export$eb32cdfe1ef3eb9c(sdp) {
    const absCaptureTimeUri = "http://www.webrtc.org/experiments/rtp-hdrext/abs-capture-time";
    return $1622be301bae0161$export$b7ea0cdabf789ea3(sdp, absCaptureTimeUri, true, true);
}
function $1622be301bae0161$export$1af83275ca9f024e(pc) {
    return pc.getStats(null).then((result)=>{
        let localCandidateType;
        let remoteCandidateType;
        result.forEach((report)=>{
            if (report.type === "transport" && report.selectedCandidatePairId) {
                const transport = result.get(report.selectedCandidatePairId);
                if (!transport) return;
                localCandidateType = result.get(transport.localCandidateId).candidateType;
                remoteCandidateType = result.get(transport.remoteCandidateId).candidateType;
                return;
            }
            if (report.type === "candidate-pair" && report.selected) {
                localCandidateType = result.get(report.localCandidateId).candidateType;
                remoteCandidateType = result.get(report.remoteCandidateId).candidateType;
            }
        });
        return localCandidateType === "relay" || localCandidateType === "relayed" || remoteCandidateType === "relay" || remoteCandidateType === "relayed";
    });
}
function $1622be301bae0161$export$49b206b8681907c1(pc, bandwidth, logger = console) {
    const sender = pc.getSenders().find((s)=>s.track && s.track.kind === "video");
    if (!sender) return Promise.resolve();
    const parameters = sender.getParameters();
    if (parameters.encodings && parameters.encodings.length === 0) return Promise.resolve();
    if (!parameters.encodings) parameters.encodings = [
        {}
    ];
    if (bandwidth === 0) delete parameters.encodings[0].maxBitrate;
    else parameters.encodings[0].maxBitrate = bandwidth * 1000;
    return sender.setParameters(parameters).catch((err)=>{
        logger.error("setParameters err: ", err);
    });
}
var $1622be301bae0161$var$_a$3;
const $1622be301bae0161$var$adapter$3 = ($1622be301bae0161$var$_a$3 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$3 !== void 0 ? $1622be301bae0161$var$_a$3 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$5 = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$1fb4852a55678982 {
    setAndGetPeerConnection({ clientId: clientId, constraints: constraints, peerConnectionConfig: peerConnectionConfig, shouldAddLocalVideo: shouldAddLocalVideo }) {
        this.peerConnectionConfig = peerConnectionConfig;
        this.shouldAddLocalVideo = shouldAddLocalVideo;
        this.clientId = clientId;
        this.pc = new RTCPeerConnection(peerConnectionConfig);
        this.signalingState = this.pc.signalingState;
        this.pc.addEventListener("signalingstatechange", ()=>{
            if (this.signalingState === this.pc.signalingState) return;
            this.signalingState = this.pc.signalingState;
            if (this.pc.signalingState === "stable") {
                this.isOperationPending = false;
                const action = this.pending.shift();
                if (action) action.apply();
            }
        });
        return this.pc;
    }
    addStream(stream) {
        this.streamIds.push(stream.id);
        this.streams.push(stream);
        if (RTCPeerConnection.prototype.addTrack) {
            stream.getAudioTracks().forEach((track)=>{
                this.pc.addTrack(track, stream);
            });
            stream.getVideoTracks().forEach((track)=>{
                this.pc.addTrack(track, stream);
            });
        } else this.pc.addStream(stream);
    }
    addTrack(track, stream) {
        if (!stream) stream = this.streams[0];
        stream === null || stream === void 0 || stream.addTrack(track);
        this.pc.addTrack(track, stream);
    }
    removeTrack(track) {
        const stream = this.streams[0];
        stream.removeTrack(track);
        const sender = this.pc.getSenders().find((sender)=>sender.track === track);
        if (sender) this.pc.removeTrack(sender);
    }
    removeStream(stream) {
        for(let i = 0; i < this.streamIds.length; i++)if (this.streamIds[i] === stream.id) {
            this.streamIds.splice(i, 1);
            this.streams.splice(i, 1);
        }
        if (this.pc) {
            if (this.pc.removeTrack) stream.getTracks().forEach((track)=>{
                const sender = this.pc.getSenders().find((sender)=>sender.track === track);
                if (sender) this.pc.removeTrack(sender);
            });
            else if (this.pc.removeStream) this.pc.removeStream(stream);
        }
    }
    _setRemoteDescription(desc) {
        if (this._deprioritizeH264Encoding) desc.sdp = $1622be301bae0161$export$aabefb65e8880783(desc.sdp);
        this.srdComplete = this.pc.setRemoteDescription(desc);
        return this.srdComplete.then(()=>{
            this.earlyIceCandidates.forEach((candidate)=>this.pc.addIceCandidate(candidate));
            this.earlyIceCandidates = [];
        });
    }
    handleOffer(message) {
        if (!this.canModifyPeerConnection()) return new Promise((resolve)=>{
            this.pending.push(()=>this.handleOffer(message).then(resolve));
        });
        this.isOperationPending = true;
        let sdp = message.sdp;
        sdp = $1622be301bae0161$export$5ac3fc986856d28f(sdp);
        sdp = $1622be301bae0161$export$29fb476286719545(sdp);
        const desc = {
            type: message.type,
            sdp: sdp
        };
        let answerToSignal;
        return this._setRemoteDescription(desc).then(()=>{
            return this.pc.createAnswer();
        }).then((answer)=>{
            answerToSignal = answer;
            return this.pc.setLocalDescription(answer);
        }).then(()=>{
            return $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
        }).then(()=>{
            return answerToSignal;
        });
    }
    handleAnswer(message) {
        const sdp = $1622be301bae0161$export$29fb476286719545(message.sdp);
        const desc = {
            type: message.type,
            sdp: sdp
        };
        return this._setRemoteDescription(desc).then(()=>{
            return $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
        }, (e)=>{
            $1622be301bae0161$var$logger$5.warn("Could not set remote description from remote answer: ", e);
        });
    }
    addIceCandidate(candidate) {
        if (!this.srdComplete) {
            this.earlyIceCandidates.push(candidate);
            return;
        }
        this.srdComplete.then(()=>{
            if (this.pc.signalingState === "closed") return;
            if ($1622be301bae0161$var$adapter$3.browserDetails.browser === "safari" && candidate && candidate.candidate === "") return;
            this.pc.addIceCandidate(candidate).catch((e)=>{
                $1622be301bae0161$var$logger$5.warn("Failed to add ICE candidate ('%s'): %s", candidate ? candidate.candidate : null, e);
            });
        });
    }
    canModifyPeerConnection() {
        return this.pc.signalingState === "stable" && !this.isOperationPending;
    }
    close() {
        const pc = this.pc;
        if (!pc) return;
        pc.oniceconnectionstatechange = null;
        pc.onicecandidate = null;
        pc.ontrack = null;
        try {
            pc.close();
        } catch (e) {
            $1622be301bae0161$var$logger$5.warn("failures during close of session", e);
        }
    }
    hasConnectedPeerConnection() {
        return this.pc && this.pc.connectionState === "connected";
    }
    replaceTrack(oldTrack, newTrack) {
        const pc = this.pc;
        if (!pc) return false;
        const senders = pc.getSenders();
        if (!oldTrack) oldTrack = (senders.find((s)=>s.track && s.track.kind === newTrack.kind) || {}).track;
        if (window.RTCRtpSender && window.RTCRtpSender.prototype.replaceTrack) {
            if (oldTrack) {
                const process = ()=>{
                    for(let i = 0; i < senders.length; i++){
                        const sender = senders[i];
                        const track = sender.track;
                        if ((track === null || track === void 0 ? void 0 : track.id) === newTrack.id) return Promise.resolve(newTrack);
                        if ((track === null || track === void 0 ? void 0 : track.id) === oldTrack.id) return senders[i].replaceTrack(newTrack);
                    }
                    return null;
                };
                let result = process();
                if (result) return result;
                let resolve = null;
                let reject = null;
                result = new Promise((_resolve, _reject)=>{
                    resolve = _resolve;
                    reject = _reject;
                });
                let retried = 0;
                let timer = setInterval(()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        const trackReplacedPromise = process();
                        if (!trackReplacedPromise) {
                            if (3 < ++retried) {
                                clearInterval(timer);
                                timer = null;
                                reject("No sender track to replace");
                            }
                            return;
                        }
                        clearInterval(timer);
                        timer = null;
                        const trackReplaced = yield trackReplacedPromise;
                        resolve(trackReplaced);
                    }), 1000);
                return result;
            }
            const stream = this.streams.find((s)=>s.getTracks().find((t)=>t.id === newTrack.id)) || this.streams[0];
            if (!stream) return Promise.reject(new Error("replaceTrack: No stream?"));
            return pc.addTrack(newTrack, stream);
        }
        if (!this.canModifyPeerConnection()) {
            this.pending.push(()=>{
                this.replaceTrack(oldTrack, newTrack);
            });
            return;
        }
        this.isOperationPending = true;
        const onn = pc.onnegotiationneeded;
        pc.onnegotiationneeded = null;
        this.removeTrack(oldTrack);
        this.addTrack(newTrack);
        setTimeout(()=>{
            pc.onnegotiationneeded = onn;
        }, 0);
        if (pc.localDescription.type === "offer") return pc.createOffer().then((offer)=>{
            offer.sdp = $1622be301bae0161$export$6cd2554db6b94584(pc.localDescription.sdp, offer.sdp);
            return pc.setLocalDescription(offer);
        }).then(()=>{
            return this._setRemoteDescription(pc.remoteDescription);
        });
        else return this._setRemoteDescription(pc.remoteDescription).then(()=>{
            return pc.createAnswer();
        }).then((answer)=>{
            answer.sdp = $1622be301bae0161$export$6cd2554db6b94584(pc.localDescription.sdp, answer.sdp);
            return pc.setLocalDescription(answer);
        });
    }
    maybeRestrictRelayBandwidth() {
        if (this.maximumTurnBandwidth === $1622be301bae0161$export$6bb71afef3ab9ece) return;
        if (!this.pc.getStats) return;
        $1622be301bae0161$export$1af83275ca9f024e(this.pc).then((isRelayed)=>{
            if (isRelayed && this.bandwidth === 0) this.changeBandwidth(this.maximumTurnBandwidth);
        });
    }
    changeBandwidth(bandwidth) {
        if (bandwidth === this.bandwidth) return;
        if (!this.canModifyPeerConnection()) {
            this.pending.push(()=>this.changeBandwidth(bandwidth));
            return;
        }
        this.bandwidth = bandwidth;
        if (!this.pc.localDescription || this.pc.localDescription.type === "") return;
        $1622be301bae0161$export$49b206b8681907c1(this.pc, this.bandwidth);
    }
    setAudioOnly(enable, excludedTrackIds = []) {
        this.pc.getTransceivers().filter((videoTransceiver)=>{
            var _a, _b, _c, _d, _e, _f;
            return (videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.direction) !== "recvonly" && ((_b = (_a = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.receiver) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "video" && !excludedTrackIds.includes((_d = (_c = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.receiver) === null || _c === void 0 ? void 0 : _c.track) === null || _d === void 0 ? void 0 : _d.id) && !excludedTrackIds.includes((_f = (_e = videoTransceiver === null || videoTransceiver === void 0 ? void 0 : videoTransceiver.sender) === null || _e === void 0 ? void 0 : _e.track) === null || _f === void 0 ? void 0 : _f.id);
        }).forEach((videoTransceiver)=>{
            videoTransceiver.direction = enable ? "sendonly" : "sendrecv";
        });
    }
    constructor({ peerConnectionId: peerConnectionId, bandwidth: bandwidth, maximumTurnBandwidth: maximumTurnBandwidth, deprioritizeH264Encoding: deprioritizeH264Encoding }){
        this.peerConnectionId = peerConnectionId;
        this.relayCandidateSeen = false;
        this.serverReflexiveCandidateSeen = false;
        this.publicHostCandidateSeen = false;
        this.ipv6HostCandidateSeen = false;
        this.ipv6HostCandidateTeredoSeen = false;
        this.ipv6HostCandidate6to4Seen = false;
        this.mdnsHostCandidateSeen = false;
        this.pc = null;
        this.wasEverConnected = false;
        this.connectionStatus = null;
        this.stats = {
            totalSent: 0,
            totalRecv: 0
        };
        this.bandwidth = bandwidth || 0;
        this.maximumTurnBandwidth = maximumTurnBandwidth;
        this.pending = [];
        this.isOperationPending = false;
        this.streamIds = [];
        this.streams = [];
        this.earlyIceCandidates = [];
        this.afterConnected = new Promise((resolve)=>{
            this.registerConnected = resolve;
        });
        this.offerOptions = {
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        };
        this._deprioritizeH264Encoding = deprioritizeH264Encoding;
    }
}
const $1622be301bae0161$export$1ea784ac1a0f1fca = {
    BLOCK_CLIENT: "block_client",
    CLAIM_ROOM: "claim_room",
    CLEAR_CHAT_HISTORY: "clear_chat_history",
    ENABLE_AUDIO: "enable_audio",
    ENABLE_VIDEO: "enable_video",
    END_STREAM: "end_stream",
    FETCH_MEDIASERVER_CONFIG: "fetch_mediaserver_config",
    HANDLE_KNOCK: "handle_knock",
    IDENTIFY_DEVICE: "identify_device",
    INVITE_CLIENT_AS_MEMBER: "invite_client_as_member",
    JOIN_ROOM: "join_room",
    KICK_CLIENT: "kick_client",
    KNOCK_ROOM: "knock_room",
    LEAVE_ROOM: "leave_room",
    SEND_CLIENT_METADATA: "send_client_metadata",
    SET_LOCK: "set_lock",
    SHARE_MEDIA: "share_media",
    START_NEW_STREAM: "start_new_stream",
    START_SCREENSHARE: "start_screenshare",
    STOP_SCREENSHARE: "stop_screenshare",
    START_URL_EMBED: "start_url_embed",
    STOP_URL_EMBED: "stop_url_embed",
    START_RECORDING: "start_recording",
    STOP_RECORDING: "stop_recording"
};
const $1622be301bae0161$export$f128bfe5688cdcff = {
    AUDIO_ENABLED: "audio_enabled",
    BACKGROUND_IMAGE_CHANGED: "background_image_changed",
    BLOCK_ADDED: "block_added",
    BLOCK_REMOVED: "block_removed",
    CHAT_HISTORY_CLEARED: "chat_history_cleared",
    CLIENT_BLOCKED: "client_blocked",
    CLIENT_INVITED_AS_MEMBER: "client_invited_as_member",
    CLIENT_KICKED: "client_kicked",
    CLIENT_LEFT: "client_left",
    CLIENT_METADATA_RECEIVED: "client_metadata_received",
    CLIENT_READY: "client_ready",
    CLIENT_ROLE_CHANGED: "client_role_changed",
    CLIENT_USER_ID_CHANGED: "client_user_id_changed",
    CONTACTS_UPDATED: "contacts_updated",
    DEVICE_IDENTIFIED: "device_identified",
    ROOM_ROLES_UPDATED: "room_roles_updated",
    KNOCK_HANDLED: "knock_handled",
    KNOCK_PAGE_BACKGROUND_CHANGED: "knock_page_background_changed",
    KNOCKER_LEFT: "knocker_left",
    MEDIASERVER_CONFIG: "mediaserver_config",
    MEDIA_SHARED: "media_shared",
    MEMBER_INVITE: "member_invite",
    NEW_CLIENT: "new_client",
    NEW_STREAM_STARTED: "new_stream_started",
    SCREENSHARE_STARTED: "screenshare_started",
    SCREENSHARE_STOPPED: "screenshare_stopped",
    OWNER_NOTIFIED: "owner_notified",
    OWNERS_CHANGED: "owners_changed",
    PLAY_CLIENT_STICKER: "play_client_sticker",
    ROOM_INTEGRATION_ENABLED: "room_integration_enabled",
    ROOM_INTEGRATION_DISABLED: "room_integration_disabled",
    ROOM_JOINED: "room_joined",
    ROOM_KNOCKED: "room_knocked",
    ROOM_LEFT: "room_left",
    ROOM_LOCKED: "room_locked",
    ROOM_PERMISSIONS_CHANGED: "room_permissions_changed",
    ROOM_LOGO_CHANGED: "room_logo_changed",
    ROOM_TYPE_CHANGED: "room_type_changed",
    ROOM_MODE_CHANGED: "room_mode_changed",
    SOCKET_USER_ID_CHANGED: "socket_user_id_changed",
    STICKERS_UNLOCKED: "stickers_unlocked",
    STREAM_ENDED: "stream_ended",
    URL_EMBED_STARTED: "url_embed_started",
    URL_EMBED_STOPPED: "url_embed_stopped",
    RECORDING_STARTED: "recording_started",
    RECORDING_STOPPED: "recording_stopped",
    USER_NOTIFIED: "user_notified",
    VIDEO_ENABLED: "video_enabled",
    CLIENT_UNABLE_TO_JOIN: "client_unable_to_join",
    LIVE_TRANSCRIPTION_STARTED: "live_transcription_started",
    LIVE_TRANSCRIPTION_STOPPED: "live_transcription_stopped"
};
const $1622be301bae0161$export$501d573e6762e730 = {
    CANNOT_INVITE_YOURSELF: "cannot_invite_yourself",
    CLIENT_MISSING_DEVICE_ID: "client_missing_device_id",
    FORBIDDEN: "forbidden",
    INTERNAL_SERVER_ERROR: "internal_server_error",
    INVALID_AVATAR: "invalid_avatar",
    INVALID_PARAMETERS: "invalid_parameters",
    INVALID_ROOM_NAME: "invalid_room_name",
    MISSING_PARAMETERS: "missing_parameters",
    MISSING_ROOM_NAME: "missing_room_name",
    NOT_AN_OWNER: "not_an_owner",
    NOT_IN_A_ROOM: "not_in_a_room",
    ROOM_ALREADY_CLAIMED: "room_already_claimed",
    ROOM_EMAIL_MISSING: "room_email_missing",
    ROOM_FULL: "room_full",
    ROOM_UNCLAIMED: "room_unclaimed",
    CLIENT_BLOCKED: "client_blocked",
    ROOM_LOCKED: "room_locked",
    TOO_LONG_TEXT: "too_long_text",
    VIDEO_STICKER_DOES_NOT_EXIST: "video_sticker_does_not_exist",
    VIDEO_STICKER_FORMAT_ERROR: "video_sticker_format_error",
    UNSUPPORTED_VIDEO_ENCODING: "unsupported_video_encoding"
};
const $1622be301bae0161$export$83849580da009913 = {
    CHAT_MESSAGE: "chat_message",
    CHAT_READ_STATE: "chat_read_state",
    CHAT_STATE: "chat_state",
    ICE_CANDIDATE: "ice_candidate",
    ICE_END_OF_CANDIDATES: "ice_endofcandidates",
    READY_TO_RECEIVE_OFFER: "ready_to_receive_offer",
    REMOTE_CLIENT_MEDIA_REQUEST: "remote_client_media_request",
    SDP_ANSWER: "sdp_answer",
    SDP_OFFER: "sdp_offer",
    VIDEO_STICKER: "video_sticker"
};
const $1622be301bae0161$export$c09e21f3212e33cd = {
    actions: {
        ACCEPT: "accept",
        HOLD: "hold",
        REJECT: "reject"
    },
    resolutions: {
        ACCEPTED: "accepted",
        ON_HOLD: "on_hold",
        REJECTED: "rejected"
    }
};
const $1622be301bae0161$export$c4a74f263978d610 = {
    PENDING_CLIENT_LEFT: "pending_client_left",
    MEDIA_QUALITY_CHANGED: "media_quality_changed"
};
const $1622be301bae0161$export$fa3d5b535a2458a1 = {
    CLIENT_CONNECTION_STATUS_CHANGED: "client_connection_status_changed",
    STREAM_ADDED: "stream_added",
    RTC_MANAGER_CREATED: "rtc_manager_created",
    RTC_MANAGER_DESTROYED: "rtc_manager_destroyed",
    LOCAL_STREAM_TRACK_ADDED: "local_stream_track_added",
    LOCAL_STREAM_TRACK_REMOVED: "local_stream_track_removed",
    REMOTE_STREAM_TRACK_ADDED: "remote_stream_track_added",
    REMOTE_STREAM_TRACK_REMOVED: "remote_stream_track_removed"
};
const $1622be301bae0161$export$426db7a6155b7a80 = {
    CONNECTING: "connecting",
    CONNECTION_FAILED: "connection_failed",
    CONNECTION_SUCCESSFUL: "connection_successful",
    CONNECTION_DISCONNECTED: "connection_disconnected"
};
const $1622be301bae0161$var$CAMERA_STREAM_ID$1 = "0";
const $1622be301bae0161$export$ec4891ba46e62598 = {
    CAMERA: "camera",
    SCREEN_SHARE: "screen_share"
};
class $1622be301bae0161$export$8be9f14711b4bbe1 {
    setup(stream) {
        this.stream = stream;
        this.streamId = stream.id;
        this.setVideoEnabled(this.isVideoEnabled && stream.getVideoTracks().length > 0);
        this.setAudioEnabled(this.isAudioEnabled && stream.getAudioTracks().length > 0);
        return this;
    }
    setStatus(status) {
        this.status = status;
        return this;
    }
    setVideoEnabled(isEnabled) {
        this.isVideoEnabled = isEnabled;
        if (!this.stream) return;
        this.stream.getVideoTracks().forEach((track)=>{
            track.enabled = isEnabled;
        });
    }
    setAudioEnabled(isEnabled) {
        this.isAudioEnabled = isEnabled;
        if (!this.stream) return;
        this.stream.getAudioTracks().forEach((track)=>{
            track.enabled = isEnabled;
        });
    }
    static getCameraId() {
        return $1622be301bae0161$var$CAMERA_STREAM_ID$1;
    }
    static getTypeFromId(id) {
        const streamId = "" + id;
        return streamId === $1622be301bae0161$var$CAMERA_STREAM_ID$1 ? $1622be301bae0161$export$ec4891ba46e62598.CAMERA : $1622be301bae0161$export$ec4891ba46e62598.SCREEN_SHARE;
    }
    constructor(id, type){
        this.id = "" + id;
        this.type = type;
        this.isEnabled = true;
        this.hasSupportForAutoSuperSize = false;
        this.isAudioEnabled = true;
        this.isVideoEnabled = true;
        this.status = $1622be301bae0161$export$426db7a6155b7a80.CONNECTING;
        this.stream = null;
        this.streamId = null;
    }
}
const $1622be301bae0161$var$lowPixelCount = 57600;
const $1622be301bae0161$var$lowBitratePerPixel = 150000 / $1622be301bae0161$var$lowPixelCount;
const $1622be301bae0161$var$highPixelCount = 921600;
const $1622be301bae0161$var$highBitratePerPixel = 1000000 / $1622be301bae0161$var$highPixelCount;
const $1622be301bae0161$var$bitrateChangePerPixel = ($1622be301bae0161$var$highBitratePerPixel - $1622be301bae0161$var$lowBitratePerPixel) / ($1622be301bae0161$var$highPixelCount - $1622be301bae0161$var$lowPixelCount);
function $1622be301bae0161$export$a7c2590c69aa3b06(width, height, frameRate) {
    let targetPixelCount = width * height;
    if (targetPixelCount < $1622be301bae0161$var$lowPixelCount) targetPixelCount = $1622be301bae0161$var$lowPixelCount;
    if (targetPixelCount > $1622be301bae0161$var$highPixelCount) targetPixelCount = $1622be301bae0161$var$highPixelCount;
    let targetBitratePerPixel = $1622be301bae0161$var$lowBitratePerPixel;
    if (targetPixelCount > $1622be301bae0161$var$highPixelCount) targetBitratePerPixel = $1622be301bae0161$var$highBitratePerPixel;
    else if (targetPixelCount > $1622be301bae0161$var$lowPixelCount) targetBitratePerPixel += (targetPixelCount - $1622be301bae0161$var$lowPixelCount) * $1622be301bae0161$var$bitrateChangePerPixel;
    let targetBitrate = width * height * targetBitratePerPixel;
    if (frameRate <= 15) targetBitrate = targetBitrate * 0.7;
    else if (frameRate <= 24) targetBitrate = targetBitrate * 0.9;
    return targetBitrate;
}
const $1622be301bae0161$var$word = "[a-fA-F\\d:]";
const $1622be301bae0161$var$boundry = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${$1622be301bae0161$var$word})|(?<=${$1622be301bae0161$var$word})(?=\\s|$))` : "";
const $1622be301bae0161$var$v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
const $1622be301bae0161$var$v6segment = "[a-fA-F\\d]{1,4}";
const $1622be301bae0161$var$v6 = `
(?:
(?:${$1622be301bae0161$var$v6segment}:){7}(?:${$1622be301bae0161$var$v6segment}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${$1622be301bae0161$var$v6segment}:){6}(?:${$1622be301bae0161$var$v4}|:${$1622be301bae0161$var$v6segment}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){5}(?::${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){4}(?:(?::${$1622be301bae0161$var$v6segment}){0,1}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){3}(?:(?::${$1622be301bae0161$var$v6segment}){0,2}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){2}(?:(?::${$1622be301bae0161$var$v6segment}){0,3}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${$1622be301bae0161$var$v6segment}:){1}(?:(?::${$1622be301bae0161$var$v6segment}){0,4}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${$1622be301bae0161$var$v6segment}){0,5}:${$1622be301bae0161$var$v4}|(?::${$1622be301bae0161$var$v6segment}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
const $1622be301bae0161$var$v46Exact = new RegExp(`(?:^${$1622be301bae0161$var$v4}$)|(?:^${$1622be301bae0161$var$v6}$)`);
const $1622be301bae0161$var$v4exact = new RegExp(`^${$1622be301bae0161$var$v4}$`);
const $1622be301bae0161$var$v6exact = new RegExp(`^${$1622be301bae0161$var$v6}$`);
const $1622be301bae0161$export$bdfe8a6e5369c106 = (options)=>options && options.exact ? $1622be301bae0161$var$v46Exact : new RegExp(`(?:${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v4}${$1622be301bae0161$var$boundry(options)})|(?:${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v6}${$1622be301bae0161$var$boundry(options)})`, "g");
$1622be301bae0161$export$bdfe8a6e5369c106.v4 = (options)=>options && options.exact ? $1622be301bae0161$var$v4exact : new RegExp(`${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v4}${$1622be301bae0161$var$boundry(options)}`, "g");
$1622be301bae0161$export$bdfe8a6e5369c106.v6 = (options)=>options && options.exact ? $1622be301bae0161$var$v6exact : new RegExp(`${$1622be301bae0161$var$boundry(options)}${$1622be301bae0161$var$v6}${$1622be301bae0161$var$boundry(options)}`, "g");
var $1622be301bae0161$export$188476a9307fd26f = {
    CAMERA_NOT_WORKING: "camera_not_working",
    CONNECTION_BLOCKED_BY_NETWORK: "connection_blocked_by_network",
    ICE_IPV6_SEEN: "ice_ipv6_seen",
    ICE_MDNS_SEEN: "ice_mdns_seen",
    ICE_NO_PUBLIC_IP_GATHERED: "ice_no_public_ip_gathered",
    ICE_NO_PUBLIC_IP_GATHERED_3SEC: "ice_no_public_ip_gathered_3sec",
    ICE_RESTART: "ice_restart",
    MICROPHONE_NOT_WORKING: "microphone_not_working",
    MICROPHONE_STOPPED_WORKING: "microphone_stopped_working",
    CAMERA_STOPPED_WORKING: "camera_stopped_working",
    NEW_PC: "new_pc",
    SFU_CONNECTION_OPEN: "sfu_connection_open",
    SFU_CONNECTION_CLOSED: "sfu_connection_closed",
    COLOCATION_SPEAKER: "colocation_speaker",
    DOMINANT_SPEAKER: "dominant_speaker",
    PC_SLD_FAILURE: "pc_sld_failure",
    PC_ON_ANSWER_FAILURE: "pc_on_answer_failure",
    PC_ON_OFFER_FAILURE: "pc_on_offer_failure"
};
var $1622be301bae0161$var$_a$2, $1622be301bae0161$var$_b;
const $1622be301bae0161$var$adapter$2 = ($1622be301bae0161$var$_a$2 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$2 !== void 0 ? $1622be301bae0161$var$_a$2 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$4 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$ICE_PUBLIC_IP_GATHERING_TIMEOUT = 3000;
const $1622be301bae0161$var$CAMERA_STREAM_ID = $1622be301bae0161$export$8be9f14711b4bbe1.getCameraId();
const $1622be301bae0161$var$browserName$1 = $1622be301bae0161$var$adapter$2.browserDetails.browser;
const $1622be301bae0161$var$browserVersion = $1622be301bae0161$var$adapter$2.browserDetails.version;
if ($1622be301bae0161$var$browserName$1 === "firefox" && $1622be301bae0161$var$adapter$2.browserShim && "shimGetDisplayMedia" in $1622be301bae0161$var$adapter$2.browserShim) ($1622be301bae0161$var$_b = $1622be301bae0161$var$adapter$2.browserShim) === null || $1622be301bae0161$var$_b === void 0 || $1622be301bae0161$var$_b.shimGetDisplayMedia(window, "screen");
let $1622be301bae0161$var$unloading$1 = false;
if ($1622be301bae0161$var$browserName$1 === "chrome") window.document.addEventListener("beforeunload", ()=>{
    $1622be301bae0161$var$unloading$1 = true;
});
class $1622be301bae0161$export$c67bf4e001e6de2 {
    numberOfPeerconnections() {
        return Object.keys(this.peerConnections).length;
    }
    isInitializedWith({ selfId: selfId, roomName: roomName, isSfu: isSfu }) {
        return this._selfId === selfId && this._roomName === roomName && isSfu === !!this._sfuServer;
    }
    supportsScreenShareAudio() {
        return true;
    }
    maybeRestrictRelayBandwidth(session) {
        session.maybeRestrictRelayBandwidth();
    }
    addNewStream(streamId, stream, audioPaused, videoPaused, beforeEffectTracks = []) {
        if (stream === this.localStreams[streamId]) return;
        this._addLocalStream(streamId, stream);
        if (streamId === $1622be301bae0161$var$CAMERA_STREAM_ID) {
            this._addStreamToPeerConnections(stream);
            const audioTrack = stream.getAudioTracks()[0];
            const videoTrack = stream.getVideoTracks()[0];
            if (audioTrack) {
                if (!audioTrack.effectTrack) this._monitorAudioTrack(audioTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "audio");
                if (beforeEffectTrack) this._monitorAudioTrack(beforeEffectTrack);
            }
            if (videoTrack) {
                if (!videoTrack.effectTrack) this._monitorVideoTrack(videoTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "video");
                if (beforeEffectTrack) this._monitorVideoTrack(beforeEffectTrack);
            }
            if (this._localStreamDeregisterFunction) {
                this._localStreamDeregisterFunction();
                this._localStreamDeregisterFunction = null;
            }
            const localStreamHandler = (e)=>{
                const { enable: enable, track: track } = e.detail;
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            };
            stream.addEventListener("stopresumevideo", localStreamHandler);
            this._localStreamDeregisterFunction = ()=>{
                stream.removeEventListener("stopresumevideo", localStreamHandler);
            };
            return;
        }
        this._screenshareVideoTrackIds.push(stream.getVideoTracks()[0].id);
        this._shareScreen(streamId, stream);
        return;
    }
    replaceTrack(oldTrack, newTrack) {
        if (newTrack.kind === "audio" && !newTrack.effectTrack) this._monitorAudioTrack(newTrack);
        if (newTrack.kind === "video" && !newTrack.effectTrack) this._monitorVideoTrack(newTrack);
        return this._replaceTrackToPeerConnections(oldTrack, newTrack);
    }
    disconnectAll() {
        Object.keys(this.peerConnections).forEach((peerConnectionId)=>{
            this.disconnect(peerConnectionId);
        });
        this.peerConnections = {};
        this._socketListenerDeregisterFunctions.forEach((func)=>{
            func();
        });
        this._socketListenerDeregisterFunctions = [];
        if (this._localStreamDeregisterFunction) {
            this._localStreamDeregisterFunction();
            this._localStreamDeregisterFunction = null;
        }
    }
    fixChromeAudio(constraints) {
        if ($1622be301bae0161$var$browserName$1 !== "chrome") return;
        const localStream = this._getLocalCameraStream();
        const audioTrack = localStream.getAudioTracks()[0];
        if (!audioTrack || audioTrack.readyState !== "ended") return;
        return navigator.mediaDevices.getUserMedia({
            audio: constraints
        }).then((stream)=>{
            const track = stream.getAudioTracks()[0];
            track.enabled = audioTrack.enabled;
            localStream.removeTrack(audioTrack);
            localStream.addTrack(track);
            return this.replaceTrack(audioTrack, track);
        });
    }
    setupSocketListeners() {
        this._socketListenerDeregisterFunctions = [
            ()=>this._clearMediaServersRefresh(),
            this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.MEDIASERVER_CONFIG, (data)=>{
                if (data.error) {
                    $1622be301bae0161$var$logger$4.warn("FETCH_MEDIASERVER_CONFIG failed:", data.error);
                    return;
                }
                this._updateAndScheduleMediaServersRefresh(data);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.READY_TO_RECEIVE_OFFER, (data)=>{
                this._connect(data.clientId);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.ICE_CANDIDATE, (data)=>{
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on ICE_CANDIDATE", data);
                    return;
                }
                session.addIceCandidate(data.message);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.ICE_END_OF_CANDIDATES, (data)=>{
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on ICE_END_OF_CANDIDATES", data);
                    return;
                }
                session.addIceCandidate(null);
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.SDP_OFFER, (data)=>{
                var _a, _b;
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on SDP_OFFER", data);
                    return;
                }
                const offer = this._transformIncomingSdp(data.message, session.pc);
                (_b = (_a = session.handleOffer(offer).then((answer)=>{
                    this._emitServerEvent($1622be301bae0161$export$83849580da009913.SDP_ANSWER, {
                        receiverId: data.clientId,
                        message: this._transformOutgoingSdp(answer)
                    });
                })).catch) === null || _b === void 0 || _b.call(_a, (e)=>{
                    this._emit($1622be301bae0161$export$188476a9307fd26f.PC_ON_OFFER_FAILURE, e);
                });
            }),
            this._serverSocket.on($1622be301bae0161$export$83849580da009913.SDP_ANSWER, (data)=>{
                var _a, _b;
                const session = this._getSession(data.clientId);
                if (!session) {
                    $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection on SDP_ANSWER", data);
                    return;
                }
                const answer = this._transformIncomingSdp(data.message, session.pc);
                (_b = (_a = session.handleAnswer(answer)) === null || _a === void 0 ? void 0 : _a.catch) === null || _b === void 0 || _b.call(_a, (e)=>{
                    this._emit($1622be301bae0161$export$188476a9307fd26f.PC_ON_ANSWER_FAILURE, e);
                });
            }),
            this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ({ room: { sfuServer: isSfu } })=>{
                if (isSfu || !this._wasScreenSharing) return;
                const screenShareStreamId = Object.keys(this.localStreams).find((id)=>id !== $1622be301bae0161$var$CAMERA_STREAM_ID);
                if (!screenShareStreamId) return;
                const screenshareStream = this.localStreams[screenShareStreamId];
                if (!screenshareStream) {
                    $1622be301bae0161$var$logger$4.warn("screenshare stream %s not found", screenShareStreamId);
                    return;
                }
                const hasAudioTrack = screenshareStream.getAudioTracks().length > 0;
                this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
                    streamId: screenShareStreamId,
                    hasAudioTrack: hasAudioTrack
                });
            })
        ];
    }
    sendAudioMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    }
    sendVideoMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    }
    sendStatsCustomEvent(eventName, data) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent(eventName, data);
    }
    rtcStatsDisconnect() {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.close();
    }
    rtcStatsReconnect() {
        if (!$1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connected) $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connect();
    }
    setAudioOnly(audioOnly) {
        this._isAudioOnlyMode = audioOnly;
        this._forEachPeerConnection((session)=>{
            if (session.hasConnectedPeerConnection()) this._withForcedRenegotiation(session, ()=>session.setAudioOnly(this._isAudioOnlyMode, this._screenshareVideoTrackIds));
        });
    }
    setRemoteScreenshareVideoTrackIds(remoteScreenshareVideoTrackIds = []) {
        const localScreenshareStream = this._getFirstLocalNonCameraStream();
        this._screenshareVideoTrackIds = [
            ...(localScreenshareStream === null || localScreenshareStream === void 0 ? void 0 : localScreenshareStream.track) ? [
                localScreenshareStream.track.id
            ] : [],
            ...remoteScreenshareVideoTrackIds
        ];
    }
    setRoomSessionId(roomSessionId) {
        this._roomSessionId = roomSessionId;
    }
    _setConnectionStatus(session, newStatus, clientId) {
        const previousStatus = session.connectionStatus;
        if (previousStatus === newStatus) return;
        if (session.peerConnectionId === this._selfId) return;
        if (previousStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_DISCONNECTED && newStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTING) return;
        session.connectionStatus = newStatus;
        setTimeout(()=>{
            this._emit($1622be301bae0161$export$fa3d5b535a2458a1.CLIENT_CONNECTION_STATUS_CHANGED, {
                streamIds: session.streamIds,
                clientId: clientId,
                status: newStatus,
                previous: previousStatus
            });
        }, 0);
    }
    _setJitterBufferTarget(pc) {
        try {
            const receivers = pc.getReceivers();
            receivers.forEach((receiver)=>{
                receiver.jitterBufferTarget = $1622be301bae0161$export$87d0694e432db510;
                receiver.playoutDelayHint = $1622be301bae0161$export$87d0694e432db510 / 1000;
            });
        } catch (error) {
            $1622be301bae0161$var$logger$4.error("Error during setting jitter buffer target:", error);
        }
    }
    _emitServerEvent(eventName, data, callback) {
        this._serverSocket.emit(eventName, data, callback);
    }
    _emit(eventName, data) {
        this._emitter.emit(eventName, data);
    }
    _addEnabledLocalStreamId(streamId) {
        this.enabledLocalStreamIds.push(streamId);
    }
    _deleteEnabledLocalStreamId(streamId) {
        const index = this.enabledLocalStreamIds.indexOf(streamId);
        if (index !== -1) this.enabledLocalStreamIds.splice(index, 1);
    }
    _getSession(peerConnectionId) {
        if (!(peerConnectionId in this.peerConnections)) return null;
        return this.peerConnections[peerConnectionId];
    }
    _getOrCreateSession(peerConnectionId, initialBandwidth) {
        let session = this.peerConnections[peerConnectionId];
        if (session === undefined) {
            const deprioritizeH264Encoding = $1622be301bae0161$var$browserName$1 === "safari" && $1622be301bae0161$var$browserVersion && $1622be301bae0161$var$browserVersion >= 14 && this._features.deprioritizeH264OnSafari;
            this.peerConnections[peerConnectionId] = session = new $1622be301bae0161$export$1fb4852a55678982({
                peerConnectionId: peerConnectionId,
                bandwidth: initialBandwidth,
                maximumTurnBandwidth: this._features.unlimitedBandwidthWhenUsingRelayP2POn ? $1622be301bae0161$export$6bb71afef3ab9ece : $1622be301bae0161$export$737bc7bda2eb5bf5,
                deprioritizeH264Encoding: deprioritizeH264Encoding
            });
            this.totalSessionsCreated++;
        }
        return session;
    }
    _getLocalCameraStream() {
        return this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
    }
    _getNonLocalCameraStreamIds() {
        return Object.keys(this.localStreams).filter((streamId)=>streamId !== $1622be301bae0161$var$CAMERA_STREAM_ID);
    }
    _isScreensharingLocally() {
        return this._getNonLocalCameraStreamIds().length > 0;
    }
    _getFirstLocalNonCameraStream() {
        const streamIds = this._getNonLocalCameraStreamIds();
        return streamIds.length === 0 ? null : this.localStreams[streamIds[0]];
    }
    _transformIncomingSdp(original, _) {
        return {
            type: original.type,
            sdp: original.sdpU
        };
    }
    _transformOutgoingSdp(original) {
        return {
            type: original.type,
            sdpU: original.sdp
        };
    }
    _createSession({ clientId: clientId, initialBandwidth: initialBandwidth, isOfferer: isOfferer, peerConnectionId: peerConnectionId, shouldAddLocalVideo: shouldAddLocalVideo }) {
        if (!peerConnectionId) throw new Error("peerConnectionId is missing");
        if (!clientId) throw new Error("clientId is missing");
        const session = this._getOrCreateSession(peerConnectionId, initialBandwidth);
        const constraints = {
            optional: []
        };
        if ($1622be301bae0161$var$browserName$1 === "chrome") constraints.optional.push({
            googCpuOveruseDetection: true
        });
        constraints.optional.push({
            rtcStatsRoomSessionId: this._roomSessionId
        });
        constraints.optional.push({
            rtcStatsClientId: this._selfId
        });
        constraints.optional.push({
            rtcStatsPeerId: peerConnectionId
        });
        constraints.optional.push({
            rtcStatsConferenceId: this._roomName
        });
        const peerConnectionConfig = {
            iceServers: this._iceServers
        };
        if (this._features.turnServerOverrideHost) {
            const host = this._features.turnServerOverrideHost;
            const port = host.indexOf(":") > 0 ? "" : ":443";
            const override = ":" + host + port;
            peerConnectionConfig.iceServers = peerConnectionConfig.iceServers.map((original)=>{
                const entry = Object.assign({}, original);
                if (entry.url) entry.url = entry.url.replace(/:[^?]*/, override);
                if (entry.urls) entry.urls = entry.urls.map((url)=>url.replace(/:[^?]*/, override));
                return entry;
            });
        }
        if (this._features.useOnlyTURN) {
            peerConnectionConfig.iceTransportPolicy = "relay";
            const filter = {
                onlyudp: /^turn:.*transport=udp$/,
                onlytcp: /^turn:.*transport=tcp$/,
                onlytls: /^turns:.*transport=tcp$/
            }[this._features.useOnlyTURN];
            if (filter) peerConnectionConfig.iceServers = peerConnectionConfig.iceServers.filter((entry)=>entry.url && entry.url.match(filter));
        }
        if ($1622be301bae0161$var$browserName$1 === "chrome") peerConnectionConfig.sdpSemantics = "unified-plan";
        const pc = session.setAndGetPeerConnection({
            constraints: constraints,
            peerConnectionConfig: peerConnectionConfig,
            shouldAddLocalVideo: shouldAddLocalVideo,
            clientId: clientId
        });
        setTimeout(()=>this._emit($1622be301bae0161$export$188476a9307fd26f.NEW_PC), 0);
        pc.ontrack = (event)=>{
            const stream = event.streams[0];
            if (stream.id === "default" && stream.getAudioTracks().length === 0) return;
            if (session.streamIds.indexOf(stream.id) === -1) {
                session.streamIds.push(stream.id);
                this._emit($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                    clientId: clientId,
                    stream: stream
                });
                if (session.connectionStatus === $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_SUCCESSFUL) setTimeout(()=>{
                    this._emit($1622be301bae0161$export$fa3d5b535a2458a1.CLIENT_CONNECTION_STATUS_CHANGED, {
                        streamIds: session.streamIds,
                        clientId: clientId,
                        status: session.connectionStatus,
                        previous: $1622be301bae0161$export$426db7a6155b7a80.CONNECTING
                    });
                }, 0);
            }
        };
        pc.oniceconnectionstatechange = ()=>{
            let newStatus;
            const currentStatus = session.connectionStatus;
            switch(pc.iceConnectionState){
                case "checking":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTING;
                    break;
                case "connected":
                case "completed":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_SUCCESSFUL;
                    if (!session.wasEverConnected) {
                        this._pendingActionsForConnectedPeerConnections.forEach((action)=>{
                            if (typeof action === "function") action();
                        });
                        this._pendingActionsForConnectedPeerConnections = [];
                    }
                    if (!session.wasEverConnected && (pc.iceConnectionState.match(/connected|completed/) || $1622be301bae0161$var$browserName$1 === "chrome" && pc.localDescription && pc.localDescription.type === "answer")) {
                        session.wasEverConnected = true;
                        if (this._features.bandwidth !== "false") this.maybeRestrictRelayBandwidth(session);
                    }
                    if (this._isAudioOnlyMode) session.setAudioOnly(true, this._screenshareVideoTrackIds);
                    session.registerConnected();
                    break;
                case "disconnected":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_DISCONNECTED;
                    setTimeout(()=>{
                        if (pc.iceConnectionState === "disconnected") this._maybeRestartIce(clientId, session);
                    }, 2000);
                    break;
                case "failed":
                    newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_FAILED;
                    if (currentStatus !== newStatus) this._maybeRestartIce(clientId, session);
                    if (session.relayCandidateSeen === null && !session.wasEverConnected) this._emit($1622be301bae0161$export$188476a9307fd26f.CONNECTION_BLOCKED_BY_NETWORK);
                    break;
                default:
                    return;
            }
            this._setConnectionStatus(session, newStatus, clientId);
        };
        pc.onconnectionstate = ()=>{
            switch(pc.connectionState){
                case "connected":
                    setTimeout(()=>{
                        $1622be301bae0161$export$60abf66a104f71b0(session.pc).then((failureDirection)=>{
                            if (failureDirection !== false) this._emit($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_NOT_WORKING, {
                                failureDirection: failureDirection,
                                clientId: clientId
                            });
                        });
                    }, 3000);
                    session.registerConnected();
                    break;
                case "failed":
                    const newStatus = $1622be301bae0161$export$426db7a6155b7a80.CONNECTION_FAILED;
                    if (session.relayCandidateSeen === null && !session.wasEverConnected) this._emit($1622be301bae0161$export$188476a9307fd26f.CONNECTION_BLOCKED_BY_NETWORK);
                    this._setConnectionStatus(session, newStatus, clientId);
                    break;
            }
        };
        const localCameraStream = this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
        if (shouldAddLocalVideo && localCameraStream) session.addStream(localCameraStream);
        if (shouldAddLocalVideo) Object.keys(this.localStreams).forEach((id)=>{
            if (id === $1622be301bae0161$var$CAMERA_STREAM_ID) return;
            const screenshareStream = this.localStreams[id];
            if (isOfferer) session.addStream(screenshareStream);
            else session.afterConnected.then(()=>{
                this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
                    receiverId: session.clientId,
                    streamId: screenshareStream.id,
                    hasAudioTrack: !!screenshareStream.getAudioTracks().length
                });
                this._withForcedRenegotiation(session, ()=>session.addStream(screenshareStream));
            });
        });
        return session;
    }
    _cleanup(peerConnectionId) {
        const session = this._getSession(peerConnectionId);
        if (!session) {
            $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection in RTCManager.disconnect()", peerConnectionId);
            return;
        }
        session.close();
        delete this.peerConnections[peerConnectionId];
    }
    _forEachPeerConnection(func) {
        Object.values(this.peerConnections).forEach((peerConnection)=>{
            func(peerConnection);
        });
    }
    _addStreamToPeerConnections(stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.addStream(stream));
        });
    }
    _addTrackToPeerConnections(track, stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.addTrack(track, stream));
        });
    }
    _replaceTrackToPeerConnections(oldTrack, newTrack) {
        const promises = [];
        this._forEachPeerConnection((session)=>{
            if (!session.hasConnectedPeerConnection()) {
                $1622be301bae0161$var$logger$4.info("Session doesn't have a connected PeerConnection, adding pending action!");
                const pendingActions = this._pendingActionsForConnectedPeerConnections;
                if (!pendingActions) {
                    $1622be301bae0161$var$logger$4.warn(`No pending action is created to repalce track, because the pending actions array is null`);
                    return;
                }
                const promise = new Promise((resolve, reject)=>{
                    const action = ()=>{
                        const replacedTrackPromise = session.replaceTrack(oldTrack, newTrack);
                        if (!replacedTrackPromise) {
                            $1622be301bae0161$var$logger$4.error("replaceTrack returned false!");
                            reject(`ReplaceTrack returned false`);
                            return;
                        }
                        replacedTrackPromise.then((track)=>resolve(track)).catch((error)=>reject(error));
                    };
                    pendingActions.push(action);
                });
                promises.push(promise);
                return;
            }
            const replacedTrackResult = session.replaceTrack(oldTrack, newTrack);
            if (!replacedTrackResult) {
                $1622be301bae0161$var$logger$4.error("replaceTrack returned false!");
                return;
            }
            promises.push(replacedTrackResult);
        });
        return Promise.all(promises);
    }
    _removeStreamFromPeerConnections(stream) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.removeStream(stream));
        });
    }
    _removeTrackFromPeerConnections(track) {
        this._forEachPeerConnection((session)=>{
            this._withForcedRenegotiation(session, ()=>session.removeTrack(track));
        });
    }
    _addLocalStream(streamId, stream) {
        this._addEnabledLocalStreamId(streamId);
        this.localStreams[streamId] = stream;
    }
    _removeLocalStream(streamId) {
        delete this.localStreams[streamId];
        this._deleteEnabledLocalStreamId(streamId);
    }
    _updateAndScheduleMediaServersRefresh({ iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds }) {
        this._iceServers = iceServers;
        this._sfuServer = sfuServer;
        this._mediaserverConfigTtlSeconds = mediaserverConfigTtlSeconds;
        this._clearMediaServersRefresh();
        if (!mediaserverConfigTtlSeconds) return;
        this._fetchMediaServersTimer = setTimeout(()=>this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.FETCH_MEDIASERVER_CONFIG), mediaserverConfigTtlSeconds * 1000);
    }
    _clearMediaServersRefresh() {
        if (!this._fetchMediaServersTimer) return;
        clearTimeout(this._fetchMediaServersTimer);
        this._fetchMediaServersTimer = null;
    }
    _monitorAudioTrack(track) {
        var _a, _b;
        if (((_a = this._audioTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._audioTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._audioTrackOnEnded);
        track.addEventListener("ended", this._audioTrackOnEnded);
        this._audioTrackBeingMonitored = track;
    }
    _monitorVideoTrack(track) {
        var _a, _b;
        if (((_a = this._videoTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._videoTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._videoTrackOnEnded);
        track.addEventListener("ended", this._videoTrackOnEnded);
        this._videoTrackBeingMonitored = track;
    }
    _connect(clientId) {
        let session = this._getSession(clientId);
        let initialBandwidth = session && session.bandwidth || 0;
        if (session) {
            $1622be301bae0161$var$logger$4.warn("Replacing peer session", clientId);
            this._cleanup(clientId);
        } else initialBandwidth = this._changeBandwidthForAllClients(true);
        session = this._createP2pSession({
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: true,
            isOfferer: true
        });
        this._negotiatePeerConnection(clientId, session);
        return Promise.resolve(session);
    }
    _maybeRestartIce(clientId, session) {
        const pc = session.pc;
        if (!(pc.iceConnectionState === "disconnected" || pc.iceConnectionState === "failed")) return;
        if (pc.localDescription.type === "offer") {
            session.wasEverConnected = false;
            session.relayCandidateSeen = false;
            session.serverReflexiveCandidateSeen = false;
            session.publicHostCandidateSeen = false;
            session.ipv6HostCandidateSeen = false;
            this.ipv6HostCandidateTeredoSeen = false;
            this.ipv6HostCandidate6to4Seen = false;
            this.mdnsHostCandidateSeen = false;
            this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_RESTART);
            this._negotiatePeerConnection(clientId, session, Object.assign({}, this.offerOptions, {
                iceRestart: true
            }));
        }
    }
    _setCodecPreferences(pc, vp9On, av1On, redOn) {
        try {
            const audioTransceivers = pc.getTransceivers().filter((transceiver)=>{
                var _a, _b;
                return ((_b = (_a = transceiver === null || transceiver === void 0 ? void 0 : transceiver.sender) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "audio";
            });
            audioTransceivers.forEach((audioTransceiver)=>{
                if (typeof RTCRtpSender.getCapabilities === "undefined") return;
                const capabilities = RTCRtpSender.getCapabilities("audio");
                for(let i = 0; i < capabilities.codecs.length; i++)if (redOn && capabilities.codecs[i].mimeType.toLowerCase() === "audio/red") {
                    capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                    break;
                }
                if (typeof audioTransceiver.setCodecPreferences === "undefined") return;
                audioTransceiver.setCodecPreferences(capabilities.codecs);
            });
            const videoTransceivers = pc.getTransceivers().filter((transceiver)=>{
                var _a, _b;
                return ((_b = (_a = transceiver === null || transceiver === void 0 ? void 0 : transceiver.sender) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.kind) === "video";
            });
            videoTransceivers.forEach((videoTransceiver)=>{
                if (RTCRtpSender.getCapabilities === undefined) return;
                const capabilities = RTCRtpSender.getCapabilities("video");
                for(let i = 0; i < capabilities.codecs.length; i++){
                    if (vp9On && capabilities.codecs[i].mimeType.toLowerCase() === "video/vp9") {
                        capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                        break;
                    }
                    if (av1On && capabilities.codecs[i].mimeType.toLowerCase() === "video/av1") {
                        capabilities.codecs.unshift(capabilities.codecs.splice(i, 1)[0]);
                        break;
                    }
                }
                if (videoTransceiver.setCodecPreferences === undefined) return;
                videoTransceiver.setCodecPreferences(capabilities.codecs);
            });
        } catch (error) {
            $1622be301bae0161$var$logger$4.error("Error during setting setCodecPreferences:", error);
        }
    }
    _negotiatePeerConnection(clientId, session, constraints) {
        if (!session) {
            $1622be301bae0161$var$logger$4.warn("No RTCPeerConnection in negotiatePeerConnection()", clientId);
            return;
        }
        const pc = session.pc;
        if (!session.canModifyPeerConnection()) {
            session.pending.push(()=>{
                this._negotiatePeerConnection(clientId, session, constraints);
            });
            return;
        }
        session.isOperationPending = true;
        const { vp9On: vp9On, av1On: av1On, redOn: redOn, rtpAbsCaptureTimeOn: rtpAbsCaptureTimeOn, cleanSdpOn: cleanSdpOn } = this._features;
        if (vp9On || av1On || redOn) this._setCodecPreferences(pc, vp9On, av1On, redOn);
        pc.createOffer(constraints || this.offerOptions).then((offer)=>{
            if (rtpAbsCaptureTimeOn) offer.sdp = $1622be301bae0161$export$eb32cdfe1ef3eb9c(offer.sdp);
            if ((vp9On || redOn) && $1622be301bae0161$var$browserName$1 === "firefox") offer.sdp = $1622be301bae0161$export$e6fb7443cbdf2b8b(offer.sdp, vp9On, redOn);
            if (cleanSdpOn) offer.sdp = $1622be301bae0161$export$529db98703a04dea(offer.sdp);
            pc.setLocalDescription(offer).catch((e)=>{
                $1622be301bae0161$var$logger$4.warn("RTCPeerConnection.setLocalDescription() failed with local offer", e);
                this._emit($1622be301bae0161$export$188476a9307fd26f.PC_SLD_FAILURE, e);
                throw e;
            }).then(()=>{
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.SDP_OFFER, {
                    receiverId: clientId,
                    message: this._transformOutgoingSdp(offer)
                });
            });
        }).catch((e)=>{
            $1622be301bae0161$var$logger$4.warn("RTCPeerConnection.createOffer() failed to create local offer", e);
        });
    }
    _withForcedRenegotiation(session, action) {
        const pc = session.pc;
        const originalOnnegotationneeded = pc.onnegotationneeded;
        pc.onnegotiationneeded = null;
        action();
        this._negotiatePeerConnection(session.clientId, session);
        setTimeout(()=>pc.onnegotiationneeded = originalOnnegotationneeded, 0);
    }
    _changeBandwidthForAllClients(isJoining) {
        let numPeers = this.numberOfPeerconnections();
        if (isJoining) numPeers += 1;
        if (numPeers === 0) return 0;
        if (numPeers > 7) numPeers = 7;
        let bandwidth = this._features.bandwidth ? parseInt(this._features.bandwidth, 10) : ({
            1: 0,
            2: this._features.highP2PBandwidth ? 768 : 384,
            3: this._features.highP2PBandwidth ? 512 : 256,
            4: 192,
            5: 128,
            6: 128,
            7: 64
        })[numPeers];
        if (bandwidth === undefined) return 0;
        if (this._features.adjustBitratesFromResolution) {
            const cameraStream = this._getLocalCameraStream();
            if (cameraStream) {
                const cameraTrack = cameraStream && cameraStream.getVideoTracks()[0];
                if (cameraTrack) {
                    const { width: width, height: height, frameRate: frameRate } = cameraTrack.getSettings();
                    if (width && height && frameRate) {
                        const optimalBandwidth = Math.round($1622be301bae0161$export$a7c2590c69aa3b06(width, height, frameRate) / 1000);
                        bandwidth = Math.min(optimalBandwidth, bandwidth || optimalBandwidth);
                    }
                }
            }
        }
        if (this._features.higherP2PBitrates) bandwidth = bandwidth * 1.5;
        this._forEachPeerConnection((session)=>{
            session.changeBandwidth(bandwidth);
        });
        return bandwidth;
    }
    _createP2pSession({ clientId: clientId, initialBandwidth: initialBandwidth, shouldAddLocalVideo: shouldAddLocalVideo = false, isOfferer: isOfferer = false }) {
        const session = this._createSession({
            peerConnectionId: clientId,
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: shouldAddLocalVideo,
            isOfferer: isOfferer
        });
        const pc = session.pc;
        if (this._features.increaseIncomingMediaBufferOn) this._setJitterBufferTarget(pc);
        const localCameraStream = this.localStreams[$1622be301bae0161$var$CAMERA_STREAM_ID];
        if (shouldAddLocalVideo && localCameraStream && !localCameraStream.getVideoTracks().length && this._stoppedVideoTrack) pc.addTrack(this._stoppedVideoTrack, localCameraStream);
        pc.onicegatheringstatechange = (event)=>{
            const connection = event.target;
            switch(connection.iceGatheringState){
                case "gathering":
                    if (this.icePublicIPGatheringTimeoutID) clearTimeout(this.icePublicIPGatheringTimeoutID);
                    this.icePublicIPGatheringTimeoutID = setTimeout(()=>{
                        if (!session.publicHostCandidateSeen && !session.relayCandidateSeen && !session.serverReflexiveCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_NO_PUBLIC_IP_GATHERED_3SEC);
                    }, $1622be301bae0161$var$ICE_PUBLIC_IP_GATHERING_TIMEOUT);
                    break;
                case "complete":
                    if (this.icePublicIPGatheringTimeoutID) clearTimeout(this.icePublicIPGatheringTimeoutID);
                    this.icePublicIPGatheringTimeoutID = undefined;
                    break;
            }
        };
        pc.onicecandidate = (event)=>{
            var _a, _b;
            if (event.candidate) {
                switch((_a = event.candidate) === null || _a === void 0 ? void 0 : _a.type){
                    case "host":
                        const address = (_b = event === null || event === void 0 ? void 0 : event.candidate) === null || _b === void 0 ? void 0 : _b.address;
                        try {
                            if ($1622be301bae0161$export$bdfe8a6e5369c106.v4({
                                exact: true
                            }).test(address)) {
                                const ipv4 = (0, (/*@__PURE__*/$parcel$interopDefault($1ecbb2f73dbf2ce4$exports)))(address);
                                if (ipv4.isPublicIp) session.publicHostCandidateSeen = true;
                            } else if ($1622be301bae0161$export$bdfe8a6e5369c106.v6({
                                exact: true
                            }).test(address.replace(/^\[(.*)\]/, "$1"))) {
                                const ipv6 = new (0, $fcb6503f150ed464$exports.Address6)(address.replace(/^\[(.*)\]/, "$1"));
                                session.ipv6HostCandidateSeen = true;
                                if (ipv6.getScope() === "Global") session.publicHostCandidateSeen = true;
                                if (ipv6.isTeredo()) session.ipv6HostCandidateTeredoSeen = true;
                                if (ipv6.is6to4()) session.ipv6HostCandidate6to4Seen = true;
                            } else {
                                const uuidv4 = address.replace(/.local/, "");
                                if (uuidv4 && (0, (/*@__PURE__*/$parcel$interopDefault($8c12fcb2a8b6be0e$exports)))(uuidv4, 4)) session.mdnsHostCandidateSeen = true;
                            }
                        } catch (error) {
                            $1622be301bae0161$var$logger$4.info("Error during parsing candidates! Error: ", {
                                error: error
                            });
                        }
                        break;
                    case "srflx":
                        if (!session.serverReflexiveCandidateSeen) session.serverReflexiveCandidateSeen = true;
                        break;
                    case "relay":
                    case "relayed":
                        if (!session.relayCandidateSeen) session.relayCandidateSeen = true;
                        break;
                }
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.ICE_CANDIDATE, {
                    receiverId: clientId,
                    message: event.candidate
                });
            } else {
                this._emitServerEvent($1622be301bae0161$export$83849580da009913.ICE_END_OF_CANDIDATES, {
                    receiverId: clientId
                });
                if (!session.publicHostCandidateSeen && !session.relayCandidateSeen && !session.serverReflexiveCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_NO_PUBLIC_IP_GATHERED);
                if (session.ipv6HostCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_IPV6_SEEN, {
                    teredoSeen: session.ipv6HostCandidateTeredoSeen,
                    sixtofourSeen: session.ipv6HostCandidate6to4Seen
                });
                if (session.mdnsHostCandidateSeen) this._emit($1622be301bae0161$export$188476a9307fd26f.ICE_MDNS_SEEN);
            }
        };
        pc.onnegotiationneeded = ()=>{
            if (pc.iceConnectionState === "new" || !session.connectionStatus) return;
            this._negotiatePeerConnection(clientId, session);
        };
        return session;
    }
    acceptNewStream({ streamId: streamId, clientId: clientId, shouldAddLocalVideo: shouldAddLocalVideo }) {
        let session = this._getSession(clientId);
        if (session && streamId !== clientId) return session;
        let initialBandwidth = session && session.bandwidth || 0;
        if (session) {
            $1622be301bae0161$var$logger$4.warn("Replacing peer session", clientId);
            this._cleanup(clientId);
        } else initialBandwidth = this._changeBandwidthForAllClients(true);
        session = this._createP2pSession({
            clientId: clientId,
            initialBandwidth: initialBandwidth,
            shouldAddLocalVideo: !!shouldAddLocalVideo,
            isOfferer: false
        });
        this._emitServerEvent($1622be301bae0161$export$83849580da009913.READY_TO_RECEIVE_OFFER, {
            receiverId: clientId
        });
        return session;
    }
    disconnect(clientId) {
        this._cleanup(clientId);
        this._changeBandwidthForAllClients(false);
        const numPeers = this.numberOfPeerconnections();
        if (numPeers === 0) setTimeout(()=>{
            const numPeers = this.numberOfPeerconnections();
            if (numPeers === 0) this.rtcStatsDisconnect();
        }, 60000);
    }
    updateStreamResolution() {}
    stopOrResumeAudio() {}
    _handleStopOrResumeVideo({ enable: enable, track: track }) {
        if (!enable) this._stoppedVideoTrack = track;
        else if (this._stoppedVideoTrack) {
            this._replaceTrackToPeerConnections(this._stoppedVideoTrack, track);
            delete this._stoppedVideoTrack;
        } else this._addTrackToPeerConnections(track);
    }
    stopOrResumeVideo(localStream, enable) {
        var _a;
        if (![
            "chrome",
            "safari"
        ].includes($1622be301bae0161$var$browserName$1)) return;
        if (enable === false) {
            const stopCameraDelay = ((_a = localStream.getVideoTracks().find((t)=>!t.enabled)) === null || _a === void 0 ? void 0 : _a.readyState) === "ended" ? 0 : 5000;
            setTimeout(()=>{
                localStream.getVideoTracks().forEach((track)=>{
                    if (track.enabled === false) {
                        track.stop();
                        localStream.removeTrack(track);
                        this._emit($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_REMOVED, {
                            stream: localStream,
                            track: track
                        });
                        this._handleStopOrResumeVideo({
                            enable: enable,
                            track: track
                        });
                    }
                });
            }, stopCameraDelay);
        } else if (localStream.getVideoTracks().length === 0) {
            const constraints = this._webrtcProvider.getMediaConstraints().video;
            if (!constraints) return;
            navigator.mediaDevices.getUserMedia({
                video: constraints
            }).then((stream)=>{
                const track = stream.getVideoTracks()[0];
                localStream.addTrack(track);
                this._monitorVideoTrack(track);
                this._emit($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_ADDED, {
                    streamId: localStream.id,
                    tracks: [
                        track
                    ],
                    screenShare: false
                });
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            });
        }
    }
    _shareScreen(streamId, stream) {
        this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
            streamId: streamId,
            hasAudioTrack: !!stream.getAudioTracks().length
        });
        this._wasScreenSharing = true;
        this._addStreamToPeerConnections(stream);
    }
    removeStream(streamId, stream, requestedByClientId) {
        this._removeLocalStream(streamId);
        this._removeStreamFromPeerConnections(stream);
        this._wasScreenSharing = false;
        this._emitServerEvent($1622be301bae0161$export$1ea784ac1a0f1fca.STOP_SCREENSHARE, {
            streamId: streamId,
            requestedByClientId: requestedByClientId
        });
    }
    hasClient(clientId) {
        return Object.keys(this.peerConnections).includes(clientId);
    }
    constructor({ selfId: selfId, room: room, emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features }){
        const { name: name, session: session, iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds } = room;
        this._selfId = selfId;
        this._roomName = name;
        this._roomSessionId = session && session.id;
        this.peerConnections = {};
        this.localStreams = {};
        this.enabledLocalStreamIds = [];
        this._screenshareVideoTrackIds = [];
        this._socketListenerDeregisterFunctions = [];
        this._localStreamDeregisterFunction = null;
        this._emitter = emitter;
        this._serverSocket = serverSocket;
        this._webrtcProvider = webrtcProvider;
        this._features = features || {};
        this._isAudioOnlyMode = false;
        this.offerOptions = {
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        };
        this._pendingActionsForConnectedPeerConnections = [];
        this._audioTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_ended", {
                unloading: $1622be301bae0161$var$unloading$1
            });
            this._emit($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_STOPPED_WORKING, {});
        };
        this._videoTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_ended", {
                unloading: $1622be301bae0161$var$unloading$1
            });
            this._emit($1622be301bae0161$export$188476a9307fd26f.CAMERA_STOPPED_WORKING, {});
        };
        this._updateAndScheduleMediaServersRefresh({
            sfuServer: sfuServer,
            iceServers: iceServers.iceServers || [],
            mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds
        });
        this.totalSessionsCreated = 0;
    }
}
class $1622be301bae0161$export$c449b73d128b1370 {
    filter(z, u = 0) {
        if (isNaN(this.x)) {
            this.x = 1 / this.C * z;
            this.cov = 1 / this.C * this.Q * (1 / this.C);
        } else {
            const predX = this.predict(u);
            const predCov = this.uncertainty();
            const K = predCov * this.C * (1 / (this.C * predCov * this.C + this.Q));
            this.x = predX + K * (z - this.C * predX);
            this.cov = predCov - K * this.C * predCov;
        }
        return this.x;
    }
    predict(u = 0) {
        return this.A * this.x + this.B * u;
    }
    uncertainty() {
        return this.A * this.cov * this.A + this.R;
    }
    lastMeasurement() {
        return this.x;
    }
    setMeasurementNoise(noise) {
        this.Q = noise;
    }
    setProcessNoise(noise) {
        this.R = noise;
    }
    constructor({ R: R = 0.01, Q: Q = 2, A: A = 1.1, B: B = 1, C: C = 1.2 } = {
        R: 0.01,
        Q: 2,
        A: 1.1,
        B: 1,
        C: 1.2
    }){
        this.R = R;
        this.Q = Q;
        this.A = A;
        this.C = C;
        this.B = B;
        this.cov = NaN;
        this.x = NaN;
    }
}
const $1622be301bae0161$export$9d693fe1516c2cb1 = ()=>{
    let ewma = -1;
    let lastMax = 0;
    let counter = 0;
    return (arr)=>{
        const max = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
        if (ewma < 0) ewma = max;
        else ewma = ewma * 0.95 + max * 0.05;
        if (++counter < 2) {
            lastMax = max;
            return 0;
        }
        const acf = (max - ewma) * (lastMax - ewma);
        lastMax = max;
        return acf;
    };
};
const $1622be301bae0161$export$2edc519377674578 = (arr)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return arr.reduce((acc, val)=>acc.concat(Math.pow(val - mean, 2)), []).reduce((acc, val)=>acc + val, 0) / arr.length;
};
const $1622be301bae0161$export$3cc65d9d108eb4e1 = (arr)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return {
        mean: mean,
        SD: Math.sqrt(arr.reduce((acc, val)=>acc + Math.pow(val - mean, 2), 0) / arr.length)
    };
};
const $1622be301bae0161$export$9b77da0927470c3d = (arr, usePopulation = false)=>{
    const mean = arr.reduce((acc, val)=>acc + val, 0) / arr.length;
    return arr.reduce((acc, val)=>acc.concat(Math.pow(val - mean, 2)), []).reduce((acc, val)=>acc + val, 0) / (arr.length - (usePopulation ? 0 : 1));
};
var $1622be301bae0161$var$scriptFunctions = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    KalmanFilter: $1622be301bae0161$export$c449b73d128b1370,
    calculateStd: $1622be301bae0161$export$2edc519377674578,
    createACFCalculator: $1622be301bae0161$export$9d693fe1516c2cb1,
    standardDeviation: $1622be301bae0161$export$3cc65d9d108eb4e1,
    variance: $1622be301bae0161$export$9b77da0927470c3d
});
const $1622be301bae0161$var$defaultParams = {
    minDecibels: -80,
    maxDecibels: -10,
    smoothingTimeConstant: 0.8,
    aggSize: 1,
    sampleRate: 10,
    reportRate: 2,
    bins: 32,
    bands: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ]
    ],
    separateTrack: {
        autoGainControl: false,
        noiseSupression: false
    },
    binFormula: "bin",
    scoreFormula: "300 * bands[1].avg / Math.max(bands[1].avg + bands[0].avg, 0.01)",
    outFormula: "score"
};
const $1622be301bae0161$var$logger$3 = new $1622be301bae0161$export$efa9a398d6368992();
function $1622be301bae0161$export$af9222748cc412c5({ micTrack: micTrack, params: params, onScoreUpdated: onScoreUpdated }) {
    const audioCtx = new AudioContext();
    let analyser = null;
    let source = null;
    let lastTrack = null;
    let lastTrackWasOurs = false;
    const setTrack = (track)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            if (lastTrack && lastTrackWasOurs) lastTrack.stop();
            lastTrackWasOurs = false;
            if (track && params.separateTrack) try {
                const stream = yield navigator.mediaDevices.getUserMedia({
                    audio: Object.assign({
                        deviceId: lastTrack === null || lastTrack === void 0 ? void 0 : lastTrack.getSettings().deviceId
                    }, params.separateTrack),
                    video: false
                });
                track = stream.getAudioTracks()[0];
                lastTrackWasOurs = true;
            } catch (ex) {
                $1622be301bae0161$var$logger$3.warn("unable to fetch new track for colocation speaker analysis, using current", ex);
            }
            lastTrack = track;
            if (source) {
                source.disconnect();
                source = null;
            }
            if (track) {
                const stream = new MediaStream([
                    track
                ]);
                source = audioCtx.createMediaStreamSource(stream);
                source.connect(analyser);
            }
        });
    let samplerInterval;
    const setParams = (newParams)=>{
        clearInterval(samplerInterval);
        params = Object.assign(Object.assign({}, $1622be301bae0161$var$defaultParams), newParams);
        if (!analyser || analyser.fftSize !== params.bins * 2) {
            let restoreTrack = null;
            if (analyser) {
                restoreTrack = lastTrack;
                setTrack(null);
            }
            analyser = audioCtx.createAnalyser();
            analyser.fftSize = params.bins * 2;
            if (restoreTrack) setTrack(restoreTrack);
        }
        const bins = new Uint8Array(analyser.frequencyBinCount);
        const scores = [];
        analyser.minDecibels = params.minDecibels;
        analyser.maxDecibels = params.maxDecibels;
        analyser.smoothingTimeConstant = params.smoothingTimeConstant;
        const initScriptFunc = params.initScript && new Function("f", "setTrack", "lastTrack", params.initScript.join("\n"));
        const scoreScriptFunc = params.scoreScript && new Function("bins", "g", "f", params.scoreScript.join("\n"));
        const calcScore = params.scoreFormula && new Function("bands", `return ${params.scoreFormula}`);
        const getOutValue = params.outFormula && new Function("score", "avg", "max", "scores", `return ${params.outFormula}`);
        const binMap = params.binFormula && new Function("bin", "index", `return ${params.binFormula}`);
        let reportRateCounter = 0;
        const globals = initScriptFunc && initScriptFunc($1622be301bae0161$var$scriptFunctions, setTrack, lastTrack);
        const sampler = ()=>{
            analyser.getByteFrequencyData(bins);
            let score = 0;
            if (calcScore) {
                const processedBands = params.bands.map((range)=>{
                    const bands = range.map((index)=>binMap(bins[index] / 255, index));
                    return {
                        avg: bands.reduce((sum, current)=>sum + current, 0) / range.length,
                        min: bands.reduce((min, current)=>Math.min(min, current / 255), Number.MAX_VALUE),
                        max: bands.reduce((max, current)=>Math.max(max, current / 255), 0)
                    };
                });
                score = calcScore(processedBands) || 0;
            } else if (scoreScriptFunc) {
                score = scoreScriptFunc(bins, globals, $1622be301bae0161$var$scriptFunctions);
                if (isNaN(score)) score = 0;
            }
            scores.push(score);
            if (scores.length > params.aggSize) scores.shift();
            reportRateCounter++;
            if (reportRateCounter >= params.reportRate) {
                reportRateCounter = 0;
                const max = scores.reduce((a, b)=>Math.max(a, b), 0);
                const avg = scores.reduce((a, b)=>a + b, 0) / scores.length;
                const out = getOutValue(score, avg, max, scores);
                onScoreUpdated({
                    bins: bins,
                    score: score,
                    max: max,
                    avg: avg,
                    out: out
                });
            }
        };
        samplerInterval = setInterval(sampler, 1000 / params.sampleRate);
    };
    setParams(params);
    setTrack(micTrack);
    return {
        setParams: setParams,
        setTrack: setTrack,
        close () {
            setTrack(null);
            clearInterval(samplerInterval);
            audioCtx.close();
        }
    };
}
const $1622be301bae0161$var$logger$2 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$MEDIA_QUALITY = Object.freeze({
    ok: "ok",
    warning: "warning",
    critical: "critical"
});
const $1622be301bae0161$var$MONITOR_INTERVAL = 600;
const $1622be301bae0161$var$TREND_HORIZON = 3;
const $1622be301bae0161$var$WARNING_SCORE = 9;
const $1622be301bae0161$var$CRITICAL_SCORE = 7;
class $1622be301bae0161$export$9a5481974d870db4 extends (0, (/*@__PURE__*/$parcel$interopDefault($0bfd6a77e39eae31$exports))) {
    close() {
        clearInterval(this._intervalHandle);
        delete this._intervalHandle;
        this._producers = {};
        this._clients = {};
    }
    _startMonitor() {
        this._intervalHandle = setInterval(()=>{
            Object.entries(this._producers).forEach(([clientId, producers])=>{
                this._evaluateClient(clientId, producers);
            });
        }, $1622be301bae0161$var$MONITOR_INTERVAL);
    }
    _evaluateClient(clientId, producers) {
        if (!this._clients[clientId]) this._clients[clientId] = {
            audio: {
                currentQuality: $1622be301bae0161$var$MEDIA_QUALITY.ok,
                trend: []
            },
            video: {
                currentQuality: $1622be301bae0161$var$MEDIA_QUALITY.ok,
                trend: []
            }
        };
        this._evaluateProducer(clientId, Object.values(producers).filter((p)=>p.kind === "audio"), "audio");
        this._evaluateProducer(clientId, Object.values(producers).filter((p)=>p.kind === "video"), "video");
    }
    _evaluateProducer(clientId, producers, kind) {
        if (producers.length === 0) return;
        const avgScore = producers.reduce((prev, curr)=>prev + curr.score, 0) / producers.length;
        const newQuality = this._evaluateScore(avgScore);
        const qualityChanged = this._updateTrend(newQuality, this._clients[clientId][kind]);
        if (qualityChanged) this.emit($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, {
            clientId: clientId,
            kind: kind,
            quality: newQuality
        });
    }
    _updateTrend(newQuality, state) {
        state.trend.push(newQuality);
        if (state.trend.length > $1622be301bae0161$var$TREND_HORIZON) state.trend.shift();
        if (newQuality !== state.currentQuality && state.trend.every((t)=>t !== state.currentQuality)) {
            state.currentQuality = newQuality;
            return true;
        } else return false;
    }
    addProducer(clientId, producerId) {
        if (!clientId || !producerId || !(typeof clientId === "string" && typeof producerId === "string")) {
            $1622be301bae0161$var$logger$2.warn("Missing clientId or producerId");
            return;
        }
        if (!this._producers[clientId]) this._producers[clientId] = {};
        this._producers[clientId][producerId] = {};
    }
    removeProducer(clientId, producerId) {
        delete this._producers[clientId][producerId];
        if (Object.keys(this._producers[clientId]).length === 0) delete this._producers[clientId];
    }
    addConsumer(clientId, consumerId) {
        if (!clientId || !consumerId) {
            $1622be301bae0161$var$logger$2.warn("Missing clientId or consumerId");
            return;
        }
        if (!this._producers[clientId]) this._producers[clientId] = {};
        this._producers[clientId][consumerId] = {};
    }
    removeConsumer(clientId, consumerId) {
        delete this._producers[clientId][consumerId];
        if (Object.keys(this._producers[clientId]).length === 0) delete this._producers[clientId];
    }
    addProducerScore(clientId, producerId, kind, score) {
        if (!Array.isArray(score) || score.length === 0 || score.some((s)=>!s || !s.hasOwnProperty("score") || typeof s.score !== "number" || isNaN(s.score))) {
            $1622be301bae0161$var$logger$2.warn("Unexpected producer score format");
            return;
        }
        this._producers[clientId][producerId] = {
            kind: kind,
            score: this._calcAvgProducerScore(score.map((s)=>s.score))
        };
    }
    addConsumerScore(clientId, consumerId, kind, score) {
        if (!score || !score.hasOwnProperty("producerScores") || !Array.isArray(score.producerScores)) {
            $1622be301bae0161$var$logger$2.warn("Unexpected consumer score format");
            return;
        }
        this._producers[clientId][consumerId] = {
            kind: kind,
            score: this._calcAvgProducerScore(score.producerScores)
        };
    }
    _evaluateScore(score) {
        if (score <= $1622be301bae0161$var$WARNING_SCORE && score > $1622be301bae0161$var$CRITICAL_SCORE) return $1622be301bae0161$var$MEDIA_QUALITY.warning;
        else if (score <= $1622be301bae0161$var$CRITICAL_SCORE && score > 0) return $1622be301bae0161$var$MEDIA_QUALITY.critical;
        else return $1622be301bae0161$var$MEDIA_QUALITY.ok;
    }
    _calcAvgProducerScore(scores) {
        try {
            if (!Array.isArray(scores) || scores.length === 0) return 0;
            let totalScore = 0;
            let divisor = 0;
            scores.forEach((score)=>{
                if (score > 0) {
                    totalScore += score;
                    divisor++;
                }
            });
            if (totalScore === 0 || divisor === 0) return 0;
            else return totalScore / divisor;
        } catch (error) {
            $1622be301bae0161$var$logger$2.error(error);
            return 0;
        }
    }
    constructor(){
        super();
        this._clients = {};
        this._producers = {};
        this._startMonitor();
    }
}
const $1622be301bae0161$export$3a1d5401f2f6ef55 = (transportConfig, features)=>{
    if (!features.useOnlyTURN) return;
    transportConfig.iceTransportPolicy = "relay";
    const filter = {
        onlyudp: /^turn:.*transport=udp$/,
        onlytcp: /^turn:.*transport=tcp$/,
        onlytls: /^turns:.*transport=tcp$/
    }[features.useOnlyTURN];
    if (filter) transportConfig.iceServers = transportConfig.iceServers.filter((entry)=>entry.url && entry.url.match(filter));
};
function $1622be301bae0161$var$getLayers({ width: width, height: height }, { numberOfActiveVideos: numberOfActiveVideos, numberOfTemporalLayers: numberOfTemporalLayers, uncappedSingleRemoteVideoOn: uncappedSingleRemoteVideoOn }) {
    const maxSide = Math.max(width, height);
    let spatialLayer = maxSide >= 480 ? maxSide >= 960 ? 2 : 1 : 0;
    let temporalLayer = numberOfTemporalLayers - 1;
    if (maxSide < 100) temporalLayer = Math.max(numberOfTemporalLayers - 2, 0);
    if (numberOfActiveVideos > 8 && spatialLayer === 0) temporalLayer = Math.max(numberOfTemporalLayers - 2, 0);
    if (numberOfActiveVideos < 4 && maxSide > 300 && spatialLayer === 0) spatialLayer = 1;
    if (uncappedSingleRemoteVideoOn && numberOfActiveVideos === 1) {
        spatialLayer = 2;
        temporalLayer = numberOfTemporalLayers - 1;
    }
    return {
        spatialLayer: spatialLayer,
        temporalLayer: temporalLayer
    };
}
function $1622be301bae0161$var$getNumberOfActiveVideos(consumers) {
    let numberOfActiveVideos = 0;
    consumers.forEach((c)=>{
        var _a, _b;
        if (c._closed || c._paused) return;
        if (((_a = c._appData) === null || _a === void 0 ? void 0 : _a.source) === "webcam" || ((_b = c._appData) === null || _b === void 0 ? void 0 : _b.source) === "screenvideo") numberOfActiveVideos++;
    });
    return numberOfActiveVideos;
}
function $1622be301bae0161$var$getNumberOfTemporalLayers(consumer) {
    var _a, _b, _c;
    return /T3/.test(((_c = (_b = (_a = consumer._rtpParameters) === null || _a === void 0 ? void 0 : _a.encodings) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.scalabilityMode) || "") ? 3 : 2;
}
var $1622be301bae0161$var$_a$1;
const $1622be301bae0161$var$adapter$1 = ($1622be301bae0161$var$_a$1 = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a$1 !== void 0 ? $1622be301bae0161$var$_a$1 : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$logger$1 = new $1622be301bae0161$export$efa9a398d6368992();
const $1622be301bae0161$var$browserName = $1622be301bae0161$var$adapter$1.browserDetails.browser;
let $1622be301bae0161$var$unloading = false;
const $1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS = 3500;
const $1622be301bae0161$var$RESTARTICE_ERROR_MAX_RETRY_COUNT = 5;
const $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID = (0, $e247db96f48d686a$export$2e2bcd8739ae039)();
const $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID = (0, $e247db96f48d686a$export$2e2bcd8739ae039)();
if ($1622be301bae0161$var$browserName === "chrome") window.document.addEventListener("beforeunload", ()=>$1622be301bae0161$var$unloading = true);
class $1622be301bae0161$export$b44cbfcf90b97eac {
    _updateAndScheduleMediaServersRefresh({ iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds }) {
        var _a, _b;
        this._iceServers = iceServers;
        this._sfuServer = sfuServer;
        this._mediaserverConfigTtlSeconds = mediaserverConfigTtlSeconds;
        (_a = this._sendTransport) === null || _a === void 0 || _a.updateIceServers({
            iceServers: this._iceServers
        });
        (_b = this._receiveTransport) === null || _b === void 0 || _b.updateIceServers({
            iceServers: this._iceServers
        });
        this._clearMediaServersRefresh();
        if (!mediaserverConfigTtlSeconds) return;
        this._fetchMediaServersTimer = setTimeout(()=>this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.FETCH_MEDIASERVER_CONFIG), mediaserverConfigTtlSeconds * 1000);
    }
    _clearMediaServersRefresh() {
        if (!this._fetchMediaServersTimer) return;
        clearTimeout(this._fetchMediaServersTimer);
        this._fetchMediaServersTimer = null;
    }
    setupSocketListeners() {
        this._socketListenerDeregisterFunctions.push(()=>this._clearMediaServersRefresh(), this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.MEDIASERVER_CONFIG, (data)=>{
            if (data.error) {
                $1622be301bae0161$var$logger$1.warn("FETCH_MEDIASERVER_CONFIG failed:", data.error);
                return;
            }
            this._updateAndScheduleMediaServersRefresh(data);
        }), this._serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ()=>{
            if (this._screenVideoTrack) this._emitScreenshareStarted();
            if (this._features.sfuReconnectV2On && !this._hasVegaConnection && this._reconnect) this._connect();
        }));
        this._connect();
    }
    _emitScreenshareStarted() {
        this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.START_SCREENSHARE, {
            streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
            hasAudioTrack: Boolean(this._screenAudioTrack)
        });
    }
    _connect() {
        if (this._features.sfuReconnectV2On) {
            if (this._hasVegaConnection) return;
            if (!this._serverSocket.isConnected()) {
                const reconnectThresholdInMs = this._serverSocket.getReconnectThreshold();
                if (!reconnectThresholdInMs) return;
                if (Date.now() > (this._serverSocket.disconnectTimestamp || 0) + reconnectThresholdInMs) return;
            }
            if (this._reconnectTimeOut) clearTimeout(this._reconnectTimeOut);
        }
        const host = this._features.sfuServerOverrideHost || [
            this._sfuServer.url
        ];
        const searchParams = new URLSearchParams(Object.assign({
            clientId: this._selfId,
            organizationId: this._room.organizationId,
            roomName: this._room.name,
            eventClaim: this._room.isClaimed ? this._eventClaim : null,
            lowBw: "true"
        }, Object.keys(this._features || {}).filter((featureKey)=>this._features[featureKey] && /^sfu/.test(featureKey)).reduce((prev, current)=>Object.assign(Object.assign({}, prev), {
                [current]: this._features[current]
            }), {})));
        const queryString = searchParams.toString();
        const wsUrl = `wss://${host}?${queryString}`;
        this._vegaConnection = new $1622be301bae0161$export$b281e2872ffa0a70(wsUrl);
        this._hasVegaConnection = true;
        this._vegaConnection.on("open", ()=>this._join());
        this._vegaConnection.on("close", ()=>this._onClose());
        this._vegaConnection.on("message", (message)=>this._onMessage(message));
    }
    _onClose() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_onClose()");
        this._hasVegaConnection = false;
        (_a = this._sendTransport) === null || _a === void 0 || _a.close();
        (_b = this._receiveTransport) === null || _b === void 0 || _b.close();
        this._sendTransport = null;
        this._receiveTransport = null;
        this._streamIdToVideoConsumerId.clear();
        this._streamIdToVideoResolution.clear();
        if (this._reconnect) this._reconnectTimeOut = setTimeout(()=>this._connect(), 1000);
        this._qualityMonitor.close();
        this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.SFU_CONNECTION_CLOSED);
    }
    _join() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("join()");
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.SFU_CONNECTION_OPEN);
            try {
                const { routerRtpCapabilities: routerRtpCapabilities } = yield this._vegaConnection.request("getCapabilities");
                if (!this._routerRtpCapabilities) {
                    $1622be301bae0161$export$1cbfd4deae6f916f(routerRtpCapabilities, this._features);
                    this._routerRtpCapabilities = routerRtpCapabilities;
                    yield this._mediasoupDevice.load({
                        routerRtpCapabilities: routerRtpCapabilities
                    });
                }
                this._vegaConnection.message("setCapabilities", {
                    rtpCapabilities: this._mediasoupDevice.rtpCapabilities
                });
                if (this._colocation) this._vegaConnection.message("setColocation", {
                    colocation: this._colocation
                });
                yield Promise.all([
                    this._createTransport(true),
                    this._createTransport(false)
                ]);
                const mediaPromises = [];
                if (this._micTrack && !this._micProducer && !this._micProducerPromise) mediaPromises.push(this._internalSendMic());
                if (this._webcamTrack && !this._webcamProducer && !this._webcamProducerPromise) mediaPromises.push(this._internalSendWebcam());
                if (this._screenVideoTrack && !this._screenVideoProducer && !this._screenVideoProducerPromise) mediaPromises.push(this._internalSendScreenVideo());
                if (this._screenAudioTrack && !this._screenAudioProducer && !this._screenAudioProducerPromise) mediaPromises.push(this._internalSendScreenAudio());
                yield Promise.all(mediaPromises);
            } catch (error) {
                $1622be301bae0161$var$logger$1.error("_join() [error:%o]", error);
            }
        });
    }
    _createTransport(send) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const creator = send ? "createSendTransport" : "createRecvTransport";
            const transportOptions = yield this._vegaConnection.request("createTransport", {
                producing: send,
                consuming: !send,
                enableTcp: true,
                enableUdp: true,
                preferUdp: true,
                sctpParameters: {
                    enableSctp: true,
                    numSctpStreams: {
                        OS: 1024,
                        MIS: 1024
                    },
                    maxSctpMessageSize: 262144,
                    sctpSendBufferSize: 262144
                }
            });
            transportOptions.iceServers = this._iceServers;
            $1622be301bae0161$export$3a1d5401f2f6ef55(transportOptions, this._features);
            const transport = this._mediasoupDevice[creator](transportOptions);
            const onConnectionStateListener = (connectionState)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    $1622be301bae0161$var$logger$1.info(`Transport ConnectionStateChanged ${connectionState}`);
                    if (connectionState !== "disconnected" && connectionState !== "failed") return;
                    if (send) {
                        if (this._sndTransportIceRestartPromise) return;
                        this._sndTransportIceRestartPromise = this._restartIce(transport).finally(()=>{
                            this._sndTransportIceRestartPromise = null;
                        });
                    } else {
                        if (this._rcvTransportIceRestartPromise) return;
                        this._rcvTransportIceRestartPromise = this._restartIce(transport).finally(()=>{
                            this._rcvTransportIceRestartPromise = null;
                        });
                    }
                });
            transport.on("connect", ({ dtlsParameters: dtlsParameters }, callback)=>{
                var _a;
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("connectTransport", {
                    transportId: transport.id,
                    dtlsParameters: dtlsParameters
                });
                callback();
            }).on("connectionstatechange", onConnectionStateListener);
            transport.observer.once("close", ()=>{
                transport.removeListener(onConnectionStateListener);
            });
            if (send) {
                transport.on("produce", ({ kind: kind, rtpParameters: rtpParameters, appData: appData }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        try {
                            const { paused: paused } = appData;
                            const { id: id } = yield (_a = this._vegaConnection) === null || _a === void 0 ? void 0 : _a.request("produce", {
                                transportId: transport.id,
                                kind: kind,
                                rtpParameters: rtpParameters,
                                paused: paused,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                transport.on("producedata", ({ appData: appData, sctpStreamParameters: sctpStreamParameters }, callback, errback)=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                        var _b;
                        try {
                            const { id: id } = yield (_b = this._vegaConnection) === null || _b === void 0 ? void 0 : _b.request("produceData", {
                                transportId: transport.id,
                                sctpStreamParameters: sctpStreamParameters,
                                appData: appData
                            });
                            callback({
                                id: id
                            });
                        } catch (error) {
                            errback(error);
                        }
                    }));
                this._sendTransport = transport;
            } else this._receiveTransport = transport;
        });
    }
    _restartIce(transport, retried = 0) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            if (!transport || !("closed" in transport) || !("connectionState" in transport)) {
                $1622be301bae0161$var$logger$1.info("_restartIce: No transport or property closed or connectionState!");
                return;
            }
            if (transport.closed) {
                $1622be301bae0161$var$logger$1.info("_restartIce: Transport is closed!");
                return;
            }
            if (transport.connectionState !== "disconnected" && transport.connectionState !== "failed") {
                $1622be301bae0161$var$logger$1.info("_restartIce: Connection is healthy ICE restart no loneger needed!");
                return;
            }
            const { iceRestartStarted: iceRestartStarted } = transport.appData;
            const now = Date.now();
            if (Number.isFinite(iceRestartStarted) && now - iceRestartStarted < $1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS) return;
            transport.appData.iceRestartStarted = now;
            if ($1622be301bae0161$var$RESTARTICE_ERROR_MAX_RETRY_COUNT <= retried) {
                $1622be301bae0161$var$logger$1.info("_restartIce: Reached restart ICE  maximum retry count!");
                return;
            }
            if (!this._vegaConnection) {
                $1622be301bae0161$var$logger$1.info(`_restartIce: Connection is undefined`);
                return;
            }
            const { iceParameters: iceParameters } = yield this._vegaConnection.request("restartIce", {
                transportId: transport.id
            });
            $1622be301bae0161$var$logger$1.info("_restartIce: ICE restart iceParameters received from SFU: ", iceParameters);
            const error = yield transport.restartIce({
                iceParameters: iceParameters
            }).then(()=>null).catch((err)=>err);
            if (error) {
                $1622be301bae0161$var$logger$1.error(`_restartIce: ICE restart failed: ${error}`);
                switch(error.message){
                    case "missing transportId":
                    case "no such transport":
                        break;
                    default:
                        yield new Promise((resolve)=>{
                            setTimeout(()=>{
                                resolve(undefined);
                            }, Math.min($1622be301bae0161$var$RESTARTICE_ERROR_RETRY_THRESHOLD_IN_MS * Math.pow(2, retried), 60000));
                        });
                        yield this._restartIce(transport, retried + 1);
                        break;
                }
                return;
            }
            yield new Promise((resolve)=>{
                setTimeout(()=>{
                    resolve(undefined);
                }, 60000 * Math.min(8, retried + 1));
            });
            if (transport.connectionState === "failed" || transport.connectionState === "disconnected") {
                yield this._restartIce(transport, retried + 1);
                return;
            }
        });
    }
    _internalSendMic() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendMic()");
            this._micProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._micTrack || !this._sendTransport || this._micProducer) {
                            this._micProducerPromise = null;
                            return;
                        }
                        const currentPaused = this._micPaused;
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._micTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("audio", false, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: false,
                                source: "mic",
                                paused: currentPaused
                            }
                        }));
                        currentPaused ? producer.pause() : producer.resume();
                        this._micProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('micProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._micProducer = null;
                            this._micProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._micTrack !== this._micProducer.track) yield this._replaceMicTrack();
                        if (this._micPaused !== this._micProducer.paused) this._pauseResumeMic();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("micProducer failed:%o", error);
                    } finally{
                        this._micProducerPromise = null;
                        if (!this._micTrack) {
                            this._stopProducer(this._micProducer);
                            this._micProducer = null;
                        }
                    }
                }))();
        });
    }
    _internalSetupMicScore() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSetupMicScore()");
            this._micScoreProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._micProducer || !this._colocation || this._micScoreProducer) {
                            this._micScoreProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produceData({
                            ordered: false,
                            maxPacketLifeTime: 3000,
                            label: "micscore",
                            appData: {
                                producerId: this._micProducer.id,
                                clientId: this._selfId
                            }
                        });
                        this._micScoreProducer = producer;
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('micScoreProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeDataProducers", {
                                dataProducerIds: [
                                    producer.id
                                ]
                            });
                            this._micScoreProducer = null;
                            this._micScoreProducerPromise = null;
                        });
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("micScoreProducer failed:%o", error);
                    } finally{
                        this._micScoreProducerPromise = null;
                        if (!this._micProducer || !this._colocation) this._stopMicScoreProducer();
                    }
                }))();
        });
    }
    _stopMicScoreProducer() {
        this._stopProducer(this._micScoreProducer);
        this._micScoreProducer = null;
    }
    _replaceMicTrack() {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceMicTrack()");
            if (!this._micTrack || !this._micProducer || this._micProducer.closed) return;
            if (this._micProducer.track !== this._micTrack) {
                yield this._micProducer.replaceTrack({
                    track: this._micTrack
                });
                (_a = this._micAnalyser) === null || _a === void 0 || _a.setTrack(this._micTrack);
                yield this._replaceMicTrack();
            }
        });
    }
    _pauseResumeMic() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_pauseResumeMic()");
        if (!this._micProducer || this._micProducer.closed) return;
        if (this._micPaused !== this._micProducer.paused) {
            if (this._micPaused) {
                this._micProducer.pause();
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseProducers", {
                    producerIds: [
                        this._micProducer.id
                    ]
                });
            } else {
                this._micProducer.resume();
                (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeProducers", {
                    producerIds: [
                        this._micProducer.id
                    ]
                });
            }
            this._pauseResumeMic();
        }
    }
    _sendMic(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendMic() [track:%o]", track);
            this._micTrack = track;
            if (this._micProducer) return yield this._replaceMicTrack();
            else if (this._micProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendMic();
        });
    }
    _sendMicScore(score) {
        if (isNaN(score)) return;
        if (!isFinite(score)) return;
        if (this._micScoreProducer) {
            if (this._micScoreProducer.closed) {
                this._stopMicScoreProducer();
                return;
            }
            try {
                this._micScoreProducer.send(JSON.stringify({
                    score: score
                }));
            } catch (ex) {
                $1622be301bae0161$var$logger$1.error("_sendMicScore failed [error:%o]", ex);
            }
            return;
        }
        if (!this._micScoreProducerPromise && this._micProducer && this._colocation && score !== 0) this._internalSetupMicScore();
    }
    _internalSendWebcam() {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendWebcam()");
            if (!this._sendTransport || this._webcamProducer || this._webcamProducerPromise || ((_a = this._webcamTrack) === null || _a === void 0 ? void 0 : _a.readyState) !== "live") return;
            this._webcamProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    var _b;
                    try {
                        const currentPaused = this._webcamPaused;
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._webcamTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("video", false, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_CAM_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: false,
                                source: "webcam",
                                paused: currentPaused
                            }
                        }));
                        currentPaused ? producer.pause() : producer.resume();
                        this._webcamProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('webcamProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._webcamProducer = null;
                            this._webcamProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._webcamTrack && this._webcamTrack !== ((_b = this._webcamProducer) === null || _b === void 0 ? void 0 : _b.track)) {
                            this._webcamProducerPromise = null;
                            this._replaceWebcamTrack();
                        }
                        if (this._webcamPaused !== this._webcamProducer.paused) this._pauseResumeWebcam();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("webcamProducer failed:%o", error);
                    } finally{
                        this._webcamProducerPromise = null;
                        if (!this._webcamTrack) {
                            this._stopProducer(this._webcamProducer);
                            this._webcamProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceWebcamTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceWebcamTrack()");
            if (!this._sendTransport || !this._webcamTrack || this._webcamProducerPromise) return;
            if (!this._webcamProducer && this._webcamTrack.enabled) {
                yield this._internalSendWebcam();
                return;
            }
            if (this._webcamProducer.track !== this._webcamTrack) {
                yield this._webcamProducer.replaceTrack({
                    track: this._webcamTrack
                });
                yield this._replaceWebcamTrack();
            }
        });
    }
    _pauseResumeWebcam() {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("_pauseResumeWebcam()");
        if (!this._webcamProducer || this._webcamProducer.closed) return;
        if (this._webcamPaused !== this._webcamProducer.paused) {
            if (this._webcamPaused) {
                this._webcamProducer.pause();
                (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseProducers", {
                    producerIds: [
                        this._webcamProducer.id
                    ]
                });
            } else {
                this._webcamProducer.resume();
                (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeProducers", {
                    producerIds: [
                        this._webcamProducer.id
                    ]
                });
            }
            this._pauseResumeWebcam();
        }
    }
    _sendWebcam(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendWebcam() [track:%o]", track);
            this._webcamTrack = track;
            if (this._webcamProducer) return yield this._replaceWebcamTrack();
            else if (this._webcamProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendWebcam();
        });
    }
    _internalSendScreenVideo() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendScreenVideo()");
            this._screenVideoProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._screenVideoTrack || !this._sendTransport || this._screenVideoProducer) {
                            this._screenVideoProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._screenVideoTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("video", true, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: true,
                                source: "screenvideo",
                                paused: false
                            }
                        }));
                        this._screenVideoProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('screenVideoProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._screenVideoProducer = null;
                            this._screenVideoProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._screenVideoTrack !== this._screenVideoProducer.track) yield this._replaceScreenVideoTrack();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("screenVideoProducer failed:%o", error);
                    } finally{
                        this._screenVideoProducerPromise = null;
                        if (!this._screenVideoTrack) {
                            yield this._stopProducer(this._screenVideoProducer);
                            this._screenVideoProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceScreenVideoTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceScreenVideoTrack()");
            if (!this._screenVideoTrack || !this._screenVideoProducer || this._screenVideoProducer.closed) return;
            if (this._screenVideoProducer.track !== this._screenVideoTrack) {
                yield this._screenVideoProducer.replaceTrack({
                    track: this._screenVideoTrack
                });
                yield this._replaceScreenVideoTrack();
            }
        });
    }
    _sendScreenVideo(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendScreenVideo() [track:%o]", track);
            this._screenVideoTrack = track;
            if (this._screenVideoProducer) return yield this._replaceScreenVideoTrack();
            else if (this._screenVideoProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendScreenVideo();
        });
    }
    _internalSendScreenAudio() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_internalSendScreenAudio()");
            this._screenAudioProducerPromise = (()=>$1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        if (!this._screenAudioTrack || !this._sendTransport || this._screenAudioProducer) {
                            this._screenAudioProducerPromise = null;
                            return;
                        }
                        const producer = yield this._sendTransport.produce(Object.assign(Object.assign({
                            track: this._screenAudioTrack,
                            disableTrackOnPause: false,
                            stopTracks: false
                        }, $1622be301bae0161$export$71f7c171c9088ed4("audio", true, this._features)), {
                            appData: {
                                streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
                                sourceClientId: this._selfId,
                                screenShare: true,
                                source: "screenaudio",
                                paused: false
                            }
                        }));
                        this._screenAudioProducer = producer;
                        this._qualityMonitor.addProducer(this._selfId, producer.id);
                        producer.observer.once("close", ()=>{
                            var _a;
                            $1622be301bae0161$var$logger$1.info('screenAudioProducer "close" event');
                            if (producer.appData.localClosed) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("closeProducers", {
                                producerIds: [
                                    producer.id
                                ]
                            });
                            this._screenAudioProducer = null;
                            this._screenAudioProducerPromise = null;
                            this._qualityMonitor.removeProducer(this._selfId, producer.id);
                        });
                        if (this._screenAudioTrack !== this._screenAudioProducer.track) yield this._replaceScreenAudioTrack();
                    } catch (error) {
                        $1622be301bae0161$var$logger$1.error("screenAudioProducer failed:%o", error);
                    } finally{
                        this._screenAudioProducerPromise = null;
                        if (!this._screenAudioTrack) {
                            yield this._stopProducer(this._screenAudioProducer);
                            this._screenAudioProducer = null;
                        }
                    }
                }))();
        });
    }
    _replaceScreenAudioTrack() {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_replaceScreenAudioTrack()");
            if (!this._screenAudioTrack || !this._screenAudioProducer || this._screenAudioProducer.closed) return;
            if (this._screenAudioProducer.track !== this._screenAudioTrack) {
                yield this._screenAudioProducer.replaceTrack({
                    track: this._screenAudioTrack
                });
                yield this._replaceScreenAudioTrack();
            }
        });
    }
    _sendScreenAudio(track) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_sendScreenAudio() [track:%o]", track);
            this._screenAudioTrack = track;
            if (this._screenAudioProducer) return yield this._replaceScreenAudioTrack();
            else if (this._screenAudioProducerPromise) return;
            if (this._sendTransport) return yield this._internalSendScreenAudio();
        });
    }
    _stopProducer(producer) {
        $1622be301bae0161$var$logger$1.info("_stopProducer()");
        if (!producer || producer.closed) return;
        producer.appData.localClosed = true;
        producer.close();
    }
    isInitializedWith({ selfId: selfId, roomName: roomName, isSfu: isSfu }) {
        return this._selfId === selfId && this._room.name === roomName && Boolean(isSfu);
    }
    setEventClaim(eventClaim) {
        var _a;
        this._eventClaim = eventClaim;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message("eventClaim", {
            eventClaim: eventClaim
        });
    }
    setColocation(colocation) {
        var _a;
        this._colocation = colocation;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message("setColocation", {
            colocation: colocation
        });
        if (!colocation && this._micScoreProducer && !this._micScoreProducerPromise) this._stopMicScoreProducer();
        this._syncMicAnalyser();
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("colocation_changed", {
            colocation: colocation
        });
    }
    setAudioOnly(audioOnly) {
        var _a;
        (_a = this._vegaConnection) === null || _a === void 0 || _a.message(audioOnly ? "enableAudioOnly" : "disableAudioOnly");
    }
    setRemoteScreenshareVideoTrackIds() {}
    setRoomSessionId(roomSessionId) {
        this._roomSessionId = roomSessionId;
    }
    disconnect(clientIdOrStreamId, _activeBreakout, eventClaim) {
        var _a;
        $1622be301bae0161$var$logger$1.info("disconnect() [clientIdOrStreamId:%s, eventClaim:%s]", clientIdOrStreamId, eventClaim);
        if (this._clientStates.has(clientIdOrStreamId)) {
            const clientState = this._clientStates.get(clientIdOrStreamId);
            clientState.hasAcceptedWebcamStream = false;
            clientState.hasAcceptedScreenStream = false;
            this._syncIncomingStreamsWithPWA(clientIdOrStreamId);
        }
        if (eventClaim) {
            this._eventClaim = eventClaim;
            (_a = this._vegaConnection) === null || _a === void 0 || _a.message("eventClaim", {
                eventClaim: eventClaim
            });
        }
    }
    replaceTrack(oldTrack, track) {
        if (track.kind === "audio") {
            if (!track.effectTrack) this._monitorAudioTrack(track);
            this._micTrack = track;
            this._replaceMicTrack();
        }
        if (track.kind === "video") {
            if (!track.effectTrack) this._monitorVideoTrack(track);
            this._webcamTrack = track;
            this._replaceWebcamTrack();
        }
    }
    removeStream(streamId, _stream, requestedByClientId) {
        $1622be301bae0161$var$logger$1.info("removeStream() [streamId:%s, requestedByClientId:%s]", streamId, requestedByClientId);
        this._emitToSignal($1622be301bae0161$export$1ea784ac1a0f1fca.STOP_SCREENSHARE, {
            streamId: $1622be301bae0161$var$OUTBOUND_SCREEN_OUTBOUND_STREAM_ID,
            requestedByClientId: requestedByClientId
        });
        this._stopProducer(this._screenVideoProducer);
        this._screenVideoProducer = null;
        this._screenVideoTrack = null;
        this._stopProducer(this._screenAudioProducer);
        this._screenAudioProducer = null;
        this._screenAudioTrack = null;
    }
    _onMicAnalyserScoreUpdated(data) {
        var _a, _b;
        (_b = (_a = this._micAnalyserDebugger) === null || _a === void 0 ? void 0 : _a.onScoreUpdated) === null || _b === void 0 || _b.call(_a, data);
        this._sendMicScore(this._micPaused ? 0 : data.out);
    }
    addNewStream(streamId, stream, audioPaused, videoPaused, beforeEffectTracks = []) {
        if (streamId === "0") {
            this._micPaused = audioPaused;
            this._webcamPaused = videoPaused;
            const videoTrack = stream.getVideoTracks()[0];
            const audioTrack = stream.getAudioTracks()[0];
            if (videoTrack) {
                this._sendWebcam(videoTrack);
                if (!videoTrack.effectTrack) this._monitorVideoTrack(videoTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "video");
                if (beforeEffectTrack) this._monitorVideoTrack(beforeEffectTrack);
            }
            if (audioTrack) {
                this._sendMic(audioTrack);
                this._syncMicAnalyser();
                if (!audioTrack.effectTrack) this._monitorAudioTrack(audioTrack);
                const beforeEffectTrack = beforeEffectTracks.find((t)=>t.kind === "audio");
                if (beforeEffectTrack) this._monitorAudioTrack(beforeEffectTrack);
            }
            if (this._localStreamDeregisterFunction) {
                this._localStreamDeregisterFunction();
                this._localStreamDeregisterFunction = null;
            }
            const localStreamHandler = (e)=>{
                const { enable: enable, track: track } = e.detail;
                this._webcamPaused = !enable;
                this._pauseResumeWebcam();
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            };
            stream.addEventListener("stopresumevideo", localStreamHandler);
            this._localStreamDeregisterFunction = ()=>{
                stream.removeEventListener("stopresumevideo", localStreamHandler);
            };
        } else {
            const videoTrack = stream.getVideoTracks()[0];
            const audioTrack = stream.getAudioTracks()[0];
            if (videoTrack) this._sendScreenVideo(videoTrack);
            if (audioTrack) this._sendScreenAudio(audioTrack);
            this._emitScreenshareStarted();
        }
    }
    _syncMicAnalyser() {
        if (this._micTrack && this._colocation && !this._micAnalyser) {
            this._micAnalyser = $1622be301bae0161$export$af9222748cc412c5({
                micTrack: this._micTrack,
                onScoreUpdated: this._onMicAnalyserScoreUpdated.bind(this)
            });
            return;
        }
        if (this._micAnalyser && !this._colocation) {
            this._micAnalyser.close();
            this._micAnalyser = null;
            return;
        }
    }
    stopOrResumeAudio(stream, enabled) {
        $1622be301bae0161$var$logger$1.info("stopOrResumeAudio() [enabled:%s]", enabled);
        this._micPaused = !enabled;
        this._pauseResumeMic();
    }
    _handleStopOrResumeVideo({ enable: enable, track: track }) {
        if (!enable) {
            if (this._webcamProducer && !this._webcamProducer.closed && this._webcamProducer.track === track) {
                this._stopProducer(this._webcamProducer);
                this._webcamProducer = null;
                this._webcamTrack = null;
            }
        } else this._sendWebcam(track);
    }
    stopOrResumeVideo(localStream, enable) {
        var _a;
        $1622be301bae0161$var$logger$1.info("stopOrResumeVideo() [enable:%s]", enable);
        this._webcamPaused = !enable;
        this._pauseResumeWebcam();
        if (![
            "chrome",
            "safari"
        ].includes($1622be301bae0161$var$browserName)) return;
        if (!enable) {
            clearTimeout(this._stopCameraTimeout);
            const stopCameraDelay = ((_a = localStream.getVideoTracks().find((t)=>!t.enabled)) === null || _a === void 0 ? void 0 : _a.readyState) === "ended" ? 0 : 5000;
            this._stopCameraTimeout = setTimeout(()=>{
                localStream.getVideoTracks().forEach((track)=>{
                    if (track.enabled === false) {
                        track.stop();
                        localStream.removeTrack(track);
                        this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_REMOVED, {
                            stream: localStream,
                            track: track
                        });
                        this._handleStopOrResumeVideo({
                            enable: enable,
                            track: track
                        });
                    }
                });
            }, stopCameraDelay);
        } else if (localStream.getVideoTracks().length === 0) {
            const constraints = this._webrtcProvider.getMediaConstraints().video;
            navigator.mediaDevices.getUserMedia({
                video: constraints
            }).then((stream)=>{
                const track = stream.getVideoTracks()[0];
                localStream.addTrack(track);
                this._monitorVideoTrack(track);
                this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.LOCAL_STREAM_TRACK_ADDED, {
                    streamId: localStream.id,
                    tracks: [
                        track
                    ],
                    screenShare: false
                });
                this._handleStopOrResumeVideo({
                    enable: enable,
                    track: track
                });
            });
        }
    }
    supportsScreenShareAudio() {
        return true;
    }
    acceptNewStream({ streamId: streamId, clientId: clientId }) {
        $1622be301bae0161$var$logger$1.info("acceptNewStream()", {
            streamId: streamId,
            clientId: clientId
        });
        const clientState = this._getOrCreateClientState(clientId);
        const isScreenShare = streamId !== clientId;
        if (isScreenShare) {
            clientState.hasAcceptedScreenStream = true;
            clientState.hasEmittedScreenStream = false;
        } else {
            clientState.hasAcceptedWebcamStream = true;
            clientState.hasEmittedWebcamStream = false;
        }
        this._syncIncomingStreamsWithPWA(clientId);
    }
    updateStreamResolution(streamId, _ignored, { width: width, height: height }) {
        var _a, _b;
        $1622be301bae0161$var$logger$1.info("updateStreamResolution()", {
            streamId: streamId,
            width: width,
            height: height
        });
        const consumerId = this._streamIdToVideoConsumerId.get(streamId);
        const consumer = this._consumers.get(consumerId);
        if (!consumer) {
            this._streamIdToVideoResolution.set(streamId, {
                width: width,
                height: height
            });
            return;
        }
        const numberOfActiveVideos = $1622be301bae0161$var$getNumberOfActiveVideos(this._consumers);
        const numberOfTemporalLayers = $1622be301bae0161$var$getNumberOfTemporalLayers(consumer);
        const { spatialLayer: spatialLayer, temporalLayer: temporalLayer } = $1622be301bae0161$var$getLayers({
            width: width,
            height: height
        }, {
            numberOfActiveVideos: numberOfActiveVideos,
            numberOfTemporalLayers: numberOfTemporalLayers,
            uncappedSingleRemoteVideoOn: (_a = this._features) === null || _a === void 0 ? void 0 : _a.uncappedSingleRemoteVideoOn
        });
        if (consumer.appData.spatialLayer !== spatialLayer || consumer.appData.temporalLayer !== temporalLayer) {
            consumer.appData.spatialLayer = spatialLayer;
            consumer.appData.temporalLayer = temporalLayer;
            (_b = this._vegaConnection) === null || _b === void 0 || _b.message("setConsumersPreferredLayers", {
                consumerIds: [
                    consumerId
                ],
                spatialLayer: spatialLayer,
                temporalLayer: temporalLayer
            });
        }
    }
    disconnectAll() {
        var _a, _b, _c, _d;
        this._reconnect = false;
        if (this._reconnectTimeOut) {
            clearTimeout(this._reconnectTimeOut);
            this._reconnectTimeOut = null;
        }
        this._socketListenerDeregisterFunctions.forEach((func)=>{
            func();
        });
        if (this._localStreamDeregisterFunction) {
            this._localStreamDeregisterFunction();
            this._localStreamDeregisterFunction = null;
        }
        this._socketListenerDeregisterFunctions = [];
        (_a = this._vegaConnection) === null || _a === void 0 || _a.removeAllListeners();
        (_b = this._vegaConnection) === null || _b === void 0 || _b.close();
        (_c = this._sendTransport) === null || _c === void 0 || _c.close();
        (_d = this._receiveTransport) === null || _d === void 0 || _d.close();
        this._micTrack = null;
        this._webcamTrack = null;
        this._screenVideoTrack = null;
        this._screenAudioTrack = null;
        this._streamIdToVideoConsumerId.clear();
        this._mediasoupDevice = null;
    }
    sendAudioMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_muted", {
            muted: muted
        });
    }
    sendVideoMutedStats(muted) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_muted", {
            muted: muted
        });
    }
    sendStatsCustomEvent(eventName, data) {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent(eventName, data);
    }
    rtcStatsDisconnect() {
        $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.close();
    }
    rtcStatsReconnect() {
        if (!$1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connected) $1622be301bae0161$export$6e1a0bfe9f2f0cbe.server.connect();
    }
    _monitorAudioTrack(track) {
        var _a, _b;
        if (((_a = this._audioTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._audioTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._audioTrackOnEnded);
        track.addEventListener("ended", this._audioTrackOnEnded);
        this._audioTrackBeingMonitored = track;
    }
    _monitorVideoTrack(track) {
        var _a, _b;
        if (((_a = this._videoTrackBeingMonitored) === null || _a === void 0 ? void 0 : _a.id) === track.id) return;
        (_b = this._videoTrackBeingMonitored) === null || _b === void 0 || _b.removeEventListener("ended", this._videoTrackOnEnded);
        track.addEventListener("ended", this._videoTrackOnEnded);
        this._videoTrackBeingMonitored = track;
    }
    _onMessage(message) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { method: method, data: data } = message;
            return Promise.resolve().then(()=>{
                switch(method){
                    case "consumerReady":
                        return this._onConsumerReady(data);
                    case "consumerClosed":
                        return this._onConsumerClosed(data);
                    case "consumerPaused":
                        return this._onConsumerPaused(data);
                    case "consumerResumed":
                        return this._onConsumerResumed(data);
                    case "dataConsumerReady":
                        return this._onDataConsumerReady(data);
                    case "dataConsumerClosed":
                        return this._onDataConsumerClosed(data);
                    case "dominantSpeaker":
                        return this._onDominantSpeaker(data);
                    case "consumerScore":
                        return this._onConsumerScore(data);
                    case "producerScore":
                        return this._onProducerScore(data);
                    default:
                        $1622be301bae0161$var$logger$1.info(`unknown message method "${method}"`);
                        return;
                }
            }).catch((error)=>{
                $1622be301bae0161$var$logger$1.error('"message" failed [error:%o]', error);
            });
        });
    }
    _onConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onConsumerReady()", {
                id: options.id,
                producerId: options.producerId
            });
            const consumer = yield this._receiveTransport.consume(options);
            consumer.pause();
            consumer.appData.localPaused = true;
            consumer.appData.spatialLayer = 2;
            this._consumers.set(consumer.id, consumer);
            this._qualityMonitor.addConsumer(consumer.appData.sourceClientId, consumer.id);
            consumer.observer.once("close", ()=>{
                this._consumers.delete(consumer.id);
                this._qualityMonitor.removeConsumer(consumer.appData.sourceClientId, consumer.id);
                this._consumerClosedCleanup(consumer);
            });
            if (this._features.increaseIncomingMediaBufferOn && consumer.rtpReceiver) try {
                consumer.rtpReceiver.jitterBufferTarget = $1622be301bae0161$export$87d0694e432db510;
                consumer.rtpReceiver.playoutDelayHint = $1622be301bae0161$export$87d0694e432db510 / 1000;
            } catch (error) {
                $1622be301bae0161$var$logger$1.error("Error during setting jitter buffer target:", error);
            }
            const { sourceClientId: clientId, screenShare: screenShare, streamId: streamId } = consumer.appData;
            const clientState = this._getOrCreateClientState(clientId);
            if (screenShare) {
                clientState.hasEmittedScreenStream = false;
                clientState.screenShareStreamId = streamId;
            } else {
                clientState.hasEmittedWebcamStream = false;
                clientState.camStreamId = streamId;
            }
            let stream = screenShare ? clientState.screenStream : clientState.webcamStream;
            if (!stream || stream.inboundId !== streamId) {
                stream = new MediaStream();
                stream.inboundId = streamId;
                screenShare ? clientState.screenStream = stream : clientState.webcamStream = stream;
            }
            if (consumer.kind === "video") this._streamIdToVideoConsumerId.set(stream.id, consumer.id);
            stream.addTrack(consumer.track);
            this._syncIncomingStreamsWithPWA(clientId);
            const resolution = this._streamIdToVideoResolution.get(stream.id);
            if (resolution) {
                this.updateStreamResolution(stream.id, null, resolution);
                this._streamIdToVideoResolution.delete(stream.id);
            }
        });
    }
    _onConsumerClosed({ consumerId: consumerId, reason: reason }) {
        var _a;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onConsumerClosed()", {
                consumerId: consumerId,
                reason: reason
            });
            (_a = this._consumers.get(consumerId)) === null || _a === void 0 || _a.close();
        });
    }
    _onConsumerPaused({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerPaused()", {
            consumerId: consumerId
        });
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        consumer.appData.remotePaused = true;
        consumer.pause();
    }
    _onConsumerResumed({ consumerId: consumerId }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerResumed()", {
            consumerId: consumerId
        });
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        consumer.appData.remotePaused = false;
        if (!consumer.appData.localPaused) consumer.resume();
    }
    _onConsumerScore({ consumerId: consumerId, kind: kind, score: score }) {
        $1622be301bae0161$var$logger$1.info("_onConsumerScore()", {
            consumerId: consumerId,
            kind: kind,
            score: score
        });
        const { appData: { sourceClientId: sourceClientId } } = this._consumers.get(consumerId) || {
            appData: {}
        };
        if (sourceClientId) this._qualityMonitor.addConsumerScore(sourceClientId, consumerId, kind, score);
    }
    _onProducerScore({ producerId: producerId, kind: kind, score: score }) {
        $1622be301bae0161$var$logger$1.info("_onProducerScore()", {
            producerId: producerId,
            kind: kind,
            score: score
        });
        [
            this._micProducer,
            this._webcamProducer,
            this._screenVideoProducer,
            this._screenAudioProducer
        ].forEach((producer)=>{
            if ((producer === null || producer === void 0 ? void 0 : producer.id) === producerId) this._qualityMonitor.addProducerScore(this._selfId, producerId, kind, score);
        });
    }
    _onDataConsumerReady(options) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onDataConsumerReady()", {
                id: options.id,
                producerId: options.producerId
            });
            const consumer = yield this._receiveTransport.consumeData(options);
            this._dataConsumers.set(consumer.id, consumer);
            consumer.once("close", ()=>{
                this._dataConsumers.delete(consumer.id);
            });
            const { clientId: clientId } = consumer.appData;
            consumer.on("message", (message)=>{
                var _a;
                if (!this._micAnalyserDebugger) return;
                if (typeof message !== "string") return;
                const { score: score } = JSON.parse(message);
                if (score) (_a = this._micAnalyserDebugger) === null || _a === void 0 || _a.onConsumerScore(consumer.appData.clientId, score);
            });
            this._syncIncomingStreamsWithPWA(clientId);
        });
    }
    _onDataConsumerClosed({ dataConsumerId: dataConsumerId, reason: reason }) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            $1622be301bae0161$var$logger$1.info("_onDataConsumerClosed()", {
                dataConsumerId: dataConsumerId,
                reason: reason
            });
            const consumer = this._dataConsumers.get(dataConsumerId);
            consumer === null || consumer === void 0 || consumer.close();
        });
    }
    _onDominantSpeaker({ consumerId: consumerId }) {
        const consumer = this._consumers.get(consumerId);
        if (!consumer) return;
        const { sourceClientId: clientId } = consumer.appData;
        this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.DOMINANT_SPEAKER, {
            clientId: clientId
        });
    }
    _consumerClosedCleanup(consumer) {
        const { sourceClientId: clientId, screenShare: screenShare } = consumer.appData;
        const clientState = this._getOrCreateClientState(clientId);
        const stream = screenShare ? clientState.screenStream : clientState.webcamStream;
        if (!stream) return;
        stream.removeTrack(consumer.track);
        if (stream.getTracks().length === 0) {
            this._streamIdToVideoConsumerId.delete(stream.id);
            this._streamIdToVideoResolution.delete(stream.id);
            if (screenShare) {
                clientState.screenStream = null;
                clientState.hasEmittedScreenStream = false;
                clientState.screenShareStreamId = null;
            } else {
                clientState.hasEmittedWebcamStream = false;
                clientState.camStreamId = null;
            }
        }
    }
    _syncIncomingStreamsWithPWA(clientId) {
        var _a, _b;
        const clientState = this._getOrCreateClientState(clientId);
        const { webcamStream: webcamStream, screenStream: screenStream, hasEmittedWebcamStream: hasEmittedWebcamStream, hasEmittedScreenStream: hasEmittedScreenStream, hasAcceptedWebcamStream: hasAcceptedWebcamStream, hasAcceptedScreenStream: hasAcceptedScreenStream, screenShareStreamId: screenShareStreamId, camStreamId: camStreamId } = clientState;
        const toPauseConsumers = [];
        const toResumeConsumers = [];
        this._consumers.forEach((consumer)=>{
            if (consumer.appData.sourceClientId !== clientId) return;
            const hasAccepted = consumer.appData.screenShare ? hasAcceptedScreenStream : hasAcceptedWebcamStream;
            if (!consumer.appData.localPaused !== hasAccepted) {
                if (hasAccepted) {
                    if (!consumer.appData.remotePaused) consumer.resume();
                    consumer.appData.localPaused = false;
                    toResumeConsumers.push(consumer.id);
                } else {
                    consumer.pause();
                    consumer.appData.localPaused = true;
                    toPauseConsumers.push(consumer.id);
                }
            }
        });
        if (toPauseConsumers.length > 0) (_a = this._vegaConnection) === null || _a === void 0 || _a.message("pauseConsumers", {
            consumerIds: toPauseConsumers
        });
        if (toResumeConsumers.length > 0) (_b = this._vegaConnection) === null || _b === void 0 || _b.message("resumeConsumers", {
            consumerIds: toResumeConsumers
        });
        if (webcamStream && !hasEmittedWebcamStream && hasAcceptedWebcamStream) {
            this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                clientId: clientId,
                stream: webcamStream,
                streamId: camStreamId,
                streamType: "webcam"
            });
            clientState.hasEmittedWebcamStream = true;
        }
        if (screenStream && !hasEmittedScreenStream && hasAcceptedScreenStream) {
            this._emitToPWA($1622be301bae0161$export$fa3d5b535a2458a1.STREAM_ADDED, {
                clientId: clientId,
                stream: screenStream,
                streamId: screenShareStreamId,
                streamType: "screenshare"
            });
            clientState.hasEmittedScreenStream = true;
        }
    }
    _getOrCreateClientState(clientId) {
        let clientState = this._clientStates.get(clientId);
        if (!clientState) {
            clientState = {
                hasAcceptedWebcamStream: false,
                hasAcceptedScreenStream: false,
                hasEmittedWebcamStream: false,
                hasEmittedScreenStream: false,
                webcamStream: null,
                screenStream: null,
                screenShareStreamId: null,
                camStreamId: null
            };
            this._clientStates.set(clientId, clientState);
        }
        return clientState;
    }
    _emitToPWA(eventName, data) {
        this._emitter.emit(eventName, data);
    }
    _emitToSignal(eventName, data, callback) {
        this._serverSocket.emit(eventName, data, callback);
    }
    shouldAcceptStreamsFromBothSides() {
        return true;
    }
    setMicAnalyserDebugger(analyserDebugger) {
        this._micAnalyserDebugger = analyserDebugger;
    }
    setMicAnalyserParams(params) {
        var _a;
        (_a = this._micAnalyser) === null || _a === void 0 || _a.setParams(params);
    }
    hasClient(clientId) {
        return this._clientStates.has(clientId);
    }
    constructor({ selfId: selfId, room: room, emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features, eventClaim: eventClaim, deviceHandlerFactory: deviceHandlerFactory }){
        const { session: session, iceServers: iceServers, sfuServer: sfuServer, mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds } = room;
        this._selfId = selfId;
        this._room = room;
        this._roomSessionId = session === null || session === void 0 ? void 0 : session.id;
        this._emitter = emitter;
        this._serverSocket = serverSocket;
        this._webrtcProvider = webrtcProvider;
        this._features = features || {};
        this._eventClaim = eventClaim;
        this._vegaConnection = null;
        this._micAnalyser = null;
        this._micAnalyserDebugger = null;
        if (deviceHandlerFactory) this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerFactory: deviceHandlerFactory
        });
        else this._mediasoupDevice = new (0, $92a5db02d3c83225$exports.Device)({
            handlerName: $1622be301bae0161$export$30afcaff46935060()
        });
        this._routerRtpCapabilities = null;
        this._sendTransport = null;
        this._receiveTransport = null;
        this._clientStates = new Map();
        this._streamIdToVideoConsumerId = new Map();
        this._streamIdToVideoResolution = new Map();
        this._consumers = new Map();
        this._dataConsumers = new Map();
        this._localStreamDeregisterFunction = null;
        this._micTrack = null;
        this._webcamTrack = null;
        this._screenVideoTrack = null;
        this._screenAudioTrack = null;
        this._micProducer = null;
        this._micProducerPromise = null;
        this._micPaused = false;
        this._micScoreProducer = null;
        this._micScoreProducerPromise = null;
        this._webcamProducer = null;
        this._webcamProducerPromise = null;
        this._webcamPaused = false;
        this._screenVideoProducer = null;
        this._screenVideoProducerPromise = null;
        this._screenAudioProducer = null;
        this._screenAudioProducerPromise = null;
        this._sndTransportIceRestartPromise = null;
        this._rcvTransportIceRestartPromise = null;
        this._colocation = null;
        this._stopCameraTimeout = null;
        this._audioTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("audio_ended", {
                unloading: $1622be301bae0161$var$unloading
            });
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.MICROPHONE_STOPPED_WORKING, {});
        };
        this._videoTrackOnEnded = ()=>{
            $1622be301bae0161$export$6e1a0bfe9f2f0cbe.sendEvent("video_ended", {
                unloading: $1622be301bae0161$var$unloading
            });
            this._emitToPWA($1622be301bae0161$export$188476a9307fd26f.CAMERA_STOPPED_WORKING, {});
        };
        this._updateAndScheduleMediaServersRefresh({
            sfuServer: sfuServer,
            iceServers: iceServers.iceServers || [],
            mediaserverConfigTtlSeconds: mediaserverConfigTtlSeconds
        });
        this._socketListenerDeregisterFunctions = [];
        this._reconnect = true;
        this._reconnectTimeOut = null;
        this._hasVegaConnection = false;
        this._qualityMonitor = new $1622be301bae0161$export$9a5481974d870db4();
        this._qualityMonitor.on($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, (payload)=>{
            this._emitToPWA($1622be301bae0161$export$c4a74f263978d610.MEDIA_QUALITY_CHANGED, payload);
        });
    }
}
class $1622be301bae0161$export$b281485fb0422c89 {
    stopRtcManager() {
        if (this.currentManager) {
            this.currentManager.disconnectAll();
            this.emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_DESTROYED);
        }
    }
    constructor({ emitter: emitter, serverSocket: serverSocket, webrtcProvider: webrtcProvider, features: features }){
        this.emitter = emitter;
        this.currentManager = null;
        serverSocket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, ({ room: room, selfId: selfId, error: error, eventClaim: eventClaim })=>{
            if (error) return;
            const config = {
                selfId: selfId,
                room: room,
                emitter: emitter,
                serverSocket: serverSocket,
                webrtcProvider: webrtcProvider,
                features: features,
                eventClaim: eventClaim,
                deviceHandlerFactory: features === null || features === void 0 ? void 0 : features.deviceHandlerFactory
            };
            const isSfu = !!room.sfuServer;
            if (this.currentManager) {
                if (this.currentManager.isInitializedWith({
                    selfId: selfId,
                    roomName: room.name,
                    isSfu: isSfu
                })) {
                    if (this.currentManager.setEventClaim && eventClaim) this.currentManager.setEventClaim(eventClaim);
                    return;
                }
                this.currentManager.disconnectAll();
                emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_DESTROYED);
            }
            let rtcManager = null;
            if (isSfu) rtcManager = new $1622be301bae0161$export$b44cbfcf90b97eac(config);
            else rtcManager = new $1622be301bae0161$export$c67bf4e001e6de2(config);
            rtcManager.rtcStatsReconnect();
            rtcManager.setupSocketListeners();
            emitter.emit($1622be301bae0161$export$fa3d5b535a2458a1.RTC_MANAGER_CREATED, {
                rtcManager: rtcManager
            });
            this.currentManager = rtcManager;
            serverSocket.setRtcManager(rtcManager);
        });
    }
}
var $1622be301bae0161$export$e781598da8ea5f70;
(function(RtcEventNames) {
    RtcEventNames["rtc_manager_created"] = "rtc_manager_created";
    RtcEventNames["stream_added"] = "stream_added";
})($1622be301bae0161$export$e781598da8ea5f70 || ($1622be301bae0161$export$e781598da8ea5f70 = {}));
class $1622be301bae0161$var$AssertionError extends Error {
    constructor(options){
        super(options.message);
        this.name = "AssertionError";
        this.code = "ERR_ASSERTION";
        this.actual = options.actual;
        this.expected = options.expected;
        this.operator = options.operator;
        if (Error.captureStackTrace) Error.captureStackTrace(this, options.stackStartFn);
    }
}
function $1622be301bae0161$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        let generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        const err = new $1622be301bae0161$var$AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
function $1622be301bae0161$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1622be301bae0161$var$AssertionError(obj);
}
function $1622be301bae0161$var$ok(...args) {
    $1622be301bae0161$var$innerOk($1622be301bae0161$var$ok, args.length, ...args);
}
const $1622be301bae0161$export$a7a9523472993e97 = {
    fail: (message)=>{
        $1622be301bae0161$var$innerFail({
            actual: "fail()",
            expected: "fail() should not be called",
            message: message,
            operator: "fail",
            stackStartFn: $1622be301bae0161$export$a7a9523472993e97.fail
        });
    },
    ok: $1622be301bae0161$var$ok
};
$1622be301bae0161$export$a7a9523472993e97.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new Error("'actual' and 'expected' arguments are required");
    if (actual == expected) $1622be301bae0161$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
$1622be301bae0161$export$a7a9523472993e97.ok = $1622be301bae0161$var$ok;
const $1622be301bae0161$export$208cffe87ba62b51 = (fn)=>{
    return new Worker(URL.createObjectURL(new Blob([
        "self.onmessage = ",
        fn.toString()
    ], {
        type: "text/javascript"
    })));
};
const $1622be301bae0161$export$318f15d7900e4898 = (count)=>{
    if (count === 0) return "";
    const count2 = count / 2;
    let result = "F";
    while(result.length <= count2)result += result;
    return result + result.substring(0, count - result.length);
};
const $1622be301bae0161$var$logger = new $1622be301bae0161$export$efa9a398d6368992();
class $1622be301bae0161$export$7dedc58743a41a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($0bfd6a77e39eae31$exports))) {
    _onRoomJoined(payload) {
        var _a, _b;
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            this.reconnectThresholdInMs = (payload.disconnectTimeout || 0) * 0.8;
            if (!((_a = payload.room) === null || _a === void 0 ? void 0 : _a.clients)) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            if (!payload.selfId) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            const myDeviceId = (_b = payload.room.clients.find((c)=>payload.selfId === c.id)) === null || _b === void 0 ? void 0 : _b.deviceId;
            if (!myDeviceId) {
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            if (!this._signalDisconnectTime) {
                this._resetClientState(payload);
                payload.room.clients = payload.room.clients.filter((c)=>!(c.deviceId === myDeviceId && c.isPendingToLeave));
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                return;
            }
            const RECONNECT_THRESHOLD = payload.disconnectTimeout * 0.8;
            const timeSinceDisconnect = Date.now() - this._signalDisconnectTime;
            if (timeSinceDisconnect > RECONNECT_THRESHOLD) {
                this._resetClientState(payload);
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
                this.metrics.roomJoinedLate++;
                return;
            }
            payload.room.clients = payload.room.clients.filter((c)=>!(c.deviceId === myDeviceId && c.isPendingToLeave));
            const allStats = yield $1622be301bae0161$export$a95105d8b2471e00();
            payload.room.clients.forEach((client)=>{
                var _a;
                try {
                    if (client.id === payload.selfId) return;
                    if (!this._clients[client.id]) {
                        this._addClientToState(client);
                        return;
                    }
                    if (!((_a = this.rtcManager) === null || _a === void 0 ? void 0 : _a.hasClient(client.id))) return;
                    if (this._hasClientStateChanged({
                        clientId: client.id,
                        webcam: client.isVideoEnabled,
                        mic: client.isAudioEnabled,
                        screenShare: client.streams.length > 1
                    })) return;
                    if (this._wasClientSendingMedia(client.id)) {
                        if (!this._isClientMediaActive(allStats, client.id)) return;
                    }
                    client.mergeWithOldClientState = true;
                } catch (error) {
                    $1622be301bae0161$var$logger.error("Failed to evaluate if we should merge client state %o", error);
                    this.metrics.evaluationFailed++;
                }
            });
            payload.room.clients.forEach((c)=>{
                if (c.isPendingToLeave) this._onPendingClientLeft({
                    clientId: c.id
                });
            });
            this.metrics.roomJoined++;
            this.emit($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, payload);
        });
    }
    _onClientLeft(payload) {
        var _a;
        const { clientId: clientId } = payload;
        const client = this._clients[clientId];
        if (client) {
            clearTimeout(client.timeout);
            delete this._clients[clientId];
        }
        (_a = this.rtcManager) === null || _a === void 0 || _a.disconnect(clientId, null, payload.eventClaim);
        this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, payload);
    }
    _onPendingClientLeft(payload) {
        const { clientId: clientId } = payload;
        const client = this._clients[clientId];
        if (!client) {
            $1622be301bae0161$var$logger.warn(`client ${clientId} not found`);
            return;
        }
        if (client.isPendingToLeave) return;
        client.isPendingToLeave = true;
        if (this._wasClientSendingMedia(clientId)) {
            client.checkActiveMediaAttempts = 0;
            this._abortIfNotActive(payload);
        }
    }
    _onNewClient(payload) {
        const { client: { id: clientId, deviceId: deviceId } } = payload;
        const client = this._clients[clientId];
        if (client && client.isPendingToLeave) {
            clearTimeout(client.timeoutHandler);
            client.isPendingToLeave = false;
            this.metrics.pendingClientCanceled++;
            return;
        }
        this._getPendingClientsByDeviceId(deviceId).forEach((client)=>{
            clearTimeout(client.timeoutHandler);
            client.isPendingToLeave = undefined;
            this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, {
                clientId: client.clientId
            });
        });
        this._addClientToState(payload.client);
        this.emit($1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT, payload);
    }
    _abortIfNotActive(payload) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const { clientId: clientId } = payload;
            let client = this._clients[clientId];
            if (!(client === null || client === void 0 ? void 0 : client.isPendingToLeave)) return;
            client.checkActiveMediaAttempts++;
            if (client.checkActiveMediaAttempts > 3) return;
            const stillActive = yield this._checkIsActive(clientId);
            if (stillActive) {
                client.timeoutHandler = setTimeout(()=>this._abortIfNotActive(payload), 500);
                return;
            }
            client = this._clients[clientId];
            if (client === null || client === void 0 ? void 0 : client.isPendingToLeave) {
                clearTimeout(client.timeoutHandler);
                delete this._clients[clientId];
                this.emit($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, payload);
            }
        });
    }
    _checkIsActive(clientId) {
        return $1622be301bae0161$var$__awaiter(this, void 0, void 0, function*() {
            const allStats = yield $1622be301bae0161$export$a95105d8b2471e00();
            return this._isClientMediaActive(allStats, clientId);
        });
    }
    _isClientMediaActive(stats, clientId) {
        const clientStats = stats === null || stats === void 0 ? void 0 : stats[clientId];
        let isActive = false;
        if (clientStats) Object.entries(clientStats.tracks).forEach(([trackId, trackStats])=>{
            if (trackId !== "probator") Object.values(trackStats.ssrcs).forEach((ssrcStats)=>{
                if ((ssrcStats.bitrate || 0) > 0) isActive = true;
            });
        });
        return isActive;
    }
    _onAudioEnabled(payload) {
        const { clientId: clientId, isAudioEnabled: isAudioEnabled } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isAudioEnabled: isAudioEnabled
        });
    }
    _onVideoEnabled(payload) {
        const { clientId: clientId, isVideoEnabled: isVideoEnabled } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isVideoEnabled: isVideoEnabled
        });
    }
    _onScreenshareChanged(payload, action) {
        const { clientId: clientId } = payload;
        this._clients[clientId] = Object.assign(Object.assign({}, this._clients[clientId] || {}), {
            isScreenshareEnabled: action
        });
    }
    _hasClientStateChanged({ clientId: clientId, webcam: webcam, mic: mic, screenShare: screenShare }) {
        const state = this._clients[clientId];
        if (!state) throw new Error(`Client ${clientId} not found in ReconnectManager state`);
        if (webcam !== state.isVideoEnabled) return true;
        if (mic !== state.isAudioEnabled) return true;
        if (screenShare !== state.isScreenshareEnabled) return true;
        return false;
    }
    _addClientToState(newClient) {
        this._clients[newClient.id] = Object.assign(Object.assign({}, this._clients[newClient.id] || {}), {
            isAudioEnabled: newClient.isAudioEnabled,
            isVideoEnabled: newClient.isVideoEnabled,
            isScreenshareEnabled: newClient.streams.length > 1,
            deviceId: newClient.deviceId,
            isPendingToLeave: newClient.isPendingToLeave,
            clientId: newClient.id
        });
    }
    _wasClientSendingMedia(clientId) {
        const client = this._clients[clientId];
        if (!client) throw new Error(`Client ${clientId} not found in ReconnectManager state`);
        return client.isAudioEnabled || client.isVideoEnabled || client.isScreenshareEnabled;
    }
    _getPendingClientsByDeviceId(deviceId) {
        return Object.values(this._clients).filter((clientState)=>{
            return clientState.deviceId === deviceId && clientState.isPendingToLeave;
        });
    }
    _resetClientState(payload) {
        this._clients = {};
        payload.room.clients.forEach((client)=>{
            if (client.id === payload.selfId) return;
            else this._addClientToState(client);
        });
    }
    constructor(socket){
        super();
        this.reconnectThresholdInMs = 0;
        this._socket = socket;
        this._clients = {};
        this._signalDisconnectTime = undefined;
        this.rtcManager = undefined;
        this.metrics = {
            roomJoinedLate: 0,
            pendingClientCanceled: 0,
            evaluationFailed: 0,
            roomJoined: 0
        };
        socket.on("disconnect", ()=>{
            this._signalDisconnectTime = Date.now();
        });
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED, (payload)=>this._onRoomJoined(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT, (payload)=>this._onNewClient(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT, (payload)=>this._onClientLeft(payload));
        socket.on($1622be301bae0161$export$c4a74f263978d610.PENDING_CLIENT_LEFT, (payload)=>this._onPendingClientLeft(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.AUDIO_ENABLED, (payload)=>this._onAudioEnabled(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.VIDEO_ENABLED, (payload)=>this._onVideoEnabled(payload));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.SCREENSHARE_STARTED, (payload)=>this._onScreenshareChanged(payload, true));
        socket.on($1622be301bae0161$export$f128bfe5688cdcff.SCREENSHARE_STOPPED, (payload)=>this._onScreenshareChanged(payload, false));
    }
}
var $1622be301bae0161$var$_a;
const $1622be301bae0161$var$adapter = ($1622be301bae0161$var$_a = (0, $c1c5c7a85a539550$export$2e2bcd8739ae039).default) !== null && $1622be301bae0161$var$_a !== void 0 ? $1622be301bae0161$var$_a : (0, $c1c5c7a85a539550$export$2e2bcd8739ae039);
const $1622be301bae0161$var$DEFAULT_SOCKET_PATH = "/protocol/socket.io/v4";
const $1622be301bae0161$var$NOOP_KEEPALIVE_INTERVAL = 2000;
class $1622be301bae0161$export$f44d178d723e910b {
    setRtcManager(rtcManager) {
        if (this._reconnectManager) this._reconnectManager.rtcManager = rtcManager;
    }
    connect() {
        if (this.isConnected() || this.isConnecting()) return;
        this._socket.open();
    }
    disconnect() {
        this._socket.disconnect();
    }
    disconnectOnConnect() {
        this._socket.once("connect", ()=>{
            this._socket.disconnect();
        });
    }
    emit(eventName, ...args) {
        this._socket.emit.apply(this._socket, arguments);
    }
    emitIfConnected(eventName, data) {
        if (!this.isConnected()) return;
        this.emit(eventName, data);
    }
    getTransport() {
        return this._socket && this._socket.io && this._socket.io.engine && this._socket.io.engine.transport && this._socket.io.engine.transport.name;
    }
    getManager() {
        return this._socket.io;
    }
    isConnecting() {
        return this._socket && this._socket.connecting;
    }
    isConnected() {
        return this._socket && this._socket.connected;
    }
    on(eventName, handler) {
        const relayableEvents = [
            $1622be301bae0161$export$f128bfe5688cdcff.ROOM_JOINED,
            $1622be301bae0161$export$f128bfe5688cdcff.CLIENT_LEFT,
            $1622be301bae0161$export$f128bfe5688cdcff.NEW_CLIENT
        ];
        if (this._reconnectManager && relayableEvents.includes(eventName)) return this._interceptEvent(eventName, handler);
        this._socket.on(eventName, handler);
        return ()=>{
            this._socket.off(eventName, handler);
        };
    }
    once(eventName, handler) {
        this._socket.once(eventName, handler);
    }
    off(eventName, handler) {
        this._socket.off(eventName, handler);
    }
    _interceptEvent(eventName, handler) {
        if (this._reconnectManager) this._reconnectManager.on(eventName, handler);
        return ()=>{
            if (this._reconnectManager) this._reconnectManager.removeListener(eventName, handler);
        };
    }
    getGlitchFreeMetrics() {
        var _a;
        return (_a = this._reconnectManager) === null || _a === void 0 ? void 0 : _a.metrics;
    }
    getReconnectThreshold() {
        var _a;
        return (_a = this._reconnectManager) === null || _a === void 0 ? void 0 : _a.reconnectThresholdInMs;
    }
    constructor(hostName, optionsOverrides, glitchFree = false){
        this._wasConnectedUsingWebsocket = false;
        this._reconnectManager = null;
        this._socket = (0, $3e27f9daa0204a44$export$841407ceb083bd74)(hostName, Object.assign({
            path: $1622be301bae0161$var$DEFAULT_SOCKET_PATH,
            randomizationFactor: 0.5,
            reconnectionDelay: 250,
            reconnectionDelayMax: 5000,
            timeout: 5000,
            transports: [
                "websocket"
            ],
            withCredentials: true
        }, optionsOverrides));
        this._socket.io.on("reconnect", ()=>{
            this._socket.sendBuffer = [];
        });
        this._socket.io.on("reconnect_attempt", ()=>{
            if (this._wasConnectedUsingWebsocket) {
                this._socket.io.opts.transports = [
                    "websocket"
                ];
                if ($1622be301bae0161$var$adapter.browserDetails.browser !== "safari") delete this._wasConnectedUsingWebsocket;
            } else this._socket.io.opts.transports = [
                "websocket",
                "polling"
            ];
        });
        if (glitchFree) this._reconnectManager = new $1622be301bae0161$export$7dedc58743a41a9(this._socket);
        this._socket.on("connect", ()=>{
            const transport = this.getTransport();
            if (transport === "websocket") {
                this._wasConnectedUsingWebsocket = true;
                if (!this.noopKeepaliveInterval) this.noopKeepaliveInterval = setInterval(()=>{
                    try {
                        if (this._socket.connected) this._socket.io.engine.sendPacket("noop");
                    } catch (ex) {}
                }, $1622be301bae0161$var$NOOP_KEEPALIVE_INTERVAL);
            }
        });
        this._socket.on("disconnect", ()=>{
            this.disconnectTimestamp = Date.now();
            if (this.noopKeepaliveInterval) {
                clearInterval(this.noopKeepaliveInterval);
                this.noopKeepaliveInterval = null;
            }
        });
    }
}
const $1622be301bae0161$var$defaultSubdomainPattern = /^(?:([^.]+)[.])?((:?[^.]+[.]){1,}[^.]+)$/;
const $1622be301bae0161$var$localstackPattern = /^(?:([^.]+)-)?(ip-[^.]*[.](?:hereby[.]dev|rfc1918[.]disappear[.]at)(?::\d+|))$/;
const $1622be301bae0161$var$localhostPattern = /^(?:([^.]+)[.])?(localhost:?\d*)/;
const $1622be301bae0161$var$serverPattern = /^(?:([^.]+)[.])?(server:?\d*)/;
const $1622be301bae0161$var$ipv4Pattern = /^(?:([^.]+)[.])?((\d+[.]){3}:?\d*)$/;
const $1622be301bae0161$var$subdomainPatterns = [
    {
        pattern: $1622be301bae0161$var$serverPattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$localhostPattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$ipv4Pattern,
        separator: "."
    },
    {
        pattern: $1622be301bae0161$var$localstackPattern,
        separator: "-"
    },
    {
        pattern: $1622be301bae0161$var$defaultSubdomainPattern,
        separator: "."
    }
];
function $1622be301bae0161$export$a08dede735aa5b41({ host: host = "whereby.com", protocol: protocol = "https:" } = {}) {
    let subdomain = "";
    let domain = host;
    let subdomainSeparator = ".";
    for (const { separator: separator, pattern: pattern } of $1622be301bae0161$var$subdomainPatterns){
        const match = pattern.exec(host);
        if (match) {
            subdomain = match[1] || "";
            domain = match[2];
            subdomainSeparator = separator;
            break;
        }
    }
    const organizationDomain = !subdomain ? domain : `${subdomain}${subdomainSeparator}${domain}`;
    return {
        domain: domain,
        domainWithSeparator: `${subdomainSeparator}${domain}`,
        organizationDomain: organizationDomain,
        organization: `${protocol}//${organizationDomain}`,
        service: `${protocol}//${domain}`,
        subdomain: subdomain
    };
}
$1622be301bae0161$export$a08dede735aa5b41(window && window.location);



var $cqkQU = parcelRequire("cqkQU");

var $029faa47ad838cc6$exports = {};

var $dVJB2 = parcelRequire("dVJB2");
var $029faa47ad838cc6$require$Buffer = $dVJB2.Buffer;
(function() {
    "use strict";
    function btoa(str) {
        var buffer;
        if (str instanceof $029faa47ad838cc6$require$Buffer) buffer = str;
        else buffer = $029faa47ad838cc6$require$Buffer.from(str.toString(), "binary");
        return buffer.toString("base64");
    }
    $029faa47ad838cc6$exports = btoa;
})();


parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");
function $4fc09928452de42f$export$cdf9d0e702cbbe4b(typePrefix, payloadCreator) {
    return (0, $58dad493bd6ec980$export$6abd22dc03e5063f)(typePrefix, payloadCreator);
}
function $4fc09928452de42f$export$495454f275c5f192(thunk) {
    return thunk;
}
function $4fc09928452de42f$export$ba71e51cd1168d8d(authorizationSelector, thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const isAuthorized = authorizationSelector(getState());
            if (!isAuthorized) {
                console.warn("Not authorized to perform this action");
                return false;
            }
            return thunk(payload)(dispatch, getState, extra);
        });
}
function $4fc09928452de42f$export$f3d6a2157932333f(thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const connectionStatus = getState().roomConnection.status;
            if (connectionStatus !== "connected") {
                console.warn("Action cannot be performed outside of a connected room");
                return false;
            }
            return thunk(payload)(dispatch, getState, extra);
        });
}
function $4fc09928452de42f$export$7a92a3664c4cb7d1(typePrefix, payloadCreator) {
    return $4fc09928452de42f$export$cdf9d0e702cbbe4b(typePrefix, (arg, thunkApi)=>{
        const { getState: getState } = thunkApi;
        const connectionStatus = getState().roomConnection.status;
        if (connectionStatus !== "connected") {
            console.warn("Action cannot be performed outside of a connected room");
            return Promise.reject("Action cannot be performed outside of a connected room");
        }
        return payloadCreator(arg, thunkApi);
    });
}
function $4fc09928452de42f$export$8ffe952306980b53(authorizationSelector, thunk) {
    return $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState, extra)=>{
            const connectionStatus = getState().roomConnection.status;
            if (connectionStatus !== "connected") {
                console.warn("Action cannot be performed outside of a connected room");
                return false;
            }
            return $4fc09928452de42f$export$ba71e51cd1168d8d(authorizationSelector, thunk)(payload)(dispatch, getState, extra);
        });
}
const $4fc09928452de42f$export$1992b10a91137ec8 = (0, $58dad493bd6ec980$export$1228acebbbcb485b)();
const $4fc09928452de42f$export$4e3495129325ad89 = $4fc09928452de42f$export$1992b10a91137ec8.startListening;
const $4fc09928452de42f$export$12515b85036caad1 = (0, $58dad493bd6ec980$export$f03a6b845d3fb58b);
const $4fc09928452de42f$export$a818dc83df27d0f4 = (selectors, callback)=>{
    return $4fc09928452de42f$export$4e3495129325ad89({
        predicate: (_, currentState, previousState)=>{
            const previousValues = selectors.map((selector)=>selector(previousState));
            const currentValues = selectors.map((selector)=>selector(currentState));
            return previousValues.some((previousValue, index)=>previousValue !== currentValues[index]);
        },
        effect: (action, { dispatch: dispatch, getState: getState, extra: extra })=>{
            const selectorResults = selectors.map((selector)=>selector(getState()));
            callback({
                dispatch: dispatch,
                getState: getState,
                extra: extra
            }, ...selectorResults);
        }
    });
};
const $4fc09928452de42f$var$coreVersion = "0.28.2";
const $4fc09928452de42f$export$d4c72bab9d6cc13a = {
    isNodeSdk: false,
    isActive: false,
    isDialIn: false,
    roomName: null,
    roomUrl: null,
    displayName: null,
    userAgent: `core:${$4fc09928452de42f$var$coreVersion}`,
    externalId: null
};
const $4fc09928452de42f$export$7a3bdf7180628a3c = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "app",
    initialState: $4fc09928452de42f$export$d4c72bab9d6cc13a,
    reducers: {
        doAppStart: (state, action)=>{
            const url = new URL(action.payload.roomUrl);
            return Object.assign(Object.assign(Object.assign({}, state), action.payload), {
                roomName: url.pathname,
                initialConfig: Object.assign({}, action.payload),
                isActive: true
            });
        },
        doAppStop: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isActive: false
            });
        }
    }
});
const { doAppStop: $4fc09928452de42f$export$d4d0f76450fb6374, doAppStart: $4fc09928452de42f$export$ca0cd7d9bebf6bc8 } = $4fc09928452de42f$export$7a3bdf7180628a3c.actions;
const $4fc09928452de42f$export$95809f86f8668b38 = (state)=>state.app;
const $4fc09928452de42f$export$ae5e487c0972282e = (state)=>state.app.isActive;
const $4fc09928452de42f$export$442c6682ecfaaef2 = (state)=>state.app.isDialIn;
const $4fc09928452de42f$export$2664cf73474d4255 = (state)=>state.app.roomName;
const $4fc09928452de42f$export$c6d654d892432c6b = (state)=>state.app.roomUrl;
const $4fc09928452de42f$export$b157fc4c059768ed = (state)=>state.app.displayName;
const $4fc09928452de42f$export$6f409a475b0c8c60 = (state)=>state.app.userAgent;
const $4fc09928452de42f$export$44202ee237048d77 = (state)=>state.app.externalId;
const $4fc09928452de42f$export$ab78798f462babdb = (state)=>state.app.isNodeSdk;
const $4fc09928452de42f$export$36ad109efa214adf = (state)=>state.app.initialConfig;
function $4fc09928452de42f$var$createSignalEventAction(name) {
    return (0, $58dad493bd6ec980$export$309c7a02b0b0bc62)(`signalConnection/event/${name}`);
}
const $4fc09928452de42f$export$6c507f583d588b9f = {
    audioEnabled: $4fc09928452de42f$var$createSignalEventAction("audioEnabled"),
    audioEnableRequested: $4fc09928452de42f$var$createSignalEventAction("audioEnableRequested"),
    chatMessage: $4fc09928452de42f$var$createSignalEventAction("chatMessage"),
    clientLeft: $4fc09928452de42f$var$createSignalEventAction("clientLeft"),
    clientKicked: $4fc09928452de42f$var$createSignalEventAction("clientKicked"),
    clientMetadataReceived: $4fc09928452de42f$var$createSignalEventAction("clientMetadataReceived"),
    clientUnableToJoin: $4fc09928452de42f$var$createSignalEventAction("clientUnableToJoin"),
    cloudRecordingStarted: $4fc09928452de42f$var$createSignalEventAction("cloudRecordingStarted"),
    cloudRecordingStopped: $4fc09928452de42f$var$createSignalEventAction("cloudRecordingStopped"),
    disconnect: $4fc09928452de42f$var$createSignalEventAction("disconnect"),
    knockerLeft: $4fc09928452de42f$var$createSignalEventAction("knockerLeft"),
    knockHandled: $4fc09928452de42f$var$createSignalEventAction("knockHandled"),
    newClient: $4fc09928452de42f$var$createSignalEventAction("newClient"),
    roomJoined: $4fc09928452de42f$var$createSignalEventAction("roomJoined"),
    roomKnocked: $4fc09928452de42f$var$createSignalEventAction("roomKnocked"),
    roomLeft: $4fc09928452de42f$var$createSignalEventAction("roomLeft"),
    roomLocked: $4fc09928452de42f$var$createSignalEventAction("roomLocked"),
    roomSessionEnded: $4fc09928452de42f$var$createSignalEventAction("roomSessionEnded"),
    screenshareStarted: $4fc09928452de42f$var$createSignalEventAction("screenshareStarted"),
    screenshareStopped: $4fc09928452de42f$var$createSignalEventAction("screenshareStopped"),
    spotlightAdded: $4fc09928452de42f$var$createSignalEventAction("spotlightAdded"),
    spotlightRemoved: $4fc09928452de42f$var$createSignalEventAction("spotlightRemoved"),
    streamingStopped: $4fc09928452de42f$var$createSignalEventAction("streamingStopped"),
    videoEnabled: $4fc09928452de42f$var$createSignalEventAction("videoEnabled"),
    videoEnableRequested: $4fc09928452de42f$var$createSignalEventAction("videoEnableRequested"),
    liveTranscriptionStarted: $4fc09928452de42f$var$createSignalEventAction("liveTranscriptionStarted"),
    liveTranscriptionStopped: $4fc09928452de42f$var$createSignalEventAction("liveTranscriptionStopped")
};
const $4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE = {
    canLockRoom: [
        "host"
    ],
    canRequestAudioEnable: [
        "host"
    ],
    canRequestVideoEnable: [
        "host"
    ],
    canKickClient: [
        "host"
    ],
    canEndMeeting: [
        "host"
    ],
    canAskToSpeak: [
        "host"
    ],
    canSpotlight: [
        "host"
    ]
};
const $4fc09928452de42f$var$initialState$f = {
    roomKey: null,
    roleName: "none"
};
const $4fc09928452de42f$export$a8061e375981838e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "authorization",
    initialState: $4fc09928452de42f$var$initialState$f,
    reducers: {
        setRoomKey: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                roomKey: action.payload
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                roomKey: action.payload.roomKey
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const client = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.clients.find((c)=>{
                var _a;
                return c.id === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.selfId);
            });
            return Object.assign(Object.assign({}, state), {
                roleName: (client === null || client === void 0 ? void 0 : client.role.roleName) || "none"
            });
        });
    }
});
const { setRoomKey: $4fc09928452de42f$export$4aa6cbb228087bb } = $4fc09928452de42f$export$a8061e375981838e.actions;
const $4fc09928452de42f$export$4040db2373332c60 = (state)=>state.authorization.roomKey;
const $4fc09928452de42f$export$c3921fe844b67c95 = (state)=>state.authorization.roleName;
const $4fc09928452de42f$export$dbb7a81a8f843adc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canLockRoom.includes(localParticipantRole));
const $4fc09928452de42f$export$a15ccd242dd0951b = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canRequestAudioEnable.includes(localParticipantRole));
const $4fc09928452de42f$export$84f3acf25e9c1055 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canRequestVideoEnable.includes(localParticipantRole));
const $4fc09928452de42f$export$e73be439ab5a8e31 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canKickClient.includes(localParticipantRole));
const $4fc09928452de42f$export$69a43832a7c34f54 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canEndMeeting.includes(localParticipantRole));
const $4fc09928452de42f$export$c53e10fe73bac35f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canAskToSpeak.includes(localParticipantRole));
const $4fc09928452de42f$export$7ad9182b247dbca0 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$c3921fe844b67c95, (localParticipantRole)=>$4fc09928452de42f$var$ROOM_ACTION_PERMISSIONS_BY_ROLE.canSpotlight.includes(localParticipantRole));
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $4fc09928452de42f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fc09928452de42f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $4fc09928452de42f$var$initialState$e = {
    isFetching: false,
    data: null
};
const $4fc09928452de42f$export$601059773552eb94 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "deviceCredentials",
    initialState: $4fc09928452de42f$var$initialState$e,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                data: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$a9bace7063f4ee1e.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
    }
});
const $4fc09928452de42f$export$a9bace7063f4ee1e = $4fc09928452de42f$export$cdf9d0e702cbbe4b("deviceCredentials/doGetDeviceCredentials", (payload, { extra: extra })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const deviceCredentials = yield extra.services.credentialsService.getCredentials();
            return deviceCredentials;
        } catch (error) {
            console.error(error);
        }
    }));
const $4fc09928452de42f$export$658d1957bbe5d193 = (state)=>state.deviceCredentials;
const $4fc09928452de42f$export$1fabdcbf2ec44a8e = (state)=>{
    var _a;
    return !!((_a = state.deviceCredentials.data) === null || _a === void 0 ? void 0 : _a.credentials);
};
const $4fc09928452de42f$export$595744fa227922ad = (state)=>{
    var _a, _b;
    return (_b = (_a = state.deviceCredentials.data) === null || _a === void 0 ? void 0 : _a.credentials) === null || _b === void 0 ? void 0 : _b.uuid;
};
const $4fc09928452de42f$export$53b9c47f466bd445 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$658d1957bbe5d193, (appIsActive, deviceCredentials)=>{
    if (appIsActive && !deviceCredentials.isFetching && !deviceCredentials.data) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$53b9c47f466bd445
], ({ dispatch: dispatch }, shouldFetchDeviceCredentials)=>{
    if (shouldFetchDeviceCredentials) dispatch($4fc09928452de42f$export$a9bace7063f4ee1e());
});
function $4fc09928452de42f$var$forwardSocketEvents(socket, dispatch) {
    socket.on("room_joined", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomJoined(payload)));
    socket.on("new_client", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.newClient(payload)));
    socket.on("client_left", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientLeft(payload)));
    socket.on("client_kicked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientKicked(payload)));
    socket.on("client_unable_to_join", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientUnableToJoin(payload)));
    socket.on("audio_enabled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.audioEnabled(payload)));
    socket.on("video_enabled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.videoEnabled(payload)));
    socket.on("audio_enable_requested", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested(payload)));
    socket.on("client_metadata_received", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived(payload)));
    socket.on("chat_message", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.chatMessage(payload)));
    socket.on("disconnect", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.disconnect()));
    socket.on("room_knocked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomKnocked(payload)));
    socket.on("room_left", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomLeft()));
    socket.on("room_locked", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomLocked(payload)));
    socket.on("room_session_ended", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded(payload)));
    socket.on("knocker_left", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.knockerLeft(payload)));
    socket.on("knock_handled", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.knockHandled(payload)));
    socket.on("screenshare_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.screenshareStarted(payload)));
    socket.on("screenshare_stopped", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.screenshareStopped(payload)));
    socket.on("cloud_recording_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStarted(payload)));
    socket.on("cloud_recording_stopped", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStopped()));
    socket.on("streaming_stopped", ()=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.streamingStopped()));
    socket.on("spotlight_added", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.spotlightAdded(payload)));
    socket.on("spotlight_removed", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.spotlightRemoved(payload)));
    socket.on("live_transcription_started", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.liveTranscriptionStarted(payload)));
    socket.on("live_transcription_stopped", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.liveTranscriptionStopped(payload)));
    socket.on("video_enable_requested", (payload)=>dispatch($4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested(payload)));
}
const $4fc09928452de42f$var$SIGNAL_BASE_URL = "wss://signal.appearin.net";
function $4fc09928452de42f$var$createSocket() {
    const parsedUrl = new URL($4fc09928452de42f$var$SIGNAL_BASE_URL);
    const socketHost = parsedUrl.origin;
    const socketOverrides = {
        autoConnect: false
    };
    return new (0, $1622be301bae0161$export$f44d178d723e910b)(socketHost, socketOverrides);
}
const $4fc09928452de42f$var$initialState$d = {
    deviceIdentified: false,
    isIdentifyingDevice: false,
    status: "ready",
    socket: null
};
const $4fc09928452de42f$export$1010602111efdae4 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "signalConnection",
    initialState: $4fc09928452de42f$var$initialState$d,
    reducers: {
        socketConnecting: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "connecting"
            });
        },
        socketConnected: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                socket: action.payload,
                status: "connected"
            });
        },
        socketDisconnected: (state)=>{
            return Object.assign(Object.assign({}, state), {
                socket: null,
                deviceIdentified: false,
                status: "disconnected"
            });
        },
        socketReconnecting: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        },
        deviceIdentifying: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isIdentifyingDevice: true
            });
        },
        deviceIdentified: (state)=>{
            return Object.assign(Object.assign({}, state), {
                deviceIdentified: true,
                isIdentifyingDevice: false
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.disconnect, (state)=>{
            return Object.assign(Object.assign({}, state), {
                deviceIdentified: false,
                status: "disconnected"
            });
        });
    }
});
const { deviceIdentifying: $4fc09928452de42f$export$bc51939d2f2cd4a, deviceIdentified: $4fc09928452de42f$export$57ca09c85670100e, socketConnected: $4fc09928452de42f$export$48b6ca2220db698a, socketConnecting: $4fc09928452de42f$export$d25d75f4bdc4482, socketDisconnected: $4fc09928452de42f$export$7b77b29673fc6d37, socketReconnecting: $4fc09928452de42f$export$fb604b2ee1249ba5 } = $4fc09928452de42f$export$1010602111efdae4.actions;
const $4fc09928452de42f$export$1ec5c2b17c26996e = $4fc09928452de42f$export$495454f275c5f192(()=>{
    return (dispatch, getState)=>{
        if ($4fc09928452de42f$export$efc69c8f0644aa20(getState())) return;
        dispatch($4fc09928452de42f$export$d25d75f4bdc4482());
        const socket = $4fc09928452de42f$var$createSocket();
        socket.on("connect", ()=>dispatch($4fc09928452de42f$export$48b6ca2220db698a(socket)));
        socket.on("device_identified", ()=>dispatch($4fc09928452de42f$export$57ca09c85670100e()));
        socket.getManager().on("reconnect", ()=>dispatch($4fc09928452de42f$export$fb604b2ee1249ba5()));
        $4fc09928452de42f$var$forwardSocketEvents(socket, dispatch);
        socket.connect();
    };
});
const $4fc09928452de42f$export$6313658c703ceaf8 = $4fc09928452de42f$export$495454f275c5f192(({ deviceCredentials: deviceCredentials })=>(dispatch, getState)=>{
        const state = getState();
        const signalSocket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        const deviceIdentified = $4fc09928452de42f$export$f861d0329c5966c4(state);
        if (!signalSocket) return;
        if (deviceIdentified) return;
        signalSocket.emit("identify_device", {
            deviceCredentials: deviceCredentials
        });
        dispatch($4fc09928452de42f$export$bc51939d2f2cd4a());
    });
const $4fc09928452de42f$export$662ce9a66e2e97d8 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const signalStatus = $4fc09928452de42f$export$fb9576bb0af6ec25(state);
        if (signalStatus === "connected") {
            const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
            socket === null || socket === void 0 || socket.disconnect();
            dispatch($4fc09928452de42f$export$7b77b29673fc6d37());
        }
    });
const $4fc09928452de42f$export$b12d0ae99b4b2470 = (state)=>state.signalConnection;
const $4fc09928452de42f$export$3ee4dc1d6a8ff538 = (state)=>state.signalConnection.isIdentifyingDevice;
const $4fc09928452de42f$export$f861d0329c5966c4 = (state)=>state.signalConnection.deviceIdentified;
const $4fc09928452de42f$export$fb9576bb0af6ec25 = (state)=>state.signalConnection.status;
const $4fc09928452de42f$export$efc69c8f0644aa20 = (state)=>state.signalConnection.socket;
const $4fc09928452de42f$export$e5344360f2c7d7e8 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$fb9576bb0af6ec25, (appIsActive, signalStatus)=>{
    if (appIsActive && [
        "ready",
        "reconnecting"
    ].includes(signalStatus)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e5344360f2c7d7e8
], ({ dispatch: dispatch }, shouldConnectSignal)=>{
    if (shouldConnectSignal) dispatch($4fc09928452de42f$export$1ec5c2b17c26996e());
});
const $4fc09928452de42f$export$d06c004c1bc5f59 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$658d1957bbe5d193, $4fc09928452de42f$export$fb9576bb0af6ec25, $4fc09928452de42f$export$f861d0329c5966c4, $4fc09928452de42f$export$3ee4dc1d6a8ff538, (deviceCredentialsRaw, signalStatus, deviceIdentified, isIdentifyingDevice)=>{
    if (deviceCredentialsRaw.data && signalStatus === "connected" && !deviceIdentified && !isIdentifyingDevice) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$d06c004c1bc5f59,
    $4fc09928452de42f$export$658d1957bbe5d193
], ({ dispatch: dispatch }, shouldIdentifyDevice, deviceCredentialsRaw)=>{
    if (shouldIdentifyDevice && deviceCredentialsRaw.data) dispatch($4fc09928452de42f$export$6313658c703ceaf8({
        deviceCredentials: deviceCredentialsRaw.data
    }));
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.roomLeft,
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$662ce9a66e2e97d8());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientKicked,
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$662ce9a66e2e97d8());
    }
});
const $4fc09928452de42f$var$initialState$c = {
    chatMessages: []
};
const $4fc09928452de42f$export$89f748d7b911fed0 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "chat",
    initialState: $4fc09928452de42f$var$initialState$c,
    reducers: {},
    extraReducers (builder) {
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.chatMessage, (state, action)=>{
            const message = {
                senderId: action.payload.senderId,
                timestamp: action.payload.timestamp,
                text: action.payload.text
            };
            return Object.assign(Object.assign({}, state), {
                chatMessages: [
                    ...state.chatMessages,
                    message
                ]
            });
        });
    }
});
const $4fc09928452de42f$export$24e3bf930d312b2b = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("chat_message", {
            text: payload.text
        });
    });
const $4fc09928452de42f$export$13f3ac2a728ceb8b = (state)=>state.chat;
const $4fc09928452de42f$export$e67c42ad18139770 = (state)=>state.chat.chatMessages;
const $4fc09928452de42f$export$b4be21ed3c586215 = {
    isRecording: false,
    error: null,
    startedAt: undefined
};
const $4fc09928452de42f$export$4a7c7275a23ed5bc = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "cloudRecording",
    initialState: $4fc09928452de42f$export$b4be21ed3c586215,
    reducers: {
        recordingRequestStarted: (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "requested"
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStopped, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isRecording: false,
                status: undefined
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.cloudRecordingStarted, (state, action)=>{
            const { payload: payload } = action;
            if (!payload.error) return state;
            return Object.assign(Object.assign({}, state), {
                isRecording: false,
                status: "error",
                error: payload.error
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, { payload: payload })=>{
            var _a;
            const { client: client } = payload;
            if (((_a = client.role) === null || _a === void 0 ? void 0 : _a.roleName) === "recorder") return Object.assign(Object.assign({}, state), {
                isRecording: true,
                status: "recording",
                startedAt: client.startedCloudRecordingAt ? new Date(client.startedCloudRecordingAt).getTime() : new Date().getTime()
            });
            return state;
        });
    }
});
const { recordingRequestStarted: $4fc09928452de42f$export$5ec9485ce4da66d8 } = $4fc09928452de42f$export$4a7c7275a23ed5bc.actions;
const $4fc09928452de42f$export$8568c037c56c4692 = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const status = $4fc09928452de42f$export$2800027a639a1395(state);
        if (status && [
            "recording",
            "requested"
        ].includes(status)) return;
        socket === null || socket === void 0 || socket.emit("start_recording", {
            recording: "cloud"
        });
        dispatch($4fc09928452de42f$export$5ec9485ce4da66d8());
    });
const $4fc09928452de42f$export$579ffd5d4359613e = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("stop_recording");
    });
const $4fc09928452de42f$export$e8f9fec2fd38be7b = (state)=>state.cloudRecording;
const $4fc09928452de42f$export$2800027a639a1395 = (state)=>state.cloudRecording.status;
const $4fc09928452de42f$export$1c8c1e3b210ae980 = (state)=>state.cloudRecording.startedAt;
const $4fc09928452de42f$export$7fef72dec076388f = (state)=>state.cloudRecording.error;
const $4fc09928452de42f$export$71863674063f458c = (state)=>state.cloudRecording.isRecording;
const $4fc09928452de42f$var$initialState$b = {
    data: null,
    isFetching: false,
    error: null
};
const $4fc09928452de42f$export$351101b59484838e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$b,
    name: "organization",
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
        });
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.fulfilled, (state, action)=>{
            if (!action.payload) return Object.assign(Object.assign({}, state), {
                isFetching: true
            });
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                data: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$1ed9272eed0ed03b.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isFetching: false,
                error: true
            });
        });
    }
});
const $4fc09928452de42f$export$1ed9272eed0ed03b = $4fc09928452de42f$export$cdf9d0e702cbbe4b("organization/doOrganizationFetch", (_, { extra: extra, getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const roomUrl = $4fc09928452de42f$export$c6d654d892432c6b(getState());
            const organization = yield extra.services.fetchOrganizationFromRoomUrl(roomUrl || "");
            if (!organization) throw new Error("Invalid room url");
            return organization;
        } catch (error) {
            console.error(error);
        }
    }));
const $4fc09928452de42f$export$149960cc946ace1e = (state)=>state.organization;
const $4fc09928452de42f$export$7ba530130176c5b4 = (state)=>{
    var _a;
    return (_a = state.organization.data) === null || _a === void 0 ? void 0 : _a.organizationId;
};
const $4fc09928452de42f$export$7090e7076d1b0f9f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$149960cc946ace1e, $4fc09928452de42f$export$658d1957bbe5d193, (appIsActive, organization, deviceCredentials)=>{
    if (appIsActive && !organization.data && !organization.isFetching && !organization.error && !deviceCredentials.isFetching) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$7090e7076d1b0f9f
], ({ dispatch: dispatch }, shouldFetchOrganization)=>{
    if (shouldFetchOrganization) dispatch($4fc09928452de42f$export$1ed9272eed0ed03b());
});
function $4fc09928452de42f$var$fakeAudioStream() {
    const audioCtx = new AudioContext();
    const oscillator = audioCtx.createOscillator();
    const destination = audioCtx.createMediaStreamDestination();
    oscillator.connect(destination);
    oscillator.start();
    return destination.stream;
}
let $4fc09928452de42f$var$rotationAngle = 0;
function $4fc09928452de42f$var$drawWebcamFrame(canvas) {
    const context = canvas.getContext("2d");
    if (!context) {
        console.error("Canvas context not available");
        return;
    }
    const wheelRadius = 100;
    const wheelCenterX = canvas.width / 2;
    const wheelCenterY = canvas.height / 2;
    context.fillStyle = "darkgreen";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.translate(wheelCenterX, wheelCenterY);
    context.rotate($4fc09928452de42f$var$rotationAngle);
    const numSlices = 12;
    const sliceAngle = 2 * Math.PI / numSlices;
    const colors = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "purple"
    ];
    for(let i = 0; i < numSlices; i++){
        context.beginPath();
        context.moveTo(0, 0);
        context.arc(0, 0, wheelRadius, i * sliceAngle, (i + 1) * sliceAngle);
        context.fillStyle = colors[i % colors.length];
        context.fill();
        context.closePath();
    }
    context.restore();
    context.fillStyle = "white";
    context.font = "42px Arial";
    const topText = "Whereby Media Stream";
    const topTextWidth = context.measureText(topText).width;
    context.fillText(topText, canvas.width / 2 - topTextWidth / 2, 50);
    context.font = "32px Arial";
    const now = new Date();
    const timeText = `time: ${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now.getSeconds().toString().padStart(2, "0")}.${now.getMilliseconds().toString().padStart(3, "0")}`;
    context.fillText(timeText, 10, canvas.height - 20);
    context.fillText(`rotation angle: ${$4fc09928452de42f$var$rotationAngle.toFixed(2)}`, canvas.width - canvas.width / 2, canvas.height - 20);
    $4fc09928452de42f$var$rotationAngle += 0.01;
}
function $4fc09928452de42f$var$fakeWebcamFrame(canvas) {
    $4fc09928452de42f$var$drawWebcamFrame(canvas);
    setInterval(()=>$4fc09928452de42f$var$drawWebcamFrame(canvas), 50);
}
const $4fc09928452de42f$var$CANVAS_VIDEO_FPS = 24;
function $4fc09928452de42f$export$2f40a00711eb9f5e() {
    const audioStream = $4fc09928452de42f$var$fakeAudioStream();
    return audioStream.getAudioTracks()[0];
}
function $4fc09928452de42f$export$50d8a22c2769f30b({ canvas: canvas }) {
    $4fc09928452de42f$var$fakeWebcamFrame(canvas);
    const videoStream = canvas.captureStream($4fc09928452de42f$var$CANVAS_VIDEO_FPS);
    return videoStream.getVideoTracks()[0];
}
function $4fc09928452de42f$export$189276e7b19b22c3({ canvas: canvas, hasAudio: hasAudio }) {
    const tracks = [
        $4fc09928452de42f$export$50d8a22c2769f30b({
            canvas: canvas
        }),
        ...hasAudio ? [
            $4fc09928452de42f$export$2f40a00711eb9f5e()
        ] : []
    ];
    return new MediaStream(tracks);
}
function $4fc09928452de42f$export$61fc7d43ac8f84b0(fn, { delay: delay = 500, edges: edges } = {}) {
    let timeout;
    let nCalls = 0;
    return (...args)=>{
        nCalls += 1;
        if (edges && nCalls === 1) fn(...args);
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            if (!edges || nCalls > 1) fn(...args);
            timeout = undefined;
            nCalls = 0;
        }, delay);
    };
}
function $4fc09928452de42f$export$83b87411fec6e66(roomAttribute, subdomainAttribute) {
    if (!roomAttribute) throw new Error("Missing room attribute");
    const m = /https:\/\/([^.]+)(\.whereby\.com|-ip-\d+-\d+-\d+-\d+.hereby.dev:4443)\/.+/.exec(roomAttribute);
    const subdomain = m && m[1] || subdomainAttribute;
    if (!subdomain) throw new Error("Missing subdomain attribute");
    if (!m) throw new Error("Could not parse room URL");
    const roomUrl = new URL(roomAttribute);
    return {
        subdomain: subdomain,
        roomUrl: roomUrl
    };
}
function $4fc09928452de42f$export$5a389667740ebcca(roomKey) {
    const [, roomKeyData] = /\.(.*)\./i.exec(roomKey) || [];
    if (!roomKeyData) return {};
    else try {
        const base64DecodedJwtData = atob(roomKeyData);
        return JSON.parse(base64DecodedJwtData);
    } catch (e) {
        return {};
    }
}
const $4fc09928452de42f$export$f6116eae9101e095 = {
    busyDeviceIds: [],
    cameraEnabled: false,
    currentSpeakerDeviceId: "default",
    devices: [],
    isSettingCameraDevice: false,
    isSettingMicrophoneDevice: false,
    isSettingSpeakerDevice: false,
    isTogglingCamera: false,
    lowDataMode: false,
    microphoneEnabled: false,
    status: "inactive",
    stream: undefined,
    isSwitchingStream: false
};
const $4fc09928452de42f$export$5bb3b96828f370d1 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localMedia",
    initialState: $4fc09928452de42f$export$f6116eae9101e095,
    reducers: {
        deviceBusy (state, action) {
            if (state.busyDeviceIds.includes(action.payload.deviceId)) return state;
            return Object.assign(Object.assign({}, state), {
                busyDeviceIds: [
                    ...state.busyDeviceIds,
                    action.payload.deviceId
                ]
            });
        },
        toggleCameraEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                cameraEnabled: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.cameraEnabled
            });
        },
        setCurrentCameraDeviceId (state, action) {
            return Object.assign(Object.assign({}, state), {
                currentCameraDeviceId: action.payload.deviceId
            });
        },
        toggleMicrophoneEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                microphoneEnabled: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.microphoneEnabled
            });
        },
        setCurrentMicrophoneDeviceId (state, action) {
            return Object.assign(Object.assign({}, state), {
                currentMicrophoneDeviceId: action.payload.deviceId
            });
        },
        setCurrentSpeakerDeviceId (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                currentSpeakerDeviceId: (_a = action.payload.deviceId) !== null && _a !== void 0 ? _a : "default"
            });
        },
        toggleLowDataModeEnabled (state, action) {
            var _a;
            return Object.assign(Object.assign({}, state), {
                lowDataMode: (_a = action.payload.enabled) !== null && _a !== void 0 ? _a : !state.lowDataMode
            });
        },
        setDevices (state, action) {
            return Object.assign(Object.assign({}, state), {
                devices: action.payload.devices
            });
        },
        setLocalMediaStream (state, action) {
            return Object.assign(Object.assign({}, state), {
                stream: action.payload.stream
            });
        },
        setLocalMediaOptions (state, action) {
            return Object.assign(Object.assign({}, state), {
                options: action.payload.options
            });
        },
        localMediaStopped (state) {
            return Object.assign(Object.assign({}, state), {
                status: "stopped",
                stream: undefined
            });
        },
        localStreamMetadataUpdated (state, action) {
            const { audio: audio, video: video } = action.payload;
            return Object.assign(Object.assign({}, state), {
                currentCameraDeviceId: video.deviceId,
                currentMicrophoneDeviceId: audio.deviceId,
                busyDeviceIds: state.busyDeviceIds.filter((id)=>id !== audio.deviceId && id !== video.deviceId)
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                options: action.payload.localMediaOptions
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.pending, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video,
                isSettingMicrophoneDevice: audio
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video ? false : state.isSettingCameraDevice,
                isSettingMicrophoneDevice: audio ? false : state.isSettingMicrophoneDevice
            });
        });
        builder.addCase($4fc09928452de42f$export$e35f65b306a0e8f6.rejected, (state, action)=>{
            const { audio: audio, video: video } = action.meta.arg;
            return Object.assign(Object.assign({}, state), {
                isSettingCameraDevice: video ? false : state.isSettingCameraDevice,
                isSettingMicrophoneDevice: audio ? false : state.isSettingMicrophoneDevice,
                cameraDeviceError: video ? action.error : state.cameraDeviceError,
                microphoneDeviceError: audio ? action.error : state.microphoneDeviceError
            });
        });
        builder.addCase($4fc09928452de42f$export$9933267781a720e.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isTogglingCamera: true
            });
        });
        builder.addCase($4fc09928452de42f$export$9933267781a720e.fulfilled, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isTogglingCamera: false
            });
        });
        builder.addCase($4fc09928452de42f$export$24ed9de9cfe6ab93.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                devices: action.payload.devices
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "starting"
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.fulfilled, (state, { payload: { stream: stream, onDeviceChange: onDeviceChange } })=>{
            let cameraDeviceId = undefined;
            let cameraEnabled = false;
            let microphoneDeviceId = undefined;
            let microphoneEnabled = false;
            const audioTrack = stream.getAudioTracks()[0];
            const videoTrack = stream.getVideoTracks()[0];
            if (audioTrack) {
                microphoneDeviceId = audioTrack.getSettings().deviceId;
                microphoneEnabled = audioTrack.enabled;
            }
            if (videoTrack) {
                cameraEnabled = videoTrack.enabled;
                cameraDeviceId = videoTrack.getSettings().deviceId;
            }
            return Object.assign(Object.assign({}, state), {
                stream: stream,
                status: "started",
                currentCameraDeviceId: cameraDeviceId,
                currentMicrophoneDeviceId: microphoneDeviceId,
                cameraEnabled: cameraEnabled,
                microphoneEnabled: microphoneEnabled,
                onDeviceChange: onDeviceChange
            });
        });
        builder.addCase($4fc09928452de42f$export$eb927cdec6bfaecd.rejected, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                status: "error",
                startError: action.error
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: true
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.fulfilled, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: false
            });
        });
        builder.addCase($4fc09928452de42f$export$128f34559d09c6da.rejected, (state)=>{
            return Object.assign(Object.assign({}, state), {
                isSwitchingStream: false
            });
        });
    }
});
const { deviceBusy: $4fc09928452de42f$export$b01847946e37298f, setCurrentCameraDeviceId: $4fc09928452de42f$export$ab12f9f2846e3448, setCurrentMicrophoneDeviceId: $4fc09928452de42f$export$2e1fc2200098f950, setCurrentSpeakerDeviceId: $4fc09928452de42f$export$1176f68d1d548ad3, toggleCameraEnabled: $4fc09928452de42f$export$93cdb5d3b5880a52, toggleMicrophoneEnabled: $4fc09928452de42f$export$11a7008b2ab330c2, toggleLowDataModeEnabled: $4fc09928452de42f$export$f8ccf9677d12adec, setLocalMediaOptions: $4fc09928452de42f$export$74044ec7ad05ecf5, setLocalMediaStream: $4fc09928452de42f$export$313da74df613e066, localMediaStopped: $4fc09928452de42f$export$9492753e9267457d, localStreamMetadataUpdated: $4fc09928452de42f$export$245247334d37072c } = $4fc09928452de42f$export$5bb3b96828f370d1.actions;
const $4fc09928452de42f$export$9933267781a720e = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doToggleCamera", (_, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        if (!stream) return;
        let track = stream.getVideoTracks()[0];
        const enabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
        try {
            if (enabled) {
                if (track) track.enabled = true;
                else {
                    const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
                    const cameraDeviceId = $4fc09928452de42f$export$9b07214a345a0c2b(state);
                    yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                        audioId: false,
                        videoId: cameraDeviceId,
                        type: "exact"
                    }), {
                        replaceStream: stream
                    });
                    track = stream.getVideoTracks()[0];
                }
            } else {
                if (!track) return;
                track.enabled = false;
                track.stop();
                stream.removeTrack(track);
            }
            stream.dispatchEvent(new CustomEvent("stopresumevideo", {
                detail: {
                    track: track,
                    enable: enabled
                }
            }));
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$var$doToggleMicrophone = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doToggleMicrophone", (_, { getState: getState })=>{
    var _a;
    const state = getState();
    const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
    if (!stream) return;
    const enabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
    const audioTrack = (_a = stream.getAudioTracks()) === null || _a === void 0 ? void 0 : _a[0];
    if (!audioTrack) return;
    audioTrack.enabled = enabled;
});
const $4fc09928452de42f$export$147a1219e0418788 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        if (!stream) return;
        const videoId = $4fc09928452de42f$export$9b07214a345a0c2b(state);
        const audioId = $4fc09928452de42f$export$15cb5bc234aa0b53(state);
        dispatch($4fc09928452de42f$export$128f34559d09c6da({
            audioId: audioId,
            videoId: videoId
        }));
    });
const $4fc09928452de42f$export$e35f65b306a0e8f6 = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/reactSetDevice", ({ audio: audio, video: video }, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            const state = getState();
            const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
            if (!stream) throw new Error("No stream");
            const audioId = audio ? $4fc09928452de42f$export$15cb5bc234aa0b53(state) : false;
            const videoId = video ? $4fc09928452de42f$export$9b07214a345a0c2b(state) : false;
            const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
            const { replacedTracks: replacedTracks } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: audioId,
                videoId: videoId,
                type: "exact"
            }), {
                replaceStream: stream
            });
            const isAudioEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
            stream.getAudioTracks().forEach((track)=>track.enabled = isAudioEnabled);
            const isVideoEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
            stream.getVideoTracks().forEach((track)=>track.enabled = isVideoEnabled);
            return {
                replacedTracks: replacedTracks
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$24ed9de9cfe6ab93 = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doUpdateDeviceList", (_, { getState: getState, dispatch: dispatch, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a, _b, _c, _d;
        const state = getState();
        let newDevices = [];
        let oldDevices = [];
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        try {
            newDevices = yield navigator.mediaDevices.enumerateDevices();
            oldDevices = $4fc09928452de42f$export$1a9647721070cccc(state);
            const shouldHandleDeviceUpdate = stream && !$4fc09928452de42f$export$54d57059e4b0746a(state) && newDevices && oldDevices && oldDevices.find((d)=>d.deviceId);
            if (!shouldHandleDeviceUpdate) return {
                devices: newDevices
            };
            const { changedDevices: changedDevices, addedDevices: addedDevices } = (0, $1622be301bae0161$export$be9584734485c5e8)({
                oldDevices: oldDevices,
                newDevices: newDevices
            });
            let autoSwitchAudioId = (_a = changedDevices.audioinput) === null || _a === void 0 ? void 0 : _a.deviceId;
            let autoSwitchVideoId = (_b = changedDevices.videoinput) === null || _b === void 0 ? void 0 : _b.deviceId;
            if (autoSwitchAudioId === undefined) autoSwitchAudioId = (_c = addedDevices.audioinput) === null || _c === void 0 ? void 0 : _c.deviceId;
            if (autoSwitchVideoId === undefined) autoSwitchVideoId = (_d = addedDevices.videoinput) === null || _d === void 0 ? void 0 : _d.deviceId;
            if (autoSwitchAudioId !== undefined || autoSwitchVideoId !== undefined) dispatch($4fc09928452de42f$export$128f34559d09c6da({
                audioId: autoSwitchAudioId,
                videoId: autoSwitchVideoId
            }));
            return {
                devices: newDevices
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$128f34559d09c6da = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doSwitchLocalStream", ({ audioId: audioId, videoId: videoId }, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const replaceStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
        const onlySwitchingOne = !!(videoId && !audioId) || !!(!videoId && audioId);
        if (!replaceStream) return;
        try {
            const { replacedTracks: replacedTracks } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: audioId === undefined ? false : audioId,
                videoId: videoId === undefined ? false : videoId,
                type: "exact"
            }), {
                replaceStream: replaceStream
            });
            const deviceId = audioId || videoId;
            if (onlySwitchingOne && deviceId) dispatch($4fc09928452de42f$export$b01847946e37298f({
                deviceId: deviceId
            }));
            return {
                replacedTracks: replacedTracks
            };
        } catch (error) {
            console.error(error);
            const deviceId = audioId || videoId;
            if (onlySwitchingOne && deviceId) dispatch($4fc09928452de42f$export$b01847946e37298f({
                deviceId: deviceId
            }));
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$eb927cdec6bfaecd = $4fc09928452de42f$export$cdf9d0e702cbbe4b("localMedia/doStartLocalMedia", (payload, { getState: getState, dispatch: dispatch, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const onDeviceChange = $4fc09928452de42f$export$61fc7d43ac8f84b0(()=>{
            dispatch($4fc09928452de42f$export$24ed9de9cfe6ab93());
        }, {
            delay: 500
        });
        if (navigator.mediaDevices) navigator.mediaDevices.addEventListener("devicechange", onDeviceChange);
        if ("getTracks" in payload) return Promise.resolve({
            stream: payload,
            onDeviceChange: onDeviceChange
        });
        if (!(payload.audio || payload.video)) return {
            stream: new MediaStream(),
            onDeviceChange: onDeviceChange
        };
        else dispatch($4fc09928452de42f$export$74044ec7ad05ecf5({
            options: payload
        }));
        try {
            yield dispatch($4fc09928452de42f$export$24ed9de9cfe6ab93());
            const state = getState();
            const constraintsOptions = $4fc09928452de42f$export$585cee7165e8d1fc(state);
            const { stream: stream } = yield (0, $1622be301bae0161$export$747191980cdf43e8)(Object.assign(Object.assign({}, constraintsOptions), {
                audioId: payload.audio,
                videoId: payload.video
            }));
            return {
                stream: stream,
                onDeviceChange: onDeviceChange
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$85e2dd05688d27d9 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const onDeviceChange = $4fc09928452de42f$export$de402d29be2417a1(getState()).onDeviceChange;
        stream === null || stream === void 0 || stream.getTracks().forEach((track)=>{
            track.stop();
        });
        if (navigator.mediaDevices && onDeviceChange) navigator.mediaDevices.removeEventListener("devicechange", onDeviceChange);
        dispatch($4fc09928452de42f$export$9492753e9267457d());
    });
const $4fc09928452de42f$export$a49b90aaf35a8e5a = (state)=>state.localMedia.busyDeviceIds;
const $4fc09928452de42f$export$68025622922ffa26 = (state)=>state.localMedia.cameraDeviceError;
const $4fc09928452de42f$export$9b07214a345a0c2b = (state)=>state.localMedia.currentCameraDeviceId;
const $4fc09928452de42f$export$15cb5bc234aa0b53 = (state)=>state.localMedia.currentMicrophoneDeviceId;
const $4fc09928452de42f$export$356fc73355033f1b = (state)=>state.localMedia.currentSpeakerDeviceId;
const $4fc09928452de42f$export$c8e0d13b9d33fb32 = (state)=>state.localMedia.cameraEnabled;
const $4fc09928452de42f$export$ee30c1c2cc195652 = (state)=>state.localMedia.microphoneEnabled;
const $4fc09928452de42f$export$7c06101e124bf472 = (state)=>state.localMedia.lowDataMode;
const $4fc09928452de42f$export$53fdac895dbb6618 = (state)=>state.localMedia.isSettingCameraDevice;
const $4fc09928452de42f$export$6dd72f0a0b587d15 = (state)=>state.localMedia.isSettingMicrophoneDevice;
const $4fc09928452de42f$export$c94b2357b1d094f9 = (state)=>state.localMedia.isTogglingCamera;
const $4fc09928452de42f$export$1a9647721070cccc = (state)=>state.localMedia.devices;
const $4fc09928452de42f$export$5365e4b7f36eeda5 = (state)=>state.localMedia.options;
const $4fc09928452de42f$export$764b04f862de3618 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$5365e4b7f36eeda5, (options)=>!!options);
const $4fc09928452de42f$export$de402d29be2417a1 = (state)=>state.localMedia;
const $4fc09928452de42f$export$6a731d6bc230a245 = (state)=>state.localMedia.status;
const $4fc09928452de42f$export$e9c4b1bf93e7c80d = (state)=>state.localMedia.stream;
const $4fc09928452de42f$export$6dc516caa6efdffc = (state)=>state.localMedia.microphoneDeviceError;
const $4fc09928452de42f$export$c86c916bf575750b = (state)=>state.localMedia.startError;
const $4fc09928452de42f$export$54d57059e4b0746a = (state)=>state.localMedia.isSwitchingStream;
const $4fc09928452de42f$export$585cee7165e8d1fc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$9b07214a345a0c2b, $4fc09928452de42f$export$15cb5bc234aa0b53, $4fc09928452de42f$export$7c06101e124bf472, (devices, videoId, audioId, lowDataMode)=>({
        devices: devices,
        videoId: videoId,
        audioId: audioId,
        options: {
            disableAEC: false,
            disableAGC: false,
            hd: true,
            lax: false,
            lowDataMode: lowDataMode,
            simulcast: true,
            widescreen: true
        }
    }));
const $4fc09928452de42f$export$5353cfedea9c4a68 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6a731d6bc230a245, (status)=>status === "starting");
const $4fc09928452de42f$export$434a4c2926dbcbc8 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$a49b90aaf35a8e5a, (devices, busyDeviceIds)=>devices.filter((d)=>d.kind === "videoinput").filter((d)=>!busyDeviceIds.includes(d.deviceId)));
const $4fc09928452de42f$export$3622b5408789e593 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, $4fc09928452de42f$export$a49b90aaf35a8e5a, (devices, busyDeviceIds)=>devices.filter((d)=>d.kind === "audioinput").filter((d)=>!busyDeviceIds.includes(d.deviceId)));
const $4fc09928452de42f$export$d743da980c7b249a = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$1a9647721070cccc, (devices)=>devices.filter((d)=>d.kind === "audiooutput"));
const $4fc09928452de42f$export$5b48ba01602df302 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$6a731d6bc230a245, $4fc09928452de42f$export$5365e4b7f36eeda5, (appIsActive, localMediaStatus, localMediaOptions)=>{
    if (appIsActive && [
        "inactive",
        "stopped"
    ].includes(localMediaStatus) && localMediaOptions) return localMediaOptions;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$5b48ba01602df302
], ({ dispatch: dispatch }, options)=>{
    if (options) dispatch($4fc09928452de42f$export$eb927cdec6bfaecd(options));
});
const $4fc09928452de42f$export$a8fc49bc491506d0 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$6a731d6bc230a245, $4fc09928452de42f$export$5365e4b7f36eeda5, (appIsActive, localMediaStatus, localMediaOptions)=>{
    return !appIsActive && localMediaStatus !== "inactive" && !!localMediaOptions;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$a8fc49bc491506d0
], ({ dispatch: dispatch }, localMediaShouldStop)=>{
    if (localMediaShouldStop) dispatch($4fc09928452de42f$export$85e2dd05688d27d9());
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$ee30c1c2cc195652(previousState);
        const newValue = $4fc09928452de42f$export$ee30c1c2cc195652(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$var$doToggleMicrophone());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$7c06101e124bf472(previousState);
        const newValue = $4fc09928452de42f$export$7c06101e124bf472(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$147a1219e0418788());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const isToggling = $4fc09928452de42f$export$c94b2357b1d094f9(currentState);
        if (isToggling) return false;
        const oldValue = $4fc09928452de42f$export$c8e0d13b9d33fb32(previousState);
        const newValue = $4fc09928452de42f$export$c8e0d13b9d33fb32(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$9933267781a720e());
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$9b07214a345a0c2b(previousState);
        const newValue = $4fc09928452de42f$export$9b07214a345a0c2b(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$e35f65b306a0e8f6({
            audio: false,
            video: true
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    predicate: (_action, currentState, previousState)=>{
        const oldValue = $4fc09928452de42f$export$15cb5bc234aa0b53(previousState);
        const newValue = $4fc09928452de42f$export$15cb5bc234aa0b53(currentState);
        const isReady = $4fc09928452de42f$export$6a731d6bc230a245(previousState) === "started";
        return isReady && oldValue !== newValue;
    },
    effect: (_action, { dispatch: dispatch })=>{
        dispatch($4fc09928452de42f$export$e35f65b306a0e8f6({
            audio: true,
            video: false
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    matcher: (0, $58dad493bd6ec980$export$2c3435c7647f7b0d)($4fc09928452de42f$export$eb927cdec6bfaecd.fulfilled, $4fc09928452de42f$export$24ed9de9cfe6ab93.fulfilled, $4fc09928452de42f$export$128f34559d09c6da.fulfilled, $4fc09928452de42f$export$128f34559d09c6da.rejected),
    effect: (_action, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state);
        const devices = $4fc09928452de42f$export$1a9647721070cccc(state);
        if (!stream) return;
        const deviceData = (0, $1622be301bae0161$export$fb9ff29788bfaf04)({
            audioTrack: stream.getAudioTracks()[0],
            videoTrack: stream.getVideoTracks()[0],
            devices: devices
        });
        dispatch($4fc09928452de42f$export$245247334d37072c(deviceData));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch })=>{
        const { enable: enable } = payload;
        if (!enable) dispatch($4fc09928452de42f$export$11a7008b2ab330c2({
            enabled: false
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch })=>{
        const { enable: enable } = payload;
        if (!enable) dispatch($4fc09928452de42f$export$93cdb5d3b5880a52({
            enabled: false
        }));
    }
});
const $4fc09928452de42f$var$NON_PERSON_ROLES = [
    "recorder",
    "streamer"
];
const $4fc09928452de42f$var$initialState$a = {
    displayName: "",
    id: "",
    isAudioEnabled: true,
    isVideoEnabled: true,
    isLocalParticipant: true,
    stream: undefined,
    isScreenSharing: false,
    roleName: "none",
    clientClaim: undefined,
    stickyReaction: undefined,
    isDialIn: false
};
const $4fc09928452de42f$export$44a9bbc9e703cf3d = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localParticipant",
    initialState: $4fc09928452de42f$var$initialState$a,
    reducers: {
        setDisplayName: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                displayName: action.payload.displayName
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ca0cd7d9bebf6bc8, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                displayName: action.payload.displayName
            });
        });
        builder.addCase($4fc09928452de42f$export$447462528605c694.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isAudioEnabled: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$5ce66a04faaa2854.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isVideoEnabled: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$5ae150f2ac8c6cf7.fulfilled, (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                stickyReaction: action.payload
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const client = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.room) === null || _b === void 0 ? void 0 : _b.clients.find((c)=>{
                var _a;
                return c.id === ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.selfId);
            });
            return Object.assign(Object.assign({}, state), {
                id: action.payload.selfId,
                roleName: (client === null || client === void 0 ? void 0 : client.role.roleName) || "none",
                clientClaim: action.payload.clientClaim
            });
        });
    }
});
const { setDisplayName: $4fc09928452de42f$export$ce7d0f83c324f6cf } = $4fc09928452de42f$export$44a9bbc9e703cf3d.actions;
const $4fc09928452de42f$export$9708f9509a207de0 = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("send_client_metadata", {
            type: "UserData",
            payload: {
                displayName: payload.displayName
            }
        });
        dispatch($4fc09928452de42f$export$ce7d0f83c324f6cf({
            displayName: payload.displayName
        }));
    });
const $4fc09928452de42f$export$447462528605c694 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doEnableAudio", (payload, { dispatch: dispatch, getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("enable_audio", {
            enabled: payload.enabled
        });
        if (payload.enabled) dispatch($4fc09928452de42f$export$5ae150f2ac8c6cf7({
            enabled: false
        }));
        return payload.enabled;
    }));
const $4fc09928452de42f$export$5ce66a04faaa2854 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doEnableVideo", (payload, { getState: getState })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("enable_video", {
            enabled: payload.enabled
        });
        return payload.enabled;
    }));
const $4fc09928452de42f$export$5ae150f2ac8c6cf7 = $4fc09928452de42f$export$7a92a3664c4cb7d1("localParticipant/doSetLocalStickyReaction", (payload, { getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a;
        const state = getState();
        const currentStickyReaction = $4fc09928452de42f$export$48358a6c3a310d22(state);
        const stickyReactionCurrentlyEnabled = Boolean(currentStickyReaction);
        const enabled = (_a = payload.enabled) !== null && _a !== void 0 ? _a : !stickyReactionCurrentlyEnabled;
        if (enabled === stickyReactionCurrentlyEnabled) return rejectWithValue(currentStickyReaction);
        const stickyReaction = enabled ? {
            reaction: "\u270B",
            timestamp: new Date().toISOString()
        } : null;
        return stickyReaction;
    }));
const $4fc09928452de42f$export$9f6c6ec96c819f3a = $4fc09928452de42f$export$f3d6a2157932333f(()=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const payload = {
            displayName: $4fc09928452de42f$export$60acd18ba1d244f9(state),
            stickyReaction: $4fc09928452de42f$export$48358a6c3a310d22(state)
        };
        socket === null || socket === void 0 || socket.emit("send_client_metadata", {
            type: "UserData",
            payload: payload
        });
    });
const $4fc09928452de42f$export$b8c8b2aa1134778b = (state)=>state.localParticipant;
const $4fc09928452de42f$export$b5166f32e739efd8 = (state)=>state.localParticipant.id;
const $4fc09928452de42f$export$60acd18ba1d244f9 = (state)=>state.localParticipant.displayName;
const $4fc09928452de42f$export$5918f36689139a10 = (state)=>state.localParticipant.clientClaim;
const $4fc09928452de42f$export$c24bfac8c734bcd5 = (state)=>state.localParticipant.isScreenSharing;
const $4fc09928452de42f$export$48358a6c3a310d22 = (state)=>state.localParticipant.stickyReaction;
const $4fc09928452de42f$export$4833cdb2a0a243e3 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$e9c4b1bf93e7c80d, (participant, localStream)=>{
    const clientView = {
        id: participant.id,
        clientId: participant.id,
        displayName: participant.displayName,
        stream: localStream,
        isLocalClient: true,
        isAudioEnabled: participant.isAudioEnabled,
        isVideoEnabled: participant.isVideoEnabled
    };
    if ($4fc09928452de42f$var$NON_PERSON_ROLES.includes(participant.roleName)) return null;
    return clientView;
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$93cdb5d3b5880a52,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enabled: enabled } = payload;
        const { isVideoEnabled: isVideoEnabled } = $4fc09928452de42f$export$b8c8b2aa1134778b(getState());
        dispatch($4fc09928452de42f$export$5ce66a04faaa2854({
            enabled: enabled || !isVideoEnabled
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$11a7008b2ab330c2,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enabled: enabled } = payload;
        const { isAudioEnabled: isAudioEnabled } = $4fc09928452de42f$export$b8c8b2aa1134778b(getState());
        dispatch($4fc09928452de42f$export$447462528605c694({
            enabled: enabled || !isAudioEnabled
        }));
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$60acd18ba1d244f9,
    $4fc09928452de42f$export$48358a6c3a310d22
], ({ dispatch: dispatch })=>{
    dispatch($4fc09928452de42f$export$9f6c6ec96c819f3a());
});
const $4fc09928452de42f$var$initialState$9 = {
    session: null,
    status: "ready",
    error: null
};
const $4fc09928452de42f$export$b633f15c3886bdc9 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$9,
    name: "roomConnection",
    reducers: {
        connectionStatusChanged: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                status: action.payload
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a, _b;
            const { error: error, isLocked: isLocked } = action.payload;
            if (error === "room_locked" && isLocked) return Object.assign(Object.assign({}, state), {
                status: "room_locked"
            });
            if (error) return Object.assign(Object.assign({}, state), {
                status: "disconnected",
                error: error
            });
            return Object.assign(Object.assign({}, state), {
                status: "connected",
                session: (_b = (_a = action.payload.room) === null || _a === void 0 ? void 0 : _a.session) !== null && _b !== void 0 ? _b : null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.disconnect, (state)=>{
            if ([
                "kicked",
                "left"
            ].includes(state.status)) return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), {
                status: "disconnected"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, action)=>{
            var _a, _b;
            return Object.assign(Object.assign({}, state), {
                session: (_b = (_a = action.payload.room) === null || _a === void 0 ? void 0 : _a.session) !== null && _b !== void 0 ? _b : null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded, (state, action)=>{
            var _a;
            if (((_a = state.session) === null || _a === void 0 ? void 0 : _a.id) !== action.payload.roomSessionId) return state;
            return Object.assign(Object.assign({}, state), {
                session: null
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientKicked, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "kicked"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomLeft, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "left"
            });
        });
        builder.addCase($4fc09928452de42f$export$fb604b2ee1249ba5, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        });
    }
});
const { connectionStatusChanged: $4fc09928452de42f$var$connectionStatusChanged } = $4fc09928452de42f$export$b633f15c3886bdc9.actions;
const $4fc09928452de42f$export$76a4467872ffe125 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const roomName = $4fc09928452de42f$export$2664cf73474d4255(state);
        const roomKey = $4fc09928452de42f$export$4040db2373332c60(state);
        const displayName = $4fc09928452de42f$export$b157fc4c059768ed(state);
        const isDialIn = $4fc09928452de42f$export$442c6682ecfaaef2(state);
        const userAgent = $4fc09928452de42f$export$6f409a475b0c8c60(state);
        const externalId = $4fc09928452de42f$export$44202ee237048d77(state);
        const organizationId = $4fc09928452de42f$export$7ba530130176c5b4(state);
        const connectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
        if (connectionStatus !== "room_locked") {
            console.warn("Room is not locked, knock aborted");
            return;
        }
        socket === null || socket === void 0 || socket.emit("knock_room", {
            avatarUrl: null,
            config: {
                isAudioEnabled: true,
                isVideoEnabled: true
            },
            deviceCapabilities: {
                canScreenshare: true
            },
            displayName: displayName,
            isCoLocated: false,
            isDialIn: isDialIn,
            isDevicePermissionDenied: false,
            kickFromOtherRooms: false,
            organizationId: organizationId,
            roomKey: roomKey,
            roomName: roomName,
            userAgent: userAgent,
            externalId: externalId
        });
        dispatch($4fc09928452de42f$var$connectionStatusChanged("knocking"));
    });
const $4fc09928452de42f$export$1cae1f7f973558d2 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const roomName = $4fc09928452de42f$export$2664cf73474d4255(state);
        const roomKey = $4fc09928452de42f$export$4040db2373332c60(state);
        const displayName = $4fc09928452de42f$export$b157fc4c059768ed(state);
        const userAgent = $4fc09928452de42f$export$6f409a475b0c8c60(state);
        const externalId = $4fc09928452de42f$export$44202ee237048d77(state);
        const isDialIn = $4fc09928452de42f$export$442c6682ecfaaef2(state);
        const organizationId = $4fc09928452de42f$export$7ba530130176c5b4(state);
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(getState());
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(getState());
        const clientClaim = $4fc09928452de42f$export$5918f36689139a10(getState());
        socket === null || socket === void 0 || socket.emit("join_room", Object.assign({
            avatarUrl: null,
            config: {
                isAudioEnabled: isMicrophoneEnabled,
                isVideoEnabled: isCameraEnabled
            },
            deviceCapabilities: {
                canScreenshare: true
            },
            displayName: displayName,
            isCoLocated: false,
            isDialIn: isDialIn,
            isDevicePermissionDenied: false,
            kickFromOtherRooms: false,
            organizationId: organizationId,
            roomKey: roomKey,
            roomName: roomName,
            userAgent: userAgent,
            externalId: externalId
        }, clientClaim && {
            clientClaim: clientClaim
        }));
        dispatch($4fc09928452de42f$var$connectionStatusChanged("connecting"));
    });
const $4fc09928452de42f$export$a0307ec948127543 = (state)=>state.roomConnection;
const $4fc09928452de42f$export$227550b00aed9e8b = (state)=>state.roomConnection.session;
const $4fc09928452de42f$export$9b6909335b1f6412 = (state)=>{
    var _a;
    return (_a = state.roomConnection.session) === null || _a === void 0 ? void 0 : _a.id;
};
const $4fc09928452de42f$export$22f0decfe3c779cc = (state)=>state.roomConnection.status;
const $4fc09928452de42f$export$b21080781118639a = (state)=>state.roomConnection.error;
const $4fc09928452de42f$export$8c54b9eb079d5771 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)([
    $4fc09928452de42f$export$ae5e487c0972282e,
    $4fc09928452de42f$export$7ba530130176c5b4,
    $4fc09928452de42f$export$22f0decfe3c779cc,
    $4fc09928452de42f$export$f861d0329c5966c4,
    $4fc09928452de42f$export$6a731d6bc230a245,
    $4fc09928452de42f$export$b21080781118639a
], (appIsActive, hasOrganizationIdFetched, roomConnectionStatus, signalConnectionDeviceIdentified, localMediaStatus, roomConnectionError)=>{
    if (appIsActive && localMediaStatus === "started" && signalConnectionDeviceIdentified && !!hasOrganizationIdFetched && [
        "ready",
        "reconnecting",
        "disconnected"
    ].includes(roomConnectionStatus) && !roomConnectionError) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$8c54b9eb079d5771
], ({ dispatch: dispatch }, shouldConnectRoom)=>{
    if (shouldConnectRoom) dispatch($4fc09928452de42f$export$1cae1f7f973558d2());
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.knockHandled,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { clientId: clientId, resolution: resolution } = payload;
        const state = getState();
        const selfId = $4fc09928452de42f$export$b5166f32e739efd8(state);
        if (clientId !== selfId) return;
        if (resolution === "accepted") {
            dispatch($4fc09928452de42f$export$4aa6cbb228087bb(payload.metadata.roomKey));
            dispatch($4fc09928452de42f$export$1cae1f7f973558d2());
        } else if (resolution === "rejected") dispatch($4fc09928452de42f$var$connectionStatusChanged("knock_rejected"));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$d4d0f76450fb6374,
    effect: (_, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const roomConnectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
        if (roomConnectionStatus === "connected") {
            const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
            socket === null || socket === void 0 || socket.emit("leave_room");
            dispatch($4fc09928452de42f$var$connectionStatusChanged("leaving"));
        } else $4fc09928452de42f$export$662ce9a66e2e97d8();
    }
});
function $4fc09928452de42f$var$createRtcEventAction(name) {
    return (0, $58dad493bd6ec980$export$309c7a02b0b0bc62)(`rtcConnection/event/${name}`);
}
const $4fc09928452de42f$var$rtcEvents = {
    rtcManagerCreated: $4fc09928452de42f$var$createRtcEventAction("rtcManagerCreated"),
    rtcManagerDestroyed: $4fc09928452de42f$var$createRtcEventAction("rtcManagerDestroyed"),
    streamAdded: $4fc09928452de42f$var$createRtcEventAction("streamAdded")
};
function $4fc09928452de42f$var$createRemoteParticipant(client, newJoiner = false) {
    const { streams: streams, role: role } = client, rest = $4fc09928452de42f$var$__rest(client, [
        "streams",
        "role"
    ]);
    return Object.assign(Object.assign({}, rest), {
        stream: null,
        streams: streams.map((streamId)=>({
                id: streamId,
                state: newJoiner ? "new_accept" : "to_accept"
            })),
        isLocalParticipant: false,
        roleName: (role === null || role === void 0 ? void 0 : role.roleName) || "none",
        presentationStream: null,
        newJoiner: newJoiner
    });
}
function $4fc09928452de42f$var$findParticipant(state, participantId) {
    const index = state.remoteParticipants.findIndex((c)=>c.id === participantId);
    return {
        index: index,
        participant: state.remoteParticipants[index]
    };
}
function $4fc09928452de42f$var$updateParticipant(state, participantId, updates) {
    const { participant: participant, index: index } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`Did not find client for update ${participantId}`);
        return state;
    }
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: [
            ...state.remoteParticipants.slice(0, index),
            Object.assign(Object.assign({}, participant), updates),
            ...state.remoteParticipants.slice(index + 1)
        ]
    });
}
function $4fc09928452de42f$var$addParticipant(state, participant) {
    const { participant: foundParticipant } = $4fc09928452de42f$var$findParticipant(state, participant.id);
    if (foundParticipant) {
        console.warn(`Client already existing ${participant.id}. Ignoring`);
        return state;
    }
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: [
            ...state.remoteParticipants,
            participant
        ]
    });
}
function $4fc09928452de42f$var$updateStreamState(state, participantId, streamId, state_) {
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`No client ${participantId} found to update stream ${streamId} ${state_}`);
        return state;
    }
    const idIdx = participant.streams.findIndex((s)=>s.id === streamId);
    const streams = [
        ...participant.streams
    ];
    streams[idIdx] = Object.assign(Object.assign({}, streams[idIdx]), {
        state: state_
    });
    return $4fc09928452de42f$var$updateParticipant(state, participantId, {
        streams: streams
    });
}
function $4fc09928452de42f$var$removeClient(state, participantId) {
    return Object.assign(Object.assign({}, state), {
        remoteParticipants: state.remoteParticipants.filter((c)=>c.id !== participantId)
    });
}
function $4fc09928452de42f$var$addStreamId(state, participantId, streamId) {
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant || participant.streams.find((s)=>s.id === streamId)) {
        console.warn(`No participant ${participantId} or stream ${streamId} already exists`);
        return state;
    }
    return $4fc09928452de42f$var$updateParticipant(state, participantId, {
        streams: [
            ...participant.streams,
            {
                id: streamId,
                state: "to_accept"
            }
        ]
    });
}
function $4fc09928452de42f$var$removeStreamId(state, participantId, streamId) {
    var _a, _b;
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, participantId);
    if (!participant) {
        console.error(`No participant ${participantId} found to remove stream ${streamId}`);
        return state;
    }
    const currentStreamId = participant.stream && participant.stream.id;
    const presentationId = ((_a = participant.presentationStream) === null || _a === void 0 ? void 0 : _a.inboundId) || ((_b = participant.presentationStream) === null || _b === void 0 ? void 0 : _b.id);
    const idIdx = participant.streams.findIndex((s)=>s.id === streamId);
    return $4fc09928452de42f$var$updateParticipant(state, participantId, Object.assign(Object.assign({
        streams: participant.streams.filter((_, i)=>i !== idIdx)
    }, currentStreamId === streamId && {
        stream: null
    }), presentationId === streamId && {
        presentationStream: null
    }));
}
function $4fc09928452de42f$var$addStream(state, payload) {
    const { clientId: clientId, stream: stream, streamType: streamType } = payload;
    let { streamId: streamId } = payload;
    const { participant: participant } = $4fc09928452de42f$var$findParticipant(state, clientId);
    if (!participant) {
        console.error(`Did not find client ${clientId} for adding stream`);
        return state;
    }
    const remoteParticipants = state.remoteParticipants;
    if (!streamId) streamId = stream.id;
    const remoteParticipant = remoteParticipants.find((p)=>p.id === clientId);
    if (!remoteParticipant) return state;
    const remoteParticipantStream = remoteParticipant.streams.find((s)=>s.id === streamId);
    if (remoteParticipant.stream && (remoteParticipant.stream.id === streamId || remoteParticipant.stream.inboundId === streamId) || !remoteParticipant.stream && streamType === "webcam" || !remoteParticipant.stream && !streamType && !remoteParticipantStream) return $4fc09928452de42f$var$updateParticipant(state, clientId, {
        stream: stream
    });
    return $4fc09928452de42f$var$updateParticipant(state, clientId, {
        presentationStream: stream
    });
}
const $4fc09928452de42f$var$initialState$8 = {
    remoteParticipants: []
};
const $4fc09928452de42f$export$b64ee0f1b6392800 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "remoteParticipants",
    initialState: $4fc09928452de42f$var$initialState$8,
    reducers: {
        streamStatusUpdated: (state, action)=>{
            let newState = state;
            for (const { clientId: clientId, streamId: streamId, state: state } of action.payload)newState = $4fc09928452de42f$var$updateStreamState(newState, clientId, streamId, state);
            return newState;
        },
        participantStreamAdded: (state, action)=>{
            const { clientId: clientId, stream: stream } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                stream: stream
            });
        },
        participantStreamIdAdded: (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$addStreamId(state, clientId, streamId);
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            var _a;
            if (!((_a = action.payload) === null || _a === void 0 ? void 0 : _a.room)) return state;
            const selfId = action.payload.selfId;
            const { clients: clients } = action.payload.room;
            return Object.assign(Object.assign({}, state), {
                remoteParticipants: clients.filter((c)=>c.id !== selfId).map((c)=>$4fc09928452de42f$var$createRemoteParticipant(c))
            });
        });
        builder.addCase($4fc09928452de42f$var$rtcEvents.streamAdded, (state, action)=>{
            return $4fc09928452de42f$var$addStream(state, action.payload);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.newClient, (state, action)=>{
            const { client: client } = action.payload;
            return $4fc09928452de42f$var$addParticipant(state, $4fc09928452de42f$var$createRemoteParticipant(client, true));
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientLeft, (state, action)=>{
            const { clientId: clientId } = action.payload;
            return $4fc09928452de42f$var$removeClient(state, clientId);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.audioEnabled, (state, action)=>{
            const { clientId: clientId, isAudioEnabled: isAudioEnabled } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                isAudioEnabled: isAudioEnabled
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.videoEnabled, (state, action)=>{
            const { clientId: clientId, isVideoEnabled: isVideoEnabled } = action.payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                isVideoEnabled: isVideoEnabled
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived, (state, action)=>{
            const { error: error, payload: payload } = action.payload;
            if (error || !payload) {
                console.warn(error || "Client metadata error received");
                return state;
            }
            const { clientId: clientId, displayName: displayName, stickyReaction: stickyReaction } = payload;
            return $4fc09928452de42f$var$updateParticipant(state, clientId, {
                displayName: displayName,
                stickyReaction: stickyReaction
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.screenshareStarted, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$addStreamId(state, clientId, streamId);
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.screenshareStopped, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return $4fc09928452de42f$var$removeStreamId(state, clientId, streamId);
        });
    }
});
const { participantStreamAdded: $4fc09928452de42f$export$c70b9874f9435dd5, participantStreamIdAdded: $4fc09928452de42f$export$60ba62dc71537bc0, streamStatusUpdated: $4fc09928452de42f$export$b7fd18e34f4b09b4 } = $4fc09928452de42f$export$b64ee0f1b6392800.actions;
const $4fc09928452de42f$export$d0f9ccaaa3a15b4c = $4fc09928452de42f$export$8ffe952306980b53((state)=>$4fc09928452de42f$export$a15ccd242dd0951b(state), (payload)=>(_, getState)=>{
        const state = getState();
        const canEnableRemoteAudio = $4fc09928452de42f$export$c53e10fe73bac35f(state);
        if (payload.enable && !canEnableRemoteAudio) {
            console.warn("Not authorized to perform this action");
            return;
        }
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("request_audio_enable", payload);
    });
const $4fc09928452de42f$export$f7fc15880c03e2a3 = $4fc09928452de42f$export$8ffe952306980b53((state)=>$4fc09928452de42f$export$84f3acf25e9c1055(state), (payload)=>(_, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        socket === null || socket === void 0 || socket.emit("request_video_enable", payload);
    });
const $4fc09928452de42f$export$6e0231f052a79a5 = (state)=>state.remoteParticipants;
const $4fc09928452de42f$export$32b66667e0002c3f = (state)=>state.remoteParticipants.remoteParticipants;
const $4fc09928452de42f$export$f97faf20840c4b0c = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$32b66667e0002c3f, (clients)=>clients.filter((c)=>!$4fc09928452de42f$var$NON_PERSON_ROLES.includes(c.roleName)));
const $4fc09928452de42f$export$c46fa984baba97ca = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$32b66667e0002c3f, (clients)=>clients.length + 1);
const $4fc09928452de42f$export$2a789fd8acb91b21 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$f97faf20840c4b0c, $4fc09928452de42f$export$b8c8b2aa1134778b, (clients, localParticipant)=>{
    if ($4fc09928452de42f$var$NON_PERSON_ROLES.includes(localParticipant.roleName)) return clients.length;
    return clients.length + 1;
});
const $4fc09928452de42f$var$initialState$7 = {
    status: "inactive",
    stream: null,
    error: null
};
const $4fc09928452de42f$export$8e6b4a78bd959605 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "localScreenshare",
    initialState: $4fc09928452de42f$var$initialState$7,
    reducers: {
        stopScreenshare (state, action) {
            return Object.assign(Object.assign({}, state), {
                status: "inactive",
                stream: null
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.pending, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "starting"
            });
        });
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.fulfilled, (state, { payload: { stream: stream } })=>{
            return Object.assign(Object.assign({}, state), {
                status: "active",
                stream: stream
            });
        });
        builder.addCase($4fc09928452de42f$export$ad4f97fa7081697c.rejected, (state, { payload: payload })=>{
            return Object.assign(Object.assign({}, state), {
                error: payload,
                status: "inactive",
                stream: null
            });
        });
    }
});
const { stopScreenshare: $4fc09928452de42f$export$f8682e9675cc7fb7 } = $4fc09928452de42f$export$8e6b4a78bd959605.actions;
const $4fc09928452de42f$export$ad4f97fa7081697c = $4fc09928452de42f$export$7a92a3664c4cb7d1("localScreenshare/doStartScreenshare", (_, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>$4fc09928452de42f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a;
        try {
            const state = getState();
            const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
            if (screenshareStream) return {
                stream: screenshareStream
            };
            const stream = yield navigator.mediaDevices.getDisplayMedia();
            const onEnded = ()=>{
                dispatch($4fc09928452de42f$export$a42cf8a339c4d2f7());
            };
            if ("oninactive" in stream) stream.addEventListener("inactive", onEnded);
            else (_a = stream.getVideoTracks()[0]) === null || _a === void 0 || _a.addEventListener("ended", onEnded);
            return {
                stream: stream
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }));
const $4fc09928452de42f$export$a42cf8a339c4d2f7 = $4fc09928452de42f$export$f3d6a2157932333f(()=>(dispatch, getState)=>{
        const state = getState();
        const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
        if (!screenshareStream) return;
        screenshareStream.getTracks().forEach((track)=>track.stop());
        dispatch($4fc09928452de42f$export$f8682e9675cc7fb7({
            stream: screenshareStream
        }));
    });
const $4fc09928452de42f$export$a859939b0ddea87e = (state)=>state.localScreenshare;
const $4fc09928452de42f$export$ed90fffaa8c7fc13 = (state)=>state.localScreenshare.status;
const $4fc09928452de42f$export$6b29f1ceafb4e0c4 = (state)=>state.localScreenshare.stream;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$9492753e9267457d,
    effect: (_, { getState: getState })=>{
        const state = getState();
        const screenshareStream = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state);
        if (!screenshareStream) return;
        screenshareStream === null || screenshareStream === void 0 || screenshareStream.getTracks().forEach((track)=>{
            track.stop();
        });
    }
});
const $4fc09928452de42f$export$4992adcf1f5b37c0 = (dispatch)=>{
    return {
        emit: (eventName, data)=>{
            if (eventName === "rtc_manager_created") dispatch($4fc09928452de42f$export$8b2ef60a5a8950d4(data));
            else if (eventName === "stream_added") dispatch($4fc09928452de42f$var$rtcEvents.streamAdded(data));
            else if (eventName === "rtc_manager_destroyed") dispatch($4fc09928452de42f$export$ba2a98274508d9fd());
        }
    };
};
const $4fc09928452de42f$var$initialState$6 = {
    dispatcherCreated: false,
    error: null,
    isCreatingDispatcher: false,
    reportedStreamResolutions: {},
    rtcManager: null,
    rtcManagerDispatcher: null,
    rtcManagerInitialized: false,
    status: "inactive",
    isAcceptingStreams: false
};
const $4fc09928452de42f$export$e0e4df945a3863bd = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "rtcConnection",
    initialState: $4fc09928452de42f$var$initialState$6,
    reducers: {
        isAcceptingStreams: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                isAcceptingStreams: action.payload
            });
        },
        resolutionReported: (state, action)=>{
            const { streamId: streamId, width: width, height: height } = action.payload;
            return Object.assign(Object.assign({}, state), {
                reportedStreamResolutions: Object.assign(Object.assign({}, state.reportedStreamResolutions), {
                    [streamId]: {
                        width: width,
                        height: height
                    }
                })
            });
        },
        rtcDisconnected: ()=>{
            return Object.assign({}, $4fc09928452de42f$var$initialState$6);
        },
        rtcDispatcherCreated: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                dispatcherCreated: true,
                rtcManagerDispatcher: action.payload
            });
        },
        rtcManagerCreated: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManager: action.payload,
                status: "ready"
            });
        },
        rtcManagerDestroyed: (state)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManager: null
            });
        },
        rtcManagerInitialized: (state)=>{
            return Object.assign(Object.assign({}, state), {
                rtcManagerInitialized: true
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$fb604b2ee1249ba5, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: "reconnecting"
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state)=>{
            return Object.assign(Object.assign({}, state), {
                status: state.status === "reconnecting" ? "ready" : state.status
            });
        });
    }
});
const { resolutionReported: $4fc09928452de42f$export$4cadac3c05692cdb, rtcDispatcherCreated: $4fc09928452de42f$export$7a0b43c0495fba52, rtcDisconnected: $4fc09928452de42f$export$5217960ace5421a9, rtcManagerCreated: $4fc09928452de42f$export$c62cff42a3450ffb, rtcManagerDestroyed: $4fc09928452de42f$export$ba2a98274508d9fd, rtcManagerInitialized: $4fc09928452de42f$export$11ea47042ef03feb, isAcceptingStreams: $4fc09928452de42f$export$4b7d734e80c97474 } = $4fc09928452de42f$export$e0e4df945a3863bd.actions;
const $4fc09928452de42f$export$57f3bfac00ca31be = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const socket = $4fc09928452de42f$export$b12d0ae99b4b2470(state).socket;
        const dispatcher = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManagerDispatcher;
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(state);
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(state);
        const isNodeSdk = $4fc09928452de42f$export$ab78798f462babdb(state);
        if (dispatcher || !socket) return;
        const webrtcProvider = {
            getMediaConstraints: ()=>({
                    audio: isMicrophoneEnabled,
                    video: isCameraEnabled
                }),
            deferrable (clientId) {
                return !clientId;
            }
        };
        const rtcManagerDispatcher = new (0, $1622be301bae0161$export$b281485fb0422c89)({
            emitter: $4fc09928452de42f$export$4992adcf1f5b37c0(dispatch),
            serverSocket: socket,
            webrtcProvider: webrtcProvider,
            features: {
                isNodeSdk: isNodeSdk,
                lowDataModeEnabled: false,
                sfuServerOverrideHost: undefined,
                turnServerOverrideHost: undefined,
                useOnlyTURN: undefined,
                vp9On: false,
                h264On: false,
                simulcastScreenshareOn: false,
                deviceHandlerFactory: isNodeSdk ? (0, $cqkQU.Safari12).createFactory() : undefined
            }
        });
        dispatch($4fc09928452de42f$export$7a0b43c0495fba52(rtcManagerDispatcher));
    });
const $4fc09928452de42f$export$a699976615c38365 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        if (rtcManager) rtcManager.disconnectAll();
        dispatch($4fc09928452de42f$export$5217960ace5421a9());
    });
const $4fc09928452de42f$export$604759fde97f2d1e = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState)=>{
        var _a;
        dispatch($4fc09928452de42f$export$4b7d734e80c97474(true));
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        const remoteClients = $4fc09928452de42f$export$32b66667e0002c3f(state);
        if (!rtcManager) throw new Error("No rtc manager");
        const activeBreakout = false;
        const shouldAcceptNewClients = (_a = rtcManager.shouldAcceptStreamsFromBothSides) === null || _a === void 0 ? void 0 : _a.call(rtcManager);
        const updates = [];
        for (const { clientId: clientId, streamId: streamId, state: state } of payload){
            const participant = remoteClients.find((p)=>p.id === clientId);
            if (!participant) continue;
            if (state === "to_accept" || state === "new_accept" && shouldAcceptNewClients || state === "old_accept" && !shouldAcceptNewClients) rtcManager.acceptNewStream({
                streamId: streamId === "0" ? clientId : streamId,
                clientId: clientId,
                shouldAddLocalVideo: streamId === "0",
                activeBreakout: activeBreakout
            });
            else if (state === "new_accept" || state === "old_accept") ;
            else if (state === "to_unaccept") rtcManager === null || rtcManager === void 0 || rtcManager.disconnect(streamId === "0" ? clientId : streamId, activeBreakout);
            else if (state !== "done_accept") continue;
            updates.push({
                clientId: clientId,
                streamId: streamId,
                state: state.replace(/to_|new_|old_/, "done_")
            });
        }
        dispatch($4fc09928452de42f$export$b7fd18e34f4b09b4(updates));
        dispatch($4fc09928452de42f$export$4b7d734e80c97474(false));
    });
const $4fc09928452de42f$export$8e38e4b6fee98ae8 = $4fc09928452de42f$export$495454f275c5f192(({ streamId: streamId, width: width, height: height })=>(dispatch, getState)=>{
        const { reportedStreamResolutions: reportedStreamResolutions, rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        const localStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        if (!rtcManager || (localStream === null || localStream === void 0 ? void 0 : localStream.id) === streamId) return;
        const old = reportedStreamResolutions[streamId];
        if (!old || old.width !== width || old.height !== height) rtcManager.updateStreamResolution(streamId, null, {
            width: width || 1,
            height: height || 1
        });
        dispatch($4fc09928452de42f$export$4cadac3c05692cdb({
            streamId: streamId,
            width: width,
            height: height
        }));
    });
const $4fc09928452de42f$export$8b2ef60a5a8950d4 = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch)=>{
        const { rtcManager: rtcManager } = payload;
        dispatch($4fc09928452de42f$export$c62cff42a3450ffb(rtcManager));
    });
const $4fc09928452de42f$export$9ccbbc280e138aa0 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const localMediaStream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(getState()).rtcManager;
        const isCameraEnabled = $4fc09928452de42f$export$c8e0d13b9d33fb32(getState());
        const isMicrophoneEnabled = $4fc09928452de42f$export$ee30c1c2cc195652(getState());
        if (localMediaStream && rtcManager) rtcManager.addNewStream("0", localMediaStream, !isMicrophoneEnabled, !isCameraEnabled);
        dispatch($4fc09928452de42f$export$11ea47042ef03feb());
    });
const $4fc09928452de42f$export$a18c733277909ffc = (state)=>state.rtcConnection;
const $4fc09928452de42f$export$70908e8ca7bafd4f = (state)=>state.rtcConnection.rtcManagerInitialized;
const $4fc09928452de42f$export$e04886b22fca6173 = (state)=>state.rtcConnection.rtcManager;
const $4fc09928452de42f$export$49c8dd8411697335 = (state)=>state.rtcConnection.dispatcherCreated;
const $4fc09928452de42f$export$8472039214e0ccef = (state)=>state.rtcConnection.isCreatingDispatcher;
const $4fc09928452de42f$export$fea824bf20fd1f4d = (state)=>state.rtcConnection.status;
const $4fc09928452de42f$export$e4d4bbfda138e686 = (state)=>state.rtcConnection.isAcceptingStreams;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { replacedTracks: replacedTracks } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const replace = (kind, oldTrack)=>{
            const track = stream === null || stream === void 0 ? void 0 : stream.getTracks().find((t)=>t.kind === kind);
            return track && (rtcManager === null || rtcManager === void 0 ? void 0 : rtcManager.replaceTrack(oldTrack, track));
        };
        replacedTracks === null || replacedTracks === void 0 || replacedTracks.forEach((t)=>{
            replace(t.kind, t);
        });
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { stream: stream } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.addNewStream(stream.id, stream, false, true);
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$d4d0f76450fb6374,
    effect: (_, { getState: getState })=>{
        const rtcManager = $4fc09928452de42f$export$e04886b22fca6173(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.rtcStatsDisconnect();
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$f8682e9675cc7fb7,
    effect: ({ payload: payload }, { getState: getState })=>{
        const { stream: stream } = payload;
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        rtcManager === null || rtcManager === void 0 || rtcManager.removeStream(stream.id, stream, null);
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$128f34559d09c6da.fulfilled,
    effect: ({ payload: payload }, { getState: getState })=>{
        var _a;
        const stream = $4fc09928452de42f$export$e9c4b1bf93e7c80d(getState());
        const { rtcManager: rtcManager } = $4fc09928452de42f$export$a18c733277909ffc(getState());
        if (stream && rtcManager) {
            const replace = (kind, oldTrack)=>{
                const track = stream.getTracks().find((t)=>t.kind === kind);
                return track && rtcManager.replaceTrack(oldTrack, track);
            };
            (_a = payload === null || payload === void 0 ? void 0 : payload.replacedTracks) === null || _a === void 0 || _a.forEach((t)=>{
                replace(t.kind, t);
            });
        }
    }
});
const $4fc09928452de42f$export$e94dcb9ad830cecb = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$ae5e487c0972282e, $4fc09928452de42f$export$49c8dd8411697335, $4fc09928452de42f$export$8472039214e0ccef, $4fc09928452de42f$export$efc69c8f0644aa20, (rtcStatus, appIsActive, dispatcherCreated, isCreatingDispatcher, signalSocket)=>{
    if (appIsActive && rtcStatus === "inactive" && !dispatcherCreated && !isCreatingDispatcher && signalSocket) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e94dcb9ad830cecb
], ({ dispatch: dispatch }, shouldConnectRtc)=>{
    if (shouldConnectRtc) dispatch($4fc09928452de42f$export$57f3bfac00ca31be());
});
const $4fc09928452de42f$export$44d04d69c6e600df = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$e04886b22fca6173, $4fc09928452de42f$export$70908e8ca7bafd4f, $4fc09928452de42f$export$6a731d6bc230a245, (rtcManager, rtcManagerInitialized, localMediaStatus)=>{
    if (localMediaStatus === "started" && rtcManager && !rtcManagerInitialized) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$44d04d69c6e600df
], ({ dispatch: dispatch }, shouldInitializeRtc)=>{
    if (shouldInitializeRtc) dispatch($4fc09928452de42f$export$9ccbbc280e138aa0());
});
const $4fc09928452de42f$export$10c6c710ffdd45f9 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$ae5e487c0972282e, (status, appIsActive)=>{
    if (!appIsActive && ![
        "inactive",
        "disconnected"
    ].includes(status)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$10c6c710ffdd45f9
], ({ dispatch: dispatch }, shouldDisconnectRtc)=>{
    if (shouldDisconnectRtc) dispatch($4fc09928452de42f$export$a699976615c38365());
});
const $4fc09928452de42f$export$e3dc5cd79b27652 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$fea824bf20fd1f4d, $4fc09928452de42f$export$32b66667e0002c3f, (rtcStatus, remoteParticipants)=>{
    if (rtcStatus !== "ready") return [];
    const upd = [];
    for (const client of remoteParticipants){
        const { streams: streams, id: clientId, newJoiner: newJoiner } = client;
        for(let i = 0; i < streams.length; i++){
            let streamId = streams[i].id;
            let state = streams[i].state;
            if ((streams === null || streams === void 0 ? void 0 : streams.length) > 1 && streams[1].id === "0") {
                if (i === 0) {
                    streamId = streams[1].id;
                    state = streams[1].state;
                } else if (i === 1) {
                    streamId = streams[0].id;
                    state = streams[0].state;
                }
            }
            if (state === "done_accept") continue;
            upd.push({
                clientId: clientId,
                streamId: streamId,
                state: `${newJoiner && streamId === "0" ? "new" : "to"}_accept`
            });
        }
    }
    return upd;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$e3dc5cd79b27652,
    $4fc09928452de42f$export$e4d4bbfda138e686
], ({ dispatch: dispatch }, streamsToAccept, isAcceptingStreams)=>{
    if (0 < streamsToAccept.length && !isAcceptingStreams) dispatch($4fc09928452de42f$export$604759fde97f2d1e(streamsToAccept));
});
function $4fc09928452de42f$var$isStreamerClient(client) {
    return client.roleName === "streamer";
}
function $4fc09928452de42f$var$isRecorderClient(client) {
    return client.roleName === "recorder";
}
const $4fc09928452de42f$var$initialState$5 = {
    isLocked: false
};
const $4fc09928452de42f$export$9ce7dca4f26ff3bd = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "room",
    initialState: $4fc09928452de42f$var$initialState$5,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            const { error: error, isLocked: isLocked } = action.payload;
            if (error) return state;
            return Object.assign(Object.assign({}, state), {
                isLocked: Boolean(isLocked)
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomLocked, (state, action)=>{
            const { isLocked: isLocked } = action.payload;
            return Object.assign(Object.assign({}, state), {
                isLocked: Boolean(isLocked)
            });
        });
    }
});
const $4fc09928452de42f$export$9eb5fcf87b4704f2 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$dbb7a81a8f843adc(state), (payload)=>(_, getState)=>{
        const state = getState();
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        socket === null || socket === void 0 || socket.emit("set_lock", {
            locked: payload.locked
        });
    });
const $4fc09928452de42f$export$d5359451ea4b2b4a = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$e73be439ab5a8e31(state), (payload)=>(_, getState)=>{
        const state = getState();
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        socket === null || socket === void 0 || socket.emit("kick_client", {
            clientId: payload.clientId,
            reasonId: "kick"
        });
    });
const $4fc09928452de42f$export$50d90cb8a8eda648 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$69a43832a7c34f54(state), (payload)=>(dispatch, getState)=>{
        const state = getState();
        const clientsToKick = $4fc09928452de42f$export$32b66667e0002c3f(state).map((c)=>c.id);
        if (clientsToKick.length) {
            const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
            socket === null || socket === void 0 || socket.emit("kick_client", {
                clientIds: clientsToKick,
                reasonId: "end-meeting"
            });
        }
        if (!payload.stayBehind) dispatch($4fc09928452de42f$export$d4d0f76450fb6374());
    });
const $4fc09928452de42f$export$f01656cae83dc9e8 = (state)=>state.room.isLocked;
const $4fc09928452de42f$export$5d9bde7516ef4510 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6b29f1ceafb4e0c4, $4fc09928452de42f$export$f97faf20840c4b0c, (localScreenshareStream, remoteParticipants)=>{
    const screenshares = [];
    if (localScreenshareStream) screenshares.push({
        id: localScreenshareStream.id || "local-screenshare",
        participantId: "local",
        hasAudioTrack: localScreenshareStream.getTracks().some((track)=>track.kind === "audio"),
        stream: localScreenshareStream,
        isLocal: true
    });
    for (const participant of remoteParticipants)if (participant.presentationStream) screenshares.push({
        id: participant.presentationStream.id || `pres-${participant.id}`,
        participantId: participant.id,
        hasAudioTrack: participant.presentationStream.getTracks().some((track)=>track.kind === "audio"),
        stream: participant.presentationStream,
        isLocal: false
    });
    return screenshares;
});
const $4fc09928452de42f$export$a16d30bbc7ea403f = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$6b29f1ceafb4e0c4, $4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$f97faf20840c4b0c, (localScreenshareStream, localParticipant, remoteParticipants)=>{
    const views = [];
    if (localScreenshareStream) {
        const isScreenshareAudioEnabled = !!localScreenshareStream.getAudioTracks().length;
        views.push({
            clientId: localParticipant.id,
            displayName: "Your screenshare",
            id: "local-screenshare",
            isAudioEnabled: isScreenshareAudioEnabled,
            isLocalClient: true,
            isPresentation: true,
            isVideoEnabled: true,
            stream: localScreenshareStream
        });
    }
    for (const c of remoteParticipants){
        if ($4fc09928452de42f$var$isStreamerClient(c) || $4fc09928452de42f$var$isRecorderClient(c)) continue;
        const { presentationStream: presentationStream } = c, clientView = $4fc09928452de42f$var$__rest(c, [
            "presentationStream"
        ]);
        const displayName = c.displayName || "Guest";
        const isPresentationActive = presentationStream && presentationStream.active;
        const presentationId = "pres-" + c.id;
        const isStreamActive = c.stream && c.stream.active;
        const isVideoEnabled = c.isVideoEnabled;
        views.push(Object.assign(Object.assign(Object.assign({}, clientView), {
            clientId: c.id,
            displayName: displayName,
            hasActivePresentation: !!isPresentationActive
        }), c.isVideoEnabled ? {
            isVideoEnabled: isVideoEnabled
        } : {}));
        if (isPresentationActive) views.push(Object.assign(Object.assign(Object.assign({}, clientView), {
            clientId: c.id,
            stream: c.presentationStream,
            displayName: `Screenshare (${displayName})`,
            id: presentationId,
            isPresentation: true,
            isVideoEnabled: true
        }), isStreamActive && {
            isRecording: null
        }));
    }
    return views;
});
const $4fc09928452de42f$export$dc94230bce59ebc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$4833cdb2a0a243e3, $4fc09928452de42f$export$a16d30bbc7ea403f, (localParticipant, remoteParticipants)=>{
    return [
        ...localParticipant ? [
            localParticipant
        ] : [],
        ...remoteParticipants
    ];
});
const $4fc09928452de42f$var$initialState$4 = {
    running: false
};
const $4fc09928452de42f$export$f9b8189900b9396b = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "connectionMonitor",
    initialState: $4fc09928452de42f$var$initialState$4,
    reducers: {
        connectionMonitorStarted: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                running: true,
                stopCallbackFunction: action.payload.stopIssueSubscription
            });
        },
        connectionMonitorStopped: ()=>{
            return Object.assign({}, $4fc09928452de42f$var$initialState$4);
        }
    }
});
const { connectionMonitorStarted: $4fc09928452de42f$export$6e7b2c1ea42955c6, connectionMonitorStopped: $4fc09928452de42f$export$193ab7b33bc455e0 } = $4fc09928452de42f$export$f9b8189900b9396b.actions;
const $4fc09928452de42f$export$2ddc2b20a645263b = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        (0, $1622be301bae0161$export$591e741f8b7f4720)(()=>{
            const state = getState();
            const clientViews = $4fc09928452de42f$export$dc94230bce59ebc(state).map((clientView)=>{
                var _a, _b;
                return {
                    id: clientView.id,
                    clientId: clientView.clientId,
                    isLocalClient: clientView.isLocalClient,
                    audio: {
                        enabled: clientView.isAudioEnabled,
                        track: (_a = clientView.stream) === null || _a === void 0 ? void 0 : _a.getAudioTracks()[0]
                    },
                    video: {
                        enabled: clientView.isVideoEnabled,
                        track: (_b = clientView.stream) === null || _b === void 0 ? void 0 : _b.getVideoTracks()[0]
                    },
                    isPresentation: clientView.isPresentation
                };
            });
            return clientViews;
        });
        const issueMonitorSubscription = (0, $1622be301bae0161$export$d2b2fe7aff003090)({
            onUpdatedIssues: (issuesAndMetricsByClients)=>{
                var _a;
                const state = getState();
                const rtcManager = $4fc09928452de42f$export$e04886b22fca6173(state);
                if (!rtcManager) return;
                let lossSend = 0;
                let lossReceive = 0;
                let bitrateSend = 0;
                let bitrateReceive = 0;
                Object.entries(issuesAndMetricsByClients.aggregated.metrics).forEach(([key, value])=>{
                    if (/loc.*packetloss/.test(key)) lossSend = Math.max(lossSend, value.curMax);
                    if (/rem.*packetloss/.test(key)) lossReceive = Math.max(lossReceive, value.curMax);
                    if (/loc.*bitrate/.test(key)) bitrateSend += value.curSum;
                    if (/rem.*bitrate/.test(key)) bitrateReceive += value.curSum;
                });
                rtcManager.sendStatsCustomEvent("insightsStats", {
                    ls: Math.round(lossSend * 1000) / 1000,
                    lr: Math.round(lossReceive * 1000) / 1000,
                    bs: Math.round(bitrateSend),
                    br: Math.round(bitrateReceive),
                    cpu: (_a = issuesAndMetricsByClients.aggregated.metrics["global-cpu-pressure"]) === null || _a === void 0 ? void 0 : _a.curSum,
                    _time: Date.now()
                });
            }
        });
        dispatch($4fc09928452de42f$export$6e7b2c1ea42955c6({
            stopIssueSubscription: issueMonitorSubscription.stop
        }));
    });
const $4fc09928452de42f$export$54c371d7bcfcc11 = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const stopCallbackFn = $4fc09928452de42f$export$be63b6e9f8d28401(state);
        if (stopCallbackFn) stopCallbackFn();
        dispatch($4fc09928452de42f$export$193ab7b33bc455e0());
    });
const $4fc09928452de42f$export$d2585f2d4e06cb7f = (state)=>state.connectionMonitor.running;
const $4fc09928452de42f$export$be63b6e9f8d28401 = (state)=>state.connectionMonitor.stopCallbackFunction;
const $4fc09928452de42f$export$565061e76fcf0d54 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$22f0decfe3c779cc, $4fc09928452de42f$export$d2585f2d4e06cb7f, (roomConnectionStatus, isRunning)=>{
    if (!isRunning && roomConnectionStatus === "connected") return true;
    return false;
});
const $4fc09928452de42f$export$73a5fd73575662ea = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$22f0decfe3c779cc, $4fc09928452de42f$export$d2585f2d4e06cb7f, (roomConnectionStatus, isRunning)=>{
    if (isRunning && [
        "kicked",
        "left"
    ].includes(roomConnectionStatus)) return true;
    return false;
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$565061e76fcf0d54
], ({ dispatch: dispatch }, shouldStartConnectionMonitor)=>{
    if (shouldStartConnectionMonitor) dispatch($4fc09928452de42f$export$2ddc2b20a645263b());
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$73a5fd73575662ea
], ({ dispatch: dispatch }, shouldStartConnectionMonitor)=>{
    if (shouldStartConnectionMonitor) dispatch($4fc09928452de42f$export$54c371d7bcfcc11());
});
const $4fc09928452de42f$var$emitter = new (0, $0bfd6a77e39eae31$exports.EventEmitter)();
function $4fc09928452de42f$var$createNotificationEvent(payload) {
    const notificationEvent = Object.assign(Object.assign({}, payload), {
        timestamp: Date.now()
    });
    return notificationEvent;
}
const $4fc09928452de42f$export$8a538fbf06331f6d = {
    emitter: $4fc09928452de42f$var$emitter,
    events: []
};
const $4fc09928452de42f$export$d90e5af6f326b5f9 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "notifications",
    initialState: $4fc09928452de42f$export$8a538fbf06331f6d,
    reducers: {
        addNotification: (state, action)=>{
            return Object.assign(Object.assign({}, state), {
                events: [
                    ...state.events,
                    Object.assign({}, action.payload)
                ]
            });
        },
        doClearNotifications: (state)=>{
            return Object.assign(Object.assign({}, state), {
                events: []
            });
        }
    }
});
const { doClearNotifications: $4fc09928452de42f$export$5e5f72fa18e2653b } = $4fc09928452de42f$export$d90e5af6f326b5f9.actions;
const $4fc09928452de42f$export$af3829d1c396a88d = $4fc09928452de42f$export$495454f275c5f192((payload)=>(dispatch, getState)=>{
        dispatch($4fc09928452de42f$export$d90e5af6f326b5f9.actions.addNotification(payload));
        const state = getState();
        const emitter = $4fc09928452de42f$export$d73c0f55214a186a(state);
        emitter.emit(payload.type, payload);
        emitter.emit("*", payload);
    });
const $4fc09928452de42f$export$d948b33042c2b6b0 = (state)=>state.notifications;
const $4fc09928452de42f$export$77602b842c31ed13 = (state)=>state.notifications.events;
const $4fc09928452de42f$export$d73c0f55214a186a = (state)=>state.notifications.emitter;
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.chatMessage,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === payload.senderId);
        if (!client) {
            console.warn("Could not find remote client that sent chat message");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: "chatMessageReceived",
            message: `${client.displayName} says: ${payload.text}`,
            props: {
                client: client,
                chatMessage: {
                    senderId: payload.senderId,
                    timestamp: payload.timestamp,
                    text: payload.text
                }
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.audioEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enable: enable, requestedByClientId: requestedByClientId } = payload;
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === requestedByClientId);
        if (!client) {
            console.warn("Could not find remote client that requested a local audio change");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: enable ? "requestAudioEnable" : "requestAudioDisable",
            message: enable ? `${client.displayName} has requested for you to speak` : `${client.displayName} has muted your microphone`,
            props: {
                client: client,
                enable: enable
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.videoEnableRequested,
    effect: ({ payload: payload }, { dispatch: dispatch, getState: getState })=>{
        const { enable: enable, requestedByClientId: requestedByClientId } = payload;
        const state = getState();
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === requestedByClientId);
        if (!client) {
            console.warn("Could not find remote client that requested a local video change");
            return;
        }
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: enable ? "requestVideoEnable" : "requestVideoDisable",
            message: enable ? `${client.displayName} has requested for you to start video` : `${client.displayName} has stopped your video`,
            props: {
                client: client,
                enable: enable
            }
        })));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientMetadataReceived,
    effect: (action, { dispatch: dispatch, getOriginalState: getOriginalState, getState: getState })=>{
        var _a;
        const { error: error, payload: payload } = action.payload;
        if (error || !payload) return;
        const { clientId: clientId, stickyReaction: stickyReaction } = payload;
        const state = getState();
        const canAskToSpeak = $4fc09928452de42f$export$c53e10fe73bac35f(state);
        if (!canAskToSpeak) return;
        const client = $4fc09928452de42f$export$f97faf20840c4b0c(state).find(({ id: id })=>id === clientId);
        if (!client) {
            console.warn("Could not find remote client that provided updated metadata");
            return;
        }
        const previousState = getOriginalState();
        const previousClient = $4fc09928452de42f$export$f97faf20840c4b0c(previousState).find(({ id: id })=>id === clientId);
        if (!stickyReaction && !(previousClient === null || previousClient === void 0 ? void 0 : previousClient.stickyReaction) || (stickyReaction === null || stickyReaction === void 0 ? void 0 : stickyReaction.timestamp) === ((_a = previousClient === null || previousClient === void 0 ? void 0 : previousClient.stickyReaction) === null || _a === void 0 ? void 0 : _a.timestamp)) return;
        dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: stickyReaction ? "remoteHandRaised" : "remoteHandLowered",
            message: `${client.displayName} ${stickyReaction ? "raised" : "lowered"} their hand`,
            props: {
                client: client,
                stickyReaction: stickyReaction
            }
        })));
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$fb9576bb0af6ec25
], ({ dispatch: dispatch, getState: getState }, signalStatus)=>{
    const state = getState();
    const roomConnectionStatus = $4fc09928452de42f$export$22f0decfe3c779cc(state);
    if ([
        "left",
        "kicked"
    ].includes(roomConnectionStatus)) return;
    if (signalStatus === "disconnected") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
        type: "signalTrouble",
        message: `Network connection lost. Trying to reconnect you...`,
        props: {}
    })));
    else if (signalStatus === "connected") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
        type: "signalOk",
        message: `Network connection available`,
        props: {}
    })));
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$6c507f583d588b9f.clientUnableToJoin,
    effect: (action, { dispatch: dispatch })=>{
        var _a;
        if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.error) === "room_full") dispatch($4fc09928452de42f$export$af3829d1c396a88d($4fc09928452de42f$var$createNotificationEvent({
            type: "clientUnableToJoinFullRoom",
            message: "Someone tried to join but the room is full and at capacity.",
            props: {}
        })));
    }
});
const $4fc09928452de42f$export$ab6ffac072dba6ff = {
    audioEnabled: {
        actions: [
            $4fc09928452de42f$export$447462528605c694.fulfilled
        ],
        rtcEventName: "audioEnabled",
        getValue: (state)=>$4fc09928452de42f$export$ee30c1c2cc195652(state),
        getOutput: (value)=>({
                enabled: value
            })
    },
    videoEnabled: {
        actions: [
            $4fc09928452de42f$export$5ce66a04faaa2854.fulfilled
        ],
        rtcEventName: "videoEnabled",
        getValue: (state)=>$4fc09928452de42f$export$c8e0d13b9d33fb32(state),
        getOutput: (value)=>({
                enabled: value
            })
    },
    localStream: {
        actions: [
            $4fc09928452de42f$export$e35f65b306a0e8f6.fulfilled
        ],
        rtcEventName: "localStream",
        getValue: (state)=>{
            var _a;
            return (_a = $4fc09928452de42f$export$e9c4b1bf93e7c80d(state)) === null || _a === void 0 ? void 0 : _a.getTracks().map((track)=>({
                    id: track.id,
                    kind: track.kind,
                    label: track.label
                }));
        },
        getOutput: (value)=>({
                stream: value
            })
    },
    localScreenshareStream: {
        actions: [
            $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled
        ],
        rtcEventName: "localScreenshareStream",
        getValue: (state)=>{
            var _a;
            return (_a = $4fc09928452de42f$export$6b29f1ceafb4e0c4(state)) === null || _a === void 0 ? void 0 : _a.getTracks().map((track)=>({
                    id: track.id,
                    kind: track.kind,
                    label: track.label
                }));
        },
        getOutput: (value)=>({
                tracks: value
            })
    },
    localScreenshareStreamStopped: {
        actions: [
            $4fc09928452de42f$export$f8682e9675cc7fb7
        ],
        rtcEventName: "localScreenshareStream",
        getValue: ()=>()=>null,
        getOutput: ()=>({})
    },
    displayName: {
        actions: [
            $4fc09928452de42f$export$ce7d0f83c324f6cf
        ],
        rtcEventName: "displayName",
        getValue: (state)=>$4fc09928452de42f$export$b157fc4c059768ed(state),
        getOutput: (value)=>({
                displayName: value
            })
    },
    clientId: {
        actions: null,
        rtcEventName: "clientId",
        getValue: (state)=>$4fc09928452de42f$export$b5166f32e739efd8(state),
        getOutput: (value)=>({
                clientId: value
            })
    },
    deviceId: {
        actions: null,
        rtcEventName: "deviceId",
        getValue: (state)=>$4fc09928452de42f$export$595744fa227922ad(state),
        getOutput: (value)=>({
                deviceId: value
            })
    },
    externalId: {
        actions: null,
        rtcEventName: "externalId",
        getValue: (state)=>$4fc09928452de42f$export$44202ee237048d77(state),
        getOutput: (value)=>({
                externalId: value
            })
    },
    organizationId: {
        actions: null,
        rtcEventName: "organizationId",
        getValue: (state)=>$4fc09928452de42f$export$7ba530130176c5b4(state),
        getOutput: (value)=>({
                organizationId: value
            })
    },
    signalConnectionStatus: {
        actions: null,
        rtcEventName: "signalConnectionStatus",
        getValue: (state)=>$4fc09928452de42f$export$fb9576bb0af6ec25(state),
        getOutput: (value)=>({
                status: value
            })
    },
    roomSessionId: {
        actions: [
            $4fc09928452de42f$export$6c507f583d588b9f.newClient,
            $4fc09928452de42f$export$6c507f583d588b9f.roomJoined,
            $4fc09928452de42f$export$6c507f583d588b9f.roomSessionEnded,
            $4fc09928452de42f$export$6c507f583d588b9f.clientLeft
        ],
        rtcEventName: "roomSessionId",
        getValue: (state)=>$4fc09928452de42f$export$9b6909335b1f6412(state),
        getOutput: (value)=>({
                roomSessionId: value
            })
    },
    rtcConnectionStatus: {
        actions: null,
        rtcEventName: "rtcConnectionStatus",
        getValue: (state)=>$4fc09928452de42f$export$fea824bf20fd1f4d(state),
        getOutput: (value)=>({
                status: value
            })
    },
    userRole: {
        actions: null,
        rtcEventName: "userRole",
        getValue: (state)=>$4fc09928452de42f$export$c3921fe844b67c95(state),
        getOutput: (value)=>({
                userRole: value
            })
    }
};
const $4fc09928452de42f$var$rtcCustomEventActions = Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).flatMap(({ actions: actions })=>{
    var _a;
    return (_a = actions === null || actions === void 0 ? void 0 : actions.map((action)=>action)) !== null && _a !== void 0 ? _a : null;
}).filter((action)=>action !== null);
const $4fc09928452de42f$var$makeComparable = (value)=>{
    if (typeof value === "object") return JSON.stringify(value);
    return value;
};
const $4fc09928452de42f$var$initialState$3 = {
    reportedValues: {}
};
const $4fc09928452de42f$export$a42fe34f713ffe77 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    initialState: $4fc09928452de42f$var$initialState$3,
    name: "rtcAnalytics",
    reducers: {
        updateReportedValues (state, action) {
            return Object.assign(Object.assign({}, state), {
                reportedValues: Object.assign(Object.assign({}, state.reportedValues), {
                    [action.payload.rtcEventName]: action.payload.value
                })
            });
        }
    }
});
const $4fc09928452de42f$export$b9e5ec038548823c = $4fc09928452de42f$export$495454f275c5f192(()=>(dispatch, getState)=>{
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        if (!rtcManager) return;
        rtcManager.sendStatsCustomEvent("insightsStats", {
            _time: Date.now(),
            ls: 0,
            lr: 0,
            bs: 0,
            br: 0,
            cpu: 0
        });
        Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).forEach(({ rtcEventName: rtcEventName, getValue: getValue, getOutput: getOutput })=>{
            var _a;
            const value = getValue(state);
            const output = Object.assign(Object.assign({}, getOutput(value)), {
                _time: Date.now()
            });
            const comparableValue = $4fc09928452de42f$var$makeComparable(value);
            if (((_a = state.rtcAnalytics.reportedValues) === null || _a === void 0 ? void 0 : _a[rtcEventName]) !== comparableValue) {
                rtcManager.sendStatsCustomEvent(rtcEventName, output);
                dispatch($4fc09928452de42f$export$3370c8e9ed370d6b({
                    rtcEventName: rtcEventName,
                    value: value
                }));
            }
        });
    });
const { updateReportedValues: $4fc09928452de42f$export$3370c8e9ed370d6b } = $4fc09928452de42f$export$a42fe34f713ffe77.actions;
$4fc09928452de42f$export$4e3495129325ad89({
    matcher: (0, $58dad493bd6ec980$export$2c3435c7647f7b0d)(...$4fc09928452de42f$var$rtcCustomEventActions),
    effect: ({ type: type }, { getState: getState, dispatch: dispatch })=>{
        var _a;
        const state = getState();
        const rtcManager = $4fc09928452de42f$export$a18c733277909ffc(state).rtcManager;
        if (!rtcManager) return;
        const rtcCustomEvent = Object.values($4fc09928452de42f$export$ab6ffac072dba6ff).find(({ actions: actions })=>actions === null || actions === void 0 ? void 0 : actions.map((a)=>a.type).includes(type));
        if (!rtcCustomEvent) return;
        const { getValue: getValue, getOutput: getOutput, rtcEventName: rtcEventName } = rtcCustomEvent;
        const value = getValue(state);
        const comparableValue = $4fc09928452de42f$var$makeComparable(value);
        const output = Object.assign(Object.assign({}, getOutput(value)), {
            _time: Date.now()
        });
        if (((_a = state.rtcAnalytics.reportedValues) === null || _a === void 0 ? void 0 : _a[rtcEventName]) !== comparableValue) {
            rtcManager.sendStatsCustomEvent(rtcEventName, output);
            dispatch($4fc09928452de42f$export$3370c8e9ed370d6b({
                rtcEventName: rtcEventName,
                value: value
            }));
        }
    }
});
$4fc09928452de42f$export$a818dc83df27d0f4([
    $4fc09928452de42f$export$70908e8ca7bafd4f
], ({ dispatch: dispatch }, selectRtcManagerInitialized)=>{
    if (selectRtcManagerInitialized) dispatch($4fc09928452de42f$export$b9e5ec038548823c());
});
function $4fc09928452de42f$export$527315a678f53c03({ isPresentation: isPresentation, stream: stream }) {
    var _a, _b;
    return isPresentation ? (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.outboundId) !== null && _a !== void 0 ? _a : stream === null || stream === void 0 ? void 0 : stream.inboundId) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.id : "0";
}
function $4fc09928452de42f$export$da1ba6c57510a447({ spotlights: spotlights, isPresentation: isPresentation, clientId: clientId, stream: stream }) {
    return !!spotlights.find((s)=>{
        const streamId = $4fc09928452de42f$export$527315a678f53c03({
            isPresentation: isPresentation,
            stream: stream
        });
        return s.clientId === clientId && s.streamId === streamId;
    });
}
function $4fc09928452de42f$var$mergeSpotlight(spotlights, spotlight) {
    const found = spotlights.find((s)=>s.clientId === spotlight.clientId && s.streamId === spotlight.streamId);
    if (found) return spotlights;
    return spotlights.concat(spotlight);
}
function $4fc09928452de42f$var$mapSpotlightsToClientViews(spotlights, clientViews) {
    return spotlights.reduce((acc, s)=>{
        const clientView = clientViews.find((c)=>s.clientId === c.clientId && s.streamId === $4fc09928452de42f$export$527315a678f53c03(c));
        if (clientView && !acc.includes(clientView)) acc.push(clientView);
        return acc;
    }, []);
}
const $4fc09928452de42f$var$initialState$2 = {
    sorted: []
};
const $4fc09928452de42f$export$bdc852be842a0179 = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "spotlights",
    initialState: $4fc09928452de42f$var$initialState$2,
    reducers: {
        addSpotlight (state, action) {
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: $4fc09928452de42f$var$mergeSpotlight(state.sorted, {
                    clientId: clientId,
                    streamId: streamId
                })
            });
        },
        removeSpotlight (state, action) {
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>!(s.clientId === clientId && s.streamId === streamId))
            });
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, action)=>{
            if (!action.payload.room) return state;
            const { spotlights: spotlights } = action.payload.room;
            return Object.assign(Object.assign({}, state), {
                sorted: spotlights
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.spotlightAdded, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: $4fc09928452de42f$var$mergeSpotlight(state.sorted, {
                    clientId: clientId,
                    streamId: streamId
                })
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.spotlightRemoved, (state, action)=>{
            const { clientId: clientId, streamId: streamId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>!(s.clientId === clientId && s.streamId === streamId))
            });
        });
        builder.addMatcher((0, $58dad493bd6ec980$export$2c3435c7647f7b0d)($4fc09928452de42f$export$6c507f583d588b9f.clientKicked, $4fc09928452de42f$export$6c507f583d588b9f.clientLeft), (state, action)=>{
            const { clientId: clientId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                sorted: state.sorted.filter((s)=>s.clientId !== clientId)
            });
        });
    }
});
const { addSpotlight: $4fc09928452de42f$export$fcc5db07d92855e0, removeSpotlight: $4fc09928452de42f$export$2da3c620a495f4c8 } = $4fc09928452de42f$export$bdc852be842a0179.actions;
const $4fc09928452de42f$export$4bf19d94733cc82e = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$7ad9182b247dbca0(state), ({ id: id })=>(_, getState)=>{
        const state = getState();
        const clientView = $4fc09928452de42f$export$dc94230bce59ebc(state).find((c)=>c.clientId === id);
        if (!clientView) return;
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        const streamId = $4fc09928452de42f$export$527315a678f53c03(clientView);
        const payload = {
            clientId: clientView.id,
            streamId: streamId !== null && streamId !== void 0 ? streamId : "0"
        };
        socket === null || socket === void 0 || socket.emit("add_spotlight", payload);
    });
const $4fc09928452de42f$export$65b4309b6edd4ad1 = $4fc09928452de42f$export$ba71e51cd1168d8d((state)=>$4fc09928452de42f$export$7ad9182b247dbca0(state), ({ id: id })=>(_, getState)=>{
        const state = getState();
        const clientView = $4fc09928452de42f$export$dc94230bce59ebc(state).find((c)=>c.clientId === id);
        if (!clientView) return;
        const { socket: socket } = $4fc09928452de42f$export$b12d0ae99b4b2470(state);
        const streamId = $4fc09928452de42f$export$527315a678f53c03(clientView);
        const payload = {
            clientId: clientView.id,
            streamId: streamId !== null && streamId !== void 0 ? streamId : "0"
        };
        socket === null || socket === void 0 || socket.emit("remove_spotlight", payload);
    });
const $4fc09928452de42f$export$30a40d8bb1242958 = (state)=>state.spotlights;
const $4fc09928452de42f$export$f9423c3be80cdebb = (state)=>state.spotlights.sorted;
const $4fc09928452de42f$export$1177c9e6c452b759 = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$b8c8b2aa1134778b, $4fc09928452de42f$export$f9423c3be80cdebb, (localParticipant, spotlights)=>{
    return $4fc09928452de42f$export$da1ba6c57510a447({
        clientId: localParticipant.id,
        stream: localParticipant.stream,
        spotlights: spotlights
    });
});
const $4fc09928452de42f$export$622ce0f62fa78bbc = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)($4fc09928452de42f$export$dc94230bce59ebc, $4fc09928452de42f$export$f9423c3be80cdebb, (clientViews, spotlights)=>{
    return $4fc09928452de42f$var$mapSpotlightsToClientViews(spotlights, clientViews);
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$ad4f97fa7081697c.fulfilled,
    effect: ({ payload: payload }, { getState: getState, dispatch: dispatch })=>{
        const { stream: stream } = payload;
        const state = getState();
        const localParticipant = $4fc09928452de42f$export$b8c8b2aa1134778b(state);
        if (!localParticipant) return;
        dispatch($4fc09928452de42f$export$fcc5db07d92855e0({
            clientId: localParticipant.id,
            streamId: stream.id
        }));
    }
});
$4fc09928452de42f$export$4e3495129325ad89({
    actionCreator: $4fc09928452de42f$export$f8682e9675cc7fb7,
    effect: ({ payload: payload }, { getState: getState, dispatch: dispatch })=>{
        const { stream: stream } = payload;
        const state = getState();
        const localParticipant = $4fc09928452de42f$export$b8c8b2aa1134778b(state);
        if (!localParticipant) return;
        dispatch($4fc09928452de42f$export$2da3c620a495f4c8({
            clientId: localParticipant.id,
            streamId: stream.id
        }));
    }
});
const $4fc09928452de42f$var$initialState$1 = {
    isStreaming: false,
    error: null,
    startedAt: undefined
};
const $4fc09928452de42f$export$c231a66657b64e4c = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "streaming",
    initialState: $4fc09928452de42f$var$initialState$1,
    reducers: {
        doHandleStreamingStarted: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isStreaming: true,
                error: null,
                startedAt: new Date().getTime()
            });
        },
        doHandleStreamingStopped: (state)=>{
            return Object.assign(Object.assign({}, state), {
                isStreaming: false
            });
        }
    }
});
const { doHandleStreamingStarted: $4fc09928452de42f$export$b0972c19c4c2ef31, doHandleStreamingStopped: $4fc09928452de42f$export$85c3199cbeef14e8 } = $4fc09928452de42f$export$c231a66657b64e4c.actions;
const $4fc09928452de42f$export$90baeb59ec142cd0 = (state)=>state.streaming;
const $4fc09928452de42f$var$initialState = {
    waitingParticipants: []
};
const $4fc09928452de42f$export$4a4178c929253d8e = (0, $58dad493bd6ec980$export$4d8d9bd83c24ae8b)({
    name: "waitingParticipants",
    initialState: $4fc09928452de42f$var$initialState,
    reducers: {},
    extraReducers: (builder)=>{
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomJoined, (state, { payload: payload })=>{
            var _a;
            if ((_a = payload.room) === null || _a === void 0 ? void 0 : _a.knockers.length) return Object.assign(Object.assign({}, state), {
                waitingParticipants: payload.room.knockers.map((knocker)=>({
                        id: knocker.clientId,
                        displayName: knocker.displayName
                    }))
            });
            else return state;
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.roomKnocked, (state, action)=>{
            const { clientId: clientId, displayName: displayName } = action.payload;
            return Object.assign(Object.assign({}, state), {
                waitingParticipants: [
                    ...state.waitingParticipants,
                    {
                        id: clientId,
                        displayName: displayName
                    }
                ]
            });
        });
        builder.addCase($4fc09928452de42f$export$6c507f583d588b9f.knockerLeft, (state, action)=>{
            const { clientId: clientId } = action.payload;
            return Object.assign(Object.assign({}, state), {
                waitingParticipants: state.waitingParticipants.filter((p)=>p.id !== clientId)
            });
        });
    }
});
const $4fc09928452de42f$export$1a5b93a56a313cfe = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const { participantId: participantId } = payload;
        const state = getState();
        const socket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        socket === null || socket === void 0 || socket.emit("handle_knock", {
            action: "accept",
            clientId: participantId,
            response: {}
        });
    });
const $4fc09928452de42f$export$dde035bd3d0904ac = $4fc09928452de42f$export$f3d6a2157932333f((payload)=>(dispatch, getState)=>{
        const { participantId: participantId } = payload;
        const state = getState();
        const socket = $4fc09928452de42f$export$efc69c8f0644aa20(state);
        socket === null || socket === void 0 || socket.emit("handle_knock", {
            action: "reject",
            clientId: participantId,
            response: {}
        });
    });
const $4fc09928452de42f$export$e99a87d20a064a78 = (state)=>state.waitingParticipants;
const $4fc09928452de42f$export$2a890977d27b6c75 = (state)=>state.waitingParticipants.waitingParticipants;
var $4fc09928452de42f$var$_a;
const $4fc09928452de42f$var$IS_DEV = ($4fc09928452de42f$var$_a = false, $4fc09928452de42f$var$_a !== void 0) ? $4fc09928452de42f$var$_a : false;
const $4fc09928452de42f$var$appReducer = (0, $ac44486100bacc69$export$66e4520cdb265d18)({
    app: $4fc09928452de42f$export$7a3bdf7180628a3c.reducer,
    authorization: $4fc09928452de42f$export$a8061e375981838e.reducer,
    chat: $4fc09928452de42f$export$89f748d7b911fed0.reducer,
    cloudRecording: $4fc09928452de42f$export$4a7c7275a23ed5bc.reducer,
    connectionMonitor: $4fc09928452de42f$export$f9b8189900b9396b.reducer,
    deviceCredentials: $4fc09928452de42f$export$601059773552eb94.reducer,
    localMedia: $4fc09928452de42f$export$5bb3b96828f370d1.reducer,
    localParticipant: $4fc09928452de42f$export$44a9bbc9e703cf3d.reducer,
    localScreenshare: $4fc09928452de42f$export$8e6b4a78bd959605.reducer,
    notifications: $4fc09928452de42f$export$d90e5af6f326b5f9.reducer,
    organization: $4fc09928452de42f$export$351101b59484838e.reducer,
    remoteParticipants: $4fc09928452de42f$export$b64ee0f1b6392800.reducer,
    room: $4fc09928452de42f$export$9ce7dca4f26ff3bd.reducer,
    roomConnection: $4fc09928452de42f$export$b633f15c3886bdc9.reducer,
    rtcAnalytics: $4fc09928452de42f$export$a42fe34f713ffe77.reducer,
    rtcConnection: $4fc09928452de42f$export$e0e4df945a3863bd.reducer,
    signalConnection: $4fc09928452de42f$export$1010602111efdae4.reducer,
    spotlights: $4fc09928452de42f$export$bdc852be842a0179.reducer,
    streaming: $4fc09928452de42f$export$c231a66657b64e4c.reducer,
    waitingParticipants: $4fc09928452de42f$export$4a4178c929253d8e.reducer
});
const $4fc09928452de42f$export$a8a69c316169e623 = (state, action)=>{
    var _a;
    if ($4fc09928452de42f$export$ca0cd7d9bebf6bc8.match(action)) {
        const resetState = {
            app: Object.assign(Object.assign({}, $4fc09928452de42f$export$7a3bdf7180628a3c.getInitialState()), {
                initialConfig: (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.initialConfig
            }),
            localMedia: Object.assign(Object.assign({}, $4fc09928452de42f$export$5bb3b96828f370d1.getInitialState()), state === null || state === void 0 ? void 0 : state.localMedia)
        };
        return $4fc09928452de42f$var$appReducer(resetState, action);
    }
    return $4fc09928452de42f$var$appReducer(state, action);
};
const $4fc09928452de42f$export$f51a9068ac82ea43 = ({ preloadedState: preloadedState, injectServices: injectServices })=>{
    return (0, $58dad493bd6ec980$export$7d8a5b498da695ac)({
        devTools: $4fc09928452de42f$var$IS_DEV,
        reducer: $4fc09928452de42f$export$a8a69c316169e623,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                thunk: {
                    extraArgument: {
                        services: injectServices
                    }
                },
                serializableCheck: false
            }).prepend($4fc09928452de42f$export$1992b10a91137ec8.middleware),
        preloadedState: preloadedState
    });
};
const $4fc09928452de42f$export$7eabfc5ef2a68f64 = (store, select, onChange)=>{
    let currentState;
    function handleChange() {
        const nextState = select(store.getState());
        if (nextState !== currentState) {
            currentState = nextState;
            onChange(currentState);
        }
    }
    const unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
};
class $4fc09928452de42f$var$Response {
    constructor(initialValues = {}){
        this.data = initialValues.data === undefined ? {} : initialValues.data;
        this.headers = initialValues.headers || {};
        this.status = initialValues.status || 200;
        this.statusText = initialValues.statusText || "OK";
        this.url = initialValues.url || null;
    }
}
function $4fc09928452de42f$var$assertTruthy(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(value, `${parameterName} is required`);
    return value;
}
function $4fc09928452de42f$var$assertBoolean(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "boolean", `${parameterName}<boolean> is required`);
    return value;
}
function $4fc09928452de42f$var$assertNumber(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "number", `${parameterName}<number> is required`);
    return value;
}
function $4fc09928452de42f$var$assertString(value, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof value === "string", `${parameterName}<string> is required`);
    return value;
}
function $4fc09928452de42f$var$assertInstanceOf(value, type, parameterName) {
    const resolvedParameterName = parameterName || type.name[0].toLowerCase() + type.name.substring(1);
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(value instanceof type, `${resolvedParameterName}<${type.name}> is required`);
    return value;
}
function $4fc09928452de42f$var$assertRoomName(roomName, parameterName = "roomName") {
    $4fc09928452de42f$var$assertString(roomName, parameterName);
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(typeof roomName === "string" && roomName[0] === "/", `${parameterName} must begin with a '/'`);
    return roomName;
}
function $4fc09928452de42f$var$assertArray(array, parameterName) {
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(Array.isArray(array), `${parameterName}<array> is required`);
    return array;
}
function $4fc09928452de42f$var$assertOneOf(value, allowedValues, parameterName) {
    $4fc09928452de42f$var$assertTruthy(value, "value");
    $4fc09928452de42f$var$assertArray(allowedValues, "allowedValues");
    const isAllowed = allowedValues.includes(value);
    if (!isAllowed) throw new Error(`${parameterName}<string> must be one of the following: ${allowedValues.join(", ")}`);
    return value;
}
function $4fc09928452de42f$var$assertRecord(ref, name) {
    if (ref === null || ref === undefined || typeof ref !== "object" || Array.isArray(ref)) throw new Error(`${name} must be a record. ${JSON.stringify(ref)}`);
    return ref;
}
function $4fc09928452de42f$var$assertNullOrType(ref, type, name, message) {
    $4fc09928452de42f$var$assertString(name, "name");
    const errorMessage = message || `${name} must be null or of type ${type}`;
    (0, $1622be301bae0161$export$a7a9523472993e97).ok(ref === null || typeof ref === type, errorMessage);
}
function $4fc09928452de42f$var$assertNullOrString(ref, name, message) {
    $4fc09928452de42f$var$assertString(name, "name");
    $4fc09928452de42f$var$assertNullOrType(ref, "string", name, message);
}
function $4fc09928452de42f$var$_getAbsoluteUrl({ baseUrl: baseUrl, url: url }) {
    return baseUrl ? baseUrl + url : url;
}
class $4fc09928452de42f$var$HttpClient {
    _requestAxios(url, options) {
        const axiosOptions = Object.assign({}, options, {
            url: url,
            baseURL: this._baseUrl
        });
        return (0, $a7H8f.default).request(axiosOptions);
    }
    request(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this._requestAxios(url, options).then((response)=>{
            const { data: data, headers: headers, status: status, statusText: statusText, config: config } = response;
            const requestUrl = config && config.url ? $4fc09928452de42f$var$_getAbsoluteUrl({
                baseUrl: config.baseURL,
                url: config.url
            }) : null;
            return new $4fc09928452de42f$var$Response({
                data: data,
                headers: headers,
                status: status,
                statusText: statusText,
                url: requestUrl
            });
        }).catch((error)=>{
            const responseObject = error.response;
            if (!responseObject) throw new Error("Could not make the request.");
            const { data: data, headers: headers, status: status, statusText: statusText, config: config } = responseObject;
            const requestUrl = config && config.url ? $4fc09928452de42f$var$_getAbsoluteUrl({
                baseUrl: config.baseURL,
                url: config.url
            }) : null;
            return Promise.reject(new $4fc09928452de42f$var$Response({
                data: data,
                headers: headers,
                status: status,
                statusText: statusText,
                url: requestUrl
            }));
        });
    }
    constructor({ baseUrl: baseUrl }){
        $4fc09928452de42f$var$assertString(baseUrl, "baseUrl");
        this._baseUrl = baseUrl;
    }
}
class $4fc09928452de42f$var$MultipartHttpClient {
    static dataToFormData(data) {
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(data, "data is required");
        const fd = new FormData();
        Object.keys(data).forEach((key)=>{
            const value = data[key];
            fd.append(key, value);
        });
        return fd;
    }
    request(url, options = {}) {
        const headers = Object.assign(options.headers || {}, {
            "Content-Type": undefined
        });
        return this._httpClient.request(url, Object.assign(options, {
            headers: headers,
            transformRequest: $4fc09928452de42f$var$MultipartHttpClient.dataToFormData
        }));
    }
    constructor({ httpClient: httpClient }){
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(httpClient, "httpClient is required");
        this._httpClient = httpClient;
    }
}
let $4fc09928452de42f$var$btoa;
if (typeof window === "object") $4fc09928452de42f$var$btoa = window.btoa || (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
else if (typeof $parcel$global === "object") $4fc09928452de42f$var$btoa = $parcel$global.btoa || (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
else $4fc09928452de42f$var$btoa = (0, (/*@__PURE__*/$parcel$interopDefault($029faa47ad838cc6$exports)));
function $4fc09928452de42f$var$_getAuthHeader(credentials) {
    if (credentials && credentials.credentials) {
        const btoaStr = `${credentials.credentials.uuid}:${credentials.hmac}`;
        return {
            Authorization: `Basic ${$4fc09928452de42f$var$btoa(btoaStr)}`
        };
    }
    return {};
}
const $4fc09928452de42f$var$noCredentials = ()=>Promise.resolve(null);
class $4fc09928452de42f$var$AuthenticatedHttpClient {
    request(url, options) {
        return this._fetchDeviceCredentials().then((credentials)=>{
            const headers = Object.assign({}, options.headers, $4fc09928452de42f$var$_getAuthHeader(credentials), {
                "X-Appearin-Device-Platform": "web"
            });
            const httpClientOptions = Object.assign({}, options, {
                headers: headers
            });
            return this._httpClient.request(url, httpClientOptions);
        });
    }
    constructor({ httpClient: httpClient, fetchDeviceCredentials: fetchDeviceCredentials }){
        this._httpClient = httpClient;
        this._fetchDeviceCredentials = fetchDeviceCredentials;
    }
}
class $4fc09928452de42f$export$dc890958d2b428da {
    request(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this.authenticatedHttpClient.request(url, options);
    }
    requestMultipart(url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this.authenticatedFormDataHttpClient.request(url, options);
    }
    constructor({ baseUrl: baseUrl = "https://api.appearin.net", fetchDeviceCredentials: fetchDeviceCredentials = $4fc09928452de42f$var$noCredentials } = {}){
        this.authenticatedHttpClient = new $4fc09928452de42f$var$AuthenticatedHttpClient({
            httpClient: new $4fc09928452de42f$var$HttpClient({
                baseUrl: baseUrl
            }),
            fetchDeviceCredentials: fetchDeviceCredentials
        });
        this.authenticatedFormDataHttpClient = new $4fc09928452de42f$var$MultipartHttpClient({
            httpClient: this.authenticatedHttpClient
        });
    }
}
function $4fc09928452de42f$var$nullOrExtract(extract) {
    return (data, propertyName)=>{
        const record = $4fc09928452de42f$var$assertRecord(data, "data");
        const value = record[propertyName];
        return value === null || value === undefined ? null : extract(data, propertyName);
    };
}
function $4fc09928452de42f$var$extractString(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    return $4fc09928452de42f$var$assertString(record[propertyName], propertyName);
}
const $4fc09928452de42f$var$extractNullOrString = $4fc09928452de42f$var$nullOrExtract($4fc09928452de42f$var$extractString);
function $4fc09928452de42f$var$extractDate(data, propertyName) {
    const dateString = $4fc09928452de42f$var$extractString(data, propertyName);
    const d = new Date(dateString);
    if (isNaN(d.getTime())) throw new Error(`Invalid date for ${dateString}`);
    return d;
}
function $4fc09928452de42f$var$extractArrayOfJson(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    return $4fc09928452de42f$var$assertArray(record[propertyName], propertyName);
}
function $4fc09928452de42f$var$extractArray(data, propertyName, transformer) {
    return $4fc09928452de42f$var$extractArrayOfJson(data, propertyName).map((value)=>transformer(value));
}
function $4fc09928452de42f$var$extractJson(data, propertyName) {
    const record = $4fc09928452de42f$var$assertRecord(data, "data");
    const value = record[propertyName];
    return value === undefined ? null : value;
}
class $4fc09928452de42f$export$a9627919734faa48 {
    toJson() {
        return Object.assign({
            credentials: this.credentials,
            hmac: this.hmac
        }, this.userId && {
            userId: this.userId
        });
    }
    static fromJson(json) {
        return new $4fc09928452de42f$export$a9627919734faa48($4fc09928452de42f$var$extractString($4fc09928452de42f$var$extractJson(json, "credentials"), "uuid"), $4fc09928452de42f$var$extractString(json, "hmac"), $4fc09928452de42f$var$extractNullOrString(json, "userId") || undefined);
    }
    constructor(uuid, hmac, userId){
        this.credentials = {
            uuid: uuid
        };
        this.hmac = hmac;
        this.userId = userId;
    }
}
class $4fc09928452de42f$var$DeviceService {
    getCredentials() {
        return this._apiClient.request("/devices", {
            method: "post"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$export$a9627919734faa48.fromJson(data);
        }).catch((error)=>{
            if (error.response) {
                if (error.response.status === 404) return null;
            }
            throw error;
        });
    }
    constructor({ apiClient: apiClient }){
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$var$ChromeStorageStore {
    loadOrDefault(defaultValue) {
        return new Promise((resolve)=>{
            this._chromeStorage.get(this._key, (result)=>{
                const unknownResult = result;
                resolve(unknownResult[this._key] || defaultValue);
            });
        });
    }
    save(value) {
        return new Promise((resolve)=>{
            this._chromeStorage.set({
                [this._key]: value
            }, ()=>{
                resolve();
            });
        });
    }
    constructor(key, chromeStorage){
        this._key = key;
        this._chromeStorage = chromeStorage;
    }
}
class $4fc09928452de42f$var$LocalStorageStore {
    loadOrDefault(defaultValue) {
        try {
            const value = this._localStorage.getItem(this._key);
            if (value) try {
                return Promise.resolve(JSON.parse(value));
            } catch (e) {}
            return Promise.resolve(defaultValue);
        } catch (e) {
            console.warn("Error getting access to storage. Are cookies blocked?", e);
            return Promise.resolve(defaultValue);
        }
    }
    save(value) {
        try {
            this._localStorage.setItem(this._key, JSON.stringify(value));
            return Promise.resolve();
        } catch (e) {
            console.warn("Error getting access to storage. Are cookies blocked?", e);
            return Promise.reject(e);
        }
    }
    constructor(key, localStorage){
        $4fc09928452de42f$var$assertTruthy(localStorage, "localStorage");
        this._key = $4fc09928452de42f$var$assertString(key, "key");
        this._localStorage = localStorage;
    }
}
let $4fc09928452de42f$var$localStorage;
try {
    $4fc09928452de42f$var$localStorage = self.localStorage;
} catch (e) {
    $4fc09928452de42f$var$localStorage = {
        getItem: ()=>undefined,
        key: ()=>undefined,
        setItem: ()=>undefined,
        removeItem: ()=>undefined,
        hasOwnProperty: ()=>undefined,
        length: 0
    };
}
var $4fc09928452de42f$var$localStorage$1 = $4fc09928452de42f$var$localStorage;
const $4fc09928452de42f$var$events = {
    CREDENTIALS_SAVED: "credentials_saved"
};
class $4fc09928452de42f$export$3977fa7307407ad9 extends (0, $0bfd6a77e39eae31$exports.EventEmitter) {
    static create({ baseUrl: baseUrl, storeName: storeName = "CredentialsStorage", storeType: storeType = "localStorage" }) {
        const deviceService = new $4fc09928452de42f$var$DeviceService({
            apiClient: new $4fc09928452de42f$export$dc890958d2b428da({
                baseUrl: baseUrl
            })
        });
        let credentialsStore = null;
        if (storeType === "localStorage") credentialsStore = new $4fc09928452de42f$var$LocalStorageStore(storeName, $4fc09928452de42f$var$localStorage$1);
        else if (storeType === "chromeStorage") credentialsStore = new $4fc09928452de42f$var$ChromeStorageStore(storeName, window["chrome"].storage.local);
        else throw new Error(`Unknown store type: ${storeType}`);
        return new $4fc09928452de42f$export$3977fa7307407ad9({
            deviceService: deviceService,
            credentialsStore: credentialsStore
        });
    }
    _fetchNewCredentialsFromApi() {
        const credentialsStore = this._credentialsStore;
        return new Promise((resolve)=>{
            const fetchCredentials = ()=>{
                this._deviceService.getCredentials().then((credentials)=>{
                    return credentialsStore.save(credentials ? credentials.toJson() : null).then(()=>resolve(credentials));
                }).catch(()=>{
                    setTimeout(fetchCredentials, 2000);
                });
            };
            fetchCredentials();
        });
    }
    getCurrentCredentials() {
        return this._credentialsStore.loadOrDefault(null).then((json)=>json ? $4fc09928452de42f$export$a9627919734faa48.fromJson(json) : null);
    }
    getCredentials() {
        if (!this.credentialsPromise) this.credentialsPromise = this.getCurrentCredentials().then((storedCredentials)=>{
            if (storedCredentials) return storedCredentials;
            return this._fetchNewCredentialsFromApi();
        });
        return this.credentialsPromise;
    }
    saveCredentials(credentials) {
        this.credentialsPromise = undefined;
        return this._credentialsStore.save(credentials.toJson()).then(()=>{
            this.emit($4fc09928452de42f$var$events.CREDENTIALS_SAVED, credentials);
            return credentials;
        });
    }
    setUserId(userId) {
        return this.getCurrentCredentials().then((storedCredentials)=>{
            if (!storedCredentials) console.error("Illegal state: no credentials to set user id for.");
            const userIdChangedFromLocalStorage = storedCredentials === null || storedCredentials.userId !== userId;
            if (!userIdChangedFromLocalStorage) return undefined;
            return this._credentialsStore.save(Object.assign({}, storedCredentials === null || storedCredentials === void 0 ? void 0 : storedCredentials.toJson(), {
                userId: userId
            }));
        }).then(()=>undefined);
    }
    constructor({ deviceService: deviceService, credentialsStore: credentialsStore }){
        super();
        this._deviceService = deviceService;
        this._credentialsStore = credentialsStore;
    }
}
const $4fc09928452de42f$var$noOrganization = ()=>Promise.resolve(undefined);
class $4fc09928452de42f$export$6fe2794aa8aa0e05 {
    _callRequestMethod(method, url, options) {
        $4fc09928452de42f$var$assertString(url, "url");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(url[0] === "/", 'url<String> only accepts relative URLs beginning with "/".');
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(options, "options are required");
        return this._fetchOrganization().then((organization)=>{
            if (!organization) return this._apiClient[method](url, options);
            const { organizationId: organizationId } = organization;
            return this._apiClient[method](`/organizations/${encodeURIComponent(organizationId)}${url}`, options);
        });
    }
    request(url, options) {
        return this._callRequestMethod("request", url, options);
    }
    requestMultipart(url, options) {
        return this._callRequestMethod("requestMultipart", url, options);
    }
    constructor({ apiClient: apiClient, fetchOrganization: fetchOrganization = $4fc09928452de42f$var$noOrganization }){
        this._apiClient = apiClient;
        this._fetchOrganization = fetchOrganization;
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$var$EmbeddedFreeTierStatus {
    static fromJson(data) {
        return new $4fc09928452de42f$var$EmbeddedFreeTierStatus({
            isExhausted: $4fc09928452de42f$var$assertBoolean(data.isExhausted, "isExhausted"),
            renewsAt: new Date($4fc09928452de42f$var$assertString(data.renewsAt, "renewsAt")),
            totalMinutesLimit: $4fc09928452de42f$var$assertNumber(data.totalMinutesLimit, "totalMinutesLimit"),
            totalMinutesUsed: $4fc09928452de42f$var$assertNumber(data.totalMinutesUsed, "totalMinutesUsed")
        });
    }
    constructor({ isExhausted: isExhausted, renewsAt: renewsAt, totalMinutesLimit: totalMinutesLimit, totalMinutesUsed: totalMinutesUsed }){
        this.isExhausted = isExhausted;
        this.renewsAt = renewsAt;
        this.totalMinutesLimit = totalMinutesLimit;
        this.totalMinutesUsed = totalMinutesUsed;
    }
}
class $4fc09928452de42f$var$Account {
    static fromJson(data) {
        return new $4fc09928452de42f$var$Account({
            basePlanId: typeof data.basePlanId === "string" ? data.basePlanId : null,
            isDeactivated: $4fc09928452de42f$var$assertBoolean(data.isDeactivated, "isDeactivated"),
            isOnTrial: $4fc09928452de42f$var$assertBoolean(data.isOnTrial, "isOnTrial"),
            onTrialUntil: typeof data.onTrialUntil === "string" ? new Date(data.onTrialUntil) : null,
            trialStatus: typeof data.trialStatus === "string" ? data.trialStatus : null,
            embeddedFreeTierStatus: data.embeddedFreeTierStatus ? $4fc09928452de42f$var$EmbeddedFreeTierStatus.fromJson(data.embeddedFreeTierStatus) : null
        });
    }
    constructor({ basePlanId: basePlanId, embeddedFreeTierStatus: embeddedFreeTierStatus, isDeactivated: isDeactivated, isOnTrial: isOnTrial, onTrialUntil: onTrialUntil, trialStatus: trialStatus }){
        this.basePlanId = basePlanId;
        this.isDeactivated = isDeactivated;
        this.isOnTrial = isOnTrial;
        this.onTrialUntil = onTrialUntil || null;
        this.trialStatus = trialStatus || null;
        this.embeddedFreeTierStatus = embeddedFreeTierStatus || null;
    }
}
function $4fc09928452de42f$export$96bdbc84526f3739(value) {
    return value !== null && value !== undefined;
}
function $4fc09928452de42f$var$createOrganizationLimits(limits = {}) {
    return {
        maxNumberOfInvitationsAndUsers: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfInvitationsAndUsers) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfInvitationsAndUsers) : null,
        maxNumberOfClaimedRooms: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfClaimedRooms) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxNumberOfClaimedRooms) : null,
        maxRoomLimitPerOrganization: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.maxRoomLimitPerOrganization) ? Number(limits === null || limits === void 0 ? void 0 : limits.maxRoomLimitPerOrganization) : null,
        trialMinutesLimit: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.trialMinutesLimit) ? Number(limits === null || limits === void 0 ? void 0 : limits.trialMinutesLimit) : null,
        includedUnits: $4fc09928452de42f$export$96bdbc84526f3739(limits === null || limits === void 0 ? void 0 : limits.includedUnits) ? Number(limits === null || limits === void 0 ? void 0 : limits.includedUnits) : null
    };
}
class $4fc09928452de42f$var$Organization {
    static fromJson(data) {
        const parsedData = $4fc09928452de42f$var$assertInstanceOf(data, Object, "data");
        const preferences = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.preferences) || {};
        const onboardingSurvey = (parsedData === null || parsedData === void 0 ? void 0 : parsedData.onboardingSurvey) || null;
        const permissions = $4fc09928452de42f$var$assertInstanceOf(parsedData.permissions, Object, "permissions");
        return new $4fc09928452de42f$var$Organization({
            organizationId: $4fc09928452de42f$var$assertString(parsedData.organizationId, "organizationId"),
            organizationName: $4fc09928452de42f$var$assertString(parsedData.organizationName, "organizationName"),
            subdomain: $4fc09928452de42f$var$assertString(parsedData.subdomain, "subdomain"),
            permissions: permissions,
            limits: $4fc09928452de42f$var$createOrganizationLimits($4fc09928452de42f$var$assertInstanceOf(parsedData.limits, Object, "limits")),
            account: parsedData.account ? $4fc09928452de42f$var$Account.fromJson(parsedData.account) : null,
            logoImageUrl: typeof parsedData.logoImageUrl === "string" ? parsedData.logoImageUrl : null,
            roomBackgroundImageUrl: typeof parsedData.roomBackgroundImageUrl === "string" ? parsedData.roomBackgroundImageUrl : null,
            roomBackgroundThumbnailUrl: typeof parsedData.roomBackgroundThumbnailUrl === "string" ? parsedData.roomBackgroundThumbnailUrl : null,
            roomKnockPageBackgroundImageUrl: typeof parsedData.roomKnockPageBackgroundImageUrl === "string" ? parsedData.roomKnockPageBackgroundImageUrl : null,
            roomKnockPageBackgroundThumbnailUrl: typeof parsedData.roomKnockPageBackgroundThumbnailUrl === "string" ? parsedData.roomKnockPageBackgroundThumbnailUrl : null,
            preferences: preferences,
            onboardingSurvey: onboardingSurvey,
            type: typeof parsedData.type === "string" ? parsedData.type : null
        });
    }
    constructor(properties){
        this.logoImageUrl = null;
        this.roomBackgroundImageUrl = null;
        this.roomBackgroundThumbnailUrl = null;
        this.roomKnockPageBackgroundImageUrl = null;
        this.roomKnockPageBackgroundThumbnailUrl = null;
        this.preferences = null;
        this.onboardingSurvey = null;
        this.type = null;
        $4fc09928452de42f$var$assertInstanceOf(properties, Object, "properties");
        $4fc09928452de42f$var$assertString(properties.organizationId, "organizationId");
        $4fc09928452de42f$var$assertString(properties.organizationName, "organizationName");
        $4fc09928452de42f$var$assertString(properties.subdomain, "subdomain");
        $4fc09928452de42f$var$assertInstanceOf(properties.permissions, Object, "permissions");
        $4fc09928452de42f$var$assertInstanceOf(properties.limits, Object, "limits");
        this.organizationId = properties.organizationId;
        this.organizationName = properties.organizationName;
        this.subdomain = properties.subdomain;
        this.permissions = properties.permissions;
        this.limits = properties.limits;
        this.account = properties.account ? new $4fc09928452de42f$var$Account(properties.account) : null;
        this.logoImageUrl = properties.logoImageUrl;
        this.roomBackgroundImageUrl = properties.roomBackgroundImageUrl;
        this.roomBackgroundThumbnailUrl = properties.roomBackgroundThumbnailUrl;
        this.roomKnockPageBackgroundImageUrl = properties.roomKnockPageBackgroundImageUrl;
        this.roomKnockPageBackgroundThumbnailUrl = properties.roomKnockPageBackgroundThumbnailUrl;
        this.preferences = properties.preferences;
        this.onboardingSurvey = properties.onboardingSurvey;
        this.type = properties.type;
    }
}
$4fc09928452de42f$var$Organization.GLOBAL_ORGANIZATION_ID = "1";
class $4fc09928452de42f$export$abbf95a02a0c9d38 {
    createOrganization({ organizationName: organizationName, subdomain: subdomain, owner: owner }) {
        const { displayName: displayName, consents: consents } = owner || {};
        const email = "email" in owner ? {
            value: owner.email,
            verificationCode: $4fc09928452de42f$var$assertString(owner.verificationCode, "owner.verificationCode")
        } : null;
        const idToken = "idToken" in owner ? owner.idToken : null;
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        $4fc09928452de42f$var$assertString(organizationName, "organizationName");
        $4fc09928452de42f$var$assertString(displayName, "owner.displayName");
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(email || idToken, "owner.email or owner.idToken is required");
        if (consents) {
            $4fc09928452de42f$var$assertArray(consents, "consents");
            for (const { consentRevisionId: consentRevisionId, action: action } of consents){
                $4fc09928452de42f$var$assertString(consentRevisionId, "consentRevisionId");
                $4fc09928452de42f$var$assertNullOrString(action, "action");
            }
        }
        return this._apiClient.request(`/organizations`, {
            method: "POST",
            data: {
                organizationName: organizationName,
                type: "private",
                subdomain: subdomain,
                owner: Object.assign(Object.assign(Object.assign(Object.assign({}, email && {
                    email: email
                }), idToken && {
                    idToken: idToken
                }), consents && {
                    consents: consents
                }), {
                    displayName: displayName
                })
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractString(data, "organizationId");
        });
    }
    getOrganizationBySubdomain(subdomain) {
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        return this._apiClient.request(`/organization-subdomains/${encodeURIComponent(subdomain)}/?fields=permissions,account,onboardingSurvey`, {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$Organization.fromJson(data);
        }).catch((res)=>{
            if (res instanceof $4fc09928452de42f$var$Response) {
                if (res.status === 404) return null;
                throw new Error(res.statusText);
            }
            throw res;
        });
    }
    getOrganizationByOrganizationId(organizationId) {
        $4fc09928452de42f$var$assertString(organizationId, "organizationId");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}?fields=permissions,account`, {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$Organization.fromJson(data);
        }).catch((res)=>{
            if (res instanceof $4fc09928452de42f$var$Response) {
                if (res.status === 404) return null;
                throw new Error(res.statusText);
            }
            throw res;
        });
    }
    getOrganizationsByContactPoint(options) {
        const { code: code } = options;
        const email = "email" in options ? options.email : null;
        const phoneNumber = "phoneNumber" in options ? options.phoneNumber : null;
        (0, $1622be301bae0161$export$a7a9523472993e97).ok((email || phoneNumber) && !(email && phoneNumber), "either email or phoneNumber is required");
        $4fc09928452de42f$var$assertString(code, "code");
        const contactPoint = email ? {
            type: "email",
            value: email
        } : {
            type: "phoneNumber",
            value: phoneNumber
        };
        return this._apiClient.request("/organization-queries", {
            method: "POST",
            data: {
                contactPoint: contactPoint,
                code: code
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (organization)=>$4fc09928452de42f$var$Organization.fromJson(organization));
        });
    }
    getOrganizationsByIdToken({ idToken: idToken }) {
        $4fc09928452de42f$var$assertString(idToken, "idToken");
        return this._apiClient.request("/organization-queries", {
            method: "POST",
            data: {
                idToken: idToken
            }
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (organization)=>{
                return $4fc09928452de42f$var$Organization.fromJson(Object.assign({
                    permissions: {},
                    limits: {}
                }, $4fc09928452de42f$var$assertRecord(organization, "organization")));
            });
        });
    }
    getOrganizationsByLoggedInUser() {
        return this._apiClient.request("/user/organizations", {
            method: "GET"
        }).then(({ data: data })=>{
            return $4fc09928452de42f$var$extractArray(data, "organizations", (o)=>{
                return $4fc09928452de42f$var$Organization.fromJson(Object.assign({
                    permissions: {},
                    limits: {}
                }, $4fc09928452de42f$var$assertRecord(o, "organization")));
            });
        });
    }
    getSubdomainAvailability(subdomain) {
        $4fc09928452de42f$var$assertString(subdomain, "subdomain");
        return this._apiClient.request(`/organization-subdomains/${encodeURIComponent(subdomain)}/availability`, {
            method: "GET"
        }).then(({ data: data })=>{
            $4fc09928452de42f$var$assertInstanceOf(data, Object, "data");
            return {
                status: $4fc09928452de42f$var$extractString(data, "status")
            };
        });
    }
    updatePreferences({ organizationId: organizationId, preferences: preferences }) {
        $4fc09928452de42f$var$assertTruthy(organizationId, "organizationId");
        $4fc09928452de42f$var$assertTruthy(preferences, "preferences");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}/preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    deleteOrganization({ organizationId: organizationId }) {
        $4fc09928452de42f$var$assertTruthy(organizationId, "organizationId");
        return this._apiClient.request(`/organizations/${encodeURIComponent(organizationId)}`, {
            method: "DELETE"
        }).then(()=>undefined);
    }
    constructor({ apiClient: apiClient }){
        this._apiClient = apiClient;
    }
}
class $4fc09928452de42f$export$c93ff2f01d9e9b32 {
    initOrganization() {
        return this.fetchOrganization().then(()=>undefined);
    }
    fetchOrganization() {
        if (!this._organizationPromise) this._organizationPromise = this._organizationService.getOrganizationBySubdomain(this._subdomain);
        return this._organizationPromise;
    }
    constructor({ organizationService: organizationService, subdomain: subdomain }){
        this._organizationService = organizationService;
        this._subdomain = subdomain;
        this._organizationPromise = null;
    }
}
class $4fc09928452de42f$var$Room {
    constructor(properties = {}){
        (0, $1622be301bae0161$export$a7a9523472993e97).ok(properties instanceof Object, "properties<object> must be empty or an object");
        this.isClaimed = false;
        this.isBanned = false;
        this.isLocked = false;
        this.knockPage = {
            backgroundImageUrl: null,
            backgroundThumbnailUrl: null
        };
        this.logoUrl = null;
        this.backgroundImageUrl = null;
        this.backgroundThumbnailUrl = null;
        this.type = null;
        this.legacyRoomType = null;
        this.mode = null;
        this.product = null;
        this.roomName = null;
        this.theme = null;
        this.preferences = {};
        this.protectedPreferences = {};
        this.publicProfile = null;
        const validProperties = {};
        Object.getOwnPropertyNames(properties).forEach((prop)=>{
            if (Object.getOwnPropertyNames(this).indexOf(prop) !== -1) validProperties[prop] = properties[prop];
        });
        if (properties.ownerId !== undefined) this.ownerId = properties.ownerId;
        if (properties.meeting !== undefined) this.meeting = properties.meeting;
        Object.assign(this, validProperties);
    }
}
class $4fc09928452de42f$var$Meeting {
    static fromJson(data) {
        return new $4fc09928452de42f$var$Meeting({
            meetingId: $4fc09928452de42f$var$extractString(data, "meetingId"),
            roomName: $4fc09928452de42f$var$extractString(data, "roomName"),
            roomUrl: $4fc09928452de42f$var$extractString(data, "roomUrl"),
            startDate: $4fc09928452de42f$var$extractDate(data, "startDate"),
            endDate: $4fc09928452de42f$var$extractDate(data, "endDate"),
            hostRoomUrl: $4fc09928452de42f$var$extractNullOrString(data, "hostRoomUrl"),
            viewerRoomUrl: $4fc09928452de42f$var$extractNullOrString(data, "viewerRoomUrl")
        });
    }
    constructor({ meetingId: meetingId, roomName: roomName, roomUrl: roomUrl, startDate: startDate, endDate: endDate, hostRoomUrl: hostRoomUrl, viewerRoomUrl: viewerRoomUrl }){
        $4fc09928452de42f$var$assertString(meetingId, "meetingId");
        $4fc09928452de42f$var$assertString(roomName, "roomName");
        $4fc09928452de42f$var$assertString(roomUrl, "roomUrl");
        $4fc09928452de42f$var$assertInstanceOf(startDate, Date, "startDate");
        $4fc09928452de42f$var$assertInstanceOf(endDate, Date, "endDate");
        this.meetingId = meetingId;
        this.roomName = roomName;
        this.roomUrl = roomUrl;
        this.startDate = startDate;
        this.endDate = endDate;
        this.hostRoomUrl = hostRoomUrl;
        this.viewerRoomUrl = viewerRoomUrl;
    }
}
function $4fc09928452de42f$var$createRoomUrl(roomName, path = "") {
    const encodedDisplayName = encodeURIComponent(roomName.substring(1));
    return `/room/${encodedDisplayName}${path}`;
}
class $4fc09928452de42f$export$a7d5657d420fa521 {
    getRooms({ types: types, fields: fields = [] } = {}) {
        $4fc09928452de42f$var$assertArray(types, "types");
        $4fc09928452de42f$var$assertArray(fields, "fields");
        return this._organizationApiClient.request("/room", {
            method: "GET",
            params: {
                types: types.join(","),
                fields: fields.join(","),
                includeOnlyLegacyRoomType: "false"
            }
        }).then(({ data: data })=>data.rooms.map((room)=>new $4fc09928452de42f$var$Room(room)));
    }
    getRoom({ roomName: roomName, fields: fields }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/rooms/${encodedDisplayName}`, {
            method: "GET",
            params: Object.assign({
                includeOnlyLegacyRoomType: "false"
            }, fields && {
                fields: fields.join(",")
            })
        }).then(({ data: data })=>new $4fc09928452de42f$var$Room(Object.assign({}, data, Object.assign({
                roomName: roomName
            }, data.meeting && {
                meeting: $4fc09928452de42f$var$Meeting.fromJson(data.meeting)
            })))).catch((response)=>{
            if (response.status === 404) return new $4fc09928452de42f$var$Room({
                roomName: roomName,
                isClaimed: false,
                mode: "normal",
                product: {
                    categoryName: "personal_free"
                },
                type: "personal",
                legacyRoomType: "free"
            });
            if (response.status === 400 && response.data.error === "Banned room") return new $4fc09928452de42f$var$Room({
                roomName: roomName,
                isBanned: true
            });
            throw new Error(response.data ? response.data.error : "Could not fetch room information");
        });
    }
    claimRoom({ roomName: roomName, type: type, mode: mode, isLocked: isLocked }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(type, "type");
        return this._organizationApiClient.request("/room/claim", {
            method: "POST",
            data: Object.assign(Object.assign({
                roomName: roomName,
                type: type
            }, typeof mode === "string" && {
                mode: mode
            }), typeof isLocked === "boolean" && {
                isLocked: isLocked
            })
        }).then(()=>undefined).catch((response)=>{
            throw new Error(response.data.error || "Failed to claim room");
        });
    }
    unclaimRoom(roomName) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}`, {
            method: "DELETE"
        }).then(()=>undefined);
    }
    renameRoom({ roomName: roomName, newRoomName: newRoomName }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(newRoomName, "newRoomName");
        const encodedRoomName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedRoomName}/roomName`, {
            method: "PUT",
            data: {
                newRoomName: newRoomName
            }
        }).then(()=>undefined);
    }
    changeMode({ roomName: roomName, mode: mode }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(mode, "mode");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/mode`, {
            method: "PUT",
            data: {
                mode: mode
            }
        }).then(()=>undefined);
    }
    updatePreferences({ roomName: roomName, preferences: preferences }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertInstanceOf(preferences, Object, "preferences");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    updateProtectedPreferences({ roomName: roomName, preferences: preferences }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertInstanceOf(preferences, Object, "preferences");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/protected-preferences`, {
            method: "PATCH",
            data: preferences
        }).then(()=>undefined);
    }
    getRoomPermissions(roomName, { roomKey: roomKey } = {}) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, "/permissions"), Object.assign({
            method: "GET"
        }, roomKey && {
            headers: {
                "X-Whereby-Room-Key": roomKey
            }
        })).then((response)=>{
            const { permissions: permissions, limits: limits } = response.data;
            return {
                permissions: permissions,
                limits: limits
            };
        });
    }
    getRoomMetrics({ roomName: roomName, metrics: metrics, from: from, to: to }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertString(metrics, "metrics");
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, "/metrics"), {
            method: "GET",
            params: {
                metrics: metrics,
                from: from,
                to: to
            }
        }).then((response)=>response.data);
    }
    changeType({ roomName: roomName, type: type }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertOneOf(type, [
            "personal",
            "personal_xl"
        ], "type");
        const encodedDisplayName = encodeURIComponent(roomName.substring(1));
        return this._organizationApiClient.request(`/room/${encodedDisplayName}/type`, {
            method: "PUT",
            data: {
                type: type
            }
        }).then(()=>undefined);
    }
    getForestSocialImage({ roomName: roomName, count: count }) {
        $4fc09928452de42f$var$assertRoomName(roomName);
        $4fc09928452de42f$var$assertNumber(count, "count");
        return this._organizationApiClient.request($4fc09928452de42f$var$createRoomUrl(roomName, `/forest-social-image/${count}`), {
            method: "GET"
        }).then((response)=>response.data.imageUrl);
    }
    constructor({ organizationApiClient: organizationApiClient }){
        this._organizationApiClient = $4fc09928452de42f$var$assertInstanceOf(organizationApiClient, $4fc09928452de42f$export$6fe2794aa8aa0e05);
    }
}
class $4fc09928452de42f$var$RoomParticipant {
    constructor({ displayName: displayName, id: id, stream: stream, isAudioEnabled: isAudioEnabled, isVideoEnabled: isVideoEnabled, stickyReaction: stickyReaction, isDialIn: isDialIn }){
        this.isLocalParticipant = false;
        this.displayName = displayName;
        this.id = id;
        this.stream = stream;
        this.isAudioEnabled = isAudioEnabled;
        this.isVideoEnabled = isVideoEnabled;
        this.stickyReaction = stickyReaction;
        this.isDialIn = isDialIn;
    }
}
class $4fc09928452de42f$export$ed007fa30041dd89 extends $4fc09928452de42f$var$RoomParticipant {
    constructor({ displayName: displayName, id: id, stream: stream, isAudioEnabled: isAudioEnabled, isVideoEnabled: isVideoEnabled, stickyReaction: stickyReaction, isDialIn: isDialIn }){
        super({
            displayName: displayName,
            id: id,
            stream: stream,
            isAudioEnabled: isAudioEnabled,
            isVideoEnabled: isVideoEnabled,
            stickyReaction: stickyReaction,
            isDialIn: isDialIn
        });
        this.isLocalParticipant = true;
    }
}
const $4fc09928452de42f$var$API_BASE_URL = "https://api.whereby.dev";
function $4fc09928452de42f$export$1f39bff4033c2336() {
    const credentialsService = $4fc09928452de42f$export$3977fa7307407ad9.create({
        baseUrl: $4fc09928452de42f$var$API_BASE_URL
    });
    const apiClient = new $4fc09928452de42f$export$dc890958d2b428da({
        fetchDeviceCredentials: credentialsService.getCredentials.bind(credentialsService),
        baseUrl: $4fc09928452de42f$var$API_BASE_URL
    });
    const organizationService = new $4fc09928452de42f$export$abbf95a02a0c9d38({
        apiClient: apiClient
    });
    const fetchOrganizationFromRoomUrl = (roomUrl)=>{
        const roomUrlObj = new URL(roomUrl);
        const urls = (0, $1622be301bae0161$export$a08dede735aa5b41)({
            host: roomUrlObj.host
        });
        const organizationServiceCache = new $4fc09928452de42f$export$c93ff2f01d9e9b32({
            organizationService: organizationService,
            subdomain: urls.subdomain
        });
        return organizationServiceCache.fetchOrganization();
    };
    return {
        credentialsService: credentialsService,
        apiClient: apiClient,
        organizationService: organizationService,
        fetchOrganizationFromRoomUrl: fetchOrganizationFromRoomUrl
    };
}



var $72a1b7fe1c0aa35a$exports = {};
"use strict";
const $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START = 0xd800;
const $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_END = 0xdbff;
const $72a1b7fe1c0aa35a$var$LOW_SURROGATE_START = 0xdc00;
const $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_START = 0x1f1e6;
const $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_END = 0x1f1ff;
const $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_START = 0x1f3fb;
const $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_END = 0x1f3ff;
const $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_START = 0xfe00;
const $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_END = 0xfe0f;
const $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_START = 0x20d0;
const $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_END = 0x20ff;
const $72a1b7fe1c0aa35a$var$ZWJ = 0x200d;
const $72a1b7fe1c0aa35a$var$GRAPHEMS = [
    0x0308,
    0x0937,
    0x0937,
    0x093F,
    0x093F,
    0x0BA8,
    0x0BBF,
    0x0BCD,
    0x0E31,
    0x0E33,
    0x0E40,
    0x0E49,
    0x1100,
    0x1161,
    0x11A8 // ( ᆨ ) HANGUL JONGSEONG KIYEOK
];
function $72a1b7fe1c0aa35a$var$runes(string) {
    if (typeof string !== "string") throw new Error("string cannot be undefined or null");
    const result = [];
    let i = 0;
    let increment = 0;
    while(i < string.length){
        increment += $72a1b7fe1c0aa35a$var$nextUnits(i + increment, string);
        if ($72a1b7fe1c0aa35a$var$isGraphem(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isVariationSelector(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isDiacriticalMark(string[i + increment])) increment++;
        if ($72a1b7fe1c0aa35a$var$isZeroWidthJoiner(string[i + increment])) {
            increment++;
            continue;
        }
        result.push(string.substring(i, i + increment));
        i += increment;
        increment = 0;
    }
    return result;
}
// Decide how many code units make up the current character.
// BMP characters: 1 code unit
// Non-BMP characters (represented by surrogate pairs): 2 code units
// Emoji with skin-tone modifiers: 4 code units (2 code points)
// Country flags: 4 code units (2 code points)
// Variations: 2 code units
function $72a1b7fe1c0aa35a$var$nextUnits(i, string) {
    const current = string[i];
    // If we don't have a value that is part of a surrogate pair, or we're at
    // the end, only take the value at i
    if (!$72a1b7fe1c0aa35a$var$isFirstOfSurrogatePair(current) || i === string.length - 1) return 1;
    const currentPair = current + string[i + 1];
    let nextPair = string.substring(i + 2, i + 5);
    // Country flags are comprised of two regional indicator symbols,
    // each represented by a surrogate pair.
    // See http://emojipedia.org/flags/
    // If both pairs are regional indicator symbols, take 4
    if ($72a1b7fe1c0aa35a$var$isRegionalIndicator(currentPair) && $72a1b7fe1c0aa35a$var$isRegionalIndicator(nextPair)) return 4;
    // If the next pair make a Fitzpatrick skin tone
    // modifier, take 4
    // See http://emojipedia.org/modifiers/
    // Technically, only some code points are meant to be
    // combined with the skin tone modifiers. This function
    // does not check the current pair to see if it is
    // one of them.
    if ($72a1b7fe1c0aa35a$var$isFitzpatrickModifier(nextPair)) return 4;
    return 2;
}
function $72a1b7fe1c0aa35a$var$isFirstOfSurrogatePair(string) {
    return string && $72a1b7fe1c0aa35a$var$betweenInclusive(string[0].charCodeAt(0), $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START, $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_END);
}
function $72a1b7fe1c0aa35a$var$isRegionalIndicator(string) {
    return $72a1b7fe1c0aa35a$var$betweenInclusive($72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(string), $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_START, $72a1b7fe1c0aa35a$var$REGIONAL_INDICATOR_END);
}
function $72a1b7fe1c0aa35a$var$isFitzpatrickModifier(string) {
    return $72a1b7fe1c0aa35a$var$betweenInclusive($72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(string), $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_START, $72a1b7fe1c0aa35a$var$FITZPATRICK_MODIFIER_END);
}
function $72a1b7fe1c0aa35a$var$isVariationSelector(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$betweenInclusive(string.charCodeAt(0), $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_START, $72a1b7fe1c0aa35a$var$VARIATION_MODIFIER_END);
}
function $72a1b7fe1c0aa35a$var$isDiacriticalMark(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$betweenInclusive(string.charCodeAt(0), $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_START, $72a1b7fe1c0aa35a$var$DIACRITICAL_MARKS_END);
}
function $72a1b7fe1c0aa35a$var$isGraphem(string) {
    return typeof string === "string" && $72a1b7fe1c0aa35a$var$GRAPHEMS.indexOf(string.charCodeAt(0)) !== -1;
}
function $72a1b7fe1c0aa35a$var$isZeroWidthJoiner(string) {
    return typeof string === "string" && string.charCodeAt(0) === $72a1b7fe1c0aa35a$var$ZWJ;
}
function $72a1b7fe1c0aa35a$var$codePointFromSurrogatePair(pair) {
    const highOffset = pair.charCodeAt(0) - $72a1b7fe1c0aa35a$var$HIGH_SURROGATE_START;
    const lowOffset = pair.charCodeAt(1) - $72a1b7fe1c0aa35a$var$LOW_SURROGATE_START;
    return (highOffset << 10) + lowOffset + 0x10000;
}
function $72a1b7fe1c0aa35a$var$betweenInclusive(value, lower, upper) {
    return value >= lower && value <= upper;
}
function $72a1b7fe1c0aa35a$var$substring(string, start, width) {
    const chars = $72a1b7fe1c0aa35a$var$runes(string);
    if (start === undefined) return string;
    if (start >= chars.length) return "";
    const rest = chars.length - start;
    const stringWidth = width === undefined ? rest : width;
    let endIndex = start + stringWidth;
    if (endIndex > start + rest) endIndex = undefined;
    return chars.slice(start, endIndex).join("");
}
$72a1b7fe1c0aa35a$exports = $72a1b7fe1c0aa35a$var$runes;
$72a1b7fe1c0aa35a$exports.substr = $72a1b7fe1c0aa35a$var$substring;



var $eZVvM = parcelRequire("eZVvM");
// packages/core/primitive/src/primitive.tsx
function $d56aa65487310417$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}


// packages/react/compose-refs/src/composeRefs.tsx

var $eZVvM = parcelRequire("eZVvM");
function $da3ef91b9f88cf6d$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $da3ef91b9f88cf6d$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$da3ef91b9f88cf6d$var$setRef(ref, node));
}
function $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05(...refs) {
    return $eZVvM.useCallback($da3ef91b9f88cf6d$export$43e446d32b3d21af(...refs), refs);
}


// packages/react/context/src/createContext.tsx

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");
function $e6270c096fd5048f$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $eZVvM.createContext(defaultContext);
    const Provider = (props)=>{
        const { children: children, ...context } = props;
        const value = $eZVvM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    };
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName) {
        const context = $eZVvM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [
        Provider,
        useContext2
    ];
}
function $e6270c096fd5048f$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $eZVvM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = (props)=>{
            var _scope_scopeName;
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const value = $eZVvM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        };
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope) {
            var _scope_scopeName;
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const context = $eZVvM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $eZVvM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $eZVvM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $e6270c096fd5048f$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $e6270c096fd5048f$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $eZVvM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}



var $eZVvM = parcelRequire("eZVvM");

// packages/react/primitive/src/Primitive.tsx

var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
// packages/react/slot/src/Slot.tsx

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
var $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $eZVvM.Children.toArray(children);
    const slottable = childrenArray.find($bbe7ec9b0e1df2a2$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($eZVvM.Children.count(newElement) > 1) return $eZVvM.Children.only(null);
                return $eZVvM.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $3pI8R.jsx)($bbe7ec9b0e1df2a2$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $eZVvM.isValidElement(newElement) ? $eZVvM.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $3pI8R.jsx)($bbe7ec9b0e1df2a2$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360.displayName = "Slot";
var $bbe7ec9b0e1df2a2$var$SlotClone = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($eZVvM.isValidElement(children)) {
        const childrenRef = $bbe7ec9b0e1df2a2$var$getElementRef(children);
        return $eZVvM.cloneElement(children, {
            ...$bbe7ec9b0e1df2a2$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $da3ef91b9f88cf6d$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $eZVvM.Children.count(children) > 1 ? $eZVvM.Children.only(null) : null;
});
$bbe7ec9b0e1df2a2$var$SlotClone.displayName = "SlotClone";
var $bbe7ec9b0e1df2a2$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $3pI8R.Fragment), {
        children: children
    });
};
function $bbe7ec9b0e1df2a2$var$isSlottable(child) {
    return $eZVvM.isValidElement(child) && child.type === $bbe7ec9b0e1df2a2$export$d9f1ccf0bdb05d45;
}
function $bbe7ec9b0e1df2a2$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $bbe7ec9b0e1df2a2$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $bbe7ec9b0e1df2a2$export$be92b6f5f03c0fe9 = $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360;



var $3pI8R = parcelRequire("3pI8R");
var $f8aef97de159082a$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $f8aef97de159082a$export$250ffa63cdc0d034 = $f8aef97de159082a$var$NODES.reduce((primitive, node)=>{
    const Node = $eZVvM.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $f8aef97de159082a$export$6d1a0317bde7de7f(target, event) {
    if (target) $e4ZGj.flushSync(()=>target.dispatchEvent(event));
}
var $f8aef97de159082a$export$be92b6f5f03c0fe9 = $f8aef97de159082a$export$250ffa63cdc0d034;



// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $eZVvM = parcelRequire("eZVvM");
function $4f278f864fa95caf$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $eZVvM.useRef(callback);
    $eZVvM.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $eZVvM.useMemo(()=>(...args)=>{
            var _callbackRef_current;
            return (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 ? void 0 : _callbackRef_current.call(callbackRef, ...args);
        }, []);
}


// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $eZVvM = parcelRequire("eZVvM");

function $5821aae492c28aef$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const onEscapeKeyDown = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $eZVvM.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $927c851443b37d6c$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $927c851443b37d6c$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $927c851443b37d6c$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $927c851443b37d6c$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $927c851443b37d6c$var$originalBodyPointerEvents;
var $927c851443b37d6c$var$DismissableLayerContext = $eZVvM.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $927c851443b37d6c$export$177fb62ff3ec1f22 = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _globalThis;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $eZVvM.useContext($927c851443b37d6c$var$DismissableLayerContext);
    const [node, setNode] = $eZVvM.useState(null);
    var _node_ownerDocument;
    const ownerDocument = (_node_ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node_ownerDocument !== void 0 ? _node_ownerDocument : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    const [, force] = $eZVvM.useState({});
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $927c851443b37d6c$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 ? void 0 : onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = $927c851443b37d6c$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 ? void 0 : onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    (0, $5821aae492c28aef$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $eZVvM.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $927c851443b37d6c$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $927c851443b37d6c$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $927c851443b37d6c$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $927c851443b37d6c$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $eZVvM.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($927c851443b37d6c$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($927c851443b37d6c$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$927c851443b37d6c$export$177fb62ff3ec1f22.displayName = $927c851443b37d6c$var$DISMISSABLE_LAYER_NAME;
var $927c851443b37d6c$var$BRANCH_NAME = "DismissableLayerBranch";
var $927c851443b37d6c$export$4d5eb2109db14228 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $eZVvM.useContext($927c851443b37d6c$var$DismissableLayerContext);
    const ref = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $eZVvM.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$927c851443b37d6c$export$4d5eb2109db14228.displayName = $927c851443b37d6c$var$BRANCH_NAME;
function $927c851443b37d6c$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handlePointerDownOutside = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $eZVvM.useRef(false);
    const handleClickRef = $eZVvM.useRef(()=>{});
    $eZVvM.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $927c851443b37d6c$var$handleAndDispatchCustomEvent($927c851443b37d6c$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $927c851443b37d6c$var$useFocusOutside(onFocusOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handleFocusOutside = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $927c851443b37d6c$var$handleAndDispatchCustomEvent($927c851443b37d6c$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $927c851443b37d6c$var$dispatchUpdate() {
    const event = new CustomEvent($927c851443b37d6c$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $927c851443b37d6c$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $f8aef97de159082a$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $927c851443b37d6c$export$be92b6f5f03c0fe9 = $927c851443b37d6c$export$177fb62ff3ec1f22;
var $927c851443b37d6c$export$aecb2ddcb55c95be = $927c851443b37d6c$export$4d5eb2109db14228;



var $eZVvM = parcelRequire("eZVvM");
"use client";
var $8a88dc3631ad332b$var$count = 0;
function $8a88dc3631ad332b$export$ac5b58043b79449b(props) {
    $8a88dc3631ad332b$export$b7ece24a22aeda8c();
    return props.children;
}
function $8a88dc3631ad332b$export$b7ece24a22aeda8c() {
    $eZVvM.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        var _edgeGuards_;
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards_ = edgeGuards[0]) !== null && _edgeGuards_ !== void 0 ? _edgeGuards_ : $8a88dc3631ad332b$var$createFocusGuard());
        var _edgeGuards_1;
        document.body.insertAdjacentElement("beforeend", (_edgeGuards_1 = edgeGuards[1]) !== null && _edgeGuards_1 !== void 0 ? _edgeGuards_1 : $8a88dc3631ad332b$var$createFocusGuard());
        $8a88dc3631ad332b$var$count++;
        return ()=>{
            if ($8a88dc3631ad332b$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $8a88dc3631ad332b$var$count--;
        };
    }, []);
}
function $8a88dc3631ad332b$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
var $8a88dc3631ad332b$export$be92b6f5f03c0fe9 = $8a88dc3631ad332b$export$ac5b58043b79449b;



var $eZVvM = parcelRequire("eZVvM");




var $3pI8R = parcelRequire("3pI8R");
"use client";
var $5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $5fa700d9aec4b79b$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $5fa700d9aec4b79b$var$FOCUS_SCOPE_NAME = "FocusScope";
var $5fa700d9aec4b79b$export$20e40289641fbbb6 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $eZVvM.useState(null);
    const onMountAutoFocus = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $eZVvM.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $eZVvM.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $5fa700d9aec4b79b$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $5fa700d9aec4b79b$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $5fa700d9aec4b79b$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $eZVvM.useEffect(()=>{
        if (container) {
            $5fa700d9aec4b79b$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, $5fa700d9aec4b79b$var$EVENT_OPTIONS);
                container.addEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $5fa700d9aec4b79b$var$focusFirst($5fa700d9aec4b79b$var$removeLinks($5fa700d9aec4b79b$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $5fa700d9aec4b79b$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, $5fa700d9aec4b79b$var$EVENT_OPTIONS);
                    container.addEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $5fa700d9aec4b79b$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    container.removeEventListener($5fa700d9aec4b79b$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $5fa700d9aec4b79b$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $eZVvM.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $5fa700d9aec4b79b$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $5fa700d9aec4b79b$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $5fa700d9aec4b79b$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$5fa700d9aec4b79b$export$20e40289641fbbb6.displayName = $5fa700d9aec4b79b$var$FOCUS_SCOPE_NAME;
function $5fa700d9aec4b79b$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $5fa700d9aec4b79b$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $5fa700d9aec4b79b$var$getTabbableEdges(container) {
    const candidates = $5fa700d9aec4b79b$var$getTabbableCandidates(container);
    const first = $5fa700d9aec4b79b$var$findVisible(candidates, container);
    const last = $5fa700d9aec4b79b$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $5fa700d9aec4b79b$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $5fa700d9aec4b79b$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$5fa700d9aec4b79b$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $5fa700d9aec4b79b$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $5fa700d9aec4b79b$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $5fa700d9aec4b79b$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $5fa700d9aec4b79b$var$isSelectableInput(element) && select) element.select();
    }
}
var $5fa700d9aec4b79b$var$focusScopesStack = $5fa700d9aec4b79b$var$createFocusScopesStack();
function $5fa700d9aec4b79b$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            stack = $5fa700d9aec4b79b$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack_;
            stack = $5fa700d9aec4b79b$var$arrayRemove(stack, focusScope);
            (_stack_ = stack[0]) === null || _stack_ === void 0 ? void 0 : _stack_.resume();
        }
    };
}
function $5fa700d9aec4b79b$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $5fa700d9aec4b79b$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $5fa700d9aec4b79b$export$be92b6f5f03c0fe9 = $5fa700d9aec4b79b$export$20e40289641fbbb6;


// packages/react/id/src/id.tsx

var $eZVvM = parcelRequire("eZVvM");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $eZVvM = parcelRequire("eZVvM");
var $9260723ef1eb7b27$var$_globalThis;
var $9260723ef1eb7b27$export$e5c5a5f917a5871c = Boolean(($9260723ef1eb7b27$var$_globalThis = globalThis) === null || $9260723ef1eb7b27$var$_globalThis === void 0 ? void 0 : $9260723ef1eb7b27$var$_globalThis.document) ? $eZVvM.useLayoutEffect : ()=>{};


var $92fce9891f0372ca$var$useReactId = $eZVvM["useId".toString()] || (()=>void 0);
var $92fce9891f0372ca$var$count = 0;
function $92fce9891f0372ca$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $eZVvM.useState($92fce9891f0372ca$var$useReactId());
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($92fce9891f0372ca$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $e43d3a7503668d03$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $e43d3a7503668d03$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $e43d3a7503668d03$export$803cd8101b6c182b = /*#__PURE__*/ $e43d3a7503668d03$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $e43d3a7503668d03$export$27b07d8a310ed8b5[0], side + "-" + $e43d3a7503668d03$export$27b07d8a310ed8b5[1]), []);
const $e43d3a7503668d03$export$96ec731ed4dcb222 = Math.min;
const $e43d3a7503668d03$export$8960430cfd85939f = Math.max;
const $e43d3a7503668d03$export$2077e0241d6afd3c = Math.round;
const $e43d3a7503668d03$export$a3fe094919f356fd = Math.floor;
const $e43d3a7503668d03$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $e43d3a7503668d03$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $e43d3a7503668d03$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $e43d3a7503668d03$export$7d15b64cf5a3a4c4(start, value, end) {
    return $e43d3a7503668d03$export$8960430cfd85939f(start, $e43d3a7503668d03$export$96ec731ed4dcb222(value, end));
}
function $e43d3a7503668d03$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $e43d3a7503668d03$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $e43d3a7503668d03$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $e43d3a7503668d03$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $e43d3a7503668d03$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $e43d3a7503668d03$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($e43d3a7503668d03$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $e43d3a7503668d03$export$2b57e0052a6d6d4c(placement) {
    return $e43d3a7503668d03$export$8a000a963141ac32($e43d3a7503668d03$export$f28e8f882010718a(placement));
}
function $e43d3a7503668d03$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $e43d3a7503668d03$export$f0989780f32bfcda(placement);
    const alignmentAxis = $e43d3a7503668d03$export$2b57e0052a6d6d4c(placement);
    const length = $e43d3a7503668d03$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $e43d3a7503668d03$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $e43d3a7503668d03$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $e43d3a7503668d03$export$496432a3699e50b1(placement) {
    const oppositePlacement = $e43d3a7503668d03$export$9c5e28bad23365fa(placement);
    return [
        $e43d3a7503668d03$export$2b182c584985588b(placement),
        oppositePlacement,
        $e43d3a7503668d03$export$2b182c584985588b(oppositePlacement)
    ];
}
function $e43d3a7503668d03$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$e43d3a7503668d03$var$oppositeAlignmentMap[alignment]);
}
function $e43d3a7503668d03$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $e43d3a7503668d03$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $e43d3a7503668d03$export$f0989780f32bfcda(placement);
    let list = $e43d3a7503668d03$var$getSideList($e43d3a7503668d03$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($e43d3a7503668d03$export$2b182c584985588b));
    }
    return list;
}
function $e43d3a7503668d03$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$e43d3a7503668d03$var$oppositeSideMap[side]);
}
function $e43d3a7503668d03$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $e43d3a7503668d03$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $e43d3a7503668d03$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $e43d3a7503668d03$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $04abf95d0af710a5$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $e43d3a7503668d03$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $e43d3a7503668d03$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $04abf95d0af710a5$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $04abf95d0af710a5$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $04abf95d0af710a5$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $04abf95d0af710a5$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $04abf95d0af710a5$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $e43d3a7503668d03$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $e43d3a7503668d03$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $04abf95d0af710a5$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $e43d3a7503668d03$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $04abf95d0af710a5$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $e43d3a7503668d03$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $e43d3a7503668d03$export$803cd8101b6c182b) ? $04abf95d0af710a5$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $e43d3a7503668d03$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $e43d3a7503668d03$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $e43d3a7503668d03$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $04abf95d0af710a5$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $e43d3a7503668d03$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $e43d3a7503668d03$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $e43d3a7503668d03$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $e43d3a7503668d03$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $04abf95d0af710a5$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $04abf95d0af710a5$var$isAnySideFullyClipped(overflow) {
    return (0, $e43d3a7503668d03$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $04abf95d0af710a5$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $04abf95d0af710a5$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $04abf95d0af710a5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $04abf95d0af710a5$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $04abf95d0af710a5$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $04abf95d0af710a5$var$getBoundingRect(rects) {
    const minX = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $04abf95d0af710a5$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $e43d3a7503668d03$export$ee05aea0aeecbad4)($04abf95d0af710a5$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $04abf95d0af710a5$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $04abf95d0af710a5$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)($04abf95d0af710a5$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $e43d3a7503668d03$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $e43d3a7503668d03$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $04abf95d0af710a5$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $04abf95d0af710a5$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $04abf95d0af710a5$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $04abf95d0af710a5$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)((0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $e43d3a7503668d03$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $e43d3a7503668d03$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $04abf95d0af710a5$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $e43d3a7503668d03$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $04abf95d0af710a5$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $e43d3a7503668d03$export$fef61f332f2c0afc)(options, state);
            const overflow = await $04abf95d0af710a5$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $e43d3a7503668d03$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $e43d3a7503668d03$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $e43d3a7503668d03$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $e43d3a7503668d03$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $cf420724ebafb241$var$hasWindow() {
    return typeof window !== "undefined";
}
function $cf420724ebafb241$export$651544f548703224(node) {
    if ($cf420724ebafb241$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $cf420724ebafb241$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $cf420724ebafb241$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($cf420724ebafb241$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $cf420724ebafb241$export$8ee0fc9ee280b4ee(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).Node;
}
function $cf420724ebafb241$export$45a5e7f76e0caa8d(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).Element;
}
function $cf420724ebafb241$export$1b3bfaa9684536aa(value) {
    if (!$cf420724ebafb241$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).HTMLElement;
}
function $cf420724ebafb241$export$af51f0f06c0f328a(value) {
    if (!$cf420724ebafb241$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $cf420724ebafb241$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $cf420724ebafb241$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $cf420724ebafb241$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $cf420724ebafb241$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($cf420724ebafb241$export$651544f548703224(element));
}
function $cf420724ebafb241$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $cf420724ebafb241$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $cf420724ebafb241$export$78551043582a6a98();
    const css = $cf420724ebafb241$export$45a5e7f76e0caa8d(elementOrCss) ? $cf420724ebafb241$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $cf420724ebafb241$export$940d8225183e1404(element) {
    let currentNode = $cf420724ebafb241$export$4e12058fc4d51d56(element);
    while($cf420724ebafb241$export$1b3bfaa9684536aa(currentNode) && !$cf420724ebafb241$export$d1162fb0b6d4cd51(currentNode)){
        if ($cf420724ebafb241$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($cf420724ebafb241$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $cf420724ebafb241$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $cf420724ebafb241$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $cf420724ebafb241$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($cf420724ebafb241$export$651544f548703224(node));
}
function $cf420724ebafb241$export$3735103072e4a80(element) {
    return $cf420724ebafb241$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $cf420724ebafb241$export$dc8fc79fa2800137(element) {
    if ($cf420724ebafb241$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $cf420724ebafb241$export$4e12058fc4d51d56(node) {
    if ($cf420724ebafb241$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $cf420724ebafb241$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $cf420724ebafb241$export$e495491855dc5418(node);
    return $cf420724ebafb241$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $cf420724ebafb241$export$7cd01a57c8ca906c(node) {
    const parentNode = $cf420724ebafb241$export$4e12058fc4d51d56(node);
    if ($cf420724ebafb241$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($cf420724ebafb241$export$1b3bfaa9684536aa(parentNode) && $cf420724ebafb241$export$989e911fa9af580a(parentNode)) return parentNode;
    return $cf420724ebafb241$export$7cd01a57c8ca906c(parentNode);
}
function $cf420724ebafb241$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $cf420724ebafb241$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $cf420724ebafb241$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $cf420724ebafb241$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $cf420724ebafb241$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $cf420724ebafb241$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $cf420724ebafb241$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $cf420724ebafb241$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $6502644ced543179$var$getCssDimensions(element) {
    const css = (0, $cf420724ebafb241$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $6502644ced543179$var$unwrapElement(element) {
    return !(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $6502644ced543179$var$getScale(element) {
    const domElement = $6502644ced543179$var$unwrapElement(element);
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(domElement)) return (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $6502644ced543179$var$getCssDimensions(domElement);
    let x = ($ ? (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $e43d3a7503668d03$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $6502644ced543179$var$noOffsets = /*#__PURE__*/ (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
function $6502644ced543179$var$getVisualOffsets(element) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    if (!(0, $cf420724ebafb241$export$78551043582a6a98)() || !win.visualViewport) return $6502644ced543179$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $6502644ced543179$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $6502644ced543179$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $6502644ced543179$var$unwrapElement(element);
    let scale = (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(offsetParent)) scale = $6502644ced543179$var$getScale(offsetParent);
        } else scale = $6502644ced543179$var$getScale(element);
    }
    const visualOffsets = $6502644ced543179$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $6502644ced543179$var$getVisualOffsets(domElement) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $cf420724ebafb241$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $cf420724ebafb241$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $6502644ced543179$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $cf420724ebafb241$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $cf420724ebafb241$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $6502644ced543179$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $6502644ced543179$var$getBoundingClientRect((0, $cf420724ebafb241$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $6502644ced543179$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $6502644ced543179$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $6502644ced543179$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $cf420724ebafb241$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $cf420724ebafb241$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const offsets = (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cf420724ebafb241$export$651544f548703224)(offsetParent) !== "body" || (0, $cf420724ebafb241$export$989e911fa9af580a)(documentElement)) scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $6502644ced543179$var$getBoundingClientRect(offsetParent);
            scale = $6502644ced543179$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6502644ced543179$var$getHTMLOffset(documentElement, scroll, true) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $6502644ced543179$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $6502644ced543179$var$getDocumentRect(element) {
    const html = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    const scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $6502644ced543179$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $cf420724ebafb241$export$3735103072e4a80)(body).direction === "rtl") x += (0, $e43d3a7503668d03$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6502644ced543179$var$getViewportRect(element, strategy) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    const html = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $cf420724ebafb241$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $6502644ced543179$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $6502644ced543179$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element) ? $6502644ced543179$var$getScale(element) : (0, $e43d3a7503668d03$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $6502644ced543179$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $6502644ced543179$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $6502644ced543179$var$getDocumentRect((0, $cf420724ebafb241$export$e495491855dc5418)(element));
    else if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $6502644ced543179$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $6502644ced543179$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $e43d3a7503668d03$export$ee05aea0aeecbad4)(rect);
}
function $6502644ced543179$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(parentNode) || (0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $cf420724ebafb241$export$3735103072e4a80)(parentNode).position === "fixed" || $6502644ced543179$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $6502644ced543179$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $cf420724ebafb241$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(el) && (0, $cf420724ebafb241$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(currentNode) && !(0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $cf420724ebafb241$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $cf420724ebafb241$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $cf420724ebafb241$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $6502644ced543179$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $6502644ced543179$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $cf420724ebafb241$export$89e651af02346cd4)(element) ? [] : $6502644ced543179$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $6502644ced543179$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $e43d3a7503668d03$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $e43d3a7503668d03$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $6502644ced543179$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $6502644ced543179$var$getDimensions(element) {
    const { width: width, height: height } = $6502644ced543179$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $6502644ced543179$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $cf420724ebafb241$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $cf420724ebafb241$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $6502644ced543179$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cf420724ebafb241$export$651544f548703224)(offsetParent) !== "body" || (0, $cf420724ebafb241$export$989e911fa9af580a)(documentElement)) scroll = (0, $cf420724ebafb241$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $6502644ced543179$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $6502644ced543179$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $6502644ced543179$var$getHTMLOffset(documentElement, scroll) : (0, $e43d3a7503668d03$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $6502644ced543179$var$isStaticPositioned(element) {
    return (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "static";
}
function $6502644ced543179$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element) || (0, $cf420724ebafb241$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $cf420724ebafb241$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $6502644ced543179$var$getOffsetParent(element, polyfill) {
    const win = (0, $cf420724ebafb241$export$38b2d434cce3ea22)(element);
    if ((0, $cf420724ebafb241$export$89e651af02346cd4)(element)) return win;
    if (!(0, $cf420724ebafb241$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $cf420724ebafb241$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$6502644ced543179$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $cf420724ebafb241$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $6502644ced543179$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $cf420724ebafb241$export$71535ffaa902797f)(offsetParent) && $6502644ced543179$var$isStaticPositioned(offsetParent))offsetParent = $6502644ced543179$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $cf420724ebafb241$export$d1162fb0b6d4cd51)(offsetParent) && $6502644ced543179$var$isStaticPositioned(offsetParent) && !(0, $cf420724ebafb241$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $cf420724ebafb241$export$940d8225183e1404)(element) || win;
}
const $6502644ced543179$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $6502644ced543179$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $6502644ced543179$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $6502644ced543179$var$isRTL(element) {
    return (0, $cf420724ebafb241$export$3735103072e4a80)(element).direction === "rtl";
}
const $6502644ced543179$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $6502644ced543179$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $cf420724ebafb241$export$e495491855dc5418,
    getClippingRect: $6502644ced543179$var$getClippingRect,
    getOffsetParent: $6502644ced543179$var$getOffsetParent,
    getElementRects: $6502644ced543179$var$getElementRects,
    getClientRects: $6502644ced543179$var$getClientRects,
    getDimensions: $6502644ced543179$var$getDimensions,
    getScale: $6502644ced543179$var$getScale,
    isElement: $cf420724ebafb241$export$45a5e7f76e0caa8d,
    isRTL: $6502644ced543179$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $6502644ced543179$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $cf420724ebafb241$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(top);
        const insetRight = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $e43d3a7503668d03$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $e43d3a7503668d03$export$8960430cfd85939f)(0, (0, $e43d3a7503668d03$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $6502644ced543179$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $6502644ced543179$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $cf420724ebafb241$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $cf420724ebafb241$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $6502644ced543179$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $6502644ced543179$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $6502644ced543179$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $6502644ced543179$export$37b6bde19b108ecc = (0, $04abf95d0af710a5$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $6502644ced543179$export$cc800923e997bb8 = (0, $04abf95d0af710a5$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $6502644ced543179$export$91fb6ecbd551914 = (0, $04abf95d0af710a5$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $6502644ced543179$export$fba63a578e423eb = (0, $04abf95d0af710a5$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $6502644ced543179$export$8a83211c878a3f1f = (0, $04abf95d0af710a5$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $6502644ced543179$export$346677f925de839c = (0, $04abf95d0af710a5$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $6502644ced543179$export$fe8985bb6374093c = (0, $04abf95d0af710a5$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $6502644ced543179$export$f2120bbfa5450bd2 = (0, $04abf95d0af710a5$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $6502644ced543179$export$18c8ad048e32c7d5 = (0, $04abf95d0af710a5$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $6502644ced543179$export$7bf07e38f3dc4b69 = (0, $04abf95d0af710a5$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $6502644ced543179$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $6502644ced543179$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $04abf95d0af710a5$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
var $9912140e987fac9e$var$index = typeof document !== "undefined" ? (0, $eZVvM.useLayoutEffect) : (0, $eZVvM.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $9912140e987fac9e$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$9912140e987fac9e$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$9912140e987fac9e$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $9912140e987fac9e$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $9912140e987fac9e$var$roundByDPR(element, value) {
    const dpr = $9912140e987fac9e$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $9912140e987fac9e$var$useLatestRef(value) {
    const ref = $eZVvM.useRef(value);
    $9912140e987fac9e$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $9912140e987fac9e$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $eZVvM.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $eZVvM.useState(middleware);
    if (!$9912140e987fac9e$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $eZVvM.useState(null);
    const [_floating, _setFloating] = $eZVvM.useState(null);
    const setReference = $eZVvM.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $eZVvM.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $eZVvM.useRef(null);
    const floatingRef = $eZVvM.useRef(null);
    const dataRef = $eZVvM.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $9912140e987fac9e$var$useLatestRef(whileElementsMounted);
    const platformRef = $9912140e987fac9e$var$useLatestRef(platform);
    const openRef = $9912140e987fac9e$var$useLatestRef(open);
    const update = $eZVvM.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $6502644ced543179$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$9912140e987fac9e$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $e4ZGj.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $9912140e987fac9e$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $eZVvM.useRef(false);
    $9912140e987fac9e$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $9912140e987fac9e$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $eZVvM.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $eZVvM.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $eZVvM.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $9912140e987fac9e$var$roundByDPR(elements.floating, data.x);
        const y = $9912140e987fac9e$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$9912140e987fac9e$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $eZVvM.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9912140e987fac9e$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $6502644ced543179$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $6502644ced543179$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9912140e987fac9e$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $6502644ced543179$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9912140e987fac9e$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $6502644ced543179$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9912140e987fac9e$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $6502644ced543179$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9912140e987fac9e$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $6502644ced543179$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9912140e987fac9e$export$346677f925de839c = (options, deps)=>({
        ...(0, $6502644ced543179$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9912140e987fac9e$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $6502644ced543179$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9912140e987fac9e$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $6502644ced543179$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9912140e987fac9e$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $6502644ced543179$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9912140e987fac9e$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$9912140e987fac9e$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


// packages/react/arrow/src/Arrow.tsx

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
var $4d5ebdb6606821b3$var$NAME = "Arrow";
var $4d5ebdb6606821b3$export$21b07c8f274aebd5 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $3pI8R.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$4d5ebdb6606821b3$export$21b07c8f274aebd5.displayName = $4d5ebdb6606821b3$var$NAME;
var $4d5ebdb6606821b3$export$be92b6f5f03c0fe9 = $4d5ebdb6606821b3$export$21b07c8f274aebd5;



// packages/react/context/src/createContext.tsx

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");
function $a3d7715a4bb999f3$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $eZVvM.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $eZVvM.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $eZVvM.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $a3d7715a4bb999f3$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $eZVvM.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const value = $eZVvM.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $3pI8R.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = $eZVvM.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $eZVvM.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $eZVvM.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $a3d7715a4bb999f3$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $a3d7715a4bb999f3$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $eZVvM.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}





// packages/react/use-size/src/useSize.tsx

var $eZVvM = parcelRequire("eZVvM");

function $416ecf6d578e0a29$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $eZVvM.useState(void 0);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $1d6744c3033b8e6e$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $1d6744c3033b8e6e$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $1d6744c3033b8e6e$var$POPPER_NAME = "Popper";
var [$1d6744c3033b8e6e$var$createPopperContext, $1d6744c3033b8e6e$export$722aac194ae923] = (0, $a3d7715a4bb999f3$export$50c7b4e9d9f19c1)($1d6744c3033b8e6e$var$POPPER_NAME);
var [$1d6744c3033b8e6e$var$PopperProvider, $1d6744c3033b8e6e$var$usePopperContext] = $1d6744c3033b8e6e$var$createPopperContext($1d6744c3033b8e6e$var$POPPER_NAME);
var $1d6744c3033b8e6e$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $eZVvM.useState(null);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$1d6744c3033b8e6e$export$badac9ada3a0bdf9.displayName = $1d6744c3033b8e6e$var$POPPER_NAME;
var $1d6744c3033b8e6e$var$ANCHOR_NAME = "PopperAnchor";
var $1d6744c3033b8e6e$export$ecd4e1ccab6ed6d = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $1d6744c3033b8e6e$var$usePopperContext($1d6744c3033b8e6e$var$ANCHOR_NAME, __scopePopper);
    const ref = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $eZVvM.useEffect(()=>{
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$1d6744c3033b8e6e$export$ecd4e1ccab6ed6d.displayName = $1d6744c3033b8e6e$var$ANCHOR_NAME;
var $1d6744c3033b8e6e$var$CONTENT_NAME = "PopperContent";
var [$1d6744c3033b8e6e$var$PopperContentProvider, $1d6744c3033b8e6e$var$useContentContext] = $1d6744c3033b8e6e$var$createPopperContext($1d6744c3033b8e6e$var$CONTENT_NAME);
var $1d6744c3033b8e6e$export$bc4ae5855d3c4fc = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2, _middlewareData_transformOrigin, _middlewareData_transformOrigin1, _middlewareData_hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $1d6744c3033b8e6e$var$usePopperContext($1d6744c3033b8e6e$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $eZVvM.useState(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $eZVvM.useState(null);
    const arrowSize = (0, $416ecf6d578e0a29$export$1ab7ae714698c4b8)(arrow);
    var _arrowSize_width;
    const arrowWidth = (_arrowSize_width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize_width !== void 0 ? _arrowSize_width : 0;
    var _arrowSize_height;
    const arrowHeight = (_arrowSize_height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize_height !== void 0 ? _arrowSize_height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($1d6744c3033b8e6e$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $9912140e987fac9e$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $6502644ced543179$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $9912140e987fac9e$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $9912140e987fac9e$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $9912140e987fac9e$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $9912140e987fac9e$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $9912140e987fac9e$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $9912140e987fac9e$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $1d6744c3033b8e6e$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $9912140e987fac9e$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onPlaced);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 ? void 0 : handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.x;
    const arrowY = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.y;
    const cannotCenterArrow = ((_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = $eZVvM.useState();
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData_transformOrigin = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin === void 0 ? void 0 : _middlewareData_transformOrigin.x,
                (_middlewareData_transformOrigin1 = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin1 === void 0 ? void 0 : _middlewareData_transformOrigin1.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.referenceHidden) && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$1d6744c3033b8e6e$export$bc4ae5855d3c4fc.displayName = $1d6744c3033b8e6e$var$CONTENT_NAME;
var $1d6744c3033b8e6e$var$ARROW_NAME = "PopperArrow";
var $1d6744c3033b8e6e$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $1d6744c3033b8e6e$export$79d62cd4e10a3fd0 = $eZVvM.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $1d6744c3033b8e6e$var$useContentContext($1d6744c3033b8e6e$var$ARROW_NAME, __scopePopper);
    const baseSide = $1d6744c3033b8e6e$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $3pI8R.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($4d5ebdb6606821b3$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$1d6744c3033b8e6e$export$79d62cd4e10a3fd0.displayName = $1d6744c3033b8e6e$var$ARROW_NAME;
function $1d6744c3033b8e6e$var$isNotNull(value) {
    return value !== null;
}
var $1d6744c3033b8e6e$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var _middlewareData_arrow_x;
            const arrowXCenter = ((_middlewareData_arrow_x = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.x) !== null && _middlewareData_arrow_x !== void 0 ? _middlewareData_arrow_x : 0) + arrowWidth / 2;
            var _middlewareData_arrow_y;
            const arrowYCenter = ((_middlewareData_arrow_y = (_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.y) !== null && _middlewareData_arrow_y !== void 0 ? _middlewareData_arrow_y : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $1d6744c3033b8e6e$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $1d6744c3033b8e6e$export$be92b6f5f03c0fe9 = $1d6744c3033b8e6e$export$badac9ada3a0bdf9;
var $1d6744c3033b8e6e$export$b688253958b8dfe7 = $1d6744c3033b8e6e$export$ecd4e1ccab6ed6d;
var $1d6744c3033b8e6e$export$7c6e2c02157bb7d2 = $1d6744c3033b8e6e$export$bc4ae5855d3c4fc;
var $1d6744c3033b8e6e$export$21b07c8f274aebd5 = $1d6744c3033b8e6e$export$79d62cd4e10a3fd0;



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a76ffa8483cdf241$var$PORTAL_NAME = "Portal";
var $a76ffa8483cdf241$export$602eac185826482c = $eZVvM.forwardRef((props, forwardedRef)=>{
    var _globalThis_document, _globalThis;
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $eZVvM.useState(false);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body);
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).createPortal(/* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$a76ffa8483cdf241$export$602eac185826482c.displayName = $a76ffa8483cdf241$var$PORTAL_NAME;
var $a76ffa8483cdf241$export$be92b6f5f03c0fe9 = $a76ffa8483cdf241$export$602eac185826482c;



var $eZVvM = parcelRequire("eZVvM");


"use client";
function $cf4ccb043a5a8762$var$useStateMachine(initialState, machine) {
    return $eZVvM.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $cf4ccb043a5a8762$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $cf4ccb043a5a8762$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $eZVvM.Children.only(children);
    const ref = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(presence.ref, $cf4ccb043a5a8762$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $eZVvM.cloneElement(child, {
        ref: ref
    }) : null;
};
$cf4ccb043a5a8762$export$99c2b779aa4e8b8b.displayName = "Presence";
function $cf4ccb043a5a8762$var$usePresence(present) {
    const [node, setNode] = $eZVvM.useState();
    const stylesRef = $eZVvM.useRef({});
    const prevPresentRef = $eZVvM.useRef(present);
    const prevAnimationNameRef = $eZVvM.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $cf4ccb043a5a8762$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $eZVvM.useEffect(()=>{
        const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $9260723ef1eb7b27$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            var _node_ownerDocument_defaultView;
            const ownerWindow = (_node_ownerDocument_defaultView = node.ownerDocument.defaultView) !== null && _node_ownerDocument_defaultView !== void 0 ? _node_ownerDocument_defaultView : window;
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $cf4ccb043a5a8762$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $eZVvM.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $cf4ccb043a5a8762$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
function $cf4ccb043a5a8762$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




// packages/react/use-controllable-state/src/useControllableState.tsx

var $eZVvM = parcelRequire("eZVvM");

function $15fe1a9c6448dfe8$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $15fe1a9c6448dfe8$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onChange);
    const setValue = $eZVvM.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $15fe1a9c6448dfe8$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $eZVvM.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $eZVvM.useRef(value);
    const handleChange = (0, $4f278f864fa95caf$export$25bec8c6f54ee79a)(onChange);
    $eZVvM.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}


var $aa2805cf61430e06$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $aa2805cf61430e06$var$counterMap = new WeakMap();
var $aa2805cf61430e06$var$uncontrolledNodes = new WeakMap();
var $aa2805cf61430e06$var$markerMap = {};
var $aa2805cf61430e06$var$lockCount = 0;
var $aa2805cf61430e06$var$unwrapHost = function(node) {
    return node && (node.host || $aa2805cf61430e06$var$unwrapHost(node.parentNode));
};
var $aa2805cf61430e06$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $aa2805cf61430e06$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $aa2805cf61430e06$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $aa2805cf61430e06$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$aa2805cf61430e06$var$markerMap[markerName]) $aa2805cf61430e06$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $aa2805cf61430e06$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($aa2805cf61430e06$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $aa2805cf61430e06$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $aa2805cf61430e06$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $aa2805cf61430e06$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $aa2805cf61430e06$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $aa2805cf61430e06$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$aa2805cf61430e06$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $aa2805cf61430e06$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $aa2805cf61430e06$var$lockCount--;
        if (!$aa2805cf61430e06$var$lockCount) {
            // clear
            $aa2805cf61430e06$var$counterMap = new WeakMap();
            $aa2805cf61430e06$var$counterMap = new WeakMap();
            $aa2805cf61430e06$var$uncontrolledNodes = new WeakMap();
            $aa2805cf61430e06$var$markerMap = {};
        }
    };
};
var $aa2805cf61430e06$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $aa2805cf61430e06$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $aa2805cf61430e06$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $aa2805cf61430e06$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $aa2805cf61430e06$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $aa2805cf61430e06$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $aa2805cf61430e06$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $aa2805cf61430e06$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($aa2805cf61430e06$export$cc95fea82d705fca() ? $aa2805cf61430e06$export$59151cc8db999a24 : $aa2805cf61430e06$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");

var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");
var $36980812ffa15784$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $36980812ffa15784$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $36980812ffa15784$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $36980812ffa15784$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $eZVvM = parcelRequire("eZVvM");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $713dd8676ce4eb23$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $eZVvM = parcelRequire("eZVvM");
function $fa63e2d41de72700$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $eZVvM.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $2b5d694d1654c02a$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $eZVvM.useLayoutEffect : $eZVvM.useEffect;
var $2b5d694d1654c02a$var$currentValues = new WeakMap();
function $2b5d694d1654c02a$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $fa63e2d41de72700$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $2b5d694d1654c02a$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $2b5d694d1654c02a$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $713dd8676ce4eb23$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $2b5d694d1654c02a$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



var $iUWBZ = parcelRequire("iUWBZ");
function $8ff640b44f4f5bb9$var$ItoI(a) {
    return a;
}
function $8ff640b44f4f5bb9$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $8ff640b44f4f5bb9$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $8ff640b44f4f5bb9$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $8ff640b44f4f5bb9$var$ItoI;
    return $8ff640b44f4f5bb9$var$innerCreateMedium(defaults, middleware);
}
function $8ff640b44f4f5bb9$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $8ff640b44f4f5bb9$var$innerCreateMedium(null);
    medium.options = (0, $iUWBZ.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $3c81697596d3d7c5$export$e27363444bedfeac = (0, $8ff640b44f4f5bb9$export$e13ec7dd7a14088d)();


var $2df8ab0d18f28fcc$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $2df8ab0d18f28fcc$export$22940b497e769dee = $eZVvM.forwardRef(function(props, parentRef) {
    var ref = $eZVvM.useRef(null);
    var _a = $eZVvM.useState({
        onScrollCapture: $2df8ab0d18f28fcc$var$nothing,
        onWheelCapture: $2df8ab0d18f28fcc$var$nothing,
        onTouchMoveCapture: $2df8ab0d18f28fcc$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $iUWBZ.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2b5d694d1654c02a$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $iUWBZ.__assign)((0, $iUWBZ.__assign)({}, rest), callbacks);
    return $eZVvM.createElement($eZVvM.Fragment, null, enabled && $eZVvM.createElement(SideCar, {
        sideCar: (0, $3c81697596d3d7c5$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $eZVvM.cloneElement($eZVvM.Children.only(children), (0, $iUWBZ.__assign)((0, $iUWBZ.__assign)({}, containerProps), {
        ref: containerRef
    })) : $eZVvM.createElement(Container, (0, $iUWBZ.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$2df8ab0d18f28fcc$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$2df8ab0d18f28fcc$export$22940b497e769dee.classNames = {
    fullWidth: (0, $36980812ffa15784$export$898e37bbd2a0ae4e),
    zeroRight: (0, $36980812ffa15784$export$1da7500147d4bc3)
};



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");
var $2a109d0481166e06$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $iUWBZ.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $eZVvM.createElement(Target, (0, $iUWBZ.__assign)({}, rest));
};
$2a109d0481166e06$var$SideCar.isSideCarExport = true;
function $2a109d0481166e06$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $2a109d0481166e06$var$SideCar;
}



var $iUWBZ = parcelRequire("iUWBZ");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
var $97cad7e43f6615ca$var$currentNonce;
var $97cad7e43f6615ca$export$c5f670b24c0ae95a = function(nonce) {
    $97cad7e43f6615ca$var$currentNonce = nonce;
};
var $97cad7e43f6615ca$export$2b85b721e524d74b = function() {
    if ($97cad7e43f6615ca$var$currentNonce) return $97cad7e43f6615ca$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $dc297644307a4751$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $97cad7e43f6615ca$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $dc297644307a4751$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $dc297644307a4751$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $dc297644307a4751$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $dc297644307a4751$var$makeStyleTag()) {
                    $dc297644307a4751$var$injectStyles(stylesheet, style);
                    $dc297644307a4751$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $88eb0de48099155e$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $dc297644307a4751$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $eZVvM.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $1943c50733f82794$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $88eb0de48099155e$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $e81a80eceffa9fbb$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $e81a80eceffa9fbb$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $e81a80eceffa9fbb$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $e81a80eceffa9fbb$var$parse(left),
        $e81a80eceffa9fbb$var$parse(top),
        $e81a80eceffa9fbb$var$parse(right)
    ];
};
var $e81a80eceffa9fbb$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $e81a80eceffa9fbb$export$efed13b5d0ca3386;
    var offsets = $e81a80eceffa9fbb$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $545793c299e71b41$var$Style = (0, $1943c50733f82794$export$c1248ee86ba532c8)();
var $545793c299e71b41$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $545793c299e71b41$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $36980812ffa15784$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($545793c299e71b41$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " .").concat((0, $36980812ffa15784$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " .").concat((0, $36980812ffa15784$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($545793c299e71b41$export$65254d5f26cb9564, "] {\n    ").concat((0, $36980812ffa15784$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $545793c299e71b41$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($545793c299e71b41$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $545793c299e71b41$export$a1939b1f9f9b02dc = function() {
    $eZVvM.useEffect(function() {
        document.body.setAttribute($545793c299e71b41$export$65254d5f26cb9564, ($545793c299e71b41$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $545793c299e71b41$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($545793c299e71b41$export$65254d5f26cb9564);
            else document.body.setAttribute($545793c299e71b41$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $545793c299e71b41$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $545793c299e71b41$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $eZVvM.useMemo(function() {
        return (0, $e81a80eceffa9fbb$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $eZVvM.createElement($545793c299e71b41$var$Style, {
        styles: $545793c299e71b41$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $b5f667d2968c2a1d$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $b5f667d2968c2a1d$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $b5f667d2968c2a1d$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $b5f667d2968c2a1d$var$options, $b5f667d2968c2a1d$var$options);
    // @ts-ignore
    window.removeEventListener("test", $b5f667d2968c2a1d$var$options, $b5f667d2968c2a1d$var$options);
} catch (err) {
    $b5f667d2968c2a1d$var$passiveSupported = false;
}
var $b5f667d2968c2a1d$export$10a6e88623fa9454 = $b5f667d2968c2a1d$var$passiveSupported ? {
    passive: false
} : false;


var $5374cafeb6c79dfa$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $5374cafeb6c79dfa$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$5374cafeb6c79dfa$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $5374cafeb6c79dfa$var$elementCouldBeVScrolled = function(node) {
    return $5374cafeb6c79dfa$var$elementCanBeScrolled(node, "overflowY");
};
var $5374cafeb6c79dfa$var$elementCouldBeHScrolled = function(node) {
    return $5374cafeb6c79dfa$var$elementCanBeScrolled(node, "overflowX");
};
var $5374cafeb6c79dfa$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $5374cafeb6c79dfa$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $5374cafeb6c79dfa$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $5374cafeb6c79dfa$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $5374cafeb6c79dfa$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $5374cafeb6c79dfa$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $5374cafeb6c79dfa$var$elementCouldBeVScrolled(node) : $5374cafeb6c79dfa$var$elementCouldBeHScrolled(node);
};
var $5374cafeb6c79dfa$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $5374cafeb6c79dfa$var$getVScrollVariables(node) : $5374cafeb6c79dfa$var$getHScrollVariables(node);
};
var $5374cafeb6c79dfa$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $5374cafeb6c79dfa$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $5374cafeb6c79dfa$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $5374cafeb6c79dfa$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($5374cafeb6c79dfa$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $40252af699c089cd$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $40252af699c089cd$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $40252af699c089cd$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $40252af699c089cd$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $40252af699c089cd$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $40252af699c089cd$var$idCounter = 0;
var $40252af699c089cd$var$lockStack = [];
function $40252af699c089cd$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $eZVvM.useRef([]);
    var touchStartRef = $eZVvM.useRef([
        0,
        0
    ]);
    var activeAxis = $eZVvM.useRef();
    var id = $eZVvM.useState($40252af699c089cd$var$idCounter++)[0];
    var Style = $eZVvM.useState((0, $1943c50733f82794$export$c1248ee86ba532c8))[0];
    var lastProps = $eZVvM.useRef(props);
    $eZVvM.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $eZVvM.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $iUWBZ.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($40252af699c089cd$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $eZVvM.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2 || event.type === "wheel" && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $40252af699c089cd$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $5374cafeb6c79dfa$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $5374cafeb6c79dfa$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $5374cafeb6c79dfa$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $eZVvM.useCallback(function(_event) {
        var event = _event;
        if (!$40252af699c089cd$var$lockStack.length || $40252af699c089cd$var$lockStack[$40252af699c089cd$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $40252af699c089cd$export$39efaa2ca254a28d(event) : $40252af699c089cd$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $40252af699c089cd$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($40252af699c089cd$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $eZVvM.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $40252af699c089cd$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $eZVvM.useCallback(function(event) {
        touchStartRef.current = $40252af699c089cd$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $eZVvM.useCallback(function(event) {
        shouldCancel(event.type, $40252af699c089cd$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $eZVvM.useCallback(function(event) {
        shouldCancel(event.type, $40252af699c089cd$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $eZVvM.useEffect(function() {
        $40252af699c089cd$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        return function() {
            $40252af699c089cd$var$lockStack = $40252af699c089cd$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $b5f667d2968c2a1d$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $eZVvM.createElement($eZVvM.Fragment, null, inert ? $eZVvM.createElement(Style, {
        styles: $40252af699c089cd$var$generateStyle(id)
    }) : null, removeScrollBar ? $eZVvM.createElement((0, $545793c299e71b41$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $40252af699c089cd$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $248e13baa32989a0$export$2e2bcd8739ae039 = (0, $2a109d0481166e06$export$6cacc8fb0a9b94ce)((0, $3c81697596d3d7c5$export$e27363444bedfeac), (0, $40252af699c089cd$export$a09dbff87b5da2d));


var $a6d74da6d6d2ca17$var$ReactRemoveScroll = $eZVvM.forwardRef(function(props, ref) {
    return $eZVvM.createElement((0, $2df8ab0d18f28fcc$export$22940b497e769dee), (0, $iUWBZ.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $248e13baa32989a0$export$2e2bcd8739ae039)
    }));
});
$a6d74da6d6d2ca17$var$ReactRemoveScroll.classNames = (0, $2df8ab0d18f28fcc$export$22940b497e769dee).classNames;
var $a6d74da6d6d2ca17$export$2e2bcd8739ae039 = $a6d74da6d6d2ca17$var$ReactRemoveScroll;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d30790ce46109715$var$POPOVER_NAME = "Popover";
var [$d30790ce46109715$var$createPopoverContext, $d30790ce46109715$export$c8393c9e73286932] = (0, $e6270c096fd5048f$export$50c7b4e9d9f19c1)($d30790ce46109715$var$POPOVER_NAME, [
    (0, $1d6744c3033b8e6e$export$722aac194ae923)
]);
var $d30790ce46109715$var$usePopperScope = (0, $1d6744c3033b8e6e$export$722aac194ae923)();
var [$d30790ce46109715$var$PopoverProvider, $d30790ce46109715$var$usePopoverContext] = $d30790ce46109715$var$createPopoverContext($d30790ce46109715$var$POPOVER_NAME);
var $d30790ce46109715$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const triggerRef = $eZVvM.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $eZVvM.useState(false);
    const [open = false, setOpen] = (0, $15fe1a9c6448dfe8$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $92fce9891f0372ca$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $eZVvM.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $eZVvM.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $eZVvM.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$d30790ce46109715$export$5b6b19405a83ff9d.displayName = $d30790ce46109715$var$POPOVER_NAME;
var $d30790ce46109715$var$ANCHOR_NAME = "PopoverAnchor";
var $d30790ce46109715$export$96e5381f42521a79 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $eZVvM.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$d30790ce46109715$export$96e5381f42521a79.displayName = $d30790ce46109715$var$ANCHOR_NAME;
var $d30790ce46109715$var$TRIGGER_NAME = "PopoverTrigger";
var $d30790ce46109715$export$7dacb05d26466c3 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $d30790ce46109715$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$d30790ce46109715$export$7dacb05d26466c3.displayName = $d30790ce46109715$var$TRIGGER_NAME;
var $d30790ce46109715$var$PORTAL_NAME = "PopoverPortal";
var [$d30790ce46109715$var$PortalProvider, $d30790ce46109715$var$usePortalContext] = $d30790ce46109715$var$createPopoverContext($d30790ce46109715$var$PORTAL_NAME, {
    forceMount: void 0
});
var $d30790ce46109715$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $cf4ccb043a5a8762$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $a76ffa8483cdf241$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$d30790ce46109715$export$dd679ffb4362d2d4.displayName = $d30790ce46109715$var$PORTAL_NAME;
var $d30790ce46109715$var$CONTENT_NAME = "PopoverContent";
var $d30790ce46109715$export$d7e1f420b25549ff = $eZVvM.forwardRef((props, forwardedRef)=>{
    const portalContext = $d30790ce46109715$var$usePortalContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $cf4ccb043a5a8762$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$d30790ce46109715$export$d7e1f420b25549ff.displayName = $d30790ce46109715$var$CONTENT_NAME;
var $d30790ce46109715$var$PopoverContentModal = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $eZVvM.useRef(null);
    const composedRefs = (0, $da3ef91b9f88cf6d$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $aa2805cf61430e06$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $a6d74da6d6d2ca17$export$2e2bcd8739ae039), {
        as: (0, $bbe7ec9b0e1df2a2$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                var _context_triggerRef_current;
                event.preventDefault();
                if (!isRightClickOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            }),
            onPointerDownOutside: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $d30790ce46109715$var$PopoverContentNonModal = $eZVvM.forwardRef((props, forwardedRef)=>{
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $eZVvM.useRef(false);
    const hasPointerDownOutsideRef = $eZVvM.useRef(false);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($d30790ce46109715$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $d30790ce46109715$var$PopoverContentImpl = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CONTENT_NAME, __scopePopover);
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    (0, $8a88dc3631ad332b$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $5fa700d9aec4b79b$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $927c851443b37d6c$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$7c6e2c02157bb7d2, {
                "data-state": $d30790ce46109715$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $d30790ce46109715$var$CLOSE_NAME = "PopoverClose";
var $d30790ce46109715$export$d6ac43ebaa40d53e = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $d30790ce46109715$var$usePopoverContext($d30790ce46109715$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $f8aef97de159082a$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $d56aa65487310417$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$d30790ce46109715$export$d6ac43ebaa40d53e.displayName = $d30790ce46109715$var$CLOSE_NAME;
var $d30790ce46109715$var$ARROW_NAME = "PopoverArrow";
var $d30790ce46109715$export$3152841115e061b2 = $eZVvM.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $d30790ce46109715$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $3pI8R.jsx)($1d6744c3033b8e6e$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$d30790ce46109715$export$3152841115e061b2.displayName = $d30790ce46109715$var$ARROW_NAME;
function $d30790ce46109715$var$getState(open) {
    return open ? "open" : "closed";
}
var $d30790ce46109715$export$be92b6f5f03c0fe9 = $d30790ce46109715$export$5b6b19405a83ff9d;
var $d30790ce46109715$export$b688253958b8dfe7 = $d30790ce46109715$export$96e5381f42521a79;
var $d30790ce46109715$export$41fb9f06171c75f4 = $d30790ce46109715$export$7dacb05d26466c3;
var $d30790ce46109715$export$602eac185826482c = $d30790ce46109715$export$dd679ffb4362d2d4;
var $d30790ce46109715$export$7c6e2c02157bb7d2 = $d30790ce46109715$export$d7e1f420b25549ff;
var $d30790ce46109715$export$f39c2d165cd861fe = $d30790ce46109715$export$d6ac43ebaa40d53e;
var $d30790ce46109715$export$21b07c8f274aebd5 = $d30790ce46109715$export$3152841115e061b2;


function $de9b795dde6747fa$export$1ac4a28ba936c3b0({ children: children }) {
    const services = (0, $4fc09928452de42f$export$1f39bff4033c2336)();
    const store = (0, $4fc09928452de42f$export$f51a9068ac82ea43)({
        injectServices: services
    });
    return $eZVvM.createElement((0, $e2346a360d18792d$export$2881499e37b75b9a), {
        store: store
    }, children);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $de9b795dde6747fa$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
const $de9b795dde6747fa$var$useAppDispatch = (0, $e2346a360d18792d$export$8ad76b76a4c905f8).withTypes();
const $de9b795dde6747fa$var$useAppSelector = (0, $e2346a360d18792d$export$2105062e25df4afe).withTypes();
const $de9b795dde6747fa$export$5da49f1f3cbe3742 = $eZVvM.forwardRef((_a, ref)=>{
    var { muted: muted, mirror: mirror = false, stream: stream, onVideoResize: onVideoResize } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "muted",
        "mirror",
        "stream",
        "onVideoResize"
    ]);
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const currentSpeakerId = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$356fc73355033f1b));
    const videoEl = $eZVvM.useRef(null);
    const audioEl = $eZVvM.useRef(null);
    $eZVvM.useImperativeHandle(ref, ()=>{
        return Object.assign(videoEl.current, {
            captureAspectRatio: ()=>{
                if (!videoEl.current) return null;
                const h = videoEl.current.videoHeight;
                const w = videoEl.current.videoWidth;
                if (w && h && w + h > 20) return w / h;
                return null;
            }
        });
    });
    $eZVvM.useEffect(()=>{
        if (!videoEl.current) return;
        const resizeObserver = new ResizeObserver((0, $4fc09928452de42f$export$61fc7d43ac8f84b0)(()=>{
            if (videoEl.current && (stream === null || stream === void 0 ? void 0 : stream.id)) {
                const width = videoEl.current.clientWidth;
                const height = videoEl.current.clientHeight;
                dispatch((0, $4fc09928452de42f$export$8e38e4b6fee98ae8)({
                    streamId: stream.id,
                    width: width,
                    height: height
                }));
                if (onVideoResize) onVideoResize({
                    width: width,
                    height: height,
                    stream: stream
                });
            }
        }, {
            delay: 1000,
            edges: true
        }));
        resizeObserver.observe(videoEl.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        stream
    ]);
    $eZVvM.useEffect(()=>{
        if (!videoEl.current) return;
        if (videoEl.current.srcObject !== stream) videoEl.current.srcObject = stream;
        if (videoEl.current.muted !== muted) videoEl.current.muted = Boolean(muted);
    }, [
        muted,
        stream,
        videoEl
    ]);
    $eZVvM.useEffect(()=>{
        if (!audioEl.current || muted || !stream || !currentSpeakerId) return;
        if (audioEl.current.srcObject !== stream) audioEl.current.srcObject = stream;
        if (audioEl.current.setSinkId) audioEl.current.setSinkId(currentSpeakerId);
    }, [
        stream,
        audioEl,
        currentSpeakerId,
        muted
    ]);
    return $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement("video", Object.assign({
        ref: videoEl,
        autoPlay: true,
        playsInline: true
    }, rest, {
        style: Object.assign({
            transform: mirror ? "scaleX(-1)" : "none",
            width: "100%",
            height: "100%"
        }, rest.style)
    })), $eZVvM.createElement("audio", {
        ref: audioEl,
        autoPlay: true,
        playsInline: true
    }));
});
$de9b795dde6747fa$export$5da49f1f3cbe3742.displayName = "VideoView";
const $de9b795dde6747fa$var$selectRoomConnectionState = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)((0, $4fc09928452de42f$export$e67c42ad18139770), (0, $4fc09928452de42f$export$e8f9fec2fd38be7b), (0, $4fc09928452de42f$export$b8c8b2aa1134778b), (0, $4fc09928452de42f$export$e9c4b1bf93e7c80d), (0, $4fc09928452de42f$export$f97faf20840c4b0c), (0, $4fc09928452de42f$export$5d9bde7516ef4510), (0, $4fc09928452de42f$export$22f0decfe3c779cc), (0, $4fc09928452de42f$export$90baeb59ec142cd0), (0, $4fc09928452de42f$export$2a890977d27b6c75), (0, $4fc09928452de42f$export$d73c0f55214a186a), (0, $4fc09928452de42f$export$622ce0f62fa78bbc), (chatMessages, cloudRecording, localParticipant, localMediaStream, remoteParticipants, screenshares, connectionStatus, streaming, waitingParticipants, notificationsEmitter, spotlightedClientViews)=>{
    const state = {
        chatMessages: chatMessages,
        cloudRecording: cloudRecording.isRecording ? {
            status: "recording"
        } : undefined,
        connectionStatus: connectionStatus,
        events: notificationsEmitter,
        liveStream: streaming.isStreaming ? {
            status: "streaming",
            startedAt: streaming.startedAt
        } : undefined,
        localScreenshareStatus: localParticipant.isScreenSharing ? "active" : undefined,
        localParticipant: Object.assign(Object.assign({}, localParticipant), {
            stream: localMediaStream
        }),
        remoteParticipants: remoteParticipants,
        screenshares: screenshares,
        waitingParticipants: waitingParticipants,
        spotlightedParticipants: spotlightedClientViews
    };
    return state;
});
const $de9b795dde6747fa$var$browserSdkVersion = "3.9.5";
const $de9b795dde6747fa$var$defaultRoomConnectionOptions = {
    localMediaOptions: {
        audio: true,
        video: true
    }
};
function $de9b795dde6747fa$export$e7be2adb7d898233(roomUrl, roomConnectionOptions = $de9b795dde6747fa$var$defaultRoomConnectionOptions) {
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const roomConnectionState = $de9b795dde6747fa$var$useAppSelector($de9b795dde6747fa$var$selectRoomConnectionState);
    const roomConfig = $eZVvM.useMemo(()=>{
        const url = new URL(roomUrl);
        const searchParams = new URLSearchParams(url.search);
        const roomKey = roomConnectionOptions.roomKey || searchParams.get("roomKey");
        return {
            displayName: roomConnectionOptions.displayName || "Guest",
            localMediaOptions: roomConnectionOptions.localMedia ? undefined : roomConnectionOptions.localMediaOptions,
            roomKey: roomKey,
            roomUrl: roomUrl,
            userAgent: `browser-sdk:${$de9b795dde6747fa$var$browserSdkVersion}`,
            externalId: roomConnectionOptions.externalId || null
        };
    }, [
        roomUrl,
        roomConnectionOptions
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            dispatch((0, $4fc09928452de42f$export$d4d0f76450fb6374)());
        };
    }, []);
    const sendChatMessage = $eZVvM.useCallback((text)=>dispatch((0, $4fc09928452de42f$export$24e3bf930d312b2b)({
            text: text
        })), [
        dispatch
    ]);
    const knock = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$76a4467872ffe125)()), [
        dispatch
    ]);
    const setDisplayName = $eZVvM.useCallback((displayName)=>dispatch((0, $4fc09928452de42f$export$9708f9509a207de0)({
            displayName: displayName
        })), [
        dispatch
    ]);
    const toggleCamera = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$93cdb5d3b5880a52)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleMicrophone = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$11a7008b2ab330c2)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleLowDataMode = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$f8ccf9677d12adec)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleRaiseHand = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$5ae150f2ac8c6cf7)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const askToSpeak = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$d0f9ccaaa3a15b4c)({
            clientIds: [
                participantId
            ],
            enable: true
        })), [
        dispatch
    ]);
    const askToTurnOnCamera = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$f7fc15880c03e2a3)({
            clientIds: [
                participantId
            ],
            enable: true
        })), [
        dispatch
    ]);
    const acceptWaitingParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$1a5b93a56a313cfe)({
            participantId: participantId
        })), [
        dispatch
    ]);
    const rejectWaitingParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$dde035bd3d0904ac)({
            participantId: participantId
        })), [
        dispatch
    ]);
    const startCloudRecording = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$8568c037c56c4692)()), [
        dispatch
    ]);
    const startScreenshare = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$ad4f97fa7081697c)()), [
        dispatch
    ]);
    const stopCloudRecording = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$579ffd5d4359613e)()), [
        dispatch
    ]);
    const stopScreenshare = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$a42cf8a339c4d2f7)()), [
        dispatch
    ]);
    const joinRoom = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$ca0cd7d9bebf6bc8)(roomConfig)), [
        dispatch
    ]);
    const leaveRoom = $eZVvM.useCallback(()=>dispatch((0, $4fc09928452de42f$export$d4d0f76450fb6374)()), [
        dispatch
    ]);
    const lockRoom = $eZVvM.useCallback((locked)=>dispatch((0, $4fc09928452de42f$export$9eb5fcf87b4704f2)({
            locked: locked
        })), [
        dispatch
    ]);
    const muteParticipants = $eZVvM.useCallback((participantIds)=>dispatch((0, $4fc09928452de42f$export$d0f9ccaaa3a15b4c)({
            clientIds: participantIds,
            enable: false
        })), [
        dispatch
    ]);
    const turnOffParticipantCameras = $eZVvM.useCallback((participantIds)=>dispatch((0, $4fc09928452de42f$export$f7fc15880c03e2a3)({
            clientIds: participantIds,
            enable: false
        })), [
        dispatch
    ]);
    const spotlightParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$4bf19d94733cc82e)({
            id: participantId
        })), [
        dispatch
    ]);
    const removeSpotlight = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$65b4309b6edd4ad1)({
            id: participantId
        })), [
        dispatch
    ]);
    const kickParticipant = $eZVvM.useCallback((participantId)=>dispatch((0, $4fc09928452de42f$export$d5359451ea4b2b4a)({
            clientId: participantId
        })), [
        dispatch
    ]);
    const endMeeting = $eZVvM.useCallback((stayBehind)=>dispatch((0, $4fc09928452de42f$export$50d90cb8a8eda648)({
            stayBehind: stayBehind
        })), [
        dispatch
    ]);
    const { events: events } = roomConnectionState, state = $de9b795dde6747fa$var$__rest(roomConnectionState, [
        "events"
    ]);
    return {
        state: state,
        events: events,
        actions: {
            toggleLowDataMode: toggleLowDataMode,
            toggleRaiseHand: toggleRaiseHand,
            askToSpeak: askToSpeak,
            askToTurnOnCamera: askToTurnOnCamera,
            acceptWaitingParticipant: acceptWaitingParticipant,
            knock: knock,
            joinRoom: joinRoom,
            leaveRoom: leaveRoom,
            lockRoom: lockRoom,
            muteParticipants: muteParticipants,
            turnOffParticipantCameras: turnOffParticipantCameras,
            kickParticipant: kickParticipant,
            endMeeting: endMeeting,
            rejectWaitingParticipant: rejectWaitingParticipant,
            sendChatMessage: sendChatMessage,
            setDisplayName: setDisplayName,
            startCloudRecording: startCloudRecording,
            startScreenshare: startScreenshare,
            stopCloudRecording: stopCloudRecording,
            stopScreenshare: stopScreenshare,
            toggleCamera: toggleCamera,
            toggleMicrophone: toggleMicrophone,
            spotlightParticipant: spotlightParticipant,
            removeSpotlight: removeSpotlight
        }
    };
}
const $de9b795dde6747fa$var$selectLocalMediaState = (0, $f3a2896bcea9aa5e$export$595d22ed68ca2841)((0, $4fc09928452de42f$export$68025622922ffa26), (0, $4fc09928452de42f$export$434a4c2926dbcbc8), (0, $4fc09928452de42f$export$9b07214a345a0c2b), (0, $4fc09928452de42f$export$15cb5bc234aa0b53), (0, $4fc09928452de42f$export$356fc73355033f1b), (0, $4fc09928452de42f$export$53fdac895dbb6618), (0, $4fc09928452de42f$export$6dd72f0a0b587d15), (0, $4fc09928452de42f$export$5353cfedea9c4a68), (0, $4fc09928452de42f$export$e9c4b1bf93e7c80d), (0, $4fc09928452de42f$export$6dc516caa6efdffc), (0, $4fc09928452de42f$export$3622b5408789e593), (0, $4fc09928452de42f$export$d743da980c7b249a), (0, $4fc09928452de42f$export$c86c916bf575750b), (cameraDeviceError, cameraDevices, currentCameraDeviceId, currentMicrophoneDeviceId, currentSpeakerDeviceId, isSettingCameraDevice, isSettingMicrophoneDevice, isStarting, localStream, microphoneDeviceError, microphoneDevices, speakerDevices, startError)=>{
    const state = {
        cameraDeviceError: cameraDeviceError,
        cameraDevices: cameraDevices,
        currentCameraDeviceId: currentCameraDeviceId,
        currentMicrophoneDeviceId: currentMicrophoneDeviceId,
        currentSpeakerDeviceId: currentSpeakerDeviceId,
        isSettingCameraDevice: isSettingCameraDevice,
        isSettingMicrophoneDevice: isSettingMicrophoneDevice,
        isStarting: isStarting,
        localStream: localStream,
        microphoneDeviceError: microphoneDeviceError,
        microphoneDevices: microphoneDevices,
        speakerDevices: speakerDevices,
        startError: startError
    };
    return state;
});
function $de9b795dde6747fa$export$4139b14dad9cc31b(optionsOrStream = {
    audio: true,
    video: true
}) {
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const localMediaState = $de9b795dde6747fa$var$useAppSelector($de9b795dde6747fa$var$selectLocalMediaState);
    $eZVvM.useEffect(()=>{
        dispatch((0, $4fc09928452de42f$export$eb927cdec6bfaecd)(optionsOrStream));
        return ()=>{
            dispatch((0, $4fc09928452de42f$export$85e2dd05688d27d9)());
        };
    }, []);
    const setCameraDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$ab12f9f2846e3448)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const setMicrophoneDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$2e1fc2200098f950)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const setSpeakerDevice = $eZVvM.useCallback((deviceId)=>dispatch((0, $4fc09928452de42f$export$1176f68d1d548ad3)({
            deviceId: deviceId
        })), [
        dispatch
    ]);
    const toggleCamera = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$93cdb5d3b5880a52)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleMicrophone = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$11a7008b2ab330c2)({
            enabled: enabled
        })), [
        dispatch
    ]);
    const toggleLowDataMode = $eZVvM.useCallback((enabled)=>dispatch((0, $4fc09928452de42f$export$f8ccf9677d12adec)({
            enabled: enabled
        })), [
        dispatch
    ]);
    return {
        state: localMediaState,
        actions: {
            setCameraDevice: setCameraDevice,
            setMicrophoneDevice: setMicrophoneDevice,
            setSpeakerDevice: setSpeakerDevice,
            toggleCameraEnabled: toggleCamera,
            toggleMicrophoneEnabled: toggleMicrophone,
            toggleLowDataModeEnabled: toggleLowDataMode
        }
    };
}
const $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1 = 420;
var $de9b795dde6747fa$var$layoutConstants = {
    MIN_WINDOW_HEIGHT: 320,
    MIN_WINDOW_WIDTH: 320,
    DESKTOP_BREAKPOINT: 1025,
    TABLET_BREAKPOINT: 750,
    PHONE_BREAKPOINT: 500,
    TOP_TOOLBAR_HEIGHT: 56,
    BOTTOM_TOOLBAR_HEIGHT: 82,
    SIDEBAR_WIDTH: 375,
    VIDEO_CONTROLS_MIN_WIDTH: $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1,
    ROOM_FOOTER_MIN_WIDTH: 180 + $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH$1,
    FLOATING_VIDEO_CONTROLS_BOTTOM_MARGIN: 20,
    WATERMARK_BAR_HEIGHT: 32,
    BREAKOUT_STAGE_BACKDROP_HEADER_HEIGHT: 28,
    BREAKOUT_STAGE_BACKDROP_FOOTER_HEIGHT: 56,
    SUBGRID_EMPTY_STAGE_MAX_WIDTH: 800,
    GROUPS_CELL_MARGIN: 8,
    GROUPS_CELL_PADDING: 12,
    GROUPS_CELL_NAV_HEIGHT: 56,
    GROUPS_CELL_AVATAR_WRAPPER_BOTTOM_MARGIN: 8,
    GROUPS_CELL_AVATAR_GRID_GAP: 8,
    GROUPS_CELL_MIN_WIDTH: 360,
    GROUPS_CELL_MAX_WIDTH: 600,
    GROUPS_ROW_HEIGHT: 72,
    GROUPS_ROW_GAP: 1,
    FOLDABLE_SCREEN_STAGE_PADDING: 8
};
function $de9b795dde6747fa$var$makeOrigin({ top: top = 0, left: left = 0 } = {}) {
    return {
        top: top,
        left: left
    };
}
function $de9b795dde6747fa$var$makeBounds({ width: width = 0, height: height = 0 } = {}) {
    return {
        width: Math.max(width, 0),
        height: Math.max(height, 0)
    };
}
function $de9b795dde6747fa$var$makeFrame({ top: top = 0, left: left = 0, width: width = 0, height: height = 0 } = {}) {
    return {
        bounds: $de9b795dde6747fa$var$makeBounds({
            width: width,
            height: height
        }),
        origin: $de9b795dde6747fa$var$makeOrigin({
            top: top,
            left: left
        })
    };
}
function $de9b795dde6747fa$var$makeBox({ top: top = 0, left: left = 0, bottom: bottom = 0, right: right = 0 } = {}) {
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right
    };
}
function $de9b795dde6747fa$var$hasBounds(bounds) {
    if (!bounds) return false;
    return !(bounds.width <= 0 || bounds.height <= 0);
}
function $de9b795dde6747fa$var$insetBounds({ bounds: bounds, fromBounds: fromBounds }) {
    return {
        width: Math.max(fromBounds.width - bounds.width, 0),
        height: Math.max(fromBounds.height - bounds.height, 0)
    };
}
function $de9b795dde6747fa$var$fitToBounds(aspectRatio, containerSize) {
    const { width: width, height: height } = containerSize;
    const contentHeight = height;
    const contentWidth = contentHeight * aspectRatio;
    const scale = Math.min(width / contentWidth, height / contentHeight);
    const adjustedWidth = contentWidth * scale;
    const adjustedHeight = contentHeight * scale;
    return {
        width: adjustedWidth,
        height: adjustedHeight
    };
}
const $de9b795dde6747fa$var$cellContentArea = ({ width: width, height: height, rows: rows, cols: cols, aspectRatio: aspectRatio })=>{
    const bounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
        width: width / cols,
        height: height / rows
    });
    return Math.round(bounds.width * bounds.height);
};
const $de9b795dde6747fa$var$getWeightedSplitCount = ({ vertical: vertical, width: width, height: height, count: count, aspectRatio: aspectRatio })=>{
    const choices = [
        1,
        2,
        3
    ].map((rowCols)=>$de9b795dde6747fa$var$cellContentArea({
            width: width,
            height: height,
            rows: vertical ? Math.ceil(count / rowCols) : rowCols,
            cols: vertical ? rowCols : Math.ceil(count / rowCols),
            aspectRatio: aspectRatio
        }));
    const closest = Math.max(...choices);
    const splits = choices.indexOf(closest) + 1;
    return {
        splits: splits,
        weight: closest
    };
};
const $de9b795dde6747fa$var$getGridSplits = ({ width: width, height: height, count: count, aspectRatio: aspectRatio })=>{
    const verticalPick = $de9b795dde6747fa$var$getWeightedSplitCount({
        vertical: true,
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    const horizontalPick = $de9b795dde6747fa$var$getWeightedSplitCount({
        vertical: false,
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    if (verticalPick.weight > horizontalPick.weight) return {
        splits: verticalPick.splits,
        vertical: true
    };
    return {
        splits: horizontalPick.splits,
        vertical: false
    };
};
function $de9b795dde6747fa$var$getGridSizeForCount({ count: count, width: width, height: height, aspectRatio: aspectRatio }) {
    if (count <= 1) return {
        rows: 1,
        cols: 1
    };
    const { splits: splits, vertical: vertical } = $de9b795dde6747fa$var$getGridSplits({
        width: width,
        height: height,
        count: count,
        aspectRatio: aspectRatio
    });
    if (vertical) return {
        rows: Math.ceil(count / splits),
        cols: splits
    };
    return {
        rows: splits,
        cols: Math.ceil(count / splits)
    };
}
function $de9b795dde6747fa$var$VideoCell(_a) {
    var { aspectRatio: aspectRatio, children: children, className: className, height: height, style: style, width: width, withRoundedCorners: withRoundedCorners = false, withShadow: withShadow = true } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "aspectRatio",
        "children",
        "className",
        "height",
        "style",
        "width",
        "withRoundedCorners",
        "withShadow"
    ]);
    let contentWidth = width;
    let contentHeight = height;
    let leftOffset = 0;
    let topOffset = 0;
    if (aspectRatio) {
        ({ width: contentWidth, height: contentHeight } = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: width,
            height: height
        }));
        leftOffset = (width - contentWidth) / 2;
        topOffset = (height - contentHeight) / 2;
    }
    const contentStyle = Object.assign({
        width: `${Math.round(contentWidth)}px`,
        height: `${Math.round(contentHeight)}px`
    }, leftOffset || topOffset ? {
        transform: `translate3d(${Math.round(leftOffset)}px, ${Math.round(topOffset)}px, 0)`
    } : {});
    return $eZVvM.createElement("div", {
        className: className,
        style: Object.assign({
            position: "absolute",
            top: 0,
            left: 0
        }, style)
    }, $eZVvM.createElement("div", Object.assign({
        style: contentStyle
    }, rest), $eZVvM.cloneElement(children, {
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        withRoundedCorners: withRoundedCorners,
        withShadow: withShadow
    })));
}
function $de9b795dde6747fa$var$generateStylesFromFrame({ origin: origin, bounds: bounds }) {
    return {
        top: Math.round(origin.top),
        left: Math.round(origin.left),
        height: Math.round(bounds.height),
        width: Math.round(bounds.width)
    };
}
function $de9b795dde6747fa$var$renderVideoCell({ cell: cell, child: child, clientId: clientId, style: style = {}, withRoundedCorners: withRoundedCorners = false, withShadow: withShadow = false }) {
    const isHidden = !$de9b795dde6747fa$var$hasBounds(cell.bounds);
    return $eZVvM.createElement($de9b795dde6747fa$var$VideoCell, {
        width: cell.bounds.width,
        height: cell.bounds.height,
        aspectRatio: cell.aspectRatio,
        style: isHidden ? {
            width: 0,
            height: 0
        } : style,
        withRoundedCorners: withRoundedCorners,
        withShadow: withShadow,
        key: clientId
    }, child);
}
function $de9b795dde6747fa$var$renderSubgridVideoCells({ content: content, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    const cells = stageLayout.subgrid.cells;
    return content.map((child, index)=>{
        var _a, _b, _c, _d;
        const cell = cells[index];
        const style = {
            height: Math.round(cell.bounds.height),
            width: Math.round(cell.bounds.width),
            transform: ""
        };
        const origin = {
            top: stageLayout.subgrid.origin.top + cell.origin.top,
            left: stageLayout.subgrid.origin.left + cell.origin.left
        };
        style.transform = `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`;
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const leftPaddings = ((_c = cell.paddings) === null || _c === void 0 ? void 0 : _c.left) || 0;
        const rightPaddings = ((_d = cell.paddings) === null || _d === void 0 ? void 0 : _d.right) || 0;
        const childWithProps = $eZVvM.cloneElement(child, {
            avatarSize: cell.bounds.width - leftPaddings - rightPaddings,
            canZoom: false,
            cellPaddings: cell.paddings,
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: false,
            key: clientId || `subgrid-${index}`,
            style: style
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `subgrid-${index}`,
            style: style,
            withRoundedCorners: withRoundedCorners,
            withShadow: withShadow
        });
    });
}
function $de9b795dde6747fa$var$renderPresentationGridVideoCells({ content: content, isConstrained: isConstrained, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    var _a;
    const cells = ((_a = stageLayout.presentationGrid) === null || _a === void 0 ? void 0 : _a.cells) || [];
    return content.map((child, index)=>{
        var _a, _b;
        if (!stageLayout.presentationGrid) return null;
        const cell = cells[index];
        const origin = {
            top: stageLayout.presentationGrid.origin.top + stageLayout.presentationGrid.paddings.top + cell.origin.top,
            left: stageLayout.presentationGrid.origin.left + stageLayout.presentationGrid.paddings.left + cell.origin.left
        };
        const style = {
            width: Math.round(cell.bounds.width),
            height: Math.round(cell.bounds.height),
            transform: `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`
        };
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const childWithProps = $eZVvM.cloneElement(child, {
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: !!isConstrained && !(child === null || child === void 0 ? void 0 : child.props.participant.isPresentation),
            canZoom: !!isConstrained,
            key: clientId || `presentation-${index}`
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `presentation-${index}`,
            style: style,
            withRoundedCorners: withRoundedCorners,
            withShadow: withShadow
        });
    });
}
function $de9b795dde6747fa$var$renderGridVideoCells({ content: content, isConstrained: isConstrained, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners, withShadow: withShadow }) {
    var _a;
    const cells = ((_a = stageLayout.videoGrid) === null || _a === void 0 ? void 0 : _a.cells) || [];
    const gridVideoCells = content.map((child, index)=>{
        var _a, _b;
        if (!stageLayout.videoGrid) return null;
        const cell = cells[index];
        const origin = {
            top: stageLayout.videoGrid.origin.top + stageLayout.videoGrid.paddings.top + cell.origin.top,
            left: stageLayout.videoGrid.origin.left + stageLayout.videoGrid.paddings.left + cell.origin.left
        };
        const style = {
            width: Math.round(cell.bounds.width),
            height: Math.round(cell.bounds.height),
            transform: `translate3d(${Math.round(origin.left)}px, ${Math.round(origin.top)}px, 0)`
        };
        const clientId = (_b = (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.participant) === null || _b === void 0 ? void 0 : _b.id;
        const childWithProps = $eZVvM.cloneElement(child, {
            isSmallCell: cell.isSmallCell,
            isZoomedByDefault: !!isConstrained && !(child === null || child === void 0 ? void 0 : child.props.participant.isPresentation),
            canZoom: !!isConstrained,
            key: clientId || `video-${index}`
        });
        return $de9b795dde6747fa$var$renderVideoCell({
            cell: cell,
            child: childWithProps,
            clientId: clientId || `video-${index}`,
            withRoundedCorners: withRoundedCorners,
            style: style,
            withShadow: withShadow
        });
    });
    return gridVideoCells;
}
function $de9b795dde6747fa$var$renderFloatingVideoCell({ content: content, containerFrame: containerFrame, stageLayout: stageLayout, withRoundedCorners: withRoundedCorners }) {
    var _a;
    if (!stageLayout.floatingContent) return null;
    const cell = stageLayout.floatingContent;
    const origin = {
        top: cell.origin.top,
        left: cell.origin.left
    };
    const style = {
        width: Math.round(cell.bounds.width),
        height: Math.round(cell.bounds.height),
        transform: `translate3d(${Math.round(containerFrame.origin.left + origin.left)}px, ${Math.round(containerFrame.origin.top + origin.top)}px, 0)`,
        position: "fixed",
        top: cell.bounds.height / 2,
        left: 0,
        zIndex: 40
    };
    const clientId = ((_a = content.props.client) === null || _a === void 0 ? void 0 : _a.id) || "floating";
    const childWithProps = $eZVvM.cloneElement(content, {
        isSmallCell: cell.isSmallCell,
        isZoomedByDefault: false,
        canZoom: false,
        key: clientId,
        isDraggable: false
    });
    return $de9b795dde6747fa$var$renderVideoCell({
        cell: cell,
        child: childWithProps,
        clientId: clientId,
        style: style,
        withRoundedCorners: withRoundedCorners,
        withShadow: false
    });
}
function $de9b795dde6747fa$var$VideoStageLayout({ containerFrame: containerFrame, debug: debug = false, featureRoundedCornersOff: featureRoundedCornersOff = false, floatingContent: floatingContent, gridContent: gridContent = [], isConstrained: isConstrained = false, layoutOverflowBackdropFrame: layoutOverflowBackdropFrame = $de9b795dde6747fa$var$makeFrame(), layoutVideoStage: stageLayout, presentationGridContent: presentationGridContent = [], subgridContent: subgridContent = [] }) {
    const withRoundedCorners = !featureRoundedCornersOff && !isConstrained;
    const cells = [];
    if (gridContent.length) cells.push(...$de9b795dde6747fa$var$renderGridVideoCells({
        content: gridContent,
        isConstrained: isConstrained,
        stageLayout: stageLayout,
        withRoundedCorners: withRoundedCorners,
        withShadow: !isConstrained
    }));
    if (presentationGridContent.length) cells.push(...$de9b795dde6747fa$var$renderPresentationGridVideoCells({
        content: presentationGridContent,
        isConstrained: isConstrained,
        stageLayout: stageLayout,
        withRoundedCorners: withRoundedCorners,
        withShadow: !isConstrained
    }));
    if (floatingContent) cells.push($de9b795dde6747fa$var$renderFloatingVideoCell({
        content: floatingContent,
        containerFrame: containerFrame,
        stageLayout: stageLayout,
        withRoundedCorners: !featureRoundedCornersOff
    }));
    if (subgridContent.length) cells.push(...$de9b795dde6747fa$var$renderSubgridVideoCells({
        content: subgridContent,
        stageLayout: stageLayout,
        withRoundedCorners: !featureRoundedCornersOff,
        withShadow: true
    }));
    return $eZVvM.createElement("div", {
        key: "video-stage-layout",
        style: {
            width: "100%",
            height: "100%",
            position: "relative"
        }
    }, $de9b795dde6747fa$var$hasBounds(layoutOverflowBackdropFrame.bounds) && $eZVvM.createElement("div", {
        style: $de9b795dde6747fa$var$generateStylesFromFrame(layoutOverflowBackdropFrame)
    }), cells, debug && $eZVvM.createElement($eZVvM.Fragment, null));
}
const $de9b795dde6747fa$var$WIDE_AR = 16 / 9;
const $de9b795dde6747fa$var$NORMAL_AR = 4 / 3;
const $de9b795dde6747fa$var$clamp = ({ value: value, min: min, max: max })=>Math.min(Math.max(value, min), max);
function $de9b795dde6747fa$var$hasDuplicates(...array) {
    return new Set(array).size !== array.length;
}
function $de9b795dde6747fa$var$findMostCommon(arr) {
    return arr.sort((a, b)=>arr.filter((v)=>v === a).length - arr.filter((v)=>v === b).length).pop();
}
function $de9b795dde6747fa$var$pickCellAspectRatio({ choices: choices = [] }) {
    const minAr = Math.min(...choices);
    const maxAr = Math.max(...choices);
    let chosenAr = null;
    if (minAr === maxAr) chosenAr = minAr;
    else {
        const dominantAr = $de9b795dde6747fa$var$hasDuplicates(choices) ? $de9b795dde6747fa$var$findMostCommon(choices) : maxAr;
        chosenAr = $de9b795dde6747fa$var$clamp({
            value: dominantAr || maxAr,
            min: $de9b795dde6747fa$var$NORMAL_AR,
            max: $de9b795dde6747fa$var$WIDE_AR
        });
    }
    return {
        minAr: minAr,
        maxAr: maxAr,
        chosenAr: chosenAr
    };
}
function $de9b795dde6747fa$var$getCenterPadding$1({ rows: rows, cols: cols, cellWidth: cellWidth, index: index, cellCount: cellCount, gridGap: gridGap }) {
    const max = rows * cols;
    const leftOver = max - cellCount;
    if (!leftOver) return 0;
    const lastIndex = max - leftOver - 1;
    const firstIndex = lastIndex - (cols - leftOver) + 1;
    const lastRowPadding = leftOver * cellWidth / 2 + gridGap;
    return index >= firstIndex && index <= lastIndex ? lastRowPadding : 0;
}
function $de9b795dde6747fa$var$getCellBounds({ width: width, height: height, rows: rows, cols: cols, gridGap: gridGap, aspectRatio: aspectRatio }) {
    const cellWidth = (width - (cols - 1) * gridGap) / cols;
    const cellHeight = (height - (rows - 1) * gridGap) / rows;
    const ar = cellWidth / cellHeight;
    let horizontalCorrection = 0;
    let verticalCorrection = 0;
    if (aspectRatio < ar) horizontalCorrection = cellWidth - cellHeight * aspectRatio;
    else if (aspectRatio > ar) verticalCorrection = cellHeight - cellWidth / aspectRatio;
    const totalHorizontalCorrection = horizontalCorrection * cols;
    const totalVerticalCorrection = verticalCorrection * rows;
    return {
        cellWidth: cellWidth - horizontalCorrection,
        cellHeight: cellHeight - verticalCorrection,
        extraHorizontalPadding: totalHorizontalCorrection / 2,
        extraVerticalPadding: totalVerticalCorrection / 2
    };
}
function $de9b795dde6747fa$var$calculateLayout$3({ width: width, height: height, cellCount: cellCount, gridGap: gridGap, cellAspectRatios: cellAspectRatios = [
    $de9b795dde6747fa$var$NORMAL_AR
], paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    if (!cellCount) return {
        cellCount: cellCount,
        cellHeight: 0,
        cellWidth: 0,
        cols: 0,
        rows: 0,
        extraHorizontalPadding: 0,
        extraVerticalPadding: 0,
        gridGap: gridGap,
        paddings: paddings
    };
    const contentWidth = width - (paddings.left + paddings.right);
    const contentHeight = height - (paddings.top + paddings.bottom);
    const cellAspectRatioTuple = $de9b795dde6747fa$var$pickCellAspectRatio({
        choices: cellAspectRatios
    });
    let cellAspectRatio = cellAspectRatioTuple.chosenAr;
    const { rows: rows, cols: cols } = $de9b795dde6747fa$var$getGridSizeForCount({
        count: cellCount,
        width: contentWidth,
        height: contentHeight,
        aspectRatio: cellAspectRatio
    });
    if (rows === 1) cellAspectRatio = $de9b795dde6747fa$var$clamp({
        value: contentWidth / cols / contentHeight,
        min: Math.min(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr),
        max: Math.max(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr)
    });
    else if (cols === 1) cellAspectRatio = $de9b795dde6747fa$var$clamp({
        value: contentWidth / (contentHeight / rows),
        min: Math.min(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr),
        max: Math.max(cellAspectRatioTuple.chosenAr, cellAspectRatioTuple.maxAr)
    });
    const { cellWidth: cellWidth, cellHeight: cellHeight, extraHorizontalPadding: extraHorizontalPadding, extraVerticalPadding: extraVerticalPadding } = $de9b795dde6747fa$var$getCellBounds({
        width: contentWidth,
        height: contentHeight,
        rows: rows,
        cols: cols,
        gridGap: gridGap,
        aspectRatio: cellAspectRatio
    });
    return {
        cellCount: cellCount,
        cellHeight: cellHeight,
        cellWidth: cellWidth,
        cols: cols,
        rows: rows,
        extraHorizontalPadding: extraHorizontalPadding,
        extraVerticalPadding: extraVerticalPadding,
        gridGap: gridGap,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$2({ index: index, layout: layout }) {
    const { cellWidth: cellWidth, cellHeight: cellHeight, rows: rows, cols: cols, cellCount: cellCount, gridGap: gridGap } = layout;
    const top = Math.floor(index / cols);
    const left = Math.floor(index % cols);
    const leftPadding = $de9b795dde6747fa$var$getCenterPadding$1({
        rows: rows,
        cols: cols,
        cellWidth: cellWidth,
        index: index,
        cellCount: cellCount,
        gridGap: gridGap
    });
    return {
        top: top * cellHeight + top * gridGap,
        left: left * cellWidth + left * gridGap + leftPadding,
        width: cellWidth,
        height: cellHeight
    };
}
const $de9b795dde6747fa$var$ROWS = "rows";
const $de9b795dde6747fa$var$COLUMNS = "columns";
function $de9b795dde6747fa$var$getPortraitLayoutGridForCount(count) {
    return ({
        1: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                1
            ]
        },
        2: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                1,
                1
            ]
        },
        3: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                1
            ]
        },
        4: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2
            ]
        },
        5: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                1
            ]
        },
        6: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                2
            ]
        },
        7: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2,
                2
            ]
        },
        8: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                2,
                2
            ]
        },
        9: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2,
                2,
                2
            ]
        },
        10: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                2,
                2
            ]
        },
        11: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                2
            ]
        },
        12: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3
            ]
        },
        13: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3
            ]
        },
        14: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3
            ]
        },
        15: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3
            ]
        },
        16: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3
            ]
        },
        17: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3
            ]
        },
        18: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        19: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3,
                3
            ]
        },
        20: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        21: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        22: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                2,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        23: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                2,
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        },
        24: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                3,
                3,
                3,
                3,
                3,
                3,
                3
            ]
        }
    })[count] || {
        type: $de9b795dde6747fa$var$ROWS,
        lines: [
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3
        ]
    };
}
function $de9b795dde6747fa$var$getLandscapeLayoutGridForCount(count) {
    return ({
        1: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                1
            ]
        },
        2: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                1,
                1
            ]
        },
        3: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                1
            ]
        },
        4: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2
            ]
        },
        5: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                3,
                2
            ],
            fractions: [
                0.45,
                0.55
            ]
        },
        6: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2,
                2
            ]
        },
        7: {
            type: $de9b795dde6747fa$var$ROWS,
            lines: [
                4,
                3
            ],
            fractions: [
                0.45,
                0.55
            ]
        },
        8: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                2,
                2,
                2,
                2
            ]
        },
        9: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                2,
                2,
                2
            ]
        },
        10: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                2,
                2
            ]
        },
        11: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                2
            ]
        },
        12: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                3
            ]
        },
        13: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                3,
                3,
                3
            ]
        },
        14: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                3,
                3
            ]
        },
        15: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                3,
                3,
                3,
                3,
                3
            ]
        },
        16: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                3,
                3,
                3,
                3
            ]
        },
        17: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                3,
                3,
                3
            ]
        },
        18: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                3,
                3
            ]
        },
        19: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                4,
                3
            ]
        },
        20: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                4,
                4,
                4,
                4,
                4
            ]
        },
        21: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                4,
                4,
                4,
                4
            ]
        },
        22: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                4,
                4,
                4
            ]
        },
        23: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                5,
                4,
                4
            ]
        },
        24: {
            type: $de9b795dde6747fa$var$COLUMNS,
            lines: [
                5,
                5,
                5,
                5,
                4
            ]
        }
    })[count] || {
        type: $de9b795dde6747fa$var$COLUMNS,
        lines: [
            5,
            5,
            5,
            5,
            5
        ]
    };
}
function $de9b795dde6747fa$var$calcCellDimensions({ layoutGrid: layoutGrid, dim: dim, secDim: secDim, index: index, count: count, gridGap: gridGap }) {
    const adjustedDim = dim - gridGap * (count - 1);
    const cellDim = adjustedDim * (layoutGrid.fractions ? layoutGrid.fractions[index] : 1 / count);
    const secCount = layoutGrid.lines[index];
    const adjustedSecDim = secDim - gridGap * (secCount - 1);
    const secCellDim = adjustedSecDim / secCount;
    return [
        cellDim,
        secCellDim
    ];
}
function $de9b795dde6747fa$var$partitionRectBy({ isHorizontal: isHorizontal, layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    const cellRects = [];
    const origin = {
        x: 0,
        y: 0
    };
    const cellOrigin = {
        x: 0,
        y: 0
    };
    const count = layoutGrid.lines.length;
    const dim = isHorizontal ? height : width;
    const secDim = isHorizontal ? width : height;
    for(let index = 0; index < count; index++){
        const cellDims = $de9b795dde6747fa$var$calcCellDimensions({
            layoutGrid: layoutGrid,
            dim: dim,
            secDim: secDim,
            index: index,
            count: count,
            gridGap: gridGap
        });
        const width = isHorizontal ? cellDims[1] : cellDims[0];
        const height = isHorizontal ? cellDims[0] : cellDims[1];
        const cellBounds = {
            width: width,
            height: height
        };
        const linesCount = layoutGrid.lines[index];
        for(let lineIndex = 0; lineIndex < linesCount; lineIndex++){
            cellRects.push({
                origin: Object.assign({}, cellOrigin),
                bounds: cellBounds
            });
            if (isHorizontal) cellOrigin.x += cellBounds.width + gridGap;
            else cellOrigin.y += cellBounds.height + gridGap;
        }
        if (isHorizontal) {
            cellOrigin.y += cellBounds.height + gridGap;
            cellOrigin.x = origin.x;
        } else {
            cellOrigin.x += cellBounds.width + gridGap;
            cellOrigin.y = origin.y;
        }
    }
    return cellRects;
}
function $de9b795dde6747fa$var$partitionRectByRows({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    return $de9b795dde6747fa$var$partitionRectBy({
        isHorizontal: true,
        layoutGrid: layoutGrid,
        width: width,
        height: height,
        gridGap: gridGap
    });
}
function $de9b795dde6747fa$var$partitionRectByColumns({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    return $de9b795dde6747fa$var$partitionRectBy({
        isHorizontal: false,
        layoutGrid: layoutGrid,
        width: width,
        height: height,
        gridGap: gridGap
    });
}
function $de9b795dde6747fa$var$partitionRect({ layoutGrid: layoutGrid, width: width, height: height, gridGap: gridGap }) {
    switch(layoutGrid.type){
        case $de9b795dde6747fa$var$ROWS:
            return $de9b795dde6747fa$var$partitionRectByRows({
                layoutGrid: layoutGrid,
                width: width,
                height: height,
                gridGap: gridGap
            });
        case $de9b795dde6747fa$var$COLUMNS:
            return $de9b795dde6747fa$var$partitionRectByColumns({
                layoutGrid: layoutGrid,
                width: width,
                height: height,
                gridGap: gridGap
            });
    }
}
function $de9b795dde6747fa$var$calculateLayout$2({ width: width, height: height, cellCount: cellCount, gridGap: gridGap = 0, paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    const contentWidth = width - (paddings.left + paddings.right);
    const contentHeight = height - (paddings.top + paddings.bottom);
    const isPortrait = Math.round(contentWidth / contentHeight * 10) / 10 <= 1.0;
    const layoutGrid = isPortrait ? $de9b795dde6747fa$var$getPortraitLayoutGridForCount(cellCount) : $de9b795dde6747fa$var$getLandscapeLayoutGridForCount(cellCount);
    const cellRects = $de9b795dde6747fa$var$partitionRect({
        layoutGrid: layoutGrid,
        width: contentWidth,
        height: contentHeight,
        gridGap: gridGap
    }) || [];
    return {
        cellRects: cellRects,
        cellCount: cellCount,
        gridGap: gridGap,
        extraHorizontalPadding: 0,
        extraVerticalPadding: 0,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$1({ index: index, layout: layout }) {
    const { cellRects: cellRects } = layout;
    const frame = cellRects[index] || $de9b795dde6747fa$var$makeFrame();
    return {
        top: frame.origin.y,
        left: frame.origin.x,
        width: frame.bounds.width,
        height: frame.bounds.height
    };
}
function $de9b795dde6747fa$var$getCenterPadding({ index: index, isPortrait: isPortrait, rows: rows, cols: cols, cellBounds: cellBounds, cellCount: cellCount }) {
    const canFit = rows * cols;
    const leftOver = canFit - cellCount;
    if (!leftOver) return 0;
    const lastIndex = canFit - leftOver - 1;
    const dimension = isPortrait ? cols : rows;
    const firstIndex = lastIndex - (dimension - leftOver) + 1;
    if (index < firstIndex || index > lastIndex) return 0;
    return leftOver * (isPortrait ? cellBounds.width : cellBounds.height) / 2;
}
function $de9b795dde6747fa$var$calculateLayout$1({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellBounds: cellBounds, paddings: paddings = $de9b795dde6747fa$var$makeBox() }) {
    let width = 0;
    let height = 0;
    let rows = 0;
    let cols = 0;
    let extraHorizontalPadding = 0;
    let extraVerticalPadding = 0;
    const contentWidth = containerBounds.width - paddings.left - paddings.right;
    const contentHeight = containerBounds.height - paddings.top - paddings.bottom;
    if (cellCount) {
        if (isPortrait) {
            cols = Math.floor(contentWidth / cellBounds.width);
            rows = Math.ceil(cellCount / cols);
            width = contentWidth;
            height = rows * cellBounds.height;
            extraHorizontalPadding = (contentWidth - cols * cellBounds.width) / 2;
        } else {
            rows = Math.floor(contentHeight / cellBounds.height);
            cols = Math.ceil(cellCount / rows);
            width = cols * cellBounds.width;
            height = contentHeight;
            extraVerticalPadding = (contentHeight - rows * cellBounds.height) / 2;
        }
    }
    return {
        isPortrait: isPortrait,
        width: width + paddings.left + paddings.right,
        height: height + paddings.top + paddings.bottom,
        cellBounds: cellBounds,
        cellCount: cellCount,
        rows: rows,
        cols: cols,
        extraHorizontalPadding: extraHorizontalPadding,
        extraVerticalPadding: extraVerticalPadding,
        paddings: paddings
    };
}
function $de9b795dde6747fa$var$getCellPropsAtIndexForLayout({ index: index, layout: layout }) {
    const { isPortrait: isPortrait, rows: rows, cols: cols, cellCount: cellCount, cellBounds: cellBounds, extraHorizontalPadding: extraHorizontalPadding, extraVerticalPadding: extraVerticalPadding, paddings: paddings } = layout;
    const top = isPortrait ? Math.floor(index / cols) : Math.floor(index % rows);
    const left = isPortrait ? Math.floor(index % cols) : Math.floor(index / rows);
    const centerPadding = $de9b795dde6747fa$var$getCenterPadding({
        index: index,
        isPortrait: isPortrait,
        rows: rows,
        cols: cols,
        cellBounds: cellBounds,
        cellCount: cellCount
    });
    return {
        top: paddings.top + extraVerticalPadding + top * cellBounds.height + (isPortrait ? 0 : centerPadding),
        left: paddings.left + extraHorizontalPadding + left * cellBounds.width + (isPortrait ? centerPadding : 0),
        width: cellBounds.width,
        height: cellBounds.height
    };
}
const { BOTTOM_TOOLBAR_HEIGHT: $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT, VIDEO_CONTROLS_MIN_WIDTH: $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH, TABLET_BREAKPOINT: $de9b795dde6747fa$var$TABLET_BREAKPOINT, SUBGRID_EMPTY_STAGE_MAX_WIDTH: $de9b795dde6747fa$var$SUBGRID_EMPTY_STAGE_MAX_WIDTH } = $de9b795dde6747fa$var$layoutConstants;
const $de9b795dde6747fa$var$MIN_GRID_HEIGHT = 200;
const $de9b795dde6747fa$var$MIN_GRID_WIDTH = 300;
const $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE = 200;
const $de9b795dde6747fa$var$OVERFLOW_ROOM_SUBGRID_TOP_PADDING = 20;
const $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER = 12;
const $de9b795dde6747fa$var$SUBGRID_CELL_PADDING_BOX = $de9b795dde6747fa$var$makeBox({
    top: 4,
    bottom: 28,
    left: 8,
    right: 8
});
function $de9b795dde6747fa$var$getSubgridSizeOptions({ hasOverflow: hasOverflow, hasStage: hasStage }) {
    if (hasOverflow && hasStage) return [
        80
    ];
    return [
        80,
        60
    ];
}
function $de9b795dde6747fa$var$getMinGridBounds({ cellCount: cellCount }) {
    const isSmallGrid = cellCount <= 6;
    const minGridHeight = isSmallGrid ? $de9b795dde6747fa$var$MIN_GRID_HEIGHT - 50 : $de9b795dde6747fa$var$MIN_GRID_HEIGHT;
    const minGridWidth = isSmallGrid ? $de9b795dde6747fa$var$MIN_GRID_WIDTH - 50 : $de9b795dde6747fa$var$MIN_GRID_WIDTH;
    return $de9b795dde6747fa$var$makeBounds({
        width: minGridWidth,
        height: minGridHeight
    });
}
function $de9b795dde6747fa$var$fitSupersizedContent({ bounds: bounds, aspectRatio: aspectRatio, minGridContainerBounds: minGridContainerBounds, hasPresentationGrid: hasPresentationGrid }) {
    const { width: width, height: height } = bounds;
    const hasVideoGrid = minGridContainerBounds.width > 0;
    if (!hasVideoGrid) return {
        isPortrait: width <= height,
        supersizedContentBounds: bounds
    };
    const minHorizontalSupersizedContentWidth = Math.round(width / 2);
    const minVerticalSupersizedContentHeight = Math.round(height / 2);
    const maxHorizontalSupersizedContentWidth = Math.max(width - minGridContainerBounds.width, 0);
    const maxVerticalSupersizedContentHeight = Math.max(height - minGridContainerBounds.height, 0);
    let isPortrait = maxHorizontalSupersizedContentWidth <= maxVerticalSupersizedContentHeight;
    let horizontalCorrection = 0;
    let verticalCorrection = 0;
    if (aspectRatio) {
        const horizontalContentBounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: maxHorizontalSupersizedContentWidth,
            height: height
        });
        const verticalContentBounds = $de9b795dde6747fa$var$fitToBounds(aspectRatio, {
            width: width,
            height: maxVerticalSupersizedContentHeight
        });
        const isPortraitContent = aspectRatio <= 1.0;
        isPortrait = isPortraitContent ? verticalContentBounds.height > horizontalContentBounds.height : verticalContentBounds.width > horizontalContentBounds.width;
        if (isPortrait) {
            const wastedSpace = maxVerticalSupersizedContentHeight - Math.max(verticalContentBounds.height, minVerticalSupersizedContentHeight);
            verticalCorrection = Math.max(wastedSpace, 0);
        } else {
            const wastedSpace = maxHorizontalSupersizedContentWidth - Math.max(horizontalContentBounds.width, minHorizontalSupersizedContentWidth);
            horizontalCorrection = Math.max(wastedSpace, 0);
        }
    } else if (hasPresentationGrid) isPortrait = maxHorizontalSupersizedContentWidth / maxVerticalSupersizedContentHeight >= 5;
    const supersizedContentBounds = {
        width: isPortrait ? width : maxHorizontalSupersizedContentWidth - horizontalCorrection,
        height: isPortrait ? maxVerticalSupersizedContentHeight - verticalCorrection : height
    };
    return {
        isPortrait: isPortrait,
        supersizedContentBounds: supersizedContentBounds
    };
}
function $de9b795dde6747fa$var$findBestSubgridLayout({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellSizeOptions: cellSizeOptions, cellPaddings: cellPaddings, paddings: paddings }) {
    let layout;
    for(let i = 0; i < cellSizeOptions.length; i++){
        const cellSize = cellSizeOptions[i];
        layout = $de9b795dde6747fa$var$calculateLayout$1({
            containerBounds: containerBounds,
            isPortrait: isPortrait,
            cellCount: cellCount,
            cellBounds: $de9b795dde6747fa$var$makeBounds({
                width: cellSize + cellPaddings.left + cellPaddings.right,
                height: cellSize + cellPaddings.top + cellPaddings.bottom
            }),
            paddings: paddings
        });
        if (layout.width <= containerBounds.width && layout.height <= containerBounds.height) return layout;
    }
    return layout;
}
function $de9b795dde6747fa$var$calculateSubgridLayout({ containerBounds: containerBounds, isPortrait: isPortrait, cellCount: cellCount, cellSizeOptions: cellSizeOptions, cellPaddings: cellPaddings, paddings: paddings }) {
    const layout = $de9b795dde6747fa$var$findBestSubgridLayout({
        containerBounds: containerBounds,
        isPortrait: isPortrait,
        cellCount: cellCount,
        cellSizeOptions: cellSizeOptions,
        cellPaddings: cellPaddings,
        paddings: paddings
    });
    const isSmallCell = layout.cellBounds.width - cellPaddings.left - cellPaddings.right === cellSizeOptions[cellSizeOptions.length - 1];
    const bounds = $de9b795dde6747fa$var$makeBounds({
        width: Math.min(layout.width, containerBounds.width),
        height: Math.min(layout.height, containerBounds.height)
    });
    const contentBounds = $de9b795dde6747fa$var$makeBounds({
        width: layout.width,
        height: layout.height
    });
    if (cellCount === 0) return {
        bounds: bounds,
        contentBounds: contentBounds,
        videoCells: []
    };
    return {
        bounds: bounds,
        contentBounds: contentBounds,
        videoCells: [
            ...Array(cellCount)
        ].map((_, index)=>{
            const { top: top, left: left, width: width, height: height } = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout({
                index: index,
                layout: layout
            });
            return {
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: top,
                    left: left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: width,
                    height: height
                }),
                paddings: cellPaddings,
                isSmallCell: isSmallCell
            };
        })
    };
}
function $de9b795dde6747fa$var$calculateStageLayout({ cellPaddings: cellPaddings, cellSizeOptions: cellSizeOptions, containerBounds: containerBounds, containerOrigin: containerOrigin, gridGap: gridGap, hasConstrainedOverflow: hasConstrainedOverflow, hasPresentationContent: hasPresentationContent, hasVideoContent: hasVideoContent, isConstrained: isConstrained, isMaximizeMode: isMaximizeMode, isPortrait: isPortrait, isSmallScreen: isSmallScreen, maxGridWidth: maxGridWidth, shouldOverflowSubgrid: shouldOverflowSubgrid, subgridVideos: subgridVideos }) {
    const { width: width, height: height } = containerBounds;
    const hasVideos = hasPresentationContent || hasVideoContent;
    const hasSubgrid = subgridVideos.length > 0;
    if (!hasSubgrid && !hasVideos) return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame()), {
            contentBounds: $de9b795dde6747fa$var$makeBounds(),
            cells: []
        }),
        hasOverflow: false
    };
    if (!hasSubgrid) return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, containerBounds), containerOrigin)),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame()), {
            contentBounds: $de9b795dde6747fa$var$makeBounds(),
            cells: []
        }),
        hasOverflow: hasConstrainedOverflow
    };
    const topSubgridPadding = shouldOverflowSubgrid ? $de9b795dde6747fa$var$OVERFLOW_ROOM_SUBGRID_TOP_PADDING : 0;
    let _containerBounds = null;
    if (!hasVideos) _containerBounds = $de9b795dde6747fa$var$makeBounds({
        width: Math.min($de9b795dde6747fa$var$SUBGRID_EMPTY_STAGE_MAX_WIDTH, containerBounds.width),
        height: containerBounds.height
    });
    else if (shouldOverflowSubgrid) {
        const cellSize = cellSizeOptions[0];
        let visibleSubgridHeight = isMaximizeMode ? $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT : $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT + cellPaddings.top + (isConstrained || isSmallScreen ? cellSize / 2 : cellSize) + cellPaddings.bottom;
        if (containerBounds.height - visibleSubgridHeight < $de9b795dde6747fa$var$MIN_GRID_HEIGHT) visibleSubgridHeight = 0;
        _containerBounds = $de9b795dde6747fa$var$makeBounds({
            width: containerBounds.width,
            height: visibleSubgridHeight
        });
    } else if (isMaximizeMode) _containerBounds = $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width,
        height: cellSizeOptions[0] + cellPaddings.top + cellPaddings.bottom
    });
    else _containerBounds = isPortrait ? $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width,
        height: containerBounds.height / 2
    }) : $de9b795dde6747fa$var$makeBounds({
        width: containerBounds.width / 2,
        height: containerBounds.height
    });
    let leftSubgridPadding = 0;
    if (_containerBounds.width > maxGridWidth) leftSubgridPadding = (_containerBounds.width - maxGridWidth) / 2;
    const subgridLayout = $de9b795dde6747fa$var$calculateSubgridLayout({
        containerBounds: _containerBounds,
        isPortrait: isPortrait,
        cellCount: subgridVideos.length,
        cellSizeOptions: cellSizeOptions,
        cellPaddings: cellPaddings,
        paddings: $de9b795dde6747fa$var$makeBox({
            top: topSubgridPadding,
            left: leftSubgridPadding,
            right: leftSubgridPadding
        })
    });
    const overflowNeedBounds = $de9b795dde6747fa$var$makeBounds({
        width: subgridLayout.contentBounds.width - _containerBounds.width,
        height: subgridLayout.contentBounds.height - _containerBounds.height
    });
    const hasOverflow = overflowNeedBounds.width > 0 || overflowNeedBounds.height > 0;
    let subgridBounds = null;
    if (!hasVideos || shouldOverflowSubgrid || hasOverflow) subgridBounds = subgridLayout.contentBounds;
    else subgridBounds = subgridLayout.bounds;
    let videosContainerBounds;
    let _subgridContainerShareBounds = subgridBounds;
    if (hasVideos) {
        if (shouldOverflowSubgrid) _subgridContainerShareBounds = $de9b795dde6747fa$var$makeBounds({
            width: 0,
            height: _containerBounds.height + topSubgridPadding + gridGap
        });
        else _subgridContainerShareBounds = isPortrait ? $de9b795dde6747fa$var$makeBounds({
            width: 0,
            height: subgridLayout.bounds.height + gridGap
        }) : $de9b795dde6747fa$var$makeBounds({
            width: subgridLayout.bounds.width + gridGap,
            height: 0
        });
        videosContainerBounds = $de9b795dde6747fa$var$insetBounds({
            bounds: _subgridContainerShareBounds,
            fromBounds: containerBounds
        });
    } else videosContainerBounds = $de9b795dde6747fa$var$makeBounds();
    const videosContainerOrigin = Object.assign({}, containerOrigin);
    let subgridOrigin;
    if (hasVideos) subgridOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: isPortrait ? Math.max(containerOrigin.top + height - _subgridContainerShareBounds.height + gridGap, 0) : containerOrigin.top,
        left: isPortrait ? containerOrigin.left : Math.max(containerOrigin.left + width - subgridBounds.width, 0)
    });
    else subgridOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: containerOrigin.top + Math.max(0, (height - subgridBounds.height) / 2),
        left: containerOrigin.left + Math.max(0, (width - subgridBounds.width) / 2)
    });
    return {
        isPortrait: isPortrait,
        videosContainer: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, videosContainerBounds), videosContainerOrigin)),
        subgrid: Object.assign(Object.assign({}, $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, subgridBounds), subgridOrigin))), {
            cells: subgridLayout.videoCells.map((cell, index)=>{
                var _a, _b;
                return Object.assign({
                    aspectRatio: ((_a = subgridVideos[index]) === null || _a === void 0 ? void 0 : _a.aspectRatio) || 1,
                    type: "video",
                    clientId: (_b = subgridVideos[index]) === null || _b === void 0 ? void 0 : _b.clientId
                }, cell);
            }),
            contentBounds: subgridLayout.contentBounds
        }),
        hasOverflow: hasOverflow || shouldOverflowSubgrid || hasConstrainedOverflow,
        overflowNeedBounds: shouldOverflowSubgrid ? $de9b795dde6747fa$var$makeBounds() : overflowNeedBounds
    };
}
function $de9b795dde6747fa$var$calculateVideosContainerLayout({ containerBounds: containerBounds, containerOrigin: containerOrigin, gridGap: gridGap, supersizedContentAspectRatio: supersizedContentAspectRatio, hasPresentationContent: hasPresentationContent, hasPresentationGrid: hasPresentationGrid, hasVideoContent: hasVideoContent, minGridBounds: minGridBounds }) {
    const { width: width, height: height } = containerBounds;
    let isPortrait = width <= height;
    let presentationGridBounds = $de9b795dde6747fa$var$makeBounds();
    let presentationGridOrigin = $de9b795dde6747fa$var$makeOrigin();
    let videoGridBounds = hasVideoContent ? Object.assign({}, containerBounds) : $de9b795dde6747fa$var$makeBounds();
    let videoGridOrigin = hasVideoContent ? Object.assign({}, containerOrigin) : $de9b795dde6747fa$var$makeOrigin();
    if (hasPresentationContent) {
        const minGridContainerBounds = $de9b795dde6747fa$var$makeBounds({
            width: hasVideoContent ? minGridBounds.width + gridGap : 0,
            height: hasVideoContent ? minGridBounds.height + gridGap : 0
        });
        const supersizedContentLayout = $de9b795dde6747fa$var$fitSupersizedContent({
            bounds: containerBounds,
            aspectRatio: supersizedContentAspectRatio || 1,
            minGridContainerBounds: minGridContainerBounds,
            hasPresentationGrid: hasPresentationGrid
        });
        isPortrait = supersizedContentLayout.isPortrait;
        presentationGridBounds = supersizedContentLayout.supersizedContentBounds;
        presentationGridOrigin = Object.assign({}, containerOrigin);
        if (hasVideoContent) {
            videoGridBounds = $de9b795dde6747fa$var$makeBounds({
                width: isPortrait ? containerBounds.width : containerBounds.width - presentationGridBounds.width - gridGap,
                height: isPortrait ? containerBounds.height - presentationGridBounds.height - gridGap : containerBounds.height
            });
            videoGridOrigin = $de9b795dde6747fa$var$makeOrigin({
                top: isPortrait ? containerOrigin.top + presentationGridBounds.height + gridGap : containerOrigin.top,
                left: isPortrait ? containerOrigin.left : containerOrigin.left + presentationGridBounds.width + gridGap
            });
        }
    }
    return {
        isPortrait: isPortrait,
        presentationGrid: Object.assign({}, $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, presentationGridBounds), presentationGridOrigin))),
        videoGrid: $de9b795dde6747fa$var$makeFrame(Object.assign(Object.assign({}, videoGridBounds), videoGridOrigin))
    };
}
function $de9b795dde6747fa$var$calculateGridLayout({ containerBounds: containerBounds, paddings: paddings = $de9b795dde6747fa$var$makeBox(), videos: videos, isConstrained: isConstrained, maxGridWidth: maxGridWidth, gridGap: gridGap }) {
    const { width: width, height: height } = containerBounds;
    const cappedWidth = maxGridWidth ? Math.min(width, maxGridWidth) : width;
    const cellCount = videos.length;
    let gridLayout = null;
    let videoCells = null;
    if (isConstrained) {
        const constrainedGridLayout = $de9b795dde6747fa$var$calculateLayout$2({
            width: width,
            height: height,
            cellCount: cellCount,
            gridGap: gridGap,
            paddings: paddings
        });
        const isSmallCell = cellCount > 4;
        videoCells = videos.map((video, index)=>{
            const cellProps = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$1({
                index: index,
                layout: constrainedGridLayout
            });
            return {
                clientId: video.clientId,
                isDraggable: video.isDraggable,
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: cellProps.top,
                    left: cellProps.left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: cellProps.width,
                    height: cellProps.height
                }),
                aspectRatio: cellProps.width / cellProps.height,
                isSmallCell: isSmallCell,
                type: "video"
            };
        });
        gridLayout = constrainedGridLayout;
    } else {
        const cellAspectRatios = videos.map((video)=>video.aspectRatio || 1);
        const minGridBounds = $de9b795dde6747fa$var$getMinGridBounds({
            cellCount: cellCount
        });
        const centerGridLayout = $de9b795dde6747fa$var$calculateLayout$3({
            width: cappedWidth,
            height: height,
            cellCount: cellCount,
            gridGap: gridGap,
            cellAspectRatios: cellAspectRatios,
            paddings: paddings
        });
        videoCells = videos.map((video, index)=>{
            const cellProps = $de9b795dde6747fa$var$getCellPropsAtIndexForLayout$2({
                index: index,
                layout: centerGridLayout
            });
            const isSmallCell = centerGridLayout.cellWidth < minGridBounds.width;
            const shouldZoom = isConstrained || isSmallCell;
            const aspectRatio = shouldZoom ? centerGridLayout.cellWidth / centerGridLayout.cellHeight : video.aspectRatio || 1;
            return {
                clientId: video.clientId,
                isDraggable: video.isDraggable,
                origin: $de9b795dde6747fa$var$makeOrigin({
                    top: cellProps.top,
                    left: cellProps.left
                }),
                bounds: $de9b795dde6747fa$var$makeBounds({
                    width: cellProps.width,
                    height: cellProps.height
                }),
                aspectRatio: aspectRatio,
                isSmallCell: isSmallCell,
                type: "video"
            };
        });
        gridLayout = centerGridLayout;
    }
    return {
        videoCells: videoCells,
        extraHorizontalPadding: width !== cappedWidth ? gridLayout.extraHorizontalPadding + (width - cappedWidth) / 2 : gridLayout.extraHorizontalPadding,
        extraVerticalPadding: gridLayout.extraVerticalPadding,
        paddings: gridLayout.paddings,
        gridGap: gridGap
    };
}
function $de9b795dde6747fa$var$calculateFloatingLayout({ roomBounds: roomBounds, containerFrame: containerFrame, floatingVideo: floatingVideo, videoControlsHeight: videoControlsHeight, margin: margin = 8 }) {
    if (!floatingVideo) return null;
    const bounds = $de9b795dde6747fa$var$fitToBounds(floatingVideo.aspectRatio || 0, {
        width: $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE,
        height: $de9b795dde6747fa$var$FLOATING_VIDEO_SIZE
    });
    const isFloating = !(roomBounds.height - containerFrame.bounds.height - containerFrame.origin.top);
    const isConstrained = containerFrame.bounds.width - (bounds.width + margin) * 2 < $de9b795dde6747fa$var$VIDEO_CONTROLS_MIN_WIDTH;
    let verticalOffset = 0;
    if (isFloating && isConstrained) verticalOffset = videoControlsHeight * -1;
    else if (!isFloating && !isConstrained) verticalOffset = videoControlsHeight;
    const origin = $de9b795dde6747fa$var$makeOrigin({
        top: containerFrame.origin.top + (containerFrame.bounds.height - bounds.height - margin) + verticalOffset,
        left: containerFrame.origin.left + (containerFrame.bounds.width - bounds.width - margin)
    });
    const videoCell = {
        clientId: floatingVideo.clientId,
        isDraggable: floatingVideo.isDraggable,
        origin: origin,
        bounds: bounds,
        aspectRatio: floatingVideo.aspectRatio,
        isSmallCell: true
    };
    return videoCell;
}
function $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({ a: a, b: b, gridGap: gridGap, isPortrait: isPortrait }) {
    const aPad = isPortrait ? a.vertical : a.horizontal;
    const bPad = isPortrait ? b.vertical : b.horizontal;
    if (aPad === bPad) return {
        a: 0,
        b: 0
    };
    const sArea = aPad < bPad ? a : b;
    const sAreaPad = isPortrait ? sArea.vertical : sArea.horizontal;
    const spaceBetween = gridGap + (aPad + bPad);
    const offset = (spaceBetween + sAreaPad) / 2 - sAreaPad;
    return {
        a: sArea === a ? offset : 0,
        b: sArea === b ? offset : 0
    };
}
function $de9b795dde6747fa$var$rebalanceLayoutInPlace({ videosContainerLayout: videosContainerLayout, gridLayout: gridLayout, presentationGridLayout: presentationGridLayout, stageLayout: stageLayout, gridGap: gridGap, shouldOverflowSubgrid: shouldOverflowSubgrid }) {
    const hasPresentationGrid = videosContainerLayout.presentationGrid.bounds.width > 0;
    const hasVideoGrid = videosContainerLayout.videoGrid.bounds.width > 0;
    const hasSubgrid = stageLayout.subgrid.bounds.width > 0;
    const videoGridRebalanceOffset = {
        vertical: 0,
        horizontal: 0
    };
    if (hasPresentationGrid && hasVideoGrid) {
        const correction = $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({
            a: {
                horizontal: presentationGridLayout.extraHorizontalPadding,
                vertical: presentationGridLayout.extraVerticalPadding
            },
            b: {
                horizontal: gridLayout.extraHorizontalPadding,
                vertical: gridLayout.extraVerticalPadding
            },
            gridGap: gridGap,
            isPortrait: videosContainerLayout.isPortrait
        });
        if (videosContainerLayout.isPortrait) {
            videosContainerLayout.presentationGrid.origin.top += correction.a;
            videosContainerLayout.videoGrid.origin.top -= correction.b;
            videoGridRebalanceOffset.vertical = correction.b;
        } else {
            videosContainerLayout.presentationGrid.origin.left += correction.a;
            videosContainerLayout.videoGrid.origin.left -= correction.b;
            videoGridRebalanceOffset.horizontal = correction.b;
        }
    }
    if (hasSubgrid && (hasPresentationGrid || hasVideoGrid) && !shouldOverflowSubgrid) {
        const presentationGridArea = {
            horizontal: presentationGridLayout.extraHorizontalPadding,
            vertical: presentationGridLayout.extraVerticalPadding
        };
        const gridArea = {
            horizontal: gridLayout.extraHorizontalPadding + videoGridRebalanceOffset.horizontal,
            vertical: gridLayout.extraVerticalPadding + videoGridRebalanceOffset.vertical
        };
        let area;
        const hasBothGrids = hasPresentationGrid && hasVideoGrid;
        if (hasBothGrids && videosContainerLayout.isPortrait && !stageLayout.isPortrait) area = presentationGridArea.horizontal < gridArea.horizontal ? presentationGridArea : gridArea;
        else if (hasBothGrids && !videosContainerLayout.isPortrait && stageLayout.isPortrait) area = presentationGridArea.vertical < gridArea.vertical ? presentationGridArea : gridArea;
        else if (hasVideoGrid) area = gridArea;
        else area = presentationGridArea;
        const correction = $de9b795dde6747fa$var$rebalanceLayoutPaddedAreas({
            a: area,
            b: {
                horizontal: 0,
                vertical: 0
            },
            gridGap: gridGap,
            isPortrait: stageLayout.isPortrait
        });
        if (stageLayout.isPortrait) stageLayout.subgrid.origin.top -= correction.b;
        else stageLayout.subgrid.origin.left -= correction.b;
    }
}
function $de9b795dde6747fa$var$redistributeEmptySpaceToSubgridInPlace({ vPaddings: vPaddings, hPaddings: hPaddings, stageLayout: stageLayout, videosContainerLayout: videosContainerLayout }) {
    if (stageLayout.isPortrait && (vPaddings.presentationGrid || vPaddings.grid)) {
        const totalVPadding = videosContainerLayout.isPortrait ? vPaddings.presentationGrid * 2 + vPaddings.grid * 2 : vPaddings.presentationGrid + vPaddings.grid;
        stageLayout.videosContainer.bounds.height -= totalVPadding;
        stageLayout.subgrid.origin.top -= totalVPadding;
        stageLayout.subgrid.bounds.height += totalVPadding;
        videosContainerLayout.presentationGrid.bounds.height -= vPaddings.presentationGrid * 2;
        videosContainerLayout.videoGrid.bounds.height -= vPaddings.grid * 2;
        if (videosContainerLayout.isPortrait) videosContainerLayout.videoGrid.origin.top -= vPaddings.presentationGrid;
    }
    if (!stageLayout.isPortrait && (hPaddings.presentationGrid || hPaddings.grid)) {
        const totalHPadding = videosContainerLayout.isPortrait ? hPaddings.presentationGrid + hPaddings.grid : hPaddings.presentationGrid * 2 + hPaddings.grid * 2;
        stageLayout.videosContainer.bounds.width -= totalHPadding;
        stageLayout.subgrid.origin.left -= totalHPadding;
        stageLayout.subgrid.bounds.width += totalHPadding;
        videosContainerLayout.presentationGrid.bounds.width -= hPaddings.presentationGrid * 2;
        videosContainerLayout.videoGrid.bounds.width -= hPaddings.grid * 2;
        if (!videosContainerLayout.isPortrait) videosContainerLayout.videoGrid.origin.left -= hPaddings.grid;
    }
}
function $de9b795dde6747fa$var$findGridsEmptySpaceToRedistribute({ need: need, stageLayout: stageLayout, gridLayout: gridLayout, presentationGridLayout: presentationGridLayout, videosContainerLayout: videosContainerLayout }) {
    let vPaddings = {
        presentationGrid: 0,
        grid: 0
    };
    let hPaddings = {
        presentationGrid: 0,
        grid: 0
    };
    if (stageLayout.isPortrait) {
        const minDim = Math.min(gridLayout.extraVerticalPadding, presentationGridLayout.extraVerticalPadding);
        vPaddings = {
            presentationGrid: Math.min(videosContainerLayout.isPortrait ? presentationGridLayout.extraVerticalPadding : minDim, need.height),
            grid: Math.min(videosContainerLayout.isPortrait ? gridLayout.extraVerticalPadding : minDim, need.height)
        };
    } else {
        const minDim = Math.min(gridLayout.extraHorizontalPadding, presentationGridLayout.extraHorizontalPadding);
        hPaddings = {
            presentationGrid: Math.min(videosContainerLayout.isPortrait ? minDim : presentationGridLayout.extraHorizontalPadding, need.width),
            grid: Math.min(videosContainerLayout.isPortrait ? minDim : gridLayout.extraHorizontalPadding, need.width)
        };
    }
    return {
        vPaddings: vPaddings,
        hPaddings: hPaddings
    };
}
function $de9b795dde6747fa$var$calculateGridLayouts({ gridGap: gridGap, isConstrained: isConstrained, presentationVideos: presentationVideos, videos: videos, videosContainerLayout: videosContainerLayout, gridLayoutPaddings: gridLayoutPaddings = $de9b795dde6747fa$var$makeBox(), presentationGridLayoutPaddings: presentationGridLayoutPaddings = $de9b795dde6747fa$var$makeBox(), maxGridWidth: maxGridWidth }) {
    const gridLayout = $de9b795dde6747fa$var$calculateGridLayout({
        containerBounds: videosContainerLayout.videoGrid.bounds,
        gridGap: gridGap,
        isConstrained: isConstrained,
        maxGridWidth: maxGridWidth,
        paddings: gridLayoutPaddings,
        videos: videos
    });
    const presentationGridLayout = $de9b795dde6747fa$var$calculateGridLayout({
        containerBounds: videosContainerLayout.presentationGrid.bounds,
        gridGap: gridGap,
        isConstrained: isConstrained,
        maxGridWidth: maxGridWidth,
        paddings: presentationGridLayoutPaddings,
        videos: presentationVideos
    });
    return {
        gridLayout: gridLayout,
        presentationGridLayout: presentationGridLayout
    };
}
function $de9b795dde6747fa$var$calculateLayout({ floatingVideo: floatingVideo, frame: frame, gridGap: gridGap, isConstrained: isConstrained, isMaximizeMode: isMaximizeMode = false, isXLMeetingSize: isXLMeetingSize = false, paddings: paddings = $de9b795dde6747fa$var$makeBox(), presentationVideos: presentationVideos = [], rebalanceLayout: rebalanceLayout = false, roomBounds: roomBounds, roomLayoutHasOverlow: roomLayoutHasOverlow = false, subgridCellPaddings: subgridCellPaddings = $de9b795dde6747fa$var$SUBGRID_CELL_PADDING_BOX, subgridVideos: subgridVideos = [], videoControlsHeight: videoControlsHeight = 0, videos: videos = [], videoGridGap: videoGridGap }) {
    let shouldOverflowSubgrid = isXLMeetingSize && (screen ? screen.width <= 2048 : true);
    const hasPresentationContent = !!presentationVideos.length;
    const hasPresentationGrid = presentationVideos.length > 1;
    const supersizedContentAspectRatio = hasPresentationContent && !hasPresentationGrid ? presentationVideos[0].aspectRatio : null;
    const hasVideoContent = !!videos.length;
    const width = frame.bounds.width - paddings.left - paddings.right;
    let height = frame.bounds.height - paddings.top - paddings.bottom;
    const maxGridWidth = Math.max(2200, 0.8 * width);
    const hasConstrainedOverflow = isConstrained && videos.length > $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER;
    const lineHeight = height / 4;
    const extraLines = Math.ceil((videos.length - $de9b795dde6747fa$var$CONSTRAINED_OVERFLOW_TRIGGER) / 3);
    height = hasConstrainedOverflow ? height + lineHeight * extraLines : height;
    const stageBounds = $de9b795dde6747fa$var$makeBounds({
        width: width,
        height: height
    });
    const stageOrigin = $de9b795dde6747fa$var$makeOrigin({
        top: paddings.top,
        left: paddings.left
    });
    const _minBounds = $de9b795dde6747fa$var$getMinGridBounds({
        cellCount: videos.length
    });
    const minGridBounds = _minBounds;
    const isSmallScreen = roomBounds.width < $de9b795dde6747fa$var$TABLET_BREAKPOINT || roomBounds.height < $de9b795dde6747fa$var$TABLET_BREAKPOINT;
    const forceStageLayoutPortrait = isMaximizeMode;
    const stageLayoutIsPortrait = forceStageLayoutPortrait || shouldOverflowSubgrid || !(hasPresentationContent || hasVideoContent) || stageBounds.width <= stageBounds.height;
    const stableStageLayoutProps = {
        cellPaddings: subgridCellPaddings,
        containerBounds: stageBounds,
        containerOrigin: stageOrigin,
        gridGap: gridGap,
        hasPresentationContent: hasPresentationContent,
        hasVideoContent: hasVideoContent,
        isConstrained: isConstrained,
        isMaximizeMode: isMaximizeMode,
        isSmallScreen: isSmallScreen,
        subgridVideos: subgridVideos,
        maxGridWidth: maxGridWidth
    };
    let stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
        cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
            hasOverflow: shouldOverflowSubgrid,
            hasStage: hasPresentationContent || hasVideoContent
        }),
        isPortrait: stageLayoutIsPortrait,
        shouldOverflowSubgrid: shouldOverflowSubgrid,
        hasConstrainedOverflow: hasConstrainedOverflow
    }));
    let forceRerunAsOverflow = false;
    if (!shouldOverflowSubgrid && roomLayoutHasOverlow && !stageLayout.hasOverflow) {
        const _stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
            containerBounds: $de9b795dde6747fa$var$makeBounds({
                width: stageBounds.width,
                height: stageBounds.height - $de9b795dde6747fa$var$BOTTOM_TOOLBAR_HEIGHT
            }),
            cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
                hasOverflow: shouldOverflowSubgrid,
                hasStage: hasPresentationContent || hasVideoContent
            }),
            isPortrait: stageLayoutIsPortrait,
            shouldOverflowSubgrid: shouldOverflowSubgrid,
            hasConstrainedOverflow: hasConstrainedOverflow
        }));
        if (_stageLayout.hasOverflow) forceRerunAsOverflow = true;
    }
    if (forceRerunAsOverflow || stageLayout.hasOverflow && !shouldOverflowSubgrid) {
        shouldOverflowSubgrid = true;
        stageLayout = $de9b795dde6747fa$var$calculateStageLayout(Object.assign(Object.assign({}, stableStageLayoutProps), {
            cellSizeOptions: $de9b795dde6747fa$var$getSubgridSizeOptions({
                hasOverflow: true,
                hasStage: hasPresentationContent || hasVideoContent
            }),
            isPortrait: true,
            shouldOverflowSubgrid: shouldOverflowSubgrid,
            hasConstrainedOverflow: hasConstrainedOverflow
        }));
    }
    const videosContainerLayout = $de9b795dde6747fa$var$calculateVideosContainerLayout({
        containerBounds: stageLayout.videosContainer.bounds,
        containerOrigin: stageLayout.videosContainer.origin,
        gridGap: gridGap,
        supersizedContentAspectRatio: supersizedContentAspectRatio || 1,
        hasPresentationContent: hasPresentationContent,
        hasPresentationGrid: hasPresentationGrid,
        hasVideoContent: hasVideoContent,
        minGridBounds: minGridBounds
    });
    let { gridLayout: gridLayout, presentationGridLayout: presentationGridLayout } = $de9b795dde6747fa$var$calculateGridLayouts({
        gridGap: videoGridGap || gridGap,
        isConstrained: isConstrained,
        presentationVideos: presentationVideos,
        videos: videos,
        videosContainerLayout: videosContainerLayout,
        maxGridWidth: maxGridWidth
    });
    if (stageLayout.hasOverflow && !shouldOverflowSubgrid) {
        const { vPaddings: vPaddings, hPaddings: hPaddings } = $de9b795dde6747fa$var$findGridsEmptySpaceToRedistribute({
            need: stageLayout.overflowNeedBounds || $de9b795dde6747fa$var$makeBounds(),
            stageLayout: stageLayout,
            gridLayout: gridLayout,
            presentationGridLayout: presentationGridLayout,
            videosContainerLayout: videosContainerLayout
        });
        if (vPaddings.presentationGrid || vPaddings.grid || hPaddings.presentationGrid || hPaddings.grid) {
            $de9b795dde6747fa$var$redistributeEmptySpaceToSubgridInPlace({
                vPaddings: vPaddings,
                hPaddings: hPaddings,
                stageLayout: stageLayout,
                videosContainerLayout: videosContainerLayout
            });
            ({ gridLayout: gridLayout, presentationGridLayout: presentationGridLayout } = $de9b795dde6747fa$var$calculateGridLayouts({
                gridGap: videoGridGap || gridGap,
                isConstrained: isConstrained,
                presentationVideos: presentationVideos,
                videos: videos,
                videosContainerLayout: videosContainerLayout,
                maxGridWidth: maxGridWidth
            }));
        }
    }
    const floatingLayout = $de9b795dde6747fa$var$calculateFloatingLayout({
        roomBounds: roomBounds,
        containerFrame: frame,
        floatingVideo: floatingVideo || null,
        videoControlsHeight: videoControlsHeight
    });
    if (rebalanceLayout) $de9b795dde6747fa$var$rebalanceLayoutInPlace({
        videosContainerLayout: videosContainerLayout,
        gridLayout: gridLayout,
        presentationGridLayout: presentationGridLayout,
        stageLayout: stageLayout,
        gridGap: gridGap,
        shouldOverflowSubgrid: shouldOverflowSubgrid
    });
    let overflowBoundsHeight = paddings.top + stageLayout.videosContainer.bounds.height + stageLayout.subgrid.bounds.height + paddings.bottom;
    if (hasPresentationContent || hasVideoContent) overflowBoundsHeight += gridGap;
    return {
        isPortrait: stageLayout.isPortrait,
        hasOverflow: stageLayout.hasOverflow,
        videosContainer: Object.assign(Object.assign({}, videosContainerLayout), {
            bounds: $de9b795dde6747fa$var$makeBounds({
                width: stageLayout.videosContainer.bounds.width,
                height: stageLayout.videosContainer.bounds.height
            }),
            origin: $de9b795dde6747fa$var$makeOrigin({
                top: stageLayout.videosContainer.origin.top,
                left: stageLayout.videosContainer.origin.left
            })
        }),
        bounds: $de9b795dde6747fa$var$makeBounds({
            height: shouldOverflowSubgrid ? overflowBoundsHeight : frame.bounds.height,
            width: frame.bounds.width
        }),
        gridGap: gridGap,
        presentationGrid: Object.assign(Object.assign({}, videosContainerLayout.presentationGrid), {
            cells: presentationGridLayout.videoCells,
            paddings: $de9b795dde6747fa$var$makeBox({
                top: presentationGridLayout.paddings.top + presentationGridLayout.extraVerticalPadding,
                bottom: presentationGridLayout.paddings.bottom + presentationGridLayout.extraVerticalPadding,
                left: presentationGridLayout.paddings.left + presentationGridLayout.extraHorizontalPadding,
                right: presentationGridLayout.paddings.right + presentationGridLayout.extraHorizontalPadding
            })
        }),
        videoGrid: Object.assign(Object.assign({}, videosContainerLayout.videoGrid), {
            cells: gridLayout.videoCells,
            paddings: $de9b795dde6747fa$var$makeBox({
                top: gridLayout.paddings.top + gridLayout.extraVerticalPadding,
                bottom: gridLayout.paddings.bottom + gridLayout.extraVerticalPadding,
                left: gridLayout.paddings.left + gridLayout.extraHorizontalPadding,
                right: gridLayout.paddings.right + gridLayout.extraHorizontalPadding
            })
        }),
        subgrid: stageLayout.subgrid,
        floatingContent: Object.assign(Object.assign(Object.assign({}, floatingLayout), floatingVideo), {
            origin: (floatingLayout === null || floatingLayout === void 0 ? void 0 : floatingLayout.origin) || $de9b795dde6747fa$var$makeOrigin(),
            bounds: (floatingLayout === null || floatingLayout === void 0 ? void 0 : floatingLayout.bounds) || $de9b795dde6747fa$var$makeBounds(),
            aspectRatio: (floatingVideo === null || floatingVideo === void 0 ? void 0 : floatingVideo.aspectRatio) || 1
        })
    };
}
function $de9b795dde6747fa$var$makeVideoCellView({ aspectRatio: aspectRatio, avatarSize: avatarSize, cellPaddings: cellPaddings, client: client, isDraggable: isDraggable = true, isPlaceholder: isPlaceholder = false, isSubgrid: isSubgrid = false }) {
    return {
        aspectRatio: aspectRatio || 16 / 9,
        avatarSize: avatarSize,
        cellPaddings: cellPaddings,
        client: client,
        clientId: (client === null || client === void 0 ? void 0 : client.id) || "",
        isDraggable: isDraggable,
        isPlaceholder: isPlaceholder,
        isSubgrid: isSubgrid,
        type: "video"
    };
}
const $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT = 12;
const $de9b795dde6747fa$var$ACTIVE_VIDEO_SUBGRID_TRIGGER = 12;
const $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT = 24;
function $de9b795dde6747fa$var$calculateSubgridViews({ clientViews: clientViews, activeVideosSubgridTrigger: activeVideosSubgridTrigger, shouldShowSubgrid: shouldShowSubgrid, spotlightedParticipants: spotlightedParticipants, maximizedParticipant: maximizedParticipant, isPhoneResolution: isPhoneResolution }) {
    if (!shouldShowSubgrid) return [];
    const hasSpotlights = spotlightedParticipants.length > 0;
    const hasPresentationStage = hasSpotlights;
    const notMaximized = maximizedParticipant ? clientViews.filter((client)=>client.id !== maximizedParticipant.id) : clientViews;
    const notSpotlighted = notMaximized.filter((client)=>!client.isPresentation && !spotlightedParticipants.includes(client));
    const noVideoViews = notSpotlighted.filter((client)=>!client.isVideoEnabled);
    const videoLimitReached = notSpotlighted.filter((client)=>client.isVideoEnabled).length > activeVideosSubgridTrigger;
    const unmutedVideos = notSpotlighted.filter((client)=>!noVideoViews.includes(client) && client.isAudioEnabled);
    const mutedVideos = notSpotlighted.filter((client)=>!noVideoViews.includes(client) && !client.isAudioEnabled);
    if (noVideoViews.length && hasPresentationStage) return [
        ...mutedVideos,
        ...noVideoViews
    ];
    if (isPhoneResolution && notSpotlighted.length > $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT) {
        const sorted = [
            ...unmutedVideos,
            ...mutedVideos
        ];
        const inGrid = sorted.slice(0, $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT);
        if (inGrid.length <= $de9b795dde6747fa$var$ACTIVE_VIDEOS_PHONE_LIMIT) return [
            ...sorted.filter((client)=>!inGrid.includes(client)),
            ...noVideoViews
        ];
        else return [
            ...mutedVideos,
            ...noVideoViews
        ];
    }
    if (videoLimitReached && mutedVideos.length) {
        const sorted = [
            ...unmutedVideos,
            ...mutedVideos
        ];
        const inGrid = sorted.slice(0, activeVideosSubgridTrigger);
        if (inGrid.length <= activeVideosSubgridTrigger) return [
            ...mutedVideos.filter((client)=>!inGrid.includes(client)),
            ...noVideoViews
        ];
        else return [
            ...mutedVideos,
            ...noVideoViews
        ];
    }
    return noVideoViews;
}
function $de9b795dde6747fa$var$useGridParticipants({ activeVideosSubgridTrigger: activeVideosSubgridTrigger = $de9b795dde6747fa$var$ACTIVE_VIDEO_SUBGRID_TRIGGER, stageParticipantLimit: stageParticipantLimit = $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT, forceSubgrid: forceSubgrid = true, enableSubgrid: enableSubgrid = true, maximizedParticipant: maximizedParticipant, floatingParticipant: floatingParticipant, isConstrained: isConstrained = false } = {}) {
    const allClientViews = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$dc94230bce59ebc));
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const numParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$2a789fd8acb91b21));
    const floatingClientView = $eZVvM.useMemo(()=>{
        return floatingParticipant;
    }, [
        floatingParticipant
    ]);
    const clientViewsNotFloating = $eZVvM.useMemo(()=>{
        if (floatingClientView) return allClientViews.filter((c)=>c.id !== floatingClientView.id);
        return allClientViews;
    }, [
        allClientViews,
        floatingClientView
    ]);
    const shouldShowSubgrid = $eZVvM.useMemo(()=>{
        if (!enableSubgrid) return false;
        return forceSubgrid ? true : numParticipants > stageParticipantLimit;
    }, [
        forceSubgrid,
        numParticipants,
        stageParticipantLimit,
        enableSubgrid
    ]);
    const clientViewsInSubgrid = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$calculateSubgridViews({
            clientViews: clientViewsNotFloating,
            activeVideosSubgridTrigger: activeVideosSubgridTrigger,
            shouldShowSubgrid: shouldShowSubgrid,
            spotlightedParticipants: spotlightedParticipants,
            maximizedParticipant: maximizedParticipant,
            isPhoneResolution: isConstrained
        });
    }, [
        clientViewsNotFloating,
        shouldShowSubgrid,
        activeVideosSubgridTrigger,
        spotlightedParticipants,
        isConstrained
    ]);
    const clientViewsOnStage = $eZVvM.useMemo(()=>{
        return clientViewsNotFloating.filter((client)=>!clientViewsInSubgrid.includes(client));
    }, [
        clientViewsNotFloating,
        clientViewsInSubgrid
    ]);
    const clientViewsInPresentationGrid = $eZVvM.useMemo(()=>{
        if (maximizedParticipant) return [
            maximizedParticipant
        ];
        return spotlightedParticipants;
    }, [
        spotlightedParticipants,
        maximizedParticipant
    ]);
    const clientViewsInGrid = $eZVvM.useMemo(()=>{
        return clientViewsOnStage.filter((client)=>!clientViewsInPresentationGrid.includes(client));
    }, [
        clientViewsOnStage,
        clientViewsInPresentationGrid
    ]);
    return {
        floatingClientView: floatingClientView,
        clientViewsInGrid: clientViewsInGrid,
        clientViewsInPresentationGrid: clientViewsInPresentationGrid,
        clientViewsInSubgrid: clientViewsInSubgrid
    };
}
function $de9b795dde6747fa$var$useGrid({ activeVideosSubgridTrigger: activeVideosSubgridTrigger, forceSubgrid: forceSubgrid, stageParticipantLimit: stageParticipantLimit = $de9b795dde6747fa$var$STAGE_PARTICIPANT_LIMIT, gridGap: gridGap = 8, videoGridGap: videoGridGap = 8, enableSubgrid: enableSubgrid = true, enableConstrainedGrid: enableConstrainedGrid = true } = {}) {
    const [containerBounds, setContainerBounds] = $eZVvM.useState({
        width: 0,
        height: 0
    });
    const [isConstrained, setIsConstrained] = $eZVvM.useState(false);
    const [clientAspectRatios, setClientAspectRatios] = $eZVvM.useState({});
    const [maximizedParticipant, setMaximizedParticipant] = $eZVvM.useState(null);
    const [floatingParticipant, setFloatingParticipant] = $eZVvM.useState(null);
    const { clientViewsInGrid: clientViewsInGrid, clientViewsInPresentationGrid: clientViewsInPresentationGrid, clientViewsInSubgrid: clientViewsInSubgrid, floatingClientView: floatingClientView } = $de9b795dde6747fa$var$useGridParticipants({
        activeVideosSubgridTrigger: activeVideosSubgridTrigger,
        forceSubgrid: forceSubgrid,
        stageParticipantLimit: stageParticipantLimit,
        enableSubgrid: enableSubgrid,
        maximizedParticipant: maximizedParticipant,
        floatingParticipant: floatingParticipant,
        isConstrained: !!enableConstrainedGrid && !!isConstrained
    });
    const cellViewsFloating = $eZVvM.useMemo(()=>{
        return floatingClientView ? [
            $de9b795dde6747fa$var$makeVideoCellView({
                client: floatingClientView,
                aspectRatio: clientAspectRatios[floatingClientView.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            })
        ] : [];
    }, [
        floatingClientView,
        clientAspectRatios
    ]);
    const cellViewsVideoGrid = $eZVvM.useMemo(()=>{
        return clientViewsInGrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            });
        });
    }, [
        clientViewsInGrid,
        clientAspectRatios
    ]);
    const cellViewsInPresentationGrid = $eZVvM.useMemo(()=>{
        return clientViewsInPresentationGrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                }
            });
        });
    }, [
        clientViewsInPresentationGrid,
        clientAspectRatios
    ]);
    const cellViewsInSubgrid = $eZVvM.useMemo(()=>{
        return clientViewsInSubgrid.map((client)=>{
            return $de9b795dde6747fa$var$makeVideoCellView({
                client: client,
                aspectRatio: clientAspectRatios[client.id],
                avatarSize: 0,
                cellPaddings: {
                    top: 0,
                    right: 0
                },
                isSubgrid: true
            });
        });
    }, [
        clientViewsInSubgrid,
        clientAspectRatios
    ]);
    const containerFrame = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$makeFrame(containerBounds);
    }, [
        containerBounds
    ]);
    $eZVvM.useEffect(()=>{
        if (!enableConstrainedGrid) return;
        setIsConstrained(containerBounds.width < 500 || containerBounds.height < 500);
    }, [
        containerBounds,
        enableConstrainedGrid
    ]);
    const videoStage = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$calculateLayout({
            floatingVideo: cellViewsFloating[0],
            frame: containerFrame,
            gridGap: gridGap,
            isConstrained: isConstrained,
            roomBounds: containerFrame.bounds,
            videos: cellViewsVideoGrid,
            videoGridGap: videoGridGap,
            presentationVideos: cellViewsInPresentationGrid,
            subgridVideos: cellViewsInSubgrid
        });
    }, [
        containerFrame,
        cellViewsFloating,
        cellViewsVideoGrid,
        cellViewsInPresentationGrid,
        cellViewsInSubgrid,
        gridGap,
        videoGridGap
    ]);
    return {
        containerFrame: containerFrame,
        cellViewsFloating: cellViewsFloating,
        cellViewsVideoGrid: cellViewsVideoGrid,
        cellViewsInPresentationGrid: cellViewsInPresentationGrid,
        cellViewsInSubgrid: cellViewsInSubgrid,
        clientAspectRatios: clientAspectRatios,
        videoStage: videoStage,
        setContainerBounds: setContainerBounds,
        setClientAspectRatios: setClientAspectRatios,
        maximizedParticipant: maximizedParticipant,
        setMaximizedParticipant: setMaximizedParticipant,
        floatingParticipant: floatingParticipant,
        setFloatingParticipant: setFloatingParticipant,
        isConstrained: isConstrained
    };
}
const $de9b795dde6747fa$var$getInitialsFromName = (name = "")=>{
    name = name.trim();
    if (name) {
        const initials = name.split(/-| /).map((n)=>(0, (/*@__PURE__*/$parcel$interopDefault($72a1b7fe1c0aa35a$exports)))(n)[0]);
        return initials.slice(0, 3);
    }
    return [];
};
const $de9b795dde6747fa$var$Initials = ({ name: name })=>{
    const initials = $de9b795dde6747fa$var$getInitialsFromName(name);
    const fontSize = [
        0,
        56,
        48,
        40
    ][initials.length] || 32;
    const initialsStr = initials.join("").toUpperCase();
    return $eZVvM.createElement("svg", {
        viewBox: "-60 -60 120 120",
        "aria-hidden": "true",
        style: {
            height: "100%",
            pointerEvents: "none",
            width: "100%"
        }
    }, $eZVvM.createElement("text", {
        x: 0,
        y: 0,
        textAnchor: "middle",
        dominantBaseline: "central",
        fontSize: fontSize
    }, initialsStr));
};
function $de9b795dde6747fa$var$Avatar(_a) {
    var { avatarUrl: avatarUrl, className: className, size: size = 40, name: name, variant: variant = "round" } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "avatarUrl",
        "className",
        "size",
        "name",
        "variant"
    ]);
    return $eZVvM.createElement("div", Object.assign({
        style: {
            height: `${size}px`,
            width: `${size}px`,
            userSelect: "none",
            overflow: "hidden",
            borderRadius: variant === "round" ? "50%" : "4px",
            backgroundColor: "#f8e3c8"
        },
        className: className,
        title: name
    }, rest), !avatarUrl && name ? $eZVvM.createElement($de9b795dde6747fa$var$Initials, {
        name: name
    }) : $eZVvM.createElement("img", {
        src: avatarUrl || "",
        alt: "",
        style: {
            height: "100%",
            width: "100%",
            objectFit: "cover",
            maxWidth: "initial"
        }
    }));
}
function $de9b795dde6747fa$var$VideoMutedIndicator({ avatarUrl: avatarUrl, displayName: displayName, isSmallCell: isSmallCell, withRoundedCorners: withRoundedCorners }) {
    return $eZVvM.createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            borderRadius: withRoundedCorners ? "8px" : "0"
        }
    }, $eZVvM.createElement("div", {
        style: {
            height: isSmallCell ? 60 : 80,
            width: isSmallCell ? 60 : 80,
            pointerEvents: "none",
            position: "relative"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$Avatar, {
        variant: "square",
        avatarUrl: avatarUrl,
        name: displayName,
        size: isSmallCell ? 60 : 80
    })));
}
const $de9b795dde6747fa$var$Popover = $d30790ce46109715$export$be92b6f5f03c0fe9;
const $de9b795dde6747fa$var$PopoverTrigger = $d30790ce46109715$export$41fb9f06171c75f4;
const $de9b795dde6747fa$var$PopoverContent = $eZVvM.forwardRef((_a, ref)=>{
    var { style: style, align: align = "center", sideOffset: sideOffset = 4 } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "style",
        "align",
        "sideOffset"
    ]);
    return $eZVvM.createElement($d30790ce46109715$export$602eac185826482c, null, $eZVvM.createElement($d30790ce46109715$export$7c6e2c02157bb7d2, Object.assign({
        ref: ref,
        align: align,
        sideOffset: sideOffset,
        style: Object.assign({
            width: "200px",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "0.375rem",
            boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
            color: "#333",
            fontSize: "14px",
            lineHeight: "1.5",
            padding: "16px",
            zIndex: 50,
            outline: "none"
        }, style)
    }, props)));
});
$de9b795dde6747fa$var$PopoverContent.displayName = $d30790ce46109715$export$7c6e2c02157bb7d2.displayName;
const $de9b795dde6747fa$var$GridContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$GridCellContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$useGridCell = ()=>{
    const gridContext = $eZVvM.useContext($de9b795dde6747fa$var$GridContext);
    const gridCellContext = $eZVvM.useContext($de9b795dde6747fa$var$GridCellContext);
    if (!gridCellContext) throw new Error("useGridCell must be used within a GridCell");
    return Object.assign(Object.assign({}, gridContext), gridCellContext);
};
const $de9b795dde6747fa$var$ParticipantMenuContext = $eZVvM.createContext({});
const $de9b795dde6747fa$var$useParticipantMenu = ()=>{
    const context = $eZVvM.useContext($de9b795dde6747fa$var$ParticipantMenuContext);
    const gridCellContext = $de9b795dde6747fa$var$useGridCell();
    if (!context) throw new Error("useParticipantMenu must be used within a ParticipantMenu");
    return Object.assign(Object.assign({}, context), gridCellContext);
};
const $de9b795dde6747fa$export$5e4296a99c887f6d = (props)=>{
    const { children: children } = props, rest = $de9b795dde6747fa$var$__rest(props, [
        "children"
    ]);
    const [open, setOpen] = $eZVvM.useState(false);
    return $eZVvM.createElement($de9b795dde6747fa$var$ParticipantMenuContext.Provider, {
        value: {
            open: open,
            setOpen: setOpen
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$Popover, Object.assign({}, rest, {
        open: open,
        onOpenChange: setOpen
    }), children));
};
const $de9b795dde6747fa$export$b1dac2119cac8cb2 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style"
    ]);
    return $eZVvM.createElement($de9b795dde6747fa$var$PopoverContent, Object.assign({
        ref: ref,
        style: Object.assign({
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "180px",
            maxWidth: "300px",
            maxHeight: "100vh",
            overflowY: "auto",
            padding: 0
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$b1dac2119cac8cb2.displayName = "ParticipantMenuContent";
const $de9b795dde6747fa$export$f6ea8009f49c9769 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style"
    ]);
    return $eZVvM.createElement($de9b795dde6747fa$var$PopoverTrigger, Object.assign({
        ref: ref,
        style: Object.assign({
            position: "absolute",
            top: "10px",
            right: "20px",
            textDecoration: "none",
            whiteSpace: "nowrap",
            border: "none",
            cursor: "pointer"
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$f6ea8009f49c9769.displayName = $de9b795dde6747fa$var$PopoverTrigger.displayName;
const $de9b795dde6747fa$export$2296c43061a9fca3 = $eZVvM.forwardRef((_a, ref)=>{
    var { children: children, style: style, participantAction: participantAction } = _a, props = $de9b795dde6747fa$var$__rest(_a, [
        "children",
        "style",
        "participantAction"
    ]);
    const { participant: participant, setOpen: setOpen, maximizedParticipant: maximizedParticipant, setMaximizedParticipant: setMaximizedParticipant, setFloatingParticipant: setFloatingParticipant, floatingParticipant: floatingParticipant } = $de9b795dde6747fa$var$useParticipantMenu();
    const dispatch = $de9b795dde6747fa$var$useAppDispatch();
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const isSpotlighted = spotlightedParticipants.find((p)=>p.id === participant.id);
    const isMaximized = (maximizedParticipant === null || maximizedParticipant === void 0 ? void 0 : maximizedParticipant.id) === participant.id;
    const isFloating = (floatingParticipant === null || floatingParticipant === void 0 ? void 0 : floatingParticipant.id) === participant.id;
    let onClick;
    switch(participantAction){
        case "maximize":
            onClick = ()=>{
                if (isMaximized) setMaximizedParticipant(null);
                else setMaximizedParticipant(participant);
                setOpen(false);
            };
            break;
        case "spotlight":
            onClick = ()=>{
                if (isSpotlighted) dispatch((0, $4fc09928452de42f$export$65b4309b6edd4ad1)({
                    id: participant.id
                }));
                else dispatch((0, $4fc09928452de42f$export$4bf19d94733cc82e)({
                    id: participant.id
                }));
                setOpen(false);
            };
            break;
        case "float":
            onClick = ()=>{
                if (isFloating) setFloatingParticipant(null);
                else setFloatingParticipant(participant);
                setOpen(false);
            };
            break;
    }
    return $eZVvM.createElement("button", Object.assign({
        ref: ref,
        role: "menuitem",
        tabIndex: -1,
        onClick: onClick !== null && onClick !== void 0 ? onClick : props.onClick,
        style: Object.assign({
            alignItems: "stretch",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            height: "40px",
            lineHeight: "40px",
            minWidth: "140px",
            padding: "0 12px",
            textAlign: "left",
            textDecoration: "none",
            whiteSpace: "nowrap",
            width: "100%"
        }, style)
    }, props), children);
});
$de9b795dde6747fa$export$2296c43061a9fca3.displayName = "ParticipantMenuItem";
function $de9b795dde6747fa$var$EllipsisIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("g", null, $eZVvM.createElement("circle", {
        cx: "6",
        cy: "12",
        r: "2"
    }), $eZVvM.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), $eZVvM.createElement("circle", {
        cx: "18",
        cy: "12",
        r: "2"
    })));
}
function $de9b795dde6747fa$var$MaximizeOnIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13.875 3c0 .62132.5037 1.125 1.125 1.125h3.284l-4.0795 4.0795c-.4393.43934-.4393 1.15166 0 1.591.4393.4393 1.1517.4393 1.591 0l4.0795-4.07951v3.28401c0 .62132.5037 1.125 1.125 1.125s1.125-.50368 1.125-1.125v-6c0-.15254-.0304-.29799-.0854-.43063-.0536-.12968-.1326-.25135-.2368-.35749l-.0147-.01469c-.203-.19928-.4812-.32219-.7881-.32219h-6c-.6213 0-1.125.50368-1.125 1.125zm-9.75 12c0-.6213-.50368-1.125-1.125-1.125s-1.125.5037-1.125 1.125v6c0 .3069.12291.5851.32219.7881.00486.005.00975.0099.01469.0147.10614.1042.22781.1832.35749.2368.13264.055.27809.0854.43063.0854h6c.62132 0 1.125-.5037 1.125-1.125s-.50368-1.125-1.125-1.125h-3.28401l4.07951-4.0795c.4393-.4393.4393-1.1517 0-1.591-.43934-.4393-1.15166-.4393-1.591 0l-4.0795 4.0795z"
    }));
}
function $de9b795dde6747fa$var$SpotlightIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m15.241.146691c-.1011-.1955882-.3809-.1955879-.482 0l-1.1063 2.139639c-.0258.04991-.0665.09058-.1164.11639l-2.1396 1.10629c-.1956.10113-.1956.38085 0 .48198l2.1396 1.10629c.0499.02581.0906.06648.1164.11639l1.1063 2.13964c.1011.19559.3809.19559.482 0l1.1063-2.13964c.0258-.04991.0665-.09058.1164-.11639l2.1396-1.10629c.1956-.10113.1956-.38085 0-.48198l-2.1396-1.10629c-.0499-.02581-.0906-.06648-.1164-.11639zm-13.741 2.900259v14.67495c0 .0511.00116.1018.00345.1523-.00229.0418-.00345.0837-.00345.1258 0 .5674.21005 1.1103.59339 1.6103.24265.3472.55042.6455.90566.8773 1.61225 1.213 4.36988 2.0124 7.50095 2.0124 4.3315 0 7.9484-1.53 8.8068-3.5681.0651-.1472.1148-.3024.1455-.4658.0315-.1532.0477-.3087.0477-.4661 0-.6032-.2374-1.1788-.668-1.7045-.1377-.1975-.2995-.4017-.4877-.6127l-14.22219-13.74809c-.28845-.27884-.67396-.43471-1.07516-.43471-.85436 0-1.54695.69259-1.54695 1.54695zm19.2646 4.59631c.0988-.19101.372-.19101.4708 0l.8546 1.65303c.0253.04874.065.08846.1137.11366l1.653.85465c.1911.0988.1911.372 0 .4708l-1.653.8546c-.0487.0253-.0884.065-.1137.1137l-.8546 1.653c-.0988.1911-.372.1911-.4708 0l-.8546-1.653c-.0253-.0487-.065-.0884-.1137-.1137l-1.653-.8546c-.1911-.0988-.1911-.372 0-.4708l1.653-.85465c.0487-.0252.0884-.06492.1137-.11366zm-3.2651 10.35684c0 .0769-.1144.6851-1.5305 1.3931-1.2964.6482-3.2274 1.1069-5.4695 1.1069s-4.17308-.4587-5.46952-1.1069c-1.41607-.708-1.53047-1.3162-1.53047-1.3931 0-.077.1144-.6851 1.53047-1.3932 1.29644-.6482 3.22742-1.1068 5.46952-1.1068s4.1731.4586 5.4695 1.1068c1.4161.7081 1.5305 1.3162 1.5305 1.3932z"
    }));
}
function $de9b795dde6747fa$var$PopOutIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        clipRule: "evenodd",
        fillRule: "evenodd",
        d: "m2.25 3v4.5c0 .41421.33579.75.75.75h4.5c.41421 0 .75-.33579.75-.75v-4.5c0-.41421-.33579-.75-.75-.75h-4.5c-.41421 0-.75.33579-.75.75zm-2.25 4.5v-4.5c0-1.65685 1.34315-3 3-3h4.5c1.65685 0 3 1.34315 3 3v4.5c0 1.65685-1.34315 3-3 3h-4.5c-1.65685 0-3-1.34315-3-3zm2.25 9v4.5c0 .4142.33579.75.75.75h4.5c.41421 0 .75-.3358.75-.75v-4.5c0-.4142-.33579-.75-.75-.75h-4.5c-.41421 0-.75.3358-.75.75zm-2.25 4.5v-4.5c0-1.6569 1.34315-3 3-3h4.5c1.65685 0 3 1.3431 3 3v4.5c0 1.6569-1.34315 3-3 3h-4.5c-1.65685 0-3-1.3431-3-3zm15.75-13.5v-4.5c0-.41421.3358-.75.75-.75h4.5c.4142 0 .75.33579.75.75v4.5c0 .41421-.3358.75-.75.75h-4.5c-.4142 0-.75-.33579-.75-.75zm-2.25-4.5v4.5c0 1.65685 1.3431 3 3 3h4.5c1.6569 0 3-1.34315 3-3v-4.5c0-1.65685-1.3431-3-3-3h-4.5c-1.6569 0-3 1.34315-3 3zm1.875 19.5c0-.6213.5037-1.125 1.125-1.125h3.284l-5.5795-5.5795c-.4393-.4393-.4393-1.1517 0-1.591s1.1517-.4393 1.591 0l5.5795 5.5795v-3.284c0-.6213.5037-1.125 1.125-1.125s1.125.5037 1.125 1.125v6c0 .308-.1238.5872-.3244.7903-.0033.0034-.0067.0068-.0101.0102-.1067.1054-.2292.1851-.3599.2391-.1326.055-.2781.0854-.4306.0854h-6c-.6213 0-1.125-.5037-1.125-1.125z"
    }));
}
function $de9b795dde6747fa$var$PopInIcon(props) {
    return $eZVvM.createElement("svg", Object.assign({
        width: "100%",
        height: "100%",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), $eZVvM.createElement("path", {
        clipRule: "evenodd",
        fillRule: "evenodd",
        d: "m2.25 3v4.5c0 .41421.33579.75.75.75h4.5c.41421 0 .75-.33579.75-.75v-4.5c0-.41421-.33579-.75-.75-.75h-4.5c-.41421 0-.75.33579-.75.75zm-2.25 4.5v-4.5c0-1.65685 1.34315-3 3-3h4.5c1.65685 0 3 1.34315 3 3v4.5c0 1.65685-1.34315 3-3 3h-4.5c-1.65685 0-3-1.34315-3-3zm2.25 9v4.5c0 .4142.33579.75.75.75h4.5c.41421 0 .75-.3358.75-.75v-4.5c0-.4142-.33579-.75-.75-.75h-4.5c-.41421 0-.75.3358-.75.75zm-2.25 4.5v-4.5c0-1.6569 1.34315-3 3-3h4.5c1.65685 0 3 1.3431 3 3v4.5c0 1.6569-1.34315 3-3 3h-4.5c-1.65685 0-3-1.3431-3-3zm15.75-13.5v-4.5c0-.41421.3358-.75.75-.75h4.5c.4142 0 .75.33579.75.75v4.5c0 .41421-.3358.75-.75.75h-4.5c-.4142 0-.75-.33579-.75-.75zm-2.25-4.5v4.5c0 1.65685 1.3431 3 3 3h4.5c1.6569 0 3-1.34315 3-3v-4.5c0-1.65685-1.3431-3-3-3h-4.5c-1.6569 0-3 1.34315-3 3zm8.625 12c0 .6213-.5037 1.125-1.125 1.125h-3.284l5.5795 5.5795c.4393.4393.4393 1.1517 0 1.591s-1.1517.4393-1.591 0l-5.5795-5.5795v3.284c0 .6213-.5037 1.125-1.125 1.125s-1.125-.5037-1.125-1.125v-6c0-.3081.1238-.5872.3244-.7904.0034-.0034.0068-.0068.0102-.0102.1067-.1053.2292-.185.3598-.239.1326-.055.2781-.0854.4306-.0854h6c.6213 0 1.125.5037 1.125 1.125z"
    }));
}
function $de9b795dde6747fa$var$DefaultParticipantMenu({ participant: participant }) {
    const spotlightedParticipants = $de9b795dde6747fa$var$useAppSelector((0, $4fc09928452de42f$export$622ce0f62fa78bbc));
    const isSpotlighted = spotlightedParticipants.find((p)=>p.id === participant.id);
    const { isHovered: isHovered, maximizedParticipant: maximizedParticipant, floatingParticipant: floatingParticipant } = $de9b795dde6747fa$var$useGridCell();
    const isMaximized = (maximizedParticipant === null || maximizedParticipant === void 0 ? void 0 : maximizedParticipant.id) === participant.id;
    const isFloating = (floatingParticipant === null || floatingParticipant === void 0 ? void 0 : floatingParticipant.id) === participant.id;
    if (!isHovered) return null;
    return $eZVvM.createElement($de9b795dde6747fa$export$5e4296a99c887f6d, null, $eZVvM.createElement($de9b795dde6747fa$export$f6ea8009f49c9769, {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: "6px",
            padding: "4px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$EllipsisIcon, {
        height: 20,
        width: 20,
        transform: "rotate(90)"
    })), $eZVvM.createElement($de9b795dde6747fa$export$b1dac2119cac8cb2, null, participant.isLocalClient ? $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "float",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, isFloating ? $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$var$PopInIcon, {
        height: 16,
        width: 16
    }), "Move to grid") : $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$var$PopOutIcon, {
        height: 16,
        width: 16
    }), "Pop out")) : null, $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "maximize",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$MaximizeOnIcon, {
        height: 16,
        width: 16
    }), isMaximized ? "Minimize" : "Maximize"), $eZVvM.createElement($de9b795dde6747fa$export$2296c43061a9fca3, {
        participantAction: "spotlight",
        style: {
            display: "flex",
            alignItems: "center",
            gap: "10px"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$SpotlightIcon, {
        height: 16,
        width: 16
    }), isSpotlighted ? "Remove spotlight" : "Spotlight")));
}
const $de9b795dde6747fa$export$1ce951ee41d30605 = $eZVvM.forwardRef(({ className: className, participant: participant, children: children }, ref)=>{
    const [isHovered, setIsHovered] = $eZVvM.useState(false);
    const handleMouseEnter = $eZVvM.useCallback(()=>{
        setIsHovered(true);
    }, []);
    const handleMouseLeave = $eZVvM.useCallback(()=>{
        setIsHovered(false);
    }, []);
    return $eZVvM.createElement($de9b795dde6747fa$var$GridCellContext.Provider, {
        value: {
            participant: participant,
            isHovered: isHovered
        }
    }, $eZVvM.createElement("div", {
        ref: ref,
        className: className,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        style: {
            height: "100%",
            width: "100%"
        }
    }, children));
});
$de9b795dde6747fa$export$1ce951ee41d30605.displayName = "GridCell";
const $de9b795dde6747fa$export$db6594055fbff7ab = $eZVvM.forwardRef((_a, ref)=>{
    var { stream: stream, style: style } = _a, rest = $de9b795dde6747fa$var$__rest(_a, [
        "stream",
        "style"
    ]);
    const videoEl = $eZVvM.useRef(null);
    const { onSetClientAspectRatio: onSetClientAspectRatio, clientAspectRatios: clientAspectRatios, participant: participant, isConstrained: isConstrained } = $de9b795dde6747fa$var$useGridCell();
    if (!participant) return null;
    const aspectRatio = clientAspectRatios[participant.id];
    $eZVvM.useImperativeHandle(ref, ()=>{
        return videoEl.current;
    });
    const handleResize = $eZVvM.useCallback(()=>{
        const ar = videoEl.current && videoEl.current.captureAspectRatio();
        if (ar && ar !== aspectRatio && participant.id) onSetClientAspectRatio({
            aspectRatio: ar,
            clientId: participant.id
        });
    }, [
        clientAspectRatios,
        participant.id,
        onSetClientAspectRatio
    ]);
    const s = stream || participant.stream;
    if (!s) return null;
    return $eZVvM.createElement($de9b795dde6747fa$export$5da49f1f3cbe3742, Object.assign({
        ref: videoEl,
        style: Object.assign(Object.assign({
            borderRadius: isConstrained ? 0 : "8px"
        }, isConstrained ? {
            objectFit: "cover"
        } : {}), style)
    }, rest, {
        stream: s,
        onVideoResize: handleResize
    }));
});
$de9b795dde6747fa$export$db6594055fbff7ab.displayName = "GridVideoView";
function $de9b795dde6747fa$var$renderCellView({ cellView: cellView, enableParticipantMenu: enableParticipantMenu, render: render }) {
    const participant = cellView === null || cellView === void 0 ? void 0 : cellView.client;
    if (!participant) return undefined;
    switch(cellView.type){
        case "video":
            return $eZVvM.createElement($de9b795dde6747fa$export$1ce951ee41d30605, {
                participant: participant
            }, participant.isVideoEnabled ? $eZVvM.createElement($eZVvM.Fragment, null, render ? render({
                participant: participant
            }) : $eZVvM.createElement($eZVvM.Fragment, null, $eZVvM.createElement($de9b795dde6747fa$export$db6594055fbff7ab, null), enableParticipantMenu ? $eZVvM.createElement($de9b795dde6747fa$var$DefaultParticipantMenu, {
                participant: participant
            }) : null)) : $eZVvM.createElement($de9b795dde6747fa$var$VideoMutedIndicator, {
                isSmallCell: false,
                displayName: (participant === null || participant === void 0 ? void 0 : participant.displayName) || "Guest",
                withRoundedCorners: true
            }));
    }
}
function $de9b795dde6747fa$export$9ca22f48fddba890({ renderParticipant: renderParticipant, renderFloatingParticipant: renderFloatingParticipant, stageParticipantLimit: stageParticipantLimit, gridGap: gridGap, videoGridGap: videoGridGap, enableSubgrid: enableSubgrid, enableParticipantMenu: enableParticipantMenu, enableConstrainedGrid: enableConstrainedGrid }) {
    const gridRef = $eZVvM.useRef(null);
    const { containerFrame: containerFrame, cellViewsFloating: cellViewsFloating, cellViewsVideoGrid: cellViewsVideoGrid, cellViewsInPresentationGrid: cellViewsInPresentationGrid, cellViewsInSubgrid: cellViewsInSubgrid, clientAspectRatios: clientAspectRatios, videoStage: videoStage, setContainerBounds: setContainerBounds, setClientAspectRatios: setClientAspectRatios, maximizedParticipant: maximizedParticipant, setMaximizedParticipant: setMaximizedParticipant, isConstrained: isConstrained, floatingParticipant: floatingParticipant, setFloatingParticipant: setFloatingParticipant } = $de9b795dde6747fa$var$useGrid({
        activeVideosSubgridTrigger: 12,
        stageParticipantLimit: stageParticipantLimit,
        gridGap: gridGap,
        videoGridGap: videoGridGap,
        enableSubgrid: enableSubgrid,
        enableConstrainedGrid: enableConstrainedGrid
    });
    const handleSetClientAspectRatio = $eZVvM.useCallback(({ aspectRatio: aspectRatio, clientId: clientId })=>{
        setClientAspectRatios((prev)=>Object.assign(Object.assign({}, prev), {
                [clientId]: aspectRatio
            }));
    }, [
        setClientAspectRatios
    ]);
    const floatingContent = $eZVvM.useMemo(()=>{
        return $de9b795dde6747fa$var$renderCellView(Object.assign({
            cellView: cellViewsFloating[0],
            enableParticipantMenu: enableParticipantMenu
        }, renderFloatingParticipant ? {
            render: ({ participant: participant })=>renderFloatingParticipant({
                    participant: participant
                })
        } : {}));
    }, [
        cellViewsFloating
    ]);
    const presentationGridContent = $eZVvM.useMemo(()=>cellViewsInPresentationGrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView(Object.assign({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            }, renderParticipant ? {
                render: ({ participant: participant })=>renderParticipant({
                        participant: participant
                    })
            } : {}))), [
        cellViewsInPresentationGrid
    ]);
    const gridContent = $eZVvM.useMemo(()=>cellViewsVideoGrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView(Object.assign({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            }, renderParticipant ? {
                render: ({ participant: participant })=>renderParticipant({
                        participant: participant
                    })
            } : {}))), [
        cellViewsVideoGrid
    ]);
    const subgridContent = $eZVvM.useMemo(()=>cellViewsInSubgrid.map((cellView)=>$de9b795dde6747fa$var$renderCellView({
                cellView: cellView,
                enableParticipantMenu: enableParticipantMenu
            })), [
        cellViewsInSubgrid
    ]);
    $eZVvM.useEffect(()=>{
        if (!gridRef.current) return;
        const resizeObserver = new ResizeObserver((0, $4fc09928452de42f$export$61fc7d43ac8f84b0)(()=>{
            var _a, _b, _c, _d;
            setContainerBounds({
                width: (_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 640,
                height: (_d = (_c = gridRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight) !== null && _d !== void 0 ? _d : 480
            });
        }, {
            delay: 60,
            edges: false
        }));
        resizeObserver.observe(gridRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return $eZVvM.createElement($de9b795dde6747fa$var$GridContext.Provider, {
        value: {
            onSetClientAspectRatio: handleSetClientAspectRatio,
            cellViewsVideoGrid: cellViewsVideoGrid,
            cellViewsInPresentationGrid: cellViewsInPresentationGrid,
            cellViewsInSubgrid: cellViewsInSubgrid,
            clientAspectRatios: clientAspectRatios,
            maximizedParticipant: maximizedParticipant,
            setMaximizedParticipant: setMaximizedParticipant,
            floatingParticipant: floatingParticipant,
            setFloatingParticipant: setFloatingParticipant,
            isConstrained: isConstrained
        }
    }, $eZVvM.createElement("div", {
        ref: gridRef,
        style: {
            width: "100%",
            height: "100%",
            position: "relative"
        }
    }, $eZVvM.createElement($de9b795dde6747fa$var$VideoStageLayout, {
        containerFrame: containerFrame,
        floatingContent: floatingContent,
        layoutVideoStage: videoStage,
        presentationGridContent: presentationGridContent,
        gridContent: gridContent,
        subgridContent: subgridContent
    })));
}



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

function $15676348d56fc1ae$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $15676348d56fc1ae$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $15676348d56fc1ae$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $15676348d56fc1ae$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15676348d56fc1ae$export$2e2bcd8739ae039 = $15676348d56fc1ae$export$4f5d2d50c9deca37;



var $ivlTt = parcelRequire("ivlTt");

var $bU7jb = parcelRequire("bU7jb");
function $71137bcc41c0338b$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}



var $44b60eacf0f66ef8$exports = {};
"use strict";
var $947ef6bede0b1763$exports = {};
function $947ef6bede0b1763$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$947ef6bede0b1763$exports = $947ef6bede0b1763$var$_interopRequireDefault, $947ef6bede0b1763$exports.__esModule = true, $947ef6bede0b1763$exports["default"] = $947ef6bede0b1763$exports;


Object.defineProperty($44b60eacf0f66ef8$exports, "__esModule", {
    value: true
});
$44b60eacf0f66ef8$exports.default = $44b60eacf0f66ef8$var$createStyled;
$44b60eacf0f66ef8$exports.shouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp;
$44b60eacf0f66ef8$exports.systemDefaultTheme = void 0;

var $44b60eacf0f66ef8$var$_extends2 = $947ef6bede0b1763$exports((parcelRequire("frncS")));

var $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2 = $947ef6bede0b1763$exports((parcelRequire("37KYO")));

var $44b60eacf0f66ef8$var$_styledEngine = $44b60eacf0f66ef8$var$_interopRequireWildcard((parcelRequire("cgitS")));

var $hWP8m = parcelRequire("hWP8m");

var $44b60eacf0f66ef8$var$_capitalize = $947ef6bede0b1763$exports((parcelRequire("booPO")));

var $44b60eacf0f66ef8$var$_getDisplayName = $947ef6bede0b1763$exports((parcelRequire("iH2bF")));

var $44b60eacf0f66ef8$var$_createTheme = $947ef6bede0b1763$exports((parcelRequire("lEj5y")));

var $44b60eacf0f66ef8$var$_styleFunctionSx = $947ef6bede0b1763$exports((parcelRequire("k2gEs")));
const $44b60eacf0f66ef8$var$_excluded = [
    "ownerState"
], $44b60eacf0f66ef8$var$_excluded2 = [
    "variants"
], $44b60eacf0f66ef8$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $44b60eacf0f66ef8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($44b60eacf0f66ef8$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $44b60eacf0f66ef8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $44b60eacf0f66ef8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $44b60eacf0f66ef8$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $44b60eacf0f66ef8$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $44b60eacf0f66ef8$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $44b60eacf0f66ef8$var$systemDefaultTheme = $44b60eacf0f66ef8$exports.systemDefaultTheme = (0, $44b60eacf0f66ef8$var$_createTheme.default)();
const $44b60eacf0f66ef8$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $44b60eacf0f66ef8$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $44b60eacf0f66ef8$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $44b60eacf0f66ef8$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $44b60eacf0f66ef8$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(_ref, $44b60eacf0f66ef8$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $44b60eacf0f66ef8$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$44b60eacf0f66ef8$var$processStyleArg(resolvedStyle, (0, $44b60eacf0f66ef8$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $44b60eacf0f66ef8$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $44b60eacf0f66ef8$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $44b60eacf0f66ef8$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $44b60eacf0f66ef8$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $44b60eacf0f66ef8$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $44b60eacf0f66ef8$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $44b60eacf0f66ef8$var$_styleFunctionSx.default)((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
            theme: $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $44b60eacf0f66ef8$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $44b60eacf0f66ef8$var$defaultOverridesResolver($44b60eacf0f66ef8$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $44b60eacf0f66ef8$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $44b60eacf0f66ef8$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $44b60eacf0f66ef8$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($44b60eacf0f66ef8$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $44b60eacf0f66ef8$var$_styledEngine.default)(tag, (0, $44b60eacf0f66ef8$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $hWP8m.isPlainObject)(stylesArg)) return (props)=>$44b60eacf0f66ef8$var$processStyleArg(stylesArg, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    theme: $44b60eacf0f66ef8$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $44b60eacf0f66ef8$var$processStyleArg(slotStyle, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $44b60eacf0f66ef8$var$resolveTheme((0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $44b60eacf0f66ef8$var$processStyleArg({
                    variants: themeVariants
                }, (0, $44b60eacf0f66ef8$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $hWP8m = parcelRequire("hWP8m");

var $34Ozv = parcelRequire("34Ozv");
var $jHIoy = parcelRequire("jHIoy");

var $gnWEo = parcelRequire("gnWEo");


var $65o8X = parcelRequire("65o8X");
function $de12fbfe653fcf7a$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $65o8X.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $hWP8m = parcelRequire("hWP8m");
var $6ae574cb2ebbc3ad$exports = {};
"use strict";

Object.defineProperty($6ae574cb2ebbc3ad$exports, "__esModule", {
    value: true
});
$6ae574cb2ebbc3ad$exports.alpha = $6ae574cb2ebbc3ad$var$alpha;
$6ae574cb2ebbc3ad$exports.blend = $6ae574cb2ebbc3ad$var$blend;
$6ae574cb2ebbc3ad$exports.colorChannel = void 0;
$6ae574cb2ebbc3ad$exports.darken = $6ae574cb2ebbc3ad$var$darken;
$6ae574cb2ebbc3ad$exports.decomposeColor = $6ae574cb2ebbc3ad$var$decomposeColor;
$6ae574cb2ebbc3ad$exports.emphasize = $6ae574cb2ebbc3ad$var$emphasize;
$6ae574cb2ebbc3ad$exports.getContrastRatio = $6ae574cb2ebbc3ad$var$getContrastRatio;
$6ae574cb2ebbc3ad$exports.getLuminance = $6ae574cb2ebbc3ad$var$getLuminance;
$6ae574cb2ebbc3ad$exports.hexToRgb = $6ae574cb2ebbc3ad$var$hexToRgb;
$6ae574cb2ebbc3ad$exports.hslToRgb = $6ae574cb2ebbc3ad$var$hslToRgb;
$6ae574cb2ebbc3ad$exports.lighten = $6ae574cb2ebbc3ad$var$lighten;
$6ae574cb2ebbc3ad$exports.private_safeAlpha = $6ae574cb2ebbc3ad$var$private_safeAlpha;
$6ae574cb2ebbc3ad$exports.private_safeColorChannel = void 0;
$6ae574cb2ebbc3ad$exports.private_safeDarken = $6ae574cb2ebbc3ad$var$private_safeDarken;
$6ae574cb2ebbc3ad$exports.private_safeEmphasize = $6ae574cb2ebbc3ad$var$private_safeEmphasize;
$6ae574cb2ebbc3ad$exports.private_safeLighten = $6ae574cb2ebbc3ad$var$private_safeLighten;
$6ae574cb2ebbc3ad$exports.recomposeColor = $6ae574cb2ebbc3ad$var$recomposeColor;
$6ae574cb2ebbc3ad$exports.rgbToHex = $6ae574cb2ebbc3ad$var$rgbToHex;

var $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2 = $947ef6bede0b1763$exports((parcelRequire("1yFU7")));

var $6ae574cb2ebbc3ad$var$_clamp = $947ef6bede0b1763$exports((parcelRequire("6Gv37")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $6ae574cb2ebbc3ad$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $6ae574cb2ebbc3ad$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $6ae574cb2ebbc3ad$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $6ae574cb2ebbc3ad$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $6ae574cb2ebbc3ad$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $6ae574cb2ebbc3ad$var$decomposeColor($6ae574cb2ebbc3ad$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $6ae574cb2ebbc3ad$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $6ae574cb2ebbc3ad$var$colorChannel = (color)=>{
    const decomposedColor = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
$6ae574cb2ebbc3ad$exports.colorChannel = $6ae574cb2ebbc3ad$var$colorChannel;
const $6ae574cb2ebbc3ad$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $6ae574cb2ebbc3ad$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $6ae574cb2ebbc3ad$exports.private_safeColorChannel = $6ae574cb2ebbc3ad$var$private_safeColorChannel;
function $6ae574cb2ebbc3ad$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $6ae574cb2ebbc3ad$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    return `#${values.map((n, i)=>$6ae574cb2ebbc3ad$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $6ae574cb2ebbc3ad$var$hslToRgb(color) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $6ae574cb2ebbc3ad$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $6ae574cb2ebbc3ad$var$getLuminance(color) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $6ae574cb2ebbc3ad$var$decomposeColor($6ae574cb2ebbc3ad$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $6ae574cb2ebbc3ad$var$getContrastRatio(foreground, background) {
    const lumA = $6ae574cb2ebbc3ad$var$getLuminance(foreground);
    const lumB = $6ae574cb2ebbc3ad$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$alpha(color, value) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    value = $6ae574cb2ebbc3ad$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeAlpha(color, value, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$darken(color, coefficient) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    coefficient = $6ae574cb2ebbc3ad$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$lighten(color, coefficient) {
    color = $6ae574cb2ebbc3ad$var$decomposeColor(color);
    coefficient = $6ae574cb2ebbc3ad$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $6ae574cb2ebbc3ad$var$recomposeColor(color);
}
function $6ae574cb2ebbc3ad$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $6ae574cb2ebbc3ad$var$emphasize(color, coefficient = 0.15) {
    return $6ae574cb2ebbc3ad$var$getLuminance(color) > 0.5 ? $6ae574cb2ebbc3ad$var$darken(color, coefficient) : $6ae574cb2ebbc3ad$var$lighten(color, coefficient);
}
function $6ae574cb2ebbc3ad$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $6ae574cb2ebbc3ad$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $6ae574cb2ebbc3ad$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $6ae574cb2ebbc3ad$var$decomposeColor(background);
    const overlayColor = $6ae574cb2ebbc3ad$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $6ae574cb2ebbc3ad$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}


const $acc6457e87554c52$var$common = {
    black: "#000",
    white: "#fff"
};
var $acc6457e87554c52$export$2e2bcd8739ae039 = $acc6457e87554c52$var$common;


const $1f6b80255be92d2b$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $1f6b80255be92d2b$export$2e2bcd8739ae039 = $1f6b80255be92d2b$var$grey;


const $1aee4d22735d5325$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $1aee4d22735d5325$export$2e2bcd8739ae039 = $1aee4d22735d5325$var$purple;


const $992de574f1606f4a$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $992de574f1606f4a$export$2e2bcd8739ae039 = $992de574f1606f4a$var$red;


const $e24ba6338a2f77c2$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $e24ba6338a2f77c2$export$2e2bcd8739ae039 = $e24ba6338a2f77c2$var$orange;


const $379600ba82adc55b$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $379600ba82adc55b$export$2e2bcd8739ae039 = $379600ba82adc55b$var$blue;


const $f2e6d095e9e71fca$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $f2e6d095e9e71fca$export$2e2bcd8739ae039 = $f2e6d095e9e71fca$var$lightBlue;


const $1dd8edf8f9af94d4$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $1dd8edf8f9af94d4$export$2e2bcd8739ae039 = $1dd8edf8f9af94d4$var$green;


const $f32dcd805ea953f7$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $f32dcd805ea953f7$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $acc6457e87554c52$export$2e2bcd8739ae039).white,
        default: (0, $acc6457e87554c52$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $f32dcd805ea953f7$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $acc6457e87554c52$export$2e2bcd8739ae039).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $acc6457e87554c52$export$2e2bcd8739ae039).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $f32dcd805ea953f7$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $6ae574cb2ebbc3ad$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $6ae574cb2ebbc3ad$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $f32dcd805ea953f7$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[200],
        light: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[50],
        dark: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[700],
        light: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[400],
        dark: (0, $379600ba82adc55b$export$2e2bcd8739ae039)[800]
    };
}
function $f32dcd805ea953f7$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[200],
        light: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[50],
        dark: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[500],
        light: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[300],
        dark: (0, $1aee4d22735d5325$export$2e2bcd8739ae039)[700]
    };
}
function $f32dcd805ea953f7$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[500],
        light: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[300],
        dark: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[700],
        light: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[400],
        dark: (0, $992de574f1606f4a$export$2e2bcd8739ae039)[800]
    };
}
function $f32dcd805ea953f7$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[400],
        light: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[300],
        dark: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[700],
        light: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[500],
        dark: (0, $f2e6d095e9e71fca$export$2e2bcd8739ae039)[900]
    };
}
function $f32dcd805ea953f7$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[400],
        light: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[300],
        dark: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[800],
        light: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[500],
        dark: (0, $1dd8edf8f9af94d4$export$2e2bcd8739ae039)[900]
    };
}
function $f32dcd805ea953f7$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $e24ba6338a2f77c2$export$2e2bcd8739ae039)[400],
        light: (0, $e24ba6338a2f77c2$export$2e2bcd8739ae039)[300],
        dark: (0, $e24ba6338a2f77c2$export$2e2bcd8739ae039)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $e24ba6338a2f77c2$export$2e2bcd8739ae039)[500],
        dark: (0, $e24ba6338a2f77c2$export$2e2bcd8739ae039)[900]
    };
}
function $f32dcd805ea953f7$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $7Z8DW.default)(palette, $f32dcd805ea953f7$var$_excluded);
    const primary = palette.primary || $f32dcd805ea953f7$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $f32dcd805ea953f7$var$getDefaultSecondary(mode);
    const error = palette.error || $f32dcd805ea953f7$var$getDefaultError(mode);
    const info = palette.info || $f32dcd805ea953f7$var$getDefaultInfo(mode);
    const success = palette.success || $f32dcd805ea953f7$var$getDefaultSuccess(mode);
    const warning = palette.warning || $f32dcd805ea953f7$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $6ae574cb2ebbc3ad$exports.getContrastRatio)(background, $f32dcd805ea953f7$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $f32dcd805ea953f7$export$55ce6f3a06c59543.text.primary : $f32dcd805ea953f7$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $65o8X.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $9u6aw.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $9u6aw.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $f32dcd805ea953f7$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $f32dcd805ea953f7$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $f32dcd805ea953f7$export$55ce6f3a06c59543,
        light: $f32dcd805ea953f7$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $hWP8m.default)((0, $65o8X.default)({
        // A collection of common colors.
        common: (0, $65o8X.default)({}, (0, $acc6457e87554c52$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $1f6b80255be92d2b$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $hWP8m = parcelRequire("hWP8m");
const $1927e300ae895ce9$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $1927e300ae895ce9$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1927e300ae895ce9$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $1927e300ae895ce9$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $1927e300ae895ce9$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $1927e300ae895ce9$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $7Z8DW.default)(_ref, $1927e300ae895ce9$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $65o8X.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $1927e300ae895ce9$var$defaultFontFamily ? {
            letterSpacing: `${$1927e300ae895ce9$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $1927e300ae895ce9$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $1927e300ae895ce9$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $hWP8m.default)((0, $65o8X.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $8b84c214fa0b5975$var$shadowKeyUmbraOpacity = 0.2;
const $8b84c214fa0b5975$var$shadowKeyPenumbraOpacity = 0.14;
const $8b84c214fa0b5975$var$shadowAmbientShadowOpacity = 0.12;
function $8b84c214fa0b5975$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$8b84c214fa0b5975$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $8b84c214fa0b5975$var$shadows = [
    "none",
    $8b84c214fa0b5975$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8b84c214fa0b5975$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8b84c214fa0b5975$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8b84c214fa0b5975$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8b84c214fa0b5975$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8b84c214fa0b5975$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8b84c214fa0b5975$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8b84c214fa0b5975$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8b84c214fa0b5975$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8b84c214fa0b5975$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8b84c214fa0b5975$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8b84c214fa0b5975$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8b84c214fa0b5975$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8b84c214fa0b5975$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8b84c214fa0b5975$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8b84c214fa0b5975$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8b84c214fa0b5975$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8b84c214fa0b5975$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8b84c214fa0b5975$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8b84c214fa0b5975$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8b84c214fa0b5975$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8b84c214fa0b5975$export$2e2bcd8739ae039 = $8b84c214fa0b5975$var$shadows;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
const $9b9400e6897b1153$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $9b9400e6897b1153$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $9b9400e6897b1153$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $9b9400e6897b1153$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $9b9400e6897b1153$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $9b9400e6897b1153$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $65o8X.default)({}, $9b9400e6897b1153$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $65o8X.default)({}, $9b9400e6897b1153$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $7Z8DW.default)(options, $9b9400e6897b1153$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $9b9400e6897b1153$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $9b9400e6897b1153$var$formatMs(delay)}`).join(",");
    };
    return (0, $65o8X.default)({
        getAutoHeightDuration: $9b9400e6897b1153$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f4ba3183d1973706$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f4ba3183d1973706$export$2e2bcd8739ae039 = $f4ba3183d1973706$var$zIndex;


const $dfae66918ab7b5ac$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $dfae66918ab7b5ac$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $7Z8DW.default)(options, $dfae66918ab7b5ac$var$_excluded);
    if (options.vars) throw new Error((0, $9u6aw.default)(18));
    const palette = (0, $f32dcd805ea953f7$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $gnWEo.default)(options);
    let muiTheme = (0, $hWP8m.default)(systemTheme, {
        mixins: (0, $de12fbfe653fcf7a$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $8b84c214fa0b5975$export$2e2bcd8739ae039).slice(),
        typography: (0, $1927e300ae895ce9$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $9b9400e6897b1153$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $65o8X.default)({}, (0, $f4ba3183d1973706$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $hWP8m.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $hWP8m.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $65o8X.default)({}, (0, $jHIoy.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $34Ozv.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $dfae66918ab7b5ac$var$warnedOnce = false;
function $dfae66918ab7b5ac$export$c469355549431d9b(...args) {
    return $dfae66918ab7b5ac$var$createTheme(...args);
}
var $dfae66918ab7b5ac$export$2e2bcd8739ae039 = $dfae66918ab7b5ac$var$createTheme;


"use client";
const $21d8dc776959fb7e$var$defaultTheme = (0, $dfae66918ab7b5ac$export$2e2bcd8739ae039)();
var $21d8dc776959fb7e$export$2e2bcd8739ae039 = $21d8dc776959fb7e$var$defaultTheme;


var $cd607e6564742347$export$2e2bcd8739ae039 = "$$material";


// copied from @mui/system/createStyled
function $5af6b33d880b74bd$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $5af6b33d880b74bd$export$2e2bcd8739ae039 = $5af6b33d880b74bd$var$slotShouldForwardProp;


const $c549a1c63ae66a43$var$rootShouldForwardProp = (prop)=>(0, $5af6b33d880b74bd$export$2e2bcd8739ae039)(prop) && prop !== "classes";
var $c549a1c63ae66a43$export$2e2bcd8739ae039 = $c549a1c63ae66a43$var$rootShouldForwardProp;



"use client";
const $a4a2e949ed07e863$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($44b60eacf0f66ef8$exports)))({
    themeId: (0, $cd607e6564742347$export$2e2bcd8739ae039),
    defaultTheme: $21d8dc776959fb7e$export$2e2bcd8739ae039,
    rootShouldForwardProp: $c549a1c63ae66a43$export$2e2bcd8739ae039
});
var $a4a2e949ed07e863$export$2e2bcd8739ae039 = $a4a2e949ed07e863$var$styled;



var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");


var $eZVvM = parcelRequire("eZVvM");


var $65o8X = parcelRequire("65o8X");
function $6860b88ec3aae518$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $65o8X.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $65o8X.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $65o8X.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $6860b88ec3aae518$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $058703d126f1b454$var$PropsContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
function $058703d126f1b454$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)($058703d126f1b454$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $058703d126f1b454$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $6860b88ec3aae518$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $6860b88ec3aae518$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $058703d126f1b454$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $eZVvM.useContext($058703d126f1b454$var$PropsContext);
    return $058703d126f1b454$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $058703d126f1b454$export$2e2bcd8739ae039 = $058703d126f1b454$var$DefaultPropsProvider;



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $64582037ee8abf00$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $058703d126f1b454$export$2e2bcd8739ae039), (0, $65o8X.default)({}, props));
}
var $64582037ee8abf00$export$2e2bcd8739ae039 = $64582037ee8abf00$var$DefaultPropsProvider;
function $64582037ee8abf00$export$2440da353cedad43(params) {
    return (0, $058703d126f1b454$export$2440da353cedad43)(params);
}


parcelRequire("eZVvM");

var $gnWEo = parcelRequire("gnWEo");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");
"use client";
function $271479f5a10767b7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $271479f5a10767b7$var$useTheme(defaultTheme = null) {
    const contextTheme = $eZVvM.useContext((0, $8kMfp.T));
    return !contextTheme || $271479f5a10767b7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $271479f5a10767b7$export$2e2bcd8739ae039 = $271479f5a10767b7$var$useTheme;


"use client";
const $123cc06973765126$export$35e57303dbd8a66 = (0, $gnWEo.default)();
function $123cc06973765126$var$useTheme(defaultTheme = $123cc06973765126$export$35e57303dbd8a66) {
    return (0, $271479f5a10767b7$export$2e2bcd8739ae039)(defaultTheme);
}
var $123cc06973765126$export$2e2bcd8739ae039 = $123cc06973765126$var$useTheme;




"use client";
function $22960e5129fa60d7$export$2e2bcd8739ae039() {
    const theme = (0, $123cc06973765126$export$2e2bcd8739ae039)((0, $21d8dc776959fb7e$export$2e2bcd8739ae039));
    return theme[0, $cd607e6564742347$export$2e2bcd8739ae039] || theme;
}



var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $29929049563c8878$var$GridContext = /*#__PURE__*/ $eZVvM.createContext();
var $29929049563c8878$export$2e2bcd8739ae039 = $29929049563c8878$var$GridContext;


const $ce48a54a23a9229a$var$defaultGenerator = (componentName)=>componentName;
const $ce48a54a23a9229a$var$createClassNameGenerator = ()=>{
    let generate = $ce48a54a23a9229a$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $ce48a54a23a9229a$var$defaultGenerator;
        }
    };
};
const $ce48a54a23a9229a$var$ClassNameGenerator = $ce48a54a23a9229a$var$createClassNameGenerator();
var $ce48a54a23a9229a$export$2e2bcd8739ae039 = $ce48a54a23a9229a$var$ClassNameGenerator;


const $66fff2ea26bc86db$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $66fff2ea26bc86db$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $66fff2ea26bc86db$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $ce48a54a23a9229a$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $66fff2ea26bc86db$export$34c0130b1f3e8ae3(slot) {
    return $66fff2ea26bc86db$export$9d6b9120de57c54[slot] !== undefined;
}


function $9d66b0007285ac75$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $7f215ca4d84aade2$export$9973ac5fd0181f33(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiGrid", slot);
}
const $7f215ca4d84aade2$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $7f215ca4d84aade2$var$DIRECTIONS = [
    "column-reverse",
    "column",
    "row-reverse",
    "row"
];
const $7f215ca4d84aade2$var$WRAPS = [
    "nowrap",
    "wrap-reverse",
    "wrap"
];
const $7f215ca4d84aade2$var$GRID_SIZES = [
    "auto",
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $7f215ca4d84aade2$var$gridClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiGrid", [
    "root",
    "container",
    "item",
    "zeroMinWidth",
    // spacings
    ...$7f215ca4d84aade2$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$7f215ca4d84aade2$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$7f215ca4d84aade2$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$7f215ca4d84aade2$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $7f215ca4d84aade2$export$2e2bcd8739ae039 = $7f215ca4d84aade2$var$gridClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $23610b7fd899719e$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $23610b7fd899719e$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), "") || "px"}`;
}
function $23610b7fd899719e$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: "100%"
        };
        else if (size === "auto") styles = {
            flexBasis: "auto",
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: "none",
            width: "auto"
        };
        else {
            const columnsBreakpointValues = (0, $ivlTt.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === "object" ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== "0px") {
                    const fullWidth = `calc(${width} + ${$23610b7fd899719e$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $65o8X.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $23610b7fd899719e$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $ivlTt.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $ivlTt.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf("column") === 0) output[`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`] = {
            maxWidth: "none"
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $23610b7fd899719e$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = "";
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== "") return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $23610b7fd899719e$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $ivlTt.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === "object") zeroValueBreakpointKeys = $23610b7fd899719e$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $ivlTt.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                marginTop: `-${$23610b7fd899719e$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: $23610b7fd899719e$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $23610b7fd899719e$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $ivlTt.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === "object") zeroValueBreakpointKeys = $23610b7fd899719e$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $ivlTt.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== "0px") return {
                width: `calc(100% + ${$23610b7fd899719e$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$23610b7fd899719e$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: $23610b7fd899719e$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: "100%",
                marginLeft: 0,
                [`& > .${(0, $7f215ca4d84aade2$export$2e2bcd8739ae039).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $23610b7fd899719e$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $23610b7fd899719e$var$GridRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiGrid",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $23610b7fd899719e$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== "row" && styles[`direction-xs-${String(direction)}`],
            wrap !== "wrap" && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        boxSizing: "border-box"
    }, ownerState.container && {
        display: "flex",
        flexWrap: "wrap",
        width: "100%"
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== "wrap" && {
        flexWrap: ownerState.wrap
    }), $23610b7fd899719e$export$71d4225eeb1bc13e, $23610b7fd899719e$export$380604d7c79f9e8f, $23610b7fd899719e$export$4315fba5128fb4a1, $23610b7fd899719e$export$ca2a698f6020fda);
function $23610b7fd899719e$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === "string" && !Number.isNaN(Number(spacing)) || typeof spacing === "number") return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $23610b7fd899719e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $23610b7fd899719e$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            "root",
            container && "container",
            item && "item",
            zeroMinWidth && "zeroMinWidth",
            ...spacingClasses,
            direction !== "row" && `direction-xs-${String(direction)}`,
            wrap !== "wrap" && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $7f215ca4d84aade2$export$9973ac5fd0181f33), classes);
};
const $23610b7fd899719e$var$Grid = /*#__PURE__*/ $eZVvM.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiGrid"
    });
    const { breakpoints: breakpoints } = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const props = (0, $bU7jb.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = "div", container: container = false, direction: direction = "row", item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = "wrap", zeroMinWidth: zeroMinWidth = false } = props, other = (0, $7Z8DW.default)(props, $23610b7fd899719e$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $eZVvM.useContext((0, $29929049563c8878$export$2e2bcd8739ae039));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $65o8X.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $23610b7fd899719e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $29929049563c8878$export$2e2bcd8739ae039).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($23610b7fd899719e$var$GridRoot, (0, $65o8X.default)({
            ownerState: ownerState,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
var $23610b7fd899719e$export$2e2bcd8739ae039 = $23610b7fd899719e$var$Grid;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $7Z8DW = parcelRequire("7Z8DW");

var $3XZxQ = parcelRequire("3XZxQ");
function $fb26d559f651f364$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3XZxQ.default)(t, o);
}




var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");
var $6c4db6b27121d531$export$2e2bcd8739ae039 = {
    disabled: false
};




var $eZVvM = parcelRequire("eZVvM");
var $1dbe22997e33b48b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);


var $7502c9e61d0d4ec3$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $61e7b8c7fcb92c69$export$bb38bb9a1161268 = "unmounted";
var $61e7b8c7fcb92c69$export$84cbff306f539230 = "exited";
var $61e7b8c7fcb92c69$export$df38205c966be359 = "entering";
var $61e7b8c7fcb92c69$export$78e9e6e3e014d60a = "entered";
var $61e7b8c7fcb92c69$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $61e7b8c7fcb92c69$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $fb26d559f651f364$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $61e7b8c7fcb92c69$export$84cbff306f539230;
                _this.appearStatus = $61e7b8c7fcb92c69$export$df38205c966be359;
            } else initialStatus = $61e7b8c7fcb92c69$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $61e7b8c7fcb92c69$export$bb38bb9a1161268;
        else initialStatus = $61e7b8c7fcb92c69$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $61e7b8c7fcb92c69$export$bb38bb9a1161268) return {
            status: $61e7b8c7fcb92c69$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $61e7b8c7fcb92c69$export$df38205c966be359 && status !== $61e7b8c7fcb92c69$export$78e9e6e3e014d60a) nextStatus = $61e7b8c7fcb92c69$export$df38205c966be359;
            } else if (status === $61e7b8c7fcb92c69$export$df38205c966be359 || status === $61e7b8c7fcb92c69$export$78e9e6e3e014d60a) nextStatus = $61e7b8c7fcb92c69$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $61e7b8c7fcb92c69$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7502c9e61d0d4ec3$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $61e7b8c7fcb92c69$export$84cbff306f539230) this.setState({
            status: $61e7b8c7fcb92c69$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $6c4db6b27121d531$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e7b8c7fcb92c69$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $61e7b8c7fcb92c69$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $61e7b8c7fcb92c69$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $6c4db6b27121d531$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e7b8c7fcb92c69$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $61e7b8c7fcb92c69$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $61e7b8c7fcb92c69$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($e4ZGj))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $61e7b8c7fcb92c69$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $7Z8DW.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Component);
$61e7b8c7fcb92c69$var$Transition.contextType = (0, $1dbe22997e33b48b$export$2e2bcd8739ae039);
$61e7b8c7fcb92c69$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $61e7b8c7fcb92c69$var$noop() {}
$61e7b8c7fcb92c69$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $61e7b8c7fcb92c69$var$noop,
    onEntering: $61e7b8c7fcb92c69$var$noop,
    onEntered: $61e7b8c7fcb92c69$var$noop,
    onExit: $61e7b8c7fcb92c69$var$noop,
    onExiting: $61e7b8c7fcb92c69$var$noop,
    onExited: $61e7b8c7fcb92c69$var$noop
};
$61e7b8c7fcb92c69$var$Transition.UNMOUNTED = $61e7b8c7fcb92c69$export$bb38bb9a1161268;
$61e7b8c7fcb92c69$var$Transition.EXITED = $61e7b8c7fcb92c69$export$84cbff306f539230;
$61e7b8c7fcb92c69$var$Transition.ENTERING = $61e7b8c7fcb92c69$export$df38205c966be359;
$61e7b8c7fcb92c69$var$Transition.ENTERED = $61e7b8c7fcb92c69$export$78e9e6e3e014d60a;
$61e7b8c7fcb92c69$var$Transition.EXITING = $61e7b8c7fcb92c69$export$4aacc83d4d59139f;
var $61e7b8c7fcb92c69$export$2e2bcd8739ae039 = $61e7b8c7fcb92c69$var$Transition;




const $a87adae6755df26f$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $a87adae6755df26f$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $54e94fe5aedb285c$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $ff7ab293f0b0d361$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $eZVvM.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $f19448b4821cb7b2$export$2e2bcd8739ae039 = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039);



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $db075bdb02672c7e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $db075bdb02672c7e$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $db075bdb02672c7e$var$Fade = /*#__PURE__*/ $eZVvM.forwardRef(function Fade(props, ref) {
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $db075bdb02672c7e$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                style: (0, $65o8X.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $db075bdb02672c7e$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $db075bdb02672c7e$export$2e2bcd8739ae039 = $db075bdb02672c7e$var$Fade;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");





var $aNuUP = parcelRequire("aNuUP");

var $hojpr = parcelRequire("hojpr");
var $d919e3e348f37215$export$2e2bcd8739ae039 = (0, $hojpr.default);






function $99562f5127c565e6$export$29cad1383b3f235d(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiCircularProgress", slot);
}
const $99562f5127c565e6$var$circularProgressClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $99562f5127c565e6$export$2e2bcd8739ae039 = $99562f5127c565e6$var$circularProgressClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $046757d70188c03a$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $046757d70188c03a$var$_ = (t)=>t, $046757d70188c03a$var$_t, $046757d70188c03a$var$_t2, $046757d70188c03a$var$_t3, $046757d70188c03a$var$_t4;
const $046757d70188c03a$var$SIZE = 44;
const $046757d70188c03a$var$circularRotateKeyframe = (0, $aNuUP.keyframes)($046757d70188c03a$var$_t || ($046757d70188c03a$var$_t = $046757d70188c03a$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $046757d70188c03a$var$circularDashKeyframe = (0, $aNuUP.keyframes)($046757d70188c03a$var$_t2 || ($046757d70188c03a$var$_t2 = $046757d70188c03a$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $046757d70188c03a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $99562f5127c565e6$export$29cad1383b3f235d), classes);
};
const $046757d70188c03a$var$CircularProgressRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $aNuUP.css)($046757d70188c03a$var$_t3 || ($046757d70188c03a$var$_t3 = $046757d70188c03a$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $046757d70188c03a$var$circularRotateKeyframe));
const $046757d70188c03a$var$CircularProgressSVG = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $046757d70188c03a$var$CircularProgressCircle = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $aNuUP.css)($046757d70188c03a$var$_t4 || ($046757d70188c03a$var$_t4 = $046757d70188c03a$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $046757d70188c03a$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $046757d70188c03a$var$CircularProgress = /*#__PURE__*/ $eZVvM.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $7Z8DW.default)(props, $046757d70188c03a$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $046757d70188c03a$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($046757d70188c03a$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $65o8X.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$046757d70188c03a$var$SIZE / 2} ${$046757d70188c03a$var$SIZE / 2} ${$046757d70188c03a$var$SIZE} ${$046757d70188c03a$var$SIZE}`,
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($046757d70188c03a$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $046757d70188c03a$var$SIZE,
                cy: $046757d70188c03a$var$SIZE,
                r: ($046757d70188c03a$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $046757d70188c03a$export$2e2bcd8739ae039 = $046757d70188c03a$var$CircularProgress;



var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @public
 */ const $530f496ded9f62d9$export$f224e4635b6f8ce2 = (0, $eZVvM.createContext)(null);



var $eZVvM = parcelRequire("eZVvM");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $75b40fe88a41e69d$export$fe4300aa8eebea86(init) {
    const ref = (0, $eZVvM.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @public
 */ const $2dbc4737509c69cd$export$22a697fb29aac98d = (0, $eZVvM.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $3442de3c7263c06c$var$PopChildMeasure extends $eZVvM.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $3442de3c7263c06c$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $eZVvM.useId)();
    const ref = (0, $eZVvM.useRef)(null);
    const size = (0, $eZVvM.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $eZVvM.useContext)((0, $2dbc4737509c69cd$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $eZVvM.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $3pI8R.jsx)($3442de3c7263c06c$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $eZVvM.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $d765126604c1d19a$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $75b40fe88a41e69d$export$fe4300aa8eebea86)($d765126604c1d19a$var$newChildrenMap);
    const id = (0, $eZVvM.useId)();
    const memoizedOnExitComplete = (0, $eZVvM.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $eZVvM.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $eZVvM.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $eZVvM.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $3pI8R.jsx)((0, $3442de3c7263c06c$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $3pI8R.jsx)((0, $530f496ded9f62d9$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $d765126604c1d19a$var$newChildrenMap() {
    return new Map();
}



var $eZVvM = parcelRequire("eZVvM");
"use client";
const $7e2e92a55d7a9c1e$export$a3579ca508007a95 = (0, $eZVvM.createContext)({});


const $586d62dcd567427e$export$8793edee2d425525 = (any)=>any;


let $bde5dfec70eede58$export$491112666e282270 = (0, $586d62dcd567427e$export$8793edee2d425525);
let $bde5dfec70eede58$export$f5708dca728d7177 = (0, $586d62dcd567427e$export$8793edee2d425525);
var $bde5dfec70eede58$var$check, $bde5dfec70eede58$var$message, $bde5dfec70eede58$var$check1, $bde5dfec70eede58$var$message1;




var $eZVvM = parcelRequire("eZVvM");
const $3f5df461b4189bd2$export$10e61aed958678dd = (child)=>child.key || "";
function $3f5df461b4189bd2$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $eZVvM.Children).forEach(children, (child)=>{
        if ((0, $eZVvM.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



var $eZVvM = parcelRequire("eZVvM");
const $be55fc6f5082c859$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $e44af1c94b39ef8b$export$700979bc83e7db82 = (0, $be55fc6f5082c859$export$4e09c449d6c407f7) ? (0, $eZVvM.useLayoutEffect) : (0, $eZVvM.useEffect);


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $315036d4e04024b7$export$3ae376d12526dd6f = ({ children: children, exitBeforeEnter: exitBeforeEnter, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $bde5dfec70eede58$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $eZVvM.useMemo)(()=>(0, $3f5df461b4189bd2$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = presentChildren.map((0, $3f5df461b4189bd2$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $eZVvM.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $eZVvM.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $75b40fe88a41e69d$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $eZVvM.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $eZVvM.useState)(presentChildren);
    (0, $e44af1c94b39ef8b$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $3f5df461b4189bd2$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $eZVvM.useContext)((0, $7e2e92a55d7a9c1e$export$a3579ca508007a95));
    return (0, $3pI8R.jsx)((0, $3pI8R.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $3f5df461b4189bd2$export$10e61aed958678dd)(child);
            const isPresent = presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $3pI8R.jsx)((0, $d765126604c1d19a$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};



var $kvR7a = parcelRequire("kvR7a");
var $2029d0a4fc5b48e8$exports = {};

!function(e, a) {
    $2029d0a4fc5b48e8$exports = a((parcelRequire("kvR7a")));
}($2029d0a4fc5b48e8$exports, function(e) {
    "use strict";
    function a(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var d = a(e), n = {
        name: "nl",
        weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
        weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
        weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
        months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
        monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
        ordinal: function(e) {
            return "[" + e + (1 === e || 8 === e || e >= 20 ? "ste" : "de") + "]";
        },
        weekStart: 1,
        yearStart: 4,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "over %s",
            past: "%s geleden",
            s: "een paar seconden",
            m: "een minuut",
            mm: "%d minuten",
            h: "een uur",
            hh: "%d uur",
            d: "een dag",
            dd: "%d dagen",
            M: "een maand",
            MM: "%d maanden",
            y: "een jaar",
            yy: "%d jaar"
        }
    };
    return d.default.locale(n, null, !0), n;
});


var $b55c0778d0239c08$exports = {};
!function(e, n) {
    $b55c0778d0239c08$exports = n();
}($b55c0778d0239c08$exports, function() {
    "use strict";
    return {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(e) {
            var n = [
                "th",
                "st",
                "nd",
                "rd"
            ], t = e % 100;
            return "[" + e + (n[(t - 20) % 10] || n[t] || n[0]) + "]";
        }
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).locale("nl");
var $fe3a9b4b2ca7c971$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)));



var $aZjGj = parcelRequire("aZjGj");
parcelRequire("4NAAR");
var $9yd0C = parcelRequire("9yd0C");
var $86cde84932c5b025$exports = {};
$86cde84932c5b025$exports = JSON.parse('{"language":{"title":"Choose your language","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Hi, how can we help you?","checkIn":"Check in","independentManualCheckIn":"No appointment","integratedManualCheckIn":"Check in manually","checkOut":"Check out","manualCheckOut":"Check out manually","parcelDelivery":"Parcel delivery","foodDelivery":"Food delivery","callReception":"Call reception","overview":"Overview","unavailable":"The reception is currently unavailable."},"check":{"option":{"checkin":{"title":"Choose an option to check in","manual":"Check in manually","code":"Check in with PIN or QR code","code-no-qr":"Check in with PIN code"},"checkout":{"title":"Choose an option to check out","manual":"Check out with name","code":"Check out with PIN or QR code","code-no-qr":"Check out with PIN code"}},"title":"You can now scan your QR code or enter your PIN code.","orText":"Or","qrScanner":{"checkin":{"title":"Choose an option to check in"},"checkout":{"title":"Choose an option to check out"},"btn":"Scan your QR code"},"hidScanner":{"title":"Hold QR code to the scanner below or enter your PIN code"},"pinOnly":{"title":"Please enter your PIN code"},"pinCode":"Enter your PIN code","manually":{"checkin":"Don\'t have a checkin code?"},"status":{"idle":{"title":"Your code is scanning.","message":"Please wait...","nfc":{"title":"Your tag is scanning.","message":"Please wait..."}},"loading":{"title":"Your code is scanning.","message":"Please wait...","nfc":{"title":"Your tag is scanning.","message":"Please wait..."}},"error":{"title":"Your code is invalid.","message":"Please try again!","nfc":{"title":"Your tag is invalid.","message":"Please try again!"},"meeting":{"tooEarly":{"title":"You\'re a bit early","message":"Your code is valid from {{validFromTime}}. The meeting starts at {{meetingStartTime}}."},"tooLate":{"title":"This code has expired","message":"The meeting ended at {{meetingEndTime}}. Your code was valid until {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"You have successfully checked in.","message":"Thank you."},"MeetingAttendee":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have successfully checked in.","message":"Your contact person has been notified."},"call-ping":{"title":"You have successfully checked in.","message":"We will now establish a phone call with your contact person."},"teams-call":{"title":"You have successfully checked in.","message":"We will now establish a Microsoft Teams call with your contact person."},"badge":{"title":"Thank you for checking in, your badge will be printed.","message":""},"video-call":{"title":"You have successfully checked in.","message":"Setting up your video call with the contact person."}},"Employee":{"title":"You have successfully checked in.","message":"Thank you.","badge":{"title":"Thank you for checking in, your badge will be printed.","message":""}},"Visitor":{"title":"You have successfully checked in.","message":"Thank you.","badge":{"title":"Thank you for checking in, your badge will be printed.","message":""}}},"checkout":{"default":{"title":"You have successfully checked out.<br/>","message":"See you again soon."},"MeetingAttendee":{"title":"You have successfully checked out.","message":"See you again soon."},"Employee":{"title":"You have successfully checked out.","message":"See you again soon."},"Visitor":{"title":"You have successfully checked out.","message":"See you again soon."},"access":{"title":"You have successfully checked out.","message":"You can now open the door."}}}}},"missingFields":{"title":"A few more details before check-in","subtitle":"Fields marked * are required","btn":"Check in","placeholder":{"other":"Other...","otherInput":"Enter your option"},"error":{"required":"You didn\'t fill in this field","email":"Invalid email address","phone":"Invalid phone number"}},"manualCheckin":{"title":{"default":"Please fill in.","documentScanner":"Pay attention when inserting your identity card:"},"subtitle":{"default":"Note - every field * is required","documentScanner":[{"parts":[{"text":"The side with the ","bold":false},{"text":"<<< >>> characters (MRZ)","bold":true},{"text":", must be ","bold":false},{"text":"facing the kiosk or scanner.","bold":true}]},{"parts":[{"text":"Hold the card still ","bold":false},{"text":"until the fields are filled in automatically.","bold":true}]}]},"noOption":"No option","btn":"Check in","placeholder":{"name":"Your name *","email":"Your e-mail *","phone":"Mobile number","contactName":"Your contact person*","other":"Other..."},"error":{"required":"You didn\'t fill in this field","name":"Invalid name","email":"Invalid email address","phone":"Invalid mobile number"},"status":{"idle":{"no-contact":{"title":"Please wait...","message":"Your registration is being processed."},"contact":{"title":"Please wait...","message":"Your contact is being notified."}},"loading":{"no-contact":{"title":"Please wait...","message":"Your registration is being processed."},"contact":{"title":"Please wait...","message":"Your contact is being notified."}},"success":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have successfully checked in.","message":"Your contact person is notified."},"call-ping":{"title":"You have successfully checked in.","message":"We will now establish a phone call with your contact person."},"teams-call":{"title":"You have successfully checked in.","message":" We will now establish a Microsoft Teams call with your contact person "},"badge":{"title":"Thank you for checking in, your badge will be printed.","message":""},"video-call":{"title":"You have successfully checked in.","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}},"documentScan":{"invalid":{"title":"Document not valid","message":"The document could not be verified or has expired. Please enter your details manually."}}},"manualCheckout":{"title":"Enter your name to check out","btn":"Check out","form":{"placeholder":{"name":"Your full name *"},"loading":"Loading...","noOptions":"No options"},"error":{"required":"You didn\'t fill in this field","name":"Invalid name"},"status":{"idle":{"title":"We are processing your information.","message":"Please wait..."},"loading":{"title":"We are processing your information.","message":"Please wait..."},"success":{"title":"You have successfully checked out.","message":"Thank you and have a nice day."},"successAccess":{"title":"You have successfully checked out.","message":"Now you can open the door."},"error":{"title":"An error occurred while checking out.","message":"Please try again!"}}},"call":{"title":{"no-email-sms":"Would you like to notify your contact?","email-sms":"We have sent an email/sms to your contact.<br/>Do you want to establish a call with them additionally?"},"callBtn":"Call","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Video call","teamsCallBtn":"Teams call","teamsMessageBtn":"Teams message","googleChatMessageBtn":"Google Chat","noBtn":"Cancel","cancelBtn":"Cancel call","status":{"connecting":{"title":"Establishing call.<br/>Please wait...","message":""},"ringing":{"title":"Calling your contact person<br/>Please wait...","message":""},"ringingReception":{"title":"Call started...","message":""},"open":{"title":"Call in progress.","message":""},"close":{"title":"Call ended.<br/>","message":""},"closeAccess":{"title":"Call ended.<br/>Now you can open the door.","message":""},"closeReception":{"title":"Call is ended.","message":""},"error":{"title":"Call is not established.<br/>Call again?","message":""}}},"message":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":"We are notifying your contact person.","message":"Please wait..."},"success":{"title":"SMS has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":" SMS has been sent. The contact has been notified. ","message":"Now you can open the door."},"error":{"title":"SMS not sent.","message":"Please try again!"}}},"videoCall":{"title":"Video call","endCall":"End call","status":{"idle":{"title":"We are creating a video room.","message":"Please wait..."},"loading":{"title":"We are creating a video room.","message":"Please wait..."},"success":{"title":"The video room has been successfully created.","message":"Joining room..."},"error":{"title":"The video room was not created successfully.","message":"Please try again!"}}},"teamsCall":{"title":"Teams call","controls":{"startCall":"Start call","endCall":"Leave","camera":"Camera","cameraOff":"Camera off","mic":"Mic","micOff":"Mic off","ringing":"Ringing...","noAnswer":"No one has answered the call."},"status":{"connecting":{"title":"Establishing call.<br/>Please wait...","message":""},"ringing":{"title":"Calling your contact person<br/>Please wait...","message":""},"connected":{"title":"Establishing call","message":""},"disconnected":{"title":"Call ended.<br/>","message":""},"disconnectedAccess":{"title":"Call ended.<br/>Now you can open the door.","message":""},"error":{"title":"Call is not established.<br/>Please try again","message":""},"noAnswer":{"title":"No one answered the call.<br/>Please try again.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":" We are notifying your contact person. ","message":"Please wait..."},"success":{"title":"Message has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":" Message has been sent. The contact has been notified. ","message":"Now you can open the door."},"error":{"title":"Message not sent.","message":"Please try again!"}}},"googleChatMessage":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":"We are notifying your contact person.","message":"Please wait..."},"success":{"title":"Message has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":"Message has been sent. The contact has been notified.","message":"Now you can open the door."},"error":{"title":"Message not sent.","message":"Please try again!"}}},"packageDelivery":{"title":"How nice of you to deliver a package!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"","input":{"label":{"contact":"Who is the parcel for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact person.","message":"Please wait..."},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact person has been notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to the contact person."},"teams-call":{"title":"Thank you for your delivery!","message":"A Microsoft Teams call will now be made to your contact person."},"video-call":{"title":"Thank you for your delivery!","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"foodDelivery":{"title":"How nice of you to deliver food!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"","input":{"label":{"contact":"Who is the food for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact.","message":"Please wait!"},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact is notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to your contact person."},"teams-call":{"title":"Thank you for your delivery!","message":"A Microsoft Teams call will now be made to your contact person."},"video-call":{"title":"Thank you for your delivery!","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"QRCodeScanner":{"title":"Please scan your QR code","subtitle":"Line up the QR code inside the red corners and keep your phone steady.","error":"Invalid QR code format","unknownError":"Unknown error occurred while scanning"},"common":{"backBtn":"Back"},"previewPDF":{"page":{"of":"of","previous":"Previous","next":"Next"},"button":{"cancel":"Cancel","accept":"Accept","next":"Next"},"title":{"consent":"Consent required"}},"offline":{"title":"Offline","receptionMessage":"The digital reception is offline at the moment and can not be used, the internet connection must be checked!","check":"Are you a visitor and do you want to speak to an employee directly? Please call {{receptionistPhone}}"},"overview":{"title":"Enter the code to open the overview!","noUsers":"No registrations","status":{"success":{"title":"The code is valid.","message":""},"error":{"title":"The code invalid.","message":"Please try again!"}},"checkoutStatus":{"loading":{"title":"Please wait...","message":""},"success":{"title":"Successful check out.","message":""},"error":{"title":"Something went wrong.","message":"Please try again!"}},"listTitle":"List of persons who checked in today but didn\'t check out","page":"Page ","table":{"head":{"fullName":"Name","type":"Type","checkedinAt":"Checked in at","host":"Host"},"type":{"Package":"Package delivery","Food":"Food delivery","Visitor":"Visitor","MeetingAttendee":"Invited visitor","Employee":"Employee","Guest":"Visitor"}},"confirmModal":{"title":"Are you sure you want to check out {{fullName}}?","cancel":"Cancel","checkout":"Check out"}},"wifi":{"title":"Connect to the Wi-Fi network"},"door":{"external":{"title":"Opening the door","subtitle":"The door will open shortly. Please wait..."},"control":{"title":"You can now open the door","subtitle":"Please press the button below!","openBtn":"Open the door"},"status":{"success":{"title":"The door has been opened","message":""},"error":{"title":"Something went wrong","message":"Please contact your contact person to open the door."},"loading":{"title":"Opening the door...","message":""}}},"photo":{"title":"Would you like to take a photo as part of your check-in process?","required":{"title":"Photo Verification Required!","instructions":"Please stand in front of the camera and follow the on-screen instructions.","securityNotice":"For security and verification purposes, a photo is required during check-in.","privacyInfo":"We respect your privacy. Your data is securely stored and used only for identification.","closingMessage":"Thank you for your cooperation."},"optional":{"title":"Would you like to take a photo as part of your check-in process?","instructions":"","securityNotice":"Taking a photo can help streamline identification and enhance security.","privacyInfo":"We respect your privacy. This step is optional, and your data will be securely handled.","closingMessage":"You can skip this step if you prefer."},"subtitle":"Please position yourself within the frame and remain still for the best result","button":{"cancel":"Cancel","accept":"Accept","skip":"Skip","next":"Next","recapture":"Recapture photo","continue":"Continue"},"error":"An error occurred while capturing the photo. The check-in process will continue without the photo."},"wayfinding":{"title":"Where would you like to go?"},"callingMenu":{"title":"Calling menu"},"bell":{"status":{"success":{"title":"The bell is ringing","message":"Someone will be with you shortly."},"error":{"title":"Something went wrong","message":"Please try again"},"loading":{"title":"Connecting...","message":"Please wait"}}},"access":{"control":{"title":"You can now open the door","subtitle":"Please press the button below.","titleAuto":"Automated door access","subtitleAuto":"The door will open for you automatically","openBtn":"Open"},"status":{"success":{"title":"The door has been opened","message":""},"error":{"title":"Something went wrong","message":"Please contact your contact person to open the door."},"loading":{"title":"Opening the door...","message":""}}}}');


var $66925b64b4b1e32a$exports = {};
$66925b64b4b1e32a$exports = JSON.parse('{"language":{"title":"Choose your language","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Hi, how can we help you?","checkIn":"Check in","independentManualCheckIn":"No appointment","integratedManualCheckIn":"Check in manually","checkOut":"Check out","manualCheckOut":"Check out manually","parcelDelivery":"Parcel delivery","foodDelivery":"Food delivery","callReception":"Call reception","overview":"Overview","unavailable":"The reception is currently unavailable."},"check":{"option":{"checkin":{"title":"Choose an option to check in","manual":"Check in manually","code":"Check in with PIN or QR code","code-no-qr":"Check in with PIN code"},"checkout":{"title":"Choose an option to check out","manual":"Check out with name","code":"Check out with PIN or QR code","code-no-qr":"Check out with PIN code"}},"title":"You can now scan your QR code or enter your PIN code.","orText":"Or","qrScanner":{"checkin":{"title":"Choose an option to check in"},"checkout":{"title":"Choose an option to check out"},"btn":"Scan your QR code"},"hidScanner":{"title":"Hold QR code to the scanner below or enter your PIN code"},"pinOnly":{"title":"Please enter your PIN code"},"pinCode":"Enter your PIN code","manually":{"checkin":"Don\'t have a checkin code?"},"status":{"idle":{"title":"Your code is scanning.","message":"Please wait...","nfc":{"title":"Your tag is scanning.","message":"Please wait..."}},"loading":{"title":"Your code is scanning.","message":"Please wait...","nfc":{"title":"Your tag is scanning.","message":"Please wait..."}},"error":{"title":"Your code is invalid.","message":"Please try again!","nfc":{"title":"Your tag is invalid.","message":"Please try again!"},"meeting":{"tooEarly":{"title":"You\'re a bit early","message":"Your code is valid from {{validFromTime}}. The meeting starts at {{meetingStartTime}}."},"tooLate":{"title":"This code has expired","message":"The meeting ended at {{meetingEndTime}}. Your code was valid until {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"You have successfully checked in.","message":"Thank you."},"MeetingAttendee":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have successfully checked in.","message":"Your contact person has been notified."},"call-ping":{"title":"You have successfully checked in.","message":"We will now establish a phone call with your contact person."},"teams-call":{"title":"You have successfully checked in.","message":"We will now establish a Microsoft Teams call with your contact person."},"badge":{"title":"Thank you for checking in, your badge will be printed.","message":""},"video-call":{"title":"You have successfully checked in.","message":"Setting up your video call with the contact person."}},"Employee":{"title":"You have successfully checked in.","message":"Thank you.","badge":{"title":"Thank you for checking in, your badge will be printed.","message":""}},"Visitor":{"title":"You have successfully checked in.","message":"Thank you.","badge":{"title":"Thank you for checking in, your badge will be printed.","message":""}}},"checkout":{"default":{"title":"You have successfully checked out.<br/>","message":"See you again soon."},"MeetingAttendee":{"title":"You have successfully checked out.","message":"See you again soon."},"Employee":{"title":"You have successfully checked out.","message":"See you again soon."},"Visitor":{"title":"You have successfully checked out.","message":"See you again soon."},"access":{"title":"You have successfully checked out.","message":"You can now open the door."}}}}},"missingFields":{"title":"A few more details before check-in","subtitle":"Fields marked * are required","btn":"Check in","placeholder":{"other":"Other...","otherInput":"Enter your option"},"error":{"required":"You didn\'t fill in this field","email":"Invalid email address","phone":"Invalid phone number"}},"manualCheckin":{"title":{"default":"Please fill in.","documentScanner":"Pay attention when inserting your identity card:"},"subtitle":{"default":"Note - every field * is required","documentScanner":[{"parts":[{"text":"The side with the ","bold":false},{"text":"<<< >>> characters (MRZ)","bold":true},{"text":", must be ","bold":false},{"text":"facing the kiosk or scanner.","bold":true}]},{"parts":[{"text":"Hold the card still ","bold":false},{"text":"until the fields are filled in automatically.","bold":true}]}]},"noOption":"No option","btn":"Check in","placeholder":{"name":"Your name *","email":"Your e-mail *","phone":"Mobile number","contactName":"Your contact person*","other":"Other..."},"error":{"required":"You didn\'t fill in this field","name":"Invalid name","email":"Invalid email address","phone":"Invalid mobile number"},"status":{"idle":{"no-contact":{"title":"Please wait...","message":"Your registration is being processed."},"contact":{"title":"Please wait...","message":"Your contact is being notified."}},"loading":{"no-contact":{"title":"Please wait...","message":"Your registration is being processed."},"contact":{"title":"Please wait...","message":"Your contact is being notified."}},"success":{"no-email-sms":{"title":"You have successfully checked in.","message":"Thank you."},"email-sms":{"title":"You have successfully checked in.","message":"Your contact person is notified."},"call-ping":{"title":"You have successfully checked in.","message":"We will now establish a phone call with your contact person."},"teams-call":{"title":"You have successfully checked in.","message":" We will now establish a Microsoft Teams call with your contact person "},"badge":{"title":"Thank you for checking in, your badge will be printed.","message":""},"video-call":{"title":"You have successfully checked in.","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}},"documentScan":{"invalid":{"title":"Document not valid","message":"The document could not be verified or has expired. Please enter your details manually."}}},"manualCheckout":{"title":"Enter your name to check out","btn":"Check out","form":{"placeholder":{"name":"Your full name *"},"loading":"Loading...","noOptions":"No options"},"error":{"required":"You didn\'t fill in this field","name":"Invalid name"},"status":{"idle":{"title":"We are processing your information.","message":"Please wait..."},"loading":{"title":"We are processing your information.","message":"Please wait..."},"success":{"title":"You have successfully checked out.","message":"Thank you and have a nice day."},"successAccess":{"title":"You have successfully checked out.","message":"Now you can open the door."},"error":{"title":"An error occurred while checking out.","message":"Please try again!"}}},"call":{"title":{"no-email-sms":"Would you like to notify your contact?","email-sms":"We have sent an email/sms to your contact.<br/>Do you want to establish a call with them additionally?"},"callBtn":"Call","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Video call","teamsCallBtn":"Teams call","teamsMessageBtn":"Teams message","googleChatMessageBtn":"Google Chat","noBtn":"Cancel","cancelBtn":"Cancel call","status":{"connecting":{"title":"Establishing call.<br/>Please wait...","message":""},"ringing":{"title":"Calling your contact person<br/>Please wait...","message":""},"ringingReception":{"title":"Call started...","message":""},"open":{"title":"Call in progress.","message":""},"close":{"title":"Call ended.<br/>","message":""},"closeAccess":{"title":"Call ended.<br/>Now you can open the door.","message":""},"closeReception":{"title":"Call is ended.","message":""},"error":{"title":"Call is not established.<br/>Call again?","message":""}}},"message":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":"We are notifying your contact person.","message":"Please wait..."},"success":{"title":"SMS has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":" SMS has been sent. The contact has been notified. ","message":"Now you can open the door."},"error":{"title":"SMS not sent.","message":"Please try again!"}}},"videoCall":{"title":"Video call","endCall":"End call","status":{"idle":{"title":"We are creating a video room.","message":"Please wait..."},"loading":{"title":"We are creating a video room.","message":"Please wait..."},"success":{"title":"The video room has been successfully created.","message":"Joining room..."},"error":{"title":"The video room was not created successfully.","message":"Please try again!"}}},"teamsCall":{"title":"Teams call","controls":{"startCall":"Start call","endCall":"Leave","camera":"Camera","cameraOff":"Camera off","mic":"Mic","micOff":"Mic off","ringing":"Ringing...","noAnswer":"No one has answered the call."},"status":{"connecting":{"title":"Establishing call.<br/>Please wait...","message":""},"ringing":{"title":"Calling your contact person<br/>Please wait...","message":""},"connected":{"title":"Establishing call","message":""},"disconnected":{"title":"Call ended.<br/>","message":""},"disconnectedAccess":{"title":"Call ended.<br/>Now you can open the door.","message":""},"error":{"title":"Call is not established.<br/>Please try again","message":""},"noAnswer":{"title":"No one answered the call.<br/>Please try again.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":" We are notifying your contact person. ","message":"Please wait..."},"success":{"title":"Message has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":" Message has been sent. The contact has been notified. ","message":"Now you can open the door."},"error":{"title":"Message not sent.","message":"Please try again!"}}},"googleChatMessage":{"status":{"idle":{"title":"We are notifying your contact person.","message":"Please wait..."},"loading":{"title":" We are notifying your contact person. ","message":"Please wait..."},"success":{"title":"Message has been sent. The contact has been notified.","message":"Thank you!"},"successAccess":{"title":" Message has been sent. The contact has been notified. ","message":"Now you can open the door."},"error":{"title":"Message not sent.","message":"Please try again!"}}},"packageDelivery":{"title":"How nice of you to deliver a package!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"","input":{"label":{"contact":"Who is the parcel for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact person.","message":"Please wait..."},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact person has been notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to the contact person."},"teams-call":{"title":"Thank you for your delivery!","message":"A Microsoft Teams call will now be made to your contact person."},"video-call":{"title":"Thank you for your delivery!","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"foodDelivery":{"title":"How nice of you to deliver food!","subtitle":"Select and notify the recipient","subtitle1":"Press the button below to let us know you are here! ","subtitle2":"","input":{"label":{"contact":"Who is the food for"},"error":{"contact":{"required":"You didn\'t fill in this field"}}},"button":{"submit":"Notify"},"status":{"loading":{"title":"We are notifying the contact.","message":"Please wait!"},"success":{"no-email-sms":{"title":"Thank you for your delivery!","message":""},"email-sms":{"title":"The contact is notified.","message":"Thank you for your delivery!"},"call-ping":{"title":"Thank you for your delivery!","message":"A telephone connection will now be made to your contact person."},"teams-call":{"title":"Thank you for your delivery!","message":"A Microsoft Teams call will now be made to your contact person."},"video-call":{"title":"Thank you for your delivery!","message":"Setting up your video call with the contact person."}},"error":{"title":"Something went wrong.","message":"Please try again!"}}},"QRCodeScanner":{"title":"Please scan your QR code","subtitle":"Line up the QR code inside the red corners and keep your phone steady.","error":"Invalid QR code format","unknownError":"Unknown error occurred while scanning"},"common":{"backBtn":"Back"},"previewPDF":{"page":{"of":"of","previous":"Previous","next":"Next"},"button":{"cancel":"Cancel","accept":"Accept","next":"Next"},"title":{"consent":"Consent required"}},"offline":{"title":"Offline","receptionMessage":"The digital reception is offline at the moment and can not be used, the internet connection must be checked!","check":"Are you a visitor and do you want to speak to an employee directly? Please call {{receptionistPhone}}"},"overview":{"title":"Enter the code to open the overview!","noUsers":"No registrations","status":{"success":{"title":"The code is valid.","message":""},"error":{"title":"The code invalid.","message":"Please try again!"}},"checkoutStatus":{"loading":{"title":"Please wait...","message":""},"success":{"title":"Successful check out.","message":""},"error":{"title":"Something went wrong.","message":"Please try again!"}},"listTitle":"List of persons who checked in today but didn\'t check out","page":"Page ","table":{"head":{"fullName":"Name","type":"Type","checkedinAt":"Checked in at","host":"Host"},"type":{"Package":"Package delivery","Food":"Food delivery","Visitor":"Visitor","MeetingAttendee":"Invited visitor","Employee":"Employee","Guest":"Visitor"}},"confirmModal":{"title":"Are you sure you want to check out {{fullName}}?","cancel":"Cancel","checkout":"Check out"}},"wifi":{"title":"Connect to the Wi-Fi network"},"door":{"external":{"title":"Opening the door","subtitle":"The door will open shortly. Please wait..."},"control":{"title":"You can now open the door","subtitle":"Please press the button below!","openBtn":"Open the door"},"status":{"success":{"title":"The door has been opened","message":""},"error":{"title":"Something went wrong","message":"Please contact your contact person to open the door."},"loading":{"title":"Opening the door...","message":""}}},"photo":{"title":"Would you like to take a photo as part of your check-in process?","required":{"title":"Photo Verification Required!","instructions":"Please stand in front of the camera and follow the on-screen instructions.","securityNotice":"For security and verification purposes, a photo is required during check-in.","privacyInfo":"We respect your privacy. Your data is securely stored and used only for identification.","closingMessage":"Thank you for your cooperation."},"optional":{"title":"Would you like to take a photo as part of your check-in process?","instructions":"","securityNotice":"Taking a photo can help streamline identification and enhance security.","privacyInfo":"We respect your privacy. This step is optional, and your data will be securely handled.","closingMessage":"You can skip this step if you prefer."},"subtitle":"Please position yourself within the frame and remain still for the best result","button":{"cancel":"Cancel","accept":"Accept","skip":"Skip","next":"Next","recapture":"Recapture photo","continue":"Continue"},"error":"An error occurred while capturing the photo. The check-in process will continue without the photo."},"wayfinding":{"title":"Where would you like to go?"},"callingMenu":{"title":"Calling menu"},"bell":{"status":{"success":{"title":"The bell is ringing","message":"Someone will be with you shortly."},"error":{"title":"Something went wrong","message":"Please try again"},"loading":{"title":"Connecting...","message":"Please wait"}}},"access":{"control":{"title":"You can now open the door","subtitle":"Please press the button below.","titleAuto":"Automated door access","subtitleAuto":"The door will open for you automatically","openBtn":"Open"},"status":{"success":{"title":"The door has been opened","message":""},"error":{"title":"Something went wrong","message":"Please contact your contact person to open the door."},"loading":{"title":"Opening the door...","message":""}}}}');


var $e426d47f6742296e$exports = {};
$e426d47f6742296e$exports = JSON.parse('{"language":{"title":"Kies uw taal","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Hi! Waar kunnen we u mee helpen?","checkIn":"Check in","independentManualCheckIn":"Check in","integratedManualCheckIn":"Handmatig inchecken","checkOut":"Check uit","manualCheckOut":"Check uit","parcelDelivery":"Pakketbezorging","foodDelivery":"Voedselbezorging ","callReception":"Bel receptie","overview":"Overzicht","unavailable":"De receptie is momenteel niet beschikbaar."},"check":{"option":{"checkin":{"title":"Selecteer een optie om in te checken","manual":"Check handmatig in","code":"Check in met uw QR- of pincode","code-no-qr":"Check in met uw QR- of pincode"},"checkout":{"title":"Selecteer een optie om uit te checken","manual":"Check uit met uw naam","code":"Check uit met uw QR- of pincode","code-no-qr":"Check uit met uw QR- of pincode"}},"title":"U kunt nu uw QR-code scannen of pincode invoeren.","orText":"OF","qrScanner":{"checkin":{"title":"Kies een optie om in te checken"},"checkout":{"title":"Kies een optie om uit te checken"},"btn":"Scan uw QR-code"},"hidScanner":{"title":"Houd de QR-code voor de scanner hieronder of voer uw pincode in"},"pinOnly":{"title":"Voer uw pincode in"},"pinCode":"Voer uw pincode in","manually":{"checkin":"Heeft u geen QR- of pincode? <0>Handmatig inchecken</0>"},"status":{"idle":{"title":"Even geduld...","message":"Uw code wordt gescand.","nfc":{"title":"Even geduld...","message":"Uw tag wordt gescand."}},"loading":{"title":"Even geduld...","message":"Uw code wordt gescand.","nfc":{"title":"Even geduld...","message":"Uw tag wordt gescand."}},"error":{"title":"Probeer het opnieuw!","message":"Uw code is ongeldig.","nfc":{"title":"Probeer het opnieuw!","message":"Uw tag is ongeldig."},"meeting":{"tooEarly":{"title":"U bent iets te vroeg","message":"Uw code is geldig vanaf {{validFromTime}}. De afspraak begint om {{meetingStartTime}}."},"tooLate":{"title":"Deze code is verlopen","message":"De afspraak is om {{meetingEndTime}} be\xebindigd. Uw code was geldig tot {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"MeetingAttendee":{"no-email-sms":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"email-sms":{"title":"Bedankt voor het inchecken!","message":"Uw contactpersoon is op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."},"teams-call":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu een oproep gestart met uw contactpersoon."},"badge":{"title":"Bedankt voor het inchecken, uw badge wordt nu geprint.","message":""},"video-call":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu een videogesprek gestart met uw contactpersoon."}},"Employee":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!","badge":{"title":"Bedankt voor het inchecken, uw badge wordt nu geprint.","message":""}},"Visitor":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!","badge":{"title":"Bedankt voor het inchecken, uw badge wordt nu geprint.","message":""}}},"checkout":{"default":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"Employee":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"MeetingAttendee":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"Visitor":{"title":"Bedankt voor het uitchecken.","message":"Tot ziens!"},"access":{"title":"Bedankt voor het uitchecken.","message":"U kunt de deur nu openen."}}}}},"missingFields":{"title":"Nog enkele gegevens voor het inchecken","subtitle":"Velden met * zijn verplicht","btn":"Inchecken","placeholder":{"other":"Anders...","otherInput":"Vul uw optie in"},"error":{"required":"Dit veld is verplicht","email":"Ongeldig e-mailadres","phone":"Ongeldig telefoonnummer"}},"manualCheckin":{"title":{"default":"Vul uw gegevens hieronder in.","documentScanner":"Let op bij het plaatsen van uw identiteitskaart:"},"subtitle":{"default":"Elk veld * moet worden ingevuld","documentScanner":[{"parts":[{"text":"De ","bold":false},{"text":"zijde met de <<< >>>-tekens (MRZ) ","bold":true},{"text":"moet ","bold":false},{"text":"naar de kiosk / scanner gericht zijn.","bold":true}]},{"parts":[{"text":"Houd de kaart stil ","bold":false},{"text":"totdat de velden automatisch zijn ingevuld.","bold":true}]}]},"noOption":"Geen optie","btn":"Check in","placeholder":{"name":"Uw naam *","email":"Uw e-mail *","phone":"Uw telefoonnummer","contactName":"Contactpersoon*","other":"Anders..."},"error":{"required":"U heeft dit veld niet ingevuld","name":"Ongeldige naam","email":"Ongeldig e-mailadres","phone":"Ongeldig telefoonnummer"},"status":{"idle":{"no-contact":{"title":"Even geduld...","message":"Uw registratie wordt verwerkt."},"contact":{"title":"Even geduld...","message":"Uw contactpersoon wordt op de hoogte gebracht."}},"loading":{"no-contact":{"title":"Even geduld...","message":"Uw registratie wordt verwerkt."},"contact":{"title":"Even geduld...","message":"Uw contactpersoon wordt op de hoogte gebracht."}},"success":{"no-email-sms":{"title":"Bedankt voor het inchecken!","message":"Fijne dag!"},"email-sms":{"title":"Bedankt voor het inchecken!","message":"Uw contactpersoon is op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu een telefonische verbinding gemaakt met uw contactpersoon."},"teams-call":{"title":"Bedankt voor het inchecken! ","message":"Er wordt nu een oproep gestart met uw contactpersoon."},"badge":{"title":"Bedankt voor het inchecken, uw badge wordt nu geprint.","message":""},"video-call":{"title":"Bedankt voor het inchecken!","message":"Er wordt nu een videogesprek gestart met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}},"documentScan":{"invalid":{"title":"Document niet geldig","message":"Het document kon niet worden geverifieerd of is verlopen. Voer uw gegevens handmatig in."}}},"manualCheckout":{"title":"Voer uw naam in om uit te checken","btn":"Check uit","form":{"placeholder":{"name":"Uw volledige naam*"},"loading":"Laden...","noOptions":"Geen opties "},"error":{"required":"U hebt dit veld niet ingevuld","name":"Ongeldige naam"},"status":{"idle":{"title":"We verwerken uw informatie...","message":""},"loading":{"title":"We verwerken uw informatie...","message":""},"success":{"title":"Bedankt voor het uitchecken!","message":"Fijne dag!"},"successAccess":{"title":"Bedankt voor het uitchecken.","message":"U kunt de deur nu openen."},"error":{"title":"Er is iets misgegaan tijdens het uitchecken.","message":"Probeer het opnieuw."}}},"call":{"title":{"no-email-sms":"Wilt u uw contactpersoon op de hoogte brengen?","email-sms":"We hebben een notificatie naar uw contactpersoon verstuurd."},"callBtn":"Bellen","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videogesprek","teamsCallBtn":"Bellen","teamsMessageBtn":"Notificatie","googleChatMessageBtn":"Google Chat","noBtn":"Terug","cancelBtn":"Gesprek be\xebindigen","status":{"connecting":{"title":"Gesprek starten","message":"Even geduld."},"ringing":{"title":"Er wordt verbinding gemaakt.<br/>Even geduld...","message":""},"ringingReception":{"title":"Oproep gestart...","message":""},"open":{"title":"Gesprek bezig.","message":""},"close":{"title":"Gesprek be\xebindigd.<br/>","message":""},"closeAccess":{"title":"Gesprek be\xebindigd.<br/>U kunt de deur nu openen..","message":""},"closeReception":{"title":"Gesprek is be\xebindigd.","message":""},"error":{"title":"Error!<br/>Er is iets misgegaan.","message":""}}},"message":{"status":{"idle":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"loading":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"success":{"title":"De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"Bedankt!"},"successAccess":{"title":"De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"U kunt de deur nu openen."},"error":{"title":"SMS niet verzonden.","message":"Probeer het opnieuw!"}}},"videoCall":{"title":"Videogesprek","endCall":"Einde gesprek ","status":{"idle":{"title":" Er wordt een videoverbinding gemaakt. ","message":"E\xe9n moment geduld alstublieft..."},"loading":{"title":" Er wordt een videoverbinding gemaakt. ","message":"E\xe9n moment geduld alstublieft..."},"success":{"title":"De videoverbinding is tot stand gebracht.","message":"Het videogesprek wordt opgestart..."},"error":{"title":"Het videogesprek kan niet opgestart worden.","message":"Probeer het alstublieft opnieuw!"}}},"teamsCall":{"title":"Oproep","controls":{"startCall":"Gesprek starten","endCall":"Gesprek verlaten","camera":"Camera","cameraOff":"Camera uit","mic":"Microfoon","micOff":"Microfoon uit","ringing":"Gaat over...","noAnswer":"Uw oproep is niet beantwoord."},"status":{"connecting":{"title":"Oproep wordt tot stand gebracht.<br/>Even geduld...","message":""},"ringing":{"title":"Contactpersoon wordt gebeld<br/>Even geduld...","message":""},"connected":{"title":"Oproep bezig.","message":""},"disconnected":{"title":"Oproep be\xebindigd.<br/>. ","message":""},"disconnectedAccess":{"title":"Oproep be\xebindigd.<br/>U kunt de deur nu openen.","message":""},"error":{"title":"Oproep kon niet worden gestart.<br/>Probeer het opnieuw.","message":""},"noAnswer":{"title":"De oproep is niet beantwoord.<br/>Probeer het opnieuw.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"loading":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"success":{"title":"Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"Bedankt!"},"successAccess":{"title":"Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"U kunt de deur nu openen."},"error":{"title":"Bericht niet verzonden.","message":"Probeer het opnieuw!"}}},"googleChatMessage":{"status":{"idle":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"loading":{"title":"Uw contactpersoon wordt op de hoogte gebracht.","message":"Even geduld..."},"success":{"title":"Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"Bedankt!"},"successAccess":{"title":"Bericht is verzonden. Uw contactpersoon wordt op de hoogte gebracht.","message":"U kunt de deur nu openen."},"error":{"title":"Bericht niet verzonden.","message":"Probeer het opnieuw!"}}},"packageDelivery":{"title":"Wat fijn dat u een pakket komt bezorgen!","subtitle":"Selecteer en breng de ontvanger op de hoogte","subtitle1":"Klik op onderstaande knop zodat we weten dat u er bent!","subtitle2":"","input":{"label":{"contact":"Voor wie is het pakket?"},"error":{"contact":{"required":"U heeft dit veld niet ingevuld."}}},"button":{"submit":"Breng op de hoogte"},"status":{"loading":{"title":"De ontvanger wordt op de hoogte gebracht.","message":"Even geduld."},"success":{"no-email-sms":{"title":"Bedankt voor het bezorgen!","message":""},"email-sms":{"title":"Bedankt voor het bezorgen!","message":"De ontvanger wordt op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."},"teams-call":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu een oproep gestart met uw contactpersoon."},"video-call":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu een video-oproep gestart met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}}},"foodDelivery":{"title":"Wat fijn dat u eten komt bezorgen!","subtitle":"Selecteer en breng de ontvanger op de hoogte","subtitle1":"Klik op onderstaande knop zodat we weten dat u er bent!","subtitle2":"","input":{"label":{"contact":"Voor wie is het eten?"},"error":{"contact":{"required":"U heeft dit veld niet ingevuld"}}},"button":{"submit":"Breng op de hoogte"},"status":{"loading":{"title":"De ontvanger wordt op de hoogte gebracht.","message":"Even geduld."},"success":{"no-email-sms":{"title":"Bedankt voor het bezorgen!","message":""},"email-sms":{"title":"Bedankt voor het bezorgen!","message":"De ontvanger wordt op de hoogte gebracht."},"call-ping":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."},"teams-call":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu een oproep gestart met uw contactpersoon."},"video-call":{"title":"Bedankt voor het bezorgen!","message":"Er wordt nu een video-oproep gestart met uw contactpersoon."}},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}}},"QRCodeScanner":{"title":"Scan uw QR-code","subtitle":"Plaats de QR-code in de rode hoeken en houd uw telefoon stil.","error":"Ongeldige QR-code","unknownError":"Er is een onbekende fout opgetreden tijdens het scannen"},"common":{"backBtn":"Terug"},"previewPDF":{"page":{"previous":"Vorige pagina","next":"Volgende pagina","of":"van"},"button":{"cancel":"Annuleren","accept":"Accepteren","next":"Volgende"},"title":{"consent":"Toestemming vereist"}},"offline":{"title":"Offline","receptionMessage":"De digitale receptie is momenteel offline en kan niet worden gebruikt, de internetverbinding moet worden gecontroleerd!","check":"Wilt u direct met een medewerker spreken? Bel dan {{receptionistPhone}}"},"overview":{"title":"Voer de code in om het overzicht te openen!","noUsers":"Geen registraties","status":{"success":{"title":"De code is geldig.","message":""},"error":{"title":"De code is ongeldig.","message":"Probeer het opnieuw!"}},"checkoutStatus":{"loading":{"title":"Even geduld...","message":""},"success":{"title":"Bedankt voor het uitchecken!","message":""},"error":{"title":"Er ging iets verkeerd.","message":"Probeer het opnieuw!"}},"listTitle":"Lijst van personen die vandaag zijn ingecheckt maar nog niet zijn uitgecheckt","page":"Pagina ","table":{"head":{"fullName":"Naam","type":"Type","checkedinAt":"Ingecheckt op","host":"Contactpersoon"},"type":{"Package":"Pakketbezorging","Food":"Voedselbezorging","Visitor":"Bezoeker","MeetingAttendee":"Uitgenodigde bezoeker","Employee":"Medewerker","Guest":"Bezoeker "}},"confirmModal":{"title":"Weet u zeker dat u {{fullName}} wilt uitchecken?","cancel":"Annuleren","checkout":"Uitchecken"}},"wifi":{"title":"Verbind met het wifi-netwerk"},"door":{"external":{"title":"Deur openen","subtitle":"We openen de deur voor u, even geduld..."},"control":{"title":"U kunt nu de deur openen.","subtitle":"Druk op de knop hieronder!","openBtn":"Deur openen"},"status":{"success":{"title":"De deur is geopend.","message":""},"error":{"title":"Er is iets misgegaan.","message":"Benader uw contactpersoon om de deur voor u te openen!"},"loading":{"title":"De deur opent...","message":""}}},"photo":{"title":"Wilt u een foto maken als onderdeel van uw incheckproces?","required":{"title":"Fotoverificatie vereist!","instructions":"Ga voor de camera staan en volg de instructies op het scherm.","securityNotice":"Voor beveiligings- en verificatiedoeleinden is een foto vereist tijdens het inchecken.","privacyInfo":"Wij respecteren uw privacy. Uw gegevens worden veilig opgeslagen en alleen gebruikt voor identificatie.","closingMessage":"Dank u voor uw medewerking."},"optional":{"title":"Wilt u een foto maken als onderdeel van uw incheckproces?","instructions":"","securityNotice":"Een foto kan helpen bij een snellere identificatie en verhoogde veiligheid.","privacyInfo":"Wij respecteren uw privacy. Deze stap is optioneel en uw gegevens worden veilig verwerkt.","closingMessage":"U kunt deze stap overslaan. "},"subtitle":"Plaats uzelf binnen het kader en sta stil voor het beste resultaat.","button":{"cancel":"Annuleren","accept":"Accepteren","skip":"Overslaan","next":"Volgende","recapture":"Foto opnieuw maken","continue":"Doorgaan"},"error":"Er is een fout opgetreden tijdens het maken van de foto. Het incheckproces gaat verder zonder de foto."},"wayfinding":{"title":"Waar wilt u naartoe?"},"callingMenu":{"title":"Belmenu"},"bell":{"status":{"success":{"title":"De bel gaat af","message":"Er komt spoedig iemand aan."},"error":{"title":"Er is iets misgegaan","message":"Probeer het opnieuw"},"loading":{"title":"Verbinding maken met de bel...","message":"Een ogenblik geduld"}}},"access":{"control":{"title":"U kunt nu de deur openen.","subtitle":"Druk op de knop hieronder!","titleAuto":"Geautomatiseerde toegang","subtitleAuto":"De deur gaat automatisch voor u open.","openBtn":"Openen"},"status":{"success":{"title":"De deur is geopend.","message":""},"error":{"title":"Er is iets misgegaan.","message":"Benader uw contactpersoon om de deur voor u te openen."},"loading":{"title":"De deur opent...","message":""}}}}');


var $a18874184f267ca0$exports = {};
$a18874184f267ca0$exports = JSON.parse('{"language":{"title":"Izaberite jezik","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Zdravo, kako mo\u017Eemo da vam pomognemo?","checkIn":"Prijavljivanje","independentManualCheckIn":"Bez termina","integratedManualCheckIn":"Ru\u010Dno prijavljivanje","checkOut":"Odjavljivanje","manualCheckOut":"Ru\u010Dno odjavljivanje","parcelDelivery":"Dostava paketa","foodDelivery":"Dostava hrane","callReception":"Pozovite recepciju","overview":"Pregled","unavailable":"Recepcija trenutno nije dostupna."},"check":{"option":{"checkin":{"title":"Izaberite opciju za prijavljivanje","manual":"Ru\u010Dno prijavljivanje","code":"Prijavite se PIN-om ili QR kodom","code-no-qr":"Prijavite se PIN kodom"},"checkout":{"title":"Izaberite opciju za odjavljivanje","manual":"Odjavite se imenom","code":"Odjavite se PIN-om ili QR kodom","code-no-qr":"Odjavite se PIN kodom"}},"title":"Sada mo\u017Eete da skenirate QR kod ili unesete PIN kod.","orText":"Ili","qrScanner":{"checkin":{"title":"Izaberite opciju za prijavljivanje"},"checkout":{"title":"Izaberite opciju za odjavljivanje"},"btn":"Skenirajte QR kod"},"hidScanner":{"title":"Prinesite QR kod skeneru ispod ili unesite PIN kod"},"pinOnly":{"title":"Unesite PIN kod"},"pinCode":"Unesite PIN kod","manually":{"checkin":"Nemate kod za prijavljivanje?"},"status":{"idle":{"title":"Skenira se kod.","message":"Molimo sa\u010Dekajte...","nfc":{"title":"Va\u0161 tag se skenira.","message":"Molimo sa\u010Dekajte..."}},"loading":{"title":"Skenira se kod.","message":"Molimo sa\u010Dekajte...","nfc":{"title":"Va\u0161 tag se skenira.","message":"Molimo sa\u010Dekajte..."}},"error":{"title":"Kod je neispravan.","message":"Molimo poku\u0161ajte ponovo!","nfc":{"title":"Tag nije validan.","message":"Molimo poku\u0161ajte ponovo!"},"meeting":{"tooEarly":{"title":"Stigli ste malo ranije","message":"Va\u0161 kod va\u017Ei od {{validFromTime}}. Sastanak po\u010Dinje u {{meetingStartTime}}."},"tooLate":{"title":"Ovaj kod je istekao","message":"Sastanak se zavr\u0161io u {{meetingEndTime}}. Va\u0161 kod je va\u017Eio do {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Uspe\u0161no ste se prijavili.","message":"Hvala vam."},"MeetingAttendee":{"no-email-sms":{"title":"Uspe\u0161no ste se prijavili.","message":"Hvala vam."},"email-sms":{"title":"Uspe\u0161no ste se prijavili.","message":"Va\u0161a kontakt osoba je obave\u0161tena."},"call-ping":{"title":"Uspe\u0161no ste se prijavili.","message":"Sada \u0107emo uspostaviti telefonski poziv sa va\u0161om kontakt osobom."},"teams-call":{"title":"Uspe\u0161no ste se prijavili.","message":"Sada \u0107emo uspostaviti Microsoft Teams poziv sa va\u0161om kontakt osobom."},"badge":{"title":"Hvala vam \u0161to ste se prijavili, va\u0161a bed\u017E \u0107e biti od\u0161tampan.","message":""},"video-call":{"title":"Uspe\u0161no ste se prijavili.","message":"Uspostavljanje video poziva sa kontakt osobom."}},"Employee":{"title":"Uspe\u0161no ste se prijavili.","message":"Hvala vam.","badge":{"title":"Hvala vam \u0161to ste se prijavili, va\u0161a bed\u017E \u0107e biti od\u0161tampan.","message":""}},"Visitor":{"title":"Uspe\u0161no ste se prijavili.","message":"Hvala vam.","badge":{"title":"Hvala vam \u0161to ste se prijavili, va\u0161a bed\u017E \u0107e biti od\u0161tampan.","message":""}}},"checkout":{"default":{"title":"Uspe\u0161no ste se odjavili.<br/>","message":"Vidimo se uskoro."},"MeetingAttendee":{"title":"Uspe\u0161no ste se odjavili.","message":"Vidimo se uskoro."},"Employee":{"title":"Uspe\u0161no ste se odjavili.","message":"Vidimo se uskoro."},"Visitor":{"title":"Uspe\u0161no ste se odjavili.","message":"Vidimo se uskoro."},"access":{"title":"Uspe\u0161no ste se odjavili.","message":"Sada mo\u017Eete da otvorite vrata."}}}}},"missingFields":{"title":"Jo\u0161 par podataka pre prijave","subtitle":"Polja ozna\u010Dena sa * su obavezna","btn":"Prijavite se","placeholder":{"other":"Drugo...","otherInput":"Unesite svoju opciju"},"error":{"required":"Niste popunili ovo polje","email":"Neispravna e-mail adresa","phone":"Neispravan broj telefona"}},"manualCheckin":{"title":{"default":"Molimo popunite.","documentScanner":"Obratite pa\u017Enju prilikom ubacivanja dokumenta:"},"subtitle":{"default":"Napomena - svako polje * je obavezno","documentScanner":[{"parts":[{"text":"Strana sa ","bold":false},{"text":"znakovima <<< >>> (MRZ) ","bold":true},{"text":"mora biti ","bold":false},{"text":"okrenuta prema kiosku / skeneru.","bold":true}]},{"parts":[{"text":"Dr\u017Eite karticu mirno ","bold":false},{"text":"dok se polja ne popune automatski.","bold":true}]}]},"noOption":"Nema opcije","btn":"Prijavite se","placeholder":{"name":"Va\u0161e ime *","email":"Va\u0161 e-mail *","phone":"Broj mobilnog","contactName":"Va\u0161a kontakt osoba*","other":"Ostalo..."},"error":{"required":"Niste popunili ovo polje","name":"Neispravno ime","email":"Neispravna e-mail adresa","phone":"Neispravan broj mobilnog"},"status":{"idle":{"no-contact":{"title":"Molimo sa\u010Dekajte...","message":"Va\u0161a registracija se obra\u0111uje."},"contact":{"title":"Molimo sa\u010Dekajte...","message":"Va\u0161 kontakt se obave\u0161tava."}},"loading":{"no-contact":{"title":"Molimo sa\u010Dekajte...","message":"Va\u0161a registracija se obra\u0111uje."},"contact":{"title":"Molimo sa\u010Dekajte...","message":"Va\u0161 kontakt se obave\u0161tava."}},"success":{"no-email-sms":{"title":"Uspe\u0161no ste se prijavili.","message":"Hvala vam."},"email-sms":{"title":"Uspe\u0161no ste se prijavili.","message":"Va\u0161a kontakt osoba je obave\u0161tena."},"call-ping":{"title":"Uspe\u0161no ste se prijavili.","message":"Sada \u0107emo uspostaviti telefonski poziv sa va\u0161om kontakt osobom."},"teams-call":{"title":"Uspe\u0161no ste se prijavili.","message":"Sada \u0107emo uspostaviti Microsoft Teams poziv sa va\u0161om kontakt osobom."},"badge":{"title":"Hvala vam \u0161to ste se prijavili, va\u0161a bed\u017E \u0107e biti od\u0161tampan.","message":""},"video-call":{"title":"Uspe\u0161no ste se prijavili.","message":"Uspostavljanje video poziva sa kontakt osobom."}},"error":{"title":"Ne\u0161to je po\u0161lo po zlu.","message":"Molimo poku\u0161ajte ponovo!"}},"documentScan":{"invalid":{"title":"Dokument nije va\u017Ee\u0107i","message":"Dokument nije mogu\u0107e verifikovati ili je istekao. Molimo unesite svoje podatke ru\u010Dno."}}},"manualCheckout":{"title":"Unesite svoje ime da se odjavite","btn":"Odjavite se","form":{"placeholder":{"name":"Va\u0161e puno ime *"},"loading":"U\u010Ditava...","noOptions":"Nema opcija"},"error":{"required":"Niste popunili ovo polje","name":"Neispravno ime"},"status":{"idle":{"title":"Obra\u0111ujemo va\u0161e informacije.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Obra\u0111ujemo va\u0161e informacije.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"Uspe\u0161no ste se odjavili.","message":"Hvala vam i prijatan dan."},"successAccess":{"title":"Uspe\u0161no ste se odjavili.","message":"Sada mo\u017Eete da otvorite vrata."},"error":{"title":"Do\u0161lo je do gre\u0161ke tokom odjavljivanja.","message":"Molimo poku\u0161ajte ponovo!"}}},"call":{"title":{"no-email-sms":"\u017Delite li da obavestite svoju kontakt osobu?","email-sms":"Poslali smo e-mail/SMS va\u0161oj kontakt osobi.<br/>Da li \u017Eelite dodatno da uspostavite poziv sa njima?"},"callBtn":"Pozovite","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Video poziv","teamsCallBtn":"Teams poziv","teamsMessageBtn":"Teams poruka","googleChatMessageBtn":"Google Chat","noBtn":"Otka\u017Ei","cancelBtn":"Otka\u017Ei poziv","status":{"connecting":{"title":"Uspostavlja se poziv.<br/>Molimo sa\u010Dekajte...","message":""},"ringing":{"title":"Pozivamo va\u0161u kontakt osobu<br/>Molimo sa\u010Dekajte...","message":""},"ringingReception":{"title":"Poziv je zapo\u010Det...","message":""},"open":{"title":"Poziv je u toku.","message":""},"close":{"title":"Poziv je zavr\u0161en.<br/>","message":""},"closeAccess":{"title":"Poziv je zavr\u0161en.<br/>Sada mo\u017Eete da otvorite vrata.","message":""},"closeReception":{"title":"Poziv je zavr\u0161en.","message":""},"error":{"title":"Poziv nije uspostavljen.<br/>Pozovite ponovo?","message":""}}},"message":{"status":{"idle":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"SMS je poslat. Kontakt je obave\u0161ten.","message":"Hvala vam!"},"successAccess":{"title":"SMS je poslat. Kontakt je obave\u0161ten.","message":"Sada mo\u017Eete da otvorite vrata."},"error":{"title":"SMS nije poslat.","message":"Molimo poku\u0161ajte ponovo!"}}},"videoCall":{"title":"Video poziv","endCall":"Zavr\u0161i poziv","status":{"idle":{"title":"Kreiramo video sobu.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Kreiramo video sobu.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"Video soba je uspe\u0161no kreirana.","message":"Ulazimo u sobu..."},"error":{"title":"Video soba nije uspe\u0161no kreirana.","message":"Molimo poku\u0161ajte ponovo!"}}},"teamsCall":{"title":"Teams poziv","controls":{"startCall":"Zapo\u010Dni poziv","endCall":"Iza\u0111i","camera":"Kamera","cameraOff":"Isklju\u010Di kameru","mic":"Mikrofon","micOff":"Isklju\u010Di mikrofon","ringing":"Poziva...","noAnswer":"Niko se nije javio."},"status":{"connecting":{"title":"Uspostavlja se poziv.<br/>Molimo sa\u010Dekajte...","message":""},"ringing":{"title":"Pozivamo va\u0161u kontakt osobu<br/>Molimo sa\u010Dekajte...","message":""},"connected":{"title":"Uspostavlja se poziv","message":""},"disconnected":{"title":"Poziv je zavr\u0161en.<br/>","message":""},"disconnectedAccess":{"title":"Poziv je zavr\u0161en.<br/>Sada mo\u017Eete da otvorite vrata.","message":""},"error":{"title":"Poziv nije uspostavljen.<br/>Molimo poku\u0161ajte ponovo","message":""},"noAnswer":{"title":"Niko se nije javio.<br/>Molimo poku\u0161ajte ponovo.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"Poruka je poslata. Kontakt je obave\u0161ten.","message":"Hvala vam!"},"successAccess":{"title":"Poruka je poslata. Kontakt je obave\u0161ten.","message":"Sada mo\u017Eete da otvorite vrata."},"error":{"title":"Poruka nije poslata.","message":"Molimo poku\u0161ajte ponovo!"}}},"googleChatMessage":{"status":{"idle":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"loading":{"title":"Obave\u0161tavamo va\u0161u kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"success":{"title":"Poruka je poslata. Kontakt je obave\u0161ten.","message":"Hvala vam!"},"successAccess":{"title":"Poruka je poslata. Kontakt je obave\u0161ten.","message":"Sada mo\u017Eete da otvorite vrata."},"error":{"title":"Poruka nije poslata.","message":"Molimo poku\u0161ajte ponovo!"}}},"packageDelivery":{"title":"Kako je lepo \u0161to dostavljate paket!","subtitle":"Izaberite i obavestite primaoca","subtitle1":"Pritisnite dugme ispod da nas obavestite da ste tu!","subtitle2":"","input":{"label":{"contact":"Za koga je paket"},"error":{"contact":{"required":"Niste popunili ovo polje"}}},"button":{"submit":"Obavesti"},"status":{"loading":{"title":"Obave\u0161tavamo kontakt osobu.","message":"Molimo sa\u010Dekajte..."},"success":{"no-email-sms":{"title":"Hvala vam na dostavi!","message":""},"email-sms":{"title":"Kontakt osoba je obave\u0161tena.","message":"Hvala vam na dostavi!"},"call-ping":{"title":"Hvala vam na dostavi!","message":"Sada \u0107e se uspostaviti telefonska veza sa kontakt osobom."},"teams-call":{"title":"Hvala vam na dostavi!","message":"Sada \u0107e se uspostaviti Microsoft Teams poziv sa va\u0161om kontakt osobom."},"video-call":{"title":"Hvala vam na dostavi!","message":"Uspostavljanje video poziva sa kontakt osobom."}},"error":{"title":"Ne\u0161to je po\u0161lo po zlu.","message":"Molimo poku\u0161ajte ponovo!"}}},"foodDelivery":{"title":"Kako je lepo \u0161to dostavljate hranu!","subtitle":"Izaberite i obavestite primaoca","subtitle1":"Pritisnite dugme ispod da nas obavestite da ste tu!","subtitle2":"","input":{"label":{"contact":"Za koga je hrana"},"error":{"contact":{"required":"Niste popunili ovo polje"}}},"button":{"submit":"Obavesti"},"status":{"loading":{"title":"Obave\u0161tavamo kontakt.","message":"Molimo sa\u010Dekajte!"},"success":{"no-email-sms":{"title":"Hvala vam na dostavi!","message":""},"email-sms":{"title":"Kontakt je obave\u0161ten.","message":"Hvala vam na dostavi!"},"call-ping":{"title":"Hvala vam na dostavi!","message":"Sada \u0107e se uspostaviti telefonska veza sa va\u0161om kontakt osobom."},"teams-call":{"title":"Hvala vam na dostavi!","message":"Sada \u0107e se uspostaviti Microsoft Teams poziv sa va\u0161om kontakt osobom."},"video-call":{"title":"Hvala vam na dostavi!","message":"Uspostavljanje video poziva sa kontakt osobom."}},"error":{"title":"Ne\u0161to je po\u0161lo po zlu.","message":"Molimo poku\u0161ajte ponovo!"}}},"QRCodeScanner":{"title":"Molimo skenirajte QR kod","subtitle":"Poravnajte QR kod unutar crvenih uglova i dr\u017Eite telefon mirno.","error":"Neispravan format QR koda","unknownError":"Do\u0161lo je do nepoznate gre\u0161ke tokom skeniranja"},"common":{"backBtn":"Nazad"},"previewPDF":{"page":{"of":"od","previous":"Prethodna","next":"Slede\u0107a"},"button":{"cancel":"Otka\u017Ei","accept":"Prihvati","next":"Slede\u0107e"},"title":{"consent":"Potrebna saglasnost"}},"offline":{"title":"Van mre\u017Ee","receptionMessage":"Digitalna recepcija je trenutno van mre\u017Ee i ne mo\u017Ee se koristiti, potrebno je proveriti internet konekciju!","check":"Da li ste posetilac i \u017Eelite da razgovarate sa zaposlenim direktno? Molimo pozovite {{receptionistPhone}}"},"overview":{"title":"Unesite kod da otvorite pregled!","noUsers":"Nema registracija","status":{"success":{"title":"Kod je valjan.","message":""},"error":{"title":"Kod je neispravan.","message":"Molimo poku\u0161ajte ponovo!"}},"checkoutStatus":{"loading":{"title":"Molimo sa\u010Dekajte...","message":""},"success":{"title":"Uspe\u0161no odjavljivanje.","message":""},"error":{"title":"Ne\u0161to je po\u0161lo po zlu.","message":"Molimo poku\u0161ajte ponovo!"}},"listTitle":"Lista osoba koje su se prijavile danas ali se nisu odjavile","page":"Stranica ","table":{"head":{"fullName":"Ime","type":"Tip","checkedinAt":"Prijavljen u","host":"Doma\u0107in"},"type":{"Package":"Dostava paketa","Food":"Dostava hrane","Visitor":"Posetilac","MeetingAttendee":"Pozvan posetilac","Employee":"Zaposleni","Guest":"Posetilac"}},"confirmModal":{"title":"Da li ste sigurni da \u017Eelite da odjavite {{fullName}}?","cancel":"Otka\u017Ei","checkout":"Odjavi"}},"wifi":{"title":"Pove\u017Eite se na Wi-Fi mre\u017Eu"},"door":{"external":{"title":"Otvaranje vrata","subtitle":"Vrata \u0107e se uskoro otvoriti. Molimo sa\u010Dekajte..."},"control":{"title":"Sada mo\u017Eete da otvorite vrata","subtitle":"Molimo pritisnite dugme ispod!","openBtn":"Otvori vrata"},"status":{"success":{"title":"Vrata su otvorena","message":""},"error":{"title":"Ne\u0161to je po\u0161lo po zlu","message":"Molimo kontaktirajte svoju kontakt osobu da otvori vrata."},"loading":{"title":"Vrata se otvaraju...","message":""}}},"photo":{"title":"Da li \u017Eelite da napravite fotografiju kao deo procesa prijavljivanja?","required":{"title":"Potrebna je verifikacija fotografijom!","instructions":"Molimo stanite pred kameru i pratite instrukcije na ekranu.","securityNotice":"Iz bezbednosnih razloga i radi verifikacije, fotografija je potrebna tokom prijavljivanja.","privacyInfo":"Po\u0161tujemo va\u0161u privatnost. Va\u0161i podaci se bezbedno \u010Duvaju i koriste se samo za identifikaciju.","closingMessage":"Hvala vam na saradnji."},"optional":{"title":"Da li \u017Eelite da napravite fotografiju kao deo procesa prijavljivanja?","instructions":"","securityNotice":"Fotografisanje mo\u017Ee pomo\u0107i u ubrzanju identifikacije i pobolj\u0161anju bezbednosti.","privacyInfo":"Po\u0161tujemo va\u0161u privatnost. Ovaj korak je opcionalan, a va\u0161i podaci \u0107e biti bezbedno obra\u0111eni.","closingMessage":"Mo\u017Eete presko\u010Diti ovaj korak ako \u017Eelite."},"subtitle":"Molimo pozicionirajte se unutar okvira i ne mrdajte za najbolji rezultat","button":{"cancel":"Otka\u017Ei","accept":"Prihvati","skip":"Presko\u010Di","next":"Slede\u0107e","recapture":"Ponovo fotografi\u0161i","continue":"Nastavi"},"error":"Do\u0161lo je do gre\u0161ke tokom fotografisanja. Proces prijavljivanja \u0107e se nastaviti bez fotografije."},"wayfinding":{"title":"Gde \u017Eelite da idete?"},"callingMenu":{"title":"Meni za pozivanje"},"bell":{"status":{"success":{"title":"Zvono zvoni","message":"Neko \u0107e uskoro do\u0107i."},"error":{"title":"Ne\u0161to nije u redu","message":"Poku\u0161ajte ponovo"},"loading":{"title":"Povezivanje...","message":"Molimo sa\u010Dekajte"}}},"access":{"control":{"title":"Sada mo\u017Eete da otvorite vrata","subtitle":"Molimo pritisnite dugme ispod.","titleAuto":"Automatski pristup vratima","subtitleAuto":"Vrata \u0107e se otvoriti automatski za vas","openBtn":"Otvori"},"status":{"success":{"title":"Vrata su otvorena","message":""},"error":{"title":"Ne\u0161to je po\u0161lo po zlu","message":"Molimo kontaktirajte svoju kontakt osobu da otvori vrata."},"loading":{"title":"Vrata se otvaraju...","message":""}}}}');


var $4ef112052723529f$exports = {};
$4ef112052723529f$exports = JSON.parse('{"language":{"title":"Choisissez votre langue","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Bonjour, comment pouvons-nous vous aider ?","checkIn":"Enregistrement","independentManualCheckIn":"Sans rendez-vous","integratedManualCheckIn":"Enregistrement manuel","checkOut":"D\xe9part","manualCheckOut":"D\xe9part manuel","parcelDelivery":"Livraison de colis","foodDelivery":"Livraison de nourriture","callReception":"Appeler la r\xe9ception","overview":"Aper\xe7u","unavailable":"La r\xe9ception est actuellement indisponible."},"check":{"option":{"checkin":{"title":"Choisissez une option pour vous enregistrer","manual":"Enregistrement manuel","code":"Enregistrement avec code PIN ou QR","code-no-qr":"Enregistrement avec code PIN"},"checkout":{"title":"Choisissez une option pour partir","manual":"D\xe9part avec nom","code":"D\xe9part avec code PIN ou QR","code-no-qr":"D\xe9part avec code PIN"}},"title":"Vous pouvez maintenant scanner votre code QR ou saisir votre code PIN.","orText":"Ou","qrScanner":{"checkin":{"title":"Choisissez une option pour vous enregistrer"},"checkout":{"title":"Choisissez une option pour partir"},"btn":"Scanner votre code QR"},"hidScanner":{"title":"Pr\xe9sentez le code QR au scanner ci-dessous ou saisissez votre code PIN"},"pinOnly":{"title":"Veuillez saisir votre code PIN"},"pinCode":"Saisissez votre code PIN","manually":{"checkin":"Vous n\'avez pas de code d\'enregistrement ?"},"status":{"idle":{"title":"Votre code est en cours de scan.","message":"Veuillez patienter...","nfc":{"title":"Votre badge est en cours de lecture.","message":"Veuillez patienter..."}},"loading":{"title":"Votre code est en cours de scan.","message":"Veuillez patienter...","nfc":{"title":"Votre badge est en cours de lecture.","message":"Veuillez patienter..."}},"error":{"title":"Votre code n\'est pas valide.","message":"Veuillez r\xe9essayer !","nfc":{"title":"Votre badge est invalide.","message":"Veuillez r\xe9essayer !"},"meeting":{"tooEarly":{"title":"Vous \xeates un peu en avance","message":"Votre code est valide \xe0 partir de {{validFromTime}}. La r\xe9union commence \xe0 {{meetingStartTime}}."},"tooLate":{"title":"Ce code a expir\xe9","message":"La r\xe9union s\'est termin\xe9e \xe0 {{meetingEndTime}}. Votre code \xe9tait valide jusqu\'\xe0 {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"MeetingAttendee":{"no-email-sms":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"email-sms":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Votre personne de contact a \xe9t\xe9 notifi\xe9e."},"call-ping":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Nous allons maintenant \xe9tablir un appel t\xe9l\xe9phonique avec votre personne de contact."},"teams-call":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Nous allons maintenant \xe9tablir un appel Microsoft Teams avec votre personne de contact."},"badge":{"title":"Merci pour votre enregistrement, votre badge va \xeatre imprim\xe9.","message":""},"video-call":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Configuration de votre appel vid\xe9o avec la personne de contact."}},"Employee":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci.","badge":{"title":"Merci pour votre enregistrement, votre badge va \xeatre imprim\xe9.","message":""}},"Visitor":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci.","badge":{"title":"Merci pour votre enregistrement, votre badge va \xeatre imprim\xe9.","message":""}}},"checkout":{"default":{"title":"Vous \xeates parti avec succ\xe8s.<br/>","message":"\xc0 bient\xf4t."},"MeetingAttendee":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."},"Employee":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."},"Visitor":{"title":"Vous \xeates parti avec succ\xe8s.","message":"\xc0 bient\xf4t."},"access":{"title":"Vous \xeates parti avec succ\xe8s.","message":"Vous pouvez maintenant ouvrir la porte."}}}}},"missingFields":{"title":"Encore quelques informations avant l\'enregistrement","subtitle":"Les champs marqu\xe9s d\'un * sont obligatoires","btn":"S\'enregistrer","placeholder":{"other":"Autre...","otherInput":"Saisissez votre option"},"error":{"required":"Vous n\'avez pas rempli ce champ","email":"Adresse e-mail non valide","phone":"Num\xe9ro de t\xe9l\xe9phone non valide"}},"manualCheckin":{"title":{"default":"Veuillez remplir.","documentScanner":"Faites attention lorsque vous ins\xe9rez votre carte d\'identit\xe9:"},"subtitle":{"default":"Remarque - chaque champ * est requis","documentScanner":[{"parts":[{"text":"Le ","bold":false},{"text":"c\xf4t\xe9 avec les caract\xe8res <<< >>> (MRZ) ","bold":true},{"text":"doit \xeatre ","bold":false},{"text":"orient\xe9 vers le kiosque / scanner.","bold":true}]},{"parts":[{"text":"Gardez la carte immobile ","bold":false},{"text":"jusqu\'\xe0 ce que les champs soient remplis automatiquement.","bold":true}]}]},"noOption":"Aucune option","btn":"S\'enregistrer","placeholder":{"name":"Votre nom *","email":"Votre e-mail *","phone":"Num\xe9ro de portable","contactName":"Votre personne de contact*","other":"Autre..."},"error":{"required":"Vous n\'avez pas rempli ce champ","name":"Nom invalide","email":"Adresse e-mail invalide","phone":"Num\xe9ro de portable invalide"},"status":{"idle":{"no-contact":{"title":"Veuillez patienter...","message":"Votre inscription est en cours de traitement."},"contact":{"title":"Veuillez patienter...","message":"Votre contact est en cours de notification."}},"loading":{"no-contact":{"title":"Veuillez patienter...","message":"Votre inscription est en cours de traitement."},"contact":{"title":"Veuillez patienter...","message":"Votre contact est en cours de notification."}},"success":{"no-email-sms":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Merci."},"email-sms":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Votre personne de contact est notifi\xe9e."},"call-ping":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Nous allons maintenant \xe9tablir un appel t\xe9l\xe9phonique avec votre personne de contact."},"teams-call":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Nous allons maintenant \xe9tablir un appel Microsoft Teams avec votre personne de contact"},"badge":{"title":"Merci pour votre enregistrement, votre badge va \xeatre imprim\xe9.","message":""},"video-call":{"title":"Vous vous \xeates enregistr\xe9 avec succ\xe8s.","message":"Configuration de votre appel vid\xe9o avec la personne de contact."}},"error":{"title":"Quelque chose a mal tourn\xe9.","message":"Veuillez r\xe9essayer !"}},"documentScan":{"invalid":{"title":"Document non valide","message":"Le document n\u2019a pas pu \xeatre v\xe9rifi\xe9 ou a expir\xe9. Veuillez saisir vos informations manuellement."}}},"manualCheckout":{"title":"Saisissez votre nom pour partir","btn":"Partir","form":{"placeholder":{"name":"Votre nom complet *"},"loading":"Chargement...","noOptions":"Aucune option"},"error":{"required":"Vous n\'avez pas rempli ce champ","name":"Nom invalide"},"status":{"idle":{"title":"Nous traitons vos informations.","message":"Veuillez patienter..."},"loading":{"title":"Nous traitons vos informations.","message":"Veuillez patienter..."},"success":{"title":"Vous \xeates parti avec succ\xe8s.","message":"Merci et bonne journ\xe9e."},"successAccess":{"title":"Vous \xeates parti avec succ\xe8s.","message":"Vous pouvez maintenant ouvrir la porte."},"error":{"title":"Une erreur s\'est produite lors du d\xe9part.","message":"Veuillez r\xe9essayer !"}}},"call":{"title":{"no-email-sms":"Souhaitez-vous notifier votre contact ?","email-sms":"Nous avons envoy\xe9 un e-mail/SMS \xe0 votre contact.<br/>Voulez-vous en plus \xe9tablir un appel avec eux ?"},"callBtn":"Appeler","pingBtn":"Signal","smsBtn":"SMS","callVideoBtn":"Appel vid\xe9o","teamsCallBtn":"Appel Teams","teamsMessageBtn":"Message Teams","googleChatMessageBtn":"Google Chat","noBtn":"Annuler","cancelBtn":"Annuler l\'appel","status":{"connecting":{"title":"\xc9tablissement de l\'appel.<br/>Veuillez patienter...","message":""},"ringing":{"title":"Appel de votre personne de contact<br/>Veuillez patienter...","message":""},"ringingReception":{"title":"Appel d\xe9marr\xe9...","message":""},"open":{"title":"Appel en cours.","message":""},"close":{"title":"Appel termin\xe9.<br/>","message":""},"closeAccess":{"title":"Appel termin\xe9.<br/>Vous pouvez maintenant ouvrir la porte.","message":""},"closeReception":{"title":"L\'appel est termin\xe9.","message":""},"error":{"title":"L\'appel n\'est pas \xe9tabli.<br/>Rappeler ?","message":""}}},"message":{"status":{"idle":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"loading":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"success":{"title":"SMS envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Merci !"},"successAccess":{"title":"SMS envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Vous pouvez maintenant ouvrir la porte."},"error":{"title":"SMS non envoy\xe9.","message":"Veuillez r\xe9essayer !"}}},"videoCall":{"title":"Appel vid\xe9o","endCall":"Raccrocher","status":{"idle":{"title":"Nous cr\xe9ons une salle vid\xe9o.","message":"Veuillez patienter..."},"loading":{"title":"Nous cr\xe9ons une salle vid\xe9o.","message":"Veuillez patienter..."},"success":{"title":"La salle vid\xe9o a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.","message":"Rejoindre la salle..."},"error":{"title":"La salle vid\xe9o n\'a pas \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.","message":"Veuillez r\xe9essayer !"}}},"teamsCall":{"title":"Appel Teams","controls":{"startCall":"Commencer l\'appel","endCall":"Quitter","camera":"Cam\xe9ra","cameraOff":"Cam\xe9ra \xe9teinte","mic":"Micro","micOff":"Micro \xe9teint","ringing":"Sonnerie...","noAnswer":"Personne n\'a r\xe9pondu \xe0 l\'appel."},"status":{"connecting":{"title":"\xc9tablissement de l\'appel.<br/>Veuillez patienter...","message":""},"ringing":{"title":"Appel de votre personne de contact<br/>Veuillez patienter...","message":""},"connected":{"title":"\xc9tablissement de l\'appel","message":""},"disconnected":{"title":"Appel termin\xe9.<br/>","message":""},"disconnectedAccess":{"title":"Appel termin\xe9.<br/>Vous pouvez maintenant ouvrir la porte.","message":""},"error":{"title":"L\'appel n\'est pas \xe9tabli.<br/>Veuillez r\xe9essayer","message":""},"noAnswer":{"title":"Personne n\'a r\xe9pondu \xe0 l\'appel.<br/>Veuillez r\xe9essayer.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"loading":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"success":{"title":"Message envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Merci !"},"successAccess":{"title":"Message envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Vous pouvez maintenant ouvrir la porte."},"error":{"title":"Message non envoy\xe9.","message":"Veuillez r\xe9essayer !"}}},"googleChatMessage":{"status":{"idle":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"loading":{"title":"Nous notifions votre personne de contact.","message":"Veuillez patienter..."},"success":{"title":"Message envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Merci !"},"successAccess":{"title":"Message envoy\xe9. Le contact a \xe9t\xe9 notifi\xe9.","message":"Vous pouvez maintenant ouvrir la porte."},"error":{"title":"Message non envoy\xe9.","message":"Veuillez r\xe9essayer !"}}},"packageDelivery":{"title":"Comme c\'est gentil de livrer un colis !","subtitle":"S\xe9lectionnez et notifiez le destinataire","subtitle1":"Appuyez sur le bouton ci-dessous pour nous faire savoir que vous \xeates l\xe0 !","subtitle2":"","input":{"label":{"contact":"Pour qui est le colis"},"error":{"contact":{"required":"Vous n\'avez pas rempli ce champ"}}},"button":{"submit":"Notifier"},"status":{"loading":{"title":"Nous notifions la personne de contact.","message":"Veuillez patienter..."},"success":{"no-email-sms":{"title":"Merci pour votre livraison !","message":""},"email-sms":{"title":"La personne de contact a \xe9t\xe9 notifi\xe9e.","message":"Merci pour votre livraison !"},"call-ping":{"title":"Merci pour votre livraison !","message":"Une connexion t\xe9l\xe9phonique va maintenant \xeatre \xe9tablie avec la personne de contact."},"teams-call":{"title":"Merci pour votre livraison !","message":"Un appel Microsoft Teams va maintenant \xeatre \xe9tabli avec votre personne de contact."},"video-call":{"title":"Merci pour votre livraison !","message":"Configuration de votre appel vid\xe9o avec la personne de contact."}},"error":{"title":"Quelque chose a mal tourn\xe9.","message":"Veuillez r\xe9essayer !"}}},"foodDelivery":{"title":"Comme c\'est gentil de livrer de la nourriture !","subtitle":"S\xe9lectionnez et notifiez le destinataire","subtitle1":"Appuyez sur le bouton ci-dessous pour nous faire savoir que vous \xeates l\xe0 !","subtitle2":"","input":{"label":{"contact":"Pour qui est la nourriture"},"error":{"contact":{"required":"Vous n\'avez pas rempli ce champ"}}},"button":{"submit":"Notifier"},"status":{"loading":{"title":"Nous notifions le contact.","message":"Veuillez patienter !"},"success":{"no-email-sms":{"title":"Merci pour votre livraison !","message":""},"email-sms":{"title":"Le contact est notifi\xe9.","message":"Merci pour votre livraison !"},"call-ping":{"title":"Merci pour votre livraison !","message":"Une connexion t\xe9l\xe9phonique va maintenant \xeatre \xe9tablie avec votre personne de contact."},"teams-call":{"title":"Merci pour votre livraison !","message":"Un appel Microsoft Teams va maintenant \xeatre \xe9tabli avec votre personne de contact."},"video-call":{"title":"Merci pour votre livraison !","message":"Configuration de votre appel vid\xe9o avec la personne de contact."}},"error":{"title":"Quelque chose a mal tourn\xe9.","message":"Veuillez r\xe9essayer !"}}},"QRCodeScanner":{"title":"Veuillez scanner votre code QR","subtitle":"Alignez le code QR \xe0 l\'int\xe9rieur des coins rouges et gardez votre t\xe9l\xe9phone stable.","error":"Format de code QR invalide","unknownError":"Erreur inconnue lors du scan"},"common":{"backBtn":"Retour"},"previewPDF":{"page":{"of":"de","previous":"Pr\xe9c\xe9dent","next":"Suivant"},"button":{"cancel":"Annuler","accept":"Accepter","next":"Suivant"},"title":{"consent":"Consentement requis"}},"offline":{"title":"Hors ligne","receptionMessage":"La r\xe9ception num\xe9rique est hors ligne pour le moment et ne peut pas \xeatre utilis\xe9e, la connexion internet doit \xeatre v\xe9rifi\xe9e !","check":"\xcates-vous un visiteur et souhaitez-vous parler directement \xe0 un employ\xe9 ? Veuillez appeler {{receptionistPhone}}"},"overview":{"title":"Saisissez le code pour ouvrir l\'aper\xe7u !","noUsers":"Aucune inscription","status":{"success":{"title":"Le code est valide.","message":""},"error":{"title":"Le code est invalide.","message":"Veuillez r\xe9essayer !"}},"checkoutStatus":{"loading":{"title":"Veuillez patienter...","message":""},"success":{"title":"D\xe9part r\xe9ussi.","message":""},"error":{"title":"Quelque chose a mal tourn\xe9.","message":"Veuillez r\xe9essayer !"}},"listTitle":"Liste des personnes qui se sont enregistr\xe9es aujourd\'hui mais ne sont pas parties","page":"Page ","table":{"head":{"fullName":"Nom","type":"Type","checkedinAt":"Enregistr\xe9 \xe0","host":"H\xf4te"},"type":{"Package":"Livraison de colis","Food":"Livraison de nourriture","Visitor":"Visiteur","MeetingAttendee":"Visiteur invit\xe9","Employee":"Employ\xe9","Guest":"Visiteur"}},"confirmModal":{"title":"\xcates-vous s\xfbr de vouloir faire partir {{fullName}} ?","cancel":"Annuler","checkout":"Faire partir"}},"wifi":{"title":"Se connecter au r\xe9seau Wi-Fi"},"door":{"external":{"title":"Ouverture de la porte","subtitle":"La porte va s\'ouvrir sous peu. Veuillez patienter..."},"control":{"title":"Vous pouvez maintenant ouvrir la porte","subtitle":"Veuillez appuyer sur le bouton ci-dessous !","openBtn":"Ouvrir la porte"},"status":{"success":{"title":"La porte a \xe9t\xe9 ouverte","message":""},"error":{"title":"Quelque chose a mal tourn\xe9","message":"Veuillez contacter votre personne de contact pour ouvrir la porte."},"loading":{"title":"Ouverture de la porte...","message":""}}},"photo":{"title":"Souhaitez-vous prendre une photo dans le cadre de votre processus d\'enregistrement ?","required":{"title":"V\xe9rification photo requise !","instructions":"Veuillez vous placer devant la cam\xe9ra et suivre les instructions \xe0 l\'\xe9cran.","securityNotice":"Pour des raisons de s\xe9curit\xe9 et de v\xe9rification, une photo est requise lors de l\'enregistrement.","privacyInfo":"Nous respectons votre vie priv\xe9e. Vos donn\xe9es sont stock\xe9es en toute s\xe9curit\xe9 et utilis\xe9es uniquement pour l\'identification.","closingMessage":"Merci pour votre coop\xe9ration."},"optional":{"title":"Souhaitez-vous prendre une photo dans le cadre de votre processus d\'enregistrement ?","instructions":"","securityNotice":"Prendre une photo peut aider \xe0 rationaliser l\'identification et am\xe9liorer la s\xe9curit\xe9.","privacyInfo":"Nous respectons votre vie priv\xe9e. Cette \xe9tape est optionnelle, et vos donn\xe9es seront trait\xe9es en toute s\xe9curit\xe9.","closingMessage":"Vous pouvez ignorer cette \xe9tape si vous pr\xe9f\xe9rez."},"subtitle":"Veuillez vous positionner dans le cadre et rester immobile pour un meilleur r\xe9sultat","button":{"cancel":"Annuler","accept":"Accepter","skip":"Ignorer","next":"Suivant","recapture":"Reprendre la photo","continue":"Continuer"},"error":"Une erreur s\'est produite lors de la capture de la photo. Le processus d\'enregistrement se poursuivra sans la photo."},"wayfinding":{"title":"O\xf9 souhaitez-vous aller ?"},"callingMenu":{"title":"Menu d\'appel"},"bell":{"status":{"success":{"title":"La sonnette retentit","message":"Quelqu\u2019un arrive bient\xf4t."},"error":{"title":"Une erreur s\'est produite","message":"Veuillez r\xe9essayer"},"loading":{"title":"Connexion...","message":"Veuillez patienter"}}},"access":{"control":{"title":"Vous pouvez maintenant ouvrir la porte","subtitle":"Veuillez appuyer sur le bouton ci-dessous.","titleAuto":"Acc\xe8s automatique \xe0 la porte","subtitleAuto":"La porte s\'ouvrira automatiquement pour vous","openBtn":"Ouvrir"},"status":{"success":{"title":"La porte a \xe9t\xe9 ouverte","message":""},"error":{"title":"Quelque chose a mal tourn\xe9","message":"Veuillez contacter votre personne de contact pour ouvrir la porte."},"loading":{"title":"Ouverture de la porte...","message":""}}}}');


var $002a7e1c39b40840$exports = {};
$002a7e1c39b40840$exports = JSON.parse('{"language":{"title":"W\xe4hlen Sie Ihre Sprache","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Hallo, wie k\xf6nnen wir Ihnen helfen?","checkIn":"Einchecken","independentManualCheckIn":"Ohne Termin","integratedManualCheckIn":"Manuell einchecken","checkOut":"Auschecken","manualCheckOut":"Manuell auschecken","parcelDelivery":"Paketlieferung","foodDelivery":"Essenslieferung","callReception":"Rezeption anrufen","overview":"\xdcbersicht","unavailable":"Die Rezeption ist derzeit nicht verf\xfcgbar."},"check":{"option":{"checkin":{"title":"W\xe4hlen Sie eine Option zum Einchecken","manual":"Manuell einchecken","code":"Mit PIN oder QR-Code einchecken","code-no-qr":"Mit PIN-Code einchecken"},"checkout":{"title":"W\xe4hlen Sie eine Option zum Auschecken","manual":"Mit Namen auschecken","code":"Mit PIN oder QR-Code auschecken","code-no-qr":"Mit PIN-Code auschecken"}},"title":"Sie k\xf6nnen nun Ihren QR-Code scannen oder Ihren PIN-Code eingeben.","orText":"Oder","qrScanner":{"checkin":{"title":"W\xe4hlen Sie eine Option zum Einchecken"},"checkout":{"title":"W\xe4hlen Sie eine Option zum Auschecken"},"btn":"QR-Code scannen"},"hidScanner":{"title":"Halten Sie den QR-Code an den Scanner unten oder geben Sie Ihren PIN-Code ein"},"pinOnly":{"title":"Bitte geben Sie Ihren PIN-Code ein"},"pinCode":"Geben Sie Ihren PIN-Code ein","manually":{"checkin":"Haben Sie keinen Anmeldecode?"},"status":{"idle":{"title":"Ihr Code wird gescannt.","message":"Bitte warten...","nfc":{"title":"Ihr Tag wird gescannt.","message":"Bitte warten..."}},"loading":{"title":"Ihr Code wird gescannt.","message":"Bitte warten...","nfc":{"title":"Ihr Tag wird gescannt.","message":"Bitte warten..."}},"error":{"title":"Ihr Code ist ung\xfcltig.","message":"Bitte versuchen Sie es erneut!","nfc":{"title":"Ihr Tag ist ung\xfcltig.","message":"Bitte versuchen Sie es erneut!"},"meeting":{"tooEarly":{"title":"Sie sind etwas zu fr\xfch","message":"Ihr Code ist g\xfcltig ab {{validFromTime}}. Das Meeting beginnt um {{meetingStartTime}}."},"tooLate":{"title":"Dieser Code ist abgelaufen","message":"Das Meeting endete um {{meetingEndTime}}. Ihr Code war g\xfcltig bis {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Vielen Dank."},"MeetingAttendee":{"no-email-sms":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Vielen Dank."},"email-sms":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Ihre Kontaktperson wurde benachrichtigt."},"call-ping":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Wir werden nun einen Telefonanruf mit Ihrer Kontaktperson herstellen."},"teams-call":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Wir werden nun einen Microsoft Teams-Anruf mit Ihrer Kontaktperson herstellen."},"badge":{"title":"Vielen Dank f\xfcr das Einchecken, Ihr Ausweis wird gedruckt.","message":""},"video-call":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Ihr Videoanruf mit der Kontaktperson wird eingerichtet."}},"Employee":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Vielen Dank.","badge":{"title":"Vielen Dank f\xfcr das Einchecken, Ihr Ausweis wird gedruckt.","message":""}},"Visitor":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Vielen Dank.","badge":{"title":"Vielen Dank f\xfcr das Einchecken, Ihr Ausweis wird gedruckt.","message":""}}},"checkout":{"default":{"title":"Sie haben sich erfolgreich ausgecheckt.<br/>","message":"Bis bald."},"MeetingAttendee":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Bis bald."},"Employee":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Bis bald."},"Visitor":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Bis bald."},"access":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen."}}}}},"missingFields":{"title":"Noch ein paar Angaben vor dem Check-in","subtitle":"Mit * markierte Felder sind erforderlich","btn":"Einchecken","placeholder":{"other":"Andere...","otherInput":"Geben Sie Ihre Option ein"},"error":{"required":"Dieses Feld ist erforderlich","email":"Ung\xfcltige E-Mail-Adresse","phone":"Ung\xfcltige Telefonnummer"}},"manualCheckin":{"title":{"default":"Bitte ausf\xfcllen.","documentScanner":"Achten Sie beim Einlegen Ihres Personalausweises auf Folgendes:"},"subtitle":{"default":"Hinweis - jedes Feld * ist erforderlich","documentScanner":[{"parts":[{"text":"Die ","bold":false},{"text":"Seite mit den <<< >>>-Zeichen (MRZ) ","bold":true},{"text":"muss ","bold":false},{"text":"zum Kiosk / Scanner gerichtet sein.","bold":true}]},{"parts":[{"text":"Halten Sie die Karte still ","bold":false},{"text":"bis die Felder automatisch ausgef\xfcllt sind.","bold":true}]}]},"noOption":"Keine Option","btn":"Einchecken","placeholder":{"name":"Ihr Name *","email":"Ihre E-Mail *","phone":"Mobilnummer","contactName":"Ihre Kontaktperson*","other":"Andere..."},"error":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt","name":"Ung\xfcltiger Name","email":"Ung\xfcltige E-Mail-Adresse","phone":"Ung\xfcltige Mobilnummer"},"status":{"idle":{"no-contact":{"title":"Bitte warten...","message":"Ihre Registrierung wird bearbeitet."},"contact":{"title":"Bitte warten...","message":"Ihre Kontaktperson wird benachrichtigt."}},"loading":{"no-contact":{"title":"Bitte warten...","message":"Ihre Registrierung wird bearbeitet."},"contact":{"title":"Bitte warten...","message":"Ihre Kontaktperson wird benachrichtigt."}},"success":{"no-email-sms":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Vielen Dank."},"email-sms":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Ihre Kontaktperson wurde benachrichtigt."},"call-ping":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Wir werden nun einen Telefonanruf mit Ihrer Kontaktperson herstellen."},"teams-call":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Wir werden nun einen Microsoft Teams-Anruf mit Ihrer Kontaktperson herstellen."},"badge":{"title":"Vielen Dank f\xfcr das Einchecken, Ihr Ausweis wird gedruckt.","message":""},"video-call":{"title":"Sie haben sich erfolgreich eingecheckt.","message":"Ihr Videoanruf mit der Kontaktperson wird eingerichtet."}},"error":{"title":"Etwas ist schiefgelaufen.","message":"Bitte versuchen Sie es erneut!"}},"documentScan":{"invalid":{"title":"Dokument ung\xfcltig","message":"Das Dokument konnte nicht verifiziert werden oder ist abgelaufen. Bitte geben Sie Ihre Daten manuell ein."}}},"manualCheckout":{"title":"Geben Sie Ihren Namen ein, um auszuchecken","btn":"Auschecken","form":{"placeholder":{"name":"Ihr vollst\xe4ndiger Name *"},"loading":"L\xe4dt...","noOptions":"Keine Optionen"},"error":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt","name":"Ung\xfcltiger Name"},"status":{"idle":{"title":"Wir verarbeiten Ihre Informationen.","message":"Bitte warten..."},"loading":{"title":"Wir verarbeiten Ihre Informationen.","message":"Bitte warten..."},"success":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Vielen Dank und einen sch\xf6nen Tag."},"successAccess":{"title":"Sie haben sich erfolgreich ausgecheckt.","message":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen."},"error":{"title":"Beim Auschecken ist ein Fehler aufgetreten.","message":"Bitte versuchen Sie es erneut!"}}},"call":{"title":{"no-email-sms":"M\xf6chten Sie Ihre Kontaktperson benachrichtigen?","email-sms":"Wir haben eine E-Mail/SMS an Ihre Kontaktperson gesendet.<br/>M\xf6chten Sie zus\xe4tzlich einen Anruf mit ihnen f\xfchren?"},"callBtn":"Anrufen","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videoanruf","teamsCallBtn":"Teams-Anruf","teamsMessageBtn":"Teams-Nachricht","googleChatMessageBtn":"Google Chat","noBtn":"Abbrechen","cancelBtn":"Anruf abbrechen","status":{"connecting":{"title":"Anruf wird hergestellt.<br/>Bitte warten...","message":""},"ringing":{"title":"Ihre Kontaktperson wird angerufen<br/>Bitte warten...","message":""},"ringingReception":{"title":"Anruf gestartet...","message":""},"open":{"title":"Anruf l\xe4uft.","message":""},"close":{"title":"Anruf beendet.<br/>","message":""},"closeAccess":{"title":"Anruf beendet.<br/>Sie k\xf6nnen nun die T\xfcr \xf6ffnen.","message":""},"closeReception":{"title":"Anruf ist beendet.","message":""},"error":{"title":"Anruf konnte nicht hergestellt werden.<br/>Erneut anrufen?","message":""}}},"message":{"status":{"idle":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"loading":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"success":{"title":"SMS wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Vielen Dank!"},"successAccess":{"title":"SMS wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen."},"error":{"title":"SMS nicht gesendet.","message":"Bitte versuchen Sie es erneut!"}}},"videoCall":{"title":"Videoanruf","endCall":"Anruf beenden","status":{"idle":{"title":"Wir erstellen einen Videoraum.","message":"Bitte warten..."},"loading":{"title":"Wir erstellen einen Videoraum.","message":"Bitte warten..."},"success":{"title":"Der Videoraum wurde erfolgreich erstellt.","message":"Raum wird betreten..."},"error":{"title":"Der Videoraum wurde nicht erfolgreich erstellt.","message":"Bitte versuchen Sie es erneut!"}}},"teamsCall":{"title":"Teams-Anruf","controls":{"startCall":"Anruf starten","endCall":"Verlassen","camera":"Kamera","cameraOff":"Kamera aus","mic":"Mikrofon","micOff":"Mikrofon aus","ringing":"Klingelt...","noAnswer":"Niemand hat den Anruf beantwortet."},"status":{"connecting":{"title":"Anruf wird hergestellt.<br/>Bitte warten...","message":""},"ringing":{"title":"Ihre Kontaktperson wird angerufen<br/>Bitte warten...","message":""},"connected":{"title":"Anruf wird hergestellt","message":""},"disconnected":{"title":"Anruf beendet.<br/>","message":""},"disconnectedAccess":{"title":"Anruf beendet.<br/>Sie k\xf6nnen nun die T\xfcr \xf6ffnen.","message":""},"error":{"title":"Anruf konnte nicht hergestellt werden.<br/>Bitte versuchen Sie es erneut","message":""},"noAnswer":{"title":"Niemand hat den Anruf beantwortet.<br/>Bitte versuchen Sie es erneut.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"loading":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"success":{"title":"Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Vielen Dank!"},"successAccess":{"title":"Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen."},"error":{"title":"Nachricht nicht gesendet.","message":"Bitte versuchen Sie es erneut!"}}},"googleChatMessage":{"status":{"idle":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"loading":{"title":"Wir benachrichtigen Ihre Kontaktperson.","message":"Bitte warten..."},"success":{"title":"Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Vielen Dank!"},"successAccess":{"title":"Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.","message":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen."},"error":{"title":"Nachricht nicht gesendet.","message":"Bitte versuchen Sie es erneut!"}}},"packageDelivery":{"title":"Wie sch\xf6n, dass Sie ein Paket liefern!","subtitle":"W\xe4hlen Sie den Empf\xe4nger aus und benachrichtigen Sie ihn","subtitle1":"Dr\xfccken Sie die Schaltfl\xe4che unten, um uns mitzuteilen, dass Sie hier sind!","subtitle2":"","input":{"label":{"contact":"F\xfcr wen ist das Paket"},"error":{"contact":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt"}}},"button":{"submit":"Benachrichtigen"},"status":{"loading":{"title":"Wir benachrichtigen die Kontaktperson.","message":"Bitte warten..."},"success":{"no-email-sms":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":""},"email-sms":{"title":"Die Kontaktperson wurde benachrichtigt.","message":"Vielen Dank f\xfcr Ihre Lieferung!"},"call-ping":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Eine Telefonverbindung zur Kontaktperson wird nun hergestellt."},"teams-call":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Ein Microsoft Teams-Anruf zu Ihrer Kontaktperson wird nun get\xe4tigt."},"video-call":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Ihr Videoanruf mit der Kontaktperson wird eingerichtet."}},"error":{"title":"Etwas ist schiefgelaufen.","message":"Bitte versuchen Sie es erneut!"}}},"foodDelivery":{"title":"Wie sch\xf6n, dass Sie Essen liefern!","subtitle":"W\xe4hlen Sie den Empf\xe4nger aus und benachrichtigen Sie ihn","subtitle1":"Dr\xfccken Sie die Schaltfl\xe4che unten, um uns mitzuteilen, dass Sie hier sind!","subtitle2":"","input":{"label":{"contact":"F\xfcr wen ist das Essen"},"error":{"contact":{"required":"Sie haben dieses Feld nicht ausgef\xfcllt"}}},"button":{"submit":"Benachrichtigen"},"status":{"loading":{"title":"Wir benachrichtigen den Kontakt.","message":"Bitte warten!"},"success":{"no-email-sms":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":""},"email-sms":{"title":"Der Kontakt wurde benachrichtigt.","message":"Vielen Dank f\xfcr Ihre Lieferung!"},"call-ping":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Eine Telefonverbindung zu Ihrer Kontaktperson wird nun hergestellt."},"teams-call":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Ein Microsoft Teams-Anruf zu Ihrer Kontaktperson wird nun get\xe4tigt."},"video-call":{"title":"Vielen Dank f\xfcr Ihre Lieferung!","message":"Ihr Videoanruf mit der Kontaktperson wird eingerichtet."}},"error":{"title":"Etwas ist schiefgelaufen.","message":"Bitte versuchen Sie es erneut!"}}},"QRCodeScanner":{"title":"Bitte scannen Sie Ihren QR-Code","subtitle":"Richten Sie den QR-Code innerhalb der roten Ecken aus und halten Sie Ihr Telefon ruhig.","error":"Ung\xfcltiges QR-Code-Format","unknownError":"Unbekannter Fehler beim Scannen aufgetreten"},"common":{"backBtn":"Zur\xfcck"},"previewPDF":{"page":{"of":"von","previous":"Vorherige","next":"N\xe4chste"},"button":{"cancel":"Abbrechen","accept":"Akzeptieren","next":"N\xe4chste"},"title":{"consent":"Einverst\xe4ndnis erforderlich"}},"offline":{"title":"Offline","receptionMessage":"Die digitale Rezeption ist derzeit offline und kann nicht verwendet werden, die Internetverbindung muss \xfcberpr\xfcft werden!","check":"Sind Sie ein Besucher und m\xf6chten Sie direkt mit einem Mitarbeiter sprechen? Bitte rufen Sie {{receptionistPhone}} an"},"overview":{"title":"Geben Sie den Code ein, um die \xdcbersicht zu \xf6ffnen!","noUsers":"Keine Registrierungen","status":{"success":{"title":"Der Code ist g\xfcltig.","message":""},"error":{"title":"Der Code ist ung\xfcltig.","message":"Bitte versuchen Sie es erneut!"}},"checkoutStatus":{"loading":{"title":"Bitte warten...","message":""},"success":{"title":"Erfolgreich ausgecheckt.","message":""},"error":{"title":"Etwas ist schiefgelaufen.","message":"Bitte versuchen Sie es erneut!"}},"listTitle":"Liste der Personen, die heute eingecheckt, aber nicht ausgecheckt haben","page":"Seite ","table":{"head":{"fullName":"Name","type":"Typ","checkedinAt":"Eingecheckt um","host":"Gastgeber"},"type":{"Package":"Paketlieferung","Food":"Essenslieferung","Visitor":"Besucher","MeetingAttendee":"Eingeladener Besucher","Employee":"Mitarbeiter","Guest":"Besucher"}},"confirmModal":{"title":"Sind Sie sicher, dass Sie {{fullName}} auschecken m\xf6chten?","cancel":"Abbrechen","checkout":"Auschecken"}},"wifi":{"title":"Mit dem Wi-Fi-Netzwerk verbinden"},"door":{"external":{"title":"T\xfcr wird ge\xf6ffnet","subtitle":"Die T\xfcr wird in K\xfcrze ge\xf6ffnet. Bitte warten..."},"control":{"title":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen","subtitle":"Bitte dr\xfccken Sie die Schaltfl\xe4che unten!","openBtn":"T\xfcr \xf6ffnen"},"status":{"success":{"title":"Die T\xfcr wurde ge\xf6ffnet","message":""},"error":{"title":"Etwas ist schiefgelaufen","message":"Bitte kontaktieren Sie Ihre Kontaktperson, um die T\xfcr zu \xf6ffnen."},"loading":{"title":"Die T\xfcr \xf6ffnet sich...","message":""}}},"photo":{"title":"M\xf6chten Sie im Rahmen Ihres Check-in-Prozesses ein Foto machen?","required":{"title":"Fotoverifizierung erforderlich!","instructions":"Bitte stellen Sie sich vor die Kamera und befolgen Sie die Anweisungen auf dem Bildschirm.","securityNotice":"Zu Sicherheits- und Verifizierungszwecken ist beim Check-in ein Foto erforderlich.","privacyInfo":"Wir respektieren Ihre Privatsph\xe4re. Ihre Daten werden sicher gespeichert und nur zur Identifikation verwendet.","closingMessage":"Vielen Dank f\xfcr Ihre Zusammenarbeit."},"optional":{"title":"M\xf6chten Sie im Rahmen Ihres Check-in-Prozesses ein Foto machen?","instructions":"","securityNotice":"Ein Foto kann helfen, die Identifikation zu vereinfachen und die Sicherheit zu erh\xf6hen.","privacyInfo":"Wir respektieren Ihre Privatsph\xe4re. Dieser Schritt ist optional und Ihre Daten werden sicher behandelt.","closingMessage":"Sie k\xf6nnen diesen Schritt \xfcberspringen, wenn Sie m\xf6chten."},"subtitle":"Bitte positionieren Sie sich innerhalb des Rahmens und bleiben Sie f\xfcr das beste Ergebnis ruhig","button":{"cancel":"Abbrechen","accept":"Akzeptieren","skip":"\xdcberspringen","next":"N\xe4chste","recapture":"Foto erneut aufnehmen","continue":"Weiter"},"error":"Beim Aufnehmen des Fotos ist ein Fehler aufgetreten. Der Check-in-Prozess wird ohne das Foto fortgesetzt."},"wayfinding":{"title":"Wohin m\xf6chten Sie gehen?"},"callingMenu":{"title":"Anrufmen\xfc"},"bell":{"status":{"success":{"title":"Die Klingel l\xe4utet","message":"Jemand kommt gleich."},"error":{"title":"Etwas ist schiefgelaufen","message":"Bitte versuchen Sie es erneut"},"loading":{"title":"Verbinden...","message":"Bitte warten"}}},"access":{"control":{"title":"Sie k\xf6nnen nun die T\xfcr \xf6ffnen","subtitle":"Bitte dr\xfccken Sie die Schaltfl\xe4che unten.","titleAuto":"Automatischer T\xfcrzugang","subtitleAuto":"Die T\xfcr wird automatisch f\xfcr Sie ge\xf6ffnet","openBtn":"\xd6ffnen"},"status":{"success":{"title":"Die T\xfcr wurde ge\xf6ffnet","message":""},"error":{"title":"Etwas ist schiefgelaufen","message":"Bitte kontaktieren Sie Ihre Kontaktperson, um die T\xfcr zu \xf6ffnen."},"loading":{"title":"Die T\xfcr \xf6ffnet sich...","message":""}}}}');


var $b19f380faffe50d1$exports = {};
$b19f380faffe50d1$exports = JSON.parse('{"language":{"title":"Escolha seu idioma","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Ol\xe1, como podemos ajud\xe1-lo?","checkIn":"Check-in","independentManualCheckIn":"Sem agendamento","integratedManualCheckIn":"Check-in manual","checkOut":"Check-out","manualCheckOut":"Check-out manual","parcelDelivery":"Entrega de encomenda","foodDelivery":"Entrega de comida","callReception":"Ligar para recep\xe7\xe3o","overview":"Vis\xe3o geral","unavailable":"A recep\xe7\xe3o est\xe1 atualmente indispon\xedvel."},"check":{"option":{"checkin":{"title":"Escolha uma op\xe7\xe3o para fazer check-in","manual":"Check-in manual","code":"Check-in com c\xf3digo PIN ou QR","code-no-qr":"Check-in com c\xf3digo PIN"},"checkout":{"title":"Escolha uma op\xe7\xe3o para fazer check-out","manual":"Check-out com nome","code":"Check-out com c\xf3digo PIN ou QR","code-no-qr":"Check-out com c\xf3digo PIN"}},"title":"Agora voc\xea pode escanear seu c\xf3digo QR ou inserir seu c\xf3digo PIN.","orText":"Ou","qrScanner":{"checkin":{"title":"Escolha uma op\xe7\xe3o para fazer check-in"},"checkout":{"title":"Escolha uma op\xe7\xe3o para fazer check-out"},"btn":"Escaneie seu c\xf3digo QR"},"hidScanner":{"title":"Aproxime o c\xf3digo QR do scanner abaixo ou digite o seu c\xf3digo PIN"},"pinOnly":{"title":"Por favor, digite o seu c\xf3digo PIN"},"pinCode":"Digite seu c\xf3digo PIN","manually":{"checkin":"N\xe3o tem c\xf3digo de check-in?"},"status":{"idle":{"title":"Seu c\xf3digo est\xe1 sendo escaneado.","message":"Por favor, aguarde...","nfc":{"title":"Sua etiqueta est\xe1 sendo escaneada.","message":"Por favor, aguarde..."}},"loading":{"title":"Seu c\xf3digo est\xe1 sendo escaneado.","message":"Por favor, aguarde...","nfc":{"title":"Sua etiqueta est\xe1 sendo escaneada.","message":"Por favor, aguarde..."}},"error":{"title":"Seu c\xf3digo \xe9 inv\xe1lido.","message":"Tente novamente!","nfc":{"title":"Sua etiqueta \xe9 inv\xe1lida.","message":"Por favor, tente novamente!"},"meeting":{"tooEarly":{"title":"Voc\xea chegou um pouco cedo","message":"Seu c\xf3digo \xe9 v\xe1lido a partir das {{validFromTime}}. A reuni\xe3o come\xe7a \xe0s {{meetingStartTime}}."},"tooLate":{"title":"Este c\xf3digo expirou","message":"A reuni\xe3o terminou \xe0s {{meetingEndTime}}. Seu c\xf3digo foi v\xe1lido at\xe9 {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"MeetingAttendee":{"no-email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Sua pessoa de contato foi notificada."},"call-ping":{"title":"Voc\xea fez check-in com sucesso.","message":"Agora estabeleceremos uma chamada telef\xf4nica com sua pessoa de contato."},"teams-call":{"title":"Voc\xea fez check-in com sucesso.","message":"Agora estabeleceremos uma chamada do Microsoft Teams com sua pessoa de contato."},"badge":{"title":"Obrigado pelo check-in, seu crach\xe1 ser\xe1 impresso.","message":""},"video-call":{"title":"Voc\xea fez check-in com sucesso.","message":"Configurando sua videochamada com a pessoa de contato."}},"Employee":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado.","badge":{"title":"Obrigado pelo check-in, seu crach\xe1 ser\xe1 impresso.","message":""}},"Visitor":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado.","badge":{"title":"Obrigado pelo check-in, seu crach\xe1 ser\xe1 impresso.","message":""}}},"checkout":{"default":{"title":"Voc\xea fez check-out com sucesso.<br/>","message":"At\xe9 breve."},"MeetingAttendee":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 breve."},"Employee":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 breve."},"Visitor":{"title":"Voc\xea fez check-out com sucesso.","message":"At\xe9 breve."},"access":{"title":"Voc\xea fez check-out com sucesso.","message":"Agora voc\xea pode abrir a porta."}}}}},"missingFields":{"title":"Mais alguns detalhes antes do check-in","subtitle":"Os campos marcados com * s\xe3o obrigat\xf3rios","btn":"Fazer check-in","placeholder":{"other":"Outro...","otherInput":"Introduza a sua op\xe7\xe3o"},"error":{"required":"N\xe3o preencheu este campo","email":"Endere\xe7o de e-mail inv\xe1lido","phone":"N\xfamero de telefone inv\xe1lido"}},"manualCheckin":{"title":{"default":"Por favor, preencha.","documentScanner":"Preste aten\xe7\xe3o ao inserir o seu documento de identidade:"},"subtitle":{"default":"Nota - cada campo * \xe9 obrigat\xf3rio","documentScanner":[{"parts":[{"text":"O ","bold":false},{"text":"lado com os caracteres <<< >>> (MRZ) ","bold":true},{"text":"deve estar ","bold":false},{"text":"voltado para o quiosque / scanner.","bold":true}]},{"parts":[{"text":"Mantenha o cart\xe3o im\xf3vel ","bold":false},{"text":"at\xe9 que os campos sejam preenchidos automaticamente.","bold":true}]}]},"noOption":"Nenhuma op\xe7\xe3o","btn":"Fazer check-in","placeholder":{"name":"Seu nome *","email":"Seu e-mail *","phone":"N\xfamero de celular","contactName":"Sua pessoa de contato*","other":"Outro..."},"error":{"required":"Voc\xea n\xe3o preencheu este campo","name":"Nome inv\xe1lido","email":"Endere\xe7o de e-mail inv\xe1lido","phone":"N\xfamero de celular inv\xe1lido"},"status":{"idle":{"no-contact":{"title":"Por favor, aguarde...","message":"Seu registro est\xe1 sendo processado."},"contact":{"title":"Por favor, aguarde...","message":"Seu contato est\xe1 sendo notificado."}},"loading":{"no-contact":{"title":"Por favor, aguarde...","message":"Seu registro est\xe1 sendo processado."},"contact":{"title":"Por favor, aguarde...","message":"Seu contato est\xe1 sendo notificado."}},"success":{"no-email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Obrigado."},"email-sms":{"title":"Voc\xea fez check-in com sucesso.","message":"Sua pessoa de contato foi notificada."},"call-ping":{"title":"Voc\xea fez check-in com sucesso.","message":"Agora estabeleceremos uma chamada telef\xf4nica com sua pessoa de contato."},"teams-call":{"title":"Voc\xea fez check-in com sucesso.","message":"Agora estabeleceremos uma chamada do Microsoft Teams com sua pessoa de contato"},"badge":{"title":"Obrigado pelo check-in, seu crach\xe1 ser\xe1 impresso.","message":""},"video-call":{"title":"Voc\xea fez check-in com sucesso.","message":"Configurando sua videochamada com a pessoa de contato."}},"error":{"title":"Algo deu errado.","message":"Tente novamente!"}},"documentScan":{"invalid":{"title":"Documento inv\xe1lido","message":"O documento n\xe3o p\xf4de ser verificado ou expirou. Por favor, introduza os seus dados manualmente."}}},"manualCheckout":{"title":"Digite seu nome para fazer check-out","btn":"Fazer check-out","form":{"placeholder":{"name":"Seu nome completo *"},"loading":"Carregando...","noOptions":"Nenhuma op\xe7\xe3o"},"error":{"required":"Voc\xea n\xe3o preencheu este campo","name":"Nome inv\xe1lido"},"status":{"idle":{"title":"Estamos processando suas informa\xe7\xf5es.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos processando suas informa\xe7\xf5es.","message":"Por favor, aguarde..."},"success":{"title":"Voc\xea fez check-out com sucesso.","message":"Obrigado e tenha um bom dia."},"successAccess":{"title":"Voc\xea fez check-out com sucesso.","message":"Agora voc\xea pode abrir a porta."},"error":{"title":"Ocorreu um erro durante o check-out.","message":"Tente novamente!"}}},"call":{"title":{"no-email-sms":"Gostaria de notificar sua pessoa de contato?","email-sms":"Enviamos um e-mail/SMS para sua pessoa de contato.<br/>Deseja estabelecer uma chamada adicional com ela?"},"callBtn":"Ligar","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Chamada de v\xeddeo","teamsCallBtn":"Chamada Teams","teamsMessageBtn":"Mensagem Teams","googleChatMessageBtn":"Google Chat","noBtn":"Cancelar","cancelBtn":"Cancelar chamada","status":{"connecting":{"title":"Estabelecendo chamada.<br/>Por favor, aguarde...","message":""},"ringing":{"title":"Ligando para sua pessoa de contato<br/>Por favor, aguarde...","message":""},"ringingReception":{"title":"Chamada iniciada...","message":""},"open":{"title":"Chamada em andamento.","message":""},"close":{"title":"Chamada encerrada.<br/>","message":""},"closeAccess":{"title":"Chamada encerrada.<br/>Agora voc\xea pode abrir a porta.","message":""},"closeReception":{"title":"Chamada encerrada.","message":""},"error":{"title":"Chamada n\xe3o foi estabelecida.<br/>Ligar novamente?","message":""}}},"message":{"status":{"idle":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"success":{"title":"SMS foi enviado. O contato foi notificado.","message":"Obrigado!"},"successAccess":{"title":"SMS foi enviado. O contato foi notificado.","message":"Agora voc\xea pode abrir a porta."},"error":{"title":"SMS n\xe3o foi enviado.","message":"Tente novamente!"}}},"videoCall":{"title":"Chamada de v\xeddeo","endCall":"Encerrar chamada","status":{"idle":{"title":"Estamos criando uma sala de v\xeddeo.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos criando uma sala de v\xeddeo.","message":"Por favor, aguarde..."},"success":{"title":"A sala de v\xeddeo foi criada com sucesso.","message":"Entrando na sala..."},"error":{"title":"A sala de v\xeddeo n\xe3o foi criada com sucesso.","message":"Tente novamente!"}}},"teamsCall":{"title":"Chamada Teams","controls":{"startCall":"Iniciar chamada","endCall":"Sair","camera":"C\xe2mera","cameraOff":"C\xe2mera desligada","mic":"Microfone","micOff":"Microfone desligado","ringing":"Tocando...","noAnswer":"Ningu\xe9m atendeu a chamada."},"status":{"connecting":{"title":"Estabelecendo chamada.<br/>Por favor, aguarde...","message":""},"ringing":{"title":"Ligando para sua pessoa de contato<br/>Por favor, aguarde...","message":""},"connected":{"title":"Estabelecendo chamada","message":""},"disconnected":{"title":"Chamada encerrada.<br/>","message":""},"disconnectedAccess":{"title":"Chamada encerrada.<br/>Agora voc\xea pode abrir a porta.","message":""},"error":{"title":"Chamada n\xe3o foi estabelecida.<br/>Tente novamente","message":""},"noAnswer":{"title":"Ningu\xe9m atendeu a chamada.<br/>Tente novamente.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"success":{"title":"Mensagem foi enviada. O contato foi notificado.","message":"Obrigado!"},"successAccess":{"title":"Mensagem foi enviada. O contato foi notificado.","message":"Agora voc\xea pode abrir a porta."},"error":{"title":"Mensagem n\xe3o foi enviada.","message":"Tente novamente!"}}},"googleChatMessage":{"status":{"idle":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"loading":{"title":"Estamos notificando sua pessoa de contato.","message":"Por favor, aguarde..."},"success":{"title":"Mensagem foi enviada. O contato foi notificado.","message":"Obrigado!"},"successAccess":{"title":"Mensagem foi enviada. O contato foi notificado.","message":"Agora voc\xea pode abrir a porta."},"error":{"title":"Mensagem n\xe3o foi enviada.","message":"Tente novamente!"}}},"packageDelivery":{"title":"Que gentil da sua parte entregar uma encomenda!","subtitle":"Selecione e notifique o destinat\xe1rio","subtitle1":"Pressione o bot\xe3o abaixo para nos informar que voc\xea est\xe1 aqui!","subtitle2":"","input":{"label":{"contact":"Para quem \xe9 a encomenda"},"error":{"contact":{"required":"Voc\xea n\xe3o preencheu este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando a pessoa de contato.","message":"Por favor, aguarde..."},"success":{"no-email-sms":{"title":"Obrigado pela sua entrega!","message":""},"email-sms":{"title":"A pessoa de contato foi notificada.","message":"Obrigado pela sua entrega!"},"call-ping":{"title":"Obrigado pela sua entrega!","message":"Uma conex\xe3o telef\xf4nica ser\xe1 estabelecida com a pessoa de contato."},"teams-call":{"title":"Obrigado pela sua entrega!","message":"Uma chamada do Microsoft Teams ser\xe1 feita para sua pessoa de contato."},"video-call":{"title":"Obrigado pela sua entrega!","message":"Configurando sua videochamada com a pessoa de contato."}},"error":{"title":"Algo deu errado.","message":"Tente novamente!"}}},"foodDelivery":{"title":"Que gentil da sua parte entregar comida!","subtitle":"Selecione e notifique o destinat\xe1rio","subtitle1":"Pressione o bot\xe3o abaixo para nos informar que voc\xea est\xe1 aqui!","subtitle2":"","input":{"label":{"contact":"Para quem \xe9 a comida"},"error":{"contact":{"required":"Voc\xea n\xe3o preencheu este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando o contato.","message":"Por favor, aguarde!"},"success":{"no-email-sms":{"title":"Obrigado pela sua entrega!","message":""},"email-sms":{"title":"O contato foi notificado.","message":"Obrigado pela sua entrega!"},"call-ping":{"title":"Obrigado pela sua entrega!","message":"Uma conex\xe3o telef\xf4nica ser\xe1 estabelecida com sua pessoa de contato."},"teams-call":{"title":"Obrigado pela sua entrega!","message":"Uma chamada do Microsoft Teams ser\xe1 feita para sua pessoa de contato."},"video-call":{"title":"Obrigado pela sua entrega!","message":"Configurando sua videochamada com a pessoa de contato."}},"error":{"title":"Algo deu errado.","message":"Tente novamente!"}}},"QRCodeScanner":{"title":"Por favor, escaneie seu c\xf3digo QR","subtitle":"Alinhe o c\xf3digo QR dentro dos cantos vermelhos e mantenha seu telefone est\xe1vel.","error":"Formato de c\xf3digo QR inv\xe1lido","unknownError":"Erro desconhecido ocorreu durante o escaneamento"},"common":{"backBtn":"Voltar"},"previewPDF":{"page":{"of":"de","previous":"Anterior","next":"Pr\xf3xima"},"button":{"cancel":"Cancelar","accept":"Aceitar","next":"Pr\xf3ximo"},"title":{"consent":"Consentimento necess\xe1rio"}},"offline":{"title":"Offline","receptionMessage":"A recep\xe7\xe3o digital est\xe1 offline no momento e n\xe3o pode ser usada, a conex\xe3o com a internet deve ser verificada!","check":"Voc\xea \xe9 um visitante e quer falar diretamente com um funcion\xe1rio? Por favor, ligue para {{receptionistPhone}}"},"overview":{"title":"Digite o c\xf3digo para abrir a vis\xe3o geral!","noUsers":"Nenhum registro","status":{"success":{"title":"O c\xf3digo \xe9 v\xe1lido.","message":""},"error":{"title":"O c\xf3digo \xe9 inv\xe1lido.","message":"Tente novamente!"}},"checkoutStatus":{"loading":{"title":"Por favor, aguarde...","message":""},"success":{"title":"Check-out bem-sucedido.","message":""},"error":{"title":"Algo deu errado.","message":"Tente novamente!"}},"listTitle":"Lista de pessoas que fizeram check-in hoje mas n\xe3o fizeram check-out","page":"P\xe1gina ","table":{"head":{"fullName":"Nome","type":"Tipo","checkedinAt":"Check-in \xe0s","host":"Anfitri\xe3o"},"type":{"Package":"Entrega de encomenda","Food":"Entrega de comida","Visitor":"Visitante","MeetingAttendee":"Visitante convidado","Employee":"Funcion\xe1rio","Guest":"Visitante"}},"confirmModal":{"title":"Tem certeza de que deseja fazer check-out de {{fullName}}?","cancel":"Cancelar","checkout":"Fazer check-out"}},"wifi":{"title":"Conectar \xe0 rede Wi-Fi"},"door":{"external":{"title":"Abrindo a porta","subtitle":"A porta ser\xe1 aberta em breve. Por favor, aguarde..."},"control":{"title":"Agora voc\xea pode abrir a porta","subtitle":"Por favor, pressione o bot\xe3o abaixo!","openBtn":"Abrir a porta"},"status":{"success":{"title":"A porta foi aberta","message":""},"error":{"title":"Algo deu errado","message":"Entre em contato com sua pessoa de contato para abrir a porta."},"loading":{"title":"Abrindo a porta...","message":""}}},"photo":{"title":"Gostaria de tirar uma foto como parte do seu processo de check-in?","required":{"title":"Verifica\xe7\xe3o por Foto Necess\xe1ria!","instructions":"Por favor, fique em frente \xe0 c\xe2mera e siga as instru\xe7\xf5es na tela.","securityNotice":"Para fins de seguran\xe7a e verifica\xe7\xe3o, uma foto \xe9 necess\xe1ria durante o check-in.","privacyInfo":"Respeitamos sua privacidade. Seus dados s\xe3o armazenados com seguran\xe7a e usados apenas para identifica\xe7\xe3o.","closingMessage":"Obrigado pela sua coopera\xe7\xe3o."},"optional":{"title":"Gostaria de tirar uma foto como parte do seu processo de check-in?","instructions":"","securityNotice":"Tirar uma foto pode ajudar a agilizar a identifica\xe7\xe3o e melhorar a seguran\xe7a.","privacyInfo":"Respeitamos sua privacidade. Este passo \xe9 opcional, e seus dados ser\xe3o tratados com seguran\xe7a.","closingMessage":"Voc\xea pode pular este passo se preferir."},"subtitle":"Por favor, posicione-se dentro do quadro e permane\xe7a im\xf3vel para o melhor resultado","button":{"cancel":"Cancelar","accept":"Aceitar","skip":"Pular","next":"Pr\xf3ximo","recapture":"Capturar foto novamente","continue":"Continuar"},"error":"Ocorreu um erro ao capturar a foto. O processo de check-in continuar\xe1 sem a foto."},"wayfinding":{"title":"Para onde gostaria de ir?"},"callingMenu":{"title":"Menu de chamadas"},"bell":{"status":{"success":{"title":"A campainha est\xe1 tocando","message":"Algu\xe9m vir\xe1 em breve."},"error":{"title":"Algo correu mal","message":"Tente novamente"},"loading":{"title":"A conectar...","message":"Aguarde por favor"}}},"access":{"control":{"title":"Agora voc\xea pode abrir a porta","subtitle":"Por favor, pressione o bot\xe3o abaixo.","titleAuto":"Acesso autom\xe1tico \xe0 porta","subtitleAuto":"A porta ser\xe1 aberta automaticamente para voc\xea","openBtn":"Abrir"},"status":{"success":{"title":"A porta foi aberta","message":""},"error":{"title":"Algo deu errado","message":"Entre em contato com sua pessoa de contato para abrir a porta."},"loading":{"title":"Abrindo a porta...","message":""}}}}');


var $ae510afae8998352$exports = {};
$ae510afae8998352$exports = JSON.parse('{"language":{"title":"Elige tu idioma","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Hola, \xbfc\xf3mo podemos ayudarte?","checkIn":"Registrar entrada","independentManualCheckIn":"Sin cita","integratedManualCheckIn":"Registrar entrada manualmente","checkOut":"Registrar salida","manualCheckOut":"Registrar salida manualmente","parcelDelivery":"Entrega de paquetes","foodDelivery":"Entrega de comida","callReception":"Llamar a recepci\xf3n","overview":"Resumen","unavailable":"La recepci\xf3n no est\xe1 disponible en este momento."},"check":{"option":{"checkin":{"title":"Elige una opci\xf3n para registrar entrada","manual":"Registrar entrada manualmente","code":"Registrar entrada con PIN o c\xf3digo QR","code-no-qr":"Registrar entrada con c\xf3digo PIN"},"checkout":{"title":"Elige una opci\xf3n para registrar salida","manual":"Registrar salida con nombre","code":"Registrar salida con PIN o c\xf3digo QR","code-no-qr":"Registrar salida con c\xf3digo PIN"}},"title":"Ahora puedes escanear tu c\xf3digo QR o ingresar tu c\xf3digo PIN.","orText":"O","qrScanner":{"checkin":{"title":"Elige una opci\xf3n para registrar entrada"},"checkout":{"title":"Elige una opci\xf3n para registrar salida"},"btn":"Escanear c\xf3digo QR"},"hidScanner":{"title":"Acerca el c\xf3digo QR al esc\xe1ner de abajo o introduce tu c\xf3digo PIN"},"pinOnly":{"title":"Por favor, introduce tu c\xf3digo PIN"},"pinCode":"Ingresa tu c\xf3digo PIN","manually":{"checkin":"\xbfNo tienes un c\xf3digo de registro?"},"status":{"idle":{"title":"Tu c\xf3digo se est\xe1 escaneando.","message":"Por favor espera...","nfc":{"title":"Su etiqueta se est\xe1 escaneando.","message":"Por favor, espere..."}},"loading":{"title":"Tu c\xf3digo se est\xe1 escaneando.","message":"Por favor espera...","nfc":{"title":"Su etiqueta se est\xe1 escaneando.","message":"Por favor, espere..."}},"error":{"title":"Tu c\xf3digo no es v\xe1lido.","message":"\xa1Por favor int\xe9ntalo de nuevo!","nfc":{"title":"Su etiqueta no es v\xe1lida.","message":"\xa1Por favor, int\xe9ntelo de nuevo!"},"meeting":{"tooEarly":{"title":"Llegaste un poco temprano","message":"Tu c\xf3digo es v\xe1lido a partir de las {{validFromTime}}. La reuni\xf3n comienza a las {{meetingStartTime}}."},"tooLate":{"title":"Este c\xf3digo ha caducado","message":"La reuni\xf3n termin\xf3 a las {{meetingEndTime}}. Tu c\xf3digo era v\xe1lido hasta las {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Te has registrado exitosamente.","message":"Gracias."},"MeetingAttendee":{"no-email-sms":{"title":"Te has registrado exitosamente.","message":"Gracias."},"email-sms":{"title":"Te has registrado exitosamente.","message":"Tu persona de contacto ha sido notificada."},"call-ping":{"title":"Te has registrado exitosamente.","message":"Ahora estableceremos una llamada telef\xf3nica con tu persona de contacto."},"teams-call":{"title":"Te has registrado exitosamente.","message":"Ahora estableceremos una llamada de Microsoft Teams con tu persona de contacto."},"badge":{"title":"Gracias por registrarte, tu credencial ser\xe1 impresa.","message":""},"video-call":{"title":"Te has registrado exitosamente.","message":"Configurando su videollamada con la persona de contacto."}},"Employee":{"title":"Te has registrado exitosamente.","message":"Gracias.","badge":{"title":"Gracias por registrarte, tu credencial ser\xe1 impresa.","message":""}},"Visitor":{"title":"Te has registrado exitosamente.","message":"Gracias.","badge":{"title":"Gracias por registrarte, tu credencial ser\xe1 impresa.","message":""}}},"checkout":{"default":{"title":"Has registrado tu salida exitosamente.<br/>","message":"Te vemos pronto."},"MeetingAttendee":{"title":"Has registrado tu salida exitosamente.","message":"Te vemos pronto."},"Employee":{"title":"Has registrado tu salida exitosamente.","message":"Te vemos pronto."},"Visitor":{"title":"Has registrado tu salida exitosamente.","message":"Te vemos pronto."},"access":{"title":"Has registrado tu salida exitosamente.","message":"Ahora puedes abrir la puerta."}}}}},"missingFields":{"title":"Algunos datos m\xe1s antes del check-in","subtitle":"Los campos marcados con * son obligatorios","btn":"Registrar entrada","placeholder":{"other":"Otro...","otherInput":"Introduzca su opci\xf3n"},"error":{"required":"No has rellenado este campo","email":"Direcci\xf3n de correo electr\xf3nico no v\xe1lida","phone":"N\xfamero de tel\xe9fono no v\xe1lido"}},"manualCheckin":{"title":{"default":"Por favor completa.","documentScanner":"Preste atenci\xf3n al insertar su documento de identidad:"},"subtitle":{"default":"Nota - todos los campos * son obligatorio","documentScanner":[{"parts":[{"text":"El ","bold":false},{"text":"lado con los caracteres <<< >>> (MRZ) ","bold":true},{"text":"debe estar ","bold":false},{"text":"orientado hacia el quiosco / esc\xe1ner.","bold":true}]},{"parts":[{"text":"Mantenga la tarjeta quieta ","bold":false},{"text":"hasta que los campos se completen autom\xe1ticamente.","bold":true}]}]},"noOption":"Sin opci\xf3n","btn":"Registrar entrada","placeholder":{"name":"Tu nombre *","email":"Tu correo electr\xf3nico *","phone":"N\xfamero de m\xf3vil","contactName":"Tu persona de contacto*","other":"Otro..."},"error":{"required":"No completaste este campo","name":"Nombre inv\xe1lido","email":"Direcci\xf3n de correo electr\xf3nico inv\xe1lida","phone":"N\xfamero de m\xf3vil inv\xe1lido"},"status":{"idle":{"no-contact":{"title":"Por favor espera...","message":"Tu registro est\xe1 siendo procesado."},"contact":{"title":"Por favor espera...","message":"Tu contacto est\xe1 siendo notificado."}},"loading":{"no-contact":{"title":"Por favor espera...","message":"Tu registro est\xe1 siendo procesado."},"contact":{"title":"Por favor espera...","message":"Tu contacto est\xe1 siendo notificado."}},"success":{"no-email-sms":{"title":"Te has registrado exitosamente.","message":"Gracias."},"email-sms":{"title":"Te has registrado exitosamente.","message":"Tu persona de contacto ha sido notificada."},"call-ping":{"title":"Te has registrado exitosamente.","message":"Ahora estableceremos una llamada telef\xf3nica con tu persona de contacto."},"teams-call":{"title":"Te has registrado exitosamente.","message":"Ahora estableceremos una llamada de Microsoft Teams con tu persona de contacto."},"badge":{"title":"Gracias por registrarte, tu credencial ser\xe1 impresa.","message":""},"video-call":{"title":"Te has registrado exitosamente.","message":"Configurando su videollamada con la persona de contacto."}},"error":{"title":"Algo sali\xf3 mal.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}},"documentScan":{"invalid":{"title":"Documento no v\xe1lido","message":"El documento no pudo ser verificado o ha caducado. Por favor, introduzca sus datos manualmente."}}},"manualCheckout":{"title":"Ingresa tu nombre para registrar salida","btn":"Registrar salida","form":{"placeholder":{"name":"Tu nombre completo *"},"loading":"Cargando...","noOptions":"Sin opciones"},"error":{"required":"No completaste este campo","name":"Nombre inv\xe1lido"},"status":{"idle":{"title":"Estamos procesando tu informaci\xf3n.","message":"Por favor espera..."},"loading":{"title":"Estamos procesando tu informaci\xf3n.","message":"Por favor espera..."},"success":{"title":"Has registrado tu salida exitosamente.","message":"Gracias y que tengas un buen d\xeda."},"successAccess":{"title":"Has registrado tu salida exitosamente.","message":"Ahora puedes abrir la puerta."},"error":{"title":"Ocurri\xf3 un error al registrar la salida.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"call":{"title":{"no-email-sms":"\xbfTe gustar\xeda notificar a tu contacto?","email-sms":"Hemos enviado un correo electr\xf3nico/SMS a tu contacto.<br/>\xbfQuieres establecer una llamada con ellos adicionalmente?"},"callBtn":"Llamar","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Videollamada","teamsCallBtn":"Llamada de Teams","teamsMessageBtn":"Mensaje de Teams","googleChatMessageBtn":"Google Chat","noBtn":"Cancelar","cancelBtn":"Cancelar llamada","status":{"connecting":{"title":"Estableciendo llamada.<br/>Por favor espera...","message":""},"ringing":{"title":"Llamando a tu persona de contacto<br/>Por favor espera...","message":""},"ringingReception":{"title":"Llamada iniciada...","message":""},"open":{"title":"Llamada en curso.","message":""},"close":{"title":"Llamada finalizada.<br/>","message":""},"closeAccess":{"title":"Llamada finalizada.<br/>Ahora puedes abrir la puerta.","message":""},"closeReception":{"title":"La llamada ha finalizado.","message":""},"error":{"title":"No se pudo establecer la llamada.<br/>\xbfLlamar de nuevo?","message":""}}},"message":{"status":{"idle":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"loading":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"success":{"title":"El SMS ha sido enviado. El contacto ha sido notificado.","message":"\xa1Gracias!"},"successAccess":{"title":"El SMS ha sido enviado. El contacto ha sido notificado.","message":"Ahora puedes abrir la puerta."},"error":{"title":"SMS no enviado.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"videoCall":{"title":"Videollamada","endCall":"Finalizar llamada","status":{"idle":{"title":"Estamos creando una sala de video.","message":"Por favor espera..."},"loading":{"title":"Estamos creando una sala de video.","message":"Por favor espera..."},"success":{"title":"La sala de video ha sido creada exitosamente.","message":"Uni\xe9ndose a la sala..."},"error":{"title":"La sala de video no fue creada exitosamente.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"teamsCall":{"title":"Llamada de Teams","controls":{"startCall":"Iniciar llamada","endCall":"Salir","camera":"C\xe1mara","cameraOff":"C\xe1mara apagada","mic":"Micr\xf3fono","micOff":"Micr\xf3fono apagado","ringing":"Sonando...","noAnswer":"Nadie ha contestado la llamada."},"status":{"connecting":{"title":"Estableciendo llamada.<br/>Por favor espera...","message":""},"ringing":{"title":"Llamando a tu persona de contacto<br/>Por favor espera...","message":""},"connected":{"title":"Estableciendo llamada","message":""},"disconnected":{"title":"Llamada finalizada.<br/>","message":""},"disconnectedAccess":{"title":"Llamada finalizada.<br/>Ahora puedes abrir la puerta.","message":""},"error":{"title":"No se pudo establecer la llamada.<br/>Por favor int\xe9ntalo de nuevo","message":""},"noAnswer":{"title":"Nadie contest\xf3 la llamada.<br/>Por favor int\xe9ntalo de nuevo.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"loading":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"success":{"title":"El mensaje ha sido enviado. El contacto ha sido notificado.","message":"\xa1Gracias!"},"successAccess":{"title":"El mensaje ha sido enviado. El contacto ha sido notificado.","message":"Ahora puedes abrir la puerta."},"error":{"title":"Mensaje no enviado.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"googleChatMessage":{"status":{"idle":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"loading":{"title":"Estamos notificando a tu persona de contacto.","message":"Por favor espera..."},"success":{"title":"El mensaje ha sido enviado. El contacto ha sido notificado.","message":"\xa1Gracias!"},"successAccess":{"title":"El mensaje ha sido enviado. El contacto ha sido notificado.","message":"Ahora puedes abrir la puerta."},"error":{"title":"Mensaje no enviado.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"packageDelivery":{"title":"\xa1Qu\xe9 amable de tu parte entregar un paquete!","subtitle":"Selecciona y notifica al destinatario","subtitle1":"\xa1Presiona el bot\xf3n de abajo para hacernos saber que est\xe1s aqu\xed!","subtitle2":"","input":{"label":{"contact":"\xbfPara qui\xe9n es el paquete?"},"error":{"contact":{"required":"No completaste este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando a la persona de contacto.","message":"Por favor espera..."},"success":{"no-email-sms":{"title":"\xa1Gracias por tu entrega!","message":""},"email-sms":{"title":"La persona de contacto ha sido notificada.","message":"\xa1Gracias por tu entrega!"},"call-ping":{"title":"\xa1Gracias por tu entrega!","message":"Ahora se establecer\xe1 una conexi\xf3n telef\xf3nica con la persona de contacto."},"teams-call":{"title":"\xa1Gracias por tu entrega!","message":"Ahora se realizar\xe1 una llamada de Microsoft Teams a tu persona de contacto."},"video-call":{"title":"\xa1Gracias por tu entrega!","message":"Configurando su videollamada con la persona de contacto."}},"error":{"title":"Algo sali\xf3 mal.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"foodDelivery":{"title":"\xa1Qu\xe9 amable de tu parte entregar comida!","subtitle":"Selecciona y notifica al destinatario","subtitle1":"\xa1Presiona el bot\xf3n de abajo para hacernos saber que est\xe1s aqu\xed!","subtitle2":"","input":{"label":{"contact":"\xbfPara qui\xe9n es la comida?"},"error":{"contact":{"required":"No completaste este campo"}}},"button":{"submit":"Notificar"},"status":{"loading":{"title":"Estamos notificando al contacto.","message":"\xa1Por favor espera!"},"success":{"no-email-sms":{"title":"\xa1Gracias por tu entrega!","message":""},"email-sms":{"title":"El contacto ha sido notificado.","message":"\xa1Gracias por tu entrega!"},"call-ping":{"title":"\xa1Gracias por tu entrega!","message":"Ahora se establecer\xe1 una conexi\xf3n telef\xf3nica con tu persona de contacto."},"teams-call":{"title":"\xa1Gracias por tu entrega!","message":"Ahora se realizar\xe1 una llamada de Microsoft Teams a tu persona de contacto."},"video-call":{"title":"\xa1Gracias por tu entrega!","message":"Configurando su videollamada con la persona de contacto."}},"error":{"title":"Algo sali\xf3 mal.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}}},"QRCodeScanner":{"title":"Por favor escanea tu c\xf3digo QR","subtitle":"Alinea el c\xf3digo QR dentro de las esquinas rojas y mant\xe9n tu tel\xe9fono estable.","error":"Formato de c\xf3digo QR inv\xe1lido","unknownError":"Error desconocido ocurri\xf3 durante el escaneo"},"common":{"backBtn":"Atr\xe1s"},"previewPDF":{"page":{"of":"de","previous":"Anterior","next":"Siguiente"},"button":{"cancel":"Cancelar","accept":"Aceptar","next":"Siguiente"},"title":{"consent":"Consentimiento requerido"}},"offline":{"title":"Desconectado","receptionMessage":"La recepci\xf3n digital est\xe1 desconectada en este momento y no puede ser utilizada, \xa1la conexi\xf3n a internet debe ser verificada!","check":"\xbfEres un visitante y quieres hablar directamente con un empleado? Por favor llama a {{receptionistPhone}}"},"overview":{"title":"\xa1Ingresa el c\xf3digo para abrir el resumen!","noUsers":"Sin registros","status":{"success":{"title":"El c\xf3digo es v\xe1lido.","message":""},"error":{"title":"El c\xf3digo es inv\xe1lido.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}},"checkoutStatus":{"loading":{"title":"Por favor espera...","message":""},"success":{"title":"Salida registrada exitosamente.","message":""},"error":{"title":"Algo sali\xf3 mal.","message":"\xa1Por favor int\xe9ntalo de nuevo!"}},"listTitle":"Lista de personas que registraron entrada hoy pero no registraron salida","page":"P\xe1gina ","table":{"head":{"fullName":"Nombre","type":"Tipo","checkedinAt":"Registr\xf3 entrada a las","host":"Anfitri\xf3n"},"type":{"Package":"Entrega de paquetes","Food":"Entrega de comida","Visitor":"Visitante","MeetingAttendee":"Visitante invitado","Employee":"Empleado","Guest":"Visitante"}},"confirmModal":{"title":"\xbfEst\xe1s seguro de que quieres registrar la salida de {{fullName}}?","cancel":"Cancelar","checkout":"Registrar salida"}},"wifi":{"title":"Conectarse a la red Wi-Fi"},"door":{"external":{"title":"Abriendo la puerta","subtitle":"La puerta se abrir\xe1 en breve. Por favor espera..."},"control":{"title":"Ahora puedes abrir la puerta","subtitle":"\xa1Por favor presiona el bot\xf3n de abajo!","openBtn":"Abrir la puerta"},"status":{"success":{"title":"La puerta ha sido abierta","message":""},"error":{"title":"Algo sali\xf3 mal","message":"Por favor contacta a tu persona de contacto para abrir la puerta."},"loading":{"title":"Abriendo la puerta...","message":""}}},"photo":{"title":"\xbfTe gustar\xeda tomar una foto como parte de tu proceso de registro?","required":{"title":"\xa1Verificaci\xf3n de foto requerida!","instructions":"Por favor p\xe1rate frente a la c\xe1mara y sigue las instrucciones en pantalla.","securityNotice":"Por motivos de seguridad y verificaci\xf3n, se requiere una foto durante el registro.","privacyInfo":"Respetamos tu privacidad. Tus datos se almacenan de forma segura y se usan solo para identificaci\xf3n.","closingMessage":"Gracias por tu cooperaci\xf3n."},"optional":{"title":"\xbfTe gustar\xeda tomar una foto como parte de tu proceso de registro?","instructions":"","securityNotice":"Tomar una foto puede ayudar a agilizar la identificaci\xf3n y mejorar la seguridad.","privacyInfo":"Respetamos tu privacidad. Este paso es opcional y tus datos ser\xe1n manejados de forma segura.","closingMessage":"Puedes omitir este paso si prefieres."},"subtitle":"Por favor posici\xf3nate dentro del marco y mantente quieto para obtener el mejor resultado","button":{"cancel":"Cancelar","accept":"Aceptar","skip":"Omitir","next":"Siguiente","recapture":"Volver a tomar foto","continue":"Continuar"},"error":"Ocurri\xf3 un error al capturar la foto. El proceso de registro continuar\xe1 sin la foto."},"wayfinding":{"title":"\xbfA d\xf3nde te gustar\xeda ir?"},"callingMenu":{"title":"Men\xfa de llamadas"},"bell":{"status":{"success":{"title":"El timbre est\xe1 sonando","message":"Alguien vendr\xe1 en breve."},"error":{"title":"Algo sali\xf3 mal","message":"Int\xe9ntelo de nuevo"},"loading":{"title":"Conectando...","message":"Por favor espere"}}},"access":{"control":{"title":"Ahora puedes abrir la puerta","subtitle":"Por favor presiona el bot\xf3n de abajo.","titleAuto":"Acceso autom\xe1tico a la puerta","subtitleAuto":"La puerta se abrir\xe1 autom\xe1ticamente para ti","openBtn":"Abrir"},"status":{"success":{"title":"La puerta ha sido abierta","message":""},"error":{"title":"Algo sali\xf3 mal","message":"Por favor contacta a tu persona de contacto para abrir la puerta."},"loading":{"title":"Abriendo la puerta...","message":""}}}}');


var $773785e71cd37a48$exports = {};
$773785e71cd37a48$exports = JSON.parse('{"language":{"title":"\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"\u3053\u3093\u306B\u3061\u306F\u3001\u3069\u306E\u3088\u3046\u306B\u304A\u624B\u4F1D\u3044\u3067\u304D\u307E\u3059\u304B\uFF1F","checkIn":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","independentManualCheckIn":"\u4E88\u7D04\u306A\u3057","integratedManualCheckIn":"\u624B\u52D5\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","checkOut":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","manualCheckOut":"\u624B\u52D5\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","parcelDelivery":"\u8377\u7269\u914D\u9054","foodDelivery":"\u98DF\u54C1\u914D\u9054","callReception":"\u53D7\u4ED8\u306B\u96FB\u8A71","overview":"\u6982\u8981","unavailable":"\u53D7\u4ED8\u306F\u73FE\u5728\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002"},"check":{"option":{"checkin":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","manual":"\u624B\u52D5\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","code":"PIN\u307E\u305F\u306FQR\u30B3\u30FC\u30C9\u3067\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","code-no-qr":"PIN\u30B3\u30FC\u30C9\u3067\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3"},"checkout":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","manual":"\u540D\u524D\u3067\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","code":"PIN\u307E\u305F\u306FQR\u30B3\u30FC\u30C9\u3067\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","code-no-qr":"PIN\u30B3\u30FC\u30C9\u3067\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8"}},"title":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u304B\u3001PIN\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","orText":"\u307E\u305F\u306F","qrScanner":{"checkin":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"checkout":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"},"btn":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3"},"hidScanner":{"title":"QR\u30B3\u30FC\u30C9\u3092\u4E0B\u306E\u30B9\u30AD\u30E3\u30CA\u30FC\u306B\u304B\u3056\u3059\u304B\u3001PIN\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"pinOnly":{"title":"PIN\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"pinCode":"PIN\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","manually":{"checkin":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u30B3\u30FC\u30C9\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u3067\u3059\u304B\uFF1F"},"status":{"idle":{"title":"\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","nfc":{"title":"\u30BF\u30B0\u3092\u8AAD\u307F\u53D6\u3063\u3066\u3044\u307E\u3059\u3002","message":"\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u2026"}},"loading":{"title":"\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","nfc":{"title":"\u30BF\u30B0\u3092\u8AAD\u307F\u53D6\u3063\u3066\u3044\u307E\u3059\u3002","message":"\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u2026"}},"error":{"title":"\u30B3\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01","nfc":{"title":"\u7121\u52B9\u306A\u30BF\u30B0\u3067\u3059\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002"},"meeting":{"tooEarly":{"title":"\u5C11\u3057\u65E9\u3059\u304E\u307E\u3059","message":"\u30B3\u30FC\u30C9\u306F {{validFromTime}} \u304B\u3089\u6709\u52B9\u3067\u3059\u3002\u4F1A\u8B70\u306F {{meetingStartTime}} \u306B\u59CB\u307E\u308A\u307E\u3059\u3002"},"tooLate":{"title":"\u3053\u306E\u30B3\u30FC\u30C9\u306F\u671F\u9650\u5207\u308C\u3067\u3059","message":"\u4F1A\u8B70\u306F {{meetingEndTime}} \u306B\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002\u30B3\u30FC\u30C9\u306F {{validUntilTime}} \u307E\u3067\u6709\u52B9\u3067\u3057\u305F\u3002"}}},"success":{"checkin":{"default":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002"},"MeetingAttendee":{"no-email-sms":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002"},"email-sms":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002"},"call-ping":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306E\u96FB\u8A71\u63A5\u7D9A\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"teams-call":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306EMicrosoft Teams\u901A\u8A71\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"badge":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30D0\u30C3\u30B8\u304C\u5370\u5237\u3055\u308C\u307E\u3059\u3002","message":""},"video-call":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306E\u30D3\u30C7\u30AA\u901A\u8A71\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002"}},"Employee":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002","badge":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30D0\u30C3\u30B8\u304C\u5370\u5237\u3055\u308C\u307E\u3059\u3002","message":""}},"Visitor":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002","badge":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30D0\u30C3\u30B8\u304C\u5370\u5237\u3055\u308C\u307E\u3059\u3002","message":""}}},"checkout":{"default":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002<br/>","message":"\u307E\u305F\u304A\u4F1A\u3044\u3057\u307E\u3057\u3087\u3046\u3002"},"MeetingAttendee":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u307E\u305F\u304A\u4F1A\u3044\u3057\u307E\u3057\u3087\u3046\u3002"},"Employee":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u307E\u305F\u304A\u4F1A\u3044\u3057\u307E\u3057\u3087\u3046\u3002"},"Visitor":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u307E\u305F\u304A\u4F1A\u3044\u3057\u307E\u3057\u3087\u3046\u3002"},"access":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"}}}}},"missingFields":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u306E\u524D\u306B\u3082\u3046\u5C11\u3057\u60C5\u5831\u3092\u304A\u9858\u3044\u3057\u307E\u3059","subtitle":"* \u306E\u4ED8\u3044\u305F\u9805\u76EE\u306F\u5FC5\u9808\u3067\u3059","btn":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","placeholder":{"other":"\u305D\u306E\u4ED6...","otherInput":"\u9078\u629E\u80A2\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"},"error":{"required":"\u3053\u306E\u9805\u76EE\u304C\u672A\u5165\u529B\u3067\u3059","email":"\u7121\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3067\u3059","phone":"\u7121\u52B9\u306A\u96FB\u8A71\u756A\u53F7\u3067\u3059"}},"manualCheckin":{"title":{"default":"\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","documentScanner":"\u8EAB\u5206\u8A3C\u660E\u66F8\u3092\u633F\u5165\u3059\u308B\u969B\u306F\u6B21\u306E\u70B9\u306B\u6CE8\u610F\u3057\u3066\u304F\u3060\u3055\u3044\uFF1A"},"subtitle":{"default":"\u6CE8\u610F - \u3059\u3079\u3066\u306E\u9805\u76EE * \u306F\u5FC5\u9808\u3067\u3059","documentScanner":[{"parts":[{"text":"<<< >>> \u306E\u6587\u5B57 (MRZ) \u304C\u8A18\u8F09\u3055\u308C\u305F","bold":true},{"text":"\u9762\u3092","bold":false},{"text":"\u30AD\u30AA\u30B9\u30AF\uFF0F\u30B9\u30AD\u30E3\u30CA\u30FC\u306B\u5411\u3051\u3066","bold":true},{"text":"\u304F\u3060\u3055\u3044\u3002","bold":false}]},{"parts":[{"text":"\u30D5\u30A3\u30FC\u30EB\u30C9\u304C\u81EA\u52D5\u7684\u306B\u5165\u529B\u3055\u308C\u308B\u307E\u3067\u3001","bold":true},{"text":"\u30AB\u30FC\u30C9\u3092\u305D\u306E\u307E\u307E\u52D5\u304B\u3055\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002","bold":false}]}]},"noOption":"\u9078\u629E\u80A2\u306A\u3057","btn":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3","placeholder":{"name":"\u304A\u540D\u524D *","email":"\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9 *","phone":"\u643A\u5E2F\u96FB\u8A71\u756A\u53F7","contactName":"\u62C5\u5F53\u8005 *","other":"\u305D\u306E\u4ED6..."},"error":{"required":"\u3053\u306E\u9805\u76EE\u3092\u5165\u529B\u3057\u3066\u3044\u307E\u305B\u3093","name":"\u7121\u52B9\u306A\u540D\u524D","email":"\u7121\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9","phone":"\u7121\u52B9\u306A\u643A\u5E2F\u96FB\u8A71\u756A\u53F7"},"status":{"idle":{"no-contact":{"title":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":"\u767B\u9332\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059\u3002"},"contact":{"title":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u4E2D\u3067\u3059\u3002"}},"loading":{"no-contact":{"title":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":"\u767B\u9332\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059\u3002"},"contact":{"title":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u4E2D\u3067\u3059\u3002"}},"success":{"no-email-sms":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002"},"email-sms":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002"},"call-ping":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306E\u96FB\u8A71\u63A5\u7D9A\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"teams-call":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306EMicrosoft Teams\u901A\u8A71\u3092\u958B\u59CB\u3057\u307E\u3059"},"badge":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\u30D0\u30C3\u30B8\u304C\u5370\u5237\u3055\u308C\u307E\u3059\u3002","message":""},"video-call":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u62C5\u5F53\u8005\u3068\u306E\u30D3\u30C7\u30AA\u901A\u8A71\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002"}},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}},"documentScan":{"invalid":{"title":"\u7121\u52B9\u306A\u66F8\u985E","message":"\u66F8\u985E\u3092\u78BA\u8A8D\u3067\u304D\u306A\u304B\u3063\u305F\u304B\u3001\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002\u624B\u52D5\u3067\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"}}},"manualCheckout":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u3059\u308B\u304A\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","btn":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8","form":{"placeholder":{"name":"\u30D5\u30EB\u30CD\u30FC\u30E0 *"},"loading":"\u8AAD\u307F\u8FBC\u307F\u4E2D...","noOptions":"\u9078\u629E\u80A2\u306A\u3057"},"error":{"required":"\u3053\u306E\u9805\u76EE\u3092\u5165\u529B\u3057\u3066\u3044\u307E\u305B\u3093","name":"\u7121\u52B9\u306A\u540D\u524D"},"status":{"idle":{"title":"\u60C5\u5831\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"loading":{"title":"\u60C5\u5831\u3092\u51E6\u7406\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002\u826F\u3044\u4E00\u65E5\u3092\u3002"},"successAccess":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002","message":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"call":{"title":{"no-email-sms":"\u62C5\u5F53\u8005\u306B\u9023\u7D61\u3057\u307E\u3059\u304B\uFF1F","email-sms":"\u62C5\u5F53\u8005\u306B\u30E1\u30FC\u30EB/SMS\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002<br/>\u8FFD\u52A0\u3067\u96FB\u8A71\u3092\u304B\u3051\u307E\u3059\u304B\uFF1F"},"callBtn":"\u901A\u8A71","pingBtn":"\u547C\u3073\u51FA\u3057","smsBtn":"SMS","callVideoBtn":"\u30D3\u30C7\u30AA\u901A\u8A71","teamsCallBtn":"Teams\u901A\u8A71","teamsMessageBtn":"Teams\u30E1\u30C3\u30BB\u30FC\u30B8","googleChatMessageBtn":"Google Chat","noBtn":"\u30AD\u30E3\u30F3\u30BB\u30EB","cancelBtn":"\u901A\u8A71\u3092\u30AD\u30E3\u30F3\u30BB\u30EB","status":{"connecting":{"title":"\u901A\u8A71\u3092\u958B\u59CB\u3057\u3066\u3044\u307E\u3059\u3002<br/>\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":""},"ringing":{"title":"\u62C5\u5F53\u8005\u306B\u96FB\u8A71\u3092\u304B\u3051\u3066\u3044\u307E\u3059<br/>\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":""},"ringingReception":{"title":"\u901A\u8A71\u3092\u958B\u59CB\u3057\u307E\u3057\u305F...","message":""},"open":{"title":"\u901A\u8A71\u4E2D\u3067\u3059\u3002","message":""},"close":{"title":"\u901A\u8A71\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002<br/>","message":""},"closeAccess":{"title":"\u901A\u8A71\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002<br/>\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","message":""},"closeReception":{"title":"\u901A\u8A71\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002","message":""},"error":{"title":"\u901A\u8A71\u304C\u7E4B\u304C\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002<br/>\u518D\u5EA6\u304B\u3051\u76F4\u3057\u307E\u3059\u304B\uFF1F","message":""}}},"message":{"status":{"idle":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"loading":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"title":"SMS\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01"},"successAccess":{"title":"SMS\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"title":"SMS\u9001\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"videoCall":{"title":"\u30D3\u30C7\u30AA\u901A\u8A71","endCall":"\u901A\u8A71\u7D42\u4E86","status":{"idle":{"title":"\u30D3\u30C7\u30AA\u30EB\u30FC\u30E0\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"loading":{"title":"\u30D3\u30C7\u30AA\u30EB\u30FC\u30E0\u3092\u4F5C\u6210\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"title":"\u30D3\u30C7\u30AA\u30EB\u30FC\u30E0\u304C\u6B63\u5E38\u306B\u4F5C\u6210\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u30EB\u30FC\u30E0\u306B\u53C2\u52A0\u4E2D..."},"error":{"title":"\u30D3\u30C7\u30AA\u30EB\u30FC\u30E0\u306E\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"teamsCall":{"title":"Teams\u901A\u8A71","controls":{"startCall":"\u901A\u8A71\u958B\u59CB","endCall":"\u9000\u51FA","camera":"\u30AB\u30E1\u30E9","cameraOff":"\u30AB\u30E1\u30E9\u30AA\u30D5","mic":"\u30DE\u30A4\u30AF","micOff":"\u30DE\u30A4\u30AF\u30AA\u30D5","ringing":"\u547C\u3073\u51FA\u3057\u4E2D...","noAnswer":"\u8AB0\u3082\u901A\u8A71\u306B\u5FDC\u7B54\u3057\u307E\u305B\u3093\u3067\u3057\u305F\u3002"},"status":{"connecting":{"title":"\u901A\u8A71\u3092\u958B\u59CB\u3057\u3066\u3044\u307E\u3059\u3002<br/>\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":""},"ringing":{"title":"\u62C5\u5F53\u8005\u306B\u96FB\u8A71\u3092\u304B\u3051\u3066\u3044\u307E\u3059<br/>\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":""},"connected":{"title":"\u901A\u8A71\u958B\u59CB\u4E2D","message":""},"disconnected":{"title":"\u901A\u8A71\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002<br/>","message":""},"disconnectedAccess":{"title":"\u901A\u8A71\u304C\u7D42\u4E86\u3057\u307E\u3057\u305F\u3002<br/>\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","message":""},"error":{"title":"\u901A\u8A71\u304C\u7E4B\u304C\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002<br/>\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044","message":""},"noAnswer":{"title":"\u8AB0\u3082\u901A\u8A71\u306B\u5FDC\u7B54\u3057\u307E\u305B\u3093\u3067\u3057\u305F\u3002<br/>\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","message":""}}},"teamsMessage":{"status":{"idle":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"loading":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01"},"successAccess":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u9001\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"googleChatMessage":{"status":{"idle":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"loading":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01"},"successAccess":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"},"error":{"title":"\u30E1\u30C3\u30BB\u30FC\u30B8\u9001\u4FE1\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"packageDelivery":{"title":"\u8377\u7269\u306E\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","subtitle":"\u53D7\u53D6\u4EBA\u3092\u9078\u629E\u3057\u3066\u901A\u77E5\u3057\u3066\u304F\u3060\u3055\u3044","subtitle1":"\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u5230\u7740\u3092\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\uFF01","subtitle2":"","input":{"label":{"contact":"\u8377\u7269\u306E\u5B9B\u5148"},"error":{"contact":{"required":"\u3053\u306E\u9805\u76EE\u3092\u5165\u529B\u3057\u3066\u3044\u307E\u305B\u3093"}}},"button":{"submit":"\u901A\u77E5"},"status":{"loading":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"success":{"no-email-sms":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":""},"email-sms":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01"},"call-ping":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306E\u96FB\u8A71\u63A5\u7D9A\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"teams-call":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306EMicrosoft Teams\u901A\u8A71\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"video-call":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306E\u30D3\u30C7\u30AA\u901A\u8A71\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002"}},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"foodDelivery":{"title":"\u98DF\u54C1\u306E\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01","subtitle":"\u53D7\u53D6\u4EBA\u3092\u9078\u629E\u3057\u3066\u901A\u77E5\u3057\u3066\u304F\u3060\u3055\u3044","subtitle1":"\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u5230\u7740\u3092\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\uFF01","subtitle2":"","input":{"label":{"contact":"\u98DF\u54C1\u306E\u5B9B\u5148"},"error":{"contact":{"required":"\u3053\u306E\u9805\u76EE\u3092\u5165\u529B\u3057\u3066\u3044\u307E\u305B\u3093"}}},"button":{"submit":"\u901A\u77E5"},"status":{"loading":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3057\u3066\u3044\u307E\u3059\u3002","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\uFF01"},"success":{"no-email-sms":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":""},"email-sms":{"title":"\u62C5\u5F53\u8005\u306B\u901A\u77E5\u3055\u308C\u307E\u3057\u305F\u3002","message":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01"},"call-ping":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306E\u96FB\u8A71\u63A5\u7D9A\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"teams-call":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306EMicrosoft Teams\u901A\u8A71\u3092\u958B\u59CB\u3057\u307E\u3059\u3002"},"video-call":{"title":"\u914D\u9054\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\uFF01","message":"\u62C5\u5F53\u8005\u3068\u306E\u30D3\u30C7\u30AA\u901A\u8A71\u3092\u8A2D\u5B9A\u3057\u3066\u3044\u307E\u3059\u3002"}},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}}},"QRCodeScanner":{"title":"QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u304F\u3060\u3055\u3044","subtitle":"QR\u30B3\u30FC\u30C9\u3092\u8D64\u3044\u67A0\u5185\u306B\u5408\u308F\u305B\u3066\u3001\u96FB\u8A71\u3092\u5B89\u5B9A\u3057\u3066\u6301\u3063\u3066\u304F\u3060\u3055\u3044\u3002","error":"\u7121\u52B9\u306AQR\u30B3\u30FC\u30C9\u5F62\u5F0F","unknownError":"\u30B9\u30AD\u30E3\u30F3\u4E2D\u306B\u4E0D\u660E\u306A\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F"},"common":{"backBtn":"\u623B\u308B"},"previewPDF":{"page":{"of":"\u306E","previous":"\u524D","next":"\u6B21"},"button":{"cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","accept":"\u627F\u8A8D","next":"\u6B21\u3078"},"title":{"consent":"\u540C\u610F\u304C\u5FC5\u8981\u3067\u3059"}},"offline":{"title":"\u30AA\u30D5\u30E9\u30A4\u30F3","receptionMessage":"\u30C7\u30B8\u30BF\u30EB\u53D7\u4ED8\u306F\u73FE\u5728\u30AA\u30D5\u30E9\u30A4\u30F3\u3067\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\uFF01","check":"\u8A2A\u554F\u8005\u306E\u65B9\u3067\u5F93\u696D\u54E1\u3068\u76F4\u63A5\u8A71\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F{{receptionistPhone}}\u306B\u304A\u96FB\u8A71\u304F\u3060\u3055\u3044"},"overview":{"title":"\u6982\u8981\u3092\u958B\u304F\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\uFF01","noUsers":"\u767B\u9332\u306A\u3057","status":{"success":{"title":"\u30B3\u30FC\u30C9\u304C\u6709\u52B9\u3067\u3059\u3002","message":""},"error":{"title":"\u30B3\u30FC\u30C9\u304C\u7121\u52B9\u3067\u3059\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}},"checkoutStatus":{"loading":{"title":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...","message":""},"success":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u5B8C\u4E86\u3002","message":""},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\uFF01"}},"listTitle":"\u672C\u65E5\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u3057\u305F\u304C\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u3057\u3066\u3044\u306A\u3044\u65B9\u306E\u30EA\u30B9\u30C8","page":"\u30DA\u30FC\u30B8 ","table":{"head":{"fullName":"\u540D\u524D","type":"\u7A2E\u985E","checkedinAt":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u6642\u523B","host":"\u62C5\u5F53\u8005"},"type":{"Package":"\u8377\u7269\u914D\u9054","Food":"\u98DF\u54C1\u914D\u9054","Visitor":"\u8A2A\u554F\u8005","MeetingAttendee":"\u62DB\u5F85\u5BA2","Employee":"\u5F93\u696D\u54E1","Guest":"\u8A2A\u554F\u8005"}},"confirmModal":{"title":"{{fullName}}\u3092\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u3057\u307E\u3059\u304B\uFF1F","cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","checkout":"\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8"}},"wifi":{"title":"Wi-Fi\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u306B\u63A5\u7D9A"},"door":{"external":{"title":"\u30C9\u30A2\u3092\u958B\u3044\u3066\u3044\u307E\u3059","subtitle":"\u307E\u3082\u306A\u304F\u30C9\u30A2\u304C\u958B\u304D\u307E\u3059\u3002\u304A\u5F85\u3061\u304F\u3060\u3055\u3044..."},"control":{"title":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059","subtitle":"\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\uFF01","openBtn":"\u30C9\u30A2\u3092\u958B\u3051\u308B"},"status":{"success":{"title":"\u30C9\u30A2\u304C\u958B\u304D\u307E\u3057\u305F","message":""},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F","message":"\u62C5\u5F53\u8005\u306B\u30C9\u30A2\u3092\u958B\u3051\u3066\u3082\u3089\u3046\u3088\u3046\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"loading":{"title":"\u30C9\u30A2\u304C\u958B\u304D\u307E\u3059...","message":""}}},"photo":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u624B\u7D9A\u304D\u306E\u4E00\u74B0\u3068\u3057\u3066\u5199\u771F\u3092\u64AE\u5F71\u3057\u307E\u3059\u304B\uFF1F","required":{"title":"\u5199\u771F\u78BA\u8A8D\u304C\u5FC5\u8981\u3067\u3059\uFF01","instructions":"\u30AB\u30E1\u30E9\u306E\u524D\u306B\u7ACB\u3063\u3066\u3001\u753B\u9762\u306E\u6307\u793A\u306B\u5F93\u3063\u3066\u304F\u3060\u3055\u3044\u3002","securityNotice":"\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3068\u78BA\u8A8D\u306E\u305F\u3081\u3001\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u6642\u306B\u5199\u771F\u304C\u5FC5\u8981\u3067\u3059\u3002","privacyInfo":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5C0A\u91CD\u3057\u307E\u3059\u3002\u30C7\u30FC\u30BF\u306F\u5B89\u5168\u306B\u4FDD\u5B58\u3055\u308C\u3001\u8EAB\u5143\u78BA\u8A8D\u306E\u305F\u3081\u306B\u306E\u307F\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002","closingMessage":"\u3054\u5354\u529B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002"},"optional":{"title":"\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u624B\u7D9A\u304D\u306E\u4E00\u74B0\u3068\u3057\u3066\u5199\u771F\u3092\u64AE\u5F71\u3057\u307E\u3059\u304B\uFF1F","instructions":"","securityNotice":"\u5199\u771F\u64AE\u5F71\u306B\u3088\u308A\u8EAB\u5143\u78BA\u8A8D\u3092\u7C21\u7D20\u5316\u3057\u3001\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u3092\u5411\u4E0A\u3055\u305B\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002","privacyInfo":"\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u5C0A\u91CD\u3057\u307E\u3059\u3002\u3053\u306E\u624B\u9806\u306F\u30AA\u30D7\u30B7\u30E7\u30F3\u3067\u3001\u30C7\u30FC\u30BF\u306F\u5B89\u5168\u306B\u51E6\u7406\u3055\u308C\u307E\u3059\u3002","closingMessage":"\u3053\u306E\u624B\u9806\u3092\u30B9\u30AD\u30C3\u30D7\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"},"subtitle":"\u30D5\u30EC\u30FC\u30E0\u5185\u306B\u7ACB\u3063\u3066\u3001\u6700\u826F\u306E\u7D50\u679C\u3092\u5F97\u308B\u305F\u3081\u9759\u6B62\u3057\u3066\u304F\u3060\u3055\u3044","button":{"cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","accept":"\u627F\u8A8D","skip":"\u30B9\u30AD\u30C3\u30D7","next":"\u6B21\u3078","recapture":"\u518D\u64AE\u5F71","continue":"\u7D9A\u884C"},"error":"\u5199\u771F\u64AE\u5F71\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3\u624B\u7D9A\u304D\u306F\u5199\u771F\u306A\u3057\u3067\u7D9A\u884C\u3055\u308C\u307E\u3059\u3002"},"wayfinding":{"title":"\u3069\u3061\u3089\u306B\u884C\u304D\u305F\u3044\u3067\u3059\u304B\uFF1F"},"callingMenu":{"title":"\u901A\u8A71\u30E1\u30CB\u30E5\u30FC"},"bell":{"status":{"success":{"title":"\u30D9\u30EB\u304C\u9CF4\u3063\u3066\u3044\u307E\u3059","message":"\u307E\u3082\u306A\u304F\u8AB0\u304B\u304C\u53C2\u308A\u307E\u3059"},"error":{"title":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","message":"\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044"},"loading":{"title":"\u63A5\u7D9A\u4E2D...","message":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044"}}},"access":{"control":{"title":"\u30C9\u30A2\u3092\u958B\u3051\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059","subtitle":"\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002","titleAuto":"\u81EA\u52D5\u30C9\u30A2\u30A2\u30AF\u30BB\u30B9","subtitleAuto":"\u30C9\u30A2\u304C\u81EA\u52D5\u7684\u306B\u958B\u304D\u307E\u3059","openBtn":"\u958B\u3051\u308B"},"status":{"success":{"title":"\u30C9\u30A2\u304C\u958B\u304D\u307E\u3057\u305F","message":""},"error":{"title":"\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F","message":"\u62C5\u5F53\u8005\u306B\u30C9\u30A2\u3092\u958B\u3051\u3066\u3082\u3089\u3046\u3088\u3046\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044\u3002"},"loading":{"title":"\u30C9\u30A2\u304C\u958B\u304D\u307E\u3059...","message":""}}}}');


var $97ec1a550c2c7b07$exports = {};
$97ec1a550c2c7b07$exports = JSON.parse('{"language":{"title":"Wybierz j\u0119zyk","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Witamy, jak mo\u017Cemy Ci pom\xf3c?","checkIn":"Zameldowanie","independentManualCheckIn":"Bez rezerwacji","integratedManualCheckIn":"Zamelduj si\u0119 r\u0119cznie","checkOut":"Wymeldowanie","manualCheckOut":"Wymelduj si\u0119 r\u0119cznie","parcelDelivery":"Dostawa przesy\u0142ek","foodDelivery":"Dostawa jedzenia","callReception":"Zadzwo\u0144 do recepcji","overview":"Przegl\u0105d","unavailable":"Recepcja jest obecnie niedost\u0119pna."},"check":{"option":{"checkin":{"title":"Wybierz opcj\u0119 zameldowania","manual":"Zamelduj si\u0119 r\u0119cznie","code":"Zamelduj si\u0119 kodem PIN lub kodem QR","code-no-qr":"Zamelduj si\u0119 kodem PIN"},"checkout":{"title":"Wybierz opcj\u0119 wymeldowania","manual":"Wymelduj si\u0119 podaj\u0105c imi\u0119","code":"Wymelduj si\u0119 kodem PIN lub kodem QR","code-no-qr":"Wymelduj si\u0119 kodem PIN"}},"title":"Mo\u017Cesz teraz zeskanowa\u0107 kod QR lub wpisa\u0107 kod PIN.","orText":"Lub","qrScanner":{"checkin":{"title":"Wybierz opcj\u0119 zameldowania"},"checkout":{"title":"Wybierz opcj\u0119 wymeldowania"},"btn":"Zeskanuj kod QR"},"hidScanner":{"title":"Przy\u0142\xf3\u017C kod QR do skanera poni\u017Cej lub wprowad\u017A sw\xf3j kod PIN"},"pinOnly":{"title":"Wprowad\u017A sw\xf3j kod PIN"},"pinCode":"Wpisz kod PIN","manually":{"checkin":"Nie masz kodu do zameldowania?"},"status":{"idle":{"title":"Kod jest skanowany.","message":"Prosz\u0119 czeka\u0107...","nfc":{"title":"Tw\xf3j tag jest skanowany.","message":"Prosz\u0119 czeka\u0107..."}},"loading":{"title":"Kod jest skanowany.","message":"Prosz\u0119 czeka\u0107...","nfc":{"title":"Tw\xf3j tag jest skanowany.","message":"Prosz\u0119 czeka\u0107..."}},"error":{"title":"Tw\xf3j kod jest nieprawid\u0142owy.","message":"Spr\xf3buj ponownie!","nfc":{"title":"Tw\xf3j tag jest nieprawid\u0142owy.","message":"Spr\xf3buj ponownie!"},"meeting":{"tooEarly":{"title":"Troch\u0119 za wcze\u015Bnie","message":"Tw\xf3j kod jest wa\u017Cny od {{validFromTime}}. Spotkanie zaczyna si\u0119 o {{meetingStartTime}}."},"tooLate":{"title":"Ten kod wygas\u0142","message":"Spotkanie zako\u0144czy\u0142o si\u0119 o {{meetingEndTime}}. Tw\xf3j kod by\u0142 wa\u017Cny do {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Dzi\u0119kujemy."},"MeetingAttendee":{"no-email-sms":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Dzi\u0119kujemy."},"email-sms":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Twoja osoba kontaktowa zosta\u0142a powiadomiona."},"call-ping":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Teraz po\u0142\u0105czymy Ci\u0119 telefonicznie z osob\u0105 kontaktow\u0105."},"teams-call":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Teraz nawi\u0105\u017Cemy po\u0142\u0105czenie Microsoft Teams z osob\u0105 kontaktow\u0105."},"badge":{"title":"Dzi\u0119kujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.","message":""},"video-call":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Trwa konfigurowanie po\u0142\u0105czenia wideo z osob\u0105 kontaktow\u0105."}},"Employee":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Dzi\u0119kujemy.","badge":{"title":"Dzi\u0119kujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.","message":""}},"Visitor":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Dzi\u0119kujemy.","badge":{"title":"Dzi\u0119kujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.","message":""}}},"checkout":{"default":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.<br/>","message":"Do zobaczenia wkr\xf3tce."},"MeetingAttendee":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Do zobaczenia wkr\xf3tce."},"Employee":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Do zobaczenia wkr\xf3tce."},"Visitor":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Do zobaczenia wkr\xf3tce."},"access":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Mo\u017Cesz teraz otworzy\u0107 drzwi."}}}}},"missingFields":{"title":"Jeszcze kilka informacji przed zameldowaniem","subtitle":"Pola oznaczone * s\u0105 wymagane","btn":"Zamelduj si\u0119","placeholder":{"other":"Inne...","otherInput":"Wpisz swoj\u0105 opcj\u0119"},"error":{"required":"Nie wype\u0142niono tego pola","email":"Nieprawid\u0142owy adres e-mail","phone":"Nieprawid\u0142owy numer telefonu"}},"manualCheckin":{"title":{"default":"Prosz\u0119 wype\u0142ni\u0107.","documentScanner":"Zwr\xf3\u0107 uwag\u0119 podczas wk\u0142adania dokumentu to\u017Csamo\u015Bci:"},"subtitle":{"default":"Uwaga - ka\u017Cde pole * jest wymagane","documentScanner":[{"parts":[{"text":"Strona z ","bold":false},{"text":"znakami <<< >>> (MRZ) ","bold":true},{"text":"musi by\u0107 ","bold":false},{"text":"skierowana w stron\u0119 kiosku / skanera.","bold":true}]},{"parts":[{"text":"Trzymaj kart\u0119 nieruchomo ","bold":false},{"text":"a\u017C pola zostan\u0105 wype\u0142nione automatycznie.","bold":true}]}]},"noOption":"Brak opcji","btn":"Zamelduj si\u0119","placeholder":{"name":"Twoje imi\u0119 i nazwisko *","email":"Tw\xf3j e-mail *","phone":"Numer telefonu","contactName":"Twoja osoba kontaktowa*","other":"Inne..."},"error":{"required":"Nie wype\u0142ni\u0142e\u015B tego pola","name":"Nieprawid\u0142owe imi\u0119","email":"Nieprawid\u0142owy adres e-mail","phone":"Nieprawid\u0142owy numer telefonu"},"status":{"idle":{"no-contact":{"title":"Prosz\u0119 czeka\u0107...","message":"Twoja rejestracja jest przetwarzana."},"contact":{"title":"Prosz\u0119 czeka\u0107...","message":"Twoja osoba kontaktowa jest powiadamiana."}},"loading":{"no-contact":{"title":"Prosz\u0119 czeka\u0107...","message":"Twoja rejestracja jest przetwarzana."},"contact":{"title":"Prosz\u0119 czeka\u0107...","message":"Twoja osoba kontaktowa jest powiadamiana."}},"success":{"no-email-sms":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Dzi\u0119kujemy."},"email-sms":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Twoja osoba kontaktowa zosta\u0142a powiadomiona."},"call-ping":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Teraz nawi\u0105\u017Cemy po\u0142\u0105czenie telefoniczne z osob\u0105 kontaktow\u0105."},"teams-call":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Teraz nawi\u0105\u017Cemy po\u0142\u0105czenie Microsoft Teams z osob\u0105 kontaktow\u0105"},"badge":{"title":"Dzi\u0119kujemy za zameldowanie, Twoja identyfikacja zostanie wydrukowana.","message":""},"video-call":{"title":"Pomy\u015Blnie si\u0119 zameldowa\u0142e\u015B.","message":"Trwa konfigurowanie po\u0142\u0105czenia wideo z osob\u0105 kontaktow\u0105."}},"error":{"title":"Co\u015B posz\u0142o nie tak.","message":"Spr\xf3buj ponownie!"}},"documentScan":{"invalid":{"title":"Dokument niewa\u017Cny","message":"Dokument nie m\xf3g\u0142 zosta\u0107 zweryfikowany lub straci\u0142 wa\u017Cno\u015B\u0107. Prosz\u0119 wprowadzi\u0107 dane r\u0119cznie."}}},"manualCheckout":{"title":"Wpisz swoje imi\u0119, aby si\u0119 wymeldowa\u0107","btn":"Wymelduj si\u0119","form":{"placeholder":{"name":"Twoje imi\u0119 i nazwisko *"},"loading":"\u0141adowanie...","noOptions":"Brak opcji"},"error":{"required":"Nie wype\u0142ni\u0142e\u015B tego pola","name":"Nieprawid\u0142owe imi\u0119"},"status":{"idle":{"title":"Przetwarzamy Twoje informacje.","message":"Prosz\u0119 czeka\u0107..."},"loading":{"title":"Przetwarzamy Twoje informacje.","message":"Prosz\u0119 czeka\u0107..."},"success":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Dzi\u0119kujemy i mi\u0142ego dnia."},"successAccess":{"title":"Pomy\u015Blnie si\u0119 wymeldowa\u0142e\u015B.","message":"Teraz mo\u017Cesz otworzy\u0107 drzwi."},"error":{"title":"Wyst\u0105pi\u0142 b\u0142\u0105d podczas wymeldowania.","message":"Spr\xf3buj ponownie!"}}},"call":{"title":{"no-email-sms":"Czy chcesz powiadomi\u0107 swoj\u0105 osob\u0119 kontaktow\u0105?","email-sms":"Wys\u0142ali\u015Bmy e-mail/SMS do Twojej osoby kontaktowej.<br/>Czy chcesz dodatkowo nawi\u0105za\u0107 z ni\u0105 po\u0142\u0105czenie?"},"callBtn":"Zadzwo\u0144","pingBtn":"Ping","smsBtn":"SMS","callVideoBtn":"Rozmowa wideo","teamsCallBtn":"Rozmowa Teams","teamsMessageBtn":"Wiadomo\u015B\u0107 Teams","googleChatMessageBtn":"Google Chat","noBtn":"Anuluj","cancelBtn":"Anuluj po\u0142\u0105czenie","status":{"connecting":{"title":"Nawi\u0105zywanie po\u0142\u0105czenia.<br/>Prosz\u0119 czeka\u0107...","message":""},"ringing":{"title":"Dzwonimy do Twojej osoby kontaktowej<br/>Prosz\u0119 czeka\u0107...","message":""},"ringingReception":{"title":"Rozpocz\u0119to po\u0142\u0105czenie...","message":""},"open":{"title":"Po\u0142\u0105czenie w toku.","message":""},"close":{"title":"Po\u0142\u0105czenie zako\u0144czone.<br/>","message":""},"closeAccess":{"title":"Po\u0142\u0105czenie zako\u0144czone.<br/>Teraz mo\u017Cesz otworzy\u0107 drzwi.","message":""},"closeReception":{"title":"Po\u0142\u0105czenie zosta\u0142o zako\u0144czone.","message":""},"error":{"title":"Po\u0142\u0105czenie nie zosta\u0142o nawi\u0105zane.<br/>Spr\xf3bowa\u0107 ponownie?","message":""}}},"message":{"status":{"idle":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"loading":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"success":{"title":"SMS zosta\u0142 wys\u0142any. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Dzi\u0119kujemy!"},"successAccess":{"title":"SMS zosta\u0142 wys\u0142any. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Teraz mo\u017Cesz otworzy\u0107 drzwi."},"error":{"title":"SMS nie zosta\u0142 wys\u0142any.","message":"Spr\xf3buj ponownie!"}}},"videoCall":{"title":"Rozmowa wideo","endCall":"Zako\u0144cz rozmow\u0119","status":{"idle":{"title":"Tworzymy pok\xf3j wideo.","message":"Prosz\u0119 czeka\u0107..."},"loading":{"title":"Tworzymy pok\xf3j wideo.","message":"Prosz\u0119 czeka\u0107..."},"success":{"title":"Pok\xf3j wideo zosta\u0142 pomy\u015Blnie utworzony.","message":"Do\u0142\u0105czanie do pokoju..."},"error":{"title":"Pok\xf3j wideo nie zosta\u0142 pomy\u015Blnie utworzony.","message":"Spr\xf3buj ponownie!"}}},"teamsCall":{"title":"Rozmowa Teams","controls":{"startCall":"Rozpocznij rozmow\u0119","endCall":"Opu\u015B\u0107","camera":"Kamera","cameraOff":"Kamera wy\u0142\u0105czona","mic":"Mikrofon","micOff":"Mikrofon wy\u0142\u0105czony","ringing":"Dzwonienie...","noAnswer":"Nikt nie odpowiedzia\u0142 na po\u0142\u0105czenie."},"status":{"connecting":{"title":"Nawi\u0105zywanie po\u0142\u0105czenia.<br/>Prosz\u0119 czeka\u0107...","message":""},"ringing":{"title":"Dzwonimy do Twojej osoby kontaktowej<br/>Prosz\u0119 czeka\u0107...","message":""},"connected":{"title":"Nawi\u0105zywanie po\u0142\u0105czenia","message":""},"disconnected":{"title":"Po\u0142\u0105czenie zako\u0144czone.<br/>","message":""},"disconnectedAccess":{"title":"Po\u0142\u0105czenie zako\u0144czone.<br/>Teraz mo\u017Cesz otworzy\u0107 drzwi.","message":""},"error":{"title":"Po\u0142\u0105czenie nie zosta\u0142o nawi\u0105zane.<br/>Spr\xf3buj ponownie","message":""},"noAnswer":{"title":"Nikt nie odpowiedzia\u0142 na po\u0142\u0105czenie.<br/>Spr\xf3buj ponownie.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"loading":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"success":{"title":"Wiadomo\u015B\u0107 zosta\u0142a wys\u0142ana. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Dzi\u0119kujemy!"},"successAccess":{"title":"Wiadomo\u015B\u0107 zosta\u0142a wys\u0142ana. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Teraz mo\u017Cesz otworzy\u0107 drzwi."},"error":{"title":"Wiadomo\u015B\u0107 nie zosta\u0142a wys\u0142ana.","message":"Spr\xf3buj ponownie!"}}},"googleChatMessage":{"status":{"idle":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"loading":{"title":"Powiadamiamy Twoj\u0105 osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"success":{"title":"Wiadomo\u015B\u0107 zosta\u0142a wys\u0142ana. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Dzi\u0119kujemy!"},"successAccess":{"title":"Wiadomo\u015B\u0107 zosta\u0142a wys\u0142ana. Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Teraz mo\u017Cesz otworzy\u0107 drzwi."},"error":{"title":"Wiadomo\u015B\u0107 nie zosta\u0142a wys\u0142ana.","message":"Spr\xf3buj ponownie!"}}},"packageDelivery":{"title":"Jak mi\u0142o z Twojej strony, \u017Ce dostarczasz przesy\u0142k\u0119!","subtitle":"Wybierz i powiadom odbiorc\u0119","subtitle1":"Naci\u015Bnij przycisk poni\u017Cej, aby da\u0107 nam zna\u0107, \u017Ce jeste\u015B tutaj!","subtitle2":"","input":{"label":{"contact":"Dla kogo jest przesy\u0142ka"},"error":{"contact":{"required":"Nie wype\u0142ni\u0142e\u015B tego pola"}}},"button":{"submit":"Powiadom"},"status":{"loading":{"title":"Powiadamiamy osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107..."},"success":{"no-email-sms":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":""},"email-sms":{"title":"Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Dzi\u0119kujemy za dostaw\u0119!"},"call-ping":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Teraz zostanie nawi\u0105zane po\u0142\u0105czenie telefoniczne z osob\u0105 kontaktow\u0105."},"teams-call":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Teraz zostanie nawi\u0105zane po\u0142\u0105czenie Microsoft Teams z osob\u0105 kontaktow\u0105."},"video-call":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Trwa konfigurowanie po\u0142\u0105czenia wideo z osob\u0105 kontaktow\u0105."}},"error":{"title":"Co\u015B posz\u0142o nie tak.","message":"Spr\xf3buj ponownie!"}}},"foodDelivery":{"title":"Jak mi\u0142o z Twojej strony, \u017Ce dostarczasz jedzenie!","subtitle":"Wybierz i powiadom odbiorc\u0119","subtitle1":"Naci\u015Bnij przycisk poni\u017Cej, aby da\u0107 nam zna\u0107, \u017Ce jeste\u015B tutaj!","subtitle2":"","input":{"label":{"contact":"Dla kogo jest jedzenie"},"error":{"contact":{"required":"Nie wype\u0142ni\u0142e\u015B tego pola"}}},"button":{"submit":"Powiadom"},"status":{"loading":{"title":"Powiadamiamy osob\u0119 kontaktow\u0105.","message":"Prosz\u0119 czeka\u0107!"},"success":{"no-email-sms":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":""},"email-sms":{"title":"Osoba kontaktowa zosta\u0142a powiadomiona.","message":"Dzi\u0119kujemy za dostaw\u0119!"},"call-ping":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Teraz zostanie nawi\u0105zane po\u0142\u0105czenie telefoniczne z osob\u0105 kontaktow\u0105."},"teams-call":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Teraz zostanie nawi\u0105zane po\u0142\u0105czenie Microsoft Teams z osob\u0105 kontaktow\u0105."},"video-call":{"title":"Dzi\u0119kujemy za dostaw\u0119!","message":"Trwa konfigurowanie po\u0142\u0105czenia wideo z osob\u0105 kontaktow\u0105."}},"error":{"title":"Co\u015B posz\u0142o nie tak.","message":"Spr\xf3buj ponownie!"}}},"QRCodeScanner":{"title":"Prosz\u0119 zeskanowa\u0107 kod QR","subtitle":"Ustaw kod QR wewn\u0105trz czerwonych rog\xf3w i trzymaj telefon stabilnie.","error":"Nieprawid\u0142owy format kodu QR","unknownError":"Wyst\u0105pi\u0142 nieznany b\u0142\u0105d podczas skanowania"},"common":{"backBtn":"Wstecz"},"previewPDF":{"page":{"of":"z","previous":"Poprzednia","next":"Nast\u0119pna"},"button":{"cancel":"Anuluj","accept":"Akceptuj","next":"Nast\u0119pny"},"title":{"consent":"Wymagana zgoda"}},"offline":{"title":"Offline","receptionMessage":"Recepcja cyfrowa jest obecnie offline i nie mo\u017Ce by\u0107 u\u017Cywana, nale\u017Cy sprawdzi\u0107 po\u0142\u0105czenie internetowe!","check":"Jeste\u015B go\u015Bciem i chcesz porozmawia\u0107 bezpo\u015Brednio z pracownikiem? Zadzwo\u0144 pod numer {{receptionistPhone}}"},"overview":{"title":"Wprowad\u017A kod, aby otworzy\u0107 przegl\u0105d!","noUsers":"Brak rejestracji","status":{"success":{"title":"Kod jest prawid\u0142owy.","message":""},"error":{"title":"Kod nieprawid\u0142owy.","message":"Spr\xf3buj ponownie!"}},"checkoutStatus":{"loading":{"title":"Prosz\u0119 czeka\u0107...","message":""},"success":{"title":"Pomy\u015Blne wymeldowanie.","message":""},"error":{"title":"Co\u015B posz\u0142o nie tak.","message":"Spr\xf3buj ponownie!"}},"listTitle":"Lista os\xf3b, kt\xf3re zameldowa\u0142y si\u0119 dzisiaj, ale si\u0119 nie wymeldowa\u0142y","page":"Strona ","table":{"head":{"fullName":"Imi\u0119 i nazwisko","type":"Typ","checkedinAt":"Zameldowany o","host":"Gospodarz"},"type":{"Package":"Dostawa przesy\u0142ek","Food":"Dostawa jedzenia","Visitor":"Go\u015B\u0107","MeetingAttendee":"Zaproszony go\u015B\u0107","Employee":"Pracownik","Guest":"Go\u015B\u0107"}},"confirmModal":{"title":"Czy na pewno chcesz wymeldowa\u0107 {{fullName}}?","cancel":"Anuluj","checkout":"Wymelduj"}},"wifi":{"title":"Po\u0142\u0105cz z sieci\u0105 Wi-Fi"},"door":{"external":{"title":"Otwieranie drzwi","subtitle":"Drzwi otworz\u0105 si\u0119 wkr\xf3tce. Prosz\u0119 czeka\u0107..."},"control":{"title":"Mo\u017Cesz teraz otworzy\u0107 drzwi","subtitle":"Prosz\u0119 nacisn\u0105\u0107 przycisk poni\u017Cej!","openBtn":"Otw\xf3rz drzwi"},"status":{"success":{"title":"Drzwi zosta\u0142y otwarte","message":""},"error":{"title":"Co\u015B posz\u0142o nie tak","message":"Skontaktuj si\u0119 z osob\u0105 kontaktow\u0105, aby otworzy\u0107 drzwi."},"loading":{"title":"Otwieranie drzwi...","message":""}}},"photo":{"title":"Czy chcia\u0142by\u015B zrobi\u0107 zdj\u0119cie w ramach procesu zameldowania?","required":{"title":"Wymagana weryfikacja zdj\u0119ciowa!","instructions":"Prosz\u0119 stan\u0105\u0107 przed kamer\u0105 i post\u0119powa\u0107 zgodnie z instrukcjami na ekranie.","securityNotice":"Ze wzgl\u0119d\xf3w bezpiecze\u0144stwa i weryfikacji, zdj\u0119cie jest wymagane podczas zameldowania.","privacyInfo":"Szanujemy Twoj\u0105 prywatno\u015B\u0107. Twoje dane s\u0105 bezpiecznie przechowywane i u\u017Cywane tylko do identyfikacji.","closingMessage":"Dzi\u0119kujemy za wsp\xf3\u0142prac\u0119."},"optional":{"title":"Czy chcia\u0142by\u015B zrobi\u0107 zdj\u0119cie w ramach procesu zameldowania?","instructions":"","securityNotice":"Zrobienie zdj\u0119cia mo\u017Ce pom\xf3c usprawni\u0107 identyfikacj\u0119 i zwi\u0119kszy\u0107 bezpiecze\u0144stwo.","privacyInfo":"Szanujemy Twoj\u0105 prywatno\u015B\u0107. Ten krok jest opcjonalny, a Twoje dane b\u0119d\u0105 bezpiecznie obs\u0142ugiwane.","closingMessage":"Mo\u017Cesz pomin\u0105\u0107 ten krok, je\u015Bli wolisz."},"subtitle":"Prosz\u0119 umie\u015Bci\u0107 si\u0119 w kadrze i pozosta\u0107 nieruchomo dla najlepszego rezultatu","button":{"cancel":"Anuluj","accept":"Akceptuj","skip":"Pomi\u0144","next":"Nast\u0119pny","recapture":"Zr\xf3b zdj\u0119cie ponownie","continue":"Kontynuuj"},"error":"Wyst\u0105pi\u0142 b\u0142\u0105d podczas robienia zdj\u0119cia. Proces zameldowania b\u0119dzie kontynuowany bez zdj\u0119cia."},"wayfinding":{"title":"Dok\u0105d chcia\u0142by\u015B si\u0119 uda\u0107?"},"callingMenu":{"title":"Menu dzwonienia"},"bell":{"status":{"success":{"title":"Dzwonek dzwoni","message":"Kto\u015B zaraz przyjdzie."},"error":{"title":"Co\u015B posz\u0142o nie tak","message":"Spr\xf3buj ponownie"},"loading":{"title":"\u0141\u0105czenie...","message":"Prosz\u0119 czeka\u0107"}}},"access":{"control":{"title":"Mo\u017Cesz teraz otworzy\u0107 drzwi","subtitle":"Prosz\u0119 nacisn\u0105\u0107 przycisk poni\u017Cej.","titleAuto":"Automatyczny dost\u0119p do drzwi","subtitleAuto":"Drzwi otworz\u0105 si\u0119 dla Ciebie automatycznie","openBtn":"Otw\xf3rz"},"status":{"success":{"title":"Drzwi zosta\u0142y otwarte","message":""},"error":{"title":"Co\u015B posz\u0142o nie tak","message":"Skontaktuj si\u0119 z osob\u0105 kontaktow\u0105, aby otworzy\u0107 drzwi."},"loading":{"title":"Otwieranie drzwi...","message":""}}}}');


var $3197beedd8eb5bc7$exports = {};
$3197beedd8eb5bc7$exports = JSON.parse('{"language":{"title":"Scegli la tua lingua","en":"English","en_US":"English","nl":"Nederlands","sr":"Srpski","fr":"Fran\xe7ais","de":"Deutsch","pt":"Portugu\xeas","es":"Espa\xf1ol","ja":"\u65E5\u672C\u8A9E","pl":"Polski","it":"Italiano"},"home":{"welcomeMessage":"Ciao, come possiamo aiutarti?","checkIn":"Registrazione","independentManualCheckIn":"Nessun appuntamento","integratedManualCheckIn":"Registrazione manuale","checkOut":"Check-out","manualCheckOut":"Check-out manuale","parcelDelivery":"Consegna pacchi","foodDelivery":"Consegna cibo","callReception":"Chiama reception","overview":"Panoramica","unavailable":"La reception \xe8 al momento non disponibile."},"check":{"option":{"checkin":{"title":"Scegli un\'opzione per registrarti","manual":"Registrazione manuale","code":"Registrazione con PIN o codice QR","code-no-qr":"Registrazione con codice PIN"},"checkout":{"title":"Scegli un\'opzione per il check-out","manual":"Check-out con nome","code":"Check-out con PIN o codice QR","code-no-qr":"Check-out con codice PIN"}},"title":"Ora puoi scansionare il tuo codice QR o inserire il tuo codice PIN.","orText":"Oppure","qrScanner":{"checkin":{"title":"Scegli un\'opzione per registrarti"},"checkout":{"title":"Scegli un\'opzione per il check-out"},"btn":"Scansiona il tuo codice QR"},"hidScanner":{"title":"Avvicina il codice QR allo scanner qui sotto o inserisci il tuo codice PIN"},"pinOnly":{"title":"Inserisci il tuo codice PIN"},"pinCode":"Inserisci il tuo codice PIN","manually":{"checkin":"Non hai un codice di registrazione?"},"status":{"idle":{"title":"Il tuo codice \xe8 in fase di scansione.","message":"Attendere prego...","nfc":{"title":"Il tuo tag \xe8 in fase di scansione.","message":"Attendere prego..."}},"loading":{"title":"Il tuo codice \xe8 in fase di scansione.","message":"Attendere prego...","nfc":{"title":"Il tuo tag \xe8 in fase di scansione.","message":"Attendere prego..."}},"error":{"title":"Il tuo codice non \xe8 valido.","message":"Riprova!","nfc":{"title":"Il tuo tag non \xe8 valido.","message":"Per favore riprova!"},"meeting":{"tooEarly":{"title":"Sei un po\' in anticipo","message":"Il tuo codice \xe8 valido dalle {{validFromTime}}. La riunione inizia alle {{meetingStartTime}}."},"tooLate":{"title":"Questo codice \xe8 scaduto","message":"La riunione \xe8 terminata alle {{meetingEndTime}}. Il tuo codice era valido fino alle {{validUntilTime}}."}}},"success":{"checkin":{"default":{"title":"Ti sei registrato con successo.","message":"Grazie."},"MeetingAttendee":{"no-email-sms":{"title":"Ti sei registrato con successo.","message":"Grazie."},"email-sms":{"title":"Ti sei registrato con successo.","message":"La tua persona di contatto \xe8 stata notificata."},"call-ping":{"title":"Ti sei registrato con successo.","message":"Ora stabiliremo una chiamata telefonica con la tua persona di contatto."},"teams-call":{"title":"Ti sei registrato con successo.","message":"Ora stabiliremo una chiamata Microsoft Teams con la tua persona di contatto."},"badge":{"title":"Grazie per la registrazione, il tuo badge verr\xe0 stampato.","message":""},"video-call":{"title":"Ti sei registrato con successo.","message":"Configurazione della videochiamata con la persona di contatto."}},"Employee":{"title":"Ti sei registrato con successo.","message":"Grazie.","badge":{"title":"Grazie per la registrazione, il tuo badge verr\xe0 stampato.","message":""}},"Visitor":{"title":"Ti sei registrato con successo.","message":"Grazie.","badge":{"title":"Grazie per la registrazione, il tuo badge verr\xe0 stampato.","message":""}}},"checkout":{"default":{"title":"Hai effettuato il check-out con successo.<br/>","message":"A presto."},"MeetingAttendee":{"title":"Hai effettuato il check-out con successo.","message":"A presto."},"Employee":{"title":"Hai effettuato il check-out con successo.","message":"A presto."},"Visitor":{"title":"Hai effettuato il check-out con successo.","message":"A presto."},"access":{"title":"Hai effettuato il check-out con successo.","message":"Ora puoi aprire la porta."}}}}},"missingFields":{"title":"Ancora qualche dettaglio prima del check-in","subtitle":"I campi contrassegnati con * sono obbligatori","btn":"Registrati","placeholder":{"other":"Altro...","otherInput":"Inserisci la tua opzione"},"error":{"required":"Non hai compilato questo campo","email":"Indirizzo e-mail non valido","phone":"Numero di telefono non valido"}},"manualCheckin":{"title":{"default":"Compila i campi.","documentScanner":"Presta attenzione quando inserisci la tua carta d\'identit\xe0:"},"subtitle":{"default":"Nota - ogni campo * \xe8 obbligatorio","documentScanner":[{"parts":[{"text":"Il ","bold":false},{"text":"lato con i caratteri <<< >>> (MRZ) ","bold":true},{"text":"deve essere ","bold":false},{"text":"rivolto verso il chiosco / scanner.","bold":true}]},{"parts":[{"text":"Tenere ferma la carta ","bold":false},{"text":"fino a quando i campi vengono compilati automaticamente.","bold":true}]}]},"noOption":"Nessuna opzione","btn":"Registrati","placeholder":{"name":"Il tuo nome *","email":"La tua e-mail *","phone":"Numero di cellulare","contactName":"La tua persona di contatto*","other":"Altro..."},"error":{"required":"Non hai compilato questo campo","name":"Nome non valido","email":"Indirizzo email non valido","phone":"Numero di cellulare non valido"},"status":{"idle":{"no-contact":{"title":"Attendere prego...","message":"La tua registrazione \xe8 in elaborazione."},"contact":{"title":"Attendere prego...","message":"Il tuo contatto sta per essere notificato."}},"loading":{"no-contact":{"title":"Attendere prego...","message":"La tua registrazione \xe8 in elaborazione."},"contact":{"title":"Attendere prego...","message":"Il tuo contatto sta per essere notificato."}},"success":{"no-email-sms":{"title":"Ti sei registrato con successo.","message":"Grazie."},"email-sms":{"title":"Ti sei registrato con successo.","message":"La tua persona di contatto \xe8 stata notificata."},"call-ping":{"title":"Ti sei registrato con successo.","message":"Ora stabiliremo una chiamata telefonica con la tua persona di contatto."},"teams-call":{"title":"Ti sei registrato con successo.","message":"Ora stabiliremo una chiamata Microsoft Teams con la tua persona di contatto"},"badge":{"title":"Grazie per la registrazione, il tuo badge verr\xe0 stampato.","message":""},"video-call":{"title":"Ti sei registrato con successo.","message":"Configurazione della videochiamata con la persona di contatto."}},"error":{"title":"Qualcosa \xe8 andato storto.","message":"Riprova!"}},"documentScan":{"invalid":{"title":"Documento non valido","message":"Il documento non \xe8 stato possibile verificare oppure \xe8 scaduto. Inserisci i tuoi dati manualmente."}}},"manualCheckout":{"title":"Inserisci il tuo nome per effettuare il check-out","btn":"Check-out","form":{"placeholder":{"name":"Il tuo nome completo *"},"loading":"Caricamento...","noOptions":"Nessuna opzione"},"error":{"required":"Non hai compilato questo campo","name":"Nome non valido"},"status":{"idle":{"title":"Stiamo elaborando le tue informazioni.","message":"Attendere prego..."},"loading":{"title":"Stiamo elaborando le tue informazioni.","message":"Attendere prego..."},"success":{"title":"Hai effettuato il check-out con successo.","message":"Grazie e buona giornata."},"successAccess":{"title":"Hai effettuato il check-out con successo.","message":"Ora puoi aprire la porta."},"error":{"title":"Si \xe8 verificato un errore durante il check-out.","message":"Riprova!"}}},"call":{"title":{"no-email-sms":"Vuoi notificare il tuo contatto?","email-sms":"Abbiamo inviato un\'email/SMS al tuo contatto.<br/>Vuoi stabilire anche una chiamata con loro?"},"callBtn":"Chiama","pingBtn":"Segnale","smsBtn":"SMS","callVideoBtn":"Videochiamata","teamsCallBtn":"Chiamata Teams","teamsMessageBtn":"Messaggio Teams","googleChatMessageBtn":"Google Chat","noBtn":"Annulla","cancelBtn":"Annulla chiamata","status":{"connecting":{"title":"Stabilimento chiamata.<br/>Attendere prego...","message":""},"ringing":{"title":"Chiamata in corso alla tua persona di contatto<br/>Attendere prego...","message":""},"ringingReception":{"title":"Chiamata avviata...","message":""},"open":{"title":"Chiamata in corso.","message":""},"close":{"title":"Chiamata terminata.<br/>","message":""},"closeAccess":{"title":"Chiamata terminata.<br/>Ora puoi aprire la porta.","message":""},"closeReception":{"title":"La chiamata \xe8 terminata.","message":""},"error":{"title":"Chiamata non stabilita.<br/>Chiamare di nuovo?","message":""}}},"message":{"status":{"idle":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"loading":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"success":{"title":"L\'SMS \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Grazie!"},"successAccess":{"title":"L\'SMS \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Ora puoi aprire la porta."},"error":{"title":"SMS non inviato.","message":"Riprova!"}}},"videoCall":{"title":"Videochiamata","endCall":"Termina chiamata","status":{"idle":{"title":"Stiamo creando una stanza video.","message":"Attendere prego..."},"loading":{"title":"Stiamo creando una stanza video.","message":"Attendere prego..."},"success":{"title":"La stanza video \xe8 stata creata con successo.","message":"Accesso alla stanza..."},"error":{"title":"La stanza video non \xe8 stata creata con successo.","message":"Riprova!"}}},"teamsCall":{"title":"Chiamata Teams","controls":{"startCall":"Avvia chiamata","endCall":"Abbandona","camera":"Fotocamera","cameraOff":"Fotocamera spenta","mic":"Microfono","micOff":"Microfono spento","ringing":"Suoneria...","noAnswer":"Nessuno ha risposto alla chiamata."},"status":{"connecting":{"title":"Stabilimento chiamata.<br/>Attendere prego...","message":""},"ringing":{"title":"Chiamata in corso alla tua persona di contatto<br/>Attendere prego...","message":""},"connected":{"title":"Stabilimento chiamata","message":""},"disconnected":{"title":"Chiamata terminata.<br/>","message":""},"disconnectedAccess":{"title":"Chiamata terminata.<br/>Ora puoi aprire la porta.","message":""},"error":{"title":"Chiamata non stabilita.<br/>Riprova","message":""},"noAnswer":{"title":"Nessuno ha risposto alla chiamata.<br/>Riprova.","message":""}}},"teamsMessage":{"status":{"idle":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"loading":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"success":{"title":"Il messaggio \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Grazie!"},"successAccess":{"title":"Il messaggio \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Ora puoi aprire la porta."},"error":{"title":"Messaggio non inviato.","message":"Riprova!"}}},"googleChatMessage":{"status":{"idle":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"loading":{"title":"Stiamo notificando la tua persona di contatto.","message":"Attendere prego..."},"success":{"title":"Il messaggio \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Grazie!"},"successAccess":{"title":"Il messaggio \xe8 stato inviato. Il contatto \xe8 stato notificato.","message":"Ora puoi aprire la porta."},"error":{"title":"Messaggio non inviato.","message":"Riprova!"}}},"packageDelivery":{"title":"Che gentile consegnare un pacco!","subtitle":"Seleziona e notifica il destinatario","subtitle1":"Premi il pulsante qui sotto per farci sapere che sei qui!","subtitle2":"","input":{"label":{"contact":"Per chi \xe8 il pacco"},"error":{"contact":{"required":"Non hai compilato questo campo"}}},"button":{"submit":"Notifica"},"status":{"loading":{"title":"Stiamo notificando la persona di contatto.","message":"Attendere prego..."},"success":{"no-email-sms":{"title":"Grazie per la tua consegna!","message":""},"email-sms":{"title":"La persona di contatto \xe8 stata notificata.","message":"Grazie per la tua consegna!"},"call-ping":{"title":"Grazie per la tua consegna!","message":"Ora verr\xe0 stabilita una connessione telefonica con la persona di contatto."},"teams-call":{"title":"Grazie per la tua consegna!","message":"Ora verr\xe0 effettuata una chiamata Microsoft Teams con la tua persona di contatto."},"video-call":{"title":"Grazie per la tua consegna!","message":"Configurazione della videochiamata con la persona di contatto."}},"error":{"title":"Qualcosa \xe8 andato storto.","message":"Riprova!"}}},"foodDelivery":{"title":"Che gentile consegnare del cibo!","subtitle":"Seleziona e notifica il destinatario","subtitle1":"Premi il pulsante qui sotto per farci sapere che sei qui!","subtitle2":"","input":{"label":{"contact":"Per chi \xe8 il cibo"},"error":{"contact":{"required":"Non hai compilato questo campo"}}},"button":{"submit":"Notifica"},"status":{"loading":{"title":"Stiamo notificando il contatto.","message":"Attendere prego!"},"success":{"no-email-sms":{"title":"Grazie per la tua consegna!","message":""},"email-sms":{"title":"Il contatto \xe8 stato notificato.","message":"Grazie per la tua consegna!"},"call-ping":{"title":"Grazie per la tua consegna!","message":"Ora verr\xe0 stabilita una connessione telefonica con la tua persona di contatto."},"teams-call":{"title":"Grazie per la tua consegna!","message":"Ora verr\xe0 effettuata una chiamata Microsoft Teams con la tua persona di contatto."},"video-call":{"title":"Grazie per la tua consegna!","message":"Configurazione della videochiamata con la persona di contatto."}},"error":{"title":"Qualcosa \xe8 andato storto.","message":"Riprova!"}}},"QRCodeScanner":{"title":"Scansiona il tuo codice QR","subtitle":"Allinea il codice QR all\'interno degli angoli rossi e tieni fermo il telefono.","error":"Formato codice QR non valido","unknownError":"Errore sconosciuto durante la scansione"},"common":{"backBtn":"Indietro"},"previewPDF":{"page":{"of":"di","previous":"Precedente","next":"Successivo"},"button":{"cancel":"Annulla","accept":"Accetta","next":"Successivo"},"title":{"consent":"Consenso richiesto"}},"offline":{"title":"Offline","receptionMessage":"La reception digitale \xe8 al momento offline e non pu\xf2 essere utilizzata, la connessione internet deve essere verificata!","check":"Sei un visitatore e vuoi parlare direttamente con un dipendente? Chiama {{receptionistPhone}}"},"overview":{"title":"Inserisci il codice per aprire la panoramica!","noUsers":"Nessuna registrazione","status":{"success":{"title":"Il codice \xe8 valido.","message":""},"error":{"title":"Il codice non \xe8 valido.","message":"Riprova!"}},"checkoutStatus":{"loading":{"title":"Attendere prego...","message":""},"success":{"title":"Check-out riuscito.","message":""},"error":{"title":"Qualcosa \xe8 andato storto.","message":"Riprova!"}},"listTitle":"Elenco delle persone che si sono registrate oggi ma non hanno effettuato il check-out","page":"Pagina ","table":{"head":{"fullName":"Nome","type":"Tipo","checkedinAt":"Registrato alle","host":"Host"},"type":{"Package":"Consegna pacchi","Food":"Consegna cibo","Visitor":"Visitatore","MeetingAttendee":"Visitatore invitato","Employee":"Dipendente","Guest":"Visitatore"}},"confirmModal":{"title":"Sei sicuro di voler effettuare il check-out di {{fullName}}?","cancel":"Annulla","checkout":"Check-out"}},"wifi":{"title":"Connettiti alla rete Wi-Fi"},"door":{"external":{"title":"Apertura della porta","subtitle":"La porta si aprir\xe0 a breve. Attendere prego..."},"control":{"title":"Ora puoi aprire la porta","subtitle":"Premi il pulsante qui sotto!","openBtn":"Apri la porta"},"status":{"success":{"title":"La porta \xe8 stata aperta","message":""},"error":{"title":"Qualcosa \xe8 andato storto","message":"Contatta la tua persona di contatto per aprire la porta."},"loading":{"title":"Apertura della porta...","message":""}}},"photo":{"title":"Vuoi scattare una foto come parte del processo di registrazione?","required":{"title":"Verifica Foto Richiesta!","instructions":"Posizionati davanti alla fotocamera e segui le istruzioni sullo schermo.","securityNotice":"Per motivi di sicurezza e verifica, \xe8 richiesta una foto durante la registrazione.","privacyInfo":"Rispettiamo la tua privacy. I tuoi dati sono archiviati in modo sicuro e utilizzati solo per l\'identificazione.","closingMessage":"Grazie per la collaborazione."},"optional":{"title":"Vuoi scattare una foto come parte del processo di registrazione?","instructions":"","securityNotice":"Scattare una foto pu\xf2 aiutare a semplificare l\'identificazione e migliorare la sicurezza.","privacyInfo":"Rispettiamo la tua privacy. Questo passaggio \xe8 opzionale e i tuoi dati verranno gestiti in modo sicuro.","closingMessage":"Puoi saltare questo passaggio se preferisci."},"subtitle":"Posizionati all\'interno della cornice e rimani fermo per ottenere il miglior risultato","button":{"cancel":"Annulla","accept":"Accetta","skip":"Salta","next":"Successivo","recapture":"Scatta di nuovo","continue":"Continua"},"error":"Si \xe8 verificato un errore durante lo scatto della foto. Il processo di registrazione continuer\xe0 senza la foto."},"wayfinding":{"title":"Dove vuoi andare?"},"callingMenu":{"title":"Menu chiamate"},"bell":{"status":{"success":{"title":"Il campanello sta suonando","message":"Qualcuno arriver\xe0 a breve."},"error":{"title":"Qualcosa \xe8 andato storto","message":"Riprova"},"loading":{"title":"Connessione...","message":"Attendere prego"}}},"access":{"control":{"title":"Ora puoi aprire la porta","subtitle":"Premi il pulsante qui sotto.","titleAuto":"Accesso automatico alla porta","subtitleAuto":"La porta si aprir\xe0 automaticamente per te","openBtn":"Apri"},"status":{"success":{"title":"La porta \xe8 stata aperta","message":""},"error":{"title":"Qualcosa \xe8 andato storto","message":"Contatta la tua persona di contatto per aprire la porta."},"loading":{"title":"Apertura della porta...","message":""}}}}');


const $4fecd7927763196f$var$resources = {
    en: (/*@__PURE__*/$parcel$interopDefault($86cde84932c5b025$exports)),
    en_US: (/*@__PURE__*/$parcel$interopDefault($66925b64b4b1e32a$exports)),
    nl: (/*@__PURE__*/$parcel$interopDefault($e426d47f6742296e$exports)),
    sr: (/*@__PURE__*/$parcel$interopDefault($a18874184f267ca0$exports)),
    fr: (/*@__PURE__*/$parcel$interopDefault($4ef112052723529f$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($002a7e1c39b40840$exports)),
    pt: (/*@__PURE__*/$parcel$interopDefault($b19f380faffe50d1$exports)),
    es: (/*@__PURE__*/$parcel$interopDefault($ae510afae8998352$exports)),
    ja: (/*@__PURE__*/$parcel$interopDefault($773785e71cd37a48$exports)),
    pl: (/*@__PURE__*/$parcel$interopDefault($97ec1a550c2c7b07$exports)),
    it: (/*@__PURE__*/$parcel$interopDefault($3197beedd8eb5bc7$exports))
};
(0, $aZjGj.default).use((0, $9yd0C.initReactI18next)).init({
    resources: $4fecd7927763196f$var$resources,
    debug: false,
    lng: "en",
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
        escapeValue: false
    }
});



var $cwDEq = parcelRequire("cwDEq");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");
parcelRequire("eZVvM");


var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $eZVvM = parcelRequire("eZVvM");
const $4b8298b1f6c5cce2$var$ThemeContext = /*#__PURE__*/ $eZVvM.createContext(null);
var $4b8298b1f6c5cce2$export$2e2bcd8739ae039 = $4b8298b1f6c5cce2$var$ThemeContext;



var $eZVvM = parcelRequire("eZVvM");

function $89fbd7ac34e17c52$export$2e2bcd8739ae039() {
    const theme = $eZVvM.useContext((0, $4b8298b1f6c5cce2$export$2e2bcd8739ae039));
    return theme;
}


const $da629066958e80aa$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $da629066958e80aa$export$2e2bcd8739ae039 = $da629066958e80aa$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $3pI8R = parcelRequire("3pI8R");
function $81172fa088d605a5$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $65o8X.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $81172fa088d605a5$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $89fbd7ac34e17c52$export$2e2bcd8739ae039)();
    const theme = $eZVvM.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $81172fa088d605a5$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $da629066958e80aa$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4b8298b1f6c5cce2$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $81172fa088d605a5$export$2e2bcd8739ae039 = $81172fa088d605a5$var$ThemeProvider;



parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
const $d97d98e83b9fa62c$var$_excluded = [
    "value"
];
const $d97d98e83b9fa62c$var$RtlContext = /*#__PURE__*/ $eZVvM.createContext();
function $d97d98e83b9fa62c$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $7Z8DW.default)(_ref, $d97d98e83b9fa62c$var$_excluded);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($d97d98e83b9fa62c$var$RtlContext.Provider, (0, $65o8X.default)({
        value: value != null ? value : true
    }, props));
}
const $d97d98e83b9fa62c$export$b2dd014b6c321cb = ()=>{
    const value = $eZVvM.useContext($d97d98e83b9fa62c$var$RtlContext);
    return value != null ? value : false;
};
var $d97d98e83b9fa62c$export$2e2bcd8739ae039 = $d97d98e83b9fa62c$var$RtlProvider;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $faab1ee4ed77fef9$var$EMPTY_THEME = {};
function $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $eZVvM.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $65o8X.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $65o8X.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $65o8X.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $faab1ee4ed77fef9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $271479f5a10767b7$export$2e2bcd8739ae039)($faab1ee4ed77fef9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $89fbd7ac34e17c52$export$2e2bcd8739ae039)() || $faab1ee4ed77fef9$var$EMPTY_THEME;
    const engineTheme = $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $faab1ee4ed77fef9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $81172fa088d605a5$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8kMfp.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d97d98e83b9fa62c$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $058703d126f1b454$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $faab1ee4ed77fef9$export$2e2bcd8739ae039 = $faab1ee4ed77fef9$var$ThemeProvider;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $43d941f371727f67$var$_excluded = [
    "theme"
];
function $43d941f371727f67$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $7Z8DW.default)(_ref, $43d941f371727f67$var$_excluded);
    const scopedTheme = themeInput[0, $cd607e6564742347$export$2e2bcd8739ae039];
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $faab1ee4ed77fef9$export$2e2bcd8739ae039), (0, $65o8X.default)({}, props, {
        themeId: scopedTheme ? (0, $cd607e6564742347$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    }));
}


var $1ed942bf934ce4b3$exports = {};
var $2c8b31d40c57a2bc$exports = {};
/* MIT license */ var $c43e08d4f102ee3c$exports = {};
"use strict";
$c43e08d4f102ee3c$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $e1e0b5537c966d2a$exports = {};
"use strict";
var $dbe4ad8d9f168d86$exports = {};
$dbe4ad8d9f168d86$exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};


var $e1e0b5537c966d2a$var$concat = Array.prototype.concat;
var $e1e0b5537c966d2a$var$slice = Array.prototype.slice;
var $e1e0b5537c966d2a$var$swizzle = $e1e0b5537c966d2a$exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($dbe4ad8d9f168d86$exports(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $e1e0b5537c966d2a$var$concat.call(results, $e1e0b5537c966d2a$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$e1e0b5537c966d2a$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($e1e0b5537c966d2a$var$swizzle(arguments));
    };
};


var $2c8b31d40c57a2bc$var$hasOwnProperty = Object.hasOwnProperty;
var $2c8b31d40c57a2bc$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $2c8b31d40c57a2bc$var$name in $c43e08d4f102ee3c$exports)if ($2c8b31d40c57a2bc$var$hasOwnProperty.call($c43e08d4f102ee3c$exports, $2c8b31d40c57a2bc$var$name)) $2c8b31d40c57a2bc$var$reverseNames[$c43e08d4f102ee3c$exports[$2c8b31d40c57a2bc$var$name]] = $2c8b31d40c57a2bc$var$name;
var $2c8b31d40c57a2bc$var$cs = $2c8b31d40c57a2bc$exports = {
    to: {},
    get: {}
};
$2c8b31d40c57a2bc$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $2c8b31d40c57a2bc$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $2c8b31d40c57a2bc$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $2c8b31d40c57a2bc$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$2c8b31d40c57a2bc$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$2c8b31d40c57a2bc$var$hasOwnProperty.call($c43e08d4f102ee3c$exports, match[1])) return null;
        rgb = $c43e08d4f102ee3c$exports[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $2c8b31d40c57a2bc$var$clamp(rgb[i], 0, 255);
    rgb[3] = $2c8b31d40c57a2bc$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$2c8b31d40c57a2bc$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $2c8b31d40c57a2bc$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$2c8b31d40c57a2bc$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $2c8b31d40c57a2bc$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $2c8b31d40c57a2bc$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$2c8b31d40c57a2bc$var$cs.to.hex = function() {
    var rgba = $e1e0b5537c966d2a$exports(arguments);
    return "#" + $2c8b31d40c57a2bc$var$hexDouble(rgba[0]) + $2c8b31d40c57a2bc$var$hexDouble(rgba[1]) + $2c8b31d40c57a2bc$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $2c8b31d40c57a2bc$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$2c8b31d40c57a2bc$var$cs.to.rgb = function() {
    var rgba = $e1e0b5537c966d2a$exports(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$2c8b31d40c57a2bc$var$cs.to.rgb.percent = function() {
    var rgba = $e1e0b5537c966d2a$exports(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$2c8b31d40c57a2bc$var$cs.to.hsl = function() {
    var hsla = $e1e0b5537c966d2a$exports(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$2c8b31d40c57a2bc$var$cs.to.hwb = function() {
    var hwba = $e1e0b5537c966d2a$exports(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$2c8b31d40c57a2bc$var$cs.to.keyword = function(rgb) {
    return $2c8b31d40c57a2bc$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $2c8b31d40c57a2bc$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $2c8b31d40c57a2bc$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}


var $91ffb7eb2bd2ce71$exports = {};
var $9ef13c34dab61823$exports = {};
/* MIT license */ /* eslint-disable no-mixed-operators */ 
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $9ef13c34dab61823$var$reverseKeywords = {};
for (const key of Object.keys($c43e08d4f102ee3c$exports))$9ef13c34dab61823$var$reverseKeywords[$c43e08d4f102ee3c$exports[key]] = key;
const $9ef13c34dab61823$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
$9ef13c34dab61823$exports = $9ef13c34dab61823$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($9ef13c34dab61823$var$convert)){
    if (!("channels" in $9ef13c34dab61823$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $9ef13c34dab61823$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($9ef13c34dab61823$var$convert[model].labels.length !== $9ef13c34dab61823$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $9ef13c34dab61823$var$convert[model];
    delete $9ef13c34dab61823$var$convert[model].channels;
    delete $9ef13c34dab61823$var$convert[model].labels;
    Object.defineProperty($9ef13c34dab61823$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($9ef13c34dab61823$var$convert[model], "labels", {
        value: labels
    });
}
$9ef13c34dab61823$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $9ef13c34dab61823$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $9ef13c34dab61823$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$9ef13c34dab61823$var$convert.rgb.keyword = function(rgb) {
    const reversed = $9ef13c34dab61823$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($c43e08d4f102ee3c$exports)){
        const value = $c43e08d4f102ee3c$exports[keyword];
        // Compute comparative distance
        const distance = $9ef13c34dab61823$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$9ef13c34dab61823$var$convert.keyword.rgb = function(keyword) {
    return $c43e08d4f102ee3c$exports[keyword];
};
$9ef13c34dab61823$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$9ef13c34dab61823$var$convert.rgb.lab = function(rgb) {
    const xyz = $9ef13c34dab61823$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$9ef13c34dab61823$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$9ef13c34dab61823$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$9ef13c34dab61823$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$9ef13c34dab61823$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$9ef13c34dab61823$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$9ef13c34dab61823$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $9ef13c34dab61823$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$9ef13c34dab61823$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $9ef13c34dab61823$var$convert.rgb.ansi16($9ef13c34dab61823$var$convert.hsv.rgb(args), args[2]);
};
$9ef13c34dab61823$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$9ef13c34dab61823$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$9ef13c34dab61823$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$9ef13c34dab61823$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$9ef13c34dab61823$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$9ef13c34dab61823$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$9ef13c34dab61823$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$9ef13c34dab61823$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$9ef13c34dab61823$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$9ef13c34dab61823$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$9ef13c34dab61823$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$9ef13c34dab61823$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$9ef13c34dab61823$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.hsv = $9ef13c34dab61823$var$convert.gray.hsl;
$9ef13c34dab61823$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$9ef13c34dab61823$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$9ef13c34dab61823$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$9ef13c34dab61823$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};


var $b8492f050d1c8c15$exports = {};

/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $b8492f050d1c8c15$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($9ef13c34dab61823$exports);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $b8492f050d1c8c15$var$deriveBFS(fromModel) {
    const graph = $b8492f050d1c8c15$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($9ef13c34dab61823$exports[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $b8492f050d1c8c15$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $b8492f050d1c8c15$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $9ef13c34dab61823$exports[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $b8492f050d1c8c15$var$link($9ef13c34dab61823$exports[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
$b8492f050d1c8c15$exports = function(fromModel) {
    const graph = $b8492f050d1c8c15$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $b8492f050d1c8c15$var$wrapConversion(toModel, graph);
    }
    return conversion;
};


const $91ffb7eb2bd2ce71$var$convert = {};
const $91ffb7eb2bd2ce71$var$models = Object.keys($9ef13c34dab61823$exports);
function $91ffb7eb2bd2ce71$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $91ffb7eb2bd2ce71$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$91ffb7eb2bd2ce71$var$models.forEach((fromModel)=>{
    $91ffb7eb2bd2ce71$var$convert[fromModel] = {};
    Object.defineProperty($91ffb7eb2bd2ce71$var$convert[fromModel], "channels", {
        value: $9ef13c34dab61823$exports[fromModel].channels
    });
    Object.defineProperty($91ffb7eb2bd2ce71$var$convert[fromModel], "labels", {
        value: $9ef13c34dab61823$exports[fromModel].labels
    });
    const routes = $b8492f050d1c8c15$exports(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $91ffb7eb2bd2ce71$var$convert[fromModel][toModel] = $91ffb7eb2bd2ce71$var$wrapRounded(fn);
        $91ffb7eb2bd2ce71$var$convert[fromModel][toModel].raw = $91ffb7eb2bd2ce71$var$wrapRaw(fn);
    });
});
$91ffb7eb2bd2ce71$exports = $91ffb7eb2bd2ce71$var$convert;


const $1ed942bf934ce4b3$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $1ed942bf934ce4b3$var$hashedModelKeys = {};
for (const model of Object.keys($91ffb7eb2bd2ce71$exports))$1ed942bf934ce4b3$var$hashedModelKeys[[
    ...$91ffb7eb2bd2ce71$exports[model].labels
].sort().join("")] = model;
const $1ed942bf934ce4b3$var$limiters = {};
function $1ed942bf934ce4b3$var$Color(object, model) {
    if (!(this instanceof $1ed942bf934ce4b3$var$Color)) return new $1ed942bf934ce4b3$var$Color(object, model);
    if (model && model in $1ed942bf934ce4b3$var$skippedModels) model = null;
    if (model && !(model in $91ffb7eb2bd2ce71$exports)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $1ed942bf934ce4b3$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $2c8b31d40c57a2bc$exports.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $91ffb7eb2bd2ce71$exports[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $91ffb7eb2bd2ce71$exports[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $1ed942bf934ce4b3$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $1ed942bf934ce4b3$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $1ed942bf934ce4b3$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $91ffb7eb2bd2ce71$exports[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $1ed942bf934ce4b3$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($1ed942bf934ce4b3$var$limiters[this.model]) {
        channels = $91ffb7eb2bd2ce71$exports[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $1ed942bf934ce4b3$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$1ed942bf934ce4b3$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $2c8b31d40c57a2bc$exports.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $2c8b31d40c57a2bc$exports.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $2c8b31d40c57a2bc$exports.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $91ffb7eb2bd2ce71$exports[this.model];
        const { labels: labels } = $91ffb7eb2bd2ce71$exports[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $1ed942bf934ce4b3$var$Color([
            ...this.color.map($1ed942bf934ce4b3$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $1ed942bf934ce4b3$var$getset("rgb", 0, $1ed942bf934ce4b3$var$maxfn(255)),
    green: $1ed942bf934ce4b3$var$getset("rgb", 1, $1ed942bf934ce4b3$var$maxfn(255)),
    blue: $1ed942bf934ce4b3$var$getset("rgb", 2, $1ed942bf934ce4b3$var$maxfn(255)),
    hue: $1ed942bf934ce4b3$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $1ed942bf934ce4b3$var$getset("hsl", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    lightness: $1ed942bf934ce4b3$var$getset("hsl", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    saturationv: $1ed942bf934ce4b3$var$getset("hsv", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    value: $1ed942bf934ce4b3$var$getset("hsv", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    chroma: $1ed942bf934ce4b3$var$getset("hcg", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    gray: $1ed942bf934ce4b3$var$getset("hcg", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    white: $1ed942bf934ce4b3$var$getset("hwb", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    wblack: $1ed942bf934ce4b3$var$getset("hwb", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    cyan: $1ed942bf934ce4b3$var$getset("cmyk", 0, $1ed942bf934ce4b3$var$maxfn(100)),
    magenta: $1ed942bf934ce4b3$var$getset("cmyk", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    yellow: $1ed942bf934ce4b3$var$getset("cmyk", 2, $1ed942bf934ce4b3$var$maxfn(100)),
    black: $1ed942bf934ce4b3$var$getset("cmyk", 3, $1ed942bf934ce4b3$var$maxfn(100)),
    x: $1ed942bf934ce4b3$var$getset("xyz", 0, $1ed942bf934ce4b3$var$maxfn(95.047)),
    y: $1ed942bf934ce4b3$var$getset("xyz", 1, $1ed942bf934ce4b3$var$maxfn(100)),
    z: $1ed942bf934ce4b3$var$getset("xyz", 2, $1ed942bf934ce4b3$var$maxfn(108.833)),
    l: $1ed942bf934ce4b3$var$getset("lab", 0, $1ed942bf934ce4b3$var$maxfn(100)),
    a: $1ed942bf934ce4b3$var$getset("lab", 1),
    b: $1ed942bf934ce4b3$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        return $91ffb7eb2bd2ce71$exports[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        return $2c8b31d40c57a2bc$exports.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $1ed942bf934ce4b3$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $2c8b31d40c57a2bc$exports.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $1ed942bf934ce4b3$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $1ed942bf934ce4b3$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($91ffb7eb2bd2ce71$exports)){
    if ($1ed942bf934ce4b3$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $91ffb7eb2bd2ce71$exports[model];
    // Conversion methods
    $1ed942bf934ce4b3$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $1ed942bf934ce4b3$var$Color(this);
        if (args.length > 0) return new $1ed942bf934ce4b3$var$Color(args, model);
        return new $1ed942bf934ce4b3$var$Color([
            ...$1ed942bf934ce4b3$var$assertArray($91ffb7eb2bd2ce71$exports[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $1ed942bf934ce4b3$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $1ed942bf934ce4b3$var$zeroArray(args, channels);
        return new $1ed942bf934ce4b3$var$Color(color, model);
    };
}
function $1ed942bf934ce4b3$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $1ed942bf934ce4b3$var$roundToPlace(places) {
    return function(number) {
        return $1ed942bf934ce4b3$var$roundTo(number, places);
    };
}
function $1ed942bf934ce4b3$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($1ed942bf934ce4b3$var$limiters[m] || ($1ed942bf934ce4b3$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $1ed942bf934ce4b3$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $1ed942bf934ce4b3$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $1ed942bf934ce4b3$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
$1ed942bf934ce4b3$exports = $1ed942bf934ce4b3$var$Color;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1PAIo = parcelRequire("1PAIo");
const $2aad6410809b406b$var$LinkBehavior = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((props, ref)=>{
    const { href: href, ...other } = props;
    // Map href (MUI) -> to (react-router)
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $1PAIo.Link), {
        ref: ref,
        to: href,
        ...other
    });
});
var $2aad6410809b406b$export$2e2bcd8739ae039 = $2aad6410809b406b$var$LinkBehavior;



var $cD0nt = parcelRequire("cD0nt");

var $eZVvM = parcelRequire("eZVvM");
const $cac46807e76713b1$export$d9dcc325f8df9b84 = ()=>{
    return (0, $eZVvM.useMemo)(()=>{
        const { hostname: hostname } = window.location;
        const parts = hostname.split(".");
        return parts.length > 2 ? parts.slice(-2).join(".") : hostname;
    }, []);
};
const $cac46807e76713b1$export$4f786993a45a8621 = ()=>{
    const domain = $cac46807e76713b1$export$d9dcc325f8df9b84();
    return (0, $eZVvM.useMemo)(()=>domain === "frontassist.eu", [
        domain
    ]);
};


const $6a1340ebfbc796da$export$2735433915558b4c = (textColor, bgColor, defaultColor)=>{
    const hexToRgb = (hex)=>{
        const cleanHex = hex.replace(/^#/, "");
        const r = parseInt(cleanHex.substring(0, 2), 16);
        const g = parseInt(cleanHex.substring(2, 4), 16);
        const b = parseInt(cleanHex.substring(4, 6), 16);
        return [
            r,
            g,
            b
        ];
    };
    const getLuminance = ([r, g, b])=>{
        const normalize = (c)=>c / 255 <= 0.03928 ? c / 255 / 12.92 : ((c / 255 + 0.055) / 1.055) ** 2.4;
        return 0.2126 * normalize(r) + 0.7152 * normalize(g) + 0.0722 * normalize(b);
    };
    const getContrastRatio = (lum1, lum2)=>{
        const lighter = Math.max(lum1, lum2);
        const darker = Math.min(lum1, lum2);
        return (lighter + 0.05) / (darker + 0.05);
    };
    const textRgb = hexToRgb(textColor);
    const bgRgb = hexToRgb(bgColor);
    const textLuminance = getLuminance(textRgb);
    const bgLuminance = getLuminance(bgRgb);
    const contrastRatio = getContrastRatio(textLuminance, bgLuminance);
    if (contrastRatio >= 3.5) return textColor;
    return bgLuminance > 0.4 ? defaultColor : "#FFFFFF";
};
function $6a1340ebfbc796da$var$createReceptionTheme(isFrontAssist, theme, fields) {
    var _theme_colors, _theme_colors1, _theme_colors2;
    var _theme_colors_primary;
    const primary = (_theme_colors_primary = theme === null || theme === void 0 ? void 0 : (_theme_colors = theme.colors) === null || _theme_colors === void 0 ? void 0 : _theme_colors.primary) !== null && _theme_colors_primary !== void 0 ? _theme_colors_primary : isFrontAssist ? "#33435d" : "#2D9CCA";
    const primaryLight = (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(primary).lighten(0.55).hex();
    const primaryDark = (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(primary).darken(0.25).hex();
    var _theme_colors_background;
    const background = (_theme_colors_background = theme === null || theme === void 0 ? void 0 : (_theme_colors1 = theme.colors) === null || _theme_colors1 === void 0 ? void 0 : _theme_colors1.background) !== null && _theme_colors_background !== void 0 ? _theme_colors_background : "#FFFFFF";
    var _theme_colors_textPrimary;
    const textPrimary = (_theme_colors_textPrimary = theme === null || theme === void 0 ? void 0 : (_theme_colors2 = theme.colors) === null || _theme_colors2 === void 0 ? void 0 : _theme_colors2.textPrimary) !== null && _theme_colors_textPrimary !== void 0 ? _theme_colors_textPrimary : "#212529";
    const contrastText = $6a1340ebfbc796da$export$2735433915558b4c(background, primary, textPrimary);
    return {
        typography: {
            fontFamily: [
                "DM Sans"
            ].join(","),
            h1: {
                fontSize: "4.4rem",
                fontWeight: "700",
                color: textPrimary
            },
            h2: {
                fontSize: "3.7rem",
                fontWeight: "700",
                color: textPrimary
            },
            h3: {
                fontSize: "3.2rem",
                fontWeight: "700",
                color: textPrimary
            },
            h4: {
                fontSize: "2.4rem",
                fontWeight: "700",
                color: textPrimary
            }
        },
        palette: {
            primary: {
                main: primary,
                dark: primaryDark,
                light: primaryLight,
                contrastText: contrastText
            },
            secondary: {
                main: "#666666"
            },
            error: {
                main: "#e13c3c"
            },
            success: {
                main: "#05c00c"
            },
            text: {
                primary: textPrimary
            },
            background: {
                default: background
            }
        },
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        width: "100%"
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        fontSize: "3.2rem",
                        color: textPrimary,
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).lighten(0.1).hex(),
                        border: `0.2rem solid ${textPrimary} !important`,
                        "fieldset.MuiOutlinedInput-notchedOutline": {
                            border: "none"
                        }
                    },
                    input: {
                        padding: "1.4rem 3.4rem !important"
                    },
                    inputAdornedStart: {
                        marginLeft: "-2rem "
                    }
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        fontSize: "3.2rem",
                        padding: "0 1rem",
                        transform: "translate(1.4rem, 1.5rem) scale(1)",
                        color: textPrimary
                    },
                    shrink: {
                        transform: "translate(2rem, -2.5rem) scale(0.75)",
                        backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).lighten(0.1).hex(),
                        padding: "0.4rem 2.5rem 0 1.5rem",
                        borderRadius: "0.7rem"
                    }
                }
            },
            MuiFormHelperText: {
                styleOverrides: {
                    root: {
                        fontSize: "2rem",
                        paddingLeft: "1rem"
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    inputRoot: {
                        padding: "0"
                    },
                    endAdornment: {
                        display: "none"
                    },
                    popper: {
                        marginTop: "0.8rem !important",
                        borderRadius: "1rem"
                    },
                    paper: {
                        margin: "0",
                        boxShadow: `0px 0px 4px -1px ${textPrimary}`,
                        border: `1px solid ${textPrimary}`,
                        borderRadius: "1rem",
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).lighten(0.1).hex()
                    },
                    listbox: {
                        padding: "0 0 0.5rem",
                        maxHeight: "21.8rem"
                    },
                    option: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 3.2rem !important",
                        color: textPrimary,
                        minHeight: "auto !important",
                        '&[aria-selected="true"]': {
                            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).lighten(0.08).hex()
                        }
                    },
                    noOptions: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 2.8rem",
                        color: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(textPrimary).lighten(0.2).hex()
                    },
                    loading: {
                        fontSize: "3.2rem",
                        padding: "1.2rem 2.8rem",
                        color: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(textPrimary).lighten(0.2).hex()
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 700,
                        fontSize: "3.2rem",
                        textTransform: "none",
                        borderRadius: "1rem",
                        boxShadow: "none",
                        color: contrastText,
                        "&:hover": {
                            boxShadow: "none"
                        }
                    },
                    sizeMedium: {
                        fontSize: "3.2rem",
                        padding: "1.45rem 2rem"
                    },
                    outlined: {
                        color: primary
                    }
                }
            },
            MuiButtonGroup: {
                styleOverrides: {
                    root: {
                        ".MuiButton-root:first-of-type": {
                            borderBottomLeftRadius: 0
                        },
                        ".MuiButton-root:last-of-type": {
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            MuiLink: {
                defaultProps: {
                    component: (0, $2aad6410809b406b$export$2e2bcd8739ae039)
                }
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        marginTop: "-3rem!important",
                        width: "56.5rem",
                        height: "38rem",
                        margin: "0",
                        boxShadow: `0px 0px 4px -1px ${textPrimary}`,
                        border: `1px solid ${textPrimary}`,
                        background: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).lighten(0.1).hex(),
                        li: {
                            fontSize: "3.2rem",
                            padding: "1.2rem 3.2rem !important",
                            color: textPrimary,
                            minHeight: "auto !important",
                            img: {
                                width: "4rem",
                                marginRight: "3rem"
                            },
                            span: {
                                fontSize: "inherit"
                            },
                            p: {
                                fontSize: "inherit",
                                fontWeight: "600"
                            }
                        }
                    }
                }
            },
            MuiInputAdornment: {
                styleOverrides: {
                    root: {
                        button: {
                            marginLeft: "1rem",
                            paddingRight: "0",
                            img: {
                                width: "4rem"
                            }
                        }
                    }
                }
            },
            MuiTable: {
                styleOverrides: {
                    root: {
                        marginTop: "3rem",
                        width: "90%"
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        width: `${100 / ((fields === null || fields === void 0 ? void 0 : fields.length) || 3)}%`,
                        textAlign: "center",
                        fontSize: "2.4rem",
                        padding: "2rem 0"
                    },
                    head: {
                        fontSize: "2.75rem",
                        fontWeight: "700"
                    }
                }
            },
            MuiTablePagination: {
                styleOverrides: {
                    root: {
                        ".MuiInputBase-root": {
                            display: "none"
                        }
                    },
                    selectLabel: {
                        display: "none"
                    },
                    displayedRows: {
                        display: "none"
                    },
                    actions: {
                        marginLeft: "0",
                        svg: {
                            width: "5rem",
                            height: "5rem"
                        }
                    }
                }
            }
        }
    };
}
const $6a1340ebfbc796da$export$d8964aec282183a3 = (props)=>{
    const { children: children, dataUpdatedAt: dataUpdatedAt, theme: theme } = props;
    const { fields: fields } = (0, $cD0nt.useOverview)();
    const isFrontAssist = (0, $cac46807e76713b1$export$4f786993a45a8621)();
    const MUItheme = (0, $eZVvM.useMemo)(()=>{
        const options = $6a1340ebfbc796da$var$createReceptionTheme(isFrontAssist, theme, fields);
        return (0, $dfae66918ab7b5ac$export$2e2bcd8739ae039)(options);
    }, [
        theme,
        dataUpdatedAt,
        isFrontAssist
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $43d941f371727f67$export$2e2bcd8739ae039), {
        theme: MUItheme,
        children: children
    });
};



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $kvR7a = parcelRequire("kvR7a");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $gdPnm = parcelRequire("gdPnm");

var $cwDEq = parcelRequire("cwDEq");
const $bad2beece3d2a513$var$getBrowserLanguage = ()=>navigator.languages.find((language)=>language.length === 2);
const $bad2beece3d2a513$var$defaultLanguages = [
    "en",
    "en_US",
    "nl",
    "sr",
    "fr",
    "de",
    "pt",
    "es",
    "ja",
    "pl",
    "it"
];
const $bad2beece3d2a513$var$LanguageContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const { Provider: $bad2beece3d2a513$var$Provider } = $bad2beece3d2a513$var$LanguageContext;
const $bad2beece3d2a513$export$c1fd9f444a3dc711 = ()=>{
    const { language: language, onChange: onChange } = (0, $eZVvM.useContext)($bad2beece3d2a513$var$LanguageContext);
    return [
        language,
        onChange
    ];
};
const $bad2beece3d2a513$export$38be4353f99148d = ()=>{
    const { languages: languages } = (0, $eZVvM.useContext)($bad2beece3d2a513$var$LanguageContext);
    return languages;
};
const $bad2beece3d2a513$var$isActivationScreen = window.location.pathname.includes("/activation");
const $bad2beece3d2a513$export$195746d839abd8b5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children, language: defaultLanguage = $bad2beece3d2a513$var$isActivationScreen ? $bad2beece3d2a513$var$getBrowserLanguage() : "en", languages: languages = $bad2beece3d2a513$var$defaultLanguages } = props;
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { screenId: screenId } = (0, $cwDEq.useAppContext)();
    const { i18n: i18n } = (0, $9GLBV.useTranslation)();
    const [language, setLanguage] = (0, $eZVvM.useState)(defaultLanguage);
    (0, $eZVvM.useEffect)(()=>{
        setLanguage(()=>defaultLanguage);
    }, [
        defaultLanguage
    ]);
    (0, $eZVvM.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).locale(language);
        i18n.changeLanguage(language);
    }, [
        language
    ]);
    const onChange = (0, $eZVvM.useCallback)((next)=>{
        setLanguage(next);
    }, [
        i18n
    ]);
    const onMessage = (0, $eZVvM.useCallback)(async (event)=>{
        const { data: rawMessage } = event;
        try {
            const message = JSON.parse(rawMessage);
            if (!(message && message.action && message.action === "update-language")) return;
            const { data: data } = message;
            await queryClient.refetchQueries([
                "digitalReception",
                {
                    id: screenId,
                    language: data
                }
            ]);
            setLanguage(data);
        } catch (e) {
        //
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("message", onMessage);
        return ()=>window.removeEventListener("message", onMessage);
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            language: language,
            languages: languages,
            onChange: onChange
        }), [
        languages,
        language,
        onChange
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($bad2beece3d2a513$var$Provider, {
        value: value,
        children: children
    });
});
var $bad2beece3d2a513$export$2e2bcd8739ae039 = $bad2beece3d2a513$var$LanguageContext;



var $l4qYG = parcelRequire("l4qYG");
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");


function $6d14c395f011340c$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $5f57867e26bb4108$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $2bdc4589d20a7f85$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $a156fe7855a1d3a0$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $b50d6f2544a29792$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $cefff5a56c58fb78$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $cefff5a56c58fb78$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $cefff5a56c58fb78$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $cefff5a56c58fb78$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $27459a0b09d3428c$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $cefff5a56c58fb78$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $6d707c97a45dfb5d$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $6d707c97a45dfb5d$export$1405a65085f40b9 = [
    "initial",
    ...$6d707c97a45dfb5d$export$16e45afcc206d3a8
];



/**
 * Generate a list of every possible transform key.
 */ const $f6b89e753c7819bf$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $f6b89e753c7819bf$export$7b42a0094fb00b6e = new Set($f6b89e753c7819bf$export$280dc01950909d86);


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;



const $9b331d1887e7c201$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $9b331d1887e7c201$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $9b331d1887e7c201$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $9b331d1887e7c201$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $9b331d1887e7c201$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $9b331d1887e7c201$var$keyframesTransition;
    else if ((0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $9b331d1887e7c201$var$criticallyDampedSpring(keyframes[1]) : $9b331d1887e7c201$var$underDampedSpring;
    return $9b331d1887e7c201$var$ease;
};


function $a03b6c3e80f89fb5$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


const $77ec403776d67d5f$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};


const $a02175ba83759089$export$888a3d84909f9e3d = {
    current: false
};


const $898d86da5e16a777$var$isNotNull = (value)=>value !== null;
function $898d86da5e16a777$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($898d86da5e16a777$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}




function $7e6a806b6d97fda2$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $8779983df53b5129$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $8779983df53b5129$var$maxElapsed = 40;
function $8779983df53b5129$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $8779983df53b5129$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $7e6a806b6d97fda2$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $77ec403776d67d5f$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $8779983df53b5129$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $8779983df53b5129$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $8779983df53b5129$export$71ecace0a033b35a.length; i++)steps[$8779983df53b5129$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $acdac96acb68981d$export$2cef06c20297c17d, cancel: $acdac96acb68981d$export$ec99c0ef4978dccb, state: $acdac96acb68981d$export$fff89137e9e818ce, steps: $acdac96acb68981d$export$1811c3a7e3af92f0 } = (0, $8779983df53b5129$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $586d62dcd567427e$export$8793edee2d425525), true);



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $b6590af9d56d7dfd$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $b6590af9d56d7dfd$var$subdivisionPrecision = 0.0000001;
const $b6590af9d56d7dfd$var$subdivisionMaxIterations = 12;
function $b6590af9d56d7dfd$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $b6590af9d56d7dfd$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $b6590af9d56d7dfd$var$subdivisionPrecision && ++i < $b6590af9d56d7dfd$var$subdivisionMaxIterations);
    return currentT;
}
function $b6590af9d56d7dfd$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $586d62dcd567427e$export$8793edee2d425525;
    const getTForX = (aX)=>$b6590af9d56d7dfd$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $b6590af9d56d7dfd$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $5f47d83f34a7c58a$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $e04d864cbb1a7b33$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $92e5ce9e557d421b$export$77edfce482316a60 = /*@__PURE__*/ (0, $b6590af9d56d7dfd$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $92e5ce9e557d421b$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $e04d864cbb1a7b33$export$2c07eeff45156d4d)($92e5ce9e557d421b$export$77edfce482316a60);
const $92e5ce9e557d421b$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $5f47d83f34a7c58a$export$f946554fb8aeaf0d)($92e5ce9e557d421b$export$b01116c84cdfe1a2);


const $9dcd65fff942a904$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $92e5ce9e557d421b$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $14c56a73b42f85a3$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $14c56a73b42f85a3$export$c8d67a19199d1a50 = (0, $e04d864cbb1a7b33$export$2c07eeff45156d4d)($14c56a73b42f85a3$export$e444123e42d03385);
const $14c56a73b42f85a3$export$30d3455eee55bed5 = (0, $5f47d83f34a7c58a$export$f946554fb8aeaf0d)($14c56a73b42f85a3$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $cb9f01153b2a3d05$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $2a0ef451ef0a1bb4$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $cb9f01153b2a3d05$export$ade84c85e44a6cb1)(value);
    else return true;
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $bda2c785ae6c314a$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $ebebb008c5329c80$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $ebebb008c5329c80$export$9de1236619d9e756 = /*@__PURE__*/ $ebebb008c5329c80$var$checkStringStartsWith("--");
const $ebebb008c5329c80$var$startsAsVariableToken = /*@__PURE__*/ $ebebb008c5329c80$var$checkStringStartsWith("var(--");
const $ebebb008c5329c80$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $ebebb008c5329c80$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $ebebb008c5329c80$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $ebebb008c5329c80$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $a97f9a67f71f7d90$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $a97f9a67f71f7d90$export$b9f0c1f373aee2b0(current) {
    const match = $a97f9a67f71f7d90$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $a97f9a67f71f7d90$var$maxDepth = 4;
function $a97f9a67f71f7d90$export$289398774300c991(current, element, depth = 1) {
    (0, $bde5dfec70eede58$export$f5708dca728d7177)(depth <= $a97f9a67f71f7d90$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $a97f9a67f71f7d90$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $bda2c785ae6c314a$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $ebebb008c5329c80$export$31f9caa2600b5723)(fallback) ? $a97f9a67f71f7d90$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




const $922cbf6b96b336a1$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $70d95d5465e99a63$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $70d95d5465e99a63$export$58f0f39f63f3cf42 = {
    ...$70d95d5465e99a63$export$98e628dec113755e,
    transform: (v)=>(0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $70d95d5465e99a63$export$dcdf75081b88279d = {
    ...$70d95d5465e99a63$export$98e628dec113755e,
    default: 1
};


const $a5596f9db4a91b91$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $a5596f9db4a91b91$export$41fc368e1a942b97 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("deg");
const $a5596f9db4a91b91$export$626336c2cd4b14de = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("%");
const $a5596f9db4a91b91$export$91c0eda1d06bf008 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("px");
const $a5596f9db4a91b91$export$f91e8c45a95a32f2 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("vh");
const $a5596f9db4a91b91$export$aed3d7b7d206c196 = /*@__PURE__*/ $a5596f9db4a91b91$var$createUnitType("vw");
const $a5596f9db4a91b91$export$44e2e1705876d7ed = {
    ...$a5596f9db4a91b91$export$626336c2cd4b14de,
    parse: (v)=>$a5596f9db4a91b91$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$a5596f9db4a91b91$export$626336c2cd4b14de.transform(v * 100)
};


const $3d2ccea53c634da1$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $3d2ccea53c634da1$export$8e5250d1aa9bf370 = (v)=>v === (0, $70d95d5465e99a63$export$98e628dec113755e) || v === (0, $a5596f9db4a91b91$export$91c0eda1d06bf008);
const $3d2ccea53c634da1$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $3d2ccea53c634da1$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $3d2ccea53c634da1$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $3d2ccea53c634da1$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $3d2ccea53c634da1$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $3d2ccea53c634da1$var$nonTranslationalTransformKeys = (0, $f6b89e753c7819bf$export$280dc01950909d86).filter((key)=>!$3d2ccea53c634da1$var$transformKeys.has(key));
function $3d2ccea53c634da1$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $3d2ccea53c634da1$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $3d2ccea53c634da1$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $3d2ccea53c634da1$var$getTranslateFromMatrix(4, 13),
    y: $3d2ccea53c634da1$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$3d2ccea53c634da1$export$781d46a8aa670d52.translateX = $3d2ccea53c634da1$export$781d46a8aa670d52.x;
$3d2ccea53c634da1$export$781d46a8aa670d52.translateY = $3d2ccea53c634da1$export$781d46a8aa670d52.y;




/**
 * Tests a provided value against a ValueType
 */ const $b11710ae4d65c274$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $f360ac2d58659cbe$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $d88a34dd2eb7fed0$export$d176691c1998a1f5 = [
    (0, $70d95d5465e99a63$export$98e628dec113755e),
    (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    (0, $a5596f9db4a91b91$export$626336c2cd4b14de),
    (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    (0, $a5596f9db4a91b91$export$aed3d7b7d206c196),
    (0, $a5596f9db4a91b91$export$f91e8c45a95a32f2),
    (0, $f360ac2d58659cbe$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d88a34dd2eb7fed0$export$eefdd52e3ccae428 = (v)=>$d88a34dd2eb7fed0$export$d176691c1998a1f5.find((0, $b11710ae4d65c274$export$6eae4d0a6a7ca7cd)(v));




const $fe4a5825614f738f$var$toResolve = new Set();
let $fe4a5825614f738f$var$isScheduled = false;
let $fe4a5825614f738f$var$anyNeedsMeasurement = false;
function $fe4a5825614f738f$var$measureAllKeyframes() {
    if ($fe4a5825614f738f$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($fe4a5825614f738f$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $3d2ccea53c634da1$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $fe4a5825614f738f$var$anyNeedsMeasurement = false;
    $fe4a5825614f738f$var$isScheduled = false;
    $fe4a5825614f738f$var$toResolve.forEach((resolver)=>resolver.complete());
    $fe4a5825614f738f$var$toResolve.clear();
}
function $fe4a5825614f738f$var$readAllKeyframes() {
    $fe4a5825614f738f$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $fe4a5825614f738f$var$anyNeedsMeasurement = true;
    });
}
function $fe4a5825614f738f$export$78b96d2a12593b05() {
    $fe4a5825614f738f$var$readAllKeyframes();
    $fe4a5825614f738f$var$measureAllKeyframes();
}
class $fe4a5825614f738f$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $fe4a5825614f738f$var$toResolve.add(this);
            if (!$fe4a5825614f738f$var$isScheduled) {
                $fe4a5825614f738f$var$isScheduled = true;
                (0, $acdac96acb68981d$export$2cef06c20297c17d).read($fe4a5825614f738f$var$readAllKeyframes);
                (0, $acdac96acb68981d$export$2cef06c20297c17d).resolveKeyframes($fe4a5825614f738f$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $fe4a5825614f738f$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $fe4a5825614f738f$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $7783f10d67c88e2e$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $341661bf74982dea$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $b51844c84c34bde2$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $f8d90bbc61e53af1$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $23c84f4c68564ae4$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $f8d90bbc61e53af1$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $b51844c84c34bde2$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $23c84f4c68564ae4$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $341661bf74982dea$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $96f36da889b7860b$var$clampRgbUnit = (v)=>(0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(0, 255, v);
const $96f36da889b7860b$export$7a99c86b5b1f4c9e = {
    ...(0, $70d95d5465e99a63$export$98e628dec113755e),
    transform: (v)=>Math.round($96f36da889b7860b$var$clampRgbUnit(v))
};
const $96f36da889b7860b$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $23c84f4c68564ae4$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $23c84f4c68564ae4$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(red) + ", " + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(green) + ", " + $96f36da889b7860b$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $7783f10d67c88e2e$export$83d2e9e3e4ee39ed)((0, $70d95d5465e99a63$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $40533b9b2b27af1c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $40533b9b2b27af1c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $23c84f4c68564ae4$export$2c8400d58aca05e)("#"),
    parse: $40533b9b2b27af1c$var$parseHex,
    transform: (0, $96f36da889b7860b$export$4e46ac54fc82cf3b).transform
};






const $6a42a864380d6ae9$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $23c84f4c68564ae4$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $23c84f4c68564ae4$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $a5596f9db4a91b91$export$626336c2cd4b14de).transform((0, $7783f10d67c88e2e$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $a5596f9db4a91b91$export$626336c2cd4b14de).transform((0, $7783f10d67c88e2e$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $7783f10d67c88e2e$export$83d2e9e3e4ee39ed)((0, $70d95d5465e99a63$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $8682243b2d1255c3$export$35e9368ef982300f = {
    test: (v)=>(0, $96f36da889b7860b$export$4e46ac54fc82cf3b).test(v) || (0, $40533b9b2b27af1c$export$834dfc94dde4b3d8).test(v) || (0, $6a42a864380d6ae9$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $96f36da889b7860b$export$4e46ac54fc82cf3b).test(v)) return (0, $96f36da889b7860b$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $6a42a864380d6ae9$export$810b04175080204c).test(v)) return (0, $6a42a864380d6ae9$export$810b04175080204c).parse(v);
        else return (0, $40533b9b2b27af1c$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $96f36da889b7860b$export$4e46ac54fc82cf3b).transform(v) : (0, $6a42a864380d6ae9$export$810b04175080204c).transform(v);
    }
};


const $f59c0f6630173981$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $5470142997ed61da$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $341661bf74982dea$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $f59c0f6630173981$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $5470142997ed61da$var$NUMBER_TOKEN = "number";
const $5470142997ed61da$var$COLOR_TOKEN = "color";
const $5470142997ed61da$var$VAR_TOKEN = "var";
const $5470142997ed61da$var$VAR_FUNCTION_TOKEN = "var(";
const $5470142997ed61da$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $5470142997ed61da$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $5470142997ed61da$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($5470142997ed61da$var$complexRegex, (parsedValue)=>{
        if ((0, $8682243b2d1255c3$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($5470142997ed61da$var$COLOR_TOKEN);
            values.push((0, $8682243b2d1255c3$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($5470142997ed61da$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($5470142997ed61da$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($5470142997ed61da$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $5470142997ed61da$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($5470142997ed61da$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $5470142997ed61da$var$parseComplexValue(v) {
    return $5470142997ed61da$export$b61fc7c44bf646d5(v).values;
}
function $5470142997ed61da$var$createTransformer(source) {
    const { split: split, types: types } = $5470142997ed61da$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $5470142997ed61da$var$NUMBER_TOKEN) output += (0, $7783f10d67c88e2e$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $5470142997ed61da$var$COLOR_TOKEN) output += (0, $8682243b2d1255c3$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $5470142997ed61da$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $5470142997ed61da$var$getAnimatableNone(v) {
    const parsed = $5470142997ed61da$var$parseComplexValue(v);
    const transformer = $5470142997ed61da$var$createTransformer(v);
    return transformer(parsed.map($5470142997ed61da$var$convertNumbersToZero));
}
const $5470142997ed61da$export$83a0e34f1302825b = {
    test: $5470142997ed61da$var$test,
    parse: $5470142997ed61da$var$parseComplexValue,
    createTransformer: $5470142997ed61da$var$createTransformer,
    getAnimatableNone: $5470142997ed61da$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $d814c116bbc362d7$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $d814c116bbc362d7$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $341661bf74982dea$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $d814c116bbc362d7$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $d814c116bbc362d7$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $d814c116bbc362d7$export$3dea766d36a8935f = {
    ...(0, $5470142997ed61da$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($d814c116bbc362d7$var$functionRegex);
        return functions ? functions.map($d814c116bbc362d7$var$applyDefaultFilter).join(" ") : v;
    }
};







const $326d6b7c609893c3$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderTopWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderRightWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderRadius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    radius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    maxWidth: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    height: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    maxHeight: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    top: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    right: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    bottom: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    left: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    paddingTop: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    paddingRight: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    paddingBottom: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    paddingLeft: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    margin: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    marginTop: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    marginRight: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    marginBottom: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    marginLeft: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008)
};




const $e04c285b44adb0c2$export$f2e4285fee37e26 = {
    rotate: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    rotateX: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    rotateY: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    rotateZ: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    scale: $70d95d5465e99a63$export$dcdf75081b88279d,
    scaleX: (0, $70d95d5465e99a63$export$dcdf75081b88279d),
    scaleY: (0, $70d95d5465e99a63$export$dcdf75081b88279d),
    scaleZ: (0, $70d95d5465e99a63$export$dcdf75081b88279d),
    skew: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    skewX: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    skewY: (0, $a5596f9db4a91b91$export$41fc368e1a942b97),
    distance: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    translateX: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    translateY: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    translateZ: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    x: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    y: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    z: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    perspective: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    transformPerspective: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    opacity: (0, $70d95d5465e99a63$export$58f0f39f63f3cf42),
    originX: (0, $a5596f9db4a91b91$export$44e2e1705876d7ed),
    originY: (0, $a5596f9db4a91b91$export$44e2e1705876d7ed),
    originZ: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008)
};



const $44cab0f7ae8cb868$export$7d260a2a5f8bc19e = {
    ...(0, $70d95d5465e99a63$export$98e628dec113755e),
    transform: Math.round
};


const $5490b350038d9669$export$eec14432cd1cb67b = {
    ...(0, $326d6b7c609893c3$export$2fb74b0a4e7d7c4a),
    ...(0, $e04c285b44adb0c2$export$f2e4285fee37e26),
    zIndex: (0, $44cab0f7ae8cb868$export$7d260a2a5f8bc19e),
    size: (0, $a5596f9db4a91b91$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $70d95d5465e99a63$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $70d95d5465e99a63$export$58f0f39f63f3cf42),
    numOctaves: (0, $44cab0f7ae8cb868$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $21740e929035fdb6$export$98cd7c72c5a731fb = {
    ...(0, $5490b350038d9669$export$eec14432cd1cb67b),
    color: // Color props
    $8682243b2d1255c3$export$35e9368ef982300f,
    backgroundColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    outlineColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    fill: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    stroke: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    borderTopColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    borderRightColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    borderBottomColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    borderLeftColor: (0, $8682243b2d1255c3$export$35e9368ef982300f),
    filter: $d814c116bbc362d7$export$3dea766d36a8935f,
    WebkitFilter: (0, $d814c116bbc362d7$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $21740e929035fdb6$export$67d1babe0338d23b = (key)=>$21740e929035fdb6$export$98cd7c72c5a731fb[key];


function $7ea9939be3c3d3fe$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $21740e929035fdb6$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $d814c116bbc362d7$export$3dea766d36a8935f)) defaultValueType = (0, $5470142997ed61da$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $6e5af34ab30ee3d2$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $6e5af34ab30ee3d2$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$6e5af34ab30ee3d2$var$invalidTemplates.has(keyframe) && (0, $5470142997ed61da$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $7ea9939be3c3d3fe$export$cea0cedcb94873b5)(name, animatableTemplate);
}


class $30d54e4a4fa013cf$export$4983792d11b61017 extends (0, $fe4a5825614f738f$export$74d34ca3182f1750) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $ebebb008c5329c80$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $a97f9a67f71f7d90$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $3d2ccea53c634da1$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $d88a34dd2eb7fed0$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $d88a34dd2eb7fed0$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $3d2ccea53c634da1$export$8e5250d1aa9bf370)(originType) && (0, $3d2ccea53c634da1$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $2a0ef451ef0a1bb4$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $6e5af34ab30ee3d2$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $3d2ccea53c634da1$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $3d2ccea53c634da1$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}




function $e953c71f76f79b0f$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}




let $7fbfc6b5a4b6f06f$var$now;
function $7fbfc6b5a4b6f06f$var$clearTime() {
    $7fbfc6b5a4b6f06f$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($7fbfc6b5a4b6f06f$var$now === undefined) $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1.set((0, $acdac96acb68981d$export$fff89137e9e818ce).isProcessing || (0, $77ec403776d67d5f$export$dd826089e3c5e502).useManualTiming ? (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp : performance.now());
        return $7fbfc6b5a4b6f06f$var$now;
    },
    set: (newTime)=>{
        $7fbfc6b5a4b6f06f$var$now = newTime;
        queueMicrotask($7fbfc6b5a4b6f06f$var$clearTime);
    }
};







/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $83342a437e84093a$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $5470142997ed61da$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $d815b55018768770$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $d815b55018768770$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $83342a437e84093a$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $83342a437e84093a$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $bde5dfec70eede58$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $d815b55018768770$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $e953c71f76f79b0f$export$6ab7812f1bac68be)(type)) && velocity;
}



/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $70769c28f13a896e$var$MAX_RESOLVE_DELAY = 40;
class $70769c28f13a896e$export$d1e4f34b9c2550c1 {
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $70769c28f13a896e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $fe4a5825614f738f$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $d815b55018768770$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $a02175ba83759089$export$888a3d84909f9e3d).current || !delay) {
                onUpdate === null || onUpdate === void 0 || onUpdate((0, $898d86da5e16a777$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete === null || onComplete === void 0 || onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
}




/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8c9e7236f0507fd5$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $f9daaa93eaf4768e$var$velocitySampleDuration = 5; // ms
function $f9daaa93eaf4768e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $f9daaa93eaf4768e$var$velocitySampleDuration, 0);
    return (0, $8c9e7236f0507fd5$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $3b0a63a5b7236b15$var$safeMin = 0.001;
const $3b0a63a5b7236b15$export$a3cdb76e84ee608e = 0.01;
const $3b0a63a5b7236b15$export$1824b851fad8862b = 10.0;
const $3b0a63a5b7236b15$export$ff08f2d53484465 = 0.05;
const $3b0a63a5b7236b15$export$201ca48e54038115 = 1;
function $3b0a63a5b7236b15$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $bde5dfec70eede58$export$491112666e282270)(duration <= (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)($3b0a63a5b7236b15$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)($3b0a63a5b7236b15$export$ff08f2d53484465, $3b0a63a5b7236b15$export$201ca48e54038115, dampingRatio);
    duration = (0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)($3b0a63a5b7236b15$export$a3cdb76e84ee608e, $3b0a63a5b7236b15$export$1824b851fad8862b, (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $3b0a63a5b7236b15$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $3b0a63a5b7236b15$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $3b0a63a5b7236b15$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $3b0a63a5b7236b15$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$3b0a63a5b7236b15$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $3b0a63a5b7236b15$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $3b0a63a5b7236b15$var$rootIterations = 12;
function $3b0a63a5b7236b15$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $3b0a63a5b7236b15$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $3b0a63a5b7236b15$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $fdc5cd0ebd232846$var$durationKeys = [
    "duration",
    "bounce"
];
const $fdc5cd0ebd232846$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $fdc5cd0ebd232846$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $fdc5cd0ebd232846$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$fdc5cd0ebd232846$var$isSpringType(options, $fdc5cd0ebd232846$var$physicsKeys) && $fdc5cd0ebd232846$var$isSpringType(options, $fdc5cd0ebd232846$var$durationKeys)) {
        const derived = (0, $3b0a63a5b7236b15$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $fdc5cd0ebd232846$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $fdc5cd0ebd232846$var$getSpringOptions({
        ...options,
        velocity: -(0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $3b0a63a5b7236b15$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $f9daaa93eaf4768e$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $945bade90b0df180$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $fdc5cd0ebd232846$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $f9daaa93eaf4768e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $17ffe7dfa5e6cb5e$export$929e5a82286172a6 = /*@__PURE__*/ (0, $b6590af9d56d7dfd$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $17ffe7dfa5e6cb5e$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $b6590af9d56d7dfd$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $17ffe7dfa5e6cb5e$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $b6590af9d56d7dfd$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $d528cf77d3d9476f$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $14d9938e6f21d101$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $7b66960f57cc2a17$var$easingLookup = {
    linear: (0, $586d62dcd567427e$export$8793edee2d425525),
    easeIn: $17ffe7dfa5e6cb5e$export$929e5a82286172a6,
    easeInOut: $17ffe7dfa5e6cb5e$export$c07234257a03d5e9,
    easeOut: $17ffe7dfa5e6cb5e$export$57636bb43b1ccbb0,
    circIn: $14c56a73b42f85a3$export$e444123e42d03385,
    circInOut: $14c56a73b42f85a3$export$30d3455eee55bed5,
    circOut: $14c56a73b42f85a3$export$c8d67a19199d1a50,
    backIn: $92e5ce9e557d421b$export$b01116c84cdfe1a2,
    backInOut: $92e5ce9e557d421b$export$ddc5fd596f6c71b2,
    backOut: $92e5ce9e557d421b$export$77edfce482316a60,
    anticipate: $9dcd65fff942a904$export$6b0af63b873d419e
};
const $7b66960f57cc2a17$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $14d9938e6f21d101$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $bde5dfec70eede58$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $b6590af9d56d7dfd$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $bde5dfec70eede58$export$f5708dca728d7177)($7b66960f57cc2a17$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $7b66960f57cc2a17$var$easingLookup[definition];
    }
    return definition;
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $af408ce9d401e7be$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $af408ce9d401e7be$export$a4627e546088548d = (...transformers)=>transformers.reduce($af408ce9d401e7be$var$combineFunctions);


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $12bda51f70c7265a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $443836d22b4ddf64$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $f1690968937689e7$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $f1690968937689e7$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $f1690968937689e7$var$hueToRgb(p, q, hue + 1 / 3);
        green = $f1690968937689e7$var$hueToRgb(p, q, hue);
        blue = $f1690968937689e7$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $46aeb136ddf49b53$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $388e816e2bafe060$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $388e816e2bafe060$var$colorTypes = [
    (0, $40533b9b2b27af1c$export$834dfc94dde4b3d8),
    (0, $96f36da889b7860b$export$4e46ac54fc82cf3b),
    (0, $6a42a864380d6ae9$export$810b04175080204c)
];
const $388e816e2bafe060$var$getColorType = (v)=>$388e816e2bafe060$var$colorTypes.find((type)=>type.test(v));
function $388e816e2bafe060$var$asRGBA(color) {
    const type = $388e816e2bafe060$var$getColorType(color);
    (0, $bde5dfec70eede58$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $6a42a864380d6ae9$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $f1690968937689e7$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $388e816e2bafe060$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $388e816e2bafe060$var$asRGBA(from);
    const toRGBA = $388e816e2bafe060$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $46aeb136ddf49b53$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $388e816e2bafe060$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $96f36da889b7860b$export$4e46ac54fc82cf3b).transform(blended);
    };
};







const $df9242d58c65c8eb$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $df9242d58c65c8eb$export$fed62ccc3fb1a568(origin, target) {
    if ($df9242d58c65c8eb$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $961ea9031ece4213$var$mixNumber(a, b) {
    return (p)=>(0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $961ea9031ece4213$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $961ea9031ece4213$var$mixNumber;
    else if (typeof a === "string") return (0, $ebebb008c5329c80$export$31f9caa2600b5723)(a) ? (0, $46aeb136ddf49b53$export$a6f92d4bae65c0f1) : (0, $8682243b2d1255c3$export$35e9368ef982300f).test(a) ? (0, $388e816e2bafe060$export$51e568cf5c039bac) : $961ea9031ece4213$export$65516310a87d8205;
    else if (Array.isArray(a)) return $961ea9031ece4213$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $8682243b2d1255c3$export$35e9368ef982300f).test(a) ? (0, $388e816e2bafe060$export$51e568cf5c039bac) : $961ea9031ece4213$export$ebc23b6840c51ba1;
    return 0, $46aeb136ddf49b53$export$a6f92d4bae65c0f1;
}
function $961ea9031ece4213$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$961ea9031ece4213$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $961ea9031ece4213$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $961ea9031ece4213$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $961ea9031ece4213$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $961ea9031ece4213$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $5470142997ed61da$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $5470142997ed61da$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $5470142997ed61da$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $df9242d58c65c8eb$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $df9242d58c65c8eb$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $df9242d58c65c8eb$export$fed62ccc3fb1a568)(origin, target);
        return (0, $af408ce9d401e7be$export$a4627e546088548d)($961ea9031ece4213$export$3bbefa2f402845c4($961ea9031ece4213$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $bde5dfec70eede58$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $46aeb136ddf49b53$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $ce4dee409deddbf1$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $961ea9031ece4213$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}


function $ecfcb692edde2fe9$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $ce4dee409deddbf1$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $586d62dcd567427e$export$8793edee2d425525) : ease;
            mixer = (0, $af408ce9d401e7be$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $ecfcb692edde2fe9$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $bde5dfec70eede58$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && input[0] === input[1]) return ()=>output[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $ecfcb692edde2fe9$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $12bda51f70c7265a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $1d20156facb00c0e$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $12bda51f70c7265a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $a16957f4a918dd0e$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $1d20156facb00c0e$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $2e85e32b4fa74249$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $368c79393381aaea$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $17ffe7dfa5e6cb5e$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $368c79393381aaea$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $d528cf77d3d9476f$export$216948827bbdc797)(ease) ? ease.map((0, $7b66960f57cc2a17$export$ef97fe084f156ca4)) : (0, $7b66960f57cc2a17$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $2e85e32b4fa74249$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $a16957f4a918dd0e$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $ecfcb692edde2fe9$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $368c79393381aaea$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8 = 20000;
function $5f5c6a0b469cfe6d$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $5f5c6a0b469cfe6d$export$f4ff70a5b4808fd8 ? Infinity : duration;
}







const $aadc4aedc6f76650$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $acdac96acb68981d$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $acdac96acb68981d$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $acdac96acb68981d$export$fff89137e9e818ce).isProcessing ? (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp : (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now()
    };
};




const $41a172794ed2cf55$var$generators = {
    decay: (0, $945bade90b0df180$export$ee3ff3a17106998),
    inertia: $945bade90b0df180$export$ee3ff3a17106998,
    tween: (0, $368c79393381aaea$export$d25ddfdf17c3ad3e),
    keyframes: (0, $368c79393381aaea$export$d25ddfdf17c3ad3e),
    spring: $fdc5cd0ebd232846$export$b36281d89752ae66
};
const $41a172794ed2cf55$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $41a172794ed2cf55$export$fd98d9cca67a58bc extends (0, $70769c28f13a896e$export$d1e4f34b9c2550c1) {
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $e953c71f76f79b0f$export$6ab7812f1bac68be)(type) ? type : $41a172794ed2cf55$var$generators[type] || (0, $368c79393381aaea$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $368c79393381aaea$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $af408ce9d401e7be$export$a4627e546088548d)($41a172794ed2cf55$var$percentToProgress, (0, $ce4dee409deddbf1$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $5f5c6a0b469cfe6d$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $898d86da5e16a777$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $aadc4aedc6f76650$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $fe4a5825614f738f$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}
// Legacy interface
function $41a172794ed2cf55$export$ee9b76de7353d815(options) {
    return new $41a172794ed2cf55$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $8614f0f2d4b1c4f3$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);




// Create a linear easing point for every 10 ms
const $40a5a3f1abcc3cdb$var$resolution = 10;
const $40a5a3f1abcc3cdb$export$66d3851e2b1ec912 = (easing, duration // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / $40a5a3f1abcc3cdb$var$resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $12bda51f70c7265a$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


function $126e79f287d0cb5d$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $477759e91af48477$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $72d52e419e00ea27$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $126e79f287d0cb5d$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $477759e91af48477$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $55a5ca433915f5db$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $72d52e419e00ea27$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


function $1ea8880f4e4e0d5c$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $55a5ca433915f5db$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $1ea8880f4e4e0d5c$export$2cf569f5e2221176 || (0, $55a5ca433915f5db$export$866c1d07a1ac2ab)()) || (0, $14d9938e6f21d101$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($1ea8880f4e4e0d5c$export$fcdd8f3f2160beda));
}
const $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $1ea8880f4e4e0d5c$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $1ea8880f4e4e0d5c$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $55a5ca433915f5db$export$866c1d07a1ac2ab)()) return (0, $40a5a3f1abcc3cdb$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $14d9938e6f21d101$export$ff43f99925d7366b)(easing)) return $1ea8880f4e4e0d5c$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$1ea8880f4e4e0d5c$export$916ea73bcd3a6030(segmentEasing, duration) || $1ea8880f4e4e0d5c$export$2cf569f5e2221176.easeOut);
    else return $1ea8880f4e4e0d5c$export$2cf569f5e2221176[easing];
}


function $57d250ae8c2a8823$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $1ea8880f4e4e0d5c$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $0365e8cc62acbaff$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}





const $0f9b8eb08505935d$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $126e79f287d0cb5d$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9d5b900ea23f213e$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9d5b900ea23f213e$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $9d5b900ea23f213e$var$requiresPregeneratedKeyframes(options) {
    return (0, $e953c71f76f79b0f$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $1ea8880f4e4e0d5c$export$fcdd8f3f2160beda)(options.ease);
}
function $9d5b900ea23f213e$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $41a172794ed2cf55$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $9d5b900ea23f213e$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $9d5b900ea23f213e$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $9d5b900ea23f213e$var$sampleDelta,
        ease: "linear"
    };
}
const $9d5b900ea23f213e$var$unsupportedEasingFunctions = {
    anticipate: $9dcd65fff942a904$export$6b0af63b873d419e,
    backInOut: $92e5ce9e557d421b$export$ddc5fd596f6c71b2,
    circInOut: $14c56a73b42f85a3$export$30d3455eee55bed5
};
function $9d5b900ea23f213e$var$isUnsupportedEase(key) {
    return key in $9d5b900ea23f213e$var$unsupportedEasingFunctions;
}
class $9d5b900ea23f213e$export$2a45abb4e6513325 extends (0, $70769c28f13a896e$export$d1e4f34b9c2550c1) {
    initPlayback(keyframes, finalKeyframe) {
        var _a;
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!((_a = motionValue.owner) === null || _a === void 0 ? void 0 : _a.current)) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $55a5ca433915f5db$export$866c1d07a1ac2ab)() && $9d5b900ea23f213e$var$isUnsupportedEase(ease)) ease = $9d5b900ea23f213e$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($9d5b900ea23f213e$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $9d5b900ea23f213e$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $57d250ae8c2a8823$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $0365e8cc62acbaff$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $898d86da5e16a777$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $586d62dcd567427e$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $0365e8cc62acbaff$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $586d62dcd567427e$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $41a172794ed2cf55$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $9d5b900ea23f213e$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $9d5b900ea23f213e$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        return (0, $0f9b8eb08505935d$export$51ea9b46fb7a8c5d)() && name && (0, $8614f0f2d4b1c4f3$export$a27eefbd8fb5e404).has(name) && motionValue && motionValue.owner && motionValue.owner.current instanceof HTMLElement && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !motionValue.owner.getProps().onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $30d54e4a4fa013cf$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
}




const $75489825f2e4ed1d$export$20d68f04f30763a5 = (0, $126e79f287d0cb5d$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $5ecb99f0dadd77fe$export$c1e41718f71efe41 {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $75489825f2e4ed1d$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $2968bc4cbdcade95$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $4b50812d6d66c8b3$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $a03b6c3e80f89fb5$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $2968bc4cbdcade95$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $9b331d1887e7c201$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $a02175ba83759089$export$888a3d84909f9e3d).current || (0, $77ec403776d67d5f$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $898d86da5e16a777$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $acdac96acb68981d$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $5ecb99f0dadd77fe$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $9d5b900ea23f213e$export$2a45abb4e6513325).supports(options)) return new (0, $9d5b900ea23f213e$export$2a45abb4e6513325)(options);
        else return new (0, $41a172794ed2cf55$export$fd98d9cca67a58bc)(options);
    };



const $c54e4fffade8783d$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $c54e4fffade8783d$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $2bdc4589d20a7f85$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $aecc3bef04e70b5b$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $aecc3bef04e70b5b$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $aecc3bef04e70b5b$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $f9840d42d34a21b8$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $aecc3bef04e70b5b$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $aecc3bef04e70b5b$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}






/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA = 30;
const $3ab7e3f68323748d$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $3ab7e3f68323748d$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $3ab7e3f68323748d$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $3ab7e3f68323748d$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9840d42d34a21b8$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $acdac96acb68981d$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($3ab7e3f68323748d$export$67fcd818a264039d.current) $3ab7e3f68323748d$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $3ab7e3f68323748d$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $8c9e7236f0507fd5$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.11.11";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $3ab7e3f68323748d$export$ce8bdc721e76545f(init, options) {
    return new $3ab7e3f68323748d$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ed22d17dd15df1fe$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $3ab7e3f68323748d$export$ce8bdc721e76545f)(value));
}
function $ed22d17dd15df1fe$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $27459a0b09d3428c$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $c54e4fffade8783d$export$5485128c47bd48bb)(target[key]);
        $ed22d17dd15df1fe$var$setMotionValue(visualElement, key, value);
    }
}



/**
 * Convert camelCase to dash-case properties.
 */ const $8aa347481fb6b490$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $525b989f99c32b36$export$ed7b8fa9dbf0105d = "framerAppearId";
const $525b989f99c32b36$export$8592e1c077c890a6 = "data-" + (0, $8aa347481fb6b490$export$9fd24a634729c672)($525b989f99c32b36$export$ed7b8fa9dbf0105d);


function $c3da4d6612ac58d3$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $525b989f99c32b36$export$8592e1c077c890a6];
}


const $afd19ce5c54b9648$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $355931738376f294$export$98397f3adbf6259f(value) {
    return Boolean((0, $afd19ce5c54b9648$export$605d60a2578142d3)(value) && value.add);
}


function $34a1e6a1b73b3167$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $355931738376f294$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $4cc3664aaaf403fe$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $4cc3664aaaf403fe$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $4cc3664aaaf403fe$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $a03b6c3e80f89fb5$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $c3da4d6612ac58d3$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $acdac96acb68981d$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $34a1e6a1b73b3167$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $4b50812d6d66c8b3$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $acdac96acb68981d$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $ed22d17dd15df1fe$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $f68947d55150a093$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $27459a0b09d3428c$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $4cc3664aaaf403fe$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f68947d55150a093$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f68947d55150a093$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($f68947d55150a093$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($f68947d55150a093$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $f68947d55150a093$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $951caf5829a5f65c$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f68947d55150a093$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f68947d55150a093$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $27459a0b09d3428c$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $4cc3664aaaf403fe$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $1d057a3ddae45d79$var$numVariantProps = (0, $6d707c97a45dfb5d$export$1405a65085f40b9).length;
function $1d057a3ddae45d79$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $1d057a3ddae45d79$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $1d057a3ddae45d79$var$numVariantProps; i++){
        const name = (0, $6d707c97a45dfb5d$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $b50d6f2544a29792$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $d0e9c38c2e7d04fb$var$reversePriorityOrder = [
    ...(0, $6d707c97a45dfb5d$export$16e45afcc206d3a8)
].reverse();
const $d0e9c38c2e7d04fb$var$numAnimationTypes = (0, $6d707c97a45dfb5d$export$16e45afcc206d3a8).length;
function $d0e9c38c2e7d04fb$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $951caf5829a5f65c$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $d0e9c38c2e7d04fb$export$bb53502b7a672aa8(visualElement) {
    let animate = $d0e9c38c2e7d04fb$var$animateList(visualElement);
    let state = $d0e9c38c2e7d04fb$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $27459a0b09d3428c$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $1d057a3ddae45d79$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $d0e9c38c2e7d04fb$var$numAnimationTypes; i++){
            const type = $d0e9c38c2e7d04fb$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $b50d6f2544a29792$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $5f57867e26bb4108$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $d0e9c38c2e7d04fb$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $2bdc4589d20a7f85$export$9153ad4c4999f4a0)(next) && (0, $2bdc4589d20a7f85$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $a156fe7855a1d3a0$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $d0e9c38c2e7d04fb$var$createState();
            isInitialRender = true;
        }
    };
}
function $d0e9c38c2e7d04fb$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $a156fe7855a1d3a0$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $d0e9c38c2e7d04fb$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $d0e9c38c2e7d04fb$var$createState() {
    return {
        animate: $d0e9c38c2e7d04fb$var$createTypeState(true),
        whileInView: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileHover: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileTap: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileDrag: $d0e9c38c2e7d04fb$var$createTypeState(),
        whileFocus: $d0e9c38c2e7d04fb$var$createTypeState(),
        exit: $d0e9c38c2e7d04fb$var$createTypeState()
    };
}


class $f393de8400f417d7$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}


class $e12a2d5689ea866d$export$b45b3fe5caabdca extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $5f57867e26bb4108$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $d0e9c38c2e7d04fb$export$bb53502b7a672aa8)(node));
    }
}



let $53c97979850eee6d$var$id = 0;
class $53c97979850eee6d$export$4989d1eb6104cc6c extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $53c97979850eee6d$var$id++;
    }
}


const $2f2fe01eb9524666$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $e12a2d5689ea866d$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $53c97979850eee6d$export$4989d1eb6104cc6c)
    }
};





const $03138406f951404f$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $3973bb66157269f5$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[`${pointType}X`],
            y: event[`${pointType}Y`]
        }
    };
}
const $3973bb66157269f5$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $03138406f951404f$export$a4cf9c8a4b063a6e)(event) && handler(event, $3973bb66157269f5$export$12f84bb882d06e1a(event));
};



function $372c30b69d6f2c21$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $519633bd86d65117$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(target, eventName, (0, $3973bb66157269f5$export$c404e80f92c98d29)(handler), options);
}



const $3a80065f413f90ab$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $3a80065f413f90ab$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $3a80065f413f90ab$export$9f17032d917177de(a.x, b.x);
    const yDelta = $3a80065f413f90ab$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $ef854c4580045766$export$d9c66232c9c4689c {
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $ef854c4580045766$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $3a80065f413f90ab$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $acdac96acb68981d$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $ef854c4580045766$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $acdac96acb68981d$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $ef854c4580045766$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $ef854c4580045766$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $03138406f951404f$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $3973bb66157269f5$export$12f84bb882d06e1a)(event);
        const initialInfo = $ef854c4580045766$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $acdac96acb68981d$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $ef854c4580045766$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $af408ce9d401e7be$export$a4627e546088548d)((0, $519633bd86d65117$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $519633bd86d65117$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $519633bd86d65117$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
}
function $ef854c4580045766$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $ef854c4580045766$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $ef854c4580045766$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $ef854c4580045766$var$subtractPoint(point, $ef854c4580045766$var$lastDevicePoint(history)),
        offset: $ef854c4580045766$var$subtractPoint(point, $ef854c4580045766$var$startDevicePoint(history)),
        velocity: $ef854c4580045766$var$getVelocity(history, 0.1)
    };
}
function $ef854c4580045766$var$startDevicePoint(history) {
    return history[0];
}
function $ef854c4580045766$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $ef854c4580045766$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $ef854c4580045766$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $0f5094f72f1ac1b0$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $1fad98f38f0015a9$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $1fad98f38f0015a9$var$globalHorizontalLock = $1fad98f38f0015a9$export$518c5fc2dcb7974b("dragHorizontal");
const $1fad98f38f0015a9$var$globalVerticalLock = $1fad98f38f0015a9$export$518c5fc2dcb7974b("dragVertical");
function $1fad98f38f0015a9$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $1fad98f38f0015a9$var$globalVerticalLock();
    else if (drag === "x") lock = $1fad98f38f0015a9$var$globalHorizontalLock();
    else {
        const openHorizontal = $1fad98f38f0015a9$var$globalHorizontalLock();
        const openVertical = $1fad98f38f0015a9$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $1fad98f38f0015a9$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $1fad98f38f0015a9$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


function $fa1715e05876aeaf$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $ef13499fe6809d49$var$SCALE_PRECISION = 0.0001;
const $ef13499fe6809d49$var$SCALE_MIN = 1 - $ef13499fe6809d49$var$SCALE_PRECISION;
const $ef13499fe6809d49$var$SCALE_MAX = 1 + $ef13499fe6809d49$var$SCALE_PRECISION;
const $ef13499fe6809d49$var$TRANSLATE_PRECISION = 0.01;
const $ef13499fe6809d49$var$TRANSLATE_MIN = 0 - $ef13499fe6809d49$var$TRANSLATE_PRECISION;
const $ef13499fe6809d49$var$TRANSLATE_MAX = 0 + $ef13499fe6809d49$var$TRANSLATE_PRECISION;
function $ef13499fe6809d49$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $ef13499fe6809d49$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $ef13499fe6809d49$export$c1c127004b72a37(target) / $ef13499fe6809d49$export$c1c127004b72a37(source);
    delta.translate = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $ef13499fe6809d49$var$SCALE_MIN && delta.scale <= $ef13499fe6809d49$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $ef13499fe6809d49$var$TRANSLATE_MIN && delta.translate <= $ef13499fe6809d49$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $ef13499fe6809d49$export$c0d25e96fc67d310(delta, source, target, origin) {
    $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $ef13499fe6809d49$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $ef13499fe6809d49$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $ef13499fe6809d49$export$c1c127004b72a37(relative);
}
function $ef13499fe6809d49$export$426154f9d100f99(target, relative, parent) {
    $ef13499fe6809d49$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $ef13499fe6809d49$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $ef13499fe6809d49$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $ef13499fe6809d49$export$c1c127004b72a37(layout);
}
function $ef13499fe6809d49$export$2785bfcc929c5650(target, layout, parent) {
    $ef13499fe6809d49$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $ef13499fe6809d49$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $747d608f57b73033$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $747d608f57b73033$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $747d608f57b73033$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $747d608f57b73033$export$690c180aa5775042(layoutBox.x, left, right),
        y: $747d608f57b73033$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $747d608f57b73033$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $747d608f57b73033$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $747d608f57b73033$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $747d608f57b73033$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $747d608f57b73033$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $ef13499fe6809d49$export$c1c127004b72a37)(source);
    const targetLength = (0, $ef13499fe6809d49$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $12bda51f70c7265a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $12bda51f70c7265a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $747d608f57b73033$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $747d608f57b73033$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $747d608f57b73033$export$7c5eaef8f4723d22(dragElastic = $747d608f57b73033$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $747d608f57b73033$export$a3366d3bac43a742;
    return {
        x: $747d608f57b73033$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $747d608f57b73033$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $747d608f57b73033$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $747d608f57b73033$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $170bad49d6474b42$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $170bad49d6474b42$export$3d227df54007d73a = ()=>({
        x: $170bad49d6474b42$export$ff25708b37f72782(),
        y: $170bad49d6474b42$export$ff25708b37f72782()
    });
const $170bad49d6474b42$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $170bad49d6474b42$export$6459fc9e86be362e = ()=>({
        x: $170bad49d6474b42$export$6db76765312617ac(),
        y: $170bad49d6474b42$export$6db76765312617ac()
    });


function $7d553f96a693c19c$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $0d09a26902ac99cd$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $0d09a26902ac99cd$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $0d09a26902ac99cd$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $e6914cf5f005c58a$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $e6914cf5f005c58a$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$e6914cf5f005c58a$var$isIdentityScale(scale) || !$e6914cf5f005c58a$var$isIdentityScale(scaleX) || !$e6914cf5f005c58a$var$isIdentityScale(scaleY);
}
function $e6914cf5f005c58a$export$a545127cf1fbb600(values) {
    return $e6914cf5f005c58a$export$bdf30dca883ea463(values) || $e6914cf5f005c58a$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $e6914cf5f005c58a$export$bf80f5f8f4dc327f(values) {
    return $e6914cf5f005c58a$var$is2DTranslate(values.x) || $e6914cf5f005c58a$var$is2DTranslate(values.y);
}
function $e6914cf5f005c58a$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $9bd1f649500a03c5$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $9bd1f649500a03c5$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $9bd1f649500a03c5$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $9bd1f649500a03c5$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $9bd1f649500a03c5$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $9bd1f649500a03c5$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $9bd1f649500a03c5$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $9bd1f649500a03c5$export$d80074982803af5c(box, { x: x, y: y }) {
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $9bd1f649500a03c5$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $9bd1f649500a03c5$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $9bd1f649500a03c5$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $e6914cf5f005c58a$export$a545127cf1fbb600)(node.latestValues)) $9bd1f649500a03c5$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX && treeScale.x > $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MAX && treeScale.y > $9bd1f649500a03c5$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $9bd1f649500a03c5$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $9bd1f649500a03c5$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $9bd1f649500a03c5$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $9bd1f649500a03c5$export$58b16271041fbfb(box, transform) {
    $9bd1f649500a03c5$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $9bd1f649500a03c5$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $af396e08e7154fa7$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $0d09a26902ac99cd$export$d3955c6a8f65a36b)((0, $0d09a26902ac99cd$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $af396e08e7154fa7$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $af396e08e7154fa7$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/framer/motion/issues/2270
const $8cc2e4c5ec757f0a$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $1a101a2ea5c41299$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $1a101a2ea5c41299$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $3973bb66157269f5$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $1fad98f38f0015a9$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $a5596f9db4a91b91$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $ef13499fe6809d49$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $34a1e6a1b73b3167$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $1a101a2ea5c41299$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $ef854c4580045766$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $8cc2e4c5ec757f0a$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $747d608f57b73033$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $fa1715e05876aeaf$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $747d608f57b73033$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $747d608f57b73033$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $747d608f57b73033$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $fa1715e05876aeaf$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $bde5dfec70eede58$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $af396e08e7154fa7$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $747d608f57b73033$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $0d09a26902ac99cd$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $0d09a26902ac99cd$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $34a1e6a1b73b3167$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $4b50812d6d66c8b3$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $fa1715e05876aeaf$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $747d608f57b73033$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            if (!$1a101a2ea5c41299$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $1a101a2ea5c41299$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $519633bd86d65117$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $fa1715e05876aeaf$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $acdac96acb68981d$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $747d608f57b73033$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
}
function $1a101a2ea5c41299$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $1a101a2ea5c41299$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $df7139fffc0bd0da$export$5d97dc2872682820 extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $586d62dcd567427e$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $586d62dcd567427e$export$8793edee2d425525);
        this.removeListeners = (0, $586d62dcd567427e$export$8793edee2d425525);
        this.controls = new (0, $1a101a2ea5c41299$export$86bff71f18910307)(node);
    }
}








const $06e74a33ef2dab00$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $06e74a33ef2dab00$export$b4f8f1ee75ce5859 extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $ef854c4580045766$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $8cc2e4c5ec757f0a$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $06e74a33ef2dab00$var$asyncHandler(onPanSessionStart),
            onStart: $06e74a33ef2dab00$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $519633bd86d65117$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $586d62dcd567427e$export$8793edee2d425525);
    }
}



var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $713a31a7394b6900$export$2a8c16d82a0a0e26() {
    const context = (0, $eZVvM.useContext)((0, $530f496ded9f62d9$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $eZVvM.useId)();
    (0, $eZVvM.useEffect)(()=>register(id), []);
    const safeToRemove = (0, $eZVvM.useCallback)(()=>onExitComplete && onExitComplete(id), [
        id,
        onExitComplete
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $713a31a7394b6900$export$8249053f690ea39a() {
    return $713a31a7394b6900$export$ee27c052bca048fb((0, $eZVvM.useContext)((0, $530f496ded9f62d9$export$f224e4635b6f8ce2)));
}
function $713a31a7394b6900$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $e945ab81c792e439$export$da5f7b802957459a = (0, $eZVvM.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $8984818e8f2095fa$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $7250ef2cfea8923f$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $7250ef2cfea8923f$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $a5596f9db4a91b91$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $7250ef2cfea8923f$export$fafff692be55225d(latest, node.target.x);
        const y = $7250ef2cfea8923f$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $6a0d39815295fa9d$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $5470142997ed61da$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $5470142997ed61da$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $8e2ec80617e1ef23$export$91ddd985b97788d1 = {};
function $8e2ec80617e1ef23$export$de9e7791c71225fd(correctors) {
    Object.assign($8e2ec80617e1ef23$export$91ddd985b97788d1, correctors);
}



const { schedule: $4ec28bebfef34728$export$bb76eed83315504c, cancel: $4ec28bebfef34728$export$3252729004b8456e } = (0, $8779983df53b5129$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $ceff8b5500f61dba$var$MeasureLayoutWithContext extends (0, $eZVvM.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $8e2ec80617e1ef23$export$de9e7791c71225fd)($ceff8b5500f61dba$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $8984818e8f2095fa$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $4ec28bebfef34728$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $ceff8b5500f61dba$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $713a31a7394b6900$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $eZVvM.useContext)((0, $7e2e92a55d7a9c1e$export$a3579ca508007a95));
    return (0, $3pI8R.jsx)($ceff8b5500f61dba$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $eZVvM.useContext)((0, $e945ab81c792e439$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $ceff8b5500f61dba$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $7250ef2cfea8923f$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $7250ef2cfea8923f$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $7250ef2cfea8923f$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $7250ef2cfea8923f$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $7250ef2cfea8923f$export$5eafb6257a5844c),
    boxShadow: (0, $6a0d39815295fa9d$export$eb0bc629e74dcf8)
};








const $6115e7b48b87f673$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $6115e7b48b87f673$var$numBorders = $6115e7b48b87f673$var$borders.length;
const $6115e7b48b87f673$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $6115e7b48b87f673$var$isPx = (value)=>typeof value === "number" || (0, $a5596f9db4a91b91$export$91c0eda1d06bf008).test(value);
function $6115e7b48b87f673$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $6115e7b48b87f673$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $6115e7b48b87f673$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $6115e7b48b87f673$var$numBorders; i++){
        const borderLabel = `border${$6115e7b48b87f673$var$borders[i]}Radius`;
        let followRadius = $6115e7b48b87f673$var$getRadius(follow, borderLabel);
        let leadRadius = $6115e7b48b87f673$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $6115e7b48b87f673$var$isPx(followRadius) === $6115e7b48b87f673$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)($6115e7b48b87f673$var$asNumber(followRadius), $6115e7b48b87f673$var$asNumber(leadRadius), progress), 0);
            if ((0, $a5596f9db4a91b91$export$626336c2cd4b14de).test(leadRadius) || (0, $a5596f9db4a91b91$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $6115e7b48b87f673$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $6115e7b48b87f673$var$easeCrossfadeIn = /*@__PURE__*/ $6115e7b48b87f673$var$compress(0, 0.5, (0, $14c56a73b42f85a3$export$c8d67a19199d1a50));
const $6115e7b48b87f673$var$easeCrossfadeOut = /*@__PURE__*/ $6115e7b48b87f673$var$compress(0.5, 0.95, (0, $586d62dcd567427e$export$8793edee2d425525));
function $6115e7b48b87f673$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $12bda51f70c7265a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$c53fd88f45d77e4b(box, originBox) {
    $f69304d5afe27751$export$a0230ae482601ae8(box.x, originBox.x);
    $f69304d5afe27751$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f69304d5afe27751$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $dc5d198bbbf3edd7$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $9bd1f649500a03c5$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $9bd1f649500a03c5$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $dc5d198bbbf3edd7$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $a5596f9db4a91b91$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $dc5d198bbbf3edd7$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $dc5d198bbbf3edd7$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $dc5d198bbbf3edd7$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $dc5d198bbbf3edd7$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $dc5d198bbbf3edd7$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $dc5d198bbbf3edd7$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(box.x, transforms, $dc5d198bbbf3edd7$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $dc5d198bbbf3edd7$export$42b76f1d0d16d5b(box.y, transforms, $dc5d198bbbf3edd7$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $886bcb20f3366154$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $886bcb20f3366154$export$a7ec7642fe550fb6(delta) {
    return $886bcb20f3366154$var$isAxisDeltaZero(delta.x) && $886bcb20f3366154$var$isAxisDeltaZero(delta.y);
}
function $886bcb20f3366154$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $886bcb20f3366154$export$8d5cf76bb7daff09(a, b) {
    return $886bcb20f3366154$export$7a9a6f114ddd0fdb(a.x, b.x) && $886bcb20f3366154$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $886bcb20f3366154$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $886bcb20f3366154$export$ef641b782d85522(a, b) {
    return $886bcb20f3366154$export$22adf28bfca1c186(a.x, b.x) && $886bcb20f3366154$export$22adf28bfca1c186(a.y, b.y);
}
function $886bcb20f3366154$export$c5706146bc63213(box) {
    return (0, $ef13499fe6809d49$export$c1c127004b72a37)(box.x) / (0, $ef13499fe6809d49$export$c1c127004b72a37)(box.y);
}
function $886bcb20f3366154$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $e5b4fbacfb22473f$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $aecc3bef04e70b5b$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $aecc3bef04e70b5b$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}



function $3650b320a42adb91$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $f9679643622f85f4$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $955760a84a2f4a81$export$1465d17e3de78a96 {
    add(child) {
        (0, $aecc3bef04e70b5b$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $aecc3bef04e70b5b$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $f9679643622f85f4$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}




/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $53c337dee8f3fdb5$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $afd19ce5c54b9648$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $c54e4fffade8783d$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






/**
 * Timeout defined in ms
 */ function $76504413525f8d84$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $acdac96acb68981d$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $acdac96acb68981d$export$ec99c0ef4978dccb)(checkElapsed);
}
function $76504413525f8d84$export$fcd451ca460f8a2a(callback, timeout) {
    return $76504413525f8d84$export$1391212d75b2ee65(callback, (0, $0f5094f72f1ac1b0$export$fc3e7e8557f8c8c7)(timeout));
}



function $6b7ef932b26b3539$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $34d9db4f3fd363f3$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $afd19ce5c54b9648$export$605d60a2578142d3)(value) ? value : (0, $3ab7e3f68323748d$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $4b50812d6d66c8b3$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}









const $58387390232a1cd0$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $58387390232a1cd0$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $58387390232a1cd0$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $58387390232a1cd0$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $58387390232a1cd0$var$animationTarget = 1000;
let $58387390232a1cd0$var$id = 0;
function $58387390232a1cd0$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $c3da4d6612ac58d3$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $acdac96acb68981d$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $58387390232a1cd0$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $f9840d42d34a21b8$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $6b7ef932b26b3539$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $76504413525f8d84$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $8984818e8f2095fa$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $8984818e8f2095fa$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($58387390232a1cd0$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $58387390232a1cd0$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $886bcb20f3366154$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $a03b6c3e80f89fb5$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $58387390232a1cd0$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($58387390232a1cd0$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $58387390232a1cd0$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($58387390232a1cd0$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($58387390232a1cd0$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($58387390232a1cd0$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($58387390232a1cd0$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($58387390232a1cd0$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
            (0, $acdac96acb68981d$export$fff89137e9e818ce).delta = (0, $922cbf6b96b336a1$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp);
            (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp = now;
            (0, $acdac96acb68981d$export$fff89137e9e818ce).isProcessing = true;
            (0, $acdac96acb68981d$export$1811c3a7e3af92f0).update.process((0, $acdac96acb68981d$export$fff89137e9e818ce));
            (0, $acdac96acb68981d$export$1811c3a7e3af92f0).preRender.process((0, $acdac96acb68981d$export$fff89137e9e818ce));
            (0, $acdac96acb68981d$export$1811c3a7e3af92f0).render.process((0, $acdac96acb68981d$export$fff89137e9e818ce));
            (0, $acdac96acb68981d$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $4ec28bebfef34728$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($58387390232a1cd0$var$clearSnapshot);
            this.sharedNodes.forEach($58387390232a1cd0$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $acdac96acb68981d$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $886bcb20f3366154$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $e6914cf5f005c58a$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $58387390232a1cd0$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($58387390232a1cd0$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $9bd1f649500a03c5$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $9bd1f649500a03c5$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $e6914cf5f005c58a$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $9bd1f649500a03c5$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $e6914cf5f005c58a$export$a545127cf1fbb600)(this.latestValues)) (0, $9bd1f649500a03c5$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $e6914cf5f005c58a$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $e6914cf5f005c58a$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $dc5d198bbbf3edd7$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $e6914cf5f005c58a$export$a545127cf1fbb600)(this.latestValues)) (0, $dc5d198bbbf3edd7$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    (0, $ef13499fe6809d49$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $ef13499fe6809d49$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $9bd1f649500a03c5$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    (0, $ef13499fe6809d49$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $e6914cf5f005c58a$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $e6914cf5f005c58a$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $acdac96acb68981d$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $9bd1f649500a03c5$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $f69304d5afe27751$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $f69304d5afe27751$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $ef13499fe6809d49$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $886bcb20f3366154$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $886bcb20f3366154$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $170bad49d6474b42$export$3d227df54007d73a)();
            this.projectionDelta = (0, $170bad49d6474b42$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $170bad49d6474b42$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $170bad49d6474b42$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($58387390232a1cd0$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $58387390232a1cd0$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $58387390232a1cd0$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $ef13499fe6809d49$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $58387390232a1cd0$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $886bcb20f3366154$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $6115e7b48b87f673$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $acdac96acb68981d$export$2cef06c20297c17d).update(()=>{
                (0, $8984818e8f2095fa$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $34d9db4f3fd363f3$export$335a17c977067b99)(0, $58387390232a1cd0$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($58387390232a1cd0$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $58387390232a1cd0$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                const xLength = (0, $ef13499fe6809d49$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $ef13499fe6809d49$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $f69304d5afe27751$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $9bd1f649500a03c5$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $ef13499fe6809d49$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $e5b4fbacfb22473f$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $58387390232a1cd0$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $58387390232a1cd0$var$transformAxes.length; i++){
                $58387390232a1cd0$var$resetDistortingTransform(`rotate${$58387390232a1cd0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $58387390232a1cd0$var$resetDistortingTransform(`skew${$58387390232a1cd0$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $58387390232a1cd0$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $53c337dee8f3fdb5$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $53c337dee8f3fdb5$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $e6914cf5f005c58a$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $3650b320a42adb91$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $8e2ec80617e1ef23$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $8e2ec80617e1ef23$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $53c337dee8f3fdb5$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($58387390232a1cd0$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $58387390232a1cd0$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.totalNodes = $58387390232a1cd0$var$metrics.resolvedTargetDeltas = $58387390232a1cd0$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($58387390232a1cd0$export$131f2f0cc5fe9609);
                this.nodes.forEach($58387390232a1cd0$var$resolveTargetDelta);
                this.nodes.forEach($58387390232a1cd0$var$calcProjection);
                this.nodes.forEach($58387390232a1cd0$export$c2664f37bc951031);
                if ($58387390232a1cd0$var$isDebug) window.MotionDebug.record($58387390232a1cd0$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $955760a84a2f4a81$export$1465d17e3de78a96)();
        }
    };
}
function $58387390232a1cd0$var$updateLayout(node) {
    node.updateLayout();
}
function $58387390232a1cd0$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ef13499fe6809d49$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($58387390232a1cd0$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $7d553f96a693c19c$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $ef13499fe6809d49$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $170bad49d6474b42$export$3d227df54007d73a)();
        (0, $ef13499fe6809d49$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $170bad49d6474b42$export$3d227df54007d73a)();
        if (isShared) (0, $ef13499fe6809d49$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $ef13499fe6809d49$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $886bcb20f3366154$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    (0, $ef13499fe6809d49$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $170bad49d6474b42$export$6459fc9e86be362e)();
                    (0, $ef13499fe6809d49$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $886bcb20f3366154$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $58387390232a1cd0$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($58387390232a1cd0$var$isDebug) $58387390232a1cd0$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $58387390232a1cd0$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $58387390232a1cd0$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $58387390232a1cd0$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $58387390232a1cd0$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $58387390232a1cd0$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $58387390232a1cd0$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $58387390232a1cd0$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $58387390232a1cd0$var$calcProjection(node) {
    node.calcProjection();
}
function $58387390232a1cd0$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $58387390232a1cd0$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $58387390232a1cd0$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $58387390232a1cd0$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $443836d22b4ddf64$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $58387390232a1cd0$export$6ffd3e6ae339a132(output, from, to, p) {
    $58387390232a1cd0$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $58387390232a1cd0$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $58387390232a1cd0$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $58387390232a1cd0$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $58387390232a1cd0$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $58387390232a1cd0$var$roundPoint = $58387390232a1cd0$var$userAgentContains("applewebkit/") && !$58387390232a1cd0$var$userAgentContains("chrome/") ? Math.round : (0, $586d62dcd567427e$export$8793edee2d425525);
function $58387390232a1cd0$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $58387390232a1cd0$var$roundPoint(axis.min);
    axis.max = $58387390232a1cd0$var$roundPoint(axis.max);
}
function $58387390232a1cd0$var$roundBox(box) {
    $58387390232a1cd0$var$roundAxis(box.x);
    $58387390232a1cd0$var$roundAxis(box.y);
}
function $58387390232a1cd0$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $ef13499fe6809d49$export$28d0384c4b79bde2)((0, $886bcb20f3366154$export$c5706146bc63213)(snapshot), (0, $886bcb20f3366154$export$c5706146bc63213)(layout), 0.2);
}
function $58387390232a1cd0$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $f31e67b7be9ea466$export$2d029a49a09b6177 = (0, $58387390232a1cd0$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $3503f60faeb40f4f$export$b91509fcf893b648 = {
    current: undefined
};
const $3503f60faeb40f4f$export$b61a9eb3dbde8858 = (0, $58387390232a1cd0$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$3503f60faeb40f4f$export$b91509fcf893b648.current) {
            const documentNode = new (0, $f31e67b7be9ea466$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $3503f60faeb40f4f$export$b91509fcf893b648.current = documentNode;
        }
        return $3503f60faeb40f4f$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $f61e96ba32376203$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $06e74a33ef2dab00$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $df7139fffc0bd0da$export$5d97dc2872682820),
        ProjectionNode: (0, $3503f60faeb40f4f$export$b61a9eb3dbde8858),
        MeasureLayout: $ceff8b5500f61dba$export$779f5fb01ad751cd
    }
};







function $43173942d5616c32$var$addHoverEvent(node, isActive) {
    const eventName = isActive ? "pointerenter" : "pointerleave";
    const callbackName = isActive ? "onHoverStart" : "onHoverEnd";
    const handleEvent = (event, info)=>{
        if (event.pointerType === "touch" || (0, $1fad98f38f0015a9$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        const callback = props[callbackName];
        if (callback) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>callback(event, info));
    };
    return (0, $519633bd86d65117$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $43173942d5616c32$export$93a81ea037eac456 extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $af408ce9d401e7be$export$a4627e546088548d)($43173942d5616c32$var$addHoverEvent(this.node, true), $43173942d5616c32$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $8ba2e2c9068ea11a$export$d4826db40d47595b extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $af408ce9d401e7be$export$a4627e546088548d)((0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $b0540c4ff22b990c$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $b0540c4ff22b990c$export$e841ada32ff745b(parent, child.parentElement);
};




function $e79daae17b0515ea$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $3973bb66157269f5$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $e79daae17b0515ea$export$f026abdbba7f0c9e extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $1fad98f38f0015a9$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $519633bd86d65117$export$fcff2e64e6676b81)(props.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $af408ce9d401e7be$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $586d62dcd567427e$export$8793edee2d425525);
        this.removeEndListeners = (0, $586d62dcd567427e$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $586d62dcd567427e$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            if (this.isPressing) return;
            this.removeEndListeners();
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel, globalTapTarget: globalTapTarget } = this.node.getProps();
                /**
                 * We only count this as a tap gesture if the event.target is the same
                 * as, or a child of, this component's element
                 */ const handler = !globalTapTarget && !(0, $b0540c4ff22b990c$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel : onTap;
                if (handler) (0, $acdac96acb68981d$export$2cef06c20297c17d).update(()=>handler(endEvent, endInfo));
            };
            const removePointerUpListener = (0, $519633bd86d65117$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $519633bd86d65117$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $af408ce9d401e7be$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $e79daae17b0515ea$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $acdac96acb68981d$export$2cef06c20297c17d).postRender(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $e79daae17b0515ea$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $e79daae17b0515ea$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $372c30b69d6f2c21$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $af408ce9d401e7be$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $65e6f67a48960f82$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $65e6f67a48960f82$var$observers = new WeakMap();
const $65e6f67a48960f82$var$fireObserverCallback = (entry)=>{
    const callback = $65e6f67a48960f82$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $65e6f67a48960f82$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($65e6f67a48960f82$var$fireObserverCallback);
};
function $65e6f67a48960f82$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$65e6f67a48960f82$var$observers.has(lookupRoot)) $65e6f67a48960f82$var$observers.set(lookupRoot, {});
    const rootObservers = $65e6f67a48960f82$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($65e6f67a48960f82$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $65e6f67a48960f82$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $65e6f67a48960f82$var$initIntersectionObserver(options);
    $65e6f67a48960f82$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $65e6f67a48960f82$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $1147643d182545be$var$thresholdNames = {
    some: 0,
    all: 1
};
class $1147643d182545be$export$150851c8cc2f0c72 extends (0, $f393de8400f417d7$export$6e91cf7616333d5) {
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $1147643d182545be$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $65e6f67a48960f82$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($1147643d182545be$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $1147643d182545be$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $dadb9870f108e4b7$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $1147643d182545be$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $e79daae17b0515ea$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $8ba2e2c9068ea11a$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $43173942d5616c32$export$93a81ea037eac456)
    }
};




const $74b97b9c8ba46a5b$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $3503f60faeb40f4f$export$b61a9eb3dbde8858),
        MeasureLayout: $ceff8b5500f61dba$export$779f5fb01ad751cd
    }
};



var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");


var $eZVvM = parcelRequire("eZVvM");
"use client";
const $8416e26aea05018d$export$2285bbca2c666415 = (0, $eZVvM.createContext)({});



var $eZVvM = parcelRequire("eZVvM");




var $eZVvM = parcelRequire("eZVvM");
"use client";
const $4b00cbb57ffac2ad$export$40f10139ecf1f171 = (0, $eZVvM.createContext)({
    strict: false
});







function $26537fed9b9cd0d9$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $eZVvM.useContext)((0, $8416e26aea05018d$export$2285bbca2c666415));
    const lazyContext = (0, $eZVvM.useContext)((0, $4b00cbb57ffac2ad$export$40f10139ecf1f171));
    const presenceContext = (0, $eZVvM.useContext)((0, $530f496ded9f62d9$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $eZVvM.useContext)((0, $2dbc4737509c69cd$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $eZVvM.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $eZVvM.useContext)((0, $e945ab81c792e439$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $26537fed9b9cd0d9$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $eZVvM.useRef)(false);
    (0, $eZVvM.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $525b989f99c32b36$export$8592e1c077c890a6];
    const wantsHandoff = (0, $eZVvM.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $e44af1c94b39ef8b$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $4ec28bebfef34728$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $eZVvM.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $26537fed9b9cd0d9$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $fa1715e05876aeaf$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $26537fed9b9cd0d9$var$getClosestProjectingNode(visualElement.parent);
}



var $eZVvM = parcelRequire("eZVvM");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $868ea6e685ff4b28$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $eZVvM.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $fa1715e05876aeaf$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $eZVvM = parcelRequire("eZVvM");





function $2fc988fc3932ede6$export$4b3c3bd8d910d78d(props) {
    return (0, $5f57867e26bb4108$export$aa71198ceeaf53ce)(props.animate) || (0, $6d707c97a45dfb5d$export$1405a65085f40b9).some((name)=>(0, $b50d6f2544a29792$export$720b90e312cea233)(props[name]));
}
function $2fc988fc3932ede6$export$ce46fa4165cdec40(props) {
    return Boolean($2fc988fc3932ede6$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $91578f775d616319$export$12fc32fc096a04a3(props, context) {
    if ((0, $2fc988fc3932ede6$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $b50d6f2544a29792$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b50d6f2544a29792$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $2b4c9db25053aff3$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $91578f775d616319$export$12fc32fc096a04a3)(props, (0, $eZVvM.useContext)((0, $8416e26aea05018d$export$2285bbca2c666415)));
    return (0, $eZVvM.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $2b4c9db25053aff3$var$variantLabelsAsDependency(initial),
        $2b4c9db25053aff3$var$variantLabelsAsDependency(animate)
    ]);
}
function $2b4c9db25053aff3$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $7e4e689c8cf2db0f$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $7e4e689c8cf2db0f$export$65570e08d843624d = {};
for(const key in $7e4e689c8cf2db0f$var$featureProps)$7e4e689c8cf2db0f$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$7e4e689c8cf2db0f$var$featureProps[key].some((name)=>!!props[name])
};


function $a7d5fd5fe62217c2$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $7e4e689c8cf2db0f$export$65570e08d843624d)[key] = {
        ...(0, $7e4e689c8cf2db0f$export$65570e08d843624d)[key],
        ...features[key]
    };
}





const $bab999e721cfef49$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");




"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $432e5fbfa76001e9$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $a7d5fd5fe62217c2$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $eZVvM.useContext)((0, $2dbc4737509c69cd$export$22a697fb29aac98d)),
            ...props,
            layoutId: $432e5fbfa76001e9$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $2b4c9db25053aff3$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $be55fc6f5082c859$export$4e09c449d6c407f7)) {
            $432e5fbfa76001e9$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $432e5fbfa76001e9$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $26537fed9b9cd0d9$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $3pI8R.jsxs)((0, $8416e26aea05018d$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $3pI8R.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $868ea6e685ff4b28$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    const ForwardRefMotionComponent = (0, $eZVvM.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $bab999e721cfef49$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $432e5fbfa76001e9$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $eZVvM.useContext)((0, $7e2e92a55d7a9c1e$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $432e5fbfa76001e9$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $eZVvM.useContext)((0, $4b00cbb57ffac2ad$export$40f10139ecf1f171)).strict;
}
function $432e5fbfa76001e9$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $7e4e689c8cf2db0f$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $417e8ab9c81f2f0c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $7a25186e874ea0c4$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $417e8ab9c81f2f0c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



function $4b00b30c458e95a5$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $06bd8852f57731ef$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $1f21ae4b02cd1f42$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $4b00b30c458e95a5$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $06bd8852f57731ef$export$28931db5d57958e5).has(key) ? (0, $8aa347481fb6b490$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $80826fc63953baa9$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $8e2ec80617e1ef23$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $aad167df34d77474$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $afd19ce5c54b9648$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $afd19ce5c54b9648$export$605d60a2578142d3)(prevProps.style[key]) || (0, $80826fc63953baa9$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}



function $168db84468a1c40a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $aad167df34d77474$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $afd19ce5c54b9648$export$605d60a2578142d3)(props[key]) || (0, $afd19ce5c54b9648$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $f6b89e753c7819bf$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $eZVvM = parcelRequire("eZVvM");







function $6a88e97517bacfe1$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $6a88e97517bacfe1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $6a88e97517bacfe1$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $eZVvM.useContext)((0, $8416e26aea05018d$export$2285bbca2c666415));
        const presenceContext = (0, $eZVvM.useContext)((0, $530f496ded9f62d9$export$f224e4635b6f8ce2));
        const make = ()=>$6a88e97517bacfe1$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $75b40fe88a41e69d$export$fe4300aa8eebea86)(make);
    };
function $6a88e97517bacfe1$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $53c337dee8f3fdb5$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $2fc988fc3932ede6$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $2fc988fc3932ede6$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $5f57867e26bb4108$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $cefff5a56c58fb78$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}


const $e58ad7e50bcadcc4$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $74bf7a692303d66e$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $e58ad7e50bcadcc4$export$8940b483cf52eeda)(),
        attrs: {}
    });



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $0a54f0d93dc3dd55$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $bc45c17cb980b55d$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $bc45c17cb980b55d$var$numTransforms = (0, $f6b89e753c7819bf$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $bc45c17cb980b55d$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $bc45c17cb980b55d$var$numTransforms; i++){
        const key = (0, $f6b89e753c7819bf$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $0a54f0d93dc3dd55$export$453ef540a9a1bd6b)(value, (0, $5490b350038d9669$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $bc45c17cb980b55d$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $16e537b6cc739ae9$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $ebebb008c5329c80$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $0a54f0d93dc3dd55$export$453ef540a9a1bd6b)(value, (0, $5490b350038d9669$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $bc45c17cb980b55d$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $2013b4939d3fefab$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $a5596f9db4a91b91$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $2013b4939d3fefab$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $2013b4939d3fefab$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $2013b4939d3fefab$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $f03eba8d5cf6fce6$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $f03eba8d5cf6fce6$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $f03eba8d5cf6fce6$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $f03eba8d5cf6fce6$var$dashKeys : $f03eba8d5cf6fce6$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $a5596f9db4a91b91$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $a5596f9db4a91b91$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $a5596f9db4a91b91$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $a15ae55154733086$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $16e537b6cc739ae9$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $2013b4939d3fefab$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $f03eba8d5cf6fce6$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $c3b8eaab2ba22eae$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



const $4cabf9b934404f74$export$44dabd3fae512e85 = {
    useVisualState: (0, $6a88e97517bacfe1$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $168db84468a1c40a$export$16da615486abaa45),
        createRenderState: (0, $74bf7a692303d66e$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            (0, $acdac96acb68981d$export$2cef06c20297c17d).read(()=>{
                try {
                    renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
                } catch (e) {
                    // Most likely trying to measure an unrendered element under Firefox
                    renderState.dimensions = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };
                }
            });
            (0, $acdac96acb68981d$export$2cef06c20297c17d).render(()=>{
                (0, $a15ae55154733086$export$5475d24f125d7053)(renderState, latestValues, (0, $c3b8eaab2ba22eae$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
                (0, $1f21ae4b02cd1f42$export$c5f8399d19a7394b)(instance, renderState);
            });
        }
    })
};





const $df0b984375ed65d2$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $6a88e97517bacfe1$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $aad167df34d77474$export$16da615486abaa45,
        createRenderState: (0, $e58ad7e50bcadcc4$export$8940b483cf52eeda)
    })
};



var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");




function $22929543408d6d1e$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $afd19ce5c54b9648$export$605d60a2578142d3)(source[key]) && !(0, $80826fc63953baa9$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $22929543408d6d1e$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $eZVvM.useMemo)(()=>{
        const state = (0, $e58ad7e50bcadcc4$export$8940b483cf52eeda)();
        (0, $16e537b6cc739ae9$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $22929543408d6d1e$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $22929543408d6d1e$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $22929543408d6d1e$var$useInitialMotionValues(props, visualState));
    return style;
}
function $22929543408d6d1e$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $22929543408d6d1e$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $97455d6caac48ac2$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $97455d6caac48ac2$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $97455d6caac48ac2$var$validMotionProps.has(key);
}


let $16e3de3eec073e66$var$shouldForward = (key)=>!(0, $97455d6caac48ac2$export$2f9c46555243bf04)(key);
function $16e3de3eec073e66$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $16e3de3eec073e66$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $97455d6caac48ac2$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $16e3de3eec073e66$export$59d6962c470509a5((parcelRequire("hMzFq")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $16e3de3eec073e66$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($16e3de3eec073e66$var$shouldForward(key) || forwardMotionProps === true && (0, $97455d6caac48ac2$export$2f9c46555243bf04)(key) || !isDom && !(0, $97455d6caac48ac2$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $eZVvM = parcelRequire("eZVvM");




function $66f6100f03812232$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $eZVvM.useMemo)(()=>{
        const state = (0, $74bf7a692303d66e$export$41be8b43e1c4d4f9)();
        (0, $a15ae55154733086$export$5475d24f125d7053)(state, visualState, (0, $c3b8eaab2ba22eae$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $22929543408d6d1e$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $2dad14849bab4bc8$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $7a25186e874ea0c4$export$88f3fc2fd3766989)(Component) ? (0, $66f6100f03812232$export$84309c4f53cb1bd5) : (0, $22929543408d6d1e$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $16e3de3eec073e66$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $eZVvM.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $eZVvM.useMemo)(()=>(0, $afd19ce5c54b9648$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $eZVvM.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $2eed622a74005592$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $7a25186e874ea0c4$export$88f3fc2fd3766989)(Component) ? (0, $4cabf9b934404f74$export$44dabd3fae512e85) : (0, $df0b984375ed65d2$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $2dad14849bab4bc8$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $432e5fbfa76001e9$export$c3ad4a902bccc2d8)(config);
    };
}



var $eZVvM = parcelRequire("eZVvM");








// Does this device prefer reduced motion? Returns `null` server-side.
const $07afbcdb8c9ca91e$export$ff7706047246b98b = {
    current: null
};
const $07afbcdb8c9ca91e$export$6476d16e2fd2d0db = {
    current: false
};


function $0647d51418a7f392$export$ca9f41fb23dded3d() {
    (0, $07afbcdb8c9ca91e$export$6476d16e2fd2d0db).current = true;
    if (!(0, $be55fc6f5082c859$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $07afbcdb8c9ca91e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $07afbcdb8c9ca91e$export$ff7706047246b98b).current = false;
}











function $a35449f22ddb2410$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $afd19ce5c54b9648$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $afd19ce5c54b9648$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $3ab7e3f68323748d$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $3ab7e3f68323748d$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}





const $73d8d0321368e9d9$export$bc2a978a17abfdde = new WeakMap();









/**
 * A list of all ValueTypes
 */ const $ab10937ce4422643$var$valueTypes = [
    ...(0, $d88a34dd2eb7fed0$export$d176691c1998a1f5),
    (0, $8682243b2d1255c3$export$35e9368ef982300f),
    (0, $5470142997ed61da$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $ab10937ce4422643$export$950e7e59ea1ffed7 = (v)=>$ab10937ce4422643$var$valueTypes.find((0, $b11710ae4d65c274$export$6eae4d0a6a7ca7cd)(v));







const $febe57d551727e6e$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $febe57d551727e6e$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $73d8d0321368e9d9$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $07afbcdb8c9ca91e$export$6476d16e2fd2d0db).current) (0, $0647d51418a7f392$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $07afbcdb8c9ca91e$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $73d8d0321368e9d9$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $acdac96acb68981d$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $acdac96acb68981d$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $7e4e689c8cf2db0f$export$65570e08d843624d){
            const featureDefinition = (0, $7e4e689c8cf2db0f$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $170bad49d6474b42$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $febe57d551727e6e$var$propEventHandlers.length; i++){
            const key = $febe57d551727e6e$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $a35449f22ddb2410$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $3ab7e3f68323748d$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $bda2c785ae6c314a$export$65583ed5a868f2d9)(value) || (0, $cb9f01153b2a3d05$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $ab10937ce4422643$export$950e7e59ea1ffed7)(value) && (0, $5470142997ed61da$export$83a0e34f1302825b).test(target)) value = (0, $7ea9939be3c3d3fe$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $afd19ce5c54b9648$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $afd19ce5c54b9648$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $cefff5a56c58fb78$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $afd19ce5c54b9648$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $f9840d42d34a21b8$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $fe4a5825614f738f$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $7fbfc6b5a4b6f06f$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $acdac96acb68981d$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $2fc988fc3932ede6$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $2fc988fc3932ede6$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $afd19ce5c54b9648$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
}



class $7a60681320743b3d$export$e49735c2a366bdc7 extends (0, $febe57d551727e6e$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $30d54e4a4fa013cf$export$4983792d11b61017);
    }
}



function $6827870418fa71a4$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $6827870418fa71a4$export$23fea75b03ac16b3 extends (0, $7a60681320743b3d$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $21740e929035fdb6$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $6827870418fa71a4$export$3735103072e4a80(instance);
            const value = ((0, $ebebb008c5329c80$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $af396e08e7154fa7$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $16e537b6cc739ae9$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $aad167df34d77474$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $afd19ce5c54b9648$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $4b00b30c458e95a5$export$1a32bf6229c258c0);
    }
}












class $8cdbf68185ab9954$export$86bcdffbaf733d84 extends (0, $7a60681320743b3d$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $f6b89e753c7819bf$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $21740e929035fdb6$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $06bd8852f57731ef$export$28931db5d57958e5).has(key) ? (0, $8aa347481fb6b490$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $168db84468a1c40a$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $a15ae55154733086$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $1f21ae4b02cd1f42$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c3b8eaab2ba22eae$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $170bad49d6474b42$export$6459fc9e86be362e);
    }
}



const $71d1c7c53f513669$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $7a25186e874ea0c4$export$88f3fc2fd3766989)(Component) ? new (0, $8cdbf68185ab9954$export$86bcdffbaf733d84)(options) : new (0, $6827870418fa71a4$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $eZVvM.Fragment)
    });
};


const $9af8b63a91e66f97$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $2eed622a74005592$export$d86feac869a7f0d5)({
    ...(0, $2f2fe01eb9524666$export$7f9953c70dacfd7f),
    ...(0, $dadb9870f108e4b7$export$e5b72898e5a201f1),
    ...(0, $f61e96ba32376203$export$d7d5d435647ed5a0),
    ...(0, $74b97b9c8ba46a5b$export$b3219800bda33a1f)
}, (0, $71d1c7c53f513669$export$56ba0183203348f5));


const $d5f8329c0fec877c$export$e25e478948902b8b = /*@__PURE__*/ (0, $6d14c395f011340c$export$3af29c0efb268f04)((0, $9af8b63a91e66f97$export$46b7e4b9dc6110c3));


parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");









var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $b625618202e2da7b$var$useEnhancedEffect = typeof window !== "undefined" ? $eZVvM.useLayoutEffect : $eZVvM.useEffect;
var $b625618202e2da7b$export$2e2bcd8739ae039 = $b625618202e2da7b$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $7fad5769266b0294$var$useEventCallback(fn) {
    const ref = $eZVvM.useRef(fn);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $eZVvM.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $7fad5769266b0294$export$2e2bcd8739ae039 = $7fad5769266b0294$var$useEventCallback;


"use client";
var $11ca5a3145a6ac50$export$2e2bcd8739ae039 = (0, $7fad5769266b0294$export$2e2bcd8739ae039);



var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $336476351ccef725$var$UNINITIALIZED = {};
function $336476351ccef725$export$2e2bcd8739ae039(init, initArg) {
    const ref = $eZVvM.useRef($336476351ccef725$var$UNINITIALIZED);
    if (ref.current === $336476351ccef725$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $eZVvM = parcelRequire("eZVvM");
"use client";
const $7b1e513b9973bd82$var$EMPTY = [];
function $7b1e513b9973bd82$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $eZVvM.useEffect(fn, $7b1e513b9973bd82$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $dbc2a71359ae6439$export$786b4da70f00938b {
    static create() {
        return new $dbc2a71359ae6439$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $dbc2a71359ae6439$export$2e2bcd8739ae039() {
    const timeout = (0, $336476351ccef725$export$2e2bcd8739ae039)($dbc2a71359ae6439$export$786b4da70f00938b.create).current;
    (0, $7b1e513b9973bd82$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $cf5c6886a3f12002$var$hadKeyboardEvent = true;
let $cf5c6886a3f12002$var$hadFocusVisibleRecently = false;
const $cf5c6886a3f12002$var$hadFocusVisibleRecentlyTimeout = new (0, $dbc2a71359ae6439$export$786b4da70f00938b)();
const $cf5c6886a3f12002$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $cf5c6886a3f12002$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $cf5c6886a3f12002$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $cf5c6886a3f12002$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $cf5c6886a3f12002$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $cf5c6886a3f12002$var$handlePointerDown() {
    $cf5c6886a3f12002$var$hadKeyboardEvent = false;
}
function $cf5c6886a3f12002$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($cf5c6886a3f12002$var$hadFocusVisibleRecently) $cf5c6886a3f12002$var$hadKeyboardEvent = true;
    }
}
function $cf5c6886a3f12002$var$prepare(doc) {
    doc.addEventListener("keydown", $cf5c6886a3f12002$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $cf5c6886a3f12002$var$handleVisibilityChange, true);
}
function $cf5c6886a3f12002$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $cf5c6886a3f12002$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $cf5c6886a3f12002$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $cf5c6886a3f12002$var$handleVisibilityChange, true);
}
function $cf5c6886a3f12002$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $cf5c6886a3f12002$var$hadKeyboardEvent || $cf5c6886a3f12002$var$focusTriggersKeyboardModality(target);
}
function $cf5c6886a3f12002$export$2e2bcd8739ae039() {
    const ref = $eZVvM.useCallback((node)=>{
        if (node != null) $cf5c6886a3f12002$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $eZVvM.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $cf5c6886a3f12002$var$hadFocusVisibleRecently = true;
            $cf5c6886a3f12002$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $cf5c6886a3f12002$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($cf5c6886a3f12002$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $6a538cd1be632e86$export$2e2bcd8739ae039 = (0, $cf5c6886a3f12002$export$2e2bcd8739ae039);



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $3Vxa5 = parcelRequire("3Vxa5");



var $eZVvM = parcelRequire("eZVvM");


var $eZVvM = parcelRequire("eZVvM");
function $4fd9b26b177b9e61$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $eZVvM.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $eZVvM.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $4fd9b26b177b9e61$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $4fd9b26b177b9e61$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $4fd9b26b177b9e61$export$fa71e2345c31d7a2(props, onExited) {
    return $4fd9b26b177b9e61$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $4fd9b26b177b9e61$var$getProp(child, "appear", props),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", props),
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", props)
        });
    });
}
function $4fd9b26b177b9e61$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $4fd9b26b177b9e61$export$bbc8a025727ea824(nextProps.children);
    var children = $4fd9b26b177b9e61$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $eZVvM.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $eZVvM.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", nextProps),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $eZVvM.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $eZVvM.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $4fd9b26b177b9e61$var$getProp(child, "exit", nextProps),
            enter: $4fd9b26b177b9e61$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $955311a93601fb86$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $955311a93601fb86$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $955311a93601fb86$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $fb26d559f651f364$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $3Vxa5.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $4fd9b26b177b9e61$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $4fd9b26b177b9e61$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $4fd9b26b177b9e61$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $65o8X.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $7Z8DW.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $955311a93601fb86$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, $1dbe22997e33b48b$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Component);
$955311a93601fb86$var$TransitionGroup.propTypes = {};
$955311a93601fb86$var$TransitionGroup.defaultProps = $955311a93601fb86$var$defaultProps;
var $955311a93601fb86$export$2e2bcd8739ae039 = $955311a93601fb86$var$TransitionGroup;




var $aNuUP = parcelRequire("aNuUP");




var $eZVvM = parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $10956df88f5537e9$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $eZVvM.useState(false);
    const rippleClassName = (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $eZVvM.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
            className: childClassName
        })
    });
}
var $10956df88f5537e9$export$2e2bcd8739ae039 = $10956df88f5537e9$var$Ripple;




function $be89b43511df88e2$export$b464606f735ab902(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTouchRipple", slot);
}
const $be89b43511df88e2$var$touchRippleClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $be89b43511df88e2$export$2e2bcd8739ae039 = $be89b43511df88e2$var$touchRippleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $6e20985d142d5a66$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $6e20985d142d5a66$var$_ = (t)=>t, $6e20985d142d5a66$var$_t, $6e20985d142d5a66$var$_t2, $6e20985d142d5a66$var$_t3, $6e20985d142d5a66$var$_t4;
const $6e20985d142d5a66$var$DURATION = 550;
const $6e20985d142d5a66$export$95d0c9356b2231a3 = 80;
const $6e20985d142d5a66$var$enterKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t || ($6e20985d142d5a66$var$_t = $6e20985d142d5a66$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $6e20985d142d5a66$var$exitKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t2 || ($6e20985d142d5a66$var$_t2 = $6e20985d142d5a66$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $6e20985d142d5a66$var$pulsateKeyframe = (0, $aNuUP.keyframes)($6e20985d142d5a66$var$_t3 || ($6e20985d142d5a66$var$_t3 = $6e20985d142d5a66$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $6e20985d142d5a66$export$f6b7418508c72c25 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $6e20985d142d5a66$export$676cfe7b12693c4b = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $10956df88f5537e9$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($6e20985d142d5a66$var$_t4 || ($6e20985d142d5a66$var$_t4 = $6e20985d142d5a66$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $be89b43511df88e2$export$2e2bcd8739ae039).rippleVisible, $6e20985d142d5a66$var$enterKeyframe, $6e20985d142d5a66$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $be89b43511df88e2$export$2e2bcd8739ae039).child, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childLeaving, $6e20985d142d5a66$var$exitKeyframe, $6e20985d142d5a66$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childPulsate, $6e20985d142d5a66$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $6e20985d142d5a66$var$TouchRipple = /*#__PURE__*/ $eZVvM.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $7Z8DW.default)(props, $6e20985d142d5a66$var$_excluded);
    const [ripples, setRipples] = $eZVvM.useState([]);
    const nextKey = $eZVvM.useRef(0);
    const rippleCallback = $eZVvM.useRef(null);
    $eZVvM.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $eZVvM.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $eZVvM.useRef(null);
    const container = $eZVvM.useRef(null);
    const startCommit = $eZVvM.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $3pI8R.jsx)($6e20985d142d5a66$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.ripple, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $be89b43511df88e2$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $be89b43511df88e2$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.child, (0, $be89b43511df88e2$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.childLeaving, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.childPulsate, (0, $be89b43511df88e2$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $6e20985d142d5a66$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $eZVvM.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($6e20985d142d5a66$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $eZVvM.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $eZVvM.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $eZVvM.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($6e20985d142d5a66$export$f6b7418508c72c25, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)((0, $be89b43511df88e2$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $955311a93601fb86$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $6e20985d142d5a66$export$2e2bcd8739ae039 = $6e20985d142d5a66$var$TouchRipple;




function $4af6f561b7116851$export$fccb0498dcd99783(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiButtonBase", slot);
}
const $4af6f561b7116851$var$buttonBaseClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $4af6f561b7116851$export$2e2bcd8739ae039 = $4af6f561b7116851$var$buttonBaseClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4a8b8bf1c0ac0824$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $4a8b8bf1c0ac0824$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $4af6f561b7116851$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $4a8b8bf1c0ac0824$export$7ec0dcc5e3cdcd36 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $4af6f561b7116851$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $4a8b8bf1c0ac0824$var$ButtonBase = /*#__PURE__*/ $eZVvM.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $7Z8DW.default)(props, $4a8b8bf1c0ac0824$var$_excluded);
    const buttonRef = $eZVvM.useRef(null);
    const rippleRef = $eZVvM.useRef(null);
    const handleRippleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $6a538cd1be632e86$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $eZVvM.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $eZVvM.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $eZVvM.useState(false);
    $eZVvM.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $eZVvM.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $eZVvM.useRef(false);
    const handleKeyDown = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $11ca5a3145a6ac50$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $65o8X.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $4a8b8bf1c0ac0824$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($4a8b8bf1c0ac0824$export$7ec0dcc5e3cdcd36, (0, $65o8X.default)({
        as: ComponentProp,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $3pI8R.jsx)((0, $6e20985d142d5a66$export$2e2bcd8739ae039), (0, $65o8X.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $4a8b8bf1c0ac0824$export$2e2bcd8739ae039 = $4a8b8bf1c0ac0824$var$ButtonBase;





function $1fb0df7e1a4ded0d$export$5a6f9035944c8119(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiButton", slot);
}
const $1fb0df7e1a4ded0d$var$buttonClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorError",
    "colorInfo",
    "colorWarning",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "icon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $1fb0df7e1a4ded0d$export$2e2bcd8739ae039 = $1fb0df7e1a4ded0d$var$buttonClasses;



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $2ead2aabe9a84af4$var$ButtonGroupContext = /*#__PURE__*/ $eZVvM.createContext({});
var $2ead2aabe9a84af4$export$2e2bcd8739ae039 = $2ead2aabe9a84af4$var$ButtonGroupContext;



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $1c0fa3646ade5325$var$ButtonGroupButtonContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
var $1c0fa3646ade5325$export$2e2bcd8739ae039 = $1c0fa3646ade5325$var$ButtonGroupButtonContext;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $d1dc812927743fa6$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $d1dc812927743fa6$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "icon",
            "startIcon",
            `iconSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            "icon",
            "endIcon",
            `iconSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $1fb0df7e1a4ded0d$export$5a6f9035944c8119), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $d1dc812927743fa6$var$commonIconStyles = (ownerState)=>(0, $65o8X.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $d1dc812927743fa6$var$ButtonRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $65o8X.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $65o8X.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $65o8X.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).focusVisible}`]: (0, $65o8X.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).disabled}`]: (0, $65o8X.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $1fb0df7e1a4ded0d$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $d1dc812927743fa6$var$ButtonStartIcon = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $d1dc812927743fa6$var$commonIconStyles(ownerState)));
const $d1dc812927743fa6$var$ButtonEndIcon = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $d1dc812927743fa6$var$commonIconStyles(ownerState)));
const $d1dc812927743fa6$var$Button = /*#__PURE__*/ $eZVvM.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $eZVvM.useContext((0, $2ead2aabe9a84af4$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $eZVvM.useContext((0, $1c0fa3646ade5325$export$2e2bcd8739ae039));
    const resolvedProps = (0, $6860b88ec3aae518$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $7Z8DW.default)(props, $d1dc812927743fa6$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $d1dc812927743fa6$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $3pI8R.jsx)($d1dc812927743fa6$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $3pI8R.jsx)($d1dc812927743fa6$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($d1dc812927743fa6$var$ButtonRoot, (0, $65o8X.default)({
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $d1dc812927743fa6$export$2e2bcd8739ae039 = $d1dc812927743fa6$var$Button;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");





var $eZVvM = parcelRequire("eZVvM");
function $05f8386e46a60a51$export$2e2bcd8739ae039(children) {
    return $eZVvM.Children.toArray(children).filter((child)=>/*#__PURE__*/ $eZVvM.isValidElement(child));
}







function $3e8c170683421297$export$b85c003f960b1f3a(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiButtonGroup", slot);
}
const $3e8c170683421297$var$buttonGroupClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiButtonGroup", [
    "root",
    "contained",
    "outlined",
    "text",
    "disableElevation",
    "disabled",
    "firstButton",
    "fullWidth",
    "vertical",
    "grouped",
    "groupedHorizontal",
    "groupedVertical",
    "groupedText",
    "groupedTextHorizontal",
    "groupedTextVertical",
    "groupedTextPrimary",
    "groupedTextSecondary",
    "groupedOutlined",
    "groupedOutlinedHorizontal",
    "groupedOutlinedVertical",
    "groupedOutlinedPrimary",
    "groupedOutlinedSecondary",
    "groupedContained",
    "groupedContainedHorizontal",
    "groupedContainedVertical",
    "groupedContainedPrimary",
    "groupedContainedSecondary",
    "lastButton",
    "middleButton"
]);
var $3e8c170683421297$export$2e2bcd8739ae039 = $3e8c170683421297$var$buttonGroupClasses;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $dd44097e65f4cd5a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $dd44097e65f4cd5a$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === "vertical" && styles.vertical
    ];
};
const $dd44097e65f4cd5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            orientation === "vertical" && "vertical",
            fullWidth && "fullWidth",
            disableElevation && "disableElevation"
        ],
        grouped: [
            "grouped",
            `grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled"
        ],
        firstButton: [
            "firstButton"
        ],
        lastButton: [
            "lastButton"
        ],
        middleButton: [
            "middleButton"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $3e8c170683421297$export$b85c003f960b1f3a), classes);
};
const $dd44097e65f4cd5a$var$ButtonGroupRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiButtonGroup",
    slot: "Root",
    overridesResolver: $dd44097e65f4cd5a$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inline-flex",
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === "contained" && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: "none"
    }, ownerState.fullWidth && {
        width: "100%"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, {
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).grouped}`]: (0, $65o8X.default)({
            minWidth: 40,
            "&:hover": (0, $65o8X.default)({}, ownerState.variant === "contained" && {
                boxShadow: "none"
            })
        }, ownerState.variant === "contained" && {
            boxShadow: "none"
        }),
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).firstButton},& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: (0, $65o8X.default)({}, ownerState.orientation === "horizontal" && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === "text" && ownerState.orientation === "horizontal" && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.orientation === "vertical" && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            borderRightColor: "transparent"
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            borderBottomColor: "transparent"
        }, ownerState.variant === "contained" && ownerState.orientation === "horizontal" && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.orientation === "vertical" && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $3e8c170683421297$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            "&:hover": (0, $65o8X.default)({}, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
                borderRightColor: "currentColor"
            }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
                borderBottomColor: "currentColor"
            })
        }),
        [`& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).lastButton},& .${(0, $3e8c170683421297$export$2e2bcd8739ae039).middleButton}`]: (0, $65o8X.default)({}, ownerState.orientation === "horizontal" && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === "vertical" && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === "outlined" && ownerState.orientation === "horizontal" && {
            marginLeft: -1
        }, ownerState.variant === "outlined" && ownerState.orientation === "vertical" && {
            marginTop: -1
        })
    }));
const $dd44097e65f4cd5a$var$ButtonGroup = /*#__PURE__*/ $eZVvM.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiButtonGroup"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = "horizontal", size: size = "medium", variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $dd44097e65f4cd5a$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $dd44097e65f4cd5a$var$useUtilityClasses(ownerState);
    const context = $eZVvM.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $05f8386e46a60a51$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return "";
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)($dd44097e65f4cd5a$var$ButtonGroupRoot, (0, $65o8X.default)({
        as: component,
        role: "group",
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ead2aabe9a84af4$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $1c0fa3646ade5325$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
var $dd44097e65f4cd5a$export$2e2bcd8739ae039 = $dd44097e65f4cd5a$var$ButtonGroup;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $bU7jb = parcelRequire("bU7jb");






function $25b28f5866789c98$export$24c1f8f60cbac79e(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTypography", slot);
}
const $25b28f5866789c98$var$typographyClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $25b28f5866789c98$export$2e2bcd8739ae039 = $25b28f5866789c98$var$typographyClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $5d7bd7102f196281$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $5d7bd7102f196281$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $25b28f5866789c98$export$24c1f8f60cbac79e), classes);
};
const $5d7bd7102f196281$export$140e2f5526d3cad8 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $5d7bd7102f196281$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $5d7bd7102f196281$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $5d7bd7102f196281$var$transformDeprecatedColors = (color)=>{
    return $5d7bd7102f196281$var$colorTransformations[color] || color;
};
const $5d7bd7102f196281$var$Typography = /*#__PURE__*/ $eZVvM.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $5d7bd7102f196281$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $bU7jb.default)((0, $65o8X.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $5d7bd7102f196281$var$defaultVariantMapping } = props, other = (0, $7Z8DW.default)(props, $5d7bd7102f196281$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $5d7bd7102f196281$var$defaultVariantMapping[variant]) || "span";
    const classes = $5d7bd7102f196281$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($5d7bd7102f196281$export$140e2f5526d3cad8, (0, $65o8X.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $5d7bd7102f196281$export$2e2bcd8739ae039 = $5d7bd7102f196281$var$Typography;



var $cD0nt = parcelRequire("cD0nt");

const $cfa01d974fc14a69$export$bd46b8ab3689edc4 = (variants)=>{
    return {
        variants: variants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        whileTap: "tap"
    };
};
const $cfa01d974fc14a69$export$1c33d2a8eb772259 = {
    initial: {
        y: "100%"
    },
    animate: {
        y: 0,
        transition: {
            duration: 0.4,
            delay: 0.1,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        y: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $cfa01d974fc14a69$export$755918b48c75c65a = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.4,
            delay: 0.1,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};



var $bhfvP = parcelRequire("bhfvP");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $aac849b99e70d441$var$SvgEn = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('cd466b68880ea3e5')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M3.307 6.259a15.942 15.942 0 0 0-2.756 5.567h8.323L3.307 6.26ZM31.448 11.826a15.944 15.944 0 0 0-2.756-5.567l-5.567 5.567h8.323ZM.55 20.174a15.945 15.945 0 0 0 2.757 5.567l5.567-5.567H.551ZM25.741 3.308A15.942 15.942 0 0 0 20.174.55v8.324l5.567-5.567ZM6.259 28.693a15.944 15.944 0 0 0 5.567 2.756v-8.324l-5.567 5.568ZM11.826.551a15.943 15.943 0 0 0-5.567 2.757l5.567 5.567V.55ZM20.174 31.449a15.944 15.944 0 0 0 5.567-2.756l-5.567-5.568v8.324ZM23.125 20.174l5.567 5.567a15.943 15.943 0 0 0 2.756-5.567h-8.323Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M31.865 13.913H18.087V.135a16.16 16.16 0 0 0-4.174 0v13.778H.135a16.16 16.16 0 0 0 0 4.174h13.778v13.778a16.166 16.166 0 0 0 4.174 0V18.087h13.778a16.166 16.166 0 0 0 0-4.174Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "m20.174 20.174 7.14 7.14c.328-.329.641-.672.94-1.027l-6.113-6.113h-1.967ZM11.826 20.174l-7.14 7.14c.329.328.672.641 1.028.94l6.112-6.113v-1.967ZM11.826 11.826l-7.14-7.14c-.328.328-.641.671-.94 1.027l6.113 6.113h1.967ZM20.174 11.826l7.14-7.14a16.017 16.017 0 0 0-1.027-.94l-6.113 6.113v1.967Z",
                    fill: "#D80027"
                })
            ]
        })
    });
var $aac849b99e70d441$export$2e2bcd8739ae039 = $aac849b99e70d441$var$SvgEn;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $81194766776af8b4$var$SvgEnUs = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M16 31.999c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z",
                fill: "#F0F0F0"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.305 15.999H32c0-1.444-.192-2.844-.55-4.174H15.304v4.174ZM15.305 7.651h14.347a16.084 16.084 0 0 0-3.692-4.174H15.305v4.174ZM16 31.999c3.766 0 7.227-1.302 9.96-3.479H6.04A15.931 15.931 0 0 0 16 32ZM2.348 24.347h27.304a15.908 15.908 0 0 0 1.797-4.174H.55a15.906 15.906 0 0 0 1.797 4.174Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M7.412 2.498H8.87l-1.357.985.518 1.594-1.356-.985-1.356.985.447-1.377a16.088 16.088 0 0 0-3.103 3.459h.467l-.863.627c-.134.224-.263.452-.387.683l.412 1.27-.769-.56c-.191.405-.366.82-.523 1.242l.454 1.398H3.13l-1.356.986.518 1.594-1.356-.985-.812.59C.042 14.658 0 15.324 0 15.999h16v-16c-3.16 0-6.107.917-8.588 2.499Zm.62 11.901-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594H8.87l-1.357.986.518 1.594Zm-.519-6.255.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595H8.87l-1.357.985Zm6.258 6.255-1.357-.985-1.356.985.518-1.594-1.356-.986h1.676l.518-1.594.518 1.594h1.677l-1.357.986.518 1.594Zm-.519-6.255.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985Zm0-4.661.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676l.518-1.595.518 1.595h1.677l-1.357.985Z",
                fill: "#0052B4"
            })
        ]
    });
var $81194766776af8b4$export$2e2bcd8739ae039 = $81194766776af8b4$var$SvgEnUs;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $a01c6f1bcfe7003c$var$SvgNl = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('6255d14cef0be76e')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0Z",
                    fill: "#A2001D"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c6.88 0 12.744-4.342 15.005-10.435H.995C3.255 27.658 9.12 32 16 32Z",
                    fill: "#0052B4"
                })
            ]
        })
    });
var $a01c6f1bcfe7003c$export$2e2bcd8739ae039 = $a01c6f1bcfe7003c$var$SvgNl;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $3f8a02afc7fd58be$var$SvgDe = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('f383e8461bdab344')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M1 21.565C3.26 27.658 9.125 32 16.005 32c6.88 0 12.744-4.342 15.005-10.435l-15.005-1.391L1 21.565Z",
                    fill: "#FFDA44"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16.005 0C9.125 0 3.26 4.342 1 10.435l15.005 1.391 15.005-1.391C28.749 4.342 22.884 0 16.005 0Z",
                    fill: "#000"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M.995 10.435A15.965 15.965 0 0 0 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16c0-1.957-.352-3.832-.995-5.565H.995Z",
                    fill: "#D80027"
                })
            ]
        })
    });
var $3f8a02afc7fd58be$export$2e2bcd8739ae039 = $3f8a02afc7fd58be$var$SvgDe;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $453b90f50adb1cf2$var$SvgFr = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('75cb4dc47f9508c6')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M32 16C32 9.12 27.658 3.256 21.565.995v30.01C27.658 28.745 32 22.879 32 16Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M0 16c0 6.88 4.342 12.744 10.435 15.005V.995C4.342 3.255 0 9.12 0 16Z",
                    fill: "#0052B4"
                })
            ]
        })
    });
var $453b90f50adb1cf2$export$2e2bcd8739ae039 = $453b90f50adb1cf2$var$SvgFr;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $747d7715f39884f2$var$SvgRs = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('45230c8e20f63d66')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z",
                    fill: "#F0F0F0"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C7.163 0 0 7.163 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16c0-8.837-7.163-16-16-16Z",
                    fill: "#0052B4"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M4.137 9.043v7.982c0 4.54 5.932 5.932 5.932 5.932s5.93-1.392 5.93-5.932V9.044H4.138Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M6.59 10.435h6.957V7.652l-1.391.696-2.087-2.087-2.087 2.087-1.392-.696v2.783ZM14.609 18.136l-4.522-4.521-4.522 4.521 1.476 1.476 3.046-3.046 3.046 3.046 1.476-1.476Z",
                    fill: "#FFDA44"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M14.609 13.913h-2.11a1.391 1.391 0 1 0-2.43-1.352 1.39 1.39 0 1 0-2.43 1.352H5.564c0 .768.67 1.391 1.438 1.391h-.046c0 .769.622 1.392 1.39 1.392 0 .68.49 1.245 1.135 1.366l-1.096 2.475a4.507 4.507 0 0 0 3.403 0l-1.097-2.475a1.391 1.391 0 0 0 1.134-1.366c.769 0 1.391-.623 1.391-1.392h-.046c.768 0 1.438-.623 1.438-1.39Z",
                    fill: "#F0F0F0"
                })
            ]
        })
    });
var $747d7715f39884f2$export$2e2bcd8739ae039 = $747d7715f39884f2$var$SvgRs;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $5c451989d277fba4$var$SvgPt = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M23.5 1.863A15.93 15.93 0 0 0 16 0c-2.71 0-5.263.674-7.5 1.863v28.274A15.93 15.93 0 0 0 16 32c2.71 0 5.263-.674 7.5-1.863V1.863Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M21.5.97C27.627 3.214 32 9.097 32 16s-4.373 12.787-10.5 15.03V.97Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.5.97v30.06C4.373 28.787 0 22.904 0 16S4.373 3.213 10.5.97Z",
                fill: "#496E2D"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.435 21.565a5.565 5.565 0 1 0 0-11.13 5.565 5.565 0 0 0 0 11.13Z",
                fill: "#FFDA44"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M7.304 13.217v3.478a3.13 3.13 0 1 0 6.261 0v-3.478h-6.26Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.435 17.739a1.045 1.045 0 0 1-1.044-1.044v-1.39h2.087v1.39c0 .576-.468 1.044-1.043 1.044Z",
                fill: "#EEE"
            })
        ]
    });
var $5c451989d277fba4$export$2e2bcd8739ae039 = $5c451989d277fba4$var$SvgPt;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $25ffe561d7b26f99$var$SvgEs = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M31.005 10.435H.995A15.966 15.966 0 0 0 0 16c0 1.957.352 3.832.995 5.565h30.01C31.648 19.832 32 17.957 32 16c0-1.957-.352-3.832-.995-5.565Z",
                fill: "#ffda44"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M16 0C9.12 0 3.256 4.342.995 10.435h30.01C28.745 4.342 22.879 0 16 0ZM16 32c6.88 0 12.744-4.342 15.005-10.435H.995C3.255 27.658 9.121 32 16 32Z",
                fill: "#d80027"
            })
        ]
    });
var $25ffe561d7b26f99$export$2e2bcd8739ae039 = $25ffe561d7b26f99$var$SvgEs;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $97a227a93f57aad3$var$SvgJp = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0Zm0 22.956a6.956 6.956 0 1 1 0-13.912 6.956 6.956 0 0 1 0 13.912Z",
                fill: "#f0f0f0"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 6.956,
                fill: "#d80027"
            })
        ]
    });
var $97a227a93f57aad3$export$2e2bcd8739ae039 = $97a227a93f57aad3$var$SvgJp;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c82f3933a6632d58$var$SvgPl = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('1cbe4accdefa2f55')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16 32c8.826 0 15.983-7.146 16-15.968V16l-16-2-16 2c0 8.837 7.163 16 16 16Z",
                    fill: "#D80027"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M32 15.968V16H0C0 7.163 7.163 0 16 0c8.826 0 15.983 7.146 16 15.968Z",
                    fill: "#EEE"
                })
            ]
        })
    });
var $c82f3933a6632d58$export$2e2bcd8739ae039 = $c82f3933a6632d58$var$SvgPl;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $646c170867bccc6c$var$SvgIt = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M23.5 1.863A15.93 15.93 0 0 0 16 0c-2.71 0-5.263.674-7.5 1.863v28.274A15.93 15.93 0 0 0 16 32c2.71 0 5.263-.674 7.5-1.863V1.863Z",
                fill: "#EEE"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M21.5.97C27.627 3.213 32 9.096 32 16s-4.373 12.787-10.5 15.03V.97Z",
                fill: "#D80027"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M10.5.97v30.06C4.373 28.787 0 22.904 0 16S4.373 3.213 10.5.97Z",
                fill: "#6DA544"
            })
        ]
    });
var $646c170867bccc6c$export$2e2bcd8739ae039 = $646c170867bccc6c$var$SvgIt;


const $f6b05c2efb87f39c$var$iconTypes = {
    en: (0, $aac849b99e70d441$export$2e2bcd8739ae039),
    en_US: (0, $81194766776af8b4$export$2e2bcd8739ae039),
    nl: (0, $a01c6f1bcfe7003c$export$2e2bcd8739ae039),
    sr: (0, $747d7715f39884f2$export$2e2bcd8739ae039),
    de: (0, $3f8a02afc7fd58be$export$2e2bcd8739ae039),
    fr: (0, $453b90f50adb1cf2$export$2e2bcd8739ae039),
    pt: (0, $5c451989d277fba4$export$2e2bcd8739ae039),
    es: (0, $25ffe561d7b26f99$export$2e2bcd8739ae039),
    ja: (0, $97a227a93f57aad3$export$2e2bcd8739ae039),
    pl: (0, $c82f3933a6632d58$export$2e2bcd8739ae039),
    it: (0, $646c170867bccc6c$export$2e2bcd8739ae039)
};
const $f6b05c2efb87f39c$var$LocaleIcon = ({ name: name, ...props })=>{
    const Icon = $f6b05c2efb87f39c$var$iconTypes[name];
    return /*#__PURE__*/ (0, $bhfvP.jsx)(Icon, {
        ...props
    });
};
var $f6b05c2efb87f39c$export$2e2bcd8739ae039 = $f6b05c2efb87f39c$var$LocaleIcon;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $56ba4849816b834d$var$SvgClose = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('6d2bef2ef2d02ca1')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M12.2 3.807a.664.664 0 0 0-.94 0L8 7.06 4.74 3.8a.664.664 0 1 0-.94.94L7.06 8 3.8 11.26a.664.664 0 1 0 .94.94L8 8.94l3.26 3.26a.664.664 0 1 0 .94-.94L8.94 8l3.26-3.26a.668.668 0 0 0 0-.933Z",
                fill: "#111"
            })
        })
    });
var $56ba4849816b834d$export$2e2bcd8739ae039 = $56ba4849816b834d$var$SvgClose;



var $bhfvP = parcelRequire("bhfvP");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $cgitS = parcelRequire("cgitS");

var $hWP8m = parcelRequire("hWP8m");



var $gnWEo = parcelRequire("gnWEo");

var $34Ozv = parcelRequire("34Ozv");
const $c188b0b6cf7ccc98$var$_excluded = [
    "ownerState"
], $c188b0b6cf7ccc98$var$_excluded2 = [
    "variants"
], $c188b0b6cf7ccc98$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $c188b0b6cf7ccc98$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c188b0b6cf7ccc98$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $c188b0b6cf7ccc98$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $c188b0b6cf7ccc98$export$35e57303dbd8a66 = (0, $gnWEo.default)();
const $c188b0b6cf7ccc98$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $c188b0b6cf7ccc98$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $c188b0b6cf7ccc98$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $c188b0b6cf7ccc98$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $c188b0b6cf7ccc98$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $7Z8DW.default)(_ref, $c188b0b6cf7ccc98$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $65o8X.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$c188b0b6cf7ccc98$var$processStyleArg(resolvedStyle, (0, $65o8X.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $7Z8DW.default)(resolvedStylesArg, $c188b0b6cf7ccc98$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $65o8X.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $65o8X.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $c188b0b6cf7ccc98$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c188b0b6cf7ccc98$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $c188b0b6cf7ccc98$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $c188b0b6cf7ccc98$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $34Ozv.default)((0, $65o8X.default)({}, props, {
            theme: $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $cgitS.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c188b0b6cf7ccc98$var$defaultOverridesResolver($c188b0b6cf7ccc98$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $7Z8DW.default)(inputOptions, $c188b0b6cf7ccc98$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $c188b0b6cf7ccc98$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c188b0b6cf7ccc98$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $cgitS.default)(tag, (0, $65o8X.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $hWP8m.isPlainObject)(stylesArg)) return (props)=>$c188b0b6cf7ccc98$var$processStyleArg(stylesArg, (0, $65o8X.default)({}, props, {
                    theme: $c188b0b6cf7ccc98$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $c188b0b6cf7ccc98$var$processStyleArg(slotStyle, (0, $65o8X.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $c188b0b6cf7ccc98$var$resolveTheme((0, $65o8X.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $c188b0b6cf7ccc98$var$processStyleArg({
                    variants: themeVariants
                }, (0, $65o8X.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $4d9b9f946ff41bcb$var$styled = (0, $c188b0b6cf7ccc98$export$2e2bcd8739ae039)();
var $4d9b9f946ff41bcb$export$2e2bcd8739ae039 = $4d9b9f946ff41bcb$var$styled;



var $18e8e5dee746a5b9$exports = {};

$18e8e5dee746a5b9$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "DigitalReceptionLogo.dde8a869.png";


const $1f77f6b4c9bb38e1$var$digitalReceptionLogo = new URL($18e8e5dee746a5b9$exports);
var $be8fdf38e0871731$exports = {};

$be8fdf38e0871731$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "FrontAssistLogo.747d47ef.png";


const $1f77f6b4c9bb38e1$var$frontAssistLogo = new URL($be8fdf38e0871731$exports);
const $1f77f6b4c9bb38e1$var$MUILogoImage = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)("div")(({ imageUrl: imageUrl })=>({
        backgroundImage: `url("${imageUrl}")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: "32rem",
        height: "18rem",
        marginBottom: "6rem",
        "@media screen and (orientation: landscape)": {
            marginBottom: "2rem",
            width: "20rem",
            height: "11.25rem"
        }
    }));
const $1f77f6b4c9bb38e1$var$LogoImage = ({ imageUrl: imageUrl })=>{
    const isFrontAssist = (0, $cac46807e76713b1$export$4f786993a45a8621)();
    const defaultLogo = isFrontAssist ? $1f77f6b4c9bb38e1$var$frontAssistLogo : $1f77f6b4c9bb38e1$var$digitalReceptionLogo;
    return /*#__PURE__*/ (0, $bhfvP.jsx)($1f77f6b4c9bb38e1$var$MUILogoImage, {
        imageUrl: imageUrl || defaultLogo
    });
};
var $1f77f6b4c9bb38e1$export$2e2bcd8739ae039 = $1f77f6b4c9bb38e1$var$LogoImage;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $0882abbd7705f7c9$var$SvgAiSparkle = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "328.496 186.769 21 22",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                className: "AISparkle_svg__st0",
                d: "M342.496 208.769c-.5-3.4-1.9-6.5-7-7 5.1-.5 6.5-3.6 7-7 .5 3.4 1.9 6.5 7 7-5.2.5-6.6 3.6-7 7Z",
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                className: "AISparkle_svg__st2",
                d: "M345.896 191.769c-.1-1-.5-1.9-2-2 1.5-.1 1.9-1 2-2 .1 1 .5 1.9 2 2-1.5.1-1.9 1-2 2Zm-11.9 6c-.4-2.7-1.5-5.1-5.5-5.5 4-.4 5.1-2.8 5.5-5.5.4 2.7 1.5 5.1 5.5 5.5-4.1.4-5.2 2.8-5.5 5.5Z",
                fill: "none",
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10,
                strokeWidth: 1.8
            })
        ]
    });
var $0882abbd7705f7c9$export$2e2bcd8739ae039 = $0882abbd7705f7c9$var$SvgAiSparkle;


const $83c22d484219d577$var$MUIFooterLanguageButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(({ theme: theme })=>({
        width: "42rem",
        borderRadius: "2rem",
        borderWidth: "0.2rem",
        "&:active": {
            borderWidth: "0.2rem"
        },
        "&:hover": {
            borderWidth: "0.2rem"
        }
    }));
const $83c22d484219d577$var$MUIModalLanguageButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(({ theme: theme, isActive: isActive })=>({
        marginBottom: "1.5rem",
        borderRadius: "2rem",
        borderColor: `${theme.palette.primary.main} !important`,
        backgroundColor: isActive ? theme.palette.primary.dark : theme.palette.primary.main
    }));
const $83c22d484219d577$var$MUILanguageModal = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        ".language-modal__content": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).darken(0.025).hex()
        }
    }));
const $83c22d484219d577$var$ConversationButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        position: "absolute",
        right: 0,
        bottom: 0,
        width: "12rem",
        borderRadius: "2rem 0rem 0rem 0rem",
        borderWidth: "0.2rem",
        "&:active": {
            borderWidth: "0.2rem"
        },
        "&:hover": {
            borderWidth: "0.2rem"
        }
    }));
const $83c22d484219d577$var$Footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "language"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const languages = (0, $bad2beece3d2a513$export$38be4353f99148d)();
    const [locale, setLocale] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const [languageModal, setLanguageModal] = (0, $eZVvM.useState)(false);
    const { data: data, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const logoUrl = (0, $cD0nt.useLogoUrl)();
    const isAIConversationEnabled = (0, $eZVvM.useMemo)(()=>{
        var _data_digitalReception_metadata, _data_digitalReception;
        return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_metadata = _data_digitalReception.metadata) === null || _data_digitalReception_metadata === void 0 ? void 0 : _data_digitalReception_metadata.aiConversation) || false;
    }, []);
    const isConversationPage = (0, $eZVvM.useMemo)(()=>window.location.pathname === "/conversation", [
        window.location.pathname
    ]);
    const renderModalLanguage = (0, $eZVvM.useCallback)((key)=>/*#__PURE__*/ (0, $bhfvP.jsxs)($83c22d484219d577$var$MUIModalLanguageButton, {
            "data-value": key,
            isActive: locale === key,
            variant: "contained",
            onClick: ()=>{
                setLocale(key);
                setLanguageModal(false);
            },
            className: "border",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $f6b05c2efb87f39c$export$2e2bcd8739ae039), {
                    name: key,
                    width: "3.2rem",
                    height: "3.2rem",
                    className: "position-absolute start-0 ms-5"
                }),
                t(`language:${key}`)
            ]
        }, key), [
        t,
        locale
    ]);
    const renderLanguage = (0, $eZVvM.useCallback)((key)=>/*#__PURE__*/ (0, $bhfvP.jsx)($83c22d484219d577$var$MUIFooterLanguageButton, {
            "data-value": key,
            variant: locale === key ? "contained" : "outlined",
            onClick: ()=>{
                setLocale(key);
            },
            children: t(`language:${key}`)
        }, key), [
        t,
        locale,
        setLocale
    ]);
    const onClose = (0, $eZVvM.useCallback)(()=>{
        setLanguageModal(false);
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("footer", {
        className: "d-flex flex-column align-items-center w-100 position-relative",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $1f77f6b4c9bb38e1$export$2e2bcd8739ae039), {
                imageUrl: logoUrl
            }),
            languages.length >= 2 ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h4",
                        className: "text-center text-secondary font-weight-regular mb-4",
                        children: t(`language:title`)
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $dd44097e65f4cd5a$export$2e2bcd8739ae039), {
                        children: languages.length > 2 ? /*#__PURE__*/ (0, $bhfvP.jsxs)($83c22d484219d577$var$MUIFooterLanguageButton, {
                            variant: "contained",
                            onClick: ()=>setLanguageModal(true),
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $f6b05c2efb87f39c$export$2e2bcd8739ae039), {
                                    name: locale,
                                    width: "3.2rem",
                                    className: "position-absolute start-0 ms-5"
                                }),
                                t(`language:${locale}`)
                            ]
                        }) : languages.map(renderLanguage)
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                        mode: "wait",
                        children: languageModal && /*#__PURE__*/ (0, $bhfvP.jsx)($83c22d484219d577$var$MUILanguageModal, {
                            className: "language-modal",
                            children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$1c33d2a8eb772259)),
                                className: "language-modal__content",
                                children: [
                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h2",
                                        className: "text-center pt-5",
                                        children: t(`language:title`)
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                        className: "language-modal__list",
                                        children: languages.map(renderModalLanguage)
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                        className: "language-modal__close",
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $56ba4849816b834d$export$2e2bcd8739ae039), {
                                            width: "6rem"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                style: {
                    height: "7rem"
                }
            }),
            isAIConversationEnabled && !isConversationPage && /*#__PURE__*/ (0, $bhfvP.jsx)($83c22d484219d577$var$ConversationButton, {
                variant: "contained",
                onClick: ()=>navigate("/conversation"),
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    fontSize: "3.6rem",
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $0882abbd7705f7c9$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
});
var $83c22d484219d577$export$2e2bcd8739ae039 = $83c22d484219d577$var$Footer;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
var $527fc7c8a06c512f$var$useEffectOnce = function(effect) {
    (0, $eZVvM.useEffect)(effect, []);
};
var $527fc7c8a06c512f$export$2e2bcd8739ae039 = $527fc7c8a06c512f$var$useEffectOnce;


var $f928d3cc22d91535$var$useUnmount = function(fn) {
    var fnRef = (0, $eZVvM.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, $527fc7c8a06c512f$export$2e2bcd8739ae039)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
var $f928d3cc22d91535$export$2e2bcd8739ae039 = $f928d3cc22d91535$var$useUnmount;


var $94447409307c79fa$var$useRafState = function(initialState) {
    var frame = (0, $eZVvM.useRef)(0);
    var _a = (0, $eZVvM.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, $eZVvM.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, $f928d3cc22d91535$export$2e2bcd8739ae039)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
var $94447409307c79fa$export$2e2bcd8739ae039 = $94447409307c79fa$var$useRafState;


var $109413e3b0fe66f1$export$8793edee2d425525 = function() {};
function $109413e3b0fe66f1$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $109413e3b0fe66f1$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $109413e3b0fe66f1$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $109413e3b0fe66f1$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $23d13b6059d874f6$var$useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, $94447409307c79fa$export$2e2bcd8739ae039)({
        width: (0, $109413e3b0fe66f1$export$4e09c449d6c407f7) ? window.innerWidth : initialWidth,
        height: (0, $109413e3b0fe66f1$export$4e09c449d6c407f7) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, $eZVvM.useEffect)(function() {
        if (0, $109413e3b0fe66f1$export$4e09c449d6c407f7) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            (0, $109413e3b0fe66f1$export$af631764ddc44097)(window, "resize", handler_1);
            return function() {
                (0, $109413e3b0fe66f1$export$8c8705df4a2dcec9)(window, "resize", handler_1);
            };
        }
    }, []);
    return state;
};
var $23d13b6059d874f6$export$2e2bcd8739ae039 = $23d13b6059d874f6$var$useWindowSize;




var $cD0nt = parcelRequire("cD0nt");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9u6aw = parcelRequire("9u6aw");

var $3WZeB = parcelRequire("3WZeB");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $086519bbae812ae3$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $3WZeB.default)(value, min, max);
}
function $086519bbae812ae3$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $086519bbae812ae3$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $086519bbae812ae3$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $086519bbae812ae3$export$677b39864803984e($086519bbae812ae3$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $9u6aw.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $9u6aw.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $086519bbae812ae3$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $086519bbae812ae3$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $086519bbae812ae3$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $086519bbae812ae3$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $086519bbae812ae3$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $086519bbae812ae3$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $086519bbae812ae3$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$086519bbae812ae3$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $086519bbae812ae3$export$29fb7152bd3f781a(color) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $086519bbae812ae3$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $086519bbae812ae3$export$c852d90bf7403b62(color) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $086519bbae812ae3$export$677b39864803984e($086519bbae812ae3$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $086519bbae812ae3$export$d061e26956a60b0a(foreground, background) {
    const lumA = $086519bbae812ae3$export$c852d90bf7403b62(foreground);
    const lumB = $086519bbae812ae3$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $086519bbae812ae3$export$58f0f39f63f3cf42(color, value) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    value = $086519bbae812ae3$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $086519bbae812ae3$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$4b073707ff63303(color, coefficient) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    coefficient = $086519bbae812ae3$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$c0816ed86df316af(color, coefficient) {
    color = $086519bbae812ae3$export$677b39864803984e(color);
    coefficient = $086519bbae812ae3$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $086519bbae812ae3$export$211a73f2b8c10ce4(color);
}
function $086519bbae812ae3$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $086519bbae812ae3$export$c852d90bf7403b62(color) > 0.5 ? $086519bbae812ae3$export$4b073707ff63303(color, coefficient) : $086519bbae812ae3$export$c0816ed86df316af(color, coefficient);
}
function $086519bbae812ae3$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $086519bbae812ae3$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $086519bbae812ae3$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $086519bbae812ae3$export$677b39864803984e(background);
    const overlayColor = $086519bbae812ae3$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $086519bbae812ae3$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
function $dc40de7e626e5d14$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $dc40de7e626e5d14$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $dc40de7e626e5d14$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $dc40de7e626e5d14$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $dc40de7e626e5d14$export$2e2bcd8739ae039 = $dc40de7e626e5d14$export$4f5d2d50c9deca37;



var $cgitS = parcelRequire("cgitS");

var $34Ozv = parcelRequire("34Ozv");
var $bU7jb = parcelRequire("bU7jb");


var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9ef1d716f5f043a0$var$_excluded = [
    "className",
    "component"
];
function $9ef1d716f5f043a0$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $cgitS.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $34Ozv.default));
    const Box = /*#__PURE__*/ $eZVvM.forwardRef(function Box(inProps, ref) {
        const theme = (0, $123cc06973765126$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $bU7jb.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $7Z8DW.default)(_extendSxProp, $9ef1d716f5f043a0$var$_excluded);
        return /*#__PURE__*/ (0, $3pI8R.jsx)(BoxRoot, (0, $65o8X.default)({
            as: component,
            ref: ref,
            className: (0, $dc40de7e626e5d14$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}







const $0681a36e30dd9b48$var$boxClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiBox", [
    "root"
]);
var $0681a36e30dd9b48$export$2e2bcd8739ae039 = $0681a36e30dd9b48$var$boxClasses;


"use client";
const $0176c5dd89354b80$var$defaultTheme = (0, $dfae66918ab7b5ac$export$2e2bcd8739ae039)();
const $0176c5dd89354b80$var$Box = (0, $9ef1d716f5f043a0$export$2e2bcd8739ae039)({
    themeId: (0, $cd607e6564742347$export$2e2bcd8739ae039),
    defaultTheme: $0176c5dd89354b80$var$defaultTheme,
    defaultClassName: (0, $0681a36e30dd9b48$export$2e2bcd8739ae039).root,
    generateClassName: (0, $ce48a54a23a9229a$export$2e2bcd8739ae039).generate
});
var $0176c5dd89354b80$export$2e2bcd8739ae039 = $0176c5dd89354b80$var$Box;



var $cD0nt = parcelRequire("cD0nt");
const $95818b44b5b795be$var$TimeWrapper = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $0176c5dd89354b80$export$2e2bcd8739ae039))(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        position: "fixed",
        width: "100%"
    }));
const $95818b44b5b795be$var$Time = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5d7bd7102f196281$export$2e2bcd8739ae039))(({ theme: theme })=>({
        minWidth: "28rem",
        // around 86px on 484x919 screen
        padding: "0 5rem",
        fontSize: "6rem",
        borderRadius: "0 0 2rem 2rem",
        borderWidth: "0.2rem",
        display: "flex",
        justifyContent: "center",
        color: theme.palette.common.white
    }));
const $95818b44b5b795be$var$formatTime = (number)=>number.toString().padStart(2, "0");
const $95818b44b5b795be$var$TimeDisplay = ({ opacity: opacity })=>{
    const [timeString, setTimeString] = (0, $eZVvM.useState)();
    (0, $eZVvM.useEffect)(()=>{
        const interval = setInterval(()=>{
            const date = new Date();
            const currentTimeString = `${$95818b44b5b795be$var$formatTime(date.getHours())}:${$95818b44b5b795be$var$formatTime(date.getMinutes())}`;
            setTimeString(()=>currentTimeString);
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    if (!timeString) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsx)($95818b44b5b795be$var$Time, {
        sx: {
            backgroundColor: (theme)=>{
                if (opacity === 0) return "transparent";
                return (0, $086519bbae812ae3$export$58f0f39f63f3cf42)(theme.palette.common.black, (opacity !== null && opacity !== void 0 ? opacity : 100) / 100);
            }
        },
        children: timeString
    });
};
const $95818b44b5b795be$var$Clock = ()=>{
    const clock = (0, $cD0nt.useClock)();
    if (!(clock === null || clock === void 0 ? void 0 : clock.enabled)) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsx)($95818b44b5b795be$var$TimeWrapper, {
        children: /*#__PURE__*/ (0, $bhfvP.jsx)($95818b44b5b795be$var$TimeDisplay, {
            opacity: clock === null || clock === void 0 ? void 0 : clock.opacity
        })
    });
};
var $95818b44b5b795be$export$2e2bcd8739ae039 = $95818b44b5b795be$var$Clock;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
const $8b1dc2b27a20c047$var$HeaderHeightContext = /*#__PURE__*/ (0, $eZVvM.createContext)(null);
const $8b1dc2b27a20c047$export$cb84c4304c266c20 = ()=>{
    const context = (0, $eZVvM.useContext)($8b1dc2b27a20c047$var$HeaderHeightContext);
    if (!context) throw new Error("useHeaderHeightContext must be used within a HeaderHeightProvider");
    return context;
};
const $8b1dc2b27a20c047$export$a9e20bb831c0d632 = ({ children: children })=>{
    const [height, setHeight] = (0, $eZVvM.useState)(0);
    const updateHeight = (0, $eZVvM.useCallback)((newHeight)=>{
        setHeight(newHeight);
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            height: height,
            setHeight: updateHeight
        }), [
        height,
        updateHeight
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($8b1dc2b27a20c047$var$HeaderHeightContext.Provider, {
        value: value,
        children: children
    });
};
var $8b1dc2b27a20c047$export$2e2bcd8739ae039 = $8b1dc2b27a20c047$export$a9e20bb831c0d632;



var $7ac4f77b4b36f545$exports = {};

$7ac4f77b4b36f545$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "DigitalReceptionBackground.1c98fa10.png";


const $da78fdcdfe3cc1e0$var$digitalReceptionBackground = new URL($7ac4f77b4b36f545$exports);
var $9b3a33b6c3d20e43$exports = {};

$9b3a33b6c3d20e43$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "FrontAssistBackground.f50caa30.png";


const $da78fdcdfe3cc1e0$var$frontAssistBackground = new URL($9b3a33b6c3d20e43$exports);
const $da78fdcdfe3cc1e0$var$MUIHeroImage = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("header")({
    height: "54.5rem",
    "@media screen and (orientation: landscape)": {
        height: "38rem"
    },
    "& div": {
        height: "100%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        "@media screen and (orientation: landscape)": {
            backgroundSize: "100% auto",
            backgroundPosition: "50% 77%"
        }
    }
});
const $da78fdcdfe3cc1e0$var$Header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    var _data_digitalReception_theme_images_hero, _data_digitalReception_theme_images, _data_digitalReception_theme, _data_digitalReception;
    const { data: data, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const imageURL = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_theme = _data_digitalReception.theme) === null || _data_digitalReception_theme === void 0 ? void 0 : (_data_digitalReception_theme_images = _data_digitalReception_theme.images) === null || _data_digitalReception_theme_images === void 0 ? void 0 : (_data_digitalReception_theme_images_hero = _data_digitalReception_theme_images.hero) === null || _data_digitalReception_theme_images_hero === void 0 ? void 0 : _data_digitalReception_theme_images_hero.absolutePath;
    const { setHeight: setHeight } = (0, $8b1dc2b27a20c047$export$cb84c4304c266c20)();
    const location = (0, $9B9bN.useLocation)();
    const isFrontAssist = (0, $cac46807e76713b1$export$4f786993a45a8621)();
    const defaultBackground = isFrontAssist ? $da78fdcdfe3cc1e0$var$frontAssistBackground : $da78fdcdfe3cc1e0$var$digitalReceptionBackground;
    const headerRef = (0, $eZVvM.useRef)(null);
    const updateHeaderHeight = ()=>{
        requestAnimationFrame(()=>{
            if (headerRef.current) setHeight(headerRef.current.getBoundingClientRect().height);
        });
    };
    (0, $eZVvM.useEffect)(()=>{
        setTimeout(updateHeaderHeight, 0);
    }, [
        dataUpdatedAt,
        location.pathname
    ]);
    (0, $eZVvM.useEffect)(()=>{
        window.addEventListener("resize", updateHeaderHeight);
        return ()=>{
            window.removeEventListener("resize", updateHeaderHeight);
        };
    }, []);
    if ((location.pathname === "/access/checkin/manual" || location.pathname === "/access/checkin/manual/" || location.pathname.startsWith("/access/checkin/missing-fields/")) && width > height) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $95818b44b5b795be$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)($da78fdcdfe3cc1e0$var$MUIHeroImage, {
                children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    ref: headerRef,
                    className: "hero__image",
                    style: {
                        backgroundImage: `url("${imageURL !== null && imageURL !== void 0 ? imageURL : defaultBackground}")`
                    }
                })
            }, dataUpdatedAt)
        ]
    });
});
var $da78fdcdfe3cc1e0$export$2e2bcd8739ae039 = $da78fdcdfe3cc1e0$var$Header;




var $bhfvP = parcelRequire("bhfvP");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");


var $65o8X = parcelRequire("65o8X");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $9bcff6e41ffd69d5$var$isHostComponent(element) {
    return typeof element === "string";
}
var $9bcff6e41ffd69d5$export$2e2bcd8739ae039 = $9bcff6e41ffd69d5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $83048e33da74ce9f$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $65o8X.default)({}, otherProps, {
        ownerState: (0, $65o8X.default)({}, otherProps.ownerState, ownerState)
    });
}
var $83048e33da74ce9f$export$2e2bcd8739ae039 = $83048e33da74ce9f$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $c4f71c307399daa8$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}
var $c4f71c307399daa8$export$2e2bcd8739ae039 = $c4f71c307399daa8$var$resolveComponentProps;



var $65o8X = parcelRequire("65o8X");
function $496b4aec7d03021f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $496b4aec7d03021f$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $496b4aec7d03021f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $496b4aec7d03021f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $496b4aec7d03021f$export$2e2bcd8739ae039 = $496b4aec7d03021f$export$4f5d2d50c9deca37;


/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $fa9bbc157eb2c0a8$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fa9bbc157eb2c0a8$export$2e2bcd8739ae039 = $fa9bbc157eb2c0a8$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $77ff8b158dc6cef0$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $77ff8b158dc6cef0$export$2e2bcd8739ae039 = $77ff8b158dc6cef0$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $199ddfc215453045$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $496b4aec7d03021f$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $65o8X.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $65o8X.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)((0, $65o8X.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $77ff8b158dc6cef0$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $77ff8b158dc6cef0$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $496b4aec7d03021f$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $65o8X.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $65o8X.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $199ddfc215453045$export$2e2bcd8739ae039 = $199ddfc215453045$var$mergeSlotProps;


"use client";
const $d63981feaa800455$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $d63981feaa800455$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $d63981feaa800455$var$_excluded3 = [
    "component"
];
function $d63981feaa800455$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $7Z8DW.default)(parameters, $d63981feaa800455$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $7Z8DW.default)(externalForwardedProps, $d63981feaa800455$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $c4f71c307399daa8$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $199ddfc215453045$export$2e2bcd8739ae039)((0, $65o8X.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $7Z8DW.default)(_mergeSlotProps.props, $d63981feaa800455$var$_excluded3);
    const ref = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $65o8X.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $83048e33da74ce9f$export$2e2bcd8739ae039)(elementType, (0, $65o8X.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $fe285c32ecd88e3f$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $fe285c32ecd88e3f$export$2e2bcd8739ae039 = $fe285c32ecd88e3f$var$getOverlayAlpha;






function $a73e2fb78f54fe9e$export$29cdb466b9b6f20b(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiPaper", slot);
}
const $a73e2fb78f54fe9e$var$paperClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $a73e2fb78f54fe9e$export$2e2bcd8739ae039 = $a73e2fb78f54fe9e$var$paperClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $08c3c2df346a18c6$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $08c3c2df346a18c6$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $a73e2fb78f54fe9e$export$29cdb466b9b6f20b), classes);
};
const $08c3c2df346a18c6$var$PaperRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $65o8X.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $65o8X.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $6ae574cb2ebbc3ad$exports.alpha)("#fff", (0, $fe285c32ecd88e3f$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $6ae574cb2ebbc3ad$exports.alpha)("#fff", (0, $fe285c32ecd88e3f$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $08c3c2df346a18c6$var$Paper = /*#__PURE__*/ $eZVvM.forwardRef(function Paper(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $7Z8DW.default)(props, $08c3c2df346a18c6$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $08c3c2df346a18c6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($08c3c2df346a18c6$var$PaperRoot, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $08c3c2df346a18c6$export$2e2bcd8739ae039 = $08c3c2df346a18c6$var$Paper;




function $21a0aaa51c86f87a$export$69aecd24bc2cf7e3(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiAlert", slot);
}
const $21a0aaa51c86f87a$var$alertClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiAlert", [
    "root",
    "action",
    "icon",
    "message",
    "filled",
    "colorSuccess",
    "colorInfo",
    "colorWarning",
    "colorError",
    "filledSuccess",
    "filledInfo",
    "filledWarning",
    "filledError",
    "outlined",
    "outlinedSuccess",
    "outlinedInfo",
    "outlinedWarning",
    "outlinedError",
    "standard",
    "standardSuccess",
    "standardInfo",
    "standardWarning",
    "standardError"
]);
var $21a0aaa51c86f87a$export$2e2bcd8739ae039 = $21a0aaa51c86f87a$var$alertClasses;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");











function $81fcec22c7c6ebd5$export$5e8702d71474f093(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiIconButton", slot);
}
const $81fcec22c7c6ebd5$var$iconButtonClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $81fcec22c7c6ebd5$export$2e2bcd8739ae039 = $81fcec22c7c6ebd5$var$iconButtonClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b4f1e2b6883d2123$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $b4f1e2b6883d2123$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $81fcec22c7c6ebd5$export$5e8702d71474f093), classes);
};
const $b4f1e2b6883d2123$var$IconButtonRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $65o8X.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $65o8X.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $65o8X.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $81fcec22c7c6ebd5$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $b4f1e2b6883d2123$var$IconButton = /*#__PURE__*/ $eZVvM.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $7Z8DW.default)(props, $b4f1e2b6883d2123$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $b4f1e2b6883d2123$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b4f1e2b6883d2123$var$IconButtonRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $b4f1e2b6883d2123$export$2e2bcd8739ae039 = $b4f1e2b6883d2123$var$IconButton;


parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








function $2fade45bdc736673$export$c7c50641356bdfa5(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiSvgIcon", slot);
}
const $2fade45bdc736673$var$svgIconClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $2fade45bdc736673$export$2e2bcd8739ae039 = $2fade45bdc736673$var$svgIconClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $1fd924c4c188e5f7$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $1fd924c4c188e5f7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $2fade45bdc736673$export$c7c50641356bdfa5), classes);
};
const $1fd924c4c188e5f7$var$SvgIconRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $1fd924c4c188e5f7$var$SvgIcon = /*#__PURE__*/ $eZVvM.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $7Z8DW.default)(props, $1fd924c4c188e5f7$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $eZVvM.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $1fd924c4c188e5f7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($1fd924c4c188e5f7$var$SvgIconRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $3pI8R.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$1fd924c4c188e5f7$var$SvgIcon.muiName = "SvgIcon";
var $1fd924c4c188e5f7$export$2e2bcd8739ae039 = $1fd924c4c188e5f7$var$SvgIcon;



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $7c53f9f4c83b6b0b$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $1fd924c4c188e5f7$export$2e2bcd8739ae039), (0, $65o8X.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $1fd924c4c188e5f7$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $eZVvM.memo(/*#__PURE__*/ $eZVvM.forwardRef(Component));
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a926ba753c7f46bd$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d7b048ba3ccda7a5$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $e912761aa747c4e6$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $b6e4a26f234550f6$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $12bec17d627bfb46$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9f5b72beddf4b2af$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $9f5b72beddf4b2af$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            "icon"
        ],
        message: [
            "message"
        ],
        action: [
            "action"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $21a0aaa51c86f87a$export$69aecd24bc2cf7e3), classes);
};
const $9f5b72beddf4b2af$var$AlertRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiAlert",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === "light" ? (0, $6ae574cb2ebbc3ad$exports.darken) : (0, $6ae574cb2ebbc3ad$exports.lighten);
    const getBackgroundColor = theme.palette.mode === "light" ? (0, $6ae574cb2ebbc3ad$exports.lighten) : (0, $6ae574cb2ebbc3ad$exports.darken);
    return (0, $65o8X.default)({}, theme.typography.body2, {
        backgroundColor: "transparent",
        display: "flex",
        padding: "6px 16px",
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "standard"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $21a0aaa51c86f87a$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "outlined"
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $21a0aaa51c86f87a$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: "filled"
                    },
                    style: (0, $65o8X.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === "dark" ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $9f5b72beddf4b2af$var$AlertIcon = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAlert",
    slot: "Icon",
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: "7px 0",
    display: "flex",
    fontSize: 22,
    opacity: 0.9
});
const $9f5b72beddf4b2af$var$AlertMessage = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAlert",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0",
    minWidth: 0,
    overflow: "auto"
});
const $9f5b72beddf4b2af$var$AlertAction = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAlert",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "flex-start",
    padding: "4px 0 0 16px",
    marginLeft: "auto",
    marginRight: -8
});
const $9f5b72beddf4b2af$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a926ba753c7f46bd$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d7b048ba3ccda7a5$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $e912761aa747c4e6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $b6e4a26f234550f6$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $9f5b72beddf4b2af$var$Alert = /*#__PURE__*/ $eZVvM.forwardRef(function Alert(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiAlert"
    });
    const { action: action, children: children, className: className, closeText: closeText = "Close", color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $9f5b72beddf4b2af$var$defaultIconMapping, onClose: onClose, role: role = "alert", severity: severity = "success", slotProps: slotProps = {}, slots: slots = {}, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $9f5b72beddf4b2af$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $9f5b72beddf4b2af$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $65o8X.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $65o8X.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $d63981feaa800455$export$2e2bcd8739ae039)("closeButton", {
        elementType: (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $d63981feaa800455$export$2e2bcd8739ae039)("closeIcon", {
        elementType: (0, $12bec17d627bfb46$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($9f5b72beddf4b2af$var$AlertRoot, (0, $65o8X.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $9f5b72beddf4b2af$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $3pI8R.jsx)($9f5b72beddf4b2af$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)(CloseButtonSlot, (0, $65o8X.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $3pI8R.jsx)(CloseIconSlot, (0, $65o8X.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $9f5b72beddf4b2af$export$2e2bcd8739ae039 = $9f5b72beddf4b2af$var$Alert;


var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








function $793f95c9fe77780b$export$5269a5bce2c2f987(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiAlertTitle", slot);
}
const $793f95c9fe77780b$var$alertTitleClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiAlertTitle", [
    "root"
]);
var $793f95c9fe77780b$export$2e2bcd8739ae039 = $793f95c9fe77780b$var$alertTitleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $5f8470a21fce7db8$var$_excluded = [
    "className"
];
const $5f8470a21fce7db8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $793f95c9fe77780b$export$5269a5bce2c2f987), classes);
};
const $5f8470a21fce7db8$var$AlertTitleRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
    name: "MuiAlertTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    return {
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: -2
    };
});
const $5f8470a21fce7db8$var$AlertTitle = /*#__PURE__*/ $eZVvM.forwardRef(function AlertTitle(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiAlertTitle"
    });
    const { className: className } = props, other = (0, $7Z8DW.default)(props, $5f8470a21fce7db8$var$_excluded);
    const ownerState = props;
    const classes = $5f8470a21fce7db8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($5f8470a21fce7db8$var$AlertTitleRoot, (0, $65o8X.default)({
        gutterBottom: true,
        component: "div",
        ownerState: ownerState,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $5f8470a21fce7db8$export$2e2bcd8739ae039 = $5f8470a21fce7db8$var$AlertTitle;


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");




"use client";
const $903cc469e8b3c0b5$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $903cc469e8b3c0b5$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $7Z8DW.default)(parameters, $903cc469e8b3c0b5$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $c4f71c307399daa8$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $199ddfc215453045$export$2e2bcd8739ae039)((0, $65o8X.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $83048e33da74ce9f$export$2e2bcd8739ae039)(elementType, (0, $65o8X.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $903cc469e8b3c0b5$export$2e2bcd8739ae039 = $903cc469e8b3c0b5$var$useSlotProps;



var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");


"use client";
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $4e2553e6b5bfc776$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    $eZVvM.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, "escapeKeyDown");
            }
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, "timeout");
        });
    });
    $eZVvM.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, "clickaway");
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $eZVvM.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $eZVvM.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener("focus", handleResume);
            window.addEventListener("blur", handlePause);
            return ()=>{
                window.removeEventListener("focus", handleResume);
                window.removeEventListener("blur", handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $65o8X.default)({}, (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(parameters), (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(externalProps));
        return (0, $65o8X.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: "presentation"
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $4e2553e6b5bfc776$export$2e2bcd8739ae039 = $4e2553e6b5bfc776$var$useSnackbar;



var $eZVvM = parcelRequire("eZVvM");

function $f99b0b65b9b991aa$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $5b7a50565d709b45$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $5b7a50565d709b45$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $5b7a50565d709b45$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = "onClick", onClickAway: onClickAway, touchEvent: touchEvent = "onTouchEnd" } = props;
    const movedRef = $eZVvM.useRef(false);
    const nodeRef = $eZVvM.useRef(null);
    const activatedRef = $eZVvM.useRef(false);
    const syntheticEventRef = $eZVvM.useRef(false);
    $eZVvM.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(// @ts-expect-error TODO upstream fix
    children.ref, nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || "clientX" in event && $5b7a50565d709b45$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $eZVvM.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $5b7a50565d709b45$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $eZVvM.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $5b7a50565d709b45$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: /*#__PURE__*/ $eZVvM.cloneElement(children, childrenProps)
    });
}






var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c673d3c31a06f300$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $c673d3c31a06f300$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $c673d3c31a06f300$var$styles = {
    entering: {
        opacity: 1,
        transform: $c673d3c31a06f300$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $c673d3c31a06f300$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $c673d3c31a06f300$var$Grow = /*#__PURE__*/ $eZVvM.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $c673d3c31a06f300$var$_excluded);
    const timer = (0, $dbc2a71359ae6439$export$2e2bcd8739ae039)();
    const autoTimeout = $eZVvM.useRef();
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const nodeRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $c673d3c31a06f300$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $c673d3c31a06f300$var$isWebKit154 ? duration : duration * 0.666,
                delay: $c673d3c31a06f300$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $c673d3c31a06f300$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                style: (0, $65o8X.default)({
                    opacity: 0,
                    transform: $c673d3c31a06f300$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $c673d3c31a06f300$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$c673d3c31a06f300$var$Grow.muiSupportAuto = true;
var $c673d3c31a06f300$export$2e2bcd8739ae039 = $c673d3c31a06f300$var$Grow;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");









function $5252cdc0c67e5f55$export$def81488db1a3216(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiSnackbarContent", slot);
}
const $5252cdc0c67e5f55$var$snackbarContentClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiSnackbarContent", [
    "root",
    "message",
    "action"
]);
var $5252cdc0c67e5f55$export$2e2bcd8739ae039 = $5252cdc0c67e5f55$var$snackbarContentClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $8238c2fc66c9a170$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $8238c2fc66c9a170$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        action: [
            "action"
        ],
        message: [
            "message"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $5252cdc0c67e5f55$export$def81488db1a3216), classes);
};
const $8238c2fc66c9a170$var$SnackbarContentRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiSnackbarContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === "light" ? 0.8 : 0.98;
    const backgroundColor = (0, $6ae574cb2ebbc3ad$exports.emphasize)(theme.palette.background.default, emphasis);
    return (0, $65o8X.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            flexGrow: "initial",
            minWidth: 288
        }
    });
});
const $8238c2fc66c9a170$var$SnackbarContentMessage = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiSnackbarContent",
    slot: "Message",
    overridesResolver: (props, styles)=>styles.message
})({
    padding: "8px 0"
});
const $8238c2fc66c9a170$var$SnackbarContentAction = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiSnackbarContent",
    slot: "Action",
    overridesResolver: (props, styles)=>styles.action
})({
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: 16,
    marginRight: -8
});
const $8238c2fc66c9a170$var$SnackbarContent = /*#__PURE__*/ $eZVvM.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiSnackbarContent"
    });
    const { action: action, className: className, message: message, role: role = "alert" } = props, other = (0, $7Z8DW.default)(props, $8238c2fc66c9a170$var$_excluded);
    const ownerState = props;
    const classes = $8238c2fc66c9a170$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($8238c2fc66c9a170$var$SnackbarContentRoot, (0, $65o8X.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($8238c2fc66c9a170$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $3pI8R.jsx)($8238c2fc66c9a170$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $8238c2fc66c9a170$export$2e2bcd8739ae039 = $8238c2fc66c9a170$var$SnackbarContent;




function $ffaba9ddbc2c83d9$export$6cb096457f5926f4(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiSnackbar", slot);
}
const $ffaba9ddbc2c83d9$var$snackbarClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiSnackbar", [
    "root",
    "anchorOriginTopCenter",
    "anchorOriginBottomCenter",
    "anchorOriginTopRight",
    "anchorOriginBottomRight",
    "anchorOriginTopLeft",
    "anchorOriginBottomLeft"
]);
var $ffaba9ddbc2c83d9$export$2e2bcd8739ae039 = $ffaba9ddbc2c83d9$var$snackbarClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9e69d8ac72f40e0c$var$_excluded = [
    "onEnter",
    "onExited"
], $9e69d8ac72f40e0c$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $9e69d8ac72f40e0c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            "root",
            `anchorOrigin${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $ffaba9ddbc2c83d9$export$6cb096457f5926f4), classes);
};
const $9e69d8ac72f40e0c$var$SnackbarRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiSnackbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
    };
    return (0, $65o8X.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: "fixed",
        display: "flex",
        left: 8,
        right: 8,
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.anchorOrigin.vertical === "top" ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === "left" && {
        justifyContent: "flex-start"
    }, ownerState.anchorOrigin.horizontal === "right" && {
        justifyContent: "flex-end"
    }, {
        [theme.breakpoints.up("sm")]: (0, $65o8X.default)({}, ownerState.anchorOrigin.vertical === "top" ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === "center" && center, ownerState.anchorOrigin.horizontal === "left" && {
            left: 24,
            right: "auto"
        }, ownerState.anchorOrigin.horizontal === "right" && {
            right: 24,
            left: "auto"
        })
    });
});
const $9e69d8ac72f40e0c$var$Snackbar = /*#__PURE__*/ $eZVvM.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiSnackbar"
    });
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: "bottom",
        horizontal: "left"
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $c673d3c31a06f300$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $9e69d8ac72f40e0c$var$_excluded), other = (0, $7Z8DW.default)(props, $9e69d8ac72f40e0c$var$_excluded2);
    const ownerState = (0, $65o8X.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $9e69d8ac72f40e0c$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $4e2553e6b5bfc776$export$2e2bcd8739ae039)((0, $65o8X.default)({}, ownerState));
    const [exited, setExited] = $eZVvM.useState(true);
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: $9e69d8ac72f40e0c$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5b7a50565d709b45$export$58385c17fee43f89), (0, $65o8X.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($9e69d8ac72f40e0c$var$SnackbarRoot, (0, $65o8X.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === "top" ? "down" : "up",
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8238c2fc66c9a170$export$2e2bcd8739ae039), (0, $65o8X.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $9e69d8ac72f40e0c$export$2e2bcd8739ae039 = $9e69d8ac72f40e0c$var$Snackbar;




var $219y6 = parcelRequire("219y6");

var $cD0nt = parcelRequire("cD0nt");
const $0cca73f3bb308eb7$var$StyledSnackbar = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $9e69d8ac72f40e0c$export$2e2bcd8739ae039))(({ theme: theme })=>({
        right: 0,
        bottom: 0,
        left: 0,
        [theme.breakpoints.up("sm")]: {
            right: 0,
            bottom: 0,
            left: 0
        }
    }));
const $0cca73f3bb308eb7$var$OfflineAlert = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "offline"
    ]);
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    const isRoot = pathname === "/";
    return /*#__PURE__*/ (0, $bhfvP.jsx)($0cca73f3bb308eb7$var$StyledSnackbar, {
        open: !(online || !isRoot),
        sx: {
            right: 0,
            bottom: 0,
            left: 0
        },
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9f5b72beddf4b2af$export$2e2bcd8739ae039), {
            severity: "error",
            sx: {
                "& .MuiAlert-icon": {
                    fontSize: "8rem"
                }
            },
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5f8470a21fce7db8$export$2e2bcd8739ae039), {
                    sx: {
                        fontSize: "5rem"
                    },
                    children: t("offline:title")
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: t("offline:receptionMessage")
                }),
                receptionistPhone && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h2",
                    children: t("offline:check", {
                        receptionistPhone: receptionistPhone
                    })
                })
            ]
        })
    });
};
var $0cca73f3bb308eb7$export$2e2bcd8739ae039 = $0cca73f3bb308eb7$var$OfflineAlert;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");




var $34d716961b2f75e7$exports = {};
"use strict";
var $ad21c7b874c12cd7$exports = {};
"use strict";
var $05b63fac90a2e10f$exports = {};
"use strict";

var $9Jpsw = parcelRequire("9Jpsw");
var $00bd3cb93ddc1ee6$exports = {};
"use strict";

var $9Jpsw = parcelRequire("9Jpsw");
var $0399158b930ce423$exports = {};
"use strict";

var $49cgi = parcelRequire("49cgi");

var $9Jpsw = parcelRequire("9Jpsw");
var $b88d7ed430c64405$exports = {};
"use strict";

var $9Jpsw = parcelRequire("9Jpsw");
var $0d83191141f01df9$exports = {};
"use strict";

var $32FwR = parcelRequire("32FwR");

var $73Rnx = parcelRequire("73Rnx");

var $lC2xF = parcelRequire("lC2xF");
var $6ae994c67970949d$exports = {};
"use strict";

var $9Jpsw = parcelRequire("9Jpsw");
var $6ae994c67970949d$var$$gOPD = $9Jpsw("%Object.getOwnPropertyDescriptor%", true);
if ($6ae994c67970949d$var$$gOPD) try {
    $6ae994c67970949d$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $6ae994c67970949d$var$$gOPD = null;
}
$6ae994c67970949d$exports = $6ae994c67970949d$var$$gOPD;


/** @type {import('.')} */ $0d83191141f01df9$exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $lC2xF("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $lC2xF("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $lC2xF("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $lC2xF("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $lC2xF("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $lC2xF("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$6ae994c67970949d$exports && $6ae994c67970949d$exports(obj, property);
    if ($32FwR) $32FwR(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $73Rnx("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};



var $b88d7ed430c64405$var$hasDescriptors = (parcelRequire("g83Bu"))();


var $lC2xF = parcelRequire("lC2xF");
var $b88d7ed430c64405$var$$floor = $9Jpsw("%Math.floor%");
/** @type {import('.')} */ $b88d7ed430c64405$exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $lC2xF("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $b88d7ed430c64405$var$$floor(length) !== length) throw new $lC2xF("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $6ae994c67970949d$exports) {
        var desc = $6ae994c67970949d$exports(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($b88d7ed430c64405$var$hasDescriptors) $0d83191141f01df9$exports(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $0d83191141f01df9$exports(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};



var $lC2xF = parcelRequire("lC2xF");
var $0399158b930ce423$var$$apply = $9Jpsw("%Function.prototype.apply%");
var $0399158b930ce423$var$$call = $9Jpsw("%Function.prototype.call%");
var $0399158b930ce423$var$$reflectApply = $9Jpsw("%Reflect.apply%", true) || $49cgi.call($0399158b930ce423$var$$call, $0399158b930ce423$var$$apply);

var $32FwR = parcelRequire("32FwR");
var $0399158b930ce423$var$$max = $9Jpsw("%Math.max%");
$0399158b930ce423$exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $lC2xF("a function is required");
    var func = $0399158b930ce423$var$$reflectApply($49cgi, $0399158b930ce423$var$$call, arguments);
    return $b88d7ed430c64405$exports(func, 1 + $0399158b930ce423$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $0399158b930ce423$var$applyBind = function applyBind() {
    return $0399158b930ce423$var$$reflectApply($49cgi, $0399158b930ce423$var$$apply, arguments);
};
if ($32FwR) $32FwR($0399158b930ce423$exports, "apply", {
    value: $0399158b930ce423$var$applyBind
});
else $0399158b930ce423$exports.apply = $0399158b930ce423$var$applyBind;


var $00bd3cb93ddc1ee6$var$$indexOf = $0399158b930ce423$exports($9Jpsw("String.prototype.indexOf"));
$00bd3cb93ddc1ee6$exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $9Jpsw(name, !!allowMissing);
    if (typeof intrinsic === "function" && $00bd3cb93ddc1ee6$var$$indexOf(name, ".prototype.") > -1) return $0399158b930ce423$exports(intrinsic);
    return intrinsic;
};


var $1dc05859d5b5abe9$exports = {};
var $1dc05859d5b5abe9$var$hasMap = typeof Map === "function" && Map.prototype;
var $1dc05859d5b5abe9$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $1dc05859d5b5abe9$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $1dc05859d5b5abe9$var$mapSize = $1dc05859d5b5abe9$var$hasMap && $1dc05859d5b5abe9$var$mapSizeDescriptor && typeof $1dc05859d5b5abe9$var$mapSizeDescriptor.get === "function" ? $1dc05859d5b5abe9$var$mapSizeDescriptor.get : null;
var $1dc05859d5b5abe9$var$mapForEach = $1dc05859d5b5abe9$var$hasMap && Map.prototype.forEach;
var $1dc05859d5b5abe9$var$hasSet = typeof Set === "function" && Set.prototype;
var $1dc05859d5b5abe9$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $1dc05859d5b5abe9$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $1dc05859d5b5abe9$var$setSize = $1dc05859d5b5abe9$var$hasSet && $1dc05859d5b5abe9$var$setSizeDescriptor && typeof $1dc05859d5b5abe9$var$setSizeDescriptor.get === "function" ? $1dc05859d5b5abe9$var$setSizeDescriptor.get : null;
var $1dc05859d5b5abe9$var$setForEach = $1dc05859d5b5abe9$var$hasSet && Set.prototype.forEach;
var $1dc05859d5b5abe9$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $1dc05859d5b5abe9$var$weakMapHas = $1dc05859d5b5abe9$var$hasWeakMap ? WeakMap.prototype.has : null;
var $1dc05859d5b5abe9$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $1dc05859d5b5abe9$var$weakSetHas = $1dc05859d5b5abe9$var$hasWeakSet ? WeakSet.prototype.has : null;
var $1dc05859d5b5abe9$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $1dc05859d5b5abe9$var$weakRefDeref = $1dc05859d5b5abe9$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $1dc05859d5b5abe9$var$booleanValueOf = Boolean.prototype.valueOf;
var $1dc05859d5b5abe9$var$objectToString = Object.prototype.toString;
var $1dc05859d5b5abe9$var$functionToString = Function.prototype.toString;
var $1dc05859d5b5abe9$var$$match = String.prototype.match;
var $1dc05859d5b5abe9$var$$slice = String.prototype.slice;
var $1dc05859d5b5abe9$var$$replace = String.prototype.replace;
var $1dc05859d5b5abe9$var$$toUpperCase = String.prototype.toUpperCase;
var $1dc05859d5b5abe9$var$$toLowerCase = String.prototype.toLowerCase;
var $1dc05859d5b5abe9$var$$test = RegExp.prototype.test;
var $1dc05859d5b5abe9$var$$concat = Array.prototype.concat;
var $1dc05859d5b5abe9$var$$join = Array.prototype.join;
var $1dc05859d5b5abe9$var$$arrSlice = Array.prototype.slice;
var $1dc05859d5b5abe9$var$$floor = Math.floor;
var $1dc05859d5b5abe9$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $1dc05859d5b5abe9$var$gOPS = Object.getOwnPropertySymbols;
var $1dc05859d5b5abe9$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $1dc05859d5b5abe9$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $1dc05859d5b5abe9$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $1dc05859d5b5abe9$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $1dc05859d5b5abe9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $1dc05859d5b5abe9$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $1dc05859d5b5abe9$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $1dc05859d5b5abe9$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$1dc05859d5b5abe9$var$$floor(-num) : $1dc05859d5b5abe9$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $1dc05859d5b5abe9$var$$slice.call(str, intStr.length + 1);
            return $1dc05859d5b5abe9$var$$replace.call(intStr, sepRegex, "$&_") + "." + $1dc05859d5b5abe9$var$$replace.call($1dc05859d5b5abe9$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $1dc05859d5b5abe9$var$$replace.call(str, sepRegex, "$&_");
}
var $c3e0ac8fd4fdc353$exports = {};
"use strict";


var $1dc05859d5b5abe9$var$inspectCustom = $c3e0ac8fd4fdc353$exports.custom;
var $1dc05859d5b5abe9$var$inspectSymbol = $1dc05859d5b5abe9$var$isSymbol($1dc05859d5b5abe9$var$inspectCustom) ? $1dc05859d5b5abe9$var$inspectCustom : null;
var $1dc05859d5b5abe9$var$quotes = {
    __proto__: null,
    "double": '"',
    single: "'"
};
var $1dc05859d5b5abe9$var$quoteREs = {
    __proto__: null,
    "double": /(["\\])/g,
    single: /(['\\])/g
};
$1dc05859d5b5abe9$exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($1dc05859d5b5abe9$var$has(opts, "quoteStyle") && !$1dc05859d5b5abe9$var$has($1dc05859d5b5abe9$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($1dc05859d5b5abe9$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $1dc05859d5b5abe9$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($1dc05859d5b5abe9$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($1dc05859d5b5abe9$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $1dc05859d5b5abe9$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $1dc05859d5b5abe9$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $1dc05859d5b5abe9$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $1dc05859d5b5abe9$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $1dc05859d5b5abe9$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($1dc05859d5b5abe9$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $1dc05859d5b5abe9$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($1dc05859d5b5abe9$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$1dc05859d5b5abe9$var$isRegExp(obj)) {
        var name = $1dc05859d5b5abe9$var$nameOf(obj);
        var keys = $1dc05859d5b5abe9$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $1dc05859d5b5abe9$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($1dc05859d5b5abe9$var$isSymbol(obj)) {
        var symString = $1dc05859d5b5abe9$var$hasShammedSymbols ? $1dc05859d5b5abe9$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $1dc05859d5b5abe9$var$symToString.call(obj);
        return typeof obj === "object" && !$1dc05859d5b5abe9$var$hasShammedSymbols ? $1dc05859d5b5abe9$var$markBoxed(symString) : symString;
    }
    if ($1dc05859d5b5abe9$var$isElement(obj)) {
        var s = "<" + $1dc05859d5b5abe9$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $1dc05859d5b5abe9$var$wrapQuotes($1dc05859d5b5abe9$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $1dc05859d5b5abe9$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($1dc05859d5b5abe9$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $1dc05859d5b5abe9$var$arrObjKeys(obj, inspect);
        if (indent && !$1dc05859d5b5abe9$var$singleLineValues(xs)) return "[" + $1dc05859d5b5abe9$var$indentedJoin(xs, indent) + "]";
        return "[ " + $1dc05859d5b5abe9$var$$join.call(xs, ", ") + " ]";
    }
    if ($1dc05859d5b5abe9$var$isError(obj)) {
        var parts = $1dc05859d5b5abe9$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$1dc05859d5b5abe9$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $1dc05859d5b5abe9$var$$join.call($1dc05859d5b5abe9$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $1dc05859d5b5abe9$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($1dc05859d5b5abe9$var$inspectSymbol && typeof obj[$1dc05859d5b5abe9$var$inspectSymbol] === "function" && $c3e0ac8fd4fdc353$exports) return $c3e0ac8fd4fdc353$exports(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($1dc05859d5b5abe9$var$isMap(obj)) {
        var mapParts = [];
        if ($1dc05859d5b5abe9$var$mapForEach) $1dc05859d5b5abe9$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $1dc05859d5b5abe9$var$collectionOf("Map", $1dc05859d5b5abe9$var$mapSize.call(obj), mapParts, indent);
    }
    if ($1dc05859d5b5abe9$var$isSet(obj)) {
        var setParts = [];
        if ($1dc05859d5b5abe9$var$setForEach) $1dc05859d5b5abe9$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $1dc05859d5b5abe9$var$collectionOf("Set", $1dc05859d5b5abe9$var$setSize.call(obj), setParts, indent);
    }
    if ($1dc05859d5b5abe9$var$isWeakMap(obj)) return $1dc05859d5b5abe9$var$weakCollectionOf("WeakMap");
    if ($1dc05859d5b5abe9$var$isWeakSet(obj)) return $1dc05859d5b5abe9$var$weakCollectionOf("WeakSet");
    if ($1dc05859d5b5abe9$var$isWeakRef(obj)) return $1dc05859d5b5abe9$var$weakCollectionOf("WeakRef");
    if ($1dc05859d5b5abe9$var$isNumber(obj)) return $1dc05859d5b5abe9$var$markBoxed(inspect(Number(obj)));
    if ($1dc05859d5b5abe9$var$isBigInt(obj)) return $1dc05859d5b5abe9$var$markBoxed(inspect($1dc05859d5b5abe9$var$bigIntValueOf.call(obj)));
    if ($1dc05859d5b5abe9$var$isBoolean(obj)) return $1dc05859d5b5abe9$var$markBoxed($1dc05859d5b5abe9$var$booleanValueOf.call(obj));
    if ($1dc05859d5b5abe9$var$isString(obj)) return $1dc05859d5b5abe9$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$1dc05859d5b5abe9$var$isDate(obj) && !$1dc05859d5b5abe9$var$isRegExp(obj)) {
        var ys = $1dc05859d5b5abe9$var$arrObjKeys(obj, inspect);
        var isPlainObject = $1dc05859d5b5abe9$var$gPO ? $1dc05859d5b5abe9$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $1dc05859d5b5abe9$var$toStringTag && Object(obj) === obj && $1dc05859d5b5abe9$var$toStringTag in obj ? $1dc05859d5b5abe9$var$$slice.call($1dc05859d5b5abe9$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $1dc05859d5b5abe9$var$$join.call($1dc05859d5b5abe9$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $1dc05859d5b5abe9$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $1dc05859d5b5abe9$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $1dc05859d5b5abe9$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $1dc05859d5b5abe9$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $1dc05859d5b5abe9$var$quote(s) {
    return $1dc05859d5b5abe9$var$$replace.call(String(s), /"/g, "&quot;");
}
function $1dc05859d5b5abe9$var$isArray(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object Array]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isDate(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object Date]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isRegExp(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object RegExp]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isError(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object Error]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isString(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object String]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isNumber(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object Number]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
function $1dc05859d5b5abe9$var$isBoolean(obj) {
    return $1dc05859d5b5abe9$var$toStr(obj) === "[object Boolean]" && (!$1dc05859d5b5abe9$var$toStringTag || !(typeof obj === "object" && $1dc05859d5b5abe9$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $1dc05859d5b5abe9$var$isSymbol(obj) {
    if ($1dc05859d5b5abe9$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$1dc05859d5b5abe9$var$symToString) return false;
    try {
        $1dc05859d5b5abe9$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$1dc05859d5b5abe9$var$bigIntValueOf) return false;
    try {
        $1dc05859d5b5abe9$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $1dc05859d5b5abe9$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $1dc05859d5b5abe9$var$has(obj, key) {
    return $1dc05859d5b5abe9$var$hasOwn.call(obj, key);
}
function $1dc05859d5b5abe9$var$toStr(obj) {
    return $1dc05859d5b5abe9$var$objectToString.call(obj);
}
function $1dc05859d5b5abe9$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $1dc05859d5b5abe9$var$$match.call($1dc05859d5b5abe9$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $1dc05859d5b5abe9$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $1dc05859d5b5abe9$var$isMap(x) {
    if (!$1dc05859d5b5abe9$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $1dc05859d5b5abe9$var$mapSize.call(x);
        try {
            $1dc05859d5b5abe9$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isWeakMap(x) {
    if (!$1dc05859d5b5abe9$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $1dc05859d5b5abe9$var$weakMapHas.call(x, $1dc05859d5b5abe9$var$weakMapHas);
        try {
            $1dc05859d5b5abe9$var$weakSetHas.call(x, $1dc05859d5b5abe9$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isWeakRef(x) {
    if (!$1dc05859d5b5abe9$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $1dc05859d5b5abe9$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isSet(x) {
    if (!$1dc05859d5b5abe9$var$setSize || !x || typeof x !== "object") return false;
    try {
        $1dc05859d5b5abe9$var$setSize.call(x);
        try {
            $1dc05859d5b5abe9$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isWeakSet(x) {
    if (!$1dc05859d5b5abe9$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $1dc05859d5b5abe9$var$weakSetHas.call(x, $1dc05859d5b5abe9$var$weakSetHas);
        try {
            $1dc05859d5b5abe9$var$weakMapHas.call(x, $1dc05859d5b5abe9$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $1dc05859d5b5abe9$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $1dc05859d5b5abe9$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $1dc05859d5b5abe9$var$inspectString($1dc05859d5b5abe9$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $1dc05859d5b5abe9$var$quoteREs[opts.quoteStyle || "single"];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $1dc05859d5b5abe9$var$$replace.call($1dc05859d5b5abe9$var$$replace.call(str, quoteRE, "\\$1"), /[\x00-\x1f]/g, $1dc05859d5b5abe9$var$lowbyte);
    return $1dc05859d5b5abe9$var$wrapQuotes(s, "single", opts);
}
function $1dc05859d5b5abe9$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $1dc05859d5b5abe9$var$$toUpperCase.call(n.toString(16));
}
function $1dc05859d5b5abe9$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $1dc05859d5b5abe9$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $1dc05859d5b5abe9$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $1dc05859d5b5abe9$var$indentedJoin(entries, indent) : $1dc05859d5b5abe9$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $1dc05859d5b5abe9$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($1dc05859d5b5abe9$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $1dc05859d5b5abe9$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $1dc05859d5b5abe9$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $1dc05859d5b5abe9$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $1dc05859d5b5abe9$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $1dc05859d5b5abe9$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $1dc05859d5b5abe9$var$arrObjKeys(obj, inspect) {
    var isArr = $1dc05859d5b5abe9$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $1dc05859d5b5abe9$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $1dc05859d5b5abe9$var$gOPS === "function" ? $1dc05859d5b5abe9$var$gOPS(obj) : [];
    var symMap;
    if ($1dc05859d5b5abe9$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$1dc05859d5b5abe9$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($1dc05859d5b5abe9$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($1dc05859d5b5abe9$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $1dc05859d5b5abe9$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($1dc05859d5b5abe9$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}



var $lC2xF = parcelRequire("lC2xF");
var $05b63fac90a2e10f$var$$WeakMap = $9Jpsw("%WeakMap%", true);
var $05b63fac90a2e10f$var$$Map = $9Jpsw("%Map%", true);
var $05b63fac90a2e10f$var$$weakMapGet = $00bd3cb93ddc1ee6$exports("WeakMap.prototype.get", true);
var $05b63fac90a2e10f$var$$weakMapSet = $00bd3cb93ddc1ee6$exports("WeakMap.prototype.set", true);
var $05b63fac90a2e10f$var$$weakMapHas = $00bd3cb93ddc1ee6$exports("WeakMap.prototype.has", true);
var $05b63fac90a2e10f$var$$mapGet = $00bd3cb93ddc1ee6$exports("Map.prototype.get", true);
var $05b63fac90a2e10f$var$$mapSet = $00bd3cb93ddc1ee6$exports("Map.prototype.set", true);
var $05b63fac90a2e10f$var$$mapHas = $00bd3cb93ddc1ee6$exports("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $05b63fac90a2e10f$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $05b63fac90a2e10f$var$listGet = function(objects, key) {
    var node = $05b63fac90a2e10f$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $05b63fac90a2e10f$var$listSet = function(objects, key, value) {
    var node = $05b63fac90a2e10f$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $05b63fac90a2e10f$var$listHas = function(objects, key) {
    return !!$05b63fac90a2e10f$var$listGetNode(objects, key);
};
/** @type {import('.')} */ $05b63fac90a2e10f$exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $lC2xF("Side channel does not contain " + $1dc05859d5b5abe9$exports(key));
        },
        get: function(key) {
            if ($05b63fac90a2e10f$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $05b63fac90a2e10f$var$$weakMapGet($wm, key);
            } else if ($05b63fac90a2e10f$var$$Map) {
                if ($m) return $05b63fac90a2e10f$var$$mapGet($m, key);
            } else {
                if ($o) return $05b63fac90a2e10f$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($05b63fac90a2e10f$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $05b63fac90a2e10f$var$$weakMapHas($wm, key);
            } else if ($05b63fac90a2e10f$var$$Map) {
                if ($m) return $05b63fac90a2e10f$var$$mapHas($m, key);
            } else {
                if ($o) return $05b63fac90a2e10f$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($05b63fac90a2e10f$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $05b63fac90a2e10f$var$$WeakMap();
                $05b63fac90a2e10f$var$$weakMapSet($wm, key, value);
            } else if ($05b63fac90a2e10f$var$$Map) {
                if (!$m) $m = new $05b63fac90a2e10f$var$$Map();
                $05b63fac90a2e10f$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $05b63fac90a2e10f$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};


var $bc66b6a76bc285e5$exports = {};
"use strict";
var $98d79773a98eeeb0$exports = {};
"use strict";
var $98d79773a98eeeb0$var$replace = String.prototype.replace;
var $98d79773a98eeeb0$var$percentTwenties = /%20/g;
var $98d79773a98eeeb0$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$98d79773a98eeeb0$exports = {
    "default": $98d79773a98eeeb0$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $98d79773a98eeeb0$var$replace.call(value, $98d79773a98eeeb0$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $98d79773a98eeeb0$var$Format.RFC1738,
    RFC3986: $98d79773a98eeeb0$var$Format.RFC3986
};


var $bc66b6a76bc285e5$var$has = Object.prototype.hasOwnProperty;
var $bc66b6a76bc285e5$var$isArray = Array.isArray;
var $bc66b6a76bc285e5$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $bc66b6a76bc285e5$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($bc66b6a76bc285e5$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $bc66b6a76bc285e5$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $bc66b6a76bc285e5$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($bc66b6a76bc285e5$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$bc66b6a76bc285e5$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($bc66b6a76bc285e5$var$isArray(target) && !$bc66b6a76bc285e5$var$isArray(source)) mergeTarget = $bc66b6a76bc285e5$var$arrayToObject(target, options);
    if ($bc66b6a76bc285e5$var$isArray(target) && $bc66b6a76bc285e5$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($bc66b6a76bc285e5$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($bc66b6a76bc285e5$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $bc66b6a76bc285e5$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $bc66b6a76bc285e5$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $bc66b6a76bc285e5$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $bc66b6a76bc285e5$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $bc66b6a76bc285e5$var$limit){
        var segment = string.length >= $bc66b6a76bc285e5$var$limit ? string.slice(j, j + $bc66b6a76bc285e5$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $98d79773a98eeeb0$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $bc66b6a76bc285e5$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $bc66b6a76bc285e5$var$hexTable[0xC0 | c >> 6] + $bc66b6a76bc285e5$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $bc66b6a76bc285e5$var$hexTable[0xE0 | c >> 12] + $bc66b6a76bc285e5$var$hexTable[0x80 | c >> 6 & 0x3F] + $bc66b6a76bc285e5$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $bc66b6a76bc285e5$var$hexTable[0xF0 | c >> 18] + $bc66b6a76bc285e5$var$hexTable[0x80 | c >> 12 & 0x3F] + $bc66b6a76bc285e5$var$hexTable[0x80 | c >> 6 & 0x3F] + $bc66b6a76bc285e5$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $bc66b6a76bc285e5$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $bc66b6a76bc285e5$var$compactQueue(queue);
    return value;
};
var $bc66b6a76bc285e5$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $bc66b6a76bc285e5$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $bc66b6a76bc285e5$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $bc66b6a76bc285e5$var$maybeMap = function maybeMap(val, fn) {
    if ($bc66b6a76bc285e5$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$bc66b6a76bc285e5$exports = {
    arrayToObject: $bc66b6a76bc285e5$var$arrayToObject,
    assign: $bc66b6a76bc285e5$var$assign,
    combine: $bc66b6a76bc285e5$var$combine,
    compact: $bc66b6a76bc285e5$var$compact,
    decode: $bc66b6a76bc285e5$var$decode,
    encode: $bc66b6a76bc285e5$var$encode,
    isBuffer: $bc66b6a76bc285e5$var$isBuffer,
    isRegExp: $bc66b6a76bc285e5$var$isRegExp,
    maybeMap: $bc66b6a76bc285e5$var$maybeMap,
    merge: $bc66b6a76bc285e5$var$merge
};



var $ad21c7b874c12cd7$var$has = Object.prototype.hasOwnProperty;
var $ad21c7b874c12cd7$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $ad21c7b874c12cd7$var$isArray = Array.isArray;
var $ad21c7b874c12cd7$var$push = Array.prototype.push;
var $ad21c7b874c12cd7$var$pushToArray = function(arr, valueOrArray) {
    $ad21c7b874c12cd7$var$push.apply(arr, $ad21c7b874c12cd7$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $ad21c7b874c12cd7$var$toISO = Date.prototype.toISOString;
var $ad21c7b874c12cd7$var$defaultFormat = $98d79773a98eeeb0$exports.default;
var $ad21c7b874c12cd7$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $bc66b6a76bc285e5$exports.encode,
    encodeValuesOnly: false,
    format: $ad21c7b874c12cd7$var$defaultFormat,
    formatter: $98d79773a98eeeb0$exports.formatters[$ad21c7b874c12cd7$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $ad21c7b874c12cd7$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $ad21c7b874c12cd7$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $ad21c7b874c12cd7$var$sentinel = {};
var $ad21c7b874c12cd7$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($ad21c7b874c12cd7$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($ad21c7b874c12cd7$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $ad21c7b874c12cd7$var$isArray(obj)) obj = $bc66b6a76bc285e5$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $ad21c7b874c12cd7$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($ad21c7b874c12cd7$var$isNonNullishPrimitive(obj) || $bc66b6a76bc285e5$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $ad21c7b874c12cd7$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $ad21c7b874c12cd7$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $ad21c7b874c12cd7$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $bc66b6a76bc285e5$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($ad21c7b874c12cd7$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $ad21c7b874c12cd7$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $ad21c7b874c12cd7$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $ad21c7b874c12cd7$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $05b63fac90a2e10f$exports();
        valueSideChannel.set($ad21c7b874c12cd7$var$sentinel, sideChannel);
        $ad21c7b874c12cd7$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $ad21c7b874c12cd7$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $ad21c7b874c12cd7$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $ad21c7b874c12cd7$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $ad21c7b874c12cd7$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $98d79773a98eeeb0$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$ad21c7b874c12cd7$var$has.call($98d79773a98eeeb0$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $98d79773a98eeeb0$exports.formatters[format];
    var filter = $ad21c7b874c12cd7$var$defaults.filter;
    if (typeof opts.filter === "function" || $ad21c7b874c12cd7$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $ad21c7b874c12cd7$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $ad21c7b874c12cd7$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $ad21c7b874c12cd7$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $ad21c7b874c12cd7$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $ad21c7b874c12cd7$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $ad21c7b874c12cd7$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $ad21c7b874c12cd7$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $ad21c7b874c12cd7$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $ad21c7b874c12cd7$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $ad21c7b874c12cd7$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $ad21c7b874c12cd7$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $ad21c7b874c12cd7$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $ad21c7b874c12cd7$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $ad21c7b874c12cd7$var$defaults.strictNullHandling
    };
};
$ad21c7b874c12cd7$exports = function(object, opts) {
    var obj = object;
    var options = $ad21c7b874c12cd7$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($ad21c7b874c12cd7$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $ad21c7b874c12cd7$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $05b63fac90a2e10f$exports();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $ad21c7b874c12cd7$var$pushToArray(keys, $ad21c7b874c12cd7$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $1c606d0a7505fbf6$exports = {};
"use strict";

var $1c606d0a7505fbf6$var$has = Object.prototype.hasOwnProperty;
var $1c606d0a7505fbf6$var$isArray = Array.isArray;
var $1c606d0a7505fbf6$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $bc66b6a76bc285e5$exports.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $1c606d0a7505fbf6$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $1c606d0a7505fbf6$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $1c606d0a7505fbf6$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $1c606d0a7505fbf6$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $1c606d0a7505fbf6$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $1c606d0a7505fbf6$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $1c606d0a7505fbf6$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $1c606d0a7505fbf6$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $1c606d0a7505fbf6$var$defaults.decoder, charset, "key");
            val = $bc66b6a76bc285e5$exports.maybeMap($1c606d0a7505fbf6$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $1c606d0a7505fbf6$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $1c606d0a7505fbf6$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $1c606d0a7505fbf6$var$isArray(val) ? [
            val
        ] : val;
        var existing = $1c606d0a7505fbf6$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $bc66b6a76bc285e5$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $1c606d0a7505fbf6$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $1c606d0a7505fbf6$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $1c606d0a7505fbf6$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $1c606d0a7505fbf6$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $1c606d0a7505fbf6$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $1c606d0a7505fbf6$var$parseObject(keys, val, options, valuesParsed);
};
var $1c606d0a7505fbf6$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $1c606d0a7505fbf6$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $1c606d0a7505fbf6$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $1c606d0a7505fbf6$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $1c606d0a7505fbf6$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $1c606d0a7505fbf6$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $1c606d0a7505fbf6$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $1c606d0a7505fbf6$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $1c606d0a7505fbf6$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $1c606d0a7505fbf6$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $1c606d0a7505fbf6$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $1c606d0a7505fbf6$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $1c606d0a7505fbf6$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $bc66b6a76bc285e5$exports.isRegExp(opts.delimiter) ? opts.delimiter : $1c606d0a7505fbf6$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $1c606d0a7505fbf6$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $1c606d0a7505fbf6$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $1c606d0a7505fbf6$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $1c606d0a7505fbf6$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $1c606d0a7505fbf6$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $1c606d0a7505fbf6$var$defaults.strictNullHandling
    };
};
$1c606d0a7505fbf6$exports = function(str, opts) {
    var options = $1c606d0a7505fbf6$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $1c606d0a7505fbf6$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $1c606d0a7505fbf6$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $bc66b6a76bc285e5$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $bc66b6a76bc285e5$exports.compact(obj);
};



$34d716961b2f75e7$exports = {
    formats: $98d79773a98eeeb0$exports,
    parse: $1c606d0a7505fbf6$exports,
    stringify: $ad21c7b874c12cd7$exports
};






var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $95a4afb818733fcb$var$SvgRingBell = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2ZM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917ZM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6Z"
        })
    });
var $95a4afb818733fcb$export$2e2bcd8739ae039 = $95a4afb818733fcb$var$SvgRingBell;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $cb55aa05ae3abc5a$var$SvgCheckIn = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('34cb41a7f0e15623')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M26.38 36.192H3.784a1.785 1.785 0 0 1 0-3.568H26.38a1.785 1.785 0 0 1 0 3.568Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M17.174 45.818a1.902 1.902 0 0 1-1.344-3.247l8.164-8.163-8.163-8.161a1.902 1.902 0 0 1 2.69-2.69l9.506 9.507a1.902 1.902 0 0 1 0 2.69L18.52 45.26c-.372.373-.86.558-1.346.558ZM40.666 80A6.673 6.673 0 0 1 34 73.335v-60a6.71 6.71 0 0 1 4.513-6.33L58.54.327c4.48-1.373 8.793 1.95 8.793 6.34v60a6.712 6.712 0 0 1-4.51 6.327l-20.033 6.68a6.976 6.976 0 0 1-2.124.327Zm20-75c-.216 0-.4.028-.596.087l-19.943 6.65A1.719 1.719 0 0 0 39 13.334v60c0 1.137 1.233 1.903 2.263 1.58l19.943-6.65a1.724 1.724 0 0 0 1.127-1.596v-60A1.67 1.67 0 0 0 60.666 5Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M16.5 16.667a2.5 2.5 0 0 1-2.5-2.5v-5C14 4.11 18.11 0 23.166 0h37.5a2.5 2.5 0 0 1 0 5h-37.5A4.172 4.172 0 0 0 19 9.167v5a2.5 2.5 0 0 1-2.5 2.5ZM36.5 70H23.166C18.11 70 14 65.89 14 60.833v-5a2.5 2.5 0 0 1 5 0v5A4.172 4.172 0 0 0 23.166 65H36.5a2.5 2.5 0 0 1 0 5Z"
                })
            ]
        })
    });
var $cb55aa05ae3abc5a$export$2e2bcd8739ae039 = $cb55aa05ae3abc5a$var$SvgCheckIn;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $04e6c4987292f3cf$var$SvgCheckOut = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("g", {
            clipPath: "url('ee6f29dd85baa145')",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M49.953 36.192H72.55a1.785 1.785 0 0 0 0-3.568H49.953a1.785 1.785 0 0 0 0 3.568Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M62.9 45.818a1.902 1.902 0 0 1-1.344-3.247l8.164-8.163-8.163-8.161a1.902 1.902 0 0 1 2.69-2.69l9.507 9.507a1.902 1.902 0 0 1 0 2.69l-9.507 9.506c-.373.373-.86.558-1.346.558ZM37.667 80a6.673 6.673 0 0 0 6.666-6.666v-60a6.709 6.709 0 0 0-4.513-6.33L19.793.327C15.313-1.046 11 2.277 11 6.667v60a6.712 6.712 0 0 0 4.51 6.327l20.033 6.68c.73.227 1.407.327 2.124.327Zm-20-75c.216 0 .4.028.596.087l19.943 6.65a1.719 1.719 0 0 1 1.127 1.597v60c0 1.137-1.233 1.903-2.263 1.58l-19.943-6.65A1.724 1.724 0 0 1 16 66.668v-60A1.67 1.67 0 0 1 17.667 5Z"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                    d: "M61.833 16.667a2.5 2.5 0 0 0 2.5-2.5v-5C64.333 4.11 60.223 0 55.167 0h-37.5a2.5 2.5 0 0 0 0 5h37.5a4.172 4.172 0 0 1 4.166 4.167v5a2.5 2.5 0 0 0 2.5 2.5ZM41.833 70h13.334c5.056 0 9.166-4.11 9.166-9.167v-5a2.5 2.5 0 0 0-5 0v5A4.172 4.172 0 0 1 55.167 65H41.833a2.5 2.5 0 0 0 0 5Z"
                })
            ]
        })
    });
var $04e6c4987292f3cf$export$2e2bcd8739ae039 = $04e6c4987292f3cf$var$SvgCheckOut;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $930fa341f898fffa$var$SvgFood = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('244df584b480ef85')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M77.656 37.5h-2.5V20.613a8.511 8.511 0 0 0-3.906-7.186V2.344A2.344 2.344 0 0 0 68.906 0h-9.375a2.344 2.344 0 0 0-2.343 2.344v11.083a8.511 8.511 0 0 0-3.907 7.186V25h-4.687v-.781a2.33 2.33 0 0 0-.387-1.288l-.007-.012-.004-.007-.005-.006-5.847-8.772V5.47A2.344 2.344 0 0 0 40 3.125H24.519A11.672 11.672 0 0 0 16.563 0C10.1 0 4.842 5.257 4.842 11.719V37.5h-2.5A2.344 2.344 0 0 0 0 39.844v9.375a2.344 2.344 0 0 0 2.344 2.343h1.18l2.284 20.783A8.583 8.583 0 0 0 14.351 80h51.298c4.39 0 8.063-3.29 8.543-7.655l2.283-20.782h1.181A2.344 2.344 0 0 0 80 49.218v-9.375a2.344 2.344 0 0 0-2.344-2.344ZM61.875 4.687h4.688v3.125h-4.688V4.688Zm-3.906 15.926c0-1.591.955-3.002 2.433-3.593a2.343 2.343 0 0 0 1.473-2.176V12.5h4.688v2.344c0 .958.583 1.82 1.473 2.176a3.852 3.852 0 0 1 2.433 3.593V37.5h-12.5V20.613Zm-4.688 9.075V37.5h-4.687v-7.813h4.687Zm-9.375-3.125V37.5H28.281V26.562h15.625Zm-2.035-4.688H28.28v-4.688h10.465l3.125 4.688ZM37.656 7.812V12.5h-9.375v-.781c0-1.37-.238-2.684-.672-3.906h10.047Zm-28.125 25H15a2.344 2.344 0 0 0 0-4.687H9.531v-4.688H15a2.344 2.344 0 0 0 0-4.687H9.531v-4.688H15a2.344 2.344 0 0 0 0-4.687H9.934c.968-2.728 3.573-4.688 6.629-4.688a7.04 7.04 0 0 1 7.03 7.032V37.5H9.532v-4.688Zm-4.844 9.376h70.626v4.687H4.686v-4.688Zm64.845 29.645a3.901 3.901 0 0 1-3.883 3.48H14.351a3.902 3.902 0 0 1-3.883-3.48L8.24 51.563h63.52l-2.228 20.27Z"
            })
        })
    });
var $930fa341f898fffa$export$2e2bcd8739ae039 = $930fa341f898fffa$var$SvgFood;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $b81cb4882ba767c6$var$SvgParcel = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M68.653 2H10.347a8.535 8.535 0 0 0-5.9 2.447A8.333 8.333 0 0 0 2 10.348v58.306A8.358 8.358 0 0 0 10.348 77h58.305A8.358 8.358 0 0 0 77 68.653V10.347A8.358 8.358 0 0 0 68.653 2ZM49.5 7v21.308L43 25.71a9.375 9.375 0 0 0-7 0l-6.5 2.598V7h20ZM72 68.653A3.352 3.352 0 0 1 68.653 72H10.347A3.352 3.352 0 0 1 7 68.653V10.347A3.352 3.352 0 0 1 10.348 7H24.5v25a2.502 2.502 0 0 0 3.43 2.322l9.925-3.972a4.393 4.393 0 0 1 3.29 0l9.925 3.97A2.5 2.5 0 0 0 54.5 32V7h14.153A3.353 3.353 0 0 1 72 10.348v58.305Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M12 53h10a2.5 2.5 0 0 0 0-5H12a2.5 2.5 0 0 0 0 5ZM32 58H12a2.5 2.5 0 0 0 0 5h20a2.5 2.5 0 0 0 0-5Z"
            })
        ]
    });
var $b81cb4882ba767c6$export$2e2bcd8739ae039 = $b81cb4882ba767c6$var$SvgParcel;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $88bc8aefc62faa68$var$SvgCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('9c117f4f3b274fd8')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.808 11.685c-.384-.4-.848-.615-1.34-.615-.488 0-.956.21-1.356.611l-1.254 1.25c-.103-.056-.206-.108-.305-.16a5.032 5.032 0 0 1-.392-.21c-1.174-.745-2.24-1.717-3.264-2.974-.496-.626-.829-1.154-1.07-1.689.324-.297.626-.607.92-.904.11-.111.221-.226.332-.337.833-.833.833-1.912 0-2.744L6.997 2.83c-.123-.123-.25-.25-.369-.377-.238-.246-.488-.5-.746-.737-.384-.38-.844-.583-1.328-.583-.484 0-.952.202-1.348.583l-.008.008-1.349 1.36a2.901 2.901 0 0 0-.86 1.844c-.095 1.158.246 2.236.508 2.942.642 1.733 1.602 3.34 3.033 5.06a18.66 18.66 0 0 0 6.214 4.866c.912.432 2.13.944 3.49 1.031.083.004.17.008.25.008.916 0 1.685-.33 2.288-.983.004-.008.012-.012.016-.02.206-.25.444-.476.694-.718.17-.163.345-.333.515-.512.393-.408.599-.884.599-1.372 0-.491-.21-.963-.61-1.36l-2.178-2.185Zm1.42 4.176c-.004 0-.004.004 0 0-.155.166-.313.317-.484.484-.258.245-.52.503-.765.793-.4.428-.873.63-1.491.63-.06 0-.123 0-.183-.004-1.178-.075-2.272-.535-3.093-.928a17.616 17.616 0 0 1-5.853-4.584c-1.352-1.63-2.256-3.137-2.855-4.754C2.135 6.51 2 5.74 2.06 5.015a1.82 1.82 0 0 1 .547-1.178l1.352-1.352c.194-.182.4-.281.603-.281.25 0 .452.15.579.277l.012.012c.242.226.472.46.714.71l.376.384L7.326 4.67c.42.42.42.809 0 1.23-.115.114-.226.23-.341.34-.333.341-.65.659-.995.968-.008.008-.016.012-.02.02-.341.34-.278.674-.207.9l.012.036c.282.682.678 1.324 1.281 2.09l.004.004c1.095 1.348 2.249 2.399 3.522 3.204.162.103.329.186.487.265.143.072.278.14.393.21.016.008.032.02.048.028a.86.86 0 0 0 .392.1c.33 0 .536-.207.603-.274l1.356-1.356c.135-.135.35-.298.599-.298.246 0 .448.155.571.29l.008.008 2.185 2.185c.408.404.408.82.004 1.24ZM11.113 4.515a5.029 5.029 0 0 1 2.736 1.42 5.055 5.055 0 0 1 1.42 2.736c.043.262.27.444.527.444.032 0 .06-.004.091-.008a.536.536 0 0 0 .44-.618 6.116 6.116 0 0 0-1.717-3.312A6.116 6.116 0 0 0 11.3 3.46a.538.538 0 0 0-.619.437.53.53 0 0 0 .433.618ZM19.726 8.334A10.063 10.063 0 0 0 16.9 2.881 10.062 10.062 0 0 0 11.446.054a.533.533 0 0 0-.615.436.538.538 0 0 0 .44.619 9.01 9.01 0 0 1 4.874 2.526 8.984 8.984 0 0 1 2.526 4.874c.044.261.27.444.528.444.031 0 .06-.004.09-.008a.525.525 0 0 0 .437-.61Z"
            })
        })
    });
var $88bc8aefc62faa68$export$2e2bcd8739ae039 = $88bc8aefc62faa68$var$SvgCall;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $a41e9611bd61d575$var$SvgNoAppointment = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M85.97 4.794H14.03c-5.495 0-9.966 4.471-9.966 9.966v3.56c0 5.495 4.47 9.966 9.966 9.966h71.94c5.495 0 9.966-4.471 9.966-9.966v-3.56c0-5.495-4.471-9.966-9.966-9.966Zm4.216 13.526a4.221 4.221 0 0 1-4.216 4.216H14.03a4.22 4.22 0 0 1-4.216-4.216v-3.56a4.22 4.22 0 0 1 4.216-4.216h71.94a4.221 4.221 0 0 1 4.216 4.216v3.56Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M54.054 13.54H15.65a3 3 0 1 0 0 6h38.403a3 3 0 1 0 0-6ZM85.97 31.524H14.03c-5.495 0-9.966 4.47-9.966 9.966v3.56c0 5.494 4.47 9.965 9.966 9.965h2.183v9.615a7.794 7.794 0 0 0-2.08-.29c-4.319 0-7.832 3.513-7.832 7.831v14.87c0 2.107.239 4.21.708 6.25a2.876 2.876 0 1 0 5.604-1.29 22.126 22.126 0 0 1-.562-4.96V72.17c0-1.147.934-2.08 2.081-2.08s2.081.933 2.081 2.08v12.347a2.875 2.875 0 1 0 5.75 0V47.226c0-1.148.934-2.081 2.082-2.081 1.147 0 2.081.933 2.081 2.081v31.38a2.875 2.875 0 1 0 5.75 0v-11.39c0-1.148.934-2.082 2.081-2.082s2.081.934 2.081 2.081v11.39a2.875 2.875 0 1 0 5.75 0v-6.434c0-1.147.934-2.08 2.081-2.08s2.081.933 2.081 2.08v6.435a2.875 2.875 0 1 0 5.75 0v-1.478c0-1.148.934-2.082 2.081-2.082 1.149 0 2.082.934 2.082 2.082v9.912c0 1.672-.188 3.341-.561 4.961a2.874 2.874 0 1 0 5.603 1.29c.47-2.044.708-4.146.708-6.25v-9.913c0-4.318-3.513-7.832-7.832-7.832-.869 0-1.702.148-2.484.411-1.036-3.113-3.971-5.367-7.428-5.367-.869 0-1.702.148-2.484.41-1.036-3.112-3.971-5.366-7.428-5.366-.721 0-1.417.106-2.081.29v-4.659H85.97c5.495 0 9.966-4.47 9.966-9.966v-3.56c0-5.494-4.471-9.965-9.966-9.965Zm4.216 13.525a4.221 4.221 0 0 1-4.216 4.216H31.876v-2.039c0-4.318-3.513-7.831-7.831-7.831-4.318 0-7.832 3.513-7.832 7.831v2.039H14.03a4.22 4.22 0 0 1-4.216-4.216v-3.56a4.22 4.22 0 0 1 4.216-4.215h71.94a4.221 4.221 0 0 1 4.216 4.216v3.56Z"
            })
        ]
    });
var $a41e9611bd61d575$export$2e2bcd8739ae039 = $a41e9611bd61d575$var$SvgNoAppointment;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $2865f1f1d57bf7c5$var$SvgOverview = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M214.5 10h-173C37.1 10 10 10 10 41.5v173.1C10 246 41.5 246 41.5 246h173.1c31.5 0 31.5-31.5 31.5-31.5v-173C246 10 218.9 10 214.5 10zm15.8 204.5s0 15.7-15.7 15.7H41.5s-15.7 0-15.7-15.7v-173c0-15.7 11.4-15.7 15.7-15.7h173.1c4.3 0 15.7 0 15.7 15.7v173zM59.4 88.7h137V72.9h-137v15.8zm0 47.2h137v-15.7h-137v15.7zm0 47.2h137v-15.7h-137v15.7z"
        })
    });
var $2865f1f1d57bf7c5$export$2e2bcd8739ae039 = $2865f1f1d57bf7c5$var$SvgOverview;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $102d9630099e4e02$var$SvgWifi = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "Wifi_svg__bi Wifi_svg__bi-wifi",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.384 6.115a.485.485 0 0 0-.047-.736A12.44 12.44 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M13.229 8.271a.482.482 0 0 0-.063-.745A9.46 9.46 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065m-2.183 2.183c.226-.226.185-.605-.1-.75A6.5 6.5 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.5 5.5 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091zM9.06 12.44c.196-.196.198-.52-.04-.66A2 2 0 0 0 8 11.5a2 2 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"
            })
        ]
    });
var $102d9630099e4e02$export$2e2bcd8739ae039 = $102d9630099e4e02$var$SvgWifi;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");


var $bhfvP = parcelRequire("bhfvP");



var $cD0nt = parcelRequire("cD0nt");
const $3f3108db7148688c$var$reveal = {
    initial: {
        opacity: 0,
        y: 105
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.7,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        }
    }
};
const $3f3108db7148688c$var$Reveal = (props)=>{
    const { children: children, disabled: disabled, className: className } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (!animationsEnabled) return children;
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        style: {
            position: "relative",
            width: "fit-content",
            overflow: "hidden"
        },
        className: `h-100 ${className}`,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
            ...!disabled && (0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($3f3108db7148688c$var$reveal),
            className: "h-100 d-flex flex-column justify-content-center",
            children: children
        })
    });
};
var $3f3108db7148688c$export$2e2bcd8739ae039 = $3f3108db7148688c$var$Reveal;



const $09725b2bdf2150cd$var$MUITitle = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme, height: height })=>({
        textAlign: "center",
        padding: "0 12rem",
        "@media screen and (orientation: landscape)": {
            position: "absolute",
            top: "0",
            height: height,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            ".children": {
                padding: "0 8rem",
                minWidth: "107.7rem",
                height: "50%",
                // backdropFilter: "blur(0.8rem)",
                background: "rgba(35, 35, 35, 0.825)",
                borderRadius: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                "& > *": {
                    color: theme.palette.background.default
                },
                "& h1, & h2, & h3, & h4": {
                    fontSize: `${height / 8.5}px`
                },
                "& h3, & h4": {
                    fontSize: `${height / 11}px`
                }
            }
        }
    }));
const $09725b2bdf2150cd$var$Title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ children: children, className: className, disableAnimation: disableAnimation })=>{
    const { height: height } = (0, $8b1dc2b27a20c047$export$cb84c4304c266c20)();
    return /*#__PURE__*/ (0, $bhfvP.jsx)($09725b2bdf2150cd$var$MUITitle, {
        className: className,
        height: height,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3f3108db7148688c$export$2e2bcd8739ae039), {
            disabled: disableAnimation,
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                className: "children",
                children: children
            })
        })
    });
});
var $09725b2bdf2150cd$export$2e2bcd8739ae039 = $09725b2bdf2150cd$var$Title;



var $eZVvM = parcelRequire("eZVvM");
var $908a651fe55bae2a$exports = {};
var $f76b96441ade902a$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f76b96441ade902a$var$nativeFloor = Math.floor, $f76b96441ade902a$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $f76b96441ade902a$var$baseRandom(lower, upper) {
    return lower + $f76b96441ade902a$var$nativeFloor($f76b96441ade902a$var$nativeRandom() * (upper - lower + 1));
}
$f76b96441ade902a$exports = $f76b96441ade902a$var$baseRandom;



var $2bHYF = parcelRequire("2bHYF");
var $8a696056c6b9f3f3$exports = {};
var $cc7ef0ffc70a3a71$exports = {};
var $237400c6af36c8bd$exports = {};
var $c9b3d20d36a4f975$exports = {};
/** Used to match a single whitespace character. */ var $c9b3d20d36a4f975$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $c9b3d20d36a4f975$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $c9b3d20d36a4f975$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$c9b3d20d36a4f975$exports = $c9b3d20d36a4f975$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $237400c6af36c8bd$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $237400c6af36c8bd$var$baseTrim(string) {
    return string ? string.slice(0, $c9b3d20d36a4f975$exports(string) + 1).replace($237400c6af36c8bd$var$reTrimStart, "") : string;
}
$237400c6af36c8bd$exports = $237400c6af36c8bd$var$baseTrim;



var $ghHeQ = parcelRequire("ghHeQ");

var $jc3qQ = parcelRequire("jc3qQ");
/** Used as references for various `Number` constants. */ var $cc7ef0ffc70a3a71$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $cc7ef0ffc70a3a71$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $cc7ef0ffc70a3a71$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $cc7ef0ffc70a3a71$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $cc7ef0ffc70a3a71$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $cc7ef0ffc70a3a71$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($jc3qQ(value)) return $cc7ef0ffc70a3a71$var$NAN;
    if ($ghHeQ(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ghHeQ(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $237400c6af36c8bd$exports(value);
    var isBinary = $cc7ef0ffc70a3a71$var$reIsBinary.test(value);
    return isBinary || $cc7ef0ffc70a3a71$var$reIsOctal.test(value) ? $cc7ef0ffc70a3a71$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $cc7ef0ffc70a3a71$var$reIsBadHex.test(value) ? $cc7ef0ffc70a3a71$var$NAN : +value;
}
$cc7ef0ffc70a3a71$exports = $cc7ef0ffc70a3a71$var$toNumber;


/** Used as references for various `Number` constants. */ var $8a696056c6b9f3f3$var$INFINITY = 1 / 0, $8a696056c6b9f3f3$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $8a696056c6b9f3f3$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $cc7ef0ffc70a3a71$exports(value);
    if (value === $8a696056c6b9f3f3$var$INFINITY || value === -$8a696056c6b9f3f3$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $8a696056c6b9f3f3$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$8a696056c6b9f3f3$exports = $8a696056c6b9f3f3$var$toFinite;


/** Built-in method references without a dependency on `root`. */ var $908a651fe55bae2a$var$freeParseFloat = parseFloat;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $908a651fe55bae2a$var$nativeMin = Math.min, $908a651fe55bae2a$var$nativeRandom = Math.random;
/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */ function $908a651fe55bae2a$var$random(lower, upper, floating) {
    if (floating && typeof floating != "boolean" && $2bHYF(lower, upper, floating)) upper = floating = undefined;
    if (floating === undefined) {
        if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined;
        } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined;
        }
    }
    if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
    } else {
        lower = $8a696056c6b9f3f3$exports(lower);
        if (upper === undefined) {
            upper = lower;
            lower = 0;
        } else upper = $8a696056c6b9f3f3$exports(upper);
    }
    if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
    }
    if (floating || lower % 1 || upper % 1) {
        var rand = $908a651fe55bae2a$var$nativeRandom();
        return $908a651fe55bae2a$var$nativeMin(lower + rand * (upper - lower + $908a651fe55bae2a$var$freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
    }
    return $f76b96441ade902a$exports(lower, upper);
}
$908a651fe55bae2a$exports = $908a651fe55bae2a$var$random;




var $cD0nt = parcelRequire("cD0nt");
const $c09514de52ec46da$var$bump = (delay)=>({
        initial: {
            opacity: 0.75,
            scale: 0.35
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 1,
                delay: delay,
                type: "spring",
                stiffness: 400,
                damping: 20
            }
        },
        tap: {
            scale: 0.95
        },
        exit: {
            scale: 1
        }
    });
const $c09514de52ec46da$var$Bump = (props)=>{
    const { children: children, disabled: disabled } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, {
        ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($c09514de52ec46da$var$bump((0, (/*@__PURE__*/$parcel$interopDefault($908a651fe55bae2a$exports)))(0.45, 0.65)))
    });
};
var $c09514de52ec46da$export$2e2bcd8739ae039 = $c09514de52ec46da$var$Bump;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");





var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $1145d194c528043b$var$SvgTransitonLogo = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: "TransitonLogo_svg__d-block TransitonLogo_svg__w-100",
        viewBox: "0 0 1000 295",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M39.92 226.368h20.254l3.937-20.253H43.858l-3.938 20.253z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "m150.962 219.221-4.259 21.993H22.449L57.633 59.413h22.364l3.575-18.518H42.363L0 259.732h161.973l7.835-40.511h-18.846zm202.091-108.504c10.09-4.257 18.401-10.382 24.936-18.373 6.532-7.99 10.849-17.587 12.95-28.786 2.45-12.25 1.75-23.125-2.101-32.634-3.849-9.507-10.236-16.974-19.16-22.399-8.925-5.424-19.862-8.137-32.81-8.137h-41.297l-22.748 116.716h45.497c13.063 0 24.643-2.127 34.733-6.387Zm-33.334-85.13h13.65c6.763 0 12.45 1.43 17.06 4.287 4.608 2.86 7.845 6.854 9.712 11.986 1.864 5.134 2.1 11.085.7 17.848-1.168 6.535-3.5 12.222-7 17.062-3.5 4.842-7.934 8.574-13.298 11.199-5.368 2.625-11.493 3.937-18.374 3.937H306.77l12.949-66.32Zm100.266 91.517 15.924-82.243h-27.473l-16.099 82.243h27.648zM442.908.213h-28.523l-4.549 23.274h28.523L442.908.213zm25.197 154.338c14.231 0 25.402-3.473 33.511-10.411 8.107-6.943 13.618-17.761 16.535-32.46l13.65-70.345c-5.599-2.914-11.725-5.162-18.373-6.736-6.65-1.576-13.186-2.363-19.6-2.363-9.448 0-17.966 1.604-25.548 4.812-7.584 3.21-13.884 7.904-18.897 14.087-5.019 6.184-8.4 13.765-10.15 22.748-1.517 8.048-1.373 15.398.437 22.047 1.808 6.65 5.075 11.93 9.8 15.836 4.724 3.91 10.701 5.863 17.936 5.863 6.299 0 11.925-1.603 16.887-4.812 2.78-1.8 5.165-3.997 7.23-6.514l-1.368 7.301c-1.4 7.231-3.998 12.424-7.787 15.574-3.794 3.15-8.898 4.724-15.313 4.724-3.967 0-8.137-.76-12.511-2.274a57.915 57.915 0 0 1-12.511-6.125l-11.025 18.548c5.132 3.5 10.79 6.125 16.974 7.875 6.182 1.75 12.89 2.625 20.123 2.625Zm18.638-60.982c-2.51 1.46-5.28 2.187-8.314 2.187-3.15 0-5.717-.875-7.699-2.625-1.984-1.75-3.297-4.228-3.937-7.437-.642-3.208-.555-6.912.262-11.111.815-4.2 2.275-7.758 4.375-10.675 2.1-2.915 4.753-5.132 7.962-6.649 3.208-1.515 6.913-2.275 11.111-2.275 2.801 0 5.365.35 7.7 1.05.87.261 1.761.652 2.663 1.107l-3.888 20.241c-.7 3.85-1.955 7.148-3.761 9.887-1.812 2.742-3.969 4.841-6.474 6.3ZM579.572.213h-28.523L546.5 23.487h28.521L579.572.213zm-22.924 116.891 15.923-82.243H545.1L529 117.104h27.648zm22.046-61.42h12.19l-5.539 28.348c-1.286 7.117-.994 13.359.876 18.723 1.864 5.367 5.132 9.537 9.797 12.512 4.665 2.975 10.44 4.462 17.325 4.462 5.014 0 9.65-.7 13.911-2.1 4.257-1.4 8.136-3.558 11.636-6.475l-7.875-16.973c-1.284 1.285-2.859 2.304-4.723 3.062-1.867.76-3.737 1.137-5.601 1.137-2.917 0-5.161-1.107-6.736-3.324-1.574-2.215-1.956-5.365-1.139-9.45l5.864-29.922h19.861l4.025-20.823H622.76l5.28-26.948h-27.82l-5.266 26.948H582.72l-4.025 20.823Zm75.506 60.019c3.909 2.683 8.896 4.026 14.961 4.026 4.9 0 9.302-.848 13.212-2.538 3.908-1.69 7.115-3.907 9.626-6.65a26.005 26.005 0 0 0 3.039-4.004l-.502 10.567h23.623l8.924-46.196c2.45-12.014.438-21.494-6.039-28.435-6.474-6.94-16.303-10.413-29.483-10.413-6.068 0-12.192.819-18.373 2.45-6.186 1.635-11.667 3.968-16.45 7l8.399 16.973a53.17 53.17 0 0 1 11.46-4.636c4.028-1.108 7.846-1.663 11.464-1.663 5.48 0 9.273 1.4 11.374 4.2 1.767 2.356 2.32 5.761 1.69 10.184-.712-.12-1.412-.278-2.127-.385-4.726-.7-9.13-1.05-13.212-1.05-11.316 0-20.62 2.306-27.912 6.912-7.291 4.61-11.695 10.879-13.21 18.811-.935 5.135-.555 9.887 1.137 14.26 1.69 4.376 4.49 7.905 8.4 10.587Zm16.361-25.897c.702-3.15 2.627-5.569 5.776-7.262 3.149-1.69 7.289-2.537 12.423-2.537 2.985 0 6.247.33 9.72.915l-1.32 7.134c-.467 2.218-1.575 4.318-3.326 6.3-1.748 1.984-3.879 3.586-6.387 4.811s-5.047 1.838-7.61 1.838c-3.619 0-6.272-1.05-7.962-3.15-1.693-2.099-2.13-4.782-1.314-8.05ZM779.926.388h-27.822l-22.748 116.716h27.822L779.926.388zM331.052 209.832c8.688-6.008 14.086-14.377 16.185-25.11 1.633-8.05.99-15.195-1.925-21.437-2.917-6.24-7.584-11.17-13.998-14.786-6.417-3.615-14.234-5.425-23.448-5.425h-40.072L245.046 259.79h28.523l7.976-40.947h14.01l13.011 40.947h30.098l-17.024-45.044c3.401-1.325 6.557-2.94 9.412-4.914Zm-39.11-44.36h11.024c3.85 0 7.114.7 9.8 2.1 2.682 1.4 4.607 3.325 5.774 5.775 1.164 2.45 1.4 5.31.7 8.575-.817 4.666-3.092 8.284-6.825 10.848-3.734 2.568-8.634 3.85-14.698 3.85h-11.843l6.068-31.147Zm121.963 15.049c-5.717-3.85-12.716-5.775-20.998-5.775-7.584 0-14.7 1.693-21.349 5.075-6.648 3.385-12.221 8.11-16.71 14.174-4.492 6.067-7.497 13.066-9.012 20.999-1.75 8.983-1.256 17.06 1.487 24.235 2.74 7.175 7.437 12.834 14.086 16.973 6.65 4.14 14.756 6.213 24.324 6.213 6.764 0 13.21-1.023 19.335-3.063s11.287-4.812 15.487-8.311l-9.8-16.974c-3.5 2.567-6.912 4.462-10.236 5.687-3.325 1.225-6.912 1.837-10.762 1.837-4.55 0-8.311-.844-11.287-2.537-2.975-1.69-5.017-4.113-6.123-7.262-.576-1.633-.896-3.446-.985-5.424h54.617l1.4-7.35c1.633-8.514 1.225-16.098-1.224-22.748-2.45-6.65-6.535-11.9-12.25-15.749Zm-30.972 18.111c2.682-1.69 5.54-2.537 8.574-2.537 3.032 0 5.482.787 7.35 2.363 1.864 1.574 3.12 3.762 3.761 6.561.389 1.7.5 3.643.396 5.774h-29.279c.622-1.897 1.408-3.623 2.374-5.16 1.864-2.976 4.139-5.308 6.824-7.001Zm103.851 38.672c-2.624 1.342-5.454 2.012-8.486 2.012-3.617 0-6.71-.962-9.274-2.887-2.567-1.924-4.375-4.55-5.425-7.875-1.05-3.324-1.168-7.2-.35-11.636.815-3.85 2.187-7.174 4.112-9.974 1.925-2.8 4.345-4.987 7.262-6.562 2.915-1.575 6.064-2.362 9.45-2.362 6.53 0 11.548 2.86 15.047 8.574l18.724-13.298c-3.5-5.95-8.08-10.5-13.737-13.65-5.659-3.149-12.22-4.724-19.686-4.724-8.049 0-15.516 1.662-22.397 4.986-6.884 3.326-12.658 7.963-17.324 13.912-4.667 5.95-7.816 12.949-9.448 20.999-1.635 8.866-.993 16.915 1.925 24.148 2.914 7.233 7.699 12.948 14.348 17.148 6.65 4.2 14.406 6.3 23.273 6.3 13.18 0 24.554-4.726 34.122-14.175l-13.998-17.148c-2.8 2.8-5.514 4.872-8.138 6.212Zm85.216 2.45c-3.325 1.225-6.912 1.837-10.762 1.837-4.549 0-8.31-.844-11.287-2.537-2.974-1.69-5.016-4.113-6.123-7.262-.576-1.633-.896-3.446-.984-5.424h54.618l1.4-7.35c1.632-8.514 1.224-16.098-1.226-22.748-2.45-6.65-6.535-11.9-12.247-15.749-5.718-3.85-12.719-5.775-21-5.775-7.584 0-14.699 1.693-21.35 5.075-6.648 3.385-12.22 8.11-16.709 14.174-4.493 6.067-7.497 13.066-9.013 20.999-1.749 8.983-1.255 17.06 1.487 24.235 2.74 7.175 7.437 12.834 14.087 16.973 6.649 4.14 14.755 6.213 24.323 6.213 6.764 0 13.212-1.023 19.338-3.063 6.123-2.04 11.284-4.812 15.485-8.311l-9.8-16.974c-3.499 2.567-6.911 4.462-10.237 5.687Zm-17.584-41.122c2.682-1.69 5.538-2.537 8.573-2.537 3.033 0 5.483.787 7.35 2.363 1.864 1.574 3.12 3.762 3.763 6.561.388 1.7.5 3.643.394 5.774h-29.28c.623-1.897 1.41-3.623 2.375-5.16 1.864-2.976 4.138-5.308 6.825-7.001Zm130.01-17.586c-4.667-4.082-10.384-6.124-17.149-6.124-6.3 0-12.104 1.634-17.41 4.9-3.533 2.173-6.522 5.032-8.994 8.546l.331-10.821h-24.496l-22.925 117.24h27.824l6.852-35.457c.079.033.156.078.234.11 5.074 2.1 10.528 3.149 16.361 3.149 8.165 0 15.662-1.692 22.487-5.074 6.822-3.382 12.598-8.225 17.323-14.524 4.723-6.3 7.901-13.763 9.536-22.398 1.633-8.282 1.545-15.923-.261-22.924-1.812-6.999-5.047-12.538-9.713-16.623Zm-17.848 38.497c-.701 4.085-2.101 7.612-4.2 10.587-2.1 2.975-4.668 5.221-7.698 6.736-3.036 1.518-6.477 2.275-10.325 2.275-3.903 0-7.746-.797-11.535-2.38l3.835-19.843c.701-3.964 1.952-7.349 3.763-10.15 1.807-2.799 3.993-4.926 6.561-6.386 2.564-1.457 5.306-2.188 8.225-2.188 3.15 0 5.686.876 7.611 2.625 1.925 1.75 3.239 4.23 3.937 7.437.7 3.21.641 6.973-.174 11.287Zm74.806-21.173h19.862l4.024-20.823h-19.805l5.28-26.948h-27.822l-5.265 26.948h-12.235L701.4 198.37h12.19l-5.54 28.347c-1.286 7.118-.993 13.36.876 18.724 1.865 5.367 5.132 9.537 9.797 12.512 4.666 2.975 10.44 4.462 17.326 4.462 5.014 0 9.65-.7 13.911-2.1 4.257-1.4 8.136-3.558 11.635-6.475l-7.874-16.974c-1.284 1.286-2.859 2.305-4.723 3.063-1.868.76-3.737 1.137-5.602 1.137-2.916 0-5.16-1.108-6.735-3.324-1.574-2.215-1.957-5.365-1.14-9.45l5.864-29.922Zm26.334 61.42h27.647l15.923-82.243h-27.471l-16.099 82.243zm22.049-116.891-4.549 23.274h28.52l4.552-23.274h-28.523zm97.553 38.41c-6.712-4.257-14.673-6.387-23.887-6.387-7.935 0-15.285 1.604-22.05 4.812-6.766 3.21-12.452 7.76-17.06 13.649-4.609 5.892-7.67 12.746-9.187 20.56-1.635 9.1-.904 17.323 2.189 24.673 3.088 7.35 7.988 13.154 14.697 17.412 6.709 4.256 14.67 6.387 23.887 6.387 7.932 0 15.25-1.635 21.96-4.9 6.708-3.265 12.365-7.844 16.974-13.737 4.607-5.889 7.67-12.744 9.186-20.56 1.75-9.214 1.078-17.438-2.013-24.673-3.09-7.232-7.99-12.976-14.697-17.236Zm-10.763 39.108c-.7 3.618-2.043 6.825-4.024 9.625-1.985 2.8-4.348 4.988-7.088 6.562-2.743 1.574-5.747 2.363-9.011 2.363-3.5 0-6.417-.903-8.75-2.712-2.334-1.808-3.967-4.375-4.9-7.7-.934-3.325-.992-7.202-.174-11.637.815-3.615 2.157-6.852 4.024-9.711 1.865-2.858 4.227-5.076 7.086-6.65s5.862-2.363 9.014-2.363c3.38 0 6.268.906 8.66 2.713 2.39 1.81 4.082 4.374 5.076 7.7.99 3.324 1.019 7.261.087 11.81Zm119.164-35.958c-4.198-6.357-10.675-9.537-19.422-9.537-6.65 0-12.748 1.634-18.286 4.9-3.907 2.302-7.185 5.247-9.902 8.767l.364-11.042h-24.497l-16.1 82.243h27.648l8.049-41.297c.815-3.965 2.102-7.407 3.85-10.324 1.751-2.914 3.908-5.19 6.474-6.825 2.566-1.632 5.309-2.45 8.225-2.45 3.732 0 6.3 1.373 7.7 4.113 1.399 2.742 1.575 6.737.526 11.987l-8.75 44.796h27.647l9.8-50.22c1.98-10.383.875-18.752-3.326-25.111Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M79.997 59.413 52.995 198.968h20.254l-3.938 20.253h81.651l30.896-159.808H79.997z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "#fff",
                d: "M233.098.384H91.421l-7.849 40.511h120.721l-34.485 178.326h41.223l38.383-198.584L253.351.384h-20.253z"
            })
        ]
    });
var $1145d194c528043b$export$2e2bcd8739ae039 = $1145d194c528043b$var$SvgTransitonLogo;



var $cD0nt = parcelRequire("cD0nt");


const $cd30023ecd93c880$var$FrontAssistLogo = new URL($be8fdf38e0871731$exports);
const $cd30023ecd93c880$var$transitionLogo = {
    initial: {
        opacity: 1
    },
    animate: {
        opacity: 0,
        top: -400,
        visibility: "hidden",
        transition: {
            duration: 0.5,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        },
        transitionEnd: {
            top: "47.5%"
        }
    },
    exit: {
        opacity: 1,
        visibility: "visible",
        top: "50%",
        transition: {
            duration: 0.4,
            delay: 0.2,
            ease: [
                0.33,
                1,
                0.68,
                1
            ]
        }
    }
};
const $cd30023ecd93c880$var$transitionCurve = (initialPath, targetPath)=>{
    return {
        initial: {
            d: initialPath
        },
        animate: {
            d: targetPath,
            transition: {
                duration: 0.5,
                delay: 0.3,
                ease: [
                    0.76,
                    0,
                    0.24,
                    1
                ]
            }
        },
        exit: {
            d: initialPath,
            transition: {
                duration: 0.2,
                ease: [
                    0.76,
                    0,
                    0.24,
                    1
                ]
            }
        }
    };
};
const $cd30023ecd93c880$var$transitionTranslate = {
    initial: {
        top: "-300px"
    },
    animate: {
        top: "-100vh",
        transition: {
            duration: 0.55,
            delay: 0.3,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        },
        transitionEnd: {
            top: "100vh"
        }
    },
    exit: {
        top: "-300px",
        transition: {
            duration: 0.2,
            ease: [
                0.76,
                0,
                0.24,
                1
            ]
        }
    }
};
const $cd30023ecd93c880$var$MUITransitionSvg = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).svg)(({ theme: theme })=>({
        path: {
            fill: theme.palette.primary.main
        }
    }));
const $cd30023ecd93c880$var$SVG = ({ height: height, width: width })=>{
    const initialPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height + 300}
        Q${width / 2} ${height + 600} 0 ${height + 300}
        L0 0
      `;
    const targetPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height}
        Q${width / 2} ${height} 0 ${height}
        L0 0
    `;
    return /*#__PURE__*/ (0, $bhfvP.jsx)($cd30023ecd93c880$var$MUITransitionSvg, {
        ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($cd30023ecd93c880$var$transitionTranslate),
        className: "curve__svg",
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).path, {
            ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($cd30023ecd93c880$var$transitionCurve(initialPath, targetPath))
        })
    });
};
const $cd30023ecd93c880$var$Curve = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const logoUrl = (0, $cD0nt.useLogoUrl)();
    const isFrontAssist = (0, $cac46807e76713b1$export$4f786993a45a8621)();
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (!animationsEnabled) return children;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "curve",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                style: {
                    opacity: !!width ? 1 : 0
                },
                className: "curve__background"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($cd30023ecd93c880$var$transitionLogo),
                className: "curve__logo",
                children: logoUrl || isFrontAssist ? /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    style: {
                        width: "20rem",
                        height: "20rem",
                        backgroundImage: `url("${logoUrl || $cd30023ecd93c880$var$FrontAssistLogo}")`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain"
                    }
                }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $1145d194c528043b$export$2e2bcd8739ae039), {
                    width: "30rem"
                })
            }),
            !!width && /*#__PURE__*/ (0, $bhfvP.jsx)($cd30023ecd93c880$var$SVG, {
                width: width,
                height: height
            }),
            children
        ]
    });
});
var $cd30023ecd93c880$export$2e2bcd8739ae039 = $cd30023ecd93c880$var$Curve;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");






const $a8c73bf5b33f7760$var$SvgIconMap = {
    1001: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("aSeg7"))),
    1002: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("lt98C"))),
    // 1003: React.lazy(() => import("../../assets/icons/Overview.svg")),
    1004: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("iT6wj"))),
    1005: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("4Uyh8"))),
    1006: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("l3WBs"))),
    // client svgs
    2001: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>(parcelRequire("gDYCL")))
};
const $a8c73bf5b33f7760$var$SvgIcon = ({ id: id, width: width })=>{
    const [Icon, setIcon] = (0, $eZVvM.useState)(null);
    (0, $eZVvM.useEffect)(()=>{
        const loadIcon = $a8c73bf5b33f7760$var$SvgIconMap[id];
        if (loadIcon) setIcon(loadIcon);
    }, [
        id
    ]);
    return Icon ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $eZVvM.Suspense), {
        fallback: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {}),
        children: /*#__PURE__*/ (0, $bhfvP.jsx)(Icon, {
            width: width
        })
    }) : null;
};
var $a8c73bf5b33f7760$export$2e2bcd8739ae039 = $a8c73bf5b33f7760$var$SvgIcon;



var $bhfvP = parcelRequire("bhfvP");
var $8cf890d9af2a8c74$exports = {};
"use strict";
var $8cf890d9af2a8c74$var$__importDefault = $8cf890d9af2a8c74$exports && $8cf890d9af2a8c74$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8cf890d9af2a8c74$exports, "__esModule", {
    value: true
});
$8cf890d9af2a8c74$exports.htmlToDOM = $8cf890d9af2a8c74$exports.domToReact = $8cf890d9af2a8c74$exports.attributesToProps = $8cf890d9af2a8c74$exports.Text = $8cf890d9af2a8c74$exports.ProcessingInstruction = $8cf890d9af2a8c74$exports.Element = $8cf890d9af2a8c74$exports.Comment = void 0;
$8cf890d9af2a8c74$exports.default = $8cf890d9af2a8c74$var$HTMLReactParser;

var $8cf890d9af2a8c74$var$html_dom_parser_1 = $8cf890d9af2a8c74$var$__importDefault((parcelRequire("g9V0c")));
$8cf890d9af2a8c74$exports.htmlToDOM = $8cf890d9af2a8c74$var$html_dom_parser_1.default;

var $8cf890d9af2a8c74$var$attributes_to_props_1 = $8cf890d9af2a8c74$var$__importDefault((parcelRequire("6wuhd")));
$8cf890d9af2a8c74$exports.attributesToProps = $8cf890d9af2a8c74$var$attributes_to_props_1.default;

var $8cf890d9af2a8c74$var$dom_to_react_1 = $8cf890d9af2a8c74$var$__importDefault((parcelRequire("65rH0")));
$8cf890d9af2a8c74$exports.domToReact = $8cf890d9af2a8c74$var$dom_to_react_1.default;
var $4809b318ba0eb150$exports = {};
"use strict";
var $4809b318ba0eb150$var$__createBinding = $4809b318ba0eb150$exports && $4809b318ba0eb150$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4809b318ba0eb150$var$__exportStar = $4809b318ba0eb150$exports && $4809b318ba0eb150$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4809b318ba0eb150$var$__createBinding(exports1, m, p);
};
Object.defineProperty($4809b318ba0eb150$exports, "__esModule", {
    value: true
});
$4809b318ba0eb150$exports.DomHandler = void 0;

var $eqgYf = parcelRequire("eqgYf");


$4809b318ba0eb150$var$__exportStar((parcelRequire("cGDDh")), $4809b318ba0eb150$exports);
// Default options
var $4809b318ba0eb150$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $4809b318ba0eb150$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("cGDDh")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $4809b318ba0eb150$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $4809b318ba0eb150$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("cGDDh")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $eqgYf.ElementType.Tag : undefined;
        var element = new (parcelRequire("cGDDh")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $eqgYf.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            var node = new (parcelRequire("cGDDh")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $eqgYf.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("cGDDh")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("cGDDh")).Text("");
        var node = new (parcelRequire("cGDDh")).CDATA([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("cGDDh")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
$4809b318ba0eb150$exports.DomHandler = $4809b318ba0eb150$var$DomHandler;
$4809b318ba0eb150$exports.default = $4809b318ba0eb150$var$DomHandler;


Object.defineProperty($8cf890d9af2a8c74$exports, "Comment", {
    enumerable: true,
    get: function() {
        return $4809b318ba0eb150$exports.Comment;
    }
});
Object.defineProperty($8cf890d9af2a8c74$exports, "Element", {
    enumerable: true,
    get: function() {
        return $4809b318ba0eb150$exports.Element;
    }
});
Object.defineProperty($8cf890d9af2a8c74$exports, "ProcessingInstruction", {
    enumerable: true,
    get: function() {
        return $4809b318ba0eb150$exports.ProcessingInstruction;
    }
});
Object.defineProperty($8cf890d9af2a8c74$exports, "Text", {
    enumerable: true,
    get: function() {
        return $4809b318ba0eb150$exports.Text;
    }
});
var $8cf890d9af2a8c74$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param html - HTML string.
 * @param options - Parser options.
 * @returns - React element(s), empty array, or string.
 */ function $8cf890d9af2a8c74$var$HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (!html) return [];
    return (0, $8cf890d9af2a8c74$var$dom_to_react_1.default)((0, $8cf890d9af2a8c74$var$html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || $8cf890d9af2a8c74$var$domParserOptions), options);
}


var $3a24dab365b1cf9b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8cf890d9af2a8c74$exports))).default || (0, (/*@__PURE__*/$parcel$interopDefault($8cf890d9af2a8c74$exports)));




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");




var $eZVvM = parcelRequire("eZVvM");
"use client";
let $a2ea28bfa453c5f2$var$globalId = 0;
function $a2ea28bfa453c5f2$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $eZVvM.useState(idOverride);
    const id = idOverride || defaultId;
    $eZVvM.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a2ea28bfa453c5f2$var$globalId += 1;
            setDefaultId(`mui-${$a2ea28bfa453c5f2$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $a2ea28bfa453c5f2$var$maybeReactUseId = $eZVvM["useId".toString()];
function $a2ea28bfa453c5f2$export$2e2bcd8739ae039(idOverride) {
    if ($a2ea28bfa453c5f2$var$maybeReactUseId !== undefined) {
        const reactId = $a2ea28bfa453c5f2$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a2ea28bfa453c5f2$var$useGlobalId(idOverride);
}




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







var $eZVvM = parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $9a735760a312790a$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $9a735760a312790a$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $9a735760a312790a$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $9a735760a312790a$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $9a735760a312790a$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $9a735760a312790a$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($9a735760a312790a$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $9a735760a312790a$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$9a735760a312790a$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $9a735760a312790a$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $9a735760a312790a$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $9a735760a312790a$var$defaultGetTabbable, isEnabled: isEnabled = $9a735760a312790a$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $eZVvM.useRef(false);
    const sentinelStart = $eZVvM.useRef(null);
    const sentinelEnd = $eZVvM.useRef(null);
    const nodeToRestore = $eZVvM.useRef(null);
    const reactFocusEventTarget = $eZVvM.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $eZVvM.useRef(false);
    const rootRef = $eZVvM.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $eZVvM.useRef(null);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $eZVvM.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $eZVvM.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $3pI8R.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $9a735760a312790a$export$2e2bcd8739ae039 = $9a735760a312790a$var$FocusTrap;



var $eZVvM = parcelRequire("eZVvM");

var $e4ZGj = parcelRequire("e4ZGj");



var $3pI8R = parcelRequire("3pI8R");
"use client";
function $d431bbc85d36d423$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $d431bbc85d36d423$var$Portal = /*#__PURE__*/ $eZVvM.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $eZVvM.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(/*#__PURE__*/ $eZVvM.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($d431bbc85d36d423$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $eZVvM.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $eZVvM.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: mountNode ? /*#__PURE__*/ $e4ZGj.createPortal(children, mountNode) : mountNode
    });
});
var $d431bbc85d36d423$export$2e2bcd8739ae039 = $d431bbc85d36d423$var$Portal;





var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








function $5513df1d16403230$export$9927a91fd93152bd(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiBackdrop", slot);
}
const $5513df1d16403230$var$backdropClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $5513df1d16403230$export$2e2bcd8739ae039 = $5513df1d16403230$var$backdropClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $d323689de65b1dad$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $d323689de65b1dad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $5513df1d16403230$export$9927a91fd93152bd), classes);
};
const $d323689de65b1dad$var$BackdropRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $d323689de65b1dad$var$Backdrop = /*#__PURE__*/ $eZVvM.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $db075bdb02672c7e$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $7Z8DW.default)(props, $d323689de65b1dad$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $d323689de65b1dad$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($d323689de65b1dad$var$BackdropRoot, (0, $65o8X.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $65o8X.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $d323689de65b1dad$export$2e2bcd8739ae039 = $d323689de65b1dad$var$Backdrop;



var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $c9bdc9b352c474f0$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $2b883556515dfdf6$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $95b4fb93ac7ed8b4$export$2e2bcd8739ae039(node) {
    const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $03d55f7ae7b30e86$var$isOverflowing(container) {
    const doc = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $03d55f7ae7b30e86$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $03d55f7ae7b30e86$var$getPaddingRight(element) {
    return parseInt((0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $03d55f7ae7b30e86$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $03d55f7ae7b30e86$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$03d55f7ae7b30e86$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(element, show);
    });
}
function $03d55f7ae7b30e86$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $03d55f7ae7b30e86$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($03d55f7ae7b30e86$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $2b883556515dfdf6$export$2e2bcd8739ae039)((0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$03d55f7ae7b30e86$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$03d55f7ae7b30e86$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $03d55f7ae7b30e86$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $03d55f7ae7b30e86$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $03d55f7ae7b30e86$var$getHiddenSiblings(container);
        $03d55f7ae7b30e86$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $03d55f7ae7b30e86$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $03d55f7ae7b30e86$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $03d55f7ae7b30e86$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $03d55f7ae7b30e86$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $03d55f7ae7b30e86$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


"use client";
function $02aadfc08eed2b96$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $02aadfc08eed2b96$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $02aadfc08eed2b96$var$defaultManager = new (0, $03d55f7ae7b30e86$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $02aadfc08eed2b96$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $02aadfc08eed2b96$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $eZVvM.useRef({});
    const mountNodeRef = $eZVvM.useRef(null);
    const modalRef = $eZVvM.useRef(null);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $eZVvM.useState(!open);
    const hasTransition = $02aadfc08eed2b96$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $02aadfc08eed2b96$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $eZVvM.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $03d55f7ae7b30e86$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $eZVvM.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $eZVvM.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $eZVvM.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $fa9bbc157eb2c0a8$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $65o8X.default)({}, propsEventHandlers, otherHandlers);
        return (0, $65o8X.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $65o8X.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $c9bdc9b352c474f0$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $c9bdc9b352c474f0$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $02aadfc08eed2b96$export$2e2bcd8739ae039 = $02aadfc08eed2b96$var$useModal;




function $1b5279c4e884991d$export$67960e22b12a638d(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiModal", slot);
}
const $1b5279c4e884991d$var$modalClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $1b5279c4e884991d$export$2e2bcd8739ae039 = $1b5279c4e884991d$var$modalClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $010e20fed2f5ff9a$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $010e20fed2f5ff9a$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $1b5279c4e884991d$export$67960e22b12a638d), classes);
};
const $010e20fed2f5ff9a$var$ModalRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $010e20fed2f5ff9a$var$ModalBackdrop = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d323689de65b1dad$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $010e20fed2f5ff9a$var$Modal = /*#__PURE__*/ $eZVvM.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $010e20fed2f5ff9a$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $7Z8DW.default)(props, $010e20fed2f5ff9a$var$_excluded);
    const propsWithDefaults = (0, $65o8X.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $02aadfc08eed2b96$export$2e2bcd8739ae039)((0, $65o8X.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $65o8X.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $010e20fed2f5ff9a$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $010e20fed2f5ff9a$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $65o8X.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d431bbc85d36d423$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)(RootSlot, (0, $65o8X.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $3pI8R.jsx)(BackdropSlot, (0, $65o8X.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $3pI8R.jsx)((0, $9a735760a312790a$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $eZVvM.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $010e20fed2f5ff9a$export$2e2bcd8739ae039 = $010e20fed2f5ff9a$var$Modal;








function $2adbfb2c9b461f68$export$2177af0aa15c34c2(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDialog", slot);
}
const $2adbfb2c9b461f68$var$dialogClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $2adbfb2c9b461f68$export$2e2bcd8739ae039 = $2adbfb2c9b461f68$var$dialogClasses;



var $eZVvM = parcelRequire("eZVvM");
const $c6eb0b1012d622bb$var$DialogContext = /*#__PURE__*/ $eZVvM.createContext({});
var $c6eb0b1012d622bb$export$2e2bcd8739ae039 = $c6eb0b1012d622bb$var$DialogContext;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b7efd849c463cc27$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $b7efd849c463cc27$var$DialogBackdrop = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d323689de65b1dad$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $b7efd849c463cc27$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $2adbfb2c9b461f68$export$2177af0aa15c34c2), classes);
};
const $b7efd849c463cc27$var$DialogRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $010e20fed2f5ff9a$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $b7efd849c463cc27$var$DialogContainer = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $b7efd849c463cc27$var$DialogPaper = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $2adbfb2c9b461f68$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $b7efd849c463cc27$var$Dialog = /*#__PURE__*/ $eZVvM.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $08c3c2df346a18c6$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $db075bdb02672c7e$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $7Z8DW.default)(props, $b7efd849c463cc27$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $b7efd849c463cc27$var$useUtilityClasses(ownerState);
    const backdropClick = $eZVvM.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $eZVvM.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $b7efd849c463cc27$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $65o8X.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogContainer, {
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $3pI8R.jsx)($b7efd849c463cc27$var$DialogPaper, (0, $65o8X.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $c6eb0b1012d622bb$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $b7efd849c463cc27$export$2e2bcd8739ae039 = $b7efd849c463cc27$var$Dialog;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







function $50a704ab66e6eab1$export$61b0ee1f05fb344e(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDialogContent", slot);
}
const $50a704ab66e6eab1$var$dialogContentClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $50a704ab66e6eab1$export$2e2bcd8739ae039 = $50a704ab66e6eab1$var$dialogContentClasses;




function $5b54c0043a945c99$export$f5d2ec7e4c47e088(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDialogTitle", slot);
}
const $5b54c0043a945c99$var$dialogTitleClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDialogTitle", [
    "root"
]);
var $5b54c0043a945c99$export$2e2bcd8739ae039 = $5b54c0043a945c99$var$dialogTitleClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4baac96c69466163$var$_excluded = [
    "className",
    "dividers"
];
const $4baac96c69466163$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $50a704ab66e6eab1$export$61b0ee1f05fb344e), classes);
};
const $4baac96c69466163$var$DialogContentRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $5b54c0043a945c99$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $4baac96c69466163$var$DialogContent = /*#__PURE__*/ $eZVvM.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $7Z8DW.default)(props, $4baac96c69466163$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        dividers: dividers
    });
    const classes = $4baac96c69466163$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($4baac96c69466163$var$DialogContentRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $4baac96c69466163$export$2e2bcd8739ae039 = $4baac96c69466163$var$DialogContent;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







function $ebaaf8db826d1cf9$export$5e57a444791c63be(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDialogActions", slot);
}
const $ebaaf8db826d1cf9$var$dialogActionsClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $ebaaf8db826d1cf9$export$2e2bcd8739ae039 = $ebaaf8db826d1cf9$var$dialogActionsClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $04c04e378ccee6ce$var$_excluded = [
    "className",
    "disableSpacing"
];
const $04c04e378ccee6ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $ebaaf8db826d1cf9$export$5e57a444791c63be), classes);
};
const $04c04e378ccee6ce$var$DialogActionsRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $04c04e378ccee6ce$var$DialogActions = /*#__PURE__*/ $eZVvM.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $7Z8DW.default)(props, $04c04e378ccee6ce$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $04c04e378ccee6ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($04c04e378ccee6ce$var$DialogActionsRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $04c04e378ccee6ce$export$2e2bcd8739ae039 = $04c04e378ccee6ce$var$DialogActions;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








function $69d1bef0f647023a$export$d9c6dc45f75b0e4f(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDialogContentText", slot);
}
const $69d1bef0f647023a$var$dialogContentTextClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDialogContentText", [
    "root"
]);
var $69d1bef0f647023a$export$2e2bcd8739ae039 = $69d1bef0f647023a$var$dialogContentTextClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c094567c9dcd56f3$var$_excluded = [
    "children",
    "className"
];
const $c094567c9dcd56f3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $69d1bef0f647023a$export$d9c6dc45f75b0e4f), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $c094567c9dcd56f3$var$DialogContentTextRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiDialogContentText",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $c094567c9dcd56f3$var$DialogContentText = /*#__PURE__*/ $eZVvM.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiDialogContentText"
    });
    const { className: className } = props, ownerState = (0, $7Z8DW.default)(props, $c094567c9dcd56f3$var$_excluded);
    const classes = $c094567c9dcd56f3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c094567c9dcd56f3$var$DialogContentTextRoot, (0, $65o8X.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
var $c094567c9dcd56f3$export$2e2bcd8739ae039 = $c094567c9dcd56f3$var$DialogContentText;




const $d48da1c7507a293a$var$animateInstruction = {
    initial: {
        x: "100%"
    },
    animate: {
        x: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        x: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $d48da1c7507a293a$var$InstructionDialog = (props)=>{
    const { instruction: instruction, onDismiss: onDismiss, title: title } = props;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), {
        fullScreen: true,
        open: true,
        transitionDuration: 0,
        component: (0, $d5f8329c0fec877c$export$e25e478948902b8b).div,
        ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($d48da1c7507a293a$var$animateInstruction),
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $4baac96c69466163$export$2e2bcd8739ae039), {
                dividers: true,
                className: "p-0",
                children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                    className: "p-5 d-flex flex-column align-items-center justify-content-center h-100",
                    children: [
                        title && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                            className: "text-center fw-bold",
                            style: {
                                fontSize: "5rem",
                                color: "#000000",
                                marginBottom: "6rem"
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            style: {
                                width: "90%"
                            },
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                className: "ql-snow",
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                    className: "ql-editor",
                                    children: (0, $3a24dab365b1cf9b$export$2e2bcd8739ae039)(instruction || "")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), {
                className: "p-5",
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                    variant: "contained",
                    className: "px-5 me-5 w-25",
                    onClick: onDismiss,
                    children: "OK"
                })
            })
        ]
    });
};
var $d48da1c7507a293a$export$2e2bcd8739ae039 = $d48da1c7507a293a$var$InstructionDialog;



var $1BSKa = parcelRequire("1BSKa");
let $07e411b3523e37a1$var$ctx = null;
const $07e411b3523e37a1$var$getCtx = ()=>{
    if (typeof window === "undefined") return null;
    if (!$07e411b3523e37a1$var$ctx) {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return null;
        try {
            $07e411b3523e37a1$var$ctx = new AudioContextClass();
        } catch (e) {
            return null;
        }
    }
    if ($07e411b3523e37a1$var$ctx.state === "suspended") $07e411b3523e37a1$var$ctx.resume().catch(()=>{});
    return $07e411b3523e37a1$var$ctx;
};
const $07e411b3523e37a1$var$beep = (freq, durationMs, volume = 0.35, type = "triangle")=>{
    const audioCtx = $07e411b3523e37a1$var$getCtx();
    if (!audioCtx) return;
    try {
        const oscillator = audioCtx.createOscillator();
        const gain = audioCtx.createGain();
        oscillator.type = type;
        oscillator.frequency.value = freq;
        const now = audioCtx.currentTime;
        const dur = durationMs / 1000;
        const attack = 0.008;
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.linearRampToValueAtTime(volume, now + attack);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + dur);
        oscillator.connect(gain);
        gain.connect(audioCtx.destination);
        oscillator.start(now);
        oscillator.stop(now + dur + 0.02);
    } catch (e) {
    // ignore audio errors — kiosk should never break because of feedback
    }
};
const $07e411b3523e37a1$export$20bce071482dbd79 = ()=>{
    $07e411b3523e37a1$var$beep(1047, 90, 0.35);
    setTimeout(()=>$07e411b3523e37a1$var$beep(1319, 90, 0.35), 95);
    setTimeout(()=>$07e411b3523e37a1$var$beep(1568, 160, 0.4), 190);
};
const $07e411b3523e37a1$export$57ae67615ee4f979 = ()=>{
    $07e411b3523e37a1$var$beep(392, 200, 0.4);
    setTimeout(()=>$07e411b3523e37a1$var$beep(311, 280, 0.4), 220);
};
const $07e411b3523e37a1$export$c4b924de6dad976b = ()=>{
    $07e411b3523e37a1$var$beep(500, 70, 0.22);
};



var $eZVvM = parcelRequire("eZVvM");

var $k55lg = parcelRequire("k55lg");

var $8xLkR = parcelRequire("8xLkR");
const $5112160982de6c43$var$useIdleEffect = (onIdle, timeout = 180000, active = true)=>{
    const idle = (0, (/*@__PURE__*/$parcel$interopDefault($k55lg)))(timeout, false);
    const prevIdle = (0, (/*@__PURE__*/$parcel$interopDefault($8xLkR)))(idle);
    (0, $eZVvM.useEffect)(()=>{
        if (!active) return;
        if (!prevIdle && idle) onIdle();
    }, [
        idle,
        prevIdle,
        active
    ]);
};
var $5112160982de6c43$export$2e2bcd8739ae039 = $5112160982de6c43$var$useIdleEffect;



var $cD0nt = parcelRequire("cD0nt");

var $eZVvM = parcelRequire("eZVvM");
const $3e6f7d6cf79bb323$export$41a91d172b3ade30 = ({ inputRef: inputRef, enabled: enabled, onScan: onScan, minLength: minLength = 4, maxDelay: maxDelay = 100, preventDefault: preventDefault = true })=>{
    const bufferRef = (0, $eZVvM.useRef)("");
    const timeoutRef = (0, $eZVvM.useRef)(null);
    const timestampRef = (0, $eZVvM.useRef)(0);
    const clearBuffer = (0, $eZVvM.useCallback)(()=>{
        bufferRef.current = "";
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!enabled || !inputRef.current) return;
        const handleKeyDown = (event)=>{
            const now = Date.now();
            const timeSinceLastKey = now - timestampRef.current;
            timestampRef.current = now;
            // reset buffer if too much time passed
            if (timeSinceLastKey > maxDelay * 2 && bufferRef.current) bufferRef.current = "";
            if (event.key === "Enter" || event.key === "Tab") {
                if (preventDefault) event.preventDefault();
                if (bufferRef.current.length >= minLength) {
                    const scannedCode = bufferRef.current.trim();
                    onScan(scannedCode);
                }
                clearBuffer();
                return;
            }
            if (event.key.length !== 1) return;
            if (preventDefault) event.preventDefault();
            bufferRef.current += event.key;
            // auto-submit after maxDelay if no Enter
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>{
                if (bufferRef.current.length >= minLength) {
                    const scannedCode = bufferRef.current.trim();
                    onScan(scannedCode);
                }
                clearBuffer();
            }, maxDelay);
        };
        const el = inputRef.current;
        el.addEventListener("keydown", handleKeyDown);
        // eslint-disable-next-line consistent-return
        return ()=>{
            el.removeEventListener("keydown", handleKeyDown);
            clearBuffer();
        };
    }, [
        inputRef,
        enabled,
        onScan,
        minLength,
        maxDelay,
        preventDefault,
        clearBuffer
    ]);
};



var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");

var $g6uH4 = parcelRequire("g6uH4");

var $fQgQB = parcelRequire("fQgQB");
const $801c1e65c4cb7f68$export$f7dc25f57197f6f8 = (0, $g6uH4.gql)`
  mutation createDeliveryEvent($input: CreateDeliverInput!) {
    createDeliveryEvent(input: $input) {
      id
      receiver {
        id
        email
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_EMPLOYEE_PREFERENCES)}
`;
const $801c1e65c4cb7f68$export$67cd3c48af49d8e3 = (0, $g6uH4.gql)`
  mutation createGuestVisitor($input: CreateGuestVisitor!) {
    createGuestVisitor(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        email
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $801c1e65c4cb7f68$export$edf5bbf13b92c589 = (0, $g6uH4.gql)`
  mutation accessScan($input: MemberAccessCheckInInput!) {
    accessScan(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      metadata
      receiver {
        id
        email
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $801c1e65c4cb7f68$export$176c60b53e487d1a = (0, $g6uH4.gql)`
  mutation createScreenEvent($input: CreateScreenEventInput!) {
    createScreenEvent(input: $input) {
      id
    }
  }
`;
const $801c1e65c4cb7f68$export$255003e9a28fdae2 = (0, $g6uH4.gql)`
  mutation createGuest($input: CreateGuest!) {
    createGuest(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        email
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${(0, $fQgQB.FRAGMENT_OWNER)}
`;
const $801c1e65c4cb7f68$export$a4a94ec8659e687e = (0, $g6uH4.gql)`
  mutation checkOutOwner($id: ID!) {
    checkOutOwner(id: $id) {
      id
      type
    }
  }
`;
const $801c1e65c4cb7f68$export$61dfaad73d5dbaea = (0, $g6uH4.gql)`
  mutation createCustomDeliveryEvent($input: CreateCustomDeliveryInput!) {
    createCustomDeliveryEvent(input: $input) {
      id
      customReceiver {
        phone
      }
    }
  }
`;
const $801c1e65c4cb7f68$export$c6b5d25ca0fed49a = (0, $g6uH4.gql)`
  mutation accessEventCreateVideoRoom($id: ID!) {
    accessEventCreateVideoRoom(id: $id) {
      id
      roomUrl
    }
  }
`;
const $801c1e65c4cb7f68$export$c134e77194a5bf4b = (0, $g6uH4.gql)`
  mutation accessEventDeleteVideoRoom($id: ID!) {
    accessEventDeleteVideoRoom(id: $id)
  }
`;
const $801c1e65c4cb7f68$export$18c24550125dc389 = (0, $g6uH4.gql)`
  mutation accessEventGetCallerAcsTokenAndTargetTeamsUserId($id: ID!) {
    accessEventGetCallerAcsTokenAndTargetTeamsUserId(id: $id) {
      callerAcsToken
      targetTeamsUserId
    }
  }
`;
const $801c1e65c4cb7f68$export$ab2c88964f3da0ba = (0, $g6uH4.gql)`
  mutation accessEventSendDoorOpenedNotification($id: ID!) {
    accessEventSendDoorOpenedNotification(id: $id) {
      id
    }
  }
`;
const $801c1e65c4cb7f68$export$844820ea0d5bdbe = (0, $g6uH4.gql)`
  mutation getCallerAcsTokenAndTargetTeamsUserIds(
    $input: CallerAcsTokenAndTargetTeamsUsersInput!
  ) {
    getCallerAcsTokenAndTargetTeamsUserIds(input: $input) {
      callerAcsToken
      targetTeamsUsers {
        email
        isGroup
        teamsUsers {
          email
          teamsUserId
        }
      }
    }
  }
`;
const $801c1e65c4cb7f68$export$8b0c33549cb7b2d4 = (0, $g6uH4.gql)`
  mutation switchShellyController($input: SwitchShellyControllerInput!) {
    switchShellyController(input: $input)
  }
`;
const $801c1e65c4cb7f68$export$a3dd2c5fafc1020c = (0, $g6uH4.gql)`
  mutation switchTuyaController($input: SwitchTuyaControllerInput!) {
    switchTuyaController(input: $input)
  }
`;


const $dd1b210a8ac55dce$export$a4a767a5e17b7e4d = ({ emails: emails, enabled: enabled = true })=>{
    const { data: data, status: status, isLoading: isLoading, error: error } = (0, $dMu0R.useQuery)([
        "getCallerAcsTokenAndTargetTeamsUserIds",
        emails
    ], ()=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$844820ea0d5bdbe), {
            input: {
                emails: emails
            }
        });
    }, {
        enabled: enabled && emails.length > 0 && emails.every((email)=>!!(email === null || email === void 0 ? void 0 : email.trim())),
        retry: false,
        refetchOnWindowFocus: false
    });
    const callerAcsToken = (0, $eZVvM.useMemo)(()=>{
        var _data_getCallerAcsTokenAndTargetTeamsUserIds;
        return data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds.callerAcsToken;
    }, [
        data
    ]);
    const isGroupCall = (0, $eZVvM.useMemo)(()=>{
        var _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds;
        return data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds.targetTeamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_ = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers[0]) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_ === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_.isGroup;
    }, [
        data
    ]);
    const targetTeamsUserIds = (0, $eZVvM.useMemo)(()=>{
        var _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers__teamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds;
        return data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds.targetTeamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_ = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers[0]) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_ === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers__teamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_.teamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers__teamsUsers === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers__teamsUsers.map((user)=>user.teamsUserId).filter(Boolean).join(",");
    }, [
        data
    ]);
    return {
        callerAcsToken: callerAcsToken,
        targetTeamsUserIds: targetTeamsUserIds,
        isGroupCall: isGroupCall,
        data: data,
        status: status,
        isLoading: isLoading,
        error: error
    };
};



var $219y6 = parcelRequire("219y6");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
const $6a07d408fb40684a$export$5d29bf985f7a8b6f = /*#__PURE__*/ (0, $eZVvM.forwardRef)(({ onKeyDown: onKeyDown }, ref)=>{
    const internalRef = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useImperativeHandle)(ref, ()=>internalRef.current);
    (0, $eZVvM.useEffect)(()=>{
        var _internalRef_current;
        (_internalRef_current = internalRef.current) === null || _internalRef_current === void 0 ? void 0 : _internalRef_current.focus();
    }, []);
    const handleBlur = ()=>{
        var _window, _window1;
        if (((_window = window) === null || _window === void 0 ? void 0 : _window.top) !== ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.self)) // don't refocus if in an iframe
        return;
        setTimeout(()=>{
            var _internalRef_current;
            return (_internalRef_current = internalRef.current) === null || _internalRef_current === void 0 ? void 0 : _internalRef_current.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $bhfvP.jsx)("input", {
        ref: internalRef,
        type: "text",
        inputMode: "none",
        readOnly: true,
        onKeyDown: onKeyDown,
        onBlur: handleBlur,
        autoComplete: "off",
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            opacity: 0,
            pointerEvents: "none"
        }
    });
});



var $eZVvM = parcelRequire("eZVvM");
const $9793d310c112b855$export$bce0a4e3097e182f = (inputRef)=>{
    const [open, setOpen] = (0, $eZVvM.useState)(false);
    const openModal = (0, $eZVvM.useCallback)(()=>setOpen(true), []);
    const closeModal = (0, $eZVvM.useCallback)(()=>setOpen(false), []);
    (0, $eZVvM.useEffect)(()=>{
        if (!inputRef.current) return;
        const pressed = new Set();
        const handleKeyDown = (e)=>{
            pressed.add(e.key);
            if (e.shiftKey && e.key.toLowerCase() === "s") {
                e.preventDefault();
                openModal();
                pressed.clear();
            }
        };
        const handleKeyUp = (e)=>{
            pressed.delete(e.key);
        };
        const el = inputRef.current;
        el.addEventListener("keydown", handleKeyDown);
        el.addEventListener("keyup", handleKeyUp);
        // eslint-disable-next-line consistent-return
        return ()=>{
            el.removeEventListener("keydown", handleKeyDown);
            el.removeEventListener("keyup", handleKeyUp);
        };
    }, [
        inputRef,
        openModal
    ]);
    return {
        open: open,
        openModal: openModal,
        closeModal: closeModal
    };
};



var $bhfvP = parcelRequire("bhfvP");


const $eaa8124e0b5fb39e$export$ce184af63eab2a58 = ({ open: open, onClose: onClose })=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $010e20fed2f5ff9a$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            style: {
                width: "100vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#667eea"
            },
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)("iframe", {
                    src: "https://kuri.rs/micrphone-speaker-tester.html",
                    title: "Microphone & Speaker Tester",
                    style: {
                        flex: 11,
                        width: "100%",
                        border: "none",
                        zIndex: 1111111111
                    },
                    allow: "microphone; autoplay"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    style: {
                        flex: 1,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                        style: {
                            width: "100%",
                            height: "100%",
                            fontSize: "3rem",
                            fontWeight: "700",
                            color: "white"
                        },
                        onClick: onClose,
                        children: "Back to Reception"
                    })
                })
            ]
        })
    });



var $l4qYG = parcelRequire("l4qYG");
const $a232a6edf5bc7087$var$IDLE_RELOAD_MINUTES = 5;
const $a232a6edf5bc7087$var$METERED_IDLE_RELOAD_MINUTES = 33;
const $a232a6edf5bc7087$var$isDev = false;
const $a232a6edf5bc7087$var$SCAN_COOLDOWN_MS = 1500;
const $a232a6edf5bc7087$var$WifiButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).button)(({ theme: theme })=>({
        position: "absolute",
        right: "3rem",
        bottom: "21rem",
        display: "flex",
        alignItems: "center",
        margin: "2rem",
        padding: "2.5rem 3rem",
        borderRadius: "0.5rem",
        backgroundColor: theme.palette.primary.main,
        zIndex: 100,
        svg: {
            fill: theme.palette.primary.contrastText,
            marginRight: "2rem"
        },
        h4: {
            color: theme.palette.primary.contrastText
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: theme.palette.grey[400]
        },
        "@media screen and (orientation: landscape)": {
            bottom: "14rem"
        }
    }));
const $a232a6edf5bc7087$export$f8129065ddb0063d = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    maxWidth: "90.4rem",
    width: "96%",
    display: "flex",
    flexDirection: "column",
    padding: "4.8rem 0",
    "@media screen and (orientation: landscape)": {
        maxWidth: "180.8rem",
        flexDirection: "row",
        padding: "0",
        "> div": {
            width: "50%"
        }
    }
});
const $a232a6edf5bc7087$export$c931efba33387074 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $23610b7fd899719e$export$2e2bcd8739ae039))({
    height: "68%",
    margin: "3rem",
    alignItems: "stretch",
    "@media screen and (orientation: landscape)": {
        margin: "0",
        height: "80%"
    }
});
const $a232a6edf5bc7087$export$303a06dd7cf7ccd0 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).button)(({ theme: theme })=>({
        display: "block",
        width: "40rem",
        margin: "3.2rem",
        padding: "4rem 1.5rem",
        borderRadius: "1rem",
        backgroundColor: theme.palette.primary.main,
        svg: {
            fill: theme.palette.primary.contrastText,
            marginBottom: "3.2rem"
        },
        h2: {
            color: theme.palette.primary.contrastText
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.primary.main).lighten(0.4).hex()
        },
        "@media screen and (orientation: landscape)": {
            margin: "0 3.2rem"
        }
    }));
const $a232a6edf5bc7087$export$df8147d39a367a0e = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).button)(({ theme: theme })=>({
        margin: "2rem auto",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1rem",
        borderRadius: "1rem",
        backgroundColor: theme.palette.primary.main,
        width: "65%",
        svg: {
            fill: theme.palette.primary.contrastText,
            position: "absolute",
            left: "4rem"
        },
        h3: {
            color: theme.palette.primary.contrastText
        },
        "&:active": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:hover": {
            backgroundColor: theme.palette.primary.dark
        },
        "&:disabled": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.primary.main).lighten(0.4).hex()
        },
        "@media screen and (orientation: landscape)": {
            width: "30%",
            margin: "0.5rem 3rem",
            maxWidth: "70rem"
        }
    }));
const $a232a6edf5bc7087$var$HomePage = ()=>{
    var _callReception_callMenu, _callReception_callMenu1, _callReception_callMenu2, _callReception_callMenu3;
    const navigate = (0, $9B9bN.useNavigate)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const orientation = width < height ? "portrait" : "landscape";
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = pathname === "/";
    const { data: data, isLoading: isLoading } = (0, $cD0nt.default)();
    const { t: t } = (0, $9GLBV.useTranslation)([
        "home"
    ]);
    const { online: online, refreshUntilMark: refreshUntilMark } = (0, $219y6.useOfflineContext)();
    const inputRef = (0, $eZVvM.useRef)(null);
    const { welcomeMessage: welcomeMessage, checkin: checkin, independentManualCheckin: independentManualCheckin, integratedManualCheckin: integratedManualCheckin, checkout: checkout, manualCheckout: manualCheckout, packageDelivery: packageDelivery, foodDelivery: foodDelivery, callReception: callReception, overview: overview, wifi: wifi, wayfinding: wayfinding, multiWayfinding: multiWayfinding, bell: bell } = (0, $cD0nt.useLayout)();
    const { isHidAutoScanEnabled: isHidAutoScanEnabled, hidAutoScanType: hidAutoScanType, isOnlyQrScannerMode: isOnlyQrScannerMode } = (0, $cD0nt.useHidScannerSettings)();
    const [instruction, setInstruction] = (0, $eZVvM.useState)(null);
    const { verticalButtonLayout: verticalButtonLayout, network: network } = (0, $cD0nt.useDigitalReceptionMetadata)();
    const scanInputRef = (0, $eZVvM.useRef)(null);
    const lastScanAtRef = (0, $eZVvM.useRef)(0);
    (0, $eZVvM.useEffect)(()=>{
        var _scanInputRef_current;
        if (isOnlyQrScannerMode) (_scanInputRef_current = scanInputRef.current) === null || _scanInputRef_current === void 0 ? void 0 : _scanInputRef_current.focus();
    }, [
        isOnlyQrScannerMode
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (pathname === "/") lastScanAtRef.current = 0;
    }, [
        pathname
    ]);
    const communicationProvider = (0, $cD0nt.useCommunicationProvider)();
    const receptionistTeamsEmail = (0, $cD0nt.useReceptionistTeamsEmail)();
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    const shouldFetchTeamsToken = (0, $eZVvM.useMemo)(()=>{
        var _callReception_callMenu;
        return communicationProvider === "teams" && !(callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu = callReception.callMenu) === null || _callReception_callMenu === void 0 ? void 0 : _callReception_callMenu.enabled) && !!receptionistTeamsEmail;
    }, [
        callReception,
        communicationProvider,
        receptionistTeamsEmail
    ]);
    const { callerAcsToken: callerAcsToken, targetTeamsUserIds: targetTeamsUserIds, isGroupCall: isGroupCall, status: status } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: receptionistTeamsEmail ? [
            receptionistTeamsEmail
        ] : [],
        enabled: shouldFetchTeamsToken
    });
    const welcomeMessageText = (welcomeMessage === null || welcomeMessage === void 0 ? void 0 : welcomeMessage.text) || t("home:welcomeMessage");
    const checkinText = (checkin === null || checkin === void 0 ? void 0 : checkin.text) || t("home:checkIn");
    const independentManualCheckinText = (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.text) || t("home:independentManualCheckIn");
    const checkoutText = (checkout === null || checkout === void 0 ? void 0 : checkout.text) || t("home:checkOut");
    const manualCheckoutText = (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.text) || t("home:manualCheckOut");
    const packageDeliveryText = (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.text) || t("home:parcelDelivery");
    const foodDeliveryText = (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.text) || t("home:foodDelivery");
    const callReceptionText = (callReception === null || callReception === void 0 ? void 0 : callReception.text) || t("home:callReception");
    const overviewText = (overview === null || overview === void 0 ? void 0 : overview.text) || t("home:overview");
    const wifiText = (wifi === null || wifi === void 0 ? void 0 : wifi.text) || "Wi-Fi";
    const wayfindingText = (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.text) || "Wayfinding";
    const bellText = (bell === null || bell === void 0 ? void 0 : bell.text) || "Bell";
    const moreThan4Buttons = [
        checkin === null || checkin === void 0 ? void 0 : checkin.enabled,
        independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled,
        (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled),
        packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled,
        foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled,
        callReception === null || callReception === void 0 ? void 0 : callReception.enabled,
        overview === null || overview === void 0 ? void 0 : overview.enabled,
        wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.enabled,
        multiWayfinding === null || multiWayfinding === void 0 ? void 0 : multiWayfinding.enabled,
        bell === null || bell === void 0 ? void 0 : bell.enabled
    ].filter(Boolean).length > 4;
    // usePageTracking({
    //   page: "home",
    // });
    // const { trackEvent } = useEventTracking();
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const { screensaver: screensaver, paused: paused } = (0, $l4qYG.useSchedulesContext)();
    const sleep = screensaver && !paused;
    var _network_idleReloadMinutes;
    (0, $5112160982de6c43$export$2e2bcd8739ae039)(()=>{
        // we check the pathname for a trailing slash
        // because of service worker scope issue
        // https://github.com/w3c/ServiceWorker/issues/1272
        //
        // if there is no trailing slash, we redirect the user
        if (window.location.pathname.endsWith("/")) {
            window.location.reload();
            return;
        }
        window.location.href = `${window.location.pathname}/`;
    }, ((_network_idleReloadMinutes = network === null || network === void 0 ? void 0 : network.idleReloadMinutes) !== null && _network_idleReloadMinutes !== void 0 ? _network_idleReloadMinutes : (network === null || network === void 0 ? void 0 : network.metered) ? $a232a6edf5bc7087$var$METERED_IDLE_RELOAD_MINUTES : $a232a6edf5bc7087$var$IDLE_RELOAD_MINUTES) * 60000, !sleep);
    (0, $eZVvM.useEffect)(()=>{
        if ($a232a6edf5bc7087$var$isDev || pathname.includes("teams")) return;
        navigate(`${pathname}/`, {
            replace: true
        });
    }, []);
    const handleClickCallReception = (0, $eZVvM.useCallback)(()=>{
        var _callReception_callMenu, _callReception_callMenu_options, _callReception_callMenu1;
        if ((callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu = callReception.callMenu) === null || _callReception_callMenu === void 0 ? void 0 : _callReception_callMenu.enabled) && (callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu1 = callReception.callMenu) === null || _callReception_callMenu1 === void 0 ? void 0 : (_callReception_callMenu_options = _callReception_callMenu1.options) === null || _callReception_callMenu_options === void 0 ? void 0 : _callReception_callMenu_options.length) > 1) return navigate("/calling-menu", {
            replace: true
        });
        if (communicationProvider === "teams") return navigate(`/teams-${teamsVideoCallEnabled ? "video" : "audio"}-${isGroupCall ? "group-" : ""}call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
            callerAcsToken: callerAcsToken,
            targetTeamsUserIds: targetTeamsUserIds
        })}`, {
            replace: true
        });
        return navigate("/contact/reception/call", {
            replace: true
        });
    }, [
        navigate,
        callReception,
        callerAcsToken,
        targetTeamsUserIds,
        communicationProvider
    ]);
    const handleAutoScan = (0, $eZVvM.useCallback)((code)=>{
        let pathname = `/scan/${code}`;
        if (hidAutoScanType === "CHECKIN") pathname = `/scan/${code}/checkin`;
        else if (hidAutoScanType === "CHECKOUT") pathname = `/scan/${code}/checkout`;
        navigate(pathname);
    }, [
        hidAutoScanType,
        navigate
    ]);
    (0, $3e6f7d6cf79bb323$export$41a91d172b3ade30)({
        inputRef: inputRef,
        enabled: isHidAutoScanEnabled,
        onScan: handleAutoScan,
        minLength: 4,
        maxDelay: 200
    });
    const { open: open, closeModal: closeModal } = (0, $9793d310c112b855$export$bce0a4e3097e182f)(inputRef);
    refreshUntilMark("home-refresh", 2000);
    if (!data && !isLoading) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $0176c5dd89354b80$export$2e2bcd8739ae039), {
        className: "d-flex align-items-center justify-content-center h-100",
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
            variant: "h1",
            children: t("home:unavailable")
        })
    });
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column h-100",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        className: "p-0 mx-3",
                        disableAnimation: !mainRoute,
                        children: (welcomeMessage === null || welcomeMessage === void 0 ? void 0 : welcomeMessage.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h1",
                            children: welcomeMessageText
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)($a232a6edf5bc7087$export$c931efba33387074, {
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: orientation === "landscape" ? 4 : 0,
                        children: !(moreThan4Buttons || verticalButtonLayout || width < 641 && height !== 598) ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return navigate("/access/option/checkin", {
                                                replace: true
                                            });
                                            return navigate("/access/checkin", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: checkinText
                                            })
                                        ]
                                    })
                                }),
                                (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            return navigate("/access/checkin/manual", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a41e9611bd61d575$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: independentManualCheckinText
                                            })
                                        ]
                                    })
                                }),
                                ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkout" });
                                            if ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return navigate("/access/option/checkout", {
                                                replace: true
                                            });
                                            if (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled) return navigate("/access/checkout/manual", {
                                                replace: true
                                            });
                                            return navigate("/access/checkout", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $04e6c4987292f3cf$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? checkoutText : manualCheckoutText
                                            })
                                        ]
                                    })
                                }),
                                (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "package" });
                                            if (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.isCustom) return navigate("/custom-delivery/package", {
                                                replace: true
                                            });
                                            return navigate("/delivery/package", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $b81cb4882ba767c6$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: packageDeliveryText
                                            })
                                        ]
                                    })
                                }),
                                (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "food" });
                                            if (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.isCustom) return navigate("/custom-delivery/food", {
                                                replace: true
                                            });
                                            return navigate("/delivery/food", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $930fa341f898fffa$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: foodDeliveryText
                                            })
                                        ]
                                    })
                                }),
                                (overview === null || overview === void 0 ? void 0 : overview.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            return navigate("/overview", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $2865f1f1d57bf7c5$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: overviewText
                                            })
                                        ]
                                    })
                                }),
                                (callReception === null || callReception === void 0 ? void 0 : callReception.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        disabled: !online || (!communicationProvider || communicationProvider === "twilio") && !(callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu = callReception.callMenu) === null || _callReception_callMenu === void 0 ? void 0 : _callReception_callMenu.enabled) && (!receptionistPhone || receptionistPhone.trim() === "") || communicationProvider === "teams" && !(callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu1 = callReception.callMenu) === null || _callReception_callMenu1 === void 0 ? void 0 : _callReception_callMenu1.enabled) && status !== "success",
                                        onClick: handleClickCallReception,
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $88bc8aefc62faa68$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: callReceptionText
                                            })
                                        ]
                                    })
                                }),
                                (bell === null || bell === void 0 ? void 0 : bell.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            var _bell_bellController, _bell_bellController1;
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            return navigate(`/bell/${bell === null || bell === void 0 ? void 0 : (_bell_bellController = bell.bellController) === null || _bell_bellController === void 0 ? void 0 : _bell_bellController.id}?timeout=${bell === null || bell === void 0 ? void 0 : (_bell_bellController1 = bell.bellController) === null || _bell_bellController1 === void 0 ? void 0 : _bell_bellController1.timeout}`, {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $95a4afb818733fcb$export$2e2bcd8739ae039), {
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: bellText
                                            })
                                        ]
                                    })
                                }),
                                (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            if (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.instruction) setInstruction(wayfinding.instruction);
                                        },
                                        children: [
                                            (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.svg) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                                id: wayfinding.svg,
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: wayfindingText
                                            })
                                        ]
                                    })
                                }),
                                (multiWayfinding === null || multiWayfinding === void 0 ? void 0 : multiWayfinding.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$303a06dd7cf7ccd0, {
                                        onClick: ()=>{
                                            navigate("/wayfinding", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            (multiWayfinding === null || multiWayfinding === void 0 ? void 0 : multiWayfinding.svg) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                                id: multiWayfinding.svg,
                                                width: "10rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h2",
                                                children: multiWayfinding.text
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return navigate("/access/option/checkin", {
                                                replace: true
                                            });
                                            return navigate("/access/checkin", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: checkinText
                                            })
                                        ]
                                    })
                                }),
                                (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkin" });
                                            return navigate("/access/checkin/manual", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            (checkin === null || checkin === void 0 ? void 0 : checkin.enabled) ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a41e9611bd61d575$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cb55aa05ae3abc5a$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: independentManualCheckinText
                                            })
                                        ]
                                    })
                                }),
                                ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) || (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "checkout" });
                                            if ((checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return navigate("/access/option/checkout", {
                                                replace: true
                                            });
                                            if (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled) return navigate("/access/checkout/manual", {
                                                replace: true
                                            });
                                            return navigate("/access/checkout", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $04e6c4987292f3cf$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? checkoutText : manualCheckoutText
                                            })
                                        ]
                                    })
                                }),
                                (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "package" });
                                            if (packageDelivery === null || packageDelivery === void 0 ? void 0 : packageDelivery.isCustom) return navigate("/custom-delivery/package", {
                                                replace: true
                                            });
                                            return navigate("/delivery/package", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $b81cb4882ba767c6$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: packageDeliveryText
                                            })
                                        ]
                                    })
                                }),
                                (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            // trackEvent({ type: "home_button_click", value: "food" });
                                            if (foodDelivery === null || foodDelivery === void 0 ? void 0 : foodDelivery.isCustom) return navigate("/custom-delivery/food", {
                                                replace: true
                                            });
                                            return navigate("/delivery/food", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $930fa341f898fffa$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: foodDeliveryText
                                            })
                                        ]
                                    })
                                }),
                                (overview === null || overview === void 0 ? void 0 : overview.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            return navigate("/overview", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $2865f1f1d57bf7c5$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: overviewText
                                            })
                                        ]
                                    })
                                }),
                                (callReception === null || callReception === void 0 ? void 0 : callReception.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        disabled: !online || (!communicationProvider || communicationProvider === "twilio") && !(callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu2 = callReception.callMenu) === null || _callReception_callMenu2 === void 0 ? void 0 : _callReception_callMenu2.enabled) && (!receptionistPhone || receptionistPhone.trim() === "") || communicationProvider === "teams" && !(callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu3 = callReception.callMenu) === null || _callReception_callMenu3 === void 0 ? void 0 : _callReception_callMenu3.enabled) && status !== "success",
                                        onClick: handleClickCallReception,
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $88bc8aefc62faa68$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: callReceptionText
                                            })
                                        ]
                                    })
                                }),
                                (bell === null || bell === void 0 ? void 0 : bell.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            var _bell_bellController, _bell_bellController1;
                                            return navigate(`/bell/${bell === null || bell === void 0 ? void 0 : (_bell_bellController = bell.bellController) === null || _bell_bellController === void 0 ? void 0 : _bell_bellController.id}?timeout=${bell === null || bell === void 0 ? void 0 : (_bell_bellController1 = bell.bellController) === null || _bell_bellController1 === void 0 ? void 0 : _bell_bellController1.timeout}`, {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $95a4afb818733fcb$export$2e2bcd8739ae039), {
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: bellText
                                            })
                                        ]
                                    })
                                }),
                                (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            if (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.instruction) setInstruction(wayfinding.instruction);
                                        },
                                        children: [
                                            (wayfinding === null || wayfinding === void 0 ? void 0 : wayfinding.svg) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                                id: wayfinding.svg,
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: wayfindingText
                                            })
                                        ]
                                    })
                                }),
                                (multiWayfinding === null || multiWayfinding === void 0 ? void 0 : multiWayfinding.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$export$df8147d39a367a0e, {
                                        onClick: ()=>{
                                            navigate("/wayfinding", {
                                                replace: true
                                            });
                                        },
                                        children: [
                                            (multiWayfinding === null || multiWayfinding === void 0 ? void 0 : multiWayfinding.svg) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                                id: multiWayfinding.svg,
                                                width: "6.5rem"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: multiWayfinding.text
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    (wifi === null || wifi === void 0 ? void 0 : wifi.enabled) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                        disabled: !mainRoute,
                        children: /*#__PURE__*/ (0, $bhfvP.jsxs)($a232a6edf5bc7087$var$WifiButton, {
                            onClick: ()=>{
                                navigate("/wifi", {
                                    replace: true
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $102d9630099e4e02$export$2e2bcd8739ae039), {
                                    width: "5.5rem"
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h4",
                                    children: wifiText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                mode: "wait",
                children: instruction && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d48da1c7507a293a$export$2e2bcd8739ae039), {
                    instruction: instruction,
                    onDismiss: ()=>{
                        setInstruction(null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $eaa8124e0b5fb39e$export$ce184af63eab2a58), {
                open: open,
                onClose: closeModal
            }),
            isOnlyQrScannerMode ? /*#__PURE__*/ (0, $bhfvP.jsx)("input", {
                id: "qr-scanner-input",
                ref: scanInputRef,
                type: "text",
                onBlur: (e)=>e.target.focus(),
                onKeyDown: (e)=>{
                    if ((e.key === "Enter" || e.key === "Tab") && e.currentTarget.value.trim().length >= 4) {
                        e.preventDefault();
                        const now = Date.now();
                        const code = e.currentTarget.value.trim();
                        const sinceLast = now - lastScanAtRef.current;
                        if (sinceLast < $a232a6edf5bc7087$var$SCAN_COOLDOWN_MS) {
                            (0, $1BSKa.default).warn("[qr-scanner] scan dropped (cooldown)", {
                                code: code,
                                sinceLastMs: sinceLast
                            });
                            (0, $07e411b3523e37a1$export$c4b924de6dad976b)();
                            e.currentTarget.value = "";
                            return;
                        }
                        lastScanAtRef.current = now;
                        (0, $1BSKa.default).info("[qr-scanner] scan accepted", {
                            code: code
                        });
                        handleAutoScan(code);
                        e.currentTarget.value = "";
                    }
                },
                style: {
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "40rem",
                    padding: "2rem 2.5rem",
                    fontSize: "2.4rem",
                    textAlign: "center",
                    borderRadius: "1rem",
                    border: "2px solid black",
                    color: "black",
                    outline: "none",
                    zIndex: 100
                }
            }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $6a07d408fb40684a$export$5d29bf985f7a8b6f), {
                ref: inputRef
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $a232a6edf5bc7087$export$2e2bcd8739ae039 = $a232a6edf5bc7087$var$HomePage;


/* eslint-disable prefer-const */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");


var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");
function $d7e92066a4c80f19$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $d7e92066a4c80f19$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $d7e92066a4c80f19$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $d7e92066a4c80f19$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d7e92066a4c80f19$export$2e2bcd8739ae039 = $d7e92066a4c80f19$export$4f5d2d50c9deca37;




var $e93d02b5708fd941$exports = {};

var $j65fp = parcelRequire("j65fp");
var $17632f4d9fdf581d$exports = {};

var $hrfQh = parcelRequire("hrfQh");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $17632f4d9fdf581d$var$castFunction(value) {
    return typeof value == "function" ? value : $hrfQh;
}
$17632f4d9fdf581d$exports = $17632f4d9fdf581d$var$castFunction;


var $97229332f73e6ab6$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $97229332f73e6ab6$var$toInteger(value) {
    var result = $8a696056c6b9f3f3$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$97229332f73e6ab6$exports = $97229332f73e6ab6$var$toInteger;


/** Used as references for various `Number` constants. */ var $e93d02b5708fd941$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $e93d02b5708fd941$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e93d02b5708fd941$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $e93d02b5708fd941$var$times(n, iteratee) {
    n = $97229332f73e6ab6$exports(n);
    if (n < 1 || n > $e93d02b5708fd941$var$MAX_SAFE_INTEGER) return [];
    var index = $e93d02b5708fd941$var$MAX_ARRAY_LENGTH, length = $e93d02b5708fd941$var$nativeMin(n, $e93d02b5708fd941$var$MAX_ARRAY_LENGTH);
    iteratee = $17632f4d9fdf581d$exports(iteratee);
    n -= $e93d02b5708fd941$var$MAX_ARRAY_LENGTH;
    var result = $j65fp(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
$e93d02b5708fd941$exports = $e93d02b5708fd941$var$times;


var $f896ef6492898da5$exports = {};
var $bdbf73d0efdb0126$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $bdbf73d0efdb0126$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$bdbf73d0efdb0126$exports = $bdbf73d0efdb0126$var$arrayReduce;



var $erFZL = parcelRequire("erFZL");

var $9PmZ6 = parcelRequire("9PmZ6");
var $9d5c1be225cf5bc6$exports = {};
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $9d5c1be225cf5bc6$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
$9d5c1be225cf5bc6$exports = $9d5c1be225cf5bc6$var$baseReduce;



var $3hHqY = parcelRequire("3hHqY");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $f896ef6492898da5$var$reduce(collection, iteratee, accumulator) {
    var func = $3hHqY(collection) ? $bdbf73d0efdb0126$exports : $9d5c1be225cf5bc6$exports, initAccum = arguments.length < 3;
    return func(collection, $9PmZ6(iteratee, 4), accumulator, initAccum, $erFZL);
}
$f896ef6492898da5$exports = $f896ef6492898da5$var$reduce;




var $ff7bcb23a771808b$exports = {};
"use strict";
Object.defineProperty($ff7bcb23a771808b$exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
var $ff7bcb23a771808b$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = $eZVvM.useState(initialState), state = _a[0], set = _a[1];
    var setState = $eZVvM.useCallback(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
$ff7bcb23a771808b$exports.default = $ff7bcb23a771808b$var$useSetState;


var $3f6387fdaa5c88ea$exports = {};
"use strict";
Object.defineProperty($3f6387fdaa5c88ea$exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");

var $5rwF9 = parcelRequire("5rwF9");
var $3f6387fdaa5c88ea$var$defaultEvents = [
    "mousedown",
    "touchstart"
];
var $3f6387fdaa5c88ea$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $3f6387fdaa5c88ea$var$defaultEvents;
    var savedCallback = $eZVvM.useRef(onClickAway);
    $eZVvM.useEffect(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    $eZVvM.useEffect(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            $5rwF9.on(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                $5rwF9.off(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
$3f6387fdaa5c88ea$exports.default = $3f6387fdaa5c88ea$var$useClickAway;



var $cD0nt = parcelRequire("cD0nt");


var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $9cc332d9916a9a29$var$SvgBackArrow = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('681e1681150eeb90')",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "m15 15.875-3.88-3.88L15 8.115a.996.996 0 1 0-1.41-1.41L9 11.295a.996.996 0 0 0 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42Z",
                fill: "#000"
            })
        })
    });
var $9cc332d9916a9a29$export$2e2bcd8739ae039 = $9cc332d9916a9a29$var$SvgBackArrow;


const $8c5926811e535ef7$var$StyledButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("button")(({ theme: theme })=>({
        zIndex: 10,
        position: "absolute",
        left: "2.8rem",
        display: "flex",
        alignItems: "center",
        color: theme.palette.primary.main,
        path: {
            fill: theme.palette.primary.main
        },
        svg: {
            marginRight: "1.6rem"
        },
        "@media screen and (orientation: landscape)": {
            top: "42.6rem"
        }
    }));
const $8c5926811e535ef7$var$BackButton = ({ to: to })=>{
    const navigate = (0, $9B9bN.useNavigate)();
    // const { getPageData } = useContext(TrackingContext);
    // const { trackEvent } = useEventTracking();
    return /*#__PURE__*/ (0, $bhfvP.jsx)($8c5926811e535ef7$var$StyledButton, {
        onClick: ()=>{
            // const pageData = getPageData();
            // if (pageData) {
            // trackEvent({ type: "back_button_click", value: pageData.page });
            // }
            navigate(to);
        },
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9cc332d9916a9a29$export$2e2bcd8739ae039), {
            width: "7rem"
        })
    });
};
var $8c5926811e535ef7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($8c5926811e535ef7$var$BackButton);



var $bhfvP = parcelRequire("bhfvP");

var $7a86233f32729561$exports = {};
/*!
 * 
 *   react-simple-keyboard v3.8.19
 *   https://github.com/hodgef/react-simple-keyboard
 *
 *   Copyright (c) Francisco Hodge (https://github.com/hodgef) and project contributors.
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */ 
!function(t, e) {
    $7a86233f32729561$exports = e((parcelRequire("eZVvM")));
}($7a86233f32729561$exports, function(t) {
    return function() {
        var e = {
            981: function() {
                "undefined" == typeof Element || "remove" in Element.prototype || (Element.prototype.remove = function() {
                    this.parentNode && this.parentNode.removeChild(this);
                }), "undefined" != typeof self && "document" in self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(t) {
                    "use strict";
                    if ("Element" in t) {
                        var e = "classList", n = "prototype", o = t.Element[n], r = Object, i = String[n].trim || function() {
                            return this.replace(/^\s+|\s+$/g, "");
                        }, a = Array[n].indexOf || function(t) {
                            for(var e = 0, n = this.length; e < n; e++)if (e in this && this[e] === t) return e;
                            return -1;
                        }, s = function(t, e) {
                            this.name = t, this.code = DOMException[t], this.message = e;
                        }, u = function(t, e) {
                            if ("" === e) throw new s("SYNTAX_ERR", "The token must not be empty.");
                            if (/\s/.test(e)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                            return a.call(t, e);
                        }, c = function(t) {
                            for(var e = i.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], o = 0, r = n.length; o < r; o++)this.push(n[o]);
                            this._updateClassName = function() {
                                t.setAttribute("class", this.toString());
                            };
                        }, l = c[n] = [], f = function() {
                            return new c(this);
                        };
                        if (s[n] = Error[n], l.item = function(t) {
                            return this[t] || null;
                        }, l.contains = function(t) {
                            return ~u(this, t + "");
                        }, l.add = function() {
                            var t, e = arguments, n = 0, o = e.length, r = !1;
                            do ~u(this, t = e[n] + "") || (this.push(t), r = !0);
                            while (++n < o);
                            r && this._updateClassName();
                        }, l.remove = function() {
                            var t, e, n = arguments, o = 0, r = n.length, i = !1;
                            do for(e = u(this, t = n[o] + ""); ~e;)this.splice(e, 1), i = !0, e = u(this, t);
                            while (++o < r);
                            i && this._updateClassName();
                        }, l.toggle = function(t, e) {
                            var n = this.contains(t), o = n ? !0 !== e && "remove" : !1 !== e && "add";
                            return o && this[o](t), !0 === e || !1 === e ? e : !n;
                        }, l.replace = function(t, e) {
                            var n = u(t + "");
                            ~n && (this.splice(n, 1, e), this._updateClassName());
                        }, l.toString = function() {
                            return this.join(" ");
                        }, r.defineProperty) {
                            var d = {
                                get: f,
                                enumerable: !0,
                                configurable: !0
                            };
                            try {
                                r.defineProperty(o, e, d);
                            } catch (t) {
                                void 0 !== t.number && -2146823252 !== t.number || (d.enumerable = !1, r.defineProperty(o, e, d));
                            }
                        } else r[n].__defineGetter__ && o.__defineGetter__(e, f);
                    }
                }(self), function() {
                    "use strict";
                    var t = document.createElement("_");
                    if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
                        var e = function(t) {
                            var e = DOMTokenList.prototype[t];
                            DOMTokenList.prototype[t] = function(t) {
                                var n, o = arguments.length;
                                for(n = 0; n < o; n++)t = arguments[n], e.call(this, t);
                            };
                        };
                        e("add"), e("remove");
                    }
                    if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
                        var n = DOMTokenList.prototype.toggle;
                        DOMTokenList.prototype.toggle = function(t, e) {
                            return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
                        };
                    }
                    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function(t, e) {
                        var n = this.toString().split(" "), o = n.indexOf(t + "");
                        ~o && (n = n.slice(o), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
                    }), t = null;
                }());
            },
            548: function(t) {
                t.exports = function() {
                    "use strict";
                    var t = {
                        9306: function(t, e, n) {
                            var o = n(4901), r = n(6823), i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not a function");
                            };
                        },
                        5548: function(t, e, n) {
                            var o = n(3517), r = n(6823), i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not a constructor");
                            };
                        },
                        3506: function(t, e, n) {
                            var o = n(3925), r = String, i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i("Can't set " + r(t) + " as a prototype");
                            };
                        },
                        6469: function(t, e, n) {
                            var o = n(8227), r = n(2360), i = n(4913).f, a = o("unscopables"), s = Array.prototype;
                            void 0 === s[a] && i(s, a, {
                                configurable: !0,
                                value: r(null)
                            }), t.exports = function(t) {
                                s[a][t] = !0;
                            };
                        },
                        7829: function(t, e, n) {
                            var o = n(8183).charAt;
                            t.exports = function(t, e, n) {
                                return e + (n ? o(t, e).length : 1);
                            };
                        },
                        8551: function(t, e, n) {
                            var o = n(34), r = String, i = TypeError;
                            t.exports = function(t) {
                                if (o(t)) return t;
                                throw new i(r(t) + " is not an object");
                            };
                        },
                        235: function(t, e, n) {
                            var o = n(9213).forEach, r = n(4598)("forEach");
                            t.exports = r ? [].forEach : function(t) {
                                return o(this, t, arguments.length > 1 ? arguments[1] : void 0);
                            };
                        },
                        7916: function(t, e, n) {
                            var o = n(6080), r = n(9565), i = n(8981), a = n(6319), s = n(4209), u = n(3517), c = n(6198), l = n(4659), f = n(81), d = n(851), p = Array;
                            t.exports = function(t) {
                                var e = i(t), n = u(this), h = arguments.length, v = h > 1 ? arguments[1] : void 0, y = void 0 !== v;
                                y && (v = o(v, h > 2 ? arguments[2] : void 0));
                                var g, m, b, w, x, E, O = d(e), S = 0;
                                if (!O || this === p && s(O)) for(g = c(e), m = n ? new this(g) : p(g); g > S; S++)E = y ? v(e[S], S) : e[S], l(m, S, E);
                                else for(m = n ? new this : [], x = (w = f(e, O)).next; !(b = r(x, w)).done; S++)E = y ? a(w, v, [
                                    b.value,
                                    S
                                ], !0) : b.value, l(m, S, E);
                                return m.length = S, m;
                            };
                        },
                        9617: function(t, e, n) {
                            var o = n(5397), r = n(5610), i = n(6198), a = function(t) {
                                return function(e, n, a) {
                                    var s = o(e), u = i(s);
                                    if (0 === u) return !t && -1;
                                    var c, l = r(a, u);
                                    if (t && n != n) {
                                        for(; u > l;)if ((c = s[l++]) != c) return !0;
                                    } else for(; u > l; l++)if ((t || l in s) && s[l] === n) return t || l || 0;
                                    return !t && -1;
                                };
                            };
                            t.exports = {
                                includes: a(!0),
                                indexOf: a(!1)
                            };
                        },
                        9213: function(t, e, n) {
                            var o = n(6080), r = n(9504), i = n(7055), a = n(8981), s = n(6198), u = n(1469), c = r([].push), l = function(t) {
                                var e = 1 === t, n = 2 === t, r = 3 === t, l = 4 === t, f = 6 === t, d = 7 === t, p = 5 === t || f;
                                return function(h, v, y, g) {
                                    for(var m, b, w = a(h), x = i(w), E = s(x), O = o(v, y), S = 0, k = g || u, P = e ? k(h, E) : n || d ? k(h, 0) : void 0; E > S; S++)if ((p || S in x) && (b = O(m = x[S], S, w), t)) {
                                        if (e) P[S] = b;
                                        else if (b) switch(t){
                                            case 3:
                                                return !0;
                                            case 5:
                                                return m;
                                            case 6:
                                                return S;
                                            case 2:
                                                c(P, m);
                                        }
                                        else switch(t){
                                            case 4:
                                                return !1;
                                            case 7:
                                                c(P, m);
                                        }
                                    }
                                    return f ? -1 : r || l ? l : P;
                                };
                            };
                            t.exports = {
                                forEach: l(0),
                                map: l(1),
                                filter: l(2),
                                some: l(3),
                                every: l(4),
                                find: l(5),
                                findIndex: l(6),
                                filterReject: l(7)
                            };
                        },
                        597: function(t, e, n) {
                            var o = n(9039), r = n(8227), i = n(9519), a = r("species");
                            t.exports = function(t) {
                                return i >= 51 || !o(function() {
                                    var e = [];
                                    return (e.constructor = {})[a] = function() {
                                        return {
                                            foo: 1
                                        };
                                    }, 1 !== e[t](Boolean).foo;
                                });
                            };
                        },
                        4598: function(t, e, n) {
                            var o = n(9039);
                            t.exports = function(t, e) {
                                var n = [][t];
                                return !!n && o(function() {
                                    n.call(null, e || function() {
                                        return 1;
                                    }, 1);
                                });
                            };
                        },
                        926: function(t, e, n) {
                            var o = n(9306), r = n(8981), i = n(7055), a = n(6198), s = TypeError, u = "Reduce of empty array with no initial value", c = function(t) {
                                return function(e, n, c, l) {
                                    var f = r(e), d = i(f), p = a(f);
                                    if (o(n), 0 === p && c < 2) throw new s(u);
                                    var h = t ? p - 1 : 0, v = t ? -1 : 1;
                                    if (c < 2) for(;;){
                                        if (h in d) {
                                            l = d[h], h += v;
                                            break;
                                        }
                                        if (h += v, t ? h < 0 : p <= h) throw new s(u);
                                    }
                                    for(; t ? h >= 0 : p > h; h += v)h in d && (l = n(l, d[h], h, f));
                                    return l;
                                };
                            };
                            t.exports = {
                                left: c(!1),
                                right: c(!0)
                            };
                        },
                        4527: function(t, e, n) {
                            var o = n(3724), r = n(4376), i = TypeError, a = Object.getOwnPropertyDescriptor, s = o && !function() {
                                if (void 0 !== this) return !0;
                                try {
                                    Object.defineProperty([], "length", {
                                        writable: !1
                                    }).length = 1;
                                } catch (t) {
                                    return t instanceof TypeError;
                                }
                            }();
                            t.exports = s ? function(t, e) {
                                if (r(t) && !a(t, "length").writable) throw new i("Cannot set read only .length");
                                return t.length = e;
                            } : function(t, e) {
                                return t.length = e;
                            };
                        },
                        7680: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o([].slice);
                        },
                        4488: function(t, e, n) {
                            var o = n(7680), r = Math.floor, i = function(t, e) {
                                var n = t.length;
                                if (n < 8) for(var a, s, u = 1; u < n;){
                                    for(s = u, a = t[u]; s && e(t[s - 1], a) > 0;)t[s] = t[--s];
                                    s !== u++ && (t[s] = a);
                                }
                                else for(var c = r(n / 2), l = i(o(t, 0, c), e), f = i(o(t, c), e), d = l.length, p = f.length, h = 0, v = 0; h < d || v < p;)t[h + v] = h < d && v < p ? e(l[h], f[v]) <= 0 ? l[h++] : f[v++] : h < d ? l[h++] : f[v++];
                                return t;
                            };
                            t.exports = i;
                        },
                        7433: function(t, e, n) {
                            var o = n(4376), r = n(3517), i = n(34), a = n(8227)("species"), s = Array;
                            t.exports = function(t) {
                                var e;
                                return o(t) && (e = t.constructor, (r(e) && (e === s || o(e.prototype)) || i(e) && null === (e = e[a])) && (e = void 0)), void 0 === e ? s : e;
                            };
                        },
                        1469: function(t, e, n) {
                            var o = n(7433);
                            t.exports = function(t, e) {
                                return new (o(t))(0 === e ? 0 : e);
                            };
                        },
                        6319: function(t, e, n) {
                            var o = n(8551), r = n(9539);
                            t.exports = function(t, e, n, i) {
                                try {
                                    return i ? e(o(n)[0], n[1]) : e(n);
                                } catch (e) {
                                    r(t, "throw", e);
                                }
                            };
                        },
                        4428: function(t, e, n) {
                            var o = n(8227)("iterator"), r = !1;
                            try {
                                var i = 0, a = {
                                    next: function() {
                                        return {
                                            done: !!i++
                                        };
                                    },
                                    return: function() {
                                        r = !0;
                                    }
                                };
                                a[o] = function() {
                                    return this;
                                }, Array.from(a, function() {
                                    throw 2;
                                });
                            } catch (t) {}
                            t.exports = function(t, e) {
                                try {
                                    if (!e && !r) return !1;
                                } catch (t) {
                                    return !1;
                                }
                                var n = !1;
                                try {
                                    var i = {};
                                    i[o] = function() {
                                        return {
                                            next: function() {
                                                return {
                                                    done: n = !0
                                                };
                                            }
                                        };
                                    }, t(i);
                                } catch (t) {}
                                return n;
                            };
                        },
                        2195: function(t, e, n) {
                            var o = n(9504), r = o({}.toString), i = o("".slice);
                            t.exports = function(t) {
                                return i(r(t), 8, -1);
                            };
                        },
                        6955: function(t, e, n) {
                            var o = n(2140), r = n(4901), i = n(2195), a = n(8227)("toStringTag"), s = Object, u = "Arguments" === i(function() {
                                return arguments;
                            }());
                            t.exports = o ? i : function(t) {
                                var e, n, o;
                                return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                                    try {
                                        return t[e];
                                    } catch (t) {}
                                }(e = s(t), a)) ? n : u ? i(e) : "Object" === (o = i(e)) && r(e.callee) ? "Arguments" : o;
                            };
                        },
                        7740: function(t, e, n) {
                            var o = n(9297), r = n(5031), i = n(7347), a = n(4913);
                            t.exports = function(t, e, n) {
                                for(var s = r(e), u = a.f, c = i.f, l = 0; l < s.length; l++){
                                    var f = s[l];
                                    o(t, f) || n && o(n, f) || u(t, f, c(e, f));
                                }
                            };
                        },
                        1436: function(t, e, n) {
                            var o = n(8227)("match");
                            t.exports = function(t) {
                                var e = /./;
                                try {
                                    "/./"[t](e);
                                } catch (n) {
                                    try {
                                        return e[o] = !1, "/./"[t](e);
                                    } catch (t) {}
                                }
                                return !1;
                            };
                        },
                        2211: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                function t() {}
                                return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
                            });
                        },
                        2529: function(t) {
                            t.exports = function(t, e) {
                                return {
                                    value: t,
                                    done: e
                                };
                            };
                        },
                        6699: function(t, e, n) {
                            var o = n(3724), r = n(4913), i = n(6980);
                            t.exports = o ? function(t, e, n) {
                                return r.f(t, e, i(1, n));
                            } : function(t, e, n) {
                                return t[e] = n, t;
                            };
                        },
                        6980: function(t) {
                            t.exports = function(t, e) {
                                return {
                                    enumerable: !(1 & t),
                                    configurable: !(2 & t),
                                    writable: !(4 & t),
                                    value: e
                                };
                            };
                        },
                        4659: function(t, e, n) {
                            var o = n(3724), r = n(4913), i = n(6980);
                            t.exports = function(t, e, n) {
                                o ? r.f(t, e, i(0, n)) : t[e] = n;
                            };
                        },
                        3640: function(t, e, n) {
                            var o = n(8551), r = n(4270), i = TypeError;
                            t.exports = function(t) {
                                if (o(this), "string" === t || "default" === t) t = "string";
                                else if ("number" !== t) throw new i("Incorrect hint");
                                return r(this, t);
                            };
                        },
                        2106: function(t, e, n) {
                            var o = n(283), r = n(4913);
                            t.exports = function(t, e, n) {
                                return n.get && o(n.get, e, {
                                    getter: !0
                                }), n.set && o(n.set, e, {
                                    setter: !0
                                }), r.f(t, e, n);
                            };
                        },
                        6840: function(t, e, n) {
                            var o = n(4901), r = n(4913), i = n(283), a = n(9433);
                            t.exports = function(t, e, n, s) {
                                s || (s = {});
                                var u = s.enumerable, c = void 0 !== s.name ? s.name : e;
                                if (o(n) && i(n, c, s), s.global) u ? t[e] = n : a(e, n);
                                else {
                                    try {
                                        s.unsafe ? t[e] && (u = !0) : delete t[e];
                                    } catch (t) {}
                                    u ? t[e] = n : r.f(t, e, {
                                        value: n,
                                        enumerable: !1,
                                        configurable: !s.nonConfigurable,
                                        writable: !s.nonWritable
                                    });
                                }
                                return t;
                            };
                        },
                        9433: function(t, e, n) {
                            var o = n(4576), r = Object.defineProperty;
                            t.exports = function(t, e) {
                                try {
                                    r(o, t, {
                                        value: e,
                                        configurable: !0,
                                        writable: !0
                                    });
                                } catch (n) {
                                    o[t] = e;
                                }
                                return e;
                            };
                        },
                        4606: function(t, e, n) {
                            var o = n(6823), r = TypeError;
                            t.exports = function(t, e) {
                                if (!delete t[e]) throw new r("Cannot delete property " + o(e) + " of " + o(t));
                            };
                        },
                        3724: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                return 7 !== Object.defineProperty({}, 1, {
                                    get: function() {
                                        return 7;
                                    }
                                })[1];
                            });
                        },
                        4055: function(t, e, n) {
                            var o = n(4576), r = n(34), i = o.document, a = r(i) && r(i.createElement);
                            t.exports = function(t) {
                                return a ? i.createElement(t) : {};
                            };
                        },
                        6837: function(t) {
                            var e = TypeError;
                            t.exports = function(t) {
                                if (t > 9007199254740991) throw e("Maximum allowed index exceeded");
                                return t;
                            };
                        },
                        7400: function(t) {
                            t.exports = {
                                CSSRuleList: 0,
                                CSSStyleDeclaration: 0,
                                CSSValueList: 0,
                                ClientRectList: 0,
                                DOMRectList: 0,
                                DOMStringList: 0,
                                DOMTokenList: 1,
                                DataTransferItemList: 0,
                                FileList: 0,
                                HTMLAllCollection: 0,
                                HTMLCollection: 0,
                                HTMLFormElement: 0,
                                HTMLSelectElement: 0,
                                MediaList: 0,
                                MimeTypeArray: 0,
                                NamedNodeMap: 0,
                                NodeList: 1,
                                PaintRequestList: 0,
                                Plugin: 0,
                                PluginArray: 0,
                                SVGLengthList: 0,
                                SVGNumberList: 0,
                                SVGPathSegList: 0,
                                SVGPointList: 0,
                                SVGStringList: 0,
                                SVGTransformList: 0,
                                SourceBufferList: 0,
                                StyleSheetList: 0,
                                TextTrackCueList: 0,
                                TextTrackList: 0,
                                TouchList: 0
                            };
                        },
                        9296: function(t, e, n) {
                            var o = n(4055)("span").classList, r = o && o.constructor && o.constructor.prototype;
                            t.exports = r === Object.prototype ? void 0 : r;
                        },
                        8727: function(t) {
                            t.exports = [
                                "constructor",
                                "hasOwnProperty",
                                "isPrototypeOf",
                                "propertyIsEnumerable",
                                "toLocaleString",
                                "toString",
                                "valueOf"
                            ];
                        },
                        3709: function(t, e, n) {
                            var o = n(2839).match(/firefox\/(\d+)/i);
                            t.exports = !!o && +o[1];
                        },
                        3763: function(t, e, n) {
                            var o = n(2839);
                            t.exports = /MSIE|Trident/.test(o);
                        },
                        6193: function(t, e, n) {
                            var o = n(4215);
                            t.exports = "NODE" === o;
                        },
                        2839: function(t, e, n) {
                            var o = n(4576).navigator, r = o && o.userAgent;
                            t.exports = r ? String(r) : "";
                        },
                        9519: function(t, e, n) {
                            var o, r, i = n(4576), a = n(2839), s = i.process, u = i.Deno, c = s && s.versions || u && u.version, l = c && c.v8;
                            l && (r = (o = l.split("."))[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !r && a && (!(o = a.match(/Edge\/(\d+)/)) || o[1] >= 74) && (o = a.match(/Chrome\/(\d+)/)) && (r = +o[1]), t.exports = r;
                        },
                        3607: function(t, e, n) {
                            var o = n(2839).match(/AppleWebKit\/(\d+)\./);
                            t.exports = !!o && +o[1];
                        },
                        4215: function(t, e, n) {
                            var o = n(4576), r = n(2839), i = n(2195), a = function(t) {
                                return r.slice(0, t.length) === t;
                            };
                            t.exports = a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : o.Bun && "string" == typeof Bun.version ? "BUN" : o.Deno && "object" == typeof Deno.version ? "DENO" : "process" === i(o.process) ? "NODE" : o.window && o.document ? "BROWSER" : "REST";
                        },
                        6518: function(t, e, n) {
                            var o = n(4576), r = n(7347).f, i = n(6699), a = n(6840), s = n(9433), u = n(7740), c = n(2796);
                            t.exports = function(t, e) {
                                var n, l, f, d, p, h = t.target, v = t.global, y = t.stat;
                                if (n = v ? o : y ? o[h] || s(h, {}) : o[h] && o[h].prototype) for(l in e){
                                    if (d = e[l], f = t.dontCallGetSet ? (p = r(n, l)) && p.value : n[l], !c(v ? l : h + (y ? "." : "#") + l, t.forced) && void 0 !== f) {
                                        if (typeof d == typeof f) continue;
                                        u(d, f);
                                    }
                                    (t.sham || f && f.sham) && i(d, "sham", !0), a(n, l, d, t);
                                }
                            };
                        },
                        9039: function(t) {
                            t.exports = function(t) {
                                try {
                                    return !!t();
                                } catch (t) {
                                    return !0;
                                }
                            };
                        },
                        9228: function(t, e, n) {
                            n(7495);
                            var o = n(9565), r = n(6840), i = n(7323), a = n(9039), s = n(8227), u = n(6699), c = s("species"), l = RegExp.prototype;
                            t.exports = function(t, e, n, f) {
                                var d = s(t), p = !a(function() {
                                    var e = {};
                                    return e[d] = function() {
                                        return 7;
                                    }, 7 !== ""[t](e);
                                }), h = p && !a(function() {
                                    var e = !1, n = /a/;
                                    return "split" === t && ((n = {}).constructor = {}, n.constructor[c] = function() {
                                        return n;
                                    }, n.flags = "", n[d] = /./[d]), n.exec = function() {
                                        return e = !0, null;
                                    }, n[d](""), !e;
                                });
                                if (!p || !h || n) {
                                    var v = /./[d], y = e(d, ""[t], function(t, e, n, r, a) {
                                        var s = e.exec;
                                        return s === i || s === l.exec ? p && !a ? {
                                            done: !0,
                                            value: o(v, e, n, r)
                                        } : {
                                            done: !0,
                                            value: o(t, n, e, r)
                                        } : {
                                            done: !1
                                        };
                                    });
                                    r(String.prototype, t, y[0]), r(l, d, y[1]);
                                }
                                f && u(l[d], "sham", !0);
                            };
                        },
                        8745: function(t, e, n) {
                            var o = n(616), r = Function.prototype, i = r.apply, a = r.call;
                            t.exports = "object" == typeof Reflect && Reflect.apply || (o ? a.bind(i) : function() {
                                return a.apply(i, arguments);
                            });
                        },
                        6080: function(t, e, n) {
                            var o = n(7476), r = n(9306), i = n(616), a = o(o.bind);
                            t.exports = function(t, e) {
                                return r(t), void 0 === e ? t : i ? a(t, e) : function() {
                                    return t.apply(e, arguments);
                                };
                            };
                        },
                        616: function(t, e, n) {
                            var o = n(9039);
                            t.exports = !o(function() {
                                var t = (function() {}).bind();
                                return "function" != typeof t || t.hasOwnProperty("prototype");
                            });
                        },
                        9565: function(t, e, n) {
                            var o = n(616), r = Function.prototype.call;
                            t.exports = o ? r.bind(r) : function() {
                                return r.apply(r, arguments);
                            };
                        },
                        350: function(t, e, n) {
                            var o = n(3724), r = n(9297), i = Function.prototype, a = o && Object.getOwnPropertyDescriptor, s = r(i, "name"), u = s && "something" === (function() {}).name, c = s && (!o || o && a(i, "name").configurable);
                            t.exports = {
                                EXISTS: s,
                                PROPER: u,
                                CONFIGURABLE: c
                            };
                        },
                        6706: function(t, e, n) {
                            var o = n(9504), r = n(9306);
                            t.exports = function(t, e, n) {
                                try {
                                    return o(r(Object.getOwnPropertyDescriptor(t, e)[n]));
                                } catch (t) {}
                            };
                        },
                        7476: function(t, e, n) {
                            var o = n(2195), r = n(9504);
                            t.exports = function(t) {
                                if ("Function" === o(t)) return r(t);
                            };
                        },
                        9504: function(t, e, n) {
                            var o = n(616), r = Function.prototype, i = r.call, a = o && r.bind.bind(i, i);
                            t.exports = o ? a : function(t) {
                                return function() {
                                    return i.apply(t, arguments);
                                };
                            };
                        },
                        7751: function(t, e, n) {
                            var o = n(4576), r = n(4901);
                            t.exports = function(t, e) {
                                var n;
                                return arguments.length < 2 ? (n = o[t], r(n) ? n : void 0) : o[t] && o[t][e];
                            };
                        },
                        851: function(t, e, n) {
                            var o = n(6955), r = n(5966), i = n(4117), a = n(6269), s = n(8227)("iterator");
                            t.exports = function(t) {
                                if (!i(t)) return r(t, s) || r(t, "@@iterator") || a[o(t)];
                            };
                        },
                        81: function(t, e, n) {
                            var o = n(9565), r = n(9306), i = n(8551), a = n(6823), s = n(851), u = TypeError;
                            t.exports = function(t, e) {
                                var n = arguments.length < 2 ? s(t) : e;
                                if (r(n)) return i(o(n, t));
                                throw new u(a(t) + " is not iterable");
                            };
                        },
                        6933: function(t, e, n) {
                            var o = n(9504), r = n(4376), i = n(4901), a = n(2195), s = n(655), u = o([].push);
                            t.exports = function(t) {
                                if (i(t)) return t;
                                if (r(t)) {
                                    for(var e = t.length, n = [], o = 0; o < e; o++){
                                        var c = t[o];
                                        "string" == typeof c ? u(n, c) : "number" != typeof c && "Number" !== a(c) && "String" !== a(c) || u(n, s(c));
                                    }
                                    var l = n.length, f = !0;
                                    return function(t, e) {
                                        if (f) return f = !1, e;
                                        if (r(this)) return e;
                                        for(var o = 0; o < l; o++)if (n[o] === t) return e;
                                    };
                                }
                            };
                        },
                        5966: function(t, e, n) {
                            var o = n(9306), r = n(4117);
                            t.exports = function(t, e) {
                                var n = t[e];
                                return r(n) ? void 0 : o(n);
                            };
                        },
                        2478: function(t, e, n) {
                            var o = n(9504), r = n(8981), i = Math.floor, a = o("".charAt), s = o("".replace), u = o("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                            t.exports = function(t, e, n, o, f, d) {
                                var p = n + t.length, h = o.length, v = l;
                                return void 0 !== f && (f = r(f), v = c), s(d, v, function(r, s) {
                                    var c;
                                    switch(a(s, 0)){
                                        case "$":
                                            return "$";
                                        case "&":
                                            return t;
                                        case "`":
                                            return u(e, 0, n);
                                        case "'":
                                            return u(e, p);
                                        case "<":
                                            c = f[u(s, 1, -1)];
                                            break;
                                        default:
                                            var l = +s;
                                            if (0 === l) return r;
                                            if (l > h) {
                                                var d = i(l / 10);
                                                return 0 === d ? r : d <= h ? void 0 === o[d - 1] ? a(s, 1) : o[d - 1] + a(s, 1) : r;
                                            }
                                            c = o[l - 1];
                                    }
                                    return void 0 === c ? "" : c;
                                });
                            };
                        },
                        4576: function(t, e, n) {
                            var o = function(t) {
                                return t && t.Math === Math && t;
                            };
                            t.exports = o("object" == typeof globalThis && globalThis) || o("object" == typeof window && window) || o("object" == typeof self && self) || o("object" == typeof n.g && n.g) || o("object" == typeof this && this) || function() {
                                return this;
                            }() || Function("return this")();
                        },
                        9297: function(t, e, n) {
                            var o = n(9504), r = n(8981), i = o({}.hasOwnProperty);
                            t.exports = Object.hasOwn || function(t, e) {
                                return i(r(t), e);
                            };
                        },
                        421: function(t) {
                            t.exports = {};
                        },
                        397: function(t, e, n) {
                            var o = n(7751);
                            t.exports = o("document", "documentElement");
                        },
                        5917: function(t, e, n) {
                            var o = n(3724), r = n(9039), i = n(4055);
                            t.exports = !o && !r(function() {
                                return 7 !== Object.defineProperty(i("div"), "a", {
                                    get: function() {
                                        return 7;
                                    }
                                }).a;
                            });
                        },
                        7055: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(2195), a = Object, s = o("".split);
                            t.exports = r(function() {
                                return !a("z").propertyIsEnumerable(0);
                            }) ? function(t) {
                                return "String" === i(t) ? s(t, "") : a(t);
                            } : a;
                        },
                        3167: function(t, e, n) {
                            var o = n(4901), r = n(34), i = n(2967);
                            t.exports = function(t, e, n) {
                                var a, s;
                                return i && o(a = e.constructor) && a !== n && r(s = a.prototype) && s !== n.prototype && i(t, s), t;
                            };
                        },
                        3706: function(t, e, n) {
                            var o = n(9504), r = n(4901), i = n(7629), a = o(Function.toString);
                            r(i.inspectSource) || (i.inspectSource = function(t) {
                                return a(t);
                            }), t.exports = i.inspectSource;
                        },
                        1181: function(t, e, n) {
                            var o, r, i, a = n(8622), s = n(4576), u = n(34), c = n(6699), l = n(9297), f = n(7629), d = n(6119), p = n(421), h = "Object already initialized", v = s.TypeError, y = s.WeakMap;
                            if (a || f.state) {
                                var g = f.state || (f.state = new y);
                                g.get = g.get, g.has = g.has, g.set = g.set, o = function(t, e) {
                                    if (g.has(t)) throw new v(h);
                                    return e.facade = t, g.set(t, e), e;
                                }, r = function(t) {
                                    return g.get(t) || {};
                                }, i = function(t) {
                                    return g.has(t);
                                };
                            } else {
                                var m = d("state");
                                p[m] = !0, o = function(t, e) {
                                    if (l(t, m)) throw new v(h);
                                    return e.facade = t, c(t, m, e), e;
                                }, r = function(t) {
                                    return l(t, m) ? t[m] : {};
                                }, i = function(t) {
                                    return l(t, m);
                                };
                            }
                            t.exports = {
                                set: o,
                                get: r,
                                has: i,
                                enforce: function(t) {
                                    return i(t) ? r(t) : o(t, {});
                                },
                                getterFor: function(t) {
                                    return function(e) {
                                        var n;
                                        if (!u(e) || (n = r(e)).type !== t) throw new v("Incompatible receiver, " + t + " required");
                                        return n;
                                    };
                                }
                            };
                        },
                        4209: function(t, e, n) {
                            var o = n(8227), r = n(6269), i = o("iterator"), a = Array.prototype;
                            t.exports = function(t) {
                                return void 0 !== t && (r.Array === t || a[i] === t);
                            };
                        },
                        4376: function(t, e, n) {
                            var o = n(2195);
                            t.exports = Array.isArray || function(t) {
                                return "Array" === o(t);
                            };
                        },
                        4901: function(t) {
                            var e = "object" == typeof document && document.all;
                            t.exports = void 0 === e && void 0 !== e ? function(t) {
                                return "function" == typeof t || t === e;
                            } : function(t) {
                                return "function" == typeof t;
                            };
                        },
                        3517: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(4901), a = n(6955), s = n(7751), u = n(3706), c = function() {}, l = s("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = o(f.exec), p = !f.test(c), h = function(t) {
                                if (!i(t)) return !1;
                                try {
                                    return l(c, [], t), !0;
                                } catch (t) {
                                    return !1;
                                }
                            }, v = function(t) {
                                if (!i(t)) return !1;
                                switch(a(t)){
                                    case "AsyncFunction":
                                    case "GeneratorFunction":
                                    case "AsyncGeneratorFunction":
                                        return !1;
                                }
                                try {
                                    return p || !!d(f, u(t));
                                } catch (t) {
                                    return !0;
                                }
                            };
                            v.sham = !0, t.exports = !l || r(function() {
                                var t;
                                return h(h.call) || !h(Object) || !h(function() {
                                    t = !0;
                                }) || t;
                            }) ? v : h;
                        },
                        2796: function(t, e, n) {
                            var o = n(9039), r = n(4901), i = /#|\.prototype\./, a = function(t, e) {
                                var n = u[s(t)];
                                return n === l || n !== c && (r(e) ? o(e) : !!e);
                            }, s = a.normalize = function(t) {
                                return String(t).replace(i, ".").toLowerCase();
                            }, u = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
                            t.exports = a;
                        },
                        2087: function(t, e, n) {
                            var o = n(34), r = Math.floor;
                            t.exports = Number.isInteger || function(t) {
                                return !o(t) && isFinite(t) && r(t) === t;
                            };
                        },
                        4117: function(t) {
                            t.exports = function(t) {
                                return null == t;
                            };
                        },
                        34: function(t, e, n) {
                            var o = n(4901);
                            t.exports = function(t) {
                                return "object" == typeof t ? null !== t : o(t);
                            };
                        },
                        3925: function(t, e, n) {
                            var o = n(34);
                            t.exports = function(t) {
                                return o(t) || null === t;
                            };
                        },
                        6395: function(t) {
                            t.exports = !1;
                        },
                        788: function(t, e, n) {
                            var o = n(34), r = n(2195), i = n(8227)("match");
                            t.exports = function(t) {
                                var e;
                                return o(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" === r(t));
                            };
                        },
                        757: function(t, e, n) {
                            var o = n(7751), r = n(4901), i = n(1625), a = n(7040), s = Object;
                            t.exports = a ? function(t) {
                                return "symbol" == typeof t;
                            } : function(t) {
                                var e = o("Symbol");
                                return r(e) && i(e.prototype, s(t));
                            };
                        },
                        9539: function(t, e, n) {
                            var o = n(9565), r = n(8551), i = n(5966);
                            t.exports = function(t, e, n) {
                                var a, s;
                                r(t);
                                try {
                                    if (!(a = i(t, "return"))) {
                                        if ("throw" === e) throw n;
                                        return n;
                                    }
                                    a = o(a, t);
                                } catch (t) {
                                    s = !0, a = t;
                                }
                                if ("throw" === e) throw n;
                                if (s) throw a;
                                return r(a), n;
                            };
                        },
                        3994: function(t, e, n) {
                            var o = n(7657).IteratorPrototype, r = n(2360), i = n(6980), a = n(687), s = n(6269), u = function() {
                                return this;
                            };
                            t.exports = function(t, e, n, c) {
                                var l = e + " Iterator";
                                return t.prototype = r(o, {
                                    next: i(+!c, n)
                                }), a(t, l, !1, !0), s[l] = u, t;
                            };
                        },
                        1088: function(t, e, n) {
                            var o = n(6518), r = n(9565), i = n(6395), a = n(350), s = n(4901), u = n(3994), c = n(2787), l = n(2967), f = n(687), d = n(6699), p = n(6840), h = n(8227), v = n(6269), y = n(7657), g = a.PROPER, m = a.CONFIGURABLE, b = y.IteratorPrototype, w = y.BUGGY_SAFARI_ITERATORS, x = h("iterator"), E = "keys", O = "values", S = "entries", k = function() {
                                return this;
                            };
                            t.exports = function(t, e, n, a, h, y, P) {
                                u(n, e, a);
                                var I, C, A, M = function(t) {
                                    if (t === h && R) return R;
                                    if (!w && t && t in N) return N[t];
                                    switch(t){
                                        case E:
                                        case O:
                                        case S:
                                            return function() {
                                                return new n(this, t);
                                            };
                                    }
                                    return function() {
                                        return new n(this);
                                    };
                                }, D = e + " Iterator", T = !1, N = t.prototype, j = N[x] || N["@@iterator"] || h && N[h], R = !w && j || M(h), L = "Array" === e && N.entries || j;
                                if (L && (I = c(L.call(new t))) !== Object.prototype && I.next && (i || c(I) === b || (l ? l(I, b) : s(I[x]) || p(I, x, k)), f(I, D, !0, !0), i && (v[D] = k)), g && h === O && j && j.name !== O && (!i && m ? d(N, "name", O) : (T = !0, R = function() {
                                    return r(j, this);
                                })), h) {
                                    if (C = {
                                        values: M(O),
                                        keys: y ? R : M(E),
                                        entries: M(S)
                                    }, P) for(A in C)(w || T || !(A in N)) && p(N, A, C[A]);
                                    else o({
                                        target: e,
                                        proto: !0,
                                        forced: w || T
                                    }, C);
                                }
                                return i && !P || N[x] === R || p(N, x, R, {
                                    name: h
                                }), v[e] = R, C;
                            };
                        },
                        7657: function(t, e, n) {
                            var o, r, i, a = n(9039), s = n(4901), u = n(34), c = n(2360), l = n(2787), f = n(6840), d = n(8227), p = n(6395), h = d("iterator"), v = !1;
                            [].keys && ("next" in (i = [].keys()) ? (r = l(l(i))) !== Object.prototype && (o = r) : v = !0), !u(o) || a(function() {
                                var t = {};
                                return o[h].call(t) !== t;
                            }) ? o = {} : p && (o = c(o)), s(o[h]) || f(o, h, function() {
                                return this;
                            }), t.exports = {
                                IteratorPrototype: o,
                                BUGGY_SAFARI_ITERATORS: v
                            };
                        },
                        6269: function(t) {
                            t.exports = {};
                        },
                        6198: function(t, e, n) {
                            var o = n(8014);
                            t.exports = function(t) {
                                return o(t.length);
                            };
                        },
                        283: function(t, e, n) {
                            var o = n(9504), r = n(9039), i = n(4901), a = n(9297), s = n(3724), u = n(350).CONFIGURABLE, c = n(3706), l = n(1181), f = l.enforce, d = l.get, p = String, h = Object.defineProperty, v = o("".slice), y = o("".replace), g = o([].join), m = s && !r(function() {
                                return 8 !== h(function() {}, "length", {
                                    value: 8
                                }).length;
                            }), b = String(String).split("String"), w = t.exports = function(t, e, n) {
                                "Symbol(" === v(p(e), 0, 7) && (e = "[" + y(p(e), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n && n.getter && (e = "get " + e), n && n.setter && (e = "set " + e), (!a(t, "name") || u && t.name !== e) && (s ? h(t, "name", {
                                    value: e,
                                    configurable: !0
                                }) : t.name = e), m && n && a(n, "arity") && t.length !== n.arity && h(t, "length", {
                                    value: n.arity
                                });
                                try {
                                    n && a(n, "constructor") && n.constructor ? s && h(t, "prototype", {
                                        writable: !1
                                    }) : t.prototype && (t.prototype = void 0);
                                } catch (t) {}
                                var o = f(t);
                                return a(o, "source") || (o.source = g(b, "string" == typeof e ? e : "")), t;
                            };
                            Function.prototype.toString = w(function() {
                                return i(this) && d(this).source || c(this);
                            }, "toString");
                        },
                        741: function(t) {
                            var e = Math.ceil, n = Math.floor;
                            t.exports = Math.trunc || function(t) {
                                var o = +t;
                                return (o > 0 ? n : e)(o);
                            };
                        },
                        5749: function(t, e, n) {
                            var o = n(788), r = TypeError;
                            t.exports = function(t) {
                                if (o(t)) throw new r("The method doesn't accept regular expressions");
                                return t;
                            };
                        },
                        4213: function(t, e, n) {
                            var o = n(3724), r = n(9504), i = n(9565), a = n(9039), s = n(1072), u = n(3717), c = n(8773), l = n(8981), f = n(7055), d = Object.assign, p = Object.defineProperty, h = r([].concat);
                            t.exports = !d || a(function() {
                                if (o && 1 !== d({
                                    b: 1
                                }, d(p({}, "a", {
                                    enumerable: !0,
                                    get: function() {
                                        p(this, "b", {
                                            value: 3,
                                            enumerable: !1
                                        });
                                    }
                                }), {
                                    b: 2
                                })).b) return !0;
                                var t = {}, e = {}, n = Symbol("assign detection"), r = "abcdefghijklmnopqrst";
                                return t[n] = 7, r.split("").forEach(function(t) {
                                    e[t] = t;
                                }), 7 !== d({}, t)[n] || s(d({}, e)).join("") !== r;
                            }) ? function(t, e) {
                                for(var n = l(t), r = arguments.length, a = 1, d = u.f, p = c.f; r > a;)for(var v, y = f(arguments[a++]), g = d ? h(s(y), d(y)) : s(y), m = g.length, b = 0; m > b;)v = g[b++], o && !i(p, y, v) || (n[v] = y[v]);
                                return n;
                            } : d;
                        },
                        2360: function(t, e, n) {
                            var o, r = n(8551), i = n(6801), a = n(8727), s = n(421), u = n(397), c = n(4055), l = n(6119), f = "prototype", d = "script", p = l("IE_PROTO"), h = function() {}, v = function(t) {
                                return "<" + d + ">" + t + "</" + d + ">";
                            }, y = function(t) {
                                t.write(v("")), t.close();
                                var e = t.parentWindow.Object;
                                return t = null, e;
                            }, g = function() {
                                try {
                                    o = new ActiveXObject("htmlfile");
                                } catch (t) {}
                                var t, e, n;
                                g = "undefined" != typeof document ? document.domain && o ? y(o) : (e = c("iframe"), n = "java" + d + ":", e.style.display = "none", u.appendChild(e), e.src = String(n), (t = e.contentWindow.document).open(), t.write(v("document.F=Object")), t.close(), t.F) : y(o);
                                for(var r = a.length; r--;)delete g[f][a[r]];
                                return g();
                            };
                            s[p] = !0, t.exports = Object.create || function(t, e) {
                                var n;
                                return null !== t ? (h[f] = r(t), n = new h, h[f] = null, n[p] = t) : n = g(), void 0 === e ? n : i.f(n, e);
                            };
                        },
                        6801: function(t, e, n) {
                            var o = n(3724), r = n(8686), i = n(4913), a = n(8551), s = n(5397), u = n(1072);
                            e.f = o && !r ? Object.defineProperties : function(t, e) {
                                a(t);
                                for(var n, o = s(e), r = u(e), c = r.length, l = 0; c > l;)i.f(t, n = r[l++], o[n]);
                                return t;
                            };
                        },
                        4913: function(t, e, n) {
                            var o = n(3724), r = n(5917), i = n(8686), a = n(8551), s = n(6969), u = TypeError, c = Object.defineProperty, l = Object.getOwnPropertyDescriptor, f = "enumerable", d = "configurable", p = "writable";
                            e.f = o ? i ? function(t, e, n) {
                                if (a(t), e = s(e), a(n), "function" == typeof t && "prototype" === e && "value" in n && p in n && !n[p]) {
                                    var o = l(t, e);
                                    o && o[p] && (t[e] = n.value, n = {
                                        configurable: d in n ? n[d] : o[d],
                                        enumerable: f in n ? n[f] : o[f],
                                        writable: !1
                                    });
                                }
                                return c(t, e, n);
                            } : c : function(t, e, n) {
                                if (a(t), e = s(e), a(n), r) try {
                                    return c(t, e, n);
                                } catch (t) {}
                                if ("get" in n || "set" in n) throw new u("Accessors not supported");
                                return "value" in n && (t[e] = n.value), t;
                            };
                        },
                        7347: function(t, e, n) {
                            var o = n(3724), r = n(9565), i = n(8773), a = n(6980), s = n(5397), u = n(6969), c = n(9297), l = n(5917), f = Object.getOwnPropertyDescriptor;
                            e.f = o ? f : function(t, e) {
                                if (t = s(t), e = u(e), l) try {
                                    return f(t, e);
                                } catch (t) {}
                                if (c(t, e)) return a(!r(i.f, t, e), t[e]);
                            };
                        },
                        298: function(t, e, n) {
                            var o = n(2195), r = n(5397), i = n(8480).f, a = n(7680), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                            t.exports.f = function(t) {
                                return s && "Window" === o(t) ? function(t) {
                                    try {
                                        return i(t);
                                    } catch (t) {
                                        return a(s);
                                    }
                                }(t) : i(r(t));
                            };
                        },
                        8480: function(t, e, n) {
                            var o = n(1828), r = n(8727).concat("length", "prototype");
                            e.f = Object.getOwnPropertyNames || function(t) {
                                return o(t, r);
                            };
                        },
                        3717: function(t, e) {
                            e.f = Object.getOwnPropertySymbols;
                        },
                        2787: function(t, e, n) {
                            var o = n(9297), r = n(4901), i = n(8981), a = n(6119), s = n(2211), u = a("IE_PROTO"), c = Object, l = c.prototype;
                            t.exports = s ? c.getPrototypeOf : function(t) {
                                var e = i(t);
                                if (o(e, u)) return e[u];
                                var n = e.constructor;
                                return r(n) && e instanceof n ? n.prototype : e instanceof c ? l : null;
                            };
                        },
                        1625: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o({}.isPrototypeOf);
                        },
                        1828: function(t, e, n) {
                            var o = n(9504), r = n(9297), i = n(5397), a = n(9617).indexOf, s = n(421), u = o([].push);
                            t.exports = function(t, e) {
                                var n, o = i(t), c = 0, l = [];
                                for(n in o)!r(s, n) && r(o, n) && u(l, n);
                                for(; e.length > c;)r(o, n = e[c++]) && (~a(l, n) || u(l, n));
                                return l;
                            };
                        },
                        1072: function(t, e, n) {
                            var o = n(1828), r = n(8727);
                            t.exports = Object.keys || function(t) {
                                return o(t, r);
                            };
                        },
                        8773: function(t, e) {
                            var n = {}.propertyIsEnumerable, o = Object.getOwnPropertyDescriptor, r = o && !n.call({
                                1: 2
                            }, 1);
                            e.f = r ? function(t) {
                                var e = o(this, t);
                                return !!e && e.enumerable;
                            } : n;
                        },
                        2551: function(t, e, n) {
                            var o = n(6395), r = n(4576), i = n(9039), a = n(3607);
                            t.exports = o || !i(function() {
                                if (!(a && a < 535)) {
                                    var t = Math.random();
                                    __defineSetter__.call(null, t, function() {}), delete r[t];
                                }
                            });
                        },
                        2967: function(t, e, n) {
                            var o = n(6706), r = n(34), i = n(7750), a = n(3506);
                            t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                                var t, e = !1, n = {};
                                try {
                                    (t = o(Object.prototype, "__proto__", "set"))(n, []), e = n instanceof Array;
                                } catch (t) {}
                                return function(n, o) {
                                    return i(n), a(o), r(n) ? (e ? t(n, o) : n.__proto__ = o, n) : n;
                                };
                            }() : void 0);
                        },
                        3179: function(t, e, n) {
                            var o = n(2140), r = n(6955);
                            t.exports = o ? ({}).toString : function() {
                                return "[object " + r(this) + "]";
                            };
                        },
                        4270: function(t, e, n) {
                            var o = n(9565), r = n(4901), i = n(34), a = TypeError;
                            t.exports = function(t, e) {
                                var n, s;
                                if ("string" === e && r(n = t.toString) && !i(s = o(n, t))) return s;
                                if (r(n = t.valueOf) && !i(s = o(n, t))) return s;
                                if ("string" !== e && r(n = t.toString) && !i(s = o(n, t))) return s;
                                throw new a("Can't convert object to primitive value");
                            };
                        },
                        5031: function(t, e, n) {
                            var o = n(7751), r = n(9504), i = n(8480), a = n(3717), s = n(8551), u = r([].concat);
                            t.exports = o("Reflect", "ownKeys") || function(t) {
                                var e = i.f(s(t)), n = a.f;
                                return n ? u(e, n(t)) : e;
                            };
                        },
                        9167: function(t, e, n) {
                            var o = n(4576);
                            t.exports = o;
                        },
                        1056: function(t, e, n) {
                            var o = n(4913).f;
                            t.exports = function(t, e, n) {
                                n in t || o(t, n, {
                                    configurable: !0,
                                    get: function() {
                                        return e[n];
                                    },
                                    set: function(t) {
                                        e[n] = t;
                                    }
                                });
                            };
                        },
                        6682: function(t, e, n) {
                            var o = n(9565), r = n(8551), i = n(4901), a = n(2195), s = n(7323), u = TypeError;
                            t.exports = function(t, e) {
                                var n = t.exec;
                                if (i(n)) {
                                    var c = o(n, t, e);
                                    return null !== c && r(c), c;
                                }
                                if ("RegExp" === a(t)) return o(s, t, e);
                                throw new u("RegExp#exec called on incompatible receiver");
                            };
                        },
                        7323: function(t, e, n) {
                            var o, r, i = n(9565), a = n(9504), s = n(655), u = n(7979), c = n(8429), l = n(5745), f = n(2360), d = n(1181).get, p = n(3635), h = n(8814), v = l("native-string-replace", String.prototype.replace), y = RegExp.prototype.exec, g = y, m = a("".charAt), b = a("".indexOf), w = a("".replace), x = a("".slice), E = (r = /b*/g, i(y, o = /a/, "a"), i(y, r, "a"), 0 !== o.lastIndex || 0 !== r.lastIndex), O = c.BROKEN_CARET, S = void 0 !== /()??/.exec("")[1];
                            (E || S || O || p || h) && (g = function(t) {
                                var e, n, o, r, a, c, l, p = this, h = d(p), k = s(t), P = h.raw;
                                if (P) return P.lastIndex = p.lastIndex, e = i(g, P, k), p.lastIndex = P.lastIndex, e;
                                var I = h.groups, C = O && p.sticky, A = i(u, p), M = p.source, D = 0, T = k;
                                if (C && (A = w(A, "y", ""), -1 === b(A, "g") && (A += "g"), T = x(k, p.lastIndex), p.lastIndex > 0 && (!p.multiline || p.multiline && "\n" !== m(k, p.lastIndex - 1)) && (M = "(?: " + M + ")", T = " " + T, D++), n = new RegExp("^(?:" + M + ")", A)), S && (n = new RegExp("^" + M + "$(?!\\s)", A)), E && (o = p.lastIndex), r = i(y, C ? n : p, T), C ? r ? (r.input = x(r.input, D), r[0] = x(r[0], D), r.index = p.lastIndex, p.lastIndex += r[0].length) : p.lastIndex = 0 : E && r && (p.lastIndex = p.global ? r.index + r[0].length : o), S && r && r.length > 1 && i(v, r[0], n, function() {
                                    for(a = 1; a < arguments.length - 2; a++)void 0 === arguments[a] && (r[a] = void 0);
                                }), r && I) for(r.groups = c = f(null), a = 0; a < I.length; a++)c[(l = I[a])[0]] = r[l[1]];
                                return r;
                            }), t.exports = g;
                        },
                        7979: function(t, e, n) {
                            var o = n(8551);
                            t.exports = function() {
                                var t = o(this), e = "";
                                return t.hasIndices && (e += "d"), t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.unicodeSets && (e += "v"), t.sticky && (e += "y"), e;
                            };
                        },
                        1034: function(t, e, n) {
                            var o = n(9565), r = n(9297), i = n(1625), a = n(7979), s = RegExp.prototype;
                            t.exports = function(t) {
                                var e = t.flags;
                                return void 0 !== e || "flags" in s || r(t, "flags") || !i(s, t) ? e : o(a, t);
                            };
                        },
                        8429: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp, i = o(function() {
                                var t = r("a", "y");
                                return t.lastIndex = 2, null !== t.exec("abcd");
                            }), a = i || o(function() {
                                return !r("a", "y").sticky;
                            }), s = i || o(function() {
                                var t = r("^r", "gy");
                                return t.lastIndex = 2, null !== t.exec("str");
                            });
                            t.exports = {
                                BROKEN_CARET: s,
                                MISSED_STICKY: a,
                                UNSUPPORTED_Y: i
                            };
                        },
                        3635: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp;
                            t.exports = o(function() {
                                var t = r(".", "s");
                                return !(t.dotAll && t.test("\n") && "s" === t.flags);
                            });
                        },
                        8814: function(t, e, n) {
                            var o = n(9039), r = n(4576).RegExp;
                            t.exports = o(function() {
                                var t = r("(?<a>b)", "g");
                                return "b" !== t.exec("b").groups.a || "bc" !== "b".replace(t, "$<a>c");
                            });
                        },
                        7750: function(t, e, n) {
                            var o = n(4117), r = TypeError;
                            t.exports = function(t) {
                                if (o(t)) throw new r("Can't call method on " + t);
                                return t;
                            };
                        },
                        7633: function(t, e, n) {
                            var o = n(7751), r = n(2106), i = n(8227), a = n(3724), s = i("species");
                            t.exports = function(t) {
                                var e = o(t);
                                a && e && !e[s] && r(e, s, {
                                    configurable: !0,
                                    get: function() {
                                        return this;
                                    }
                                });
                            };
                        },
                        687: function(t, e, n) {
                            var o = n(4913).f, r = n(9297), i = n(8227)("toStringTag");
                            t.exports = function(t, e, n) {
                                t && !n && (t = t.prototype), t && !r(t, i) && o(t, i, {
                                    configurable: !0,
                                    value: e
                                });
                            };
                        },
                        6119: function(t, e, n) {
                            var o = n(5745), r = n(3392), i = o("keys");
                            t.exports = function(t) {
                                return i[t] || (i[t] = r(t));
                            };
                        },
                        7629: function(t, e, n) {
                            var o = n(6395), r = n(4576), i = n(9433), a = "__core-js_shared__", s = t.exports = r[a] || i(a, {});
                            (s.versions || (s.versions = [])).push({
                                version: "3.39.0",
                                mode: o ? "pure" : "global",
                                copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
                                license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
                                source: "https://github.com/zloirock/core-js"
                            });
                        },
                        5745: function(t, e, n) {
                            var o = n(7629);
                            t.exports = function(t, e) {
                                return o[t] || (o[t] = e || {});
                            };
                        },
                        2293: function(t, e, n) {
                            var o = n(8551), r = n(5548), i = n(4117), a = n(8227)("species");
                            t.exports = function(t, e) {
                                var n, s = o(t).constructor;
                                return void 0 === s || i(n = o(s)[a]) ? e : r(n);
                            };
                        },
                        8183: function(t, e, n) {
                            var o = n(9504), r = n(1291), i = n(655), a = n(7750), s = o("".charAt), u = o("".charCodeAt), c = o("".slice), l = function(t) {
                                return function(e, n) {
                                    var o, l, f = i(a(e)), d = r(n), p = f.length;
                                    return d < 0 || d >= p ? t ? "" : void 0 : (o = u(f, d)) < 55296 || o > 56319 || d + 1 === p || (l = u(f, d + 1)) < 56320 || l > 57343 ? t ? s(f, d) : o : t ? c(f, d, d + 2) : l - 56320 + (o - 55296 << 10) + 65536;
                                };
                            };
                            t.exports = {
                                codeAt: l(!1),
                                charAt: l(!0)
                            };
                        },
                        706: function(t, e, n) {
                            var o = n(350).PROPER, r = n(9039), i = n(7452);
                            t.exports = function(t) {
                                return r(function() {
                                    return !!i[t]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[t]() || o && i[t].name !== t;
                                });
                            };
                        },
                        3802: function(t, e, n) {
                            var o = n(9504), r = n(7750), i = n(655), a = n(7452), s = o("".replace), u = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(t) {
                                return function(e) {
                                    var n = i(r(e));
                                    return 1 & t && (n = s(n, u, "")), 2 & t && (n = s(n, c, "$1")), n;
                                };
                            };
                            t.exports = {
                                start: l(1),
                                end: l(2),
                                trim: l(3)
                            };
                        },
                        4495: function(t, e, n) {
                            var o = n(9519), r = n(9039), i = n(4576).String;
                            t.exports = !!Object.getOwnPropertySymbols && !r(function() {
                                var t = Symbol("symbol detection");
                                return !i(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && o && o < 41;
                            });
                        },
                        8242: function(t, e, n) {
                            var o = n(9565), r = n(7751), i = n(8227), a = n(6840);
                            t.exports = function() {
                                var t = r("Symbol"), e = t && t.prototype, n = e && e.valueOf, s = i("toPrimitive");
                                e && !e[s] && a(e, s, function(t) {
                                    return o(n, this);
                                }, {
                                    arity: 1
                                });
                            };
                        },
                        1296: function(t, e, n) {
                            var o = n(4495);
                            t.exports = o && !!Symbol.for && !!Symbol.keyFor;
                        },
                        1240: function(t, e, n) {
                            var o = n(9504);
                            t.exports = o(1..valueOf);
                        },
                        5610: function(t, e, n) {
                            var o = n(1291), r = Math.max, i = Math.min;
                            t.exports = function(t, e) {
                                var n = o(t);
                                return n < 0 ? r(n + e, 0) : i(n, e);
                            };
                        },
                        5397: function(t, e, n) {
                            var o = n(7055), r = n(7750);
                            t.exports = function(t) {
                                return o(r(t));
                            };
                        },
                        1291: function(t, e, n) {
                            var o = n(741);
                            t.exports = function(t) {
                                var e = +t;
                                return e != e || 0 === e ? 0 : o(e);
                            };
                        },
                        8014: function(t, e, n) {
                            var o = n(1291), r = Math.min;
                            t.exports = function(t) {
                                var e = o(t);
                                return e > 0 ? r(e, 9007199254740991) : 0;
                            };
                        },
                        8981: function(t, e, n) {
                            var o = n(7750), r = Object;
                            t.exports = function(t) {
                                return r(o(t));
                            };
                        },
                        2777: function(t, e, n) {
                            var o = n(9565), r = n(34), i = n(757), a = n(5966), s = n(4270), u = n(8227), c = TypeError, l = u("toPrimitive");
                            t.exports = function(t, e) {
                                if (!r(t) || i(t)) return t;
                                var n, u = a(t, l);
                                if (u) {
                                    if (void 0 === e && (e = "default"), n = o(u, t, e), !r(n) || i(n)) return n;
                                    throw new c("Can't convert object to primitive value");
                                }
                                return void 0 === e && (e = "number"), s(t, e);
                            };
                        },
                        6969: function(t, e, n) {
                            var o = n(2777), r = n(757);
                            t.exports = function(t) {
                                var e = o(t, "string");
                                return r(e) ? e : e + "";
                            };
                        },
                        2140: function(t, e, n) {
                            var o = {};
                            o[n(8227)("toStringTag")] = "z", t.exports = "[object z]" === String(o);
                        },
                        655: function(t, e, n) {
                            var o = n(6955), r = String;
                            t.exports = function(t) {
                                if ("Symbol" === o(t)) throw new TypeError("Cannot convert a Symbol value to a string");
                                return r(t);
                            };
                        },
                        6823: function(t) {
                            var e = String;
                            t.exports = function(t) {
                                try {
                                    return e(t);
                                } catch (t) {
                                    return "Object";
                                }
                            };
                        },
                        3392: function(t, e, n) {
                            var o = n(9504), r = 0, i = Math.random(), a = o(1..toString);
                            t.exports = function(t) {
                                return "Symbol(" + (void 0 === t ? "" : t) + ")_" + a(++r + i, 36);
                            };
                        },
                        7040: function(t, e, n) {
                            var o = n(4495);
                            t.exports = o && !Symbol.sham && "symbol" == typeof Symbol.iterator;
                        },
                        8686: function(t, e, n) {
                            var o = n(3724), r = n(9039);
                            t.exports = o && r(function() {
                                return 42 !== Object.defineProperty(function() {}, "prototype", {
                                    value: 42,
                                    writable: !1
                                }).prototype;
                            });
                        },
                        8622: function(t, e, n) {
                            var o = n(4576), r = n(4901), i = o.WeakMap;
                            t.exports = r(i) && /native code/.test(String(i));
                        },
                        511: function(t, e, n) {
                            var o = n(9167), r = n(9297), i = n(1951), a = n(4913).f;
                            t.exports = function(t) {
                                var e = o.Symbol || (o.Symbol = {});
                                r(e, t) || a(e, t, {
                                    value: i.f(t)
                                });
                            };
                        },
                        1951: function(t, e, n) {
                            var o = n(8227);
                            e.f = o;
                        },
                        8227: function(t, e, n) {
                            var o = n(4576), r = n(5745), i = n(9297), a = n(3392), s = n(4495), u = n(7040), c = o.Symbol, l = r("wks"), f = u ? c.for || c : c && c.withoutSetter || a;
                            t.exports = function(t) {
                                return i(l, t) || (l[t] = s && i(c, t) ? c[t] : f("Symbol." + t)), l[t];
                            };
                        },
                        7452: function(t) {
                            t.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
                        },
                        8706: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(4376), a = n(34), s = n(8981), u = n(6198), c = n(6837), l = n(4659), f = n(1469), d = n(597), p = n(8227), h = n(9519), v = p("isConcatSpreadable"), y = h >= 51 || !r(function() {
                                var t = [];
                                return t[v] = !1, t.concat()[0] !== t;
                            }), g = function(t) {
                                if (!a(t)) return !1;
                                var e = t[v];
                                return void 0 !== e ? !!e : i(t);
                            };
                            o({
                                target: "Array",
                                proto: !0,
                                arity: 1,
                                forced: !y || !d("concat")
                            }, {
                                concat: function(t) {
                                    var e, n, o, r, i, a = s(this), d = f(a, 0), p = 0;
                                    for(e = -1, o = arguments.length; e < o; e++)if (g(i = -1 === e ? a : arguments[e])) for(r = u(i), c(p + r), n = 0; n < r; n++, p++)n in i && l(d, p, i[n]);
                                    else c(p + 1), l(d, p++, i);
                                    return d.length = p, d;
                                }
                            });
                        },
                        2008: function(t, e, n) {
                            var o = n(6518), r = n(9213).filter;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(597)("filter")
                            }, {
                                filter: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        3418: function(t, e, n) {
                            var o = n(6518), r = n(7916);
                            o({
                                target: "Array",
                                stat: !0,
                                forced: !n(4428)(function(t) {
                                    Array.from(t);
                                })
                            }, {
                                from: r
                            });
                        },
                        4423: function(t, e, n) {
                            var o = n(6518), r = n(9617).includes, i = n(9039), a = n(6469);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: i(function() {
                                    return !Array(1).includes();
                                })
                            }, {
                                includes: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            }), a("includes");
                        },
                        5276: function(t, e, n) {
                            var o = n(6518), r = n(7476), i = n(9617).indexOf, a = n(4598), s = r([].indexOf), u = !!s && 1 / s([
                                1
                            ], 1, -0) < 0;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: u || !a("indexOf")
                            }, {
                                indexOf: function(t) {
                                    var e = arguments.length > 1 ? arguments[1] : void 0;
                                    return u ? s(this, t, e) || 0 : i(this, t, e);
                                }
                            });
                        },
                        3792: function(t, e, n) {
                            var o = n(5397), r = n(6469), i = n(6269), a = n(1181), s = n(4913).f, u = n(1088), c = n(2529), l = n(6395), f = n(3724), d = "Array Iterator", p = a.set, h = a.getterFor(d);
                            t.exports = u(Array, "Array", function(t, e) {
                                p(this, {
                                    type: d,
                                    target: o(t),
                                    index: 0,
                                    kind: e
                                });
                            }, function() {
                                var t = h(this), e = t.target, n = t.index++;
                                if (!e || n >= e.length) return t.target = null, c(void 0, !0);
                                switch(t.kind){
                                    case "keys":
                                        return c(n, !1);
                                    case "values":
                                        return c(e[n], !1);
                                }
                                return c([
                                    n,
                                    e[n]
                                ], !1);
                            }, "values");
                            var v = i.Arguments = i.Array;
                            if (r("keys"), r("values"), r("entries"), !l && f && "values" !== v.name) try {
                                s(v, "name", {
                                    value: "values"
                                });
                            } catch (t) {}
                        },
                        8598: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(7055), a = n(5397), s = n(4598), u = r([].join);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: i !== Object || !s("join", ",")
                            }, {
                                join: function(t) {
                                    return u(a(this), void 0 === t ? "," : t);
                                }
                            });
                        },
                        2062: function(t, e, n) {
                            var o = n(6518), r = n(9213).map;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(597)("map")
                            }, {
                                map: function(t) {
                                    return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        2712: function(t, e, n) {
                            var o = n(6518), r = n(926).left, i = n(4598), a = n(9519);
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !n(6193) && a > 79 && a < 83 || !i("reduce")
                            }, {
                                reduce: function(t) {
                                    var e = arguments.length;
                                    return r(this, t, e, e > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        4782: function(t, e, n) {
                            var o = n(6518), r = n(4376), i = n(3517), a = n(34), s = n(5610), u = n(6198), c = n(5397), l = n(4659), f = n(8227), d = n(597), p = n(7680), h = d("slice"), v = f("species"), y = Array, g = Math.max;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !h
                            }, {
                                slice: function(t, e) {
                                    var n, o, f, d = c(this), h = u(d), m = s(t, h), b = s(void 0 === e ? h : e, h);
                                    if (r(d) && (n = d.constructor, (i(n) && (n === y || r(n.prototype)) || a(n) && null === (n = n[v])) && (n = void 0), n === y || void 0 === n)) return p(d, m, b);
                                    for(o = new (void 0 === n ? y : n)(g(b - m, 0)), f = 0; m < b; m++, f++)m in d && l(o, f, d[m]);
                                    return o.length = f, o;
                                }
                            });
                        },
                        6910: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(9306), a = n(8981), s = n(6198), u = n(4606), c = n(655), l = n(9039), f = n(4488), d = n(4598), p = n(3709), h = n(3763), v = n(9519), y = n(3607), g = [], m = r(g.sort), b = r(g.push), w = l(function() {
                                g.sort(void 0);
                            }), x = l(function() {
                                g.sort(null);
                            }), E = d("sort"), O = !l(function() {
                                if (v) return v < 70;
                                if (!(p && p > 3)) {
                                    if (h) return !0;
                                    if (y) return y < 603;
                                    var t, e, n, o, r = "";
                                    for(t = 65; t < 76; t++){
                                        switch(e = String.fromCharCode(t), t){
                                            case 66:
                                            case 69:
                                            case 70:
                                            case 72:
                                                n = 3;
                                                break;
                                            case 68:
                                            case 71:
                                                n = 4;
                                                break;
                                            default:
                                                n = 2;
                                        }
                                        for(o = 0; o < 47; o++)g.push({
                                            k: e + o,
                                            v: n
                                        });
                                    }
                                    for(g.sort(function(t, e) {
                                        return e.v - t.v;
                                    }), o = 0; o < g.length; o++)e = g[o].k.charAt(0), r.charAt(r.length - 1) !== e && (r += e);
                                    return "DGBEFHACIJK" !== r;
                                }
                            });
                            o({
                                target: "Array",
                                proto: !0,
                                forced: w || !x || !E || !O
                            }, {
                                sort: function(t) {
                                    void 0 !== t && i(t);
                                    var e = a(this);
                                    if (O) return void 0 === t ? m(e) : m(e, t);
                                    var n, o, r = [], l = s(e);
                                    for(o = 0; o < l; o++)o in e && b(r, e[o]);
                                    for(f(r, function(t) {
                                        return function(e, n) {
                                            return void 0 === n ? -1 : void 0 === e ? 1 : void 0 !== t ? +t(e, n) || 0 : c(e) > c(n) ? 1 : -1;
                                        };
                                    }(t)), n = s(r), o = 0; o < n;)e[o] = r[o++];
                                    for(; o < l;)u(e, o++);
                                    return e;
                                }
                            });
                        },
                        4554: function(t, e, n) {
                            var o = n(6518), r = n(8981), i = n(5610), a = n(1291), s = n(6198), u = n(4527), c = n(6837), l = n(1469), f = n(4659), d = n(4606), p = n(597)("splice"), h = Math.max, v = Math.min;
                            o({
                                target: "Array",
                                proto: !0,
                                forced: !p
                            }, {
                                splice: function(t, e) {
                                    var n, o, p, y, g, m, b = r(this), w = s(b), x = i(t, w), E = arguments.length;
                                    for(0 === E ? n = o = 0 : 1 === E ? (n = 0, o = w - x) : (n = E - 2, o = v(h(a(e), 0), w - x)), c(w + n - o), p = l(b, o), y = 0; y < o; y++)(g = x + y) in b && f(p, y, b[g]);
                                    if (p.length = o, n < o) {
                                        for(y = x; y < w - o; y++)m = y + n, (g = y + o) in b ? b[m] = b[g] : d(b, m);
                                        for(y = w; y > w - o + n; y--)d(b, y - 1);
                                    } else if (n > o) for(y = w - o; y > x; y--)m = y + n - 1, (g = y + o - 1) in b ? b[m] = b[g] : d(b, m);
                                    for(y = 0; y < n; y++)b[y + x] = arguments[y + 2];
                                    return u(b, w - o + n), p;
                                }
                            });
                        },
                        739: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(8981), a = n(2777);
                            o({
                                target: "Date",
                                proto: !0,
                                arity: 1,
                                forced: r(function() {
                                    return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
                                        toISOString: function() {
                                            return 1;
                                        }
                                    });
                                })
                            }, {
                                toJSON: function(t) {
                                    var e = i(this), n = a(e, "number");
                                    return "number" != typeof n || isFinite(n) ? e.toISOString() : null;
                                }
                            });
                        },
                        9572: function(t, e, n) {
                            var o = n(9297), r = n(6840), i = n(3640), a = n(8227)("toPrimitive"), s = Date.prototype;
                            o(s, a) || r(s, a, i);
                        },
                        2010: function(t, e, n) {
                            var o = n(3724), r = n(350).EXISTS, i = n(9504), a = n(2106), s = Function.prototype, u = i(s.toString), c = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, l = i(c.exec);
                            o && !r && a(s, "name", {
                                configurable: !0,
                                get: function() {
                                    try {
                                        return l(c, u(this))[1];
                                    } catch (t) {
                                        return "";
                                    }
                                }
                            });
                        },
                        3110: function(t, e, n) {
                            var o = n(6518), r = n(7751), i = n(8745), a = n(9565), s = n(9504), u = n(9039), c = n(4901), l = n(757), f = n(7680), d = n(6933), p = n(4495), h = String, v = r("JSON", "stringify"), y = s(/./.exec), g = s("".charAt), m = s("".charCodeAt), b = s("".replace), w = s(1..toString), x = /[\uD800-\uDFFF]/g, E = /^[\uD800-\uDBFF]$/, O = /^[\uDC00-\uDFFF]$/, S = !p || u(function() {
                                var t = r("Symbol")("stringify detection");
                                return "[null]" !== v([
                                    t
                                ]) || "{}" !== v({
                                    a: t
                                }) || "{}" !== v(Object(t));
                            }), k = u(function() {
                                return '"\udf06\ud834"' !== v("\udf06\ud834") || '"\udead"' !== v("\udead");
                            }), P = function(t, e) {
                                var n = f(arguments), o = d(e);
                                if (c(o) || void 0 !== t && !l(t)) return n[1] = function(t, e) {
                                    if (c(o) && (e = a(o, this, h(t), e)), !l(e)) return e;
                                }, i(v, null, n);
                            }, I = function(t, e, n) {
                                var o = g(n, e - 1), r = g(n, e + 1);
                                return y(E, t) && !y(O, r) || y(O, t) && !y(E, o) ? "\\u" + w(m(t, 0), 16) : t;
                            };
                            v && o({
                                target: "JSON",
                                stat: !0,
                                arity: 3,
                                forced: S || k
                            }, {
                                stringify: function(t, e, n) {
                                    var o = f(arguments), r = i(S ? P : v, null, o);
                                    return k && "string" == typeof r ? b(r, x, I) : r;
                                }
                            });
                        },
                        2892: function(t, e, n) {
                            var o = n(6518), r = n(6395), i = n(3724), a = n(4576), s = n(9167), u = n(9504), c = n(2796), l = n(9297), f = n(3167), d = n(1625), p = n(757), h = n(2777), v = n(9039), y = n(8480).f, g = n(7347).f, m = n(4913).f, b = n(1240), w = n(3802).trim, x = "Number", E = a[x], O = s[x], S = E.prototype, k = a.TypeError, P = u("".slice), I = u("".charCodeAt), C = function(t) {
                                var e, n, o, r, i, a, s, u, c = h(t, "number");
                                if (p(c)) throw new k("Cannot convert a Symbol value to a number");
                                if ("string" == typeof c && c.length > 2) {
                                    if (c = w(c), 43 === (e = I(c, 0)) || 45 === e) {
                                        if (88 === (n = I(c, 2)) || 120 === n) return NaN;
                                    } else if (48 === e) {
                                        switch(I(c, 1)){
                                            case 66:
                                            case 98:
                                                o = 2, r = 49;
                                                break;
                                            case 79:
                                            case 111:
                                                o = 8, r = 55;
                                                break;
                                            default:
                                                return +c;
                                        }
                                        for(a = (i = P(c, 2)).length, s = 0; s < a; s++)if ((u = I(i, s)) < 48 || u > r) return NaN;
                                        return parseInt(i, o);
                                    }
                                }
                                return +c;
                            }, A = c(x, !E(" 0o1") || !E("0b1") || E("+0x1")), M = function(t) {
                                var e, n = arguments.length < 1 ? 0 : E(function(t) {
                                    var e = h(t, "number");
                                    return "bigint" == typeof e ? e : C(e);
                                }(t));
                                return d(S, e = this) && v(function() {
                                    b(e);
                                }) ? f(Object(n), this, M) : n;
                            };
                            M.prototype = S, A && !r && (S.constructor = M), o({
                                global: !0,
                                constructor: !0,
                                wrap: !0,
                                forced: A
                            }, {
                                Number: M
                            });
                            var D = function(t, e) {
                                for(var n, o = i ? y(e) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), r = 0; o.length > r; r++)l(e, n = o[r]) && !l(t, n) && m(t, n, g(e, n));
                            };
                            r && O && D(s[x], O), (A || r) && D(s[x], E);
                        },
                        2637: function(t, e, n) {
                            n(6518)({
                                target: "Number",
                                stat: !0
                            }, {
                                isInteger: n(2087)
                            });
                        },
                        9085: function(t, e, n) {
                            var o = n(6518), r = n(4213);
                            o({
                                target: "Object",
                                stat: !0,
                                arity: 2,
                                forced: Object.assign !== r
                            }, {
                                assign: r
                            });
                        },
                        7427: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(2551), a = n(9306), s = n(8981), u = n(4913);
                            r && o({
                                target: "Object",
                                proto: !0,
                                forced: i
                            }, {
                                __defineGetter__: function(t, e) {
                                    u.f(s(this), t, {
                                        get: a(e),
                                        enumerable: !0,
                                        configurable: !0
                                    });
                                }
                            });
                        },
                        3851: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(5397), a = n(7347).f, s = n(3724);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: !s || r(function() {
                                    a(1);
                                }),
                                sham: !s
                            }, {
                                getOwnPropertyDescriptor: function(t, e) {
                                    return a(i(t), e);
                                }
                            });
                        },
                        1278: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(5031), a = n(5397), s = n(7347), u = n(4659);
                            o({
                                target: "Object",
                                stat: !0,
                                sham: !r
                            }, {
                                getOwnPropertyDescriptors: function(t) {
                                    for(var e, n, o = a(t), r = s.f, c = i(o), l = {}, f = 0; c.length > f;)void 0 !== (n = r(o, e = c[f++])) && u(l, e, n);
                                    return l;
                                }
                            });
                        },
                        1480: function(t, e, n) {
                            var o = n(6518), r = n(9039), i = n(298).f;
                            o({
                                target: "Object",
                                stat: !0,
                                forced: r(function() {
                                    return !Object.getOwnPropertyNames(1);
                                })
                            }, {
                                getOwnPropertyNames: i
                            });
                        },
                        9773: function(t, e, n) {
                            var o = n(6518), r = n(4495), i = n(9039), a = n(3717), s = n(8981);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: !r || i(function() {
                                    a.f(1);
                                })
                            }, {
                                getOwnPropertySymbols: function(t) {
                                    var e = a.f;
                                    return e ? e(s(t)) : [];
                                }
                            });
                        },
                        9432: function(t, e, n) {
                            var o = n(6518), r = n(8981), i = n(1072);
                            o({
                                target: "Object",
                                stat: !0,
                                forced: n(9039)(function() {
                                    i(1);
                                })
                            }, {
                                keys: function(t) {
                                    return i(r(t));
                                }
                            });
                        },
                        6099: function(t, e, n) {
                            var o = n(2140), r = n(6840), i = n(3179);
                            o || r(Object.prototype, "toString", i, {
                                unsafe: !0
                            });
                        },
                        4864: function(t, e, n) {
                            var o = n(3724), r = n(4576), i = n(9504), a = n(2796), s = n(3167), u = n(6699), c = n(2360), l = n(8480).f, f = n(1625), d = n(788), p = n(655), h = n(1034), v = n(8429), y = n(1056), g = n(6840), m = n(9039), b = n(9297), w = n(1181).enforce, x = n(7633), E = n(8227), O = n(3635), S = n(8814), k = E("match"), P = r.RegExp, I = P.prototype, C = r.SyntaxError, A = i(I.exec), M = i("".charAt), D = i("".replace), T = i("".indexOf), N = i("".slice), j = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, R = /a/g, L = /a/g, B = new P(R) !== R, K = v.MISSED_STICKY, _ = v.UNSUPPORTED_Y;
                            if (a("RegExp", o && (!B || K || O || S || m(function() {
                                return L[k] = !1, P(R) !== R || P(L) === L || "/a/i" !== String(P(R, "i"));
                            })))) {
                                for(var F = function(t, e) {
                                    var n, o, r, i, a, l, v = f(I, this), y = d(t), g = void 0 === e, m = [], x = t;
                                    if (!v && y && g && t.constructor === F) return t;
                                    if ((y || f(I, t)) && (t = t.source, g && (e = h(x))), t = void 0 === t ? "" : p(t), e = void 0 === e ? "" : p(e), x = t, O && ("dotAll" in R) && (o = !!e && T(e, "s") > -1) && (e = D(e, /s/g, "")), n = e, K && ("sticky" in R) && (r = !!e && T(e, "y") > -1) && _ && (e = D(e, /y/g, "")), S && (i = function(t) {
                                        for(var e, n = t.length, o = 0, r = "", i = [], a = c(null), s = !1, u = !1, l = 0, f = ""; o <= n; o++){
                                            if ("\\" === (e = M(t, o))) e += M(t, ++o);
                                            else if ("]" === e) s = !1;
                                            else if (!s) switch(!0){
                                                case "[" === e:
                                                    s = !0;
                                                    break;
                                                case "(" === e:
                                                    if (r += e, "?:" === N(t, o + 1, o + 3)) continue;
                                                    A(j, N(t, o + 1)) && (o += 2, u = !0), l++;
                                                    continue;
                                                case ">" === e && u:
                                                    if ("" === f || b(a, f)) throw new C("Invalid capture group name");
                                                    a[f] = !0, i[i.length] = [
                                                        f,
                                                        l
                                                    ], u = !1, f = "";
                                                    continue;
                                            }
                                            u ? f += e : r += e;
                                        }
                                        return [
                                            r,
                                            i
                                        ];
                                    }(t), t = i[0], m = i[1]), a = s(P(t, e), v ? this : I, F), (o || r || m.length) && (l = w(a), o && (l.dotAll = !0, l.raw = F(function(t) {
                                        for(var e, n = t.length, o = 0, r = "", i = !1; o <= n; o++)"\\" !== (e = M(t, o)) ? i || "." !== e ? ("[" === e ? i = !0 : "]" === e && (i = !1), r += e) : r += "[\\s\\S]" : r += e + M(t, ++o);
                                        return r;
                                    }(t), n)), r && (l.sticky = !0), m.length && (l.groups = m)), t !== x) try {
                                        u(a, "source", "" === x ? "(?:)" : x);
                                    } catch (t) {}
                                    return a;
                                }, U = l(P), H = 0; U.length > H;)y(F, P, U[H++]);
                                I.constructor = F, F.prototype = I, g(r, "RegExp", F, {
                                    constructor: !0
                                });
                            }
                            x("RegExp");
                        },
                        7495: function(t, e, n) {
                            var o = n(6518), r = n(7323);
                            o({
                                target: "RegExp",
                                proto: !0,
                                forced: /./.exec !== r
                            }, {
                                exec: r
                            });
                        },
                        8781: function(t, e, n) {
                            var o = n(350).PROPER, r = n(6840), i = n(8551), a = n(655), s = n(9039), u = n(1034), c = "toString", l = RegExp.prototype, f = l[c], d = s(function() {
                                return "/a/b" !== f.call({
                                    source: "a",
                                    flags: "b"
                                });
                            }), p = o && f.name !== c;
                            (d || p) && r(l, c, function() {
                                var t = i(this);
                                return "/" + a(t.source) + "/" + a(u(t));
                            }, {
                                unsafe: !0
                            });
                        },
                        1699: function(t, e, n) {
                            var o = n(6518), r = n(9504), i = n(5749), a = n(7750), s = n(655), u = n(1436), c = r("".indexOf);
                            o({
                                target: "String",
                                proto: !0,
                                forced: !u("includes")
                            }, {
                                includes: function(t) {
                                    return !!~c(s(a(this)), s(i(t)), arguments.length > 1 ? arguments[1] : void 0);
                                }
                            });
                        },
                        7764: function(t, e, n) {
                            var o = n(8183).charAt, r = n(655), i = n(1181), a = n(1088), s = n(2529), u = "String Iterator", c = i.set, l = i.getterFor(u);
                            a(String, "String", function(t) {
                                c(this, {
                                    type: u,
                                    string: r(t),
                                    index: 0
                                });
                            }, function() {
                                var t, e = l(this), n = e.string, r = e.index;
                                return r >= n.length ? s(void 0, !0) : (t = o(n, r), e.index += t.length, s(t, !1));
                            });
                        },
                        8543: function(t, e, n) {
                            var o = n(6518), r = n(9565), i = n(7476), a = n(3994), s = n(2529), u = n(7750), c = n(8014), l = n(655), f = n(8551), d = n(4117), p = n(2195), h = n(788), v = n(1034), y = n(5966), g = n(6840), m = n(9039), b = n(8227), w = n(2293), x = n(7829), E = n(6682), O = n(1181), S = n(6395), k = b("matchAll"), P = "RegExp String", I = P + " Iterator", C = O.set, A = O.getterFor(I), M = RegExp.prototype, D = TypeError, T = i("".indexOf), N = i("".matchAll), j = !!N && !m(function() {
                                N("a", /./);
                            }), R = a(function(t, e, n, o) {
                                C(this, {
                                    type: I,
                                    regexp: t,
                                    string: e,
                                    global: n,
                                    unicode: o,
                                    done: !1
                                });
                            }, P, function() {
                                var t = A(this);
                                if (t.done) return s(void 0, !0);
                                var e = t.regexp, n = t.string, o = E(e, n);
                                return null === o ? (t.done = !0, s(void 0, !0)) : t.global ? ("" === l(o[0]) && (e.lastIndex = x(n, c(e.lastIndex), t.unicode)), s(o, !1)) : (t.done = !0, s(o, !1));
                            }), L = function(t) {
                                var e, n, o, r = f(this), i = l(t), a = w(r, RegExp), s = l(v(r));
                                return e = new a(a === RegExp ? r.source : r, s), n = !!~T(s, "g"), o = !!~T(s, "u"), e.lastIndex = c(r.lastIndex), new R(e, i, n, o);
                            };
                            o({
                                target: "String",
                                proto: !0,
                                forced: j
                            }, {
                                matchAll: function(t) {
                                    var e, n, o, i, a = u(this);
                                    if (d(t)) {
                                        if (j) return N(a, t);
                                    } else {
                                        if (h(t) && (e = l(u(v(t))), !~T(e, "g"))) throw new D("`.matchAll` does not allow non-global regexes");
                                        if (j) return N(a, t);
                                        if (void 0 === (o = y(t, k)) && S && "RegExp" === p(t) && (o = L), o) return r(o, t, a);
                                    }
                                    return n = l(a), i = new RegExp(t, "g"), S ? r(L, i, n) : i[k](n);
                                }
                            }), S || k in M || g(M, k, L);
                        },
                        1761: function(t, e, n) {
                            var o = n(9565), r = n(9228), i = n(8551), a = n(4117), s = n(8014), u = n(655), c = n(7750), l = n(5966), f = n(7829), d = n(6682);
                            r("match", function(t, e, n) {
                                return [
                                    function(e) {
                                        var n = c(this), r = a(e) ? void 0 : l(e, t);
                                        return r ? o(r, e, n) : new RegExp(e)[t](u(n));
                                    },
                                    function(t) {
                                        var o = i(this), r = u(t), a = n(e, o, r);
                                        if (a.done) return a.value;
                                        if (!o.global) return d(o, r);
                                        var c = o.unicode;
                                        o.lastIndex = 0;
                                        for(var l, p = [], h = 0; null !== (l = d(o, r));){
                                            var v = u(l[0]);
                                            p[h] = v, "" === v && (o.lastIndex = f(r, s(o.lastIndex), c)), h++;
                                        }
                                        return 0 === h ? null : p;
                                    }
                                ];
                            });
                        },
                        5440: function(t, e, n) {
                            var o = n(8745), r = n(9565), i = n(9504), a = n(9228), s = n(9039), u = n(8551), c = n(4901), l = n(4117), f = n(1291), d = n(8014), p = n(655), h = n(7750), v = n(7829), y = n(5966), g = n(2478), m = n(6682), b = n(8227)("replace"), w = Math.max, x = Math.min, E = i([].concat), O = i([].push), S = i("".indexOf), k = i("".slice), P = "$0" === "a".replace(/./, "$0"), I = !!/./[b] && "" === /./[b]("a", "$0");
                            a("replace", function(t, e, n) {
                                var i = I ? "$" : "$0";
                                return [
                                    function(t, n) {
                                        var o = h(this), i = l(t) ? void 0 : y(t, b);
                                        return i ? r(i, t, o, n) : r(e, p(o), t, n);
                                    },
                                    function(t, r) {
                                        var a = u(this), s = p(t);
                                        if ("string" == typeof r && -1 === S(r, i) && -1 === S(r, "$<")) {
                                            var l = n(e, a, s, r);
                                            if (l.done) return l.value;
                                        }
                                        var h = c(r);
                                        h || (r = p(r));
                                        var y, b = a.global;
                                        b && (y = a.unicode, a.lastIndex = 0);
                                        for(var P, I = []; null !== (P = m(a, s)) && (O(I, P), b);)"" === p(P[0]) && (a.lastIndex = v(s, d(a.lastIndex), y));
                                        for(var C, A = "", M = 0, D = 0; D < I.length; D++){
                                            for(var T, N = p((P = I[D])[0]), j = w(x(f(P.index), s.length), 0), R = [], L = 1; L < P.length; L++)O(R, void 0 === (C = P[L]) ? C : String(C));
                                            var B = P.groups;
                                            if (h) {
                                                var K = E([
                                                    N
                                                ], R, j, s);
                                                void 0 !== B && O(K, B), T = p(o(r, void 0, K));
                                            } else T = g(N, s, j, R, B, r);
                                            j >= M && (A += k(s, M, j) + T, M = j + N.length);
                                        }
                                        return A + k(s, M);
                                    }
                                ];
                            }, !!s(function() {
                                var t = /./;
                                return t.exec = function() {
                                    var t = [];
                                    return t.groups = {
                                        a: "7"
                                    }, t;
                                }, "7" !== "".replace(t, "$<a>");
                            }) || !P || I);
                        },
                        744: function(t, e, n) {
                            var o = n(9565), r = n(9504), i = n(9228), a = n(8551), s = n(4117), u = n(7750), c = n(2293), l = n(7829), f = n(8014), d = n(655), p = n(5966), h = n(6682), v = n(8429), y = n(9039), g = v.UNSUPPORTED_Y, m = Math.min, b = r([].push), w = r("".slice), x = !y(function() {
                                var t = /(?:)/, e = t.exec;
                                t.exec = function() {
                                    return e.apply(this, arguments);
                                };
                                var n = "ab".split(t);
                                return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
                            }), E = "c" === "abbc".split(/(b)*/)[1] || 4 !== "test".split(/(?:)/, -1).length || 2 !== "ab".split(/(?:ab)*/).length || 4 !== ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length;
                            i("split", function(t, e, n) {
                                var r = "0".split(void 0, 0).length ? function(t, n) {
                                    return void 0 === t && 0 === n ? [] : o(e, this, t, n);
                                } : e;
                                return [
                                    function(e, n) {
                                        var i = u(this), a = s(e) ? void 0 : p(e, t);
                                        return a ? o(a, e, i, n) : o(r, d(i), e, n);
                                    },
                                    function(t, o) {
                                        var i = a(this), s = d(t);
                                        if (!E) {
                                            var u = n(r, i, s, o, r !== e);
                                            if (u.done) return u.value;
                                        }
                                        var p = c(i, RegExp), v = i.unicode, y = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (g ? "g" : "y"), x = new p(g ? "^(?:" + i.source + ")" : i, y), O = void 0 === o ? 4294967295 : o >>> 0;
                                        if (0 === O) return [];
                                        if (0 === s.length) return null === h(x, s) ? [
                                            s
                                        ] : [];
                                        for(var S = 0, k = 0, P = []; k < s.length;){
                                            x.lastIndex = g ? 0 : k;
                                            var I, C = h(x, g ? w(s, k) : s);
                                            if (null === C || (I = m(f(x.lastIndex + (g ? k : 0)), s.length)) === S) k = l(s, k, v);
                                            else {
                                                if (b(P, w(s, S, k)), P.length === O) return P;
                                                for(var A = 1; A <= C.length - 1; A++)if (b(P, C[A]), P.length === O) return P;
                                                k = S = I;
                                            }
                                        }
                                        return b(P, w(s, S)), P;
                                    }
                                ];
                            }, E || !x, g);
                        },
                        2762: function(t, e, n) {
                            var o = n(6518), r = n(3802).trim;
                            o({
                                target: "String",
                                proto: !0,
                                forced: n(706)("trim")
                            }, {
                                trim: function() {
                                    return r(this);
                                }
                            });
                        },
                        6761: function(t, e, n) {
                            var o = n(6518), r = n(4576), i = n(9565), a = n(9504), s = n(6395), u = n(3724), c = n(4495), l = n(9039), f = n(9297), d = n(1625), p = n(8551), h = n(5397), v = n(6969), y = n(655), g = n(6980), m = n(2360), b = n(1072), w = n(8480), x = n(298), E = n(3717), O = n(7347), S = n(4913), k = n(6801), P = n(8773), I = n(6840), C = n(2106), A = n(5745), M = n(6119), D = n(421), T = n(3392), N = n(8227), j = n(1951), R = n(511), L = n(8242), B = n(687), K = n(1181), _ = n(9213).forEach, F = M("hidden"), U = "Symbol", H = "prototype", $ = K.set, G = K.getterFor(U), V = Object[H], z = r.Symbol, Y = z && z[H], W = r.RangeError, J = r.TypeError, X = r.QObject, q = O.f, Q = S.f, Z = x.f, tt = P.f, et = a([].push), nt = A("symbols"), ot = A("op-symbols"), rt = A("wks"), it = !X || !X[H] || !X[H].findChild, at = function(t, e, n) {
                                var o = q(V, e);
                                o && delete V[e], Q(t, e, n), o && t !== V && Q(V, e, o);
                            }, st = u && l(function() {
                                return 7 !== m(Q({}, "a", {
                                    get: function() {
                                        return Q(this, "a", {
                                            value: 7
                                        }).a;
                                    }
                                })).a;
                            }) ? at : Q, ut = function(t, e) {
                                var n = nt[t] = m(Y);
                                return $(n, {
                                    type: U,
                                    tag: t,
                                    description: e
                                }), u || (n.description = e), n;
                            }, ct = function(t, e, n) {
                                t === V && ct(ot, e, n), p(t);
                                var o = v(e);
                                return p(n), f(nt, o) ? (n.enumerable ? (f(t, F) && t[F][o] && (t[F][o] = !1), n = m(n, {
                                    enumerable: g(0, !1)
                                })) : (f(t, F) || Q(t, F, g(1, m(null))), t[F][o] = !0), st(t, o, n)) : Q(t, o, n);
                            }, lt = function(t, e) {
                                p(t);
                                var n = h(e), o = b(n).concat(ht(n));
                                return _(o, function(e) {
                                    u && !i(ft, n, e) || ct(t, e, n[e]);
                                }), t;
                            }, ft = function(t) {
                                var e = v(t), n = i(tt, this, e);
                                return !(this === V && f(nt, e) && !f(ot, e)) && (!(n || !f(this, e) || !f(nt, e) || f(this, F) && this[F][e]) || n);
                            }, dt = function(t, e) {
                                var n = h(t), o = v(e);
                                if (n !== V || !f(nt, o) || f(ot, o)) {
                                    var r = q(n, o);
                                    return !r || !f(nt, o) || f(n, F) && n[F][o] || (r.enumerable = !0), r;
                                }
                            }, pt = function(t) {
                                var e = Z(h(t)), n = [];
                                return _(e, function(t) {
                                    f(nt, t) || f(D, t) || et(n, t);
                                }), n;
                            }, ht = function(t) {
                                var e = t === V, n = Z(e ? ot : h(t)), o = [];
                                return _(n, function(t) {
                                    !f(nt, t) || e && !f(V, t) || et(o, nt[t]);
                                }), o;
                            };
                            c || (z = function() {
                                if (d(Y, this)) throw new J("Symbol is not a constructor");
                                var t = arguments.length && void 0 !== arguments[0] ? y(arguments[0]) : void 0, e = T(t), n = function(t) {
                                    var o = void 0 === this ? r : this;
                                    o === V && i(n, ot, t), f(o, F) && f(o[F], e) && (o[F][e] = !1);
                                    var a = g(1, t);
                                    try {
                                        st(o, e, a);
                                    } catch (t) {
                                        if (!(t instanceof W)) throw t;
                                        at(o, e, a);
                                    }
                                };
                                return u && it && st(V, e, {
                                    configurable: !0,
                                    set: n
                                }), ut(e, t);
                            }, I(Y = z[H], "toString", function() {
                                return G(this).tag;
                            }), I(z, "withoutSetter", function(t) {
                                return ut(T(t), t);
                            }), P.f = ft, S.f = ct, k.f = lt, O.f = dt, w.f = x.f = pt, E.f = ht, j.f = function(t) {
                                return ut(N(t), t);
                            }, u && (C(Y, "description", {
                                configurable: !0,
                                get: function() {
                                    return G(this).description;
                                }
                            }), s || I(V, "propertyIsEnumerable", ft, {
                                unsafe: !0
                            }))), o({
                                global: !0,
                                constructor: !0,
                                wrap: !0,
                                forced: !c,
                                sham: !c
                            }, {
                                Symbol: z
                            }), _(b(rt), function(t) {
                                R(t);
                            }), o({
                                target: U,
                                stat: !0,
                                forced: !c
                            }, {
                                useSetter: function() {
                                    it = !0;
                                },
                                useSimple: function() {
                                    it = !1;
                                }
                            }), o({
                                target: "Object",
                                stat: !0,
                                forced: !c,
                                sham: !u
                            }, {
                                create: function(t, e) {
                                    return void 0 === e ? m(t) : lt(m(t), e);
                                },
                                defineProperty: ct,
                                defineProperties: lt,
                                getOwnPropertyDescriptor: dt
                            }), o({
                                target: "Object",
                                stat: !0,
                                forced: !c
                            }, {
                                getOwnPropertyNames: pt
                            }), L(), B(z, U), D[F] = !0;
                        },
                        9463: function(t, e, n) {
                            var o = n(6518), r = n(3724), i = n(4576), a = n(9504), s = n(9297), u = n(4901), c = n(1625), l = n(655), f = n(2106), d = n(7740), p = i.Symbol, h = p && p.prototype;
                            if (r && u(p) && (!("description" in h) || void 0 !== p().description)) {
                                var v = {}, y = function() {
                                    var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : l(arguments[0]), e = c(h, this) ? new p(t) : void 0 === t ? p() : p(t);
                                    return "" === t && (v[e] = !0), e;
                                };
                                d(y, p), y.prototype = h, h.constructor = y;
                                var g = "Symbol(description detection)" === String(p("description detection")), m = a(h.valueOf), b = a(h.toString), w = /^Symbol\((.*)\)[^)]+$/, x = a("".replace), E = a("".slice);
                                f(h, "description", {
                                    configurable: !0,
                                    get: function() {
                                        var t = m(this);
                                        if (s(v, t)) return "";
                                        var e = b(t), n = g ? E(e, 7, -1) : x(e, w, "$1");
                                        return "" === n ? void 0 : n;
                                    }
                                }), o({
                                    global: !0,
                                    constructor: !0,
                                    forced: !0
                                }, {
                                    Symbol: y
                                });
                            }
                        },
                        1510: function(t, e, n) {
                            var o = n(6518), r = n(7751), i = n(9297), a = n(655), s = n(5745), u = n(1296), c = s("string-to-symbol-registry"), l = s("symbol-to-string-registry");
                            o({
                                target: "Symbol",
                                stat: !0,
                                forced: !u
                            }, {
                                for: function(t) {
                                    var e = a(t);
                                    if (i(c, e)) return c[e];
                                    var n = r("Symbol")(e);
                                    return c[e] = n, l[n] = e, n;
                                }
                            });
                        },
                        2259: function(t, e, n) {
                            n(511)("iterator");
                        },
                        2675: function(t, e, n) {
                            n(6761), n(1510), n(7812), n(3110), n(9773);
                        },
                        7812: function(t, e, n) {
                            var o = n(6518), r = n(9297), i = n(757), a = n(6823), s = n(5745), u = n(1296), c = s("symbol-to-string-registry");
                            o({
                                target: "Symbol",
                                stat: !0,
                                forced: !u
                            }, {
                                keyFor: function(t) {
                                    if (!i(t)) throw new TypeError(a(t) + " is not a symbol");
                                    if (r(c, t)) return c[t];
                                }
                            });
                        },
                        5700: function(t, e, n) {
                            var o = n(511), r = n(8242);
                            o("toPrimitive"), r();
                        },
                        8344: function(t, e, n) {
                            n(8543);
                        },
                        3500: function(t, e, n) {
                            var o = n(4576), r = n(7400), i = n(9296), a = n(235), s = n(6699), u = function(t) {
                                if (t && t.forEach !== a) try {
                                    s(t, "forEach", a);
                                } catch (e) {
                                    t.forEach = a;
                                }
                            };
                            for(var c in r)r[c] && u(o[c] && o[c].prototype);
                            u(i);
                        },
                        2953: function(t, e, n) {
                            var o = n(4576), r = n(7400), i = n(9296), a = n(3792), s = n(6699), u = n(687), c = n(8227)("iterator"), l = a.values, f = function(t, e) {
                                if (t) {
                                    if (t[c] !== l) try {
                                        s(t, c, l);
                                    } catch (e) {
                                        t[c] = l;
                                    }
                                    if (u(t, e, !0), r[e]) {
                                        for(var n in a)if (t[n] !== a[n]) try {
                                            s(t, n, a[n]);
                                        } catch (e) {
                                            t[n] = a[n];
                                        }
                                    }
                                }
                            };
                            for(var d in r)f(o[d] && o[d].prototype, d);
                            f(i, "DOMTokenList");
                        }
                    }, e = {};
                    function n(o) {
                        var r = e[o];
                        if (void 0 !== r) return r.exports;
                        var i = e[o] = {
                            exports: {}
                        };
                        return t[o].call(i.exports, i, i.exports, n), i.exports;
                    }
                    n.d = function(t, e) {
                        for(var o in e)n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
                            enumerable: !0,
                            get: e[o]
                        });
                    }, n.g = function() {
                        if ("object" == typeof globalThis) return globalThis;
                        try {
                            return this || new Function("return this")();
                        } catch (t) {
                            if ("object" == typeof window) return window;
                        }
                    }(), n.o = function(t, e) {
                        return Object.prototype.hasOwnProperty.call(t, e);
                    }, n.r = function(t) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    };
                    var o = {};
                    function r(t) {
                        return function(t) {
                            if (Array.isArray(t)) return a(t);
                        }(t) || function(t) {
                            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                        }(t) || i(t) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }
                    function i(t, e) {
                        if (t) {
                            if ("string" == typeof t) return a(t, e);
                            var n = ({}).toString.call(t).slice(8, -1);
                            return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(t, e) : void 0;
                        }
                    }
                    function a(t, e) {
                        (null == e || e > t.length) && (e = t.length);
                        for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
                        return o;
                    }
                    function s(t) {
                        return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, s(t);
                    }
                    function u(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, l(o.key), o);
                        }
                    }
                    function c(t, e, n) {
                        return (e = l(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function l(t) {
                        var e = function(t, e) {
                            if ("object" != s(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != s(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == s(e) ? e : e + "";
                    }
                    n.r(o), n.d(o, {
                        SimpleKeyboard: function() {
                            return T;
                        },
                        default: function() {
                            return N;
                        }
                    }), n(5276), n(8598), n(4782), n(4554), n(2010), n(7427), n(6099), n(7495), n(8781), n(5440), n(744), n(2762), "undefined" == typeof Element || "remove" in Element.prototype || (Element.prototype.remove = function() {
                        this.parentNode && this.parentNode.removeChild(this);
                    }), "undefined" != typeof self && "document" in self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(t) {
                        if ("Element" in t) {
                            var e = "classList", n = "prototype", o = t.Element[n], r = Object, i = String[n].trim || function() {
                                return this.replace(/^\s+|\s+$/g, "");
                            }, a = Array[n].indexOf || function(t) {
                                for(var e = 0, n = this.length; e < n; e++)if (e in this && this[e] === t) return e;
                                return -1;
                            }, s = function(t, e) {
                                this.name = t, this.code = DOMException[t], this.message = e;
                            }, u = function(t, e) {
                                if ("" === e) throw new s("SYNTAX_ERR", "The token must not be empty.");
                                if (/\s/.test(e)) throw new s("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
                                return a.call(t, e);
                            }, c = function(t) {
                                for(var e = i.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], o = 0, r = n.length; o < r; o++)this.push(n[o]);
                                this._updateClassName = function() {
                                    t.setAttribute("class", this.toString());
                                };
                            }, l = c[n] = [], f = function() {
                                return new c(this);
                            };
                            if (s[n] = Error[n], l.item = function(t) {
                                return this[t] || null;
                            }, l.contains = function(t) {
                                return ~u(this, t + "");
                            }, l.add = function() {
                                var t, e = arguments, n = 0, o = e.length, r = !1;
                                do ~u(this, t = e[n] + "") || (this.push(t), r = !0);
                                while (++n < o);
                                r && this._updateClassName();
                            }, l.remove = function() {
                                var t, e, n = arguments, o = 0, r = n.length, i = !1;
                                do for(e = u(this, t = n[o] + ""); ~e;)this.splice(e, 1), i = !0, e = u(this, t);
                                while (++o < r);
                                i && this._updateClassName();
                            }, l.toggle = function(t, e) {
                                var n = this.contains(t), o = n ? !0 !== e && "remove" : !1 !== e && "add";
                                return o && this[o](t), !0 === e || !1 === e ? e : !n;
                            }, l.replace = function(t, e) {
                                var n = u(t + "");
                                ~n && (this.splice(n, 1, e), this._updateClassName());
                            }, l.toString = function() {
                                return this.join(" ");
                            }, r.defineProperty) {
                                var d = {
                                    get: f,
                                    enumerable: !0,
                                    configurable: !0
                                };
                                try {
                                    r.defineProperty(o, e, d);
                                } catch (t) {
                                    void 0 !== t.number && -2146823252 !== t.number || (d.enumerable = !1, r.defineProperty(o, e, d));
                                }
                            } else r[n].__defineGetter__ && o.__defineGetter__(e, f);
                        }
                    }(self), function() {
                        var t = document.createElement("_");
                        if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
                            var e = function(t) {
                                var e = DOMTokenList.prototype[t];
                                DOMTokenList.prototype[t] = function(t) {
                                    var n, o = arguments.length;
                                    for(n = 0; n < o; n++)t = arguments[n], e.call(this, t);
                                };
                            };
                            e("add"), e("remove");
                        }
                        if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
                            var n = DOMTokenList.prototype.toggle;
                            DOMTokenList.prototype.toggle = function(t, e) {
                                return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
                            };
                        }
                        "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function(t, e) {
                            var n = this.toString().split(" "), o = n.indexOf(t + "");
                            ~o && (n = n.slice(o), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
                        }), t = null;
                    }()), n(2675), n(9463), n(2259), n(5700), n(8706), n(2008), n(3418), n(4423), n(3792), n(2062), n(6910), n(739), n(9572), n(2892), n(9085), n(3851), n(1278), n(9432), n(4864), n(1699), n(7764), n(8344), n(3500), n(2953), n(2712), n(2637), n(1480), n(1761);
                    var f = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = e.getOptions, o = e.getCaretPosition, r = e.getCaretPositionEnd, i = e.dispatch;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), c(this, "getOptions", void 0), c(this, "getCaretPosition", void 0), c(this, "getCaretPositionEnd", void 0), c(this, "dispatch", void 0), c(this, "maxLengthReached", void 0), c(this, "isStandardButton", function(t) {
                                return t && !("{" === t[0] && "}" === t[t.length - 1]);
                            }), this.getOptions = n, this.getCaretPosition = o, this.getCaretPositionEnd = r, this.dispatch = i, t.bindMethods(t, this);
                        }, e = [
                            {
                                key: "getButtonType",
                                value: function(t) {
                                    return t.includes("{") && t.includes("}") && "{//}" !== t ? "functionBtn" : "standardBtn";
                                }
                            },
                            {
                                key: "getButtonClass",
                                value: function(t) {
                                    var e = this.getButtonType(t), n = t.replace("{", "").replace("}", ""), o = "";
                                    return "standardBtn" !== e && (o = " hg-button-".concat(n)), "hg-".concat(e).concat(o);
                                }
                            },
                            {
                                key: "getDefaultDiplay",
                                value: function() {
                                    return {
                                        "{bksp}": "backspace",
                                        "{backspace}": "backspace",
                                        "{enter}": "< enter",
                                        "{shift}": "shift",
                                        "{shiftleft}": "shift",
                                        "{shiftright}": "shift",
                                        "{alt}": "alt",
                                        "{s}": "shift",
                                        "{tab}": "tab",
                                        "{lock}": "caps",
                                        "{capslock}": "caps",
                                        "{accept}": "Submit",
                                        "{space}": " ",
                                        "{//}": " ",
                                        "{esc}": "esc",
                                        "{escape}": "esc",
                                        "{f1}": "f1",
                                        "{f2}": "f2",
                                        "{f3}": "f3",
                                        "{f4}": "f4",
                                        "{f5}": "f5",
                                        "{f6}": "f6",
                                        "{f7}": "f7",
                                        "{f8}": "f8",
                                        "{f9}": "f9",
                                        "{f10}": "f10",
                                        "{f11}": "f11",
                                        "{f12}": "f12",
                                        "{numpaddivide}": "/",
                                        "{numlock}": "lock",
                                        "{arrowup}": "\u2191",
                                        "{arrowleft}": "\u2190",
                                        "{arrowdown}": "\u2193",
                                        "{arrowright}": "\u2192",
                                        "{prtscr}": "print",
                                        "{scrolllock}": "scroll",
                                        "{pause}": "pause",
                                        "{insert}": "ins",
                                        "{home}": "home",
                                        "{pageup}": "up",
                                        "{delete}": "del",
                                        "{forwarddelete}": "del",
                                        "{end}": "end",
                                        "{pagedown}": "down",
                                        "{numpadmultiply}": "*",
                                        "{numpadsubtract}": "-",
                                        "{numpadadd}": "+",
                                        "{numpadenter}": "enter",
                                        "{period}": ".",
                                        "{numpaddecimal}": ".",
                                        "{numpad0}": "0",
                                        "{numpad1}": "1",
                                        "{numpad2}": "2",
                                        "{numpad3}": "3",
                                        "{numpad4}": "4",
                                        "{numpad5}": "5",
                                        "{numpad6}": "6",
                                        "{numpad7}": "7",
                                        "{numpad8}": "8",
                                        "{numpad9}": "9"
                                    };
                                }
                            },
                            {
                                key: "getButtonDisplayName",
                                value: function(t, e) {
                                    return (e = arguments.length > 2 && void 0 !== arguments[2] && arguments[2] ? Object.assign({}, this.getDefaultDiplay(), e) : e || this.getDefaultDiplay())[t] || t;
                                }
                            },
                            {
                                key: "getUpdatedInput",
                                value: function(t, e, n) {
                                    var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : n, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], i = this.getOptions(), a = [
                                        n,
                                        o,
                                        r
                                    ], s = e;
                                    return ("{bksp}" === t || "{backspace}" === t) && s.length > 0 ? s = this.removeAt.apply(this, [
                                        s
                                    ].concat(a)) : ("{delete}" === t || "{forwarddelete}" === t) && s.length > 0 ? s = this.removeForwardsAt.apply(this, [
                                        s
                                    ].concat(a)) : "{space}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        " "
                                    ].concat(a)) : "{tab}" !== t || "boolean" == typeof i.tabCharOnTab && !1 === i.tabCharOnTab ? "{enter}" !== t && "{numpadenter}" !== t || !i.newLineOnEnter ? t.includes("numpad") && Number.isInteger(Number(t[t.length - 2])) ? s = this.addStringAt.apply(this, [
                                        s,
                                        t[t.length - 2]
                                    ].concat(a)) : "{numpaddivide}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "/"
                                    ].concat(a)) : "{numpadmultiply}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "*"
                                    ].concat(a)) : "{numpadsubtract}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "-"
                                    ].concat(a)) : "{numpadadd}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "+"
                                    ].concat(a)) : "{numpaddecimal}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        "."
                                    ].concat(a)) : "{" === t || "}" === t ? s = this.addStringAt.apply(this, [
                                        s,
                                        t
                                    ].concat(a)) : t.includes("{") || t.includes("}") || (s = this.addStringAt.apply(this, [
                                        s,
                                        t
                                    ].concat(a))) : s = this.addStringAt.apply(this, [
                                        s,
                                        "\n"
                                    ].concat(a)) : s = this.addStringAt.apply(this, [
                                        s,
                                        "	"
                                    ].concat(a)), i.debug && console.log("Input will be: " + s), s;
                                }
                            },
                            {
                                key: "updateCaretPos",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.updateCaretPosAction(t, e);
                                    this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    });
                                }
                            },
                            {
                                key: "updateCaretPosAction",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = this.getOptions(), o = this.getCaretPosition();
                                    return null != o && (e ? o > 0 && (o -= t) : o += t), n.debug && console.log("Caret at:", o), o;
                                }
                            },
                            {
                                key: "addStringAt",
                                value: function(t, e) {
                                    var n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.length, i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                                    return o || 0 === o ? (n = [
                                        t.slice(0, o),
                                        e,
                                        t.slice(r)
                                    ].join(""), this.isMaxLengthReached() || i && this.updateCaretPos(e.length)) : n = t + e, n;
                                }
                            },
                            {
                                key: "removeAt",
                                value: function(t) {
                                    var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                                    if (0 === n && 0 === o) return t;
                                    if (n === o) {
                                        var i = /([\uD800-\uDBFF][\uDC00-\uDFFF])/g;
                                        n && n >= 0 ? t.substring(n - 2, n).match(i) ? (e = t.substr(0, n - 2) + t.substr(n), r && this.updateCaretPos(2, !0)) : (e = t.substr(0, n - 1) + t.substr(n), r && this.updateCaretPos(1, !0)) : t.slice(-2).match(i) ? (e = t.slice(0, -2), r && this.updateCaretPos(2, !0)) : (e = t.slice(0, -1), r && this.updateCaretPos(1, !0));
                                    } else e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    });
                                    return e;
                                }
                            },
                            {
                                key: "removeForwardsAt",
                                value: function(t) {
                                    var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.length, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t.length, r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                                    return null != t && t.length && null !== n ? (n === o ? e = t.substring(n, n + 2).match(/([\uD800-\uDBFF][\uDC00-\uDFFF])/g) ? t.substr(0, n) + t.substr(n + 2) : t.substr(0, n) + t.substr(n + 1) : (e = t.slice(0, n) + t.slice(o), r && this.dispatch(function(t) {
                                        t.setCaretPosition(n);
                                    })), e) : t;
                                }
                            },
                            {
                                key: "handleMaxLength",
                                value: function(t, e) {
                                    var n = this.getOptions(), o = n.maxLength, r = t[n.inputName || "default"], i = e.length - 1 >= o;
                                    if (e.length <= r.length) return !1;
                                    if (Number.isInteger(o)) return n.debug && console.log("maxLength (num) reached:", i), i ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                    if ("object" === s(o)) {
                                        var a = e.length - 1 >= o[n.inputName || "default"];
                                        return n.debug && console.log("maxLength (obj) reached:", a), a ? (this.maxLengthReached = !0, !0) : (this.maxLengthReached = !1, !1);
                                    }
                                }
                            },
                            {
                                key: "isMaxLengthReached",
                                value: function() {
                                    return Boolean(this.maxLengthReached);
                                }
                            },
                            {
                                key: "isTouchDevice",
                                value: function() {
                                    return "ontouchstart" in window || navigator.maxTouchPoints;
                                }
                            },
                            {
                                key: "pointerEventsSupported",
                                value: function() {
                                    return !!window.PointerEvent;
                                }
                            },
                            {
                                key: "camelCase",
                                value: function(t) {
                                    return t ? t.toLowerCase().trim().split(/[.\-_\s]/g).reduce(function(t, e) {
                                        return e.length ? t + e[0].toUpperCase() + e.slice(1) : t;
                                    }) : "";
                                }
                            },
                            {
                                key: "chunkArray",
                                value: function(t, e) {
                                    return r(Array(Math.ceil(t.length / e))).map(function(n, o) {
                                        return t.slice(e * o, e + e * o);
                                    });
                                }
                            },
                            {
                                key: "escapeRegex",
                                value: function(t) {
                                    return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                                }
                            },
                            {
                                key: "getRtlOffset",
                                value: function(t, e) {
                                    var n = t, o = e.indexOf("\u202B");
                                    return o < t && -1 != o && n--, e.indexOf("\u202C") < t && -1 != o && n--, n < 0 ? 0 : n;
                                }
                            }
                        ], n = [
                            {
                                key: "bindMethods",
                                value: function(t, e) {
                                    var n, o = function(t, e) {
                                        var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                                        if (!n) {
                                            if (Array.isArray(t) || (n = i(t)) || e && t && "number" == typeof t.length) {
                                                n && (t = n);
                                                var o = 0, r = function() {};
                                                return {
                                                    s: r,
                                                    n: function() {
                                                        return o >= t.length ? {
                                                            done: !0
                                                        } : {
                                                            done: !1,
                                                            value: t[o++]
                                                        };
                                                    },
                                                    e: function(t) {
                                                        throw t;
                                                    },
                                                    f: r
                                                };
                                            }
                                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                        }
                                        var a, s = !0, u = !1;
                                        return {
                                            s: function() {
                                                n = n.call(t);
                                            },
                                            n: function() {
                                                var t = n.next();
                                                return s = t.done, t;
                                            },
                                            e: function(t) {
                                                u = !0, a = t;
                                            },
                                            f: function() {
                                                try {
                                                    s || null == n.return || n.return();
                                                } finally{
                                                    if (u) throw a;
                                                }
                                            }
                                        };
                                    }(Object.getOwnPropertyNames(t.prototype));
                                    try {
                                        for(o.s(); !(n = o.n()).done;){
                                            var r = n.value;
                                            "constructor" === r || "bindMethods" === r || (e[r] = e[r].bind(e));
                                        }
                                    } catch (t) {
                                        o.e(t);
                                    } finally{
                                        o.f();
                                    }
                                }
                            }
                        ], e && u(t.prototype, e), n && u(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }();
                    c(f, "noop", function() {});
                    var d = f;
                    function p(t) {
                        return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, p(t);
                    }
                    function h(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, y(o.key), o);
                        }
                    }
                    function v(t, e, n) {
                        return (e = y(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function y(t) {
                        var e = function(t, e) {
                            if ("object" != p(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != p(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == p(e) ? e : e + "";
                    }
                    var g = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = this, o = e.dispatch, r = e.getOptions;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), v(this, "getOptions", void 0), v(this, "dispatch", void 0), v(this, "isModifierKey", function(t) {
                                return t.altKey || t.ctrlKey || t.shiftKey || [
                                    "Tab",
                                    "CapsLock",
                                    "Esc",
                                    "ArrowUp",
                                    "ArrowDown",
                                    "ArrowLeft",
                                    "ArrowRight"
                                ].includes(t.code || t.key || n.keyCodeToKey(null == t ? void 0 : t.keyCode));
                            }), this.dispatch = o, this.getOptions = r, d.bindMethods(t, this);
                        }, e = [
                            {
                                key: "handleHighlightKeyDown",
                                value: function(t) {
                                    var e = this.getOptions();
                                    e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                                    var n = this.getSimpleKeyboardLayoutKey(t);
                                    this.dispatch(function(o) {
                                        var r, i, a = o.getButtonElement(n), s = o.getButtonElement("{".concat(n, "}"));
                                        if (a) r = a, i = n;
                                        else {
                                            if (!s) return;
                                            r = s, i = "{".concat(n, "}");
                                        }
                                        var u, c, l, f, d = function(t) {
                                            t.style.background = e.physicalKeyboardHighlightBgColor || "#dadce4", t.style.color = e.physicalKeyboardHighlightTextColor || "black";
                                        };
                                        if (r) {
                                            if (Array.isArray(r)) {
                                                if (r.forEach(function(t) {
                                                    return d(t);
                                                }), e.physicalKeyboardHighlightPress) {
                                                    if (e.physicalKeyboardHighlightPressUsePointerEvents) null === (u = r[0]) || void 0 === u || null === (c = u.onpointerdown) || void 0 === c || c.call(u, t);
                                                    else if (e.physicalKeyboardHighlightPressUseClick) {
                                                        var p;
                                                        null === (p = r[0]) || void 0 === p || p.click();
                                                    } else o.handleButtonClicked(i, t);
                                                }
                                            } else d(r), e.physicalKeyboardHighlightPress && (e.physicalKeyboardHighlightPressUsePointerEvents ? null === (l = r) || void 0 === l || null === (f = l.onpointerdown) || void 0 === f || f.call(l, t) : e.physicalKeyboardHighlightPressUseClick ? r.click() : o.handleButtonClicked(i, t));
                                        }
                                    });
                                }
                            },
                            {
                                key: "handleHighlightKeyUp",
                                value: function(t) {
                                    var e = this.getOptions();
                                    e.physicalKeyboardHighlightPreventDefault && this.isModifierKey(t) && (t.preventDefault(), t.stopImmediatePropagation());
                                    var n = this.getSimpleKeyboardLayoutKey(t);
                                    this.dispatch(function(o) {
                                        var r, i, a, s = o.getButtonElement(n) || o.getButtonElement("{".concat(n, "}")), u = function(t) {
                                            t.removeAttribute && t.removeAttribute("style");
                                        };
                                        s && (Array.isArray(s) ? (s.forEach(function(t) {
                                            return u(t);
                                        }), e.physicalKeyboardHighlightPressUsePointerEvents && (null === (r = s[0]) || void 0 === r || null === (i = r.onpointerup) || void 0 === i || i.call(r, t))) : (u(s), e.physicalKeyboardHighlightPressUsePointerEvents && (null == s || null === (a = s.onpointerup) || void 0 === a || a.call(s, t))));
                                    });
                                }
                            },
                            {
                                key: "getSimpleKeyboardLayoutKey",
                                value: function(t) {
                                    var e, n = "", o = t.code || t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode);
                                    return (n = null != o && o.includes("Numpad") || null != o && o.includes("Shift") || null != o && o.includes("Space") || null != o && o.includes("Backspace") || null != o && o.includes("Control") || null != o && o.includes("Alt") || null != o && o.includes("Meta") ? t.code || "" : t.key || this.keyCodeToKey(null == t ? void 0 : t.keyCode) || "").length > 1 ? null === (e = n) || void 0 === e ? void 0 : e.toLowerCase() : n;
                                }
                            },
                            {
                                key: "keyCodeToKey",
                                value: function(t) {
                                    return ({
                                        8: "Backspace",
                                        9: "Tab",
                                        13: "Enter",
                                        16: "Shift",
                                        17: "Ctrl",
                                        18: "Alt",
                                        19: "Pause",
                                        20: "CapsLock",
                                        27: "Esc",
                                        32: "Space",
                                        33: "PageUp",
                                        34: "PageDown",
                                        35: "End",
                                        36: "Home",
                                        37: "ArrowLeft",
                                        38: "ArrowUp",
                                        39: "ArrowRight",
                                        40: "ArrowDown",
                                        45: "Insert",
                                        46: "Delete",
                                        48: "0",
                                        49: "1",
                                        50: "2",
                                        51: "3",
                                        52: "4",
                                        53: "5",
                                        54: "6",
                                        55: "7",
                                        56: "8",
                                        57: "9",
                                        65: "A",
                                        66: "B",
                                        67: "C",
                                        68: "D",
                                        69: "E",
                                        70: "F",
                                        71: "G",
                                        72: "H",
                                        73: "I",
                                        74: "J",
                                        75: "K",
                                        76: "L",
                                        77: "M",
                                        78: "N",
                                        79: "O",
                                        80: "P",
                                        81: "Q",
                                        82: "R",
                                        83: "S",
                                        84: "T",
                                        85: "U",
                                        86: "V",
                                        87: "W",
                                        88: "X",
                                        89: "Y",
                                        90: "Z",
                                        91: "Meta",
                                        96: "Numpad0",
                                        97: "Numpad1",
                                        98: "Numpad2",
                                        99: "Numpad3",
                                        100: "Numpad4",
                                        101: "Numpad5",
                                        102: "Numpad6",
                                        103: "Numpad7",
                                        104: "Numpad8",
                                        105: "Numpad9",
                                        106: "NumpadMultiply",
                                        107: "NumpadAdd",
                                        109: "NumpadSubtract",
                                        110: "NumpadDecimal",
                                        111: "NumpadDivide",
                                        112: "F1",
                                        113: "F2",
                                        114: "F3",
                                        115: "F4",
                                        116: "F5",
                                        117: "F6",
                                        118: "F7",
                                        119: "F8",
                                        120: "F9",
                                        121: "F10",
                                        122: "F11",
                                        123: "F12",
                                        144: "NumLock",
                                        145: "ScrollLock",
                                        186: ";",
                                        187: "=",
                                        188: ",",
                                        189: "-",
                                        190: ".",
                                        191: "/",
                                        192: "`",
                                        219: "[",
                                        220: "\\",
                                        221: "]",
                                        222: "'"
                                    })[t] || "";
                                }
                            }
                        ], e && h(t.prototype, e), n && h(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }();
                    function m(t) {
                        return m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, m(t);
                    }
                    function b(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, x(o.key), o);
                        }
                    }
                    function w(t, e, n) {
                        return (e = x(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function x(t) {
                        var e = function(t, e) {
                            if ("object" != m(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != m(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == m(e) ? e : e + "";
                    }
                    var E = function() {
                        var t, e, n;
                        return t = function t(e) {
                            var n = e.utilities, o = e.options;
                            !function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), w(this, "utilities", void 0), w(this, "options", void 0), w(this, "candidateBoxElement", void 0), w(this, "pageIndex", 0), w(this, "pageSize", void 0), this.utilities = n, this.options = o, d.bindMethods(t, this), this.pageSize = this.utilities.getOptions().layoutCandidatesPageSize || 5;
                        }, e = [
                            {
                                key: "destroy",
                                value: function() {
                                    this.candidateBoxElement && (this.candidateBoxElement.remove(), this.pageIndex = 0);
                                }
                            },
                            {
                                key: "show",
                                value: function(t) {
                                    var e = this, n = t.candidateValue, o = t.targetElement, r = t.onSelect;
                                    if (n && n.length) {
                                        var i = this.utilities.chunkArray(n.split(" "), this.pageSize);
                                        this.renderPage({
                                            candidateListPages: i,
                                            targetElement: o,
                                            pageIndex: this.pageIndex,
                                            nbPages: i.length,
                                            onItemSelected: function(t, n) {
                                                r(t, n), e.destroy();
                                            }
                                        });
                                    }
                                }
                            },
                            {
                                key: "renderPage",
                                value: function(t) {
                                    var e, n = this, o = t.candidateListPages, r = t.targetElement, i = t.pageIndex, a = t.nbPages, s = t.onItemSelected;
                                    null === (e = this.candidateBoxElement) || void 0 === e || e.remove(), this.candidateBoxElement = document.createElement("div"), this.candidateBoxElement.className = "hg-candidate-box";
                                    var u = document.createElement("ul");
                                    u.className = "hg-candidate-box-list", o[i].forEach(function(t) {
                                        var e, o = document.createElement("li"), r = function() {
                                            var t = new (n.options.useTouchEvents ? TouchEvent : MouseEvent)("click");
                                            return Object.defineProperty(t, "target", {
                                                value: o
                                            }), t;
                                        };
                                        o.className = "hg-candidate-box-list-item", o.innerHTML = (null === (e = n.options.display) || void 0 === e ? void 0 : e[t]) || t, n.options.useTouchEvents ? o.ontouchstart = function(e) {
                                            return s(t, e || r());
                                        } : o.onclick = function() {
                                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r();
                                            return s(t, e);
                                        }, u.appendChild(o);
                                    });
                                    var c = i > 0, l = document.createElement("div");
                                    l.classList.add("hg-candidate-box-prev"), c && l.classList.add("hg-candidate-box-btn-active");
                                    var f = function() {
                                        c && n.renderPage({
                                            candidateListPages: o,
                                            targetElement: r,
                                            pageIndex: i - 1,
                                            nbPages: a,
                                            onItemSelected: s
                                        });
                                    };
                                    this.options.useTouchEvents ? l.ontouchstart = f : l.onclick = f, this.candidateBoxElement.appendChild(l), this.candidateBoxElement.appendChild(u);
                                    var d = i < a - 1, p = document.createElement("div");
                                    p.classList.add("hg-candidate-box-next"), d && p.classList.add("hg-candidate-box-btn-active");
                                    var h = function() {
                                        d && n.renderPage({
                                            candidateListPages: o,
                                            targetElement: r,
                                            pageIndex: i + 1,
                                            nbPages: a,
                                            onItemSelected: s
                                        });
                                    };
                                    this.options.useTouchEvents ? p.ontouchstart = h : p.onclick = h, this.candidateBoxElement.appendChild(p), r.prepend(this.candidateBoxElement);
                                }
                            }
                        ], e && b(t.prototype, e), n && b(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }(), O = E;
                    function S(t) {
                        return function(t) {
                            if (Array.isArray(t)) return k(t);
                        }(t) || function(t) {
                            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
                        }(t) || function(t, e) {
                            if (t) {
                                if ("string" == typeof t) return k(t, e);
                                var n = ({}).toString.call(t).slice(8, -1);
                                return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? k(t, e) : void 0;
                            }
                        }(t) || function() {
                            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }();
                    }
                    function k(t, e) {
                        (null == e || e > t.length) && (e = t.length);
                        for(var n = 0, o = Array(e); n < e; n++)o[n] = t[n];
                        return o;
                    }
                    function P(t) {
                        return P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                            return typeof t;
                        } : function(t) {
                            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                        }, P(t);
                    }
                    function I(t, e) {
                        var n = Object.keys(t);
                        if (Object.getOwnPropertySymbols) {
                            var o = Object.getOwnPropertySymbols(t);
                            e && (o = o.filter(function(e) {
                                return Object.getOwnPropertyDescriptor(t, e).enumerable;
                            })), n.push.apply(n, o);
                        }
                        return n;
                    }
                    function C(t, e) {
                        for(var n = 0; n < e.length; n++){
                            var o = e[n];
                            o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, M(o.key), o);
                        }
                    }
                    function A(t, e, n) {
                        return (e = M(e)) in t ? Object.defineProperty(t, e, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : t[e] = n, t;
                    }
                    function M(t) {
                        var e = function(t, e) {
                            if ("object" != P(t) || !t) return t;
                            var n = t[Symbol.toPrimitive];
                            if (void 0 !== n) {
                                var o = n.call(t, e || "default");
                                if ("object" != P(o)) return o;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === e ? String : Number)(t);
                        }(t, "string");
                        return "symbol" == P(e) ? e : e + "";
                    }
                    var D = function() {
                        var t, e, n;
                        return t = function t(e, n) {
                            var o = this;
                            if (function(t, e) {
                                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                            }(this, t), A(this, "input", void 0), A(this, "options", void 0), A(this, "utilities", void 0), A(this, "caretPosition", void 0), A(this, "caretPositionEnd", void 0), A(this, "keyboardDOM", void 0), A(this, "keyboardPluginClasses", void 0), A(this, "keyboardDOMClass", void 0), A(this, "buttonElements", void 0), A(this, "currentInstanceName", void 0), A(this, "allKeyboardInstances", void 0), A(this, "keyboardInstanceNames", void 0), A(this, "isFirstKeyboardInstance", void 0), A(this, "physicalKeyboard", void 0), A(this, "modules", void 0), A(this, "activeButtonClass", void 0), A(this, "holdInteractionTimeout", void 0), A(this, "holdTimeout", void 0), A(this, "isMouseHold", void 0), A(this, "initialized", void 0), A(this, "candidateBox", void 0), A(this, "keyboardRowsDOM", void 0), A(this, "defaultName", "default"), A(this, "activeInputElement", null), A(this, "handleParams", function(t, e) {
                                var n, o, r;
                                if ("string" == typeof t) n = t.split(".").join(""), o = document.querySelector(".".concat(n)), r = e;
                                else if (t instanceof HTMLDivElement) {
                                    if (!t.className) throw console.warn("Any DOM element passed as parameter must have a class."), new Error("KEYBOARD_DOM_CLASS_ERROR");
                                    n = t.className.split(" ")[0], o = t, r = e;
                                } else n = "simple-keyboard", o = document.querySelector(".".concat(n)), r = t;
                                return {
                                    keyboardDOMClass: n,
                                    keyboardDOM: o,
                                    options: r
                                };
                            }), A(this, "getOptions", function() {
                                return o.options;
                            }), A(this, "getCaretPosition", function() {
                                return o.caretPosition;
                            }), A(this, "getCaretPositionEnd", function() {
                                return o.caretPositionEnd;
                            }), A(this, "registerModule", function(t, e) {
                                o.modules[t] || (o.modules[t] = {}), e(o.modules[t]);
                            }), A(this, "getKeyboardClassString", function() {
                                for(var t = arguments.length, e = new Array(t), n = 0; n < t; n++)e[n] = arguments[n];
                                return [
                                    o.keyboardDOMClass
                                ].concat(e).filter(function(t) {
                                    return !!t;
                                }).join(" ");
                            }), "undefined" != typeof window) {
                                var r = this.handleParams(e, n), i = r.keyboardDOMClass, a = r.keyboardDOM, s = r.options, u = void 0 === s ? {} : s;
                                this.utilities = new d({
                                    getOptions: this.getOptions,
                                    getCaretPosition: this.getCaretPosition,
                                    getCaretPositionEnd: this.getCaretPositionEnd,
                                    dispatch: this.dispatch
                                }), this.caretPosition = null, this.caretPositionEnd = null, this.keyboardDOM = a, this.options = function(t) {
                                    for(var e = 1; e < arguments.length; e++){
                                        var n = null != arguments[e] ? arguments[e] : {};
                                        e % 2 ? I(Object(n), !0).forEach(function(e) {
                                            A(t, e, n[e]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function(e) {
                                            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                                        });
                                    }
                                    return t;
                                }({
                                    layoutName: "default",
                                    theme: "hg-theme-default",
                                    inputName: "default",
                                    preventMouseDownDefault: !1,
                                    enableLayoutCandidates: !0,
                                    excludeFromLayout: {}
                                }, u), this.keyboardPluginClasses = "", d.bindMethods(t, this);
                                var c = this.options.inputName, l = void 0 === c ? this.defaultName : c;
                                if (this.input = {}, this.input[l] = "", this.keyboardDOMClass = i, this.buttonElements = {}, window.SimpleKeyboardInstances || (window.SimpleKeyboardInstances = {}), this.currentInstanceName = this.utilities.camelCase(this.keyboardDOMClass), window.SimpleKeyboardInstances[this.currentInstanceName] = this, this.allKeyboardInstances = window.SimpleKeyboardInstances, this.keyboardInstanceNames = Object.keys(window.SimpleKeyboardInstances), this.isFirstKeyboardInstance = this.keyboardInstanceNames[0] === this.currentInstanceName, this.physicalKeyboard = new g({
                                    dispatch: this.dispatch,
                                    getOptions: this.getOptions
                                }), this.candidateBox = this.options.enableLayoutCandidates ? new O({
                                    utilities: this.utilities,
                                    options: this.options
                                }) : null, !this.keyboardDOM) throw console.warn('".'.concat(i, '" was not found in the DOM.')), new Error("KEYBOARD_DOM_ERROR");
                                this.render(), this.modules = {}, this.loadModules();
                            }
                        }, e = [
                            {
                                key: "setCaretPosition",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;
                                    this.caretPosition = t, this.caretPositionEnd = e;
                                }
                            },
                            {
                                key: "getInputCandidates",
                                value: function(t) {
                                    var e = this, n = this.options, o = n.layoutCandidates, r = n.layoutCandidatesCaseSensitiveMatch;
                                    if (!o || "object" !== P(o)) return {};
                                    var i = Object.keys(o).filter(function(n) {
                                        var o = t.substring(0, e.getCaretPositionEnd() || 0) || t, i = new RegExp("".concat(e.utilities.escapeRegex(n), "$"), r ? "g" : "gi");
                                        return !!S(o.matchAll(i)).length;
                                    });
                                    if (i.length > 1) {
                                        var a = i.sort(function(t, e) {
                                            return e.length - t.length;
                                        })[0];
                                        return {
                                            candidateKey: a,
                                            candidateValue: o[a]
                                        };
                                    }
                                    if (i.length) {
                                        var s = i[0];
                                        return {
                                            candidateKey: s,
                                            candidateValue: o[s]
                                        };
                                    }
                                    return {};
                                }
                            },
                            {
                                key: "showCandidatesBox",
                                value: function(t, e, n) {
                                    var o = this;
                                    this.candidateBox && this.candidateBox.show({
                                        candidateValue: e,
                                        targetElement: n,
                                        onSelect: function(e, n) {
                                            var r = o.options, i = r.layoutCandidatesCaseSensitiveMatch, a = r.disableCandidateNormalization, s = r.enableLayoutCandidatesKeyPress, u = e;
                                            a || (u = e.normalize("NFD")), "function" == typeof o.options.beforeInputUpdate && o.options.beforeInputUpdate(o);
                                            var c = o.getInput(o.options.inputName, !0), l = o.getCaretPositionEnd() || 0, f = c.substring(0, l || 0) || c, d = new RegExp("".concat(o.utilities.escapeRegex(t), "$"), i ? "g" : "gi"), p = f.replace(d, u), h = c.replace(f, p), v = p.length - f.length, y = (l || c.length) + v;
                                            y < 0 && (y = 0), o.setInput(h, o.options.inputName, !0), o.setCaretPosition(y), s && "function" == typeof o.options.onKeyPress && o.options.onKeyPress(e, n), "function" == typeof o.options.onChange && o.options.onChange(o.getInput(o.options.inputName, !0), n), "function" == typeof o.options.onChangeAll && o.options.onChangeAll(o.getAllInputs(), n);
                                        }
                                    });
                                }
                            },
                            {
                                key: "handleButtonClicked",
                                value: function(t, e) {
                                    var n = this.options, o = n.inputName, r = void 0 === o ? this.defaultName : o, i = n.debug;
                                    if ("{//}" !== t) {
                                        this.input[r] || (this.input[r] = ""), "function" == typeof this.options.beforeInputUpdate && this.options.beforeInputUpdate(this);
                                        var a = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd);
                                        if (this.utilities.isStandardButton(t) && this.activeInputElement && this.input[r] && this.input[r] === a && 0 === this.caretPosition && this.caretPositionEnd === a.length) return this.setInput("", this.options.inputName, !0), this.setCaretPosition(0), this.activeInputElement.value = "", this.activeInputElement.setSelectionRange(0, 0), void this.handleButtonClicked(t, e);
                                        if ("function" == typeof this.options.onKeyPress && this.options.onKeyPress(t, e), this.input[r] !== a && (!this.options.inputPattern || this.options.inputPattern && this.inputPatternIsValid(a))) {
                                            if (this.options.maxLength && this.utilities.handleMaxLength(this.input, a)) return;
                                            var s = this.utilities.getUpdatedInput(t, this.input[r], this.caretPosition, this.caretPositionEnd, !0);
                                            if (this.setInput(s, this.options.inputName, !0), i && console.log("Input changed:", this.getAllInputs()), this.options.debug && console.log("Caret at: ", this.getCaretPosition(), this.getCaretPositionEnd(), "(".concat(this.keyboardDOMClass, ")"), null == e ? void 0 : e.type), this.options.syncInstanceInputs && this.syncInstanceInputs(), "function" == typeof this.options.onChange && this.options.onChange(this.getInput(this.options.inputName, !0), e), "function" == typeof this.options.onChangeAll && this.options.onChangeAll(this.getAllInputs(), e), null != e && e.target && this.options.enableLayoutCandidates) {
                                                var u, c = this.getInputCandidates(a), l = c.candidateKey, f = c.candidateValue;
                                                l && f ? this.showCandidatesBox(l, f, this.keyboardDOM) : null === (u = this.candidateBox) || void 0 === u || u.destroy();
                                            }
                                        }
                                        this.caretPositionEnd && this.caretPosition !== this.caretPositionEnd && (this.setCaretPosition(this.caretPositionEnd, this.caretPositionEnd), this.activeInputElement && this.activeInputElement.setSelectionRange(this.caretPositionEnd, this.caretPositionEnd), this.options.debug && console.log("Caret position aligned", this.caretPosition)), i && console.log("Key pressed:", t);
                                    }
                                }
                            },
                            {
                                key: "getMouseHold",
                                value: function() {
                                    return this.isMouseHold;
                                }
                            },
                            {
                                key: "setMouseHold",
                                value: function(t) {
                                    this.options.syncInstanceInputs ? this.dispatch(function(e) {
                                        e.isMouseHold = t;
                                    }) : this.isMouseHold = t;
                                }
                            },
                            {
                                key: "handleButtonMouseDown",
                                value: function(t, e) {
                                    var n = this;
                                    e && (this.options.preventMouseDownDefault && e.preventDefault(), this.options.stopMouseDownPropagation && e.stopPropagation(), e.target.classList.add(this.activeButtonClass)), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdTimeout && clearTimeout(this.holdTimeout), this.setMouseHold(!0), this.options.disableButtonHold || (this.holdTimeout = window.setTimeout(function() {
                                        (n.getMouseHold() && (!t.includes("{") && !t.includes("}") || "{delete}" === t || "{backspace}" === t || "{bksp}" === t || "{space}" === t || "{tab}" === t) || "{arrowright}" === t || "{arrowleft}" === t || "{arrowup}" === t || "{arrowdown}" === t) && (n.options.debug && console.log("Button held:", t), n.handleButtonHold(t)), clearTimeout(n.holdTimeout);
                                    }, 500));
                                }
                            },
                            {
                                key: "handleButtonMouseUp",
                                value: function(t, e) {
                                    var n = this;
                                    e && (this.options.preventMouseUpDefault && e.preventDefault && e.preventDefault(), this.options.stopMouseUpPropagation && e.stopPropagation && e.stopPropagation(), !(e.target === this.keyboardDOM || e.target && this.keyboardDOM.contains(e.target) || this.candidateBox && this.candidateBox.candidateBoxElement && (e.target === this.candidateBox.candidateBoxElement || e.target && this.candidateBox.candidateBoxElement.contains(e.target))) && this.candidateBox && this.candidateBox.destroy()), this.recurseButtons(function(t) {
                                        t.classList.remove(n.activeButtonClass);
                                    }), this.setMouseHold(!1), this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), t && "function" == typeof this.options.onKeyReleased && this.options.onKeyReleased(t, e);
                                }
                            },
                            {
                                key: "handleKeyboardContainerMouseDown",
                                value: function(t) {
                                    this.options.preventMouseDownDefault && t.preventDefault();
                                }
                            },
                            {
                                key: "handleButtonHold",
                                value: function(t) {
                                    var e = this;
                                    this.holdInteractionTimeout && clearTimeout(this.holdInteractionTimeout), this.holdInteractionTimeout = window.setTimeout(function() {
                                        e.getMouseHold() ? (e.handleButtonClicked(t), e.handleButtonHold(t)) : clearTimeout(e.holdInteractionTimeout);
                                    }, 100);
                                }
                            },
                            {
                                key: "syncInstanceInputs",
                                value: function() {
                                    var t = this;
                                    this.dispatch(function(e) {
                                        e.replaceInput(t.input), e.setCaretPosition(t.caretPosition, t.caretPositionEnd);
                                    });
                                }
                            },
                            {
                                key: "clearInput",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName;
                                    this.input[t] = "", this.setCaretPosition(0), this.options.syncInstanceInputs && this.syncInstanceInputs();
                                }
                            },
                            {
                                key: "getInput",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.options.inputName || this.defaultName, e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                    return this.options.syncInstanceInputs && !e && this.syncInstanceInputs(), this.options.rtl ? "\u202B" + this.input[t].replace("\u202B", "").replace("\u202C", "") + "\u202C" : this.input[t];
                                }
                            },
                            {
                                key: "getAllInputs",
                                value: function() {
                                    var t = this, e = {};
                                    return Object.keys(this.input).forEach(function(n) {
                                        e[n] = t.getInput(n, !0);
                                    }), e;
                                }
                            },
                            {
                                key: "setInput",
                                value: function(t) {
                                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.options.inputName || this.defaultName, n = arguments.length > 2 ? arguments[2] : void 0;
                                    this.input[e] = t, !n && this.options.syncInstanceInputs && this.syncInstanceInputs();
                                }
                            },
                            {
                                key: "replaceInput",
                                value: function(t) {
                                    this.input = t;
                                }
                            },
                            {
                                key: "setOptions",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = this.changedOptions(t);
                                    this.options = Object.assign(this.options, t), e.length && (this.options.debug && console.log("changedOptions", e), this.onSetOptions(e), this.render());
                                }
                            },
                            {
                                key: "changedOptions",
                                value: function(t) {
                                    var e = this;
                                    return Object.keys(t).filter(function(n) {
                                        return JSON.stringify(t[n]) !== JSON.stringify(e.options[n]);
                                    });
                                }
                            },
                            {
                                key: "onSetOptions",
                                value: function() {
                                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                                    t.includes("layoutName") && this.candidateBox && this.candidateBox.destroy(), (t.includes("layoutCandidatesPageSize") || t.includes("layoutCandidates")) && this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = new O({
                                        utilities: this.utilities,
                                        options: this.options
                                    }));
                                }
                            },
                            {
                                key: "resetRows",
                                value: function() {
                                    this.keyboardRowsDOM && this.keyboardRowsDOM.remove(), this.keyboardDOM.className = this.keyboardDOMClass, this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.buttonElements = {};
                                }
                            },
                            {
                                key: "dispatch",
                                value: function(t) {
                                    if (!window.SimpleKeyboardInstances) throw console.warn("SimpleKeyboardInstances is not defined. Dispatch cannot be called."), new Error("INSTANCES_VAR_ERROR");
                                    return Object.keys(window.SimpleKeyboardInstances).forEach(function(e) {
                                        t(window.SimpleKeyboardInstances[e], e);
                                    });
                                }
                            },
                            {
                                key: "addButtonTheme",
                                value: function(t, e) {
                                    var n = this;
                                    e && t && (t.split(" ").forEach(function(o) {
                                        e.split(" ").forEach(function(e) {
                                            n.options.buttonTheme || (n.options.buttonTheme = []);
                                            var r = !1;
                                            n.options.buttonTheme.map(function(t) {
                                                if (null != t && t.class.split(" ").includes(e)) {
                                                    r = !0;
                                                    var n = t.buttons.split(" ");
                                                    n.includes(o) || (r = !0, n.push(o), t.buttons = n.join(" "));
                                                }
                                                return t;
                                            }), r || n.options.buttonTheme.push({
                                                class: e,
                                                buttons: t
                                            });
                                        });
                                    }), this.render());
                                }
                            },
                            {
                                key: "removeButtonTheme",
                                value: function(t, e) {
                                    var n = this;
                                    if (!t && !e) return this.options.buttonTheme = [], void this.render();
                                    t && Array.isArray(this.options.buttonTheme) && this.options.buttonTheme.length && (t.split(" ").forEach(function(t) {
                                        var o;
                                        null === (o = n.options) || void 0 === o || null === (o = o.buttonTheme) || void 0 === o || o.map(function(o, r) {
                                            if (o && e && e.includes(o.class) || !e) {
                                                var i, a, s = null === (i = o) || void 0 === i ? void 0 : i.buttons.split(" ").filter(function(e) {
                                                    return e !== t;
                                                });
                                                o && null != s && s.length ? o.buttons = s.join(" ") : (null === (a = n.options.buttonTheme) || void 0 === a || a.splice(r, 1), o = null);
                                            }
                                            return o;
                                        });
                                    }), this.render());
                                }
                            },
                            {
                                key: "getButtonElement",
                                value: function(t) {
                                    var e, n = this.buttonElements[t];
                                    return n && (e = n.length > 1 ? n : n[0]), e;
                                }
                            },
                            {
                                key: "inputPatternIsValid",
                                value: function(t) {
                                    var e, n = this.options.inputPattern;
                                    if ((e = n instanceof RegExp ? n : n[this.options.inputName || this.defaultName]) && t) {
                                        var o = e.test(t);
                                        return this.options.debug && console.log('inputPattern ("'.concat(e, '"): ').concat(o ? "passed" : "did not pass!")), o;
                                    }
                                    return !0;
                                }
                            },
                            {
                                key: "setEventListeners",
                                value: function() {
                                    if (this.isFirstKeyboardInstance || !this.allKeyboardInstances) {
                                        this.options.debug && console.log("Caret handling started (".concat(this.keyboardDOMClass, ")"));
                                        var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                                        document.addEventListener("keyup", this.handleKeyUp, e), document.addEventListener("keydown", this.handleKeyDown, e), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("touchend", this.handleTouchEnd), this.options.updateCaretOnSelectionChange && document.addEventListener("selectionchange", this.handleSelectionChange), document.addEventListener("select", this.handleSelect);
                                    }
                                }
                            },
                            {
                                key: "handleKeyUp",
                                value: function(t) {
                                    this.caretEventHandler(t), this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyUp(t);
                                }
                            },
                            {
                                key: "handleKeyDown",
                                value: function(t) {
                                    this.options.physicalKeyboardHighlight && this.physicalKeyboard.handleHighlightKeyDown(t);
                                }
                            },
                            {
                                key: "handleMouseUp",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleTouchEnd",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleSelect",
                                value: function(t) {
                                    this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "handleSelectionChange",
                                value: function(t) {
                                    navigator.userAgent.includes("Firefox") || this.caretEventHandler(t);
                                }
                            },
                            {
                                key: "caretEventHandler",
                                value: function(t) {
                                    var e, n = this;
                                    t.target.tagName && (e = t.target.tagName.toLowerCase()), this.dispatch(function(o) {
                                        var r = t.target === o.keyboardDOM || t.target && o.keyboardDOM.contains(t.target);
                                        if (n.options.syncInstanceInputs && Array.isArray(t.path) && (r = t.path.some(function(t) {
                                            var e;
                                            return null == t || null === (e = t.hasAttribute) || void 0 === e ? void 0 : e.call(t, "data-skInstance");
                                        })), ("textarea" === e || "input" === e && [
                                            "text",
                                            "search",
                                            "url",
                                            "tel",
                                            "password"
                                        ].includes(t.target.type)) && !o.options.disableCaretPositioning) {
                                            var i = t.target.selectionStart, a = t.target.selectionEnd;
                                            o.options.rtl && (i = o.utilities.getRtlOffset(i, o.getInput()), a = o.utilities.getRtlOffset(a, o.getInput())), o.setCaretPosition(i, a), o.activeInputElement = t.target, o.options.debug && console.log("Caret at: ", o.getCaretPosition(), o.getCaretPositionEnd(), t && t.target.tagName.toLowerCase(), "(".concat(o.keyboardDOMClass, ")"), null == t ? void 0 : t.type);
                                        } else !o.options.disableCaretPositioning && r || "selectionchange" === (null == t ? void 0 : t.type) || (o.setCaretPosition(null), o.activeInputElement = null, o.options.debug && console.log('Caret position reset due to "'.concat(null == t ? void 0 : t.type, '" event'), t));
                                    });
                                }
                            },
                            {
                                key: "recurseButtons",
                                value: function(t) {
                                    var e = this;
                                    t && Object.keys(this.buttonElements).forEach(function(n) {
                                        return e.buttonElements[n].forEach(t);
                                    });
                                }
                            },
                            {
                                key: "destroy",
                                value: function() {
                                    this.options.debug && console.log("Destroying simple-keyboard instance: ".concat(this.currentInstanceName));
                                    var t = this.options.physicalKeyboardHighlightPreventDefault, e = void 0 !== t && t;
                                    document.removeEventListener("keyup", this.handleKeyUp, e), document.removeEventListener("keydown", this.handleKeyDown, e), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("touchend", this.handleTouchEnd), document.removeEventListener("select", this.handleSelect), this.options.updateCaretOnSelectionChange && document.removeEventListener("selectionchange", this.handleSelectionChange), document.onpointerup = null, document.ontouchend = null, document.ontouchcancel = null, document.onmouseup = null, this.recurseButtons(function(t) {
                                        t && (t.onpointerdown = null, t.onpointerup = null, t.onpointercancel = null, t.ontouchstart = null, t.ontouchend = null, t.ontouchcancel = null, t.onclick = null, t.onmousedown = null, t.onmouseup = null, t.remove(), t = null);
                                    }), this.keyboardDOM.onpointerdown = null, this.keyboardDOM.ontouchstart = null, this.keyboardDOM.onmousedown = null, this.resetRows(), this.candidateBox && (this.candidateBox.destroy(), this.candidateBox = null), this.activeInputElement = null, this.keyboardDOM.removeAttribute("data-skInstance"), this.keyboardDOM.innerHTML = "", window.SimpleKeyboardInstances[this.currentInstanceName] = null, delete window.SimpleKeyboardInstances[this.currentInstanceName], this.initialized = !1;
                                }
                            },
                            {
                                key: "getButtonThemeClasses",
                                value: function(t) {
                                    var e = this.options.buttonTheme, n = [];
                                    return Array.isArray(e) && e.forEach(function(e) {
                                        if (e && e.class && "string" == typeof e.class && e.buttons && "string" == typeof e.buttons) {
                                            var o = e.class.split(" ");
                                            e.buttons.split(" ").includes(t) && (n = [].concat(S(n), S(o)));
                                        } else console.warn('Incorrect "buttonTheme". Please check the documentation.', e);
                                    }), n;
                                }
                            },
                            {
                                key: "setDOMButtonAttributes",
                                value: function(t, e) {
                                    var n = this.options.buttonAttributes;
                                    Array.isArray(n) && n.forEach(function(n) {
                                        n.attribute && "string" == typeof n.attribute && n.value && "string" == typeof n.value && n.buttons && "string" == typeof n.buttons ? n.buttons.split(" ").includes(t) && e(n.attribute, n.value) : console.warn('Incorrect "buttonAttributes". Please check the documentation.', n);
                                    });
                                }
                            },
                            {
                                key: "onTouchDeviceDetected",
                                value: function() {
                                    this.processAutoTouchEvents(), this.disableContextualWindow();
                                }
                            },
                            {
                                key: "disableContextualWindow",
                                value: function() {
                                    window.oncontextmenu = function(t) {
                                        if (t.target.classList.contains("hg-button")) return t.preventDefault(), t.stopPropagation(), !1;
                                    };
                                }
                            },
                            {
                                key: "processAutoTouchEvents",
                                value: function() {
                                    this.options.autoUseTouchEvents && (this.options.useTouchEvents = !0, this.options.debug && console.log("autoUseTouchEvents: Touch device detected, useTouchEvents enabled."));
                                }
                            },
                            {
                                key: "onInit",
                                value: function() {
                                    this.options.debug && console.log("".concat(this.keyboardDOMClass, " Initialized")), this.setEventListeners(), "function" == typeof this.options.onInit && this.options.onInit(this);
                                }
                            },
                            {
                                key: "beforeFirstRender",
                                value: function() {
                                    this.utilities.isTouchDevice() && this.onTouchDeviceDetected(), "function" == typeof this.options.beforeFirstRender && this.options.beforeFirstRender(this), this.isFirstKeyboardInstance && this.utilities.pointerEventsSupported() && !this.options.useTouchEvents && !this.options.useMouseEvents && this.options.debug && console.log("Using PointerEvents as it is supported by this browser"), this.options.useTouchEvents && this.options.debug && console.log("useTouchEvents has been enabled. Only touch events will be used.");
                                }
                            },
                            {
                                key: "beforeRender",
                                value: function() {
                                    "function" == typeof this.options.beforeRender && this.options.beforeRender(this);
                                }
                            },
                            {
                                key: "onRender",
                                value: function() {
                                    "function" == typeof this.options.onRender && this.options.onRender(this);
                                }
                            },
                            {
                                key: "onModulesLoaded",
                                value: function() {
                                    "function" == typeof this.options.onModulesLoaded && this.options.onModulesLoaded(this);
                                }
                            },
                            {
                                key: "loadModules",
                                value: function() {
                                    var t = this;
                                    Array.isArray(this.options.modules) && (this.options.modules.forEach(function(e) {
                                        var n = new e(t);
                                        n.init && n.init(t);
                                    }), this.keyboardPluginClasses = "modules-loaded", this.render(), this.onModulesLoaded());
                                }
                            },
                            {
                                key: "getModuleProp",
                                value: function(t, e) {
                                    return !!this.modules[t] && this.modules[t][e];
                                }
                            },
                            {
                                key: "getModulesList",
                                value: function() {
                                    return Object.keys(this.modules);
                                }
                            },
                            {
                                key: "parseRowDOMContainers",
                                value: function(t, e, n, o) {
                                    var r = this, i = Array.from(t.children), a = 0;
                                    return i.length && n.forEach(function(n, s) {
                                        var u = o[s];
                                        if (!(u && u > n)) return !1;
                                        var c = n - a, l = u - a, f = document.createElement("div");
                                        f.className += "hg-button-container";
                                        var d = "".concat(r.options.layoutName, "-r").concat(e, "c").concat(s);
                                        f.setAttribute("data-skUID", d);
                                        var p = i.splice(c, l - c + 1);
                                        a = l - c, p.forEach(function(t) {
                                            return f.appendChild(t);
                                        }), i.splice(c, 0, f), t.innerHTML = "", i.forEach(function(e) {
                                            return t.appendChild(e);
                                        }), r.options.debug && console.log("rowDOMContainer", p, c, l, a + 1);
                                    }), t;
                                }
                            },
                            {
                                key: "render",
                                value: function() {
                                    var t = this;
                                    this.resetRows(), this.initialized || this.beforeFirstRender(), this.beforeRender();
                                    var e = "hg-layout-".concat(this.options.layoutName), n = this.options.layout || {
                                        default: [
                                            "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                                            "{tab} q w e r t y u i o p [ ] \\",
                                            "{lock} a s d f g h j k l ; ' {enter}",
                                            "{shift} z x c v b n m , . / {shift}",
                                            ".com @ {space}"
                                        ],
                                        shift: [
                                            "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                                            "{tab} Q W E R T Y U I O P { } |",
                                            '{lock} A S D F G H J K L : " {enter}',
                                            "{shift} Z X C V B N M < > ? {shift}",
                                            ".com @ {space}"
                                        ]
                                    }, o = this.options.useTouchEvents || !1, r = o ? "hg-touch-events" : "", i = this.options.useMouseEvents || !1, a = this.options.disableRowButtonContainers;
                                    this.keyboardDOM.className = this.getKeyboardClassString(this.options.theme, e, this.keyboardPluginClasses, r), this.keyboardDOM.setAttribute("data-skInstance", this.currentInstanceName), this.keyboardRowsDOM = document.createElement("div"), this.keyboardRowsDOM.className = "hg-rows", n[this.options.layoutName || this.defaultName].forEach(function(e, n) {
                                        var r = e.split(" ");
                                        t.options.excludeFromLayout && t.options.excludeFromLayout[t.options.layoutName || t.defaultName] && (r = r.filter(function(e) {
                                            return t.options.excludeFromLayout && !t.options.excludeFromLayout[t.options.layoutName || t.defaultName].includes(e);
                                        }));
                                        var s = document.createElement("div");
                                        s.className += "hg-row";
                                        var u = [], c = [];
                                        r.forEach(function(e, r) {
                                            var l, f = !a && "string" == typeof e && e.length > 1 && 0 === e.indexOf("["), d = !a && "string" == typeof e && e.length > 1 && e.indexOf("]") === e.length - 1;
                                            f && (u.push(r), e = e.replace(/\[/g, "")), d && (c.push(r), e = e.replace(/\]/g, ""));
                                            var p = t.utilities.getButtonClass(e), h = t.utilities.getButtonDisplayName(e, t.options.display, t.options.mergeDisplay), v = t.options.useButtonTag ? "button" : "div", y = document.createElement(v);
                                            y.className += "hg-button ".concat(p), (l = y.classList).add.apply(l, S(t.getButtonThemeClasses(e))), t.setDOMButtonAttributes(e, function(t, e) {
                                                y.setAttribute(t, e);
                                            }), t.activeButtonClass = "hg-activeButton", !t.utilities.pointerEventsSupported() || o || i ? o ? (y.ontouchstart = function(n) {
                                                t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.ontouchend = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }, y.ontouchcancel = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }) : (y.onclick = function(n) {
                                                t.setMouseHold(!1), "function" != typeof t.options.onKeyReleased && t.handleButtonClicked(e, n);
                                            }, y.onmousedown = function(n) {
                                                "function" != typeof t.options.onKeyReleased || t.isMouseHold || t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.onmouseup = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }) : (y.onpointerdown = function(n) {
                                                t.handleButtonClicked(e, n), t.handleButtonMouseDown(e, n);
                                            }, y.onpointerup = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }, y.onpointercancel = function(n) {
                                                t.handleButtonMouseUp(e, n);
                                            }), y.setAttribute("data-skBtn", e);
                                            var g = "".concat(t.options.layoutName, "-r").concat(n, "b").concat(r);
                                            y.setAttribute("data-skBtnUID", g);
                                            var m = document.createElement("span");
                                            m.innerHTML = h, y.appendChild(m), t.buttonElements[e] || (t.buttonElements[e] = []), t.buttonElements[e].push(y), s.appendChild(y);
                                        }), s = t.parseRowDOMContainers(s, n, u, c), t.keyboardRowsDOM.appendChild(s);
                                    }), this.keyboardDOM.appendChild(this.keyboardRowsDOM), this.onRender(), this.initialized || (this.initialized = !0, !this.utilities.pointerEventsSupported() || o || i ? o ? (document.ontouchend = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, document.ontouchcancel = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.ontouchstart = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }) : o || (document.onmouseup = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.onmousedown = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }) : (document.onpointerup = function(e) {
                                        return t.handleButtonMouseUp(void 0, e);
                                    }, this.keyboardDOM.onpointerdown = function(e) {
                                        return t.handleKeyboardContainerMouseDown(e);
                                    }), this.onInit());
                                }
                            }
                        ], e && C(t.prototype, e), n && C(t, n), Object.defineProperty(t, "prototype", {
                            writable: !1
                        }), t;
                    }(), T = D, N = T;
                    return o;
                }();
            },
            442: function(e) {
                "use strict";
                e.exports = t;
            }
        }, n = {};
        function o(t) {
            var r = n[t];
            if (void 0 !== r) return r.exports;
            var i = n[t] = {
                exports: {}
            };
            return e[t].call(i.exports, i, i.exports, o), i.exports;
        }
        o.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return o.d(e, {
                a: e
            }), e;
        }, o.d = function(t, e) {
            for(var n in e)o.o(e, n) && !o.o(t, n) && Object.defineProperty(t, n, {
                enumerable: !0,
                get: e[n]
            });
        }, o.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, o.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            o.r(r), o.d(r, {
                KeyboardReact: function() {
                    return l;
                },
                default: function() {
                    return f;
                }
            });
            o(981);
            var t = o(442), e = o(548), n = o.n(e);
            function i(t) {
                return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, i(t);
            }
            function a(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(t);
                    e && (o = o.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, o);
                }
                return n;
            }
            function s(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? a(Object(n), !0).forEach(function(e) {
                        u(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function u(t, e, n) {
                return (e = function(t) {
                    var e = function(t, e) {
                        if ("object" != i(t) || !t) return t;
                        var n = t[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(t, e || "default");
                            if ("object" != i(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === e ? String : Number)(t);
                    }(t, "string");
                    return "symbol" == i(e) ? e : e + "";
                }(e)) in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var c = function(t) {
                return s(s({}, t), {}, {
                    keyboardRef: null
                });
            }, l = function(e) {
                var o = e.baseClass || "react-simple-keyboard", r = t.useRef(null), i = t.useRef(null), a = t.useRef(null), u = t.useRef(e);
                return t.useEffect(function() {
                    return function() {
                        a.current && a.current.destroy(), r.current = !1;
                    };
                }, []), t.useEffect(function() {
                    var t = function(t) {
                        return s(s({}, t), {}, {
                            theme: "simple-keyboard ".concat(t.theme || "hg-theme-default")
                        });
                    }(e);
                    if (!r.current) {
                        r.current = !0, t.debug && console.log("ReactSimpleKeyboard: Init");
                        var l = i.current, f = ".".concat(o);
                        a.current = new (n())(l || f, t), t.keyboardRef && t.keyboardRef(a.current);
                    }
                    var d = function(t, e) {
                        var n = c(e), o = c(t);
                        return Object.keys(n).filter(function(t) {
                            return n[t] !== o[t];
                        });
                    }(u.current, t);
                    if (d.length) {
                        var p = a.current;
                        u.current = t, null == p || p.setOptions(t), t.debug && console.log("ReactSimpleKeyboard - setOptions called due to updated props:", d);
                    }
                }, [
                    r,
                    o,
                    u,
                    e
                ]), t.createElement("div", {
                    className: o,
                    ref: i
                });
            }, f = l;
        }(), r;
    }();
});



var $eZVvM = parcelRequire("eZVvM");
const $542517bd98c741d7$export$86757e9fe5e12048 = {
    "phone-pad": {
        "{space}": "space",
        "{bksp}": "\u232B",
        "{enter}": "\u21B5"
    },
    default: {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "default-shift": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "default-alt": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "abc",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    email: {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "email-shift": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "123",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    "email-alt": {
        "{shift}": "shift",
        "{bksp}": "\u232B",
        "{alt}": "abc",
        "{space}": "space",
        "{enter}": "\u21B5"
    },
    pin: {}
};
const $542517bd98c741d7$export$78ca07932ec5b059 = {
    default: [
        // "+ 1 2 3 4 5 6 7 8 9 0",
        "q w e r t y u i o p",
        "a s d f g h j k l",
        "{shift} z x c v b n m {bksp}",
        "{alt} , {space} . {enter}"
    ],
    "default-alt": [
        "1 2 3 4 5 6 7 8 9 0",
        "@ # $ _ & - + ( ) /",
        `* " ' : ; ! ? {bksp}`,
        "{alt} , {space} . {enter}"
    ],
    "default-shift": [
        // "~ ! @ # $ % ^ &amp; * ( ) _ ` {bksp}",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "{shift} Z X C V B N M {bksp}",
        "{alt} , {space} . {enter}"
    ],
    "phone-pad": [
        "1 2 3 {//}",
        //
        "4 5 6 {//}",
        //
        "7 8 9 {bksp}",
        //
        "+ 0 # {enter}" //
    ],
    email: [
        "q w e r t y u i o p",
        "a s d f g h j k l",
        "{shift} z x c v b n m {bksp}",
        "{alt} {space} @ . {enter}"
    ],
    "email-alt": [
        "1 2 3 4 5 6 7 8 9 0",
        "@ # $ _ & - + ( ) /",
        `* " ' : ; ! ? {bksp}`,
        "{alt} {space} . {enter}"
    ],
    "email-shift": [
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "{shift} Z X C V B N M {bksp}",
        "{alt} {space} @ . {enter}"
    ],
    pin: [
        "1 2 3",
        "4 5 6",
        "7 8 9",
        "{//} 0 {//}",
        "{bksp}" //
    ]
};



var $k9qks = parcelRequire("k9qks");

var $cD0nt = parcelRequire("cD0nt");
const $65b2ace84335c487$var$VirtualKeyboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((props, ref)=>{
    const { layoutName: layoutName = "default" } = props;
    const keyboardRef = (0, $eZVvM.useRef)();
    const rootRef = (0, $eZVvM.useRef)(null);
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    (0, $eZVvM.useImperativeHandle)(ref, ()=>({
            setInput: (input, inputName, skipSync)=>{
                if (!keyboardRef.current) return;
                keyboardRef.current.setInput(input, inputName, skipSync);
            },
            setCaretPosition: (position, endPosition)=>{
                if (!keyboardRef.current) return;
                keyboardRef.current.setCaretPosition(position, endPosition);
            }
        }));
    var _metadata_keyboardBottomOffset;
    const offset = (_metadata_keyboardBottomOffset = metadata === null || metadata === void 0 ? void 0 : metadata.keyboardBottomOffset) !== null && _metadata_keyboardBottomOffset !== void 0 ? _metadata_keyboardBottomOffset : 0;
    (0, $eZVvM.useLayoutEffect)(()=>{
        var _rootRef_current;
        const el = (_rootRef_current = rootRef.current) === null || _rootRef_current === void 0 ? void 0 : _rootRef_current.closest(".keyboard");
        if (!(el instanceof HTMLElement)) return undefined;
        el.style.setProperty("--keyboard-offset", `${offset}rem`);
        return ()=>{
            el.style.removeProperty("--keyboard-offset");
        };
    }, [
        offset
    ]);
    // Disable virtual keyboard if we are inside a webview
    // or if it is set that way in the metadata
    if (!(0, $k9qks.isVirtualKeyboardEnabled) || (metadata === null || metadata === void 0 ? void 0 : metadata.isVirtualKeyboardDisabled)) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        ref: rootRef,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7a86233f32729561$exports))), {
            ...props,
            keyboardRef: (ref)=>{
                keyboardRef.current = ref;
            },
            tabCharOnTab: false,
            mergeDisplay: true,
            layout: (0, $542517bd98c741d7$export$78ca07932ec5b059),
            display: (0, $542517bd98c741d7$export$86757e9fe5e12048)[layoutName],
            preventMouseDownDefault: true
        })
    });
});
var $65b2ace84335c487$export$2e2bcd8739ae039 = $65b2ace84335c487$var$VirtualKeyboard;




var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");





// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $cdd9f8889be8e555$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $c67a96687a400a99$export$2e2bcd8739ae039 = (0, $cdd9f8889be8e555$export$2e2bcd8739ae039);






var $173ff66374ad2b51$export$2e2bcd8739ae039 = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039);



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9ebd66ad6ae55237$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $9ebd66ad6ae55237$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== "none" && typeof transform === "string") {
        const transformValues = transform.split("(")[1].split(")")[0].split(",");
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === "left") {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === "right") {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === "up") {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $9ebd66ad6ae55237$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === "function" ? containerPropProp() : containerPropProp;
}
function $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $9ebd66ad6ae55237$var$resolveContainer(containerProp);
    const transform = $9ebd66ad6ae55237$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $9ebd66ad6ae55237$var$Slide = /*#__PURE__*/ $eZVvM.forwardRef(function Slide(props, ref) {
    const theme = (0, $22960e5129fa60d7$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = "down", easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $61e7b8c7fcb92c69$export$2e2bcd8739ae039) } = props, other = (0, $7Z8DW.default)(props, $9ebd66ad6ae55237$var$_excluded);
    const childrenRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(children.ref, childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $a87adae6755df26f$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0, $65o8X.default)({}, transitionProps));
        node.style.transition = theme.transitions.create("transform", (0, $65o8X.default)({}, transitionProps));
        node.style.webkitTransform = "none";
        node.style.transform = "none";
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $a87adae6755df26f$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("-webkit-transform", transitionProps);
        node.style.transition = theme.transitions.create("transform", transitionProps);
        $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = "";
        node.style.transition = "";
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $eZVvM.useCallback(()=>{
        if (childrenRef.current) $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $eZVvM.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === "down" || direction === "right") return undefined;
        const handleResize = (0, $c67a96687a400a99$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $9ebd66ad6ae55237$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $eZVvM.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $eZVvM.cloneElement(children, (0, $65o8X.default)({
                ref: handleRef,
                style: (0, $65o8X.default)({
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $9ebd66ad6ae55237$export$2e2bcd8739ae039 = $9ebd66ad6ae55237$var$Slide;


parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $219y6 = parcelRequire("219y6");

var $cD0nt = parcelRequire("cD0nt");
const $ae73822bb7ab31ca$var$Transition = /*#__PURE__*/ (0, $eZVvM.forwardRef)(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9ebd66ad6ae55237$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $ae73822bb7ab31ca$var$OfflineModal = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "offline"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    if (online) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), {
        fullScreen: true,
        open: true,
        onClose: ()=>{
            navigate("/");
        },
        TransitionComponent: $ae73822bb7ab31ca$var$Transition,
        sx: {
            p: 3,
            "& .MuiPaper-root": {
                borderRadius: 2
            }
        },
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $4baac96c69466163$export$2e2bcd8739ae039), {
            sx: {
                display: "flex",
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h1",
                    sx: {
                        px: 4
                    },
                    children: t("offline:receptionMessage")
                }),
                receptionistPhone && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h1",
                    sx: {
                        px: 4
                    },
                    children: t("offline:check", {
                        receptionistPhone: receptionistPhone
                    })
                })
            ]
        })
    });
};
var $ae73822bb7ab31ca$export$2e2bcd8739ae039 = $ae73822bb7ab31ca$var$OfflineModal;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");








var $bhfvP = parcelRequire("bhfvP");
const $ead8f2bf5d3dae75$var$isPdf = (file)=>{
    var _file_absolutePath;
    return !!(file === null || file === void 0 ? void 0 : (_file_absolutePath = file.absolutePath) === null || _file_absolutePath === void 0 ? void 0 : _file_absolutePath.endsWith("pdf"));
};
/**
 * The document body of the agreement dialog.
 *
 * A PDF handed to the browser is the slow path: the built-in viewer takes
 * seconds to start on kiosk hardware, and inside a WebView there is no viewer at
 * all. So the server renders each page to an image up front and those are drawn
 * here instead — plain <img>, cached by the service worker like any other asset.
 *
 * The PDF stays as the fallback for documents that have not been rendered yet
 * (the job runs after upload) or where rendering failed.
 */ const $ead8f2bf5d3dae75$var$AgreementDocument = ({ file: file })=>{
    if (!(file === null || file === void 0 ? void 0 : file.absolutePath)) return null;
    var _file_pages;
    const pages = (_file_pages = file.pages) !== null && _file_pages !== void 0 ? _file_pages : [];
    if (pages.length > 0) return(// No scroller of its own: the dialog content scrolls, see AggrementDialog.
    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        className: "ea-pages",
        children: pages.map((page, index)=>/*#__PURE__*/ (0, $bhfvP.jsx)("img", {
                src: page.absolutePath,
                alt: "",
                className: "w-100 d-block",
                // A native image drag cancels the pointer and would stop the scroll.
                draggable: false,
                /**
         * The first page is what the visitor is waiting on; the rest can
         * arrive as they scroll.
         */ loading: index === 0 ? "eager" : "lazy"
            }, page.id))
    }));
    if ($ead8f2bf5d3dae75$var$isPdf(file)) return /*#__PURE__*/ (0, $bhfvP.jsx)("iframe", {
        title: "aggrement",
        src: `${file.absolutePath}#toolbar=0`,
        width: "100%",
        height: "98%"
    });
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        className: "ea-image h-100",
        style: {
            backgroundImage: `url("${file.absolutePath}")`
        }
    });
};
var $ead8f2bf5d3dae75$export$2e2bcd8739ae039 = $ead8f2bf5d3dae75$var$AgreementDocument;



var $eZVvM = parcelRequire("eZVvM");
/**
 * Finger-drag scrolling for a scroll container.
 *
 * The kiosks (ProDVX panels) only scrolled through the scrollbar — dragging a
 * finger over the content did nothing, while the very same build scrolls fine
 * in a desktop browser with touch emulation. The page's own CSS is correct
 * (`overflow-y: auto`, `-webkit-overflow-scrolling: touch`, overlays are
 * `pointer-events: none`, framer-motion sets no `touch-action` without `drag`),
 * so the difference lives in the device's runtime, which we do not control and
 * which changes with every panel the client buys.
 *
 * So instead of guessing at WebView versions, we drive the scroll ourselves
 * from pointer events. `touch-action: none` hands the gesture over completely,
 * which also means the behaviour is now IDENTICAL on the kiosk and on a
 * developer's machine — a reported scroll problem can finally be reproduced
 * with a mouse.
 *
 * Taps are preserved: nothing happens until the finger travels past
 * `DRAG_THRESHOLD_PX`, and a drag that crossed it swallows the click it would
 * otherwise produce, so sliding across a button never dials reception.
 */ /** Movement before a touch counts as a drag instead of a tap. */ const $2b97c297394ec2fd$var$DRAG_THRESHOLD_PX = 8;
/** Velocity decay per frame after release. Lower = stops sooner. */ const $2b97c297394ec2fd$var$MOMENTUM_FRICTION = 0.94;
/** Below this (px/ms) the glide is over. */ const $2b97c297394ec2fd$var$MOMENTUM_MIN_VELOCITY = 0.02;
/**
 * Only the most recent movement should decide the fling, otherwise a slow drag
 * ending in a flick (or the reverse) throws the list the wrong way.
 */ const $2b97c297394ec2fd$var$VELOCITY_SMOOTHING = 0.7;
const $2b97c297394ec2fd$export$9a005dd890431a0a = (element, enabled = true)=>{
    (0, $eZVvM.useEffect)(()=>{
        if (!element || !enabled) return undefined;
        // Local handle for the whole effect: the element this run subscribed to is
        // the one it must also scroll and clean up, even if the prop changes.
        const node = element;
        // Touches stand in for pointers where the runtime has no Pointer Events.
        const hasPointerEvents = typeof window.PointerEvent === "function";
        let activePointerId = null;
        let isDragging = false;
        let startY = 0;
        let lastY = 0;
        let lastMoveAt = 0;
        let velocity = 0;
        let momentumFrame = null;
        /**
     * A drag ends with a `click` the browser still considers legitimate. This
     * flag makes the capture-phase listener below eat exactly one of them.
     */ let swallowNextClick = false;
        const stopMomentum = ()=>{
            if (momentumFrame !== null) {
                cancelAnimationFrame(momentumFrame);
                momentumFrame = null;
            }
        };
        const startMomentum = ()=>{
            let previousFrameAt = performance.now();
            const step = (now)=>{
                const elapsed = now - previousFrameAt;
                previousFrameAt = now;
                const before = node.scrollTop;
                node.scrollTop -= velocity * elapsed;
                velocity *= $2b97c297394ec2fd$var$MOMENTUM_FRICTION;
                // Hitting the top or the bottom ends the glide — without this the loop
                // keeps running against a wall until friction alone stops it.
                const hitBounds = node.scrollTop === before;
                if (hitBounds || Math.abs(velocity) < $2b97c297394ec2fd$var$MOMENTUM_MIN_VELOCITY) {
                    momentumFrame = null;
                    return;
                }
                momentumFrame = requestAnimationFrame(step);
            };
            momentumFrame = requestAnimationFrame(step);
        };
        const onPointerDown = (event)=>{
            // Right/middle mouse buttons must not grab the list.
            if (event.pointerType === "mouse" && event.button !== 0) return;
            stopMomentum();
            activePointerId = event.pointerId;
            isDragging = false;
            swallowNextClick = false;
            startY = event.clientY;
            lastY = event.clientY;
            lastMoveAt = event.timeStamp;
            velocity = 0;
        };
        const onPointerMove = (event)=>{
            if (activePointerId !== event.pointerId) return;
            if (!isDragging) {
                if (Math.abs(event.clientY - startY) <= $2b97c297394ec2fd$var$DRAG_THRESHOLD_PX) return;
                isDragging = true;
                // Keep receiving events once the finger slides off the container —
                // without capture a fast drag simply stops halfway.
                if (hasPointerEvents) node.setPointerCapture(event.pointerId);
            }
            const deltaY = event.clientY - lastY;
            const elapsed = event.timeStamp - lastMoveAt;
            node.scrollTop -= deltaY;
            if (elapsed > 0) {
                const instant = deltaY / elapsed;
                velocity = velocity * (1 - $2b97c297394ec2fd$var$VELOCITY_SMOOTHING) + instant * $2b97c297394ec2fd$var$VELOCITY_SMOOTHING;
            }
            lastY = event.clientY;
            lastMoveAt = event.timeStamp;
        };
        const endDrag = (event)=>{
            if (activePointerId !== event.pointerId) return;
            if (hasPointerEvents && node.hasPointerCapture(event.pointerId)) node.releasePointerCapture(event.pointerId);
            if (isDragging) {
                swallowNextClick = true;
                if (Math.abs(velocity) >= $2b97c297394ec2fd$var$MOMENTUM_MIN_VELOCITY) startMomentum();
            }
            activePointerId = null;
            isDragging = false;
        };
        const onClickCapture = (event)=>{
            if (!swallowNextClick) return;
            swallowNextClick = false;
            event.preventDefault();
            event.stopPropagation();
        };
        const previousTouchAction = node.style.touchAction;
        // We own the gesture now; leaving the native one on would scroll twice on
        // the devices where it does work.
        node.style.touchAction = "none";
        node.addEventListener("click", onClickCapture, true);
        if (hasPointerEvents) {
            node.addEventListener("pointerdown", onPointerDown);
            node.addEventListener("pointermove", onPointerMove);
            node.addEventListener("pointerup", endDrag);
            node.addEventListener("pointercancel", endDrag);
            return ()=>{
                stopMomentum();
                node.style.touchAction = previousTouchAction;
                node.removeEventListener("pointerdown", onPointerDown);
                node.removeEventListener("pointermove", onPointerMove);
                node.removeEventListener("pointerup", endDrag);
                node.removeEventListener("pointercancel", endDrag);
                node.removeEventListener("click", onClickCapture, true);
            };
        }
        // Pre-Chrome-55 WebViews: feed the same handlers from touches.
        const asPointer = (event)=>{
            var _event_changedTouches_;
            var _event_changedTouches__clientY;
            return {
                pointerId: 1,
                pointerType: "touch",
                button: 0,
                clientY: (_event_changedTouches__clientY = (_event_changedTouches_ = event.changedTouches[0]) === null || _event_changedTouches_ === void 0 ? void 0 : _event_changedTouches_.clientY) !== null && _event_changedTouches__clientY !== void 0 ? _event_changedTouches__clientY : lastY,
                timeStamp: event.timeStamp
            };
        };
        const onTouchStart = (event)=>onPointerDown(asPointer(event));
        const onTouchMove = (event)=>{
            onPointerMove(asPointer(event));
            if (isDragging) event.preventDefault();
        };
        const onTouchEnd = (event)=>endDrag(asPointer(event));
        node.addEventListener("touchstart", onTouchStart, {
            passive: true
        });
        node.addEventListener("touchmove", onTouchMove, {
            passive: false
        });
        node.addEventListener("touchend", onTouchEnd);
        node.addEventListener("touchcancel", onTouchEnd);
        return ()=>{
            stopMomentum();
            node.style.touchAction = previousTouchAction;
            node.removeEventListener("touchstart", onTouchStart);
            node.removeEventListener("touchmove", onTouchMove);
            node.removeEventListener("touchend", onTouchEnd);
            node.removeEventListener("touchcancel", onTouchEnd);
            node.removeEventListener("click", onClickCapture, true);
        };
    }, [
        element,
        enabled
    ]);
};
var $2b97c297394ec2fd$export$2e2bcd8739ae039 = $2b97c297394ec2fd$export$9a005dd890431a0a;


const $e81413a0b5db7291$var$animateAgreement = {
    initial: {
        x: "100%"
    },
    animate: {
        x: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        x: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $e81413a0b5db7291$var$AgreementDialog = (props)=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "previewPDF"
    ]);
    const { aggrements: aggrements, onDismiss: onDismiss, onAccept: onAccept } = props;
    const aggrement = aggrements[0];
    const [scroller, setScroller] = (0, $eZVvM.useState)(null);
    // The one scroll container of the dialog; ProDVX panels do not finger-scroll it natively.
    (0, $2b97c297394ec2fd$export$9a005dd890431a0a)(scroller);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
        mode: "wait",
        children: !!aggrement && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), {
            fullScreen: true,
            open: !!aggrement,
            transitionDuration: 0,
            component: (0, $d5f8329c0fec877c$export$e25e478948902b8b).div,
            ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($e81413a0b5db7291$var$animateAgreement),
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $4baac96c69466163$export$2e2bcd8739ae039), {
                    ref: setScroller,
                    dividers: true,
                    className: "p-0",
                    children: [
                        !!aggrement.text && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "mb-5",
                                    style: {
                                        fontSize: "5rem",
                                        color: "#000000"
                                    },
                                    children: aggrement.title
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    style: {
                                        fontSize: "3rem",
                                        color: "#000000"
                                    },
                                    children: aggrement.text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ead8f2bf5d3dae75$export$2e2bcd8739ae039), {
                            file: aggrement.file
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), {
                    className: "p-5",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-5 me-5 w",
                            onClick: onDismiss,
                            children: t("previewPDF:button.cancel")
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-5",
                            onClick: ()=>onAccept(aggrement.id),
                            children: aggrement.approvalRequired ? t("previewPDF:button.accept") : t("previewPDF:button.next")
                        })
                    ]
                })
            ]
        })
    });
};
var $e81413a0b5db7291$export$2e2bcd8739ae039 = $e81413a0b5db7291$var$AgreementDialog;



var $eZVvM = parcelRequire("eZVvM");

var $kvR7a = parcelRequire("kvR7a");

var $cD0nt = parcelRequire("cD0nt");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $cD0nt = parcelRequire("cD0nt");
const $df7836568f00d170$export$93d14698c0f75a24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $df7836568f00d170$export$5ed187c484559ae9 = ()=>(0, $eZVvM.useContext)($df7836568f00d170$export$93d14698c0f75a24);
const $df7836568f00d170$export$97bb174867dd5720 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    var _data_digitalReception_entranceAgreement, _data_digitalReception;
    const { children: children } = props;
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const { data: data } = (0, $cD0nt.default)();
    const [accepted, setAccepted] = (0, $eZVvM.useState)([]);
    (0, $eZVvM.useEffect)(()=>{
        if (pathname === "/") setAccepted((previous)=>previous.length ? [] : previous);
    }, [
        pathname
    ]);
    const agreementFiles = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_entranceAgreement = _data_digitalReception.entranceAgreement) === null || _data_digitalReception_entranceAgreement === void 0 ? void 0 : _data_digitalReception_entranceAgreement.files;
    /**
   * Warm the rendered pages while the screen is idle, so the dialog paints
   * from cache the moment someone checks in. The service worker keeps them
   * afterwards, which is also what makes the dialog work offline.
   */ (0, $eZVvM.useEffect)(()=>{
        (agreementFiles !== null && agreementFiles !== void 0 ? agreementFiles : []).forEach((file)=>{
            var _file_file;
            var _file_file_pages;
            ((_file_file_pages = (_file_file = file.file) === null || _file_file === void 0 ? void 0 : _file_file.pages) !== null && _file_file_pages !== void 0 ? _file_file_pages : []).forEach((page)=>{
                if (!page.absolutePath) return;
                const image = new Image();
                image.src = page.absolutePath;
            });
        });
    }, [
        agreementFiles
    ]);
    const accept = (0, $eZVvM.useCallback)((id)=>{
        setAccepted((previous)=>previous.includes(id) ? previous : [
                ...previous,
                id
            ]);
    }, []);
    const isAccepted = (0, $eZVvM.useCallback)((id)=>accepted.includes(id), [
        accepted
    ]);
    const value = (0, $eZVvM.useMemo)(()=>({
            accepted: accepted,
            accept: accept,
            isAccepted: isAccepted
        }), [
        accepted,
        accept,
        isAccepted
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($df7836568f00d170$export$93d14698c0f75a24.Provider, {
        value: value,
        children: children
    });
});


const $5e33a52931d48974$var$AUDIENCE_KEY_BY_MEMBER_TYPE = {
    Employee: "employee",
    Visitor: "visitor",
    Guest: "guest",
    MeetingAttendee: "meetingAttendee"
};
const $5e33a52931d48974$var$AUDIENCE_KEYS = [
    "employee",
    "visitor",
    "guest",
    "meetingAttendee"
];
const $5e33a52931d48974$var$isWithinValidityWindow = (target)=>{
    const { validFrom: validFrom, validUntil: validUntil } = target;
    if (validFrom && (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))().isBefore((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(validFrom).startOf("day"))) return false;
    if (validUntil && (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))().isAfter((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(validUntil).endOf("day"))) return false;
    return true;
};
/**
 * A document with no audience — or with every type ticked — can be shown before
 * anyone identifies themselves. Anything narrower has to wait until we know who
 * is standing at the screen.
 */ const $5e33a52931d48974$var$isForEveryone = (file)=>!file.audience || $5e33a52931d48974$var$AUDIENCE_KEYS.every((key)=>{
        var _file_audience_key, _file_audience;
        return ((_file_audience = file.audience) === null || _file_audience === void 0 ? void 0 : (_file_audience_key = _file_audience[key]) === null || _file_audience_key === void 0 ? void 0 : _file_audience_key.enabled) !== false;
    });
const $5e33a52931d48974$var$isForMemberType = (file, memberType)=>{
    var _file_audience_AUDIENCE_KEY_BY_MEMBER_TYPE_memberType, _file_audience;
    if (!memberType) return $5e33a52931d48974$var$isForEveryone(file);
    return ((_file_audience = file.audience) === null || _file_audience === void 0 ? void 0 : (_file_audience_AUDIENCE_KEY_BY_MEMBER_TYPE_memberType = _file_audience[$5e33a52931d48974$var$AUDIENCE_KEY_BY_MEMBER_TYPE[memberType]]) === null || _file_audience_AUDIENCE_KEY_BY_MEMBER_TYPE_memberType === void 0 ? void 0 : _file_audience_AUDIENCE_KEY_BY_MEMBER_TYPE_memberType.enabled) !== false;
};
const $5e33a52931d48974$export$991b23a188dc1bb5 = ()=>{
    var _data_digitalReception;
    const { data: data } = (0, $cD0nt.default)();
    const { isAccepted: isAccepted } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    const entranceAgreement = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.entranceAgreement;
    var _entranceAgreement_showFirst;
    const showFirst = (_entranceAgreement_showFirst = entranceAgreement === null || entranceAgreement === void 0 ? void 0 : entranceAgreement.showFirst) !== null && _entranceAgreement_showFirst !== void 0 ? _entranceAgreement_showFirst : false;
    /**
   * The agreement as a whole can be switched off or scheduled; either way none
   * of its documents are in play right now.
   */ const activeFiles = (0, $eZVvM.useMemo)(()=>{
        if (!entranceAgreement || entranceAgreement.disabled) return [];
        if (!$5e33a52931d48974$var$isWithinValidityWindow(entranceAgreement)) return [];
        var _entranceAgreement_files;
        return ((_entranceAgreement_files = entranceAgreement.files) !== null && _entranceAgreement_files !== void 0 ? _entranceAgreement_files : []).filter((file)=>!file.disabled && $5e33a52931d48974$var$isWithinValidityWindow(file));
    /**
     * The board is refetched every few minutes and hands back a new object each
     * time, which is what re-evaluates the window — a screen can sit on the same
     * page for days, and a document that expired overnight has to disappear.
     */ }, [
        entranceAgreement
    ]);
    const universalAgreements = (0, $eZVvM.useMemo)(()=>activeFiles.filter($5e33a52931d48974$var$isForEveryone).filter((file)=>!isAccepted(file.id)), [
        activeFiles,
        isAccepted
    ]);
    const hasRestrictedAgreements = (0, $eZVvM.useMemo)(()=>activeFiles.some((file)=>!$5e33a52931d48974$var$isForEveryone(file)), [
        activeFiles
    ]);
    const agreementsFor = (0, $eZVvM.useCallback)((memberType)=>activeFiles.filter((file)=>$5e33a52931d48974$var$isForMemberType(file, memberType)).filter((file)=>!isAccepted(file.id)), [
        activeFiles,
        isAccepted
    ]);
    return (0, $eZVvM.useMemo)(()=>{
        var _data_digitalReception;
        return {
            screen: (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.id) || "",
            showFirst: showFirst,
            universalAgreements: universalAgreements,
            hasRestrictedAgreements: hasRestrictedAgreements,
            agreementsFor: agreementsFor
        };
    }, [
        data,
        showFirst,
        universalAgreements,
        hasRestrictedAgreements,
        agreementsFor
    ]);
};




var $k9qks = parcelRequire("k9qks");

var $219y6 = parcelRequire("219y6");



var $eZVvM = parcelRequire("eZVvM");


var $cD0nt = parcelRequire("cD0nt");
const $af950ce5b1f47a3b$var$moveUp = (delay)=>({
        initial: {
            y: 150,
            opacity: 0
        },
        animate: {
            y: 0,
            opacity: 1,
            transition: {
                duration: 0.35,
                delay: delay,
                ease: "easeOut"
            }
        }
    });
const $af950ce5b1f47a3b$var$MoveUp = (props)=>{
    const { children: children, disabled: disabled, delay: delay } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, {
        ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($af950ce5b1f47a3b$var$moveUp(delay))
    });
};
var $af950ce5b1f47a3b$export$2e2bcd8739ae039 = $af950ce5b1f47a3b$var$MoveUp;


const $0428a1863c553843$var$Divider = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        backgroundColor: theme.palette.text.primary
    }));
const $0428a1863c553843$var$ScannerButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        fontSize: "2.5rem"
    }));
const $0428a1863c553843$export$75ee337032588709 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).input)(({ theme: theme })=>({
        color: theme.palette.text.primary,
        borderColor: theme.palette.primary.main,
        background: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).lighten(0.1).hex(),
        "&:focus": {
            borderColor: theme.palette.primary.main,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).darken(0.07).hex()
        },
        "&.error": {
            borderColor: theme.palette.error.main
        }
    }));
const $0428a1863c553843$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $0428a1863c553843$var$isMediaDevicesSupported = ()=>{
    const isMediaDevicesSupported = typeof navigator !== "undefined" && !!navigator.mediaDevices;
    return isMediaDevicesSupported;
};
const $0428a1863c553843$var$CheckPage = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "check"
    ]);
    const { action: action, code: code } = (0, $9B9bN.useParams)();
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/access\/${action}\/?$`).test(pathname);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const isCameraFeatureEnabled = (0, $eZVvM.useMemo)(()=>{
        const isNotFree = clientPlan && clientPlan !== "free";
        if (!isNotFree) return false;
        return $0428a1863c553843$var$isMediaDevicesSupported();
    }, [
        clientPlan
    ]);
    const { integratedManualCheckin: integratedManualCheckin, checkout: checkout, manualCheckout: manualCheckout } = (0, $cD0nt.useLayout)();
    const { isHidScannerActive: isHidScannerActive } = (0, $cD0nt.useHidScannerSettings)();
    const { isSocketScannerActive: isSocketScannerActive } = (0, $cD0nt.useSocketScannerSettings)();
    const isExternalScannerActive = isHidScannerActive || isSocketScannerActive;
    const [pinCode, setPinCode] = (0, (/*@__PURE__*/$parcel$interopDefault($ff7bcb23a771808b$exports)))($0428a1863c553843$var$defaultPinCode);
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const navigate = (0, $9B9bN.useNavigate)();
    const { showFirst: showFirst, universalAgreements: universalAgreements } = (0, $5e33a52931d48974$export$991b23a188dc1bb5)();
    const { accept: accept } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    /**
   * Nobody has identified themselves yet on this page, so only the documents
   * meant for every member type can go up here. The rest wait for the code.
   *
   * Derived rather than held in state: the board config can still be loading
   * when this mounts, and a list captured then would stay empty for good.
   */ const pendingAgreements = action === "checkin" && showFirst && mainRoute ? universalAgreements : [];
    // usePageTracking({
    //   page: action,
    // });
    // const { trackEvent } = useEventTracking();
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode({
                [focusedInput]: value
            });
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                var _document_activeElement;
                if (document.activeElement) (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            setPinCode(()=>({
                    [focusedInput]: ""
                }));
            const nextFocusedInput = Math.max(1, +focusedInput - 1);
            setFocusedInput(`${nextFocusedInput}`);
        }
    }, [
        focusedInput
    ]);
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, (/*@__PURE__*/$parcel$interopDefault($f896ef6492898da5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e93d02b5708fd941$exports)))(6), (acc, key)=>({
                ...acc,
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, []);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event;
        // trackEvent({ type: "input_focus", value: `pin_${action}` });
        setFocusedInput(`${+name}`);
        if (keyboard.current) keyboard.current.setInput("", name);
    }, []);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        /**
     * Blur when setting last input is set form keyboard
     */ if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, []);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault();
                    // eslint-disable-next-line prefer-destructuring
                    const name = (event === null || event === void 0 ? void 0 : event.currentTarget).name;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($0428a1863c553843$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 ? void 0 : element.addEventListener("beforeinput", onBeforeInput);
        });
        // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 ? void 0 : element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                {
                    event.preventDefault();
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    /**
   * Auto-focus input
   */ (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]);
    /**
   * Re-focus first input after we go back to this page.
   * Useful when we get back from code scan with an error
   */ (0, $eZVvM.useEffect)(()=>{
        if (!code && !focusedInput) setFocusedInput("1");
    }, [
        code
    ]);
    /**
   * Document-level fallback for HID barcode scanners (keyboard emulators).
   * If a digit keystroke arrives while no input/textarea is focused, redirect
   * it to the first empty PIN input so the scan isn't dropped.
   */ (0, $eZVvM.useEffect)(()=>{
        if (code) return;
        const onDocKeyDown = (event)=>{
            var _Object_getOwnPropertyDescriptor;
            if (event.ctrlKey || event.altKey || event.metaKey) return;
            if (event.key.length !== 1 || !/^\d$/.test(event.key)) return;
            const active = document.activeElement;
            const activeIsPinInput = active instanceof HTMLInputElement && /^[1-6]$/.test(active.name);
            // Don't interfere if focus is already inside a non-pin input (textarea,
            // manual entry, etc.) — that's user typing intentionally.
            if ((active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement) && !activeIsPinInput) return;
            // If focus is already in an empty pin input, let the browser handle it
            // normally — that's the happy path for a slow scan or manual entry.
            if (activeIsPinInput && active.value.length === 0) return;
            const inputs = [
                1,
                2,
                3,
                4,
                5,
                6
            ].map((i)=>document.querySelector(`input[name="${i}"]`)).filter((el)=>!!el);
            if (inputs.length === 0) return;
            const target = inputs.find((input)=>!input.value);
            if (!target) {
                event.preventDefault();
                return;
            }
            event.preventDefault();
            target.focus();
            const nativeSetter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.set;
            nativeSetter === null || nativeSetter === void 0 ? void 0 : nativeSetter.call(target, event.key);
            target.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        };
        document.addEventListener("keydown", onDocKeyDown);
        // eslint-disable-next-line consistent-return
        return ()=>{
            document.removeEventListener("keydown", onDocKeyDown);
        };
    }, [
        code
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const pinCodeArr = Object.values(pinCode);
        const timeout = setTimeout(()=>{
            if (pinCodeArr.every((input)=>input !== "")) {
                var _document_activeElement;
                navigate({
                    pathname: `${pinCodeArr.join("")}`
                });
                // setPinCode(defaultPinCode);
                setFocusedInput(undefined);
                if (document.activeElement) (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
            }
        }, 500);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pinCode
    ]);
    const backLink = (0, $eZVvM.useMemo)(()=>{
        if (action === "checkin" && (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled)) return "/access/option/checkin";
        if (action === "checkout" && (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) && (manualCheckout === null || manualCheckout === void 0 ? void 0 : manualCheckout.enabled)) return "/access/option/checkout";
        return "/";
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: backLink
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        disableAnimation: !mainRoute,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h1",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: (()=>{
                                    if (isHidScannerActive) return "check:hidScanner.title";
                                    if (isSocketScannerActive) return "check:title";
                                    if (isCameraFeatureEnabled) return `check:qrScanner.${action}.title`;
                                    return "check:pinOnly.title";
                                })()
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        className: "check-options",
                        children: [
                            isCameraFeatureEnabled && !isExternalScannerActive && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                        disabled: !mainRoute,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($0428a1863c553843$var$ScannerButton, {
                                                variant: "contained",
                                                disabled: !online,
                                                onClick: ()=>{
                                                    // trackEvent({ type: "scan_button_click", value: action });
                                                    navigate(`/scanner/${action}`);
                                                },
                                                children: t("check:qrScanner.btn")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                                        className: "divider d-flex align-items-center mx-auto",
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)($0428a1863c553843$var$Divider, {
                                                className: "col dropdown-divider"
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h4",
                                                className: "col-auto px-5",
                                                children: t("check:orText")
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)($0428a1863c553843$var$Divider, {
                                                className: "col dropdown-divider"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsxs)("form", {
                                className: "pin__wrapper",
                                autoComplete: "off",
                                children: [
                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3f3108db7148688c$export$2e2bcd8739ae039), {
                                        className: "mx-auto",
                                        disabled: !mainRoute,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                            variant: "h4",
                                            className: "font-weight-regular pin__title w-100",
                                            children: t("check:pinCode")
                                        })
                                    }),
                                    [
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6
                                    ].map((i)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $af950ce5b1f47a3b$export$2e2bcd8739ae039), {
                                            disabled: !mainRoute,
                                            delay: 0.15 + 0.05 * i,
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($0428a1863c553843$export$75ee337032588709, {
                                                id: `${i}`,
                                                name: `${i}`,
                                                min: 0,
                                                max: 9,
                                                type: (0, $k9qks.isVirtualKeyboardEnabled) ? "text" : "number",
                                                className: "pin__input",
                                                autoComplete: "chrome-off",
                                                onFocus: onFocus,
                                                onChange: onChange,
                                                onKeyDown: onKeyDown,
                                                onPasteCapture: onPasteCapture,
                                                value: pinCode[i],
                                                maxLength: 1,
                                                pattern: "[0-9]*"
                                            })
                                        }, i))
                                ]
                            })
                        ]
                    }),
                    (0, $k9qks.isVirtualKeyboardEnabled) && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        ref: keyboardBox,
                        className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                            keyboard__out: !focusedInput
                        }),
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                            ref: keyboard,
                            disableButtonHold: true,
                            layoutName: "pin",
                            inputName: focusedInput,
                            onChange: onKeyboardChange,
                            onKeyPress: onKeyboardKeyPress
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e81413a0b5db7291$export$2e2bcd8739ae039), {
                aggrements: pendingAgreements,
                onDismiss: ()=>{
                    navigate("/");
                },
                onAccept: accept
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {})
        ]
    });
};
var $0428a1863c553843$export$2e2bcd8739ae039 = $0428a1863c553843$var$CheckPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");




var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $bf84313ce63ae7d0$var$SvgCode = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M73.333 23.333H6.667A6.673 6.673 0 0 0 0 30v20a6.673 6.673 0 0 0 6.667 6.667h66.666A6.673 6.673 0 0 0 80 50V30a6.673 6.673 0 0 0-6.667-6.667ZM76.667 50a3.338 3.338 0 0 1-3.334 3.333H6.667A3.338 3.338 0 0 1 3.333 50V30a3.338 3.338 0 0 1 3.334-3.333h66.666A3.338 3.338 0 0 1 76.667 30v20Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M20.773 36.667a1.667 1.667 0 0 0-2.277-.61l-1.83 1.056V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.829-1.057a1.666 1.666 0 1 0-1.667 2.887L11.667 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45a1.666 1.666 0 1 0 3.333 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.611-2.278L18.333 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277ZM37.44 36.667a1.667 1.667 0 0 0-2.277-.61l-1.83 1.056V35A1.666 1.666 0 1 0 30 35v2.113l-1.83-1.057a1.666 1.666 0 1 0-1.667 2.887L28.334 40l-1.829 1.056a1.667 1.667 0 1 0 1.667 2.888L30 42.887V45a1.666 1.666 0 1 0 3.332 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.61-2.278L35 40l1.83-1.056a1.666 1.666 0 0 0 .61-2.277ZM54.106 36.667a1.667 1.667 0 0 0-2.277-.61L50 37.112V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.83-1.057a1.666 1.666 0 1 0-1.667 2.887L45 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45A1.666 1.666 0 1 0 50 45v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.61-2.278L51.666 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277ZM70.773 36.667a1.666 1.666 0 0 0-2.277-.61l-1.83 1.056V35a1.666 1.666 0 1 0-3.333 0v2.113l-1.829-1.057a1.666 1.666 0 1 0-1.667 2.887L61.667 40l-1.83 1.056a1.667 1.667 0 1 0 1.667 2.888l1.83-1.057V45a1.666 1.666 0 1 0 3.333 0v-2.113l1.83 1.057a1.665 1.665 0 0 0 2.277-.61 1.667 1.667 0 0 0-.611-2.278L68.333 40l1.83-1.056c.797-.46 1.07-1.48.61-2.277Z"
            })
        ]
    });
var $bf84313ce63ae7d0$export$2e2bcd8739ae039 = $bf84313ce63ae7d0$var$SvgCode;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $290a81f72ffb3053$var$SvgManual = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 81 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M33.125 55.932c2.8-1.774 4.675-4.879 4.675-8.432 0-5.515-4.486-10-10-10s-10 4.485-10 10c0 3.553 1.875 6.658 4.674 8.432a17.09 17.09 0 0 0-9.358 7.852 2.5 2.5 0 1 0 4.368 2.432C19.619 62.383 23.57 60 27.8 60c4.228 0 8.181 2.383 10.316 6.216.651 1.169 2.204 1.63 3.4.969a2.5 2.5 0 0 0 .968-3.401 17.09 17.09 0 0 0-9.359-7.852ZM27.8 42.5c2.757 0 5 2.244 5 5s-2.243 5-5 5c-2.758 0-5-2.244-5-5s2.242-5 5-5Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M70.3 15h-20V7.5c0-2.756-2.243-5-5-5h-10c-2.758 0-5 2.244-5 5V15h-20c-4.136 0-7.5 3.364-7.5 7.5V70c0 4.136 3.364 7.5 7.5 7.5h60c4.136 0 7.5-3.364 7.5-7.5V22.5c0-4.136-3.364-7.5-7.5-7.5Zm-35-7.5h10l.004 9.982c0 .006-.004.012-.004.018h-10v-10ZM30.996 20c.867 1.487 2.461 2.5 4.304 2.5h10c1.842 0 3.437-1.013 4.304-2.5H52.8v5c0 1.38-1.122 2.5-2.5 2.5h-20c-1.378 0-2.5-1.12-2.5-2.5v-5h3.196ZM72.8 70c0 1.38-1.122 2.5-2.5 2.5h-60c-1.378 0-2.5-1.12-2.5-2.5V22.5c0-1.38 1.122-2.5 2.5-2.5h12.5v5c0 4.136 3.364 7.5 7.5 7.5h20c4.136 0 7.5-3.364 7.5-7.5v-5h12.5c1.378 0 2.5 1.12 2.5 2.5V70Z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M65.3 40H47.8a2.5 2.5 0 1 0 0 5h17.5a2.5 2.5 0 1 0 0-5ZM65.3 50h-15a2.5 2.5 0 1 0 0 5h15a2.5 2.5 0 1 0 0-5ZM65.3 60H52.8a2.5 2.5 0 1 0 0 5h12.5a2.5 2.5 0 1 0 0-5Z"
            })
        ]
    });
var $290a81f72ffb3053$export$2e2bcd8739ae039 = $290a81f72ffb3053$var$SvgManual;









var $cD0nt = parcelRequire("cD0nt");


var $219y6 = parcelRequire("219y6");

const $95520ba8aabd9a50$var$MUIOptionButtonGroup = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)("div", {
    shouldForwardProp: (prop)=>prop !== "count"
})(({ count: count = 2 })=>({
        maxWidth: "90.4rem",
        width: "96%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "4.8rem 0 2.4rem",
        "@media screen and (orientation: landscape)": {
            maxWidth: "180.8rem",
            flexDirection: "row",
            padding: "0",
            "> div": {
                width: `${100 / Math.max(count, 2)}%`
            }
        }
    }));
const $95520ba8aabd9a50$export$7a47e935b0481fac = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).button)(({ theme: theme })=>({
        position: "relative",
        width: "90%",
        height: "16rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "2.25rem 0 3.5rem",
        borderRadius: "1rem",
        border: `0.2rem solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.main,
        ":hover": {
            backgroundColor: theme.palette.primary.dark,
            border: `0.2rem solid ${theme.palette.primary.dark}`
        },
        svg: {
            position: "absolute",
            left: "4rem",
            fill: theme.palette.primary.contrastText
        },
        h3: {
            color: theme.palette.primary.contrastText,
            margin: "0 12rem"
        },
        "@media screen and (orientation: landscape)": {
            height: "14rem",
            margin: "0 1rem 6.4rem 6rem"
        }
    }));
const $95520ba8aabd9a50$var$LOGO_LEFT = "4rem";
const $95520ba8aabd9a50$var$DEFAULT_LOGO_WIDTH = "8rem";
const $95520ba8aabd9a50$export$a8bc6dccdc09aece = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)($95520ba8aabd9a50$export$7a47e935b0481fac, {
    shouldForwardProp: (prop)=>prop !== "overlayColor" && prop !== "frameColor" && prop !== "logoBackgroundColor" && prop !== "logoWidth"
})(({ overlayColor: overlayColor, frameColor: frameColor, logoBackgroundColor: logoBackgroundColor, logoWidth: logoWidth = $95520ba8aabd9a50$var$DEFAULT_LOGO_WIDTH })=>{
    const colors = {
        ...logoBackgroundColor ? {
            backgroundColor: logoBackgroundColor
        } : {},
        ...frameColor ? {
            borderColor: frameColor
        } : {}
    };
    return {
        overflow: "hidden",
        ...colors,
        ":hover": colors,
        ":active": colors,
        ...overlayColor ? {
            "::after": {
                content: '""',
                position: "absolute",
                inset: 0,
                backgroundColor: overlayColor
            }
        } : {},
        svg: {
            zIndex: 1,
            maxHeight: "10rem"
        },
        h3: {
            position: "relative",
            zIndex: 1,
            margin: `0 calc(${$95520ba8aabd9a50$var$LOGO_LEFT} + ${logoWidth})`
        },
        ":disabled": {
            opacity: 0.5
        }
    };
});
const $95520ba8aabd9a50$var$CheckOptions = ()=>{
    var _metadata_uiOverrides_home_flows_action_title, _metadata_uiOverrides_home_flows_action, _metadata_uiOverrides_home_flows, _metadata_uiOverrides_home, _metadata_uiOverrides, _metadata_uiOverrides_home_flows_action_buttons_code, _metadata_uiOverrides_home_flows_action_buttons, _metadata_uiOverrides_home_flows_action1, _metadata_uiOverrides_home_flows1, _metadata_uiOverrides_home1, _metadata_uiOverrides1, _metadata_uiOverrides_home_flows_action_buttons_manual, _metadata_uiOverrides_home_flows_action_buttons1, _metadata_uiOverrides_home_flows_action2, _metadata_uiOverrides_home_flows2, _metadata_uiOverrides_home2, _metadata_uiOverrides2;
    const navigate = (0, $9B9bN.useNavigate)();
    const { action: action } = (0, $9B9bN.useParams)();
    const { t: t } = (0, $9GLBV.useTranslation)();
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const { isHidScannerActive: isHidScannerActive } = (0, $cD0nt.useHidScannerSettings)();
    const { isSocketScannerActive: isSocketScannerActive } = (0, $cD0nt.useSocketScannerSettings)();
    const hasCameraScanner = clientPlan !== "free" && typeof navigator !== "undefined" && !!navigator.mediaDevices;
    const hasAnyQrScanner = isHidScannerActive || isSocketScannerActive || hasCameraScanner;
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const title = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides = metadata.uiOverrides) === null || _metadata_uiOverrides === void 0 ? void 0 : (_metadata_uiOverrides_home = _metadata_uiOverrides.home) === null || _metadata_uiOverrides_home === void 0 ? void 0 : (_metadata_uiOverrides_home_flows = _metadata_uiOverrides_home.flows) === null || _metadata_uiOverrides_home_flows === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action = _metadata_uiOverrides_home_flows[action]) === null || _metadata_uiOverrides_home_flows_action === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action_title = _metadata_uiOverrides_home_flows_action.title) === null || _metadata_uiOverrides_home_flows_action_title === void 0 ? void 0 : _metadata_uiOverrides_home_flows_action_title[language];
    const codeText = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides1 = metadata.uiOverrides) === null || _metadata_uiOverrides1 === void 0 ? void 0 : (_metadata_uiOverrides_home1 = _metadata_uiOverrides1.home) === null || _metadata_uiOverrides_home1 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows1 = _metadata_uiOverrides_home1.flows) === null || _metadata_uiOverrides_home_flows1 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action1 = _metadata_uiOverrides_home_flows1[action]) === null || _metadata_uiOverrides_home_flows_action1 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action_buttons = _metadata_uiOverrides_home_flows_action1.buttons) === null || _metadata_uiOverrides_home_flows_action_buttons === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action_buttons_code = _metadata_uiOverrides_home_flows_action_buttons.code) === null || _metadata_uiOverrides_home_flows_action_buttons_code === void 0 ? void 0 : _metadata_uiOverrides_home_flows_action_buttons_code[language];
    const manualText = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides2 = metadata.uiOverrides) === null || _metadata_uiOverrides2 === void 0 ? void 0 : (_metadata_uiOverrides_home2 = _metadata_uiOverrides2.home) === null || _metadata_uiOverrides_home2 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows2 = _metadata_uiOverrides_home2.flows) === null || _metadata_uiOverrides_home_flows2 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action2 = _metadata_uiOverrides_home_flows2[action]) === null || _metadata_uiOverrides_home_flows_action2 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action_buttons1 = _metadata_uiOverrides_home_flows_action2.buttons) === null || _metadata_uiOverrides_home_flows_action_buttons1 === void 0 ? void 0 : (_metadata_uiOverrides_home_flows_action_buttons_manual = _metadata_uiOverrides_home_flows_action_buttons1.manual) === null || _metadata_uiOverrides_home_flows_action_buttons_manual === void 0 ? void 0 : _metadata_uiOverrides_home_flows_action_buttons_manual[language];
    const { online: online } = (0, $219y6.useOfflineContext)();
    const extraButtons = (0, $cD0nt.useCheckFlowExtraButtons)(action);
    const communicationProvider = (0, $cD0nt.useCommunicationProvider)();
    const isTeamsExtraButton = (0, $eZVvM.useCallback)((button)=>{
        var _button_phone;
        return communicationProvider === "teams" && !((_button_phone = button.phone) === null || _button_phone === void 0 ? void 0 : _button_phone.trim());
    }, [
        communicationProvider
    ]);
    const extraButtonEmails = (0, $eZVvM.useMemo)(()=>extraButtons.filter(isTeamsExtraButton).map((button)=>button.email).filter((email)=>!!(email === null || email === void 0 ? void 0 : email.trim())), [
        extraButtons,
        isTeamsExtraButton
    ]);
    const { callerAcsToken: callerAcsToken, data: teamsData } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: extraButtonEmails
    });
    const visibleExtraButtons = (0, $eZVvM.useMemo)(()=>extraButtons.filter((button)=>{
            var _button_email, _button_phone;
            return isTeamsExtraButton(button) ? !!((_button_email = button.email) === null || _button_email === void 0 ? void 0 : _button_email.trim()) : !!((_button_phone = button.phone) === null || _button_phone === void 0 ? void 0 : _button_phone.trim());
        }), [
        extraButtons,
        isTeamsExtraButton
    ]);
    const getTargetTeamsUser = (0, $eZVvM.useCallback)((email)=>{
        var _teamsData_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers, _teamsData_getCallerAcsTokenAndTargetTeamsUserIds;
        return teamsData === null || teamsData === void 0 ? void 0 : (_teamsData_getCallerAcsTokenAndTargetTeamsUserIds = teamsData.getCallerAcsTokenAndTargetTeamsUserIds) === null || _teamsData_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : (_teamsData_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers = _teamsData_getCallerAcsTokenAndTargetTeamsUserIds.targetTeamsUsers) === null || _teamsData_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers === void 0 ? void 0 : _teamsData_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers.find((targetTeamsUser)=>targetTeamsUser.email === email);
    }, [
        teamsData
    ]);
    const isExtraButtonDisabled = (0, $eZVvM.useCallback)((button)=>{
        var _button_phone;
        if (!online) return true;
        if (isTeamsExtraButton(button)) {
            var _targetTeamsUser_teamsUsers_, _targetTeamsUser_teamsUsers;
            const targetTeamsUser = getTargetTeamsUser(button.email);
            if (!targetTeamsUser) return true;
            return !targetTeamsUser.isGroup && !((_targetTeamsUser_teamsUsers = targetTeamsUser.teamsUsers) === null || _targetTeamsUser_teamsUsers === void 0 ? void 0 : (_targetTeamsUser_teamsUsers_ = _targetTeamsUser_teamsUsers[0]) === null || _targetTeamsUser_teamsUsers_ === void 0 ? void 0 : _targetTeamsUser_teamsUsers_.teamsUserId);
        }
        return !((_button_phone = button.phone) === null || _button_phone === void 0 ? void 0 : _button_phone.trim());
    }, [
        online,
        isTeamsExtraButton,
        getTargetTeamsUser
    ]);
    const handleClickExtraButton = (0, $eZVvM.useCallback)((button)=>{
        if (isTeamsExtraButton(button)) {
            var _targetTeamsUser_teamsUsers;
            const targetTeamsUser = getTargetTeamsUser(button.email);
            const targetTeamsUserIds = targetTeamsUser === null || targetTeamsUser === void 0 ? void 0 : (_targetTeamsUser_teamsUsers = targetTeamsUser.teamsUsers) === null || _targetTeamsUser_teamsUsers === void 0 ? void 0 : _targetTeamsUser_teamsUsers.map((user)=>user.teamsUserId).filter(Boolean).join(",");
            return navigate(`/${button.teamsCall === "video" ? "teams-video" : `access/option/${action}/teams-audio`}-${(targetTeamsUser === null || targetTeamsUser === void 0 ? void 0 : targetTeamsUser.isGroup) ? "group-" : ""}call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                callerAcsToken: callerAcsToken,
                targetTeamsUserIds: targetTeamsUserIds
            })}`, {
                replace: true
            });
        }
        return navigate(`/access/option/${action}/contact/extra-${button.id}/call`, {
            replace: true
        });
    }, [
        action,
        navigate,
        isTeamsExtraButton,
        getTargetTeamsUser,
        callerAcsToken
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: "/"
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        className: "page-title home",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h1",
                            children: title || t(`check:option.${action}.title`)
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)($95520ba8aabd9a50$var$MUIOptionButtonGroup, {
                        count: 2 + visibleExtraButtons.length,
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $bhfvP.jsxs)($95520ba8aabd9a50$export$7a47e935b0481fac, {
                                    onClick: ()=>{
                                        return navigate(`/access/${action}`, {
                                            replace: true
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bf84313ce63ae7d0$export$2e2bcd8739ae039), {
                                            width: "8rem"
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                            variant: "h3",
                                            children: codeText || t(`check:option.${action}.code${hasAnyQrScanner ? "" : "-no-qr"}`)
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $bhfvP.jsxs)($95520ba8aabd9a50$export$7a47e935b0481fac, {
                                    onClick: ()=>{
                                        return navigate(`/access/${action}/manual`, {
                                            replace: true
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $290a81f72ffb3053$export$2e2bcd8739ae039), {
                                            width: "8rem"
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                            variant: "h3",
                                            children: manualText || t(`check:option.${action}.manual`)
                                        })
                                    ]
                                })
                            }),
                            visibleExtraButtons.map((button)=>{
                                var _button_icon, _button_icon1, _button_label, _button_label1, _button_label2, _button_label3;
                                return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($95520ba8aabd9a50$export$a8bc6dccdc09aece, {
                                        disabled: isExtraButtonDisabled(button),
                                        overlayColor: button.overlayColor,
                                        frameColor: button.borderColor || button.overlayColor,
                                        logoBackgroundColor: button.backgroundColor,
                                        logoWidth: (_button_icon = button.icon) === null || _button_icon === void 0 ? void 0 : _button_icon.width,
                                        onClick: ()=>handleClickExtraButton(button),
                                        children: [
                                            !!((_button_icon1 = button.icon) === null || _button_icon1 === void 0 ? void 0 : _button_icon1.svg) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                                id: button.icon.svg,
                                                width: button.icon.width || $95520ba8aabd9a50$var$DEFAULT_LOGO_WIDTH
                                            }),
                                            !!(((_button_label = button.label) === null || _button_label === void 0 ? void 0 : _button_label[language]) || ((_button_label1 = button.label) === null || _button_label1 === void 0 ? void 0 : _button_label1.en)) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: ((_button_label2 = button.label) === null || _button_label2 === void 0 ? void 0 : _button_label2[language]) || ((_button_label3 = button.label) === null || _button_label3 === void 0 ? void 0 : _button_label3.en)
                                            })
                                        ]
                                    })
                                }, button.id);
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $95520ba8aabd9a50$export$2e2bcd8739ae039 = $95520ba8aabd9a50$var$CheckOptions;


/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $bhfvP = parcelRequire("bhfvP");

var $aNuUP = parcelRequire("aNuUP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $eZVvM = parcelRequire("eZVvM");
var $afb237382692687d$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $afb237382692687d$var$isDateObject = (value1)=>value1 instanceof Date;
var $afb237382692687d$var$isNullOrUndefined = (value1)=>value1 == null;
const $afb237382692687d$var$isObjectType = (value1)=>typeof value1 === "object";
var $afb237382692687d$var$isObject = (value1)=>!$afb237382692687d$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $afb237382692687d$var$isObjectType(value1) && !$afb237382692687d$var$isDateObject(value1);
var $afb237382692687d$var$getEventValue = (event)=>$afb237382692687d$var$isObject(event) && event.target ? $afb237382692687d$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $afb237382692687d$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $afb237382692687d$var$isNameInFieldArray = (names, name)=>names.has($afb237382692687d$var$getNodeParentName(name));
var $afb237382692687d$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $afb237382692687d$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $afb237382692687d$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $afb237382692687d$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($afb237382692687d$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $afb237382692687d$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$afb237382692687d$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $afb237382692687d$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $afb237382692687d$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $afb237382692687d$var$isUndefined = (val)=>val === undefined;
var $afb237382692687d$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$afb237382692687d$var$isObject(object)) return defaultValue;
    const result = $afb237382692687d$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$afb237382692687d$var$isNullOrUndefined(result) ? result : result[key], object);
    return $afb237382692687d$var$isUndefined(result) || result === object ? $afb237382692687d$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $afb237382692687d$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $afb237382692687d$var$isKey = (value1)=>/^\w*$/.test(value1);
var $afb237382692687d$var$stringToPath = (input)=>$afb237382692687d$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
var $afb237382692687d$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $afb237382692687d$var$isKey(path) ? [
        path
    ] : $afb237382692687d$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $afb237382692687d$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === "__proto__") return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $afb237382692687d$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $afb237382692687d$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $afb237382692687d$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $afb237382692687d$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afb237382692687d$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useContext($afb237382692687d$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $afb237382692687d$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement($afb237382692687d$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $afb237382692687d$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $afb237382692687d$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $afb237382692687d$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $afb237382692687d$var$isEmptyObject = (value1)=>$afb237382692687d$var$isObject(value1) && !Object.keys(value1).length;
var $afb237382692687d$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $afb237382692687d$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $afb237382692687d$var$VALIDATION_MODE.all));
};
var $afb237382692687d$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $afb237382692687d$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $afb237382692687d$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $afb237382692687d$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$606f11b2eb45ecc6(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    _name.current = name;
    $afb237382692687d$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $afb237382692687d$var$shouldSubscribeByName(_name.current, value1.name, exact) && $afb237382692687d$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $afb237382692687d$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $afb237382692687d$var$isString = (value1)=>typeof value1 === "string";
var $afb237382692687d$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($afb237382692687d$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $afb237382692687d$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $afb237382692687d$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $afb237382692687d$export$3c773aa2b84f29e0(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    _name.current = name;
    $afb237382692687d$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($afb237382692687d$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($afb237382692687d$var$cloneObject($afb237382692687d$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$e8c786024a2b0a79(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $afb237382692687d$var$isNameInFieldArray(control._names.array, name);
    const value1 = $afb237382692687d$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $afb237382692687d$export$3988ae62b71be9a3(control._formValues, name, $afb237382692687d$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $afb237382692687d$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$afb237382692687d$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $afb237382692687d$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($afb237382692687d$var$isUndefined($afb237382692687d$export$3988ae62b71be9a3(control._formValues, name))) $afb237382692687d$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $afb237382692687d$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$afb237382692687d$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $afb237382692687d$var$getEventValue(event),
                        name: name
                    },
                    type: $afb237382692687d$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $afb237382692687d$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $afb237382692687d$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((elm)=>{
                const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$afb237382692687d$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$afb237382692687d$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $afb237382692687d$export$bd0bf19f25da8474 = (props)=>props.render($afb237382692687d$export$e8c786024a2b0a79(props));
const $afb237382692687d$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($afb237382692687d$var$isObjectType(obj[key])) {
        const nested = $afb237382692687d$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $afb237382692687d$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$a7fed597f4b8afd8(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $afb237382692687d$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $afb237382692687d$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $afb237382692687d$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $afb237382692687d$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $afb237382692687d$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $afb237382692687d$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$afb237382692687d$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $afb237382692687d$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $afb237382692687d$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $afb237382692687d$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $afb237382692687d$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $afb237382692687d$var$VALIDATION_MODE.all,
        isOnTouch: mode === $afb237382692687d$var$VALIDATION_MODE.onTouched
    });
var $afb237382692687d$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $afb237382692687d$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $afb237382692687d$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($afb237382692687d$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($afb237382692687d$var$isObject(currentField)) {
                if ($afb237382692687d$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $afb237382692687d$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$export$3988ae62b71be9a3(errors, name));
    $afb237382692687d$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $afb237382692687d$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $afb237382692687d$var$isFileInput = (element)=>element.type === "file";
var $afb237382692687d$var$isFunction = (value1)=>typeof value1 === "function";
var $afb237382692687d$var$isHTMLElement = (value1)=>{
    if (!$afb237382692687d$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $afb237382692687d$var$isMessage = (value1)=>$afb237382692687d$var$isString(value1);
var $afb237382692687d$var$isRadioInput = (element)=>element.type === "radio";
var $afb237382692687d$var$isRegex = (value1)=>value1 instanceof RegExp;
const $afb237382692687d$var$defaultResult = {
    value: false,
    isValid: false
};
const $afb237382692687d$var$validResult = {
    value: true,
    isValid: true
};
var $afb237382692687d$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$afb237382692687d$var$isUndefined(options[0].attributes.value) ? $afb237382692687d$var$isUndefined(options[0].value) || options[0].value === "" ? $afb237382692687d$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $afb237382692687d$var$validResult : $afb237382692687d$var$defaultResult;
    }
    return $afb237382692687d$var$defaultResult;
};
const $afb237382692687d$var$defaultReturn = {
    isValid: false,
    value: null
};
var $afb237382692687d$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $afb237382692687d$var$defaultReturn) : $afb237382692687d$var$defaultReturn;
function $afb237382692687d$var$getValidateError(result, ref, type = "validate") {
    if ($afb237382692687d$var$isMessage(result) || Array.isArray(result) && result.every($afb237382692687d$var$isMessage) || $afb237382692687d$var$isBoolean(result) && !result) return {
        type: type,
        message: $afb237382692687d$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $afb237382692687d$var$getValueAndMessage = (validationData)=>$afb237382692687d$var$isObject(validationData) && !$afb237382692687d$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $afb237382692687d$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $afb237382692687d$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($afb237382692687d$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $afb237382692687d$var$isRadioInput(ref);
    const isCheckBox = $afb237382692687d$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $afb237382692687d$var$isFileInput(ref)) && $afb237382692687d$var$isUndefined(ref.value) && $afb237382692687d$var$isUndefined(inputValue) || $afb237382692687d$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $afb237382692687d$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $afb237382692687d$var$INPUT_VALIDATION_RULES.maxLength, minType = $afb237382692687d$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $afb237382692687d$var$isNullOrUndefined(inputValue)) || $afb237382692687d$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$afb237382692687d$var$getCheckboxValue(refs).isValid || isRadio && !$afb237382692687d$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $afb237382692687d$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $afb237382692687d$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $afb237382692687d$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$afb237382692687d$var$isNullOrUndefined(min) || !$afb237382692687d$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $afb237382692687d$var$getValueAndMessage(max);
        const minOutput = $afb237382692687d$var$getValueAndMessage(min);
        if (!$afb237382692687d$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$afb237382692687d$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$afb237382692687d$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($afb237382692687d$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($afb237382692687d$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $afb237382692687d$var$INPUT_VALIDATION_RULES.max, $afb237382692687d$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($afb237382692687d$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $afb237382692687d$var$getValueAndMessage(maxLength);
        const minLengthOutput = $afb237382692687d$var$getValueAndMessage(minLength);
        const exceedMax = !$afb237382692687d$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$afb237382692687d$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $afb237382692687d$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $afb237382692687d$var$getValueAndMessage(pattern);
        if ($afb237382692687d$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $afb237382692687d$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($afb237382692687d$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $afb237382692687d$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($afb237382692687d$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($afb237382692687d$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$afb237382692687d$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $afb237382692687d$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$afb237382692687d$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $afb237382692687d$var$appendAt = (data, value1)=>[
        ...data,
        ...$afb237382692687d$var$convertToArrayPayload(value1)
    ];
var $afb237382692687d$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $afb237382692687d$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$afb237382692687d$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $afb237382692687d$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($afb237382692687d$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $afb237382692687d$var$prependAt = (data, value1)=>[
        ...$afb237382692687d$var$convertToArrayPayload(value1),
        ...$afb237382692687d$var$convertToArrayPayload(data)
    ];
function $afb237382692687d$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $afb237382692687d$var$compact(temp).length ? temp : [];
}
var $afb237382692687d$var$removeArrayAt = (data, index)=>$afb237382692687d$var$isUndefined(index) ? [] : $afb237382692687d$var$removeAtIndexes(data, $afb237382692687d$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $afb237382692687d$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $afb237382692687d$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $afb237382692687d$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $afb237382692687d$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$afb237382692687d$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $afb237382692687d$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $afb237382692687d$var$isKey(path) ? [
        path
    ] : $afb237382692687d$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $afb237382692687d$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($afb237382692687d$var$isObject(childObject) && $afb237382692687d$var$isEmptyObject(childObject) || Array.isArray(childObject) && $afb237382692687d$var$isEmptyArray(childObject))) $afb237382692687d$var$unset(object, paths.slice(0, -1));
    return object;
}
var $afb237382692687d$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$310131896651d559(props) {
    const methods = $afb237382692687d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(control._getFieldArray(name).map($afb237382692687d$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $afb237382692687d$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $afb237382692687d$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($afb237382692687d$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $afb237382692687d$var$appendAt(ids.current, appendValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$appendAt, {
            argA: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, 0, options);
        ids.current = $afb237382692687d$var$prependAt(ids.current, prependValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$prependAt, {
            argA: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $afb237382692687d$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $afb237382692687d$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        const updatedFieldArrayValues = $afb237382692687d$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $afb237382692687d$var$getFocusFieldName(name, index, options);
        ids.current = $afb237382692687d$var$insert(ids.current, index, insertValue.map($afb237382692687d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$insert, {
            argA: index,
            argB: $afb237382692687d$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afb237382692687d$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $afb237382692687d$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $afb237382692687d$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $afb237382692687d$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $afb237382692687d$var$cloneObject(value1);
        const updatedFieldArrayValues = $afb237382692687d$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $afb237382692687d$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $afb237382692687d$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $afb237382692687d$var$convertToArrayPayload($afb237382692687d$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($afb237382692687d$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        control._state.action = false;
        $afb237382692687d$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$afb237382692687d$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $afb237382692687d$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $afb237382692687d$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $afb237382692687d$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $afb237382692687d$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $afb237382692687d$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($afb237382692687d$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $afb237382692687d$var$getValidationModes(control._options.mode).isOnSubmit)) $afb237382692687d$var$validateField(field, control._formValues, control._options.criteriaMode === $afb237382692687d$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$afb237382692687d$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $afb237382692687d$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $afb237382692687d$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        !$afb237382692687d$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $afb237382692687d$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $afb237382692687d$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $afb237382692687d$var$isPrimitive = (value1)=>$afb237382692687d$var$isNullOrUndefined(value1) || !$afb237382692687d$var$isObjectType(value1);
function $afb237382692687d$var$deepEqual(object1, object2) {
    if ($afb237382692687d$var$isPrimitive(object1) || $afb237382692687d$var$isPrimitive(object2)) return object1 === object2;
    if ($afb237382692687d$var$isDateObject(object1) && $afb237382692687d$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($afb237382692687d$var$isDateObject(val1) && $afb237382692687d$var$isDateObject(val2) || $afb237382692687d$var$isObject(val1) && $afb237382692687d$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$afb237382692687d$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $afb237382692687d$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $afb237382692687d$var$isRadioOrCheckbox = (ref)=>$afb237382692687d$var$isRadioInput(ref) || $afb237382692687d$var$isCheckBoxInput(ref);
var $afb237382692687d$var$live = (ref)=>$afb237382692687d$var$isHTMLElement(ref) && ref.isConnected;
var $afb237382692687d$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($afb237382692687d$var$isFunction(data[key])) return true;
    }
    return false;
};
function $afb237382692687d$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($afb237382692687d$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $afb237382692687d$var$isObject(data[key]) && !$afb237382692687d$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $afb237382692687d$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$afb237382692687d$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $afb237382692687d$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($afb237382692687d$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $afb237382692687d$var$isObject(data[key]) && !$afb237382692687d$var$objectHasFunction(data[key])) {
            if ($afb237382692687d$var$isUndefined(formValues) || $afb237382692687d$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $afb237382692687d$var$markFieldsDirty(data[key], []) : {
                ...$afb237382692687d$var$markFieldsDirty(data[key])
            };
            else $afb237382692687d$var$getDirtyFieldsFromDefaultValues(data[key], $afb237382692687d$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$afb237382692687d$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $afb237382692687d$var$getDirtyFields = (defaultValues, formValues)=>$afb237382692687d$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $afb237382692687d$var$markFieldsDirty(formValues));
var $afb237382692687d$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$afb237382692687d$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $afb237382692687d$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $afb237382692687d$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($afb237382692687d$var$isFileInput(ref)) return ref.files;
    if ($afb237382692687d$var$isRadioInput(ref)) return $afb237382692687d$var$getRadioValue(_f.refs).value;
    if ($afb237382692687d$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($afb237382692687d$var$isCheckBoxInput(ref)) return $afb237382692687d$var$getCheckboxValue(_f.refs).value;
    return $afb237382692687d$var$getFieldValueAs($afb237382692687d$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $afb237382692687d$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        field && $afb237382692687d$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $afb237382692687d$var$getRuleValue = (rule)=>$afb237382692687d$var$isUndefined(rule) ? rule : $afb237382692687d$var$isRegex(rule) ? rule.source : $afb237382692687d$var$isObject(rule) ? $afb237382692687d$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $afb237382692687d$var$ASYNC_FUNCTION = "AsyncFunction";
var $afb237382692687d$var$hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!($afb237382692687d$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $afb237382692687d$var$ASYNC_FUNCTION || $afb237382692687d$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $afb237382692687d$var$ASYNC_FUNCTION));
var $afb237382692687d$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $afb237382692687d$var$schemaErrorLookup(errors, _fields, name) {
    const error = $afb237382692687d$export$3988ae62b71be9a3(errors, name);
    if (error || $afb237382692687d$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $afb237382692687d$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $afb237382692687d$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $afb237382692687d$var$unsetEmptyArray = (ref, name)=>!$afb237382692687d$var$compact($afb237382692687d$export$3988ae62b71be9a3(ref, name)).length && $afb237382692687d$var$unset(ref, name);
const $afb237382692687d$var$defaultOptions = {
    mode: $afb237382692687d$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $afb237382692687d$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $afb237382692687d$var$createFormControl(props = {}) {
    let _options = {
        ...$afb237382692687d$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $afb237382692687d$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $afb237382692687d$var$isObject(_options.defaultValues) || $afb237382692687d$var$isObject(_options.values) ? $afb237382692687d$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $afb237382692687d$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $afb237382692687d$var$createSubject(),
        array: $afb237382692687d$var$createSubject(),
        state: $afb237382692687d$var$createSubject()
    };
    const validationModeBeforeSubmit = $afb237382692687d$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $afb237382692687d$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $afb237382692687d$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!props.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $afb237382692687d$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!props.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $afb237382692687d$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$afb237382692687d$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !props.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($afb237382692687d$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $afb237382692687d$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $afb237382692687d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $afb237382692687d$export$3988ae62b71be9a3(_formValues, name, $afb237382692687d$var$isUndefined(value1) ? $afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $afb237382692687d$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $afb237382692687d$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!props.disabled) {
            const disabledField = !!($afb237382692687d$export$3988ae62b71be9a3(_fields, name) && $afb237382692687d$export$3988ae62b71be9a3(_fields, name)._f && $afb237382692687d$export$3988ae62b71be9a3(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || $afb237382692687d$var$deepEqual($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && $afb237382692687d$export$3988ae62b71be9a3(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? $afb237382692687d$var$unset(_formState.dirtyFields, name) : $afb237382692687d$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $afb237382692687d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $afb237382692687d$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afb237382692687d$var$unset(_formState.errors, name);
        }
        if ((error ? !$afb237382692687d$var$deepEqual(previousFieldError, error) : previousFieldError) || !$afb237382692687d$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $afb237382692687d$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $afb237382692687d$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $afb237382692687d$export$3988ae62b71be9a3(errors, name);
            error ? $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $afb237382692687d$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $afb237382692687d$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $afb237382692687d$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($afb237382692687d$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $afb237382692687d$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $afb237382692687d$var$unset(_formState.errors, _f.name));
                }
                !$afb237382692687d$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$afb237382692687d$var$live(ref)) : !$afb237382692687d$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!props.disabled && (name && data && $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, data), !$afb237382692687d$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$afb237382692687d$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $afb237382692687d$var$isUndefined(defaultValue) ? _defaultValues : $afb237382692687d$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$afb237382692687d$var$compact($afb237382692687d$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, $afb237382692687d$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $afb237382692687d$var$isHTMLElement(fieldReference.ref) && $afb237382692687d$var$isNullOrUndefined(value1) ? "" : value1;
                if ($afb237382692687d$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($afb237382692687d$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($afb237382692687d$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $afb237382692687d$var$isObject(fieldValue) || field && !field._f) && !$afb237382692687d$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $afb237382692687d$var$cloneObject(value1);
        $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$afb237382692687d$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $afb237382692687d$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $afb237382692687d$var$getFieldValue(field._f) : $afb237382692687d$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $afb237382692687d$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $afb237382692687d$var$deepEqual(fieldValue, $afb237382692687d$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $afb237382692687d$var$EVENTS.BLUR || event.type === $afb237382692687d$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$afb237382692687d$var$hasValidation(field._f) && !_options.resolver && !$afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $afb237382692687d$var$skipValidation(isBlurEvent, $afb237382692687d$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $afb237382692687d$var$isWatched(name, _names, isBlurEvent);
            $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$afb237382692687d$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === "onBlur") {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $afb237382692687d$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $afb237382692687d$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $afb237382692687d$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $afb237382692687d$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $afb237382692687d$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($afb237382692687d$var$isUndefined(name) ? name : fieldNames);
            isValid = $afb237382692687d$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$afb237382692687d$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$afb237382692687d$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $afb237382692687d$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $afb237382692687d$var$isUndefined(fieldNames) ? values : $afb237382692687d$var$isString(fieldNames) ? $afb237382692687d$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$afb237382692687d$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $afb237382692687d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$afb237382692687d$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$afb237382692687d$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $afb237382692687d$var$convertToArrayPayload(name).forEach((inputName)=>$afb237382692687d$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($afb237382692687d$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $afb237382692687d$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $afb237382692687d$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$afb237382692687d$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $afb237382692687d$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $afb237382692687d$var$unset(_fields, fieldName);
                $afb237382692687d$var$unset(_formValues, fieldName);
            }
            !options.keepError && $afb237382692687d$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $afb237382692687d$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $afb237382692687d$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $afb237382692687d$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $afb237382692687d$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($afb237382692687d$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $afb237382692687d$var$isUndefined(value1) ? $afb237382692687d$var$getFieldValue(field ? field._f : $afb237382692687d$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $afb237382692687d$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $afb237382692687d$var$isBoolean(options.disabled) || $afb237382692687d$var$isBoolean(props.disabled);
        $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $afb237382692687d$var$isBoolean(options.disabled) ? options.disabled : props.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || props.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $afb237382692687d$var$getRuleValue(options.min),
                max: $afb237382692687d$var$getRuleValue(options.max),
                minLength: $afb237382692687d$var$getRuleValue(options.minLength),
                maxLength: $afb237382692687d$var$getRuleValue(options.maxLength),
                pattern: $afb237382692687d$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $afb237382692687d$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $afb237382692687d$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $afb237382692687d$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($afb237382692687d$var$live),
                                    fieldRef,
                                    ...Array.isArray($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($afb237382692687d$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $afb237382692687d$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($afb237382692687d$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $afb237382692687d$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $afb237382692687d$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $afb237382692687d$var$unset(_formState.errors, "root");
            if ($afb237382692687d$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $afb237382692687d$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($afb237382692687d$export$3988ae62b71be9a3(_fields, name)) {
            if ($afb237382692687d$var$isUndefined(options.defaultValue)) setValue(name, $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $afb237382692687d$export$adaa4cf7ef1b65be(_defaultValues, name, $afb237382692687d$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $afb237382692687d$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $afb237382692687d$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $afb237382692687d$var$cloneObject($afb237382692687d$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $afb237382692687d$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $afb237382692687d$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $afb237382692687d$var$cloneObject(updatedValues);
        const isEmptyResetValues = $afb237382692687d$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($afb237382692687d$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$afb237382692687d$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $afb237382692687d$export$adaa4cf7ef1b65be(values, fieldName, $afb237382692687d$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $afb237382692687d$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($afb237382692687d$var$isWeb && $afb237382692687d$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($afb237382692687d$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $afb237382692687d$var$cloneObject(_defaultValues) : {} : $afb237382692687d$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$afb237382692687d$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $afb237382692687d$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $afb237382692687d$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($afb237382692687d$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $afb237382692687d$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$afb237382692687d$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $afb237382692687d$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $afb237382692687d$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $afb237382692687d$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$afb237382692687d$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $afb237382692687d$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($afb237382692687d$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (props.values && !$afb237382692687d$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (_formControl.current) _formControl.current.watch = _formControl.current.watch.bind({});
    }, [
        formState
    ]);
    _formControl.current.formState = $afb237382692687d$var$getProxyFormState(formState, control);
    return _formControl.current;
}



var $eZVvM = parcelRequire("eZVvM");

var $30Kai = parcelRequire("30Kai");

var $bq3DV = parcelRequire("bq3DV");

var $4QcTI = parcelRequire("4QcTI");

var $g3yHX = parcelRequire("g3yHX");
// CLASS
class $6a981849e8378921$export$d3c1860ee66f291a extends (0, $4QcTI.Subscribable) {
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $g3yHX.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $30Kai.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $bq3DV.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
}


var $bq3DV = parcelRequire("bq3DV");
var $g3yHX = parcelRequire("g3yHX");

var $l7YCt = parcelRequire("l7YCt");

var $gdPnm = parcelRequire("gdPnm");

var $gCLDX = parcelRequire("gCLDX");
"use client";
function $084aaf38c3338203$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $g3yHX.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, $gdPnm.useQueryClient)({
        context: options.context
    });
    const [observer] = $eZVvM.useState(()=>new (0, $6a981849e8378921$export$d3c1860ee66f291a)(queryClient, options));
    $eZVvM.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $l7YCt.useSyncExternalStore)($eZVvM.useCallback((onStoreChange)=>observer.subscribe((0, $bq3DV.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $eZVvM.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($084aaf38c3338203$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $gCLDX.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $084aaf38c3338203$var$noop() {}


var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");


var $72bd4d366489160d$exports = {};

var $l4rgt = parcelRequire("l4rgt");

var $9PmZ6 = parcelRequire("9PmZ6");
var $8419c3e14ec60841$exports = {};

var $erFZL = parcelRequire("erFZL");

var $gyLmc = parcelRequire("gyLmc");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $8419c3e14ec60841$var$baseMap(collection, iteratee) {
    var index = -1, result = $gyLmc(collection) ? Array(collection.length) : [];
    $erFZL(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$8419c3e14ec60841$exports = $8419c3e14ec60841$var$baseMap;



var $3hHqY = parcelRequire("3hHqY");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $72bd4d366489160d$var$map(collection, iteratee) {
    var func = $3hHqY(collection) ? $l4rgt : $8419c3e14ec60841$exports;
    return func(collection, $9PmZ6(iteratee, 3));
}
$72bd4d366489160d$exports = $72bd4d366489160d$var$map;


var $8fab9d099c4589dd$exports = {};

var $akGgj = parcelRequire("akGgj");

var $9PmZ6 = parcelRequire("9PmZ6");
var $9752f1763fe4f119$exports = {};

var $erFZL = parcelRequire("erFZL");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9752f1763fe4f119$var$baseSome(collection, predicate) {
    var result;
    $erFZL(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$9752f1763fe4f119$exports = $9752f1763fe4f119$var$baseSome;



var $3hHqY = parcelRequire("3hHqY");

var $2bHYF = parcelRequire("2bHYF");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $8fab9d099c4589dd$var$some(collection, predicate, guard) {
    var func = $3hHqY(collection) ? $akGgj : $9752f1763fe4f119$exports;
    if (guard && $2bHYF(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9PmZ6(predicate, 3));
}
$8fab9d099c4589dd$exports = $8fab9d099c4589dd$var$some;


var $2f526e07c519dc18$export$d3305692eb3e9a81;
var $2f526e07c519dc18$export$9a0a9c75ccef13fb;
var $2f526e07c519dc18$export$7d9f7e9c1c02b41e;
var $2f526e07c519dc18$export$dc8de070e3f64a1a;
var $2f526e07c519dc18$export$c606acb2d9bafce;
var $2f526e07c519dc18$export$5e172d3d07078e9e;
var $2f526e07c519dc18$export$55418e842cf62482;
var $2f526e07c519dc18$export$7a171f172be0782e;
"use strict";
var $985979d475adc8c1$exports = {};
$985979d475adc8c1$exports = JSON.parse('[{"code":"AD","name":"Andorra"},{"code":"AE","name":"United Arab Emirates"},{"code":"AF","name":"Afghanistan"},{"code":"AG","name":"Antigua and Barbuda"},{"code":"AI","name":"Anguilla"},{"code":"AL","name":"Albania"},{"code":"AM","name":"Armenia"},{"code":"AO","name":"Angola"},{"code":"AQ","name":"Antarctica"},{"code":"AR","name":"Argentina"},{"code":"AS","name":"American Samoa"},{"code":"AT","name":"Austria"},{"code":"AU","name":"Australia"},{"code":"AW","name":"Aruba"},{"code":"AX","name":"\xc5land Islands"},{"code":"AZ","name":"Azerbaijan"},{"code":"BA","name":"Bosnia and Herzegovina"},{"code":"BB","name":"Barbados"},{"code":"BD","name":"Bangladesh"},{"code":"BE","name":"Belgium"},{"code":"BF","name":"Burkina Faso"},{"code":"BG","name":"Bulgaria"},{"code":"BH","name":"Bahrain"},{"code":"BI","name":"Burundi"},{"code":"BJ","name":"Benin"},{"code":"BL","name":"Saint Barth\xe9lemy"},{"code":"BM","name":"Bermuda"},{"code":"BN","name":"Brunei Darussalam"},{"code":"BO","name":"Bolivia, Plurinational State of"},{"code":"BQ","name":"Bonaire, Sint Eustatius and Saba"},{"code":"BR","name":"Brazil"},{"code":"BS","name":"Bahamas"},{"code":"BT","name":"Bhutan"},{"code":"BV","name":"Bouvet Island"},{"code":"BW","name":"Botswana"},{"code":"BY","name":"Belarus"},{"code":"BZ","name":"Belize"},{"code":"CA","name":"Canada"},{"code":"CC","name":"Cocos (Keeling) Islands"},{"code":"CD","name":"Congo, Democratic Republic of the"},{"code":"CF","name":"Central African Republic"},{"code":"CG","name":"Congo"},{"code":"CH","name":"Switzerland"},{"code":"CI","name":"C\xf4te d\'Ivoire"},{"code":"CK","name":"Cook Islands"},{"code":"CL","name":"Chile"},{"code":"CM","name":"Cameroon"},{"code":"CN","name":"China"},{"code":"CO","name":"Colombia"},{"code":"CR","name":"Costa Rica"},{"code":"CU","name":"Cuba"},{"code":"CV","name":"Cabo Verde"},{"code":"CW","name":"Cura\xe7ao"},{"code":"CX","name":"Christmas Island"},{"code":"CY","name":"Cyprus"},{"code":"CZ","name":"Czechia"},{"code":"DE","name":"Germany"},{"code":"DJ","name":"Djibouti"},{"code":"DK","name":"Denmark"},{"code":"DM","name":"Dominica"},{"code":"DO","name":"Dominican Republic"},{"code":"DZ","name":"Algeria"},{"code":"EC","name":"Ecuador"},{"code":"EE","name":"Estonia"},{"code":"EG","name":"Egypt"},{"code":"EH","name":"Western Sahara"},{"code":"ER","name":"Eritrea"},{"code":"ES","name":"Spain"},{"code":"ET","name":"Ethiopia"},{"code":"FI","name":"Finland"},{"code":"FJ","name":"Fiji"},{"code":"FK","name":"Falkland Islands (Malvinas)"},{"code":"FM","name":"Micronesia, Federated States of"},{"code":"FO","name":"Faroe Islands"},{"code":"FR","name":"France"},{"code":"GA","name":"Gabon"},{"code":"GB","name":"United Kingdom of Great Britain and Northern Ireland"},{"code":"GD","name":"Grenada"},{"code":"GE","name":"Georgia"},{"code":"GF","name":"French Guiana"},{"code":"GG","name":"Guernsey"},{"code":"GH","name":"Ghana"},{"code":"GI","name":"Gibraltar"},{"code":"GL","name":"Greenland"},{"code":"GM","name":"Gambia"},{"code":"GN","name":"Guinea"},{"code":"GP","name":"Guadeloupe"},{"code":"GQ","name":"Equatorial Guinea"},{"code":"GR","name":"Greece"},{"code":"GS","name":"South Georgia and the South Sandwich Islands"},{"code":"GT","name":"Guatemala"},{"code":"GU","name":"Guam"},{"code":"GW","name":"Guinea-Bissau"},{"code":"GY","name":"Guyana"},{"code":"HK","name":"Hong Kong"},{"code":"HM","name":"Heard Island and McDonald Islands"},{"code":"HN","name":"Honduras"},{"code":"HR","name":"Croatia"},{"code":"HT","name":"Haiti"},{"code":"HU","name":"Hungary"},{"code":"ID","name":"Indonesia"},{"code":"IE","name":"Ireland"},{"code":"IL","name":"Israel"},{"code":"IM","name":"Isle of Man"},{"code":"IN","name":"India"},{"code":"IO","name":"British Indian Ocean Territory"},{"code":"IQ","name":"Iraq"},{"code":"IR","name":"Iran, Islamic Republic of"},{"code":"IS","name":"Iceland"},{"code":"IT","name":"Italy"},{"code":"JE","name":"Jersey"},{"code":"JM","name":"Jamaica"},{"code":"JO","name":"Jordan"},{"code":"JP","name":"Japan"},{"code":"KE","name":"Kenya"},{"code":"KG","name":"Kyrgyzstan"},{"code":"KH","name":"Cambodia"},{"code":"KI","name":"Kiribati"},{"code":"KM","name":"Comoros"},{"code":"KN","name":"Saint Kitts and Nevis"},{"code":"KP","name":"Korea, Democratic People\'s Republic of"},{"code":"KR","name":"Korea, Republic of"},{"code":"KW","name":"Kuwait"},{"code":"KY","name":"Cayman Islands"},{"code":"KZ","name":"Kazakhstan"},{"code":"LA","name":"Lao People\'s Democratic Republic"},{"code":"LB","name":"Lebanon"},{"code":"LC","name":"Saint Lucia"},{"code":"LI","name":"Liechtenstein"},{"code":"LK","name":"Sri Lanka"},{"code":"LR","name":"Liberia"},{"code":"LS","name":"Lesotho"},{"code":"LT","name":"Lithuania"},{"code":"LU","name":"Luxembourg"},{"code":"LV","name":"Latvia"},{"code":"LY","name":"Libya"},{"code":"MA","name":"Morocco"},{"code":"MC","name":"Monaco"},{"code":"MD","name":"Moldova, Republic of"},{"code":"ME","name":"Montenegro"},{"code":"MF","name":"Saint Martin, (French part)"},{"code":"MG","name":"Madagascar"},{"code":"MH","name":"Marshall Islands"},{"code":"MK","name":"North Macedonia"},{"code":"ML","name":"Mali"},{"code":"MM","name":"Myanmar"},{"code":"MN","name":"Mongolia"},{"code":"MO","name":"Macao"},{"code":"MP","name":"Northern Mariana Islands"},{"code":"MQ","name":"Martinique"},{"code":"MR","name":"Mauritania"},{"code":"MS","name":"Montserrat"},{"code":"MT","name":"Malta"},{"code":"MU","name":"Mauritius"},{"code":"MV","name":"Maldives"},{"code":"MW","name":"Malawi"},{"code":"MX","name":"Mexico"},{"code":"MY","name":"Malaysia"},{"code":"MZ","name":"Mozambique"},{"code":"NA","name":"Namibia"},{"code":"NC","name":"New Caledonia"},{"code":"NE","name":"Niger"},{"code":"NF","name":"Norfolk Island"},{"code":"NG","name":"Nigeria"},{"code":"NI","name":"Nicaragua"},{"code":"NL","name":"Netherlands"},{"code":"NO","name":"Norway"},{"code":"NP","name":"Nepal"},{"code":"NR","name":"Nauru"},{"code":"NU","name":"Niue"},{"code":"NZ","name":"New Zealand"},{"code":"OM","name":"Oman"},{"code":"PA","name":"Panama"},{"code":"PE","name":"Peru"},{"code":"PF","name":"French Polynesia"},{"code":"PG","name":"Papua New Guinea"},{"code":"PH","name":"Philippines"},{"code":"PK","name":"Pakistan"},{"code":"PL","name":"Poland"},{"code":"PM","name":"Saint Pierre and Miquelon"},{"code":"PN","name":"Pitcairn"},{"code":"PR","name":"Puerto Rico"},{"code":"PS","name":"Palestine, State of"},{"code":"PT","name":"Portugal"},{"code":"PW","name":"Palau"},{"code":"PY","name":"Paraguay"},{"code":"QA","name":"Qatar"},{"code":"RE","name":"R\xe9union"},{"code":"RO","name":"Romania"},{"code":"RS","name":"Serbia"},{"code":"RU","name":"Russian Federation"},{"code":"RW","name":"Rwanda"},{"code":"SA","name":"Saudi Arabia"},{"code":"SB","name":"Solomon Islands"},{"code":"SC","name":"Seychelles"},{"code":"SD","name":"Sudan"},{"code":"SE","name":"Sweden"},{"code":"SG","name":"Singapore"},{"code":"SH","name":"Saint Helena, Ascension and Tristan da Cunha"},{"code":"SI","name":"Slovenia"},{"code":"SJ","name":"Svalbard and Jan Mayen"},{"code":"SK","name":"Slovakia"},{"code":"SL","name":"Sierra Leone"},{"code":"SM","name":"San Marino"},{"code":"SN","name":"Senegal"},{"code":"SO","name":"Somalia"},{"code":"SR","name":"Suriname"},{"code":"SS","name":"South Sudan"},{"code":"ST","name":"Sao Tome and Principe"},{"code":"SV","name":"El Salvador"},{"code":"SX","name":"Sint Maarten, (Dutch part)"},{"code":"SY","name":"Syrian Arab Republic"},{"code":"SZ","name":"Eswatini"},{"code":"TC","name":"Turks and Caicos Islands"},{"code":"TD","name":"Chad"},{"code":"TF","name":"French Southern Territories"},{"code":"TG","name":"Togo"},{"code":"TH","name":"Thailand"},{"code":"TJ","name":"Tajikistan"},{"code":"TK","name":"Tokelau"},{"code":"TL","name":"Timor-Leste"},{"code":"TM","name":"Turkmenistan"},{"code":"TN","name":"Tunisia"},{"code":"TO","name":"Tonga"},{"code":"TR","name":"T\xfcrkiye"},{"code":"TT","name":"Trinidad and Tobago"},{"code":"TV","name":"Tuvalu"},{"code":"TW","name":"Taiwan, Province of China"},{"code":"TZ","name":"Tanzania, United Republic of"},{"code":"UA","name":"Ukraine"},{"code":"UG","name":"Uganda"},{"code":"UM","name":"United States Minor Outlying Islands"},{"code":"US","name":"United States of America"},{"code":"UY","name":"Uruguay"},{"code":"UZ","name":"Uzbekistan"},{"code":"VA","name":"Holy See"},{"code":"VC","name":"Saint Vincent and the Grenadines"},{"code":"VE","name":"Venezuela, Bolivarian Republic of"},{"code":"VG","name":"Virgin Islands, British"},{"code":"VI","name":"Virgin Islands, U.S."},{"code":"VN","name":"Viet Nam"},{"code":"VU","name":"Vanuatu"},{"code":"WF","name":"Wallis and Futuna"},{"code":"WS","name":"Samoa"},{"code":"YE","name":"Yemen"},{"code":"YT","name":"Mayotte"},{"code":"ZA","name":"South Africa"},{"code":"ZM","name":"Zambia"},{"code":"ZW","name":"Zimbabwe"}]');


/** Precompute name and code lookups. */ var $2f526e07c519dc18$var$nameMap = {};
var $2f526e07c519dc18$var$codeMap = {};
$985979d475adc8c1$exports.forEach($2f526e07c519dc18$var$mapCodeAndName);
function $2f526e07c519dc18$var$mapCodeAndName(country) {
    $2f526e07c519dc18$var$nameMap[country.name.toLowerCase()] = country.code;
    $2f526e07c519dc18$var$codeMap[country.code.toLowerCase()] = country.name;
}
$2f526e07c519dc18$export$d3305692eb3e9a81 = function overwrite(countries) {
    if (!countries || !countries.length) return;
    countries.forEach(function(country) {
        var foundIndex = $985979d475adc8c1$exports.findIndex(function(item) {
            return item.code === country.code;
        });
        $985979d475adc8c1$exports[foundIndex] = country;
        $2f526e07c519dc18$var$mapCodeAndName(country);
    });
};
$2f526e07c519dc18$export$9a0a9c75ccef13fb = function getCode(name) {
    return $2f526e07c519dc18$var$nameMap[name.toLowerCase()];
};
$2f526e07c519dc18$export$7d9f7e9c1c02b41e = function getName(code) {
    return $2f526e07c519dc18$var$codeMap[code.toLowerCase()];
};
$2f526e07c519dc18$export$dc8de070e3f64a1a = function getNames() {
    return $985979d475adc8c1$exports.map(function(country) {
        return country.name;
    });
};
$2f526e07c519dc18$export$c606acb2d9bafce = function getCodes() {
    return $985979d475adc8c1$exports.map(function(country) {
        return country.code;
    });
};
$2f526e07c519dc18$export$5e172d3d07078e9e = function getCodeList() {
    return $2f526e07c519dc18$var$codeMap;
};
$2f526e07c519dc18$export$55418e842cf62482 = function getNameList() {
    return $2f526e07c519dc18$var$nameMap;
};
$2f526e07c519dc18$export$7a171f172be0782e = function getData() {
    return $985979d475adc8c1$exports;
};


// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $4e50f7ec0625ce58$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|2[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[235]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                        "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                        "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "46"
                    ]
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6|90"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[49]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6|7[245]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                    [
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ]
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "3[2-8]\\d{9,10}",
                    [
                        11,
                        12
                    ]
                ],
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[0135-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(0-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(0-$1)",
                    1
                ]
            ],
            "0",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|452|678|86",
                        "[12]|452|6788|86"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|[89]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]|8(?:0[6-9]|[36])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "[2-9]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[0467]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",
            [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "[6-9]\\d{6}|[1-6]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "(?:[2489]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-9]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[689]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[26-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[1245]|3[12])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "(?:[1-6]\\d|71)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[67]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ],
                0,
                0,
                0,
                [
                    "305209\\d{4}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "00",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ]
                ]
            ]
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[47-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2|39"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                [
                    "348[57]\\d{7}",
                    [
                        11
                    ]
                ],
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $bd8175273c79c979$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $4e50f7ec0625ce58$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


var $4d6e350a05862563$var$objectConstructor = {}.constructor;
function $4d6e350a05862563$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $4d6e350a05862563$var$objectConstructor;
}


function $5b2a4ba64c315cbc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b2a4ba64c315cbc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b2a4ba64c315cbc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b2a4ba64c315cbc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b2a4ba64c315cbc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b2a4ba64c315cbc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b2a4ba64c315cbc$var$_slicedToArray(arr, i) {
    return $5b2a4ba64c315cbc$var$_arrayWithHoles(arr) || $5b2a4ba64c315cbc$var$_iterableToArrayLimit(arr, i) || $5b2a4ba64c315cbc$var$_unsupportedIterableToArray(arr, i) || $5b2a4ba64c315cbc$var$_nonIterableRest();
}
function $5b2a4ba64c315cbc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b2a4ba64c315cbc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5b2a4ba64c315cbc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5b2a4ba64c315cbc$var$_arrayLikeToArray(o, minLen);
}
function $5b2a4ba64c315cbc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5b2a4ba64c315cbc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $5b2a4ba64c315cbc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5b2a4ba64c315cbc$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $5b2a4ba64c315cbc$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $5b2a4ba64c315cbc$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $4d6e350a05862563$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $bb091544218c2422$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $bb091544218c2422$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $bb091544218c2422$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $bb091544218c2422$export$852d1d4a47329634 = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"
var $bb091544218c2422$var$DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var $bb091544218c2422$var$SLASHES = "\uFF0F/";
var $bb091544218c2422$var$DOTS = "\uFF0E.";
var $bb091544218c2422$export$20542845033f576e = " \xa0\xad\u200B\u2060\u3000";
var $bb091544218c2422$var$BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $bb091544218c2422$var$TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
var $bb091544218c2422$export$7f01587e28f9194 = "".concat($bb091544218c2422$var$DASHES).concat($bb091544218c2422$var$SLASHES).concat($bb091544218c2422$var$DOTS).concat($bb091544218c2422$export$20542845033f576e).concat($bb091544218c2422$var$BRACKETS).concat($bb091544218c2422$var$TILDES);
var $bb091544218c2422$export$207c99ccf3902df8 = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $d3d926b62f621051$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d3d926b62f621051$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d3d926b62f621051$var$_typeof(obj);
}
function $d3d926b62f621051$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d3d926b62f621051$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d3d926b62f621051$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d3d926b62f621051$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d3d926b62f621051$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d3d926b62f621051$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d3d926b62f621051$var$_setPrototypeOf(subClass, superClass);
}
function $d3d926b62f621051$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d3d926b62f621051$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d3d926b62f621051$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d3d926b62f621051$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d3d926b62f621051$var$_possibleConstructorReturn(this, result);
    };
}
function $d3d926b62f621051$var$_possibleConstructorReturn(self, call) {
    if (call && ($d3d926b62f621051$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d3d926b62f621051$var$_assertThisInitialized(self);
}
function $d3d926b62f621051$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d3d926b62f621051$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $d3d926b62f621051$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d3d926b62f621051$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $d3d926b62f621051$var$_construct(Class, arguments, $d3d926b62f621051$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $d3d926b62f621051$var$_setPrototypeOf(Wrapper, Class);
    };
    return $d3d926b62f621051$var$_wrapNativeSuper(Class);
}
function $d3d926b62f621051$var$_construct(Parent, args, Class) {
    if ($d3d926b62f621051$var$_isNativeReflectConstruct()) $d3d926b62f621051$var$_construct = Reflect.construct;
    else $d3d926b62f621051$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $d3d926b62f621051$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $d3d926b62f621051$var$_construct.apply(null, arguments);
}
function $d3d926b62f621051$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d3d926b62f621051$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $d3d926b62f621051$var$_setPrototypeOf(o, p) {
    $d3d926b62f621051$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d3d926b62f621051$var$_setPrototypeOf(o, p);
}
function $d3d926b62f621051$var$_getPrototypeOf(o) {
    $d3d926b62f621051$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d3d926b62f621051$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $d3d926b62f621051$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $d3d926b62f621051$var$_inherits(ParseError, _Error);
    var _super = $d3d926b62f621051$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $d3d926b62f621051$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($d3d926b62f621051$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $d3d926b62f621051$var$_createClass(ParseError);
}(/*#__PURE__*/ $d3d926b62f621051$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $13ffcff4e5ead5fe$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}



function $e6fbb5d84511f017$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e6fbb5d84511f017$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e6fbb5d84511f017$var$_typeof(obj);
}
function $e6fbb5d84511f017$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6fbb5d84511f017$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e6fbb5d84511f017$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e6fbb5d84511f017$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e6fbb5d84511f017$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $e6fbb5d84511f017$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $e6fbb5d84511f017$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $e6fbb5d84511f017$var$V4 = "1.7.35";
var $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX = " ext. ";
var $e6fbb5d84511f017$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $e6fbb5d84511f017$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Metadata);
        $e6fbb5d84511f017$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $e6fbb5d84511f017$var$setVersion.call(this, metadata);
    }
    $e6fbb5d84511f017$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $e6fbb5d84511f017$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $e6fbb5d84511f017$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $e6fbb5d84511f017$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $e6fbb5d84511f017$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $e6fbb5d84511f017$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $e6fbb5d84511f017$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $e6fbb5d84511f017$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $e6fbb5d84511f017$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $e6fbb5d84511f017$var$getType(this.types(), _type2)) return new $e6fbb5d84511f017$var$Type($e6fbb5d84511f017$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $e6fbb5d84511f017$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $e6fbb5d84511f017$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$e6fbb5d84511f017$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $e6fbb5d84511f017$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $e6fbb5d84511f017$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $e6fbb5d84511f017$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $e6fbb5d84511f017$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $e6fbb5d84511f017$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $e6fbb5d84511f017$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata) || !(0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $4d6e350a05862563$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $e6fbb5d84511f017$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $e6fbb5d84511f017$var$typeOf = function typeOf(_) {
    return $e6fbb5d84511f017$var$_typeof(_);
};
function $e6fbb5d84511f017$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $e6fbb5d84511f017$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $e6fbb5d84511f017$var$DEFAULT_EXT_PREFIX;
}
function $e6fbb5d84511f017$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $e6fbb5d84511f017$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $e6fbb5d84511f017$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $e6fbb5d84511f017$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $13ffcff4e5ead5fe$export$2e2bcd8739ae039)(version, $e6fbb5d84511f017$var$V3) === -1) this.v2 = true;
        else if ((0, $13ffcff4e5ead5fe$export$2e2bcd8739ae039)(version, $e6fbb5d84511f017$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $58e1772fb891efdb$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $58e1772fb891efdb$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $bb091544218c2422$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $58e1772fb891efdb$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $58e1772fb891efdb$var$RFC3966_EXTN_PREFIX + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $58e1772fb891efdb$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $d22af7acfc2f0108$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]{" + (0, $bb091544218c2422$export$cd8355bcbe13154) + "}"; //
var $d22af7acfc2f0108$export$a77dd7471651eee = "[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + "]*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + (0, $bb091544218c2422$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $bb091544218c2422$export$7f01587e28f9194) + "]*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $d22af7acfc2f0108$export$a2d12a04749c087d = $d22af7acfc2f0108$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $58e1772fb891efdb$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $d22af7acfc2f0108$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $d22af7acfc2f0108$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $d22af7acfc2f0108$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $bb091544218c2422$export$cd8355bcbe13154) && $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $d22af7acfc2f0108$export$4c3f76c95c05197c(number) {
    return $d22af7acfc2f0108$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $f65265fe1e6db889$var$EXTN_PATTERN = new RegExp("(?:" + (0, $58e1772fb891efdb$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $f65265fe1e6db889$export$2e2bcd8739ae039(number) {
    var start = number.search($f65265fe1e6db889$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($f65265fe1e6db889$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $f88cd79102f734e2$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f88cd79102f734e2$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f88cd79102f734e2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f88cd79102f734e2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f88cd79102f734e2$var$_arrayLikeToArray(o, minLen);
}
function $f88cd79102f734e2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f88cd79102f734e2$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9" // Eastern-Arabic digit 9
};
function $f88cd79102f734e2$export$1d16fddea1437169(character) {
    return $f88cd79102f734e2$export$2848f3d68c08fe69[character];
}
function $f88cd79102f734e2$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $f88cd79102f734e2$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $f88cd79102f734e2$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $af1822d55479411a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $af1822d55479411a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af1822d55479411a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af1822d55479411a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af1822d55479411a$var$_arrayLikeToArray(o, minLen);
}
function $af1822d55479411a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af1822d55479411a$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $af1822d55479411a$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $af1822d55479411a$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $af1822d55479411a$export$13d8790d7fb84c28(character, prevParsedCharacters, emitEvent) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) {
            // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
            // Any 3rd-party code that used to `import` and call this function before that
            // won't be passing any `emitEvent` argument.
            //
            // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
            // of parsing an input string when the user inputs something like `"2+7"
            // https://github.com/catamphetamine/react-phone-number-input/issues/437
            //
            // If the parser encounters an unexpected `+` in a string being parsed
            // then it simply discards that out-of-place `+` and any following characters.
            //
            if (typeof emitEvent === "function") emitEvent("end");
            return;
        }
        return "+";
    } // Allow digits.
    return (0, $f88cd79102f734e2$export$1d16fddea1437169)(character);
}




function $4ce6c7f0c8a3e783$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $4ce6c7f0c8a3e783$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4ce6c7f0c8a3e783$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4ce6c7f0c8a3e783$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4ce6c7f0c8a3e783$var$_arrayLikeToArray(o, minLen);
}
function $4ce6c7f0c8a3e783$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4ce6c7f0c8a3e783$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $4ce6c7f0c8a3e783$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $a3a086b198e80566$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $a3a086b198e80566$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $4ce6c7f0c8a3e783$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $a8f2dd648e97fe5b$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $a8f2dd648e97fe5b$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $a8f2dd648e97fe5b$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $13401f55428d37e4$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $28c8a560eb0c7641$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $28c8a560eb0c7641$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $28c8a560eb0c7641$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $28c8a560eb0c7641$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $28c8a560eb0c7641$var$_arrayLikeToArray(o, minLen);
}
function $28c8a560eb0c7641$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $28c8a560eb0c7641$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $28c8a560eb0c7641$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $28c8a560eb0c7641$var$_createForOfIteratorHelperLoose($28c8a560eb0c7641$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $28c8a560eb0c7641$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $49e490fc864cb6d6$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $28c8a560eb0c7641$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $52850ae2cabd2045$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $52850ae2cabd2045$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $52850ae2cabd2045$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $f8ea06b400de8cbe$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $bb091544218c2422$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $113045d9ca8c8c9c$export$4f32ad1c51a7a6be = /(\$\d)/;
function $113045d9ca8c8c9c$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($113045d9ca8c8c9c$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $f8ea06b400de8cbe$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $3dd63edf7677d390$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $3dd63edf7677d390$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($3dd63edf7677d390$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $fec889cd5135fee1$var$_slicedToArray(arr, i) {
    return $fec889cd5135fee1$var$_arrayWithHoles(arr) || $fec889cd5135fee1$var$_iterableToArrayLimit(arr, i) || $fec889cd5135fee1$var$_unsupportedIterableToArray(arr, i) || $fec889cd5135fee1$var$_nonIterableRest();
}
function $fec889cd5135fee1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fec889cd5135fee1$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fec889cd5135fee1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fec889cd5135fee1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $fec889cd5135fee1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fec889cd5135fee1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fec889cd5135fee1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fec889cd5135fee1$var$_arrayLikeToArray(o, minLen);
}
function $fec889cd5135fee1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fec889cd5135fee1$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $fec889cd5135fee1$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $fec889cd5135fee1$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $d22af7acfc2f0108$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $fec889cd5135fee1$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $3cb3e9a16ec57e92$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $3cb3e9a16ec57e92$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb3e9a16ec57e92$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cb3e9a16ec57e92$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cb3e9a16ec57e92$var$_arrayLikeToArray(o, minLen);
}
function $3cb3e9a16ec57e92$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cb3e9a16ec57e92$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3cb3e9a16ec57e92$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3cb3e9a16ec57e92$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3cb3e9a16ec57e92$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3cb3e9a16ec57e92$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3cb3e9a16ec57e92$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $3cb3e9a16ec57e92$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $3cb3e9a16ec57e92$var$_objectSpread($3cb3e9a16ec57e92$var$_objectSpread({}, $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS), options);
    else options = $3cb3e9a16ec57e92$var$DEFAULT_OPTIONS;
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $3cb3e9a16ec57e92$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $3cb3e9a16ec57e92$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $fec889cd5135fee1$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $3cb3e9a16ec57e92$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $3cb3e9a16ec57e92$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $3cb3e9a16ec57e92$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $3cb3e9a16ec57e92$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $113045d9ca8c8c9c$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $3cb3e9a16ec57e92$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $3cb3e9a16ec57e92$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $3cb3e9a16ec57e92$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $3cb3e9a16ec57e92$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $3dd63edf7677d390$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($3cb3e9a16ec57e92$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $a1f8752c4f3cd32b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a1f8752c4f3cd32b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a1f8752c4f3cd32b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a1f8752c4f3cd32b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a1f8752c4f3cd32b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a1f8752c4f3cd32b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a1f8752c4f3cd32b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a1f8752c4f3cd32b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a1f8752c4f3cd32b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a1f8752c4f3cd32b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a1f8752c4f3cd32b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $a1f8752c4f3cd32b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $a1f8752c4f3cd32b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $a1f8752c4f3cd32b$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $a1f8752c4f3cd32b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $a1f8752c4f3cd32b$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $52850ae2cabd2045$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $a8f2dd648e97fe5b$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $49e490fc864cb6d6$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $28c8a560eb0c7641$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $3cb3e9a16ec57e92$export$2e2bcd8739ae039)(this, _format, options ? $a1f8752c4f3cd32b$var$_objectSpread($a1f8752c4f3cd32b$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $a1f8752c4f3cd32b$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $a1f8752c4f3cd32b$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($a1f8752c4f3cd32b$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($a1f8752c4f3cd32b$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $a4ed7c3839145d19$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $bb091544218c2422$export$852d1d4a47329634) + "])");
function $a4ed7c3839145d19$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($a4ed7c3839145d19$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $83f6ec74aec660d0$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $d650e373b3dd0ea7$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $83f6ec74aec660d0$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$d650e373b3dd0ea7$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$d650e373b3dd0ea7$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $d650e373b3dd0ea7$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $d650e373b3dd0ea7$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $6fdd253f41c7c10e$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $13401f55428d37e4$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $a3a086b198e80566$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $2c1edb3f7d3b8cef$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $a4ed7c3839145d19$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $6fdd253f41c7c10e$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $bb091544218c2422$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $ae7386ec57b9d14a$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $ae7386ec57b9d14a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ae7386ec57b9d14a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ae7386ec57b9d14a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ae7386ec57b9d14a$var$_arrayLikeToArray(o, minLen);
}
function $ae7386ec57b9d14a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ae7386ec57b9d14a$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // const matchingCountries = []
    for(var _iterator = $ae7386ec57b9d14a$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $28c8a560eb0c7641$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) // If both the `defaultCountry` and the "main" one match the phone number,
        // don't prefer the `defaultCountry` over the "main" one.
        // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
        return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
    } // // Return the first ("main") one of the `matchingCountries`.
// if (matchingCountries.length > 0) {
// 	return matchingCountries[0]
// }
}


var $b4570bb92b85ccdd$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $b4570bb92b85ccdd$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($b4570bb92b85ccdd$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $ae7386ec57b9d14a$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $46b70126e6497d26$export$1ddc7eed78155f68 = "+";
var $46b70126e6497d26$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + "|" + $46b70126e6497d26$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $46b70126e6497d26$export$1ddc7eed78155f68 + $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $bb091544218c2422$export$852d1d4a47329634) + "]" + $46b70126e6497d26$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $46b70126e6497d26$var$ALPHANUM_ = (0, $bb091544218c2422$export$852d1d4a47329634);
var $46b70126e6497d26$var$RFC3966_DOMAINLABEL_ = "[" + $46b70126e6497d26$var$ALPHANUM_ + "]+((\\-)*[" + $46b70126e6497d26$var$ALPHANUM_ + "])*";
var $46b70126e6497d26$var$VALID_ALPHA_ = "a-zA-Z";
var $46b70126e6497d26$var$RFC3966_TOPLABEL_ = "[" + $46b70126e6497d26$var$VALID_ALPHA_ + "]+((\\-)*[" + $46b70126e6497d26$var$ALPHANUM_ + "])*";
var $46b70126e6497d26$var$RFC3966_DOMAINNAME_ = "^(" + $46b70126e6497d26$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $46b70126e6497d26$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $46b70126e6497d26$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($46b70126e6497d26$var$RFC3966_DOMAINNAME_, "g");
var $46b70126e6497d26$export$70d485ce3f6de783 = "tel:";
var $46b70126e6497d26$export$f6d5879d582c3a27 = ";phone-context=";
var $46b70126e6497d26$export$9e356e12edb00a81 = ";isub=";
function $46b70126e6497d26$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($46b70126e6497d26$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $46b70126e6497d26$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $46b70126e6497d26$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $46b70126e6497d26$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $46b70126e6497d26$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $4ade84d9b7b6a594$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $46b70126e6497d26$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $46b70126e6497d26$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $46b70126e6497d26$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $46b70126e6497d26$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $46b70126e6497d26$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $46b70126e6497d26$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $46b70126e6497d26$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $ca0c84384b8b23d5$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $ca0c84384b8b23d5$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $bb091544218c2422$export$207c99ccf3902df8) + (0, $bb091544218c2422$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $ca0c84384b8b23d5$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $bb091544218c2422$export$852d1d4a47329634) + "#" + "]+$");
var $ca0c84384b8b23d5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $ca0c84384b8b23d5$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $e6fbb5d84511f017$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $ca0c84384b8b23d5$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $ca0c84384b8b23d5$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $bb091544218c2422$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $bb091544218c2422$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $a1f8752c4f3cd32b$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $13401f55428d37e4$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $ca0c84384b8b23d5$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $a8f2dd648e97fe5b$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $ca0c84384b8b23d5$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $ca0c84384b8b23d5$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $d3d926b62f621051$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($ca0c84384b8b23d5$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($ca0c84384b8b23d5$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $ca0c84384b8b23d5$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $4ade84d9b7b6a594$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $ca0c84384b8b23d5$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $d22af7acfc2f0108$export$2e2bcd8739ae039)(number)) {
        if ((0, $d22af7acfc2f0108$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $f65265fe1e6db889$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $ca0c84384b8b23d5$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $ca0c84384b8b23d5$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $2c1edb3f7d3b8cef$export$2e2bcd8739ae039)((0, $af1822d55479411a$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($ca0c84384b8b23d5$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $e6fbb5d84511f017$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $d650e373b3dd0ea7$export$2e2bcd8739ae039)((0, $af1822d55479411a$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $b4570bb92b85ccdd$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $d61da0a7a8d3e218$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d61da0a7a8d3e218$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d61da0a7a8d3e218$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d61da0a7a8d3e218$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d61da0a7a8d3e218$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d61da0a7a8d3e218$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d61da0a7a8d3e218$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $ca0c84384b8b23d5$export$2e2bcd8739ae039)(text, $d61da0a7a8d3e218$var$_objectSpread($d61da0a7a8d3e218$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}




function $67075222c993894d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $67075222c993894d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $67075222c993894d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $67075222c993894d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $67075222c993894d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $67075222c993894d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $67075222c993894d$export$2e2bcd8739ae039(text, options, metadata) {
    // Validate `defaultCountry`.
    if (options && options.defaultCountry && !(0, $e6fbb5d84511f017$export$bd9e113b8b17202a)(options.defaultCountry, metadata)) options = $67075222c993894d$var$_objectSpread($67075222c993894d$var$_objectSpread({}, options), {}, {
        defaultCountry: undefined
    });
     // Parse phone number.
    try {
        return (0, $d61da0a7a8d3e218$export$2e2bcd8739ae039)(text, options, metadata);
    } catch (error) {
        /* istanbul ignore else */ if (error instanceof (0, $d3d926b62f621051$export$2e2bcd8739ae039)) ;
        else throw error;
    }
}


function $6eaeaad4ed665394$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6eaeaad4ed665394$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6eaeaad4ed665394$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6eaeaad4ed665394$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6eaeaad4ed665394$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6eaeaad4ed665394$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6eaeaad4ed665394$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $5b2a4ba64c315cbc$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    options = $6eaeaad4ed665394$var$_objectSpread($6eaeaad4ed665394$var$_objectSpread({}, options), {}, {
        extract: false
    });
    var phoneNumber = (0, $67075222c993894d$export$2e2bcd8739ae039)(text, options, metadata);
    return phoneNumber && phoneNumber.isValid() || false;
}


function $4b02a3aa0d676adb$export$992e2df24bec72ba() {
    return (0, $bd8175273c79c979$export$2e2bcd8739ae039)((0, $6eaeaad4ed665394$export$2e2bcd8739ae039), arguments);
}




function $75098892ab1d2130$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $5b2a4ba64c315cbc$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $d61da0a7a8d3e218$export$2e2bcd8739ae039)(text, options, metadata);
}


function $2bc546ee6dbb8ac5$export$176bb591929cc9a8() {
    return (0, $bd8175273c79c979$export$2e2bcd8739ae039)((0, $75098892ab1d2130$export$2e2bcd8739ae039), arguments);
}





var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $hWP8m = parcelRequire("hWP8m");


var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $9u6aw = parcelRequire("9u6aw");

var $eZVvM = parcelRequire("eZVvM");







var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $32e460333a0042c0$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $32e460333a0042c0$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $32e460333a0042c0$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $32e460333a0042c0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $32e460333a0042c0$var$TextareaAutosize = /*#__PURE__*/ $eZVvM.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $7Z8DW.default)(props, $32e460333a0042c0$var$_excluded);
    const { current: isControlled } = $eZVvM.useRef(value != null);
    const inputRef = $eZVvM.useRef(null);
    const handleRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const heightRef = $eZVvM.useRef(null);
    const shadowRef = $eZVvM.useRef(null);
    const calculateTextareaStyles = $eZVvM.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $32e460333a0042c0$var$getStyleValue(computedStyle.paddingBottom) + $32e460333a0042c0$var$getStyleValue(computedStyle.paddingTop);
        const border = $32e460333a0042c0$var$getStyleValue(computedStyle.borderBottomWidth) + $32e460333a0042c0$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $eZVvM.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($32e460333a0042c0$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $cdd9f8889be8e555$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $95b4fb93ac7ed8b4$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)("textarea", (0, $65o8X.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $3pI8R.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $65o8X.default)({}, $32e460333a0042c0$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $32e460333a0042c0$export$2e2bcd8739ae039 = $32e460333a0042c0$var$TextareaAutosize;


function $444c1dee43ac56ee$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $8ff433bd507b8393$var$FormControlContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
var $8ff433bd507b8393$export$2e2bcd8739ae039 = $8ff433bd507b8393$var$FormControlContext;



var $eZVvM = parcelRequire("eZVvM");

"use client";
function $25d70ea28a10b810$export$2e2bcd8739ae039() {
    return $eZVvM.useContext((0, $8ff433bd507b8393$export$2e2bcd8739ae039));
}







"use client";
var $56e26d0f2548c6fe$export$2e2bcd8739ae039 = (0, $b625618202e2da7b$export$2e2bcd8739ae039);



var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");

parcelRequire("eZVvM");


var $jDDa9 = parcelRequire("jDDa9");


var $3pI8R = parcelRequire("3pI8R");
"use client";
function $7c8bdbbc0ef0e3aa$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $123cc06973765126$export$2e2bcd8739ae039)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $jDDa9.default), {
        styles: globalStyles
    });
}
var $7c8bdbbc0ef0e3aa$export$2e2bcd8739ae039 = $7c8bdbbc0ef0e3aa$var$GlobalStyles;





var $3pI8R = parcelRequire("3pI8R");
"use client";
function $d11e3b02afa92310$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7c8bdbbc0ef0e3aa$export$2e2bcd8739ae039), (0, $65o8X.default)({}, props, {
        defaultTheme: (0, $21d8dc776959fb7e$export$2e2bcd8739ae039),
        themeId: (0, $cd607e6564742347$export$2e2bcd8739ae039)
    }));
}
var $d11e3b02afa92310$export$2e2bcd8739ae039 = $d11e3b02afa92310$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $2a36f652fefb4086$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $2a36f652fefb4086$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($2a36f652fefb4086$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $2a36f652fefb4086$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $2a36f652fefb4086$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $10069671872fbce9$export$ef57d5c8ca2278f6(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiInputBase", slot);
}
const $10069671872fbce9$var$inputBaseClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $10069671872fbce9$export$2e2bcd8739ae039 = $10069671872fbce9$var$inputBaseClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $2ae777ca6f95078f$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $2ae777ca6f95078f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $2ae777ca6f95078f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $2ae777ca6f95078f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $10069671872fbce9$export$ef57d5c8ca2278f6), classes);
};
const $2ae777ca6f95078f$export$298a043133d72a38 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $2ae777ca6f95078f$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $10069671872fbce9$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $2ae777ca6f95078f$export$a1ad29c901026019 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $2ae777ca6f95078f$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $65o8X.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $65o8X.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $10069671872fbce9$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $10069671872fbce9$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $2ae777ca6f95078f$var$inputGlobalStyles = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d11e3b02afa92310$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $2ae777ca6f95078f$var$InputBase = /*#__PURE__*/ $eZVvM.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $7Z8DW.default)(props, $2ae777ca6f95078f$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $eZVvM.useRef(value != null);
    const inputRef = $eZVvM.useRef();
    const handleInputRefWarning = $eZVvM.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $eZVvM.useState(false);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $eZVvM.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $eZVvM.useCallback((obj)=>{
        if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $9u6aw.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $eZVvM.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $65o8X.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $65o8X.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $32e460333a0042c0$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $eZVvM.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $2ae777ca6f95078f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $2ae777ca6f95078f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $2ae777ca6f95078f$export$a1ad29c901026019;
    inputProps = (0, $65o8X.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $2ae777ca6f95078f$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $3pI8R.jsxs)(Root, (0, $65o8X.default)({}, rootProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $65o8X.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $3pI8R.jsx)(Input, (0, $65o8X.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $65o8X.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $65o8X.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $2ae777ca6f95078f$export$2e2bcd8739ae039 = $2ae777ca6f95078f$var$InputBase;





var $65o8X = parcelRequire("65o8X");



function $6ed1fa5c66b8a143$export$cdb270390122322b(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiInput", slot);
}
const $6ed1fa5c66b8a143$var$inputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $6ed1fa5c66b8a143$export$2e2bcd8739ae039 = $6ed1fa5c66b8a143$var$inputClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $746043b2897ffa7d$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $746043b2897ffa7d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $6ed1fa5c66b8a143$export$cdb270390122322b), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $746043b2897ffa7d$var$InputRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $2ae777ca6f95078f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $65o8X.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).disabled}, .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $746043b2897ffa7d$var$InputInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})({});
const $746043b2897ffa7d$var$Input = /*#__PURE__*/ $eZVvM.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $746043b2897ffa7d$var$_excluded);
    const classes = $746043b2897ffa7d$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hWP8m.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $746043b2897ffa7d$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $746043b2897ffa7d$var$InputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$746043b2897ffa7d$var$Input.muiName = "Input";
var $746043b2897ffa7d$export$2e2bcd8739ae039 = $746043b2897ffa7d$var$Input;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $hWP8m = parcelRequire("hWP8m");







var $65o8X = parcelRequire("65o8X");



function $d04b109876522ebe$export$3331e419f1a48437(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFilledInput", slot);
}
const $d04b109876522ebe$var$filledInputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $d04b109876522ebe$export$2e2bcd8739ae039 = $d04b109876522ebe$var$filledInputClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4f39814fc95716c5$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $4f39814fc95716c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d04b109876522ebe$export$3331e419f1a48437), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $4f39814fc95716c5$var$FilledInputRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $2ae777ca6f95078f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $65o8X.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}, .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $d04b109876522ebe$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $4f39814fc95716c5$var$FilledInputInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $4f39814fc95716c5$var$FilledInput = /*#__PURE__*/ $eZVvM.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $4f39814fc95716c5$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $4f39814fc95716c5$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $hWP8m.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $4f39814fc95716c5$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $4f39814fc95716c5$var$FilledInputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$4f39814fc95716c5$var$FilledInput.muiName = "Input";
var $4f39814fc95716c5$export$2e2bcd8739ae039 = $4f39814fc95716c5$var$FilledInput;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $c78151445c4daad2$var$_span;
const $c78151445c4daad2$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $c78151445c4daad2$var$NotchedOutlineRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("fieldset", {
    shouldForwardProp: (0, $c549a1c63ae66a43$export$2e2bcd8739ae039)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $c78151445c4daad2$var$NotchedOutlineLegend = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("legend", {
    shouldForwardProp: (0, $c549a1c63ae66a43$export$2e2bcd8739ae039)
})(({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $65o8X.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $c78151445c4daad2$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $7Z8DW.default)(props, $c78151445c4daad2$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $65o8X.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c78151445c4daad2$var$NotchedOutlineRoot, (0, $65o8X.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($c78151445c4daad2$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                children: label
            }) : $c78151445c4daad2$var$_span || ($c78151445c4daad2$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}






var $65o8X = parcelRequire("65o8X");



function $02e8718168a8e608$export$89922944c7227687(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiOutlinedInput", slot);
}
const $02e8718168a8e608$var$outlinedInputClasses = (0, $65o8X.default)({}, (0, $10069671872fbce9$export$2e2bcd8739ae039), (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $02e8718168a8e608$export$2e2bcd8739ae039 = $02e8718168a8e608$var$outlinedInputClasses;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $361c4111f560ec07$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $361c4111f560ec07$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $02e8718168a8e608$export$89922944c7227687), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $361c4111f560ec07$var$OutlinedInputRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $2ae777ca6f95078f$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $65o8X.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).focused} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).error} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $02e8718168a8e608$export$2e2bcd8739ae039).disabled} .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $65o8X.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $361c4111f560ec07$var$NotchedOutlineRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $c78151445c4daad2$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $361c4111f560ec07$var$OutlinedInputInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $2ae777ca6f95078f$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $2ae777ca6f95078f$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $361c4111f560ec07$var$OutlinedInput = /*#__PURE__*/ $eZVvM.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $7Z8DW.default)(props, $361c4111f560ec07$var$_excluded);
    const classes = $361c4111f560ec07$var$useUtilityClasses(props);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $361c4111f560ec07$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $361c4111f560ec07$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), (0, $65o8X.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $3pI8R.jsx)($361c4111f560ec07$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $65o8X.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$361c4111f560ec07$var$OutlinedInput.muiName = "Input";
var $361c4111f560ec07$export$2e2bcd8739ae039 = $361c4111f560ec07$var$OutlinedInput;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");






var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");










function $df9a99952c00e9b4$export$f7d501e40371cd17(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFormLabel", slot);
}
const $df9a99952c00e9b4$var$formLabelClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $df9a99952c00e9b4$export$2e2bcd8739ae039 = $df9a99952c00e9b4$var$formLabelClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $baec0adc5cc19b6f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $baec0adc5cc19b6f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $df9a99952c00e9b4$export$f7d501e40371cd17), classes);
};
const $baec0adc5cc19b6f$export$aa5bc7f8a4705b27 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $65o8X.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $baec0adc5cc19b6f$var$AsteriskComponent = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $baec0adc5cc19b6f$var$FormLabel = /*#__PURE__*/ $eZVvM.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $7Z8DW.default)(props, $baec0adc5cc19b6f$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $baec0adc5cc19b6f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($baec0adc5cc19b6f$export$aa5bc7f8a4705b27, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $3pI8R.jsxs)($baec0adc5cc19b6f$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $baec0adc5cc19b6f$export$2e2bcd8739ae039 = $baec0adc5cc19b6f$var$FormLabel;







function $e5dfedf4cc54a909$export$c1c4b4545ad2ea5f(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiInputLabel", slot);
}
const $e5dfedf4cc54a909$var$inputLabelClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $e5dfedf4cc54a909$export$2e2bcd8739ae039 = $e5dfedf4cc54a909$var$inputLabelClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $a75413bd2bd509d5$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $a75413bd2bd509d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $e5dfedf4cc54a909$export$c1c4b4545ad2ea5f), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $a75413bd2bd509d5$var$InputLabelRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $baec0adc5cc19b6f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $df9a99952c00e9b4$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $65o8X.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $65o8X.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $65o8X.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $a75413bd2bd509d5$var$InputLabel = /*#__PURE__*/ $eZVvM.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $7Z8DW.default)(props, $a75413bd2bd509d5$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $a75413bd2bd509d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($a75413bd2bd509d5$var$InputLabelRoot, (0, $65o8X.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $a75413bd2bd509d5$export$2e2bcd8739ae039 = $a75413bd2bd509d5$var$InputLabel;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








var $eZVvM = parcelRequire("eZVvM");
function $ed5347ce345f45b7$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $eZVvM.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $3d74c99d23f8a3b2$export$2e2bcd8739ae039 = (0, $ed5347ce345f45b7$export$2e2bcd8739ae039);





function $573390ea71e0f4b6$export$149c8b8bab2289d1(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFormControl", slot);
}
const $573390ea71e0f4b6$var$formControlClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $573390ea71e0f4b6$export$2e2bcd8739ae039 = $573390ea71e0f4b6$var$formControlClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $0fad4ddd6eb88026$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $0fad4ddd6eb88026$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $573390ea71e0f4b6$export$149c8b8bab2289d1), classes);
};
const $0fad4ddd6eb88026$var$FormControlRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $65o8X.default)({}, styles.root, styles[`margin${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $0fad4ddd6eb88026$var$FormControl = /*#__PURE__*/ $eZVvM.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $0fad4ddd6eb88026$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $0fad4ddd6eb88026$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $eZVvM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $eZVvM.Children.forEach(children, (child)=>{
            if (!(0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $2a36f652fefb4086$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $eZVvM.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $eZVvM.Children.forEach(children, (child)=>{
            if (!(0, $3d74c99d23f8a3b2$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)(child.props, true) || (0, $2a36f652fefb4086$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $eZVvM.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $eZVvM.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($0fad4ddd6eb88026$var$FormControlRoot, (0, $65o8X.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $0fad4ddd6eb88026$export$2e2bcd8739ae039 = $0fad4ddd6eb88026$var$FormControl;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");









function $d93508d3cebe561c$export$a394fa61b1d583a9(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFormHelperText", slot);
}
const $d93508d3cebe561c$var$formHelperTextClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $d93508d3cebe561c$export$2e2bcd8739ae039 = $d93508d3cebe561c$var$formHelperTextClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
var $3e2316ee7e27c519$var$_span;
const $3e2316ee7e27c519$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $3e2316ee7e27c519$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d93508d3cebe561c$export$a394fa61b1d583a9), classes);
};
const $3e2316ee7e27c519$var$FormHelperTextRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $d93508d3cebe561c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $d93508d3cebe561c$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $3e2316ee7e27c519$var$FormHelperText = /*#__PURE__*/ $eZVvM.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $7Z8DW.default)(props, $3e2316ee7e27c519$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $3e2316ee7e27c519$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($3e2316ee7e27c519$var$FormHelperTextRoot, (0, $65o8X.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $3e2316ee7e27c519$var$_span || ($3e2316ee7e27c519$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $3e2316ee7e27c519$export$2e2bcd8739ae039 = $3e2316ee7e27c519$var$FormHelperText;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");



var $hWP8m = parcelRequire("hWP8m");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $9u6aw = parcelRequire("9u6aw");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");






var $815e6328e9787b0a$export$2e2bcd8739ae039 = (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039);




var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");







var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("2ZVAX");



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");






var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $4650e5b1f00f8b80$var$ListContext = /*#__PURE__*/ $eZVvM.createContext({});
var $4650e5b1f00f8b80$export$2e2bcd8739ae039 = $4650e5b1f00f8b80$var$ListContext;




function $1e420068fcdd564f$export$c6bd6795ed6e3203(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiList", slot);
}
const $1e420068fcdd564f$var$listClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $1e420068fcdd564f$export$2e2bcd8739ae039 = $1e420068fcdd564f$var$listClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b4c754b766f3049c$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $b4c754b766f3049c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $1e420068fcdd564f$export$c6bd6795ed6e3203), classes);
};
const $b4c754b766f3049c$var$ListRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $b4c754b766f3049c$var$List = /*#__PURE__*/ $eZVvM.forwardRef(function List(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $7Z8DW.default)(props, $b4c754b766f3049c$var$_excluded);
    const context = $eZVvM.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $b4c754b766f3049c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)($b4c754b766f3049c$var$ListRoot, (0, $65o8X.default)({
            as: component,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $b4c754b766f3049c$export$2e2bcd8739ae039 = $b4c754b766f3049c$var$List;



var $332af7b06d6ba7e1$export$2e2bcd8739ae039 = (0, $2b883556515dfdf6$export$2e2bcd8739ae039);





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c899ace137ef326b$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $c899ace137ef326b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $c899ace137ef326b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $c899ace137ef326b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$c899ace137ef326b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $c899ace137ef326b$var$MenuList = /*#__PURE__*/ $eZVvM.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $7Z8DW.default)(props, $c899ace137ef326b$var$_excluded);
    const listRef = $eZVvM.useRef(null);
    const textCriteriaRef = $eZVvM.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $eZVvM.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $332af7b06d6ba7e1$export$2e2bcd8739ae039)((0, $815e6328e9787b0a$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $c899ace137ef326b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $c899ace137ef326b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $c899ace137ef326b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $c899ace137ef326b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $c899ace137ef326b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eZVvM.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $eZVvM.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $eZVvM.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $b4c754b766f3049c$export$2e2bcd8739ae039), (0, $65o8X.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $c899ace137ef326b$export$2e2bcd8739ae039 = $c899ace137ef326b$var$MenuList;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");





















function $dca460790b1f8f85$export$88f455dd56c95edb(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiPopover", slot);
}
const $dca460790b1f8f85$var$popoverClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiPopover", [
    "root",
    "paper"
]);
var $dca460790b1f8f85$export$2e2bcd8739ae039 = $dca460790b1f8f85$var$popoverClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $a2e02f582907f016$var$_excluded = [
    "onEntering"
], $a2e02f582907f016$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $a2e02f582907f016$var$_excluded3 = [
    "slotProps"
];
function $a2e02f582907f016$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $a2e02f582907f016$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $a2e02f582907f016$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $a2e02f582907f016$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $a2e02f582907f016$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $dca460790b1f8f85$export$88f455dd56c95edb), classes);
};
const $a2e02f582907f016$export$bcce13685275fc99 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $010e20fed2f5ff9a$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $a2e02f582907f016$export$821346c38a2d9390 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $a2e02f582907f016$var$Popover = /*#__PURE__*/ $eZVvM.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $c673d3c31a06f300$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $a2e02f582907f016$var$_excluded), other = (0, $7Z8DW.default)(props, $a2e02f582907f016$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $eZVvM.useRef();
    const handlePaperRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $65o8X.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $a2e02f582907f016$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $eZVvM.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $a2e02f582907f016$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $a2e02f582907f016$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $a2e02f582907f016$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $eZVvM.useCallback((elemRect)=>{
        return {
            vertical: $a2e02f582907f016$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $a2e02f582907f016$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $eZVvM.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $a2e02f582907f016$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)($a2e02f582907f016$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $a2e02f582907f016$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $eZVvM.useState(open);
    const setPositioningStyles = $eZVvM.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $eZVvM.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $eZVvM.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $eZVvM.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $eZVvM.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $c67a96687a400a99$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $173ff66374ad2b51$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $815e6328e9787b0a$export$2e2bcd8739ae039)($a2e02f582907f016$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $a2e02f582907f016$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $a2e02f582907f016$export$821346c38a2d9390;
    const paperProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $65o8X.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $65o8X.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $7Z8DW.default)(_useSlotProps, $a2e02f582907f016$var$_excluded3);
    return /*#__PURE__*/ (0, $3pI8R.jsx)(RootSlot, (0, $65o8X.default)({}, rootProps, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $3pI8R.jsx)(TransitionComponent, (0, $65o8X.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $3pI8R.jsx)(PaperSlot, (0, $65o8X.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $a2e02f582907f016$export$2e2bcd8739ae039 = $a2e02f582907f016$var$Popover;






function $d77a4c1a4ae2ec6f$export$2cf86a63a84fe23d(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiMenu", slot);
}
const $d77a4c1a4ae2ec6f$var$menuClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $d77a4c1a4ae2ec6f$export$2e2bcd8739ae039 = $d77a4c1a4ae2ec6f$var$menuClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $99e7ab0961a065f0$var$_excluded = [
    "onEntering"
], $99e7ab0961a065f0$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $99e7ab0961a065f0$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $99e7ab0961a065f0$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $99e7ab0961a065f0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d77a4c1a4ae2ec6f$export$2cf86a63a84fe23d), classes);
};
const $99e7ab0961a065f0$var$MenuRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $a2e02f582907f016$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $99e7ab0961a065f0$export$4f7c51a5920c9f33 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $a2e02f582907f016$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $99e7ab0961a065f0$var$MenuMenuList = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $c899ace137ef326b$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $99e7ab0961a065f0$var$Menu = /*#__PURE__*/ $eZVvM.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $7Z8DW.default)(props.TransitionProps, $99e7ab0961a065f0$var$_excluded), other = (0, $7Z8DW.default)(props, $99e7ab0961a065f0$var$_excluded2);
    const isRtl = (0, $d97d98e83b9fa62c$export$b2dd014b6c321cb)();
    const ownerState = (0, $65o8X.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $99e7ab0961a065f0$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $eZVvM.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? "rtl" : "ltr"
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $eZVvM.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $99e7ab0961a065f0$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)($99e7ab0961a065f0$var$MenuRoot, (0, $65o8X.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $99e7ab0961a065f0$var$RTL_ORIGIN : $99e7ab0961a065f0$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $65o8X.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($99e7ab0961a065f0$var$MenuMenuList, (0, $65o8X.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $99e7ab0961a065f0$export$2e2bcd8739ae039 = $99e7ab0961a065f0$var$Menu;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







function $1c01fc5556175c1c$export$1ee13051fd9e2ab5(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiNativeSelect", slot);
}
const $1c01fc5556175c1c$var$nativeSelectClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $1c01fc5556175c1c$export$2e2bcd8739ae039 = $1c01fc5556175c1c$var$nativeSelectClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $708fde035a2604fb$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $708fde035a2604fb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $1c01fc5556175c1c$export$1ee13051fd9e2ab5), classes);
};
const $708fde035a2604fb$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $65o8X.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $708fde035a2604fb$var$NativeSelectSelect = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $c549a1c63ae66a43$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($708fde035a2604fb$export$c1eccd1617458c87);
const $708fde035a2604fb$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $65o8X.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $1c01fc5556175c1c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $708fde035a2604fb$var$NativeSelectIcon = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($708fde035a2604fb$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $708fde035a2604fb$var$NativeSelectInput = /*#__PURE__*/ $eZVvM.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $708fde035a2604fb$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $708fde035a2604fb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($708fde035a2604fb$var$NativeSelectSelect, (0, $65o8X.default)({
                ownerState: ownerState,
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $3pI8R.jsx)($708fde035a2604fb$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $708fde035a2604fb$export$2e2bcd8739ae039 = $708fde035a2604fb$var$NativeSelectInput;






var $eZVvM = parcelRequire("eZVvM");
"use client";
function $c06b8889293cbc6c$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $eZVvM.useRef(controlled !== undefined);
    const [valueState, setValue] = $eZVvM.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $eZVvM.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


"use client";
var $5fc2b53e4d223165$export$2e2bcd8739ae039 = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039);




function $4ee8094de686c7d7$export$2c0c1ee5a3392e(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiSelect", slot);
}
const $4ee8094de686c7d7$var$selectClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $4ee8094de686c7d7$export$2e2bcd8739ae039 = $4ee8094de686c7d7$var$selectClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $8ccecd0152d75a10$var$_span;
const $8ccecd0152d75a10$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $8ccecd0152d75a10$var$SelectSelect = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $708fde035a2604fb$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $4ee8094de686c7d7$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $8ccecd0152d75a10$var$SelectIcon = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $708fde035a2604fb$export$e7a817afd12a40d0));
const $8ccecd0152d75a10$var$SelectNativeInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("input", {
    shouldForwardProp: (prop)=>(0, $5af6b33d880b74bd$export$2e2bcd8739ae039)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $8ccecd0152d75a10$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $8ccecd0152d75a10$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $8ccecd0152d75a10$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $4ee8094de686c7d7$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $8ccecd0152d75a10$var$SelectInput = /*#__PURE__*/ $eZVvM.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $7Z8DW.default)(props, $8ccecd0152d75a10$var$_excluded);
    const [value, setValueState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $eZVvM.useRef(null);
    const displayRef = $eZVvM.useRef(null);
    const [displayNode, setDisplayNode] = $eZVvM.useState(null);
    const { current: isOpenControlled } = $eZVvM.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $eZVvM.useState();
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $eZVvM.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $eZVvM.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $eZVvM.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $eZVvM.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $eZVvM.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $815e6328e9787b0a$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $eZVvM.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $2a36f652fefb4086$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $eZVvM.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $9u6aw.default)(2));
            selected = value.some((v)=>$8ccecd0152d75a10$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $8ccecd0152d75a10$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $eZVvM.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $65o8X.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $8ccecd0152d75a10$var$useUtilityClasses(ownerState);
    const paperProps = (0, $65o8X.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectSelect, (0, $65o8X.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $8ccecd0152d75a10$var$isEmpty(display) ? $8ccecd0152d75a10$var$_span || ($8ccecd0152d75a10$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectNativeInput, (0, $65o8X.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $3pI8R.jsx)($8ccecd0152d75a10$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3pI8R.jsx)((0, $99e7ab0961a065f0$export$2e2bcd8739ae039), (0, $65o8X.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $65o8X.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $65o8X.default)({}, MenuProps.slotProps, {
                    paper: (0, $65o8X.default)({}, paperProps, {
                        style: (0, $65o8X.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $8ccecd0152d75a10$export$2e2bcd8739ae039 = $8ccecd0152d75a10$var$SelectInput;




parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a75f8309f0ea897a$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");










var $3pI8R = parcelRequire("3pI8R");
"use client";
const $22932f6b5a031346$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $22932f6b5a031346$var$_excluded2 = [
    "root"
];
const $22932f6b5a031346$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $22932f6b5a031346$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) && prop !== "variant",
    slot: "Root"
};
const $22932f6b5a031346$var$StyledInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $746043b2897ffa7d$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$StyledOutlinedInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $361c4111f560ec07$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$StyledFilledInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $4f39814fc95716c5$export$2e2bcd8739ae039), $22932f6b5a031346$var$styledRootConfig)("");
const $22932f6b5a031346$var$Select = /*#__PURE__*/ $eZVvM.forwardRef(function Select(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $a75f8309f0ea897a$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $7Z8DW.default)(props, $22932f6b5a031346$var$_excluded);
    const inputComponent = native ? (0, $708fde035a2604fb$export$2e2bcd8739ae039) : (0, $8ccecd0152d75a10$export$2e2bcd8739ae039);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $65o8X.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $22932f6b5a031346$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $7Z8DW.default)(classes, $22932f6b5a031346$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $3pI8R.jsx)($22932f6b5a031346$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($eZVvM.Fragment, {
        children: /*#__PURE__*/ $eZVvM.cloneElement(InputComponent, (0, $65o8X.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $65o8X.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $65o8X.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $hWP8m.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$22932f6b5a031346$var$Select.muiName = "Select";
var $22932f6b5a031346$export$2e2bcd8739ae039 = $22932f6b5a031346$var$Select;




function $d4174659c1bfcace$export$c1bdcbaf0596aeda(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTextField", slot);
}
const $d4174659c1bfcace$var$textFieldClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTextField", [
    "root"
]);
var $d4174659c1bfcace$export$2e2bcd8739ae039 = $d4174659c1bfcace$var$textFieldClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $ebb4e6a14e6dbf24$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $ebb4e6a14e6dbf24$var$variantComponent = {
    standard: (0, $746043b2897ffa7d$export$2e2bcd8739ae039),
    filled: (0, $4f39814fc95716c5$export$2e2bcd8739ae039),
    outlined: (0, $361c4111f560ec07$export$2e2bcd8739ae039)
};
const $ebb4e6a14e6dbf24$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d4174659c1bfcace$export$c1bdcbaf0596aeda), classes);
};
const $ebb4e6a14e6dbf24$var$TextFieldRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $ebb4e6a14e6dbf24$var$TextField = /*#__PURE__*/ $eZVvM.forwardRef(function TextField(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $7Z8DW.default)(props, $ebb4e6a14e6dbf24$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $ebb4e6a14e6dbf24$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $ebb4e6a14e6dbf24$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $3pI8R.jsx)(InputComponent, (0, $65o8X.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($ebb4e6a14e6dbf24$var$TextFieldRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a75413bd2bd509d5$export$2e2bcd8739ae039), (0, $65o8X.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $22932f6b5a031346$export$2e2bcd8739ae039), (0, $65o8X.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $3pI8R.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), (0, $65o8X.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $ebb4e6a14e6dbf24$export$2e2bcd8739ae039 = $ebb4e6a14e6dbf24$var$TextField;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
"use client";
const $22a6c89cdb3425e5$var$usePreviousProps = (value)=>{
    const ref = $eZVvM.useRef({});
    $eZVvM.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $22a6c89cdb3425e5$export$2e2bcd8739ae039 = $22a6c89cdb3425e5$var$usePreviousProps;


"use client";
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $282f8ba67d45d941$var$stripDiacritics(string) {
    return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}
function $282f8ba67d45d941$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = "any", stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $282f8ba67d45d941$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $282f8ba67d45d941$var$stripDiacritics(candidate);
            return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $282f8ba67d45d941$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $282f8ba67d45d941$var$defaultFilterOptions = $282f8ba67d45d941$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $282f8ba67d45d941$var$pageSize = 5;
const $282f8ba67d45d941$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
function $282f8ba67d45d941$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $282f8ba67d45d941$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = "Mui", autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = "useAutocomplete", defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $282f8ba67d45d941$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== "string") return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $eZVvM.useRef(false);
    const firstFocus = $eZVvM.useRef(true);
    const inputRef = $eZVvM.useRef(null);
    const listboxRef = $eZVvM.useRef(null);
    const [anchorEl, setAnchorEl] = $eZVvM.useState(null);
    const [focusedTag, setFocusedTag] = $eZVvM.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $eZVvM.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: "",
        name: componentName,
        state: "inputValue"
    });
    const [focused, setFocused] = $eZVvM.useState(false);
    const resetInputValue = $eZVvM.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = "";
        else if (newValue == null) newInputValue = "";
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === "string" ? optionLabel : "";
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, "reset");
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $c06b8889293cbc6c$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: "open"
    });
    const [inputPristine, setInputPristine] = $eZVvM.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? "" : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $22a6c89cdb3425e5$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $eZVvM.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusTag = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $eZVvM.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute("aria-disabled") === "true";
            if (option && option.hasAttribute("tabindex") && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === "next") nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason = "auto" })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute("aria-activedescendant");
        else inputRef.current.setAttribute("aria-activedescendant", `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute("role") !== "listbox") listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === "keyboard") option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse" && reason !== "touch") {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $7fad5769266b0294$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = "next", reason: reason = "auto" })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === "reset") return defaultHighlighted;
            if (diff === "start") return 0;
            if (diff === "end") return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== "reset") {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : "";
            const label2 = value2 ? getOptionLabel(value2) : "";
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $282f8ba67d45d941$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $eZVvM.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: "reset"
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $282f8ba67d45d941$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $282f8ba67d45d941$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: "reset"
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $7fad5769266b0294$export$2e2bcd8739ae039)((node)=>{
        (0, $54e94fe5aedb285c$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $eZVvM.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $eZVvM.useRef(false);
    const selectNewValue = (event, option, reasonProp = "selectOption", origin = "options")=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = $282f8ba67d45d941$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== "freeSolo") {
                newValue.splice(itemIndex, 1);
                reason = "removeOption";
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true") nextFocus += direction === "next" ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === "") handleClose(event, "toggleInput");
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === "" && direction === "previous") nextTag = value.length - 1;
        } else {
            nextTag += direction === "next" ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState("");
        if (onInputChange) onInputChange(event, "", "clear");
        handleValue(event, multiple ? [] : null, "clear");
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                "ArrowLeft",
                "ArrowRight"
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case "Home":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "End":
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: event
                        });
                    }
                    break;
                case "PageUp":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$282f8ba67d45d941$var$pageSize,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "PageDown":
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $282f8ba67d45d941$var$pageSize,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowDown":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: "next",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowUp":
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: "previous",
                        reason: "keyboard",
                        event: event
                    });
                    handleOpen(event);
                    break;
                case "ArrowLeft":
                    handleFocusTag(event, "previous");
                    break;
                case "ArrowRight":
                    handleFocusTag(event, "next");
                    break;
                case "Enter":
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, "selectOption");
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, "createOption", "freeSolo");
                    }
                    break;
                case "Escape":
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, "escape");
                    } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case "Backspace":
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                case "Delete":
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === "" && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, "removeOption", {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
        else if (autoSelect && freeSolo && inputValue !== "") selectNewValue(event, inputValue, "blur", "freeSolo");
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, "blur");
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, "input");
        }
        if (newValue === "") {
            if (!disableClearable && !multiple) handleValue(event, null, "clear");
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: "mouse"
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute("data-option-index")),
            reason: "touch"
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute("data-option-index"));
        selectNewValue(event, filteredOptions[index], "selectOption");
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "removeOption", {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, "toggleInput");
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute("id") !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === "" || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $65o8X.default)({
                "aria-owns": listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                "aria-activedescendant": popupOpen ? "" : null,
                "aria-autocomplete": autoComplete ? "both" : "list",
                "aria-controls": listboxAvailable ? `${id}-listbox` : undefined,
                "aria-expanded": listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: "off",
                ref: inputRef,
                autoCapitalize: "none",
                spellCheck: "false",
                role: "combobox",
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: "button",
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $65o8X.default)({
                key: index,
                "data-tag-index": index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: "listbox",
                id: `${id}-listbox`,
                "aria-labelledby": `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: "option",
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                "data-option-index": index,
                "aria-disabled": disabled,
                "aria-selected": selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $282f8ba67d45d941$export$2e2bcd8739ae039 = $282f8ba67d45d941$var$useAutocomplete;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");
var $ad13676242e47154$exports = {};
"use strict";
"use client";
Object.defineProperty($ad13676242e47154$exports, "__esModule", {
    value: true
});
$ad13676242e47154$exports.default = void 0;

var $ad13676242e47154$var$React = $ad13676242e47154$var$_interopRequireWildcard((parcelRequire("eZVvM")));
parcelRequire("aNuUP");
var $8kMfp = parcelRequire("8kMfp");
function $ad13676242e47154$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($ad13676242e47154$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $ad13676242e47154$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $ad13676242e47154$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $ad13676242e47154$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $ad13676242e47154$var$useTheme(defaultTheme = null) {
    const contextTheme = $ad13676242e47154$var$React.useContext($8kMfp.T);
    return !contextTheme || $ad13676242e47154$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $ad13676242e47154$var$_default = $ad13676242e47154$exports.default = $ad13676242e47154$var$useTheme;






var $eZVvM = parcelRequire("eZVvM");

var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");

function $d0ce3738840a2408$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $92b65ec046e98f4d$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $92b65ec046e98f4d$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $92b65ec046e98f4d$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $ad3f7a5a8482840f$export$8960430cfd85939f = Math.max;
var $ad3f7a5a8482840f$export$96ec731ed4dcb222 = Math.min;
var $ad3f7a5a8482840f$export$2077e0241d6afd3c = Math.round;



function $4b26ed5ce8100ea6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
}


function $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $eebe817f20e734af$export$2e2bcd8739ae039(node) {
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $b9b075552c2ee2ee$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $a9cc91b11697ab72$export$2e2bcd8739ae039(node) {
    if (node === (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(node) || !(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(node)) return (0, $eebe817f20e734af$export$2e2bcd8739ae039)(node);
    else return (0, $b9b075552c2ee2ee$export$2e2bcd8739ae039)(node);
}


function $7d7193fe56f182d8$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $52c660cda767c7d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e59b09d2eb8bea89$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)((0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element)).left + (0, $eebe817f20e734af$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $b8946eb1ad0de2f1$export$2e2bcd8739ae039(element) {
    return (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $8d0fcb165fc13a08$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $d0f350e126e8de99$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d0f350e126e8de99$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent) && $d0f350e126e8de99$var$isElementScaled(offsetParent);
    var documentElement = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $a9cc91b11697ab72$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $8ac7236a7bdef816$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $2b8f424b5adba263$export$2e2bcd8739ae039(element) {
    if ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $a574c050346a8ac4$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(node) && (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(node)) return node;
    return $a574c050346a8ac4$export$2e2bcd8739ae039((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(node));
}





function $0e12a92913d4c423$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a574c050346a8ac4$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8d0fcb165fc13a08$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($0e12a92913d4c423$export$2e2bcd8739ae039((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(target)));
}







function $96699daebcf0ac6c$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) >= 0;
}




function $79e7fa5afa96173f$var$getTrueOffsetParent(element) {
    if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $79e7fa5afa96173f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $4b26ed5ce8100ea6$export$2e2bcd8739ae039)());
    if (isIE && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $2b8f424b5adba263$export$2e2bcd8739ae039)(element);
    if ((0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $79e7fa5afa96173f$export$2e2bcd8739ae039(element) {
    var window = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element);
    var offsetParent = $79e7fa5afa96173f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $96699daebcf0ac6c$export$2e2bcd8739ae039)(offsetParent) && (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $79e7fa5afa96173f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $79e7fa5afa96173f$var$getContainingBlock(element) || window;
}


var $6f22ac8331a483e2$export$1e95b668f3b82d = "top";
var $6f22ac8331a483e2$export$40e543e69a8b3fbb = "bottom";
var $6f22ac8331a483e2$export$79ffe56a765070d2 = "right";
var $6f22ac8331a483e2$export$eabcd2c8791e7bf4 = "left";
var $6f22ac8331a483e2$export$dfb5619354ba860 = "auto";
var $6f22ac8331a483e2$export$aec2ce47c367b8c3 = [
    $6f22ac8331a483e2$export$1e95b668f3b82d,
    $6f22ac8331a483e2$export$40e543e69a8b3fbb,
    $6f22ac8331a483e2$export$79ffe56a765070d2,
    $6f22ac8331a483e2$export$eabcd2c8791e7bf4
];
var $6f22ac8331a483e2$export$b3571188c770cc5a = "start";
var $6f22ac8331a483e2$export$bd5df0f255a350f8 = "end";
var $6f22ac8331a483e2$export$390fd549c5303b4d = "clippingParents";
var $6f22ac8331a483e2$export$d7b7311ec04a3e8f = "viewport";
var $6f22ac8331a483e2$export$ae5ab1c730825774 = "popper";
var $6f22ac8331a483e2$export$ca50aac9f3ba507f = "reference";
var $6f22ac8331a483e2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6f22ac8331a483e2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6f22ac8331a483e2$export$b3571188c770cc5a,
        placement + "-" + $6f22ac8331a483e2$export$bd5df0f255a350f8
    ]);
}, []);
var $6f22ac8331a483e2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6f22ac8331a483e2$export$aec2ce47c367b8c3, [
    $6f22ac8331a483e2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6f22ac8331a483e2$export$b3571188c770cc5a,
        placement + "-" + $6f22ac8331a483e2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6f22ac8331a483e2$export$421679a7c3d56e = "beforeRead";
var $6f22ac8331a483e2$export$aafa59e2e03f2942 = "read";
var $6f22ac8331a483e2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $6f22ac8331a483e2$export$c65e99957a05207c = "beforeMain";
var $6f22ac8331a483e2$export$f22da7240b7add18 = "main";
var $6f22ac8331a483e2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6f22ac8331a483e2$export$8d4d2d70e7d46032 = "beforeWrite";
var $6f22ac8331a483e2$export$68d8715fc104d294 = "write";
var $6f22ac8331a483e2$export$70a6e5159acce2e6 = "afterWrite";
var $6f22ac8331a483e2$export$d087d3878fdf71d5 = [
    $6f22ac8331a483e2$export$421679a7c3d56e,
    $6f22ac8331a483e2$export$aafa59e2e03f2942,
    $6f22ac8331a483e2$export$6964f6c886723980,
    $6f22ac8331a483e2$export$c65e99957a05207c,
    $6f22ac8331a483e2$export$f22da7240b7add18,
    $6f22ac8331a483e2$export$bab79516f2d662fe,
    $6f22ac8331a483e2$export$8d4d2d70e7d46032,
    $6f22ac8331a483e2$export$68d8715fc104d294,
    $6f22ac8331a483e2$export$70a6e5159acce2e6
];


function $603713de06d15020$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $603713de06d15020$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $603713de06d15020$var$order(modifiers); // order based on phase
    return (0, $6f22ac8331a483e2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $bc094e3784c45654$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $7be418f0773d1592$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2abb20d7ea296a1b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $2abb20d7ea296a1b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $2abb20d7ea296a1b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2abb20d7ea296a1b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $2abb20d7ea296a1b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(reference) ? (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $0e12a92913d4c423$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $603713de06d15020$export$2e2bcd8739ae039)((0, $7be418f0773d1592$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2abb20d7ea296a1b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $d0f350e126e8de99$export$2e2bcd8739ae039)(reference, (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bc094e3784c45654$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2abb20d7ea296a1b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2abb20d7ea296a1b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2abb20d7ea296a1b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ee6b3e5d1222bd05$var$passive = {
    passive: true
};
function $ee6b3e5d1222bd05$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ee6b3e5d1222bd05$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ee6b3e5d1222bd05$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ee6b3e5d1222bd05$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ee6b3e5d1222bd05$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ee6b3e5d1222bd05$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ee6b3e5d1222bd05$var$effect,
    data: {}
};



function $87559d8954c2621c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6501fafdaa9fbf80$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $efeabed7f1253daf$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $036f2738b316629f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $6f22ac8331a483e2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $6f22ac8331a483e2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $6f22ac8331a483e2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $6f22ac8331a483e2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $6f22ac8331a483e2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $9f7f079db3eb0441$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $036f2738b316629f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $9f7f079db3eb0441$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $9f7f079db3eb0441$var$popperOffsets,
    data: {}
};










var $ba6260f5a8d7d967$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $ba6260f5a8d7d967$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $ad3f7a5a8482840f$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $ba6260f5a8d7d967$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
    var sideY = (0, $6f22ac8331a483e2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(popper);
            if ((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $6f22ac8331a483e2$export$1e95b668f3b82d) || (placement === (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) || placement === (0, $6f22ac8331a483e2$export$79ffe56a765070d2)) && variation === (0, $6f22ac8331a483e2$export$bd5df0f255a350f8)) {
            sideY = (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) || (placement === (0, $6f22ac8331a483e2$export$1e95b668f3b82d) || placement === (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)) && variation === (0, $6f22ac8331a483e2$export$bd5df0f255a350f8)) {
            sideX = (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $ba6260f5a8d7d967$var$unsetSides);
    var _ref4 = roundOffsets === true ? $ba6260f5a8d7d967$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $ba6260f5a8d7d967$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $ba6260f5a8d7d967$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $ba6260f5a8d7d967$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ba6260f5a8d7d967$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $ba6260f5a8d7d967$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $3518c1e74083d57a$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || !(0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $3518c1e74083d57a$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) || !(0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3518c1e74083d57a$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $3518c1e74083d57a$var$applyStyles,
    effect: $3518c1e74083d57a$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $3c1dca40ee13caa5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $3c1dca40ee13caa5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $6f22ac8331a483e2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $3c1dca40ee13caa5$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3c1dca40ee13caa5$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $3c1dca40ee13caa5$var$offset
};


var $da09f54b256866ad$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $da09f54b256866ad$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $da09f54b256866ad$var$hash[matched];
    });
}



var $f7c35de4d48611a4$var$hash = {
    start: "end",
    end: "start"
};
function $f7c35de4d48611a4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f7c35de4d48611a4$var$hash[matched];
    });
}







function $0dc71baccd59e88b$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d0ce3738840a2408$export$2e2bcd8739ae039)(element);
    var html = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $dcf20f4bb8fb2c9e$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f106b29f65555188$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $eebe817f20e734af$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e59b09d2eb8bea89$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $4e82368a640c40d5$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $92b65ec046e98f4d$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $8c9ef49674af264e$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $01683c672f46903f$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $01683c672f46903f$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $6f22ac8331a483e2$export$d7b7311ec04a3e8f) ? (0, $8c9ef49674af264e$export$2e2bcd8739ae039)((0, $0dc71baccd59e88b$export$2e2bcd8739ae039)(element, strategy)) : (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clippingParent) ? $01683c672f46903f$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $8c9ef49674af264e$export$2e2bcd8739ae039)((0, $f106b29f65555188$export$2e2bcd8739ae039)((0, $52c660cda767c7d2$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $01683c672f46903f$var$getClippingParents(element) {
    var clippingParents = (0, $0e12a92913d4c423$export$2e2bcd8739ae039)((0, $2b8f424b5adba263$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $b8946eb1ad0de2f1$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $92b65ec046e98f4d$export$1b3bfaa9684536aa)(element) ? (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4e82368a640c40d5$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $7d7193fe56f182d8$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $01683c672f46903f$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $01683c672f46903f$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $01683c672f46903f$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $01683c672f46903f$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $baddc6c5521d5e15$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $89c0491d5a2636c8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $baddc6c5521d5e15$export$2e2bcd8739ae039)(), paddingObject);
}


function $4389887f9718103c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $190a711189c6b251$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $6f22ac8331a483e2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $6f22ac8331a483e2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $6f22ac8331a483e2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $89c0491d5a2636c8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4389887f9718103c$export$2e2bcd8739ae039)(padding, (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) ? (0, $6f22ac8331a483e2$export$ca50aac9f3ba507f) : (0, $6f22ac8331a483e2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $01683c672f46903f$export$2e2bcd8739ae039)((0, $92b65ec046e98f4d$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $52c660cda767c7d2$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f2b4d85d6b0d7eb4$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $036f2738b316629f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $8c9ef49674af264e$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $6f22ac8331a483e2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $6f22ac8331a483e2$export$79ffe56a765070d2),
                (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
                (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $fa38cbc56ce873f6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $6f22ac8331a483e2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $6f22ac8331a483e2$export$368f9a87e87fa4e1) : (0, $6f22ac8331a483e2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $bf633ea20b60f266$var$getExpandedFallbackPlacements(placement) {
    if ((0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f7c35de4d48611a4$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f7c35de4d48611a4$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $bf633ea20b60f266$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $da09f54b256866ad$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $bf633ea20b60f266$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$dfb5619354ba860) ? (0, $fa38cbc56ce873f6$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(placement) === (0, $6f22ac8331a483e2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
            (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $6f22ac8331a483e2$export$79ffe56a765070d2) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $da09f54b256866ad$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bf633ea20b60f266$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $bf633ea20b60f266$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $b62df35d662a501c$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $d164fcd4acbd6bc6$export$f28d906d67a997f3(min, value, max) {
    return (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(min, (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(value, max));
}
function $d164fcd4acbd6bc6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d164fcd4acbd6bc6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $63491105a13ee82c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6501fafdaa9fbf80$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b62df35d662a501c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $6f22ac8331a483e2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $6f22ac8331a483e2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $baddc6c5521d5e15$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(tether ? (0, $ad3f7a5a8482840f$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $ad3f7a5a8482840f$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
            (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d164fcd4acbd6bc6$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $63491105a13ee82c$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $63491105a13ee82c$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $2935d5367238fc80$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $89c0491d5a2636c8$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4389887f9718103c$export$2e2bcd8739ae039)(padding, (0, $6f22ac8331a483e2$export$aec2ce47c367b8c3)));
};
function $2935d5367238fc80$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $87559d8954c2621c$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $efeabed7f1253daf$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2935d5367238fc80$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $8ac7236a7bdef816$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $6f22ac8331a483e2$export$1e95b668f3b82d) : (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb) : (0, $6f22ac8331a483e2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $79e7fa5afa96173f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d164fcd4acbd6bc6$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2935d5367238fc80$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4e82368a640c40d5$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2935d5367238fc80$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $2935d5367238fc80$var$arrow,
    effect: $2935d5367238fc80$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $b6b199cccd8b0717$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $b6b199cccd8b0717$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $6f22ac8331a483e2$export$1e95b668f3b82d),
        (0, $6f22ac8331a483e2$export$79ffe56a765070d2),
        (0, $6f22ac8331a483e2$export$40e543e69a8b3fbb),
        (0, $6f22ac8331a483e2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $b6b199cccd8b0717$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $190a711189c6b251$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $b6b199cccd8b0717$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $b6b199cccd8b0717$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $b6b199cccd8b0717$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $b6b199cccd8b0717$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $b6b199cccd8b0717$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $b6b199cccd8b0717$var$hide
};




var $216a443298308e45$export$d34966752335dd47 = [
    (0, $ee6b3e5d1222bd05$export$2e2bcd8739ae039),
    (0, $9f7f079db3eb0441$export$2e2bcd8739ae039),
    (0, $ba6260f5a8d7d967$export$2e2bcd8739ae039),
    (0, $3518c1e74083d57a$export$2e2bcd8739ae039),
    (0, $3c1dca40ee13caa5$export$2e2bcd8739ae039),
    (0, $bf633ea20b60f266$export$2e2bcd8739ae039),
    (0, $63491105a13ee82c$export$2e2bcd8739ae039),
    (0, $2935d5367238fc80$export$2e2bcd8739ae039),
    (0, $b6b199cccd8b0717$export$2e2bcd8739ae039)
];
var $216a443298308e45$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2abb20d7ea296a1b$export$ed5e13716264f202)({
    defaultModifiers: $216a443298308e45$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules








function $324dac256b289ae8$export$1b69b6cd0fa638a1(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiPopper", slot);
}
const $324dac256b289ae8$var$popperClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiPopper", [
    "root"
]);
var $324dac256b289ae8$export$2e2bcd8739ae039 = $324dac256b289ae8$var$popperClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $64d0853836321eb3$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $64d0853836321eb3$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $64d0853836321eb3$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $64d0853836321eb3$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $64d0853836321eb3$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $64d0853836321eb3$var$isVirtualElement(element) {
    return !$64d0853836321eb3$var$isHTMLElement(element);
}
const $64d0853836321eb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $324dac256b289ae8$export$1b69b6cd0fa638a1), classes);
};
const $64d0853836321eb3$var$defaultPopperOptions = {};
const $64d0853836321eb3$var$PopperTooltip = /*#__PURE__*/ $eZVvM.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $7Z8DW.default)(props, $64d0853836321eb3$var$_excluded);
    const tooltipRef = $eZVvM.useRef(null);
    const ownRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $eZVvM.useRef(null);
    const handlePopperRef = (0, $ff7ab293f0b0d361$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $eZVvM.useRef(handlePopperRef);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $eZVvM.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $64d0853836321eb3$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $eZVvM.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $eZVvM.useState($64d0853836321eb3$var$resolveAnchorEl(anchorEl));
    $eZVvM.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $eZVvM.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($64d0853836321eb3$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $b625618202e2da7b$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $216a443298308e45$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $65o8X.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $64d0853836321eb3$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $903cc469e8b3c0b5$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $3pI8R.jsx)(Root, (0, $65o8X.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $64d0853836321eb3$var$Popper = /*#__PURE__*/ $eZVvM.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $64d0853836321eb3$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7Z8DW.default)(props, $64d0853836321eb3$var$_excluded2);
    const [exited, setExited] = $eZVvM.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $64d0853836321eb3$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $64d0853836321eb3$var$isHTMLElement(resolvedAnchorEl) ? (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $f99b0b65b9b991aa$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d431bbc85d36d423$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($64d0853836321eb3$var$PopperTooltip, (0, $65o8X.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $65o8X.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $64d0853836321eb3$export$2e2bcd8739ae039 = $64d0853836321eb3$var$Popper;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $1760f7053664752f$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $1760f7053664752f$var$PopperRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $64d0853836321eb3$export$2e2bcd8739ae039), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $1760f7053664752f$var$Popper = /*#__PURE__*/ $eZVvM.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($ad13676242e47154$exports)))();
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $7Z8DW.default)(props, $1760f7053664752f$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $65o8X.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($1760f7053664752f$var$PopperRoot, (0, $65o8X.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $1760f7053664752f$export$2e2bcd8739ae039 = $1760f7053664752f$var$Popper;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








function $d67041776ab2240e$export$6816d4fc0981ec7(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiListSubheader", slot);
}
const $d67041776ab2240e$var$listSubheaderClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiListSubheader", [
    "root",
    "colorPrimary",
    "colorInherit",
    "gutters",
    "inset",
    "sticky"
]);
var $d67041776ab2240e$export$2e2bcd8739ae039 = $d67041776ab2240e$var$listSubheaderClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $582c74c86fa27313$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $582c74c86fa27313$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "default" && `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && "gutters",
            inset && "inset",
            !disableSticky && "sticky"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d67041776ab2240e$export$6816d4fc0981ec7), classes);
};
const $582c74c86fa27313$var$ListSubheaderRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("li", {
    name: "MuiListSubheader",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        boxSizing: "border-box",
        lineHeight: "48px",
        listStyle: "none",
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === "primary" && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === "inherit" && {
        color: "inherit"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: "sticky",
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $582c74c86fa27313$var$ListSubheader = /*#__PURE__*/ $eZVvM.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiListSubheader"
    });
    const { className: className, color: color = "default", component: component = "li", disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $7Z8DW.default)(props, $582c74c86fa27313$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $582c74c86fa27313$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($582c74c86fa27313$var$ListSubheaderRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$582c74c86fa27313$var$ListSubheader.muiSkipListHighlight = true;
var $582c74c86fa27313$export$2e2bcd8739ae039 = $582c74c86fa27313$var$ListSubheader;





var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");




parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $d6f52fd6c316c042$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");










function $dfc2caa43c166e10$export$31444911e4ee6fdd(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiChip", slot);
}
const $dfc2caa43c166e10$var$chipClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $dfc2caa43c166e10$export$2e2bcd8739ae039 = $dfc2caa43c166e10$var$chipClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $39eec2a383e148e0$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $39eec2a383e148e0$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            "label",
            `label${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}Color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $dfc2caa43c166e10$export$31444911e4ee6fdd), classes);
};
const $39eec2a383e148e0$var$ChipRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(variant)}Color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $65o8X.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: (0, $65o8X.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $65o8X.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: (0, $65o8X.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $dfc2caa43c166e10$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $39eec2a383e148e0$var$ChipLabel = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $39eec2a383e148e0$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $39eec2a383e148e0$var$Chip = /*#__PURE__*/ $eZVvM.forwardRef(function Chip(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $7Z8DW.default)(props, $39eec2a383e148e0$var$_excluded);
    const chipRef = $eZVvM.useRef(null);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $39eec2a383e148e0$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $39eec2a383e148e0$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $eZVvM.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $39eec2a383e148e0$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039) ? (0, $65o8X.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $eZVvM.isValidElement(deleteIconProp) ? /*#__PURE__*/ $eZVvM.cloneElement(deleteIconProp, {
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $3pI8R.jsx)((0, $d6f52fd6c316c042$export$2e2bcd8739ae039), {
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $eZVvM.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $eZVvM.cloneElement(avatarProp, {
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $eZVvM.isValidElement(iconProp)) icon = /*#__PURE__*/ $eZVvM.cloneElement(iconProp, {
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($39eec2a383e148e0$var$ChipRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $3pI8R.jsx)($39eec2a383e148e0$var$ChipLabel, {
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $39eec2a383e148e0$export$2e2bcd8739ae039 = $39eec2a383e148e0$var$Chip;












function $6f6b068b68b5f599$export$8ee01529667e66d9(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiAutocomplete", slot);
}
const $6f6b068b68b5f599$var$autocompleteClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiAutocomplete", [
    "root",
    "expanded",
    "fullWidth",
    "focused",
    "focusVisible",
    "tag",
    "tagSizeSmall",
    "tagSizeMedium",
    "hasPopupIcon",
    "hasClearIcon",
    "inputRoot",
    "input",
    "inputFocused",
    "endAdornment",
    "clearIndicator",
    "popupIndicator",
    "popupIndicatorOpen",
    "popper",
    "popperDisablePortal",
    "paper",
    "listbox",
    "loading",
    "noOptions",
    "option",
    "groupLabel",
    "groupUl"
]);
var $6f6b068b68b5f599$export$2e2bcd8739ae039 = $6f6b068b68b5f599$var$autocompleteClasses;





var $3pI8R = parcelRequire("3pI8R");
"use client";
var $ac6c22b4d4537c6c$var$_ClearIcon, $ac6c22b4d4537c6c$var$_ArrowDropDownIcon;
const $ac6c22b4d4537c6c$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $ac6c22b4d4537c6c$var$_excluded2 = [
    "ref"
], $ac6c22b4d4537c6c$var$_excluded3 = [
    "key"
], $ac6c22b4d4537c6c$var$_excluded4 = [
    "key"
];
const $ac6c22b4d4537c6c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            focused && "focused",
            fullWidth && "fullWidth",
            hasClearIcon && "hasClearIcon",
            hasPopupIcon && "hasPopupIcon"
        ],
        inputRoot: [
            "inputRoot"
        ],
        input: [
            "input",
            inputFocused && "inputFocused"
        ],
        tag: [
            "tag",
            `tagSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            "endAdornment"
        ],
        clearIndicator: [
            "clearIndicator"
        ],
        popupIndicator: [
            "popupIndicator",
            popupOpen && "popupIndicatorOpen"
        ],
        popper: [
            "popper",
            disablePortal && "popperDisablePortal"
        ],
        paper: [
            "paper"
        ],
        listbox: [
            "listbox"
        ],
        loading: [
            "loading"
        ],
        noOptions: [
            "noOptions"
        ],
        option: [
            "option"
        ],
        groupLabel: [
            "groupLabel"
        ],
        groupUl: [
            "groupUl"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $6f6b068b68b5f599$export$8ee01529667e66d9), classes);
};
const $ac6c22b4d4537c6c$var$AutocompleteRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused} .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: "visible"
    },
    /* Avoid double tap issue on iOS */ "@media (pointer: fine)": {
        [`&:hover .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: "visible"
        }
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: "calc(100% - 6px)"
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        "& .MuiInput-input": {
            padding: "4px 4px 4px 0px"
        }
    },
    [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $6ed1fa5c66b8a143$export$2e2bcd8739ae039).input}`]: {
            padding: "2px 4px 3px 0"
        }
    },
    [`& .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            padding: "7.5px 4px 7.5px 5px"
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $02e8718168a8e608$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px 2.5px 8px"
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).input}`]: {
            padding: "7px 4px"
        },
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).input}`]: {
            padding: "2.5px 4px"
        }
    },
    [`& .${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $d04b109876522ebe$export$2e2bcd8739ae039).root}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).hiddenLabel}.${(0, $10069671872fbce9$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: "ellipsis",
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: "100%"
            }
        },
        {
            props: {
                size: "small"
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: "calc(100% - 4px)"
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: "wrap"
                }
            }
        }
    ]
});
const $ac6c22b4d4537c6c$var$AutocompleteEndAdornment = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "EndAdornment",
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translate(0, -50%)"
});
const $ac6c22b4d4537c6c$var$AutocompleteClearIndicator = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "ClearIndicator",
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: "hidden"
});
const $ac6c22b4d4537c6c$var$AutocompletePopupIndicator = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "PopupIndicator",
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $65o8X.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: "rotate(180deg)"
            }
        }
    ]
});
const $ac6c22b4d4537c6c$var$AutocompletePopper = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $1760f7053664752f$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Popper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: "absolute"
                }
            }
        ]
    }));
const $ac6c22b4d4537c6c$var$AutocompletePaper = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $08c3c2df346a18c6$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body1, {
        overflow: "auto"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteLoading = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Loading",
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteNoOptions = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "NoOptions",
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: "14px 16px"
    }));
const $ac6c22b4d4537c6c$var$AutocompleteListbox = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiAutocomplete",
    slot: "Listbox",
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: "none",
        margin: 0,
        padding: "8px 0",
        maxHeight: "40vh",
        overflow: "auto",
        position: "relative",
        [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up("sm")]: {
                minHeight: "auto"
            },
            [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: "none"
            },
            [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    "@media (hover: none)": {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $ac6c22b4d4537c6c$var$AutocompleteGroupLabel = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $582c74c86fa27313$export$2e2bcd8739ae039), {
    name: "MuiAutocomplete",
    slot: "GroupLabel",
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $ac6c22b4d4537c6c$var$AutocompleteGroupUl = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("ul", {
    name: "MuiAutocomplete",
    slot: "GroupUl",
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $6f6b068b68b5f599$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $ac6c22b4d4537c6c$var$Autocomplete = /*#__PURE__*/ $eZVvM.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiAutocomplete"
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $ac6c22b4d4537c6c$var$_ClearIcon || ($ac6c22b4d4537c6c$var$_ClearIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $12bec17d627bfb46$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = "Clear", closeText: closeText = "Close", componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = "auto", freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = "ul", ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = "No options", openOnFocus: openOnFocus = false, openText: openText = "Open", PaperComponent: PaperComponent = (0, $08c3c2df346a18c6$export$2e2bcd8739ae039), PopperComponent: PopperComponent = (0, $1760f7053664752f$export$2e2bcd8739ae039), popupIcon: popupIcon = $ac6c22b4d4537c6c$var$_ArrowDropDownIcon || ($ac6c22b4d4537c6c$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $a75f8309f0ea897a$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = "medium", slotProps: slotProps = {} } = props, other = (0, $7Z8DW.default)(props, $ac6c22b4d4537c6c$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $282f8ba67d45d941$export$2e2bcd8739ae039)((0, $65o8X.default)({}, props, {
        componentName: "Autocomplete"
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $7Z8DW.default)(_getListboxProps, $ac6c22b4d4537c6c$var$_excluded2);
    const combinedListboxRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $65o8X.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $ac6c22b4d4537c6c$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $65o8X.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $7Z8DW.default)(_getCustomizedTagProp, $ac6c22b4d4537c6c$var$_excluded3);
            return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $39eec2a383e148e0$export$2e2bcd8739ae039), (0, $65o8X.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $3pI8R.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $7Z8DW.default)(props2, $ac6c22b4d4537c6c$var$_excluded4);
        return /*#__PURE__*/ (0, $3pI8R.jsx)("li", (0, $65o8X.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $65o8X.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps["aria-selected"],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    const renderAutocompletePopperChildren = (children)=>/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePopper, (0, $65o8X.default)({
            as: PopperComponent,
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            ownerState: ownerState,
            role: "presentation",
            anchorEl: anchorEl,
            open: popupOpen
        }, popperSlotProps, {
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
            children: /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePaper, (0, $65o8X.default)({
                ownerState: ownerState,
                as: PaperComponent
            }, paperSlotProps, {
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                children: children
            }))
        }));
    let autocompletePopper = null;
    if (groupedOptions.length > 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteListbox, (0, $65o8X.default)({
        as: ListboxComponent,
        className: classes.listbox,
        ownerState: ownerState
    }, otherListboxProps, ListboxProps, {
        ref: combinedListboxRef,
        children: groupedOptions.map((option, index)=>{
            if (groupBy) return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
            });
            return renderListOption(option, index);
        })
    })));
    else if (loading && groupedOptions.length === 0) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteLoading, {
        className: classes.loading,
        ownerState: ownerState,
        children: loadingText
    }));
    else if (groupedOptions.length === 0 && !freeSolo && !loading) autocompletePopper = renderAutocompletePopperChildren(/*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteNoOptions, {
        className: classes.noOptions,
        ownerState: ownerState,
        role: "presentation",
        onMouseDown: (event)=>{
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
        },
        children: noOptionsText
    }));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteRoot, (0, $65o8X.default)({
                ref: ref,
                className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === "small" ? "small" : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $65o8X.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $3pI8R.jsxs)($ac6c22b4d4537c6c$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompleteClearIndicator, (0, $65o8X.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $3pI8R.jsx)($ac6c22b4d4537c6c$var$AutocompletePopupIndicator, (0, $65o8X.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $65o8X.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? autocompletePopper : null
        ]
    });
});
var $ac6c22b4d4537c6c$export$2e2bcd8739ae039 = $ac6c22b4d4537c6c$var$Autocomplete;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");












function $b643b5f13809fc1c$export$46f01d01378ec5a2(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiDivider", slot);
}
const $b643b5f13809fc1c$var$dividerClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $b643b5f13809fc1c$export$2e2bcd8739ae039 = $b643b5f13809fc1c$var$dividerClasses;




function $5e9fb9532a3d4425$export$81478e24460c57f2(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiListItemIcon", slot);
}
const $5e9fb9532a3d4425$var$listItemIconClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $5e9fb9532a3d4425$export$2e2bcd8739ae039 = $5e9fb9532a3d4425$var$listItemIconClasses;




function $12bfc73a3b0677c5$export$1061006a0db3aeb5(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiListItemText", slot);
}
const $12bfc73a3b0677c5$var$listItemTextClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $12bfc73a3b0677c5$export$2e2bcd8739ae039 = $12bfc73a3b0677c5$var$listItemTextClasses;




function $0258ddb2b5125a4d$export$515f8c67b5305377(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiMenuItem", slot);
}
const $0258ddb2b5125a4d$var$menuItemClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $0258ddb2b5125a4d$export$2e2bcd8739ae039 = $0258ddb2b5125a4d$var$menuItemClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $0f9712359a52dd90$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $0f9712359a52dd90$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $0f9712359a52dd90$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $0258ddb2b5125a4d$export$515f8c67b5305377), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $0f9712359a52dd90$var$MenuItemRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $0f9712359a52dd90$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0258ddb2b5125a4d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $b643b5f13809fc1c$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $b643b5f13809fc1c$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $5e9fb9532a3d4425$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $65o8X.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $5e9fb9532a3d4425$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $0f9712359a52dd90$var$MenuItem = /*#__PURE__*/ $eZVvM.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $7Z8DW.default)(props, $0f9712359a52dd90$var$_excluded);
    const context = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    const childContext = $eZVvM.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $eZVvM.useRef(null);
    (0, $56e26d0f2548c6fe$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $65o8X.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $0f9712359a52dd90$var$useUtilityClasses(props);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($0f9712359a52dd90$var$MenuItemRoot, (0, $65o8X.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $0f9712359a52dd90$export$2e2bcd8739ae039 = $0f9712359a52dd90$var$MenuItem;






var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");



var $hWP8m = parcelRequire("hWP8m");




function $138a13ba53116fa6$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $6860b88ec3aae518$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



"use client";
function $053d2b2b00af7ed9$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $123cc06973765126$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $138a13ba53116fa6$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $bU7jb = parcelRequire("bU7jb");

var $gnWEo = parcelRequire("gnWEo");

var $ivlTt = parcelRequire("ivlTt");

var $fwBcG = parcelRequire("fwBcG");

var $3pI8R = parcelRequire("3pI8R");
const $970a1f0778f3124f$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $970a1f0778f3124f$var$defaultTheme = (0, $gnWEo.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $970a1f0778f3124f$var$defaultCreateStyledComponent = (0, $4d9b9f946ff41bcb$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $970a1f0778f3124f$var$useThemePropsDefault(props) {
    return (0, $053d2b2b00af7ed9$export$2e2bcd8739ae039)({
        props: props,
        name: "MuiStack",
        defaultTheme: $970a1f0778f3124f$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $970a1f0778f3124f$var$joinChildren(children, separator) {
    const childrenArray = $eZVvM.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $eZVvM.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $970a1f0778f3124f$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $970a1f0778f3124f$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $65o8X.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $ivlTt.handleBreakpoints)({
        theme: theme
    }, (0, $ivlTt.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $fwBcG.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $ivlTt.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $ivlTt.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $fwBcG.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$970a1f0778f3124f$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $fwBcG.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $hWP8m.default)(styles, (0, $ivlTt.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $ivlTt.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $970a1f0778f3124f$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $970a1f0778f3124f$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $970a1f0778f3124f$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (slot)=>(0, $66fff2ea26bc86db$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($970a1f0778f3124f$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $eZVvM.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $bU7jb.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $7Z8DW.default)(props, $970a1f0778f3124f$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $3pI8R.jsx)(StackRoot, (0, $65o8X.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $dc40de7e626e5d14$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: divider ? $970a1f0778f3124f$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}




"use client";
const $f0699641ce52b51c$var$Stack = (0, $970a1f0778f3124f$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $64582037ee8abf00$export$2440da353cedad43)({
            props: inProps,
            name: "MuiStack"
        })
});
var $f0699641ce52b51c$export$2e2bcd8739ae039 = $f0699641ce52b51c$var$Stack;








function $b3c4c9e9e0e292ea$export$717666c39ec07e12(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFormControlLabel", slot);
}
const $b3c4c9e9e0e292ea$var$formControlLabelClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $b3c4c9e9e0e292ea$export$2e2bcd8739ae039 = $b3c4c9e9e0e292ea$var$formControlLabelClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $22c108142293b90b$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $22c108142293b90b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $b3c4c9e9e0e292ea$export$717666c39ec07e12), classes);
};
const $22c108142293b90b$export$1b479270917a5676 = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $b3c4c9e9e0e292ea$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $b3c4c9e9e0e292ea$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $b3c4c9e9e0e292ea$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $b3c4c9e9e0e292ea$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $22c108142293b90b$var$AsteriskComponent = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $b3c4c9e9e0e292ea$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $22c108142293b90b$var$FormControlLabel = /*#__PURE__*/ $eZVvM.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $7Z8DW.default)(props, $22c108142293b90b$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $22c108142293b90b$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $5d7bd7102f196281$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), (0, $65o8X.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($22c108142293b90b$export$1b479270917a5676, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $eZVvM.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $3pI8R.jsxs)((0, $f0699641ce52b51c$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $3pI8R.jsxs)($22c108142293b90b$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $22c108142293b90b$export$2e2bcd8739ae039 = $22c108142293b90b$var$FormControlLabel;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");






var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");











function $4dd9513b92b0b8db$export$baa0faa0c7ad8085(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("PrivateSwitchBase", slot);
}
const $4dd9513b92b0b8db$var$switchBaseClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $4dd9513b92b0b8db$export$2e2bcd8739ae039 = $4dd9513b92b0b8db$var$switchBaseClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $07988f80e068cbf3$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $07988f80e068cbf3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $4dd9513b92b0b8db$export$baa0faa0c7ad8085), classes);
};
const $07988f80e068cbf3$var$SwitchBaseRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $4a8b8bf1c0ac0824$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $65o8X.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $07988f80e068cbf3$var$SwitchBaseInput = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("input", {
    shouldForwardProp: (0, $c549a1c63ae66a43$export$2e2bcd8739ae039)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $07988f80e068cbf3$var$SwitchBase = /*#__PURE__*/ $eZVvM.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $7Z8DW.default)(props, $07988f80e068cbf3$var$_excluded);
    const [checked, setCheckedState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $65o8X.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $07988f80e068cbf3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($07988f80e068cbf3$var$SwitchBaseRoot, (0, $65o8X.default)({
        component: "span",
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($07988f80e068cbf3$var$SwitchBaseInput, (0, $65o8X.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $07988f80e068cbf3$export$2e2bcd8739ae039 = $07988f80e068cbf3$var$SwitchBase;


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $2cc6721f39522de9$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $eb16aa1a8436efbc$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $7b79135c268f5931$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");







function $9b8c5f614bd838a3$export$6c57c6e16b4063b(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiCheckbox", slot);
}
const $9b8c5f614bd838a3$var$checkboxClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiCheckbox", [
    "root",
    "checked",
    "disabled",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium"
]);
var $9b8c5f614bd838a3$export$2e2bcd8739ae039 = $9b8c5f614bd838a3$var$checkboxClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $8ae3ab071636d4be$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $8ae3ab071636d4be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            indeterminate && "indeterminate",
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $9b8c5f614bd838a3$export$6c57c6e16b4063b), classes);
    return (0, $65o8X.default)({}, classes, composedClasses);
};
const $8ae3ab071636d4be$var$CheckboxRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $07988f80e068cbf3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiCheckbox",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== "default" && styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $9b8c5f614bd838a3$export$2e2bcd8739ae039).checked}, &.${(0, $9b8c5f614bd838a3$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9b8c5f614bd838a3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $8ae3ab071636d4be$var$defaultCheckedIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $eb16aa1a8436efbc$export$2e2bcd8739ae039), {});
const $8ae3ab071636d4be$var$defaultIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2cc6721f39522de9$export$2e2bcd8739ae039), {});
const $8ae3ab071636d4be$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7b79135c268f5931$export$2e2bcd8739ae039), {});
const $8ae3ab071636d4be$var$Checkbox = /*#__PURE__*/ $eZVvM.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiCheckbox"
    });
    const { checkedIcon: checkedIcon = $8ae3ab071636d4be$var$defaultCheckedIcon, color: color = "primary", icon: iconProp = $8ae3ab071636d4be$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $8ae3ab071636d4be$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = "medium", className: className } = props, other = (0, $7Z8DW.default)(props, $8ae3ab071636d4be$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $8ae3ab071636d4be$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($8ae3ab071636d4be$var$CheckboxRoot, (0, $65o8X.default)({
        type: "checkbox",
        inputProps: (0, $65o8X.default)({
            "data-indeterminate": indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $eZVvM.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $eZVvM.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $8ae3ab071636d4be$export$2e2bcd8739ae039 = $8ae3ab071636d4be$var$Checkbox;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







function $f7e6503e48cf2694$export$d72d4cbdc30b331f(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiFormGroup", slot);
}
const $f7e6503e48cf2694$var$formGroupClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiFormGroup", [
    "root",
    "row",
    "error"
]);
var $f7e6503e48cf2694$export$2e2bcd8739ae039 = $f7e6503e48cf2694$var$formGroupClasses;





var $3pI8R = parcelRequire("3pI8R");
"use client";
const $18c672662b2cbd45$var$_excluded = [
    "className",
    "row"
];
const $18c672662b2cbd45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $f7e6503e48cf2694$export$d72d4cbdc30b331f), classes);
};
const $18c672662b2cbd45$var$FormGroupRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiFormGroup",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap"
    }, ownerState.row && {
        flexDirection: "row"
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $18c672662b2cbd45$var$FormGroup = /*#__PURE__*/ $eZVvM.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiFormGroup"
    });
    const { className: className, row: row = false } = props, other = (0, $7Z8DW.default)(props, $18c672662b2cbd45$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)();
    const fcs = (0, $444c1dee43ac56ee$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $65o8X.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $18c672662b2cbd45$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($18c672662b2cbd45$var$FormGroupRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $18c672662b2cbd45$export$2e2bcd8739ae039 = $18c672662b2cbd45$var$FormGroup;




function $d457e1b50446f41b$export$c4cff3a43f7cabb6(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiRadioGroup", slot);
}
const $d457e1b50446f41b$var$radioGroupClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiRadioGroup", [
    "root",
    "row",
    "error"
]);
var $d457e1b50446f41b$export$2e2bcd8739ae039 = $d457e1b50446f41b$var$radioGroupClasses;





var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $f23e5848acee15d4$var$RadioGroupContext = /*#__PURE__*/ $eZVvM.createContext(undefined);
var $f23e5848acee15d4$export$2e2bcd8739ae039 = $f23e5848acee15d4$var$RadioGroupContext;



"use client";
var $a58721cd01f32473$export$2e2bcd8739ae039 = (0, $a2ea28bfa453c5f2$export$2e2bcd8739ae039);



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $e1871041eddbc6dd$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $e1871041eddbc6dd$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            "root",
            row && "row",
            error && "error"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d457e1b50446f41b$export$c4cff3a43f7cabb6), classes);
};
const $e1871041eddbc6dd$var$RadioGroup = /*#__PURE__*/ $eZVvM.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $7Z8DW.default)(props, $e1871041eddbc6dd$var$_excluded);
    const rootRef = $eZVvM.useRef(null);
    const classes = $e1871041eddbc6dd$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $5fc2b53e4d223165$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "RadioGroup"
    });
    $eZVvM.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector("input:not(:disabled):checked");
                if (!input) input = rootRef.current.querySelector("input:not(:disabled)");
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $f19448b4821cb7b2$export$2e2bcd8739ae039)(ref, rootRef);
    const name = (0, $a58721cd01f32473$export$2e2bcd8739ae039)(nameProp);
    const contextValue = $eZVvM.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $f23e5848acee15d4$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)((0, $18c672662b2cbd45$export$2e2bcd8739ae039), (0, $65o8X.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
var $e1871041eddbc6dd$export$2e2bcd8739ae039 = $e1871041eddbc6dd$var$RadioGroup;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








var $65o8X = parcelRequire("65o8X");
parcelRequire("eZVvM");

parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $5e26989a382a7a73$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $a3c2e6fa8a2e0489$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked");




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4008299d7fbe9aeb$var$RadioButtonIconRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span", {
    shouldForwardProp: (0, $c549a1c63ae66a43$export$2e2bcd8739ae039)
})({
    position: "relative",
    display: "flex"
});
const $4008299d7fbe9aeb$var$RadioButtonIconBackground = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5e26989a382a7a73$export$2e2bcd8739ae039))({
    // Scale applied to prevent dot misalignment in Safari
    transform: "scale(1)"
});
const $4008299d7fbe9aeb$var$RadioButtonIconDot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $a3c2e6fa8a2e0489$export$2e2bcd8739ae039))(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        left: 0,
        position: "absolute",
        transform: "scale(0)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $4008299d7fbe9aeb$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $65o8X.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($4008299d7fbe9aeb$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $3pI8R.jsx)($4008299d7fbe9aeb$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $3pI8R.jsx)($4008299d7fbe9aeb$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $4008299d7fbe9aeb$export$2e2bcd8739ae039 = $4008299d7fbe9aeb$var$RadioButtonIcon;




var $4ab1d1120469c97b$export$2e2bcd8739ae039 = (0, $c9bdc9b352c474f0$export$2e2bcd8739ae039);



var $eZVvM = parcelRequire("eZVvM");

"use client";
function $7d56ce9e599a7240$export$2e2bcd8739ae039() {
    return $eZVvM.useContext((0, $f23e5848acee15d4$export$2e2bcd8739ae039));
}




function $f60228c5443d33e4$export$192f7b2363c77155(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiRadio", slot);
}
const $f60228c5443d33e4$var$radioClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiRadio", [
    "root",
    "checked",
    "disabled",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall"
]);
var $f60228c5443d33e4$export$2e2bcd8739ae039 = $f60228c5443d33e4$var$radioClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9e28f53eb94d78d4$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $9e28f53eb94d78d4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(color)}`,
            size !== "medium" && `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $65o8X.default)({}, classes, (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $f60228c5443d33e4$export$192f7b2363c77155), classes));
};
const $9e28f53eb94d78d4$var$RadioRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $07988f80e068cbf3$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $c549a1c63ae66a43$export$2e2bcd8739ae039)(prop) || prop === "classes",
    name: "MuiRadio",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== "medium" && styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`color${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === "default" ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(ownerState.color === "default" ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $f60228c5443d33e4$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $f60228c5443d33e4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $9e28f53eb94d78d4$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $9e28f53eb94d78d4$var$defaultCheckedIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4008299d7fbe9aeb$export$2e2bcd8739ae039), {
    checked: true
});
const $9e28f53eb94d78d4$var$defaultIcon = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $4008299d7fbe9aeb$export$2e2bcd8739ae039), {});
const $9e28f53eb94d78d4$var$Radio = /*#__PURE__*/ $eZVvM.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiRadio"
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $9e28f53eb94d78d4$var$defaultCheckedIcon, color: color = "primary", icon: icon = $9e28f53eb94d78d4$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = "medium", className: className } = props, other = (0, $7Z8DW.default)(props, $9e28f53eb94d78d4$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $9e28f53eb94d78d4$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $7d56ce9e599a7240$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $4ab1d1120469c97b$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === "undefined") checked = $9e28f53eb94d78d4$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === "undefined") name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $3pI8R.jsx)($9e28f53eb94d78d4$var$RadioRoot, (0, $65o8X.default)({
        type: "radio",
        icon: /*#__PURE__*/ $eZVvM.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $9e28f53eb94d78d4$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $eZVvM.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $9e28f53eb94d78d4$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $9e28f53eb94d78d4$export$2e2bcd8739ae039 = $9e28f53eb94d78d4$var$Radio;





var $3pI8R = parcelRequire("3pI8R");

var $eZVvM = parcelRequire("eZVvM");






var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");








var $3pI8R = parcelRequire("3pI8R");
"use client";
const $b8d8870a92540e83$var$_excluded = [
    "className"
];
const $b8d8870a92540e83$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            alignItems === "flex-start" && "alignItemsFlexStart"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $5e9fb9532a3d4425$export$81478e24460c57f2), classes);
};
const $b8d8870a92540e83$var$ListItemIconRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: "inline-flex"
    }, ownerState.alignItems === "flex-start" && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $b8d8870a92540e83$var$ListItemIcon = /*#__PURE__*/ $eZVvM.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiListItemIcon"
    });
    const { className: className } = props, other = (0, $7Z8DW.default)(props, $b8d8870a92540e83$var$_excluded);
    const context = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    const ownerState = (0, $65o8X.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $b8d8870a92540e83$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($b8d8870a92540e83$var$ListItemIconRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $b8d8870a92540e83$export$2e2bcd8739ae039 = $b8d8870a92540e83$var$ListItemIcon;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");









var $3pI8R = parcelRequire("3pI8R");
"use client";
const $f4c2a1be62dbd0c3$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $f4c2a1be62dbd0c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $12bfc73a3b0677c5$export$1061006a0db3aeb5), classes);
};
const $f4c2a1be62dbd0c3$var$ListItemTextRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $12bfc73a3b0677c5$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $65o8X.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $f4c2a1be62dbd0c3$var$ListItemText = /*#__PURE__*/ $eZVvM.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $7Z8DW.default)(props, $f4c2a1be62dbd0c3$var$_excluded);
    const { dense: dense } = $eZVvM.useContext((0, $4650e5b1f00f8b80$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $65o8X.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $f4c2a1be62dbd0c3$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $5d7bd7102f196281$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), (0, $65o8X.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $5d7bd7102f196281$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), (0, $65o8X.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $3pI8R.jsxs)($f4c2a1be62dbd0c3$var$ListItemTextRoot, (0, $65o8X.default)({
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $f4c2a1be62dbd0c3$export$2e2bcd8739ae039 = $f4c2a1be62dbd0c3$var$ListItemText;




var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");










function $28bffe0f438cff3e$export$4b135a4b3a6c4550(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiInputAdornment", slot);
}
const $28bffe0f438cff3e$var$inputAdornmentClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $28bffe0f438cff3e$export$2e2bcd8739ae039 = $28bffe0f438cff3e$var$inputAdornmentClasses;




var $3pI8R = parcelRequire("3pI8R");
"use client";
var $2716b83202966b50$var$_span;
const $2716b83202966b50$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $2716b83202966b50$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $2716b83202966b50$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $28bffe0f438cff3e$export$4b135a4b3a6c4550), classes);
};
const $2716b83202966b50$var$InputAdornmentRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $2716b83202966b50$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $28bffe0f438cff3e$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $28bffe0f438cff3e$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $2716b83202966b50$var$InputAdornment = /*#__PURE__*/ $eZVvM.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $7Z8DW.default)(props, $2716b83202966b50$var$_excluded);
    const muiFormControl = (0, $25d70ea28a10b810$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $65o8X.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $2716b83202966b50$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $8ff433bd507b8393$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($2716b83202966b50$var$InputAdornmentRoot, (0, $65o8X.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $3pI8R.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $3pI8R.jsxs)($eZVvM.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $2716b83202966b50$var$_span || ($2716b83202966b50$var$_span = /*#__PURE__*/ (0, $3pI8R.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $2716b83202966b50$export$2e2bcd8739ae039 = $2716b83202966b50$var$InputAdornment;



const $bb50b4d24b214940$var$Dn = {
    Flag: (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("span")(()=>({
            display: "flex",
            alignItems: "center"
        }))
}, $bb50b4d24b214940$var$Re = "MuiTelInput-Flag", $bb50b4d24b214940$var$_e = ({ isoCode: t, children: n })=>/* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Dn.Flag, {
        "data-testid": t,
        className: $bb50b4d24b214940$var$Re,
        children: n
    }), $bb50b4d24b214940$var$q = "en", $bb50b4d24b214940$var$St = {
    EU: [
        "AD",
        "AL",
        "AT",
        "AX",
        "BA",
        "BE",
        "BG",
        "BY",
        "CH",
        "CY",
        "CZ",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FO",
        "FR",
        "GB",
        "GG",
        "GI",
        "GR",
        "HR",
        "HU",
        "IE",
        "IM",
        "IS",
        "IT",
        "JE",
        "LI",
        "LT",
        "LU",
        "LV",
        "MC",
        "MD",
        "ME",
        "MK",
        "MT",
        "NL",
        "NO",
        "PL",
        "PT",
        "RO",
        "RS",
        "RU",
        "SE",
        "SI",
        "SJ",
        "SK",
        "SM",
        "UA",
        "VA",
        "XK"
    ],
    AS: [
        "AE",
        "AF",
        "AM",
        "AZ",
        "BD",
        "BH",
        "BN",
        "BT",
        "CC",
        "CN",
        "CX",
        "GE",
        "HK",
        "ID",
        "IL",
        "IN",
        "IO",
        "IQ",
        "IR",
        "JO",
        "JP",
        "KG",
        "KH",
        "KP",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "MM",
        "MN",
        "MO",
        "MV",
        "MY",
        "NP",
        "OM",
        "PH",
        "PK",
        "PS",
        "QA",
        "SA",
        "SG",
        "SY",
        "TH",
        "TJ",
        "TM",
        "TR",
        "TW",
        "UZ",
        "VN",
        "YE"
    ],
    NA: [
        "AG",
        "AI",
        "AW",
        "BB",
        "BL",
        "BM",
        "BQ",
        "BS",
        "BZ",
        "CA",
        "CR",
        "CU",
        "CW",
        "DM",
        "DO",
        "GD",
        "GL",
        "GP",
        "GT",
        "HN",
        "HT",
        "JM",
        "KN",
        "KY",
        "LC",
        "MF",
        "MQ",
        "MS",
        "MX",
        "NI",
        "PA",
        "PM",
        "PR",
        "SV",
        "SX",
        "TC",
        "TT",
        "US",
        "VC",
        "VG",
        "VI"
    ],
    SA: [
        "AR",
        "BO",
        "BR",
        "CL",
        "CO",
        "EC",
        "FK",
        "GF",
        "GY",
        "PE",
        "PY",
        "SR",
        "UY",
        "VE"
    ],
    OC: [
        "AS",
        "AU",
        "CK",
        "FJ",
        "FM",
        "GU",
        "KI",
        "MH",
        "MP",
        "NC",
        "NF",
        "NR",
        "NU",
        "NZ",
        "PF",
        "PG",
        "PW",
        "SB",
        "TK",
        "TL",
        "TO",
        "TV",
        "VU",
        "WF",
        "WS"
    ],
    AF: [
        "AO",
        "BF",
        "BI",
        "BJ",
        "BW",
        "CD",
        "CF",
        "CG",
        "CI",
        "CM",
        "CV",
        "DJ",
        "DZ",
        "EG",
        "EH",
        "ER",
        "ET",
        "GA",
        "GH",
        "GM",
        "GN",
        "GQ",
        "GW",
        "KE",
        "KM",
        "LR",
        "LS",
        "LY",
        "MA",
        "MG",
        "ML",
        "MR",
        "MU",
        "MW",
        "MZ",
        "NA",
        "NE",
        "NG",
        "RE",
        "RW",
        "SC",
        "SD",
        "SH",
        "SL",
        "SN",
        "SO",
        "SS",
        "ST",
        "SZ",
        "TD",
        "TG",
        "TN",
        "TZ",
        "UG",
        "YT",
        "ZA",
        "ZM",
        "ZW"
    ]
}, $bb50b4d24b214940$var$Tt = {
    version: 4,
    country_calling_codes: {
        1: [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        7: [
            "RU",
            "KZ"
        ],
        20: [
            "EG"
        ],
        27: [
            "ZA"
        ],
        30: [
            "GR"
        ],
        31: [
            "NL"
        ],
        32: [
            "BE"
        ],
        33: [
            "FR"
        ],
        34: [
            "ES"
        ],
        36: [
            "HU"
        ],
        39: [
            "IT",
            "VA"
        ],
        40: [
            "RO"
        ],
        41: [
            "CH"
        ],
        43: [
            "AT"
        ],
        44: [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        45: [
            "DK"
        ],
        46: [
            "SE"
        ],
        47: [
            "NO",
            "SJ"
        ],
        48: [
            "PL"
        ],
        49: [
            "DE"
        ],
        51: [
            "PE"
        ],
        52: [
            "MX"
        ],
        53: [
            "CU"
        ],
        54: [
            "AR"
        ],
        55: [
            "BR"
        ],
        56: [
            "CL"
        ],
        57: [
            "CO"
        ],
        58: [
            "VE"
        ],
        60: [
            "MY"
        ],
        61: [
            "AU",
            "CC",
            "CX"
        ],
        62: [
            "ID"
        ],
        63: [
            "PH"
        ],
        64: [
            "NZ"
        ],
        65: [
            "SG"
        ],
        66: [
            "TH"
        ],
        81: [
            "JP"
        ],
        82: [
            "KR"
        ],
        84: [
            "VN"
        ],
        86: [
            "CN"
        ],
        90: [
            "TR"
        ],
        91: [
            "IN"
        ],
        92: [
            "PK"
        ],
        93: [
            "AF"
        ],
        94: [
            "LK"
        ],
        95: [
            "MM"
        ],
        98: [
            "IR"
        ],
        211: [
            "SS"
        ],
        212: [
            "MA",
            "EH"
        ],
        213: [
            "DZ"
        ],
        216: [
            "TN"
        ],
        218: [
            "LY"
        ],
        220: [
            "GM"
        ],
        221: [
            "SN"
        ],
        222: [
            "MR"
        ],
        223: [
            "ML"
        ],
        224: [
            "GN"
        ],
        225: [
            "CI"
        ],
        226: [
            "BF"
        ],
        227: [
            "NE"
        ],
        228: [
            "TG"
        ],
        229: [
            "BJ"
        ],
        230: [
            "MU"
        ],
        231: [
            "LR"
        ],
        232: [
            "SL"
        ],
        233: [
            "GH"
        ],
        234: [
            "NG"
        ],
        235: [
            "TD"
        ],
        236: [
            "CF"
        ],
        237: [
            "CM"
        ],
        238: [
            "CV"
        ],
        239: [
            "ST"
        ],
        240: [
            "GQ"
        ],
        241: [
            "GA"
        ],
        242: [
            "CG"
        ],
        243: [
            "CD"
        ],
        244: [
            "AO"
        ],
        245: [
            "GW"
        ],
        246: [
            "IO"
        ],
        247: [
            "AC"
        ],
        248: [
            "SC"
        ],
        249: [
            "SD"
        ],
        250: [
            "RW"
        ],
        251: [
            "ET"
        ],
        252: [
            "SO"
        ],
        253: [
            "DJ"
        ],
        254: [
            "KE"
        ],
        255: [
            "TZ"
        ],
        256: [
            "UG"
        ],
        257: [
            "BI"
        ],
        258: [
            "MZ"
        ],
        260: [
            "ZM"
        ],
        261: [
            "MG"
        ],
        262: [
            "RE",
            "YT"
        ],
        263: [
            "ZW"
        ],
        264: [
            "NA"
        ],
        265: [
            "MW"
        ],
        266: [
            "LS"
        ],
        267: [
            "BW"
        ],
        268: [
            "SZ"
        ],
        269: [
            "KM"
        ],
        290: [
            "SH",
            "TA"
        ],
        291: [
            "ER"
        ],
        297: [
            "AW"
        ],
        298: [
            "FO"
        ],
        299: [
            "GL"
        ],
        350: [
            "GI"
        ],
        351: [
            "PT"
        ],
        352: [
            "LU"
        ],
        353: [
            "IE"
        ],
        354: [
            "IS"
        ],
        355: [
            "AL"
        ],
        356: [
            "MT"
        ],
        357: [
            "CY"
        ],
        358: [
            "FI",
            "AX"
        ],
        359: [
            "BG"
        ],
        370: [
            "LT"
        ],
        371: [
            "LV"
        ],
        372: [
            "EE"
        ],
        373: [
            "MD"
        ],
        374: [
            "AM"
        ],
        375: [
            "BY"
        ],
        376: [
            "AD"
        ],
        377: [
            "MC"
        ],
        378: [
            "SM"
        ],
        380: [
            "UA"
        ],
        381: [
            "RS"
        ],
        382: [
            "ME"
        ],
        383: [
            "XK"
        ],
        385: [
            "HR"
        ],
        386: [
            "SI"
        ],
        387: [
            "BA"
        ],
        389: [
            "MK"
        ],
        420: [
            "CZ"
        ],
        421: [
            "SK"
        ],
        423: [
            "LI"
        ],
        500: [
            "FK"
        ],
        501: [
            "BZ"
        ],
        502: [
            "GT"
        ],
        503: [
            "SV"
        ],
        504: [
            "HN"
        ],
        505: [
            "NI"
        ],
        506: [
            "CR"
        ],
        507: [
            "PA"
        ],
        508: [
            "PM"
        ],
        509: [
            "HT"
        ],
        590: [
            "GP",
            "BL",
            "MF"
        ],
        591: [
            "BO"
        ],
        592: [
            "GY"
        ],
        593: [
            "EC"
        ],
        594: [
            "GF"
        ],
        595: [
            "PY"
        ],
        596: [
            "MQ"
        ],
        597: [
            "SR"
        ],
        598: [
            "UY"
        ],
        599: [
            "CW",
            "BQ"
        ],
        670: [
            "TL"
        ],
        672: [
            "NF"
        ],
        673: [
            "BN"
        ],
        674: [
            "NR"
        ],
        675: [
            "PG"
        ],
        676: [
            "TO"
        ],
        677: [
            "SB"
        ],
        678: [
            "VU"
        ],
        679: [
            "FJ"
        ],
        680: [
            "PW"
        ],
        681: [
            "WF"
        ],
        682: [
            "CK"
        ],
        683: [
            "NU"
        ],
        685: [
            "WS"
        ],
        686: [
            "KI"
        ],
        687: [
            "NC"
        ],
        688: [
            "TV"
        ],
        689: [
            "PF"
        ],
        690: [
            "TK"
        ],
        691: [
            "FM"
        ],
        692: [
            "MH"
        ],
        850: [
            "KP"
        ],
        852: [
            "HK"
        ],
        853: [
            "MO"
        ],
        855: [
            "KH"
        ],
        856: [
            "LA"
        ],
        880: [
            "BD"
        ],
        886: [
            "TW"
        ],
        960: [
            "MV"
        ],
        961: [
            "LB"
        ],
        962: [
            "JO"
        ],
        963: [
            "SY"
        ],
        964: [
            "IQ"
        ],
        965: [
            "KW"
        ],
        966: [
            "SA"
        ],
        967: [
            "YE"
        ],
        968: [
            "OM"
        ],
        970: [
            "PS"
        ],
        971: [
            "AE"
        ],
        972: [
            "IL"
        ],
        973: [
            "BH"
        ],
        974: [
            "QA"
        ],
        975: [
            "BT"
        ],
        976: [
            "MN"
        ],
        977: [
            "NP"
        ],
        992: [
            "TJ"
        ],
        993: [
            "TM"
        ],
        994: [
            "AZ"
        ],
        995: [
            "GE"
        ],
        996: [
            "KG"
        ],
        998: [
            "UZ"
        ]
    },
    countries: {
        AC: [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        AD: [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        AE: [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AF: [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AG: [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        AI: [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        AL: [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AM: [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AO: [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        AR: [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        AS: [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        AT: [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        AU: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        AW: [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        AX: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        AZ: [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BA: [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BB: [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        BD: [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BE: [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BF: [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        BG: [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        BH: [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        BI: [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        BJ: [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        BL: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        BM: [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        BN: [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        BO: [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        BQ: [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        BR: [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        BS: [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        BT: [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        BW: [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        BY: [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        BZ: [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CA: [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        CC: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CD: [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CF: [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        CG: [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        CH: [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CI: [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        CK: [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        CL: [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        CM: [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        CN: [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        CO: [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        CR: [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        CU: [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        CV: [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        CW: [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        CX: [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        CY: [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        CZ: [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        DE: [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[03568]",
                        "15(?:[0568]|31)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        DJ: [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        DK: [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        DM: [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        DO: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        DZ: [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EC: [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        EE: [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        EG: [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        EH: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        ER: [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ES: [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        ET: [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        FI: [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "20[2-59]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "(?:[1-3]0|[68])0|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[14]|2[09]|50|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        FJ: [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        FK: [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        FM: [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        FO: [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        FR: [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GA: [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        GB: [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        GD: [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        GE: [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GF: [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GG: [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        GH: [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        GI: [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        GL: [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        GM: [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        GN: [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        GP: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        GQ: [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        GR: [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        GT: [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        GU: [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        GW: [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        GY: [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        HK: [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        HN: [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        HR: [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        HT: [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        HU: [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        ID: [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IE: [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IL: [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        IM: [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        IN: [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        IO: [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        IQ: [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IR: [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        IS: [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        IT: [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]|43"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[2-9]\\d{7,8}|(?:31|43)\\d{8}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        JE: [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        JM: [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        JO: [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        JP: [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        KE: [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KG: [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KH: [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        KI: [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        KM: [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        KN: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        KP: [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        KR: [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        KW: [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        KY: [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        KZ: [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        LA: [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LB: [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        LC: [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        LI: [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        LK: [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LR: [
            "231",
            "00",
            "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4[67]|[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        LS: [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        LT: [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        LU: [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        LV: [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        LY: [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MA: [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        MC: [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MD: [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ME: [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MF: [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        MG: [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        MH: [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        MK: [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ML: [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        MM: [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MN: [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MO: [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        MP: [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        MQ: [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MR: [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        MS: [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        MT: [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        MU: [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        MV: [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        MW: [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MX: [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        MY: [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        MZ: [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NA: [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NC: [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        NE: [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        NF: [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        NG: [
            "234",
            "009",
            "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "20[129]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NI: [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        NL: [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        NO: [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        NP: [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        NR: [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        NU: [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        NZ: [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        OM: [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        PA: [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PE: [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        PF: [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PG: [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        PH: [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PK: [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        PL: [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        PM: [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        PR: [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        PS: [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        PT: [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        PW: [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        PY: [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        QA: [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        RE: [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        RO: [
            "40",
            "00",
            "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        RS: [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        RU: [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        RW: [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SA: [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        SB: [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        SC: [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SD: [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SE: [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        SG: [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        SH: [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        SI: [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        SJ: [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        SK: [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        SL: [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        SM: [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        SN: [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        SO: [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        SR: [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        SS: [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ST: [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        SV: [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        SX: [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        SY: [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        SZ: [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        TA: [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        TC: [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        TD: [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        TG: [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        TH: [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        TJ: [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TK: [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        TL: [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TM: [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        TN: [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        TO: [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        TR: [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        TT: [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        TV: [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        TW: [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        TZ: [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        UA: [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        UG: [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        US: [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        UY: [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        UZ: [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        VA: [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        VC: [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        VE: [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        VG: [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        VI: [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        VN: [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        VU: [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        WF: [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        WS: [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        XK: [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YE: [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        YT: [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        ZA: [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZM: [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        ZW: [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    nonGeographic: {
        800: [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        808: [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        870: [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        878: [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        881: [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        882: [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        883: [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        888: [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        979: [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};
function $bb50b4d24b214940$var$Mn(t) {
    return typeof t == "object" && !Array.isArray(t) && t !== null;
}
const $bb50b4d24b214940$var$Rn = Object.keys, $bb50b4d24b214940$var$B = $bb50b4d24b214940$var$Tt.countries, $bb50b4d24b214940$var$_n = $bb50b4d24b214940$var$Rn($bb50b4d24b214940$var$B), $bb50b4d24b214940$var$Ln = "US";
function $bb50b4d24b214940$var$S(t, n) {
    const e = Array.isArray(t);
    return n ? e && t.length > 0 : e;
}
function $bb50b4d24b214940$var$kn(t, n) {
    return t.find((e)=>n.includes(e)) || null;
}
function $bb50b4d24b214940$var$tt(t) {
    var _B_t;
    return (_B_t = $bb50b4d24b214940$var$B[t]) === null || _B_t === void 0 ? void 0 : _B_t[0];
}
function $bb50b4d24b214940$var$Gn(t) {
    return t || $bb50b4d24b214940$var$Ln;
}
function $bb50b4d24b214940$var$Lt(t, n) {
    return [
        ...new Set(n.concat(t))
    ];
}
function $bb50b4d24b214940$var$Bn(t) {
    return t.flatMap((n)=>$bb50b4d24b214940$var$St[n]);
}
function $bb50b4d24b214940$var$Le(t, n) {
    return t.filter((e)=>n.includes(e));
}
function $bb50b4d24b214940$var$ke(t, n) {
    return $bb50b4d24b214940$var$S(n, !0) ? t.filter((e)=>!n.includes(e)) : t;
}
function $bb50b4d24b214940$var$jn(t, n) {
    const { onlyCountries: e, excludedCountries: r, continents: d, preferredCountries: i } = n;
    if ($bb50b4d24b214940$var$S(e, !0)) {
        const u = $bb50b4d24b214940$var$Le(t, e);
        return $bb50b4d24b214940$var$S(i, !0) ? $bb50b4d24b214940$var$Lt(u, i) : u;
    }
    const a = $bb50b4d24b214940$var$S(d, !0) ? $bb50b4d24b214940$var$Bn(d) : t, o = $bb50b4d24b214940$var$S(i, !0) ? $bb50b4d24b214940$var$Lt(a, i) : a;
    return $bb50b4d24b214940$var$S(r, !0) ? $bb50b4d24b214940$var$ke(o, r) : o;
}
function $bb50b4d24b214940$var$Ge(t, n) {
    return t.some((e)=>$bb50b4d24b214940$var$St[e].includes(n));
}
function $bb50b4d24b214940$var$Un(t, n) {
    return [
        ...t
    ].sort((e, r)=>{
        const d = n.of(e), i = n.of(r);
        return d.localeCompare(i);
    });
}
const $bb50b4d24b214940$var$Wn = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAABXNvynAAAMeGlDQ1BEaXNwbGF5AABIiZVXd1ST9xp+vpGEhBFGQEBG2EsQ2UNmmIKCbBBHSAIEQoghQcU9ahWtWxw40bqLViuodaJWrRbBbR1FLSqVWtQ6Ubl/JKD13nvuue85ye89z+95n3d838nJC3DfCBUKGWkIlMlVyrT4aH5Obh6f9RAU2ODAAG5CUYUiKjU1GQB6z8+MAF5dAwEAlz2FCoUM/58ZiyUVIoDIB1AgrhCVAcRxgF4jUihVADMfgMM4lUIFMKcB4ClzcvMA5jIAvCKNvw0Ar0DjHwbAU2akCQBmC6CjJxQqiwCD2wD4laIiFWDwHoC3XCyVA9wBAMJFxUIxwJUBGFBWVi4GuCsBuFaKihQA9ziAoILPNIv+oV/Qpy8UFvX5mr4AADox0gqFTDjh/xzN/7Yymbo3hzMAvWJlQhoAHkDcKC1PSgOgBxCd8oJhKQCMAeKNVKyZO0ByitUJmRo+aSWqEOQBMANIb7EwJgmAFUDGyWXDkrV4QaE0LhGAIUCOl6oSMwCYA+QcSUVsupazQVmeps1FNhQqBVFa/KxQCWhz3VWXZkZp9Z8XSxK1+pRBVXFGNgAOQDlWSrOGATAAKK+K0vQkLWdwVbFgWC9HqU7LBOAIUGkSeXy0Rp+qLFTGpWn51WUVvf1SG4qlicO0/l5VcUaCZj7UKZEwNl3TC9UikUdl9upIKnKSe3sRS2JiNb1TjyXyzHStzhuFKjpNE0tzFLJULZ+2l8ji0wDYA7RfRWW6NpbOUikztM+ILlSoUjM0ddJVJcIhqZp66EVIhgAx4EMNPgpQjhJImzsbO8HX3sRBCCWKIIGnFumNyIYQSsghRDqq8CfkkKCiLy4aQighQSXk+NCHar49UQghlKiEBBUoxUMoUYYkyCCBGkpIIO/LloXfoYT037ILwYcI5ZChHEpI/wvei35CoiBAshZR92bkc3uZzFhmDDOBGcd0oy3pcDqUTqbD6Ug6nPahg+jg3j4+8RkPGa2M+4yrjDbGzdHSGcovqhyKNqi1M5Sg4PNZ0M60D+1PR9NhdDgdDD5tRlvCk/ajg+goOoIOpf3pYAi0dauh/GKGX3Tw2dPQ8tjebJLdjx3Jdv0y0sDdwL9PRQL5P+ajqbWgb96Cvpsv8ws+m74Y5Uj6kknNofZRZ6gT1DnqMNUIPnWMOkBdoI5QjZ+9Xb9DiaK+bGmQQI5SyCD9t3xCbU4lJKjw3und4f1ec6eSjFcBgKBcMUEpLSpW8aMUCpmEnygXeQ3g+3j7+AA5uXl8zc/Xi+EgABBmFz5hM38Dwo719PT8+Akbcgz4PhDgHPyEuQYBRrrA2YMitbJSg9EAwAAHXPBgARs4wBWe8EEAQhGJWAxBCjKQi1EQoRhlUGIcJmE6ZmMeFmE5VmM9NmEbvsNeNOIwTuAnnEcLruIW2tCOJ+jCK3QTBMEi9AkTwoKwJZwID8KHCCLCiVgimUgjcokxRBEhJ9TEJGImMY9YQqwmNhLbie+Jg8QJ4hzRStwk7hEdxHPiHUmReiSPtCadyYFkEBlFJpEZ5EiyiBxLVpGzyAXkSrKO3EU2kCfI8+RVso18Qr6kQOlSZpQd5UkFUQIqhcqjCiklNYWqpmqoOqqeOkSdoS5TbVQn9ZZm0iY0n/akQ+kEOpMW0WPpKfR8ejW9jW6gT9GX6Xt0F/2Roc+wYngwQhiJjBxGEWMcYzajhrGFsZ9xmnGV0c54xWQyzZguzEBmAjOXWcKcyJzPXMvczTzObGU+YL5ksVgWLA9WGCuFJWSpWLNZq1i7WMdYl1jtrDc6ujq2Oj46cTp5OnKdGTo1Ojt0jupc0nmk0802ZDuxQ9gpbDF7AnshezP7EPsiu53dzTHiuHDCOBmcEs50zkpOPec05zbnha6urr1usO5wXanuNN2Vunt0z+re032rZ6znrifQy9dT6y3Q26p3XO+m3gt9fX1n/Uj9PH2V/gL97fon9e/qvzEwMfAySDQQG0w1qDVoMLhk8JTL5jpxo7ijuFXcGu4+7kVupyHb0NlQYCg0nGJYa3jQ8LrhSyMTo0FGKUZlRvONdhidM3pszDJ2No41FhvPMt5kfNL4gQll4mAiMBGZzDTZbHLapJ3H5LnwEnklvHm873jNvC5TY1M/0yzT8aa1pkdM28woM2ezRDOZ2UKzvWbXzN71s+4X1U/Sb26/+n6X+r02728eaS4xrzbfbX7V/J0F3yLWotRisUWjxR1L2tLdcrjlOMt1lqctO/vz+of2F/Wv7r+3/69WpJW7VZrVRKtNVhesXlrbWMdbK6xXWZ+07rQxs4m0KbFZZnPUpsPWxDbcVmq7zPaY7R98U34UX8ZfyT/F77KzskuwU9tttGu267Z3sc+0n2G/2/6OA8chyKHQYZlDk0OXo63jUMdJjjsdf3ViOwU5FTutcDrj9NrZxTnb+WvnRufHLuYuiS5VLjtdbrvqu0a4jnWtc73ixnQLcit1W+vW4k66+7sXu9e6X/QgPQI8pB5rPVoHMAYED5APqBtw3VPPM8qz0nOn5z0vM69krxlejV5PBzoOzBu4eOCZgR+9/b1l3pu9bw0yHjRk0IxBhwY993H3EfnU+lzx1feN853qe8D3mZ+Hn8Rvnd8NfxP/of5f+zf5fwgIDFAG1Ad0BDoGjglcE3g9iBeUGjQ/6GwwIzg6eGrw4eC3IQEhqpC9IX+FeoaWhu4IfTzYZbBk8ObBD8Lsw4RhG8PawvnhY8I3hLdF2EUII+oi7kc6RIojt0Q+inKLKonaFfU02jtaGb0/+rUgRDBZcDyGiomPqY5pjjWOzYxdHXs3zj6uKG5nXFe8f/zE+OMJjISkhMUJ1xOtE0WJ2xO7hgQOmTzkVJJeUnrS6qT7ye7JyuRDQ8mhQ4YuHXp7mNMw+bDGFKQkpixNuZPqkjo29cfhzOGpw2uHP0wblDYp7Uy6Sfro9B3przKiMxZm3Mp0zVRnNmVxs/Kztme9zo7JXpLdljMwZ3LO+VzLXGnugTxWXlbelryXI2JHLB/Rnu+fPzv/2kiXkeNHnhtlOUo26sho7mjh6H1jGGOyx+wY816YIqwTvixILFhT0CUSiFaInogjxcvEHZIwyRLJo8KwwiWFj4vCipYWdRRHFNcUd0oF0tXSZyUJJetLXpemlG4t7ZFly3aX6ZSNKTsoN5aXyk+V25SPL29VeChmK9rGhoxdPrZLmaTcUkFUjKw4oOKpFKoLalf1V+p7leGVtZVvxmWN2zfeaLx8/IUJ7hPmTnhUFVf17UR6omhi0yS7SdMn3ZscNXnjFGJKwZSmqQ5TZ01tnxY/bdt0zvTS6b/M8J6xZMbfM7NnHpplPWvarAdfxX+1c7bBbOXs61+Hfr1+Dj1HOqd5ru/cVXM/Vourf57nPa9m3vv5ovk/fzPom5Xf9CwoXNC8MGDhukXMRfJF1xZHLN62xGhJ1ZIHS4cubVjGX1a97O/lo5efq/GrWb+Cs0K9om1l8soDqxxXLVr1fnXx6qu10bW711itmbvm9Vrx2kvrItfVr7deP2/9uw3SDTc2xm9sqHOuq9nE3FS56eHmrM1nvg36dvsWyy3ztnzYKt/ati1t26ntgdu377DasXAnuVO9s2NX/q6W72K+O1DvWb9xt9nueXuwR73nj+/HfH9tb9Lepn1B++p/cPphzX6T/dUNRMOEhq7G4sa2A7kHWg8OOdh0KPTQ/h+9ftx62O5w7RHTIwuPco7OOtpzrOrYy+OK450nik48aBrddOtkzskrp4afaj6ddPrsT3E/nTwTdebY2bCzh8+FnDv4c9DPjecDzjdc8L+w/xf/X/Y3BzQ3XAy8eKAluOVQ6+DWo5ciLp24HHP5pyuJV85fHXa19VrmtRvX86+33RDfeHxTdvPZr5W/dt+adptxu/qO4Z2au1Z3635z+213W0DbkXsx9y7cT79/64HowZPfK35/3z7rof7Dmke2j7Y/9nl8uCOuo+WPEX+0P1E86e6c/afRn2ueuj794a/Ivy505XS1P1M+63k+/4XFi61/+/3d9DL15d1XZa+6X1e/sXiz7W3Q2zPvst896h73nvV+5Qe3D4c+Jn283VPW06MQKoUAAAoAWVgIPN8K6OcCJi0AZ4RmFwQAEJr9FdD8B/nPvmZfBAAEAPU8YHgnILgO7NkMOBcC3HwgVR/ICAbp69v30VpFoa+PRksvGmDc7el54QywlgIfFvX0dNf19HzYBFC3geNyzQ4KAExDYEPih4KyAvwH0+ynn/X45QmQvr5++PL8F6mCkLerjl90AAAACXBIWXMAAAsTAAALEwEAmpwYAAAE92lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDUgNzkuMTYzNDk5LCAyMDE4LzA4LzEzLTE2OjQwOjIyICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxOSAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjItMDMtMTJUMTQ6MTY6NTArMDE6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIyLTAzLTIwVDEwOjIyOjUxKzAxOjAwIiB4bXA6TWV0YWRhdGFEYXRlPSIyMDIyLTAzLTIwVDEwOjIyOjUxKzAxOjAwIiBkYzpmb3JtYXQ9ImltYWdlL3BuZyIgcGhvdG9zaG9wOkNvbG9yTW9kZT0iMyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpmZDY2ZDIzMC1mMDk3LTRhMjUtODkxNi1mN2YxMmQ2NTRhNjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ZmQ2NmQyMzAtZjA5Ny00YTI1LTg5MTYtZjdmMTJkNjU0YTY5IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6ZmQ2NmQyMzAtZjA5Ny00YTI1LTg5MTYtZjdmMTJkNjU0YTY5Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDpmZDY2ZDIzMC1mMDk3LTRhMjUtODkxNi1mN2YxMmQ2NTRhNjkiIHN0RXZ0OndoZW49IjIwMjItMDMtMTJUMTQ6MTY6NTArMDE6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE5IChNYWNpbnRvc2gpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjHOcacAAAMOSURBVFiFzZixa1NBHMe/FxOIryWNNUkjJCYQkhJKU2oXsdJowU7t6KZroYNDB7eOgn+Dg0t10MmhrhUUEelm2hDaUmibQBtbQxuaI5JHn4O8cHe59/LuRY3fJbnj97vf5373vSOEzC8t4+W9mcUNzfcc/6mSw9H38U9rzx4d1ndJ9e27xa3Q0It+QznR1MbHjEfsbL1Bu35XjZflqtYBgPLMwgpZX/9gWEbYqN6gCAxofzVPjKWU1jyU0pos0MnYSddFBQa0rh1nY1lpmjbskSWJgbKOpBJJgy3OFmTjZcedSiQNuxyrDVBKaxxwt6R6g6LeoEglksZ4bozcvnO3PW91zOa8uVY6k8Z4boykM2lpvKxpLIenI8NmAwAwNTmB8dwYAQDN78Pcgznp5mQQU5MTiMdiAIB4LIbpfL4jT1bTnOMsIR6t1edZ7Zy7pCa06E0xbzqfb8OaOt4/4NbqVptSWlN+Jczjn529z83TZgtfv3zm7MHChgODXPxmoWjsHewT1ZeGFL5tXSplADg5/U7CoYhhWsOU3tJRKm1zDYgmE0SELVcq2N3ZRTgUUX5SXQGzsoNOZTJE8/s6YEVbqcj20rEyRjxENr9ZKHLFvT4vUpkMiSYTfxwWkACzYOx3Ur20LLRZKBp6S2+PNb+vw7PdYMWGWDWoZ0uwkllA5ute5NgSweEhaed7FbuubCxKCixLYo9TZg9Zd4HfnhYvptW6srHYHCmw6sXIZkc5WL2lgzZbXIwI7fSUxOY4toSVstlR4vV5ublSadvY29nhLiLAQ9tdYjvZAlu9GFawektHuVLhwGWd7uZTu+6Tw3LZ1U7F3wUAOFhWN0aiEE/BKrabXFlCBRYAjqrHEO0Rj8XgDwSVaysDXw+NdMw56ZYM+tpVv2p5deAfp1Wc1C/aY5WjZaFps4Wj6rFqefce9geCaNbP3KT2lOv6WXNbsNfcnt/hfy1POBJd7TeEU50fVlevPB3wFH/mbj3pN4wTRdbePCTzS8t4fTOQLs8srBiD/sf9hpKJXDRfmX8G/gKUwMkA3my/NwAAAABJRU5ErkJggg==", $bb50b4d24b214940$var$kt = {
    AC: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 513 342'%3e%3cpath fill='%230052B4' d='M0 0h513v342H0z'/%3e%3cpath fill='white' d='M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z'/%3e%3cpath fill='%2329DBFF' d='M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9'/%3e%3cpath fill='white' d='M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4'/%3e%3cpath fill='%2329DBFF' d='M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53'/%3e%3cpath fill='white' d='M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1'/%3e%3cpath fill='%2329DBFF' d='M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5'/%3e%3cpath fill='%235CC85C' d='M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z'/%3e%3cellipse transform='rotate(-82.3 291.431 225.686)' fill='%23F7A226' cx='291.4' cy='225.7' rx='48.7' ry='15.7'/%3e%3cellipse transform='rotate(-68.099 303.087 164.67)' fill='%23DDC7AB' cx='303.1' cy='164.7' rx='11.7' ry='7.2'/%3e%3cellipse transform='rotate(-81.738 291.697 271.697)' fill='%23DDC7AB' cx='291.7' cy='271.7' rx='11.4' ry='3.3'/%3e%3cellipse transform='matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)' fill='%23DDC7AB' cx='299.6' cy='269.4' rx='3.3' ry='11'/%3e%3cellipse transform='rotate(-21.518 314.54 201.06)' fill='%23DDC7AB' cx='314.5' cy='201.1' rx='4.1' ry='13.7'/%3e%3cellipse transform='rotate(-21.518 317.511 178.077)' fill='%23DDC7AB' cx='317.5' cy='178.1' rx='13.7' ry='4.1'/%3e%3cellipse transform='rotate(-7.7 473.781 225.857)' fill='%23F7A226' cx='473.6' cy='225.9' rx='15.7' ry='48.7'/%3e%3cellipse transform='rotate(-21.901 462.057 164.866)' fill='%23DDC7AB' cx='462' cy='164.9' rx='7.2' ry='11.7'/%3e%3cellipse transform='rotate(-8.27 473.27 271.908)' fill='%23DDC7AB' cx='473.4' cy='271.9' rx='3.3' ry='11.4'/%3e%3cellipse transform='matrix(.05353 -.9986 .9986 .05353 171.34 719.998)' fill='%23DDC7AB' cx='465.5' cy='269.6' rx='11' ry='3.3'/%3e%3cellipse transform='rotate(-68.482 450.552 201.247)' fill='%23DDC7AB' cx='450.6' cy='201.2' rx='13.7' ry='4.1'/%3e%3cellipse transform='rotate(-68.482 447.58 178.265)' fill='%23DDC7AB' cx='447.6' cy='178.3' rx='4.1' ry='13.7'/%3e%3cpath fill='%23B0C6CC' d='M373.3 130.3L356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z'/%3e%3cpath fill='white' d='M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z'/%3e%3cpath fill='%23D80027' d='M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z'/%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath fill='%23D80027' d='M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6l-77.8-53.3h22.6l62.5 42.3v11z'/%3e%3c/svg%3e",
    TA: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 341.3'%3e%3cpath fill='%230052B4' d='M0 0h512v341.3H0z'/%3e%3cpath fill='white' d='M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z'/%3e%3cg fill='%23D80027'%3e%3cpath d='M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z'/%3e%3cpath d='M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z'/%3e%3c/g%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath d='M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z' fill='%23D80027'/%3e%3cpath fill='%232E52B2' d='M256 22.7v30.7h-46.1z'/%3e%3cpath d='M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z' fill='%23D80027'/%3e%3cpath fill='%2329DBFF' d='M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z'/%3e%3cpath fill='white' d='M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9'/%3e%3cpath fill='%2329DBFF' d='M385.4 251.7l-22.9-43h45.8z'/%3e%3cpath fill='white' d='M385.4 165.8l-22.9 42.9h45.8z'/%3e%3cellipse fill='%23FFBE57' cx='474.8' cy='236.8' rx='16.8' ry='43.3'/%3e%3cellipse fill='%23FFBE57' cx='295.3' cy='236.8' rx='16.8' ry='43.3'/%3e%3cpath fill='white' d='M385.4 31.5l-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z'/%3e%3cellipse fill='%23A5A5A5' cx='386.3' cy='104.3' rx='34.3' ry='23.3'/%3e%3c/svg%3e"
}, $bb50b4d24b214940$var$Hn = (t)=>t === "TA" || t === "AC" ? ({
        TA: $bb50b4d24b214940$var$kt.TA,
        AC: $bb50b4d24b214940$var$kt.AC
    })[t] : `https://flagcdn.com/w40/${t.toLowerCase()}.webp`, $bb50b4d24b214940$var$Ft = "MuiTelInput-FlagImg", $bb50b4d24b214940$var$wt = ({ isoCode: t, countryName: n })=>({
        src: $bb50b4d24b214940$var$Hn(t),
        loading: "lazy",
        width: 26,
        alt: n,
        className: $bb50b4d24b214940$var$Ft
    }), $bb50b4d24b214940$var$Vn = (t, { countryName: n })=>/* @__PURE__ */ (0, $3pI8R.jsx)("img", {
        ...$bb50b4d24b214940$var$wt({
            isoCode: t,
            countryName: n
        })
    }), $bb50b4d24b214940$var$Zn = /* @__PURE__ */ (0, $3pI8R.jsx)("img", {
    src: $bb50b4d24b214940$var$Wn,
    loading: "lazy",
    width: 26,
    alt: "unknown",
    className: $bb50b4d24b214940$var$Ft
});
function $bb50b4d24b214940$var$G(...t) {}
function $bb50b4d24b214940$var$Be(t = $bb50b4d24b214940$var$q) {
    try {
        return new Intl.DisplayNames(t, {
            type: "region"
        });
    } catch (n) {
        return $bb50b4d24b214940$var$G(n), new Intl.DisplayNames($bb50b4d24b214940$var$q, {
            type: "region"
        });
    }
}
const $bb50b4d24b214940$var$Yn = {
    CallingCodeSplitted: (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5d7bd7102f196281$export$2e2bcd8739ae039))({
        borderRight: `1px solid ${(0, $1f6b80255be92d2b$export$2e2bcd8739ae039)[300]}`,
        paddingRight: 10,
        cursor: "default",
        pointerEvents: "none"
    })
}, $bb50b4d24b214940$var$yt = "MuiTelInput-IconButton", $bb50b4d24b214940$var$zn = ({ disableDropdown: t = !1, forceCallingCode: n = !1, langOfCountryName: e = $bb50b4d24b214940$var$q, isFlagsMenuOpened: r = !1, getFlagElement: d, unknownFlagElement: i, isoCode: a, ...o })=>{
    const u = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>$bb50b4d24b214940$var$Be(e), [
        e
    ]), l = /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$_e, {
        isoCode: a,
        children: a ? d(a, {
            countryName: u.of(a) || "",
            isSelected: !0,
            imgProps: $bb50b4d24b214940$var$wt({
                isoCode: a,
                countryName: u.of(a) || ""
            })
        }) : i
    });
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $3pI8R.Fragment), {
        children: [
            t ? /* @__PURE__ */ (0, $3pI8R.jsx)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
                tabIndex: -1,
                className: $bb50b4d24b214940$var$yt,
                role: "",
                disableRipple: !0,
                sx: {
                    pointerEvents: "none",
                    aspectRatio: "1 / 1"
                },
                component: "span",
                children: l
            }) : /* @__PURE__ */ (0, $3pI8R.jsx)((0, $b4f1e2b6883d2123$export$2e2bcd8739ae039), {
                ...o,
                "aria-label": "Select country",
                className: $bb50b4d24b214940$var$yt,
                "aria-haspopup": "listbox",
                sx: {
                    aspectRatio: "1 / 1"
                },
                "aria-controls": r ? "select-country" : void 0,
                "aria-expanded": r ? "true" : "false",
                children: l
            }),
            n && a ? /* @__PURE__ */ (0, $3pI8R.jsxs)($bb50b4d24b214940$var$Yn.CallingCodeSplitted, {
                children: [
                    "+",
                    $bb50b4d24b214940$var$tt(a)
                ]
            }) : null
        ]
    });
}, $bb50b4d24b214940$var$Gt = {
    ListItemIcon: (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $b8d8870a92540e83$export$2e2bcd8739ae039))({
        marginRight: "10px"
    }),
    ListItemText: (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $f4c2a1be62dbd0c3$export$2e2bcd8739ae039))({
        marginRight: "10px"
    })
}, $bb50b4d24b214940$var$je = "MuiTelInput-MenuItem", $bb50b4d24b214940$var$Ue = "MuiTelInput-ListItemIcon-flag", $bb50b4d24b214940$var$We = "MuiTelInput-ListItemText-country", $bb50b4d24b214940$var$He = "MuiTelInput-Typography-calling-code", $bb50b4d24b214940$var$Xn = ({ isoCode: t, onSelectCountry: n, countryName: e, getFlagElement: r, ...d })=>{
    var _B_t;
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
        ...d,
        onClick: (a)=>{
            a.preventDefault(), n(t);
        },
        role: "option",
        "data-testid": `option-${t}`,
        className: $bb50b4d24b214940$var$je,
        children: [
            /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Gt.ListItemIcon, {
                className: $bb50b4d24b214940$var$Ue,
                children: /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$_e, {
                    isoCode: t,
                    children: r(t, {
                        countryName: e,
                        isSelected: !1,
                        imgProps: $bb50b4d24b214940$var$wt({
                            isoCode: t,
                            countryName: e
                        })
                    })
                })
            }),
            /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Gt.ListItemText, {
                className: $bb50b4d24b214940$var$We,
                children: e
            }),
            /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                variant: "body2",
                color: "text.secondary",
                className: $bb50b4d24b214940$var$He,
                children: [
                    "+",
                    (_B_t = $bb50b4d24b214940$var$B[t]) === null || _B_t === void 0 ? void 0 : _B_t[0]
                ]
            })
        ]
    });
}, $bb50b4d24b214940$var$Kn = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($bb50b4d24b214940$var$Xn), $bb50b4d24b214940$var$Qn = [], $bb50b4d24b214940$var$Jn = [], $bb50b4d24b214940$var$qn = [], $bb50b4d24b214940$var$tr = [], $bb50b4d24b214940$var$Ve = "MuiTelInput-Menu", $bb50b4d24b214940$var$er = ({ anchorEl: t, isoCode: n, onSelectCountry: e, excludedCountries: r = $bb50b4d24b214940$var$Qn, onlyCountries: d = $bb50b4d24b214940$var$Jn, langOfCountryName: i = $bb50b4d24b214940$var$q, continents: a = $bb50b4d24b214940$var$qn, preferredCountries: o = $bb50b4d24b214940$var$tr, className: u, getFlagElement: l, ...$ })=>{
    const c = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useMemo(()=>$bb50b4d24b214940$var$Be(i), [
        i
    ]), f = $bb50b4d24b214940$var$Un($bb50b4d24b214940$var$_n, c), h = $bb50b4d24b214940$var$jn(f, {
        onlyCountries: d,
        excludedCountries: r,
        continents: a,
        preferredCountries: o
    });
    return /* @__PURE__ */ (0, $3pI8R.jsx)((0, $99e7ab0961a065f0$export$2e2bcd8739ae039), {
        anchorEl: t,
        open: !!t,
        id: "select-country",
        className: `${$bb50b4d24b214940$var$Ve} ${u || ""}`,
        MenuListProps: {
            role: "listbox",
            "aria-activedescendant": n ? `country-${n}` : "",
            "aria-labelledby": "select-country"
        },
        ...$,
        children: h.map((g)=>/* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$Kn, {
                onSelectCountry: e,
                isoCode: g,
                countryName: c.of(g) || "",
                selected: g === n,
                id: `country-${g}`,
                getFlagElement: l
            }, g))
    });
};
function $bb50b4d24b214940$var$nr(t) {
    const { length: n } = t.value;
    t.setSelectionRange(n, n);
}
function $bb50b4d24b214940$var$st(t, n) {
    typeof n == "function" ? n(t) : n && $bb50b4d24b214940$var$Mn(n) && "current" in n && (n.current = t);
}
function $bb50b4d24b214940$var$Ze(t, n) {
    return t.replace(n, "");
}
function $bb50b4d24b214940$var$rr(t) {
    const { defaultCountry: n, onlyCountries: e, excludedCountries: r, continents: d, forceCallingCode: i } = t;
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (e && r) {
            const a = $bb50b4d24b214940$var$kn(e, r);
            a && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have the country ${a} to be included in the 'onlyCountries' AND 'excludedCountries' props`);
        }
    }, [
        e,
        r
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && r && r.includes(n) && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have the 'defaultCountry' (${n}) prop excluded by the 'excludedCountries' prop`);
    }, [
        n,
        r
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && e && !e.includes(n) && $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have a 'defaultCountry' prop (${n}) and a 'onlyCountries' prop but without included the 'defaultCountry' (${n})`);
    }, [
        n,
        e
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        n && d && d.length > 0 && (d.some((o)=>$bb50b4d24b214940$var$St[o].includes(n)) || $bb50b4d24b214940$var$G(`[mui-tel-input] Not expected to have a 'defaultCountry' prop (${n}) and a 'continents' prop that are not contain the country (${n})`));
    }, [
        n,
        d
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        i && !n && $bb50b4d24b214940$var$G("[mui-tel-input] 'forceCallingCode' needs 'defaultCountry' defined. Will default to US.");
    }, [
        n,
        i
    ]);
}
function $bb50b4d24b214940$var$Ye(t, n) {
    var e = Array.prototype.slice.call(n);
    return e.push($bb50b4d24b214940$var$Tt), t.apply(this, e);
}
function $bb50b4d24b214940$var$pt(t) {
    "@babel/helpers - typeof";
    return $bb50b4d24b214940$var$pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
    } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, $bb50b4d24b214940$var$pt(t);
}
function $bb50b4d24b214940$var$Bt(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$dr(t, n, e) {
    return n && $bb50b4d24b214940$var$Bt(t.prototype, n), e && $bb50b4d24b214940$var$Bt(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function $bb50b4d24b214940$var$ir(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$ar(t, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(n && n.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), n && $bb50b4d24b214940$var$Z(t, n);
}
function $bb50b4d24b214940$var$or(t) {
    var n = $bb50b4d24b214940$var$Xe();
    return function() {
        var r = $bb50b4d24b214940$var$Y(t), d;
        if (n) {
            var i = $bb50b4d24b214940$var$Y(this).constructor;
            d = Reflect.construct(r, arguments, i);
        } else d = r.apply(this, arguments);
        return $bb50b4d24b214940$var$ur(this, d);
    };
}
function $bb50b4d24b214940$var$ur(t, n) {
    if (n && ($bb50b4d24b214940$var$pt(n) === "object" || typeof n == "function")) return n;
    if (n !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $bb50b4d24b214940$var$ze(t);
}
function $bb50b4d24b214940$var$ze(t) {
    if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function $bb50b4d24b214940$var$vt(t) {
    var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return $bb50b4d24b214940$var$vt = function(r) {
        if (r === null || !$bb50b4d24b214940$var$lr(r)) return r;
        if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof n < "u") {
            if (n.has(r)) return n.get(r);
            n.set(r, d);
        }
        function d() {
            return $bb50b4d24b214940$var$K(r, arguments, $bb50b4d24b214940$var$Y(this).constructor);
        }
        return d.prototype = Object.create(r.prototype, {
            constructor: {
                value: d,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $bb50b4d24b214940$var$Z(d, r);
    }, $bb50b4d24b214940$var$vt(t);
}
function $bb50b4d24b214940$var$K(t, n, e) {
    return $bb50b4d24b214940$var$Xe() ? $bb50b4d24b214940$var$K = Reflect.construct : $bb50b4d24b214940$var$K = function(d, i, a) {
        var o = [
            null
        ];
        o.push.apply(o, i);
        var u = Function.bind.apply(d, o), l = new u();
        return a && $bb50b4d24b214940$var$Z(l, a.prototype), l;
    }, $bb50b4d24b214940$var$K.apply(null, arguments);
}
function $bb50b4d24b214940$var$Xe() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (e) {
        return !1;
    }
}
function $bb50b4d24b214940$var$lr(t) {
    return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function $bb50b4d24b214940$var$Z(t, n) {
    return $bb50b4d24b214940$var$Z = Object.setPrototypeOf || function(r, d) {
        return r.__proto__ = d, r;
    }, $bb50b4d24b214940$var$Z(t, n);
}
function $bb50b4d24b214940$var$Y(t) {
    return $bb50b4d24b214940$var$Y = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    }, $bb50b4d24b214940$var$Y(t);
}
var $bb50b4d24b214940$var$E = /* @__PURE__ */ function(t) {
    $bb50b4d24b214940$var$ar(e, t);
    var n = $bb50b4d24b214940$var$or(e);
    function e(r) {
        var d;
        return $bb50b4d24b214940$var$ir(this, e), d = n.call(this, r), Object.setPrototypeOf($bb50b4d24b214940$var$ze(d), e.prototype), d.name = d.constructor.name, d;
    }
    return $bb50b4d24b214940$var$dr(e);
}(/* @__PURE__ */ $bb50b4d24b214940$var$vt(Error)), $bb50b4d24b214940$var$Dt = 2, $bb50b4d24b214940$var$$r = 17, $bb50b4d24b214940$var$sr = 3, $bb50b4d24b214940$var$N = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9", $bb50b4d24b214940$var$fr = "-\u2010-\u2015\u2212\u30FC\uFF0D", $bb50b4d24b214940$var$cr = "\uFF0F/", $bb50b4d24b214940$var$hr = "\uFF0E.", $bb50b4d24b214940$var$gr = " \xa0\xad\u200B\u2060\u3000", $bb50b4d24b214940$var$mr = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]", $bb50b4d24b214940$var$yr = "~\u2053\u223C\uFF5E", $bb50b4d24b214940$var$x = "".concat($bb50b4d24b214940$var$fr).concat($bb50b4d24b214940$var$cr).concat($bb50b4d24b214940$var$hr).concat($bb50b4d24b214940$var$gr).concat($bb50b4d24b214940$var$mr).concat($bb50b4d24b214940$var$yr), $bb50b4d24b214940$var$rt = "+\uFF0B";
function $bb50b4d24b214940$var$jt(t, n) {
    t = t.split("-"), n = n.split("-");
    for(var e = t[0].split("."), r = n[0].split("."), d = 0; d < 3; d++){
        var i = Number(e[d]), a = Number(r[d]);
        if (i > a) return 1;
        if (a > i) return -1;
        if (!isNaN(i) && isNaN(a)) return 1;
        if (isNaN(i) && !isNaN(a)) return -1;
    }
    return t[1] && n[1] ? t[1] > n[1] ? 1 : t[1] < n[1] ? -1 : 0 : !t[1] && n[1] ? 1 : t[1] && !n[1] ? -1 : 0;
}
var $bb50b4d24b214940$var$pr = {}.constructor;
function $bb50b4d24b214940$var$R(t) {
    return t != null && t.constructor === $bb50b4d24b214940$var$pr;
}
function $bb50b4d24b214940$var$Ct(t) {
    "@babel/helpers - typeof";
    return $bb50b4d24b214940$var$Ct = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
    } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, $bb50b4d24b214940$var$Ct(t);
}
function $bb50b4d24b214940$var$dt(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Ut(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$it(t, n, e) {
    return n && $bb50b4d24b214940$var$Ut(t.prototype, n), e && $bb50b4d24b214940$var$Ut(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$vr = "1.2.0", $bb50b4d24b214940$var$Cr = "1.7.35", $bb50b4d24b214940$var$Wt = " ext. ", $bb50b4d24b214940$var$Nr = /^\d+$/, $bb50b4d24b214940$var$v = /* @__PURE__ */ function() {
    function t(n) {
        $bb50b4d24b214940$var$dt(this, t), $bb50b4d24b214940$var$Ir(n), this.metadata = n, $bb50b4d24b214940$var$Ke.call(this, n);
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "getCountries",
            value: function() {
                return Object.keys(this.metadata.countries).filter(function(e) {
                    return e !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function(e) {
                return this.metadata.countries[e];
            }
        },
        {
            key: "nonGeographic",
            value: function() {
                if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function(e) {
                return this.getCountryMetadata(e) !== void 0;
            }
        },
        {
            key: "hasCallingCode",
            value: function(e) {
                if (this.getCountryCodesForCallingCode(e)) return !0;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[e]) return !0;
                } else {
                    var r = this.countryCallingCodes()[e];
                    if (r && r.length === 1 && r[0] === "001") return !0;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function(e) {
                return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
            }
        },
        {
            key: "country",
            value: function(e) {
                return this.selectNumberingPlan(e);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function(e, r) {
                if (e && $bb50b4d24b214940$var$Nr.test(e) && (r = e, e = null), e && e !== "001") {
                    if (!this.hasCountry(e)) throw new Error("Unknown country: ".concat(e));
                    this.numberingPlan = new $bb50b4d24b214940$var$Ht(this.getCountryMetadata(e), this);
                } else if (r) {
                    if (!this.hasCallingCode(r)) throw new Error("Unknown calling code: ".concat(r));
                    this.numberingPlan = new $bb50b4d24b214940$var$Ht(this.getNumberingPlanMetadata(r), this);
                } else this.numberingPlan = void 0;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function(e) {
                var r = this.countryCallingCodes()[e];
                if (r) return r.length === 1 && r[0].length === 3 ? void 0 : r;
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function(e) {
                var r = this.getCountryCodesForCallingCode(e);
                if (r) return r[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function(e) {
                var r = this.getCountryCodeForCallingCode(e);
                if (r) return this.getCountryMetadata(r);
                if (this.nonGeographic()) {
                    var d = this.nonGeographic()[e];
                    if (d) return d;
                } else {
                    var i = this.countryCallingCodes()[e];
                    if (i && i.length === 1 && i[0] === "001") return this.metadata.countries["001"];
                }
            }
        },
        {
            key: "countryCallingCode",
            value: function() {
                return this.numberingPlan.callingCode();
            }
        },
        {
            key: "IDDPrefix",
            value: function() {
                return this.numberingPlan.IDDPrefix();
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function() {
                return this.numberingPlan.defaultIDDPrefix();
            }
        },
        {
            key: "nationalNumberPattern",
            value: function() {
                return this.numberingPlan.nationalNumberPattern();
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                return this.numberingPlan.possibleLengths();
            }
        },
        {
            key: "formats",
            value: function() {
                return this.numberingPlan.formats();
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function() {
                return this.numberingPlan.nationalPrefixForParsing();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function() {
                return this.numberingPlan.nationalPrefixTransformRule();
            }
        },
        {
            key: "leadingDigits",
            value: function() {
                return this.numberingPlan.leadingDigits();
            }
        },
        {
            key: "hasTypes",
            value: function() {
                return this.numberingPlan.hasTypes();
            }
        },
        {
            key: "type",
            value: function(e) {
                return this.numberingPlan.type(e);
            }
        },
        {
            key: "ext",
            value: function() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function() {
                return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
            }
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function(e) {
                return this.selectNumberingPlan(e);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function() {
                return this.numberingPlan !== void 0;
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$Ht = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this.globalMetadataObject = e, this.metadata = n, $bb50b4d24b214940$var$Ke.call(this, e.metadata);
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "callingCode",
            value: function() {
                return this.metadata[0];
            }
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            }
        },
        {
            key: "IDDPrefix",
            value: function() {
                if (!(this.v1 || this.v2)) return this.metadata[1];
            }
        },
        {
            key: "defaultIDDPrefix",
            value: function() {
                if (!(this.v1 || this.v2)) return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function() {
                return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function(e) {
                return e[this.v1 ? 2 : this.v2 ? 3 : 4];
            }
        },
        {
            key: "formats",
            value: function() {
                var e = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return r.map(function(d) {
                    return new $bb50b4d24b214940$var$br(d, e);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function(e) {
                return e[this.v1 ? 4 : this.v2 ? 5 : 6];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function() {
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function() {
                return this.types() && this.types().length === 0 ? !1 : !!this.types();
            }
        },
        {
            key: "type",
            value: function(e) {
                if (this.hasTypes() && $bb50b4d24b214940$var$Vt(this.types(), e)) return new $bb50b4d24b214940$var$Ar($bb50b4d24b214940$var$Vt(this.types(), e), this);
            }
        },
        {
            key: "ext",
            value: function() {
                return this.v1 || this.v2 ? $bb50b4d24b214940$var$Wt : this.metadata[13] || $bb50b4d24b214940$var$Wt;
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$br = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this._format = n, this.metadata = e;
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "pattern",
            value: function() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function() {
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "usesNationalPrefix",
            value: function() {
                return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$bb50b4d24b214940$var$Pr.test(this.nationalPrefixFormattingRule()));
            }
        },
        {
            key: "internationalFormat",
            value: function() {
                return this._format[5] || this.format();
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$Pr = /^\(?\$1\)?$/, $bb50b4d24b214940$var$Ar = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$dt(this, t), this.type = n, this.metadata = e;
    }
    return $bb50b4d24b214940$var$it(t, [
        {
            key: "pattern",
            value: function() {
                return this.metadata.v1 ? this.type : this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function() {
                if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Vt(t, n) {
    switch(n){
        case "FIXED_LINE":
            return t[0];
        case "MOBILE":
            return t[1];
        case "TOLL_FREE":
            return t[2];
        case "PREMIUM_RATE":
            return t[3];
        case "PERSONAL_NUMBER":
            return t[4];
        case "VOICEMAIL":
            return t[5];
        case "UAN":
            return t[6];
        case "PAGER":
            return t[7];
        case "VOIP":
            return t[8];
        case "SHARED_COST":
            return t[9];
    }
}
function $bb50b4d24b214940$var$Ir(t) {
    if (!t) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
    if (!$bb50b4d24b214940$var$R(t) || !$bb50b4d24b214940$var$R(t.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat($bb50b4d24b214940$var$R(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + $bb50b4d24b214940$var$xr(t) + ": " + t, "."));
}
var $bb50b4d24b214940$var$xr = function(n) {
    return $bb50b4d24b214940$var$Ct(n);
};
function $bb50b4d24b214940$var$Mt(t, n) {
    if (n = new $bb50b4d24b214940$var$v(n), n.hasCountry(t)) return n.country(t).countryCallingCode();
    throw new Error("Unknown country: ".concat(t));
}
function $bb50b4d24b214940$var$Or(t, n) {
    return n.countries.hasOwnProperty(t);
}
function $bb50b4d24b214940$var$Ke(t) {
    var n = t.version;
    typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? $bb50b4d24b214940$var$jt(n, $bb50b4d24b214940$var$vr) === -1 ? this.v2 = !0 : $bb50b4d24b214940$var$jt(n, $bb50b4d24b214940$var$Cr) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var $bb50b4d24b214940$var$Er = ";ext=", $bb50b4d24b214940$var$k = function(n) {
    return "([".concat($bb50b4d24b214940$var$N, "]{1,").concat(n, "})");
};
function $bb50b4d24b214940$var$Qe(t) {
    var n = "20", e = "15", r = "9", d = "6", i = "[ \xa0\\t,]*", a = "[:\\.\uFF0E]?[ \xa0\\t,-]*", o = "#?", u = "(?:e?xt(?:ensi(?:o\u0301?|\xf3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)", l = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)", $ = "[- ]+", c = "[ \xa0\\t]*", f = "(?:,{2}|;)", h = $bb50b4d24b214940$var$Er + $bb50b4d24b214940$var$k(n), g = i + u + a + $bb50b4d24b214940$var$k(n) + o, b = i + l + a + $bb50b4d24b214940$var$k(r) + o, p = $ + $bb50b4d24b214940$var$k(d) + "#", D = c + f + a + $bb50b4d24b214940$var$k(e) + o, j = c + "(?:,)+" + a + $bb50b4d24b214940$var$k(r) + o;
    return h + "|" + g + "|" + b + "|" + p + "|" + D + "|" + j;
}
var $bb50b4d24b214940$var$Sr = "[" + $bb50b4d24b214940$var$N + "]{" + $bb50b4d24b214940$var$Dt + "}", $bb50b4d24b214940$var$Tr = "[" + $bb50b4d24b214940$var$rt + "]{0,1}(?:[" + $bb50b4d24b214940$var$x + "]*[" + $bb50b4d24b214940$var$N + "]){3,}[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]*", $bb50b4d24b214940$var$Fr = new RegExp("^[" + $bb50b4d24b214940$var$rt + "]{0,1}(?:[" + $bb50b4d24b214940$var$x + "]*[" + $bb50b4d24b214940$var$N + "]){1,2}$", "i"), $bb50b4d24b214940$var$wr = $bb50b4d24b214940$var$Tr + // Phone number extensions
"(?:" + $bb50b4d24b214940$var$Qe() + ")?", $bb50b4d24b214940$var$Dr = new RegExp(// Either a short two-digit-only phone number
"^" + $bb50b4d24b214940$var$Sr + "$|^" + $bb50b4d24b214940$var$wr + "$", "i");
function $bb50b4d24b214940$var$Nt(t) {
    return t.length >= $bb50b4d24b214940$var$Dt && $bb50b4d24b214940$var$Dr.test(t);
}
function $bb50b4d24b214940$var$Mr(t) {
    return $bb50b4d24b214940$var$Fr.test(t);
}
var $bb50b4d24b214940$var$Zt = new RegExp("(?:" + $bb50b4d24b214940$var$Qe() + ")$", "i");
function $bb50b4d24b214940$var$Rr(t) {
    var n = t.search($bb50b4d24b214940$var$Zt);
    if (n < 0) return {};
    for(var e = t.slice(0, n), r = t.match($bb50b4d24b214940$var$Zt), d = 1; d < r.length;){
        if (r[d]) return {
            number: e,
            ext: r[d]
        };
        d++;
    }
}
function $bb50b4d24b214940$var$_r(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Lr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Lr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Yt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Yt(t, n);
    }
}
function $bb50b4d24b214940$var$Yt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$kr = {
    0: "0",
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    "\uFF10": "0",
    // Fullwidth digit 0
    "\uFF11": "1",
    // Fullwidth digit 1
    "\uFF12": "2",
    // Fullwidth digit 2
    "\uFF13": "3",
    // Fullwidth digit 3
    "\uFF14": "4",
    // Fullwidth digit 4
    "\uFF15": "5",
    // Fullwidth digit 5
    "\uFF16": "6",
    // Fullwidth digit 6
    "\uFF17": "7",
    // Fullwidth digit 7
    "\uFF18": "8",
    // Fullwidth digit 8
    "\uFF19": "9",
    // Fullwidth digit 9
    "\u0660": "0",
    // Arabic-indic digit 0
    "\u0661": "1",
    // Arabic-indic digit 1
    "\u0662": "2",
    // Arabic-indic digit 2
    "\u0663": "3",
    // Arabic-indic digit 3
    "\u0664": "4",
    // Arabic-indic digit 4
    "\u0665": "5",
    // Arabic-indic digit 5
    "\u0666": "6",
    // Arabic-indic digit 6
    "\u0667": "7",
    // Arabic-indic digit 7
    "\u0668": "8",
    // Arabic-indic digit 8
    "\u0669": "9",
    // Arabic-indic digit 9
    "\u06F0": "0",
    // Eastern-Arabic digit 0
    "\u06F1": "1",
    // Eastern-Arabic digit 1
    "\u06F2": "2",
    // Eastern-Arabic digit 2
    "\u06F3": "3",
    // Eastern-Arabic digit 3
    "\u06F4": "4",
    // Eastern-Arabic digit 4
    "\u06F5": "5",
    // Eastern-Arabic digit 5
    "\u06F6": "6",
    // Eastern-Arabic digit 6
    "\u06F7": "7",
    // Eastern-Arabic digit 7
    "\u06F8": "8",
    // Eastern-Arabic digit 8
    "\u06F9": "9"
};
function $bb50b4d24b214940$var$Je(t) {
    return $bb50b4d24b214940$var$kr[t];
}
function $bb50b4d24b214940$var$et(t) {
    for(var n = "", e = $bb50b4d24b214940$var$_r(t.split("")), r; !(r = e()).done;){
        var d = r.value, i = $bb50b4d24b214940$var$Je(d);
        i && (n += i);
    }
    return n;
}
function $bb50b4d24b214940$var$Gr(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Br(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Br(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$zt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$zt(t, n);
    }
}
function $bb50b4d24b214940$var$zt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Xt(t) {
    for(var n = "", e = $bb50b4d24b214940$var$Gr(t.split("")), r; !(r = e()).done;){
        var d = r.value;
        n += $bb50b4d24b214940$var$jr(d, n) || "";
    }
    return n;
}
function $bb50b4d24b214940$var$jr(t, n, e) {
    if (t === "+") {
        if (n) {
            typeof e == "function" && e("end");
            return;
        }
        return "+";
    }
    return $bb50b4d24b214940$var$Je(t);
}
function $bb50b4d24b214940$var$Ur(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Wr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Wr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Kt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Kt(t, n);
    }
}
function $bb50b4d24b214940$var$Kt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Hr(t, n) {
    for(var e = t.slice(), r = $bb50b4d24b214940$var$Ur(n), d; !(d = r()).done;){
        var i = d.value;
        t.indexOf(i) < 0 && e.push(i);
    }
    return e.sort(function(a, o) {
        return a - o;
    });
}
function $bb50b4d24b214940$var$at(t, n) {
    return $bb50b4d24b214940$var$qe(t, void 0, n);
}
function $bb50b4d24b214940$var$qe(t, n, e) {
    var r = e.type(n), d = r && r.possibleLengths() || e.possibleLengths();
    if (!d) return "IS_POSSIBLE";
    if (n === "FIXED_LINE_OR_MOBILE") {
        if (!e.type("FIXED_LINE")) return $bb50b4d24b214940$var$qe(t, "MOBILE", e);
        var i = e.type("MOBILE");
        i && (d = $bb50b4d24b214940$var$Hr(d, i.possibleLengths()));
    } else if (n && !r) return "INVALID_LENGTH";
    var a = t.length, o = d[0];
    return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : d[d.length - 1] < a ? "TOO_LONG" : d.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function $bb50b4d24b214940$var$Vr(t, n, e) {
    if (n === void 0 && (n = {}), e = new $bb50b4d24b214940$var$v(e), n.v2) {
        if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
        e.selectNumberingPlan(t.countryCallingCode);
    } else {
        if (!t.phone) return !1;
        if (t.country) {
            if (!e.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
            e.country(t.country);
        } else {
            if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
            e.selectNumberingPlan(t.countryCallingCode);
        }
    }
    if (e.possibleLengths()) return $bb50b4d24b214940$var$tn(t.phone || t.nationalNumber, e);
    if (t.countryCallingCode && e.isNonGeographicCallingCode(t.countryCallingCode)) return !0;
    throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function $bb50b4d24b214940$var$tn(t, n) {
    switch($bb50b4d24b214940$var$at(t, n)){
        case "IS_POSSIBLE":
            return !0;
        default:
            return !1;
    }
}
function $bb50b4d24b214940$var$T(t, n) {
    return t = t || "", new RegExp("^(?:" + n + ")$").test(t);
}
function $bb50b4d24b214940$var$Zr(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$Yr(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Yr(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Qt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Qt(t, n);
    }
}
function $bb50b4d24b214940$var$Qt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$zr = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
];
function $bb50b4d24b214940$var$ot(t, n, e) {
    if (n = n || {}, !(!t.country && !t.countryCallingCode)) {
        e = new $bb50b4d24b214940$var$v(e), e.selectNumberingPlan(t.country, t.countryCallingCode);
        var r = n.v2 ? t.nationalNumber : t.phone;
        if ($bb50b4d24b214940$var$T(r, e.nationalNumberPattern())) {
            if ($bb50b4d24b214940$var$ft(r, "FIXED_LINE", e)) return e.type("MOBILE") && e.type("MOBILE").pattern() === "" || !e.type("MOBILE") || $bb50b4d24b214940$var$ft(r, "MOBILE", e) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
            for(var d = $bb50b4d24b214940$var$Zr($bb50b4d24b214940$var$zr), i; !(i = d()).done;){
                var a = i.value;
                if ($bb50b4d24b214940$var$ft(r, a, e)) return a;
            }
        }
    }
}
function $bb50b4d24b214940$var$ft(t, n, e) {
    return n = e.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(t.length) < 0 ? !1 : $bb50b4d24b214940$var$T(t, n.pattern());
}
function $bb50b4d24b214940$var$Xr(t, n, e) {
    if (n = n || {}, e = new $bb50b4d24b214940$var$v(e), e.selectNumberingPlan(t.country, t.countryCallingCode), e.hasTypes()) return $bb50b4d24b214940$var$ot(t, n, e.metadata) !== void 0;
    var r = n.v2 ? t.nationalNumber : t.phone;
    return $bb50b4d24b214940$var$T(r, e.nationalNumberPattern());
}
function $bb50b4d24b214940$var$Kr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e), d = r.getCountryCodesForCallingCode(t);
    return d ? d.filter(function(i) {
        return $bb50b4d24b214940$var$Qr(n, i, e);
    }) : [];
}
function $bb50b4d24b214940$var$Qr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e);
    return r.selectNumberingPlan(n), r.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
function $bb50b4d24b214940$var$en(t) {
    return t.replace(new RegExp("[".concat($bb50b4d24b214940$var$x, "]+"), "g"), " ").trim();
}
var $bb50b4d24b214940$var$nn = /(\$\d)/;
function $bb50b4d24b214940$var$rn(t, n, e) {
    var r = e.useInternationalFormat, d = e.withNationalPrefix;
    e.carrierCode, e.metadata;
    var i = t.replace(new RegExp(n.pattern()), r ? n.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    d && n.nationalPrefixFormattingRule() ? n.format().replace($bb50b4d24b214940$var$nn, n.nationalPrefixFormattingRule()) : n.format());
    return r ? $bb50b4d24b214940$var$en(i) : i;
}
var $bb50b4d24b214940$var$Jr = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function $bb50b4d24b214940$var$qr(t, n, e) {
    var r = new $bb50b4d24b214940$var$v(e);
    if (r.selectNumberingPlan(t, n), r.defaultIDDPrefix()) return r.defaultIDDPrefix();
    if ($bb50b4d24b214940$var$Jr.test(r.IDDPrefix())) return r.IDDPrefix();
}
function $bb50b4d24b214940$var$td(t) {
    var n = t.number, e = t.ext;
    if (!n) return "";
    if (n[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(n).concat(e ? ";ext=" + e : "");
}
function $bb50b4d24b214940$var$ed(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$nd(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$nd(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Jt(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Jt(t, n);
    }
}
function $bb50b4d24b214940$var$Jt(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$qt(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$te(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$qt(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$rd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$qt(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$rd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
var $bb50b4d24b214940$var$ee = {
    formatExtension: function(n, e, r) {
        return "".concat(n).concat(r.ext()).concat(e);
    }
};
function $bb50b4d24b214940$var$dd(t, n, e, r) {
    if (e ? e = $bb50b4d24b214940$var$te($bb50b4d24b214940$var$te({}, $bb50b4d24b214940$var$ee), e) : e = $bb50b4d24b214940$var$ee, r = new $bb50b4d24b214940$var$v(r), t.country && t.country !== "001") {
        if (!r.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
        r.country(t.country);
    } else if (t.countryCallingCode) r.selectNumberingPlan(t.countryCallingCode);
    else return t.phone || "";
    var d = r.countryCallingCode(), i = e.v2 ? t.nationalNumber : t.phone, a;
    switch(n){
        case "NATIONAL":
            return i ? (a = $bb50b4d24b214940$var$nt(i, t.carrierCode, "NATIONAL", r, e), $bb50b4d24b214940$var$ct(a, t.ext, r, e.formatExtension)) : "";
        case "INTERNATIONAL":
            return i ? (a = $bb50b4d24b214940$var$nt(i, null, "INTERNATIONAL", r, e), a = "+".concat(d, " ").concat(a), $bb50b4d24b214940$var$ct(a, t.ext, r, e.formatExtension)) : "+".concat(d);
        case "E.164":
            return "+".concat(d).concat(i);
        case "RFC3966":
            return $bb50b4d24b214940$var$td({
                number: "+".concat(d).concat(i),
                ext: t.ext
            });
        case "IDD":
            if (!e.fromCountry) return;
            var o = $bb50b4d24b214940$var$ad(i, t.carrierCode, d, e.fromCountry, r);
            return $bb50b4d24b214940$var$ct(o, t.ext, r, e.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
    }
}
function $bb50b4d24b214940$var$nt(t, n, e, r, d) {
    var i = $bb50b4d24b214940$var$id(r.formats(), t);
    return i ? $bb50b4d24b214940$var$rn(t, i, {
        useInternationalFormat: e === "INTERNATIONAL",
        withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && d && d.nationalPrefix === !1),
        carrierCode: n,
        metadata: r
    }) : t;
}
function $bb50b4d24b214940$var$id(t, n) {
    for(var e = $bb50b4d24b214940$var$ed(t), r; !(r = e()).done;){
        var d = r.value;
        if (d.leadingDigitsPatterns().length > 0) {
            var i = d.leadingDigitsPatterns()[d.leadingDigitsPatterns().length - 1];
            if (n.search(i) !== 0) continue;
        }
        if ($bb50b4d24b214940$var$T(n, d.pattern())) return d;
    }
}
function $bb50b4d24b214940$var$ct(t, n, e, r) {
    return n ? r(t, n, e) : t;
}
function $bb50b4d24b214940$var$ad(t, n, e, r, d) {
    var i = $bb50b4d24b214940$var$Mt(r, d.metadata);
    if (i === e) {
        var a = $bb50b4d24b214940$var$nt(t, n, "NATIONAL", d);
        return e === "1" ? e + " " + a : a;
    }
    var o = $bb50b4d24b214940$var$qr(r, void 0, d.metadata);
    if (o) return "".concat(o, " ").concat(e, " ").concat($bb50b4d24b214940$var$nt(t, null, "INTERNATIONAL", d));
}
function $bb50b4d24b214940$var$ne(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$re(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$ne(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$od(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$ne(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$od(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$ud(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$de(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$ld(t, n, e) {
    return n && $bb50b4d24b214940$var$de(t.prototype, n), e && $bb50b4d24b214940$var$de(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$dn = /* @__PURE__ */ function() {
    function t(n, e, r) {
        if ($bb50b4d24b214940$var$ud(this, t), !n) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!e) throw new TypeError("`nationalNumber` not passed");
        if (!r) throw new TypeError("`metadata` not passed");
        var d = $bb50b4d24b214940$var$sd(n, r), i = d.country, a = d.countryCallingCode;
        this.country = i, this.countryCallingCode = a, this.nationalNumber = e, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
            return r;
        };
    }
    return $bb50b4d24b214940$var$ld(t, [
        {
            key: "setExt",
            value: function(e) {
                this.ext = e;
            }
        },
        {
            key: "getPossibleCountries",
            value: function() {
                return this.country ? [
                    this.country
                ] : $bb50b4d24b214940$var$Kr(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function() {
                return $bb50b4d24b214940$var$Vr(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function() {
                return $bb50b4d24b214940$var$Xr(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function() {
                var e = new $bb50b4d24b214940$var$v(this.getMetadata());
                return e.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function(e) {
                return this.number === e.number && this.ext === e.ext;
            }
        },
        {
            key: "getType",
            value: function() {
                return $bb50b4d24b214940$var$ot(this, {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function(e, r) {
                return $bb50b4d24b214940$var$dd(this, e, r ? $bb50b4d24b214940$var$re($bb50b4d24b214940$var$re({}, r), {}, {
                    v2: !0
                }) : {
                    v2: !0
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function(e) {
                return this.format("NATIONAL", e);
            }
        },
        {
            key: "formatInternational",
            value: function(e) {
                return this.format("INTERNATIONAL", e);
            }
        },
        {
            key: "getURI",
            value: function(e) {
                return this.format("RFC3966", e);
            }
        }
    ]), t;
}(), $bb50b4d24b214940$var$$d = function(n) {
    return /^[A-Z]{2}$/.test(n);
};
function $bb50b4d24b214940$var$sd(t, n) {
    var e, r, d = new $bb50b4d24b214940$var$v(n);
    return $bb50b4d24b214940$var$$d(t) ? (e = t, d.selectNumberingPlan(e), r = d.countryCallingCode()) : r = t, {
        country: e,
        countryCallingCode: r
    };
}
var $bb50b4d24b214940$var$fd = new RegExp("([" + $bb50b4d24b214940$var$N + "])");
function $bb50b4d24b214940$var$an(t, n, e, r) {
    if (n) {
        var d = new $bb50b4d24b214940$var$v(r);
        d.selectNumberingPlan(n, e);
        var i = new RegExp(d.IDDPrefix());
        if (t.search(i) === 0) {
            t = t.slice(t.match(i)[0].length);
            var a = t.match($bb50b4d24b214940$var$fd);
            if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0")) return t;
        }
    }
}
function $bb50b4d24b214940$var$bt(t, n) {
    if (t && n.numberingPlan.nationalPrefixForParsing()) {
        var e = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), r = e.exec(t);
        if (r) {
            var d, i, a = r.length - 1, o = a > 0 && r[a];
            if (n.nationalPrefixTransformRule() && o) d = t.replace(e, n.nationalPrefixTransformRule()), a > 1 && (i = r[1]);
            else {
                var u = r[0];
                d = t.slice(u.length), o && (i = r[1]);
            }
            var l;
            if (o) {
                var $ = t.indexOf(r[1]), c = t.slice(0, $);
                c === n.numberingPlan.nationalPrefix() && (l = n.numberingPlan.nationalPrefix());
            } else l = r[0];
            return {
                nationalNumber: d,
                nationalPrefix: l,
                carrierCode: i
            };
        }
    }
    return {
        nationalNumber: t
    };
}
function $bb50b4d24b214940$var$Pt(t, n) {
    var e = $bb50b4d24b214940$var$bt(t, n), r = e.carrierCode, d = e.nationalNumber;
    if (d !== t) {
        if (!$bb50b4d24b214940$var$cd(t, d, n)) return {
            nationalNumber: t
        };
        if (n.possibleLengths() && !$bb50b4d24b214940$var$hd(d, n)) return {
            nationalNumber: t
        };
    }
    return {
        nationalNumber: d,
        carrierCode: r
    };
}
function $bb50b4d24b214940$var$cd(t, n, e) {
    return !($bb50b4d24b214940$var$T(t, e.nationalNumberPattern()) && !$bb50b4d24b214940$var$T(n, e.nationalNumberPattern()));
}
function $bb50b4d24b214940$var$hd(t, n) {
    switch($bb50b4d24b214940$var$at(t, n)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            return !1;
        default:
            return !0;
    }
}
function $bb50b4d24b214940$var$on(t, n, e, r) {
    var d = n ? $bb50b4d24b214940$var$Mt(n, r) : e;
    if (t.indexOf(d) === 0) {
        r = new $bb50b4d24b214940$var$v(r), r.selectNumberingPlan(n, e);
        var i = t.slice(d.length), a = $bb50b4d24b214940$var$Pt(i, r), o = a.nationalNumber, u = $bb50b4d24b214940$var$Pt(t, r), l = u.nationalNumber;
        if (!$bb50b4d24b214940$var$T(l, r.nationalNumberPattern()) && $bb50b4d24b214940$var$T(o, r.nationalNumberPattern()) || $bb50b4d24b214940$var$at(l, r) === "TOO_LONG") return {
            countryCallingCode: d,
            number: i
        };
    }
    return {
        number: t
    };
}
function $bb50b4d24b214940$var$un(t, n, e, r) {
    if (!t) return {};
    var d;
    if (t[0] !== "+") {
        var i = $bb50b4d24b214940$var$an(t, n, e, r);
        if (i && i !== t) d = !0, t = "+" + i;
        else {
            if (n || e) {
                var a = $bb50b4d24b214940$var$on(t, n, e, r), o = a.countryCallingCode, u = a.number;
                if (o) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: o,
                    number: u
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: t
            };
        }
    }
    if (t[1] === "0") return {};
    r = new $bb50b4d24b214940$var$v(r);
    for(var l = 2; l - 1 <= $bb50b4d24b214940$var$sr && l <= t.length;){
        var $ = t.slice(1, l);
        if (r.hasCallingCode($)) return r.selectNumberingPlan($), {
            countryCallingCodeSource: d ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
            countryCallingCode: $,
            number: t.slice(l)
        };
        l++;
    }
    return {};
}
function $bb50b4d24b214940$var$gd(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$md(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$md(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$ie(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$ie(t, n);
    }
}
function $bb50b4d24b214940$var$ie(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$ln(t, n) {
    var e = n.countries, r = n.defaultCountry, d = n.metadata;
    d = new $bb50b4d24b214940$var$v(d);
    for(var i = [], a = $bb50b4d24b214940$var$gd(e), o; !(o = a()).done;){
        var u = o.value;
        if (d.country(u), d.leadingDigits()) {
            if (t && t.search(d.leadingDigits()) === 0) return u;
        } else if ($bb50b4d24b214940$var$ot({
            phone: t,
            country: u
        }, void 0, d.metadata)) {
            if (r) {
                if (u === r) return u;
                i.push(u);
            } else return u;
        }
    }
    if (i.length > 0) return i[0];
}
var $bb50b4d24b214940$var$yd = !1;
function $bb50b4d24b214940$var$$n(t, n) {
    var e = n.nationalNumber, r = n.defaultCountry, d = n.metadata;
    if ($bb50b4d24b214940$var$yd && d.isNonGeographicCallingCode(t)) return "001";
    var i = d.getCountryCodesForCallingCode(t);
    if (i) return i.length === 1 ? i[0] : $bb50b4d24b214940$var$ln(e, {
        countries: i,
        defaultCountry: r,
        metadata: d.metadata
    });
}
var $bb50b4d24b214940$var$sn = "+", $bb50b4d24b214940$var$pd = "[\\-\\.\\(\\)]?", $bb50b4d24b214940$var$ae = "([" + $bb50b4d24b214940$var$N + "]|" + $bb50b4d24b214940$var$pd + ")", $bb50b4d24b214940$var$vd = "^\\" + $bb50b4d24b214940$var$sn + $bb50b4d24b214940$var$ae + "*[" + $bb50b4d24b214940$var$N + "]" + $bb50b4d24b214940$var$ae + "*$", $bb50b4d24b214940$var$Cd = new RegExp($bb50b4d24b214940$var$vd, "g"), $bb50b4d24b214940$var$At = $bb50b4d24b214940$var$N, $bb50b4d24b214940$var$Nd = "[" + $bb50b4d24b214940$var$At + "]+((\\-)*[" + $bb50b4d24b214940$var$At + "])*", $bb50b4d24b214940$var$bd = "a-zA-Z", $bb50b4d24b214940$var$Pd = "[" + $bb50b4d24b214940$var$bd + "]+((\\-)*[" + $bb50b4d24b214940$var$At + "])*", $bb50b4d24b214940$var$Ad = "^(" + $bb50b4d24b214940$var$Nd + "\\.)*" + $bb50b4d24b214940$var$Pd + "\\.?$", $bb50b4d24b214940$var$Id = new RegExp($bb50b4d24b214940$var$Ad, "g"), $bb50b4d24b214940$var$oe = "tel:", $bb50b4d24b214940$var$It = ";phone-context=", $bb50b4d24b214940$var$xd = ";isub=";
function $bb50b4d24b214940$var$Od(t) {
    var n = t.indexOf($bb50b4d24b214940$var$It);
    if (n < 0) return null;
    var e = n + $bb50b4d24b214940$var$It.length;
    if (e >= t.length) return "";
    var r = t.indexOf(";", e);
    return r >= 0 ? t.substring(e, r) : t.substring(e);
}
function $bb50b4d24b214940$var$Ed(t) {
    return t === null ? !0 : t.length === 0 ? !1 : $bb50b4d24b214940$var$Cd.test(t) || $bb50b4d24b214940$var$Id.test(t);
}
function $bb50b4d24b214940$var$Sd(t, n) {
    var e = n.extractFormattedPhoneNumber, r = $bb50b4d24b214940$var$Od(t);
    if (!$bb50b4d24b214940$var$Ed(r)) throw new $bb50b4d24b214940$var$E("NOT_A_NUMBER");
    var d;
    if (r === null) d = e(t) || "";
    else {
        d = "", r.charAt(0) === $bb50b4d24b214940$var$sn && (d += r);
        var i = t.indexOf($bb50b4d24b214940$var$oe), a;
        i >= 0 ? a = i + $bb50b4d24b214940$var$oe.length : a = 0;
        var o = t.indexOf($bb50b4d24b214940$var$It);
        d += t.substring(a, o);
    }
    var u = d.indexOf($bb50b4d24b214940$var$xd);
    if (u > 0 && (d = d.substring(0, u)), d !== "") return d;
}
var $bb50b4d24b214940$var$Td = 250, $bb50b4d24b214940$var$Fd = new RegExp("[" + $bb50b4d24b214940$var$rt + $bb50b4d24b214940$var$N + "]"), $bb50b4d24b214940$var$wd = new RegExp("[^" + $bb50b4d24b214940$var$N + "#]+$");
function $bb50b4d24b214940$var$xt(t, n, e) {
    if (n = n || {}, e = new $bb50b4d24b214940$var$v(e), n.defaultCountry && !e.hasCountry(n.defaultCountry)) throw n.v2 ? new $bb50b4d24b214940$var$E("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
    var r = $bb50b4d24b214940$var$Md(t, n.v2, n.extract), d = r.number, i = r.ext, a = r.error;
    if (!d) {
        if (n.v2) throw a === "TOO_SHORT" ? new $bb50b4d24b214940$var$E("TOO_SHORT") : new $bb50b4d24b214940$var$E("NOT_A_NUMBER");
        return {};
    }
    var o = $bb50b4d24b214940$var$_d(d, n.defaultCountry, n.defaultCallingCode, e), u = o.country, l = o.nationalNumber, $ = o.countryCallingCode, c = o.countryCallingCodeSource, f = o.carrierCode;
    if (!e.hasSelectedNumberingPlan()) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("INVALID_COUNTRY");
        return {};
    }
    if (!l || l.length < $bb50b4d24b214940$var$Dt) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("TOO_SHORT");
        return {};
    }
    if (l.length > $bb50b4d24b214940$var$$r) {
        if (n.v2) throw new $bb50b4d24b214940$var$E("TOO_LONG");
        return {};
    }
    if (n.v2) {
        var h = new $bb50b4d24b214940$var$dn($, l, e.metadata);
        return u && (h.country = u), f && (h.carrierCode = f), i && (h.ext = i), h.__countryCallingCodeSource = c, h;
    }
    var g = (n.extended ? e.hasSelectedNumberingPlan() : u) ? $bb50b4d24b214940$var$T(l, e.nationalNumberPattern()) : !1;
    return n.extended ? {
        country: u,
        countryCallingCode: $,
        carrierCode: f,
        valid: g,
        possible: g ? !0 : !!(n.extended === !0 && e.possibleLengths() && $bb50b4d24b214940$var$tn(l, e)),
        phone: l,
        ext: i
    } : g ? $bb50b4d24b214940$var$Rd(u, l, i) : {};
}
function $bb50b4d24b214940$var$Dd(t, n, e) {
    if (t) {
        if (t.length > $bb50b4d24b214940$var$Td) {
            if (e) throw new $bb50b4d24b214940$var$E("TOO_LONG");
            return;
        }
        if (n === !1) return t;
        var r = t.search($bb50b4d24b214940$var$Fd);
        if (!(r < 0)) return t.slice(r).replace($bb50b4d24b214940$var$wd, "");
    }
}
function $bb50b4d24b214940$var$Md(t, n, e) {
    var r = $bb50b4d24b214940$var$Sd(t, {
        extractFormattedPhoneNumber: function(a) {
            return $bb50b4d24b214940$var$Dd(a, e, n);
        }
    });
    if (!r) return {};
    if (!$bb50b4d24b214940$var$Nt(r)) return $bb50b4d24b214940$var$Mr(r) ? {
        error: "TOO_SHORT"
    } : {};
    var d = $bb50b4d24b214940$var$Rr(r);
    return d.ext ? d : {
        number: r
    };
}
function $bb50b4d24b214940$var$Rd(t, n, e) {
    var r = {
        country: t,
        phone: n
    };
    return e && (r.ext = e), r;
}
function $bb50b4d24b214940$var$_d(t, n, e, r) {
    var d = $bb50b4d24b214940$var$un($bb50b4d24b214940$var$Xt(t), n, e, r.metadata), i = d.countryCallingCodeSource, a = d.countryCallingCode, o = d.number, u;
    if (a) r.selectNumberingPlan(a);
    else if (o && (n || e)) r.selectNumberingPlan(n, e), n && (u = n), a = e || $bb50b4d24b214940$var$Mt(n, r.metadata);
    else return {};
    if (!o) return {
        countryCallingCodeSource: i,
        countryCallingCode: a
    };
    var l = $bb50b4d24b214940$var$Pt($bb50b4d24b214940$var$Xt(o), r), $ = l.nationalNumber, c = l.carrierCode, f = $bb50b4d24b214940$var$$n(a, {
        nationalNumber: $,
        defaultCountry: n,
        metadata: r
    });
    return f && (u = f, f === "001" || r.country(u)), {
        country: u,
        countryCallingCode: a,
        countryCallingCodeSource: i,
        nationalNumber: $,
        carrierCode: c
    };
}
function $bb50b4d24b214940$var$ue(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$le(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$ue(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Ld(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$ue(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Ld(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$kd(t, n, e) {
    return $bb50b4d24b214940$var$xt(t, $bb50b4d24b214940$var$le($bb50b4d24b214940$var$le({}, n), {}, {
        v2: !0
    }), e);
}
function $bb50b4d24b214940$var$$e(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$Gd(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$$e(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Bd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$$e(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Bd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$jd(t, n) {
    return $bb50b4d24b214940$var$Vd(t) || $bb50b4d24b214940$var$Hd(t, n) || $bb50b4d24b214940$var$Wd(t, n) || $bb50b4d24b214940$var$Ud();
}
function $bb50b4d24b214940$var$Ud() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Wd(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$se(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$se(t, n);
    }
}
function $bb50b4d24b214940$var$se(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Hd(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Vd(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$Zd(t) {
    var n = Array.prototype.slice.call(t), e = $bb50b4d24b214940$var$jd(n, 4), r = e[0], d = e[1], i = e[2], a = e[3], o, u, l;
    if (typeof r == "string") o = r;
    else throw new TypeError("A text for parsing must be a string.");
    if (!d || typeof d == "string") a ? (u = i, l = a) : (u = void 0, l = i), d && (u = $bb50b4d24b214940$var$Gd({
        defaultCountry: d
    }, u));
    else if ($bb50b4d24b214940$var$R(d)) i ? (u = d, l = i) : l = d;
    else throw new Error("Invalid second argument: ".concat(d));
    return {
        text: o,
        options: u,
        metadata: l
    };
}
function $bb50b4d24b214940$var$fe(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$ce(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$fe(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Yd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$fe(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Yd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$zd(t, n, e) {
    n && n.defaultCountry && !$bb50b4d24b214940$var$Or(n.defaultCountry, e) && (n = $bb50b4d24b214940$var$ce($bb50b4d24b214940$var$ce({}, n), {}, {
        defaultCountry: void 0
    }));
    try {
        return $bb50b4d24b214940$var$kd(t, n, e);
    } catch (r) {
        if (!(r instanceof $bb50b4d24b214940$var$E)) throw r;
    }
}
function $bb50b4d24b214940$var$he(t, n) {
    var e = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(t);
        n && (r = r.filter(function(d) {
            return Object.getOwnPropertyDescriptor(t, d).enumerable;
        })), e.push.apply(e, r);
    }
    return e;
}
function $bb50b4d24b214940$var$ge(t) {
    for(var n = 1; n < arguments.length; n++){
        var e = arguments[n] != null ? arguments[n] : {};
        n % 2 ? $bb50b4d24b214940$var$he(Object(e), !0).forEach(function(r) {
            $bb50b4d24b214940$var$Xd(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : $bb50b4d24b214940$var$he(Object(e)).forEach(function(r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
    }
    return t;
}
function $bb50b4d24b214940$var$Xd(t, n, e) {
    return n in t ? Object.defineProperty(t, n, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[n] = e, t;
}
function $bb50b4d24b214940$var$Kd() {
    var t = $bb50b4d24b214940$var$Zd(arguments), n = t.text, e = t.options, r = t.metadata;
    e = $bb50b4d24b214940$var$ge($bb50b4d24b214940$var$ge({}, e), {}, {
        extract: !1
    });
    var d = $bb50b4d24b214940$var$zd(n, e, r);
    return d && d.isValid() || !1;
}
function $bb50b4d24b214940$var$Qd(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$me(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Jd(t, n, e) {
    return n && $bb50b4d24b214940$var$me(t.prototype, n), e && $bb50b4d24b214940$var$me(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$qd = /* @__PURE__ */ function() {
    function t(n) {
        var e = n.onCountryChange, r = n.onCallingCodeChange;
        $bb50b4d24b214940$var$Qd(this, t), this.onCountryChange = e, this.onCallingCodeChange = r;
    }
    return $bb50b4d24b214940$var$Jd(t, [
        {
            key: "reset",
            value: function(e) {
                var r = e.country, d = e.callingCode;
                this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, d);
            }
        },
        {
            key: "resetNationalSignificantNumber",
            value: function() {
                this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
            }
        },
        {
            key: "update",
            value: function(e) {
                for(var r = 0, d = Object.keys(e); r < d.length; r++){
                    var i = d[r];
                    this[i] = e[i];
                }
            }
        },
        {
            key: "initCountryAndCallingCode",
            value: function(e, r) {
                this.setCountry(e), this.setCallingCode(r);
            }
        },
        {
            key: "setCountry",
            value: function(e) {
                this.country = e, this.onCountryChange(e);
            }
        },
        {
            key: "setCallingCode",
            value: function(e) {
                this.callingCode = e, this.onCallingCodeChange(e, this.country);
            }
        },
        {
            key: "startInternationalNumber",
            value: function(e, r) {
                this.international = !0, this.initCountryAndCallingCode(e, r);
            }
        },
        {
            key: "appendDigits",
            value: function(e) {
                this.digits += e;
            }
        },
        {
            key: "appendNationalSignificantNumberDigits",
            value: function(e) {
                this.nationalSignificantNumber += e;
            }
        },
        {
            key: "getNationalDigits",
            value: function() {
                return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
            }
        },
        {
            key: "getDigitsWithoutInternationalPrefix",
            value: function() {
                return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$ti(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$ei(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$ei(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$ye(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$ye(t, n);
    }
}
function $bb50b4d24b214940$var$ye(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
var $bb50b4d24b214940$var$I = "x", $bb50b4d24b214940$var$ht = new RegExp($bb50b4d24b214940$var$I);
function $bb50b4d24b214940$var$Q(t, n) {
    if (n < 1) return "";
    for(var e = ""; n > 1;)n & 1 && (e += t), n >>= 1, t += t;
    return e + t;
}
function $bb50b4d24b214940$var$pe(t, n) {
    return t[n] === ")" && n++, $bb50b4d24b214940$var$ni(t.slice(0, n));
}
function $bb50b4d24b214940$var$ni(t) {
    for(var n = [], e = 0; e < t.length;)t[e] === "(" ? n.push(e) : t[e] === ")" && n.pop(), e++;
    var r = 0, d = "";
    n.push(t.length);
    for(var i = 0, a = n; i < a.length; i++){
        var o = a[i];
        d += t.slice(r, o), r = o + 1;
    }
    return d;
}
function $bb50b4d24b214940$var$ri(t, n, e) {
    for(var r = $bb50b4d24b214940$var$ti(e.split("")), d; !(d = r()).done;){
        var i = d.value;
        if (t.slice(n + 1).search($bb50b4d24b214940$var$ht) < 0) return;
        n = t.search($bb50b4d24b214940$var$ht), t = t.replace($bb50b4d24b214940$var$ht, i);
    }
    return [
        t,
        n
    ];
}
function $bb50b4d24b214940$var$di(t, n, e) {
    var r = e.metadata, d = e.shouldTryNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix, a = new RegExp("^(?:".concat(n.pattern(), ")$"));
    if (a.test(t.nationalSignificantNumber)) return $bb50b4d24b214940$var$ai(t, n, {
        metadata: r,
        shouldTryNationalPrefixFormattingRule: d,
        getSeparatorAfterNationalPrefix: i
    });
}
function $bb50b4d24b214940$var$ii(t, n) {
    return $bb50b4d24b214940$var$at(t, n) === "IS_POSSIBLE";
}
function $bb50b4d24b214940$var$ai(t, n, e) {
    var r = e.metadata, d = e.shouldTryNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix;
    if (t.nationalSignificantNumber, t.international, t.nationalPrefix, t.carrierCode, d(n)) {
        var a = $bb50b4d24b214940$var$ve(t, n, {
            useNationalPrefixFormattingRule: !0,
            getSeparatorAfterNationalPrefix: i,
            metadata: r
        });
        if (a) return a;
    }
    return $bb50b4d24b214940$var$ve(t, n, {
        useNationalPrefixFormattingRule: !1,
        getSeparatorAfterNationalPrefix: i,
        metadata: r
    });
}
function $bb50b4d24b214940$var$ve(t, n, e) {
    var r = e.metadata, d = e.useNationalPrefixFormattingRule, i = e.getSeparatorAfterNationalPrefix, a = $bb50b4d24b214940$var$rn(t.nationalSignificantNumber, n, {
        carrierCode: t.carrierCode,
        useInternationalFormat: t.international,
        withNationalPrefix: d,
        metadata: r
    });
    if (d || (t.nationalPrefix ? a = t.nationalPrefix + i(n) + a : t.complexPrefixBeforeNationalSignificantNumber && (a = t.complexPrefixBeforeNationalSignificantNumber + " " + a)), $bb50b4d24b214940$var$oi(a, t)) return a;
}
function $bb50b4d24b214940$var$oi(t, n) {
    return $bb50b4d24b214940$var$et(t) === n.getNationalDigits();
}
function $bb50b4d24b214940$var$ui(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Ce(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$li(t, n, e) {
    return n && $bb50b4d24b214940$var$Ce(t.prototype, n), e && $bb50b4d24b214940$var$Ce(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$$i = /* @__PURE__ */ function() {
    function t() {
        $bb50b4d24b214940$var$ui(this, t);
    }
    return $bb50b4d24b214940$var$li(t, [
        {
            key: "parse",
            value: function(e) {
                if (this.context = [
                    {
                        or: !0,
                        instructions: []
                    }
                ], this.parsePattern(e), this.context.length !== 1) throw new Error("Non-finalized contexts left when pattern parse ended");
                var r = this.context[0], d = r.branches, i = r.instructions;
                if (d) return {
                    op: "|",
                    args: d.concat([
                        $bb50b4d24b214940$var$gt(i)
                    ])
                };
                if (i.length === 0) throw new Error("Pattern is required");
                return i.length === 1 ? i[0] : i;
            }
        },
        {
            key: "startContext",
            value: function(e) {
                this.context.push(e);
            }
        },
        {
            key: "endContext",
            value: function() {
                this.context.pop();
            }
        },
        {
            key: "getContext",
            value: function() {
                return this.context[this.context.length - 1];
            }
        },
        {
            key: "parsePattern",
            value: function(e) {
                if (!e) throw new Error("Pattern is required");
                var r = e.match($bb50b4d24b214940$var$ci);
                if (!r) {
                    if ($bb50b4d24b214940$var$fi.test(e)) throw new Error("Illegal characters found in a pattern: ".concat(e));
                    this.getContext().instructions = this.getContext().instructions.concat(e.split(""));
                    return;
                }
                var d = r[1], i = e.slice(0, r.index), a = e.slice(r.index + d.length);
                switch(d){
                    case "(?:":
                        i && this.parsePattern(i), this.startContext({
                            or: !0,
                            instructions: [],
                            branches: []
                        });
                        break;
                    case ")":
                        if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
                        if (i && this.parsePattern(i), this.getContext().instructions.length === 0) throw new Error('No instructions found after "|" operator in an "or" group');
                        var o = this.getContext(), u = o.branches;
                        u.push($bb50b4d24b214940$var$gt(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
                            op: "|",
                            args: u
                        });
                        break;
                    case "|":
                        if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
                        if (i && this.parsePattern(i), !this.getContext().branches) {
                            if (this.context.length === 1) this.getContext().branches = [];
                            else throw new Error('"branches" not found in an "or" group context');
                        }
                        this.getContext().branches.push($bb50b4d24b214940$var$gt(this.getContext().instructions)), this.getContext().instructions = [];
                        break;
                    case "[":
                        i && this.parsePattern(i), this.startContext({
                            oneOfSet: !0
                        });
                        break;
                    case "]":
                        if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
                        this.endContext(), this.getContext().instructions.push({
                            op: "[]",
                            args: $bb50b4d24b214940$var$si(i)
                        });
                        break;
                    default:
                        throw new Error("Unknown operator: ".concat(d));
                }
                a && this.parsePattern(a);
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$si(t) {
    for(var n = [], e = 0; e < t.length;){
        if (t[e] === "-") {
            if (e === 0 || e === t.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(t));
            for(var r = t[e - 1].charCodeAt(0) + 1, d = t[e + 1].charCodeAt(0) - 1, i = r; i <= d;)n.push(String.fromCharCode(i)), i++;
        } else n.push(t[e]);
        e++;
    }
    return n;
}
var $bb50b4d24b214940$var$fi = /[\(\)\[\]\?\:\|]/, $bb50b4d24b214940$var$ci = new RegExp(// any of:
"(\\||\\(\\?\\:|\\)|\\[|\\])");
function $bb50b4d24b214940$var$gt(t) {
    return t.length === 1 ? t[0] : t;
}
function $bb50b4d24b214940$var$Ne(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$hi(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$hi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$be(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$be(t, n);
    }
}
function $bb50b4d24b214940$var$be(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$gi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Pe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$mi(t, n, e) {
    return n && $bb50b4d24b214940$var$Pe(t.prototype, n), e && $bb50b4d24b214940$var$Pe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$yi = /* @__PURE__ */ function() {
    function t(n) {
        $bb50b4d24b214940$var$gi(this, t), this.matchTree = new $bb50b4d24b214940$var$$i().parse(n);
    }
    return $bb50b4d24b214940$var$mi(t, [
        {
            key: "match",
            value: function(e) {
                var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, d = r.allowOverflow;
                if (!e) throw new Error("String is required");
                var i = $bb50b4d24b214940$var$Ot(e.split(""), this.matchTree, !0);
                if (i && i.match && delete i.matchedChars, !(i && i.overflow && !d)) return i;
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Ot(t, n, e) {
    if (typeof n == "string") {
        var r = t.join("");
        return n.indexOf(r) === 0 ? t.length === n.length ? {
            match: !0,
            matchedChars: t
        } : {
            partialMatch: !0
        } : r.indexOf(n) === 0 ? e && t.length > n.length ? {
            overflow: !0
        } : {
            match: !0,
            matchedChars: t.slice(0, n.length)
        } : void 0;
    }
    if (Array.isArray(n)) {
        for(var d = t.slice(), i = 0; i < n.length;){
            var a = n[i], o = $bb50b4d24b214940$var$Ot(d, a, e && i === n.length - 1);
            if (o) {
                if (o.overflow) return o;
                if (o.match) {
                    if (d = d.slice(o.matchedChars.length), d.length === 0) return i === n.length - 1 ? {
                        match: !0,
                        matchedChars: t
                    } : {
                        partialMatch: !0
                    };
                } else {
                    if (o.partialMatch) return {
                        partialMatch: !0
                    };
                    throw new Error(`Unsupported match result:
`.concat(JSON.stringify(o, null, 2)));
                }
            } else return;
            i++;
        }
        return e ? {
            overflow: !0
        } : {
            match: !0,
            matchedChars: t.slice(0, t.length - d.length)
        };
    }
    switch(n.op){
        case "|":
            for(var u, l = $bb50b4d24b214940$var$Ne(n.args), $; !($ = l()).done;){
                var c = $.value, f = $bb50b4d24b214940$var$Ot(t, c, e);
                if (f) {
                    if (f.overflow) return f;
                    if (f.match) return {
                        match: !0,
                        matchedChars: f.matchedChars
                    };
                    if (f.partialMatch) u = !0;
                    else throw new Error(`Unsupported match result:
`.concat(JSON.stringify(f, null, 2)));
                }
            }
            return u ? {
                partialMatch: !0
            } : void 0;
        case "[]":
            for(var h = $bb50b4d24b214940$var$Ne(n.args), g; !(g = h()).done;){
                var b = g.value;
                if (t[0] === b) return t.length === 1 ? {
                    match: !0,
                    matchedChars: t
                } : e ? {
                    overflow: !0
                } : {
                    match: !0,
                    matchedChars: [
                        b
                    ]
                };
            }
            return;
        default:
            throw new Error("Unsupported instruction tree: ".concat(n));
    }
}
function $bb50b4d24b214940$var$Ae(t, n) {
    var e = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e) return (e = e.call(t)).next.bind(e);
    if (Array.isArray(t) || (e = $bb50b4d24b214940$var$pi(t)) || n && t && typeof t.length == "number") {
        e && (t = e);
        var r = 0;
        return function() {
            return r >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[r++]
            };
        };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$pi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Ie(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Ie(t, n);
    }
}
function $bb50b4d24b214940$var$Ie(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$vi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$xe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Ci(t, n, e) {
    return n && $bb50b4d24b214940$var$xe(t.prototype, n), e && $bb50b4d24b214940$var$xe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$Et = "9", $bb50b4d24b214940$var$Ni = 15, $bb50b4d24b214940$var$bi = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$Et, $bb50b4d24b214940$var$Ni), $bb50b4d24b214940$var$Pi = /[- ]/, $bb50b4d24b214940$var$Ai = function() {
    return /\[([^\[\]])*\]/g;
}, $bb50b4d24b214940$var$Ii = function() {
    return /\d(?=[^,}][^,}])/g;
}, $bb50b4d24b214940$var$xi = new RegExp("[" + $bb50b4d24b214940$var$x + "]*\\$1[" + $bb50b4d24b214940$var$x + "]*(\\$\\d[" + $bb50b4d24b214940$var$x + "]*)*$"), $bb50b4d24b214940$var$Oe = 3, $bb50b4d24b214940$var$Oi = /* @__PURE__ */ function() {
    function t(n) {
        n.state;
        var e = n.metadata;
        $bb50b4d24b214940$var$vi(this, t), this.metadata = e, this.resetFormat();
    }
    return $bb50b4d24b214940$var$Ci(t, [
        {
            key: "resetFormat",
            value: function() {
                this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
            }
        },
        {
            key: "reset",
            value: function(e, r) {
                this.resetFormat(), e ? (this.isNANP = e.callingCode() === "1", this.matchingFormats = e.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
            }
        },
        {
            key: "format",
            value: function(e, r) {
                var d = this;
                if ($bb50b4d24b214940$var$ii(r.nationalSignificantNumber, this.metadata)) for(var i = $bb50b4d24b214940$var$Ae(this.matchingFormats), a; !(a = i()).done;){
                    var o = a.value, u = $bb50b4d24b214940$var$di(r, o, {
                        metadata: this.metadata,
                        shouldTryNationalPrefixFormattingRule: function($) {
                            return d.shouldTryNationalPrefixFormattingRule($, {
                                international: r.international,
                                nationalPrefix: r.nationalPrefix
                            });
                        },
                        getSeparatorAfterNationalPrefix: function($) {
                            return d.getSeparatorAfterNationalPrefix($);
                        }
                    });
                    if (u) return this.resetFormat(), this.chosenFormat = o, this.setNationalNumberTemplate(u.replace(/\d/g, $bb50b4d24b214940$var$I), r), this.populatedNationalNumberTemplate = u, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf($bb50b4d24b214940$var$I), u;
                }
                return this.formatNationalNumberWithNextDigits(e, r);
            }
        },
        {
            key: "formatNationalNumberWithNextDigits",
            value: function(e, r) {
                var d = this.chosenFormat, i = this.chooseFormat(r);
                if (i) return i === d ? this.formatNextNationalNumberDigits(e) : this.formatNextNationalNumberDigits(r.getNationalDigits());
            }
        },
        {
            key: "narrowDownMatchingFormats",
            value: function(e) {
                var r = this, d = e.nationalSignificantNumber, i = e.nationalPrefix, a = e.international, o = d, u = o.length - $bb50b4d24b214940$var$Oe;
                u < 0 && (u = 0), this.matchingFormats = this.matchingFormats.filter(function(l) {
                    return r.formatSuits(l, a, i) && r.formatMatches(l, o, u);
                }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
            }
        },
        {
            key: "formatSuits",
            value: function(e, r, d) {
                return !(d && !e.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
                !e.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !d && e.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
            }
        },
        {
            key: "formatMatches",
            value: function(e, r, d) {
                var i = e.leadingDigitsPatterns().length;
                if (i === 0) return !0;
                d = Math.min(d, i - 1);
                var a = e.leadingDigitsPatterns()[d];
                if (r.length < $bb50b4d24b214940$var$Oe) try {
                    return new $bb50b4d24b214940$var$yi(a).match(r, {
                        allowOverflow: !0
                    }) !== void 0;
                } catch (o) {
                    return console.error(o), !0;
                }
                return new RegExp("^(".concat(a, ")")).test(r);
            }
        },
        {
            key: "getFormatFormat",
            value: function(e, r) {
                return r ? e.internationalFormat() : e.format();
            }
        },
        {
            key: "chooseFormat",
            value: function(e) {
                for(var r = this, d = function() {
                    var l = a.value;
                    return r.chosenFormat === l ? "break" : $bb50b4d24b214940$var$xi.test(r.getFormatFormat(l, e.international)) ? r.createTemplateForFormat(l, e) ? (r.chosenFormat = l, "break") : (r.matchingFormats = r.matchingFormats.filter(function($) {
                        return $ !== l;
                    }), "continue") : "continue";
                }, i = $bb50b4d24b214940$var$Ae(this.matchingFormats.slice()), a; !(a = i()).done;){
                    var o = d();
                    if (o === "break") break;
                }
                return this.chosenFormat || this.resetFormat(), this.chosenFormat;
            }
        },
        {
            key: "createTemplateForFormat",
            value: function(e, r) {
                if (!(e.pattern().indexOf("|") >= 0)) {
                    var d = this.getTemplateForFormat(e, r);
                    if (d) return this.setNationalNumberTemplate(d, r), !0;
                }
            }
        },
        {
            key: "getSeparatorAfterNationalPrefix",
            value: function(e) {
                return this.isNANP || e && e.nationalPrefixFormattingRule() && $bb50b4d24b214940$var$Pi.test(e.nationalPrefixFormattingRule()) ? " " : "";
            }
        },
        {
            key: "getInternationalPrefixBeforeCountryCallingCode",
            value: function(e, r) {
                var d = e.IDDPrefix, i = e.missingPlus;
                return d ? r && r.spacing === !1 ? d : d + " " : i ? "" : "+";
            }
        },
        {
            key: "getTemplate",
            value: function(e) {
                if (this.template) {
                    for(var r = -1, d = 0, i = e.international ? this.getInternationalPrefixBeforeCountryCallingCode(e, {
                        spacing: !1
                    }) : ""; d < i.length + e.getDigitsWithoutInternationalPrefix().length;)r = this.template.indexOf($bb50b4d24b214940$var$I, r + 1), d++;
                    return $bb50b4d24b214940$var$pe(this.template, r + 1);
                }
            }
        },
        {
            key: "setNationalNumberTemplate",
            value: function(e, r) {
                this.nationalNumberTemplate = e, this.populatedNationalNumberTemplate = e, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, $bb50b4d24b214940$var$I) + $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, r.callingCode.length) + " " + e : this.template = e;
            }
        },
        {
            key: "getTemplateForFormat",
            value: function(e, r) {
                var d = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, o = r.complexPrefixBeforeNationalSignificantNumber, u = e.pattern();
                u = u.replace($bb50b4d24b214940$var$Ai(), "\\d").replace($bb50b4d24b214940$var$Ii(), "\\d");
                var l = $bb50b4d24b214940$var$bi.match(u)[0];
                if (!(d.length > l.length)) {
                    var $ = new RegExp("^" + u + "$"), c = d.replace(/\d/g, $bb50b4d24b214940$var$Et);
                    $.test(c) && (l = c);
                    var f = this.getFormatFormat(e, i), h;
                    if (this.shouldTryNationalPrefixFormattingRule(e, {
                        international: i,
                        nationalPrefix: a
                    })) {
                        var g = f.replace($bb50b4d24b214940$var$nn, e.nationalPrefixFormattingRule());
                        if ($bb50b4d24b214940$var$et(e.nationalPrefixFormattingRule()) === (a || "") + $bb50b4d24b214940$var$et("$1") && (f = g, h = !0, a)) for(var b = a.length; b > 0;)f = f.replace(/\d/, $bb50b4d24b214940$var$I), b--;
                    }
                    var p = l.replace(new RegExp(u), f).replace(new RegExp($bb50b4d24b214940$var$Et, "g"), $bb50b4d24b214940$var$I);
                    return h || (o ? p = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, o.length) + " " + p : a && (p = $bb50b4d24b214940$var$Q($bb50b4d24b214940$var$I, a.length) + this.getSeparatorAfterNationalPrefix(e) + p)), i && (p = $bb50b4d24b214940$var$en(p)), p;
                }
            }
        },
        {
            key: "formatNextNationalNumberDigits",
            value: function(e) {
                var r = $bb50b4d24b214940$var$ri(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, e);
                if (!r) {
                    this.resetFormat();
                    return;
                }
                return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], $bb50b4d24b214940$var$pe(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
            }
        },
        {
            key: "shouldTryNationalPrefixFormattingRule",
            value: function(e, r) {
                var d = r.international, i = r.nationalPrefix;
                if (e.nationalPrefixFormattingRule()) {
                    var a = e.usesNationalPrefix();
                    if (a && i || !a && !d) return !0;
                }
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$fn(t, n) {
    return $bb50b4d24b214940$var$Fi(t) || $bb50b4d24b214940$var$Ti(t, n) || $bb50b4d24b214940$var$Si(t, n) || $bb50b4d24b214940$var$Ei();
}
function $bb50b4d24b214940$var$Ei() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Si(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Ee(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Ee(t, n);
    }
}
function $bb50b4d24b214940$var$Ee(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Ti(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Fi(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$wi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Se(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Di(t, n, e) {
    return n && $bb50b4d24b214940$var$Se(t.prototype, n), e && $bb50b4d24b214940$var$Se(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$Mi = "[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+", $bb50b4d24b214940$var$Ri = new RegExp("^" + $bb50b4d24b214940$var$Mi + "$", "i"), $bb50b4d24b214940$var$_i = "(?:[" + $bb50b4d24b214940$var$rt + "][" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]*|[" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+)", $bb50b4d24b214940$var$Li = new RegExp("[^" + $bb50b4d24b214940$var$x + $bb50b4d24b214940$var$N + "]+.*$"), $bb50b4d24b214940$var$ki = /[^\d\[\]]/, $bb50b4d24b214940$var$Gi = /* @__PURE__ */ function() {
    function t(n) {
        var e = n.defaultCountry, r = n.defaultCallingCode, d = n.metadata, i = n.onNationalSignificantNumberChange;
        $bb50b4d24b214940$var$wi(this, t), this.defaultCountry = e, this.defaultCallingCode = r, this.metadata = d, this.onNationalSignificantNumberChange = i;
    }
    return $bb50b4d24b214940$var$Di(t, [
        {
            key: "input",
            value: function(e, r) {
                var d = $bb50b4d24b214940$var$Ui(e), i = $bb50b4d24b214940$var$fn(d, 2), a = i[0], o = i[1], u = $bb50b4d24b214940$var$et(a), l;
                return o && (r.digits || (r.startInternationalNumber(), u || (l = !0))), u && this.inputDigits(u, r), {
                    digits: u,
                    justLeadingPlus: l
                };
            }
        },
        {
            key: "inputDigits",
            value: function(e, r) {
                var d = r.digits, i = d.length < 3 && d.length + e.length >= 3;
                if (r.appendDigits(e), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
                    if (!this.extractCountryCallingCode(r)) return;
                } else r.appendNationalSignificantNumberDigits(e);
                r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
                    return r.update(a);
                });
            }
        },
        {
            key: "isWaitingForCountryCallingCode",
            value: function(e) {
                var r = e.international, d = e.callingCode;
                return r && !d;
            }
        },
        {
            key: "extractCountryCallingCode",
            value: function(e) {
                var r = $bb50b4d24b214940$var$un("+" + e.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), d = r.countryCallingCode, i = r.number;
                if (d) return e.setCallingCode(d), e.update({
                    nationalSignificantNumber: i
                }), !0;
            }
        },
        {
            key: "reset",
            value: function(e) {
                if (e) {
                    this.hasSelectedNumberingPlan = !0;
                    var r = e._nationalPrefixForParsing();
                    this.couldPossiblyExtractAnotherNationalSignificantNumber = r && $bb50b4d24b214940$var$ki.test(r);
                } else this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
            }
        },
        {
            key: "extractNationalSignificantNumber",
            value: function(e, r) {
                if (this.hasSelectedNumberingPlan) {
                    var d = $bb50b4d24b214940$var$bt(e, this.metadata), i = d.nationalPrefix, a = d.nationalNumber, o = d.carrierCode;
                    if (a !== e) return this.onExtractedNationalNumber(i, o, a, e, r), !0;
                }
            }
        },
        {
            key: "extractAnotherNationalSignificantNumber",
            value: function(e, r, d) {
                if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(e, d);
                if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
                    var i = $bb50b4d24b214940$var$bt(e, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, u = i.carrierCode;
                    if (o !== r) return this.onExtractedNationalNumber(a, u, o, e, d), !0;
                }
            }
        },
        {
            key: "onExtractedNationalNumber",
            value: function(e, r, d, i, a) {
                var o, u, l = i.lastIndexOf(d);
                if (l >= 0 && l === i.length - d.length) {
                    u = !0;
                    var $ = i.slice(0, l);
                    $ !== e && (o = $);
                }
                a({
                    nationalPrefix: e,
                    carrierCode: r,
                    nationalSignificantNumber: d,
                    nationalSignificantNumberMatchesInput: u,
                    complexPrefixBeforeNationalSignificantNumber: o
                }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
            }
        },
        {
            key: "reExtractNationalSignificantNumber",
            value: function(e) {
                if (this.extractAnotherNationalSignificantNumber(e.getNationalDigits(), e.nationalSignificantNumber, function(r) {
                    return e.update(r);
                })) return !0;
                if (this.extractIddPrefix(e)) return this.extractCallingCodeAndNationalSignificantNumber(e), !0;
                if (this.fixMissingPlus(e)) return this.extractCallingCodeAndNationalSignificantNumber(e), !0;
            }
        },
        {
            key: "extractIddPrefix",
            value: function(e) {
                var r = e.international, d = e.IDDPrefix, i = e.digits;
                if (e.nationalSignificantNumber, !(r || d)) {
                    var a = $bb50b4d24b214940$var$an(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
                    if (a !== void 0 && a !== i) return e.update({
                        IDDPrefix: i.slice(0, i.length - a.length)
                    }), this.startInternationalNumber(e, {
                        country: void 0,
                        callingCode: void 0
                    }), !0;
                }
            }
        },
        {
            key: "fixMissingPlus",
            value: function(e) {
                if (!e.international) {
                    var r = $bb50b4d24b214940$var$on(e.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), d = r.countryCallingCode;
                    if (r.number, d) return e.update({
                        missingPlus: !0
                    }), this.startInternationalNumber(e, {
                        country: e.country,
                        callingCode: d
                    }), !0;
                }
            }
        },
        {
            key: "startInternationalNumber",
            value: function(e, r) {
                var d = r.country, i = r.callingCode;
                e.startInternationalNumber(d, i), e.nationalSignificantNumber && (e.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
            }
        },
        {
            key: "extractCallingCodeAndNationalSignificantNumber",
            value: function(e) {
                this.extractCountryCallingCode(e) && this.extractNationalSignificantNumber(e.getNationalDigits(), function(r) {
                    return e.update(r);
                });
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Bi(t) {
    var n = t.search($bb50b4d24b214940$var$_i);
    if (!(n < 0)) {
        t = t.slice(n);
        var e;
        return t[0] === "+" && (e = !0, t = t.slice(1)), t = t.replace($bb50b4d24b214940$var$Li, ""), e && (t = "+" + t), t;
    }
}
function $bb50b4d24b214940$var$ji(t) {
    var n = $bb50b4d24b214940$var$Bi(t) || "";
    return n[0] === "+" ? [
        n.slice(1),
        !0
    ] : [
        n
    ];
}
function $bb50b4d24b214940$var$Ui(t) {
    var n = $bb50b4d24b214940$var$ji(t), e = $bb50b4d24b214940$var$fn(n, 2), r = e[0], d = e[1];
    return $bb50b4d24b214940$var$Ri.test(r) || (r = ""), [
        r,
        d
    ];
}
function $bb50b4d24b214940$var$Wi(t, n) {
    return $bb50b4d24b214940$var$Yi(t) || $bb50b4d24b214940$var$Zi(t, n) || $bb50b4d24b214940$var$Vi(t, n) || $bb50b4d24b214940$var$Hi();
}
function $bb50b4d24b214940$var$Hi() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$Vi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$Te(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$Te(t, n);
    }
}
function $bb50b4d24b214940$var$Te(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$Zi(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$Yi(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$zi(t, n) {
    if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $bb50b4d24b214940$var$Fe(t, n) {
    for(var e = 0; e < n.length; e++){
        var r = n[e];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
}
function $bb50b4d24b214940$var$Xi(t, n, e) {
    return n && $bb50b4d24b214940$var$Fe(t.prototype, n), e && $bb50b4d24b214940$var$Fe(t, e), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
var $bb50b4d24b214940$var$cn = /* @__PURE__ */ function() {
    function t(n, e) {
        $bb50b4d24b214940$var$zi(this, t), this.metadata = new $bb50b4d24b214940$var$v(e);
        var r = this.getCountryAndCallingCode(n), d = $bb50b4d24b214940$var$Wi(r, 2), i = d[0], a = d[1];
        this.defaultCountry = i, this.defaultCallingCode = a, this.reset();
    }
    return $bb50b4d24b214940$var$Xi(t, [
        {
            key: "getCountryAndCallingCode",
            value: function(e) {
                var r, d;
                return e && ($bb50b4d24b214940$var$R(e) ? (r = e.defaultCountry, d = e.defaultCallingCode) : r = e), r && !this.metadata.hasCountry(r) && (r = void 0), [
                    r,
                    d
                ];
            }
        },
        {
            key: "input",
            value: function(e) {
                var r = this.parser.input(e, this.state), d = r.digits, i = r.justLeadingPlus;
                if (i) this.formattedOutput = "+";
                else if (d) {
                    this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
                    var a;
                    if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(d, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
                        this.determineTheCountryIfNeeded();
                        var o = this.state.getNationalDigits();
                        o && (a = this.formatter.format(o, this.state));
                    }
                    this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
                }
                return this.formattedOutput;
            }
        },
        {
            key: "reset",
            value: function() {
                var e = this;
                return this.state = new $bb50b4d24b214940$var$qd({
                    onCountryChange: function(d) {
                        e.country = d;
                    },
                    onCallingCodeChange: function(d, i) {
                        e.metadata.selectNumberingPlan(i, d), e.formatter.reset(e.metadata.numberingPlan, e.state), e.parser.reset(e.metadata.numberingPlan);
                    }
                }), this.formatter = new $bb50b4d24b214940$var$Oi({
                    state: this.state,
                    metadata: this.metadata
                }), this.parser = new $bb50b4d24b214940$var$Gi({
                    defaultCountry: this.defaultCountry,
                    defaultCallingCode: this.defaultCallingCode,
                    metadata: this.metadata,
                    state: this.state,
                    onNationalSignificantNumberChange: function() {
                        e.determineTheCountryIfNeeded(), e.formatter.reset(e.metadata.numberingPlan, e.state);
                    }
                }), this.state.reset({
                    country: this.defaultCountry,
                    callingCode: this.defaultCallingCode
                }), this.formattedOutput = "", this;
            }
        },
        {
            key: "isInternational",
            value: function() {
                return this.state.international;
            }
        },
        {
            key: "getCallingCode",
            value: function() {
                if (this.isInternational()) return this.state.callingCode;
            }
        },
        {
            key: "getCountryCallingCode",
            value: function() {
                return this.getCallingCode();
            }
        },
        {
            key: "getCountry",
            value: function() {
                var e = this.state.digits;
                if (e) return this._getCountry();
            }
        },
        {
            key: "_getCountry",
            value: function() {
                var e = this.state.country;
                return e;
            }
        },
        {
            key: "determineTheCountryIfNeeded",
            value: function() {
                (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
            }
        },
        {
            key: "getFullNumber",
            value: function(e) {
                var r = this;
                if (this.isInternational()) {
                    var d = function(o) {
                        return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
                            spacing: !!o
                        }) + o;
                    }, i = this.state.callingCode;
                    return d(i ? e ? "".concat(i, " ").concat(e) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
                }
                return e;
            }
        },
        {
            key: "getNonFormattedNationalNumberWithPrefix",
            value: function() {
                var e = this.state, r = e.nationalSignificantNumber, d = e.complexPrefixBeforeNationalSignificantNumber, i = e.nationalPrefix, a = r, o = d || i;
                return o && (a = o + a), a;
            }
        },
        {
            key: "getNonFormattedNumber",
            value: function() {
                var e = this.state.nationalSignificantNumberMatchesInput;
                return this.getFullNumber(e ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
            }
        },
        {
            key: "getNonFormattedTemplate",
            value: function() {
                var e = this.getNonFormattedNumber();
                if (e) return e.replace(/[\+\d]/g, $bb50b4d24b214940$var$I);
            }
        },
        {
            key: "isCountryCallingCodeAmbiguous",
            value: function() {
                var e = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(e);
                return r && r.length > 1;
            }
        },
        {
            key: "determineTheCountry",
            value: function() {
                this.state.setCountry($bb50b4d24b214940$var$$n(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
                    nationalNumber: this.state.nationalSignificantNumber,
                    defaultCountry: this.defaultCountry,
                    metadata: this.metadata
                }));
            }
        },
        {
            key: "getNumberValue",
            value: function() {
                var e = this.state, r = e.digits, d = e.callingCode, i = e.country, a = e.nationalSignificantNumber;
                if (r) {
                    if (this.isInternational()) return d ? "+" + d + a : "+" + r;
                    if (i || d) {
                        var o = i ? this.metadata.countryCallingCode() : d;
                        return "+" + o + a;
                    }
                }
            }
        },
        {
            key: "getNumber",
            value: function() {
                var e = this.state, r = e.nationalSignificantNumber, d = e.carrierCode, i = e.callingCode, a = this._getCountry();
                if (r && !(!a && !i)) {
                    if (a && a === this.defaultCountry) {
                        var o = new $bb50b4d24b214940$var$v(this.metadata.metadata);
                        o.selectNumberingPlan(a);
                        var u = o.numberingPlan.callingCode(), l = this.metadata.getCountryCodesForCallingCode(u);
                        if (l.length > 1) {
                            var $ = $bb50b4d24b214940$var$ln(r, {
                                countries: l,
                                defaultCountry: this.defaultCountry,
                                metadata: this.metadata.metadata
                            });
                            $ && (a = $);
                        }
                    }
                    var c = new $bb50b4d24b214940$var$dn(a || i, r, this.metadata.metadata);
                    return d && (c.carrierCode = d), c;
                }
            }
        },
        {
            key: "isPossible",
            value: function() {
                var e = this.getNumber();
                return e ? e.isPossible() : !1;
            }
        },
        {
            key: "isValid",
            value: function() {
                var e = this.getNumber();
                return e ? e.isValid() : !1;
            }
        },
        {
            key: "getNationalNumber",
            value: function() {
                return this.state.nationalSignificantNumber;
            }
        },
        {
            key: "getChars",
            value: function() {
                return (this.state.international ? "+" : "") + this.state.digits;
            }
        },
        {
            key: "getTemplate",
            value: function() {
                return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
            }
        }
    ]), t;
}();
function $bb50b4d24b214940$var$Ki() {
    return $bb50b4d24b214940$var$Ye($bb50b4d24b214940$var$Kd, arguments);
}
function $bb50b4d24b214940$export$80d8c6912928a4eb(t) {
    return $bb50b4d24b214940$var$cn.call(this, t, $bb50b4d24b214940$var$Tt);
}
$bb50b4d24b214940$export$80d8c6912928a4eb.prototype = Object.create($bb50b4d24b214940$var$cn.prototype, {});
$bb50b4d24b214940$export$80d8c6912928a4eb.prototype.constructor = $bb50b4d24b214940$export$80d8c6912928a4eb;
function $bb50b4d24b214940$var$Qi(t, n) {
    return $bb50b4d24b214940$var$e1(t) || $bb50b4d24b214940$var$t1(t, n) || $bb50b4d24b214940$var$qi(t, n) || $bb50b4d24b214940$var$Ji();
}
function $bb50b4d24b214940$var$Ji() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $bb50b4d24b214940$var$qi(t, n) {
    if (t) {
        if (typeof t == "string") return $bb50b4d24b214940$var$we(t, n);
        var e = Object.prototype.toString.call(t).slice(8, -1);
        if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set") return Array.from(t);
        if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return $bb50b4d24b214940$var$we(t, n);
    }
}
function $bb50b4d24b214940$var$we(t, n) {
    (n == null || n > t.length) && (n = t.length);
    for(var e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $bb50b4d24b214940$var$t1(t, n) {
    var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
    if (e != null) {
        var r = [], d = !0, i = !1, a, o;
        try {
            for(e = e.call(t); !(d = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); d = !0);
        } catch (u) {
            i = !0, o = u;
        } finally{
            try {
                !d && e.return != null && e.return();
            } finally{
                if (i) throw o;
            }
        }
        return r;
    }
}
function $bb50b4d24b214940$var$e1(t) {
    if (Array.isArray(t)) return t;
}
function $bb50b4d24b214940$var$n1() {
    var t = $bb50b4d24b214940$var$r1(arguments), n = t.input, e = t.options, r = t.metadata;
    if (n.phone) return $bb50b4d24b214940$var$ot(n, e, r);
}
function $bb50b4d24b214940$var$r1(t) {
    var n = Array.prototype.slice.call(t), e = $bb50b4d24b214940$var$Qi(n, 4), r = e[0], d = e[1], i = e[2], a = e[3], o, u = {}, l;
    if (typeof r == "string") $bb50b4d24b214940$var$R(d) ? (i ? (u = d, l = i) : l = d, $bb50b4d24b214940$var$Nt(r) ? o = $bb50b4d24b214940$var$xt(r, void 0, l) : o = {}) : (a ? (u = i, l = a) : l = i, $bb50b4d24b214940$var$Nt(r) ? o = $bb50b4d24b214940$var$xt(r, {
        defaultCountry: d
    }, l) : o = {});
    else if ($bb50b4d24b214940$var$R(r)) o = r, i ? (u = d, l = i) : l = d;
    else throw new TypeError("A phone number must either be a string or an object of shape { phone, [country] }.");
    return {
        input: o,
        options: u,
        metadata: l
    };
}
function $bb50b4d24b214940$export$f1c97bcb220031e2() {
    return $bb50b4d24b214940$var$Ye($bb50b4d24b214940$var$n1, arguments);
}
function $bb50b4d24b214940$var$mt(t) {
    var _B_n, _B_n1;
    const { defaultCountry: n, initialValue: e, disableFormatting: r, forceCallingCode: d } = t, i = n ? `+${(_B_n = $bb50b4d24b214940$var$B[n]) === null || _B_n === void 0 ? void 0 : _B_n[0]}` : "", a = new $bb50b4d24b214940$export$80d8c6912928a4eb(n);
    let o = a.input(e);
    d && o === "+" && n && (o = `+${(_B_n1 = $bb50b4d24b214940$var$B[n]) === null || _B_n1 === void 0 ? void 0 : _B_n1[0]}`);
    const u = a.getNumberValue();
    return r && u && (o = u), {
        inputValue: o || i,
        isoCode: a.getCountry() || n || null
    };
}
function $bb50b4d24b214940$var$d1(t, n) {
    const { excludedCountries: e, onlyCountries: r, continents: d } = n;
    return !($bb50b4d24b214940$var$S(e, !0) && e.includes(t) || $bb50b4d24b214940$var$S(r) && !r.includes(t) || $bb50b4d24b214940$var$S(d) && !$bb50b4d24b214940$var$Ge(d, t));
}
function $bb50b4d24b214940$var$i1({ value: t, onChange: n, defaultCountry: e, onlyCountries: r, excludedCountries: d, continents: i, disableFormatting: a, forceCallingCode: o }) {
    const u = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(e || null), l = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(new $bb50b4d24b214940$export$80d8c6912928a4eb(e)), $ = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(null), [c, f] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(e), [h, g] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(()=>$bb50b4d24b214940$var$mt({
            initialValue: t,
            defaultCountry: e,
            disableFormatting: a,
            forceCallingCode: o
        })), [b, p] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(t), D = (s)=>{
        var _l_current_getNumber;
        var _l_current_getNumber_getType;
        return {
            countryCallingCode: l.current.getCallingCode() || null,
            countryCode: l.current.getCountry() || null,
            nationalNumber: l.current.getNationalNumber(),
            numberType: (_l_current_getNumber_getType = (_l_current_getNumber = l.current.getNumber()) === null || _l_current_getNumber === void 0 ? void 0 : _l_current_getNumber.getType()) !== null && _l_current_getNumber_getType !== void 0 ? _l_current_getNumber_getType : null,
            numberValue: l.current.getNumberValue() || null,
            reason: s
        };
    }, j = (s)=>s && $bb50b4d24b214940$var$d1(s, {
            onlyCountries: r,
            excludedCountries: d,
            continents: i
        }), U = (s)=>(l.current.reset(), l.current.input(s)), ut = (s)=>s.startsWith("+") || s === "" ? s : `+${s}`, lt = (s, O)=>`+${$bb50b4d24b214940$var$tt(O)}${s}`, $t = (s)=>{
        const O = o ? lt(s.target.value, h.isoCode) : ut(s.target.value), F = U(O), M = l.current.getCountry(), A = o ? // always the same country, can't change
        h.isoCode : M || u.current, P = l.current.getNumberValue() || "";
        u.current = A;
        const W = D("input");
        if (P && (!A || !j(A))) n === null || n === void 0 ? void 0 : n(P, {
            ...W,
            // we show the input value but without any formatting, or country..
            countryCode: null,
            countryCallingCode: null,
            nationalNumber: null
        }), p(P), g({
            isoCode: null,
            inputValue: P
        });
        else {
            const w = a ? P : F;
            n === null || n === void 0 ? void 0 : n(w, W), p(w), g({
                isoCode: A,
                inputValue: w
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (t !== b) {
            p(t);
            const s = $bb50b4d24b214940$var$mt({
                initialValue: t,
                defaultCountry: e,
                forceCallingCode: o,
                disableFormatting: a
            });
            u.current = s.isoCode, g(s);
        }
    }, [
        t,
        b,
        e,
        o,
        a
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useEffect(()=>{
        if (e !== c) {
            f(e), l.current = new $bb50b4d24b214940$export$80d8c6912928a4eb(e);
            const { inputValue: s, isoCode: O } = $bb50b4d24b214940$var$mt({
                initialValue: "",
                defaultCountry: e,
                forceCallingCode: o,
                disableFormatting: a
            });
            p(s), l.current.input(s), u.current = l.current.getCountry() || null, n === null || n === void 0 ? void 0 : n(s, D("country")), g({
                inputValue: s,
                isoCode: O
            });
        }
    }, [
        e,
        c,
        n,
        o,
        a
    ]);
    const z = (s)=>{
        var _B_s;
        if (s === h.isoCode) return;
        const O = (_B_s = $bb50b4d24b214940$var$B[s]) === null || _B_s === void 0 ? void 0 : _B_s[0], { inputValue: F, isoCode: M } = h;
        let A = F;
        if (M) {
            const w = `+${$bb50b4d24b214940$var$tt(M)}`;
            A = F.startsWith(w) ? $bb50b4d24b214940$var$Ze(F, w) : "";
        }
        let P = `+${O}${A}`;
        a || (P = U(P)), n === null || n === void 0 ? void 0 : n(P, {
            ...D("country"),
            // Some country have the same calling code, so we choose what the user has selected
            countryCode: s
        }), u.current = s, p(P), g({
            isoCode: s,
            inputValue: P
        });
    };
    return {
        inputValue: h.inputValue,
        isoCode: h.isoCode,
        onInputChange: $t,
        onCountryChange: z,
        inputRef: $
    };
}
function $bb50b4d24b214940$export$ba16fc01b090027c(t, n) {
    const e = new $bb50b4d24b214940$export$80d8c6912928a4eb();
    e.input(t);
    const r = e.getCountry();
    if (!r || (n === null || n === void 0 ? void 0 : n.continents) && n.continents.length > 0 && !$bb50b4d24b214940$var$Ge(n.continents, r)) return !1;
    if ((n === null || n === void 0 ? void 0 : n.onlyCountries) && n.onlyCountries.length > 0) {
        const [d] = $bb50b4d24b214940$var$Le([
            r
        ], n.onlyCountries);
        if (!d) return !1;
    }
    if ((n === null || n === void 0 ? void 0 : n.excludedCountries) && n.excludedCountries.length > 0) {
        const [d] = $bb50b4d24b214940$var$ke([
            r
        ], n.excludedCountries);
        if (!d) return !1;
    }
    return $bb50b4d24b214940$var$Ki(t);
}
const $bb50b4d24b214940$export$7b08a25ee27059c2 = "MuiTelInput-TextField", $bb50b4d24b214940$export$5d5d29ff8b7e8a02 = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).forwardRef((t, n)=>{
    const { forceCallingCode: e = !1, onlyCountries: r, excludedCountries: d, defaultCountry: i, onDoubleClick: a, onFocus: o, onCopy: u, value: l = "", inputProps: $, InputProps: c, inputRef: f, disabled: h, onChange: g, disableDropdown: b, disableFormatting: p = !1, focusOnSelectCountry: D, langOfCountryName: j, continents: U, preferredCountries: ut, MenuProps: lt, className: $t, getFlagElement: z = $bb50b4d24b214940$var$Vn, unknownFlagElement: s = $bb50b4d24b214940$var$Zn, ...O } = t, F = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef(null), [M, A] = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useState(null), P = e ? $bb50b4d24b214940$var$Gn(i) : i;
    $bb50b4d24b214940$var$rr(t);
    const { onInputChange: W, onCountryChange: w, inputRef: L, isoCode: X, inputValue: Rt } = $bb50b4d24b214940$var$i1({
        forceCallingCode: e,
        defaultCountry: P,
        value: l !== null && l !== void 0 ? l : "",
        onChange: g,
        excludedCountries: d,
        onlyCountries: r,
        disableFormatting: p,
        continents: U
    }), gn = (y)=>{
        y.preventDefault(), (!h || !b) && A(F.current);
    }, mn = (y)=>{
        A(null), w(y), D && L.current && L.current.focus();
    }, yn = (y)=>{
        L.current && $bb50b4d24b214940$var$nr(L.current), o === null || o === void 0 ? void 0 : o(y);
    }, pn = (y)=>{
        const H = L.current;
        H.setSelectionRange(0, H.value.length), a === null || a === void 0 ? void 0 : a(y);
    }, vn = (y)=>{
        if (u) {
            u(y);
            return;
        }
        const H = window.getSelection();
        if (H) {
            const In = H.toString().replaceAll(" ", "");
            y.clipboardData.setData("text/plain", In), y.preventDefault();
        }
    }, Cn = (y)=>{
        L.current = y, (c === null || c === void 0 ? void 0 : c.inputRef) && $bb50b4d24b214940$var$st(y, c.inputRef), f && $bb50b4d24b214940$var$st(y, f);
    }, Nn = (y)=>{
        F.current = y, n && $bb50b4d24b214940$var$st(y, n);
    }, bn = ()=>{
        A(null);
    }, Pn = X ? `+${$bb50b4d24b214940$var$tt(X)}` : "", An = e ? // We removed the isoCode but no necessarily the space after
    $bb50b4d24b214940$var$Ze(Rt, Pn).trimStart() : Rt;
    return /* @__PURE__ */ (0, $3pI8R.jsxs)((0, $3pI8R.Fragment), {
        children: [
            /* @__PURE__ */ (0, $3pI8R.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                type: "tel",
                disabled: h,
                value: An,
                ref: Nn,
                onDoubleClick: pn,
                inputRef: Cn,
                className: `${$bb50b4d24b214940$export$7b08a25ee27059c2} ${$t || ""}`,
                onChange: W,
                inputProps: {
                    onCopy: vn,
                    ...$
                },
                onFocus: yn,
                InputProps: {
                    startAdornment: /* @__PURE__ */ (0, $3pI8R.jsx)((0, $2716b83202966b50$export$2e2bcd8739ae039), {
                        position: "start",
                        sx: {
                            flexShrink: 0
                        },
                        children: /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$zn, {
                            isFlagsMenuOpened: !!M,
                            isoCode: X,
                            forceCallingCode: e,
                            onClick: gn,
                            disabled: h,
                            getFlagElement: z,
                            unknownFlagElement: s,
                            disableDropdown: !!b
                        })
                    }),
                    ...c
                },
                ...O
            }),
            b ? null : /* @__PURE__ */ (0, $3pI8R.jsx)($bb50b4d24b214940$var$er, {
                onlyCountries: r,
                excludedCountries: d,
                continents: U,
                anchorEl: M,
                isoCode: X,
                preferredCountries: ut,
                onClose: bn,
                langOfCountryName: j,
                onSelectCountry: mn,
                getFlagElement: z,
                ...lt
            })
        ]
    });
}), $bb50b4d24b214940$export$188d75d71883854a = {
    textField: $bb50b4d24b214940$export$7b08a25ee27059c2,
    flagContainer: $bb50b4d24b214940$var$Re,
    flagImg: $bb50b4d24b214940$var$Ft,
    flagButton: $bb50b4d24b214940$var$yt,
    menu: $bb50b4d24b214940$var$Ve,
    menuItem: $bb50b4d24b214940$var$je,
    listItemIconFlag: $bb50b4d24b214940$var$Ue,
    listItemTextCountry: $bb50b4d24b214940$var$We,
    callingCode: $bb50b4d24b214940$var$He
};





var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $7f4a49b3533c9276$var$SvgError = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        width: "1.1rem",
        height: "4.6rem",
        viewBox: "0 0 11 46",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M1.92 30.856 1.022.2h8.768l-.96 30.656H1.92Zm3.647 14.592c-1.536 0-2.794-.47-3.776-1.408-.938-.939-1.408-2.07-1.408-3.392 0-1.365.47-2.517 1.408-3.456.982-.939 2.24-1.408 3.776-1.408 1.45 0 2.646.47 3.584 1.408.982.939 1.472 2.09 1.472 3.456 0 1.323-.49 2.453-1.472 3.392-.938.939-2.133 1.408-3.584 1.408Z",
            fill: "#FF4E4E"
        })
    });
var $7f4a49b3533c9276$export$2e2bcd8739ae039 = $7f4a49b3533c9276$var$SvgError;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $535a39e60c31f2a1$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 15 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M5.233 9.82a.637.637 0 0 1-.24-.043.662.662 0 0 1-.216-.152l-3.93-3.93a.65.65 0 0 1-.196-.478.65.65 0 0 1 .196-.477.625.625 0 0 1 .456-.196c.173 0 .325.066.456.196l3.474 3.474L13.114.332a.637.637 0 0 1 .467-.195c.181 0 .337.065.467.195s.195.286.195.467c0 .18-.065.336-.195.467l-8.36 8.36a.662.662 0 0 1-.216.151.638.638 0 0 1-.24.044Z",
            fill: "#20BE75"
        })
    });
var $535a39e60c31f2a1$export$2e2bcd8739ae039 = $535a39e60c31f2a1$var$SvgSuccess;


const $5c7af9bb295ce42c$var$StatusIcon = ({ status: status })=>{
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: `main-modal__icon-box text-${status}`,
        children: [
            status === "loading" && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                className: "spinner-border m-auto",
                role: "status"
            }),
            status === "success" && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                className: "m-auto success",
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $535a39e60c31f2a1$export$2e2bcd8739ae039), {
                    width: "4.7rem",
                    height: "3.4rem"
                })
            }),
            status === "error" && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                className: "m-auto error",
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $7f4a49b3533c9276$export$2e2bcd8739ae039), {
                    width: "1.1rem",
                    height: "4.6rem"
                })
            })
        ]
    });
};
var $5c7af9bb295ce42c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($5c7af9bb295ce42c$var$StatusIcon);




const $35a1a9204bb33fb3$var$Modal = (props)=>{
    const { title: title, message: message, status: status, onDismiss: onDismiss } = props;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "main-modal",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$755918b48c75c65a)),
                className: "main-modal__background"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$1c33d2a8eb772259)),
                className: "main-modal__content",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        className: "text-center mt-5",
                        children: [
                            title && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h1",
                                className: `text-${status}`,
                                children: title
                            }),
                            message && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h2",
                                className: "mt-5",
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5c7af9bb295ce42c$export$2e2bcd8739ae039), {
                        status: status
                    }),
                    status !== "loading" && !!onDismiss && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "main-modal__close",
                        onClick: onDismiss,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $56ba4849816b834d$export$2e2bcd8739ae039), {
                            width: "5.5rem"
                        })
                    })
                ]
            })
        ]
    });
};
var $35a1a9204bb33fb3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($35a1a9204bb33fb3$var$Modal);










var $eZVvM = parcelRequire("eZVvM");


var $cD0nt = parcelRequire("cD0nt");
const $5dbe44b630dd4a2f$var$moveLeft = (delay)=>({
        initial: {
            x: 200,
            opacity: 0
        },
        animate: {
            x: 0,
            opacity: 1,
            transition: {
                duration: 0.35,
                delay: delay,
                ease: "easeOut"
            }
        }
    });
const $5dbe44b630dd4a2f$var$MoveLeft = (props)=>{
    const { children: children, disabled: disabled, delay: delay } = props;
    const animationsEnabled = (0, $cD0nt.useAnimationsEnabled)();
    if (disabled || !animationsEnabled) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).cloneElement(children, {
        ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($5dbe44b630dd4a2f$var$moveLeft(delay))
    });
};
var $5dbe44b630dd4a2f$export$2e2bcd8739ae039 = $5dbe44b630dd4a2f$var$MoveLeft;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");








var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
var $8e8171dbde9eba52$exports = {};

(function webpackUniversalModuleDefinition(root, factory) {
    $8e8171dbde9eba52$exports = factory((parcelRequire("eZVvM")));
})($8e8171dbde9eba52$exports, function(__WEBPACK_EXTERNAL_MODULE_react__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/react-webcam.tsx");
    /******/ }({
        /***/ "./src/react-webcam.tsx": /*!******************************!*\
  !*** ./src/react-webcam.tsx ***!
  \******************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __rest = function(s, e) {
                var t = {};
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function") {
                    for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
                }
                return t;
            };
            // polyfill based on https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
            (function polyfillGetUserMedia() {
                if (typeof window === "undefined") return;
                // Older browsers might not implement mediaDevices at all, so we set an empty object first
                if (navigator.mediaDevices === undefined) navigator.mediaDevices = {};
                // Some browsers partially implement mediaDevices. We can't just assign an object
                // with getUserMedia as it would overwrite existing properties.
                // Here, we will just add the getUserMedia property if it's missing.
                if (navigator.mediaDevices.getUserMedia === undefined) navigator.mediaDevices.getUserMedia = function(constraints) {
                    // First get ahold of the legacy getUserMedia, if present
                    var getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                    // Some browsers just don't implement it - return a rejected promise with an error
                    // to keep a consistent interface
                    if (!getUserMedia) return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
                    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                    return new Promise(function(resolve, reject) {
                        getUserMedia.call(navigator, constraints, resolve, reject);
                    });
                };
            })();
            function hasGetUserMedia() {
                return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
            }
            var Webcam = /** @class */ function(_super) {
                __extends(Webcam, _super);
                function Webcam(props) {
                    var _this = _super.call(this, props) || this;
                    _this.canvas = null;
                    _this.ctx = null;
                    _this.requestUserMediaId = 0;
                    _this.unmounted = false;
                    _this.state = {
                        hasUserMedia: false
                    };
                    return _this;
                }
                Webcam.prototype.componentDidMount = function() {
                    var _a = this, state = _a.state, props = _a.props;
                    this.unmounted = false;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    if (!state.hasUserMedia) this.requestUserMedia();
                    if (props.children && typeof props.children != "function") console.warn("children must be a function");
                };
                Webcam.prototype.componentDidUpdate = function(nextProps) {
                    var props = this.props;
                    if (!hasGetUserMedia()) {
                        props.onUserMediaError("getUserMedia not supported");
                        return;
                    }
                    var audioConstraintsChanged = JSON.stringify(nextProps.audioConstraints) !== JSON.stringify(props.audioConstraints);
                    var videoConstraintsChanged = JSON.stringify(nextProps.videoConstraints) !== JSON.stringify(props.videoConstraints);
                    var minScreenshotWidthChanged = nextProps.minScreenshotWidth !== props.minScreenshotWidth;
                    var minScreenshotHeightChanged = nextProps.minScreenshotHeight !== props.minScreenshotHeight;
                    if (videoConstraintsChanged || minScreenshotWidthChanged || minScreenshotHeightChanged) {
                        this.canvas = null;
                        this.ctx = null;
                    }
                    if (audioConstraintsChanged || videoConstraintsChanged) {
                        this.stopAndCleanup();
                        this.requestUserMedia();
                    }
                };
                Webcam.prototype.componentWillUnmount = function() {
                    this.unmounted = true;
                    this.stopAndCleanup();
                };
                Webcam.stopMediaStream = function(stream) {
                    if (stream) {
                        if (stream.getVideoTracks && stream.getAudioTracks) {
                            stream.getVideoTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                            stream.getAudioTracks().map(function(track) {
                                stream.removeTrack(track);
                                track.stop();
                            });
                        } else stream.stop();
                    }
                };
                Webcam.prototype.stopAndCleanup = function() {
                    var state = this.state;
                    if (state.hasUserMedia) {
                        Webcam.stopMediaStream(this.stream);
                        if (state.src) window.URL.revokeObjectURL(state.src);
                    }
                };
                Webcam.prototype.getScreenshot = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!state.hasUserMedia) return null;
                    var canvas = this.getCanvas(screenshotDimensions);
                    return canvas && canvas.toDataURL(props.screenshotFormat, props.screenshotQuality);
                };
                Webcam.prototype.getCanvas = function(screenshotDimensions) {
                    var _a = this, state = _a.state, props = _a.props;
                    if (!this.video) return null;
                    if (!state.hasUserMedia || !this.video.videoHeight) return null;
                    if (!this.ctx) {
                        var canvasWidth = this.video.videoWidth;
                        var canvasHeight = this.video.videoHeight;
                        if (!this.props.forceScreenshotSourceSize) {
                            var aspectRatio = canvasWidth / canvasHeight;
                            canvasWidth = props.minScreenshotWidth || this.video.clientWidth;
                            canvasHeight = canvasWidth / aspectRatio;
                            if (props.minScreenshotHeight && canvasHeight < props.minScreenshotHeight) {
                                canvasHeight = props.minScreenshotHeight;
                                canvasWidth = canvasHeight * aspectRatio;
                            }
                        }
                        this.canvas = document.createElement("canvas");
                        this.canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
                        this.canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
                        this.ctx = this.canvas.getContext("2d");
                    }
                    var _b = this, ctx = _b.ctx, canvas = _b.canvas;
                    if (ctx && canvas) {
                        // adjust the height and width of the canvas to the given dimensions
                        canvas.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width;
                        canvas.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height;
                        // mirror the screenshot
                        if (props.mirrored) {
                            ctx.translate(canvas.width, 0);
                            ctx.scale(-1, 1);
                        }
                        ctx.imageSmoothingEnabled = props.imageSmoothing;
                        ctx.drawImage(this.video, 0, 0, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvas.width, (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvas.height);
                        // invert mirroring
                        if (props.mirrored) {
                            ctx.scale(-1, 1);
                            ctx.translate(-canvas.width, 0);
                        }
                    }
                    return canvas;
                };
                Webcam.prototype.requestUserMedia = function() {
                    var _this = this;
                    var props = this.props;
                    var sourceSelected = function(audioConstraints, videoConstraints) {
                        var constraints = {
                            video: typeof videoConstraints !== "undefined" ? videoConstraints : true
                        };
                        if (props.audio) constraints.audio = typeof audioConstraints !== "undefined" ? audioConstraints : true;
                        _this.requestUserMediaId++;
                        var myRequestUserMediaId = _this.requestUserMediaId;
                        navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                            if (_this.unmounted || myRequestUserMediaId !== _this.requestUserMediaId) Webcam.stopMediaStream(stream);
                            else _this.handleUserMedia(null, stream);
                        }).catch(function(e) {
                            _this.handleUserMedia(e);
                        });
                    };
                    if ("mediaDevices" in navigator) sourceSelected(props.audioConstraints, props.videoConstraints);
                    else {
                        var optionalSource_1 = function(id) {
                            return {
                                optional: [
                                    {
                                        sourceId: id
                                    }
                                ]
                            };
                        };
                        var constraintToSourceId_1 = function(constraint) {
                            var deviceId = constraint.deviceId;
                            if (typeof deviceId === "string") return deviceId;
                            if (Array.isArray(deviceId) && deviceId.length > 0) return deviceId[0];
                            if (typeof deviceId === "object" && deviceId.ideal) return deviceId.ideal;
                            return null;
                        };
                        // @ts-ignore: deprecated api
                        MediaStreamTrack.getSources(function(sources) {
                            var audioSource = null;
                            var videoSource = null;
                            sources.forEach(function(source) {
                                if (source.kind === "audio") audioSource = source.id;
                                else if (source.kind === "video") videoSource = source.id;
                            });
                            var audioSourceId = constraintToSourceId_1(props.audioConstraints);
                            if (audioSourceId) audioSource = audioSourceId;
                            var videoSourceId = constraintToSourceId_1(props.videoConstraints);
                            if (videoSourceId) videoSource = videoSourceId;
                            sourceSelected(optionalSource_1(audioSource), optionalSource_1(videoSource));
                        });
                    }
                };
                Webcam.prototype.handleUserMedia = function(err, stream) {
                    var props = this.props;
                    if (err || !stream) {
                        this.setState({
                            hasUserMedia: false
                        });
                        props.onUserMediaError(err);
                        return;
                    }
                    this.stream = stream;
                    try {
                        if (this.video) this.video.srcObject = stream;
                        this.setState({
                            hasUserMedia: true
                        });
                    } catch (error) {
                        this.setState({
                            hasUserMedia: true,
                            src: window.URL.createObjectURL(stream)
                        });
                    }
                    props.onUserMedia(stream);
                };
                Webcam.prototype.render = function() {
                    var _this = this;
                    var _a = this, state = _a.state, props = _a.props;
                    var audio = props.audio, forceScreenshotSourceSize = props.forceScreenshotSourceSize, disablePictureInPicture = props.disablePictureInPicture, onUserMedia = props.onUserMedia, onUserMediaError = props.onUserMediaError, screenshotFormat = props.screenshotFormat, screenshotQuality = props.screenshotQuality, minScreenshotWidth = props.minScreenshotWidth, minScreenshotHeight = props.minScreenshotHeight, audioConstraints = props.audioConstraints, videoConstraints = props.videoConstraints, imageSmoothing = props.imageSmoothing, mirrored = props.mirrored, _b = props.style, style = _b === void 0 ? {} : _b, children = props.children, rest = __rest(props, [
                        "audio",
                        "forceScreenshotSourceSize",
                        "disablePictureInPicture",
                        "onUserMedia",
                        "onUserMediaError",
                        "screenshotFormat",
                        "screenshotQuality",
                        "minScreenshotWidth",
                        "minScreenshotHeight",
                        "audioConstraints",
                        "videoConstraints",
                        "imageSmoothing",
                        "mirrored",
                        "style",
                        "children"
                    ]);
                    var videoStyle = mirrored ? __assign(__assign({}, style), {
                        transform: (style.transform || "") + " scaleX(-1)"
                    }) : style;
                    var childrenProps = {
                        getScreenshot: this.getScreenshot.bind(this)
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", __assign({
                        autoPlay: true,
                        disablePictureInPicture: disablePictureInPicture,
                        src: state.src,
                        muted: !audio,
                        playsInline: true,
                        ref: function(ref) {
                            _this.video = ref;
                        },
                        style: videoStyle
                    }, rest)), children && children(childrenProps));
                };
                Webcam.defaultProps = {
                    audio: false,
                    disablePictureInPicture: false,
                    forceScreenshotSourceSize: false,
                    imageSmoothing: true,
                    mirrored: false,
                    onUserMedia: function() {
                        return undefined;
                    },
                    onUserMediaError: function() {
                        return undefined;
                    },
                    screenshotFormat: "image/webp",
                    screenshotQuality: 0.92
                };
                return Webcam;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            /* harmony default export */ __webpack_exports__["default"] = Webcam;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ }
    })["default"];
});




parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1BSKa = parcelRequire("1BSKa");

var $eOD8X = parcelRequire("eOD8X");
const $e92fc026f2fe1d33$var$CLIENT_TOKEN = (0, window.location.pathname.split("/")[2]);
const $e92fc026f2fe1d33$var$FileUploadContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $e92fc026f2fe1d33$export$6397b8382b014af7 = ()=>(0, $eZVvM.useContext)($e92fc026f2fe1d33$var$FileUploadContext);
const $e92fc026f2fe1d33$export$c9026ab2f790e4f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const apiUrl = (0, $eOD8X.getApiUrl)();
    const baseURL = apiUrl.replace(/(http)(s)?\:\/\//, "ws$2://");
    const socketURL = (0, $eZVvM.useMemo)(()=>new URL(`${baseURL}/upload`), [
        baseURL
    ]);
    if ($e92fc026f2fe1d33$var$CLIENT_TOKEN) socketURL.searchParams.set("clientToken", $e92fc026f2fe1d33$var$CLIENT_TOKEN);
    const socket = (0, $eZVvM.useMemo)(()=>new WebSocket(socketURL), [
        socketURL
    ]);
    (0, $eZVvM.useEffect)(()=>{
        socket.onopen = ()=>(0, $1BSKa.default).debug("[File upload socket] Connection opened");
        socket.onerror = (error)=>(0, $1BSKa.default).error("[File upload socket] Connection error", error);
        socket.onclose = (event)=>(0, $1BSKa.default).debug("[File upload socket] Disconnected", event.reason);
        return ()=>{
            if (socket) socket.close();
        };
    }, [
        socket
    ]);
    const onUpload = (0, $eZVvM.useCallback)((fileUpload)=>{
        return new Promise((resolve, reject)=>{
            if (!socket) throw new Error("Socket not ready");
            socket.send(JSON.stringify({
                filename: fileUpload.file.name,
                file: fileUpload.data
            }));
            socket.onerror = reject;
            socket.onmessage = (e)=>{
                let message;
                try {
                    message = JSON.parse(e.data);
                } catch (e1) {
                    message = e.data;
                }
                if (!message) return reject(new Error("Failed to upload the file"));
                return resolve([
                    message
                ]);
            };
        });
    }, [
        socket
    ]);
    const value = (0, $eZVvM.useMemo)(()=>({
            socket: socket,
            onUpload: onUpload
        }), []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($e92fc026f2fe1d33$var$FileUploadContext.Provider, {
        value: value,
        children: children
    });
});
var $e92fc026f2fe1d33$export$2e2bcd8739ae039 = $e92fc026f2fe1d33$export$c9026ab2f790e4f7;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $eZVvM = parcelRequire("eZVvM");
var $12c6b0ab9da17bee$var$n, $12c6b0ab9da17bee$var$o, $12c6b0ab9da17bee$var$i = ($12c6b0ab9da17bee$var$n = function(t, e) {
    return $12c6b0ab9da17bee$var$n = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
    }, $12c6b0ab9da17bee$var$n(t, e);
}, function(t, e) {
    function r() {
        this.constructor = t;
    }
    $12c6b0ab9da17bee$var$n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r);
}), $12c6b0ab9da17bee$var$a = function(t) {
    function e(e) {
        var r, n, o, i = this.constructor, a = t.call(this, e) || this;
        return Object.defineProperty(a, "name", {
            value: i.name,
            enumerable: !1,
            configurable: !0
        }), r = a, n = i.prototype, (o = Object.setPrototypeOf) ? o(r, n) : r.__proto__ = n, function(t, e) {
            void 0 === e && (e = t.constructor);
            var r = Error.captureStackTrace;
            r && r(t, e);
        }(a), a;
    }
    return $12c6b0ab9da17bee$var$i(e, t), e;
}(Error), $12c6b0ab9da17bee$var$u = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$s = function(t) {
    function e(e) {
        void 0 === e && (e = void 0);
        var r = t.call(this, e) || this;
        return r.message = e, r;
    }
    return $12c6b0ab9da17bee$var$u(e, t), e.prototype.getKind = function() {
        return this.constructor.kind;
    }, e.kind = "Exception", e;
}($12c6b0ab9da17bee$var$a), $12c6b0ab9da17bee$var$c = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$f = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$c(e, t), e.kind = "ArgumentException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$h = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$l = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$h(e, t), e.kind = "IllegalArgumentException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$d = function() {
    function t(t) {
        if (this.binarizer = t, null === t) throw new $12c6b0ab9da17bee$var$l("Binarizer must be non-null.");
    }
    return t.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    }, t.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    }, t.prototype.getBlackRow = function(t, e) {
        return this.binarizer.getBlackRow(t, e);
    }, t.prototype.getBlackMatrix = function() {
        return null !== this.matrix && void 0 !== this.matrix || (this.matrix = this.binarizer.getBlackMatrix()), this.matrix;
    }, t.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    }, t.prototype.crop = function(e, r, n, o) {
        var i = this.binarizer.getLuminanceSource().crop(e, r, n, o);
        return new t(this.binarizer.createBinarizer(i));
    }, t.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    }, t.prototype.rotateCounterClockwise = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.rotateCounterClockwise45 = function() {
        var e = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new t(this.binarizer.createBinarizer(e));
    }, t.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (t) {
            return "";
        }
    }, t;
}(), $12c6b0ab9da17bee$var$p = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$g = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$p(e, t), e.getChecksumInstance = function() {
        return new e;
    }, e.kind = "ChecksumException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$y = function() {
    function t(t) {
        this.source = t;
    }
    return t.prototype.getLuminanceSource = function() {
        return this.source;
    }, t.prototype.getWidth = function() {
        return this.source.getWidth();
    }, t.prototype.getHeight = function() {
        return this.source.getHeight();
    }, t;
}(), $12c6b0ab9da17bee$var$w = function() {
    function t() {}
    return t.arraycopy = function(t, e, r, n, o) {
        for(; o--;)r[n++] = t[e++];
    }, t.currentTimeMillis = function() {
        return Date.now();
    }, t;
}(), $12c6b0ab9da17bee$var$_ = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$v = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$_(e, t), e.kind = "IndexOutOfBoundsException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$m = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$A = function(t) {
    function e(e, r) {
        void 0 === e && (e = void 0), void 0 === r && (r = void 0);
        var n = t.call(this, r) || this;
        return n.index = e, n.message = r, n;
    }
    return $12c6b0ab9da17bee$var$m(e, t), e.kind = "ArrayIndexOutOfBoundsException", e;
}($12c6b0ab9da17bee$var$v), $12c6b0ab9da17bee$var$E = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$C = function() {
    function t() {}
    return t.fill = function(t, e) {
        for(var r = 0, n = t.length; r < n; r++)t[r] = e;
    }, t.fillWithin = function(e, r, n, o) {
        t.rangeCheck(e.length, r, n);
        for(var i = r; i < n; i++)e[i] = o;
    }, t.rangeCheck = function(t, e, r) {
        if (e > r) throw new $12c6b0ab9da17bee$var$l("fromIndex(" + e + ") > toIndex(" + r + ")");
        if (e < 0) throw new $12c6b0ab9da17bee$var$A(e);
        if (r > t) throw new $12c6b0ab9da17bee$var$A(r);
    }, t.asList = function() {
        for(var t = [], e = 0; e < arguments.length; e++)t[e] = arguments[e];
        return t;
    }, t.create = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Array.from({
                length: e
            }).fill(r);
        });
    }, t.createInt32Array = function(t, e, r) {
        return Array.from({
            length: t
        }).map(function(t) {
            return Int32Array.from({
                length: e
            }).fill(r);
        });
    }, t.equals = function(t, e) {
        if (!t) return !1;
        if (!e) return !1;
        if (!t.length) return !1;
        if (!e.length) return !1;
        if (t.length !== e.length) return !1;
        for(var r = 0, n = t.length; r < n; r++)if (t[r] !== e[r]) return !1;
        return !0;
    }, t.hashCode = function(t) {
        var e, r;
        if (null === t) return 0;
        var n = 1;
        try {
            for(var o = $12c6b0ab9da17bee$var$E(t), i = o.next(); !i.done; i = o.next())n = 31 * n + i.value;
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.fillUint8Array = function(t, e) {
        for(var r = 0; r !== t.length; r++)t[r] = e;
    }, t.copyOf = function(t, e) {
        return t.slice(0, e);
    }, t.copyOfUint8Array = function(t, e) {
        if (t.length <= e) {
            var r = new Uint8Array(e);
            return r.set(t), r;
        }
        return t.slice(0, e);
    }, t.copyOfRange = function(t, e, r) {
        var n = r - e, o = new Int32Array(n);
        return $12c6b0ab9da17bee$var$w.arraycopy(t, e, o, 0, n), o;
    }, t.binarySearch = function(e, r, n) {
        void 0 === n && (n = t.numberComparator);
        for(var o = 0, i = e.length - 1; o <= i;){
            var a = i + o >> 1, u = n(r, e[a]);
            if (u > 0) o = a + 1;
            else {
                if (!(u < 0)) return a;
                i = a - 1;
            }
        }
        return -o - 1;
    }, t.numberComparator = function(t, e) {
        return t - e;
    }, t;
}(), $12c6b0ab9da17bee$var$I = function() {
    function t() {}
    return t.numberOfTrailingZeros = function(t) {
        var e;
        if (0 === t) return 32;
        var r = 31;
        return 0 !== (e = t << 16) && (r -= 16, t = e), 0 !== (e = t << 8) && (r -= 8, t = e), 0 !== (e = t << 4) && (r -= 4, t = e), 0 !== (e = t << 2) && (r -= 2, t = e), r - (t << 1 >>> 31);
    }, t.numberOfLeadingZeros = function(t) {
        if (0 === t) return 32;
        var e = 1;
        return t >>> 16 == 0 && (e += 16, t <<= 16), t >>> 24 == 0 && (e += 8, t <<= 8), t >>> 28 == 0 && (e += 4, t <<= 4), t >>> 30 == 0 && (e += 2, t <<= 2), e -= t >>> 31;
    }, t.toHexString = function(t) {
        return t.toString(16);
    }, t.toBinaryString = function(t) {
        return String(parseInt(String(t), 2));
    }, t.bitCount = function(t) {
        return t = (t = (858993459 & (t -= t >>> 1 & 1431655765)) + (t >>> 2 & 858993459)) + (t >>> 4) & 252645135, t += t >>> 8, 63 & (t += t >>> 16);
    }, t.truncDivision = function(t, e) {
        return Math.trunc(t / e);
    }, t.parseInt = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t.MIN_VALUE_32_BITS = -2147483648, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $12c6b0ab9da17bee$var$S = function() {
    function t(e, r) {
        void 0 === e ? (this.size = 0, this.bits = new Int32Array(1)) : (this.size = e, this.bits = null == r ? t.makeArray(e) : r);
    }
    return t.prototype.getSize = function() {
        return this.size;
    }, t.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    }, t.prototype.ensureCapacity = function(e) {
        if (e > 32 * this.bits.length) {
            var r = t.makeArray(e);
            $12c6b0ab9da17bee$var$w.arraycopy(this.bits, 0, r, 0, this.bits.length), this.bits = r;
        }
    }, t.prototype.get = function(t) {
        return 0 != (this.bits[Math.floor(t / 32)] & 1 << (31 & t));
    }, t.prototype.set = function(t) {
        this.bits[Math.floor(t / 32)] |= 1 << (31 & t);
    }, t.prototype.flip = function(t) {
        this.bits[Math.floor(t / 32)] ^= 1 << (31 & t);
    }, t.prototype.getNextSet = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = r[n];
        }
        var a = 32 * n + $12c6b0ab9da17bee$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.getNextUnset = function(t) {
        var e = this.size;
        if (t >= e) return e;
        var r = this.bits, n = Math.floor(t / 32), o = ~r[n];
        o &= ~((1 << (31 & t)) - 1);
        for(var i = r.length; 0 === o;){
            if (++n === i) return e;
            o = ~r[n];
        }
        var a = 32 * n + $12c6b0ab9da17bee$var$I.numberOfTrailingZeros(o);
        return a > e ? e : a;
    }, t.prototype.setBulk = function(t, e) {
        this.bits[Math.floor(t / 32)] = e;
    }, t.prototype.setRange = function(t, e) {
        if (e < t || t < 0 || e > this.size) throw new $12c6b0ab9da17bee$var$l;
        if (e !== t) {
            e--;
            for(var r = Math.floor(t / 32), n = Math.floor(e / 32), o = this.bits, i = r; i <= n; i++){
                var a = (2 << (i < n ? 31 : 31 & e)) - (1 << (i > r ? 0 : 31 & t));
                o[i] |= a;
            }
        }
    }, t.prototype.clear = function() {
        for(var t = this.bits.length, e = this.bits, r = 0; r < t; r++)e[r] = 0;
    }, t.prototype.isRange = function(t, e, r) {
        if (e < t || t < 0 || e > this.size) throw new $12c6b0ab9da17bee$var$l;
        if (e === t) return !0;
        e--;
        for(var n = Math.floor(t / 32), o = Math.floor(e / 32), i = this.bits, a = n; a <= o; a++){
            var u = (2 << (a < o ? 31 : 31 & e)) - (1 << (a > n ? 0 : 31 & t)) & 4294967295;
            if ((i[a] & u) !== (r ? u : 0)) return !1;
        }
        return !0;
    }, t.prototype.appendBit = function(t) {
        this.ensureCapacity(this.size + 1), t && (this.bits[Math.floor(this.size / 32)] |= 1 << (31 & this.size)), this.size++;
    }, t.prototype.appendBits = function(t, e) {
        if (e < 0 || e > 32) throw new $12c6b0ab9da17bee$var$l("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + e);
        for(var r = e; r > 0; r--)this.appendBit(1 == (t >> r - 1 & 1));
    }, t.prototype.appendBitArray = function(t) {
        var e = t.size;
        this.ensureCapacity(this.size + e);
        for(var r = 0; r < e; r++)this.appendBit(t.get(r));
    }, t.prototype.xor = function(t) {
        if (this.size !== t.size) throw new $12c6b0ab9da17bee$var$l("Sizes don't match");
        for(var e = this.bits, r = 0, n = e.length; r < n; r++)e[r] ^= t.bits[r];
    }, t.prototype.toBytes = function(t, e, r, n) {
        for(var o = 0; o < n; o++){
            for(var i = 0, a = 0; a < 8; a++)this.get(t) && (i |= 1 << 7 - a), t++;
            e[r + o] = i;
        }
    }, t.prototype.getBitArray = function() {
        return this.bits;
    }, t.prototype.reverse = function() {
        for(var t = new Int32Array(this.bits.length), e = Math.floor((this.size - 1) / 32), r = e + 1, n = this.bits, o = 0; o < r; o++){
            var i = n[o];
            i = (i = (i = (i = (i = i >> 1 & 1431655765 | (1431655765 & i) << 1) >> 2 & 858993459 | (858993459 & i) << 2) >> 4 & 252645135 | (252645135 & i) << 4) >> 8 & 16711935 | (16711935 & i) << 8) >> 16 & 65535 | (65535 & i) << 16, t[e - o] = i;
        }
        if (this.size !== 32 * r) {
            var a = 32 * r - this.size, u = t[0] >>> a;
            for(o = 1; o < r; o++){
                var s = t[o];
                u |= s << 32 - a, t[o - 1] = u, u = s >>> a;
            }
            t[r - 1] = u;
        }
        this.bits = t;
    }, t.makeArray = function(t) {
        return new Int32Array(Math.floor((t + 31) / 32));
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.size === r.size && $12c6b0ab9da17bee$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        return 31 * this.size + $12c6b0ab9da17bee$var$C.hashCode(this.bits);
    }, t.prototype.toString = function() {
        for(var t = "", e = 0, r = this.size; e < r; e++)0 == (7 & e) && (t += " "), t += this.get(e) ? "X" : ".";
        return t;
    }, t.prototype.clone = function() {
        return new t(this.size, this.bits.slice());
    }, t;
}();
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.PURE_BARCODE = 1] = "PURE_BARCODE", t[t.POSSIBLE_FORMATS = 2] = "POSSIBLE_FORMATS", t[t.TRY_HARDER = 3] = "TRY_HARDER", t[t.CHARACTER_SET = 4] = "CHARACTER_SET", t[t.ALLOWED_LENGTHS = 5] = "ALLOWED_LENGTHS", t[t.ASSUME_CODE_39_CHECK_DIGIT = 6] = "ASSUME_CODE_39_CHECK_DIGIT", t[t.ASSUME_GS1 = 7] = "ASSUME_GS1", t[t.RETURN_CODABAR_START_END = 8] = "RETURN_CODABAR_START_END", t[t.NEED_RESULT_POINT_CALLBACK = 9] = "NEED_RESULT_POINT_CALLBACK", t[t.ALLOWED_EAN_EXTENSIONS = 10] = "ALLOWED_EAN_EXTENSIONS";
}($12c6b0ab9da17bee$var$o || ($12c6b0ab9da17bee$var$o = {}));
var $12c6b0ab9da17bee$var$O, $12c6b0ab9da17bee$var$T = $12c6b0ab9da17bee$var$o, $12c6b0ab9da17bee$var$b = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$R = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$b(e, t), e.getFormatInstance = function() {
        return new e;
    }, e.kind = "FormatException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$N = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    t[t.Cp437 = 0] = "Cp437", t[t.ISO8859_1 = 1] = "ISO8859_1", t[t.ISO8859_2 = 2] = "ISO8859_2", t[t.ISO8859_3 = 3] = "ISO8859_3", t[t.ISO8859_4 = 4] = "ISO8859_4", t[t.ISO8859_5 = 5] = "ISO8859_5", t[t.ISO8859_6 = 6] = "ISO8859_6", t[t.ISO8859_7 = 7] = "ISO8859_7", t[t.ISO8859_8 = 8] = "ISO8859_8", t[t.ISO8859_9 = 9] = "ISO8859_9", t[t.ISO8859_10 = 10] = "ISO8859_10", t[t.ISO8859_11 = 11] = "ISO8859_11", t[t.ISO8859_13 = 12] = "ISO8859_13", t[t.ISO8859_14 = 13] = "ISO8859_14", t[t.ISO8859_15 = 14] = "ISO8859_15", t[t.ISO8859_16 = 15] = "ISO8859_16", t[t.SJIS = 16] = "SJIS", t[t.Cp1250 = 17] = "Cp1250", t[t.Cp1251 = 18] = "Cp1251", t[t.Cp1252 = 19] = "Cp1252", t[t.Cp1256 = 20] = "Cp1256", t[t.UnicodeBigUnmarked = 21] = "UnicodeBigUnmarked", t[t.UTF8 = 22] = "UTF8", t[t.ASCII = 23] = "ASCII", t[t.Big5 = 24] = "Big5", t[t.GB18030 = 25] = "GB18030", t[t.EUC_KR = 26] = "EUC_KR";
}($12c6b0ab9da17bee$var$O || ($12c6b0ab9da17bee$var$O = {}));
var $12c6b0ab9da17bee$var$D, $12c6b0ab9da17bee$var$P = function() {
    function t(e, r, n) {
        for(var o, i, a = [], u = 3; u < arguments.length; u++)a[u - 3] = arguments[u];
        this.valueIdentifier = e, this.name = n, this.values = "number" == typeof r ? Int32Array.from([
            r
        ]) : r, this.otherEncodingNames = a, t.VALUE_IDENTIFIER_TO_ECI.set(e, this), t.NAME_TO_ECI.set(n, this);
        for(var s = this.values, c = 0, f = s.length; c !== f; c++){
            var h = s[c];
            t.VALUES_TO_ECI.set(h, this);
        }
        try {
            for(var l = $12c6b0ab9da17bee$var$N(a), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                t.NAME_TO_ECI.set(p, this);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = l.return) && i.call(l);
            } finally{
                if (o) throw o.error;
            }
        }
    }
    return t.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    }, t.prototype.getName = function() {
        return this.name;
    }, t.prototype.getValue = function() {
        return this.values[0];
    }, t.getCharacterSetECIByValue = function(e) {
        if (e < 0 || e >= 900) throw new $12c6b0ab9da17bee$var$R("incorect value");
        var r = t.VALUES_TO_ECI.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$R("incorect value");
        return r;
    }, t.getCharacterSetECIByName = function(e) {
        var r = t.NAME_TO_ECI.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$R("incorect value");
        return r;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.getName() === r.getName();
    }, t.VALUE_IDENTIFIER_TO_ECI = new Map, t.VALUES_TO_ECI = new Map, t.NAME_TO_ECI = new Map, t.Cp437 = new t($12c6b0ab9da17bee$var$O.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437"), t.ISO8859_1 = new t($12c6b0ab9da17bee$var$O.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1"), t.ISO8859_2 = new t($12c6b0ab9da17bee$var$O.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2"), t.ISO8859_3 = new t($12c6b0ab9da17bee$var$O.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3"), t.ISO8859_4 = new t($12c6b0ab9da17bee$var$O.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4"), t.ISO8859_5 = new t($12c6b0ab9da17bee$var$O.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5"), t.ISO8859_6 = new t($12c6b0ab9da17bee$var$O.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6"), t.ISO8859_7 = new t($12c6b0ab9da17bee$var$O.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7"), t.ISO8859_8 = new t($12c6b0ab9da17bee$var$O.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8"), t.ISO8859_9 = new t($12c6b0ab9da17bee$var$O.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9"), t.ISO8859_10 = new t($12c6b0ab9da17bee$var$O.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10"), t.ISO8859_11 = new t($12c6b0ab9da17bee$var$O.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11"), t.ISO8859_13 = new t($12c6b0ab9da17bee$var$O.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13"), t.ISO8859_14 = new t($12c6b0ab9da17bee$var$O.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14"), t.ISO8859_15 = new t($12c6b0ab9da17bee$var$O.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15"), t.ISO8859_16 = new t($12c6b0ab9da17bee$var$O.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16"), t.SJIS = new t($12c6b0ab9da17bee$var$O.SJIS, 20, "SJIS", "Shift_JIS"), t.Cp1250 = new t($12c6b0ab9da17bee$var$O.Cp1250, 21, "Cp1250", "windows-1250"), t.Cp1251 = new t($12c6b0ab9da17bee$var$O.Cp1251, 22, "Cp1251", "windows-1251"), t.Cp1252 = new t($12c6b0ab9da17bee$var$O.Cp1252, 23, "Cp1252", "windows-1252"), t.Cp1256 = new t($12c6b0ab9da17bee$var$O.Cp1256, 24, "Cp1256", "windows-1256"), t.UnicodeBigUnmarked = new t($12c6b0ab9da17bee$var$O.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig"), t.UTF8 = new t($12c6b0ab9da17bee$var$O.UTF8, 26, "UTF8", "UTF-8"), t.ASCII = new t($12c6b0ab9da17bee$var$O.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII"), t.Big5 = new t($12c6b0ab9da17bee$var$O.Big5, 28, "Big5"), t.GB18030 = new t($12c6b0ab9da17bee$var$O.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK"), t.EUC_KR = new t($12c6b0ab9da17bee$var$O.EUC_KR, 30, "EUC_KR", "EUC-KR"), t;
}(), $12c6b0ab9da17bee$var$M = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$B = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$M(e, t), e.kind = "UnsupportedOperationException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$L = function() {
    function t() {}
    return t.decode = function(t, e) {
        var r = this.encodingName(e);
        return this.customDecoder ? this.customDecoder(t, r) : "undefined" == typeof TextDecoder || this.shouldDecodeOnFallback(r) ? this.decodeFallback(t, r) : new TextDecoder(r).decode(t);
    }, t.shouldDecodeOnFallback = function(e) {
        return !t.isBrowser() && "ISO-8859-1" === e;
    }, t.encode = function(t, e) {
        var r = this.encodingName(e);
        return this.customEncoder ? this.customEncoder(t, r) : "undefined" == typeof TextEncoder ? this.encodeFallback(t) : (new TextEncoder).encode(t);
    }, t.isBrowser = function() {
        return "undefined" != typeof window && "[object Window]" === ({}).toString.call(window);
    }, t.encodingName = function(t) {
        return "string" == typeof t ? t : t.getName();
    }, t.encodingCharacterSet = function(t) {
        return t instanceof $12c6b0ab9da17bee$var$P ? t : $12c6b0ab9da17bee$var$P.getCharacterSetECIByName(t);
    }, t.decodeFallback = function(e, r) {
        var n = this.encodingCharacterSet(r);
        if (t.isDecodeFallbackSupported(n)) {
            for(var o = "", i = 0, a = e.length; i < a; i++){
                var u = e[i].toString(16);
                u.length < 2 && (u = "0" + u), o += "%" + u;
            }
            return decodeURIComponent(o);
        }
        if (n.equals($12c6b0ab9da17bee$var$P.UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(e.buffer));
        throw new $12c6b0ab9da17bee$var$B("Encoding " + this.encodingName(r) + " not supported by fallback.");
    }, t.isDecodeFallbackSupported = function(t) {
        return t.equals($12c6b0ab9da17bee$var$P.UTF8) || t.equals($12c6b0ab9da17bee$var$P.ISO8859_1) || t.equals($12c6b0ab9da17bee$var$P.ASCII);
    }, t.encodeFallback = function(t) {
        for(var e = btoa(unescape(encodeURIComponent(t))).split(""), r = [], n = 0; n < e.length; n++)r.push(e[n].charCodeAt(0));
        return new Uint8Array(r);
    }, t;
}(), $12c6b0ab9da17bee$var$F = function() {
    function t() {}
    return t.castAsNonUtf8Char = function(t, e) {
        void 0 === e && (e = null);
        var r = e ? e.getName() : this.ISO88591;
        return $12c6b0ab9da17bee$var$L.decode(new Uint8Array([
            t
        ]), r);
    }, t.guessEncoding = function(e, r) {
        if (null != r && void 0 !== r.get($12c6b0ab9da17bee$var$T.CHARACTER_SET)) return r.get($12c6b0ab9da17bee$var$T.CHARACTER_SET).toString();
        for(var n = e.length, o = !0, i = !0, a = !0, u = 0, s = 0, c = 0, f = 0, h = 0, l = 0, d = 0, p = 0, g = 0, y = 0, w = 0, _ = e.length > 3 && 239 === e[0] && 187 === e[1] && 191 === e[2], v = 0; v < n && (o || i || a); v++){
            var m = 255 & e[v];
            a && (u > 0 ? 0 == (128 & m) ? a = !1 : u-- : 0 != (128 & m) && (0 == (64 & m) ? a = !1 : (u++, 0 == (32 & m) ? s++ : (u++, 0 == (16 & m) ? c++ : (u++, 0 == (8 & m) ? f++ : a = !1))))), o && (m > 127 && m < 160 ? o = !1 : m > 159 && (m < 192 || 215 === m || 247 === m) && w++), i && (h > 0 ? m < 64 || 127 === m || m > 252 ? i = !1 : h-- : 128 === m || 160 === m || m > 239 ? i = !1 : m > 160 && m < 224 ? (l++, p = 0, ++d > g && (g = d)) : m > 127 ? (h++, d = 0, ++p > y && (y = p)) : (d = 0, p = 0));
        }
        return a && u > 0 && (a = !1), i && h > 0 && (i = !1), a && (_ || s + c + f > 0) ? t.UTF8 : i && (t.ASSUME_SHIFT_JIS || g >= 3 || y >= 3) ? t.SHIFT_JIS : o && i ? 2 === g && 2 === l || 10 * w >= n ? t.SHIFT_JIS : t.ISO88591 : o ? t.ISO88591 : i ? t.SHIFT_JIS : a ? t.UTF8 : t.PLATFORM_DEFAULT_ENCODING;
    }, t.format = function(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        var n = -1;
        function o(t, r, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++n]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[n];
                        break;
                    case "c":
                        s = e[n][0];
                        break;
                    case "f":
                        s = parseFloat(e[n]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[n]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[n]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[n]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[n], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== r ? s + h : h + s;
                return s;
            }
        }
        var i = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return t.replace(i, o);
    }, t.getBytes = function(t, e) {
        return $12c6b0ab9da17bee$var$L.encode(t, e);
    }, t.getCharCode = function(t, e) {
        return void 0 === e && (e = 0), t.charCodeAt(e);
    }, t.getCharAt = function(t) {
        return String.fromCharCode(t);
    }, t.SHIFT_JIS = $12c6b0ab9da17bee$var$P.SJIS.getName(), t.GB2312 = "GB2312", t.ISO88591 = $12c6b0ab9da17bee$var$P.ISO8859_1.getName(), t.EUC_JP = "EUC_JP", t.UTF8 = $12c6b0ab9da17bee$var$P.UTF8.getName(), t.PLATFORM_DEFAULT_ENCODING = t.UTF8, t.ASSUME_SHIFT_JIS = !1, t;
}(), $12c6b0ab9da17bee$var$k = function() {
    function t(t) {
        void 0 === t && (t = ""), this.value = t;
    }
    return t.prototype.enableDecoding = function(t) {
        return this.encoding = t, this;
    }, t.prototype.append = function(t) {
        return "string" == typeof t ? this.value += t.toString() : this.encoding ? this.value += $12c6b0ab9da17bee$var$F.castAsNonUtf8Char(t, this.encoding) : this.value += String.fromCharCode(t), this;
    }, t.prototype.appendChars = function(t, e, r) {
        for(var n = e; e < e + r; n++)this.append(t[n]);
        return this;
    }, t.prototype.length = function() {
        return this.value.length;
    }, t.prototype.charAt = function(t) {
        return this.value.charAt(t);
    }, t.prototype.deleteCharAt = function(t) {
        this.value = this.value.substr(0, t) + this.value.substring(t + 1);
    }, t.prototype.setCharAt = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + 1);
    }, t.prototype.substring = function(t, e) {
        return this.value.substring(t, e);
    }, t.prototype.setLengthToZero = function() {
        this.value = "";
    }, t.prototype.toString = function() {
        return this.value;
    }, t.prototype.insert = function(t, e) {
        this.value = this.value.substr(0, t) + e + this.value.substr(t + e.length);
    }, t;
}(), $12c6b0ab9da17bee$var$x = function() {
    function t(t, e, r, n) {
        if (this.width = t, this.height = e, this.rowSize = r, this.bits = n, null == e && (e = t), this.height = e, t < 1 || e < 1) throw new $12c6b0ab9da17bee$var$l("Both dimensions must be greater than 0");
        null == r && (r = Math.floor((t + 31) / 32)), this.rowSize = r, null == n && (this.bits = new Int32Array(this.rowSize * this.height));
    }
    return t.parseFromBooleanArray = function(e) {
        for(var r = e.length, n = e[0].length, o = new t(n, r), i = 0; i < r; i++)for(var a = e[i], u = 0; u < n; u++)a[u] && o.set(u, i);
        return o;
    }, t.parseFromString = function(e, r, n) {
        if (null === e) throw new $12c6b0ab9da17bee$var$l("stringRepresentation cannot be null");
        for(var o = new Array(e.length), i = 0, a = 0, u = -1, s = 0, c = 0; c < e.length;)if ("\n" === e.charAt(c) || "\r" === e.charAt(c)) {
            if (i > a) {
                if (-1 === u) u = i - a;
                else if (i - a !== u) throw new $12c6b0ab9da17bee$var$l("row lengths do not match");
                a = i, s++;
            }
            c++;
        } else if (e.substring(c, c + r.length) === r) c += r.length, o[i] = !0, i++;
        else {
            if (e.substring(c, c + n.length) !== n) throw new $12c6b0ab9da17bee$var$l("illegal character encountered: " + e.substring(c));
            c += n.length, o[i] = !1, i++;
        }
        if (i > a) {
            if (-1 === u) u = i - a;
            else if (i - a !== u) throw new $12c6b0ab9da17bee$var$l("row lengths do not match");
            s++;
        }
        for(var f = new t(u, s), h = 0; h < i; h++)o[h] && f.set(Math.floor(h % u), Math.floor(h / u));
        return f;
    }, t.prototype.get = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        return 0 != (this.bits[r] >>> (31 & t) & 1);
    }, t.prototype.set = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] |= 1 << (31 & t) & 4294967295;
    }, t.prototype.unset = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] &= ~(1 << (31 & t) & 4294967295);
    }, t.prototype.flip = function(t, e) {
        var r = e * this.rowSize + Math.floor(t / 32);
        this.bits[r] ^= 1 << (31 & t) & 4294967295;
    }, t.prototype.xor = function(t) {
        if (this.width !== t.getWidth() || this.height !== t.getHeight() || this.rowSize !== t.getRowSize()) throw new $12c6b0ab9da17bee$var$l("input matrix dimensions do not match");
        for(var e = new $12c6b0ab9da17bee$var$S(Math.floor(this.width / 32) + 1), r = this.rowSize, n = this.bits, o = 0, i = this.height; o < i; o++)for(var a = o * r, u = t.getRow(o, e).getBitArray(), s = 0; s < r; s++)n[a + s] ^= u[s];
    }, t.prototype.clear = function() {
        for(var t = this.bits, e = t.length, r = 0; r < e; r++)t[r] = 0;
    }, t.prototype.setRegion = function(t, e, r, n) {
        if (e < 0 || t < 0) throw new $12c6b0ab9da17bee$var$l("Left and top must be nonnegative");
        if (n < 1 || r < 1) throw new $12c6b0ab9da17bee$var$l("Height and width must be at least 1");
        var o = t + r, i = e + n;
        if (i > this.height || o > this.width) throw new $12c6b0ab9da17bee$var$l("The region must fit inside the matrix");
        for(var a = this.rowSize, u = this.bits, s = e; s < i; s++)for(var c = s * a, f = t; f < o; f++)u[c + Math.floor(f / 32)] |= 1 << (31 & f) & 4294967295;
    }, t.prototype.getRow = function(t, e) {
        null == e || e.getSize() < this.width ? e = new $12c6b0ab9da17bee$var$S(this.width) : e.clear();
        for(var r = this.rowSize, n = this.bits, o = t * r, i = 0; i < r; i++)e.setBulk(32 * i, n[o + i]);
        return e;
    }, t.prototype.setRow = function(t, e) {
        $12c6b0ab9da17bee$var$w.arraycopy(e.getBitArray(), 0, this.bits, t * this.rowSize, this.rowSize);
    }, t.prototype.rotate180 = function() {
        for(var t = this.getWidth(), e = this.getHeight(), r = new $12c6b0ab9da17bee$var$S(t), n = new $12c6b0ab9da17bee$var$S(t), o = 0, i = Math.floor((e + 1) / 2); o < i; o++)r = this.getRow(o, r), n = this.getRow(e - 1 - o, n), r.reverse(), n.reverse(), this.setRow(o, n), this.setRow(e - 1 - o, r);
    }, t.prototype.getEnclosingRectangle = function() {
        for(var t = this.width, e = this.height, r = this.rowSize, n = this.bits, o = t, i = e, a = -1, u = -1, s = 0; s < e; s++)for(var c = 0; c < r; c++){
            var f = n[s * r + c];
            if (0 !== f) {
                if (s < i && (i = s), s > u && (u = s), 32 * c < o) {
                    for(var h = 0; 0 == (f << 31 - h & 4294967295);)h++;
                    32 * c + h < o && (o = 32 * c + h);
                }
                if (32 * c + 31 > a) {
                    for(h = 31; f >>> h == 0;)h--;
                    32 * c + h > a && (a = 32 * c + h);
                }
            }
        }
        return a < o || u < i ? null : Int32Array.from([
            o,
            i,
            a - o + 1,
            u - i + 1
        ]);
    }, t.prototype.getTopLeftOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = 0; r < e.length && 0 === e[r];)r++;
        if (r === e.length) return null;
        for(var n = r / t, o = r % t * 32, i = e[r], a = 0; 0 == (i << 31 - a & 4294967295);)a++;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getBottomRightOnBit = function() {
        for(var t = this.rowSize, e = this.bits, r = e.length - 1; r >= 0 && 0 === e[r];)r--;
        if (r < 0) return null;
        for(var n = Math.floor(r / t), o = 32 * Math.floor(r % t), i = e[r], a = 31; i >>> a == 0;)a--;
        return o += a, Int32Array.from([
            o,
            n
        ]);
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getRowSize = function() {
        return this.rowSize;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.width === r.width && this.height === r.height && this.rowSize === r.rowSize && $12c6b0ab9da17bee$var$C.equals(this.bits, r.bits);
    }, t.prototype.hashCode = function() {
        var t = this.width;
        return t = 31 * (t = 31 * (t = 31 * (t = 31 * t + this.width) + this.height) + this.rowSize) + $12c6b0ab9da17bee$var$C.hashCode(this.bits);
    }, t.prototype.toString = function(t, e, r) {
        return void 0 === t && (t = "X "), void 0 === e && (e = "  "), void 0 === r && (r = "\n"), this.buildToString(t, e, r);
    }, t.prototype.buildToString = function(t, e, r) {
        for(var n = new $12c6b0ab9da17bee$var$k, o = 0, i = this.height; o < i; o++){
            for(var a = 0, u = this.width; a < u; a++)n.append(this.get(a, o) ? t : e);
            n.append(r);
        }
        return n.toString();
    }, t.prototype.clone = function() {
        return new t(this.width, this.height, this.rowSize, this.bits.slice());
    }, t;
}(), $12c6b0ab9da17bee$var$V = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$U = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$V(e, t), e.getNotFoundInstance = function() {
        return new e;
    }, e.kind = "NotFoundException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$H = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$G = function(t) {
    function e(r) {
        var n = t.call(this, r) || this;
        return n.luminances = e.EMPTY, n.buckets = new Int32Array(e.LUMINANCE_BUCKETS), n;
    }
    return $12c6b0ab9da17bee$var$H(e, t), e.prototype.getBlackRow = function(t, r) {
        var n = this.getLuminanceSource(), o = n.getWidth();
        null == r || r.getSize() < o ? r = new $12c6b0ab9da17bee$var$S(o) : r.clear(), this.initArrays(o);
        for(var i = n.getRow(t, this.luminances), a = this.buckets, u = 0; u < o; u++)a[(255 & i[u]) >> e.LUMINANCE_SHIFT]++;
        var s = e.estimateBlackPoint(a);
        if (o < 3) for(u = 0; u < o; u++)(255 & i[u]) < s && r.set(u);
        else {
            var c = 255 & i[0], f = 255 & i[1];
            for(u = 1; u < o - 1; u++){
                var h = 255 & i[u + 1];
                (4 * f - c - h) / 2 < s && r.set(u), c = f, f = h;
            }
        }
        return r;
    }, e.prototype.getBlackMatrix = function() {
        var t = this.getLuminanceSource(), r = t.getWidth(), n = t.getHeight(), o = new $12c6b0ab9da17bee$var$x(r, n);
        this.initArrays(r);
        for(var i = this.buckets, a = 1; a < 5; a++)for(var u = Math.floor(n * a / 5), s = t.getRow(u, this.luminances), c = Math.floor(4 * r / 5), f = Math.floor(r / 5); f < c; f++)i[(255 & s[f]) >> e.LUMINANCE_SHIFT]++;
        var h = e.estimateBlackPoint(i), l = t.getMatrix();
        for(a = 0; a < n; a++){
            var d = a * r;
            for(f = 0; f < r; f++)(255 & l[d + f]) < h && o.set(f, a);
        }
        return o;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.prototype.initArrays = function(t) {
        this.luminances.length < t && (this.luminances = new Uint8ClampedArray(t));
        for(var r = this.buckets, n = 0; n < e.LUMINANCE_BUCKETS; n++)r[n] = 0;
    }, e.estimateBlackPoint = function(t) {
        for(var r = t.length, n = 0, o = 0, i = 0, a = 0; a < r; a++)t[a] > i && (o = a, i = t[a]), t[a] > n && (n = t[a]);
        var u = 0, s = 0;
        for(a = 0; a < r; a++){
            var c = a - o;
            (d = t[a] * c * c) > s && (u = a, s = d);
        }
        if (o > u) {
            var f = o;
            o = u, u = f;
        }
        if (u - o <= r / 16) throw new $12c6b0ab9da17bee$var$U;
        var h = u - 1, l = -1;
        for(a = u - 1; a > o; a--){
            var d, p = a - o;
            (d = p * p * (u - a) * (n - t[a])) > l && (h = a, l = d);
        }
        return h << e.LUMINANCE_SHIFT;
    }, e.LUMINANCE_BITS = 5, e.LUMINANCE_SHIFT = 8 - e.LUMINANCE_BITS, e.LUMINANCE_BUCKETS = 1 << e.LUMINANCE_BITS, e.EMPTY = Uint8ClampedArray.from([
        0
    ]), e;
}($12c6b0ab9da17bee$var$y), $12c6b0ab9da17bee$var$X = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$W = function(t) {
    function e(e) {
        var r = t.call(this, e) || this;
        return r.matrix = null, r;
    }
    return $12c6b0ab9da17bee$var$X(e, t), e.prototype.getBlackMatrix = function() {
        if (null !== this.matrix) return this.matrix;
        var r = this.getLuminanceSource(), n = r.getWidth(), o = r.getHeight();
        if (n >= e.MINIMUM_DIMENSION && o >= e.MINIMUM_DIMENSION) {
            var i = r.getMatrix(), a = n >> e.BLOCK_SIZE_POWER;
            0 != (n & e.BLOCK_SIZE_MASK) && a++;
            var u = o >> e.BLOCK_SIZE_POWER;
            0 != (o & e.BLOCK_SIZE_MASK) && u++;
            var s = e.calculateBlackPoints(i, a, u, n, o), c = new $12c6b0ab9da17bee$var$x(n, o);
            e.calculateThresholdForBlock(i, a, u, n, o, s, c), this.matrix = c;
        } else this.matrix = t.prototype.getBlackMatrix.call(this);
        return this.matrix;
    }, e.prototype.createBinarizer = function(t) {
        return new e(t);
    }, e.calculateThresholdForBlock = function(t, r, n, o, i, a, u) {
        for(var s = i - e.BLOCK_SIZE, c = o - e.BLOCK_SIZE, f = 0; f < n; f++){
            var h = f << e.BLOCK_SIZE_POWER;
            h > s && (h = s);
            for(var l = e.cap(f, 2, n - 3), d = 0; d < r; d++){
                var p = d << e.BLOCK_SIZE_POWER;
                p > c && (p = c);
                for(var g = e.cap(d, 2, r - 3), y = 0, w = -2; w <= 2; w++){
                    var _ = a[l + w];
                    y += _[g - 2] + _[g - 1] + _[g] + _[g + 1] + _[g + 2];
                }
                var v = y / 25;
                e.thresholdBlock(t, p, h, v, o, u);
            }
        }
    }, e.cap = function(t, e, r) {
        return t < e ? e : t > r ? r : t;
    }, e.thresholdBlock = function(t, r, n, o, i, a) {
        for(var u = 0, s = n * i + r; u < e.BLOCK_SIZE; u++, s += i)for(var c = 0; c < e.BLOCK_SIZE; c++)(255 & t[s + c]) <= o && a.set(r + c, n + u);
    }, e.calculateBlackPoints = function(t, r, n, o, i) {
        for(var a = i - e.BLOCK_SIZE, u = o - e.BLOCK_SIZE, s = new Array(n), c = 0; c < n; c++){
            s[c] = new Int32Array(r);
            var f = c << e.BLOCK_SIZE_POWER;
            f > a && (f = a);
            for(var h = 0; h < r; h++){
                var l = h << e.BLOCK_SIZE_POWER;
                l > u && (l = u);
                for(var d = 0, p = 255, g = 0, y = 0, w = f * o + l; y < e.BLOCK_SIZE; y++, w += o){
                    for(var _ = 0; _ < e.BLOCK_SIZE; _++){
                        var v = 255 & t[w + _];
                        d += v, v < p && (p = v), v > g && (g = v);
                    }
                    if (g - p > e.MIN_DYNAMIC_RANGE) for(y++, w += o; y < e.BLOCK_SIZE; y++, w += o)for(_ = 0; _ < e.BLOCK_SIZE; _++)d += 255 & t[w + _];
                }
                var m = d >> 2 * e.BLOCK_SIZE_POWER;
                if (g - p <= e.MIN_DYNAMIC_RANGE && (m = p / 2, c > 0 && h > 0)) {
                    var A = (s[c - 1][h] + 2 * s[c][h - 1] + s[c - 1][h - 1]) / 4;
                    p < A && (m = A);
                }
                s[c][h] = m;
            }
        }
        return s;
    }, e.BLOCK_SIZE_POWER = 3, e.BLOCK_SIZE = 1 << e.BLOCK_SIZE_POWER, e.BLOCK_SIZE_MASK = e.BLOCK_SIZE - 1, e.MINIMUM_DIMENSION = 5 * e.BLOCK_SIZE, e.MIN_DYNAMIC_RANGE = 24, e;
}($12c6b0ab9da17bee$var$G), $12c6b0ab9da17bee$var$j = function() {
    function t(t, e) {
        this.width = t, this.height = e;
    }
    return t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.isCropSupported = function() {
        return !1;
    }, t.prototype.crop = function(t, e, r, n) {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support cropping.");
    }, t.prototype.isRotateSupported = function() {
        return !1;
    }, t.prototype.rotateCounterClockwise = function() {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support rotation by 90 degrees.");
    }, t.prototype.rotateCounterClockwise45 = function() {
        throw new $12c6b0ab9da17bee$var$B("This luminance source does not support rotation by 45 degrees.");
    }, t.prototype.toString = function() {
        for(var t = new Uint8ClampedArray(this.width), e = new $12c6b0ab9da17bee$var$k, r = 0; r < this.height; r++){
            for(var n = this.getRow(r, t), o = 0; o < this.width; o++){
                var i = 255 & n[o], a = void 0;
                a = i < 64 ? "#" : i < 128 ? "+" : i < 192 ? "." : " ", e.append(a);
            }
            e.append("\n");
        }
        return e.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Y = function(t) {
    function e(e) {
        var r = t.call(this, e.getWidth(), e.getHeight()) || this;
        return r.delegate = e, r;
    }
    return $12c6b0ab9da17bee$var$z(e, t), e.prototype.getRow = function(t, e) {
        for(var r = this.delegate.getRow(t, e), n = this.getWidth(), o = 0; o < n; o++)r[o] = 255 - (255 & r[o]);
        return r;
    }, e.prototype.getMatrix = function() {
        for(var t = this.delegate.getMatrix(), e = this.getWidth() * this.getHeight(), r = new Uint8ClampedArray(e), n = 0; n < e; n++)r[n] = 255 - (255 & t[n]);
        return r;
    }, e.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.delegate.crop(t, r, n, o));
    }, e.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    }, e.prototype.invert = function() {
        return this.delegate;
    }, e.prototype.rotateCounterClockwise = function() {
        return new e(this.delegate.rotateCounterClockwise());
    }, e.prototype.rotateCounterClockwise45 = function() {
        return new e(this.delegate.rotateCounterClockwise45());
    }, e;
}($12c6b0ab9da17bee$var$j), $12c6b0ab9da17bee$var$Z = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$K = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.tempCanvasElement = null, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $12c6b0ab9da17bee$var$Z(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d").getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(r.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement(), n = r.getContext("2d"), o = t * e.DEGREE_TO_RADIANS, i = this.canvas.width, a = this.canvas.height, u = Math.ceil(Math.abs(Math.cos(o)) * i + Math.abs(Math.sin(o)) * a), s = Math.ceil(Math.abs(Math.sin(o)) * i + Math.abs(Math.cos(o)) * a);
        return r.width = u, r.height = s, n.translate(u / 2, s / 2), n.rotate(o), n.drawImage(this.canvas, i / -2, a / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($12c6b0ab9da17bee$var$j), $12c6b0ab9da17bee$var$q = function() {
    function t(t, e, r) {
        this.deviceId = t, this.label = e, this.kind = "videoinput", this.groupId = r || void 0;
    }
    return t.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    }, t;
}(), $12c6b0ab9da17bee$var$Q = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $12c6b0ab9da17bee$var$J = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $12c6b0ab9da17bee$var$$ = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$tt = function() {
    function t(t, e, r) {
        void 0 === e && (e = 500), this.reader = t, this.timeBetweenScansMillis = e, this._hints = r, this._stopContinuousDecode = !1, this._stopAsyncDecode = !1, this._timeBetweenDecodingAttempts = 0;
    }
    return Object.defineProperty(t.prototype, "hasNavigator", {
        get: function() {
            return "undefined" != typeof navigator;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "isMediaDevicesSuported", {
        get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "canEnumerateDevices", {
        get: function() {
            return !(!this.isMediaDevicesSuported || !navigator.mediaDevices.enumerateDevices);
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "timeBetweenDecodingAttempts", {
        get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        set: function(t) {
            this._timeBetweenDecodingAttempts = t < 0 ? 0 : t;
        },
        enumerable: !1,
        configurable: !0
    }), Object.defineProperty(t.prototype, "hints", {
        get: function() {
            return this._hints;
        },
        set: function(t) {
            this._hints = t || null;
        },
        enumerable: !1,
        configurable: !0
    }), t.prototype.listVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $12c6b0ab9da17bee$var$J(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $12c6b0ab9da17bee$var$$(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.prototype.getVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return [
                            2,
                            t.sent().map(function(t) {
                                return new $12c6b0ab9da17bee$var$q(t.deviceId, t.label);
                            })
                        ];
                }
            });
        });
    }, t.prototype.findDeviceById = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var e;
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        return (e = r.sent()) ? [
                            2,
                            e.find(function(e) {
                                return e.deviceId === t;
                            })
                        ] : [
                            2,
                            null
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.decodeOnceFromVideoDevice(t, e)
                        ];
                    case 1:
                        return [
                            2,
                            r.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnce(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromInputVideoDeviceContinuously = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            this.decodeFromVideoDevice(t, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return n = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(n, e, r)
                        ];
                    case 1:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeFromStream(n, e, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var n;
            return $12c6b0ab9da17bee$var$J(this, function(o) {
                switch(o.label){
                    case 0:
                        return this.reset(), [
                            4,
                            this.attachStreamToVideo(t, e)
                        ];
                    case 1:
                        return n = o.sent(), [
                            4,
                            this.decodeContinuously(n, r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = !0;
    }, t.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = !0;
    }, t.prototype.attachStreamToVideo = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$J(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = this.prepareVideoElement(e), this.addVideoSource(r, t), this.videoElement = r, this.stream = t, [
                            4,
                            this.playVideoOnLoadAsync(r)
                        ];
                    case 1:
                        return n.sent(), [
                            2,
                            r
                        ];
                }
            });
        });
    }, t.prototype.playVideoOnLoadAsync = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            return e.playVideoOnLoad(t, function() {
                return r();
            });
        });
    }, t.prototype.playVideoOnLoad = function(t, e) {
        var r = this;
        this.videoEndedListener = function() {
            return r.stopStreams();
        }, this.videoCanPlayListener = function() {
            return r.tryPlayVideo(t);
        }, t.addEventListener("ended", this.videoEndedListener), t.addEventListener("canplay", this.videoCanPlayListener), t.addEventListener("playing", e), this.tryPlayVideo(t);
    }, t.prototype.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && !t.ended && t.readyState > 2;
    }, t.prototype.tryPlayVideo = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        if (this.isVideoPlaying(t)) return console.warn("Trying to play video that is already playing."), [
                            2
                        ];
                        e.label = 1;
                    case 1:
                        return e.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            t.play()
                        ];
                    case 2:
                        return e.sent(), [
                            3,
                            4
                        ];
                    case 3:
                        return e.sent(), console.warn("It was not possible to play the video."), [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.prototype.decodeFromImage = function(t, e) {
        if (!t && !e) throw new $12c6b0ab9da17bee$var$f("either imageElement with a src set or an url must be provided");
        return e && !t ? this.decodeFromImageUrl(e) : this.decodeFromImageElement(t);
    }, t.prototype.decodeFromVideo = function(t, e) {
        if (!t && !e) throw new $12c6b0ab9da17bee$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrl(e) : this.decodeFromVideoElement(t);
    }, t.prototype.decodeFromVideoContinuously = function(t, e, r) {
        if (void 0 === t && void 0 === e) throw new $12c6b0ab9da17bee$var$f("Either an element with a src set or an URL must be provided");
        return e && !t ? this.decodeFromVideoUrlContinuously(e, r) : this.decodeFromVideoElementContinuously(t, r);
    }, t.prototype.decodeFromImageElement = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An image element must be provided.");
        this.reset();
        var e = this.prepareImageElement(t);
        return this.imageElement = e, this.isImageLoaded(e) ? this.decodeOnce(e, !1, !0) : this._decodeOnLoadImage(e);
    }, t.prototype.decodeFromVideoElement = function(t) {
        var e = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideo(e);
    }, t.prototype.decodeFromVideoElementContinuously = function(t, e) {
        var r = this._decodeFromVideoElementSetup(t);
        return this._decodeOnLoadVideoContinuously(r, e);
    }, t.prototype._decodeFromVideoElementSetup = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
        this.reset();
        var e = this.prepareVideoElement(t);
        return this.videoElement = e, e;
    }, t.prototype.decodeFromImageUrl = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareImageElement();
        this.imageElement = e;
        var r = this._decodeOnLoadImage(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrl = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var e = this.prepareVideoElement(), r = this.decodeFromVideoElement(e);
        return e.src = t, r;
    }, t.prototype.decodeFromVideoUrlContinuously = function(t, e) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
        this.reset();
        var r = this.prepareVideoElement(), n = this.decodeFromVideoElementContinuously(r, e);
        return r.src = t, n;
    }, t.prototype._decodeOnLoadImage = function(t) {
        var e = this;
        return new Promise(function(r, n) {
            e.imageLoadedListener = function() {
                return e.decodeOnce(t, !1, !0).then(r, n);
            }, t.addEventListener("load", e.imageLoadedListener);
        });
    }, t.prototype._decodeOnLoadVideo = function(t) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(e) {
                switch(e.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return e.sent(), [
                            4,
                            this.decodeOnce(t)
                        ];
                    case 2:
                        return [
                            2,
                            e.sent()
                        ];
                }
            });
        });
    }, t.prototype._decodeOnLoadVideoContinuously = function(t, e) {
        return $12c6b0ab9da17bee$var$Q(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$J(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            this.playVideoOnLoadAsync(t)
                        ];
                    case 1:
                        return r.sent(), this.decodeContinuously(t, e), [
                            2
                        ];
                }
            });
        });
    }, t.prototype.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.prototype.prepareImageElement = function(t) {
        var e;
        return void 0 === t && ((e = document.createElement("img")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "img")), t instanceof HTMLImageElement && (e = t), e;
    }, t.prototype.prepareVideoElement = function(t) {
        var e;
        return t || "undefined" == typeof document || ((e = document.createElement("video")).width = 200, e.height = 200), "string" == typeof t && (e = this.getMediaElement(t, "video")), t instanceof HTMLVideoElement && (e = t), e.setAttribute("autoplay", "true"), e.setAttribute("muted", "true"), e.setAttribute("playsinline", "true"), e;
    }, t.prototype.decodeOnce = function(t, e, r) {
        var n = this;
        void 0 === e && (e = !0), void 0 === r && (r = !0), this._stopAsyncDecode = !1;
        var o = function(i, a) {
            if (n._stopAsyncDecode) return a(new $12c6b0ab9da17bee$var$U("Video stream has ended before any code could be detected.")), void (n._stopAsyncDecode = void 0);
            try {
                i(n.decode(t));
            } catch (t) {
                if (e && t instanceof $12c6b0ab9da17bee$var$U || (t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R) && r) return setTimeout(o, n._timeBetweenDecodingAttempts, i, a);
                a(t);
            }
        };
        return new Promise(function(t, e) {
            return o(t, e);
        });
    }, t.prototype.decodeContinuously = function(t, e) {
        var r = this;
        this._stopContinuousDecode = !1;
        var n = function() {
            if (r._stopContinuousDecode) r._stopContinuousDecode = void 0;
            else try {
                var o = r.decode(t);
                e(o, null), setTimeout(n, r.timeBetweenScansMillis);
            } catch (t) {
                e(null, t), (t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$U) && setTimeout(n, r._timeBetweenDecodingAttempts);
            }
        };
        n();
    }, t.prototype.decode = function(t) {
        var e = this.createBinaryBitmap(t);
        return this.decodeBitmap(e);
    }, t.prototype.createBinaryBitmap = function(t) {
        var e = this.getCaptureCanvasContext(t);
        this.drawImageOnCanvas(e, t);
        var r = this.getCaptureCanvas(t), n = new $12c6b0ab9da17bee$var$K(r), o = new $12c6b0ab9da17bee$var$W(n);
        return new $12c6b0ab9da17bee$var$d(o);
    }, t.prototype.getCaptureCanvasContext = function(t) {
        if (!this.captureCanvasContext) {
            var e = this.getCaptureCanvas(t).getContext("2d");
            this.captureCanvasContext = e;
        }
        return this.captureCanvasContext;
    }, t.prototype.getCaptureCanvas = function(t) {
        if (!this.captureCanvas) {
            var e = this.createCaptureCanvas(t);
            this.captureCanvas = e;
        }
        return this.captureCanvas;
    }, t.prototype.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this._hints);
    }, t.prototype.createCaptureCanvas = function(t) {
        if ("undefined" == typeof document) return this._destroyCaptureCanvas(), null;
        var e, r, n = document.createElement("canvas");
        return void 0 !== t && (t instanceof HTMLVideoElement ? (e = t.videoWidth, r = t.videoHeight) : t instanceof HTMLImageElement && (e = t.naturalWidth || t.width, r = t.naturalHeight || t.height)), n.style.width = e + "px", n.style.height = r + "px", n.width = e, n.height = r, n;
    }, t.prototype.stopStreams = function() {
        this.stream && (this.stream.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), this.stream = void 0), !1 === this._stopAsyncDecode && this.stopAsyncDecode(), !1 === this._stopContinuousDecode && this.stopContinuousDecode();
    }, t.prototype.reset = function() {
        this.stopStreams(), this._destroyVideoElement(), this._destroyImageElement(), this._destroyCaptureCanvas();
    }, t.prototype._destroyVideoElement = function() {
        this.videoElement && (void 0 !== this.videoEndedListener && this.videoElement.removeEventListener("ended", this.videoEndedListener), void 0 !== this.videoPlayingEventListener && this.videoElement.removeEventListener("playing", this.videoPlayingEventListener), void 0 !== this.videoCanPlayListener && this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener), this.cleanVideoSource(this.videoElement), this.videoElement = void 0);
    }, t.prototype._destroyImageElement = function() {
        this.imageElement && (void 0 !== this.imageLoadedListener && this.imageElement.removeEventListener("load", this.imageLoadedListener), this.imageElement.src = void 0, this.imageElement.removeAttribute("src"), this.imageElement = void 0);
    }, t.prototype._destroyCaptureCanvas = function() {
        this.captureCanvasContext = void 0, this.captureCanvas = void 0;
    }, t.prototype.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.prototype.cleanVideoSource = function(t) {
        try {
            t.srcObject = null;
        } catch (e) {
            t.src = "";
        }
        this.videoElement.removeAttribute("src");
    }, t;
}(), $12c6b0ab9da17bee$var$et = function() {
    function t(t, e, r, n, o, i) {
        void 0 === r && (r = null == e ? 0 : 8 * e.length), void 0 === i && (i = $12c6b0ab9da17bee$var$w.currentTimeMillis()), this.text = t, this.rawBytes = e, this.numBits = r, this.resultPoints = n, this.format = o, this.timestamp = i, this.text = t, this.rawBytes = e, this.numBits = null == r ? null == e ? 0 : 8 * e.length : r, this.resultPoints = n, this.format = o, this.resultMetadata = null, this.timestamp = null == i ? $12c6b0ab9da17bee$var$w.currentTimeMillis() : i;
    }
    return t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.getBarcodeFormat = function() {
        return this.format;
    }, t.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    }, t.prototype.putMetadata = function(t, e) {
        null === this.resultMetadata && (this.resultMetadata = new Map), this.resultMetadata.set(t, e);
    }, t.prototype.putAllMetadata = function(t) {
        null !== t && (null === this.resultMetadata ? this.resultMetadata = t : this.resultMetadata = new Map(t));
    }, t.prototype.addResultPoints = function(t) {
        var e = this.resultPoints;
        if (null === e) this.resultPoints = t;
        else if (null !== t && t.length > 0) {
            var r = new Array(e.length + t.length);
            $12c6b0ab9da17bee$var$w.arraycopy(e, 0, r, 0, e.length), $12c6b0ab9da17bee$var$w.arraycopy(t, 0, r, e.length, t.length), this.resultPoints = r;
        }
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.toString = function() {
        return this.text;
    }, t;
}();
!function(t) {
    t[t.AZTEC = 0] = "AZTEC", t[t.CODABAR = 1] = "CODABAR", t[t.CODE_39 = 2] = "CODE_39", t[t.CODE_93 = 3] = "CODE_93", t[t.CODE_128 = 4] = "CODE_128", t[t.DATA_MATRIX = 5] = "DATA_MATRIX", t[t.EAN_8 = 6] = "EAN_8", t[t.EAN_13 = 7] = "EAN_13", t[t.ITF = 8] = "ITF", t[t.MAXICODE = 9] = "MAXICODE", t[t.PDF_417 = 10] = "PDF_417", t[t.QR_CODE = 11] = "QR_CODE", t[t.RSS_14 = 12] = "RSS_14", t[t.RSS_EXPANDED = 13] = "RSS_EXPANDED", t[t.UPC_A = 14] = "UPC_A", t[t.UPC_E = 15] = "UPC_E", t[t.UPC_EAN_EXTENSION = 16] = "UPC_EAN_EXTENSION";
}($12c6b0ab9da17bee$var$D || ($12c6b0ab9da17bee$var$D = {}));
var $12c6b0ab9da17bee$var$rt, $12c6b0ab9da17bee$var$nt = $12c6b0ab9da17bee$var$D;
!function(t) {
    t[t.OTHER = 0] = "OTHER", t[t.ORIENTATION = 1] = "ORIENTATION", t[t.BYTE_SEGMENTS = 2] = "BYTE_SEGMENTS", t[t.ERROR_CORRECTION_LEVEL = 3] = "ERROR_CORRECTION_LEVEL", t[t.ISSUE_NUMBER = 4] = "ISSUE_NUMBER", t[t.SUGGESTED_PRICE = 5] = "SUGGESTED_PRICE", t[t.POSSIBLE_COUNTRY = 6] = "POSSIBLE_COUNTRY", t[t.UPC_EAN_EXTENSION = 7] = "UPC_EAN_EXTENSION", t[t.PDF417_EXTRA_METADATA = 8] = "PDF417_EXTRA_METADATA", t[t.STRUCTURED_APPEND_SEQUENCE = 9] = "STRUCTURED_APPEND_SEQUENCE", t[t.STRUCTURED_APPEND_PARITY = 10] = "STRUCTURED_APPEND_PARITY";
}($12c6b0ab9da17bee$var$rt || ($12c6b0ab9da17bee$var$rt = {}));
var $12c6b0ab9da17bee$var$ot, $12c6b0ab9da17bee$var$it = $12c6b0ab9da17bee$var$rt, $12c6b0ab9da17bee$var$at = function() {
    function t(t, e, r, n, o, i) {
        void 0 === o && (o = -1), void 0 === i && (i = -1), this.rawBytes = t, this.text = e, this.byteSegments = r, this.ecLevel = n, this.structuredAppendSequenceNumber = o, this.structuredAppendParity = i, this.numBits = null == t ? 0 : 8 * t.length;
    }
    return t.prototype.getRawBytes = function() {
        return this.rawBytes;
    }, t.prototype.getNumBits = function() {
        return this.numBits;
    }, t.prototype.setNumBits = function(t) {
        this.numBits = t;
    }, t.prototype.getText = function() {
        return this.text;
    }, t.prototype.getByteSegments = function() {
        return this.byteSegments;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    }, t.prototype.setErrorsCorrected = function(t) {
        this.errorsCorrected = t;
    }, t.prototype.getErasures = function() {
        return this.erasures;
    }, t.prototype.setErasures = function(t) {
        this.erasures = t;
    }, t.prototype.getOther = function() {
        return this.other;
    }, t.prototype.setOther = function(t) {
        this.other = t;
    }, t.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    }, t.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    }, t.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    }, t;
}(), $12c6b0ab9da17bee$var$ut = function() {
    function t() {}
    return t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$l;
        return this.logTable[t];
    }, t.addOrSubtract = function(t, e) {
        return t ^ e;
    }, t;
}(), $12c6b0ab9da17bee$var$st = function() {
    function t(t, e) {
        if (0 === e.length) throw new $12c6b0ab9da17bee$var$l;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = Int32Array.from([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $12c6b0ab9da17bee$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        if (0 === t) return this.getCoefficient(0);
        var e, r = this.coefficients;
        if (1 === t) {
            e = 0;
            for(var n = 0, o = r.length; n !== o; n++){
                var i = r[n];
                e = $12c6b0ab9da17bee$var$ut.addOrSubtract(e, i);
            }
            return e;
        }
        e = r[0];
        var a = r.length, u = this.field;
        for(n = 1; n < a; n++)e = $12c6b0ab9da17bee$var$ut.addOrSubtract(u.multiply(t, e), r[n]);
        return e;
    }, t.prototype.addOrSubtract = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $12c6b0ab9da17bee$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = $12c6b0ab9da17bee$var$ut.addOrSubtract(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.multiply = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || e.isZero()) return this.field.getZero();
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = this.field, s = 0; s < n; s++)for(var c = r[s], f = 0; f < i; f++)a[s + f] = $12c6b0ab9da17bee$var$ut.addOrSubtract(a[s + f], u.multiply(c, o[f]));
        return new t(u, a);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return this.field.getZero();
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = this.field, o = new Int32Array(r), i = this.coefficients, a = 0; a < r; a++)o[a] = n.multiply(i[a], e);
        return new t(n, o);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === r) return this.field.getZero();
        for(var n = this.coefficients, o = n.length, i = new Int32Array(o + e), a = this.field, u = 0; u < o; u++)i[u] = a.multiply(n[u], r);
        return new t(a, i);
    }, t.prototype.divide = function(t) {
        if (!this.field.equals(t.field)) throw new $12c6b0ab9da17bee$var$l("GenericGFPolys do not have same GenericGF field");
        if (t.isZero()) throw new $12c6b0ab9da17bee$var$l("Divide by 0");
        for(var e = this.field, r = e.getZero(), n = this, o = t.getCoefficient(t.getDegree()), i = e.inverse(o); n.getDegree() >= t.getDegree() && !n.isZero();){
            var a = n.getDegree() - t.getDegree(), u = e.multiply(n.getCoefficient(n.getDegree()), i), s = t.multiplyByMonomial(a, u), c = e.buildMonomial(a, u);
            r = r.addOrSubtract(c), n = n.addOrSubtract(s);
        }
        return [
            r,
            n
        ];
    }, t.prototype.toString = function() {
        for(var t = "", e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            if (0 !== r) {
                if (r < 0 ? (t += " - ", r = -r) : t.length > 0 && (t += " + "), 0 === e || 1 !== r) {
                    var n = this.field.log(r);
                    0 === n ? t += "1" : 1 === n ? t += "a" : (t += "a^", t += n);
                }
                0 !== e && (1 === e ? t += "x" : (t += "x^", t += e));
            }
        }
        return t;
    }, t;
}(), $12c6b0ab9da17bee$var$ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ft = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$ct(e, t), e.kind = "ArithmeticException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$lt = function(t) {
    function e(e, r, n) {
        var o = t.call(this) || this;
        o.primitive = e, o.size = r, o.generatorBase = n;
        for(var i = new Int32Array(r), a = 1, u = 0; u < r; u++)i[u] = a, (a *= 2) >= r && (a ^= e, a &= r - 1);
        o.expTable = i;
        var s = new Int32Array(r);
        for(u = 0; u < r - 1; u++)s[i[u]] = u;
        return o.logTable = s, o.zero = new $12c6b0ab9da17bee$var$st(o, Int32Array.from([
            0
        ])), o.one = new $12c6b0ab9da17bee$var$st(o, Int32Array.from([
            1
        ])), o;
    }
    return $12c6b0ab9da17bee$var$ht(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $12c6b0ab9da17bee$var$st(this, r);
    }, e.prototype.inverse = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$ft;
        return this.expTable[this.size - this.logTable[t] - 1];
    }, e.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.size - 1)];
    }, e.prototype.getSize = function() {
        return this.size;
    }, e.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    }, e.prototype.toString = function() {
        return "GF(0x" + $12c6b0ab9da17bee$var$I.toHexString(this.primitive) + "," + this.size + ")";
    }, e.prototype.equals = function(t) {
        return t === this;
    }, e.AZTEC_DATA_12 = new e(4201, 4096, 1), e.AZTEC_DATA_10 = new e(1033, 1024, 1), e.AZTEC_DATA_6 = new e(67, 64, 1), e.AZTEC_PARAM = new e(19, 16, 1), e.QR_CODE_FIELD_256 = new e(285, 256, 0), e.DATA_MATRIX_FIELD_256 = new e(301, 256, 1), e.AZTEC_DATA_8 = e.DATA_MATRIX_FIELD_256, e.MAXICODE_FIELD_64 = e.AZTEC_DATA_6, e;
}($12c6b0ab9da17bee$var$ut), $12c6b0ab9da17bee$var$dt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$pt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$dt(e, t), e.kind = "ReedSolomonException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$gt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$yt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$gt(e, t), e.kind = "IllegalStateException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$wt = function() {
    function t(t) {
        this.field = t;
    }
    return t.prototype.decode = function(t, e) {
        for(var r = this.field, n = new $12c6b0ab9da17bee$var$st(r, t), o = new Int32Array(e), i = !0, a = 0; a < e; a++){
            var u = n.evaluateAt(r.exp(a + r.getGeneratorBase()));
            o[o.length - 1 - a] = u, 0 !== u && (i = !1);
        }
        if (!i) {
            var s = new $12c6b0ab9da17bee$var$st(r, o), c = this.runEuclideanAlgorithm(r.buildMonomial(e, 1), s, e), f = c[0], h = c[1], l = this.findErrorLocations(f), d = this.findErrorMagnitudes(h, l);
            for(a = 0; a < l.length; a++){
                var p = t.length - 1 - r.log(l[a]);
                if (p < 0) throw new $12c6b0ab9da17bee$var$pt("Bad error location");
                t[p] = $12c6b0ab9da17bee$var$lt.addOrSubtract(t[p], d[a]);
            }
        }
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = this.field, i = t, a = e, u = o.getZero(), s = o.getOne(); a.getDegree() >= (r / 2 | 0);){
            var c = i, f = u;
            if (u = s, (i = a).isZero()) throw new $12c6b0ab9da17bee$var$pt("r_{i-1} was zero");
            a = c;
            for(var h = o.getZero(), l = i.getCoefficient(i.getDegree()), d = o.inverse(l); a.getDegree() >= i.getDegree() && !a.isZero();){
                var p = a.getDegree() - i.getDegree(), g = o.multiply(a.getCoefficient(a.getDegree()), d);
                h = h.addOrSubtract(o.buildMonomial(p, g)), a = a.addOrSubtract(i.multiplyByMonomial(p, g));
            }
            if (s = h.multiply(u).addOrSubtract(f), a.getDegree() >= i.getDegree()) throw new $12c6b0ab9da17bee$var$yt("Division algorithm failed to reduce polynomial?");
        }
        var y = s.getCoefficient(0);
        if (0 === y) throw new $12c6b0ab9da17bee$var$pt("sigmaTilde(0) was zero");
        var w = o.inverse(y);
        return [
            s.multiplyScalar(w),
            a.multiplyScalar(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        var e = t.getDegree();
        if (1 === e) return Int32Array.from([
            t.getCoefficient(1)
        ]);
        for(var r = new Int32Array(e), n = 0, o = this.field, i = 1; i < o.getSize() && n < e; i++)0 === t.evaluateAt(i) && (r[n] = o.inverse(i), n++);
        if (n !== e) throw new $12c6b0ab9da17bee$var$pt("Error locator degree does not match number of roots");
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e) {
        for(var r = e.length, n = new Int32Array(r), o = this.field, i = 0; i < r; i++){
            for(var a = o.inverse(e[i]), u = 1, s = 0; s < r; s++)if (i !== s) {
                var c = o.multiply(e[s], a), f = 0 == (1 & c) ? 1 | c : -2 & c;
                u = o.multiply(u, f);
            }
            n[i] = o.multiply(t.evaluateAt(a), o.inverse(u)), 0 !== o.getGeneratorBase() && (n[i] = o.multiply(n[i], a));
        }
        return n;
    }, t;
}();
!function(t) {
    t[t.UPPER = 0] = "UPPER", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.DIGIT = 3] = "DIGIT", t[t.PUNCT = 4] = "PUNCT", t[t.BINARY = 5] = "BINARY";
}($12c6b0ab9da17bee$var$ot || ($12c6b0ab9da17bee$var$ot = {}));
var $12c6b0ab9da17bee$var$_t = function() {
    function t() {}
    return t.prototype.decode = function(e) {
        this.ddata = e;
        var r = e.getBits(), n = this.extractBits(r), o = this.correctBits(n), i = t.convertBoolArrayToByteArray(o), a = t.getEncodedData(o), u = new $12c6b0ab9da17bee$var$at(i, a, null, null);
        return u.setNumBits(o.length), u;
    }, t.highLevelDecode = function(t) {
        return this.getEncodedData(t);
    }, t.getEncodedData = function(e) {
        for(var r = e.length, n = $12c6b0ab9da17bee$var$ot.UPPER, o = $12c6b0ab9da17bee$var$ot.UPPER, i = "", a = 0; a < r;)if (o === $12c6b0ab9da17bee$var$ot.BINARY) {
            if (r - a < 5) break;
            var u = t.readCode(e, a, 5);
            if (a += 5, 0 === u) {
                if (r - a < 11) break;
                u = t.readCode(e, a, 11) + 31, a += 11;
            }
            for(var s = 0; s < u; s++){
                if (r - a < 8) {
                    a = r;
                    break;
                }
                var c = t.readCode(e, a, 8);
                i += $12c6b0ab9da17bee$var$F.castAsNonUtf8Char(c), a += 8;
            }
            o = n;
        } else {
            var f = o === $12c6b0ab9da17bee$var$ot.DIGIT ? 4 : 5;
            if (r - a < f) break;
            c = t.readCode(e, a, f);
            a += f;
            var h = t.getCharacter(o, c);
            h.startsWith("CTRL_") ? (n = o, o = t.getTable(h.charAt(5)), "L" === h.charAt(6) && (n = o)) : (i += h, o = n);
        }
        return i;
    }, t.getTable = function(t) {
        switch(t){
            case "L":
                return $12c6b0ab9da17bee$var$ot.LOWER;
            case "P":
                return $12c6b0ab9da17bee$var$ot.PUNCT;
            case "M":
                return $12c6b0ab9da17bee$var$ot.MIXED;
            case "D":
                return $12c6b0ab9da17bee$var$ot.DIGIT;
            case "B":
                return $12c6b0ab9da17bee$var$ot.BINARY;
            default:
                return $12c6b0ab9da17bee$var$ot.UPPER;
        }
    }, t.getCharacter = function(e, r) {
        switch(e){
            case $12c6b0ab9da17bee$var$ot.UPPER:
                return t.UPPER_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.LOWER:
                return t.LOWER_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.MIXED:
                return t.MIXED_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.PUNCT:
                return t.PUNCT_TABLE[r];
            case $12c6b0ab9da17bee$var$ot.DIGIT:
                return t.DIGIT_TABLE[r];
            default:
                throw new $12c6b0ab9da17bee$var$yt("Bad table");
        }
    }, t.prototype.correctBits = function(e) {
        var r, n;
        this.ddata.getNbLayers() <= 2 ? (n = 6, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_6) : this.ddata.getNbLayers() <= 8 ? (n = 8, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_8) : this.ddata.getNbLayers() <= 22 ? (n = 10, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_10) : (n = 12, r = $12c6b0ab9da17bee$var$lt.AZTEC_DATA_12);
        var o = this.ddata.getNbDatablocks(), i = e.length / n;
        if (i < o) throw new $12c6b0ab9da17bee$var$R;
        for(var a = e.length % n, u = new Int32Array(i), s = 0; s < i; s++, a += n)u[s] = t.readCode(e, a, n);
        try {
            new $12c6b0ab9da17bee$var$wt(r).decode(u, i - o);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
        var c = (1 << n) - 1, f = 0;
        for(s = 0; s < o; s++){
            if (0 === (d = u[s]) || d === c) throw new $12c6b0ab9da17bee$var$R;
            1 !== d && d !== c - 1 || f++;
        }
        var h = new Array(o * n - f), l = 0;
        for(s = 0; s < o; s++){
            var d;
            if (1 === (d = u[s]) || d === c - 1) h.fill(d > 1, l, l + n - 1), l += n - 1;
            else for(var p = n - 1; p >= 0; --p)h[l++] = 0 != (d & 1 << p);
        }
        return h;
    }, t.prototype.extractBits = function(t) {
        var e = this.ddata.isCompact(), r = this.ddata.getNbLayers(), n = (e ? 11 : 14) + 4 * r, o = new Int32Array(n), i = new Array(this.totalBitsInLayer(r, e));
        if (e) for(var a = 0; a < o.length; a++)o[a] = a;
        else {
            var u = n + 1 + 2 * $12c6b0ab9da17bee$var$I.truncDivision($12c6b0ab9da17bee$var$I.truncDivision(n, 2) - 1, 15), s = n / 2, c = $12c6b0ab9da17bee$var$I.truncDivision(u, 2);
            for(a = 0; a < s; a++){
                var f = a + $12c6b0ab9da17bee$var$I.truncDivision(a, 15);
                o[s - a - 1] = c - f - 1, o[s + a] = c + f + 1;
            }
        }
        a = 0;
        for(var h = 0; a < r; a++){
            for(var l = 4 * (r - a) + (e ? 9 : 12), d = 2 * a, p = n - 1 - d, g = 0; g < l; g++)for(var y = 2 * g, w = 0; w < 2; w++)i[h + y + w] = t.get(o[d + w], o[d + g]), i[h + 2 * l + y + w] = t.get(o[d + g], o[p - w]), i[h + 4 * l + y + w] = t.get(o[p - w], o[p - g]), i[h + 6 * l + y + w] = t.get(o[p - g], o[d + w]);
            h += 8 * l;
        }
        return i;
    }, t.readCode = function(t, e, r) {
        for(var n = 0, o = e; o < e + r; o++)n <<= 1, t[o] && (n |= 1);
        return n;
    }, t.readByte = function(e, r) {
        var n = e.length - r;
        return n >= 8 ? t.readCode(e, r, 8) : t.readCode(e, r, n) << 8 - n;
    }, t.convertBoolArrayToByteArray = function(e) {
        for(var r = new Uint8Array((e.length + 7) / 8), n = 0; n < r.length; n++)r[n] = t.readByte(e, 8 * n);
        return r;
    }, t.prototype.totalBitsInLayer = function(t, e) {
        return ((e ? 88 : 112) + 16 * t) * t;
    }, t.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ], t.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\\1",
        "\\2",
        "\\3",
        "\\4",
        "\\5",
        "\\6",
        "\\7",
        "\b",
        "	",
        "\n",
        "\\13",
        "\f",
        "\r",
        "\\33",
        "\\34",
        "\\35",
        "\\36",
        "\\37",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\\177",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ], t.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ], t.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ], t;
}(), $12c6b0ab9da17bee$var$vt = function() {
    function t() {}
    return t.round = function(t) {
        return t <= Number.MIN_SAFE_INTEGER ? Number.MIN_SAFE_INTEGER : t >= Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : t + (t < 0 ? -0.5 : .5) | 0;
    }, t.distance = function(t, e, r, n) {
        var o = t - r, i = e - n;
        return Math.sqrt(o * o + i * i);
    }, t.sum = function(t) {
        for(var e = 0, r = 0, n = t.length; r !== n; r++)e += t[r];
        return e;
    }, t;
}(), $12c6b0ab9da17bee$var$mt = function() {
    function t() {}
    return t.floatToIntBits = function(t) {
        return t;
    }, t.MAX_VALUE = Number.MAX_SAFE_INTEGER, t;
}(), $12c6b0ab9da17bee$var$At = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t.prototype.equals = function(e) {
        if (e instanceof t) {
            var r = e;
            return this.x === r.x && this.y === r.y;
        }
        return !1;
    }, t.prototype.hashCode = function() {
        return 31 * $12c6b0ab9da17bee$var$mt.floatToIntBits(this.x) + $12c6b0ab9da17bee$var$mt.floatToIntBits(this.y);
    }, t.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    }, t.orderBestPatterns = function(t) {
        var e, r, n, o = this.distance(t[0], t[1]), i = this.distance(t[1], t[2]), a = this.distance(t[0], t[2]);
        if (i >= o && i >= a ? (r = t[0], e = t[1], n = t[2]) : a >= i && a >= o ? (r = t[1], e = t[0], n = t[2]) : (r = t[2], e = t[0], n = t[1]), this.crossProductZ(e, r, n) < 0) {
            var u = e;
            e = n, n = u;
        }
        t[0] = e, t[1] = r, t[2] = n;
    }, t.distance = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.x, t.y, e.x, e.y);
    }, t.crossProductZ = function(t, e, r) {
        var n = e.x, o = e.y;
        return (r.x - n) * (t.y - o) - (r.y - o) * (t.x - n);
    }, t;
}(), $12c6b0ab9da17bee$var$Et = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $12c6b0ab9da17bee$var$Ct = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$It = function(t) {
    function e(e, r, n, o, i) {
        var a = t.call(this, e, r) || this;
        return a.compact = n, a.nbDatablocks = o, a.nbLayers = i, a;
    }
    return $12c6b0ab9da17bee$var$Ct(e, t), e.prototype.getNbLayers = function() {
        return this.nbLayers;
    }, e.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    }, e.prototype.isCompact = function() {
        return this.compact;
    }, e;
}($12c6b0ab9da17bee$var$Et), $12c6b0ab9da17bee$var$St = function() {
    function t(e, r, n, o) {
        this.image = e, this.height = e.getHeight(), this.width = e.getWidth(), null == r && (r = t.INIT_SIZE), null == n && (n = e.getWidth() / 2 | 0), null == o && (o = e.getHeight() / 2 | 0);
        var i = r / 2 | 0;
        if (this.leftInit = n - i, this.rightInit = n + i, this.upInit = o - i, this.downInit = o + i, this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new $12c6b0ab9da17bee$var$U;
    }
    return t.prototype.detect = function() {
        for(var t = this.leftInit, e = this.rightInit, r = this.upInit, n = this.downInit, o = !1, i = !0, a = !1, u = !1, s = !1, c = !1, f = !1, h = this.width, l = this.height; i;){
            i = !1;
            for(var d = !0; (d || !u) && e < h;)(d = this.containsBlackPoint(r, n, e, !1)) ? (e++, i = !0, u = !0) : u || e++;
            if (e >= h) {
                o = !0;
                break;
            }
            for(var p = !0; (p || !s) && n < l;)(p = this.containsBlackPoint(t, e, n, !0)) ? (n++, i = !0, s = !0) : s || n++;
            if (n >= l) {
                o = !0;
                break;
            }
            for(var g = !0; (g || !c) && t >= 0;)(g = this.containsBlackPoint(r, n, t, !1)) ? (t--, i = !0, c = !0) : c || t--;
            if (t < 0) {
                o = !0;
                break;
            }
            for(var y = !0; (y || !f) && r >= 0;)(y = this.containsBlackPoint(t, e, r, !0)) ? (r--, i = !0, f = !0) : f || r--;
            if (r < 0) {
                o = !0;
                break;
            }
            i && (a = !0);
        }
        if (!o && a) {
            for(var w = e - t, _ = null, v = 1; null === _ && v < w; v++)_ = this.getBlackPointOnSegment(t, n - v, t + v, n);
            if (null == _) throw new $12c6b0ab9da17bee$var$U;
            var m = null;
            for(v = 1; null === m && v < w; v++)m = this.getBlackPointOnSegment(t, r + v, t + v, r);
            if (null == m) throw new $12c6b0ab9da17bee$var$U;
            var A = null;
            for(v = 1; null === A && v < w; v++)A = this.getBlackPointOnSegment(e, r + v, e - v, r);
            if (null == A) throw new $12c6b0ab9da17bee$var$U;
            var E = null;
            for(v = 1; null === E && v < w; v++)E = this.getBlackPointOnSegment(e, n - v, e - v, n);
            if (null == E) throw new $12c6b0ab9da17bee$var$U;
            return this.centerEdges(E, _, A, m);
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.prototype.getBlackPointOnSegment = function(t, e, r, n) {
        for(var o = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$vt.distance(t, e, r, n)), i = (r - t) / o, a = (n - e) / o, u = this.image, s = 0; s < o; s++){
            var c = $12c6b0ab9da17bee$var$vt.round(t + s * i), f = $12c6b0ab9da17bee$var$vt.round(e + s * a);
            if (u.get(c, f)) return new $12c6b0ab9da17bee$var$At(c, f);
        }
        return null;
    }, t.prototype.centerEdges = function(e, r, n, o) {
        var i = e.getX(), a = e.getY(), u = r.getX(), s = r.getY(), c = n.getX(), f = n.getY(), h = o.getX(), l = o.getY(), d = t.CORR;
        return i < this.width / 2 ? [
            new $12c6b0ab9da17bee$var$At(h - d, l + d),
            new $12c6b0ab9da17bee$var$At(u + d, s + d),
            new $12c6b0ab9da17bee$var$At(c - d, f - d),
            new $12c6b0ab9da17bee$var$At(i + d, a - d)
        ] : [
            new $12c6b0ab9da17bee$var$At(h + d, l + d),
            new $12c6b0ab9da17bee$var$At(u + d, s - d),
            new $12c6b0ab9da17bee$var$At(c - d, f + d),
            new $12c6b0ab9da17bee$var$At(i - d, a - d)
        ];
    }, t.prototype.containsBlackPoint = function(t, e, r, n) {
        var o = this.image;
        if (n) {
            for(var i = t; i <= e; i++)if (o.get(i, r)) return !0;
        } else for(var a = t; a <= e; a++)if (o.get(r, a)) return !0;
        return !1;
    }, t.INIT_SIZE = 10, t.CORR = 1, t;
}(), $12c6b0ab9da17bee$var$Ot = function() {
    function t() {}
    return t.checkAndNudgePoints = function(t, e) {
        for(var r = t.getWidth(), n = t.getHeight(), o = !0, i = 0; i < e.length && o; i += 2){
            var a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $12c6b0ab9da17bee$var$U;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
        o = !0;
        for(i = e.length - 2; i >= 0 && o; i -= 2){
            a = Math.floor(e[i]), u = Math.floor(e[i + 1]);
            if (a < -1 || a > r || u < -1 || u > n) throw new $12c6b0ab9da17bee$var$U;
            o = !1, -1 === a ? (e[i] = 0, o = !0) : a === r && (e[i] = r - 1, o = !0), -1 === u ? (e[i + 1] = 0, o = !0) : u === n && (e[i + 1] = n - 1, o = !0);
        }
    }, t;
}(), $12c6b0ab9da17bee$var$Tt = function() {
    function t(t, e, r, n, o, i, a, u, s) {
        this.a11 = t, this.a21 = e, this.a31 = r, this.a12 = n, this.a22 = o, this.a32 = i, this.a13 = a, this.a23 = u, this.a33 = s;
    }
    return t.quadrilateralToQuadrilateral = function(e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y) {
        var w = t.quadrilateralToSquare(e, r, n, o, i, a, u, s);
        return t.squareToQuadrilateral(c, f, h, l, d, p, g, y).times(w);
    }, t.prototype.transformPoints = function(t) {
        for(var e = t.length, r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = 0; h < e; h += 2){
            var l = t[h], d = t[h + 1], p = o * l + u * d + f;
            t[h] = (r * l + i * d + s) / p, t[h + 1] = (n * l + a * d + c) / p;
        }
    }, t.prototype.transformPointsWithValues = function(t, e) {
        for(var r = this.a11, n = this.a12, o = this.a13, i = this.a21, a = this.a22, u = this.a23, s = this.a31, c = this.a32, f = this.a33, h = t.length, l = 0; l < h; l++){
            var d = t[l], p = e[l], g = o * d + u * p + f;
            t[l] = (r * d + i * p + s) / g, e[l] = (n * d + a * p + c) / g;
        }
    }, t.squareToQuadrilateral = function(e, r, n, o, i, a, u, s) {
        var c = e - n + i - u, f = r - o + a - s;
        if (0 === c && 0 === f) return new t(n - e, i - n, e, o - r, a - o, r, 0, 0, 1);
        var h = n - i, l = u - i, d = o - a, p = s - a, g = h * p - l * d, y = (c * p - l * f) / g, w = (h * f - c * d) / g;
        return new t(n - e + y * n, u - e + w * u, e, o - r + y * o, s - r + w * s, r, y, w, 1);
    }, t.quadrilateralToSquare = function(e, r, n, o, i, a, u, s) {
        return t.squareToQuadrilateral(e, r, n, o, i, a, u, s).buildAdjoint();
    }, t.prototype.buildAdjoint = function() {
        return new t(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    }, t.prototype.times = function(e) {
        return new t(this.a11 * e.a11 + this.a21 * e.a12 + this.a31 * e.a13, this.a11 * e.a21 + this.a21 * e.a22 + this.a31 * e.a23, this.a11 * e.a31 + this.a21 * e.a32 + this.a31 * e.a33, this.a12 * e.a11 + this.a22 * e.a12 + this.a32 * e.a13, this.a12 * e.a21 + this.a22 * e.a22 + this.a32 * e.a23, this.a12 * e.a31 + this.a22 * e.a32 + this.a32 * e.a33, this.a13 * e.a11 + this.a23 * e.a12 + this.a33 * e.a13, this.a13 * e.a21 + this.a23 * e.a22 + this.a33 * e.a23, this.a13 * e.a31 + this.a23 * e.a32 + this.a33 * e.a33);
    }, t;
}(), $12c6b0ab9da17bee$var$bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Rt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$bt(e, t), e.prototype.sampleGrid = function(t, e, r, n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _) {
        var v = $12c6b0ab9da17bee$var$Tt.quadrilateralToQuadrilateral(n, o, i, a, u, s, c, f, h, l, d, p, g, y, w, _);
        return this.sampleGridWithTransform(t, e, r, v);
    }, e.prototype.sampleGridWithTransform = function(t, e, r, n) {
        if (e <= 0 || r <= 0) throw new $12c6b0ab9da17bee$var$U;
        for(var o = new $12c6b0ab9da17bee$var$x(e, r), i = new Float32Array(2 * e), a = 0; a < r; a++){
            for(var u = i.length, s = a + .5, c = 0; c < u; c += 2)i[c] = c / 2 + .5, i[c + 1] = s;
            n.transformPoints(i), $12c6b0ab9da17bee$var$Ot.checkAndNudgePoints(t, i);
            try {
                for(c = 0; c < u; c += 2)t.get(Math.floor(i[c]), Math.floor(i[c + 1])) && o.set(c / 2, a);
            } catch (t) {
                throw new $12c6b0ab9da17bee$var$U;
            }
        }
        return o;
    }, e;
}($12c6b0ab9da17bee$var$Ot), $12c6b0ab9da17bee$var$Nt = function() {
    function t() {}
    return t.setGridSampler = function(e) {
        t.gridSampler = e;
    }, t.getInstance = function() {
        return t.gridSampler;
    }, t.gridSampler = new $12c6b0ab9da17bee$var$Rt, t;
}(), $12c6b0ab9da17bee$var$Dt = function() {
    function t(t, e) {
        this.x = t, this.y = e;
    }
    return t.prototype.toResultPoint = function() {
        return new $12c6b0ab9da17bee$var$At(this.getX(), this.getY());
    }, t.prototype.getX = function() {
        return this.x;
    }, t.prototype.getY = function() {
        return this.y;
    }, t;
}(), $12c6b0ab9da17bee$var$Pt = function() {
    function t(t) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            3808,
            476,
            2107,
            1799
        ]), this.image = t;
    }
    return t.prototype.detect = function() {
        return this.detectMirror(!1);
    }, t.prototype.detectMirror = function(t) {
        var e = this.getMatrixCenter(), r = this.getBullsEyeCorners(e);
        if (t) {
            var n = r[0];
            r[0] = r[2], r[2] = n;
        }
        this.extractParameters(r);
        var o = this.sampleGrid(this.image, r[this.shift % 4], r[(this.shift + 1) % 4], r[(this.shift + 2) % 4], r[(this.shift + 3) % 4]), i = this.getMatrixCornerPoints(r);
        return new $12c6b0ab9da17bee$var$It(o, i, this.compact, this.nbDataBlocks, this.nbLayers);
    }, t.prototype.extractParameters = function(t) {
        if (!(this.isValidPoint(t[0]) && this.isValidPoint(t[1]) && this.isValidPoint(t[2]) && this.isValidPoint(t[3]))) throw new $12c6b0ab9da17bee$var$U;
        var e = 2 * this.nbCenterLayers, r = new Int32Array([
            this.sampleLine(t[0], t[1], e),
            this.sampleLine(t[1], t[2], e),
            this.sampleLine(t[2], t[3], e),
            this.sampleLine(t[3], t[0], e)
        ]);
        this.shift = this.getRotation(r, e);
        for(var n = 0, o = 0; o < 4; o++){
            var i = r[(this.shift + o) % 4];
            this.compact ? (n <<= 7, n += i >> 1 & 127) : (n <<= 10, n += (i >> 2 & 992) + (i >> 1 & 31));
        }
        var a = this.getCorrectedParameterData(n, this.compact);
        this.compact ? (this.nbLayers = 1 + (a >> 6), this.nbDataBlocks = 1 + (63 & a)) : (this.nbLayers = 1 + (a >> 11), this.nbDataBlocks = 1 + (2047 & a));
    }, t.prototype.getRotation = function(t, e) {
        var r = 0;
        t.forEach(function(t, n, o) {
            r = (r << 3) + ((t >> e - 2 << 1) + (1 & t));
        }), r = ((1 & r) << 11) + (r >> 1);
        for(var n = 0; n < 4; n++)if ($12c6b0ab9da17bee$var$I.bitCount(r ^ this.EXPECTED_CORNER_BITS[n]) <= 2) return n;
        throw new $12c6b0ab9da17bee$var$U;
    }, t.prototype.getCorrectedParameterData = function(t, e) {
        var r, n;
        e ? (r = 7, n = 2) : (r = 10, n = 4);
        for(var o = r - n, i = new Int32Array(r), a = r - 1; a >= 0; --a)i[a] = 15 & t, t >>= 4;
        try {
            new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.AZTEC_PARAM).decode(i, o);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$U;
        }
        var u = 0;
        for(a = 0; a < n; a++)u = (u << 4) + i[a];
        return u;
    }, t.prototype.getBullsEyeCorners = function(t) {
        var e = t, r = t, n = t, o = t, i = !0;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var a = this.getFirstDifferent(e, i, 1, -1), u = this.getFirstDifferent(r, i, 1, 1), s = this.getFirstDifferent(n, i, -1, 1), c = this.getFirstDifferent(o, i, -1, -1);
            if (this.nbCenterLayers > 2) {
                var f = this.distancePoint(c, a) * this.nbCenterLayers / (this.distancePoint(o, e) * (this.nbCenterLayers + 2));
                if (f < .75 || f > 1.25 || !this.isWhiteOrBlackRectangle(a, u, s, c)) break;
            }
            e = a, r = u, n = s, o = c, i = !i;
        }
        if (5 !== this.nbCenterLayers && 7 !== this.nbCenterLayers) throw new $12c6b0ab9da17bee$var$U;
        this.compact = 5 === this.nbCenterLayers;
        var h = new $12c6b0ab9da17bee$var$At(e.getX() + .5, e.getY() - .5), l = new $12c6b0ab9da17bee$var$At(r.getX() + .5, r.getY() + .5), d = new $12c6b0ab9da17bee$var$At(n.getX() - .5, n.getY() + .5), p = new $12c6b0ab9da17bee$var$At(o.getX() - .5, o.getY() - .5);
        return this.expandSquare([
            h,
            l,
            d,
            p
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    }, t.prototype.getMatrixCenter = function() {
        var t, e, r, n;
        try {
            t = (s = new $12c6b0ab9da17bee$var$St(this.image).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (a) {
            var o = this.image.getWidth() / 2, i = this.image.getHeight() / 2;
            t = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o + 7, i - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o + 7, i + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o - 7, i + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(o - 7, i - 7), !1, -1, -1).toResultPoint();
        }
        var a = $12c6b0ab9da17bee$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $12c6b0ab9da17bee$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4);
        try {
            var s;
            t = (s = new $12c6b0ab9da17bee$var$St(this.image, 15, a, u).detect())[0], e = s[1], r = s[2], n = s[3];
        } catch (o) {
            t = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a + 7, u - 7), !1, 1, -1).toResultPoint(), e = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a + 7, u + 7), !1, 1, 1).toResultPoint(), r = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a - 7, u + 7), !1, -1, 1).toResultPoint(), n = this.getFirstDifferent(new $12c6b0ab9da17bee$var$Dt(a - 7, u - 7), !1, -1, -1).toResultPoint();
        }
        return a = $12c6b0ab9da17bee$var$vt.round((t.getX() + n.getX() + e.getX() + r.getX()) / 4), u = $12c6b0ab9da17bee$var$vt.round((t.getY() + n.getY() + e.getY() + r.getY()) / 4), new $12c6b0ab9da17bee$var$Dt(a, u);
    }, t.prototype.getMatrixCornerPoints = function(t) {
        return this.expandSquare(t, 2 * this.nbCenterLayers, this.getDimension());
    }, t.prototype.sampleGrid = function(t, e, r, n, o) {
        var i = $12c6b0ab9da17bee$var$Nt.getInstance(), a = this.getDimension(), u = a / 2 - this.nbCenterLayers, s = a / 2 + this.nbCenterLayers;
        return i.sampleGrid(t, a, a, u, u, s, u, s, s, u, s, e.getX(), e.getY(), r.getX(), r.getY(), n.getX(), n.getY(), o.getX(), o.getY());
    }, t.prototype.sampleLine = function(t, e, r) {
        for(var n = 0, o = this.distanceResultPoint(t, e), i = o / r, a = t.getX(), u = t.getY(), s = i * (e.getX() - t.getX()) / o, c = i * (e.getY() - t.getY()) / o, f = 0; f < r; f++)this.image.get($12c6b0ab9da17bee$var$vt.round(a + f * s), $12c6b0ab9da17bee$var$vt.round(u + f * c)) && (n |= 1 << r - f - 1);
        return n;
    }, t.prototype.isWhiteOrBlackRectangle = function(t, e, r, n) {
        t = new $12c6b0ab9da17bee$var$Dt(t.getX() - 3, t.getY() + 3), e = new $12c6b0ab9da17bee$var$Dt(e.getX() - 3, e.getY() - 3), r = new $12c6b0ab9da17bee$var$Dt(r.getX() + 3, r.getY() - 3), n = new $12c6b0ab9da17bee$var$Dt(n.getX() + 3, n.getY() + 3);
        var o = this.getColor(n, t);
        if (0 === o) return !1;
        var i = this.getColor(t, e);
        return i === o && (i = this.getColor(e, r)) === o && (i = this.getColor(r, n)) === o;
    }, t.prototype.getColor = function(t, e) {
        for(var r = this.distancePoint(t, e), n = (e.getX() - t.getX()) / r, o = (e.getY() - t.getY()) / r, i = 0, a = t.getX(), u = t.getY(), s = this.image.get(t.getX(), t.getY()), c = Math.ceil(r), f = 0; f < c; f++)a += n, u += o, this.image.get($12c6b0ab9da17bee$var$vt.round(a), $12c6b0ab9da17bee$var$vt.round(u)) !== s && i++;
        var h = i / r;
        return h > .1 && h < .9 ? 0 : h <= .1 === s ? 1 : -1;
    }, t.prototype.getFirstDifferent = function(t, e, r, n) {
        for(var o = t.getX() + r, i = t.getY() + n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r, i += n;
        for(o -= r, i -= n; this.isValid(o, i) && this.image.get(o, i) === e;)o += r;
        for(o -= r; this.isValid(o, i) && this.image.get(o, i) === e;)i += n;
        return new $12c6b0ab9da17bee$var$Dt(o, i -= n);
    }, t.prototype.expandSquare = function(t, e, r) {
        var n = r / (2 * e), o = t[0].getX() - t[2].getX(), i = t[0].getY() - t[2].getY(), a = (t[0].getX() + t[2].getX()) / 2, u = (t[0].getY() + t[2].getY()) / 2, s = new $12c6b0ab9da17bee$var$At(a + n * o, u + n * i), c = new $12c6b0ab9da17bee$var$At(a - n * o, u - n * i);
        return o = t[1].getX() - t[3].getX(), i = t[1].getY() - t[3].getY(), a = (t[1].getX() + t[3].getX()) / 2, u = (t[1].getY() + t[3].getY()) / 2, [
            s,
            new $12c6b0ab9da17bee$var$At(a + n * o, u + n * i),
            c,
            new $12c6b0ab9da17bee$var$At(a - n * o, u - n * i)
        ];
    }, t.prototype.isValid = function(t, e) {
        return t >= 0 && t < this.image.getWidth() && e > 0 && e < this.image.getHeight();
    }, t.prototype.isValidPoint = function(t) {
        var e = $12c6b0ab9da17bee$var$vt.round(t.getX()), r = $12c6b0ab9da17bee$var$vt.round(t.getY());
        return this.isValid(e, r);
    }, t.prototype.distancePoint = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.distanceResultPoint = function(t, e) {
        return $12c6b0ab9da17bee$var$vt.distance(t.getX(), t.getY(), e.getX(), e.getY());
    }, t.prototype.getDimension = function() {
        return this.compact ? 4 * this.nbLayers + 11 : this.nbLayers <= 4 ? 4 * this.nbLayers + 15 : 4 * this.nbLayers + 2 * ($12c6b0ab9da17bee$var$I.truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    }, t;
}(), $12c6b0ab9da17bee$var$Mt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        void 0 === e && (e = null);
        var r = null, n = new $12c6b0ab9da17bee$var$Pt(t.getBlackMatrix()), o = null, i = null;
        try {
            o = (a = n.detectMirror(!1)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $12c6b0ab9da17bee$var$_t).decode(a);
        } catch (t) {
            r = t;
        }
        if (null == i) try {
            var a;
            o = (a = n.detectMirror(!0)).getPoints(), this.reportFoundResultPoints(e, o), i = (new $12c6b0ab9da17bee$var$_t).decode(a);
        } catch (t) {
            if (null != r) throw r;
            throw t;
        }
        var u = new $12c6b0ab9da17bee$var$et(i.getText(), i.getRawBytes(), i.getNumBits(), o, $12c6b0ab9da17bee$var$nt.AZTEC, $12c6b0ab9da17bee$var$w.currentTimeMillis()), s = i.getByteSegments();
        null != s && u.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, s);
        var c = i.getECLevel();
        return null != c && u.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, c), u;
    }, t.prototype.reportFoundResultPoints = function(t, e) {
        if (null != t) {
            var r = t.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
            null != r && e.forEach(function(t, e, n) {
                r.foundPossibleResultPoint(t);
            });
        }
    }, t.prototype.reset = function() {}, t;
}(), $12c6b0ab9da17bee$var$Bt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Mt, e) || this;
    }
    $12c6b0ab9da17bee$var$Bt(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$Lt = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        try {
            return this.doDecode(t, e);
        } catch (c) {
            if (e && !0 === e.get($12c6b0ab9da17bee$var$T.TRY_HARDER) && t.isRotateSupported()) {
                var r = t.rotateCounterClockwise(), n = this.doDecode(r, e), o = n.getResultMetadata(), i = 270;
                null !== o && !0 === o.get($12c6b0ab9da17bee$var$it.ORIENTATION) && (i += o.get($12c6b0ab9da17bee$var$it.ORIENTATION) % 360), n.putMetadata($12c6b0ab9da17bee$var$it.ORIENTATION, i);
                var a = n.getResultPoints();
                if (null !== a) for(var u = r.getHeight(), s = 0; s < a.length; s++)a[s] = new $12c6b0ab9da17bee$var$At(u - a[s].getY() - 1, a[s].getX());
                return n;
            }
            throw new $12c6b0ab9da17bee$var$U;
        }
    }, t.prototype.reset = function() {}, t.prototype.doDecode = function(t, e) {
        var r, n = t.getWidth(), o = t.getHeight(), i = new $12c6b0ab9da17bee$var$S(n), a = e && !0 === e.get($12c6b0ab9da17bee$var$T.TRY_HARDER), u = Math.max(1, o >> (a ? 8 : 5));
        r = a ? o : 15;
        for(var s = Math.trunc(o / 2), c = 0; c < r; c++){
            var f = Math.trunc((c + 1) / 2), h = s + u * (0 == (1 & c) ? f : -f);
            if (h < 0 || h >= o) break;
            try {
                i = t.getBlackRow(h, i);
            } catch (t) {
                continue;
            }
            for(var l = function(t) {
                if (1 === t && (i.reverse(), e && !0 === e.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK))) {
                    var r = new Map;
                    e.forEach(function(t, e) {
                        return r.set(e, t);
                    }), r.delete($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK), e = r;
                }
                try {
                    var o = d.decodeRow(h, i, e);
                    if (1 === t) {
                        o.putMetadata($12c6b0ab9da17bee$var$it.ORIENTATION, 180);
                        var a = o.getResultPoints();
                        null !== a && (a[0] = new $12c6b0ab9da17bee$var$At(n - a[0].getX() - 1, a[0].getY()), a[1] = new $12c6b0ab9da17bee$var$At(n - a[1].getX() - 1, a[1].getY()));
                    }
                    return {
                        value: o
                    };
                } catch (t) {}
            }, d = this, p = 0; p < 2; p++){
                var g = l(p);
                if ("object" == typeof g) return g.value;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.recordPattern = function(t, e, r) {
        for(var n = r.length, o = 0; o < n; o++)r[o] = 0;
        var i = t.getSize();
        if (e >= i) throw new $12c6b0ab9da17bee$var$U;
        for(var a = !t.get(e), u = 0, s = e; s < i;){
            if (t.get(s) !== a) r[u]++;
            else {
                if (++u === n) break;
                r[u] = 1, a = !a;
            }
            s++;
        }
        if (u !== n && (u !== n - 1 || s !== i)) throw new $12c6b0ab9da17bee$var$U;
    }, t.recordPatternInReverse = function(e, r, n) {
        for(var o = n.length, i = e.get(r); r > 0 && o >= 0;)e.get(--r) !== i && (o--, i = !i);
        if (o >= 0) throw new $12c6b0ab9da17bee$var$U;
        t.recordPattern(e, r + 1, n);
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return Number.POSITIVE_INFINITY;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return Number.POSITIVE_INFINITY;
            s += l;
        }
        return s / o;
    }, t;
}(), $12c6b0ab9da17bee$var$Ft = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$kt = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Ft(e, t), e.findStartPattern = function(t) {
        for(var r = t.getSize(), n = t.getNextSet(0), o = 0, i = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), a = n, u = !1, s = n; s < r; s++)if (t.get(s) !== u) i[o]++;
        else {
            if (5 === o) {
                for(var c = e.MAX_AVG_VARIANCE, f = -1, h = e.CODE_START_A; h <= e.CODE_START_C; h++){
                    var l = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, e.CODE_PATTERNS[h], e.MAX_INDIVIDUAL_VARIANCE);
                    l < c && (c = l, f = h);
                }
                if (f >= 0 && t.isRange(Math.max(0, a - (s - a) / 2), a, !1)) return Int32Array.from([
                    a,
                    s,
                    f
                ]);
                a += i[0] + i[1], (i = i.slice(2, i.length - 1))[o - 1] = 0, i[o] = 0, o--;
            } else o++;
            i[o] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeCode = function(t, r, n) {
        $12c6b0ab9da17bee$var$Lt.recordPattern(t, n, r);
        for(var o = e.MAX_AVG_VARIANCE, i = -1, a = 0; a < e.CODE_PATTERNS.length; a++){
            var u = e.CODE_PATTERNS[a], s = this.patternMatchVariance(r, u, e.MAX_INDIVIDUAL_VARIANCE);
            s < o && (o = s, i = a);
        }
        if (i >= 0) return i;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.decodeRow = function(t, r, n) {
        var o, i = n && !0 === n.get($12c6b0ab9da17bee$var$T.ASSUME_GS1), a = e.findStartPattern(r), u = a[2], s = 0, c = new Uint8Array(20);
        switch(c[s++] = u, u){
            case e.CODE_START_A:
                o = e.CODE_CODE_A;
                break;
            case e.CODE_START_B:
                o = e.CODE_CODE_B;
                break;
            case e.CODE_START_C:
                o = e.CODE_CODE_C;
                break;
            default:
                throw new $12c6b0ab9da17bee$var$R;
        }
        for(var f = !1, h = !1, l = "", d = a[0], p = a[1], y = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]), w = 0, _ = 0, v = u, m = 0, A = !0, E = !1, C = !1; !f;){
            var I = h;
            switch(h = !1, w = _, _ = e.decodeCode(r, y, p), c[s++] = _, _ !== e.CODE_STOP && (A = !0), _ !== e.CODE_STOP && (v += ++m * _), d = p, p += y.reduce(function(t, e) {
                return t + e;
            }, 0), _){
                case e.CODE_START_A:
                case e.CODE_START_B:
                case e.CODE_START_C:
                    throw new $12c6b0ab9da17bee$var$R;
            }
            switch(o){
                case e.CODE_CODE_A:
                    if (_ < 64) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else if (_ < 96) l += C === E ? String.fromCharCode(_ - 64) : String.fromCharCode(_ + 64), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_A:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_B:
                    if (_ < 96) l += C === E ? String.fromCharCode(" ".charCodeAt(0) + _) : String.fromCharCode(" ".charCodeAt(0) + _ + 128), C = !1;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_FNC_2:
                        case e.CODE_FNC_3:
                            break;
                        case e.CODE_FNC_4_B:
                            !E && C ? (E = !0, C = !1) : E && C ? (E = !1, C = !1) : C = !0;
                            break;
                        case e.CODE_SHIFT:
                            h = !0, o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_C:
                            o = e.CODE_CODE_C;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
                    break;
                case e.CODE_CODE_C:
                    if (_ < 100) _ < 10 && (l += "0"), l += _;
                    else switch(_ !== e.CODE_STOP && (A = !1), _){
                        case e.CODE_FNC_1:
                            i && (0 === l.length ? l += "]C1" : l += String.fromCharCode(29));
                            break;
                        case e.CODE_CODE_A:
                            o = e.CODE_CODE_A;
                            break;
                        case e.CODE_CODE_B:
                            o = e.CODE_CODE_B;
                            break;
                        case e.CODE_STOP:
                            f = !0;
                    }
            }
            I && (o = o === e.CODE_CODE_A ? e.CODE_CODE_B : e.CODE_CODE_A);
        }
        var S = p - d;
        if (p = r.getNextUnset(p), !r.isRange(p, Math.min(r.getSize(), p + (p - d) / 2), !1)) throw new $12c6b0ab9da17bee$var$U;
        if ((v -= m * w) % 103 !== w) throw new $12c6b0ab9da17bee$var$g;
        var O = l.length;
        if (0 === O) throw new $12c6b0ab9da17bee$var$U;
        O > 0 && A && (l = o === e.CODE_CODE_C ? l.substring(0, O - 2) : l.substring(0, O - 1));
        for(var b = (a[1] + a[0]) / 2, N = d + S / 2, D = c.length, P = new Uint8Array(D), M = 0; M < D; M++)P[M] = c[M];
        var B = [
            new $12c6b0ab9da17bee$var$At(b, t),
            new $12c6b0ab9da17bee$var$At(N, t)
        ];
        return new $12c6b0ab9da17bee$var$et(l, P, 0, B, $12c6b0ab9da17bee$var$nt.CODE_128, (new Date).getTime());
    }, e.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ], e.MAX_AVG_VARIANCE = .25, e.MAX_INDIVIDUAL_VARIANCE = .7, e.CODE_SHIFT = 98, e.CODE_CODE_C = 99, e.CODE_CODE_B = 100, e.CODE_CODE_A = 101, e.CODE_FNC_1 = 102, e.CODE_FNC_2 = 97, e.CODE_FNC_3 = 96, e.CODE_FNC_4_A = 101, e.CODE_FNC_4_B = 100, e.CODE_START_A = 103, e.CODE_START_B = 104, e.CODE_START_C = 105, e.CODE_STOP = 106, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$xt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Vt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ut = function(t) {
    function e(e, r) {
        void 0 === e && (e = !1), void 0 === r && (r = !1);
        var n = t.call(this) || this;
        return n.usingCheckDigit = e, n.extendedMode = r, n.decodeRowResult = "", n.counters = new Int32Array(9), n;
    }
    return $12c6b0ab9da17bee$var$xt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.counters;
        s.fill(0), this.decodeRowResult = "";
        var c, f, h = e.findAsteriskPattern(r, s), l = r.getNextSet(h[1]), d = r.getSize();
        do {
            e.recordPattern(r, l, s);
            var p = e.toNarrowWidePattern(s);
            if (p < 0) throw new $12c6b0ab9da17bee$var$U;
            c = e.patternToChar(p), this.decodeRowResult += c, f = l;
            try {
                for(var y = (o = void 0, $12c6b0ab9da17bee$var$Vt(s)), w = y.next(); !w.done; w = y.next())l += w.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (i = y.return) && i.call(y);
                } finally{
                    if (o) throw o.error;
                }
            }
            l = r.getNextSet(l);
        }while ("*" !== c);
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1);
        var _, v = 0;
        try {
            for(var m = $12c6b0ab9da17bee$var$Vt(s), A = m.next(); !A.done; A = m.next())v += A.value;
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (u = m.return) && u.call(m);
            } finally{
                if (a) throw a.error;
            }
        }
        if (l !== d && 2 * (l - f - v) < v) throw new $12c6b0ab9da17bee$var$U;
        if (this.usingCheckDigit) {
            for(var E = this.decodeRowResult.length - 1, C = 0, I = 0; I < E; I++)C += e.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(I));
            if (this.decodeRowResult.charAt(E) !== e.ALPHABET_STRING.charAt(C % 43)) throw new $12c6b0ab9da17bee$var$g;
            this.decodeRowResult = this.decodeRowResult.substring(0, E);
        }
        if (0 === this.decodeRowResult.length) throw new $12c6b0ab9da17bee$var$U;
        _ = this.extendedMode ? e.decodeExtended(this.decodeRowResult) : this.decodeRowResult;
        var S = (h[1] + h[0]) / 2, O = f + v / 2;
        return new $12c6b0ab9da17bee$var$et(_, null, 0, [
            new $12c6b0ab9da17bee$var$At(S, t),
            new $12c6b0ab9da17bee$var$At(O, t)
        ], $12c6b0ab9da17bee$var$nt.CODE_39, (new Date).getTime());
    }, e.findAsteriskPattern = function(t, r) {
        for(var n = t.getSize(), o = t.getNextSet(0), i = 0, a = o, u = !1, s = r.length, c = o; c < n; c++)if (t.get(c) !== u) r[i]++;
        else {
            if (i === s - 1) {
                if (this.toNarrowWidePattern(r) === e.ASTERISK_ENCODING && t.isRange(Math.max(0, a - Math.floor((c - a) / 2)), a, !1)) return [
                    a,
                    c
                ];
                a += r[0] + r[1], r.copyWithin(0, 2, 2 + i - 1), r[i - 1] = 0, r[i] = 0, i--;
            } else i++;
            r[i] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.toNarrowWidePattern = function(t) {
        var e, r, n, o = t.length, i = 0;
        do {
            var a = 2147483647;
            try {
                for(var u = (e = void 0, $12c6b0ab9da17bee$var$Vt(t)), s = u.next(); !s.done; s = u.next())(l = s.value) < a && l > i && (a = l);
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (r = u.return) && r.call(u);
                } finally{
                    if (e) throw e.error;
                }
            }
            i = a, n = 0;
            for(var c = 0, f = 0, h = 0; h < o; h++)(l = t[h]) > i && (f |= 1 << o - 1 - h, n++, c += l);
            if (3 === n) {
                for(h = 0; h < o && n > 0; h++){
                    var l;
                    if ((l = t[h]) > i && (n--, 2 * l >= c)) return -1;
                }
                return f;
            }
        }while (n > 3);
        return -1;
    }, e.patternToChar = function(t) {
        for(var r = 0; r < e.CHARACTER_ENCODINGS.length; r++)if (e.CHARACTER_ENCODINGS[r] === t) return e.ALPHABET_STRING.charAt(r);
        if (t === e.ASTERISK_ENCODING) return "*";
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeExtended = function(t) {
        for(var e = t.length, r = "", n = 0; n < e; n++){
            var o = t.charAt(n);
            if ("+" === o || "$" === o || "%" === o || "/" === o) {
                var i = t.charAt(n + 1), a = "\0";
                switch(o){
                    case "+":
                        if (!(i >= "A" && i <= "Z")) throw new $12c6b0ab9da17bee$var$R;
                        a = String.fromCharCode(i.charCodeAt(0) + 32);
                        break;
                    case "$":
                        if (!(i >= "A" && i <= "Z")) throw new $12c6b0ab9da17bee$var$R;
                        a = String.fromCharCode(i.charCodeAt(0) - 64);
                        break;
                    case "%":
                        if (i >= "A" && i <= "E") a = String.fromCharCode(i.charCodeAt(0) - 38);
                        else if (i >= "F" && i <= "J") a = String.fromCharCode(i.charCodeAt(0) - 11);
                        else if (i >= "K" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) + 16);
                        else if (i >= "P" && i <= "T") a = String.fromCharCode(i.charCodeAt(0) + 43);
                        else if ("U" === i) a = "\0";
                        else if ("V" === i) a = "@";
                        else if ("W" === i) a = "`";
                        else {
                            if ("X" !== i && "Y" !== i && "Z" !== i) throw new $12c6b0ab9da17bee$var$R;
                            a = "\x7f";
                        }
                        break;
                    case "/":
                        if (i >= "A" && i <= "O") a = String.fromCharCode(i.charCodeAt(0) - 32);
                        else {
                            if ("Z" !== i) throw new $12c6b0ab9da17bee$var$R;
                            a = ":";
                        }
                }
                r += a, n++;
            } else r += o;
        }
        return r;
    }, e.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%", e.CHARACTER_ENCODINGS = [
        52,
        289,
        97,
        352,
        49,
        304,
        112,
        37,
        292,
        100,
        265,
        73,
        328,
        25,
        280,
        88,
        13,
        268,
        76,
        28,
        259,
        67,
        322,
        19,
        274,
        82,
        7,
        262,
        70,
        22,
        385,
        193,
        448,
        145,
        400,
        208,
        133,
        388,
        196,
        168,
        162,
        138,
        42
    ], e.ASTERISK_ENCODING = 148, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$Ht = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Gt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Xt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.narrowLineWidth = -1, e;
    }
    return $12c6b0ab9da17bee$var$Ht(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a = this.decodeStart(r), u = this.decodeEnd(r), s = new $12c6b0ab9da17bee$var$k;
        e.decodeMiddle(r, a[1], u[0], s);
        var c = s.toString(), f = null;
        null != n && (f = n.get($12c6b0ab9da17bee$var$T.ALLOWED_LENGTHS)), null == f && (f = e.DEFAULT_ALLOWED_LENGTHS);
        var h = c.length, l = !1, d = 0;
        try {
            for(var p = $12c6b0ab9da17bee$var$Gt(f), g = p.next(); !g.done; g = p.next()){
                var y = g.value;
                if (h === y) {
                    l = !0;
                    break;
                }
                y > d && (d = y);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        if (!l && h > d && (l = !0), !l) throw new $12c6b0ab9da17bee$var$R;
        var w = [
            new $12c6b0ab9da17bee$var$At(a[1], t),
            new $12c6b0ab9da17bee$var$At(u[0], t)
        ];
        return new $12c6b0ab9da17bee$var$et(c, null, 0, w, $12c6b0ab9da17bee$var$nt.ITF, (new Date).getTime());
    }, e.decodeMiddle = function(t, r, n, o) {
        var i = new Int32Array(10), a = new Int32Array(5), u = new Int32Array(5);
        for(i.fill(0), a.fill(0), u.fill(0); r < n;){
            $12c6b0ab9da17bee$var$Lt.recordPattern(t, r, i);
            for(var s = 0; s < 5; s++){
                var c = 2 * s;
                a[s] = i[c], u[s] = i[c + 1];
            }
            var f = e.decodeDigit(a);
            o.append(f.toString()), f = this.decodeDigit(u), o.append(f.toString()), i.forEach(function(t) {
                r += t;
            });
        }
    }, e.prototype.decodeStart = function(t) {
        var r = e.skipWhiteSpace(t), n = e.findGuardPattern(t, r, e.START_PATTERN);
        return this.narrowLineWidth = (n[1] - n[0]) / 4, this.validateQuietZone(t, n[0]), n;
    }, e.prototype.validateQuietZone = function(t, e) {
        var r = 10 * this.narrowLineWidth;
        r = r < e ? r : e;
        for(var n = e - 1; r > 0 && n >= 0 && !t.get(n); n--)r--;
        if (0 !== r) throw new $12c6b0ab9da17bee$var$U;
    }, e.skipWhiteSpace = function(t) {
        var e = t.getSize(), r = t.getNextSet(0);
        if (r === e) throw new $12c6b0ab9da17bee$var$U;
        return r;
    }, e.prototype.decodeEnd = function(t) {
        t.reverse();
        try {
            var r = e.skipWhiteSpace(t), n = void 0;
            try {
                n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[0]);
            } catch (o) {
                o instanceof $12c6b0ab9da17bee$var$U && (n = e.findGuardPattern(t, r, e.END_PATTERN_REVERSED[1]));
            }
            this.validateQuietZone(t, n[0]);
            var o = n[0];
            return n[0] = t.getSize() - n[1], n[1] = t.getSize() - o, n;
        } finally{
            t.reverse();
        }
    }, e.findGuardPattern = function(t, r, n) {
        var o = n.length, i = new Int32Array(o), a = t.getSize(), u = !1, s = 0, c = r;
        i.fill(0);
        for(var f = r; f < a; f++)if (t.get(f) !== u) i[s]++;
        else {
            if (s === o - 1) {
                if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, n, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return [
                    c,
                    f
                ];
                c += i[0] + i[1], $12c6b0ab9da17bee$var$w.arraycopy(i, 2, i, 0, s - 1), i[s - 1] = 0, i[s] = 0, s--;
            } else s++;
            i[s] = 1, u = !u;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeDigit = function(t) {
        for(var r = e.MAX_AVG_VARIANCE, n = -1, o = e.PATTERNS.length, i = 0; i < o; i++){
            var a = e.PATTERNS[i], u = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(t, a, e.MAX_INDIVIDUAL_VARIANCE);
            u < r ? (r = u, n = i) : u === r && (n = -1);
        }
        if (n >= 0) return n % 10;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ])
    ], e.MAX_AVG_VARIANCE = .38, e.MAX_INDIVIDUAL_VARIANCE = .5, e.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ], e.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]), e.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ])
    ], e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$Wt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$jt = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.decodeRowStringBuffer = "", e;
    }
    return $12c6b0ab9da17bee$var$Wt(e, t), e.findStartGuardPattern = function(t) {
        for(var r, n = !1, o = 0, i = Int32Array.from([
            0,
            0,
            0
        ]); !n;){
            i = Int32Array.from([
                0,
                0,
                0
            ]);
            var a = (r = e.findGuardPattern(t, o, !1, this.START_END_PATTERN, i))[0], u = a - ((o = r[1]) - a);
            u >= 0 && (n = t.isRange(u, a, !1));
        }
        return r;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e.findGuardPatternWithoutCounters = function(t, e, r, n) {
        return this.findGuardPattern(t, e, r, n, new Int32Array(n.length));
    }, e.findGuardPattern = function(t, r, n, o, i) {
        for(var a = t.getSize(), u = 0, s = r = n ? t.getNextUnset(r) : t.getNextSet(r), c = o.length, f = n, h = r; h < a; h++)if (t.get(h) !== f) i[u]++;
        else {
            if (u === c - 1) {
                if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(i, o, e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return Int32Array.from([
                    s,
                    h
                ]);
                s += i[0] + i[1];
                for(var l = i.slice(2, i.length - 1), d = 0; d < u - 1; d++)i[d] = l[d];
                i[u - 1] = 0, i[u] = 0, u--;
            } else u++;
            i[u] = 1, f = !f;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.decodeDigit = function(t, r, n, o) {
        this.recordPattern(t, n, r);
        for(var i = this.MAX_AVG_VARIANCE, a = -1, u = o.length, s = 0; s < u; s++){
            var c = o[s], f = $12c6b0ab9da17bee$var$Lt.patternMatchVariance(r, c, e.MAX_INDIVIDUAL_VARIANCE);
            f < i && (i = f, a = s);
        }
        if (a >= 0) return a;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.MAX_AVG_VARIANCE = .48, e.MAX_INDIVIDUAL_VARIANCE = .7, e.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]), e.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]), e.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ], e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Yt = function() {
    function t() {
        this.CHECK_DIGIT_ENCODINGS = [
            24,
            20,
            18,
            17,
            12,
            6,
            3,
            10,
            9,
            5
        ], this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $12c6b0ab9da17bee$var$At((n[0] + n[1]) / 2, e),
            new $12c6b0ab9da17bee$var$At(i, e)
        ], c = new $12c6b0ab9da17bee$var$et(a, null, 0, s, $12c6b0ab9da17bee$var$nt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(e, r, n) {
        var o, i, a = this.decodeMiddleCounters;
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = e.getSize(), s = r[1], c = 0, f = 0; f < 5 && s < u; f++){
            var h = $12c6b0ab9da17bee$var$jt.decodeDigit(e, a, s, $12c6b0ab9da17bee$var$jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $12c6b0ab9da17bee$var$zt(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 4 - f), 4 !== f && (s = e.getNextSet(s), s = e.getNextUnset(s));
        }
        if (5 !== n.length) throw new $12c6b0ab9da17bee$var$U;
        var p = this.determineCheckDigit(c);
        if (t.extensionChecksum(n.toString()) !== p) throw new $12c6b0ab9da17bee$var$U;
        return s;
    }, t.extensionChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 2; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        r *= 3;
        for(n = e - 1; n >= 0; n -= 2)r += t.charAt(n).charCodeAt(0) - "0".charCodeAt(0);
        return (r *= 3) % 10;
    }, t.prototype.determineCheckDigit = function(t) {
        for(var e = 0; e < 10; e++)if (t === this.CHECK_DIGIT_ENCODINGS[e]) return e;
        throw new $12c6b0ab9da17bee$var$U;
    }, t.parseExtensionString = function(e) {
        if (5 !== e.length) return null;
        var r = t.parseExtension5String(e);
        return null == r ? null : new Map([
            [
                $12c6b0ab9da17bee$var$it.SUGGESTED_PRICE,
                r
            ]
        ]);
    }, t.parseExtension5String = function(t) {
        var e;
        switch(t.charAt(0)){
            case "0":
                e = "\xa3";
                break;
            case "5":
                e = "$";
                break;
            case "9":
                switch(t){
                    case "90000":
                        return null;
                    case "99991":
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                e = "";
                break;
            default:
                e = "";
        }
        var r = parseInt(t.substring(1)), n = r % 100;
        return e + (r / 100).toString() + "." + (n < 10 ? "0" + n : n.toString());
    }, t;
}(), $12c6b0ab9da17bee$var$Zt = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Kt = function() {
    function t() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), this.decodeRowStringBuffer = "";
    }
    return t.prototype.decodeRow = function(e, r, n) {
        var o = this.decodeRowStringBuffer, i = this.decodeMiddle(r, n, o), a = o.toString(), u = t.parseExtensionString(a), s = [
            new $12c6b0ab9da17bee$var$At((n[0] + n[1]) / 2, e),
            new $12c6b0ab9da17bee$var$At(i, e)
        ], c = new $12c6b0ab9da17bee$var$et(a, null, 0, s, $12c6b0ab9da17bee$var$nt.UPC_EAN_EXTENSION, (new Date).getTime());
        return null != u && c.putAllMetadata(u), c;
    }, t.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i = this.decodeMiddleCounters;
        i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 0;
        for(var a = t.getSize(), u = e[1], s = 0, c = 0; c < 2 && u < a; c++){
            var f = $12c6b0ab9da17bee$var$jt.decodeDigit(t, i, u, $12c6b0ab9da17bee$var$jt.L_AND_G_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + f % 10);
            try {
                for(var h = (n = void 0, $12c6b0ab9da17bee$var$Zt(i)), l = h.next(); !l.done; l = h.next())u += l.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    l && !l.done && (o = h.return) && o.call(h);
                } finally{
                    if (n) throw n.error;
                }
            }
            f >= 10 && (s |= 1 << 1 - c), 1 !== c && (u = t.getNextSet(u), u = t.getNextUnset(u));
        }
        if (2 !== r.length) throw new $12c6b0ab9da17bee$var$U;
        if (parseInt(r.toString()) % 4 !== s) throw new $12c6b0ab9da17bee$var$U;
        return u;
    }, t.parseExtensionString = function(t) {
        return 2 !== t.length ? null : new Map([
            [
                $12c6b0ab9da17bee$var$it.ISSUE_NUMBER,
                parseInt(t)
            ]
        ]);
    }, t;
}(), $12c6b0ab9da17bee$var$qt = function() {
    function t() {}
    return t.decodeRow = function(t, e, r) {
        var n = $12c6b0ab9da17bee$var$jt.findGuardPattern(e, r, !1, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            return (new $12c6b0ab9da17bee$var$Yt).decodeRow(t, e, n);
        } catch (r) {
            return (new $12c6b0ab9da17bee$var$Kt).decodeRow(t, e, n);
        }
    }, t.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]), t;
}(), $12c6b0ab9da17bee$var$Qt = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Jt = function(t) {
    function e() {
        var r = t.call(this) || this;
        r.decodeRowStringBuffer = "", e.L_AND_G_PATTERNS = e.L_PATTERNS.map(function(t) {
            return Int32Array.from(t);
        });
        for(var n = 10; n < 20; n++){
            for(var o = e.L_PATTERNS[n - 10], i = new Int32Array(o.length), a = 0; a < o.length; a++)i[a] = o[o.length - a - 1];
            e.L_AND_G_PATTERNS[n] = i;
        }
        return r;
    }
    return $12c6b0ab9da17bee$var$Qt(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o = e.findStartGuardPattern(r), i = null == n ? null : n.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
        if (null != i) {
            var a = new $12c6b0ab9da17bee$var$At((o[0] + o[1]) / 2, t);
            i.foundPossibleResultPoint(a);
        }
        var u = this.decodeMiddle(r, o, this.decodeRowStringBuffer), s = u.rowOffset, c = u.resultString;
        if (null != i) {
            var f = new $12c6b0ab9da17bee$var$At(s, t);
            i.foundPossibleResultPoint(f);
        }
        var h = e.decodeEnd(r, s);
        if (null != i) {
            var l = new $12c6b0ab9da17bee$var$At((h[0] + h[1]) / 2, t);
            i.foundPossibleResultPoint(l);
        }
        var d = h[1], p = d + (d - h[0]);
        if (p >= r.getSize() || !r.isRange(d, p, !1)) throw new $12c6b0ab9da17bee$var$U;
        var y = c.toString();
        if (y.length < 8) throw new $12c6b0ab9da17bee$var$R;
        if (!e.checkChecksum(y)) throw new $12c6b0ab9da17bee$var$g;
        var w = (o[1] + o[0]) / 2, _ = (h[1] + h[0]) / 2, v = this.getBarcodeFormat(), m = [
            new $12c6b0ab9da17bee$var$At(w, t),
            new $12c6b0ab9da17bee$var$At(_, t)
        ], A = new $12c6b0ab9da17bee$var$et(y, null, 0, m, v, (new Date).getTime()), E = 0;
        try {
            var C = $12c6b0ab9da17bee$var$qt.decodeRow(t, r, h[1]);
            A.putMetadata($12c6b0ab9da17bee$var$it.UPC_EAN_EXTENSION, C.getText()), A.putAllMetadata(C.getResultMetadata()), A.addResultPoints(C.getResultPoints()), E = C.getText().length;
        } catch (t) {}
        var I = null == n ? null : n.get($12c6b0ab9da17bee$var$T.ALLOWED_EAN_EXTENSIONS);
        if (null != I) {
            var S = !1;
            for(var O in I)if (E.toString() === O) {
                S = !0;
                break;
            }
            if (!S) throw new $12c6b0ab9da17bee$var$U;
        }
        return v === $12c6b0ab9da17bee$var$nt.EAN_13 || $12c6b0ab9da17bee$var$nt.UPC_A, A;
    }, e.checkChecksum = function(t) {
        return e.checkStandardUPCEANChecksum(t);
    }, e.checkStandardUPCEANChecksum = function(t) {
        var r = t.length;
        if (0 === r) return !1;
        var n = parseInt(t.charAt(r - 1), 10);
        return e.getStandardUPCEANChecksum(t.substring(0, r - 1)) === n;
    }, e.getStandardUPCEANChecksum = function(t) {
        for(var e = t.length, r = 0, n = e - 1; n >= 0; n -= 2){
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        r *= 3;
        for(n = e - 2; n >= 0; n -= 2){
            var o;
            if ((o = t.charAt(n).charCodeAt(0) - "0".charCodeAt(0)) < 0 || o > 9) throw new $12c6b0ab9da17bee$var$R;
            r += o;
        }
        return (1e3 - r) % 10;
    }, e.decodeEnd = function(t, r) {
        return e.findGuardPattern(t, r, !1, e.START_END_PATTERN, new Int32Array(e.START_END_PATTERN.length).fill(0));
    }, e;
}($12c6b0ab9da17bee$var$jt), $12c6b0ab9da17bee$var$$t = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$te = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ee = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $12c6b0ab9da17bee$var$$t(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a, u, s = this.decodeMiddleCounters;
        s[0] = 0, s[1] = 0, s[2] = 0, s[3] = 0;
        for(var c = t.getSize(), f = r[1], h = 0, l = 0; l < 6 && f < c; l++){
            var d = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, s, f, $12c6b0ab9da17bee$var$Jt.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d % 10);
            try {
                for(var p = (o = void 0, $12c6b0ab9da17bee$var$te(s)), g = p.next(); !g.done; g = p.next())f += g.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (i = p.return) && i.call(p);
                } finally{
                    if (o) throw o.error;
                }
            }
            d >= 10 && (h |= 1 << 5 - l);
        }
        n = e.determineFirstDigit(n, h), f = $12c6b0ab9da17bee$var$Jt.findGuardPattern(t, f, !0, $12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN, new Int32Array($12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(l = 0; l < 6 && f < c; l++){
            d = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, s, f, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + d);
            try {
                for(var y = (a = void 0, $12c6b0ab9da17bee$var$te(s)), w = y.next(); !w.done; w = y.next())f += w.value;
            } catch (t) {
                a = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (u = y.return) && u.call(y);
                } finally{
                    if (a) throw a.error;
                }
            }
        }
        return {
            rowOffset: f,
            resultString: n
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.EAN_13;
    }, e.determineFirstDigit = function(t, e) {
        for(var r = 0; r < 10; r++)if (e === this.FIRST_DIGIT_ENCODINGS[r]) return t = String.fromCharCode("0".charCodeAt(0) + r) + t;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.FIRST_DIGIT_ENCODINGS = [
        0,
        11,
        13,
        14,
        19,
        25,
        28,
        21,
        22,
        26
    ], e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$re = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ne = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$oe = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]), e;
    }
    return $12c6b0ab9da17bee$var$re(e, t), e.prototype.decodeMiddle = function(t, e, r) {
        var n, o, i, a, u = this.decodeMiddleCounters;
        u[0] = 0, u[1] = 0, u[2] = 0, u[3] = 0;
        for(var s = t.getSize(), c = e[1], f = 0; f < 4 && c < s; f++){
            var h = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, u, c, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var l = (n = void 0, $12c6b0ab9da17bee$var$ne(u)), d = l.next(); !d.done; d = l.next())c += d.value;
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (o = l.return) && o.call(l);
                } finally{
                    if (n) throw n.error;
                }
            }
        }
        c = $12c6b0ab9da17bee$var$Jt.findGuardPattern(t, c, !0, $12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN, new Int32Array($12c6b0ab9da17bee$var$Jt.MIDDLE_PATTERN.length).fill(0))[1];
        for(f = 0; f < 4 && c < s; f++){
            h = $12c6b0ab9da17bee$var$Jt.decodeDigit(t, u, c, $12c6b0ab9da17bee$var$Jt.L_PATTERNS);
            r += String.fromCharCode("0".charCodeAt(0) + h);
            try {
                for(var p = (i = void 0, $12c6b0ab9da17bee$var$ne(u)), g = p.next(); !g.done; g = p.next())c += g.value;
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    g && !g.done && (a = p.return) && a.call(p);
                } finally{
                    if (i) throw i.error;
                }
            }
        }
        return {
            rowOffset: c,
            resultString: r
        };
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.EAN_8;
    }, e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$ie = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ae = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.ean13Reader = new $12c6b0ab9da17bee$var$ee, e;
    }
    return $12c6b0ab9da17bee$var$ie(e, t), e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.UPC_A;
    }, e.prototype.decode = function(t, e) {
        return this.maybeReturnResult(this.ean13Reader.decode(t));
    }, e.prototype.decodeRow = function(t, e, r) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(t, e, r));
    }, e.prototype.decodeMiddle = function(t, e, r) {
        return this.ean13Reader.decodeMiddle(t, e, r);
    }, e.prototype.maybeReturnResult = function(t) {
        var e = t.getText();
        if ("0" === e.charAt(0)) {
            var r = new $12c6b0ab9da17bee$var$et(e.substring(1), null, null, t.getResultPoints(), $12c6b0ab9da17bee$var$nt.UPC_A);
            return null != t.getResultMetadata() && r.putAllMetadata(t.getResultMetadata()), r;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        this.ean13Reader.reset();
    }, e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$ue = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$se = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ce = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeMiddleCounters = new Int32Array(4), e;
    }
    return $12c6b0ab9da17bee$var$ue(e, t), e.prototype.decodeMiddle = function(t, r, n) {
        var o, i, a = this.decodeMiddleCounters.map(function(t) {
            return t;
        });
        a[0] = 0, a[1] = 0, a[2] = 0, a[3] = 0;
        for(var u = t.getSize(), s = r[1], c = 0, f = 0; f < 6 && s < u; f++){
            var h = e.decodeDigit(t, a, s, e.L_AND_G_PATTERNS);
            n += String.fromCharCode("0".charCodeAt(0) + h % 10);
            try {
                for(var l = (o = void 0, $12c6b0ab9da17bee$var$se(a)), d = l.next(); !d.done; d = l.next())s += d.value;
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    d && !d.done && (i = l.return) && i.call(l);
                } finally{
                    if (o) throw o.error;
                }
            }
            h >= 10 && (c |= 1 << 5 - f);
        }
        return e.determineNumSysAndCheckDigit(new $12c6b0ab9da17bee$var$k(n), c), s;
    }, e.prototype.decodeEnd = function(t, r) {
        return e.findGuardPatternWithoutCounters(t, r, !0, e.MIDDLE_END_PATTERN);
    }, e.prototype.checkChecksum = function(t) {
        return $12c6b0ab9da17bee$var$Jt.checkChecksum(e.convertUPCEtoUPCA(t));
    }, e.determineNumSysAndCheckDigit = function(t, e) {
        for(var r = 0; r <= 1; r++)for(var n = 0; n < 10; n++)if (e === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[r][n]) return t.insert(0, "0" + r), void t.append("0" + n);
        throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
    }, e.prototype.getBarcodeFormat = function() {
        return $12c6b0ab9da17bee$var$nt.UPC_E;
    }, e.convertUPCEtoUPCA = function(t) {
        var e = t.slice(1, 7).split("").map(function(t) {
            return t.charCodeAt(0);
        }), r = new $12c6b0ab9da17bee$var$k;
        r.append(t.charAt(0));
        var n = e[5];
        switch(n){
            case 0:
            case 1:
            case 2:
                r.appendChars(e, 0, 2), r.append(n), r.append("0000"), r.appendChars(e, 2, 3);
                break;
            case 3:
                r.appendChars(e, 0, 3), r.append("00000"), r.appendChars(e, 3, 2);
                break;
            case 4:
                r.appendChars(e, 0, 4), r.append("00000"), r.append(e[4]);
                break;
            default:
                r.appendChars(e, 0, 5), r.append("0000"), r.append(n);
        }
        return t.length >= 8 && r.append(t.charAt(7)), r.toString();
    }, e.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]), e.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            56,
            52,
            50,
            49,
            44,
            38,
            35,
            42,
            41,
            37
        ]),
        Int32Array.from([
            7,
            11,
            13,
            14,
            19,
            25,
            28,
            21,
            22,
            1
        ])
    ], e;
}($12c6b0ab9da17bee$var$Jt), $12c6b0ab9da17bee$var$fe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$he = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$le = function(t) {
    function e(e) {
        var r = t.call(this) || this, n = null == e ? null : e.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), o = [];
        return null != n && (n.indexOf($12c6b0ab9da17bee$var$nt.EAN_13) > -1 ? o.push(new $12c6b0ab9da17bee$var$ee) : n.indexOf($12c6b0ab9da17bee$var$nt.UPC_A) > -1 && o.push(new $12c6b0ab9da17bee$var$ae), n.indexOf($12c6b0ab9da17bee$var$nt.EAN_8) > -1 && o.push(new $12c6b0ab9da17bee$var$oe), n.indexOf($12c6b0ab9da17bee$var$nt.UPC_E) > -1 && o.push(new $12c6b0ab9da17bee$var$ce)), 0 === o.length && (o.push(new $12c6b0ab9da17bee$var$ee), o.push(new $12c6b0ab9da17bee$var$oe), o.push(new $12c6b0ab9da17bee$var$ce)), r.readers = o, r;
    }
    return $12c6b0ab9da17bee$var$fe(e, t), e.prototype.decodeRow = function(t, e, r) {
        var n, o;
        try {
            for(var i = $12c6b0ab9da17bee$var$he(this.readers), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                try {
                    var s = u.decodeRow(t, e, r), c = s.getBarcodeFormat() === $12c6b0ab9da17bee$var$nt.EAN_13 && "0" === s.getText().charAt(0), f = null == r ? null : r.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), h = null == f || f.includes($12c6b0ab9da17bee$var$nt.UPC_A);
                    if (c && h) {
                        var l = s.getRawBytes(), d = new $12c6b0ab9da17bee$var$et(s.getText().substring(1), l, l.length, s.getResultPoints(), $12c6b0ab9da17bee$var$nt.UPC_A);
                        return d.putAllMetadata(s.getResultMetadata()), d;
                    }
                    return s;
                } catch (t) {}
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        var t, e;
        try {
            for(var r = $12c6b0ab9da17bee$var$he(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$de = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$pe = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ge = function(t) {
    function e() {
        var e = t.call(this) || this;
        return e.decodeFinderCounters = new Int32Array(4), e.dataCharacterCounters = new Int32Array(8), e.oddRoundingErrors = new Array(4), e.evenRoundingErrors = new Array(4), e.oddCounts = new Array(e.dataCharacterCounters.length / 2), e.evenCounts = new Array(e.dataCharacterCounters.length / 2), e;
    }
    return $12c6b0ab9da17bee$var$de(e, t), e.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    }, e.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    }, e.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    }, e.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    }, e.prototype.getOddCounts = function() {
        return this.oddCounts;
    }, e.prototype.getEvenCounts = function() {
        return this.evenCounts;
    }, e.prototype.parseFinderValue = function(t, r) {
        for(var n = 0; n < r.length; n++)if ($12c6b0ab9da17bee$var$Lt.patternMatchVariance(t, r[n], e.MAX_INDIVIDUAL_VARIANCE) < e.MAX_AVG_VARIANCE) return n;
        throw new $12c6b0ab9da17bee$var$U;
    }, e.count = function(t) {
        return $12c6b0ab9da17bee$var$vt.sum(new Int32Array(t));
    }, e.increment = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] > n && (n = e[o], r = o);
        t[r]++;
    }, e.decrement = function(t, e) {
        for(var r = 0, n = e[0], o = 1; o < t.length; o++)e[o] < n && (n = e[o], r = o);
        t[r]--;
    }, e.isFinderPattern = function(t) {
        var r, n, o = t[0] + t[1], i = o / (o + t[2] + t[3]);
        if (i >= e.MIN_FINDER_PATTERN_RATIO && i <= e.MAX_FINDER_PATTERN_RATIO) {
            var a = Number.MAX_SAFE_INTEGER, u = Number.MIN_SAFE_INTEGER;
            try {
                for(var s = $12c6b0ab9da17bee$var$pe(t), c = s.next(); !c.done; c = s.next()){
                    var f = c.value;
                    f > u && (u = f), f < a && (a = f);
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    c && !c.done && (n = s.return) && n.call(s);
                } finally{
                    if (r) throw r.error;
                }
            }
            return u < 10 * a;
        }
        return !1;
    }, e.MAX_AVG_VARIANCE = .2, e.MAX_INDIVIDUAL_VARIANCE = .45, e.MIN_FINDER_PATTERN_RATIO = 9.5 / 12, e.MAX_FINDER_PATTERN_RATIO = 12.5 / 14, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$ye = function() {
    function t(t, e) {
        this.value = t, this.checksumPortion = e;
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    }, t.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value && this.checksumPortion === r.checksumPortion;
    }, t.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    }, t;
}(), $12c6b0ab9da17bee$var$we = function() {
    function t(t, e, r, n, o) {
        this.value = t, this.startEnd = e, this.value = t, this.startEnd = e, this.resultPoints = new Array, this.resultPoints.push(new $12c6b0ab9da17bee$var$At(r, o)), this.resultPoints.push(new $12c6b0ab9da17bee$var$At(n, o));
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getStartEnd = function() {
        return this.startEnd;
    }, t.prototype.getResultPoints = function() {
        return this.resultPoints;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.hashCode = function() {
        return this.value;
    }, t;
}(), $12c6b0ab9da17bee$var$_e = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$ve = function() {
    function t() {}
    return t.getRSSvalue = function(e, r, n) {
        var o, i, a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$_e(e), s = u.next(); !s.done; s = u.next())a += s.value;
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (i = u.return) && i.call(u);
            } finally{
                if (o) throw o.error;
            }
        }
        for(var c = 0, f = 0, h = e.length, l = 0; l < h - 1; l++){
            var d = void 0;
            for(d = 1, f |= 1 << l; d < e[l]; d++, f &= ~(1 << l)){
                var p = t.combins(a - d - 1, h - l - 2);
                if (n && 0 === f && a - d - (h - l - 1) >= h - l - 1 && (p -= t.combins(a - d - (h - l), h - l - 2)), h - l - 1 > 1) {
                    for(var g = 0, y = a - d - (h - l - 2); y > r; y--)g += t.combins(a - d - y - 1, h - l - 3);
                    p -= g * (h - 1 - l);
                } else a - d > r && p--;
                c += p;
            }
            a -= d;
        }
        return c;
    }, t.combins = function(t, e) {
        var r, n;
        t - e > e ? (n = e, r = t - e) : (n = t - e, r = e);
        for(var o = 1, i = 1, a = t; a > r; a--)o *= a, i <= n && (o /= i, i++);
        for(; i <= n;)o /= i, i++;
        return o;
    }, t;
}(), $12c6b0ab9da17bee$var$me = function() {
    function t() {}
    return t.buildBitArray = function(t) {
        var e = 2 * t.length - 1;
        null == t[t.length - 1].getRightChar() && (e -= 1);
        for(var r = new $12c6b0ab9da17bee$var$S(12 * e), n = 0, o = t[0].getRightChar().getValue(), i = 11; i >= 0; --i)0 != (o & 1 << i) && r.set(n), n++;
        for(i = 1; i < t.length; ++i){
            for(var a = t[i], u = a.getLeftChar().getValue(), s = 11; s >= 0; --s)0 != (u & 1 << s) && r.set(n), n++;
            if (null != a.getRightChar()) {
                var c = a.getRightChar().getValue();
                for(s = 11; s >= 0; --s)0 != (c & 1 << s) && r.set(n), n++;
            }
        }
        return r;
    }, t;
}(), $12c6b0ab9da17bee$var$Ae = function() {
    function t(t, e) {
        e ? this.decodedInformation = null : (this.finished = t, this.decodedInformation = e);
    }
    return t.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    }, t.prototype.isFinished = function() {
        return this.finished;
    }, t;
}(), $12c6b0ab9da17bee$var$Ee = function() {
    function t(t) {
        this.newPosition = t;
    }
    return t.prototype.getNewPosition = function() {
        return this.newPosition;
    }, t;
}(), $12c6b0ab9da17bee$var$Ce = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ie = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n.value = r, n;
    }
    return $12c6b0ab9da17bee$var$Ce(e, t), e.prototype.getValue = function() {
        return this.value;
    }, e.prototype.isFNC1 = function() {
        return this.value === e.FNC1;
    }, e.FNC1 = "$", e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Se = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Oe = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return n ? (o.remaining = !0, o.remainingValue = o.remainingValue) : (o.remaining = !1, o.remainingValue = 0), o.newString = r, o;
    }
    return $12c6b0ab9da17bee$var$Se(e, t), e.prototype.getNewString = function() {
        return this.newString;
    }, e.prototype.isRemaining = function() {
        return this.remaining;
    }, e.prototype.getRemainingValue = function() {
        return this.remainingValue;
    }, e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Te = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$be = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        if (r < 0 || r > 10 || n < 0 || n > 10) throw new $12c6b0ab9da17bee$var$R;
        return o.firstDigit = r, o.secondDigit = n, o;
    }
    return $12c6b0ab9da17bee$var$Te(e, t), e.prototype.getFirstDigit = function() {
        return this.firstDigit;
    }, e.prototype.getSecondDigit = function() {
        return this.secondDigit;
    }, e.prototype.getValue = function() {
        return 10 * this.firstDigit + this.secondDigit;
    }, e.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === e.FNC1;
    }, e.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === e.FNC1;
    }, e.prototype.isAnyFNC1 = function() {
        return this.firstDigit === e.FNC1 || this.secondDigit === e.FNC1;
    }, e.FNC1 = 10, e;
}($12c6b0ab9da17bee$var$Ee), $12c6b0ab9da17bee$var$Re = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ne = function() {
    function t() {}
    return t.parseFieldsInGeneralPurpose = function(e) {
        var r, n, o, i, a, u, s, c;
        if (!e) return null;
        if (e.length < 2) throw new $12c6b0ab9da17bee$var$U;
        var f = e.substring(0, 2);
        try {
            for(var h = $12c6b0ab9da17bee$var$Re(t.TWO_DIGIT_DATA_LENGTH), l = h.next(); !l.done; l = h.next()){
                if ((A = l.value)[0] === f) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(2, A[2], e) : t.processFixedAI(2, A[1], e);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        if (e.length < 3) throw new $12c6b0ab9da17bee$var$U;
        var d = e.substring(0, 3);
        try {
            for(var p = $12c6b0ab9da17bee$var$Re(t.THREE_DIGIT_DATA_LENGTH), g = p.next(); !g.done; g = p.next()){
                if ((A = g.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(3, A[2], e) : t.processFixedAI(3, A[1], e);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                g && !g.done && (i = p.return) && i.call(p);
            } finally{
                if (o) throw o.error;
            }
        }
        try {
            for(var y = $12c6b0ab9da17bee$var$Re(t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), w = y.next(); !w.done; w = y.next()){
                if ((A = w.value)[0] === d) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        if (e.length < 4) throw new $12c6b0ab9da17bee$var$U;
        var _ = e.substring(0, 4);
        try {
            for(var v = $12c6b0ab9da17bee$var$Re(t.FOUR_DIGIT_DATA_LENGTH), m = v.next(); !m.done; m = v.next()){
                var A;
                if ((A = m.value)[0] === _) return A[1] === t.VARIABLE_LENGTH ? t.processVariableAI(4, A[2], e) : t.processFixedAI(4, A[1], e);
            }
        } catch (t) {
            s = {
                error: t
            };
        } finally{
            try {
                m && !m.done && (c = v.return) && c.call(v);
            } finally{
                if (s) throw s.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, t.processFixedAI = function(e, r, n) {
        if (n.length < e) throw new $12c6b0ab9da17bee$var$U;
        var o = n.substring(0, e);
        if (n.length < e + r) throw new $12c6b0ab9da17bee$var$U;
        var i = n.substring(e, e + r), a = n.substring(e + r), u = "(" + o + ")" + i, s = t.parseFieldsInGeneralPurpose(a);
        return null == s ? u : u + s;
    }, t.processVariableAI = function(e, r, n) {
        var o, i = n.substring(0, e);
        o = n.length < e + r ? n.length : e + r;
        var a = n.substring(e, o), u = n.substring(o), s = "(" + i + ")" + a, c = t.parseFieldsInGeneralPurpose(u);
        return null == c ? s : s + c;
    }, t.VARIABLE_LENGTH = [], t.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            t.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            t.VARIABLE_LENGTH,
            8
        ],
        [
            "90",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            t.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.THREE_DIGIT_DATA_LENGTH = [
        [
            "240",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            t.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            t.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ], t.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            t.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            t.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            t.VARIABLE_LENGTH,
            30
        ]
    ], t.FOUR_DIGIT_DATA_LENGTH = [
        [
            "7001",
            13
        ],
        [
            "7002",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            t.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            t.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            t.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            t.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            t.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            t.VARIABLE_LENGTH,
            70
        ]
    ], t;
}(), $12c6b0ab9da17bee$var$De = function() {
    function t(t) {
        this.buffer = new $12c6b0ab9da17bee$var$k, this.information = t;
    }
    return t.prototype.decodeAllCodes = function(t, e) {
        for(var r = e, n = null;;){
            var o = this.decodeGeneralPurposeField(r, n), i = $12c6b0ab9da17bee$var$Ne.parseFieldsInGeneralPurpose(o.getNewString());
            if (null != i && t.append(i), n = o.isRemaining() ? "" + o.getRemainingValue() : null, r === o.getNewPosition()) break;
            r = o.getNewPosition();
        }
        return t.toString();
    }, t.prototype.isStillNumeric = function(t) {
        if (t + 7 > this.information.getSize()) return t + 4 <= this.information.getSize();
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !0;
        return this.information.get(t + 3);
    }, t.prototype.decodeNumeric = function(t) {
        if (t + 7 > this.information.getSize()) {
            var e = this.extractNumericValueFromBitArray(t, 4);
            return new $12c6b0ab9da17bee$var$be(this.information.getSize(), 0 === e ? $12c6b0ab9da17bee$var$be.FNC1 : e - 1, $12c6b0ab9da17bee$var$be.FNC1);
        }
        var r = this.extractNumericValueFromBitArray(t, 7);
        return new $12c6b0ab9da17bee$var$be(t + 7, (r - 8) / 11, (r - 8) % 11);
    }, t.prototype.extractNumericValueFromBitArray = function(e, r) {
        return t.extractNumericValueFromBitArray(this.information, e, r);
    }, t.extractNumericValueFromBitArray = function(t, e, r) {
        for(var n = 0, o = 0; o < r; ++o)t.get(e + o) && (n |= 1 << r - o - 1);
        return n;
    }, t.prototype.decodeGeneralPurposeField = function(t, e) {
        this.buffer.setLengthToZero(), null != e && this.buffer.append(e), this.current.setPosition(t);
        var r = this.parseBlocks();
        return null != r && r.isRemaining() ? new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString(), r.getRemainingValue()) : new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
    }, t.prototype.parseBlocks = function() {
        var t, e;
        do {
            var r = this.current.getPosition();
            if (t = this.current.isAlpha() ? (e = this.parseAlphaBlock()).isFinished() : this.current.isIsoIec646() ? (e = this.parseIsoIec646Block()).isFinished() : (e = this.parseNumericBlock()).isFinished(), !(r !== this.current.getPosition()) && !t) break;
        }while (!t);
        return e.getDecodedInformation();
    }, t.prototype.parseNumericBlock = function() {
        for(; this.isStillNumeric(this.current.getPosition());){
            var t = this.decodeNumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFirstDigitFNC1()) {
                var e = void 0;
                return e = t.isSecondDigitFNC1() ? new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString()) : new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString(), t.getSecondDigit()), new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            if (this.buffer.append(t.getFirstDigit()), t.isSecondDigitFNC1()) {
                e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getSecondDigit());
        }
        return this.isNumericToAlphaNumericLatch(this.current.getPosition()) && (this.current.setAlpha(), this.current.incrementPosition(4)), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.parseIsoIec646Block = function() {
        for(; this.isStillIsoIec646(this.current.getPosition());){
            var t = this.decodeIsoIec646(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setAlpha()), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.parseAlphaBlock = function() {
        for(; this.isStillAlpha(this.current.getPosition());){
            var t = this.decodeAlphanumeric(this.current.getPosition());
            if (this.current.setPosition(t.getNewPosition()), t.isFNC1()) {
                var e = new $12c6b0ab9da17bee$var$Oe(this.current.getPosition(), this.buffer.toString());
                return new $12c6b0ab9da17bee$var$Ae(!0, e);
            }
            this.buffer.append(t.getValue());
        }
        return this.isAlphaOr646ToNumericLatch(this.current.getPosition()) ? (this.current.incrementPosition(3), this.current.setNumeric()) : this.isAlphaTo646ToAlphaLatch(this.current.getPosition()) && (this.current.getPosition() + 5 < this.information.getSize() ? this.current.incrementPosition(5) : this.current.setPosition(this.information.getSize()), this.current.setIsoIec646()), new $12c6b0ab9da17bee$var$Ae(!1);
    }, t.prototype.isStillIsoIec646 = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 7 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 7);
        if (r >= 64 && r < 116) return !0;
        if (t + 8 > this.information.getSize()) return !1;
        var n = this.extractNumericValueFromBitArray(t, 8);
        return n >= 232 && n < 253;
    }, t.prototype.decodeIsoIec646 = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $12c6b0ab9da17bee$var$Ie(t + 5, $12c6b0ab9da17bee$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $12c6b0ab9da17bee$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 7);
        if (n >= 64 && n < 90) return new $12c6b0ab9da17bee$var$Ie(t + 7, "" + (n + 1));
        if (n >= 90 && n < 116) return new $12c6b0ab9da17bee$var$Ie(t + 7, "" + (n + 7));
        switch(this.extractNumericValueFromBitArray(t, 8)){
            case 232:
                r = "!";
                break;
            case 233:
                r = '"';
                break;
            case 234:
                r = "%";
                break;
            case 235:
                r = "&";
                break;
            case 236:
                r = "'";
                break;
            case 237:
                r = "(";
                break;
            case 238:
                r = ")";
                break;
            case 239:
                r = "*";
                break;
            case 240:
                r = "+";
                break;
            case 241:
                r = ",";
                break;
            case 242:
                r = "-";
                break;
            case 243:
                r = ".";
                break;
            case 244:
                r = "/";
                break;
            case 245:
                r = ":";
                break;
            case 246:
                r = ";";
                break;
            case 247:
                r = "<";
                break;
            case 248:
                r = "=";
                break;
            case 249:
                r = ">";
                break;
            case 250:
                r = "?";
                break;
            case 251:
                r = "_";
                break;
            case 252:
                r = " ";
                break;
            default:
                throw new $12c6b0ab9da17bee$var$R;
        }
        return new $12c6b0ab9da17bee$var$Ie(t + 8, r);
    }, t.prototype.isStillAlpha = function(t) {
        if (t + 5 > this.information.getSize()) return !1;
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (e >= 5 && e < 16) return !0;
        if (t + 6 > this.information.getSize()) return !1;
        var r = this.extractNumericValueFromBitArray(t, 6);
        return r >= 16 && r < 63;
    }, t.prototype.decodeAlphanumeric = function(t) {
        var e = this.extractNumericValueFromBitArray(t, 5);
        if (15 === e) return new $12c6b0ab9da17bee$var$Ie(t + 5, $12c6b0ab9da17bee$var$Ie.FNC1);
        if (e >= 5 && e < 15) return new $12c6b0ab9da17bee$var$Ie(t + 5, "0" + (e - 5));
        var r, n = this.extractNumericValueFromBitArray(t, 6);
        if (n >= 32 && n < 58) return new $12c6b0ab9da17bee$var$Ie(t + 6, "" + (n + 33));
        switch(n){
            case 58:
                r = "*";
                break;
            case 59:
                r = ",";
                break;
            case 60:
                r = "-";
                break;
            case 61:
                r = ".";
                break;
            case 62:
                r = "/";
                break;
            default:
                throw new $12c6b0ab9da17bee$var$yt("Decoding invalid alphanumeric value: " + n);
        }
        return new $12c6b0ab9da17bee$var$Ie(t + 6, r);
    }, t.prototype.isAlphaTo646ToAlphaLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 5 && e + t < this.information.getSize(); ++e)if (2 === e) {
            if (!this.information.get(t + 2)) return !1;
        } else if (this.information.get(t + e)) return !1;
        return !0;
    }, t.prototype.isAlphaOr646ToNumericLatch = function(t) {
        if (t + 3 > this.information.getSize()) return !1;
        for(var e = t; e < t + 3; ++e)if (this.information.get(e)) return !1;
        return !0;
    }, t.prototype.isNumericToAlphaNumericLatch = function(t) {
        if (t + 1 > this.information.getSize()) return !1;
        for(var e = 0; e < 4 && e + t < this.information.getSize(); ++e)if (this.information.get(t + e)) return !1;
        return !0;
    }, t;
}(), $12c6b0ab9da17bee$var$Pe = function() {
    function t(t) {
        this.information = t, this.generalDecoder = new $12c6b0ab9da17bee$var$De(t);
    }
    return t.prototype.getInformation = function() {
        return this.information;
    }, t.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    }, t;
}(), $12c6b0ab9da17bee$var$Me = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Be = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Me(e, t), e.prototype.encodeCompressedGtin = function(t, e) {
        t.append("(01)");
        var r = t.length();
        t.append("9"), this.encodeCompressedGtinWithoutAI(t, e, r);
    }, e.prototype.encodeCompressedGtinWithoutAI = function(t, r, n) {
        for(var o = 0; o < 4; ++o){
            var i = this.getGeneralDecoder().extractNumericValueFromBitArray(r + 10 * o, 10);
            i / 100 == 0 && t.append("0"), i / 10 == 0 && t.append("0"), t.append(i);
        }
        e.appendCheckDigit(t, n);
    }, e.appendCheckDigit = function(t, e) {
        for(var r = 0, n = 0; n < 13; n++){
            var o = t.charAt(n + e).charCodeAt(0) - "0".charCodeAt(0);
            r += 0 == (1 & n) ? 3 * o : o;
        }
        10 === (r = 10 - r % 10) && (r = 0), t.append(r);
    }, e.GTIN_SIZE = 40, e;
}($12c6b0ab9da17bee$var$Pe), $12c6b0ab9da17bee$var$Le = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Fe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Le(e, t), e.prototype.parseInformation = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        t.append("(01)");
        var r = t.length(), n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE, 4);
        return t.append(n), this.encodeCompressedGtinWithoutAI(t, e.HEADER_SIZE + 4, r), this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE + 44);
    }, e.HEADER_SIZE = 4, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$xe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$ke(e, t), e.prototype.parseInformation = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        return this.getGeneralDecoder().decodeAllCodes(t, e.HEADER_SIZE);
    }, e.HEADER_SIZE = 5, e;
}($12c6b0ab9da17bee$var$Pe), $12c6b0ab9da17bee$var$Ve = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ue = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ve(e, t), e.prototype.encodeCompressedWeight = function(t, e, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e, r);
        this.addWeightCode(t, n);
        for(var o = this.checkWeight(n), i = 1e5, a = 0; a < 5; ++a)o / i == 0 && t.append("0"), i /= 10;
        t.append(o);
    }, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$He = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ge = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$He(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + $12c6b0ab9da17bee$var$Ue.GTIN_SIZE + e.WEIGHT_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + $12c6b0ab9da17bee$var$Ue.GTIN_SIZE, e.WEIGHT_SIZE), t.toString();
    }, e.HEADER_SIZE = 5, e.WEIGHT_SIZE = 15, e;
}($12c6b0ab9da17bee$var$Ue), $12c6b0ab9da17bee$var$Xe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$We = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Xe(e, t), e.prototype.addWeightCode = function(t, e) {
        t.append("(3103)");
    }, e.prototype.checkWeight = function(t) {
        return t;
    }, e;
}($12c6b0ab9da17bee$var$Ge), $12c6b0ab9da17bee$var$je = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$je(e, t), e.prototype.addWeightCode = function(t, e) {
        e < 1e4 ? t.append("(3202)") : t.append("(3203)");
    }, e.prototype.checkWeight = function(t) {
        return t < 1e4 ? t : t - 1e4;
    }, e;
}($12c6b0ab9da17bee$var$Ge), $12c6b0ab9da17bee$var$Ye = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ze = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ye(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(392"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, null);
        return t.append(n.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$Ke = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$qe = function(t) {
    function e(e) {
        return t.call(this, e) || this;
    }
    return $12c6b0ab9da17bee$var$Ke(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        this.encodeCompressedGtin(t, e.HEADER_SIZE);
        var r = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE, e.LAST_DIGIT_SIZE);
        t.append("(393"), t.append(r), t.append(")");
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE, e.FIRST_THREE_DIGITS_SIZE);
        n / 100 == 0 && t.append("0"), n / 10 == 0 && t.append("0"), t.append(n);
        var o = this.getGeneralDecoder().decodeGeneralPurposeField(e.HEADER_SIZE + $12c6b0ab9da17bee$var$Be.GTIN_SIZE + e.LAST_DIGIT_SIZE + e.FIRST_THREE_DIGITS_SIZE, null);
        return t.append(o.getNewString()), t.toString();
    }, e.HEADER_SIZE = 8, e.LAST_DIGIT_SIZE = 2, e.FIRST_THREE_DIGITS_SIZE = 10, e;
}($12c6b0ab9da17bee$var$Be), $12c6b0ab9da17bee$var$Qe = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Je = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.dateCode = n, o.firstAIdigits = r, o;
    }
    return $12c6b0ab9da17bee$var$Qe(e, t), e.prototype.parseInformation = function() {
        if (this.getInformation().getSize() != e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE + e.DATE_SIZE) throw new $12c6b0ab9da17bee$var$U;
        var t = new $12c6b0ab9da17bee$var$k;
        return this.encodeCompressedGtin(t, e.HEADER_SIZE), this.encodeCompressedWeight(t, e.HEADER_SIZE + e.GTIN_SIZE, e.WEIGHT_SIZE), this.encodeCompressedDate(t, e.HEADER_SIZE + e.GTIN_SIZE + e.WEIGHT_SIZE), t.toString();
    }, e.prototype.encodeCompressedDate = function(t, r) {
        var n = this.getGeneralDecoder().extractNumericValueFromBitArray(r, e.DATE_SIZE);
        if (38400 != n) {
            t.append("("), t.append(this.dateCode), t.append(")");
            var o = n % 32, i = (n /= 32) % 12 + 1, a = n /= 12;
            a / 10 == 0 && t.append("0"), t.append(a), i / 10 == 0 && t.append("0"), t.append(i), o / 10 == 0 && t.append("0"), t.append(o);
        }
    }, e.prototype.addWeightCode = function(t, e) {
        t.append("("), t.append(this.firstAIdigits), t.append(e / 1e5), t.append(")");
    }, e.prototype.checkWeight = function(t) {
        return t % 1e5;
    }, e.HEADER_SIZE = 8, e.WEIGHT_SIZE = 20, e.DATE_SIZE = 16, e;
}($12c6b0ab9da17bee$var$Ue);
var $12c6b0ab9da17bee$var$$e = function() {
    function t(t, e, r, n) {
        this.leftchar = t, this.rightchar = e, this.finderpattern = r, this.maybeLast = n;
    }
    return t.prototype.mayBeLast = function() {
        return this.maybeLast;
    }, t.prototype.getLeftChar = function() {
        return this.leftchar;
    }, t.prototype.getRightChar = function() {
        return this.rightchar;
    }, t.prototype.getFinderPattern = function() {
        return this.finderpattern;
    }, t.prototype.mustBeLast = function() {
        return null == this.rightchar;
    }, t.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (null == this.finderpattern ? "null" : this.finderpattern.getValue()) + " ]";
    }, t.equals = function(e, r) {
        return e instanceof t && t.equalsOrNull(e.leftchar, r.leftchar) && t.equalsOrNull(e.rightchar, r.rightchar) && t.equalsOrNull(e.finderpattern, r.finderpattern);
    }, t.equalsOrNull = function(e, r) {
        return null === e ? null === r : t.equals(e, r);
    }, t.prototype.hashCode = function() {
        return this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
    }, t;
}(), $12c6b0ab9da17bee$var$tr = function() {
    function t(t, e, r) {
        this.pairs = t, this.rowNumber = e, this.wasReversed = r;
    }
    return t.prototype.getPairs = function() {
        return this.pairs;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.isReversed = function() {
        return this.wasReversed;
    }, t.prototype.isEquivalent = function(t) {
        return this.checkEqualitity(this, t);
    }, t.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    }, t.prototype.equals = function(e, r) {
        return e instanceof t && this.checkEqualitity(e, r) && e.wasReversed === r.wasReversed;
    }, t.prototype.checkEqualitity = function(t, e) {
        var r;
        if (t && e) return t.forEach(function(t, n) {
            e.forEach(function(e) {
                t.getLeftChar().getValue() === e.getLeftChar().getValue() && t.getRightChar().getValue() === e.getRightChar().getValue() && t.getFinderPatter().getValue() === e.getFinderPatter().getValue() && (r = !0);
            });
        }), r;
    }, t;
}(), $12c6b0ab9da17bee$var$er = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$rr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$nr = function(t) {
    function e() {
        var r = null !== t && t.apply(this, arguments) || this;
        return r.pairs = new Array(e.MAX_PAIRS), r.rows = new Array, r.startEnd = [
            2
        ], r;
    }
    return $12c6b0ab9da17bee$var$er(e, t), e.prototype.decodeRow = function(t, r, n) {
        this.pairs.length = 0, this.startFromEven = !1;
        try {
            return e.constructResult(this.decodeRow2pairs(t, r));
        } catch (t) {}
        return this.pairs.length = 0, this.startFromEven = !0, e.constructResult(this.decodeRow2pairs(t, r));
    }, e.prototype.reset = function() {
        this.pairs.length = 0, this.rows.length = 0;
    }, e.prototype.decodeRow2pairs = function(t, e) {
        for(var r, n = !1; !n;)try {
            this.pairs.push(this.retrieveNextPair(e, this.pairs, t));
        } catch (t) {
            if (t instanceof $12c6b0ab9da17bee$var$U) {
                if (!this.pairs.length) throw new $12c6b0ab9da17bee$var$U;
                n = !0;
            }
        }
        if (this.checkChecksum()) return this.pairs;
        if (r = !!this.rows.length, this.storeRow(t, !1), r) {
            var o = this.checkRowsBoolean(!1);
            if (null != o) return o;
            if (null != (o = this.checkRowsBoolean(!0))) return o;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.checkRowsBoolean = function(t) {
        if (this.rows.length > 25) return this.rows.length = 0, null;
        this.pairs.length = 0, t && (this.rows = this.rows.reverse());
        var e = null;
        try {
            e = this.checkRows(new Array, 0);
        } catch (t) {
            console.log(t);
        }
        return t && (this.rows = this.rows.reverse()), e;
    }, e.prototype.checkRows = function(t, r) {
        for(var n, o, i = r; i < this.rows.length; i++){
            var a = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var u = (n = void 0, $12c6b0ab9da17bee$var$rr(t)), s = u.next(); !s.done; s = u.next()){
                    var c = s.value;
                    this.pairs.push(c.getPairs());
                }
            } catch (t) {
                n = {
                    error: t
                };
            } finally{
                try {
                    s && !s.done && (o = u.return) && o.call(u);
                } finally{
                    if (n) throw n.error;
                }
            }
            if (this.pairs.push(a.getPairs()), e.isValidSequence(this.pairs)) {
                if (this.checkChecksum()) return this.pairs;
                var f = new Array(t);
                f.push(a);
                try {
                    return this.checkRows(f, i + 1);
                } catch (t) {
                    console.log(t);
                }
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.isValidSequence = function(t) {
        var r, n;
        try {
            for(var o = $12c6b0ab9da17bee$var$rr(e.FINDER_PATTERN_SEQUENCES), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (!(t.length > a.length)) {
                    for(var u = !0, s = 0; s < t.length; s++)if (t[s].getFinderPattern().getValue() != a[s]) {
                        u = !1;
                        break;
                    }
                    if (u) return !0;
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (n = o.return) && n.call(o);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.storeRow = function(t, r) {
        for(var n = 0, o = !1, i = !1; n < this.rows.length;){
            var a = this.rows[n];
            if (a.getRowNumber() > t) {
                i = a.isEquivalent(this.pairs);
                break;
            }
            o = a.isEquivalent(this.pairs), n++;
        }
        i || o || e.isPartialRow(this.pairs, this.rows) || (this.rows.push(n, new $12c6b0ab9da17bee$var$tr(this.pairs, t, r)), this.removePartialRows(this.pairs, this.rows));
    }, e.prototype.removePartialRows = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $12c6b0ab9da17bee$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value;
                if (f.getPairs().length !== t.length) try {
                    for(var h = (o = void 0, $12c6b0ab9da17bee$var$rr(f.getPairs())), l = h.next(); !l.done; l = h.next()){
                        var d = l.value, p = !1;
                        try {
                            for(var g = (a = void 0, $12c6b0ab9da17bee$var$rr(t)), y = g.next(); !y.done; y = g.next()){
                                var w = y.value;
                                if ($12c6b0ab9da17bee$var$$e.equals(d, w)) {
                                    p = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                y && !y.done && (u = g.return) && u.call(g);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        p;
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        l && !l.done && (i = h.return) && i.call(h);
                    } finally{
                        if (o) throw o.error;
                    }
                }
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
    }, e.isPartialRow = function(t, e) {
        var r, n, o, i, a, u;
        try {
            for(var s = $12c6b0ab9da17bee$var$rr(e), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = !0;
                try {
                    for(var l = (o = void 0, $12c6b0ab9da17bee$var$rr(t)), d = l.next(); !d.done; d = l.next()){
                        var p = d.value, g = !1;
                        try {
                            for(var y = (a = void 0, $12c6b0ab9da17bee$var$rr(f.getPairs())), w = y.next(); !w.done; w = y.next()){
                                var _ = w.value;
                                if (p.equals(_)) {
                                    g = !0;
                                    break;
                                }
                            }
                        } catch (t) {
                            a = {
                                error: t
                            };
                        } finally{
                            try {
                                w && !w.done && (u = y.return) && u.call(y);
                            } finally{
                                if (a) throw a.error;
                            }
                        }
                        if (!g) {
                            h = !1;
                            break;
                        }
                    }
                } catch (t) {
                    o = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (i = l.return) && i.call(l);
                    } finally{
                        if (o) throw o.error;
                    }
                }
                if (h) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (n = s.return) && n.call(s);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, e.prototype.getRows = function() {
        return this.rows;
    }, e.constructResult = function(t) {
        var e = (function(t) {
            try {
                if (t.get(1)) return new $12c6b0ab9da17bee$var$Fe(t);
                if (!t.get(2)) return new $12c6b0ab9da17bee$var$xe(t);
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 4)){
                    case 4:
                        return new $12c6b0ab9da17bee$var$We(t);
                    case 5:
                        return new $12c6b0ab9da17bee$var$ze(t);
                }
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 5)){
                    case 12:
                        return new $12c6b0ab9da17bee$var$Ze(t);
                    case 13:
                        return new $12c6b0ab9da17bee$var$qe(t);
                }
                switch($12c6b0ab9da17bee$var$De.extractNumericValueFromBitArray(t, 1, 7)){
                    case 56:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "11");
                    case 57:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "11");
                    case 58:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "13");
                    case 59:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "13");
                    case 60:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "15");
                    case 61:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "15");
                    case 62:
                        return new $12c6b0ab9da17bee$var$Je(t, "310", "17");
                    case 63:
                        return new $12c6b0ab9da17bee$var$Je(t, "320", "17");
                }
            } catch (e) {
                throw console.log(e), new $12c6b0ab9da17bee$var$yt("unknown decoder: " + t);
            }
        })($12c6b0ab9da17bee$var$me.buildBitArray(t)).parseInformation(), r = t[0].getFinderPattern().getResultPoints(), n = t[t.length - 1].getFinderPattern().getResultPoints(), o = [
            r[0],
            r[1],
            n[0],
            n[1]
        ];
        return new $12c6b0ab9da17bee$var$et(e, null, null, o, $12c6b0ab9da17bee$var$nt.RSS_EXPANDED, null);
    }, e.prototype.checkChecksum = function() {
        var t = this.pairs.get(0), e = t.getLeftChar(), r = t.getRightChar();
        if (null == r) return !1;
        for(var n = r.getChecksumPortion(), o = 2, i = 1; i < this.pairs.size(); ++i){
            var a = this.pairs.get(i);
            n += a.getLeftChar().getChecksumPortion(), o++;
            var u = a.getRightChar();
            null != u && (n += u.getChecksumPortion(), o++);
        }
        return 211 * (o - 4) + (n %= 211) == e.getValue();
    }, e.getNextSecondBar = function(t, e) {
        var r;
        return t.get(e) ? (r = t.getNextUnset(e), r = t.getNextSet(r)) : (r = t.getNextSet(e), r = t.getNextUnset(r)), r;
    }, e.prototype.retrieveNextPair = function(t, r, n) {
        var o, i = r.length % 2 == 0;
        this.startFromEven && (i = !i);
        var a = !0, u = -1;
        do this.findNextPair(t, r, u), null == (o = this.parseFoundFinderPattern(t, n, i)) ? u = e.getNextSecondBar(t, this.startEnd[0]) : a = !1;
        while (a);
        var s, c = this.decodeDataCharacter(t, o, i, !0);
        if (!this.isEmptyPair(r) && r[r.length - 1].mustBeLast()) throw new $12c6b0ab9da17bee$var$U;
        try {
            s = this.decodeDataCharacter(t, o, i, !1);
        } catch (t) {
            s = null, console.log(t);
        }
        return new $12c6b0ab9da17bee$var$$e(c, s, o, !0);
    }, e.prototype.isEmptyPair = function(t) {
        return 0 === t.length;
    }, e.prototype.findNextPair = function(t, r, n) {
        var o = this.getDecodeFinderCounters();
        o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0;
        var i, a = t.getSize();
        if (n >= 0) i = n;
        else if (this.isEmptyPair(r)) i = 0;
        else i = r[r.length - 1].getFinderPattern().getStartEnd()[1];
        var u = r.length % 2 != 0;
        this.startFromEven && (u = !u);
        for(var s = !1; i < a && (s = !t.get(i));)i++;
        for(var c = 0, f = i, h = i; h < a; h++)if (t.get(h) != s) o[c]++;
        else {
            if (3 == c) {
                if (u && e.reverseCounters(o), e.isFinderPattern(o)) return this.startEnd[0] = f, void (this.startEnd[1] = h);
                u && e.reverseCounters(o), f += o[0] + o[1], o[0] = o[2], o[1] = o[3], o[2] = 0, o[3] = 0, c--;
            } else c++;
            o[c] = 1, s = !s;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.reverseCounters = function(t) {
        for(var e = t.length, r = 0; r < e / 2; ++r){
            var n = t[r];
            t[r] = t[e - r - 1], t[e - r - 1] = n;
        }
    }, e.prototype.parseFoundFinderPattern = function(t, r, n) {
        var o, i, a;
        if (n) {
            for(var u = this.startEnd[0] - 1; u >= 0 && !t.get(u);)u--;
            u++, o = this.startEnd[0] - u, i = u, a = this.startEnd[1];
        } else i = this.startEnd[0], o = (a = t.getNextUnset(this.startEnd[1] + 1)) - this.startEnd[1];
        var s, c = this.getDecodeFinderCounters();
        $12c6b0ab9da17bee$var$w.arraycopy(c, 0, c, 1, c.length - 1), c[0] = o;
        try {
            s = this.parseFinderValue(c, e.FINDER_PATTERNS);
        } catch (t) {
            return null;
        }
        return new $12c6b0ab9da17bee$var$we(s, [
            i,
            a
        ], i, a, r);
    }, e.prototype.decodeDataCharacter = function(t, r, n, o) {
        for(var i = this.getDataCharacterCounters(), a = 0; a < i.length; a++)i[a] = 0;
        if (o) e.recordPatternInReverse(t, r.getStartEnd()[0], i);
        else {
            e.recordPattern(t, r.getStartEnd()[1], i);
            for(var u = 0, s = i.length - 1; u < s; u++, s--){
                var c = i[u];
                i[u] = i[s], i[s] = c;
            }
        }
        var f = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(i)) / 17, h = (r.getStartEnd()[1] - r.getStartEnd()[0]) / 15;
        if (Math.abs(f - h) / h > .3) throw new $12c6b0ab9da17bee$var$U;
        var l = this.getOddCounts(), d = this.getEvenCounts(), p = this.getOddRoundingErrors(), g = this.getEvenRoundingErrors();
        for(u = 0; u < i.length; u++){
            var y = 1 * i[u] / f, w = y + .5;
            if (w < 1) {
                if (y < .3) throw new $12c6b0ab9da17bee$var$U;
                w = 1;
            } else if (w > 8) {
                if (y > 8.7) throw new $12c6b0ab9da17bee$var$U;
                w = 8;
            }
            var _ = u / 2;
            0 == (1 & u) ? (l[_] = w, p[_] = y - w) : (d[_] = w, g[_] = y - w);
        }
        this.adjustOddEvenCounts(17);
        var v = 4 * r.getValue() + (n ? 0 : 2) + (o ? 0 : 1) - 1, m = 0, A = 0;
        for(u = l.length - 1; u >= 0; u--){
            if (e.isNotA1left(r, n, o)) {
                var E = e.WEIGHTS[v][2 * u];
                A += l[u] * E;
            }
            m += l[u];
        }
        var C = 0;
        for(u = d.length - 1; u >= 0; u--)if (e.isNotA1left(r, n, o)) {
            E = e.WEIGHTS[v][2 * u + 1];
            C += d[u] * E;
        }
        var I = A + C;
        if (0 != (1 & m) || m > 13 || m < 4) throw new $12c6b0ab9da17bee$var$U;
        var S = (13 - m) / 2, O = e.SYMBOL_WIDEST[S], T = 9 - O, b = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, O, !0), R = $12c6b0ab9da17bee$var$ve.getRSSvalue(d, T, !1), N = e.EVEN_TOTAL_SUBSET[S], D = e.GSUM[S];
        return new $12c6b0ab9da17bee$var$ye(b * N + R + D, I);
    }, e.isNotA1left = function(t, e, r) {
        return !(0 == t.getValue() && e && r);
    }, e.prototype.adjustOddEvenCounts = function(t) {
        var r = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getOddCounts())), n = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1;
        r > 13 ? i = !0 : r < 4 && (o = !0);
        var a = !1, u = !1;
        n > 13 ? u = !0 : n < 4 && (a = !0);
        var s = r + n - t, c = 1 == (1 & r), f = 0 == (1 & n);
        if (1 == s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                i = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                u = !0;
            }
        } else if (-1 == s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                o = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                a = !0;
            }
        } else {
            if (0 != s) throw new $12c6b0ab9da17bee$var$U;
            if (c) {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $12c6b0ab9da17bee$var$U;
        }
        if (o) {
            if (i) throw new $12c6b0ab9da17bee$var$U;
            e.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && e.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $12c6b0ab9da17bee$var$U;
            e.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && e.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ], e.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ], e.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ], e.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ], e.FINDER_PAT_A = 0, e.FINDER_PAT_B = 1, e.FINDER_PAT_C = 2, e.FINDER_PAT_D = 3, e.FINDER_PAT_E = 4, e.FINDER_PAT_F = 5, e.FINDER_PATTERN_SEQUENCES = [
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_C,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_C
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_E,
            e.FINDER_PAT_B,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ],
        [
            e.FINDER_PAT_A,
            e.FINDER_PAT_A,
            e.FINDER_PAT_B,
            e.FINDER_PAT_B,
            e.FINDER_PAT_C,
            e.FINDER_PAT_D,
            e.FINDER_PAT_D,
            e.FINDER_PAT_E,
            e.FINDER_PAT_E,
            e.FINDER_PAT_F,
            e.FINDER_PAT_F
        ]
    ], e.MAX_PAIRS = 11, e;
}($12c6b0ab9da17bee$var$ge), $12c6b0ab9da17bee$var$or = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ir = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.count = 0, o.finderPattern = n, o;
    }
    return $12c6b0ab9da17bee$var$or(e, t), e.prototype.getFinderPattern = function() {
        return this.finderPattern;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.incrementCount = function() {
        this.count++;
    }, e;
}($12c6b0ab9da17bee$var$ye), $12c6b0ab9da17bee$var$ar = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$sr = function(t) {
    function e() {
        var e = null !== t && t.apply(this, arguments) || this;
        return e.possibleLeftPairs = [], e.possibleRightPairs = [], e;
    }
    return $12c6b0ab9da17bee$var$ar(e, t), e.prototype.decodeRow = function(t, r, n) {
        var o, i, a, u, s = this.decodePair(r, !1, t, n);
        e.addOrTally(this.possibleLeftPairs, s), r.reverse();
        var c = this.decodePair(r, !0, t, n);
        e.addOrTally(this.possibleRightPairs, c), r.reverse();
        try {
            for(var f = $12c6b0ab9da17bee$var$ur(this.possibleLeftPairs), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (l.getCount() > 1) try {
                    for(var d = (a = void 0, $12c6b0ab9da17bee$var$ur(this.possibleRightPairs)), p = d.next(); !p.done; p = d.next()){
                        var g = p.value;
                        if (g.getCount() > 1 && e.checkChecksum(l, g)) return e.constructResult(l, g);
                    }
                } catch (t) {
                    a = {
                        error: t
                    };
                } finally{
                    try {
                        p && !p.done && (u = d.return) && u.call(d);
                    } finally{
                        if (a) throw a.error;
                    }
                }
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.addOrTally = function(t, e) {
        var r, n;
        if (null != e) {
            var o = !1;
            try {
                for(var i = $12c6b0ab9da17bee$var$ur(t), a = i.next(); !a.done; a = i.next()){
                    var u = a.value;
                    if (u.getValue() === e.getValue()) {
                        u.incrementCount(), o = !0;
                        break;
                    }
                }
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    a && !a.done && (n = i.return) && n.call(i);
                } finally{
                    if (r) throw r.error;
                }
            }
            o || t.push(e);
        }
    }, e.prototype.reset = function() {
        this.possibleLeftPairs.length = 0, this.possibleRightPairs.length = 0;
    }, e.constructResult = function(t, e) {
        for(var r = 4537077 * t.getValue() + e.getValue(), n = new String(r).toString(), o = new $12c6b0ab9da17bee$var$k, i = 13 - n.length; i > 0; i--)o.append("0");
        o.append(n);
        var a = 0;
        for(i = 0; i < 13; i++){
            var u = o.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            a += 0 == (1 & i) ? 3 * u : u;
        }
        10 === (a = 10 - a % 10) && (a = 0), o.append(a.toString());
        var s = t.getFinderPattern().getResultPoints(), c = e.getFinderPattern().getResultPoints();
        return new $12c6b0ab9da17bee$var$et(o.toString(), null, 0, [
            s[0],
            s[1],
            c[0],
            c[1]
        ], $12c6b0ab9da17bee$var$nt.RSS_14, (new Date).getTime());
    }, e.checkChecksum = function(t, e) {
        var r = (t.getChecksumPortion() + 16 * e.getChecksumPortion()) % 79, n = 9 * t.getFinderPattern().getValue() + e.getFinderPattern().getValue();
        return n > 72 && n--, n > 8 && n--, r === n;
    }, e.prototype.decodePair = function(t, e, r, n) {
        try {
            var o = this.findFinderPattern(t, e), i = this.parseFoundFinderPattern(t, r, e, o), a = null == n ? null : n.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
            if (null != a) {
                var u = (o[0] + o[1]) / 2;
                e && (u = t.getSize() - 1 - u), a.foundPossibleResultPoint(new $12c6b0ab9da17bee$var$At(u, r));
            }
            var s = this.decodeDataCharacter(t, i, !0), c = this.decodeDataCharacter(t, i, !1);
            return new $12c6b0ab9da17bee$var$ir(1597 * s.getValue() + c.getValue(), s.getChecksumPortion() + 4 * c.getChecksumPortion(), i);
        } catch (t) {
            return null;
        }
    }, e.prototype.decodeDataCharacter = function(t, r, n) {
        for(var o = this.getDataCharacterCounters(), i = 0; i < o.length; i++)o[i] = 0;
        if (n) $12c6b0ab9da17bee$var$Lt.recordPatternInReverse(t, r.getStartEnd()[0], o);
        else {
            $12c6b0ab9da17bee$var$Lt.recordPattern(t, r.getStartEnd()[1] + 1, o);
            for(var a = 0, u = o.length - 1; a < u; a++, u--){
                var s = o[a];
                o[a] = o[u], o[u] = s;
            }
        }
        var c = n ? 16 : 15, f = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(o)) / c, h = this.getOddCounts(), l = this.getEvenCounts(), d = this.getOddRoundingErrors(), p = this.getEvenRoundingErrors();
        for(a = 0; a < o.length; a++){
            var g = o[a] / f, y = Math.floor(g + .5);
            y < 1 ? y = 1 : y > 8 && (y = 8);
            var w = Math.floor(a / 2);
            0 == (1 & a) ? (h[w] = y, d[w] = g - y) : (l[w] = y, p[w] = g - y);
        }
        this.adjustOddEvenCounts(n, c);
        var _ = 0, v = 0;
        for(a = h.length - 1; a >= 0; a--)v *= 9, v += h[a], _ += h[a];
        var m = 0, A = 0;
        for(a = l.length - 1; a >= 0; a--)m *= 9, m += l[a], A += l[a];
        var E = v + 3 * m;
        if (n) {
            if (0 != (1 & _) || _ > 12 || _ < 4) throw new $12c6b0ab9da17bee$var$U;
            var C = (12 - _) / 2, I = 9 - (R = e.OUTSIDE_ODD_WIDEST[C]), S = $12c6b0ab9da17bee$var$ve.getRSSvalue(h, R, !1), O = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, I, !0), T = e.OUTSIDE_EVEN_TOTAL_SUBSET[C], b = e.OUTSIDE_GSUM[C];
            return new $12c6b0ab9da17bee$var$ye(S * T + O + b, E);
        }
        if (0 != (1 & A) || A > 10 || A < 4) throw new $12c6b0ab9da17bee$var$U;
        C = (10 - A) / 2, I = 9 - (R = e.INSIDE_ODD_WIDEST[C]), S = $12c6b0ab9da17bee$var$ve.getRSSvalue(h, R, !0), O = $12c6b0ab9da17bee$var$ve.getRSSvalue(l, I, !1);
        var R, N = e.INSIDE_ODD_TOTAL_SUBSET[C];
        b = e.INSIDE_GSUM[C];
        return new $12c6b0ab9da17bee$var$ye(O * N + S + b, E);
    }, e.prototype.findFinderPattern = function(t, e) {
        var r = this.getDecodeFinderCounters();
        r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0;
        for(var n = t.getSize(), o = !1, i = 0; i < n && e !== (o = !t.get(i));)i++;
        for(var a = 0, u = i, s = i; s < n; s++)if (t.get(s) !== o) r[a]++;
        else {
            if (3 === a) {
                if ($12c6b0ab9da17bee$var$ge.isFinderPattern(r)) return [
                    u,
                    s
                ];
                u += r[0] + r[1], r[0] = r[2], r[1] = r[3], r[2] = 0, r[3] = 0, a--;
            } else a++;
            r[a] = 1, o = !o;
        }
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.parseFoundFinderPattern = function(t, r, n, o) {
        for(var i = t.get(o[0]), a = o[0] - 1; a >= 0 && i !== t.get(a);)a--;
        a++;
        var u = o[0] - a, s = this.getDecodeFinderCounters(), c = new Int32Array(s.length);
        $12c6b0ab9da17bee$var$w.arraycopy(s, 0, c, 1, s.length - 1), c[0] = u;
        var f = this.parseFinderValue(c, e.FINDER_PATTERNS), h = a, l = o[1];
        return n && (h = t.getSize() - 1 - h, l = t.getSize() - 1 - l), new $12c6b0ab9da17bee$var$we(f, [
            a,
            o[1]
        ], h, l, r);
    }, e.prototype.adjustOddEvenCounts = function(t, e) {
        var r = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getOddCounts())), n = $12c6b0ab9da17bee$var$vt.sum(new Int32Array(this.getEvenCounts())), o = !1, i = !1, a = !1, u = !1;
        t ? (r > 12 ? i = !0 : r < 4 && (o = !0), n > 12 ? u = !0 : n < 4 && (a = !0)) : (r > 11 ? i = !0 : r < 5 && (o = !0), n > 10 ? u = !0 : n < 4 && (a = !0));
        var s = r + n - e, c = (1 & r) == (t ? 1 : 0), f = 1 == (1 & n);
        if (1 === s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                i = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                u = !0;
            }
        } else if (-1 === s) {
            if (c) {
                if (f) throw new $12c6b0ab9da17bee$var$U;
                o = !0;
            } else {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                a = !0;
            }
        } else {
            if (0 !== s) throw new $12c6b0ab9da17bee$var$U;
            if (c) {
                if (!f) throw new $12c6b0ab9da17bee$var$U;
                r < n ? (o = !0, u = !0) : (i = !0, a = !0);
            } else if (f) throw new $12c6b0ab9da17bee$var$U;
        }
        if (o) {
            if (i) throw new $12c6b0ab9da17bee$var$U;
            $12c6b0ab9da17bee$var$ge.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (i && $12c6b0ab9da17bee$var$ge.decrement(this.getOddCounts(), this.getOddRoundingErrors()), a) {
            if (u) throw new $12c6b0ab9da17bee$var$U;
            $12c6b0ab9da17bee$var$ge.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        u && $12c6b0ab9da17bee$var$ge.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    }, e.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ], e.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ], e.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ], e.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ], e.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ], e.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ], e.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ], e;
}($12c6b0ab9da17bee$var$ge), $12c6b0ab9da17bee$var$cr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$fr = function(t) {
    function e(e) {
        var r = t.call(this) || this;
        r.readers = [];
        var n = e ? e.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS) : null, o = e && void 0 !== e.get($12c6b0ab9da17bee$var$T.ASSUME_CODE_39_CHECK_DIGIT);
        return n && ((n.includes($12c6b0ab9da17bee$var$nt.EAN_13) || n.includes($12c6b0ab9da17bee$var$nt.UPC_A) || n.includes($12c6b0ab9da17bee$var$nt.EAN_8) || n.includes($12c6b0ab9da17bee$var$nt.UPC_E)) && r.readers.push(new $12c6b0ab9da17bee$var$le(e)), n.includes($12c6b0ab9da17bee$var$nt.CODE_39) && r.readers.push(new $12c6b0ab9da17bee$var$Ut(o)), n.includes($12c6b0ab9da17bee$var$nt.CODE_128) && r.readers.push(new $12c6b0ab9da17bee$var$kt), n.includes($12c6b0ab9da17bee$var$nt.ITF) && r.readers.push(new $12c6b0ab9da17bee$var$Xt), n.includes($12c6b0ab9da17bee$var$nt.RSS_14) && r.readers.push(new $12c6b0ab9da17bee$var$sr), n.includes($12c6b0ab9da17bee$var$nt.RSS_EXPANDED) && (console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk."), r.readers.push(new $12c6b0ab9da17bee$var$nr))), 0 === r.readers.length && (r.readers.push(new $12c6b0ab9da17bee$var$le(e)), r.readers.push(new $12c6b0ab9da17bee$var$Ut), r.readers.push(new $12c6b0ab9da17bee$var$le(e)), r.readers.push(new $12c6b0ab9da17bee$var$kt), r.readers.push(new $12c6b0ab9da17bee$var$Xt), r.readers.push(new $12c6b0ab9da17bee$var$sr)), r;
    }
    return $12c6b0ab9da17bee$var$cr(e, t), e.prototype.decodeRow = function(t, e, r) {
        for(var n = 0; n < this.readers.length; n++)try {
            return this.readers[n].decodeRow(t, e, r);
        } catch (t) {}
        throw new $12c6b0ab9da17bee$var$U;
    }, e.prototype.reset = function() {
        this.readers.forEach(function(t) {
            return t.reset();
        });
    }, e;
}($12c6b0ab9da17bee$var$Lt), $12c6b0ab9da17bee$var$hr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$fr(r), e, r) || this;
    }
    $12c6b0ab9da17bee$var$hr(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$lr, $12c6b0ab9da17bee$var$dr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$pr = function() {
    function t(t, e, r) {
        this.ecCodewords = t, this.ecBlocks = [
            e
        ], r && this.ecBlocks.push(r);
    }
    return t.prototype.getECCodewords = function() {
        return this.ecCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $12c6b0ab9da17bee$var$gr = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $12c6b0ab9da17bee$var$yr = function() {
    function t(t, e, r, n, o, i) {
        var a, u;
        this.versionNumber = t, this.symbolSizeRows = e, this.symbolSizeColumns = r, this.dataRegionSizeRows = n, this.dataRegionSizeColumns = o, this.ecBlocks = i;
        var s = 0, c = i.getECCodewords(), f = i.getECBlocks();
        try {
            for(var h = $12c6b0ab9da17bee$var$dr(f), l = h.next(); !l.done; l = h.next()){
                var d = l.value;
                s += d.getCount() * (d.getDataCodewords() + c);
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (u = h.return) && u.call(h);
            } finally{
                if (a) throw a.error;
            }
        }
        this.totalCodewords = s;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    }, t.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    }, t.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    }, t.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t.getVersionForDimensions = function(e, r) {
        var n, o;
        if (0 != (1 & e) || 0 != (1 & r)) throw new $12c6b0ab9da17bee$var$R;
        try {
            for(var i = $12c6b0ab9da17bee$var$dr(t.VERSIONS), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (u.symbolSizeRows === e && u.symbolSizeColumns === r) return u;
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (o = i.return) && o.call(i);
            } finally{
                if (n) throw n.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.buildVersions = function() {
        return [
            new t(1, 10, 10, 8, 8, new $12c6b0ab9da17bee$var$pr(5, new $12c6b0ab9da17bee$var$gr(1, 3))),
            new t(2, 12, 12, 10, 10, new $12c6b0ab9da17bee$var$pr(7, new $12c6b0ab9da17bee$var$gr(1, 5))),
            new t(3, 14, 14, 12, 12, new $12c6b0ab9da17bee$var$pr(10, new $12c6b0ab9da17bee$var$gr(1, 8))),
            new t(4, 16, 16, 14, 14, new $12c6b0ab9da17bee$var$pr(12, new $12c6b0ab9da17bee$var$gr(1, 12))),
            new t(5, 18, 18, 16, 16, new $12c6b0ab9da17bee$var$pr(14, new $12c6b0ab9da17bee$var$gr(1, 18))),
            new t(6, 20, 20, 18, 18, new $12c6b0ab9da17bee$var$pr(18, new $12c6b0ab9da17bee$var$gr(1, 22))),
            new t(7, 22, 22, 20, 20, new $12c6b0ab9da17bee$var$pr(20, new $12c6b0ab9da17bee$var$gr(1, 30))),
            new t(8, 24, 24, 22, 22, new $12c6b0ab9da17bee$var$pr(24, new $12c6b0ab9da17bee$var$gr(1, 36))),
            new t(9, 26, 26, 24, 24, new $12c6b0ab9da17bee$var$pr(28, new $12c6b0ab9da17bee$var$gr(1, 44))),
            new t(10, 32, 32, 14, 14, new $12c6b0ab9da17bee$var$pr(36, new $12c6b0ab9da17bee$var$gr(1, 62))),
            new t(11, 36, 36, 16, 16, new $12c6b0ab9da17bee$var$pr(42, new $12c6b0ab9da17bee$var$gr(1, 86))),
            new t(12, 40, 40, 18, 18, new $12c6b0ab9da17bee$var$pr(48, new $12c6b0ab9da17bee$var$gr(1, 114))),
            new t(13, 44, 44, 20, 20, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(1, 144))),
            new t(14, 48, 48, 22, 22, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(1, 174))),
            new t(15, 52, 52, 24, 24, new $12c6b0ab9da17bee$var$pr(42, new $12c6b0ab9da17bee$var$gr(2, 102))),
            new t(16, 64, 64, 14, 14, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(2, 140))),
            new t(17, 72, 72, 16, 16, new $12c6b0ab9da17bee$var$pr(36, new $12c6b0ab9da17bee$var$gr(4, 92))),
            new t(18, 80, 80, 18, 18, new $12c6b0ab9da17bee$var$pr(48, new $12c6b0ab9da17bee$var$gr(4, 114))),
            new t(19, 88, 88, 20, 20, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(4, 144))),
            new t(20, 96, 96, 22, 22, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(4, 174))),
            new t(21, 104, 104, 24, 24, new $12c6b0ab9da17bee$var$pr(56, new $12c6b0ab9da17bee$var$gr(6, 136))),
            new t(22, 120, 120, 18, 18, new $12c6b0ab9da17bee$var$pr(68, new $12c6b0ab9da17bee$var$gr(6, 175))),
            new t(23, 132, 132, 20, 20, new $12c6b0ab9da17bee$var$pr(62, new $12c6b0ab9da17bee$var$gr(8, 163))),
            new t(24, 144, 144, 22, 22, new $12c6b0ab9da17bee$var$pr(62, new $12c6b0ab9da17bee$var$gr(8, 156), new $12c6b0ab9da17bee$var$gr(2, 155))),
            new t(25, 8, 18, 6, 16, new $12c6b0ab9da17bee$var$pr(7, new $12c6b0ab9da17bee$var$gr(1, 5))),
            new t(26, 8, 32, 6, 14, new $12c6b0ab9da17bee$var$pr(11, new $12c6b0ab9da17bee$var$gr(1, 10))),
            new t(27, 12, 26, 10, 24, new $12c6b0ab9da17bee$var$pr(14, new $12c6b0ab9da17bee$var$gr(1, 16))),
            new t(28, 12, 36, 10, 16, new $12c6b0ab9da17bee$var$pr(18, new $12c6b0ab9da17bee$var$gr(1, 22))),
            new t(29, 16, 36, 14, 16, new $12c6b0ab9da17bee$var$pr(24, new $12c6b0ab9da17bee$var$gr(1, 32))),
            new t(30, 16, 48, 14, 22, new $12c6b0ab9da17bee$var$pr(28, new $12c6b0ab9da17bee$var$gr(1, 49)))
        ];
    }, t.VERSIONS = t.buildVersions(), t;
}(), $12c6b0ab9da17bee$var$wr = function() {
    function t(e) {
        var r = e.getHeight();
        if (r < 8 || r > 144 || 0 != (1 & r)) throw new $12c6b0ab9da17bee$var$R;
        this.version = t.readVersion(e), this.mappingBitMatrix = this.extractDataRegion(e), this.readMappingMatrix = new $12c6b0ab9da17bee$var$x(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    return t.prototype.getVersion = function() {
        return this.version;
    }, t.readVersion = function(t) {
        var e = t.getHeight(), r = t.getWidth();
        return $12c6b0ab9da17bee$var$yr.getVersionForDimensions(e, r);
    }, t.prototype.readCodewords = function() {
        var t = new Int8Array(this.version.getTotalCodewords()), e = 0, r = 4, n = 0, o = this.mappingBitMatrix.getHeight(), i = this.mappingBitMatrix.getWidth(), a = !1, u = !1, s = !1, c = !1;
        do if (r !== o || 0 !== n || a) {
            if (r !== o - 2 || 0 !== n || 0 == (3 & i) || u) {
                if (r !== o + 4 || 2 !== n || 0 != (7 & i) || s) {
                    if (r !== o - 2 || 0 !== n || 4 != (7 & i) || c) {
                        do r < o && n >= 0 && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r -= 2, n += 2;
                        while (r >= 0 && n < i);
                        r += 1, n += 3;
                        do r >= 0 && n < i && !this.readMappingMatrix.get(n, r) && (t[e++] = 255 & this.readUtah(r, n, o, i)), r += 2, n -= 2;
                        while (r < o && n >= 0);
                        r += 3, n += 1;
                    } else t[e++] = 255 & this.readCorner4(o, i), r -= 2, n += 2, c = !0;
                } else t[e++] = 255 & this.readCorner3(o, i), r -= 2, n += 2, s = !0;
            } else t[e++] = 255 & this.readCorner2(o, i), r -= 2, n += 2, u = !0;
        } else t[e++] = 255 & this.readCorner1(o, i), r -= 2, n += 2, a = !0;
        while (r < o || n < i);
        if (e !== this.version.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$R;
        return t;
    }, t.prototype.readModule = function(t, e, r, n) {
        return t < 0 && (t += r, e += 4 - (r + 4 & 7)), e < 0 && (e += n, t += 4 - (n + 4 & 7)), this.readMappingMatrix.set(e, t), this.mappingBitMatrix.get(e, t);
    }, t.prototype.readUtah = function(t, e, r, n) {
        var o = 0;
        return this.readModule(t - 2, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 2, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t - 1, e, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 2, r, n) && (o |= 1), o <<= 1, this.readModule(t, e - 1, r, n) && (o |= 1), o <<= 1, this.readModule(t, e, r, n) && (o |= 1), o;
    }, t.prototype.readCorner1 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 1, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner2 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 4, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner3 = function(t, e) {
        var r = 0;
        return this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 3, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.readCorner4 = function(t, e) {
        var r = 0;
        return this.readModule(t - 3, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 2, 0, t, e) && (r |= 1), r <<= 1, this.readModule(t - 1, 0, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 2, t, e) && (r |= 1), r <<= 1, this.readModule(0, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(1, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(2, e - 1, t, e) && (r |= 1), r <<= 1, this.readModule(3, e - 1, t, e) && (r |= 1), r;
    }, t.prototype.extractDataRegion = function(t) {
        var e = this.version.getSymbolSizeRows(), r = this.version.getSymbolSizeColumns();
        if (t.getHeight() !== e) throw new $12c6b0ab9da17bee$var$l("Dimension of bitMatrix must match the version size");
        for(var n = this.version.getDataRegionSizeRows(), o = this.version.getDataRegionSizeColumns(), i = e / n | 0, a = r / o | 0, u = new $12c6b0ab9da17bee$var$x(a * o, i * n), s = 0; s < i; ++s)for(var c = s * n, f = 0; f < a; ++f)for(var h = f * o, d = 0; d < n; ++d)for(var p = s * (n + 2) + 1 + d, g = c + d, y = 0; y < o; ++y){
            var w = f * (o + 2) + 1 + y;
            if (t.get(w, p)) {
                var _ = h + y;
                u.set(_, g);
            }
        }
        return u;
    }, t;
}(), $12c6b0ab9da17bee$var$_r = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$vr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r) {
        var n, o, i, a, u = r.getECBlocks(), s = 0, c = u.getECBlocks();
        try {
            for(var f = $12c6b0ab9da17bee$var$_r(c), h = f.next(); !h.done; h = f.next())s += (w = h.value).getCount();
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (o = f.return) && o.call(f);
            } finally{
                if (n) throw n.error;
            }
        }
        var d = new Array(s), p = 0;
        try {
            for(var g = $12c6b0ab9da17bee$var$_r(c), y = g.next(); !y.done; y = g.next())for(var w = y.value, _ = 0; _ < w.getCount(); _++){
                var v = w.getDataCodewords(), m = u.getECCodewords() + v;
                d[p++] = new t(v, new Uint8Array(m));
            }
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (a = g.return) && a.call(g);
            } finally{
                if (i) throw i.error;
            }
        }
        var A = d[0].codewords.length - u.getECCodewords(), E = A - 1, C = 0;
        for(_ = 0; _ < E; _++)for(var I = 0; I < p; I++)d[I].codewords[_] = e[C++];
        var S = 24 === r.getVersionNumber(), O = S ? 8 : p;
        for(I = 0; I < O; I++)d[I].codewords[A - 1] = e[C++];
        var T = d[0].codewords.length;
        for(_ = A; _ < T; _++)for(I = 0; I < p; I++){
            var b = S ? (I + 8) % p : I, R = S && b > 7 ? _ - 1 : _;
            d[b].codewords[R] = e[C++];
        }
        if (C !== e.length) throw new $12c6b0ab9da17bee$var$l;
        return d;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}(), $12c6b0ab9da17bee$var$mr = function() {
    function t(t) {
        this.bytes = t, this.byteOffset = 0, this.bitOffset = 0;
    }
    return t.prototype.getBitOffset = function() {
        return this.bitOffset;
    }, t.prototype.getByteOffset = function() {
        return this.byteOffset;
    }, t.prototype.readBits = function(t) {
        if (t < 1 || t > 32 || t > this.available()) throw new $12c6b0ab9da17bee$var$l("" + t);
        var e = 0, r = this.bitOffset, n = this.byteOffset, o = this.bytes;
        if (r > 0) {
            var i = 8 - r, a = t < i ? t : i, u = 255 >> 8 - a << (s = i - a);
            e = (o[n] & u) >> s, t -= a, 8 === (r += a) && (r = 0, n++);
        }
        if (t > 0) {
            for(; t >= 8;)e = e << 8 | 255 & o[n], n++, t -= 8;
            if (t > 0) {
                var s;
                u = 255 >> (s = 8 - t) << s;
                e = e << t | (o[n] & u) >> s, r += t;
            }
        }
        return this.bitOffset = r, this.byteOffset = n, e;
    }, t.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }, t;
}();
!function(t) {
    t[t.PAD_ENCODE = 0] = "PAD_ENCODE", t[t.ASCII_ENCODE = 1] = "ASCII_ENCODE", t[t.C40_ENCODE = 2] = "C40_ENCODE", t[t.TEXT_ENCODE = 3] = "TEXT_ENCODE", t[t.ANSIX12_ENCODE = 4] = "ANSIX12_ENCODE", t[t.EDIFACT_ENCODE = 5] = "EDIFACT_ENCODE", t[t.BASE256_ENCODE = 6] = "BASE256_ENCODE";
}($12c6b0ab9da17bee$var$lr || ($12c6b0ab9da17bee$var$lr = {}));
var $12c6b0ab9da17bee$var$Ar, $12c6b0ab9da17bee$var$Er = function() {
    function t() {}
    return t.decode = function(t) {
        var e = new $12c6b0ab9da17bee$var$mr(t), r = new $12c6b0ab9da17bee$var$k, n = new $12c6b0ab9da17bee$var$k, o = new Array, i = $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
        do if (i === $12c6b0ab9da17bee$var$lr.ASCII_ENCODE) i = this.decodeAsciiSegment(e, r, n);
        else {
            switch(i){
                case $12c6b0ab9da17bee$var$lr.C40_ENCODE:
                    this.decodeC40Segment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.TEXT_ENCODE:
                    this.decodeTextSegment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(e, r);
                    break;
                case $12c6b0ab9da17bee$var$lr.BASE256_ENCODE:
                    this.decodeBase256Segment(e, r, o);
                    break;
                default:
                    throw new $12c6b0ab9da17bee$var$R;
            }
            i = $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
        }
        while (i !== $12c6b0ab9da17bee$var$lr.PAD_ENCODE && e.available() > 0);
        return n.length() > 0 && r.append(n.toString()), new $12c6b0ab9da17bee$var$at(t, r.toString(), 0 === o.length ? null : o, null);
    }, t.decodeAsciiSegment = function(t, e, r) {
        var n = !1;
        do {
            var o = t.readBits(8);
            if (0 === o) throw new $12c6b0ab9da17bee$var$R;
            if (o <= 128) return n && (o += 128), e.append(String.fromCharCode(o - 1)), $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
            if (129 === o) return $12c6b0ab9da17bee$var$lr.PAD_ENCODE;
            if (o <= 229) {
                var i = o - 130;
                i < 10 && e.append("0"), e.append("" + i);
            } else switch(o){
                case 230:
                    return $12c6b0ab9da17bee$var$lr.C40_ENCODE;
                case 231:
                    return $12c6b0ab9da17bee$var$lr.BASE256_ENCODE;
                case 232:
                    e.append(String.fromCharCode(29));
                    break;
                case 233:
                case 234:
                case 241:
                    break;
                case 235:
                    n = !0;
                    break;
                case 236:
                    e.append("[)>\x1e05\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 237:
                    e.append("[)>\x1e06\x1d"), r.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $12c6b0ab9da17bee$var$lr.ANSIX12_ENCODE;
                case 239:
                    return $12c6b0ab9da17bee$var$lr.TEXT_ENCODE;
                case 240:
                    return $12c6b0ab9da17bee$var$lr.EDIFACT_ENCODE;
                default:
                    if (254 !== o || 0 !== t.available()) throw new $12c6b0ab9da17bee$var$R;
            }
        }while (t.available() > 0);
        return $12c6b0ab9da17bee$var$lr.ASCII_ENCODE;
    }, t.decodeC40Segment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.C40_BASIC_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                            var s = this.C40_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.C40_SHIFT2_SET_CHARS.length) {
                            s = this.C40_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                        o = 0;
                        break;
                    case 3:
                        r ? (e.append(String.fromCharCode(u + 224)), r = !1) : e.append(String.fromCharCode(u + 96)), o = 0;
                        break;
                    default:
                        throw new $12c6b0ab9da17bee$var$R;
                }
            }
        }while (t.available() > 0);
    }, t.decodeTextSegment = function(t, e) {
        var r = !1, n = [], o = 0;
        do {
            if (8 === t.available()) return;
            var i = t.readBits(8);
            if (254 === i) return;
            this.parseTwoBytes(i, t.readBits(8), n);
            for(var a = 0; a < 3; a++){
                var u = n[a];
                switch(o){
                    case 0:
                        if (u < 3) o = u + 1;
                        else {
                            if (!(u < this.TEXT_BASIC_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                            var s = this.TEXT_BASIC_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        }
                        break;
                    case 1:
                        r ? (e.append(String.fromCharCode(u + 128)), r = !1) : e.append(String.fromCharCode(u)), o = 0;
                        break;
                    case 2:
                        if (u < this.TEXT_SHIFT2_SET_CHARS.length) {
                            s = this.TEXT_SHIFT2_SET_CHARS[u];
                            r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s);
                        } else switch(u){
                            case 27:
                                e.append(String.fromCharCode(29));
                                break;
                            case 30:
                                r = !0;
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                        o = 0;
                        break;
                    case 3:
                        if (!(u < this.TEXT_SHIFT3_SET_CHARS.length)) throw new $12c6b0ab9da17bee$var$R;
                        s = this.TEXT_SHIFT3_SET_CHARS[u];
                        r ? (e.append(String.fromCharCode(s.charCodeAt(0) + 128)), r = !1) : e.append(s), o = 0;
                        break;
                    default:
                        throw new $12c6b0ab9da17bee$var$R;
                }
            }
        }while (t.available() > 0);
    }, t.decodeAnsiX12Segment = function(t, e) {
        var r = [];
        do {
            if (8 === t.available()) return;
            var n = t.readBits(8);
            if (254 === n) return;
            this.parseTwoBytes(n, t.readBits(8), r);
            for(var o = 0; o < 3; o++){
                var i = r[o];
                switch(i){
                    case 0:
                        e.append("\r");
                        break;
                    case 1:
                        e.append("*");
                        break;
                    case 2:
                        e.append(">");
                        break;
                    case 3:
                        e.append(" ");
                        break;
                    default:
                        if (i < 14) e.append(String.fromCharCode(i + 44));
                        else {
                            if (!(i < 40)) throw new $12c6b0ab9da17bee$var$R;
                            e.append(String.fromCharCode(i + 51));
                        }
                }
            }
        }while (t.available() > 0);
    }, t.parseTwoBytes = function(t, e, r) {
        var n = (t << 8) + e - 1, o = Math.floor(n / 1600);
        r[0] = o, n -= 1600 * o, o = Math.floor(n / 40), r[1] = o, r[2] = n - 40 * o;
    }, t.decodeEdifactSegment = function(t, e) {
        do {
            if (t.available() <= 16) return;
            for(var r = 0; r < 4; r++){
                var n = t.readBits(6);
                if (31 === n) {
                    var o = 8 - t.getBitOffset();
                    return void (8 !== o && t.readBits(o));
                }
                0 == (32 & n) && (n |= 64), e.append(String.fromCharCode(n));
            }
        }while (t.available() > 0);
    }, t.decodeBase256Segment = function(t, e, r) {
        var n, o = 1 + t.getByteOffset(), i = this.unrandomize255State(t.readBits(8), o++);
        if ((n = 0 === i ? t.available() / 8 | 0 : i < 250 ? i : 250 * (i - 249) + this.unrandomize255State(t.readBits(8), o++)) < 0) throw new $12c6b0ab9da17bee$var$R;
        for(var a = new Uint8Array(n), u = 0; u < n; u++){
            if (t.available() < 8) throw new $12c6b0ab9da17bee$var$R;
            a[u] = this.unrandomize255State(t.readBits(8), o++);
        }
        r.push(a);
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(a, $12c6b0ab9da17bee$var$F.ISO88591));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$yt("Platform does not support required encoding: " + t.message);
        }
    }, t.unrandomize255State = function(t, e) {
        var r = t - (149 * e % 255 + 1);
        return r >= 0 ? r : r + 256;
    }, t.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ], t.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ], t.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.TEXT_SHIFT2_SET_CHARS = t.C40_SHIFT2_SET_CHARS, t.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ], t;
}(), $12c6b0ab9da17bee$var$Cr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Ir = function() {
    function t() {
        this.rsDecoder = new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.DATA_MATRIX_FIELD_256);
    }
    return t.prototype.decode = function(t) {
        var e, r, n = new $12c6b0ab9da17bee$var$wr(t), o = n.getVersion(), i = n.readCodewords(), a = $12c6b0ab9da17bee$var$vr.getDataBlocks(i, o), u = 0;
        try {
            for(var s = $12c6b0ab9da17bee$var$Cr(a), c = s.next(); !c.done; c = s.next())u += c.value.getNumDataCodewords();
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        for(var f = new Uint8Array(u), h = a.length, l = 0; l < h; l++){
            var d = a[l], p = d.getCodewords(), g = d.getNumDataCodewords();
            this.correctErrors(p, g);
            for(var y = 0; y < g; y++)f[y * h + l] = p[y];
        }
        return $12c6b0ab9da17bee$var$Er.decode(f);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$g;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $12c6b0ab9da17bee$var$Sr = function() {
    function t(t) {
        this.image = t, this.rectangleDetector = new $12c6b0ab9da17bee$var$St(this.image);
    }
    return t.prototype.detect = function() {
        var e = this.rectangleDetector.detect(), r = this.detectSolid1(e);
        if ((r = this.detectSolid2(r))[3] = this.correctTopRight(r), !r[3]) throw new $12c6b0ab9da17bee$var$U;
        var n = (r = this.shiftToModuleCenter(r))[0], o = r[1], i = r[2], a = r[3], u = this.transitionsBetween(n, a) + 1, s = this.transitionsBetween(i, a) + 1;
        1 == (1 & u) && (u += 1), 1 == (1 & s) && (s += 1), 4 * u < 7 * s && 4 * s < 7 * u && (u = s = Math.max(u, s));
        var c = t.sampleGrid(this.image, n, o, i, a, u, s);
        return new $12c6b0ab9da17bee$var$Et(c, [
            n,
            o,
            i,
            a
        ]);
    }, t.shiftPoint = function(t, e, r) {
        var n = (e.getX() - t.getX()) / (r + 1), o = (e.getY() - t.getY()) / (r + 1);
        return new $12c6b0ab9da17bee$var$At(t.getX() + n, t.getY() + o);
    }, t.moveAway = function(t, e, r) {
        var n = t.getX(), o = t.getY();
        return n < e ? n -= 1 : n += 1, o < r ? o -= 1 : o += 1, new $12c6b0ab9da17bee$var$At(n, o);
    }, t.prototype.detectSolid1 = function(t) {
        var e = t[0], r = t[1], n = t[3], o = t[2], i = this.transitionsBetween(e, r), a = this.transitionsBetween(r, n), u = this.transitionsBetween(n, o), s = this.transitionsBetween(o, e), c = i, f = [
            o,
            e,
            r,
            n
        ];
        return c > a && (c = a, f[0] = e, f[1] = r, f[2] = n, f[3] = o), c > u && (c = u, f[0] = r, f[1] = n, f[2] = o, f[3] = e), c > s && (f[0] = n, f[1] = o, f[2] = e, f[3] = r), f;
    }, t.prototype.detectSolid2 = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = t.shiftPoint(n, o, 4 * (a + 1)), s = t.shiftPoint(o, n, 4 * (a + 1));
        return this.transitionsBetween(u, r) < this.transitionsBetween(s, i) ? (e[0] = r, e[1] = n, e[2] = o, e[3] = i) : (e[0] = n, e[1] = o, e[2] = i, e[3] = r), e;
    }, t.prototype.correctTopRight = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i), u = this.transitionsBetween(n, i), s = t.shiftPoint(r, n, 4 * (u + 1)), c = t.shiftPoint(o, n, 4 * (a + 1));
        a = this.transitionsBetween(s, i), u = this.transitionsBetween(c, i);
        var f = new $12c6b0ab9da17bee$var$At(i.getX() + (o.getX() - n.getX()) / (a + 1), i.getY() + (o.getY() - n.getY()) / (a + 1)), h = new $12c6b0ab9da17bee$var$At(i.getX() + (r.getX() - n.getX()) / (u + 1), i.getY() + (r.getY() - n.getY()) / (u + 1));
        return this.isValid(f) ? this.isValid(h) ? this.transitionsBetween(s, f) + this.transitionsBetween(c, f) > this.transitionsBetween(s, h) + this.transitionsBetween(c, h) ? f : h : f : this.isValid(h) ? h : null;
    }, t.prototype.shiftToModuleCenter = function(e) {
        var r = e[0], n = e[1], o = e[2], i = e[3], a = this.transitionsBetween(r, i) + 1, u = this.transitionsBetween(o, i) + 1, s = t.shiftPoint(r, n, 4 * u), c = t.shiftPoint(o, n, 4 * a);
        1 == (1 & (a = this.transitionsBetween(s, i) + 1)) && (a += 1), 1 == (1 & (u = this.transitionsBetween(c, i) + 1)) && (u += 1);
        var f, h, l = (r.getX() + n.getX() + o.getX() + i.getX()) / 4, d = (r.getY() + n.getY() + o.getY() + i.getY()) / 4;
        return r = t.moveAway(r, l, d), n = t.moveAway(n, l, d), o = t.moveAway(o, l, d), i = t.moveAway(i, l, d), s = t.shiftPoint(r, n, 4 * u), s = t.shiftPoint(s, i, 4 * a), f = t.shiftPoint(n, r, 4 * u), f = t.shiftPoint(f, o, 4 * a), c = t.shiftPoint(o, i, 4 * u), c = t.shiftPoint(c, n, 4 * a), h = t.shiftPoint(i, o, 4 * u), [
            s,
            f,
            c,
            h = t.shiftPoint(h, r, 4 * a)
        ];
    }, t.prototype.isValid = function(t) {
        return t.getX() >= 0 && t.getX() < this.image.getWidth() && t.getY() > 0 && t.getY() < this.image.getHeight();
    }, t.sampleGrid = function(t, e, r, n, o, i, a) {
        return $12c6b0ab9da17bee$var$Nt.getInstance().sampleGrid(t, i, a, .5, .5, i - .5, .5, i - .5, a - .5, .5, a - .5, e.getX(), e.getY(), o.getX(), o.getY(), n.getX(), n.getY(), r.getX(), r.getY());
    }, t.prototype.transitionsBetween = function(t, e) {
        var r = Math.trunc(t.getX()), n = Math.trunc(t.getY()), o = Math.trunc(e.getX()), i = Math.trunc(e.getY()), a = Math.abs(i - n) > Math.abs(o - r);
        if (a) {
            var u = r;
            r = n, n = u, u = o, o = i, i = u;
        }
        for(var s = Math.abs(o - r), c = Math.abs(i - n), f = -s / 2, h = n < i ? 1 : -1, l = r < o ? 1 : -1, d = 0, p = this.image.get(a ? n : r, a ? r : n), g = r, y = n; g !== o; g += l){
            var w = this.image.get(a ? y : g, a ? g : y);
            if (w !== p && (d++, p = w), (f += c) > 0) {
                if (y === i) break;
                y += h, f -= s;
            }
        }
        return d;
    }, t;
}(), $12c6b0ab9da17bee$var$Or = function() {
    function t() {
        this.decoder = new $12c6b0ab9da17bee$var$Ir;
    }
    return t.prototype.decode = function(e, r) {
        var n, o;
        if (void 0 === r && (r = null), null != r && r.has($12c6b0ab9da17bee$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decode(i), o = t.NO_POINTS;
        } else {
            var a = new $12c6b0ab9da17bee$var$Sr(e.getBlackMatrix()).detect();
            n = this.decoder.decode(a.getBits()), o = a.getPoints();
        }
        var u = n.getRawBytes(), s = new $12c6b0ab9da17bee$var$et(n.getText(), u, 8 * u.length, o, $12c6b0ab9da17bee$var$nt.DATA_MATRIX, $12c6b0ab9da17bee$var$w.currentTimeMillis()), c = n.getByteSegments();
        null != c && s.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, c);
        var f = n.getECLevel();
        return null != f && s.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, f), s;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null == e || null == r) throw new $12c6b0ab9da17bee$var$U;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = (r[0] - a + 1) / n, s = (i - o + 1) / n;
        if (u <= 0 || s <= 0) throw new $12c6b0ab9da17bee$var$U;
        var c = n / 2;
        o += c, a += c;
        for(var f = new $12c6b0ab9da17bee$var$x(u, s), h = 0; h < s; h++)for(var l = o + h * n, d = 0; d < u; d++)t.get(a + d * n, l) && f.set(d, h);
        return f;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getWidth(), n = t[0], o = t[1]; n < r && e.get(n, o);)n++;
        if (n === r) throw new $12c6b0ab9da17bee$var$U;
        var i = n - t[0];
        if (0 === i) throw new $12c6b0ab9da17bee$var$U;
        return i;
    }, t.NO_POINTS = [], t;
}(), $12c6b0ab9da17bee$var$Tr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Or, e) || this;
    }
    $12c6b0ab9da17bee$var$Tr(e, t);
}($12c6b0ab9da17bee$var$tt), function(t) {
    t[t.L = 0] = "L", t[t.M = 1] = "M", t[t.Q = 2] = "Q", t[t.H = 3] = "H";
}($12c6b0ab9da17bee$var$Ar || ($12c6b0ab9da17bee$var$Ar = {}));
var $12c6b0ab9da17bee$var$br, $12c6b0ab9da17bee$var$Rr = function() {
    function t(e, r, n) {
        this.value = e, this.stringValue = r, this.bits = n, t.FOR_BITS.set(n, this), t.FOR_VALUE.set(e, this);
    }
    return t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.fromString = function(e) {
        switch(e){
            case "L":
                return t.L;
            case "M":
                return t.M;
            case "Q":
                return t.Q;
            case "H":
                return t.H;
            default:
                throw new $12c6b0ab9da17bee$var$f(e + "not available");
        }
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.forBits = function(e) {
        if (e < 0 || e >= t.FOR_BITS.size) throw new $12c6b0ab9da17bee$var$l;
        return t.FOR_BITS.get(e);
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.L = new t($12c6b0ab9da17bee$var$Ar.L, "L", 1), t.M = new t($12c6b0ab9da17bee$var$Ar.M, "M", 0), t.Q = new t($12c6b0ab9da17bee$var$Ar.Q, "Q", 3), t.H = new t($12c6b0ab9da17bee$var$Ar.H, "H", 2), t;
}(), $12c6b0ab9da17bee$var$Nr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Dr = function() {
    function t(t) {
        this.errorCorrectionLevel = $12c6b0ab9da17bee$var$Rr.forBits(t >> 3 & 3), this.dataMask = 7 & t;
    }
    return t.numBitsDiffering = function(t, e) {
        return $12c6b0ab9da17bee$var$I.bitCount(t ^ e);
    }, t.decodeFormatInformation = function(e, r) {
        var n = t.doDecodeFormatInformation(e, r);
        return null !== n ? n : t.doDecodeFormatInformation(e ^ t.FORMAT_INFO_MASK_QR, r ^ t.FORMAT_INFO_MASK_QR);
    }, t.doDecodeFormatInformation = function(e, r) {
        var n, o, i = Number.MAX_SAFE_INTEGER, a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$Nr(t.FORMAT_INFO_DECODE_LOOKUP), s = u.next(); !s.done; s = u.next()){
                var c = s.value, f = c[0];
                if (f === e || f === r) return new t(c[1]);
                var h = t.numBitsDiffering(e, f);
                h < i && (a = c[1], i = h), e !== r && (h = t.numBitsDiffering(r, f)) < i && (a = c[1], i = h);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (o = u.return) && o.call(u);
            } finally{
                if (n) throw n.error;
            }
        }
        return i <= 3 ? new t(a) : null;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getDataMask = function() {
        return this.dataMask;
    }, t.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.errorCorrectionLevel === r.errorCorrectionLevel && this.dataMask === r.dataMask;
    }, t.FORMAT_INFO_MASK_QR = 21522, t.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            21522,
            0
        ]),
        Int32Array.from([
            20773,
            1
        ]),
        Int32Array.from([
            24188,
            2
        ]),
        Int32Array.from([
            23371,
            3
        ]),
        Int32Array.from([
            17913,
            4
        ]),
        Int32Array.from([
            16590,
            5
        ]),
        Int32Array.from([
            20375,
            6
        ]),
        Int32Array.from([
            19104,
            7
        ]),
        Int32Array.from([
            30660,
            8
        ]),
        Int32Array.from([
            29427,
            9
        ]),
        Int32Array.from([
            32170,
            10
        ]),
        Int32Array.from([
            30877,
            11
        ]),
        Int32Array.from([
            26159,
            12
        ]),
        Int32Array.from([
            25368,
            13
        ]),
        Int32Array.from([
            27713,
            14
        ]),
        Int32Array.from([
            26998,
            15
        ]),
        Int32Array.from([
            5769,
            16
        ]),
        Int32Array.from([
            5054,
            17
        ]),
        Int32Array.from([
            7399,
            18
        ]),
        Int32Array.from([
            6608,
            19
        ]),
        Int32Array.from([
            1890,
            20
        ]),
        Int32Array.from([
            597,
            21
        ]),
        Int32Array.from([
            3340,
            22
        ]),
        Int32Array.from([
            2107,
            23
        ]),
        Int32Array.from([
            13663,
            24
        ]),
        Int32Array.from([
            12392,
            25
        ]),
        Int32Array.from([
            16177,
            26
        ]),
        Int32Array.from([
            14854,
            27
        ]),
        Int32Array.from([
            9396,
            28
        ]),
        Int32Array.from([
            8579,
            29
        ]),
        Int32Array.from([
            11994,
            30
        ]),
        Int32Array.from([
            11245,
            31
        ])
    ], t;
}(), $12c6b0ab9da17bee$var$Pr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Mr = function() {
    function t(t) {
        for(var e = [], r = 1; r < arguments.length; r++)e[r - 1] = arguments[r];
        this.ecCodewordsPerBlock = t, this.ecBlocks = e;
    }
    return t.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    }, t.prototype.getNumBlocks = function() {
        var t, e, r = 0, n = this.ecBlocks;
        try {
            for(var o = $12c6b0ab9da17bee$var$Pr(n), i = o.next(); !i.done; i = o.next())r += i.value.getCount();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r;
    }, t.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    }, t.prototype.getECBlocks = function() {
        return this.ecBlocks;
    }, t;
}(), $12c6b0ab9da17bee$var$Br = function() {
    function t(t, e) {
        this.count = t, this.dataCodewords = e;
    }
    return t.prototype.getCount = function() {
        return this.count;
    }, t.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    }, t;
}(), $12c6b0ab9da17bee$var$Lr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Fr = function() {
    function t(t, e) {
        for(var r, n, o = [], i = 2; i < arguments.length; i++)o[i - 2] = arguments[i];
        this.versionNumber = t, this.alignmentPatternCenters = e, this.ecBlocks = o;
        var a = 0, u = o[0].getECCodewordsPerBlock(), s = o[0].getECBlocks();
        try {
            for(var c = $12c6b0ab9da17bee$var$Lr(s), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                a += h.getCount() * (h.getDataCodewords() + u);
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (n = c.return) && n.call(c);
            } finally{
                if (r) throw r.error;
            }
        }
        this.totalCodewords = a;
    }
    return t.prototype.getVersionNumber = function() {
        return this.versionNumber;
    }, t.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    }, t.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    }, t.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    }, t.prototype.getECBlocksForLevel = function(t) {
        return this.ecBlocks[t.getValue()];
    }, t.getProvisionalVersionForDimension = function(t) {
        if (t % 4 != 1) throw new $12c6b0ab9da17bee$var$R;
        try {
            return this.getVersionForNumber((t - 17) / 4);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R;
        }
    }, t.getVersionForNumber = function(e) {
        if (e < 1 || e > 40) throw new $12c6b0ab9da17bee$var$l;
        return t.VERSIONS[e - 1];
    }, t.decodeVersionInformation = function(e) {
        for(var r = Number.MAX_SAFE_INTEGER, n = 0, o = 0; o < t.VERSION_DECODE_INFO.length; o++){
            var i = t.VERSION_DECODE_INFO[o];
            if (i === e) return t.getVersionForNumber(o + 7);
            var a = $12c6b0ab9da17bee$var$Dr.numBitsDiffering(e, i);
            a < r && (n = o + 7, r = a);
        }
        return r <= 3 ? t.getVersionForNumber(n) : null;
    }, t.prototype.buildFunctionPattern = function() {
        var t = this.getDimensionForVersion(), e = new $12c6b0ab9da17bee$var$x(t);
        e.setRegion(0, 0, 9, 9), e.setRegion(t - 8, 0, 8, 9), e.setRegion(0, t - 8, 9, 8);
        for(var r = this.alignmentPatternCenters.length, n = 0; n < r; n++)for(var o = this.alignmentPatternCenters[n] - 2, i = 0; i < r; i++)0 === n && (0 === i || i === r - 1) || n === r - 1 && 0 === i || e.setRegion(this.alignmentPatternCenters[i] - 2, o, 5, 5);
        return e.setRegion(6, 9, 1, t - 17), e.setRegion(9, 6, t - 17, 1), this.versionNumber > 6 && (e.setRegion(t - 11, 0, 3, 6), e.setRegion(0, t - 11, 6, 3)), e;
    }, t.prototype.toString = function() {
        return "" + this.versionNumber;
    }, t.VERSION_DECODE_INFO = Int32Array.from([
        31892,
        34236,
        39577,
        42195,
        48118,
        51042,
        55367,
        58893,
        63784,
        68472,
        70749,
        76311,
        79154,
        84390,
        87683,
        92361,
        96236,
        102084,
        102881,
        110507,
        110734,
        117786,
        119615,
        126325,
        127568,
        133589,
        136944,
        141498,
        145311,
        150283,
        152622,
        158308,
        161089,
        167017
    ]), t.VERSIONS = [
        new t(1, new Int32Array(0), new $12c6b0ab9da17bee$var$Mr(7, new $12c6b0ab9da17bee$var$Br(1, 19)), new $12c6b0ab9da17bee$var$Mr(10, new $12c6b0ab9da17bee$var$Br(1, 16)), new $12c6b0ab9da17bee$var$Mr(13, new $12c6b0ab9da17bee$var$Br(1, 13)), new $12c6b0ab9da17bee$var$Mr(17, new $12c6b0ab9da17bee$var$Br(1, 9))),
        new t(2, Int32Array.from([
            6,
            18
        ]), new $12c6b0ab9da17bee$var$Mr(10, new $12c6b0ab9da17bee$var$Br(1, 34)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(1, 28)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(1, 22)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 16))),
        new t(3, Int32Array.from([
            6,
            22
        ]), new $12c6b0ab9da17bee$var$Mr(15, new $12c6b0ab9da17bee$var$Br(1, 55)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(1, 44)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 17)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 13))),
        new t(4, Int32Array.from([
            6,
            26
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(1, 80)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 32)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(2, 24)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(4, 9))),
        new t(5, Int32Array.from([
            6,
            30
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(1, 108)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 43)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 15), new $12c6b0ab9da17bee$var$Br(2, 16)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 11), new $12c6b0ab9da17bee$var$Br(2, 12))),
        new t(6, Int32Array.from([
            6,
            34
        ]), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 68)), new $12c6b0ab9da17bee$var$Mr(16, new $12c6b0ab9da17bee$var$Br(4, 27)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 19)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 15))),
        new t(7, Int32Array.from([
            6,
            22,
            38
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(2, 78)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(4, 31)), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(4, 15)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 13), new $12c6b0ab9da17bee$var$Br(1, 14))),
        new t(8, Int32Array.from([
            6,
            24,
            42
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 97)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(2, 38), new $12c6b0ab9da17bee$var$Br(2, 39)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(4, 18), new $12c6b0ab9da17bee$var$Br(2, 19)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 14), new $12c6b0ab9da17bee$var$Br(2, 15))),
        new t(9, Int32Array.from([
            6,
            26,
            46
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(2, 116)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(3, 36), new $12c6b0ab9da17bee$var$Br(2, 37)), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(4, 16), new $12c6b0ab9da17bee$var$Br(4, 17)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 12), new $12c6b0ab9da17bee$var$Br(4, 13))),
        new t(10, Int32Array.from([
            6,
            28,
            50
        ]), new $12c6b0ab9da17bee$var$Mr(18, new $12c6b0ab9da17bee$var$Br(2, 68), new $12c6b0ab9da17bee$var$Br(2, 69)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 43), new $12c6b0ab9da17bee$var$Br(1, 44)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(6, 19), new $12c6b0ab9da17bee$var$Br(2, 20)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 15), new $12c6b0ab9da17bee$var$Br(2, 16))),
        new t(11, Int32Array.from([
            6,
            30,
            54
        ]), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(4, 81)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(1, 50), new $12c6b0ab9da17bee$var$Br(4, 51)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 22), new $12c6b0ab9da17bee$var$Br(4, 23)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(3, 12), new $12c6b0ab9da17bee$var$Br(8, 13))),
        new t(12, Int32Array.from([
            6,
            32,
            58
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(2, 92), new $12c6b0ab9da17bee$var$Br(2, 93)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(6, 36), new $12c6b0ab9da17bee$var$Br(2, 37)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 20), new $12c6b0ab9da17bee$var$Br(6, 21)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(7, 14), new $12c6b0ab9da17bee$var$Br(4, 15))),
        new t(13, Int32Array.from([
            6,
            34,
            62
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(4, 107)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(8, 37), new $12c6b0ab9da17bee$var$Br(1, 38)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(8, 20), new $12c6b0ab9da17bee$var$Br(4, 21)), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(12, 11), new $12c6b0ab9da17bee$var$Br(4, 12))),
        new t(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 115), new $12c6b0ab9da17bee$var$Br(1, 116)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(4, 40), new $12c6b0ab9da17bee$var$Br(5, 41)), new $12c6b0ab9da17bee$var$Mr(20, new $12c6b0ab9da17bee$var$Br(11, 16), new $12c6b0ab9da17bee$var$Br(5, 17)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(11, 12), new $12c6b0ab9da17bee$var$Br(5, 13))),
        new t(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new $12c6b0ab9da17bee$var$Mr(22, new $12c6b0ab9da17bee$var$Br(5, 87), new $12c6b0ab9da17bee$var$Br(1, 88)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(5, 41), new $12c6b0ab9da17bee$var$Br(5, 42)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 24), new $12c6b0ab9da17bee$var$Br(7, 25)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(11, 12), new $12c6b0ab9da17bee$var$Br(7, 13))),
        new t(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(5, 98), new $12c6b0ab9da17bee$var$Br(1, 99)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(7, 45), new $12c6b0ab9da17bee$var$Br(3, 46)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(15, 19), new $12c6b0ab9da17bee$var$Br(2, 20)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 15), new $12c6b0ab9da17bee$var$Br(13, 16))),
        new t(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 107), new $12c6b0ab9da17bee$var$Br(5, 108)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 46), new $12c6b0ab9da17bee$var$Br(1, 47)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(1, 22), new $12c6b0ab9da17bee$var$Br(15, 23)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(17, 15))),
        new t(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 120), new $12c6b0ab9da17bee$var$Br(1, 121)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(9, 43), new $12c6b0ab9da17bee$var$Br(4, 44)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 22), new $12c6b0ab9da17bee$var$Br(1, 23)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 14), new $12c6b0ab9da17bee$var$Br(19, 15))),
        new t(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 113), new $12c6b0ab9da17bee$var$Br(4, 114)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(3, 44), new $12c6b0ab9da17bee$var$Br(11, 45)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(17, 21), new $12c6b0ab9da17bee$var$Br(4, 22)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(9, 13), new $12c6b0ab9da17bee$var$Br(16, 14))),
        new t(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 107), new $12c6b0ab9da17bee$var$Br(5, 108)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(3, 41), new $12c6b0ab9da17bee$var$Br(13, 42)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(15, 24), new $12c6b0ab9da17bee$var$Br(5, 25)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(15, 15), new $12c6b0ab9da17bee$var$Br(10, 16))),
        new t(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 116), new $12c6b0ab9da17bee$var$Br(4, 117)), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(17, 42)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 22), new $12c6b0ab9da17bee$var$Br(6, 23)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 16), new $12c6b0ab9da17bee$var$Br(6, 17))),
        new t(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 111), new $12c6b0ab9da17bee$var$Br(7, 112)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(17, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 24), new $12c6b0ab9da17bee$var$Br(16, 25)), new $12c6b0ab9da17bee$var$Mr(24, new $12c6b0ab9da17bee$var$Br(34, 13))),
        new t(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 121), new $12c6b0ab9da17bee$var$Br(5, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(4, 47), new $12c6b0ab9da17bee$var$Br(14, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(16, 15), new $12c6b0ab9da17bee$var$Br(14, 16))),
        new t(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(6, 117), new $12c6b0ab9da17bee$var$Br(4, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 45), new $12c6b0ab9da17bee$var$Br(14, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 24), new $12c6b0ab9da17bee$var$Br(16, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(30, 16), new $12c6b0ab9da17bee$var$Br(2, 17))),
        new t(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new $12c6b0ab9da17bee$var$Mr(26, new $12c6b0ab9da17bee$var$Br(8, 106), new $12c6b0ab9da17bee$var$Br(4, 107)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(8, 47), new $12c6b0ab9da17bee$var$Br(13, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 24), new $12c6b0ab9da17bee$var$Br(22, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(22, 15), new $12c6b0ab9da17bee$var$Br(13, 16))),
        new t(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 114), new $12c6b0ab9da17bee$var$Br(2, 115)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(19, 46), new $12c6b0ab9da17bee$var$Br(4, 47)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(28, 22), new $12c6b0ab9da17bee$var$Br(6, 23)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(33, 16), new $12c6b0ab9da17bee$var$Br(4, 17))),
        new t(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(8, 122), new $12c6b0ab9da17bee$var$Br(4, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(22, 45), new $12c6b0ab9da17bee$var$Br(3, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(8, 23), new $12c6b0ab9da17bee$var$Br(26, 24)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(12, 15), new $12c6b0ab9da17bee$var$Br(28, 16))),
        new t(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(3, 117), new $12c6b0ab9da17bee$var$Br(10, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(3, 45), new $12c6b0ab9da17bee$var$Br(23, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 24), new $12c6b0ab9da17bee$var$Br(31, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 15), new $12c6b0ab9da17bee$var$Br(31, 16))),
        new t(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(7, 116), new $12c6b0ab9da17bee$var$Br(7, 117)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(21, 45), new $12c6b0ab9da17bee$var$Br(7, 46)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(1, 23), new $12c6b0ab9da17bee$var$Br(37, 24)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 15), new $12c6b0ab9da17bee$var$Br(26, 16))),
        new t(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(5, 115), new $12c6b0ab9da17bee$var$Br(10, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(19, 47), new $12c6b0ab9da17bee$var$Br(10, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(15, 24), new $12c6b0ab9da17bee$var$Br(25, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(23, 15), new $12c6b0ab9da17bee$var$Br(25, 16))),
        new t(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(13, 115), new $12c6b0ab9da17bee$var$Br(3, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(2, 46), new $12c6b0ab9da17bee$var$Br(29, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(42, 24), new $12c6b0ab9da17bee$var$Br(1, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(23, 15), new $12c6b0ab9da17bee$var$Br(28, 16))),
        new t(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 115)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(10, 46), new $12c6b0ab9da17bee$var$Br(23, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(10, 24), new $12c6b0ab9da17bee$var$Br(35, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 15), new $12c6b0ab9da17bee$var$Br(35, 16))),
        new t(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 115), new $12c6b0ab9da17bee$var$Br(1, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(14, 46), new $12c6b0ab9da17bee$var$Br(21, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(29, 24), new $12c6b0ab9da17bee$var$Br(19, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(11, 15), new $12c6b0ab9da17bee$var$Br(46, 16))),
        new t(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(13, 115), new $12c6b0ab9da17bee$var$Br(6, 116)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(14, 46), new $12c6b0ab9da17bee$var$Br(23, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(44, 24), new $12c6b0ab9da17bee$var$Br(7, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(59, 16), new $12c6b0ab9da17bee$var$Br(1, 17))),
        new t(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(12, 121), new $12c6b0ab9da17bee$var$Br(7, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(12, 47), new $12c6b0ab9da17bee$var$Br(26, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(39, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(22, 15), new $12c6b0ab9da17bee$var$Br(41, 16))),
        new t(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(6, 121), new $12c6b0ab9da17bee$var$Br(14, 122)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(6, 47), new $12c6b0ab9da17bee$var$Br(34, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(46, 24), new $12c6b0ab9da17bee$var$Br(10, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(2, 15), new $12c6b0ab9da17bee$var$Br(64, 16))),
        new t(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(17, 122), new $12c6b0ab9da17bee$var$Br(4, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(29, 46), new $12c6b0ab9da17bee$var$Br(14, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(49, 24), new $12c6b0ab9da17bee$var$Br(10, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(24, 15), new $12c6b0ab9da17bee$var$Br(46, 16))),
        new t(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(4, 122), new $12c6b0ab9da17bee$var$Br(18, 123)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(13, 46), new $12c6b0ab9da17bee$var$Br(32, 47)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(48, 24), new $12c6b0ab9da17bee$var$Br(14, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(42, 15), new $12c6b0ab9da17bee$var$Br(32, 16))),
        new t(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(20, 117), new $12c6b0ab9da17bee$var$Br(4, 118)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(40, 47), new $12c6b0ab9da17bee$var$Br(7, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(43, 24), new $12c6b0ab9da17bee$var$Br(22, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(10, 15), new $12c6b0ab9da17bee$var$Br(67, 16))),
        new t(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(19, 118), new $12c6b0ab9da17bee$var$Br(6, 119)), new $12c6b0ab9da17bee$var$Mr(28, new $12c6b0ab9da17bee$var$Br(18, 47), new $12c6b0ab9da17bee$var$Br(31, 48)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(34, 24), new $12c6b0ab9da17bee$var$Br(34, 25)), new $12c6b0ab9da17bee$var$Mr(30, new $12c6b0ab9da17bee$var$Br(20, 15), new $12c6b0ab9da17bee$var$Br(61, 16)))
    ], t;
}();
!function(t) {
    t[t.DATA_MASK_000 = 0] = "DATA_MASK_000", t[t.DATA_MASK_001 = 1] = "DATA_MASK_001", t[t.DATA_MASK_010 = 2] = "DATA_MASK_010", t[t.DATA_MASK_011 = 3] = "DATA_MASK_011", t[t.DATA_MASK_100 = 4] = "DATA_MASK_100", t[t.DATA_MASK_101 = 5] = "DATA_MASK_101", t[t.DATA_MASK_110 = 6] = "DATA_MASK_110", t[t.DATA_MASK_111 = 7] = "DATA_MASK_111";
}($12c6b0ab9da17bee$var$br || ($12c6b0ab9da17bee$var$br = {}));
var $12c6b0ab9da17bee$var$kr, $12c6b0ab9da17bee$var$xr = function() {
    function t(t, e) {
        this.value = t, this.isMasked = e;
    }
    return t.prototype.unmaskBitMatrix = function(t, e) {
        for(var r = 0; r < e; r++)for(var n = 0; n < e; n++)this.isMasked(r, n) && t.flip(n, r);
    }, t.values = new Map([
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_000,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_000, function(t, e) {
                return 0 == (t + e & 1);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_001,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_001, function(t, e) {
                return 0 == (1 & t);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_010,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_010, function(t, e) {
                return e % 3 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_011,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_011, function(t, e) {
                return (t + e) % 3 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_100,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_100, function(t, e) {
                return 0 == (Math.floor(t / 2) + Math.floor(e / 3) & 1);
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_101,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_101, function(t, e) {
                return t * e % 6 == 0;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_110,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_110, function(t, e) {
                return t * e % 6 < 3;
            })
        ],
        [
            $12c6b0ab9da17bee$var$br.DATA_MASK_111,
            new t($12c6b0ab9da17bee$var$br.DATA_MASK_111, function(t, e) {
                return 0 == (t + e + t * e % 3 & 1);
            })
        ]
    ]), t;
}(), $12c6b0ab9da17bee$var$Vr = function() {
    function t(t) {
        var e = t.getHeight();
        if (e < 21 || 1 != (3 & e)) throw new $12c6b0ab9da17bee$var$R;
        this.bitMatrix = t;
    }
    return t.prototype.readFormatInformation = function() {
        if (null !== this.parsedFormatInfo && void 0 !== this.parsedFormatInfo) return this.parsedFormatInfo;
        for(var t = 0, e = 0; e < 6; e++)t = this.copyBit(e, 8, t);
        t = this.copyBit(7, 8, t), t = this.copyBit(8, 8, t), t = this.copyBit(8, 7, t);
        for(var r = 5; r >= 0; r--)t = this.copyBit(8, r, t);
        var n = this.bitMatrix.getHeight(), o = 0, i = n - 7;
        for(r = n - 1; r >= i; r--)o = this.copyBit(8, r, o);
        for(e = n - 8; e < n; e++)o = this.copyBit(e, 8, o);
        if (this.parsedFormatInfo = $12c6b0ab9da17bee$var$Dr.decodeFormatInformation(t, o), null !== this.parsedFormatInfo) return this.parsedFormatInfo;
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.readVersion = function() {
        if (null !== this.parsedVersion && void 0 !== this.parsedVersion) return this.parsedVersion;
        var t = this.bitMatrix.getHeight(), e = Math.floor((t - 17) / 4);
        if (e <= 6) return $12c6b0ab9da17bee$var$Fr.getVersionForNumber(e);
        for(var r = 0, n = t - 11, o = 5; o >= 0; o--)for(var i = t - 9; i >= n; i--)r = this.copyBit(i, o, r);
        var a = $12c6b0ab9da17bee$var$Fr.decodeVersionInformation(r);
        if (null !== a && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        r = 0;
        for(i = 5; i >= 0; i--)for(o = t - 9; o >= n; o--)r = this.copyBit(i, o, r);
        if (null !== (a = $12c6b0ab9da17bee$var$Fr.decodeVersionInformation(r)) && a.getDimensionForVersion() === t) return this.parsedVersion = a, a;
        throw new $12c6b0ab9da17bee$var$R;
    }, t.prototype.copyBit = function(t, e, r) {
        return (this.isMirror ? this.bitMatrix.get(e, t) : this.bitMatrix.get(t, e)) ? r << 1 | 1 : r << 1;
    }, t.prototype.readCodewords = function() {
        var t = this.readFormatInformation(), e = this.readVersion(), r = $12c6b0ab9da17bee$var$xr.values.get(t.getDataMask()), n = this.bitMatrix.getHeight();
        r.unmaskBitMatrix(this.bitMatrix, n);
        for(var o = e.buildFunctionPattern(), i = !0, a = new Uint8Array(e.getTotalCodewords()), u = 0, s = 0, c = 0, f = n - 1; f > 0; f -= 2){
            6 === f && f--;
            for(var h = 0; h < n; h++)for(var l = i ? n - 1 - h : h, d = 0; d < 2; d++)o.get(f - d, l) || (c++, s <<= 1, this.bitMatrix.get(f - d, l) && (s |= 1), 8 === c && (a[u++] = s, c = 0, s = 0));
            i = !i;
        }
        if (u !== e.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$R;
        return a;
    }, t.prototype.remask = function() {
        if (null !== this.parsedFormatInfo) {
            var t = $12c6b0ab9da17bee$var$xr.values[this.parsedFormatInfo.getDataMask()], e = this.bitMatrix.getHeight();
            t.unmaskBitMatrix(this.bitMatrix, e);
        }
    }, t.prototype.setMirror = function(t) {
        this.parsedVersion = null, this.parsedFormatInfo = null, this.isMirror = t;
    }, t.prototype.mirror = function() {
        for(var t = this.bitMatrix, e = 0, r = t.getWidth(); e < r; e++)for(var n = e + 1, o = t.getHeight(); n < o; n++)t.get(e, n) !== t.get(n, e) && (t.flip(n, e), t.flip(e, n));
    }, t;
}(), $12c6b0ab9da17bee$var$Ur = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Hr = function() {
    function t(t, e) {
        this.numDataCodewords = t, this.codewords = e;
    }
    return t.getDataBlocks = function(e, r, n) {
        var o, i, a, u;
        if (e.length !== r.getTotalCodewords()) throw new $12c6b0ab9da17bee$var$l;
        var s = r.getECBlocksForLevel(n), c = 0, f = s.getECBlocks();
        try {
            for(var h = $12c6b0ab9da17bee$var$Ur(f), d = h.next(); !d.done; d = h.next())c += (_ = d.value).getCount();
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (i = h.return) && i.call(h);
            } finally{
                if (o) throw o.error;
            }
        }
        var p = new Array(c), g = 0;
        try {
            for(var y = $12c6b0ab9da17bee$var$Ur(f), w = y.next(); !w.done; w = y.next())for(var _ = w.value, v = 0; v < _.getCount(); v++){
                var m = _.getDataCodewords(), A = s.getECCodewordsPerBlock() + m;
                p[g++] = new t(m, new Uint8Array(A));
            }
        } catch (t) {
            a = {
                error: t
            };
        } finally{
            try {
                w && !w.done && (u = y.return) && u.call(y);
            } finally{
                if (a) throw a.error;
            }
        }
        for(var E = p[0].codewords.length, C = p.length - 1; C >= 0;){
            if (p[C].codewords.length === E) break;
            C--;
        }
        C++;
        var I = E - s.getECCodewordsPerBlock(), S = 0;
        for(v = 0; v < I; v++)for(var O = 0; O < g; O++)p[O].codewords[v] = e[S++];
        for(O = C; O < g; O++)p[O].codewords[I] = e[S++];
        var T = p[0].codewords.length;
        for(v = I; v < T; v++)for(O = 0; O < g; O++){
            var b = O < C ? v : v + 1;
            p[O].codewords[b] = e[S++];
        }
        return p;
    }, t.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t;
}();
!function(t) {
    t[t.TERMINATOR = 0] = "TERMINATOR", t[t.NUMERIC = 1] = "NUMERIC", t[t.ALPHANUMERIC = 2] = "ALPHANUMERIC", t[t.STRUCTURED_APPEND = 3] = "STRUCTURED_APPEND", t[t.BYTE = 4] = "BYTE", t[t.ECI = 5] = "ECI", t[t.KANJI = 6] = "KANJI", t[t.FNC1_FIRST_POSITION = 7] = "FNC1_FIRST_POSITION", t[t.FNC1_SECOND_POSITION = 8] = "FNC1_SECOND_POSITION", t[t.HANZI = 9] = "HANZI";
}($12c6b0ab9da17bee$var$kr || ($12c6b0ab9da17bee$var$kr = {}));
var $12c6b0ab9da17bee$var$Gr, $12c6b0ab9da17bee$var$Xr, $12c6b0ab9da17bee$var$Wr = function() {
    function t(e, r, n, o) {
        this.value = e, this.stringValue = r, this.characterCountBitsForVersions = n, this.bits = o, t.FOR_BITS.set(o, this), t.FOR_VALUE.set(e, this);
    }
    return t.forBits = function(e) {
        var r = t.FOR_BITS.get(e);
        if (void 0 === r) throw new $12c6b0ab9da17bee$var$l;
        return r;
    }, t.prototype.getCharacterCountBits = function(t) {
        var e, r = t.getVersionNumber();
        return e = r <= 9 ? 0 : r <= 26 ? 1 : 2, this.characterCountBitsForVersions[e];
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        return this.value === r.value;
    }, t.prototype.toString = function() {
        return this.stringValue;
    }, t.FOR_BITS = new Map, t.FOR_VALUE = new Map, t.TERMINATOR = new t($12c6b0ab9da17bee$var$kr.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0), t.NUMERIC = new t($12c6b0ab9da17bee$var$kr.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 1), t.ALPHANUMERIC = new t($12c6b0ab9da17bee$var$kr.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 2), t.STRUCTURED_APPEND = new t($12c6b0ab9da17bee$var$kr.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 3), t.BYTE = new t($12c6b0ab9da17bee$var$kr.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 4), t.ECI = new t($12c6b0ab9da17bee$var$kr.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 7), t.KANJI = new t($12c6b0ab9da17bee$var$kr.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 8), t.FNC1_FIRST_POSITION = new t($12c6b0ab9da17bee$var$kr.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 5), t.FNC1_SECOND_POSITION = new t($12c6b0ab9da17bee$var$kr.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 9), t.HANZI = new t($12c6b0ab9da17bee$var$kr.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 13), t;
}(), $12c6b0ab9da17bee$var$jr = function() {
    function t() {}
    return t.decode = function(e, r, n, o) {
        var i = new $12c6b0ab9da17bee$var$mr(e), a = new $12c6b0ab9da17bee$var$k, u = new Array, s = -1, c = -1;
        try {
            var f = null, h = !1, l = void 0;
            do {
                if (i.available() < 4) l = $12c6b0ab9da17bee$var$Wr.TERMINATOR;
                else {
                    var d = i.readBits(4);
                    l = $12c6b0ab9da17bee$var$Wr.forBits(d);
                }
                switch(l){
                    case $12c6b0ab9da17bee$var$Wr.TERMINATOR:
                        break;
                    case $12c6b0ab9da17bee$var$Wr.FNC1_FIRST_POSITION:
                    case $12c6b0ab9da17bee$var$Wr.FNC1_SECOND_POSITION:
                        h = !0;
                        break;
                    case $12c6b0ab9da17bee$var$Wr.STRUCTURED_APPEND:
                        if (i.available() < 16) throw new $12c6b0ab9da17bee$var$R;
                        s = i.readBits(8), c = i.readBits(8);
                        break;
                    case $12c6b0ab9da17bee$var$Wr.ECI:
                        var p = t.parseECIValue(i);
                        if (null === (f = $12c6b0ab9da17bee$var$P.getCharacterSetECIByValue(p))) throw new $12c6b0ab9da17bee$var$R;
                        break;
                    case $12c6b0ab9da17bee$var$Wr.HANZI:
                        var g = i.readBits(4), y = i.readBits(l.getCharacterCountBits(r));
                        g === t.GB2312_SUBSET && t.decodeHanziSegment(i, a, y);
                        break;
                    default:
                        var w = i.readBits(l.getCharacterCountBits(r));
                        switch(l){
                            case $12c6b0ab9da17bee$var$Wr.NUMERIC:
                                t.decodeNumericSegment(i, a, w);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC:
                                t.decodeAlphanumericSegment(i, a, w, h);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.BYTE:
                                t.decodeByteSegment(i, a, w, f, u, o);
                                break;
                            case $12c6b0ab9da17bee$var$Wr.KANJI:
                                t.decodeKanjiSegment(i, a, w);
                                break;
                            default:
                                throw new $12c6b0ab9da17bee$var$R;
                        }
                }
            }while (l !== $12c6b0ab9da17bee$var$Wr.TERMINATOR);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R;
        }
        return new $12c6b0ab9da17bee$var$at(e, a.toString(), 0 === u.length ? null : u, null === n ? null : n.toString(), s, c);
    }, t.decodeHanziSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 96 << 8 & 4294967295 | i % 96;
            a += a < 959 ? 41377 : 42657, n[o] = a >> 8 & 255, n[o + 1] = 255 & a, o += 2, r--;
        }
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(n, $12c6b0ab9da17bee$var$F.GB2312));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
    }, t.decodeKanjiSegment = function(t, e, r) {
        if (13 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var n = new Uint8Array(2 * r), o = 0; r > 0;){
            var i = t.readBits(13), a = i / 192 << 8 & 4294967295 | i % 192;
            a += a < 7936 ? 33088 : 49472, n[o] = a >> 8, n[o + 1] = a, o += 2, r--;
        }
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(n, $12c6b0ab9da17bee$var$F.SHIFT_JIS));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
    }, t.decodeByteSegment = function(t, e, r, n, o, i) {
        if (8 * r > t.available()) throw new $12c6b0ab9da17bee$var$R;
        for(var a, u = new Uint8Array(r), s = 0; s < r; s++)u[s] = t.readBits(8);
        a = null === n ? $12c6b0ab9da17bee$var$F.guessEncoding(u, i) : n.getName();
        try {
            e.append($12c6b0ab9da17bee$var$L.decode(u, a));
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$R(t);
        }
        o.push(u);
    }, t.toAlphaNumericChar = function(e) {
        if (e >= t.ALPHANUMERIC_CHARS.length) throw new $12c6b0ab9da17bee$var$R;
        return t.ALPHANUMERIC_CHARS[e];
    }, t.decodeAlphanumericSegment = function(e, r, n, o) {
        for(var i = r.length(); n > 1;){
            if (e.available() < 11) throw new $12c6b0ab9da17bee$var$R;
            var a = e.readBits(11);
            r.append(t.toAlphaNumericChar(Math.floor(a / 45))), r.append(t.toAlphaNumericChar(a % 45)), n -= 2;
        }
        if (1 === n) {
            if (e.available() < 6) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(e.readBits(6)));
        }
        if (o) for(var u = i; u < r.length(); u++)"%" === r.charAt(u) && (u < r.length() - 1 && "%" === r.charAt(u + 1) ? r.deleteCharAt(u + 1) : r.setCharAt(u, String.fromCharCode(29)));
    }, t.decodeNumericSegment = function(e, r, n) {
        for(; n >= 3;){
            if (e.available() < 10) throw new $12c6b0ab9da17bee$var$R;
            var o = e.readBits(10);
            if (o >= 1e3) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(Math.floor(o / 100))), r.append(t.toAlphaNumericChar(Math.floor(o / 10) % 10)), r.append(t.toAlphaNumericChar(o % 10)), n -= 3;
        }
        if (2 === n) {
            if (e.available() < 7) throw new $12c6b0ab9da17bee$var$R;
            var i = e.readBits(7);
            if (i >= 100) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(Math.floor(i / 10))), r.append(t.toAlphaNumericChar(i % 10));
        } else if (1 === n) {
            if (e.available() < 4) throw new $12c6b0ab9da17bee$var$R;
            var a = e.readBits(4);
            if (a >= 10) throw new $12c6b0ab9da17bee$var$R;
            r.append(t.toAlphaNumericChar(a));
        }
    }, t.parseECIValue = function(t) {
        var e = t.readBits(8);
        if (0 == (128 & e)) return 127 & e;
        if (128 == (192 & e)) return (63 & e) << 8 & 4294967295 | t.readBits(8);
        if (192 == (224 & e)) return (31 & e) << 16 & 4294967295 | t.readBits(16);
        throw new $12c6b0ab9da17bee$var$R;
    }, t.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", t.GB2312_SUBSET = 1, t;
}(), $12c6b0ab9da17bee$var$zr = function() {
    function t(t) {
        this.mirrored = t;
    }
    return t.prototype.isMirrored = function() {
        return this.mirrored;
    }, t.prototype.applyMirroredCorrection = function(t) {
        if (this.mirrored && null !== t && !(t.length < 3)) {
            var e = t[0];
            t[0] = t[2], t[2] = e;
        }
    }, t;
}(), $12c6b0ab9da17bee$var$Yr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Zr = function() {
    function t() {
        this.rsDecoder = new $12c6b0ab9da17bee$var$wt($12c6b0ab9da17bee$var$lt.QR_CODE_FIELD_256);
    }
    return t.prototype.decodeBooleanArray = function(t, e) {
        return this.decodeBitMatrix($12c6b0ab9da17bee$var$x.parseFromBooleanArray(t), e);
    }, t.prototype.decodeBitMatrix = function(t, e) {
        var r = new $12c6b0ab9da17bee$var$Vr(t), n = null;
        try {
            return this.decodeBitMatrixParser(r, e);
        } catch (t) {
            n = t;
        }
        try {
            r.remask(), r.setMirror(!0), r.readVersion(), r.readFormatInformation(), r.mirror();
            var o = this.decodeBitMatrixParser(r, e);
            return o.setOther(new $12c6b0ab9da17bee$var$zr(!0)), o;
        } catch (t) {
            if (null !== n) throw n;
            throw t;
        }
    }, t.prototype.decodeBitMatrixParser = function(t, e) {
        var r, n, o, i, a = t.readVersion(), u = t.readFormatInformation().getErrorCorrectionLevel(), s = t.readCodewords(), c = $12c6b0ab9da17bee$var$Hr.getDataBlocks(s, a, u), f = 0;
        try {
            for(var h = $12c6b0ab9da17bee$var$Yr(c), l = h.next(); !l.done; l = h.next())f += (w = l.value).getNumDataCodewords();
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (n = h.return) && n.call(h);
            } finally{
                if (r) throw r.error;
            }
        }
        var d = new Uint8Array(f), p = 0;
        try {
            for(var g = $12c6b0ab9da17bee$var$Yr(c), y = g.next(); !y.done; y = g.next()){
                var w, _ = (w = y.value).getCodewords(), v = w.getNumDataCodewords();
                this.correctErrors(_, v);
                for(var m = 0; m < v; m++)d[p++] = _[m];
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                y && !y.done && (i = g.return) && i.call(g);
            } finally{
                if (o) throw o.error;
            }
        }
        return $12c6b0ab9da17bee$var$jr.decode(d, a, u, e);
    }, t.prototype.correctErrors = function(t, e) {
        var r = new Int32Array(t);
        try {
            this.rsDecoder.decode(r, t.length - e);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$g;
        }
        for(var n = 0; n < e; n++)t[n] = r[n];
    }, t;
}(), $12c6b0ab9da17bee$var$Kr = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$qr = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, r) || this;
        return o.estimatedModuleSize = n, o;
    }
    return $12c6b0ab9da17bee$var$Kr(e, t), e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        return new e((this.getX() + r) / 2, (this.getY() + t) / 2, (this.estimatedModuleSize + n) / 2);
    }, e;
}($12c6b0ab9da17bee$var$At), $12c6b0ab9da17bee$var$Qr = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Jr = function() {
    function t(t, e, r, n, o, i, a) {
        this.image = t, this.startX = e, this.startY = r, this.width = n, this.height = o, this.moduleSize = i, this.resultPointCallback = a, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(3);
    }
    return t.prototype.find = function() {
        for(var t = this.startX, e = this.height, r = t + this.width, n = this.startY + e / 2, o = new Int32Array(3), i = this.image, a = 0; a < e; a++){
            var u = n + (0 == (1 & a) ? Math.floor((a + 1) / 2) : -Math.floor((a + 1) / 2));
            o[0] = 0, o[1] = 0, o[2] = 0;
            for(var s = t; s < r && !i.get(s, u);)s++;
            for(var c = 0; s < r;){
                if (i.get(s, u)) {
                    if (1 === c) o[1]++;
                    else if (2 === c) {
                        var f;
                        if (this.foundPatternCross(o)) {
                            if (null !== (f = this.handlePossibleCenter(o, u, s))) return f;
                        }
                        o[0] = o[2], o[1] = 1, o[2] = 0, c = 1;
                    } else o[++c]++;
                } else 1 === c && c++, o[c]++;
                s++;
            }
            if (this.foundPatternCross(o)) {
                if (null !== (f = this.handlePossibleCenter(o, u, r))) return f;
            }
        }
        if (0 !== this.possibleCenters.length) return this.possibleCenters[0];
        throw new $12c6b0ab9da17bee$var$U;
    }, t.centerFromEnd = function(t, e) {
        return e - t[2] - t[1] / 2;
    }, t.prototype.foundPatternCross = function(t) {
        for(var e = this.moduleSize, r = e / 2, n = 0; n < 3; n++)if (Math.abs(e - t[n]) >= r) return !1;
        return !0;
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        var i = this.image, a = i.getHeight(), u = this.crossCheckStateCount;
        u[0] = 0, u[1] = 0, u[2] = 0;
        for(var s = e; s >= 0 && i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s) && u[1] <= n;)u[1]++, s++;
        if (s === a || u[1] > n) return NaN;
        for(; s < a && !i.get(r, s) && u[2] <= n;)u[2]++, s++;
        if (u[2] > n) return NaN;
        var c = u[0] + u[1] + u[2];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : this.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n) {
        var o, i, a = e[0] + e[1] + e[2], u = t.centerFromEnd(e, n), s = this.crossCheckVertical(r, u, 2 * e[1], a);
        if (!isNaN(s)) {
            var c = (e[0] + e[1] + e[2]) / 3;
            try {
                for(var f = $12c6b0ab9da17bee$var$Qr(this.possibleCenters), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (l.aboutEquals(c, s, u)) return l.combineEstimate(s, u, c);
                }
            } catch (t) {
                o = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (i = f.return) && i.call(f);
                } finally{
                    if (o) throw o.error;
                }
            }
            var d = new $12c6b0ab9da17bee$var$qr(u, s, c);
            this.possibleCenters.push(d), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(d);
        }
        return null;
    }, t;
}(), $12c6b0ab9da17bee$var$$r = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$tn = function(t) {
    function e(e, r, n, o) {
        var i = t.call(this, e, r) || this;
        return i.estimatedModuleSize = n, i.count = o, void 0 === o && (i.count = 1), i;
    }
    return $12c6b0ab9da17bee$var$$r(e, t), e.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    }, e.prototype.getCount = function() {
        return this.count;
    }, e.prototype.aboutEquals = function(t, e, r) {
        if (Math.abs(e - this.getY()) <= t && Math.abs(r - this.getX()) <= t) {
            var n = Math.abs(t - this.estimatedModuleSize);
            return n <= 1 || n <= this.estimatedModuleSize;
        }
        return !1;
    }, e.prototype.combineEstimate = function(t, r, n) {
        var o = this.count + 1;
        return new e((this.count * this.getX() + r) / o, (this.count * this.getY() + t) / o, (this.count * this.estimatedModuleSize + n) / o, o);
    }, e;
}($12c6b0ab9da17bee$var$At), $12c6b0ab9da17bee$var$en = function() {
    function t(t) {
        this.bottomLeft = t[0], this.topLeft = t[1], this.topRight = t[2];
    }
    return t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t;
}(), $12c6b0ab9da17bee$var$rn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$nn = function() {
    function t(t, e) {
        this.image = t, this.resultPointCallback = e, this.possibleCenters = [], this.crossCheckStateCount = new Int32Array(5), this.resultPointCallback = e;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    }, t.prototype.find = function(e) {
        var r = null != e && void 0 !== e.get($12c6b0ab9da17bee$var$T.TRY_HARDER), n = null != e && void 0 !== e.get($12c6b0ab9da17bee$var$T.PURE_BARCODE), o = this.image, i = o.getHeight(), a = o.getWidth(), u = Math.floor(3 * i / (4 * t.MAX_MODULES));
        (u < t.MIN_SKIP || r) && (u = t.MIN_SKIP);
        for(var s = !1, c = new Int32Array(5), f = u - 1; f < i && !s; f += u){
            c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
            for(var h = 0, l = 0; l < a; l++)if (o.get(l, f)) 1 == (1 & h) && h++, c[h]++;
            else if (0 == (1 & h)) {
                if (4 === h) {
                    if (t.foundPatternCross(c)) {
                        if (!0 !== this.handlePossibleCenter(c, f, l, n)) {
                            c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                            continue;
                        }
                        if (u = 2, !0 === this.hasSkipped) s = this.haveMultiplyConfirmedCenters();
                        else {
                            var d = this.findRowSkip();
                            d > c[2] && (f += d - c[2] - u, l = a - 1);
                        }
                        h = 0, c[0] = 0, c[1] = 0, c[2] = 0, c[3] = 0, c[4] = 0;
                    } else c[0] = c[2], c[1] = c[3], c[2] = c[4], c[3] = 1, c[4] = 0, h = 3;
                } else c[++h]++;
            } else c[h]++;
            if (t.foundPatternCross(c)) !0 === this.handlePossibleCenter(c, f, a, n) && (u = c[0], this.hasSkipped && (s = this.haveMultiplyConfirmedCenters()));
        }
        var p = this.selectBestPatterns();
        return $12c6b0ab9da17bee$var$At.orderBestPatterns(p), new $12c6b0ab9da17bee$var$en(p);
    }, t.centerFromEnd = function(t, e) {
        return e - t[4] - t[3] - t[2] / 2;
    }, t.foundPatternCross = function(t) {
        for(var e = 0, r = 0; r < 5; r++){
            var n = t[r];
            if (0 === n) return !1;
            e += n;
        }
        if (e < 7) return !1;
        var o = e / 7, i = o / 2;
        return Math.abs(o - t[0]) < i && Math.abs(o - t[1]) < i && Math.abs(3 * o - t[2]) < 3 * i && Math.abs(o - t[3]) < i && Math.abs(o - t[4]) < i;
    }, t.prototype.getCrossCheckStateCount = function() {
        var t = this.crossCheckStateCount;
        return t[0] = 0, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t;
    }, t.prototype.crossCheckDiagonal = function(e, r, n, o) {
        for(var i = this.getCrossCheckStateCount(), a = 0, u = this.image; e >= a && r >= a && u.get(r - a, e - a);)i[2]++, a++;
        if (e < a || r < a) return !1;
        for(; e >= a && r >= a && !u.get(r - a, e - a) && i[1] <= n;)i[1]++, a++;
        if (e < a || r < a || i[1] > n) return !1;
        for(; e >= a && r >= a && u.get(r - a, e - a) && i[0] <= n;)i[0]++, a++;
        if (i[0] > n) return !1;
        var s = u.getHeight(), c = u.getWidth();
        for(a = 1; e + a < s && r + a < c && u.get(r + a, e + a);)i[2]++, a++;
        if (e + a >= s || r + a >= c) return !1;
        for(; e + a < s && r + a < c && !u.get(r + a, e + a) && i[3] < n;)i[3]++, a++;
        if (e + a >= s || r + a >= c || i[3] >= n) return !1;
        for(; e + a < s && r + a < c && u.get(r + a, e + a) && i[4] < n;)i[4]++, a++;
        if (i[4] >= n) return !1;
        var f = i[0] + i[1] + i[2] + i[3] + i[4];
        return Math.abs(f - o) < 2 * o && t.foundPatternCross(i);
    }, t.prototype.crossCheckVertical = function(e, r, n, o) {
        for(var i = this.image, a = i.getHeight(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(r, s);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(r, s) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(r, s) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(r, s);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(r, s) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(r, s) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= 2 * o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.crossCheckHorizontal = function(e, r, n, o) {
        for(var i = this.image, a = i.getWidth(), u = this.getCrossCheckStateCount(), s = e; s >= 0 && i.get(s, r);)u[2]++, s--;
        if (s < 0) return NaN;
        for(; s >= 0 && !i.get(s, r) && u[1] <= n;)u[1]++, s--;
        if (s < 0 || u[1] > n) return NaN;
        for(; s >= 0 && i.get(s, r) && u[0] <= n;)u[0]++, s--;
        if (u[0] > n) return NaN;
        for(s = e + 1; s < a && i.get(s, r);)u[2]++, s++;
        if (s === a) return NaN;
        for(; s < a && !i.get(s, r) && u[3] < n;)u[3]++, s++;
        if (s === a || u[3] >= n) return NaN;
        for(; s < a && i.get(s, r) && u[4] < n;)u[4]++, s++;
        if (u[4] >= n) return NaN;
        var c = u[0] + u[1] + u[2] + u[3] + u[4];
        return 5 * Math.abs(c - o) >= o ? NaN : t.foundPatternCross(u) ? t.centerFromEnd(u, s) : NaN;
    }, t.prototype.handlePossibleCenter = function(e, r, n, o) {
        var i = e[0] + e[1] + e[2] + e[3] + e[4], a = t.centerFromEnd(e, n), u = this.crossCheckVertical(r, Math.floor(a), e[2], i);
        if (!isNaN(u) && (a = this.crossCheckHorizontal(Math.floor(a), Math.floor(u), e[2], i), !isNaN(a) && (!o || this.crossCheckDiagonal(Math.floor(u), Math.floor(a), e[2], i)))) {
            for(var s = i / 7, c = !1, f = this.possibleCenters, h = 0, l = f.length; h < l; h++){
                var d = f[h];
                if (d.aboutEquals(s, u, a)) {
                    f[h] = d.combineEstimate(u, a, s), c = !0;
                    break;
                }
            }
            if (!c) {
                var p = new $12c6b0ab9da17bee$var$tn(a, u, s);
                f.push(p), null !== this.resultPointCallback && void 0 !== this.resultPointCallback && this.resultPointCallback.foundPossibleResultPoint(p);
            }
            return !0;
        }
        return !1;
    }, t.prototype.findRowSkip = function() {
        var e, r;
        if (this.possibleCenters.length <= 1) return 0;
        var n = null;
        try {
            for(var o = $12c6b0ab9da17bee$var$rn(this.possibleCenters), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (a.getCount() >= t.CENTER_QUORUM) {
                    if (null != n) return this.hasSkipped = !0, Math.floor((Math.abs(n.getX() - a.getX()) - Math.abs(n.getY() - a.getY())) / 2);
                    n = a;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return 0;
    }, t.prototype.haveMultiplyConfirmedCenters = function() {
        var e, r, n, o, i = 0, a = 0, u = this.possibleCenters.length;
        try {
            for(var s = $12c6b0ab9da17bee$var$rn(this.possibleCenters), c = s.next(); !c.done; c = s.next())(p = c.value).getCount() >= t.CENTER_QUORUM && (i++, a += p.getEstimatedModuleSize());
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (r = s.return) && r.call(s);
            } finally{
                if (e) throw e.error;
            }
        }
        if (i < 3) return !1;
        var f = a / u, h = 0;
        try {
            for(var l = $12c6b0ab9da17bee$var$rn(this.possibleCenters), d = l.next(); !d.done; d = l.next()){
                var p = d.value;
                h += Math.abs(p.getEstimatedModuleSize() - f);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                d && !d.done && (o = l.return) && o.call(l);
            } finally{
                if (n) throw n.error;
            }
        }
        return h <= .05 * a;
    }, t.prototype.selectBestPatterns = function() {
        var t, e, r, n, o = this.possibleCenters.length;
        if (o < 3) throw new $12c6b0ab9da17bee$var$U;
        var i, a = this.possibleCenters;
        if (o > 3) {
            var u = 0, s = 0;
            try {
                for(var c = $12c6b0ab9da17bee$var$rn(this.possibleCenters), f = c.next(); !f.done; f = c.next()){
                    var h = f.value.getEstimatedModuleSize();
                    u += h, s += h * h;
                }
            } catch (e) {
                t = {
                    error: e
                };
            } finally{
                try {
                    f && !f.done && (e = c.return) && e.call(c);
                } finally{
                    if (t) throw t.error;
                }
            }
            i = u / o;
            var l = Math.sqrt(s / o - i * i);
            a.sort(function(t, e) {
                var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                return r < n ? -1 : r > n ? 1 : 0;
            });
            for(var d = Math.max(.2 * i, l), p = 0; p < a.length && a.length > 3; p++){
                var g = a[p];
                Math.abs(g.getEstimatedModuleSize() - i) > d && (a.splice(p, 1), p--);
            }
        }
        if (a.length > 3) {
            u = 0;
            try {
                for(var y = $12c6b0ab9da17bee$var$rn(a), w = y.next(); !w.done; w = y.next())u += w.value.getEstimatedModuleSize();
            } catch (t) {
                r = {
                    error: t
                };
            } finally{
                try {
                    w && !w.done && (n = y.return) && n.call(y);
                } finally{
                    if (r) throw r.error;
                }
            }
            i = u / a.length, a.sort(function(t, e) {
                if (e.getCount() === t.getCount()) {
                    var r = Math.abs(e.getEstimatedModuleSize() - i), n = Math.abs(t.getEstimatedModuleSize() - i);
                    return r < n ? 1 : r > n ? -1 : 0;
                }
                return e.getCount() - t.getCount();
            }), a.splice(3);
        }
        return [
            a[0],
            a[1],
            a[2]
        ];
    }, t.CENTER_QUORUM = 2, t.MIN_SKIP = 3, t.MAX_MODULES = 57, t;
}(), $12c6b0ab9da17bee$var$on = function() {
    function t(t) {
        this.image = t;
    }
    return t.prototype.getImage = function() {
        return this.image;
    }, t.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    }, t.prototype.detect = function(t) {
        this.resultPointCallback = null == t ? null : t.get($12c6b0ab9da17bee$var$T.NEED_RESULT_POINT_CALLBACK);
        var e = new $12c6b0ab9da17bee$var$nn(this.image, this.resultPointCallback).find(t);
        return this.processFinderPatternInfo(e);
    }, t.prototype.processFinderPatternInfo = function(e) {
        var r = e.getTopLeft(), n = e.getTopRight(), o = e.getBottomLeft(), i = this.calculateModuleSize(r, n, o);
        if (i < 1) throw new $12c6b0ab9da17bee$var$U("No pattern found in proccess finder.");
        var a = t.computeDimension(r, n, o, i), u = $12c6b0ab9da17bee$var$Fr.getProvisionalVersionForDimension(a), s = u.getDimensionForVersion() - 7, c = null;
        if (u.getAlignmentPatternCenters().length > 0) for(var f = n.getX() - r.getX() + o.getX(), h = n.getY() - r.getY() + o.getY(), l = 1 - 3 / s, d = Math.floor(r.getX() + l * (f - r.getX())), p = Math.floor(r.getY() + l * (h - r.getY())), g = 4; g <= 16; g <<= 1)try {
            c = this.findAlignmentInRegion(i, d, p, g);
            break;
        } catch (t) {
            if (!(t instanceof $12c6b0ab9da17bee$var$U)) throw t;
        }
        var y = t.createTransform(r, n, o, c, a), w = t.sampleGrid(this.image, y, a);
        return new $12c6b0ab9da17bee$var$Et(w, null === c ? [
            o,
            r,
            n
        ] : [
            o,
            r,
            n,
            c
        ]);
    }, t.createTransform = function(t, e, r, n, o) {
        var i, a, u, s, c = o - 3.5;
        return null !== n ? (i = n.getX(), a = n.getY(), s = u = c - 3) : (i = e.getX() - t.getX() + r.getX(), a = e.getY() - t.getY() + r.getY(), u = c, s = c), $12c6b0ab9da17bee$var$Tt.quadrilateralToQuadrilateral(3.5, 3.5, c, 3.5, u, s, 3.5, c, t.getX(), t.getY(), e.getX(), e.getY(), i, a, r.getX(), r.getY());
    }, t.sampleGrid = function(t, e, r) {
        return $12c6b0ab9da17bee$var$Nt.getInstance().sampleGridWithTransform(t, r, r, e);
    }, t.computeDimension = function(t, e, r, n) {
        var o = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$At.distance(t, e) / n), i = $12c6b0ab9da17bee$var$vt.round($12c6b0ab9da17bee$var$At.distance(t, r) / n), a = Math.floor((o + i) / 2) + 7;
        switch(3 & a){
            case 0:
                a++;
                break;
            case 2:
                a--;
                break;
            case 3:
                throw new $12c6b0ab9da17bee$var$U("Dimensions could be not found.");
        }
        return a;
    }, t.prototype.calculateModuleSize = function(t, e, r) {
        return (this.calculateModuleSizeOneWay(t, e) + this.calculateModuleSizeOneWay(t, r)) / 2;
    }, t.prototype.calculateModuleSizeOneWay = function(t, e) {
        var r = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.getX()), Math.floor(t.getY()), Math.floor(e.getX()), Math.floor(e.getY())), n = this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.getX()), Math.floor(e.getY()), Math.floor(t.getX()), Math.floor(t.getY()));
        return isNaN(r) ? n / 7 : isNaN(n) ? r / 7 : (r + n) / 14;
    }, t.prototype.sizeOfBlackWhiteBlackRunBothWays = function(t, e, r, n) {
        var o = this.sizeOfBlackWhiteBlackRun(t, e, r, n), i = 1, a = t - (r - t);
        a < 0 ? (i = t / (t - a), a = 0) : a >= this.image.getWidth() && (i = (this.image.getWidth() - 1 - t) / (a - t), a = this.image.getWidth() - 1);
        var u = Math.floor(e - (n - e) * i);
        return i = 1, u < 0 ? (i = e / (e - u), u = 0) : u >= this.image.getHeight() && (i = (this.image.getHeight() - 1 - e) / (u - e), u = this.image.getHeight() - 1), a = Math.floor(t + (a - t) * i), (o += this.sizeOfBlackWhiteBlackRun(t, e, a, u)) - 1;
    }, t.prototype.sizeOfBlackWhiteBlackRun = function(t, e, r, n) {
        var o = Math.abs(n - e) > Math.abs(r - t);
        if (o) {
            var i = t;
            t = e, e = i, i = r, r = n, n = i;
        }
        for(var a = Math.abs(r - t), u = Math.abs(n - e), s = -a / 2, c = t < r ? 1 : -1, f = e < n ? 1 : -1, h = 0, l = r + c, d = t, p = e; d !== l; d += c){
            var g = o ? p : d, y = o ? d : p;
            if (1 === h === this.image.get(g, y)) {
                if (2 === h) return $12c6b0ab9da17bee$var$vt.distance(d, p, t, e);
                h++;
            }
            if ((s += u) > 0) {
                if (p === n) break;
                p += f, s -= a;
            }
        }
        return 2 === h ? $12c6b0ab9da17bee$var$vt.distance(r + c, n, t, e) : NaN;
    }, t.prototype.findAlignmentInRegion = function(t, e, r, n) {
        var o = Math.floor(n * t), i = Math.max(0, e - o), a = Math.min(this.image.getWidth() - 1, e + o);
        if (a - i < 3 * t) throw new $12c6b0ab9da17bee$var$U("Alignment top exceeds estimated module size.");
        var u = Math.max(0, r - o), s = Math.min(this.image.getHeight() - 1, r + o);
        if (s - u < 3 * t) throw new $12c6b0ab9da17bee$var$U("Alignment bottom exceeds estimated module size.");
        return new $12c6b0ab9da17bee$var$Jr(this.image, i, u, a - i, s - u, t, this.resultPointCallback).find();
    }, t;
}(), $12c6b0ab9da17bee$var$an = function() {
    function t() {
        this.decoder = new $12c6b0ab9da17bee$var$Zr;
    }
    return t.prototype.getDecoder = function() {
        return this.decoder;
    }, t.prototype.decode = function(e, r) {
        var n, o;
        if (null != r && void 0 !== r.get($12c6b0ab9da17bee$var$T.PURE_BARCODE)) {
            var i = t.extractPureBits(e.getBlackMatrix());
            n = this.decoder.decodeBitMatrix(i, r), o = t.NO_POINTS;
        } else {
            var a = new $12c6b0ab9da17bee$var$on(e.getBlackMatrix()).detect(r);
            n = this.decoder.decodeBitMatrix(a.getBits(), r), o = a.getPoints();
        }
        n.getOther() instanceof $12c6b0ab9da17bee$var$zr && n.getOther().applyMirroredCorrection(o);
        var u = new $12c6b0ab9da17bee$var$et(n.getText(), n.getRawBytes(), void 0, o, $12c6b0ab9da17bee$var$nt.QR_CODE, void 0), s = n.getByteSegments();
        null !== s && u.putMetadata($12c6b0ab9da17bee$var$it.BYTE_SEGMENTS, s);
        var c = n.getECLevel();
        return null !== c && u.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, c), n.hasStructuredAppend() && (u.putMetadata($12c6b0ab9da17bee$var$it.STRUCTURED_APPEND_SEQUENCE, n.getStructuredAppendSequenceNumber()), u.putMetadata($12c6b0ab9da17bee$var$it.STRUCTURED_APPEND_PARITY, n.getStructuredAppendParity())), u;
    }, t.prototype.reset = function() {}, t.extractPureBits = function(t) {
        var e = t.getTopLeftOnBit(), r = t.getBottomRightOnBit();
        if (null === e || null === r) throw new $12c6b0ab9da17bee$var$U;
        var n = this.moduleSize(e, t), o = e[1], i = r[1], a = e[0], u = r[0];
        if (a >= u || o >= i) throw new $12c6b0ab9da17bee$var$U;
        if (i - o != u - a && (u = a + (i - o)) >= t.getWidth()) throw new $12c6b0ab9da17bee$var$U;
        var s = Math.round((u - a + 1) / n), c = Math.round((i - o + 1) / n);
        if (s <= 0 || c <= 0) throw new $12c6b0ab9da17bee$var$U;
        if (c !== s) throw new $12c6b0ab9da17bee$var$U;
        var f = Math.floor(n / 2);
        o += f;
        var h = (a += f) + Math.floor((s - 1) * n) - u;
        if (h > 0) {
            if (h > f) throw new $12c6b0ab9da17bee$var$U;
            a -= h;
        }
        var l = o + Math.floor((c - 1) * n) - i;
        if (l > 0) {
            if (l > f) throw new $12c6b0ab9da17bee$var$U;
            o -= l;
        }
        for(var d = new $12c6b0ab9da17bee$var$x(s, c), p = 0; p < c; p++)for(var g = o + Math.floor(p * n), y = 0; y < s; y++)t.get(a + Math.floor(y * n), g) && d.set(y, p);
        return d;
    }, t.moduleSize = function(t, e) {
        for(var r = e.getHeight(), n = e.getWidth(), o = t[0], i = t[1], a = !0, u = 0; o < n && i < r;){
            if (a !== e.get(o, i)) {
                if (5 == ++u) break;
                a = !a;
            }
            o++, i++;
        }
        if (o === n || i === r) throw new $12c6b0ab9da17bee$var$U;
        return (o - t[0]) / 7;
    }, t.NO_POINTS = new Array, t;
}(), $12c6b0ab9da17bee$var$un = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$sn = function() {
    function t() {}
    return t.prototype.PDF417Common = function() {}, t.getBitCountSum = function(t) {
        return $12c6b0ab9da17bee$var$vt.sum(t);
    }, t.toIntArray = function(e) {
        var r, n;
        if (null == e || !e.length) return t.EMPTY_INT_ARRAY;
        var o = new Int32Array(e.length), i = 0;
        try {
            for(var a = $12c6b0ab9da17bee$var$un(e), u = a.next(); !u.done; u = a.next()){
                var s = u.value;
                o[i++] = s;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                u && !u.done && (n = a.return) && n.call(a);
            } finally{
                if (r) throw r.error;
            }
        }
        return o;
    }, t.getCodeword = function(e) {
        var r = $12c6b0ab9da17bee$var$C.binarySearch(t.SYMBOL_TABLE, 262143 & e);
        return r < 0 ? -1 : (t.CODEWORD_TABLE[r] - 1) % t.NUMBER_OF_CODEWORDS;
    }, t.NUMBER_OF_CODEWORDS = 929, t.MAX_CODEWORDS_IN_BARCODE = t.NUMBER_OF_CODEWORDS - 1, t.MIN_ROWS_IN_BARCODE = 3, t.MAX_ROWS_IN_BARCODE = 90, t.MODULES_IN_CODEWORD = 17, t.MODULES_IN_STOP_PATTERN = 18, t.BARS_IN_MODULE = 8, t.EMPTY_INT_ARRAY = new Int32Array([]), t.SYMBOL_TABLE = Int32Array.from([
        66142,
        66170,
        66206,
        66236,
        66290,
        66292,
        66350,
        66382,
        66396,
        66454,
        66470,
        66476,
        66594,
        66600,
        66614,
        66626,
        66628,
        66632,
        66640,
        66654,
        66662,
        66668,
        66682,
        66690,
        66718,
        66720,
        66748,
        66758,
        66776,
        66798,
        66802,
        66804,
        66820,
        66824,
        66832,
        66846,
        66848,
        66876,
        66880,
        66936,
        66950,
        66956,
        66968,
        66992,
        67006,
        67022,
        67036,
        67042,
        67044,
        67048,
        67062,
        67118,
        67150,
        67164,
        67214,
        67228,
        67256,
        67294,
        67322,
        67350,
        67366,
        67372,
        67398,
        67404,
        67416,
        67438,
        67474,
        67476,
        67490,
        67492,
        67496,
        67510,
        67618,
        67624,
        67650,
        67656,
        67664,
        67678,
        67686,
        67692,
        67706,
        67714,
        67716,
        67728,
        67742,
        67744,
        67772,
        67782,
        67788,
        67800,
        67822,
        67826,
        67828,
        67842,
        67848,
        67870,
        67872,
        67900,
        67904,
        67960,
        67974,
        67992,
        68016,
        68030,
        68046,
        68060,
        68066,
        68068,
        68072,
        68086,
        68104,
        68112,
        68126,
        68128,
        68156,
        68160,
        68216,
        68336,
        68358,
        68364,
        68376,
        68400,
        68414,
        68448,
        68476,
        68494,
        68508,
        68536,
        68546,
        68548,
        68552,
        68560,
        68574,
        68582,
        68588,
        68654,
        68686,
        68700,
        68706,
        68708,
        68712,
        68726,
        68750,
        68764,
        68792,
        68802,
        68804,
        68808,
        68816,
        68830,
        68838,
        68844,
        68858,
        68878,
        68892,
        68920,
        68976,
        68990,
        68994,
        68996,
        69e3,
        69008,
        69022,
        69024,
        69052,
        69062,
        69068,
        69080,
        69102,
        69106,
        69108,
        69142,
        69158,
        69164,
        69190,
        69208,
        69230,
        69254,
        69260,
        69272,
        69296,
        69310,
        69326,
        69340,
        69386,
        69394,
        69396,
        69410,
        69416,
        69430,
        69442,
        69444,
        69448,
        69456,
        69470,
        69478,
        69484,
        69554,
        69556,
        69666,
        69672,
        69698,
        69704,
        69712,
        69726,
        69754,
        69762,
        69764,
        69776,
        69790,
        69792,
        69820,
        69830,
        69836,
        69848,
        69870,
        69874,
        69876,
        69890,
        69918,
        69920,
        69948,
        69952,
        70008,
        70022,
        70040,
        70064,
        70078,
        70094,
        70108,
        70114,
        70116,
        70120,
        70134,
        70152,
        70174,
        70176,
        70264,
        70384,
        70412,
        70448,
        70462,
        70496,
        70524,
        70542,
        70556,
        70584,
        70594,
        70600,
        70608,
        70622,
        70630,
        70636,
        70664,
        70672,
        70686,
        70688,
        70716,
        70720,
        70776,
        70896,
        71136,
        71180,
        71192,
        71216,
        71230,
        71264,
        71292,
        71360,
        71416,
        71452,
        71480,
        71536,
        71550,
        71554,
        71556,
        71560,
        71568,
        71582,
        71584,
        71612,
        71622,
        71628,
        71640,
        71662,
        71726,
        71732,
        71758,
        71772,
        71778,
        71780,
        71784,
        71798,
        71822,
        71836,
        71864,
        71874,
        71880,
        71888,
        71902,
        71910,
        71916,
        71930,
        71950,
        71964,
        71992,
        72048,
        72062,
        72066,
        72068,
        72080,
        72094,
        72096,
        72124,
        72134,
        72140,
        72152,
        72174,
        72178,
        72180,
        72206,
        72220,
        72248,
        72304,
        72318,
        72416,
        72444,
        72456,
        72464,
        72478,
        72480,
        72508,
        72512,
        72568,
        72588,
        72600,
        72624,
        72638,
        72654,
        72668,
        72674,
        72676,
        72680,
        72694,
        72726,
        72742,
        72748,
        72774,
        72780,
        72792,
        72814,
        72838,
        72856,
        72880,
        72894,
        72910,
        72924,
        72930,
        72932,
        72936,
        72950,
        72966,
        72972,
        72984,
        73008,
        73022,
        73056,
        73084,
        73102,
        73116,
        73144,
        73156,
        73160,
        73168,
        73182,
        73190,
        73196,
        73210,
        73226,
        73234,
        73236,
        73250,
        73252,
        73256,
        73270,
        73282,
        73284,
        73296,
        73310,
        73318,
        73324,
        73346,
        73348,
        73352,
        73360,
        73374,
        73376,
        73404,
        73414,
        73420,
        73432,
        73454,
        73498,
        73518,
        73522,
        73524,
        73550,
        73564,
        73570,
        73572,
        73576,
        73590,
        73800,
        73822,
        73858,
        73860,
        73872,
        73886,
        73888,
        73916,
        73944,
        73970,
        73972,
        73992,
        74014,
        74016,
        74044,
        74048,
        74104,
        74118,
        74136,
        74160,
        74174,
        74210,
        74212,
        74216,
        74230,
        74244,
        74256,
        74270,
        74272,
        74360,
        74480,
        74502,
        74508,
        74544,
        74558,
        74592,
        74620,
        74638,
        74652,
        74680,
        74690,
        74696,
        74704,
        74726,
        74732,
        74782,
        74784,
        74812,
        74992,
        75232,
        75288,
        75326,
        75360,
        75388,
        75456,
        75512,
        75576,
        75632,
        75646,
        75650,
        75652,
        75664,
        75678,
        75680,
        75708,
        75718,
        75724,
        75736,
        75758,
        75808,
        75836,
        75840,
        75896,
        76016,
        76256,
        76736,
        76824,
        76848,
        76862,
        76896,
        76924,
        76992,
        77048,
        77296,
        77340,
        77368,
        77424,
        77438,
        77536,
        77564,
        77572,
        77576,
        77584,
        77600,
        77628,
        77632,
        77688,
        77702,
        77708,
        77720,
        77744,
        77758,
        77774,
        77788,
        77870,
        77902,
        77916,
        77922,
        77928,
        77966,
        77980,
        78008,
        78018,
        78024,
        78032,
        78046,
        78060,
        78074,
        78094,
        78136,
        78192,
        78206,
        78210,
        78212,
        78224,
        78238,
        78240,
        78268,
        78278,
        78284,
        78296,
        78322,
        78324,
        78350,
        78364,
        78448,
        78462,
        78560,
        78588,
        78600,
        78622,
        78624,
        78652,
        78656,
        78712,
        78726,
        78744,
        78768,
        78782,
        78798,
        78812,
        78818,
        78820,
        78824,
        78838,
        78862,
        78876,
        78904,
        78960,
        78974,
        79072,
        79100,
        79296,
        79352,
        79368,
        79376,
        79390,
        79392,
        79420,
        79424,
        79480,
        79600,
        79628,
        79640,
        79664,
        79678,
        79712,
        79740,
        79772,
        79800,
        79810,
        79812,
        79816,
        79824,
        79838,
        79846,
        79852,
        79894,
        79910,
        79916,
        79942,
        79948,
        79960,
        79982,
        79988,
        80006,
        80024,
        80048,
        80062,
        80078,
        80092,
        80098,
        80100,
        80104,
        80134,
        80140,
        80176,
        80190,
        80224,
        80252,
        80270,
        80284,
        80312,
        80328,
        80336,
        80350,
        80358,
        80364,
        80378,
        80390,
        80396,
        80408,
        80432,
        80446,
        80480,
        80508,
        80576,
        80632,
        80654,
        80668,
        80696,
        80752,
        80766,
        80776,
        80784,
        80798,
        80800,
        80828,
        80844,
        80856,
        80878,
        80882,
        80884,
        80914,
        80916,
        80930,
        80932,
        80936,
        80950,
        80962,
        80968,
        80976,
        80990,
        80998,
        81004,
        81026,
        81028,
        81040,
        81054,
        81056,
        81084,
        81094,
        81100,
        81112,
        81134,
        81154,
        81156,
        81160,
        81168,
        81182,
        81184,
        81212,
        81216,
        81272,
        81286,
        81292,
        81304,
        81328,
        81342,
        81358,
        81372,
        81380,
        81384,
        81398,
        81434,
        81454,
        81458,
        81460,
        81486,
        81500,
        81506,
        81508,
        81512,
        81526,
        81550,
        81564,
        81592,
        81602,
        81604,
        81608,
        81616,
        81630,
        81638,
        81644,
        81702,
        81708,
        81722,
        81734,
        81740,
        81752,
        81774,
        81778,
        81780,
        82050,
        82078,
        82080,
        82108,
        82180,
        82184,
        82192,
        82206,
        82208,
        82236,
        82240,
        82296,
        82316,
        82328,
        82352,
        82366,
        82402,
        82404,
        82408,
        82440,
        82448,
        82462,
        82464,
        82492,
        82496,
        82552,
        82672,
        82694,
        82700,
        82712,
        82736,
        82750,
        82784,
        82812,
        82830,
        82882,
        82884,
        82888,
        82896,
        82918,
        82924,
        82952,
        82960,
        82974,
        82976,
        83004,
        83008,
        83064,
        83184,
        83424,
        83468,
        83480,
        83504,
        83518,
        83552,
        83580,
        83648,
        83704,
        83740,
        83768,
        83824,
        83838,
        83842,
        83844,
        83848,
        83856,
        83872,
        83900,
        83910,
        83916,
        83928,
        83950,
        83984,
        84e3,
        84028,
        84032,
        84088,
        84208,
        84448,
        84928,
        85040,
        85054,
        85088,
        85116,
        85184,
        85240,
        85488,
        85560,
        85616,
        85630,
        85728,
        85756,
        85764,
        85768,
        85776,
        85790,
        85792,
        85820,
        85824,
        85880,
        85894,
        85900,
        85912,
        85936,
        85966,
        85980,
        86048,
        86080,
        86136,
        86256,
        86496,
        86976,
        88160,
        88188,
        88256,
        88312,
        88560,
        89056,
        89200,
        89214,
        89312,
        89340,
        89536,
        89592,
        89608,
        89616,
        89632,
        89664,
        89720,
        89840,
        89868,
        89880,
        89904,
        89952,
        89980,
        89998,
        90012,
        90040,
        90190,
        90204,
        90254,
        90268,
        90296,
        90306,
        90308,
        90312,
        90334,
        90382,
        90396,
        90424,
        90480,
        90494,
        90500,
        90504,
        90512,
        90526,
        90528,
        90556,
        90566,
        90572,
        90584,
        90610,
        90612,
        90638,
        90652,
        90680,
        90736,
        90750,
        90848,
        90876,
        90884,
        90888,
        90896,
        90910,
        90912,
        90940,
        90944,
        91e3,
        91014,
        91020,
        91032,
        91056,
        91070,
        91086,
        91100,
        91106,
        91108,
        91112,
        91126,
        91150,
        91164,
        91192,
        91248,
        91262,
        91360,
        91388,
        91584,
        91640,
        91664,
        91678,
        91680,
        91708,
        91712,
        91768,
        91888,
        91928,
        91952,
        91966,
        92e3,
        92028,
        92046,
        92060,
        92088,
        92098,
        92100,
        92104,
        92112,
        92126,
        92134,
        92140,
        92188,
        92216,
        92272,
        92384,
        92412,
        92608,
        92664,
        93168,
        93200,
        93214,
        93216,
        93244,
        93248,
        93304,
        93424,
        93664,
        93720,
        93744,
        93758,
        93792,
        93820,
        93888,
        93944,
        93980,
        94008,
        94064,
        94078,
        94084,
        94088,
        94096,
        94110,
        94112,
        94140,
        94150,
        94156,
        94168,
        94246,
        94252,
        94278,
        94284,
        94296,
        94318,
        94342,
        94348,
        94360,
        94384,
        94398,
        94414,
        94428,
        94440,
        94470,
        94476,
        94488,
        94512,
        94526,
        94560,
        94588,
        94606,
        94620,
        94648,
        94658,
        94660,
        94664,
        94672,
        94686,
        94694,
        94700,
        94714,
        94726,
        94732,
        94744,
        94768,
        94782,
        94816,
        94844,
        94912,
        94968,
        94990,
        95004,
        95032,
        95088,
        95102,
        95112,
        95120,
        95134,
        95136,
        95164,
        95180,
        95192,
        95214,
        95218,
        95220,
        95244,
        95256,
        95280,
        95294,
        95328,
        95356,
        95424,
        95480,
        95728,
        95758,
        95772,
        95800,
        95856,
        95870,
        95968,
        95996,
        96008,
        96016,
        96030,
        96032,
        96060,
        96064,
        96120,
        96152,
        96176,
        96190,
        96220,
        96226,
        96228,
        96232,
        96290,
        96292,
        96296,
        96310,
        96322,
        96324,
        96328,
        96336,
        96350,
        96358,
        96364,
        96386,
        96388,
        96392,
        96400,
        96414,
        96416,
        96444,
        96454,
        96460,
        96472,
        96494,
        96498,
        96500,
        96514,
        96516,
        96520,
        96528,
        96542,
        96544,
        96572,
        96576,
        96632,
        96646,
        96652,
        96664,
        96688,
        96702,
        96718,
        96732,
        96738,
        96740,
        96744,
        96758,
        96772,
        96776,
        96784,
        96798,
        96800,
        96828,
        96832,
        96888,
        97008,
        97030,
        97036,
        97048,
        97072,
        97086,
        97120,
        97148,
        97166,
        97180,
        97208,
        97220,
        97224,
        97232,
        97246,
        97254,
        97260,
        97326,
        97330,
        97332,
        97358,
        97372,
        97378,
        97380,
        97384,
        97398,
        97422,
        97436,
        97464,
        97474,
        97476,
        97480,
        97488,
        97502,
        97510,
        97516,
        97550,
        97564,
        97592,
        97648,
        97666,
        97668,
        97672,
        97680,
        97694,
        97696,
        97724,
        97734,
        97740,
        97752,
        97774,
        97830,
        97836,
        97850,
        97862,
        97868,
        97880,
        97902,
        97906,
        97908,
        97926,
        97932,
        97944,
        97968,
        97998,
        98012,
        98018,
        98020,
        98024,
        98038,
        98618,
        98674,
        98676,
        98838,
        98854,
        98874,
        98892,
        98904,
        98926,
        98930,
        98932,
        98968,
        99006,
        99042,
        99044,
        99048,
        99062,
        99166,
        99194,
        99246,
        99286,
        99350,
        99366,
        99372,
        99386,
        99398,
        99416,
        99438,
        99442,
        99444,
        99462,
        99504,
        99518,
        99534,
        99548,
        99554,
        99556,
        99560,
        99574,
        99590,
        99596,
        99608,
        99632,
        99646,
        99680,
        99708,
        99726,
        99740,
        99768,
        99778,
        99780,
        99784,
        99792,
        99806,
        99814,
        99820,
        99834,
        99858,
        99860,
        99874,
        99880,
        99894,
        99906,
        99920,
        99934,
        99962,
        99970,
        99972,
        99976,
        99984,
        99998,
        1e5,
        100028,
        100038,
        100044,
        100056,
        100078,
        100082,
        100084,
        100142,
        100174,
        100188,
        100246,
        100262,
        100268,
        100306,
        100308,
        100390,
        100396,
        100410,
        100422,
        100428,
        100440,
        100462,
        100466,
        100468,
        100486,
        100504,
        100528,
        100542,
        100558,
        100572,
        100578,
        100580,
        100584,
        100598,
        100620,
        100656,
        100670,
        100704,
        100732,
        100750,
        100792,
        100802,
        100808,
        100816,
        100830,
        100838,
        100844,
        100858,
        100888,
        100912,
        100926,
        100960,
        100988,
        101056,
        101112,
        101148,
        101176,
        101232,
        101246,
        101250,
        101252,
        101256,
        101264,
        101278,
        101280,
        101308,
        101318,
        101324,
        101336,
        101358,
        101362,
        101364,
        101410,
        101412,
        101416,
        101430,
        101442,
        101448,
        101456,
        101470,
        101478,
        101498,
        101506,
        101508,
        101520,
        101534,
        101536,
        101564,
        101580,
        101618,
        101620,
        101636,
        101640,
        101648,
        101662,
        101664,
        101692,
        101696,
        101752,
        101766,
        101784,
        101838,
        101858,
        101860,
        101864,
        101934,
        101938,
        101940,
        101966,
        101980,
        101986,
        101988,
        101992,
        102030,
        102044,
        102072,
        102082,
        102084,
        102088,
        102096,
        102138,
        102166,
        102182,
        102188,
        102214,
        102220,
        102232,
        102254,
        102282,
        102290,
        102292,
        102306,
        102308,
        102312,
        102326,
        102444,
        102458,
        102470,
        102476,
        102488,
        102514,
        102516,
        102534,
        102552,
        102576,
        102590,
        102606,
        102620,
        102626,
        102632,
        102646,
        102662,
        102668,
        102704,
        102718,
        102752,
        102780,
        102798,
        102812,
        102840,
        102850,
        102856,
        102864,
        102878,
        102886,
        102892,
        102906,
        102936,
        102974,
        103008,
        103036,
        103104,
        103160,
        103224,
        103280,
        103294,
        103298,
        103300,
        103312,
        103326,
        103328,
        103356,
        103366,
        103372,
        103384,
        103406,
        103410,
        103412,
        103472,
        103486,
        103520,
        103548,
        103616,
        103672,
        103920,
        103992,
        104048,
        104062,
        104160,
        104188,
        104194,
        104196,
        104200,
        104208,
        104224,
        104252,
        104256,
        104312,
        104326,
        104332,
        104344,
        104368,
        104382,
        104398,
        104412,
        104418,
        104420,
        104424,
        104482,
        104484,
        104514,
        104520,
        104528,
        104542,
        104550,
        104570,
        104578,
        104580,
        104592,
        104606,
        104608,
        104636,
        104652,
        104690,
        104692,
        104706,
        104712,
        104734,
        104736,
        104764,
        104768,
        104824,
        104838,
        104856,
        104910,
        104930,
        104932,
        104936,
        104968,
        104976,
        104990,
        104992,
        105020,
        105024,
        105080,
        105200,
        105240,
        105278,
        105312,
        105372,
        105410,
        105412,
        105416,
        105424,
        105446,
        105518,
        105524,
        105550,
        105564,
        105570,
        105572,
        105576,
        105614,
        105628,
        105656,
        105666,
        105672,
        105680,
        105702,
        105722,
        105742,
        105756,
        105784,
        105840,
        105854,
        105858,
        105860,
        105864,
        105872,
        105888,
        105932,
        105970,
        105972,
        106006,
        106022,
        106028,
        106054,
        106060,
        106072,
        106100,
        106118,
        106124,
        106136,
        106160,
        106174,
        106190,
        106210,
        106212,
        106216,
        106250,
        106258,
        106260,
        106274,
        106276,
        106280,
        106306,
        106308,
        106312,
        106320,
        106334,
        106348,
        106394,
        106414,
        106418,
        106420,
        106566,
        106572,
        106610,
        106612,
        106630,
        106636,
        106648,
        106672,
        106686,
        106722,
        106724,
        106728,
        106742,
        106758,
        106764,
        106776,
        106800,
        106814,
        106848,
        106876,
        106894,
        106908,
        106936,
        106946,
        106948,
        106952,
        106960,
        106974,
        106982,
        106988,
        107032,
        107056,
        107070,
        107104,
        107132,
        107200,
        107256,
        107292,
        107320,
        107376,
        107390,
        107394,
        107396,
        107400,
        107408,
        107422,
        107424,
        107452,
        107462,
        107468,
        107480,
        107502,
        107506,
        107508,
        107544,
        107568,
        107582,
        107616,
        107644,
        107712,
        107768,
        108016,
        108060,
        108088,
        108144,
        108158,
        108256,
        108284,
        108290,
        108292,
        108296,
        108304,
        108318,
        108320,
        108348,
        108352,
        108408,
        108422,
        108428,
        108440,
        108464,
        108478,
        108494,
        108508,
        108514,
        108516,
        108520,
        108592,
        108640,
        108668,
        108736,
        108792,
        109040,
        109536,
        109680,
        109694,
        109792,
        109820,
        110016,
        110072,
        110084,
        110088,
        110096,
        110112,
        110140,
        110144,
        110200,
        110320,
        110342,
        110348,
        110360,
        110384,
        110398,
        110432,
        110460,
        110478,
        110492,
        110520,
        110532,
        110536,
        110544,
        110558,
        110658,
        110686,
        110714,
        110722,
        110724,
        110728,
        110736,
        110750,
        110752,
        110780,
        110796,
        110834,
        110836,
        110850,
        110852,
        110856,
        110864,
        110878,
        110880,
        110908,
        110912,
        110968,
        110982,
        111e3,
        111054,
        111074,
        111076,
        111080,
        111108,
        111112,
        111120,
        111134,
        111136,
        111164,
        111168,
        111224,
        111344,
        111372,
        111422,
        111456,
        111516,
        111554,
        111556,
        111560,
        111568,
        111590,
        111632,
        111646,
        111648,
        111676,
        111680,
        111736,
        111856,
        112096,
        112152,
        112224,
        112252,
        112320,
        112440,
        112514,
        112516,
        112520,
        112528,
        112542,
        112544,
        112588,
        112686,
        112718,
        112732,
        112782,
        112796,
        112824,
        112834,
        112836,
        112840,
        112848,
        112870,
        112890,
        112910,
        112924,
        112952,
        113008,
        113022,
        113026,
        113028,
        113032,
        113040,
        113054,
        113056,
        113100,
        113138,
        113140,
        113166,
        113180,
        113208,
        113264,
        113278,
        113376,
        113404,
        113416,
        113424,
        113440,
        113468,
        113472,
        113560,
        113614,
        113634,
        113636,
        113640,
        113686,
        113702,
        113708,
        113734,
        113740,
        113752,
        113778,
        113780,
        113798,
        113804,
        113816,
        113840,
        113854,
        113870,
        113890,
        113892,
        113896,
        113926,
        113932,
        113944,
        113968,
        113982,
        114016,
        114044,
        114076,
        114114,
        114116,
        114120,
        114128,
        114150,
        114170,
        114194,
        114196,
        114210,
        114212,
        114216,
        114242,
        114244,
        114248,
        114256,
        114270,
        114278,
        114306,
        114308,
        114312,
        114320,
        114334,
        114336,
        114364,
        114380,
        114420,
        114458,
        114478,
        114482,
        114484,
        114510,
        114524,
        114530,
        114532,
        114536,
        114842,
        114866,
        114868,
        114970,
        114994,
        114996,
        115042,
        115044,
        115048,
        115062,
        115130,
        115226,
        115250,
        115252,
        115278,
        115292,
        115298,
        115300,
        115304,
        115318,
        115342,
        115394,
        115396,
        115400,
        115408,
        115422,
        115430,
        115436,
        115450,
        115478,
        115494,
        115514,
        115526,
        115532,
        115570,
        115572,
        115738,
        115758,
        115762,
        115764,
        115790,
        115804,
        115810,
        115812,
        115816,
        115830,
        115854,
        115868,
        115896,
        115906,
        115912,
        115920,
        115934,
        115942,
        115948,
        115962,
        115996,
        116024,
        116080,
        116094,
        116098,
        116100,
        116104,
        116112,
        116126,
        116128,
        116156,
        116166,
        116172,
        116184,
        116206,
        116210,
        116212,
        116246,
        116262,
        116268,
        116282,
        116294,
        116300,
        116312,
        116334,
        116338,
        116340,
        116358,
        116364,
        116376,
        116400,
        116414,
        116430,
        116444,
        116450,
        116452,
        116456,
        116498,
        116500,
        116514,
        116520,
        116534,
        116546,
        116548,
        116552,
        116560,
        116574,
        116582,
        116588,
        116602,
        116654,
        116694,
        116714,
        116762,
        116782,
        116786,
        116788,
        116814,
        116828,
        116834,
        116836,
        116840,
        116854,
        116878,
        116892,
        116920,
        116930,
        116936,
        116944,
        116958,
        116966,
        116972,
        116986,
        117006,
        117048,
        117104,
        117118,
        117122,
        117124,
        117136,
        117150,
        117152,
        117180,
        117190,
        117196,
        117208,
        117230,
        117234,
        117236,
        117304,
        117360,
        117374,
        117472,
        117500,
        117506,
        117508,
        117512,
        117520,
        117536,
        117564,
        117568,
        117624,
        117638,
        117644,
        117656,
        117680,
        117694,
        117710,
        117724,
        117730,
        117732,
        117736,
        117750,
        117782,
        117798,
        117804,
        117818,
        117830,
        117848,
        117874,
        117876,
        117894,
        117936,
        117950,
        117966,
        117986,
        117988,
        117992,
        118022,
        118028,
        118040,
        118064,
        118078,
        118112,
        118140,
        118172,
        118210,
        118212,
        118216,
        118224,
        118238,
        118246,
        118266,
        118306,
        118312,
        118338,
        118352,
        118366,
        118374,
        118394,
        118402,
        118404,
        118408,
        118416,
        118430,
        118432,
        118460,
        118476,
        118514,
        118516,
        118574,
        118578,
        118580,
        118606,
        118620,
        118626,
        118628,
        118632,
        118678,
        118694,
        118700,
        118730,
        118738,
        118740,
        118830,
        118834,
        118836,
        118862,
        118876,
        118882,
        118884,
        118888,
        118902,
        118926,
        118940,
        118968,
        118978,
        118980,
        118984,
        118992,
        119006,
        119014,
        119020,
        119034,
        119068,
        119096,
        119152,
        119166,
        119170,
        119172,
        119176,
        119184,
        119198,
        119200,
        119228,
        119238,
        119244,
        119256,
        119278,
        119282,
        119284,
        119324,
        119352,
        119408,
        119422,
        119520,
        119548,
        119554,
        119556,
        119560,
        119568,
        119582,
        119584,
        119612,
        119616,
        119672,
        119686,
        119692,
        119704,
        119728,
        119742,
        119758,
        119772,
        119778,
        119780,
        119784,
        119798,
        119920,
        119934,
        120032,
        120060,
        120256,
        120312,
        120324,
        120328,
        120336,
        120352,
        120384,
        120440,
        120560,
        120582,
        120588,
        120600,
        120624,
        120638,
        120672,
        120700,
        120718,
        120732,
        120760,
        120770,
        120772,
        120776,
        120784,
        120798,
        120806,
        120812,
        120870,
        120876,
        120890,
        120902,
        120908,
        120920,
        120946,
        120948,
        120966,
        120972,
        120984,
        121008,
        121022,
        121038,
        121058,
        121060,
        121064,
        121078,
        121100,
        121112,
        121136,
        121150,
        121184,
        121212,
        121244,
        121282,
        121284,
        121288,
        121296,
        121318,
        121338,
        121356,
        121368,
        121392,
        121406,
        121440,
        121468,
        121536,
        121592,
        121656,
        121730,
        121732,
        121736,
        121744,
        121758,
        121760,
        121804,
        121842,
        121844,
        121890,
        121922,
        121924,
        121928,
        121936,
        121950,
        121958,
        121978,
        121986,
        121988,
        121992,
        122e3,
        122014,
        122016,
        122044,
        122060,
        122098,
        122100,
        122116,
        122120,
        122128,
        122142,
        122144,
        122172,
        122176,
        122232,
        122246,
        122264,
        122318,
        122338,
        122340,
        122344,
        122414,
        122418,
        122420,
        122446,
        122460,
        122466,
        122468,
        122472,
        122510,
        122524,
        122552,
        122562,
        122564,
        122568,
        122576,
        122598,
        122618,
        122646,
        122662,
        122668,
        122694,
        122700,
        122712,
        122738,
        122740,
        122762,
        122770,
        122772,
        122786,
        122788,
        122792,
        123018,
        123026,
        123028,
        123042,
        123044,
        123048,
        123062,
        123098,
        123146,
        123154,
        123156,
        123170,
        123172,
        123176,
        123190,
        123202,
        123204,
        123208,
        123216,
        123238,
        123244,
        123258,
        123290,
        123314,
        123316,
        123402,
        123410,
        123412,
        123426,
        123428,
        123432,
        123446,
        123458,
        123464,
        123472,
        123486,
        123494,
        123500,
        123514,
        123522,
        123524,
        123528,
        123536,
        123552,
        123580,
        123590,
        123596,
        123608,
        123630,
        123634,
        123636,
        123674,
        123698,
        123700,
        123740,
        123746,
        123748,
        123752,
        123834,
        123914,
        123922,
        123924,
        123938,
        123944,
        123958,
        123970,
        123976,
        123984,
        123998,
        124006,
        124012,
        124026,
        124034,
        124036,
        124048,
        124062,
        124064,
        124092,
        124102,
        124108,
        124120,
        124142,
        124146,
        124148,
        124162,
        124164,
        124168,
        124176,
        124190,
        124192,
        124220,
        124224,
        124280,
        124294,
        124300,
        124312,
        124336,
        124350,
        124366,
        124380,
        124386,
        124388,
        124392,
        124406,
        124442,
        124462,
        124466,
        124468,
        124494,
        124508,
        124514,
        124520,
        124558,
        124572,
        124600,
        124610,
        124612,
        124616,
        124624,
        124646,
        124666,
        124694,
        124710,
        124716,
        124730,
        124742,
        124748,
        124760,
        124786,
        124788,
        124818,
        124820,
        124834,
        124836,
        124840,
        124854,
        124946,
        124948,
        124962,
        124964,
        124968,
        124982,
        124994,
        124996,
        125e3,
        125008,
        125022,
        125030,
        125036,
        125050,
        125058,
        125060,
        125064,
        125072,
        125086,
        125088,
        125116,
        125126,
        125132,
        125144,
        125166,
        125170,
        125172,
        125186,
        125188,
        125192,
        125200,
        125216,
        125244,
        125248,
        125304,
        125318,
        125324,
        125336,
        125360,
        125374,
        125390,
        125404,
        125410,
        125412,
        125416,
        125430,
        125444,
        125448,
        125456,
        125472,
        125504,
        125560,
        125680,
        125702,
        125708,
        125720,
        125744,
        125758,
        125792,
        125820,
        125838,
        125852,
        125880,
        125890,
        125892,
        125896,
        125904,
        125918,
        125926,
        125932,
        125978,
        125998,
        126002,
        126004,
        126030,
        126044,
        126050,
        126052,
        126056,
        126094,
        126108,
        126136,
        126146,
        126148,
        126152,
        126160,
        126182,
        126202,
        126222,
        126236,
        126264,
        126320,
        126334,
        126338,
        126340,
        126344,
        126352,
        126366,
        126368,
        126412,
        126450,
        126452,
        126486,
        126502,
        126508,
        126522,
        126534,
        126540,
        126552,
        126574,
        126578,
        126580,
        126598,
        126604,
        126616,
        126640,
        126654,
        126670,
        126684,
        126690,
        126692,
        126696,
        126738,
        126754,
        126756,
        126760,
        126774,
        126786,
        126788,
        126792,
        126800,
        126814,
        126822,
        126828,
        126842,
        126894,
        126898,
        126900,
        126934,
        127126,
        127142,
        127148,
        127162,
        127178,
        127186,
        127188,
        127254,
        127270,
        127276,
        127290,
        127302,
        127308,
        127320,
        127342,
        127346,
        127348,
        127370,
        127378,
        127380,
        127394,
        127396,
        127400,
        127450,
        127510,
        127526,
        127532,
        127546,
        127558,
        127576,
        127598,
        127602,
        127604,
        127622,
        127628,
        127640,
        127664,
        127678,
        127694,
        127708,
        127714,
        127716,
        127720,
        127734,
        127754,
        127762,
        127764,
        127778,
        127784,
        127810,
        127812,
        127816,
        127824,
        127838,
        127846,
        127866,
        127898,
        127918,
        127922,
        127924,
        128022,
        128038,
        128044,
        128058,
        128070,
        128076,
        128088,
        128110,
        128114,
        128116,
        128134,
        128140,
        128152,
        128176,
        128190,
        128206,
        128220,
        128226,
        128228,
        128232,
        128246,
        128262,
        128268,
        128280,
        128304,
        128318,
        128352,
        128380,
        128398,
        128412,
        128440,
        128450,
        128452,
        128456,
        128464,
        128478,
        128486,
        128492,
        128506,
        128522,
        128530,
        128532,
        128546,
        128548,
        128552,
        128566,
        128578,
        128580,
        128584,
        128592,
        128606,
        128614,
        128634,
        128642,
        128644,
        128648,
        128656,
        128670,
        128672,
        128700,
        128716,
        128754,
        128756,
        128794,
        128814,
        128818,
        128820,
        128846,
        128860,
        128866,
        128868,
        128872,
        128886,
        128918,
        128934,
        128940,
        128954,
        128978,
        128980,
        129178,
        129198,
        129202,
        129204,
        129238,
        129258,
        129306,
        129326,
        129330,
        129332,
        129358,
        129372,
        129378,
        129380,
        129384,
        129398,
        129430,
        129446,
        129452,
        129466,
        129482,
        129490,
        129492,
        129562,
        129582,
        129586,
        129588,
        129614,
        129628,
        129634,
        129636,
        129640,
        129654,
        129678,
        129692,
        129720,
        129730,
        129732,
        129736,
        129744,
        129758,
        129766,
        129772,
        129814,
        129830,
        129836,
        129850,
        129862,
        129868,
        129880,
        129902,
        129906,
        129908,
        129930,
        129938,
        129940,
        129954,
        129956,
        129960,
        129974,
        130010
    ]), t.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2e3,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1e3,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]), t;
}(), $12c6b0ab9da17bee$var$cn = function() {
    function t(t, e) {
        this.bits = t, this.points = e;
    }
    return t.prototype.getBits = function() {
        return this.bits;
    }, t.prototype.getPoints = function() {
        return this.points;
    }, t;
}(), $12c6b0ab9da17bee$var$fn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$hn = function() {
    function t() {}
    return t.detectMultiple = function(e, r, n) {
        var o = e.getBlackMatrix(), i = t.detect(n, o);
        return i.length || ((o = o.clone()).rotate180(), i = t.detect(n, o)), new $12c6b0ab9da17bee$var$cn(o, i);
    }, t.detect = function(e, r) {
        for(var n, o, i = new Array, a = 0, u = 0, s = !1; a < r.getHeight();){
            var c = t.findVertices(r, a, u);
            if (null != c[0] || null != c[3]) {
                if (s = !0, i.push(c), !e) break;
                null != c[2] ? (u = Math.trunc(c[2].getX()), a = Math.trunc(c[2].getY())) : (u = Math.trunc(c[4].getX()), a = Math.trunc(c[4].getY()));
            } else {
                if (!s) break;
                s = !1, u = 0;
                try {
                    for(var f = (n = void 0, $12c6b0ab9da17bee$var$fn(i)), h = f.next(); !h.done; h = f.next()){
                        var l = h.value;
                        null != l[1] && (a = Math.trunc(Math.max(a, l[1].getY()))), null != l[3] && (a = Math.max(a, Math.trunc(l[3].getY())));
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        h && !h.done && (o = f.return) && o.call(f);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                a += t.ROW_STEP;
            }
        }
        return i;
    }, t.findVertices = function(e, r, n) {
        var o = e.getHeight(), i = e.getWidth(), a = new Array(8);
        return t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.START_PATTERN), t.INDEXES_START_PATTERN), null != a[4] && (n = Math.trunc(a[4].getX()), r = Math.trunc(a[4].getY())), t.copyToResult(a, t.findRowsWithPattern(e, o, i, r, n, t.STOP_PATTERN), t.INDEXES_STOP_PATTERN), a;
    }, t.copyToResult = function(t, e, r) {
        for(var n = 0; n < r.length; n++)t[r[n]] = e[n];
    }, t.findRowsWithPattern = function(e, r, n, o, i, a) {
        for(var u = new Array(4), s = !1, c = new Int32Array(a.length); o < r; o += t.ROW_STEP)if (null != (d = t.findGuardPattern(e, i, o, n, !1, a, c))) {
            for(; o > 0;){
                if (null == (l = t.findGuardPattern(e, i, --o, n, !1, a, c))) {
                    o++;
                    break;
                }
                d = l;
            }
            u[0] = new $12c6b0ab9da17bee$var$At(d[0], o), u[1] = new $12c6b0ab9da17bee$var$At(d[1], o), s = !0;
            break;
        }
        var f = o + 1;
        if (s) {
            for(var h = 0, l = Int32Array.from([
                Math.trunc(u[0].getX()),
                Math.trunc(u[1].getX())
            ]); f < r; f++){
                var d;
                if (null != (d = t.findGuardPattern(e, l[0], f, n, !1, a, c)) && Math.abs(l[0] - d[0]) < t.MAX_PATTERN_DRIFT && Math.abs(l[1] - d[1]) < t.MAX_PATTERN_DRIFT) l = d, h = 0;
                else {
                    if (h > t.SKIPPED_ROW_COUNT_MAX) break;
                    h++;
                }
            }
            f -= h + 1, u[2] = new $12c6b0ab9da17bee$var$At(l[0], f), u[3] = new $12c6b0ab9da17bee$var$At(l[1], f);
        }
        return f - o < t.BARCODE_MIN_HEIGHT && $12c6b0ab9da17bee$var$C.fill(u, null), u;
    }, t.findGuardPattern = function(e, r, n, o, i, a, u) {
        $12c6b0ab9da17bee$var$C.fillWithin(u, 0, u.length, 0);
        for(var s = r, c = 0; e.get(s, n) && s > 0 && c++ < t.MAX_PIXEL_DRIFT;)s--;
        for(var f = s, h = 0, l = a.length, d = i; f < o; f++)if (e.get(f, n) !== d) u[h]++;
        else {
            if (h === l - 1) {
                if (t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE) return new Int32Array([
                    s,
                    f
                ]);
                s += u[0] + u[1], $12c6b0ab9da17bee$var$w.arraycopy(u, 2, u, 0, h - 1), u[h - 1] = 0, u[h] = 0, h--;
            } else h++;
            u[h] = 1, d = !d;
        }
        return h === l - 1 && t.patternMatchVariance(u, a, t.MAX_INDIVIDUAL_VARIANCE) < t.MAX_AVG_VARIANCE ? new Int32Array([
            s,
            f - 1
        ]) : null;
    }, t.patternMatchVariance = function(t, e, r) {
        for(var n = t.length, o = 0, i = 0, a = 0; a < n; a++)o += t[a], i += e[a];
        if (o < i) return 1 / 0;
        var u = o / i;
        r *= u;
        for(var s = 0, c = 0; c < n; c++){
            var f = t[c], h = e[c] * u, l = f > h ? f - h : h - f;
            if (l > r) return 1 / 0;
            s += l;
        }
        return s / o;
    }, t.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]), t.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]), t.MAX_AVG_VARIANCE = .42, t.MAX_INDIVIDUAL_VARIANCE = .8, t.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]), t.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]), t.MAX_PIXEL_DRIFT = 3, t.MAX_PATTERN_DRIFT = 5, t.SKIPPED_ROW_COUNT_MAX = 25, t.ROW_STEP = 5, t.BARCODE_MIN_HEIGHT = 10, t;
}(), $12c6b0ab9da17bee$var$ln = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$dn = function() {
    function t(t, e) {
        if (0 === e.length) throw new $12c6b0ab9da17bee$var$l;
        this.field = t;
        var r = e.length;
        if (r > 1 && 0 === e[0]) {
            for(var n = 1; n < r && 0 === e[n];)n++;
            n === r ? this.coefficients = new Int32Array([
                0
            ]) : (this.coefficients = new Int32Array(r - n), $12c6b0ab9da17bee$var$w.arraycopy(e, n, this.coefficients, 0, this.coefficients.length));
        } else this.coefficients = e;
    }
    return t.prototype.getCoefficients = function() {
        return this.coefficients;
    }, t.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    }, t.prototype.isZero = function() {
        return 0 === this.coefficients[0];
    }, t.prototype.getCoefficient = function(t) {
        return this.coefficients[this.coefficients.length - 1 - t];
    }, t.prototype.evaluateAt = function(t) {
        var e, r;
        if (0 === t) return this.getCoefficient(0);
        if (1 === t) {
            var n = 0;
            try {
                for(var o = $12c6b0ab9da17bee$var$ln(this.coefficients), i = o.next(); !i.done; i = o.next()){
                    var a = i.value;
                    n = this.field.add(n, a);
                }
            } catch (t) {
                e = {
                    error: t
                };
            } finally{
                try {
                    i && !i.done && (r = o.return) && r.call(o);
                } finally{
                    if (e) throw e.error;
                }
            }
            return n;
        }
        for(var u = this.coefficients[0], s = this.coefficients.length, c = 1; c < s; c++)u = this.field.add(this.field.multiply(t, u), this.coefficients[c]);
        return u;
    }, t.prototype.add = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return e;
        if (e.isZero()) return this;
        var r = this.coefficients, n = e.coefficients;
        if (r.length > n.length) {
            var o = r;
            r = n, n = o;
        }
        var i = new Int32Array(n.length), a = n.length - r.length;
        $12c6b0ab9da17bee$var$w.arraycopy(n, 0, i, 0, a);
        for(var u = a; u < n.length; u++)i[u] = this.field.add(r[u - a], n[u]);
        return new t(this.field, i);
    }, t.prototype.subtract = function(t) {
        if (!this.field.equals(t.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        return t.isZero() ? this : this.add(t.negative());
    }, t.prototype.multiply = function(e) {
        return e instanceof t ? this.multiplyOther(e) : this.multiplyScalar(e);
    }, t.prototype.multiplyOther = function(e) {
        if (!this.field.equals(e.field)) throw new $12c6b0ab9da17bee$var$l("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || e.isZero()) return new t(this.field, new Int32Array([
            0
        ]));
        for(var r = this.coefficients, n = r.length, o = e.coefficients, i = o.length, a = new Int32Array(n + i - 1), u = 0; u < n; u++)for(var s = r[u], c = 0; c < i; c++)a[u + c] = this.field.add(a[u + c], this.field.multiply(s, o[c]));
        return new t(this.field, a);
    }, t.prototype.negative = function() {
        for(var e = this.coefficients.length, r = new Int32Array(e), n = 0; n < e; n++)r[n] = this.field.subtract(0, this.coefficients[n]);
        return new t(this.field, r);
    }, t.prototype.multiplyScalar = function(e) {
        if (0 === e) return new t(this.field, new Int32Array([
            0
        ]));
        if (1 === e) return this;
        for(var r = this.coefficients.length, n = new Int32Array(r), o = 0; o < r; o++)n[o] = this.field.multiply(this.coefficients[o], e);
        return new t(this.field, n);
    }, t.prototype.multiplyByMonomial = function(e, r) {
        if (e < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === r) return new t(this.field, new Int32Array([
            0
        ]));
        for(var n = this.coefficients.length, o = new Int32Array(n + e), i = 0; i < n; i++)o[i] = this.field.multiply(this.coefficients[i], r);
        return new t(this.field, o);
    }, t.prototype.toString = function() {
        for(var t = new $12c6b0ab9da17bee$var$k, e = this.getDegree(); e >= 0; e--){
            var r = this.getCoefficient(e);
            0 !== r && (r < 0 ? (t.append(" - "), r = -r) : t.length() > 0 && t.append(" + "), 0 !== e && 1 === r || t.append(r), 0 !== e && (1 === e ? t.append("x") : (t.append("x^"), t.append(e))));
        }
        return t.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$pn = function() {
    function t() {}
    return t.prototype.add = function(t, e) {
        return (t + e) % this.modulus;
    }, t.prototype.subtract = function(t, e) {
        return (this.modulus + t - e) % this.modulus;
    }, t.prototype.exp = function(t) {
        return this.expTable[t];
    }, t.prototype.log = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$l;
        return this.logTable[t];
    }, t.prototype.inverse = function(t) {
        if (0 === t) throw new $12c6b0ab9da17bee$var$ft;
        return this.expTable[this.modulus - this.logTable[t] - 1];
    }, t.prototype.multiply = function(t, e) {
        return 0 === t || 0 === e ? 0 : this.expTable[(this.logTable[t] + this.logTable[e]) % (this.modulus - 1)];
    }, t.prototype.getSize = function() {
        return this.modulus;
    }, t.prototype.equals = function(t) {
        return t === this;
    }, t;
}(), $12c6b0ab9da17bee$var$gn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$yn = function(t) {
    function e(e, r) {
        var n = t.call(this) || this;
        n.modulus = e, n.expTable = new Int32Array(e), n.logTable = new Int32Array(e);
        for(var o = 1, i = 0; i < e; i++)n.expTable[i] = o, o = o * r % e;
        for(i = 0; i < e - 1; i++)n.logTable[n.expTable[i]] = i;
        return n.zero = new $12c6b0ab9da17bee$var$dn(n, new Int32Array([
            0
        ])), n.one = new $12c6b0ab9da17bee$var$dn(n, new Int32Array([
            1
        ])), n;
    }
    return $12c6b0ab9da17bee$var$gn(e, t), e.prototype.getZero = function() {
        return this.zero;
    }, e.prototype.getOne = function() {
        return this.one;
    }, e.prototype.buildMonomial = function(t, e) {
        if (t < 0) throw new $12c6b0ab9da17bee$var$l;
        if (0 === e) return this.zero;
        var r = new Int32Array(t + 1);
        return r[0] = e, new $12c6b0ab9da17bee$var$dn(this, r);
    }, e.PDF417_GF = new e($12c6b0ab9da17bee$var$sn.NUMBER_OF_CODEWORDS, 3), e;
}($12c6b0ab9da17bee$var$pn), $12c6b0ab9da17bee$var$wn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$_n = function() {
    function t() {
        this.field = $12c6b0ab9da17bee$var$yn.PDF417_GF;
    }
    return t.prototype.decode = function(t, e, r) {
        for(var n, o, i = new $12c6b0ab9da17bee$var$dn(this.field, t), a = new Int32Array(e), u = !1, s = e; s > 0; s--){
            var c = i.evaluateAt(this.field.exp(s));
            a[e - s] = c, 0 !== c && (u = !0);
        }
        if (!u) return 0;
        var f = this.field.getOne();
        if (null != r) try {
            for(var h = $12c6b0ab9da17bee$var$wn(r), l = h.next(); !l.done; l = h.next()){
                var d = l.value, p = this.field.exp(t.length - 1 - d), y = new $12c6b0ab9da17bee$var$dn(this.field, new Int32Array([
                    this.field.subtract(0, p),
                    1
                ]));
                f = f.multiply(y);
            }
        } catch (t) {
            n = {
                error: t
            };
        } finally{
            try {
                l && !l.done && (o = h.return) && o.call(h);
            } finally{
                if (n) throw n.error;
            }
        }
        var w = new $12c6b0ab9da17bee$var$dn(this.field, a), _ = this.runEuclideanAlgorithm(this.field.buildMonomial(e, 1), w, e), v = _[0], m = _[1], A = this.findErrorLocations(v), E = this.findErrorMagnitudes(m, v, A);
        for(s = 0; s < A.length; s++){
            var C = t.length - 1 - this.field.log(A[s]);
            if (C < 0) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            t[C] = this.field.subtract(t[C], E[s]);
        }
        return A.length;
    }, t.prototype.runEuclideanAlgorithm = function(t, e, r) {
        if (t.getDegree() < e.getDegree()) {
            var n = t;
            t = e, e = n;
        }
        for(var o = t, i = e, a = this.field.getZero(), u = this.field.getOne(); i.getDegree() >= Math.round(r / 2);){
            var s = o, c = a;
            if (a = u, (o = i).isZero()) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            i = s;
            for(var f = this.field.getZero(), h = o.getCoefficient(o.getDegree()), l = this.field.inverse(h); i.getDegree() >= o.getDegree() && !i.isZero();){
                var d = i.getDegree() - o.getDegree(), p = this.field.multiply(i.getCoefficient(i.getDegree()), l);
                f = f.add(this.field.buildMonomial(d, p)), i = i.subtract(o.multiplyByMonomial(d, p));
            }
            u = f.multiply(a).subtract(c).negative();
        }
        var y = u.getCoefficient(0);
        if (0 === y) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        var w = this.field.inverse(y);
        return [
            u.multiply(w),
            i.multiply(w)
        ];
    }, t.prototype.findErrorLocations = function(t) {
        for(var e = t.getDegree(), r = new Int32Array(e), n = 0, o = 1; o < this.field.getSize() && n < e; o++)0 === t.evaluateAt(o) && (r[n] = this.field.inverse(o), n++);
        if (n !== e) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        return r;
    }, t.prototype.findErrorMagnitudes = function(t, e, r) {
        for(var n = e.getDegree(), o = new Int32Array(n), i = 1; i <= n; i++)o[n - i] = this.field.multiply(i, e.getCoefficient(i));
        var a = new $12c6b0ab9da17bee$var$dn(this.field, o), u = r.length, s = new Int32Array(u);
        for(i = 0; i < u; i++){
            var c = this.field.inverse(r[i]), f = this.field.subtract(0, t.evaluateAt(c)), h = this.field.inverse(a.evaluateAt(c));
            s[i] = this.field.multiply(f, h);
        }
        return s;
    }, t;
}(), $12c6b0ab9da17bee$var$vn = function() {
    function t(e, r, n, o, i) {
        e instanceof t ? this.constructor_2(e) : this.constructor_1(e, r, n, o, i);
    }
    return t.prototype.constructor_1 = function(t, e, r, n, o) {
        var i = null == e || null == r, a = null == n || null == o;
        if (i && a) throw new $12c6b0ab9da17bee$var$U;
        i ? (e = new $12c6b0ab9da17bee$var$At(0, n.getY()), r = new $12c6b0ab9da17bee$var$At(0, o.getY())) : a && (n = new $12c6b0ab9da17bee$var$At(t.getWidth() - 1, e.getY()), o = new $12c6b0ab9da17bee$var$At(t.getWidth() - 1, r.getY())), this.image = t, this.topLeft = e, this.bottomLeft = r, this.topRight = n, this.bottomRight = o, this.minX = Math.trunc(Math.min(e.getX(), r.getX())), this.maxX = Math.trunc(Math.max(n.getX(), o.getX())), this.minY = Math.trunc(Math.min(e.getY(), n.getY())), this.maxY = Math.trunc(Math.max(r.getY(), o.getY()));
    }, t.prototype.constructor_2 = function(t) {
        this.image = t.image, this.topLeft = t.getTopLeft(), this.bottomLeft = t.getBottomLeft(), this.topRight = t.getTopRight(), this.bottomRight = t.getBottomRight(), this.minX = t.getMinX(), this.maxX = t.getMaxX(), this.minY = t.getMinY(), this.maxY = t.getMaxY();
    }, t.merge = function(e, r) {
        return null == e ? r : null == r ? e : new t(e.image, e.topLeft, e.bottomLeft, r.topRight, r.bottomRight);
    }, t.prototype.addMissingRows = function(e, r, n) {
        var o = this.topLeft, i = this.bottomLeft, a = this.topRight, u = this.bottomRight;
        if (e > 0) {
            var s = n ? this.topLeft : this.topRight, c = Math.trunc(s.getY() - e);
            c < 0 && (c = 0);
            var f = new $12c6b0ab9da17bee$var$At(s.getX(), c);
            n ? o = f : a = f;
        }
        if (r > 0) {
            var h = n ? this.bottomLeft : this.bottomRight, l = Math.trunc(h.getY() + r);
            l >= this.image.getHeight() && (l = this.image.getHeight() - 1);
            var d = new $12c6b0ab9da17bee$var$At(h.getX(), l);
            n ? i = d : u = d;
        }
        return new t(this.image, o, i, a, u);
    }, t.prototype.getMinX = function() {
        return this.minX;
    }, t.prototype.getMaxX = function() {
        return this.maxX;
    }, t.prototype.getMinY = function() {
        return this.minY;
    }, t.prototype.getMaxY = function() {
        return this.maxY;
    }, t.prototype.getTopLeft = function() {
        return this.topLeft;
    }, t.prototype.getTopRight = function() {
        return this.topRight;
    }, t.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    }, t.prototype.getBottomRight = function() {
        return this.bottomRight;
    }, t;
}(), $12c6b0ab9da17bee$var$mn = function() {
    function t(t, e, r, n) {
        this.columnCount = t, this.errorCorrectionLevel = n, this.rowCountUpperPart = e, this.rowCountLowerPart = r, this.rowCount = e + r;
    }
    return t.prototype.getColumnCount = function() {
        return this.columnCount;
    }, t.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    }, t.prototype.getRowCount = function() {
        return this.rowCount;
    }, t.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    }, t.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    }, t;
}(), $12c6b0ab9da17bee$var$An = function() {
    function t() {
        this.buffer = "";
    }
    return t.form = function(t, e) {
        var r = -1;
        return t.replace(/%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g, function(t, n, o, i, a, u) {
            if ("%%" === t) return "%";
            if (void 0 !== e[++r]) {
                t = i ? parseInt(i.substr(1)) : void 0;
                var s, c = a ? parseInt(a.substr(1)) : void 0;
                switch(u){
                    case "s":
                        s = e[r];
                        break;
                    case "c":
                        s = e[r][0];
                        break;
                    case "f":
                        s = parseFloat(e[r]).toFixed(t);
                        break;
                    case "p":
                        s = parseFloat(e[r]).toPrecision(t);
                        break;
                    case "e":
                        s = parseFloat(e[r]).toExponential(t);
                        break;
                    case "x":
                        s = parseInt(e[r]).toString(c || 16);
                        break;
                    case "d":
                        s = parseFloat(parseInt(e[r], c || 10).toPrecision(t)).toFixed(0);
                }
                s = "object" == typeof s ? JSON.stringify(s) : (+s).toString(c);
                for(var f = parseInt(o), h = o && o[0] + "" == "0" ? "0" : " "; s.length < f;)s = void 0 !== n ? s + h : h + s;
                return s;
            }
        });
    }, t.prototype.format = function(e) {
        for(var r = [], n = 1; n < arguments.length; n++)r[n - 1] = arguments[n];
        this.buffer += t.form(e, r);
    }, t.prototype.toString = function() {
        return this.buffer;
    }, t;
}(), $12c6b0ab9da17bee$var$En = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Cn = function() {
    function t(t) {
        this.boundingBox = new $12c6b0ab9da17bee$var$vn(t), this.codewords = new Array(t.getMaxY() - t.getMinY() + 1);
    }
    return t.prototype.getCodewordNearby = function(e) {
        var r = this.getCodeword(e);
        if (null != r) return r;
        for(var n = 1; n < t.MAX_NEARBY_DISTANCE; n++){
            var o = this.imageRowToCodewordIndex(e) - n;
            if (o >= 0 && null != (r = this.codewords[o])) return r;
            if ((o = this.imageRowToCodewordIndex(e) + n) < this.codewords.length && null != (r = this.codewords[o])) return r;
        }
        return null;
    }, t.prototype.imageRowToCodewordIndex = function(t) {
        return t - this.boundingBox.getMinY();
    }, t.prototype.setCodeword = function(t, e) {
        this.codewords[this.imageRowToCodewordIndex(t)] = e;
    }, t.prototype.getCodeword = function(t) {
        return this.codewords[this.imageRowToCodewordIndex(t)];
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.getCodewords = function() {
        return this.codewords;
    }, t.prototype.toString = function() {
        var t, e, r = new $12c6b0ab9da17bee$var$An, n = 0;
        try {
            for(var o = $12c6b0ab9da17bee$var$En(this.codewords), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                null != a ? r.format("%3d: %3d|%3d%n", n++, a.getRowNumber(), a.getValue()) : r.format("%3d:    |   %n", n++);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return r.toString();
    }, t.MAX_NEARBY_DISTANCE = 5, t;
}(), $12c6b0ab9da17bee$var$In = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Sn = function(t, e) {
    var r = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r) return t;
    var n, o, i = r.call(t), a = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(n = i.next()).done;)a.push(n.value);
    } catch (t) {
        o = {
            error: t
        };
    } finally{
        try {
            n && !n.done && (r = i.return) && r.call(i);
        } finally{
            if (o) throw o.error;
        }
    }
    return a;
}, $12c6b0ab9da17bee$var$On = function() {
    function t() {
        this.values = new Map;
    }
    return t.prototype.setValue = function(t) {
        t = Math.trunc(t);
        var e = this.values.get(t);
        null == e && (e = 0), e++, this.values.set(t, e);
    }, t.prototype.getValue = function() {
        var t, e, r = -1, n = new Array, o = function(t, e) {
            var o = function() {
                return t;
            }, i = function() {
                return e;
            };
            i() > r ? (r = i(), (n = []).push(o())) : i() === r && n.push(o());
        };
        try {
            for(var i = $12c6b0ab9da17bee$var$In(this.values.entries()), a = i.next(); !a.done; a = i.next()){
                var u = $12c6b0ab9da17bee$var$Sn(a.value, 2);
                o(u[0], u[1]);
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                a && !a.done && (e = i.return) && e.call(i);
            } finally{
                if (t) throw t.error;
            }
        }
        return $12c6b0ab9da17bee$var$sn.toIntArray(n);
    }, t.prototype.getConfidence = function(t) {
        return this.values.get(t);
    }, t;
}(), $12c6b0ab9da17bee$var$Tn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$bn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Rn = function(t) {
    function e(e, r) {
        var n = t.call(this, e) || this;
        return n._isLeft = r, n;
    }
    return $12c6b0ab9da17bee$var$Tn(e, t), e.prototype.setRowNumbers = function() {
        var t, e;
        try {
            for(var r = $12c6b0ab9da17bee$var$bn(this.getCodewords()), n = r.next(); !n.done; n = r.next()){
                var o = n.value;
                null != o && o.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, e.prototype.adjustCompleteIndicatorColumnRowNumbers = function(t) {
        var e = this.getCodewords();
        this.setRowNumbers(), this.removeIncorrectCodewords(e, t);
        for(var r = this.getBoundingBox(), n = this._isLeft ? r.getTopLeft() : r.getTopRight(), o = this._isLeft ? r.getBottomLeft() : r.getBottomRight(), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.imageRowToCodewordIndex(Math.trunc(o.getY())), u = -1, s = 1, c = 0, f = i; f < a; f++)if (null != e[f]) {
            var h = e[f], l = h.getRowNumber() - u;
            if (0 === l) c++;
            else if (1 === l) s = Math.max(s, c), c = 1, u = h.getRowNumber();
            else if (l < 0 || h.getRowNumber() >= t.getRowCount() || l > f) e[f] = null;
            else {
                for(var d = void 0, p = (d = s > 2 ? (s - 2) * l : l) >= f, g = 1; g <= d && !p; g++)p = null != e[f - g];
                p ? e[f] = null : (u = h.getRowNumber(), c = 1);
            }
        }
    }, e.prototype.getRowHeights = function() {
        var t, e, r = this.getBarcodeMetadata();
        if (null == r) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(r);
        var n = new Int32Array(r.getRowCount());
        try {
            for(var o = $12c6b0ab9da17bee$var$bn(this.getCodewords()), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                if (null != a) {
                    var u = a.getRowNumber();
                    if (u >= n.length) continue;
                    n[u]++;
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                i && !i.done && (e = o.return) && e.call(o);
            } finally{
                if (t) throw t.error;
            }
        }
        return n;
    }, e.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(t) {
        for(var e = this.getBoundingBox(), r = this._isLeft ? e.getTopLeft() : e.getTopRight(), n = this._isLeft ? e.getBottomLeft() : e.getBottomRight(), o = this.imageRowToCodewordIndex(Math.trunc(r.getY())), i = this.imageRowToCodewordIndex(Math.trunc(n.getY())), a = this.getCodewords(), u = -1, s = o; s < i; s++)if (null != a[s]) {
            var c = a[s];
            c.setRowNumberAsRowIndicatorColumn();
            var f = c.getRowNumber() - u;
            0 === f || (1 === f ? u = c.getRowNumber() : c.getRowNumber() >= t.getRowCount() ? a[s] = null : u = c.getRowNumber());
        }
    }, e.prototype.getBarcodeMetadata = function() {
        var t, e, r = this.getCodewords(), n = new $12c6b0ab9da17bee$var$On, o = new $12c6b0ab9da17bee$var$On, i = new $12c6b0ab9da17bee$var$On, a = new $12c6b0ab9da17bee$var$On;
        try {
            for(var u = $12c6b0ab9da17bee$var$bn(r), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (null != c) {
                    c.setRowNumberAsRowIndicatorColumn();
                    var f = c.getValue() % 30, h = c.getRowNumber();
                    switch(this._isLeft || (h += 2), h % 3){
                        case 0:
                            o.setValue(3 * f + 1);
                            break;
                        case 1:
                            a.setValue(f / 3), i.setValue(f % 3);
                            break;
                        case 2:
                            n.setValue(f + 1);
                    }
                }
            }
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                s && !s.done && (e = u.return) && e.call(u);
            } finally{
                if (t) throw t.error;
            }
        }
        if (0 === n.getValue().length || 0 === o.getValue().length || 0 === i.getValue().length || 0 === a.getValue().length || n.getValue()[0] < 1 || o.getValue()[0] + i.getValue()[0] < $12c6b0ab9da17bee$var$sn.MIN_ROWS_IN_BARCODE || o.getValue()[0] + i.getValue()[0] > $12c6b0ab9da17bee$var$sn.MAX_ROWS_IN_BARCODE) return null;
        var l = new $12c6b0ab9da17bee$var$mn(n.getValue()[0], o.getValue()[0], i.getValue()[0], a.getValue()[0]);
        return this.removeIncorrectCodewords(r, l), l;
    }, e.prototype.removeIncorrectCodewords = function(t, e) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            if (null != t[r]) {
                var o = n.getValue() % 30, i = n.getRowNumber();
                if (i > e.getRowCount()) t[r] = null;
                else switch(this._isLeft || (i += 2), i % 3){
                    case 0:
                        3 * o + 1 !== e.getRowCountUpperPart() && (t[r] = null);
                        break;
                    case 1:
                        Math.trunc(o / 3) === e.getErrorCorrectionLevel() && o % 3 === e.getRowCountLowerPart() || (t[r] = null);
                        break;
                    case 2:
                        o + 1 !== e.getColumnCount() && (t[r] = null);
                }
            }
        }
    }, e.prototype.isLeft = function() {
        return this._isLeft;
    }, e.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + t.prototype.toString.call(this);
    }, e;
}($12c6b0ab9da17bee$var$Cn), $12c6b0ab9da17bee$var$Nn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Dn = function() {
    function t(t, e) {
        this.ADJUST_ROW_NUMBER_SKIP = 2, this.barcodeMetadata = t, this.barcodeColumnCount = t.getColumnCount(), this.boundingBox = e, this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    return t.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]), this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var t, e = $12c6b0ab9da17bee$var$sn.MAX_CODEWORDS_IN_BARCODE;
        do t = e, e = this.adjustRowNumbersAndGetCount();
        while (e > 0 && e < t);
        return this.detectionResultColumns;
    }, t.prototype.adjustIndicatorColumnRowNumbers = function(t) {
        null != t && t.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    }, t.prototype.adjustRowNumbersAndGetCount = function() {
        var t = this.adjustRowNumbersByRow();
        if (0 === t) return 0;
        for(var e = 1; e < this.barcodeColumnCount + 1; e++)for(var r = this.detectionResultColumns[e].getCodewords(), n = 0; n < r.length; n++)null != r[n] && (r[n].hasValidRowNumber() || this.adjustRowNumbers(e, n, r));
        return t;
    }, t.prototype.adjustRowNumbersByRow = function() {
        return this.adjustRowNumbersFromBothRI(), this.adjustRowNumbersFromLRI() + this.adjustRowNumbersFromRRI();
    }, t.prototype.adjustRowNumbersFromBothRI = function() {
        if (null != this.detectionResultColumns[0] && null != this.detectionResultColumns[this.barcodeColumnCount + 1]) {
            for(var t = this.detectionResultColumns[0].getCodewords(), e = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), r = 0; r < t.length; r++)if (null != t[r] && null != e[r] && t[r].getRowNumber() === e[r].getRowNumber()) for(var n = 1; n <= this.barcodeColumnCount; n++){
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o && (o.setRowNumber(t[r].getRowNumber()), o.hasValidRowNumber() || (this.detectionResultColumns[n].getCodewords()[r] = null));
            }
        }
    }, t.prototype.adjustRowNumbersFromRRI = function() {
        if (null == this.detectionResultColumns[this.barcodeColumnCount + 1]) return 0;
        for(var e = 0, r = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = this.barcodeColumnCount + 1; a > 0 && i < this.ADJUST_ROW_NUMBER_SKIP; a--){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.prototype.adjustRowNumbersFromLRI = function() {
        if (null == this.detectionResultColumns[0]) return 0;
        for(var e = 0, r = this.detectionResultColumns[0].getCodewords(), n = 0; n < r.length; n++)if (null != r[n]) for(var o = r[n].getRowNumber(), i = 0, a = 1; a < this.barcodeColumnCount + 1 && i < this.ADJUST_ROW_NUMBER_SKIP; a++){
            var u = this.detectionResultColumns[a].getCodewords()[n];
            null != u && (i = t.adjustRowNumberIfValid(o, i, u), u.hasValidRowNumber() || e++);
        }
        return e;
    }, t.adjustRowNumberIfValid = function(t, e, r) {
        return null == r || r.hasValidRowNumber() || (r.isValidRowNumber(t) ? (r.setRowNumber(t), e = 0) : ++e), e;
    }, t.prototype.adjustRowNumbers = function(e, r, n) {
        var o, i, a = n[r], u = this.detectionResultColumns[e - 1].getCodewords(), s = u;
        null != this.detectionResultColumns[e + 1] && (s = this.detectionResultColumns[e + 1].getCodewords());
        var c = new Array(14);
        c[2] = u[r], c[3] = s[r], r > 0 && (c[0] = n[r - 1], c[4] = u[r - 1], c[5] = s[r - 1]), r > 1 && (c[8] = n[r - 2], c[10] = u[r - 2], c[11] = s[r - 2]), r < n.length - 1 && (c[1] = n[r + 1], c[6] = u[r + 1], c[7] = s[r + 1]), r < n.length - 2 && (c[9] = n[r + 2], c[12] = u[r + 2], c[13] = s[r + 2]);
        try {
            for(var f = $12c6b0ab9da17bee$var$Nn(c), h = f.next(); !h.done; h = f.next()){
                var l = h.value;
                if (t.adjustRowNumber(a, l)) return;
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                h && !h.done && (i = f.return) && i.call(f);
            } finally{
                if (o) throw o.error;
            }
        }
    }, t.adjustRowNumber = function(t, e) {
        return null != e && !(!e.hasValidRowNumber() || e.getBucket() !== t.getBucket()) && (t.setRowNumber(e.getRowNumber()), !0);
    }, t.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    }, t.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    }, t.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    }, t.prototype.setBoundingBox = function(t) {
        this.boundingBox = t;
    }, t.prototype.getBoundingBox = function() {
        return this.boundingBox;
    }, t.prototype.setDetectionResultColumn = function(t, e) {
        this.detectionResultColumns[t] = e;
    }, t.prototype.getDetectionResultColumn = function(t) {
        return this.detectionResultColumns[t];
    }, t.prototype.toString = function() {
        var t = this.detectionResultColumns[0];
        null == t && (t = this.detectionResultColumns[this.barcodeColumnCount + 1]);
        for(var e = new $12c6b0ab9da17bee$var$An, r = 0; r < t.getCodewords().length; r++){
            e.format("CW %3d:", r);
            for(var n = 0; n < this.barcodeColumnCount + 2; n++)if (null != this.detectionResultColumns[n]) {
                var o = this.detectionResultColumns[n].getCodewords()[r];
                null != o ? e.format(" %3d|%3d", o.getRowNumber(), o.getValue()) : e.format("    |   ");
            } else e.format("    |   ");
            e.format("%n");
        }
        return e.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$Pn = function() {
    function t(e, r, n, o) {
        this.rowNumber = t.BARCODE_ROW_UNKNOWN, this.startX = Math.trunc(e), this.endX = Math.trunc(r), this.bucket = Math.trunc(n), this.value = Math.trunc(o);
    }
    return t.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    }, t.prototype.isValidRowNumber = function(e) {
        return e !== t.BARCODE_ROW_UNKNOWN && this.bucket === e % 3 * 3;
    }, t.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(3 * Math.trunc(this.value / 30) + Math.trunc(this.bucket / 3));
    }, t.prototype.getWidth = function() {
        return this.endX - this.startX;
    }, t.prototype.getStartX = function() {
        return this.startX;
    }, t.prototype.getEndX = function() {
        return this.endX;
    }, t.prototype.getBucket = function() {
        return this.bucket;
    }, t.prototype.getValue = function() {
        return this.value;
    }, t.prototype.getRowNumber = function() {
        return this.rowNumber;
    }, t.prototype.setRowNumber = function(t) {
        this.rowNumber = t;
    }, t.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    }, t.BARCODE_ROW_UNKNOWN = -1, t;
}(), $12c6b0ab9da17bee$var$Mn = function() {
    function t() {}
    return t.initialize = function() {
        for(var e = 0; e < $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE.length; e++)for(var r = $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE[e], n = 1 & r, o = 0; o < $12c6b0ab9da17bee$var$sn.BARS_IN_MODULE; o++){
            for(var i = 0; (1 & r) === n;)i += 1, r >>= 1;
            n = 1 & r, t.RATIOS_TABLE[e] || (t.RATIOS_TABLE[e] = new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE)), t.RATIOS_TABLE[e][$12c6b0ab9da17bee$var$sn.BARS_IN_MODULE - o - 1] = Math.fround(i / $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD);
        }
        this.bSymbolTableReady = !0;
    }, t.getDecodedValue = function(e) {
        var r = t.getDecodedCodewordValue(t.sampleBitCounts(e));
        return -1 !== r ? r : t.getClosestDecodedValue(e);
    }, t.sampleBitCounts = function(t) {
        for(var e = $12c6b0ab9da17bee$var$vt.sum(t), r = new Int32Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE), n = 0, o = 0, i = 0; i < $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD; i++){
            var a = e / (2 * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD) + i * e / $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD;
            o + t[n] <= a && (o += t[n], n++), r[n]++;
        }
        return r;
    }, t.getDecodedCodewordValue = function(e) {
        var r = t.getBitValue(e);
        return -1 === $12c6b0ab9da17bee$var$sn.getCodeword(r) ? -1 : r;
    }, t.getBitValue = function(t) {
        for(var e = 0, r = 0; r < t.length; r++)for(var n = 0; n < t[r]; n++)e = e << 1 | (r % 2 == 0 ? 1 : 0);
        return Math.trunc(e);
    }, t.getClosestDecodedValue = function(e) {
        var r = $12c6b0ab9da17bee$var$vt.sum(e), n = new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE);
        if (r > 1) for(var o = 0; o < n.length; o++)n[o] = Math.fround(e[o] / r);
        var i = $12c6b0ab9da17bee$var$mt.MAX_VALUE, a = -1;
        this.bSymbolTableReady || t.initialize();
        for(var u = 0; u < t.RATIOS_TABLE.length; u++){
            for(var s = 0, c = t.RATIOS_TABLE[u], f = 0; f < $12c6b0ab9da17bee$var$sn.BARS_IN_MODULE; f++){
                var h = Math.fround(c[f] - n[f]);
                if ((s += Math.fround(h * h)) >= i) break;
            }
            s < i && (i = s, a = $12c6b0ab9da17bee$var$sn.SYMBOL_TABLE[u]);
        }
        return a;
    }, t.bSymbolTableReady = !1, t.RATIOS_TABLE = new Array($12c6b0ab9da17bee$var$sn.SYMBOL_TABLE.length).map(function(t) {
        return new Array($12c6b0ab9da17bee$var$sn.BARS_IN_MODULE);
    }), t;
}(), $12c6b0ab9da17bee$var$Bn = function() {
    function t() {
        this.segmentCount = -1, this.fileSize = -1, this.timestamp = -1, this.checksum = -1;
    }
    return t.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    }, t.prototype.setSegmentIndex = function(t) {
        this.segmentIndex = t;
    }, t.prototype.getFileId = function() {
        return this.fileId;
    }, t.prototype.setFileId = function(t) {
        this.fileId = t;
    }, t.prototype.getOptionalData = function() {
        return this.optionalData;
    }, t.prototype.setOptionalData = function(t) {
        this.optionalData = t;
    }, t.prototype.isLastSegment = function() {
        return this.lastSegment;
    }, t.prototype.setLastSegment = function(t) {
        this.lastSegment = t;
    }, t.prototype.getSegmentCount = function() {
        return this.segmentCount;
    }, t.prototype.setSegmentCount = function(t) {
        this.segmentCount = t;
    }, t.prototype.getSender = function() {
        return this.sender || null;
    }, t.prototype.setSender = function(t) {
        this.sender = t;
    }, t.prototype.getAddressee = function() {
        return this.addressee || null;
    }, t.prototype.setAddressee = function(t) {
        this.addressee = t;
    }, t.prototype.getFileName = function() {
        return this.fileName;
    }, t.prototype.setFileName = function(t) {
        this.fileName = t;
    }, t.prototype.getFileSize = function() {
        return this.fileSize;
    }, t.prototype.setFileSize = function(t) {
        this.fileSize = t;
    }, t.prototype.getChecksum = function() {
        return this.checksum;
    }, t.prototype.setChecksum = function(t) {
        this.checksum = t;
    }, t.prototype.getTimestamp = function() {
        return this.timestamp;
    }, t.prototype.setTimestamp = function(t) {
        this.timestamp = t;
    }, t;
}(), $12c6b0ab9da17bee$var$Ln = function() {
    function t() {}
    return t.parseLong = function(t, e) {
        return void 0 === e && (e = void 0), parseInt(t, e);
    }, t;
}(), $12c6b0ab9da17bee$var$Fn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$kn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Fn(e, t), e.kind = "NullPointerException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$xn = function() {
    function t() {}
    return t.prototype.writeBytes = function(t) {
        this.writeBytesOffset(t, 0, t.length);
    }, t.prototype.writeBytesOffset = function(t, e, r) {
        if (null == t) throw new $12c6b0ab9da17bee$var$kn;
        if (e < 0 || e > t.length || r < 0 || e + r > t.length || e + r < 0) throw new $12c6b0ab9da17bee$var$v;
        if (0 !== r) for(var n = 0; n < r; n++)this.write(t[e + n]);
    }, t.prototype.flush = function() {}, t.prototype.close = function() {}, t;
}(), $12c6b0ab9da17bee$var$Vn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Un = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$Vn(e, t), e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$Hn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Gn = function(t) {
    function e(e) {
        void 0 === e && (e = 32);
        var r = t.call(this) || this;
        if (r.count = 0, e < 0) throw new $12c6b0ab9da17bee$var$l("Negative initial size: " + e);
        return r.buf = new Uint8Array(e), r;
    }
    return $12c6b0ab9da17bee$var$Hn(e, t), e.prototype.ensureCapacity = function(t) {
        t - this.buf.length > 0 && this.grow(t);
    }, e.prototype.grow = function(t) {
        var e = this.buf.length << 1;
        if (e - t < 0 && (e = t), e < 0) {
            if (t < 0) throw new $12c6b0ab9da17bee$var$Un;
            e = $12c6b0ab9da17bee$var$I.MAX_VALUE;
        }
        this.buf = $12c6b0ab9da17bee$var$C.copyOfUint8Array(this.buf, e);
    }, e.prototype.write = function(t) {
        this.ensureCapacity(this.count + 1), this.buf[this.count] = t, this.count += 1;
    }, e.prototype.writeBytesOffset = function(t, e, r) {
        if (e < 0 || e > t.length || r < 0 || e + r - t.length > 0) throw new $12c6b0ab9da17bee$var$v;
        this.ensureCapacity(this.count + r), $12c6b0ab9da17bee$var$w.arraycopy(t, e, this.buf, this.count, r), this.count += r;
    }, e.prototype.writeTo = function(t) {
        t.writeBytesOffset(this.buf, 0, this.count);
    }, e.prototype.reset = function() {
        this.count = 0;
    }, e.prototype.toByteArray = function() {
        return $12c6b0ab9da17bee$var$C.copyOfUint8Array(this.buf, this.count);
    }, e.prototype.size = function() {
        return this.count;
    }, e.prototype.toString = function(t) {
        return t ? "string" == typeof t ? this.toString_string(t) : this.toString_number(t) : this.toString_void();
    }, e.prototype.toString_void = function() {
        return new String(this.buf).toString();
    }, e.prototype.toString_string = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.toString_number = function(t) {
        return new String(this.buf).toString();
    }, e.prototype.close = function() {}, e;
}($12c6b0ab9da17bee$var$xn);
function $12c6b0ab9da17bee$var$Xn() {
    if ("undefined" != typeof window) return window.BigInt || null;
    if ("undefined" != typeof $parcel$global) return $parcel$global.BigInt || null;
    if ("undefined" != typeof self) return self.BigInt || null;
    throw new Error("Can't search globals for BigInt!");
}
function $12c6b0ab9da17bee$var$Wn(t) {
    if (void 0 === $12c6b0ab9da17bee$var$Xr && ($12c6b0ab9da17bee$var$Xr = $12c6b0ab9da17bee$var$Xn()), null === $12c6b0ab9da17bee$var$Xr) throw new Error("BigInt is not supported!");
    return $12c6b0ab9da17bee$var$Xr(t);
}
!function(t) {
    t[t.ALPHA = 0] = "ALPHA", t[t.LOWER = 1] = "LOWER", t[t.MIXED = 2] = "MIXED", t[t.PUNCT = 3] = "PUNCT", t[t.ALPHA_SHIFT = 4] = "ALPHA_SHIFT", t[t.PUNCT_SHIFT = 5] = "PUNCT_SHIFT";
}($12c6b0ab9da17bee$var$Gr || ($12c6b0ab9da17bee$var$Gr = {}));
var $12c6b0ab9da17bee$var$jn = function() {
    function t() {}
    return t.decode = function(e, r) {
        var n = new $12c6b0ab9da17bee$var$k(""), o = $12c6b0ab9da17bee$var$P.ISO8859_1;
        n.enableDecoding(o);
        for(var i = 1, a = e[i++], u = new $12c6b0ab9da17bee$var$Bn; i < e[0];){
            switch(a){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    i = t.textCompaction(e, i, n);
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                    i = t.byteCompaction(a, e, o, i, n);
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    n.append(e[i++]);
                    break;
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                    i = t.numericCompaction(e, i, n);
                    break;
                case t.ECI_CHARSET:
                    $12c6b0ab9da17bee$var$P.getCharacterSetECIByValue(e[i++]);
                    break;
                case t.ECI_GENERAL_PURPOSE:
                    i += 2;
                    break;
                case t.ECI_USER_DEFINED:
                    i++;
                    break;
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    i = t.decodeMacroBlock(e, i, u);
                    break;
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    throw new $12c6b0ab9da17bee$var$R;
                default:
                    i--, i = t.textCompaction(e, i, n);
            }
            if (!(i < e.length)) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
            a = e[i++];
        }
        if (0 === n.length()) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var s = new $12c6b0ab9da17bee$var$at(null, n.toString(), null, r);
        return s.setOther(u), s;
    }, t.decodeMacroBlock = function(e, r, n) {
        if (r + t.NUMBER_OF_SEQUENCE_CODEWORDS > e[0]) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        for(var o = new Int32Array(t.NUMBER_OF_SEQUENCE_CODEWORDS), i = 0; i < t.NUMBER_OF_SEQUENCE_CODEWORDS; i++, r++)o[i] = e[r];
        n.setSegmentIndex($12c6b0ab9da17bee$var$I.parseInt(t.decodeBase900toBase10(o, t.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var a = new $12c6b0ab9da17bee$var$k;
        r = t.textCompaction(e, r, a), n.setFileId(a.toString());
        var u = -1;
        for(e[r] === t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD && (u = r + 1); r < e[0];)switch(e[r]){
            case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                switch(e[++r]){
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var s = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, s), n.setFileName(s.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var c = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, c), n.setSender(c.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var f = new $12c6b0ab9da17bee$var$k;
                        r = t.textCompaction(e, r + 1, f), n.setAddressee(f.toString());
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var h = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, h), n.setSegmentCount($12c6b0ab9da17bee$var$I.parseInt(h.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var l = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, l), n.setTimestamp($12c6b0ab9da17bee$var$Ln.parseLong(l.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var d = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, d), n.setChecksum($12c6b0ab9da17bee$var$I.parseInt(d.toString()));
                        break;
                    case t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var p = new $12c6b0ab9da17bee$var$k;
                        r = t.numericCompaction(e, r + 1, p), n.setFileSize($12c6b0ab9da17bee$var$Ln.parseLong(p.toString()));
                        break;
                    default:
                        throw $12c6b0ab9da17bee$var$R.getFormatInstance();
                }
                break;
            case t.MACRO_PDF417_TERMINATOR:
                r++, n.setLastSegment(!0);
                break;
            default:
                throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        }
        if (-1 !== u) {
            var g = r - u;
            n.isLastSegment() && g--, n.setOptionalData($12c6b0ab9da17bee$var$C.copyOfRange(e, u, u + g));
        }
        return r;
    }, t.textCompaction = function(e, r, n) {
        for(var o = new Int32Array(2 * (e[0] - r)), i = new Int32Array(2 * (e[0] - r)), a = 0, u = !1; r < e[0] && !u;){
            var s = e[r++];
            if (s < t.TEXT_COMPACTION_MODE_LATCH) o[a] = s / 30, o[a + 1] = s % 30, a += 2;
            else switch(s){
                case t.TEXT_COMPACTION_MODE_LATCH:
                    o[a++] = t.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.NUMERIC_COMPACTION_MODE_LATCH:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, u = !0;
                    break;
                case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    o[a] = t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE, s = e[r++], i[a] = s, a++;
            }
        }
        return t.decodeTextCompaction(o, i, a, n), r;
    }, t.decodeTextCompaction = function(e, r, n, o) {
        for(var i = $12c6b0ab9da17bee$var$Gr.ALPHA, a = $12c6b0ab9da17bee$var$Gr.ALPHA, u = 0; u < n;){
            var s = e[u], c = "";
            switch(i){
                case $12c6b0ab9da17bee$var$Gr.ALPHA:
                    if (s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $12c6b0ab9da17bee$var$Gr.LOWER;
                            break;
                        case t.ML:
                            i = $12c6b0ab9da17bee$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.LOWER:
                    if (s < 26) c = String.fromCharCode(97 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.AS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.ALPHA_SHIFT;
                            break;
                        case t.ML:
                            i = $12c6b0ab9da17bee$var$Gr.MIXED;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.MIXED:
                    if (s < t.PL) c = t.MIXED_CHARS[s];
                    else switch(s){
                        case t.PL:
                            i = $12c6b0ab9da17bee$var$Gr.PUNCT;
                            break;
                        case 26:
                            c = " ";
                            break;
                        case t.LL:
                            i = $12c6b0ab9da17bee$var$Gr.LOWER;
                            break;
                        case t.AL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.PS:
                            a = i, i = $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.PUNCT:
                    if (s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.ALPHA_SHIFT:
                    if (i = a, s < 26) c = String.fromCharCode(65 + s);
                    else switch(s){
                        case 26:
                            c = " ";
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
                    break;
                case $12c6b0ab9da17bee$var$Gr.PUNCT_SHIFT:
                    if (i = a, s < t.PAL) c = t.PUNCT_CHARS[s];
                    else switch(s){
                        case t.PAL:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                            break;
                        case t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            o.append(r[u]);
                            break;
                        case t.TEXT_COMPACTION_MODE_LATCH:
                            i = $12c6b0ab9da17bee$var$Gr.ALPHA;
                    }
            }
            "" !== c && o.append(c), u++;
        }
    }, t.byteCompaction = function(e, r, n, o, i) {
        var a = new $12c6b0ab9da17bee$var$Gn, u = 0, s = 0, c = !1;
        switch(e){
            case t.BYTE_COMPACTION_MODE_LATCH:
                for(var f = new Int32Array(6), h = r[o++]; o < r[0] && !c;)switch(f[u++] = h, s = 900 * s + h, h = r[o++]){
                    case t.TEXT_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH:
                    case t.NUMERIC_COMPACTION_MODE_LATCH:
                    case t.BYTE_COMPACTION_MODE_LATCH_6:
                    case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                    case t.MACRO_PDF417_TERMINATOR:
                        o--, c = !0;
                        break;
                    default:
                        if (u % 5 == 0 && u > 0) {
                            for(var l = 0; l < 6; ++l)a.write(Number($12c6b0ab9da17bee$var$Wn(s) >> $12c6b0ab9da17bee$var$Wn(8 * (5 - l))));
                            s = 0, u = 0;
                        }
                }
                o === r[0] && h < t.TEXT_COMPACTION_MODE_LATCH && (f[u++] = h);
                for(var d = 0; d < u; d++)a.write(f[d]);
                break;
            case t.BYTE_COMPACTION_MODE_LATCH_6:
                for(; o < r[0] && !c;){
                    var p = r[o++];
                    if (p < t.TEXT_COMPACTION_MODE_LATCH) u++, s = 900 * s + p;
                    else switch(p){
                        case t.TEXT_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH:
                        case t.NUMERIC_COMPACTION_MODE_LATCH:
                        case t.BYTE_COMPACTION_MODE_LATCH_6:
                        case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case t.MACRO_PDF417_TERMINATOR:
                            o--, c = !0;
                    }
                    if (u % 5 == 0 && u > 0) {
                        for(l = 0; l < 6; ++l)a.write(Number($12c6b0ab9da17bee$var$Wn(s) >> $12c6b0ab9da17bee$var$Wn(8 * (5 - l))));
                        s = 0, u = 0;
                    }
                }
        }
        return i.append($12c6b0ab9da17bee$var$L.decode(a.toByteArray(), n)), o;
    }, t.numericCompaction = function(e, r, n) {
        for(var o = 0, i = !1, a = new Int32Array(t.MAX_NUMERIC_CODEWORDS); r < e[0] && !i;){
            var u = e[r++];
            if (r === e[0] && (i = !0), u < t.TEXT_COMPACTION_MODE_LATCH) a[o] = u, o++;
            else switch(u){
                case t.TEXT_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH:
                case t.BYTE_COMPACTION_MODE_LATCH_6:
                case t.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case t.MACRO_PDF417_TERMINATOR:
                    r--, i = !0;
            }
            (o % t.MAX_NUMERIC_CODEWORDS == 0 || u === t.NUMERIC_COMPACTION_MODE_LATCH || i) && o > 0 && (n.append(t.decodeBase900toBase10(a, o)), o = 0);
        }
        return r;
    }, t.decodeBase900toBase10 = function(e, r) {
        for(var n = $12c6b0ab9da17bee$var$Wn(0), o = 0; o < r; o++)n += t.EXP900[r - o - 1] * $12c6b0ab9da17bee$var$Wn(e[o]);
        var i = n.toString();
        if ("1" !== i.charAt(0)) throw new $12c6b0ab9da17bee$var$R;
        return i.substring(1);
    }, t.TEXT_COMPACTION_MODE_LATCH = 900, t.BYTE_COMPACTION_MODE_LATCH = 901, t.NUMERIC_COMPACTION_MODE_LATCH = 902, t.BYTE_COMPACTION_MODE_LATCH_6 = 924, t.ECI_USER_DEFINED = 925, t.ECI_GENERAL_PURPOSE = 926, t.ECI_CHARSET = 927, t.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928, t.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923, t.MACRO_PDF417_TERMINATOR = 922, t.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913, t.MAX_NUMERIC_CODEWORDS = 15, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0, t.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1, t.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2, t.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3, t.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4, t.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5, t.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6, t.PL = 25, t.LL = 27, t.AS = 27, t.ML = 28, t.AL = 28, t.PS = 29, t.PAL = 29, t.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'", t.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^", t.EXP900 = $12c6b0ab9da17bee$var$Xn() ? function() {
        var t = [];
        t[0] = $12c6b0ab9da17bee$var$Wn(1);
        var e = $12c6b0ab9da17bee$var$Wn(900);
        t[1] = e;
        for(var r = 2; r < 16; r++)t[r] = t[r - 1] * e;
        return t;
    }() : [], t.NUMBER_OF_SEQUENCE_CODEWORDS = 2, t;
}(), $12c6b0ab9da17bee$var$zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Yn = function() {
    function t() {}
    return t.decode = function(e, r, n, o, i, a, u) {
        for(var s, c = new $12c6b0ab9da17bee$var$vn(e, r, n, o, i), f = null, h = null, l = !0;; l = !1){
            if (null != r && (f = t.getRowIndicatorColumn(e, c, r, !0, a, u)), null != o && (h = t.getRowIndicatorColumn(e, c, o, !1, a, u)), null == (s = t.merge(f, h))) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            var d = s.getBoundingBox();
            if (!l || null == d || !(d.getMinY() < c.getMinY() || d.getMaxY() > c.getMaxY())) break;
            c = d;
        }
        s.setBoundingBox(c);
        var p = s.getBarcodeColumnCount() + 1;
        s.setDetectionResultColumn(0, f), s.setDetectionResultColumn(p, h);
        for(var g = null != f, y = 1; y <= p; y++){
            var w = g ? y : p - y;
            if (void 0 === s.getDetectionResultColumn(w)) {
                var _ = void 0;
                _ = 0 === w || w === p ? new $12c6b0ab9da17bee$var$Rn(c, 0 === w) : new $12c6b0ab9da17bee$var$Cn(c), s.setDetectionResultColumn(w, _);
                for(var v = -1, m = v, A = c.getMinY(); A <= c.getMaxY(); A++){
                    if ((v = t.getStartColumn(s, w, A, g)) < 0 || v > c.getMaxX()) {
                        if (-1 === m) continue;
                        v = m;
                    }
                    var E = t.detectCodeword(e, c.getMinX(), c.getMaxX(), g, v, A, a, u);
                    null != E && (_.setCodeword(A, E), m = v, a = Math.min(a, E.getWidth()), u = Math.max(u, E.getWidth()));
                }
            }
        }
        return t.createDecoderResult(s);
    }, t.merge = function(e, r) {
        if (null == e && null == r) return null;
        var n = t.getBarcodeMetadata(e, r);
        if (null == n) return null;
        var o = $12c6b0ab9da17bee$var$vn.merge(t.adjustBoundingBox(e), t.adjustBoundingBox(r));
        return new $12c6b0ab9da17bee$var$Dn(n, o);
    }, t.adjustBoundingBox = function(e) {
        var r, n;
        if (null == e) return null;
        var o = e.getRowHeights();
        if (null == o) return null;
        var i = t.getMax(o), a = 0;
        try {
            for(var u = $12c6b0ab9da17bee$var$zn(o), s = u.next(); !s.done; s = u.next()){
                var c = s.value;
                if (a += i - c, c > 0) break;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                s && !s.done && (n = u.return) && n.call(u);
            } finally{
                if (r) throw r.error;
            }
        }
        for(var f = e.getCodewords(), h = 0; a > 0 && null == f[h]; h++)a--;
        var l = 0;
        for(h = o.length - 1; h >= 0 && (l += i - o[h], !(o[h] > 0)); h--);
        for(h = f.length - 1; l > 0 && null == f[h]; h--)l--;
        return e.getBoundingBox().addMissingRows(a, l, e.isLeft());
    }, t.getMax = function(t) {
        var e, r, n = -1;
        try {
            for(var o = $12c6b0ab9da17bee$var$zn(t), i = o.next(); !i.done; i = o.next()){
                var a = i.value;
                n = Math.max(n, a);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                i && !i.done && (r = o.return) && r.call(o);
            } finally{
                if (e) throw e.error;
            }
        }
        return n;
    }, t.getBarcodeMetadata = function(t, e) {
        var r, n;
        return null == t || null == (r = t.getBarcodeMetadata()) ? null == e ? null : e.getBarcodeMetadata() : null == e || null == (n = e.getBarcodeMetadata()) ? r : r.getColumnCount() !== n.getColumnCount() && r.getErrorCorrectionLevel() !== n.getErrorCorrectionLevel() && r.getRowCount() !== n.getRowCount() ? null : r;
    }, t.getRowIndicatorColumn = function(e, r, n, o, i, a) {
        for(var u = new $12c6b0ab9da17bee$var$Rn(r, o), s = 0; s < 2; s++)for(var c = 0 === s ? 1 : -1, f = Math.trunc(Math.trunc(n.getX())), h = Math.trunc(Math.trunc(n.getY())); h <= r.getMaxY() && h >= r.getMinY(); h += c){
            var l = t.detectCodeword(e, 0, e.getWidth(), o, f, h, i, a);
            null != l && (u.setCodeword(h, l), f = o ? l.getStartX() : l.getEndX());
        }
        return u;
    }, t.adjustCodewordCount = function(e, r) {
        var n = r[0][1], o = n.getValue(), i = e.getBarcodeColumnCount() * e.getBarcodeRowCount() - t.getNumberOfECCodeWords(e.getBarcodeECLevel());
        if (0 === o.length) {
            if (i < 1 || i > $12c6b0ab9da17bee$var$sn.MAX_CODEWORDS_IN_BARCODE) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            n.setValue(i);
        } else o[0] !== i && n.setValue(i);
    }, t.createDecoderResult = function(e) {
        var r = t.createBarcodeMatrix(e);
        t.adjustCodewordCount(e, r);
        for(var n = new Array, o = new Int32Array(e.getBarcodeRowCount() * e.getBarcodeColumnCount()), i = [], a = new Array, u = 0; u < e.getBarcodeRowCount(); u++)for(var s = 0; s < e.getBarcodeColumnCount(); s++){
            var c = r[u][s + 1].getValue(), f = u * e.getBarcodeColumnCount() + s;
            0 === c.length ? n.push(f) : 1 === c.length ? o[f] = c[0] : (a.push(f), i.push(c));
        }
        for(var h = new Array(i.length), l = 0; l < h.length; l++)h[l] = i[l];
        return t.createDecoderResultFromAmbiguousValues(e.getBarcodeECLevel(), o, $12c6b0ab9da17bee$var$sn.toIntArray(n), $12c6b0ab9da17bee$var$sn.toIntArray(a), h);
    }, t.createDecoderResultFromAmbiguousValues = function(e, r, n, o, i) {
        for(var a = new Int32Array(o.length), u = 100; u-- > 0;){
            for(var s = 0; s < a.length; s++)r[o[s]] = i[s][a[s]];
            try {
                return t.decodeCodewords(r, e, n);
            } catch (t) {
                if (!(t instanceof $12c6b0ab9da17bee$var$g)) throw t;
            }
            if (0 === a.length) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            for(s = 0; s < a.length; s++){
                if (a[s] < i[s].length - 1) {
                    a[s]++;
                    break;
                }
                if (a[s] = 0, s === a.length - 1) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
            }
        }
        throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
    }, t.createBarcodeMatrix = function(t) {
        for(var e, r, n, o, i = Array.from({
            length: t.getBarcodeRowCount()
        }, function() {
            return new Array(t.getBarcodeColumnCount() + 2);
        }), a = 0; a < i.length; a++)for(var u = 0; u < i[a].length; u++)i[a][u] = new $12c6b0ab9da17bee$var$On;
        var s = 0;
        try {
            for(var c = $12c6b0ab9da17bee$var$zn(t.getDetectionResultColumns()), f = c.next(); !f.done; f = c.next()){
                var h = f.value;
                if (null != h) try {
                    for(var l = (n = void 0, $12c6b0ab9da17bee$var$zn(h.getCodewords())), d = l.next(); !d.done; d = l.next()){
                        var p = d.value;
                        if (null != p) {
                            var g = p.getRowNumber();
                            if (g >= 0) {
                                if (g >= i.length) continue;
                                i[g][s].setValue(p.getValue());
                            }
                        }
                    }
                } catch (t) {
                    n = {
                        error: t
                    };
                } finally{
                    try {
                        d && !d.done && (o = l.return) && o.call(l);
                    } finally{
                        if (n) throw n.error;
                    }
                }
                s++;
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                f && !f.done && (r = c.return) && r.call(c);
            } finally{
                if (e) throw e.error;
            }
        }
        return i;
    }, t.isValidBarcodeColumn = function(t, e) {
        return e >= 0 && e <= t.getBarcodeColumnCount() + 1;
    }, t.getStartColumn = function(e, r, n, o) {
        var i, a, u = o ? 1 : -1, s = null;
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodeword(n)), null != s) return o ? s.getEndX() : s.getStartX();
        if (null != (s = e.getDetectionResultColumn(r).getCodewordNearby(n))) return o ? s.getStartX() : s.getEndX();
        if (t.isValidBarcodeColumn(e, r - u) && (s = e.getDetectionResultColumn(r - u).getCodewordNearby(n)), null != s) return o ? s.getEndX() : s.getStartX();
        for(var c = 0; t.isValidBarcodeColumn(e, r - u);){
            r -= u;
            try {
                for(var f = (i = void 0, $12c6b0ab9da17bee$var$zn(e.getDetectionResultColumn(r).getCodewords())), h = f.next(); !h.done; h = f.next()){
                    var l = h.value;
                    if (null != l) return (o ? l.getEndX() : l.getStartX()) + u * c * (l.getEndX() - l.getStartX());
                }
            } catch (t) {
                i = {
                    error: t
                };
            } finally{
                try {
                    h && !h.done && (a = f.return) && a.call(f);
                } finally{
                    if (i) throw i.error;
                }
            }
            c++;
        }
        return o ? e.getBoundingBox().getMinX() : e.getBoundingBox().getMaxX();
    }, t.detectCodeword = function(e, r, n, o, i, a, u, s) {
        i = t.adjustCodewordStartColumn(e, r, n, o, i, a);
        var c, f = t.getModuleBitCount(e, r, n, o, i, a);
        if (null == f) return null;
        var h = $12c6b0ab9da17bee$var$vt.sum(f);
        if (o) c = i + h;
        else {
            for(var l = 0; l < f.length / 2; l++){
                var d = f[l];
                f[l] = f[f.length - 1 - l], f[f.length - 1 - l] = d;
            }
            i = (c = i) - h;
        }
        if (!t.checkCodewordSkew(h, u, s)) return null;
        var p = $12c6b0ab9da17bee$var$Mn.getDecodedValue(f), g = $12c6b0ab9da17bee$var$sn.getCodeword(p);
        return -1 === g ? null : new $12c6b0ab9da17bee$var$Pn(i, c, t.getCodewordBucketNumber(p), g);
    }, t.getModuleBitCount = function(t, e, r, n, o, i) {
        for(var a = o, u = new Int32Array(8), s = 0, c = n ? 1 : -1, f = n; (n ? a < r : a >= e) && s < u.length;)t.get(a, i) === f ? (u[s]++, a += c) : (s++, f = !f);
        return s === u.length || a === (n ? r : e) && s === u.length - 1 ? u : null;
    }, t.getNumberOfECCodeWords = function(t) {
        return 2 << t;
    }, t.adjustCodewordStartColumn = function(e, r, n, o, i, a) {
        for(var u = i, s = o ? -1 : 1, c = 0; c < 2; c++){
            for(; (o ? u >= r : u < n) && o === e.get(u, a);){
                if (Math.abs(i - u) > t.CODEWORD_SKEW_SIZE) return i;
                u += s;
            }
            s = -s, o = !o;
        }
        return u;
    }, t.checkCodewordSkew = function(e, r, n) {
        return r - t.CODEWORD_SKEW_SIZE <= e && e <= n + t.CODEWORD_SKEW_SIZE;
    }, t.decodeCodewords = function(e, r, n) {
        if (0 === e.length) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var o = 1 << r + 1, i = t.correctErrors(e, n, o);
        t.verifyCodewordCount(e, o);
        var a = $12c6b0ab9da17bee$var$jn.decode(e, "" + r);
        return a.setErrorsCorrected(i), a.setErasures(n.length), a;
    }, t.correctErrors = function(e, r, n) {
        if (null != r && r.length > n / 2 + t.MAX_ERRORS || n < 0 || n > t.MAX_EC_CODEWORDS) throw $12c6b0ab9da17bee$var$g.getChecksumInstance();
        return t.errorCorrection.decode(e, n, r);
    }, t.verifyCodewordCount = function(t, e) {
        if (t.length < 4) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        var r = t[0];
        if (r > t.length) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
        if (0 === r) {
            if (!(e < t.length)) throw $12c6b0ab9da17bee$var$R.getFormatInstance();
            t[0] = t.length - e;
        }
    }, t.getBitCountForCodeword = function(t) {
        for(var e = new Int32Array(8), r = 0, n = e.length - 1; !((1 & t) !== r && (r = 1 & t, --n < 0));)e[n]++, t >>= 1;
        return e;
    }, t.getCodewordBucketNumber = function(t) {
        return t instanceof Int32Array ? this.getCodewordBucketNumber_Int32Array(t) : this.getCodewordBucketNumber_number(t);
    }, t.getCodewordBucketNumber_number = function(e) {
        return t.getCodewordBucketNumber(t.getBitCountForCodeword(e));
    }, t.getCodewordBucketNumber_Int32Array = function(t) {
        return (t[0] - t[2] + t[4] - t[6] + 9) % 9;
    }, t.toString = function(t) {
        for(var e = new $12c6b0ab9da17bee$var$An, r = 0; r < t.length; r++){
            e.format("Row %2d: ", r);
            for(var n = 0; n < t[r].length; n++){
                var o = t[r][n];
                0 === o.getValue().length ? e.format("        ", null) : e.format("%4d(%2d)", o.getValue()[0], o.getConfidence(o.getValue()[0]));
            }
            e.format("%n");
        }
        return e.toString();
    }, t.CODEWORD_SKEW_SIZE = 2, t.MAX_ERRORS = 3, t.MAX_EC_CODEWORDS = 512, t.errorCorrection = new $12c6b0ab9da17bee$var$_n, t;
}(), $12c6b0ab9da17bee$var$Zn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Kn = function() {
    function t() {}
    return t.prototype.decode = function(e, r) {
        void 0 === r && (r = null);
        var n = t.decode(e, r, !1);
        if (null == n || 0 === n.length || null == n[0]) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
        return n[0];
    }, t.prototype.decodeMultiple = function(e, r) {
        void 0 === r && (r = null);
        try {
            return t.decode(e, r, !0);
        } catch (t) {
            if (t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$g) throw $12c6b0ab9da17bee$var$U.getNotFoundInstance();
            throw t;
        }
    }, t.decode = function(e, r, n) {
        var o, i, a = new Array, u = $12c6b0ab9da17bee$var$hn.detectMultiple(e, r, n);
        try {
            for(var s = $12c6b0ab9da17bee$var$Zn(u.getPoints()), c = s.next(); !c.done; c = s.next()){
                var f = c.value, h = $12c6b0ab9da17bee$var$Yn.decode(u.getBits(), f[4], f[5], f[6], f[7], t.getMinCodewordWidth(f), t.getMaxCodewordWidth(f)), l = new $12c6b0ab9da17bee$var$et(h.getText(), h.getRawBytes(), void 0, f, $12c6b0ab9da17bee$var$nt.PDF_417);
                l.putMetadata($12c6b0ab9da17bee$var$it.ERROR_CORRECTION_LEVEL, h.getECLevel());
                var d = h.getOther();
                null != d && l.putMetadata($12c6b0ab9da17bee$var$it.PDF417_EXTRA_METADATA, d), a.push(l);
            }
        } catch (t) {
            o = {
                error: t
            };
        } finally{
            try {
                c && !c.done && (i = s.return) && i.call(s);
            } finally{
                if (o) throw o.error;
            }
        }
        return a.map(function(t) {
            return t;
        });
    }, t.getMaxWidth = function(t, e) {
        return null == t || null == e ? 0 : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMinWidth = function(t, e) {
        return null == t || null == e ? $12c6b0ab9da17bee$var$I.MAX_VALUE : Math.trunc(Math.abs(t.getX() - e.getX()));
    }, t.getMaxCodewordWidth = function(e) {
        return Math.floor(Math.max(Math.max(t.getMaxWidth(e[0], e[4]), t.getMaxWidth(e[6], e[2]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN), Math.max(t.getMaxWidth(e[1], e[5]), t.getMaxWidth(e[7], e[3]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.getMinCodewordWidth = function(e) {
        return Math.floor(Math.min(Math.min(t.getMinWidth(e[0], e[4]), t.getMinWidth(e[6], e[2]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN), Math.min(t.getMinWidth(e[1], e[5]), t.getMinWidth(e[7], e[3]) * $12c6b0ab9da17bee$var$sn.MODULES_IN_CODEWORD / $12c6b0ab9da17bee$var$sn.MODULES_IN_STOP_PATTERN)));
    }, t.prototype.reset = function() {}, t;
}(), $12c6b0ab9da17bee$var$qn = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Qn = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$qn(e, t), e.kind = "ReaderException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$Jn = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$$n = function() {
    function t() {}
    return t.prototype.decode = function(t, e) {
        return this.setHints(e), this.decodeInternal(t);
    }, t.prototype.decodeWithState = function(t) {
        return null !== this.readers && void 0 !== this.readers || this.setHints(null), this.decodeInternal(t);
    }, t.prototype.setHints = function(t) {
        this.hints = t;
        var e = null != t && void 0 !== t.get($12c6b0ab9da17bee$var$T.TRY_HARDER), r = null == t ? null : t.get($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS), n = new Array;
        if (null != r) {
            var o = r.some(function(t) {
                return t === $12c6b0ab9da17bee$var$nt.UPC_A || t === $12c6b0ab9da17bee$var$nt.UPC_E || t === $12c6b0ab9da17bee$var$nt.EAN_13 || t === $12c6b0ab9da17bee$var$nt.EAN_8 || t === $12c6b0ab9da17bee$var$nt.CODABAR || t === $12c6b0ab9da17bee$var$nt.CODE_39 || t === $12c6b0ab9da17bee$var$nt.CODE_93 || t === $12c6b0ab9da17bee$var$nt.CODE_128 || t === $12c6b0ab9da17bee$var$nt.ITF || t === $12c6b0ab9da17bee$var$nt.RSS_14 || t === $12c6b0ab9da17bee$var$nt.RSS_EXPANDED;
            });
            o && !e && n.push(new $12c6b0ab9da17bee$var$fr(t)), r.includes($12c6b0ab9da17bee$var$nt.QR_CODE) && n.push(new $12c6b0ab9da17bee$var$an), r.includes($12c6b0ab9da17bee$var$nt.DATA_MATRIX) && n.push(new $12c6b0ab9da17bee$var$Or), r.includes($12c6b0ab9da17bee$var$nt.AZTEC) && n.push(new $12c6b0ab9da17bee$var$Mt), r.includes($12c6b0ab9da17bee$var$nt.PDF_417) && n.push(new $12c6b0ab9da17bee$var$Kn), o && e && n.push(new $12c6b0ab9da17bee$var$fr(t));
        }
        0 === n.length && (e || n.push(new $12c6b0ab9da17bee$var$fr(t)), n.push(new $12c6b0ab9da17bee$var$an), n.push(new $12c6b0ab9da17bee$var$Or), n.push(new $12c6b0ab9da17bee$var$Mt), n.push(new $12c6b0ab9da17bee$var$Kn), e && n.push(new $12c6b0ab9da17bee$var$fr(t))), this.readers = n;
    }, t.prototype.reset = function() {
        var t, e;
        if (null !== this.readers) try {
            for(var r = $12c6b0ab9da17bee$var$Jn(this.readers), n = r.next(); !n.done; n = r.next())n.value.reset();
        } catch (e) {
            t = {
                error: e
            };
        } finally{
            try {
                n && !n.done && (e = r.return) && e.call(r);
            } finally{
                if (t) throw t.error;
            }
        }
    }, t.prototype.decodeInternal = function(t) {
        var e, r;
        if (null === this.readers) throw new $12c6b0ab9da17bee$var$Qn("No readers where selected, nothing can be read.");
        try {
            for(var n = $12c6b0ab9da17bee$var$Jn(this.readers), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                try {
                    return i.decode(t, this.hints);
                } catch (t) {
                    if (t instanceof $12c6b0ab9da17bee$var$Qn) continue;
                }
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
        throw new $12c6b0ab9da17bee$var$U("No MultiFormat Readers were able to detect the code.");
    }, t;
}(), $12c6b0ab9da17bee$var$to = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        void 0 === e && (e = null), void 0 === r && (r = 500);
        var n = new $12c6b0ab9da17bee$var$$n;
        return n.setHints(e), t.call(this, n, r) || this;
    }
    $12c6b0ab9da17bee$var$to(e, t), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    };
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$Kn, e) || this;
    }
    $12c6b0ab9da17bee$var$eo(e, t);
}($12c6b0ab9da17bee$var$tt);
var $12c6b0ab9da17bee$var$ro, $12c6b0ab9da17bee$var$no = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e) {
        return void 0 === e && (e = 500), t.call(this, new $12c6b0ab9da17bee$var$an, e) || this;
    }
    $12c6b0ab9da17bee$var$no(e, t);
}($12c6b0ab9da17bee$var$tt), function(t) {
    t[t.ERROR_CORRECTION = 0] = "ERROR_CORRECTION", t[t.CHARACTER_SET = 1] = "CHARACTER_SET", t[t.DATA_MATRIX_SHAPE = 2] = "DATA_MATRIX_SHAPE", t[t.MIN_SIZE = 3] = "MIN_SIZE", t[t.MAX_SIZE = 4] = "MAX_SIZE", t[t.MARGIN = 5] = "MARGIN", t[t.PDF417_COMPACT = 6] = "PDF417_COMPACT", t[t.PDF417_COMPACTION = 7] = "PDF417_COMPACTION", t[t.PDF417_DIMENSIONS = 8] = "PDF417_DIMENSIONS", t[t.AZTEC_LAYERS = 9] = "AZTEC_LAYERS", t[t.QR_VERSION = 10] = "QR_VERSION";
}($12c6b0ab9da17bee$var$ro || ($12c6b0ab9da17bee$var$ro = {}));
var $12c6b0ab9da17bee$var$oo = $12c6b0ab9da17bee$var$ro, $12c6b0ab9da17bee$var$io = function() {
    function t(t) {
        this.field = t, this.cachedGenerators = [], this.cachedGenerators.push(new $12c6b0ab9da17bee$var$st(t, Int32Array.from([
            1
        ])));
    }
    return t.prototype.buildGenerator = function(t) {
        var e = this.cachedGenerators;
        if (t >= e.length) for(var r = e[e.length - 1], n = this.field, o = e.length; o <= t; o++){
            var i = r.multiply(new $12c6b0ab9da17bee$var$st(n, Int32Array.from([
                1,
                n.exp(o - 1 + n.getGeneratorBase())
            ])));
            e.push(i), r = i;
        }
        return e[t];
    }, t.prototype.encode = function(t, e) {
        if (0 === e) throw new $12c6b0ab9da17bee$var$l("No error correction bytes");
        var r = t.length - e;
        if (r <= 0) throw new $12c6b0ab9da17bee$var$l("No data bytes provided");
        var n = this.buildGenerator(e), o = new Int32Array(r);
        $12c6b0ab9da17bee$var$w.arraycopy(t, 0, o, 0, r);
        for(var i = new $12c6b0ab9da17bee$var$st(this.field, o), a = (i = i.multiplyByMonomial(e, 1)).divide(n)[1].getCoefficients(), u = e - a.length, s = 0; s < u; s++)t[r + s] = 0;
        $12c6b0ab9da17bee$var$w.arraycopy(a, 0, t, r + u, a.length);
    }, t;
}(), $12c6b0ab9da17bee$var$ao = function() {
    function t() {}
    return t.applyMaskPenaltyRule1 = function(e) {
        return t.applyMaskPenaltyRule1Internal(e, !0) + t.applyMaskPenaltyRule1Internal(e, !1);
    }, t.applyMaskPenaltyRule2 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i - 1; a++)for(var u = n[a], s = 0; s < o - 1; s++){
            var c = u[s];
            c === u[s + 1] && c === n[a + 1][s] && c === n[a + 1][s + 1] && r++;
        }
        return t.N2 * r;
    }, t.applyMaskPenaltyRule3 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = 0; u < o; u++){
            var s = n[a];
            u + 6 < o && 1 === s[u] && 0 === s[u + 1] && 1 === s[u + 2] && 1 === s[u + 3] && 1 === s[u + 4] && 0 === s[u + 5] && 1 === s[u + 6] && (t.isWhiteHorizontal(s, u - 4, u) || t.isWhiteHorizontal(s, u + 7, u + 11)) && r++, a + 6 < i && 1 === n[a][u] && 0 === n[a + 1][u] && 1 === n[a + 2][u] && 1 === n[a + 3][u] && 1 === n[a + 4][u] && 0 === n[a + 5][u] && 1 === n[a + 6][u] && (t.isWhiteVertical(n, u, a - 4, a) || t.isWhiteVertical(n, u, a + 7, a + 11)) && r++;
        }
        return r * t.N3;
    }, t.isWhiteHorizontal = function(t, e, r) {
        e = Math.max(e, 0), r = Math.min(r, t.length);
        for(var n = e; n < r; n++)if (1 === t[n]) return !1;
        return !0;
    }, t.isWhiteVertical = function(t, e, r, n) {
        r = Math.max(r, 0), n = Math.min(n, t.length);
        for(var o = r; o < n; o++)if (1 === t[o][e]) return !1;
        return !0;
    }, t.applyMaskPenaltyRule4 = function(e) {
        for(var r = 0, n = e.getArray(), o = e.getWidth(), i = e.getHeight(), a = 0; a < i; a++)for(var u = n[a], s = 0; s < o; s++)1 === u[s] && r++;
        var c = e.getHeight() * e.getWidth();
        return Math.floor(10 * Math.abs(2 * r - c) / c) * t.N4;
    }, t.getDataMaskBit = function(t, e, r) {
        var n, o;
        switch(t){
            case 0:
                n = r + e & 1;
                break;
            case 1:
                n = 1 & r;
                break;
            case 2:
                n = e % 3;
                break;
            case 3:
                n = (r + e) % 3;
                break;
            case 4:
                n = Math.floor(r / 2) + Math.floor(e / 3) & 1;
                break;
            case 5:
                n = (1 & (o = r * e)) + o % 3;
                break;
            case 6:
                n = (1 & (o = r * e)) + o % 3 & 1;
                break;
            case 7:
                n = (o = r * e) % 3 + (r + e & 1) & 1;
                break;
            default:
                throw new $12c6b0ab9da17bee$var$l("Invalid mask pattern: " + t);
        }
        return 0 === n;
    }, t.applyMaskPenaltyRule1Internal = function(e, r) {
        for(var n = 0, o = r ? e.getHeight() : e.getWidth(), i = r ? e.getWidth() : e.getHeight(), a = e.getArray(), u = 0; u < o; u++){
            for(var s = 0, c = -1, f = 0; f < i; f++){
                var h = r ? a[u][f] : a[f][u];
                h === c ? s++ : (s >= 5 && (n += t.N1 + (s - 5)), s = 1, c = h);
            }
            s >= 5 && (n += t.N1 + (s - 5));
        }
        return n;
    }, t.N1 = 3, t.N2 = 3, t.N3 = 40, t.N4 = 10, t;
}(), $12c6b0ab9da17bee$var$uo = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$so = function() {
    function t(t, e) {
        this.width = t, this.height = e;
        for(var r = new Array(e), n = 0; n !== e; n++)r[n] = new Uint8Array(t);
        this.bytes = r;
    }
    return t.prototype.getHeight = function() {
        return this.height;
    }, t.prototype.getWidth = function() {
        return this.width;
    }, t.prototype.get = function(t, e) {
        return this.bytes[e][t];
    }, t.prototype.getArray = function() {
        return this.bytes;
    }, t.prototype.setNumber = function(t, e, r) {
        this.bytes[e][t] = r;
    }, t.prototype.setBoolean = function(t, e, r) {
        this.bytes[e][t] = r ? 1 : 0;
    }, t.prototype.clear = function(t) {
        var e, r;
        try {
            for(var n = $12c6b0ab9da17bee$var$uo(this.bytes), o = n.next(); !o.done; o = n.next()){
                var i = o.value;
                $12c6b0ab9da17bee$var$C.fill(i, t);
            }
        } catch (t) {
            e = {
                error: t
            };
        } finally{
            try {
                o && !o.done && (r = n.return) && r.call(n);
            } finally{
                if (e) throw e.error;
            }
        }
    }, t.prototype.equals = function(e) {
        if (!(e instanceof t)) return !1;
        var r = e;
        if (this.width !== r.width) return !1;
        if (this.height !== r.height) return !1;
        for(var n = 0, o = this.height; n < o; ++n)for(var i = this.bytes[n], a = r.bytes[n], u = 0, s = this.width; u < s; ++u)if (i[u] !== a[u]) return !1;
        return !0;
    }, t.prototype.toString = function() {
        for(var t = new $12c6b0ab9da17bee$var$k, e = 0, r = this.height; e < r; ++e){
            for(var n = this.bytes[e], o = 0, i = this.width; o < i; ++o)switch(n[o]){
                case 0:
                    t.append(" 0");
                    break;
                case 1:
                    t.append(" 1");
                    break;
                default:
                    t.append("  ");
            }
            t.append("\n");
        }
        return t.toString();
    }, t;
}(), $12c6b0ab9da17bee$var$co = function() {
    function t() {
        this.maskPattern = -1;
    }
    return t.prototype.getMode = function() {
        return this.mode;
    }, t.prototype.getECLevel = function() {
        return this.ecLevel;
    }, t.prototype.getVersion = function() {
        return this.version;
    }, t.prototype.getMaskPattern = function() {
        return this.maskPattern;
    }, t.prototype.getMatrix = function() {
        return this.matrix;
    }, t.prototype.toString = function() {
        var t = new $12c6b0ab9da17bee$var$k;
        return t.append("<<\n"), t.append(" mode: "), t.append(this.mode ? this.mode.toString() : "null"), t.append("\n ecLevel: "), t.append(this.ecLevel ? this.ecLevel.toString() : "null"), t.append("\n version: "), t.append(this.version ? this.version.toString() : "null"), t.append("\n maskPattern: "), t.append(this.maskPattern.toString()), this.matrix ? (t.append("\n matrix:\n"), t.append(this.matrix.toString())) : t.append("\n matrix: null\n"), t.append(">>\n"), t.toString();
    }, t.prototype.setMode = function(t) {
        this.mode = t;
    }, t.prototype.setECLevel = function(t) {
        this.ecLevel = t;
    }, t.prototype.setVersion = function(t) {
        this.version = t;
    }, t.prototype.setMaskPattern = function(t) {
        this.maskPattern = t;
    }, t.prototype.setMatrix = function(t) {
        this.matrix = t;
    }, t.isValidMaskPattern = function(e) {
        return e >= 0 && e < t.NUM_MASK_PATTERNS;
    }, t.NUM_MASK_PATTERNS = 8, t;
}(), $12c6b0ab9da17bee$var$fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$ho = function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    return $12c6b0ab9da17bee$var$fo(e, t), e.kind = "WriterException", e;
}($12c6b0ab9da17bee$var$s), $12c6b0ab9da17bee$var$lo = function() {
    function t() {}
    return t.clearMatrix = function(t) {
        t.clear(255);
    }, t.buildMatrix = function(e, r, n, o, i) {
        t.clearMatrix(i), t.embedBasicPatterns(n, i), t.embedTypeInfo(r, o, i), t.maybeEmbedVersionInfo(n, i), t.embedDataBits(e, o, i);
    }, t.embedBasicPatterns = function(e, r) {
        t.embedPositionDetectionPatternsAndSeparators(r), t.embedDarkDotAtLeftBottomCorner(r), t.maybeEmbedPositionAdjustmentPatterns(e, r), t.embedTimingPatterns(r);
    }, t.embedTypeInfo = function(e, r, n) {
        var o = new $12c6b0ab9da17bee$var$S;
        t.makeTypeInfoBits(e, r, o);
        for(var i = 0, a = o.getSize(); i < a; ++i){
            var u = o.get(o.getSize() - 1 - i), s = t.TYPE_INFO_COORDINATES[i], c = s[0], f = s[1];
            if (n.setBoolean(c, f, u), i < 8) {
                var h = n.getWidth() - i - 1, l = 8;
                n.setBoolean(h, l, u);
            } else {
                h = 8, l = n.getHeight() - 7 + (i - 8);
                n.setBoolean(h, l, u);
            }
        }
    }, t.maybeEmbedVersionInfo = function(e, r) {
        if (!(e.getVersionNumber() < 7)) {
            var n = new $12c6b0ab9da17bee$var$S;
            t.makeVersionInfoBits(e, n);
            for(var o = 17, i = 0; i < 6; ++i)for(var a = 0; a < 3; ++a){
                var u = n.get(o);
                o--, r.setBoolean(i, r.getHeight() - 11 + a, u), r.setBoolean(r.getHeight() - 11 + a, i, u);
            }
        }
    }, t.embedDataBits = function(e, r, n) {
        for(var o = 0, i = -1, a = n.getWidth() - 1, u = n.getHeight() - 1; a > 0;){
            for(6 === a && (a -= 1); u >= 0 && u < n.getHeight();){
                for(var s = 0; s < 2; ++s){
                    var c = a - s;
                    if (t.isEmpty(n.get(c, u))) {
                        var f = void 0;
                        o < e.getSize() ? (f = e.get(o), ++o) : f = !1, 255 !== r && $12c6b0ab9da17bee$var$ao.getDataMaskBit(r, c, u) && (f = !f), n.setBoolean(c, u, f);
                    }
                }
                u += i;
            }
            u += i = -i, a -= 2;
        }
        if (o !== e.getSize()) throw new $12c6b0ab9da17bee$var$ho("Not all bits consumed: " + o + "/" + e.getSize());
    }, t.findMSBSet = function(t) {
        return 32 - $12c6b0ab9da17bee$var$I.numberOfLeadingZeros(t);
    }, t.calculateBCHCode = function(e, r) {
        if (0 === r) throw new $12c6b0ab9da17bee$var$l("0 polynomial");
        var n = t.findMSBSet(r);
        for(e <<= n - 1; t.findMSBSet(e) >= n;)e ^= r << t.findMSBSet(e) - n;
        return e;
    }, t.makeTypeInfoBits = function(e, r, n) {
        if (!$12c6b0ab9da17bee$var$co.isValidMaskPattern(r)) throw new $12c6b0ab9da17bee$var$ho("Invalid mask pattern");
        var o = e.getBits() << 3 | r;
        n.appendBits(o, 5);
        var i = t.calculateBCHCode(o, t.TYPE_INFO_POLY);
        n.appendBits(i, 10);
        var a = new $12c6b0ab9da17bee$var$S;
        if (a.appendBits(t.TYPE_INFO_MASK_PATTERN, 15), n.xor(a), 15 !== n.getSize()) throw new $12c6b0ab9da17bee$var$ho("should not happen but we got: " + n.getSize());
    }, t.makeVersionInfoBits = function(e, r) {
        r.appendBits(e.getVersionNumber(), 6);
        var n = t.calculateBCHCode(e.getVersionNumber(), t.VERSION_INFO_POLY);
        if (r.appendBits(n, 12), 18 !== r.getSize()) throw new $12c6b0ab9da17bee$var$ho("should not happen but we got: " + r.getSize());
    }, t.isEmpty = function(t) {
        return 255 === t;
    }, t.embedTimingPatterns = function(e) {
        for(var r = 8; r < e.getWidth() - 8; ++r){
            var n = (r + 1) % 2;
            t.isEmpty(e.get(r, 6)) && e.setNumber(r, 6, n), t.isEmpty(e.get(6, r)) && e.setNumber(6, r, n);
        }
    }, t.embedDarkDotAtLeftBottomCorner = function(t) {
        if (0 === t.get(8, t.getHeight() - 8)) throw new $12c6b0ab9da17bee$var$ho;
        t.setNumber(8, t.getHeight() - 8, 1);
    }, t.embedHorizontalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 8; ++o){
            if (!t.isEmpty(n.get(e + o, r))) throw new $12c6b0ab9da17bee$var$ho;
            n.setNumber(e + o, r, 0);
        }
    }, t.embedVerticalSeparationPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o){
            if (!t.isEmpty(n.get(e, r + o))) throw new $12c6b0ab9da17bee$var$ho;
            n.setNumber(e, r + o, 0);
        }
    }, t.embedPositionAdjustmentPattern = function(e, r, n) {
        for(var o = 0; o < 5; ++o)for(var i = t.POSITION_ADJUSTMENT_PATTERN[o], a = 0; a < 5; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPattern = function(e, r, n) {
        for(var o = 0; o < 7; ++o)for(var i = t.POSITION_DETECTION_PATTERN[o], a = 0; a < 7; ++a)n.setNumber(e + a, r + o, i[a]);
    }, t.embedPositionDetectionPatternsAndSeparators = function(e) {
        var r = t.POSITION_DETECTION_PATTERN[0].length;
        t.embedPositionDetectionPattern(0, 0, e), t.embedPositionDetectionPattern(e.getWidth() - r, 0, e), t.embedPositionDetectionPattern(0, e.getWidth() - r, e);
        t.embedHorizontalSeparationPattern(0, 7, e), t.embedHorizontalSeparationPattern(e.getWidth() - 8, 7, e), t.embedHorizontalSeparationPattern(0, e.getWidth() - 8, e);
        t.embedVerticalSeparationPattern(7, 0, e), t.embedVerticalSeparationPattern(e.getHeight() - 7 - 1, 0, e), t.embedVerticalSeparationPattern(7, e.getHeight() - 7, e);
    }, t.maybeEmbedPositionAdjustmentPatterns = function(e, r) {
        if (!(e.getVersionNumber() < 2)) for(var n = e.getVersionNumber() - 1, o = t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[n], i = 0, a = o.length; i !== a; i++){
            var u = o[i];
            if (u >= 0) for(var s = 0; s !== a; s++){
                var c = o[s];
                c >= 0 && t.isEmpty(r.get(c, u)) && t.embedPositionAdjustmentPattern(c - 2, u - 2, r);
            }
        }
    }, t.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]), t.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]), t.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]), t.VERSION_INFO_POLY = 7973, t.TYPE_INFO_POLY = 1335, t.TYPE_INFO_MASK_PATTERN = 21522, t;
}(), $12c6b0ab9da17bee$var$po = function() {
    function t(t, e) {
        this.dataBytes = t, this.errorCorrectionBytes = e;
    }
    return t.prototype.getDataBytes = function() {
        return this.dataBytes;
    }, t.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    }, t;
}(), $12c6b0ab9da17bee$var$go = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function() {
    function t() {}
    t.calculateMaskPenalty = function(t) {
        return $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule1(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule2(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule3(t) + $12c6b0ab9da17bee$var$ao.applyMaskPenaltyRule4(t);
    }, t.encode = function(e, r, n) {
        void 0 === n && (n = null);
        var o = t.DEFAULT_BYTE_MODE_ENCODING, i = null !== n && void 0 !== n.get($12c6b0ab9da17bee$var$oo.CHARACTER_SET);
        i && (o = n.get($12c6b0ab9da17bee$var$oo.CHARACTER_SET).toString());
        var a = this.chooseMode(e, o), u = new $12c6b0ab9da17bee$var$S;
        if (a === $12c6b0ab9da17bee$var$Wr.BYTE && (i || t.DEFAULT_BYTE_MODE_ENCODING !== o)) {
            var s = $12c6b0ab9da17bee$var$P.getCharacterSetECIByName(o);
            void 0 !== s && this.appendECI(s, u);
        }
        this.appendModeInfo(a, u);
        var c, f = new $12c6b0ab9da17bee$var$S;
        if (this.appendBytes(e, a, f, o), null !== n && void 0 !== n.get($12c6b0ab9da17bee$var$oo.QR_VERSION)) {
            var h = Number.parseInt(n.get($12c6b0ab9da17bee$var$oo.QR_VERSION).toString(), 10);
            c = $12c6b0ab9da17bee$var$Fr.getVersionForNumber(h);
            var l = this.calculateBitsNeeded(a, u, f, c);
            if (!this.willFit(l, c, r)) throw new $12c6b0ab9da17bee$var$ho("Data too big for requested version");
        } else c = this.recommendVersion(r, a, u, f);
        var d = new $12c6b0ab9da17bee$var$S;
        d.appendBitArray(u);
        var p = a === $12c6b0ab9da17bee$var$Wr.BYTE ? f.getSizeInBytes() : e.length;
        this.appendLengthInfo(p, c, a, d), d.appendBitArray(f);
        var g = c.getECBlocksForLevel(r), y = c.getTotalCodewords() - g.getTotalECCodewords();
        this.terminateBits(y, d);
        var w = this.interleaveWithECBytes(d, c.getTotalCodewords(), y, g.getNumBlocks()), _ = new $12c6b0ab9da17bee$var$co;
        _.setECLevel(r), _.setMode(a), _.setVersion(c);
        var v = c.getDimensionForVersion(), m = new $12c6b0ab9da17bee$var$so(v, v), A = this.chooseMaskPattern(w, r, c, m);
        return _.setMaskPattern(A), $12c6b0ab9da17bee$var$lo.buildMatrix(w, r, c, A, m), _.setMatrix(m), _;
    }, t.recommendVersion = function(t, e, r, n) {
        var o = this.calculateBitsNeeded(e, r, n, $12c6b0ab9da17bee$var$Fr.getVersionForNumber(1)), i = this.chooseVersion(o, t), a = this.calculateBitsNeeded(e, r, n, i);
        return this.chooseVersion(a, t);
    }, t.calculateBitsNeeded = function(t, e, r, n) {
        return e.getSize() + t.getCharacterCountBits(n) + r.getSize();
    }, t.getAlphanumericCode = function(e) {
        return e < t.ALPHANUMERIC_TABLE.length ? t.ALPHANUMERIC_TABLE[e] : -1;
    }, t.chooseMode = function(e, r) {
        if (void 0 === r && (r = null), $12c6b0ab9da17bee$var$P.SJIS.getName() === r && this.isOnlyDoubleByteKanji(e)) return $12c6b0ab9da17bee$var$Wr.KANJI;
        for(var n = !1, o = !1, i = 0, a = e.length; i < a; ++i){
            var u = e.charAt(i);
            if (t.isDigit(u)) n = !0;
            else {
                if (-1 === this.getAlphanumericCode(u.charCodeAt(0))) return $12c6b0ab9da17bee$var$Wr.BYTE;
                o = !0;
            }
        }
        return o ? $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC : n ? $12c6b0ab9da17bee$var$Wr.NUMERIC : $12c6b0ab9da17bee$var$Wr.BYTE;
    }, t.isOnlyDoubleByteKanji = function(t) {
        var e;
        try {
            e = $12c6b0ab9da17bee$var$L.encode(t, $12c6b0ab9da17bee$var$P.SJIS);
        } catch (t) {
            return !1;
        }
        var r = e.length;
        if (r % 2 != 0) return !1;
        for(var n = 0; n < r; n += 2){
            var o = 255 & e[n];
            if ((o < 129 || o > 159) && (o < 224 || o > 235)) return !1;
        }
        return !0;
    }, t.chooseMaskPattern = function(t, e, r, n) {
        for(var o = Number.MAX_SAFE_INTEGER, i = -1, a = 0; a < $12c6b0ab9da17bee$var$co.NUM_MASK_PATTERNS; a++){
            $12c6b0ab9da17bee$var$lo.buildMatrix(t, e, r, a, n);
            var u = this.calculateMaskPenalty(n);
            u < o && (o = u, i = a);
        }
        return i;
    }, t.chooseVersion = function(e, r) {
        for(var n = 1; n <= 40; n++){
            var o = $12c6b0ab9da17bee$var$Fr.getVersionForNumber(n);
            if (t.willFit(e, o, r)) return o;
        }
        throw new $12c6b0ab9da17bee$var$ho("Data too big");
    }, t.willFit = function(t, e, r) {
        return e.getTotalCodewords() - e.getECBlocksForLevel(r).getTotalECCodewords() >= (t + 7) / 8;
    }, t.terminateBits = function(t, e) {
        var r = 8 * t;
        if (e.getSize() > r) throw new $12c6b0ab9da17bee$var$ho("data bits cannot fit in the QR Code" + e.getSize() + " > " + r);
        for(var n = 0; n < 4 && e.getSize() < r; ++n)e.appendBit(!1);
        var o = 7 & e.getSize();
        if (o > 0) for(n = o; n < 8; n++)e.appendBit(!1);
        var i = t - e.getSizeInBytes();
        for(n = 0; n < i; ++n)e.appendBits(0 == (1 & n) ? 236 : 17, 8);
        if (e.getSize() !== r) throw new $12c6b0ab9da17bee$var$ho("Bits size does not equal capacity");
    }, t.getNumDataBytesAndNumECBytesForBlockID = function(t, e, r, n, o, i) {
        if (n >= r) throw new $12c6b0ab9da17bee$var$ho("Block ID too large");
        var a = t % r, u = r - a, s = Math.floor(t / r), c = s + 1, f = Math.floor(e / r), h = f + 1, l = s - f, d = c - h;
        if (l !== d) throw new $12c6b0ab9da17bee$var$ho("EC bytes mismatch");
        if (r !== u + a) throw new $12c6b0ab9da17bee$var$ho("RS blocks mismatch");
        if (t !== (f + l) * u + (h + d) * a) throw new $12c6b0ab9da17bee$var$ho("Total bytes mismatch");
        n < u ? (o[0] = f, i[0] = l) : (o[0] = h, i[0] = d);
    }, t.interleaveWithECBytes = function(e, r, n, o) {
        var i, a, u, s;
        if (e.getSizeInBytes() !== n) throw new $12c6b0ab9da17bee$var$ho("Number of bits and data bytes does not match");
        for(var c = 0, f = 0, h = 0, l = new Array, d = 0; d < o; ++d){
            var p = new Int32Array(1), g = new Int32Array(1);
            t.getNumDataBytesAndNumECBytesForBlockID(r, n, o, d, p, g);
            var y = p[0], w = new Uint8Array(y);
            e.toBytes(8 * c, w, 0, y);
            var _ = t.generateECBytes(w, g[0]);
            l.push(new $12c6b0ab9da17bee$var$po(w, _)), f = Math.max(f, y), h = Math.max(h, _.length), c += p[0];
        }
        if (n !== c) throw new $12c6b0ab9da17bee$var$ho("Data bytes does not match offset");
        var v = new $12c6b0ab9da17bee$var$S;
        for(d = 0; d < f; ++d)try {
            for(var m = (i = void 0, $12c6b0ab9da17bee$var$go(l)), A = m.next(); !A.done; A = m.next())d < (w = A.value.getDataBytes()).length && v.appendBits(w[d], 8);
        } catch (t) {
            i = {
                error: t
            };
        } finally{
            try {
                A && !A.done && (a = m.return) && a.call(m);
            } finally{
                if (i) throw i.error;
            }
        }
        for(d = 0; d < h; ++d)try {
            for(var E = (u = void 0, $12c6b0ab9da17bee$var$go(l)), C = E.next(); !C.done; C = E.next())d < (_ = C.value.getErrorCorrectionBytes()).length && v.appendBits(_[d], 8);
        } catch (t) {
            u = {
                error: t
            };
        } finally{
            try {
                C && !C.done && (s = E.return) && s.call(E);
            } finally{
                if (u) throw u.error;
            }
        }
        if (r !== v.getSizeInBytes()) throw new $12c6b0ab9da17bee$var$ho("Interleaving error: " + r + " and " + v.getSizeInBytes() + " differ.");
        return v;
    }, t.generateECBytes = function(t, e) {
        for(var r = t.length, n = new Int32Array(r + e), o = 0; o < r; o++)n[o] = 255 & t[o];
        new $12c6b0ab9da17bee$var$io($12c6b0ab9da17bee$var$lt.QR_CODE_FIELD_256).encode(n, e);
        var i = new Uint8Array(e);
        for(o = 0; o < e; o++)i[o] = n[r + o];
        return i;
    }, t.appendModeInfo = function(t, e) {
        e.appendBits(t.getBits(), 4);
    }, t.appendLengthInfo = function(t, e, r, n) {
        var o = r.getCharacterCountBits(e);
        if (t >= 1 << o) throw new $12c6b0ab9da17bee$var$ho(t + " is bigger than " + ((1 << o) - 1));
        n.appendBits(t, o);
    }, t.appendBytes = function(e, r, n, o) {
        switch(r){
            case $12c6b0ab9da17bee$var$Wr.NUMERIC:
                t.appendNumericBytes(e, n);
                break;
            case $12c6b0ab9da17bee$var$Wr.ALPHANUMERIC:
                t.appendAlphanumericBytes(e, n);
                break;
            case $12c6b0ab9da17bee$var$Wr.BYTE:
                t.append8BitBytes(e, n, o);
                break;
            case $12c6b0ab9da17bee$var$Wr.KANJI:
                t.appendKanjiBytes(e, n);
                break;
            default:
                throw new $12c6b0ab9da17bee$var$ho("Invalid mode: " + r);
        }
    }, t.getDigit = function(t) {
        return t.charCodeAt(0) - 48;
    }, t.isDigit = function(e) {
        var r = t.getDigit(e);
        return r >= 0 && r <= 9;
    }, t.appendNumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getDigit(e.charAt(o));
            if (o + 2 < n) {
                var a = t.getDigit(e.charAt(o + 1)), u = t.getDigit(e.charAt(o + 2));
                r.appendBits(100 * i + 10 * a + u, 10), o += 3;
            } else if (o + 1 < n) {
                a = t.getDigit(e.charAt(o + 1));
                r.appendBits(10 * i + a, 7), o += 2;
            } else r.appendBits(i, 4), o++;
        }
    }, t.appendAlphanumericBytes = function(e, r) {
        for(var n = e.length, o = 0; o < n;){
            var i = t.getAlphanumericCode(e.charCodeAt(o));
            if (-1 === i) throw new $12c6b0ab9da17bee$var$ho;
            if (o + 1 < n) {
                var a = t.getAlphanumericCode(e.charCodeAt(o + 1));
                if (-1 === a) throw new $12c6b0ab9da17bee$var$ho;
                r.appendBits(45 * i + a, 11), o += 2;
            } else r.appendBits(i, 6), o++;
        }
    }, t.append8BitBytes = function(t, e, r) {
        var n;
        try {
            n = $12c6b0ab9da17bee$var$L.encode(t, r);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$ho(t);
        }
        for(var o = 0, i = n.length; o !== i; o++){
            var a = n[o];
            e.appendBits(a, 8);
        }
    }, t.appendKanjiBytes = function(t, e) {
        var r;
        try {
            r = $12c6b0ab9da17bee$var$L.encode(t, $12c6b0ab9da17bee$var$P.SJIS);
        } catch (t) {
            throw new $12c6b0ab9da17bee$var$ho(t);
        }
        for(var n = r.length, o = 0; o < n; o += 2){
            var i = (255 & r[o]) << 8 & 4294967295 | 255 & r[o + 1], a = -1;
            if (i >= 33088 && i <= 40956 ? a = i - 33088 : i >= 57408 && i <= 60351 && (a = i - 49472), -1 === a) throw new $12c6b0ab9da17bee$var$ho("Invalid byte sequence");
            var u = 192 * (a >> 8) + (255 & a);
            e.appendBits(u, 13);
        }
    }, t.appendECI = function(t, e) {
        e.appendBits($12c6b0ab9da17bee$var$Wr.ECI.getBits(), 4), e.appendBits(t.getValue(), 8);
    }, t.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]), t.DEFAULT_BYTE_MODE_ENCODING = $12c6b0ab9da17bee$var$P.UTF8.getName();
}();
var $12c6b0ab9da17bee$var$yo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u, s) {
        var c = t.call(this, a, u) || this;
        if (c.yuvData = e, c.dataWidth = r, c.dataHeight = n, c.left = o, c.top = i, o + a > r || i + u > n) throw new $12c6b0ab9da17bee$var$l("Crop rectangle does not fit within image data.");
        return s && c.reverseHorizontal(a, u), c;
    }
    $12c6b0ab9da17bee$var$yo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.yuvData;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $12c6b0ab9da17bee$var$w.arraycopy(this.yuvData, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.yuvData, this.dataWidth, this.dataHeight, this.left + t, this.top + r, n, o, !1);
    }, e.prototype.renderThumbnail = function() {
        for(var t = this.getWidth() / e.THUMBNAIL_SCALE_FACTOR, r = this.getHeight() / e.THUMBNAIL_SCALE_FACTOR, n = new Int32Array(t * r), o = this.yuvData, i = this.top * this.dataWidth + this.left, a = 0; a < r; a++){
            for(var u = a * t, s = 0; s < t; s++){
                var c = 255 & o[i + s * e.THUMBNAIL_SCALE_FACTOR];
                n[u + s] = 4278190080 | 65793 * c;
            }
            i += this.dataWidth * e.THUMBNAIL_SCALE_FACTOR;
        }
        return n;
    }, e.prototype.getThumbnailWidth = function() {
        return this.getWidth() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.getThumbnailHeight = function() {
        return this.getHeight() / e.THUMBNAIL_SCALE_FACTOR;
    }, e.prototype.reverseHorizontal = function(t, e) {
        for(var r = this.yuvData, n = 0, o = this.top * this.dataWidth + this.left; n < e; n++, o += this.dataWidth)for(var i = o + t / 2, a = o, u = o + t - 1; a < i; a++, u--){
            var s = r[a];
            r[a] = r[u], r[u] = s;
        }
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.THUMBNAIL_SCALE_FACTOR = 2;
}($12c6b0ab9da17bee$var$j);
var $12c6b0ab9da17bee$var$wo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n, o, i, a, u) {
        var s = t.call(this, r, n) || this;
        if (s.dataWidth = o, s.dataHeight = i, s.left = a, s.top = u, 4 === e.BYTES_PER_ELEMENT) {
            for(var c = r * n, f = new Uint8ClampedArray(c), h = 0; h < c; h++){
                var d = e[h], p = d >> 16 & 255, g = d >> 7 & 510, y = 255 & d;
                f[h] = (p + g + y) / 4 & 255;
            }
            s.luminances = f;
        } else s.luminances = e;
        if (void 0 === o && (s.dataWidth = r), void 0 === i && (s.dataHeight = n), void 0 === a && (s.left = 0), void 0 === u && (s.top = 0), s.left + r > s.dataWidth || s.top + n > s.dataHeight) throw new $12c6b0ab9da17bee$var$l("Crop rectangle does not fit within image data.");
        return s;
    }
    $12c6b0ab9da17bee$var$wo(e, t), e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth();
        (null == e || e.length < r) && (e = new Uint8ClampedArray(r));
        var n = (t + this.top) * this.dataWidth + this.left;
        return $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, n, e, 0, r), e;
    }, e.prototype.getMatrix = function() {
        var t = this.getWidth(), e = this.getHeight();
        if (t === this.dataWidth && e === this.dataHeight) return this.luminances;
        var r = t * e, n = new Uint8ClampedArray(r), o = this.top * this.dataWidth + this.left;
        if (t === this.dataWidth) return $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, o, n, 0, r), n;
        for(var i = 0; i < e; i++){
            var a = i * t;
            $12c6b0ab9da17bee$var$w.arraycopy(this.luminances, o, n, a, t), o += this.dataWidth;
        }
        return n;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(t, r, n, o) {
        return new e(this.luminances, n, o, this.dataWidth, this.dataHeight, this.left + t, this.top + r);
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    };
}($12c6b0ab9da17bee$var$j);
var $12c6b0ab9da17bee$var$_o = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e() {
        return null !== t && t.apply(this, arguments) || this;
    }
    $12c6b0ab9da17bee$var$_o(e, t), e.forName = function(t) {
        return this.getCharacterSetECIByName(t);
    };
}($12c6b0ab9da17bee$var$P);
var $12c6b0ab9da17bee$var$vo = function() {
    function t(t) {
        this.previous = t;
    }
    return t.prototype.getPrevious = function() {
        return this.previous;
    }, t;
}(), $12c6b0ab9da17bee$var$mo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Ao = function(t) {
    function e(e, r, n) {
        var o = t.call(this, e) || this;
        return o.value = r, o.bitCount = n, o;
    }
    return $12c6b0ab9da17bee$var$mo(e, t), e.prototype.appendTo = function(t, e) {
        t.appendBits(this.value, this.bitCount);
    }, e.prototype.add = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.addBinaryShift = function(t, r) {
        return console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token"), new e(this, t, r);
    }, e.prototype.toString = function() {
        var t = this.value & (1 << this.bitCount) - 1;
        return t |= 1 << this.bitCount, "<" + $12c6b0ab9da17bee$var$I.toBinaryString(t | 1 << this.bitCount).substring(1) + ">";
    }, e;
}($12c6b0ab9da17bee$var$vo), $12c6b0ab9da17bee$var$Eo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r, n) {
        var o = t.call(this, e, 0, 0) || this;
        return o.binaryShiftStart = r, o.binaryShiftByteCount = n, o;
    }
    $12c6b0ab9da17bee$var$Eo(e, t), e.prototype.appendTo = function(t, e) {
        for(var r = 0; r < this.binaryShiftByteCount; r++)(0 === r || 31 === r && this.binaryShiftByteCount <= 62) && (t.appendBits(31, 5), this.binaryShiftByteCount > 62 ? t.appendBits(this.binaryShiftByteCount - 31, 16) : 0 === r ? t.appendBits(Math.min(this.binaryShiftByteCount, 31), 5) : t.appendBits(this.binaryShiftByteCount - 31, 5)), t.appendBits(e[this.binaryShiftStart + r], 8);
    }, e.prototype.addBinaryShift = function(t, r) {
        return new e(this, t, r);
    }, e.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    };
}($12c6b0ab9da17bee$var$Ao);
new $12c6b0ab9da17bee$var$Ao(null, 0, 0);
var $12c6b0ab9da17bee$var$Co = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
!function(t) {
    var e, r;
    try {
        for(var n = $12c6b0ab9da17bee$var$Co(t), o = n.next(); !o.done; o = n.next()){
            var i = o.value;
            $12c6b0ab9da17bee$var$C.fill(i, -1);
        }
    } catch (t) {
        e = {
            error: t
        };
    } finally{
        try {
            o && !o.done && (r = n.return) && r.call(n);
        } finally{
            if (e) throw e.error;
        }
    }
    t[0][4] = 0, t[1][4] = 0, t[1][0] = 28, t[3][4] = 0, t[2][4] = 0, t[2][0] = 15;
}($12c6b0ab9da17bee$var$C.createInt32Array(6, 6)), function(t) {
    var e = $12c6b0ab9da17bee$var$F.getCharCode(" "), r = $12c6b0ab9da17bee$var$F.getCharCode("."), n = $12c6b0ab9da17bee$var$F.getCharCode(",");
    t[0][e] = 1;
    for(var o = $12c6b0ab9da17bee$var$F.getCharCode("Z"), i = $12c6b0ab9da17bee$var$F.getCharCode("A"), a = i; a <= o; a++)t[0][a] = a - i + 2;
    t[1][e] = 1;
    var u = $12c6b0ab9da17bee$var$F.getCharCode("z"), s = $12c6b0ab9da17bee$var$F.getCharCode("a");
    for(a = s; a <= u; a++)t[1][a] = a - s + 2;
    t[2][e] = 1;
    var c = $12c6b0ab9da17bee$var$F.getCharCode("9"), f = $12c6b0ab9da17bee$var$F.getCharCode("0");
    for(a = f; a <= c; a++)t[2][a] = a - f + 2;
    t[2][n] = 12, t[2][r] = 13;
    for(var h = [
        "\0",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ], l = 0; l < h.length; l++)t[3][$12c6b0ab9da17bee$var$F.getCharCode(h[l])] = l;
    var d = [
        "\0",
        "\r",
        "\0",
        "\0",
        "\0",
        "\0",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(l = 0; l < d.length; l++)$12c6b0ab9da17bee$var$F.getCharCode(d[l]) > 0 && (t[4][$12c6b0ab9da17bee$var$F.getCharCode(d[l])] = l);
}($12c6b0ab9da17bee$var$C.createInt32Array(5, 256));
var $12c6b0ab9da17bee$var$Io = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$So = function(t) {
    function e(r) {
        var n = t.call(this, r.width, r.height) || this;
        return n.canvas = r, n.buffer = e.makeBufferFromCanvasImageData(r), n;
    }
    return $12c6b0ab9da17bee$var$Io(e, t), e.makeBufferFromCanvasImageData = function(t) {
        var r = t.getContext("2d");
        if (!r) throw new Error("Couldn't get canvas context.");
        var n = r.getImageData(0, 0, t.width, t.height);
        return e.toGrayscaleBuffer(n.data, t.width, t.height);
    }, e.toGrayscaleBuffer = function(t, e, r) {
        for(var n = new Uint8ClampedArray(e * r), o = 0, i = 0, a = t.length; o < a; o += 4, i++){
            var u = void 0;
            if (0 === t[o + 3]) u = 255;
            else u = 306 * t[o] + 601 * t[o + 1] + 117 * t[o + 2] + 512 >> 10;
            n[i] = u;
        }
        return n;
    }, e.prototype.getRow = function(t, e) {
        if (t < 0 || t >= this.getHeight()) throw new $12c6b0ab9da17bee$var$l("Requested row is outside the image: " + t);
        var r = this.getWidth(), n = t * r;
        return null === e ? e = this.buffer.slice(n, n + r) : (e.length < r && (e = new Uint8ClampedArray(r)), e.set(this.buffer.slice(n, n + r))), e;
    }, e.prototype.getMatrix = function() {
        return this.buffer;
    }, e.prototype.isCropSupported = function() {
        return !0;
    }, e.prototype.crop = function(e, r, n, o) {
        return t.prototype.crop.call(this, e, r, n, o), this;
    }, e.prototype.isRotateSupported = function() {
        return !0;
    }, e.prototype.rotateCounterClockwise = function() {
        return this.rotate(-90), this;
    }, e.prototype.rotateCounterClockwise45 = function() {
        return this.rotate(-45), this;
    }, e.prototype.invert = function() {
        return new $12c6b0ab9da17bee$var$Y(this);
    }, e.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var t = this.canvas.ownerDocument.createElement("canvas");
            t.width = this.canvas.width, t.height = this.canvas.height, this.tempCanvasElement = t;
        }
        return this.tempCanvasElement;
    }, e.prototype.rotate = function(t) {
        var r = this.getTempCanvasElement();
        if (!r) throw new Error("Could not create a Canvas element.");
        var n = t * e.DEGREE_TO_RADIANS, o = this.canvas.width, i = this.canvas.height, a = Math.ceil(Math.abs(Math.cos(n)) * o + Math.abs(Math.sin(n)) * i), u = Math.ceil(Math.abs(Math.sin(n)) * o + Math.abs(Math.cos(n)) * i);
        r.width = a, r.height = u;
        var s = r.getContext("2d");
        if (!s) throw new Error("Could not create a Convas Context element.");
        return s.translate(a / 2, u / 2), s.rotate(n), s.drawImage(this.canvas, o / -2, i / -2), this.buffer = e.makeBufferFromCanvasImageData(r), this;
    }, e.DEGREE_TO_RADIANS = Math.PI / 180, e;
}($12c6b0ab9da17bee$var$j);
function $12c6b0ab9da17bee$var$Oo() {
    return "undefined" != typeof navigator;
}
function $12c6b0ab9da17bee$var$To() {
    return !!($12c6b0ab9da17bee$var$Oo() && navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
}
var $12c6b0ab9da17bee$var$bo = function() {
    return $12c6b0ab9da17bee$var$bo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $12c6b0ab9da17bee$var$bo.apply(this, arguments);
}, $12c6b0ab9da17bee$var$Ro = function(t, e, r, n) {
    return new (r || (r = Promise))(function(o, i) {
        function a(t) {
            try {
                s(n.next(t));
            } catch (t) {
                i(t);
            }
        }
        function u(t) {
            try {
                s(n.throw(t));
            } catch (t) {
                i(t);
            }
        }
        function s(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function(t) {
                t(e);
            })).then(a, u);
        }
        s((n = n.apply(t, e || [])).next());
    });
}, $12c6b0ab9da17bee$var$No = function(t, e) {
    var r, n, o, i, a = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function u(i) {
        return function(u) {
            return function(i) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;
                    switch(n = 0, o && (i = [
                        2 & i[0],
                        o.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            o = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, n = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < o[1]) {
                                a.label = o[1], o = i;
                                break;
                            }
                            if (o && a.label < o[2]) {
                                a.label = o[2], a.ops.push(i);
                                break;
                            }
                            o[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = e.call(t, a);
                } catch (t) {
                    i = [
                        6,
                        t
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                u
            ]);
        };
    }
}, $12c6b0ab9da17bee$var$Do = function(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r = e && t[e], n = 0;
    if (r) return r.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && n >= t.length && (t = void 0), {
                value: t && t[n++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, $12c6b0ab9da17bee$var$Po = {
    delayBetweenScanAttempts: 500,
    delayBetweenScanSuccess: 500,
    tryPlayVideoTimeout: 5e3
}, $12c6b0ab9da17bee$var$Mo = function() {
    function t(t, e, r) {
        void 0 === e && (e = new Map), void 0 === r && (r = {}), this.reader = t, this.hints = e, this.options = $12c6b0ab9da17bee$var$bo($12c6b0ab9da17bee$var$bo({}, $12c6b0ab9da17bee$var$Po), r);
    }
    return Object.defineProperty(t.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS, t);
        },
        enumerable: !1,
        configurable: !0
    }), t.addVideoSource = function(t, e) {
        try {
            t.srcObject = e;
        } catch (r) {
            t.src = URL.createObjectURL(e);
        }
    }, t.mediaStreamSetTorch = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            t.applyConstraints({
                                advanced: [
                                    {
                                        fillLightMode: e ? "flash" : "off",
                                        torch: !!e
                                    }
                                ]
                            })
                        ];
                    case 1:
                        return r.sent(), [
                            2
                        ];
                }
            });
        });
    }, t.mediaStreamIsTorchCompatible = function(e) {
        var r, n, o = e.getVideoTracks();
        try {
            for(var i = $12c6b0ab9da17bee$var$Do(o), a = i.next(); !a.done; a = i.next()){
                var u = a.value;
                if (t.mediaStreamIsTorchCompatibleTrack(u)) return !0;
            }
        } catch (t) {
            r = {
                error: t
            };
        } finally{
            try {
                a && !a.done && (n = i.return) && n.call(i);
            } finally{
                if (r) throw r.error;
            }
        }
        return !1;
    }, t.mediaStreamIsTorchCompatibleTrack = function(t) {
        try {
            return "torch" in t.getCapabilities();
        } catch (t) {
            return console.error(t), console.warn("Your browser may be not fully compatible with WebRTC and/or ImageCapture specs. Torch will not be available."), !1;
        }
    }, t.isVideoPlaying = function(t) {
        return t.currentTime > 0 && !t.paused && t.readyState > 2;
    }, t.getMediaElement = function(t, e) {
        var r = document.getElementById(t);
        if (!r) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' not found");
        if (r.nodeName.toLowerCase() !== e.toLowerCase()) throw new $12c6b0ab9da17bee$var$f("element with id '" + t + "' must be an " + e + " element");
        return r;
    }, t.createVideoElement = function(e) {
        if (e instanceof HTMLVideoElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "video");
        if (!e && "undefined" != typeof document) {
            var r = document.createElement("video");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get videoElement from videoSource!");
    }, t.prepareImageElement = function(e) {
        if (e instanceof HTMLImageElement) return e;
        if ("string" == typeof e) return t.getMediaElement(e, "img");
        if (void 0 === e) {
            var r = document.createElement("img");
            return r.width = 200, r.height = 200, r;
        }
        throw new Error("Couldn't get imageElement from imageSource!");
    }, t.prepareVideoElement = function(e) {
        var r = t.createVideoElement(e);
        return r.setAttribute("autoplay", "true"), r.setAttribute("muted", "true"), r.setAttribute("playsinline", "true"), r;
    }, t.isImageLoaded = function(t) {
        return !!t.complete && 0 !== t.naturalWidth;
    }, t.createBinaryBitmapFromCanvas = function(t) {
        var e = new $12c6b0ab9da17bee$var$So(t), r = new $12c6b0ab9da17bee$var$W(e);
        return new $12c6b0ab9da17bee$var$d(r);
    }, t.drawImageOnCanvas = function(t, e) {
        t.drawImage(e, 0, 0);
    }, t.getMediaElementDimensions = function(t) {
        if (t instanceof HTMLVideoElement) return {
            height: t.videoHeight,
            width: t.videoWidth
        };
        if (t instanceof HTMLImageElement) return {
            height: t.naturalHeight || t.height,
            width: t.naturalWidth || t.width
        };
        throw new Error("Couldn't find the Source's dimentions!");
    }, t.createCaptureCanvas = function(e) {
        if (!e) throw new $12c6b0ab9da17bee$var$f("Cannot create a capture canvas without a media element.");
        if ("undefined" == typeof document) throw new Error('The page "Document" is undefined, make sure you\'re running in a browser.');
        var r = document.createElement("canvas"), n = t.getMediaElementDimensions(e), o = n.width, i = n.height;
        return r.style.width = o + "px", r.style.height = i + "px", r.width = o, r.height = i, r;
    }, t.tryPlayVideo = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (null == e ? void 0 : e.ended) return console.error("Trying to play video that has ended."), [
                            2,
                            !1
                        ];
                        if (t.isVideoPlaying(e)) return console.warn("Trying to play video that is already playing."), [
                            2,
                            !0
                        ];
                        n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]), [
                            4,
                            e.play()
                        ];
                    case 2:
                        return n.sent(), [
                            2,
                            !0
                        ];
                    case 3:
                        return r = n.sent(), console.warn("It was not possible to play the video.", r), [
                            2,
                            !1
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.createCanvasFromMediaElement = function(e) {
        var r = t.createCaptureCanvas(e), n = r.getContext("2d");
        if (!n) throw new Error("Couldn't find Canvas 2D Context.");
        return t.drawImageOnCanvas(n, e), r;
    }, t.createBinaryBitmapFromMediaElem = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return t.createBinaryBitmapFromCanvas(r);
    }, t.destroyImageElement = function(t) {
        t.src = "", t.removeAttribute("src"), t = void 0;
    }, t.listVideoInputDevices = function() {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var t, e, r, n, o, i, a, u, s, c, f, h;
            return $12c6b0ab9da17bee$var$No(this, function(l) {
                switch(l.label){
                    case 0:
                        if (!$12c6b0ab9da17bee$var$Oo()) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!$12c6b0ab9da17bee$var$To()) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        t = l.sent(), e = [];
                        try {
                            for(r = $12c6b0ab9da17bee$var$Do(t), n = r.next(); !n.done; n = r.next())o = n.value, "videoinput" === (i = "video" === o.kind ? "videoinput" : o.kind) && (a = o.deviceId || o.id, u = o.label || "Video device " + (e.length + 1), s = o.groupId, c = {
                                deviceId: a,
                                label: u,
                                kind: i,
                                groupId: s
                            }, e.push(c));
                        } catch (t) {
                            f = {
                                error: t
                            };
                        } finally{
                            try {
                                n && !n.done && (h = r.return) && h.call(r);
                            } finally{
                                if (f) throw f.error;
                            }
                        }
                        return [
                            2,
                            e
                        ];
                }
            });
        });
    }, t.findDeviceById = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.listVideoInputDevices()
                        ];
                    case 1:
                        return (r = n.sent()) ? [
                            2,
                            r.find(function(t) {
                                return t.deviceId === e;
                            })
                        ] : [
                            2
                        ];
                }
            });
        });
    }, t.cleanVideoSource = function(t) {
        if (t) {
            try {
                t.srcObject = null;
            } catch (e) {
                t.src = "";
            }
            t && t.removeAttribute("src");
        }
    }, t.playVideoOnLoadAsync = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            t.tryPlayVideo(e)
                        ];
                    case 1:
                        return n.sent() ? [
                            2,
                            !0
                        ] : [
                            2,
                            new Promise(function(n, o) {
                                var i = setTimeout(function() {
                                    t.isVideoPlaying(e) || (o(!1), e.removeEventListener("canplay", a));
                                }, r), a = function() {
                                    t.tryPlayVideo(e).then(function(t) {
                                        clearTimeout(i), e.removeEventListener("canplay", a), n(t);
                                    });
                                };
                                e.addEventListener("canplay", a);
                            })
                        ];
                }
            });
        });
    }, t.attachStreamToVideo = function(e, r, n) {
        return void 0 === n && (n = 5e3), $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return o = t.prepareVideoElement(r), t.addVideoSource(o, e), [
                            4,
                            t.playVideoOnLoadAsync(o, n)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            o
                        ];
                }
            });
        });
    }, t._waitImageLoad = function(e) {
        return new Promise(function(r, n) {
            var o = setTimeout(function() {
                t.isImageLoaded(e) || (e.removeEventListener("load", i), n());
            }, 1e4), i = function() {
                clearTimeout(o), e.removeEventListener("load", i), r();
            };
            e.addEventListener("load", i);
        });
    }, t.checkCallbackFnOrThrow = function(t) {
        if (!t) throw new $12c6b0ab9da17bee$var$f("`callbackFn` is a required parameter, you cannot capture results without it.");
    }, t.disposeMediaStream = function(t) {
        t.getVideoTracks().forEach(function(t) {
            return t.stop();
        }), t = void 0;
    }, t.prototype.decode = function(e) {
        var r = t.createCanvasFromMediaElement(e);
        return this.decodeFromCanvas(r);
    }, t.prototype.decodeBitmap = function(t) {
        return this.reader.decode(t, this.hints);
    }, t.prototype.decodeFromCanvas = function(e) {
        var r = t.createBinaryBitmapFromCanvas(e);
        return this.decodeBitmap(r);
    }, t.prototype.decodeFromImageElement = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An image element must be provided.");
                        return r = t.prepareImageElement(e), [
                            4,
                            this._decodeOnLoadImage(r)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromImageUrl = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        (r = t.prepareImageElement()).src = e, n.label = 1;
                    case 1:
                        return n.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            this.decodeFromImageElement(r)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                    case 3:
                        return t.destroyImageElement(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromConstraints = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o, i;
            return $12c6b0ab9da17bee$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), [
                            4,
                            navigator.mediaDevices.getUserMedia(e)
                        ];
                    case 1:
                        o = a.sent(), a.label = 2;
                    case 2:
                        return a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]), [
                            4,
                            this.decodeFromStream(o, r, n)
                        ];
                    case 3:
                        return [
                            2,
                            a.sent()
                        ];
                    case 4:
                        throw i = a.sent(), t.disposeMediaStream(o), i;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeFromStream = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o, i, a, u, s, c, f, h, l, d, p = this;
            return $12c6b0ab9da17bee$var$No(this, function(g) {
                switch(g.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.attachStreamToVideo(e, r, o)
                        ];
                    case 1:
                        return i = g.sent(), a = function() {
                            var t, r;
                            try {
                                for(var n = $12c6b0ab9da17bee$var$Do(e.getVideoTracks()), o = n.next(); !o.done; o = n.next())o.value.stop();
                            } catch (e) {
                                t = {
                                    error: e
                                };
                            } finally{
                                try {
                                    o && !o.done && (r = n.return) && r.call(n);
                                } finally{
                                    if (t) throw t.error;
                                }
                            }
                            e = void 0;
                        }, u = function() {
                            a(), t.cleanVideoSource(i);
                        }, s = this.scan(i, n, u), c = e.getVideoTracks(), f = $12c6b0ab9da17bee$var$bo($12c6b0ab9da17bee$var$bo({}, s), {
                            stop: function() {
                                s.stop();
                            },
                            streamVideoConstraintsApply: function(t, e) {
                                return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
                                    var r, n, o, i, a, u;
                                    return $12c6b0ab9da17bee$var$No(this, function(s) {
                                        switch(s.label){
                                            case 0:
                                                r = e ? c.filter(e) : c, s.label = 1;
                                            case 1:
                                                s.trys.push([
                                                    1,
                                                    6,
                                                    7,
                                                    8
                                                ]), n = $12c6b0ab9da17bee$var$Do(r), o = n.next(), s.label = 2;
                                            case 2:
                                                return o.done ? [
                                                    3,
                                                    5
                                                ] : [
                                                    4,
                                                    o.value.applyConstraints(t)
                                                ];
                                            case 3:
                                                s.sent(), s.label = 4;
                                            case 4:
                                                return o = n.next(), [
                                                    3,
                                                    2
                                                ];
                                            case 5:
                                                return [
                                                    3,
                                                    8
                                                ];
                                            case 6:
                                                return i = s.sent(), a = {
                                                    error: i
                                                }, [
                                                    3,
                                                    8
                                                ];
                                            case 7:
                                                try {
                                                    o && !o.done && (u = n.return) && u.call(n);
                                                } finally{
                                                    if (a) throw a.error;
                                                }
                                                return [
                                                    7
                                                ];
                                            case 8:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            },
                            streamVideoConstraintsGet: function(t) {
                                return c.find(t).getConstraints();
                            },
                            streamVideoSettingsGet: function(t) {
                                return c.find(t).getSettings();
                            },
                            streamVideoCapabilitiesGet: function(t) {
                                return c.find(t).getCapabilities();
                            }
                        }), t.mediaStreamIsTorchCompatible(e) && (h = null == c ? void 0 : c.find(function(e) {
                            return t.mediaStreamIsTorchCompatibleTrack(e);
                        }), l = function(e) {
                            return $12c6b0ab9da17bee$var$Ro(p, void 0, void 0, function() {
                                return $12c6b0ab9da17bee$var$No(this, function(r) {
                                    switch(r.label){
                                        case 0:
                                            return [
                                                4,
                                                t.mediaStreamSetTorch(h, e)
                                            ];
                                        case 1:
                                            return r.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, f.switchTorch = l, d = function() {
                            s.stop(), l(!1);
                        }, f.stop = d), [
                            2,
                            f
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoDevice = function(e, r, n) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return t.checkCallbackFnOrThrow(n), o = {
                            video: e ? {
                                deviceId: {
                                    exact: e
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeFromConstraints(o, r, n)
                        ];
                    case 1:
                        return [
                            2,
                            i.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoElement = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
                        return n = t.prepareVideoElement(e), o = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, o)
                        ];
                    case 1:
                        return i.sent(), [
                            2,
                            this.scan(n, r)
                        ];
                }
            });
        });
    }, t.prototype.decodeFromVideoUrl = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o, i;
            return $12c6b0ab9da17bee$var$No(this, function(a) {
                switch(a.label){
                    case 0:
                        if (t.checkCallbackFnOrThrow(r), !e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        return (n = t.prepareVideoElement()).src = e, o = function() {
                            t.cleanVideoSource(n);
                        }, i = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(n, i)
                        ];
                    case 1:
                        return a.sent(), [
                            2,
                            this.scan(n, r, o)
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromConstraints = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            navigator.mediaDevices.getUserMedia(t)
                        ];
                    case 1:
                        return r = n.sent(), [
                            4,
                            this.decodeOnceFromStream(r, e)
                        ];
                    case 2:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromStream = function(e, r) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var n, o;
            return $12c6b0ab9da17bee$var$No(this, function(i) {
                switch(i.label){
                    case 0:
                        return n = Boolean(r), [
                            4,
                            t.attachStreamToVideo(e, r)
                        ];
                    case 1:
                        o = i.sent(), i.label = 2;
                    case 2:
                        return i.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]), [
                            4,
                            this.scanOneResult(o)
                        ];
                    case 3:
                        return [
                            2,
                            i.sent()
                        ];
                    case 4:
                        return n || t.cleanVideoSource(o), [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoDevice = function(t, e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r;
            return $12c6b0ab9da17bee$var$No(this, function(n) {
                switch(n.label){
                    case 0:
                        return r = {
                            video: t ? {
                                deviceId: {
                                    exact: t
                                }
                            } : {
                                facingMode: "environment"
                            }
                        }, [
                            4,
                            this.decodeOnceFromConstraints(r, e)
                        ];
                    case 1:
                        return [
                            2,
                            n.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoElement = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $12c6b0ab9da17bee$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("A video element must be provided.");
                        return r = t.prepareVideoElement(e), n = this.options.tryPlayVideoTimeout, [
                            4,
                            t.playVideoOnLoadAsync(r, n)
                        ];
                    case 1:
                        return o.sent(), [
                            4,
                            this.scanOneResult(r)
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                }
            });
        });
    }, t.prototype.decodeOnceFromVideoUrl = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            var r, n;
            return $12c6b0ab9da17bee$var$No(this, function(o) {
                switch(o.label){
                    case 0:
                        if (!e) throw new $12c6b0ab9da17bee$var$f("An URL must be provided.");
                        (r = t.prepareVideoElement()).src = e, n = this.decodeOnceFromVideoElement(r), o.label = 1;
                    case 1:
                        return o.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]), [
                            4,
                            n
                        ];
                    case 2:
                        return [
                            2,
                            o.sent()
                        ];
                    case 3:
                        return t.cleanVideoSource(r), [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
    }, t.prototype.scanOneResult = function(t, e, r, n) {
        var o = this;
        return void 0 === e && (e = !0), void 0 === r && (r = !0), void 0 === n && (n = !0), new Promise(function(i, a) {
            o.scan(t, function(t, o, u) {
                if (t) return i(t), void u.stop();
                if (o) {
                    if (o instanceof $12c6b0ab9da17bee$var$U && e) return;
                    if (o instanceof $12c6b0ab9da17bee$var$g && r) return;
                    if (o instanceof $12c6b0ab9da17bee$var$R && n) return;
                    u.stop(), a(o);
                }
            });
        });
    }, t.prototype.scan = function(e, r, n) {
        var o = this;
        t.checkCallbackFnOrThrow(r);
        var i = t.createCaptureCanvas(e), a = i.getContext("2d");
        if (!a) throw new Error("Couldn't create canvas for visual element scan.");
        var u, s = function() {
            a = void 0, i = void 0;
        }, c = !1, f = {
            stop: function() {
                c = !0, clearTimeout(u), s(), n && n();
            }
        }, h = function() {
            if (!c) try {
                t.drawImageOnCanvas(a, e);
                var l = o.decodeFromCanvas(i);
                r(l, void 0, f), u = setTimeout(h, o.options.delayBetweenScanSuccess);
            } catch (t) {
                if (r(void 0, t, f), t instanceof $12c6b0ab9da17bee$var$g || t instanceof $12c6b0ab9da17bee$var$R || t instanceof $12c6b0ab9da17bee$var$U) return void (u = setTimeout(h, o.options.delayBetweenScanAttempts));
                s(), n && n(t);
            }
        };
        return h(), f;
    }, t.prototype._decodeOnLoadImage = function(e) {
        return $12c6b0ab9da17bee$var$Ro(this, void 0, void 0, function() {
            return $12c6b0ab9da17bee$var$No(this, function(r) {
                switch(r.label){
                    case 0:
                        return t.isImageLoaded(e) ? [
                            3,
                            2
                        ] : [
                            4,
                            t._waitImageLoad(e)
                        ];
                    case 1:
                        r.sent(), r.label = 2;
                    case 2:
                        return [
                            2,
                            this.decode(e)
                        ];
                }
            });
        });
    }, t;
}(), $12c6b0ab9da17bee$var$Bo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Mt, e, r) || this;
    }
    $12c6b0ab9da17bee$var$Bo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Lo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$fr(e), e, r) || this;
    }
    $12c6b0ab9da17bee$var$Lo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Fo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Or, e, r) || this;
    }
    $12c6b0ab9da17bee$var$Fo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$ko = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        var n = this, o = new $12c6b0ab9da17bee$var$$n;
        return o.setHints(e), (n = t.call(this, o, e, r) || this).reader = o, n;
    }
    $12c6b0ab9da17bee$var$ko(e, t), Object.defineProperty(e.prototype, "possibleFormats", {
        set: function(t) {
            this.hints.set($12c6b0ab9da17bee$var$T.POSSIBLE_FORMATS, t), this.reader.setHints(this.hints);
        },
        enumerable: !1,
        configurable: !0
    }), e.prototype.decodeBitmap = function(t) {
        return this.reader.decodeWithState(t);
    }, e.prototype.setHints = function(t) {
        this.hints = t, this.reader.setHints(this.hints);
    };
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$xo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}();
!function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$Kn, e, r) || this;
    }
    $12c6b0ab9da17bee$var$xo(e, t);
}($12c6b0ab9da17bee$var$Mo);
var $12c6b0ab9da17bee$var$Vo = function() {
    var t = function(e, r) {
        return t = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(t, e) {
            t.__proto__ = e;
        } || function(t, e) {
            for(var r in e)e.hasOwnProperty(r) && (t[r] = e[r]);
        }, t(e, r);
    };
    return function(e, r) {
        function n() {
            this.constructor = e;
        }
        t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n);
    };
}(), $12c6b0ab9da17bee$var$Uo = function(t) {
    function e(e, r) {
        return t.call(this, new $12c6b0ab9da17bee$var$an, e, r) || this;
    }
    return $12c6b0ab9da17bee$var$Vo(e, t), e;
}($12c6b0ab9da17bee$var$Mo), $12c6b0ab9da17bee$var$Ho = function(t, e, r) {
    var n = typeof t === r;
    return n || console.warn('[ReactQrReader]: Expected "'.concat(e, '" to be a of type "').concat(r, '".')), n;
}, $12c6b0ab9da17bee$export$950f6bcb8267c4b = function(t) {
    var n = t.scanDelay, o = t.constraints, i = t.onResult, a = t.videoId, u = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(function() {
        var t = new $12c6b0ab9da17bee$var$Uo(null, {
            delayBetweenScanAttempts: n
        });
        if (!function() {
            var t = "undefined" != typeof navigator && !!navigator.mediaDevices;
            return t || console.warn('[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t;
        }() && $12c6b0ab9da17bee$var$Ho(i, "onResult", "function")) i(null, new Error('MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"'), t);
        return $12c6b0ab9da17bee$var$Ho(o, "constraints", "object") && t.decodeFromConstraints({
            video: o
        }, a, function(e, r) {
            $12c6b0ab9da17bee$var$Ho(i, "onResult", "function") && i(e, r, t);
        }).then(function(t) {
            return u.current = t;
        }).catch(function(e) {
            $12c6b0ab9da17bee$var$Ho(i, "onResult", "function") && i(null, e, t);
        }), function() {
            var t;
            null === (t = u.current) || void 0 === t || t.stop();
        };
    }, []);
}, $12c6b0ab9da17bee$var$Xo = function() {
    return $12c6b0ab9da17bee$var$Xo = Object.assign || function(t) {
        for(var e, r = 1, n = arguments.length; r < n; r++)for(var o in e = arguments[r])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
        return t;
    }, $12c6b0ab9da17bee$var$Xo.apply(this, arguments);
}, $12c6b0ab9da17bee$var$Wo = {
    container: {
        width: "100%",
        paddingTop: "100%",
        overflow: "hidden",
        position: "relative"
    },
    video: {
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "block",
        overflow: "hidden",
        position: "absolute",
        transform: void 0
    }
}, $12c6b0ab9da17bee$export$5d05a7e825dbf285 = function(e) {
    var r = e.videoContainerStyle, n = e.containerStyle, o = e.videoStyle, i = e.constraints, a = e.ViewFinder, u = e.scanDelay, s = e.className, c = e.onResult, f = e.videoId;
    return $12c6b0ab9da17bee$export$950f6bcb8267c4b({
        constraints: i,
        scanDelay: u,
        onResult: c,
        videoId: f
    }), $eZVvM.createElement("section", {
        className: s,
        style: n
    }, $eZVvM.createElement("div", {
        style: $12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo({}, $12c6b0ab9da17bee$var$Wo.container), r)
    }, !!a && $eZVvM.createElement(a, null), $eZVvM.createElement("video", {
        muted: !0,
        id: f,
        style: $12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo($12c6b0ab9da17bee$var$Xo({}, $12c6b0ab9da17bee$var$Wo.video), o), {
            transform: "user" === (null == i ? void 0 : i.facingMode) && "scaleX(-1)"
        })
    })));
};
$12c6b0ab9da17bee$export$5d05a7e825dbf285.displayName = "QrReader", $12c6b0ab9da17bee$export$5d05a7e825dbf285.defaultProps = {
    constraints: {
        facingMode: "user"
    },
    videoId: "video",
    scanDelay: 500
};


var $6bd535989f3fab53$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $6bd535989f3fab53$exports = factory();
})(typeof self !== "undefined" ? self : $6bd535989f3fab53$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix = /** @class */ function() {
                function BitMatrix(data, width) {
                    this.width = width;
                    this.height = data.length / width;
                    this.data = data;
                }
                BitMatrix.createEmpty = function(width, height) {
                    return new BitMatrix(new Uint8ClampedArray(width * height), width);
                };
                BitMatrix.prototype.get = function(x, y) {
                    if (x < 0 || x >= this.width || y < 0 || y >= this.height) return false;
                    return !!this.data[y * this.width + x];
                };
                BitMatrix.prototype.set = function(x, y, v) {
                    this.data[y * this.width + x] = v ? 1 : 0;
                };
                BitMatrix.prototype.setRegion = function(left, top, width, height, v) {
                    for(var y = top; y < top + height; y++)for(var x = left; x < left + width; x++)this.set(x, y, !!v);
                };
                return BitMatrix;
            }();
            exports.BitMatrix = BitMatrix;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGFPoly_1 = __webpack_require__(2);
            function addOrSubtractGF(a, b) {
                return a ^ b; // tslint:disable-line:no-bitwise
            }
            exports.addOrSubtractGF = addOrSubtractGF;
            var GenericGF = /** @class */ function() {
                function GenericGF(primitive, size, genBase) {
                    this.primitive = primitive;
                    this.size = size;
                    this.generatorBase = genBase;
                    this.expTable = new Array(this.size);
                    this.logTable = new Array(this.size);
                    var x = 1;
                    for(var i = 0; i < this.size; i++){
                        this.expTable[i] = x;
                        x = x * 2;
                        if (x >= this.size) x = (x ^ this.primitive) & this.size - 1; // tslint:disable-line:no-bitwise
                    }
                    for(var i = 0; i < this.size - 1; i++)this.logTable[this.expTable[i]] = i;
                    this.zero = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        0
                    ]));
                    this.one = new GenericGFPoly_1.default(this, Uint8ClampedArray.from([
                        1
                    ]));
                }
                GenericGF.prototype.multiply = function(a, b) {
                    if (a === 0 || b === 0) return 0;
                    return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
                };
                GenericGF.prototype.inverse = function(a) {
                    if (a === 0) throw new Error("Can't invert 0");
                    return this.expTable[this.size - this.logTable[a] - 1];
                };
                GenericGF.prototype.buildMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid monomial degree less than 0");
                    if (coefficient === 0) return this.zero;
                    var coefficients = new Uint8ClampedArray(degree + 1);
                    coefficients[0] = coefficient;
                    return new GenericGFPoly_1.default(this, coefficients);
                };
                GenericGF.prototype.log = function(a) {
                    if (a === 0) throw new Error("Can't take log(0)");
                    return this.logTable[a];
                };
                GenericGF.prototype.exp = function(a) {
                    return this.expTable[a];
                };
                return GenericGF;
            }();
            exports.default = GenericGF;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly = /** @class */ function() {
                function GenericGFPoly(field, coefficients) {
                    if (coefficients.length === 0) throw new Error("No coefficients.");
                    this.field = field;
                    var coefficientsLength = coefficients.length;
                    if (coefficientsLength > 1 && coefficients[0] === 0) {
                        // Leading term must be non-zero for anything except the constant polynomial "0"
                        var firstNonZero = 1;
                        while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
                        if (firstNonZero === coefficientsLength) this.coefficients = field.zero.coefficients;
                        else {
                            this.coefficients = new Uint8ClampedArray(coefficientsLength - firstNonZero);
                            for(var i = 0; i < this.coefficients.length; i++)this.coefficients[i] = coefficients[firstNonZero + i];
                        }
                    } else this.coefficients = coefficients;
                }
                GenericGFPoly.prototype.degree = function() {
                    return this.coefficients.length - 1;
                };
                GenericGFPoly.prototype.isZero = function() {
                    return this.coefficients[0] === 0;
                };
                GenericGFPoly.prototype.getCoefficient = function(degree) {
                    return this.coefficients[this.coefficients.length - 1 - degree];
                };
                GenericGFPoly.prototype.addOrSubtract = function(other) {
                    var _a;
                    if (this.isZero()) return other;
                    if (other.isZero()) return this;
                    var smallerCoefficients = this.coefficients;
                    var largerCoefficients = other.coefficients;
                    if (smallerCoefficients.length > largerCoefficients.length) _a = [
                        largerCoefficients,
                        smallerCoefficients
                    ], smallerCoefficients = _a[0], largerCoefficients = _a[1];
                    var sumDiff = new Uint8ClampedArray(largerCoefficients.length);
                    var lengthDiff = largerCoefficients.length - smallerCoefficients.length;
                    for(var i = 0; i < lengthDiff; i++)sumDiff[i] = largerCoefficients[i];
                    for(var i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = GenericGF_1.addOrSubtractGF(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
                    return new GenericGFPoly(this.field, sumDiff);
                };
                GenericGFPoly.prototype.multiply = function(scalar) {
                    if (scalar === 0) return this.field.zero;
                    if (scalar === 1) return this;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyPoly = function(other) {
                    if (this.isZero() || other.isZero()) return this.field.zero;
                    var aCoefficients = this.coefficients;
                    var aLength = aCoefficients.length;
                    var bCoefficients = other.coefficients;
                    var bLength = bCoefficients.length;
                    var product = new Uint8ClampedArray(aLength + bLength - 1);
                    for(var i = 0; i < aLength; i++){
                        var aCoeff = aCoefficients[i];
                        for(var j = 0; j < bLength; j++)product[i + j] = GenericGF_1.addOrSubtractGF(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
                    }
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.multiplyByMonomial = function(degree, coefficient) {
                    if (degree < 0) throw new Error("Invalid degree less than 0");
                    if (coefficient === 0) return this.field.zero;
                    var size = this.coefficients.length;
                    var product = new Uint8ClampedArray(size + degree);
                    for(var i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
                    return new GenericGFPoly(this.field, product);
                };
                GenericGFPoly.prototype.evaluateAt = function(a) {
                    var result = 0;
                    if (a === 0) // Just return the x^0 coefficient
                    return this.getCoefficient(0);
                    var size = this.coefficients.length;
                    if (a === 1) {
                        // Just the sum of the coefficients
                        this.coefficients.forEach(function(coefficient) {
                            result = GenericGF_1.addOrSubtractGF(result, coefficient);
                        });
                        return result;
                    }
                    result = this.coefficients[0];
                    for(var i = 1; i < size; i++)result = GenericGF_1.addOrSubtractGF(this.field.multiply(a, result), this.coefficients[i]);
                    return result;
                };
                return GenericGFPoly;
            }();
            exports.default = GenericGFPoly;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var binarizer_1 = __webpack_require__(4);
            var decoder_1 = __webpack_require__(5);
            var extractor_1 = __webpack_require__(11);
            var locator_1 = __webpack_require__(12);
            function scan(matrix) {
                var locations = locator_1.locate(matrix);
                if (!locations) return null;
                for(var _i = 0, locations_1 = locations; _i < locations_1.length; _i++){
                    var location_1 = locations_1[_i];
                    var extracted = extractor_1.extract(matrix, location_1);
                    var decoded = decoder_1.decode(extracted.matrix);
                    if (decoded) return {
                        binaryData: decoded.bytes,
                        data: decoded.text,
                        chunks: decoded.chunks,
                        version: decoded.version,
                        location: {
                            topRightCorner: extracted.mappingFunction(location_1.dimension, 0),
                            topLeftCorner: extracted.mappingFunction(0, 0),
                            bottomRightCorner: extracted.mappingFunction(location_1.dimension, location_1.dimension),
                            bottomLeftCorner: extracted.mappingFunction(0, location_1.dimension),
                            topRightFinderPattern: location_1.topRight,
                            topLeftFinderPattern: location_1.topLeft,
                            bottomLeftFinderPattern: location_1.bottomLeft,
                            bottomRightAlignmentPattern: location_1.alignmentPattern
                        }
                    };
                }
                return null;
            }
            var defaultOptions = {
                inversionAttempts: "attemptBoth"
            };
            function jsQR(data, width, height, providedOptions) {
                if (providedOptions === void 0) providedOptions = {};
                var options = defaultOptions;
                Object.keys(options || {}).forEach(function(opt) {
                    options[opt] = providedOptions[opt] || options[opt];
                });
                var shouldInvert = options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst";
                var tryInvertedFirst = options.inversionAttempts === "onlyInvert" || options.inversionAttempts === "invertFirst";
                var _a = binarizer_1.binarize(data, width, height, shouldInvert), binarized = _a.binarized, inverted = _a.inverted;
                var result = scan(tryInvertedFirst ? inverted : binarized);
                if (!result && (options.inversionAttempts === "attemptBoth" || options.inversionAttempts === "invertFirst")) result = scan(tryInvertedFirst ? binarized : inverted);
                return result;
            }
            jsQR.default = jsQR;
            exports.default = jsQR;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var REGION_SIZE = 8;
            var MIN_DYNAMIC_RANGE = 24;
            function numBetween(value, min, max) {
                return value < min ? min : value > max ? max : value;
            }
            // Like BitMatrix but accepts arbitry Uint8 values
            var Matrix = /** @class */ function() {
                function Matrix(width, height) {
                    this.width = width;
                    this.data = new Uint8ClampedArray(width * height);
                }
                Matrix.prototype.get = function(x, y) {
                    return this.data[y * this.width + x];
                };
                Matrix.prototype.set = function(x, y, value) {
                    this.data[y * this.width + x] = value;
                };
                return Matrix;
            }();
            function binarize(data, width, height, returnInverted) {
                if (data.length !== width * height * 4) throw new Error("Malformed data passed to binarizer.");
                // Convert image to greyscale
                var greyscalePixels = new Matrix(width, height);
                for(var x = 0; x < width; x++)for(var y = 0; y < height; y++){
                    var r = data[(y * width + x) * 4 + 0];
                    var g = data[(y * width + x) * 4 + 1];
                    var b = data[(y * width + x) * 4 + 2];
                    greyscalePixels.set(x, y, 0.2126 * r + 0.7152 * g + 0.0722 * b);
                }
                var horizontalRegionCount = Math.ceil(width / REGION_SIZE);
                var verticalRegionCount = Math.ceil(height / REGION_SIZE);
                var blackPoints = new Matrix(horizontalRegionCount, verticalRegionCount);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var sum = 0;
                    var min = Infinity;
                    var max = 0;
                    for(var y = 0; y < REGION_SIZE; y++)for(var x = 0; x < REGION_SIZE; x++){
                        var pixelLumosity = greyscalePixels.get(hortizontalRegion * REGION_SIZE + x, verticalRegion * REGION_SIZE + y);
                        sum += pixelLumosity;
                        min = Math.min(min, pixelLumosity);
                        max = Math.max(max, pixelLumosity);
                    }
                    var average = sum / Math.pow(REGION_SIZE, 2);
                    if (max - min <= MIN_DYNAMIC_RANGE) {
                        // If variation within the block is low, assume this is a block with only light or only
                        // dark pixels. In that case we do not want to use the average, as it would divide this
                        // low contrast area into black and white pixels, essentially creating data out of noise.
                        //
                        // Default the blackpoint for these blocks to be half the min - effectively white them out
                        average = min / 2;
                        if (verticalRegion > 0 && hortizontalRegion > 0) {
                            // Correct the "white background" assumption for blocks that have neighbors by comparing
                            // the pixels in this block to the previously calculated black points. This is based on
                            // the fact that dark barcode symbology is always surrounded by some amount of light
                            // background for which reasonable black point estimates were made. The bp estimated at
                            // the boundaries is used for the interior.
                            // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                            var averageNeighborBlackPoint = (blackPoints.get(hortizontalRegion, verticalRegion - 1) + 2 * blackPoints.get(hortizontalRegion - 1, verticalRegion) + blackPoints.get(hortizontalRegion - 1, verticalRegion - 1)) / 4;
                            if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                        }
                    }
                    blackPoints.set(hortizontalRegion, verticalRegion, average);
                }
                var binarized = BitMatrix_1.BitMatrix.createEmpty(width, height);
                var inverted = null;
                if (returnInverted) inverted = BitMatrix_1.BitMatrix.createEmpty(width, height);
                for(var verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(var hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
                    var left = numBetween(hortizontalRegion, 2, horizontalRegionCount - 3);
                    var top_1 = numBetween(verticalRegion, 2, verticalRegionCount - 3);
                    var sum = 0;
                    for(var xRegion = -2; xRegion <= 2; xRegion++)for(var yRegion = -2; yRegion <= 2; yRegion++)sum += blackPoints.get(left + xRegion, top_1 + yRegion);
                    var threshold = sum / 25;
                    for(var xRegion = 0; xRegion < REGION_SIZE; xRegion++)for(var yRegion = 0; yRegion < REGION_SIZE; yRegion++){
                        var x = hortizontalRegion * REGION_SIZE + xRegion;
                        var y = verticalRegion * REGION_SIZE + yRegion;
                        var lum = greyscalePixels.get(x, y);
                        binarized.set(x, y, lum <= threshold);
                        if (returnInverted) inverted.set(x, y, !(lum <= threshold));
                    }
                }
                if (returnInverted) return {
                    binarized: binarized,
                    inverted: inverted
                };
                return {
                    binarized: binarized
                };
            }
            exports.binarize = binarize;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            var decodeData_1 = __webpack_require__(6);
            var reedsolomon_1 = __webpack_require__(9);
            var version_1 = __webpack_require__(10);
            // tslint:disable:no-bitwise
            function numBitsDiffering(x, y) {
                var z = x ^ y;
                var bitCount = 0;
                while(z){
                    bitCount++;
                    z &= z - 1;
                }
                return bitCount;
            }
            function pushBit(bit, byte) {
                return byte << 1 | bit;
            }
            // tslint:enable:no-bitwise
            var FORMAT_INFO_TABLE = [
                {
                    bits: 0x5412,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x5125,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x5E7C,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x5B4B,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x45F9,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x40CE,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x4F97,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x4AA0,
                    formatInfo: {
                        errorCorrectionLevel: 1,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x77C4,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x72F3,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x7DAA,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x789D,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x662F,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x6318,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x6C41,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x6976,
                    formatInfo: {
                        errorCorrectionLevel: 0,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x1689,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x13BE,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x1CE7,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x19D0,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x0762,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x0255,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x0D0C,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x083B,
                    formatInfo: {
                        errorCorrectionLevel: 3,
                        dataMask: 7
                    }
                },
                {
                    bits: 0x355F,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 0
                    }
                },
                {
                    bits: 0x3068,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 1
                    }
                },
                {
                    bits: 0x3F31,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 2
                    }
                },
                {
                    bits: 0x3A06,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 3
                    }
                },
                {
                    bits: 0x24B4,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 4
                    }
                },
                {
                    bits: 0x2183,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 5
                    }
                },
                {
                    bits: 0x2EDA,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 6
                    }
                },
                {
                    bits: 0x2BED,
                    formatInfo: {
                        errorCorrectionLevel: 2,
                        dataMask: 7
                    }
                }
            ];
            var DATA_MASKS = [
                function(p) {
                    return (p.y + p.x) % 2 === 0;
                },
                function(p) {
                    return p.y % 2 === 0;
                },
                function(p) {
                    return p.x % 3 === 0;
                },
                function(p) {
                    return (p.y + p.x) % 3 === 0;
                },
                function(p) {
                    return (Math.floor(p.y / 2) + Math.floor(p.x / 3)) % 2 === 0;
                },
                function(p) {
                    return p.x * p.y % 2 + p.x * p.y % 3 === 0;
                },
                function(p) {
                    return (p.y * p.x % 2 + p.y * p.x % 3) % 2 === 0;
                },
                function(p) {
                    return ((p.y + p.x) % 2 + p.y * p.x % 3) % 2 === 0;
                }
            ];
            function buildFunctionPatternMask(version) {
                var dimension = 17 + 4 * version.versionNumber;
                var matrix = BitMatrix_1.BitMatrix.createEmpty(dimension, dimension);
                matrix.setRegion(0, 0, 9, 9, true); // Top left finder pattern + separator + format
                matrix.setRegion(dimension - 8, 0, 8, 9, true); // Top right finder pattern + separator + format
                matrix.setRegion(0, dimension - 8, 9, 8, true); // Bottom left finder pattern + separator + format
                // Alignment patterns
                for(var _i = 0, _a = version.alignmentPatternCenters; _i < _a.length; _i++){
                    var x = _a[_i];
                    for(var _b = 0, _c = version.alignmentPatternCenters; _b < _c.length; _b++){
                        var y = _c[_b];
                        if (!(x === 6 && y === 6 || x === 6 && y === dimension - 7 || x === dimension - 7 && y === 6)) matrix.setRegion(x - 2, y - 2, 5, 5, true);
                    }
                }
                matrix.setRegion(6, 9, 1, dimension - 17, true); // Vertical timing pattern
                matrix.setRegion(9, 6, dimension - 17, 1, true); // Horizontal timing pattern
                if (version.versionNumber > 6) {
                    matrix.setRegion(dimension - 11, 0, 3, 6, true); // Version info, top right
                    matrix.setRegion(0, dimension - 11, 6, 3, true); // Version info, bottom left
                }
                return matrix;
            }
            function readCodewords(matrix, version, formatInfo) {
                var dataMask = DATA_MASKS[formatInfo.dataMask];
                var dimension = matrix.height;
                var functionPatternMask = buildFunctionPatternMask(version);
                var codewords = [];
                var currentByte = 0;
                var bitsRead = 0;
                // Read columns in pairs, from right to left
                var readingUp = true;
                for(var columnIndex = dimension - 1; columnIndex > 0; columnIndex -= 2){
                    if (columnIndex === 6) columnIndex--;
                    for(var i = 0; i < dimension; i++){
                        var y = readingUp ? dimension - 1 - i : i;
                        for(var columnOffset = 0; columnOffset < 2; columnOffset++){
                            var x = columnIndex - columnOffset;
                            if (!functionPatternMask.get(x, y)) {
                                bitsRead++;
                                var bit = matrix.get(x, y);
                                if (dataMask({
                                    y: y,
                                    x: x
                                })) bit = !bit;
                                currentByte = pushBit(bit, currentByte);
                                if (bitsRead === 8) {
                                    codewords.push(currentByte);
                                    bitsRead = 0;
                                    currentByte = 0;
                                }
                            }
                        }
                    }
                    readingUp = !readingUp;
                }
                return codewords;
            }
            function readVersion(matrix) {
                var dimension = matrix.height;
                var provisionalVersion = Math.floor((dimension - 17) / 4);
                if (provisionalVersion <= 6) return version_1.VERSIONS[provisionalVersion - 1];
                var topRightVersionBits = 0;
                for(var y = 5; y >= 0; y--)for(var x = dimension - 9; x >= dimension - 11; x--)topRightVersionBits = pushBit(matrix.get(x, y), topRightVersionBits);
                var bottomLeftVersionBits = 0;
                for(var x = 5; x >= 0; x--)for(var y = dimension - 9; y >= dimension - 11; y--)bottomLeftVersionBits = pushBit(matrix.get(x, y), bottomLeftVersionBits);
                var bestDifference = Infinity;
                var bestVersion;
                for(var _i = 0, VERSIONS_1 = version_1.VERSIONS; _i < VERSIONS_1.length; _i++){
                    var version = VERSIONS_1[_i];
                    if (version.infoBits === topRightVersionBits || version.infoBits === bottomLeftVersionBits) return version;
                    var difference = numBitsDiffering(topRightVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                    difference = numBitsDiffering(bottomLeftVersionBits, version.infoBits);
                    if (difference < bestDifference) {
                        bestVersion = version;
                        bestDifference = difference;
                    }
                }
                // We can tolerate up to 3 bits of error since no two version info codewords will
                // differ in less than 8 bits.
                if (bestDifference <= 3) return bestVersion;
            }
            function readFormatInformation(matrix) {
                var topLeftFormatInfoBits = 0;
                for(var x = 0; x <= 8; x++)if (x !== 6) topLeftFormatInfoBits = pushBit(matrix.get(x, 8), topLeftFormatInfoBits);
                for(var y = 7; y >= 0; y--)if (y !== 6) topLeftFormatInfoBits = pushBit(matrix.get(8, y), topLeftFormatInfoBits);
                var dimension = matrix.height;
                var topRightBottomRightFormatInfoBits = 0;
                for(var y = dimension - 1; y >= dimension - 7; y--)topRightBottomRightFormatInfoBits = pushBit(matrix.get(8, y), topRightBottomRightFormatInfoBits);
                for(var x = dimension - 8; x < dimension; x++)topRightBottomRightFormatInfoBits = pushBit(matrix.get(x, 8), topRightBottomRightFormatInfoBits);
                var bestDifference = Infinity;
                var bestFormatInfo = null;
                for(var _i = 0, FORMAT_INFO_TABLE_1 = FORMAT_INFO_TABLE; _i < FORMAT_INFO_TABLE_1.length; _i++){
                    var _a = FORMAT_INFO_TABLE_1[_i], bits = _a.bits, formatInfo = _a.formatInfo;
                    if (bits === topLeftFormatInfoBits || bits === topRightBottomRightFormatInfoBits) return formatInfo;
                    var difference = numBitsDiffering(topLeftFormatInfoBits, bits);
                    if (difference < bestDifference) {
                        bestFormatInfo = formatInfo;
                        bestDifference = difference;
                    }
                    if (topLeftFormatInfoBits !== topRightBottomRightFormatInfoBits) {
                        difference = numBitsDiffering(topRightBottomRightFormatInfoBits, bits);
                        if (difference < bestDifference) {
                            bestFormatInfo = formatInfo;
                            bestDifference = difference;
                        }
                    }
                }
                // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits differing means we found a match
                if (bestDifference <= 3) return bestFormatInfo;
                return null;
            }
            function getDataBlocks(codewords, version, ecLevel) {
                var ecInfo = version.errorCorrectionLevels[ecLevel];
                var dataBlocks = [];
                var totalCodewords = 0;
                ecInfo.ecBlocks.forEach(function(block) {
                    for(var i = 0; i < block.numBlocks; i++){
                        dataBlocks.push({
                            numDataCodewords: block.dataCodewordsPerBlock,
                            codewords: []
                        });
                        totalCodewords += block.dataCodewordsPerBlock + ecInfo.ecCodewordsPerBlock;
                    }
                });
                // In some cases the QR code will be malformed enough that we pull off more or less than we should.
                // If we pull off less there's nothing we can do.
                // If we pull off more we can safely truncate
                if (codewords.length < totalCodewords) return null;
                codewords = codewords.slice(0, totalCodewords);
                var shortBlockSize = ecInfo.ecBlocks[0].dataCodewordsPerBlock;
                // Pull codewords to fill the blocks up to the minimum size
                for(var i = 0; i < shortBlockSize; i++)for(var _i = 0, dataBlocks_1 = dataBlocks; _i < dataBlocks_1.length; _i++){
                    var dataBlock = dataBlocks_1[_i];
                    dataBlock.codewords.push(codewords.shift());
                }
                // If there are any large blocks, pull codewords to fill the last element of those
                if (ecInfo.ecBlocks.length > 1) {
                    var smallBlockCount = ecInfo.ecBlocks[0].numBlocks;
                    var largeBlockCount = ecInfo.ecBlocks[1].numBlocks;
                    for(var i = 0; i < largeBlockCount; i++)dataBlocks[smallBlockCount + i].codewords.push(codewords.shift());
                }
                // Add the rest of the codewords to the blocks. These are the error correction codewords.
                while(codewords.length > 0)for(var _a = 0, dataBlocks_2 = dataBlocks; _a < dataBlocks_2.length; _a++){
                    var dataBlock = dataBlocks_2[_a];
                    dataBlock.codewords.push(codewords.shift());
                }
                return dataBlocks;
            }
            function decodeMatrix(matrix) {
                var version = readVersion(matrix);
                if (!version) return null;
                var formatInfo = readFormatInformation(matrix);
                if (!formatInfo) return null;
                var codewords = readCodewords(matrix, version, formatInfo);
                var dataBlocks = getDataBlocks(codewords, version, formatInfo.errorCorrectionLevel);
                if (!dataBlocks) return null;
                // Count total number of data bytes
                var totalBytes = dataBlocks.reduce(function(a, b) {
                    return a + b.numDataCodewords;
                }, 0);
                var resultBytes = new Uint8ClampedArray(totalBytes);
                var resultIndex = 0;
                for(var _i = 0, dataBlocks_3 = dataBlocks; _i < dataBlocks_3.length; _i++){
                    var dataBlock = dataBlocks_3[_i];
                    var correctedBytes = reedsolomon_1.decode(dataBlock.codewords, dataBlock.codewords.length - dataBlock.numDataCodewords);
                    if (!correctedBytes) return null;
                    for(var i = 0; i < dataBlock.numDataCodewords; i++)resultBytes[resultIndex++] = correctedBytes[i];
                }
                try {
                    return decodeData_1.decode(resultBytes, version.versionNumber);
                } catch (_a) {
                    return null;
                }
            }
            function decode(matrix) {
                if (matrix == null) return null;
                var result = decodeMatrix(matrix);
                if (result) return result;
                // Decoding didn't work, try mirroring the QR across the topLeft -> bottomRight line.
                for(var x = 0; x < matrix.width; x++){
                    for(var y = x + 1; y < matrix.height; y++)if (matrix.get(x, y) !== matrix.get(y, x)) {
                        matrix.set(x, y, !matrix.get(x, y));
                        matrix.set(y, x, !matrix.get(y, x));
                    }
                }
                return decodeMatrix(matrix);
            }
            exports.decode = decode;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            // tslint:disable:no-bitwise
            var BitStream_1 = __webpack_require__(7);
            var shiftJISTable_1 = __webpack_require__(8);
            var Mode;
            (function(Mode) {
                Mode["Numeric"] = "numeric";
                Mode["Alphanumeric"] = "alphanumeric";
                Mode["Byte"] = "byte";
                Mode["Kanji"] = "kanji";
                Mode["ECI"] = "eci";
            })(Mode = exports.Mode || (exports.Mode = {}));
            var ModeByte;
            (function(ModeByte) {
                ModeByte[ModeByte["Terminator"] = 0] = "Terminator";
                ModeByte[ModeByte["Numeric"] = 1] = "Numeric";
                ModeByte[ModeByte["Alphanumeric"] = 2] = "Alphanumeric";
                ModeByte[ModeByte["Byte"] = 4] = "Byte";
                ModeByte[ModeByte["Kanji"] = 8] = "Kanji";
                ModeByte[ModeByte["ECI"] = 7] = "ECI";
            // StructuredAppend = 0x3,
            // FNC1FirstPosition = 0x5,
            // FNC1SecondPosition = 0x9,
            })(ModeByte || (ModeByte = {}));
            function decodeNumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    10,
                    12,
                    14
                ][size];
                var length = stream.readBits(characterCountSize);
                // Read digits in groups of 3
                while(length >= 3){
                    var num = stream.readBits(10);
                    if (num >= 1000) throw new Error("Invalid numeric value above 999");
                    var a = Math.floor(num / 100);
                    var b = Math.floor(num / 10) % 10;
                    var c = num % 10;
                    bytes.push(48 + a, 48 + b, 48 + c);
                    text += a.toString() + b.toString() + c.toString();
                    length -= 3;
                }
                // If the number of digits aren't a multiple of 3, the remaining digits are special cased.
                if (length === 2) {
                    var num = stream.readBits(7);
                    if (num >= 100) throw new Error("Invalid numeric value above 99");
                    var a = Math.floor(num / 10);
                    var b = num % 10;
                    bytes.push(48 + a, 48 + b);
                    text += a.toString() + b.toString();
                } else if (length === 1) {
                    var num = stream.readBits(4);
                    if (num >= 10) throw new Error("Invalid numeric value above 9");
                    bytes.push(48 + num);
                    text += num.toString();
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            var AlphanumericCharacterCodes = [
                "0",
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
                " ",
                "$",
                "%",
                "*",
                "+",
                "-",
                ".",
                "/",
                ":"
            ];
            function decodeAlphanumeric(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    9,
                    11,
                    13
                ][size];
                var length = stream.readBits(characterCountSize);
                while(length >= 2){
                    var v = stream.readBits(11);
                    var a = Math.floor(v / 45);
                    var b = v % 45;
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0), AlphanumericCharacterCodes[b].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a] + AlphanumericCharacterCodes[b];
                    length -= 2;
                }
                if (length === 1) {
                    var a = stream.readBits(6);
                    bytes.push(AlphanumericCharacterCodes[a].charCodeAt(0));
                    text += AlphanumericCharacterCodes[a];
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeByte(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    16,
                    16
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var b = stream.readBits(8);
                    bytes.push(b);
                }
                try {
                    text += decodeURIComponent(bytes.map(function(b) {
                        return "%" + ("0" + b.toString(16)).substr(-2);
                    }).join(""));
                } catch (_a) {
                // failed to decode
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decodeKanji(stream, size) {
                var bytes = [];
                var text = "";
                var characterCountSize = [
                    8,
                    10,
                    12
                ][size];
                var length = stream.readBits(characterCountSize);
                for(var i = 0; i < length; i++){
                    var k = stream.readBits(13);
                    var c = Math.floor(k / 0xC0) << 8 | k % 0xC0;
                    if (c < 0x1F00) c += 0x8140;
                    else c += 0xC140;
                    bytes.push(c >> 8, c & 0xFF);
                    text += String.fromCharCode(shiftJISTable_1.shiftJISTable[c]);
                }
                return {
                    bytes: bytes,
                    text: text
                };
            }
            function decode(data, version) {
                var _a, _b, _c, _d;
                var stream = new BitStream_1.BitStream(data);
                // There are 3 'sizes' based on the version. 1-9 is small (0), 10-26 is medium (1) and 27-40 is large (2).
                var size = version <= 9 ? 0 : version <= 26 ? 1 : 2;
                var result = {
                    text: "",
                    bytes: [],
                    chunks: [],
                    version: version
                };
                while(stream.available() >= 4){
                    var mode = stream.readBits(4);
                    if (mode === ModeByte.Terminator) return result;
                    else if (mode === ModeByte.ECI) {
                        if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(7)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(14)
                        });
                        else if (stream.readBits(1) === 0) result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: stream.readBits(21)
                        });
                        else // ECI data seems corrupted
                        result.chunks.push({
                            type: Mode.ECI,
                            assignmentNumber: -1
                        });
                    } else if (mode === ModeByte.Numeric) {
                        var numericResult = decodeNumeric(stream, size);
                        result.text += numericResult.text;
                        (_a = result.bytes).push.apply(_a, numericResult.bytes);
                        result.chunks.push({
                            type: Mode.Numeric,
                            text: numericResult.text
                        });
                    } else if (mode === ModeByte.Alphanumeric) {
                        var alphanumericResult = decodeAlphanumeric(stream, size);
                        result.text += alphanumericResult.text;
                        (_b = result.bytes).push.apply(_b, alphanumericResult.bytes);
                        result.chunks.push({
                            type: Mode.Alphanumeric,
                            text: alphanumericResult.text
                        });
                    } else if (mode === ModeByte.Byte) {
                        var byteResult = decodeByte(stream, size);
                        result.text += byteResult.text;
                        (_c = result.bytes).push.apply(_c, byteResult.bytes);
                        result.chunks.push({
                            type: Mode.Byte,
                            bytes: byteResult.bytes,
                            text: byteResult.text
                        });
                    } else if (mode === ModeByte.Kanji) {
                        var kanjiResult = decodeKanji(stream, size);
                        result.text += kanjiResult.text;
                        (_d = result.bytes).push.apply(_d, kanjiResult.bytes);
                        result.chunks.push({
                            type: Mode.Kanji,
                            bytes: kanjiResult.bytes,
                            text: kanjiResult.text
                        });
                    }
                }
                // If there is no data left, or the remaining bits are all 0, then that counts as a termination marker
                if (stream.available() === 0 || stream.readBits(stream.available()) === 0) return result;
            }
            exports.decode = decode;
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // tslint:disable:no-bitwise
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitStream = /** @class */ function() {
                function BitStream(bytes) {
                    this.byteOffset = 0;
                    this.bitOffset = 0;
                    this.bytes = bytes;
                }
                BitStream.prototype.readBits = function(numBits) {
                    if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new Error("Cannot read " + numBits.toString() + " bits");
                    var result = 0;
                    // First, read remainder from current byte
                    if (this.bitOffset > 0) {
                        var bitsLeft = 8 - this.bitOffset;
                        var toRead = numBits < bitsLeft ? numBits : bitsLeft;
                        var bitsToNotRead = bitsLeft - toRead;
                        var mask = 0xFF >> 8 - toRead << bitsToNotRead;
                        result = (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                        numBits -= toRead;
                        this.bitOffset += toRead;
                        if (this.bitOffset === 8) {
                            this.bitOffset = 0;
                            this.byteOffset++;
                        }
                    }
                    // Next read whole bytes
                    if (numBits > 0) {
                        while(numBits >= 8){
                            result = result << 8 | this.bytes[this.byteOffset] & 0xFF;
                            this.byteOffset++;
                            numBits -= 8;
                        }
                        // Finally read a partial byte
                        if (numBits > 0) {
                            var bitsToNotRead = 8 - numBits;
                            var mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                            result = result << numBits | (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                            this.bitOffset += numBits;
                        }
                    }
                    return result;
                };
                BitStream.prototype.available = function() {
                    return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
                };
                return BitStream;
            }();
            exports.BitStream = BitStream;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.shiftJISTable = {
                0x20: 0x0020,
                0x21: 0x0021,
                0x22: 0x0022,
                0x23: 0x0023,
                0x24: 0x0024,
                0x25: 0x0025,
                0x26: 0x0026,
                0x27: 0x0027,
                0x28: 0x0028,
                0x29: 0x0029,
                0x2A: 0x002A,
                0x2B: 0x002B,
                0x2C: 0x002C,
                0x2D: 0x002D,
                0x2E: 0x002E,
                0x2F: 0x002F,
                0x30: 0x0030,
                0x31: 0x0031,
                0x32: 0x0032,
                0x33: 0x0033,
                0x34: 0x0034,
                0x35: 0x0035,
                0x36: 0x0036,
                0x37: 0x0037,
                0x38: 0x0038,
                0x39: 0x0039,
                0x3A: 0x003A,
                0x3B: 0x003B,
                0x3C: 0x003C,
                0x3D: 0x003D,
                0x3E: 0x003E,
                0x3F: 0x003F,
                0x40: 0x0040,
                0x41: 0x0041,
                0x42: 0x0042,
                0x43: 0x0043,
                0x44: 0x0044,
                0x45: 0x0045,
                0x46: 0x0046,
                0x47: 0x0047,
                0x48: 0x0048,
                0x49: 0x0049,
                0x4A: 0x004A,
                0x4B: 0x004B,
                0x4C: 0x004C,
                0x4D: 0x004D,
                0x4E: 0x004E,
                0x4F: 0x004F,
                0x50: 0x0050,
                0x51: 0x0051,
                0x52: 0x0052,
                0x53: 0x0053,
                0x54: 0x0054,
                0x55: 0x0055,
                0x56: 0x0056,
                0x57: 0x0057,
                0x58: 0x0058,
                0x59: 0x0059,
                0x5A: 0x005A,
                0x5B: 0x005B,
                0x5C: 0x00A5,
                0x5D: 0x005D,
                0x5E: 0x005E,
                0x5F: 0x005F,
                0x60: 0x0060,
                0x61: 0x0061,
                0x62: 0x0062,
                0x63: 0x0063,
                0x64: 0x0064,
                0x65: 0x0065,
                0x66: 0x0066,
                0x67: 0x0067,
                0x68: 0x0068,
                0x69: 0x0069,
                0x6A: 0x006A,
                0x6B: 0x006B,
                0x6C: 0x006C,
                0x6D: 0x006D,
                0x6E: 0x006E,
                0x6F: 0x006F,
                0x70: 0x0070,
                0x71: 0x0071,
                0x72: 0x0072,
                0x73: 0x0073,
                0x74: 0x0074,
                0x75: 0x0075,
                0x76: 0x0076,
                0x77: 0x0077,
                0x78: 0x0078,
                0x79: 0x0079,
                0x7A: 0x007A,
                0x7B: 0x007B,
                0x7C: 0x007C,
                0x7D: 0x007D,
                0x7E: 0x203E,
                0x8140: 0x3000,
                0x8141: 0x3001,
                0x8142: 0x3002,
                0x8143: 0xFF0C,
                0x8144: 0xFF0E,
                0x8145: 0x30FB,
                0x8146: 0xFF1A,
                0x8147: 0xFF1B,
                0x8148: 0xFF1F,
                0x8149: 0xFF01,
                0x814A: 0x309B,
                0x814B: 0x309C,
                0x814C: 0x00B4,
                0x814D: 0xFF40,
                0x814E: 0x00A8,
                0x814F: 0xFF3E,
                0x8150: 0xFFE3,
                0x8151: 0xFF3F,
                0x8152: 0x30FD,
                0x8153: 0x30FE,
                0x8154: 0x309D,
                0x8155: 0x309E,
                0x8156: 0x3003,
                0x8157: 0x4EDD,
                0x8158: 0x3005,
                0x8159: 0x3006,
                0x815A: 0x3007,
                0x815B: 0x30FC,
                0x815C: 0x2015,
                0x815D: 0x2010,
                0x815E: 0xFF0F,
                0x815F: 0x005C,
                0x8160: 0x301C,
                0x8161: 0x2016,
                0x8162: 0xFF5C,
                0x8163: 0x2026,
                0x8164: 0x2025,
                0x8165: 0x2018,
                0x8166: 0x2019,
                0x8167: 0x201C,
                0x8168: 0x201D,
                0x8169: 0xFF08,
                0x816A: 0xFF09,
                0x816B: 0x3014,
                0x816C: 0x3015,
                0x816D: 0xFF3B,
                0x816E: 0xFF3D,
                0x816F: 0xFF5B,
                0x8170: 0xFF5D,
                0x8171: 0x3008,
                0x8172: 0x3009,
                0x8173: 0x300A,
                0x8174: 0x300B,
                0x8175: 0x300C,
                0x8176: 0x300D,
                0x8177: 0x300E,
                0x8178: 0x300F,
                0x8179: 0x3010,
                0x817A: 0x3011,
                0x817B: 0xFF0B,
                0x817C: 0x2212,
                0x817D: 0x00B1,
                0x817E: 0x00D7,
                0x8180: 0x00F7,
                0x8181: 0xFF1D,
                0x8182: 0x2260,
                0x8183: 0xFF1C,
                0x8184: 0xFF1E,
                0x8185: 0x2266,
                0x8186: 0x2267,
                0x8187: 0x221E,
                0x8188: 0x2234,
                0x8189: 0x2642,
                0x818A: 0x2640,
                0x818B: 0x00B0,
                0x818C: 0x2032,
                0x818D: 0x2033,
                0x818E: 0x2103,
                0x818F: 0xFFE5,
                0x8190: 0xFF04,
                0x8191: 0x00A2,
                0x8192: 0x00A3,
                0x8193: 0xFF05,
                0x8194: 0xFF03,
                0x8195: 0xFF06,
                0x8196: 0xFF0A,
                0x8197: 0xFF20,
                0x8198: 0x00A7,
                0x8199: 0x2606,
                0x819A: 0x2605,
                0x819B: 0x25CB,
                0x819C: 0x25CF,
                0x819D: 0x25CE,
                0x819E: 0x25C7,
                0x819F: 0x25C6,
                0x81A0: 0x25A1,
                0x81A1: 0x25A0,
                0x81A2: 0x25B3,
                0x81A3: 0x25B2,
                0x81A4: 0x25BD,
                0x81A5: 0x25BC,
                0x81A6: 0x203B,
                0x81A7: 0x3012,
                0x81A8: 0x2192,
                0x81A9: 0x2190,
                0x81AA: 0x2191,
                0x81AB: 0x2193,
                0x81AC: 0x3013,
                0x81B8: 0x2208,
                0x81B9: 0x220B,
                0x81BA: 0x2286,
                0x81BB: 0x2287,
                0x81BC: 0x2282,
                0x81BD: 0x2283,
                0x81BE: 0x222A,
                0x81BF: 0x2229,
                0x81C8: 0x2227,
                0x81C9: 0x2228,
                0x81CA: 0x00AC,
                0x81CB: 0x21D2,
                0x81CC: 0x21D4,
                0x81CD: 0x2200,
                0x81CE: 0x2203,
                0x81DA: 0x2220,
                0x81DB: 0x22A5,
                0x81DC: 0x2312,
                0x81DD: 0x2202,
                0x81DE: 0x2207,
                0x81DF: 0x2261,
                0x81E0: 0x2252,
                0x81E1: 0x226A,
                0x81E2: 0x226B,
                0x81E3: 0x221A,
                0x81E4: 0x223D,
                0x81E5: 0x221D,
                0x81E6: 0x2235,
                0x81E7: 0x222B,
                0x81E8: 0x222C,
                0x81F0: 0x212B,
                0x81F1: 0x2030,
                0x81F2: 0x266F,
                0x81F3: 0x266D,
                0x81F4: 0x266A,
                0x81F5: 0x2020,
                0x81F6: 0x2021,
                0x81F7: 0x00B6,
                0x81FC: 0x25EF,
                0x824F: 0xFF10,
                0x8250: 0xFF11,
                0x8251: 0xFF12,
                0x8252: 0xFF13,
                0x8253: 0xFF14,
                0x8254: 0xFF15,
                0x8255: 0xFF16,
                0x8256: 0xFF17,
                0x8257: 0xFF18,
                0x8258: 0xFF19,
                0x8260: 0xFF21,
                0x8261: 0xFF22,
                0x8262: 0xFF23,
                0x8263: 0xFF24,
                0x8264: 0xFF25,
                0x8265: 0xFF26,
                0x8266: 0xFF27,
                0x8267: 0xFF28,
                0x8268: 0xFF29,
                0x8269: 0xFF2A,
                0x826A: 0xFF2B,
                0x826B: 0xFF2C,
                0x826C: 0xFF2D,
                0x826D: 0xFF2E,
                0x826E: 0xFF2F,
                0x826F: 0xFF30,
                0x8270: 0xFF31,
                0x8271: 0xFF32,
                0x8272: 0xFF33,
                0x8273: 0xFF34,
                0x8274: 0xFF35,
                0x8275: 0xFF36,
                0x8276: 0xFF37,
                0x8277: 0xFF38,
                0x8278: 0xFF39,
                0x8279: 0xFF3A,
                0x8281: 0xFF41,
                0x8282: 0xFF42,
                0x8283: 0xFF43,
                0x8284: 0xFF44,
                0x8285: 0xFF45,
                0x8286: 0xFF46,
                0x8287: 0xFF47,
                0x8288: 0xFF48,
                0x8289: 0xFF49,
                0x828A: 0xFF4A,
                0x828B: 0xFF4B,
                0x828C: 0xFF4C,
                0x828D: 0xFF4D,
                0x828E: 0xFF4E,
                0x828F: 0xFF4F,
                0x8290: 0xFF50,
                0x8291: 0xFF51,
                0x8292: 0xFF52,
                0x8293: 0xFF53,
                0x8294: 0xFF54,
                0x8295: 0xFF55,
                0x8296: 0xFF56,
                0x8297: 0xFF57,
                0x8298: 0xFF58,
                0x8299: 0xFF59,
                0x829A: 0xFF5A,
                0x829F: 0x3041,
                0x82A0: 0x3042,
                0x82A1: 0x3043,
                0x82A2: 0x3044,
                0x82A3: 0x3045,
                0x82A4: 0x3046,
                0x82A5: 0x3047,
                0x82A6: 0x3048,
                0x82A7: 0x3049,
                0x82A8: 0x304A,
                0x82A9: 0x304B,
                0x82AA: 0x304C,
                0x82AB: 0x304D,
                0x82AC: 0x304E,
                0x82AD: 0x304F,
                0x82AE: 0x3050,
                0x82AF: 0x3051,
                0x82B0: 0x3052,
                0x82B1: 0x3053,
                0x82B2: 0x3054,
                0x82B3: 0x3055,
                0x82B4: 0x3056,
                0x82B5: 0x3057,
                0x82B6: 0x3058,
                0x82B7: 0x3059,
                0x82B8: 0x305A,
                0x82B9: 0x305B,
                0x82BA: 0x305C,
                0x82BB: 0x305D,
                0x82BC: 0x305E,
                0x82BD: 0x305F,
                0x82BE: 0x3060,
                0x82BF: 0x3061,
                0x82C0: 0x3062,
                0x82C1: 0x3063,
                0x82C2: 0x3064,
                0x82C3: 0x3065,
                0x82C4: 0x3066,
                0x82C5: 0x3067,
                0x82C6: 0x3068,
                0x82C7: 0x3069,
                0x82C8: 0x306A,
                0x82C9: 0x306B,
                0x82CA: 0x306C,
                0x82CB: 0x306D,
                0x82CC: 0x306E,
                0x82CD: 0x306F,
                0x82CE: 0x3070,
                0x82CF: 0x3071,
                0x82D0: 0x3072,
                0x82D1: 0x3073,
                0x82D2: 0x3074,
                0x82D3: 0x3075,
                0x82D4: 0x3076,
                0x82D5: 0x3077,
                0x82D6: 0x3078,
                0x82D7: 0x3079,
                0x82D8: 0x307A,
                0x82D9: 0x307B,
                0x82DA: 0x307C,
                0x82DB: 0x307D,
                0x82DC: 0x307E,
                0x82DD: 0x307F,
                0x82DE: 0x3080,
                0x82DF: 0x3081,
                0x82E0: 0x3082,
                0x82E1: 0x3083,
                0x82E2: 0x3084,
                0x82E3: 0x3085,
                0x82E4: 0x3086,
                0x82E5: 0x3087,
                0x82E6: 0x3088,
                0x82E7: 0x3089,
                0x82E8: 0x308A,
                0x82E9: 0x308B,
                0x82EA: 0x308C,
                0x82EB: 0x308D,
                0x82EC: 0x308E,
                0x82ED: 0x308F,
                0x82EE: 0x3090,
                0x82EF: 0x3091,
                0x82F0: 0x3092,
                0x82F1: 0x3093,
                0x8340: 0x30A1,
                0x8341: 0x30A2,
                0x8342: 0x30A3,
                0x8343: 0x30A4,
                0x8344: 0x30A5,
                0x8345: 0x30A6,
                0x8346: 0x30A7,
                0x8347: 0x30A8,
                0x8348: 0x30A9,
                0x8349: 0x30AA,
                0x834A: 0x30AB,
                0x834B: 0x30AC,
                0x834C: 0x30AD,
                0x834D: 0x30AE,
                0x834E: 0x30AF,
                0x834F: 0x30B0,
                0x8350: 0x30B1,
                0x8351: 0x30B2,
                0x8352: 0x30B3,
                0x8353: 0x30B4,
                0x8354: 0x30B5,
                0x8355: 0x30B6,
                0x8356: 0x30B7,
                0x8357: 0x30B8,
                0x8358: 0x30B9,
                0x8359: 0x30BA,
                0x835A: 0x30BB,
                0x835B: 0x30BC,
                0x835C: 0x30BD,
                0x835D: 0x30BE,
                0x835E: 0x30BF,
                0x835F: 0x30C0,
                0x8360: 0x30C1,
                0x8361: 0x30C2,
                0x8362: 0x30C3,
                0x8363: 0x30C4,
                0x8364: 0x30C5,
                0x8365: 0x30C6,
                0x8366: 0x30C7,
                0x8367: 0x30C8,
                0x8368: 0x30C9,
                0x8369: 0x30CA,
                0x836A: 0x30CB,
                0x836B: 0x30CC,
                0x836C: 0x30CD,
                0x836D: 0x30CE,
                0x836E: 0x30CF,
                0x836F: 0x30D0,
                0x8370: 0x30D1,
                0x8371: 0x30D2,
                0x8372: 0x30D3,
                0x8373: 0x30D4,
                0x8374: 0x30D5,
                0x8375: 0x30D6,
                0x8376: 0x30D7,
                0x8377: 0x30D8,
                0x8378: 0x30D9,
                0x8379: 0x30DA,
                0x837A: 0x30DB,
                0x837B: 0x30DC,
                0x837C: 0x30DD,
                0x837D: 0x30DE,
                0x837E: 0x30DF,
                0x8380: 0x30E0,
                0x8381: 0x30E1,
                0x8382: 0x30E2,
                0x8383: 0x30E3,
                0x8384: 0x30E4,
                0x8385: 0x30E5,
                0x8386: 0x30E6,
                0x8387: 0x30E7,
                0x8388: 0x30E8,
                0x8389: 0x30E9,
                0x838A: 0x30EA,
                0x838B: 0x30EB,
                0x838C: 0x30EC,
                0x838D: 0x30ED,
                0x838E: 0x30EE,
                0x838F: 0x30EF,
                0x8390: 0x30F0,
                0x8391: 0x30F1,
                0x8392: 0x30F2,
                0x8393: 0x30F3,
                0x8394: 0x30F4,
                0x8395: 0x30F5,
                0x8396: 0x30F6,
                0x839F: 0x0391,
                0x83A0: 0x0392,
                0x83A1: 0x0393,
                0x83A2: 0x0394,
                0x83A3: 0x0395,
                0x83A4: 0x0396,
                0x83A5: 0x0397,
                0x83A6: 0x0398,
                0x83A7: 0x0399,
                0x83A8: 0x039A,
                0x83A9: 0x039B,
                0x83AA: 0x039C,
                0x83AB: 0x039D,
                0x83AC: 0x039E,
                0x83AD: 0x039F,
                0x83AE: 0x03A0,
                0x83AF: 0x03A1,
                0x83B0: 0x03A3,
                0x83B1: 0x03A4,
                0x83B2: 0x03A5,
                0x83B3: 0x03A6,
                0x83B4: 0x03A7,
                0x83B5: 0x03A8,
                0x83B6: 0x03A9,
                0x83BF: 0x03B1,
                0x83C0: 0x03B2,
                0x83C1: 0x03B3,
                0x83C2: 0x03B4,
                0x83C3: 0x03B5,
                0x83C4: 0x03B6,
                0x83C5: 0x03B7,
                0x83C6: 0x03B8,
                0x83C7: 0x03B9,
                0x83C8: 0x03BA,
                0x83C9: 0x03BB,
                0x83CA: 0x03BC,
                0x83CB: 0x03BD,
                0x83CC: 0x03BE,
                0x83CD: 0x03BF,
                0x83CE: 0x03C0,
                0x83CF: 0x03C1,
                0x83D0: 0x03C3,
                0x83D1: 0x03C4,
                0x83D2: 0x03C5,
                0x83D3: 0x03C6,
                0x83D4: 0x03C7,
                0x83D5: 0x03C8,
                0x83D6: 0x03C9,
                0x8440: 0x0410,
                0x8441: 0x0411,
                0x8442: 0x0412,
                0x8443: 0x0413,
                0x8444: 0x0414,
                0x8445: 0x0415,
                0x8446: 0x0401,
                0x8447: 0x0416,
                0x8448: 0x0417,
                0x8449: 0x0418,
                0x844A: 0x0419,
                0x844B: 0x041A,
                0x844C: 0x041B,
                0x844D: 0x041C,
                0x844E: 0x041D,
                0x844F: 0x041E,
                0x8450: 0x041F,
                0x8451: 0x0420,
                0x8452: 0x0421,
                0x8453: 0x0422,
                0x8454: 0x0423,
                0x8455: 0x0424,
                0x8456: 0x0425,
                0x8457: 0x0426,
                0x8458: 0x0427,
                0x8459: 0x0428,
                0x845A: 0x0429,
                0x845B: 0x042A,
                0x845C: 0x042B,
                0x845D: 0x042C,
                0x845E: 0x042D,
                0x845F: 0x042E,
                0x8460: 0x042F,
                0x8470: 0x0430,
                0x8471: 0x0431,
                0x8472: 0x0432,
                0x8473: 0x0433,
                0x8474: 0x0434,
                0x8475: 0x0435,
                0x8476: 0x0451,
                0x8477: 0x0436,
                0x8478: 0x0437,
                0x8479: 0x0438,
                0x847A: 0x0439,
                0x847B: 0x043A,
                0x847C: 0x043B,
                0x847D: 0x043C,
                0x847E: 0x043D,
                0x8480: 0x043E,
                0x8481: 0x043F,
                0x8482: 0x0440,
                0x8483: 0x0441,
                0x8484: 0x0442,
                0x8485: 0x0443,
                0x8486: 0x0444,
                0x8487: 0x0445,
                0x8488: 0x0446,
                0x8489: 0x0447,
                0x848A: 0x0448,
                0x848B: 0x0449,
                0x848C: 0x044A,
                0x848D: 0x044B,
                0x848E: 0x044C,
                0x848F: 0x044D,
                0x8490: 0x044E,
                0x8491: 0x044F,
                0x849F: 0x2500,
                0x84A0: 0x2502,
                0x84A1: 0x250C,
                0x84A2: 0x2510,
                0x84A3: 0x2518,
                0x84A4: 0x2514,
                0x84A5: 0x251C,
                0x84A6: 0x252C,
                0x84A7: 0x2524,
                0x84A8: 0x2534,
                0x84A9: 0x253C,
                0x84AA: 0x2501,
                0x84AB: 0x2503,
                0x84AC: 0x250F,
                0x84AD: 0x2513,
                0x84AE: 0x251B,
                0x84AF: 0x2517,
                0x84B0: 0x2523,
                0x84B1: 0x2533,
                0x84B2: 0x252B,
                0x84B3: 0x253B,
                0x84B4: 0x254B,
                0x84B5: 0x2520,
                0x84B6: 0x252F,
                0x84B7: 0x2528,
                0x84B8: 0x2537,
                0x84B9: 0x253F,
                0x84BA: 0x251D,
                0x84BB: 0x2530,
                0x84BC: 0x2525,
                0x84BD: 0x2538,
                0x84BE: 0x2542,
                0x889F: 0x4E9C,
                0x88A0: 0x5516,
                0x88A1: 0x5A03,
                0x88A2: 0x963F,
                0x88A3: 0x54C0,
                0x88A4: 0x611B,
                0x88A5: 0x6328,
                0x88A6: 0x59F6,
                0x88A7: 0x9022,
                0x88A8: 0x8475,
                0x88A9: 0x831C,
                0x88AA: 0x7A50,
                0x88AB: 0x60AA,
                0x88AC: 0x63E1,
                0x88AD: 0x6E25,
                0x88AE: 0x65ED,
                0x88AF: 0x8466,
                0x88B0: 0x82A6,
                0x88B1: 0x9BF5,
                0x88B2: 0x6893,
                0x88B3: 0x5727,
                0x88B4: 0x65A1,
                0x88B5: 0x6271,
                0x88B6: 0x5B9B,
                0x88B7: 0x59D0,
                0x88B8: 0x867B,
                0x88B9: 0x98F4,
                0x88BA: 0x7D62,
                0x88BB: 0x7DBE,
                0x88BC: 0x9B8E,
                0x88BD: 0x6216,
                0x88BE: 0x7C9F,
                0x88BF: 0x88B7,
                0x88C0: 0x5B89,
                0x88C1: 0x5EB5,
                0x88C2: 0x6309,
                0x88C3: 0x6697,
                0x88C4: 0x6848,
                0x88C5: 0x95C7,
                0x88C6: 0x978D,
                0x88C7: 0x674F,
                0x88C8: 0x4EE5,
                0x88C9: 0x4F0A,
                0x88CA: 0x4F4D,
                0x88CB: 0x4F9D,
                0x88CC: 0x5049,
                0x88CD: 0x56F2,
                0x88CE: 0x5937,
                0x88CF: 0x59D4,
                0x88D0: 0x5A01,
                0x88D1: 0x5C09,
                0x88D2: 0x60DF,
                0x88D3: 0x610F,
                0x88D4: 0x6170,
                0x88D5: 0x6613,
                0x88D6: 0x6905,
                0x88D7: 0x70BA,
                0x88D8: 0x754F,
                0x88D9: 0x7570,
                0x88DA: 0x79FB,
                0x88DB: 0x7DAD,
                0x88DC: 0x7DEF,
                0x88DD: 0x80C3,
                0x88DE: 0x840E,
                0x88DF: 0x8863,
                0x88E0: 0x8B02,
                0x88E1: 0x9055,
                0x88E2: 0x907A,
                0x88E3: 0x533B,
                0x88E4: 0x4E95,
                0x88E5: 0x4EA5,
                0x88E6: 0x57DF,
                0x88E7: 0x80B2,
                0x88E8: 0x90C1,
                0x88E9: 0x78EF,
                0x88EA: 0x4E00,
                0x88EB: 0x58F1,
                0x88EC: 0x6EA2,
                0x88ED: 0x9038,
                0x88EE: 0x7A32,
                0x88EF: 0x8328,
                0x88F0: 0x828B,
                0x88F1: 0x9C2F,
                0x88F2: 0x5141,
                0x88F3: 0x5370,
                0x88F4: 0x54BD,
                0x88F5: 0x54E1,
                0x88F6: 0x56E0,
                0x88F7: 0x59FB,
                0x88F8: 0x5F15,
                0x88F9: 0x98F2,
                0x88FA: 0x6DEB,
                0x88FB: 0x80E4,
                0x88FC: 0x852D,
                0x8940: 0x9662,
                0x8941: 0x9670,
                0x8942: 0x96A0,
                0x8943: 0x97FB,
                0x8944: 0x540B,
                0x8945: 0x53F3,
                0x8946: 0x5B87,
                0x8947: 0x70CF,
                0x8948: 0x7FBD,
                0x8949: 0x8FC2,
                0x894A: 0x96E8,
                0x894B: 0x536F,
                0x894C: 0x9D5C,
                0x894D: 0x7ABA,
                0x894E: 0x4E11,
                0x894F: 0x7893,
                0x8950: 0x81FC,
                0x8951: 0x6E26,
                0x8952: 0x5618,
                0x8953: 0x5504,
                0x8954: 0x6B1D,
                0x8955: 0x851A,
                0x8956: 0x9C3B,
                0x8957: 0x59E5,
                0x8958: 0x53A9,
                0x8959: 0x6D66,
                0x895A: 0x74DC,
                0x895B: 0x958F,
                0x895C: 0x5642,
                0x895D: 0x4E91,
                0x895E: 0x904B,
                0x895F: 0x96F2,
                0x8960: 0x834F,
                0x8961: 0x990C,
                0x8962: 0x53E1,
                0x8963: 0x55B6,
                0x8964: 0x5B30,
                0x8965: 0x5F71,
                0x8966: 0x6620,
                0x8967: 0x66F3,
                0x8968: 0x6804,
                0x8969: 0x6C38,
                0x896A: 0x6CF3,
                0x896B: 0x6D29,
                0x896C: 0x745B,
                0x896D: 0x76C8,
                0x896E: 0x7A4E,
                0x896F: 0x9834,
                0x8970: 0x82F1,
                0x8971: 0x885B,
                0x8972: 0x8A60,
                0x8973: 0x92ED,
                0x8974: 0x6DB2,
                0x8975: 0x75AB,
                0x8976: 0x76CA,
                0x8977: 0x99C5,
                0x8978: 0x60A6,
                0x8979: 0x8B01,
                0x897A: 0x8D8A,
                0x897B: 0x95B2,
                0x897C: 0x698E,
                0x897D: 0x53AD,
                0x897E: 0x5186,
                0x8980: 0x5712,
                0x8981: 0x5830,
                0x8982: 0x5944,
                0x8983: 0x5BB4,
                0x8984: 0x5EF6,
                0x8985: 0x6028,
                0x8986: 0x63A9,
                0x8987: 0x63F4,
                0x8988: 0x6CBF,
                0x8989: 0x6F14,
                0x898A: 0x708E,
                0x898B: 0x7114,
                0x898C: 0x7159,
                0x898D: 0x71D5,
                0x898E: 0x733F,
                0x898F: 0x7E01,
                0x8990: 0x8276,
                0x8991: 0x82D1,
                0x8992: 0x8597,
                0x8993: 0x9060,
                0x8994: 0x925B,
                0x8995: 0x9D1B,
                0x8996: 0x5869,
                0x8997: 0x65BC,
                0x8998: 0x6C5A,
                0x8999: 0x7525,
                0x899A: 0x51F9,
                0x899B: 0x592E,
                0x899C: 0x5965,
                0x899D: 0x5F80,
                0x899E: 0x5FDC,
                0x899F: 0x62BC,
                0x89A0: 0x65FA,
                0x89A1: 0x6A2A,
                0x89A2: 0x6B27,
                0x89A3: 0x6BB4,
                0x89A4: 0x738B,
                0x89A5: 0x7FC1,
                0x89A6: 0x8956,
                0x89A7: 0x9D2C,
                0x89A8: 0x9D0E,
                0x89A9: 0x9EC4,
                0x89AA: 0x5CA1,
                0x89AB: 0x6C96,
                0x89AC: 0x837B,
                0x89AD: 0x5104,
                0x89AE: 0x5C4B,
                0x89AF: 0x61B6,
                0x89B0: 0x81C6,
                0x89B1: 0x6876,
                0x89B2: 0x7261,
                0x89B3: 0x4E59,
                0x89B4: 0x4FFA,
                0x89B5: 0x5378,
                0x89B6: 0x6069,
                0x89B7: 0x6E29,
                0x89B8: 0x7A4F,
                0x89B9: 0x97F3,
                0x89BA: 0x4E0B,
                0x89BB: 0x5316,
                0x89BC: 0x4EEE,
                0x89BD: 0x4F55,
                0x89BE: 0x4F3D,
                0x89BF: 0x4FA1,
                0x89C0: 0x4F73,
                0x89C1: 0x52A0,
                0x89C2: 0x53EF,
                0x89C3: 0x5609,
                0x89C4: 0x590F,
                0x89C5: 0x5AC1,
                0x89C6: 0x5BB6,
                0x89C7: 0x5BE1,
                0x89C8: 0x79D1,
                0x89C9: 0x6687,
                0x89CA: 0x679C,
                0x89CB: 0x67B6,
                0x89CC: 0x6B4C,
                0x89CD: 0x6CB3,
                0x89CE: 0x706B,
                0x89CF: 0x73C2,
                0x89D0: 0x798D,
                0x89D1: 0x79BE,
                0x89D2: 0x7A3C,
                0x89D3: 0x7B87,
                0x89D4: 0x82B1,
                0x89D5: 0x82DB,
                0x89D6: 0x8304,
                0x89D7: 0x8377,
                0x89D8: 0x83EF,
                0x89D9: 0x83D3,
                0x89DA: 0x8766,
                0x89DB: 0x8AB2,
                0x89DC: 0x5629,
                0x89DD: 0x8CA8,
                0x89DE: 0x8FE6,
                0x89DF: 0x904E,
                0x89E0: 0x971E,
                0x89E1: 0x868A,
                0x89E2: 0x4FC4,
                0x89E3: 0x5CE8,
                0x89E4: 0x6211,
                0x89E5: 0x7259,
                0x89E6: 0x753B,
                0x89E7: 0x81E5,
                0x89E8: 0x82BD,
                0x89E9: 0x86FE,
                0x89EA: 0x8CC0,
                0x89EB: 0x96C5,
                0x89EC: 0x9913,
                0x89ED: 0x99D5,
                0x89EE: 0x4ECB,
                0x89EF: 0x4F1A,
                0x89F0: 0x89E3,
                0x89F1: 0x56DE,
                0x89F2: 0x584A,
                0x89F3: 0x58CA,
                0x89F4: 0x5EFB,
                0x89F5: 0x5FEB,
                0x89F6: 0x602A,
                0x89F7: 0x6094,
                0x89F8: 0x6062,
                0x89F9: 0x61D0,
                0x89FA: 0x6212,
                0x89FB: 0x62D0,
                0x89FC: 0x6539,
                0x8A40: 0x9B41,
                0x8A41: 0x6666,
                0x8A42: 0x68B0,
                0x8A43: 0x6D77,
                0x8A44: 0x7070,
                0x8A45: 0x754C,
                0x8A46: 0x7686,
                0x8A47: 0x7D75,
                0x8A48: 0x82A5,
                0x8A49: 0x87F9,
                0x8A4A: 0x958B,
                0x8A4B: 0x968E,
                0x8A4C: 0x8C9D,
                0x8A4D: 0x51F1,
                0x8A4E: 0x52BE,
                0x8A4F: 0x5916,
                0x8A50: 0x54B3,
                0x8A51: 0x5BB3,
                0x8A52: 0x5D16,
                0x8A53: 0x6168,
                0x8A54: 0x6982,
                0x8A55: 0x6DAF,
                0x8A56: 0x788D,
                0x8A57: 0x84CB,
                0x8A58: 0x8857,
                0x8A59: 0x8A72,
                0x8A5A: 0x93A7,
                0x8A5B: 0x9AB8,
                0x8A5C: 0x6D6C,
                0x8A5D: 0x99A8,
                0x8A5E: 0x86D9,
                0x8A5F: 0x57A3,
                0x8A60: 0x67FF,
                0x8A61: 0x86CE,
                0x8A62: 0x920E,
                0x8A63: 0x5283,
                0x8A64: 0x5687,
                0x8A65: 0x5404,
                0x8A66: 0x5ED3,
                0x8A67: 0x62E1,
                0x8A68: 0x64B9,
                0x8A69: 0x683C,
                0x8A6A: 0x6838,
                0x8A6B: 0x6BBB,
                0x8A6C: 0x7372,
                0x8A6D: 0x78BA,
                0x8A6E: 0x7A6B,
                0x8A6F: 0x899A,
                0x8A70: 0x89D2,
                0x8A71: 0x8D6B,
                0x8A72: 0x8F03,
                0x8A73: 0x90ED,
                0x8A74: 0x95A3,
                0x8A75: 0x9694,
                0x8A76: 0x9769,
                0x8A77: 0x5B66,
                0x8A78: 0x5CB3,
                0x8A79: 0x697D,
                0x8A7A: 0x984D,
                0x8A7B: 0x984E,
                0x8A7C: 0x639B,
                0x8A7D: 0x7B20,
                0x8A7E: 0x6A2B,
                0x8A80: 0x6A7F,
                0x8A81: 0x68B6,
                0x8A82: 0x9C0D,
                0x8A83: 0x6F5F,
                0x8A84: 0x5272,
                0x8A85: 0x559D,
                0x8A86: 0x6070,
                0x8A87: 0x62EC,
                0x8A88: 0x6D3B,
                0x8A89: 0x6E07,
                0x8A8A: 0x6ED1,
                0x8A8B: 0x845B,
                0x8A8C: 0x8910,
                0x8A8D: 0x8F44,
                0x8A8E: 0x4E14,
                0x8A8F: 0x9C39,
                0x8A90: 0x53F6,
                0x8A91: 0x691B,
                0x8A92: 0x6A3A,
                0x8A93: 0x9784,
                0x8A94: 0x682A,
                0x8A95: 0x515C,
                0x8A96: 0x7AC3,
                0x8A97: 0x84B2,
                0x8A98: 0x91DC,
                0x8A99: 0x938C,
                0x8A9A: 0x565B,
                0x8A9B: 0x9D28,
                0x8A9C: 0x6822,
                0x8A9D: 0x8305,
                0x8A9E: 0x8431,
                0x8A9F: 0x7CA5,
                0x8AA0: 0x5208,
                0x8AA1: 0x82C5,
                0x8AA2: 0x74E6,
                0x8AA3: 0x4E7E,
                0x8AA4: 0x4F83,
                0x8AA5: 0x51A0,
                0x8AA6: 0x5BD2,
                0x8AA7: 0x520A,
                0x8AA8: 0x52D8,
                0x8AA9: 0x52E7,
                0x8AAA: 0x5DFB,
                0x8AAB: 0x559A,
                0x8AAC: 0x582A,
                0x8AAD: 0x59E6,
                0x8AAE: 0x5B8C,
                0x8AAF: 0x5B98,
                0x8AB0: 0x5BDB,
                0x8AB1: 0x5E72,
                0x8AB2: 0x5E79,
                0x8AB3: 0x60A3,
                0x8AB4: 0x611F,
                0x8AB5: 0x6163,
                0x8AB6: 0x61BE,
                0x8AB7: 0x63DB,
                0x8AB8: 0x6562,
                0x8AB9: 0x67D1,
                0x8ABA: 0x6853,
                0x8ABB: 0x68FA,
                0x8ABC: 0x6B3E,
                0x8ABD: 0x6B53,
                0x8ABE: 0x6C57,
                0x8ABF: 0x6F22,
                0x8AC0: 0x6F97,
                0x8AC1: 0x6F45,
                0x8AC2: 0x74B0,
                0x8AC3: 0x7518,
                0x8AC4: 0x76E3,
                0x8AC5: 0x770B,
                0x8AC6: 0x7AFF,
                0x8AC7: 0x7BA1,
                0x8AC8: 0x7C21,
                0x8AC9: 0x7DE9,
                0x8ACA: 0x7F36,
                0x8ACB: 0x7FF0,
                0x8ACC: 0x809D,
                0x8ACD: 0x8266,
                0x8ACE: 0x839E,
                0x8ACF: 0x89B3,
                0x8AD0: 0x8ACC,
                0x8AD1: 0x8CAB,
                0x8AD2: 0x9084,
                0x8AD3: 0x9451,
                0x8AD4: 0x9593,
                0x8AD5: 0x9591,
                0x8AD6: 0x95A2,
                0x8AD7: 0x9665,
                0x8AD8: 0x97D3,
                0x8AD9: 0x9928,
                0x8ADA: 0x8218,
                0x8ADB: 0x4E38,
                0x8ADC: 0x542B,
                0x8ADD: 0x5CB8,
                0x8ADE: 0x5DCC,
                0x8ADF: 0x73A9,
                0x8AE0: 0x764C,
                0x8AE1: 0x773C,
                0x8AE2: 0x5CA9,
                0x8AE3: 0x7FEB,
                0x8AE4: 0x8D0B,
                0x8AE5: 0x96C1,
                0x8AE6: 0x9811,
                0x8AE7: 0x9854,
                0x8AE8: 0x9858,
                0x8AE9: 0x4F01,
                0x8AEA: 0x4F0E,
                0x8AEB: 0x5371,
                0x8AEC: 0x559C,
                0x8AED: 0x5668,
                0x8AEE: 0x57FA,
                0x8AEF: 0x5947,
                0x8AF0: 0x5B09,
                0x8AF1: 0x5BC4,
                0x8AF2: 0x5C90,
                0x8AF3: 0x5E0C,
                0x8AF4: 0x5E7E,
                0x8AF5: 0x5FCC,
                0x8AF6: 0x63EE,
                0x8AF7: 0x673A,
                0x8AF8: 0x65D7,
                0x8AF9: 0x65E2,
                0x8AFA: 0x671F,
                0x8AFB: 0x68CB,
                0x8AFC: 0x68C4,
                0x8B40: 0x6A5F,
                0x8B41: 0x5E30,
                0x8B42: 0x6BC5,
                0x8B43: 0x6C17,
                0x8B44: 0x6C7D,
                0x8B45: 0x757F,
                0x8B46: 0x7948,
                0x8B47: 0x5B63,
                0x8B48: 0x7A00,
                0x8B49: 0x7D00,
                0x8B4A: 0x5FBD,
                0x8B4B: 0x898F,
                0x8B4C: 0x8A18,
                0x8B4D: 0x8CB4,
                0x8B4E: 0x8D77,
                0x8B4F: 0x8ECC,
                0x8B50: 0x8F1D,
                0x8B51: 0x98E2,
                0x8B52: 0x9A0E,
                0x8B53: 0x9B3C,
                0x8B54: 0x4E80,
                0x8B55: 0x507D,
                0x8B56: 0x5100,
                0x8B57: 0x5993,
                0x8B58: 0x5B9C,
                0x8B59: 0x622F,
                0x8B5A: 0x6280,
                0x8B5B: 0x64EC,
                0x8B5C: 0x6B3A,
                0x8B5D: 0x72A0,
                0x8B5E: 0x7591,
                0x8B5F: 0x7947,
                0x8B60: 0x7FA9,
                0x8B61: 0x87FB,
                0x8B62: 0x8ABC,
                0x8B63: 0x8B70,
                0x8B64: 0x63AC,
                0x8B65: 0x83CA,
                0x8B66: 0x97A0,
                0x8B67: 0x5409,
                0x8B68: 0x5403,
                0x8B69: 0x55AB,
                0x8B6A: 0x6854,
                0x8B6B: 0x6A58,
                0x8B6C: 0x8A70,
                0x8B6D: 0x7827,
                0x8B6E: 0x6775,
                0x8B6F: 0x9ECD,
                0x8B70: 0x5374,
                0x8B71: 0x5BA2,
                0x8B72: 0x811A,
                0x8B73: 0x8650,
                0x8B74: 0x9006,
                0x8B75: 0x4E18,
                0x8B76: 0x4E45,
                0x8B77: 0x4EC7,
                0x8B78: 0x4F11,
                0x8B79: 0x53CA,
                0x8B7A: 0x5438,
                0x8B7B: 0x5BAE,
                0x8B7C: 0x5F13,
                0x8B7D: 0x6025,
                0x8B7E: 0x6551,
                0x8B80: 0x673D,
                0x8B81: 0x6C42,
                0x8B82: 0x6C72,
                0x8B83: 0x6CE3,
                0x8B84: 0x7078,
                0x8B85: 0x7403,
                0x8B86: 0x7A76,
                0x8B87: 0x7AAE,
                0x8B88: 0x7B08,
                0x8B89: 0x7D1A,
                0x8B8A: 0x7CFE,
                0x8B8B: 0x7D66,
                0x8B8C: 0x65E7,
                0x8B8D: 0x725B,
                0x8B8E: 0x53BB,
                0x8B8F: 0x5C45,
                0x8B90: 0x5DE8,
                0x8B91: 0x62D2,
                0x8B92: 0x62E0,
                0x8B93: 0x6319,
                0x8B94: 0x6E20,
                0x8B95: 0x865A,
                0x8B96: 0x8A31,
                0x8B97: 0x8DDD,
                0x8B98: 0x92F8,
                0x8B99: 0x6F01,
                0x8B9A: 0x79A6,
                0x8B9B: 0x9B5A,
                0x8B9C: 0x4EA8,
                0x8B9D: 0x4EAB,
                0x8B9E: 0x4EAC,
                0x8B9F: 0x4F9B,
                0x8BA0: 0x4FA0,
                0x8BA1: 0x50D1,
                0x8BA2: 0x5147,
                0x8BA3: 0x7AF6,
                0x8BA4: 0x5171,
                0x8BA5: 0x51F6,
                0x8BA6: 0x5354,
                0x8BA7: 0x5321,
                0x8BA8: 0x537F,
                0x8BA9: 0x53EB,
                0x8BAA: 0x55AC,
                0x8BAB: 0x5883,
                0x8BAC: 0x5CE1,
                0x8BAD: 0x5F37,
                0x8BAE: 0x5F4A,
                0x8BAF: 0x602F,
                0x8BB0: 0x6050,
                0x8BB1: 0x606D,
                0x8BB2: 0x631F,
                0x8BB3: 0x6559,
                0x8BB4: 0x6A4B,
                0x8BB5: 0x6CC1,
                0x8BB6: 0x72C2,
                0x8BB7: 0x72ED,
                0x8BB8: 0x77EF,
                0x8BB9: 0x80F8,
                0x8BBA: 0x8105,
                0x8BBB: 0x8208,
                0x8BBC: 0x854E,
                0x8BBD: 0x90F7,
                0x8BBE: 0x93E1,
                0x8BBF: 0x97FF,
                0x8BC0: 0x9957,
                0x8BC1: 0x9A5A,
                0x8BC2: 0x4EF0,
                0x8BC3: 0x51DD,
                0x8BC4: 0x5C2D,
                0x8BC5: 0x6681,
                0x8BC6: 0x696D,
                0x8BC7: 0x5C40,
                0x8BC8: 0x66F2,
                0x8BC9: 0x6975,
                0x8BCA: 0x7389,
                0x8BCB: 0x6850,
                0x8BCC: 0x7C81,
                0x8BCD: 0x50C5,
                0x8BCE: 0x52E4,
                0x8BCF: 0x5747,
                0x8BD0: 0x5DFE,
                0x8BD1: 0x9326,
                0x8BD2: 0x65A4,
                0x8BD3: 0x6B23,
                0x8BD4: 0x6B3D,
                0x8BD5: 0x7434,
                0x8BD6: 0x7981,
                0x8BD7: 0x79BD,
                0x8BD8: 0x7B4B,
                0x8BD9: 0x7DCA,
                0x8BDA: 0x82B9,
                0x8BDB: 0x83CC,
                0x8BDC: 0x887F,
                0x8BDD: 0x895F,
                0x8BDE: 0x8B39,
                0x8BDF: 0x8FD1,
                0x8BE0: 0x91D1,
                0x8BE1: 0x541F,
                0x8BE2: 0x9280,
                0x8BE3: 0x4E5D,
                0x8BE4: 0x5036,
                0x8BE5: 0x53E5,
                0x8BE6: 0x533A,
                0x8BE7: 0x72D7,
                0x8BE8: 0x7396,
                0x8BE9: 0x77E9,
                0x8BEA: 0x82E6,
                0x8BEB: 0x8EAF,
                0x8BEC: 0x99C6,
                0x8BED: 0x99C8,
                0x8BEE: 0x99D2,
                0x8BEF: 0x5177,
                0x8BF0: 0x611A,
                0x8BF1: 0x865E,
                0x8BF2: 0x55B0,
                0x8BF3: 0x7A7A,
                0x8BF4: 0x5076,
                0x8BF5: 0x5BD3,
                0x8BF6: 0x9047,
                0x8BF7: 0x9685,
                0x8BF8: 0x4E32,
                0x8BF9: 0x6ADB,
                0x8BFA: 0x91E7,
                0x8BFB: 0x5C51,
                0x8BFC: 0x5C48,
                0x8C40: 0x6398,
                0x8C41: 0x7A9F,
                0x8C42: 0x6C93,
                0x8C43: 0x9774,
                0x8C44: 0x8F61,
                0x8C45: 0x7AAA,
                0x8C46: 0x718A,
                0x8C47: 0x9688,
                0x8C48: 0x7C82,
                0x8C49: 0x6817,
                0x8C4A: 0x7E70,
                0x8C4B: 0x6851,
                0x8C4C: 0x936C,
                0x8C4D: 0x52F2,
                0x8C4E: 0x541B,
                0x8C4F: 0x85AB,
                0x8C50: 0x8A13,
                0x8C51: 0x7FA4,
                0x8C52: 0x8ECD,
                0x8C53: 0x90E1,
                0x8C54: 0x5366,
                0x8C55: 0x8888,
                0x8C56: 0x7941,
                0x8C57: 0x4FC2,
                0x8C58: 0x50BE,
                0x8C59: 0x5211,
                0x8C5A: 0x5144,
                0x8C5B: 0x5553,
                0x8C5C: 0x572D,
                0x8C5D: 0x73EA,
                0x8C5E: 0x578B,
                0x8C5F: 0x5951,
                0x8C60: 0x5F62,
                0x8C61: 0x5F84,
                0x8C62: 0x6075,
                0x8C63: 0x6176,
                0x8C64: 0x6167,
                0x8C65: 0x61A9,
                0x8C66: 0x63B2,
                0x8C67: 0x643A,
                0x8C68: 0x656C,
                0x8C69: 0x666F,
                0x8C6A: 0x6842,
                0x8C6B: 0x6E13,
                0x8C6C: 0x7566,
                0x8C6D: 0x7A3D,
                0x8C6E: 0x7CFB,
                0x8C6F: 0x7D4C,
                0x8C70: 0x7D99,
                0x8C71: 0x7E4B,
                0x8C72: 0x7F6B,
                0x8C73: 0x830E,
                0x8C74: 0x834A,
                0x8C75: 0x86CD,
                0x8C76: 0x8A08,
                0x8C77: 0x8A63,
                0x8C78: 0x8B66,
                0x8C79: 0x8EFD,
                0x8C7A: 0x981A,
                0x8C7B: 0x9D8F,
                0x8C7C: 0x82B8,
                0x8C7D: 0x8FCE,
                0x8C7E: 0x9BE8,
                0x8C80: 0x5287,
                0x8C81: 0x621F,
                0x8C82: 0x6483,
                0x8C83: 0x6FC0,
                0x8C84: 0x9699,
                0x8C85: 0x6841,
                0x8C86: 0x5091,
                0x8C87: 0x6B20,
                0x8C88: 0x6C7A,
                0x8C89: 0x6F54,
                0x8C8A: 0x7A74,
                0x8C8B: 0x7D50,
                0x8C8C: 0x8840,
                0x8C8D: 0x8A23,
                0x8C8E: 0x6708,
                0x8C8F: 0x4EF6,
                0x8C90: 0x5039,
                0x8C91: 0x5026,
                0x8C92: 0x5065,
                0x8C93: 0x517C,
                0x8C94: 0x5238,
                0x8C95: 0x5263,
                0x8C96: 0x55A7,
                0x8C97: 0x570F,
                0x8C98: 0x5805,
                0x8C99: 0x5ACC,
                0x8C9A: 0x5EFA,
                0x8C9B: 0x61B2,
                0x8C9C: 0x61F8,
                0x8C9D: 0x62F3,
                0x8C9E: 0x6372,
                0x8C9F: 0x691C,
                0x8CA0: 0x6A29,
                0x8CA1: 0x727D,
                0x8CA2: 0x72AC,
                0x8CA3: 0x732E,
                0x8CA4: 0x7814,
                0x8CA5: 0x786F,
                0x8CA6: 0x7D79,
                0x8CA7: 0x770C,
                0x8CA8: 0x80A9,
                0x8CA9: 0x898B,
                0x8CAA: 0x8B19,
                0x8CAB: 0x8CE2,
                0x8CAC: 0x8ED2,
                0x8CAD: 0x9063,
                0x8CAE: 0x9375,
                0x8CAF: 0x967A,
                0x8CB0: 0x9855,
                0x8CB1: 0x9A13,
                0x8CB2: 0x9E78,
                0x8CB3: 0x5143,
                0x8CB4: 0x539F,
                0x8CB5: 0x53B3,
                0x8CB6: 0x5E7B,
                0x8CB7: 0x5F26,
                0x8CB8: 0x6E1B,
                0x8CB9: 0x6E90,
                0x8CBA: 0x7384,
                0x8CBB: 0x73FE,
                0x8CBC: 0x7D43,
                0x8CBD: 0x8237,
                0x8CBE: 0x8A00,
                0x8CBF: 0x8AFA,
                0x8CC0: 0x9650,
                0x8CC1: 0x4E4E,
                0x8CC2: 0x500B,
                0x8CC3: 0x53E4,
                0x8CC4: 0x547C,
                0x8CC5: 0x56FA,
                0x8CC6: 0x59D1,
                0x8CC7: 0x5B64,
                0x8CC8: 0x5DF1,
                0x8CC9: 0x5EAB,
                0x8CCA: 0x5F27,
                0x8CCB: 0x6238,
                0x8CCC: 0x6545,
                0x8CCD: 0x67AF,
                0x8CCE: 0x6E56,
                0x8CCF: 0x72D0,
                0x8CD0: 0x7CCA,
                0x8CD1: 0x88B4,
                0x8CD2: 0x80A1,
                0x8CD3: 0x80E1,
                0x8CD4: 0x83F0,
                0x8CD5: 0x864E,
                0x8CD6: 0x8A87,
                0x8CD7: 0x8DE8,
                0x8CD8: 0x9237,
                0x8CD9: 0x96C7,
                0x8CDA: 0x9867,
                0x8CDB: 0x9F13,
                0x8CDC: 0x4E94,
                0x8CDD: 0x4E92,
                0x8CDE: 0x4F0D,
                0x8CDF: 0x5348,
                0x8CE0: 0x5449,
                0x8CE1: 0x543E,
                0x8CE2: 0x5A2F,
                0x8CE3: 0x5F8C,
                0x8CE4: 0x5FA1,
                0x8CE5: 0x609F,
                0x8CE6: 0x68A7,
                0x8CE7: 0x6A8E,
                0x8CE8: 0x745A,
                0x8CE9: 0x7881,
                0x8CEA: 0x8A9E,
                0x8CEB: 0x8AA4,
                0x8CEC: 0x8B77,
                0x8CED: 0x9190,
                0x8CEE: 0x4E5E,
                0x8CEF: 0x9BC9,
                0x8CF0: 0x4EA4,
                0x8CF1: 0x4F7C,
                0x8CF2: 0x4FAF,
                0x8CF3: 0x5019,
                0x8CF4: 0x5016,
                0x8CF5: 0x5149,
                0x8CF6: 0x516C,
                0x8CF7: 0x529F,
                0x8CF8: 0x52B9,
                0x8CF9: 0x52FE,
                0x8CFA: 0x539A,
                0x8CFB: 0x53E3,
                0x8CFC: 0x5411,
                0x8D40: 0x540E,
                0x8D41: 0x5589,
                0x8D42: 0x5751,
                0x8D43: 0x57A2,
                0x8D44: 0x597D,
                0x8D45: 0x5B54,
                0x8D46: 0x5B5D,
                0x8D47: 0x5B8F,
                0x8D48: 0x5DE5,
                0x8D49: 0x5DE7,
                0x8D4A: 0x5DF7,
                0x8D4B: 0x5E78,
                0x8D4C: 0x5E83,
                0x8D4D: 0x5E9A,
                0x8D4E: 0x5EB7,
                0x8D4F: 0x5F18,
                0x8D50: 0x6052,
                0x8D51: 0x614C,
                0x8D52: 0x6297,
                0x8D53: 0x62D8,
                0x8D54: 0x63A7,
                0x8D55: 0x653B,
                0x8D56: 0x6602,
                0x8D57: 0x6643,
                0x8D58: 0x66F4,
                0x8D59: 0x676D,
                0x8D5A: 0x6821,
                0x8D5B: 0x6897,
                0x8D5C: 0x69CB,
                0x8D5D: 0x6C5F,
                0x8D5E: 0x6D2A,
                0x8D5F: 0x6D69,
                0x8D60: 0x6E2F,
                0x8D61: 0x6E9D,
                0x8D62: 0x7532,
                0x8D63: 0x7687,
                0x8D64: 0x786C,
                0x8D65: 0x7A3F,
                0x8D66: 0x7CE0,
                0x8D67: 0x7D05,
                0x8D68: 0x7D18,
                0x8D69: 0x7D5E,
                0x8D6A: 0x7DB1,
                0x8D6B: 0x8015,
                0x8D6C: 0x8003,
                0x8D6D: 0x80AF,
                0x8D6E: 0x80B1,
                0x8D6F: 0x8154,
                0x8D70: 0x818F,
                0x8D71: 0x822A,
                0x8D72: 0x8352,
                0x8D73: 0x884C,
                0x8D74: 0x8861,
                0x8D75: 0x8B1B,
                0x8D76: 0x8CA2,
                0x8D77: 0x8CFC,
                0x8D78: 0x90CA,
                0x8D79: 0x9175,
                0x8D7A: 0x9271,
                0x8D7B: 0x783F,
                0x8D7C: 0x92FC,
                0x8D7D: 0x95A4,
                0x8D7E: 0x964D,
                0x8D80: 0x9805,
                0x8D81: 0x9999,
                0x8D82: 0x9AD8,
                0x8D83: 0x9D3B,
                0x8D84: 0x525B,
                0x8D85: 0x52AB,
                0x8D86: 0x53F7,
                0x8D87: 0x5408,
                0x8D88: 0x58D5,
                0x8D89: 0x62F7,
                0x8D8A: 0x6FE0,
                0x8D8B: 0x8C6A,
                0x8D8C: 0x8F5F,
                0x8D8D: 0x9EB9,
                0x8D8E: 0x514B,
                0x8D8F: 0x523B,
                0x8D90: 0x544A,
                0x8D91: 0x56FD,
                0x8D92: 0x7A40,
                0x8D93: 0x9177,
                0x8D94: 0x9D60,
                0x8D95: 0x9ED2,
                0x8D96: 0x7344,
                0x8D97: 0x6F09,
                0x8D98: 0x8170,
                0x8D99: 0x7511,
                0x8D9A: 0x5FFD,
                0x8D9B: 0x60DA,
                0x8D9C: 0x9AA8,
                0x8D9D: 0x72DB,
                0x8D9E: 0x8FBC,
                0x8D9F: 0x6B64,
                0x8DA0: 0x9803,
                0x8DA1: 0x4ECA,
                0x8DA2: 0x56F0,
                0x8DA3: 0x5764,
                0x8DA4: 0x58BE,
                0x8DA5: 0x5A5A,
                0x8DA6: 0x6068,
                0x8DA7: 0x61C7,
                0x8DA8: 0x660F,
                0x8DA9: 0x6606,
                0x8DAA: 0x6839,
                0x8DAB: 0x68B1,
                0x8DAC: 0x6DF7,
                0x8DAD: 0x75D5,
                0x8DAE: 0x7D3A,
                0x8DAF: 0x826E,
                0x8DB0: 0x9B42,
                0x8DB1: 0x4E9B,
                0x8DB2: 0x4F50,
                0x8DB3: 0x53C9,
                0x8DB4: 0x5506,
                0x8DB5: 0x5D6F,
                0x8DB6: 0x5DE6,
                0x8DB7: 0x5DEE,
                0x8DB8: 0x67FB,
                0x8DB9: 0x6C99,
                0x8DBA: 0x7473,
                0x8DBB: 0x7802,
                0x8DBC: 0x8A50,
                0x8DBD: 0x9396,
                0x8DBE: 0x88DF,
                0x8DBF: 0x5750,
                0x8DC0: 0x5EA7,
                0x8DC1: 0x632B,
                0x8DC2: 0x50B5,
                0x8DC3: 0x50AC,
                0x8DC4: 0x518D,
                0x8DC5: 0x6700,
                0x8DC6: 0x54C9,
                0x8DC7: 0x585E,
                0x8DC8: 0x59BB,
                0x8DC9: 0x5BB0,
                0x8DCA: 0x5F69,
                0x8DCB: 0x624D,
                0x8DCC: 0x63A1,
                0x8DCD: 0x683D,
                0x8DCE: 0x6B73,
                0x8DCF: 0x6E08,
                0x8DD0: 0x707D,
                0x8DD1: 0x91C7,
                0x8DD2: 0x7280,
                0x8DD3: 0x7815,
                0x8DD4: 0x7826,
                0x8DD5: 0x796D,
                0x8DD6: 0x658E,
                0x8DD7: 0x7D30,
                0x8DD8: 0x83DC,
                0x8DD9: 0x88C1,
                0x8DDA: 0x8F09,
                0x8DDB: 0x969B,
                0x8DDC: 0x5264,
                0x8DDD: 0x5728,
                0x8DDE: 0x6750,
                0x8DDF: 0x7F6A,
                0x8DE0: 0x8CA1,
                0x8DE1: 0x51B4,
                0x8DE2: 0x5742,
                0x8DE3: 0x962A,
                0x8DE4: 0x583A,
                0x8DE5: 0x698A,
                0x8DE6: 0x80B4,
                0x8DE7: 0x54B2,
                0x8DE8: 0x5D0E,
                0x8DE9: 0x57FC,
                0x8DEA: 0x7895,
                0x8DEB: 0x9DFA,
                0x8DEC: 0x4F5C,
                0x8DED: 0x524A,
                0x8DEE: 0x548B,
                0x8DEF: 0x643E,
                0x8DF0: 0x6628,
                0x8DF1: 0x6714,
                0x8DF2: 0x67F5,
                0x8DF3: 0x7A84,
                0x8DF4: 0x7B56,
                0x8DF5: 0x7D22,
                0x8DF6: 0x932F,
                0x8DF7: 0x685C,
                0x8DF8: 0x9BAD,
                0x8DF9: 0x7B39,
                0x8DFA: 0x5319,
                0x8DFB: 0x518A,
                0x8DFC: 0x5237,
                0x8E40: 0x5BDF,
                0x8E41: 0x62F6,
                0x8E42: 0x64AE,
                0x8E43: 0x64E6,
                0x8E44: 0x672D,
                0x8E45: 0x6BBA,
                0x8E46: 0x85A9,
                0x8E47: 0x96D1,
                0x8E48: 0x7690,
                0x8E49: 0x9BD6,
                0x8E4A: 0x634C,
                0x8E4B: 0x9306,
                0x8E4C: 0x9BAB,
                0x8E4D: 0x76BF,
                0x8E4E: 0x6652,
                0x8E4F: 0x4E09,
                0x8E50: 0x5098,
                0x8E51: 0x53C2,
                0x8E52: 0x5C71,
                0x8E53: 0x60E8,
                0x8E54: 0x6492,
                0x8E55: 0x6563,
                0x8E56: 0x685F,
                0x8E57: 0x71E6,
                0x8E58: 0x73CA,
                0x8E59: 0x7523,
                0x8E5A: 0x7B97,
                0x8E5B: 0x7E82,
                0x8E5C: 0x8695,
                0x8E5D: 0x8B83,
                0x8E5E: 0x8CDB,
                0x8E5F: 0x9178,
                0x8E60: 0x9910,
                0x8E61: 0x65AC,
                0x8E62: 0x66AB,
                0x8E63: 0x6B8B,
                0x8E64: 0x4ED5,
                0x8E65: 0x4ED4,
                0x8E66: 0x4F3A,
                0x8E67: 0x4F7F,
                0x8E68: 0x523A,
                0x8E69: 0x53F8,
                0x8E6A: 0x53F2,
                0x8E6B: 0x55E3,
                0x8E6C: 0x56DB,
                0x8E6D: 0x58EB,
                0x8E6E: 0x59CB,
                0x8E6F: 0x59C9,
                0x8E70: 0x59FF,
                0x8E71: 0x5B50,
                0x8E72: 0x5C4D,
                0x8E73: 0x5E02,
                0x8E74: 0x5E2B,
                0x8E75: 0x5FD7,
                0x8E76: 0x601D,
                0x8E77: 0x6307,
                0x8E78: 0x652F,
                0x8E79: 0x5B5C,
                0x8E7A: 0x65AF,
                0x8E7B: 0x65BD,
                0x8E7C: 0x65E8,
                0x8E7D: 0x679D,
                0x8E7E: 0x6B62,
                0x8E80: 0x6B7B,
                0x8E81: 0x6C0F,
                0x8E82: 0x7345,
                0x8E83: 0x7949,
                0x8E84: 0x79C1,
                0x8E85: 0x7CF8,
                0x8E86: 0x7D19,
                0x8E87: 0x7D2B,
                0x8E88: 0x80A2,
                0x8E89: 0x8102,
                0x8E8A: 0x81F3,
                0x8E8B: 0x8996,
                0x8E8C: 0x8A5E,
                0x8E8D: 0x8A69,
                0x8E8E: 0x8A66,
                0x8E8F: 0x8A8C,
                0x8E90: 0x8AEE,
                0x8E91: 0x8CC7,
                0x8E92: 0x8CDC,
                0x8E93: 0x96CC,
                0x8E94: 0x98FC,
                0x8E95: 0x6B6F,
                0x8E96: 0x4E8B,
                0x8E97: 0x4F3C,
                0x8E98: 0x4F8D,
                0x8E99: 0x5150,
                0x8E9A: 0x5B57,
                0x8E9B: 0x5BFA,
                0x8E9C: 0x6148,
                0x8E9D: 0x6301,
                0x8E9E: 0x6642,
                0x8E9F: 0x6B21,
                0x8EA0: 0x6ECB,
                0x8EA1: 0x6CBB,
                0x8EA2: 0x723E,
                0x8EA3: 0x74BD,
                0x8EA4: 0x75D4,
                0x8EA5: 0x78C1,
                0x8EA6: 0x793A,
                0x8EA7: 0x800C,
                0x8EA8: 0x8033,
                0x8EA9: 0x81EA,
                0x8EAA: 0x8494,
                0x8EAB: 0x8F9E,
                0x8EAC: 0x6C50,
                0x8EAD: 0x9E7F,
                0x8EAE: 0x5F0F,
                0x8EAF: 0x8B58,
                0x8EB0: 0x9D2B,
                0x8EB1: 0x7AFA,
                0x8EB2: 0x8EF8,
                0x8EB3: 0x5B8D,
                0x8EB4: 0x96EB,
                0x8EB5: 0x4E03,
                0x8EB6: 0x53F1,
                0x8EB7: 0x57F7,
                0x8EB8: 0x5931,
                0x8EB9: 0x5AC9,
                0x8EBA: 0x5BA4,
                0x8EBB: 0x6089,
                0x8EBC: 0x6E7F,
                0x8EBD: 0x6F06,
                0x8EBE: 0x75BE,
                0x8EBF: 0x8CEA,
                0x8EC0: 0x5B9F,
                0x8EC1: 0x8500,
                0x8EC2: 0x7BE0,
                0x8EC3: 0x5072,
                0x8EC4: 0x67F4,
                0x8EC5: 0x829D,
                0x8EC6: 0x5C61,
                0x8EC7: 0x854A,
                0x8EC8: 0x7E1E,
                0x8EC9: 0x820E,
                0x8ECA: 0x5199,
                0x8ECB: 0x5C04,
                0x8ECC: 0x6368,
                0x8ECD: 0x8D66,
                0x8ECE: 0x659C,
                0x8ECF: 0x716E,
                0x8ED0: 0x793E,
                0x8ED1: 0x7D17,
                0x8ED2: 0x8005,
                0x8ED3: 0x8B1D,
                0x8ED4: 0x8ECA,
                0x8ED5: 0x906E,
                0x8ED6: 0x86C7,
                0x8ED7: 0x90AA,
                0x8ED8: 0x501F,
                0x8ED9: 0x52FA,
                0x8EDA: 0x5C3A,
                0x8EDB: 0x6753,
                0x8EDC: 0x707C,
                0x8EDD: 0x7235,
                0x8EDE: 0x914C,
                0x8EDF: 0x91C8,
                0x8EE0: 0x932B,
                0x8EE1: 0x82E5,
                0x8EE2: 0x5BC2,
                0x8EE3: 0x5F31,
                0x8EE4: 0x60F9,
                0x8EE5: 0x4E3B,
                0x8EE6: 0x53D6,
                0x8EE7: 0x5B88,
                0x8EE8: 0x624B,
                0x8EE9: 0x6731,
                0x8EEA: 0x6B8A,
                0x8EEB: 0x72E9,
                0x8EEC: 0x73E0,
                0x8EED: 0x7A2E,
                0x8EEE: 0x816B,
                0x8EEF: 0x8DA3,
                0x8EF0: 0x9152,
                0x8EF1: 0x9996,
                0x8EF2: 0x5112,
                0x8EF3: 0x53D7,
                0x8EF4: 0x546A,
                0x8EF5: 0x5BFF,
                0x8EF6: 0x6388,
                0x8EF7: 0x6A39,
                0x8EF8: 0x7DAC,
                0x8EF9: 0x9700,
                0x8EFA: 0x56DA,
                0x8EFB: 0x53CE,
                0x8EFC: 0x5468,
                0x8F40: 0x5B97,
                0x8F41: 0x5C31,
                0x8F42: 0x5DDE,
                0x8F43: 0x4FEE,
                0x8F44: 0x6101,
                0x8F45: 0x62FE,
                0x8F46: 0x6D32,
                0x8F47: 0x79C0,
                0x8F48: 0x79CB,
                0x8F49: 0x7D42,
                0x8F4A: 0x7E4D,
                0x8F4B: 0x7FD2,
                0x8F4C: 0x81ED,
                0x8F4D: 0x821F,
                0x8F4E: 0x8490,
                0x8F4F: 0x8846,
                0x8F50: 0x8972,
                0x8F51: 0x8B90,
                0x8F52: 0x8E74,
                0x8F53: 0x8F2F,
                0x8F54: 0x9031,
                0x8F55: 0x914B,
                0x8F56: 0x916C,
                0x8F57: 0x96C6,
                0x8F58: 0x919C,
                0x8F59: 0x4EC0,
                0x8F5A: 0x4F4F,
                0x8F5B: 0x5145,
                0x8F5C: 0x5341,
                0x8F5D: 0x5F93,
                0x8F5E: 0x620E,
                0x8F5F: 0x67D4,
                0x8F60: 0x6C41,
                0x8F61: 0x6E0B,
                0x8F62: 0x7363,
                0x8F63: 0x7E26,
                0x8F64: 0x91CD,
                0x8F65: 0x9283,
                0x8F66: 0x53D4,
                0x8F67: 0x5919,
                0x8F68: 0x5BBF,
                0x8F69: 0x6DD1,
                0x8F6A: 0x795D,
                0x8F6B: 0x7E2E,
                0x8F6C: 0x7C9B,
                0x8F6D: 0x587E,
                0x8F6E: 0x719F,
                0x8F6F: 0x51FA,
                0x8F70: 0x8853,
                0x8F71: 0x8FF0,
                0x8F72: 0x4FCA,
                0x8F73: 0x5CFB,
                0x8F74: 0x6625,
                0x8F75: 0x77AC,
                0x8F76: 0x7AE3,
                0x8F77: 0x821C,
                0x8F78: 0x99FF,
                0x8F79: 0x51C6,
                0x8F7A: 0x5FAA,
                0x8F7B: 0x65EC,
                0x8F7C: 0x696F,
                0x8F7D: 0x6B89,
                0x8F7E: 0x6DF3,
                0x8F80: 0x6E96,
                0x8F81: 0x6F64,
                0x8F82: 0x76FE,
                0x8F83: 0x7D14,
                0x8F84: 0x5DE1,
                0x8F85: 0x9075,
                0x8F86: 0x9187,
                0x8F87: 0x9806,
                0x8F88: 0x51E6,
                0x8F89: 0x521D,
                0x8F8A: 0x6240,
                0x8F8B: 0x6691,
                0x8F8C: 0x66D9,
                0x8F8D: 0x6E1A,
                0x8F8E: 0x5EB6,
                0x8F8F: 0x7DD2,
                0x8F90: 0x7F72,
                0x8F91: 0x66F8,
                0x8F92: 0x85AF,
                0x8F93: 0x85F7,
                0x8F94: 0x8AF8,
                0x8F95: 0x52A9,
                0x8F96: 0x53D9,
                0x8F97: 0x5973,
                0x8F98: 0x5E8F,
                0x8F99: 0x5F90,
                0x8F9A: 0x6055,
                0x8F9B: 0x92E4,
                0x8F9C: 0x9664,
                0x8F9D: 0x50B7,
                0x8F9E: 0x511F,
                0x8F9F: 0x52DD,
                0x8FA0: 0x5320,
                0x8FA1: 0x5347,
                0x8FA2: 0x53EC,
                0x8FA3: 0x54E8,
                0x8FA4: 0x5546,
                0x8FA5: 0x5531,
                0x8FA6: 0x5617,
                0x8FA7: 0x5968,
                0x8FA8: 0x59BE,
                0x8FA9: 0x5A3C,
                0x8FAA: 0x5BB5,
                0x8FAB: 0x5C06,
                0x8FAC: 0x5C0F,
                0x8FAD: 0x5C11,
                0x8FAE: 0x5C1A,
                0x8FAF: 0x5E84,
                0x8FB0: 0x5E8A,
                0x8FB1: 0x5EE0,
                0x8FB2: 0x5F70,
                0x8FB3: 0x627F,
                0x8FB4: 0x6284,
                0x8FB5: 0x62DB,
                0x8FB6: 0x638C,
                0x8FB7: 0x6377,
                0x8FB8: 0x6607,
                0x8FB9: 0x660C,
                0x8FBA: 0x662D,
                0x8FBB: 0x6676,
                0x8FBC: 0x677E,
                0x8FBD: 0x68A2,
                0x8FBE: 0x6A1F,
                0x8FBF: 0x6A35,
                0x8FC0: 0x6CBC,
                0x8FC1: 0x6D88,
                0x8FC2: 0x6E09,
                0x8FC3: 0x6E58,
                0x8FC4: 0x713C,
                0x8FC5: 0x7126,
                0x8FC6: 0x7167,
                0x8FC7: 0x75C7,
                0x8FC8: 0x7701,
                0x8FC9: 0x785D,
                0x8FCA: 0x7901,
                0x8FCB: 0x7965,
                0x8FCC: 0x79F0,
                0x8FCD: 0x7AE0,
                0x8FCE: 0x7B11,
                0x8FCF: 0x7CA7,
                0x8FD0: 0x7D39,
                0x8FD1: 0x8096,
                0x8FD2: 0x83D6,
                0x8FD3: 0x848B,
                0x8FD4: 0x8549,
                0x8FD5: 0x885D,
                0x8FD6: 0x88F3,
                0x8FD7: 0x8A1F,
                0x8FD8: 0x8A3C,
                0x8FD9: 0x8A54,
                0x8FDA: 0x8A73,
                0x8FDB: 0x8C61,
                0x8FDC: 0x8CDE,
                0x8FDD: 0x91A4,
                0x8FDE: 0x9266,
                0x8FDF: 0x937E,
                0x8FE0: 0x9418,
                0x8FE1: 0x969C,
                0x8FE2: 0x9798,
                0x8FE3: 0x4E0A,
                0x8FE4: 0x4E08,
                0x8FE5: 0x4E1E,
                0x8FE6: 0x4E57,
                0x8FE7: 0x5197,
                0x8FE8: 0x5270,
                0x8FE9: 0x57CE,
                0x8FEA: 0x5834,
                0x8FEB: 0x58CC,
                0x8FEC: 0x5B22,
                0x8FED: 0x5E38,
                0x8FEE: 0x60C5,
                0x8FEF: 0x64FE,
                0x8FF0: 0x6761,
                0x8FF1: 0x6756,
                0x8FF2: 0x6D44,
                0x8FF3: 0x72B6,
                0x8FF4: 0x7573,
                0x8FF5: 0x7A63,
                0x8FF6: 0x84B8,
                0x8FF7: 0x8B72,
                0x8FF8: 0x91B8,
                0x8FF9: 0x9320,
                0x8FFA: 0x5631,
                0x8FFB: 0x57F4,
                0x8FFC: 0x98FE,
                0x9040: 0x62ED,
                0x9041: 0x690D,
                0x9042: 0x6B96,
                0x9043: 0x71ED,
                0x9044: 0x7E54,
                0x9045: 0x8077,
                0x9046: 0x8272,
                0x9047: 0x89E6,
                0x9048: 0x98DF,
                0x9049: 0x8755,
                0x904A: 0x8FB1,
                0x904B: 0x5C3B,
                0x904C: 0x4F38,
                0x904D: 0x4FE1,
                0x904E: 0x4FB5,
                0x904F: 0x5507,
                0x9050: 0x5A20,
                0x9051: 0x5BDD,
                0x9052: 0x5BE9,
                0x9053: 0x5FC3,
                0x9054: 0x614E,
                0x9055: 0x632F,
                0x9056: 0x65B0,
                0x9057: 0x664B,
                0x9058: 0x68EE,
                0x9059: 0x699B,
                0x905A: 0x6D78,
                0x905B: 0x6DF1,
                0x905C: 0x7533,
                0x905D: 0x75B9,
                0x905E: 0x771F,
                0x905F: 0x795E,
                0x9060: 0x79E6,
                0x9061: 0x7D33,
                0x9062: 0x81E3,
                0x9063: 0x82AF,
                0x9064: 0x85AA,
                0x9065: 0x89AA,
                0x9066: 0x8A3A,
                0x9067: 0x8EAB,
                0x9068: 0x8F9B,
                0x9069: 0x9032,
                0x906A: 0x91DD,
                0x906B: 0x9707,
                0x906C: 0x4EBA,
                0x906D: 0x4EC1,
                0x906E: 0x5203,
                0x906F: 0x5875,
                0x9070: 0x58EC,
                0x9071: 0x5C0B,
                0x9072: 0x751A,
                0x9073: 0x5C3D,
                0x9074: 0x814E,
                0x9075: 0x8A0A,
                0x9076: 0x8FC5,
                0x9077: 0x9663,
                0x9078: 0x976D,
                0x9079: 0x7B25,
                0x907A: 0x8ACF,
                0x907B: 0x9808,
                0x907C: 0x9162,
                0x907D: 0x56F3,
                0x907E: 0x53A8,
                0x9080: 0x9017,
                0x9081: 0x5439,
                0x9082: 0x5782,
                0x9083: 0x5E25,
                0x9084: 0x63A8,
                0x9085: 0x6C34,
                0x9086: 0x708A,
                0x9087: 0x7761,
                0x9088: 0x7C8B,
                0x9089: 0x7FE0,
                0x908A: 0x8870,
                0x908B: 0x9042,
                0x908C: 0x9154,
                0x908D: 0x9310,
                0x908E: 0x9318,
                0x908F: 0x968F,
                0x9090: 0x745E,
                0x9091: 0x9AC4,
                0x9092: 0x5D07,
                0x9093: 0x5D69,
                0x9094: 0x6570,
                0x9095: 0x67A2,
                0x9096: 0x8DA8,
                0x9097: 0x96DB,
                0x9098: 0x636E,
                0x9099: 0x6749,
                0x909A: 0x6919,
                0x909B: 0x83C5,
                0x909C: 0x9817,
                0x909D: 0x96C0,
                0x909E: 0x88FE,
                0x909F: 0x6F84,
                0x90A0: 0x647A,
                0x90A1: 0x5BF8,
                0x90A2: 0x4E16,
                0x90A3: 0x702C,
                0x90A4: 0x755D,
                0x90A5: 0x662F,
                0x90A6: 0x51C4,
                0x90A7: 0x5236,
                0x90A8: 0x52E2,
                0x90A9: 0x59D3,
                0x90AA: 0x5F81,
                0x90AB: 0x6027,
                0x90AC: 0x6210,
                0x90AD: 0x653F,
                0x90AE: 0x6574,
                0x90AF: 0x661F,
                0x90B0: 0x6674,
                0x90B1: 0x68F2,
                0x90B2: 0x6816,
                0x90B3: 0x6B63,
                0x90B4: 0x6E05,
                0x90B5: 0x7272,
                0x90B6: 0x751F,
                0x90B7: 0x76DB,
                0x90B8: 0x7CBE,
                0x90B9: 0x8056,
                0x90BA: 0x58F0,
                0x90BB: 0x88FD,
                0x90BC: 0x897F,
                0x90BD: 0x8AA0,
                0x90BE: 0x8A93,
                0x90BF: 0x8ACB,
                0x90C0: 0x901D,
                0x90C1: 0x9192,
                0x90C2: 0x9752,
                0x90C3: 0x9759,
                0x90C4: 0x6589,
                0x90C5: 0x7A0E,
                0x90C6: 0x8106,
                0x90C7: 0x96BB,
                0x90C8: 0x5E2D,
                0x90C9: 0x60DC,
                0x90CA: 0x621A,
                0x90CB: 0x65A5,
                0x90CC: 0x6614,
                0x90CD: 0x6790,
                0x90CE: 0x77F3,
                0x90CF: 0x7A4D,
                0x90D0: 0x7C4D,
                0x90D1: 0x7E3E,
                0x90D2: 0x810A,
                0x90D3: 0x8CAC,
                0x90D4: 0x8D64,
                0x90D5: 0x8DE1,
                0x90D6: 0x8E5F,
                0x90D7: 0x78A9,
                0x90D8: 0x5207,
                0x90D9: 0x62D9,
                0x90DA: 0x63A5,
                0x90DB: 0x6442,
                0x90DC: 0x6298,
                0x90DD: 0x8A2D,
                0x90DE: 0x7A83,
                0x90DF: 0x7BC0,
                0x90E0: 0x8AAC,
                0x90E1: 0x96EA,
                0x90E2: 0x7D76,
                0x90E3: 0x820C,
                0x90E4: 0x8749,
                0x90E5: 0x4ED9,
                0x90E6: 0x5148,
                0x90E7: 0x5343,
                0x90E8: 0x5360,
                0x90E9: 0x5BA3,
                0x90EA: 0x5C02,
                0x90EB: 0x5C16,
                0x90EC: 0x5DDD,
                0x90ED: 0x6226,
                0x90EE: 0x6247,
                0x90EF: 0x64B0,
                0x90F0: 0x6813,
                0x90F1: 0x6834,
                0x90F2: 0x6CC9,
                0x90F3: 0x6D45,
                0x90F4: 0x6D17,
                0x90F5: 0x67D3,
                0x90F6: 0x6F5C,
                0x90F7: 0x714E,
                0x90F8: 0x717D,
                0x90F9: 0x65CB,
                0x90FA: 0x7A7F,
                0x90FB: 0x7BAD,
                0x90FC: 0x7DDA,
                0x9140: 0x7E4A,
                0x9141: 0x7FA8,
                0x9142: 0x817A,
                0x9143: 0x821B,
                0x9144: 0x8239,
                0x9145: 0x85A6,
                0x9146: 0x8A6E,
                0x9147: 0x8CCE,
                0x9148: 0x8DF5,
                0x9149: 0x9078,
                0x914A: 0x9077,
                0x914B: 0x92AD,
                0x914C: 0x9291,
                0x914D: 0x9583,
                0x914E: 0x9BAE,
                0x914F: 0x524D,
                0x9150: 0x5584,
                0x9151: 0x6F38,
                0x9152: 0x7136,
                0x9153: 0x5168,
                0x9154: 0x7985,
                0x9155: 0x7E55,
                0x9156: 0x81B3,
                0x9157: 0x7CCE,
                0x9158: 0x564C,
                0x9159: 0x5851,
                0x915A: 0x5CA8,
                0x915B: 0x63AA,
                0x915C: 0x66FE,
                0x915D: 0x66FD,
                0x915E: 0x695A,
                0x915F: 0x72D9,
                0x9160: 0x758F,
                0x9161: 0x758E,
                0x9162: 0x790E,
                0x9163: 0x7956,
                0x9164: 0x79DF,
                0x9165: 0x7C97,
                0x9166: 0x7D20,
                0x9167: 0x7D44,
                0x9168: 0x8607,
                0x9169: 0x8A34,
                0x916A: 0x963B,
                0x916B: 0x9061,
                0x916C: 0x9F20,
                0x916D: 0x50E7,
                0x916E: 0x5275,
                0x916F: 0x53CC,
                0x9170: 0x53E2,
                0x9171: 0x5009,
                0x9172: 0x55AA,
                0x9173: 0x58EE,
                0x9174: 0x594F,
                0x9175: 0x723D,
                0x9176: 0x5B8B,
                0x9177: 0x5C64,
                0x9178: 0x531D,
                0x9179: 0x60E3,
                0x917A: 0x60F3,
                0x917B: 0x635C,
                0x917C: 0x6383,
                0x917D: 0x633F,
                0x917E: 0x63BB,
                0x9180: 0x64CD,
                0x9181: 0x65E9,
                0x9182: 0x66F9,
                0x9183: 0x5DE3,
                0x9184: 0x69CD,
                0x9185: 0x69FD,
                0x9186: 0x6F15,
                0x9187: 0x71E5,
                0x9188: 0x4E89,
                0x9189: 0x75E9,
                0x918A: 0x76F8,
                0x918B: 0x7A93,
                0x918C: 0x7CDF,
                0x918D: 0x7DCF,
                0x918E: 0x7D9C,
                0x918F: 0x8061,
                0x9190: 0x8349,
                0x9191: 0x8358,
                0x9192: 0x846C,
                0x9193: 0x84BC,
                0x9194: 0x85FB,
                0x9195: 0x88C5,
                0x9196: 0x8D70,
                0x9197: 0x9001,
                0x9198: 0x906D,
                0x9199: 0x9397,
                0x919A: 0x971C,
                0x919B: 0x9A12,
                0x919C: 0x50CF,
                0x919D: 0x5897,
                0x919E: 0x618E,
                0x919F: 0x81D3,
                0x91A0: 0x8535,
                0x91A1: 0x8D08,
                0x91A2: 0x9020,
                0x91A3: 0x4FC3,
                0x91A4: 0x5074,
                0x91A5: 0x5247,
                0x91A6: 0x5373,
                0x91A7: 0x606F,
                0x91A8: 0x6349,
                0x91A9: 0x675F,
                0x91AA: 0x6E2C,
                0x91AB: 0x8DB3,
                0x91AC: 0x901F,
                0x91AD: 0x4FD7,
                0x91AE: 0x5C5E,
                0x91AF: 0x8CCA,
                0x91B0: 0x65CF,
                0x91B1: 0x7D9A,
                0x91B2: 0x5352,
                0x91B3: 0x8896,
                0x91B4: 0x5176,
                0x91B5: 0x63C3,
                0x91B6: 0x5B58,
                0x91B7: 0x5B6B,
                0x91B8: 0x5C0A,
                0x91B9: 0x640D,
                0x91BA: 0x6751,
                0x91BB: 0x905C,
                0x91BC: 0x4ED6,
                0x91BD: 0x591A,
                0x91BE: 0x592A,
                0x91BF: 0x6C70,
                0x91C0: 0x8A51,
                0x91C1: 0x553E,
                0x91C2: 0x5815,
                0x91C3: 0x59A5,
                0x91C4: 0x60F0,
                0x91C5: 0x6253,
                0x91C6: 0x67C1,
                0x91C7: 0x8235,
                0x91C8: 0x6955,
                0x91C9: 0x9640,
                0x91CA: 0x99C4,
                0x91CB: 0x9A28,
                0x91CC: 0x4F53,
                0x91CD: 0x5806,
                0x91CE: 0x5BFE,
                0x91CF: 0x8010,
                0x91D0: 0x5CB1,
                0x91D1: 0x5E2F,
                0x91D2: 0x5F85,
                0x91D3: 0x6020,
                0x91D4: 0x614B,
                0x91D5: 0x6234,
                0x91D6: 0x66FF,
                0x91D7: 0x6CF0,
                0x91D8: 0x6EDE,
                0x91D9: 0x80CE,
                0x91DA: 0x817F,
                0x91DB: 0x82D4,
                0x91DC: 0x888B,
                0x91DD: 0x8CB8,
                0x91DE: 0x9000,
                0x91DF: 0x902E,
                0x91E0: 0x968A,
                0x91E1: 0x9EDB,
                0x91E2: 0x9BDB,
                0x91E3: 0x4EE3,
                0x91E4: 0x53F0,
                0x91E5: 0x5927,
                0x91E6: 0x7B2C,
                0x91E7: 0x918D,
                0x91E8: 0x984C,
                0x91E9: 0x9DF9,
                0x91EA: 0x6EDD,
                0x91EB: 0x7027,
                0x91EC: 0x5353,
                0x91ED: 0x5544,
                0x91EE: 0x5B85,
                0x91EF: 0x6258,
                0x91F0: 0x629E,
                0x91F1: 0x62D3,
                0x91F2: 0x6CA2,
                0x91F3: 0x6FEF,
                0x91F4: 0x7422,
                0x91F5: 0x8A17,
                0x91F6: 0x9438,
                0x91F7: 0x6FC1,
                0x91F8: 0x8AFE,
                0x91F9: 0x8338,
                0x91FA: 0x51E7,
                0x91FB: 0x86F8,
                0x91FC: 0x53EA,
                0x9240: 0x53E9,
                0x9241: 0x4F46,
                0x9242: 0x9054,
                0x9243: 0x8FB0,
                0x9244: 0x596A,
                0x9245: 0x8131,
                0x9246: 0x5DFD,
                0x9247: 0x7AEA,
                0x9248: 0x8FBF,
                0x9249: 0x68DA,
                0x924A: 0x8C37,
                0x924B: 0x72F8,
                0x924C: 0x9C48,
                0x924D: 0x6A3D,
                0x924E: 0x8AB0,
                0x924F: 0x4E39,
                0x9250: 0x5358,
                0x9251: 0x5606,
                0x9252: 0x5766,
                0x9253: 0x62C5,
                0x9254: 0x63A2,
                0x9255: 0x65E6,
                0x9256: 0x6B4E,
                0x9257: 0x6DE1,
                0x9258: 0x6E5B,
                0x9259: 0x70AD,
                0x925A: 0x77ED,
                0x925B: 0x7AEF,
                0x925C: 0x7BAA,
                0x925D: 0x7DBB,
                0x925E: 0x803D,
                0x925F: 0x80C6,
                0x9260: 0x86CB,
                0x9261: 0x8A95,
                0x9262: 0x935B,
                0x9263: 0x56E3,
                0x9264: 0x58C7,
                0x9265: 0x5F3E,
                0x9266: 0x65AD,
                0x9267: 0x6696,
                0x9268: 0x6A80,
                0x9269: 0x6BB5,
                0x926A: 0x7537,
                0x926B: 0x8AC7,
                0x926C: 0x5024,
                0x926D: 0x77E5,
                0x926E: 0x5730,
                0x926F: 0x5F1B,
                0x9270: 0x6065,
                0x9271: 0x667A,
                0x9272: 0x6C60,
                0x9273: 0x75F4,
                0x9274: 0x7A1A,
                0x9275: 0x7F6E,
                0x9276: 0x81F4,
                0x9277: 0x8718,
                0x9278: 0x9045,
                0x9279: 0x99B3,
                0x927A: 0x7BC9,
                0x927B: 0x755C,
                0x927C: 0x7AF9,
                0x927D: 0x7B51,
                0x927E: 0x84C4,
                0x9280: 0x9010,
                0x9281: 0x79E9,
                0x9282: 0x7A92,
                0x9283: 0x8336,
                0x9284: 0x5AE1,
                0x9285: 0x7740,
                0x9286: 0x4E2D,
                0x9287: 0x4EF2,
                0x9288: 0x5B99,
                0x9289: 0x5FE0,
                0x928A: 0x62BD,
                0x928B: 0x663C,
                0x928C: 0x67F1,
                0x928D: 0x6CE8,
                0x928E: 0x866B,
                0x928F: 0x8877,
                0x9290: 0x8A3B,
                0x9291: 0x914E,
                0x9292: 0x92F3,
                0x9293: 0x99D0,
                0x9294: 0x6A17,
                0x9295: 0x7026,
                0x9296: 0x732A,
                0x9297: 0x82E7,
                0x9298: 0x8457,
                0x9299: 0x8CAF,
                0x929A: 0x4E01,
                0x929B: 0x5146,
                0x929C: 0x51CB,
                0x929D: 0x558B,
                0x929E: 0x5BF5,
                0x929F: 0x5E16,
                0x92A0: 0x5E33,
                0x92A1: 0x5E81,
                0x92A2: 0x5F14,
                0x92A3: 0x5F35,
                0x92A4: 0x5F6B,
                0x92A5: 0x5FB4,
                0x92A6: 0x61F2,
                0x92A7: 0x6311,
                0x92A8: 0x66A2,
                0x92A9: 0x671D,
                0x92AA: 0x6F6E,
                0x92AB: 0x7252,
                0x92AC: 0x753A,
                0x92AD: 0x773A,
                0x92AE: 0x8074,
                0x92AF: 0x8139,
                0x92B0: 0x8178,
                0x92B1: 0x8776,
                0x92B2: 0x8ABF,
                0x92B3: 0x8ADC,
                0x92B4: 0x8D85,
                0x92B5: 0x8DF3,
                0x92B6: 0x929A,
                0x92B7: 0x9577,
                0x92B8: 0x9802,
                0x92B9: 0x9CE5,
                0x92BA: 0x52C5,
                0x92BB: 0x6357,
                0x92BC: 0x76F4,
                0x92BD: 0x6715,
                0x92BE: 0x6C88,
                0x92BF: 0x73CD,
                0x92C0: 0x8CC3,
                0x92C1: 0x93AE,
                0x92C2: 0x9673,
                0x92C3: 0x6D25,
                0x92C4: 0x589C,
                0x92C5: 0x690E,
                0x92C6: 0x69CC,
                0x92C7: 0x8FFD,
                0x92C8: 0x939A,
                0x92C9: 0x75DB,
                0x92CA: 0x901A,
                0x92CB: 0x585A,
                0x92CC: 0x6802,
                0x92CD: 0x63B4,
                0x92CE: 0x69FB,
                0x92CF: 0x4F43,
                0x92D0: 0x6F2C,
                0x92D1: 0x67D8,
                0x92D2: 0x8FBB,
                0x92D3: 0x8526,
                0x92D4: 0x7DB4,
                0x92D5: 0x9354,
                0x92D6: 0x693F,
                0x92D7: 0x6F70,
                0x92D8: 0x576A,
                0x92D9: 0x58F7,
                0x92DA: 0x5B2C,
                0x92DB: 0x7D2C,
                0x92DC: 0x722A,
                0x92DD: 0x540A,
                0x92DE: 0x91E3,
                0x92DF: 0x9DB4,
                0x92E0: 0x4EAD,
                0x92E1: 0x4F4E,
                0x92E2: 0x505C,
                0x92E3: 0x5075,
                0x92E4: 0x5243,
                0x92E5: 0x8C9E,
                0x92E6: 0x5448,
                0x92E7: 0x5824,
                0x92E8: 0x5B9A,
                0x92E9: 0x5E1D,
                0x92EA: 0x5E95,
                0x92EB: 0x5EAD,
                0x92EC: 0x5EF7,
                0x92ED: 0x5F1F,
                0x92EE: 0x608C,
                0x92EF: 0x62B5,
                0x92F0: 0x633A,
                0x92F1: 0x63D0,
                0x92F2: 0x68AF,
                0x92F3: 0x6C40,
                0x92F4: 0x7887,
                0x92F5: 0x798E,
                0x92F6: 0x7A0B,
                0x92F7: 0x7DE0,
                0x92F8: 0x8247,
                0x92F9: 0x8A02,
                0x92FA: 0x8AE6,
                0x92FB: 0x8E44,
                0x92FC: 0x9013,
                0x9340: 0x90B8,
                0x9341: 0x912D,
                0x9342: 0x91D8,
                0x9343: 0x9F0E,
                0x9344: 0x6CE5,
                0x9345: 0x6458,
                0x9346: 0x64E2,
                0x9347: 0x6575,
                0x9348: 0x6EF4,
                0x9349: 0x7684,
                0x934A: 0x7B1B,
                0x934B: 0x9069,
                0x934C: 0x93D1,
                0x934D: 0x6EBA,
                0x934E: 0x54F2,
                0x934F: 0x5FB9,
                0x9350: 0x64A4,
                0x9351: 0x8F4D,
                0x9352: 0x8FED,
                0x9353: 0x9244,
                0x9354: 0x5178,
                0x9355: 0x586B,
                0x9356: 0x5929,
                0x9357: 0x5C55,
                0x9358: 0x5E97,
                0x9359: 0x6DFB,
                0x935A: 0x7E8F,
                0x935B: 0x751C,
                0x935C: 0x8CBC,
                0x935D: 0x8EE2,
                0x935E: 0x985B,
                0x935F: 0x70B9,
                0x9360: 0x4F1D,
                0x9361: 0x6BBF,
                0x9362: 0x6FB1,
                0x9363: 0x7530,
                0x9364: 0x96FB,
                0x9365: 0x514E,
                0x9366: 0x5410,
                0x9367: 0x5835,
                0x9368: 0x5857,
                0x9369: 0x59AC,
                0x936A: 0x5C60,
                0x936B: 0x5F92,
                0x936C: 0x6597,
                0x936D: 0x675C,
                0x936E: 0x6E21,
                0x936F: 0x767B,
                0x9370: 0x83DF,
                0x9371: 0x8CED,
                0x9372: 0x9014,
                0x9373: 0x90FD,
                0x9374: 0x934D,
                0x9375: 0x7825,
                0x9376: 0x783A,
                0x9377: 0x52AA,
                0x9378: 0x5EA6,
                0x9379: 0x571F,
                0x937A: 0x5974,
                0x937B: 0x6012,
                0x937C: 0x5012,
                0x937D: 0x515A,
                0x937E: 0x51AC,
                0x9380: 0x51CD,
                0x9381: 0x5200,
                0x9382: 0x5510,
                0x9383: 0x5854,
                0x9384: 0x5858,
                0x9385: 0x5957,
                0x9386: 0x5B95,
                0x9387: 0x5CF6,
                0x9388: 0x5D8B,
                0x9389: 0x60BC,
                0x938A: 0x6295,
                0x938B: 0x642D,
                0x938C: 0x6771,
                0x938D: 0x6843,
                0x938E: 0x68BC,
                0x938F: 0x68DF,
                0x9390: 0x76D7,
                0x9391: 0x6DD8,
                0x9392: 0x6E6F,
                0x9393: 0x6D9B,
                0x9394: 0x706F,
                0x9395: 0x71C8,
                0x9396: 0x5F53,
                0x9397: 0x75D8,
                0x9398: 0x7977,
                0x9399: 0x7B49,
                0x939A: 0x7B54,
                0x939B: 0x7B52,
                0x939C: 0x7CD6,
                0x939D: 0x7D71,
                0x939E: 0x5230,
                0x939F: 0x8463,
                0x93A0: 0x8569,
                0x93A1: 0x85E4,
                0x93A2: 0x8A0E,
                0x93A3: 0x8B04,
                0x93A4: 0x8C46,
                0x93A5: 0x8E0F,
                0x93A6: 0x9003,
                0x93A7: 0x900F,
                0x93A8: 0x9419,
                0x93A9: 0x9676,
                0x93AA: 0x982D,
                0x93AB: 0x9A30,
                0x93AC: 0x95D8,
                0x93AD: 0x50CD,
                0x93AE: 0x52D5,
                0x93AF: 0x540C,
                0x93B0: 0x5802,
                0x93B1: 0x5C0E,
                0x93B2: 0x61A7,
                0x93B3: 0x649E,
                0x93B4: 0x6D1E,
                0x93B5: 0x77B3,
                0x93B6: 0x7AE5,
                0x93B7: 0x80F4,
                0x93B8: 0x8404,
                0x93B9: 0x9053,
                0x93BA: 0x9285,
                0x93BB: 0x5CE0,
                0x93BC: 0x9D07,
                0x93BD: 0x533F,
                0x93BE: 0x5F97,
                0x93BF: 0x5FB3,
                0x93C0: 0x6D9C,
                0x93C1: 0x7279,
                0x93C2: 0x7763,
                0x93C3: 0x79BF,
                0x93C4: 0x7BE4,
                0x93C5: 0x6BD2,
                0x93C6: 0x72EC,
                0x93C7: 0x8AAD,
                0x93C8: 0x6803,
                0x93C9: 0x6A61,
                0x93CA: 0x51F8,
                0x93CB: 0x7A81,
                0x93CC: 0x6934,
                0x93CD: 0x5C4A,
                0x93CE: 0x9CF6,
                0x93CF: 0x82EB,
                0x93D0: 0x5BC5,
                0x93D1: 0x9149,
                0x93D2: 0x701E,
                0x93D3: 0x5678,
                0x93D4: 0x5C6F,
                0x93D5: 0x60C7,
                0x93D6: 0x6566,
                0x93D7: 0x6C8C,
                0x93D8: 0x8C5A,
                0x93D9: 0x9041,
                0x93DA: 0x9813,
                0x93DB: 0x5451,
                0x93DC: 0x66C7,
                0x93DD: 0x920D,
                0x93DE: 0x5948,
                0x93DF: 0x90A3,
                0x93E0: 0x5185,
                0x93E1: 0x4E4D,
                0x93E2: 0x51EA,
                0x93E3: 0x8599,
                0x93E4: 0x8B0E,
                0x93E5: 0x7058,
                0x93E6: 0x637A,
                0x93E7: 0x934B,
                0x93E8: 0x6962,
                0x93E9: 0x99B4,
                0x93EA: 0x7E04,
                0x93EB: 0x7577,
                0x93EC: 0x5357,
                0x93ED: 0x6960,
                0x93EE: 0x8EDF,
                0x93EF: 0x96E3,
                0x93F0: 0x6C5D,
                0x93F1: 0x4E8C,
                0x93F2: 0x5C3C,
                0x93F3: 0x5F10,
                0x93F4: 0x8FE9,
                0x93F5: 0x5302,
                0x93F6: 0x8CD1,
                0x93F7: 0x8089,
                0x93F8: 0x8679,
                0x93F9: 0x5EFF,
                0x93FA: 0x65E5,
                0x93FB: 0x4E73,
                0x93FC: 0x5165,
                0x9440: 0x5982,
                0x9441: 0x5C3F,
                0x9442: 0x97EE,
                0x9443: 0x4EFB,
                0x9444: 0x598A,
                0x9445: 0x5FCD,
                0x9446: 0x8A8D,
                0x9447: 0x6FE1,
                0x9448: 0x79B0,
                0x9449: 0x7962,
                0x944A: 0x5BE7,
                0x944B: 0x8471,
                0x944C: 0x732B,
                0x944D: 0x71B1,
                0x944E: 0x5E74,
                0x944F: 0x5FF5,
                0x9450: 0x637B,
                0x9451: 0x649A,
                0x9452: 0x71C3,
                0x9453: 0x7C98,
                0x9454: 0x4E43,
                0x9455: 0x5EFC,
                0x9456: 0x4E4B,
                0x9457: 0x57DC,
                0x9458: 0x56A2,
                0x9459: 0x60A9,
                0x945A: 0x6FC3,
                0x945B: 0x7D0D,
                0x945C: 0x80FD,
                0x945D: 0x8133,
                0x945E: 0x81BF,
                0x945F: 0x8FB2,
                0x9460: 0x8997,
                0x9461: 0x86A4,
                0x9462: 0x5DF4,
                0x9463: 0x628A,
                0x9464: 0x64AD,
                0x9465: 0x8987,
                0x9466: 0x6777,
                0x9467: 0x6CE2,
                0x9468: 0x6D3E,
                0x9469: 0x7436,
                0x946A: 0x7834,
                0x946B: 0x5A46,
                0x946C: 0x7F75,
                0x946D: 0x82AD,
                0x946E: 0x99AC,
                0x946F: 0x4FF3,
                0x9470: 0x5EC3,
                0x9471: 0x62DD,
                0x9472: 0x6392,
                0x9473: 0x6557,
                0x9474: 0x676F,
                0x9475: 0x76C3,
                0x9476: 0x724C,
                0x9477: 0x80CC,
                0x9478: 0x80BA,
                0x9479: 0x8F29,
                0x947A: 0x914D,
                0x947B: 0x500D,
                0x947C: 0x57F9,
                0x947D: 0x5A92,
                0x947E: 0x6885,
                0x9480: 0x6973,
                0x9481: 0x7164,
                0x9482: 0x72FD,
                0x9483: 0x8CB7,
                0x9484: 0x58F2,
                0x9485: 0x8CE0,
                0x9486: 0x966A,
                0x9487: 0x9019,
                0x9488: 0x877F,
                0x9489: 0x79E4,
                0x948A: 0x77E7,
                0x948B: 0x8429,
                0x948C: 0x4F2F,
                0x948D: 0x5265,
                0x948E: 0x535A,
                0x948F: 0x62CD,
                0x9490: 0x67CF,
                0x9491: 0x6CCA,
                0x9492: 0x767D,
                0x9493: 0x7B94,
                0x9494: 0x7C95,
                0x9495: 0x8236,
                0x9496: 0x8584,
                0x9497: 0x8FEB,
                0x9498: 0x66DD,
                0x9499: 0x6F20,
                0x949A: 0x7206,
                0x949B: 0x7E1B,
                0x949C: 0x83AB,
                0x949D: 0x99C1,
                0x949E: 0x9EA6,
                0x949F: 0x51FD,
                0x94A0: 0x7BB1,
                0x94A1: 0x7872,
                0x94A2: 0x7BB8,
                0x94A3: 0x8087,
                0x94A4: 0x7B48,
                0x94A5: 0x6AE8,
                0x94A6: 0x5E61,
                0x94A7: 0x808C,
                0x94A8: 0x7551,
                0x94A9: 0x7560,
                0x94AA: 0x516B,
                0x94AB: 0x9262,
                0x94AC: 0x6E8C,
                0x94AD: 0x767A,
                0x94AE: 0x9197,
                0x94AF: 0x9AEA,
                0x94B0: 0x4F10,
                0x94B1: 0x7F70,
                0x94B2: 0x629C,
                0x94B3: 0x7B4F,
                0x94B4: 0x95A5,
                0x94B5: 0x9CE9,
                0x94B6: 0x567A,
                0x94B7: 0x5859,
                0x94B8: 0x86E4,
                0x94B9: 0x96BC,
                0x94BA: 0x4F34,
                0x94BB: 0x5224,
                0x94BC: 0x534A,
                0x94BD: 0x53CD,
                0x94BE: 0x53DB,
                0x94BF: 0x5E06,
                0x94C0: 0x642C,
                0x94C1: 0x6591,
                0x94C2: 0x677F,
                0x94C3: 0x6C3E,
                0x94C4: 0x6C4E,
                0x94C5: 0x7248,
                0x94C6: 0x72AF,
                0x94C7: 0x73ED,
                0x94C8: 0x7554,
                0x94C9: 0x7E41,
                0x94CA: 0x822C,
                0x94CB: 0x85E9,
                0x94CC: 0x8CA9,
                0x94CD: 0x7BC4,
                0x94CE: 0x91C6,
                0x94CF: 0x7169,
                0x94D0: 0x9812,
                0x94D1: 0x98EF,
                0x94D2: 0x633D,
                0x94D3: 0x6669,
                0x94D4: 0x756A,
                0x94D5: 0x76E4,
                0x94D6: 0x78D0,
                0x94D7: 0x8543,
                0x94D8: 0x86EE,
                0x94D9: 0x532A,
                0x94DA: 0x5351,
                0x94DB: 0x5426,
                0x94DC: 0x5983,
                0x94DD: 0x5E87,
                0x94DE: 0x5F7C,
                0x94DF: 0x60B2,
                0x94E0: 0x6249,
                0x94E1: 0x6279,
                0x94E2: 0x62AB,
                0x94E3: 0x6590,
                0x94E4: 0x6BD4,
                0x94E5: 0x6CCC,
                0x94E6: 0x75B2,
                0x94E7: 0x76AE,
                0x94E8: 0x7891,
                0x94E9: 0x79D8,
                0x94EA: 0x7DCB,
                0x94EB: 0x7F77,
                0x94EC: 0x80A5,
                0x94ED: 0x88AB,
                0x94EE: 0x8AB9,
                0x94EF: 0x8CBB,
                0x94F0: 0x907F,
                0x94F1: 0x975E,
                0x94F2: 0x98DB,
                0x94F3: 0x6A0B,
                0x94F4: 0x7C38,
                0x94F5: 0x5099,
                0x94F6: 0x5C3E,
                0x94F7: 0x5FAE,
                0x94F8: 0x6787,
                0x94F9: 0x6BD8,
                0x94FA: 0x7435,
                0x94FB: 0x7709,
                0x94FC: 0x7F8E,
                0x9540: 0x9F3B,
                0x9541: 0x67CA,
                0x9542: 0x7A17,
                0x9543: 0x5339,
                0x9544: 0x758B,
                0x9545: 0x9AED,
                0x9546: 0x5F66,
                0x9547: 0x819D,
                0x9548: 0x83F1,
                0x9549: 0x8098,
                0x954A: 0x5F3C,
                0x954B: 0x5FC5,
                0x954C: 0x7562,
                0x954D: 0x7B46,
                0x954E: 0x903C,
                0x954F: 0x6867,
                0x9550: 0x59EB,
                0x9551: 0x5A9B,
                0x9552: 0x7D10,
                0x9553: 0x767E,
                0x9554: 0x8B2C,
                0x9555: 0x4FF5,
                0x9556: 0x5F6A,
                0x9557: 0x6A19,
                0x9558: 0x6C37,
                0x9559: 0x6F02,
                0x955A: 0x74E2,
                0x955B: 0x7968,
                0x955C: 0x8868,
                0x955D: 0x8A55,
                0x955E: 0x8C79,
                0x955F: 0x5EDF,
                0x9560: 0x63CF,
                0x9561: 0x75C5,
                0x9562: 0x79D2,
                0x9563: 0x82D7,
                0x9564: 0x9328,
                0x9565: 0x92F2,
                0x9566: 0x849C,
                0x9567: 0x86ED,
                0x9568: 0x9C2D,
                0x9569: 0x54C1,
                0x956A: 0x5F6C,
                0x956B: 0x658C,
                0x956C: 0x6D5C,
                0x956D: 0x7015,
                0x956E: 0x8CA7,
                0x956F: 0x8CD3,
                0x9570: 0x983B,
                0x9571: 0x654F,
                0x9572: 0x74F6,
                0x9573: 0x4E0D,
                0x9574: 0x4ED8,
                0x9575: 0x57E0,
                0x9576: 0x592B,
                0x9577: 0x5A66,
                0x9578: 0x5BCC,
                0x9579: 0x51A8,
                0x957A: 0x5E03,
                0x957B: 0x5E9C,
                0x957C: 0x6016,
                0x957D: 0x6276,
                0x957E: 0x6577,
                0x9580: 0x65A7,
                0x9581: 0x666E,
                0x9582: 0x6D6E,
                0x9583: 0x7236,
                0x9584: 0x7B26,
                0x9585: 0x8150,
                0x9586: 0x819A,
                0x9587: 0x8299,
                0x9588: 0x8B5C,
                0x9589: 0x8CA0,
                0x958A: 0x8CE6,
                0x958B: 0x8D74,
                0x958C: 0x961C,
                0x958D: 0x9644,
                0x958E: 0x4FAE,
                0x958F: 0x64AB,
                0x9590: 0x6B66,
                0x9591: 0x821E,
                0x9592: 0x8461,
                0x9593: 0x856A,
                0x9594: 0x90E8,
                0x9595: 0x5C01,
                0x9596: 0x6953,
                0x9597: 0x98A8,
                0x9598: 0x847A,
                0x9599: 0x8557,
                0x959A: 0x4F0F,
                0x959B: 0x526F,
                0x959C: 0x5FA9,
                0x959D: 0x5E45,
                0x959E: 0x670D,
                0x959F: 0x798F,
                0x95A0: 0x8179,
                0x95A1: 0x8907,
                0x95A2: 0x8986,
                0x95A3: 0x6DF5,
                0x95A4: 0x5F17,
                0x95A5: 0x6255,
                0x95A6: 0x6CB8,
                0x95A7: 0x4ECF,
                0x95A8: 0x7269,
                0x95A9: 0x9B92,
                0x95AA: 0x5206,
                0x95AB: 0x543B,
                0x95AC: 0x5674,
                0x95AD: 0x58B3,
                0x95AE: 0x61A4,
                0x95AF: 0x626E,
                0x95B0: 0x711A,
                0x95B1: 0x596E,
                0x95B2: 0x7C89,
                0x95B3: 0x7CDE,
                0x95B4: 0x7D1B,
                0x95B5: 0x96F0,
                0x95B6: 0x6587,
                0x95B7: 0x805E,
                0x95B8: 0x4E19,
                0x95B9: 0x4F75,
                0x95BA: 0x5175,
                0x95BB: 0x5840,
                0x95BC: 0x5E63,
                0x95BD: 0x5E73,
                0x95BE: 0x5F0A,
                0x95BF: 0x67C4,
                0x95C0: 0x4E26,
                0x95C1: 0x853D,
                0x95C2: 0x9589,
                0x95C3: 0x965B,
                0x95C4: 0x7C73,
                0x95C5: 0x9801,
                0x95C6: 0x50FB,
                0x95C7: 0x58C1,
                0x95C8: 0x7656,
                0x95C9: 0x78A7,
                0x95CA: 0x5225,
                0x95CB: 0x77A5,
                0x95CC: 0x8511,
                0x95CD: 0x7B86,
                0x95CE: 0x504F,
                0x95CF: 0x5909,
                0x95D0: 0x7247,
                0x95D1: 0x7BC7,
                0x95D2: 0x7DE8,
                0x95D3: 0x8FBA,
                0x95D4: 0x8FD4,
                0x95D5: 0x904D,
                0x95D6: 0x4FBF,
                0x95D7: 0x52C9,
                0x95D8: 0x5A29,
                0x95D9: 0x5F01,
                0x95DA: 0x97AD,
                0x95DB: 0x4FDD,
                0x95DC: 0x8217,
                0x95DD: 0x92EA,
                0x95DE: 0x5703,
                0x95DF: 0x6355,
                0x95E0: 0x6B69,
                0x95E1: 0x752B,
                0x95E2: 0x88DC,
                0x95E3: 0x8F14,
                0x95E4: 0x7A42,
                0x95E5: 0x52DF,
                0x95E6: 0x5893,
                0x95E7: 0x6155,
                0x95E8: 0x620A,
                0x95E9: 0x66AE,
                0x95EA: 0x6BCD,
                0x95EB: 0x7C3F,
                0x95EC: 0x83E9,
                0x95ED: 0x5023,
                0x95EE: 0x4FF8,
                0x95EF: 0x5305,
                0x95F0: 0x5446,
                0x95F1: 0x5831,
                0x95F2: 0x5949,
                0x95F3: 0x5B9D,
                0x95F4: 0x5CF0,
                0x95F5: 0x5CEF,
                0x95F6: 0x5D29,
                0x95F7: 0x5E96,
                0x95F8: 0x62B1,
                0x95F9: 0x6367,
                0x95FA: 0x653E,
                0x95FB: 0x65B9,
                0x95FC: 0x670B,
                0x9640: 0x6CD5,
                0x9641: 0x6CE1,
                0x9642: 0x70F9,
                0x9643: 0x7832,
                0x9644: 0x7E2B,
                0x9645: 0x80DE,
                0x9646: 0x82B3,
                0x9647: 0x840C,
                0x9648: 0x84EC,
                0x9649: 0x8702,
                0x964A: 0x8912,
                0x964B: 0x8A2A,
                0x964C: 0x8C4A,
                0x964D: 0x90A6,
                0x964E: 0x92D2,
                0x964F: 0x98FD,
                0x9650: 0x9CF3,
                0x9651: 0x9D6C,
                0x9652: 0x4E4F,
                0x9653: 0x4EA1,
                0x9654: 0x508D,
                0x9655: 0x5256,
                0x9656: 0x574A,
                0x9657: 0x59A8,
                0x9658: 0x5E3D,
                0x9659: 0x5FD8,
                0x965A: 0x5FD9,
                0x965B: 0x623F,
                0x965C: 0x66B4,
                0x965D: 0x671B,
                0x965E: 0x67D0,
                0x965F: 0x68D2,
                0x9660: 0x5192,
                0x9661: 0x7D21,
                0x9662: 0x80AA,
                0x9663: 0x81A8,
                0x9664: 0x8B00,
                0x9665: 0x8C8C,
                0x9666: 0x8CBF,
                0x9667: 0x927E,
                0x9668: 0x9632,
                0x9669: 0x5420,
                0x966A: 0x982C,
                0x966B: 0x5317,
                0x966C: 0x50D5,
                0x966D: 0x535C,
                0x966E: 0x58A8,
                0x966F: 0x64B2,
                0x9670: 0x6734,
                0x9671: 0x7267,
                0x9672: 0x7766,
                0x9673: 0x7A46,
                0x9674: 0x91E6,
                0x9675: 0x52C3,
                0x9676: 0x6CA1,
                0x9677: 0x6B86,
                0x9678: 0x5800,
                0x9679: 0x5E4C,
                0x967A: 0x5954,
                0x967B: 0x672C,
                0x967C: 0x7FFB,
                0x967D: 0x51E1,
                0x967E: 0x76C6,
                0x9680: 0x6469,
                0x9681: 0x78E8,
                0x9682: 0x9B54,
                0x9683: 0x9EBB,
                0x9684: 0x57CB,
                0x9685: 0x59B9,
                0x9686: 0x6627,
                0x9687: 0x679A,
                0x9688: 0x6BCE,
                0x9689: 0x54E9,
                0x968A: 0x69D9,
                0x968B: 0x5E55,
                0x968C: 0x819C,
                0x968D: 0x6795,
                0x968E: 0x9BAA,
                0x968F: 0x67FE,
                0x9690: 0x9C52,
                0x9691: 0x685D,
                0x9692: 0x4EA6,
                0x9693: 0x4FE3,
                0x9694: 0x53C8,
                0x9695: 0x62B9,
                0x9696: 0x672B,
                0x9697: 0x6CAB,
                0x9698: 0x8FC4,
                0x9699: 0x4FAD,
                0x969A: 0x7E6D,
                0x969B: 0x9EBF,
                0x969C: 0x4E07,
                0x969D: 0x6162,
                0x969E: 0x6E80,
                0x969F: 0x6F2B,
                0x96A0: 0x8513,
                0x96A1: 0x5473,
                0x96A2: 0x672A,
                0x96A3: 0x9B45,
                0x96A4: 0x5DF3,
                0x96A5: 0x7B95,
                0x96A6: 0x5CAC,
                0x96A7: 0x5BC6,
                0x96A8: 0x871C,
                0x96A9: 0x6E4A,
                0x96AA: 0x84D1,
                0x96AB: 0x7A14,
                0x96AC: 0x8108,
                0x96AD: 0x5999,
                0x96AE: 0x7C8D,
                0x96AF: 0x6C11,
                0x96B0: 0x7720,
                0x96B1: 0x52D9,
                0x96B2: 0x5922,
                0x96B3: 0x7121,
                0x96B4: 0x725F,
                0x96B5: 0x77DB,
                0x96B6: 0x9727,
                0x96B7: 0x9D61,
                0x96B8: 0x690B,
                0x96B9: 0x5A7F,
                0x96BA: 0x5A18,
                0x96BB: 0x51A5,
                0x96BC: 0x540D,
                0x96BD: 0x547D,
                0x96BE: 0x660E,
                0x96BF: 0x76DF,
                0x96C0: 0x8FF7,
                0x96C1: 0x9298,
                0x96C2: 0x9CF4,
                0x96C3: 0x59EA,
                0x96C4: 0x725D,
                0x96C5: 0x6EC5,
                0x96C6: 0x514D,
                0x96C7: 0x68C9,
                0x96C8: 0x7DBF,
                0x96C9: 0x7DEC,
                0x96CA: 0x9762,
                0x96CB: 0x9EBA,
                0x96CC: 0x6478,
                0x96CD: 0x6A21,
                0x96CE: 0x8302,
                0x96CF: 0x5984,
                0x96D0: 0x5B5F,
                0x96D1: 0x6BDB,
                0x96D2: 0x731B,
                0x96D3: 0x76F2,
                0x96D4: 0x7DB2,
                0x96D5: 0x8017,
                0x96D6: 0x8499,
                0x96D7: 0x5132,
                0x96D8: 0x6728,
                0x96D9: 0x9ED9,
                0x96DA: 0x76EE,
                0x96DB: 0x6762,
                0x96DC: 0x52FF,
                0x96DD: 0x9905,
                0x96DE: 0x5C24,
                0x96DF: 0x623B,
                0x96E0: 0x7C7E,
                0x96E1: 0x8CB0,
                0x96E2: 0x554F,
                0x96E3: 0x60B6,
                0x96E4: 0x7D0B,
                0x96E5: 0x9580,
                0x96E6: 0x5301,
                0x96E7: 0x4E5F,
                0x96E8: 0x51B6,
                0x96E9: 0x591C,
                0x96EA: 0x723A,
                0x96EB: 0x8036,
                0x96EC: 0x91CE,
                0x96ED: 0x5F25,
                0x96EE: 0x77E2,
                0x96EF: 0x5384,
                0x96F0: 0x5F79,
                0x96F1: 0x7D04,
                0x96F2: 0x85AC,
                0x96F3: 0x8A33,
                0x96F4: 0x8E8D,
                0x96F5: 0x9756,
                0x96F6: 0x67F3,
                0x96F7: 0x85AE,
                0x96F8: 0x9453,
                0x96F9: 0x6109,
                0x96FA: 0x6108,
                0x96FB: 0x6CB9,
                0x96FC: 0x7652,
                0x9740: 0x8AED,
                0x9741: 0x8F38,
                0x9742: 0x552F,
                0x9743: 0x4F51,
                0x9744: 0x512A,
                0x9745: 0x52C7,
                0x9746: 0x53CB,
                0x9747: 0x5BA5,
                0x9748: 0x5E7D,
                0x9749: 0x60A0,
                0x974A: 0x6182,
                0x974B: 0x63D6,
                0x974C: 0x6709,
                0x974D: 0x67DA,
                0x974E: 0x6E67,
                0x974F: 0x6D8C,
                0x9750: 0x7336,
                0x9751: 0x7337,
                0x9752: 0x7531,
                0x9753: 0x7950,
                0x9754: 0x88D5,
                0x9755: 0x8A98,
                0x9756: 0x904A,
                0x9757: 0x9091,
                0x9758: 0x90F5,
                0x9759: 0x96C4,
                0x975A: 0x878D,
                0x975B: 0x5915,
                0x975C: 0x4E88,
                0x975D: 0x4F59,
                0x975E: 0x4E0E,
                0x975F: 0x8A89,
                0x9760: 0x8F3F,
                0x9761: 0x9810,
                0x9762: 0x50AD,
                0x9763: 0x5E7C,
                0x9764: 0x5996,
                0x9765: 0x5BB9,
                0x9766: 0x5EB8,
                0x9767: 0x63DA,
                0x9768: 0x63FA,
                0x9769: 0x64C1,
                0x976A: 0x66DC,
                0x976B: 0x694A,
                0x976C: 0x69D8,
                0x976D: 0x6D0B,
                0x976E: 0x6EB6,
                0x976F: 0x7194,
                0x9770: 0x7528,
                0x9771: 0x7AAF,
                0x9772: 0x7F8A,
                0x9773: 0x8000,
                0x9774: 0x8449,
                0x9775: 0x84C9,
                0x9776: 0x8981,
                0x9777: 0x8B21,
                0x9778: 0x8E0A,
                0x9779: 0x9065,
                0x977A: 0x967D,
                0x977B: 0x990A,
                0x977C: 0x617E,
                0x977D: 0x6291,
                0x977E: 0x6B32,
                0x9780: 0x6C83,
                0x9781: 0x6D74,
                0x9782: 0x7FCC,
                0x9783: 0x7FFC,
                0x9784: 0x6DC0,
                0x9785: 0x7F85,
                0x9786: 0x87BA,
                0x9787: 0x88F8,
                0x9788: 0x6765,
                0x9789: 0x83B1,
                0x978A: 0x983C,
                0x978B: 0x96F7,
                0x978C: 0x6D1B,
                0x978D: 0x7D61,
                0x978E: 0x843D,
                0x978F: 0x916A,
                0x9790: 0x4E71,
                0x9791: 0x5375,
                0x9792: 0x5D50,
                0x9793: 0x6B04,
                0x9794: 0x6FEB,
                0x9795: 0x85CD,
                0x9796: 0x862D,
                0x9797: 0x89A7,
                0x9798: 0x5229,
                0x9799: 0x540F,
                0x979A: 0x5C65,
                0x979B: 0x674E,
                0x979C: 0x68A8,
                0x979D: 0x7406,
                0x979E: 0x7483,
                0x979F: 0x75E2,
                0x97A0: 0x88CF,
                0x97A1: 0x88E1,
                0x97A2: 0x91CC,
                0x97A3: 0x96E2,
                0x97A4: 0x9678,
                0x97A5: 0x5F8B,
                0x97A6: 0x7387,
                0x97A7: 0x7ACB,
                0x97A8: 0x844E,
                0x97A9: 0x63A0,
                0x97AA: 0x7565,
                0x97AB: 0x5289,
                0x97AC: 0x6D41,
                0x97AD: 0x6E9C,
                0x97AE: 0x7409,
                0x97AF: 0x7559,
                0x97B0: 0x786B,
                0x97B1: 0x7C92,
                0x97B2: 0x9686,
                0x97B3: 0x7ADC,
                0x97B4: 0x9F8D,
                0x97B5: 0x4FB6,
                0x97B6: 0x616E,
                0x97B7: 0x65C5,
                0x97B8: 0x865C,
                0x97B9: 0x4E86,
                0x97BA: 0x4EAE,
                0x97BB: 0x50DA,
                0x97BC: 0x4E21,
                0x97BD: 0x51CC,
                0x97BE: 0x5BEE,
                0x97BF: 0x6599,
                0x97C0: 0x6881,
                0x97C1: 0x6DBC,
                0x97C2: 0x731F,
                0x97C3: 0x7642,
                0x97C4: 0x77AD,
                0x97C5: 0x7A1C,
                0x97C6: 0x7CE7,
                0x97C7: 0x826F,
                0x97C8: 0x8AD2,
                0x97C9: 0x907C,
                0x97CA: 0x91CF,
                0x97CB: 0x9675,
                0x97CC: 0x9818,
                0x97CD: 0x529B,
                0x97CE: 0x7DD1,
                0x97CF: 0x502B,
                0x97D0: 0x5398,
                0x97D1: 0x6797,
                0x97D2: 0x6DCB,
                0x97D3: 0x71D0,
                0x97D4: 0x7433,
                0x97D5: 0x81E8,
                0x97D6: 0x8F2A,
                0x97D7: 0x96A3,
                0x97D8: 0x9C57,
                0x97D9: 0x9E9F,
                0x97DA: 0x7460,
                0x97DB: 0x5841,
                0x97DC: 0x6D99,
                0x97DD: 0x7D2F,
                0x97DE: 0x985E,
                0x97DF: 0x4EE4,
                0x97E0: 0x4F36,
                0x97E1: 0x4F8B,
                0x97E2: 0x51B7,
                0x97E3: 0x52B1,
                0x97E4: 0x5DBA,
                0x97E5: 0x601C,
                0x97E6: 0x73B2,
                0x97E7: 0x793C,
                0x97E8: 0x82D3,
                0x97E9: 0x9234,
                0x97EA: 0x96B7,
                0x97EB: 0x96F6,
                0x97EC: 0x970A,
                0x97ED: 0x9E97,
                0x97EE: 0x9F62,
                0x97EF: 0x66A6,
                0x97F0: 0x6B74,
                0x97F1: 0x5217,
                0x97F2: 0x52A3,
                0x97F3: 0x70C8,
                0x97F4: 0x88C2,
                0x97F5: 0x5EC9,
                0x97F6: 0x604B,
                0x97F7: 0x6190,
                0x97F8: 0x6F23,
                0x97F9: 0x7149,
                0x97FA: 0x7C3E,
                0x97FB: 0x7DF4,
                0x97FC: 0x806F,
                0x9840: 0x84EE,
                0x9841: 0x9023,
                0x9842: 0x932C,
                0x9843: 0x5442,
                0x9844: 0x9B6F,
                0x9845: 0x6AD3,
                0x9846: 0x7089,
                0x9847: 0x8CC2,
                0x9848: 0x8DEF,
                0x9849: 0x9732,
                0x984A: 0x52B4,
                0x984B: 0x5A41,
                0x984C: 0x5ECA,
                0x984D: 0x5F04,
                0x984E: 0x6717,
                0x984F: 0x697C,
                0x9850: 0x6994,
                0x9851: 0x6D6A,
                0x9852: 0x6F0F,
                0x9853: 0x7262,
                0x9854: 0x72FC,
                0x9855: 0x7BED,
                0x9856: 0x8001,
                0x9857: 0x807E,
                0x9858: 0x874B,
                0x9859: 0x90CE,
                0x985A: 0x516D,
                0x985B: 0x9E93,
                0x985C: 0x7984,
                0x985D: 0x808B,
                0x985E: 0x9332,
                0x985F: 0x8AD6,
                0x9860: 0x502D,
                0x9861: 0x548C,
                0x9862: 0x8A71,
                0x9863: 0x6B6A,
                0x9864: 0x8CC4,
                0x9865: 0x8107,
                0x9866: 0x60D1,
                0x9867: 0x67A0,
                0x9868: 0x9DF2,
                0x9869: 0x4E99,
                0x986A: 0x4E98,
                0x986B: 0x9C10,
                0x986C: 0x8A6B,
                0x986D: 0x85C1,
                0x986E: 0x8568,
                0x986F: 0x6900,
                0x9870: 0x6E7E,
                0x9871: 0x7897,
                0x9872: 0x8155,
                0x989F: 0x5F0C,
                0x98A0: 0x4E10,
                0x98A1: 0x4E15,
                0x98A2: 0x4E2A,
                0x98A3: 0x4E31,
                0x98A4: 0x4E36,
                0x98A5: 0x4E3C,
                0x98A6: 0x4E3F,
                0x98A7: 0x4E42,
                0x98A8: 0x4E56,
                0x98A9: 0x4E58,
                0x98AA: 0x4E82,
                0x98AB: 0x4E85,
                0x98AC: 0x8C6B,
                0x98AD: 0x4E8A,
                0x98AE: 0x8212,
                0x98AF: 0x5F0D,
                0x98B0: 0x4E8E,
                0x98B1: 0x4E9E,
                0x98B2: 0x4E9F,
                0x98B3: 0x4EA0,
                0x98B4: 0x4EA2,
                0x98B5: 0x4EB0,
                0x98B6: 0x4EB3,
                0x98B7: 0x4EB6,
                0x98B8: 0x4ECE,
                0x98B9: 0x4ECD,
                0x98BA: 0x4EC4,
                0x98BB: 0x4EC6,
                0x98BC: 0x4EC2,
                0x98BD: 0x4ED7,
                0x98BE: 0x4EDE,
                0x98BF: 0x4EED,
                0x98C0: 0x4EDF,
                0x98C1: 0x4EF7,
                0x98C2: 0x4F09,
                0x98C3: 0x4F5A,
                0x98C4: 0x4F30,
                0x98C5: 0x4F5B,
                0x98C6: 0x4F5D,
                0x98C7: 0x4F57,
                0x98C8: 0x4F47,
                0x98C9: 0x4F76,
                0x98CA: 0x4F88,
                0x98CB: 0x4F8F,
                0x98CC: 0x4F98,
                0x98CD: 0x4F7B,
                0x98CE: 0x4F69,
                0x98CF: 0x4F70,
                0x98D0: 0x4F91,
                0x98D1: 0x4F6F,
                0x98D2: 0x4F86,
                0x98D3: 0x4F96,
                0x98D4: 0x5118,
                0x98D5: 0x4FD4,
                0x98D6: 0x4FDF,
                0x98D7: 0x4FCE,
                0x98D8: 0x4FD8,
                0x98D9: 0x4FDB,
                0x98DA: 0x4FD1,
                0x98DB: 0x4FDA,
                0x98DC: 0x4FD0,
                0x98DD: 0x4FE4,
                0x98DE: 0x4FE5,
                0x98DF: 0x501A,
                0x98E0: 0x5028,
                0x98E1: 0x5014,
                0x98E2: 0x502A,
                0x98E3: 0x5025,
                0x98E4: 0x5005,
                0x98E5: 0x4F1C,
                0x98E6: 0x4FF6,
                0x98E7: 0x5021,
                0x98E8: 0x5029,
                0x98E9: 0x502C,
                0x98EA: 0x4FFE,
                0x98EB: 0x4FEF,
                0x98EC: 0x5011,
                0x98ED: 0x5006,
                0x98EE: 0x5043,
                0x98EF: 0x5047,
                0x98F0: 0x6703,
                0x98F1: 0x5055,
                0x98F2: 0x5050,
                0x98F3: 0x5048,
                0x98F4: 0x505A,
                0x98F5: 0x5056,
                0x98F6: 0x506C,
                0x98F7: 0x5078,
                0x98F8: 0x5080,
                0x98F9: 0x509A,
                0x98FA: 0x5085,
                0x98FB: 0x50B4,
                0x98FC: 0x50B2,
                0x9940: 0x50C9,
                0x9941: 0x50CA,
                0x9942: 0x50B3,
                0x9943: 0x50C2,
                0x9944: 0x50D6,
                0x9945: 0x50DE,
                0x9946: 0x50E5,
                0x9947: 0x50ED,
                0x9948: 0x50E3,
                0x9949: 0x50EE,
                0x994A: 0x50F9,
                0x994B: 0x50F5,
                0x994C: 0x5109,
                0x994D: 0x5101,
                0x994E: 0x5102,
                0x994F: 0x5116,
                0x9950: 0x5115,
                0x9951: 0x5114,
                0x9952: 0x511A,
                0x9953: 0x5121,
                0x9954: 0x513A,
                0x9955: 0x5137,
                0x9956: 0x513C,
                0x9957: 0x513B,
                0x9958: 0x513F,
                0x9959: 0x5140,
                0x995A: 0x5152,
                0x995B: 0x514C,
                0x995C: 0x5154,
                0x995D: 0x5162,
                0x995E: 0x7AF8,
                0x995F: 0x5169,
                0x9960: 0x516A,
                0x9961: 0x516E,
                0x9962: 0x5180,
                0x9963: 0x5182,
                0x9964: 0x56D8,
                0x9965: 0x518C,
                0x9966: 0x5189,
                0x9967: 0x518F,
                0x9968: 0x5191,
                0x9969: 0x5193,
                0x996A: 0x5195,
                0x996B: 0x5196,
                0x996C: 0x51A4,
                0x996D: 0x51A6,
                0x996E: 0x51A2,
                0x996F: 0x51A9,
                0x9970: 0x51AA,
                0x9971: 0x51AB,
                0x9972: 0x51B3,
                0x9973: 0x51B1,
                0x9974: 0x51B2,
                0x9975: 0x51B0,
                0x9976: 0x51B5,
                0x9977: 0x51BD,
                0x9978: 0x51C5,
                0x9979: 0x51C9,
                0x997A: 0x51DB,
                0x997B: 0x51E0,
                0x997C: 0x8655,
                0x997D: 0x51E9,
                0x997E: 0x51ED,
                0x9980: 0x51F0,
                0x9981: 0x51F5,
                0x9982: 0x51FE,
                0x9983: 0x5204,
                0x9984: 0x520B,
                0x9985: 0x5214,
                0x9986: 0x520E,
                0x9987: 0x5227,
                0x9988: 0x522A,
                0x9989: 0x522E,
                0x998A: 0x5233,
                0x998B: 0x5239,
                0x998C: 0x524F,
                0x998D: 0x5244,
                0x998E: 0x524B,
                0x998F: 0x524C,
                0x9990: 0x525E,
                0x9991: 0x5254,
                0x9992: 0x526A,
                0x9993: 0x5274,
                0x9994: 0x5269,
                0x9995: 0x5273,
                0x9996: 0x527F,
                0x9997: 0x527D,
                0x9998: 0x528D,
                0x9999: 0x5294,
                0x999A: 0x5292,
                0x999B: 0x5271,
                0x999C: 0x5288,
                0x999D: 0x5291,
                0x999E: 0x8FA8,
                0x999F: 0x8FA7,
                0x99A0: 0x52AC,
                0x99A1: 0x52AD,
                0x99A2: 0x52BC,
                0x99A3: 0x52B5,
                0x99A4: 0x52C1,
                0x99A5: 0x52CD,
                0x99A6: 0x52D7,
                0x99A7: 0x52DE,
                0x99A8: 0x52E3,
                0x99A9: 0x52E6,
                0x99AA: 0x98ED,
                0x99AB: 0x52E0,
                0x99AC: 0x52F3,
                0x99AD: 0x52F5,
                0x99AE: 0x52F8,
                0x99AF: 0x52F9,
                0x99B0: 0x5306,
                0x99B1: 0x5308,
                0x99B2: 0x7538,
                0x99B3: 0x530D,
                0x99B4: 0x5310,
                0x99B5: 0x530F,
                0x99B6: 0x5315,
                0x99B7: 0x531A,
                0x99B8: 0x5323,
                0x99B9: 0x532F,
                0x99BA: 0x5331,
                0x99BB: 0x5333,
                0x99BC: 0x5338,
                0x99BD: 0x5340,
                0x99BE: 0x5346,
                0x99BF: 0x5345,
                0x99C0: 0x4E17,
                0x99C1: 0x5349,
                0x99C2: 0x534D,
                0x99C3: 0x51D6,
                0x99C4: 0x535E,
                0x99C5: 0x5369,
                0x99C6: 0x536E,
                0x99C7: 0x5918,
                0x99C8: 0x537B,
                0x99C9: 0x5377,
                0x99CA: 0x5382,
                0x99CB: 0x5396,
                0x99CC: 0x53A0,
                0x99CD: 0x53A6,
                0x99CE: 0x53A5,
                0x99CF: 0x53AE,
                0x99D0: 0x53B0,
                0x99D1: 0x53B6,
                0x99D2: 0x53C3,
                0x99D3: 0x7C12,
                0x99D4: 0x96D9,
                0x99D5: 0x53DF,
                0x99D6: 0x66FC,
                0x99D7: 0x71EE,
                0x99D8: 0x53EE,
                0x99D9: 0x53E8,
                0x99DA: 0x53ED,
                0x99DB: 0x53FA,
                0x99DC: 0x5401,
                0x99DD: 0x543D,
                0x99DE: 0x5440,
                0x99DF: 0x542C,
                0x99E0: 0x542D,
                0x99E1: 0x543C,
                0x99E2: 0x542E,
                0x99E3: 0x5436,
                0x99E4: 0x5429,
                0x99E5: 0x541D,
                0x99E6: 0x544E,
                0x99E7: 0x548F,
                0x99E8: 0x5475,
                0x99E9: 0x548E,
                0x99EA: 0x545F,
                0x99EB: 0x5471,
                0x99EC: 0x5477,
                0x99ED: 0x5470,
                0x99EE: 0x5492,
                0x99EF: 0x547B,
                0x99F0: 0x5480,
                0x99F1: 0x5476,
                0x99F2: 0x5484,
                0x99F3: 0x5490,
                0x99F4: 0x5486,
                0x99F5: 0x54C7,
                0x99F6: 0x54A2,
                0x99F7: 0x54B8,
                0x99F8: 0x54A5,
                0x99F9: 0x54AC,
                0x99FA: 0x54C4,
                0x99FB: 0x54C8,
                0x99FC: 0x54A8,
                0x9A40: 0x54AB,
                0x9A41: 0x54C2,
                0x9A42: 0x54A4,
                0x9A43: 0x54BE,
                0x9A44: 0x54BC,
                0x9A45: 0x54D8,
                0x9A46: 0x54E5,
                0x9A47: 0x54E6,
                0x9A48: 0x550F,
                0x9A49: 0x5514,
                0x9A4A: 0x54FD,
                0x9A4B: 0x54EE,
                0x9A4C: 0x54ED,
                0x9A4D: 0x54FA,
                0x9A4E: 0x54E2,
                0x9A4F: 0x5539,
                0x9A50: 0x5540,
                0x9A51: 0x5563,
                0x9A52: 0x554C,
                0x9A53: 0x552E,
                0x9A54: 0x555C,
                0x9A55: 0x5545,
                0x9A56: 0x5556,
                0x9A57: 0x5557,
                0x9A58: 0x5538,
                0x9A59: 0x5533,
                0x9A5A: 0x555D,
                0x9A5B: 0x5599,
                0x9A5C: 0x5580,
                0x9A5D: 0x54AF,
                0x9A5E: 0x558A,
                0x9A5F: 0x559F,
                0x9A60: 0x557B,
                0x9A61: 0x557E,
                0x9A62: 0x5598,
                0x9A63: 0x559E,
                0x9A64: 0x55AE,
                0x9A65: 0x557C,
                0x9A66: 0x5583,
                0x9A67: 0x55A9,
                0x9A68: 0x5587,
                0x9A69: 0x55A8,
                0x9A6A: 0x55DA,
                0x9A6B: 0x55C5,
                0x9A6C: 0x55DF,
                0x9A6D: 0x55C4,
                0x9A6E: 0x55DC,
                0x9A6F: 0x55E4,
                0x9A70: 0x55D4,
                0x9A71: 0x5614,
                0x9A72: 0x55F7,
                0x9A73: 0x5616,
                0x9A74: 0x55FE,
                0x9A75: 0x55FD,
                0x9A76: 0x561B,
                0x9A77: 0x55F9,
                0x9A78: 0x564E,
                0x9A79: 0x5650,
                0x9A7A: 0x71DF,
                0x9A7B: 0x5634,
                0x9A7C: 0x5636,
                0x9A7D: 0x5632,
                0x9A7E: 0x5638,
                0x9A80: 0x566B,
                0x9A81: 0x5664,
                0x9A82: 0x562F,
                0x9A83: 0x566C,
                0x9A84: 0x566A,
                0x9A85: 0x5686,
                0x9A86: 0x5680,
                0x9A87: 0x568A,
                0x9A88: 0x56A0,
                0x9A89: 0x5694,
                0x9A8A: 0x568F,
                0x9A8B: 0x56A5,
                0x9A8C: 0x56AE,
                0x9A8D: 0x56B6,
                0x9A8E: 0x56B4,
                0x9A8F: 0x56C2,
                0x9A90: 0x56BC,
                0x9A91: 0x56C1,
                0x9A92: 0x56C3,
                0x9A93: 0x56C0,
                0x9A94: 0x56C8,
                0x9A95: 0x56CE,
                0x9A96: 0x56D1,
                0x9A97: 0x56D3,
                0x9A98: 0x56D7,
                0x9A99: 0x56EE,
                0x9A9A: 0x56F9,
                0x9A9B: 0x5700,
                0x9A9C: 0x56FF,
                0x9A9D: 0x5704,
                0x9A9E: 0x5709,
                0x9A9F: 0x5708,
                0x9AA0: 0x570B,
                0x9AA1: 0x570D,
                0x9AA2: 0x5713,
                0x9AA3: 0x5718,
                0x9AA4: 0x5716,
                0x9AA5: 0x55C7,
                0x9AA6: 0x571C,
                0x9AA7: 0x5726,
                0x9AA8: 0x5737,
                0x9AA9: 0x5738,
                0x9AAA: 0x574E,
                0x9AAB: 0x573B,
                0x9AAC: 0x5740,
                0x9AAD: 0x574F,
                0x9AAE: 0x5769,
                0x9AAF: 0x57C0,
                0x9AB0: 0x5788,
                0x9AB1: 0x5761,
                0x9AB2: 0x577F,
                0x9AB3: 0x5789,
                0x9AB4: 0x5793,
                0x9AB5: 0x57A0,
                0x9AB6: 0x57B3,
                0x9AB7: 0x57A4,
                0x9AB8: 0x57AA,
                0x9AB9: 0x57B0,
                0x9ABA: 0x57C3,
                0x9ABB: 0x57C6,
                0x9ABC: 0x57D4,
                0x9ABD: 0x57D2,
                0x9ABE: 0x57D3,
                0x9ABF: 0x580A,
                0x9AC0: 0x57D6,
                0x9AC1: 0x57E3,
                0x9AC2: 0x580B,
                0x9AC3: 0x5819,
                0x9AC4: 0x581D,
                0x9AC5: 0x5872,
                0x9AC6: 0x5821,
                0x9AC7: 0x5862,
                0x9AC8: 0x584B,
                0x9AC9: 0x5870,
                0x9ACA: 0x6BC0,
                0x9ACB: 0x5852,
                0x9ACC: 0x583D,
                0x9ACD: 0x5879,
                0x9ACE: 0x5885,
                0x9ACF: 0x58B9,
                0x9AD0: 0x589F,
                0x9AD1: 0x58AB,
                0x9AD2: 0x58BA,
                0x9AD3: 0x58DE,
                0x9AD4: 0x58BB,
                0x9AD5: 0x58B8,
                0x9AD6: 0x58AE,
                0x9AD7: 0x58C5,
                0x9AD8: 0x58D3,
                0x9AD9: 0x58D1,
                0x9ADA: 0x58D7,
                0x9ADB: 0x58D9,
                0x9ADC: 0x58D8,
                0x9ADD: 0x58E5,
                0x9ADE: 0x58DC,
                0x9ADF: 0x58E4,
                0x9AE0: 0x58DF,
                0x9AE1: 0x58EF,
                0x9AE2: 0x58FA,
                0x9AE3: 0x58F9,
                0x9AE4: 0x58FB,
                0x9AE5: 0x58FC,
                0x9AE6: 0x58FD,
                0x9AE7: 0x5902,
                0x9AE8: 0x590A,
                0x9AE9: 0x5910,
                0x9AEA: 0x591B,
                0x9AEB: 0x68A6,
                0x9AEC: 0x5925,
                0x9AED: 0x592C,
                0x9AEE: 0x592D,
                0x9AEF: 0x5932,
                0x9AF0: 0x5938,
                0x9AF1: 0x593E,
                0x9AF2: 0x7AD2,
                0x9AF3: 0x5955,
                0x9AF4: 0x5950,
                0x9AF5: 0x594E,
                0x9AF6: 0x595A,
                0x9AF7: 0x5958,
                0x9AF8: 0x5962,
                0x9AF9: 0x5960,
                0x9AFA: 0x5967,
                0x9AFB: 0x596C,
                0x9AFC: 0x5969,
                0x9B40: 0x5978,
                0x9B41: 0x5981,
                0x9B42: 0x599D,
                0x9B43: 0x4F5E,
                0x9B44: 0x4FAB,
                0x9B45: 0x59A3,
                0x9B46: 0x59B2,
                0x9B47: 0x59C6,
                0x9B48: 0x59E8,
                0x9B49: 0x59DC,
                0x9B4A: 0x598D,
                0x9B4B: 0x59D9,
                0x9B4C: 0x59DA,
                0x9B4D: 0x5A25,
                0x9B4E: 0x5A1F,
                0x9B4F: 0x5A11,
                0x9B50: 0x5A1C,
                0x9B51: 0x5A09,
                0x9B52: 0x5A1A,
                0x9B53: 0x5A40,
                0x9B54: 0x5A6C,
                0x9B55: 0x5A49,
                0x9B56: 0x5A35,
                0x9B57: 0x5A36,
                0x9B58: 0x5A62,
                0x9B59: 0x5A6A,
                0x9B5A: 0x5A9A,
                0x9B5B: 0x5ABC,
                0x9B5C: 0x5ABE,
                0x9B5D: 0x5ACB,
                0x9B5E: 0x5AC2,
                0x9B5F: 0x5ABD,
                0x9B60: 0x5AE3,
                0x9B61: 0x5AD7,
                0x9B62: 0x5AE6,
                0x9B63: 0x5AE9,
                0x9B64: 0x5AD6,
                0x9B65: 0x5AFA,
                0x9B66: 0x5AFB,
                0x9B67: 0x5B0C,
                0x9B68: 0x5B0B,
                0x9B69: 0x5B16,
                0x9B6A: 0x5B32,
                0x9B6B: 0x5AD0,
                0x9B6C: 0x5B2A,
                0x9B6D: 0x5B36,
                0x9B6E: 0x5B3E,
                0x9B6F: 0x5B43,
                0x9B70: 0x5B45,
                0x9B71: 0x5B40,
                0x9B72: 0x5B51,
                0x9B73: 0x5B55,
                0x9B74: 0x5B5A,
                0x9B75: 0x5B5B,
                0x9B76: 0x5B65,
                0x9B77: 0x5B69,
                0x9B78: 0x5B70,
                0x9B79: 0x5B73,
                0x9B7A: 0x5B75,
                0x9B7B: 0x5B78,
                0x9B7C: 0x6588,
                0x9B7D: 0x5B7A,
                0x9B7E: 0x5B80,
                0x9B80: 0x5B83,
                0x9B81: 0x5BA6,
                0x9B82: 0x5BB8,
                0x9B83: 0x5BC3,
                0x9B84: 0x5BC7,
                0x9B85: 0x5BC9,
                0x9B86: 0x5BD4,
                0x9B87: 0x5BD0,
                0x9B88: 0x5BE4,
                0x9B89: 0x5BE6,
                0x9B8A: 0x5BE2,
                0x9B8B: 0x5BDE,
                0x9B8C: 0x5BE5,
                0x9B8D: 0x5BEB,
                0x9B8E: 0x5BF0,
                0x9B8F: 0x5BF6,
                0x9B90: 0x5BF3,
                0x9B91: 0x5C05,
                0x9B92: 0x5C07,
                0x9B93: 0x5C08,
                0x9B94: 0x5C0D,
                0x9B95: 0x5C13,
                0x9B96: 0x5C20,
                0x9B97: 0x5C22,
                0x9B98: 0x5C28,
                0x9B99: 0x5C38,
                0x9B9A: 0x5C39,
                0x9B9B: 0x5C41,
                0x9B9C: 0x5C46,
                0x9B9D: 0x5C4E,
                0x9B9E: 0x5C53,
                0x9B9F: 0x5C50,
                0x9BA0: 0x5C4F,
                0x9BA1: 0x5B71,
                0x9BA2: 0x5C6C,
                0x9BA3: 0x5C6E,
                0x9BA4: 0x4E62,
                0x9BA5: 0x5C76,
                0x9BA6: 0x5C79,
                0x9BA7: 0x5C8C,
                0x9BA8: 0x5C91,
                0x9BA9: 0x5C94,
                0x9BAA: 0x599B,
                0x9BAB: 0x5CAB,
                0x9BAC: 0x5CBB,
                0x9BAD: 0x5CB6,
                0x9BAE: 0x5CBC,
                0x9BAF: 0x5CB7,
                0x9BB0: 0x5CC5,
                0x9BB1: 0x5CBE,
                0x9BB2: 0x5CC7,
                0x9BB3: 0x5CD9,
                0x9BB4: 0x5CE9,
                0x9BB5: 0x5CFD,
                0x9BB6: 0x5CFA,
                0x9BB7: 0x5CED,
                0x9BB8: 0x5D8C,
                0x9BB9: 0x5CEA,
                0x9BBA: 0x5D0B,
                0x9BBB: 0x5D15,
                0x9BBC: 0x5D17,
                0x9BBD: 0x5D5C,
                0x9BBE: 0x5D1F,
                0x9BBF: 0x5D1B,
                0x9BC0: 0x5D11,
                0x9BC1: 0x5D14,
                0x9BC2: 0x5D22,
                0x9BC3: 0x5D1A,
                0x9BC4: 0x5D19,
                0x9BC5: 0x5D18,
                0x9BC6: 0x5D4C,
                0x9BC7: 0x5D52,
                0x9BC8: 0x5D4E,
                0x9BC9: 0x5D4B,
                0x9BCA: 0x5D6C,
                0x9BCB: 0x5D73,
                0x9BCC: 0x5D76,
                0x9BCD: 0x5D87,
                0x9BCE: 0x5D84,
                0x9BCF: 0x5D82,
                0x9BD0: 0x5DA2,
                0x9BD1: 0x5D9D,
                0x9BD2: 0x5DAC,
                0x9BD3: 0x5DAE,
                0x9BD4: 0x5DBD,
                0x9BD5: 0x5D90,
                0x9BD6: 0x5DB7,
                0x9BD7: 0x5DBC,
                0x9BD8: 0x5DC9,
                0x9BD9: 0x5DCD,
                0x9BDA: 0x5DD3,
                0x9BDB: 0x5DD2,
                0x9BDC: 0x5DD6,
                0x9BDD: 0x5DDB,
                0x9BDE: 0x5DEB,
                0x9BDF: 0x5DF2,
                0x9BE0: 0x5DF5,
                0x9BE1: 0x5E0B,
                0x9BE2: 0x5E1A,
                0x9BE3: 0x5E19,
                0x9BE4: 0x5E11,
                0x9BE5: 0x5E1B,
                0x9BE6: 0x5E36,
                0x9BE7: 0x5E37,
                0x9BE8: 0x5E44,
                0x9BE9: 0x5E43,
                0x9BEA: 0x5E40,
                0x9BEB: 0x5E4E,
                0x9BEC: 0x5E57,
                0x9BED: 0x5E54,
                0x9BEE: 0x5E5F,
                0x9BEF: 0x5E62,
                0x9BF0: 0x5E64,
                0x9BF1: 0x5E47,
                0x9BF2: 0x5E75,
                0x9BF3: 0x5E76,
                0x9BF4: 0x5E7A,
                0x9BF5: 0x9EBC,
                0x9BF6: 0x5E7F,
                0x9BF7: 0x5EA0,
                0x9BF8: 0x5EC1,
                0x9BF9: 0x5EC2,
                0x9BFA: 0x5EC8,
                0x9BFB: 0x5ED0,
                0x9BFC: 0x5ECF,
                0x9C40: 0x5ED6,
                0x9C41: 0x5EE3,
                0x9C42: 0x5EDD,
                0x9C43: 0x5EDA,
                0x9C44: 0x5EDB,
                0x9C45: 0x5EE2,
                0x9C46: 0x5EE1,
                0x9C47: 0x5EE8,
                0x9C48: 0x5EE9,
                0x9C49: 0x5EEC,
                0x9C4A: 0x5EF1,
                0x9C4B: 0x5EF3,
                0x9C4C: 0x5EF0,
                0x9C4D: 0x5EF4,
                0x9C4E: 0x5EF8,
                0x9C4F: 0x5EFE,
                0x9C50: 0x5F03,
                0x9C51: 0x5F09,
                0x9C52: 0x5F5D,
                0x9C53: 0x5F5C,
                0x9C54: 0x5F0B,
                0x9C55: 0x5F11,
                0x9C56: 0x5F16,
                0x9C57: 0x5F29,
                0x9C58: 0x5F2D,
                0x9C59: 0x5F38,
                0x9C5A: 0x5F41,
                0x9C5B: 0x5F48,
                0x9C5C: 0x5F4C,
                0x9C5D: 0x5F4E,
                0x9C5E: 0x5F2F,
                0x9C5F: 0x5F51,
                0x9C60: 0x5F56,
                0x9C61: 0x5F57,
                0x9C62: 0x5F59,
                0x9C63: 0x5F61,
                0x9C64: 0x5F6D,
                0x9C65: 0x5F73,
                0x9C66: 0x5F77,
                0x9C67: 0x5F83,
                0x9C68: 0x5F82,
                0x9C69: 0x5F7F,
                0x9C6A: 0x5F8A,
                0x9C6B: 0x5F88,
                0x9C6C: 0x5F91,
                0x9C6D: 0x5F87,
                0x9C6E: 0x5F9E,
                0x9C6F: 0x5F99,
                0x9C70: 0x5F98,
                0x9C71: 0x5FA0,
                0x9C72: 0x5FA8,
                0x9C73: 0x5FAD,
                0x9C74: 0x5FBC,
                0x9C75: 0x5FD6,
                0x9C76: 0x5FFB,
                0x9C77: 0x5FE4,
                0x9C78: 0x5FF8,
                0x9C79: 0x5FF1,
                0x9C7A: 0x5FDD,
                0x9C7B: 0x60B3,
                0x9C7C: 0x5FFF,
                0x9C7D: 0x6021,
                0x9C7E: 0x6060,
                0x9C80: 0x6019,
                0x9C81: 0x6010,
                0x9C82: 0x6029,
                0x9C83: 0x600E,
                0x9C84: 0x6031,
                0x9C85: 0x601B,
                0x9C86: 0x6015,
                0x9C87: 0x602B,
                0x9C88: 0x6026,
                0x9C89: 0x600F,
                0x9C8A: 0x603A,
                0x9C8B: 0x605A,
                0x9C8C: 0x6041,
                0x9C8D: 0x606A,
                0x9C8E: 0x6077,
                0x9C8F: 0x605F,
                0x9C90: 0x604A,
                0x9C91: 0x6046,
                0x9C92: 0x604D,
                0x9C93: 0x6063,
                0x9C94: 0x6043,
                0x9C95: 0x6064,
                0x9C96: 0x6042,
                0x9C97: 0x606C,
                0x9C98: 0x606B,
                0x9C99: 0x6059,
                0x9C9A: 0x6081,
                0x9C9B: 0x608D,
                0x9C9C: 0x60E7,
                0x9C9D: 0x6083,
                0x9C9E: 0x609A,
                0x9C9F: 0x6084,
                0x9CA0: 0x609B,
                0x9CA1: 0x6096,
                0x9CA2: 0x6097,
                0x9CA3: 0x6092,
                0x9CA4: 0x60A7,
                0x9CA5: 0x608B,
                0x9CA6: 0x60E1,
                0x9CA7: 0x60B8,
                0x9CA8: 0x60E0,
                0x9CA9: 0x60D3,
                0x9CAA: 0x60B4,
                0x9CAB: 0x5FF0,
                0x9CAC: 0x60BD,
                0x9CAD: 0x60C6,
                0x9CAE: 0x60B5,
                0x9CAF: 0x60D8,
                0x9CB0: 0x614D,
                0x9CB1: 0x6115,
                0x9CB2: 0x6106,
                0x9CB3: 0x60F6,
                0x9CB4: 0x60F7,
                0x9CB5: 0x6100,
                0x9CB6: 0x60F4,
                0x9CB7: 0x60FA,
                0x9CB8: 0x6103,
                0x9CB9: 0x6121,
                0x9CBA: 0x60FB,
                0x9CBB: 0x60F1,
                0x9CBC: 0x610D,
                0x9CBD: 0x610E,
                0x9CBE: 0x6147,
                0x9CBF: 0x613E,
                0x9CC0: 0x6128,
                0x9CC1: 0x6127,
                0x9CC2: 0x614A,
                0x9CC3: 0x613F,
                0x9CC4: 0x613C,
                0x9CC5: 0x612C,
                0x9CC6: 0x6134,
                0x9CC7: 0x613D,
                0x9CC8: 0x6142,
                0x9CC9: 0x6144,
                0x9CCA: 0x6173,
                0x9CCB: 0x6177,
                0x9CCC: 0x6158,
                0x9CCD: 0x6159,
                0x9CCE: 0x615A,
                0x9CCF: 0x616B,
                0x9CD0: 0x6174,
                0x9CD1: 0x616F,
                0x9CD2: 0x6165,
                0x9CD3: 0x6171,
                0x9CD4: 0x615F,
                0x9CD5: 0x615D,
                0x9CD6: 0x6153,
                0x9CD7: 0x6175,
                0x9CD8: 0x6199,
                0x9CD9: 0x6196,
                0x9CDA: 0x6187,
                0x9CDB: 0x61AC,
                0x9CDC: 0x6194,
                0x9CDD: 0x619A,
                0x9CDE: 0x618A,
                0x9CDF: 0x6191,
                0x9CE0: 0x61AB,
                0x9CE1: 0x61AE,
                0x9CE2: 0x61CC,
                0x9CE3: 0x61CA,
                0x9CE4: 0x61C9,
                0x9CE5: 0x61F7,
                0x9CE6: 0x61C8,
                0x9CE7: 0x61C3,
                0x9CE8: 0x61C6,
                0x9CE9: 0x61BA,
                0x9CEA: 0x61CB,
                0x9CEB: 0x7F79,
                0x9CEC: 0x61CD,
                0x9CED: 0x61E6,
                0x9CEE: 0x61E3,
                0x9CEF: 0x61F6,
                0x9CF0: 0x61FA,
                0x9CF1: 0x61F4,
                0x9CF2: 0x61FF,
                0x9CF3: 0x61FD,
                0x9CF4: 0x61FC,
                0x9CF5: 0x61FE,
                0x9CF6: 0x6200,
                0x9CF7: 0x6208,
                0x9CF8: 0x6209,
                0x9CF9: 0x620D,
                0x9CFA: 0x620C,
                0x9CFB: 0x6214,
                0x9CFC: 0x621B,
                0x9D40: 0x621E,
                0x9D41: 0x6221,
                0x9D42: 0x622A,
                0x9D43: 0x622E,
                0x9D44: 0x6230,
                0x9D45: 0x6232,
                0x9D46: 0x6233,
                0x9D47: 0x6241,
                0x9D48: 0x624E,
                0x9D49: 0x625E,
                0x9D4A: 0x6263,
                0x9D4B: 0x625B,
                0x9D4C: 0x6260,
                0x9D4D: 0x6268,
                0x9D4E: 0x627C,
                0x9D4F: 0x6282,
                0x9D50: 0x6289,
                0x9D51: 0x627E,
                0x9D52: 0x6292,
                0x9D53: 0x6293,
                0x9D54: 0x6296,
                0x9D55: 0x62D4,
                0x9D56: 0x6283,
                0x9D57: 0x6294,
                0x9D58: 0x62D7,
                0x9D59: 0x62D1,
                0x9D5A: 0x62BB,
                0x9D5B: 0x62CF,
                0x9D5C: 0x62FF,
                0x9D5D: 0x62C6,
                0x9D5E: 0x64D4,
                0x9D5F: 0x62C8,
                0x9D60: 0x62DC,
                0x9D61: 0x62CC,
                0x9D62: 0x62CA,
                0x9D63: 0x62C2,
                0x9D64: 0x62C7,
                0x9D65: 0x629B,
                0x9D66: 0x62C9,
                0x9D67: 0x630C,
                0x9D68: 0x62EE,
                0x9D69: 0x62F1,
                0x9D6A: 0x6327,
                0x9D6B: 0x6302,
                0x9D6C: 0x6308,
                0x9D6D: 0x62EF,
                0x9D6E: 0x62F5,
                0x9D6F: 0x6350,
                0x9D70: 0x633E,
                0x9D71: 0x634D,
                0x9D72: 0x641C,
                0x9D73: 0x634F,
                0x9D74: 0x6396,
                0x9D75: 0x638E,
                0x9D76: 0x6380,
                0x9D77: 0x63AB,
                0x9D78: 0x6376,
                0x9D79: 0x63A3,
                0x9D7A: 0x638F,
                0x9D7B: 0x6389,
                0x9D7C: 0x639F,
                0x9D7D: 0x63B5,
                0x9D7E: 0x636B,
                0x9D80: 0x6369,
                0x9D81: 0x63BE,
                0x9D82: 0x63E9,
                0x9D83: 0x63C0,
                0x9D84: 0x63C6,
                0x9D85: 0x63E3,
                0x9D86: 0x63C9,
                0x9D87: 0x63D2,
                0x9D88: 0x63F6,
                0x9D89: 0x63C4,
                0x9D8A: 0x6416,
                0x9D8B: 0x6434,
                0x9D8C: 0x6406,
                0x9D8D: 0x6413,
                0x9D8E: 0x6426,
                0x9D8F: 0x6436,
                0x9D90: 0x651D,
                0x9D91: 0x6417,
                0x9D92: 0x6428,
                0x9D93: 0x640F,
                0x9D94: 0x6467,
                0x9D95: 0x646F,
                0x9D96: 0x6476,
                0x9D97: 0x644E,
                0x9D98: 0x652A,
                0x9D99: 0x6495,
                0x9D9A: 0x6493,
                0x9D9B: 0x64A5,
                0x9D9C: 0x64A9,
                0x9D9D: 0x6488,
                0x9D9E: 0x64BC,
                0x9D9F: 0x64DA,
                0x9DA0: 0x64D2,
                0x9DA1: 0x64C5,
                0x9DA2: 0x64C7,
                0x9DA3: 0x64BB,
                0x9DA4: 0x64D8,
                0x9DA5: 0x64C2,
                0x9DA6: 0x64F1,
                0x9DA7: 0x64E7,
                0x9DA8: 0x8209,
                0x9DA9: 0x64E0,
                0x9DAA: 0x64E1,
                0x9DAB: 0x62AC,
                0x9DAC: 0x64E3,
                0x9DAD: 0x64EF,
                0x9DAE: 0x652C,
                0x9DAF: 0x64F6,
                0x9DB0: 0x64F4,
                0x9DB1: 0x64F2,
                0x9DB2: 0x64FA,
                0x9DB3: 0x6500,
                0x9DB4: 0x64FD,
                0x9DB5: 0x6518,
                0x9DB6: 0x651C,
                0x9DB7: 0x6505,
                0x9DB8: 0x6524,
                0x9DB9: 0x6523,
                0x9DBA: 0x652B,
                0x9DBB: 0x6534,
                0x9DBC: 0x6535,
                0x9DBD: 0x6537,
                0x9DBE: 0x6536,
                0x9DBF: 0x6538,
                0x9DC0: 0x754B,
                0x9DC1: 0x6548,
                0x9DC2: 0x6556,
                0x9DC3: 0x6555,
                0x9DC4: 0x654D,
                0x9DC5: 0x6558,
                0x9DC6: 0x655E,
                0x9DC7: 0x655D,
                0x9DC8: 0x6572,
                0x9DC9: 0x6578,
                0x9DCA: 0x6582,
                0x9DCB: 0x6583,
                0x9DCC: 0x8B8A,
                0x9DCD: 0x659B,
                0x9DCE: 0x659F,
                0x9DCF: 0x65AB,
                0x9DD0: 0x65B7,
                0x9DD1: 0x65C3,
                0x9DD2: 0x65C6,
                0x9DD3: 0x65C1,
                0x9DD4: 0x65C4,
                0x9DD5: 0x65CC,
                0x9DD6: 0x65D2,
                0x9DD7: 0x65DB,
                0x9DD8: 0x65D9,
                0x9DD9: 0x65E0,
                0x9DDA: 0x65E1,
                0x9DDB: 0x65F1,
                0x9DDC: 0x6772,
                0x9DDD: 0x660A,
                0x9DDE: 0x6603,
                0x9DDF: 0x65FB,
                0x9DE0: 0x6773,
                0x9DE1: 0x6635,
                0x9DE2: 0x6636,
                0x9DE3: 0x6634,
                0x9DE4: 0x661C,
                0x9DE5: 0x664F,
                0x9DE6: 0x6644,
                0x9DE7: 0x6649,
                0x9DE8: 0x6641,
                0x9DE9: 0x665E,
                0x9DEA: 0x665D,
                0x9DEB: 0x6664,
                0x9DEC: 0x6667,
                0x9DED: 0x6668,
                0x9DEE: 0x665F,
                0x9DEF: 0x6662,
                0x9DF0: 0x6670,
                0x9DF1: 0x6683,
                0x9DF2: 0x6688,
                0x9DF3: 0x668E,
                0x9DF4: 0x6689,
                0x9DF5: 0x6684,
                0x9DF6: 0x6698,
                0x9DF7: 0x669D,
                0x9DF8: 0x66C1,
                0x9DF9: 0x66B9,
                0x9DFA: 0x66C9,
                0x9DFB: 0x66BE,
                0x9DFC: 0x66BC,
                0x9E40: 0x66C4,
                0x9E41: 0x66B8,
                0x9E42: 0x66D6,
                0x9E43: 0x66DA,
                0x9E44: 0x66E0,
                0x9E45: 0x663F,
                0x9E46: 0x66E6,
                0x9E47: 0x66E9,
                0x9E48: 0x66F0,
                0x9E49: 0x66F5,
                0x9E4A: 0x66F7,
                0x9E4B: 0x670F,
                0x9E4C: 0x6716,
                0x9E4D: 0x671E,
                0x9E4E: 0x6726,
                0x9E4F: 0x6727,
                0x9E50: 0x9738,
                0x9E51: 0x672E,
                0x9E52: 0x673F,
                0x9E53: 0x6736,
                0x9E54: 0x6741,
                0x9E55: 0x6738,
                0x9E56: 0x6737,
                0x9E57: 0x6746,
                0x9E58: 0x675E,
                0x9E59: 0x6760,
                0x9E5A: 0x6759,
                0x9E5B: 0x6763,
                0x9E5C: 0x6764,
                0x9E5D: 0x6789,
                0x9E5E: 0x6770,
                0x9E5F: 0x67A9,
                0x9E60: 0x677C,
                0x9E61: 0x676A,
                0x9E62: 0x678C,
                0x9E63: 0x678B,
                0x9E64: 0x67A6,
                0x9E65: 0x67A1,
                0x9E66: 0x6785,
                0x9E67: 0x67B7,
                0x9E68: 0x67EF,
                0x9E69: 0x67B4,
                0x9E6A: 0x67EC,
                0x9E6B: 0x67B3,
                0x9E6C: 0x67E9,
                0x9E6D: 0x67B8,
                0x9E6E: 0x67E4,
                0x9E6F: 0x67DE,
                0x9E70: 0x67DD,
                0x9E71: 0x67E2,
                0x9E72: 0x67EE,
                0x9E73: 0x67B9,
                0x9E74: 0x67CE,
                0x9E75: 0x67C6,
                0x9E76: 0x67E7,
                0x9E77: 0x6A9C,
                0x9E78: 0x681E,
                0x9E79: 0x6846,
                0x9E7A: 0x6829,
                0x9E7B: 0x6840,
                0x9E7C: 0x684D,
                0x9E7D: 0x6832,
                0x9E7E: 0x684E,
                0x9E80: 0x68B3,
                0x9E81: 0x682B,
                0x9E82: 0x6859,
                0x9E83: 0x6863,
                0x9E84: 0x6877,
                0x9E85: 0x687F,
                0x9E86: 0x689F,
                0x9E87: 0x688F,
                0x9E88: 0x68AD,
                0x9E89: 0x6894,
                0x9E8A: 0x689D,
                0x9E8B: 0x689B,
                0x9E8C: 0x6883,
                0x9E8D: 0x6AAE,
                0x9E8E: 0x68B9,
                0x9E8F: 0x6874,
                0x9E90: 0x68B5,
                0x9E91: 0x68A0,
                0x9E92: 0x68BA,
                0x9E93: 0x690F,
                0x9E94: 0x688D,
                0x9E95: 0x687E,
                0x9E96: 0x6901,
                0x9E97: 0x68CA,
                0x9E98: 0x6908,
                0x9E99: 0x68D8,
                0x9E9A: 0x6922,
                0x9E9B: 0x6926,
                0x9E9C: 0x68E1,
                0x9E9D: 0x690C,
                0x9E9E: 0x68CD,
                0x9E9F: 0x68D4,
                0x9EA0: 0x68E7,
                0x9EA1: 0x68D5,
                0x9EA2: 0x6936,
                0x9EA3: 0x6912,
                0x9EA4: 0x6904,
                0x9EA5: 0x68D7,
                0x9EA6: 0x68E3,
                0x9EA7: 0x6925,
                0x9EA8: 0x68F9,
                0x9EA9: 0x68E0,
                0x9EAA: 0x68EF,
                0x9EAB: 0x6928,
                0x9EAC: 0x692A,
                0x9EAD: 0x691A,
                0x9EAE: 0x6923,
                0x9EAF: 0x6921,
                0x9EB0: 0x68C6,
                0x9EB1: 0x6979,
                0x9EB2: 0x6977,
                0x9EB3: 0x695C,
                0x9EB4: 0x6978,
                0x9EB5: 0x696B,
                0x9EB6: 0x6954,
                0x9EB7: 0x697E,
                0x9EB8: 0x696E,
                0x9EB9: 0x6939,
                0x9EBA: 0x6974,
                0x9EBB: 0x693D,
                0x9EBC: 0x6959,
                0x9EBD: 0x6930,
                0x9EBE: 0x6961,
                0x9EBF: 0x695E,
                0x9EC0: 0x695D,
                0x9EC1: 0x6981,
                0x9EC2: 0x696A,
                0x9EC3: 0x69B2,
                0x9EC4: 0x69AE,
                0x9EC5: 0x69D0,
                0x9EC6: 0x69BF,
                0x9EC7: 0x69C1,
                0x9EC8: 0x69D3,
                0x9EC9: 0x69BE,
                0x9ECA: 0x69CE,
                0x9ECB: 0x5BE8,
                0x9ECC: 0x69CA,
                0x9ECD: 0x69DD,
                0x9ECE: 0x69BB,
                0x9ECF: 0x69C3,
                0x9ED0: 0x69A7,
                0x9ED1: 0x6A2E,
                0x9ED2: 0x6991,
                0x9ED3: 0x69A0,
                0x9ED4: 0x699C,
                0x9ED5: 0x6995,
                0x9ED6: 0x69B4,
                0x9ED7: 0x69DE,
                0x9ED8: 0x69E8,
                0x9ED9: 0x6A02,
                0x9EDA: 0x6A1B,
                0x9EDB: 0x69FF,
                0x9EDC: 0x6B0A,
                0x9EDD: 0x69F9,
                0x9EDE: 0x69F2,
                0x9EDF: 0x69E7,
                0x9EE0: 0x6A05,
                0x9EE1: 0x69B1,
                0x9EE2: 0x6A1E,
                0x9EE3: 0x69ED,
                0x9EE4: 0x6A14,
                0x9EE5: 0x69EB,
                0x9EE6: 0x6A0A,
                0x9EE7: 0x6A12,
                0x9EE8: 0x6AC1,
                0x9EE9: 0x6A23,
                0x9EEA: 0x6A13,
                0x9EEB: 0x6A44,
                0x9EEC: 0x6A0C,
                0x9EED: 0x6A72,
                0x9EEE: 0x6A36,
                0x9EEF: 0x6A78,
                0x9EF0: 0x6A47,
                0x9EF1: 0x6A62,
                0x9EF2: 0x6A59,
                0x9EF3: 0x6A66,
                0x9EF4: 0x6A48,
                0x9EF5: 0x6A38,
                0x9EF6: 0x6A22,
                0x9EF7: 0x6A90,
                0x9EF8: 0x6A8D,
                0x9EF9: 0x6AA0,
                0x9EFA: 0x6A84,
                0x9EFB: 0x6AA2,
                0x9EFC: 0x6AA3,
                0x9F40: 0x6A97,
                0x9F41: 0x8617,
                0x9F42: 0x6ABB,
                0x9F43: 0x6AC3,
                0x9F44: 0x6AC2,
                0x9F45: 0x6AB8,
                0x9F46: 0x6AB3,
                0x9F47: 0x6AAC,
                0x9F48: 0x6ADE,
                0x9F49: 0x6AD1,
                0x9F4A: 0x6ADF,
                0x9F4B: 0x6AAA,
                0x9F4C: 0x6ADA,
                0x9F4D: 0x6AEA,
                0x9F4E: 0x6AFB,
                0x9F4F: 0x6B05,
                0x9F50: 0x8616,
                0x9F51: 0x6AFA,
                0x9F52: 0x6B12,
                0x9F53: 0x6B16,
                0x9F54: 0x9B31,
                0x9F55: 0x6B1F,
                0x9F56: 0x6B38,
                0x9F57: 0x6B37,
                0x9F58: 0x76DC,
                0x9F59: 0x6B39,
                0x9F5A: 0x98EE,
                0x9F5B: 0x6B47,
                0x9F5C: 0x6B43,
                0x9F5D: 0x6B49,
                0x9F5E: 0x6B50,
                0x9F5F: 0x6B59,
                0x9F60: 0x6B54,
                0x9F61: 0x6B5B,
                0x9F62: 0x6B5F,
                0x9F63: 0x6B61,
                0x9F64: 0x6B78,
                0x9F65: 0x6B79,
                0x9F66: 0x6B7F,
                0x9F67: 0x6B80,
                0x9F68: 0x6B84,
                0x9F69: 0x6B83,
                0x9F6A: 0x6B8D,
                0x9F6B: 0x6B98,
                0x9F6C: 0x6B95,
                0x9F6D: 0x6B9E,
                0x9F6E: 0x6BA4,
                0x9F6F: 0x6BAA,
                0x9F70: 0x6BAB,
                0x9F71: 0x6BAF,
                0x9F72: 0x6BB2,
                0x9F73: 0x6BB1,
                0x9F74: 0x6BB3,
                0x9F75: 0x6BB7,
                0x9F76: 0x6BBC,
                0x9F77: 0x6BC6,
                0x9F78: 0x6BCB,
                0x9F79: 0x6BD3,
                0x9F7A: 0x6BDF,
                0x9F7B: 0x6BEC,
                0x9F7C: 0x6BEB,
                0x9F7D: 0x6BF3,
                0x9F7E: 0x6BEF,
                0x9F80: 0x9EBE,
                0x9F81: 0x6C08,
                0x9F82: 0x6C13,
                0x9F83: 0x6C14,
                0x9F84: 0x6C1B,
                0x9F85: 0x6C24,
                0x9F86: 0x6C23,
                0x9F87: 0x6C5E,
                0x9F88: 0x6C55,
                0x9F89: 0x6C62,
                0x9F8A: 0x6C6A,
                0x9F8B: 0x6C82,
                0x9F8C: 0x6C8D,
                0x9F8D: 0x6C9A,
                0x9F8E: 0x6C81,
                0x9F8F: 0x6C9B,
                0x9F90: 0x6C7E,
                0x9F91: 0x6C68,
                0x9F92: 0x6C73,
                0x9F93: 0x6C92,
                0x9F94: 0x6C90,
                0x9F95: 0x6CC4,
                0x9F96: 0x6CF1,
                0x9F97: 0x6CD3,
                0x9F98: 0x6CBD,
                0x9F99: 0x6CD7,
                0x9F9A: 0x6CC5,
                0x9F9B: 0x6CDD,
                0x9F9C: 0x6CAE,
                0x9F9D: 0x6CB1,
                0x9F9E: 0x6CBE,
                0x9F9F: 0x6CBA,
                0x9FA0: 0x6CDB,
                0x9FA1: 0x6CEF,
                0x9FA2: 0x6CD9,
                0x9FA3: 0x6CEA,
                0x9FA4: 0x6D1F,
                0x9FA5: 0x884D,
                0x9FA6: 0x6D36,
                0x9FA7: 0x6D2B,
                0x9FA8: 0x6D3D,
                0x9FA9: 0x6D38,
                0x9FAA: 0x6D19,
                0x9FAB: 0x6D35,
                0x9FAC: 0x6D33,
                0x9FAD: 0x6D12,
                0x9FAE: 0x6D0C,
                0x9FAF: 0x6D63,
                0x9FB0: 0x6D93,
                0x9FB1: 0x6D64,
                0x9FB2: 0x6D5A,
                0x9FB3: 0x6D79,
                0x9FB4: 0x6D59,
                0x9FB5: 0x6D8E,
                0x9FB6: 0x6D95,
                0x9FB7: 0x6FE4,
                0x9FB8: 0x6D85,
                0x9FB9: 0x6DF9,
                0x9FBA: 0x6E15,
                0x9FBB: 0x6E0A,
                0x9FBC: 0x6DB5,
                0x9FBD: 0x6DC7,
                0x9FBE: 0x6DE6,
                0x9FBF: 0x6DB8,
                0x9FC0: 0x6DC6,
                0x9FC1: 0x6DEC,
                0x9FC2: 0x6DDE,
                0x9FC3: 0x6DCC,
                0x9FC4: 0x6DE8,
                0x9FC5: 0x6DD2,
                0x9FC6: 0x6DC5,
                0x9FC7: 0x6DFA,
                0x9FC8: 0x6DD9,
                0x9FC9: 0x6DE4,
                0x9FCA: 0x6DD5,
                0x9FCB: 0x6DEA,
                0x9FCC: 0x6DEE,
                0x9FCD: 0x6E2D,
                0x9FCE: 0x6E6E,
                0x9FCF: 0x6E2E,
                0x9FD0: 0x6E19,
                0x9FD1: 0x6E72,
                0x9FD2: 0x6E5F,
                0x9FD3: 0x6E3E,
                0x9FD4: 0x6E23,
                0x9FD5: 0x6E6B,
                0x9FD6: 0x6E2B,
                0x9FD7: 0x6E76,
                0x9FD8: 0x6E4D,
                0x9FD9: 0x6E1F,
                0x9FDA: 0x6E43,
                0x9FDB: 0x6E3A,
                0x9FDC: 0x6E4E,
                0x9FDD: 0x6E24,
                0x9FDE: 0x6EFF,
                0x9FDF: 0x6E1D,
                0x9FE0: 0x6E38,
                0x9FE1: 0x6E82,
                0x9FE2: 0x6EAA,
                0x9FE3: 0x6E98,
                0x9FE4: 0x6EC9,
                0x9FE5: 0x6EB7,
                0x9FE6: 0x6ED3,
                0x9FE7: 0x6EBD,
                0x9FE8: 0x6EAF,
                0x9FE9: 0x6EC4,
                0x9FEA: 0x6EB2,
                0x9FEB: 0x6ED4,
                0x9FEC: 0x6ED5,
                0x9FED: 0x6E8F,
                0x9FEE: 0x6EA5,
                0x9FEF: 0x6EC2,
                0x9FF0: 0x6E9F,
                0x9FF1: 0x6F41,
                0x9FF2: 0x6F11,
                0x9FF3: 0x704C,
                0x9FF4: 0x6EEC,
                0x9FF5: 0x6EF8,
                0x9FF6: 0x6EFE,
                0x9FF7: 0x6F3F,
                0x9FF8: 0x6EF2,
                0x9FF9: 0x6F31,
                0x9FFA: 0x6EEF,
                0x9FFB: 0x6F32,
                0x9FFC: 0x6ECC,
                0xA1: 0xFF61,
                0xA2: 0xFF62,
                0xA3: 0xFF63,
                0xA4: 0xFF64,
                0xA5: 0xFF65,
                0xA6: 0xFF66,
                0xA7: 0xFF67,
                0xA8: 0xFF68,
                0xA9: 0xFF69,
                0xAA: 0xFF6A,
                0xAB: 0xFF6B,
                0xAC: 0xFF6C,
                0xAD: 0xFF6D,
                0xAE: 0xFF6E,
                0xAF: 0xFF6F,
                0xB0: 0xFF70,
                0xB1: 0xFF71,
                0xB2: 0xFF72,
                0xB3: 0xFF73,
                0xB4: 0xFF74,
                0xB5: 0xFF75,
                0xB6: 0xFF76,
                0xB7: 0xFF77,
                0xB8: 0xFF78,
                0xB9: 0xFF79,
                0xBA: 0xFF7A,
                0xBB: 0xFF7B,
                0xBC: 0xFF7C,
                0xBD: 0xFF7D,
                0xBE: 0xFF7E,
                0xBF: 0xFF7F,
                0xC0: 0xFF80,
                0xC1: 0xFF81,
                0xC2: 0xFF82,
                0xC3: 0xFF83,
                0xC4: 0xFF84,
                0xC5: 0xFF85,
                0xC6: 0xFF86,
                0xC7: 0xFF87,
                0xC8: 0xFF88,
                0xC9: 0xFF89,
                0xCA: 0xFF8A,
                0xCB: 0xFF8B,
                0xCC: 0xFF8C,
                0xCD: 0xFF8D,
                0xCE: 0xFF8E,
                0xCF: 0xFF8F,
                0xD0: 0xFF90,
                0xD1: 0xFF91,
                0xD2: 0xFF92,
                0xD3: 0xFF93,
                0xD4: 0xFF94,
                0xD5: 0xFF95,
                0xD6: 0xFF96,
                0xD7: 0xFF97,
                0xD8: 0xFF98,
                0xD9: 0xFF99,
                0xDA: 0xFF9A,
                0xDB: 0xFF9B,
                0xDC: 0xFF9C,
                0xDD: 0xFF9D,
                0xDE: 0xFF9E,
                0xDF: 0xFF9F,
                0xE040: 0x6F3E,
                0xE041: 0x6F13,
                0xE042: 0x6EF7,
                0xE043: 0x6F86,
                0xE044: 0x6F7A,
                0xE045: 0x6F78,
                0xE046: 0x6F81,
                0xE047: 0x6F80,
                0xE048: 0x6F6F,
                0xE049: 0x6F5B,
                0xE04A: 0x6FF3,
                0xE04B: 0x6F6D,
                0xE04C: 0x6F82,
                0xE04D: 0x6F7C,
                0xE04E: 0x6F58,
                0xE04F: 0x6F8E,
                0xE050: 0x6F91,
                0xE051: 0x6FC2,
                0xE052: 0x6F66,
                0xE053: 0x6FB3,
                0xE054: 0x6FA3,
                0xE055: 0x6FA1,
                0xE056: 0x6FA4,
                0xE057: 0x6FB9,
                0xE058: 0x6FC6,
                0xE059: 0x6FAA,
                0xE05A: 0x6FDF,
                0xE05B: 0x6FD5,
                0xE05C: 0x6FEC,
                0xE05D: 0x6FD4,
                0xE05E: 0x6FD8,
                0xE05F: 0x6FF1,
                0xE060: 0x6FEE,
                0xE061: 0x6FDB,
                0xE062: 0x7009,
                0xE063: 0x700B,
                0xE064: 0x6FFA,
                0xE065: 0x7011,
                0xE066: 0x7001,
                0xE067: 0x700F,
                0xE068: 0x6FFE,
                0xE069: 0x701B,
                0xE06A: 0x701A,
                0xE06B: 0x6F74,
                0xE06C: 0x701D,
                0xE06D: 0x7018,
                0xE06E: 0x701F,
                0xE06F: 0x7030,
                0xE070: 0x703E,
                0xE071: 0x7032,
                0xE072: 0x7051,
                0xE073: 0x7063,
                0xE074: 0x7099,
                0xE075: 0x7092,
                0xE076: 0x70AF,
                0xE077: 0x70F1,
                0xE078: 0x70AC,
                0xE079: 0x70B8,
                0xE07A: 0x70B3,
                0xE07B: 0x70AE,
                0xE07C: 0x70DF,
                0xE07D: 0x70CB,
                0xE07E: 0x70DD,
                0xE080: 0x70D9,
                0xE081: 0x7109,
                0xE082: 0x70FD,
                0xE083: 0x711C,
                0xE084: 0x7119,
                0xE085: 0x7165,
                0xE086: 0x7155,
                0xE087: 0x7188,
                0xE088: 0x7166,
                0xE089: 0x7162,
                0xE08A: 0x714C,
                0xE08B: 0x7156,
                0xE08C: 0x716C,
                0xE08D: 0x718F,
                0xE08E: 0x71FB,
                0xE08F: 0x7184,
                0xE090: 0x7195,
                0xE091: 0x71A8,
                0xE092: 0x71AC,
                0xE093: 0x71D7,
                0xE094: 0x71B9,
                0xE095: 0x71BE,
                0xE096: 0x71D2,
                0xE097: 0x71C9,
                0xE098: 0x71D4,
                0xE099: 0x71CE,
                0xE09A: 0x71E0,
                0xE09B: 0x71EC,
                0xE09C: 0x71E7,
                0xE09D: 0x71F5,
                0xE09E: 0x71FC,
                0xE09F: 0x71F9,
                0xE0A0: 0x71FF,
                0xE0A1: 0x720D,
                0xE0A2: 0x7210,
                0xE0A3: 0x721B,
                0xE0A4: 0x7228,
                0xE0A5: 0x722D,
                0xE0A6: 0x722C,
                0xE0A7: 0x7230,
                0xE0A8: 0x7232,
                0xE0A9: 0x723B,
                0xE0AA: 0x723C,
                0xE0AB: 0x723F,
                0xE0AC: 0x7240,
                0xE0AD: 0x7246,
                0xE0AE: 0x724B,
                0xE0AF: 0x7258,
                0xE0B0: 0x7274,
                0xE0B1: 0x727E,
                0xE0B2: 0x7282,
                0xE0B3: 0x7281,
                0xE0B4: 0x7287,
                0xE0B5: 0x7292,
                0xE0B6: 0x7296,
                0xE0B7: 0x72A2,
                0xE0B8: 0x72A7,
                0xE0B9: 0x72B9,
                0xE0BA: 0x72B2,
                0xE0BB: 0x72C3,
                0xE0BC: 0x72C6,
                0xE0BD: 0x72C4,
                0xE0BE: 0x72CE,
                0xE0BF: 0x72D2,
                0xE0C0: 0x72E2,
                0xE0C1: 0x72E0,
                0xE0C2: 0x72E1,
                0xE0C3: 0x72F9,
                0xE0C4: 0x72F7,
                0xE0C5: 0x500F,
                0xE0C6: 0x7317,
                0xE0C7: 0x730A,
                0xE0C8: 0x731C,
                0xE0C9: 0x7316,
                0xE0CA: 0x731D,
                0xE0CB: 0x7334,
                0xE0CC: 0x732F,
                0xE0CD: 0x7329,
                0xE0CE: 0x7325,
                0xE0CF: 0x733E,
                0xE0D0: 0x734E,
                0xE0D1: 0x734F,
                0xE0D2: 0x9ED8,
                0xE0D3: 0x7357,
                0xE0D4: 0x736A,
                0xE0D5: 0x7368,
                0xE0D6: 0x7370,
                0xE0D7: 0x7378,
                0xE0D8: 0x7375,
                0xE0D9: 0x737B,
                0xE0DA: 0x737A,
                0xE0DB: 0x73C8,
                0xE0DC: 0x73B3,
                0xE0DD: 0x73CE,
                0xE0DE: 0x73BB,
                0xE0DF: 0x73C0,
                0xE0E0: 0x73E5,
                0xE0E1: 0x73EE,
                0xE0E2: 0x73DE,
                0xE0E3: 0x74A2,
                0xE0E4: 0x7405,
                0xE0E5: 0x746F,
                0xE0E6: 0x7425,
                0xE0E7: 0x73F8,
                0xE0E8: 0x7432,
                0xE0E9: 0x743A,
                0xE0EA: 0x7455,
                0xE0EB: 0x743F,
                0xE0EC: 0x745F,
                0xE0ED: 0x7459,
                0xE0EE: 0x7441,
                0xE0EF: 0x745C,
                0xE0F0: 0x7469,
                0xE0F1: 0x7470,
                0xE0F2: 0x7463,
                0xE0F3: 0x746A,
                0xE0F4: 0x7476,
                0xE0F5: 0x747E,
                0xE0F6: 0x748B,
                0xE0F7: 0x749E,
                0xE0F8: 0x74A7,
                0xE0F9: 0x74CA,
                0xE0FA: 0x74CF,
                0xE0FB: 0x74D4,
                0xE0FC: 0x73F1,
                0xE140: 0x74E0,
                0xE141: 0x74E3,
                0xE142: 0x74E7,
                0xE143: 0x74E9,
                0xE144: 0x74EE,
                0xE145: 0x74F2,
                0xE146: 0x74F0,
                0xE147: 0x74F1,
                0xE148: 0x74F8,
                0xE149: 0x74F7,
                0xE14A: 0x7504,
                0xE14B: 0x7503,
                0xE14C: 0x7505,
                0xE14D: 0x750C,
                0xE14E: 0x750E,
                0xE14F: 0x750D,
                0xE150: 0x7515,
                0xE151: 0x7513,
                0xE152: 0x751E,
                0xE153: 0x7526,
                0xE154: 0x752C,
                0xE155: 0x753C,
                0xE156: 0x7544,
                0xE157: 0x754D,
                0xE158: 0x754A,
                0xE159: 0x7549,
                0xE15A: 0x755B,
                0xE15B: 0x7546,
                0xE15C: 0x755A,
                0xE15D: 0x7569,
                0xE15E: 0x7564,
                0xE15F: 0x7567,
                0xE160: 0x756B,
                0xE161: 0x756D,
                0xE162: 0x7578,
                0xE163: 0x7576,
                0xE164: 0x7586,
                0xE165: 0x7587,
                0xE166: 0x7574,
                0xE167: 0x758A,
                0xE168: 0x7589,
                0xE169: 0x7582,
                0xE16A: 0x7594,
                0xE16B: 0x759A,
                0xE16C: 0x759D,
                0xE16D: 0x75A5,
                0xE16E: 0x75A3,
                0xE16F: 0x75C2,
                0xE170: 0x75B3,
                0xE171: 0x75C3,
                0xE172: 0x75B5,
                0xE173: 0x75BD,
                0xE174: 0x75B8,
                0xE175: 0x75BC,
                0xE176: 0x75B1,
                0xE177: 0x75CD,
                0xE178: 0x75CA,
                0xE179: 0x75D2,
                0xE17A: 0x75D9,
                0xE17B: 0x75E3,
                0xE17C: 0x75DE,
                0xE17D: 0x75FE,
                0xE17E: 0x75FF,
                0xE180: 0x75FC,
                0xE181: 0x7601,
                0xE182: 0x75F0,
                0xE183: 0x75FA,
                0xE184: 0x75F2,
                0xE185: 0x75F3,
                0xE186: 0x760B,
                0xE187: 0x760D,
                0xE188: 0x7609,
                0xE189: 0x761F,
                0xE18A: 0x7627,
                0xE18B: 0x7620,
                0xE18C: 0x7621,
                0xE18D: 0x7622,
                0xE18E: 0x7624,
                0xE18F: 0x7634,
                0xE190: 0x7630,
                0xE191: 0x763B,
                0xE192: 0x7647,
                0xE193: 0x7648,
                0xE194: 0x7646,
                0xE195: 0x765C,
                0xE196: 0x7658,
                0xE197: 0x7661,
                0xE198: 0x7662,
                0xE199: 0x7668,
                0xE19A: 0x7669,
                0xE19B: 0x766A,
                0xE19C: 0x7667,
                0xE19D: 0x766C,
                0xE19E: 0x7670,
                0xE19F: 0x7672,
                0xE1A0: 0x7676,
                0xE1A1: 0x7678,
                0xE1A2: 0x767C,
                0xE1A3: 0x7680,
                0xE1A4: 0x7683,
                0xE1A5: 0x7688,
                0xE1A6: 0x768B,
                0xE1A7: 0x768E,
                0xE1A8: 0x7696,
                0xE1A9: 0x7693,
                0xE1AA: 0x7699,
                0xE1AB: 0x769A,
                0xE1AC: 0x76B0,
                0xE1AD: 0x76B4,
                0xE1AE: 0x76B8,
                0xE1AF: 0x76B9,
                0xE1B0: 0x76BA,
                0xE1B1: 0x76C2,
                0xE1B2: 0x76CD,
                0xE1B3: 0x76D6,
                0xE1B4: 0x76D2,
                0xE1B5: 0x76DE,
                0xE1B6: 0x76E1,
                0xE1B7: 0x76E5,
                0xE1B8: 0x76E7,
                0xE1B9: 0x76EA,
                0xE1BA: 0x862F,
                0xE1BB: 0x76FB,
                0xE1BC: 0x7708,
                0xE1BD: 0x7707,
                0xE1BE: 0x7704,
                0xE1BF: 0x7729,
                0xE1C0: 0x7724,
                0xE1C1: 0x771E,
                0xE1C2: 0x7725,
                0xE1C3: 0x7726,
                0xE1C4: 0x771B,
                0xE1C5: 0x7737,
                0xE1C6: 0x7738,
                0xE1C7: 0x7747,
                0xE1C8: 0x775A,
                0xE1C9: 0x7768,
                0xE1CA: 0x776B,
                0xE1CB: 0x775B,
                0xE1CC: 0x7765,
                0xE1CD: 0x777F,
                0xE1CE: 0x777E,
                0xE1CF: 0x7779,
                0xE1D0: 0x778E,
                0xE1D1: 0x778B,
                0xE1D2: 0x7791,
                0xE1D3: 0x77A0,
                0xE1D4: 0x779E,
                0xE1D5: 0x77B0,
                0xE1D6: 0x77B6,
                0xE1D7: 0x77B9,
                0xE1D8: 0x77BF,
                0xE1D9: 0x77BC,
                0xE1DA: 0x77BD,
                0xE1DB: 0x77BB,
                0xE1DC: 0x77C7,
                0xE1DD: 0x77CD,
                0xE1DE: 0x77D7,
                0xE1DF: 0x77DA,
                0xE1E0: 0x77DC,
                0xE1E1: 0x77E3,
                0xE1E2: 0x77EE,
                0xE1E3: 0x77FC,
                0xE1E4: 0x780C,
                0xE1E5: 0x7812,
                0xE1E6: 0x7926,
                0xE1E7: 0x7820,
                0xE1E8: 0x792A,
                0xE1E9: 0x7845,
                0xE1EA: 0x788E,
                0xE1EB: 0x7874,
                0xE1EC: 0x7886,
                0xE1ED: 0x787C,
                0xE1EE: 0x789A,
                0xE1EF: 0x788C,
                0xE1F0: 0x78A3,
                0xE1F1: 0x78B5,
                0xE1F2: 0x78AA,
                0xE1F3: 0x78AF,
                0xE1F4: 0x78D1,
                0xE1F5: 0x78C6,
                0xE1F6: 0x78CB,
                0xE1F7: 0x78D4,
                0xE1F8: 0x78BE,
                0xE1F9: 0x78BC,
                0xE1FA: 0x78C5,
                0xE1FB: 0x78CA,
                0xE1FC: 0x78EC,
                0xE240: 0x78E7,
                0xE241: 0x78DA,
                0xE242: 0x78FD,
                0xE243: 0x78F4,
                0xE244: 0x7907,
                0xE245: 0x7912,
                0xE246: 0x7911,
                0xE247: 0x7919,
                0xE248: 0x792C,
                0xE249: 0x792B,
                0xE24A: 0x7940,
                0xE24B: 0x7960,
                0xE24C: 0x7957,
                0xE24D: 0x795F,
                0xE24E: 0x795A,
                0xE24F: 0x7955,
                0xE250: 0x7953,
                0xE251: 0x797A,
                0xE252: 0x797F,
                0xE253: 0x798A,
                0xE254: 0x799D,
                0xE255: 0x79A7,
                0xE256: 0x9F4B,
                0xE257: 0x79AA,
                0xE258: 0x79AE,
                0xE259: 0x79B3,
                0xE25A: 0x79B9,
                0xE25B: 0x79BA,
                0xE25C: 0x79C9,
                0xE25D: 0x79D5,
                0xE25E: 0x79E7,
                0xE25F: 0x79EC,
                0xE260: 0x79E1,
                0xE261: 0x79E3,
                0xE262: 0x7A08,
                0xE263: 0x7A0D,
                0xE264: 0x7A18,
                0xE265: 0x7A19,
                0xE266: 0x7A20,
                0xE267: 0x7A1F,
                0xE268: 0x7980,
                0xE269: 0x7A31,
                0xE26A: 0x7A3B,
                0xE26B: 0x7A3E,
                0xE26C: 0x7A37,
                0xE26D: 0x7A43,
                0xE26E: 0x7A57,
                0xE26F: 0x7A49,
                0xE270: 0x7A61,
                0xE271: 0x7A62,
                0xE272: 0x7A69,
                0xE273: 0x9F9D,
                0xE274: 0x7A70,
                0xE275: 0x7A79,
                0xE276: 0x7A7D,
                0xE277: 0x7A88,
                0xE278: 0x7A97,
                0xE279: 0x7A95,
                0xE27A: 0x7A98,
                0xE27B: 0x7A96,
                0xE27C: 0x7AA9,
                0xE27D: 0x7AC8,
                0xE27E: 0x7AB0,
                0xE280: 0x7AB6,
                0xE281: 0x7AC5,
                0xE282: 0x7AC4,
                0xE283: 0x7ABF,
                0xE284: 0x9083,
                0xE285: 0x7AC7,
                0xE286: 0x7ACA,
                0xE287: 0x7ACD,
                0xE288: 0x7ACF,
                0xE289: 0x7AD5,
                0xE28A: 0x7AD3,
                0xE28B: 0x7AD9,
                0xE28C: 0x7ADA,
                0xE28D: 0x7ADD,
                0xE28E: 0x7AE1,
                0xE28F: 0x7AE2,
                0xE290: 0x7AE6,
                0xE291: 0x7AED,
                0xE292: 0x7AF0,
                0xE293: 0x7B02,
                0xE294: 0x7B0F,
                0xE295: 0x7B0A,
                0xE296: 0x7B06,
                0xE297: 0x7B33,
                0xE298: 0x7B18,
                0xE299: 0x7B19,
                0xE29A: 0x7B1E,
                0xE29B: 0x7B35,
                0xE29C: 0x7B28,
                0xE29D: 0x7B36,
                0xE29E: 0x7B50,
                0xE29F: 0x7B7A,
                0xE2A0: 0x7B04,
                0xE2A1: 0x7B4D,
                0xE2A2: 0x7B0B,
                0xE2A3: 0x7B4C,
                0xE2A4: 0x7B45,
                0xE2A5: 0x7B75,
                0xE2A6: 0x7B65,
                0xE2A7: 0x7B74,
                0xE2A8: 0x7B67,
                0xE2A9: 0x7B70,
                0xE2AA: 0x7B71,
                0xE2AB: 0x7B6C,
                0xE2AC: 0x7B6E,
                0xE2AD: 0x7B9D,
                0xE2AE: 0x7B98,
                0xE2AF: 0x7B9F,
                0xE2B0: 0x7B8D,
                0xE2B1: 0x7B9C,
                0xE2B2: 0x7B9A,
                0xE2B3: 0x7B8B,
                0xE2B4: 0x7B92,
                0xE2B5: 0x7B8F,
                0xE2B6: 0x7B5D,
                0xE2B7: 0x7B99,
                0xE2B8: 0x7BCB,
                0xE2B9: 0x7BC1,
                0xE2BA: 0x7BCC,
                0xE2BB: 0x7BCF,
                0xE2BC: 0x7BB4,
                0xE2BD: 0x7BC6,
                0xE2BE: 0x7BDD,
                0xE2BF: 0x7BE9,
                0xE2C0: 0x7C11,
                0xE2C1: 0x7C14,
                0xE2C2: 0x7BE6,
                0xE2C3: 0x7BE5,
                0xE2C4: 0x7C60,
                0xE2C5: 0x7C00,
                0xE2C6: 0x7C07,
                0xE2C7: 0x7C13,
                0xE2C8: 0x7BF3,
                0xE2C9: 0x7BF7,
                0xE2CA: 0x7C17,
                0xE2CB: 0x7C0D,
                0xE2CC: 0x7BF6,
                0xE2CD: 0x7C23,
                0xE2CE: 0x7C27,
                0xE2CF: 0x7C2A,
                0xE2D0: 0x7C1F,
                0xE2D1: 0x7C37,
                0xE2D2: 0x7C2B,
                0xE2D3: 0x7C3D,
                0xE2D4: 0x7C4C,
                0xE2D5: 0x7C43,
                0xE2D6: 0x7C54,
                0xE2D7: 0x7C4F,
                0xE2D8: 0x7C40,
                0xE2D9: 0x7C50,
                0xE2DA: 0x7C58,
                0xE2DB: 0x7C5F,
                0xE2DC: 0x7C64,
                0xE2DD: 0x7C56,
                0xE2DE: 0x7C65,
                0xE2DF: 0x7C6C,
                0xE2E0: 0x7C75,
                0xE2E1: 0x7C83,
                0xE2E2: 0x7C90,
                0xE2E3: 0x7CA4,
                0xE2E4: 0x7CAD,
                0xE2E5: 0x7CA2,
                0xE2E6: 0x7CAB,
                0xE2E7: 0x7CA1,
                0xE2E8: 0x7CA8,
                0xE2E9: 0x7CB3,
                0xE2EA: 0x7CB2,
                0xE2EB: 0x7CB1,
                0xE2EC: 0x7CAE,
                0xE2ED: 0x7CB9,
                0xE2EE: 0x7CBD,
                0xE2EF: 0x7CC0,
                0xE2F0: 0x7CC5,
                0xE2F1: 0x7CC2,
                0xE2F2: 0x7CD8,
                0xE2F3: 0x7CD2,
                0xE2F4: 0x7CDC,
                0xE2F5: 0x7CE2,
                0xE2F6: 0x9B3B,
                0xE2F7: 0x7CEF,
                0xE2F8: 0x7CF2,
                0xE2F9: 0x7CF4,
                0xE2FA: 0x7CF6,
                0xE2FB: 0x7CFA,
                0xE2FC: 0x7D06,
                0xE340: 0x7D02,
                0xE341: 0x7D1C,
                0xE342: 0x7D15,
                0xE343: 0x7D0A,
                0xE344: 0x7D45,
                0xE345: 0x7D4B,
                0xE346: 0x7D2E,
                0xE347: 0x7D32,
                0xE348: 0x7D3F,
                0xE349: 0x7D35,
                0xE34A: 0x7D46,
                0xE34B: 0x7D73,
                0xE34C: 0x7D56,
                0xE34D: 0x7D4E,
                0xE34E: 0x7D72,
                0xE34F: 0x7D68,
                0xE350: 0x7D6E,
                0xE351: 0x7D4F,
                0xE352: 0x7D63,
                0xE353: 0x7D93,
                0xE354: 0x7D89,
                0xE355: 0x7D5B,
                0xE356: 0x7D8F,
                0xE357: 0x7D7D,
                0xE358: 0x7D9B,
                0xE359: 0x7DBA,
                0xE35A: 0x7DAE,
                0xE35B: 0x7DA3,
                0xE35C: 0x7DB5,
                0xE35D: 0x7DC7,
                0xE35E: 0x7DBD,
                0xE35F: 0x7DAB,
                0xE360: 0x7E3D,
                0xE361: 0x7DA2,
                0xE362: 0x7DAF,
                0xE363: 0x7DDC,
                0xE364: 0x7DB8,
                0xE365: 0x7D9F,
                0xE366: 0x7DB0,
                0xE367: 0x7DD8,
                0xE368: 0x7DDD,
                0xE369: 0x7DE4,
                0xE36A: 0x7DDE,
                0xE36B: 0x7DFB,
                0xE36C: 0x7DF2,
                0xE36D: 0x7DE1,
                0xE36E: 0x7E05,
                0xE36F: 0x7E0A,
                0xE370: 0x7E23,
                0xE371: 0x7E21,
                0xE372: 0x7E12,
                0xE373: 0x7E31,
                0xE374: 0x7E1F,
                0xE375: 0x7E09,
                0xE376: 0x7E0B,
                0xE377: 0x7E22,
                0xE378: 0x7E46,
                0xE379: 0x7E66,
                0xE37A: 0x7E3B,
                0xE37B: 0x7E35,
                0xE37C: 0x7E39,
                0xE37D: 0x7E43,
                0xE37E: 0x7E37,
                0xE380: 0x7E32,
                0xE381: 0x7E3A,
                0xE382: 0x7E67,
                0xE383: 0x7E5D,
                0xE384: 0x7E56,
                0xE385: 0x7E5E,
                0xE386: 0x7E59,
                0xE387: 0x7E5A,
                0xE388: 0x7E79,
                0xE389: 0x7E6A,
                0xE38A: 0x7E69,
                0xE38B: 0x7E7C,
                0xE38C: 0x7E7B,
                0xE38D: 0x7E83,
                0xE38E: 0x7DD5,
                0xE38F: 0x7E7D,
                0xE390: 0x8FAE,
                0xE391: 0x7E7F,
                0xE392: 0x7E88,
                0xE393: 0x7E89,
                0xE394: 0x7E8C,
                0xE395: 0x7E92,
                0xE396: 0x7E90,
                0xE397: 0x7E93,
                0xE398: 0x7E94,
                0xE399: 0x7E96,
                0xE39A: 0x7E8E,
                0xE39B: 0x7E9B,
                0xE39C: 0x7E9C,
                0xE39D: 0x7F38,
                0xE39E: 0x7F3A,
                0xE39F: 0x7F45,
                0xE3A0: 0x7F4C,
                0xE3A1: 0x7F4D,
                0xE3A2: 0x7F4E,
                0xE3A3: 0x7F50,
                0xE3A4: 0x7F51,
                0xE3A5: 0x7F55,
                0xE3A6: 0x7F54,
                0xE3A7: 0x7F58,
                0xE3A8: 0x7F5F,
                0xE3A9: 0x7F60,
                0xE3AA: 0x7F68,
                0xE3AB: 0x7F69,
                0xE3AC: 0x7F67,
                0xE3AD: 0x7F78,
                0xE3AE: 0x7F82,
                0xE3AF: 0x7F86,
                0xE3B0: 0x7F83,
                0xE3B1: 0x7F88,
                0xE3B2: 0x7F87,
                0xE3B3: 0x7F8C,
                0xE3B4: 0x7F94,
                0xE3B5: 0x7F9E,
                0xE3B6: 0x7F9D,
                0xE3B7: 0x7F9A,
                0xE3B8: 0x7FA3,
                0xE3B9: 0x7FAF,
                0xE3BA: 0x7FB2,
                0xE3BB: 0x7FB9,
                0xE3BC: 0x7FAE,
                0xE3BD: 0x7FB6,
                0xE3BE: 0x7FB8,
                0xE3BF: 0x8B71,
                0xE3C0: 0x7FC5,
                0xE3C1: 0x7FC6,
                0xE3C2: 0x7FCA,
                0xE3C3: 0x7FD5,
                0xE3C4: 0x7FD4,
                0xE3C5: 0x7FE1,
                0xE3C6: 0x7FE6,
                0xE3C7: 0x7FE9,
                0xE3C8: 0x7FF3,
                0xE3C9: 0x7FF9,
                0xE3CA: 0x98DC,
                0xE3CB: 0x8006,
                0xE3CC: 0x8004,
                0xE3CD: 0x800B,
                0xE3CE: 0x8012,
                0xE3CF: 0x8018,
                0xE3D0: 0x8019,
                0xE3D1: 0x801C,
                0xE3D2: 0x8021,
                0xE3D3: 0x8028,
                0xE3D4: 0x803F,
                0xE3D5: 0x803B,
                0xE3D6: 0x804A,
                0xE3D7: 0x8046,
                0xE3D8: 0x8052,
                0xE3D9: 0x8058,
                0xE3DA: 0x805A,
                0xE3DB: 0x805F,
                0xE3DC: 0x8062,
                0xE3DD: 0x8068,
                0xE3DE: 0x8073,
                0xE3DF: 0x8072,
                0xE3E0: 0x8070,
                0xE3E1: 0x8076,
                0xE3E2: 0x8079,
                0xE3E3: 0x807D,
                0xE3E4: 0x807F,
                0xE3E5: 0x8084,
                0xE3E6: 0x8086,
                0xE3E7: 0x8085,
                0xE3E8: 0x809B,
                0xE3E9: 0x8093,
                0xE3EA: 0x809A,
                0xE3EB: 0x80AD,
                0xE3EC: 0x5190,
                0xE3ED: 0x80AC,
                0xE3EE: 0x80DB,
                0xE3EF: 0x80E5,
                0xE3F0: 0x80D9,
                0xE3F1: 0x80DD,
                0xE3F2: 0x80C4,
                0xE3F3: 0x80DA,
                0xE3F4: 0x80D6,
                0xE3F5: 0x8109,
                0xE3F6: 0x80EF,
                0xE3F7: 0x80F1,
                0xE3F8: 0x811B,
                0xE3F9: 0x8129,
                0xE3FA: 0x8123,
                0xE3FB: 0x812F,
                0xE3FC: 0x814B,
                0xE440: 0x968B,
                0xE441: 0x8146,
                0xE442: 0x813E,
                0xE443: 0x8153,
                0xE444: 0x8151,
                0xE445: 0x80FC,
                0xE446: 0x8171,
                0xE447: 0x816E,
                0xE448: 0x8165,
                0xE449: 0x8166,
                0xE44A: 0x8174,
                0xE44B: 0x8183,
                0xE44C: 0x8188,
                0xE44D: 0x818A,
                0xE44E: 0x8180,
                0xE44F: 0x8182,
                0xE450: 0x81A0,
                0xE451: 0x8195,
                0xE452: 0x81A4,
                0xE453: 0x81A3,
                0xE454: 0x815F,
                0xE455: 0x8193,
                0xE456: 0x81A9,
                0xE457: 0x81B0,
                0xE458: 0x81B5,
                0xE459: 0x81BE,
                0xE45A: 0x81B8,
                0xE45B: 0x81BD,
                0xE45C: 0x81C0,
                0xE45D: 0x81C2,
                0xE45E: 0x81BA,
                0xE45F: 0x81C9,
                0xE460: 0x81CD,
                0xE461: 0x81D1,
                0xE462: 0x81D9,
                0xE463: 0x81D8,
                0xE464: 0x81C8,
                0xE465: 0x81DA,
                0xE466: 0x81DF,
                0xE467: 0x81E0,
                0xE468: 0x81E7,
                0xE469: 0x81FA,
                0xE46A: 0x81FB,
                0xE46B: 0x81FE,
                0xE46C: 0x8201,
                0xE46D: 0x8202,
                0xE46E: 0x8205,
                0xE46F: 0x8207,
                0xE470: 0x820A,
                0xE471: 0x820D,
                0xE472: 0x8210,
                0xE473: 0x8216,
                0xE474: 0x8229,
                0xE475: 0x822B,
                0xE476: 0x8238,
                0xE477: 0x8233,
                0xE478: 0x8240,
                0xE479: 0x8259,
                0xE47A: 0x8258,
                0xE47B: 0x825D,
                0xE47C: 0x825A,
                0xE47D: 0x825F,
                0xE47E: 0x8264,
                0xE480: 0x8262,
                0xE481: 0x8268,
                0xE482: 0x826A,
                0xE483: 0x826B,
                0xE484: 0x822E,
                0xE485: 0x8271,
                0xE486: 0x8277,
                0xE487: 0x8278,
                0xE488: 0x827E,
                0xE489: 0x828D,
                0xE48A: 0x8292,
                0xE48B: 0x82AB,
                0xE48C: 0x829F,
                0xE48D: 0x82BB,
                0xE48E: 0x82AC,
                0xE48F: 0x82E1,
                0xE490: 0x82E3,
                0xE491: 0x82DF,
                0xE492: 0x82D2,
                0xE493: 0x82F4,
                0xE494: 0x82F3,
                0xE495: 0x82FA,
                0xE496: 0x8393,
                0xE497: 0x8303,
                0xE498: 0x82FB,
                0xE499: 0x82F9,
                0xE49A: 0x82DE,
                0xE49B: 0x8306,
                0xE49C: 0x82DC,
                0xE49D: 0x8309,
                0xE49E: 0x82D9,
                0xE49F: 0x8335,
                0xE4A0: 0x8334,
                0xE4A1: 0x8316,
                0xE4A2: 0x8332,
                0xE4A3: 0x8331,
                0xE4A4: 0x8340,
                0xE4A5: 0x8339,
                0xE4A6: 0x8350,
                0xE4A7: 0x8345,
                0xE4A8: 0x832F,
                0xE4A9: 0x832B,
                0xE4AA: 0x8317,
                0xE4AB: 0x8318,
                0xE4AC: 0x8385,
                0xE4AD: 0x839A,
                0xE4AE: 0x83AA,
                0xE4AF: 0x839F,
                0xE4B0: 0x83A2,
                0xE4B1: 0x8396,
                0xE4B2: 0x8323,
                0xE4B3: 0x838E,
                0xE4B4: 0x8387,
                0xE4B5: 0x838A,
                0xE4B6: 0x837C,
                0xE4B7: 0x83B5,
                0xE4B8: 0x8373,
                0xE4B9: 0x8375,
                0xE4BA: 0x83A0,
                0xE4BB: 0x8389,
                0xE4BC: 0x83A8,
                0xE4BD: 0x83F4,
                0xE4BE: 0x8413,
                0xE4BF: 0x83EB,
                0xE4C0: 0x83CE,
                0xE4C1: 0x83FD,
                0xE4C2: 0x8403,
                0xE4C3: 0x83D8,
                0xE4C4: 0x840B,
                0xE4C5: 0x83C1,
                0xE4C6: 0x83F7,
                0xE4C7: 0x8407,
                0xE4C8: 0x83E0,
                0xE4C9: 0x83F2,
                0xE4CA: 0x840D,
                0xE4CB: 0x8422,
                0xE4CC: 0x8420,
                0xE4CD: 0x83BD,
                0xE4CE: 0x8438,
                0xE4CF: 0x8506,
                0xE4D0: 0x83FB,
                0xE4D1: 0x846D,
                0xE4D2: 0x842A,
                0xE4D3: 0x843C,
                0xE4D4: 0x855A,
                0xE4D5: 0x8484,
                0xE4D6: 0x8477,
                0xE4D7: 0x846B,
                0xE4D8: 0x84AD,
                0xE4D9: 0x846E,
                0xE4DA: 0x8482,
                0xE4DB: 0x8469,
                0xE4DC: 0x8446,
                0xE4DD: 0x842C,
                0xE4DE: 0x846F,
                0xE4DF: 0x8479,
                0xE4E0: 0x8435,
                0xE4E1: 0x84CA,
                0xE4E2: 0x8462,
                0xE4E3: 0x84B9,
                0xE4E4: 0x84BF,
                0xE4E5: 0x849F,
                0xE4E6: 0x84D9,
                0xE4E7: 0x84CD,
                0xE4E8: 0x84BB,
                0xE4E9: 0x84DA,
                0xE4EA: 0x84D0,
                0xE4EB: 0x84C1,
                0xE4EC: 0x84C6,
                0xE4ED: 0x84D6,
                0xE4EE: 0x84A1,
                0xE4EF: 0x8521,
                0xE4F0: 0x84FF,
                0xE4F1: 0x84F4,
                0xE4F2: 0x8517,
                0xE4F3: 0x8518,
                0xE4F4: 0x852C,
                0xE4F5: 0x851F,
                0xE4F6: 0x8515,
                0xE4F7: 0x8514,
                0xE4F8: 0x84FC,
                0xE4F9: 0x8540,
                0xE4FA: 0x8563,
                0xE4FB: 0x8558,
                0xE4FC: 0x8548,
                0xE540: 0x8541,
                0xE541: 0x8602,
                0xE542: 0x854B,
                0xE543: 0x8555,
                0xE544: 0x8580,
                0xE545: 0x85A4,
                0xE546: 0x8588,
                0xE547: 0x8591,
                0xE548: 0x858A,
                0xE549: 0x85A8,
                0xE54A: 0x856D,
                0xE54B: 0x8594,
                0xE54C: 0x859B,
                0xE54D: 0x85EA,
                0xE54E: 0x8587,
                0xE54F: 0x859C,
                0xE550: 0x8577,
                0xE551: 0x857E,
                0xE552: 0x8590,
                0xE553: 0x85C9,
                0xE554: 0x85BA,
                0xE555: 0x85CF,
                0xE556: 0x85B9,
                0xE557: 0x85D0,
                0xE558: 0x85D5,
                0xE559: 0x85DD,
                0xE55A: 0x85E5,
                0xE55B: 0x85DC,
                0xE55C: 0x85F9,
                0xE55D: 0x860A,
                0xE55E: 0x8613,
                0xE55F: 0x860B,
                0xE560: 0x85FE,
                0xE561: 0x85FA,
                0xE562: 0x8606,
                0xE563: 0x8622,
                0xE564: 0x861A,
                0xE565: 0x8630,
                0xE566: 0x863F,
                0xE567: 0x864D,
                0xE568: 0x4E55,
                0xE569: 0x8654,
                0xE56A: 0x865F,
                0xE56B: 0x8667,
                0xE56C: 0x8671,
                0xE56D: 0x8693,
                0xE56E: 0x86A3,
                0xE56F: 0x86A9,
                0xE570: 0x86AA,
                0xE571: 0x868B,
                0xE572: 0x868C,
                0xE573: 0x86B6,
                0xE574: 0x86AF,
                0xE575: 0x86C4,
                0xE576: 0x86C6,
                0xE577: 0x86B0,
                0xE578: 0x86C9,
                0xE579: 0x8823,
                0xE57A: 0x86AB,
                0xE57B: 0x86D4,
                0xE57C: 0x86DE,
                0xE57D: 0x86E9,
                0xE57E: 0x86EC,
                0xE580: 0x86DF,
                0xE581: 0x86DB,
                0xE582: 0x86EF,
                0xE583: 0x8712,
                0xE584: 0x8706,
                0xE585: 0x8708,
                0xE586: 0x8700,
                0xE587: 0x8703,
                0xE588: 0x86FB,
                0xE589: 0x8711,
                0xE58A: 0x8709,
                0xE58B: 0x870D,
                0xE58C: 0x86F9,
                0xE58D: 0x870A,
                0xE58E: 0x8734,
                0xE58F: 0x873F,
                0xE590: 0x8737,
                0xE591: 0x873B,
                0xE592: 0x8725,
                0xE593: 0x8729,
                0xE594: 0x871A,
                0xE595: 0x8760,
                0xE596: 0x875F,
                0xE597: 0x8778,
                0xE598: 0x874C,
                0xE599: 0x874E,
                0xE59A: 0x8774,
                0xE59B: 0x8757,
                0xE59C: 0x8768,
                0xE59D: 0x876E,
                0xE59E: 0x8759,
                0xE59F: 0x8753,
                0xE5A0: 0x8763,
                0xE5A1: 0x876A,
                0xE5A2: 0x8805,
                0xE5A3: 0x87A2,
                0xE5A4: 0x879F,
                0xE5A5: 0x8782,
                0xE5A6: 0x87AF,
                0xE5A7: 0x87CB,
                0xE5A8: 0x87BD,
                0xE5A9: 0x87C0,
                0xE5AA: 0x87D0,
                0xE5AB: 0x96D6,
                0xE5AC: 0x87AB,
                0xE5AD: 0x87C4,
                0xE5AE: 0x87B3,
                0xE5AF: 0x87C7,
                0xE5B0: 0x87C6,
                0xE5B1: 0x87BB,
                0xE5B2: 0x87EF,
                0xE5B3: 0x87F2,
                0xE5B4: 0x87E0,
                0xE5B5: 0x880F,
                0xE5B6: 0x880D,
                0xE5B7: 0x87FE,
                0xE5B8: 0x87F6,
                0xE5B9: 0x87F7,
                0xE5BA: 0x880E,
                0xE5BB: 0x87D2,
                0xE5BC: 0x8811,
                0xE5BD: 0x8816,
                0xE5BE: 0x8815,
                0xE5BF: 0x8822,
                0xE5C0: 0x8821,
                0xE5C1: 0x8831,
                0xE5C2: 0x8836,
                0xE5C3: 0x8839,
                0xE5C4: 0x8827,
                0xE5C5: 0x883B,
                0xE5C6: 0x8844,
                0xE5C7: 0x8842,
                0xE5C8: 0x8852,
                0xE5C9: 0x8859,
                0xE5CA: 0x885E,
                0xE5CB: 0x8862,
                0xE5CC: 0x886B,
                0xE5CD: 0x8881,
                0xE5CE: 0x887E,
                0xE5CF: 0x889E,
                0xE5D0: 0x8875,
                0xE5D1: 0x887D,
                0xE5D2: 0x88B5,
                0xE5D3: 0x8872,
                0xE5D4: 0x8882,
                0xE5D5: 0x8897,
                0xE5D6: 0x8892,
                0xE5D7: 0x88AE,
                0xE5D8: 0x8899,
                0xE5D9: 0x88A2,
                0xE5DA: 0x888D,
                0xE5DB: 0x88A4,
                0xE5DC: 0x88B0,
                0xE5DD: 0x88BF,
                0xE5DE: 0x88B1,
                0xE5DF: 0x88C3,
                0xE5E0: 0x88C4,
                0xE5E1: 0x88D4,
                0xE5E2: 0x88D8,
                0xE5E3: 0x88D9,
                0xE5E4: 0x88DD,
                0xE5E5: 0x88F9,
                0xE5E6: 0x8902,
                0xE5E7: 0x88FC,
                0xE5E8: 0x88F4,
                0xE5E9: 0x88E8,
                0xE5EA: 0x88F2,
                0xE5EB: 0x8904,
                0xE5EC: 0x890C,
                0xE5ED: 0x890A,
                0xE5EE: 0x8913,
                0xE5EF: 0x8943,
                0xE5F0: 0x891E,
                0xE5F1: 0x8925,
                0xE5F2: 0x892A,
                0xE5F3: 0x892B,
                0xE5F4: 0x8941,
                0xE5F5: 0x8944,
                0xE5F6: 0x893B,
                0xE5F7: 0x8936,
                0xE5F8: 0x8938,
                0xE5F9: 0x894C,
                0xE5FA: 0x891D,
                0xE5FB: 0x8960,
                0xE5FC: 0x895E,
                0xE640: 0x8966,
                0xE641: 0x8964,
                0xE642: 0x896D,
                0xE643: 0x896A,
                0xE644: 0x896F,
                0xE645: 0x8974,
                0xE646: 0x8977,
                0xE647: 0x897E,
                0xE648: 0x8983,
                0xE649: 0x8988,
                0xE64A: 0x898A,
                0xE64B: 0x8993,
                0xE64C: 0x8998,
                0xE64D: 0x89A1,
                0xE64E: 0x89A9,
                0xE64F: 0x89A6,
                0xE650: 0x89AC,
                0xE651: 0x89AF,
                0xE652: 0x89B2,
                0xE653: 0x89BA,
                0xE654: 0x89BD,
                0xE655: 0x89BF,
                0xE656: 0x89C0,
                0xE657: 0x89DA,
                0xE658: 0x89DC,
                0xE659: 0x89DD,
                0xE65A: 0x89E7,
                0xE65B: 0x89F4,
                0xE65C: 0x89F8,
                0xE65D: 0x8A03,
                0xE65E: 0x8A16,
                0xE65F: 0x8A10,
                0xE660: 0x8A0C,
                0xE661: 0x8A1B,
                0xE662: 0x8A1D,
                0xE663: 0x8A25,
                0xE664: 0x8A36,
                0xE665: 0x8A41,
                0xE666: 0x8A5B,
                0xE667: 0x8A52,
                0xE668: 0x8A46,
                0xE669: 0x8A48,
                0xE66A: 0x8A7C,
                0xE66B: 0x8A6D,
                0xE66C: 0x8A6C,
                0xE66D: 0x8A62,
                0xE66E: 0x8A85,
                0xE66F: 0x8A82,
                0xE670: 0x8A84,
                0xE671: 0x8AA8,
                0xE672: 0x8AA1,
                0xE673: 0x8A91,
                0xE674: 0x8AA5,
                0xE675: 0x8AA6,
                0xE676: 0x8A9A,
                0xE677: 0x8AA3,
                0xE678: 0x8AC4,
                0xE679: 0x8ACD,
                0xE67A: 0x8AC2,
                0xE67B: 0x8ADA,
                0xE67C: 0x8AEB,
                0xE67D: 0x8AF3,
                0xE67E: 0x8AE7,
                0xE680: 0x8AE4,
                0xE681: 0x8AF1,
                0xE682: 0x8B14,
                0xE683: 0x8AE0,
                0xE684: 0x8AE2,
                0xE685: 0x8AF7,
                0xE686: 0x8ADE,
                0xE687: 0x8ADB,
                0xE688: 0x8B0C,
                0xE689: 0x8B07,
                0xE68A: 0x8B1A,
                0xE68B: 0x8AE1,
                0xE68C: 0x8B16,
                0xE68D: 0x8B10,
                0xE68E: 0x8B17,
                0xE68F: 0x8B20,
                0xE690: 0x8B33,
                0xE691: 0x97AB,
                0xE692: 0x8B26,
                0xE693: 0x8B2B,
                0xE694: 0x8B3E,
                0xE695: 0x8B28,
                0xE696: 0x8B41,
                0xE697: 0x8B4C,
                0xE698: 0x8B4F,
                0xE699: 0x8B4E,
                0xE69A: 0x8B49,
                0xE69B: 0x8B56,
                0xE69C: 0x8B5B,
                0xE69D: 0x8B5A,
                0xE69E: 0x8B6B,
                0xE69F: 0x8B5F,
                0xE6A0: 0x8B6C,
                0xE6A1: 0x8B6F,
                0xE6A2: 0x8B74,
                0xE6A3: 0x8B7D,
                0xE6A4: 0x8B80,
                0xE6A5: 0x8B8C,
                0xE6A6: 0x8B8E,
                0xE6A7: 0x8B92,
                0xE6A8: 0x8B93,
                0xE6A9: 0x8B96,
                0xE6AA: 0x8B99,
                0xE6AB: 0x8B9A,
                0xE6AC: 0x8C3A,
                0xE6AD: 0x8C41,
                0xE6AE: 0x8C3F,
                0xE6AF: 0x8C48,
                0xE6B0: 0x8C4C,
                0xE6B1: 0x8C4E,
                0xE6B2: 0x8C50,
                0xE6B3: 0x8C55,
                0xE6B4: 0x8C62,
                0xE6B5: 0x8C6C,
                0xE6B6: 0x8C78,
                0xE6B7: 0x8C7A,
                0xE6B8: 0x8C82,
                0xE6B9: 0x8C89,
                0xE6BA: 0x8C85,
                0xE6BB: 0x8C8A,
                0xE6BC: 0x8C8D,
                0xE6BD: 0x8C8E,
                0xE6BE: 0x8C94,
                0xE6BF: 0x8C7C,
                0xE6C0: 0x8C98,
                0xE6C1: 0x621D,
                0xE6C2: 0x8CAD,
                0xE6C3: 0x8CAA,
                0xE6C4: 0x8CBD,
                0xE6C5: 0x8CB2,
                0xE6C6: 0x8CB3,
                0xE6C7: 0x8CAE,
                0xE6C8: 0x8CB6,
                0xE6C9: 0x8CC8,
                0xE6CA: 0x8CC1,
                0xE6CB: 0x8CE4,
                0xE6CC: 0x8CE3,
                0xE6CD: 0x8CDA,
                0xE6CE: 0x8CFD,
                0xE6CF: 0x8CFA,
                0xE6D0: 0x8CFB,
                0xE6D1: 0x8D04,
                0xE6D2: 0x8D05,
                0xE6D3: 0x8D0A,
                0xE6D4: 0x8D07,
                0xE6D5: 0x8D0F,
                0xE6D6: 0x8D0D,
                0xE6D7: 0x8D10,
                0xE6D8: 0x9F4E,
                0xE6D9: 0x8D13,
                0xE6DA: 0x8CCD,
                0xE6DB: 0x8D14,
                0xE6DC: 0x8D16,
                0xE6DD: 0x8D67,
                0xE6DE: 0x8D6D,
                0xE6DF: 0x8D71,
                0xE6E0: 0x8D73,
                0xE6E1: 0x8D81,
                0xE6E2: 0x8D99,
                0xE6E3: 0x8DC2,
                0xE6E4: 0x8DBE,
                0xE6E5: 0x8DBA,
                0xE6E6: 0x8DCF,
                0xE6E7: 0x8DDA,
                0xE6E8: 0x8DD6,
                0xE6E9: 0x8DCC,
                0xE6EA: 0x8DDB,
                0xE6EB: 0x8DCB,
                0xE6EC: 0x8DEA,
                0xE6ED: 0x8DEB,
                0xE6EE: 0x8DDF,
                0xE6EF: 0x8DE3,
                0xE6F0: 0x8DFC,
                0xE6F1: 0x8E08,
                0xE6F2: 0x8E09,
                0xE6F3: 0x8DFF,
                0xE6F4: 0x8E1D,
                0xE6F5: 0x8E1E,
                0xE6F6: 0x8E10,
                0xE6F7: 0x8E1F,
                0xE6F8: 0x8E42,
                0xE6F9: 0x8E35,
                0xE6FA: 0x8E30,
                0xE6FB: 0x8E34,
                0xE6FC: 0x8E4A,
                0xE740: 0x8E47,
                0xE741: 0x8E49,
                0xE742: 0x8E4C,
                0xE743: 0x8E50,
                0xE744: 0x8E48,
                0xE745: 0x8E59,
                0xE746: 0x8E64,
                0xE747: 0x8E60,
                0xE748: 0x8E2A,
                0xE749: 0x8E63,
                0xE74A: 0x8E55,
                0xE74B: 0x8E76,
                0xE74C: 0x8E72,
                0xE74D: 0x8E7C,
                0xE74E: 0x8E81,
                0xE74F: 0x8E87,
                0xE750: 0x8E85,
                0xE751: 0x8E84,
                0xE752: 0x8E8B,
                0xE753: 0x8E8A,
                0xE754: 0x8E93,
                0xE755: 0x8E91,
                0xE756: 0x8E94,
                0xE757: 0x8E99,
                0xE758: 0x8EAA,
                0xE759: 0x8EA1,
                0xE75A: 0x8EAC,
                0xE75B: 0x8EB0,
                0xE75C: 0x8EC6,
                0xE75D: 0x8EB1,
                0xE75E: 0x8EBE,
                0xE75F: 0x8EC5,
                0xE760: 0x8EC8,
                0xE761: 0x8ECB,
                0xE762: 0x8EDB,
                0xE763: 0x8EE3,
                0xE764: 0x8EFC,
                0xE765: 0x8EFB,
                0xE766: 0x8EEB,
                0xE767: 0x8EFE,
                0xE768: 0x8F0A,
                0xE769: 0x8F05,
                0xE76A: 0x8F15,
                0xE76B: 0x8F12,
                0xE76C: 0x8F19,
                0xE76D: 0x8F13,
                0xE76E: 0x8F1C,
                0xE76F: 0x8F1F,
                0xE770: 0x8F1B,
                0xE771: 0x8F0C,
                0xE772: 0x8F26,
                0xE773: 0x8F33,
                0xE774: 0x8F3B,
                0xE775: 0x8F39,
                0xE776: 0x8F45,
                0xE777: 0x8F42,
                0xE778: 0x8F3E,
                0xE779: 0x8F4C,
                0xE77A: 0x8F49,
                0xE77B: 0x8F46,
                0xE77C: 0x8F4E,
                0xE77D: 0x8F57,
                0xE77E: 0x8F5C,
                0xE780: 0x8F62,
                0xE781: 0x8F63,
                0xE782: 0x8F64,
                0xE783: 0x8F9C,
                0xE784: 0x8F9F,
                0xE785: 0x8FA3,
                0xE786: 0x8FAD,
                0xE787: 0x8FAF,
                0xE788: 0x8FB7,
                0xE789: 0x8FDA,
                0xE78A: 0x8FE5,
                0xE78B: 0x8FE2,
                0xE78C: 0x8FEA,
                0xE78D: 0x8FEF,
                0xE78E: 0x9087,
                0xE78F: 0x8FF4,
                0xE790: 0x9005,
                0xE791: 0x8FF9,
                0xE792: 0x8FFA,
                0xE793: 0x9011,
                0xE794: 0x9015,
                0xE795: 0x9021,
                0xE796: 0x900D,
                0xE797: 0x901E,
                0xE798: 0x9016,
                0xE799: 0x900B,
                0xE79A: 0x9027,
                0xE79B: 0x9036,
                0xE79C: 0x9035,
                0xE79D: 0x9039,
                0xE79E: 0x8FF8,
                0xE79F: 0x904F,
                0xE7A0: 0x9050,
                0xE7A1: 0x9051,
                0xE7A2: 0x9052,
                0xE7A3: 0x900E,
                0xE7A4: 0x9049,
                0xE7A5: 0x903E,
                0xE7A6: 0x9056,
                0xE7A7: 0x9058,
                0xE7A8: 0x905E,
                0xE7A9: 0x9068,
                0xE7AA: 0x906F,
                0xE7AB: 0x9076,
                0xE7AC: 0x96A8,
                0xE7AD: 0x9072,
                0xE7AE: 0x9082,
                0xE7AF: 0x907D,
                0xE7B0: 0x9081,
                0xE7B1: 0x9080,
                0xE7B2: 0x908A,
                0xE7B3: 0x9089,
                0xE7B4: 0x908F,
                0xE7B5: 0x90A8,
                0xE7B6: 0x90AF,
                0xE7B7: 0x90B1,
                0xE7B8: 0x90B5,
                0xE7B9: 0x90E2,
                0xE7BA: 0x90E4,
                0xE7BB: 0x6248,
                0xE7BC: 0x90DB,
                0xE7BD: 0x9102,
                0xE7BE: 0x9112,
                0xE7BF: 0x9119,
                0xE7C0: 0x9132,
                0xE7C1: 0x9130,
                0xE7C2: 0x914A,
                0xE7C3: 0x9156,
                0xE7C4: 0x9158,
                0xE7C5: 0x9163,
                0xE7C6: 0x9165,
                0xE7C7: 0x9169,
                0xE7C8: 0x9173,
                0xE7C9: 0x9172,
                0xE7CA: 0x918B,
                0xE7CB: 0x9189,
                0xE7CC: 0x9182,
                0xE7CD: 0x91A2,
                0xE7CE: 0x91AB,
                0xE7CF: 0x91AF,
                0xE7D0: 0x91AA,
                0xE7D1: 0x91B5,
                0xE7D2: 0x91B4,
                0xE7D3: 0x91BA,
                0xE7D4: 0x91C0,
                0xE7D5: 0x91C1,
                0xE7D6: 0x91C9,
                0xE7D7: 0x91CB,
                0xE7D8: 0x91D0,
                0xE7D9: 0x91D6,
                0xE7DA: 0x91DF,
                0xE7DB: 0x91E1,
                0xE7DC: 0x91DB,
                0xE7DD: 0x91FC,
                0xE7DE: 0x91F5,
                0xE7DF: 0x91F6,
                0xE7E0: 0x921E,
                0xE7E1: 0x91FF,
                0xE7E2: 0x9214,
                0xE7E3: 0x922C,
                0xE7E4: 0x9215,
                0xE7E5: 0x9211,
                0xE7E6: 0x925E,
                0xE7E7: 0x9257,
                0xE7E8: 0x9245,
                0xE7E9: 0x9249,
                0xE7EA: 0x9264,
                0xE7EB: 0x9248,
                0xE7EC: 0x9295,
                0xE7ED: 0x923F,
                0xE7EE: 0x924B,
                0xE7EF: 0x9250,
                0xE7F0: 0x929C,
                0xE7F1: 0x9296,
                0xE7F2: 0x9293,
                0xE7F3: 0x929B,
                0xE7F4: 0x925A,
                0xE7F5: 0x92CF,
                0xE7F6: 0x92B9,
                0xE7F7: 0x92B7,
                0xE7F8: 0x92E9,
                0xE7F9: 0x930F,
                0xE7FA: 0x92FA,
                0xE7FB: 0x9344,
                0xE7FC: 0x932E,
                0xE840: 0x9319,
                0xE841: 0x9322,
                0xE842: 0x931A,
                0xE843: 0x9323,
                0xE844: 0x933A,
                0xE845: 0x9335,
                0xE846: 0x933B,
                0xE847: 0x935C,
                0xE848: 0x9360,
                0xE849: 0x937C,
                0xE84A: 0x936E,
                0xE84B: 0x9356,
                0xE84C: 0x93B0,
                0xE84D: 0x93AC,
                0xE84E: 0x93AD,
                0xE84F: 0x9394,
                0xE850: 0x93B9,
                0xE851: 0x93D6,
                0xE852: 0x93D7,
                0xE853: 0x93E8,
                0xE854: 0x93E5,
                0xE855: 0x93D8,
                0xE856: 0x93C3,
                0xE857: 0x93DD,
                0xE858: 0x93D0,
                0xE859: 0x93C8,
                0xE85A: 0x93E4,
                0xE85B: 0x941A,
                0xE85C: 0x9414,
                0xE85D: 0x9413,
                0xE85E: 0x9403,
                0xE85F: 0x9407,
                0xE860: 0x9410,
                0xE861: 0x9436,
                0xE862: 0x942B,
                0xE863: 0x9435,
                0xE864: 0x9421,
                0xE865: 0x943A,
                0xE866: 0x9441,
                0xE867: 0x9452,
                0xE868: 0x9444,
                0xE869: 0x945B,
                0xE86A: 0x9460,
                0xE86B: 0x9462,
                0xE86C: 0x945E,
                0xE86D: 0x946A,
                0xE86E: 0x9229,
                0xE86F: 0x9470,
                0xE870: 0x9475,
                0xE871: 0x9477,
                0xE872: 0x947D,
                0xE873: 0x945A,
                0xE874: 0x947C,
                0xE875: 0x947E,
                0xE876: 0x9481,
                0xE877: 0x947F,
                0xE878: 0x9582,
                0xE879: 0x9587,
                0xE87A: 0x958A,
                0xE87B: 0x9594,
                0xE87C: 0x9596,
                0xE87D: 0x9598,
                0xE87E: 0x9599,
                0xE880: 0x95A0,
                0xE881: 0x95A8,
                0xE882: 0x95A7,
                0xE883: 0x95AD,
                0xE884: 0x95BC,
                0xE885: 0x95BB,
                0xE886: 0x95B9,
                0xE887: 0x95BE,
                0xE888: 0x95CA,
                0xE889: 0x6FF6,
                0xE88A: 0x95C3,
                0xE88B: 0x95CD,
                0xE88C: 0x95CC,
                0xE88D: 0x95D5,
                0xE88E: 0x95D4,
                0xE88F: 0x95D6,
                0xE890: 0x95DC,
                0xE891: 0x95E1,
                0xE892: 0x95E5,
                0xE893: 0x95E2,
                0xE894: 0x9621,
                0xE895: 0x9628,
                0xE896: 0x962E,
                0xE897: 0x962F,
                0xE898: 0x9642,
                0xE899: 0x964C,
                0xE89A: 0x964F,
                0xE89B: 0x964B,
                0xE89C: 0x9677,
                0xE89D: 0x965C,
                0xE89E: 0x965E,
                0xE89F: 0x965D,
                0xE8A0: 0x965F,
                0xE8A1: 0x9666,
                0xE8A2: 0x9672,
                0xE8A3: 0x966C,
                0xE8A4: 0x968D,
                0xE8A5: 0x9698,
                0xE8A6: 0x9695,
                0xE8A7: 0x9697,
                0xE8A8: 0x96AA,
                0xE8A9: 0x96A7,
                0xE8AA: 0x96B1,
                0xE8AB: 0x96B2,
                0xE8AC: 0x96B0,
                0xE8AD: 0x96B4,
                0xE8AE: 0x96B6,
                0xE8AF: 0x96B8,
                0xE8B0: 0x96B9,
                0xE8B1: 0x96CE,
                0xE8B2: 0x96CB,
                0xE8B3: 0x96C9,
                0xE8B4: 0x96CD,
                0xE8B5: 0x894D,
                0xE8B6: 0x96DC,
                0xE8B7: 0x970D,
                0xE8B8: 0x96D5,
                0xE8B9: 0x96F9,
                0xE8BA: 0x9704,
                0xE8BB: 0x9706,
                0xE8BC: 0x9708,
                0xE8BD: 0x9713,
                0xE8BE: 0x970E,
                0xE8BF: 0x9711,
                0xE8C0: 0x970F,
                0xE8C1: 0x9716,
                0xE8C2: 0x9719,
                0xE8C3: 0x9724,
                0xE8C4: 0x972A,
                0xE8C5: 0x9730,
                0xE8C6: 0x9739,
                0xE8C7: 0x973D,
                0xE8C8: 0x973E,
                0xE8C9: 0x9744,
                0xE8CA: 0x9746,
                0xE8CB: 0x9748,
                0xE8CC: 0x9742,
                0xE8CD: 0x9749,
                0xE8CE: 0x975C,
                0xE8CF: 0x9760,
                0xE8D0: 0x9764,
                0xE8D1: 0x9766,
                0xE8D2: 0x9768,
                0xE8D3: 0x52D2,
                0xE8D4: 0x976B,
                0xE8D5: 0x9771,
                0xE8D6: 0x9779,
                0xE8D7: 0x9785,
                0xE8D8: 0x977C,
                0xE8D9: 0x9781,
                0xE8DA: 0x977A,
                0xE8DB: 0x9786,
                0xE8DC: 0x978B,
                0xE8DD: 0x978F,
                0xE8DE: 0x9790,
                0xE8DF: 0x979C,
                0xE8E0: 0x97A8,
                0xE8E1: 0x97A6,
                0xE8E2: 0x97A3,
                0xE8E3: 0x97B3,
                0xE8E4: 0x97B4,
                0xE8E5: 0x97C3,
                0xE8E6: 0x97C6,
                0xE8E7: 0x97C8,
                0xE8E8: 0x97CB,
                0xE8E9: 0x97DC,
                0xE8EA: 0x97ED,
                0xE8EB: 0x9F4F,
                0xE8EC: 0x97F2,
                0xE8ED: 0x7ADF,
                0xE8EE: 0x97F6,
                0xE8EF: 0x97F5,
                0xE8F0: 0x980F,
                0xE8F1: 0x980C,
                0xE8F2: 0x9838,
                0xE8F3: 0x9824,
                0xE8F4: 0x9821,
                0xE8F5: 0x9837,
                0xE8F6: 0x983D,
                0xE8F7: 0x9846,
                0xE8F8: 0x984F,
                0xE8F9: 0x984B,
                0xE8FA: 0x986B,
                0xE8FB: 0x986F,
                0xE8FC: 0x9870,
                0xE940: 0x9871,
                0xE941: 0x9874,
                0xE942: 0x9873,
                0xE943: 0x98AA,
                0xE944: 0x98AF,
                0xE945: 0x98B1,
                0xE946: 0x98B6,
                0xE947: 0x98C4,
                0xE948: 0x98C3,
                0xE949: 0x98C6,
                0xE94A: 0x98E9,
                0xE94B: 0x98EB,
                0xE94C: 0x9903,
                0xE94D: 0x9909,
                0xE94E: 0x9912,
                0xE94F: 0x9914,
                0xE950: 0x9918,
                0xE951: 0x9921,
                0xE952: 0x991D,
                0xE953: 0x991E,
                0xE954: 0x9924,
                0xE955: 0x9920,
                0xE956: 0x992C,
                0xE957: 0x992E,
                0xE958: 0x993D,
                0xE959: 0x993E,
                0xE95A: 0x9942,
                0xE95B: 0x9949,
                0xE95C: 0x9945,
                0xE95D: 0x9950,
                0xE95E: 0x994B,
                0xE95F: 0x9951,
                0xE960: 0x9952,
                0xE961: 0x994C,
                0xE962: 0x9955,
                0xE963: 0x9997,
                0xE964: 0x9998,
                0xE965: 0x99A5,
                0xE966: 0x99AD,
                0xE967: 0x99AE,
                0xE968: 0x99BC,
                0xE969: 0x99DF,
                0xE96A: 0x99DB,
                0xE96B: 0x99DD,
                0xE96C: 0x99D8,
                0xE96D: 0x99D1,
                0xE96E: 0x99ED,
                0xE96F: 0x99EE,
                0xE970: 0x99F1,
                0xE971: 0x99F2,
                0xE972: 0x99FB,
                0xE973: 0x99F8,
                0xE974: 0x9A01,
                0xE975: 0x9A0F,
                0xE976: 0x9A05,
                0xE977: 0x99E2,
                0xE978: 0x9A19,
                0xE979: 0x9A2B,
                0xE97A: 0x9A37,
                0xE97B: 0x9A45,
                0xE97C: 0x9A42,
                0xE97D: 0x9A40,
                0xE97E: 0x9A43,
                0xE980: 0x9A3E,
                0xE981: 0x9A55,
                0xE982: 0x9A4D,
                0xE983: 0x9A5B,
                0xE984: 0x9A57,
                0xE985: 0x9A5F,
                0xE986: 0x9A62,
                0xE987: 0x9A65,
                0xE988: 0x9A64,
                0xE989: 0x9A69,
                0xE98A: 0x9A6B,
                0xE98B: 0x9A6A,
                0xE98C: 0x9AAD,
                0xE98D: 0x9AB0,
                0xE98E: 0x9ABC,
                0xE98F: 0x9AC0,
                0xE990: 0x9ACF,
                0xE991: 0x9AD1,
                0xE992: 0x9AD3,
                0xE993: 0x9AD4,
                0xE994: 0x9ADE,
                0xE995: 0x9ADF,
                0xE996: 0x9AE2,
                0xE997: 0x9AE3,
                0xE998: 0x9AE6,
                0xE999: 0x9AEF,
                0xE99A: 0x9AEB,
                0xE99B: 0x9AEE,
                0xE99C: 0x9AF4,
                0xE99D: 0x9AF1,
                0xE99E: 0x9AF7,
                0xE99F: 0x9AFB,
                0xE9A0: 0x9B06,
                0xE9A1: 0x9B18,
                0xE9A2: 0x9B1A,
                0xE9A3: 0x9B1F,
                0xE9A4: 0x9B22,
                0xE9A5: 0x9B23,
                0xE9A6: 0x9B25,
                0xE9A7: 0x9B27,
                0xE9A8: 0x9B28,
                0xE9A9: 0x9B29,
                0xE9AA: 0x9B2A,
                0xE9AB: 0x9B2E,
                0xE9AC: 0x9B2F,
                0xE9AD: 0x9B32,
                0xE9AE: 0x9B44,
                0xE9AF: 0x9B43,
                0xE9B0: 0x9B4F,
                0xE9B1: 0x9B4D,
                0xE9B2: 0x9B4E,
                0xE9B3: 0x9B51,
                0xE9B4: 0x9B58,
                0xE9B5: 0x9B74,
                0xE9B6: 0x9B93,
                0xE9B7: 0x9B83,
                0xE9B8: 0x9B91,
                0xE9B9: 0x9B96,
                0xE9BA: 0x9B97,
                0xE9BB: 0x9B9F,
                0xE9BC: 0x9BA0,
                0xE9BD: 0x9BA8,
                0xE9BE: 0x9BB4,
                0xE9BF: 0x9BC0,
                0xE9C0: 0x9BCA,
                0xE9C1: 0x9BB9,
                0xE9C2: 0x9BC6,
                0xE9C3: 0x9BCF,
                0xE9C4: 0x9BD1,
                0xE9C5: 0x9BD2,
                0xE9C6: 0x9BE3,
                0xE9C7: 0x9BE2,
                0xE9C8: 0x9BE4,
                0xE9C9: 0x9BD4,
                0xE9CA: 0x9BE1,
                0xE9CB: 0x9C3A,
                0xE9CC: 0x9BF2,
                0xE9CD: 0x9BF1,
                0xE9CE: 0x9BF0,
                0xE9CF: 0x9C15,
                0xE9D0: 0x9C14,
                0xE9D1: 0x9C09,
                0xE9D2: 0x9C13,
                0xE9D3: 0x9C0C,
                0xE9D4: 0x9C06,
                0xE9D5: 0x9C08,
                0xE9D6: 0x9C12,
                0xE9D7: 0x9C0A,
                0xE9D8: 0x9C04,
                0xE9D9: 0x9C2E,
                0xE9DA: 0x9C1B,
                0xE9DB: 0x9C25,
                0xE9DC: 0x9C24,
                0xE9DD: 0x9C21,
                0xE9DE: 0x9C30,
                0xE9DF: 0x9C47,
                0xE9E0: 0x9C32,
                0xE9E1: 0x9C46,
                0xE9E2: 0x9C3E,
                0xE9E3: 0x9C5A,
                0xE9E4: 0x9C60,
                0xE9E5: 0x9C67,
                0xE9E6: 0x9C76,
                0xE9E7: 0x9C78,
                0xE9E8: 0x9CE7,
                0xE9E9: 0x9CEC,
                0xE9EA: 0x9CF0,
                0xE9EB: 0x9D09,
                0xE9EC: 0x9D08,
                0xE9ED: 0x9CEB,
                0xE9EE: 0x9D03,
                0xE9EF: 0x9D06,
                0xE9F0: 0x9D2A,
                0xE9F1: 0x9D26,
                0xE9F2: 0x9DAF,
                0xE9F3: 0x9D23,
                0xE9F4: 0x9D1F,
                0xE9F5: 0x9D44,
                0xE9F6: 0x9D15,
                0xE9F7: 0x9D12,
                0xE9F8: 0x9D41,
                0xE9F9: 0x9D3F,
                0xE9FA: 0x9D3E,
                0xE9FB: 0x9D46,
                0xE9FC: 0x9D48,
                0xEA40: 0x9D5D,
                0xEA41: 0x9D5E,
                0xEA42: 0x9D64,
                0xEA43: 0x9D51,
                0xEA44: 0x9D50,
                0xEA45: 0x9D59,
                0xEA46: 0x9D72,
                0xEA47: 0x9D89,
                0xEA48: 0x9D87,
                0xEA49: 0x9DAB,
                0xEA4A: 0x9D6F,
                0xEA4B: 0x9D7A,
                0xEA4C: 0x9D9A,
                0xEA4D: 0x9DA4,
                0xEA4E: 0x9DA9,
                0xEA4F: 0x9DB2,
                0xEA50: 0x9DC4,
                0xEA51: 0x9DC1,
                0xEA52: 0x9DBB,
                0xEA53: 0x9DB8,
                0xEA54: 0x9DBA,
                0xEA55: 0x9DC6,
                0xEA56: 0x9DCF,
                0xEA57: 0x9DC2,
                0xEA58: 0x9DD9,
                0xEA59: 0x9DD3,
                0xEA5A: 0x9DF8,
                0xEA5B: 0x9DE6,
                0xEA5C: 0x9DED,
                0xEA5D: 0x9DEF,
                0xEA5E: 0x9DFD,
                0xEA5F: 0x9E1A,
                0xEA60: 0x9E1B,
                0xEA61: 0x9E1E,
                0xEA62: 0x9E75,
                0xEA63: 0x9E79,
                0xEA64: 0x9E7D,
                0xEA65: 0x9E81,
                0xEA66: 0x9E88,
                0xEA67: 0x9E8B,
                0xEA68: 0x9E8C,
                0xEA69: 0x9E92,
                0xEA6A: 0x9E95,
                0xEA6B: 0x9E91,
                0xEA6C: 0x9E9D,
                0xEA6D: 0x9EA5,
                0xEA6E: 0x9EA9,
                0xEA6F: 0x9EB8,
                0xEA70: 0x9EAA,
                0xEA71: 0x9EAD,
                0xEA72: 0x9761,
                0xEA73: 0x9ECC,
                0xEA74: 0x9ECE,
                0xEA75: 0x9ECF,
                0xEA76: 0x9ED0,
                0xEA77: 0x9ED4,
                0xEA78: 0x9EDC,
                0xEA79: 0x9EDE,
                0xEA7A: 0x9EDD,
                0xEA7B: 0x9EE0,
                0xEA7C: 0x9EE5,
                0xEA7D: 0x9EE8,
                0xEA7E: 0x9EEF,
                0xEA80: 0x9EF4,
                0xEA81: 0x9EF6,
                0xEA82: 0x9EF7,
                0xEA83: 0x9EF9,
                0xEA84: 0x9EFB,
                0xEA85: 0x9EFC,
                0xEA86: 0x9EFD,
                0xEA87: 0x9F07,
                0xEA88: 0x9F08,
                0xEA89: 0x76B7,
                0xEA8A: 0x9F15,
                0xEA8B: 0x9F21,
                0xEA8C: 0x9F2C,
                0xEA8D: 0x9F3E,
                0xEA8E: 0x9F4A,
                0xEA8F: 0x9F52,
                0xEA90: 0x9F54,
                0xEA91: 0x9F63,
                0xEA92: 0x9F5F,
                0xEA93: 0x9F60,
                0xEA94: 0x9F61,
                0xEA95: 0x9F66,
                0xEA96: 0x9F67,
                0xEA97: 0x9F6C,
                0xEA98: 0x9F6A,
                0xEA99: 0x9F77,
                0xEA9A: 0x9F72,
                0xEA9B: 0x9F76,
                0xEA9C: 0x9F95,
                0xEA9D: 0x9F9C,
                0xEA9E: 0x9FA0,
                0xEA9F: 0x582F,
                0xEAA0: 0x69C7,
                0xEAA1: 0x9059,
                0xEAA2: 0x7464,
                0xEAA3: 0x51DC,
                0xEAA4: 0x7199
            };
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GenericGF_1 = __webpack_require__(1);
            var GenericGFPoly_1 = __webpack_require__(2);
            function runEuclideanAlgorithm(field, a, b, R) {
                var _a;
                // Assume a's degree is >= b's
                if (a.degree() < b.degree()) _a = [
                    b,
                    a
                ], a = _a[0], b = _a[1];
                var rLast = a;
                var r = b;
                var tLast = field.zero;
                var t = field.one;
                // Run Euclidean algorithm until r's degree is less than R/2
                while(r.degree() >= R / 2){
                    var rLastLast = rLast;
                    var tLastLast = tLast;
                    rLast = r;
                    tLast = t;
                    // Divide rLastLast by rLast, with quotient in q and remainder in r
                    if (rLast.isZero()) // Euclidean algorithm already terminated?
                    return null;
                    r = rLastLast;
                    var q = field.zero;
                    var denominatorLeadingTerm = rLast.getCoefficient(rLast.degree());
                    var dltInverse = field.inverse(denominatorLeadingTerm);
                    while(r.degree() >= rLast.degree() && !r.isZero()){
                        var degreeDiff = r.degree() - rLast.degree();
                        var scale = field.multiply(r.getCoefficient(r.degree()), dltInverse);
                        q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                        r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
                    }
                    t = q.multiplyPoly(tLast).addOrSubtract(tLastLast);
                    if (r.degree() >= rLast.degree()) return null;
                }
                var sigmaTildeAtZero = t.getCoefficient(0);
                if (sigmaTildeAtZero === 0) return null;
                var inverse = field.inverse(sigmaTildeAtZero);
                return [
                    t.multiply(inverse),
                    r.multiply(inverse)
                ];
            }
            function findErrorLocations(field, errorLocator) {
                // This is a direct application of Chien's search
                var numErrors = errorLocator.degree();
                if (numErrors === 1) return [
                    errorLocator.getCoefficient(1)
                ];
                var result = new Array(numErrors);
                var errorCount = 0;
                for(var i = 1; i < field.size && errorCount < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
                    result[errorCount] = field.inverse(i);
                    errorCount++;
                }
                if (errorCount !== numErrors) return null;
                return result;
            }
            function findErrorMagnitudes(field, errorEvaluator, errorLocations) {
                // This is directly applying Forney's Formula
                var s = errorLocations.length;
                var result = new Array(s);
                for(var i = 0; i < s; i++){
                    var xiInverse = field.inverse(errorLocations[i]);
                    var denominator = 1;
                    for(var j = 0; j < s; j++)if (i !== j) denominator = field.multiply(denominator, GenericGF_1.addOrSubtractGF(1, field.multiply(errorLocations[j], xiInverse)));
                    result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
                    if (field.generatorBase !== 0) result[i] = field.multiply(result[i], xiInverse);
                }
                return result;
            }
            function decode(bytes, twoS) {
                var outputBytes = new Uint8ClampedArray(bytes.length);
                outputBytes.set(bytes);
                var field = new GenericGF_1.default(0x011D, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
                var poly = new GenericGFPoly_1.default(field, outputBytes);
                var syndromeCoefficients = new Uint8ClampedArray(twoS);
                var error = false;
                for(var s = 0; s < twoS; s++){
                    var evaluation = poly.evaluateAt(field.exp(s + field.generatorBase));
                    syndromeCoefficients[syndromeCoefficients.length - 1 - s] = evaluation;
                    if (evaluation !== 0) error = true;
                }
                if (!error) return outputBytes;
                var syndrome = new GenericGFPoly_1.default(field, syndromeCoefficients);
                var sigmaOmega = runEuclideanAlgorithm(field, field.buildMonomial(twoS, 1), syndrome, twoS);
                if (sigmaOmega === null) return null;
                var errorLocations = findErrorLocations(field, sigmaOmega[0]);
                if (errorLocations == null) return null;
                var errorMagnitudes = findErrorMagnitudes(field, sigmaOmega[1], errorLocations);
                for(var i = 0; i < errorLocations.length; i++){
                    var position = outputBytes.length - 1 - field.log(errorLocations[i]);
                    if (position < 0) return null;
                    outputBytes[position] = GenericGF_1.addOrSubtractGF(outputBytes[position], errorMagnitudes[i]);
                }
                return outputBytes;
            }
            exports.decode = decode;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.VERSIONS = [
                {
                    infoBits: null,
                    versionNumber: 1,
                    alignmentPatternCenters: [],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 7,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 13,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 17,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 2,
                    alignmentPatternCenters: [
                        6,
                        18
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 10,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 34
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 28
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 3,
                    alignmentPatternCenters: [
                        6,
                        22
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 15,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 55
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 4,
                    alignmentPatternCenters: [
                        6,
                        26
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 80
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 32
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 9
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 5,
                    alignmentPatternCenters: [
                        6,
                        30
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 43
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: null,
                    versionNumber: 6,
                    alignmentPatternCenters: [
                        6,
                        34
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 16,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 27
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x07C94,
                    versionNumber: 7,
                    alignmentPatternCenters: [
                        6,
                        22,
                        38
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 78
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 31
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x085BC,
                    versionNumber: 8,
                    alignmentPatternCenters: [
                        6,
                        24,
                        42
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 97
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 38
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 39
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 18
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 19
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x09A99,
                    versionNumber: 9,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0A4D3,
                    versionNumber: 10,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 18,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 68
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 69
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0BBF6,
                    versionNumber: 11,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 81
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 50
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 51
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0C762,
                    versionNumber: 12,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 92
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 93
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 36
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 37
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0D847,
                    versionNumber: 13,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 37
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 38
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 20
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 21
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 11
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 12
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0E60D,
                    versionNumber: 14,
                    alignmentPatternCenters: [
                        6,
                        26,
                        46,
                        66
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 40
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 20,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x0F928,
                    versionNumber: 15,
                    alignmentPatternCenters: [
                        6,
                        26,
                        48,
                        70
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 22,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 87
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 88
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 12
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x10B78,
                    versionNumber: 16,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 98
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 99
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 19
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 20
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1145D,
                    versionNumber: 17,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x12A17,
                    versionNumber: 18,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 120
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 121
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 43
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 44
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 14
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x13532,
                    versionNumber: 19,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 113
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 114
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 44
                                },
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 45
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 21
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 22
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 9,
                                    dataCodewordsPerBlock: 13
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 14
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x149A6,
                    versionNumber: 20,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 107
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 108
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 41
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x15683,
                    versionNumber: 21,
                    alignmentPatternCenters: [
                        6,
                        28,
                        50,
                        72,
                        94
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 42
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x168C9,
                    versionNumber: 22,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 111
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 112
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 24,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 13
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x177EC,
                    versionNumber: 23,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        74,
                        102
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x18EC4,
                    versionNumber: 24,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 16,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 30,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x191E1,
                    versionNumber: 25,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 26,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 106
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 107
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1AFAB,
                    versionNumber: 26,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 114
                                },
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 22
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 23
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 33,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1B08E,
                    versionNumber: 27,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 8,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1CC1A,
                    versionNumber: 28,
                    alignmentPatternCenters: [
                        6,
                        26,
                        50,
                        74,
                        98,
                        122
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1D33F,
                    versionNumber: 29,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 116
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 117
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 45
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 46
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 23
                                },
                                {
                                    numBlocks: 37,
                                    dataCodewordsPerBlock: 24
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1ED75,
                    versionNumber: 30,
                    alignmentPatternCenters: [
                        6,
                        26,
                        52,
                        78,
                        104,
                        130
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 5,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 15,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 25,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x1F250,
                    versionNumber: 31,
                    alignmentPatternCenters: [
                        6,
                        30,
                        56,
                        82,
                        108,
                        134
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 3,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 28,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x209D5,
                    versionNumber: 32,
                    alignmentPatternCenters: [
                        6,
                        34,
                        60,
                        86,
                        112,
                        138
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 35,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x216F0,
                    versionNumber: 33,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 21,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 11,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x228BA,
                    versionNumber: 34,
                    alignmentPatternCenters: [
                        6,
                        34,
                        62,
                        90,
                        118,
                        146
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 115
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 116
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 23,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 44,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 59,
                                    dataCodewordsPerBlock: 16
                                },
                                {
                                    numBlocks: 1,
                                    dataCodewordsPerBlock: 17
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2379F,
                    versionNumber: 35,
                    alignmentPatternCenters: [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126,
                        150
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 12,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 26,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 39,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 41,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x24B0B,
                    versionNumber: 36,
                    alignmentPatternCenters: [
                        6,
                        24,
                        50,
                        76,
                        102,
                        128,
                        154
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 121
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 122
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 2,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 64,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x2542E,
                    versionNumber: 37,
                    alignmentPatternCenters: [
                        6,
                        28,
                        54,
                        80,
                        106,
                        132,
                        158
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 17,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 29,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 49,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 24,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 46,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x26A64,
                    versionNumber: 38,
                    alignmentPatternCenters: [
                        6,
                        32,
                        58,
                        84,
                        110,
                        136,
                        162
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 122
                                },
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 123
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 13,
                                    dataCodewordsPerBlock: 46
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 47
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 48,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 14,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 42,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 32,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x27541,
                    versionNumber: 39,
                    alignmentPatternCenters: [
                        6,
                        26,
                        54,
                        82,
                        110,
                        138,
                        166
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 117
                                },
                                {
                                    numBlocks: 4,
                                    dataCodewordsPerBlock: 118
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 40,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 7,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 43,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 22,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 10,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 67,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                },
                {
                    infoBits: 0x28C69,
                    versionNumber: 40,
                    alignmentPatternCenters: [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142,
                        170
                    ],
                    errorCorrectionLevels: [
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 19,
                                    dataCodewordsPerBlock: 118
                                },
                                {
                                    numBlocks: 6,
                                    dataCodewordsPerBlock: 119
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 28,
                            ecBlocks: [
                                {
                                    numBlocks: 18,
                                    dataCodewordsPerBlock: 47
                                },
                                {
                                    numBlocks: 31,
                                    dataCodewordsPerBlock: 48
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 24
                                },
                                {
                                    numBlocks: 34,
                                    dataCodewordsPerBlock: 25
                                }
                            ]
                        },
                        {
                            ecCodewordsPerBlock: 30,
                            ecBlocks: [
                                {
                                    numBlocks: 20,
                                    dataCodewordsPerBlock: 15
                                },
                                {
                                    numBlocks: 61,
                                    dataCodewordsPerBlock: 16
                                }
                            ]
                        }
                    ]
                }
            ];
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var BitMatrix_1 = __webpack_require__(0);
            function squareToQuadrilateral(p1, p2, p3, p4) {
                var dx3 = p1.x - p2.x + p3.x - p4.x;
                var dy3 = p1.y - p2.y + p3.y - p4.y;
                if (dx3 === 0 && dy3 === 0) return {
                    a11: p2.x - p1.x,
                    a12: p2.y - p1.y,
                    a13: 0,
                    a21: p3.x - p2.x,
                    a22: p3.y - p2.y,
                    a23: 0,
                    a31: p1.x,
                    a32: p1.y,
                    a33: 1
                };
                else {
                    var dx1 = p2.x - p3.x;
                    var dx2 = p4.x - p3.x;
                    var dy1 = p2.y - p3.y;
                    var dy2 = p4.y - p3.y;
                    var denominator = dx1 * dy2 - dx2 * dy1;
                    var a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
                    var a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
                    return {
                        a11: p2.x - p1.x + a13 * p2.x,
                        a12: p2.y - p1.y + a13 * p2.y,
                        a13: a13,
                        a21: p4.x - p1.x + a23 * p4.x,
                        a22: p4.y - p1.y + a23 * p4.y,
                        a23: a23,
                        a31: p1.x,
                        a32: p1.y,
                        a33: 1
                    };
                }
            }
            function quadrilateralToSquare(p1, p2, p3, p4) {
                // Here, the adjoint serves as the inverse:
                var sToQ = squareToQuadrilateral(p1, p2, p3, p4);
                return {
                    a11: sToQ.a22 * sToQ.a33 - sToQ.a23 * sToQ.a32,
                    a12: sToQ.a13 * sToQ.a32 - sToQ.a12 * sToQ.a33,
                    a13: sToQ.a12 * sToQ.a23 - sToQ.a13 * sToQ.a22,
                    a21: sToQ.a23 * sToQ.a31 - sToQ.a21 * sToQ.a33,
                    a22: sToQ.a11 * sToQ.a33 - sToQ.a13 * sToQ.a31,
                    a23: sToQ.a13 * sToQ.a21 - sToQ.a11 * sToQ.a23,
                    a31: sToQ.a21 * sToQ.a32 - sToQ.a22 * sToQ.a31,
                    a32: sToQ.a12 * sToQ.a31 - sToQ.a11 * sToQ.a32,
                    a33: sToQ.a11 * sToQ.a22 - sToQ.a12 * sToQ.a21
                };
            }
            function times(a, b) {
                return {
                    a11: a.a11 * b.a11 + a.a21 * b.a12 + a.a31 * b.a13,
                    a12: a.a12 * b.a11 + a.a22 * b.a12 + a.a32 * b.a13,
                    a13: a.a13 * b.a11 + a.a23 * b.a12 + a.a33 * b.a13,
                    a21: a.a11 * b.a21 + a.a21 * b.a22 + a.a31 * b.a23,
                    a22: a.a12 * b.a21 + a.a22 * b.a22 + a.a32 * b.a23,
                    a23: a.a13 * b.a21 + a.a23 * b.a22 + a.a33 * b.a23,
                    a31: a.a11 * b.a31 + a.a21 * b.a32 + a.a31 * b.a33,
                    a32: a.a12 * b.a31 + a.a22 * b.a32 + a.a32 * b.a33,
                    a33: a.a13 * b.a31 + a.a23 * b.a32 + a.a33 * b.a33
                };
            }
            function extract(image, location) {
                var qToS = quadrilateralToSquare({
                    x: 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 3.5,
                    y: 3.5
                }, {
                    x: location.dimension - 6.5,
                    y: location.dimension - 6.5
                }, {
                    x: 3.5,
                    y: location.dimension - 3.5
                });
                var sToQ = squareToQuadrilateral(location.topLeft, location.topRight, location.alignmentPattern, location.bottomLeft);
                var transform = times(sToQ, qToS);
                var matrix = BitMatrix_1.BitMatrix.createEmpty(location.dimension, location.dimension);
                var mappingFunction = function(x, y) {
                    var denominator = transform.a13 * x + transform.a23 * y + transform.a33;
                    return {
                        x: (transform.a11 * x + transform.a21 * y + transform.a31) / denominator,
                        y: (transform.a12 * x + transform.a22 * y + transform.a32) / denominator
                    };
                };
                for(var y = 0; y < location.dimension; y++)for(var x = 0; x < location.dimension; x++){
                    var xValue = x + 0.5;
                    var yValue = y + 0.5;
                    var sourcePixel = mappingFunction(xValue, yValue);
                    matrix.set(x, y, image.get(Math.floor(sourcePixel.x), Math.floor(sourcePixel.y)));
                }
                return {
                    matrix: matrix,
                    mappingFunction: mappingFunction
                };
            }
            exports.extract = extract;
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var MAX_FINDERPATTERNS_TO_SEARCH = 4;
            var MIN_QUAD_RATIO = 0.5;
            var MAX_QUAD_RATIO = 1.5;
            var distance = function(a, b) {
                return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
            };
            function sum(values) {
                return values.reduce(function(a, b) {
                    return a + b;
                });
            }
            // Takes three finder patterns and organizes them into topLeft, topRight, etc
            function reorderFinderPatterns(pattern1, pattern2, pattern3) {
                var _a, _b, _c, _d;
                // Find distances between pattern centers
                var oneTwoDistance = distance(pattern1, pattern2);
                var twoThreeDistance = distance(pattern2, pattern3);
                var oneThreeDistance = distance(pattern1, pattern3);
                var bottomLeft;
                var topLeft;
                var topRight;
                // Assume one closest to other two is B; A and C will just be guesses at first
                if (twoThreeDistance >= oneTwoDistance && twoThreeDistance >= oneThreeDistance) _a = [
                    pattern2,
                    pattern1,
                    pattern3
                ], bottomLeft = _a[0], topLeft = _a[1], topRight = _a[2];
                else if (oneThreeDistance >= twoThreeDistance && oneThreeDistance >= oneTwoDistance) _b = [
                    pattern1,
                    pattern2,
                    pattern3
                ], bottomLeft = _b[0], topLeft = _b[1], topRight = _b[2];
                else _c = [
                    pattern1,
                    pattern3,
                    pattern2
                ], bottomLeft = _c[0], topLeft = _c[1], topRight = _c[2];
                // Use cross product to figure out whether bottomLeft (A) and topRight (C) are correct or flipped in relation to topLeft (B)
                // This asks whether BC x BA has a positive z component, which is the arrangement we want. If it's negative, then
                // we've got it flipped around and should swap topRight and bottomLeft.
                if ((topRight.x - topLeft.x) * (bottomLeft.y - topLeft.y) - (topRight.y - topLeft.y) * (bottomLeft.x - topLeft.x) < 0) _d = [
                    topRight,
                    bottomLeft
                ], bottomLeft = _d[0], topRight = _d[1];
                return {
                    bottomLeft: bottomLeft,
                    topLeft: topLeft,
                    topRight: topRight
                };
            }
            // Computes the dimension (number of modules on a side) of the QR Code based on the position of the finder patterns
            function computeDimension(topLeft, topRight, bottomLeft, matrix) {
                var moduleSize = (sum(countBlackWhiteRun(topLeft, bottomLeft, matrix, 5)) / 7 + // Divide by 7 since the ratio is 1:1:3:1:1
                sum(countBlackWhiteRun(topLeft, topRight, matrix, 5)) / 7 + sum(countBlackWhiteRun(bottomLeft, topLeft, matrix, 5)) / 7 + sum(countBlackWhiteRun(topRight, topLeft, matrix, 5)) / 7) / 4;
                if (moduleSize < 1) throw new Error("Invalid module size");
                var topDimension = Math.round(distance(topLeft, topRight) / moduleSize);
                var sideDimension = Math.round(distance(topLeft, bottomLeft) / moduleSize);
                var dimension = Math.floor((topDimension + sideDimension) / 2) + 7;
                switch(dimension % 4){
                    case 0:
                        dimension++;
                        break;
                    case 2:
                        dimension--;
                        break;
                }
                return {
                    dimension: dimension,
                    moduleSize: moduleSize
                };
            }
            // Takes an origin point and an end point and counts the sizes of the black white run from the origin towards the end point.
            // Returns an array of elements, representing the pixel size of the black white run.
            // Uses a variant of http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
            function countBlackWhiteRunTowardsPoint(origin, end, matrix, length) {
                var switchPoints = [
                    {
                        x: Math.floor(origin.x),
                        y: Math.floor(origin.y)
                    }
                ];
                var steep = Math.abs(end.y - origin.y) > Math.abs(end.x - origin.x);
                var fromX;
                var fromY;
                var toX;
                var toY;
                if (steep) {
                    fromX = Math.floor(origin.y);
                    fromY = Math.floor(origin.x);
                    toX = Math.floor(end.y);
                    toY = Math.floor(end.x);
                } else {
                    fromX = Math.floor(origin.x);
                    fromY = Math.floor(origin.y);
                    toX = Math.floor(end.x);
                    toY = Math.floor(end.y);
                }
                var dx = Math.abs(toX - fromX);
                var dy = Math.abs(toY - fromY);
                var error = Math.floor(-dx / 2);
                var xStep = fromX < toX ? 1 : -1;
                var yStep = fromY < toY ? 1 : -1;
                var currentPixel = true;
                // Loop up until x == toX, but not beyond
                for(var x = fromX, y = fromY; x !== toX + xStep; x += xStep){
                    // Does current pixel mean we have moved white to black or vice versa?
                    // Scanning black in state 0,2 and white in state 1, so if we find the wrong
                    // color, advance to next state or end if we are in state 2 already
                    var realX = steep ? y : x;
                    var realY = steep ? x : y;
                    if (matrix.get(realX, realY) !== currentPixel) {
                        currentPixel = !currentPixel;
                        switchPoints.push({
                            x: realX,
                            y: realY
                        });
                        if (switchPoints.length === length + 1) break;
                    }
                    error += dy;
                    if (error > 0) {
                        if (y === toY) break;
                        y += yStep;
                        error -= dx;
                    }
                }
                var distances = [];
                for(var i = 0; i < length; i++)if (switchPoints[i] && switchPoints[i + 1]) distances.push(distance(switchPoints[i], switchPoints[i + 1]));
                else distances.push(0);
                return distances;
            }
            // Takes an origin point and an end point and counts the sizes of the black white run in the origin point
            // along the line that intersects with the end point. Returns an array of elements, representing the pixel sizes
            // of the black white run. Takes a length which represents the number of switches from black to white to look for.
            function countBlackWhiteRun(origin, end, matrix, length) {
                var _a;
                var rise = end.y - origin.y;
                var run = end.x - origin.x;
                var towardsEnd = countBlackWhiteRunTowardsPoint(origin, end, matrix, Math.ceil(length / 2));
                var awayFromEnd = countBlackWhiteRunTowardsPoint(origin, {
                    x: origin.x - run,
                    y: origin.y - rise
                }, matrix, Math.ceil(length / 2));
                var middleValue = towardsEnd.shift() + awayFromEnd.shift() - 1; // Substract one so we don't double count a pixel
                return (_a = awayFromEnd.concat(middleValue)).concat.apply(_a, towardsEnd);
            }
            // Takes in a black white run and an array of expected ratios. Returns the average size of the run as well as the "error" -
            // that is the amount the run diverges from the expected ratio
            function scoreBlackWhiteRun(sequence, ratios) {
                var averageSize = sum(sequence) / sum(ratios);
                var error = 0;
                ratios.forEach(function(ratio, i) {
                    error += Math.pow(sequence[i] - ratio * averageSize, 2);
                });
                return {
                    averageSize: averageSize,
                    error: error
                };
            }
            // Takes an X,Y point and an array of sizes and scores the point against those ratios.
            // For example for a finder pattern takes the ratio list of 1:1:3:1:1 and checks horizontal, vertical and diagonal ratios
            // against that.
            function scorePattern(point, ratios, matrix) {
                try {
                    var horizontalRun = countBlackWhiteRun(point, {
                        x: -1,
                        y: point.y
                    }, matrix, ratios.length);
                    var verticalRun = countBlackWhiteRun(point, {
                        x: point.x,
                        y: -1
                    }, matrix, ratios.length);
                    var topLeftPoint = {
                        x: Math.max(0, point.x - point.y) - 1,
                        y: Math.max(0, point.y - point.x) - 1
                    };
                    var topLeftBottomRightRun = countBlackWhiteRun(point, topLeftPoint, matrix, ratios.length);
                    var bottomLeftPoint = {
                        x: Math.min(matrix.width, point.x + point.y) + 1,
                        y: Math.min(matrix.height, point.y + point.x) + 1
                    };
                    var bottomLeftTopRightRun = countBlackWhiteRun(point, bottomLeftPoint, matrix, ratios.length);
                    var horzError = scoreBlackWhiteRun(horizontalRun, ratios);
                    var vertError = scoreBlackWhiteRun(verticalRun, ratios);
                    var diagDownError = scoreBlackWhiteRun(topLeftBottomRightRun, ratios);
                    var diagUpError = scoreBlackWhiteRun(bottomLeftTopRightRun, ratios);
                    var ratioError = Math.sqrt(horzError.error * horzError.error + vertError.error * vertError.error + diagDownError.error * diagDownError.error + diagUpError.error * diagUpError.error);
                    var avgSize = (horzError.averageSize + vertError.averageSize + diagDownError.averageSize + diagUpError.averageSize) / 4;
                    var sizeError = (Math.pow(horzError.averageSize - avgSize, 2) + Math.pow(vertError.averageSize - avgSize, 2) + Math.pow(diagDownError.averageSize - avgSize, 2) + Math.pow(diagUpError.averageSize - avgSize, 2)) / avgSize;
                    return ratioError + sizeError;
                } catch (_a) {
                    return Infinity;
                }
            }
            function recenterLocation(matrix, p) {
                var leftX = Math.round(p.x);
                while(matrix.get(leftX, Math.round(p.y)))leftX--;
                var rightX = Math.round(p.x);
                while(matrix.get(rightX, Math.round(p.y)))rightX++;
                var x = (leftX + rightX) / 2;
                var topY = Math.round(p.y);
                while(matrix.get(Math.round(x), topY))topY--;
                var bottomY = Math.round(p.y);
                while(matrix.get(Math.round(x), bottomY))bottomY++;
                var y = (topY + bottomY) / 2;
                return {
                    x: x,
                    y: y
                };
            }
            function locate(matrix) {
                var finderPatternQuads = [];
                var activeFinderPatternQuads = [];
                var alignmentPatternQuads = [];
                var activeAlignmentPatternQuads = [];
                var _loop_1 = function(y) {
                    var length_1 = 0;
                    var lastBit = false;
                    var scans = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ];
                    var _loop_2 = function(x) {
                        var v = matrix.get(x, y);
                        if (v === lastBit) length_1++;
                        else {
                            scans = [
                                scans[1],
                                scans[2],
                                scans[3],
                                scans[4],
                                length_1
                            ];
                            length_1 = 1;
                            lastBit = v;
                            // Do the last 5 color changes ~ match the expected ratio for a finder pattern? 1:1:3:1:1 of b:w:b:w:b
                            var averageFinderPatternBlocksize = sum(scans) / 7;
                            var validFinderPattern = Math.abs(scans[0] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[1] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[2] - 3 * averageFinderPatternBlocksize) < 3 * averageFinderPatternBlocksize && Math.abs(scans[3] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[4] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && !v; // And make sure the current pixel is white since finder patterns are bordered in white
                            // Do the last 3 color changes ~ match the expected ratio for an alignment pattern? 1:1:1 of w:b:w
                            var averageAlignmentPatternBlocksize = sum(scans.slice(-3)) / 3;
                            var validAlignmentPattern = Math.abs(scans[2] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[3] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[4] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && v; // Is the current pixel black since alignment patterns are bordered in black
                            if (validFinderPattern) {
                                // Compute the start and end x values of the large center black square
                                var endX_1 = x - scans[3] - scans[4];
                                var startX_1 = endX_1 - scans[2];
                                var line = {
                                    startX: startX_1,
                                    endX: endX_1,
                                    y: y
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeFinderPatternQuads.filter(function(q) {
                                    return startX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || endX_1 >= q.bottom.startX && startX_1 <= q.bottom.endX || startX_1 <= q.bottom.startX && endX_1 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeFinderPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                            if (validAlignmentPattern) {
                                // Compute the start and end x values of the center black square
                                var endX_2 = x - scans[4];
                                var startX_2 = endX_2 - scans[3];
                                var line = {
                                    startX: startX_2,
                                    y: y,
                                    endX: endX_2
                                };
                                // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                                // that line as the starting point.
                                var matchingQuads = activeAlignmentPatternQuads.filter(function(q) {
                                    return startX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || endX_2 >= q.bottom.startX && startX_2 <= q.bottom.endX || startX_2 <= q.bottom.startX && endX_2 >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > MIN_QUAD_RATIO;
                                });
                                if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                                else activeAlignmentPatternQuads.push({
                                    top: line,
                                    bottom: line
                                });
                            }
                        }
                    };
                    for(var x = -1; x <= matrix.width; x++)_loop_2(x);
                    finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y !== y && q.bottom.y - q.top.y >= 2;
                    }));
                    activeFinderPatternQuads = activeFinderPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                    alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y !== y;
                    }));
                    activeAlignmentPatternQuads = activeAlignmentPatternQuads.filter(function(q) {
                        return q.bottom.y === y;
                    });
                };
                for(var y = 0; y <= matrix.height; y++)_loop_1(y);
                finderPatternQuads.push.apply(finderPatternQuads, activeFinderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }));
                alignmentPatternQuads.push.apply(alignmentPatternQuads, activeAlignmentPatternQuads);
                var finderPatternGroups = finderPatternQuads.filter(function(q) {
                    return q.bottom.y - q.top.y >= 2;
                }) // All quads must be at least 2px tall since the center square is larger than a block
                .map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.round(x), Math.round(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var score = scorePattern({
                        x: Math.round(x),
                        y: Math.round(y)
                    }, [
                        1,
                        1,
                        3,
                        1,
                        1
                    ], matrix);
                    return {
                        score: score,
                        x: x,
                        y: y,
                        size: size
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected quads from above
                .sort(function(a, b) {
                    return a.score - b.score;
                })// Now take the top finder pattern options and try to find 2 other options with a similar size.
                .map(function(point, i, finderPatterns) {
                    if (i > MAX_FINDERPATTERNS_TO_SEARCH) return null;
                    var otherPoints = finderPatterns.filter(function(p, ii) {
                        return i !== ii;
                    }).map(function(p) {
                        return {
                            x: p.x,
                            y: p.y,
                            score: p.score + Math.pow(p.size - point.size, 2) / point.size,
                            size: p.size
                        };
                    }).sort(function(a, b) {
                        return a.score - b.score;
                    });
                    if (otherPoints.length < 2) return null;
                    var score = point.score + otherPoints[0].score + otherPoints[1].score;
                    return {
                        points: [
                            point
                        ].concat(otherPoints.slice(0, 2)),
                        score: score
                    };
                }).filter(function(q) {
                    return !!q;
                }) // Filter out any rejected finder patterns from above
                .sort(function(a, b) {
                    return a.score - b.score;
                });
                if (finderPatternGroups.length === 0) return null;
                var _a = reorderFinderPatterns(finderPatternGroups[0].points[0], finderPatternGroups[0].points[1], finderPatternGroups[0].points[2]), topRight = _a.topRight, topLeft = _a.topLeft, bottomLeft = _a.bottomLeft;
                var alignment = findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft);
                var result = [];
                if (alignment) result.push({
                    alignmentPattern: {
                        x: alignment.alignmentPattern.x,
                        y: alignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: bottomLeft.x,
                        y: bottomLeft.y
                    },
                    dimension: alignment.dimension,
                    topLeft: {
                        x: topLeft.x,
                        y: topLeft.y
                    },
                    topRight: {
                        x: topRight.x,
                        y: topRight.y
                    }
                });
                // We normally use the center of the quads as the location of the tracking points, which is optimal for most cases and will account
                // for a skew in the image. However, In some cases, a slight skew might not be real and instead be caused by image compression
                // errors and/or low resolution. For those cases, we'd be better off centering the point exactly in the middle of the black area. We
                // compute and return the location data for the naively centered points as it is little additional work and allows for multiple
                // attempts at decoding harder images.
                var midTopRight = recenterLocation(matrix, topRight);
                var midTopLeft = recenterLocation(matrix, topLeft);
                var midBottomLeft = recenterLocation(matrix, bottomLeft);
                var centeredAlignment = findAlignmentPattern(matrix, alignmentPatternQuads, midTopRight, midTopLeft, midBottomLeft);
                if (centeredAlignment) result.push({
                    alignmentPattern: {
                        x: centeredAlignment.alignmentPattern.x,
                        y: centeredAlignment.alignmentPattern.y
                    },
                    bottomLeft: {
                        x: midBottomLeft.x,
                        y: midBottomLeft.y
                    },
                    topLeft: {
                        x: midTopLeft.x,
                        y: midTopLeft.y
                    },
                    topRight: {
                        x: midTopRight.x,
                        y: midTopRight.y
                    },
                    dimension: centeredAlignment.dimension
                });
                if (result.length === 0) return null;
                return result;
            }
            exports.locate = locate;
            function findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft) {
                var _a;
                // Now that we've found the three finder patterns we can determine the blockSize and the size of the QR code.
                // We'll use these to help find the alignment pattern but also later when we do the extraction.
                var dimension;
                var moduleSize;
                try {
                    _a = computeDimension(topLeft, topRight, bottomLeft, matrix), dimension = _a.dimension, moduleSize = _a.moduleSize;
                } catch (e) {
                    return null;
                }
                // Now find the alignment pattern
                var bottomRightFinderPattern = {
                    x: topRight.x - topLeft.x + bottomLeft.x,
                    y: topRight.y - topLeft.y + bottomLeft.y
                };
                var modulesBetweenFinderPatterns = (distance(topLeft, bottomLeft) + distance(topLeft, topRight)) / 2 / moduleSize;
                var correctionToTopLeft = 1 - 3 / modulesBetweenFinderPatterns;
                var expectedAlignmentPattern = {
                    x: topLeft.x + correctionToTopLeft * (bottomRightFinderPattern.x - topLeft.x),
                    y: topLeft.y + correctionToTopLeft * (bottomRightFinderPattern.y - topLeft.y)
                };
                var alignmentPatterns = alignmentPatternQuads.map(function(q) {
                    var x = (q.top.startX + q.top.endX + q.bottom.startX + q.bottom.endX) / 4;
                    var y = (q.top.y + q.bottom.y + 1) / 2;
                    if (!matrix.get(Math.floor(x), Math.floor(y))) return;
                    var lengths = [
                        q.top.endX - q.top.startX,
                        q.bottom.endX - q.bottom.startX,
                        q.bottom.y - q.top.y + 1
                    ];
                    var size = sum(lengths) / lengths.length;
                    var sizeScore = scorePattern({
                        x: Math.floor(x),
                        y: Math.floor(y)
                    }, [
                        1,
                        1,
                        1
                    ], matrix);
                    var score = sizeScore + distance({
                        x: x,
                        y: y
                    }, expectedAlignmentPattern);
                    return {
                        x: x,
                        y: y,
                        score: score
                    };
                }).filter(function(v) {
                    return !!v;
                }).sort(function(a, b) {
                    return a.score - b.score;
                });
                // If there are less than 15 modules between finder patterns it's a version 1 QR code and as such has no alignmemnt pattern
                // so we can only use our best guess.
                var alignmentPattern = modulesBetweenFinderPatterns >= 15 && alignmentPatterns.length ? alignmentPatterns[0] : expectedAlignmentPattern;
                return {
                    alignmentPattern: alignmentPattern,
                    dimension: dimension
                };
            }
        /***/ }
    ])["default"];
});




var $cD0nt = parcelRequire("cD0nt");




var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1BSKa = parcelRequire("1BSKa");

const $37420fc4e509e88c$var$visibleStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40rem",
    padding: "2rem 2.5rem",
    fontSize: "2.4rem",
    textAlign: "center",
    borderRadius: "1rem",
    border: "2px solid black",
    color: "black",
    outline: "none",
    zIndex: 100
};
const $37420fc4e509e88c$var$hiddenStyle = {
    position: "fixed",
    top: "-9999px",
    left: "-9999px",
    width: "1px",
    height: "1px",
    opacity: 0
};
const $37420fc4e509e88c$var$HidScannerInput = ({ onScan: onScan, cooldownMs: cooldownMs = 1500, minLength: minLength = 4, visible: visible = false, validate: validate, logTag: logTag = "hid-scanner" })=>{
    const inputRef = (0, $eZVvM.useRef)(null);
    const lastScanAtRef = (0, $eZVvM.useRef)(0);
    (0, $eZVvM.useEffect)(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)("input", {
        ref: inputRef,
        type: "text",
        autoComplete: "off",
        onBlur: (e)=>e.target.focus(),
        onKeyDown: (e)=>{
            if (e.key !== "Enter" && e.key !== "Tab") return;
            const code = e.currentTarget.value.trim();
            if (code.length < minLength) return;
            e.preventDefault();
            const now = Date.now();
            const sinceLast = now - lastScanAtRef.current;
            if (sinceLast < cooldownMs) {
                (0, $1BSKa.default).warn(`[${logTag}] scan dropped (cooldown)`, {
                    code: code,
                    sinceLastMs: sinceLast
                });
                (0, $07e411b3523e37a1$export$c4b924de6dad976b)();
                e.currentTarget.value = "";
                return;
            }
            if (validate && !validate(code)) {
                (0, $1BSKa.default).warn(`[${logTag}] scan dropped (invalid)`, {
                    code: code
                });
                (0, $07e411b3523e37a1$export$c4b924de6dad976b)();
                e.currentTarget.value = "";
                return;
            }
            lastScanAtRef.current = now;
            (0, $1BSKa.default).info(`[${logTag}] scan accepted`, {
                code: code
            });
            onScan(code);
            e.currentTarget.value = "";
        },
        style: visible ? $37420fc4e509e88c$var$visibleStyle : $37420fc4e509e88c$var$hiddenStyle,
        "aria-hidden": !visible
    });
};
var $37420fc4e509e88c$export$2e2bcd8739ae039 = $37420fc4e509e88c$var$HidScannerInput;


const $048f48bf49f3c8ad$export$cad6bc48b0b04c72 = ()=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 100 100",
        style: {
            top: 0,
            left: 0,
            zIndex: 1,
            boxSizing: "border-box",
            position: "absolute",
            width: "100%",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M13,0 L0,0 L0,13",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M0,87 L0,100 L13,100",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M87,100 L100,100 L100,87",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                fill: "none",
                d: "M100,13 L100,0 87,0",
                stroke: "rgba(255, 0, 0, 0.5)",
                strokeWidth: "0.5rem"
            })
        ]
    });
const $048f48bf49f3c8ad$var$QRCodeScanner = ()=>{
    var _match_params;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "QRCodeScanner"
    ]);
    const match = (0, $9B9bN.useMatch)({
        path: "/scanner/:action"
    });
    const action = match === null || match === void 0 ? void 0 : (_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.action;
    const navigate = (0, $9B9bN.useNavigate)();
    const { qrScannerRotation: qrScannerRotation = 0 } = (0, $cD0nt.useDigitalReceptionMetadata)();
    const [error, setError] = (0, $eZVvM.useState)(null);
    (0, $eZVvM.useEffect)(()=>{
        const scanQrCode = ()=>{
            try {
                setError(null);
                const video = document.getElementById("qr-video");
                if (!video || video.readyState !== video.HAVE_ENOUGH_DATA) return;
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                ctx === null || ctx === void 0 ? void 0 : ctx.translate(canvas.width, 0);
                ctx === null || ctx === void 0 ? void 0 : ctx.scale(-1, 1);
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                if (!imageData) return;
                const code = (0, (/*@__PURE__*/$parcel$interopDefault($6bd535989f3fab53$exports)))(imageData.data, canvas.width, canvas.height);
                if (code) {
                    const data = code.data.trim();
                    const regex = /^\d+$/;
                    if (regex.test(data) && data.length === 6) navigate(`/access/${action}/${data}`);
                    else setError(t("QRCodeScanner:error"));
                }
            } catch (err) {
                setError(t("QRCodeScanner:unknownError"));
            }
        };
        const interval = setInterval(scanQrCode, 500);
        return ()=>clearInterval(interval);
    }, [
        navigate,
        action
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: `/access/${action}`
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h1",
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "QRCodeScanner:title"
                                })
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h4",
                                className: "font-weight-regular mt-5",
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "QRCodeScanner:subtitle"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        className: "qr-scanner",
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                style: {
                                    width: "100%",
                                    margin: "auto",
                                    transform: `rotate(${qrScannerRotation}deg)`
                                },
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $12c6b0ab9da17bee$export$5d05a7e825dbf285), {
                                    videoId: "qr-video",
                                    constraints: {
                                        facingMode: "user",
                                        aspectRatio: 1
                                    },
                                    ViewFinder: $048f48bf49f3c8ad$export$cad6bc48b0b04c72
                                })
                            }),
                            error && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h3",
                                className: "position-absolute text-center text-error p-4",
                                children: error
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $37420fc4e509e88c$export$2e2bcd8739ae039), {
                logTag: "qr-scanner-camera-fallback",
                validate: (code)=>/^\d+$/.test(code) && code.length === 6,
                onScan: (code)=>navigate(`/access/${action}/${code}`)
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $048f48bf49f3c8ad$export$2e2bcd8739ae039 = $048f48bf49f3c8ad$var$QRCodeScanner;


const $7d6568e8be4ca2d2$var$CaptureTitle = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("h5")({
    fontSize: "3.5rem",
    margin: "7rem 10rem 4rem",
    color: "#000000",
    textAlign: "center"
});
const $7d6568e8be4ca2d2$var$CaptureError = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "100%",
    height: "100%",
    padding: "10rem",
    fontSize: "4.5rem",
    color: "red",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
});
const $7d6568e8be4ca2d2$var$CaptureContainer = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "5rem",
    "& svg": {
        width: "calc(100% - 4rem) !important",
        height: "calc(100% - 4rem) !important",
        top: "2rem !important",
        left: "2rem !important"
    },
    "@media screen and (orientation: landscape)": {
        flexDirection: "row",
        justifyContent: "center",
        "& > :first-of-type": {
            marginRight: "2rem"
        }
    }
});
const $7d6568e8be4ca2d2$var$Countdown = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "end",
    fontSize: "7rem",
    color: "white",
    padding: "2rem 4.5rem"
});
const $7d6568e8be4ca2d2$var$videoConstraints = {
    aspectRatio: 1,
    facingMode: {
        ideal: "environment"
    }
};
const $7d6568e8be4ca2d2$var$CameraCapture = ({ onAccept: onAccept })=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "photo"
    ]);
    const { onUpload: onUpload } = (0, $e92fc026f2fe1d33$export$6397b8382b014af7)();
    const webcamRef = (0, $eZVvM.useRef)(null);
    const [imgSrc, setImgSrc] = (0, $eZVvM.useState)(null);
    const [countdown, setCountdown] = (0, $eZVvM.useState)(0);
    const [captureError, setCaptureError] = (0, $eZVvM.useState)(false);
    const capturePhoto = (0, $eZVvM.useCallback)(()=>{
        if (webcamRef.current && webcamRef.current.getScreenshot) {
            const imageSrc = webcamRef.current.getScreenshot();
            setImgSrc(imageSrc);
            setCountdown(0);
        }
    }, []);
    const dataURLtoFile = (dataURL, filename)=>{
        const arr = dataURL.split(",");
        const mimeMatch = arr[0].match(/:(.*?);/);
        if (!mimeMatch) return null;
        const mime = mimeMatch[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        // eslint-disable-next-line no-plusplus
        while(n--)u8arr[n] = bstr.charCodeAt(n);
        return new File([
            u8arr
        ], filename, {
            type: mime
        });
    };
    const handleError = ()=>{
        setCaptureError(true);
        setTimeout(()=>{
            onAccept("");
            setCaptureError(false);
        }, 5000);
    };
    const handleUpload = ()=>{
        if (imgSrc) {
            const file = dataURLtoFile(imgSrc, `photo_${Date.now()}.png`);
            if (!file) {
                handleError();
                return;
            }
            const fileUploadData = {
                data: imgSrc,
                file: file
            };
            onUpload(fileUploadData).then((response)=>{
                onAccept(response === null || response === void 0 ? void 0 : response[0].file.id);
            }).catch(()=>{
                handleError();
            });
        }
    };
    (0, $eZVvM.useEffect)(()=>{
        if (!imgSrc) {
            setCountdown(6);
            const countdownInterval = setInterval(()=>{
                setCountdown((prevCountdown)=>{
                    if (prevCountdown <= 1) {
                        clearInterval(countdownInterval);
                        capturePhoto();
                        return 0;
                    }
                    return prevCountdown - 1;
                });
            }, 1000);
        }
    }, [
        capturePhoto,
        imgSrc
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        className: "w-100 h-100 ",
        children: captureError ? /*#__PURE__*/ (0, $bhfvP.jsx)($7d6568e8be4ca2d2$var$CaptureError, {
            children: t("photo:error")
        }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)($7d6568e8be4ca2d2$var$CaptureTitle, {
                    children: t("photo:subtitle")
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)($7d6568e8be4ca2d2$var$CaptureContainer, {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                            className: "position-relative mb-5",
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8e8171dbde9eba52$exports))), {
                                    audio: false,
                                    ref: webcamRef,
                                    screenshotFormat: "image/png",
                                    videoConstraints: $7d6568e8be4ca2d2$var$videoConstraints,
                                    style: {
                                        display: "block",
                                        width: "65rem",
                                        height: "65srem",
                                        borderRadius: "1rem"
                                    }
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $048f48bf49f3c8ad$export$cad6bc48b0b04c72), {}),
                                countdown !== 0 && /*#__PURE__*/ (0, $bhfvP.jsx)($7d6568e8be4ca2d2$var$Countdown, {
                                    children: countdown
                                })
                            ]
                        }),
                        imgSrc && /*#__PURE__*/ (0, $bhfvP.jsx)("img", {
                            className: "rounded-4 mt-0",
                            src: imgSrc,
                            alt: "Captured"
                        })
                    ]
                }),
                imgSrc && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-2 mt-2 me-5",
                            style: {
                                width: "31rem"
                            },
                            onClick: ()=>setImgSrc(null),
                            children: t("photo:button.recapture")
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-2 mt-2",
                            style: {
                                width: "31rem"
                            },
                            onClick: handleUpload,
                            children: t("photo:button.continue")
                        })
                    ]
                })
            ]
        })
    });
};
var $7d6568e8be4ca2d2$export$2e2bcd8739ae039 = $7d6568e8be4ca2d2$var$CameraCapture;



const $c967df95bbff7b87$var$animatePhoto = {
    initial: {
        x: "100%"
    },
    animate: {
        x: 0,
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    },
    exit: {
        x: "100%",
        transition: {
            duration: 0.4,
            ease: [
                0.165,
                0.84,
                0.44,
                1
            ]
        }
    }
};
const $c967df95bbff7b87$var$PhotoDialog = (props)=>{
    const { onClose: onClose, onAccept: onAccept, required: required } = props;
    const [photoCapture, setPhotoCapture] = (0, $eZVvM.useState)(false);
    const { t: t } = (0, $9GLBV.useTranslation)([
        "photo"
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
        mode: "wait",
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), {
            fullScreen: true,
            open: true,
            transitionDuration: 0,
            component: (0, $d5f8329c0fec877c$export$e25e478948902b8b).div,
            ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)($c967df95bbff7b87$var$animatePhoto),
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $4baac96c69466163$export$2e2bcd8739ae039), {
                    dividers: true,
                    className: "p-0 d-flex align-items-center justify-content-center text-center",
                    children: !photoCapture ? /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "d-flex flex-column",
                        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                            className: "p-5",
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "p-5 text-center fw-semibold",
                                    style: {
                                        fontSize: "4.5rem",
                                        color: "#000000"
                                    },
                                    children: t(`photo:${required ? "required" : "optional"}.title`)
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "p-5 text-center",
                                    style: {
                                        fontSize: "3.5rem",
                                        color: "#000000"
                                    },
                                    children: t(`photo:${required ? "required" : "optional"}.securityNotice`)
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "p-4 text-center",
                                    style: {
                                        fontSize: "3.5rem",
                                        color: "#000000"
                                    },
                                    children: t(`photo:${required ? "required" : "optional"}.instructions`)
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "p-4 text-center",
                                    style: {
                                        fontSize: "3.5rem",
                                        color: "#000000"
                                    },
                                    children: t(`photo:${required ? "required" : "optional"}.privacyInfo`)
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c094567c9dcd56f3$export$2e2bcd8739ae039), {
                                    className: "p-5 text-center",
                                    style: {
                                        fontSize: "4.5rem",
                                        color: "#000000"
                                    },
                                    children: t(`photo:${required ? "required" : "optional"}.closingMessage`)
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e92fc026f2fe1d33$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $7d6568e8be4ca2d2$export$2e2bcd8739ae039), {
                            onAccept: onAccept
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), {
                    className: "p-5",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-5 me-5 w",
                            onClick: onClose,
                            children: t(`photo:button.${required ? "cancel" : "skip"}`)
                        }),
                        !photoCapture && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "px-5",
                            onClick: ()=>{
                                setPhotoCapture(true);
                            },
                            children: t(`photo:button.${required ? "next" : "accept"}`)
                        })
                    ]
                })
            ]
        })
    });
};
var $c967df95bbff7b87$export$2e2bcd8739ae039 = $c967df95bbff7b87$var$PhotoDialog;



var $cD0nt = parcelRequire("cD0nt");

var $eZVvM = parcelRequire("eZVvM");
var $9f150a284e68dfbb$exports = {};
"use strict";
Object.defineProperty($9f150a284e68dfbb$exports, "__esModule", {
    value: true
});

var $eZVvM = parcelRequire("eZVvM");
function $9f150a284e68dfbb$var$useTimeoutFn(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = $eZVvM.useRef(false);
    var timeout = $eZVvM.useRef();
    var callback = $eZVvM.useRef(fn);
    var isReady = $eZVvM.useCallback(function() {
        return ready.current;
    }, []);
    var set = $eZVvM.useCallback(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = $eZVvM.useCallback(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    $eZVvM.useEffect(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    $eZVvM.useEffect(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}
$9f150a284e68dfbb$exports.default = $9f150a284e68dfbb$var$useTimeoutFn;


function $5848bfc96b8c5272$export$300a7784b83886c8(fn = ()=>null, ms = 0) {
    const [, cancelTimeout, resetTimeout] = (0, (/*@__PURE__*/$parcel$interopDefault($9f150a284e68dfbb$exports)))(fn, ms);
    const disabled = (0, $eZVvM.useMemo)(()=>!(typeof ms === "number" && ms > 0), []);
    (0, $eZVvM.useEffect)(()=>{
        if (disabled) cancelTimeout();
        else resetTimeout();
        return ()=>{
            cancelTimeout();
        };
    }, [
        disabled
    ]);
}



var $eZVvM = parcelRequire("eZVvM");

function $b93fbe9fa8871676$export$4d340688cbe434a5(currentStatus = "idle", ms = 2000) {
    const [status, setStatus] = (0, $eZVvM.useState)(currentStatus);
    const [, cancel, reset] = (0, (/*@__PURE__*/$parcel$interopDefault($9f150a284e68dfbb$exports)))(()=>{
        setStatus(currentStatus);
    }, ms);
    (0, $eZVvM.useEffect)(()=>{
        switch(currentStatus){
            case "success":
            case "error":
                reset();
                break;
            default:
                cancel();
                setStatus(currentStatus);
                break;
        }
    }, [
        currentStatus
    ]);
    return status;
}



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");


const $325562920a04a1bd$export$27b435a0411fd08e = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { activeAccess: activeAccess } = (0, $cD0nt.useAccessSettings)();
    const [doorStatus, setDoorStatus] = (0, $eZVvM.useState)();
    const trigger = (0, $eZVvM.useCallback)(async (id)=>{
        setDoorStatus("loading");
        try {
            await (0, $jnPOB.client).request(activeAccess === "shelly" ? (0, $801c1e65c4cb7f68$export$8b0c33549cb7b2d4) : (0, $801c1e65c4cb7f68$export$a3dd2c5fafc1020c), {
                input: {
                    id: id,
                    action: activeAccess === "shelly" ? "ON_WITH_DELAY" : "ON"
                }
            });
            setDoorStatus("success");
        } catch (e) {
            setDoorStatus("error");
        }
    }, [
        activeAccess
    ]);
    const onDismissDoor = (0, $eZVvM.useCallback)(()=>{
        if (doorStatus === "error") {
            setDoorStatus(undefined);
            return;
        }
        navigate("/", {
            replace: true
        });
    }, [
        doorStatus,
        navigate
    ]);
    const doorTimeout = (0, $eZVvM.useMemo)(()=>{
        if (doorStatus === "error") return 7000;
        if (doorStatus === "success") return 4000;
        return 0;
    }, [
        doorStatus
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismissDoor, doorTimeout);
    const doorModal = doorStatus ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        status: doorStatus,
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `access:status.${doorStatus}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `access:status.${doorStatus}.message`
        }),
        onDismiss: onDismissDoor
    }) : null;
    return {
        trigger: trigger,
        doorStatus: doorStatus,
        doorModal: doorModal
    };
};



/** Combining marks left over after NFD decomposition. */ const $ff6a04e1584a86ed$var$COMBINING_MARKS = /[\u0300-\u036f]/g;
/**
 * Characters NFD does not decompose — their diacritic is part of the glyph — plus
 * the ligatures, which fold to two letters.
 */ const $ff6a04e1584a86ed$var$FOLD_EXCEPTIONS = {
    "\xdf": "ss",
    "\xe6": "ae",
    \u0153: "oe",
    "\xf8": "o",
    \u0142: "l",
    \u0111: "d",
    "\xf0": "d",
    "\xfe": "th",
    \u0127: "h",
    \u0167: "t",
    \u014B: "n",
    \u0131: "i",
    \u0133: "ij"
};
const $ff6a04e1584a86ed$export$7e13855abec31c34 = (value)=>Array.from(value.normalize("NFD").replace($ff6a04e1584a86ed$var$COMBINING_MARKS, "").toLowerCase()).map((char)=>{
        var _FOLD_EXCEPTIONS_char;
        return (_FOLD_EXCEPTIONS_char = $ff6a04e1584a86ed$var$FOLD_EXCEPTIONS[char]) !== null && _FOLD_EXCEPTIONS_char !== void 0 ? _FOLD_EXCEPTIONS_char : char;
    }).join("");



var $jnPOB = parcelRequire("jnPOB");


var $k9qks = parcelRequire("k9qks");

var $kCXUJ = parcelRequire("kCXUJ");

/// <reference types="nwjs-types" />

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $1BSKa = parcelRequire("1BSKa");
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");
var $e18cee267b875a58$exports = {};
$parcel$export($e18cee267b875a58$exports, "PDFDocument", function () { return $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039; });

var $1RwW5 = parcelRequire("1RwW5");

var $1RwW5 = parcelRequire("1RwW5");
parcelRequire("dJvqn");

var $aGkK2 = parcelRequire("aGkK2");

var $1RwW5 = parcelRequire("1RwW5");

var $jjzmO = parcelRequire("jjzmO");

var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $9d5120c628a2c36d$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $equxL.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).Percent;
        buffer[offset++] = (0, $aGkK2.default).P;
        buffer[offset++] = (0, $aGkK2.default).D;
        buffer[offset++] = (0, $aGkK2.default).F;
        buffer[offset++] = (0, $aGkK2.default).Dash;
        offset += (0, $equxL.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).Period;
        offset += (0, $equxL.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).Newline;
        buffer[offset++] = (0, $aGkK2.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $9d5120c628a2c36d$export$2e2bcd8739ae039 = $9d5120c628a2c36d$var$PDFHeader;



var $dJvqn = parcelRequire("dJvqn");

var $joN8z = parcelRequire("joN8z");

var $aeaZ4 = parcelRequire("aeaZ4");

var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");

var $1RwW5 = parcelRequire("1RwW5");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
var $4fa296e6a51e8ed5$var$PDFNull = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return "null";
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $aGkK2.default).n;
        buffer[offset++] = (0, $aGkK2.default).u;
        buffer[offset++] = (0, $aGkK2.default).l;
        buffer[offset++] = (0, $aGkK2.default).l;
        return 4;
    };
    return PDFNull;
}((0, $fi0fX.default));
var $4fa296e6a51e8ed5$export$2e2bcd8739ae039 = new $4fa296e6a51e8ed5$var$PDFNull();



var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
var $9ab23d4939782527$var$PDFDict = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $1RwW5.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $1RwW5.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = "";
        var existingKeys = this.keys();
        var key = (0, $iqqIy.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $iqqIy.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = "<<\n";
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + " " + value.toString() + "\n";
        }
        dictString += ">>";
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).LessThan;
        buffer[offset++] = (0, $aGkK2.default).LessThan;
        buffer[offset++] = (0, $aGkK2.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Newline;
        }
        buffer[offset++] = (0, $aGkK2.default).GreaterThan;
        buffer[offset++] = (0, $aGkK2.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $fi0fX.default));
var $9ab23d4939782527$export$2e2bcd8739ae039 = $9ab23d4939782527$var$PDFDict;



var $iqqIy = parcelRequire("iqqIy");


var $3vNQK = parcelRequire("3vNQK");

var $fi0fX = parcelRequire("fi0fX");

var $1RwW5 = parcelRequire("1RwW5");

var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
var $b753fca77bba2f04$var$PDFStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "clone");
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "getContentsString");
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "getContents");
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "getContentsSize");
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $iqqIy.default).Length, (0, $3vNQK.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += "\nstream\n";
        streamString += this.getContentsString();
        streamString += "\nendstream";
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).Newline;
        buffer[offset++] = (0, $aGkK2.default).s;
        buffer[offset++] = (0, $aGkK2.default).t;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).a;
        buffer[offset++] = (0, $aGkK2.default).m;
        buffer[offset++] = (0, $aGkK2.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $aGkK2.default).Newline;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).n;
        buffer[offset++] = (0, $aGkK2.default).d;
        buffer[offset++] = (0, $aGkK2.default).s;
        buffer[offset++] = (0, $aGkK2.default).t;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).a;
        buffer[offset++] = (0, $aGkK2.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $fi0fX.default));
var $b753fca77bba2f04$export$2e2bcd8739ae039 = $b753fca77bba2f04$var$PDFStream;


parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
var $f3af422d5f07580f$var$PDFRawStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $hOX8d.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $b753fca77bba2f04$export$2e2bcd8739ae039));
var $f3af422d5f07580f$export$2e2bcd8739ae039 = $f3af422d5f07580f$var$PDFRawStream;



var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $fi0fX = parcelRequire("fi0fX");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $2544783d06ee48ba$var$ENFORCER = {};
var $2544783d06ee48ba$var$pool = new Map();
var $2544783d06ee48ba$var$PDFRef = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $2544783d06ee48ba$var$ENFORCER) throw new (0, $dJvqn.PrivateConstructorError)("PDFRef");
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $equxL.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $2544783d06ee48ba$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($2544783d06ee48ba$var$ENFORCER, objectNumber, generationNumber);
            $2544783d06ee48ba$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $fi0fX.default));
var $2544783d06ee48ba$export$2e2bcd8739ae039 = $2544783d06ee48ba$var$PDFRef;



var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $81b82bf3cb721b12$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $fi0fX.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = "";
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + " ";
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $fi0fX.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $fi0fX.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $equxL.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
        }
        offset += (0, $equxL.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $81b82bf3cb721b12$export$2e2bcd8739ae039 = $81b82bf3cb721b12$var$PDFOperator;


var $1330496c55834efa$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = '"';
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($1330496c55834efa$var$PDFOperatorNames || ($1330496c55834efa$var$PDFOperatorNames = {}));
var $1330496c55834efa$export$2e2bcd8739ae039 = $1330496c55834efa$var$PDFOperatorNames;



var $1RwW5 = parcelRequire("1RwW5");

var $1RwW5 = parcelRequire("1RwW5");

var $jjzmO = parcelRequire("jjzmO");

var $dJvqn = parcelRequire("dJvqn");

var $iqqIy = parcelRequire("iqqIy");

parcelRequire("3Iuzo");
var $k9ooy = parcelRequire("k9ooy");
var $c77f585a2c4de6fc$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($jjzmO))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $iqqIy.default).of("Filter"), (0, $iqqIy.default).of("FlateDecode"));
        _this.contentsCache = (0, $k9ooy.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "getUnencodedContents");
    };
    return PDFFlateStream;
}((0, $b753fca77bba2f04$export$2e2bcd8739ae039));
var $c77f585a2c4de6fc$export$2e2bcd8739ae039 = $c77f585a2c4de6fc$var$PDFFlateStream;



var $aGkK2 = parcelRequire("aGkK2");
var $2c3e42ef98d100c6$var$PDFContentStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = "";
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $c77f585a2c4de6fc$export$2e2bcd8739ae039));
var $2c3e42ef98d100c6$export$2e2bcd8739ae039 = $2c3e42ef98d100c6$var$PDFContentStream;


parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $3ccfe2a4746ab0c6$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $bcf2ef2f9428db1c$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $bcf2ef2f9428db1c$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $9d5120c628a2c36d$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $3ccfe2a4746ab0c6$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039)) {
                if (result === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $dJvqn.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039)) {
                if (result === (0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $dJvqn.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($bcf2ef2f9428db1c$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $fi0fX.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039;
        else if (typeof literal === "string") return (0, $iqqIy.default).of(literal);
        else if (typeof literal === "number") return (0, $3vNQK.default).of(literal);
        else if (typeof literal === "boolean") return literal ? (0, $aeaZ4.default).True : (0, $aeaZ4.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $joN8z.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $9ab23d4939782527$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $iqqIy.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $f3af422d5f07580f$export$2e2bcd8739ae039).of(this.obj(dict), (0, $hOX8d.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($jjzmO))).deflate((0, $hOX8d.typedArrayFor)(contents)), (0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, dict), {
            Filter: "FlateDecode"
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $2c3e42ef98d100c6$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $1RwW5.__assign)((0, $1RwW5.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: "XObject",
            Subtype: "Form"
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $2c3e42ef98d100c6$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $2c3e42ef98d100c6$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $bcf2ef2f9428db1c$export$2e2bcd8739ae039 = $bcf2ef2f9428db1c$var$PDFContext;



var $joN8z = parcelRequire("joN8z");


var $iqqIy = parcelRequire("iqqIy");



var $1RwW5 = parcelRequire("1RwW5");

var $joN8z = parcelRequire("joN8z");


var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");

var $302c9174c68f73e6$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $iqqIy.default).Parent, (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $iqqIy.default).of("Contents"));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $iqqIy.default).Annots, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $iqqIy.default).BleedBox, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $iqqIy.default).TrimBox, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $iqqIy.default).ArtBox, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $iqqIy.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $iqqIy.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $iqqIy.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $joN8z.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $iqqIy.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $3vNQK.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $iqqIy.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $iqqIy.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $joN8z.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $iqqIy.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039)) this.set((0, $iqqIy.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $iqqIy.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $9ab23d4939782527$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $iqqIy.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $iqqIy.default).Font, (0, $9ab23d4939782527$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $iqqIy.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $iqqIy.default).XObject, (0, $9ab23d4939782527$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $iqqIy.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $iqqIy.default).ExtGState, (0, $9ab23d4939782527$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $iqqIy.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $iqqIy.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $iqqIy.default).Font, (0, $9ab23d4939782527$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $iqqIy.default).XObject, (0, $9ab23d4939782527$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $iqqIy.default).ExtGState, (0, $9ab23d4939782527$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        "Resources",
        "MediaBox",
        "CropBox",
        "Rotate"
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $iqqIy.default).Type, (0, $iqqIy.default).Page);
        dict.set((0, $iqqIy.default).Parent, parent);
        dict.set((0, $iqqIy.default).Resources, context.obj({}));
        dict.set((0, $iqqIy.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $9ab23d4939782527$export$2e2bcd8739ae039));
var $302c9174c68f73e6$export$2e2bcd8739ae039 = $302c9174c68f73e6$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $02b1048d3880ea05$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $302c9174c68f73e6$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $joN8z.default) ? _this.copyPDFArray(object) : object instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $302c9174c68f73e6$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $iqqIy.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $iqqIy.default).of("Parent"));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $02b1048d3880ea05$export$2e2bcd8739ae039 = $02b1048d3880ea05$var$PDFObjectCopier;



var $1RwW5 = parcelRequire("1RwW5");


var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $dc36e9f3639c5ac6$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $equxL.padStart)(String(entry.offset), 10, "0");
                section += " ";
                section += (0, $equxL.padStart)(String(entry.ref.generationNumber), 5, "0");
                section += " ";
                section += entry.deleted ? "f" : "n";
                section += " \n";
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).x;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).f;
        buffer[offset++] = (0, $aGkK2.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $equxL.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $equxL.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $equxL.padStart)(String(entry.offset), 10, "0");
            offset += (0, $equxL.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
            var entryGen = (0, $equxL.padStart)(String(entry.ref.generationNumber), 5, "0");
            offset += (0, $equxL.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Space;
            buffer[offset++] = entry.deleted ? (0, $aGkK2.default).f : (0, $aGkK2.default).n;
            buffer[offset++] = (0, $aGkK2.default).Space;
            buffer[offset++] = (0, $aGkK2.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $dc36e9f3639c5ac6$export$2e2bcd8739ae039 = $dc36e9f3639c5ac6$var$PDFCrossRefSection;




var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $f336eceb9cb22fb8$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).s;
        buffer[offset++] = (0, $aGkK2.default).t;
        buffer[offset++] = (0, $aGkK2.default).a;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).t;
        buffer[offset++] = (0, $aGkK2.default).x;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).f;
        buffer[offset++] = (0, $aGkK2.default).Newline;
        offset += (0, $equxL.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).Newline;
        buffer[offset++] = (0, $aGkK2.default).Percent;
        buffer[offset++] = (0, $aGkK2.default).Percent;
        buffer[offset++] = (0, $aGkK2.default).E;
        buffer[offset++] = (0, $aGkK2.default).O;
        buffer[offset++] = (0, $aGkK2.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $f336eceb9cb22fb8$export$2e2bcd8739ae039 = $f336eceb9cb22fb8$var$PDFTrailer;



var $aGkK2 = parcelRequire("aGkK2");
var $d352c1dda82e2187$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $aGkK2.default).t;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).a;
        buffer[offset++] = (0, $aGkK2.default).i;
        buffer[offset++] = (0, $aGkK2.default).l;
        buffer[offset++] = (0, $aGkK2.default).e;
        buffer[offset++] = (0, $aGkK2.default).r;
        buffer[offset++] = (0, $aGkK2.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $d352c1dda82e2187$export$2e2bcd8739ae039 = $d352c1dda82e2187$var$PDFTrailerDict;



var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");


var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $hOX8d = parcelRequire("hOX8d");
var $8a9e786e9c994a75$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $iqqIy.default).of("Type"), (0, $iqqIy.default).of("ObjStm"));
        _this.dict.set((0, $iqqIy.default).of("N"), (0, $3vNQK.default).of(_this.objects.length));
        _this.dict.set((0, $iqqIy.default).of("First"), (0, $3vNQK.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $equxL.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $aGkK2.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $hOX8d.last)(this.offsets)[1] + (0, $hOX8d.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = "";
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $c77f585a2c4de6fc$export$2e2bcd8739ae039));
var $8a9e786e9c994a75$export$2e2bcd8739ae039 = $8a9e786e9c994a75$var$PDFObjectStream;



var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $2O2jP = parcelRequire("2O2jP");
var $711a45888f7f3cc3$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $1RwW5.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $equxL.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $aGkK2.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $equxL.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $aGkK2.default).Space;
                        buffer[offset++] = (0, $aGkK2.default).o;
                        buffer[offset++] = (0, $aGkK2.default).b;
                        buffer[offset++] = (0, $aGkK2.default).j;
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        buffer[offset++] = (0, $aGkK2.default).e;
                        buffer[offset++] = (0, $aGkK2.default).n;
                        buffer[offset++] = (0, $aGkK2.default).d;
                        buffer[offset++] = (0, $aGkK2.default).o;
                        buffer[offset++] = (0, $aGkK2.default).b;
                        buffer[offset++] = (0, $aGkK2.default).j;
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        buffer[offset++] = (0, $aGkK2.default).Newline;
                        n = object instanceof (0, $8a9e786e9c994a75$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $aGkK2.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $aGkK2.default).Newline;
                            buffer[offset++] = (0, $aGkK2.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $9d5120c628a2c36d$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $dc36e9f3639c5ac6$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $d352c1dda82e2187$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $f336eceb9cb22fb8$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $711a45888f7f3cc3$export$2e2bcd8739ae039 = $711a45888f7f3cc3$var$PDFWriter;



var $1RwW5 = parcelRequire("1RwW5");



var $1RwW5 = parcelRequire("1RwW5");

var $fi0fX = parcelRequire("fi0fX");
var $24ad3c29928be025$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $fi0fX.default));
var $24ad3c29928be025$export$2e2bcd8739ae039 = $24ad3c29928be025$var$PDFInvalidObject;



var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");



var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");


parcelRequire("3Iuzo");
var $j8ZLl = parcelRequire("j8ZLl");
var $k9ooy = parcelRequire("k9ooy");
var $hOX8d = parcelRequire("hOX8d");
var $b4869aa4aa199f85$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($b4869aa4aa199f85$export$e41c32906b33062a || ($b4869aa4aa199f85$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $b4869aa4aa199f85$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $b4869aa4aa199f85$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $b4869aa4aa199f85$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $b4869aa4aa199f85$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $j8ZLl.sizeInBytes)(first);
                var secondSize = (0, $j8ZLl.sizeInBytes)(second);
                var thirdSize = (0, $j8ZLl.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $k9ooy.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $k9ooy.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $k9ooy.default).populatedBy(_this.computeIndex);
        dict.set((0, $iqqIy.default).of("Type"), (0, $iqqIy.default).of("XRef"));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $b4869aa4aa199f85$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $b4869aa4aa199f85$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $b4869aa4aa199f85$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = "";
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(first));
            var secondBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(second));
            var thirdBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(first));
            var secondBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(second));
            var thirdBytes = (0, $hOX8d.reverseArray)((0, $j8ZLl.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $hOX8d.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $iqqIy.default).of("W"), context.obj(byteWidths));
        this.dict.set((0, $iqqIy.default).of("Index"), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $c77f585a2c4de6fc$export$2e2bcd8739ae039));
var $b4869aa4aa199f85$export$2e2bcd8739ae039 = $b4869aa4aa199f85$var$PDFCrossRefStream;




parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
var $2O2jP = parcelRequire("2O2jP");
var $4ce308fa1beafd09$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $9d5120c628a2c36d$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $b4869aa4aa199f85$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039) || object instanceof (0, $24ad3c29928be025$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $hOX8d.last)(compressedObjects);
                        objectStreamRef = (0, $hOX8d.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $8a9e786e9c994a75$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $iqqIy.default).of("Size"), (0, $3vNQK.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $f336eceb9cb22fb8$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $711a45888f7f3cc3$export$2e2bcd8739ae039));
var $4ce308fa1beafd09$export$2e2bcd8739ae039 = $4ce308fa1beafd09$var$PDFStreamWriter;






parcelRequire("dFOCr");
var $l6GEW = parcelRequire("l6GEW");
var $fsila = parcelRequire("fsila");

var $1RwW5 = parcelRequire("1RwW5");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $720Bx = parcelRequire("720Bx");
var $axUYF = parcelRequire("axUYF");

var $dJvqn = parcelRequire("dJvqn");
var $83374afbe9879719$var$PDFHexString = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? "0" : "");
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $720Bx.hasUtf16BOM)(bytes)) return (0, $720Bx.utf16Decode)(bytes);
        return (0, $axUYF.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $equxL.parseDate)(text);
        if (!date) throw new (0, $dJvqn.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $aGkK2.default).LessThan;
        offset += (0, $equxL.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $720Bx.utf16Encode)(value);
        var hex = "";
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $equxL.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $fi0fX.default));
var $83374afbe9879719$export$2e2bcd8739ae039 = $83374afbe9879719$var$PDFHexString;


parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $a818e8311cd0aafa$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $fsila.FontNames).ZapfDingbats ? (0, $l6GEW.Encodings).ZapfDingbats : fontName === (0, $fsila.FontNames).Symbol ? (0, $l6GEW.Encodings).Symbol : (0, $l6GEW.Encodings).WinAnsi;
        this.font = (0, $fsila.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $equxL.toHexString)(glyphs[idx].code);
        return (0, $83374afbe9879719$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: "Font",
            Subtype: "Type1",
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $l6GEW.Encodings).WinAnsi ? "WinAnsiEncoding" : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $equxL.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $a818e8311cd0aafa$export$2e2bcd8739ae039 = $a818e8311cd0aafa$var$StandardFontEmbedder;



var $1RwW5 = parcelRequire("1RwW5");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");

var $720Bx = parcelRequire("720Bx");
var $005b35af0d3c61f7$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $005b35af0d3c61f7$var$cmapHexFormat($005b35af0d3c61f7$var$cmapHexString(glyphId(glyph)));
        var unicode = $005b35af0d3c61f7$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($005b35af0d3c61f7$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $005b35af0d3c61f7$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $005b35af0d3c61f7$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join("\n") + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $005b35af0d3c61f7$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join("") + ">";
};
var $005b35af0d3c61f7$var$cmapHexString = function(value) {
    return (0, $equxL.toHexStringOfMinLength)(value, 4);
};
var $005b35af0d3c61f7$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $720Bx.isWithinBMP)(codePoint)) return $005b35af0d3c61f7$var$cmapHexString(codePoint);
    if ((0, $720Bx.hasSurrogates)(codePoint)) {
        var hs = (0, $720Bx.highSurrogate)(codePoint);
        var ls = (0, $720Bx.lowSurrogate)(codePoint);
        return "" + $005b35af0d3c61f7$var$cmapHexString(hs) + $005b35af0d3c61f7$var$cmapHexString(ls);
    }
    var hex = (0, $equxL.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $c782306c339042fe$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $c782306c339042fe$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font["OS/2"] ? font["OS/2"].sFamilyClass : 0;
    var flags = $c782306c339042fe$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $1RwW5 = parcelRequire("1RwW5");

var $fi0fX = parcelRequire("fi0fX");

var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $720Bx = parcelRequire("720Bx");
var $axUYF = parcelRequire("axUYF");

var $dJvqn = parcelRequire("dJvqn");
var $03aa38dbd8969f43$var$PDFString = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = "";
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $equxL.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $aGkK2.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $aGkK2.default).Newline) pushByte();
                else if (byte === (0, $aGkK2.default).CarriageReturn) pushByte();
                else if (byte === (0, $aGkK2.default).n) pushByte((0, $aGkK2.default).Newline);
                else if (byte === (0, $aGkK2.default).r) pushByte((0, $aGkK2.default).CarriageReturn);
                else if (byte === (0, $aGkK2.default).t) pushByte((0, $aGkK2.default).Tab);
                else if (byte === (0, $aGkK2.default).b) pushByte((0, $aGkK2.default).Backspace);
                else if (byte === (0, $aGkK2.default).f) pushByte((0, $aGkK2.default).FormFeed);
                else if (byte === (0, $aGkK2.default).LeftParen) pushByte((0, $aGkK2.default).LeftParen);
                else if (byte === (0, $aGkK2.default).RightParen) pushByte((0, $aGkK2.default).RightParen);
                else if (byte === (0, $aGkK2.default).Backspace) pushByte((0, $aGkK2.default).BackSlash);
                else if (byte >= (0, $aGkK2.default).Zero && byte <= (0, $aGkK2.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= "0" && nextChar <= "7")) {
                        pushByte(parseInt(octal, 8));
                        octal = "";
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $720Bx.hasUtf16BOM)(bytes)) return (0, $720Bx.utf16Decode)(bytes);
        return (0, $axUYF.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $equxL.parseDate)(text);
        if (!date) throw new (0, $dJvqn.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $aGkK2.default).LeftParen;
        offset += (0, $equxL.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $aGkK2.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $equxL.padStart)(String(date.getUTCFullYear()), 4, "0");
        var month = (0, $equxL.padStart)(String(date.getUTCMonth() + 1), 2, "0");
        var day = (0, $equxL.padStart)(String(date.getUTCDate()), 2, "0");
        var hours = (0, $equxL.padStart)(String(date.getUTCHours()), 2, "0");
        var mins = (0, $equxL.padStart)(String(date.getUTCMinutes()), 2, "0");
        var secs = (0, $equxL.padStart)(String(date.getUTCSeconds()), 2, "0");
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $fi0fX.default));
var $03aa38dbd8969f43$export$2e2bcd8739ae039 = $03aa38dbd8969f43$var$PDFString;


parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
var $k9ooy = parcelRequire("k9ooy");
var $equxL = parcelRequire("equxL");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $ac7b02d65ced7399$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $hOX8d.sortedUniq)(glyphs.sort((0, $hOX8d.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || "Font";
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = "";
        this.glyphCache = (0, $k9ooy.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $equxL.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $83374afbe9879719$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: "Font",
                            Subtype: "Type0",
                            BaseFont: this.baseFontName,
                            Encoding: "Identity-H",
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: "Font",
                            Subtype: this.isCFF() ? "CIDFontType0" : "CIDFontType2",
                            CIDToGIDMap: "Identity",
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of("Adobe"),
                                Ordering: (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of("Identity"),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $1RwW5.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: "FontDescriptor",
                            FontName: this.baseFontName,
                            Flags: (0, $c782306c339042fe$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? "FontFile3" : "FontFile2"] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $1RwW5.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? "CIDFontType0C" : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $005b35af0d3c61f7$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $ac7b02d65ced7399$export$2e2bcd8739ae039 = $ac7b02d65ced7399$var$CustomFontEmbedder;



var $1RwW5 = parcelRequire("1RwW5");


parcelRequire("3Iuzo");
var $k9ooy = parcelRequire("k9ooy");
var $hOX8d = parcelRequire("hOX8d");
var $equxL = parcelRequire("equxL");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $74b9b066d9e8e864$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $k9ooy.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $equxL.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $83374afbe9879719$export$2e2bcd8739ae039).of(hexCodes.join(""));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on("data", function(bytes) {
                return parts.push(bytes);
            }).on("end", function() {
                return resolve((0, $hOX8d.mergeUint8Arrays)(parts));
            }).on("error", function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $ac7b02d65ced7399$export$2e2bcd8739ae039));
var $74b9b066d9e8e864$export$2e2bcd8739ae039 = $74b9b066d9e8e864$var$CustomFontSubsetEmbedder;



var $1RwW5 = parcelRequire("1RwW5");


var $684e3b3e06b271aa$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($684e3b3e06b271aa$export$c12eac46fbec1b74 || ($684e3b3e06b271aa$export$c12eac46fbec1b74 = {}));
var $684e3b3e06b271aa$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $1RwW5.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: "EmbeddedFile",
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: "Filespec",
                    F: (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $684e3b3e06b271aa$export$2e2bcd8739ae039 = $684e3b3e06b271aa$var$FileEmbedder;



var $1RwW5 = parcelRequire("1RwW5");
// prettier-ignore
var $eaa7124f5925770b$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $eaa7124f5925770b$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($eaa7124f5925770b$var$ColorSpace || ($eaa7124f5925770b$var$ColorSpace = {}));
var $eaa7124f5925770b$var$ChannelToColorSpace = {
    1: $eaa7124f5925770b$var$ColorSpace.DeviceGray,
    3: $eaa7124f5925770b$var$ColorSpace.DeviceRGB,
    4: $eaa7124f5925770b$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $eaa7124f5925770b$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $1RwW5.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error("SOI not found in JPEG");
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($eaa7124f5925770b$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$eaa7124f5925770b$var$MARKERS.includes(marker)) throw new Error("Invalid JPEG");
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $eaa7124f5925770b$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error("Unknown JPEG channel.");
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $1RwW5.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: "XObject",
                    Subtype: "Image",
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: "DCTDecode",
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $eaa7124f5925770b$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $eaa7124f5925770b$export$2e2bcd8739ae039 = $eaa7124f5925770b$var$JpegEmbedder;



var $1RwW5 = parcelRequire("1RwW5");

var $jjzmO = parcelRequire("jjzmO");
var $8d1f0fb7aedc51c0$var$UPNG = {};
$8d1f0fb7aedc51c0$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $8d1f0fb7aedc51c0$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $8d1f0fb7aedc51c0$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $8d1f0fb7aedc51c0$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $8d1f0fb7aedc51c0$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $8d1f0fb7aedc51c0$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$8d1f0fb7aedc51c0$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $8d1f0fb7aedc51c0$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $8d1f0fb7aedc51c0$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$8d1f0fb7aedc51c0$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $8d1f0fb7aedc51c0$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $8d1f0fb7aedc51c0$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $8d1f0fb7aedc51c0$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $8d1f0fb7aedc51c0$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $8d1f0fb7aedc51c0$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $8d1f0fb7aedc51c0$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $8d1f0fb7aedc51c0$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $8d1f0fb7aedc51c0$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $8d1f0fb7aedc51c0$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._inflate = function(data, buff) {
    var out = $8d1f0fb7aedc51c0$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$8d1f0fb7aedc51c0$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$8d1f0fb7aedc51c0$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $8d1f0fb7aedc51c0$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $8d1f0fb7aedc51c0$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $8d1f0fb7aedc51c0$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $8d1f0fb7aedc51c0$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$8d1f0fb7aedc51c0$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $8d1f0fb7aedc51c0$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$8d1f0fb7aedc51c0$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $8d1f0fb7aedc51c0$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $8d1f0fb7aedc51c0$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$8d1f0fb7aedc51c0$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$8d1f0fb7aedc51c0$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $8d1f0fb7aedc51c0$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $8d1f0fb7aedc51c0$var$UPNG.encode.compressPNG(nimg, -1);
    return $8d1f0fb7aedc51c0$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$8d1f0fb7aedc51c0$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $8d1f0fb7aedc51c0$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $8d1f0fb7aedc51c0$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$8d1f0fb7aedc51c0$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $8d1f0fb7aedc51c0$var$UPNG.crc.crc, wUi = $8d1f0fb7aedc51c0$var$UPNG._bin.writeUint, wUs = $8d1f0fb7aedc51c0$var$UPNG._bin.writeUshort, wAs = $8d1f0fb7aedc51c0$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$8d1f0fb7aedc51c0$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $8d1f0fb7aedc51c0$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$8d1f0fb7aedc51c0$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $8d1f0fb7aedc51c0$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $8d1f0fb7aedc51c0$var$UPNG.encode.concatRGBA(nbufs), qres = $8d1f0fb7aedc51c0$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$8d1f0fb7aedc51c0$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $8d1f0fb7aedc51c0$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $8d1f0fb7aedc51c0$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $8d1f0fb7aedc51c0$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $8d1f0fb7aedc51c0$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $8d1f0fb7aedc51c0$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $8d1f0fb7aedc51c0$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$8d1f0fb7aedc51c0$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $8d1f0fb7aedc51c0$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $8d1f0fb7aedc51c0$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $8d1f0fb7aedc51c0$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$8d1f0fb7aedc51c0$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $8d1f0fb7aedc51c0$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$8d1f0fb7aedc51c0$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($jjzmO)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$8d1f0fb7aedc51c0$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$8d1f0fb7aedc51c0$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $8d1f0fb7aedc51c0$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$8d1f0fb7aedc51c0$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $8d1f0fb7aedc51c0$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $8d1f0fb7aedc51c0$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$8d1f0fb7aedc51c0$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $8d1f0fb7aedc51c0$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $8d1f0fb7aedc51c0$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $8d1f0fb7aedc51c0$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $8d1f0fb7aedc51c0$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $8d1f0fb7aedc51c0$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $8d1f0fb7aedc51c0$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $8d1f0fb7aedc51c0$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $8d1f0fb7aedc51c0$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $8d1f0fb7aedc51c0$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $8d1f0fb7aedc51c0$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $8d1f0fb7aedc51c0$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $8d1f0fb7aedc51c0$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $8d1f0fb7aedc51c0$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $8d1f0fb7aedc51c0$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$8d1f0fb7aedc51c0$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $8d1f0fb7aedc51c0$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$8d1f0fb7aedc51c0$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$8d1f0fb7aedc51c0$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $8d1f0fb7aedc51c0$export$2e2bcd8739ae039 = $8d1f0fb7aedc51c0$var$UPNG;


var $70e69e0bac56e116$var$getImageType = function(ctype) {
    if (ctype === 0) return $70e69e0bac56e116$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $70e69e0bac56e116$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $70e69e0bac56e116$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $70e69e0bac56e116$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $70e69e0bac56e116$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $70e69e0bac56e116$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $70e69e0bac56e116$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($70e69e0bac56e116$export$3ff975e8f63e458c || ($70e69e0bac56e116$export$3ff975e8f63e458c = {}));
var $70e69e0bac56e116$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $8d1f0fb7aedc51c0$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $8d1f0fb7aedc51c0$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $70e69e0bac56e116$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $70e69e0bac56e116$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $7463aa2ac79da73b$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = "DeviceRGB";
    }
    PngEmbedder.for = function(imageData) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $1RwW5.__generator)(this, function(_a) {
                png = (0, $70e69e0bac56e116$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $1RwW5.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: "XObject",
                    Subtype: "Image",
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: "XObject",
            Subtype: "Image",
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: "DeviceGray",
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $7463aa2ac79da73b$export$2e2bcd8739ae039 = $7463aa2ac79da73b$var$PngEmbedder;



var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $3vNQK = parcelRequire("3vNQK");



var $dJvqn = parcelRequire("dJvqn");

var $joN8z = parcelRequire("joN8z");


var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $4dafd06a08c429f0$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $4dafd06a08c429f0$export$2e2bcd8739ae039 = $4dafd06a08c429f0$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $aef8ebac8fb18c5d$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $aef8ebac8fb18c5d$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $aef8ebac8fb18c5d$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $4dafd06a08c429f0$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "readBlock");
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $aef8ebac8fb18c5d$export$2e2bcd8739ae039 = $aef8ebac8fb18c5d$var$DecodeStream;


var $9045149a8c46bacf$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $9045149a8c46bacf$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($9045149a8c46bacf$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($9045149a8c46bacf$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $aef8ebac8fb18c5d$export$2e2bcd8739ae039));
var $9045149a8c46bacf$export$2e2bcd8739ae039 = $9045149a8c46bacf$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $1RwW5 = parcelRequire("1RwW5");

var $9d8676ece5e59747$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $aef8ebac8fb18c5d$export$2e2bcd8739ae039));
var $9d8676ece5e59747$export$2e2bcd8739ae039 = $9d8676ece5e59747$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $1RwW5 = parcelRequire("1RwW5");

// prettier-ignore
var $7492cf9fc8f2ce75$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $7492cf9fc8f2ce75$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $7492cf9fc8f2ce75$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $7492cf9fc8f2ce75$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $7492cf9fc8f2ce75$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $7492cf9fc8f2ce75$var$FlateStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error("Bad block header in flate stream");
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error("Bad uncompressed block length in flate stream");
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $7492cf9fc8f2ce75$var$fixedLitCodeTab;
            distCodeTable = $7492cf9fc8f2ce75$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($7492cf9fc8f2ce75$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$7492cf9fc8f2ce75$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error("Unknown block type in flate stream");
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $7492cf9fc8f2ce75$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $7492cf9fc8f2ce75$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error("Bad encoding in flate stream");
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === "number") console.log("FLATE:", code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error("Bad encoding in flate stream");
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $aef8ebac8fb18c5d$export$2e2bcd8739ae039));
var $7492cf9fc8f2ce75$export$2e2bcd8739ae039 = $7492cf9fc8f2ce75$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $1RwW5 = parcelRequire("1RwW5");

var $26b29ca14870092f$var$LZWStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $aef8ebac8fb18c5d$export$2e2bcd8739ae039));
var $26b29ca14870092f$export$2e2bcd8739ae039 = $26b29ca14870092f$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $1RwW5 = parcelRequire("1RwW5");

var $46302b44ad805d6e$var$RunLengthStream = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $aef8ebac8fb18c5d$export$2e2bcd8739ae039));
var $46302b44ad805d6e$export$2e2bcd8739ae039 = $46302b44ad805d6e$var$RunLengthStream;



var $660f2755f9f0c8aa$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $iqqIy.default).of("FlateDecode")) return new (0, $7492cf9fc8f2ce75$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $iqqIy.default).of("LZWDecode")) {
        var earlyChange = 1;
        if (params instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $iqqIy.default).of("EarlyChange"));
            if (EarlyChange instanceof (0, $3vNQK.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $26b29ca14870092f$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $iqqIy.default).of("ASCII85Decode")) return new (0, $9045149a8c46bacf$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $iqqIy.default).of("ASCIIHexDecode")) return new (0, $9d8676ece5e59747$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $iqqIy.default).of("RunLengthDecode")) return new (0, $46302b44ad805d6e$export$2e2bcd8739ae039)(stream);
    throw new (0, $dJvqn.UnsupportedEncodingError)(encoding.asString());
};
var $660f2755f9f0c8aa$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $4dafd06a08c429f0$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $iqqIy.default).of("Filter"));
    var DecodeParms = dict.lookup((0, $iqqIy.default).of("DecodeParms"));
    if (Filter instanceof (0, $iqqIy.default)) stream = $660f2755f9f0c8aa$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $joN8z.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $660f2755f9f0c8aa$var$decodeStream(stream, Filter.lookup(idx, (0, $iqqIy.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $9ab23d4939782527$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $dJvqn.UnexpectedObjectTypeError)([
        (0, $iqqIy.default),
        (0, $joN8z.default)
    ], Filter);
    return stream;
};




var $aGkK2 = parcelRequire("aGkK2");
parcelRequire("3Iuzo");
var $hOX8d = parcelRequire("hOX8d");
var $e5537a67d34d93c3$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $3vNQK.default)).asNumber() - mediaBox.lookup(0, (0, $3vNQK.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $3vNQK.default)).asNumber() - mediaBox.lookup(1, (0, $3vNQK.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $e5537a67d34d93c3$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $e5537a67d34d93c3$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $e5537a67d34d93c3$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $e5537a67d34d93c3$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $1RwW5.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $dJvqn.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: "XObject",
                    Subtype: "Form",
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $aGkK2.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $b753fca77bba2f04$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $f3af422d5f07580f$export$2e2bcd8739ae039)) content = (0, $660f2755f9f0c8aa$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $2c3e42ef98d100c6$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $dJvqn.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $hOX8d.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $e5537a67d34d93c3$export$2e2bcd8739ae039 = $e5537a67d34d93c3$var$PDFPageEmbedder;



var $3QSuJ = parcelRequire("3QSuJ");

var $fi0fX = parcelRequire("fi0fX");

var $aeaZ4 = parcelRequire("aeaZ4");

var $3vNQK = parcelRequire("3vNQK");



var $iqqIy = parcelRequire("iqqIy");


var $joN8z = parcelRequire("joN8z");






var $1RwW5 = parcelRequire("1RwW5");


var $iqqIy = parcelRequire("iqqIy");

var $1RwW5 = parcelRequire("1RwW5");



var $joN8z = parcelRequire("joN8z");

var $iqqIy = parcelRequire("iqqIy");

var $1RwW5 = parcelRequire("1RwW5");


var $iqqIy = parcelRequire("iqqIy");




var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");

var $joN8z = parcelRequire("joN8z");

parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");

var $dJvqn = parcelRequire("dJvqn");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $eb642424ca22d672$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $eb642424ca22d672$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $iqqIy.default).of("T"), (0, $03aa38dbd8969f43$export$2e2bcd8739ae039), (0, $83374afbe9879719$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $iqqIy.default).of("Ff"));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $3vNQK.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $iqqIy.default).of("V"));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $iqqIy.default).of("Kids"), (0, $joN8z.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $iqqIy.default).of("DA"));
        if (da instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || da instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $iqqIy.default).of("Kids"), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $iqqIy.default).of("Parent"));
        if (parentRef instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $iqqIy.default).of("Parent"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $iqqIy.default).of("Parent"));
        else this.dict.set((0, $iqqIy.default).of("Parent"), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $iqqIy.default).of("T"));
        else this.dict.set((0, $iqqIy.default).of("T"), (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $iqqIy.default).of("DA"), (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : "";
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $dJvqn.MissingDAEntryError)(name);
        var daMatch = (0, $equxL.findLastMatch)(da, $eb642424ca22d672$var$tfRegex);
        if (!daMatch.match) throw new (0, $dJvqn.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : "";
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $iqqIy.default).of("Ff"), (0, $3vNQK.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $eb642424ca22d672$export$2e2bcd8739ae039 = $eb642424ca22d672$var$PDFAcroField;



var $1RwW5 = parcelRequire("1RwW5");


var $iqqIy = parcelRequire("iqqIy");




var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");
// TODO: Also handle the `/S` and `/D` entries
var $fb5fde09a861ed95$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $iqqIy.default).of("W"));
        if (W instanceof (0, $3vNQK.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $iqqIy.default).of("W"), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $fb5fde09a861ed95$export$2e2bcd8739ae039 = $fb5fde09a861ed95$var$BorderStyle;




var $iqqIy = parcelRequire("iqqIy");


var $joN8z = parcelRequire("joN8z");


var $3vNQK = parcelRequire("3vNQK");
var $a6f8b50c86664813$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $iqqIy.default).of("Rect"), (0, $joN8z.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $iqqIy.default).of("AP"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $iqqIy.default).of("F"));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $3vNQK.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $iqqIy.default).of("Rect"), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $iqqIy.default).of("AS"));
        if (AS instanceof (0, $iqqIy.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $iqqIy.default).of("AS"), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $iqqIy.default).of("AP"), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $iqqIy.default).of("AP"), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $iqqIy.default).of("N"));
        if (N instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039) || N instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $iqqIy.default).of("N"), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $iqqIy.default).of("R"), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $iqqIy.default).of("D"), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $iqqIy.default).of("R"));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $iqqIy.default).of("D"));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $iqqIy.default).of("N"), (0, $9ab23d4939782527$export$2e2bcd8739ae039), (0, $b753fca77bba2f04$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $iqqIy.default).of("R"), (0, $9ab23d4939782527$export$2e2bcd8739ae039), (0, $b753fca77bba2f04$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $iqqIy.default).of("D"), (0, $9ab23d4939782527$export$2e2bcd8739ae039), (0, $b753fca77bba2f04$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $iqqIy.default).of("F"), (0, $3vNQK.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $a6f8b50c86664813$export$2e2bcd8739ae039 = $a6f8b50c86664813$var$PDFAnnotation;



var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");

var $joN8z = parcelRequire("joN8z");


var $f33f37dc742ddd2c$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $iqqIy.default).of("R"));
        if (R instanceof (0, $3vNQK.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $iqqIy.default).of("BC"));
        if (BC instanceof (0, $joN8z.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $iqqIy.default).of("BG"));
        if (BG instanceof (0, $joN8z.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $iqqIy.default).of("CA"));
        if (CA instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039) || CA instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $iqqIy.default).of("RC"));
        if (RC instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039) || RC instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $iqqIy.default).of("AC"));
        if (AC instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039) || AC instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $3vNQK.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $3vNQK.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $iqqIy.default).of("R"), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $iqqIy.default).of("BC"), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $iqqIy.default).of("BG"), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $iqqIy.default).of("CA"), CA);
        if (captions.rollover) {
            var RC = (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $iqqIy.default).of("RC"), RC);
        } else this.dict.delete((0, $iqqIy.default).of("RC"));
        if (captions.down) {
            var AC = (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $iqqIy.default).of("AC"), AC);
        } else this.dict.delete((0, $iqqIy.default).of("AC"));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $f33f37dc742ddd2c$export$2e2bcd8739ae039 = $f33f37dc742ddd2c$var$AppearanceCharacteristics;


var $9bc860280d8053e3$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $iqqIy.default).of("MK"));
        if (MK instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $iqqIy.default).of("BS"));
        if (BS instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $iqqIy.default).of("DA"));
        if (da instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || da instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $iqqIy.default).of("P"));
        if (P instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $iqqIy.default).of("P"), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $iqqIy.default).of("DA"), (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $f33f37dc742ddd2c$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $f33f37dc742ddd2c$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $f33f37dc742ddd2c$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $iqqIy.default).of("MK"), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $fb5fde09a861ed95$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $fb5fde09a861ed95$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $fb5fde09a861ed95$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $iqqIy.default).of("BS"), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $iqqIy.default).of("Off")) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: "Annot",
            Subtype: "Widget",
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $a6f8b50c86664813$export$2e2bcd8739ae039));
var $9bc860280d8053e3$export$2e2bcd8739ae039 = $9bc860280d8053e3$var$PDFWidgetAnnotation;



var $dJvqn = parcelRequire("dJvqn");
var $6d47de64576b5104$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $iqqIy.default).of("FT"));
        return this.dict.context.lookup(nameOrRef, (0, $iqqIy.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $9bc860280d8053e3$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $9ab23d4939782527$export$2e2bcd8739ae039));
            widgets[idx] = (0, $9bc860280d8053e3$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $dJvqn.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $dJvqn.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $iqqIy.default).of("Kids"), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $eb642424ca22d672$export$2e2bcd8739ae039));
var $6d47de64576b5104$export$2e2bcd8739ae039 = $6d47de64576b5104$var$PDFAcroTerminal;



var $dJvqn = parcelRequire("dJvqn");
var $b6a311353b8fbcab$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $iqqIy.default).of("Opt"), (0, $03aa38dbd8969f43$export$2e2bcd8739ae039), (0, $83374afbe9879719$export$2e2bcd8739ae039), (0, $joN8z.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $iqqIy.default).of("Opt"), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || opt instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || value instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || opt instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $dJvqn.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $dJvqn.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : "");
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $iqqIy.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $6d47de64576b5104$export$2e2bcd8739ae039));
var $b6a311353b8fbcab$export$2e2bcd8739ae039 = $b6a311353b8fbcab$var$PDFAcroButton;



var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");


var $dJvqn = parcelRequire("dJvqn");
var $366bd3575fe0730a$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $iqqIy.default).of("Yes");
        if (value !== onValue && value !== (0, $iqqIy.default).of("Off")) throw new (0, $dJvqn.InvalidAcroFieldValueError)();
        this.dict.set((0, $iqqIy.default).of("V"), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $iqqIy.default).of("Off");
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $iqqIy.default)) return v;
        return (0, $iqqIy.default).of("Off");
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $b6a311353b8fbcab$export$2e2bcd8739ae039));
var $366bd3575fe0730a$export$2e2bcd8739ae039 = $366bd3575fe0730a$var$PDFAcroCheckBox;



var $1RwW5 = parcelRequire("1RwW5");




var $joN8z = parcelRequire("joN8z");

var $iqqIy = parcelRequire("iqqIy");
var $87bc4bd3413a26f1$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $87bc4bd3413a26f1$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $87bc4bd3413a26f1$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $87bc4bd3413a26f1$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $87bc4bd3413a26f1$var$flag(2)] = "NoExport";
})($87bc4bd3413a26f1$export$3600c95532547643 || ($87bc4bd3413a26f1$export$3600c95532547643 = {}));
var $87bc4bd3413a26f1$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $87bc4bd3413a26f1$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $87bc4bd3413a26f1$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $87bc4bd3413a26f1$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $87bc4bd3413a26f1$var$flag(25)] = "RadiosInUnison";
})($87bc4bd3413a26f1$export$59f660e89ffb4f8a || ($87bc4bd3413a26f1$export$59f660e89ffb4f8a = {}));
var $87bc4bd3413a26f1$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $87bc4bd3413a26f1$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $87bc4bd3413a26f1$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $87bc4bd3413a26f1$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $87bc4bd3413a26f1$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $87bc4bd3413a26f1$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $87bc4bd3413a26f1$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $87bc4bd3413a26f1$var$flag(25)] = "RichText";
})($87bc4bd3413a26f1$export$389fc7b97397dc8b || ($87bc4bd3413a26f1$export$389fc7b97397dc8b = {}));
var $87bc4bd3413a26f1$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $87bc4bd3413a26f1$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $87bc4bd3413a26f1$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $87bc4bd3413a26f1$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $87bc4bd3413a26f1$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $87bc4bd3413a26f1$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $87bc4bd3413a26f1$var$flag(26)] = "CommitOnSelChange";
})($87bc4bd3413a26f1$export$eb88827058402599 || ($87bc4bd3413a26f1$export$eb88827058402599 = {}));



var $dJvqn = parcelRequire("dJvqn");
var $3346223057056adf$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).Combo) && !this.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $dJvqn.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $iqqIy.default).of("V"));
        if (values.length === 1) this.dict.set((0, $iqqIy.default).of("V"), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect)) throw new (0, $dJvqn.MultiSelectValueError)();
            this.dict.set((0, $iqqIy.default).of("V"), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $iqqIy.default).of("I"), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $iqqIy.default).of("I"));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || v instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $joN8z.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || value instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $iqqIy.default).of("Opt"), (0, $03aa38dbd8969f43$export$2e2bcd8739ae039), (0, $83374afbe9879719$export$2e2bcd8739ae039), (0, $joN8z.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $iqqIy.default).of("Opt"), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || Opt instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $joN8z.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || item instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $joN8z.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $03aa38dbd8969f43$export$2e2bcd8739ae039), (0, $83374afbe9879719$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $03aa38dbd8969f43$export$2e2bcd8739ae039), (0, $83374afbe9879719$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $6d47de64576b5104$export$2e2bcd8739ae039));
var $3346223057056adf$export$2e2bcd8739ae039 = $3346223057056adf$var$PDFAcroChoice;



var $1RwW5 = parcelRequire("1RwW5");


var $a23ff55154ff7b90$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: "Ch",
            Ff: (0, $87bc4bd3413a26f1$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $3346223057056adf$export$2e2bcd8739ae039));
var $a23ff55154ff7b90$export$2e2bcd8739ae039 = $a23ff55154ff7b90$var$PDFAcroComboBox;





var $joN8z = parcelRequire("joN8z");

var $iqqIy = parcelRequire("iqqIy");

var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");

var $0f1722da3d8b388a$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $iqqIy.default).of("Kids"), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $eb642424ca22d672$export$2e2bcd8739ae039));
var $0f1722da3d8b388a$export$2e2bcd8739ae039 = $0f1722da3d8b388a$var$PDFAcroNonTerminal;



var $3vNQK = parcelRequire("3vNQK");


var $iqqIy = parcelRequire("iqqIy");

var $joN8z = parcelRequire("joN8z");




var $1RwW5 = parcelRequire("1RwW5");

var $bf720ad6e6c2fea4$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $6d47de64576b5104$export$2e2bcd8739ae039));
var $bf720ad6e6c2fea4$export$2e2bcd8739ae039 = $bf720ad6e6c2fea4$var$PDFAcroSignature;



var $1RwW5 = parcelRequire("1RwW5");

var $3vNQK = parcelRequire("3vNQK");



var $iqqIy = parcelRequire("iqqIy");

var $10326d8429dfa0fe$var$PDFAcroText = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $iqqIy.default).of("MaxLen"));
        if (maxLen instanceof (0, $3vNQK.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $iqqIy.default).of("Q"));
        if (q instanceof (0, $3vNQK.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $iqqIy.default).of("MaxLen"), (0, $3vNQK.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $iqqIy.default).of("MaxLen"));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $iqqIy.default).of("Q"), (0, $3vNQK.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $iqqIy.default).of("V"), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $iqqIy.default).of("V"));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039) || v instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: "Tx",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $6d47de64576b5104$export$2e2bcd8739ae039));
var $10326d8429dfa0fe$export$2e2bcd8739ae039 = $10326d8429dfa0fe$var$PDFAcroText;



var $1RwW5 = parcelRequire("1RwW5");


var $5e596fab1c09e732$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Ff: (0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $b6a311353b8fbcab$export$2e2bcd8739ae039));
var $5e596fab1c09e732$export$2e2bcd8739ae039 = $5e596fab1c09e732$var$PDFAcroPushButton;



var $1RwW5 = parcelRequire("1RwW5");

var $iqqIy = parcelRequire("iqqIy");



var $dJvqn = parcelRequire("dJvqn");
var $ca447f5713e88cbf$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $iqqIy.default).of("Off")) throw new (0, $dJvqn.InvalidAcroFieldValueError)();
        this.dict.set((0, $iqqIy.default).of("V"), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $iqqIy.default).of("Off");
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $iqqIy.default)) return v;
        return (0, $iqqIy.default).of("Off");
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: "Btn",
            Ff: (0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $b6a311353b8fbcab$export$2e2bcd8739ae039));
var $ca447f5713e88cbf$export$2e2bcd8739ae039 = $ca447f5713e88cbf$var$PDFAcroRadioButton;





var $1RwW5 = parcelRequire("1RwW5");

var $eaae09ebc1864895$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: "Ch",
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $3346223057056adf$export$2e2bcd8739ae039));
var $eaae09ebc1864895$export$2e2bcd8739ae039 = $eaae09ebc1864895$var$PDFAcroListBox;



var $f1113a8ba3b3d35a$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039) && dict instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) kids.push([
            $f1113a8ba3b3d35a$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $f1113a8ba3b3d35a$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $f1113a8ba3b3d35a$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $0f1722da3d8b388a$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $f1113a8ba3b3d35a$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $f1113a8ba3b3d35a$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $iqqIy.default).of("Kids"));
    if (kids instanceof (0, $joN8z.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039) && kid.has((0, $iqqIy.default).of("T"));
        if (kidIsField) return true;
    }
    return false;
};
var $f1113a8ba3b3d35a$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $f1113a8ba3b3d35a$var$getInheritableAttribute(dict, (0, $iqqIy.default).of("FT"));
    var type = dict.context.lookup(ftNameOrRef, (0, $iqqIy.default));
    if (type === (0, $iqqIy.default).of("Btn")) return $f1113a8ba3b3d35a$var$createPDFAcroButton(dict, ref);
    if (type === (0, $iqqIy.default).of("Ch")) return $f1113a8ba3b3d35a$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $iqqIy.default).of("Tx")) return (0, $10326d8429dfa0fe$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $iqqIy.default).of("Sig")) return (0, $bf720ad6e6c2fea4$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $6d47de64576b5104$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $f1113a8ba3b3d35a$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $f1113a8ba3b3d35a$var$getInheritableAttribute(dict, (0, $iqqIy.default).of("Ff"));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $3vNQK.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($f1113a8ba3b3d35a$var$flagIsSet(flags, (0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).PushButton)) return (0, $5e596fab1c09e732$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($f1113a8ba3b3d35a$var$flagIsSet(flags, (0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).Radio)) return (0, $ca447f5713e88cbf$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $366bd3575fe0730a$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $f1113a8ba3b3d35a$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $f1113a8ba3b3d35a$var$getInheritableAttribute(dict, (0, $iqqIy.default).of("Ff"));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $3vNQK.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($f1113a8ba3b3d35a$var$flagIsSet(flags, (0, $87bc4bd3413a26f1$export$eb88827058402599).Combo)) return (0, $a23ff55154ff7b90$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $eaae09ebc1864895$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $f1113a8ba3b3d35a$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $f1113a8ba3b3d35a$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $f1113a8ba3b3d35a$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $f1113a8ba3b3d35a$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $iqqIy.default).of("Parent"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    if (Parent) $f1113a8ba3b3d35a$var$ascend(Parent, visitor);
};


var $f260eebdeee2a02c$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $iqqIy.default).of("Fields"));
        if (fields instanceof (0, $joN8z.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $9ab23d4939782527$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $f1113a8ba3b3d35a$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $0f1722da3d8b388a$export$2e2bcd8739ae039)) pushFields((0, $f1113a8ba3b3d35a$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $iqqIy.default).of("Fields"), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $f260eebdeee2a02c$export$2e2bcd8739ae039 = $f260eebdeee2a02c$var$PDFAcroForm;














var $3QSuJ = parcelRequire("3QSuJ");
var $c3efb0b78e769239$var$PDFCatalog = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $iqqIy.default).of("Pages"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $iqqIy.default).of("AcroForm"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $f260eebdeee2a02c$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $f260eebdeee2a02c$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $iqqIy.default).of("AcroForm"), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $iqqIy.default).of("ViewerPreferences"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $3QSuJ.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $3QSuJ.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $iqqIy.default).of("ViewerPreferences"), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $iqqIy.default).of("Pages"));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $iqqIy.default).of("Type"), (0, $iqqIy.default).of("Catalog"));
        dict.set((0, $iqqIy.default).of("Pages"), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $9ab23d4939782527$export$2e2bcd8739ae039));
var $c3efb0b78e769239$export$2e2bcd8739ae039 = $c3efb0b78e769239$var$PDFCatalog;






var $1RwW5 = parcelRequire("1RwW5");

var $joN8z = parcelRequire("joN8z");


var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");


var $dJvqn = parcelRequire("dJvqn");
var $14c63af9936e316a$var$PDFPageTree = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $iqqIy.default).of("Parent"));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $iqqIy.default).of("Kids"), (0, $joN8z.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $iqqIy.default).of("Count"), (0, $3vNQK.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $dJvqn.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $302c9174c68f73e6$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $dJvqn.CorruptPageTreeError)(targetIndex, "insertLeafNode");
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $dJvqn.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $302c9174c68f73e6$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $dJvqn.CorruptPageTreeError)(targetIndex, "removeLeafNode");
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $iqqIy.default).of("Count"), (0, $3vNQK.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $302c9174c68f73e6$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $iqqIy.default).of("Count"), (0, $3vNQK.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $iqqIy.default).of("Type"), (0, $iqqIy.default).of("Pages"));
        dict.set((0, $iqqIy.default).of("Kids"), context.obj([]));
        dict.set((0, $iqqIy.default).of("Count"), context.obj(0));
        if (parent) dict.set((0, $iqqIy.default).of("Parent"), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $9ab23d4939782527$export$2e2bcd8739ae039));
var $14c63af9936e316a$export$2e2bcd8739ae039 = $14c63af9936e316a$var$PDFPageTree;







var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $joN8z = parcelRequire("joN8z");

var $aeaZ4 = parcelRequire("aeaZ4");



var $iqqIy = parcelRequire("iqqIy");


var $3vNQK = parcelRequire("3vNQK");




var $dJvqn = parcelRequire("dJvqn");

var $aGkK2 = parcelRequire("aGkK2");

var $aGkK2 = parcelRequire("aGkK2");
var $6510fc52ff32c562$export$9492c31549e88980 = new Uint8Array(256);
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Zero] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).One] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Two] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Three] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Four] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Five] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Six] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Seven] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Eight] = 1;
$6510fc52ff32c562$export$9492c31549e88980[(0, $aGkK2.default).Nine] = 1;
var $6510fc52ff32c562$export$d438b84505bee68c = new Uint8Array(256);
$6510fc52ff32c562$export$d438b84505bee68c[(0, $aGkK2.default).Period] = 1;
$6510fc52ff32c562$export$d438b84505bee68c[(0, $aGkK2.default).Plus] = 1;
$6510fc52ff32c562$export$d438b84505bee68c[(0, $aGkK2.default).Minus] = 1;
var $6510fc52ff32c562$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $6510fc52ff32c562$var$idx = 0, $6510fc52ff32c562$var$len = 256; $6510fc52ff32c562$var$idx < $6510fc52ff32c562$var$len; $6510fc52ff32c562$var$idx++)$6510fc52ff32c562$export$4d926b029fa61cfe[$6510fc52ff32c562$var$idx] = $6510fc52ff32c562$export$9492c31549e88980[$6510fc52ff32c562$var$idx] || $6510fc52ff32c562$export$d438b84505bee68c[$6510fc52ff32c562$var$idx] ? 1 : 0;



var $1Ian3 = parcelRequire("1Ian3");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $c35afd8be5c5ea12$var$Newline = (0, $aGkK2.default).Newline, $c35afd8be5c5ea12$var$CarriageReturn = (0, $aGkK2.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $c35afd8be5c5ea12$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = "";
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $6510fc52ff32c562$export$9492c31549e88980)[byte]) break;
            value += (0, $equxL.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $dJvqn.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = "";
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $6510fc52ff32c562$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $equxL.charFromCode)(this.bytes.next());
            if (byte === (0, $aGkK2.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $6510fc52ff32c562$export$9492c31549e88980)[byte]) break;
            value += (0, $equxL.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $dJvqn.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $1Ian3.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $c35afd8be5c5ea12$var$Newline || byte === $c35afd8be5c5ea12$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $aGkK2.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $c35afd8be5c5ea12$var$Newline || byte === $c35afd8be5c5ea12$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $c35afd8be5c5ea12$export$2e2bcd8739ae039 = $c35afd8be5c5ea12$var$BaseParser;



var $dJvqn = parcelRequire("dJvqn");


var $aGkK2 = parcelRequire("aGkK2");
// TODO: See how line/col tracking affects performance
var $cd7ffa7e8daa0b9d$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $aGkK2.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $dJvqn.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $660f2755f9f0c8aa$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $cd7ffa7e8daa0b9d$export$2e2bcd8739ae039 = $cd7ffa7e8daa0b9d$var$ByteStream;






var $aGkK2 = parcelRequire("aGkK2");

var $gmw8F = parcelRequire("gmw8F");

var $1RwW5 = parcelRequire("1RwW5");

var $aGkK2 = parcelRequire("aGkK2");
var $8f08caf989d0b798$var$Space = (0, $aGkK2.default).Space, $8f08caf989d0b798$var$CarriageReturn = (0, $aGkK2.default).CarriageReturn, $8f08caf989d0b798$var$Newline = (0, $aGkK2.default).Newline;
var $8f08caf989d0b798$var$stream = [
    (0, $aGkK2.default).s,
    (0, $aGkK2.default).t,
    (0, $aGkK2.default).r,
    (0, $aGkK2.default).e,
    (0, $aGkK2.default).a,
    (0, $aGkK2.default).m
];
var $8f08caf989d0b798$var$endstream = [
    (0, $aGkK2.default).e,
    (0, $aGkK2.default).n,
    (0, $aGkK2.default).d,
    (0, $aGkK2.default).s,
    (0, $aGkK2.default).t,
    (0, $aGkK2.default).r,
    (0, $aGkK2.default).e,
    (0, $aGkK2.default).a,
    (0, $aGkK2.default).m
];
var $8f08caf989d0b798$export$93ad50ccfacdd77 = {
    header: [
        (0, $aGkK2.default).Percent,
        (0, $aGkK2.default).P,
        (0, $aGkK2.default).D,
        (0, $aGkK2.default).F,
        (0, $aGkK2.default).Dash
    ],
    eof: [
        (0, $aGkK2.default).Percent,
        (0, $aGkK2.default).Percent,
        (0, $aGkK2.default).E,
        (0, $aGkK2.default).O,
        (0, $aGkK2.default).F
    ],
    obj: [
        (0, $aGkK2.default).o,
        (0, $aGkK2.default).b,
        (0, $aGkK2.default).j
    ],
    endobj: [
        (0, $aGkK2.default).e,
        (0, $aGkK2.default).n,
        (0, $aGkK2.default).d,
        (0, $aGkK2.default).o,
        (0, $aGkK2.default).b,
        (0, $aGkK2.default).j
    ],
    xref: [
        (0, $aGkK2.default).x,
        (0, $aGkK2.default).r,
        (0, $aGkK2.default).e,
        (0, $aGkK2.default).f
    ],
    trailer: [
        (0, $aGkK2.default).t,
        (0, $aGkK2.default).r,
        (0, $aGkK2.default).a,
        (0, $aGkK2.default).i,
        (0, $aGkK2.default).l,
        (0, $aGkK2.default).e,
        (0, $aGkK2.default).r
    ],
    startxref: [
        (0, $aGkK2.default).s,
        (0, $aGkK2.default).t,
        (0, $aGkK2.default).a,
        (0, $aGkK2.default).r,
        (0, $aGkK2.default).t,
        (0, $aGkK2.default).x,
        (0, $aGkK2.default).r,
        (0, $aGkK2.default).e,
        (0, $aGkK2.default).f
    ],
    true: [
        (0, $aGkK2.default).t,
        (0, $aGkK2.default).r,
        (0, $aGkK2.default).u,
        (0, $aGkK2.default).e
    ],
    false: [
        (0, $aGkK2.default).f,
        (0, $aGkK2.default).a,
        (0, $aGkK2.default).l,
        (0, $aGkK2.default).s,
        (0, $aGkK2.default).e
    ],
    null: [
        (0, $aGkK2.default).n,
        (0, $aGkK2.default).u,
        (0, $aGkK2.default).l,
        (0, $aGkK2.default).l
    ],
    stream: $8f08caf989d0b798$var$stream,
    streamEOF1: (0, $1RwW5.__spreadArrays)($8f08caf989d0b798$var$stream, [
        $8f08caf989d0b798$var$Space,
        $8f08caf989d0b798$var$CarriageReturn,
        $8f08caf989d0b798$var$Newline
    ]),
    streamEOF2: (0, $1RwW5.__spreadArrays)($8f08caf989d0b798$var$stream, [
        $8f08caf989d0b798$var$CarriageReturn,
        $8f08caf989d0b798$var$Newline
    ]),
    streamEOF3: (0, $1RwW5.__spreadArrays)($8f08caf989d0b798$var$stream, [
        $8f08caf989d0b798$var$CarriageReturn
    ]),
    streamEOF4: (0, $1RwW5.__spreadArrays)($8f08caf989d0b798$var$stream, [
        $8f08caf989d0b798$var$Newline
    ]),
    endstream: $8f08caf989d0b798$var$endstream,
    EOF1endstream: (0, $1RwW5.__spreadArrays)([
        $8f08caf989d0b798$var$CarriageReturn,
        $8f08caf989d0b798$var$Newline
    ], $8f08caf989d0b798$var$endstream),
    EOF2endstream: (0, $1RwW5.__spreadArrays)([
        $8f08caf989d0b798$var$CarriageReturn
    ], $8f08caf989d0b798$var$endstream),
    EOF3endstream: (0, $1RwW5.__spreadArrays)([
        $8f08caf989d0b798$var$Newline
    ], $8f08caf989d0b798$var$endstream)
};




var $1Ian3 = parcelRequire("1Ian3");
parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
// TODO: Throw error if eof is reached before finishing object parse...
var $0a4edfefeb8a2019$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).true)) return (0, $aeaZ4.default).True;
        if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).false)) return (0, $aeaZ4.default).False;
        if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).null)) return 0, $4fa296e6a51e8ed5$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $aGkK2.default).LessThan && this.bytes.peekAhead(1) === (0, $aGkK2.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $aGkK2.default).LessThan) return this.parseHexString();
        if (byte === (0, $aGkK2.default).LeftParen) return this.parseString();
        if (byte === (0, $aGkK2.default).ForwardSlash) return this.parseName();
        if (byte === (0, $aGkK2.default).LeftSquareBracket) return this.parseArray();
        if ((0, $6510fc52ff32c562$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $dJvqn.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $6510fc52ff32c562$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $aGkK2.default).R) {
                this.bytes.assertNext((0, $aGkK2.default).R);
                return (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $3vNQK.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = "";
        this.bytes.assertNext((0, $aGkK2.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $aGkK2.default).GreaterThan)value += (0, $equxL.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $aGkK2.default).GreaterThan);
        return (0, $83374afbe9879719$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = "";
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $equxL.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $aGkK2.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $aGkK2.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $aGkK2.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $dJvqn.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $aGkK2.default).ForwardSlash);
        var name = "";
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $1Ian3.IsWhitespace)[byte] || (0, $gmw8F.IsDelimiter)[byte]) break;
            name += (0, $equxL.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $iqqIy.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $aGkK2.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $joN8z.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $aGkK2.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $aGkK2.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $aGkK2.default).LessThan);
        this.bytes.assertNext((0, $aGkK2.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $aGkK2.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $aGkK2.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $aGkK2.default).GreaterThan);
        this.bytes.assertNext((0, $aGkK2.default).GreaterThan);
        var Type = dict.get((0, $iqqIy.default).of("Type"));
        if (Type === (0, $iqqIy.default).of("Catalog")) return (0, $c3efb0b78e769239$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $iqqIy.default).of("Pages")) return (0, $14c63af9936e316a$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $iqqIy.default).of("Page")) return (0, $302c9174c68f73e6$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $9ab23d4939782527$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $iqqIy.default).of("Length"));
        if (Length instanceof (0, $3vNQK.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $f3af422d5f07580f$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $dJvqn.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $cd7ffa7e8daa0b9d$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $c35afd8be5c5ea12$export$2e2bcd8739ae039));
var $0a4edfefeb8a2019$export$2e2bcd8739ae039 = $0a4edfefeb8a2019$var$PDFObjectParser;



var $1RwW5 = parcelRequire("1RwW5");

var $dJvqn = parcelRequire("dJvqn");

var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");



parcelRequire("3Iuzo");
var $2O2jP = parcelRequire("2O2jP");
var $cc2b6fe6a3933bc2$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $cd7ffa7e8daa0b9d$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $iqqIy.default).of("First"), (0, $3vNQK.default)).asNumber();
        _this.objectCount = dict.lookup((0, $iqqIy.default).of("N"), (0, $3vNQK.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $dJvqn.ReparseError)("PDFObjectStreamParser", "parseIntoContext");
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $0a4edfefeb8a2019$export$2e2bcd8739ae039));
var $cc2b6fe6a3933bc2$export$2e2bcd8739ae039 = $cc2b6fe6a3933bc2$var$PDFObjectStreamParser;



var $1RwW5 = parcelRequire("1RwW5");




var $dJvqn = parcelRequire("dJvqn");



var $iqqIy = parcelRequire("iqqIy");






var $dJvqn = parcelRequire("dJvqn");

var $joN8z = parcelRequire("joN8z");

var $iqqIy = parcelRequire("iqqIy");

var $3vNQK = parcelRequire("3vNQK");


var $0b6516fe9ab7c8d5$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $cd7ffa7e8daa0b9d$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $iqqIy.default).of("Size"), (0, $3vNQK.default));
        var Index = this.dict.lookup((0, $iqqIy.default).of("Index"));
        if (Index instanceof (0, $joN8z.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $3vNQK.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $3vNQK.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $iqqIy.default).of("W"), (0, $joN8z.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $3vNQK.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $dJvqn.ReparseError)("PDFXRefStreamParser", "parseIntoContext");
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $iqqIy.default).of("Root")),
            Encrypt: this.dict.get((0, $iqqIy.default).of("Encrypt")),
            Info: this.dict.get((0, $iqqIy.default).of("Info")),
            ID: this.dict.get((0, $iqqIy.default).of("ID"))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $0b6516fe9ab7c8d5$export$2e2bcd8739ae039 = $0b6516fe9ab7c8d5$var$PDFXRefStreamParser;




var $aGkK2 = parcelRequire("aGkK2");


parcelRequire("3Iuzo");
var $2O2jP = parcelRequire("2O2jP");
var $caffe1d62685a180$var$PDFParser = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $cd7ffa7e8daa0b9d$export$2e2bcd8739ae039).of(pdfBytes), (0, $bcf2ef2f9428db1c$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $dJvqn.ReparseError)("PDFParser", "parseDocument");
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $dJvqn.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(0))) {
                            console.warn("Removing parsed object: 0 0 R");
                            this.context.delete((0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039) && obj.lookup((0, $iqqIy.default).of("Type")) === (0, $iqqIy.default).of("Catalog");
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $aGkK2.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $9d5120c628a2c36d$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $dJvqn.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).obj)) throw new (0, $dJvqn.MissingKeywordError)(this.bytes.position(), (0, $8f08caf989d0b798$export$93ad50ccfacdd77).obj);
        return (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $f3af422d5f07580f$export$2e2bcd8739ae039) && object.dict.lookup((0, $iqqIy.default).of("Type")) === (0, $iqqIy.default).of("ObjStm"))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $cc2b6fe6a3933bc2$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $f3af422d5f07580f$export$2e2bcd8739ae039) && object.dict.lookup((0, $iqqIy.default).of("Type")) === (0, $iqqIy.default).of("XRef")) (0, $0b6516fe9ab7c8d5$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $dJvqn.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $8f08caf989d0b798$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $24ad3c29928be025$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $6510fc52ff32c562$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $2O2jP.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $dc36e9f3639c5ac6$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $6510fc52ff32c562$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $aGkK2.default).n || byte === (0, $aGkK2.default).f) {
                var ref = (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $aGkK2.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $iqqIy.default).of("Root")) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $iqqIy.default).of("Encrypt")) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $iqqIy.default).of("Info")) || context.trailerInfo.Info,
            ID: dict.get((0, $iqqIy.default).of("ID")) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $f336eceb9cb22fb8$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $aGkK2.default).Space && byte <= (0, $aGkK2.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $8f08caf989d0b798$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $0a4edfefeb8a2019$export$2e2bcd8739ae039));
var $caffe1d62685a180$export$2e2bcd8739ae039 = $caffe1d62685a180$var$PDFParser;







var $2f8c90105c44d753$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $2f8c90105c44d753$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $2f8c90105c44d753$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $2f8c90105c44d753$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $2f8c90105c44d753$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $2f8c90105c44d753$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $2f8c90105c44d753$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $2f8c90105c44d753$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $2f8c90105c44d753$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $2f8c90105c44d753$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $2f8c90105c44d753$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $2f8c90105c44d753$var$flag(9)] = "LockedContents";
})($2f8c90105c44d753$export$1fa7b68b35026177 || ($2f8c90105c44d753$export$1fa7b68b35026177 = {}));







var $iqqIy = parcelRequire("iqqIy");
var $3vNQK = parcelRequire("3vNQK");
var $7742e0c764b6d545$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $iqqIy.default) ? name : (0, $iqqIy.default).of(name);
};
var $7742e0c764b6d545$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $3vNQK.default) ? num : (0, $3vNQK.default).of(num);
};
var $7742e0c764b6d545$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $3vNQK.default) ? num.asNumber() : num;
};


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $kMOPh = parcelRequire("kMOPh");
var $9087813372121b21$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($9087813372121b21$export$c3cc0f63dbb3500f || ($9087813372121b21$export$c3cc0f63dbb3500f = {}));
var $9087813372121b21$export$8449e153fbd325fc = function(radianAngle) {
    (0, $kqiuD.assertIs)(radianAngle, "radianAngle", [
        "number"
    ]);
    return {
        type: $9087813372121b21$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $9087813372121b21$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $kqiuD.assertIs)(degreeAngle, "degreeAngle", [
        "number"
    ]);
    return {
        type: $9087813372121b21$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $9087813372121b21$var$Radians = $9087813372121b21$export$c3cc0f63dbb3500f.Radians, $9087813372121b21$var$Degrees = $9087813372121b21$export$c3cc0f63dbb3500f.Degrees;
var $9087813372121b21$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $9087813372121b21$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $9087813372121b21$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $9087813372121b21$var$Radians ? rotation.angle : rotation.type === $9087813372121b21$var$Degrees ? $9087813372121b21$export$c9fcf1a7df975d78(rotation.angle) : (0, $kMOPh.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $9087813372121b21$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $9087813372121b21$var$Radians ? $9087813372121b21$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $9087813372121b21$var$Degrees ? rotation.angle : (0, $kMOPh.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $9087813372121b21$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $9087813372121b21$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $9087813372121b21$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $9087813372121b21$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $9087813372121b21$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $91e585bfd8e87555$export$e0b576e7a74416cd = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).ClipNonZero);
};
var $91e585bfd8e87555$export$dd6fb25f201b5a7a = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $91e585bfd8e87555$var$cos = Math.cos, $91e585bfd8e87555$var$sin = Math.sin, $91e585bfd8e87555$var$tan = Math.tan;
var $91e585bfd8e87555$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(a),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(b),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(c),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(d),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(e),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $91e585bfd8e87555$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $91e585bfd8e87555$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $91e585bfd8e87555$export$dcdf75081b88279d = function(xPos, yPos) {
    return $91e585bfd8e87555$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $91e585bfd8e87555$export$a2ba89726971a90f = function(angle) {
    return $91e585bfd8e87555$export$ed5b99ee38154497($91e585bfd8e87555$var$cos((0, $7742e0c764b6d545$export$37576b9ba69b50db)(angle)), $91e585bfd8e87555$var$sin((0, $7742e0c764b6d545$export$37576b9ba69b50db)(angle)), -$91e585bfd8e87555$var$sin((0, $7742e0c764b6d545$export$37576b9ba69b50db)(angle)), $91e585bfd8e87555$var$cos((0, $7742e0c764b6d545$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $91e585bfd8e87555$export$91df22fbff99d059 = function(angle) {
    return $91e585bfd8e87555$export$a2ba89726971a90f((0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(angle)));
};
var $91e585bfd8e87555$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $91e585bfd8e87555$export$ed5b99ee38154497(1, $91e585bfd8e87555$var$tan((0, $7742e0c764b6d545$export$37576b9ba69b50db)(xSkewAngle)), $91e585bfd8e87555$var$tan((0, $7742e0c764b6d545$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $91e585bfd8e87555$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $91e585bfd8e87555$export$985cb1d69d6a3add((0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(xSkewAngle)), (0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(ySkewAngle)));
};
var $91e585bfd8e87555$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)).join(" ") + "]",
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $91e585bfd8e87555$export$d10d019aadfd45c7 = function() {
    return $91e585bfd8e87555$export$e0e900d241274e06([], 0);
};
var $91e585bfd8e87555$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($91e585bfd8e87555$export$7a77bc708e50709e || ($91e585bfd8e87555$export$7a77bc708e50709e = {}));
var $91e585bfd8e87555$export$6c65ed24e870eec = function(style) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $91e585bfd8e87555$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($91e585bfd8e87555$export$cba5d0f1cde60b86 || ($91e585bfd8e87555$export$cba5d0f1cde60b86 = {}));
var $91e585bfd8e87555$export$97dfb3b4509cd5bc = function(style) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $91e585bfd8e87555$export$568567f665d3f3bb = function(state) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $7742e0c764b6d545$export$69d5e1b305482e08)(state)
    ]);
};
var $91e585bfd8e87555$export$cb182c48e35739ac = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).PushGraphicsState);
};
var $91e585bfd8e87555$export$10581a6f45bf75eb = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).PopGraphicsState);
};
var $91e585bfd8e87555$export$558e0f90d8262345 = function(width) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $91e585bfd8e87555$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x1),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y1),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x2),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y2),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x3),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $91e585bfd8e87555$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x1),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y1),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x2),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $91e585bfd8e87555$export$21f87e210c424cd0 = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).ClosePath);
};
var $91e585bfd8e87555$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).MoveTo, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(xPos),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $91e585bfd8e87555$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).LineTo, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(xPos),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $91e585bfd8e87555$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(xPos),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(yPos),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(width),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $91e585bfd8e87555$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $91e585bfd8e87555$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $91e585bfd8e87555$export$d9b706f8d0a70aef = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).StrokePath);
};
var $91e585bfd8e87555$export$9563e054e6f787fb = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).FillNonZero);
};
var $91e585bfd8e87555$export$76d37801baac10fb = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $91e585bfd8e87555$export$d366e9c0a9bd860f = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).EndPath);
};
var $91e585bfd8e87555$export$829ffc2dbe358942 = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).NextLine);
};
var $91e585bfd8e87555$export$b84c1833e225e397 = function(x, y) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).MoveText, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(x),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $91e585bfd8e87555$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $91e585bfd8e87555$export$337b8dbf65fbb95e = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).BeginText);
};
var $91e585bfd8e87555$export$e3caa83a99d72806 = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).EndText);
};
var $91e585bfd8e87555$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $7742e0c764b6d545$export$69d5e1b305482e08)(name),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $91e585bfd8e87555$export$710392ce2617f080 = function(spacing) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $91e585bfd8e87555$export$a2801242b2f8967d = function(spacing) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $91e585bfd8e87555$export$20dbb065c447b4da = function(squeeze) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $91e585bfd8e87555$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $91e585bfd8e87555$export$ad1653459b07f70c = function(rise) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetTextRise, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $91e585bfd8e87555$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($91e585bfd8e87555$export$ca45e4ab114d4814 || ($91e585bfd8e87555$export$ca45e4ab114d4814 = {}));
var $91e585bfd8e87555$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $91e585bfd8e87555$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(a),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(b),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(c),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(d),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(e),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $91e585bfd8e87555$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $91e585bfd8e87555$export$d3656d656af31043($91e585bfd8e87555$var$cos((0, $7742e0c764b6d545$export$37576b9ba69b50db)(rotationAngle)), $91e585bfd8e87555$var$sin((0, $7742e0c764b6d545$export$37576b9ba69b50db)(rotationAngle)) + $91e585bfd8e87555$var$tan((0, $7742e0c764b6d545$export$37576b9ba69b50db)(xSkewAngle)), -$91e585bfd8e87555$var$sin((0, $7742e0c764b6d545$export$37576b9ba69b50db)(rotationAngle)) + $91e585bfd8e87555$var$tan((0, $7742e0c764b6d545$export$37576b9ba69b50db)(ySkewAngle)), $91e585bfd8e87555$var$cos((0, $7742e0c764b6d545$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $91e585bfd8e87555$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $91e585bfd8e87555$export$f567083ac6aa5aa3((0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(rotationAngle)), (0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(xSkewAngle)), (0, $9087813372121b21$export$c9fcf1a7df975d78)((0, $7742e0c764b6d545$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $91e585bfd8e87555$export$382c18f8bccd9e2b = function(name) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).DrawObject, [
        (0, $7742e0c764b6d545$export$69d5e1b305482e08)(name)
    ]);
};
var $91e585bfd8e87555$export$f30201749d00f572 = function(gray) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $91e585bfd8e87555$export$6502921112196b8f = function(gray) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $91e585bfd8e87555$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(red),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(green),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $91e585bfd8e87555$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(red),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(green),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $91e585bfd8e87555$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(cyan),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(magenta),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(yellow),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $91e585bfd8e87555$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(cyan),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(magenta),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(yellow),
        (0, $7742e0c764b6d545$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $91e585bfd8e87555$export$a028b403e40f1ab2 = function(tag) {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $7742e0c764b6d545$export$69d5e1b305482e08)(tag)
    ]);
};
var $91e585bfd8e87555$export$935e2334f5a50589 = function() {
    return (0, $81b82bf3cb721b12$export$2e2bcd8739ae039).of((0, $1330496c55834efa$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $kMOPh = parcelRequire("kMOPh");
var $c14702c24eb19bfa$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($c14702c24eb19bfa$export$4eb09b1c0a6dec24 || ($c14702c24eb19bfa$export$4eb09b1c0a6dec24 = {}));
var $c14702c24eb19bfa$export$6f416a6db2dfcd5c = function(gray) {
    (0, $kqiuD.assertRange)(gray, "gray", 0.0, 1.0);
    return {
        type: $c14702c24eb19bfa$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $c14702c24eb19bfa$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $kqiuD.assertRange)(red, "red", 0, 1);
    (0, $kqiuD.assertRange)(green, "green", 0, 1);
    (0, $kqiuD.assertRange)(blue, "blue", 0, 1);
    return {
        type: $c14702c24eb19bfa$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $c14702c24eb19bfa$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $kqiuD.assertRange)(cyan, "cyan", 0, 1);
    (0, $kqiuD.assertRange)(magenta, "magenta", 0, 1);
    (0, $kqiuD.assertRange)(yellow, "yellow", 0, 1);
    (0, $kqiuD.assertRange)(key, "key", 0, 1);
    return {
        type: $c14702c24eb19bfa$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $c14702c24eb19bfa$var$Grayscale = $c14702c24eb19bfa$export$4eb09b1c0a6dec24.Grayscale, $c14702c24eb19bfa$var$RGB = $c14702c24eb19bfa$export$4eb09b1c0a6dec24.RGB, $c14702c24eb19bfa$var$CMYK = $c14702c24eb19bfa$export$4eb09b1c0a6dec24.CMYK;
var $c14702c24eb19bfa$export$6126e5d7ba707741 = function(color) {
    return color.type === $c14702c24eb19bfa$var$Grayscale ? (0, $91e585bfd8e87555$export$f30201749d00f572)(color.gray) : color.type === $c14702c24eb19bfa$var$RGB ? (0, $91e585bfd8e87555$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $c14702c24eb19bfa$var$CMYK ? (0, $91e585bfd8e87555$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $kMOPh.error)("Invalid color: " + JSON.stringify(color));
};
var $c14702c24eb19bfa$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $c14702c24eb19bfa$var$Grayscale ? (0, $91e585bfd8e87555$export$6502921112196b8f)(color.gray) : color.type === $c14702c24eb19bfa$var$RGB ? (0, $91e585bfd8e87555$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $c14702c24eb19bfa$var$CMYK ? (0, $91e585bfd8e87555$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $kMOPh.error)("Invalid color: " + JSON.stringify(color));
};
var $c14702c24eb19bfa$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $c14702c24eb19bfa$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $c14702c24eb19bfa$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $c14702c24eb19bfa$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $c14702c24eb19bfa$export$ffee2793812e3e56 = function(color) {
    return color.type === $c14702c24eb19bfa$var$Grayscale ? [
        color.gray
    ] : color.type === $c14702c24eb19bfa$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $c14702c24eb19bfa$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $kMOPh.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $7f6af42a8ea49f58$var$cx = 0;
var $7f6af42a8ea49f58$var$cy = 0;
var $7f6af42a8ea49f58$var$px = 0;
var $7f6af42a8ea49f58$var$py = 0;
var $7f6af42a8ea49f58$var$sx = 0;
var $7f6af42a8ea49f58$var$sy = 0;
var $7f6af42a8ea49f58$var$parameters = new Map([
    [
        "A",
        7
    ],
    [
        "a",
        7
    ],
    [
        "C",
        6
    ],
    [
        "c",
        6
    ],
    [
        "H",
        1
    ],
    [
        "h",
        1
    ],
    [
        "L",
        2
    ],
    [
        "l",
        2
    ],
    [
        "M",
        2
    ],
    [
        "m",
        2
    ],
    [
        "Q",
        4
    ],
    [
        "q",
        4
    ],
    [
        "S",
        4
    ],
    [
        "s",
        4
    ],
    [
        "T",
        2
    ],
    [
        "t",
        2
    ],
    [
        "V",
        1
    ],
    [
        "v",
        1
    ],
    [
        "Z",
        0
    ],
    [
        "z",
        0
    ]
]);
var $7f6af42a8ea49f58$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = "";
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($7f6af42a8ea49f58$var$parameters.has(c)) {
            params = $7f6af42a8ea49f58$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = "";
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            " ",
            ","
        ].includes(c) || c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== "e" || c === "." && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === "M") cmd = "L";
                if (cmd === "m") cmd = "l";
            } else args[args.length] = +curArg;
            foundDecimal = c === ".";
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                "-",
                "."
            ].includes(c) ? c : "";
        } else {
            curArg += c;
            if (c === ".") foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === "M") cmd = "L";
            if (cmd === "m") cmd = "l";
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $7f6af42a8ea49f58$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $7f6af42a8ea49f58$var$cx = $7f6af42a8ea49f58$var$cy = $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$sx = $7f6af42a8ea49f58$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $7f6af42a8ea49f58$var$runners[c.cmd] === "function") {
            var cmd = $7f6af42a8ea49f58$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $7f6af42a8ea49f58$var$runners = {
    M: function(a) {
        $7f6af42a8ea49f58$var$cx = a[0];
        $7f6af42a8ea49f58$var$cy = a[1];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        $7f6af42a8ea49f58$var$sx = $7f6af42a8ea49f58$var$cx;
        $7f6af42a8ea49f58$var$sy = $7f6af42a8ea49f58$var$cy;
        return (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    m: function(a) {
        $7f6af42a8ea49f58$var$cx += a[0];
        $7f6af42a8ea49f58$var$cy += a[1];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        $7f6af42a8ea49f58$var$sx = $7f6af42a8ea49f58$var$cx;
        $7f6af42a8ea49f58$var$sy = $7f6af42a8ea49f58$var$cy;
        return (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    C: function(a) {
        $7f6af42a8ea49f58$var$cx = a[4];
        $7f6af42a8ea49f58$var$cy = a[5];
        $7f6af42a8ea49f58$var$px = a[2];
        $7f6af42a8ea49f58$var$py = a[3];
        return (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(a[0] + $7f6af42a8ea49f58$var$cx, a[1] + $7f6af42a8ea49f58$var$cy, a[2] + $7f6af42a8ea49f58$var$cx, a[3] + $7f6af42a8ea49f58$var$cy, a[4] + $7f6af42a8ea49f58$var$cx, a[5] + $7f6af42a8ea49f58$var$cy);
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx + a[2];
        $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy + a[3];
        $7f6af42a8ea49f58$var$cx += a[4];
        $7f6af42a8ea49f58$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($7f6af42a8ea49f58$var$px === null || $7f6af42a8ea49f58$var$py === null) {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx;
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy;
        }
        var cmd = (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)($7f6af42a8ea49f58$var$cx - ($7f6af42a8ea49f58$var$px - $7f6af42a8ea49f58$var$cx), $7f6af42a8ea49f58$var$cy - ($7f6af42a8ea49f58$var$py - $7f6af42a8ea49f58$var$cy), a[0], a[1], a[2], a[3]);
        $7f6af42a8ea49f58$var$px = a[0];
        $7f6af42a8ea49f58$var$py = a[1];
        $7f6af42a8ea49f58$var$cx = a[2];
        $7f6af42a8ea49f58$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($7f6af42a8ea49f58$var$px === null || $7f6af42a8ea49f58$var$py === null) {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx;
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy;
        }
        var cmd = (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)($7f6af42a8ea49f58$var$cx - ($7f6af42a8ea49f58$var$px - $7f6af42a8ea49f58$var$cx), $7f6af42a8ea49f58$var$cy - ($7f6af42a8ea49f58$var$py - $7f6af42a8ea49f58$var$cy), $7f6af42a8ea49f58$var$cx + a[0], $7f6af42a8ea49f58$var$cy + a[1], $7f6af42a8ea49f58$var$cx + a[2], $7f6af42a8ea49f58$var$cy + a[3]);
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx + a[0];
        $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy + a[1];
        $7f6af42a8ea49f58$var$cx += a[2];
        $7f6af42a8ea49f58$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $7f6af42a8ea49f58$var$px = a[0];
        $7f6af42a8ea49f58$var$py = a[1];
        $7f6af42a8ea49f58$var$cx = a[2];
        $7f6af42a8ea49f58$var$cy = a[3];
        return (0, $91e585bfd8e87555$export$6f4913b22432f892)(a[0], a[1], $7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    q: function(a) {
        var cmd = (0, $91e585bfd8e87555$export$6f4913b22432f892)(a[0] + $7f6af42a8ea49f58$var$cx, a[1] + $7f6af42a8ea49f58$var$cy, a[2] + $7f6af42a8ea49f58$var$cx, a[3] + $7f6af42a8ea49f58$var$cy);
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx + a[0];
        $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy + a[1];
        $7f6af42a8ea49f58$var$cx += a[2];
        $7f6af42a8ea49f58$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($7f6af42a8ea49f58$var$px === null || $7f6af42a8ea49f58$var$py === null) {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx;
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy;
        } else {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx - ($7f6af42a8ea49f58$var$px - $7f6af42a8ea49f58$var$cx);
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy - ($7f6af42a8ea49f58$var$py - $7f6af42a8ea49f58$var$cy);
        }
        var cmd = (0, $91e585bfd8e87555$export$6f4913b22432f892)($7f6af42a8ea49f58$var$px, $7f6af42a8ea49f58$var$py, a[0], a[1]);
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx - ($7f6af42a8ea49f58$var$px - $7f6af42a8ea49f58$var$cx);
        $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy - ($7f6af42a8ea49f58$var$py - $7f6af42a8ea49f58$var$cy);
        $7f6af42a8ea49f58$var$cx = a[0];
        $7f6af42a8ea49f58$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($7f6af42a8ea49f58$var$px === null || $7f6af42a8ea49f58$var$py === null) {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx;
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy;
        } else {
            $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$cx - ($7f6af42a8ea49f58$var$px - $7f6af42a8ea49f58$var$cx);
            $7f6af42a8ea49f58$var$py = $7f6af42a8ea49f58$var$cy - ($7f6af42a8ea49f58$var$py - $7f6af42a8ea49f58$var$cy);
        }
        var cmd = (0, $91e585bfd8e87555$export$6f4913b22432f892)($7f6af42a8ea49f58$var$px, $7f6af42a8ea49f58$var$py, $7f6af42a8ea49f58$var$cx + a[0], $7f6af42a8ea49f58$var$cy + a[1]);
        $7f6af42a8ea49f58$var$cx += a[0];
        $7f6af42a8ea49f58$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $7f6af42a8ea49f58$var$solveArc($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy, a);
        $7f6af42a8ea49f58$var$cx = a[5];
        $7f6af42a8ea49f58$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $7f6af42a8ea49f58$var$cx;
        a[6] += $7f6af42a8ea49f58$var$cy;
        var cmds = $7f6af42a8ea49f58$var$solveArc($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy, a);
        $7f6af42a8ea49f58$var$cx = a[5];
        $7f6af42a8ea49f58$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $7f6af42a8ea49f58$var$cx = a[0];
        $7f6af42a8ea49f58$var$cy = a[1];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    l: function(a) {
        $7f6af42a8ea49f58$var$cx += a[0];
        $7f6af42a8ea49f58$var$cy += a[1];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    H: function(a) {
        $7f6af42a8ea49f58$var$cx = a[0];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    h: function(a) {
        $7f6af42a8ea49f58$var$cx += a[0];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    V: function(a) {
        $7f6af42a8ea49f58$var$cy = a[0];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    v: function(a) {
        $7f6af42a8ea49f58$var$cy += a[0];
        $7f6af42a8ea49f58$var$px = $7f6af42a8ea49f58$var$py = null;
        return (0, $91e585bfd8e87555$export$73abee0cf983cb99)($7f6af42a8ea49f58$var$cx, $7f6af42a8ea49f58$var$cy);
    },
    Z: function() {
        var cmd = (0, $91e585bfd8e87555$export$21f87e210c424cd0)();
        $7f6af42a8ea49f58$var$cx = $7f6af42a8ea49f58$var$sx;
        $7f6af42a8ea49f58$var$cy = $7f6af42a8ea49f58$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $91e585bfd8e87555$export$21f87e210c424cd0)();
        $7f6af42a8ea49f58$var$cx = $7f6af42a8ea49f58$var$sx;
        $7f6af42a8ea49f58$var$cy = $7f6af42a8ea49f58$var$sy;
        return cmd;
    }
};
var $7f6af42a8ea49f58$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $7f6af42a8ea49f58$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $7f6af42a8ea49f58$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $91e585bfd8e87555$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $7f6af42a8ea49f58$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $7f6af42a8ea49f58$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $7f6af42a8ea49f58$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $7f6af42a8ea49f58$var$px * $7f6af42a8ea49f58$var$px / (rx * rx) + $7f6af42a8ea49f58$var$py * $7f6af42a8ea49f58$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $7f6af42a8ea49f58$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $7f6af42a8ea49f58$export$8de5166f0a5bde2a = function(path) {
    return $7f6af42a8ea49f58$var$apply($7f6af42a8ea49f58$var$parse(path));
};



var $6adb43bb58413115$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        (0, $91e585bfd8e87555$export$337b8dbf65fbb95e)(),
        (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        (0, $91e585bfd8e87555$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $91e585bfd8e87555$export$f567083ac6aa5aa3)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate), (0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $91e585bfd8e87555$export$778bfc3c1a2b7ba4)(line),
        (0, $91e585bfd8e87555$export$e3caa83a99d72806)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        (0, $91e585bfd8e87555$export$337b8dbf65fbb95e)(),
        (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        (0, $91e585bfd8e87555$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $91e585bfd8e87555$export$79399e66b6bb212c)(options.lineHeight),
        (0, $91e585bfd8e87555$export$f567083ac6aa5aa3)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate), (0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $91e585bfd8e87555$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $91e585bfd8e87555$export$829ffc2dbe358942)());
    operators.push((0, $91e585bfd8e87555$export$e3caa83a99d72806)(), (0, $91e585bfd8e87555$export$10581a6f45bf75eb)());
    return operators;
};
var $6adb43bb58413115$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $91e585bfd8e87555$export$a2ba89726971a90f)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate)),
        (0, $91e585bfd8e87555$export$dcdf75081b88279d)(options.width, options.height),
        (0, $91e585bfd8e87555$export$985cb1d69d6a3add)((0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew)),
        (0, $91e585bfd8e87555$export$382c18f8bccd9e2b)(name),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $91e585bfd8e87555$export$a2ba89726971a90f)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate)),
        (0, $91e585bfd8e87555$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $91e585bfd8e87555$export$985cb1d69d6a3add)((0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew)),
        (0, $91e585bfd8e87555$export$382c18f8bccd9e2b)(name),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c14702c24eb19bfa$export$ae31e5cacc8bb23d)(options.color),
        (0, $91e585bfd8e87555$export$558e0f90d8262345)(options.thickness),
        (0, $91e585bfd8e87555$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $91e585bfd8e87555$export$6c65ed24e870eec)(options.lineCap),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $91e585bfd8e87555$export$d9b706f8d0a70aef)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c14702c24eb19bfa$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $91e585bfd8e87555$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $91e585bfd8e87555$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $91e585bfd8e87555$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $91e585bfd8e87555$export$a2ba89726971a90f)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate)),
        (0, $91e585bfd8e87555$export$985cb1d69d6a3add)((0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew)),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(0, 0),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(0, options.height),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(options.width, options.height),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(options.width, 0),
        (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $91e585bfd8e87555$export$76d37801baac10fb)() : options.color ? (0, $91e585bfd8e87555$export$9563e054e6f787fb)() : options.borderColor ? (0, $91e585bfd8e87555$export$d9b706f8d0a70aef)() : (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $6adb43bb58413115$export$f219d5f4b18063ad = function(config) {
    var x = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.x);
    var y = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $6adb43bb58413115$var$KAPPA;
    var oy = yScale * $6adb43bb58413115$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(x, ym),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ];
};
var $6adb43bb58413115$var$drawEllipseCurves = function(config) {
    var centerX = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $6adb43bb58413115$var$KAPPA;
    var oy = yScale * $6adb43bb58413115$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $91e585bfd8e87555$export$a2ba89726971a90f)((0, $9087813372121b21$export$cba01ba138429a1d)(config.rotate)),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(x, ym),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $91e585bfd8e87555$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $6adb43bb58413115$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c14702c24eb19bfa$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $91e585bfd8e87555$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $91e585bfd8e87555$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $91e585bfd8e87555$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $6adb43bb58413115$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $6adb43bb58413115$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $91e585bfd8e87555$export$76d37801baac10fb)() : options.color ? (0, $91e585bfd8e87555$export$9563e054e6f787fb)() : options.borderColor ? (0, $91e585bfd8e87555$export$d9b706f8d0a70aef)() : (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $6adb43bb58413115$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $91e585bfd8e87555$export$568567f665d3f3bb)(options.graphicsState),
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $91e585bfd8e87555$export$a2ba89726971a90f)((0, $9087813372121b21$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $9087813372121b21$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $91e585bfd8e87555$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $91e585bfd8e87555$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $c14702c24eb19bfa$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $91e585bfd8e87555$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $91e585bfd8e87555$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $91e585bfd8e87555$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $7f6af42a8ea49f58$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $91e585bfd8e87555$export$76d37801baac10fb)() : options.color ? (0, $91e585bfd8e87555$export$9563e054e6f787fb)() : options.borderColor ? (0, $91e585bfd8e87555$export$d9b706f8d0a70aef)() : (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $6adb43bb58413115$export$695703ffa02b3ffb = function(options) {
    var size = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
        options.color && (0, $c14702c24eb19bfa$export$ae31e5cacc8bb23d)(options.color),
        (0, $91e585bfd8e87555$export$558e0f90d8262345)(options.thickness),
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $91e585bfd8e87555$export$d9b706f8d0a70aef)(),
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $6adb43bb58413115$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(0, 0),
        (0, $91e585bfd8e87555$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $91e585bfd8e87555$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $91e585bfd8e87555$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(0, options.height),
        (0, $91e585bfd8e87555$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $6adb43bb58413115$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $6adb43bb58413115$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.width);
    var height = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $6adb43bb58413115$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]);
};
var $6adb43bb58413115$export$d01bb537f184a293 = function(options) {
    var width = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.width);
    var height = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $6adb43bb58413115$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $6adb43bb58413115$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]);
};
var $6adb43bb58413115$export$31046eb8c5070d92 = function(options) {
    var x = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.x);
    var y = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.y);
    var width = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.width);
    var height = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.height);
    var background = $6adb43bb58413115$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    var lines = $6adb43bb58413115$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]);
};
var $6adb43bb58413115$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $91e585bfd8e87555$export$337b8dbf65fbb95e)(),
        (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(options.color),
        (0, $91e585bfd8e87555$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $91e585bfd8e87555$export$f567083ac6aa5aa3)((0, $9087813372121b21$export$cba01ba138429a1d)(options.rotate), (0, $9087813372121b21$export$cba01ba138429a1d)(options.xSkew), (0, $9087813372121b21$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $91e585bfd8e87555$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $91e585bfd8e87555$export$e3caa83a99d72806)());
    return operators;
};
var $6adb43bb58413115$export$7d8517ad99905084 = function(options) {
    var x = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.x);
    var y = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.y);
    var width = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.width);
    var height = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        (0, $91e585bfd8e87555$export$e0b576e7a74416cd)(),
        (0, $91e585bfd8e87555$export$d366e9c0a9bd860f)()
    ];
    var background = $6adb43bb58413115$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    var lines = $6adb43bb58413115$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$a028b403e40f1ab2)("Tx"),
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], lines, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)(),
        (0, $91e585bfd8e87555$export$935e2334f5a50589)()
    ]);
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]);
};
var $6adb43bb58413115$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.x);
    var y = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.y);
    var width = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.width);
    var height = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $7742e0c764b6d545$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $91e585bfd8e87555$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $91e585bfd8e87555$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $91e585bfd8e87555$export$21f87e210c424cd0)(),
        (0, $91e585bfd8e87555$export$e0b576e7a74416cd)(),
        (0, $91e585bfd8e87555$export$d366e9c0a9bd860f)()
    ];
    var background = $6adb43bb58413115$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $6adb43bb58413115$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $6adb43bb58413115$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
        ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$a028b403e40f1ab2)("Tx"),
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], lines, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)(),
        (0, $91e585bfd8e87555$export$935e2334f5a50589)()
    ]);
    return (0, $1RwW5.__spreadArrays)([
        (0, $91e585bfd8e87555$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $1RwW5 = parcelRequire("1RwW5");
// TODO: Include link to documentation with example
var $6f6e7a6c2ffe413f$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = "Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $6f6e7a6c2ffe413f$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = "Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $6f6e7a6c2ffe413f$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = "A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $6f6e7a6c2ffe413f$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = "PDFDocument has no pages so `PDFDocument.removePage` cannot be called";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $6f6e7a6c2ffe413f$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = 'PDFDocument has no form field with the name "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $6f6e7a6c2ffe413f$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = 'Expected field "' + name + '" to be of type ' + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $6f6e7a6c2ffe413f$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = 'Failed to select check box due to missing onValue: "' + onValue + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $6f6e7a6c2ffe413f$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = 'A field already exists with the specified name: "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $6f6e7a6c2ffe413f$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = 'Field name contains invalid component: "' + namePart + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $6f6e7a6c2ffe413f$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = 'A non-terminal field already exists with the specified name: "' + name + '"';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $6f6e7a6c2ffe413f$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $6f6e7a6c2ffe413f$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $6f6e7a6c2ffe413f$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $6f6e7a6c2ffe413f$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $b13d9a72faafa782$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($b13d9a72faafa782$export$84b2d1b68830363f || ($b13d9a72faafa782$export$84b2d1b68830363f = {}));


parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $bd0e221f04ec79d1$var$MIN_FONT_SIZE = 4;
var $bd0e221f04ec79d1$var$MAX_FONT_SIZE = 500;
var $bd0e221f04ec79d1$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $bd0e221f04ec79d1$var$MIN_FONT_SIZE;
    while(fontSize < $bd0e221f04ec79d1$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(" ");
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + " ";
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $bd0e221f04ec79d1$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $bd0e221f04ec79d1$var$MIN_FONT_SIZE;
    var chars = (0, $equxL.charSplit)(line);
    while(fontSize < $bd0e221f04ec79d1$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $bd0e221f04ec79d1$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $bd0e221f04ec79d1$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $bd0e221f04ec79d1$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $bd0e221f04ec79d1$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $equxL.lineSplit)((0, $equxL.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $bd0e221f04ec79d1$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $bd0e221f04ec79d1$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $bd0e221f04ec79d1$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $equxL.mergeLines)((0, $equxL.cleanText)(text));
    if (line.length > cellCount) throw new (0, $6f6e7a6c2ffe413f$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $bd0e221f04ec79d1$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $equxL.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $bd0e221f04ec79d1$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $equxL.mergeLines)((0, $equxL.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $bd0e221f04ec79d1$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("3Iuzo");
var $equxL = parcelRequire("equxL");
var $3ef67fd0f654b344$export$8a3aea031520d39b = function(appearance) {
    if ("normal" in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $3ef67fd0f654b344$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $3ef67fd0f654b344$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
    var daMatch = (_b = (0, $equxL.findLastMatch)(da, $3ef67fd0f654b344$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $3ef67fd0f654b344$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $3ef67fd0f654b344$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
    var daMatch = (0, $equxL.findLastMatch)(da, $3ef67fd0f654b344$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === "g" && c1) return (0, $c14702c24eb19bfa$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === "rg" && c1 && c2 && c3) return (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === "k" && c1 && c2 && c3 && c4) return (0, $c14702c24eb19bfa$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $3ef67fd0f654b344$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(color).toString(),
        (0, $91e585bfd8e87555$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : "dummy__noop", fontSize).toString()
    ].join("\n");
    field.setDefaultAppearance(da);
};
var $3ef67fd0f654b344$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$1c2f7a8d0ec539ab)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$1c2f7a8d0ec539ab)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$1c2f7a8d0ec539ab)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$1c2f7a8d0ec539ab)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $3ef67fd0f654b344$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$d01bb537f184a293)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$d01bb537f184a293)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$d01bb537f184a293)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$d01bb537f184a293)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $3ef67fd0f654b344$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(button.acroField);
    var widgetFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(widget);
    var fieldFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : "";
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : "";
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $bd0e221f04ec79d1$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $bd0e221f04ec79d1$export$c0030606588cf6f2)(downText, {
        alignment: (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$31046eb8c5070d92)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$31046eb8c5070d92)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $3ef67fd0f654b344$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(widget);
    var fieldFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : "";
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $bd0e221f04ec79d1$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $bd0e221f04ec79d1$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $bd0e221f04ec79d1$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$7d8517ad99905084)(options));
};
var $3ef67fd0f654b344$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(widget);
    var fieldFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : "";
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $bd0e221f04ec79d1$export$c0030606588cf6f2)(text, {
        alignment: (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$7d8517ad99905084)(options));
};
var $3ef67fd0f654b344$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $3ef67fd0f654b344$var$getDefaultColor(widget);
    var fieldColor = $3ef67fd0f654b344$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(widget);
    var fieldFontSize = $3ef67fd0f654b344$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $c14702c24eb19bfa$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = "";
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += "\n";
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $bd0e221f04ec79d1$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $3ef67fd0f654b344$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $3ef67fd0f654b344$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $1RwW5 = parcelRequire("1RwW5");

var $1RwW5 = parcelRequire("1RwW5");




var $1RwW5 = parcelRequire("1RwW5");


var $1RwW5 = parcelRequire("1RwW5");


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $9fe9d1e9876159aa$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $kqiuD.assertIs)(ref, "ref", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $kqiuD.assertIs)(embedder, "embedder", [
            [
                (0, $e5537a67d34d93c3$export$2e2bcd8739ae039),
                "PDFPageEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $kqiuD.assertIs)(factor, "factor", [
            "number"
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $9fe9d1e9876159aa$export$2e2bcd8739ae039 = $9fe9d1e9876159aa$var$PDFEmbeddedPage;



var $1RwW5 = parcelRequire("1RwW5");


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $aa8c4ba965c8bda4$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $kqiuD.assertIs)(ref, "ref", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $kqiuD.assertIs)(embedder, "embedder", [
            [
                (0, $ac7b02d65ced7399$export$2e2bcd8739ae039),
                "CustomFontEmbedder"
            ],
            [
                (0, $a818e8311cd0aafa$export$2e2bcd8739ae039),
                "StandardFontEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $kqiuD.assertIs)(text, "text", [
            "string"
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $kqiuD.assertIs)(text, "text", [
            "string"
        ]);
        (0, $kqiuD.assertIs)(size, "size", [
            "number"
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $kqiuD.assertIs)(size, "size", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, "options.descender", [
            "boolean"
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $a818e8311cd0aafa$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $aa8c4ba965c8bda4$export$2e2bcd8739ae039 = $aa8c4ba965c8bda4$var$PDFFont;



var $1RwW5 = parcelRequire("1RwW5");


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $91214de71374288b$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $kqiuD.assertIs)(ref, "ref", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        (0, $kqiuD.assertIs)(embedder, "embedder", [
            [
                (0, $eaa7124f5925770b$export$2e2bcd8739ae039),
                "JpegEmbedder"
            ],
            [
                (0, $7463aa2ac79da73b$export$2e2bcd8739ae039),
                "PngEmbedder"
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $kqiuD.assertIs)(factor, "factor", [
            "number"
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $91214de71374288b$export$2e2bcd8739ae039 = $91214de71374288b$var$PDFImage;




var $1RwW5 = parcelRequire("1RwW5");



var $1RwW5 = parcelRequire("1RwW5");





var $1RwW5 = parcelRequire("1RwW5");




var $dJvqn = parcelRequire("dJvqn");
var $iqqIy = parcelRequire("iqqIy");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $013af8a75e51a9b3$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($013af8a75e51a9b3$export$8efa99ca8f041e7e || ($013af8a75e51a9b3$export$8efa99ca8f041e7e = {}));





var $46a82a1980bd7c8f$export$55643210f1835a35 = function(options) {
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, "options.x", [
        "number"
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, "options.y", [
        "number"
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, "options.width", [
        "number"
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, "options.height", [
        "number"
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, "options.textColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, "options.backgroundColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, "options.borderColor", [
        [
            Object,
            "Color"
        ]
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, "options.borderWidth", [
        "number"
    ]);
    (0, $kqiuD.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, "options.rotate", [
        [
            Object,
            "Rotation"
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $46a82a1980bd7c8f$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $kqiuD.assertIs)(acroField, "acroField", [
            [
                (0, $6d47de64576b5104$export$2e2bcd8739ae039),
                "PDFAcroTerminal"
            ]
        ]);
        (0, $kqiuD.assertIs)(ref, "ref", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : "";
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "needsAppearancesUpdate");
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $dJvqn.MethodNotImplementedError)(this.constructor.name, "defaultUpdateAppearances");
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $9087813372121b21$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $kqiuD.assertMultiple)(degreesAngle, "degreesAngle", 90);
        // Create a widget for this field
        var widget = (0, $9bc860280d8053e3$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $9087813372121b21$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $c14702c24eb19bfa$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $c14702c24eb19bfa$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $2f8c90105c44d753$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $2f8c90105c44d753$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $2f8c90105c44d753$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : "";
            var newDa = da + "\n" + (0, $c14702c24eb19bfa$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $9087813372121b21$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $9087813372121b21$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (0, $9087813372121b21$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix("Image", 10);
        var appearance = (0, $1RwW5.__spreadArrays)(rotate, (0, $6adb43bb58413115$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $iqqIy.default).of("Off"), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $46a82a1980bd7c8f$export$2e2bcd8739ae039 = $46a82a1980bd7c8f$var$PDFField;



var $iqqIy = parcelRequire("iqqIy");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $b71f5e631a5d97b2$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroCheckBox, "acroCheckBox", [
            [
                (0, $366bd3575fe0730a$export$2e2bcd8739ae039),
                "PDFAcroCheckBox"
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $iqqIy.default).of("Yes");
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $iqqIy.default).of("Off"));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $kqiuD.assertIs)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $iqqIy.default).of("Off"));
        this.updateWidgetAppearance(widget, (0, $iqqIy.default).of("Yes"));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $iqqIy.default).of("Yes");
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$e11eab3ac6c06eb0);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $b71f5e631a5d97b2$export$2e2bcd8739ae039 = $b71f5e631a5d97b2$var$PDFCheckBox;



var $1RwW5 = parcelRequire("1RwW5");







parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $7fbf01c2353404d3$var$PDFDropdown = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroComboBox, "acroComboBox", [
            [
                (0, $a23ff55154ff7b90$export$2e2bcd8739ae039),
                "PDFAcroComboBox"
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $kqiuD.assertIs)(options, "options", [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $kqiuD.assertIs)(options, "options", [
            "string",
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $kqiuD.assertIs)(options, "options", [
            "string",
            Array
        ]);
        (0, $kqiuD.assertIs)(merge, "merge", [
            "boolean"
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $kqiuD.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $kqiuD.assertIs)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$90f1ca03d512ec5);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $7fbf01c2353404d3$export$2e2bcd8739ae039 = $7fbf01c2353404d3$var$PDFDropdown;



var $1RwW5 = parcelRequire("1RwW5");







parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $d3da34fe2ba49dd2$var$PDFOptionList = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroListBox, "acroListBox", [
            [
                (0, $eaae09ebc1864895$export$2e2bcd8739ae039),
                "PDFAcroListBox"
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $kqiuD.assertIs)(options, "options", [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $kqiuD.assertIs)(options, "options", [
            "string",
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $kqiuD.assertIs)(options, "options", [
            "string",
            Array
        ]);
        (0, $kqiuD.assertIs)(merge, "merge", [
            "boolean"
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $kqiuD.assertIsSubset)(optionsArr, "option", validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $kqiuD.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $kqiuD.assertIs)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$f9fab495286778d2);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $d3da34fe2ba49dd2$export$2e2bcd8739ae039 = $d3da34fe2ba49dd2$var$PDFOptionList;



var $1RwW5 = parcelRequire("1RwW5");






var $iqqIy = parcelRequire("iqqIy");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $b127946f2261cc89$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroRadioButton, "acroRadioButton", [
            [
                (0, $ca447f5713e88cbf$export$2e2bcd8739ae039),
                "PDFAcroRadioButton"
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $iqqIy.default).of("Off")) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $kqiuD.assertIs)(option, "option", [
            "string"
        ]);
        var validOptions = this.getOptions();
        (0, $kqiuD.assertIsOneOf)(option, "option", validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $iqqIy.default).of("Off"));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $kqiuD.assertIs)(option, "option", [
            "string"
        ]);
        (0, $kqiuD.assertIs)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $iqqIy.default).of("Off"));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$6440094330a99ef8);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $b127946f2261cc89$export$2e2bcd8739ae039 = $b127946f2261cc89$var$PDFRadioGroup;



var $1RwW5 = parcelRequire("1RwW5");


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $e5dcf88ab4f4a0f4$var$PDFSignature = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroSignature, "acroSignature", [
            [
                (0, $bf720ad6e6c2fea4$export$2e2bcd8739ae039),
                "PDFAcroSignature"
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $e5dcf88ab4f4a0f4$export$2e2bcd8739ae039 = $e5dcf88ab4f4a0f4$var$PDFSignature;



var $1RwW5 = parcelRequire("1RwW5");










parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $76c093def3f64d47$var$PDFTextField = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroText, "acroText", [
            [
                (0, $10326d8429dfa0fe$export$2e2bcd8739ae039),
                "PDFAcroText"
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $6f6e7a6c2ffe413f$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $kqiuD.assertOrUndefined)(text, "text", [
            "string"
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $6f6e7a6c2ffe413f$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $b13d9a72faafa782$export$84b2d1b68830363f).Right : (0, $b13d9a72faafa782$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $kqiuD.assertIsOneOf)(alignment, "alignment", (0, $b13d9a72faafa782$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $kqiuD.assertRangeOrUndefined)(maxLength, "maxLength", 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $6f6e7a6c2ffe413f$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Center ? (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $b13d9a72faafa782$export$84b2d1b68830363f).Right ? (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Right : (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $kqiuD.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $87bc4bd3413a26f1$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $kqiuD.assertIs)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!("textColor" in options)) options.textColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("backgroundColor" in options)) options.backgroundColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!("borderColor" in options)) options.borderColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!("borderWidth" in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$42ba95e6b8df3d7);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $76c093def3f64d47$export$2e2bcd8739ae039 = $76c093def3f64d47$var$PDFTextField;




var $7038235c9fe0ffd7$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($7038235c9fe0ffd7$export$7dcb046109e65a3d || ($7038235c9fe0ffd7$export$7dcb046109e65a3d = {}));





var $iqqIy = parcelRequire("iqqIy");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $k9ooy = parcelRequire("k9ooy");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $9aed74cef8b9b9cc$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $7038235c9fe0ffd7$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $kqiuD.assertIs)(acroForm, "acroForm", [
            [
                (0, $f260eebdeee2a02c$export$2e2bcd8739ae039),
                "PDFAcroForm"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $k9ooy.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $iqqIy.default).of("XFA"));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $iqqIy.default).of("XFA"));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $9aed74cef8b9b9cc$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $c82e2cce13fd9b58$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $c82e2cce13fd9b58$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $b71f5e631a5d97b2$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $b71f5e631a5d97b2$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $7fbf01c2353404d3$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $7fbf01c2353404d3$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $d3da34fe2ba49dd2$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $d3da34fe2ba49dd2$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $b127946f2261cc89$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $b127946f2261cc89$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $e5dcf88ab4f4a0f4$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $e5dcf88ab4f4a0f4$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $76c093def3f64d47$export$2e2bcd8739ae039)) return field;
        throw new (0, $6f6e7a6c2ffe413f$export$8909da6c566ff652)(name, (0, $76c093def3f64d47$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $5e596fab1c09e732$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $c82e2cce13fd9b58$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $366bd3575fe0730a$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $b71f5e631a5d97b2$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $a23ff55154ff7b90$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $7fbf01c2353404d3$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $eaae09ebc1864895$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $d3da34fe2ba49dd2$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $ca447f5713e88cbf$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $b127946f2261cc89$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        var nameParts = $9aed74cef8b9b9cc$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $10326d8429dfa0fe$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $9aed74cef8b9b9cc$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $76c093def3f64d47$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject("FlatWidget", widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $1RwW5.__spreadArrays)([
                    (0, $91e585bfd8e87555$export$cb182c48e35739ac)(),
                    (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $6adb43bb58413115$export$5dd9a0a87f38a2a6)((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $91e585bfd8e87555$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $91e585bfd8e87555$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $kqiuD.assertOrUndefined)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $kqiuD.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $kqiuD.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $kqiuD.assertOrUndefined)(fieldRef, "fieldRef", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error("Could not find PDFRef for PDFObject");
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039) && (field instanceof (0, $b71f5e631a5d97b2$export$2e2bcd8739ae039) || field instanceof (0, $b127946f2261cc89$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $iqqIy.default).of("Off"));
            if (ref instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $2544783d06ee48ba$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $6f6e7a6c2ffe413f$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $0f1722da3d8b388a$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $f260eebdeee2a02c$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $f1113a8ba3b3d35a$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $0f1722da3d8b388a$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $6f6e7a6c2ffe413f$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $9aed74cef8b9b9cc$export$2e2bcd8739ae039 = $9aed74cef8b9b9cc$var$PDFForm;
var $9aed74cef8b9b9cc$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $5e596fab1c09e732$export$2e2bcd8739ae039)) return (0, $c82e2cce13fd9b58$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $366bd3575fe0730a$export$2e2bcd8739ae039)) return (0, $b71f5e631a5d97b2$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $a23ff55154ff7b90$export$2e2bcd8739ae039)) return (0, $7fbf01c2353404d3$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $eaae09ebc1864895$export$2e2bcd8739ae039)) return (0, $d3da34fe2ba49dd2$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $10326d8429dfa0fe$export$2e2bcd8739ae039)) return (0, $76c093def3f64d47$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $ca447f5713e88cbf$export$2e2bcd8739ae039)) return (0, $b127946f2261cc89$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $bf720ad6e6c2fea4$export$2e2bcd8739ae039)) return (0, $e5dcf88ab4f4a0f4$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $9aed74cef8b9b9cc$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error("PDF field names must not be empty strings");
    var parts = fullyQualifiedName.split(".");
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === "") throw new Error('Periods in PDF field names must be separated by at least one character: "' + fullyQualifiedName + '"');
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $9aed74cef8b9b9cc$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $f1113a8ba3b3d35a$export$34b4fb8893136c4c)("Kids" in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $6f6e7a6c2ffe413f$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $13ff7b13daacac10$export$b4a05ae367f5515c = {
    "4A0": [
        4767.87,
        6740.79
    ],
    "2A0": [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $dJvqn = parcelRequire("dJvqn");
var $iqqIy = parcelRequire("iqqIy");
var $0fe13793b1765f8f$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($0fe13793b1765f8f$export$ba19d141a3749548 || ($0fe13793b1765f8f$export$ba19d141a3749548 = {}));


parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $k9ooy = parcelRequire("k9ooy");
var $hOX8d = parcelRequire("hOX8d");
var $6dc53 = parcelRequire("6dc53");
var $dhfaG = parcelRequire("dhfaG");


var $1RwW5 = parcelRequire("1RwW5");

var $joN8z = parcelRequire("joN8z");
var $iqqIy = parcelRequire("iqqIy");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $88a26a3ae517f0bf$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $iqqIy.default).of("Names"))) this.doc.catalog.set((0, $iqqIy.default).of("Names"), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $iqqIy.default).of("Names"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
                        if (!Names.has((0, $iqqIy.default).of("EmbeddedFiles"))) Names.set((0, $iqqIy.default).of("EmbeddedFiles"), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $iqqIy.default).of("EmbeddedFiles"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $iqqIy.default).of("Names"))) EmbeddedFiles.set((0, $iqqIy.default).of("Names"), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $iqqIy.default).of("Names"), (0, $joN8z.default));
                        EFNames.push((0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $iqqIy.default).of("AF"))) this.doc.catalog.set((0, $iqqIy.default).of("AF"), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $iqqIy.default).of("AF"), (0, $joN8z.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $88a26a3ae517f0bf$export$2e2bcd8739ae039 = $88a26a3ae517f0bf$var$PDFEmbeddedFile;



var $1RwW5 = parcelRequire("1RwW5");

var $joN8z = parcelRequire("joN8z");
var $iqqIy = parcelRequire("iqqIy");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $adb439d23e7ecd61$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $iqqIy.default).of("Names"))) catalog.set((0, $iqqIy.default).of("Names"), context.obj({}));
                        Names = catalog.lookup((0, $iqqIy.default).of("Names"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
                        if (!Names.has((0, $iqqIy.default).of("JavaScript"))) Names.set((0, $iqqIy.default).of("JavaScript"), context.obj({}));
                        Javascript = Names.lookup((0, $iqqIy.default).of("JavaScript"), (0, $9ab23d4939782527$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $iqqIy.default).of("Names"))) Javascript.set((0, $iqqIy.default).of("Names"), context.obj([]));
                        JSNames = Javascript.lookup((0, $iqqIy.default).of("Names"), (0, $joN8z.default));
                        JSNames.push((0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $adb439d23e7ecd61$export$2e2bcd8739ae039 = $adb439d23e7ecd61$var$PDFJavaScript;



var $1RwW5 = parcelRequire("1RwW5");

var $fee3787ba1fa5bbc$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $1RwW5.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: "Action",
                    S: "JavaScript",
                    JS: (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $fee3787ba1fa5bbc$export$2e2bcd8739ae039 = $fee3787ba1fa5bbc$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $7dbd2d7fa8dcdf9e$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            " "
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $302c9174c68f73e6$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $9897d120e9ff26bb$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $9aed74cef8b9b9cc$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $kqiuD.assertIs)(context, "context", [
            [
                (0, $bcf2ef2f9428db1c$export$2e2bcd8739ae039),
                "PDFContext"
            ]
        ]);
        (0, $kqiuD.assertIs)(ignoreEncryption, "ignoreEncryption", [
            "boolean"
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $k9ooy.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $k9ooy.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $6f6e7a6c2ffe413f$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $1RwW5.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $0fe13793b1765f8f$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $kqiuD.assertIs)(pdf, "pdf", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $kqiuD.assertIs)(ignoreEncryption, "ignoreEncryption", [
                            "boolean"
                        ]);
                        (0, $kqiuD.assertIs)(parseSpeed, "parseSpeed", [
                            "number"
                        ]);
                        (0, $kqiuD.assertIs)(throwOnInvalidObject, "throwOnInvalidObject", [
                            "boolean"
                        ]);
                        bytes = (0, $hOX8d.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $caffe1d62685a180$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $1RwW5.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $bcf2ef2f9428db1c$export$2e2bcd8739ae039).create();
                pageTree = (0, $14c63af9936e316a$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $c3efb0b78e769239$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn("Removing XFA form data as pdf-lib does not support reading or writing XFA");
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $iqqIy.default).Title);
        if (!title) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $iqqIy.default).Author);
        if (!author) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $iqqIy.default).Subject);
        if (!subject) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $iqqIy.default).Keywords);
        if (!keywords) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $iqqIy.default).Creator);
        if (!creator) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $iqqIy.default).Producer);
        if (!producer) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $iqqIy.default).CreationDate);
        if (!creationDate) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $iqqIy.default).ModDate);
        if (!modificationDate) return undefined;
        $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $kqiuD.assertIs)(title, "title", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Title");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $kqiuD.assertIs)(author, "author", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Author");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $kqiuD.assertIs)(subject, "author", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Subject");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $kqiuD.assertIs)(keywords, "keywords", [
            Array
        ]);
        var key = (0, $iqqIy.default).of("Keywords");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(keywords.join(" ")));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $kqiuD.assertIs)(creator, "creator", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Creator");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $kqiuD.assertIs)(producer, "creator", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Producer");
        this.getInfoDict().set(key, (0, $83374afbe9879719$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $kqiuD.assertIs)(language, "language", [
            "string"
        ]);
        var key = (0, $iqqIy.default).of("Lang");
        this.catalog.set(key, (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $kqiuD.assertIs)(creationDate, "creationDate", [
            [
                Date,
                "Date"
            ]
        ]);
        var key = (0, $iqqIy.default).of("CreationDate");
        this.getInfoDict().set(key, (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $kqiuD.assertIs)(modificationDate, "modificationDate", [
            [
                Date,
                "Date"
            ]
        ]);
        var key = (0, $iqqIy.default).of("ModDate");
        this.getInfoDict().set(key, (0, $03aa38dbd8969f43$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $kqiuD.assertRange)(index, "index", 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $hOX8d.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $6f6e7a6c2ffe413f$export$cdca06c5927ddc2d)();
        (0, $kqiuD.assertRange)(index, "index", 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $kqiuD.assertIs)(page, "page", [
            "undefined",
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $kqiuD.assertRange)(index, "index", 0, pageCount);
        (0, $kqiuD.assertIs)(page, "page", [
            "undefined",
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $13ff7b13daacac10$export$b4a05ae367f5515c).A4;
            page = (0, $9897d120e9ff26bb$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $6f6e7a6c2ffe413f$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $kqiuD.assertIs)(srcDoc, "srcDoc", [
                            [
                                PDFDocument,
                                "PDFDocument"
                            ]
                        ]);
                        (0, $kqiuD.assertIs)(indices, "indices", [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $02b1048d3880ea05$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $9897d120e9ff26bb$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $kqiuD.assertIs)(name, "name", [
            "string"
        ]);
        (0, $kqiuD.assertIs)(script, "script", [
            "string"
        ]);
        var embedder = (0, $fee3787ba1fa5bbc$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $adb439d23e7ecd61$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $1RwW5.__generator)(this, function(_a) {
                (0, $kqiuD.assertIs)(attachment, "attachment", [
                    "string",
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $kqiuD.assertIs)(name, "name", [
                    "string"
                ]);
                (0, $kqiuD.assertOrUndefined)(options.mimeType, "mimeType", [
                    "string"
                ]);
                (0, $kqiuD.assertOrUndefined)(options.description, "description", [
                    "string"
                ]);
                (0, $kqiuD.assertOrUndefined)(options.creationDate, "options.creationDate", [
                    Date
                ]);
                (0, $kqiuD.assertOrUndefined)(options.modificationDate, "options.modificationDate", [
                    Date
                ]);
                (0, $kqiuD.assertIsOneOfOrUndefined)(options.afRelationship, "options.afRelationship", (0, $684e3b3e06b271aa$export$c12eac46fbec1b74));
                bytes = (0, $hOX8d.toUint8Array)(attachment);
                embedder = (0, $684e3b3e06b271aa$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $88a26a3ae517f0bf$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $1RwW5.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $kqiuD.assertIs)(font, "font", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $kqiuD.assertIs)(subset, "subset", [
                            "boolean"
                        ]);
                        if (!(0, $dhfaG.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $a818e8311cd0aafa$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $hOX8d.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $hOX8d.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $74b9b066d9e8e864$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $ac7b02d65ced7399$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError("`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`");
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $kqiuD.assertIs)(font, "font", [
            "string"
        ]);
        if (!(0, $dhfaG.isStandardFont)(font)) throw new TypeError("`font` must be one of type `StandardFonts`");
        var embedder = (0, $a818e8311cd0aafa$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $kqiuD.assertIs)(jpg, "jpg", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $hOX8d.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $eaa7124f5925770b$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $91214de71374288b$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $kqiuD.assertIs)(png, "png", [
                            "string",
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $hOX8d.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $7463aa2ac79da73b$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $91214de71374288b$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $kqiuD.assertIs)(pdf, "pdf", [
                            "string",
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                "PDFDocument"
                            ]
                        ]);
                        (0, $kqiuD.assertIs)(indices, "indices", [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $hOX8d.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $kqiuD.assertIs)(page, "page", [
                            [
                                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                                "PDFPage"
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $dJvqn.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $02b1048d3880ea05$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $e5537a67d34d93c3$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $9fe9d1e9876159aa$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $1RwW5.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $kqiuD.assertIs)(useObjectStreams, "useObjectStreams", [
                            "boolean"
                        ]);
                        (0, $kqiuD.assertIs)(addDefaultPage, "addDefaultPage", [
                            "boolean"
                        ]);
                        (0, $kqiuD.assertIs)(objectsPerTick, "objectsPerTick", [
                            "number"
                        ]);
                        (0, $kqiuD.assertIs)(updateFieldAppearances, "updateFieldAppearances", [
                            "boolean"
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $4ce308fa1beafd09$export$2e2bcd8739ae039) : (0, $711a45888f7f3cc3$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $1RwW5.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $1RwW5.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $kqiuD.assertIs)(dataUri, "dataUri", [
                            "boolean"
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $6dc53.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $1RwW5.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $1RwW5.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $iqqIy.default).of("Creator"))) this.setCreator(pdfLib);
        if (!info.get((0, $iqqIy.default).of("CreationDate"))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $6f6e7a6c2ffe413f$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039 = $7dbd2d7fa8dcdf9e$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $7dbd2d7fa8dcdf9e$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $83374afbe9879719$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $03aa38dbd8969f43$export$2e2bcd8739ae039))) throw new (0, $dJvqn.UnexpectedObjectTypeError)([
        (0, $83374afbe9879719$export$2e2bcd8739ae039),
        (0, $03aa38dbd8969f43$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $17ba36fcb0a87e8d$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($17ba36fcb0a87e8d$export$c9b8fe72ac71821 || ($17ba36fcb0a87e8d$export$c9b8fe72ac71821 = {}));





var $joN8z = parcelRequire("joN8z");
var $iqqIy = parcelRequire("iqqIy");
parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
var $equxL = parcelRequire("equxL");
var $dhfaG = parcelRequire("dhfaG");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $9897d120e9ff26bb$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $kqiuD.assertIs)(leafNode, "leafNode", [
            [
                (0, $302c9174c68f73e6$export$2e2bcd8739ae039),
                "PDFPageLeaf"
            ]
        ]);
        (0, $kqiuD.assertIs)(ref, "ref", [
            [
                (0, $2544783d06ee48ba$export$2e2bcd8739ae039),
                "PDFRef"
            ]
        ]);
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $9087813372121b21$export$56cb859c01fa134d)(angle);
        (0, $kqiuD.assertMultiple)(degreesAngle, "degreesAngle", 90);
        this.node.set((0, $iqqIy.default).of("Rotate"), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $9087813372121b21$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $dhfaG.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $dhfaG.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $dhfaG.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $dhfaG.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $iqqIy.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $iqqIy.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $iqqIy.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $iqqIy.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(width, "width", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(height, "height", [
            "number"
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $iqqIy.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $91e585bfd8e87555$export$cb182c48e35739ac)(), (0, $91e585bfd8e87555$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $91e585bfd8e87555$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $91e585bfd8e87555$export$cb182c48e35739ac)(), (0, $91e585bfd8e87555$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $91e585bfd8e87555$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $9ab23d4939782527$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $kqiuD.assertIs)(fontSize, "fontSize", [
            "number"
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $kqiuD.assertIs)(fontColor, "fontColor", [
            [
                Object,
                "Color"
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $kqiuD.assertIs)(lineHeight, "lineHeight", [
            "number"
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $kqiuD.assertIs)(x, "x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(y, "y", [
            "number"
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $kqiuD.assertIs)(yDecrease, "yDecrease", [
            "number"
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $kqiuD.assertIs)(yIncrease, "yIncrease", [
            "number"
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $kqiuD.assertIs)(xDecrease, "xDecrease", [
            "number"
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $kqiuD.assertIs)(xIncrease, "xIncrease", [
            "number"
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $kqiuD.assertEachIs)(operator, "operator", [
            [
                (0, $81b82bf3cb721b12$export$2e2bcd8739ae039),
                "PDFOperator"
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $kqiuD.assertIs)(text, "text", [
            "string"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertOrUndefined)(options.font, "options.font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.size, "options.size", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.lineHeight, "options.lineHeight", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.maxWidth, "options.maxWidth", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.wordBreaks, "options.wordBreaks", [
            Array
        ]);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $equxL.lineSplit)((0, $equxL.cleanText)(text)) : (0, $equxL.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $kqiuD.assertIs)(image, "image", [
            [
                (0, $91214de71374288b$export$2e2bcd8739ae039),
                "PDFImage"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject("Image", image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $kqiuD.assertIs)(embeddedPage, "embeddedPage", [
            [
                (0, $9fe9d1e9876159aa$export$2e2bcd8739ae039),
                "PDFEmbeddedPage"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xScale, "options.xScale", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.yScale, "options.yScale", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject("EmbeddedPdfPage", embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $kqiuD.assertIs)(path, "path", [
            "string"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.scale, "options.scale", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $91e585bfd8e87555$export$7a77bc708e50709e));
        (0, $kqiuD.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.borderColor = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $kqiuD.assertIs)(options.start, "options.start", [
            [
                Object,
                "{ x: number, y: number }"
            ]
        ]);
        (0, $kqiuD.assertIs)(options.end, "options.end", [
            [
                Object,
                "{ x: number, y: number }"
            ]
        ]);
        (0, $kqiuD.assertIs)(options.start.x, "options.start.x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(options.start.y, "options.start.y", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(options.end.x, "options.end.x", [
            "number"
        ]);
        (0, $kqiuD.assertIs)(options.end.y, "options.end.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.thickness, "options.thickness", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.dashArray, "options.dashArray", [
            Array
        ]);
        (0, $kqiuD.assertOrUndefined)(options.dashPhase, "options.dashPhase", [
            "number"
        ]);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.lineCap, "options.lineCap", (0, $91e585bfd8e87555$export$7a77bc708e50709e));
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!("color" in options)) options.color = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.width, "options.width", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.height, "options.height", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xSkew, "options.xSkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.ySkew, "options.ySkew", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $91e585bfd8e87555$export$7a77bc708e50709e));
        (0, $kqiuD.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.color = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $kqiuD.assertOrUndefined)(size, "size", [
            "number"
        ]);
        this.drawRectangle((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $kqiuD.assertOrUndefined)(options.x, "options.x", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.y, "options.y", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.xScale, "options.xScale", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.yScale, "options.yScale", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.rotate, "options.rotate", [
            [
                Object,
                "Rotation"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(options.color, "options.color", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.opacity, "opacity.opacity", 0, 1);
        (0, $kqiuD.assertOrUndefined)(options.borderColor, "options.borderColor", [
            [
                Object,
                "Color"
            ]
        ]);
        (0, $kqiuD.assertRangeOrUndefined)(options.borderOpacity, "options.borderOpacity", 0, 1);
        (0, $kqiuD.assertOrUndefined)(options.borderWidth, "options.borderWidth", [
            "number"
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashArray, "options.borderDashArray", [
            Array
        ]);
        (0, $kqiuD.assertOrUndefined)(options.borderDashPhase, "options.borderDashPhase", [
            "number"
        ]);
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.borderLineCap, "options.borderLineCap", (0, $91e585bfd8e87555$export$7a77bc708e50709e));
        (0, $kqiuD.assertIsOneOfOrUndefined)(options.blendMode, "options.blendMode", (0, $17ba36fcb0a87e8d$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!("color" in options) && !("borderColor" in options)) options.color = (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $6adb43bb58413115$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $kqiuD.assertOrUndefined)(size, "size", [
            "number"
        ]);
        this.drawEllipse((0, $1RwW5.__assign)((0, $1RwW5.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $7038235c9fe0ffd7$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $2c3e42ef98d100c6$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: "ExtGState",
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState("GS", graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            "RD",
            "CL",
            "Vertices",
            "QuadPoints",
            "L",
            "Rect"
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $iqqIy.default).of(selectors[idx]));
            if (list instanceof (0, $joN8z.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $iqqIy.default).of("InkList"));
        if (inkLists instanceof (0, $joN8z.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $joN8z.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $kqiuD.assertIs)(doc, "doc", [
            [
                (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039),
                "PDFDocument"
            ]
        ]);
        var dummyRef = (0, $2544783d06ee48ba$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $302c9174c68f73e6$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $9897d120e9ff26bb$export$2e2bcd8739ae039 = $9897d120e9ff26bb$var$PDFPage;









parcelRequire("3Iuzo");
var $kqiuD = parcelRequire("kqiuD");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $c82e2cce13fd9b58$var$PDFButton = /** @class */ function(_super) {
    (0, $1RwW5.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $kqiuD.assertIs)(acroPushButton, "acroButton", [
            [
                (0, $5e596fab1c09e732$export$2e2bcd8739ae039),
                "PDFAcroPushButton"
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $013af8a75e51a9b3$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $kqiuD.assertPositive)(fontSize, "fontSize");
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $kqiuD.assertOrUndefined)(text, "text", [
            "string"
        ]);
        (0, $kqiuD.assertOrUndefined)(page, "page", [
            [
                (0, $9897d120e9ff26bb$export$2e2bcd8739ae039),
                "PDFPage"
            ]
        ]);
        (0, $46a82a1980bd7c8f$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $c14702c24eb19bfa$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $9087813372121b21$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $b753fca77bba2f04$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $kqiuD.assertIs)(font, "font", [
            [
                (0, $aa8c4ba965c8bda4$export$2e2bcd8739ae039),
                "PDFFont"
            ]
        ]);
        (0, $kqiuD.assertOrUndefined)(provider, "provider", [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $3ef67fd0f654b344$export$68f9b19f48ffeeec);
        var appearances = (0, $3ef67fd0f654b344$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $46a82a1980bd7c8f$export$2e2bcd8739ae039));
var $c82e2cce13fd9b58$export$2e2bcd8739ae039 = $c82e2cce13fd9b58$var$PDFButton;




































var $0a75f0b62c4bb8eb$exports = {};


parcelRequire("3Iuzo");
$parcel$exportWildcard($e18cee267b875a58$exports, $0a75f0b62c4bb8eb$exports);



var $cD0nt = parcelRequire("cD0nt");

var $eOD8X = parcelRequire("eOD8X");
var $0dd5dae821aa55f2$var$_window_location_pathname_split, $0dd5dae821aa55f2$var$_window_location_pathname_split1, $0dd5dae821aa55f2$var$_window_location_pathname;
/**
 * Logs an error message when the Brother Printer print operation fails.
 *
 * This function is used to handle errors that occur during the printing process
 * with the Brother Printer. It logs the error details using the application's
 * logging mechanism.
 *
 * @param {any} error - The error object containing details about the print failure.
 */ function $0dd5dae821aa55f2$var$kp_AirPrinter_printDidFailWithErrorEx(error) {
    (0, $1BSKa.default).error(`[BrotherPrinter] Print failed with error: `, error);
}
const $0dd5dae821aa55f2$var$isDev = false;
const $0dd5dae821aa55f2$var$CLIENT_TOKEN = $0dd5dae821aa55f2$var$isDev ? "1" : window.location.pathname.split("/")[2];
var $0dd5dae821aa55f2$var$_window_location_pathname_split_;
const $0dd5dae821aa55f2$var$BOARD_ID = $0dd5dae821aa55f2$var$isDev ? "1" : ($0dd5dae821aa55f2$var$_window_location_pathname_split_ = ($0dd5dae821aa55f2$var$_window_location_pathname = window.location.pathname) === null || $0dd5dae821aa55f2$var$_window_location_pathname === void 0 ? void 0 : ($0dd5dae821aa55f2$var$_window_location_pathname_split1 = $0dd5dae821aa55f2$var$_window_location_pathname.split) === null || $0dd5dae821aa55f2$var$_window_location_pathname_split1 === void 0 ? void 0 : ($0dd5dae821aa55f2$var$_window_location_pathname_split = $0dd5dae821aa55f2$var$_window_location_pathname_split1.call($0dd5dae821aa55f2$var$_window_location_pathname, "/")) === null || $0dd5dae821aa55f2$var$_window_location_pathname_split === void 0 ? void 0 : $0dd5dae821aa55f2$var$_window_location_pathname_split[4]) !== null && $0dd5dae821aa55f2$var$_window_location_pathname_split_ !== void 0 ? $0dd5dae821aa55f2$var$_window_location_pathname_split_ : null;
const $0dd5dae821aa55f2$var$BrotherPrinterContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $0dd5dae821aa55f2$export$faea1c5655e55612 = ()=>(0, $eZVvM.useContext)($0dd5dae821aa55f2$var$BrotherPrinterContext);
const $0dd5dae821aa55f2$export$5a5aa8671a894896 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const printFrameRef = (0, $eZVvM.useRef)(null);
    const enableBrotherPrinter = (0, $cD0nt.usePrintingEnabled)();
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const printerName = (0, $cD0nt.usePrinter)();
    const printingLabel = (0, $cD0nt.usePrintingLabel)();
    const apiUrl = (0, $eOD8X.getApiUrl)();
    const api = (0, $eZVvM.useMemo)(()=>{
        return (0, $a7H8f.default).create({
            baseURL: `${apiUrl}/api/v1`,
            headers: {
                "client-token": $0dd5dae821aa55f2$var$CLIENT_TOKEN,
                "board-id": $0dd5dae821aa55f2$var$BOARD_ID
            }
        });
    }, []);
    const getPrintDocument = (0, $eZVvM.useCallback)(async (id, options)=>{
        try {
            if (!api) throw new Error("API not found!");
            const response = await api.get(`/brother-printer/print/${id}`, options);
            (0, $1BSKa.default).debug(`[BrotherPrinter] Print request has been sent for id: ${id}`);
            return response;
        } catch (error) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Print request failed: `, error);
            return undefined;
        }
    }, [
        api
    ]);
    const removePrintFrame = (0, $eZVvM.useCallback)(()=>{
        if (!printFrameRef.current) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Print frame not found on timeout close!`);
            return;
        }
        try {
            printFrameRef.current.remove();
            printFrameRef.current = null;
        } catch (error) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Error while removing print frame: `, error);
        }
    }, [
        printFrameRef.current
    ]);
    const closePrint = (0, $eZVvM.useCallback)(()=>{
        if (!printFrameRef.current) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Print frame not found on close!`);
            return;
        }
        try {
            setTimeout(removePrintFrame);
        } catch (error) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Error while closing print: `, error);
        }
    }, [
        printFrameRef.current
    ]);
    const startPrint = (0, $eZVvM.useCallback)(()=>{
        var _printFrameRef_current;
        const printWindow = (_printFrameRef_current = printFrameRef.current) === null || _printFrameRef_current === void 0 ? void 0 : _printFrameRef_current.contentWindow;
        if (!printWindow) return;
        if (metadata === null || metadata === void 0 ? void 0 : metadata.nwPrint) // mistake, use other method - printInNewNWWindow
        return;
        printWindow.onbeforeprint = closePrint;
        printWindow.onafterprint = closePrint;
        printWindow === null || printWindow === void 0 ? void 0 : printWindow.print();
    }, [
        printFrameRef.current,
        metadata
    ]);
    const printInWindow = (printWindow, printDocument)=>{
        try {
            setTimeout(()=>{
                var _printWindow_document;
                printWindow === null || printWindow === void 0 ? void 0 : (_printWindow_document = printWindow.document) === null || _printWindow_document === void 0 ? void 0 : _printWindow_document.write(printDocument);
            }, 100);
            setTimeout(()=>{
                printWindow === null || printWindow === void 0 ? void 0 : printWindow.print();
            }, 200);
            setTimeout(()=>{
                printWindow === null || printWindow === void 0 ? void 0 : printWindow.close();
            }, 300);
        } catch (error) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Error while printing: `, error);
        }
    };
    const printInNewNWWindow = (0, $eZVvM.useCallback)(async (printDocument)=>{
        try {
            console.log("Printing a document in a new NW window", printDocument);
            // @ts-expect-error - nw.require is available in NW.js runtime
            const fs = nw.require("fs");
            // @ts-expect-error - nw.require is available in NW.js runtime
            const path = nw.require("path");
            // @ts-expect-error - nw.require gives Node context process with reliable execPath
            const nwProcess = nw.require("process");
            const timestamp = Date.now();
            // Use NW.js app directory instead of OS temp dir, since chrome-extension
            // protocol can't access /tmp on Linux
            const appDir = path.dirname(nwProcess.execPath);
            const tempDir = path.join(appDir, "temp");
            if (!fs.existsSync(tempDir)) fs.mkdirSync(tempDir, {
                recursive: true
            });
            const tempPdfPath = path.join(tempDir, `print-${timestamp}.pdf`);
            const arrayBuffer = await printDocument.arrayBuffer();
            // Resize PDF to fit custom print dimensions if configured in settings (mm)
            const printWidth = printingLabel === null || printingLabel === void 0 ? void 0 : printingLabel.width;
            const printHeight = printingLabel === null || printingLabel === void 0 ? void 0 : printingLabel.height;
            let pdfBytes;
            // lets resize it here in case print width/height are set
            if (printWidth && printHeight) {
                const targetWidthPt = printWidth / 25.4 * 72;
                const targetHeightPt = printHeight / 25.4 * 72;
                const srcDoc = await (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039).load(arrayBuffer);
                const resizedDoc = await (0, $7dbd2d7fa8dcdf9e$export$2e2bcd8739ae039).create();
                const pages = await resizedDoc.copyPages(srcDoc, srcDoc.getPageIndices());
                for (const page of pages){
                    // Content is already rotated by the backend via transformation matrices,
                    // so we only need to scale and fit to the target label size
                    const { width: origW, height: origH } = page.getSize();
                    const scale = Math.min(targetWidthPt / origW, targetHeightPt / origH);
                    page.setSize(targetWidthPt, targetHeightPt);
                    page.scaleContent(scale, scale);
                    const xOffset = (targetWidthPt - origW * scale) / 2;
                    const yOffset = (targetHeightPt - origH * scale) / 2;
                    page.translateContent(xOffset, yOffset);
                    resizedDoc.addPage(page);
                }
                pdfBytes = await resizedDoc.save();
                console.log(`Resized PDF to ${printWidth}x${printHeight}mm`);
            } else pdfBytes = new Uint8Array(arrayBuffer);
            // write
            fs.writeFileSync(tempPdfPath, pdfBytes);
            console.log("Wrote PDF to temp file:", tempPdfPath);
            // Use file:// URL so Chromium can access the local file
            // (plain paths get prefixed with chrome-extension:// which can't reach the filesystem)
            const fileUrl = "file://" + tempPdfPath.replace(/\\/g, "/");
            nw.Window.open(fileUrl, {
                show: false,
                // Keeps the window completely invisible
                width: 1200,
                height: 1200
            }, (hiddenWin)=>{
                console.log("New NW print window opened", hiddenWin);
                // Poll until the PDF is loaded in the window, since NW.js loaded event
                // doesn't fire for PDFs rendered by Chromium's PDF plugin
                const maxAttempts = 20; // 20 * 500ms = 10s max wait
                let attempts = 0;
                const checkReady = setInterval(()=>{
                    attempts++;
                    try {
                        const doc = hiddenWin.window.document;
                        const readyState = doc === null || doc === void 0 ? void 0 : doc.readyState;
                        console.log(`NW print window check #${attempts}, readyState: ${readyState}`);
                        if (readyState === "complete" || attempts >= maxAttempts) {
                            clearInterval(checkReady);
                            if (attempts >= maxAttempts) console.warn("NW print window: max wait reached, proceeding anyway");
                            console.log("NW print window ready");
                            // @ts-ignore - getPrinters is available in NW.js runtime
                            hiddenWin.getPrinters(function(printers) {
                                console.log("Available printers: ", printers);
                                const defaultPrinter = printers.find((p)=>p.isDefault) || printers[0];
                                console.log("Default printer: ", defaultPrinter);
                                console.log("Setup printer", printerName);
                                console.log("Printing with printer:", printerName || defaultPrinter.deviceName);
                                if (printerName || defaultPrinter) hiddenWin.print({
                                    autoprint: true,
                                    printer: printerName || defaultPrinter.deviceName,
                                    headerFooterEnabled: false,
                                    shouldPrintBackgrounds: false
                                });
                                else console.warn("No printers found on this system.");
                            });
                            // Close the hidden window a few seconds later to clean up memory
                            setTimeout(()=>{
                                console.log("Closing NW print window after 10 seconds");
                                hiddenWin.close(true);
                                try {
                                    fs.unlinkSync(tempPdfPath);
                                } catch (e) {
                                /* ignore */ }
                            }, 10000);
                        }
                    } catch (e) {
                        // Window not ready yet, keep polling
                        console.log(`NW print window check #${attempts}: not ready yet`);
                    }
                }, 500);
            });
        } catch (error) {
            console.error(`[BrotherPrinter] Error while printing in new NW window: `, error);
            (0, $1BSKa.default).error(`[BrotherPrinter] Error while printing in new NW window: `, error instanceof Error ? error.message : error);
        }
    }, [
        printerName
    ]);
    const printInIFrame = (printDocument)=>{
        try {
            const frame = document.createElement("iframe");
            printFrameRef.current = frame;
            frame.id = "print-frame";
            frame.onload = ()=>{
                startPrint();
            };
            frame.src = URL.createObjectURL(printDocument);
            frame.style = `
        visibility: hidden;
        opacity: 0;
        width: 350px;
        height: 212px;
        position: fixed;
      `;
            document.body.appendChild(printFrameRef.current);
        } catch (error) {
            (0, $1BSKa.default).error(`[BrotherPrinter] Error while printing: `, error);
        }
    };
    const printInIOS = (printDocument)=>{
        try {
            window.kp_AirPrinter_printPdf(printDocument);
        } catch (error) {
            console.log("Error while printing: ", error);
        }
    };
    /**
   * Prints a badge by its owner ID (member - employee or visitor, meeting attendee). It checks if the
   * BrotherPrinter is enabled in the digital reception before printing.
   *
   * For example, to print a meeting attendee badge, you need to use the meeting attendee ID:
   * ```
   * const attendeeId = accessEventData?.accessEvent?.owner?.id;
   * ```
   *
   * This function retrieves a print document using the provided ID and attempts to print it
   * by creating an iframe and appending it to the document body, opening a new window, directly
   * printing in the body, or using iOS printing based on the metadata configuration. If the document
   * is not found or an error occurs during the printing process, appropriate error messages are logged.
   *
   * @param {string} id - The ID of the document to be printed.
   * @param {Window | null} printWindowRef - Optional reference to a print window.
   * @returns {Promise<void>} A promise that resolves when the print process is initiated or an error occurs.
   */ const print = (0, $eZVvM.useCallback)((id, printWindowRef)=>{
        if (!id || !enableBrotherPrinter) return;
        if (printWindowRef) console.log("printWindowRef from above");
        let printWindow = null;
        if ((metadata === null || metadata === void 0 ? void 0 : metadata.printRef) === "window" && !printWindowRef) printWindow = window.open("", "");
        const options = {
            ...(metadata === null || metadata === void 0 ? void 0 : metadata.printRef) === "iframe" || !(metadata === null || metadata === void 0 ? void 0 : metadata.printRef) ? {
                responseType: "blob"
            } : {},
            params: {
                rotation: metadata.printRotation
            }
        };
        getPrintDocument(id, options).then((printDocument)=>{
            if (!printDocument) {
                (0, $1BSKa.default).error(`[BrotherPrinter] Print document not found!`);
                return;
            }
            if ((metadata === null || metadata === void 0 ? void 0 : metadata.printRef) === "window") {
                printInWindow(printWindowRef || printWindow, printDocument.data);
                return;
            }
            if (metadata === null || metadata === void 0 ? void 0 : metadata.nwPrint) {
                printInNewNWWindow(printDocument.data);
                return;
            }
            if ((metadata === null || metadata === void 0 ? void 0 : metadata.printRef) === "printIOS") {
                printInIOS(printDocument.data);
                return;
            }
            printInIFrame(printDocument.data);
        });
    }, [
        enableBrotherPrinter
    ]);
    const value = (0, $eZVvM.useMemo)(()=>({
            print: print
        }), [
        print
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($0dd5dae821aa55f2$var$BrotherPrinterContext.Provider, {
        value: value,
        children: children
    });
});
var $0dd5dae821aa55f2$export$2e2bcd8739ae039 = $0dd5dae821aa55f2$export$5a5aa8671a894896;



const $51e8f738038336ca$var$ManualCheckinGrid = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $23610b7fd899719e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        paddingTop: "3rem",
        flex: "0 1 auto",
        minHeight: 0,
        overflowY: "auto",
        alignContent: "flex-start",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
            width: "2rem"
        },
        "&::-webkit-scrollbar-track": {
            background: theme.palette.primary.light,
            borderRadius: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
            borderRadius: "8px"
        }
    }));
const $51e8f738038336ca$var$ManualCheckinField = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div)(({ theme: theme })=>({
        marginBottom: "1.75rem",
        width: "56.5rem",
        "@media screen and (orientation: landscape)": {
            width: "50rem"
        }
    }));
const $51e8f738038336ca$var$getFieldType = (code, fields)=>{
    var _fields_find;
    return code === "contact" ? "EmployeeList" : (_fields_find = fields.find((field)=>field.name === code || field.code === code)) === null || _fields_find === void 0 ? void 0 : _fields_find.type;
};
const $51e8f738038336ca$var$ManualCheckin = ()=>{
    var _registrationFields_, _registrationFields_1, _data_createGuest, _data_createGuest_owner, _data_createGuest1, _receiver_availablePreferences_visitor_autoChannel, _receiver_availablePreferences_visitor, _receiver_availablePreferences, _receiver_availablePreferences_visitor_autoChannel1, _receiver_availablePreferences_visitor1, _receiver_availablePreferences1, _receiver_availablePreferences_visitor_autoChannel2, _receiver_availablePreferences_visitor2, _receiver_availablePreferences2, _receiver_availablePreferences_visitor_autoChannel3, _receiver_availablePreferences_visitor3, _receiver_availablePreferences3, _receiver_availablePreferences_visitor_autoChannel4, _receiver_availablePreferences_visitor4, _receiver_availablePreferences4, _data_createGuest2, _receiver_availablePreferences_visitor_autoChannel5, _receiver_availablePreferences_visitor5, _receiver_availablePreferences5, _receptionMetadata_message_checkin, _receptionMetadata_message, _typeMessages_title, _typeMessages_message, _receptionMetadata_uiOverrides, _mcOverrides_title, _mcOverrides_subtitle, _mcOverrides_btn;
    const { t: t } = (0, $9GLBV.useTranslation)();
    const navigate = (0, $9B9bN.useNavigate)();
    const { pathname: pathname, state: locationState } = (0, $9B9bN.useLocation)();
    const { print: print } = (0, $0dd5dae821aa55f2$export$faea1c5655e55612)();
    const { height: headerHeight } = (0, $8b1dc2b27a20c047$export$cb84c4304c266c20)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const mainRoute = /^\/access\/checkin\/manual\/?$/.test(pathname);
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const languages = (0, $bad2beece3d2a513$export$38be4353f99148d)();
    const { integratedManualCheckin: integratedManualCheckin, independentManualCheckin: independentManualCheckin } = (0, $cD0nt.useLayout)();
    const registrationFields = (0, $eZVvM.useMemo)(()=>{
        var _integratedManualCheckin_registration, _independentManualCheckin_registration;
        var _integratedManualCheckin_registration_fields;
        if (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) return (_integratedManualCheckin_registration_fields = integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : (_integratedManualCheckin_registration = integratedManualCheckin.registration) === null || _integratedManualCheckin_registration === void 0 ? void 0 : _integratedManualCheckin_registration.fields) !== null && _integratedManualCheckin_registration_fields !== void 0 ? _integratedManualCheckin_registration_fields : [];
        var _independentManualCheckin_registration_fields;
        if (independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : independentManualCheckin.enabled) return (_independentManualCheckin_registration_fields = independentManualCheckin === null || independentManualCheckin === void 0 ? void 0 : (_independentManualCheckin_registration = independentManualCheckin.registration) === null || _independentManualCheckin_registration === void 0 ? void 0 : _independentManualCheckin_registration.fields) !== null && _independentManualCheckin_registration_fields !== void 0 ? _independentManualCheckin_registration_fields : [];
        return [];
    }, [
        integratedManualCheckin,
        independentManualCheckin
    ]);
    const hasContact = (0, $eZVvM.useMemo)(()=>registrationFields.some((field)=>field.type === "EmployeeList"), [
        registrationFields
    ]);
    const receptionMetadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const contactPreviewEnabled = (0, $cD0nt.useContactPreviewEnabled)();
    const { isAccessAllowedForGuestsForCheckin: isAccessAllowedForGuestsForCheckin, isAccessEnabledForAutoOpenForCheckin: isAccessEnabledForAutoOpenForCheckin, accessController: accessController } = (0, $cD0nt.useAccessSettings)();
    const { trigger: triggerAutoSwitch, doorModal: doorModal } = (0, $325562920a04a1bd$export$27b435a0411fd08e)();
    const { isDocumentScannerEnabled: isDocumentScannerEnabled, fields: fields } = (0, $cD0nt.useDocumentScannerSettings)();
    const getFieldDisabledStatus = (controllerId)=>{
        if (!isDocumentScannerEnabled) return false;
        const scannerField = Object.values(fields).find((f)=>f.field === controllerId);
        return !!scannerField && scannerField.field != null && scannerField.allowManualInput === false;
    };
    const defaultFormValues = (0, $eZVvM.useMemo)(()=>({
            info: registrationFields.reduce((acc, item)=>{
                acc[item.name || item.code] = item.type !== "Checkbox" ? "" : false;
                if (locationState === null || locationState === void 0 ? void 0 : locationState[item.name || item.code]) acc[item.name || item.code] = locationState === null || locationState === void 0 ? void 0 : locationState[item.name || item.code];
                return acc;
            }, {}),
            contact: {
                label: ""
            }
        }), [
        registrationFields,
        locationState
    ]);
    const [customOtherValue, setCustomOtherValue] = (0, $eZVvM.useState)();
    const [isOtherSelected, setIsOtherSelected] = (0, $eZVvM.useState)(false);
    const drCountry = (0, $cD0nt.useDigitalReceptionCountry)();
    const drCountryCode = (0, $eZVvM.useMemo)(()=>drCountry ? (0, $2f526e07c519dc18$export$9a0a9c75ccef13fb)(drCountry) : null, [
        drCountry
    ]);
    const defaultCountry = (0, $eZVvM.useMemo)(()=>{
        if (!!drCountryCode) return drCountryCode;
        if ([
            "nl",
            "fr",
            "de",
            "pt",
            "es",
            "pl",
            "it"
        ].includes(language)) return language.toUpperCase();
        if (language === "en") return "GB";
        if (language === "sr") return "RS";
        if (language === "en_US") return "US";
        if (language === "ja") return "JP";
        return undefined;
    }, [
        language
    ]);
    const preferredCountries = (0, $eZVvM.useMemo)(()=>{
        return (drCountryCode ? [
            drCountryCode
        ] : []).concat(languages.flatMap((language)=>{
            if ([
                "nl",
                "fr",
                "de",
                "pt",
                "es",
                "pl",
                "it"
            ].includes(language)) return [
                language.toUpperCase()
            ];
            if (language === "en") return "GB";
            if (language === "sr") return [
                "RS"
            ];
            if (language === "en_US") return [
                "US"
            ];
            if (language === "ja") return [
                "JP"
            ];
            return [];
        }));
    }, [
        languages
    ]);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const { screen: screen, showFirst: showFirst, agreementsFor: agreementsFor } = (0, $5e33a52931d48974$export$991b23a188dc1bb5)();
    const { accepted: accepted, accept: accept } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    /**
   * Manual registration always creates a Guest, so the audience is known from
   * the start here — no need to resolve anyone's identity first.
   */ const guestAgreements = agreementsFor("Guest");
    const showsAgreementsUpfront = showFirst && !pathname.includes("contact");
    /**
   * Set when the guest submits with documents still outstanding — the mode
   * where they come after the form rather than before it.
   */ const [agreementsRequested, setAgreementsRequested] = (0, $eZVvM.useState)(false);
    /**
   * Derived, never copied into state. `agreementsFor` already drops whatever
   * has been accepted, while the board query hands back a new object on every
   * poll — and an undefined one whenever the kiosk's connection blips, since
   * `online` is part of its cache key. A copy kept here would be re-seeded off
   * that and reopen documents the guest is long done with, which is how a
   * finished check-in ended up back on an agreement instead of the home screen.
   */ const pendingAgreements = showsAgreementsUpfront || agreementsRequested ? guestAgreements : [];
    /**
   * What the mutation reports as signed. Read through a ref because the submit
   * path runs from callbacks that deliberately hold no dependencies, and a
   * stale empty list there would record nothing at all.
   */ const acceptedRef = (0, $eZVvM.useRef)(accepted);
    acceptedRef.current = accepted;
    const { isPhotoCaptureAllowedForVisitors: isPhotoCaptureAllowedForVisitors, isPhotoCaptureRequiredForVisitors: isPhotoCaptureRequiredForVisitors } = (0, $cD0nt.usePhotoCaptureSettings)();
    const [photoRequired, setPhotoRequired] = (0, $eZVvM.useState)(false);
    const [employeeSelectOpen, setEmployeeSelectOpen] = (0, $eZVvM.useState)(false);
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const queryClient = (0, $gdPnm.useQueryClient)();
    const printingEnabled = (0, $cD0nt.usePrintingEnabled)();
    // usePageTracking({
    //   page: "manual_checkin",
    // });
    // const { trackEvent } = useEventTracking();
    const { data: employeesData } = (0, $dMu0R.useQuery)([
        "employees",
        {
            filter: {
                preferences: {
                    visitor: {
                        enabled: {
                            EQ: true
                        }
                    }
                }
            },
            pagination: {
                limit: 99999
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_EMPLOYEES), variables), {
        enabled: hasContact
    });
    const employees = (0, $eZVvM.useMemo)(()=>employeesData === null || employeesData === void 0 ? void 0 : employeesData.employees, [
        employeesData
    ]);
    const contactList = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(employees, (employee)=>({
                id: employee.id,
                label: employee.fullName
            })), [
        employees
    ]);
    const [layout, setLayout] = (0, $eZVvM.useState)("default-shift");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)(`info.${((_registrationFields_ = registrationFields[0]) === null || _registrationFields_ === void 0 ? void 0 : _registrationFields_.name) || ((_registrationFields_1 = registrationFields[0]) === null || _registrationFields_1 === void 0 ? void 0 : _registrationFields_1.code)}`);
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: defaultFormValues,
        mode: "onSubmit"
    });
    const { setValue: setValue, handleSubmit: handleSubmit, watch: watch } = methods;
    const selectedContact = watch("contact");
    const hasSelectedContact = !!(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.id);
    (0, $eZVvM.useEffect)(()=>{
        methods.register("photo");
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (locationState && typeof locationState === "object") Object.entries(locationState).forEach(([key, field])=>{
            if (field && typeof field === "object" && "id" in field && "value" in field) {
                const { id: id, value: value } = field;
                const foundField = registrationFields.find((f)=>f.id === id);
                if (foundField && value) {
                    const fieldKey = foundField.name || foundField.code;
                    setValue(`info.${fieldKey}`, value, {
                        shouldValidate: false,
                        shouldDirty: true,
                        shouldTouch: true
                    });
                }
            }
        });
    }, [
        locationState,
        setValue,
        registrationFields
    ]);
    const { data: data, status: requestStatus, mutate: mutate, reset: reset } = (0, $084aaf38c3338203$export$609860bf8b0084c)((input)=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$255003e9a28fdae2), {
            input: input
        });
    });
    const receiver = data === null || data === void 0 ? void 0 : (_data_createGuest = data.createGuest) === null || _data_createGuest === void 0 ? void 0 : _data_createGuest.receiver;
    const ownerId = data === null || data === void 0 ? void 0 : (_data_createGuest1 = data.createGuest) === null || _data_createGuest1 === void 0 ? void 0 : (_data_createGuest_owner = _data_createGuest1.owner) === null || _data_createGuest_owner === void 0 ? void 0 : _data_createGuest_owner.id;
    const receiverEmail = receiver === null || receiver === void 0 ? void 0 : receiver.email;
    const autoEmail = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_visitor = _receiver_availablePreferences.visitor) === null || _receiver_availablePreferences_visitor === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel = _receiver_availablePreferences_visitor.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel.email;
    const autoSMS = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences1 = receiver.availablePreferences) === null || _receiver_availablePreferences1 === void 0 ? void 0 : (_receiver_availablePreferences_visitor1 = _receiver_availablePreferences1.visitor) === null || _receiver_availablePreferences_visitor1 === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel1 = _receiver_availablePreferences_visitor1.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel1 === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel1.sms;
    const autoCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences2 = receiver.availablePreferences) === null || _receiver_availablePreferences2 === void 0 ? void 0 : (_receiver_availablePreferences_visitor2 = _receiver_availablePreferences2.visitor) === null || _receiver_availablePreferences_visitor2 === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel2 = _receiver_availablePreferences_visitor2.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel2 === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel2.call;
    const autoPing = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences3 = receiver.availablePreferences) === null || _receiver_availablePreferences3 === void 0 ? void 0 : (_receiver_availablePreferences_visitor3 = _receiver_availablePreferences3.visitor) === null || _receiver_availablePreferences_visitor3 === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel3 = _receiver_availablePreferences_visitor3.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel3 === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel3.ping;
    const autoVideoCall = !!(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences4 = receiver.availablePreferences) === null || _receiver_availablePreferences4 === void 0 ? void 0 : (_receiver_availablePreferences_visitor4 = _receiver_availablePreferences4.visitor) === null || _receiver_availablePreferences_visitor4 === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel4 = _receiver_availablePreferences_visitor4.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel4 === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel4.videoCall) && !!(data === null || data === void 0 ? void 0 : (_data_createGuest2 = data.createGuest) === null || _data_createGuest2 === void 0 ? void 0 : _data_createGuest2.videoRoom);
    const autoTeamsCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences5 = receiver.availablePreferences) === null || _receiver_availablePreferences5 === void 0 ? void 0 : (_receiver_availablePreferences_visitor5 = _receiver_availablePreferences5.visitor) === null || _receiver_availablePreferences_visitor5 === void 0 ? void 0 : (_receiver_availablePreferences_visitor_autoChannel5 = _receiver_availablePreferences_visitor5.autoChannel) === null || _receiver_availablePreferences_visitor_autoChannel5 === void 0 ? void 0 : _receiver_availablePreferences_visitor_autoChannel5.teamsCall;
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `manualCheckin:status.${status}`;
        if (status === "error") return key;
        if (status !== "success") return `${key}.${hasSelectedContact ? "contact" : "no-contact"}`;
        if (printingEnabled) return `${key}.badge`;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoTeamsCall) messageType = "teams-call";
        else if (autoVideoCall) messageType = "video-call";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        status,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS,
        autoTeamsCall,
        printingEnabled,
        hasSelectedContact,
        autoVideoCall
    ]);
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const { callerAcsToken: callerAcsToken, targetTeamsUserIds: targetTeamsUserIds } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: receiverEmail ? [
            receiverEmail
        ] : [],
        enabled: !!autoTeamsCall && !!receiverEmail
    });
    const onDismiss = (0, $eZVvM.useCallback)(async ()=>{
        var _data_createGuest;
        const id = data === null || data === void 0 ? void 0 : (_data_createGuest = data.createGuest) === null || _data_createGuest === void 0 ? void 0 : _data_createGuest.id;
        const isFree = clientPlan && clientPlan === "free";
        // const autoSMS = receiver?.availablePreferences?.visitor?.autoChannel?.sms;
        /**
     * Prefetch access event so we don't wait when on calling page
     */ await queryClient.prefetchQuery([
            `access/event/${id}`
        ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                id: id
            })).catch(()=>null);
        /**
     * Can the user be navigated to contact page based on permissions and cations
     *
     * - Has to be non free user
     * - Access must belong to a visitor that is checking in
     * - Employee has to have at least one notification channel enabled
     */ const canContinue = !isFree && id && status === "success";
        if (canContinue) {
            var _data_createGuest1, _receiver_availablePreferences_visitor, _receiver_availablePreferences;
            if (ownerId) {
                let printWindow = null;
                if (printingEnabled && (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.printRef) === "window") {
                    printWindow = window.open("", "");
                    window.focus();
                }
                print(ownerId, printWindow);
            }
            if (autoCall || autoPing) {
                setCalling(true);
                return navigate(`/access/checkin/manual/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                    replace: true
                });
            }
            if (!!autoTeamsCall) return navigate(`/${teamsVideoCallEnabled ? "teams-video" : `access/checkin/manual/teams-audio`}-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                callerAcsToken: callerAcsToken,
                targetTeamsUserIds: targetTeamsUserIds,
                type: "Guest"
            })}`, {
                replace: true
            });
            if (autoVideoCall) return navigate(`/video-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                id: id,
                type: "Guest"
            })}`, {
                state: {
                    videoRoom: data === null || data === void 0 ? void 0 : (_data_createGuest1 = data.createGuest) === null || _data_createGuest1 === void 0 ? void 0 : _data_createGuest1.videoRoom
                }
            });
            // if (!!autoSMS) {
            //   return navigate("/", { replace: true });
            // }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_visitor = _receiver_availablePreferences.visitor) === null || _receiver_availablePreferences_visitor === void 0 ? void 0 : _receiver_availablePreferences_visitor.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                replace: true
            });
            if (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.enableExternalDoorTrigger) return navigate("/door", {
                replace: true
            });
            if (isAccessAllowedForGuestsForCheckin) {
                if (isAccessEnabledForAutoOpenForCheckin && accessController) return triggerAutoSwitch(accessController);
                return navigate(`/access-control/${accessController}`, {
                    replace: true
                });
            }
        }
        /**
     * Reset modal on error state
     */ if (status === "error") return reset();
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        var _receptionMetadata_message_checkin, _receptionMetadata_message;
        if (status === "error") return 10000;
        if (status === "success") return (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : (_receptionMetadata_message = receptionMetadata.message) === null || _receptionMetadata_message === void 0 ? void 0 : (_receptionMetadata_message_checkin = _receptionMetadata_message.checkin) === null || _receptionMetadata_message_checkin === void 0 ? void 0 : _receptionMetadata_message_checkin.durationMs) || 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", field = "", value = "")=>{
        switch(field){
            case "EmployeeList":
            case "Company":
            case "Text":
                if (!value || value.slice(-1) === " ") return "default-shift";
                return "default";
            case "Phone":
                return "phone-pad";
            case "Number":
                return "pin";
            case "Email":
                return "email";
            default:
                return layout;
        }
    }, []);
    const [showDocScanInvalid, setShowDocScanInvalid] = (0, $eZVvM.useState)(false);
    (0, $eZVvM.useEffect)(()=>{
        if ((locationState === null || locationState === void 0 ? void 0 : locationState.documentScanStatus) === "invalid") {
            setShowDocScanInvalid(true);
            const timer = setTimeout(()=>{
                setShowDocScanInvalid(false);
            }, 8000);
            return ()=>clearTimeout(timer);
        }
        return undefined;
    }, [
        locationState,
        navigate
    ]);
    (0, $eZVvM.useEffect)(()=>{
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, registrationFields[0].type, ""));
    }, [
        registrationFields
    ]);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        let prevValue = methods.getValues(focusedInput) || "";
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $51e8f738038336ca$var$getFieldType((focusedInput === null || focusedInput === void 0 ? void 0 : focusedInput.split(".").pop()) || "Text", registrationFields), value));
        if (focusedInput === "contact") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            setValue("contact", {
                label: value
            });
        } else setValue(focusedInput, value);
        /**
     * Update caret position of text input
     */ if (input) {
            var _keyboard_current;
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            const type = $51e8f738038336ca$var$getFieldType((focusedInput === null || focusedInput === void 0 ? void 0 : focusedInput.split(".").pop()) || "Text", registrationFields);
            if (type === "Phone" || type === "Number") (_keyboard_current = keyboard.current) === null || _keyboard_current === void 0 ? void 0 : _keyboard_current.setCaretPosition(prevValue.length < value.length ? prevValue.length + 1 : value.length, prevValue.length < value.length ? prevValue.length + 1 : value.length);
            else input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && [
            "INPUT",
            "TEXTAREA"
        ].includes((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName)) return;
        setFocusedInput(undefined);
    });
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        // trackEvent({ type: "input_focus", value: `visitor_${name}` });
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $51e8f738038336ca$var$getFieldType((name === null || name === void 0 ? void 0 : name.split(".").pop()) || "Text", registrationFields), value));
        setFocusedInput(name);
    }, []);
    const onSubmit = (0, $eZVvM.useCallback)(({ info: info, contact: contact, photo: photo })=>{
        // trackEvent({ type: "notify_button_click", value: "visitor" });
        let input = {
            info: Object.fromEntries(Object.entries(info).filter(([key, value])=>value !== "").map(([key, value])=>{
                const type = $51e8f738038336ca$var$getFieldType(key, registrationFields);
                if (type === "Phone") return [
                    key,
                    (0, $2bc546ee6dbb8ac5$export$176bb591929cc9a8)(value).number
                ];
                return [
                    key,
                    value
                ];
            })),
            employee: contact === null || contact === void 0 ? void 0 : contact.id,
            ...screen ? {
                screen: screen
            } : {}
        };
        const acceptedAgreements = acceptedRef.current;
        if (acceptedAgreements.length) input = {
            ...input,
            acceptedAgreements: acceptedAgreements
        };
        if (photo) input = {
            ...input,
            photo: photo
        };
        mutate(input, {
            onSuccess () {
            // trackEvent({ type: "manual_checkin", value: "success" });
            },
            onError () {
            // trackEvent({ type: "manual_checkin", value: `error` });
            }
        });
    }, [
        mutate
    ]);
    const onBeforePhotoSubmit = (0, $eZVvM.useCallback)((variables)=>{
        if (isPhotoCaptureAllowedForVisitors) return setPhotoRequired(true);
        return onSubmit(variables);
    }, [
        isPhotoCaptureAllowedForVisitors
    ]);
    const onBeforeAgreementSubmit = (0, $eZVvM.useCallback)((variables)=>{
        /**
     * Anything still outstanding is shown now — including the case where the
     * documents were meant to come up front but this page was reached past
     * them. Nothing is reported as signed that the guest never saw.
     */ if (guestAgreements.length > 0) return setAgreementsRequested(true);
        return onBeforePhotoSubmit(variables);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        guestAgreements
    ]);
    /**
   * One list, kept by the provider, so every page of a check-in agrees on what
   * has been signed and a document cannot come back once it is done.
   */ const onAcceptAgreement = accept;
    /**
   * The documents came after the form, so the check-in carries on by itself
   * once the last one is out of the way.
   *
   * `screen` stands in for "the board config is here": without it the list of
   * documents reads as empty for the wrong reason, and the check-in would go
   * out unsigned — and without a screen for the server to check it against.
   */ (0, $eZVvM.useEffect)(()=>{
        if (!agreementsRequested || !screen || guestAgreements.length > 0) return;
        setAgreementsRequested(false);
        methods.handleSubmit(onBeforePhotoSubmit)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agreementsRequested,
        screen,
        guestAgreements.length
    ]);
    const onAcceptPhoto = (0, $eZVvM.useCallback)((photo)=>{
        methods.setValue("photo", photo);
        setPhotoRequired(false);
        methods.handleSubmit(onSubmit)();
    }, []);
    const onPhotoDialogClose = (0, $eZVvM.useCallback)(()=>{
        setPhotoRequired(false);
        if (!isPhotoCaptureRequiredForVisitors) methods.handleSubmit(onSubmit)();
    }, [
        isPhotoCaptureRequiredForVisitors
    ]);
    /**
   * Synchronize text caret position with virtual keyboard
   */ const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    /**
   * Synchronize text input with virtual keyboard
   */ const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event;
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $51e8f738038336ca$var$getFieldType((name === null || name === void 0 ? void 0 : name.split(".").pop()) || "Text", registrationFields), value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onCountryInputChange = (0, $eZVvM.useCallback)((value)=>{
        if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, $51e8f738038336ca$var$getFieldType("Phone", registrationFields), value));
        keyboard.current.setInput(value, "phone");
        keyboard.current.setCaretPosition(value.length, value.length);
        setValue("info.phone", value);
        setFocusedInput("info.phone");
    }, []);
    const typeMessages = status === "success" && (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : (_receptionMetadata_message = receptionMetadata.message) === null || _receptionMetadata_message === void 0 ? void 0 : (_receptionMetadata_message_checkin = _receptionMetadata_message.checkin) === null || _receptionMetadata_message_checkin === void 0 ? void 0 : _receptionMetadata_message_checkin.Guest);
    const localizedTitle = typeof typeMessages === "object" && typeof ((_typeMessages_title = typeMessages.title) === null || _typeMessages_title === void 0 ? void 0 : _typeMessages_title[language]) === "string" ? typeMessages.title[language] : undefined;
    const localizedMessage = typeof typeMessages === "object" && typeof ((_typeMessages_message = typeMessages.message) === null || _typeMessages_message === void 0 ? void 0 : _typeMessages_message[language]) === "string" ? typeMessages.message[language] : undefined;
    const mcOverrides = receptionMetadata === null || receptionMetadata === void 0 ? void 0 : (_receptionMetadata_uiOverrides = receptionMetadata.uiOverrides) === null || _receptionMetadata_uiOverrides === void 0 ? void 0 : _receptionMetadata_uiOverrides.manualCheckin;
    const titleOverride = mcOverrides === null || mcOverrides === void 0 ? void 0 : (_mcOverrides_title = mcOverrides.title) === null || _mcOverrides_title === void 0 ? void 0 : _mcOverrides_title[language];
    const subtitleOverride = mcOverrides === null || mcOverrides === void 0 ? void 0 : (_mcOverrides_subtitle = mcOverrides.subtitle) === null || _mcOverrides_subtitle === void 0 ? void 0 : _mcOverrides_subtitle[language];
    const btnOverride = mcOverrides === null || mcOverrides === void 0 ? void 0 : (_mcOverrides_btn = mcOverrides.btn) === null || _mcOverrides_btn === void 0 ? void 0 : _mcOverrides_btn[language];
    const renderDocumentScannerSubtitle = (subtitleValue)=>{
        if (Array.isArray(subtitleValue)) return /*#__PURE__*/ (0, $bhfvP.jsx)("ul", {
            style: {
                textAlign: "left"
            },
            children: subtitleValue.map((item)=>/*#__PURE__*/ (0, $bhfvP.jsx)("li", {
                    children: item.parts.map((part, partIndex)=>{
                        const partKey = `${part.text}-${part.bold ? "bold" : "normal"}-${partIndex}`;
                        return part.bold ? /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                            style: {
                                fontWeight: "bold"
                            },
                            children: part.text
                        }, partKey) : /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                            children: part.text
                        }, partKey);
                    })
                }, item.parts.map((p)=>p.text).join("-")))
        });
        return subtitleValue;
    };
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), {
                ...methods,
                children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                    className: "d-flex align-items-center flex-column h-100",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                            to: (integratedManualCheckin === null || integratedManualCheckin === void 0 ? void 0 : integratedManualCheckin.enabled) ? "/access/option/checkin" : "/"
                        }),
                        !isDocumentScannerEnabled ? /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                            className: "mb-5 text-center",
                            style: {
                                margin: "0 10rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h1",
                                    children: titleOverride || t("manualCheckin:title.default")
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h3",
                                    className: "font-weight-regular pt-3",
                                    children: subtitleOverride || t("manualCheckin:subtitle.default")
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                            className: "mb-5 text-center",
                            style: {
                                margin: "0 10rem"
                            },
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h1",
                                    children: t("manualCheckin:title.documentScanner")
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h3",
                                    className: "font-weight-regular pt-3 text-center",
                                    sx: {
                                        fontWeight: "normal"
                                    },
                                    children: renderDocumentScannerSubtitle(t("manualCheckin:subtitle.documentScanner", {
                                        returnObjects: true
                                    }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            style: {
                                flex: "1 1 0",
                                minHeight: 0,
                                width: "100%",
                                display: "flex",
                                flexDirection: "column"
                            },
                            children: /*#__PURE__*/ (0, $bhfvP.jsxs)("form", {
                                className: "form d-flex flex-column mt-0",
                                style: {
                                    flex: "1 1 0",
                                    minHeight: 0,
                                    width: "100%"
                                },
                                autoComplete: "off",
                                onSubmit: handleSubmit(onBeforeAgreementSubmit),
                                children: [
                                    /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinGrid, {
                                        container: true,
                                        justifyContent: "center",
                                        columnGap: 4,
                                        children: registrationFields.map((field, i)=>{
                                            var _field_checkbox_description, _field_checkbox, _field_checkbox_description1, _field_checkbox1;
                                            if (field.type === "Text" || field.type === "Number") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, ref: ref, value: value, ...rest }, fieldState: { error: error } })=>{
                                                            const disabled = getFieldDisabledStatus(field.id);
                                                            var _error_message;
                                                            return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                ...rest,
                                                                error: !!error,
                                                                helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                                type: field.type.toLowerCase(),
                                                                autoFocus: i === 0,
                                                                inputRef: ref,
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: value,
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus,
                                                                disabled: disabled,
                                                                sx: (theme)=>({
                                                                        "& .MuiInputBase-input.Mui-disabled": {
                                                                            WebkitTextFillColor: theme.palette.text.primary,
                                                                            opacity: 1
                                                                        },
                                                                        "& .MuiInputLabel-root.Mui-disabled": {
                                                                            color: theme.palette.text.primary,
                                                                            opacity: 0.7
                                                                        }
                                                                    })
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "Email") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            },
                                                            pattern: {
                                                                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                                message: t("manualCheckin:error.email")
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, ref: ref, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                            var _error_message;
                                                            return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                ...rest,
                                                                error: !!error,
                                                                helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                                inputRef: ref,
                                                                autoFocus: i === 0,
                                                                type: (0, $k9qks.isVirtualKeyboardEnabled) ? "text" : "email",
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: rest.value || "",
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "Phone") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            },
                                                            validate: (value)=>{
                                                                return !value || (0, $4b02a3aa0d676adb$export$992e2df24bec72ba)(value) || t("manualCheckin:error.phone");
                                                            }
                                                        },
                                                        render: ({ field: { ref: ref, onChange: onChange, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                            var _error_message;
                                                            return (0, $bhfvP.jsx)((0, $bb50b4d24b214940$export$5d5d29ff8b7e8a02), {
                                                                ...rest,
                                                                error: !!error,
                                                                inputRef: ref,
                                                                variant: "outlined",
                                                                autoFocus: i === 0,
                                                                helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                                defaultCountry: defaultCountry,
                                                                preferredCountries: preferredCountries,
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: rest.value || "",
                                                                onSelect: (e)=>{
                                                                    onInputChange(e);
                                                                    onChange(e.target.value);
                                                                },
                                                                onChange: (input)=>{
                                                                    onChange(input);
                                                                    onCountryInputChange(input);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "EmployeeList") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: "contact",
                                                        rules: {
                                                            ...field.required && {
                                                                required: {
                                                                    value: true,
                                                                    message: t("manualCheckin:error.required")
                                                                },
                                                                validate: {
                                                                    exists: (value)=>{
                                                                        if (!(value && (value === null || value === void 0 ? void 0 : value.id))) return t("manualCheckin:error.required");
                                                                        return true;
                                                                    }
                                                                }
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                            var _value_label;
                                                            var _value_label_length;
                                                            return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                                open: employeeSelectOpen && (contactPreviewEnabled || !(value === null || value === void 0 ? void 0 : value.id) && ((_value_label_length = value === null || value === void 0 ? void 0 : (_value_label = value.label) === null || _value_label === void 0 ? void 0 : _value_label.length) !== null && _value_label_length !== void 0 ? _value_label_length : 0) > 2 || !!(value === null || value === void 0 ? void 0 : value.id)),
                                                                clearOnBlur: true,
                                                                blurOnSelect: true,
                                                                disableClearable: true,
                                                                disablePortal: true,
                                                                autoFocus: i === 0,
                                                                noOptionsText: t("manualCheckin:noOption"),
                                                                // PopperComponent={PopperTop}
                                                                value: !!(value && value.id) ? value : null,
                                                                options: contactList,
                                                                getOptionLabel: (option)=>option.label || "",
                                                                isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                                filterOptions: (options)=>{
                                                                    if (value === null || value === void 0 ? void 0 : value.id) return options.filter((o)=>o.id === value.id);
                                                                    var _value_label;
                                                                    const query = (0, $ff6a04e1584a86ed$export$7e13855abec31c34)((_value_label = value === null || value === void 0 ? void 0 : value.label) !== null && _value_label !== void 0 ? _value_label : "");
                                                                    if (contactPreviewEnabled) {
                                                                        if (!query) return options;
                                                                        return options.filter((o)=>(0, $ff6a04e1584a86ed$export$7e13855abec31c34)(o.label).includes(query));
                                                                    }
                                                                    if (!query || query.length < 3) return [];
                                                                    return options.filter((o)=>(0, $ff6a04e1584a86ed$export$7e13855abec31c34)(o.label).includes(query));
                                                                },
                                                                renderOption: (props, option)=>/*#__PURE__*/ (0, $aNuUP.createElement)("li", {
                                                                        ...props,
                                                                        key: option.id
                                                                    }, option.label),
                                                                onChange: (_event, newValue, reason)=>{
                                                                    if (reason === "selectOption") onChange(newValue);
                                                                },
                                                                onBlur: ()=>{
                                                                    const currentValue = methods.getValues(name);
                                                                    setEmployeeSelectOpen(false);
                                                                    if (!!(currentValue && currentValue.id)) return;
                                                                    if (keyboard.current) keyboard.current.setInput("", name);
                                                                    onChange(undefined);
                                                                },
                                                                inputValue: !!(value && value.label) ? value.label : "",
                                                                renderInput: (params)=>{
                                                                    var _error_message;
                                                                    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                        ...params,
                                                                        error: !!error,
                                                                        helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                                        type: "text",
                                                                        name: "contact",
                                                                        variant: "outlined",
                                                                        autoCapitalize: "sentences",
                                                                        label: field.label + (field.required ? " *" : ""),
                                                                        className: error && "error__field",
                                                                        onChange: (event)=>{
                                                                            const { target: { value: value } } = event;
                                                                            onInputChange(event);
                                                                            onChange({
                                                                                label: value
                                                                            });
                                                                        },
                                                                        onSelect: onInputSelect,
                                                                        inputProps: {
                                                                            ...params.inputProps,
                                                                            onFocus: (e)=>{
                                                                                setEmployeeSelectOpen(true);
                                                                                onInputFocus(e);
                                                                            }
                                                                        }
                                                                    });
                                                                }
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "Dropdown") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                            var _field_dropdownOptions, _field_dropdownOptions1;
                                                            let height = "0";
                                                            if ((_field_dropdownOptions = field.dropdownOptions) === null || _field_dropdownOptions === void 0 ? void 0 : _field_dropdownOptions.length) {
                                                                height = "24rem";
                                                                if (field.dropdownOptions.length === 2) height = "17rem";
                                                                if (field.dropdownOptions.length === 1) height = "9rem";
                                                            }
                                                            var _error_message;
                                                            return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
                                                                fullWidth: true,
                                                                error: !!error,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a75413bd2bd509d5$export$2e2bcd8739ae039), {
                                                                        children: field.label + (field.required ? " *" : "")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22932f6b5a031346$export$2e2bcd8739ae039), {
                                                                        value: value || "",
                                                                        onChange: (event)=>onChange(event.target.value),
                                                                        label: field.label + (field.required ? " *" : ""),
                                                                        MenuProps: {
                                                                            PaperProps: {
                                                                                sx: {
                                                                                    marginTop: "1rem !important",
                                                                                    height: height
                                                                                }
                                                                            }
                                                                        },
                                                                        children: (_field_dropdownOptions1 = field.dropdownOptions) === null || _field_dropdownOptions1 === void 0 ? void 0 : _field_dropdownOptions1.map((option)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
                                                                                value: option.value,
                                                                                children: option.label
                                                                            }, option.value))
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), {
                                                                        children: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " "
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "RadioButtons") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                            var _field_radioButtons_buttons, _field_radioButtons, _field_radioButtons1;
                                                            var _error_message;
                                                            return (0, $bhfvP.jsxs)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
                                                                fullWidth: true,
                                                                error: !!error,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                                        variant: "h4",
                                                                        className: "mb-2",
                                                                        children: field.label + (field.required ? " *" : "")
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $e1871041eddbc6dd$export$2e2bcd8739ae039), {
                                                                        name: name,
                                                                        value: value,
                                                                        onChange: (event)=>{
                                                                            const selectedValue = event.target.value;
                                                                            onChange(selectedValue);
                                                                        },
                                                                        children: [
                                                                            (_field_radioButtons = field.radioButtons) === null || _field_radioButtons === void 0 ? void 0 : (_field_radioButtons_buttons = _field_radioButtons.buttons) === null || _field_radioButtons_buttons === void 0 ? void 0 : _field_radioButtons_buttons.map((option)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                                    value: option.value,
                                                                                    onChange: ()=>{
                                                                                        setIsOtherSelected(false);
                                                                                        setCustomOtherValue("");
                                                                                    },
                                                                                    control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9e28f53eb94d78d4$export$2e2bcd8739ae039), {
                                                                                        sx: {
                                                                                            transform: "scale(2)"
                                                                                        }
                                                                                    }),
                                                                                    label: /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: "2.5rem",
                                                                                            marginLeft: "1rem"
                                                                                        },
                                                                                        children: option.label
                                                                                    }),
                                                                                    style: {
                                                                                        marginLeft: 0,
                                                                                        marginBottom: "0.75rem"
                                                                                    }
                                                                                }, option.value)),
                                                                            ((_field_radioButtons1 = field.radioButtons) === null || _field_radioButtons1 === void 0 ? void 0 : _field_radioButtons1.hasOther) && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                                        value: customOtherValue,
                                                                                        control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9e28f53eb94d78d4$export$2e2bcd8739ae039), {
                                                                                            sx: {
                                                                                                transform: "scale(2)"
                                                                                            }
                                                                                        }),
                                                                                        label: /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                                                                                            style: {
                                                                                                fontSize: "2.5rem",
                                                                                                marginLeft: "1rem"
                                                                                            },
                                                                                            children: t("manualCheckin:placeholder.other")
                                                                                        }),
                                                                                        style: {
                                                                                            marginLeft: 0
                                                                                        },
                                                                                        onChange: ()=>{
                                                                                            setIsOtherSelected(true);
                                                                                            setCustomOtherValue("");
                                                                                            onChange("");
                                                                                        }
                                                                                    }, "other"),
                                                                                    isOtherSelected && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                                        fullWidth: true,
                                                                                        variant: "outlined",
                                                                                        placeholder: "Enter your option",
                                                                                        value: customOtherValue,
                                                                                        onChange: (e)=>{
                                                                                            setCustomOtherValue(e.target.value);
                                                                                            onChange(e.target.value);
                                                                                        },
                                                                                        style: {
                                                                                            marginTop: "1rem",
                                                                                            fontSize: "2rem"
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), {
                                                                        children: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " "
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                            if (field.type === "Checkbox") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsxs)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h4",
                                                            children: field.label
                                                        }),
                                                        ((_field_checkbox = field.checkbox) === null || _field_checkbox === void 0 ? void 0 : (_field_checkbox_description = _field_checkbox.description) === null || _field_checkbox_description === void 0 ? void 0 : _field_checkbox_description.title) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h4",
                                                            className: "fs-3",
                                                            children: field.checkbox.description.title
                                                        }),
                                                        ((_field_checkbox1 = field.checkbox) === null || _field_checkbox1 === void 0 ? void 0 : (_field_checkbox_description1 = _field_checkbox1.description) === null || _field_checkbox_description1 === void 0 ? void 0 : _field_checkbox_description1.text) && /*#__PURE__*/ (0, $bhfvP.jsx)("p", {
                                                            style: {
                                                                fontSize: "1.85rem"
                                                            },
                                                            children: field.checkbox.description.text
                                                        }),
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                            name: `info.${field.name || field.code}`,
                                                            render: ({ field: { onChange: onChange, ...rest }, fieldState: { error: error } })=>{
                                                                var _field_checkbox;
                                                                return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                    control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8ae3ab071636d4be$export$2e2bcd8739ae039), {
                                                                        ...rest,
                                                                        defaultChecked: false,
                                                                        onChange: (event)=>{
                                                                            onChange(event.target.checked);
                                                                        },
                                                                        sx: {
                                                                            "& .MuiSvgIcon-root": {
                                                                                fontSize: "3rem"
                                                                            }
                                                                        }
                                                                    }),
                                                                    label: (_field_checkbox = field.checkbox) === null || _field_checkbox === void 0 ? void 0 : _field_checkbox.label,
                                                                    sx: {
                                                                        marginBottom: "2rem",
                                                                        "& .MuiFormControlLabel-label": {
                                                                            fontSize: "2.5rem"
                                                                        }
                                                                    }
                                                                });
                                                            }
                                                        })
                                                    ]
                                                })
                                            }, field.code);
                                            return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                                disabled: !mainRoute,
                                                delay: 0.4 + i * 0.06,
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$var$ManualCheckinField, {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `info.${field.name || field.code}`,
                                                        rules: {
                                                            ...field.required && {
                                                                required: t("manualCheckin:error.required")
                                                            }
                                                        },
                                                        render: ({ field: { onChange: onChange, ref: ref, value: value, ...rest }, fieldState: { error: error } })=>{
                                                            const disabled = getFieldDisabledStatus(field.id);
                                                            var _error_message;
                                                            return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                ...rest,
                                                                error: !!error,
                                                                helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                                inputRef: ref,
                                                                autoFocus: i === 0,
                                                                variant: "outlined",
                                                                label: field.label + (field.required ? " *" : ""),
                                                                value: value,
                                                                onSelect: onInputSelect,
                                                                onChange: (event)=>{
                                                                    const { target: { value: value } } = event;
                                                                    onInputChange(event);
                                                                    onChange(value);
                                                                },
                                                                className: error && "error__field",
                                                                onFocus: onInputFocus,
                                                                autoComplete: "chrome-off",
                                                                disabled: disabled
                                                            });
                                                        }
                                                    })
                                                })
                                            }, field.code);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "center",
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                            disabled: !mainRoute,
                                            delay: 0.6,
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                                className: "mt-5",
                                                style: {
                                                    width: "56.5rem",
                                                    paddingBottom: "5rem"
                                                },
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                                    variant: "contained",
                                                    className: "w-100",
                                                    style: {
                                                        transform: "translateX(-1rem)"
                                                    },
                                                    onClick: handleSubmit(onBeforeAgreementSubmit),
                                                    children: btnOverride || t("manualCheckin:btn")
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        status !== "idle" && !calling && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                            status: status,
                            title: // @ts-ignore
                            localizedTitle !== null && localizedTitle !== void 0 ? localizedTitle : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${translationKey}.title`
                            }),
                            message: localizedMessage !== null && localizedMessage !== void 0 ? localizedMessage : // @ts-ignore
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${translationKey}.message`
                            }),
                            onDismiss: onDismiss
                        }),
                        (0, $k9qks.isVirtualKeyboardEnabled) && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e81413a0b5db7291$export$2e2bcd8739ae039), {
                aggrements: requestStatus === "idle" ? pendingAgreements : [],
                onDismiss: ()=>{
                    return navigate("/");
                },
                onAccept: onAcceptAgreement
            }),
            photoRequired && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c967df95bbff7b87$export$2e2bcd8739ae039), {
                onClose: onPhotoDialogClose,
                onAccept: onAcceptPhoto,
                required: isPhotoCaptureRequiredForVisitors
            }),
            showDocScanInvalid && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                status: "error",
                title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: "manualCheckin:documentScan.invalid.title"
                }),
                message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: "manualCheckin:documentScan.invalid.message"
                }),
                onDismiss: ()=>setShowDocScanInvalid(false)
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {}),
            doorModal
        ]
    });
};
var $51e8f738038336ca$export$2e2bcd8739ae039 = $51e8f738038336ca$var$ManualCheckin;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");


























var $cD0nt = parcelRequire("cD0nt");

var $k9qks = parcelRequire("k9qks");
const $1dd93def3f756822$var$MissingFieldsGrid = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $23610b7fd899719e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        paddingTop: "3rem",
        flex: "0 1 auto",
        minHeight: 0,
        overflowY: "auto",
        alignContent: "flex-start",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
            width: "2rem"
        },
        "&::-webkit-scrollbar-track": {
            background: theme.palette.primary.light,
            borderRadius: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
            borderRadius: "8px"
        }
    }));
const $1dd93def3f756822$var$MissingFieldsRow = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div)(()=>({
        marginBottom: "1.75rem",
        width: "56.5rem",
        "@media screen and (orientation: landscape)": {
            width: "50rem"
        }
    }));
const $1dd93def3f756822$var$localize = (source, language)=>{
    if (!source) return "";
    return source[language] || source.en || Object.values(source)[0] || "";
};
const $1dd93def3f756822$var$getFieldType = (code, fields)=>{
    var _fields_find;
    return (_fields_find = fields.find((f)=>f.code === code)) === null || _fields_find === void 0 ? void 0 : _fields_find.type;
};
const $1dd93def3f756822$var$getLayoutForFieldAndValue = (layout, type, value = "")=>{
    switch(type){
        case "Text":
            if (!value || value.slice(-1) === " ") return "default-shift";
            return "default";
        case "Phone":
            return "phone-pad";
        case "Number":
            return "pin";
        case "Email":
            return "email";
        default:
            return layout;
    }
};
const $1dd93def3f756822$var$MissingFields = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)();
    const navigate = (0, $9B9bN.useNavigate)();
    const { code: code } = (0, $9B9bN.useParams)();
    const { state: state } = (0, $9B9bN.useLocation)();
    const { fields: fields = [], photo: photo = null, action: action = "checkin" } = state || {};
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const languages = (0, $bad2beece3d2a513$export$38be4353f99148d)();
    const drCountry = (0, $cD0nt.useDigitalReceptionCountry)();
    const drCountryCode = (0, $eZVvM.useMemo)(()=>drCountry ? (0, $2f526e07c519dc18$export$9a0a9c75ccef13fb)(drCountry) : null, [
        drCountry
    ]);
    const defaultCountry = (0, $eZVvM.useMemo)(()=>{
        if (drCountryCode) return drCountryCode;
        if ([
            "nl",
            "fr",
            "de",
            "pt",
            "es",
            "pl",
            "it"
        ].includes(language)) return language.toUpperCase();
        if (language === "en") return "GB";
        if (language === "en_US") return "US";
        return undefined;
    }, [
        language,
        drCountryCode
    ]);
    const preferredCountries = (0, $eZVvM.useMemo)(()=>(drCountryCode ? [
            drCountryCode
        ] : []).concat(languages.flatMap((lang)=>{
            if ([
                "nl",
                "fr",
                "de",
                "pt",
                "es",
                "pl",
                "it"
            ].includes(lang)) return [
                lang.toUpperCase()
            ];
            if (lang === "en") return "GB";
            if (lang === "en_US") return [
                "US"
            ];
            return [];
        })), [
        languages,
        drCountryCode
    ]);
    const sortedFields = (0, $eZVvM.useMemo)(()=>[
            ...fields
        ].sort((a, b)=>{
            var _a_order, _b_order;
            return ((_a_order = a.order) !== null && _a_order !== void 0 ? _a_order : 0) - ((_b_order = b.order) !== null && _b_order !== void 0 ? _b_order : 0);
        }), [
        fields
    ]);
    const defaultValues = (0, $eZVvM.useMemo)(()=>({
            values: sortedFields.reduce((acc, field)=>{
                acc[field.code] = field.type === "Checkbox" ? false : "";
                return acc;
            }, {})
        }), [
        sortedFields
    ]);
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: defaultValues,
        mode: "onSubmit"
    });
    const { handleSubmit: handleSubmit, control: control, setValue: setValue, getValues: getValues } = methods;
    const [layout, setLayout] = (0, $eZVvM.useState)("default-shift");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)(sortedFields[0] ? `values.${sortedFields[0].code}` : undefined);
    const [otherByField, setOtherByField] = (0, $eZVvM.useState)({});
    const [customOtherValueByField, setCustomOtherValueByField] = (0, $eZVvM.useState)({});
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(()=>{
        if (!sortedFields[0]) return;
        setLayout((prev)=>$1dd93def3f756822$var$getLayoutForFieldAndValue(prev, sortedFields[0].type, ""));
    }, [
        sortedFields
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && [
            "INPUT",
            "TEXTAREA"
        ].includes((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName)) return;
        setFocusedInput(undefined);
    });
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        if (!keyboard.current) return;
        const fieldCode = (name === null || name === void 0 ? void 0 : name.split(".").pop()) || "";
        setLayout((prev)=>$1dd93def3f756822$var$getLayoutForFieldAndValue(prev, $1dd93def3f756822$var$getFieldType(fieldCode, sortedFields), value));
        setFocusedInput(name);
    }, [
        sortedFields
    ]);
    const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event;
        if (!keyboard.current) return;
        const fieldCode = (name === null || name === void 0 ? void 0 : name.split(".").pop()) || "";
        setLayout((prev)=>$1dd93def3f756822$var$getLayoutForFieldAndValue(prev, $1dd93def3f756822$var$getFieldType(fieldCode, sortedFields), value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, [
        sortedFields
    ]);
    const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (typeof selectionStart !== "number" || typeof selectionEnd !== "number") return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        if (!focusedInput) return;
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        const prevValue = getValues(focusedInput) || "";
        const fieldCode = focusedInput.split(".").pop() || "";
        setLayout((prev)=>$1dd93def3f756822$var$getLayoutForFieldAndValue(prev, $1dd93def3f756822$var$getFieldType(fieldCode, sortedFields), value));
        setValue(focusedInput, value);
        if (input) {
            var _keyboard_current;
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            const type = $1dd93def3f756822$var$getFieldType(fieldCode, sortedFields);
            if (type === "Phone" || type === "Number") (_keyboard_current = keyboard.current) === null || _keyboard_current === void 0 ? void 0 : _keyboard_current.setCaretPosition(prevValue.length < value.length ? prevValue.length + 1 : value.length, prevValue.length < value.length ? prevValue.length + 1 : value.length);
            else input.setSelectionRange(next, next);
        }
    }, [
        focusedInput,
        sortedFields,
        getValues,
        setValue
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((l)=>l.endsWith("alt") ? l.split("-").shift() : `${l.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((l)=>l.endsWith("shift") ? l.split("-").shift() : `${l.split("-").shift()}-shift`);
    }, []);
    const onSubmit = (0, $eZVvM.useCallback)(({ values: values })=>{
        const customFieldValues = Object.fromEntries(Object.entries(values).map(([key, raw])=>{
            const field = sortedFields.find((f)=>f.code === key);
            if ((field === null || field === void 0 ? void 0 : field.type) === "Phone" && typeof raw === "string" && raw) try {
                return [
                    key,
                    (0, $2bc546ee6dbb8ac5$export$176bb591929cc9a8)(raw).number
                ];
            } catch (e) {
                return [
                    key,
                    raw
                ];
            }
            return [
                key,
                raw
            ];
        }));
        navigate(`/access/${action}/${code}`, {
            replace: true,
            state: {
                customFieldValues: customFieldValues,
                photo: photo
            }
        });
    }, [
        sortedFields,
        navigate,
        action,
        code,
        photo
    ]);
    if (!code || sortedFields.length === 0) {
        navigate("/", {
            replace: true
        });
        return null;
    }
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), {
            ...methods,
            children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column h-100",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: "/"
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        className: "mb-5 text-center",
                        style: {
                            margin: "0 10rem"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h1",
                                children: t("missingFields:title", "A few more details before check-in")
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h3",
                                className: "font-weight-regular pt-3",
                                children: t("missingFields:subtitle", "Fields marked * are required")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("form", {
                        className: "form d-flex flex-column mt-0",
                        style: {
                            flex: "1 1 0",
                            minHeight: 0,
                            width: "100%"
                        },
                        autoComplete: "off",
                        onSubmit: handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsGrid, {
                                container: true,
                                justifyContent: "center",
                                columnGap: 4,
                                children: sortedFields.map((field, i)=>{
                                    const label = $1dd93def3f756822$var$localize(field.label, language) + (field.required ? " *" : "");
                                    const requiredRule = field.required ? {
                                        required: t("missingFields:error.required", "Required")
                                    } : {};
                                    if (field.type === "Text" || field.type === "Number") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                        delay: 0.4 + i * 0.06,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsRow, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                name: `values.${field.code}`,
                                                control: control,
                                                rules: requiredRule,
                                                render: ({ field: { onChange: onChange, ref: ref, value: value, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                    var _error_message;
                                                    return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                        ...rest,
                                                        error: !!error,
                                                        helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                        type: field.type.toLowerCase(),
                                                        autoFocus: i === 0,
                                                        inputRef: ref,
                                                        variant: "outlined",
                                                        label: label,
                                                        value: value !== null && value !== void 0 ? value : "",
                                                        onSelect: onInputSelect,
                                                        onFocus: onInputFocus,
                                                        onChange: (e)=>{
                                                            onInputChange(e);
                                                            onChange(e.target.value);
                                                        },
                                                        className: error ? "error__field" : undefined
                                                    });
                                                }
                                            })
                                        })
                                    }, field.code);
                                    if (field.type === "Email") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                        delay: 0.4 + i * 0.06,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsRow, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                name: `values.${field.code}`,
                                                control: control,
                                                rules: {
                                                    ...requiredRule,
                                                    pattern: {
                                                        value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                        message: t("missingFields:error.email", "Invalid email address")
                                                    }
                                                },
                                                render: ({ field: { onChange: onChange, ref: ref, value: value, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                    var _error_message;
                                                    return (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                        ...rest,
                                                        error: !!error,
                                                        helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                        inputRef: ref,
                                                        autoFocus: i === 0,
                                                        type: (0, $k9qks.isVirtualKeyboardEnabled) ? "text" : "email",
                                                        variant: "outlined",
                                                        label: label,
                                                        value: value !== null && value !== void 0 ? value : "",
                                                        onSelect: onInputSelect,
                                                        onFocus: onInputFocus,
                                                        onChange: (e)=>{
                                                            onInputChange(e);
                                                            onChange(e.target.value);
                                                        },
                                                        className: error ? "error__field" : undefined
                                                    });
                                                }
                                            })
                                        })
                                    }, field.code);
                                    if (field.type === "Phone") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                        delay: 0.4 + i * 0.06,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsRow, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                name: `values.${field.code}`,
                                                control: control,
                                                rules: {
                                                    ...requiredRule,
                                                    validate: (value)=>!value || typeof value !== "string" || (0, $4b02a3aa0d676adb$export$992e2df24bec72ba)(value) || t("missingFields:error.phone", "Invalid phone number")
                                                },
                                                render: ({ field: { ref: ref, onChange: onChange, value: value, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                    var _error_message;
                                                    return (0, $bhfvP.jsx)((0, $bb50b4d24b214940$export$5d5d29ff8b7e8a02), {
                                                        ...rest,
                                                        error: !!error,
                                                        inputRef: ref,
                                                        variant: "outlined",
                                                        autoFocus: i === 0,
                                                        helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                        defaultCountry: defaultCountry,
                                                        preferredCountries: preferredCountries,
                                                        label: label,
                                                        value: value || "",
                                                        onSelect: (e)=>{
                                                            onInputChange(e);
                                                            onChange(e.target.value);
                                                        },
                                                        onChange: (input)=>onChange(input),
                                                        onFocus: onInputFocus,
                                                        className: error ? "error__field" : undefined
                                                    });
                                                }
                                            })
                                        })
                                    }, field.code);
                                    if (field.type === "Dropdown") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                        delay: 0.4 + i * 0.06,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsRow, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                name: `values.${field.code}`,
                                                control: control,
                                                rules: requiredRule,
                                                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>{
                                                    var _field_dropdownOptions, _field_dropdownOptions1;
                                                    let height = "0";
                                                    if ((_field_dropdownOptions = field.dropdownOptions) === null || _field_dropdownOptions === void 0 ? void 0 : _field_dropdownOptions.length) {
                                                        height = "24rem";
                                                        if (field.dropdownOptions.length === 2) height = "17rem";
                                                        if (field.dropdownOptions.length === 1) height = "9rem";
                                                    }
                                                    var _error_message;
                                                    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
                                                        fullWidth: true,
                                                        error: !!error,
                                                        children: [
                                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a75413bd2bd509d5$export$2e2bcd8739ae039), {
                                                                children: label
                                                            }),
                                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22932f6b5a031346$export$2e2bcd8739ae039), {
                                                                value: value || "",
                                                                onChange: (e)=>onChange(e.target.value),
                                                                label: label,
                                                                MenuProps: {
                                                                    PaperProps: {
                                                                        sx: {
                                                                            marginTop: "1rem !important",
                                                                            height: height
                                                                        }
                                                                    }
                                                                },
                                                                children: (_field_dropdownOptions1 = field.dropdownOptions) === null || _field_dropdownOptions1 === void 0 ? void 0 : _field_dropdownOptions1.map((option)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
                                                                        value: option.value,
                                                                        children: $1dd93def3f756822$var$localize(option, language)
                                                                    }, option.value))
                                                            }),
                                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), {
                                                                children: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " "
                                                            })
                                                        ]
                                                    });
                                                }
                                            })
                                        })
                                    }, field.code);
                                    if (field.type === "RadioButtons") {
                                        const OTHER_RADIO_VALUE = "__other__";
                                        const isOtherSelected = !!otherByField[field.code];
                                        const customOtherValue = customOtherValueByField[field.code] || "";
                                        return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                            delay: 0.4 + i * 0.06,
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$var$MissingFieldsRow, {
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                    name: `values.${field.code}`,
                                                    control: control,
                                                    rules: requiredRule,
                                                    render: ({ field: { onChange: onChange, value: value, name: name }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                        var _field_radioButtons_buttons, _field_radioButtons, _field_radioButtons1;
                                                        var _error_message;
                                                        return (0, $bhfvP.jsxs)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
                                                            fullWidth: true,
                                                            error: !!error,
                                                            children: [
                                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                                    variant: "h4",
                                                                    className: "mb-2",
                                                                    children: label
                                                                }),
                                                                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $e1871041eddbc6dd$export$2e2bcd8739ae039), {
                                                                    name: name,
                                                                    value: isOtherSelected ? OTHER_RADIO_VALUE : value !== null && value !== void 0 ? value : "",
                                                                    onChange: (e)=>{
                                                                        const v = e.target.value;
                                                                        if (v === OTHER_RADIO_VALUE) {
                                                                            setOtherByField((prev)=>({
                                                                                    ...prev,
                                                                                    [field.code]: true
                                                                                }));
                                                                            setCustomOtherValueByField((prev)=>({
                                                                                    ...prev,
                                                                                    [field.code]: ""
                                                                                }));
                                                                            onChange("");
                                                                        } else {
                                                                            setOtherByField((prev)=>({
                                                                                    ...prev,
                                                                                    [field.code]: false
                                                                                }));
                                                                            setCustomOtherValueByField((prev)=>({
                                                                                    ...prev,
                                                                                    [field.code]: ""
                                                                                }));
                                                                            onChange(v);
                                                                        }
                                                                    },
                                                                    children: [
                                                                        (_field_radioButtons = field.radioButtons) === null || _field_radioButtons === void 0 ? void 0 : (_field_radioButtons_buttons = _field_radioButtons.buttons) === null || _field_radioButtons_buttons === void 0 ? void 0 : _field_radioButtons_buttons.map((option)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                                value: option.value,
                                                                                control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9e28f53eb94d78d4$export$2e2bcd8739ae039), {
                                                                                    sx: {
                                                                                        transform: "scale(2)"
                                                                                    }
                                                                                }),
                                                                                label: /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                                                                                    style: {
                                                                                        fontSize: "2.5rem",
                                                                                        marginLeft: "1rem"
                                                                                    },
                                                                                    children: $1dd93def3f756822$var$localize(option, language)
                                                                                }),
                                                                                style: {
                                                                                    marginLeft: 0,
                                                                                    marginBottom: "0.75rem"
                                                                                }
                                                                            }, option.value)),
                                                                        ((_field_radioButtons1 = field.radioButtons) === null || _field_radioButtons1 === void 0 ? void 0 : _field_radioButtons1.hasOther) && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                                    value: OTHER_RADIO_VALUE,
                                                                                    control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9e28f53eb94d78d4$export$2e2bcd8739ae039), {
                                                                                        sx: {
                                                                                            transform: "scale(2)"
                                                                                        }
                                                                                    }),
                                                                                    label: /*#__PURE__*/ (0, $bhfvP.jsx)("span", {
                                                                                        style: {
                                                                                            fontSize: "2.5rem",
                                                                                            marginLeft: "1rem"
                                                                                        },
                                                                                        children: t("missingFields:placeholder.other", "Other...")
                                                                                    }),
                                                                                    style: {
                                                                                        marginLeft: 0
                                                                                    }
                                                                                }, "other"),
                                                                                isOtherSelected && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                                                    fullWidth: true,
                                                                                    variant: "outlined",
                                                                                    placeholder: t("missingFields:placeholder.otherInput", "Enter your option"),
                                                                                    value: customOtherValue,
                                                                                    onChange: (e)=>{
                                                                                        setCustomOtherValueByField((prev)=>({
                                                                                                ...prev,
                                                                                                [field.code]: e.target.value
                                                                                            }));
                                                                                        onChange(e.target.value);
                                                                                    },
                                                                                    style: {
                                                                                        marginTop: "1rem",
                                                                                        fontSize: "2rem"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), {
                                                                    children: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " "
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            })
                                        }, field.code);
                                    }
                                    if (field.type === "Checkbox") {
                                        var _field_checkbox, _field_checkbox_description, _field_checkbox1, _field_checkbox_description1, _field_checkbox2;
                                        const checkboxLabel = $1dd93def3f756822$var$localize((_field_checkbox = field.checkbox) === null || _field_checkbox === void 0 ? void 0 : _field_checkbox.label, language);
                                        const descTitle = $1dd93def3f756822$var$localize((_field_checkbox1 = field.checkbox) === null || _field_checkbox1 === void 0 ? void 0 : (_field_checkbox_description = _field_checkbox1.description) === null || _field_checkbox_description === void 0 ? void 0 : _field_checkbox_description.title, language);
                                        const descText = $1dd93def3f756822$var$localize((_field_checkbox2 = field.checkbox) === null || _field_checkbox2 === void 0 ? void 0 : (_field_checkbox_description1 = _field_checkbox2.description) === null || _field_checkbox_description1 === void 0 ? void 0 : _field_checkbox_description1.text, language);
                                        return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                            delay: 0.4 + i * 0.06,
                                            children: /*#__PURE__*/ (0, $bhfvP.jsxs)($1dd93def3f756822$var$MissingFieldsRow, {
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h4",
                                                        children: label
                                                    }),
                                                    descTitle && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h4",
                                                        className: "fs-3",
                                                        children: descTitle
                                                    }),
                                                    descText && /*#__PURE__*/ (0, $bhfvP.jsx)("p", {
                                                        style: {
                                                            fontSize: "1.85rem"
                                                        },
                                                        children: descText
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                                        name: `values.${field.code}`,
                                                        control: control,
                                                        rules: field.required ? {
                                                            validate: (v)=>v === true || t("missingFields:error.required", "Required")
                                                        } : {},
                                                        render: ({ field: { onChange: onChange, value: value, ...rest }, fieldState: { error: error } })=>/*#__PURE__*/ {
                                                            var _error_message;
                                                            return (0, $bhfvP.jsxs)((0, $0fad4ddd6eb88026$export$2e2bcd8739ae039), {
                                                                error: !!error,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $22c108142293b90b$export$2e2bcd8739ae039), {
                                                                        control: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8ae3ab071636d4be$export$2e2bcd8739ae039), {
                                                                            ...rest,
                                                                            checked: !!value,
                                                                            onChange: (e)=>onChange(e.target.checked),
                                                                            sx: {
                                                                                "& .MuiSvgIcon-root": {
                                                                                    fontSize: "3rem"
                                                                                }
                                                                            }
                                                                        }),
                                                                        label: checkboxLabel,
                                                                        sx: {
                                                                            marginBottom: "1rem",
                                                                            "& .MuiFormControlLabel-label": {
                                                                                fontSize: "2.5rem"
                                                                            }
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $3e2316ee7e27c519$export$2e2bcd8739ae039), {
                                                                        children: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " "
                                                                    })
                                                                ]
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        }, field.code);
                                    }
                                    return null;
                                })
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "center",
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    delay: 0.6,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                        className: "mt-5",
                                        style: {
                                            width: "56.5rem",
                                            paddingBottom: "5rem"
                                        },
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            className: "w-100",
                                            style: {
                                                transform: "translateX(-1rem)"
                                            },
                                            type: "submit",
                                            children: t("missingFields:btn", "Continue check-in")
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    (0, $k9qks.isVirtualKeyboardEnabled) && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        ref: keyboardBox,
                        className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                            keyboard__out: !focusedInput
                        }),
                        onClick: (e)=>{
                            e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                            ref: keyboard,
                            layoutName: layout,
                            inputName: focusedInput,
                            onChange: onKeyboardChange,
                            onKeyPress: onKeyboardKeyPress
                        })
                    })
                ]
            })
        })
    });
};
var $1dd93def3f756822$export$2e2bcd8739ae039 = $1dd93def3f756822$var$MissingFields;



var $bhfvP = parcelRequire("bhfvP");

var $aNuUP = parcelRequire("aNuUP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $dMu0R = parcelRequire("dMu0R");



var $8TMnn = parcelRequire("8TMnn");













var $jnPOB = parcelRequire("jnPOB");





var $kCXUJ = parcelRequire("kCXUJ");

var $cD0nt = parcelRequire("cD0nt");


const $1d90c3166f8c2150$var$ManualCheckout = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)();
    const navigate = (0, $9B9bN.useNavigate)();
    const [layout, setLayout] = (0, $eZVvM.useState)("default");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("name");
    const identificationCode = (0, $cD0nt.useIdentificationCode)();
    const { isAccessAllowedForEmployeesForCheckout: isAccessAllowedForEmployeesForCheckout, isAccessAllowedForVisitorsForCheckout: isAccessAllowedForVisitorsForCheckout, isAccessAllowedForGuestsForCheckout: isAccessAllowedForGuestsForCheckout, isAccessAllowedForMeetingAttendeesForCheckout: isAccessAllowedForMeetingAttendeesForCheckout, isAccessEnabledForAutoOpenForCheckout: isAccessEnabledForAutoOpenForCheckout, accessController: accessController } = (0, $cD0nt.useAccessSettings)();
    const { trigger: triggerAutoSwitch, doorModal: doorModal } = (0, $325562920a04a1bd$export$27b435a0411fd08e)();
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const [nameForList, setNameForList] = (0, $eZVvM.useState)("");
    const [checkoutList, setCheckoutList] = (0, $eZVvM.useState)([]);
    const { checkout: checkout } = (0, $cD0nt.useLayout)();
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: {
            name: undefined
        },
        mode: "onSubmit"
    });
    const { isLoading: isLoading } = (0, $dMu0R.useQuery)([
        "currentlyCheckedIn",
        {
            filter: {
                owner: {
                    fullName: nameForList,
                    guestMatch: {
                        code: identificationCode,
                        value: nameForList
                    }
                }
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_CURRENTLY_CHECKED_IN), variables), {
        enabled: nameForList.length === 2,
        onSuccess: (data)=>{
            var _data_currentlyCheckedIn;
            const list = (0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(data === null || data === void 0 ? void 0 : (_data_currentlyCheckedIn = data.currentlyCheckedIn) === null || _data_currentlyCheckedIn === void 0 ? void 0 : _data_currentlyCheckedIn.events, (accessEvent)=>{
                var _owner_fields_find;
                const owner = (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "owner");
                let label = "";
                if ("fullName" in owner) label = owner.fullName;
                else if ("fields" in owner) label = ((_owner_fields_find = owner.fields.find((field)=>field.name === "fullName" || field.name === identificationCode)) === null || _owner_fields_find === void 0 ? void 0 : _owner_fields_find.value) || "";
                return {
                    label: label,
                    id: accessEvent.owner.id
                };
            });
            setCheckoutList(list);
        }
    });
    (0, $eZVvM.useEffect)(()=>{
        if (nameForList.length < 3) setCheckoutList([]);
    }, [
        nameForList
    ]);
    const { data: data, status: requestStatus, mutate: onCheckoutOwner, reset: reset } = (0, $084aaf38c3338203$export$609860bf8b0084c)(async (id)=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$a4a94ec8659e687e), {
            id: id
        });
    });
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const willNavigateToCheckoutAccessControl = (0, $eZVvM.useMemo)(()=>{
        var _data_checkOutOwner, _data_checkOutOwner1, _data_checkOutOwner2, _data_checkOutOwner3;
        return (data === null || data === void 0 ? void 0 : (_data_checkOutOwner = data.checkOutOwner) === null || _data_checkOutOwner === void 0 ? void 0 : _data_checkOutOwner.type) === "Employee" && isAccessAllowedForEmployeesForCheckout || (data === null || data === void 0 ? void 0 : (_data_checkOutOwner1 = data.checkOutOwner) === null || _data_checkOutOwner1 === void 0 ? void 0 : _data_checkOutOwner1.type) === "MeetingAttendee" && isAccessAllowedForMeetingAttendeesForCheckout || (data === null || data === void 0 ? void 0 : (_data_checkOutOwner2 = data.checkOutOwner) === null || _data_checkOutOwner2 === void 0 ? void 0 : _data_checkOutOwner2.type) === "Visitor" && isAccessAllowedForVisitorsForCheckout || (data === null || data === void 0 ? void 0 : (_data_checkOutOwner3 = data.checkOutOwner) === null || _data_checkOutOwner3 === void 0 ? void 0 : _data_checkOutOwner3.type) === "Guest" && isAccessAllowedForGuestsForCheckout;
    }, [
        data,
        isAccessAllowedForMeetingAttendeesForCheckout,
        isAccessAllowedForVisitorsForCheckout,
        isAccessAllowedForEmployeesForCheckout,
        isAccessAllowedForGuestsForCheckout
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (status === "success") {
            if (willNavigateToCheckoutAccessControl) {
                if (isAccessEnabledForAutoOpenForCheckout && accessController) return triggerAutoSwitch(accessController);
                return navigate(`/access-control/${accessController}`, {
                    replace: true
                });
            }
        }
        if (status === "error") return reset();
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data,
        accessController,
        willNavigateToCheckoutAccessControl,
        isAccessEnabledForAutoOpenForCheckout,
        triggerAutoSwitch
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", _field = "", value = "")=>{
        if (layout === "default-alt") return layout;
        // Capitalize after whitespace and at start
        if (!value || value.slice(-1) === " ") return "default-shift";
        return "default";
    }, []);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        if (value.length === 2) setNameForList(value);
        if (value.length === 1) setNameForList("");
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        if (!focusedInput) return;
        let prevValue = methods.getValues(focusedInput);
        setLayout((prevLayout)=>{
            const nextLayout = getLayoutForFieldAndValue(prevLayout, focusedInput, value);
            return nextLayout;
        });
        if (focusedInput === "name") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            methods.setValue("name", {
                label: value
            });
        } else methods.setValue(focusedInput, value);
        if (!prevValue) return;
        /**
     * Update caret position of text input
     */ if (input) {
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    const onSubmit = (0, $eZVvM.useCallback)((variables)=>{
        return onCheckoutOwner(variables.name.id);
    }, []);
    /**
   * Synchronize text caret position with virtual keyboard
   */ const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        setFocusedInput(name);
    }, []);
    /**
   * Synchronize text input with virtual keyboard
   */ const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event;
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const willNavigateToCheckoutAccessControlPage = (0, $eZVvM.useMemo)(()=>willNavigateToCheckoutAccessControl && !(isAccessEnabledForAutoOpenForCheckout && accessController), [
        willNavigateToCheckoutAccessControl,
        isAccessEnabledForAutoOpenForCheckout,
        accessController
    ]);
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToCheckoutAccessControlPage && status === "success") return "successAccess";
        return status;
    }, [
        willNavigateToCheckoutAccessControlPage,
        status
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), {
                ...methods,
                children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                    className: "d-flex align-items-center flex-column",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                            to: (checkout === null || checkout === void 0 ? void 0 : checkout.enabled) ? "/access/option/checkout" : "/"
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                            className: "page-title",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h1",
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: "manualCheckout:title"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsxs)("form", {
                            className: "form d-flex flex-column",
                            autoComplete: "off",
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    delay: 0.55,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                        className: "search-input",
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                            name: "name",
                                            rules: {
                                                required: {
                                                    value: true,
                                                    message: t("manualCheckout:error.required")
                                                },
                                                validate: {
                                                    exists: (value)=>{
                                                        if (!(value && value.id)) return t("manualCheckout:error.required");
                                                        return true;
                                                    }
                                                }
                                            },
                                            render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                    clearOnBlur: true,
                                                    blurOnSelect: true,
                                                    disableClearable: true,
                                                    loading: isLoading,
                                                    loadingText: t("manualCheckout:form.loading"),
                                                    noOptionsText: t("manualCheckout:form.noOptions"),
                                                    open: nameForList.length > 0,
                                                    onClose: ()=>{
                                                        setNameForList("");
                                                    },
                                                    value: !!(value && value.id) ? value : null,
                                                    options: checkoutList,
                                                    getOptionLabel: (option)=>option.label || "",
                                                    isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                    renderOption: (props, option)=>/*#__PURE__*/ (0, $aNuUP.createElement)("li", {
                                                            ...props,
                                                            key: option.id
                                                        }, option.label),
                                                    onChange: (_event, newValue, reason)=>{
                                                        if (reason === "selectOption") onChange(newValue);
                                                    },
                                                    onBlur: ()=>{
                                                        const currentValue = methods.getValues(name);
                                                        if (!!(currentValue && currentValue.id)) return;
                                                        if (keyboard.current) keyboard.current.setInput("", name);
                                                        onChange(undefined);
                                                    },
                                                    inputValue: !!(value && value.label) ? value.label : "",
                                                    renderInput: (params)=>{
                                                        var _error_message;
                                                        return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                            ...params,
                                                            type: "text",
                                                            name: "name",
                                                            variant: "outlined",
                                                            autoFocus: true,
                                                            error: !!error,
                                                            helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                            label: t("manualCheckout:form.placeholder.name"),
                                                            onChange: (event)=>{
                                                                const { target: { value: value } } = event;
                                                                if (value.length === 2) setNameForList(value);
                                                                if (value.length === 1) setNameForList("");
                                                                onInputChange(event);
                                                                onChange({
                                                                    label: value
                                                                });
                                                            },
                                                            onFocus: onInputFocus,
                                                            onSelect: onInputSelect
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    delay: 0.65,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            onClick: methods.handleSubmit(onSubmit),
                                            className: "mt-4 w-100",
                                            children: t("manualCheckout:btn")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                            mode: "wait",
                            children: status !== "idle" && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                                title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `manualCheckout:status.${statusKey}.title`
                                }),
                                message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `manualCheckout:status.${statusKey}.message`
                                }),
                                status: status,
                                onDismiss: onDismiss
                            })
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {}),
            doorModal
        ]
    });
};
var $1d90c3166f8c2150$export$2e2bcd8739ae039 = $1d90c3166f8c2150$var$ManualCheckout;



var $bhfvP = parcelRequire("bhfvP");

var $aNuUP = parcelRequire("aNuUP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");


var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


















var $jnPOB = parcelRequire("jnPOB");



var $eZVvM = parcelRequire("eZVvM");

var $cD0nt = parcelRequire("cD0nt");

const $90bf2fef1816810d$var$ACCESS_EVENT_TYPE = {
    package: "Package",
    food: "Food"
};
const $90bf2fef1816810d$export$6b25c561f36ba00c = (action)=>{
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    return (0, $eZVvM.useMemo)(()=>{
        var _metadata_message, _texts_title, _texts_message;
        const delivery = metadata === null || metadata === void 0 ? void 0 : (_metadata_message = metadata.message) === null || _metadata_message === void 0 ? void 0 : _metadata_message.delivery;
        const texts = delivery === null || delivery === void 0 ? void 0 : delivery[$90bf2fef1816810d$var$ACCESS_EVENT_TYPE[action]];
        return {
            title: typeof (texts === null || texts === void 0 ? void 0 : (_texts_title = texts.title) === null || _texts_title === void 0 ? void 0 : _texts_title[language]) === "string" ? texts.title[language] : undefined,
            message: typeof (texts === null || texts === void 0 ? void 0 : (_texts_message = texts.message) === null || _texts_message === void 0 ? void 0 : _texts_message[language]) === "string" ? texts.message[language] : undefined,
            durationMs: delivery === null || delivery === void 0 ? void 0 : delivery.durationMs
        };
    }, [
        metadata,
        action,
        language
    ]);
};





var $cD0nt = parcelRequire("cD0nt");


var $k9qks = parcelRequire("k9qks");


var $kCXUJ = parcelRequire("kCXUJ");

var $219y6 = parcelRequire("219y6");
const $2168cd7ff7398c79$var$DeliveryPage = ()=>{
    var _match_params, _metadata_uiOverrides_delivery_flows_action_title, _metadata_uiOverrides_delivery_flows_action, _metadata_uiOverrides_delivery_flows, _metadata_uiOverrides_delivery, _metadata_uiOverrides, _metadata_uiOverrides_delivery_flows_action_subtitle, _metadata_uiOverrides_delivery_flows_action1, _metadata_uiOverrides_delivery_flows1, _metadata_uiOverrides_delivery1, _metadata_uiOverrides1, _metadata_uiOverrides_delivery_flows_action_buttons_submit, _metadata_uiOverrides_delivery_flows_action_buttons, _metadata_uiOverrides_delivery_flows_action2, _metadata_uiOverrides_delivery_flows2, _metadata_uiOverrides_delivery2, _metadata_uiOverrides2, _data_createDeliveryEvent, _receiver_availablePreferences__autoChannel, _receiver_availablePreferences_, _receiver_availablePreferences, _receiver_availablePreferences__autoChannel1, _receiver_availablePreferences_1, _receiver_availablePreferences1, _receiver_availablePreferences__autoChannel2, _receiver_availablePreferences_2, _receiver_availablePreferences2, _receiver_availablePreferences__autoChannel3, _receiver_availablePreferences_3, _receiver_availablePreferences3, _receiver_availablePreferences__autoChannel4, _receiver_availablePreferences_4, _receiver_availablePreferences4, _data_createDeliveryEvent1, _receiver_availablePreferences__autoChannel5, _receiver_availablePreferences_5, _receiver_availablePreferences5;
    const match = (0, $9B9bN.useMatch)({
        path: "/delivery/:action"
    });
    const action = match === null || match === void 0 ? void 0 : (_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.action;
    const namespace = action === "food" ? "foodDelivery" : "packageDelivery";
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/delivery\/${action}\/?$`).test(pathname);
    const { t: t } = (0, $9GLBV.useTranslation)([
        namespace
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const contactPreviewEnabled = (0, $cD0nt.useContactPreviewEnabled)();
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const titleOverride = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides = metadata.uiOverrides) === null || _metadata_uiOverrides === void 0 ? void 0 : (_metadata_uiOverrides_delivery = _metadata_uiOverrides.delivery) === null || _metadata_uiOverrides_delivery === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows = _metadata_uiOverrides_delivery.flows) === null || _metadata_uiOverrides_delivery_flows === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action = _metadata_uiOverrides_delivery_flows[action]) === null || _metadata_uiOverrides_delivery_flows_action === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action_title = _metadata_uiOverrides_delivery_flows_action.title) === null || _metadata_uiOverrides_delivery_flows_action_title === void 0 ? void 0 : _metadata_uiOverrides_delivery_flows_action_title[language];
    const subtitleOverride = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides1 = metadata.uiOverrides) === null || _metadata_uiOverrides1 === void 0 ? void 0 : (_metadata_uiOverrides_delivery1 = _metadata_uiOverrides1.delivery) === null || _metadata_uiOverrides_delivery1 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows1 = _metadata_uiOverrides_delivery1.flows) === null || _metadata_uiOverrides_delivery_flows1 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action1 = _metadata_uiOverrides_delivery_flows1[action]) === null || _metadata_uiOverrides_delivery_flows_action1 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action_subtitle = _metadata_uiOverrides_delivery_flows_action1.subtitle) === null || _metadata_uiOverrides_delivery_flows_action_subtitle === void 0 ? void 0 : _metadata_uiOverrides_delivery_flows_action_subtitle[language];
    const submitButtonOverride = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides2 = metadata.uiOverrides) === null || _metadata_uiOverrides2 === void 0 ? void 0 : (_metadata_uiOverrides_delivery2 = _metadata_uiOverrides2.delivery) === null || _metadata_uiOverrides_delivery2 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows2 = _metadata_uiOverrides_delivery2.flows) === null || _metadata_uiOverrides_delivery_flows2 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action2 = _metadata_uiOverrides_delivery_flows2[action]) === null || _metadata_uiOverrides_delivery_flows_action2 === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action_buttons = _metadata_uiOverrides_delivery_flows_action2.buttons) === null || _metadata_uiOverrides_delivery_flows_action_buttons === void 0 ? void 0 : (_metadata_uiOverrides_delivery_flows_action_buttons_submit = _metadata_uiOverrides_delivery_flows_action_buttons.submit) === null || _metadata_uiOverrides_delivery_flows_action_buttons_submit === void 0 ? void 0 : _metadata_uiOverrides_delivery_flows_action_buttons_submit[language];
    // usePageTracking({
    //   page: action,
    // });
    // const { trackEvent } = useEventTracking();
    const [employeeSelectOpen, setEmployeeSelectOpen] = (0, $eZVvM.useState)(false);
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const [layout, setLayout] = (0, $eZVvM.useState)("default");
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)(undefined);
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const methods = (0, $afb237382692687d$export$87c0cf8eb5a167e0)({
        defaultValues: {
            contact: undefined
        },
        mode: "onSubmit"
    });
    const { data: employeesData } = (0, $dMu0R.useQuery)([
        "employees",
        {
            filter: {
                preferences: {
                    [namespace]: {
                        enabled: {
                            EQ: true
                        }
                    }
                }
            },
            pagination: {
                limit: 99999
            }
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_EMPLOYEES), variables));
    const employees = (0, $eZVvM.useMemo)(()=>employeesData === null || employeesData === void 0 ? void 0 : employeesData.employees, [
        employeesData
    ]);
    const contactList = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(employees, (employee)=>({
                id: employee.id,
                label: employee.fullName
            })), [
        employeesData
    ]);
    const { data: data, status: requestStatus, mutate: onCreateDeliveryEvent } = (0, $084aaf38c3338203$export$609860bf8b0084c)(async (input)=>{
        var _response_createDeliveryEvent;
        const response = await (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$f7dc25f57197f6f8), {
            input: input
        });
        const accessScanId = response === null || response === void 0 ? void 0 : (_response_createDeliveryEvent = response.createDeliveryEvent) === null || _response_createDeliveryEvent === void 0 ? void 0 : _response_createDeliveryEvent.id;
        /**
     * Prefetch access event so we don't wait when on contact page
     */ await queryClient.prefetchQuery([
            `access/event/${accessScanId}`
        ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                id: accessScanId
            })).catch(()=>null);
        return response;
    });
    const receiver = data === null || data === void 0 ? void 0 : (_data_createDeliveryEvent = data.createDeliveryEvent) === null || _data_createDeliveryEvent === void 0 ? void 0 : _data_createDeliveryEvent.receiver;
    const receiverEmail = receiver === null || receiver === void 0 ? void 0 : receiver.email;
    const autoEmail = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_ = _receiver_availablePreferences[`${action}Delivery`]) === null || _receiver_availablePreferences_ === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel = _receiver_availablePreferences_.autoChannel) === null || _receiver_availablePreferences__autoChannel === void 0 ? void 0 : _receiver_availablePreferences__autoChannel.email;
    const autoSMS = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences1 = receiver.availablePreferences) === null || _receiver_availablePreferences1 === void 0 ? void 0 : (_receiver_availablePreferences_1 = _receiver_availablePreferences1[`${action}Delivery`]) === null || _receiver_availablePreferences_1 === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel1 = _receiver_availablePreferences_1.autoChannel) === null || _receiver_availablePreferences__autoChannel1 === void 0 ? void 0 : _receiver_availablePreferences__autoChannel1.sms;
    const autoCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences2 = receiver.availablePreferences) === null || _receiver_availablePreferences2 === void 0 ? void 0 : (_receiver_availablePreferences_2 = _receiver_availablePreferences2[`${action}Delivery`]) === null || _receiver_availablePreferences_2 === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel2 = _receiver_availablePreferences_2.autoChannel) === null || _receiver_availablePreferences__autoChannel2 === void 0 ? void 0 : _receiver_availablePreferences__autoChannel2.call;
    const autoPing = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences3 = receiver.availablePreferences) === null || _receiver_availablePreferences3 === void 0 ? void 0 : (_receiver_availablePreferences_3 = _receiver_availablePreferences3[`${action}Delivery`]) === null || _receiver_availablePreferences_3 === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel3 = _receiver_availablePreferences_3.autoChannel) === null || _receiver_availablePreferences__autoChannel3 === void 0 ? void 0 : _receiver_availablePreferences__autoChannel3.ping;
    const autoVideoCall = !!(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences4 = receiver.availablePreferences) === null || _receiver_availablePreferences4 === void 0 ? void 0 : (_receiver_availablePreferences_4 = _receiver_availablePreferences4[`${action}Delivery`]) === null || _receiver_availablePreferences_4 === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel4 = _receiver_availablePreferences_4.autoChannel) === null || _receiver_availablePreferences__autoChannel4 === void 0 ? void 0 : _receiver_availablePreferences__autoChannel4.videoCall) && !!(data === null || data === void 0 ? void 0 : (_data_createDeliveryEvent1 = data.createDeliveryEvent) === null || _data_createDeliveryEvent1 === void 0 ? void 0 : _data_createDeliveryEvent1.videoRoom);
    const autoTeamsCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences5 = receiver.availablePreferences) === null || _receiver_availablePreferences5 === void 0 ? void 0 : (_receiver_availablePreferences_5 = _receiver_availablePreferences5[`${action}Delivery`]) === null || _receiver_availablePreferences_5 === void 0 ? void 0 : (_receiver_availablePreferences__autoChannel5 = _receiver_availablePreferences_5.autoChannel) === null || _receiver_availablePreferences__autoChannel5 === void 0 ? void 0 : _receiver_availablePreferences__autoChannel5.teamsCall;
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `${namespace}:status.${status}`;
        if (status !== "success") return key;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoTeamsCall) messageType = "teams-call";
        else if (autoVideoCall) messageType = "video-call";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        namespace,
        status,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS,
        autoTeamsCall,
        autoVideoCall
    ]);
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const { callerAcsToken: callerAcsToken, targetTeamsUserIds: targetTeamsUserIds } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: receiverEmail ? [
            receiverEmail
        ] : [],
        enabled: !!autoTeamsCall && !!receiverEmail
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        var _data_createDeliveryEvent;
        const id = data === null || data === void 0 ? void 0 : (_data_createDeliveryEvent = data.createDeliveryEvent) === null || _data_createDeliveryEvent === void 0 ? void 0 : _data_createDeliveryEvent.id;
        const isFree = clientPlan && clientPlan === "free";
        /**
     * Can the user be navigated to contact page based on permissions and cations
     *
     * - Has to be non free user
     * - Employee has to have at least one notification channel enabled
     */ const canContinue = !isFree && !!id && status === "success";
        if (canContinue) {
            var _data_createDeliveryEvent1, _data_createDeliveryEvent2, _receiver_availablePreferences_namespace, _receiver_availablePreferences;
            if (!!autoCall || !!autoPing) {
                setCalling(true);
                return navigate(`/delivery/${action}/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                    replace: true
                });
            }
            if (!!autoTeamsCall) return navigate(`/${teamsVideoCallEnabled ? "teams-video" : `delivery/${action}/teams-audio`}-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                callerAcsToken: callerAcsToken,
                targetTeamsUserIds: targetTeamsUserIds
            })}`, {
                replace: true
            });
            if (autoVideoCall) return navigate(`/video-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                id: id,
                type: data === null || data === void 0 ? void 0 : (_data_createDeliveryEvent1 = data.createDeliveryEvent) === null || _data_createDeliveryEvent1 === void 0 ? void 0 : _data_createDeliveryEvent1.type
            })}`, {
                state: {
                    videoRoom: data === null || data === void 0 ? void 0 : (_data_createDeliveryEvent2 = data.createDeliveryEvent) === null || _data_createDeliveryEvent2 === void 0 ? void 0 : _data_createDeliveryEvent2.videoRoom
                }
            });
            // if (!!autoSMS) {
            //   return navigate("/", { replace: true });
            // }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_namespace = _receiver_availablePreferences[namespace]) === null || _receiver_availablePreferences_namespace === void 0 ? void 0 : _receiver_availablePreferences_namespace.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                replace: true
            });
        }
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data
    ]);
    const successMessage = (0, $90bf2fef1816810d$export$6b25c561f36ba00c)(action);
    const overriddenTitle = status === "success" ? successMessage.title : undefined;
    const overriddenMessage = status === "success" ? successMessage.message : undefined;
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return successMessage.durationMs || 3000;
        return 0;
    }, [
        status,
        successMessage.durationMs
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const getLayoutForFieldAndValue = (0, $eZVvM.useCallback)((layout = "default", _field = "", value = "")=>{
        if (layout === "default-alt") return layout;
        // Capitalize after whitespace and at start
        if (!value || value.slice(-1) === " ") return "default-shift";
        return "default";
    }, []);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value = "")=>{
        const input = document.querySelector(`[name="${focusedInput}"]`);
        let selectionStart = Math.max(0, value.length - 1);
        if (input && typeof input.selectionStart === "number") selectionStart = input.selectionStart;
        if (!focusedInput) return;
        let prevValue = methods.getValues(focusedInput);
        setLayout((prevLayout)=>{
            const nextLayout = getLayoutForFieldAndValue(prevLayout, focusedInput, value);
            return nextLayout;
        });
        if (focusedInput === "contact") {
            if (prevValue && typeof prevValue.label === "string") prevValue = prevValue.label;
            methods.setValue("contact", {
                label: value
            });
        } else methods.setValue(focusedInput, value);
        if (!prevValue) return;
        /**
     * Update caret position of text input
     */ if (input) {
            const position = prevValue.length - value.length;
            const next = Math.max(0, selectionStart - position);
            input.setSelectionRange(next, next);
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button = "")=>{
        if (button === "{alt}") setLayout((layout)=>layout.endsWith("alt") ? layout.split("-").shift() : `${layout.split("-").shift()}-alt`);
        if (button === "{shift}") setLayout((layout)=>layout.endsWith("shift") ? layout.split("-").shift() : `${layout.split("-").shift()}-shift`);
    }, [
        focusedInput,
        layout
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    const onSubmit = (0, $eZVvM.useCallback)((variables)=>{
        const input = {
            type: action === "package" ? "Package" : "Food",
            employee: variables.contact.id
        };
        // trackEvent({ type: "notify_button_click", value: action });
        return onCreateDeliveryEvent(input, {
            onSuccess () {
            // trackEvent({ type: `${action}_delivery`, value: "success" });
            },
            onError () {
            // trackEvent({ type: `${action}_delivery`, value: `$error` });
            }
        });
    }, []);
    /**
   * Synchronize text caret position with virtual keyboard
   */ const onInputSelect = (0, $eZVvM.useCallback)((event)=>{
        if (!keyboard.current) return;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (!(typeof selectionStart === "number" && typeof selectionEnd === "number")) return;
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    const onInputFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        setFocusedInput(name);
    }, []);
    /**
   * Synchronize text input with virtual keyboard
   */ const onInputChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } } = event;
        /**
     * Skip if there is no virtual keyboard
     */ if (!keyboard.current) return;
        setLayout((prevLayout)=>getLayoutForFieldAndValue(prevLayout, name, value));
        keyboard.current.setInput(value, name);
        keyboard.current.setCaretPosition(selectionStart, selectionEnd);
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$8ce1ff4f94d08846), {
                ...methods,
                children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                    className: "d-flex align-items-center flex-column",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                            to: "/"
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                            disableAnimation: !mainRoute,
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h1",
                                    children: titleOverride !== null && titleOverride !== void 0 ? titleOverride : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                        i18nKey: `${namespace}:title`
                                    })
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                    variant: "h3",
                                    className: "font-weight-regular mt-3",
                                    children: subtitleOverride !== null && subtitleOverride !== void 0 ? subtitleOverride : t(`${namespace}:subtitle`)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsxs)("form", {
                            className: "form d-flex flex-column",
                            autoComplete: "off",
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    delay: 0.5,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                        className: "search-input",
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $afb237382692687d$export$bd0bf19f25da8474), {
                                            name: "contact",
                                            rules: {
                                                required: {
                                                    value: true,
                                                    message: t(`${namespace}:input.error.contact.required`)
                                                },
                                                validate: {
                                                    exists: (value)=>{
                                                        if (!(value && value.id)) return t(`${namespace}:input.error.contact.required`);
                                                        return true;
                                                    }
                                                }
                                            },
                                            render: ({ field: { onChange: onChange, name: name, value: value }, fieldState: { error: error } })=>{
                                                var _value_label;
                                                var _value_label_length;
                                                return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ac6c22b4d4537c6c$export$2e2bcd8739ae039), {
                                                    open: employeeSelectOpen && (contactPreviewEnabled || !(value === null || value === void 0 ? void 0 : value.id) && ((_value_label_length = value === null || value === void 0 ? void 0 : (_value_label = value.label) === null || _value_label === void 0 ? void 0 : _value_label.length) !== null && _value_label_length !== void 0 ? _value_label_length : 0) > 2 || !!(value === null || value === void 0 ? void 0 : value.id)),
                                                    clearOnBlur: true,
                                                    blurOnSelect: true,
                                                    disableClearable: true,
                                                    value: !!(value && value.id) ? value : null,
                                                    options: contactList,
                                                    getOptionLabel: (option)=>option.label || "",
                                                    isOptionEqualToValue: (option, value)=>(value === null || value === void 0 ? void 0 : value.id) === (option === null || option === void 0 ? void 0 : option.id),
                                                    filterOptions: (options)=>{
                                                        if (value === null || value === void 0 ? void 0 : value.id) return options.filter((o)=>o.id === value.id);
                                                        var _value_label;
                                                        const query = (0, $ff6a04e1584a86ed$export$7e13855abec31c34)((_value_label = value === null || value === void 0 ? void 0 : value.label) !== null && _value_label !== void 0 ? _value_label : "");
                                                        if (contactPreviewEnabled) {
                                                            if (!query) return options;
                                                            return options.filter((o)=>(0, $ff6a04e1584a86ed$export$7e13855abec31c34)(o.label).includes(query));
                                                        }
                                                        if (!query || query.length < 3) return [];
                                                        return options.filter((o)=>(0, $ff6a04e1584a86ed$export$7e13855abec31c34)(o.label).includes(query));
                                                    },
                                                    renderOption: (props, option)=>/*#__PURE__*/ (0, $aNuUP.createElement)("li", {
                                                            ...props,
                                                            key: option.id
                                                        }, option.label),
                                                    onChange: (_event, newValue, reason)=>{
                                                        if (reason === "selectOption") onChange(newValue);
                                                    },
                                                    onBlur: ()=>{
                                                        const currentValue = methods.getValues(name);
                                                        setEmployeeSelectOpen(false);
                                                        if (!!(currentValue && currentValue.id)) return;
                                                        if (keyboard.current) keyboard.current.setInput("", name);
                                                        onChange(undefined);
                                                    },
                                                    inputValue: !!(value && value.label) ? value.label : "",
                                                    renderInput: (params)=>{
                                                        var _error_message;
                                                        return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ebb4e6a14e6dbf24$export$2e2bcd8739ae039), {
                                                            ...params,
                                                            type: "text",
                                                            name: "contact",
                                                            variant: "outlined",
                                                            error: !!error,
                                                            helperText: (_error_message = error === null || error === void 0 ? void 0 : error.message) !== null && _error_message !== void 0 ? _error_message : " ",
                                                            label: t(`${namespace}:input.label.contact`),
                                                            className: error && "error__field",
                                                            onChange: (event)=>{
                                                                const { target: { value: value } } = event;
                                                                onInputChange(event);
                                                                onChange({
                                                                    label: value
                                                                });
                                                            },
                                                            onSelect: onInputSelect,
                                                            inputProps: {
                                                                ...params.inputProps,
                                                                onFocus: (e)=>{
                                                                    setEmployeeSelectOpen(true);
                                                                    onInputFocus(e);
                                                                }
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    disabled: !mainRoute,
                                    delay: 0.6,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                                        className: "w-100",
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            className: "mx-1 w-100",
                                            disabled: !online,
                                            onClick: methods.handleSubmit(onSubmit),
                                            children: submitButtonOverride !== null && submitButtonOverride !== void 0 ? submitButtonOverride : t(`${namespace}:button.submit`)
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                            mode: "wait",
                            children: status !== "idle" && !calling && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                                status: status,
                                title: overriddenTitle !== null && overriddenTitle !== void 0 ? overriddenTitle : // @ts-ignore
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `${translationKey}.title`
                                }),
                                message: overriddenMessage !== null && overriddenMessage !== void 0 ? overriddenMessage : // @ts-ignore
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                    i18nKey: `${translationKey}.message`
                                }),
                                onDismiss: onDismiss
                            })
                        }),
                        (0, $k9qks.isVirtualKeyboardEnabled) && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            ref: keyboardBox,
                            className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                                keyboard__out: !focusedInput
                            }),
                            onClick: (e)=>{
                                e.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                                ref: keyboard,
                                layoutName: layout,
                                inputName: focusedInput,
                                onChange: onKeyboardChange,
                                onKeyPress: onKeyboardKeyPress
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {})
        ]
    });
};
var $2168cd7ff7398c79$export$2e2bcd8739ae039 = $2168cd7ff7398c79$var$DeliveryPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");


var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $gdPnm = parcelRequire("gdPnm");




var $cD0nt = parcelRequire("cD0nt");









var $jnPOB = parcelRequire("jnPOB");






var $kCXUJ = parcelRequire("kCXUJ");
const $3ca7a3633993e2eb$var$CustomDeliveryPage = ()=>{
    var _match_params, _metadata_uiOverrides_customDelivery_flows_action_title, _metadata_uiOverrides_customDelivery_flows_action, _metadata_uiOverrides_customDelivery_flows, _metadata_uiOverrides_customDelivery, _metadata_uiOverrides, _metadata_uiOverrides_customDelivery_flows_action_subtitle1, _metadata_uiOverrides_customDelivery_flows_action1, _metadata_uiOverrides_customDelivery_flows1, _metadata_uiOverrides_customDelivery1, _metadata_uiOverrides1, _metadata_uiOverrides_customDelivery_flows_action_subtitle2, _metadata_uiOverrides_customDelivery_flows_action2, _metadata_uiOverrides_customDelivery_flows2, _metadata_uiOverrides_customDelivery2, _metadata_uiOverrides2, _metadata_uiOverrides_customDelivery_flows_action_buttons_submit, _metadata_uiOverrides_customDelivery_flows_action_buttons, _metadata_uiOverrides_customDelivery_flows_action3, _metadata_uiOverrides_customDelivery_flows3, _metadata_uiOverrides_customDelivery3, _metadata_uiOverrides3;
    const match = (0, $9B9bN.useMatch)({
        path: "/custom-delivery/:action"
    });
    const action = match === null || match === void 0 ? void 0 : (_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.action;
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/custom-delivery\/${action}\/?$`).test(pathname);
    const namespace = action === "food" ? "foodDelivery" : "packageDelivery";
    const [calling, setCalling] = (0, $eZVvM.useState)(false);
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const { t: t } = (0, $9GLBV.useTranslation)([
        namespace
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const communicationProvider = (0, $cD0nt.useCommunicationProvider)();
    const deliveryReceiver = (0, $cD0nt.useDeliveryReceiver)();
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const metadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const titleOverride = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides = metadata.uiOverrides) === null || _metadata_uiOverrides === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery = _metadata_uiOverrides.customDelivery) === null || _metadata_uiOverrides_customDelivery === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows = _metadata_uiOverrides_customDelivery.flows) === null || _metadata_uiOverrides_customDelivery_flows === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action = _metadata_uiOverrides_customDelivery_flows[action]) === null || _metadata_uiOverrides_customDelivery_flows_action === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action_title = _metadata_uiOverrides_customDelivery_flows_action.title) === null || _metadata_uiOverrides_customDelivery_flows_action_title === void 0 ? void 0 : _metadata_uiOverrides_customDelivery_flows_action_title[language];
    const subtitle1Override = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides1 = metadata.uiOverrides) === null || _metadata_uiOverrides1 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery1 = _metadata_uiOverrides1.customDelivery) === null || _metadata_uiOverrides_customDelivery1 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows1 = _metadata_uiOverrides_customDelivery1.flows) === null || _metadata_uiOverrides_customDelivery_flows1 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action1 = _metadata_uiOverrides_customDelivery_flows1[action]) === null || _metadata_uiOverrides_customDelivery_flows_action1 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action_subtitle1 = _metadata_uiOverrides_customDelivery_flows_action1.subtitle1) === null || _metadata_uiOverrides_customDelivery_flows_action_subtitle1 === void 0 ? void 0 : _metadata_uiOverrides_customDelivery_flows_action_subtitle1[language];
    const subtitle2Override = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides2 = metadata.uiOverrides) === null || _metadata_uiOverrides2 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery2 = _metadata_uiOverrides2.customDelivery) === null || _metadata_uiOverrides_customDelivery2 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows2 = _metadata_uiOverrides_customDelivery2.flows) === null || _metadata_uiOverrides_customDelivery_flows2 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action2 = _metadata_uiOverrides_customDelivery_flows2[action]) === null || _metadata_uiOverrides_customDelivery_flows_action2 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action_subtitle2 = _metadata_uiOverrides_customDelivery_flows_action2.subtitle2) === null || _metadata_uiOverrides_customDelivery_flows_action_subtitle2 === void 0 ? void 0 : _metadata_uiOverrides_customDelivery_flows_action_subtitle2[language];
    const submitButtonOverride = metadata === null || metadata === void 0 ? void 0 : (_metadata_uiOverrides3 = metadata.uiOverrides) === null || _metadata_uiOverrides3 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery3 = _metadata_uiOverrides3.customDelivery) === null || _metadata_uiOverrides_customDelivery3 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows3 = _metadata_uiOverrides_customDelivery3.flows) === null || _metadata_uiOverrides_customDelivery_flows3 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action3 = _metadata_uiOverrides_customDelivery_flows3[action]) === null || _metadata_uiOverrides_customDelivery_flows_action3 === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action_buttons = _metadata_uiOverrides_customDelivery_flows_action3.buttons) === null || _metadata_uiOverrides_customDelivery_flows_action_buttons === void 0 ? void 0 : (_metadata_uiOverrides_customDelivery_flows_action_buttons_submit = _metadata_uiOverrides_customDelivery_flows_action_buttons.submit) === null || _metadata_uiOverrides_customDelivery_flows_action_buttons_submit === void 0 ? void 0 : _metadata_uiOverrides_customDelivery_flows_action_buttons_submit[language];
    const { data: data, status: requestStatus, mutate: onCreateCustomDeliveryEvent } = (0, $084aaf38c3338203$export$609860bf8b0084c)(async (input)=>{
        var _response_createCustomDeliveryEvent;
        const response = await (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$61dfaad73d5dbaea), {
            input: input
        });
        const accessScanId = response === null || response === void 0 ? void 0 : (_response_createCustomDeliveryEvent = response.createCustomDeliveryEvent) === null || _response_createCustomDeliveryEvent === void 0 ? void 0 : _response_createCustomDeliveryEvent.id;
        /**
     * Prefetch access event so we don't wait when on contact page
     */ await queryClient.prefetchQuery([
            `access/event/${accessScanId}`
        ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                id: accessScanId
            })).catch(()=>null);
        return response;
    });
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `${namespace}:status.${status}`;
        if (status !== "success") return key;
        let messageType = "no-email-sms";
        if ((!communicationProvider || communicationProvider === "twilio") && !!(deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.phone)) messageType = "call-ping";
        else messageType = "email-sms";
        return `${key}.${messageType}`;
    }, [
        namespace,
        status,
        deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.phone,
        communicationProvider
    ]);
    const shouldFetchTeamsToken = (0, $eZVvM.useMemo)(()=>{
        return communicationProvider === "teams" && !!(deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email);
    }, [
        communicationProvider,
        deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email
    ]);
    const { callerAcsToken: callerAcsToken, targetTeamsUserIds: targetTeamsUserIds, isGroupCall: isGroupCall } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: (deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email) ? [
            deliveryReceiver.email
        ] : [],
        enabled: shouldFetchTeamsToken
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        var _data_createCustomDeliveryEvent;
        const id = data === null || data === void 0 ? void 0 : (_data_createCustomDeliveryEvent = data.createCustomDeliveryEvent) === null || _data_createCustomDeliveryEvent === void 0 ? void 0 : _data_createCustomDeliveryEvent.id;
        const isFree = clientPlan && clientPlan === "free";
        const canNavigate = !isFree && !!id && status === "success";
        if (canNavigate && communicationProvider !== "teams" && !!(deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.phone)) {
            setCalling(true);
            return navigate(`/custom-delivery/${action}/contact/${id}/call`, {
                replace: true
            });
        }
        if (canNavigate && communicationProvider === "teams" && !!(deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email)) return navigate(`/${teamsVideoCallEnabled ? "teams-video" : `custom-delivery/${action}/teams-audio`}-${isGroupCall ? "group-" : ""}call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
            callerAcsToken: callerAcsToken,
            targetTeamsUserIds: targetTeamsUserIds
        })}`, {
            replace: true
        });
        return navigate("/", {
            replace: true
        });
    }, [
        status,
        data,
        callerAcsToken,
        targetTeamsUserIds,
        communicationProvider,
        deliveryReceiver
    ]);
    const successMessage = (0, $90bf2fef1816810d$export$6b25c561f36ba00c)(action);
    const overriddenTitle = status === "success" ? successMessage.title : undefined;
    const overriddenMessage = status === "success" ? successMessage.message : undefined;
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 6000;
        if (status === "success") return successMessage.durationMs || 3000;
        return 0;
    }, [
        status,
        successMessage.durationMs
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const onSubmit = (0, $eZVvM.useCallback)(()=>{
        if (!((deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.email) || (deliveryReceiver === null || deliveryReceiver === void 0 ? void 0 : deliveryReceiver.fullName))) return;
        const input = {
            type: action === "package" ? "Package" : "Food",
            receiver: {
                fullName: deliveryReceiver.fullName,
                email: deliveryReceiver.email,
                ...(!communicationProvider || communicationProvider === "twilio") && deliveryReceiver.phone && {
                    phone: deliveryReceiver.phone
                }
            }
        };
        onCreateCustomDeliveryEvent(input);
    }, [
        onCreateCustomDeliveryEvent,
        deliveryReceiver,
        action,
        communicationProvider
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                    disableAnimation: !mainRoute,
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        className: "delivery-title",
                        children: titleOverride !== null && titleOverride !== void 0 ? titleOverride : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${namespace}:title`
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $3f3108db7148688c$export$2e2bcd8739ae039), {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h3",
                            className: "font-weight-regular mt-5",
                            children: subtitle1Override !== null && subtitle1Override !== void 0 ? subtitle1Override : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${namespace}:subtitle1`
                            })
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h4",
                            className: "font-weight-regular mt-4 mb-5",
                            children: subtitle2Override !== null && subtitle2Override !== void 0 ? subtitle2Override : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `${namespace}:subtitle2`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                    disabled: !mainRoute,
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                        style: {
                            width: "54rem"
                        },
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                            variant: "contained",
                            className: "mx-1 mt-5 w-100",
                            onClick: onSubmit,
                            children: submitButtonOverride !== null && submitButtonOverride !== void 0 ? submitButtonOverride : t(`${namespace}:button.submit`)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                    mode: "wait",
                    children: status !== "idle" && !calling && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                        status: status,
                        title: overriddenTitle !== null && overriddenTitle !== void 0 ? overriddenTitle : // @ts-ignore
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${translationKey}.title`
                        }),
                        message: overriddenMessage !== null && overriddenMessage !== void 0 ? overriddenMessage : // @ts-ignore
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `${translationKey}.message`
                        }),
                        onDismiss: onDismiss
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {}),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ae73822bb7ab31ca$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $3ca7a3633993e2eb$export$2e2bcd8739ae039 = $3ca7a3633993e2eb$var$CustomDeliveryPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $dMu0R = parcelRequire("dMu0R");
var $gdPnm = parcelRequire("gdPnm");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $1PAIo = parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


var $jnPOB = parcelRequire("jnPOB");











var $cD0nt = parcelRequire("cD0nt");


var $kCXUJ = parcelRequire("kCXUJ");


var $4vAM8 = parcelRequire("4vAM8");

var $1BSKa = parcelRequire("1BSKa");

const $ad6b9549d45a0e2a$var$Scanning = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ photo: photo })=>{
    var _location_state, _data_accessScan, _data_accessScan1, _data_accessScan2, _data_accessScan_owner, _data_accessScan3, _data_accessScan4, _receiver_availablePreferences_meetingAttendee_autoChannel, _receiver_availablePreferences_meetingAttendee, _receiver_availablePreferences, _receiver_availablePreferences_meetingAttendee_autoChannel1, _receiver_availablePreferences_meetingAttendee1, _receiver_availablePreferences1, _receiver_availablePreferences_meetingAttendee_autoChannel2, _receiver_availablePreferences_meetingAttendee2, _receiver_availablePreferences2, _receiver_availablePreferences_meetingAttendee_autoChannel3, _receiver_availablePreferences_meetingAttendee3, _receiver_availablePreferences3, _receiver_availablePreferences_meetingAttendee_autoChannel4, _receiver_availablePreferences_meetingAttendee4, _receiver_availablePreferences4, _data_accessScan5, _receiver_availablePreferences_meetingAttendee_autoChannel5, _receiver_availablePreferences_meetingAttendee5, _receiver_availablePreferences5, _receptionMetadata_message_direction, _receptionMetadata_message, _typeMessages_title, _typeMessages_message;
    const navigate = (0, $9B9bN.useNavigate)();
    const { code: code, action: action } = (0, $9B9bN.useParams)();
    const [searchParams] = (0, $1PAIo.useSearchParams)();
    const location = (0, $9B9bN.useLocation)();
    const locationCustomFieldValues = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.customFieldValues;
    /**
   * Determines whether the current scan should be treated as NFC scanning.
   *
   * - When scanning via the Prodvx kiosk, NFC scans explicitly pass `isNFC=true`
   *   as a query parameter.
   *
   * - In the future, when NFC scanning is implemented via the Castit Wayfinding app,
   *   the same `isNFC=true` flag will be used. (This is currently NOT implemented,
   *   as devices will rely on NFC readers that behave as keyboard emulators.)
   *
   * - When using keyboard-emulated NFC readers, no explicit NFC flag is sent.
   *   In that case, we infer NFC scanning based on the scanned value:
   *   currently, only NFC UUIDs differ from standard PIN codes by having
   *   a length other than 6 characters.
   *
   * - At the moment, there are no other known non-6-character scan values
   *   besides NFC UUIDs. If additional formats are introduced in the future,
   *   this logic should be revisited and extended accordingly.
   */ const isNfcScanning = searchParams.get("isNFC") === "true" || !!code && code.length !== 6;
    const clientPlan = (0, $cD0nt.useClientPlan)();
    const queryClient = (0, $gdPnm.useQueryClient)();
    const printingEnabled = (0, $cD0nt.usePrintingEnabled)();
    const { print: print } = (0, $0dd5dae821aa55f2$export$faea1c5655e55612)();
    const receptionMetadata = (0, $cD0nt.useDigitalReceptionMetadata)();
    const { isOnlyQrScannerMode: isOnlyQrScannerMode } = (0, $cD0nt.useHidScannerSettings)();
    const { isAccessAllowedForVisitorsForCheckin: isAccessAllowedForVisitorsForCheckin, isAccessAllowedForGuestsForCheckin: isAccessAllowedForGuestsForCheckin, isAccessAllowedForEmployeesForCheckin: isAccessAllowedForEmployeesForCheckin, isAccessAllowedForMeetingAttendeesForCheckin: isAccessAllowedForMeetingAttendeesForCheckin, isAccessEnabledForAutoOpenForCheckin: isAccessEnabledForAutoOpenForCheckin, isAccessAllowedForVisitorsForCheckout: isAccessAllowedForVisitorsForCheckout, isAccessAllowedForGuestsForCheckout: isAccessAllowedForGuestsForCheckout, isAccessAllowedForEmployeesForCheckout: isAccessAllowedForEmployeesForCheckout, isAccessAllowedForMeetingAttendeesForCheckout: isAccessAllowedForMeetingAttendeesForCheckout, isAccessEnabledForAutoOpenForCheckout: isAccessEnabledForAutoOpenForCheckout, accessController: accessController } = (0, $cD0nt.useAccessSettings)();
    const { trigger: triggerAutoSwitch, doorStatus: doorStatus, doorModal: doorModal } = (0, $325562920a04a1bd$export$27b435a0411fd08e)();
    // const { trackEvent } = useEventTracking();
    const { screen: screen } = (0, $5e33a52931d48974$export$991b23a188dc1bb5)();
    const { accepted: acceptedAgreements } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    const [meetingAccessError, setMeetingAccessError] = (0, $eZVvM.useState)(null);
    const formatTime = (iso)=>iso ? (0, $fe3a9b4b2ca7c971$export$2e2bcd8739ae039)(iso).format("HH:mm") : "";
    const { data: data, status: requestStatus } = (0, $dMu0R.useQuery)([
        `scan/${code}`
    ], async ()=>{
        var _response_accessScan;
        let input = {
            code: code
        };
        if (action) input = {
            ...input,
            action: action === "checkout" ? "checkOut" : "checkIn"
        };
        /**
     * Only the documents this person went through, not every document the
     * screen has — the server writes one signing record per id it gets.
     */ if (acceptedAgreements.length > 0) input = {
            ...input,
            acceptedAgreements: acceptedAgreements,
            screen: screen
        };
        if (photo) input = {
            ...input,
            photo: photo
        };
        if (locationCustomFieldValues) input = {
            ...input,
            customFieldValues: locationCustomFieldValues
        };
        const response = await (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$edf5bbf13b92c589), {
            input: input
        });
        const accessScanId = response === null || response === void 0 ? void 0 : (_response_accessScan = response.accessScan) === null || _response_accessScan === void 0 ? void 0 : _response_accessScan.id;
        /**
     * Prefetch access event so we don't wait when on contact page
     */ await queryClient.prefetchQuery([
            `access/event/${accessScanId}`
        ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
                id: accessScanId
            })).catch(()=>null);
        return response;
    }, {
        cacheTime: 0,
        staleTime: 0,
        retry: false,
        refetchOnWindowFocus: false,
        onError (error) {
            var _error_response;
            const graphqlErrors = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.errors;
            const preregError = graphqlErrors === null || graphqlErrors === void 0 ? void 0 : graphqlErrors.find((e)=>{
                var _e_extensions;
                return (e === null || e === void 0 ? void 0 : (_e_extensions = e.extensions) === null || _e_extensions === void 0 ? void 0 : _e_extensions.code) === "MISSING_PREREG_FIELDS";
            });
            if (preregError && code) {
                var _preregError_extensions;
                var _preregError_extensions_fields;
                const fields = (_preregError_extensions_fields = (_preregError_extensions = preregError.extensions) === null || _preregError_extensions === void 0 ? void 0 : _preregError_extensions.fields) !== null && _preregError_extensions_fields !== void 0 ? _preregError_extensions_fields : [];
                navigate(`/access/checkin/missing-fields/${code}`, {
                    replace: true,
                    state: {
                        fields: fields,
                        photo: photo,
                        action: action
                    }
                });
                return;
            }
            const meetingError = graphqlErrors === null || graphqlErrors === void 0 ? void 0 : graphqlErrors.find((e)=>{
                var _e_extensions, _e_extensions1;
                return (e === null || e === void 0 ? void 0 : (_e_extensions = e.extensions) === null || _e_extensions === void 0 ? void 0 : _e_extensions.code) === "MEETING_CODE_TOO_EARLY" || (e === null || e === void 0 ? void 0 : (_e_extensions1 = e.extensions) === null || _e_extensions1 === void 0 ? void 0 : _e_extensions1.code) === "MEETING_CODE_TOO_LATE";
            });
            if (meetingError) {
                var _meetingError_extensions;
                const ext = (_meetingError_extensions = meetingError.extensions) !== null && _meetingError_extensions !== void 0 ? _meetingError_extensions : {};
                const kind = ext.code === "MEETING_CODE_TOO_EARLY" ? "tooEarly" : "tooLate";
                setMeetingAccessError({
                    kind: kind,
                    values: {
                        validFromTime: formatTime(ext.validFrom),
                        validUntilTime: formatTime(ext.validUntil),
                        meetingStartTime: formatTime(ext.dtstart),
                        meetingEndTime: formatTime(ext.dtend)
                    }
                });
            }
        }
    });
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const { qrSocket: qrSocket } = (0, $4vAM8.useScannerContext)();
    const scanResultEmittedRef = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(()=>{
        if (!qrSocket || !code) return;
        if (status !== "success" && status !== "error") return;
        const key = `${code}:${status}`;
        if (scanResultEmittedRef.current === key) return;
        scanResultEmittedRef.current = key;
        qrSocket.emit("scan-result", {
            result: status === "success" ? "good" : "bad"
        });
    }, [
        qrSocket,
        status,
        code
    ]);
    const feedbackPlayedRef = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(()=>{
        if (!isOnlyQrScannerMode) return;
        if (!status || status === "loading" || status === "idle") return;
        const key = `${code}:${status}`;
        if (feedbackPlayedRef.current === key) return;
        feedbackPlayedRef.current = key;
        if (status === "success") {
            (0, $1BSKa.default).info("[scan] success", {
                code: code,
                action: action
            });
            (0, $07e411b3523e37a1$export$20bce071482dbd79)();
        } else if (status === "error") {
            (0, $1BSKa.default).warn("[scan] error", {
                code: code,
                action: action
            });
            (0, $07e411b3523e37a1$export$57ae67615ee4f979)();
        }
    }, [
        status,
        code,
        action,
        isOnlyQrScannerMode
    ]);
    const id = data === null || data === void 0 ? void 0 : (_data_accessScan = data.accessScan) === null || _data_accessScan === void 0 ? void 0 : _data_accessScan.id;
    const type = data === null || data === void 0 ? void 0 : (_data_accessScan1 = data.accessScan) === null || _data_accessScan1 === void 0 ? void 0 : _data_accessScan1.type;
    const metadata = data === null || data === void 0 ? void 0 : (_data_accessScan2 = data.accessScan) === null || _data_accessScan2 === void 0 ? void 0 : _data_accessScan2.metadata;
    const ownerId = data === null || data === void 0 ? void 0 : (_data_accessScan3 = data.accessScan) === null || _data_accessScan3 === void 0 ? void 0 : (_data_accessScan_owner = _data_accessScan3.owner) === null || _data_accessScan_owner === void 0 ? void 0 : _data_accessScan_owner.id;
    const receiver = data === null || data === void 0 ? void 0 : (_data_accessScan4 = data.accessScan) === null || _data_accessScan4 === void 0 ? void 0 : _data_accessScan4.receiver;
    const receiverEmail = receiver === null || receiver === void 0 ? void 0 : receiver.email;
    const autoEmail = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee = _receiver_availablePreferences.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel = _receiver_availablePreferences_meetingAttendee.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel.email;
    const autoSMS = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences1 = receiver.availablePreferences) === null || _receiver_availablePreferences1 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee1 = _receiver_availablePreferences1.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee1 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel1 = _receiver_availablePreferences_meetingAttendee1.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel1 === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel1.sms;
    const autoCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences2 = receiver.availablePreferences) === null || _receiver_availablePreferences2 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee2 = _receiver_availablePreferences2.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee2 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel2 = _receiver_availablePreferences_meetingAttendee2.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel2 === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel2.call;
    const autoPing = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences3 = receiver.availablePreferences) === null || _receiver_availablePreferences3 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee3 = _receiver_availablePreferences3.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee3 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel3 = _receiver_availablePreferences_meetingAttendee3.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel3 === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel3.ping;
    const autoVideoCall = !!(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences4 = receiver.availablePreferences) === null || _receiver_availablePreferences4 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee4 = _receiver_availablePreferences4.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee4 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel4 = _receiver_availablePreferences_meetingAttendee4.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel4 === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel4.videoCall) && !!(data === null || data === void 0 ? void 0 : (_data_accessScan5 = data.accessScan) === null || _data_accessScan5 === void 0 ? void 0 : _data_accessScan5.videoRoom);
    const autoTeamsCall = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences5 = receiver.availablePreferences) === null || _receiver_availablePreferences5 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee5 = _receiver_availablePreferences5.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee5 === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee_autoChannel5 = _receiver_availablePreferences_meetingAttendee5.autoChannel) === null || _receiver_availablePreferences_meetingAttendee_autoChannel5 === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee_autoChannel5.teamsCall;
    const direction = (0, $eZVvM.useMemo)(()=>{
        if (data) return !!(metadata && "checkOut" in metadata) ? "checkout" : "checkin";
        return action || "checkin";
    }, [
        data
    ]);
    const translationKey = (0, $eZVvM.useMemo)(()=>{
        const key = `check:status.${status}`;
        if (!(status === "success" && type)) {
            if (status === "error" && meetingAccessError) return `check:status.error.meeting.${meetingAccessError.kind}`;
            if (isNfcScanning) return `${key}.nfc`;
            return key;
        }
        const returnType = type === "Guest" ? "Visitor" : type;
        if (direction === "checkout") {
            if (!(isAccessEnabledForAutoOpenForCheckout && accessController) && (type === "Employee" && isAccessAllowedForEmployeesForCheckout || type === "MeetingAttendee" && isAccessAllowedForMeetingAttendeesForCheckout || type === "Visitor" && isAccessAllowedForVisitorsForCheckout || type === "Guest" && isAccessAllowedForGuestsForCheckout)) return `${key}.${direction}.access`;
            return `${key}.${direction}.${returnType}`;
        }
        if (printingEnabled) return `${key}.${direction}.${returnType}.badge`;
        if (type !== "MeetingAttendee") return `${key}.${direction}.${returnType}`;
        let messageType = "no-email-sms";
        if (autoCall || autoPing) messageType = "call-ping";
        else if (autoTeamsCall) messageType = "teams-call";
        else if (autoVideoCall) messageType = "video-call";
        else if (autoEmail || autoSMS) messageType = "email-sms";
        return `${key}.${direction}.${returnType}.${messageType}`;
    }, [
        status,
        direction,
        type,
        autoCall,
        autoPing,
        autoEmail,
        autoSMS,
        autoTeamsCall,
        autoVideoCall,
        printingEnabled,
        isAccessAllowedForVisitorsForCheckout,
        isAccessAllowedForGuestsForCheckout,
        isAccessAllowedForEmployeesForCheckout,
        isAccessAllowedForMeetingAttendeesForCheckout,
        isAccessEnabledForAutoOpenForCheckout,
        accessController,
        isNfcScanning
    ]);
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const { callerAcsToken: callerAcsToken, targetTeamsUserIds: targetTeamsUserIds } = (0, $dd1b210a8ac55dce$export$a4a767a5e17b7e4d)({
        emails: receiverEmail ? [
            receiverEmail
        ] : [],
        enabled: !!autoTeamsCall && !!receiverEmail
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        const isFree = clientPlan && clientPlan === "free";
        const isCheckInSuccess = id && direction === "checkin" && status === "success";
        const isCheckOutSuccess = id && direction === "checkout" && status === "success";
        if (!isFree && isCheckInSuccess) {
            if (type !== "MeetingAttendee") {
                if (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.enableExternalDoorTrigger) return navigate("/door", {
                    replace: true
                });
                if (!!(receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.accessControl)) return navigate(`/door-control/${id}`, {
                    replace: true
                });
                if (type === "Employee" && isAccessAllowedForEmployeesForCheckin || type === "Visitor" && isAccessAllowedForVisitorsForCheckin || type === "Guest" && isAccessAllowedForGuestsForCheckin) {
                    if (isAccessEnabledForAutoOpenForCheckin && accessController) return triggerAutoSwitch(accessController);
                    return navigate(`/access-control/${accessController}`, {
                        replace: true
                    });
                }
            }
            const shouldPrint = printingEnabled && ownerId;
            if (shouldPrint) {
                let printWindow = null;
                if (receptionMetadata.printRef === "window") {
                    printWindow = window.open("", "");
                    window.focus();
                }
                print(ownerId, printWindow);
            }
            if (type === "MeetingAttendee") {
                var _data_accessScan, _receiver_availablePreferences_meetingAttendee, _receiver_availablePreferences;
                if (autoCall || autoPing) return navigate(`/access/checkin/contact/${id}/${!!autoCall ? "call" : "ping"}`, {
                    replace: true
                });
                if (!!autoTeamsCall) return navigate(`/${teamsVideoCallEnabled ? "teams-video" : `access/checkin/teams-audio`}-call?${(0, $f19az.default).stringify({
                    callerAcsToken: callerAcsToken,
                    targetTeamsUserIds: targetTeamsUserIds,
                    type: "MeetingAttendee"
                })}`, {
                    replace: true
                });
                if (autoVideoCall) return navigate(`/video-call?${(0, $f19az.default).stringify({
                    id: id,
                    type: "MeetingAttendee"
                })}`, {
                    state: {
                        videoRoom: data === null || data === void 0 ? void 0 : (_data_accessScan = data.accessScan) === null || _data_accessScan === void 0 ? void 0 : _data_accessScan.videoRoom
                    }
                });
                // if (!!autoSMS) {
                //   return navigate("/", { replace: true });
                // }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8fab9d099c4589dd$exports)))(receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : (_receiver_availablePreferences_meetingAttendee = _receiver_availablePreferences.meetingAttendee) === null || _receiver_availablePreferences_meetingAttendee === void 0 ? void 0 : _receiver_availablePreferences_meetingAttendee.channel, (v)=>v === true)) return navigate(`/contact/${id}`, {
                    replace: true
                });
                if (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.enableExternalDoorTrigger) return navigate("/door", {
                    replace: true
                });
                if (!!(receptionMetadata === null || receptionMetadata === void 0 ? void 0 : receptionMetadata.accessControl)) return navigate(`/door-control/${id}`, {
                    replace: true
                });
                if (isAccessAllowedForMeetingAttendeesForCheckin) {
                    if (isAccessEnabledForAutoOpenForCheckin && accessController) return triggerAutoSwitch(accessController);
                    return navigate(`/access-control/${accessController}`, {
                        replace: true
                    });
                }
            }
        }
        if (!isFree && isCheckOutSuccess) {
            if (type === "Employee" && isAccessAllowedForEmployeesForCheckout || type === "MeetingAttendee" && isAccessAllowedForMeetingAttendeesForCheckout || type === "Visitor" && isAccessAllowedForVisitorsForCheckout || type === "Guest" && isAccessAllowedForGuestsForCheckout) {
                if (isAccessEnabledForAutoOpenForCheckout && accessController) return triggerAutoSwitch(accessController);
                return navigate(`/access-control/${accessController}`, {
                    replace: true
                });
            }
        }
        /**
     * In case there was an error, try to redirect the user to where he came from in order to retry the action
     */ if (status === "error") return navigate(-1);
        return navigate("/");
    }, [
        id,
        direction,
        status,
        type,
        action
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        var _receptionMetadata_message_direction, _receptionMetadata_message;
        if (status === "error") return 3000;
        if (status === "success") return (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : (_receptionMetadata_message = receptionMetadata.message) === null || _receptionMetadata_message === void 0 ? void 0 : (_receptionMetadata_message_direction = _receptionMetadata_message[direction]) === null || _receptionMetadata_message_direction === void 0 ? void 0 : _receptionMetadata_message_direction.durationMs) || 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const [language] = (0, $bad2beece3d2a513$export$c1fd9f444a3dc711)();
    const typeMessages = status === "success" && type && (receptionMetadata === null || receptionMetadata === void 0 ? void 0 : (_receptionMetadata_message = receptionMetadata.message) === null || _receptionMetadata_message === void 0 ? void 0 : (_receptionMetadata_message_direction = _receptionMetadata_message[direction]) === null || _receptionMetadata_message_direction === void 0 ? void 0 : _receptionMetadata_message_direction[type]);
    const localizedTitle = typeof typeMessages === "object" && typeof ((_typeMessages_title = typeMessages.title) === null || _typeMessages_title === void 0 ? void 0 : _typeMessages_title[language]) === "string" ? typeMessages.title[language] : undefined;
    const localizedMessage = typeof typeMessages === "object" && typeof ((_typeMessages_message = typeMessages.message) === null || _typeMessages_message === void 0 ? void 0 : _typeMessages_message[language]) === "string" ? typeMessages.message[language] : undefined;
    if (doorStatus) return doorModal;
    const transValues = meetingAccessError === null || meetingAccessError === void 0 ? void 0 : meetingAccessError.values;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        title: localizedTitle !== null && localizedTitle !== void 0 ? localizedTitle : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            // @ts-expect-error
            i18nKey: `${translationKey}.title`,
            values: transValues
        }),
        message: localizedMessage !== null && localizedMessage !== void 0 ? localizedMessage : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            // @ts-expect-error
            i18nKey: `${translationKey}.message`,
            values: transValues
        }),
        status: status,
        onDismiss: onDismiss
    });
});
const $ad6b9549d45a0e2a$var$PreScanning = ()=>{
    var _preScanLocation_state;
    const { code: code, action: action } = (0, $9B9bN.useParams)();
    const isCheckin = action === "checkin";
    const navigate = (0, $9B9bN.useNavigate)();
    const preScanLocation = (0, $9B9bN.useLocation)();
    var _preScanLocation_state_photo;
    const seededPhoto = (_preScanLocation_state_photo = (_preScanLocation_state = preScanLocation.state) === null || _preScanLocation_state === void 0 ? void 0 : _preScanLocation_state.photo) !== null && _preScanLocation_state_photo !== void 0 ? _preScanLocation_state_photo : null;
    const { agreementsFor: agreementsFor, hasRestrictedAgreements: hasRestrictedAgreements } = (0, $5e33a52931d48974$export$991b23a188dc1bb5)();
    const { accept: accept } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    /**
   * The code identifies the person, so from here on the documents can be
   * narrowed to their member type — including the ones that were deliberately
   * held back on the page before this one.
   */ const [memberType, setMemberType] = (0, $eZVvM.useState)();
    const pendingAgreements = isCheckin ? agreementsFor(memberType) : [];
    const { isPhotoCaptureEnabled: isPhotoCaptureEnabled, isPhotoCaptureAllowedForEmployees: isPhotoCaptureAllowedForEmployees, isPhotoCaptureAllowedForVisitors: isPhotoCaptureAllowedForVisitors, isPhotoCaptureAllowedForMeetingAttendees: isPhotoCaptureAllowedForMeetingAttendees, isPhotoCaptureRequiredForEmployees: isPhotoCaptureRequiredForEmployees, isPhotoCaptureRequiredForVisitors: isPhotoCaptureRequiredForVisitors, isPhotoCaptureRequiredForMeetingAttendees: isPhotoCaptureRequiredForMeetingAttendees } = (0, $cD0nt.usePhotoCaptureSettings)();
    const [photoCapture, setPhotoCapture] = (0, $eZVvM.useState)(false);
    const [photoCaptureRequired, setPhotoCaptureRequired] = (0, $eZVvM.useState)(false);
    const [photo, setPhoto] = (0, $eZVvM.useState)(seededPhoto);
    const [isMemberTypeAndPhotoChecked, setIsMemberTypeAndPhotoChecked] = (0, $eZVvM.useState)(!!seededPhoto);
    const handleUserData = (0, $eZVvM.useCallback)((userData)=>{
        var _typeConfig_type;
        const { type: type, hasPhoto: hasPhoto } = userData.getMemberTypeAndPhotoStatusByCode;
        setMemberType(type);
        const typeConfig = {
            Employee: {
                allowed: isPhotoCaptureAllowedForEmployees,
                required: isPhotoCaptureRequiredForEmployees
            },
            Visitor: {
                allowed: isPhotoCaptureAllowedForVisitors,
                required: isPhotoCaptureRequiredForVisitors
            },
            MeetingAttendee: {
                allowed: isPhotoCaptureAllowedForMeetingAttendees,
                required: isPhotoCaptureRequiredForMeetingAttendees
            }
        };
        if (((_typeConfig_type = typeConfig[type]) === null || _typeConfig_type === void 0 ? void 0 : _typeConfig_type.allowed) && !hasPhoto) {
            setPhotoCapture(true);
            setPhotoCaptureRequired(typeConfig[type].required);
        } else {
            setPhotoCapture(false);
            setPhotoCaptureRequired(false);
        }
    }, [
        isPhotoCaptureAllowedForEmployees,
        isPhotoCaptureAllowedForVisitors,
        isPhotoCaptureAllowedForMeetingAttendees,
        isPhotoCaptureRequiredForEmployees,
        isPhotoCaptureRequiredForVisitors,
        isPhotoCaptureRequiredForMeetingAttendees
    ]);
    const { status: status } = (0, $dMu0R.useQuery)([
        "getMemberTypeAndPhotoStatusByCode",
        {
            code: code
        }
    ], ({ queryKey: [_key, variables] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_MEMBER_CODE_CHECK), variables), {
        /**
     * Resolving the member type also gates the entrance agreements now, so
     * the request is worth making for screens that restrict a document to
     * certain member types even when photo capture is off.
     */ enabled: isCheckin && (isPhotoCaptureEnabled || hasRestrictedAgreements) && !!code && !isMemberTypeAndPhotoChecked,
        retry: false,
        onSuccess: handleUserData,
        onError: ()=>{
            setTimeout(()=>{
                navigate(-1);
            }, 3000);
        },
        onSettled: ()=>{
            setIsMemberTypeAndPhotoChecked(true);
        }
    });
    /**
   * Photo capture owns the error and loading states of this request; when it is
   * off, the type is a nice-to-have for picking documents and a failure must not
   * stop the scan — accessScan reports the real reason a moment later.
   */ if (isCheckin && isPhotoCaptureEnabled && status === "error") return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `check:status.${status}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `check:status.${status}.message`
        }),
        status: status
    });
    /**
   * Hold everything back until the type is known — showing the universal
   * documents first and the rest a second later would read as two dialogs.
   */ if (isCheckin && (isPhotoCaptureEnabled || hasRestrictedAgreements) && (status === "loading" || !isMemberTypeAndPhotoChecked)) return null;
    if (pendingAgreements.length > 0) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e81413a0b5db7291$export$2e2bcd8739ae039), {
        aggrements: pendingAgreements,
        onDismiss: ()=>{
            navigate("/");
        },
        onAccept: accept
    });
    if (isCheckin && isPhotoCaptureEnabled) {
        if (photoCapture) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c967df95bbff7b87$export$2e2bcd8739ae039), {
            onClose: ()=>{
                if (photoCaptureRequired) {
                    navigate(-1);
                    return;
                }
                setPhotoCapture(false);
            },
            onAccept: (photo)=>{
                setPhoto(photo);
                setPhotoCapture(false);
            },
            required: photoCaptureRequired
        });
    }
    return /*#__PURE__*/ (0, $bhfvP.jsx)($ad6b9549d45a0e2a$var$Scanning, {
        photo: photo
    });
};
var $ad6b9549d45a0e2a$export$2e2bcd8739ae039 = $ad6b9549d45a0e2a$var$PreScanning;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");


var $kvR7a = parcelRequire("kvR7a");

var $8TMnn = parcelRequire("8TMnn");







var $cD0nt = parcelRequire("cD0nt");


var $jnPOB = parcelRequire("jnPOB");





var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");




var $eZVvM = parcelRequire("eZVvM");
"use client";
/**
 * @ignore - internal component.
 */ const $2825253bc8f618b1$var$TableContext = /*#__PURE__*/ $eZVvM.createContext();
var $2825253bc8f618b1$export$2e2bcd8739ae039 = $2825253bc8f618b1$var$TableContext;






function $14df835c08c4cfc5$export$315cb19215f77ce0(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTable", slot);
}
const $14df835c08c4cfc5$var$tableClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTable", [
    "root",
    "stickyHeader"
]);
var $14df835c08c4cfc5$export$2e2bcd8739ae039 = $14df835c08c4cfc5$var$tableClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $db79de1a297ed967$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $db79de1a297ed967$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            stickyHeader && "stickyHeader"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $14df835c08c4cfc5$export$315cb19215f77ce0), classes);
};
const $db79de1a297ed967$var$TableRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("table", {
    name: "MuiTable",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        "& caption": (0, $65o8X.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: "left",
            captionSide: "bottom"
        })
    }, ownerState.stickyHeader && {
        borderCollapse: "separate"
    }));
const $db79de1a297ed967$var$defaultComponent = "table";
const $db79de1a297ed967$var$Table = /*#__PURE__*/ $eZVvM.forwardRef(function Table(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTable"
    });
    const { className: className, component: component = $db79de1a297ed967$var$defaultComponent, padding: padding = "normal", size: size = "medium", stickyHeader: stickyHeader = false } = props, other = (0, $7Z8DW.default)(props, $db79de1a297ed967$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $db79de1a297ed967$var$useUtilityClasses(ownerState);
    const table = $eZVvM.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2825253bc8f618b1$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($db79de1a297ed967$var$TableRoot, (0, $65o8X.default)({
            as: component,
            role: component === $db79de1a297ed967$var$defaultComponent ? null : "table",
            ref: ref,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
var $db79de1a297ed967$export$2e2bcd8739ae039 = $db79de1a297ed967$var$Table;






var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");









var $3pI8R = parcelRequire("3pI8R");
"use client";
const $c1362b6727a9c743$var$_excluded = [
    "className",
    "id"
];
const $c1362b6727a9c743$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $5b54c0043a945c99$export$f5d2ec7e4c47e088), classes);
};
const $c1362b6727a9c743$var$DialogTitleRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
    name: "MuiDialogTitle",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    padding: "16px 24px",
    flex: "0 0 auto"
});
const $c1362b6727a9c743$var$DialogTitle = /*#__PURE__*/ $eZVvM.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiDialogTitle"
    });
    const { className: className, id: idProp } = props, other = (0, $7Z8DW.default)(props, $c1362b6727a9c743$var$_excluded);
    const ownerState = props;
    const classes = $c1362b6727a9c743$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $eZVvM.useContext((0, $c6eb0b1012d622bb$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $3pI8R.jsx)($c1362b6727a9c743$var$DialogTitleRoot, (0, $65o8X.default)({
        component: "h2",
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $c1362b6727a9c743$export$2e2bcd8739ae039 = $c1362b6727a9c743$var$DialogTitle;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");




var $eZVvM = parcelRequire("eZVvM");
/**
 * @ignore - internal component.
 */ const $7f83dacee02c3385$var$Tablelvl2Context = /*#__PURE__*/ $eZVvM.createContext();
var $7f83dacee02c3385$export$2e2bcd8739ae039 = $7f83dacee02c3385$var$Tablelvl2Context;






function $39fe9b73ab291a1b$export$98bd2a9b566ec665(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTableBody", slot);
}
const $39fe9b73ab291a1b$var$tableBodyClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTableBody", [
    "root"
]);
var $39fe9b73ab291a1b$export$2e2bcd8739ae039 = $39fe9b73ab291a1b$var$tableBodyClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $9fcfd65a6f660c02$var$_excluded = [
    "className",
    "component"
];
const $9fcfd65a6f660c02$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $39fe9b73ab291a1b$export$98bd2a9b566ec665), classes);
};
const $9fcfd65a6f660c02$var$TableBodyRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("tbody", {
    name: "MuiTableBody",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-row-group"
});
const $9fcfd65a6f660c02$var$tablelvl2 = {
    variant: "body"
};
const $9fcfd65a6f660c02$var$defaultComponent = "tbody";
const $9fcfd65a6f660c02$var$TableBody = /*#__PURE__*/ $eZVvM.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTableBody"
    });
    const { className: className, component: component = $9fcfd65a6f660c02$var$defaultComponent } = props, other = (0, $7Z8DW.default)(props, $9fcfd65a6f660c02$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component
    });
    const classes = $9fcfd65a6f660c02$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7f83dacee02c3385$export$2e2bcd8739ae039).Provider, {
        value: $9fcfd65a6f660c02$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($9fcfd65a6f660c02$var$TableBodyRoot, (0, $65o8X.default)({
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $9fcfd65a6f660c02$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $9fcfd65a6f660c02$export$2e2bcd8739ae039 = $9fcfd65a6f660c02$var$TableBody;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");











function $a419e745007941da$export$33a0f07a16a10b1b(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTableCell", slot);
}
const $a419e745007941da$var$tableCellClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTableCell", [
    "root",
    "head",
    "body",
    "footer",
    "sizeSmall",
    "sizeMedium",
    "paddingCheckbox",
    "paddingNone",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "alignJustify",
    "stickyHeader"
]);
var $a419e745007941da$export$2e2bcd8739ae039 = $a419e745007941da$var$tableCellClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $44fabe1c086da0e8$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $44fabe1c086da0e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            stickyHeader && "stickyHeader",
            align !== "inherit" && `align${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(align)}`,
            padding !== "normal" && `padding${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $a419e745007941da$export$33a0f07a16a10b1b), classes);
};
const $44fabe1c086da0e8$var$TableCellRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("td", {
    name: "MuiTableCell",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== "normal" && styles[`padding${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== "inherit" && styles[`align${(0, $d919e3e348f37215$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({}, theme.typography.body2, {
        display: "table-cell",
        verticalAlign: "inherit",
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === "light" ? (0, $6ae574cb2ebbc3ad$exports.lighten)((0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.divider, 1), 0.88) : (0, $6ae574cb2ebbc3ad$exports.darken)((0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: "left",
        padding: 16
    }, ownerState.variant === "head" && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === "body" && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === "footer" && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === "small" && {
        padding: "6px 16px",
        [`&.${(0, $a419e745007941da$export$2e2bcd8739ae039).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: "0 12px 0 16px",
            "& > *": {
                padding: 0
            }
        }
    }, ownerState.padding === "checkbox" && {
        width: 48,
        // prevent the checkbox column from growing
        padding: "0 0 0 4px"
    }, ownerState.padding === "none" && {
        padding: 0
    }, ownerState.align === "left" && {
        textAlign: "left"
    }, ownerState.align === "center" && {
        textAlign: "center"
    }, ownerState.align === "right" && {
        textAlign: "right",
        flexDirection: "row-reverse"
    }, ownerState.align === "justify" && {
        textAlign: "justify"
    }, ownerState.stickyHeader && {
        position: "sticky",
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $44fabe1c086da0e8$var$TableCell = /*#__PURE__*/ $eZVvM.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTableCell"
    });
    const { align: align = "inherit", className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $7Z8DW.default)(props, $44fabe1c086da0e8$var$_excluded);
    const table = $eZVvM.useContext((0, $2825253bc8f618b1$export$2e2bcd8739ae039));
    const tablelvl2 = $eZVvM.useContext((0, $7f83dacee02c3385$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === "head";
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? "th" : "td";
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === "td") scope = undefined;
    else if (!scope && isHeadCell) scope = "col";
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $65o8X.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : "normal"),
        size: sizeProp || (table && table.size ? table.size : "medium"),
        sortDirection: sortDirection,
        stickyHeader: variant === "head" && table && table.stickyHeader,
        variant: variant
    });
    const classes = $44fabe1c086da0e8$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === "asc" ? "ascending" : "descending";
    return /*#__PURE__*/ (0, $3pI8R.jsx)($44fabe1c086da0e8$var$TableCellRoot, (0, $65o8X.default)({
        as: component,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
var $44fabe1c086da0e8$export$2e2bcd8739ae039 = $44fabe1c086da0e8$var$TableCell;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");








function $2413846fa386dab9$export$2e731cea2d1c2392(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTableHead", slot);
}
const $2413846fa386dab9$var$tableHeadClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTableHead", [
    "root"
]);
var $2413846fa386dab9$export$2e2bcd8739ae039 = $2413846fa386dab9$var$tableHeadClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $ccb518d543a08c0b$var$_excluded = [
    "className",
    "component"
];
const $ccb518d543a08c0b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $2413846fa386dab9$export$2e731cea2d1c2392), classes);
};
const $ccb518d543a08c0b$var$TableHeadRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("thead", {
    name: "MuiTableHead",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "table-header-group"
});
const $ccb518d543a08c0b$var$tablelvl2 = {
    variant: "head"
};
const $ccb518d543a08c0b$var$defaultComponent = "thead";
const $ccb518d543a08c0b$var$TableHead = /*#__PURE__*/ $eZVvM.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTableHead"
    });
    const { className: className, component: component = $ccb518d543a08c0b$var$defaultComponent } = props, other = (0, $7Z8DW.default)(props, $ccb518d543a08c0b$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component
    });
    const classes = $ccb518d543a08c0b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)((0, $7f83dacee02c3385$export$2e2bcd8739ae039).Provider, {
        value: $ccb518d543a08c0b$var$tablelvl2,
        children: /*#__PURE__*/ (0, $3pI8R.jsx)($ccb518d543a08c0b$var$TableHeadRoot, (0, $65o8X.default)({
            as: component,
            className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            role: component === $ccb518d543a08c0b$var$defaultComponent ? null : "rowgroup",
            ownerState: ownerState
        }, other))
    });
});
var $ccb518d543a08c0b$export$2e2bcd8739ae039 = $ccb518d543a08c0b$var$TableHead;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");









function $55a199f1d3fd1128$export$ba0a6d6c28940107(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTableRow", slot);
}
const $55a199f1d3fd1128$var$tableRowClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTableRow", [
    "root",
    "selected",
    "hover",
    "head",
    "footer"
]);
var $55a199f1d3fd1128$export$2e2bcd8739ae039 = $55a199f1d3fd1128$var$tableRowClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4c0efebf189cf88c$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $4c0efebf189cf88c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            hover && "hover",
            head && "head",
            footer && "footer"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $55a199f1d3fd1128$export$ba0a6d6c28940107), classes);
};
const $4c0efebf189cf88c$var$TableRowRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("tr", {
    name: "MuiTableRow",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: "inherit",
        display: "table-row",
        verticalAlign: "middle",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $55a199f1d3fd1128$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $55a199f1d3fd1128$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6ae574cb2ebbc3ad$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $4c0efebf189cf88c$var$defaultComponent = "tr";
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $4c0efebf189cf88c$var$TableRow = /*#__PURE__*/ $eZVvM.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTableRow"
    });
    const { className: className, component: component = $4c0efebf189cf88c$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $7Z8DW.default)(props, $4c0efebf189cf88c$var$_excluded);
    const tablelvl2 = $eZVvM.useContext((0, $7f83dacee02c3385$export$2e2bcd8739ae039));
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === "head",
        footer: tablelvl2 && tablelvl2.variant === "footer"
    });
    const classes = $4c0efebf189cf88c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($4c0efebf189cf88c$var$TableRowRoot, (0, $65o8X.default)({
        as: component,
        ref: ref,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        role: component === $4c0efebf189cf88c$var$defaultComponent ? null : "row",
        ownerState: ownerState
    }, other));
});
var $4c0efebf189cf88c$export$2e2bcd8739ae039 = $4c0efebf189cf88c$var$TableRow;



var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");













var $7Z8DW = parcelRequire("7Z8DW");

var $65o8X = parcelRequire("65o8X");

var $eZVvM = parcelRequire("eZVvM");







function $6561b46deff9f921$export$b12cb262231eef32(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiToolbar", slot);
}
const $6561b46deff9f921$var$toolbarClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiToolbar", [
    "root",
    "gutters",
    "regular",
    "dense"
]);
var $6561b46deff9f921$export$2e2bcd8739ae039 = $6561b46deff9f921$var$toolbarClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $22d70a0651fbcda7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $22d70a0651fbcda7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            !disableGutters && "gutters",
            variant
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $6561b46deff9f921$export$b12cb262231eef32), classes);
};
const $22d70a0651fbcda7$var$ToolbarRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $65o8X.default)({
        position: "relative",
        display: "flex",
        alignItems: "center"
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === "dense" && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === "regular" && theme.mixins.toolbar);
const $22d70a0651fbcda7$var$Toolbar = /*#__PURE__*/ $eZVvM.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiToolbar"
    });
    const { className: className, component: component = "div", disableGutters: disableGutters = false, variant: variant = "regular" } = props, other = (0, $7Z8DW.default)(props, $22d70a0651fbcda7$var$_excluded);
    const ownerState = (0, $65o8X.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $22d70a0651fbcda7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $3pI8R.jsx)($22d70a0651fbcda7$var$ToolbarRoot, (0, $65o8X.default)({
        as: component,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $22d70a0651fbcda7$export$2e2bcd8739ae039 = $22d70a0651fbcda7$var$Toolbar;



var $65o8X = parcelRequire("65o8X");

var $7Z8DW = parcelRequire("7Z8DW");

var $eZVvM = parcelRequire("eZVvM");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $21257f7b239802c1$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $49723fd6a07cbebb$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");



parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $093d0b931c936d4d$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage");


parcelRequire("eZVvM");


var $3pI8R = parcelRequire("3pI8R");
"use client";
var $bd17771ae11f0f75$export$2e2bcd8739ae039 = (0, $7c53f9f4c83b6b0b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $3pI8R.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage");



var $3pI8R = parcelRequire("3pI8R");
"use client";
const $4fbe1ba91e0af990$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $4fbe1ba91e0af990$var$TablePaginationActions = /*#__PURE__*/ $eZVvM.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $7Z8DW.default)(props, $4fbe1ba91e0af990$var$_excluded);
    const isRtl = (0, $d97d98e83b9fa62c$export$b2dd014b6c321cb)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $b4f1e2b6883d2123$export$2e2bcd8739ae039);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $bd17771ae11f0f75$export$2e2bcd8739ae039);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $093d0b931c936d4d$export$2e2bcd8739ae039);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $49723fd6a07cbebb$export$2e2bcd8739ae039);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $21257f7b239802c1$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $3pI8R.jsxs)("div", (0, $65o8X.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonSlot, (0, $65o8X.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel("first", page),
                title: getItemAriaLabel("first", page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonIcon, (0, $65o8X.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonIcon, (0, $65o8X.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonSlot, (0, $65o8X.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel("previous", page),
                title: getItemAriaLabel("previous", page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonIcon, (0, $65o8X.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonIcon, (0, $65o8X.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonSlot, (0, $65o8X.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel("next", page),
                title: getItemAriaLabel("next", page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(PreviousButtonIcon, (0, $65o8X.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(NextButtonIcon, (0, $65o8X.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonSlot, (0, $65o8X.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel("last", page),
                title: getItemAriaLabel("last", page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $3pI8R.jsx)(FirstButtonIcon, (0, $65o8X.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $3pI8R.jsx)(LastButtonIcon, (0, $65o8X.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
var $4fbe1ba91e0af990$export$2e2bcd8739ae039 = $4fbe1ba91e0af990$var$TablePaginationActions;





function $d2e1a6cb1af65901$export$909e637b22246f4c(slot) {
    return (0, $66fff2ea26bc86db$export$2e2bcd8739ae039)("MuiTablePagination", slot);
}
const $d2e1a6cb1af65901$var$tablePaginationClasses = (0, $9d66b0007285ac75$export$2e2bcd8739ae039)("MuiTablePagination", [
    "root",
    "toolbar",
    "spacer",
    "selectLabel",
    "selectRoot",
    "select",
    "selectIcon",
    "input",
    "menuItem",
    "displayedRows",
    "actions"
]);
var $d2e1a6cb1af65901$export$2e2bcd8739ae039 = $d2e1a6cb1af65901$var$tablePaginationClasses;



var $3pI8R = parcelRequire("3pI8R");
"use client";
var $e537ef0a6120e2f7$var$_InputBase;
const $e537ef0a6120e2f7$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $e537ef0a6120e2f7$var$TablePaginationRoot = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: "auto",
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        "&:last-child": {
            padding: 0
        }
    }));
const $e537ef0a6120e2f7$var$TablePaginationToolbar = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $22d70a0651fbcda7$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Toolbar",
    overridesResolver: (props, styles)=>(0, $65o8X.default)({
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up("sm")]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $e537ef0a6120e2f7$var$TablePaginationSpacer = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div", {
    name: "MuiTablePagination",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: "1 1 100%"
});
const $e537ef0a6120e2f7$var$TablePaginationSelectLabel = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("p", {
    name: "MuiTablePagination",
    slot: "SelectLabel",
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $e537ef0a6120e2f7$var$TablePaginationSelect = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $22932f6b5a031346$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "Select",
    overridesResolver: (props, styles)=>(0, $65o8X.default)({
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: "inherit",
    fontSize: "inherit",
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $d2e1a6cb1af65901$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: "right",
        textAlignLast: "right" // Align <select> on Chrome.
    }
});
const $e537ef0a6120e2f7$var$TablePaginationMenuItem = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $0f9712359a52dd90$export$2e2bcd8739ae039), {
    name: "MuiTablePagination",
    slot: "MenuItem",
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $e537ef0a6120e2f7$var$TablePaginationDisplayedRows = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("p", {
    name: "MuiTablePagination",
    slot: "DisplayedRows",
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $65o8X.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $e537ef0a6120e2f7$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $e537ef0a6120e2f7$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $e537ef0a6120e2f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        toolbar: [
            "toolbar"
        ],
        spacer: [
            "spacer"
        ],
        selectLabel: [
            "selectLabel"
        ],
        select: [
            "select"
        ],
        input: [
            "input"
        ],
        selectIcon: [
            "selectIcon"
        ],
        menuItem: [
            "menuItem"
        ],
        displayedRows: [
            "displayedRows"
        ],
        actions: [
            "actions"
        ]
    };
    return (0, $71137bcc41c0338b$export$2e2bcd8739ae039)(slots, (0, $d2e1a6cb1af65901$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $e537ef0a6120e2f7$var$TablePagination = /*#__PURE__*/ $eZVvM.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $64582037ee8abf00$export$2440da353cedad43)({
        props: inProps,
        name: "MuiTablePagination"
    });
    const { ActionsComponent: ActionsComponent = (0, $4fbe1ba91e0af990$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $44fabe1c086da0e8$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $e537ef0a6120e2f7$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $e537ef0a6120e2f7$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = "Rows per page:", nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $7Z8DW.default)(props, $e537ef0a6120e2f7$var$_excluded);
    const ownerState = props;
    const classes = $e537ef0a6120e2f7$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? "option" : $e537ef0a6120e2f7$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $44fabe1c086da0e8$export$2e2bcd8739ae039) || component === "td") colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $a58721cd01f32473$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $a58721cd01f32473$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationRoot, (0, $65o8X.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $3pI8R.jsxs)($e537ef0a6120e2f7$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationSelect, (0, $65o8X.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $e537ef0a6120e2f7$var$_InputBase || ($e537ef0a6120e2f7$var$_InputBase = /*#__PURE__*/ (0, $3pI8R.jsx)((0, $2ae777ca6f95078f$export$2e2bcd8739ae039), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $65o8X.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $15676348d56fc1ae$export$2e2bcd8739ae039)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $eZVvM.createElement)(MenuItemComponent, (0, $65o8X.default)({}, !(0, $9bcff6e41ffd69d5$export$2e2bcd8739ae039)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $3pI8R.jsx)($e537ef0a6120e2f7$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $3pI8R.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
var $e537ef0a6120e2f7$export$2e2bcd8739ae039 = $e537ef0a6120e2f7$var$TablePagination;



var $gdPnm = parcelRequire("gdPnm");



var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");



const $6c8127774da1df4a$var$CheckoutButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d1dc812927743fa6$export$2e2bcd8739ae039))(()=>({
        fontSize: "2.5rem",
        width: "15rem",
        marginLeft: "2rem"
    }));
const $6c8127774da1df4a$var$List = (props)=>{
    const { rows: rows } = props;
    const { fields: fields } = (0, $cD0nt.useOverview)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const rowsPerPage = width < height ? 7 : 2;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "overview"
    ]);
    const [page, setPage] = (0, $eZVvM.useState)(0);
    const [open, setOpen] = (0, $eZVvM.useState)(true);
    const [confirmModalId, setConfirmModalId] = (0, $eZVvM.useState)();
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const numberOfPages = Math.ceil(rows.length / rowsPerPage);
    const { status: requestStatus, mutate: onCheckoutOwner } = (0, $084aaf38c3338203$export$609860bf8b0084c)(async (id)=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$a4a94ec8659e687e), {
            id: id
        });
    });
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const queryClient = (0, $gdPnm.useQueryClient)();
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (status === "success" || status === "error") {
            setOpen(false);
            queryClient.invalidateQueries({
                queryKey: [
                    "currentlyCheckedIn"
                ],
                refetchType: "all"
            });
        }
    }, [
        status
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 4000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $db79de1a297ed967$export$2e2bcd8739ae039), {
                style: {
                    width: "93%"
                },
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ccb518d543a08c0b$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                            delay: 0.1,
                            children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $4c0efebf189cf88c$export$2e2bcd8739ae039), {
                                component: (0, $d5f8329c0fec877c$export$e25e478948902b8b).tr,
                                children: [
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("NAME")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: "2.5rem"
                                        },
                                        children: t(`overview:table.head.fullName`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("TYPE")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: "2.5rem"
                                        },
                                        children: t(`overview:table.head.type`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKIN_TIME")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: "2.5rem"
                                        },
                                        children: t(`overview:table.head.checkedinAt`)
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.includes("HOST")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                        style: {
                                            fontSize: "2.5rem"
                                        },
                                        children: t(`overview:table.head.host`)
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9fcfd65a6f660c02$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                            children: rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, i)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $5dbe44b630dd4a2f$export$2e2bcd8739ae039), {
                                    delay: 0.15 + i * 0.05,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $4c0efebf189cf88c$export$2e2bcd8739ae039), {
                                        component: (0, $d5f8329c0fec877c$export$e25e478948902b8b).tr,
                                        children: [
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("NAME")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                component: "th",
                                                scope: "row",
                                                className: "text-secondary",
                                                children: row.fullName
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("TYPE")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: t(`overview:table.type.${row.type}`)
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKIN_TIME")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: row.checkinAt
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("HOST")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: row.host || "/"
                                            }),
                                            (fields === null || fields === void 0 ? void 0 : fields.includes("CHECKOUT")) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $44fabe1c086da0e8$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($6c8127774da1df4a$var$CheckoutButton, {
                                                    variant: "contained",
                                                    size: "small",
                                                    onClick: ()=>{
                                                        setConfirmModalId(row.id);
                                                    },
                                                    children: t("home:checkOut")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $b7efd849c463cc27$export$2e2bcd8739ae039), {
                                                open: confirmModalId === row.id,
                                                onClose: ()=>{
                                                    setConfirmModalId(undefined);
                                                },
                                                sx: {
                                                    ".MuiPaper-root": {
                                                        paddingX: 5,
                                                        paddingY: 3,
                                                        animation: "moveUp 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c1362b6727a9c743$export$2e2bcd8739ae039), {
                                                        className: "text-center mb-5",
                                                        fontSize: 32,
                                                        children: t("overview:confirmModal.title", {
                                                            fullName: row.fullName
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $04c04e378ccee6ce$export$2e2bcd8739ae039), {
                                                        className: "justify-content-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                                                variant: "contained",
                                                                size: "small",
                                                                className: "mx-4 px-5",
                                                                onClick: ()=>{
                                                                    setConfirmModalId(undefined);
                                                                },
                                                                children: t("overview:confirmModal.cancel")
                                                            }),
                                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                                                                variant: "contained",
                                                                size: "small",
                                                                className: "px-5",
                                                                onClick: ()=>{
                                                                    onCheckoutOwner(row.id);
                                                                    setConfirmModalId(undefined);
                                                                    setOpen(true);
                                                                },
                                                                children: t("overview:confirmModal.checkout")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, row.id))
                        })
                    })
                ]
            }),
            numberOfPages !== 1 && /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center mt-5 pt-3",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        style: {
                            fontSize: "2.7rem"
                        },
                        children: [
                            t("overview:page"),
                            " ",
                            /*#__PURE__*/ (0, $bhfvP.jsxs)("span", {
                                className: "ms-4",
                                children: [
                                    page + 1,
                                    " / ",
                                    numberOfPages
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e537ef0a6120e2f7$export$2e2bcd8739ae039), {
                        component: "div",
                        count: rows.length,
                        rowsPerPage: rowsPerPage,
                        page: page,
                        onPageChange: handleChangePage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                mode: "wait",
                children: open && status !== "idle" && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `overview:checkoutStatus.${status}.title`
                    }),
                    message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `overview:checkoutStatus.${status}.message`
                    }),
                    status: status,
                    onDismiss: onDismiss
                })
            })
        ]
    });
};
var $6c8127774da1df4a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo($6c8127774da1df4a$var$List);






var $kCXUJ = parcelRequire("kCXUJ");

var $k9qks = parcelRequire("k9qks");
const $bc17b97e9a1273e2$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $bc17b97e9a1273e2$var$getOwnerField = (owner, fieldName, identificationCode)=>{
    if (!owner) return "";
    if (fieldName in owner) return (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(owner, [
        fieldName
    ]);
    if ("fields" in owner) {
        const field = owner.fields.find((field)=>field.name === fieldName || field.name === identificationCode);
        return field ? field.value : "";
    }
    return "";
};
const $bc17b97e9a1273e2$var$OverviewPage = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "overview"
    ]);
    const [pinCode, setPinCode] = (0, (/*@__PURE__*/$parcel$interopDefault($ff7bcb23a771808b$exports)))($bc17b97e9a1273e2$var$defaultPinCode);
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    const [status, setStatus] = (0, $eZVvM.useState)();
    const [queryEnabled, setQueryEnabled] = (0, $eZVvM.useState)(false);
    const identificationCode = (0, $cD0nt.useIdentificationCode)();
    const [overviewList, setOverviewList] = (0, $eZVvM.useState)();
    const { code: overviewCode, openWithoutCode: openWithoutCode } = (0, $cD0nt.useOverview)();
    (0, $dMu0R.useQuery)([
        "currentlyCheckedIn"
    ], ({ queryKey: [_key] })=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_CURRENTLY_CHECKED_IN), {
            pagination: {
                limit: 100000
            }
        }), {
        enabled: queryEnabled || openWithoutCode,
        onSuccess: (data)=>{
            var _data_currentlyCheckedIn;
            const list = (0, (/*@__PURE__*/$parcel$interopDefault($72bd4d366489160d$exports)))(data === null || data === void 0 ? void 0 : (_data_currentlyCheckedIn = data.currentlyCheckedIn) === null || _data_currentlyCheckedIn === void 0 ? void 0 : _data_currentlyCheckedIn.events, (accessEvent)=>{
                const checkinAt = (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "metadata.checkIn.date");
                return {
                    id: accessEvent.owner.id,
                    fullName: $bc17b97e9a1273e2$var$getOwnerField(accessEvent.owner, "fullName", identificationCode),
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "type"),
                    checkinAt: (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(checkinAt).format("DD-MM-YYYY / HH:mm"),
                    host: (0, (/*@__PURE__*/$parcel$interopDefault($8TMnn)))(accessEvent, "receiver.fullName") || ""
                };
            });
            setOverviewList(list);
        }
    });
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode({
                [focusedInput]: value
            });
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                var _document_activeElement;
                if (document.activeElement) (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            if (pinCode[+focusedInput]) setPinCode({
                [focusedInput]: ""
            });
            else {
                setPinCode({
                    [+focusedInput - 1]: ""
                });
                const nextFocusedInput = Math.max(1, +focusedInput - 1);
                setFocusedInput(`${nextFocusedInput}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, (/*@__PURE__*/$parcel$interopDefault($f896ef6492898da5$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($e93d02b5708fd941$exports)))(6), (acc, key)=>({
                ...acc,
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, []);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event;
        setFocusedInput(`${+name}`);
        if (keyboard.current) keyboard.current.setInput("", name);
    }, []);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        /**
     * Blur when setting last input is set form keyboard
     */ if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, []);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault();
                    const { name: name } = event === null || event === void 0 ? void 0 : event.currentTarget;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($bc17b97e9a1273e2$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 ? void 0 : element.addEventListener("beforeinput", onBeforeInput);
        });
        // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 ? void 0 : element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                event.preventDefault();
                if (pinCode[+name]) setPinCode({
                    [name]: ""
                });
                else {
                    setPinCode({
                        [+name - 1]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                }
                break;
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        pinCode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3f6387fdaa5c88ea$exports)))(keyboardBox, (event)=>{
        var _event_target;
        if (event.target && ((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName) === "INPUT") return;
        setFocusedInput(undefined);
    });
    /**
   * Auto-focus input
   */ (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const pinCodeArr = Object.values(pinCode);
        const timeout = setTimeout(()=>{
            if (pinCodeArr.every((input)=>input !== "")) {
                if (pinCodeArr.join("") === overviewCode) {
                    setStatus("success");
                    setQueryEnabled(true);
                    return;
                }
                setStatus("error");
            }
        }, 500);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        pinCode
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(async ()=>{
        if (status === "success") setStatus(undefined);
        if (status === "error") {
            var _document_activeElement;
            setStatus(undefined);
            setPinCode($bc17b97e9a1273e2$var$defaultPinCode);
            setFocusedInput("1");
            if (document.activeElement) (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
        }
    }, [
        status
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 4000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                !overviewList && !openWithoutCode ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                            className: "page-title",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h1",
                                children: t(`overview:title`)
                            })
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)("form", {
                            className: "pin__wrapper",
                            autoComplete: "off",
                            children: [
                                1,
                                2,
                                3,
                                4,
                                5,
                                6
                            ].map((i)=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $af950ce5b1f47a3b$export$2e2bcd8739ae039), {
                                    delay: 0.15 + 0.05 * i,
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $0428a1863c553843$export$75ee337032588709), {
                                        id: `${i}`,
                                        name: `${i}`,
                                        min: 0,
                                        max: 9,
                                        type: "password",
                                        className: "pin__input",
                                        autoComplete: "off",
                                        onFocus: onFocus,
                                        onChange: onChange,
                                        onKeyDown: onKeyDown,
                                        onPasteCapture: onPasteCapture,
                                        value: pinCode[i],
                                        maxLength: 1,
                                        pattern: "[0-9]*"
                                    })
                                }, i))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                            className: "page-title mb-5",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h3",
                                children: t(`overview:listTitle`)
                            })
                        }),
                        (overviewList === null || overviewList === void 0 ? void 0 : overviewList.length) ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $6c8127774da1df4a$export$2e2bcd8739ae039), {
                            rows: overviewList
                        }) : null,
                        (overviewList === null || overviewList === void 0 ? void 0 : overviewList.length) === 0 ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h3",
                            className: "text-secondary",
                            children: t(`overview:noUsers`)
                        }) : null
                    ]
                }),
                !openWithoutCode && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    ref: keyboardBox,
                    className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                        keyboard__out: !focusedInput
                    }),
                    onClick: (e)=>{
                        e.stopPropagation();
                    },
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                        ref: keyboard,
                        disableButtonHold: true,
                        layoutName: "pin",
                        inputName: focusedInput,
                        onChange: onKeyboardChange,
                        onKeyPress: onKeyboardKeyPress
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
                    mode: "wait",
                    children: !!status && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `overview:status.${status}.title`
                        }),
                        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `overview:status.${status}.message`
                        }),
                        status: status,
                        onDismiss: onDismiss
                    })
                })
            ]
        })
    });
};
var $bc17b97e9a1273e2$export$2e2bcd8739ae039 = $bc17b97e9a1273e2$var$OverviewPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");

var $dMu0R = parcelRequire("dMu0R");
var $51a4b996f723547d$exports = {};
"use strict";
Object.defineProperty($51a4b996f723547d$exports, "__esModule", {
    value: true
});
$51a4b996f723547d$exports.TwilioError = $51a4b996f723547d$exports.Logger = $51a4b996f723547d$exports.PreflightTest = $51a4b996f723547d$exports.Device = $51a4b996f723547d$exports.Call = void 0;
var $d421c5c6d9b8d50a$exports = {};
"use strict";
var $d421c5c6d9b8d50a$var$__extends = $d421c5c6d9b8d50a$exports && $d421c5c6d9b8d50a$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d421c5c6d9b8d50a$var$__assign = $d421c5c6d9b8d50a$exports && $d421c5c6d9b8d50a$exports.__assign || function() {
    $d421c5c6d9b8d50a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d421c5c6d9b8d50a$var$__assign.apply(this, arguments);
};
Object.defineProperty($d421c5c6d9b8d50a$exports, "__esModule", {
    value: true
});

var $33fb184fd4e2bd63$exports = {};
"use strict";
var $33fb184fd4e2bd63$var$__extends = $33fb184fd4e2bd63$exports && $33fb184fd4e2bd63$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($33fb184fd4e2bd63$exports, "__esModule", {
    value: true
});

var $33fb184fd4e2bd63$var$Backoff = /** @class */ function(_super) {
    $33fb184fd4e2bd63$var$__extends(Backoff, _super);
    /**
     * Construct a {@link Backoff}.
     * @param {object} options
     * @property {number} min - Initial timeout in milliseconds [100]
     * @property {number} max - Max timeout [10000]
     * @property {boolean} jitter - Apply jitter [0]
     * @property {number} factor - Multiplication factor for Backoff operation [2]
     */ function Backoff(options) {
        var _this = _super.call(this) || this;
        Object.defineProperties(_this, {
            _attempts: {
                value: 0,
                writable: true
            },
            _duration: {
                enumerable: false,
                get: function() {
                    var ms = this._min * Math.pow(this._factor, this._attempts);
                    if (this._jitter) {
                        var rand = Math.random();
                        var deviation = Math.floor(rand * this._jitter * ms);
                        // tslint:disable-next-line
                        ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
                    }
                    // tslint:disable-next-line
                    return Math.min(ms, this._max) | 0;
                }
            },
            _factor: {
                value: options.factor || 2
            },
            _jitter: {
                value: options.jitter > 0 && options.jitter <= 1 ? options.jitter : 0
            },
            _max: {
                value: options.max || 10000
            },
            _min: {
                value: options.min || 100
            },
            _timeoutID: {
                value: null,
                writable: true
            }
        });
        return _this;
    }
    Backoff.prototype.backoff = function() {
        var _this = this;
        var duration = this._duration;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
        this.emit("backoff", this._attempts, duration);
        this._timeoutID = setTimeout(function() {
            _this.emit("ready", _this._attempts, duration);
            _this._attempts++;
        }, duration);
    };
    Backoff.prototype.reset = function() {
        this._attempts = 0;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
    };
    return Backoff;
}($0bfd6a77e39eae31$exports.EventEmitter);
$33fb184fd4e2bd63$exports.default = $33fb184fd4e2bd63$var$Backoff;


var $b171bc6ab63df54e$exports = {};
"use strict";
var $b171bc6ab63df54e$var$__extends = $b171bc6ab63df54e$exports && $b171bc6ab63df54e$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b171bc6ab63df54e$var$__assign = $b171bc6ab63df54e$exports && $b171bc6ab63df54e$exports.__assign || function() {
    $b171bc6ab63df54e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b171bc6ab63df54e$var$__assign.apply(this, arguments);
};
var $b171bc6ab63df54e$var$__awaiter = $b171bc6ab63df54e$exports && $b171bc6ab63df54e$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b171bc6ab63df54e$var$__generator = $b171bc6ab63df54e$exports && $b171bc6ab63df54e$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($b171bc6ab63df54e$exports, "__esModule", {
    value: true
});

var $db9f743c60fc8d83$exports = {};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === "function" && define.amd) define(definition);
    else if (0, $db9f743c60fc8d83$exports) $db9f743c60fc8d83$exports = definition();
    else root.log = definition();
})($db9f743c60fc8d83$exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === "function") return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === "debug") methodName = "log";
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === "trace" && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, "log");
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */ for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, loggerName);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, defaultLevel, factory) {
        var self = this;
        var currentLevel;
        var storageKey = "loglevel";
        if (name) storageKey += ":" + name;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || "silent").toUpperCase();
            if (typeof window === undefinedType) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var location = cookie.indexOf(encodeURIComponent(storageKey) + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            return currentLevel;
        };
        self.setLevel = function(level, persist) {
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
                currentLevel = level;
                if (persist !== false) persistLevelIfPossible(level);
                replaceLoggingMethods.call(self, level, name);
                if (typeof console === undefinedType && level < self.levels.SILENT) return "No console available for logging";
            } else throw "log.setLevel() called with invalid level: " + level;
        };
        self.setDefaultLevel = function(level) {
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        // Initialize with the right level
        var initialLevel = getPersistedLevel();
        if (initialLevel == null) initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
        self.setLevel(initialLevel, false);
    }
    /*
     *
     * Top-level API
     *
     */ var defaultLogger = new Logger();
    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    return defaultLogger;
});


var $54a2599bd8145d0c$exports = {};
"use strict";
var $54a2599bd8145d0c$var$__extends = $54a2599bd8145d0c$exports && $54a2599bd8145d0c$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $54a2599bd8145d0c$var$__awaiter = $54a2599bd8145d0c$exports && $54a2599bd8145d0c$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $54a2599bd8145d0c$var$__generator = $54a2599bd8145d0c$exports && $54a2599bd8145d0c$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($54a2599bd8145d0c$exports, "__esModule", {
    value: true
});


var $9b99a7197ac9a7b1$exports = {};
"use strict";
var $9b99a7197ac9a7b1$var$__extends = $9b99a7197ac9a7b1$exports && $9b99a7197ac9a7b1$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($9b99a7197ac9a7b1$exports, "__esModule", {
    value: true
});
$9b99a7197ac9a7b1$exports.UserMediaErrors = $9b99a7197ac9a7b1$exports.TwilioError = $9b99a7197ac9a7b1$exports.SIPServerErrors = $9b99a7197ac9a7b1$exports.SignatureValidationErrors = $9b99a7197ac9a7b1$exports.SignalingErrors = $9b99a7197ac9a7b1$exports.MediaErrors = $9b99a7197ac9a7b1$exports.MalformedRequestErrors = $9b99a7197ac9a7b1$exports.GeneralErrors = $9b99a7197ac9a7b1$exports.ClientErrors = $9b99a7197ac9a7b1$exports.AuthorizationErrors = $9b99a7197ac9a7b1$exports.hasErrorByCode = $9b99a7197ac9a7b1$exports.getErrorByCode = $9b99a7197ac9a7b1$exports.NotSupportedError = $9b99a7197ac9a7b1$exports.InvalidStateError = $9b99a7197ac9a7b1$exports.InvalidArgumentError = $9b99a7197ac9a7b1$exports.getPreciseSignalingErrorByCode = void 0;
var $8cac52d96525625c$exports = {};
"use strict";
/* tslint:disable max-classes-per-file max-line-length */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $8cac52d96525625c$var$__extends = $8cac52d96525625c$exports && $8cac52d96525625c$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($8cac52d96525625c$exports, "__esModule", {
    value: true
});
$8cac52d96525625c$exports.errorsByCode = $8cac52d96525625c$exports.MediaErrors = $8cac52d96525625c$exports.SignalingErrors = $8cac52d96525625c$exports.UserMediaErrors = $8cac52d96525625c$exports.MalformedRequestErrors = $8cac52d96525625c$exports.GeneralErrors = $8cac52d96525625c$exports.SIPServerErrors = $8cac52d96525625c$exports.ClientErrors = $8cac52d96525625c$exports.SignatureValidationErrors = $8cac52d96525625c$exports.AuthorizationErrors = $8cac52d96525625c$exports.TwilioError = void 0;
var $fa87f7a283781910$exports = {};
"use strict";
var $fa87f7a283781910$var$__extends = $fa87f7a283781910$exports && $fa87f7a283781910$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($fa87f7a283781910$exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @publicapi
 * @internal
 */ var $fa87f7a283781910$var$TwilioError = /** @class */ function(_super) {
    $fa87f7a283781910$var$__extends(TwilioError, _super);
    function TwilioError(messageOrError, error) {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, TwilioError.prototype);
        var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
        var originalError = typeof messageOrError === "object" ? messageOrError : error;
        _this.message = _this.name + " (" + _this.code + "): " + message;
        _this.originalError = originalError;
        return _this;
    }
    return TwilioError;
}(Error);
$fa87f7a283781910$exports.default = $fa87f7a283781910$var$TwilioError;


$8cac52d96525625c$exports.TwilioError = $fa87f7a283781910$exports.default;
var $8cac52d96525625c$var$AuthorizationErrors;
(function(AuthorizationErrors) {
    var AccessTokenInvalid = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenInvalid, _super);
        function AccessTokenInvalid(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20101;
            _this.description = "Invalid access token";
            _this.explanation = "Twilio was unable to validate your Access Token";
            _this.name = "AccessTokenInvalid";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AccessTokenInvalid.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenInvalid;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.AccessTokenInvalid = AccessTokenInvalid;
    var AccessTokenExpired = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenExpired, _super);
        function AccessTokenExpired(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20104;
            _this.description = "Access token expired or expiration date invalid";
            _this.explanation = "The Access Token provided to the Twilio API has expired, the expiration time specified in the token was invalid, or the expiration time specified was too far in the future";
            _this.name = "AccessTokenExpired";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AccessTokenExpired.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenExpired;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.AccessTokenExpired = AccessTokenExpired;
    var AuthenticationFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthenticationFailed, _super);
        function AuthenticationFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 20151;
            _this.description = "Authentication Failed";
            _this.explanation = "The Authentication with the provided JWT failed";
            _this.name = "AuthenticationFailed";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AuthenticationFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthenticationFailed;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.AuthenticationFailed = AuthenticationFailed;
})($8cac52d96525625c$var$AuthorizationErrors = $8cac52d96525625c$exports.AuthorizationErrors || ($8cac52d96525625c$exports.AuthorizationErrors = {}));
var $8cac52d96525625c$var$SignatureValidationErrors;
(function(SignatureValidationErrors) {
    var AccessTokenSignatureValidationFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AccessTokenSignatureValidationFailed, _super);
        function AccessTokenSignatureValidationFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The access token has an invalid Account SID, API Key, or API Key Secret."
            ];
            _this.code = 31202;
            _this.description = "Signature validation failed.";
            _this.explanation = "The provided access token failed signature validation.";
            _this.name = "AccessTokenSignatureValidationFailed";
            _this.solutions = [
                "Ensure the Account SID, API Key, and API Key Secret are valid when generating your access token."
            ];
            Object.setPrototypeOf(_this, SignatureValidationErrors.AccessTokenSignatureValidationFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AccessTokenSignatureValidationFailed;
    }($fa87f7a283781910$exports.default);
    SignatureValidationErrors.AccessTokenSignatureValidationFailed = AccessTokenSignatureValidationFailed;
})($8cac52d96525625c$var$SignatureValidationErrors = $8cac52d96525625c$exports.SignatureValidationErrors || ($8cac52d96525625c$exports.SignatureValidationErrors = {}));
var $8cac52d96525625c$var$ClientErrors;
(function(ClientErrors) {
    var BadRequest = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(BadRequest, _super);
        function BadRequest(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31400;
            _this.description = "Bad Request (HTTP/SIP)";
            _this.explanation = "The request could not be understood due to malformed syntax.";
            _this.name = "BadRequest";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.BadRequest.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return BadRequest;
    }($fa87f7a283781910$exports.default);
    ClientErrors.BadRequest = BadRequest;
    var NotFound = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(NotFound, _super);
        function NotFound(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The outbound call was made to an invalid phone number.",
                "The TwiML application sid is missing a Voice URL."
            ];
            _this.code = 31404;
            _this.description = "Not Found (HTTP/SIP)";
            _this.explanation = "The server has not found anything matching the request.";
            _this.name = "NotFound";
            _this.solutions = [
                "Ensure the phone number dialed is valid.",
                "Ensure the TwiML application is configured correctly with a Voice URL link."
            ];
            Object.setPrototypeOf(_this, ClientErrors.NotFound.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return NotFound;
    }($fa87f7a283781910$exports.default);
    ClientErrors.NotFound = NotFound;
    var TemporarilyUnavailable = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(TemporarilyUnavailable, _super);
        function TemporarilyUnavailable(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31480;
            _this.description = "Temporarily Unavailable (SIP)";
            _this.explanation = "The callee is currently unavailable.";
            _this.name = "TemporarilyUnavailable";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.TemporarilyUnavailable.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return TemporarilyUnavailable;
    }($fa87f7a283781910$exports.default);
    ClientErrors.TemporarilyUnavailable = TemporarilyUnavailable;
    var BusyHere = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(BusyHere, _super);
        function BusyHere(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31486;
            _this.description = "Busy Here (SIP)";
            _this.explanation = "The callee is busy.";
            _this.name = "BusyHere";
            _this.solutions = [];
            Object.setPrototypeOf(_this, ClientErrors.BusyHere.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return BusyHere;
    }($fa87f7a283781910$exports.default);
    ClientErrors.BusyHere = BusyHere;
})($8cac52d96525625c$var$ClientErrors = $8cac52d96525625c$exports.ClientErrors || ($8cac52d96525625c$exports.ClientErrors = {}));
var $8cac52d96525625c$var$SIPServerErrors;
(function(SIPServerErrors) {
    var Decline = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(Decline, _super);
        function Decline(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31603;
            _this.description = "Decline (SIP)";
            _this.explanation = "The callee does not wish to participate in the call.";
            _this.name = "Decline";
            _this.solutions = [];
            Object.setPrototypeOf(_this, SIPServerErrors.Decline.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return Decline;
    }($fa87f7a283781910$exports.default);
    SIPServerErrors.Decline = Decline;
})($8cac52d96525625c$var$SIPServerErrors = $8cac52d96525625c$exports.SIPServerErrors || ($8cac52d96525625c$exports.SIPServerErrors = {}));
var $8cac52d96525625c$var$GeneralErrors;
(function(GeneralErrors) {
    var UnknownError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(UnknownError, _super);
        function UnknownError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31000;
            _this.description = "Unknown Error";
            _this.explanation = "An unknown error has occurred. See error details for more information.";
            _this.name = "UnknownError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.UnknownError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return UnknownError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.UnknownError = UnknownError;
    var ApplicationNotFoundError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ApplicationNotFoundError, _super);
        function ApplicationNotFoundError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31001;
            _this.description = "Application Not Found";
            _this.explanation = "";
            _this.name = "ApplicationNotFoundError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ApplicationNotFoundError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ApplicationNotFoundError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.ApplicationNotFoundError = ApplicationNotFoundError;
    var ConnectionDeclinedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionDeclinedError, _super);
        function ConnectionDeclinedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31002;
            _this.description = "Connection Declined";
            _this.explanation = "";
            _this.name = "ConnectionDeclinedError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionDeclinedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionDeclinedError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.ConnectionDeclinedError = ConnectionDeclinedError;
    var ConnectionTimeoutError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionTimeoutError, _super);
        function ConnectionTimeoutError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31003;
            _this.description = "Connection Timeout";
            _this.explanation = "The server could not produce a response within a suitable amount of time.";
            _this.name = "ConnectionTimeoutError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionTimeoutError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionTimeoutError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.ConnectionTimeoutError = ConnectionTimeoutError;
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31005;
            _this.description = "Connection error";
            _this.explanation = "A connection error occurred during the call";
            _this.name = "ConnectionError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.ConnectionError = ConnectionError;
    var CallCancelledError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(CallCancelledError, _super);
        function CallCancelledError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity."
            ];
            _this.code = 31008;
            _this.description = "Call cancelled";
            _this.explanation = "Unable to answer because the call has ended";
            _this.name = "CallCancelledError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.CallCancelledError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return CallCancelledError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.CallCancelledError = CallCancelledError;
    var TransportError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(TransportError, _super);
        function TransportError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31009;
            _this.description = "Transport error";
            _this.explanation = "No transport available to send or receive messages";
            _this.name = "TransportError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, GeneralErrors.TransportError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return TransportError;
    }($fa87f7a283781910$exports.default);
    GeneralErrors.TransportError = TransportError;
})($8cac52d96525625c$var$GeneralErrors = $8cac52d96525625c$exports.GeneralErrors || ($8cac52d96525625c$exports.GeneralErrors = {}));
var $8cac52d96525625c$var$MalformedRequestErrors;
(function(MalformedRequestErrors) {
    var MalformedRequestError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MalformedRequestError, _super);
        function MalformedRequestError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Invalid content or MessageType passed to sendMessage method."
            ];
            _this.code = 31100;
            _this.description = "The request had malformed syntax.";
            _this.explanation = "The request could not be understood due to malformed syntax.";
            _this.name = "MalformedRequestError";
            _this.solutions = [
                "Ensure content and MessageType passed to sendMessage method are valid."
            ];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MalformedRequestError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MalformedRequestError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.MalformedRequestError = MalformedRequestError;
    var MissingParameterArrayError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MissingParameterArrayError, _super);
        function MissingParameterArrayError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31101;
            _this.description = "Missing parameter array in request";
            _this.explanation = "";
            _this.name = "MissingParameterArrayError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MissingParameterArrayError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MissingParameterArrayError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.MissingParameterArrayError = MissingParameterArrayError;
    var AuthorizationTokenMissingError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthorizationTokenMissingError, _super);
        function AuthorizationTokenMissingError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31102;
            _this.description = "Authorization token missing in request.";
            _this.explanation = "";
            _this.name = "AuthorizationTokenMissingError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.AuthorizationTokenMissingError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthorizationTokenMissingError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.AuthorizationTokenMissingError = AuthorizationTokenMissingError;
    var MaxParameterLengthExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(MaxParameterLengthExceededError, _super);
        function MaxParameterLengthExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31103;
            _this.description = "Maximum parameter length has been exceeded.";
            _this.explanation = "Length of parameters cannot exceed MAX_PARAM_LENGTH.";
            _this.name = "MaxParameterLengthExceededError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.MaxParameterLengthExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return MaxParameterLengthExceededError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.MaxParameterLengthExceededError = MaxParameterLengthExceededError;
    var InvalidBridgeTokenError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidBridgeTokenError, _super);
        function InvalidBridgeTokenError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31104;
            _this.description = "Invalid bridge token";
            _this.explanation = "";
            _this.name = "InvalidBridgeTokenError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.InvalidBridgeTokenError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidBridgeTokenError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.InvalidBridgeTokenError = InvalidBridgeTokenError;
    var InvalidClientNameError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidClientNameError, _super);
        function InvalidClientNameError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Client name contains invalid characters."
            ];
            _this.code = 31105;
            _this.description = "Invalid client name";
            _this.explanation = "Client name should not contain control, space, delims, or unwise characters.";
            _this.name = "InvalidClientNameError";
            _this.solutions = [
                "Make sure that client name does not contain any of the invalid characters."
            ];
            Object.setPrototypeOf(_this, MalformedRequestErrors.InvalidClientNameError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidClientNameError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.InvalidClientNameError = InvalidClientNameError;
    var ReconnectParameterInvalidError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ReconnectParameterInvalidError, _super);
        function ReconnectParameterInvalidError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31107;
            _this.description = "The reconnect parameter is invalid";
            _this.explanation = "";
            _this.name = "ReconnectParameterInvalidError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, MalformedRequestErrors.ReconnectParameterInvalidError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ReconnectParameterInvalidError;
    }($fa87f7a283781910$exports.default);
    MalformedRequestErrors.ReconnectParameterInvalidError = ReconnectParameterInvalidError;
})($8cac52d96525625c$var$MalformedRequestErrors = $8cac52d96525625c$exports.MalformedRequestErrors || ($8cac52d96525625c$exports.MalformedRequestErrors = {}));
(function(AuthorizationErrors) {
    var AuthorizationError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AuthorizationError, _super);
        function AuthorizationError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31201;
            _this.description = "Authorization error";
            _this.explanation = "The request requires user authentication. The server understood the request, but is refusing to fulfill it.";
            _this.name = "AuthorizationError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.AuthorizationError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AuthorizationError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.AuthorizationError = AuthorizationError;
    var NoValidAccountError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(NoValidAccountError, _super);
        function NoValidAccountError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31203;
            _this.description = "No valid account";
            _this.explanation = "";
            _this.name = "NoValidAccountError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.NoValidAccountError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return NoValidAccountError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.NoValidAccountError = NoValidAccountError;
    var InvalidJWTTokenError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(InvalidJWTTokenError, _super);
        function InvalidJWTTokenError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31204;
            _this.description = "Invalid JWT token";
            _this.explanation = "";
            _this.name = "InvalidJWTTokenError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.InvalidJWTTokenError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return InvalidJWTTokenError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.InvalidJWTTokenError = InvalidJWTTokenError;
    var JWTTokenExpiredError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(JWTTokenExpiredError, _super);
        function JWTTokenExpiredError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31205;
            _this.description = "JWT token expired";
            _this.explanation = "";
            _this.name = "JWTTokenExpiredError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.JWTTokenExpiredError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return JWTTokenExpiredError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.JWTTokenExpiredError = JWTTokenExpiredError;
    var RateExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(RateExceededError, _super);
        function RateExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "Rate limit exceeded."
            ];
            _this.code = 31206;
            _this.description = "Rate exceeded authorized limit.";
            _this.explanation = "The request performed exceeds the authorized limit.";
            _this.name = "RateExceededError";
            _this.solutions = [
                "Ensure message send rate does not exceed authorized limits."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.RateExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return RateExceededError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.RateExceededError = RateExceededError;
    var JWTTokenExpirationTooLongError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(JWTTokenExpirationTooLongError, _super);
        function JWTTokenExpirationTooLongError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31207;
            _this.description = "JWT token expiration too long";
            _this.explanation = "";
            _this.name = "JWTTokenExpirationTooLongError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.JWTTokenExpirationTooLongError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return JWTTokenExpirationTooLongError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.JWTTokenExpirationTooLongError = JWTTokenExpirationTooLongError;
    var ReconnectAttemptError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ReconnectAttemptError, _super);
        function ReconnectAttemptError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 31209;
            _this.description = "Reconnect attempt is not authorized.";
            _this.explanation = "";
            _this.name = "ReconnectAttemptError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, AuthorizationErrors.ReconnectAttemptError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ReconnectAttemptError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.ReconnectAttemptError = ReconnectAttemptError;
    var CallMessageEventTypeInvalidError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(CallMessageEventTypeInvalidError, _super);
        function CallMessageEventTypeInvalidError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Call Message Event Type is invalid and is not understood by Twilio Voice."
            ];
            _this.code = 31210;
            _this.description = "Call Message Event Type is invalid.";
            _this.explanation = "The Call Message Event Type is invalid and is not understood by Twilio Voice.";
            _this.name = "CallMessageEventTypeInvalidError";
            _this.solutions = [
                "Ensure the Call Message Event Type is Valid and understood by Twilio Voice and try again."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.CallMessageEventTypeInvalidError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return CallMessageEventTypeInvalidError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.CallMessageEventTypeInvalidError = CallMessageEventTypeInvalidError;
    var PayloadSizeExceededError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(PayloadSizeExceededError, _super);
        function PayloadSizeExceededError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The payload size of Call Message Event exceeds the authorized limit."
            ];
            _this.code = 31212;
            _this.description = "Call Message Event Payload size exceeded authorized limit.";
            _this.explanation = "The request performed to send a Call Message Event exceeds the payload size authorized limit";
            _this.name = "PayloadSizeExceededError";
            _this.solutions = [
                "Reduce payload size of Call Message Event to be within the authorized limit and try again."
            ];
            Object.setPrototypeOf(_this, AuthorizationErrors.PayloadSizeExceededError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return PayloadSizeExceededError;
    }($fa87f7a283781910$exports.default);
    AuthorizationErrors.PayloadSizeExceededError = PayloadSizeExceededError;
})($8cac52d96525625c$var$AuthorizationErrors = $8cac52d96525625c$exports.AuthorizationErrors || ($8cac52d96525625c$exports.AuthorizationErrors = {}));
var $8cac52d96525625c$var$UserMediaErrors;
(function(UserMediaErrors) {
    var PermissionDeniedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(PermissionDeniedError, _super);
        function PermissionDeniedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The user denied the getUserMedia request.",
                "The browser denied the getUserMedia request."
            ];
            _this.code = 31401;
            _this.description = "UserMedia Permission Denied Error";
            _this.explanation = "The browser or end-user denied permissions to user media. Therefore we were unable to acquire input audio.";
            _this.name = "PermissionDeniedError";
            _this.solutions = [
                "The user should accept the request next time prompted. If the browser saved the deny, the user should change that permission in their browser.",
                "The user should to verify that the browser has permission to access the microphone at this address."
            ];
            Object.setPrototypeOf(_this, UserMediaErrors.PermissionDeniedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return PermissionDeniedError;
    }($fa87f7a283781910$exports.default);
    UserMediaErrors.PermissionDeniedError = PermissionDeniedError;
    var AcquisitionFailedError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(AcquisitionFailedError, _super);
        function AcquisitionFailedError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "NotFoundError - The deviceID specified was not found.",
                "The getUserMedia constraints were overconstrained and no devices matched."
            ];
            _this.code = 31402;
            _this.description = "UserMedia Acquisition Failed Error";
            _this.explanation = "The browser and end-user allowed permissions, however getting the media failed. Usually this is due to bad constraints, but can sometimes fail due to browser, OS or hardware issues.";
            _this.name = "AcquisitionFailedError";
            _this.solutions = [
                "Ensure the deviceID being specified exists.",
                "Try acquiring media with fewer constraints."
            ];
            Object.setPrototypeOf(_this, UserMediaErrors.AcquisitionFailedError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return AcquisitionFailedError;
    }($fa87f7a283781910$exports.default);
    UserMediaErrors.AcquisitionFailedError = AcquisitionFailedError;
})($8cac52d96525625c$var$UserMediaErrors = $8cac52d96525625c$exports.UserMediaErrors || ($8cac52d96525625c$exports.UserMediaErrors = {}));
var $8cac52d96525625c$var$SignalingErrors;
(function(SignalingErrors) {
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [];
            _this.code = 53000;
            _this.description = "Signaling connection error";
            _this.explanation = "Raised whenever a signaling connection error occurs that is not covered by a more specific error code.";
            _this.name = "ConnectionError";
            _this.solutions = [];
            Object.setPrototypeOf(_this, SignalingErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($fa87f7a283781910$exports.default);
    SignalingErrors.ConnectionError = ConnectionError;
    var ConnectionDisconnected = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionDisconnected, _super);
        function ConnectionDisconnected(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The device running your application lost its Internet connection."
            ];
            _this.code = 53001;
            _this.description = "Signaling connection disconnected";
            _this.explanation = "Raised whenever the signaling connection is unexpectedly disconnected.";
            _this.name = "ConnectionDisconnected";
            _this.solutions = [
                "Ensure the device running your application has access to a stable Internet connection."
            ];
            Object.setPrototypeOf(_this, SignalingErrors.ConnectionDisconnected.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionDisconnected;
    }($fa87f7a283781910$exports.default);
    SignalingErrors.ConnectionDisconnected = ConnectionDisconnected;
})($8cac52d96525625c$var$SignalingErrors = $8cac52d96525625c$exports.SignalingErrors || ($8cac52d96525625c$exports.SignalingErrors = {}));
var $8cac52d96525625c$var$MediaErrors;
(function(MediaErrors) {
    var ClientLocalDescFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ClientLocalDescFailed, _super);
        function ClientLocalDescFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client may not be using a supported WebRTC implementation.",
                "The Client may not have the necessary resources to create or apply a new media description."
            ];
            _this.code = 53400;
            _this.description = "Client is unable to create or apply a local media description";
            _this.explanation = "Raised whenever a Client is unable to create or apply a local media description.";
            _this.name = "ClientLocalDescFailed";
            _this.solutions = [
                "If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ClientLocalDescFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ClientLocalDescFailed;
    }($fa87f7a283781910$exports.default);
    MediaErrors.ClientLocalDescFailed = ClientLocalDescFailed;
    var ClientRemoteDescFailed = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ClientRemoteDescFailed, _super);
        function ClientRemoteDescFailed(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client may not be using a supported WebRTC implementation.",
                "The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.",
                "The Client may not have the necessary resources to apply a new media description."
            ];
            _this.code = 53402;
            _this.description = "Client is unable to apply a remote media description";
            _this.explanation = "Raised whenever the Client receives a remote media description but is unable to apply it.";
            _this.name = "ClientRemoteDescFailed";
            _this.solutions = [
                "If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ClientRemoteDescFailed.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ClientRemoteDescFailed;
    }($fa87f7a283781910$exports.default);
    MediaErrors.ClientRemoteDescFailed = ClientRemoteDescFailed;
    var ConnectionError = /** @class */ function(_super) {
        $8cac52d96525625c$var$__extends(ConnectionError, _super);
        function ConnectionError(messageOrError, error) {
            var _this = _super.call(this, messageOrError, error) || this;
            _this.causes = [
                "The Client was unable to establish a media connection.",
                "A media connection which was active failed liveliness checks."
            ];
            _this.code = 53405;
            _this.description = "Media connection failed";
            _this.explanation = "Raised by the Client or Server whenever a media connection fails.";
            _this.name = "ConnectionError";
            _this.solutions = [
                "If the problem persists, try connecting to another region.",
                "Check your Client's network connectivity.",
                "If you've provided custom ICE Servers then ensure that the URLs and credentials are valid."
            ];
            Object.setPrototypeOf(_this, MediaErrors.ConnectionError.prototype);
            var message = typeof messageOrError === "string" ? messageOrError : _this.explanation;
            var originalError = typeof messageOrError === "object" ? messageOrError : error;
            _this.message = _this.name + " (" + _this.code + "): " + message;
            _this.originalError = originalError;
            return _this;
        }
        return ConnectionError;
    }($fa87f7a283781910$exports.default);
    MediaErrors.ConnectionError = ConnectionError;
})($8cac52d96525625c$var$MediaErrors = $8cac52d96525625c$exports.MediaErrors || ($8cac52d96525625c$exports.MediaErrors = {}));
/**
 * @private
 */ $8cac52d96525625c$exports.errorsByCode = new Map([
    [
        20101,
        $8cac52d96525625c$var$AuthorizationErrors.AccessTokenInvalid
    ],
    [
        20104,
        $8cac52d96525625c$var$AuthorizationErrors.AccessTokenExpired
    ],
    [
        20151,
        $8cac52d96525625c$var$AuthorizationErrors.AuthenticationFailed
    ],
    [
        31202,
        $8cac52d96525625c$var$SignatureValidationErrors.AccessTokenSignatureValidationFailed
    ],
    [
        31400,
        $8cac52d96525625c$var$ClientErrors.BadRequest
    ],
    [
        31404,
        $8cac52d96525625c$var$ClientErrors.NotFound
    ],
    [
        31480,
        $8cac52d96525625c$var$ClientErrors.TemporarilyUnavailable
    ],
    [
        31486,
        $8cac52d96525625c$var$ClientErrors.BusyHere
    ],
    [
        31603,
        $8cac52d96525625c$var$SIPServerErrors.Decline
    ],
    [
        31000,
        $8cac52d96525625c$var$GeneralErrors.UnknownError
    ],
    [
        31001,
        $8cac52d96525625c$var$GeneralErrors.ApplicationNotFoundError
    ],
    [
        31002,
        $8cac52d96525625c$var$GeneralErrors.ConnectionDeclinedError
    ],
    [
        31003,
        $8cac52d96525625c$var$GeneralErrors.ConnectionTimeoutError
    ],
    [
        31005,
        $8cac52d96525625c$var$GeneralErrors.ConnectionError
    ],
    [
        31008,
        $8cac52d96525625c$var$GeneralErrors.CallCancelledError
    ],
    [
        31009,
        $8cac52d96525625c$var$GeneralErrors.TransportError
    ],
    [
        31100,
        $8cac52d96525625c$var$MalformedRequestErrors.MalformedRequestError
    ],
    [
        31101,
        $8cac52d96525625c$var$MalformedRequestErrors.MissingParameterArrayError
    ],
    [
        31102,
        $8cac52d96525625c$var$MalformedRequestErrors.AuthorizationTokenMissingError
    ],
    [
        31103,
        $8cac52d96525625c$var$MalformedRequestErrors.MaxParameterLengthExceededError
    ],
    [
        31104,
        $8cac52d96525625c$var$MalformedRequestErrors.InvalidBridgeTokenError
    ],
    [
        31105,
        $8cac52d96525625c$var$MalformedRequestErrors.InvalidClientNameError
    ],
    [
        31107,
        $8cac52d96525625c$var$MalformedRequestErrors.ReconnectParameterInvalidError
    ],
    [
        31201,
        $8cac52d96525625c$var$AuthorizationErrors.AuthorizationError
    ],
    [
        31203,
        $8cac52d96525625c$var$AuthorizationErrors.NoValidAccountError
    ],
    [
        31204,
        $8cac52d96525625c$var$AuthorizationErrors.InvalidJWTTokenError
    ],
    [
        31205,
        $8cac52d96525625c$var$AuthorizationErrors.JWTTokenExpiredError
    ],
    [
        31206,
        $8cac52d96525625c$var$AuthorizationErrors.RateExceededError
    ],
    [
        31207,
        $8cac52d96525625c$var$AuthorizationErrors.JWTTokenExpirationTooLongError
    ],
    [
        31209,
        $8cac52d96525625c$var$AuthorizationErrors.ReconnectAttemptError
    ],
    [
        31210,
        $8cac52d96525625c$var$AuthorizationErrors.CallMessageEventTypeInvalidError
    ],
    [
        31212,
        $8cac52d96525625c$var$AuthorizationErrors.PayloadSizeExceededError
    ],
    [
        31401,
        $8cac52d96525625c$var$UserMediaErrors.PermissionDeniedError
    ],
    [
        31402,
        $8cac52d96525625c$var$UserMediaErrors.AcquisitionFailedError
    ],
    [
        53000,
        $8cac52d96525625c$var$SignalingErrors.ConnectionError
    ],
    [
        53001,
        $8cac52d96525625c$var$SignalingErrors.ConnectionDisconnected
    ],
    [
        53400,
        $8cac52d96525625c$var$MediaErrors.ClientLocalDescFailed
    ],
    [
        53402,
        $8cac52d96525625c$var$MediaErrors.ClientRemoteDescFailed
    ],
    [
        53405,
        $8cac52d96525625c$var$MediaErrors.ConnectionError
    ]
]);
Object.freeze($8cac52d96525625c$exports.errorsByCode);


Object.defineProperty($9b99a7197ac9a7b1$exports, "AuthorizationErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.AuthorizationErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "ClientErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.ClientErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "GeneralErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.GeneralErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "MalformedRequestErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.MalformedRequestErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "MediaErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.MediaErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "SignalingErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.SignalingErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "SignatureValidationErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.SignatureValidationErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "SIPServerErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.SIPServerErrors;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "TwilioError", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.TwilioError;
    }
});
Object.defineProperty($9b99a7197ac9a7b1$exports, "UserMediaErrors", {
    enumerable: true,
    get: function() {
        return $8cac52d96525625c$exports.UserMediaErrors;
    }
});
/**
 * NOTE(mhuynh): Replacing generic error codes with new (more specific) codes,
 * is a breaking change. If an error code is found in this set, we only perform
 * the transformation if the feature flag is enabled.
 *
 * With every major version bump, such that we are allowed to introduce breaking
 * changes as per semver specification, this array should be cleared.
 *
 * TODO: [VBLOCKS-2295] Remove this in 3.x
 */ var $9b99a7197ac9a7b1$var$PRECISE_SIGNALING_ERROR_CODES = new Set([
    /**
     * 310XX Errors
     */ 31001,
    31002,
    31003,
    /**
     * 311XX Errors
     */ 31101,
    31102,
    31103,
    31104,
    31105,
    31107,
    /**
     * 312XX Errors
     */ 31201,
    31202,
    31203,
    31204,
    31205,
    31207,
    /**
     * 314XX Errors
     */ 31404,
    31480,
    31486,
    /**
     * 316XX Errors
     */ 31603
]);
function $9b99a7197ac9a7b1$var$getPreciseSignalingErrorByCode(enableImprovedSignalingErrorPrecision, errorCode) {
    if (typeof errorCode !== "number") return;
    if (!$9b99a7197ac9a7b1$var$hasErrorByCode(errorCode)) return;
    var shouldTransform = enableImprovedSignalingErrorPrecision ? true : !$9b99a7197ac9a7b1$var$PRECISE_SIGNALING_ERROR_CODES.has(errorCode);
    if (!shouldTransform) return;
    return $9b99a7197ac9a7b1$var$getErrorByCode(errorCode);
}
$9b99a7197ac9a7b1$exports.getPreciseSignalingErrorByCode = $9b99a7197ac9a7b1$var$getPreciseSignalingErrorByCode;
// Application errors that can be avoided by good app logic
var $9b99a7197ac9a7b1$var$InvalidArgumentError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(InvalidArgumentError, _super);
    function InvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "InvalidArgumentError";
        return _this;
    }
    return InvalidArgumentError;
}(Error);
$9b99a7197ac9a7b1$exports.InvalidArgumentError = $9b99a7197ac9a7b1$var$InvalidArgumentError;
var $9b99a7197ac9a7b1$var$InvalidStateError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(InvalidStateError, _super);
    function InvalidStateError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "InvalidStateError";
        return _this;
    }
    return InvalidStateError;
}(Error);
$9b99a7197ac9a7b1$exports.InvalidStateError = $9b99a7197ac9a7b1$var$InvalidStateError;
var $9b99a7197ac9a7b1$var$NotSupportedError = /** @class */ function(_super) {
    $9b99a7197ac9a7b1$var$__extends(NotSupportedError, _super);
    function NotSupportedError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "NotSupportedError";
        return _this;
    }
    return NotSupportedError;
}(Error);
$9b99a7197ac9a7b1$exports.NotSupportedError = $9b99a7197ac9a7b1$var$NotSupportedError;
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
function $9b99a7197ac9a7b1$var$getErrorByCode(code) {
    var error = $8cac52d96525625c$exports.errorsByCode.get(code);
    if (!error) throw new $9b99a7197ac9a7b1$var$InvalidArgumentError("Error code " + code + " not found");
    return error;
}
$9b99a7197ac9a7b1$exports.getErrorByCode = $9b99a7197ac9a7b1$var$getErrorByCode;
// This should only be used to look up error codes returned by a server
// using the same repo of error codes.
function $9b99a7197ac9a7b1$var$hasErrorByCode(code) {
    return $8cac52d96525625c$exports.errorsByCode.has(code);
}
$9b99a7197ac9a7b1$exports.hasErrorByCode = $9b99a7197ac9a7b1$var$hasErrorByCode;


var $674d4885484aa9f2$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $674d4885484aa9f2$var$__spreadArrays = $674d4885484aa9f2$exports && $674d4885484aa9f2$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($674d4885484aa9f2$exports, "__esModule", {
    value: true
});
$674d4885484aa9f2$exports.Logger = void 0;

var $e9da3ede67c59403$exports = {};
"use strict";
/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */ /**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty($e9da3ede67c59403$exports, "__esModule", {
    value: true
});
$e9da3ede67c59403$exports.SOUNDS_BASE_URL = $e9da3ede67c59403$exports.RELEASE_VERSION = $e9da3ede67c59403$exports.PACKAGE_NAME = $e9da3ede67c59403$exports.ECHO_TEST_DURATION = $e9da3ede67c59403$exports.COWBELL_AUDIO_URL = void 0;
var $e9da3ede67c59403$var$PACKAGE_NAME = "@twilio/voice-sdk";
$e9da3ede67c59403$exports.PACKAGE_NAME = $e9da3ede67c59403$var$PACKAGE_NAME;
var $e9da3ede67c59403$var$RELEASE_VERSION = "2.12.1";
$e9da3ede67c59403$exports.RELEASE_VERSION = $e9da3ede67c59403$var$RELEASE_VERSION;
var $e9da3ede67c59403$var$SOUNDS_BASE_URL = "https://sdk.twilio.com/js/client/sounds/releases/1.0.0";
$e9da3ede67c59403$exports.SOUNDS_BASE_URL = $e9da3ede67c59403$var$SOUNDS_BASE_URL;
var $e9da3ede67c59403$var$COWBELL_AUDIO_URL = $e9da3ede67c59403$var$SOUNDS_BASE_URL + "/cowbell.mp3?cache=" + $e9da3ede67c59403$var$RELEASE_VERSION;
$e9da3ede67c59403$exports.COWBELL_AUDIO_URL = $e9da3ede67c59403$var$COWBELL_AUDIO_URL;
var $e9da3ede67c59403$var$ECHO_TEST_DURATION = 20000;
$e9da3ede67c59403$exports.ECHO_TEST_DURATION = $e9da3ede67c59403$var$ECHO_TEST_DURATION;


/**
 * {@link Log} provides logging features throughout the sdk using loglevel module
 * See https://github.com/pimterry/loglevel for documentation
 * @private
 */ var $674d4885484aa9f2$var$Log = /** @class */ function() {
    /**
     * @constructor
     * @param [tag] - tag name for the logs
     * @param [options] - Optional settings
     */ function Log(tag, options) {
        this._log = Log.getLogLevelInstance(options);
        this._prefix = "[TwilioVoice][" + tag + "]";
    }
    /**
     * Return the `loglevel` instance maintained internally.
     * @param [options] - Optional settings
     * @returns The `loglevel` instance.
     */ Log.getLogLevelInstance = function(options) {
        if (!Log.loglevelInstance) try {
            Log.loglevelInstance = (options && options.LogLevelModule ? options.LogLevelModule : $db9f743c60fc8d83$exports).getLogger($e9da3ede67c59403$exports.PACKAGE_NAME);
        } catch (_a) {
            // tslint:disable-next-line
            console.warn("Cannot create custom logger");
            Log.loglevelInstance = console;
        }
        return Log.loglevelInstance;
    };
    /**
     * Log a debug message
     * @param args - Any number of arguments to be passed to loglevel.debug
     */ Log.prototype.debug = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).debug.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log an error message
     * @param args - Any number of arguments to be passed to loglevel.error
     */ Log.prototype.error = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).error.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log an info message
     * @param args - Any number of arguments to be passed to loglevel.info
     */ Log.prototype.info = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).info.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Set a default log level to disable all logging below the given level
     */ Log.prototype.setDefaultLevel = function(level) {
        if (this._log.setDefaultLevel) this._log.setDefaultLevel(level);
        else // tslint:disable-next-line
        console.warn("Logger cannot setDefaultLevel");
    };
    /**
     * Log a warning message
     * @param args - Any number of arguments to be passed to loglevel.warn
     */ Log.prototype.warn = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        (_a = this._log).warn.apply(_a, $674d4885484aa9f2$var$__spreadArrays([
            this._prefix
        ], args));
    };
    /**
     * Log levels
     */ Log.levels = $db9f743c60fc8d83$exports.levels;
    return Log;
}();
$674d4885484aa9f2$exports.Logger = $674d4885484aa9f2$var$Log.getLogLevelInstance();
$674d4885484aa9f2$exports.default = $674d4885484aa9f2$var$Log;


var $9f7e520c5c2d3314$exports = {};
"use strict";
Object.defineProperty($9f7e520c5c2d3314$exports, "__esModule", {
    value: true
});



var $9f7e520c5c2d3314$var$DEFAULT_TEST_SOUND_URL = $e9da3ede67c59403$exports.SOUNDS_BASE_URL + "/outgoing.mp3";
/**
 * A smart collection containing a Set of active output devices.
 * @publicapi
 */ var $9f7e520c5c2d3314$var$OutputDeviceCollection = /** @class */ function() {
    /**
     * @private
     */ function OutputDeviceCollection(_name, _availableDevices, _beforeChange, _isSupported) {
        this._name = _name;
        this._availableDevices = _availableDevices;
        this._beforeChange = _beforeChange;
        this._isSupported = _isSupported;
        /**
         * The currently active output devices.
         */ this._activeDevices = new Set();
        /**
         * An instance of Logger to use.
         */ this._log = new $674d4885484aa9f2$exports.default("OutputDeviceCollection");
    }
    /**
     * Delete a device from the collection. If no devices remain, the 'default'
     * device will be added as the sole device. If no `default` device exists,
     * the first available device will be used.
     * @param device - The device to delete from the collection
     * @returns whether the device was present before it was deleted
     */ OutputDeviceCollection.prototype.delete = function(device) {
        this._log.debug(".delete", device);
        var wasDeleted = !!this._activeDevices.delete(device);
        var defaultDevice = this._availableDevices.get("default") || Array.from(this._availableDevices.values())[0];
        if (!this._activeDevices.size && defaultDevice) this._activeDevices.add(defaultDevice);
        // Call _beforeChange so that the implementation can react when a device is
        // removed or lost.
        var deviceIds = Array.from(this._activeDevices.values()).map(function(deviceInfo) {
            return deviceInfo.deviceId;
        });
        this._beforeChange(this._name, deviceIds);
        return !!wasDeleted;
    };
    /**
     * Get the current set of devices.
     */ OutputDeviceCollection.prototype.get = function() {
        return this._activeDevices;
    };
    /**
     * Replace the current set of devices with a new set of devices.
     * @param deviceIdOrIds - An ID or array of IDs of devices to replace the existing devices with.
     * @returns Rejects if this feature is not supported, any of the supplied IDs are not found,
     * or no IDs are passed.
     */ OutputDeviceCollection.prototype.set = function(deviceIdOrIds) {
        var _this = this;
        this._log.debug(".set", deviceIdOrIds);
        if (!this._isSupported) return Promise.reject(new $9b99a7197ac9a7b1$exports.NotSupportedError("This browser does not support audio output selection"));
        var deviceIds = Array.isArray(deviceIdOrIds) ? deviceIdOrIds : [
            deviceIdOrIds
        ];
        if (!deviceIds.length) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Must specify at least one device to set"));
        var missingIds = [];
        var devices = deviceIds.map(function(id) {
            var device = _this._availableDevices.get(id);
            if (!device) missingIds.push(id);
            return device;
        });
        if (missingIds.length) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Devices not found: " + missingIds.join(", ")));
        return new Promise(function(resolve) {
            resolve(_this._beforeChange(_this._name, deviceIds));
        }).then(function() {
            _this._activeDevices.clear();
            devices.forEach(_this._activeDevices.add, _this._activeDevices);
        });
    };
    /**
     * Test the devices by playing audio through them.
     * @param [soundUrl] - An optional URL. If none is specified, we will
     *   play a default test tone.
     * @returns Resolves with the result of the underlying HTMLAudioElements' play() calls.
     */ OutputDeviceCollection.prototype.test = function(soundUrl) {
        if (soundUrl === void 0) soundUrl = $9f7e520c5c2d3314$var$DEFAULT_TEST_SOUND_URL;
        if (!this._isSupported) return Promise.reject(new $9b99a7197ac9a7b1$exports.NotSupportedError("This browser does not support audio output selection"));
        if (!this._activeDevices.size) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidStateError("No active output devices to test"));
        return Promise.all(Array.from(this._activeDevices).map(function(device) {
            var el;
            // (rrowland) We need to wait for the oncanplay event because of a regression introduced
            // in Chrome M72: https://bugs.chromium.org/p/chromium/issues/detail?id=930876
            return new Promise(function(resolve) {
                el = new Audio(soundUrl);
                el.oncanplay = resolve;
            }).then(function() {
                return el.setSinkId(device.deviceId).then(function() {
                    return el.play();
                });
            });
        }));
    };
    return OutputDeviceCollection;
}();
$9f7e520c5c2d3314$exports.default = $9f7e520c5c2d3314$var$OutputDeviceCollection;


var $3cb2157746d27905$exports = {};
"use strict";
Object.defineProperty($3cb2157746d27905$exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var $3cb2157746d27905$var$MediaDeviceInfoShim = /** @class */ function() {
    function MediaDeviceInfoShim(options) {
        Object.defineProperties(this, {
            deviceId: {
                get: function() {
                    return options.deviceId;
                }
            },
            groupId: {
                get: function() {
                    return options.groupId;
                }
            },
            kind: {
                get: function() {
                    return options.kind;
                }
            },
            label: {
                get: function() {
                    return options.label;
                }
            }
        });
    }
    return MediaDeviceInfoShim;
}();
$3cb2157746d27905$exports.default = $3cb2157746d27905$var$MediaDeviceInfoShim;


var $b060d15305f18a68$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty($b060d15305f18a68$exports, "__esModule", {
    value: true
});
$b060d15305f18a68$exports.promisifyEvents = $b060d15305f18a68$exports.flatMap = $b060d15305f18a68$exports.queryToJson = $b060d15305f18a68$exports.isUnifiedPlanDefault = $b060d15305f18a68$exports.isSafari = $b060d15305f18a68$exports.isLegacyEdge = $b060d15305f18a68$exports.isFirefox = $b060d15305f18a68$exports.isChrome = $b060d15305f18a68$exports.isElectron = $b060d15305f18a68$exports.difference = $b060d15305f18a68$exports.average = $b060d15305f18a68$exports.Exception = void 0;
/**
 * Exception class.
 * @class
 * @name Exception
 * @exports Exception as Twilio.Exception
 * @memberOf Twilio
 * @param {string} message The exception message
 */ function $b060d15305f18a68$var$TwilioException(message) {
    if (!(this instanceof $b060d15305f18a68$var$TwilioException)) return new $b060d15305f18a68$var$TwilioException(message);
    this.message = message;
}
/**
 * Returns the exception message.
 *
 * @return {string} The exception message.
 */ $b060d15305f18a68$var$TwilioException.prototype.toString = function() {
    return "Twilio.Exception: " + this.message;
};
function $b060d15305f18a68$var$average(values) {
    return values && values.length ? values.reduce(function(t, v) {
        return t + v;
    }) / values.length : 0;
}
$b060d15305f18a68$exports.average = $b060d15305f18a68$var$average;
function $b060d15305f18a68$var$difference(lefts, rights, getKey) {
    getKey = getKey || function(a) {
        return a;
    };
    var rightKeys = new Set(rights.map(getKey));
    return lefts.filter(function(left) {
        return !rightKeys.has(getKey(left));
    });
}
$b060d15305f18a68$exports.difference = $b060d15305f18a68$var$difference;
function $b060d15305f18a68$var$isElectron(navigator) {
    return !!navigator.userAgent.match("Electron");
}
$b060d15305f18a68$exports.isElectron = $b060d15305f18a68$var$isElectron;
function $b060d15305f18a68$var$isChrome(window1, navigator) {
    var isCriOS = !!navigator.userAgent.match("CriOS");
    var isHeadlessChrome = !!navigator.userAgent.match("HeadlessChrome");
    var isGoogle = typeof window1.chrome !== "undefined" && navigator.vendor === "Google Inc." && navigator.userAgent.indexOf("OPR") === -1 && navigator.userAgent.indexOf("Edge") === -1;
    return isCriOS || $b060d15305f18a68$var$isElectron(navigator) || isGoogle || isHeadlessChrome;
}
$b060d15305f18a68$exports.isChrome = $b060d15305f18a68$var$isChrome;
function $b060d15305f18a68$var$isFirefox(navigator) {
    navigator = navigator || (typeof window === "undefined" ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === "string" && /firefox|fxios/i.test(navigator.userAgent);
}
$b060d15305f18a68$exports.isFirefox = $b060d15305f18a68$var$isFirefox;
function $b060d15305f18a68$var$isLegacyEdge(navigator) {
    navigator = navigator || (typeof window === "undefined" ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === "string" && /edge\/\d+/i.test(navigator.userAgent);
}
$b060d15305f18a68$exports.isLegacyEdge = $b060d15305f18a68$var$isLegacyEdge;
function $b060d15305f18a68$var$isSafari(navigator) {
    return !!navigator.vendor && navigator.vendor.indexOf("Apple") !== -1 && navigator.userAgent && navigator.userAgent.indexOf("CriOS") === -1 && navigator.userAgent.indexOf("FxiOS") === -1;
}
$b060d15305f18a68$exports.isSafari = $b060d15305f18a68$var$isSafari;
function $b060d15305f18a68$var$isUnifiedPlanDefault(window1, navigator, PeerConnection, RtpTransceiver) {
    if (typeof window1 === "undefined" || typeof navigator === "undefined" || typeof PeerConnection === "undefined" || typeof RtpTransceiver === "undefined" || typeof PeerConnection.prototype === "undefined" || typeof RtpTransceiver.prototype === "undefined") return false;
    if ($b060d15305f18a68$var$isChrome(window1, navigator) && PeerConnection.prototype.addTransceiver) {
        var pc = new PeerConnection();
        var isUnifiedPlan = true;
        try {
            pc.addTransceiver("audio");
        } catch (e) {
            isUnifiedPlan = false;
        }
        pc.close();
        return isUnifiedPlan;
    } else if ($b060d15305f18a68$var$isFirefox(navigator)) return true;
    else if ($b060d15305f18a68$var$isSafari(navigator)) return "currentDirection" in RtpTransceiver.prototype;
    // Edge currently does not support unified plan.
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/17733189/
    // https://wpdev.uservoice.com/forums/257854-microsoft-edge-developer/suggestions/34451998-sdp-unified-plan
    return false;
}
$b060d15305f18a68$exports.isUnifiedPlanDefault = $b060d15305f18a68$var$isUnifiedPlanDefault;
function $b060d15305f18a68$var$queryToJson(params) {
    if (!params) return "";
    return params.split("&").reduce(function(output, pair) {
        var parts = pair.split("=");
        var key = parts[0];
        var value = decodeURIComponent((parts[1] || "").replace(/\+/g, "%20"));
        if (key) output[key] = value;
        return output;
    }, {});
}
$b060d15305f18a68$exports.queryToJson = $b060d15305f18a68$var$queryToJson;
/**
 * Map a list to an array of arrays, and return the flattened result.
 * @param {Array<*>|Set<*>|Map<*>} list
 * @param {function(*): Array<*>} [mapFn]
 * @returns Array<*>
 */ function $b060d15305f18a68$var$flatMap(list, mapFn) {
    var listArray = list instanceof Map || list instanceof Set ? Array.from(list.values()) : list;
    mapFn = mapFn || function(item) {
        return item;
    };
    return listArray.reduce(function(flattened, item) {
        var mapped = mapFn(item);
        return flattened.concat(mapped);
    }, []);
}
$b060d15305f18a68$exports.flatMap = $b060d15305f18a68$var$flatMap;
/**
 * Converts an EventEmitter's events into a promise and automatically
 * cleans up handlers once the promise is resolved or rejected.
 */ function $b060d15305f18a68$var$promisifyEvents(emitter, resolveEventName, rejectEventName) {
    return new Promise(function(resolve, reject) {
        function resolveHandler() {
            emitter.removeListener(rejectEventName, rejectHandler);
            resolve();
        }
        function rejectHandler() {
            emitter.removeListener(resolveEventName, resolveHandler);
            reject();
        }
        emitter.once(resolveEventName, resolveHandler);
        emitter.once(rejectEventName, rejectHandler);
    });
}
$b060d15305f18a68$exports.promisifyEvents = $b060d15305f18a68$var$promisifyEvents;
var $b060d15305f18a68$var$Exception = $b060d15305f18a68$var$TwilioException;
$b060d15305f18a68$exports.Exception = $b060d15305f18a68$var$Exception;


/**
 * Aliases for audio kinds, used for labelling.
 * @private
 */ var $54a2599bd8145d0c$var$kindAliases = {
    audioinput: "Audio Input",
    audiooutput: "Audio Output"
};
/**
 * Provides input and output audio-based functionality in one convenient class.
 * @publicapi
 */ var $54a2599bd8145d0c$var$AudioHelper = /** @class */ function(_super) {
    $54a2599bd8145d0c$var$__extends(AudioHelper, _super);
    /**
     * @constructor
     * @private
     * @param onActiveOutputsChanged - A callback to be called when the user changes the active output devices.
     * @param onActiveInputChanged - A callback to be called when the user changes the active input device.
     * @param [options]
     */ function AudioHelper(onActiveOutputsChanged, onActiveInputChanged, options) {
        var _a;
        var _this = _super.call(this) || this;
        /**
         * A Map of all audio input devices currently available to the browser by their device ID.
         */ _this.availableInputDevices = new Map();
        /**
         * A Map of all audio output devices currently available to the browser by their device ID.
         */ _this.availableOutputDevices = new Map();
        /**
         * The currently set audio constraints set by setAudioConstraints().
         */ _this._audioConstraints = null;
        /**
         * The audio stream of the default device.
         * This is populated when _openDefaultDeviceWithConstraints is called,
         * See _selectedInputDeviceStream for differences.
         * TODO: Combine these two workflows (3.x?)
         */ _this._defaultInputDeviceStream = null;
        /**
         * Whether each sound is enabled.
         */ _this._enabledSounds = (_a = {}, _a[$b171bc6ab63df54e$exports.default.SoundName.Disconnect] = true, _a[$b171bc6ab63df54e$exports.default.SoundName.Incoming] = true, _a[$b171bc6ab63df54e$exports.default.SoundName.Outgoing] = true, _a);
        /**
         * The current input device.
         */ _this._inputDevice = null;
        /**
         * The internal promise created when calling setInputDevice
         */ _this._inputDevicePromise = null;
        /**
         * Whether the {@link AudioHelper} is currently polling the input stream's volume.
         */ _this._isPollingInputVolume = false;
        /**
         * An instance of Logger to use.
         */ _this._log = new $674d4885484aa9f2$exports.default("AudioHelper");
        /**
         * Internal reference to the processed stream
         */ _this._processedStream = null;
        /**
         * The selected input stream coming from the microphone device.
         * This is populated when the setInputDevice is called, meaning,
         * the end user manually selected it, which is different than
         * the defaultInputDeviceStream.
         * TODO: Combine these two workflows (3.x?)
         */ _this._selectedInputDeviceStream = null;
        /**
         * A record of unknown devices (Devices without labels)
         */ _this._unknownDeviceIndexes = {
            audioinput: {},
            audiooutput: {}
        };
        /**
         * Update the available input and output devices
         * @private
         */ _this._updateAvailableDevices = function() {
            if (!_this._mediaDevices || !_this._enumerateDevices) return Promise.reject("Enumeration not supported");
            return _this._enumerateDevices().then(function(devices) {
                _this._updateDevices(devices.filter(function(d) {
                    return d.kind === "audiooutput";
                }), _this.availableOutputDevices, _this._removeLostOutput);
                _this._updateDevices(devices.filter(function(d) {
                    return d.kind === "audioinput";
                }), _this.availableInputDevices, _this._removeLostInput);
                var defaultDevice = _this.availableOutputDevices.get("default") || Array.from(_this.availableOutputDevices.values())[0];
                [
                    _this.speakerDevices,
                    _this.ringtoneDevices
                ].forEach(function(outputDevices) {
                    if (!outputDevices.get().size && _this.availableOutputDevices.size && _this.isOutputSelectionSupported) outputDevices.set(defaultDevice.deviceId).catch(function(reason) {
                        _this._log.warn("Unable to set audio output devices. " + reason);
                    });
                });
            });
        };
        /**
         * Remove an input device from inputs
         * @param lostDevice
         * @returns Whether the device was active
         */ _this._removeLostInput = function(lostDevice) {
            if (!_this.inputDevice || _this.inputDevice.deviceId !== lostDevice.deviceId) return false;
            _this._destroyProcessedStream();
            _this._replaceStream(null);
            _this._inputDevice = null;
            _this._maybeStopPollingVolume();
            var defaultDevice = _this.availableInputDevices.get("default") || Array.from(_this.availableInputDevices.values())[0];
            if (defaultDevice) _this.setInputDevice(defaultDevice.deviceId);
            return true;
        };
        /**
         * Remove an input device from outputs
         * @param lostDevice
         * @returns Whether the device was active
         */ _this._removeLostOutput = function(lostDevice) {
            var wasSpeakerLost = _this.speakerDevices.delete(lostDevice);
            var wasRingtoneLost = _this.ringtoneDevices.delete(lostDevice);
            return wasSpeakerLost || wasRingtoneLost;
        };
        options = Object.assign({
            AudioContext: typeof AudioContext !== "undefined" && AudioContext,
            setSinkId: typeof HTMLAudioElement !== "undefined" && HTMLAudioElement.prototype.setSinkId
        }, options);
        _this._beforeSetInputDevice = options.beforeSetInputDevice || function() {
            return Promise.resolve();
        };
        _this._updateUserOptions(options);
        _this._audioProcessorEventObserver = options.audioProcessorEventObserver;
        _this._mediaDevices = options.mediaDevices || navigator.mediaDevices;
        _this._onActiveInputChanged = onActiveInputChanged;
        _this._enumerateDevices = typeof options.enumerateDevices === "function" ? options.enumerateDevices : _this._mediaDevices && _this._mediaDevices.enumerateDevices.bind(_this._mediaDevices);
        var isAudioContextSupported = !!(options.AudioContext || options.audioContext);
        var isEnumerationSupported = !!_this._enumerateDevices;
        if (options.enabledSounds) _this._enabledSounds = options.enabledSounds;
        var isSetSinkSupported = typeof options.setSinkId === "function";
        _this.isOutputSelectionSupported = isEnumerationSupported && isSetSinkSupported;
        _this.isVolumeSupported = isAudioContextSupported;
        if (_this.isVolumeSupported) {
            _this._audioContext = options.audioContext || options.AudioContext && new options.AudioContext();
            if (_this._audioContext) {
                _this._inputVolumeAnalyser = _this._audioContext.createAnalyser();
                _this._inputVolumeAnalyser.fftSize = 32;
                _this._inputVolumeAnalyser.smoothingTimeConstant = 0.3;
            }
        }
        _this.ringtoneDevices = new $9f7e520c5c2d3314$exports.default("ringtone", _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);
        _this.speakerDevices = new $9f7e520c5c2d3314$exports.default("speaker", _this.availableOutputDevices, onActiveOutputsChanged, _this.isOutputSelectionSupported);
        _this.addListener("newListener", function(eventName) {
            if (eventName === "inputVolume") _this._maybeStartPollingVolume();
        });
        _this.addListener("removeListener", function(eventName) {
            if (eventName === "inputVolume") _this._maybeStopPollingVolume();
        });
        _this.once("newListener", function() {
            // NOTE (rrowland): Ideally we would only check isEnumerationSupported here, but
            //   in at least one browser version (Tested in FF48) enumerateDevices actually
            //   returns bad data for the listed devices. Instead, we check for
            //   isOutputSelectionSupported to avoid these quirks that may negatively affect customers.
            if (!_this.isOutputSelectionSupported) _this._log.warn("Warning: This browser does not support audio output selection.");
            if (!_this.isVolumeSupported) _this._log.warn("Warning: This browser does not support Twilio's volume indicator feature.");
        });
        if (isEnumerationSupported) _this._initializeEnumeration();
        // NOTE (kchoy): Currently microphone permissions are not supported in firefox, and Safari V15 and older.
        // https://github.com/mozilla/standards-positions/issues/19#issuecomment-370158947
        // https://caniuse.com/permissions-api
        if (navigator && navigator.permissions && typeof navigator.permissions.query === "function") navigator.permissions.query({
            name: "microphone"
        }).then(function(microphonePermissionStatus) {
            if (microphonePermissionStatus.state !== "granted") {
                var handleStateChange = function() {
                    _this._updateAvailableDevices();
                    _this._stopMicrophonePermissionListener();
                };
                microphonePermissionStatus.addEventListener("change", handleStateChange);
                _this._microphonePermissionStatus = microphonePermissionStatus;
                _this._onMicrophonePermissionStatusChanged = handleStateChange;
            }
        }).catch(function(reason) {
            return _this._log.warn("Warning: unable to listen for microphone permission changes. " + reason);
        });
        else _this._log.warn("Warning: current browser does not support permissions API.");
        return _this;
    }
    Object.defineProperty(AudioHelper.prototype, "audioConstraints", {
        /**
         * The currently set audio constraints set by setAudioConstraints(). Starts as null.
         */ get: function() {
            return this._audioConstraints;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "inputDevice", {
        /**
         * The active input device. Having no inputDevice specified by `setInputDevice()`
         * will disable input selection related functionality.
         */ get: function() {
            return this._inputDevice;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "inputStream", {
        /**
         * The current input stream coming from the microphone device or
         * the processed audio stream if there is an {@link AudioProcessor}.
         */ get: function() {
            return this._processedStream || this._selectedInputDeviceStream;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioHelper.prototype, "processedStream", {
        /**
         * The processed stream if an {@link AudioProcessor} was previously added.
         */ get: function() {
            return this._processedStream;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy this AudioHelper instance
     * @private
     */ AudioHelper.prototype._destroy = function() {
        this._stopDefaultInputDeviceStream();
        this._stopSelectedInputDeviceStream();
        this._destroyProcessedStream();
        this._maybeStopPollingVolume();
        this.removeAllListeners();
        this._stopMicrophonePermissionListener();
        this._unbind();
    };
    /**
     * Promise to wait for the input device, if setInputDevice is called outside of the SDK
     * @private
     */ AudioHelper.prototype._getInputDevicePromise = function() {
        return this._inputDevicePromise;
    };
    /**
     * Start polling volume if it's supported and there's an input stream to poll.
     * @private
     */ AudioHelper.prototype._maybeStartPollingVolume = function() {
        var _this = this;
        if (!this.isVolumeSupported || !this.inputStream) return;
        this._updateVolumeSource();
        if (this._isPollingInputVolume || !this._inputVolumeAnalyser) return;
        var bufferLength = this._inputVolumeAnalyser.frequencyBinCount;
        var buffer = new Uint8Array(bufferLength);
        this._isPollingInputVolume = true;
        var emitVolume = function() {
            if (!_this._isPollingInputVolume) return;
            if (_this._inputVolumeAnalyser) {
                _this._inputVolumeAnalyser.getByteFrequencyData(buffer);
                var inputVolume = $b060d15305f18a68$exports.average(buffer);
                _this.emit("inputVolume", inputVolume / 255);
            }
            requestAnimationFrame(emitVolume);
        };
        requestAnimationFrame(emitVolume);
    };
    /**
     * Stop polling volume if it's currently polling and there are no listeners.
     * @private
     */ AudioHelper.prototype._maybeStopPollingVolume = function() {
        if (!this.isVolumeSupported) return;
        if (!this._isPollingInputVolume || this.inputStream && this.listenerCount("inputVolume")) return;
        if (this._inputVolumeSource) {
            this._inputVolumeSource.disconnect();
            delete this._inputVolumeSource;
        }
        this._isPollingInputVolume = false;
    };
    /**
     * Call getUserMedia with specified constraints
     * @private
     */ AudioHelper.prototype._openDefaultDeviceWithConstraints = function(constraints) {
        var _this = this;
        this._log.info("Opening default device with constraints", constraints);
        return this._getUserMedia(constraints).then(function(stream) {
            _this._log.info("Opened default device. Updating available devices.");
            // Ensures deviceId's and labels are populated after the gUM call
            // by calling enumerateDevices
            _this._updateAvailableDevices().catch(function(error) {
                // Ignore error, we don't want to break the call flow
                _this._log.warn("Unable to updateAvailableDevices after gUM call", error);
            });
            _this._defaultInputDeviceStream = stream;
            return _this._maybeCreateProcessedStream(stream);
        });
    };
    /**
     * Stop the default audio stream
     * @private
     */ AudioHelper.prototype._stopDefaultInputDeviceStream = function() {
        if (this._defaultInputDeviceStream) {
            this._log.info("stopping default device stream");
            this._defaultInputDeviceStream.getTracks().forEach(function(track) {
                return track.stop();
            });
            this._defaultInputDeviceStream = null;
            this._destroyProcessedStream();
        }
    };
    /**
     * Unbind the listeners from mediaDevices.
     * @private
     */ AudioHelper.prototype._unbind = function() {
        if (!this._mediaDevices || !this._enumerateDevices) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Enumeration is not supported");
        if (this._mediaDevices.removeEventListener) this._mediaDevices.removeEventListener("devicechange", this._updateAvailableDevices);
    };
    /**
     * Update AudioHelper options that can be changed by the user
     * @private
     */ AudioHelper.prototype._updateUserOptions = function(options) {
        if (typeof options.enumerateDevices === "function") this._enumerateDevices = options.enumerateDevices;
        if (typeof options.getUserMedia === "function") this._getUserMedia = options.getUserMedia;
    };
    /**
     * Adds an {@link AudioProcessor} object. Once added, the AudioHelper will route
     * the input audio stream through the processor before sending the audio
     * stream to Twilio. Only one AudioProcessor can be added at this time.
     *
     * See the {@link AudioProcessor} interface for an example.
     *
     * @param processor The AudioProcessor to add.
     * @returns
     */ AudioHelper.prototype.addProcessor = function(processor) {
        this._log.debug(".addProcessor");
        if (this._processor) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Adding multiple AudioProcessors is not supported at this time.");
        if (typeof processor !== "object" || processor === null) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Missing AudioProcessor argument.");
        if (typeof processor.createProcessedStream !== "function") throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Missing createProcessedStream() method.");
        if (typeof processor.destroyProcessedStream !== "function") throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Missing destroyProcessedStream() method.");
        this._processor = processor;
        this._audioProcessorEventObserver.emit("add");
        return this._restartStreams();
    };
    /**
     * Enable or disable the disconnect sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.disconnect = function(doEnable) {
        this._log.debug(".disconnect", doEnable);
        return this._maybeEnableSound($b171bc6ab63df54e$exports.default.SoundName.Disconnect, doEnable);
    };
    /**
     * Enable or disable the incoming sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.incoming = function(doEnable) {
        this._log.debug(".incoming", doEnable);
        return this._maybeEnableSound($b171bc6ab63df54e$exports.default.SoundName.Incoming, doEnable);
    };
    /**
     * Enable or disable the outgoing sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ AudioHelper.prototype.outgoing = function(doEnable) {
        this._log.debug(".outgoing", doEnable);
        return this._maybeEnableSound($b171bc6ab63df54e$exports.default.SoundName.Outgoing, doEnable);
    };
    /**
     * Removes an {@link AudioProcessor}. Once removed, the AudioHelper will start using
     * the audio stream from the selected input device for existing or future calls.
     *
     * @param processor The AudioProcessor to remove.
     * @returns
     */ AudioHelper.prototype.removeProcessor = function(processor) {
        this._log.debug(".removeProcessor");
        if (typeof processor !== "object" || processor === null) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Missing AudioProcessor argument.");
        if (this._processor !== processor) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Cannot remove an AudioProcessor that has not been previously added.");
        this._destroyProcessedStream();
        this._processor = null;
        this._audioProcessorEventObserver.emit("remove");
        return this._restartStreams();
    };
    /**
     * Set the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. Any deviceId specified here will be ignored. Instead, device IDs should
     * be specified using {@link AudioHelper#setInputDevice}. The returned Promise resolves
     * when the media is successfully reacquired, or immediately if no input device is set.
     * @param audioConstraints - The MediaTrackConstraints to apply.
     */ AudioHelper.prototype.setAudioConstraints = function(audioConstraints) {
        this._log.debug(".setAudioConstraints", audioConstraints);
        this._audioConstraints = Object.assign({}, audioConstraints);
        delete this._audioConstraints.deviceId;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    };
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     */ AudioHelper.prototype.setInputDevice = function(deviceId) {
        this._log.debug(".setInputDevice", deviceId);
        return this._setInputDevice(deviceId, false);
    };
    /**
     * Unset the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. The returned Promise resolves when the media is successfully reacquired,
     * or immediately if no input device is set.
     */ AudioHelper.prototype.unsetAudioConstraints = function() {
        this._log.debug(".unsetAudioConstraints");
        this._audioConstraints = null;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    };
    /**
     * Unset the input device, stopping the tracks. This should only be called when not in a connection, and
     *   will not allow removal of the input device during a live call.
     */ AudioHelper.prototype.unsetInputDevice = function() {
        var _this = this;
        this._log.debug(".unsetInputDevice", this.inputDevice);
        if (!this.inputDevice) return Promise.resolve();
        this._destroyProcessedStream();
        return this._onActiveInputChanged(null).then(function() {
            _this._replaceStream(null);
            _this._inputDevice = null;
            _this._maybeStopPollingVolume();
        });
    };
    /**
     * Destroys processed stream and update references
     */ AudioHelper.prototype._destroyProcessedStream = function() {
        if (this._processor && this._processedStream) {
            this._log.info("destroying processed stream");
            var processedStream = this._processedStream;
            this._processedStream.getTracks().forEach(function(track) {
                return track.stop();
            });
            this._processedStream = null;
            this._processor.destroyProcessedStream(processedStream);
            this._audioProcessorEventObserver.emit("destroy");
        }
    };
    /**
     * Get the index of an un-labeled Device.
     * @param mediaDeviceInfo
     * @returns The index of the passed MediaDeviceInfo
     */ AudioHelper.prototype._getUnknownDeviceIndex = function(mediaDeviceInfo) {
        var id = mediaDeviceInfo.deviceId;
        var kind = mediaDeviceInfo.kind;
        var index = this._unknownDeviceIndexes[kind][id];
        if (!index) {
            index = Object.keys(this._unknownDeviceIndexes[kind]).length + 1;
            this._unknownDeviceIndexes[kind][id] = index;
        }
        return index;
    };
    /**
     * Initialize output device enumeration.
     */ AudioHelper.prototype._initializeEnumeration = function() {
        var _this = this;
        if (!this._mediaDevices || !this._enumerateDevices) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Enumeration is not supported");
        if (this._mediaDevices.addEventListener) this._mediaDevices.addEventListener("devicechange", this._updateAvailableDevices);
        this._updateAvailableDevices().then(function() {
            if (!_this.isOutputSelectionSupported) return;
            Promise.all([
                _this.speakerDevices.set("default"),
                _this.ringtoneDevices.set("default")
            ]).catch(function(reason) {
                _this._log.warn("Warning: Unable to set audio output devices. " + reason);
            });
        });
    };
    /**
     * Route input stream to the processor if it exists
     */ AudioHelper.prototype._maybeCreateProcessedStream = function(stream) {
        var _this = this;
        if (this._processor) {
            this._log.info("Creating processed stream");
            return this._processor.createProcessedStream(stream).then(function(processedStream) {
                _this._processedStream = processedStream;
                _this._audioProcessorEventObserver.emit("create");
                return _this._processedStream;
            });
        }
        return Promise.resolve(stream);
    };
    /**
     * Set whether the sound is enabled or not
     * @param soundName
     * @param doEnable
     * @returns Whether the sound is enabled or not
     */ AudioHelper.prototype._maybeEnableSound = function(soundName, doEnable) {
        if (typeof doEnable !== "undefined") this._enabledSounds[soundName] = doEnable;
        return this._enabledSounds[soundName];
    };
    /**
     * Stop the tracks on the current input stream before replacing it with the passed stream.
     * @param stream - The new stream
     */ AudioHelper.prototype._replaceStream = function(stream) {
        this._log.info("Replacing with new stream.");
        if (this._selectedInputDeviceStream) {
            this._log.info("Old stream detected. Stopping tracks.");
            this._stopSelectedInputDeviceStream();
        }
        this._selectedInputDeviceStream = stream;
    };
    /**
     * Restart the active streams
     */ AudioHelper.prototype._restartStreams = function() {
        if (this.inputDevice && this._selectedInputDeviceStream) {
            this._log.info("Restarting selected input device");
            return this._setInputDevice(this.inputDevice.deviceId, true);
        }
        if (this._defaultInputDeviceStream) {
            var defaultDevice = this.availableInputDevices.get("default") || Array.from(this.availableInputDevices.values())[0];
            this._log.info("Restarting default input device, now becoming selected.");
            return this._setInputDevice(defaultDevice.deviceId, true);
        }
        return Promise.resolve();
    };
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     * @param forceGetUserMedia - If true, getUserMedia will be called even if
     *   the specified device is already active.
     */ AudioHelper.prototype._setInputDevice = function(deviceId, forceGetUserMedia) {
        return $54a2599bd8145d0c$var$__awaiter(this, void 0, void 0, function() {
            var setInputDevice;
            var _this = this;
            return $54a2599bd8145d0c$var$__generator(this, function(_a) {
                setInputDevice = function() {
                    return $54a2599bd8145d0c$var$__awaiter(_this, void 0, void 0, function() {
                        var device, constraints;
                        var _this = this;
                        return $54a2599bd8145d0c$var$__generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    return [
                                        4 /*yield*/ ,
                                        this._beforeSetInputDevice()
                                    ];
                                case 1:
                                    _a.sent();
                                    if (typeof deviceId !== "string") return [
                                        2 /*return*/ ,
                                        Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Must specify the device to set"))
                                    ];
                                    device = this.availableInputDevices.get(deviceId);
                                    if (!device) return [
                                        2 /*return*/ ,
                                        Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Device not found: " + deviceId))
                                    ];
                                    this._log.info("Setting input device. ID: " + deviceId);
                                    if (this._inputDevice && this._inputDevice.deviceId === deviceId && this._selectedInputDeviceStream) {
                                        if (!forceGetUserMedia) return [
                                            2 /*return*/ ,
                                            Promise.resolve()
                                        ];
                                        // If the currently active track is still in readyState `live`, gUM may return the same track
                                        // rather than returning a fresh track.
                                        this._log.info("Same track detected on setInputDevice, stopping old tracks.");
                                        this._stopSelectedInputDeviceStream();
                                    }
                                    // Release the default device in case it was created previously
                                    this._stopDefaultInputDeviceStream();
                                    constraints = {
                                        audio: Object.assign({
                                            deviceId: {
                                                exact: deviceId
                                            }
                                        }, this.audioConstraints)
                                    };
                                    this._log.info("setInputDevice: getting new tracks.");
                                    return [
                                        2 /*return*/ ,
                                        this._getUserMedia(constraints).then(function(originalStream) {
                                            _this._destroyProcessedStream();
                                            return _this._maybeCreateProcessedStream(originalStream).then(function(newStream) {
                                                _this._log.info("setInputDevice: invoking _onActiveInputChanged.");
                                                return _this._onActiveInputChanged(newStream).then(function() {
                                                    _this._replaceStream(originalStream);
                                                    _this._inputDevice = device;
                                                    _this._maybeStartPollingVolume();
                                                });
                                            });
                                        })
                                    ];
                            }
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    this._inputDevicePromise = setInputDevice().finally(function() {
                        _this._inputDevicePromise = null;
                    })
                ];
            });
        });
    };
    /**
     * Remove event listener for microphone permissions
     */ AudioHelper.prototype._stopMicrophonePermissionListener = function() {
        var _a;
        if ((_a = this._microphonePermissionStatus) === null || _a === void 0 ? void 0 : _a.removeEventListener) this._microphonePermissionStatus.removeEventListener("change", this._onMicrophonePermissionStatusChanged);
    };
    /**
     * Stop the selected audio stream
     */ AudioHelper.prototype._stopSelectedInputDeviceStream = function() {
        if (this._selectedInputDeviceStream) {
            this._log.info("Stopping selected device stream");
            this._selectedInputDeviceStream.getTracks().forEach(function(track) {
                return track.stop();
            });
        }
    };
    /**
     * Update a set of devices.
     * @param updatedDevices - An updated list of available Devices
     * @param availableDevices - The previous list of available Devices
     * @param removeLostDevice - The method to call if a previously available Device is
     *   no longer available.
     */ AudioHelper.prototype._updateDevices = function(updatedDevices, availableDevices, removeLostDevice) {
        var _this = this;
        var updatedDeviceIds = updatedDevices.map(function(d) {
            return d.deviceId;
        });
        var knownDeviceIds = Array.from(availableDevices.values()).map(function(d) {
            return d.deviceId;
        });
        var lostActiveDevices = [];
        // Remove lost devices
        var lostDeviceIds = $b060d15305f18a68$exports.difference(knownDeviceIds, updatedDeviceIds);
        lostDeviceIds.forEach(function(lostDeviceId) {
            var lostDevice = availableDevices.get(lostDeviceId);
            if (lostDevice) {
                availableDevices.delete(lostDeviceId);
                if (removeLostDevice(lostDevice)) lostActiveDevices.push(lostDevice);
            }
        });
        // Add any new devices, or devices with updated labels
        var deviceChanged = false;
        updatedDevices.forEach(function(newDevice) {
            var existingDevice = availableDevices.get(newDevice.deviceId);
            var newMediaDeviceInfo = _this._wrapMediaDeviceInfo(newDevice);
            if (!existingDevice || existingDevice.label !== newMediaDeviceInfo.label) {
                availableDevices.set(newDevice.deviceId, newMediaDeviceInfo);
                deviceChanged = true;
            }
        });
        if (deviceChanged || lostDeviceIds.length) {
            // Force a new gUM in case the underlying tracks of the active stream have changed. One
            //   reason this might happen is when `default` is selected and set to a USB device,
            //   then that device is unplugged or plugged back in. We can't check for the 'ended'
            //   event or readyState because it is asynchronous and may take upwards of 5 seconds,
            //   in my testing. (rrowland)
            var defaultId_1 = "default";
            // this.inputDevice is not null if audio.setInputDevice() was explicitly called
            var isInputDeviceSet = this.inputDevice && this.inputDevice.deviceId === defaultId_1;
            // If this.inputDevice is null, and default stream is not null, it means
            // the user is using the default stream and did not explicitly call audio.setInputDevice()
            var isDefaultDeviceSet = this._defaultInputDeviceStream && this.availableInputDevices.get(defaultId_1);
            if (isInputDeviceSet || isDefaultDeviceSet) {
                this._log.warn("Calling getUserMedia after device change to ensure that the           tracks of the active device (default) have not gone stale.");
                // NOTE(csantos): Updating the stream in the same execution context as the devicechange event
                // causes the new gUM call to fail silently. Meaning, the gUM call may succeed,
                // but it won't actually update the stream. We need to update the stream in a different
                // execution context (setTimeout) to properly update the stream.
                setTimeout(function() {
                    _this._setInputDevice(defaultId_1, true);
                }, 0);
            }
            this._log.debug("#deviceChange", lostActiveDevices);
            this.emit("deviceChange", lostActiveDevices);
        }
    };
    /**
     * Disconnect the old input volume source, and create and connect a new one with the current
     * input stream.
     */ AudioHelper.prototype._updateVolumeSource = function() {
        if (!this.inputStream || !this._audioContext || !this._inputVolumeAnalyser) return;
        if (this._inputVolumeSource) this._inputVolumeSource.disconnect();
        try {
            this._inputVolumeSource = this._audioContext.createMediaStreamSource(this.inputStream);
            this._inputVolumeSource.connect(this._inputVolumeAnalyser);
        } catch (ex) {
            this._log.warn("Unable to update volume source", ex);
            delete this._inputVolumeSource;
        }
    };
    /**
     * Convert a MediaDeviceInfo to a IMediaDeviceInfoShim.
     * @param mediaDeviceInfo - The info to convert
     * @returns The converted shim
     */ AudioHelper.prototype._wrapMediaDeviceInfo = function(mediaDeviceInfo) {
        var options = {
            deviceId: mediaDeviceInfo.deviceId,
            groupId: mediaDeviceInfo.groupId,
            kind: mediaDeviceInfo.kind,
            label: mediaDeviceInfo.label
        };
        if (!options.label) {
            if (options.deviceId === "default") options.label = "Default";
            else {
                var index = this._getUnknownDeviceIndex(mediaDeviceInfo);
                options.label = "Unknown " + $54a2599bd8145d0c$var$kindAliases[options.kind] + " Device " + index;
            }
        }
        return new $3cb2157746d27905$exports.default(options);
    };
    return AudioHelper;
}($0bfd6a77e39eae31$exports.EventEmitter);
$54a2599bd8145d0c$var$AudioHelper || ($54a2599bd8145d0c$var$AudioHelper = {});
$54a2599bd8145d0c$exports.default = $54a2599bd8145d0c$var$AudioHelper;


var $faaf8cc587ce2922$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $faaf8cc587ce2922$var$__extends = $faaf8cc587ce2922$exports && $faaf8cc587ce2922$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($faaf8cc587ce2922$exports, "__esModule", {
    value: true
});
$faaf8cc587ce2922$exports.AudioProcessorEventObserver = void 0;


/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @private
 */ var $faaf8cc587ce2922$var$AudioProcessorEventObserver = /** @class */ function(_super) {
    $faaf8cc587ce2922$var$__extends(AudioProcessorEventObserver, _super);
    function AudioProcessorEventObserver() {
        var _this = _super.call(this) || this;
        _this._log = new $674d4885484aa9f2$exports.default("AudioProcessorEventObserver");
        _this._log.info("Creating AudioProcessorEventObserver instance");
        _this.on("enabled", function() {
            return _this._reEmitEvent("enabled");
        });
        _this.on("add", function() {
            return _this._reEmitEvent("add");
        });
        _this.on("remove", function() {
            return _this._reEmitEvent("remove");
        });
        _this.on("create", function() {
            return _this._reEmitEvent("create-processed-stream");
        });
        _this.on("destroy", function() {
            return _this._reEmitEvent("destroy-processed-stream");
        });
        return _this;
    }
    AudioProcessorEventObserver.prototype.destroy = function() {
        this.removeAllListeners();
    };
    AudioProcessorEventObserver.prototype._reEmitEvent = function(name) {
        this._log.info("AudioProcessor:" + name);
        this.emit("event", {
            name: name,
            group: "audio-processor"
        });
    };
    return AudioProcessorEventObserver;
}($0bfd6a77e39eae31$exports.EventEmitter);
$faaf8cc587ce2922$exports.AudioProcessorEventObserver = $faaf8cc587ce2922$var$AudioProcessorEventObserver;




var $a927d7a97cfdd257$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ Object.defineProperty($a927d7a97cfdd257$exports, "__esModule", {
    value: true
});

/**
 * A Map of DTMF Sound Names to their mock frequency pairs.
 */ var $a927d7a97cfdd257$var$bandFrequencies = {
    dtmf0: [
        1360,
        960
    ],
    dtmf1: [
        1230,
        720
    ],
    dtmf2: [
        1360,
        720
    ],
    dtmf3: [
        1480,
        720
    ],
    dtmf4: [
        1230,
        790
    ],
    dtmf5: [
        1360,
        790
    ],
    dtmf6: [
        1480,
        790
    ],
    dtmf7: [
        1230,
        870
    ],
    dtmf8: [
        1360,
        870
    ],
    dtmf9: [
        1480,
        870
    ],
    dtmfh: [
        1480,
        960
    ],
    dtmfs: [
        1230,
        960
    ]
};
var $a927d7a97cfdd257$var$DialtonePlayer = /** @class */ function() {
    function DialtonePlayer(_context) {
        var _this = this;
        this._context = _context;
        /**
         * Gain nodes, reducing the frequency.
         */ this._gainNodes = [];
        this._gainNodes = [
            this._context.createGain(),
            this._context.createGain()
        ];
        this._gainNodes.forEach(function(gainNode) {
            gainNode.connect(_this._context.destination);
            gainNode.gain.value = 0.1;
            _this._gainNodes.push(gainNode);
        });
    }
    DialtonePlayer.prototype.cleanup = function() {
        this._gainNodes.forEach(function(gainNode) {
            gainNode.disconnect();
        });
    };
    /**
     * Play the dual frequency tone for the passed DTMF name.
     * @param sound
     */ DialtonePlayer.prototype.play = function(sound) {
        var _this = this;
        var frequencies = $a927d7a97cfdd257$var$bandFrequencies[sound];
        if (!frequencies) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Invalid DTMF sound name");
        var oscillators = [
            this._context.createOscillator(),
            this._context.createOscillator()
        ];
        oscillators.forEach(function(oscillator, i) {
            oscillator.type = "sine";
            oscillator.frequency.value = frequencies[i];
            oscillator.connect(_this._gainNodes[i]);
            oscillator.start();
            oscillator.stop(_this._context.currentTime + 0.1);
            oscillator.addEventListener("ended", function() {
                return oscillator.disconnect();
            });
        });
    };
    return DialtonePlayer;
}();
$a927d7a97cfdd257$exports.default = $a927d7a97cfdd257$var$DialtonePlayer;



var $589357f68de838e6$exports = {};
"use strict";
var $589357f68de838e6$var$__extends = $589357f68de838e6$exports && $589357f68de838e6$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($589357f68de838e6$exports, "__esModule", {
    value: true
});


var $59f7367924b380b3$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty($59f7367924b380b3$exports, "__esModule", {
    value: true
});
function $59f7367924b380b3$var$request(method, params, callback) {
    var body = JSON.stringify(params.body || {});
    var headers = new Headers();
    params.headers = params.headers || [];
    Object.entries(params.headers).forEach(function(_a) {
        var headerName = _a[0], headerBody = _a[1];
        return headers.append(headerName, headerBody);
    });
    fetch(params.url, {
        body: body,
        headers: headers,
        method: method
    }).then(function(response) {
        return response.text();
    }, callback).then(function(responseText) {
        return callback(null, responseText);
    }, callback);
}
/**
 * Use XMLHttpRequest to get a network resource.
 * @param {String} method - HTTP Method
 * @param {Object} params - Request parameters
 * @param {String} params.url - URL of the resource
 * @param {Array}  params.headers - An array of headers to pass [{ headerName : headerBody }]
 * @param {Object} params.body - A JSON body to send to the resource
 * @returns {response}
 */ var $59f7367924b380b3$var$Request = $59f7367924b380b3$var$request;
/**
 * Sugar function for request('GET', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~get} callback - The callback that handles the response.
 */ $59f7367924b380b3$var$Request.get = function get(params, callback) {
    return new this("GET", params, callback);
};
/**
 * Sugar function for request('POST', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~post} callback - The callback that handles the response.
 */ $59f7367924b380b3$var$Request.post = function post(params, callback) {
    return new this("POST", params, callback);
};
$59f7367924b380b3$exports.default = $59f7367924b380b3$var$Request;


/**
 * Builds Endpoint Analytics (EA) event payloads and sends them to
 *   the EA server.
 * @constructor
 * @param {String} productName - Name of the product publishing events.
 * @param {String} token - The JWT token to use to authenticate with
 *   the EA server.
 * @param {EventPublisher.Options} options
 * @property {Boolean} isEnabled - Whether or not this publisher is publishing
 *   to the server. Currently ignores the request altogether, in the future this
 *   may store them in case publishing is re-enabled later. Defaults to true.
 */ /**
 * @typedef {Object} EventPublisher.Options
 * @property {Object} [metadata=undefined] - A publisher_metadata object to send
 *   with each payload.
 * @property {String} [host='eventgw.twilio.com'] - The host address of the EA
 *   server to publish to.
 * @property {Object|Function} [defaultPayload] - A default payload to extend
 *   when creating and sending event payloads. Also takes a function that
 *   should return an object representing the default payload. This is
 *   useful for fields that should always be present when they are
 *   available, but are not always available.
 */ var $589357f68de838e6$var$EventPublisher = /** @class */ function(_super) {
    $589357f68de838e6$var$__extends(EventPublisher, _super);
    function EventPublisher(productName, token, options) {
        var _this = _super.call(this) || this;
        if (!(_this instanceof EventPublisher)) return new EventPublisher(productName, token, options);
        // Apply default options
        options = Object.assign({
            defaultPayload: function() {
                return {};
            }
        }, options);
        var defaultPayload = options.defaultPayload;
        if (typeof defaultPayload !== "function") defaultPayload = function() {
            return Object.assign({}, options.defaultPayload);
        };
        var isEnabled = true;
        var metadata = Object.assign({
            app_name: undefined,
            app_version: undefined
        }, options.metadata);
        Object.defineProperties(_this, {
            _defaultPayload: {
                value: defaultPayload
            },
            _host: {
                value: options.host,
                writable: true
            },
            _isEnabled: {
                get: function() {
                    return isEnabled;
                },
                set: function(_isEnabled) {
                    isEnabled = _isEnabled;
                }
            },
            _log: {
                value: new $674d4885484aa9f2$exports.default("EventPublisher")
            },
            _request: {
                value: options.request || $59f7367924b380b3$exports.default,
                writable: true
            },
            _token: {
                value: token,
                writable: true
            },
            isEnabled: {
                enumerable: true,
                get: function() {
                    return isEnabled;
                }
            },
            metadata: {
                enumerable: true,
                get: function() {
                    return metadata;
                }
            },
            productName: {
                enumerable: true,
                value: productName
            },
            token: {
                enumerable: true,
                get: function() {
                    return this._token;
                }
            }
        });
        return _this;
    }
    return EventPublisher;
}($0bfd6a77e39eae31$exports.EventEmitter);
/**
 * Post to an EA server.
 * @private
 * @param {String} endpointName - Endpoint to post the event to
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @param {?Boolean} [force=false] - Whether or not to send this even if
 *    publishing is disabled.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype._post = function _post(endpointName, level, group, name, payload, connection, force) {
    var _this = this;
    if (!this.isEnabled && !force || !this._host) {
        this._log.debug("Publishing cancelled", JSON.stringify({
            isEnabled: this.isEnabled,
            force: force,
            host: this._host
        }));
        return Promise.resolve();
    }
    if (!connection || (!connection.parameters || !connection.parameters.CallSid) && !connection.outboundConnectionId) {
        if (!connection) this._log.debug("Publishing cancelled. Missing connection object");
        else this._log.debug("Publishing cancelled. Missing connection info", JSON.stringify({
            outboundConnectionId: connection.outboundConnectionId,
            parameters: connection.parameters
        }));
        return Promise.resolve();
    }
    var event = {
        group: group,
        level: level.toUpperCase(),
        name: name,
        payload: payload && payload.forEach ? payload.slice(0) : Object.assign(this._defaultPayload(connection), payload),
        payload_type: "application/json",
        private: false,
        publisher: this.productName,
        timestamp: new Date().toISOString()
    };
    if (this.metadata) event.publisher_metadata = this.metadata;
    if (endpointName === "EndpointEvents") this._log.debug("Publishing insights", JSON.stringify({
        endpointName: endpointName,
        event: event,
        force: force,
        host: this._host
    }));
    var requestParams = {
        body: event,
        headers: {
            "Content-Type": "application/json",
            "X-Twilio-Token": this.token
        },
        url: "https://" + this._host + "/v4/" + endpointName
    };
    return new Promise(function(resolve, reject) {
        _this._request.post(requestParams, function(err) {
            if (err) {
                _this.emit("error", err);
                reject(err);
            } else resolve();
        });
    }).catch(function(e) {
        _this._log.error("Unable to post " + group + " " + name + " event to Insights. Received error: " + e);
    });
};
/**
 * Post an event to the EA server. Use this method when the level
 *  is dynamic. Otherwise, it's better practice to use the sugar
 *  methods named for the specific level.
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.post = function post(level, group, name, payload, connection, force) {
    return this._post("EndpointEvents", level, group, name, payload, connection, force);
};
/**
 * Post a debug-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.debug = function debug(group, name, payload, connection) {
    return this.post("debug", group, name, payload, connection);
};
/**
 * Post an info-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.info = function info(group, name, payload, connection) {
    return this.post("info", group, name, payload, connection);
};
/**
 * Post a warning-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.warn = function warn(group, name, payload, connection) {
    return this.post("warning", group, name, payload, connection);
};
/**
 * Post an error-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.error = function error(group, name, payload, connection) {
    return this.post("error", group, name, payload, connection);
};
/**
 * Post a metrics event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {Array<Object>} metrics - The metrics to post.
 * @param {?Object} [customFields] - Custom fields to append to each payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $589357f68de838e6$var$EventPublisher.prototype.postMetrics = function postMetrics(group, name, metrics, customFields, connection) {
    var _this = this;
    return new Promise(function(resolve) {
        var samples = metrics.map($589357f68de838e6$var$formatMetric).map(function(sample) {
            return Object.assign(sample, customFields);
        });
        resolve(_this._post("EndpointMetrics", "info", group, name, samples, connection));
    });
};
/**
 * Update the host address of the insights server to publish to.
 * @param {String} host - The new host address of the insights server.
 */ $589357f68de838e6$var$EventPublisher.prototype.setHost = function setHost(host) {
    this._host = host;
};
/**
 * Update the token to use to authenticate requests.
 * @param {string} token
 * @returns {void}
 */ $589357f68de838e6$var$EventPublisher.prototype.setToken = function setToken(token) {
    this._token = token;
};
/**
 * Enable the publishing of events.
 */ $589357f68de838e6$var$EventPublisher.prototype.enable = function enable() {
    this._isEnabled = true;
};
/**
 * Disable the publishing of events.
 */ $589357f68de838e6$var$EventPublisher.prototype.disable = function disable() {
    this._isEnabled = false;
};
function $589357f68de838e6$var$formatMetric(sample) {
    return {
        audio_codec: sample.codecName,
        audio_level_in: sample.audioInputLevel,
        audio_level_out: sample.audioOutputLevel,
        bytes_received: sample.bytesReceived,
        bytes_sent: sample.bytesSent,
        call_volume_input: sample.inputVolume,
        call_volume_output: sample.outputVolume,
        jitter: sample.jitter,
        mos: sample.mos && Math.round(sample.mos * 100) / 100,
        packets_lost: sample.packetsLost,
        packets_lost_fraction: sample.packetsLostFraction && Math.round(sample.packetsLostFraction * 100) / 100,
        packets_received: sample.packetsReceived,
        rtt: sample.rtt,
        timestamp: new Date(sample.timestamp).toISOString(),
        total_bytes_received: sample.totals.bytesReceived,
        total_bytes_sent: sample.totals.bytesSent,
        total_packets_lost: sample.totals.packetsLost,
        total_packets_received: sample.totals.packetsReceived,
        total_packets_sent: sample.totals.packetsSent
    };
}
$589357f68de838e6$exports.default = $589357f68de838e6$var$EventPublisher;



var $87f1bccdd5744d30$exports = {};
"use strict";
var $87f1bccdd5744d30$var$__extends = $87f1bccdd5744d30$exports && $87f1bccdd5744d30$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $87f1bccdd5744d30$var$__assign = $87f1bccdd5744d30$exports && $87f1bccdd5744d30$exports.__assign || function() {
    $87f1bccdd5744d30$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87f1bccdd5744d30$var$__assign.apply(this, arguments);
};
var $87f1bccdd5744d30$var$__awaiter = $87f1bccdd5744d30$exports && $87f1bccdd5744d30$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $87f1bccdd5744d30$var$__generator = $87f1bccdd5744d30$exports && $87f1bccdd5744d30$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($87f1bccdd5744d30$exports, "__esModule", {
    value: true
});
$87f1bccdd5744d30$exports.PreflightTest = void 0;





var $2818b1ada62f2007$exports = {};
"use strict";
var $2818b1ada62f2007$var$__spreadArrays = $2818b1ada62f2007$exports && $2818b1ada62f2007$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($2818b1ada62f2007$exports, "__esModule", {
    value: true
});
$2818b1ada62f2007$exports.getRTCIceCandidateStatsReport = $2818b1ada62f2007$exports.getRTCStats = void 0;

var $43635ee3f7940fdc$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
Object.defineProperty($43635ee3f7940fdc$exports, "__esModule", {
    value: true
});
/**
 * This file was imported from another project. If making changes to this file, please don't
 * make them here. Make them on the linked repo below, then copy back:
 * https://code.hq.twilio.com/client/MockRTCStatsReport
 */ // The legacy max volume, which is the positive half of a signed short integer.
var $43635ee3f7940fdc$var$OLD_MAX_VOLUME = 32767;
var $43635ee3f7940fdc$var$NativeRTCStatsReport = typeof window !== "undefined" ? window.RTCStatsReport : undefined;
/**
 * Create a MockRTCStatsReport wrapper around a Map of RTCStats objects. If RTCStatsReport is available
 *   natively, it will be inherited so that instanceof checks pass.
 * @constructor
 * @extends RTCStatsReport
 * @param {Map<string, RTCStats>} statsMap - A Map of RTCStats objects to wrap
 *   with a MockRTCStatsReport object.
 */ function $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap) {
    if (!(this instanceof $43635ee3f7940fdc$var$MockRTCStatsReport)) return new $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap);
    var self = this;
    Object.defineProperties(this, {
        _map: {
            value: statsMap
        },
        size: {
            enumerable: true,
            get: function() {
                return self._map.size;
            }
        }
    });
    this[Symbol.iterator] = statsMap[Symbol.iterator];
}
// If RTCStatsReport is available natively, inherit it. Keep our constructor.
if ($43635ee3f7940fdc$var$NativeRTCStatsReport) {
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype = Object.create($43635ee3f7940fdc$var$NativeRTCStatsReport.prototype);
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype.constructor = $43635ee3f7940fdc$var$MockRTCStatsReport;
}
// Map the Map-like read methods to the underlying Map
[
    "entries",
    "forEach",
    "get",
    "has",
    "keys",
    "values"
].forEach(function(key) {
    $43635ee3f7940fdc$var$MockRTCStatsReport.prototype[key] = function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (_a = this._map)[key].apply(_a, args);
    };
});
/**
 * Convert an array of RTCStats objects into a mock RTCStatsReport object.
 * @param {Array<RTCStats>}
 * @return {MockRTCStatsReport}
 */ $43635ee3f7940fdc$var$MockRTCStatsReport.fromArray = function fromArray(array) {
    return new $43635ee3f7940fdc$var$MockRTCStatsReport(array.reduce(function(map, rtcStats) {
        map.set(rtcStats.id, rtcStats);
        return map;
    }, new Map()));
};
/**
 * Convert a legacy RTCStatsResponse object into a mock RTCStatsReport object.
 * @param {RTCStatsResponse} statsResponse - An RTCStatsResponse object returned by the
 *   legacy getStats(callback) method in Chrome.
 * @return {MockRTCStatsReport} A mock RTCStatsReport object.
 */ $43635ee3f7940fdc$var$MockRTCStatsReport.fromRTCStatsResponse = function fromRTCStatsResponse(statsResponse) {
    var activeCandidatePairId;
    var transportIds = new Map();
    var statsMap = statsResponse.result().reduce(function(map, report) {
        var id = report.id;
        switch(report.type){
            case "googCertificate":
                map.set(id, $43635ee3f7940fdc$var$createRTCCertificateStats(report));
                break;
            case "datachannel":
                map.set(id, $43635ee3f7940fdc$var$createRTCDataChannelStats(report));
                break;
            case "googCandidatePair":
                if ($43635ee3f7940fdc$var$getBoolean(report, "googActiveConnection")) activeCandidatePairId = id;
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidatePairStats(report));
                break;
            case "localcandidate":
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, false));
                break;
            case "remotecandidate":
                map.set(id, $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, true));
                break;
            case "ssrc":
                if ($43635ee3f7940fdc$var$isPresent(report, "packetsReceived")) map.set("rtp-" + id, $43635ee3f7940fdc$var$createRTCInboundRTPStreamStats(report));
                else map.set("rtp-" + id, $43635ee3f7940fdc$var$createRTCOutboundRTPStreamStats(report));
                map.set("track-" + id, $43635ee3f7940fdc$var$createRTCMediaStreamTrackStats(report));
                map.set("codec-" + id, $43635ee3f7940fdc$var$createRTCCodecStats(report));
                break;
            case "googComponent":
                var transportReport = $43635ee3f7940fdc$var$createRTCTransportStats(report);
                transportIds.set(transportReport.selectedCandidatePairId, id);
                map.set(id, $43635ee3f7940fdc$var$createRTCTransportStats(report));
                break;
        }
        return map;
    }, new Map());
    if (activeCandidatePairId) {
        var activeTransportId = transportIds.get(activeCandidatePairId);
        if (activeTransportId) statsMap.get(activeTransportId).dtlsState = "connected";
    }
    return new $43635ee3f7940fdc$var$MockRTCStatsReport(statsMap);
};
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCTransportStats}
 */ function $43635ee3f7940fdc$var$createRTCTransportStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        dtlsState: undefined,
        id: report.id,
        localCertificateId: report.stat("localCertificateId"),
        remoteCertificateId: report.stat("remoteCertificateId"),
        rtcpTransportStatsId: undefined,
        selectedCandidatePairId: report.stat("selectedCandidatePairId"),
        timestamp: Date.parse(report.timestamp),
        type: "transport"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCCodecStats}
 */ function $43635ee3f7940fdc$var$createRTCCodecStats(report) {
    return {
        channels: undefined,
        clockRate: undefined,
        id: report.id,
        implementation: undefined,
        mimeType: report.stat("mediaType") + "/" + report.stat("googCodecName"),
        payloadType: undefined,
        sdpFmtpLine: undefined,
        timestamp: Date.parse(report.timestamp),
        type: "codec"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCMediaStreamTrackStats}
 */ function $43635ee3f7940fdc$var$createRTCMediaStreamTrackStats(report) {
    return {
        audioLevel: $43635ee3f7940fdc$var$isPresent(report, "audioOutputLevel") ? $43635ee3f7940fdc$var$getInt(report, "audioOutputLevel") / $43635ee3f7940fdc$var$OLD_MAX_VOLUME : ($43635ee3f7940fdc$var$getInt(report, "audioInputLevel") || 0) / $43635ee3f7940fdc$var$OLD_MAX_VOLUME,
        detached: undefined,
        echoReturnLoss: $43635ee3f7940fdc$var$getFloat(report, "googEchoCancellationReturnLoss"),
        echoReturnLossEnhancement: $43635ee3f7940fdc$var$getFloat(report, "googEchoCancellationReturnLossEnhancement"),
        ended: undefined,
        frameHeight: $43635ee3f7940fdc$var$isPresent(report, "googFrameHeightReceived") ? $43635ee3f7940fdc$var$getInt(report, "googFrameHeightReceived") : $43635ee3f7940fdc$var$getInt(report, "googFrameHeightSent"),
        frameWidth: $43635ee3f7940fdc$var$isPresent(report, "googFrameWidthReceived") ? $43635ee3f7940fdc$var$getInt(report, "googFrameWidthReceived") : $43635ee3f7940fdc$var$getInt(report, "googFrameWidthSent"),
        framesCorrupted: undefined,
        framesDecoded: $43635ee3f7940fdc$var$getInt(report, "framesDecoded"),
        framesDropped: undefined,
        framesPerSecond: undefined,
        framesReceived: undefined,
        framesSent: $43635ee3f7940fdc$var$getInt(report, "framesEncoded"),
        fullFramesLost: undefined,
        id: report.id,
        kind: report.stat("mediaType"),
        partialFramesLost: undefined,
        remoteSource: undefined,
        ssrcIds: undefined,
        timestamp: Date.parse(report.timestamp),
        trackIdentifier: report.stat("googTrackId"),
        type: "track"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isInbound - Whether to create an inbound stats object, or outbound.
 * @returns {RTCRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, isInbound) {
    return {
        associateStatsId: undefined,
        codecId: "codec-" + report.id,
        firCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googFirsSent") : undefined,
        id: report.id,
        isRemote: undefined,
        mediaType: report.stat("mediaType"),
        nackCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googNacksSent") : $43635ee3f7940fdc$var$getInt(report, "googNacksReceived"),
        pliCount: isInbound ? $43635ee3f7940fdc$var$getInt(report, "googPlisSent") : $43635ee3f7940fdc$var$getInt(report, "googPlisReceived"),
        qpSum: $43635ee3f7940fdc$var$getInt(report, "qpSum"),
        sliCount: undefined,
        ssrc: report.stat("ssrc"),
        timestamp: Date.parse(report.timestamp),
        trackId: "track-" + report.id,
        transportId: report.stat("transportId")
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCInboundRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCInboundRTPStreamStats(report) {
    var rtp = $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, true);
    Object.assign(rtp, {
        burstDiscardCount: undefined,
        burstDiscardRate: undefined,
        burstLossCount: undefined,
        burstLossRate: undefined,
        burstPacketsDiscarded: undefined,
        burstPacketsLost: undefined,
        bytesReceived: $43635ee3f7940fdc$var$getInt(report, "bytesReceived"),
        fractionLost: undefined,
        framesDecoded: $43635ee3f7940fdc$var$getInt(report, "framesDecoded"),
        gapDiscardRate: undefined,
        gapLossRate: undefined,
        jitter: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googJitterReceived")),
        packetsDiscarded: undefined,
        packetsLost: $43635ee3f7940fdc$var$getInt(report, "packetsLost"),
        packetsReceived: $43635ee3f7940fdc$var$getInt(report, "packetsReceived"),
        packetsRepaired: undefined,
        roundTripTime: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googRtt")),
        type: "inbound-rtp"
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCOutboundRTPStreamStats}
 */ function $43635ee3f7940fdc$var$createRTCOutboundRTPStreamStats(report) {
    var rtp = $43635ee3f7940fdc$var$createRTCRTPStreamStats(report, false);
    Object.assign(rtp, {
        bytesSent: $43635ee3f7940fdc$var$getInt(report, "bytesSent"),
        framesEncoded: $43635ee3f7940fdc$var$getInt(report, "framesEncoded"),
        packetsSent: $43635ee3f7940fdc$var$getInt(report, "packetsSent"),
        remoteTimestamp: undefined,
        targetBitrate: undefined,
        type: "outbound-rtp"
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isRemote - Whether to create for a remote candidate, or local candidate.
 * @returns {RTCIceCandidateStats}
 */ function $43635ee3f7940fdc$var$createRTCIceCandidateStats(report, isRemote) {
    return {
        candidateType: $43635ee3f7940fdc$var$translateCandidateType(report.stat("candidateType")),
        deleted: undefined,
        id: report.id,
        ip: report.stat("ipAddress"),
        isRemote: isRemote,
        port: $43635ee3f7940fdc$var$getInt(report, "portNumber"),
        priority: $43635ee3f7940fdc$var$getFloat(report, "priority"),
        protocol: report.stat("transport"),
        relayProtocol: undefined,
        timestamp: Date.parse(report.timestamp),
        transportId: undefined,
        type: isRemote ? "remote-candidate" : "local-candidate",
        url: undefined
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCandidatePairStats}
 */ function $43635ee3f7940fdc$var$createRTCIceCandidatePairStats(report) {
    return {
        availableIncomingBitrate: undefined,
        availableOutgoingBitrate: undefined,
        bytesReceived: $43635ee3f7940fdc$var$getInt(report, "bytesReceived"),
        bytesSent: $43635ee3f7940fdc$var$getInt(report, "bytesSent"),
        consentRequestsSent: $43635ee3f7940fdc$var$getInt(report, "consentRequestsSent"),
        currentRoundTripTime: $43635ee3f7940fdc$var$convertMsToSeconds(report.stat("googRtt")),
        id: report.id,
        lastPacketReceivedTimestamp: undefined,
        lastPacketSentTimestamp: undefined,
        localCandidateId: report.stat("localCandidateId"),
        nominated: undefined,
        priority: undefined,
        readable: undefined,
        remoteCandidateId: report.stat("remoteCandidateId"),
        requestsReceived: $43635ee3f7940fdc$var$getInt(report, "requestsReceived"),
        requestsSent: $43635ee3f7940fdc$var$getInt(report, "requestsSent"),
        responsesReceived: $43635ee3f7940fdc$var$getInt(report, "responsesReceived"),
        responsesSent: $43635ee3f7940fdc$var$getInt(report, "responsesSent"),
        retransmissionsReceived: undefined,
        retransmissionsSent: undefined,
        state: undefined,
        timestamp: Date.parse(report.timestamp),
        totalRoundTripTime: undefined,
        transportId: report.stat("googChannelId"),
        type: "candidate-pair",
        writable: $43635ee3f7940fdc$var$getBoolean(report, "googWritable")
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCertificateStats}
 */ function $43635ee3f7940fdc$var$createRTCCertificateStats(report) {
    return {
        base64Certificate: report.stat("googDerBase64"),
        fingerprint: report.stat("googFingerprint"),
        fingerprintAlgorithm: report.stat("googFingerprintAlgorithm"),
        id: report.id,
        issuerCertificateId: report.stat("googIssuerId"),
        timestamp: Date.parse(report.timestamp),
        type: "certificate"
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCDataChannelStats}
 */ function $43635ee3f7940fdc$var$createRTCDataChannelStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        datachannelid: report.stat("datachannelid"),
        id: report.id,
        label: report.stat("label"),
        messagesReceived: undefined,
        messagesSent: undefined,
        protocol: report.stat("protocol"),
        state: report.stat("state"),
        timestamp: Date.parse(report.timestamp),
        transportId: report.stat("transportId"),
        type: "data-channel"
    };
}
/**
 * @param {number} inMs - A time in milliseconds
 * @returns {number} The time in seconds
 */ function $43635ee3f7940fdc$var$convertMsToSeconds(inMs) {
    return isNaN(inMs) || inMs === "" ? undefined : parseInt(inMs, 10) / 1000;
}
/**
 * @param {string} type - A type in the legacy format
 * @returns {string} The type adjusted to new standards for known naming changes
 */ function $43635ee3f7940fdc$var$translateCandidateType(type) {
    switch(type){
        case "peerreflexive":
            return "prflx";
        case "serverreflexive":
            return "srflx";
        case "host":
        case "relay":
        default:
            return type;
    }
}
function $43635ee3f7940fdc$var$getInt(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? parseInt(stat, 10) : undefined;
}
function $43635ee3f7940fdc$var$getFloat(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? parseFloat(stat) : undefined;
}
function $43635ee3f7940fdc$var$getBoolean(report, statName) {
    var stat = report.stat(statName);
    return $43635ee3f7940fdc$var$isPresent(report, statName) ? stat === "true" || stat === true : undefined;
}
function $43635ee3f7940fdc$var$isPresent(report, statName) {
    var stat = report.stat(statName);
    return typeof stat !== "undefined" && stat !== "";
}
$43635ee3f7940fdc$exports.default = $43635ee3f7940fdc$var$MockRTCStatsReport;


var $2818b1ada62f2007$var$ERROR_PEER_CONNECTION_NULL = "PeerConnection is null";
var $2818b1ada62f2007$var$ERROR_WEB_RTC_UNSUPPORTED = "WebRTC statistics are unsupported";
/**
 * Helper function to find a specific stat from a report.
 * Some environment provide the stats report as a map (regular browsers)
 * but some provide stats report as an array (citrix vdi)
 * @private
 */ function $2818b1ada62f2007$var$findStatById(report, id) {
    if (typeof report.get === "function") return report.get(id);
    return report.find(function(s) {
        return s.id === id;
    });
}
/**
 * Generate WebRTC statistics report for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCStatsReport>} WebRTC RTCStatsReport object
 */ function $2818b1ada62f2007$var$getRTCStatsReport(peerConnection) {
    if (!peerConnection) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError($2818b1ada62f2007$var$ERROR_PEER_CONNECTION_NULL));
    if (typeof peerConnection.getStats !== "function") return Promise.reject(new $9b99a7197ac9a7b1$exports.NotSupportedError($2818b1ada62f2007$var$ERROR_WEB_RTC_UNSUPPORTED));
    var promise;
    try {
        promise = peerConnection.getStats();
    } catch (e) {
        promise = new Promise(function(resolve) {
            return peerConnection.getStats(resolve);
        }).then($43635ee3f7940fdc$exports.default.fromRTCStatsResponse);
    }
    return promise;
}
/**
 * @typedef {Object} StatsOptions
 * Used for testing to inject and extract methods.
 * @property {function} [createRTCSample] - Method for parsing an RTCStatsReport
 */ /**
 * Collects any WebRTC statistics for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @param {StatsOptions} options - List of custom options.
 * @return {Promise<RTCSample>} Universally-formatted version of RTC stats.
 */ function $2818b1ada62f2007$var$getRTCStats(peerConnection, options) {
    options = Object.assign({
        createRTCSample: $2818b1ada62f2007$var$createRTCSample
    }, options);
    return $2818b1ada62f2007$var$getRTCStatsReport(peerConnection).then(options.createRTCSample);
}
$2818b1ada62f2007$exports.getRTCStats = $2818b1ada62f2007$var$getRTCStats;
/**
 * Generate WebRTC stats report containing relevant information about ICE candidates for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCIceCandidateStatsReport>} RTCIceCandidateStatsReport object
 */ function $2818b1ada62f2007$var$getRTCIceCandidateStatsReport(peerConnection) {
    return $2818b1ada62f2007$var$getRTCStatsReport(peerConnection).then(function(report) {
        // Find the relevant information needed to determine selected candidates later
        var _a = Array.from(report.values()).reduce(function(rval, stat) {
            [
                "candidatePairs",
                "localCandidates",
                "remoteCandidates"
            ].forEach(function(prop) {
                if (!rval[prop]) rval[prop] = [];
            });
            switch(stat.type){
                case "candidate-pair":
                    rval.candidatePairs.push(stat);
                    break;
                case "local-candidate":
                    rval.localCandidates.push(stat);
                    break;
                case "remote-candidate":
                    rval.remoteCandidates.push(stat);
                    break;
                case "transport":
                    // This transport is the one being used if selectedCandidatePairId is populated
                    if (stat.selectedCandidatePairId) rval.transport = stat;
                    break;
            }
            return rval;
        }, {}), candidatePairs = _a.candidatePairs, localCandidates = _a.localCandidates, remoteCandidates = _a.remoteCandidates, transport = _a.transport;
        // This is a report containing information about the selected candidates, such as IDs
        // This is coming from WebRTC stats directly and doesn't contain the actual ICE Candidates info
        var selectedCandidatePairReport = candidatePairs.find(function(pair) {
            // Firefox
            return pair.selected || // Spec-compliant way
            transport && pair.id === transport.selectedCandidatePairId;
        });
        var selectedIceCandidatePairStats;
        if (selectedCandidatePairReport) selectedIceCandidatePairStats = {
            localCandidate: localCandidates.find(function(candidate) {
                return candidate.id === selectedCandidatePairReport.localCandidateId;
            }),
            remoteCandidate: remoteCandidates.find(function(candidate) {
                return candidate.id === selectedCandidatePairReport.remoteCandidateId;
            })
        };
        // Build the return object
        return {
            iceCandidateStats: $2818b1ada62f2007$var$__spreadArrays(localCandidates, remoteCandidates),
            selectedIceCandidatePairStats: selectedIceCandidatePairStats
        };
    });
}
$2818b1ada62f2007$exports.getRTCIceCandidateStatsReport = $2818b1ada62f2007$var$getRTCIceCandidateStatsReport;
/**
 * @typedef {Object} RTCSample - A sample containing relevant WebRTC stats information.
 * @property {Number} [timestamp]
 * @property {String} [codecName] - MimeType name of the codec being used by the outbound audio stream
 * @property {Number} [rtt] - Round trip time
 * @property {Number} [jitter]
 * @property {Number} [packetsSent]
 * @property {Number} [packetsLost]
 * @property {Number} [packetsReceived]
 * @property {Number} [bytesReceived]
 * @property {Number} [bytesSent]
 * @property {Number} [localAddress]
 * @property {Number} [remoteAddress]
 */ function $2818b1ada62f2007$var$RTCSample() {}
/**
 * Create an RTCSample object from an RTCStatsReport
 * @private
 * @param {RTCStatsReport} statsReport
 * @returns {RTCSample}
 */ function $2818b1ada62f2007$var$createRTCSample(statsReport) {
    var activeTransportId = null;
    var sample = new $2818b1ada62f2007$var$RTCSample();
    var fallbackTimestamp;
    Array.from(statsReport.values()).forEach(function(stats) {
        // Skip isRemote tracks which will be phased out completely and break in FF66.
        if (stats.isRemote) return;
        // Firefox hack -- Older firefox doesn't have dashes in type names
        var type = stats.type.replace("-", "");
        fallbackTimestamp = fallbackTimestamp || stats.timestamp;
        // (rrowland) As I understand it, this is supposed to come in on remote-inbound-rtp but it's
        // currently coming in on remote-outbound-rtp, so I'm leaving this outside the switch until
        // the appropriate place to look is cleared up.
        if (stats.remoteId) {
            var remote = $2818b1ada62f2007$var$findStatById(statsReport, stats.remoteId);
            if (remote && remote.roundTripTime) sample.rtt = remote.roundTripTime * 1000;
        }
        switch(type){
            case "inboundrtp":
                sample.timestamp = sample.timestamp || stats.timestamp;
                sample.jitter = stats.jitter * 1000;
                sample.packetsLost = stats.packetsLost;
                sample.packetsReceived = stats.packetsReceived;
                sample.bytesReceived = stats.bytesReceived;
                break;
            case "outboundrtp":
                sample.timestamp = stats.timestamp;
                sample.packetsSent = stats.packetsSent;
                sample.bytesSent = stats.bytesSent;
                if (stats.codecId) {
                    var codec = $2818b1ada62f2007$var$findStatById(statsReport, stats.codecId);
                    sample.codecName = codec ? codec.mimeType && codec.mimeType.match(/(.*\/)?(.*)/)[2] : stats.codecId;
                }
                break;
            case "transport":
                activeTransportId = stats.id;
                break;
        }
    });
    if (!sample.timestamp) sample.timestamp = fallbackTimestamp;
    var activeTransport = $2818b1ada62f2007$var$findStatById(statsReport, activeTransportId);
    if (!activeTransport) return sample;
    var selectedCandidatePair = $2818b1ada62f2007$var$findStatById(statsReport, activeTransport.selectedCandidatePairId);
    if (!selectedCandidatePair) return sample;
    var localCandidate = $2818b1ada62f2007$var$findStatById(statsReport, selectedCandidatePair.localCandidateId);
    var remoteCandidate = $2818b1ada62f2007$var$findStatById(statsReport, selectedCandidatePair.remoteCandidateId);
    if (!sample.rtt) sample.rtt = selectedCandidatePair && selectedCandidatePair.currentRoundTripTime * 1000;
    Object.assign(sample, {
        // ip is deprecated. use address first then ip if on older versions of browser
        localAddress: localCandidate && (localCandidate.address || localCandidate.ip),
        remoteAddress: remoteCandidate && (remoteCandidate.address || remoteCandidate.ip)
    });
    return sample;
}



/**
 * Runs some tests to identify issues, if any, prohibiting successful calling.
 */ var $87f1bccdd5744d30$var$PreflightTest = /** @class */ function(_super) {
    $87f1bccdd5744d30$var$__extends(PreflightTest, _super);
    /**
     * Construct a {@link PreflightTest} instance.
     * @constructor
     * @param token - A Twilio JWT token string.
     * @param options
     */ function PreflightTest(token, options) {
        var _this = _super.call(this) || this;
        /**
         * Whether this test has already logged an insights-connection-warning.
         */ _this._hasInsightsErrored = false;
        /**
         * An instance of Logger to use.
         */ _this._log = new $674d4885484aa9f2$exports.default("PreflightTest");
        /**
         * Network related timing measurements for this test
         */ _this._networkTiming = {};
        /**
         * The options passed to {@link PreflightTest} constructor
         */ _this._options = {
            codecPreferences: [
                $d421c5c6d9b8d50a$exports.default.Codec.PCMU,
                $d421c5c6d9b8d50a$exports.default.Codec.Opus
            ],
            edge: "roaming",
            fakeMicInput: false,
            logLevel: "error",
            signalingTimeoutMs: 10000
        };
        /**
         * Current status of this test
         */ _this._status = PreflightTest.Status.Connecting;
        Object.assign(_this._options, options);
        _this._samples = [];
        _this._warnings = [];
        _this._startTime = Date.now();
        _this._initDevice(token, $87f1bccdd5744d30$var$__assign($87f1bccdd5744d30$var$__assign({}, _this._options), {
            fileInputStream: _this._options.fakeMicInput ? _this._getStreamFromFile() : undefined
        }));
        // Device sets the loglevel so start logging after initializing the device.
        // Then selectively log options that users can modify.
        var userOptions = [
            "codecPreferences",
            "edge",
            "fakeMicInput",
            "logLevel",
            "signalingTimeoutMs"
        ];
        var userOptionOverrides = [
            "audioContext",
            "deviceFactory",
            "fileInputStream",
            "getRTCIceCandidateStatsReport",
            "iceServers",
            "rtcConfiguration"
        ];
        if (typeof options === "object") {
            var toLog_1 = $87f1bccdd5744d30$var$__assign({}, options);
            Object.keys(toLog_1).forEach(function(key) {
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog_1[key];
                if (userOptionOverrides.includes(key)) toLog_1[key] = true;
            });
            _this._log.debug(".constructor", JSON.stringify(toLog_1));
        }
        return _this;
    }
    /**
     * Stops the current test and raises a failed event.
     */ PreflightTest.prototype.stop = function() {
        var _this = this;
        this._log.debug(".stop");
        var error = new $9b99a7197ac9a7b1$exports.GeneralErrors.CallCancelledError();
        if (this._device) {
            this._device.once($b171bc6ab63df54e$exports.default.EventName.Unregistered, function() {
                return _this._onFailed(error);
            });
            this._device.destroy();
        } else this._onFailed(error);
    };
    /**
     * Emit a {PreflightTest.Warning}
     */ PreflightTest.prototype._emitWarning = function(name, description, rtcWarning) {
        var warning = {
            name: name,
            description: description
        };
        if (rtcWarning) warning.rtcWarning = rtcWarning;
        this._warnings.push(warning);
        this._log.debug("#" + PreflightTest.Events.Warning, JSON.stringify(warning));
        this.emit(PreflightTest.Events.Warning, warning);
    };
    /**
     * Returns call quality base on the RTC Stats
     */ PreflightTest.prototype._getCallQuality = function(mos) {
        if (mos > 4.2) return PreflightTest.CallQuality.Excellent;
        else if (mos >= 4.1 && mos <= 4.2) return PreflightTest.CallQuality.Great;
        else if (mos >= 3.7 && mos <= 4) return PreflightTest.CallQuality.Good;
        else if (mos >= 3.1 && mos <= 3.6) return PreflightTest.CallQuality.Fair;
        else return PreflightTest.CallQuality.Degraded;
    };
    /**
     * Returns the report for this test.
     */ PreflightTest.prototype._getReport = function() {
        var _a, _b, _c;
        var stats = this._getRTCStats();
        var testTiming = {
            start: this._startTime
        };
        if (this._endTime) {
            testTiming.end = this._endTime;
            testTiming.duration = this._endTime - this._startTime;
        }
        var report = {
            callSid: this._callSid,
            edge: this._edge,
            iceCandidateStats: (_b = (_a = this._rtcIceCandidateStatsReport) === null || _a === void 0 ? void 0 : _a.iceCandidateStats) !== null && _b !== void 0 ? _b : [],
            networkTiming: this._networkTiming,
            samples: this._samples,
            selectedEdge: this._options.edge,
            stats: stats,
            testTiming: testTiming,
            totals: this._getRTCSampleTotals(),
            warnings: this._warnings
        };
        var selectedIceCandidatePairStats = (_c = this._rtcIceCandidateStatsReport) === null || _c === void 0 ? void 0 : _c.selectedIceCandidatePairStats;
        if (selectedIceCandidatePairStats) {
            report.selectedIceCandidatePairStats = selectedIceCandidatePairStats;
            report.isTurnRequired = selectedIceCandidatePairStats.localCandidate.candidateType === "relay" || selectedIceCandidatePairStats.remoteCandidate.candidateType === "relay";
        }
        if (stats) report.callQuality = this._getCallQuality(stats.mos.average);
        return report;
    };
    /**
     * Returns RTC stats totals for this test
     */ PreflightTest.prototype._getRTCSampleTotals = function() {
        if (!this._latestSample) return;
        return $87f1bccdd5744d30$var$__assign({}, this._latestSample.totals);
    };
    /**
     * Returns RTC related stats captured during the test call
     */ PreflightTest.prototype._getRTCStats = function() {
        var firstMosSampleIdx = this._samples.findIndex(function(sample) {
            return typeof sample.mos === "number" && sample.mos > 0;
        });
        var samples = firstMosSampleIdx >= 0 ? this._samples.slice(firstMosSampleIdx) : [];
        if (!samples || !samples.length) return;
        return [
            "jitter",
            "mos",
            "rtt"
        ].reduce(function(statObj, stat) {
            var _a;
            var values = samples.map(function(s) {
                return s[stat];
            });
            return $87f1bccdd5744d30$var$__assign($87f1bccdd5744d30$var$__assign({}, statObj), (_a = {}, _a[stat] = {
                average: Number((values.reduce(function(total, value) {
                    return total + value;
                }) / values.length).toPrecision(5)),
                max: Math.max.apply(Math, values),
                min: Math.min.apply(Math, values)
            }, _a));
        }, {});
    };
    /**
     * Returns a MediaStream from a media file
     */ PreflightTest.prototype._getStreamFromFile = function() {
        var audioContext = this._options.audioContext;
        if (!audioContext) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Cannot fake input audio stream: AudioContext is not supported by this browser.");
        var audioEl = new Audio($e9da3ede67c59403$exports.COWBELL_AUDIO_URL);
        audioEl.addEventListener("canplaythrough", function() {
            return audioEl.play();
        });
        if (typeof audioEl.setAttribute === "function") audioEl.setAttribute("crossorigin", "anonymous");
        var src = audioContext.createMediaElementSource(audioEl);
        var dest = audioContext.createMediaStreamDestination();
        src.connect(dest);
        return dest.stream;
    };
    /**
     * Initialize the device
     */ PreflightTest.prototype._initDevice = function(token, options) {
        var _this = this;
        try {
            this._device = new (options.deviceFactory || $b171bc6ab63df54e$exports.default)(token, {
                codecPreferences: options.codecPreferences,
                edge: options.edge,
                fileInputStream: options.fileInputStream,
                logLevel: options.logLevel,
                preflight: true
            });
            this._device.once($b171bc6ab63df54e$exports.default.EventName.Registered, function() {
                _this._onDeviceRegistered();
            });
            this._device.once($b171bc6ab63df54e$exports.default.EventName.Error, function(error) {
                _this._onDeviceError(error);
            });
            this._device.register();
        } catch (error) {
            // We want to return before failing so the consumer can capture the event
            setTimeout(function() {
                _this._onFailed(error);
            });
            return;
        }
        this._signalingTimeoutTimer = setTimeout(function() {
            _this._onDeviceError(new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionError("WebSocket Connection Timeout"));
        }, options.signalingTimeoutMs);
    };
    /**
     * Called on {@link Device} error event
     * @param error
     */ PreflightTest.prototype._onDeviceError = function(error) {
        this._device.destroy();
        this._onFailed(error);
    };
    /**
     * Called on {@link Device} ready event
     */ PreflightTest.prototype._onDeviceRegistered = function() {
        return $87f1bccdd5744d30$var$__awaiter(this, void 0, void 0, function() {
            var _a, audio, publisher;
            var _this = this;
            return $87f1bccdd5744d30$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        clearTimeout(this._echoTimer);
                        clearTimeout(this._signalingTimeoutTimer);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._device.connect({
                                rtcConfiguration: this._options.rtcConfiguration
                            })
                        ];
                    case 1:
                        _a._call = _b.sent();
                        this._networkTiming.signaling = {
                            start: Date.now()
                        };
                        this._setupCallHandlers(this._call);
                        this._edge = this._device.edge || undefined;
                        if (this._options.fakeMicInput) {
                            this._echoTimer = setTimeout(function() {
                                return _this._device.disconnectAll();
                            }, $e9da3ede67c59403$exports.ECHO_TEST_DURATION);
                            audio = this._device.audio;
                            if (audio) {
                                audio.disconnect(false);
                                audio.outgoing(false);
                            }
                        }
                        this._call.once("disconnect", function() {
                            _this._device.once($b171bc6ab63df54e$exports.default.EventName.Unregistered, function() {
                                return _this._onUnregistered();
                            });
                            _this._device.destroy();
                        });
                        publisher = this._call["_publisher"];
                        publisher.on("error", function() {
                            if (!_this._hasInsightsErrored) _this._emitWarning("insights-connection-error", "Received an error when attempting to connect to Insights gateway");
                            _this._hasInsightsErrored = true;
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Called when there is a fatal error
     * @param error
     */ PreflightTest.prototype._onFailed = function(error) {
        clearTimeout(this._echoTimer);
        clearTimeout(this._signalingTimeoutTimer);
        this._releaseHandlers();
        this._endTime = Date.now();
        this._status = PreflightTest.Status.Failed;
        this._log.debug("#" + PreflightTest.Events.Failed, error);
        this.emit(PreflightTest.Events.Failed, error);
    };
    /**
     * Called when the device goes offline.
     * This indicates that the test has been completed, but we won't know if it failed or not.
     * The onError event will be the indicator whether the test failed.
     */ PreflightTest.prototype._onUnregistered = function() {
        var _this = this;
        // We need to make sure we always execute preflight.on('completed') last
        // as client SDK sometimes emits 'offline' event before emitting fatal errors.
        setTimeout(function() {
            if (_this._status === PreflightTest.Status.Failed) return;
            clearTimeout(_this._echoTimer);
            clearTimeout(_this._signalingTimeoutTimer);
            _this._releaseHandlers();
            _this._endTime = Date.now();
            _this._status = PreflightTest.Status.Completed;
            _this._report = _this._getReport();
            _this._log.debug("#" + PreflightTest.Events.Completed, JSON.stringify(_this._report));
            _this.emit(PreflightTest.Events.Completed, _this._report);
        }, 10);
    };
    /**
     * Clean up all handlers for device and call
     */ PreflightTest.prototype._releaseHandlers = function() {
        [
            this._device,
            this._call
        ].forEach(function(emitter) {
            if (emitter) emitter.eventNames().forEach(function(name) {
                return emitter.removeAllListeners(name);
            });
        });
    };
    /**
     * Setup the event handlers for the {@link Call} of the test call
     * @param call
     */ PreflightTest.prototype._setupCallHandlers = function(call) {
        var _this = this;
        if (this._options.fakeMicInput) // When volume events start emitting, it means all audio outputs have been created.
        // Let's mute them if we're using fake mic input.
        call.once("volume", function() {
            call["_mediaHandler"].outputs.forEach(function(output) {
                return output.audio.muted = true;
            });
        });
        call.on("warning", function(name, data) {
            _this._emitWarning(name, "Received an RTCWarning. See .rtcWarning for the RTCWarning", data);
        });
        call.once("accept", function() {
            _this._callSid = call["_mediaHandler"].callSid;
            _this._status = PreflightTest.Status.Connected;
            _this._log.debug("#" + PreflightTest.Events.Connected);
            _this.emit(PreflightTest.Events.Connected);
        });
        call.on("sample", function(sample) {
            return $87f1bccdd5744d30$var$__awaiter(_this, void 0, void 0, function() {
                var _a;
                return $87f1bccdd5744d30$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!!this._latestSample) return [
                                3 /*break*/ ,
                                2
                            ];
                            _a = this;
                            return [
                                4 /*yield*/ ,
                                (this._options.getRTCIceCandidateStatsReport || $2818b1ada62f2007$exports.getRTCIceCandidateStatsReport)(call["_mediaHandler"].version.pc)
                            ];
                        case 1:
                            _a._rtcIceCandidateStatsReport = _b.sent();
                            _b.label = 2;
                        case 2:
                            this._latestSample = sample;
                            this._samples.push(sample);
                            this._log.debug("#" + PreflightTest.Events.Sample, JSON.stringify(sample));
                            this.emit(PreflightTest.Events.Sample, sample);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        // TODO: Update the following once the SDK supports emitting these events
        // Let's shim for now
        [
            {
                reportLabel: "peerConnection",
                type: "pcconnection"
            },
            {
                reportLabel: "ice",
                type: "iceconnection"
            },
            {
                reportLabel: "dtls",
                type: "dtlstransport"
            },
            {
                reportLabel: "signaling",
                type: "signaling"
            }
        ].forEach(function(_a) {
            var type = _a.type, reportLabel = _a.reportLabel;
            var handlerName = "on" + type + "statechange";
            var originalHandler = call["_mediaHandler"][handlerName];
            call["_mediaHandler"][handlerName] = function(state) {
                var timing = _this._networkTiming[reportLabel] = _this._networkTiming[reportLabel] || {
                    start: 0
                };
                if (state === "connecting" || state === "checking") timing.start = Date.now();
                else if ((state === "connected" || state === "stable") && !timing.duration) {
                    timing.end = Date.now();
                    timing.duration = timing.end - timing.start;
                }
                originalHandler(state);
            };
        });
    };
    Object.defineProperty(PreflightTest.prototype, "callSid", {
        /**
         * The callsid generated for the test call.
         */ get: function() {
            return this._callSid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "endTime", {
        /**
         * A timestamp in milliseconds of when the test ended.
         */ get: function() {
            return this._endTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "latestSample", {
        /**
         * The latest WebRTC sample collected.
         */ get: function() {
            return this._latestSample;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "report", {
        /**
         * The report for this test.
         */ get: function() {
            return this._report;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "startTime", {
        /**
         * A timestamp in milliseconds of when the test started.
         */ get: function() {
            return this._startTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreflightTest.prototype, "status", {
        /**
         * The status of the test.
         */ get: function() {
            return this._status;
        },
        enumerable: false,
        configurable: true
    });
    return PreflightTest;
}($0bfd6a77e39eae31$exports.EventEmitter);
$87f1bccdd5744d30$exports.PreflightTest = $87f1bccdd5744d30$var$PreflightTest;
(function(PreflightTest) {
    /**
     * The quality of the call determined by different mos ranges.
     * Mos is calculated base on the WebRTC stats - rtt, jitter, and packet lost.
     */ var CallQuality;
    (function(CallQuality) {
        /**
         * If the average mos is over 4.2.
         */ CallQuality["Excellent"] = "excellent";
        /**
         * If the average mos is between 4.1 and 4.2 both inclusive.
         */ CallQuality["Great"] = "great";
        /**
         * If the average mos is between 3.7 and 4.0 both inclusive.
         */ CallQuality["Good"] = "good";
        /**
         * If the average mos is between 3.1 and 3.6 both inclusive.
         */ CallQuality["Fair"] = "fair";
        /**
         * If the average mos is 3.0 or below.
         */ CallQuality["Degraded"] = "degraded";
    })(CallQuality = PreflightTest.CallQuality || (PreflightTest.CallQuality = {}));
    /**
     * Possible events that a [[PreflightTest]] might emit.
     */ var Events;
    (function(Events) {
        /**
         * See [[PreflightTest.completedEvent]]
         */ Events["Completed"] = "completed";
        /**
         * See [[PreflightTest.connectedEvent]]
         */ Events["Connected"] = "connected";
        /**
         * See [[PreflightTest.failedEvent]]
         */ Events["Failed"] = "failed";
        /**
         * See [[PreflightTest.sampleEvent]]
         */ Events["Sample"] = "sample";
        /**
         * See [[PreflightTest.warningEvent]]
         */ Events["Warning"] = "warning";
    })(Events = PreflightTest.Events || (PreflightTest.Events = {}));
    /**
     * Possible status of the test.
     */ var Status;
    (function(Status) {
        /**
         * Call to Twilio has initiated.
         */ Status["Connecting"] = "connecting";
        /**
         * Call to Twilio has been established.
         */ Status["Connected"] = "connected";
        /**
         * The connection to Twilio has been disconnected and the test call has completed.
         */ Status["Completed"] = "completed";
        /**
         * The test has stopped and failed.
         */ Status["Failed"] = "failed";
    })(Status = PreflightTest.Status || (PreflightTest.Status = {}));
})($87f1bccdd5744d30$var$PreflightTest = $87f1bccdd5744d30$exports.PreflightTest || ($87f1bccdd5744d30$exports.PreflightTest = {}));
$87f1bccdd5744d30$exports.PreflightTest = $87f1bccdd5744d30$var$PreflightTest;


var $2b1007c1151c9a8f$exports = {};
"use strict";
var $2b1007c1151c9a8f$var$__extends = $2b1007c1151c9a8f$exports && $2b1007c1151c9a8f$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($2b1007c1151c9a8f$exports, "__esModule", {
    value: true
});




var $2bba9ec2604db348$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Tools
 * @internalapi
 */ var $2bba9ec2604db348$var$__extends = $2bba9ec2604db348$exports && $2bba9ec2604db348$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2bba9ec2604db348$var$__assign = $2bba9ec2604db348$exports && $2bba9ec2604db348$exports.__assign || function() {
    $2bba9ec2604db348$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2bba9ec2604db348$var$__assign.apply(this, arguments);
};
Object.defineProperty($2bba9ec2604db348$exports, "__esModule", {
    value: true
});
$2bba9ec2604db348$exports.WSTransportState = void 0;




var $2bba9ec2604db348$var$WebSocket = globalThis.WebSocket;
var $2bba9ec2604db348$var$CONNECT_SUCCESS_TIMEOUT = 10000;
var $2bba9ec2604db348$var$CONNECT_TIMEOUT = 5000;
var $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT = 15000;
var $2bba9ec2604db348$var$MAX_PREFERRED_DURATION = 15000;
var $2bba9ec2604db348$var$MAX_PRIMARY_DURATION = Infinity;
var $2bba9ec2604db348$var$MAX_PREFERRED_DELAY = 1000;
var $2bba9ec2604db348$var$MAX_PRIMARY_DELAY = 20000;
/**
 * All possible states of WSTransport.
 */ var $2bba9ec2604db348$var$WSTransportState;
(function(WSTransportState) {
    /**
     * The WebSocket is not open but is trying to connect.
     */ WSTransportState["Connecting"] = "connecting";
    /**
     * The WebSocket is not open and is not trying to connect.
     */ WSTransportState["Closed"] = "closed";
    /**
     * The underlying WebSocket is open and active.
     */ WSTransportState["Open"] = "open";
})($2bba9ec2604db348$var$WSTransportState = $2bba9ec2604db348$exports.WSTransportState || ($2bba9ec2604db348$exports.WSTransportState = {}));
/**
 * WebSocket Transport
 */ var $2bba9ec2604db348$var$WSTransport = /** @class */ function(_super) {
    $2bba9ec2604db348$var$__extends(WSTransport, _super);
    /**
     * @constructor
     * @param uris - List of URI of the endpoints to connect to.
     * @param [options] - Constructor options.
     */ function WSTransport(uris, options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The current state of the WSTransport.
         */ _this.state = $2bba9ec2604db348$var$WSTransportState.Closed;
        /**
         * Start timestamp values for backoffs.
         */ _this._backoffStartTime = {
            preferred: null,
            primary: null
        };
        /**
         * The URI that the transport is connecting or connected to. The value of this
         * property is `null` if a connection attempt has not been made yet.
         */ _this._connectedUri = null;
        /**
         * An instance of Logger to use.
         */ _this._log = new $674d4885484aa9f2$exports.default("WSTransport");
        /**
         * Whether we should attempt to fallback if we receive an applicable error
         * when trying to connect to a signaling endpoint.
         */ _this._shouldFallback = false;
        /**
         * The current uri index that the transport is connected to.
         */ _this._uriIndex = 0;
        /**
         * Move the uri index to the next index
         * If the index is at the end, the index goes back to the first one.
         */ _this._moveUriIndex = function() {
            _this._uriIndex++;
            if (_this._uriIndex >= _this._uris.length) _this._uriIndex = 0;
        };
        /**
         * Called in response to WebSocket#close event.
         */ _this._onSocketClose = function(event) {
            _this._log.error("Received websocket close event code: " + event.code + ". Reason: " + event.reason);
            // 1006: Abnormal close. When the server is unreacheable
            // 1015: TLS Handshake error
            if (event.code === 1006 || event.code === 1015) {
                _this.emit("error", {
                    code: 31005,
                    message: event.reason || "Websocket connection to Twilio's signaling servers were unexpectedly ended. If this is happening consistently, there may be an issue resolving the hostname provided. If a region or an edge is being specified in Device setup, ensure it is valid.",
                    twilioError: new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionError()
                });
                var wasConnected = // Only in Safari and certain Firefox versions, on network interruption, websocket drops right away with 1006
                // Let's check current state if it's open, meaning we should not fallback
                // because we're coming from a previously connected session
                _this.state === $2bba9ec2604db348$var$WSTransportState.Open || // But on other browsers, websocket doesn't drop
                // but our heartbeat catches it, setting the internal state to "Connecting".
                // With this, we should check the previous state instead.
                _this._previousState === $2bba9ec2604db348$var$WSTransportState.Open;
                // Only fallback if this is not the first error
                // and if we were not connected previously
                if (_this._shouldFallback || !wasConnected) _this._moveUriIndex();
                _this._shouldFallback = true;
            }
            _this._closeSocket();
        };
        /**
         * Called in response to WebSocket#error event.
         */ _this._onSocketError = function(err) {
            _this._log.error("WebSocket received error: " + err.message);
            _this.emit("error", {
                code: 31000,
                message: err.message || "WSTransport socket error",
                twilioError: new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionDisconnected()
            });
        };
        /**
         * Called in response to WebSocket#message event.
         */ _this._onSocketMessage = function(message) {
            // Clear heartbeat timeout on any incoming message, as they
            // all indicate an active connection.
            _this._setHeartbeatTimeout();
            // Filter and respond to heartbeats
            if (_this._socket && message.data === "\n") {
                _this._socket.send("\n");
                _this._log.debug("heartbeat");
                return;
            }
            if (message && typeof message.data === "string") _this._log.debug("Received: " + message.data);
            _this.emit("message", message);
        };
        /**
         * Called in response to WebSocket#open event.
         */ _this._onSocketOpen = function() {
            _this._log.info("WebSocket opened successfully.");
            _this._timeOpened = Date.now();
            _this._shouldFallback = false;
            _this._setState($2bba9ec2604db348$var$WSTransportState.Open);
            clearTimeout(_this._connectTimeout);
            _this._resetBackoffs();
            _this._setHeartbeatTimeout();
            _this.emit("open");
        };
        _this._options = $2bba9ec2604db348$var$__assign($2bba9ec2604db348$var$__assign({}, WSTransport.defaultConstructorOptions), options);
        _this._uris = uris;
        _this._backoff = _this._setupBackoffs();
        return _this;
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ WSTransport.prototype.close = function() {
        this._log.info("WSTransport.close() called...");
        this._close();
    };
    /**
     * Attempt to open a WebSocket connection.
     */ WSTransport.prototype.open = function() {
        this._log.info("WSTransport.open() called...");
        if (this._socket && (this._socket.readyState === $2bba9ec2604db348$var$WebSocket.CONNECTING || this._socket.readyState === $2bba9ec2604db348$var$WebSocket.OPEN)) {
            this._log.info("WebSocket already open.");
            return;
        }
        if (this._preferredUri) this._connect(this._preferredUri);
        else this._connect(this._uris[this._uriIndex]);
    };
    /**
     * Send a message through the WebSocket connection.
     * @param message - A message to send to the endpoint.
     * @returns Whether the message was sent.
     */ WSTransport.prototype.send = function(message) {
        this._log.debug("Sending: " + message);
        // We can't send the message if the WebSocket isn't open
        if (!this._socket || this._socket.readyState !== $2bba9ec2604db348$var$WebSocket.OPEN) {
            this._log.debug("Cannot send message. WebSocket is not open.");
            return false;
        }
        try {
            this._socket.send(message);
        } catch (e) {
            // Some unknown error occurred. Reset the socket to get a fresh session.
            this._log.error("Error while sending message:", e.message);
            this._closeSocket();
            return false;
        }
        return true;
    };
    /**
     * Update the preferred URI to connect to. Useful for Call signaling
     * reconnection, which requires connecting on the same edge. If `null` is
     * passed, the preferred URI is unset and the original `uris` array and
     * `uriIndex` is used to determine the signaling URI to connect to.
     * @param uri
     */ WSTransport.prototype.updatePreferredURI = function(uri) {
        this._preferredUri = uri;
    };
    /**
     * Update acceptable URIs to reconnect to. Resets the URI index to 0.
     */ WSTransport.prototype.updateURIs = function(uris) {
        if (typeof uris === "string") uris = [
            uris
        ];
        this._uris = uris;
        this._uriIndex = 0;
    };
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ WSTransport.prototype._close = function() {
        this._setState($2bba9ec2604db348$var$WSTransportState.Closed);
        this._closeSocket();
    };
    /**
     * Close the WebSocket and remove all event listeners.
     */ WSTransport.prototype._closeSocket = function() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._heartbeatTimeout);
        this._log.info("Closing and cleaning up WebSocket...");
        if (!this._socket) {
            this._log.info("No WebSocket to clean up.");
            return;
        }
        this._socket.removeEventListener("close", this._onSocketClose);
        this._socket.removeEventListener("error", this._onSocketError);
        this._socket.removeEventListener("message", this._onSocketMessage);
        this._socket.removeEventListener("open", this._onSocketOpen);
        if (this._socket.readyState === $2bba9ec2604db348$var$WebSocket.CONNECTING || this._socket.readyState === $2bba9ec2604db348$var$WebSocket.OPEN) this._socket.close();
        // Reset backoff counter if connection was open for long enough to be considered successful
        if (this._timeOpened && Date.now() - this._timeOpened > $2bba9ec2604db348$var$CONNECT_SUCCESS_TIMEOUT) this._resetBackoffs();
        if (this.state !== $2bba9ec2604db348$var$WSTransportState.Closed) this._performBackoff();
        delete this._socket;
        this.emit("close");
    };
    /**
     * Attempt to connect to the endpoint via WebSocket.
     * @param [uri] - URI string to connect to.
     * @param [retryCount] - Retry number, if this is a retry. Undefined if
     *   first attempt, 1+ if a retry.
     */ WSTransport.prototype._connect = function(uri, retryCount) {
        var _this = this;
        this._log.info(typeof retryCount === "number" ? "Attempting to reconnect (retry #" + retryCount + ")..." : "Attempting to connect...");
        this._closeSocket();
        this._setState($2bba9ec2604db348$var$WSTransportState.Connecting);
        this._connectedUri = uri;
        try {
            this._socket = new this._options.WebSocket(this._connectedUri);
        } catch (e) {
            this._log.error("Could not connect to endpoint:", e.message);
            this._close();
            this.emit("error", {
                code: 31000,
                message: e.message || "Could not connect to " + this._connectedUri,
                twilioError: new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionDisconnected()
            });
            return;
        }
        this._socket.addEventListener("close", this._onSocketClose);
        this._socket.addEventListener("error", this._onSocketError);
        this._socket.addEventListener("message", this._onSocketMessage);
        this._socket.addEventListener("open", this._onSocketOpen);
        delete this._timeOpened;
        this._connectTimeout = setTimeout(function() {
            _this._log.info("WebSocket connection attempt timed out.");
            _this._moveUriIndex();
            _this._closeSocket();
        }, this._options.connectTimeoutMs);
    };
    /**
     * Perform a backoff. If a preferred URI is set (not null), then backoff
     * using the preferred mechanism. Otherwise, use the primary mechanism.
     */ WSTransport.prototype._performBackoff = function() {
        if (this._preferredUri) {
            this._log.info("Preferred URI set; backing off.");
            this._backoff.preferred.backoff();
        } else {
            this._log.info("Preferred URI not set; backing off.");
            this._backoff.primary.backoff();
        }
    };
    /**
     * Reset both primary and preferred backoff mechanisms.
     */ WSTransport.prototype._resetBackoffs = function() {
        this._backoff.preferred.reset();
        this._backoff.primary.reset();
        this._backoffStartTime.preferred = null;
        this._backoffStartTime.primary = null;
    };
    /**
     * Set a timeout to reconnect after HEARTBEAT_TIMEOUT milliseconds
     *   have passed without receiving a message over the WebSocket.
     */ WSTransport.prototype._setHeartbeatTimeout = function() {
        var _this = this;
        clearTimeout(this._heartbeatTimeout);
        this._heartbeatTimeout = setTimeout(function() {
            _this._log.info("No messages received in " + $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT / 1000 + " seconds. Reconnecting...");
            _this._shouldFallback = true;
            _this._closeSocket();
        }, $2bba9ec2604db348$var$HEARTBEAT_TIMEOUT);
    };
    /**
     * Set the current and previous state
     */ WSTransport.prototype._setState = function(state) {
        this._previousState = this.state;
        this.state = state;
    };
    /**
     * Set up the primary and preferred backoff mechanisms.
     */ WSTransport.prototype._setupBackoffs = function() {
        var _this = this;
        var preferredBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPreferredDelayMs,
            min: 100
        };
        this._log.info("Initializing preferred transport backoff using config: ", preferredBackoffConfig);
        var preferredBackoff = new $33fb184fd4e2bd63$exports.default(preferredBackoffConfig);
        preferredBackoff.on("backoff", function(attempt, delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Preferred backoff initiated but transport state is closed; not attempting a connection.");
                return;
            }
            _this._log.info("Will attempt to reconnect Websocket to preferred URI in " + delay + "ms");
            if (attempt === 0) {
                _this._backoffStartTime.preferred = Date.now();
                _this._log.info("Preferred backoff start; " + _this._backoffStartTime.preferred);
            }
        });
        preferredBackoff.on("ready", function(attempt, _delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Preferred backoff ready but transport state is closed; not attempting a connection.");
                return;
            }
            if (_this._backoffStartTime.preferred === null) {
                _this._log.info("Preferred backoff start time invalid; not attempting a connection.");
                return;
            }
            if (Date.now() - _this._backoffStartTime.preferred > _this._options.maxPreferredDurationMs) {
                _this._log.info("Max preferred backoff attempt time exceeded; falling back to primary backoff.");
                _this._preferredUri = null;
                _this._backoff.primary.backoff();
                return;
            }
            if (typeof _this._preferredUri !== "string") {
                _this._log.info("Preferred URI cleared; falling back to primary backoff.");
                _this._preferredUri = null;
                _this._backoff.primary.backoff();
                return;
            }
            _this._connect(_this._preferredUri, attempt + 1);
        });
        var primaryBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPrimaryDelayMs,
            // We only want a random initial delay if there are any fallback edges
            // Initial delay between 1s and 5s both inclusive
            min: this._uris && this._uris.length > 1 ? Math.floor(Math.random() * 4001) + 1000 : 100
        };
        this._log.info("Initializing primary transport backoff using config: ", primaryBackoffConfig);
        var primaryBackoff = new $33fb184fd4e2bd63$exports.default(primaryBackoffConfig);
        primaryBackoff.on("backoff", function(attempt, delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Primary backoff initiated but transport state is closed; not attempting a connection.");
                return;
            }
            _this._log.info("Will attempt to reconnect WebSocket in " + delay + "ms");
            if (attempt === 0) {
                _this._backoffStartTime.primary = Date.now();
                _this._log.info("Primary backoff start; " + _this._backoffStartTime.primary);
            }
        });
        primaryBackoff.on("ready", function(attempt, _delay) {
            if (_this.state === $2bba9ec2604db348$var$WSTransportState.Closed) {
                _this._log.info("Primary backoff ready but transport state is closed; not attempting a connection.");
                return;
            }
            if (_this._backoffStartTime.primary === null) {
                _this._log.info("Primary backoff start time invalid; not attempting a connection.");
                return;
            }
            if (Date.now() - _this._backoffStartTime.primary > _this._options.maxPrimaryDurationMs) {
                _this._log.info("Max primary backoff attempt time exceeded; not attempting a connection.");
                return;
            }
            _this._connect(_this._uris[_this._uriIndex], attempt + 1);
        });
        return {
            preferred: preferredBackoff,
            primary: primaryBackoff
        };
    };
    Object.defineProperty(WSTransport.prototype, "uri", {
        /**
         * The uri the transport is currently connected to
         */ get: function() {
            return this._connectedUri;
        },
        enumerable: false,
        configurable: true
    });
    WSTransport.defaultConstructorOptions = {
        WebSocket: $2bba9ec2604db348$var$WebSocket,
        connectTimeoutMs: $2bba9ec2604db348$var$CONNECT_TIMEOUT,
        maxPreferredDelayMs: $2bba9ec2604db348$var$MAX_PREFERRED_DELAY,
        maxPreferredDurationMs: $2bba9ec2604db348$var$MAX_PREFERRED_DURATION,
        maxPrimaryDelayMs: $2bba9ec2604db348$var$MAX_PRIMARY_DELAY,
        maxPrimaryDurationMs: $2bba9ec2604db348$var$MAX_PRIMARY_DURATION
    };
    return WSTransport;
}($0bfd6a77e39eae31$exports.EventEmitter);
$2bba9ec2604db348$exports.default = $2bba9ec2604db348$var$WSTransport;


var $2b1007c1151c9a8f$var$PSTREAM_VERSION = "1.6";
// In seconds
var $2b1007c1151c9a8f$var$MAX_RECONNECT_TIMEOUT_ALLOWED = 30;
/**
 * Constructor for PStream objects.
 *
 * @exports PStream as Twilio.PStream
 * @memberOf Twilio
 * @borrows EventEmitter#addListener as #addListener
 * @borrows EventEmitter#removeListener as #removeListener
 * @borrows EventEmitter#emit as #emit
 * @borrows EventEmitter#hasListener as #hasListener
 * @constructor
 * @param {string} token The Twilio capabilities JWT
 * @param {string[]} uris An array of PStream endpoint URIs
 * @param {object} [options]
 * @config {boolean} [options.backoffMaxMs=20000] Enable debugging
 */ var $2b1007c1151c9a8f$var$PStream = /** @class */ function(_super) {
    $2b1007c1151c9a8f$var$__extends(PStream, _super);
    function PStream(token, uris, options) {
        var _this = _super.call(this) || this;
        if (!(_this instanceof PStream)) return new PStream(token, uris, options);
        var defaults = {
            TransportFactory: $2bba9ec2604db348$exports.default
        };
        options = options || {};
        for(var prop in defaults){
            if (prop in options) continue;
            options[prop] = defaults[prop];
        }
        _this.options = options;
        _this.token = token || "";
        _this.status = "disconnected";
        _this.gateway = null;
        _this.region = null;
        _this._messageQueue = [];
        _this._preferredUri = null;
        _this._uris = uris;
        _this._handleTransportClose = _this._handleTransportClose.bind(_this);
        _this._handleTransportError = _this._handleTransportError.bind(_this);
        _this._handleTransportMessage = _this._handleTransportMessage.bind(_this);
        _this._handleTransportOpen = _this._handleTransportOpen.bind(_this);
        _this._log = new $674d4885484aa9f2$exports.default("PStream");
        // NOTE(mroberts): EventEmitter requires that we catch all errors.
        _this.on("error", function() {
            _this._log.warn("Unexpected error handled in pstream");
        });
        /*
         *events used by device
         *'invite',
         *'ready',
         *'error',
         *'offline',
         *
         *'cancel',
         *'presence',
         *'roster',
         *'answer',
         *'candidate',
         *'hangup'
         */ var self = _this;
        _this.addListener("ready", function() {
            self.status = "ready";
        });
        _this.addListener("offline", function() {
            self.status = "offline";
        });
        _this.addListener("close", function() {
            self._log.info('Received "close" from server. Destroying PStream...');
            self._destroy();
        });
        _this.transport = new _this.options.TransportFactory(_this._uris, {
            backoffMaxMs: _this.options.backoffMaxMs,
            maxPreferredDurationMs: _this.options.maxPreferredDurationMs
        });
        Object.defineProperties(_this, {
            uri: {
                enumerable: true,
                get: function() {
                    return this.transport.uri;
                }
            }
        });
        _this.transport.on("close", _this._handleTransportClose);
        _this.transport.on("error", _this._handleTransportError);
        _this.transport.on("message", _this._handleTransportMessage);
        _this.transport.on("open", _this._handleTransportOpen);
        _this.transport.open();
        return _this;
    }
    return PStream;
}($0bfd6a77e39eae31$exports.EventEmitter);
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportClose = function() {
    this.emit("transportClose");
    if (this.status !== "disconnected") {
        if (this.status !== "offline") this.emit("offline", this);
        this.status = "disconnected";
    }
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportError = function(error) {
    if (!error) {
        this.emit("error", {
            error: {
                code: 31000,
                message: "Websocket closed without a provided reason",
                twilioError: new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionDisconnected()
            }
        });
        return;
    }
    // We receive some errors without call metadata (just the error). We need to convert these
    // to be contained within the 'error' field so that these errors match the expected format.
    this.emit("error", typeof error.code !== "undefined" ? {
        error: error
    } : error);
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportMessage = function(msg) {
    if (!msg || !msg.data || typeof msg.data !== "string") return;
    var _a = JSON.parse(msg.data), type = _a.type, _b = _a.payload, payload = _b === void 0 ? {} : _b;
    this.gateway = payload.gateway || this.gateway;
    this.region = payload.region || this.region;
    if (type === "error" && payload.error) payload.error.twilioError = new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionError();
    this.emit(type, payload);
};
$2b1007c1151c9a8f$var$PStream.prototype._handleTransportOpen = function() {
    var _this = this;
    this.status = "connected";
    this.setToken(this.token);
    this.emit("transportOpen");
    var messages = this._messageQueue.splice(0, this._messageQueue.length);
    messages.forEach(function(message) {
        return _this._publish.apply(_this, message);
    });
};
/**
 * @return {string}
 */ $2b1007c1151c9a8f$var$PStream.toString = function() {
    return "[Twilio.PStream class]";
};
$2b1007c1151c9a8f$var$PStream.prototype.toString = function() {
    return "[Twilio.PStream instance]";
};
$2b1007c1151c9a8f$var$PStream.prototype.setToken = function(token) {
    this._log.info("Setting token and publishing listen");
    this.token = token;
    var reconnectTimeout = 0;
    var t = this.options.maxPreferredDurationMs;
    this._log.info("maxPreferredDurationMs:" + t);
    if (typeof t === "number" && t >= 0) reconnectTimeout = Math.min(Math.ceil(t / 1000), $2b1007c1151c9a8f$var$MAX_RECONNECT_TIMEOUT_ALLOWED);
    this._log.info("reconnectTimeout:" + reconnectTimeout);
    var payload = {
        browserinfo: $2b1007c1151c9a8f$var$getBrowserInfo(),
        reconnectTimeout: reconnectTimeout,
        token: token
    };
    this._publish("listen", payload);
};
$2b1007c1151c9a8f$var$PStream.prototype.sendMessage = function(callsid, content, contenttype, messagetype, voiceeventsid) {
    if (contenttype === void 0) contenttype = "application/json";
    var payload = {
        callsid: callsid,
        content: content,
        contenttype: contenttype,
        messagetype: messagetype,
        voiceeventsid: voiceeventsid
    };
    this._publish("message", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.register = function(mediaCapabilities) {
    var regPayload = {
        media: mediaCapabilities
    };
    this._publish("register", regPayload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.invite = function(sdp, callsid, params) {
    var payload = {
        callsid: callsid,
        sdp: sdp,
        twilio: params ? {
            params: params
        } : {}
    };
    this._publish("invite", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reconnect = function(sdp, callsid, reconnect) {
    var payload = {
        callsid: callsid,
        reconnect: reconnect,
        sdp: sdp,
        twilio: {}
    };
    this._publish("invite", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.answer = function(sdp, callsid) {
    this._publish("answer", {
        sdp: sdp,
        callsid: callsid
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.dtmf = function(callsid, digits) {
    this._publish("dtmf", {
        callsid: callsid,
        dtmf: digits
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.hangup = function(callsid, message) {
    var payload = message ? {
        callsid: callsid,
        message: message
    } : {
        callsid: callsid
    };
    this._publish("hangup", payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reject = function(callsid) {
    this._publish("reject", {
        callsid: callsid
    }, true);
};
$2b1007c1151c9a8f$var$PStream.prototype.reinvite = function(sdp, callsid) {
    this._publish("reinvite", {
        sdp: sdp,
        callsid: callsid
    }, false);
};
$2b1007c1151c9a8f$var$PStream.prototype._destroy = function() {
    this.transport.removeListener("close", this._handleTransportClose);
    this.transport.removeListener("error", this._handleTransportError);
    this.transport.removeListener("message", this._handleTransportMessage);
    this.transport.removeListener("open", this._handleTransportOpen);
    this.transport.close();
    this.emit("offline", this);
};
$2b1007c1151c9a8f$var$PStream.prototype.destroy = function() {
    this._log.info("PStream.destroy() called...");
    this._destroy();
    return this;
};
$2b1007c1151c9a8f$var$PStream.prototype.updatePreferredURI = function(uri) {
    this._preferredUri = uri;
    this.transport.updatePreferredURI(uri);
};
$2b1007c1151c9a8f$var$PStream.prototype.updateURIs = function(uris) {
    this._uris = uris;
    this.transport.updateURIs(this._uris);
};
$2b1007c1151c9a8f$var$PStream.prototype.publish = function(type, payload) {
    return this._publish(type, payload, true);
};
$2b1007c1151c9a8f$var$PStream.prototype._publish = function(type, payload, shouldRetry) {
    var msg = JSON.stringify({
        payload: payload,
        type: type,
        version: $2b1007c1151c9a8f$var$PSTREAM_VERSION
    });
    var isSent = !!this.transport.send(msg);
    if (!isSent) {
        this.emit("error", {
            error: {
                code: 31009,
                message: "No transport available to send or receive messages",
                twilioError: new $9b99a7197ac9a7b1$exports.GeneralErrors.TransportError()
            }
        });
        if (shouldRetry) this._messageQueue.push([
            type,
            payload,
            true
        ]);
    }
};
function $2b1007c1151c9a8f$var$getBrowserInfo() {
    var nav = typeof navigator !== "undefined" ? navigator : {};
    var info = {
        browser: {
            platform: nav.platform || "unknown",
            userAgent: nav.userAgent || "unknown"
        },
        p: "browser",
        plugin: "rtc",
        v: $e9da3ede67c59403$exports.RELEASE_VERSION
    };
    return info;
}
$2b1007c1151c9a8f$exports.default = $2b1007c1151c9a8f$var$PStream;


var $916a4edaaacc98cf$exports = {};
"use strict";
var $916a4edaaacc98cf$var$_a;
Object.defineProperty($916a4edaaacc98cf$exports, "__esModule", {
    value: true
});
$916a4edaaacc98cf$exports.getRegionShortcode = $916a4edaaacc98cf$exports.getChunderURIs = $916a4edaaacc98cf$exports.createSignalingEndpointURL = $916a4edaaacc98cf$exports.createEventGatewayURI = $916a4edaaacc98cf$exports.defaultEdge = $916a4edaaacc98cf$exports.regionToEdge = $916a4edaaacc98cf$exports.regionShortcodes = $916a4edaaacc98cf$exports.Region = $916a4edaaacc98cf$exports.Edge = void 0;

/**
 * Valid edges.
 * @private
 */ var $916a4edaaacc98cf$var$Edge;
(function(Edge) {
    /**
     * Public edges
     */ Edge["Sydney"] = "sydney";
    Edge["SaoPaulo"] = "sao-paulo";
    Edge["Dublin"] = "dublin";
    Edge["Frankfurt"] = "frankfurt";
    Edge["Tokyo"] = "tokyo";
    Edge["Singapore"] = "singapore";
    Edge["Ashburn"] = "ashburn";
    Edge["Umatilla"] = "umatilla";
    Edge["Roaming"] = "roaming";
    /**
     * Interconnect edges
     */ Edge["AshburnIx"] = "ashburn-ix";
    Edge["SanJoseIx"] = "san-jose-ix";
    Edge["LondonIx"] = "london-ix";
    Edge["FrankfurtIx"] = "frankfurt-ix";
    Edge["SingaporeIx"] = "singapore-ix";
    Edge["SydneyIx"] = "sydney-ix";
    Edge["TokyoIx"] = "tokyo-ix";
})($916a4edaaacc98cf$var$Edge = $916a4edaaacc98cf$exports.Edge || ($916a4edaaacc98cf$exports.Edge = {}));
/**
 * Valid current regions.
 *
 * @deprecated
 *
 * CLIENT-6831
 * This is no longer used or updated for checking validity of regions in the
 * SDK. We now allow any string to be passed for region. Invalid regions won't
 * be able to connect, and won't throw an exception.
 *
 * CLIENT-7519
 * This is used again to temporarily convert edge values to regions as part of
 * Phase 1 Regional. This is still considered deprecated.
 *
 * @private
 */ var $916a4edaaacc98cf$var$Region;
(function(Region) {
    Region["Au1"] = "au1";
    Region["Au1Ix"] = "au1-ix";
    Region["Br1"] = "br1";
    Region["De1"] = "de1";
    Region["De1Ix"] = "de1-ix";
    Region["Gll"] = "gll";
    Region["Ie1"] = "ie1";
    Region["Ie1Ix"] = "ie1-ix";
    Region["Ie1Tnx"] = "ie1-tnx";
    Region["Jp1"] = "jp1";
    Region["Jp1Ix"] = "jp1-ix";
    Region["Sg1"] = "sg1";
    Region["Sg1Ix"] = "sg1-ix";
    Region["Sg1Tnx"] = "sg1-tnx";
    Region["Us1"] = "us1";
    Region["Us1Ix"] = "us1-ix";
    Region["Us1Tnx"] = "us1-tnx";
    Region["Us2"] = "us2";
    Region["Us2Ix"] = "us2-ix";
    Region["Us2Tnx"] = "us2-tnx";
})($916a4edaaacc98cf$var$Region = $916a4edaaacc98cf$exports.Region || ($916a4edaaacc98cf$exports.Region = {}));
/**
 * Region shortcodes. Maps the full region name from AWS to the Twilio shortcode.
 * @private
 */ $916a4edaaacc98cf$exports.regionShortcodes = {
    ASIAPAC_SINGAPORE: $916a4edaaacc98cf$var$Region.Sg1,
    ASIAPAC_SYDNEY: $916a4edaaacc98cf$var$Region.Au1,
    ASIAPAC_TOKYO: $916a4edaaacc98cf$var$Region.Jp1,
    EU_FRANKFURT: $916a4edaaacc98cf$var$Region.De1,
    EU_IRELAND: $916a4edaaacc98cf$var$Region.Ie1,
    SOUTH_AMERICA_SAO_PAULO: $916a4edaaacc98cf$var$Region.Br1,
    US_EAST_VIRGINIA: $916a4edaaacc98cf$var$Region.Us1,
    US_WEST_OREGON: $916a4edaaacc98cf$var$Region.Us2
};
/**
 * Region to edge mapping, as part of Phase 1 Regional (CLIENT-7519).
 * Temporary.
 * @private
 */ $916a4edaaacc98cf$exports.regionToEdge = ($916a4edaaacc98cf$var$_a = {}, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Au1] = $916a4edaaacc98cf$var$Edge.Sydney, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Br1] = $916a4edaaacc98cf$var$Edge.SaoPaulo, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1] = $916a4edaaacc98cf$var$Edge.Dublin, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.De1] = $916a4edaaacc98cf$var$Edge.Frankfurt, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Jp1] = $916a4edaaacc98cf$var$Edge.Tokyo, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1] = $916a4edaaacc98cf$var$Edge.Singapore, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1] = $916a4edaaacc98cf$var$Edge.Ashburn, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2] = $916a4edaaacc98cf$var$Edge.Umatilla, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Gll] = $916a4edaaacc98cf$var$Edge.Roaming, /**
     * Interconnect edges
     */ $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1Ix] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2Ix] = $916a4edaaacc98cf$var$Edge.SanJoseIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1Ix] = $916a4edaaacc98cf$var$Edge.LondonIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.De1Ix] = $916a4edaaacc98cf$var$Edge.FrankfurtIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1Ix] = $916a4edaaacc98cf$var$Edge.SingaporeIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Au1Ix] = $916a4edaaacc98cf$var$Edge.SydneyIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Jp1Ix] = $916a4edaaacc98cf$var$Edge.TokyoIx, /**
     * Tnx regions
     */ $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us1Tnx] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Us2Tnx] = $916a4edaaacc98cf$var$Edge.AshburnIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Ie1Tnx] = $916a4edaaacc98cf$var$Edge.LondonIx, $916a4edaaacc98cf$var$_a[$916a4edaaacc98cf$var$Region.Sg1Tnx] = $916a4edaaacc98cf$var$Edge.SingaporeIx, $916a4edaaacc98cf$var$_a);
/**
 * The default edge to connect to and create a chunder uri from, if the edge
 * parameter is not specified during setup in `Device`.
 * @constant
 */ $916a4edaaacc98cf$exports.defaultEdge = $916a4edaaacc98cf$var$Edge.Roaming;
/**
 * The default event gateway URI to publish to.
 * @constant
 * @private
 */ var $916a4edaaacc98cf$var$defaultEventGatewayURI = "eventgw.twilio.com";
/**
 * String template for an edge chunder URI
 * @param edge - The edge.
 */ function $916a4edaaacc98cf$var$createChunderEdgeURI(edge) {
    return "voice-js." + edge + ".twilio.com";
}
/**
 * String template for a region insights URI
 * @param region - The region.
 */ function $916a4edaaacc98cf$var$createEventGatewayURI(region) {
    return region ? "eventgw." + region + ".twilio.com" : $916a4edaaacc98cf$var$defaultEventGatewayURI;
}
$916a4edaaacc98cf$exports.createEventGatewayURI = $916a4edaaacc98cf$var$createEventGatewayURI;
/**
 * Create a signaling endpoint URL to connect a websocket to from a chunder URI.
 * @param uri the chunder URI to create a signaling endpoint URL for
 */ function $916a4edaaacc98cf$var$createSignalingEndpointURL(uri) {
    return "wss://" + uri + "/signal";
}
$916a4edaaacc98cf$exports.createSignalingEndpointURL = $916a4edaaacc98cf$var$createSignalingEndpointURL;
/**
 * Get the URI associated with the passed edge.
 * @private
 * @param edge - A string or an array of edge values
 * @returns An array of chunder URIs
 */ function $916a4edaaacc98cf$var$getChunderURIs(edge) {
    if (!!edge && typeof edge !== "string" && !Array.isArray(edge)) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("If `edge` is provided, it must be of type `string` or an array of strings.");
    var uris;
    if (edge) {
        var edgeParams = Array.isArray(edge) ? edge : [
            edge
        ];
        uris = edgeParams.map(function(param) {
            return $916a4edaaacc98cf$var$createChunderEdgeURI(param);
        });
    } else uris = [
        $916a4edaaacc98cf$var$createChunderEdgeURI($916a4edaaacc98cf$exports.defaultEdge)
    ];
    return uris;
}
$916a4edaaacc98cf$exports.getChunderURIs = $916a4edaaacc98cf$var$getChunderURIs;
/**
 * Get the region shortcode by its full AWS region string.
 *
 * @private
 * @param region - The region's full AWS string.
 */ function $916a4edaaacc98cf$var$getRegionShortcode(region) {
    return $916a4edaaacc98cf$exports.regionShortcodes[region] || null;
}
$916a4edaaacc98cf$exports.getRegionShortcode = $916a4edaaacc98cf$var$getRegionShortcode;


var $44123d2d42b91b4b$exports = {};
"use strict";
Object.defineProperty($44123d2d42b91b4b$exports, "__esModule", {
    value: true
});
$44123d2d42b91b4b$exports.PeerConnection = $44123d2d42b91b4b$exports.getMediaEngine = $44123d2d42b91b4b$exports.enabled = void 0;
var $eebba6bea300b063$exports = {};
"use strict";
Object.defineProperty($eebba6bea300b063$exports, "__esModule", {
    value: true
});



var $c1a056b32fadc499$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
// tslint:disable only-arrow-functions
/* global webkitRTCPeerConnection, mozRTCPeerConnection, mozRTCSessionDescription, mozRTCIceCandidate */ Object.defineProperty($c1a056b32fadc499$exports, "__esModule", {
    value: true
});


var $5daed6d4af7231db$exports = {};
"use strict";
Object.defineProperty($5daed6d4af7231db$exports, "__esModule", {
    value: true
});
$5daed6d4af7231db$exports.setMaxAverageBitrate = $5daed6d4af7231db$exports.setIceAggressiveNomination = $5daed6d4af7231db$exports.setCodecPreferences = $5daed6d4af7231db$exports.getPreferredCodecInfo = void 0;

var $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName = {
    0: "PCMU",
    8: "PCMA"
};
var $5daed6d4af7231db$var$defaultOpusId = 111;
var $5daed6d4af7231db$var$BITRATE_MAX = 510000;
var $5daed6d4af7231db$var$BITRATE_MIN = 6000;
function $5daed6d4af7231db$var$getPreferredCodecInfo(sdp) {
    var _a = /a=rtpmap:(\d+) (\S+)/m.exec(sdp) || [
        null,
        "",
        ""
    ], codecId = _a[1], codecName = _a[2];
    var regex = new RegExp("a=fmtp:" + codecId + " (\\S+)", "m");
    var _b = regex.exec(sdp) || [
        null,
        ""
    ], codecParams = _b[1];
    return {
        codecName: codecName,
        codecParams: codecParams
    };
}
$5daed6d4af7231db$exports.getPreferredCodecInfo = $5daed6d4af7231db$var$getPreferredCodecInfo;
function $5daed6d4af7231db$var$setIceAggressiveNomination(sdp) {
    // This only works on Chrome. We don't want any side effects on other browsers
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1024096
    // https://issues.corp.twilio.com/browse/CLIENT-6911
    if (!$b060d15305f18a68$exports.isChrome(window, window.navigator)) return sdp;
    return sdp.split("\n").filter(function(line) {
        return line.indexOf("a=ice-lite") === -1;
    }).join("\n");
}
$5daed6d4af7231db$exports.setIceAggressiveNomination = $5daed6d4af7231db$var$setIceAggressiveNomination;
function $5daed6d4af7231db$var$setMaxAverageBitrate(sdp, maxAverageBitrate) {
    if (typeof maxAverageBitrate !== "number" || maxAverageBitrate < $5daed6d4af7231db$var$BITRATE_MIN || maxAverageBitrate > $5daed6d4af7231db$var$BITRATE_MAX) return sdp;
    var matches = /a=rtpmap:(\d+) opus/m.exec(sdp);
    var opusId = matches && matches.length ? matches[1] : $5daed6d4af7231db$var$defaultOpusId;
    var regex = new RegExp("a=fmtp:" + opusId);
    var lines = sdp.split("\n").map(function(line) {
        return regex.test(line) ? line + (";maxaveragebitrate=" + maxAverageBitrate) : line;
    });
    return lines.join("\n");
}
$5daed6d4af7231db$exports.setMaxAverageBitrate = $5daed6d4af7231db$var$setMaxAverageBitrate;
/**
 * Return a new SDP string with the re-ordered codec preferences.
 * @param {string} sdp
 * @param {Array<AudioCodec>} preferredCodecs - If empty, the existing order
 *   of audio codecs is preserved
 * @returns {string} Updated SDP string
 */ function $5daed6d4af7231db$var$setCodecPreferences(sdp, preferredCodecs) {
    var mediaSections = $5daed6d4af7231db$var$getMediaSections(sdp);
    var session = sdp.split("\r\nm=")[0];
    return [
        session
    ].concat(mediaSections.map(function(section) {
        // Codec preferences should not be applied to m=application sections.
        if (!/^m=(audio|video)/.test(section)) return section;
        var kind = section.match(/^m=(audio|video)/)[1];
        var codecMap = $5daed6d4af7231db$var$createCodecMapForMediaSection(section);
        var payloadTypes = $5daed6d4af7231db$var$getReorderedPayloadTypes(codecMap, preferredCodecs);
        var newSection = $5daed6d4af7231db$var$setPayloadTypesInMediaSection(payloadTypes, section);
        var pcmaPayloadTypes = codecMap.get("pcma") || [];
        var pcmuPayloadTypes = codecMap.get("pcmu") || [];
        var fixedBitratePayloadTypes = kind === "audio" ? new Set(pcmaPayloadTypes.concat(pcmuPayloadTypes)) : new Set();
        return fixedBitratePayloadTypes.has(payloadTypes[0]) ? newSection.replace(/\r\nb=(AS|TIAS):([0-9]+)/g, "") : newSection;
    })).join("\r\n");
}
$5daed6d4af7231db$exports.setCodecPreferences = $5daed6d4af7231db$var$setCodecPreferences;
/**
 * Get the m= sections of a particular kind and direction from an sdp.
 * @param {string} sdp - SDP string
 * @param {string} [kind] - Pattern for matching kind
 * @param {string} [direction] - Pattern for matching direction
 * @returns {Array<string>} mediaSections
 */ function $5daed6d4af7231db$var$getMediaSections(sdp, kind, direction) {
    return sdp.replace(/\r\n\r\n$/, "\r\n").split("\r\nm=").slice(1).map(function(mediaSection) {
        return "m=" + mediaSection;
    }).filter(function(mediaSection) {
        var kindPattern = new RegExp("m=" + (kind || ".*"), "gm");
        var directionPattern = new RegExp("a=" + (direction || ".*"), "gm");
        return kindPattern.test(mediaSection) && directionPattern.test(mediaSection);
    });
}
/**
 * Create a Codec Map for the given m= section.
 * @param {string} section - The given m= section
 * @returns {Map<Codec, Array<PT>>}
 */ function $5daed6d4af7231db$var$createCodecMapForMediaSection(section) {
    return Array.from($5daed6d4af7231db$var$createPtToCodecName(section)).reduce(function(codecMap, pair) {
        var pt = pair[0];
        var codecName = pair[1];
        var pts = codecMap.get(codecName) || [];
        return codecMap.set(codecName, pts.concat(pt));
    }, new Map());
}
/**
 * Create the reordered Codec Payload Types based on the preferred Codec Names.
 * @param {Map<Codec, Array<PT>>} codecMap - Codec Map
 * @param {Array<Codec>} preferredCodecs - Preferred Codec Names
 * @returns {Array<PT>} Reordered Payload Types
 */ function $5daed6d4af7231db$var$getReorderedPayloadTypes(codecMap, preferredCodecs) {
    preferredCodecs = preferredCodecs.map(function(codecName) {
        return codecName.toLowerCase();
    });
    var preferredPayloadTypes = $b060d15305f18a68$exports.flatMap(preferredCodecs, function(codecName) {
        return codecMap.get(codecName) || [];
    });
    var remainingCodecs = $b060d15305f18a68$exports.difference(Array.from(codecMap.keys()), preferredCodecs);
    var remainingPayloadTypes = $b060d15305f18a68$exports.flatMap(remainingCodecs, function(codecName) {
        return codecMap.get(codecName);
    });
    return preferredPayloadTypes.concat(remainingPayloadTypes);
}
/**
 * Set the given Codec Payload Types in the first line of the given m= section.
 * @param {Array<PT>} payloadTypes - Payload Types
 * @param {string} section - Given m= section
 * @returns {string} - Updated m= section
 */ function $5daed6d4af7231db$var$setPayloadTypesInMediaSection(payloadTypes, section) {
    var lines = section.split("\r\n");
    var mLine = lines[0];
    var otherLines = lines.slice(1);
    mLine = mLine.replace(/([0-9]+\s?)+$/, payloadTypes.join(" "));
    return [
        mLine
    ].concat(otherLines).join("\r\n");
}
/**
 * Create a Map from PTs to codec names for the given m= section.
 * @param {string} mediaSection - The given m= section.
 * @returns {Map<PT, Codec>} ptToCodecName
 */ function $5daed6d4af7231db$var$createPtToCodecName(mediaSection) {
    return $5daed6d4af7231db$var$getPayloadTypesInMediaSection(mediaSection).reduce(function(ptToCodecName, pt) {
        var rtpmapPattern = new RegExp("a=rtpmap:" + pt + " ([^/]+)");
        var matches = mediaSection.match(rtpmapPattern);
        var codecName = matches ? matches[1].toLowerCase() : $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName[pt] ? $5daed6d4af7231db$var$ptToFixedBitrateAudioCodecName[pt].toLowerCase() : "";
        return ptToCodecName.set(pt, codecName);
    }, new Map());
}
/**
 * Get the Codec Payload Types present in the first line of the given m= section
 * @param {string} section - The m= section
 * @returns {Array<PT>} Payload Types
 */ function $5daed6d4af7231db$var$getPayloadTypesInMediaSection(section) {
    var mLine = section.split("\r\n")[0];
    // In "m=<kind> <port> <proto> <payload_type_1> <payload_type_2> ... <payload_type_n>",
    // the regex matches <port> and the PayloadTypes.
    var matches = mLine.match(/([0-9]+)/g);
    // This should not happen, but in case there are no PayloadTypes in
    // the m= line, return an empty array.
    if (!matches) return [];
    // Since only the PayloadTypes are needed, we discard the <port>.
    return matches.slice(1).map(function(match) {
        return parseInt(match, 10);
    });
}


var $4d0d30e95648dedb$exports = {};
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
var $f54c1386e6532a91$exports = {};
/* eslint-env node */ "use strict";
// SDP helpers.
var $f54c1386e6532a91$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$f54c1386e6532a91$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substr(2, 10);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$f54c1386e6532a91$var$SDPUtils.localCName = $f54c1386e6532a91$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$f54c1386e6532a91$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map(function(line) {
        return line.trim();
    });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$f54c1386e6532a91$var$SDPUtils.splitSections = function(blob) {
    var parts = blob.split("\nm=");
    return parts.map(function(part, index) {
        return (index > 0 ? "m=" + part : part).trim() + "\r\n";
    });
};
// returns the session description.
$f54c1386e6532a91$var$SDPUtils.getDescription = function(blob) {
    var sections = $f54c1386e6532a91$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// returns the individual media sections.
$f54c1386e6532a91$var$SDPUtils.getMediaSections = function(blob) {
    var sections = $f54c1386e6532a91$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$f54c1386e6532a91$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $f54c1386e6532a91$var$SDPUtils.splitLines(blob).filter(function(line) {
        return line.indexOf(prefix) === 0;
    });
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
$f54c1386e6532a91$var$SDPUtils.parseCandidate = function(line) {
    var parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    var candidate = {
        foundation: parts[0],
        component: parseInt(parts[1], 10),
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(var i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compability.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
$f54c1386e6532a91$var$SDPUtils.writeCandidate = function(candidate) {
    var sdp = [];
    sdp.push(candidate.foundation);
    sdp.push(candidate.component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    var type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
$f54c1386e6532a91$var$SDPUtils.parseIceOptions = function(line) {
    return line.substr(14).split(" ");
};
// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$f54c1386e6532a91$var$SDPUtils.parseRtpMap = function(line) {
    var parts = line.substr(9).split(" ");
    var parsed = {
        payloadType: parseInt(parts.shift(), 10) // was: id
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeRtpMap = function(codec) {
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    var channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$f54c1386e6532a91$var$SDPUtils.parseExtmap = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1]
    };
};
// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$f54c1386e6532a91$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + "\r\n";
};
// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$f54c1386e6532a91$var$SDPUtils.parseFmtp = function(line) {
    var parsed = {};
    var kv;
    var parts = line.substr(line.indexOf(" ") + 1).split(";");
    for(var j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeFmtp = function(codec) {
    var line = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        var params = [];
        Object.keys(codec.parameters).forEach(function(param) {
            if (codec.parameters[param]) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$f54c1386e6532a91$var$SDPUtils.parseRtcpFb = function(line) {
    var parts = line.substr(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$f54c1386e6532a91$var$SDPUtils.writeRtcpFb = function(codec) {
    var lines = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$f54c1386e6532a91$var$SDPUtils.parseSsrcMedia = function(line) {
    var sp = line.indexOf(" ");
    var parts = {
        ssrc: parseInt(line.substr(7, sp - 7), 10)
    };
    var colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substr(sp + 1, colon - sp - 1);
        parts.value = line.substr(colon + 1);
    } else parts.attribute = line.substr(sp + 1);
    return parts;
};
$f54c1386e6532a91$var$SDPUtils.parseSsrcGroup = function(line) {
    var parts = line.substr(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map(function(ssrc) {
            return parseInt(ssrc, 10);
        })
    };
};
// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
$f54c1386e6532a91$var$SDPUtils.getMid = function(mediaSection) {
    var mid = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substr(6);
};
$f54c1386e6532a91$var$SDPUtils.parseFingerprint = function(line) {
    var parts = line.substr(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1]
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$f54c1386e6532a91$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    var lines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role.
    // Note2: 'algorithm' is not case sensitive except in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($f54c1386e6532a91$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$f54c1386e6532a91$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    var sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach(function(fp) {
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$f54c1386e6532a91$var$SDPUtils.parseCryptoLine = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$f54c1386e6532a91$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $f54c1386e6532a91$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$f54c1386e6532a91$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    var parts = keyParams.substr(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$f54c1386e6532a91$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES paramters.
$f54c1386e6532a91$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    var lines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($f54c1386e6532a91$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$f54c1386e6532a91$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    var ufrag = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    var pwd = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substr(12),
        password: pwd.substr(10)
    };
};
// Serializes ICE parameters to SDP.
$f54c1386e6532a91$var$SDPUtils.writeIceParameters = function(params) {
    return "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
};
// Parses the SDP media section and returns RTCRtpParameters.
$f54c1386e6532a91$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    var description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    for(var i = 3; i < mline.length; i++){
        var pt = mline[i];
        var rtpmapline = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            var codec = $f54c1386e6532a91$var$SDPUtils.parseRtpMap(rtpmapline);
            var fmtps = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $f54c1386e6532a91$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($f54c1386e6532a91$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach(function(line) {
        description.headerExtensions.push($f54c1386e6532a91$var$SDPUtils.parseExtmap(line));
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$f54c1386e6532a91$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    var sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " UDP/TLS/RTP/SAVPF ";
    sdp += caps.codecs.map(function(codec) {
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach(function(codec) {
        sdp += $f54c1386e6532a91$var$SDPUtils.writeRtpMap(codec);
        sdp += $f54c1386e6532a91$var$SDPUtils.writeFmtp(codec);
        sdp += $f54c1386e6532a91$var$SDPUtils.writeRtcpFb(codec);
    });
    var maxptime = 0;
    caps.codecs.forEach(function(codec) {
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    sdp += "a=rtcp-mux\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach(function(extension) {
        sdp += $f54c1386e6532a91$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$f54c1386e6532a91$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    var encodingParameters = [];
    var description = $f54c1386e6532a91$var$SDPUtils.parseRtpParameters(mediaSection);
    var hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    var hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    var ssrcs = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(parts) {
        return parts.attribute === "cname";
    });
    var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    var secondarySsrc;
    var flows = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map(function(line) {
        var parts = line.substr(17).split(" ");
        return parts.map(function(part) {
            return parseInt(part, 10);
        });
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach(function(codec) {
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            var encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    var bandwidth = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substr(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substr(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach(function(params) {
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$f54c1386e6532a91$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    var rtcpParameters = {};
    // Gets the first SSRC. Note tha with RTX there might be multiple
    // SSRCs.
    var remoteSsrc = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(obj) {
        return obj.attribute === "cname";
    })[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    var rsize = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    var mux = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$f54c1386e6532a91$var$SDPUtils.parseMsid = function(mediaSection) {
    var parts;
    var spec = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substr(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    var planB = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $f54c1386e6532a91$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(msidParts) {
        return msidParts.attribute === "msid";
    });
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$f54c1386e6532a91$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    var mline = $f54c1386e6532a91$var$SDPUtils.parseMLine(mediaSection);
    var maxSizeLine = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    var maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    var sctpPort = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substr(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    var sctpMapLines = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        var parts = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:")[0].substr(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$f54c1386e6532a91$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    var output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$f54c1386e6532a91$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 21);
};
// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$f54c1386e6532a91$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    var sessionId;
    var version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $f54c1386e6532a91$var$SDPUtils.generateSessionId();
    var user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
$f54c1386e6532a91$var$SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
    var sdp = $f54c1386e6532a91$var$SDPUtils.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $f54c1386e6532a91$var$SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $f54c1386e6532a91$var$SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.direction) sdp += "a=" + transceiver.direction + "\r\n";
    else if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        // spec.
        var msid = "msid:" + stream.id + " " + transceiver.rtpSender.track.id + "\r\n";
        sdp += "a=" + msid;
        // for Chrome.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $f54c1386e6532a91$var$SDPUtils.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $f54c1386e6532a91$var$SDPUtils.localCName + "\r\n";
    return sdp;
};
// Gets the direction from the mediaSection or the sessionpart.
$f54c1386e6532a91$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    for(var i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substr(2);
        default:
    }
    if (sessionpart) return $f54c1386e6532a91$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$f54c1386e6532a91$var$SDPUtils.getKind = function(mediaSection) {
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    return mline[0].substr(2);
};
$f54c1386e6532a91$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$f54c1386e6532a91$var$SDPUtils.parseMLine = function(mediaSection) {
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(mediaSection);
    var parts = lines[0].substr(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$f54c1386e6532a91$var$SDPUtils.parseOLine = function(mediaSection) {
    var line = $f54c1386e6532a91$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    var parts = line.substr(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$f54c1386e6532a91$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    var lines = $f54c1386e6532a91$var$SDPUtils.splitLines(blob);
    for(var i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$f54c1386e6532a91$exports = $f54c1386e6532a91$var$SDPUtils;


function $4d0d30e95648dedb$var$writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
    var sdp = $f54c1386e6532a91$exports.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $f54c1386e6532a91$exports.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $f54c1386e6532a91$exports.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : dtlsRole || "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
        transceiver.rtpSender._initialTrackId = trackId;
        // spec.
        var msid = "msid:" + (stream ? stream.id : "-") + " " + trackId + "\r\n";
        sdp += "a=" + msid;
        // for Chrome. Legacy should no longer be required.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        // RTX
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $f54c1386e6532a91$exports.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $f54c1386e6532a91$exports.localCName + "\r\n";
    return sdp;
}
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function $4d0d30e95648dedb$var$filterIceServers(iceServers, edgeVersion) {
    var hasTurn = false;
    iceServers = JSON.parse(JSON.stringify(iceServers));
    return iceServers.filter(function(server) {
        if (server && (server.urls || server.url)) {
            var urls = server.urls || server.url;
            if (server.url && !server.urls) console.warn("RTCIceServer.url is deprecated! Use urls instead.");
            var isString = typeof urls === "string";
            if (isString) urls = [
                urls
            ];
            urls = urls.filter(function(url) {
                var validTurn = url.indexOf("turn:") === 0 && url.indexOf("transport=udp") !== -1 && url.indexOf("turn:[") === -1 && !hasTurn;
                if (validTurn) {
                    hasTurn = true;
                    return true;
                }
                return url.indexOf("stun:") === 0 && edgeVersion >= 14393 && url.indexOf("?transport=udp") === -1;
            });
            delete server.url;
            server.urls = isString ? urls[0] : urls;
            return !!urls.length;
        }
    });
}
// Determines the intersection of local and remote capabilities.
function $4d0d30e95648dedb$var$getCommonCapabilities(localCapabilities, remoteCapabilities) {
    var commonCapabilities = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: []
    };
    var findCodecByPayloadType = function(pt, codecs) {
        pt = parseInt(pt, 10);
        for(var i = 0; i < codecs.length; i++){
            if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) return codecs[i];
        }
    };
    var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
        var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
        var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
        return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
    };
    localCapabilities.codecs.forEach(function(lCodec) {
        for(var i = 0; i < remoteCapabilities.codecs.length; i++){
            var rCodec = remoteCapabilities.codecs[i];
            if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
                if (lCodec.name.toLowerCase() === "rtx" && lCodec.parameters && rCodec.parameters.apt) {
                    // for RTX we need to find the local rtx that has a apt
                    // which points to the same local codec as the remote one.
                    if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) continue;
                }
                rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
                // number of channels is the highest common number of channels
                rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels);
                // push rCodec so we reply with offerer payload type
                commonCapabilities.codecs.push(rCodec);
                // determine common feedback mechanisms
                rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
                    for(var j = 0; j < lCodec.rtcpFeedback.length; j++){
                        if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) return true;
                    }
                    return false;
                });
                break;
            }
        }
    });
    localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
        for(var i = 0; i < remoteCapabilities.headerExtensions.length; i++){
            var rHeaderExtension = remoteCapabilities.headerExtensions[i];
            if (lHeaderExtension.uri === rHeaderExtension.uri) {
                commonCapabilities.headerExtensions.push(rHeaderExtension);
                break;
            }
        }
    });
    // FIXME: fecMechanisms
    return commonCapabilities;
}
// is action=setLocalDescription with type allowed in signalingState
function $4d0d30e95648dedb$var$isActionAllowedInSignalingState(action, type, signalingState) {
    return ({
        offer: {
            setLocalDescription: [
                "stable",
                "have-local-offer"
            ],
            setRemoteDescription: [
                "stable",
                "have-remote-offer"
            ]
        },
        answer: {
            setLocalDescription: [
                "have-remote-offer",
                "have-local-pranswer"
            ],
            setRemoteDescription: [
                "have-local-offer",
                "have-remote-pranswer"
            ]
        }
    })[type][action].indexOf(signalingState) !== -1;
}
function $4d0d30e95648dedb$var$maybeAddCandidate(iceTransport, candidate) {
    // Edge's internal representation adds some fields therefore
    // not all fieldѕ are taken into account.
    var alreadyAdded = iceTransport.getRemoteCandidates().find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
    });
    if (!alreadyAdded) iceTransport.addRemoteCandidate(candidate);
    return !alreadyAdded;
}
function $4d0d30e95648dedb$var$makeError(name, description) {
    var e = new Error(description);
    e.name = name;
    return e;
}
$4d0d30e95648dedb$exports = function(window, edgeVersion) {
    // https://w3c.github.io/mediacapture-main/#mediastream
    // Helper function to add the track to the stream and
    // dispatch the event ourselves.
    function addTrackToStreamAndFireEvent(track, stream) {
        stream.addTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("addtrack", {
            track: track
        }));
    }
    function removeTrackFromStreamAndFireEvent(track, stream) {
        stream.removeTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("removetrack", {
            track: track
        }));
    }
    function fireAddTrack(pc, track, receiver, streams) {
        var trackEvent = new Event("track");
        trackEvent.track = track;
        trackEvent.receiver = receiver;
        trackEvent.transceiver = {
            receiver: receiver
        };
        trackEvent.streams = streams;
        window.setTimeout(function() {
            pc._dispatchEvent("track", trackEvent);
        });
    }
    var RTCPeerConnection = function(config) {
        var pc = this;
        var _eventTarget = document.createDocumentFragment();
        [
            "addEventListener",
            "removeEventListener",
            "dispatchEvent"
        ].forEach(function(method) {
            pc[method] = _eventTarget[method].bind(_eventTarget);
        });
        this.canTrickleIceCandidates = null;
        this.needNegotiation = false;
        this.localStreams = [];
        this.remoteStreams = [];
        this.localDescription = null;
        this.remoteDescription = null;
        this.signalingState = "stable";
        this.iceConnectionState = "new";
        this.iceGatheringState = "new";
        config = JSON.parse(JSON.stringify(config || {}));
        this.usingBundle = config.bundlePolicy === "max-bundle";
        if (config.rtcpMuxPolicy === "negotiate") throw $4d0d30e95648dedb$var$makeError("NotSupportedError", "rtcpMuxPolicy 'negotiate' is not supported");
        else if (!config.rtcpMuxPolicy) config.rtcpMuxPolicy = "require";
        switch(config.iceTransportPolicy){
            case "all":
            case "relay":
                break;
            default:
                config.iceTransportPolicy = "all";
                break;
        }
        switch(config.bundlePolicy){
            case "balanced":
            case "max-compat":
            case "max-bundle":
                break;
            default:
                config.bundlePolicy = "balanced";
                break;
        }
        config.iceServers = $4d0d30e95648dedb$var$filterIceServers(config.iceServers || [], edgeVersion);
        this._iceGatherers = [];
        if (config.iceCandidatePoolSize) for(var i = config.iceCandidatePoolSize; i > 0; i--)this._iceGatherers.push(new window.RTCIceGatherer({
            iceServers: config.iceServers,
            gatherPolicy: config.iceTransportPolicy
        }));
        else config.iceCandidatePoolSize = 0;
        this._config = config;
        // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
        // everything that is needed to describe a SDP m-line.
        this.transceivers = [];
        this._sdpSessionId = $f54c1386e6532a91$exports.generateSessionId();
        this._sdpSessionVersion = 0;
        this._dtlsRole = undefined; // role for a=setup to use in answers.
        this._isClosed = false;
    };
    // set up event handlers on prototype
    RTCPeerConnection.prototype.onicecandidate = null;
    RTCPeerConnection.prototype.onaddstream = null;
    RTCPeerConnection.prototype.ontrack = null;
    RTCPeerConnection.prototype.onremovestream = null;
    RTCPeerConnection.prototype.onsignalingstatechange = null;
    RTCPeerConnection.prototype.oniceconnectionstatechange = null;
    RTCPeerConnection.prototype.onicegatheringstatechange = null;
    RTCPeerConnection.prototype.onnegotiationneeded = null;
    RTCPeerConnection.prototype.ondatachannel = null;
    RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
        if (this._isClosed) return;
        this.dispatchEvent(event);
        if (typeof this["on" + name] === "function") this["on" + name](event);
    };
    RTCPeerConnection.prototype._emitGatheringStateChange = function() {
        var event = new Event("icegatheringstatechange");
        this._dispatchEvent("icegatheringstatechange", event);
    };
    RTCPeerConnection.prototype.getConfiguration = function() {
        return this._config;
    };
    RTCPeerConnection.prototype.getLocalStreams = function() {
        return this.localStreams;
    };
    RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this.remoteStreams;
    };
    // internal helper to create a transceiver object.
    // (whih is not yet the same as the WebRTC 1.0 transceiver)
    RTCPeerConnection.prototype._createTransceiver = function(kind) {
        var hasBundleTransport = this.transceivers.length > 0;
        var transceiver = {
            track: null,
            iceGatherer: null,
            iceTransport: null,
            dtlsTransport: null,
            localCapabilities: null,
            remoteCapabilities: null,
            rtpSender: null,
            rtpReceiver: null,
            kind: kind,
            mid: null,
            sendEncodingParameters: null,
            recvEncodingParameters: null,
            stream: null,
            associatedRemoteMediaStreams: [],
            wantReceive: true
        };
        if (this.usingBundle && hasBundleTransport) {
            transceiver.iceTransport = this.transceivers[0].iceTransport;
            transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
        } else {
            var transports = this._createIceAndDtlsTransports();
            transceiver.iceTransport = transports.iceTransport;
            transceiver.dtlsTransport = transports.dtlsTransport;
        }
        this.transceivers.push(transceiver);
        return transceiver;
    };
    RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (this._isClosed) throw $4d0d30e95648dedb$var$makeError("InvalidStateError", "Attempted to call addTrack on a closed peerconnection.");
        var alreadyExists = this.transceivers.find(function(s) {
            return s.track === track;
        });
        if (alreadyExists) throw $4d0d30e95648dedb$var$makeError("InvalidAccessError", "Track already exists.");
        var transceiver;
        for(var i = 0; i < this.transceivers.length; i++)if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) transceiver = this.transceivers[i];
        if (!transceiver) transceiver = this._createTransceiver(track.kind);
        this._maybeFireNegotiationNeeded();
        if (this.localStreams.indexOf(stream) === -1) this.localStreams.push(stream);
        transceiver.track = track;
        transceiver.stream = stream;
        transceiver.rtpSender = new window.RTCRtpSender(track, transceiver.dtlsTransport);
        return transceiver.rtpSender;
    };
    RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        if (edgeVersion >= 15025) stream.getTracks().forEach(function(track) {
            pc.addTrack(track, stream);
        });
        else {
            // Clone is necessary for local demos mostly, attaching directly
            // to two different senders does not work (build 10547).
            // Fixed in 15025 (or earlier)
            var clonedStream = stream.clone();
            stream.getTracks().forEach(function(track, idx) {
                var clonedTrack = clonedStream.getTracks()[idx];
                track.addEventListener("enabled", function(event) {
                    clonedTrack.enabled = event.enabled;
                });
            });
            clonedStream.getTracks().forEach(function(track) {
                pc.addTrack(track, clonedStream);
            });
        }
    };
    RTCPeerConnection.prototype.removeTrack = function(sender) {
        if (this._isClosed) throw $4d0d30e95648dedb$var$makeError("InvalidStateError", "Attempted to call removeTrack on a closed peerconnection.");
        if (!(sender instanceof window.RTCRtpSender)) throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
        var transceiver = this.transceivers.find(function(t) {
            return t.rtpSender === sender;
        });
        if (!transceiver) throw $4d0d30e95648dedb$var$makeError("InvalidAccessError", "Sender was not created by this connection.");
        var stream = transceiver.stream;
        transceiver.rtpSender.stop();
        transceiver.rtpSender = null;
        transceiver.track = null;
        transceiver.stream = null;
        // remove the stream from the set of local streams
        var localStreams = this.transceivers.map(function(t) {
            return t.stream;
        });
        if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) this.localStreams.splice(this.localStreams.indexOf(stream), 1);
        this._maybeFireNegotiationNeeded();
    };
    RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        stream.getTracks().forEach(function(track) {
            var sender = pc.getSenders().find(function(s) {
                return s.track === track;
            });
            if (sender) pc.removeTrack(sender);
        });
    };
    RTCPeerConnection.prototype.getSenders = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpSender;
        }).map(function(transceiver) {
            return transceiver.rtpSender;
        });
    };
    RTCPeerConnection.prototype.getReceivers = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpReceiver;
        }).map(function(transceiver) {
            return transceiver.rtpReceiver;
        });
    };
    RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex, usingBundle) {
        var pc = this;
        if (usingBundle && sdpMLineIndex > 0) return this.transceivers[0].iceGatherer;
        else if (this._iceGatherers.length) return this._iceGatherers.shift();
        var iceGatherer = new window.RTCIceGatherer({
            iceServers: this._config.iceServers,
            gatherPolicy: this._config.iceTransportPolicy
        });
        Object.defineProperty(iceGatherer, "state", {
            value: "new",
            writable: true
        });
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
        this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
            var end = !event.candidate || Object.keys(event.candidate).length === 0;
            // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            iceGatherer.state = end ? "completed" : "gathering";
            if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
        };
        iceGatherer.addEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        return iceGatherer;
    };
    // start gathering from an RTCIceGatherer.
    RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
        var pc = this;
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer.onlocalcandidate) return;
        var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
        iceGatherer.removeEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        iceGatherer.onlocalcandidate = function(evt) {
            if (pc.usingBundle && sdpMLineIndex > 0) // if we know that we use bundle we can drop candidates with
            // ѕdpMLineIndex > 0. If we don't do this then our state gets
            // confused since we dispose the extra ice gatherer.
            return;
            var event = new Event("icecandidate");
            event.candidate = {
                sdpMid: mid,
                sdpMLineIndex: sdpMLineIndex
            };
            var cand = evt.candidate;
            // Edge emits an empty object for RTCIceCandidateComplete‥
            var end = !cand || Object.keys(cand).length === 0;
            if (end) // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            {
                if (iceGatherer.state === "new" || iceGatherer.state === "gathering") iceGatherer.state = "completed";
            } else {
                if (iceGatherer.state === "new") iceGatherer.state = "gathering";
                // RTCIceCandidate doesn't have a component, needs to be added
                cand.component = 1;
                var serializedCandidate = $f54c1386e6532a91$exports.writeCandidate(cand);
                event.candidate = Object.assign(event.candidate, $f54c1386e6532a91$exports.parseCandidate(serializedCandidate));
                event.candidate.candidate = serializedCandidate;
            }
            // update local description.
            var sections = $f54c1386e6532a91$exports.getMediaSections(pc.localDescription.sdp);
            if (!end) sections[event.candidate.sdpMLineIndex] += "a=" + event.candidate.candidate + "\r\n";
            else sections[event.candidate.sdpMLineIndex] += "a=end-of-candidates\r\n";
            pc.localDescription.sdp = $f54c1386e6532a91$exports.getDescription(pc.localDescription.sdp) + sections.join("");
            var complete = pc.transceivers.every(function(transceiver) {
                return transceiver.iceGatherer && transceiver.iceGatherer.state === "completed";
            });
            if (pc.iceGatheringState !== "gathering") {
                pc.iceGatheringState = "gathering";
                pc._emitGatheringStateChange();
            }
            // Emit candidate. Also emit null candidate when all gatherers are
            // complete.
            if (!end) pc._dispatchEvent("icecandidate", event);
            if (complete) {
                pc._dispatchEvent("icecandidate", new Event("icecandidate"));
                pc.iceGatheringState = "complete";
                pc._emitGatheringStateChange();
            }
        };
        // emit already gathered candidates.
        window.setTimeout(function() {
            bufferedCandidateEvents.forEach(function(e) {
                iceGatherer.onlocalcandidate(e);
            });
        }, 0);
    };
    // Create ICE transport and DTLS transport.
    RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
        var pc = this;
        var iceTransport = new window.RTCIceTransport(null);
        iceTransport.onicestatechange = function() {
            pc._updateConnectionState();
        };
        var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
        dtlsTransport.ondtlsstatechange = function() {
            pc._updateConnectionState();
        };
        dtlsTransport.onerror = function() {
            // onerror does not set state to failed by itself.
            Object.defineProperty(dtlsTransport, "state", {
                value: "failed",
                writable: true
            });
            pc._updateConnectionState();
        };
        return {
            iceTransport: iceTransport,
            dtlsTransport: dtlsTransport
        };
    };
    // Destroy ICE gatherer, ICE transport and DTLS transport.
    // Without triggering the callbacks.
    RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(sdpMLineIndex) {
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer) {
            delete iceGatherer.onlocalcandidate;
            delete this.transceivers[sdpMLineIndex].iceGatherer;
        }
        var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
        if (iceTransport) {
            delete iceTransport.onicestatechange;
            delete this.transceivers[sdpMLineIndex].iceTransport;
        }
        var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
        if (dtlsTransport) {
            delete dtlsTransport.ondtlsstatechange;
            delete dtlsTransport.onerror;
            delete this.transceivers[sdpMLineIndex].dtlsTransport;
        }
    };
    // Start the RTP Sender and Receiver for a transceiver.
    RTCPeerConnection.prototype._transceive = function(transceiver, send, recv) {
        var params = $4d0d30e95648dedb$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
        if (send && transceiver.rtpSender) {
            params.encodings = transceiver.sendEncodingParameters;
            params.rtcp = {
                cname: $f54c1386e6532a91$exports.localCName,
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.recvEncodingParameters.length) params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
            transceiver.rtpSender.send(params);
        }
        if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
            // remove RTX field in Edge 14942
            if (transceiver.kind === "video" && transceiver.recvEncodingParameters && edgeVersion < 15019) transceiver.recvEncodingParameters.forEach(function(p) {
                delete p.rtx;
            });
            if (transceiver.recvEncodingParameters.length) params.encodings = transceiver.recvEncodingParameters;
            else params.encodings = [
                {}
            ];
            params.rtcp = {
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.rtcpParameters.cname) params.rtcp.cname = transceiver.rtcpParameters.cname;
            if (transceiver.sendEncodingParameters.length) params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
            transceiver.rtpReceiver.receive(params);
        }
    };
    RTCPeerConnection.prototype.setLocalDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($4d0d30e95648dedb$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$4d0d30e95648dedb$var$isActionAllowedInSignalingState("setLocalDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not set local " + description.type + " in state " + pc.signalingState));
        var sections;
        var sessionpart;
        if (description.type === "offer") {
            // VERY limited support for SDP munging. Limited to:
            // * changing the order of codecs
            sections = $f54c1386e6532a91$exports.splitSections(description.sdp);
            sessionpart = sections.shift();
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var caps = $f54c1386e6532a91$exports.parseRtpParameters(mediaSection);
                pc.transceivers[sdpMLineIndex].localCapabilities = caps;
            });
            pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                pc._gather(transceiver.mid, sdpMLineIndex);
            });
        } else if (description.type === "answer") {
            sections = $f54c1386e6532a91$exports.splitSections(pc.remoteDescription.sdp);
            sessionpart = sections.shift();
            var isIceLite = $f54c1386e6532a91$exports.matchPrefix(sessionpart, "a=ice-lite").length > 0;
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var transceiver = pc.transceivers[sdpMLineIndex];
                var iceGatherer = transceiver.iceGatherer;
                var iceTransport = transceiver.iceTransport;
                var dtlsTransport = transceiver.dtlsTransport;
                var localCapabilities = transceiver.localCapabilities;
                var remoteCapabilities = transceiver.remoteCapabilities;
                // treat bundle-only as not-rejected.
                var rejected = $f54c1386e6532a91$exports.isRejected(mediaSection) && $f54c1386e6532a91$exports.matchPrefix(mediaSection, "a=bundle-only").length === 0;
                if (!rejected && !transceiver.isDatachannel) {
                    var remoteIceParameters = $f54c1386e6532a91$exports.getIceParameters(mediaSection, sessionpart);
                    var remoteDtlsParameters = $f54c1386e6532a91$exports.getDtlsParameters(mediaSection, sessionpart);
                    if (isIceLite) remoteDtlsParameters.role = "server";
                    if (!pc.usingBundle || sdpMLineIndex === 0) {
                        pc._gather(transceiver.mid, sdpMLineIndex);
                        if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? "controlling" : "controlled");
                        if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                    }
                    // Calculate intersection of capabilities.
                    var params = $4d0d30e95648dedb$var$getCommonCapabilities(localCapabilities, remoteCapabilities);
                    // Start the RTCRtpSender. The RTCRtpReceiver for this
                    // transceiver has already been started in setRemoteDescription.
                    pc._transceive(transceiver, params.codecs.length > 0, false);
                }
            });
        }
        pc.localDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-local-offer");
        else pc._updateSignalingState("stable");
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.setRemoteDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($4d0d30e95648dedb$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$4d0d30e95648dedb$var$isActionAllowedInSignalingState("setRemoteDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not set remote " + description.type + " in state " + pc.signalingState));
        var streams = {};
        pc.remoteStreams.forEach(function(stream) {
            streams[stream.id] = stream;
        });
        var receiverList = [];
        var sections = $f54c1386e6532a91$exports.splitSections(description.sdp);
        var sessionpart = sections.shift();
        var isIceLite = $f54c1386e6532a91$exports.matchPrefix(sessionpart, "a=ice-lite").length > 0;
        var usingBundle = $f54c1386e6532a91$exports.matchPrefix(sessionpart, "a=group:BUNDLE ").length > 0;
        pc.usingBundle = usingBundle;
        var iceOptions = $f54c1386e6532a91$exports.matchPrefix(sessionpart, "a=ice-options:")[0];
        if (iceOptions) pc.canTrickleIceCandidates = iceOptions.substr(14).split(" ").indexOf("trickle") >= 0;
        else pc.canTrickleIceCandidates = false;
        sections.forEach(function(mediaSection, sdpMLineIndex) {
            var lines = $f54c1386e6532a91$exports.splitLines(mediaSection);
            var kind = $f54c1386e6532a91$exports.getKind(mediaSection);
            // treat bundle-only as not-rejected.
            var rejected = $f54c1386e6532a91$exports.isRejected(mediaSection) && $f54c1386e6532a91$exports.matchPrefix(mediaSection, "a=bundle-only").length === 0;
            var protocol = lines[0].substr(2).split(" ")[2];
            var direction = $f54c1386e6532a91$exports.getDirection(mediaSection, sessionpart);
            var remoteMsid = $f54c1386e6532a91$exports.parseMsid(mediaSection);
            var mid = $f54c1386e6532a91$exports.getMid(mediaSection) || $f54c1386e6532a91$exports.generateIdentifier();
            // Reject datachannels which are not implemented yet.
            if (kind === "application" && protocol === "DTLS/SCTP") {
                pc.transceivers[sdpMLineIndex] = {
                    mid: mid,
                    isDatachannel: true
                };
                return;
            }
            var transceiver;
            var iceGatherer;
            var iceTransport;
            var dtlsTransport;
            var rtpReceiver;
            var sendEncodingParameters;
            var recvEncodingParameters;
            var localCapabilities;
            var track;
            // FIXME: ensure the mediaSection has rtcp-mux set.
            var remoteCapabilities = $f54c1386e6532a91$exports.parseRtpParameters(mediaSection);
            var remoteIceParameters;
            var remoteDtlsParameters;
            if (!rejected) {
                remoteIceParameters = $f54c1386e6532a91$exports.getIceParameters(mediaSection, sessionpart);
                remoteDtlsParameters = $f54c1386e6532a91$exports.getDtlsParameters(mediaSection, sessionpart);
                remoteDtlsParameters.role = "client";
            }
            recvEncodingParameters = $f54c1386e6532a91$exports.parseRtpEncodingParameters(mediaSection);
            var rtcpParameters = $f54c1386e6532a91$exports.parseRtcpParameters(mediaSection);
            var isComplete = $f54c1386e6532a91$exports.matchPrefix(mediaSection, "a=end-of-candidates", sessionpart).length > 0;
            var cands = $f54c1386e6532a91$exports.matchPrefix(mediaSection, "a=candidate:").map(function(cand) {
                return $f54c1386e6532a91$exports.parseCandidate(cand);
            }).filter(function(cand) {
                return cand.component === 1;
            });
            // Check if we can use BUNDLE and dispose transports.
            if ((description.type === "offer" || description.type === "answer") && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
                pc._disposeIceAndDtlsTransports(sdpMLineIndex);
                pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
                pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
                pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;
                if (pc.transceivers[sdpMLineIndex].rtpSender) pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
                if (pc.transceivers[sdpMLineIndex].rtpReceiver) pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
            }
            if (description.type === "offer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
                transceiver.mid = mid;
                if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
                if (cands.length && transceiver.iceTransport.state === "new") {
                    if (isComplete && (!usingBundle || sdpMLineIndex === 0)) transceiver.iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);
                // filter RTX until additional stuff needed for RTX is implemented
                // in adapter.js
                if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                    return codec.name !== "rtx";
                });
                sendEncodingParameters = transceiver.sendEncodingParameters || [
                    {
                        ssrc: (2 * sdpMLineIndex + 2) * 1001
                    }
                ];
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                var isNewTrack = false;
                if (direction === "sendrecv" || direction === "sendonly") {
                    isNewTrack = !transceiver.rtpReceiver;
                    rtpReceiver = transceiver.rtpReceiver || new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                    if (isNewTrack) {
                        var stream;
                        track = rtpReceiver.track;
                        // FIXME: does not work with Plan B.
                        if (remoteMsid && remoteMsid.stream === "-") ;
                        else if (remoteMsid) {
                            if (!streams[remoteMsid.stream]) {
                                streams[remoteMsid.stream] = new window.MediaStream();
                                Object.defineProperty(streams[remoteMsid.stream], "id", {
                                    get: function() {
                                        return remoteMsid.stream;
                                    }
                                });
                            }
                            Object.defineProperty(track, "id", {
                                get: function() {
                                    return remoteMsid.track;
                                }
                            });
                            stream = streams[remoteMsid.stream];
                        } else {
                            if (!streams.default) streams.default = new window.MediaStream();
                            stream = streams.default;
                        }
                        if (stream) {
                            addTrackToStreamAndFireEvent(track, stream);
                            transceiver.associatedRemoteMediaStreams.push(stream);
                        }
                        receiverList.push([
                            track,
                            rtpReceiver,
                            stream
                        ]);
                    }
                } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
                    transceiver.associatedRemoteMediaStreams.forEach(function(s) {
                        var nativeTrack = s.getTracks().find(function(t) {
                            return t.id === transceiver.rtpReceiver.track.id;
                        });
                        if (nativeTrack) removeTrackFromStreamAndFireEvent(nativeTrack, s);
                    });
                    transceiver.associatedRemoteMediaStreams = [];
                }
                transceiver.localCapabilities = localCapabilities;
                transceiver.remoteCapabilities = remoteCapabilities;
                transceiver.rtpReceiver = rtpReceiver;
                transceiver.rtcpParameters = rtcpParameters;
                transceiver.sendEncodingParameters = sendEncodingParameters;
                transceiver.recvEncodingParameters = recvEncodingParameters;
                // Start the RTCRtpReceiver now. The RTPSender is started in
                // setLocalDescription.
                pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
            } else if (description.type === "answer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex];
                iceGatherer = transceiver.iceGatherer;
                iceTransport = transceiver.iceTransport;
                dtlsTransport = transceiver.dtlsTransport;
                rtpReceiver = transceiver.rtpReceiver;
                sendEncodingParameters = transceiver.sendEncodingParameters;
                localCapabilities = transceiver.localCapabilities;
                pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
                pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
                pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
                if (cands.length && iceTransport.state === "new") {
                    if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                if (!usingBundle || sdpMLineIndex === 0) {
                    if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, "controlling");
                    if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                }
                pc._transceive(transceiver, direction === "sendrecv" || direction === "recvonly", direction === "sendrecv" || direction === "sendonly");
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                if (rtpReceiver && (direction === "sendrecv" || direction === "sendonly")) {
                    track = rtpReceiver.track;
                    if (remoteMsid) {
                        if (!streams[remoteMsid.stream]) streams[remoteMsid.stream] = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams[remoteMsid.stream]
                        ]);
                    } else {
                        if (!streams.default) streams.default = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams.default);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams.default
                        ]);
                    }
                } else // FIXME: actually the receiver should be created later.
                delete transceiver.rtpReceiver;
            }
        });
        if (pc._dtlsRole === undefined) pc._dtlsRole = description.type === "offer" ? "active" : "passive";
        pc.remoteDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-remote-offer");
        else pc._updateSignalingState("stable");
        Object.keys(streams).forEach(function(sid) {
            var stream = streams[sid];
            if (stream.getTracks().length) {
                if (pc.remoteStreams.indexOf(stream) === -1) {
                    pc.remoteStreams.push(stream);
                    var event = new Event("addstream");
                    event.stream = stream;
                    window.setTimeout(function() {
                        pc._dispatchEvent("addstream", event);
                    });
                }
                receiverList.forEach(function(item) {
                    var track = item[0];
                    var receiver = item[1];
                    if (stream.id !== item[2].id) return;
                    fireAddTrack(pc, track, receiver, [
                        stream
                    ]);
                });
            }
        });
        receiverList.forEach(function(item) {
            if (item[2]) return;
            fireAddTrack(pc, item[0], item[1], []);
        });
        // check whether addIceCandidate({}) was called within four seconds after
        // setRemoteDescription.
        window.setTimeout(function() {
            if (!(pc && pc.transceivers)) return;
            pc.transceivers.forEach(function(transceiver) {
                if (transceiver.iceTransport && transceiver.iceTransport.state === "new" && transceiver.iceTransport.getRemoteCandidates().length > 0) {
                    console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification");
                    transceiver.iceTransport.addRemoteCandidate({});
                }
            });
        }, 4000);
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.close = function() {
        this.transceivers.forEach(function(transceiver) {
            /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */ if (transceiver.iceTransport) transceiver.iceTransport.stop();
            if (transceiver.dtlsTransport) transceiver.dtlsTransport.stop();
            if (transceiver.rtpSender) transceiver.rtpSender.stop();
            if (transceiver.rtpReceiver) transceiver.rtpReceiver.stop();
        });
        // FIXME: clean up tracks, local streams, remote streams, etc
        this._isClosed = true;
        this._updateSignalingState("closed");
    };
    // Update the signaling state.
    RTCPeerConnection.prototype._updateSignalingState = function(newState) {
        this.signalingState = newState;
        var event = new Event("signalingstatechange");
        this._dispatchEvent("signalingstatechange", event);
    };
    // Determine whether to fire the negotiationneeded event.
    RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
        var pc = this;
        if (this.signalingState !== "stable" || this.needNegotiation === true) return;
        this.needNegotiation = true;
        window.setTimeout(function() {
            if (pc.needNegotiation) {
                pc.needNegotiation = false;
                var event = new Event("negotiationneeded");
                pc._dispatchEvent("negotiationneeded", event);
            }
        }, 0);
    };
    // Update the connection state.
    RTCPeerConnection.prototype._updateConnectionState = function() {
        var newState;
        var states = {
            "new": 0,
            closed: 0,
            connecting: 0,
            checking: 0,
            connected: 0,
            completed: 0,
            disconnected: 0,
            failed: 0
        };
        this.transceivers.forEach(function(transceiver) {
            states[transceiver.iceTransport.state]++;
            states[transceiver.dtlsTransport.state]++;
        });
        // ICETransport.completed and connected are the same for this purpose.
        states.connected += states.completed;
        newState = "new";
        if (states.failed > 0) newState = "failed";
        else if (states.connecting > 0 || states.checking > 0) newState = "connecting";
        else if (states.disconnected > 0) newState = "disconnected";
        else if (states.new > 0) newState = "new";
        else if (states.connected > 0 || states.completed > 0) newState = "connected";
        if (newState !== this.iceConnectionState) {
            this.iceConnectionState = newState;
            var event = new Event("iceconnectionstatechange");
            this._dispatchEvent("iceconnectionstatechange", event);
        }
    };
    RTCPeerConnection.prototype.createOffer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not call createOffer after close"));
        var numAudioTracks = pc.transceivers.filter(function(t) {
            return t.kind === "audio";
        }).length;
        var numVideoTracks = pc.transceivers.filter(function(t) {
            return t.kind === "video";
        }).length;
        // Determine number of audio and video tracks we need to send/recv.
        var offerOptions = arguments[0];
        if (offerOptions) {
            // Reject Chrome legacy constraints.
            if (offerOptions.mandatory || offerOptions.optional) throw new TypeError("Legacy mandatory/optional constraints not supported.");
            if (offerOptions.offerToReceiveAudio !== undefined) {
                if (offerOptions.offerToReceiveAudio === true) numAudioTracks = 1;
                else if (offerOptions.offerToReceiveAudio === false) numAudioTracks = 0;
                else numAudioTracks = offerOptions.offerToReceiveAudio;
            }
            if (offerOptions.offerToReceiveVideo !== undefined) {
                if (offerOptions.offerToReceiveVideo === true) numVideoTracks = 1;
                else if (offerOptions.offerToReceiveVideo === false) numVideoTracks = 0;
                else numVideoTracks = offerOptions.offerToReceiveVideo;
            }
        }
        pc.transceivers.forEach(function(transceiver) {
            if (transceiver.kind === "audio") {
                numAudioTracks--;
                if (numAudioTracks < 0) transceiver.wantReceive = false;
            } else if (transceiver.kind === "video") {
                numVideoTracks--;
                if (numVideoTracks < 0) transceiver.wantReceive = false;
            }
        });
        // Create M-lines for recvonly streams.
        while(numAudioTracks > 0 || numVideoTracks > 0){
            if (numAudioTracks > 0) {
                pc._createTransceiver("audio");
                numAudioTracks--;
            }
            if (numVideoTracks > 0) {
                pc._createTransceiver("video");
                numVideoTracks--;
            }
        }
        var sdp = $f54c1386e6532a91$exports.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            // For each track, create an ice gatherer, ice transport,
            // dtls transport, potentially rtpsender and rtpreceiver.
            var track = transceiver.track;
            var kind = transceiver.kind;
            var mid = transceiver.mid || $f54c1386e6532a91$exports.generateIdentifier();
            transceiver.mid = mid;
            if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
            var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
            // filter RTX until additional stuff needed for RTX is implemented
            // in adapter.js
            if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                return codec.name !== "rtx";
            });
            localCapabilities.codecs.forEach(function(codec) {
                // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
                // by adding level-asymmetry-allowed=1
                if (codec.name === "H264" && codec.parameters["level-asymmetry-allowed"] === undefined) codec.parameters["level-asymmetry-allowed"] = "1";
                // for subsequent offers, we might have to re-use the payload
                // type of the last offer.
                if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
                    if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) codec.preferredPayloadType = remoteCodec.payloadType;
                });
            });
            localCapabilities.headerExtensions.forEach(function(hdrExt) {
                var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
                remoteExtensions.forEach(function(rHdrExt) {
                    if (hdrExt.uri === rHdrExt.uri) hdrExt.id = rHdrExt.id;
                });
            });
            // generate an ssrc now, to be used later in rtpSender.send
            var sendEncodingParameters = transceiver.sendEncodingParameters || [
                {
                    ssrc: (2 * sdpMLineIndex + 1) * 1001
                }
            ];
            if (track) // add RTX
            {
                if (edgeVersion >= 15019 && kind === "video" && !sendEncodingParameters[0].rtx) sendEncodingParameters[0].rtx = {
                    ssrc: sendEncodingParameters[0].ssrc + 1
                };
            }
            if (transceiver.wantReceive) transceiver.rtpReceiver = new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
            transceiver.localCapabilities = localCapabilities;
            transceiver.sendEncodingParameters = sendEncodingParameters;
        });
        // always offer BUNDLE and dispose on return if not supported.
        if (pc._config.bundlePolicy !== "max-compat") sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        sdp += "a=ice-options:trickle\r\n";
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            sdp += $4d0d30e95648dedb$var$writeMediaSection(transceiver, transceiver.localCapabilities, "offer", transceiver.stream, pc._dtlsRole);
            sdp += "a=rtcp-rsize\r\n";
            if (transceiver.iceGatherer && pc.iceGatheringState !== "new" && (sdpMLineIndex === 0 || !pc.usingBundle)) {
                transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
                    cand.component = 1;
                    sdp += "a=" + $f54c1386e6532a91$exports.writeCandidate(cand) + "\r\n";
                });
                if (transceiver.iceGatherer.state === "completed") sdp += "a=end-of-candidates\r\n";
            }
        });
        var desc = new window.RTCSessionDescription({
            type: "offer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.createAnswer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not call createAnswer after close"));
        var sdp = $f54c1386e6532a91$exports.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        if (pc.usingBundle) sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        var mediaSectionsInOffer = $f54c1386e6532a91$exports.getMediaSections(pc.remoteDescription.sdp).length;
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            if (sdpMLineIndex + 1 > mediaSectionsInOffer) return;
            if (transceiver.isDatachannel) {
                sdp += "m=application 0 DTLS/SCTP 5000\r\nc=IN IP4 0.0.0.0\r\na=mid:" + transceiver.mid + "\r\n";
                return;
            }
            // FIXME: look at direction.
            if (transceiver.stream) {
                var localTrack;
                if (transceiver.kind === "audio") localTrack = transceiver.stream.getAudioTracks()[0];
                else if (transceiver.kind === "video") localTrack = transceiver.stream.getVideoTracks()[0];
                if (localTrack) // add RTX
                {
                    if (edgeVersion >= 15019 && transceiver.kind === "video" && !transceiver.sendEncodingParameters[0].rtx) transceiver.sendEncodingParameters[0].rtx = {
                        ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
                    };
                }
            }
            // Calculate intersection of capabilities.
            var commonCapabilities = $4d0d30e95648dedb$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
            var hasRtx = commonCapabilities.codecs.filter(function(c) {
                return c.name.toLowerCase() === "rtx";
            }).length;
            if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
            sdp += $4d0d30e95648dedb$var$writeMediaSection(transceiver, commonCapabilities, "answer", transceiver.stream, pc._dtlsRole);
            if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
        });
        var desc = new window.RTCSessionDescription({
            type: "answer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
        var pc = this;
        var sections;
        if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) return Promise.reject(new TypeError("sdpMLineIndex or sdpMid required"));
        // TODO: needs to go into ops queue.
        return new Promise(function(resolve, reject) {
            if (!pc.remoteDescription) return reject($4d0d30e95648dedb$var$makeError("InvalidStateError", "Can not add ICE candidate without a remote description"));
            else if (!candidate || candidate.candidate === "") for(var j = 0; j < pc.transceivers.length; j++){
                if (pc.transceivers[j].isDatachannel) continue;
                pc.transceivers[j].iceTransport.addRemoteCandidate({});
                sections = $f54c1386e6532a91$exports.getMediaSections(pc.remoteDescription.sdp);
                sections[j] += "a=end-of-candidates\r\n";
                pc.remoteDescription.sdp = $f54c1386e6532a91$exports.getDescription(pc.remoteDescription.sdp) + sections.join("");
                if (pc.usingBundle) break;
            }
            else {
                var sdpMLineIndex = candidate.sdpMLineIndex;
                if (candidate.sdpMid) {
                    for(var i = 0; i < pc.transceivers.length; i++)if (pc.transceivers[i].mid === candidate.sdpMid) {
                        sdpMLineIndex = i;
                        break;
                    }
                }
                var transceiver = pc.transceivers[sdpMLineIndex];
                if (transceiver) {
                    if (transceiver.isDatachannel) return resolve();
                    var cand = Object.keys(candidate.candidate).length > 0 ? $f54c1386e6532a91$exports.parseCandidate(candidate.candidate) : {};
                    // Ignore Chrome's invalid candidates since Edge does not like them.
                    if (cand.protocol === "tcp" && (cand.port === 0 || cand.port === 9)) return resolve();
                    // Ignore RTCP candidates, we assume RTCP-MUX.
                    if (cand.component && cand.component !== 1) return resolve();
                    // when using bundle, avoid adding candidates to the wrong
                    // ice transport. And avoid adding candidates added in the SDP.
                    if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
                        if (!$4d0d30e95648dedb$var$maybeAddCandidate(transceiver.iceTransport, cand)) return reject($4d0d30e95648dedb$var$makeError("OperationError", "Can not add ICE candidate"));
                    }
                    // update the remoteDescription.
                    var candidateString = candidate.candidate.trim();
                    if (candidateString.indexOf("a=") === 0) candidateString = candidateString.substr(2);
                    sections = $f54c1386e6532a91$exports.getMediaSections(pc.remoteDescription.sdp);
                    sections[sdpMLineIndex] += "a=" + (cand.type ? candidateString : "end-of-candidates") + "\r\n";
                    pc.remoteDescription.sdp = sections.join("");
                } else return reject($4d0d30e95648dedb$var$makeError("OperationError", "Can not add ICE candidate"));
            }
            resolve();
        });
    };
    RTCPeerConnection.prototype.getStats = function() {
        var promises = [];
        this.transceivers.forEach(function(transceiver) {
            [
                "rtpSender",
                "rtpReceiver",
                "iceGatherer",
                "iceTransport",
                "dtlsTransport"
            ].forEach(function(method) {
                if (transceiver[method]) promises.push(transceiver[method].getStats());
            });
        });
        var fixStatsType = function(stat) {
            return ({
                inboundrtp: "inbound-rtp",
                outboundrtp: "outbound-rtp",
                candidatepair: "candidate-pair",
                localcandidate: "local-candidate",
                remotecandidate: "remote-candidate"
            })[stat.type] || stat.type;
        };
        return new Promise(function(resolve) {
            // shim getStats with maplike support
            var results = new Map();
            Promise.all(promises).then(function(res) {
                res.forEach(function(result) {
                    Object.keys(result).forEach(function(id) {
                        result[id].type = fixStatsType(result[id]);
                        results.set(id, result[id]);
                    });
                });
                resolve(results);
            });
        });
    };
    // legacy callback shims. Should be moved to adapter.js some days.
    var methods = [
        "createOffer",
        "createAnswer"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[0] === "function" || typeof args[1] === "function") return nativeMethod.apply(this, [
                arguments[2]
            ]).then(function(description) {
                if (typeof args[0] === "function") args[0].apply(null, [
                    description
                ]);
            }, function(error) {
                if (typeof args[1] === "function") args[1].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    methods = [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function" || typeof args[2] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            }, function(error) {
                if (typeof args[2] === "function") args[2].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    // getStats is special. It doesn't have a spec legacy method yet we support
    // getStats(something, cb) without error callbacks.
    [
        "getStats"
    ].forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    return RTCPeerConnection;
};


function $c1a056b32fadc499$var$RTCPC(options) {
    if (typeof window === "undefined") {
        this.log.info("No RTCPeerConnection implementation available. The window object was not found.");
        return;
    }
    if (options && options.RTCPeerConnection) this.RTCPeerConnection = options.RTCPeerConnection;
    else if ($b060d15305f18a68$exports.isLegacyEdge()) this.RTCPeerConnection = new $4d0d30e95648dedb$exports(typeof window !== "undefined" ? window : $parcel$global);
    else if (typeof window.RTCPeerConnection === "function") this.RTCPeerConnection = window.RTCPeerConnection;
    else if (typeof window.webkitRTCPeerConnection === "function") this.RTCPeerConnection = webkitRTCPeerConnection;
    else if (typeof window.mozRTCPeerConnection === "function") {
        this.RTCPeerConnection = mozRTCPeerConnection;
        window.RTCSessionDescription = mozRTCSessionDescription;
        window.RTCIceCandidate = mozRTCIceCandidate;
    } else this.log.info("No RTCPeerConnection implementation available");
}
$c1a056b32fadc499$var$RTCPC.prototype.create = function(rtcConfiguration) {
    this.log = new $674d4885484aa9f2$exports.default("RTCPC");
    this.pc = new this.RTCPeerConnection(rtcConfiguration);
};
$c1a056b32fadc499$var$RTCPC.prototype.createModernConstraints = function(c) {
    // createOffer differs between Chrome 23 and Chrome 24+.
    // See https://groups.google.com/forum/?fromgroups=#!topic/discuss-webrtc/JBDZtrMumyU
    // Unfortunately I haven't figured out a way to detect which format
    // is required ahead of time, so we'll first try the old way, and
    // if we get an exception, then we'll try the new way.
    if (typeof c === "undefined") return null;
    // NOTE(mroberts): As of Chrome 38, Chrome still appears to expect
    // constraints under the 'mandatory' key, and with the first letter of each
    // constraint capitalized. Firefox, on the other hand, has deprecated the
    // 'mandatory' key and does not expect the first letter of each constraint
    // capitalized.
    var nc = Object.assign({}, c);
    if (typeof webkitRTCPeerConnection !== "undefined" && !$b060d15305f18a68$exports.isLegacyEdge()) {
        nc.mandatory = {};
        if (typeof c.audio !== "undefined") nc.mandatory.OfferToReceiveAudio = c.audio;
        if (typeof c.video !== "undefined") nc.mandatory.OfferToReceiveVideo = c.video;
    } else {
        if (typeof c.audio !== "undefined") nc.offerToReceiveAudio = c.audio;
        if (typeof c.video !== "undefined") nc.offerToReceiveVideo = c.video;
    }
    delete nc.audio;
    delete nc.video;
    return nc;
};
$c1a056b32fadc499$var$RTCPC.prototype.createOffer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    var _this = this;
    constraints = this.createModernConstraints(constraints);
    return $c1a056b32fadc499$var$promisifyCreate(this.pc.createOffer, this.pc)(constraints).then(function(offer) {
        if (!_this.pc) return Promise.resolve();
        var sdp = $5daed6d4af7231db$exports.setMaxAverageBitrate(offer.sdp, maxAverageBitrate);
        return $c1a056b32fadc499$var$promisifySet(_this.pc.setLocalDescription, _this.pc)(new RTCSessionDescription({
            sdp: $5daed6d4af7231db$exports.setCodecPreferences(sdp, codecPreferences),
            type: "offer"
        }));
    }).then(onSuccess, onError);
};
$c1a056b32fadc499$var$RTCPC.prototype.createAnswer = function(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError) {
    var _this = this;
    constraints = this.createModernConstraints(constraints);
    return $c1a056b32fadc499$var$promisifyCreate(this.pc.createAnswer, this.pc)(constraints).then(function(answer) {
        if (!_this.pc) return Promise.resolve();
        var sdp = $5daed6d4af7231db$exports.setMaxAverageBitrate(answer.sdp, maxAverageBitrate);
        return $c1a056b32fadc499$var$promisifySet(_this.pc.setLocalDescription, _this.pc)(new RTCSessionDescription({
            sdp: $5daed6d4af7231db$exports.setCodecPreferences(sdp, codecPreferences),
            type: "answer"
        }));
    }).then(onSuccess, onError);
};
$c1a056b32fadc499$var$RTCPC.prototype.processSDP = function(maxAverageBitrate, codecPreferences, sdp, constraints, onSuccess, onError) {
    var _this = this;
    sdp = $5daed6d4af7231db$exports.setCodecPreferences(sdp, codecPreferences);
    var desc = new RTCSessionDescription({
        sdp: sdp,
        type: "offer"
    });
    return $c1a056b32fadc499$var$promisifySet(this.pc.setRemoteDescription, this.pc)(desc).then(function() {
        _this.createAnswer(maxAverageBitrate, codecPreferences, constraints, onSuccess, onError);
    });
};
$c1a056b32fadc499$var$RTCPC.prototype.getSDP = function() {
    return this.pc.localDescription.sdp;
};
$c1a056b32fadc499$var$RTCPC.prototype.processAnswer = function(codecPreferences, sdp, onSuccess, onError) {
    if (!this.pc) return Promise.resolve();
    sdp = $5daed6d4af7231db$exports.setCodecPreferences(sdp, codecPreferences);
    return $c1a056b32fadc499$var$promisifySet(this.pc.setRemoteDescription, this.pc)(new RTCSessionDescription({
        sdp: sdp,
        type: "answer"
    })).then(onSuccess, onError);
};
/* NOTE(mroberts): Firefox 18 through 21 include a `mozRTCPeerConnection`
   object, but attempting to instantiate it will throw the error

       Error: PeerConnection not enabled (did you set the pref?)

   unless the `media.peerconnection.enabled` pref is enabled. So we need to test
   if we can actually instantiate `mozRTCPeerConnection`; however, if the user
   *has* enabled `media.peerconnection.enabled`, we need to perform the same
   test that we use to detect Firefox 24 and above, namely:

       typeof (new mozRTCPeerConnection()).getLocalStreams === 'function'

    NOTE(rrowland): We no longer support Legacy Edge as of Sep 1, 2020.
*/ $c1a056b32fadc499$var$RTCPC.test = function() {
    if (typeof navigator === "object") {
        var getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
        if ($b060d15305f18a68$exports.isLegacyEdge(navigator)) return false;
        if (getUserMedia && typeof window.RTCPeerConnection === "function") return true;
        else if (getUserMedia && typeof window.webkitRTCPeerConnection === "function") return true;
        else if (getUserMedia && typeof window.mozRTCPeerConnection === "function") {
            try {
                var test_1 = new window.mozRTCPeerConnection();
                if (typeof test_1.getLocalStreams !== "function") return false;
            } catch (e) {
                return false;
            }
            return true;
        } else if (typeof RTCIceGatherer !== "undefined") return true;
    }
    return false;
};
function $c1a056b32fadc499$var$promisify(fn, ctx, areCallbacksFirst, checkRval) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        return new Promise(function(resolve) {
            var returnValue = fn.apply(ctx, args);
            if (!checkRval) {
                resolve(returnValue);
                return;
            }
            if (typeof returnValue === "object" && typeof returnValue.then === "function") resolve(returnValue);
            else throw new Error();
        }).catch(function() {
            return new Promise(function(resolve, reject) {
                fn.apply(ctx, areCallbacksFirst ? [
                    resolve,
                    reject
                ].concat(args) : args.concat([
                    resolve,
                    reject
                ]));
            });
        });
    };
}
function $c1a056b32fadc499$var$promisifyCreate(fn, ctx) {
    return $c1a056b32fadc499$var$promisify(fn, ctx, true, true);
}
function $c1a056b32fadc499$var$promisifySet(fn, ctx) {
    return $c1a056b32fadc499$var$promisify(fn, ctx, false, false);
}
$c1a056b32fadc499$exports.default = $c1a056b32fadc499$var$RTCPC;



var $eebba6bea300b063$var$ICE_GATHERING_TIMEOUT = 15000;
var $eebba6bea300b063$var$ICE_GATHERING_FAIL_NONE = "none";
var $eebba6bea300b063$var$ICE_GATHERING_FAIL_TIMEOUT = "timeout";
var $eebba6bea300b063$var$INITIAL_ICE_CONNECTION_STATE = "new";
var $eebba6bea300b063$var$VOLUME_INTERVAL_MS = 50;
/**
 * @typedef {Object} PeerConnection
 * @param audioHelper
 * @param pstream
 * @param options
 * @return {PeerConnection}
 * @constructor
 */ function $eebba6bea300b063$var$PeerConnection(audioHelper, pstream, options) {
    if (!audioHelper || !pstream) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Audiohelper, and pstream are required arguments");
    if (!(this instanceof $eebba6bea300b063$var$PeerConnection)) return new $eebba6bea300b063$var$PeerConnection(audioHelper, pstream, options);
    this._log = new $674d4885484aa9f2$exports.default("PeerConnection");
    function noop() {
        this._log.warn("Unexpected noop call in peerconnection");
    }
    this.onaudio = noop;
    this.onopen = noop;
    this.onerror = noop;
    this.onclose = noop;
    this.ondisconnected = noop;
    this.onfailed = noop;
    this.onconnected = noop;
    this.onreconnected = noop;
    this.onsignalingstatechange = noop;
    this.ondtlstransportstatechange = noop;
    this.onicegatheringfailure = noop;
    this.onicegatheringstatechange = noop;
    this.oniceconnectionstatechange = noop;
    this.onpcconnectionstatechange = noop;
    this.onicecandidate = noop;
    this.onselectedcandidatepairchange = noop;
    this.onvolume = noop;
    this.version = null;
    this.pstream = pstream;
    this.stream = null;
    this.sinkIds = new Set([
        "default"
    ]);
    this.outputs = new Map();
    this.status = "connecting";
    this.callSid = null;
    this.isMuted = false;
    var AudioContext = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);
    this._isSinkSupported = !!AudioContext && typeof HTMLAudioElement !== "undefined" && HTMLAudioElement.prototype.setSinkId;
    // NOTE(mmalavalli): Since each Connection creates its own AudioContext,
    // after 6 instances an exception is thrown. Refer https://www.w3.org/2011/audio/track/issues/3.
    // In order to get around it, we are re-using the Device's AudioContext.
    this._audioContext = AudioContext && audioHelper._audioContext;
    this._audioHelper = audioHelper;
    this._hasIceCandidates = false;
    this._hasIceGatheringFailures = false;
    this._iceGatheringTimeoutId = null;
    this._masterAudio = null;
    this._masterAudioDeviceId = null;
    this._mediaStreamSource = null;
    this._dtmfSender = null;
    this._dtmfSenderUnsupported = false;
    this._callEvents = [];
    this._nextTimeToPublish = Date.now();
    this._onAnswerOrRinging = noop;
    this._onHangup = noop;
    this._remoteStream = null;
    this._shouldManageStream = true;
    this._iceState = $eebba6bea300b063$var$INITIAL_ICE_CONNECTION_STATE;
    this._isUnifiedPlan = options.isUnifiedPlan;
    this.options = options = options || {};
    this.navigator = options.navigator || (typeof navigator !== "undefined" ? navigator : null);
    this.util = options.util || $b060d15305f18a68$exports;
    this.codecPreferences = options.codecPreferences;
    return this;
}
$eebba6bea300b063$var$PeerConnection.prototype.uri = function() {
    return this._uri;
};
/**
 * Open the underlying RTCPeerConnection with a MediaStream obtained by
 *   passed constraints. The resulting MediaStream is created internally
 *   and will therefore be managed and destroyed internally.
 * @param {MediaStreamConstraints} constraints
 */ $eebba6bea300b063$var$PeerConnection.prototype.openDefaultDeviceWithConstraints = function(constraints) {
    return this._audioHelper._openDefaultDeviceWithConstraints(constraints).then(this._setInputTracksFromStream.bind(this, false));
};
/**
 * Replace the existing input audio tracks with the audio tracks from the
 *   passed input audio stream. We re-use the existing stream because
 *   the AnalyzerNode is bound to the stream.
 * @param {MediaStream} stream
 */ $eebba6bea300b063$var$PeerConnection.prototype.setInputTracksFromStream = function(stream) {
    var self = this;
    return this._setInputTracksFromStream(true, stream).then(function() {
        self._shouldManageStream = false;
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._createAnalyser = function(audioContext, options) {
    options = Object.assign({
        fftSize: 32,
        smoothingTimeConstant: 0.3
    }, options);
    var analyser = audioContext.createAnalyser();
    // tslint:disable-next-line
    for(var field in options)analyser[field] = options[field];
    return analyser;
};
$eebba6bea300b063$var$PeerConnection.prototype._setVolumeHandler = function(handler) {
    this.onvolume = handler;
};
$eebba6bea300b063$var$PeerConnection.prototype._startPollingVolume = function() {
    if (!this._audioContext || !this.stream || !this._remoteStream) return;
    var audioContext = this._audioContext;
    var inputAnalyser = this._inputAnalyser = this._createAnalyser(audioContext);
    var inputBufferLength = inputAnalyser.frequencyBinCount;
    var inputDataArray = new Uint8Array(inputBufferLength);
    this._inputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    var outputAnalyser = this._outputAnalyser = this._createAnalyser(audioContext);
    var outputBufferLength = outputAnalyser.frequencyBinCount;
    var outputDataArray = new Uint8Array(outputBufferLength);
    this._outputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    this._updateInputStreamSource(this.stream);
    this._updateOutputStreamSource(this._remoteStream);
    var self = this;
    setTimeout(function emitVolume() {
        if (!self._audioContext) return;
        else if (self.status === "closed") {
            self._inputAnalyser.disconnect();
            self._outputAnalyser.disconnect();
            self._inputAnalyser2.disconnect();
            self._outputAnalyser2.disconnect();
            return;
        }
        self._inputAnalyser.getByteFrequencyData(inputDataArray);
        var inputVolume = self.util.average(inputDataArray);
        self._inputAnalyser2.getByteFrequencyData(inputDataArray);
        var inputVolume2 = self.util.average(inputDataArray);
        self._outputAnalyser.getByteFrequencyData(outputDataArray);
        var outputVolume = self.util.average(outputDataArray);
        self._outputAnalyser2.getByteFrequencyData(outputDataArray);
        var outputVolume2 = self.util.average(outputDataArray);
        self.onvolume(inputVolume / 255, outputVolume / 255, inputVolume2, outputVolume2);
        setTimeout(emitVolume, $eebba6bea300b063$var$VOLUME_INTERVAL_MS);
    }, $eebba6bea300b063$var$VOLUME_INTERVAL_MS);
};
$eebba6bea300b063$var$PeerConnection.prototype._stopStream = function _stopStream() {
    // We shouldn't stop the tracks if they were not created inside
    //   this PeerConnection.
    if (!this._shouldManageStream) return;
    this._audioHelper._stopDefaultInputDeviceStream();
};
/**
 * Update the stream source with the new input audio stream.
 * @param {MediaStream} stream
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._updateInputStreamSource = function(stream) {
    if (this._inputStreamSource) this._inputStreamSource.disconnect();
    try {
        this._inputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._inputStreamSource.connect(this._inputAnalyser);
        this._inputStreamSource.connect(this._inputAnalyser2);
    } catch (ex) {
        this._log.warn("Unable to update input MediaStreamSource", ex);
        this._inputStreamSource = null;
    }
};
/**
 * Update the stream source with the new ouput audio stream.
 * @param {MediaStream} stream
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._updateOutputStreamSource = function(stream) {
    if (this._outputStreamSource) this._outputStreamSource.disconnect();
    try {
        this._outputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._outputStreamSource.connect(this._outputAnalyser);
        this._outputStreamSource.connect(this._outputAnalyser2);
    } catch (ex) {
        this._log.warn("Unable to update output MediaStreamSource", ex);
        this._outputStreamSource = null;
    }
};
/**
 * Replace the tracks of the current stream with new tracks. We do this rather than replacing the
 *   whole stream because AnalyzerNodes are bound to a stream.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksFromStream = function(shouldClone, newStream) {
    return this._isUnifiedPlan ? this._setInputTracksForUnifiedPlan(shouldClone, newStream) : this._setInputTracksForPlanB(shouldClone, newStream);
};
/**
 * Replace the tracks of the current stream with new tracks using the 'plan-b' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksForPlanB = function(shouldClone, newStream) {
    var _this = this;
    if (!newStream) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Can not set input stream to null while in a call"));
    if (!newStream.getAudioTracks().length) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Supplied input stream has no audio tracks"));
    var localStream = this.stream;
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
    else {
        this._stopStream();
        $eebba6bea300b063$var$removeStream(this.version.pc, localStream);
        localStream.getAudioTracks().forEach(localStream.removeTrack, localStream);
        newStream.getAudioTracks().forEach(localStream.addTrack, localStream);
        $eebba6bea300b063$var$addStream(this.version.pc, newStream);
        this._updateInputStreamSource(this.stream);
    }
    // Apply mute settings to new input track
    this.mute(this.isMuted);
    if (!this.version) return Promise.resolve(this.stream);
    return new Promise(function(resolve, reject) {
        _this.version.createOffer(_this.options.maxAverageBitrate, _this.codecPreferences, {
            audio: true
        }, function() {
            _this.version.processAnswer(_this.codecPreferences, _this._answerSdp, function() {
                resolve(_this.stream);
            }, reject);
        }, reject);
    });
};
/**
 * Replace the tracks of the current stream with new tracks using the 'unified-plan' method.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setInputTracksForUnifiedPlan = function(shouldClone, newStream) {
    var _this = this;
    if (!newStream) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Can not set input stream to null while in a call"));
    if (!newStream.getAudioTracks().length) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Supplied input stream has no audio tracks"));
    var localStream = this.stream;
    var getStreamPromise = function() {
        // Apply mute settings to new input track
        _this.mute(_this.isMuted);
        return Promise.resolve(_this.stream);
    };
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
    else {
        // If the call was started with gUM, and we are now replacing that track with an
        // external stream's tracks, we should stop the old managed track.
        if (this._shouldManageStream) this._stopStream();
        if (!this._sender) this._sender = this.version.pc.getSenders()[0];
        return this._sender.replaceTrack(newStream.getAudioTracks()[0]).then(function() {
            _this._updateInputStreamSource(newStream);
            _this.stream = shouldClone ? $eebba6bea300b063$var$cloneStream(newStream) : newStream;
            return getStreamPromise();
        });
    }
    return getStreamPromise();
};
$eebba6bea300b063$var$PeerConnection.prototype._onInputDevicesChanged = function() {
    if (!this.stream) return;
    // If all of our active tracks are ended, then our active input was lost
    var activeInputWasLost = this.stream.getAudioTracks().every(function(track) {
        return track.readyState === "ended";
    });
    // We only want to act if we manage the stream in PeerConnection (It was created
    // here, rather than passed in.)
    if (activeInputWasLost && this._shouldManageStream) this.openDefaultDeviceWithConstraints({
        audio: true
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._onIceGatheringFailure = function(type) {
    this._hasIceGatheringFailures = true;
    this.onicegatheringfailure(type);
};
$eebba6bea300b063$var$PeerConnection.prototype._onMediaConnectionStateChange = function(newState) {
    var previousState = this._iceState;
    if (previousState === newState || newState !== "connected" && newState !== "disconnected" && newState !== "failed") return;
    this._iceState = newState;
    var message;
    switch(newState){
        case "connected":
            if (previousState === "disconnected" || previousState === "failed") {
                message = "ICE liveliness check succeeded. Connection with Twilio restored";
                this._log.info(message);
                this.onreconnected(message);
            } else {
                message = "Media connection established.";
                this._log.info(message);
                this.onconnected(message);
            }
            this._stopIceGatheringTimeout();
            this._hasIceGatheringFailures = false;
            break;
        case "disconnected":
            message = "ICE liveliness check failed. May be having trouble connecting to Twilio";
            this._log.warn(message);
            this.ondisconnected(message);
            break;
        case "failed":
            message = "Connection with Twilio was interrupted.";
            this._log.warn(message);
            this.onfailed(message);
            break;
    }
};
$eebba6bea300b063$var$PeerConnection.prototype._setSinkIds = function(sinkIds) {
    if (!this._isSinkSupported) return Promise.reject(new $9b99a7197ac9a7b1$exports.NotSupportedError("Audio output selection is not supported by this browser"));
    this.sinkIds = new Set(sinkIds.forEach ? sinkIds : [
        sinkIds
    ]);
    return this.version ? this._updateAudioOutputs() : Promise.resolve();
};
/**
 * Start timeout for ICE Gathering
 */ $eebba6bea300b063$var$PeerConnection.prototype._startIceGatheringTimeout = function startIceGatheringTimeout() {
    var _this = this;
    this._stopIceGatheringTimeout();
    this._iceGatheringTimeoutId = setTimeout(function() {
        _this._onIceGatheringFailure($eebba6bea300b063$var$ICE_GATHERING_FAIL_TIMEOUT);
    }, $eebba6bea300b063$var$ICE_GATHERING_TIMEOUT);
};
/**
 * Stop timeout for ICE Gathering
 */ $eebba6bea300b063$var$PeerConnection.prototype._stopIceGatheringTimeout = function stopIceGatheringTimeout() {
    clearInterval(this._iceGatheringTimeoutId);
};
$eebba6bea300b063$var$PeerConnection.prototype._updateAudioOutputs = function updateAudioOutputs() {
    var addedOutputIds = Array.from(this.sinkIds).filter(function(id) {
        return !this.outputs.has(id);
    }, this);
    var removedOutputIds = Array.from(this.outputs.keys()).filter(function(id) {
        return !this.sinkIds.has(id);
    }, this);
    var self = this;
    var createOutputPromises = addedOutputIds.map(this._createAudioOutput, this);
    return Promise.all(createOutputPromises).then(function() {
        return Promise.all(removedOutputIds.map(self._removeAudioOutput, self));
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._createAudio = function createAudio(arr) {
    var audio = new Audio(arr);
    this.onaudio(audio);
    return audio;
};
$eebba6bea300b063$var$PeerConnection.prototype._createAudioOutput = function createAudioOutput(id) {
    var dest = null;
    if (this._mediaStreamSource) {
        dest = this._audioContext.createMediaStreamDestination();
        this._mediaStreamSource.connect(dest);
    }
    var audio = this._createAudio();
    $eebba6bea300b063$var$setAudioSource(audio, dest && dest.stream ? dest.stream : this.pcStream);
    var self = this;
    return audio.setSinkId(id).then(function() {
        return audio.play();
    }).then(function() {
        self.outputs.set(id, {
            audio: audio,
            dest: dest
        });
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._removeAudioOutputs = function removeAudioOutputs() {
    if (this._masterAudio && typeof this._masterAudioDeviceId !== "undefined") {
        this._disableOutput(this, this._masterAudioDeviceId);
        this.outputs.delete(this._masterAudioDeviceId);
        this._masterAudioDeviceId = null;
        // Release the audio resources before deleting the audio
        if (!this._masterAudio.paused) this._masterAudio.pause();
        if (typeof this._masterAudio.srcObject !== "undefined") this._masterAudio.srcObject = null;
        else this._masterAudio.src = "";
        this._masterAudio = null;
    }
    return Array.from(this.outputs.keys()).map(this._removeAudioOutput, this);
};
$eebba6bea300b063$var$PeerConnection.prototype._disableOutput = function disableOutput(pc, id) {
    var output = pc.outputs.get(id);
    if (!output) return;
    if (output.audio) {
        output.audio.pause();
        output.audio.src = "";
    }
    if (output.dest) output.dest.disconnect();
};
/**
 * Disable a non-master output, and update the master output to assume its state. This
 *   is called when the device ID assigned to the master output has been removed from
 *   active devices. We can not simply remove the master audio output, so we must
 *   instead reassign it.
 * @private
 * @param {PeerConnection} pc
 * @param {string} masterId - The current device ID assigned to the master audio element.
 */ $eebba6bea300b063$var$PeerConnection.prototype._reassignMasterOutput = function reassignMasterOutput(pc, masterId) {
    var masterOutput = pc.outputs.get(masterId);
    pc.outputs.delete(masterId);
    var self = this;
    var activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    var idToReplace = typeof activeDeviceId === "string" ? activeDeviceId : "default";
    return masterOutput.audio.setSinkId(idToReplace).then(function() {
        self._disableOutput(pc, idToReplace);
        pc.outputs.set(idToReplace, masterOutput);
        pc._masterAudioDeviceId = idToReplace;
    }).catch(function rollback() {
        pc.outputs.set(masterId, masterOutput);
        self._log.info("Could not reassign master output. Attempted to roll back.");
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._removeAudioOutput = function removeAudioOutput(id) {
    if (this._masterAudioDeviceId === id) return this._reassignMasterOutput(this, id);
    this._disableOutput(this, id);
    this.outputs.delete(id);
    return Promise.resolve();
};
/**
 * Use an AudioContext to potentially split our audio output stream to multiple
 *   audio devices. This is only available to browsers with AudioContext and
 *   HTMLAudioElement.setSinkId() available. We save the source stream in
 *   _masterAudio, and use it for one of the active audio devices. We keep
 *   track of its ID because we must replace it if we lose its initial device.
 */ $eebba6bea300b063$var$PeerConnection.prototype._onAddTrack = function onAddTrack(pc, stream) {
    var audio = pc._masterAudio = this._createAudio();
    $eebba6bea300b063$var$setAudioSource(audio, stream);
    audio.play();
    // Assign the initial master audio element to a random active output device
    var activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    var deviceId = typeof activeDeviceId === "string" ? activeDeviceId : "default";
    pc._masterAudioDeviceId = deviceId;
    pc.outputs.set(deviceId, {
        audio: audio
    });
    try {
        pc._mediaStreamSource = pc._audioContext.createMediaStreamSource(stream);
    } catch (ex) {
        this._log.warn("Unable to create a MediaStreamSource from onAddTrack", ex);
        this._mediaStreamSource = null;
    }
    pc.pcStream = stream;
    pc._updateAudioOutputs();
};
/**
 * Use a single audio element to play the audio output stream. This does not
 *   support multiple output devices, and is a fallback for when AudioContext
 *   and/or HTMLAudioElement.setSinkId() is not available to the client.
 */ $eebba6bea300b063$var$PeerConnection.prototype._fallbackOnAddTrack = function fallbackOnAddTrack(pc, stream) {
    var audio = document && document.createElement("audio");
    audio.autoplay = true;
    if (!$eebba6bea300b063$var$setAudioSource(audio, stream)) pc._log.info("Error attaching stream to element.");
    pc.outputs.set("default", {
        audio: audio
    });
};
$eebba6bea300b063$var$PeerConnection.prototype._setEncodingParameters = function(enableDscp) {
    if (!enableDscp || !this._sender || typeof this._sender.getParameters !== "function" || typeof this._sender.setParameters !== "function") return;
    var params = this._sender.getParameters();
    if (!params.priority && !(params.encodings && params.encodings.length)) return;
    // This is how MDN's RTPSenderParameters defines priority
    params.priority = "high";
    // And this is how it's currently implemented in Chrome M72+
    if (params.encodings && params.encodings.length) params.encodings.forEach(function(encoding) {
        encoding.priority = "high";
        encoding.networkPriority = "high";
    });
    this._sender.setParameters(params);
};
$eebba6bea300b063$var$PeerConnection.prototype._setupPeerConnection = function(rtcConfiguration) {
    var _this = this;
    var self = this;
    var version = new (this.options.rtcpcFactory || $c1a056b32fadc499$exports.default)({
        RTCPeerConnection: this.options.RTCPeerConnection
    });
    version.create(rtcConfiguration);
    $eebba6bea300b063$var$addStream(version.pc, this.stream);
    var eventName = "ontrack" in version.pc ? "ontrack" : "onaddstream";
    version.pc[eventName] = function(event) {
        var stream = self._remoteStream = event.stream || event.streams[0];
        if (typeof version.pc.getSenders === "function") _this._sender = version.pc.getSenders()[0];
        if (self._isSinkSupported) self._onAddTrack(self, stream);
        else self._fallbackOnAddTrack(self, stream);
        self._startPollingVolume();
    };
    return version;
};
$eebba6bea300b063$var$PeerConnection.prototype._maybeSetIceAggressiveNomination = function(sdp) {
    return this.options.forceAggressiveIceNomination ? $5daed6d4af7231db$exports.setIceAggressiveNomination(sdp) : sdp;
};
$eebba6bea300b063$var$PeerConnection.prototype._setupChannel = function() {
    var _this = this;
    var pc = this.version.pc;
    // Chrome 25 supports onopen
    this.version.pc.onopen = function() {
        _this.status = "open";
        _this.onopen();
    };
    // Chrome 26 doesn't support onopen so must detect state change
    this.version.pc.onstatechange = function() {
        if (_this.version.pc && _this.version.pc.readyState === "stable") {
            _this.status = "open";
            _this.onopen();
        }
    };
    // Chrome 27 changed onstatechange to onsignalingstatechange
    this.version.pc.onsignalingstatechange = function() {
        var state = pc.signalingState;
        _this._log.info('signalingState is "' + state + '"');
        if (_this.version.pc && _this.version.pc.signalingState === "stable") {
            _this.status = "open";
            _this.onopen();
        }
        _this.onsignalingstatechange(pc.signalingState);
    };
    // Chrome 72+
    pc.onconnectionstatechange = function(event) {
        var state = pc.connectionState;
        if (!state && event && event.target) {
            // VDI environment
            var targetPc = event.target;
            state = targetPc.connectionState || targetPc.connectionState_;
            _this._log.info("pc.connectionState not detected. Using target PC. State=" + state);
        }
        if (!state) _this._log.warn('onconnectionstatechange detected but state is "' + state + '"');
        else _this._log.info('pc.connectionState is "' + state + '"');
        _this.onpcconnectionstatechange(state);
        _this._onMediaConnectionStateChange(state);
    };
    pc.onicecandidate = function(event) {
        var candidate = event.candidate;
        if (candidate) {
            _this._hasIceCandidates = true;
            _this.onicecandidate(candidate);
            _this._setupRTCIceTransportListener();
        }
        _this._log.info("ICE Candidate: " + JSON.stringify(candidate));
    };
    pc.onicegatheringstatechange = function() {
        var state = pc.iceGatheringState;
        if (state === "gathering") _this._startIceGatheringTimeout();
        else if (state === "complete") {
            _this._stopIceGatheringTimeout();
            // Fail if no candidates found
            if (!_this._hasIceCandidates) _this._onIceGatheringFailure($eebba6bea300b063$var$ICE_GATHERING_FAIL_NONE);
            // There was a failure mid-gathering phase. We want to start our timer and issue
            // an ice restart if we don't get connected after our timeout
            if (_this._hasIceCandidates && _this._hasIceGatheringFailures) _this._startIceGatheringTimeout();
        }
        _this._log.info('pc.iceGatheringState is "' + pc.iceGatheringState + '"');
        _this.onicegatheringstatechange(state);
    };
    pc.oniceconnectionstatechange = function() {
        _this._log.info('pc.iceConnectionState is "' + pc.iceConnectionState + '"');
        _this.oniceconnectionstatechange(pc.iceConnectionState);
        _this._onMediaConnectionStateChange(pc.iceConnectionState);
    };
};
$eebba6bea300b063$var$PeerConnection.prototype._initializeMediaStream = function(rtcConfiguration) {
    // if mediastream already open then do nothing
    if (this.status === "open") return false;
    if (this.pstream.status === "disconnected") {
        this.onerror({
            info: {
                code: 31000,
                message: "Cannot establish connection. Client is disconnected",
                twilioError: new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionDisconnected()
            }
        });
        this.close();
        return false;
    }
    this.version = this._setupPeerConnection(rtcConfiguration);
    this._setupChannel();
    return true;
};
/**
 * Remove reconnection-related listeners
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._removeReconnectionListeners = function() {
    if (this.pstream) {
        this.pstream.removeListener("answer", this._onAnswerOrRinging);
        this.pstream.removeListener("hangup", this._onHangup);
    }
};
/**
 * Setup a listener for RTCDtlsTransport to capture state changes events
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setupRTCDtlsTransportListener = function() {
    var _this = this;
    var dtlsTransport = this.getRTCDtlsTransport();
    if (!dtlsTransport || dtlsTransport.onstatechange) return;
    var handler = function() {
        _this._log.info('dtlsTransportState is "' + dtlsTransport.state + '"');
        _this.ondtlstransportstatechange(dtlsTransport.state);
    };
    // Publish initial state
    handler();
    dtlsTransport.onstatechange = handler;
};
/**
 * Setup a listener for RTCIceTransport to capture selected candidate pair changes
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype._setupRTCIceTransportListener = function() {
    var _this = this;
    var iceTransport = this._getRTCIceTransport();
    if (!iceTransport || iceTransport.onselectedcandidatepairchange) return;
    iceTransport.onselectedcandidatepairchange = function() {
        return _this.onselectedcandidatepairchange(iceTransport.getSelectedCandidatePair());
    };
};
/**
 * Restarts ICE for the current connection
 * ICE Restart failures are ignored. Retries are managed in Connection
 * @private
 */ $eebba6bea300b063$var$PeerConnection.prototype.iceRestart = function() {
    var _this = this;
    this._log.info("Attempting to restart ICE...");
    this._hasIceCandidates = false;
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        iceRestart: true
    }).then(function() {
        _this._removeReconnectionListeners();
        _this._onAnswerOrRinging = function(payload) {
            _this._removeReconnectionListeners();
            if (!payload.sdp || _this.version.pc.signalingState !== "have-local-offer") {
                var message = "Invalid state or param during ICE Restart:" + ("hasSdp:" + !!payload.sdp + ", signalingState:" + _this.version.pc.signalingState);
                _this._log.warn(message);
                return;
            }
            var sdp = _this._maybeSetIceAggressiveNomination(payload.sdp);
            _this._answerSdp = sdp;
            if (_this.status !== "closed") _this.version.processAnswer(_this.codecPreferences, sdp, null, function(err) {
                var message = err && err.message ? err.message : err;
                _this._log.error("Failed to process answer during ICE Restart. Error: " + message);
            });
        };
        _this._onHangup = function() {
            _this._log.info("Received hangup during ICE Restart");
            _this._removeReconnectionListeners();
        };
        _this.pstream.on("answer", _this._onAnswerOrRinging);
        _this.pstream.on("hangup", _this._onHangup);
        _this.pstream.reinvite(_this.version.getSDP(), _this.callSid);
    }).catch(function(err) {
        var message = err && err.message ? err.message : err;
        _this._log.error("Failed to createOffer during ICE Restart. Error: " + message);
        // CreateOffer failures doesn't transition ice state to failed
        // We need trigger it so it can be picked up by retries
        _this.onfailed(message);
    });
};
$eebba6bea300b063$var$PeerConnection.prototype.makeOutgoingCall = function(params, signalingReconnectToken, callsid, rtcConfiguration, onMediaStarted) {
    var _this = this;
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    var self = this;
    this.callSid = callsid;
    function onAnswerSuccess() {
        if (self.options) self._setEncodingParameters(self.options.dscp);
        onMediaStarted(self.version.pc);
    }
    function onAnswerError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error processing answer: " + errMsg,
                twilioError: new $9b99a7197ac9a7b1$exports.MediaErrors.ClientRemoteDescFailed()
            }
        });
    }
    this._onAnswerOrRinging = function(payload) {
        if (!payload.sdp) return;
        var sdp = _this._maybeSetIceAggressiveNomination(payload.sdp);
        self._answerSdp = sdp;
        if (self.status !== "closed") self.version.processAnswer(_this.codecPreferences, sdp, onAnswerSuccess, onAnswerError);
        self.pstream.removeListener("answer", self._onAnswerOrRinging);
        self.pstream.removeListener("ringing", self._onAnswerOrRinging);
    };
    this.pstream.on("answer", this._onAnswerOrRinging);
    this.pstream.on("ringing", this._onAnswerOrRinging);
    function onOfferSuccess() {
        if (self.status !== "closed") {
            if (signalingReconnectToken) self.pstream.reconnect(self.version.getSDP(), self.callSid, signalingReconnectToken);
            else self.pstream.invite(self.version.getSDP(), self.callSid, params);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onOfferError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error creating the offer: " + errMsg,
                twilioError: new $9b99a7197ac9a7b1$exports.MediaErrors.ClientLocalDescFailed()
            }
        });
    }
    this.version.createOffer(this.options.maxAverageBitrate, this.codecPreferences, {
        audio: true
    }, onOfferSuccess, onOfferError);
};
$eebba6bea300b063$var$PeerConnection.prototype.answerIncomingCall = function(callSid, sdp, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    sdp = this._maybeSetIceAggressiveNomination(sdp);
    this._answerSdp = sdp.replace(/^a=setup:actpass$/gm, "a=setup:passive");
    this.callSid = callSid;
    var self = this;
    function onAnswerSuccess() {
        if (self.status !== "closed") {
            self.pstream.answer(self.version.getSDP(), callSid);
            if (self.options) self._setEncodingParameters(self.options.dscp);
            onMediaStarted(self.version.pc);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onAnswerError(err) {
        var errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: "Error creating the answer: " + errMsg,
                twilioError: new $9b99a7197ac9a7b1$exports.MediaErrors.ClientRemoteDescFailed()
            }
        });
    }
    this.version.processSDP(this.options.maxAverageBitrate, this.codecPreferences, sdp, {
        audio: true
    }, onAnswerSuccess, onAnswerError);
};
$eebba6bea300b063$var$PeerConnection.prototype.close = function() {
    if (this.version && this.version.pc) {
        if (this.version.pc.signalingState !== "closed") this.version.pc.close();
        this.version.pc = null;
    }
    if (this.stream) {
        this.mute(false);
        this._stopStream();
    }
    this.stream = null;
    this._removeReconnectionListeners();
    this._stopIceGatheringTimeout();
    Promise.all(this._removeAudioOutputs()).catch(function() {
    // We don't need to alert about failures here.
    });
    if (this._mediaStreamSource) this._mediaStreamSource.disconnect();
    if (this._inputAnalyser) this._inputAnalyser.disconnect();
    if (this._outputAnalyser) this._outputAnalyser.disconnect();
    if (this._inputAnalyser2) this._inputAnalyser2.disconnect();
    if (this._outputAnalyser2) this._outputAnalyser2.disconnect();
    this.status = "closed";
    this.onclose();
};
$eebba6bea300b063$var$PeerConnection.prototype.reject = function(callSid) {
    this.callSid = callSid;
};
$eebba6bea300b063$var$PeerConnection.prototype.ignore = function(callSid) {
    this.callSid = callSid;
};
/**
 * Mute or unmute input audio. If the stream is not yet present, the setting
 *   is saved and applied to future streams/tracks.
 * @params {boolean} shouldMute - Whether the input audio should
 *   be muted or unmuted.
 */ $eebba6bea300b063$var$PeerConnection.prototype.mute = function(shouldMute) {
    this.isMuted = shouldMute;
    if (!this.stream) return;
    if (this._sender && this._sender.track) this._sender.track.enabled = !shouldMute;
    else {
        var audioTracks = typeof this.stream.getAudioTracks === "function" ? this.stream.getAudioTracks() : this.stream.audioTracks;
        audioTracks.forEach(function(track) {
            track.enabled = !shouldMute;
        });
    }
};
/**
 * Get or create an RTCDTMFSender for the first local audio MediaStreamTrack
 * we can get from the RTCPeerConnection. Return null if unsupported.
 * @instance
 * @returns ?RTCDTMFSender
 */ $eebba6bea300b063$var$PeerConnection.prototype.getOrCreateDTMFSender = function getOrCreateDTMFSender() {
    if (this._dtmfSender || this._dtmfSenderUnsupported) return this._dtmfSender || null;
    var self = this;
    var pc = this.version.pc;
    if (!pc) {
        this._log.warn("No RTCPeerConnection available to call createDTMFSender on");
        return null;
    }
    if (typeof pc.getSenders === "function" && (typeof RTCDTMFSender === "function" || typeof RTCDtmfSender === "function")) {
        var chosenSender = pc.getSenders().find(function(sender) {
            return sender.dtmf;
        });
        if (chosenSender) {
            this._log.info("Using RTCRtpSender#dtmf");
            this._dtmfSender = chosenSender.dtmf;
            return this._dtmfSender;
        }
    }
    if (typeof pc.createDTMFSender === "function" && typeof pc.getLocalStreams === "function") {
        var track = pc.getLocalStreams().map(function(stream) {
            var tracks = self._getAudioTracks(stream);
            return tracks && tracks[0];
        })[0];
        if (!track) {
            this._log.warn("No local audio MediaStreamTrack available on the RTCPeerConnection to pass to createDTMFSender");
            return null;
        }
        this._log.info("Creating RTCDTMFSender");
        this._dtmfSender = pc.createDTMFSender(track);
        return this._dtmfSender;
    }
    this._log.info("RTCPeerConnection does not support RTCDTMFSender");
    this._dtmfSenderUnsupported = true;
    return null;
};
/**
 * Get the RTCDtlTransport object from the PeerConnection
 * @returns RTCDtlTransport
 */ $eebba6bea300b063$var$PeerConnection.prototype.getRTCDtlsTransport = function getRTCDtlsTransport() {
    var sender = this.version && this.version.pc && typeof this.version.pc.getSenders === "function" && this.version.pc.getSenders()[0];
    return sender && sender.transport || null;
};
$eebba6bea300b063$var$PeerConnection.prototype._canStopMediaStreamTrack = function() {
    return typeof MediaStreamTrack.prototype.stop === "function";
};
$eebba6bea300b063$var$PeerConnection.prototype._getAudioTracks = function(stream) {
    return typeof stream.getAudioTracks === "function" ? stream.getAudioTracks() : stream.audioTracks;
};
/**
 * Get the RTCIceTransport object from the PeerConnection
 * @returns RTCIceTransport
 */ $eebba6bea300b063$var$PeerConnection.prototype._getRTCIceTransport = function _getRTCIceTransport() {
    var dtlsTransport = this.getRTCDtlsTransport();
    return dtlsTransport && dtlsTransport.iceTransport || null;
};
// Is PeerConnection.protocol used outside of our SDK? We should remove this if not.
$eebba6bea300b063$var$PeerConnection.protocol = function() {
    return $c1a056b32fadc499$exports.default.test() ? new $c1a056b32fadc499$exports.default() : null;
}();
function $eebba6bea300b063$var$addStream(pc, stream) {
    if (typeof pc.addTrack === "function") stream.getAudioTracks().forEach(function(track) {
        // The second parameters, stream, should not be necessary per the latest editor's
        //   draft, but FF requires it. https://bugzilla.mozilla.org/show_bug.cgi?id=1231414
        pc.addTrack(track, stream);
    });
    else pc.addStream(stream);
}
function $eebba6bea300b063$var$cloneStream(oldStream) {
    var newStream = typeof MediaStream !== "undefined" ? new MediaStream() : new webkitMediaStream();
    oldStream.getAudioTracks().forEach(newStream.addTrack, newStream);
    return newStream;
}
function $eebba6bea300b063$var$removeStream(pc, stream) {
    if (typeof pc.removeTrack === "function") pc.getSenders().forEach(function(sender) {
        pc.removeTrack(sender);
    });
    else pc.removeStream(stream);
}
/**
 * Set the source of an HTMLAudioElement to the specified MediaStream
 * @param {HTMLAudioElement} audio
 * @param {MediaStream} stream
 * @returns {boolean} Whether the audio source was set successfully
 */ function $eebba6bea300b063$var$setAudioSource(audio, stream) {
    if (typeof audio.srcObject !== "undefined") audio.srcObject = stream;
    else if (typeof audio.mozSrcObject !== "undefined") audio.mozSrcObject = stream;
    else if (typeof audio.src !== "undefined") {
        var _window = audio.options.window || window;
        audio.src = (_window.URL || _window.webkitURL).createObjectURL(stream);
    } else return false;
    return true;
}
$eebba6bea300b063$var$PeerConnection.enabled = $c1a056b32fadc499$exports.default.test();
$eebba6bea300b063$exports.default = $eebba6bea300b063$var$PeerConnection;


$44123d2d42b91b4b$exports.PeerConnection = $eebba6bea300b063$exports.default;

function $44123d2d42b91b4b$var$enabled() {
    return $c1a056b32fadc499$exports.default.test();
}
$44123d2d42b91b4b$exports.enabled = $44123d2d42b91b4b$var$enabled;
function $44123d2d42b91b4b$var$getMediaEngine() {
    return typeof RTCIceGatherer !== "undefined" ? "ORTC" : "WebRTC";
}
$44123d2d42b91b4b$exports.getMediaEngine = $44123d2d42b91b4b$var$getMediaEngine;


var $8484cd27499b985d$exports = {};
"use strict";
Object.defineProperty($8484cd27499b985d$exports, "__esModule", {
    value: true
});


function $8484cd27499b985d$var$getUserMedia(constraints, options) {
    options = options || {};
    options.util = options.util || $b060d15305f18a68$exports;
    options.navigator = options.navigator || (typeof navigator !== "undefined" ? navigator : null);
    return new Promise(function(resolve, reject) {
        if (!options.navigator) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("getUserMedia is not supported");
        switch("function"){
            case typeof (options.navigator.mediaDevices && options.navigator.mediaDevices.getUserMedia):
                return resolve(options.navigator.mediaDevices.getUserMedia(constraints));
            case typeof options.navigator.webkitGetUserMedia:
                return options.navigator.webkitGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.mozGetUserMedia:
                return options.navigator.mozGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.getUserMedia:
                return options.navigator.getUserMedia(constraints, resolve, reject);
            default:
                throw new $9b99a7197ac9a7b1$exports.NotSupportedError("getUserMedia is not supported");
        }
    }).catch(function(e) {
        throw options.util.isFirefox() && e.name === "NotReadableError" ? new $9b99a7197ac9a7b1$exports.NotSupportedError("Firefox does not currently support opening multiple audio input trackssimultaneously, even across different tabs.\nRelated Bugzilla thread: https://bugzilla.mozilla.org/show_bug.cgi?id=1299324") : e;
    });
}
$8484cd27499b985d$exports.default = $8484cd27499b985d$var$getUserMedia;


var $bed8333b6111cc0c$exports = {};
"use strict";
Object.defineProperty($bed8333b6111cc0c$exports, "__esModule", {
    value: true
});
var $5e1a1dd2be123335$exports = {};
"use strict";
var $5e1a1dd2be123335$var$__awaiter = $5e1a1dd2be123335$exports && $5e1a1dd2be123335$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5e1a1dd2be123335$var$__generator = $5e1a1dd2be123335$exports && $5e1a1dd2be123335$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($5e1a1dd2be123335$exports, "__esModule", {
    value: true
});
$5e1a1dd2be123335$exports.AsyncQueue = void 0;
var $7a0af5df212bae23$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty($7a0af5df212bae23$exports, "__esModule", {
    value: true
});
/**
 * Deferred Promise
 */ var $7a0af5df212bae23$var$Deferred = /** @class */ function() {
    /**
     * @constructor
     */ function Deferred() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        /**
         * @returns The {@link Deferred} Promise
         */ get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Rejects this promise
     */ Deferred.prototype.reject = function(reason) {
        this._reject(reason);
    };
    /**
     * Resolves this promise
     */ Deferred.prototype.resolve = function(value) {
        this._resolve(value);
    };
    return Deferred;
}();
$7a0af5df212bae23$exports.default = $7a0af5df212bae23$var$Deferred;


/**
 * Queue async operations and executes them synchronously.
 */ var $5e1a1dd2be123335$var$AsyncQueue = /** @class */ function() {
    function AsyncQueue() {
        /**
         * The list of async operations in this queue
         */ this._operations = [];
    }
    /**
     * Adds the async operation to the queue
     * @param callback An async callback that returns a promise
     * @returns A promise that will get resolved or rejected after executing the callback
     */ AsyncQueue.prototype.enqueue = function(callback) {
        var hasPending = !!this._operations.length;
        var deferred = new $7a0af5df212bae23$exports.default();
        this._operations.push({
            deferred: deferred,
            callback: callback
        });
        if (!hasPending) this._processQueue();
        return deferred.promise;
    };
    /**
     * Start processing the queue. This executes the first item and removes it after.
     * Then do the same for next items until the queue is emptied.
     */ AsyncQueue.prototype._processQueue = function() {
        return $5e1a1dd2be123335$var$__awaiter(this, void 0, void 0, function() {
            var _a, deferred, callback, result, error, hasResolved, e_1;
            return $5e1a1dd2be123335$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this._operations.length) return [
                            3 /*break*/ ,
                            5
                        ];
                        _a = this._operations[0], deferred = _a.deferred, callback = _a.callback;
                        result = void 0;
                        error = void 0;
                        hasResolved = void 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback()
                        ];
                    case 2:
                        result = _b.sent();
                        hasResolved = true;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        error = e_1;
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        // Remove the item
                        this._operations.shift();
                        if (hasResolved) deferred.resolve(result);
                        else deferred.reject(error);
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AsyncQueue;
}();
$5e1a1dd2be123335$exports.AsyncQueue = $5e1a1dd2be123335$var$AsyncQueue;


var $c4e9fe229c935929$exports = {};
"use strict";
var $c4e9fe229c935929$var$__extends = $c4e9fe229c935929$exports && $c4e9fe229c935929$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c4e9fe229c935929$var$__awaiter = $c4e9fe229c935929$exports && $c4e9fe229c935929$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c4e9fe229c935929$var$__generator = $c4e9fe229c935929$exports && $c4e9fe229c935929$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($c4e9fe229c935929$exports, "__esModule", {
    value: true
});
var $bf4286f23b7e4663$exports = {};
"use strict";
Object.defineProperty($bf4286f23b7e4663$exports, "__esModule", {
    value: true
});
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ // @ts-nocheck
var $bf4286f23b7e4663$var$Deferred = /** @class */ function() {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "reject", {
        get: function() {
            return this._reject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Deferred.prototype, "resolve", {
        get: function() {
            return this._resolve;
        },
        enumerable: false,
        configurable: true
    });
    return Deferred;
}();
$bf4286f23b7e4663$exports.default = $bf4286f23b7e4663$var$Deferred;


var $8644b01a35e59d4d$exports = {};
"use strict";
var $8644b01a35e59d4d$var$__spreadArrays = $8644b01a35e59d4d$exports && $8644b01a35e59d4d$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($8644b01a35e59d4d$exports, "__esModule", {
    value: true
});

var $8644b01a35e59d4d$var$EventTarget = /** @class */ function() {
    function EventTarget() {
        this._eventEmitter = new $0bfd6a77e39eae31$exports.EventEmitter();
    }
    EventTarget.prototype.addEventListener = function(name, handler) {
        return this._eventEmitter.addListener(name, handler);
    };
    EventTarget.prototype.dispatchEvent = function(name) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        return (_a = this._eventEmitter).emit.apply(_a, $8644b01a35e59d4d$var$__spreadArrays([
            name
        ], args));
    };
    EventTarget.prototype.removeEventListener = function(name, handler) {
        return this._eventEmitter.removeListener(name, handler);
    };
    return EventTarget;
}();
$8644b01a35e59d4d$exports.default = $8644b01a35e59d4d$var$EventTarget;


/**
 * An {@link AudioPlayer} is an HTMLAudioElement-like object that uses AudioContext
 *   to circumvent browser limitations.
 * @private
 */ var $c4e9fe229c935929$var$AudioPlayer = /** @class */ function(_super) {
    $c4e9fe229c935929$var$__extends(AudioPlayer, _super);
    /**
     * @private
     */ function AudioPlayer(audioContext, srcOrOptions, options) {
        if (srcOrOptions === void 0) srcOrOptions = {};
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The AudioBufferSourceNode of the actively loaded sound. Null if a sound
         *   has not been loaded yet. This is re-used for each time the sound is
         *   played.
         */ _this._audioNode = null;
        /**
         * Whether or not the audio element should loop. If disabled during playback,
         *   playing continues until the sound ends and then stops looping.
         */ _this._loop = false;
        /**
         * An Array of deferred-like objects for each pending `play` Promise. When
         *   .pause() is called or .src is set, all pending play Promises are
         *   immediately rejected.
         */ _this._pendingPlayDeferreds = [];
        /**
         * The current sinkId of the device audio is being played through.
         */ _this._sinkId = "default";
        /**
         * The source URL of the sound to play. When set, the currently playing sound will stop.
         */ _this._src = "";
        if (typeof srcOrOptions !== "string") options = srcOrOptions;
        _this._audioContext = audioContext;
        _this._audioElement = new (options.AudioFactory || Audio)();
        _this._bufferPromise = _this._createPlayDeferred().promise;
        _this._destination = _this._audioContext.destination;
        _this._gainNode = _this._audioContext.createGain();
        _this._gainNode.connect(_this._destination);
        _this._XMLHttpRequest = options.XMLHttpRequestFactory || XMLHttpRequest;
        _this.addEventListener("canplaythrough", function() {
            _this._resolvePlayDeferreds();
        });
        if (typeof srcOrOptions === "string") _this.src = srcOrOptions;
        return _this;
    }
    Object.defineProperty(AudioPlayer.prototype, "destination", {
        get: function() {
            return this._destination;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "loop", {
        get: function() {
            return this._loop;
        },
        set: function(shouldLoop) {
            var self = this;
            function pauseAfterPlaythrough() {
                self._audioNode.removeEventListener("ended", pauseAfterPlaythrough);
                self.pause();
            }
            // If a sound is already looping, it should continue playing
            //   the current playthrough and then stop.
            if (!shouldLoop && this.loop && !this.paused) this._audioNode.addEventListener("ended", pauseAfterPlaythrough);
            this._loop = shouldLoop;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "muted", {
        /**
         * Whether the audio element is muted.
         */ get: function() {
            return this._gainNode.gain.value === 0;
        },
        set: function(shouldBeMuted) {
            this._gainNode.gain.value = shouldBeMuted ? 0 : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "paused", {
        /**
         * Whether the sound is paused. this._audioNode only exists when sound is playing;
         *   otherwise AudioPlayer is considered paused.
         */ get: function() {
            return this._audioNode === null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "src", {
        get: function() {
            return this._src;
        },
        set: function(src) {
            this._load(src);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "srcObject", {
        /**
         * The srcObject of the HTMLMediaElement
         */ get: function() {
            return this._audioElement.srcObject;
        },
        set: function(srcObject) {
            this._audioElement.srcObject = srcObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AudioPlayer.prototype, "sinkId", {
        get: function() {
            return this._sinkId;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Stop any ongoing playback and reload the source file.
     */ AudioPlayer.prototype.load = function() {
        this._load(this._src);
    };
    /**
     * Pause the audio coming from this AudioPlayer. This will reject any pending
     *   play Promises.
     */ AudioPlayer.prototype.pause = function() {
        if (this.paused) return;
        this._audioElement.pause();
        this._audioNode.stop();
        this._audioNode.disconnect(this._gainNode);
        this._audioNode = null;
        this._rejectPlayDeferreds(new Error("The play() request was interrupted by a call to pause()."));
    };
    /**
     * Play the sound. If the buffer hasn't loaded yet, wait for the buffer to load. If
     *   the source URL is not set yet, this Promise will remain pending until a source
     *   URL is set.
     */ AudioPlayer.prototype.play = function() {
        return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
            var buffer;
            var _this = this;
            return $c4e9fe229c935929$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.paused) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this._bufferPromise
                        ];
                    case 1:
                        _a.sent();
                        if (!this.paused) return [
                            2 /*return*/ 
                        ];
                        throw new Error("The play() request was interrupted by a call to pause().");
                    case 2:
                        this._audioNode = this._audioContext.createBufferSource();
                        this._audioNode.loop = this.loop;
                        this._audioNode.addEventListener("ended", function() {
                            if (_this._audioNode && _this._audioNode.loop) return;
                            _this.dispatchEvent("ended");
                        });
                        return [
                            4 /*yield*/ ,
                            this._bufferPromise
                        ];
                    case 3:
                        buffer = _a.sent();
                        if (this.paused) throw new Error("The play() request was interrupted by a call to pause().");
                        this._audioNode.buffer = buffer;
                        this._audioNode.connect(this._gainNode);
                        this._audioNode.start();
                        if (this._audioElement.srcObject) return [
                            2 /*return*/ ,
                            this._audioElement.play()
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Change which device the sound should play through.
     * @param sinkId - The sink of the device to play sound through.
     */ AudioPlayer.prototype.setSinkId = function(sinkId) {
        return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
            return $c4e9fe229c935929$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof this._audioElement.setSinkId !== "function") throw new Error("This browser does not support setSinkId.");
                        if (sinkId === this.sinkId) return [
                            2 /*return*/ 
                        ];
                        if (sinkId === "default") {
                            if (!this.paused) this._gainNode.disconnect(this._destination);
                            this._audioElement.srcObject = null;
                            this._destination = this._audioContext.destination;
                            this._gainNode.connect(this._destination);
                            this._sinkId = sinkId;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            this._audioElement.setSinkId(sinkId)
                        ];
                    case 1:
                        _a.sent();
                        if (this._audioElement.srcObject) return [
                            2 /*return*/ 
                        ];
                        this._gainNode.disconnect(this._audioContext.destination);
                        this._destination = this._audioContext.createMediaStreamDestination();
                        this._audioElement.srcObject = this._destination.stream;
                        this._sinkId = sinkId;
                        this._gainNode.connect(this._destination);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create a Deferred for a Promise that will be resolved when .src is set or rejected
     *   when .pause is called.
     */ AudioPlayer.prototype._createPlayDeferred = function() {
        var deferred = new $bf4286f23b7e4663$exports.default();
        this._pendingPlayDeferreds.push(deferred);
        return deferred;
    };
    /**
     * Stop current playback and load a sound file.
     * @param src - The source URL of the file to load
     */ AudioPlayer.prototype._load = function(src) {
        var _this = this;
        if (this._src && this._src !== src) this.pause();
        this._src = src;
        this._bufferPromise = new Promise(function(resolve, reject) {
            return $c4e9fe229c935929$var$__awaiter(_this, void 0, void 0, function() {
                var buffer;
                return $c4e9fe229c935929$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!src) return [
                                2 /*return*/ ,
                                this._createPlayDeferred().promise
                            ];
                            return [
                                4 /*yield*/ ,
                                $c4e9fe229c935929$var$bufferSound(this._audioContext, this._XMLHttpRequest, src)
                            ];
                        case 1:
                            buffer = _a.sent();
                            this.dispatchEvent("canplaythrough");
                            resolve(buffer);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    /**
     * Reject all deferreds for the Play promise.
     * @param reason
     */ AudioPlayer.prototype._rejectPlayDeferreds = function(reason) {
        var deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(function(_a) {
            var reject = _a.reject;
            return reject(reason);
        });
    };
    /**
     * Resolve all deferreds for the Play promise.
     * @param result
     */ AudioPlayer.prototype._resolvePlayDeferreds = function(result) {
        var deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(function(_a) {
            var resolve = _a.resolve;
            return resolve(result);
        });
    };
    return AudioPlayer;
}($8644b01a35e59d4d$exports.default);
/**
 * Use XMLHttpRequest to load the AudioBuffer of a remote audio asset.
 * @private
 * @param context - The AudioContext to use to decode the audio data
 * @param RequestFactory - The XMLHttpRequest factory to build
 * @param src - The URL of the audio asset to load.
 * @returns A Promise containing the decoded AudioBuffer.
 */ // tslint:disable-next-line:variable-name
function $c4e9fe229c935929$var$bufferSound(context, RequestFactory, src) {
    return $c4e9fe229c935929$var$__awaiter(this, void 0, void 0, function() {
        var request, event;
        return $c4e9fe229c935929$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    request = new RequestFactory();
                    request.open("GET", src, true);
                    request.responseType = "arraybuffer";
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            request.addEventListener("load", resolve);
                            request.send();
                        })
                    ];
                case 1:
                    event = _a.sent();
                    // Safari uses a callback here instead of a Promise.
                    try {
                        return [
                            2 /*return*/ ,
                            context.decodeAudioData(event.target.response)
                        ];
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve) {
                                context.decodeAudioData(event.target.response, resolve);
                            })
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
$c4e9fe229c935929$exports.default = $c4e9fe229c935929$var$AudioPlayer;



/**
 * @class
 * @param {string} name - Name of the sound
 * @param {string} url - URL of the sound
 * @param {Sound#ConstructorOptions} options
 * @property {boolean} isPlaying - Whether the Sound is currently playing audio.
 * @property {string} name - Name of the sound
 * @property {string} url - URL of the sound
 * @property {AudioContext} audioContext - The AudioContext to use if available for AudioPlayer.
 */ /**
 * @typedef {Object} Sound#ConstructorOptions
 * @property {number} [maxDuration=0] - The maximum length of time to play the sound
 *   before stopping it.
 * @property {Boolean} [shouldLoop=false] - Whether the sound should be looped.
 */ function $bed8333b6111cc0c$var$Sound(name, url, options) {
    if (!(this instanceof $bed8333b6111cc0c$var$Sound)) return new $bed8333b6111cc0c$var$Sound(name, url, options);
    if (!name || !url) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("name and url are required arguments");
    options = Object.assign({
        AudioFactory: typeof Audio !== "undefined" ? Audio : null,
        maxDuration: 0,
        shouldLoop: false
    }, options);
    options.AudioPlayer = options.audioContext ? $c4e9fe229c935929$exports.default.bind($c4e9fe229c935929$exports.default, options.audioContext) : options.AudioFactory;
    Object.defineProperties(this, {
        _Audio: {
            value: options.AudioPlayer
        },
        _activeEls: {
            value: new Map()
        },
        _isSinkSupported: {
            value: options.AudioFactory !== null && typeof options.AudioFactory.prototype.setSinkId === "function"
        },
        _maxDuration: {
            value: options.maxDuration
        },
        _maxDurationTimeout: {
            value: null,
            writable: true
        },
        _operations: {
            value: new $5e1a1dd2be123335$exports.AsyncQueue()
        },
        _playPromise: {
            value: null,
            writable: true
        },
        _shouldLoop: {
            value: options.shouldLoop
        },
        _sinkIds: {
            value: [
                "default"
            ]
        },
        isPlaying: {
            enumerable: true,
            get: function() {
                return !!this._playPromise;
            }
        },
        name: {
            enumerable: true,
            value: name
        },
        url: {
            enumerable: true,
            value: url
        }
    });
    if (this._Audio) // Play it (muted and should not loop) as soon as possible so that it does not get incorrectly caught by Chrome's
    // "gesture requirement for media playback" feature.
    // https://plus.google.com/+FrancoisBeaufort/posts/6PiJQqJzGqX
    this._play(true, false);
}
function $bed8333b6111cc0c$var$destroyAudioElement(audioElement) {
    if (audioElement) {
        audioElement.pause();
        audioElement.src = "";
        audioElement.srcObject = null;
        audioElement.load();
    }
}
/**
 * Plays the audio element that was initialized using the speficied sinkId
 */ $bed8333b6111cc0c$var$Sound.prototype._playAudioElement = function _playAudioElement(sinkId, isMuted, shouldLoop) {
    var _this = this;
    var audioElement = this._activeEls.get(sinkId);
    if (!audioElement) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError('sinkId: "' + sinkId + "\" doesn't have an audio element");
    audioElement.muted = !!isMuted;
    audioElement.loop = !!shouldLoop;
    return audioElement.play().then(function() {
        return audioElement;
    }).catch(function(reason) {
        $bed8333b6111cc0c$var$destroyAudioElement(audioElement);
        _this._activeEls.delete(sinkId);
        throw reason;
    });
};
/**
 * Start playing the sound. Will stop the currently playing sound first.
 * If it exists, the audio element that was initialized for the sinkId will be used
 */ $bed8333b6111cc0c$var$Sound.prototype._play = function _play(forceIsMuted, forceShouldLoop) {
    if (this.isPlaying) this._stop();
    if (this._maxDuration > 0) this._maxDurationTimeout = setTimeout(this._stop.bind(this), this._maxDuration);
    forceShouldLoop = typeof forceShouldLoop === "boolean" ? forceShouldLoop : this._shouldLoop;
    var self = this;
    var playPromise = this._playPromise = Promise.all(this._sinkIds.map(function createAudioElement(sinkId) {
        if (!self._Audio) return Promise.resolve();
        var audioElement = self._activeEls.get(sinkId);
        if (audioElement) return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
        audioElement = new self._Audio(self.url);
        // Make sure the browser always retrieves the resource using CORS.
        // By default when using media tags, origin header is not sent to server
        // which causes the server to not return CORS headers. When this caches
        // on the CDN or browser, it causes issues to future requests that needs CORS,
        // which is true when using AudioContext. Please note that we won't have to do this
        // once we migrate to CloudFront.
        if (typeof audioElement.setAttribute === "function") audioElement.setAttribute("crossorigin", "anonymous");
        /**
         * (rrowland) Bug in Chrome 53 & 54 prevents us from calling Audio.setSinkId without
         *   crashing the tab. https://bugs.chromium.org/p/chromium/issues/detail?id=655342
         */ return new Promise(function(resolve) {
            audioElement.addEventListener("canplaythrough", resolve);
        }).then(function() {
            return (self._isSinkSupported ? audioElement.setSinkId(sinkId) : Promise.resolve()).then(function setSinkIdSuccess() {
                self._activeEls.set(sinkId, audioElement);
                // Stop has been called, bail out
                if (!self._playPromise) return Promise.resolve();
                return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
            });
        });
    }));
    return playPromise;
};
/**
 * Stop playing the sound.
 */ $bed8333b6111cc0c$var$Sound.prototype._stop = function _stop() {
    var _this = this;
    this._activeEls.forEach(function(audioEl, sinkId) {
        if (_this._sinkIds.includes(sinkId)) {
            audioEl.pause();
            audioEl.currentTime = 0;
        } else {
            // Destroy the ones that are not used anymore
            $bed8333b6111cc0c$var$destroyAudioElement(audioEl);
            _this._activeEls.delete(sinkId);
        }
    });
    clearTimeout(this._maxDurationTimeout);
    this._playPromise = null;
    this._maxDurationTimeout = null;
};
/**
 * Update the sinkIds of the audio output devices this sound should play through.
 */ $bed8333b6111cc0c$var$Sound.prototype.setSinkIds = function setSinkIds(ids) {
    if (!this._isSinkSupported) return;
    ids = ids.forEach ? ids : [
        ids
    ];
    [].splice.apply(this._sinkIds, [
        0,
        this._sinkIds.length
    ].concat(ids));
};
/**
 * Add a stop operation to the queue
 */ $bed8333b6111cc0c$var$Sound.prototype.stop = function stop() {
    var _this = this;
    this._operations.enqueue(function() {
        _this._stop();
        return Promise.resolve();
    });
};
/**
 * Add a play operation to the queue
 */ $bed8333b6111cc0c$var$Sound.prototype.play = function play() {
    var _this = this;
    return this._operations.enqueue(function() {
        return _this._play();
    });
};
$bed8333b6111cc0c$exports.default = $bed8333b6111cc0c$var$Sound;



var $8cd2d998b29ee05f$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty($8cd2d998b29ee05f$exports, "__esModule", {
    value: true
});
$8cd2d998b29ee05f$exports.generateVoiceEventSid = void 0;
var $998ea8f131a3449e$exports = {};




(function() {
    var crypt = (parcelRequire("1dirW")), utf8 = (parcelRequire("2uhSt")).utf8, isBuffer = (parcelRequire("bGeEO")), bin = (parcelRequire("2uhSt")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === "binary") message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    $998ea8f131a3449e$exports = function(message, options) {
        if (message === undefined || message === null) throw new Error("Illegal argument " + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();



// If imported as an ESM module, sometimes md5 is available by accessing
// the "default" property of the imported library.
// @ts-ignore
var $8cd2d998b29ee05f$var$md5 = typeof $998ea8f131a3449e$exports === "function" ? $998ea8f131a3449e$exports : $998ea8f131a3449e$exports.default;
function $8cd2d998b29ee05f$var$generateUuid() {
    if (typeof window !== "object") throw new $9b99a7197ac9a7b1$exports.NotSupportedError("This platform is not supported.");
    var crypto = window.crypto;
    if (typeof crypto !== "object") throw new $9b99a7197ac9a7b1$exports.NotSupportedError("The `crypto` module is not available on this platform.");
    if (typeof (crypto.randomUUID || crypto.getRandomValues) === "undefined") throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Neither `crypto.randomUUID` or `crypto.getRandomValues` are available on this platform.");
    var uInt32Arr = window.Uint32Array;
    if (typeof uInt32Arr === "undefined") throw new $9b99a7197ac9a7b1$exports.NotSupportedError("The `Uint32Array` module is not available on this platform.");
    var generateRandomValues = typeof crypto.randomUUID === "function" ? function() {
        return crypto.randomUUID();
    } : function() {
        return crypto.getRandomValues(new Uint32Array(32)).toString();
    };
    return $8cd2d998b29ee05f$var$md5(generateRandomValues());
}
function $8cd2d998b29ee05f$var$generateVoiceEventSid() {
    return "KX" + $8cd2d998b29ee05f$var$generateUuid();
}
$8cd2d998b29ee05f$exports.generateVoiceEventSid = $8cd2d998b29ee05f$var$generateVoiceEventSid;


var $b171bc6ab63df54e$var$REGISTRATION_INTERVAL = 30000;
var $b171bc6ab63df54e$var$RINGTONE_PLAY_TIMEOUT = 2000;
var $b171bc6ab63df54e$var$PUBLISHER_PRODUCT_NAME = "twilio-js-sdk";
var $b171bc6ab63df54e$var$INVALID_TOKEN_MESSAGE = 'Parameter "token" must be of type "string".';
/**
 * Twilio Device. Allows registration for incoming calls, and placing outgoing calls.
 * @publicapi
 */ var $b171bc6ab63df54e$var$Device = /** @class */ function(_super) {
    $b171bc6ab63df54e$var$__extends(Device, _super);
    /**
     * Construct a {@link Device} instance. The {@link Device} can be registered
     * to make and listen for calls using {@link Device.register}.
     * @constructor
     * @param options
     */ function Device(token, options) {
        var _a;
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        /**
         * The currently active {@link Call}, if there is one.
         */ _this._activeCall = null;
        /**
         * The AudioHelper instance associated with this {@link Device}.
         */ _this._audio = null;
        /**
         * The AudioProcessorEventObserver instance to use
         */ _this._audioProcessorEventObserver = null;
        /**
         * An audio input MediaStream to pass to new {@link Call} instances.
         */ _this._callInputStream = null;
        /**
         * An array of {@link Call}s. Though only one can be active, multiple may exist when there
         * are multiple incoming, unanswered {@link Call}s.
         */ _this._calls = [];
        /**
         * An array of {@link Device} IDs to be used to play sounds through, to be passed to
         * new {@link Call} instances.
         */ _this._callSinkIds = [
            "default"
        ];
        /**
         * The list of chunder URIs that will be passed to PStream
         */ _this._chunderURIs = [];
        /**
         * Default options used by {@link Device}.
         */ _this._defaultOptions = {
            allowIncomingWhileBusy: false,
            closeProtection: false,
            codecPreferences: [
                $d421c5c6d9b8d50a$exports.default.Codec.PCMU,
                $d421c5c6d9b8d50a$exports.default.Codec.Opus
            ],
            dscp: true,
            enableImprovedSignalingErrorPrecision: false,
            forceAggressiveIceNomination: false,
            logLevel: $db9f743c60fc8d83$exports.levels.ERROR,
            maxCallSignalingTimeoutMs: 0,
            preflight: false,
            sounds: {},
            tokenRefreshMs: 10000,
            voiceEventSidGenerator: $8cd2d998b29ee05f$exports.generateVoiceEventSid
        };
        /**
         * The name of the edge the {@link Device} is connected to.
         */ _this._edge = null;
        /**
         * The name of the home region the {@link Device} is connected to.
         */ _this._home = null;
        /**
         * The identity associated with this Device.
         */ _this._identity = null;
        /**
         * An instance of Logger to use.
         */ _this._log = new $674d4885484aa9f2$exports.default("Device");
        /**
         * The internal promise created when calling {@link Device.makeCall}.
         */ _this._makeCallPromise = null;
        /**
         * The options passed to {@link Device} constructor or {@link Device.updateOptions}.
         */ _this._options = {};
        /**
         * The preferred URI to (re)-connect signaling to.
         */ _this._preferredURI = null;
        /**
         * An Insights Event Publisher.
         */ _this._publisher = null;
        /**
         * The region the {@link Device} is connected to.
         */ _this._region = null;
        /**
         * A timeout ID for a setTimeout schedule to re-register the {@link Device}.
         */ _this._regTimer = null;
        /**
         * Boolean representing whether or not the {@link Device} was registered when
         * receiving a signaling `offline`. Determines if the {@link Device} attempts
         * a `re-register` once signaling is re-established when receiving a
         * `connected` event from the stream.
         */ _this._shouldReRegister = false;
        /**
         * A Map of Sounds to play.
         */ _this._soundcache = new Map();
        /**
         * The current status of the {@link Device}.
         */ _this._state = Device.State.Unregistered;
        /**
         * A map from {@link Device.State} to {@link Device.EventName}.
         */ _this._stateEventMapping = (_a = {}, _a[Device.State.Destroyed] = Device.EventName.Destroyed, _a[Device.State.Unregistered] = Device.EventName.Unregistered, _a[Device.State.Registering] = Device.EventName.Registering, _a[Device.State.Registered] = Device.EventName.Registered, _a);
        /**
         * The Signaling stream.
         */ _this._stream = null;
        /**
         * A promise that will resolve when the Signaling stream is ready.
         */ _this._streamConnectedPromise = null;
        /**
         * A timeout to track when the current AccessToken will expire.
         */ _this._tokenWillExpireTimeout = null;
        /**
         * Create the default Insights payload
         * @param call
         */ _this._createDefaultPayload = function(call) {
            var payload = {
                aggressive_nomination: _this._options.forceAggressiveIceNomination,
                browser_extension: _this._isBrowserExtension,
                dscp: !!_this._options.dscp,
                ice_restart_enabled: true,
                platform: $44123d2d42b91b4b$exports.getMediaEngine(),
                sdk_version: $e9da3ede67c59403$exports.RELEASE_VERSION
            };
            function setIfDefined(propertyName, value) {
                if (value) payload[propertyName] = value;
            }
            if (call) {
                var callSid = call.parameters.CallSid;
                setIfDefined("call_sid", /^TJ/.test(callSid) ? undefined : callSid);
                setIfDefined("temp_call_sid", call.outboundConnectionId);
                setIfDefined("audio_codec", call.codec);
                payload.direction = call.direction;
            }
            setIfDefined("gateway", _this._stream && _this._stream.gateway);
            setIfDefined("region", _this._stream && _this._stream.region);
            return payload;
        };
        /**
         * Called when a 'close' event is received from the signaling stream.
         */ _this._onSignalingClose = function() {
            _this._stream = null;
            _this._streamConnectedPromise = null;
        };
        /**
         * Called when a 'connected' event is received from the signaling stream.
         */ _this._onSignalingConnected = function(payload) {
            var _a;
            var region = $916a4edaaacc98cf$exports.getRegionShortcode(payload.region);
            _this._edge = payload.edge || $916a4edaaacc98cf$exports.regionToEdge[region] || payload.region;
            _this._region = region || payload.region;
            _this._home = payload.home;
            (_a = _this._publisher) === null || _a === void 0 || _a.setHost($916a4edaaacc98cf$exports.createEventGatewayURI(payload.home));
            if (payload.token) {
                _this._identity = payload.token.identity;
                if (typeof payload.token.ttl === "number" && typeof _this._options.tokenRefreshMs === "number") {
                    var ttlMs = payload.token.ttl * 1000;
                    var timeoutMs = Math.max(0, ttlMs - _this._options.tokenRefreshMs);
                    _this._tokenWillExpireTimeout = setTimeout(function() {
                        _this._log.debug("#tokenWillExpire");
                        _this.emit("tokenWillExpire", _this);
                        if (_this._tokenWillExpireTimeout) {
                            clearTimeout(_this._tokenWillExpireTimeout);
                            _this._tokenWillExpireTimeout = null;
                        }
                    }, timeoutMs);
                }
            }
            var preferredURIs = $916a4edaaacc98cf$exports.getChunderURIs(_this._edge);
            if (preferredURIs.length > 0) {
                var preferredURI = preferredURIs[0];
                _this._preferredURI = $916a4edaaacc98cf$exports.createSignalingEndpointURL(preferredURI);
            } else _this._log.warn("Could not parse a preferred URI from the stream#connected event.");
            // The signaling stream emits a `connected` event after reconnection, if the
            // device was registered before this, then register again.
            if (_this._shouldReRegister) _this.register();
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ _this._onSignalingError = function(payload) {
            if (typeof payload !== "object") {
                _this._log.warn("Invalid signaling error payload", payload);
                return;
            }
            var originalError = payload.error, callsid = payload.callsid, voiceeventsid = payload.voiceeventsid;
            // voiceeventsid is for call message events which are handled in the call object
            // missing originalError shouldn't be possible but check here to fail properly
            if (typeof originalError !== "object" || !!voiceeventsid) {
                _this._log.warn("Ignoring signaling error payload", {
                    originalError: originalError,
                    voiceeventsid: voiceeventsid
                });
                return;
            }
            var call = typeof callsid === "string" && _this._findCall(callsid) || undefined;
            var code = originalError.code, customMessage = originalError.message;
            var twilioError = originalError.twilioError;
            if (typeof code === "number") {
                if (code === 31201) twilioError = new $9b99a7197ac9a7b1$exports.AuthorizationErrors.AuthenticationFailed(originalError);
                else if (code === 31204) twilioError = new $9b99a7197ac9a7b1$exports.AuthorizationErrors.AccessTokenInvalid(originalError);
                else if (code === 31205) {
                    // Stop trying to register presence after token expires
                    _this._stopRegistrationTimer();
                    twilioError = new $9b99a7197ac9a7b1$exports.AuthorizationErrors.AccessTokenExpired(originalError);
                } else {
                    var errorConstructor = $9b99a7197ac9a7b1$exports.getPreciseSignalingErrorByCode(!!_this._options.enableImprovedSignalingErrorPrecision, code);
                    if (typeof errorConstructor !== "undefined") twilioError = new errorConstructor(originalError);
                }
            }
            if (!twilioError) {
                _this._log.error("Unknown signaling error: ", originalError);
                twilioError = new $9b99a7197ac9a7b1$exports.GeneralErrors.UnknownError(customMessage, originalError);
            }
            _this._log.error("Received error: ", twilioError);
            _this._log.debug("#error", originalError);
            _this.emit(Device.EventName.Error, twilioError, call);
        };
        /**
         * Called when an 'invite' event is received from the signaling stream.
         */ _this._onSignalingInvite = function(payload) {
            return $b171bc6ab63df54e$var$__awaiter(_this, void 0, void 0, function() {
                var wasBusy, callParameters, customParameters, call, play;
                var _this = this;
                var _a;
                return $b171bc6ab63df54e$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            wasBusy = !!this._activeCall;
                            if (wasBusy && !this._options.allowIncomingWhileBusy) {
                                this._log.info("Device busy; ignoring incoming invite");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            if (!payload.callsid || !payload.sdp) {
                                this._log.debug("#error", payload);
                                this.emit(Device.EventName.Error, new $9b99a7197ac9a7b1$exports.ClientErrors.BadRequest("Malformed invite from gateway"));
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            callParameters = payload.parameters || {};
                            callParameters.CallSid = callParameters.CallSid || payload.callsid;
                            customParameters = Object.assign({}, $b060d15305f18a68$exports.queryToJson(callParameters.Params));
                            this._makeCallPromise = this._makeCall(customParameters, {
                                callParameters: callParameters,
                                enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                                offerSdp: payload.sdp,
                                reconnectToken: payload.reconnect,
                                voiceEventSidGenerator: this._options.voiceEventSidGenerator
                            });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                this._makeCallPromise
                            ];
                        case 2:
                            call = _b.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            this._makeCallPromise = null;
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 4:
                            this._calls.push(call);
                            call.once("accept", function() {
                                _this._soundcache.get(Device.SoundName.Incoming).stop();
                                _this._publishNetworkChange();
                            });
                            play = ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.incoming()) && !wasBusy ? function() {
                                return _this._soundcache.get(Device.SoundName.Incoming).play();
                            } : function() {
                                return Promise.resolve();
                            };
                            this._showIncomingCall(call, play);
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        /**
         * Called when an 'offline' event is received from the signaling stream.
         */ _this._onSignalingOffline = function() {
            _this._log.info("Stream is offline");
            _this._edge = null;
            _this._region = null;
            _this._shouldReRegister = _this.state !== Device.State.Unregistered;
            _this._setState(Device.State.Unregistered);
        };
        /**
         * Called when a 'ready' event is received from the signaling stream.
         */ _this._onSignalingReady = function() {
            _this._log.info("Stream is ready");
            _this._setState(Device.State.Registered);
        };
        /**
         * Publish a NetworkInformation#change event to Insights if there's an active {@link Call}.
         */ _this._publishNetworkChange = function() {
            if (!_this._activeCall) return;
            if (_this._networkInformation) _this._publisher.info("network-information", "network-change", {
                connection_type: _this._networkInformation.type,
                downlink: _this._networkInformation.downlink,
                downlinkMax: _this._networkInformation.downlinkMax,
                effective_type: _this._networkInformation.effectiveType,
                rtt: _this._networkInformation.rtt
            }, _this._activeCall);
        };
        /**
         * Update the input stream being used for calls so that any current call and all future calls
         * will use the new input stream.
         * @param inputStream
         */ _this._updateInputStream = function(inputStream) {
            var call = _this._activeCall;
            if (call && !inputStream) return Promise.reject(new $9b99a7197ac9a7b1$exports.InvalidStateError("Cannot unset input device while a call is in progress."));
            _this._callInputStream = inputStream;
            return call ? call._setInputTracksFromStream(inputStream) : Promise.resolve();
        };
        /**
         * Update the device IDs of output devices being used to play sounds through.
         * @param type - Whether to update ringtone or speaker sounds
         * @param sinkIds - An array of device IDs
         */ _this._updateSinkIds = function(type, sinkIds) {
            var promise = type === "ringtone" ? _this._updateRingtoneSinkIds(sinkIds) : _this._updateSpeakerSinkIds(sinkIds);
            return promise.then(function() {
                _this._publisher.info("audio", type + "-devices-set", {
                    audio_device_ids: sinkIds
                }, _this._activeCall);
            }, function(error) {
                _this._publisher.error("audio", type + "-devices-set-failed", {
                    audio_device_ids: sinkIds,
                    message: error.message
                }, _this._activeCall);
                throw error;
            });
        };
        // Setup loglevel asap to avoid missed logs
        _this._setupLoglevel(options.logLevel);
        _this._logOptions("constructor", options);
        _this.updateToken(token);
        if ($b060d15305f18a68$exports.isLegacyEdge()) throw new $9b99a7197ac9a7b1$exports.NotSupportedError("Microsoft Edge Legacy (https://support.microsoft.com/en-us/help/4533505/what-is-microsoft-edge-legacy) is deprecated and will not be able to connect to Twilio to make or receive calls after September 1st, 2020. Please see this documentation for a list of supported browsers https://www.twilio.com/docs/voice/client/javascript#supported-browsers");
        if (!Device.isSupported && options.ignoreBrowserSupport) {
            if (window && window.location && window.location.protocol === "http:") throw new $9b99a7197ac9a7b1$exports.NotSupportedError("twilio.js wasn't able to find WebRTC browser support.           This is most likely because this page is served over http rather than https,           which does not support WebRTC in many browsers. Please load this page over https and           try again.");
            throw new $9b99a7197ac9a7b1$exports.NotSupportedError("twilio.js 1.3+ SDKs require WebRTC browser support.         For more information, see <https://www.twilio.com/docs/api/client/twilio-js>.         If you have any questions about this announcement, please contact         Twilio Support at <help@twilio.com>.");
        }
        var root = globalThis;
        var browser = root.msBrowser || root.browser || root.chrome;
        _this._isBrowserExtension = !!browser && !!browser.runtime && !!browser.runtime.id || !!root.safari && !!root.safari.extension;
        if (_this._isBrowserExtension) _this._log.info("Running as browser extension.");
        if (navigator) {
            var n = navigator;
            _this._networkInformation = n.connection || n.mozConnection || n.webkitConnection;
        }
        if (_this._networkInformation && typeof _this._networkInformation.addEventListener === "function") _this._networkInformation.addEventListener("change", _this._publishNetworkChange);
        Device._getOrCreateAudioContext();
        if (Device._audioContext) {
            if (!Device._dialtonePlayer) Device._dialtonePlayer = new $a927d7a97cfdd257$exports.default(Device._audioContext);
        }
        if (typeof Device._isUnifiedPlanDefault === "undefined") Device._isUnifiedPlanDefault = typeof window !== "undefined" && typeof RTCPeerConnection !== "undefined" && typeof RTCRtpTransceiver !== "undefined" ? $b060d15305f18a68$exports.isUnifiedPlanDefault(window, window.navigator, RTCPeerConnection, RTCRtpTransceiver) : false;
        _this._boundDestroy = _this.destroy.bind(_this);
        _this._boundConfirmClose = _this._confirmClose.bind(_this);
        if (typeof window !== "undefined" && window.addEventListener) {
            window.addEventListener("unload", _this._boundDestroy);
            window.addEventListener("pagehide", _this._boundDestroy);
        }
        _this.updateOptions(options);
        return _this;
    }
    Object.defineProperty(Device, "audioContext", {
        /**
         * The AudioContext to be used by {@link Device} instances.
         * @private
         */ get: function() {
            return Device._audioContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "extension", {
        /**
         * Which sound file extension is supported.
         * @private
         */ get: function() {
            // NOTE(mroberts): Node workaround.
            var a = typeof document !== "undefined" ? document.createElement("audio") : {
                canPlayType: false
            };
            var canPlayMp3;
            try {
                canPlayMp3 = a.canPlayType && !!a.canPlayType("audio/mpeg").replace(/no/, "");
            } catch (e) {
                canPlayMp3 = false;
            }
            var canPlayVorbis;
            try {
                canPlayVorbis = a.canPlayType && !!a.canPlayType("audio/ogg;codecs='vorbis'").replace(/no/, "");
            } catch (e) {
                canPlayVorbis = false;
            }
            return canPlayVorbis && !canPlayMp3 ? "ogg" : "mp3";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "isSupported", {
        /**
         * Whether or not this SDK is supported by the current browser.
         */ get: function() {
            return $44123d2d42b91b4b$exports.enabled();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device, "packageName", {
        /**
         * Package name of the SDK.
         */ get: function() {
            return $e9da3ede67c59403$exports.PACKAGE_NAME;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Run some tests to identify issues, if any, prohibiting successful calling.
     * @param token - A Twilio JWT token string
     * @param options
     */ Device.runPreflight = function(token, options) {
        return new $87f1bccdd5744d30$exports.PreflightTest(token, $b171bc6ab63df54e$var$__assign({
            audioContext: Device._getOrCreateAudioContext()
        }, options));
    };
    /**
     * String representation of {@link Device} class.
     * @private
     */ Device.toString = function() {
        return "[Twilio.Device class]";
    };
    Object.defineProperty(Device, "version", {
        /**
         * Current SDK version.
         */ get: function() {
            return $e9da3ede67c59403$exports.RELEASE_VERSION;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Initializes the AudioContext instance shared across the Voice SDK,
     * or returns the existing instance if one has already been initialized.
     */ Device._getOrCreateAudioContext = function() {
        if (!Device._audioContext) {
            if (typeof AudioContext !== "undefined") Device._audioContext = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Device._audioContext = new webkitAudioContext();
        }
        return Device._audioContext;
    };
    Object.defineProperty(Device.prototype, "audio", {
        /**
         * Return the {@link AudioHelper} used by this {@link Device}.
         */ get: function() {
            return this._audio;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Make an outgoing Call.
     * @param options
     */ Device.prototype.connect = function(options) {
        if (options === void 0) options = {};
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var customParameters, parameters, signalingReconnectToken, connectTokenParts, isReconnect, twimlParams, callOptions, activeCall, _a;
            return $b171bc6ab63df54e$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this._log.debug(".connect", JSON.stringify(options));
                        this._throwIfDestroyed();
                        if (this._activeCall) throw new $9b99a7197ac9a7b1$exports.InvalidStateError("A Call is already active");
                        if (options.connectToken) {
                            try {
                                connectTokenParts = JSON.parse(decodeURIComponent(atob(options.connectToken)));
                                customParameters = connectTokenParts.customParameters;
                                parameters = connectTokenParts.parameters;
                                signalingReconnectToken = connectTokenParts.signalingReconnectToken;
                            } catch (_c) {
                                throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Cannot parse connectToken");
                            }
                            if (!parameters || !parameters.CallSid || !signalingReconnectToken) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Invalid connectToken");
                        }
                        isReconnect = false;
                        twimlParams = {};
                        callOptions = {
                            enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                            rtcConfiguration: options.rtcConfiguration,
                            voiceEventSidGenerator: this._options.voiceEventSidGenerator
                        };
                        if (signalingReconnectToken && parameters) {
                            isReconnect = true;
                            callOptions.callParameters = parameters;
                            callOptions.reconnectCallSid = parameters.CallSid;
                            callOptions.reconnectToken = signalingReconnectToken;
                            twimlParams = customParameters || twimlParams;
                        } else twimlParams = options.params || twimlParams;
                        this._makeCallPromise = this._makeCall(twimlParams, callOptions, isReconnect);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._makeCallPromise
                        ];
                    case 2:
                        activeCall = _a._activeCall = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        this._makeCallPromise = null;
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        // Make sure any incoming calls are ignored
                        this._calls.splice(0).forEach(function(call) {
                            return call.ignore();
                        });
                        // Stop the incoming sound if it's playing
                        this._soundcache.get(Device.SoundName.Incoming).stop();
                        activeCall.accept({
                            rtcConstraints: options.rtcConstraints
                        });
                        this._publishNetworkChange();
                        return [
                            2 /*return*/ ,
                            activeCall
                        ];
                }
            });
        });
    };
    Object.defineProperty(Device.prototype, "calls", {
        /**
         * Return the calls that this {@link Device} is maintaining.
         */ get: function() {
            return this._calls;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Destroy the {@link Device}, freeing references to be garbage collected.
     */ Device.prototype.destroy = function() {
        var _a;
        this._log.debug(".destroy");
        this._log.debug("Rejecting any incoming calls");
        var calls = this._calls.slice(0);
        calls.forEach(function(call) {
            return call.reject();
        });
        this.disconnectAll();
        this._stopRegistrationTimer();
        this._destroyStream();
        this._destroyPublisher();
        this._destroyAudioHelper();
        (_a = this._audioProcessorEventObserver) === null || _a === void 0 || _a.destroy();
        if (this._networkInformation && typeof this._networkInformation.removeEventListener === "function") this._networkInformation.removeEventListener("change", this._publishNetworkChange);
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("beforeunload", this._boundConfirmClose);
            window.removeEventListener("unload", this._boundDestroy);
            window.removeEventListener("pagehide", this._boundDestroy);
        }
        this._setState(Device.State.Destroyed);
        $0bfd6a77e39eae31$exports.EventEmitter.prototype.removeAllListeners.call(this);
    };
    /**
     * Disconnect all {@link Call}s.
     */ Device.prototype.disconnectAll = function() {
        this._log.debug(".disconnectAll");
        var calls = this._calls.splice(0);
        calls.forEach(function(call) {
            return call.disconnect();
        });
        if (this._activeCall) this._activeCall.disconnect();
    };
    Object.defineProperty(Device.prototype, "edge", {
        /**
         * Returns the {@link Edge} value the {@link Device} is currently connected
         * to. The value will be `null` when the {@link Device} is offline.
         */ get: function() {
            return this._edge;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "home", {
        /**
         * Returns the home value the {@link Device} is currently connected
         * to. The value will be `null` when the {@link Device} is offline.
         */ get: function() {
            return this._home;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "identity", {
        /**
         * Returns the identity associated with the {@link Device} for incoming calls. Only
         * populated when registered.
         */ get: function() {
            return this._identity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isBusy", {
        /**
         * Whether the Device is currently on an active Call.
         */ get: function() {
            return !!this._activeCall;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Register the `Device` to the Twilio backend, allowing it to receive calls.
     */ Device.prototype.register = function() {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this._log.debug(".register");
                        if (this.state !== Device.State.Unregistered) throw new $9b99a7197ac9a7b1$exports.InvalidStateError('Attempt to register when device is in state "' + this.state + '". ' + ('Must be "' + Device.State.Unregistered + '".'));
                        this._shouldReRegister = false;
                        this._setState(Device.State.Registering);
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise || this._setupStream()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this._sendPresence(true)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            $b060d15305f18a68$exports.promisifyEvents(this, Device.State.Registered, Device.State.Unregistered)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Object.defineProperty(Device.prototype, "state", {
        /**
         * Get the state of this {@link Device} instance
         */ get: function() {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "token", {
        /**
         * Get the token used by this {@link Device}.
         */ get: function() {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * String representation of {@link Device} instance.
     * @private
     */ Device.prototype.toString = function() {
        return "[Twilio.Device instance]";
    };
    /**
     * Unregister the `Device` to the Twilio backend, disallowing it to receive
     * calls.
     */ Device.prototype.unregister = function() {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var stream, streamOfflinePromise;
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this._log.debug(".unregister");
                        if (this.state !== Device.State.Registered) throw new $9b99a7197ac9a7b1$exports.InvalidStateError('Attempt to unregister when device is in state "' + this.state + '". ' + ('Must be "' + Device.State.Registered + '".'));
                        this._shouldReRegister = false;
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise
                        ];
                    case 1:
                        stream = _a.sent();
                        streamOfflinePromise = new Promise(function(resolve) {
                            stream.on("offline", resolve);
                        });
                        return [
                            4 /*yield*/ ,
                            this._sendPresence(false)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            streamOfflinePromise
                        ];
                    case 3:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Set the options used within the {@link Device}.
     * @param options
     */ Device.prototype.updateOptions = function(options) {
        if (options === void 0) options = {};
        this._logOptions("updateOptions", options);
        if (this.state === Device.State.Destroyed) throw new $9b99a7197ac9a7b1$exports.InvalidStateError('Attempt to "updateOptions" when device is in state "' + this.state + '".');
        this._options = $b171bc6ab63df54e$var$__assign($b171bc6ab63df54e$var$__assign($b171bc6ab63df54e$var$__assign({}, this._defaultOptions), this._options), options);
        var originalChunderURIs = new Set(this._chunderURIs);
        var chunderw = typeof this._options.chunderw === "string" ? [
            this._options.chunderw
        ] : Array.isArray(this._options.chunderw) && this._options.chunderw;
        var newChunderURIs = this._chunderURIs = (chunderw || $916a4edaaacc98cf$exports.getChunderURIs(this._options.edge)).map($916a4edaaacc98cf$exports.createSignalingEndpointURL);
        var hasChunderURIsChanged = originalChunderURIs.size !== newChunderURIs.length;
        if (!hasChunderURIsChanged) for(var _i = 0, newChunderURIs_1 = newChunderURIs; _i < newChunderURIs_1.length; _i++){
            var uri = newChunderURIs_1[_i];
            if (!originalChunderURIs.has(uri)) {
                hasChunderURIsChanged = true;
                break;
            }
        }
        if (this.isBusy && hasChunderURIsChanged) throw new $9b99a7197ac9a7b1$exports.InvalidStateError("Cannot change Edge while on an active Call");
        this._setupLoglevel(this._options.logLevel);
        for(var _a = 0, _b = Object.keys(Device._defaultSounds); _a < _b.length; _a++){
            var name_1 = _b[_a];
            var soundDef = Device._defaultSounds[name_1];
            var defaultUrl = $e9da3ede67c59403$exports.SOUNDS_BASE_URL + "/" + soundDef.filename + "." + Device.extension + ("?cache=" + $e9da3ede67c59403$exports.RELEASE_VERSION);
            var soundUrl = this._options.sounds && this._options.sounds[name_1] || defaultUrl;
            var sound = new (this._options.Sound || $bed8333b6111cc0c$exports.default)(name_1, soundUrl, {
                audioContext: this._options.disableAudioContextSounds ? null : Device.audioContext,
                maxDuration: soundDef.maxDuration,
                shouldLoop: soundDef.shouldLoop
            });
            this._soundcache.set(name_1, sound);
        }
        this._setupAudioHelper();
        this._setupPublisher();
        if (hasChunderURIsChanged && this._streamConnectedPromise) this._setupStream();
        // Setup close protection and make sure we clean up ongoing calls on unload.
        if (typeof window !== "undefined" && typeof window.addEventListener === "function" && this._options.closeProtection) {
            window.removeEventListener("beforeunload", this._boundConfirmClose);
            window.addEventListener("beforeunload", this._boundConfirmClose);
        }
    };
    /**
     * Update the token used by this {@link Device} to connect to Twilio.
     * It is recommended to call this API after [[Device.tokenWillExpireEvent]] is emitted,
     * and before or after a call to prevent a potential ~1s audio loss during the update process.
     * @param token
     */ Device.prototype.updateToken = function(token) {
        this._log.debug(".updateToken");
        if (this.state === Device.State.Destroyed) throw new $9b99a7197ac9a7b1$exports.InvalidStateError('Attempt to "updateToken" when device is in state "' + this.state + '".');
        if (typeof token !== "string") throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError($b171bc6ab63df54e$var$INVALID_TOKEN_MESSAGE);
        this._token = token;
        if (this._stream) this._stream.setToken(this._token);
        if (this._publisher) this._publisher.setToken(this._token);
    };
    /**
     * Called on window's beforeunload event if closeProtection is enabled,
     * preventing users from accidentally navigating away from an active call.
     * @param event
     */ Device.prototype._confirmClose = function(event) {
        if (!this._activeCall) return "";
        var closeProtection = this._options.closeProtection || false;
        var confirmationMsg = typeof closeProtection !== "string" ? "A call is currently in-progress. Leaving or reloading this page will end the call." : closeProtection;
        (event || window.event).returnValue = confirmationMsg;
        return confirmationMsg;
    };
    /**
     * Destroy the AudioHelper.
     */ Device.prototype._destroyAudioHelper = function() {
        if (!this._audio) return;
        this._audio._destroy();
        this._audio = null;
    };
    /**
     * Destroy the publisher.
     */ Device.prototype._destroyPublisher = function() {
        // Attempt to destroy non-existent publisher.
        if (!this._publisher) return;
        this._publisher = null;
    };
    /**
     * Destroy the connection to the signaling server.
     */ Device.prototype._destroyStream = function() {
        if (this._stream) {
            this._stream.removeListener("close", this._onSignalingClose);
            this._stream.removeListener("connected", this._onSignalingConnected);
            this._stream.removeListener("error", this._onSignalingError);
            this._stream.removeListener("invite", this._onSignalingInvite);
            this._stream.removeListener("offline", this._onSignalingOffline);
            this._stream.removeListener("ready", this._onSignalingReady);
            this._stream.destroy();
            this._stream = null;
        }
        this._onSignalingOffline();
        this._streamConnectedPromise = null;
    };
    /**
     * Find a {@link Call} by its CallSid.
     * @param callSid
     */ Device.prototype._findCall = function(callSid) {
        return this._calls.find(function(call) {
            return call.parameters.CallSid === callSid || call.outboundConnectionId === callSid;
        }) || null;
    };
    /**
     * Utility function to log device options
     */ Device.prototype._logOptions = function(caller, options) {
        if (options === void 0) options = {};
        // Selectively log options that users can modify.
        // Also, convert user overrides.
        // This prevents potential app crash when calling JSON.stringify
        // and when sending log strings remotely
        var userOptions = [
            "allowIncomingWhileBusy",
            "appName",
            "appVersion",
            "closeProtection",
            "codecPreferences",
            "disableAudioContextSounds",
            "dscp",
            "edge",
            "enableImprovedSignalingErrorPrecision",
            "forceAggressiveIceNomination",
            "logLevel",
            "maxAverageBitrate",
            "maxCallSignalingTimeoutMs",
            "sounds",
            "tokenRefreshMs"
        ];
        var userOptionOverrides = [
            "RTCPeerConnection",
            "enumerateDevices",
            "getUserMedia"
        ];
        if (typeof options === "object") {
            var toLog_1 = $b171bc6ab63df54e$var$__assign({}, options);
            Object.keys(toLog_1).forEach(function(key) {
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog_1[key];
                if (userOptionOverrides.includes(key)) toLog_1[key] = true;
            });
            this._log.debug("." + caller, JSON.stringify(toLog_1));
        }
    };
    /**
     * Create a new {@link Call}.
     * @param twimlParams - A flat object containing key:value pairs to be sent to the TwiML app.
     * @param options - Options to be used to instantiate the {@link Call}.
     */ Device.prototype._makeCall = function(twimlParams, options, isReconnect) {
        var _a;
        if (isReconnect === void 0) isReconnect = false;
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var inputDevicePromise, config, maybeUnsetPreferredUri, call;
            var _b;
            var _this = this;
            return $b171bc6ab63df54e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (typeof Device._isUnifiedPlanDefault === "undefined") throw new $9b99a7197ac9a7b1$exports.InvalidStateError("Device has not been initialized.");
                        inputDevicePromise = (_a = this._audio) === null || _a === void 0 ? void 0 : _a._getInputDevicePromise();
                        if (!inputDevicePromise) return [
                            3 /*break*/ ,
                            2
                        ];
                        this._log.debug("inputDevicePromise detected, waiting...");
                        return [
                            4 /*yield*/ ,
                            inputDevicePromise
                        ];
                    case 1:
                        _c.sent();
                        this._log.debug("inputDevicePromise resolved");
                        _c.label = 2;
                    case 2:
                        _b = {
                            audioHelper: this._audio,
                            isUnifiedPlanDefault: Device._isUnifiedPlanDefault,
                            onIgnore: function() {
                                _this._soundcache.get(Device.SoundName.Incoming).stop();
                            }
                        };
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise || this._setupStream()
                        ];
                    case 3:
                        config = (_b.pstream = _c.sent(), _b.publisher = this._publisher, _b.soundcache = this._soundcache, _b);
                        options = Object.assign({
                            MediaStream: this._options.MediaStream || $44123d2d42b91b4b$exports.PeerConnection,
                            RTCPeerConnection: this._options.RTCPeerConnection,
                            beforeAccept: function(currentCall) {
                                if (!_this._activeCall || _this._activeCall === currentCall) return;
                                _this._activeCall.disconnect();
                                _this._removeCall(_this._activeCall);
                            },
                            codecPreferences: this._options.codecPreferences,
                            customSounds: this._options.sounds,
                            dialtonePlayer: Device._dialtonePlayer,
                            dscp: this._options.dscp,
                            // TODO(csantos): Remove forceAggressiveIceNomination option in 3.x
                            forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
                            getInputStream: function() {
                                return _this._options.fileInputStream || _this._callInputStream;
                            },
                            getSinkIds: function() {
                                return _this._callSinkIds;
                            },
                            maxAverageBitrate: this._options.maxAverageBitrate,
                            preflight: this._options.preflight,
                            rtcConstraints: this._options.rtcConstraints,
                            shouldPlayDisconnect: function() {
                                var _a;
                                return (_a = _this._audio) === null || _a === void 0 ? void 0 : _a.disconnect();
                            },
                            twimlParams: twimlParams,
                            voiceEventSidGenerator: this._options.voiceEventSidGenerator
                        }, options);
                        maybeUnsetPreferredUri = function() {
                            if (!_this._stream) {
                                _this._log.warn("UnsetPreferredUri called without a stream");
                                return;
                            }
                            if (_this._activeCall === null && _this._calls.length === 0) _this._stream.updatePreferredURI(null);
                        };
                        call = new (this._options.Call || $d421c5c6d9b8d50a$exports.default)(config, options);
                        this._publisher.info("settings", "init", {
                            RTCPeerConnection: !!this._options.RTCPeerConnection,
                            enumerateDevices: !!this._options.enumerateDevices,
                            getUserMedia: !!this._options.getUserMedia
                        }, call);
                        call.once("accept", function() {
                            var _a, _b, _c;
                            _this._stream.updatePreferredURI(_this._preferredURI);
                            _this._removeCall(call);
                            _this._activeCall = call;
                            if (_this._audio) _this._audio._maybeStartPollingVolume();
                            if (call.direction === $d421c5c6d9b8d50a$exports.default.CallDirection.Outgoing && ((_a = _this._audio) === null || _a === void 0 ? void 0 : _a.outgoing()) && !isReconnect) _this._soundcache.get(Device.SoundName.Outgoing).play();
                            var data = {
                                edge: _this._edge || _this._region
                            };
                            if (_this._options.edge) data["selected_edge"] = Array.isArray(_this._options.edge) ? _this._options.edge : [
                                _this._options.edge
                            ];
                            _this._publisher.info("settings", "edge", data, call);
                            if ((_b = _this._audio) === null || _b === void 0 ? void 0 : _b.processedStream) (_c = _this._audioProcessorEventObserver) === null || _c === void 0 || _c.emit("enabled");
                        });
                        call.addListener("error", function(error) {
                            if (call.status() === "closed") {
                                _this._removeCall(call);
                                maybeUnsetPreferredUri();
                            }
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._maybeStopIncomingSound();
                        });
                        call.once("cancel", function() {
                            _this._log.info("Canceled: " + call.parameters.CallSid);
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._maybeStopIncomingSound();
                        });
                        call.once("disconnect", function() {
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            /**
                             * NOTE(kamalbennani): We need to stop the incoming sound when the call is
                             * disconnected right after the user has accepted the call (activeCall.accept()), and before
                             * the call has been fully connected (i.e. before the `pstream.answer` event)
                             */ _this._maybeStopIncomingSound();
                        });
                        call.once("reject", function() {
                            _this._log.info("Rejected: " + call.parameters.CallSid);
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            maybeUnsetPreferredUri();
                            _this._maybeStopIncomingSound();
                        });
                        call.on("transportClose", function() {
                            if (call.status() !== $d421c5c6d9b8d50a$exports.default.State.Pending) return;
                            if (_this._audio) _this._audio._maybeStopPollingVolume();
                            _this._removeCall(call);
                            /**
                             * NOTE(mhuynh): We don't want to call `maybeUnsetPreferredUri` because
                             * a `transportClose` will happen during signaling reconnection.
                             */ _this._maybeStopIncomingSound();
                        });
                        return [
                            2 /*return*/ ,
                            call
                        ];
                }
            });
        });
    };
    /**
     * Stop the incoming sound if no {@link Call}s remain.
     */ Device.prototype._maybeStopIncomingSound = function() {
        if (!this._calls.length) this._soundcache.get(Device.SoundName.Incoming).stop();
    };
    /**
     * Remove a {@link Call} from device.calls by reference
     * @param call
     */ Device.prototype._removeCall = function(call) {
        if (this._activeCall === call) {
            this._activeCall = null;
            this._makeCallPromise = null;
        }
        for(var i = this._calls.length - 1; i >= 0; i--)if (call === this._calls[i]) this._calls.splice(i, 1);
    };
    /**
     * Register with the signaling server.
     */ Device.prototype._sendPresence = function(presence) {
        return $b171bc6ab63df54e$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $b171bc6ab63df54e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._streamConnectedPromise
                        ];
                    case 1:
                        stream = _a.sent();
                        if (!stream) return [
                            2 /*return*/ 
                        ];
                        stream.register({
                            audio: presence
                        });
                        if (presence) this._startRegistrationTimer();
                        else this._stopRegistrationTimer();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Helper function that sets and emits the state of the device.
     * @param state The new state of the device.
     */ Device.prototype._setState = function(state) {
        if (state === this.state) return;
        this._state = state;
        var name = this._stateEventMapping[state];
        this._log.debug("#" + name);
        this.emit(name);
    };
    /**
     * Set up an audio helper for usage by this {@link Device}.
     */ Device.prototype._setupAudioHelper = function() {
        var _this = this;
        if (!this._audioProcessorEventObserver) {
            this._audioProcessorEventObserver = new $faaf8cc587ce2922$exports.AudioProcessorEventObserver();
            this._audioProcessorEventObserver.on("event", function(_a) {
                var name = _a.name, group = _a.group;
                _this._publisher.info(group, name, {}, _this._activeCall);
            });
        }
        var audioOptions = {
            audioContext: Device.audioContext,
            audioProcessorEventObserver: this._audioProcessorEventObserver,
            beforeSetInputDevice: function() {
                if (_this._makeCallPromise) {
                    _this._log.debug("beforeSetInputDevice pause detected");
                    return _this._makeCallPromise;
                } else {
                    _this._log.debug("beforeSetInputDevice pause not detected, setting default");
                    return Promise.resolve();
                }
            },
            enumerateDevices: this._options.enumerateDevices,
            getUserMedia: this._options.getUserMedia || $8484cd27499b985d$exports.default
        };
        if (this._audio) {
            this._log.info("Found existing audio helper; updating options...");
            this._audio._updateUserOptions(audioOptions);
            return;
        }
        this._audio = new (this._options.AudioHelper || $54a2599bd8145d0c$exports.default)(this._updateSinkIds, this._updateInputStream, audioOptions);
        this._audio.on("deviceChange", function(lostActiveDevices) {
            var activeCall = _this._activeCall;
            var deviceIds = lostActiveDevices.map(function(device) {
                return device.deviceId;
            });
            _this._publisher.info("audio", "device-change", {
                lost_active_device_ids: deviceIds
            }, activeCall);
            if (activeCall) activeCall["_mediaHandler"]._onInputDevicesChanged();
        });
    };
    /**
     * Setup logger's loglevel
     */ Device.prototype._setupLoglevel = function(logLevel) {
        var level = typeof logLevel === "number" || typeof logLevel === "string" ? logLevel : $db9f743c60fc8d83$exports.levels.ERROR;
        this._log.setDefaultLevel(level);
        this._log.info("Set logger default level to", level);
    };
    /**
     * Create and set a publisher for the {@link Device} to use.
     */ Device.prototype._setupPublisher = function() {
        var _this = this;
        if (this._publisher) {
            this._log.info("Found existing publisher; destroying...");
            this._destroyPublisher();
        }
        var publisherOptions = {
            defaultPayload: this._createDefaultPayload,
            metadata: {
                app_name: this._options.appName,
                app_version: this._options.appVersion
            }
        };
        if (this._options.eventgw) publisherOptions.host = this._options.eventgw;
        if (this._home) publisherOptions.host = $916a4edaaacc98cf$exports.createEventGatewayURI(this._home);
        this._publisher = new (this._options.Publisher || $589357f68de838e6$exports.default)($b171bc6ab63df54e$var$PUBLISHER_PRODUCT_NAME, this.token, publisherOptions);
        if (this._options.publishEvents === false) this._publisher.disable();
        else this._publisher.on("error", function(error) {
            _this._log.warn("Cannot connect to insights.", error);
        });
        return this._publisher;
    };
    /**
     * Set up the connection to the signaling server. Tears down an existing
     * stream if called while a stream exists.
     */ Device.prototype._setupStream = function() {
        var _this = this;
        if (this._stream) {
            this._log.info("Found existing stream; destroying...");
            this._destroyStream();
        }
        this._log.info("Setting up VSP");
        this._stream = new (this._options.PStream || $2b1007c1151c9a8f$exports.default)(this.token, this._chunderURIs, {
            backoffMaxMs: this._options.backoffMaxMs,
            maxPreferredDurationMs: this._options.maxCallSignalingTimeoutMs
        });
        this._stream.addListener("close", this._onSignalingClose);
        this._stream.addListener("connected", this._onSignalingConnected);
        this._stream.addListener("error", this._onSignalingError);
        this._stream.addListener("invite", this._onSignalingInvite);
        this._stream.addListener("offline", this._onSignalingOffline);
        this._stream.addListener("ready", this._onSignalingReady);
        return this._streamConnectedPromise = $b060d15305f18a68$exports.promisifyEvents(this._stream, "connected", "close").then(function() {
            return _this._stream;
        });
    };
    /**
     * Start playing the incoming ringtone, and subsequently emit the incoming event.
     * @param call
     * @param play - The function to be used to play the sound. Must return a Promise.
     */ Device.prototype._showIncomingCall = function(call, play) {
        var _this = this;
        var timeout;
        return Promise.race([
            play(),
            new Promise(function(resolve, reject) {
                timeout = setTimeout(function() {
                    var msg = "Playing incoming ringtone took too long; it might not play. Continuing execution...";
                    reject(new Error(msg));
                }, $b171bc6ab63df54e$var$RINGTONE_PLAY_TIMEOUT);
            })
        ]).catch(function(reason) {
            _this._log.warn(reason.message);
        }).then(function() {
            clearTimeout(timeout);
            _this._log.debug("#incoming", JSON.stringify({
                customParameters: call.customParameters,
                parameters: call.parameters
            }));
            _this.emit(Device.EventName.Incoming, call);
        });
    };
    /**
     * Set a timeout to send another register message to the signaling server.
     */ Device.prototype._startRegistrationTimer = function() {
        var _this = this;
        this._stopRegistrationTimer();
        this._regTimer = setTimeout(function() {
            _this._sendPresence(true);
        }, $b171bc6ab63df54e$var$REGISTRATION_INTERVAL);
    };
    /**
     * Stop sending registration messages to the signaling server.
     */ Device.prototype._stopRegistrationTimer = function() {
        if (this._regTimer) clearTimeout(this._regTimer);
    };
    /**
     * Throw an error if the {@link Device} is destroyed.
     */ Device.prototype._throwIfDestroyed = function() {
        if (this.state === Device.State.Destroyed) throw new $9b99a7197ac9a7b1$exports.InvalidStateError("Device has been destroyed.");
    };
    /**
     * Update the device IDs of output devices being used to play the incoming ringtone through.
     * @param sinkIds - An array of device IDs
     */ Device.prototype._updateRingtoneSinkIds = function(sinkIds) {
        return Promise.resolve(this._soundcache.get(Device.SoundName.Incoming).setSinkIds(sinkIds));
    };
    /**
     * Update the device IDs of output devices being used to play the non-ringtone sounds
     * and Call audio through.
     * @param sinkIds - An array of device IDs
     */ Device.prototype._updateSpeakerSinkIds = function(sinkIds) {
        Array.from(this._soundcache.entries()).filter(function(entry) {
            return entry[0] !== Device.SoundName.Incoming;
        }).forEach(function(entry) {
            return entry[1].setSinkIds(sinkIds);
        });
        this._callSinkIds = sinkIds;
        var call = this._activeCall;
        return call ? call._setSinkIds(sinkIds) : Promise.resolve();
    };
    Device._defaultSounds = {
        disconnect: {
            filename: "disconnect",
            maxDuration: 3000
        },
        dtmf0: {
            filename: "dtmf-0",
            maxDuration: 1000
        },
        dtmf1: {
            filename: "dtmf-1",
            maxDuration: 1000
        },
        dtmf2: {
            filename: "dtmf-2",
            maxDuration: 1000
        },
        dtmf3: {
            filename: "dtmf-3",
            maxDuration: 1000
        },
        dtmf4: {
            filename: "dtmf-4",
            maxDuration: 1000
        },
        dtmf5: {
            filename: "dtmf-5",
            maxDuration: 1000
        },
        dtmf6: {
            filename: "dtmf-6",
            maxDuration: 1000
        },
        dtmf7: {
            filename: "dtmf-7",
            maxDuration: 1000
        },
        dtmf8: {
            filename: "dtmf-8",
            maxDuration: 1000
        },
        dtmf9: {
            filename: "dtmf-9",
            maxDuration: 1000
        },
        dtmfh: {
            filename: "dtmf-hash",
            maxDuration: 1000
        },
        dtmfs: {
            filename: "dtmf-star",
            maxDuration: 1000
        },
        incoming: {
            filename: "incoming",
            shouldLoop: true
        },
        outgoing: {
            filename: "outgoing",
            maxDuration: 3000
        }
    };
    return Device;
}($0bfd6a77e39eae31$exports.EventEmitter);
(function(Device) {
    /**
     * All valid {@link Device} event names.
     */ var EventName;
    (function(EventName) {
        EventName["Error"] = "error";
        EventName["Incoming"] = "incoming";
        EventName["Destroyed"] = "destroyed";
        EventName["Unregistered"] = "unregistered";
        EventName["Registering"] = "registering";
        EventName["Registered"] = "registered";
        EventName["TokenWillExpire"] = "tokenWillExpire";
    })(EventName = Device.EventName || (Device.EventName = {}));
    /**
     * All possible {@link Device} states.
     */ var State;
    (function(State) {
        State["Destroyed"] = "destroyed";
        State["Unregistered"] = "unregistered";
        State["Registering"] = "registering";
        State["Registered"] = "registered";
    })(State = Device.State || (Device.State = {}));
    /**
     * Names of all sounds handled by the {@link Device}.
     */ var SoundName;
    (function(SoundName) {
        SoundName["Incoming"] = "incoming";
        SoundName["Outgoing"] = "outgoing";
        SoundName["Disconnect"] = "disconnect";
        SoundName["Dtmf0"] = "dtmf0";
        SoundName["Dtmf1"] = "dtmf1";
        SoundName["Dtmf2"] = "dtmf2";
        SoundName["Dtmf3"] = "dtmf3";
        SoundName["Dtmf4"] = "dtmf4";
        SoundName["Dtmf5"] = "dtmf5";
        SoundName["Dtmf6"] = "dtmf6";
        SoundName["Dtmf7"] = "dtmf7";
        SoundName["Dtmf8"] = "dtmf8";
        SoundName["Dtmf9"] = "dtmf9";
        SoundName["DtmfS"] = "dtmfs";
        SoundName["DtmfH"] = "dtmfh";
    })(SoundName = Device.SoundName || (Device.SoundName = {}));
})($b171bc6ab63df54e$var$Device || ($b171bc6ab63df54e$var$Device = {}));
$b171bc6ab63df54e$exports.default = $b171bc6ab63df54e$var$Device;





var $3b7d8de69f288bc0$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty($3b7d8de69f288bc0$exports, "__esModule", {
    value: true
});
$3b7d8de69f288bc0$exports.IceCandidate = void 0;
/**
 * {@link RTCIceCandidate} parses an ICE candidate gathered by the browser
 * and returns a IceCandidate object
 */ var $3b7d8de69f288bc0$var$IceCandidate = /** @class */ function() {
    /**
     * @constructor
     * @param iceCandidate RTCIceCandidate coming from the browser
     */ function IceCandidate(iceCandidate, isRemote) {
        if (isRemote === void 0) isRemote = false;
        /**
         * Whether this is deleted from the list of candidate gathered
         */ this.deleted = false;
        var cost;
        var parts = iceCandidate.candidate.split("network-cost ");
        if (parts[1]) cost = parseInt(parts[1], 10);
        this.candidateType = iceCandidate.type;
        this.ip = iceCandidate.ip || iceCandidate.address;
        this.isRemote = isRemote;
        this.networkCost = cost;
        this.port = iceCandidate.port;
        this.priority = iceCandidate.priority;
        this.protocol = iceCandidate.protocol;
        this.relatedAddress = iceCandidate.relatedAddress;
        this.relatedPort = iceCandidate.relatedPort;
        this.tcpType = iceCandidate.tcpType;
        this.transportId = iceCandidate.sdpMid;
    }
    /**
     * Get the payload object for insights
     */ IceCandidate.prototype.toPayload = function() {
        return {
            "candidate_type": this.candidateType,
            "deleted": this.deleted,
            "ip": this.ip,
            "is_remote": this.isRemote,
            "network-cost": this.networkCost,
            "port": this.port,
            "priority": this.priority,
            "protocol": this.protocol,
            "related_address": this.relatedAddress,
            "related_port": this.relatedPort,
            "tcp_type": this.tcpType,
            "transport_id": this.transportId
        };
    };
    return IceCandidate;
}();
$3b7d8de69f288bc0$exports.IceCandidate = $3b7d8de69f288bc0$var$IceCandidate;



var $def52bc890d25e83$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ var $def52bc890d25e83$var$__extends = $def52bc890d25e83$exports && $def52bc890d25e83$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $def52bc890d25e83$var$__assign = $def52bc890d25e83$exports && $def52bc890d25e83$exports.__assign || function() {
    $def52bc890d25e83$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $def52bc890d25e83$var$__assign.apply(this, arguments);
};
var $def52bc890d25e83$var$__spreadArrays = $def52bc890d25e83$exports && $def52bc890d25e83$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($def52bc890d25e83$exports, "__esModule", {
    value: true
});


var $61001e332e3cd220$exports = {};
"use strict";
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */ Object.defineProperty($61001e332e3cd220$exports, "__esModule", {
    value: true
});
$61001e332e3cd220$exports.isNonNegativeNumber = $61001e332e3cd220$exports.calculate = void 0;
var $61001e332e3cd220$var$r0 = 94.768; // Constant used in computing "rFactor".
/**
 * Calculate the mos score of a stats object
 * @param {number} rtt
 * @param {number} jitter
 * @param {number} fractionLost - The fraction of packets that have been lost.
 * Calculated by packetsLost / totalPackets
 * @return {number | null} mos - Calculated MOS, `1.0` through roughly `4.5`.
 * Returns `null` when any of the input parameters are not a `non-negative`
 * number.
 */ function $61001e332e3cd220$var$calculate(rtt, jitter, fractionLost) {
    if (typeof rtt !== "number" || typeof jitter !== "number" || typeof fractionLost !== "number" || !$61001e332e3cd220$var$isNonNegativeNumber(rtt) || !$61001e332e3cd220$var$isNonNegativeNumber(jitter) || !$61001e332e3cd220$var$isNonNegativeNumber(fractionLost)) return null;
    // Compute the effective latency.
    var effectiveLatency = rtt + jitter * 2 + 10;
    // Compute the initial "rFactor" from effective latency.
    var rFactor = 0;
    switch(true){
        case effectiveLatency < 160:
            rFactor = $61001e332e3cd220$var$r0 - effectiveLatency / 40;
            break;
        case effectiveLatency < 1000:
            rFactor = $61001e332e3cd220$var$r0 - (effectiveLatency - 120) / 10;
            break;
    }
    // Adjust "rFactor" with the fraction of packets lost.
    switch(true){
        case fractionLost <= rFactor / 2.5:
            rFactor = Math.max(rFactor - fractionLost * 2.5, 6.52);
            break;
        default:
            rFactor = 0;
            break;
    }
    // Compute MOS from "rFactor".
    var mos = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
    return mos;
}
$61001e332e3cd220$exports.calculate = $61001e332e3cd220$var$calculate;
/**
 * Returns true if and only if the parameter passed is a number, is not `NaN`,
 * is finite, and is greater than or equal to `0`.
 * @param n
 */ function $61001e332e3cd220$var$isNonNegativeNumber(n) {
    return typeof n === "number" && !isNaN(n) && isFinite(n) && n >= 0;
}
$61001e332e3cd220$exports.isNonNegativeNumber = $61001e332e3cd220$var$isNonNegativeNumber;
$61001e332e3cd220$exports.default = {
    calculate: $61001e332e3cd220$var$calculate,
    isNonNegativeNumber: $61001e332e3cd220$var$isNonNegativeNumber
};




// How many samples we use when testing metric thresholds
var $def52bc890d25e83$var$SAMPLE_COUNT_METRICS = 5;
// How many samples that need to cross the threshold to
// raise or clear a warning.
var $def52bc890d25e83$var$SAMPLE_COUNT_CLEAR = 0;
var $def52bc890d25e83$var$SAMPLE_COUNT_RAISE = 3;
var $def52bc890d25e83$var$SAMPLE_INTERVAL = 1000;
var $def52bc890d25e83$var$WARNING_TIMEOUT = 5000;
var $def52bc890d25e83$var$DEFAULT_THRESHOLDS = {
    audioInputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    audioOutputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    bytesReceived: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    bytesSent: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    jitter: {
        max: 30
    },
    mos: {
        min: 3
    },
    packetsLostFraction: [
        {
            max: 1
        },
        {
            clearValue: 1,
            maxAverage: 3,
            sampleCount: 7
        }
    ],
    rtt: {
        max: 400
    }
};
/**
 * Count the number of values that cross the max threshold.
 * @private
 * @param max - The max allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $def52bc890d25e83$var$countHigh(max, values) {
    return values.reduce(function(highCount, value) {
        return highCount += value > max ? 1 : 0;
    }, 0);
}
/**
 * Count the number of values that cross the min threshold.
 * @private
 * @param min - The minimum allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $def52bc890d25e83$var$countLow(min, values) {
    return values.reduce(function(lowCount, value) {
        return lowCount += value < min ? 1 : 0;
    }, 0);
}
/**
 * Calculate the standard deviation from a list of numbers.
 * @private
 * @param values The list of numbers to calculate the standard deviation from.
 * @returns The standard deviation of a list of numbers.
 */ function $def52bc890d25e83$var$calculateStandardDeviation(values) {
    if (values.length <= 0) return null;
    var valueAverage = values.reduce(function(partialSum, value) {
        return partialSum + value;
    }, 0) / values.length;
    var diffSquared = values.map(function(value) {
        return Math.pow(value - valueAverage, 2);
    });
    var stdDev = Math.sqrt(diffSquared.reduce(function(partialSum, value) {
        return partialSum + value;
    }, 0) / diffSquared.length);
    return stdDev;
}
/**
 * Flatten a set of numerical sample sets into a single array of samples.
 * @param sampleSets
 */ function $def52bc890d25e83$var$flattenSamples(sampleSets) {
    return sampleSets.reduce(function(flat, current) {
        return $def52bc890d25e83$var$__spreadArrays(flat, current);
    }, []);
}
/**
 * {@link StatsMonitor} polls a peerConnection via PeerConnection.getStats
 * and emits warnings when stats cross the specified threshold values.
 */ var $def52bc890d25e83$var$StatsMonitor = /** @class */ function(_super) {
    $def52bc890d25e83$var$__extends(StatsMonitor, _super);
    /**
     * @constructor
     * @param [options] - Optional settings
     */ function StatsMonitor(options) {
        var _this = _super.call(this) || this;
        /**
         * A map of warnings with their raised time
         */ _this._activeWarnings = new Map();
        /**
         * A map of stats with the number of exceeded thresholds
         */ _this._currentStreaks = new Map();
        /**
         * Keeps track of input volumes in the last second
         */ _this._inputVolumes = [];
        /**
         * Keeps track of output volumes in the last second
         */ _this._outputVolumes = [];
        /**
         * Sample buffer. Saves most recent samples
         */ _this._sampleBuffer = [];
        /**
         * Keeps track of supplemental sample values.
         *
         * Currently used for constant audio detection. Contains an array of volume
         * samples for each sample interval.
         */ _this._supplementalSampleBuffers = {
            audioInputLevel: [],
            audioOutputLevel: []
        };
        /**
         * Whether warnings should be enabled
         */ _this._warningsEnabled = true;
        options = options || {};
        _this._getRTCStats = options.getRTCStats || $2818b1ada62f2007$exports.getRTCStats;
        _this._mos = options.Mos || $61001e332e3cd220$exports.default;
        _this._peerConnection = options.peerConnection;
        _this._thresholds = $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, $def52bc890d25e83$var$DEFAULT_THRESHOLDS), options.thresholds);
        var thresholdSampleCounts = Object.values(_this._thresholds).map(function(threshold) {
            return threshold.sampleCount;
        }).filter(function(sampleCount) {
            return !!sampleCount;
        });
        _this._maxSampleCount = Math.max.apply(Math, $def52bc890d25e83$var$__spreadArrays([
            $def52bc890d25e83$var$SAMPLE_COUNT_METRICS
        ], thresholdSampleCounts));
        if (_this._peerConnection) _this.enable(_this._peerConnection);
        return _this;
    }
    /**
     * Called when a volume sample is available
     * @param inputVolume - Input volume level from 0 to 32767
     * @param outputVolume - Output volume level from 0 to 32767
     */ StatsMonitor.prototype.addVolumes = function(inputVolume, outputVolume) {
        this._inputVolumes.push(inputVolume);
        this._outputVolumes.push(outputVolume);
    };
    /**
     * Stop sampling RTC statistics for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.disable = function() {
        if (this._sampleInterval) {
            clearInterval(this._sampleInterval);
            delete this._sampleInterval;
        }
        return this;
    };
    /**
     * Disable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.disableWarnings = function() {
        if (this._warningsEnabled) this._activeWarnings.clear();
        this._warningsEnabled = false;
        return this;
    };
    /**
     * Start sampling RTC statistics for this {@link StatsMonitor}.
     * @param peerConnection - A PeerConnection to monitor.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.enable = function(peerConnection) {
        if (peerConnection) {
            if (this._peerConnection && peerConnection !== this._peerConnection) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Attempted to replace an existing PeerConnection in StatsMonitor.enable");
            this._peerConnection = peerConnection;
        }
        if (!this._peerConnection) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Can not enable StatsMonitor without a PeerConnection");
        this._sampleInterval = this._sampleInterval || setInterval(this._fetchSample.bind(this), $def52bc890d25e83$var$SAMPLE_INTERVAL);
        return this;
    };
    /**
     * Enable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ StatsMonitor.prototype.enableWarnings = function() {
        this._warningsEnabled = true;
        return this;
    };
    /**
     * Check if there is an active warning for a specific stat and threshold
     * @param statName - The name of the stat to check
     * @param thresholdName - The name of the threshold to check
     * @returns Whether there is an active warning for a specific stat and threshold
     */ StatsMonitor.prototype.hasActiveWarning = function(statName, thresholdName) {
        var warningId = statName + ":" + thresholdName;
        return !!this._activeWarnings.get(warningId);
    };
    /**
     * Add a sample to our sample buffer and remove the oldest if we are over the limit.
     * @param sample - Sample to add
     */ StatsMonitor.prototype._addSample = function(sample) {
        var samples = this._sampleBuffer;
        samples.push(sample);
        // We store 1 extra sample so that we always have (current, previous)
        // available for all {sampleBufferSize} threshold validations.
        if (samples.length > this._maxSampleCount) samples.splice(0, samples.length - this._maxSampleCount);
    };
    /**
     * Clear an active warning.
     * @param statName - The name of the stat to clear.
     * @param thresholdName - The name of the threshold to clear
     * @param [data] - Any relevant sample data.
     */ StatsMonitor.prototype._clearWarning = function(statName, thresholdName, data) {
        var warningId = statName + ":" + thresholdName;
        var activeWarning = this._activeWarnings.get(warningId);
        if (!activeWarning || Date.now() - activeWarning.timeRaised < $def52bc890d25e83$var$WARNING_TIMEOUT) return;
        this._activeWarnings.delete(warningId);
        this.emit("warning-cleared", $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: this._thresholds[statName][thresholdName]
            }
        }));
    };
    /**
     * Create a sample object from a stats object using the previous sample, if available.
     * @param stats - Stats retrieved from getStatistics
     * @param [previousSample=null] - The previous sample to use to calculate deltas.
     * @returns A universally-formatted version of RTC stats.
     */ StatsMonitor.prototype._createSample = function(stats, previousSample) {
        var previousBytesSent = previousSample && previousSample.totals.bytesSent || 0;
        var previousBytesReceived = previousSample && previousSample.totals.bytesReceived || 0;
        var previousPacketsSent = previousSample && previousSample.totals.packetsSent || 0;
        var previousPacketsReceived = previousSample && previousSample.totals.packetsReceived || 0;
        var previousPacketsLost = previousSample && previousSample.totals.packetsLost || 0;
        var currentBytesSent = stats.bytesSent - previousBytesSent;
        var currentBytesReceived = stats.bytesReceived - previousBytesReceived;
        var currentPacketsSent = stats.packetsSent - previousPacketsSent;
        var currentPacketsReceived = stats.packetsReceived - previousPacketsReceived;
        var currentPacketsLost = stats.packetsLost - previousPacketsLost;
        var currentInboundPackets = currentPacketsReceived + currentPacketsLost;
        var currentPacketsLostFraction = currentInboundPackets > 0 ? currentPacketsLost / currentInboundPackets * 100 : 0;
        var totalInboundPackets = stats.packetsReceived + stats.packetsLost;
        var totalPacketsLostFraction = totalInboundPackets > 0 ? stats.packetsLost / totalInboundPackets * 100 : 100;
        var rttValue = typeof stats.rtt === "number" || !previousSample ? stats.rtt : previousSample.rtt;
        var audioInputLevelValues = this._inputVolumes.splice(0);
        this._supplementalSampleBuffers.audioInputLevel.push(audioInputLevelValues);
        var audioOutputLevelValues = this._outputVolumes.splice(0);
        this._supplementalSampleBuffers.audioOutputLevel.push(audioOutputLevelValues);
        return {
            audioInputLevel: Math.round($b060d15305f18a68$exports.average(audioInputLevelValues)),
            audioOutputLevel: Math.round($b060d15305f18a68$exports.average(audioOutputLevelValues)),
            bytesReceived: currentBytesReceived,
            bytesSent: currentBytesSent,
            codecName: stats.codecName,
            jitter: stats.jitter,
            mos: this._mos.calculate(rttValue, stats.jitter, previousSample && currentPacketsLostFraction),
            packetsLost: currentPacketsLost,
            packetsLostFraction: currentPacketsLostFraction,
            packetsReceived: currentPacketsReceived,
            packetsSent: currentPacketsSent,
            rtt: rttValue,
            timestamp: stats.timestamp,
            totals: {
                bytesReceived: stats.bytesReceived,
                bytesSent: stats.bytesSent,
                packetsLost: stats.packetsLost,
                packetsLostFraction: totalPacketsLostFraction,
                packetsReceived: stats.packetsReceived,
                packetsSent: stats.packetsSent
            }
        };
    };
    /**
     * Get stats from the PeerConnection and add it to our list of samples.
     */ StatsMonitor.prototype._fetchSample = function() {
        var _this = this;
        this._getSample().then(function(sample) {
            _this._addSample(sample);
            _this._raiseWarnings();
            _this.emit("sample", sample);
        }).catch(function(error) {
            _this.disable();
            // We only bubble up any errors coming from pc.getStats()
            // No need to attach a twilioError
            _this.emit("error", error);
        });
    };
    /**
     * Get stats from the PeerConnection.
     * @returns A universally-formatted version of RTC stats.
     */ StatsMonitor.prototype._getSample = function() {
        var _this = this;
        return this._getRTCStats(this._peerConnection).then(function(stats) {
            var previousSample = null;
            if (_this._sampleBuffer.length) previousSample = _this._sampleBuffer[_this._sampleBuffer.length - 1];
            return _this._createSample(stats, previousSample);
        });
    };
    /**
     * Raise a warning and log its raised time.
     * @param statName - The name of the stat to raise.
     * @param thresholdName - The name of the threshold to raise
     * @param [data] - Any relevant sample data.
     */ StatsMonitor.prototype._raiseWarning = function(statName, thresholdName, data) {
        var warningId = statName + ":" + thresholdName;
        if (this._activeWarnings.has(warningId)) return;
        this._activeWarnings.set(warningId, {
            timeRaised: Date.now()
        });
        var thresholds = this._thresholds[statName];
        var thresholdValue;
        if (Array.isArray(thresholds)) {
            var foundThreshold = thresholds.find(function(threshold) {
                return thresholdName in threshold;
            });
            if (foundThreshold) thresholdValue = foundThreshold[thresholdName];
        } else thresholdValue = this._thresholds[statName][thresholdName];
        this.emit("warning", $def52bc890d25e83$var$__assign($def52bc890d25e83$var$__assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: thresholdValue
            }
        }));
    };
    /**
     * Apply our thresholds to our array of RTCStat samples.
     */ StatsMonitor.prototype._raiseWarnings = function() {
        var _this = this;
        if (!this._warningsEnabled) return;
        Object.keys(this._thresholds).forEach(function(name) {
            return _this._raiseWarningsForStat(name);
        });
    };
    /**
     * Apply thresholds for a given stat name to our array of
     * RTCStat samples and raise or clear any associated warnings.
     * @param statName - Name of the stat to compare.
     */ StatsMonitor.prototype._raiseWarningsForStat = function(statName) {
        var _this = this;
        var limits = Array.isArray(this._thresholds[statName]) ? this._thresholds[statName] : [
            this._thresholds[statName]
        ];
        limits.forEach(function(limit) {
            var samples = _this._sampleBuffer;
            var clearCount = limit.clearCount || $def52bc890d25e83$var$SAMPLE_COUNT_CLEAR;
            var raiseCount = limit.raiseCount || $def52bc890d25e83$var$SAMPLE_COUNT_RAISE;
            var sampleCount = limit.sampleCount || _this._maxSampleCount;
            var relevantSamples = samples.slice(-sampleCount);
            var values = relevantSamples.map(function(sample) {
                return sample[statName];
            });
            // (rrowland) If we have a bad or missing value in the set, we don't
            // have enough information to throw or clear a warning. Bail out.
            var containsNull = values.some(function(value) {
                return typeof value === "undefined" || value === null;
            });
            if (containsNull) return;
            var count;
            if (typeof limit.max === "number") {
                count = $def52bc890d25e83$var$countHigh(limit.max, values);
                if (count >= raiseCount) _this._raiseWarning(statName, "max", {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) _this._clearWarning(statName, "max", {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.min === "number") {
                count = $def52bc890d25e83$var$countLow(limit.min, values);
                if (count >= raiseCount) _this._raiseWarning(statName, "min", {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) _this._clearWarning(statName, "min", {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.maxDuration === "number" && samples.length > 1) {
                relevantSamples = samples.slice(-2);
                var prevValue = relevantSamples[0][statName];
                var curValue = relevantSamples[1][statName];
                var prevStreak = _this._currentStreaks.get(statName) || 0;
                var streak = prevValue === curValue ? prevStreak + 1 : 0;
                _this._currentStreaks.set(statName, streak);
                if (streak >= limit.maxDuration) _this._raiseWarning(statName, "maxDuration", {
                    value: streak
                });
                else if (streak === 0) _this._clearWarning(statName, "maxDuration", {
                    value: prevStreak
                });
            }
            if (typeof limit.minStandardDeviation === "number") {
                var sampleSets = _this._supplementalSampleBuffers[statName];
                if (!sampleSets || sampleSets.length < limit.sampleCount) return;
                if (sampleSets.length > limit.sampleCount) sampleSets.splice(0, sampleSets.length - limit.sampleCount);
                var flatSamples = $def52bc890d25e83$var$flattenSamples(sampleSets.slice(-sampleCount));
                var stdDev = $def52bc890d25e83$var$calculateStandardDeviation(flatSamples);
                if (typeof stdDev !== "number") return;
                if (stdDev < limit.minStandardDeviation) _this._raiseWarning(statName, "minStandardDeviation", {
                    value: stdDev
                });
                else _this._clearWarning(statName, "minStandardDeviation", {
                    value: stdDev
                });
            }
            [
                [
                    "maxAverage",
                    function(x, y) {
                        return x > y;
                    }
                ],
                [
                    "minAverage",
                    function(x, y) {
                        return x < y;
                    }
                ]
            ].forEach(function(_a) {
                var thresholdName = _a[0], comparator = _a[1];
                if (typeof limit[thresholdName] === "number" && values.length >= sampleCount) {
                    var avg = $b060d15305f18a68$exports.average(values);
                    if (comparator(avg, limit[thresholdName])) _this._raiseWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                    else if (!comparator(avg, limit.clearValue || limit[thresholdName])) _this._clearWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                }
            });
        });
    };
    return StatsMonitor;
}($0bfd6a77e39eae31$exports.EventEmitter);
$def52bc890d25e83$exports.default = $def52bc890d25e83$var$StatsMonitor;





var $d421c5c6d9b8d50a$var$BACKOFF_CONFIG = {
    factor: 1.1,
    jitter: 0.5,
    max: 30000,
    min: 1
};
var $d421c5c6d9b8d50a$var$DTMF_INTER_TONE_GAP = 70;
var $d421c5c6d9b8d50a$var$DTMF_PAUSE_DURATION = 500;
var $d421c5c6d9b8d50a$var$DTMF_TONE_DURATION = 160;
var $d421c5c6d9b8d50a$var$METRICS_BATCH_SIZE = 10;
var $d421c5c6d9b8d50a$var$METRICS_DELAY = 5000;
var $d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR = {
    disconnect: true,
    info: {
        code: 31003,
        message: "Connection with Twilio was interrupted.",
        twilioError: new $9b99a7197ac9a7b1$exports.MediaErrors.ConnectionError()
    }
};
var $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES = {
    // The stat `packetsLostFraction` is monitored by two separate thresholds,
    // `maxAverage` and `max`. Each threshold emits a different warning name.
    packetsLostFraction: {
        max: "packet-loss",
        maxAverage: "packets-lost-fraction"
    }
};
var $d421c5c6d9b8d50a$var$WARNING_NAMES = {
    audioInputLevel: "audio-input-level",
    audioOutputLevel: "audio-output-level",
    bytesReceived: "bytes-received",
    bytesSent: "bytes-sent",
    jitter: "jitter",
    mos: "mos",
    rtt: "rtt"
};
var $d421c5c6d9b8d50a$var$WARNING_PREFIXES = {
    max: "high-",
    maxAverage: "high-",
    maxDuration: "constant-",
    min: "low-",
    minStandardDeviation: "constant-"
};
/**
 * A {@link Call} represents a media and signaling connection to a TwiML application.
 * @publicapi
 */ var $d421c5c6d9b8d50a$var$Call = /** @class */ function(_super) {
    $d421c5c6d9b8d50a$var$__extends(Call, _super);
    /**
     * @constructor
     * @private
     * @param config - Mandatory configuration options
     * @param [options] - Optional settings
     */ function Call(config, options) {
        var _this = _super.call(this) || this;
        /**
         * Call parameters received from Twilio for an incoming call.
         */ _this.parameters = {};
        /**
         * The number of times input volume has been the same consecutively.
         */ _this._inputVolumeStreak = 0;
        /**
         * Whether the call has been answered.
         */ _this._isAnswered = false;
        /**
         * Whether the call has been cancelled.
         */ _this._isCancelled = false;
        /**
         * Whether the call has been rejected
         */ _this._isRejected = false;
        /**
         * The most recent public input volume value. 0 -> 1 representing -100 to -30 dB.
         */ _this._latestInputVolume = 0;
        /**
         * The most recent public output volume value. 0 -> 1 representing -100 to -30 dB.
         */ _this._latestOutputVolume = 0;
        /**
         * An instance of Logger to use.
         */ _this._log = new $674d4885484aa9f2$exports.default("Call");
        /**
         * State of the {@link Call}'s media.
         */ _this._mediaStatus = Call.State.Pending;
        /**
         * A map of messages sent via sendMessage API using voiceEventSid as the key.
         * The message will be deleted once an 'ack' or an error is received from the server.
         */ _this._messages = new Map();
        /**
         * A batch of metrics samples to send to Insights. Gets cleared after
         * each send and appended to on each new sample.
         */ _this._metricsSamples = [];
        /**
         * Options passed to this {@link Call}.
         */ _this._options = {
            MediaHandler: $44123d2d42b91b4b$exports.PeerConnection,
            enableImprovedSignalingErrorPrecision: false,
            offerSdp: null,
            shouldPlayDisconnect: function() {
                return true;
            },
            voiceEventSidGenerator: $8cd2d998b29ee05f$exports.generateVoiceEventSid
        };
        /**
         * The number of times output volume has been the same consecutively.
         */ _this._outputVolumeStreak = 0;
        /**
         * Whether the {@link Call} should send a hangup on disconnect.
         */ _this._shouldSendHangup = true;
        /**
         * State of the {@link Call}'s signaling.
         */ _this._signalingStatus = Call.State.Pending;
        /**
         * A Map of Sounds to play.
         */ _this._soundcache = new Map();
        /**
         * State of the {@link Call}.
         */ _this._status = Call.State.Pending;
        /**
         * Whether the {@link Call} has been connected. Used to determine if we are reconnected.
         */ _this._wasConnected = false;
        /**
         * String representation of {@link Call} instance.
         * @private
         */ _this.toString = function() {
            return "[Twilio.Call instance]";
        };
        _this._emitWarning = function(groupPrefix, warningName, threshold, value, wasCleared, warningData) {
            var groupSuffix = wasCleared ? "-cleared" : "-raised";
            var groupName = groupPrefix + "warning" + groupSuffix;
            // Ignore constant input if the Call is muted (Expected)
            if (warningName === "constant-audio-input-level" && _this.isMuted()) return;
            var level = wasCleared ? "info" : "warning";
            // Avoid throwing false positives as warnings until we refactor volume metrics
            if (warningName === "constant-audio-output-level") level = "info";
            var payloadData = {
                threshold: threshold
            };
            if (value) {
                if (value instanceof Array) payloadData.values = value.map(function(val) {
                    if (typeof val === "number") return Math.round(val * 100) / 100;
                    return value;
                });
                else payloadData.value = value;
            }
            _this._publisher.post(level, groupName, warningName, {
                data: payloadData
            }, _this);
            if (warningName !== "constant-audio-output-level") {
                var emitName = wasCleared ? "warning-cleared" : "warning";
                _this._log.debug("#" + emitName, warningName);
                _this.emit(emitName, warningName, warningData && !wasCleared ? warningData : null);
            }
        };
        /**
         * Called when the {@link Call} receives an ack from signaling
         * @param payload
         */ _this._onAck = function(payload) {
            var acktype = payload.acktype, callsid = payload.callsid, voiceeventsid = payload.voiceeventsid;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received ack from a different callsid: " + callsid);
                return;
            }
            if (acktype === "message") _this._onMessageSent(voiceeventsid);
        };
        /**
         * Called when the {@link Call} is answered.
         * @param payload
         */ _this._onAnswer = function(payload) {
            if (typeof payload.reconnect === "string") _this._signalingReconnectToken = payload.reconnect;
            // answerOnBridge=false will send a 183 which we need to catch in _onRinging when
            // the enableRingingState flag is disabled. In that case, we will receive a 200 after
            // the callee accepts the call firing a second `accept` event if we don't
            // short circuit here.
            if (_this._isAnswered && _this._status !== Call.State.Reconnecting) return;
            _this._setCallSid(payload);
            _this._isAnswered = true;
            _this._maybeTransitionToOpen();
        };
        /**
         * Called when the {@link Call} is cancelled.
         * @param payload
         */ _this._onCancel = function(payload) {
            // (rrowland) Is this check necessary? Verify, and if so move to pstream / VSP module.
            var callsid = payload.callsid;
            if (_this.parameters.CallSid === callsid) {
                _this._isCancelled = true;
                _this._publisher.info("connection", "cancel", null, _this);
                _this._cleanupEventListeners();
                _this._mediaHandler.close();
                _this._status = Call.State.Closed;
                _this._log.debug("#cancel");
                _this.emit("cancel");
                _this._pstream.removeListener("cancel", _this._onCancel);
            }
        };
        /**
         * Called when we receive a connected event from pstream.
         * Re-emits the event.
         */ _this._onConnected = function() {
            _this._log.info("Received connected from pstream");
            if (_this._signalingReconnectToken && _this._mediaHandler.version) _this._pstream.reconnect(_this._mediaHandler.version.getSDP(), _this.parameters.CallSid, _this._signalingReconnectToken);
        };
        /**
         * Called when the {@link Call} is hung up.
         * @param payload
         */ _this._onHangup = function(payload) {
            if (_this.status() === Call.State.Closed) return;
            /**
             *  see if callsid passed in message matches either callsid or outbound id
             *  call should always have either callsid or outbound id
             *  if no callsid passed hangup anyways
             */ if (payload.callsid && (_this.parameters.CallSid || _this.outboundConnectionId)) {
                if (payload.callsid !== _this.parameters.CallSid && payload.callsid !== _this.outboundConnectionId) return;
            } else if (payload.callsid) // hangup is for another call
            return;
            _this._log.info("Received HANGUP from gateway");
            if (payload.error) {
                var code = payload.error.code;
                var errorConstructor = $9b99a7197ac9a7b1$exports.getPreciseSignalingErrorByCode(_this._options.enableImprovedSignalingErrorPrecision, code);
                var error = typeof errorConstructor !== "undefined" ? new errorConstructor(payload.error.message) : new $9b99a7197ac9a7b1$exports.GeneralErrors.ConnectionError("Error sent from gateway in HANGUP");
                _this._log.error("Received an error from the gateway:", error);
                _this._log.debug("#error", error);
                _this.emit("error", error);
            }
            _this._shouldSendHangup = false;
            _this._publisher.info("connection", "disconnected-by-remote", null, _this);
            _this._disconnect(null, true);
            _this._cleanupEventListeners();
        };
        /**
         * Called when there is a media failure.
         * Manages all media-related states and takes action base on the states
         * @param type - Type of media failure
         */ _this._onMediaFailure = function(type) {
            var _a = Call.MediaFailure, ConnectionDisconnected = _a.ConnectionDisconnected, ConnectionFailed = _a.ConnectionFailed, IceGatheringFailed = _a.IceGatheringFailed, LowBytes = _a.LowBytes;
            // These types signifies the end of a single ICE cycle
            var isEndOfIceCycle = type === ConnectionFailed || type === IceGatheringFailed;
            // All browsers except chrome doesn't update pc.iceConnectionState and pc.connectionState
            // after issuing an ICE Restart, which we use to determine if ICE Restart is complete.
            // Since we cannot detect if ICE Restart is complete, we will not retry.
            if (!$b060d15305f18a68$exports.isChrome(window, window.navigator) && type === ConnectionFailed) return _this._mediaHandler.onerror($d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR);
            // Ignore subsequent requests if ice restart is in progress
            if (_this._mediaStatus === Call.State.Reconnecting) {
                // This is a retry. Previous ICE Restart failed
                if (isEndOfIceCycle) {
                    // We already exceeded max retry time.
                    if (Date.now() - _this._mediaReconnectStartTime > $d421c5c6d9b8d50a$var$BACKOFF_CONFIG.max) {
                        _this._log.warn("Exceeded max ICE retries");
                        return _this._mediaHandler.onerror($d421c5c6d9b8d50a$var$MEDIA_DISCONNECT_ERROR);
                    }
                    // Issue ICE restart with backoff
                    try {
                        _this._mediaReconnectBackoff.backoff();
                    } catch (error) {
                        // Catch and ignore 'Backoff in progress.' errors. If a backoff is
                        // ongoing and we try to start another one, there shouldn't be a
                        // problem.
                        if (!(error.message && error.message === "Backoff in progress.")) throw error;
                    }
                }
                return;
            }
            var pc = _this._mediaHandler.version.pc;
            var isIceDisconnected = pc && pc.iceConnectionState === "disconnected";
            var hasLowBytesWarning = _this._monitor.hasActiveWarning("bytesSent", "min") || _this._monitor.hasActiveWarning("bytesReceived", "min");
            // Only certain conditions can trigger media reconnection
            if (type === LowBytes && isIceDisconnected || type === ConnectionDisconnected && hasLowBytesWarning || isEndOfIceCycle) {
                var mediaReconnectionError = new $9b99a7197ac9a7b1$exports.MediaErrors.ConnectionError("Media connection failed.");
                _this._log.warn("ICE Connection disconnected.");
                _this._publisher.warn("connection", "error", mediaReconnectionError, _this);
                _this._publisher.info("connection", "reconnecting", null, _this);
                _this._mediaReconnectStartTime = Date.now();
                _this._status = Call.State.Reconnecting;
                _this._mediaStatus = Call.State.Reconnecting;
                _this._mediaReconnectBackoff.reset();
                _this._mediaReconnectBackoff.backoff();
                _this._log.debug("#reconnecting");
                _this.emit("reconnecting", mediaReconnectionError);
            }
        };
        /**
         * Called when media call is restored
         */ _this._onMediaReconnected = function() {
            // Only trigger once.
            // This can trigger on pc.onIceConnectionChange and pc.onConnectionChange.
            if (_this._mediaStatus !== Call.State.Reconnecting) return;
            _this._log.info("ICE Connection reestablished.");
            _this._mediaStatus = Call.State.Open;
            if (_this._signalingStatus === Call.State.Open) {
                _this._publisher.info("connection", "reconnected", null, _this);
                _this._log.debug("#reconnected");
                _this.emit("reconnected");
                _this._status = Call.State.Open;
            }
        };
        /**
         * Raised when a Call receives a message from the backend.
         * @param payload - A record representing the payload of the message from the
         * Twilio backend.
         */ _this._onMessageReceived = function(payload) {
            var callsid = payload.callsid, content = payload.content, contenttype = payload.contenttype, messagetype = payload.messagetype, voiceeventsid = payload.voiceeventsid;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received a message from a different callsid: " + callsid);
                return;
            }
            var data = {
                content: content,
                contentType: contenttype,
                messageType: messagetype,
                voiceEventSid: voiceeventsid
            };
            _this._publisher.info("call-message", messagetype, {
                content_type: contenttype,
                event_type: "received",
                voice_event_sid: voiceeventsid
            }, _this);
            _this._log.debug("#messageReceived", JSON.stringify(data));
            _this.emit("messageReceived", data);
        };
        /**
         * Raised when a Call receives an 'ack' with an 'acktype' of 'message.
         * This means that the message sent via sendMessage API has been received by the signaling server.
         * @param voiceEventSid
         */ _this._onMessageSent = function(voiceEventSid) {
            if (!_this._messages.has(voiceEventSid)) {
                _this._log.warn("Received a messageSent with a voiceEventSid that doesn't exists: " + voiceEventSid);
                return;
            }
            var message = _this._messages.get(voiceEventSid);
            _this._messages.delete(voiceEventSid);
            _this._publisher.info("call-message", message === null || message === void 0 ? void 0 : message.messageType, {
                content_type: message === null || message === void 0 ? void 0 : message.contentType,
                event_type: "sent",
                voice_event_sid: voiceEventSid
            }, _this);
            _this._log.debug("#messageSent", JSON.stringify(message));
            _this.emit("messageSent", message);
        };
        /**
         * When we get a RINGING signal from PStream, update the {@link Call} status.
         * @param payload
         */ _this._onRinging = function(payload) {
            _this._setCallSid(payload);
            // If we're not in 'connecting' or 'ringing' state, this event was received out of order.
            if (_this._status !== Call.State.Connecting && _this._status !== Call.State.Ringing) return;
            var hasEarlyMedia = !!payload.sdp;
            _this._status = Call.State.Ringing;
            _this._publisher.info("connection", "outgoing-ringing", {
                hasEarlyMedia: hasEarlyMedia
            }, _this);
            _this._log.debug("#ringing");
            _this.emit("ringing", hasEarlyMedia);
        };
        /**
         * Called each time StatsMonitor emits a sample.
         * Emits stats event and batches the call stats metrics and sends them to Insights.
         * @param sample
         */ _this._onRTCSample = function(sample) {
            var callMetrics = $d421c5c6d9b8d50a$var$__assign($d421c5c6d9b8d50a$var$__assign({}, sample), {
                inputVolume: _this._latestInputVolume,
                outputVolume: _this._latestOutputVolume
            });
            _this._codec = callMetrics.codecName;
            _this._metricsSamples.push(callMetrics);
            if (_this._metricsSamples.length >= $d421c5c6d9b8d50a$var$METRICS_BATCH_SIZE) _this._publishMetrics();
            _this.emit("sample", sample);
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ _this._onSignalingError = function(payload) {
            var callsid = payload.callsid, voiceeventsid = payload.voiceeventsid, error = payload.error;
            if (_this.parameters.CallSid !== callsid) {
                _this._log.warn("Received an error from a different callsid: " + callsid);
                return;
            }
            if (voiceeventsid && _this._messages.has(voiceeventsid)) {
                // Do not emit an error here. Device is handling all signaling related errors.
                _this._messages.delete(voiceeventsid);
                _this._log.warn("Received an error while sending a message.", payload);
                _this._publisher.error("call-message", "error", {
                    code: error.code,
                    message: error.message,
                    voice_event_sid: voiceeventsid
                }, _this);
                var twilioError = void 0;
                var errorConstructor = $9b99a7197ac9a7b1$exports.getPreciseSignalingErrorByCode(!!_this._options.enableImprovedSignalingErrorPrecision, error.code);
                if (typeof errorConstructor !== "undefined") twilioError = new errorConstructor(error);
                if (!twilioError) {
                    _this._log.error("Unknown Call Message Error: ", error);
                    twilioError = new $9b99a7197ac9a7b1$exports.GeneralErrors.UnknownError(error.message, error);
                }
                _this._log.debug("#error", error, twilioError);
                _this.emit("error", twilioError);
            }
        };
        /**
         * Called when signaling is restored
         */ _this._onSignalingReconnected = function() {
            if (_this._signalingStatus !== Call.State.Reconnecting) return;
            _this._log.info("Signaling Connection reestablished.");
            _this._signalingStatus = Call.State.Open;
            if (_this._mediaStatus === Call.State.Open) {
                _this._publisher.info("connection", "reconnected", null, _this);
                _this._log.debug("#reconnected");
                _this.emit("reconnected");
                _this._status = Call.State.Open;
            }
        };
        /**
         * Called when we receive a transportClose event from pstream.
         * Re-emits the event.
         */ _this._onTransportClose = function() {
            _this._log.error("Received transportClose from pstream");
            _this._log.debug("#transportClose");
            _this.emit("transportClose");
            if (_this._signalingReconnectToken) {
                _this._status = Call.State.Reconnecting;
                _this._signalingStatus = Call.State.Reconnecting;
                _this._log.debug("#reconnecting");
                _this.emit("reconnecting", new $9b99a7197ac9a7b1$exports.SignalingErrors.ConnectionDisconnected());
            } else {
                _this._status = Call.State.Closed;
                _this._signalingStatus = Call.State.Closed;
            }
        };
        /**
         * Re-emit an StatsMonitor warning as a {@link Call}.warning or .warning-cleared event.
         * @param warningData
         * @param wasCleared - Whether this is a -cleared or -raised event.
         */ _this._reemitWarning = function(warningData, wasCleared) {
            var groupPrefix = /^audio/.test(warningData.name) ? "audio-level-" : "network-quality-";
            var warningPrefix = $d421c5c6d9b8d50a$var$WARNING_PREFIXES[warningData.threshold.name];
            /**
             * NOTE: There are two "packet-loss" warnings: `high-packet-loss` and
             * `high-packets-lost-fraction`, so in this case we need to use a different
             * `WARNING_NAME` mapping.
             */ var warningName;
            if (warningData.name in $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES) warningName = $d421c5c6d9b8d50a$var$MULTIPLE_THRESHOLD_WARNING_NAMES[warningData.name][warningData.threshold.name];
            else if (warningData.name in $d421c5c6d9b8d50a$var$WARNING_NAMES) warningName = $d421c5c6d9b8d50a$var$WARNING_NAMES[warningData.name];
            var warning = warningPrefix + warningName;
            _this._emitWarning(groupPrefix, warning, warningData.threshold.value, warningData.values || warningData.value, wasCleared, warningData);
        };
        /**
         * Re-emit an StatsMonitor warning-cleared as a .warning-cleared event.
         * @param warningData
         */ _this._reemitWarningCleared = function(warningData) {
            _this._reemitWarning(warningData, true);
        };
        _this._isUnifiedPlanDefault = config.isUnifiedPlanDefault;
        _this._soundcache = config.soundcache;
        if (typeof config.onIgnore === "function") _this._onIgnore = config.onIgnore;
        var message = options && options.twimlParams || {};
        _this.customParameters = new Map(Object.entries(message).map(function(_a) {
            var key = _a[0], val = _a[1];
            return [
                key,
                String(val)
            ];
        }));
        Object.assign(_this._options, options);
        if (_this._options.callParameters) _this.parameters = _this._options.callParameters;
        if (_this._options.reconnectToken) _this._signalingReconnectToken = _this._options.reconnectToken;
        _this._voiceEventSidGenerator = _this._options.voiceEventSidGenerator || $8cd2d998b29ee05f$exports.generateVoiceEventSid;
        _this._direction = _this.parameters.CallSid && !_this._options.reconnectCallSid ? Call.CallDirection.Incoming : Call.CallDirection.Outgoing;
        if (_this.parameters) _this.callerInfo = _this.parameters.StirStatus ? {
            isVerified: _this.parameters.StirStatus === "TN-Validation-Passed-A"
        } : null;
        else _this.callerInfo = null;
        _this._mediaReconnectBackoff = new $33fb184fd4e2bd63$exports.default($d421c5c6d9b8d50a$var$BACKOFF_CONFIG);
        _this._mediaReconnectBackoff.on("ready", function() {
            return _this._mediaHandler.iceRestart();
        });
        // temporary call sid to be used for outgoing calls
        _this.outboundConnectionId = $d421c5c6d9b8d50a$var$generateTempCallSid();
        var publisher = _this._publisher = config.publisher;
        if (_this._direction === Call.CallDirection.Incoming) publisher.info("connection", "incoming", null, _this);
        else publisher.info("connection", "outgoing", {
            preflight: _this._options.preflight,
            reconnect: !!_this._options.reconnectCallSid
        }, _this);
        var monitor = _this._monitor = new (_this._options.StatsMonitor || $def52bc890d25e83$exports.default)();
        monitor.on("sample", _this._onRTCSample);
        // First 20 seconds or so are choppy, so let's not bother with these warnings.
        monitor.disableWarnings();
        setTimeout(function() {
            return monitor.enableWarnings();
        }, $d421c5c6d9b8d50a$var$METRICS_DELAY);
        monitor.on("warning", function(data, wasCleared) {
            if (data.name === "bytesSent" || data.name === "bytesReceived") _this._onMediaFailure(Call.MediaFailure.LowBytes);
            _this._reemitWarning(data, wasCleared);
        });
        monitor.on("warning-cleared", function(data) {
            _this._reemitWarningCleared(data);
        });
        _this._mediaHandler = new _this._options.MediaHandler(config.audioHelper, config.pstream, {
            RTCPeerConnection: _this._options.RTCPeerConnection,
            codecPreferences: _this._options.codecPreferences,
            dscp: _this._options.dscp,
            forceAggressiveIceNomination: _this._options.forceAggressiveIceNomination,
            isUnifiedPlan: _this._isUnifiedPlanDefault,
            maxAverageBitrate: _this._options.maxAverageBitrate
        });
        _this.on("volume", function(inputVolume, outputVolume) {
            _this._inputVolumeStreak = _this._checkVolume(inputVolume, _this._inputVolumeStreak, _this._latestInputVolume, "input");
            _this._outputVolumeStreak = _this._checkVolume(outputVolume, _this._outputVolumeStreak, _this._latestOutputVolume, "output");
            _this._latestInputVolume = inputVolume;
            _this._latestOutputVolume = outputVolume;
        });
        _this._mediaHandler.onaudio = function(remoteAudio) {
            _this._log.debug("#audio");
            _this.emit("audio", remoteAudio);
        };
        _this._mediaHandler.onvolume = function(inputVolume, outputVolume, internalInputVolume, internalOutputVolume) {
            // (rrowland) These values mock the 0 -> 32767 format used by legacy getStats. We should look into
            // migrating to a newer standard, either 0.0 -> linear or -127 to 0 in dB, matching the range
            // chosen below.
            monitor.addVolumes(internalInputVolume / 255 * 32767, internalOutputVolume / 255 * 32767);
            // (rrowland) 0.0 -> 1.0 linear
            _this.emit("volume", inputVolume, outputVolume);
        };
        _this._mediaHandler.ondtlstransportstatechange = function(state) {
            var level = state === "failed" ? "error" : "debug";
            _this._publisher.post(level, "dtls-transport-state", state, null, _this);
        };
        _this._mediaHandler.onpcconnectionstatechange = function(state) {
            var level = "debug";
            var dtlsTransport = _this._mediaHandler.getRTCDtlsTransport();
            if (state === "failed") level = dtlsTransport && dtlsTransport.state === "failed" ? "error" : "warning";
            _this._publisher.post(level, "pc-connection-state", state, null, _this);
        };
        _this._mediaHandler.onicecandidate = function(candidate) {
            var payload = new $3b7d8de69f288bc0$exports.IceCandidate(candidate).toPayload();
            _this._publisher.debug("ice-candidate", "ice-candidate", payload, _this);
        };
        _this._mediaHandler.onselectedcandidatepairchange = function(pair) {
            var localCandidatePayload = new $3b7d8de69f288bc0$exports.IceCandidate(pair.local).toPayload();
            var remoteCandidatePayload = new $3b7d8de69f288bc0$exports.IceCandidate(pair.remote, true).toPayload();
            _this._publisher.debug("ice-candidate", "selected-ice-candidate-pair", {
                local_candidate: localCandidatePayload,
                remote_candidate: remoteCandidatePayload
            }, _this);
        };
        _this._mediaHandler.oniceconnectionstatechange = function(state) {
            var level = state === "failed" ? "error" : "debug";
            _this._publisher.post(level, "ice-connection-state", state, null, _this);
        };
        _this._mediaHandler.onicegatheringfailure = function(type) {
            _this._publisher.warn("ice-gathering-state", type, null, _this);
            _this._onMediaFailure(Call.MediaFailure.IceGatheringFailed);
        };
        _this._mediaHandler.onicegatheringstatechange = function(state) {
            _this._publisher.debug("ice-gathering-state", state, null, _this);
        };
        _this._mediaHandler.onsignalingstatechange = function(state) {
            _this._publisher.debug("signaling-state", state, null, _this);
        };
        _this._mediaHandler.ondisconnected = function(msg) {
            _this._log.warn(msg);
            _this._publisher.warn("network-quality-warning-raised", "ice-connectivity-lost", {
                message: msg
            }, _this);
            _this._log.debug("#warning", "ice-connectivity-lost");
            _this.emit("warning", "ice-connectivity-lost");
            _this._onMediaFailure(Call.MediaFailure.ConnectionDisconnected);
        };
        _this._mediaHandler.onfailed = function(msg) {
            _this._onMediaFailure(Call.MediaFailure.ConnectionFailed);
        };
        _this._mediaHandler.onconnected = function() {
            // First time _mediaHandler is connected, but ICE Gathering issued an ICE restart and succeeded.
            if (_this._status === Call.State.Reconnecting) _this._onMediaReconnected();
        };
        _this._mediaHandler.onreconnected = function(msg) {
            _this._log.info(msg);
            _this._publisher.info("network-quality-warning-cleared", "ice-connectivity-lost", {
                message: msg
            }, _this);
            _this._log.debug("#warning-cleared", "ice-connectivity-lost");
            _this.emit("warning-cleared", "ice-connectivity-lost");
            _this._onMediaReconnected();
        };
        _this._mediaHandler.onerror = function(e) {
            if (e.disconnect === true) _this._disconnect(e.info && e.info.message);
            var error = e.info.twilioError || new $9b99a7197ac9a7b1$exports.GeneralErrors.UnknownError(e.info.message);
            _this._log.error("Received an error from MediaStream:", e);
            _this._log.debug("#error", error);
            _this.emit("error", error);
        };
        _this._mediaHandler.onopen = function() {
            // NOTE(mroberts): While this may have been happening in previous
            // versions of Chrome, since Chrome 45 we have seen the
            // PeerConnection's onsignalingstatechange handler invoked multiple
            // times in the same signalingState 'stable'. When this happens, we
            // invoke this onopen function. If we invoke it twice without checking
            // for _status 'open', we'd accidentally close the PeerConnection.
            //
            // See <https://code.google.com/p/webrtc/issues/detail?id=4996>.
            if (_this._status === Call.State.Open || _this._status === Call.State.Reconnecting) return;
            else if (_this._status === Call.State.Ringing || _this._status === Call.State.Connecting) {
                _this.mute(_this._mediaHandler.isMuted);
                _this._mediaStatus = Call.State.Open;
                _this._maybeTransitionToOpen();
            } else // call was probably canceled sometime before this
            _this._mediaHandler.close();
        };
        _this._mediaHandler.onclose = function() {
            _this._status = Call.State.Closed;
            if (_this._options.shouldPlayDisconnect && _this._options.shouldPlayDisconnect() && !_this._isCancelled && !_this._isRejected) _this._soundcache.get($b171bc6ab63df54e$exports.default.SoundName.Disconnect).play();
            monitor.disable();
            _this._publishMetrics();
            if (!_this._isCancelled && !_this._isRejected) {
                // tslint:disable no-console
                _this._log.debug("#disconnect");
                _this.emit("disconnect", _this);
            }
        };
        _this._pstream = config.pstream;
        _this._pstream.on("ack", _this._onAck);
        _this._pstream.on("cancel", _this._onCancel);
        _this._pstream.on("error", _this._onSignalingError);
        _this._pstream.on("ringing", _this._onRinging);
        _this._pstream.on("transportClose", _this._onTransportClose);
        _this._pstream.on("connected", _this._onConnected);
        _this._pstream.on("message", _this._onMessageReceived);
        _this.on("error", function(error) {
            _this._publisher.error("connection", "error", {
                code: error.code,
                message: error.message
            }, _this);
            if (_this._pstream && _this._pstream.status === "disconnected") _this._cleanupEventListeners();
        });
        _this.on("disconnect", function() {
            _this._cleanupEventListeners();
        });
        return _this;
    }
    Object.defineProperty(Call.prototype, "direction", {
        /**
         * Whether this {@link Call} is incoming or outgoing.
         */ get: function() {
            return this._direction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "codec", {
        /**
         * Audio codec used for this {@link Call}. Expecting {@link Call.Codec} but
         * will copy whatever we get from RTC stats.
         */ get: function() {
            return this._codec;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Call.prototype, "connectToken", {
        /**
         * The connect token is available as soon as the call is established
         * and connected to Twilio. Use this token to reconnect to a call via the {@link Device.connect}
         * method.
         *
         * For incoming calls, it is available in the call object after the {@link Device.incomingEvent} is emitted.
         * For outgoing calls, it is available after the {@link Call.acceptEvent} is emitted.
         */ get: function() {
            var _this = this;
            var signalingReconnectToken = this._signalingReconnectToken;
            var callSid = this.parameters && this.parameters.CallSid ? this.parameters.CallSid : undefined;
            if (!signalingReconnectToken || !callSid) return;
            var customParameters = this.customParameters && typeof this.customParameters.keys === "function" ? Array.from(this.customParameters.keys()).reduce(function(result, key) {
                result[key] = _this.customParameters.get(key);
                return result;
            }, {}) : {};
            var parameters = this.parameters || {};
            return btoa(encodeURIComponent(JSON.stringify({
                customParameters: customParameters,
                parameters: parameters,
                signalingReconnectToken: signalingReconnectToken
            })));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Set the audio input tracks from a given stream.
     * @param stream
     * @private
     */ Call.prototype._setInputTracksFromStream = function(stream) {
        return this._mediaHandler.setInputTracksFromStream(stream);
    };
    /**
     * Set the audio output sink IDs.
     * @param sinkIds
     * @private
     */ Call.prototype._setSinkIds = function(sinkIds) {
        return this._mediaHandler._setSinkIds(sinkIds);
    };
    /**
     * Accept the incoming {@link Call}.
     * @param [options]
     */ Call.prototype.accept = function(options) {
        var _this = this;
        this._log.debug(".accept", options);
        if (this._status !== Call.State.Pending) {
            this._log.debug(".accept noop. status is '" + this._status + "'");
            return;
        }
        options = options || {};
        var rtcConfiguration = options.rtcConfiguration || this._options.rtcConfiguration;
        var rtcConstraints = options.rtcConstraints || this._options.rtcConstraints || {};
        var audioConstraints = {
            audio: typeof rtcConstraints.audio !== "undefined" ? rtcConstraints.audio : true
        };
        this._status = Call.State.Connecting;
        var connect = function() {
            if (_this._status !== Call.State.Connecting) {
                // call must have been canceled
                _this._cleanupEventListeners();
                _this._mediaHandler.close();
                return;
            }
            var onAnswer = function(pc) {
                // Report that the call was answered, and directionality
                var eventName = _this._direction === Call.CallDirection.Incoming ? "accepted-by-local" : "accepted-by-remote";
                _this._publisher.info("connection", eventName, null, _this);
                // Report the preferred codec and params as they appear in the SDP
                var _a = $5daed6d4af7231db$exports.getPreferredCodecInfo(_this._mediaHandler.version.getSDP()), codecName = _a.codecName, codecParams = _a.codecParams;
                _this._publisher.info("settings", "codec", {
                    codec_params: codecParams,
                    selected_codec: codecName
                }, _this);
                // Enable RTC monitoring
                _this._monitor.enable(pc);
            };
            var sinkIds = typeof _this._options.getSinkIds === "function" && _this._options.getSinkIds();
            if (Array.isArray(sinkIds)) _this._mediaHandler._setSinkIds(sinkIds).catch(function() {
            // (rrowland) We don't want this to throw to console since the customer
            // can't control this. This will most commonly be rejected on browsers
            // that don't support setting sink IDs.
            });
            _this._pstream.addListener("hangup", _this._onHangup);
            if (_this._direction === Call.CallDirection.Incoming) {
                _this._isAnswered = true;
                _this._pstream.on("answer", _this._onAnswer);
                _this._mediaHandler.answerIncomingCall(_this.parameters.CallSid, _this._options.offerSdp, rtcConfiguration, onAnswer);
            } else {
                var params = Array.from(_this.customParameters.entries()).map(function(pair) {
                    return encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]);
                }).join("&");
                _this._pstream.on("answer", _this._onAnswer);
                _this._mediaHandler.makeOutgoingCall(params, _this._signalingReconnectToken, _this._options.reconnectCallSid || _this.outboundConnectionId, rtcConfiguration, onAnswer);
            }
        };
        if (this._options.beforeAccept) this._options.beforeAccept(this);
        var inputStream = typeof this._options.getInputStream === "function" && this._options.getInputStream();
        var promise = inputStream ? this._mediaHandler.setInputTracksFromStream(inputStream) : this._mediaHandler.openDefaultDeviceWithConstraints(audioConstraints);
        promise.then(function() {
            _this._publisher.info("get-user-media", "succeeded", {
                data: {
                    audioConstraints: audioConstraints
                }
            }, _this);
            connect();
        }, function(error) {
            var twilioError;
            if (error.code === 31208 || [
                "PermissionDeniedError",
                "NotAllowedError"
            ].indexOf(error.name) !== -1) {
                twilioError = new $9b99a7197ac9a7b1$exports.UserMediaErrors.PermissionDeniedError();
                _this._publisher.error("get-user-media", "denied", {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, _this);
            } else {
                twilioError = new $9b99a7197ac9a7b1$exports.UserMediaErrors.AcquisitionFailedError();
                _this._publisher.error("get-user-media", "failed", {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, _this);
            }
            _this._disconnect();
            _this._log.debug("#error", error);
            _this.emit("error", twilioError);
        });
    };
    /**
     * Disconnect from the {@link Call}.
     */ Call.prototype.disconnect = function() {
        this._log.debug(".disconnect");
        this._disconnect();
    };
    /**
     * Get the local MediaStream, if set.
     */ Call.prototype.getLocalStream = function() {
        return this._mediaHandler && this._mediaHandler.stream;
    };
    /**
     * Get the remote MediaStream, if set.
     */ Call.prototype.getRemoteStream = function() {
        return this._mediaHandler && this._mediaHandler._remoteStream;
    };
    /**
     * Ignore the incoming {@link Call}.
     */ Call.prototype.ignore = function() {
        this._log.debug(".ignore");
        if (this._status !== Call.State.Pending) {
            this._log.debug(".ignore noop. status is '" + this._status + "'");
            return;
        }
        this._status = Call.State.Closed;
        this._mediaHandler.ignore(this.parameters.CallSid);
        this._publisher.info("connection", "ignored-by-local", null, this);
        if (this._onIgnore) this._onIgnore();
    };
    /**
     * Check whether call is muted
     */ Call.prototype.isMuted = function() {
        return this._mediaHandler.isMuted;
    };
    /**
     * Mute incoming audio.
     * @param shouldMute - Whether the incoming audio should be muted. Defaults to true.
     */ Call.prototype.mute = function(shouldMute) {
        if (shouldMute === void 0) shouldMute = true;
        this._log.debug(".mute", shouldMute);
        var wasMuted = this._mediaHandler.isMuted;
        this._mediaHandler.mute(shouldMute);
        var isMuted = this._mediaHandler.isMuted;
        if (wasMuted !== isMuted) {
            this._publisher.info("connection", isMuted ? "muted" : "unmuted", null, this);
            this._log.debug("#mute", isMuted);
            this.emit("mute", isMuted, this);
        }
    };
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has given call quality feedback. Called without a score, this
     *   will report that the customer declined to give feedback.
     * @param score - The end-user's rating of the call; an
     *   integer 1 through 5. Or undefined if the user declined to give
     *   feedback.
     * @param issue - The primary issue the end user
     *   experienced on the call. Can be: ['one-way-audio', 'choppy-audio',
     *   'dropped-call', 'audio-latency', 'noisy-call', 'echo']
     */ Call.prototype.postFeedback = function(score, issue) {
        if (typeof score === "undefined" || score === null) return this._postFeedbackDeclined();
        if (!Object.values(Call.FeedbackScore).includes(score)) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Feedback score must be one of: " + Object.values(Call.FeedbackScore));
        if (typeof issue !== "undefined" && issue !== null && !Object.values(Call.FeedbackIssue).includes(issue)) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Feedback issue must be one of: " + Object.values(Call.FeedbackIssue));
        return this._publisher.info("feedback", "received", {
            issue_name: issue,
            quality_score: score
        }, this, true);
    };
    /**
     * Reject the incoming {@link Call}.
     */ Call.prototype.reject = function() {
        this._log.debug(".reject");
        if (this._status !== Call.State.Pending) {
            this._log.debug(".reject noop. status is '" + this._status + "'");
            return;
        }
        this._isRejected = true;
        this._pstream.reject(this.parameters.CallSid);
        this._mediaHandler.reject(this.parameters.CallSid);
        this._publisher.info("connection", "rejected-by-local", null, this);
        this._cleanupEventListeners();
        this._mediaHandler.close();
        this._status = Call.State.Closed;
        this._log.debug("#reject");
        this.emit("reject");
    };
    /**
     * Send a string of digits.
     * @param digits
     */ Call.prototype.sendDigits = function(digits) {
        var _this = this;
        this._log.debug(".sendDigits", digits);
        if (digits.match(/[^0-9*#w]/)) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("Illegal character passed into sendDigits");
        var customSounds = this._options.customSounds || {};
        var sequence = [];
        digits.split("").forEach(function(digit) {
            var dtmf = digit !== "w" ? "dtmf" + digit : "";
            if (dtmf === "dtmf*") dtmf = "dtmfs";
            if (dtmf === "dtmf#") dtmf = "dtmfh";
            sequence.push(dtmf);
        });
        var playNextDigit = function() {
            var digit = sequence.shift();
            if (digit) {
                if (_this._options.dialtonePlayer && !customSounds[digit]) _this._options.dialtonePlayer.play(digit);
                else _this._soundcache.get(digit).play();
            }
            if (sequence.length) setTimeout(function() {
                return playNextDigit();
            }, 200);
        };
        playNextDigit();
        var dtmfSender = this._mediaHandler.getOrCreateDTMFSender();
        function insertDTMF(dtmfs) {
            if (!dtmfs.length) return;
            var dtmf = dtmfs.shift();
            if (dtmf && dtmf.length) dtmfSender.insertDTMF(dtmf, $d421c5c6d9b8d50a$var$DTMF_TONE_DURATION, $d421c5c6d9b8d50a$var$DTMF_INTER_TONE_GAP);
            setTimeout(insertDTMF.bind(null, dtmfs), $d421c5c6d9b8d50a$var$DTMF_PAUSE_DURATION);
        }
        if (dtmfSender) {
            if (!("canInsertDTMF" in dtmfSender) || dtmfSender.canInsertDTMF) {
                this._log.info("Sending digits using RTCDTMFSender");
                // NOTE(mroberts): We can't just map 'w' to ',' since
                // RTCDTMFSender's pause duration is 2 s and Twilio's is more
                // like 500 ms. Instead, we will fudge it with setTimeout.
                insertDTMF(digits.split("w"));
                return;
            }
            this._log.info("RTCDTMFSender cannot insert DTMF");
        }
        // send pstream message to send DTMF
        this._log.info("Sending digits over PStream");
        if (this._pstream !== null && this._pstream.status !== "disconnected") this._pstream.dtmf(this.parameters.CallSid, digits);
        else {
            var error = new $9b99a7197ac9a7b1$exports.GeneralErrors.ConnectionError("Could not send DTMF: Signaling channel is disconnected");
            this._log.debug("#error", error);
            this.emit("error", error);
        }
    };
    /**
     * Send a message to Twilio. Your backend application can listen for these
     * messages to allow communication between your frontend and backend applications.
     * <br/><br/>This feature is currently in Beta.
     * @param message - The message object to send.
     * @returns A voice event sid that uniquely identifies the message that was sent.
     */ Call.prototype.sendMessage = function(message) {
        this._log.debug(".sendMessage", JSON.stringify(message));
        var content = message.content, contentType = message.contentType, messageType = message.messageType;
        if (typeof content === "undefined" || content === null) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("`content` is empty");
        if (typeof messageType !== "string") throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("`messageType` must be a string.");
        if (messageType.length === 0) throw new $9b99a7197ac9a7b1$exports.InvalidArgumentError("`messageType` must be a non-empty string.");
        if (this._pstream === null) throw new $9b99a7197ac9a7b1$exports.InvalidStateError("Could not send CallMessage; Signaling channel is disconnected");
        var callSid = this.parameters.CallSid;
        if (typeof this.parameters.CallSid === "undefined") throw new $9b99a7197ac9a7b1$exports.InvalidStateError("Could not send CallMessage; Call has no CallSid");
        var voiceEventSid = this._voiceEventSidGenerator();
        this._messages.set(voiceEventSid, {
            content: content,
            contentType: contentType,
            messageType: messageType,
            voiceEventSid: voiceEventSid
        });
        this._pstream.sendMessage(callSid, content, contentType, messageType, voiceEventSid);
        return voiceEventSid;
    };
    /**
     * Get the current {@link Call} status.
     */ Call.prototype.status = function() {
        return this._status;
    };
    /**
     * Check the volume passed, emitting a warning if one way audio is detected or cleared.
     * @param currentVolume - The current volume for this direction
     * @param streakFieldName - The name of the field on the {@link Call} object that tracks how many times the
     *   current value has been repeated consecutively.
     * @param lastValueFieldName - The name of the field on the {@link Call} object that tracks the most recent
     *   volume for this direction
     * @param direction - The directionality of this audio track, either 'input' or 'output'
     * @returns The current streak; how many times in a row the same value has been polled.
     */ Call.prototype._checkVolume = function(currentVolume, currentStreak, lastValue, direction) {
        var wasWarningRaised = currentStreak >= 10;
        var newStreak = 0;
        if (lastValue === currentVolume) newStreak = currentStreak;
        if (newStreak >= 10) this._emitWarning("audio-level-", "constant-audio-" + direction + "-level", 10, newStreak, false);
        else if (wasWarningRaised) this._emitWarning("audio-level-", "constant-audio-" + direction + "-level", 10, newStreak, true);
        return newStreak;
    };
    /**
     * Clean up event listeners.
     */ Call.prototype._cleanupEventListeners = function() {
        var _this = this;
        var cleanup = function() {
            if (!_this._pstream) return;
            _this._pstream.removeListener("ack", _this._onAck);
            _this._pstream.removeListener("answer", _this._onAnswer);
            _this._pstream.removeListener("cancel", _this._onCancel);
            _this._pstream.removeListener("error", _this._onSignalingError);
            _this._pstream.removeListener("hangup", _this._onHangup);
            _this._pstream.removeListener("ringing", _this._onRinging);
            _this._pstream.removeListener("transportClose", _this._onTransportClose);
            _this._pstream.removeListener("connected", _this._onConnected);
            _this._pstream.removeListener("message", _this._onMessageReceived);
        };
        // This is kind of a hack, but it lets us avoid rewriting more code.
        // Basically, there's a sequencing problem with the way PeerConnection raises
        // the
        //
        //   Cannot establish call. SDK is disconnected
        //
        // error in Call#accept. It calls PeerConnection#onerror, which emits
        // the error event on Call. An error handler on Call then calls
        // cleanupEventListeners, but then control returns to Call#accept. It's
        // at this point that we add a listener for the answer event that never gets
        // removed. setTimeout will allow us to rerun cleanup again, _after_
        // Call#accept returns.
        cleanup();
        setTimeout(cleanup, 0);
    };
    /**
     * Create the payload wrapper for a batch of metrics to be sent to Insights.
     */ Call.prototype._createMetricPayload = function() {
        var payload = {
            call_sid: this.parameters.CallSid,
            dscp: !!this._options.dscp,
            sdk_version: $e9da3ede67c59403$exports.RELEASE_VERSION
        };
        if (this._options.gateway) payload.gateway = this._options.gateway;
        payload.direction = this._direction;
        return payload;
    };
    /**
     * Disconnect the {@link Call}.
     * @param message - A message explaining why the {@link Call} is being disconnected.
     * @param wasRemote - Whether the disconnect was triggered locally or remotely.
     */ Call.prototype._disconnect = function(message, wasRemote) {
        message = typeof message === "string" ? message : null;
        if (this._status !== Call.State.Open && this._status !== Call.State.Connecting && this._status !== Call.State.Reconnecting && this._status !== Call.State.Ringing) return;
        this._log.info("Disconnecting...");
        // send pstream hangup message
        if (this._pstream !== null && this._pstream.status !== "disconnected" && this._shouldSendHangup) {
            var callsid = this.parameters.CallSid || this.outboundConnectionId;
            if (callsid) this._pstream.hangup(callsid, message);
        }
        this._cleanupEventListeners();
        this._mediaHandler.close();
        if (!wasRemote) this._publisher.info("connection", "disconnected-by-local", null, this);
    };
    /**
     * Transition to {@link CallStatus.Open} if criteria is met.
     */ Call.prototype._maybeTransitionToOpen = function() {
        var wasConnected = this._wasConnected;
        if (this._isAnswered) {
            this._onSignalingReconnected();
            this._signalingStatus = Call.State.Open;
            if (this._mediaHandler && this._mediaHandler.status === "open") {
                this._status = Call.State.Open;
                if (!this._wasConnected) {
                    this._wasConnected = true;
                    this._log.debug("#accept");
                    this.emit("accept", this);
                }
            }
        }
    };
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has ignored a request for feedback.
     */ Call.prototype._postFeedbackDeclined = function() {
        return this._publisher.info("feedback", "received-none", null, this, true);
    };
    /**
     * Publish the current set of queued metrics samples to Insights.
     */ Call.prototype._publishMetrics = function() {
        var _this = this;
        if (this._metricsSamples.length === 0) return;
        this._publisher.postMetrics("quality-metrics-samples", "metrics-sample", this._metricsSamples.splice(0), this._createMetricPayload(), this).catch(function(e) {
            _this._log.warn("Unable to post metrics to Insights. Received error:", e);
        });
    };
    /**
     * Set the CallSid
     * @param payload
     */ Call.prototype._setCallSid = function(payload) {
        var callSid = payload.callsid;
        if (!callSid) return;
        this.parameters.CallSid = callSid;
        this._mediaHandler.callSid = callSid;
    };
    /**
     * String representation of the {@link Call} class.
     * @private
     */ Call.toString = function() {
        return "[Twilio.Call class]";
    };
    return Call;
}($0bfd6a77e39eae31$exports.EventEmitter);
(function(Call) {
    /**
     * Possible states of the {@link Call}.
     */ var State;
    (function(State) {
        State["Closed"] = "closed";
        State["Connecting"] = "connecting";
        State["Open"] = "open";
        State["Pending"] = "pending";
        State["Reconnecting"] = "reconnecting";
        State["Ringing"] = "ringing";
    })(State = Call.State || (Call.State = {}));
    /**
     * Different issues that may have been experienced during a call, that can be
     * reported to Twilio Insights via {@link Call}.postFeedback().
     */ var FeedbackIssue;
    (function(FeedbackIssue) {
        FeedbackIssue["AudioLatency"] = "audio-latency";
        FeedbackIssue["ChoppyAudio"] = "choppy-audio";
        FeedbackIssue["DroppedCall"] = "dropped-call";
        FeedbackIssue["Echo"] = "echo";
        FeedbackIssue["NoisyCall"] = "noisy-call";
        FeedbackIssue["OneWayAudio"] = "one-way-audio";
    })(FeedbackIssue = Call.FeedbackIssue || (Call.FeedbackIssue = {}));
    /**
     * A rating of call quality experienced during a call, to be reported to Twilio Insights
     * via {@link Call}.postFeedback().
     */ var FeedbackScore;
    (function(FeedbackScore) {
        FeedbackScore[FeedbackScore["One"] = 1] = "One";
        FeedbackScore[FeedbackScore["Two"] = 2] = "Two";
        FeedbackScore[FeedbackScore["Three"] = 3] = "Three";
        FeedbackScore[FeedbackScore["Four"] = 4] = "Four";
        FeedbackScore[FeedbackScore["Five"] = 5] = "Five";
    })(FeedbackScore = Call.FeedbackScore || (Call.FeedbackScore = {}));
    /**
     * The directionality of the {@link Call}, whether incoming or outgoing.
     */ var CallDirection;
    (function(CallDirection) {
        CallDirection["Incoming"] = "INCOMING";
        CallDirection["Outgoing"] = "OUTGOING";
    })(CallDirection = Call.CallDirection || (Call.CallDirection = {}));
    /**
     * Valid audio codecs to use for the media connection.
     */ var Codec;
    (function(Codec) {
        Codec["Opus"] = "opus";
        Codec["PCMU"] = "pcmu";
    })(Codec = Call.Codec || (Call.Codec = {}));
    /**
     * Possible ICE Gathering failures
     */ var IceGatheringFailureReason;
    (function(IceGatheringFailureReason) {
        IceGatheringFailureReason["None"] = "none";
        IceGatheringFailureReason["Timeout"] = "timeout";
    })(IceGatheringFailureReason = Call.IceGatheringFailureReason || (Call.IceGatheringFailureReason = {}));
    /**
     * Possible media failures
     */ var MediaFailure;
    (function(MediaFailure) {
        MediaFailure["ConnectionDisconnected"] = "ConnectionDisconnected";
        MediaFailure["ConnectionFailed"] = "ConnectionFailed";
        MediaFailure["IceGatheringFailed"] = "IceGatheringFailed";
        MediaFailure["LowBytes"] = "LowBytes";
    })(MediaFailure = Call.MediaFailure || (Call.MediaFailure = {}));
})($d421c5c6d9b8d50a$var$Call || ($d421c5c6d9b8d50a$var$Call = {}));
function $d421c5c6d9b8d50a$var$generateTempCallSid() {
    return "TJSxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* tslint:disable:no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* tslint:enable:no-bitwise */ return v.toString(16);
    });
}
$d421c5c6d9b8d50a$exports.default = $d421c5c6d9b8d50a$var$Call;


$51a4b996f723547d$exports.Call = $d421c5c6d9b8d50a$exports.default;

$51a4b996f723547d$exports.Device = $b171bc6ab63df54e$exports.default;

$51a4b996f723547d$exports.TwilioError = $9b99a7197ac9a7b1$exports;

Object.defineProperty($51a4b996f723547d$exports, "Logger", {
    enumerable: true,
    get: function() {
        return $674d4885484aa9f2$exports.Logger;
    }
});

Object.defineProperty($51a4b996f723547d$exports, "PreflightTest", {
    enumerable: true,
    get: function() {
        return $87f1bccdd5744d30$exports.PreflightTest;
    }
});



var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $1BSKa = parcelRequire("1BSKa");

var $eOD8X = parcelRequire("eOD8X");

var $cD0nt = parcelRequire("cD0nt");

var $jnPOB = parcelRequire("jnPOB");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");


var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $eZVvM = parcelRequire("eZVvM");
var $c5282e84bbfd10c8$var$counter = 0;
var $c5282e84bbfd10c8$var$buckets = {};
var $c5282e84bbfd10c8$export$1b5647019d6b9cab = function(fn, ms) {
    var _a;
    var id = $c5282e84bbfd10c8$var$counter++;
    if ($c5282e84bbfd10c8$var$buckets[ms]) $c5282e84bbfd10c8$var$buckets[ms].listeners[id] = fn;
    else {
        var timer = setInterval(function() {
            var listeners = $c5282e84bbfd10c8$var$buckets[ms].listeners;
            var didThrow = false;
            var lastError;
            for(var _i = 0, _a = Object.values(listeners); _i < _a.length; _i++){
                var listener = _a[_i];
                try {
                    listener();
                } catch (error) {
                    didThrow = true;
                    lastError = error;
                }
            }
            if (didThrow) throw lastError;
        }, ms);
        $c5282e84bbfd10c8$var$buckets[ms] = {
            ms: ms,
            timer: timer,
            listeners: (_a = {}, _a[id] = fn, _a)
        };
    }
    return {
        bucket: $c5282e84bbfd10c8$var$buckets[ms],
        id: id
    };
};
var $c5282e84bbfd10c8$export$f95833d4abc1f553 = function(_a) {
    var bucket = _a.bucket, id = _a.id;
    delete bucket.listeners[id];
    var hasListeners = false;
    for(var listener in bucket.listeners){
        hasListeners = true;
        break;
    }
    if (!hasListeners) {
        clearInterval(bucket.timer);
        delete $c5282e84bbfd10c8$var$buckets[bucket.ms];
    }
};


var $98ca4c1b8d99238b$var$useHarmonicIntervalFn = function(fn, delay) {
    if (delay === void 0) delay = 0;
    var latestCallback = (0, $eZVvM.useRef)(function() {});
    (0, $eZVvM.useEffect)(function() {
        latestCallback.current = fn;
    });
    (0, $eZVvM.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = (0, $c5282e84bbfd10c8$export$1b5647019d6b9cab)(function() {
                return latestCallback.current();
            }, delay);
            return function() {
                return (0, $c5282e84bbfd10c8$export$f95833d4abc1f553)(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
var $98ca4c1b8d99238b$export$2e2bcd8739ae039 = $98ca4c1b8d99238b$var$useHarmonicIntervalFn;



var $kvR7a = parcelRequire("kvR7a");
var $2dae22fc9bb2c196$exports = {};
!function(t, s) {
    $2dae22fc9bb2c196$exports = s();
}($2dae22fc9bb2c196$exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).extend((0, (/*@__PURE__*/$parcel$interopDefault($2dae22fc9bb2c196$exports))));
const $91d7fbf064bcdcd2$var$TimeDuration = ()=>{
    const started = (0, $eZVvM.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))().valueOf(), []);
    const [time, setTime] = (0, $eZVvM.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).duration((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))()).diff((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(started))).format("mm:ss"));
    (0, $98ca4c1b8d99238b$export$2e2bcd8739ae039)(()=>{
        setTime((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a))).duration((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))()).diff((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(started))).format("mm:ss"));
    }, 1000);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: time
    });
};
var $91d7fbf064bcdcd2$export$2e2bcd8739ae039 = $91d7fbf064bcdcd2$var$TimeDuration;




var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c9195da5caeb5ffe$var$SvgOpenCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("g", {
            clipPath: "url('9310b962156e51b9')",
            fill: "#4A4A4A",
            children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M15.808 11.685c-.384-.4-.848-.615-1.34-.615-.488 0-.956.21-1.356.611l-1.254 1.25c-.103-.056-.206-.108-.305-.16a5.032 5.032 0 0 1-.392-.21c-1.174-.745-2.24-1.717-3.264-2.974-.496-.626-.829-1.154-1.07-1.689.324-.297.626-.607.92-.904.11-.111.221-.226.332-.337.833-.833.833-1.912 0-2.744L6.997 2.83c-.123-.123-.25-.25-.369-.377-.238-.246-.488-.5-.746-.737-.384-.38-.844-.583-1.328-.583-.484 0-.952.202-1.348.583l-.008.008-1.349 1.36a2.901 2.901 0 0 0-.86 1.844c-.095 1.158.246 2.236.508 2.942.642 1.733 1.602 3.34 3.033 5.06a18.66 18.66 0 0 0 6.214 4.866c.912.432 2.13.944 3.49 1.031.083.004.17.008.25.008.916 0 1.685-.33 2.288-.983.004-.008.012-.012.016-.02.206-.25.444-.476.694-.718.17-.163.345-.333.515-.512.393-.408.599-.884.599-1.372 0-.491-.21-.963-.61-1.36l-2.178-2.185Zm1.42 4.176c-.004 0-.004.004 0 0-.155.166-.313.317-.484.484-.258.245-.52.503-.765.793-.4.428-.873.63-1.491.63-.06 0-.123 0-.183-.004-1.178-.075-2.272-.535-3.093-.928a17.616 17.616 0 0 1-5.853-4.584c-1.352-1.63-2.256-3.137-2.855-4.754C2.135 6.51 2 5.74 2.06 5.015a1.82 1.82 0 0 1 .547-1.178l1.352-1.352c.194-.182.4-.281.603-.281.25 0 .452.15.579.277l.012.012c.242.226.472.46.714.71l.376.384L7.326 4.67c.42.42.42.809 0 1.23-.115.114-.226.23-.341.34-.333.341-.65.659-.995.968-.008.008-.016.012-.02.02-.341.34-.278.674-.207.9l.012.036c.282.682.678 1.324 1.281 2.09l.004.004c1.095 1.348 2.249 2.399 3.522 3.204.162.103.329.186.487.265.143.072.278.14.393.21.016.008.032.02.048.028a.86.86 0 0 0 .392.1c.33 0 .536-.207.603-.274l1.356-1.356c.135-.135.35-.298.599-.298.246 0 .448.155.571.29l.008.008 2.185 2.185c.408.404.408.82.004 1.24ZM11.113 4.515a5.029 5.029 0 0 1 2.736 1.42 5.055 5.055 0 0 1 1.42 2.736c.043.262.27.444.527.444.032 0 .06-.004.091-.008a.536.536 0 0 0 .44-.618 6.116 6.116 0 0 0-1.717-3.312A6.116 6.116 0 0 0 11.3 3.46a.538.538 0 0 0-.619.437.53.53 0 0 0 .433.618ZM19.726 8.334A10.063 10.063 0 0 0 16.9 2.881 10.062 10.062 0 0 0 11.446.054a.533.533 0 0 0-.615.436.538.538 0 0 0 .44.619 9.01 9.01 0 0 1 4.874 2.526 8.984 8.984 0 0 1 2.526 4.874c.044.261.27.444.528.444.031 0 .06-.004.09-.008a.525.525 0 0 0 .437-.61Z"
            })
        })
    });
var $c9195da5caeb5ffe$export$2e2bcd8739ae039 = $c9195da5caeb5ffe$var$SvgOpenCall;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c9e4713e7e3526f7$var$SvgCloseCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        width: "6.4rem",
        height: "6.4rem",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "m14.675 11.698-1.833 1.859a6.503 6.503 0 0 0-1.27 7.54 71.657 71.657 0 0 0 13.108 17.94 1.92 1.92 0 1 1-2.711 2.72A75.492 75.492 0 0 1 8.152 22.842l-.01-.02a10.343 10.343 0 0 1 2-11.997l1.82-1.845a7.603 7.603 0 0 1 10.72 0l.003.004 4.024 4.023a7.604 7.604 0 0 1 0 10.72l-.004.004-2.223 2.223a75.077 75.077 0 0 0 6.218 7.07 1.92 1.92 0 0 1-2.719 2.712 78.923 78.923 0 0 1-7.583-8.816 1.92 1.92 0 0 1 .186-2.5l3.401-3.4a3.763 3.763 0 0 0 .002-5.304l-4.013-4.013-.002-.002a3.763 3.763 0 0 0-5.298-.004ZM45.352 38.646a3.71 3.71 0 0 0-2.64 1.103l-.009.009-3.405 3.405a1.92 1.92 0 0 1-2.489.193 105.487 105.487 0 0 1-2.866-2.194l-.028-.022a1.92 1.92 0 0 1 2.369-3.022c.5.391.992.777 1.478 1.15l2.222-2.222a7.548 7.548 0 0 1 8.28-1.656 7.548 7.548 0 0 1 2.46 1.66l3.978 3.978.004.004a7.551 7.551 0 0 1 .005 10.73l-1.81 1.835-.002.003a10.367 10.367 0 0 1-12.002 1.98l-.01-.005a73.6 73.6 0 0 1-13.144-8.543 1.92 1.92 0 1 1 2.424-2.979 69.759 69.759 0 0 0 12.451 8.095 6.528 6.528 0 0 0 7.55-1.248c.001 0 0 0 0 0l1.834-1.86a3.706 3.706 0 0 0 .817-4.07 3.716 3.716 0 0 0-.816-1.21l-.008-.009-4.002-4.002a3.711 3.711 0 0 0-2.64-1.103Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M58.958 4.837c.75.75.75 1.966 0 2.716l-51.2 51.2a1.92 1.92 0 0 1-2.715-2.716l51.2-51.2a1.92 1.92 0 0 1 2.715 0Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $c9e4713e7e3526f7$export$2e2bcd8739ae039 = $c9e4713e7e3526f7$var$SvgCloseCall;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $dee41ba920963cc7$var$SvgEstablishCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M60.07 45.188c-.106-.088-12.084-8.676-15.334-8.098-1.562.276-2.456 1.34-4.246 3.474a61.081 61.081 0 0 1-1.518 1.752 24.919 24.919 0 0 1-3.302-1.344A27.4 27.4 0 0 1 23.028 28.33a24.919 24.919 0 0 1-1.344-3.302 63.181 63.181 0 0 1 1.764-1.528c2.122-1.78 3.186-2.674 3.462-4.238.566-3.238-8.01-15.226-8.098-15.334A4.578 4.578 0 0 0 15.4 2C11.924 2 2 14.872 2 17.042c0 .126.182 12.934 15.976 29C34.024 61.818 46.832 62 46.958 62 49.128 62 62 52.076 62 48.6a4.573 4.573 0 0 0-1.93-3.412Zm-13.332 12.8c-1.748-.144-12.496-1.562-25.934-14.764-13.27-13.51-14.652-24.288-14.79-25.958a54.109 54.109 0 0 1 9.412-11.122c.08.08.186.2.322.356a70.776 70.776 0 0 1 7.148 12.126 23.774 23.774 0 0 1-2.032 1.822 20.068 20.068 0 0 0-3.024 2.844 1.999 1.999 0 0 0-.342 1.502 22.836 22.836 0 0 0 1.93 5.282A31.42 31.42 0 0 0 33.924 44.57a22.779 22.779 0 0 0 5.282 1.932 1.988 1.988 0 0 0 1.502-.342 20.232 20.232 0 0 0 2.856-3.036c.626-.748 1.464-1.746 1.78-2.028A70.324 70.324 0 0 1 57.5 48.252c.166.14.282.248.36.318a54.061 54.061 0 0 1-11.122 9.414v.004ZM44.97 29l12.245-12.245v6.386H60v-9.748A1.393 1.393 0 0 0 58.607 12H48.86v2.785h6.386L43 27.031 44.97 29Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M49.03 3 36.786 15.245V8.86H34v9.748A1.393 1.393 0 0 0 35.393 20h9.748v-2.785h-6.386L51 4.969 49.03 3Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $dee41ba920963cc7$export$2e2bcd8739ae039 = $dee41ba920963cc7$var$SvgEstablishCall;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $756dda2289d9c53f$var$SvgRingCall = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M60.07 45.188c-.106-.088-12.084-8.676-15.334-8.098-1.562.276-2.456 1.34-4.246 3.474a61.081 61.081 0 0 1-1.518 1.752 24.919 24.919 0 0 1-3.302-1.344A27.4 27.4 0 0 1 23.028 28.33a24.919 24.919 0 0 1-1.344-3.302 63.181 63.181 0 0 1 1.764-1.528c2.122-1.78 3.186-2.674 3.462-4.238.566-3.238-8.01-15.226-8.098-15.334A4.578 4.578 0 0 0 15.4 2C11.924 2 2 14.872 2 17.042c0 .126.182 12.934 15.976 29C34.024 61.818 46.832 62 46.958 62 49.128 62 62 52.076 62 48.6a4.573 4.573 0 0 0-1.93-3.412Zm-13.332 12.8c-1.748-.144-12.496-1.562-25.934-14.764-13.27-13.51-14.652-24.288-14.79-25.958a54.109 54.109 0 0 1 9.412-11.122c.08.08.186.2.322.356a70.776 70.776 0 0 1 7.148 12.126 23.774 23.774 0 0 1-2.032 1.822 20.068 20.068 0 0 0-3.024 2.844 1.999 1.999 0 0 0-.342 1.502 22.836 22.836 0 0 0 1.93 5.282A31.42 31.42 0 0 0 33.924 44.57a22.779 22.779 0 0 0 5.282 1.932 1.988 1.988 0 0 0 1.502-.342 20.232 20.232 0 0 0 2.856-3.036c.626-.748 1.464-1.746 1.78-2.028A70.324 70.324 0 0 1 57.5 48.252c.166.14.282.248.36.318a54.061 54.061 0 0 1-11.122 9.414v.004Z",
                fill: "#4A4A4A"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M37.414 29.414 55 11.828V21h4V7a2 2 0 0 0-2-2H43v4h9.172L34.586 26.586l2.828 2.828Z",
                fill: "#4A4A4A"
            })
        ]
    });
var $756dda2289d9c53f$export$2e2bcd8739ae039 = $756dda2289d9c53f$var$SvgRingCall;




const $5a8921586fbf1614$var$IconComponent = {
    connecting: (0, $dee41ba920963cc7$export$2e2bcd8739ae039),
    ringing: (0, $756dda2289d9c53f$export$2e2bcd8739ae039),
    open: (0, $c9195da5caeb5ffe$export$2e2bcd8739ae039),
    close: (0, $c9e4713e7e3526f7$export$2e2bcd8739ae039),
    error: (0, $7f4a49b3533c9276$export$2e2bcd8739ae039)
};
const $5a8921586fbf1614$var$StatusIcon = ({ status: status })=>{
    const StatusIconComponent = (0, $eZVvM.useMemo)(()=>$5a8921586fbf1614$var$IconComponent[status], [
        status
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)(StatusIconComponent, {
        width: "6.4rem",
        height: "6.4rem"
    });
};
const $5a8921586fbf1614$var$CallingModal = ({ status: status, isCallingReception: isCallingReception, willNavigateToAccessControl: willNavigateToAccessControl, onEndCall: onEndCall, onClose: onClose })=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "call"
    ]);
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToAccessControl && status === "close") return "closeAccess";
        // if (isCallingReception && status === "close") {
        //   return "closeReception";
        // }
        if (isCallingReception && status === "ringing") return "ringingReception";
        return status;
    }, [
        willNavigateToAccessControl,
        isCallingReception,
        status
    ]);
    if (!status) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "main-modal",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$755918b48c75c65a)),
                className: "main-modal__background"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$1c33d2a8eb772259)),
                className: "main-modal__content text-center",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        className: `text-${status} mt-5`,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `call:status.${statusKey}.title`
                        })
                    }),
                    status === "open" && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h2",
                        style: {
                            height: "7rem"
                        },
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $91d7fbf064bcdcd2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "main-modal__icon-box",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            className: "m-auto call",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($5a8921586fbf1614$var$StatusIcon, {
                                status: status
                            })
                        })
                    }),
                    status !== "close" && status !== "error" && /*#__PURE__*/ (0, $bhfvP.jsx)("button", {
                        className: "display-6 py-4 px-5 text-white bg-secondary fs-medium rounded",
                        onClick: onEndCall,
                        children: t("call:cancelBtn")
                    }),
                    (status === "close" || status === "error") && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "main-modal__close",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $56ba4849816b834d$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $5a8921586fbf1614$export$2e2bcd8739ae039 = $5a8921586fbf1614$var$CallingModal;



var $219y6 = parcelRequire("219y6");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
const $8f3c957259b6070e$var$CallActiveContext = /*#__PURE__*/ (0, $eZVvM.createContext)({
    callActive: false,
    setCallActive: ()=>undefined
});
const $8f3c957259b6070e$export$8606ddc51e61fc8f = ({ children: children })=>{
    const [callActive, setActive] = (0, $eZVvM.useState)(false);
    const setCallActive = (0, $eZVvM.useCallback)((active)=>{
        setActive(active);
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            callActive: callActive,
            setCallActive: setCallActive
        }), [
        callActive,
        setCallActive
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($8f3c957259b6070e$var$CallActiveContext.Provider, {
        value: value,
        children: children
    });
};
const $8f3c957259b6070e$export$86214f0f28cf0b34 = ()=>(0, $eZVvM.useContext)($8f3c957259b6070e$var$CallActiveContext);
var $8f3c957259b6070e$export$2e2bcd8739ae039 = $8f3c957259b6070e$var$CallActiveContext;



var $kCXUJ = parcelRequire("kCXUJ");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $cD0nt = parcelRequire("cD0nt");

const $3b483b17d943788b$export$bb937f14df32ee16 = ({ type: type, id: id } = {})=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { enableExternalDoorTrigger: enableExternalDoorTrigger, accessControl: accessControl } = (0, $cD0nt.useDigitalReceptionMetadata)();
    const { isAccessAllowedForGuestsForCheckin: isAccessAllowedForGuestsForCheckin, isAccessAllowedForMeetingAttendeesForCheckin: isAccessAllowedForMeetingAttendeesForCheckin, isAccessEnabledForAutoOpenForCheckin: isAccessEnabledForAutoOpenForCheckin, accessController: accessController } = (0, $cD0nt.useAccessSettings)();
    const { trigger: trigger, doorStatus: doorStatus, doorModal: doorModal } = (0, $325562920a04a1bd$export$27b435a0411fd08e)();
    const willNavigateToCheckinAccessControl = (0, $eZVvM.useMemo)(()=>{
        return !!(accessController && (type === "MeetingAttendee" && isAccessAllowedForMeetingAttendeesForCheckin || type === "Guest" && isAccessAllowedForGuestsForCheckin));
    }, [
        type,
        accessController,
        isAccessAllowedForMeetingAttendeesForCheckin,
        isAccessAllowedForGuestsForCheckin
    ]);
    const willNavigateToCheckinAccessControlPage = (0, $eZVvM.useMemo)(()=>{
        return willNavigateToCheckinAccessControl && !(isAccessEnabledForAutoOpenForCheckin && accessController);
    }, [
        willNavigateToCheckinAccessControl,
        isAccessEnabledForAutoOpenForCheckin,
        accessController
    ]);
    const handleCheckinAccessNavigation = (0, $eZVvM.useCallback)(()=>{
        if (enableExternalDoorTrigger && (type === "MeetingAttendee" || type === "Guest")) {
            navigate("/door", {
                replace: true
            });
            return;
        }
        if (accessControl && type === "MeetingAttendee") {
            navigate(`/door-control/${id}`, {
                replace: true
            });
            return;
        }
        if (willNavigateToCheckinAccessControl) {
            if (isAccessEnabledForAutoOpenForCheckin && accessController) {
                trigger(accessController);
                return;
            }
            navigate(`/access-control/${accessController}`, {
                replace: true
            });
            return;
        }
        navigate("/", {
            replace: true
        });
    }, [
        id,
        type,
        accessControl,
        enableExternalDoorTrigger,
        accessController,
        willNavigateToCheckinAccessControl,
        isAccessEnabledForAutoOpenForCheckin,
        trigger,
        navigate
    ]);
    return {
        handleCheckinAccessNavigation: handleCheckinAccessNavigation,
        willNavigateToCheckinAccessControl: willNavigateToCheckinAccessControl,
        willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage,
        isDoorOpening: !!doorStatus,
        accessSwitchModal: doorModal
    };
};



var $eZVvM = parcelRequire("eZVvM");
var $78c28c50acae20ba$exports = {};

$78c28c50acae20ba$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "start_call.f7448007.mp3";


var $47b497da4426a11c$exports = {};

$47b497da4426a11c$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "call_ringing_repeat_me.983b3e87.mp3";


var $b2e743cb0f71c8cb$exports = {};

$b2e743cb0f71c8cb$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "call_started_talk_now.f356b497.mp3";


var $94a6b8e08ade5f89$exports = {};

$94a6b8e08ade5f89$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "end_call.474f44e0.mp3";


const $dcc94db3b6c367f7$export$a712c06eeb4d5ac8 = ()=>{
    const startSound = (0, $eZVvM.useRef)(new Audio(new URL($78c28c50acae20ba$exports).href));
    const ringingSound = (0, $eZVvM.useRef)(new Audio(new URL($47b497da4426a11c$exports).href));
    const connectedSound = (0, $eZVvM.useRef)(new Audio(new URL($b2e743cb0f71c8cb$exports).href));
    const endSound = (0, $eZVvM.useRef)(new Audio(new URL($94a6b8e08ade5f89$exports).href));
    (0, $eZVvM.useEffect)(()=>{
        if (ringingSound.current) ringingSound.current.loop = true;
    }, []);
    const stopAllSounds = ()=>{
        [
            startSound,
            ringingSound,
            connectedSound,
            endSound
        ].forEach((audioRef)=>{
            const audio = audioRef.current;
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        });
    };
    const playSound = async (audioRef)=>{
        try {
            var _ringingSound_current;
            if (audioRef === ringingSound && !((_ringingSound_current = ringingSound.current) === null || _ringingSound_current === void 0 ? void 0 : _ringingSound_current.paused)) return;
            stopAllSounds();
            const audio = audioRef.current;
            if (audio) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, 50);
                });
                audio.currentTime = 0;
                await audio.play();
            }
        } catch (error) {
            console.log("Error playing sound:", error);
        }
    };
    return {
        startSound: startSound,
        ringingSound: ringingSound,
        connectedSound: connectedSound,
        endSound: endSound,
        playSound: playSound,
        stopAllSounds: stopAllSounds
    };
};


const $7195b02b4387c5f9$var$isDev = false;
const $7195b02b4387c5f9$var$CLIENT_TOKEN = $7195b02b4387c5f9$var$isDev ? "1" : window.location.pathname.split("/")[2];
const $7195b02b4387c5f9$var$apiUrl = (0, $eOD8X.getApiUrl)();
const $7195b02b4387c5f9$var$api = (0, $a7H8f.default).create({
    baseURL: `${$7195b02b4387c5f9$var$apiUrl}/api/v2`,
    headers: {
        "client-token": $7195b02b4387c5f9$var$CLIENT_TOKEN
    }
});
var $ea42a6a2d9a0f5f3$exports = {};

$ea42a6a2d9a0f5f3$exports = (parcelRequire("eDQ3p")).getBundleURL("5HDbK") + "silence.e570ca27.mp3";




const $7195b02b4387c5f9$var$Calling = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    var _match_params, _match_params1, _accessEventData_accessEvent_receiver, _accessEventData_accessEvent, _accessEventData_accessEvent_customReceiver, _accessEventData_accessEvent1, _accessEventData_accessEvent2;
    const navigate = (0, $9B9bN.useNavigate)();
    const { location: { pathname: pathname } } = window;
    const { online: online } = (0, $219y6.useOfflineContext)();
    const { setCallActive: setCallActive } = (0, $8f3c957259b6070e$export$86214f0f28cf0b34)();
    const { ringDuration: ringDuration, maxDuration: maxDuration } = (0, $cD0nt.useCallSettings)();
    const { startSound: startSound, ringingSound: ringingSound, connectedSound: connectedSound, endSound: endSound, playSound: playSound, stopAllSounds: stopAllSounds } = (0, $dcc94db3b6c367f7$export$a712c06eeb4d5ac8)();
    const { callReception: callReception } = (0, $cD0nt.useLayout)();
    const callingOptions = (0, $eZVvM.useMemo)(()=>{
        var _callReception_callMenu;
        return (callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu = callReception.callMenu) === null || _callReception_callMenu === void 0 ? void 0 : _callReception_callMenu.options) || [];
    }, [
        callReception
    ]);
    const path = (0, $eZVvM.useMemo)(()=>{
        if (pathname.includes("access/option")) return `access/option/:action/contact/:id/:callType`;
        if (pathname.includes("delivery")) return `${pathname.includes("custom") ? "custom-" : ""}delivery/:action/contact/:id/:callType`;
        if (pathname.includes("access")) return `access/checkin/${pathname.includes("manual") ? "manual/" : ""}contact/:id/:callType`;
        if (pathname.includes("calling-menu")) return `calling-menu/contact/:id/:callType`;
        return "contact/:id/:callType";
    }, []);
    const match = (0, $9B9bN.useMatch)({
        path: path
    });
    const id = match === null || match === void 0 ? void 0 : (_match_params = match.params) === null || _match_params === void 0 ? void 0 : _match_params.id;
    const callType = match === null || match === void 0 ? void 0 : (_match_params1 = match.params) === null || _match_params1 === void 0 ? void 0 : _match_params1.callType;
    const receptionistPhone = (0, $cD0nt.useReceptionistPhone)();
    const extraButtons = (0, $cD0nt.useCheckFlowExtraButtons)();
    const isCallingExtraButton = !!(id === null || id === void 0 ? void 0 : id.startsWith("extra-"));
    // a direct number is dialed, there is no access event behind it
    const isCallingReception = !!(id === null || id === void 0 ? void 0 : id.startsWith("reception")) || isCallingExtraButton;
    const { data: accessEventData } = (0, $dMu0R.useQuery)([
        `access/event/${id}`
    ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
            id: id
        }), {
        enabled: !!id && !isCallingReception,
        retry: false,
        staleTime: 60000,
        onError: ()=>{
            navigate("/", {
                replace: true
            });
        }
    });
    const receiverPhone = (accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : (_accessEventData_accessEvent_receiver = _accessEventData_accessEvent.receiver) === null || _accessEventData_accessEvent_receiver === void 0 ? void 0 : _accessEventData_accessEvent_receiver.phone) || (accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent1 = accessEventData.accessEvent) === null || _accessEventData_accessEvent1 === void 0 ? void 0 : (_accessEventData_accessEvent_customReceiver = _accessEventData_accessEvent1.customReceiver) === null || _accessEventData_accessEvent_customReceiver === void 0 ? void 0 : _accessEventData_accessEvent_customReceiver.phone);
    const accessEventType = accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent2 = accessEventData.accessEvent) === null || _accessEventData_accessEvent2 === void 0 ? void 0 : _accessEventData_accessEvent2.type;
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage, isDoorOpening: isDoorOpening, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: accessEventType,
        id: id
    });
    const phoneNumber = (0, $eZVvM.useMemo)(()=>{
        var _extraButtons_find;
        if (id === "reception") return receptionistPhone;
        if (isCallingExtraButton) return (_extraButtons_find = extraButtons.find((button)=>button.id === (id === null || id === void 0 ? void 0 : id.replace("extra-", "")))) === null || _extraButtons_find === void 0 ? void 0 : _extraButtons_find.phone;
        if (!!id && /^reception-\d+$/.test(id)) {
            const index = parseInt(id.split("-")[1], 10);
            return callingOptions[index].phone;
        }
        return receiverPhone;
    }, [
        receptionistPhone,
        receiverPhone,
        id,
        callingOptions,
        isCallingExtraButton,
        extraButtons
    ]);
    const timerRef = (0, $eZVvM.useRef)();
    const call = (0, $eZVvM.useRef)();
    const device = (0, $eZVvM.useRef)();
    const [callingStatus, setCallingStatus] = (0, $eZVvM.useState)();
    const { data: data } = (0, $dMu0R.useQuery)([
        "token"
    ], ()=>$7195b02b4387c5f9$var$api.get(`/twilio/token`).then(({ data: data })=>data).catch((error)=>{
            (0, $1BSKa.default).error(`[device] - disconnect`, error);
        }), {
        refetchOnWindowFocus: false,
        cacheTime: 0,
        staleTime: 0
    });
    const onEndCall = (0, $eZVvM.useCallback)(()=>{
        var _device_current, _device_current1;
        (_device_current = device.current) === null || _device_current === void 0 ? void 0 : _device_current.disconnectAll();
        (_device_current1 = device.current) === null || _device_current1 === void 0 ? void 0 : _device_current1.destroy();
    }, []);
    const onClose = (0, $eZVvM.useCallback)(()=>{
        setCallingStatus(undefined);
        handleCheckinAccessNavigation();
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        let ringingTimeout;
        const init = async ()=>{
            if (!phoneNumber) {
                handleCheckinAccessNavigation();
                return;
            }
            if (!(data && data.token) || !online) return;
            device.current = new (0, $51a4b996f723547d$exports.Device)(data.token, {
                ...data.edge ? {
                    edge: data.edge
                } : {},
                disableAudioContextSounds: true,
                sounds: {
                    incoming: new URL($ea42a6a2d9a0f5f3$exports).href,
                    outgoing: new URL($ea42a6a2d9a0f5f3$exports).href,
                    disconnect: new URL($ea42a6a2d9a0f5f3$exports).href
                }
            });
            (0, $1BSKa.default).debug(`[device] Device connected`);
            (0, $1BSKa.default).debug(`[call] Establishing a call`);
            setCallActive(true);
            setCallingStatus("connecting");
            ringingTimeout = setTimeout(()=>{
                setCallingStatus((prev)=>{
                    if (prev === "connecting") {
                        (0, $1BSKa.default).debug("[call] Fallback: forcing ringing state after timeout");
                        playSound(ringingSound);
                        return "ringing";
                    }
                    return prev;
                });
            }, 2500);
            playSound(startSound);
            let params = {
                To: phoneNumber
            };
            if (callType === "ping") params = {
                ...params,
                Timeout: "10",
                Ping: "1"
            };
            else params = {
                ...params,
                Timeout: String(ringDuration),
                ...maxDuration ? {
                    TimeLimit: String(maxDuration)
                } : {}
            };
            call.current = await device.current.connect({
                params: params
            });
            call.current.on("ringing", (call)=>{
                if (call) {
                    playSound(ringingSound);
                    setCallingStatus("ringing");
                }
            });
            call.current.on("accept", ()=>{
                /**
         * If someone answers the "ping" call by chance,
         * end the call automatically
         */ if (callType === "ping") {
                    playSound(endSound);
                    onEndCall();
                    return;
                }
                playSound(connectedSound);
                setCallingStatus("open");
            });
            call.current.on("cancel", ()=>{
                (0, $1BSKa.default).debug(`[call] The call has been canceled.`);
                setCallActive(false);
                playSound(endSound);
                setCallingStatus("close");
            });
            call.current.on("disconnect", (call)=>{
                (0, $1BSKa.default).debug(`[call] The call has been disconnected.`, call);
                setCallActive(false);
                playSound(endSound);
                setCallingStatus("close");
            });
            call.current.on("reject", ()=>{
                (0, $1BSKa.default).debug(`[call] The call was rejected.`);
                setCallActive(false);
                playSound(endSound);
                setCallingStatus("close");
            });
            call.current.on("error", (error)=>{
                (0, $1BSKa.default).error(`[call] An error has occurred: `, error);
                // trackEvent({ type: "calling", value: "error" });
                setCallActive(false);
                playSound(endSound);
                setCallingStatus("error");
            });
            call.current.on("reconnected", ()=>{
                (0, $1BSKa.default).debug(`[call] The call has regained connectivity.`);
            });
            call.current.on("reconnecting", (error)=>{
                (0, $1BSKa.default).debug(`[call] Connectivity error: `, error);
            });
            device.current.on("error", (twilioError)=>{
                (0, $1BSKa.default).error(`[device] An error has occurred: `, twilioError);
                // trackEvent({ type: "calling", value: "error" });
                setCallActive(false);
                playSound(endSound);
                setCallingStatus("error");
            });
        };
        init();
        return ()=>{
            setCallActive(false);
            stopAllSounds();
            if (!device.current) return;
            clearTimeout(ringingTimeout);
            device.current.disconnectAll();
            device.current.destroy();
            (0, $1BSKa.default).debug(`[device] Device disconnected`);
        };
    }, [
        data,
        phoneNumber
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (callingStatus === "close" || callingStatus === "error") timerRef.current = setTimeout(()=>{
            handleCheckinAccessNavigation();
        }, 5000);
        return ()=>{
            clearTimeout(timerRef.current);
        };
    }, [
        callingStatus
    ]);
    if (isDoorOpening) return accessSwitchModal;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5a8921586fbf1614$export$2e2bcd8739ae039), {
        status: callingStatus,
        isCallingReception: isCallingReception,
        willNavigateToAccessControl: willNavigateToCheckinAccessControlPage,
        onEndCall: onEndCall,
        onClose: onClose
    });
});
var $7195b02b4387c5f9$export$2e2bcd8739ae039 = $7195b02b4387c5f9$var$Calling;



var $bhfvP = parcelRequire("bhfvP");


var $dMu0R = parcelRequire("dMu0R");


var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");

var $eZVvM = parcelRequire("eZVvM");
var $fbb21c0271b7a945$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, $eZVvM.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0, $eZVvM.useCallback)(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
var $fbb21c0271b7a945$export$2e2bcd8739ae039 = $fbb21c0271b7a945$var$useSetState;



var $jnPOB = parcelRequire("jnPOB");

var $bhfvP = parcelRequire("bhfvP");


var $eZVvM = parcelRequire("eZVvM");

var $k9qks = parcelRequire("k9qks");

var $jXblK = parcelRequire("jXblK");

const $994d1307fc527979$var$PinInputField = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("input")(({ theme: theme })=>({
        color: theme.palette.text.primary,
        borderColor: theme.palette.primary.main,
        background: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).lighten(0.1).hex(),
        "&:focus": {
            borderColor: theme.palette.primary.main,
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).darken(0.07).hex()
        },
        "&.error": {
            borderColor: theme.palette.error.main
        }
    }));
const $994d1307fc527979$var$DebugComponent = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
        variant: "h1",
        children: [
            children,
            JSON.stringify(value, null, 2) + ""
        ]
    });
};
const $994d1307fc527979$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $994d1307fc527979$var$PinInputs = ({ showValues: showValues = true, focusedInput: focusedInput, setFocusedInput: setFocusedInput, pinCode: pinCode, setPinCode: setPinCode, keyboard: keyboard })=>{
    const onPasteCapture = (0, $eZVvM.useCallback)((event)=>{
        const content = event.clipboardData.getData("Text");
        const isValidPin = /^[0-9]{1,6}$/g.test(content);
        if (!isValidPin) return;
        event.preventDefault();
        const pinCode = (0, $jXblK.reduce)((0, $jXblK.times)(6), (acc, key)=>({
                ...acc,
                [key + 1]: content[key]
            }), {});
        setPinCode(pinCode);
    }, [
        setPinCode
    ]);
    const onFocus = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name } } = event;
        setFocusedInput(`${+name}`);
        if (keyboard === null || keyboard === void 0 ? void 0 : keyboard.current) keyboard === null || keyboard === void 0 ? void 0 : keyboard.current.setInput("", name);
    }, [
        setFocusedInput
    ]);
    const onChange = (0, $eZVvM.useCallback)((event)=>{
        const { target: { name: name, value: value } } = event;
        /**
     * Blur when setting last input is set form keyboard
     */ if (name === "6" && value && !!value.length) event.target.blur();
        const regex = /^\d$/;
        if (value === "" || regex.test(value)) {
            setPinCode({
                [name]: value
            });
            let nextFocusedInput = +name;
            if (name === "6") nextFocusedInput = undefined;
            else if (value.length) nextFocusedInput += 1;
            else nextFocusedInput -= 1;
            setFocusedInput(nextFocusedInput ? `${nextFocusedInput}` : undefined);
        }
    }, [
        setFocusedInput
    ]);
    const onKeyDown = (0, $eZVvM.useCallback)((event)=>{
        const { code: code, currentTarget: { name: name } } = event;
        switch(code){
            case "Backspace":
                {
                    event.preventDefault();
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowRight":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.min(+name + 1, 6);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowLeft":
                {
                    event.preventDefault();
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, []);
    /**
   * Auto-focus input
   */ (0, $eZVvM.useEffect)(()=>{
        if (focusedInput) {
            const input = document.querySelector(`input[name="${focusedInput}"]`);
            if (input && typeof input.focus === "function") {
                input.focus();
                input.select();
            }
        }
    }, [
        focusedInput
    ]);
    const onBeforeInput = (0, $eZVvM.useCallback)((event)=>{
        switch(event.inputType){
            case "deleteByComposition":
            case "deleteByCut":
            case "deleteByDrag":
            case "deleteEntireSoftLine":
            case "deleteSoftLineBackward":
            case "deleteSoftLineForward":
            case "deleteHardLineBackward":
            case "deleteHardLineForward":
            case "deleteWordBackward":
            case "deleteWordForward":
            case "deleteContent":
            case "deleteContentForward":
            case "deleteContentBackward":
                {
                    event.preventDefault();
                    // eslint-disable-next-line prefer-destructuring
                    const name = (event === null || event === void 0 ? void 0 : event.currentTarget).name;
                    setPinCode({
                        [name]: ""
                    });
                    const nextFocusedInput = Math.max(1, +name - 1);
                    setFocusedInput(`${nextFocusedInput}`);
                    break;
                }
            default:
                break;
        }
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (!(0, $k9qks.isInWebView)) return;
        const ids = Object.keys($994d1307fc527979$var$defaultPinCode);
        ids.forEach((id)=>{
            const element = document.querySelector(`[id='${id}']`);
            element === null || element === void 0 ? void 0 : element.addEventListener("beforeinput", onBeforeInput);
        });
        // eslint-disable-next-line consistent-return
        return ()=>{
            ids.forEach((id)=>{
                const element = document.querySelector(`[id='${id}']`);
                element === null || element === void 0 ? void 0 : element.removeEventListener("beforeinput", onBeforeInput);
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: [
            1,
            2,
            3,
            4,
            5,
            6
        ].map((i)=>{
            const isPinBlank = pinCode[i].toString() === "";
            return /*#__PURE__*/ (0, $bhfvP.jsx)($994d1307fc527979$var$PinInputField, {
                id: `${i}`,
                name: `${i}`,
                min: 0,
                max: 9,
                inputMode: "numeric",
                type: (0, $k9qks.isVirtualKeyboardEnabled) || !showValues ? "text" : "number",
                className: "pin__input",
                autoComplete: "chrome-off",
                onFocus: onFocus,
                onChange: onChange,
                onKeyDown: onKeyDown,
                onPasteCapture: onPasteCapture,
                value: isPinBlank ? "" : showValues ? pinCode[i] : "*",
                maxLength: 1,
                pattern: "[0-9]*"
            }, i);
        })
    });
};
var $994d1307fc527979$export$2e2bcd8739ae039 = $994d1307fc527979$var$PinInputs;




var $k9qks = parcelRequire("k9qks");

var $kCXUJ = parcelRequire("kCXUJ");

var $219y6 = parcelRequire("219y6");
const $01691f0da1880d6d$var$defaultPinCode = {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: ""
};
const $01691f0da1880d6d$var$Activation = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "check"
    ]);
    const { storeData: storeData, getData: getData, refreshUntilMark: refreshUntilMark } = (0, $219y6.useOfflineContext)();
    const [focusedInput, setFocusedInput] = (0, $eZVvM.useState)("1");
    // inputted by user
    const [pinCode, setPinCode] = (0, $fbb21c0271b7a945$export$2e2bcd8739ae039)($01691f0da1880d6d$var$defaultPinCode);
    const [code, setCode] = (0, $eZVvM.useState)("");
    const keyboard = (0, $eZVvM.useRef)(null);
    const keyboardBox = (0, $eZVvM.useRef)(null);
    const onKeyboardChange = (0, $eZVvM.useCallback)((value)=>{
        const regex = /^\d$/;
        if (focusedInput && +focusedInput < 7 && (value === "" || regex.test(value))) {
            /**
       * Reset virtual input after we set the code
       */ if (keyboard.current) keyboard.current.setInput("", focusedInput);
            setPinCode(()=>({
                    [focusedInput]: value
                }));
            if (focusedInput === "6" && value.length) setFocusedInput(undefined);
            else {
                var _document_activeElement;
                if (document.activeElement) (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.blur();
                setFocusedInput(`${+focusedInput + 1}`);
            }
        }
    }, [
        focusedInput
    ]);
    const onKeyboardKeyPress = (0, $eZVvM.useCallback)((button)=>{
        if (button === "{bksp}" && typeof focusedInput !== "undefined") {
            setPinCode(()=>({
                    [focusedInput]: ""
                }));
            const nextFocusedInput = Math.max(1, +focusedInput - 1);
            setFocusedInput(`${nextFocusedInput}`);
        }
    }, [
        focusedInput
    ]);
    // const code = Object.values(pinCode).join("");
    const getCachedCodeAndPlayerUrl = (0, $eZVvM.useCallback)(async ()=>{
        let code;
        let playerUrl;
        try {
            code = await getData("/activation-code");
        } catch (e) {
        // do nothing
        }
        try {
            playerUrl = await getData("/player-url");
        } catch (e) {
        // do nothing
        }
        return {
            code: code,
            playerUrl: playerUrl
        };
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        const getCode = async ()=>{
            const enteredCode = Object.values(pinCode).join("");
            if (!enteredCode) {
                // get code from cache if the user has not entered any code
                const { code: code, playerUrl: playerUrl } = await getCachedCodeAndPlayerUrl() || {};
                if (playerUrl) {
                    const hasTrailingSlash = playerUrl.endsWith("/");
                    window.location.replace(playerUrl + (hasTrailingSlash ? "" : "/"));
                    return;
                }
                setCode(()=>code);
                return;
            }
            setCode(()=>Object.values(pinCode).join(""));
        };
        getCode();
    }, [
        pinCode
    ]);
    (0, $dMu0R.useQuery)([
        "activation",
        code
    ], async ()=>{
        try {
            const { digitalReceptionPublic: digitalReceptionPublic } = await (0, $jnPOB.client).request((0, $kCXUJ.QUERY_DIGITAL_RECEPTION_PUBLIC), {
                input: {
                    code: code
                }
            });
            storeData("/activation-code", {
                code: code
            });
            storeData("/player-url", digitalReceptionPublic.playerUrl);
            const hasTrailingSlash = digitalReceptionPublic.playerUrl.endsWith("/");
            window.location.replace(digitalReceptionPublic.playerUrl + (hasTrailingSlash ? "" : "/"));
        } catch (error) {
            setPinCode($01691f0da1880d6d$var$defaultPinCode);
            setFocusedInput("1");
        }
    }, {
        enabled: !!code && code.length === 6,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnReconnect: true
    });
    refreshUntilMark("activation-refresh", 2000);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                variant: "h4",
                className: "font-weight-regular pin__title",
                children: t("check:pinCode")
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $994d1307fc527979$export$2e2bcd8739ae039), {
                    showValues: false,
                    focusedInput: focusedInput,
                    setFocusedInput: setFocusedInput,
                    pinCode: pinCode,
                    setPinCode: setPinCode,
                    keyboard: keyboard
                })
            }),
            ((0, $k9qks.isVirtualKeyboardEnabled) || !(0, $k9qks.isPWA)) && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                ref: keyboardBox,
                className: (0, $d7e92066a4c80f19$export$2e2bcd8739ae039)("keyboard ", {
                    keyboard__out: !focusedInput
                }),
                onClick: (e)=>{
                    e.stopPropagation();
                },
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $65b2ace84335c487$export$2e2bcd8739ae039), {
                    ref: keyboard,
                    disableButtonHold: true,
                    layoutName: "pin",
                    inputName: focusedInput,
                    onChange: onKeyboardChange,
                    onKeyPress: onKeyboardKeyPress
                })
            })
        ]
    });
};
var $01691f0da1880d6d$export$2e2bcd8739ae039 = $01691f0da1880d6d$var$Activation;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $dMu0R = parcelRequire("dMu0R");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");





var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


var $jnPOB = parcelRequire("jnPOB");

var $kCXUJ = parcelRequire("kCXUJ");




var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");
var $g6uH4 = parcelRequire("g6uH4");




const $1b818836d3ce10be$var$MUTATION_ACCESS_EVENT_SEND_MESSAGE = (0, $g6uH4.gql)`
  mutation accessEventSendMessage($id: ID!) {
    accessEventSendMessage(id: $id) {
      id
    }
  }
`;
const $1b818836d3ce10be$var$Message = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const type = query.type;
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage, isDoorOpening: isDoorOpening, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    // const { trackEvent } = useEventTracking();
    const { status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/message`
    ], ()=>{
        return (0, $jnPOB.client).request($1b818836d3ce10be$var$MUTATION_ACCESS_EVENT_SEND_MESSAGE, {
            id: id
        });
    }, {
        retry: false,
        refetchOnWindowFocus: false,
        onSuccess () {
        // trackEvent({
        //   type: "message_send",
        //   value: "success",
        // });
        },
        onError () {
        // trackEvent({
        //   type: "message_send",
        //   value: "error",
        // });
        }
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        /**
     * Redirect to previous route in case of error so you can retry
     */ if (requestStatus === "error") return navigate(-1);
        return handleCheckinAccessNavigation();
    }, [
        requestStatus
    ]);
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToCheckinAccessControlPage && status === "success") return "successAccess";
        return status;
    }, [
        willNavigateToCheckinAccessControlPage,
        status
    ]);
    if (isDoorOpening) return accessSwitchModal;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `message:status.${statusKey}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `message:status.${statusKey}.message`
        }),
        status: status,
        onDismiss: onDismiss
    });
};
var $1b818836d3ce10be$export$2e2bcd8739ae039 = $1b818836d3ce10be$var$Message;





var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");
var $g6uH4 = parcelRequire("g6uH4");




const $47c7c543580779e4$var$MUTATION_ACCESS_EVENT_SEND_TEAMS_MESSAGE = (0, $g6uH4.gql)`
  mutation accessEventSendTeamsMessage($id: ID!) {
    accessEventSendTeamsMessage(id: $id) {
      id
    }
  }
`;
const $47c7c543580779e4$var$TeamsMessage = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const type = query.type;
    const { id: id } = (0, $9B9bN.useParams)();
    // const { trackEvent } = useEventTracking();
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage, isDoorOpening: isDoorOpening, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    const { status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/teams-message`
    ], ()=>{
        return (0, $jnPOB.client).request($47c7c543580779e4$var$MUTATION_ACCESS_EVENT_SEND_TEAMS_MESSAGE, {
            id: id
        });
    }, {
        retry: false,
        refetchOnWindowFocus: false,
        onSuccess () {
        // trackEvent({
        //   type: "message_send",
        //   value: "success",
        // });
        },
        onError () {
        // trackEvent({
        //   type: "message_send",
        //   value: "error",
        // });
        }
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        /**
     * Redirect to previous route in case of error so you can retry
     */ if (requestStatus === "error") return navigate(-1);
        return handleCheckinAccessNavigation();
    }, [
        requestStatus
    ]);
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToCheckinAccessControlPage && status === "success") return "successAccess";
        return status;
    }, [
        willNavigateToCheckinAccessControlPage,
        status
    ]);
    if (isDoorOpening) return accessSwitchModal;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `teamsMessage:status.${statusKey}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `teamsMessage:status.${statusKey}.message`
        }),
        status: status,
        onDismiss: onDismiss
    });
};
var $47c7c543580779e4$export$2e2bcd8739ae039 = $47c7c543580779e4$var$TeamsMessage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");

var $jnPOB = parcelRequire("jnPOB");
var $g6uH4 = parcelRequire("g6uH4");




const $f17404c021f76fe4$var$MUTATION_ACCESS_EVENT_SEND_GOOGLE_CHAT_MESSAGE = (0, $g6uH4.gql)`
  mutation accessEventSendGoogleChatMessage($id: ID!) {
    accessEventSendGoogleChatMessage(id: $id) {
      id
    }
  }
`;
const $f17404c021f76fe4$var$GoogleChatMessage = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const type = query.type;
    const { id: id } = (0, $9B9bN.useParams)();
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage, isDoorOpening: isDoorOpening, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    const { status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/google-chat-message`
    ], ()=>{
        return (0, $jnPOB.client).request($f17404c021f76fe4$var$MUTATION_ACCESS_EVENT_SEND_GOOGLE_CHAT_MESSAGE, {
            id: id
        });
    }, {
        retry: false,
        refetchOnWindowFocus: false
    });
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (requestStatus === "error") return navigate(-1);
        return handleCheckinAccessNavigation();
    }, [
        requestStatus
    ]);
    const status = (0, $b93fbe9fa8871676$export$4d340688cbe434a5)(requestStatus, 1500);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 3000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToCheckinAccessControlPage && status === "success") return "successAccess";
        return status;
    }, [
        willNavigateToCheckinAccessControlPage,
        status
    ]);
    if (isDoorOpening) return accessSwitchModal;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `googleChatMessage:status.${statusKey}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `googleChatMessage:status.${statusKey}.message`
        }),
        status: status,
        onDismiss: onDismiss
    });
};
var $f17404c021f76fe4$export$2e2bcd8739ae039 = $f17404c021f76fe4$var$GoogleChatMessage;



var $cD0nt = parcelRequire("cD0nt");

/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $6rUEX = parcelRequire("6rUEX");
var $cf5b5da7977a3fc4$exports = {};
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the Microsoft Software License Terms for the Azure Communications Services, Azure CPaaS, AZURE COMMUNICATION SERVICES VOICE AND VIDEO CALLING CLIENT LIBRARY
// See LICENSE file for license information.

var $lUPho = parcelRequire("lUPho");

var $dVJB2 = parcelRequire("dVJB2");
var $cf5b5da7977a3fc4$require$Buffer = $dVJB2.Buffer;


!function(g, f) {
    f($cf5b5da7977a3fc4$exports, (parcelRequire("bBnY4")), (parcelRequire("eTmRH")));
}($cf5b5da7977a3fc4$exports, function(g, f, S) {
    "use strict";
    var v, _ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
    function getDefaultExportFromCjs(g) {
        return g && g.__esModule && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g;
    }
    function createCommonjsModule(g, f, S) {
        return g(S = {
            path: f,
            exports: {},
            require: function(g, f) {
                return commonjsRequire(g, null == f ? S.path : f);
            }
        }, S.exports), S.exports;
    }
    function getAugmentedNamespace(g) {
        if (g.__esModule) return g;
        var f = Object.defineProperty({}, "__esModule", {
            value: !0
        });
        return Object.keys(g).forEach(function(S) {
            var v = Object.getOwnPropertyDescriptor(g, S);
            Object.defineProperty(f, S, v.get ? v : {
                enumerable: !0,
                get: function() {
                    return g[S];
                }
            });
        }), f;
    }
    function commonjsRequire() {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
    }
    /*! *****************************************************************************
	Copyright (C) Microsoft. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0

	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.

	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */ !function(g) {
        !function(f) {
            var S = "object" == typeof _ ? _ : "object" == typeof self ? self : "object" == typeof this ? this : Function("return this;")(), v = makeExporter(g);
            function makeExporter(g, f) {
                return function(S, v) {
                    "function" != typeof g[S] && Object.defineProperty(g, S, {
                        configurable: !0,
                        writable: !0,
                        value: v
                    }), f && f(S, v);
                };
            }
            void 0 === S.Reflect ? S.Reflect = g : v = makeExporter(S.Reflect, v), f(v);
        }(function(g) {
            var f = Object.prototype.hasOwnProperty, S = "function" == typeof Symbol, v = S && void 0 !== Symbol.toPrimitive ? Symbol.toPrimitive : "@@toPrimitive", _ = S && void 0 !== Symbol.iterator ? Symbol.iterator : "@@iterator", C = "function" == typeof Object.create, E = ({
                __proto__: []
            }) instanceof Array, T = !C && !E, I = {
                create: C ? function() {
                    return MakeDictionary(Object.create(null));
                } : E ? function() {
                    return MakeDictionary({
                        __proto__: null
                    });
                } : function() {
                    return MakeDictionary({});
                },
                has: T ? function(g, S) {
                    return f.call(g, S);
                } : function(g, f) {
                    return f in g;
                },
                get: T ? function(g, S) {
                    return f.call(g, S) ? g[S] : void 0;
                } : function(g, f) {
                    return g[f];
                }
            }, b = Object.getPrototypeOf(Function), A = "object" == typeof $lUPho && $lUPho.env && false, R = A || "function" != typeof Map || "function" != typeof Map.prototype.entries ? CreateMapPolyfill() : Map, P = A || "function" != typeof Set || "function" != typeof Set.prototype.entries ? CreateSetPolyfill() : Set, w = new (A || "function" != typeof WeakMap ? CreateWeakMapPolyfill() : WeakMap);
            function decorate(g, f, S, v) {
                if (IsUndefined(S)) {
                    if (!IsArray(g)) throw new TypeError;
                    if (!IsConstructor(f)) throw new TypeError;
                    return DecorateConstructor(g, f);
                }
                if (!IsArray(g)) throw new TypeError;
                if (!IsObject(f)) throw new TypeError;
                if (!IsObject(v) && !IsUndefined(v) && !IsNull(v)) throw new TypeError;
                return IsNull(v) && (v = void 0), DecorateProperty(g, f, S = ToPropertyKey(S), v);
            }
            function metadata(g, f) {
                function decorator(S, v) {
                    if (!IsObject(S)) throw new TypeError;
                    if (!IsUndefined(v) && !IsPropertyKey(v)) throw new TypeError;
                    OrdinaryDefineOwnMetadata(g, f, S, v);
                }
                return decorator;
            }
            function defineMetadata(g, f, S, v) {
                if (!IsObject(S)) throw new TypeError;
                return IsUndefined(v) || (v = ToPropertyKey(v)), OrdinaryDefineOwnMetadata(g, f, S, v);
            }
            function hasMetadata(g, f, S) {
                if (!IsObject(f)) throw new TypeError;
                return IsUndefined(S) || (S = ToPropertyKey(S)), OrdinaryHasMetadata(g, f, S);
            }
            function hasOwnMetadata(g, f, S) {
                if (!IsObject(f)) throw new TypeError;
                return IsUndefined(S) || (S = ToPropertyKey(S)), OrdinaryHasOwnMetadata(g, f, S);
            }
            function getMetadata(g, f, S) {
                if (!IsObject(f)) throw new TypeError;
                return IsUndefined(S) || (S = ToPropertyKey(S)), OrdinaryGetMetadata(g, f, S);
            }
            function getOwnMetadata(g, f, S) {
                if (!IsObject(f)) throw new TypeError;
                return IsUndefined(S) || (S = ToPropertyKey(S)), OrdinaryGetOwnMetadata(g, f, S);
            }
            function getMetadataKeys(g, f) {
                if (!IsObject(g)) throw new TypeError;
                return IsUndefined(f) || (f = ToPropertyKey(f)), OrdinaryMetadataKeys(g, f);
            }
            function getOwnMetadataKeys(g, f) {
                if (!IsObject(g)) throw new TypeError;
                return IsUndefined(f) || (f = ToPropertyKey(f)), OrdinaryOwnMetadataKeys(g, f);
            }
            function deleteMetadata(g, f, S) {
                if (!IsObject(f)) throw new TypeError;
                IsUndefined(S) || (S = ToPropertyKey(S));
                var v = GetOrCreateMetadataMap(f, S, !1);
                if (IsUndefined(v)) return !1;
                if (!v.delete(g)) return !1;
                if (v.size > 0) return !0;
                var _ = w.get(f);
                return _.delete(S), _.size > 0 || w.delete(f), !0;
            }
            function DecorateConstructor(g, f) {
                for(var S = g.length - 1; S >= 0; --S){
                    var v = (0, g[S])(f);
                    if (!IsUndefined(v) && !IsNull(v)) {
                        if (!IsConstructor(v)) throw new TypeError;
                        f = v;
                    }
                }
                return f;
            }
            function DecorateProperty(g, f, S, v) {
                for(var _ = g.length - 1; _ >= 0; --_){
                    var C = (0, g[_])(f, S, v);
                    if (!IsUndefined(C) && !IsNull(C)) {
                        if (!IsObject(C)) throw new TypeError;
                        v = C;
                    }
                }
                return v;
            }
            function GetOrCreateMetadataMap(g, f, S) {
                var v = w.get(g);
                if (IsUndefined(v)) {
                    if (!S) return;
                    v = new R, w.set(g, v);
                }
                var _ = v.get(f);
                if (IsUndefined(_)) {
                    if (!S) return;
                    _ = new R, v.set(f, _);
                }
                return _;
            }
            function OrdinaryHasMetadata(g, f, S) {
                if (OrdinaryHasOwnMetadata(g, f, S)) return !0;
                var v = OrdinaryGetPrototypeOf(f);
                return !IsNull(v) && OrdinaryHasMetadata(g, v, S);
            }
            function OrdinaryHasOwnMetadata(g, f, S) {
                var v = GetOrCreateMetadataMap(f, S, !1);
                return !IsUndefined(v) && ToBoolean(v.has(g));
            }
            function OrdinaryGetMetadata(g, f, S) {
                if (OrdinaryHasOwnMetadata(g, f, S)) return OrdinaryGetOwnMetadata(g, f, S);
                var v = OrdinaryGetPrototypeOf(f);
                return IsNull(v) ? void 0 : OrdinaryGetMetadata(g, v, S);
            }
            function OrdinaryGetOwnMetadata(g, f, S) {
                var v = GetOrCreateMetadataMap(f, S, !1);
                if (!IsUndefined(v)) return v.get(g);
            }
            function OrdinaryDefineOwnMetadata(g, f, S, v) {
                GetOrCreateMetadataMap(S, v, !0).set(g, f);
            }
            function OrdinaryMetadataKeys(g, f) {
                var S = OrdinaryOwnMetadataKeys(g, f), v = OrdinaryGetPrototypeOf(g);
                if (null === v) return S;
                var _ = OrdinaryMetadataKeys(v, f);
                if (_.length <= 0) return S;
                if (S.length <= 0) return _;
                for(var C = new P, E = [], T = 0, I = S; T < I.length; T++){
                    var b = I[T];
                    C.has(b) || (C.add(b), E.push(b));
                }
                for(var A = 0, R = _; A < R.length; A++){
                    b = R[A];
                    C.has(b) || (C.add(b), E.push(b));
                }
                return E;
            }
            function OrdinaryOwnMetadataKeys(g, f) {
                var S = [], v = GetOrCreateMetadataMap(g, f, !1);
                if (IsUndefined(v)) return S;
                for(var _ = GetIterator(v.keys()), C = 0;;){
                    var E = IteratorStep(_);
                    if (!E) return S.length = C, S;
                    var T = IteratorValue(E);
                    try {
                        S[C] = T;
                    } catch (g) {
                        try {
                            IteratorClose(_);
                        } finally{
                            throw g;
                        }
                    }
                    C++;
                }
            }
            function Type(g) {
                if (null === g) return 1;
                switch(typeof g){
                    case "undefined":
                        return 0;
                    case "boolean":
                        return 2;
                    case "string":
                        return 3;
                    case "symbol":
                        return 4;
                    case "number":
                        return 5;
                    case "object":
                        return null === g ? 1 : 6;
                    default:
                        return 6;
                }
            }
            function IsUndefined(g) {
                return void 0 === g;
            }
            function IsNull(g) {
                return null === g;
            }
            function IsSymbol(g) {
                return "symbol" == typeof g;
            }
            function IsObject(g) {
                return "object" == typeof g ? null !== g : "function" == typeof g;
            }
            function ToPrimitive(g, f) {
                switch(Type(g)){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        return g;
                }
                var S = 3 === f ? "string" : 5 === f ? "number" : "default", _ = GetMethod(g, v);
                if (void 0 !== _) {
                    var C = _.call(g, S);
                    if (IsObject(C)) throw new TypeError;
                    return C;
                }
                return OrdinaryToPrimitive(g, "default" === S ? "number" : S);
            }
            function OrdinaryToPrimitive(g, f) {
                if ("string" === f) {
                    var S = g.toString;
                    if (IsCallable(S)) {
                        if (!IsObject(_ = S.call(g))) return _;
                    }
                    if (IsCallable(v = g.valueOf)) {
                        if (!IsObject(_ = v.call(g))) return _;
                    }
                } else {
                    var v;
                    if (IsCallable(v = g.valueOf)) {
                        if (!IsObject(_ = v.call(g))) return _;
                    }
                    var _, C = g.toString;
                    if (IsCallable(C)) {
                        if (!IsObject(_ = C.call(g))) return _;
                    }
                }
                throw new TypeError;
            }
            function ToBoolean(g) {
                return !!g;
            }
            function ToString(g) {
                return "" + g;
            }
            function ToPropertyKey(g) {
                var f = ToPrimitive(g, 3);
                return IsSymbol(f) ? f : ToString(f);
            }
            function IsArray(g) {
                return Array.isArray ? Array.isArray(g) : g instanceof Object ? g instanceof Array : "[object Array]" === Object.prototype.toString.call(g);
            }
            function IsCallable(g) {
                return "function" == typeof g;
            }
            function IsConstructor(g) {
                return "function" == typeof g;
            }
            function IsPropertyKey(g) {
                switch(Type(g)){
                    case 3:
                    case 4:
                        return !0;
                    default:
                        return !1;
                }
            }
            function GetMethod(g, f) {
                var S = g[f];
                if (null != S) {
                    if (!IsCallable(S)) throw new TypeError;
                    return S;
                }
            }
            function GetIterator(g) {
                var f = GetMethod(g, _);
                if (!IsCallable(f)) throw new TypeError;
                var S = f.call(g);
                if (!IsObject(S)) throw new TypeError;
                return S;
            }
            function IteratorValue(g) {
                return g.value;
            }
            function IteratorStep(g) {
                var f = g.next();
                return !f.done && f;
            }
            function IteratorClose(g) {
                var f = g.return;
                f && f.call(g);
            }
            function OrdinaryGetPrototypeOf(g) {
                var f = Object.getPrototypeOf(g);
                if ("function" != typeof g || g === b) return f;
                if (f !== b) return f;
                var S = g.prototype, v = S && Object.getPrototypeOf(S);
                if (null == v || v === Object.prototype) return f;
                var _ = v.constructor;
                return "function" != typeof _ || _ === g ? f : _;
            }
            function CreateMapPolyfill() {
                var g = {}, f = [], S = function() {
                    function MapIterator(g, f, S) {
                        this._index = 0, this._keys = g, this._values = f, this._selector = S;
                    }
                    return MapIterator.prototype["@@iterator"] = function() {
                        return this;
                    }, MapIterator.prototype[_] = function() {
                        return this;
                    }, MapIterator.prototype.next = function() {
                        var g = this._index;
                        if (g >= 0 && g < this._keys.length) {
                            var S = this._selector(this._keys[g], this._values[g]);
                            return g + 1 >= this._keys.length ? (this._index = -1, this._keys = f, this._values = f) : this._index++, {
                                value: S,
                                done: !1
                            };
                        }
                        return {
                            value: void 0,
                            done: !0
                        };
                    }, MapIterator.prototype.throw = function(g) {
                        throw this._index >= 0 && (this._index = -1, this._keys = f, this._values = f), g;
                    }, MapIterator.prototype.return = function(g) {
                        return this._index >= 0 && (this._index = -1, this._keys = f, this._values = f), {
                            value: g,
                            done: !0
                        };
                    }, MapIterator;
                }();
                return function() {
                    function Map1() {
                        this._keys = [], this._values = [], this._cacheKey = g, this._cacheIndex = -2;
                    }
                    return Object.defineProperty(Map1.prototype, "size", {
                        get: function() {
                            return this._keys.length;
                        },
                        enumerable: !0,
                        configurable: !0
                    }), Map1.prototype.has = function(g) {
                        return this._find(g, !1) >= 0;
                    }, Map1.prototype.get = function(g) {
                        var f = this._find(g, !1);
                        return f >= 0 ? this._values[f] : void 0;
                    }, Map1.prototype.set = function(g, f) {
                        var S = this._find(g, !0);
                        return this._values[S] = f, this;
                    }, Map1.prototype.delete = function(f) {
                        var S = this._find(f, !1);
                        if (S >= 0) {
                            for(var v = this._keys.length, _ = S + 1; _ < v; _++)this._keys[_ - 1] = this._keys[_], this._values[_ - 1] = this._values[_];
                            return this._keys.length--, this._values.length--, f === this._cacheKey && (this._cacheKey = g, this._cacheIndex = -2), !0;
                        }
                        return !1;
                    }, Map1.prototype.clear = function() {
                        this._keys.length = 0, this._values.length = 0, this._cacheKey = g, this._cacheIndex = -2;
                    }, Map1.prototype.keys = function() {
                        return new S(this._keys, this._values, getKey);
                    }, Map1.prototype.values = function() {
                        return new S(this._keys, this._values, getValue);
                    }, Map1.prototype.entries = function() {
                        return new S(this._keys, this._values, getEntry);
                    }, Map1.prototype["@@iterator"] = function() {
                        return this.entries();
                    }, Map1.prototype[_] = function() {
                        return this.entries();
                    }, Map1.prototype._find = function(g, f) {
                        return this._cacheKey !== g && (this._cacheIndex = this._keys.indexOf(this._cacheKey = g)), this._cacheIndex < 0 && f && (this._cacheIndex = this._keys.length, this._keys.push(g), this._values.push(void 0)), this._cacheIndex;
                    }, Map1;
                }();
                function getKey(g, f) {
                    return g;
                }
                function getValue(g, f) {
                    return f;
                }
                function getEntry(g, f) {
                    return [
                        g,
                        f
                    ];
                }
            }
            function CreateSetPolyfill() {
                return function() {
                    function Set1() {
                        this._map = new R;
                    }
                    return Object.defineProperty(Set1.prototype, "size", {
                        get: function() {
                            return this._map.size;
                        },
                        enumerable: !0,
                        configurable: !0
                    }), Set1.prototype.has = function(g) {
                        return this._map.has(g);
                    }, Set1.prototype.add = function(g) {
                        return this._map.set(g, g), this;
                    }, Set1.prototype.delete = function(g) {
                        return this._map.delete(g);
                    }, Set1.prototype.clear = function() {
                        this._map.clear();
                    }, Set1.prototype.keys = function() {
                        return this._map.keys();
                    }, Set1.prototype.values = function() {
                        return this._map.values();
                    }, Set1.prototype.entries = function() {
                        return this._map.entries();
                    }, Set1.prototype["@@iterator"] = function() {
                        return this.keys();
                    }, Set1.prototype[_] = function() {
                        return this.keys();
                    }, Set1;
                }();
            }
            function CreateWeakMapPolyfill() {
                var g = 16, S = I.create(), v = CreateUniqueKey();
                return function() {
                    function WeakMap1() {
                        this._key = CreateUniqueKey();
                    }
                    return WeakMap1.prototype.has = function(g) {
                        var f = GetOrCreateWeakMapTable(g, !1);
                        return void 0 !== f && I.has(f, this._key);
                    }, WeakMap1.prototype.get = function(g) {
                        var f = GetOrCreateWeakMapTable(g, !1);
                        return void 0 !== f ? I.get(f, this._key) : void 0;
                    }, WeakMap1.prototype.set = function(g, f) {
                        return GetOrCreateWeakMapTable(g, !0)[this._key] = f, this;
                    }, WeakMap1.prototype.delete = function(g) {
                        var f = GetOrCreateWeakMapTable(g, !1);
                        return void 0 !== f && delete f[this._key];
                    }, WeakMap1.prototype.clear = function() {
                        this._key = CreateUniqueKey();
                    }, WeakMap1;
                }();
                function CreateUniqueKey() {
                    var g;
                    do g = "@@WeakMap@@" + CreateUUID();
                    while (I.has(S, g));
                    return S[g] = !0, g;
                }
                function GetOrCreateWeakMapTable(g, S) {
                    if (!f.call(g, v)) {
                        if (!S) return;
                        Object.defineProperty(g, v, {
                            value: I.create()
                        });
                    }
                    return g[v];
                }
                function FillRandomBytes(g, f) {
                    for(var S = 0; S < f; ++S)g[S] = 255 * Math.random() | 0;
                    return g;
                }
                function GenRandomBytes(g) {
                    return "function" == typeof Uint8Array ? "undefined" != typeof crypto ? crypto.getRandomValues(new Uint8Array(g)) : "undefined" != typeof msCrypto ? msCrypto.getRandomValues(new Uint8Array(g)) : FillRandomBytes(new Uint8Array(g), g) : FillRandomBytes(new Array(g), g);
                }
                function CreateUUID() {
                    var f = GenRandomBytes(g);
                    f[6] = 79 & f[6] | 64, f[8] = 191 & f[8] | 128;
                    for(var S = "", v = 0; v < g; ++v){
                        var _ = f[v];
                        4 !== v && 6 !== v && 8 !== v || (S += "-"), _ < 16 && (S += "0"), S += _.toString(16).toLowerCase();
                    }
                    return S;
                }
            }
            function MakeDictionary(g) {
                return g.__ = void 0, delete g.__, g;
            }
            g("decorate", decorate), g("metadata", metadata), g("defineMetadata", defineMetadata), g("hasMetadata", hasMetadata), g("hasOwnMetadata", hasOwnMetadata), g("getMetadata", getMetadata), g("getOwnMetadata", getOwnMetadata), g("getMetadataKeys", getMetadataKeys), g("getOwnMetadataKeys", getOwnMetadataKeys), g("deleteMetadata", deleteMetadata);
        });
    }(v || (v = {}));
    var C = createCommonjsModule(function(g, f) {
        function vsprintf(g, f) {
            var S = 0;
            return g.replace(/%[dixs%]/g, function(g) {
                var v = 0;
                if ("%" !== g[v++]) return "";
                var _ = g[v++];
                return "%" === _ ? "%" : "s" === _ || "d" === _ || "i" === _ ? f[S++] : "x" === _ ? f[S++].toString(16) : g;
            });
        }
        function sprintf(g) {
            for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
            return vsprintf(g, f);
        }
        /*!
	 *  AufLog.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2016-12-29
	 *  Copyright 2016 Microsoft. All rights reserved.
	 *
	 */ Object.defineProperty(f, "__esModule", {
            value: !0
        }), function(g) {
            g[g.Trace = 10] = "Trace", g[g.Debug6 = 16] = "Debug6", g[g.Debug5 = 18] = "Debug5", g[g.Debug4 = 20] = "Debug4", g[g.Debug3 = 30] = "Debug3", g[g.Debug2 = 40] = "Debug2", g[g.Debug1 = 50] = "Debug1", g[g.Warning = 60] = "Warning", g[g.Error = 70] = "Error", g[g.Fatal = 80] = "Fatal", g[g.MetaData = 90] = "MetaData";
        }(f.LogLevel || (f.LogLevel = {})), function(g) {
            g[g.UseDefault = 0] = "UseDefault", g[g.Compress = 1] = "Compress", g[g.Disabled = 2] = "Disabled";
        }(f.LogFileCompression || (f.LogFileCompression = {})), function(g) {
            g[g.Raw = 0] = "Raw", g[g.Base64 = 1] = "Base64";
        }(f.LogFileEncoding || (f.LogFileEncoding = {})), function(g) {
            g[g.Unencrypted = 0] = "Unencrypted", g[g.Encrypted = 1] = "Encrypted";
        }(f.LogFileEncryption || (f.LogFileEncryption = {})), function(g) {
            g[g.PEM = 0] = "PEM", g[g.DER = 1] = "DER", g[g.BER = 2] = "BER";
        }(f.CertStoreFormat || (f.CertStoreFormat = {})), function(g) {
            g[g.InsertFront = 8] = "InsertFront";
        }(f.AppenderFlags || (f.AppenderFlags = {})), f.vsprintf = vsprintf, f.sprintf = sprintf;
    }), E = createCommonjsModule(function(g, f) {
        /*!
	 *  LogFactory.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2016-12-29
	 *  Copyright 2016 Microsoft. All rights reserved.
	 *
	 */ var S, v, E = _ && _.__extends || (S = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        });
        function hash(g) {
            if (null === g) return -1;
            for(var f = 0, S = g.length - 1; S >= 0; S--)f = 37 * f + g.charCodeAt(S) | 0;
            var v = "__auf_literal:";
            for(S = v.length - 1; S >= 0; S--)f = 37 * f + v.charCodeAt(S) | 0;
            return f;
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), function(g) {
            g[g.Unsafe = 0] = "Unsafe", g[g.Safe = 1] = "Safe", g[g.Inherited_Unsafe = 2] = "Inherited_Unsafe", g[g.Inherited_Safe = 3] = "Inherited_Safe", g[g.Blacklisted_Unsafe = 4] = "Blacklisted_Unsafe";
        }(v || (v = {}));
        var T, I = function() {
            function LogComponentImpl(g, f) {
                this._level = C.LogLevel.Debug4, this._threshold = 255, this._safe = v.Inherited_Unsafe, this._name = g, f && (this._level = f.level(), this._safe = f.safe() ? v.Inherited_Safe : v.Inherited_Unsafe, this._extendedInfo = f.extendedInfo());
            }
            return LogComponentImpl.prototype.name = function() {
                return this._name;
            }, LogComponentImpl.prototype.safe = function() {
                return this._safe === v.Safe || this._safe === v.Inherited_Safe;
            }, LogComponentImpl.prototype.safety = function() {
                return this._safe;
            }, LogComponentImpl.prototype.setSafety = function(g) {
                this._safe = g;
            }, LogComponentImpl.prototype.description = function() {
                return this._desc;
            }, LogComponentImpl.prototype.setDescription = function(g) {
                this._desc = g;
            }, LogComponentImpl.prototype.level = function() {
                return this._level;
            }, LogComponentImpl.prototype.setLevel = function(g) {
                T.setLevel(this, g);
            }, LogComponentImpl.prototype._setLevel = function(g) {
                this._level = g;
            }, LogComponentImpl.prototype._setThreshold = function(g) {
                this._threshold = g;
            }, LogComponentImpl.prototype.isEnabled = function(g) {
                return this._threshold <= g;
            }, LogComponentImpl.prototype.setExtendedInfo = function(g) {
                this._extendedInfo = g;
            }, LogComponentImpl.prototype.extendedInfo = function() {
                return this._extendedInfo;
            }, LogComponentImpl.prototype.trace = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Trace,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug6 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug6,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug5 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug5,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug4 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug4,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug3 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug3,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug2 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug2,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.debug1 = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Debug1,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.warn = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Warning,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.error = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Error,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.fatal = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.Fatal,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl.prototype.meta = function(g) {
                for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                T.log.apply(T, [
                    this,
                    C.LogLevel.MetaData,
                    hash(g),
                    g
                ].concat(f));
            }, LogComponentImpl;
        }(), b = function() {
            function LogFactory() {}
            return LogFactory.instance = function() {
                return T;
            }, LogFactory.levelToString = function(g) {
                return g <= C.LogLevel.Trace ? "TRACE" : g <= C.LogLevel.Debug6 ? "DEBUG6" : g <= C.LogLevel.Debug5 ? "DEBUG5" : g <= C.LogLevel.Debug4 ? "DEBUG4" : g <= C.LogLevel.Debug3 ? "DEBUG3" : g <= C.LogLevel.Debug2 ? "DEBUG2" : g <= C.LogLevel.Debug1 ? "DEBUG1" : g <= C.LogLevel.Warning ? "WARN" : g <= C.LogLevel.Error ? "ERROR" : g <= C.LogLevel.Fatal ? "FATAL" : (C.LogLevel.MetaData, "META");
            }, LogFactory.levelFromString = function(g) {
                return this._levelFromString[g] || parseInt(g, 10);
            }, LogFactory;
        }();
        function findLevel(g, f) {
            for(var S = f.name(); S.length > 0;){
                if (g[S]) return g[S];
                var v = S.lastIndexOf(".");
                S = v < 0 ? "" : S.substr(0, v);
            }
            return g[""] ? g[""] : C.LogLevel.Debug4;
        }
        function findThreshold(g, f) {
            var S = 255;
            return f.forEach(function(f) {
                var v = 255;
                f.appender.levels() ? v = Math.min(v, findLevel(f.appender.levels(), g)) : f.appender.receiveAll() || (v = Math.min(v, g.level())), S = Math.min(S, v);
            }), S;
        }
        function appenderMatches(g, f, S) {
            return !!g.appender.receiveAll() || (g.appender.levels() ? S >= findLevel(g.appender.levels(), f) : S >= f.level());
        }
        b._levelFromString = {
            TRACE: C.LogLevel.Trace,
            DEBUG6: C.LogLevel.Debug6,
            DEBUG5: C.LogLevel.Debug5,
            DEBUG4: C.LogLevel.Debug4,
            DEBUG3: C.LogLevel.Debug3,
            DEBUG2: C.LogLevel.Debug2,
            DEBUG1: C.LogLevel.Debug1,
            WARN: C.LogLevel.Warning,
            ERROR: C.LogLevel.Error,
            FATAL: C.LogLevel.Fatal,
            META: C.LogLevel.MetaData
        }, f.LogFactory = b;
        var A = function(g) {
            function LogFactoryImpl() {
                var f = g.call(this) || this;
                return f._nextId = 0, f._appenders = [], f._components = {}, f._componentBlacklist = [], f._components[""] = new I("", null), f;
            }
            return E(LogFactoryImpl, g), LogFactoryImpl.prototype.toHex = function(g) {
                return (4294967296 + g).toString(16).substr(-8);
            }, LogFactoryImpl.prototype.addAppender = function(g, f) {
                void 0 === f && (f = 0);
                var S = this._nextId++;
                return f & C.AppenderFlags.InsertFront ? this._appenders.unshift({
                    appender: g,
                    handle: S
                }) : this._appenders.push({
                    appender: g,
                    handle: S
                }), this.recalcComponentThresholds(), S;
            }, LogFactoryImpl.prototype.removeAppender = function(g) {
                for(var f = 0; f < this._appenders.length; f++)if (this._appenders[f].handle === g) {
                    this._appenders.splice(f, 1);
                    break;
                }
                this.recalcComponentThresholds();
            }, LogFactoryImpl.prototype.log = function(g, f, S, v) {
                for(var _ = [], C = 4; C < arguments.length; C++)_[C - 4] = arguments[C];
                try {
                    if (g.isEnabled(f)) {
                        var E = {
                            timestamp: (new Date).getTime(),
                            component: g,
                            level: f
                        };
                        this._appenders.forEach(function(C) {
                            appenderMatches(C, g, f) && C.appender.log(E, S, v, _);
                        });
                    }
                } catch (g) {}
            }, LogFactoryImpl.prototype.parent = function(g) {
                for(;;){
                    var f = g.lastIndexOf(".");
                    if (g = f >= 0 ? g.substr(0, f) : "", this._components[g]) return this._components[g];
                }
            }, LogFactoryImpl.prototype.children = function(g) {
                var f = [];
                for(var S in this._components)this.parent(S).name() === g && f.push(this._components[S]);
                return f;
            }, LogFactoryImpl.prototype.component = function(g) {
                if (this._components[g]) return this._components[g];
                var f = new I(g, this.parent(g));
                this._components[g] = f;
                var S = findThreshold(f, this._appenders);
                return f._setThreshold(S), f;
            }, LogFactoryImpl.prototype.rootComponent = function() {
                return this.component("");
            }, LogFactoryImpl.prototype.setSafetyRecursive = function(g, f) {
                var S = this;
                this.children(g).forEach(function(g) {
                    g.safety() !== v.Inherited_Safe && g.safety() !== v.Inherited_Unsafe || (g.setSafety(f), S.setSafetyRecursive(g.name(), f));
                });
            }, LogFactoryImpl.prototype.declareComponentSafe = function(g, f) {
                var S = this.component(g);
                -1 !== this._componentBlacklist.indexOf(S.name()) ? S.setSafety(v.Blacklisted_Unsafe) : S.setSafety(f ? v.Safe : v.Unsafe), this.setSafetyRecursive(g, f ? v.Inherited_Safe : v.Inherited_Unsafe);
            }, LogFactoryImpl.prototype.declareComponentDescription = function(g, f) {
                this.component(g).setDescription(f);
            }, LogFactoryImpl.prototype.setExtendedInfoRecursive = function(g, f) {
                var S = this;
                this.children(g).forEach(function(g) {
                    void 0 === g.extendedInfo() && (g.setExtendedInfo(f), S.setExtendedInfoRecursive(g.name(), f));
                });
            }, LogFactoryImpl.prototype.declareComponentExtendedInfo = function(g, f) {
                var S = this.component(g);
                S.setExtendedInfo(f), this.setExtendedInfoRecursive(S.name(), f);
            }, LogFactoryImpl.prototype.recalcComponentThresholds = function() {
                for(var g in this._components){
                    var f = this._components[g], S = findThreshold(f, this._appenders);
                    f._setThreshold(S);
                }
            }, LogFactoryImpl.prototype.setLevel = function(g, f) {
                if ("" === g.name()) for(var S in this._components){
                    (C = this._components[S])._setLevel(f);
                    var v = findThreshold(C, this._appenders);
                    C._setThreshold(v);
                }
                else {
                    var _ = g.name() + ".";
                    g._setLevel(f);
                    v = findThreshold(g, this._appenders);
                    for(var S in g._setThreshold(v), this._components){
                        var C;
                        if ((C = this._components[S]).name().substr(0, _.length) === _) {
                            C._setLevel(f);
                            var E = findThreshold(C, this._appenders);
                            C._setThreshold(E);
                        }
                    }
                }
            }, LogFactoryImpl.prototype.setComponentBlacklist = function(g) {
                for(var f in this._componentBlacklist = g, this._components){
                    var S = this._components[f];
                    -1 !== this._componentBlacklist.indexOf(S.name()) && S.setSafety(v.Blacklisted_Unsafe);
                }
            }, LogFactoryImpl;
        }(b);
        T = new A;
    }), T = createCommonjsModule(function(g, f) {
        function fromThenable(g) {
            var f = Defer();
            return g.then(function(g) {
                f.resolve(g);
            }, function(g) {
                f.reject(g);
            }), f.promise().thenAsync(function(g) {
                return g;
            });
        }
        function isThenable(g) {
            return null != g && "function" == typeof g.then;
        }
        function isCancelable(g) {
            return null != g && "function" == typeof g.cancel;
        }
        function run(g, S) {
            if (!f.config.catchExceptions) return g();
            try {
                return g();
            } catch (g) {
                return S(g);
            }
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.config = {
            exceptionsToConsole: !0,
            catchExceptions: !0,
            traceEnabled: !1,
            exceptionHandler: void 0,
            unhandledErrorHandler: function(g) {
                throw g;
            }
        }, f.fromThenable = fromThenable;
        var S, v = [], _ = "undefined" != typeof setImmediate;
        function asyncCallback(g) {
            v.push(g), 1 === v.length && (_ ? setImmediate(resolveAsyncCallbacks) : setTimeout(resolveAsyncCallbacks, 0));
        }
        function resolveAsyncCallbacks() {
            var g = v;
            v = [];
            for(var f = 0; f < g.length; f++)g[f]();
        }
        function all(g) {
            if (0 === g.length) return Resolved([]);
            var f, v = Defer(), _ = g.length, C = Array(g.length);
            v.onCancel(function(f) {
                g.forEach(function(g) {
                    isCancelable(g) && S.SyncTask.cancelOtherInternal(g, f);
                });
            });
            var checkFinish = function() {
                0 == --_ && (void 0 !== f ? v.reject(f) : v.resolve(C));
            };
            return g.forEach(function(g, S) {
                isThenable(g) ? g.then(function(g) {
                    C[S] = g, checkFinish();
                }, function(g) {
                    void 0 === f && (f = void 0 === g || g), checkFinish();
                }) : (C[S] = g, checkFinish());
            }), v.promise();
        }
        function Defer() {
            return new S.SyncTask;
        }
        function Resolved(g) {
            return (new S.SyncTask).resolve(g).promise();
        }
        function Rejected(g) {
            return (new S.SyncTask).reject(g).promise();
        }
        function race(g) {
            var f = Defer(), v = !1;
            return f.onCancel(function(f) {
                g.forEach(function(g) {
                    isCancelable(g) && S.SyncTask.cancelOtherInternal(g, f);
                });
            }), g.forEach(function(g) {
                isThenable(g) ? g.then(function(g) {
                    v || (v = !0, f.resolve(g));
                }, function(g) {
                    v || (v = !0, f.reject(g));
                }) : v || (v = !0, f.resolve(g));
            }), f.promise();
        }
        function raceTimer(g, f) {
            var S = Defer(), v = setTimeout(function() {
                S.resolve({
                    timedOut: !0
                });
            }, f);
            return race([
                g.then(function(g) {
                    return clearTimeout(v), {
                        timedOut: !1,
                        result: g
                    };
                }),
                S.promise()
            ]);
        }
        f.asyncCallback = asyncCallback, function(g) {
            var S = function() {
                function SyncTask() {
                    this._completedSuccess = !1, this._completedFail = !1, this._traceEnabled = !1, this._cancelCallbacks = [], this._wasCanceled = !1, this._wasExplicitlyCanceled = !1, this._resolving = !1, this._storedCallbackSets = [], this._mustHandleError = !0;
                }
                return SyncTask.prototype._addCallbackSet = function(g, f) {
                    var S = this, v = new SyncTask;
                    return v.onCancel(function(f) {
                        g.wasCanceled = !0, g.cancelContext = f, S._cancelInternal(f);
                    }), g.task = v, this._storedCallbackSets.push(g), f ? this._mustHandleError = !1 : v._mustHandleError = !1, this._resolving || (this._completedSuccess ? this._resolveSuccesses() : this._completedFail && this._resolveFailures()), v.promise();
                }, SyncTask.prototype.onCancel = function(g) {
                    return this._completedSuccess || this._completedFail || (this._wasCanceled ? g(this._cancelContext) : this._cancelCallbacks.push(g)), this;
                }, SyncTask.prototype.then = function(g, f) {
                    return this._addCallbackSet({
                        successFunc: g,
                        failFunc: f
                    }, !0);
                }, SyncTask.prototype.thenAsync = function(g, f) {
                    return this._addCallbackSet({
                        successFunc: g,
                        failFunc: f,
                        asyncCallback: !0
                    }, !0);
                }, SyncTask.prototype.catch = function(g) {
                    return this._addCallbackSet({
                        failFunc: g
                    }, !0);
                }, SyncTask.prototype.always = function(g) {
                    return this._addCallbackSet({
                        successFunc: g,
                        failFunc: g
                    }, !0);
                }, SyncTask.prototype.setTracingEnabled = function(g) {
                    return this._traceEnabled = g, this;
                }, SyncTask.prototype.finally = function(g) {
                    return this._addCallbackSet({
                        successFunc: g,
                        failFunc: g
                    }, !1), this;
                }, SyncTask.prototype.done = function(g) {
                    return this._addCallbackSet({
                        successFunc: g
                    }, !1), this;
                }, SyncTask.prototype.fail = function(g) {
                    return this._addCallbackSet({
                        failFunc: g
                    }, !1), this;
                }, SyncTask.prototype.resolve = function(g) {
                    return this._checkState(!0), this._completedSuccess = !0, this._storedResolution = g, this._cancelCallbacks = [], this._resolveSuccesses(), this;
                }, SyncTask.prototype.reject = function(g) {
                    return this._checkState(!1), this._completedFail = !0, this._storedErrResolution = g, this._cancelCallbacks = [], this._resolveFailures(), SyncTask._enforceErrorHandled(this), this;
                }, SyncTask.prototype._checkState = function(g) {
                    if (this._completedSuccess || this._completedFail) {
                        this._completeStack && console.error(this._completeStack.message, this._completeStack.stack);
                        var S = "Failed to " + (g ? "resolve" : "reject") + ": the task is already " + (this._completedSuccess ? "resolved" : "rejected");
                        throw new Error(S);
                    }
                    (f.config.traceEnabled || this._traceEnabled) && (this._completeStack = new Error("resolve"));
                }, SyncTask._enforceErrorHandled = function(g) {
                    g._mustHandleError && (SyncTask._rejectedTasks.push(g), SyncTask._enforceErrorHandledTimer || (SyncTask._enforceErrorHandledTimer = setTimeout(function() {
                        SyncTask._enforceErrorHandledTimer = void 0;
                        var g = SyncTask._rejectedTasks;
                        SyncTask._rejectedTasks = [], g.forEach(function(g, S) {
                            g._mustHandleError && f.config.unhandledErrorHandler(g._storedErrResolution);
                        });
                    }, 0)));
                }, SyncTask.prototype.cancel = function(g) {
                    if (this._wasExplicitlyCanceled) throw new Error("Already Canceled");
                    this._wasExplicitlyCanceled = !0, this._cancelInternal(g);
                }, SyncTask.prototype._cancelInternal = function(g) {
                    var f = this;
                    if (!this._wasCanceled) {
                        this._wasCanceled = !0, this._cancelContext = g;
                        var S = this._cancelCallbacks;
                        this._cancelCallbacks = [], S.length > 0 && S.forEach(function(g) {
                            f._completedSuccess || f._completedFail || g(f._cancelContext);
                        });
                    }
                }, SyncTask.cancelOtherInternal = function(g, f) {
                    var S = g;
                    S._storedCallbackSets && S._cancelInternal ? S._cancelInternal(f) : g.cancel(f);
                }, SyncTask.prototype.promise = function() {
                    return this;
                }, SyncTask.prototype._resolveSuccesses = function() {
                    var g = this;
                    for(this._resolving = !0; this._storedCallbackSets.length;){
                        var f = this._storedCallbackSets;
                        this._storedCallbackSets = [], f.forEach(function(f) {
                            f.asyncCallback ? asyncCallback(function() {
                                return g._resolveSuccessCallback(f);
                            }) : g._resolveSuccessCallback(f);
                        });
                    }
                    this._resolving = !1;
                }, SyncTask.prototype._resolveSuccessCallback = function(g) {
                    var f = this;
                    g.successFunc ? run(function() {
                        var S = g.successFunc(f._storedResolution);
                        isCancelable(S) && (g.wasCanceled ? SyncTask.cancelOtherInternal(S, g.cancelContext) : g.task.onCancel(function(g) {
                            return SyncTask.cancelOtherInternal(S, g);
                        })), isThenable(S) ? S.then(function(f) {
                            g.task.resolve(f);
                        }, function(f) {
                            g.task.reject(f);
                        }) : g.task.resolve(S);
                    }, function(S) {
                        f._handleException(S, "SyncTask caught exception in success block: " + S.toString()), g.task.reject(S);
                    }) : g.task.resolve(this._storedResolution);
                }, SyncTask.prototype._resolveFailures = function() {
                    var g = this;
                    for(this._resolving = !0; this._storedCallbackSets.length;){
                        var f = this._storedCallbackSets;
                        this._storedCallbackSets = [], f.forEach(function(f) {
                            f.asyncCallback ? asyncCallback(function() {
                                return g._resolveFailureCallback(f);
                            }) : g._resolveFailureCallback(f);
                        });
                    }
                    this._resolving = !1;
                }, SyncTask.prototype._resolveFailureCallback = function(g) {
                    var f = this;
                    g.failFunc ? run(function() {
                        var S = g.failFunc(f._storedErrResolution);
                        isCancelable(S) && (g.wasCanceled ? SyncTask.cancelOtherInternal(S, g.cancelContext) : g.task.onCancel(function(g) {
                            return SyncTask.cancelOtherInternal(S, g);
                        })), isThenable(S) ? S.then(function(f) {
                            g.task.resolve(f);
                        }, function(f) {
                            g.task.reject(f);
                        }) : g.task.resolve(S);
                    }, function(S) {
                        f._handleException(S, "SyncTask caught exception in failure block: " + S.toString()), g.task.reject(S);
                    }) : g.task.reject(this._storedErrResolution);
                }, SyncTask.prototype._handleException = function(g, S) {
                    f.config.exceptionsToConsole && console.error(S), f.config.exceptionHandler && f.config.exceptionHandler(g);
                }, SyncTask.prototype.toEs6Promise = function() {
                    var g = this;
                    return new Promise(function(f, S) {
                        return g.then(f, S);
                    });
                }, SyncTask._rejectedTasks = [], SyncTask;
            }();
            g.SyncTask = S;
        }(S || (S = {})), f.all = all, f.Defer = Defer, f.Resolved = Resolved, f.Rejected = Rejected, f.race = race, f.raceTimer = raceTimer;
    }), I = createCommonjsModule(function(g, f) {
        /*!
	 *  Appenders.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2016-12-29
	 *  Copyright 2016 Microsoft. All rights reserved.
	 *
	 */ var S, v = _ && _.__extends || (S = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        });
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var T, I = function() {
            function AbstractLogAppender(g) {
                this._formatter = g || new b;
            }
            return AbstractLogAppender.prototype.formatter = function() {
                return this._formatter;
            }, AbstractLogAppender.prototype.receiveAll = function() {
                return !1;
            }, AbstractLogAppender.prototype.levels = function() {
                return null;
            }, AbstractLogAppender;
        }();
        function toHex(g) {
            return (4294967296 + g).toString(16).substr(-8);
        }
        function pad(g, f) {
            return (1e12 + g).toString(10).substr(-f);
        }
        f.AbstractLogAppender = I, function(g) {
            g[g.Timestamp = 1] = "Timestamp", g[g.Component = 4] = "Component", g[g.Level = 8] = "Level", g[g.FullDate = 32] = "FullDate", g[g.LogId = 64] = "LogId";
        }(T = f.SLF_Flags || (f.SLF_Flags = {}));
        var b = function() {
            function StandardLogFormatter(g) {
                void 0 === g && (g = 4294967295), this._flags = g;
            }
            return StandardLogFormatter.prototype.format = function(g, f, S, v) {
                var _ = "";
                if (this._flags & T.FullDate) _ += new Date(g.timestamp).toISOString() + " ";
                else if (this._flags & T.Timestamp) {
                    var I = new Date(g.timestamp);
                    _ += pad(I.getHours(), 2) + ":" + pad(I.getMinutes(), 2) + ":" + pad(I.getSeconds(), 2) + "." + pad(I.getMilliseconds(), 2) + " ";
                }
                return this._flags & T.LogId && (_ += "[#" + toHex(f) + "-" + (g.component.safe() ? "S" : "u") + "] "), this._flags & T.Level && (_ += "[" + E.LogFactory.levelToString(g.level) + "] "), this._flags & T.Component && (_ += "[" + g.component.name() + "] "), S || "" === S ? _ + C.vsprintf(S, v) : _ + toHex(f) + ": " + v.join(" ");
            }, StandardLogFormatter;
        }();
        f.StandardLogFormatter = b;
        var A = console, R = console.log || function() {}, P = console.info || R, w = console.warn || P, M = console.error || w, O = function(g) {
            function ConsoleAppender() {
                return null !== g && g.apply(this, arguments) || this;
            }
            return v(ConsoleAppender, g), ConsoleAppender.prototype.log = function(g, f, S, v) {
                v = v.slice(0);
                var _ = g.level <= C.LogLevel.Debug3 ? R : g.level <= C.LogLevel.Debug1 ? P : g.level <= C.LogLevel.Warning ? w : M;
                if (-1 === f) {
                    var E = this.formatter().format(g, f, "", []);
                    "string" == typeof v[0] && (E += v.shift()), _.apply(A, [
                        E
                    ].concat(v));
                } else {
                    for(var T = void 0, I = []; T = S.match(/\s*%@\s*$/);)S = S.substr(0, S.length - T[0].length), I.unshift(v.pop());
                    E = this.formatter().format(g, f, S, v);
                    _.apply(A, [
                        E
                    ].concat(I));
                }
            }, ConsoleAppender;
        }(I);
        f.ConsoleAppender = O;
        var D = function() {
            function ChainedLogAppender(g) {
                this._chained = g;
            }
            return ChainedLogAppender.prototype.log = function(g, f, S, v) {
                this._chained.log(g, f, S, v);
            }, ChainedLogAppender.prototype.receiveAll = function() {
                return this._chained.receiveAll();
            }, ChainedLogAppender.prototype.levels = function() {
                return this._chained.levels();
            }, ChainedLogAppender;
        }();
        f.ChainedLogAppender = D;
        var N = function(g) {
            function LevelWrappedAppender(f, S) {
                var v = g.call(this, f) || this;
                return v._levels = S, v;
            }
            return v(LevelWrappedAppender, g), LevelWrappedAppender.prototype.levels = function() {
                return this._levels;
            }, LevelWrappedAppender;
        }(D);
        function wrapAppenderWithLogLevels(g, f) {
            return new N(g, f);
        }
        f.wrapAppenderWithLogLevels = wrapAppenderWithLogLevels;
    }), b = createCommonjsModule(function(g, f) {
        /*!
	 *  RootToolsManager.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2016-12-29
	 *  Copyright 2016 Microsoft. All rights reserved.
	 *
	 */ var S, v = _ && _.__extends || (S = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        });
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var b = E.LogFactory.instance().component("RootToolsManager");
        E.LogFactory.instance().declareComponentSafe("RootToolsManager", !0);
        var A, R = "638b8ba2bae14e07aa5d73ddb5d5e5c5-297b8412-5df3-4a83-83c4-7b76c6c5d3f0-7104";
        !function(g) {
            g[g.InternalBuild = 0] = "InternalBuild", g[g.PublicBuild = 1] = "PublicBuild";
        }(A = f.BuildType || (f.BuildType = {}));
        var P = A.InternalBuild;
        function setBuildType(g) {
            var f = P;
            return P = g, f;
        }
        function toHex(g) {
            return (4294967296 + g).toString(16).substr(-8);
        }
        function map(g, f) {
            var S = [];
            for(var v in g)S.push(f(v, g[v]));
            return S;
        }
        function arrayEquals(g, f, S) {
            if (null == g) return null == f || 0 === f.length;
            if (null == f) return null == g || 0 === g.length;
            if (g.length === f.length) {
                for(var v = 0; v < g.length; v++)if (!S(g[v], f[v])) return !1;
                return !0;
            }
            return !1;
        }
        function matcherEquals(g, f) {
            return null == g ? null == f : null == f ? null == g : g.arg === f.arg && g.op === f.op && g.value === f.value;
        }
        function conditionEquals(g, f) {
            return null == g ? null == f || 0 === f.logId : null == f ? null == g || 0 === g.logId : g.logId === f.logId && g.name === f.name && arrayEquals(g.matchers, f.matchers, matcherEquals);
        }
        function filterEqualsToNativeFilter(g, f) {
            return null == g ? null == f : null == f ? null == g : g.component === f.component && g.parsedLevel === f.level;
        }
        function filterEquals(g, f) {
            return null == g ? null == f : null == f ? null == g : g.component === f.component && g.level === f.level;
        }
        function formatArgs(g) {
            for(var f = [], S = 0; S < g.length; S++)"string" == typeof g[S] || "number" == typeof g[S] ? f.push(g[S]) : f.push(JSON.stringify(g[S]));
            return f;
        }
        f.setBuildType = setBuildType;
        var w = function(g) {
            function Trigger(f, S, v) {
                var _ = g.call(this) || this;
                return _._unmetConditions = [], _._rtMan = f, _._triggerCallback = S, _._ecsConfig = v, _.resetConditions(), _;
            }
            return v(Trigger, g), Trigger.prototype.config = function() {
                return this._ecsConfig;
            }, Trigger.prototype.configEquals = function(g) {
                return this._ecsConfig.includeUnsafe === g.includeUnsafe && this._ecsConfig.mutualSubmissionType === g.mutualSubmissionType && this._ecsConfig.name === g.name && this._ecsConfig.reenableAfterTriggering === g.reenableAfterTriggering && this._ecsConfig.experimentTarget === g.experimentTarget && conditionEquals(this._ecsConfig.resetCondition, g.resetCondition) && arrayEquals(this._ecsConfig.conditions, g.conditions, conditionEquals) && arrayEquals(this._ecsConfig.filters, g.filters, filterEquals);
            }, Trigger.prototype.nativeConfigEquals = function(g) {
                return this._ecsConfig.includeUnsafe === g.includeUnsafe && this._ecsConfig.name === g.name && this._ecsConfig.reenableAfterTriggering === g.reenableAfterTriggering && conditionEquals(this._ecsConfig.resetCondition, g.resetCondition) && arrayEquals(this._ecsConfig.conditions, g.conditions, conditionEquals) && arrayEquals(this._ecsConfig.filters, g.filters, filterEqualsToNativeFilter);
            }, Trigger.prototype.needReset = function(g) {
                return !this.configEquals(g);
            }, Trigger.prototype.resetConditions = function() {
                this._unmetConditions = [];
                for(var g = 0; g < this._ecsConfig.conditions.length; g++)this._unmetConditions.push(g);
            }, Trigger.prototype.matcherMatches = function(g, f) {
                if (g.arg >= f.length) return !1;
                var S = f[g.arg], v = "string" == typeof S ? g.value : parseInt(g.value, 10);
                return "=" === g.op || "==" === g.op ? S === v : "!=" === g.op ? S !== v : "<" === g.op ? S < v : "<=" === g.op ? S <= v : ">" === g.op ? S > v : ">=" === g.op ? S >= v : "CONTAINS" === g.op.toUpperCase() && ("" + S).indexOf(g.value) >= 0;
            }, Trigger.prototype.conditionMatches = function(g, f, S) {
                if (f !== g.logId) return !1;
                if (g.matchers) {
                    for(var v = 0; v < g.matchers.length; v++)if (!this.matcherMatches(g.matchers[v], S)) return !1;
                }
                return !0;
            }, Trigger.prototype.log = function(g, f, S, v) {
                if (0 !== this._unmetConditions.length && g.component !== b) {
                    var _ = this._ecsConfig;
                    _.resetCondition && this.conditionMatches(_.resetCondition, f, v) && (b.debug4("LogTrigger %s: resetCondition met", _.name), this.resetConditions());
                    for(var C = 0; C < this._unmetConditions.length; C++){
                        var E = this._unmetConditions[C];
                        if (this.conditionMatches(_.conditions[E], f, v)) {
                            b.debug4("LogTrigger %s: condition %s met", _.name, _.conditions[E].name), this._unmetConditions.splice(C, 1);
                            break;
                        }
                    }
                    0 === this._unmetConditions.length && (b.debug1("LogTrigger %s has triggered, trying to send the log", _.name), this._triggerCallback.call(this._rtMan, _), _.reenableAfterTriggering && this.resetConditions());
                }
            }, Trigger.prototype.receiveAll = function() {
                return !0;
            }, Trigger;
        }(I.AbstractLogAppender), M = function(g) {
            function CircularBuffer(f, S, v) {
                var _ = g.call(this) || this;
                return _._circularBuffer = [], _._circularBufferMaxSize = 0, _._onBufferOverflow = null, _._circularBuffer = [], _._circularBufferMaxSize = S, _._includeUnsafe = f, _._onBufferOverflow = v || function() {
                    return _._circularBuffer.shift();
                }, _;
            }
            return v(CircularBuffer, g), CircularBuffer.prototype.log = function(g, f, S, v) {
                if ((this._includeUnsafe || g.component.safe()) && !(this._circularBuffer.length > this._circularBufferMaxSize)) {
                    var _ = {
                        md: g,
                        logId: f,
                        messages: formatArgs(v)
                    };
                    this._circularBuffer.push(_), this._circularBuffer.length > this._circularBufferMaxSize && this._onBufferOverflow();
                }
            }, CircularBuffer.prototype.visitReverseOrder = function(g) {
                for(var f = this._circularBuffer.length - 1; f >= 0; f--){
                    var S = this._circularBuffer[f];
                    if (!g(S.md, S.logId, S.messages)) return;
                }
            }, CircularBuffer.prototype.visitForwardOrder = function(g) {
                for(var f = 0; f < this._circularBuffer.length; f++){
                    var S = this._circularBuffer[f];
                    if (!g(S.md, S.logId, S.messages)) return;
                }
            }, CircularBuffer.prototype.needReset = function(g, f) {
                return g !== this._includeUnsafe || f !== this._circularBufferMaxSize;
            }, CircularBuffer.prototype.dumpLogBuffer = function(g, f, S) {
                var v = this, _ = new O(g.reverse), C = g.filter.map(function(g) {
                    return {
                        component: "root" === g.component ? "" : g.component,
                        parsedLevel: g.level
                    };
                }), E = S || {
                    matchedLines: 0,
                    totalLines: 0
                };
                return (g.reverse ? this.visitReverseOrder : this.visitForwardOrder).apply(this, [
                    function(g, S, T) {
                        return E.totalLines++, v.filterMatches(g, S, T, C) && (E.matchedLines++, _.log(g.component, g.timestamp, g.level, S, T)), !f || _._data.length < f;
                    }
                ]), _.close(), _.data();
            }, CircularBuffer.prototype.filterMatches = function(g, f, S, v) {
                for(var _ = 0; _ < v.length; _++)if (("" === v[_].component || g.component.name() === v[_].component || g.component.name().substr(0, v[_].component.length) === v[_].component && "." === g.component.name().charAt(v[_].component.length)) && g.level >= v[_].parsedLevel) return !0;
                return !1;
            }, CircularBuffer.prototype.clear = function() {
                this._circularBuffer = [];
            }, CircularBuffer.prototype.size = function() {
                return this._circularBuffer.length;
            }, CircularBuffer.prototype.empty = function() {
                return 0 === this.size();
            }, CircularBuffer.prototype.capacity = function() {
                return this._circularBufferMaxSize;
            }, CircularBuffer;
        }(I.AbstractLogAppender);
        f.CircularBuffer = M;
        var O = function() {
            function BinaryLogFormatter(g) {
                this._reverse = g, this._first = !0, this._pending = [], this._components = {}, this._componentCount = 0, this._lastts = 0, this._base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", this._data = "ULOG2" + String.fromCharCode(33) + String.fromCharCode(32), this._data += g ? String.fromCharCode(34) : String.fromCharCode(32), this._data += String.fromCharCode(32);
            }
            return BinaryLogFormatter.prototype._add8 = function(g) {
                if (this._pending.push(255 & g), 3 === this._pending.length) {
                    var f = (this._pending[0] << 16) + (this._pending[1] << 8) + (this._pending[2] << 0), S = this._base64chars[f >> 18 & 63] + this._base64chars[f >> 12 & 63] + this._base64chars[f >> 6 & 63] + this._base64chars[f >> 0 & 63];
                    this._data += S, this._pending = [];
                }
            }, BinaryLogFormatter.prototype._add16 = function(g) {
                this._add8(g >> 8 & 255), this._add8(g >> 0 & 255);
            }, BinaryLogFormatter.prototype._add32 = function(g) {
                this._add8(g >> 24 & 255), this._add8(g >> 16 & 255), this._add8(g >> 8 & 255), this._add8(g >> 0 & 255);
            }, BinaryLogFormatter.prototype._add64 = function(g) {
                this._add32(g / 4294967296 | 0), this._add32(0 | g);
            }, BinaryLogFormatter.prototype._addS = function(g) {
                for(var f = 0; f < g.length; f++)this._add8(g.charCodeAt(f));
                this._add8(0);
            }, BinaryLogFormatter.prototype._close = function() {
                for(; this._pending.length;)this._add8(0);
            }, BinaryLogFormatter.prototype.log = function(g, f, S, v, _) {
                var C = this._components[g.name()];
                C || (C = ++this._componentCount, this._components[g.name()] = C, this._add8(2), this._add16(C), this._addS(g.name()), this._addS(""), this._addS(""), this._add8(g.safe() ? 1 : 0));
                var E = 128;
                this._first && (E |= 2);
                var T = f - this._lastts;
                this._lastts = f, T > -128 && T < 128 && (E |= 1), this._add8(E), 1 & E ? this._add8(T) : this._add64(1e3 * f), this._first && (this._add32(1), this._add8(0), this._add16(0)), this._add16(C), this._add8(S), this._add32(v), this._add8(_.length);
                for(var I = 0; I < _.length; I++)this._add8(8), this._addS("" + _[I]);
                this._first = !1;
            }, BinaryLogFormatter.prototype.close = function() {
                this._add8(7), this._close();
            }, BinaryLogFormatter.prototype.data = function() {
                return this._data;
            }, BinaryLogFormatter.prototype.empty = function() {
                return this._first;
            }, BinaryLogFormatter;
        }(), D = function(g) {
            function DumperBuffer(f, S, v, _) {
                var C = g.call(this) || this;
                return C._capacity = f, C._onBufferOverflow = S, C._enableThrottling = v, C._maxVerbosityLevel = _, C._outputFormatter = new O(!1), C._linesStored = 0, C._throttling = !1, C._linesThrottled = 0, C;
            }
            return v(DumperBuffer, g), DumperBuffer.prototype.log = function(g, f, S, v) {
                this._maxVerbosityLevel && g.level < this._maxVerbosityLevel || (this._throttling ? this._linesThrottled++ : (this._linesStored++, this._outputFormatter.log(g.component, g.timestamp, g.level, f, formatArgs(v))), this._linesStored > this._capacity && (this._enableThrottling ? this._throttling || (this._throttling = !0) : this._onBufferOverflow()));
            }, DumperBuffer.prototype.dumpAndReset = function() {
                if (this._outputFormatter.empty()) return "";
                this._linesThrottled > 0 && this._outputFormatter.log(b, (new Date).getTime(), C.LogLevel.Fatal, -1, [
                    "RooToolsManager: Log buffer overflow! " + this._linesThrottled + " lines thrown away"
                ]), this._outputFormatter.close();
                var g = this._outputFormatter.data();
                return this.clearBuffer(), g;
            }, DumperBuffer.prototype.empty = function() {
                return this._outputFormatter.empty();
            }, DumperBuffer.prototype.clearBuffer = function() {
                this._outputFormatter = new O(!1), this._linesStored = 0, this._linesThrottled = 0, this._throttling = !1;
            }, DumperBuffer.prototype.capacity = function() {
                return this._capacity;
            }, DumperBuffer.prototype.throttlingEnabled = function() {
                return this._enableThrottling;
            }, DumperBuffer.prototype.size = function() {
                return this._linesStored;
            }, DumperBuffer.prototype.maxVerbosityLevel = function() {
                return this._maxVerbosityLevel;
            }, DumperBuffer;
        }(I.AbstractLogAppender);
        function validateExperimentTarget(g) {
            return "Native" === g || "JavaScript" === g || "Mixed" === g;
        }
        f.DumperBuffer = D;
        var N = function() {
            function RootToolsManagerImpl() {
                this._maxUploadSize = 0, this._jsToNativeBuffer = null, this._jsToNativeBufferHandle = null, this._jsToNativeFlushTimer = null, this._jsToNativeFlushInterval = 0, this._triggers = {}, this._defaultBuffers = [
                    {
                        size: 2097152,
                        level: C.LogLevel.Debug4
                    }
                ], this._defaultKillswitch = {
                    blacklist: [],
                    whitelist: []
                }, this._defaultBlacklists = {
                    component: [],
                    logline: []
                }, this._localLogLevels = {}, this._defaultExperimentTarget = "Mixed", this._BRBCallback = null;
            }
            return RootToolsManagerImpl.prototype.setDelegate = function(g) {
                this._glue = g, this.registerListeners();
            }, RootToolsManagerImpl.prototype.isDelegateSet = function() {
                return null != this._glue;
            }, RootToolsManagerImpl.prototype.setNativeFunctions = function(g) {
                this._native && this._native.log_config.removeLogTriggerListener(this), this._native = g, this._native && this._native.log_config.addLogTriggerListener(this);
            }, RootToolsManagerImpl.prototype.applyLogLevels = function() {
                var g = {};
                for(var f in this._localLogLevels)g[f] = this._localLogLevels[f];
                g[""] = g.root || C.LogLevel.Debug4, delete g.root;
                var S = map(g, function(g, f) {
                    return {
                        component: g,
                        level: f
                    };
                });
                S.sort(function(g, f) {
                    return g.component.length - f.component.length;
                }), S.forEach(function(g) {
                    return E.LogFactory.instance().component(g.component).setLevel(g.level);
                }), this._native && this._native.log_config.setLogLevelConfig(S);
            }, RootToolsManagerImpl.prototype.setLocalLogLevelConfig = function(g) {
                this._localLogLevels = g, this.applyLogLevels();
            }, RootToolsManagerImpl.prototype.parseMatcher = function(g) {
                return null == g || null == g.arg || null == g.op || null == g.value ? null : {
                    arg: g.arg,
                    op: g.op,
                    value: g.value
                };
            }, RootToolsManagerImpl.prototype.parseCondition = function(g) {
                if (null == g || null == g.logId) return null;
                if (g.matchers && !(g.matchers instanceof Array)) return null;
                var f = {
                    name: g.name || toHex(g.logId),
                    logId: g.logId,
                    matchers: []
                };
                if (g.matchers && g.matchers.length) for(var S = 0, v = g.matchers; S < v.length; S++){
                    var _ = v[S], C = this.parseMatcher(_);
                    C && f.matchers.push(C);
                }
                return f;
            }, RootToolsManagerImpl.prototype.parseFilter = function(g) {
                return null == g || null == g.component || 0 === g.component.length ? null : {
                    component: g.component,
                    level: g.level,
                    parsedLevel: E.LogFactory.levelFromString(g.level)
                };
            }, RootToolsManagerImpl.prototype.parseConfig = function(g, f, S) {
                if (null == g) return null;
                if (!(g.conditions instanceof Array) || 0 == g.conditions.length) return null;
                if (!(g.filters instanceof Array) || 0 == g.filters.length) return null;
                if (g.resetCondition && !this.parseCondition(g.resetCondition)) return null;
                for(var v = {
                    name: g.name || f + "->" + S,
                    ecsNs: f,
                    reenableAfterTriggering: g.reenableAfterTriggering || !1,
                    mutualSubmissionType: g.mutualSubmissionType || "",
                    includeUnsafe: P !== A.PublicBuild && (g.includeUnsafe || !1),
                    experimentTarget: validateExperimentTarget(g.experimentTarget) && g.experimentTarget || this._defaultExperimentTarget,
                    conditions: [],
                    resetCondition: null == g.resetCondition ? g.resetCondition : this.parseCondition(g.resetCondition),
                    filters: []
                }, _ = 0, C = g.conditions; _ < C.length; _++){
                    var E = C[_], T = this.parseCondition(E);
                    T && v.conditions.push(T);
                }
                for(var I = 0, b = g.filters; I < b.length; I++){
                    var R = b[I], w = this.parseFilter(R);
                    w && v.filters.push(w);
                }
                return 0 === v.conditions.length ? null : v;
            }, RootToolsManagerImpl.prototype.isExperimentListed = function(g, f, S, v) {
                return !!g && (!(!v || !g.some(function(g) {
                    return "*" === g.namespace;
                })) || g.some(function(g) {
                    return g.namespace === f && (g.experiment === S || "*" == g.experiment);
                }));
            }, RootToolsManagerImpl.prototype.isExperimentAllowed = function(g, f, S) {
                return !this.isExperimentListed(g.blacklist, f, S, !0) || this.isExperimentListed(g.whitelist, f, S, !1);
            }, RootToolsManagerImpl.prototype.findTrigger = function(g, f) {
                for(var S in g)if (g[S].configEquals(f)) return S;
                return null;
            }, RootToolsManagerImpl.prototype.findTriggerByNativeConfig = function(g, f) {
                for(var S in g)if (g[S].nativeConfigEquals(f)) return S;
                return null;
            }, RootToolsManagerImpl.prototype.OnEcsChange = function() {
                var g = this;
                function forEachAsync(g, f, S) {
                    return f < g.length ? S(g[f]).then(function() {
                        return forEachAsync(g, f + 1, S);
                    }) : T.Resolved();
                }
                return null == this._glue ? T.Resolved() : this._glue.fetchEcsConfig("SkypeRootTools", "ULBaseline").then(function(f) {
                    b.debug4("Reloading ULBaseline config - new config: %@", f), f || (b.warn("No ULBaseline config"), f = {}), g._maxUploadSize = f.logUpload && f.logUpload.maxSize || 1024;
                    var S = [], v = g._triggers;
                    g._triggers = {};
                    var _ = (f.logUpload && f.logUpload.maxSize || 1024) / 100, T = f.circularBuffer && f.circularBuffer.enabled, A = f.circularBuffer && f.circularBuffer.buffers || g._defaultBuffers, R = f.circularBuffer && f.circularBuffer.storeUnsafe;
                    g._defaultExperimentTarget = validateExperimentTarget(f.defaultExperimentTarget) && f.defaultExperimentTarget || "Mixed";
                    var P = f.killswitch || g._defaultKillswitch, O = f.blacklists || g._defaultBlacklists;
                    O.component.length > 0 && E.LogFactory.instance().setComponentBlacklist(O.component);
                    var D = {};
                    (f.componentLevels || []).forEach(function(g) {
                        return D[g.component] = g.level;
                    }), forEachAsync(f.configPaths || [], 0, function(f) {
                        return g._glue.fetchEcsConfig(f.ns, f.key).then(function(_) {
                            var C = _ instanceof Array ? _ : [
                                _
                            ];
                            b.debug4("Reloading ECS config for %s->%s - new config: %@", f.ns, f.key, C);
                            for(var E = 0, I = C; E < I.length; E++){
                                var A = I[E];
                                if (null != A) {
                                    var w = g.parseConfig(A, f.ns, f.key);
                                    if (null != w) {
                                        if ("JavaScript" === w.experimentTarget || "Mixed" === w.experimentTarget) {
                                            if (b.debug2("Parsed ECS config for %s->%s - %@", f.ns, f.key, w), g.isExperimentAllowed(P, f.ns, w.name)) {
                                                b.debug2("Allowing %s->%s:%s according to killswitch", f.ns, f.key, w.name), T = !0;
                                                var M = g.findTrigger(v, w);
                                                null != M ? (b.debug2("Triggers updated, keeping trigger %s", w.name), g._triggers[M] = v[M], delete v[M]) : S.push(w), w.filters && w.filters.forEach(function(g) {
                                                    return D[g.component] = Math.min(D[g.component] || 255, g.parsedLevel);
                                                }), w.includeUnsafe && (R = !0);
                                            } else b.debug2("Disallowing %s->%s according to killswitch", f.ns, f.key);
                                        } else b.debug4("Skipping %s->%s, targeted for %s", f.ns, f.key, w);
                                    } else b.error("Failed to parse ECS config for %s->%s", f.ns, f.key);
                                }
                            }
                        });
                    }).always(function() {
                        for(var f in g.applyLogLevels(), v)b.debug2("Triggers updated, removing trigger %s", v[f].config().name), E.LogFactory.instance().removeAppender(+f);
                        if (S.forEach(function(f) {
                            b.debug2("Triggers updated, adding trigger %s", f.name);
                            var S = new w(g, g._triggered, f), v = E.LogFactory.instance().addAppender(S);
                            g._triggers[String(v)] = S;
                        }), D[""] = D.root || C.LogLevel.Debug4, delete D.root, !g._circularBuffer || T && !g._circularBuffer.needReset(R, _) ? g._circularBuffer && (Object.keys(v).length > 0 || S.length > 0 ? (b.debug2("Buffer updated, reapplying log levels, removing log levels wrapper"), E.LogFactory.instance().removeAppender(g._circularBufferHandle), g._circularBufferHandle = null) : b.debug2("Buffer updated, no change")) : (b.debug2("Buffer updated, removing existing buffer"), E.LogFactory.instance().removeAppender(g._circularBufferHandle), g._circularBuffer = null, g._circularBufferHandle = null), T && (g._circularBuffer || (b.debug2("Buffer updated, adding new buffer (storeUnsafe=%d,maxSize=%s)", R, _), g._circularBuffer = new M(R, _)), null == g._circularBufferHandle && (b.debug2("Creating log level wrapper"), g._circularBufferHandle = E.LogFactory.instance().addAppender(I.wrapAppenderWithLogLevels(g._circularBuffer, D), C.AppenderFlags.InsertFront))), g._native) {
                            var P = map(D, function(g, f) {
                                return {
                                    component: g,
                                    level: f
                                };
                            });
                            P.sort(function(g, f) {
                                return g.component.length - f.component.length;
                            }), g._native.log_config.setLogBufferConfig(T, {
                                storeUnsafe: R,
                                buffers: A
                            }, P);
                            var O = [];
                            for(var N in g._triggers){
                                var k = g._triggers[N].config();
                                O.push({
                                    name: k.name,
                                    ecsNs: k.ecsNs,
                                    conditions: k.conditions,
                                    resetCondition: k.resetCondition,
                                    includeUnsafe: k.includeUnsafe,
                                    reenableAfterTriggering: k.reenableAfterTriggering,
                                    filters: k.filters.map(function(g) {
                                        return {
                                            component: g.component,
                                            level: g.parsedLevel
                                        };
                                    }),
                                    dumpFile: !1,
                                    metadata: {}
                                });
                            }
                            g._native.log_config.setLogTriggerConfig(O, {});
                        }
                    });
                });
            }, RootToolsManagerImpl.prototype._send = function(g, f) {
                null != this._glue && (this._glue.sendTelemetry(R, {
                    logTriggerName: g.name,
                    logEcsNs: g.ecsNs,
                    logdata: f
                }), b.debug4("LogSender::send, sent %d bytes", f.length));
            }, RootToolsManagerImpl.prototype.triggered = function(g, f) {}, RootToolsManagerImpl.prototype.triggeredPartially = function(g, f, S, v, _) {
                var C = this.findTriggerByNativeConfig(this._triggers, g);
                if (C) {
                    var T = {
                        level: f.level,
                        component: E.LogFactory.instance().component(f.component),
                        timestamp: f.timestamp
                    };
                    this._triggers[C].log(T, S, v, _);
                }
            }, RootToolsManagerImpl.prototype.reset = function(g) {
                var f = this.findTriggerByNativeConfig(this._triggers, g);
                f && this._triggers[f].resetConditions();
            }, RootToolsManagerImpl.prototype.dumpLogBuffer = function(g, f) {
                if (this._circularBuffer) {
                    var S = {
                        matchedLines: 0,
                        totalLines: 0
                    }, v = this._circularBuffer.dumpLogBuffer(g, this._maxUploadSize, S);
                    if (b.debug4("dumpLogBuffer: dumped %d of %d lines, size of payload: %d", S.matchedLines, S.totalLines, null != v ? v.length : 0), this._native) {
                        var _ = T.Defer();
                        return this._native.log_config.mergeAndDumpLogBuffer(v, g, f, function(g) {
                            return _.resolve(g);
                        }), _.promise();
                    }
                    return T.Resolved(v);
                }
                return b.warn("dumpLogBuffer: no log buffer enabled"), T.Rejected();
            }, RootToolsManagerImpl.prototype._triggered = function(g) {
                var f = this, S = {
                    compression: C.LogFileCompression.Compress,
                    encoding: C.LogFileEncoding.Base64,
                    encryption: C.LogFileEncryption.Encrypted,
                    maxRotations: 0,
                    maxSize: this._maxUploadSize,
                    reverse: !0
                }, v = {
                    includeUnsafe: g.includeUnsafe,
                    filter: g.filters.map(function(g) {
                        return {
                            component: g.component,
                            level: g.parsedLevel
                        };
                    }),
                    reverse: !0
                };
                this.dumpLogBuffer(v, S).then(function(S) {
                    return f._send(g, S);
                });
            }, RootToolsManagerImpl.prototype.sendBRBEvent = function(g, f) {
                try {
                    if (b.debug2("sendBRBEvent %s", JSON.stringify(g)), null != this._glue && "function" == typeof this._glue.sendLoggingEventToNative) {
                        var S = {
                            eventType: "uploadBRB",
                            mutualSubmissionType: "call",
                            payload: g
                        }, v = void 0 !== f ? JSON.stringify({
                            userIds: f
                        }) : "";
                        this._glue.sendLoggingEventToNative(JSON.stringify(S), v);
                    }
                } catch (g) {
                    b.error("sendBRBEvent %s: %s", g.name, g.message);
                }
            }, RootToolsManagerImpl.prototype.setBRBCallback = function(g) {
                b.debug2("setBRBCallback"), null != this._glue ? "function" == typeof this._glue.setNativeLoggingEventCallback ? this._BRBCallback = g : b.warn("setBRBCallback: RootToolsManagerDelegate missing setNativeLoggingEventCallback method") : b.warn("setBRBCallback: RootToolsManagerDelegate is not set");
            }, RootToolsManagerImpl.prototype.registerListeners = function() {
                var g = this;
                null != this._glue && "function" == typeof this._glue.setNativeLoggingEventCallback ? this._glue.setNativeLoggingEventCallback(function(f, S) {
                    return g.handleNativeLoggingEvent(f, S);
                }) : b.warn("registerListeners: RootToolsManagerDelegate missing setNativeLoggingEventCallback method");
            }, RootToolsManagerImpl.prototype.handleNativeLoggingEvent = function(g, f) {
                try {
                    b.debug2("Native Log event message: %s aux: %s", g, f);
                    var S = JSON.parse(g);
                    if (S.eventType && "uploadBRB" === S.eventType) {
                        if ("function" != typeof this._BRBCallback) return void b.warn("BRBCallback not set, ignoring native event");
                        b.debug4("Sending BRB callback: %@", S.payload), this._BRBCallback(S.payload);
                    } else S.eventType && "jsLogFileConfiguration" === S.eventType && this.handleLogFileConfigEvent(S);
                } catch (g) {
                    b.error("handleNativeLoggingEvent %s: %s", g.name, g.message);
                }
            }, RootToolsManagerImpl.prototype.handleLogFileConfigEvent = function(g) {
                if (g.payload) {
                    var f = g.payload;
                    if (f.enabled) {
                        if (f.chunkSize && f.flushInterval) {
                            var S = {
                                chunkSize: f.chunkSize,
                                flushInterval: f.flushInterval,
                                enableThrottling: f.enableThrottling,
                                maxVerbosityLevel: f.maxVerbosityLevel
                            };
                            this.startJsToNativeLogging(S);
                        }
                    } else this.flushDisableJsToNativeLogging();
                }
            }, RootToolsManagerImpl.prototype.logExternalForDDL = function(g, f) {
                try {
                    if (b.debug2("logExternalForDDL %s %s", g, f), null != this._glue && "function" == typeof this._glue.sendLoggingEventToNative) {
                        var S = {
                            eventType: "logInSClog",
                            payload: {
                                message: g,
                                parameters: f
                            }
                        };
                        this._glue.sendLoggingEventToNative(JSON.stringify(S), "");
                    } else b.warn("ignoring logExternalForDDL, delegate misconfigured");
                } catch (g) {
                    b.error("logExternalForDDL %s: %s", g.name, g.message);
                }
            }, RootToolsManagerImpl.prototype.startJsToNativeLogging = function(g) {
                var f = this, S = g.chunkSize, v = g.flushInterval, _ = g.enableThrottling, C = this._getVerbosityLevelFromConfig(g.maxVerbosityLevel);
                if (this._jsToNativeBuffer) {
                    if (this._jsToNativeBuffer.capacity() === S && this._jsToNativeFlushInterval === v && this._jsToNativeBuffer.throttlingEnabled() === _ && this._jsToNativeBuffer.maxVerbosityLevel() === C) return void b.debug1("Same JS2Native settings received - doing nothing");
                    b.debug1("Reapplying js to native settings"), this.flushDisableJsToNativeLogging();
                }
                this._jsToNativeBuffer = new D(S, function() {
                    f.onJsToNativeBufferReady(f._jsToNativeBuffer);
                }, _, C), this.setJsToNativeFlushTimeout(v), this._jsToNativeFlushInterval = v, this._jsToNativeBufferHandle = E.LogFactory.instance().addAppender(this._jsToNativeBuffer);
            }, RootToolsManagerImpl.prototype._getVerbosityLevelFromConfig = function(g) {
                return g ? E.LogFactory.levelFromString(g) : null;
            }, RootToolsManagerImpl.prototype.flushDisableJsToNativeLogging = function() {
                this._jsToNativeBuffer && this.onJsToNativeBufferReady(this._jsToNativeBuffer), this.plainDisableJsToNativeLogging();
            }, RootToolsManagerImpl.prototype.plainDisableJsToNativeLogging = function() {
                this.clearJsToNativeFlushTimeout(), this._jsToNativeBufferHandle && (E.LogFactory.instance().removeAppender(this._jsToNativeBufferHandle), this._jsToNativeBufferHandle = 0, this._jsToNativeBuffer = null, b.debug1("Disabling forwarding JS logs to native"));
            }, RootToolsManagerImpl.prototype.onJsToNativeBufferReady = function(g) {
                null != this._glue && "function" == typeof this._glue.sendLoggingEventToNative ? (this.clearJsToNativeFlushTimeout(), this.dumpJsToNativeBuffer(g), this.setJsToNativeFlushTimeout(this._jsToNativeFlushInterval)) : this.plainDisableJsToNativeLogging();
            }, RootToolsManagerImpl.prototype.dumpJsToNativeBuffer = function(g) {
                if (!g.empty()) {
                    var f = g.dumpAndReset(), S = {
                        eventType: "writeLogData"
                    };
                    this._glue.sendLoggingEventToNative(JSON.stringify(S), f);
                }
            }, RootToolsManagerImpl.prototype.clearJsToNativeFlushTimeout = function() {
                this._jsToNativeFlushTimer && (clearTimeout(this._jsToNativeFlushTimer), this._jsToNativeFlushTimer = null);
            }, RootToolsManagerImpl.prototype.setJsToNativeFlushTimeout = function(g) {
                var f = this;
                !this._jsToNativeFlushTimer && g && (this._jsToNativeFlushTimer = setTimeout(function() {
                    f._jsToNativeFlushTimer = null, f.onJsToNativeBufferReady(f._jsToNativeBuffer);
                }, g));
            }, RootToolsManagerImpl.prototype.stopAsyncOperations = function() {
                this.flushDisableJsToNativeLogging();
            }, RootToolsManagerImpl;
        }();
        f.RootToolsManager = new N;
    }), A = createCommonjsModule(function(g, f) {
        /*!
	 *  pii.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2017-01-16
	 *  Copyright 2017 Microsoft. All rights reserved.
	 *
	 */ Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var DefaultTagger = function(g) {
            return g;
        }, S = !0, v = DefaultTagger, _ = {}, C = 0;
        function addName(g) {
            return _[g] = "u" + ++C;
        }
        var E, T = /^([0-9][0-9]?):([^<>\*\{\}&'\"\/\\?^`|~\s]+)$/;
        !function(g) {
            g[g.MSA = 1] = "MSA", g[g.S4B_Bridge = 2] = "S4B_Bridge", g[g.PSTN = 4] = "PSTN", g[g.SkypeId = 8] = "SkypeId", g[g.Thread = 19] = "Thread", g[g.LegacyShortCircuit = 20] = "LegacyShortCircuit", g[g.OneToOneTextMessage = 21] = "OneToOneTextMessage", g[g.GroupTextMessage = 22] = "GroupTextMessage", g[g.Bot = 28] = "Bot", g[g.InternalSkype = 48] = "InternalSkype";
        }(E || (E = {}));
        var I = [
            E.Thread,
            E.InternalSkype
        ];
        function enableAnonymization(g) {
            S = g;
        }
        function useTagger(g) {
            v = g || DefaultTagger;
        }
        f.enableAnonymization = enableAnonymization, f.useTagger = useTagger, function(g) {
            function untaggedUserName(g) {
                return S ? g ? _[g] || addName(g) : null : g;
            }
            function UserName(g) {
                var f = untaggedUserName(g);
                return v(f);
            }
            function Mri(g) {
                var f, S = g.match(T);
                if (S) {
                    var _ = Number(S[1]), C = S[2];
                    f = -1 != I.indexOf(_) ? g : _ + ":" + untaggedUserName(C);
                } else f = untaggedUserName(g);
                return v(f);
            }
            function Omit(g) {
                var f;
                return f = S ? "number" == typeof g ? 19229 : "string" == typeof g ? g.charAt(0) + "..." : null : g, v(f);
            }
            g.UserName = UserName, g.Mri = Mri, g.Omit = Omit;
        }(f.pii || (f.pii = {}));
    }), R = createCommonjsModule(function(g, f) {
        /*!
	 *  index.ts
	 *  AUF
	 *
	 *  Created by Johan Blumenberg on 2016-12-29
	 *  Copyright 2016 Microsoft. All rights reserved.
	 *
	 */ function __export(g) {
            for(var S in g)f.hasOwnProperty(S) || (f[S] = g[S]);
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), __export(C), __export(E), __export(b), __export(I), __export(A);
    }), P = createCommonjsModule(function(g, f) {
        (function() {
            var S, v = "4.17.21", C = 200, E = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", T = "Expected a function", I = "Invalid `variable` option passed into `_.template`", b = "__lodash_hash_undefined__", A = 500, R = "__lodash_placeholder__", P = 1, w = 2, M = 4, O = 1, D = 2, N = 1, k = 2, L = 4, F = 8, x = 16, U = 32, V = 64, B = 128, H = 256, $ = 512, j = 30, G = "...", q = 800, W = 16, z = 1, K = 2, J = 3, Y = 1 / 0, Q = 9007199254740991, X = 17976931348623157e292, Z = NaN, ee = 4294967295, te = ee - 1, ie = ee >>> 1, ne = [
                [
                    "ary",
                    B
                ],
                [
                    "bind",
                    N
                ],
                [
                    "bindKey",
                    k
                ],
                [
                    "curry",
                    F
                ],
                [
                    "curryRight",
                    x
                ],
                [
                    "flip",
                    $
                ],
                [
                    "partial",
                    U
                ],
                [
                    "partialRight",
                    V
                ],
                [
                    "rearg",
                    H
                ]
            ], re = "[object Arguments]", ae = "[object Array]", se = "[object AsyncFunction]", oe = "[object Boolean]", le = "[object Date]", ce = "[object DOMException]", de = "[object Error]", ue = "[object Function]", he = "[object GeneratorFunction]", ge = "[object Map]", pe = "[object Number]", me = "[object Null]", fe = "[object Object]", Se = "[object Promise]", ve = "[object Proxy]", _e = "[object RegExp]", Ce = "[object Set]", ye = "[object String]", Ee = "[object Symbol]", Te = "[object Undefined]", Ie = "[object WeakMap]", be = "[object WeakSet]", Ae = "[object ArrayBuffer]", Re = "[object DataView]", Pe = "[object Float32Array]", we = "[object Float64Array]", Me = "[object Int8Array]", Oe = "[object Int16Array]", De = "[object Int32Array]", Ne = "[object Uint8Array]", ke = "[object Uint8ClampedArray]", Le = "[object Uint16Array]", Fe = "[object Uint32Array]", xe = /\b__p \+= '';/g, Ue = /\b(__p \+=) '' \+/g, Ve = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Be = /&(?:amp|lt|gt|quot|#39);/g, He = /[&<>"']/g, $e = RegExp(Be.source), je = RegExp(He.source), Ge = /<%-([\s\S]+?)%>/g, qe = /<%([\s\S]+?)%>/g, We = /<%=([\s\S]+?)%>/g, ze = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ke = /^\w*$/, Je = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ye = /[\\^$.*+?()[\]{}|]/g, Qe = RegExp(Ye.source), Xe = /^\s+/, Ze = /\s/, et = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, tt = /\{\n\/\* \[wrapped with (.+)\] \*/, it = /,? & /, nt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, rt = /[()=,{}\[\]\/\s]/, at = /\\(\\)?/g, st = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ot = /\w*$/, lt = /^[-+]0x[0-9a-f]+$/i, ct = /^0b[01]+$/i, dt = /^\[object .+?Constructor\]$/, ut = /^0o[0-7]+$/i, ht = /^(?:0|[1-9]\d*)$/, gt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, pt = /($^)/, mt = /['\n\r\u2028\u2029\\]/g, ft = "\ud800-\udfff", St = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", vt = "\\u2700-\\u27bf", _t = "a-z\\xdf-\\xf6\\xf8-\\xff", Ct = "A-Z\\xc0-\\xd6\\xd8-\\xde", yt = "\\ufe0e\\ufe0f", Et = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Tt = "['\u2019]", It = "[" + ft + "]", bt = "[" + Et + "]", At = "[" + St + "]", Rt = "\\d+", Pt = "[" + vt + "]", wt = "[" + _t + "]", Mt = "[^" + ft + Et + Rt + vt + _t + Ct + "]", Ot = "\ud83c[\udffb-\udfff]", Dt = "[^" + ft + "]", Nt = "(?:\ud83c[\udde6-\uddff]){2}", kt = "[\ud800-\udbff][\udc00-\udfff]", Lt = "[" + Ct + "]", Ft = "\\u200d", xt = "(?:" + wt + "|" + Mt + ")", Ut = "(?:" + Lt + "|" + Mt + ")", Vt = "(?:" + Tt + "(?:d|ll|m|re|s|t|ve))?", Bt = "(?:" + Tt + "(?:D|LL|M|RE|S|T|VE))?", Ht = "(?:" + At + "|" + Ot + ")" + "?", $t = "[" + yt + "]?", jt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Gt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", qt = $t + Ht + ("(?:" + Ft + "(?:" + [
                Dt,
                Nt,
                kt
            ].join("|") + ")" + $t + Ht + ")*"), Wt = "(?:" + [
                Pt,
                Nt,
                kt
            ].join("|") + ")" + qt, zt = "(?:" + [
                Dt + At + "?",
                At,
                Nt,
                kt,
                It
            ].join("|") + ")", Kt = RegExp(Tt, "g"), Jt = RegExp(At, "g"), Yt = RegExp(Ot + "(?=" + Ot + ")|" + zt + qt, "g"), Qt = RegExp([
                Lt + "?" + wt + "+" + Vt + "(?=" + [
                    bt,
                    Lt,
                    "$"
                ].join("|") + ")",
                Ut + "+" + Bt + "(?=" + [
                    bt,
                    Lt + xt,
                    "$"
                ].join("|") + ")",
                Lt + "?" + xt + "+" + Vt,
                Lt + "+" + Bt,
                Gt,
                jt,
                Rt,
                Wt
            ].join("|"), "g"), Xt = RegExp("[" + Ft + ft + St + yt + "]"), Zt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ei = [
                "Array",
                "Buffer",
                "DataView",
                "Date",
                "Error",
                "Float32Array",
                "Float64Array",
                "Function",
                "Int8Array",
                "Int16Array",
                "Int32Array",
                "Map",
                "Math",
                "Object",
                "Promise",
                "RegExp",
                "Set",
                "String",
                "Symbol",
                "TypeError",
                "Uint8Array",
                "Uint8ClampedArray",
                "Uint16Array",
                "Uint32Array",
                "WeakMap",
                "_",
                "clearTimeout",
                "isFinite",
                "parseInt",
                "setTimeout"
            ], ti = -1, ii = {};
            ii[Pe] = ii[we] = ii[Me] = ii[Oe] = ii[De] = ii[Ne] = ii[ke] = ii[Le] = ii[Fe] = !0, ii[re] = ii[ae] = ii[Ae] = ii[oe] = ii[Re] = ii[le] = ii[de] = ii[ue] = ii[ge] = ii[pe] = ii[fe] = ii[_e] = ii[Ce] = ii[ye] = ii[Ie] = !1;
            var ni = {};
            ni[re] = ni[ae] = ni[Ae] = ni[Re] = ni[oe] = ni[le] = ni[Pe] = ni[we] = ni[Me] = ni[Oe] = ni[De] = ni[ge] = ni[pe] = ni[fe] = ni[_e] = ni[Ce] = ni[ye] = ni[Ee] = ni[Ne] = ni[ke] = ni[Le] = ni[Fe] = !0, ni[de] = ni[ue] = ni[Ie] = !1;
            var ri = {
                "\xc0": "A",
                "\xc1": "A",
                "\xc2": "A",
                "\xc3": "A",
                "\xc4": "A",
                "\xc5": "A",
                "\xe0": "a",
                "\xe1": "a",
                "\xe2": "a",
                "\xe3": "a",
                "\xe4": "a",
                "\xe5": "a",
                "\xc7": "C",
                "\xe7": "c",
                "\xd0": "D",
                "\xf0": "d",
                "\xc8": "E",
                "\xc9": "E",
                "\xca": "E",
                "\xcb": "E",
                "\xe8": "e",
                "\xe9": "e",
                "\xea": "e",
                "\xeb": "e",
                "\xcc": "I",
                "\xcd": "I",
                "\xce": "I",
                "\xcf": "I",
                "\xec": "i",
                "\xed": "i",
                "\xee": "i",
                "\xef": "i",
                "\xd1": "N",
                "\xf1": "n",
                "\xd2": "O",
                "\xd3": "O",
                "\xd4": "O",
                "\xd5": "O",
                "\xd6": "O",
                "\xd8": "O",
                "\xf2": "o",
                "\xf3": "o",
                "\xf4": "o",
                "\xf5": "o",
                "\xf6": "o",
                "\xf8": "o",
                "\xd9": "U",
                "\xda": "U",
                "\xdb": "U",
                "\xdc": "U",
                "\xf9": "u",
                "\xfa": "u",
                "\xfb": "u",
                "\xfc": "u",
                "\xdd": "Y",
                "\xfd": "y",
                "\xff": "y",
                "\xc6": "Ae",
                "\xe6": "ae",
                "\xde": "Th",
                "\xfe": "th",
                "\xdf": "ss",
                "\u0100": "A",
                "\u0102": "A",
                "\u0104": "A",
                "\u0101": "a",
                "\u0103": "a",
                "\u0105": "a",
                "\u0106": "C",
                "\u0108": "C",
                "\u010A": "C",
                "\u010C": "C",
                "\u0107": "c",
                "\u0109": "c",
                "\u010B": "c",
                "\u010D": "c",
                "\u010E": "D",
                "\u0110": "D",
                "\u010F": "d",
                "\u0111": "d",
                "\u0112": "E",
                "\u0114": "E",
                "\u0116": "E",
                "\u0118": "E",
                "\u011A": "E",
                "\u0113": "e",
                "\u0115": "e",
                "\u0117": "e",
                "\u0119": "e",
                "\u011B": "e",
                "\u011C": "G",
                "\u011E": "G",
                "\u0120": "G",
                "\u0122": "G",
                "\u011D": "g",
                "\u011F": "g",
                "\u0121": "g",
                "\u0123": "g",
                "\u0124": "H",
                "\u0126": "H",
                "\u0125": "h",
                "\u0127": "h",
                "\u0128": "I",
                "\u012A": "I",
                "\u012C": "I",
                "\u012E": "I",
                "\u0130": "I",
                "\u0129": "i",
                "\u012B": "i",
                "\u012D": "i",
                "\u012F": "i",
                "\u0131": "i",
                "\u0134": "J",
                "\u0135": "j",
                "\u0136": "K",
                "\u0137": "k",
                "\u0138": "k",
                "\u0139": "L",
                "\u013B": "L",
                "\u013D": "L",
                "\u013F": "L",
                "\u0141": "L",
                "\u013A": "l",
                "\u013C": "l",
                "\u013E": "l",
                "\u0140": "l",
                "\u0142": "l",
                "\u0143": "N",
                "\u0145": "N",
                "\u0147": "N",
                "\u014A": "N",
                "\u0144": "n",
                "\u0146": "n",
                "\u0148": "n",
                "\u014B": "n",
                "\u014C": "O",
                "\u014E": "O",
                "\u0150": "O",
                "\u014D": "o",
                "\u014F": "o",
                "\u0151": "o",
                "\u0154": "R",
                "\u0156": "R",
                "\u0158": "R",
                "\u0155": "r",
                "\u0157": "r",
                "\u0159": "r",
                "\u015A": "S",
                "\u015C": "S",
                "\u015E": "S",
                "\u0160": "S",
                "\u015B": "s",
                "\u015D": "s",
                "\u015F": "s",
                "\u0161": "s",
                "\u0162": "T",
                "\u0164": "T",
                "\u0166": "T",
                "\u0163": "t",
                "\u0165": "t",
                "\u0167": "t",
                "\u0168": "U",
                "\u016A": "U",
                "\u016C": "U",
                "\u016E": "U",
                "\u0170": "U",
                "\u0172": "U",
                "\u0169": "u",
                "\u016B": "u",
                "\u016D": "u",
                "\u016F": "u",
                "\u0171": "u",
                "\u0173": "u",
                "\u0174": "W",
                "\u0175": "w",
                "\u0176": "Y",
                "\u0177": "y",
                "\u0178": "Y",
                "\u0179": "Z",
                "\u017B": "Z",
                "\u017D": "Z",
                "\u017A": "z",
                "\u017C": "z",
                "\u017E": "z",
                "\u0132": "IJ",
                "\u0133": "ij",
                "\u0152": "Oe",
                "\u0153": "oe",
                "\u0149": "'n",
                "\u017F": "s"
            }, ai = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#39;"
            }, si = {
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&#39;": "'"
            }, oi = {
                "\\": "\\",
                "'": "'",
                "\n": "n",
                "\r": "r",
                "\u2028": "u2028",
                "\u2029": "u2029"
            }, li = parseFloat, ci = parseInt, di = "object" == typeof _ && _ && _.Object === Object && _, ui = "object" == typeof self && self && self.Object === Object && self, hi = di || ui || Function("return this")(), gi = f && !f.nodeType && f, pi = gi && g && !g.nodeType && g, mi = pi && pi.exports === gi, fi = mi && di.process, Si = function() {
                try {
                    var g = pi && pi.require && pi.require("util").types;
                    return g || fi && fi.binding && fi.binding("util");
                } catch (g) {}
            }(), vi = Si && Si.isArrayBuffer, _i = Si && Si.isDate, Ci = Si && Si.isMap, yi = Si && Si.isRegExp, Ei = Si && Si.isSet, Ti = Si && Si.isTypedArray;
            function apply(g, f, S) {
                switch(S.length){
                    case 0:
                        return g.call(f);
                    case 1:
                        return g.call(f, S[0]);
                    case 2:
                        return g.call(f, S[0], S[1]);
                    case 3:
                        return g.call(f, S[0], S[1], S[2]);
                }
                return g.apply(f, S);
            }
            function arrayAggregator(g, f, S, v) {
                for(var _ = -1, C = null == g ? 0 : g.length; ++_ < C;){
                    var E = g[_];
                    f(v, E, S(E), g);
                }
                return v;
            }
            function arrayEach(g, f) {
                for(var S = -1, v = null == g ? 0 : g.length; ++S < v && !1 !== f(g[S], S, g););
                return g;
            }
            function arrayEachRight(g, f) {
                for(var S = null == g ? 0 : g.length; S-- && !1 !== f(g[S], S, g););
                return g;
            }
            function arrayEvery(g, f) {
                for(var S = -1, v = null == g ? 0 : g.length; ++S < v;)if (!f(g[S], S, g)) return !1;
                return !0;
            }
            function arrayFilter(g, f) {
                for(var S = -1, v = null == g ? 0 : g.length, _ = 0, C = []; ++S < v;){
                    var E = g[S];
                    f(E, S, g) && (C[_++] = E);
                }
                return C;
            }
            function arrayIncludes(g, f) {
                return !!(null == g ? 0 : g.length) && baseIndexOf(g, f, 0) > -1;
            }
            function arrayIncludesWith(g, f, S) {
                for(var v = -1, _ = null == g ? 0 : g.length; ++v < _;)if (S(f, g[v])) return !0;
                return !1;
            }
            function arrayMap(g, f) {
                for(var S = -1, v = null == g ? 0 : g.length, _ = Array(v); ++S < v;)_[S] = f(g[S], S, g);
                return _;
            }
            function arrayPush(g, f) {
                for(var S = -1, v = f.length, _ = g.length; ++S < v;)g[_ + S] = f[S];
                return g;
            }
            function arrayReduce(g, f, S, v) {
                var _ = -1, C = null == g ? 0 : g.length;
                for(v && C && (S = g[++_]); ++_ < C;)S = f(S, g[_], _, g);
                return S;
            }
            function arrayReduceRight(g, f, S, v) {
                var _ = null == g ? 0 : g.length;
                for(v && _ && (S = g[--_]); _--;)S = f(S, g[_], _, g);
                return S;
            }
            function arraySome(g, f) {
                for(var S = -1, v = null == g ? 0 : g.length; ++S < v;)if (f(g[S], S, g)) return !0;
                return !1;
            }
            var Ii = baseProperty("length");
            function asciiToArray(g) {
                return g.split("");
            }
            function asciiWords(g) {
                return g.match(nt) || [];
            }
            function baseFindKey(g, f, S) {
                var v;
                return S(g, function(g, S, _) {
                    if (f(g, S, _)) return v = S, !1;
                }), v;
            }
            function baseFindIndex(g, f, S, v) {
                for(var _ = g.length, C = S + (v ? 1 : -1); v ? C-- : ++C < _;)if (f(g[C], C, g)) return C;
                return -1;
            }
            function baseIndexOf(g, f, S) {
                return f == f ? strictIndexOf(g, f, S) : baseFindIndex(g, baseIsNaN, S);
            }
            function baseIndexOfWith(g, f, S, v) {
                for(var _ = S - 1, C = g.length; ++_ < C;)if (v(g[_], f)) return _;
                return -1;
            }
            function baseIsNaN(g) {
                return g != g;
            }
            function baseMean(g, f) {
                var S = null == g ? 0 : g.length;
                return S ? baseSum(g, f) / S : Z;
            }
            function baseProperty(g) {
                return function(f) {
                    return null == f ? S : f[g];
                };
            }
            function basePropertyOf(g) {
                return function(f) {
                    return null == g ? S : g[f];
                };
            }
            function baseReduce(g, f, S, v, _) {
                return _(g, function(g, _, C) {
                    S = v ? (v = !1, g) : f(S, g, _, C);
                }), S;
            }
            function baseSortBy(g, f) {
                var S = g.length;
                for(g.sort(f); S--;)g[S] = g[S].value;
                return g;
            }
            function baseSum(g, f) {
                for(var v, _ = -1, C = g.length; ++_ < C;){
                    var E = f(g[_]);
                    E !== S && (v = v === S ? E : v + E);
                }
                return v;
            }
            function baseTimes(g, f) {
                for(var S = -1, v = Array(g); ++S < g;)v[S] = f(S);
                return v;
            }
            function baseToPairs(g, f) {
                return arrayMap(f, function(f) {
                    return [
                        f,
                        g[f]
                    ];
                });
            }
            function baseTrim(g) {
                return g ? g.slice(0, trimmedEndIndex(g) + 1).replace(Xe, "") : g;
            }
            function baseUnary(g) {
                return function(f) {
                    return g(f);
                };
            }
            function baseValues(g, f) {
                return arrayMap(f, function(f) {
                    return g[f];
                });
            }
            function cacheHas(g, f) {
                return g.has(f);
            }
            function charsStartIndex(g, f) {
                for(var S = -1, v = g.length; ++S < v && baseIndexOf(f, g[S], 0) > -1;);
                return S;
            }
            function charsEndIndex(g, f) {
                for(var S = g.length; S-- && baseIndexOf(f, g[S], 0) > -1;);
                return S;
            }
            function countHolders(g, f) {
                for(var S = g.length, v = 0; S--;)g[S] === f && ++v;
                return v;
            }
            var bi = basePropertyOf(ri), Ai = basePropertyOf(ai);
            function escapeStringChar(g) {
                return "\\" + oi[g];
            }
            function getValue(g, f) {
                return null == g ? S : g[f];
            }
            function hasUnicode(g) {
                return Xt.test(g);
            }
            function hasUnicodeWord(g) {
                return Zt.test(g);
            }
            function iteratorToArray(g) {
                for(var f, S = []; !(f = g.next()).done;)S.push(f.value);
                return S;
            }
            function mapToArray(g) {
                var f = -1, S = Array(g.size);
                return g.forEach(function(g, v) {
                    S[++f] = [
                        v,
                        g
                    ];
                }), S;
            }
            function overArg(g, f) {
                return function(S) {
                    return g(f(S));
                };
            }
            function replaceHolders(g, f) {
                for(var S = -1, v = g.length, _ = 0, C = []; ++S < v;){
                    var E = g[S];
                    E !== f && E !== R || (g[S] = R, C[_++] = S);
                }
                return C;
            }
            function setToArray(g) {
                var f = -1, S = Array(g.size);
                return g.forEach(function(g) {
                    S[++f] = g;
                }), S;
            }
            function setToPairs(g) {
                var f = -1, S = Array(g.size);
                return g.forEach(function(g) {
                    S[++f] = [
                        g,
                        g
                    ];
                }), S;
            }
            function strictIndexOf(g, f, S) {
                for(var v = S - 1, _ = g.length; ++v < _;)if (g[v] === f) return v;
                return -1;
            }
            function strictLastIndexOf(g, f, S) {
                for(var v = S + 1; v--;)if (g[v] === f) return v;
                return v;
            }
            function stringSize(g) {
                return hasUnicode(g) ? unicodeSize(g) : Ii(g);
            }
            function stringToArray(g) {
                return hasUnicode(g) ? unicodeToArray(g) : asciiToArray(g);
            }
            function trimmedEndIndex(g) {
                for(var f = g.length; f-- && Ze.test(g.charAt(f)););
                return f;
            }
            var Ri = basePropertyOf(si);
            function unicodeSize(g) {
                for(var f = Yt.lastIndex = 0; Yt.test(g);)++f;
                return f;
            }
            function unicodeToArray(g) {
                return g.match(Yt) || [];
            }
            function unicodeWords(g) {
                return g.match(Qt) || [];
            }
            var Pi = function runInContext(g) {
                var f, _ = (g = null == g ? hi : wi.defaults(hi.Object(), g, wi.pick(hi, ei))).Array, Ze = g.Date, nt = g.Error, ft = g.Function, St = g.Math, vt = g.Object, _t = g.RegExp, Ct = g.String, yt = g.TypeError, Et = _.prototype, Tt = ft.prototype, It = vt.prototype, bt = g["__core-js_shared__"], At = Tt.toString, Rt = It.hasOwnProperty, Pt = 0, wt = (f = /[^.]+$/.exec(bt && bt.keys && bt.keys.IE_PROTO || "")) ? "Symbol(src)_1." + f : "", Mt = It.toString, Ot = At.call(vt), Dt = hi._, Nt = _t("^" + At.call(Rt).replace(Ye, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), kt = mi ? g.Buffer : S, Lt = g.Symbol, Ft = g.Uint8Array, xt = kt ? kt.allocUnsafe : S, Ut = overArg(vt.getPrototypeOf, vt), Vt = vt.create, Bt = It.propertyIsEnumerable, Ht = Et.splice, $t = Lt ? Lt.isConcatSpreadable : S, jt = Lt ? Lt.iterator : S, Gt = Lt ? Lt.toStringTag : S, qt = function() {
                    try {
                        var g = getNative(vt, "defineProperty");
                        return g({}, "", {}), g;
                    } catch (g) {}
                }(), Wt = g.clearTimeout !== hi.clearTimeout && g.clearTimeout, zt = Ze && Ze.now !== hi.Date.now && Ze.now, Yt = g.setTimeout !== hi.setTimeout && g.setTimeout, Qt = St.ceil, Xt = St.floor, Zt = vt.getOwnPropertySymbols, ri = kt ? kt.isBuffer : S, ai = g.isFinite, si = Et.join, oi = overArg(vt.keys, vt), di = St.max, ui = St.min, gi = Ze.now, pi = g.parseInt, fi = St.random, Si = Et.reverse, Ii = getNative(g, "DataView"), Pi = getNative(g, "Map"), Mi = getNative(g, "Promise"), Oi = getNative(g, "Set"), Di = getNative(g, "WeakMap"), Ni = getNative(vt, "create"), ki = Di && new Di, Li = {}, Fi = toSource(Ii), xi = toSource(Pi), Ui = toSource(Mi), Vi = toSource(Oi), Bi = toSource(Di), Hi = Lt ? Lt.prototype : S, $i = Hi ? Hi.valueOf : S, ji = Hi ? Hi.toString : S;
                function lodash(g) {
                    if (isObjectLike(g) && !Kn(g) && !(g instanceof LazyWrapper)) {
                        if (g instanceof LodashWrapper) return g;
                        if (Rt.call(g, "__wrapped__")) return wrapperClone(g);
                    }
                    return new LodashWrapper(g);
                }
                var Gi = function() {
                    function object() {}
                    return function(g) {
                        if (!isObject(g)) return {};
                        if (Vt) return Vt(g);
                        object.prototype = g;
                        var f = new object;
                        return object.prototype = S, f;
                    };
                }();
                function baseLodash() {}
                function LodashWrapper(g, f) {
                    this.__wrapped__ = g, this.__actions__ = [], this.__chain__ = !!f, this.__index__ = 0, this.__values__ = S;
                }
                function LazyWrapper(g) {
                    this.__wrapped__ = g, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ee, this.__views__ = [];
                }
                function lazyClone() {
                    var g = new LazyWrapper(this.__wrapped__);
                    return g.__actions__ = copyArray(this.__actions__), g.__dir__ = this.__dir__, g.__filtered__ = this.__filtered__, g.__iteratees__ = copyArray(this.__iteratees__), g.__takeCount__ = this.__takeCount__, g.__views__ = copyArray(this.__views__), g;
                }
                function lazyReverse() {
                    if (this.__filtered__) {
                        var g = new LazyWrapper(this);
                        g.__dir__ = -1, g.__filtered__ = !0;
                    } else (g = this.clone()).__dir__ *= -1;
                    return g;
                }
                function lazyValue() {
                    var g = this.__wrapped__.value(), f = this.__dir__, S = Kn(g), v = f < 0, _ = S ? g.length : 0, C = getView(0, _, this.__views__), E = C.start, T = C.end, I = T - E, b = v ? T : E - 1, A = this.__iteratees__, R = A.length, P = 0, w = ui(I, this.__takeCount__);
                    if (!S || !v && _ == I && w == I) return baseWrapperValue(g, this.__actions__);
                    var M = [];
                    e: for(; I-- && P < w;){
                        for(var O = -1, D = g[b += f]; ++O < R;){
                            var N = A[O], k = N.iteratee, L = N.type, F = k(D);
                            if (L == K) D = F;
                            else if (!F) {
                                if (L == z) continue e;
                                break e;
                            }
                        }
                        M[P++] = D;
                    }
                    return M;
                }
                function Hash(g) {
                    var f = -1, S = null == g ? 0 : g.length;
                    for(this.clear(); ++f < S;){
                        var v = g[f];
                        this.set(v[0], v[1]);
                    }
                }
                function hashClear() {
                    this.__data__ = Ni ? Ni(null) : {}, this.size = 0;
                }
                function hashDelete(g) {
                    var f = this.has(g) && delete this.__data__[g];
                    return this.size -= f ? 1 : 0, f;
                }
                function hashGet(g) {
                    var f = this.__data__;
                    if (Ni) {
                        var v = f[g];
                        return v === b ? S : v;
                    }
                    return Rt.call(f, g) ? f[g] : S;
                }
                function hashHas(g) {
                    var f = this.__data__;
                    return Ni ? f[g] !== S : Rt.call(f, g);
                }
                function hashSet(g, f) {
                    var v = this.__data__;
                    return this.size += this.has(g) ? 0 : 1, v[g] = Ni && f === S ? b : f, this;
                }
                function ListCache(g) {
                    var f = -1, S = null == g ? 0 : g.length;
                    for(this.clear(); ++f < S;){
                        var v = g[f];
                        this.set(v[0], v[1]);
                    }
                }
                function listCacheClear() {
                    this.__data__ = [], this.size = 0;
                }
                function listCacheDelete(g) {
                    var f = this.__data__, S = assocIndexOf(f, g);
                    return !(S < 0) && (S == f.length - 1 ? f.pop() : Ht.call(f, S, 1), --this.size, !0);
                }
                function listCacheGet(g) {
                    var f = this.__data__, v = assocIndexOf(f, g);
                    return v < 0 ? S : f[v][1];
                }
                function listCacheHas(g) {
                    return assocIndexOf(this.__data__, g) > -1;
                }
                function listCacheSet(g, f) {
                    var S = this.__data__, v = assocIndexOf(S, g);
                    return v < 0 ? (++this.size, S.push([
                        g,
                        f
                    ])) : S[v][1] = f, this;
                }
                function MapCache(g) {
                    var f = -1, S = null == g ? 0 : g.length;
                    for(this.clear(); ++f < S;){
                        var v = g[f];
                        this.set(v[0], v[1]);
                    }
                }
                function mapCacheClear() {
                    this.size = 0, this.__data__ = {
                        hash: new Hash,
                        map: new (Pi || ListCache),
                        string: new Hash
                    };
                }
                function mapCacheDelete(g) {
                    var f = getMapData(this, g).delete(g);
                    return this.size -= f ? 1 : 0, f;
                }
                function mapCacheGet(g) {
                    return getMapData(this, g).get(g);
                }
                function mapCacheHas(g) {
                    return getMapData(this, g).has(g);
                }
                function mapCacheSet(g, f) {
                    var S = getMapData(this, g), v = S.size;
                    return S.set(g, f), this.size += S.size == v ? 0 : 1, this;
                }
                function SetCache(g) {
                    var f = -1, S = null == g ? 0 : g.length;
                    for(this.__data__ = new MapCache; ++f < S;)this.add(g[f]);
                }
                function setCacheAdd(g) {
                    return this.__data__.set(g, b), this;
                }
                function setCacheHas(g) {
                    return this.__data__.has(g);
                }
                function Stack(g) {
                    var f = this.__data__ = new ListCache(g);
                    this.size = f.size;
                }
                function stackClear() {
                    this.__data__ = new ListCache, this.size = 0;
                }
                function stackDelete(g) {
                    var f = this.__data__, S = f.delete(g);
                    return this.size = f.size, S;
                }
                function stackGet(g) {
                    return this.__data__.get(g);
                }
                function stackHas(g) {
                    return this.__data__.has(g);
                }
                function stackSet(g, f) {
                    var S = this.__data__;
                    if (S instanceof ListCache) {
                        var v = S.__data__;
                        if (!Pi || v.length < C - 1) return v.push([
                            g,
                            f
                        ]), this.size = ++S.size, this;
                        S = this.__data__ = new MapCache(v);
                    }
                    return S.set(g, f), this.size = S.size, this;
                }
                function arrayLikeKeys(g, f) {
                    var S = Kn(g), v = !S && zn(g), _ = !S && !v && Yn(g), C = !S && !v && !_ && tr(g), E = S || v || _ || C, T = E ? baseTimes(g.length, Ct) : [], I = T.length;
                    for(var b in g)!f && !Rt.call(g, b) || E && ("length" == b || _ && ("offset" == b || "parent" == b) || C && ("buffer" == b || "byteLength" == b || "byteOffset" == b) || isIndex(b, I)) || T.push(b);
                    return T;
                }
                function arraySample(g) {
                    var f = g.length;
                    return f ? g[baseRandom(0, f - 1)] : S;
                }
                function arraySampleSize(g, f) {
                    return shuffleSelf(copyArray(g), baseClamp(f, 0, g.length));
                }
                function arrayShuffle(g) {
                    return shuffleSelf(copyArray(g));
                }
                function assignMergeValue(g, f, v) {
                    (v !== S && !eq(g[f], v) || v === S && !(f in g)) && baseAssignValue(g, f, v);
                }
                function assignValue(g, f, v) {
                    var _ = g[f];
                    Rt.call(g, f) && eq(_, v) && (v !== S || f in g) || baseAssignValue(g, f, v);
                }
                function assocIndexOf(g, f) {
                    for(var S = g.length; S--;)if (eq(g[S][0], f)) return S;
                    return -1;
                }
                function baseAggregator(g, f, S, v) {
                    return qi(g, function(g, _, C) {
                        f(v, g, S(g), C);
                    }), v;
                }
                function baseAssign(g, f) {
                    return g && copyObject(f, keys(f), g);
                }
                function baseAssignIn(g, f) {
                    return g && copyObject(f, keysIn(f), g);
                }
                function baseAssignValue(g, f, S) {
                    "__proto__" == f && qt ? qt(g, f, {
                        configurable: !0,
                        enumerable: !0,
                        value: S,
                        writable: !0
                    }) : g[f] = S;
                }
                function baseAt(g, f) {
                    for(var v = -1, C = f.length, E = _(C), T = null == g; ++v < C;)E[v] = T ? S : get(g, f[v]);
                    return E;
                }
                function baseClamp(g, f, v) {
                    return g == g && (v !== S && (g = g <= v ? g : v), f !== S && (g = g >= f ? g : f)), g;
                }
                function baseClone(g, f, v, _, C, E) {
                    var T, I = f & P, b = f & w, A = f & M;
                    if (v && (T = C ? v(g, _, C, E) : v(g)), T !== S) return T;
                    if (!isObject(g)) return g;
                    var R = Kn(g);
                    if (R) {
                        if (T = initCloneArray(g), !I) return copyArray(g, T);
                    } else {
                        var O = rn(g), D = O == ue || O == he;
                        if (Yn(g)) return cloneBuffer(g, I);
                        if (O == fe || O == re || D && !C) {
                            if (T = b || D ? {} : initCloneObject(g), !I) return b ? copySymbolsIn(g, baseAssignIn(T, g)) : copySymbols(g, baseAssign(T, g));
                        } else {
                            if (!ni[O]) return C ? g : {};
                            T = initCloneByTag(g, O, I);
                        }
                    }
                    E || (E = new Stack);
                    var N = E.get(g);
                    if (N) return N;
                    E.set(g, T), er(g) ? g.forEach(function(S) {
                        T.add(baseClone(S, f, v, S, g, E));
                    }) : Xn(g) && g.forEach(function(S, _) {
                        T.set(_, baseClone(S, f, v, _, g, E));
                    });
                    var k = R ? S : (A ? b ? getAllKeysIn : getAllKeys : b ? keysIn : keys)(g);
                    return arrayEach(k || g, function(S, _) {
                        k && (S = g[_ = S]), assignValue(T, _, baseClone(S, f, v, _, g, E));
                    }), T;
                }
                function baseConforms(g) {
                    var f = keys(g);
                    return function(S) {
                        return baseConformsTo(S, g, f);
                    };
                }
                function baseConformsTo(g, f, v) {
                    var _ = v.length;
                    if (null == g) return !_;
                    for(g = vt(g); _--;){
                        var C = v[_], E = f[C], T = g[C];
                        if (T === S && !(C in g) || !E(T)) return !1;
                    }
                    return !0;
                }
                function baseDelay(g, f, v) {
                    if ("function" != typeof g) throw new yt(T);
                    return on(function() {
                        g.apply(S, v);
                    }, f);
                }
                function baseDifference(g, f, S, v) {
                    var _ = -1, E = arrayIncludes, T = !0, I = g.length, b = [], A = f.length;
                    if (!I) return b;
                    S && (f = arrayMap(f, baseUnary(S))), v ? (E = arrayIncludesWith, T = !1) : f.length >= C && (E = cacheHas, T = !1, f = new SetCache(f));
                    e: for(; ++_ < I;){
                        var R = g[_], P = null == S ? R : S(R);
                        if (R = v || 0 !== R ? R : 0, T && P == P) {
                            for(var w = A; w--;)if (f[w] === P) continue e;
                            b.push(R);
                        } else E(f, P, v) || b.push(R);
                    }
                    return b;
                }
                lodash.templateSettings = {
                    escape: Ge,
                    evaluate: qe,
                    interpolate: We,
                    variable: "",
                    imports: {
                        _: lodash
                    }
                }, lodash.prototype = baseLodash.prototype, lodash.prototype.constructor = lodash, LodashWrapper.prototype = Gi(baseLodash.prototype), LodashWrapper.prototype.constructor = LodashWrapper, LazyWrapper.prototype = Gi(baseLodash.prototype), LazyWrapper.prototype.constructor = LazyWrapper, Hash.prototype.clear = hashClear, Hash.prototype.delete = hashDelete, Hash.prototype.get = hashGet, Hash.prototype.has = hashHas, Hash.prototype.set = hashSet, ListCache.prototype.clear = listCacheClear, ListCache.prototype.delete = listCacheDelete, ListCache.prototype.get = listCacheGet, ListCache.prototype.has = listCacheHas, ListCache.prototype.set = listCacheSet, MapCache.prototype.clear = mapCacheClear, MapCache.prototype.delete = mapCacheDelete, MapCache.prototype.get = mapCacheGet, MapCache.prototype.has = mapCacheHas, MapCache.prototype.set = mapCacheSet, SetCache.prototype.add = SetCache.prototype.push = setCacheAdd, SetCache.prototype.has = setCacheHas, Stack.prototype.clear = stackClear, Stack.prototype.delete = stackDelete, Stack.prototype.get = stackGet, Stack.prototype.has = stackHas, Stack.prototype.set = stackSet;
                var qi = createBaseEach(baseForOwn), Wi = createBaseEach(baseForOwnRight, !0);
                function baseEvery(g, f) {
                    var S = !0;
                    return qi(g, function(g, v, _) {
                        return S = !!f(g, v, _);
                    }), S;
                }
                function baseExtremum(g, f, v) {
                    for(var _ = -1, C = g.length; ++_ < C;){
                        var E = g[_], T = f(E);
                        if (null != T && (I === S ? T == T && !isSymbol(T) : v(T, I))) var I = T, b = E;
                    }
                    return b;
                }
                function baseFill(g, f, v, _) {
                    var C = g.length;
                    for((v = toInteger(v)) < 0 && (v = -v > C ? 0 : C + v), (_ = _ === S || _ > C ? C : toInteger(_)) < 0 && (_ += C), _ = v > _ ? 0 : toLength(_); v < _;)g[v++] = f;
                    return g;
                }
                function baseFilter(g, f) {
                    var S = [];
                    return qi(g, function(g, v, _) {
                        f(g, v, _) && S.push(g);
                    }), S;
                }
                function baseFlatten(g, f, S, v, _) {
                    var C = -1, E = g.length;
                    for(S || (S = isFlattenable), _ || (_ = []); ++C < E;){
                        var T = g[C];
                        f > 0 && S(T) ? f > 1 ? baseFlatten(T, f - 1, S, v, _) : arrayPush(_, T) : v || (_[_.length] = T);
                    }
                    return _;
                }
                var zi = createBaseFor(), Ki = createBaseFor(!0);
                function baseForOwn(g, f) {
                    return g && zi(g, f, keys);
                }
                function baseForOwnRight(g, f) {
                    return g && Ki(g, f, keys);
                }
                function baseFunctions(g, f) {
                    return arrayFilter(f, function(f) {
                        return isFunction(g[f]);
                    });
                }
                function baseGet(g, f) {
                    for(var v = 0, _ = (f = castPath(f, g)).length; null != g && v < _;)g = g[toKey(f[v++])];
                    return v && v == _ ? g : S;
                }
                function baseGetAllKeys(g, f, S) {
                    var v = f(g);
                    return Kn(g) ? v : arrayPush(v, S(g));
                }
                function baseGetTag(g) {
                    return null == g ? g === S ? Te : me : Gt && Gt in vt(g) ? getRawTag(g) : objectToString(g);
                }
                function baseGt(g, f) {
                    return g > f;
                }
                function baseHas(g, f) {
                    return null != g && Rt.call(g, f);
                }
                function baseHasIn(g, f) {
                    return null != g && f in vt(g);
                }
                function baseInRange(g, f, S) {
                    return g >= ui(f, S) && g < di(f, S);
                }
                function baseIntersection(g, f, v) {
                    for(var C = v ? arrayIncludesWith : arrayIncludes, E = g[0].length, T = g.length, I = T, b = _(T), A = 1 / 0, R = []; I--;){
                        var P = g[I];
                        I && f && (P = arrayMap(P, baseUnary(f))), A = ui(P.length, A), b[I] = !v && (f || E >= 120 && P.length >= 120) ? new SetCache(I && P) : S;
                    }
                    P = g[0];
                    var w = -1, M = b[0];
                    e: for(; ++w < E && R.length < A;){
                        var O = P[w], D = f ? f(O) : O;
                        if (O = v || 0 !== O ? O : 0, !(M ? cacheHas(M, D) : C(R, D, v))) {
                            for(I = T; --I;){
                                var N = b[I];
                                if (!(N ? cacheHas(N, D) : C(g[I], D, v))) continue e;
                            }
                            M && M.push(D), R.push(O);
                        }
                    }
                    return R;
                }
                function baseInverter(g, f, S, v) {
                    return baseForOwn(g, function(g, _, C) {
                        f(v, S(g), _, C);
                    }), v;
                }
                function baseInvoke(g, f, v) {
                    var _ = null == (g = parent(g, f = castPath(f, g))) ? g : g[toKey(last(f))];
                    return null == _ ? S : apply(_, g, v);
                }
                function baseIsArguments(g) {
                    return isObjectLike(g) && baseGetTag(g) == re;
                }
                function baseIsArrayBuffer(g) {
                    return isObjectLike(g) && baseGetTag(g) == Ae;
                }
                function baseIsDate(g) {
                    return isObjectLike(g) && baseGetTag(g) == le;
                }
                function baseIsEqual(g, f, S, v, _) {
                    return g === f || (null == g || null == f || !isObjectLike(g) && !isObjectLike(f) ? g != g && f != f : baseIsEqualDeep(g, f, S, v, baseIsEqual, _));
                }
                function baseIsEqualDeep(g, f, S, v, _, C) {
                    var E = Kn(g), T = Kn(f), I = E ? ae : rn(g), b = T ? ae : rn(f), A = (I = I == re ? fe : I) == fe, R = (b = b == re ? fe : b) == fe, P = I == b;
                    if (P && Yn(g)) {
                        if (!Yn(f)) return !1;
                        E = !0, A = !1;
                    }
                    if (P && !A) return C || (C = new Stack), E || tr(g) ? equalArrays(g, f, S, v, _, C) : equalByTag(g, f, I, S, v, _, C);
                    if (!(S & O)) {
                        var w = A && Rt.call(g, "__wrapped__"), M = R && Rt.call(f, "__wrapped__");
                        if (w || M) {
                            var D = w ? g.value() : g, N = M ? f.value() : f;
                            return C || (C = new Stack), _(D, N, S, v, C);
                        }
                    }
                    return !!P && (C || (C = new Stack), equalObjects(g, f, S, v, _, C));
                }
                function baseIsMap(g) {
                    return isObjectLike(g) && rn(g) == ge;
                }
                function baseIsMatch(g, f, v, _) {
                    var C = v.length, E = C, T = !_;
                    if (null == g) return !E;
                    for(g = vt(g); C--;){
                        var I = v[C];
                        if (T && I[2] ? I[1] !== g[I[0]] : !(I[0] in g)) return !1;
                    }
                    for(; ++C < E;){
                        var b = (I = v[C])[0], A = g[b], R = I[1];
                        if (T && I[2]) {
                            if (A === S && !(b in g)) return !1;
                        } else {
                            var P = new Stack;
                            if (_) var w = _(A, R, b, g, f, P);
                            if (!(w === S ? baseIsEqual(R, A, O | D, _, P) : w)) return !1;
                        }
                    }
                    return !0;
                }
                function baseIsNative(g) {
                    return !(!isObject(g) || isMasked(g)) && (isFunction(g) ? Nt : dt).test(toSource(g));
                }
                function baseIsRegExp(g) {
                    return isObjectLike(g) && baseGetTag(g) == _e;
                }
                function baseIsSet(g) {
                    return isObjectLike(g) && rn(g) == Ce;
                }
                function baseIsTypedArray(g) {
                    return isObjectLike(g) && isLength(g.length) && !!ii[baseGetTag(g)];
                }
                function baseIteratee(g) {
                    return "function" == typeof g ? g : null == g ? identity : "object" == typeof g ? Kn(g) ? baseMatchesProperty(g[0], g[1]) : baseMatches(g) : property(g);
                }
                function baseKeys(g) {
                    if (!isPrototype(g)) return oi(g);
                    var f = [];
                    for(var S in vt(g))Rt.call(g, S) && "constructor" != S && f.push(S);
                    return f;
                }
                function baseKeysIn(g) {
                    if (!isObject(g)) return nativeKeysIn(g);
                    var f = isPrototype(g), S = [];
                    for(var v in g)("constructor" != v || !f && Rt.call(g, v)) && S.push(v);
                    return S;
                }
                function baseLt(g, f) {
                    return g < f;
                }
                function baseMap(g, f) {
                    var S = -1, v = isArrayLike(g) ? _(g.length) : [];
                    return qi(g, function(g, _, C) {
                        v[++S] = f(g, _, C);
                    }), v;
                }
                function baseMatches(g) {
                    var f = getMatchData(g);
                    return 1 == f.length && f[0][2] ? matchesStrictComparable(f[0][0], f[0][1]) : function(S) {
                        return S === g || baseIsMatch(S, g, f);
                    };
                }
                function baseMatchesProperty(g, f) {
                    return isKey(g) && isStrictComparable(f) ? matchesStrictComparable(toKey(g), f) : function(v) {
                        var _ = get(v, g);
                        return _ === S && _ === f ? hasIn(v, g) : baseIsEqual(f, _, O | D);
                    };
                }
                function baseMerge(g, f, v, _, C) {
                    g !== f && zi(f, function(E, T) {
                        if (C || (C = new Stack), isObject(E)) baseMergeDeep(g, f, T, v, baseMerge, _, C);
                        else {
                            var I = _ ? _(safeGet(g, T), E, T + "", g, f, C) : S;
                            I === S && (I = E), assignMergeValue(g, T, I);
                        }
                    }, keysIn);
                }
                function baseMergeDeep(g, f, v, _, C, E, T) {
                    var I = safeGet(g, v), b = safeGet(f, v), A = T.get(b);
                    if (A) assignMergeValue(g, v, A);
                    else {
                        var R = E ? E(I, b, v + "", g, f, T) : S, P = R === S;
                        if (P) {
                            var w = Kn(b), M = !w && Yn(b), O = !w && !M && tr(b);
                            R = b, w || M || O ? Kn(I) ? R = I : isArrayLikeObject(I) ? R = copyArray(I) : M ? (P = !1, R = cloneBuffer(b, !0)) : O ? (P = !1, R = cloneTypedArray(b, !0)) : R = [] : isPlainObject(b) || zn(b) ? (R = I, zn(I) ? R = toPlainObject(I) : isObject(I) && !isFunction(I) || (R = initCloneObject(b))) : P = !1;
                        }
                        P && (T.set(b, R), C(R, b, _, E, T), T.delete(b)), assignMergeValue(g, v, R);
                    }
                }
                function baseNth(g, f) {
                    var v = g.length;
                    if (v) return isIndex(f += f < 0 ? v : 0, v) ? g[f] : S;
                }
                function baseOrderBy(g, f, S) {
                    f = f.length ? arrayMap(f, function(g) {
                        return Kn(g) ? function(f) {
                            return baseGet(f, 1 === g.length ? g[0] : g);
                        } : g;
                    }) : [
                        identity
                    ];
                    var v = -1;
                    f = arrayMap(f, baseUnary(getIteratee()));
                    var _ = baseMap(g, function(g, S, _) {
                        var C = arrayMap(f, function(f) {
                            return f(g);
                        });
                        return {
                            criteria: C,
                            index: ++v,
                            value: g
                        };
                    });
                    return baseSortBy(_, function(g, f) {
                        return compareMultiple(g, f, S);
                    });
                }
                function basePick(g, f) {
                    return basePickBy(g, f, function(f, S) {
                        return hasIn(g, S);
                    });
                }
                function basePickBy(g, f, S) {
                    for(var v = -1, _ = f.length, C = {}; ++v < _;){
                        var E = f[v], T = baseGet(g, E);
                        S(T, E) && baseSet(C, castPath(E, g), T);
                    }
                    return C;
                }
                function basePropertyDeep(g) {
                    return function(f) {
                        return baseGet(f, g);
                    };
                }
                function basePullAll(g, f, S, v) {
                    var _ = v ? baseIndexOfWith : baseIndexOf, C = -1, E = f.length, T = g;
                    for(g === f && (f = copyArray(f)), S && (T = arrayMap(g, baseUnary(S))); ++C < E;)for(var I = 0, b = f[C], A = S ? S(b) : b; (I = _(T, A, I, v)) > -1;)T !== g && Ht.call(T, I, 1), Ht.call(g, I, 1);
                    return g;
                }
                function basePullAt(g, f) {
                    for(var S = g ? f.length : 0, v = S - 1; S--;){
                        var _ = f[S];
                        if (S == v || _ !== C) {
                            var C = _;
                            isIndex(_) ? Ht.call(g, _, 1) : baseUnset(g, _);
                        }
                    }
                    return g;
                }
                function baseRandom(g, f) {
                    return g + Xt(fi() * (f - g + 1));
                }
                function baseRange(g, f, S, v) {
                    for(var C = -1, E = di(Qt((f - g) / (S || 1)), 0), T = _(E); E--;)T[v ? E : ++C] = g, g += S;
                    return T;
                }
                function baseRepeat(g, f) {
                    var S = "";
                    if (!g || f < 1 || f > Q) return S;
                    do f % 2 && (S += g), (f = Xt(f / 2)) && (g += g);
                    while (f);
                    return S;
                }
                function baseRest(g, f) {
                    return ln(overRest(g, f, identity), g + "");
                }
                function baseSample(g) {
                    return arraySample(values(g));
                }
                function baseSampleSize(g, f) {
                    var S = values(g);
                    return shuffleSelf(S, baseClamp(f, 0, S.length));
                }
                function baseSet(g, f, v, _) {
                    if (!isObject(g)) return g;
                    for(var C = -1, E = (f = castPath(f, g)).length, T = E - 1, I = g; null != I && ++C < E;){
                        var b = toKey(f[C]), A = v;
                        if ("__proto__" === b || "constructor" === b || "prototype" === b) return g;
                        if (C != T) {
                            var R = I[b];
                            (A = _ ? _(R, b, I) : S) === S && (A = isObject(R) ? R : isIndex(f[C + 1]) ? [] : {});
                        }
                        assignValue(I, b, A), I = I[b];
                    }
                    return g;
                }
                var Ji = ki ? function(g, f) {
                    return ki.set(g, f), g;
                } : identity, Yi = qt ? function(g, f) {
                    return qt(g, "toString", {
                        configurable: !0,
                        enumerable: !1,
                        value: constant(f),
                        writable: !0
                    });
                } : identity;
                function baseShuffle(g) {
                    return shuffleSelf(values(g));
                }
                function baseSlice(g, f, S) {
                    var v = -1, C = g.length;
                    f < 0 && (f = -f > C ? 0 : C + f), (S = S > C ? C : S) < 0 && (S += C), C = f > S ? 0 : S - f >>> 0, f >>>= 0;
                    for(var E = _(C); ++v < C;)E[v] = g[v + f];
                    return E;
                }
                function baseSome(g, f) {
                    var S;
                    return qi(g, function(g, v, _) {
                        return !(S = f(g, v, _));
                    }), !!S;
                }
                function baseSortedIndex(g, f, S) {
                    var v = 0, _ = null == g ? v : g.length;
                    if ("number" == typeof f && f == f && _ <= ie) {
                        for(; v < _;){
                            var C = v + _ >>> 1, E = g[C];
                            null !== E && !isSymbol(E) && (S ? E <= f : E < f) ? v = C + 1 : _ = C;
                        }
                        return _;
                    }
                    return baseSortedIndexBy(g, f, identity, S);
                }
                function baseSortedIndexBy(g, f, v, _) {
                    var C = 0, E = null == g ? 0 : g.length;
                    if (0 === E) return 0;
                    for(var T = (f = v(f)) != f, I = null === f, b = isSymbol(f), A = f === S; C < E;){
                        var R = Xt((C + E) / 2), P = v(g[R]), w = P !== S, M = null === P, O = P == P, D = isSymbol(P);
                        if (T) var N = _ || O;
                        else N = A ? O && (_ || w) : I ? O && w && (_ || !M) : b ? O && w && !M && (_ || !D) : !M && !D && (_ ? P <= f : P < f);
                        N ? C = R + 1 : E = R;
                    }
                    return ui(E, te);
                }
                function baseSortedUniq(g, f) {
                    for(var S = -1, v = g.length, _ = 0, C = []; ++S < v;){
                        var E = g[S], T = f ? f(E) : E;
                        if (!S || !eq(T, I)) {
                            var I = T;
                            C[_++] = 0 === E ? 0 : E;
                        }
                    }
                    return C;
                }
                function baseToNumber(g) {
                    return "number" == typeof g ? g : isSymbol(g) ? Z : +g;
                }
                function baseToString(g) {
                    if ("string" == typeof g) return g;
                    if (Kn(g)) return arrayMap(g, baseToString) + "";
                    if (isSymbol(g)) return ji ? ji.call(g) : "";
                    var f = g + "";
                    return "0" == f && 1 / g == -Y ? "-0" : f;
                }
                function baseUniq(g, f, S) {
                    var v = -1, _ = arrayIncludes, E = g.length, T = !0, I = [], b = I;
                    if (S) T = !1, _ = arrayIncludesWith;
                    else if (E >= C) {
                        var A = f ? null : Zi(g);
                        if (A) return setToArray(A);
                        T = !1, _ = cacheHas, b = new SetCache;
                    } else b = f ? [] : I;
                    e: for(; ++v < E;){
                        var R = g[v], P = f ? f(R) : R;
                        if (R = S || 0 !== R ? R : 0, T && P == P) {
                            for(var w = b.length; w--;)if (b[w] === P) continue e;
                            f && b.push(P), I.push(R);
                        } else _(b, P, S) || (b !== I && b.push(P), I.push(R));
                    }
                    return I;
                }
                function baseUnset(g, f) {
                    return null == (g = parent(g, f = castPath(f, g))) || delete g[toKey(last(f))];
                }
                function baseUpdate(g, f, S, v) {
                    return baseSet(g, f, S(baseGet(g, f)), v);
                }
                function baseWhile(g, f, S, v) {
                    for(var _ = g.length, C = v ? _ : -1; (v ? C-- : ++C < _) && f(g[C], C, g););
                    return S ? baseSlice(g, v ? 0 : C, v ? C + 1 : _) : baseSlice(g, v ? C + 1 : 0, v ? _ : C);
                }
                function baseWrapperValue(g, f) {
                    var S = g;
                    return S instanceof LazyWrapper && (S = S.value()), arrayReduce(f, function(g, f) {
                        return f.func.apply(f.thisArg, arrayPush([
                            g
                        ], f.args));
                    }, S);
                }
                function baseXor(g, f, S) {
                    var v = g.length;
                    if (v < 2) return v ? baseUniq(g[0]) : [];
                    for(var C = -1, E = _(v); ++C < v;)for(var T = g[C], I = -1; ++I < v;)I != C && (E[C] = baseDifference(E[C] || T, g[I], f, S));
                    return baseUniq(baseFlatten(E, 1), f, S);
                }
                function baseZipObject(g, f, v) {
                    for(var _ = -1, C = g.length, E = f.length, T = {}; ++_ < C;){
                        var I = _ < E ? f[_] : S;
                        v(T, g[_], I);
                    }
                    return T;
                }
                function castArrayLikeObject(g) {
                    return isArrayLikeObject(g) ? g : [];
                }
                function castFunction(g) {
                    return "function" == typeof g ? g : identity;
                }
                function castPath(g, f) {
                    return Kn(g) ? g : isKey(g, f) ? [
                        g
                    ] : cn(toString(g));
                }
                var Qi = baseRest;
                function castSlice(g, f, v) {
                    var _ = g.length;
                    return v = v === S ? _ : v, !f && v >= _ ? g : baseSlice(g, f, v);
                }
                var Xi = Wt || function(g) {
                    return hi.clearTimeout(g);
                };
                function cloneBuffer(g, f) {
                    if (f) return g.slice();
                    var S = g.length, v = xt ? xt(S) : new g.constructor(S);
                    return g.copy(v), v;
                }
                function cloneArrayBuffer(g) {
                    var f = new g.constructor(g.byteLength);
                    return new Ft(f).set(new Ft(g)), f;
                }
                function cloneDataView(g, f) {
                    var S = f ? cloneArrayBuffer(g.buffer) : g.buffer;
                    return new g.constructor(S, g.byteOffset, g.byteLength);
                }
                function cloneRegExp(g) {
                    var f = new g.constructor(g.source, ot.exec(g));
                    return f.lastIndex = g.lastIndex, f;
                }
                function cloneSymbol(g) {
                    return $i ? vt($i.call(g)) : {};
                }
                function cloneTypedArray(g, f) {
                    var S = f ? cloneArrayBuffer(g.buffer) : g.buffer;
                    return new g.constructor(S, g.byteOffset, g.length);
                }
                function compareAscending(g, f) {
                    if (g !== f) {
                        var v = g !== S, _ = null === g, C = g == g, E = isSymbol(g), T = f !== S, I = null === f, b = f == f, A = isSymbol(f);
                        if (!I && !A && !E && g > f || E && T && b && !I && !A || _ && T && b || !v && b || !C) return 1;
                        if (!_ && !E && !A && g < f || A && v && C && !_ && !E || I && v && C || !T && C || !b) return -1;
                    }
                    return 0;
                }
                function compareMultiple(g, f, S) {
                    for(var v = -1, _ = g.criteria, C = f.criteria, E = _.length, T = S.length; ++v < E;){
                        var I = compareAscending(_[v], C[v]);
                        if (I) return v >= T ? I : I * ("desc" == S[v] ? -1 : 1);
                    }
                    return g.index - f.index;
                }
                function composeArgs(g, f, S, v) {
                    for(var C = -1, E = g.length, T = S.length, I = -1, b = f.length, A = di(E - T, 0), R = _(b + A), P = !v; ++I < b;)R[I] = f[I];
                    for(; ++C < T;)(P || C < E) && (R[S[C]] = g[C]);
                    for(; A--;)R[I++] = g[C++];
                    return R;
                }
                function composeArgsRight(g, f, S, v) {
                    for(var C = -1, E = g.length, T = -1, I = S.length, b = -1, A = f.length, R = di(E - I, 0), P = _(R + A), w = !v; ++C < R;)P[C] = g[C];
                    for(var M = C; ++b < A;)P[M + b] = f[b];
                    for(; ++T < I;)(w || C < E) && (P[M + S[T]] = g[C++]);
                    return P;
                }
                function copyArray(g, f) {
                    var S = -1, v = g.length;
                    for(f || (f = _(v)); ++S < v;)f[S] = g[S];
                    return f;
                }
                function copyObject(g, f, v, _) {
                    var C = !v;
                    v || (v = {});
                    for(var E = -1, T = f.length; ++E < T;){
                        var I = f[E], b = _ ? _(v[I], g[I], I, v, g) : S;
                        b === S && (b = g[I]), C ? baseAssignValue(v, I, b) : assignValue(v, I, b);
                    }
                    return v;
                }
                function copySymbols(g, f) {
                    return copyObject(g, tn(g), f);
                }
                function copySymbolsIn(g, f) {
                    return copyObject(g, nn(g), f);
                }
                function createAggregator(g, f) {
                    return function(S, v) {
                        var _ = Kn(S) ? arrayAggregator : baseAggregator, C = f ? f() : {};
                        return _(S, g, getIteratee(v, 2), C);
                    };
                }
                function createAssigner(g) {
                    return baseRest(function(f, v) {
                        var _ = -1, C = v.length, E = C > 1 ? v[C - 1] : S, T = C > 2 ? v[2] : S;
                        for(E = g.length > 3 && "function" == typeof E ? (C--, E) : S, T && isIterateeCall(v[0], v[1], T) && (E = C < 3 ? S : E, C = 1), f = vt(f); ++_ < C;){
                            var I = v[_];
                            I && g(f, I, _, E);
                        }
                        return f;
                    });
                }
                function createBaseEach(g, f) {
                    return function(S, v) {
                        if (null == S) return S;
                        if (!isArrayLike(S)) return g(S, v);
                        for(var _ = S.length, C = f ? _ : -1, E = vt(S); (f ? C-- : ++C < _) && !1 !== v(E[C], C, E););
                        return S;
                    };
                }
                function createBaseFor(g) {
                    return function(f, S, v) {
                        for(var _ = -1, C = vt(f), E = v(f), T = E.length; T--;){
                            var I = E[g ? T : ++_];
                            if (!1 === S(C[I], I, C)) break;
                        }
                        return f;
                    };
                }
                function createBind(g, f, S) {
                    var v = f & N, _ = createCtor(g);
                    function wrapper() {
                        return (this && this !== hi && this instanceof wrapper ? _ : g).apply(v ? S : this, arguments);
                    }
                    return wrapper;
                }
                function createCaseFirst(g) {
                    return function(f) {
                        var v = hasUnicode(f = toString(f)) ? stringToArray(f) : S, _ = v ? v[0] : f.charAt(0), C = v ? castSlice(v, 1).join("") : f.slice(1);
                        return _[g]() + C;
                    };
                }
                function createCompounder(g) {
                    return function(f) {
                        return arrayReduce(words(deburr(f).replace(Kt, "")), g, "");
                    };
                }
                function createCtor(g) {
                    return function() {
                        var f = arguments;
                        switch(f.length){
                            case 0:
                                return new g;
                            case 1:
                                return new g(f[0]);
                            case 2:
                                return new g(f[0], f[1]);
                            case 3:
                                return new g(f[0], f[1], f[2]);
                            case 4:
                                return new g(f[0], f[1], f[2], f[3]);
                            case 5:
                                return new g(f[0], f[1], f[2], f[3], f[4]);
                            case 6:
                                return new g(f[0], f[1], f[2], f[3], f[4], f[5]);
                            case 7:
                                return new g(f[0], f[1], f[2], f[3], f[4], f[5], f[6]);
                        }
                        var S = Gi(g.prototype), v = g.apply(S, f);
                        return isObject(v) ? v : S;
                    };
                }
                function createCurry(g, f, v) {
                    var C = createCtor(g);
                    function wrapper() {
                        for(var E = arguments.length, T = _(E), I = E, b = getHolder(wrapper); I--;)T[I] = arguments[I];
                        var A = E < 3 && T[0] !== b && T[E - 1] !== b ? [] : replaceHolders(T, b);
                        return (E -= A.length) < v ? createRecurry(g, f, createHybrid, wrapper.placeholder, S, T, A, S, S, v - E) : apply(this && this !== hi && this instanceof wrapper ? C : g, this, T);
                    }
                    return wrapper;
                }
                function createFind(g) {
                    return function(f, v, _) {
                        var C = vt(f);
                        if (!isArrayLike(f)) {
                            var E = getIteratee(v, 3);
                            f = keys(f), v = function(g) {
                                return E(C[g], g, C);
                            };
                        }
                        var T = g(f, v, _);
                        return T > -1 ? C[E ? f[T] : T] : S;
                    };
                }
                function createFlow(g) {
                    return flatRest(function(f) {
                        var v = f.length, _ = v, C = LodashWrapper.prototype.thru;
                        for(g && f.reverse(); _--;){
                            var E = f[_];
                            if ("function" != typeof E) throw new yt(T);
                            if (C && !I && "wrapper" == getFuncName(E)) var I = new LodashWrapper([], !0);
                        }
                        for(_ = I ? _ : v; ++_ < v;){
                            var b = getFuncName(E = f[_]), A = "wrapper" == b ? en(E) : S;
                            I = A && isLaziable(A[0]) && A[1] == (B | F | U | H) && !A[4].length && 1 == A[9] ? I[getFuncName(A[0])].apply(I, A[3]) : 1 == E.length && isLaziable(E) ? I[b]() : I.thru(E);
                        }
                        return function() {
                            var g = arguments, S = g[0];
                            if (I && 1 == g.length && Kn(S)) return I.plant(S).value();
                            for(var _ = 0, C = v ? f[_].apply(this, g) : S; ++_ < v;)C = f[_].call(this, C);
                            return C;
                        };
                    });
                }
                function createHybrid(g, f, v, C, E, T, I, b, A, R) {
                    var P = f & B, w = f & N, M = f & k, O = f & (F | x), D = f & $, L = M ? S : createCtor(g);
                    function wrapper() {
                        for(var S = arguments.length, N = _(S), k = S; k--;)N[k] = arguments[k];
                        if (O) var F = getHolder(wrapper), x = countHolders(N, F);
                        if (C && (N = composeArgs(N, C, E, O)), T && (N = composeArgsRight(N, T, I, O)), S -= x, O && S < R) {
                            var U = replaceHolders(N, F);
                            return createRecurry(g, f, createHybrid, wrapper.placeholder, v, N, U, b, A, R - S);
                        }
                        var V = w ? v : this, B = M ? V[g] : g;
                        return S = N.length, b ? N = reorder(N, b) : D && S > 1 && N.reverse(), P && A < S && (N.length = A), this && this !== hi && this instanceof wrapper && (B = L || createCtor(B)), B.apply(V, N);
                    }
                    return wrapper;
                }
                function createInverter(g, f) {
                    return function(S, v) {
                        return baseInverter(S, g, f(v), {});
                    };
                }
                function createMathOperation(g, f) {
                    return function(v, _) {
                        var C;
                        if (v === S && _ === S) return f;
                        if (v !== S && (C = v), _ !== S) {
                            if (C === S) return _;
                            "string" == typeof v || "string" == typeof _ ? (v = baseToString(v), _ = baseToString(_)) : (v = baseToNumber(v), _ = baseToNumber(_)), C = g(v, _);
                        }
                        return C;
                    };
                }
                function createOver(g) {
                    return flatRest(function(f) {
                        return f = arrayMap(f, baseUnary(getIteratee())), baseRest(function(S) {
                            var v = this;
                            return g(f, function(g) {
                                return apply(g, v, S);
                            });
                        });
                    });
                }
                function createPadding(g, f) {
                    var v = (f = f === S ? " " : baseToString(f)).length;
                    if (v < 2) return v ? baseRepeat(f, g) : f;
                    var _ = baseRepeat(f, Qt(g / stringSize(f)));
                    return hasUnicode(f) ? castSlice(stringToArray(_), 0, g).join("") : _.slice(0, g);
                }
                function createPartial(g, f, S, v) {
                    var C = f & N, E = createCtor(g);
                    function wrapper() {
                        for(var f = -1, T = arguments.length, I = -1, b = v.length, A = _(b + T), R = this && this !== hi && this instanceof wrapper ? E : g; ++I < b;)A[I] = v[I];
                        for(; T--;)A[I++] = arguments[++f];
                        return apply(R, C ? S : this, A);
                    }
                    return wrapper;
                }
                function createRange(g) {
                    return function(f, v, _) {
                        return _ && "number" != typeof _ && isIterateeCall(f, v, _) && (v = _ = S), f = toFinite(f), v === S ? (v = f, f = 0) : v = toFinite(v), baseRange(f, v, _ = _ === S ? f < v ? 1 : -1 : toFinite(_), g);
                    };
                }
                function createRelationalOperation(g) {
                    return function(f, S) {
                        return "string" == typeof f && "string" == typeof S || (f = toNumber(f), S = toNumber(S)), g(f, S);
                    };
                }
                function createRecurry(g, f, v, _, C, E, T, I, b, A) {
                    var R = f & F;
                    f |= R ? U : V, (f &= ~(R ? V : U)) & L || (f &= ~(N | k));
                    var P = [
                        g,
                        f,
                        C,
                        R ? E : S,
                        R ? T : S,
                        R ? S : E,
                        R ? S : T,
                        I,
                        b,
                        A
                    ], w = v.apply(S, P);
                    return isLaziable(g) && sn(w, P), w.placeholder = _, setWrapToString(w, g, f);
                }
                function createRound(g) {
                    var f = St[g];
                    return function(g, S) {
                        if (g = toNumber(g), (S = null == S ? 0 : ui(toInteger(S), 292)) && ai(g)) {
                            var v = (toString(g) + "e").split("e");
                            return +((v = (toString(f(v[0] + "e" + (+v[1] + S))) + "e").split("e"))[0] + "e" + (+v[1] - S));
                        }
                        return f(g);
                    };
                }
                var Zi = Oi && 1 / setToArray(new Oi([
                    ,
                    -0
                ]))[1] == Y ? function(g) {
                    return new Oi(g);
                } : noop;
                function createToPairs(g) {
                    return function(f) {
                        var S = rn(f);
                        return S == ge ? mapToArray(f) : S == Ce ? setToPairs(f) : baseToPairs(f, g(f));
                    };
                }
                function createWrap(g, f, v, _, C, E, I, b) {
                    var A = f & k;
                    if (!A && "function" != typeof g) throw new yt(T);
                    var R = _ ? _.length : 0;
                    if (R || (f &= ~(U | V), _ = C = S), I = I === S ? I : di(toInteger(I), 0), b = b === S ? b : toInteger(b), R -= C ? C.length : 0, f & V) {
                        var P = _, w = C;
                        _ = C = S;
                    }
                    var M = A ? S : en(g), O = [
                        g,
                        f,
                        v,
                        _,
                        C,
                        P,
                        w,
                        E,
                        I,
                        b
                    ];
                    if (M && mergeData(O, M), g = O[0], f = O[1], v = O[2], _ = O[3], C = O[4], !(b = O[9] = O[9] === S ? A ? 0 : g.length : di(O[9] - R, 0)) && f & (F | x) && (f &= ~(F | x)), f && f != N) D = f == F || f == x ? createCurry(g, f, b) : f != U && f != (N | U) || C.length ? createHybrid.apply(S, O) : createPartial(g, f, v, _);
                    else var D = createBind(g, f, v);
                    return setWrapToString((M ? Ji : sn)(D, O), g, f);
                }
                function customDefaultsAssignIn(g, f, v, _) {
                    return g === S || eq(g, It[v]) && !Rt.call(_, v) ? f : g;
                }
                function customDefaultsMerge(g, f, v, _, C, E) {
                    return isObject(g) && isObject(f) && (E.set(f, g), baseMerge(g, f, S, customDefaultsMerge, E), E.delete(f)), g;
                }
                function customOmitClone(g) {
                    return isPlainObject(g) ? S : g;
                }
                function equalArrays(g, f, v, _, C, E) {
                    var T = v & O, I = g.length, b = f.length;
                    if (I != b && !(T && b > I)) return !1;
                    var A = E.get(g), R = E.get(f);
                    if (A && R) return A == f && R == g;
                    var P = -1, w = !0, M = v & D ? new SetCache : S;
                    for(E.set(g, f), E.set(f, g); ++P < I;){
                        var N = g[P], k = f[P];
                        if (_) var L = T ? _(k, N, P, f, g, E) : _(N, k, P, g, f, E);
                        if (L !== S) {
                            if (L) continue;
                            w = !1;
                            break;
                        }
                        if (M) {
                            if (!arraySome(f, function(g, f) {
                                if (!cacheHas(M, f) && (N === g || C(N, g, v, _, E))) return M.push(f);
                            })) {
                                w = !1;
                                break;
                            }
                        } else if (N !== k && !C(N, k, v, _, E)) {
                            w = !1;
                            break;
                        }
                    }
                    return E.delete(g), E.delete(f), w;
                }
                function equalByTag(g, f, S, v, _, C, E) {
                    switch(S){
                        case Re:
                            if (g.byteLength != f.byteLength || g.byteOffset != f.byteOffset) return !1;
                            g = g.buffer, f = f.buffer;
                        case Ae:
                            return !(g.byteLength != f.byteLength || !C(new Ft(g), new Ft(f)));
                        case oe:
                        case le:
                        case pe:
                            return eq(+g, +f);
                        case de:
                            return g.name == f.name && g.message == f.message;
                        case _e:
                        case ye:
                            return g == f + "";
                        case ge:
                            var T = mapToArray;
                        case Ce:
                            var I = v & O;
                            if (T || (T = setToArray), g.size != f.size && !I) return !1;
                            var b = E.get(g);
                            if (b) return b == f;
                            v |= D, E.set(g, f);
                            var A = equalArrays(T(g), T(f), v, _, C, E);
                            return E.delete(g), A;
                        case Ee:
                            if ($i) return $i.call(g) == $i.call(f);
                    }
                    return !1;
                }
                function equalObjects(g, f, v, _, C, E) {
                    var T = v & O, I = getAllKeys(g), b = I.length;
                    if (b != getAllKeys(f).length && !T) return !1;
                    for(var A = b; A--;){
                        var R = I[A];
                        if (!(T ? R in f : Rt.call(f, R))) return !1;
                    }
                    var P = E.get(g), w = E.get(f);
                    if (P && w) return P == f && w == g;
                    var M = !0;
                    E.set(g, f), E.set(f, g);
                    for(var D = T; ++A < b;){
                        var N = g[R = I[A]], k = f[R];
                        if (_) var L = T ? _(k, N, R, f, g, E) : _(N, k, R, g, f, E);
                        if (!(L === S ? N === k || C(N, k, v, _, E) : L)) {
                            M = !1;
                            break;
                        }
                        D || (D = "constructor" == R);
                    }
                    if (M && !D) {
                        var F = g.constructor, x = f.constructor;
                        F == x || !("constructor" in g) || !("constructor" in f) || "function" == typeof F && F instanceof F && "function" == typeof x && x instanceof x || (M = !1);
                    }
                    return E.delete(g), E.delete(f), M;
                }
                function flatRest(g) {
                    return ln(overRest(g, S, flatten), g + "");
                }
                function getAllKeys(g) {
                    return baseGetAllKeys(g, keys, tn);
                }
                function getAllKeysIn(g) {
                    return baseGetAllKeys(g, keysIn, nn);
                }
                var en = ki ? function(g) {
                    return ki.get(g);
                } : noop;
                function getFuncName(g) {
                    for(var f = g.name + "", S = Li[f], v = Rt.call(Li, f) ? S.length : 0; v--;){
                        var _ = S[v], C = _.func;
                        if (null == C || C == g) return _.name;
                    }
                    return f;
                }
                function getHolder(g) {
                    return (Rt.call(lodash, "placeholder") ? lodash : g).placeholder;
                }
                function getIteratee() {
                    var g = lodash.iteratee || iteratee;
                    return g = g === iteratee ? baseIteratee : g, arguments.length ? g(arguments[0], arguments[1]) : g;
                }
                function getMapData(g, f) {
                    var S = g.__data__;
                    return isKeyable(f) ? S["string" == typeof f ? "string" : "hash"] : S.map;
                }
                function getMatchData(g) {
                    for(var f = keys(g), S = f.length; S--;){
                        var v = f[S], _ = g[v];
                        f[S] = [
                            v,
                            _,
                            isStrictComparable(_)
                        ];
                    }
                    return f;
                }
                function getNative(g, f) {
                    var v = getValue(g, f);
                    return baseIsNative(v) ? v : S;
                }
                function getRawTag(g) {
                    var f = Rt.call(g, Gt), v = g[Gt];
                    try {
                        g[Gt] = S;
                        var _ = !0;
                    } catch (g) {}
                    var C = Mt.call(g);
                    return _ && (f ? g[Gt] = v : delete g[Gt]), C;
                }
                var tn = Zt ? function(g) {
                    return null == g ? [] : (g = vt(g), arrayFilter(Zt(g), function(f) {
                        return Bt.call(g, f);
                    }));
                } : stubArray, nn = Zt ? function(g) {
                    for(var f = []; g;)arrayPush(f, tn(g)), g = Ut(g);
                    return f;
                } : stubArray, rn = baseGetTag;
                function getView(g, f, S) {
                    for(var v = -1, _ = S.length; ++v < _;){
                        var C = S[v], E = C.size;
                        switch(C.type){
                            case "drop":
                                g += E;
                                break;
                            case "dropRight":
                                f -= E;
                                break;
                            case "take":
                                f = ui(f, g + E);
                                break;
                            case "takeRight":
                                g = di(g, f - E);
                        }
                    }
                    return {
                        start: g,
                        end: f
                    };
                }
                function getWrapDetails(g) {
                    var f = g.match(tt);
                    return f ? f[1].split(it) : [];
                }
                function hasPath(g, f, S) {
                    for(var v = -1, _ = (f = castPath(f, g)).length, C = !1; ++v < _;){
                        var E = toKey(f[v]);
                        if (!(C = null != g && S(g, E))) break;
                        g = g[E];
                    }
                    return C || ++v != _ ? C : !!(_ = null == g ? 0 : g.length) && isLength(_) && isIndex(E, _) && (Kn(g) || zn(g));
                }
                function initCloneArray(g) {
                    var f = g.length, S = new g.constructor(f);
                    return f && "string" == typeof g[0] && Rt.call(g, "index") && (S.index = g.index, S.input = g.input), S;
                }
                function initCloneObject(g) {
                    return "function" != typeof g.constructor || isPrototype(g) ? {} : Gi(Ut(g));
                }
                function initCloneByTag(g, f, S) {
                    var v = g.constructor;
                    switch(f){
                        case Ae:
                            return cloneArrayBuffer(g);
                        case oe:
                        case le:
                            return new v(+g);
                        case Re:
                            return cloneDataView(g, S);
                        case Pe:
                        case we:
                        case Me:
                        case Oe:
                        case De:
                        case Ne:
                        case ke:
                        case Le:
                        case Fe:
                            return cloneTypedArray(g, S);
                        case ge:
                            return new v;
                        case pe:
                        case ye:
                            return new v(g);
                        case _e:
                            return cloneRegExp(g);
                        case Ce:
                            return new v;
                        case Ee:
                            return cloneSymbol(g);
                    }
                }
                function insertWrapDetails(g, f) {
                    var S = f.length;
                    if (!S) return g;
                    var v = S - 1;
                    return f[v] = (S > 1 ? "& " : "") + f[v], f = f.join(S > 2 ? ", " : " "), g.replace(et, "{\n/* [wrapped with " + f + "] */\n");
                }
                function isFlattenable(g) {
                    return Kn(g) || zn(g) || !!($t && g && g[$t]);
                }
                function isIndex(g, f) {
                    var S = typeof g;
                    return !!(f = null == f ? Q : f) && ("number" == S || "symbol" != S && ht.test(g)) && g > -1 && g % 1 == 0 && g < f;
                }
                function isIterateeCall(g, f, S) {
                    if (!isObject(S)) return !1;
                    var v = typeof f;
                    return !!("number" == v ? isArrayLike(S) && isIndex(f, S.length) : "string" == v && f in S) && eq(S[f], g);
                }
                function isKey(g, f) {
                    if (Kn(g)) return !1;
                    var S = typeof g;
                    return !("number" != S && "symbol" != S && "boolean" != S && null != g && !isSymbol(g)) || Ke.test(g) || !ze.test(g) || null != f && g in vt(f);
                }
                function isKeyable(g) {
                    var f = typeof g;
                    return "string" == f || "number" == f || "symbol" == f || "boolean" == f ? "__proto__" !== g : null === g;
                }
                function isLaziable(g) {
                    var f = getFuncName(g), S = lodash[f];
                    if ("function" != typeof S || !(f in LazyWrapper.prototype)) return !1;
                    if (g === S) return !0;
                    var v = en(S);
                    return !!v && g === v[0];
                }
                function isMasked(g) {
                    return !!wt && wt in g;
                }
                (Ii && rn(new Ii(new ArrayBuffer(1))) != Re || Pi && rn(new Pi) != ge || Mi && rn(Mi.resolve()) != Se || Oi && rn(new Oi) != Ce || Di && rn(new Di) != Ie) && (rn = function(g) {
                    var f = baseGetTag(g), v = f == fe ? g.constructor : S, _ = v ? toSource(v) : "";
                    if (_) switch(_){
                        case Fi:
                            return Re;
                        case xi:
                            return ge;
                        case Ui:
                            return Se;
                        case Vi:
                            return Ce;
                        case Bi:
                            return Ie;
                    }
                    return f;
                });
                var an = bt ? isFunction : stubFalse;
                function isPrototype(g) {
                    var f = g && g.constructor;
                    return g === ("function" == typeof f && f.prototype || It);
                }
                function isStrictComparable(g) {
                    return g == g && !isObject(g);
                }
                function matchesStrictComparable(g, f) {
                    return function(v) {
                        return null != v && v[g] === f && (f !== S || g in vt(v));
                    };
                }
                function memoizeCapped(g) {
                    var f = memoize(g, function(g) {
                        return S.size === A && S.clear(), g;
                    }), S = f.cache;
                    return f;
                }
                function mergeData(g, f) {
                    var S = g[1], v = f[1], _ = S | v, C = _ < (N | k | B), E = v == B && S == F || v == B && S == H && g[7].length <= f[8] || v == (B | H) && f[7].length <= f[8] && S == F;
                    if (!C && !E) return g;
                    v & N && (g[2] = f[2], _ |= S & N ? 0 : L);
                    var T = f[3];
                    if (T) {
                        var I = g[3];
                        g[3] = I ? composeArgs(I, T, f[4]) : T, g[4] = I ? replaceHolders(g[3], R) : f[4];
                    }
                    return (T = f[5]) && (I = g[5], g[5] = I ? composeArgsRight(I, T, f[6]) : T, g[6] = I ? replaceHolders(g[5], R) : f[6]), (T = f[7]) && (g[7] = T), v & B && (g[8] = null == g[8] ? f[8] : ui(g[8], f[8])), null == g[9] && (g[9] = f[9]), g[0] = f[0], g[1] = _, g;
                }
                function nativeKeysIn(g) {
                    var f = [];
                    if (null != g) for(var S in vt(g))f.push(S);
                    return f;
                }
                function objectToString(g) {
                    return Mt.call(g);
                }
                function overRest(g, f, v) {
                    return f = di(f === S ? g.length - 1 : f, 0), function() {
                        for(var S = arguments, C = -1, E = di(S.length - f, 0), T = _(E); ++C < E;)T[C] = S[f + C];
                        C = -1;
                        for(var I = _(f + 1); ++C < f;)I[C] = S[C];
                        return I[f] = v(T), apply(g, this, I);
                    };
                }
                function parent(g, f) {
                    return f.length < 2 ? g : baseGet(g, baseSlice(f, 0, -1));
                }
                function reorder(g, f) {
                    for(var v = g.length, _ = ui(f.length, v), C = copyArray(g); _--;){
                        var E = f[_];
                        g[_] = isIndex(E, v) ? C[E] : S;
                    }
                    return g;
                }
                function safeGet(g, f) {
                    if (("constructor" !== f || "function" != typeof g[f]) && "__proto__" != f) return g[f];
                }
                var sn = shortOut(Ji), on = Yt || function(g, f) {
                    return hi.setTimeout(g, f);
                }, ln = shortOut(Yi);
                function setWrapToString(g, f, S) {
                    var v = f + "";
                    return ln(g, insertWrapDetails(v, updateWrapDetails(getWrapDetails(v), S)));
                }
                function shortOut(g) {
                    var f = 0, v = 0;
                    return function() {
                        var _ = gi(), C = W - (_ - v);
                        if (v = _, C > 0) {
                            if (++f >= q) return arguments[0];
                        } else f = 0;
                        return g.apply(S, arguments);
                    };
                }
                function shuffleSelf(g, f) {
                    var v = -1, _ = g.length, C = _ - 1;
                    for(f = f === S ? _ : f; ++v < f;){
                        var E = baseRandom(v, C), T = g[E];
                        g[E] = g[v], g[v] = T;
                    }
                    return g.length = f, g;
                }
                var cn = memoizeCapped(function(g) {
                    var f = [];
                    return 46 === g.charCodeAt(0) && f.push(""), g.replace(Je, function(g, S, v, _) {
                        f.push(v ? _.replace(at, "$1") : S || g);
                    }), f;
                });
                function toKey(g) {
                    if ("string" == typeof g || isSymbol(g)) return g;
                    var f = g + "";
                    return "0" == f && 1 / g == -Y ? "-0" : f;
                }
                function toSource(g) {
                    if (null != g) {
                        try {
                            return At.call(g);
                        } catch (g) {}
                        try {
                            return g + "";
                        } catch (g) {}
                    }
                    return "";
                }
                function updateWrapDetails(g, f) {
                    return arrayEach(ne, function(S) {
                        var v = "_." + S[0];
                        f & S[1] && !arrayIncludes(g, v) && g.push(v);
                    }), g.sort();
                }
                function wrapperClone(g) {
                    if (g instanceof LazyWrapper) return g.clone();
                    var f = new LodashWrapper(g.__wrapped__, g.__chain__);
                    return f.__actions__ = copyArray(g.__actions__), f.__index__ = g.__index__, f.__values__ = g.__values__, f;
                }
                function chunk(g, f, v) {
                    f = (v ? isIterateeCall(g, f, v) : f === S) ? 1 : di(toInteger(f), 0);
                    var C = null == g ? 0 : g.length;
                    if (!C || f < 1) return [];
                    for(var E = 0, T = 0, I = _(Qt(C / f)); E < C;)I[T++] = baseSlice(g, E, E += f);
                    return I;
                }
                function compact(g) {
                    for(var f = -1, S = null == g ? 0 : g.length, v = 0, _ = []; ++f < S;){
                        var C = g[f];
                        C && (_[v++] = C);
                    }
                    return _;
                }
                function concat() {
                    var g = arguments.length;
                    if (!g) return [];
                    for(var f = _(g - 1), S = arguments[0], v = g; v--;)f[v - 1] = arguments[v];
                    return arrayPush(Kn(S) ? copyArray(S) : [
                        S
                    ], baseFlatten(f, 1));
                }
                var dn = baseRest(function(g, f) {
                    return isArrayLikeObject(g) ? baseDifference(g, baseFlatten(f, 1, isArrayLikeObject, !0)) : [];
                }), un = baseRest(function(g, f) {
                    var v = last(f);
                    return isArrayLikeObject(v) && (v = S), isArrayLikeObject(g) ? baseDifference(g, baseFlatten(f, 1, isArrayLikeObject, !0), getIteratee(v, 2)) : [];
                }), hn = baseRest(function(g, f) {
                    var v = last(f);
                    return isArrayLikeObject(v) && (v = S), isArrayLikeObject(g) ? baseDifference(g, baseFlatten(f, 1, isArrayLikeObject, !0), S, v) : [];
                });
                function drop(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    return _ ? baseSlice(g, (f = v || f === S ? 1 : toInteger(f)) < 0 ? 0 : f, _) : [];
                }
                function dropRight(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    return _ ? baseSlice(g, 0, (f = _ - (f = v || f === S ? 1 : toInteger(f))) < 0 ? 0 : f) : [];
                }
                function dropRightWhile(g, f) {
                    return g && g.length ? baseWhile(g, getIteratee(f, 3), !0, !0) : [];
                }
                function dropWhile(g, f) {
                    return g && g.length ? baseWhile(g, getIteratee(f, 3), !0) : [];
                }
                function fill(g, f, S, v) {
                    var _ = null == g ? 0 : g.length;
                    return _ ? (S && "number" != typeof S && isIterateeCall(g, f, S) && (S = 0, v = _), baseFill(g, f, S, v)) : [];
                }
                function findIndex(g, f, S) {
                    var v = null == g ? 0 : g.length;
                    if (!v) return -1;
                    var _ = null == S ? 0 : toInteger(S);
                    return _ < 0 && (_ = di(v + _, 0)), baseFindIndex(g, getIteratee(f, 3), _);
                }
                function findLastIndex(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    if (!_) return -1;
                    var C = _ - 1;
                    return v !== S && (C = toInteger(v), C = v < 0 ? di(_ + C, 0) : ui(C, _ - 1)), baseFindIndex(g, getIteratee(f, 3), C, !0);
                }
                function flatten(g) {
                    return (null == g ? 0 : g.length) ? baseFlatten(g, 1) : [];
                }
                function flattenDeep(g) {
                    return (null == g ? 0 : g.length) ? baseFlatten(g, Y) : [];
                }
                function flattenDepth(g, f) {
                    return (null == g ? 0 : g.length) ? baseFlatten(g, f = f === S ? 1 : toInteger(f)) : [];
                }
                function fromPairs(g) {
                    for(var f = -1, S = null == g ? 0 : g.length, v = {}; ++f < S;){
                        var _ = g[f];
                        v[_[0]] = _[1];
                    }
                    return v;
                }
                function head(g) {
                    return g && g.length ? g[0] : S;
                }
                function indexOf(g, f, S) {
                    var v = null == g ? 0 : g.length;
                    if (!v) return -1;
                    var _ = null == S ? 0 : toInteger(S);
                    return _ < 0 && (_ = di(v + _, 0)), baseIndexOf(g, f, _);
                }
                function initial(g) {
                    return (null == g ? 0 : g.length) ? baseSlice(g, 0, -1) : [];
                }
                var gn = baseRest(function(g) {
                    var f = arrayMap(g, castArrayLikeObject);
                    return f.length && f[0] === g[0] ? baseIntersection(f) : [];
                }), pn = baseRest(function(g) {
                    var f = last(g), v = arrayMap(g, castArrayLikeObject);
                    return f === last(v) ? f = S : v.pop(), v.length && v[0] === g[0] ? baseIntersection(v, getIteratee(f, 2)) : [];
                }), mn = baseRest(function(g) {
                    var f = last(g), v = arrayMap(g, castArrayLikeObject);
                    return (f = "function" == typeof f ? f : S) && v.pop(), v.length && v[0] === g[0] ? baseIntersection(v, S, f) : [];
                });
                function join(g, f) {
                    return null == g ? "" : si.call(g, f);
                }
                function last(g) {
                    var f = null == g ? 0 : g.length;
                    return f ? g[f - 1] : S;
                }
                function lastIndexOf(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    if (!_) return -1;
                    var C = _;
                    return v !== S && (C = (C = toInteger(v)) < 0 ? di(_ + C, 0) : ui(C, _ - 1)), f == f ? strictLastIndexOf(g, f, C) : baseFindIndex(g, baseIsNaN, C, !0);
                }
                function nth(g, f) {
                    return g && g.length ? baseNth(g, toInteger(f)) : S;
                }
                var fn = baseRest(pullAll);
                function pullAll(g, f) {
                    return g && g.length && f && f.length ? basePullAll(g, f) : g;
                }
                function pullAllBy(g, f, S) {
                    return g && g.length && f && f.length ? basePullAll(g, f, getIteratee(S, 2)) : g;
                }
                function pullAllWith(g, f, v) {
                    return g && g.length && f && f.length ? basePullAll(g, f, S, v) : g;
                }
                var Sn = flatRest(function(g, f) {
                    var S = null == g ? 0 : g.length, v = baseAt(g, f);
                    return basePullAt(g, arrayMap(f, function(g) {
                        return isIndex(g, S) ? +g : g;
                    }).sort(compareAscending)), v;
                });
                function remove(g, f) {
                    var S = [];
                    if (!g || !g.length) return S;
                    var v = -1, _ = [], C = g.length;
                    for(f = getIteratee(f, 3); ++v < C;){
                        var E = g[v];
                        f(E, v, g) && (S.push(E), _.push(v));
                    }
                    return basePullAt(g, _), S;
                }
                function reverse(g) {
                    return null == g ? g : Si.call(g);
                }
                function slice(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    return _ ? (v && "number" != typeof v && isIterateeCall(g, f, v) ? (f = 0, v = _) : (f = null == f ? 0 : toInteger(f), v = v === S ? _ : toInteger(v)), baseSlice(g, f, v)) : [];
                }
                function sortedIndex(g, f) {
                    return baseSortedIndex(g, f);
                }
                function sortedIndexBy(g, f, S) {
                    return baseSortedIndexBy(g, f, getIteratee(S, 2));
                }
                function sortedIndexOf(g, f) {
                    var S = null == g ? 0 : g.length;
                    if (S) {
                        var v = baseSortedIndex(g, f);
                        if (v < S && eq(g[v], f)) return v;
                    }
                    return -1;
                }
                function sortedLastIndex(g, f) {
                    return baseSortedIndex(g, f, !0);
                }
                function sortedLastIndexBy(g, f, S) {
                    return baseSortedIndexBy(g, f, getIteratee(S, 2), !0);
                }
                function sortedLastIndexOf(g, f) {
                    if (null == g ? 0 : g.length) {
                        var S = baseSortedIndex(g, f, !0) - 1;
                        if (eq(g[S], f)) return S;
                    }
                    return -1;
                }
                function sortedUniq(g) {
                    return g && g.length ? baseSortedUniq(g) : [];
                }
                function sortedUniqBy(g, f) {
                    return g && g.length ? baseSortedUniq(g, getIteratee(f, 2)) : [];
                }
                function tail(g) {
                    var f = null == g ? 0 : g.length;
                    return f ? baseSlice(g, 1, f) : [];
                }
                function take(g, f, v) {
                    return g && g.length ? baseSlice(g, 0, (f = v || f === S ? 1 : toInteger(f)) < 0 ? 0 : f) : [];
                }
                function takeRight(g, f, v) {
                    var _ = null == g ? 0 : g.length;
                    return _ ? baseSlice(g, (f = _ - (f = v || f === S ? 1 : toInteger(f))) < 0 ? 0 : f, _) : [];
                }
                function takeRightWhile(g, f) {
                    return g && g.length ? baseWhile(g, getIteratee(f, 3), !1, !0) : [];
                }
                function takeWhile(g, f) {
                    return g && g.length ? baseWhile(g, getIteratee(f, 3)) : [];
                }
                var vn = baseRest(function(g) {
                    return baseUniq(baseFlatten(g, 1, isArrayLikeObject, !0));
                }), _n = baseRest(function(g) {
                    var f = last(g);
                    return isArrayLikeObject(f) && (f = S), baseUniq(baseFlatten(g, 1, isArrayLikeObject, !0), getIteratee(f, 2));
                }), Cn = baseRest(function(g) {
                    var f = last(g);
                    return f = "function" == typeof f ? f : S, baseUniq(baseFlatten(g, 1, isArrayLikeObject, !0), S, f);
                });
                function uniq(g) {
                    return g && g.length ? baseUniq(g) : [];
                }
                function uniqBy(g, f) {
                    return g && g.length ? baseUniq(g, getIteratee(f, 2)) : [];
                }
                function uniqWith(g, f) {
                    return f = "function" == typeof f ? f : S, g && g.length ? baseUniq(g, S, f) : [];
                }
                function unzip(g) {
                    if (!g || !g.length) return [];
                    var f = 0;
                    return g = arrayFilter(g, function(g) {
                        if (isArrayLikeObject(g)) return f = di(g.length, f), !0;
                    }), baseTimes(f, function(f) {
                        return arrayMap(g, baseProperty(f));
                    });
                }
                function unzipWith(g, f) {
                    if (!g || !g.length) return [];
                    var v = unzip(g);
                    return null == f ? v : arrayMap(v, function(g) {
                        return apply(f, S, g);
                    });
                }
                var yn = baseRest(function(g, f) {
                    return isArrayLikeObject(g) ? baseDifference(g, f) : [];
                }), En = baseRest(function(g) {
                    return baseXor(arrayFilter(g, isArrayLikeObject));
                }), Tn = baseRest(function(g) {
                    var f = last(g);
                    return isArrayLikeObject(f) && (f = S), baseXor(arrayFilter(g, isArrayLikeObject), getIteratee(f, 2));
                }), In = baseRest(function(g) {
                    var f = last(g);
                    return f = "function" == typeof f ? f : S, baseXor(arrayFilter(g, isArrayLikeObject), S, f);
                }), bn = baseRest(unzip);
                function zipObject(g, f) {
                    return baseZipObject(g || [], f || [], assignValue);
                }
                function zipObjectDeep(g, f) {
                    return baseZipObject(g || [], f || [], baseSet);
                }
                var An = baseRest(function(g) {
                    var f = g.length, v = f > 1 ? g[f - 1] : S;
                    return v = "function" == typeof v ? (g.pop(), v) : S, unzipWith(g, v);
                });
                function chain(g) {
                    var f = lodash(g);
                    return f.__chain__ = !0, f;
                }
                function tap(g, f) {
                    return f(g), g;
                }
                function thru(g, f) {
                    return f(g);
                }
                var Rn = flatRest(function(g) {
                    var f = g.length, v = f ? g[0] : 0, _ = this.__wrapped__, interceptor = function(f) {
                        return baseAt(f, g);
                    };
                    return !(f > 1 || this.__actions__.length) && _ instanceof LazyWrapper && isIndex(v) ? ((_ = _.slice(v, +v + (f ? 1 : 0))).__actions__.push({
                        func: thru,
                        args: [
                            interceptor
                        ],
                        thisArg: S
                    }), new LodashWrapper(_, this.__chain__).thru(function(g) {
                        return f && !g.length && g.push(S), g;
                    })) : this.thru(interceptor);
                });
                function wrapperChain() {
                    return chain(this);
                }
                function wrapperCommit() {
                    return new LodashWrapper(this.value(), this.__chain__);
                }
                function wrapperNext() {
                    this.__values__ === S && (this.__values__ = toArray(this.value()));
                    var g = this.__index__ >= this.__values__.length;
                    return {
                        done: g,
                        value: g ? S : this.__values__[this.__index__++]
                    };
                }
                function wrapperToIterator() {
                    return this;
                }
                function wrapperPlant(g) {
                    for(var f, v = this; v instanceof baseLodash;){
                        var _ = wrapperClone(v);
                        _.__index__ = 0, _.__values__ = S, f ? C.__wrapped__ = _ : f = _;
                        var C = _;
                        v = v.__wrapped__;
                    }
                    return C.__wrapped__ = g, f;
                }
                function wrapperReverse() {
                    var g = this.__wrapped__;
                    if (g instanceof LazyWrapper) {
                        var f = g;
                        return this.__actions__.length && (f = new LazyWrapper(this)), (f = f.reverse()).__actions__.push({
                            func: thru,
                            args: [
                                reverse
                            ],
                            thisArg: S
                        }), new LodashWrapper(f, this.__chain__);
                    }
                    return this.thru(reverse);
                }
                function wrapperValue() {
                    return baseWrapperValue(this.__wrapped__, this.__actions__);
                }
                var Pn = createAggregator(function(g, f, S) {
                    Rt.call(g, S) ? ++g[S] : baseAssignValue(g, S, 1);
                });
                function every(g, f, v) {
                    var _ = Kn(g) ? arrayEvery : baseEvery;
                    return v && isIterateeCall(g, f, v) && (f = S), _(g, getIteratee(f, 3));
                }
                function filter(g, f) {
                    return (Kn(g) ? arrayFilter : baseFilter)(g, getIteratee(f, 3));
                }
                var wn = createFind(findIndex), Mn = createFind(findLastIndex);
                function flatMap(g, f) {
                    return baseFlatten(map(g, f), 1);
                }
                function flatMapDeep(g, f) {
                    return baseFlatten(map(g, f), Y);
                }
                function flatMapDepth(g, f, v) {
                    return v = v === S ? 1 : toInteger(v), baseFlatten(map(g, f), v);
                }
                function forEach(g, f) {
                    return (Kn(g) ? arrayEach : qi)(g, getIteratee(f, 3));
                }
                function forEachRight(g, f) {
                    return (Kn(g) ? arrayEachRight : Wi)(g, getIteratee(f, 3));
                }
                var On = createAggregator(function(g, f, S) {
                    Rt.call(g, S) ? g[S].push(f) : baseAssignValue(g, S, [
                        f
                    ]);
                });
                function includes(g, f, S, v) {
                    g = isArrayLike(g) ? g : values(g), S = S && !v ? toInteger(S) : 0;
                    var _ = g.length;
                    return S < 0 && (S = di(_ + S, 0)), isString(g) ? S <= _ && g.indexOf(f, S) > -1 : !!_ && baseIndexOf(g, f, S) > -1;
                }
                var Dn = baseRest(function(g, f, S) {
                    var v = -1, C = "function" == typeof f, E = isArrayLike(g) ? _(g.length) : [];
                    return qi(g, function(g) {
                        E[++v] = C ? apply(f, g, S) : baseInvoke(g, f, S);
                    }), E;
                }), Nn = createAggregator(function(g, f, S) {
                    baseAssignValue(g, S, f);
                });
                function map(g, f) {
                    return (Kn(g) ? arrayMap : baseMap)(g, getIteratee(f, 3));
                }
                function orderBy(g, f, v, _) {
                    return null == g ? [] : (Kn(f) || (f = null == f ? [] : [
                        f
                    ]), Kn(v = _ ? S : v) || (v = null == v ? [] : [
                        v
                    ]), baseOrderBy(g, f, v));
                }
                var kn = createAggregator(function(g, f, S) {
                    g[S ? 0 : 1].push(f);
                }, function() {
                    return [
                        [],
                        []
                    ];
                });
                function reduce(g, f, S) {
                    var v = Kn(g) ? arrayReduce : baseReduce, _ = arguments.length < 3;
                    return v(g, getIteratee(f, 4), S, _, qi);
                }
                function reduceRight(g, f, S) {
                    var v = Kn(g) ? arrayReduceRight : baseReduce, _ = arguments.length < 3;
                    return v(g, getIteratee(f, 4), S, _, Wi);
                }
                function reject(g, f) {
                    return (Kn(g) ? arrayFilter : baseFilter)(g, negate(getIteratee(f, 3)));
                }
                function sample(g) {
                    return (Kn(g) ? arraySample : baseSample)(g);
                }
                function sampleSize(g, f, v) {
                    return f = (v ? isIterateeCall(g, f, v) : f === S) ? 1 : toInteger(f), (Kn(g) ? arraySampleSize : baseSampleSize)(g, f);
                }
                function shuffle(g) {
                    return (Kn(g) ? arrayShuffle : baseShuffle)(g);
                }
                function size(g) {
                    if (null == g) return 0;
                    if (isArrayLike(g)) return isString(g) ? stringSize(g) : g.length;
                    var f = rn(g);
                    return f == ge || f == Ce ? g.size : baseKeys(g).length;
                }
                function some(g, f, v) {
                    var _ = Kn(g) ? arraySome : baseSome;
                    return v && isIterateeCall(g, f, v) && (f = S), _(g, getIteratee(f, 3));
                }
                var Ln = baseRest(function(g, f) {
                    if (null == g) return [];
                    var S = f.length;
                    return S > 1 && isIterateeCall(g, f[0], f[1]) ? f = [] : S > 2 && isIterateeCall(f[0], f[1], f[2]) && (f = [
                        f[0]
                    ]), baseOrderBy(g, baseFlatten(f, 1), []);
                }), Fn = zt || function() {
                    return hi.Date.now();
                };
                function after(g, f) {
                    if ("function" != typeof f) throw new yt(T);
                    return g = toInteger(g), function() {
                        if (--g < 1) return f.apply(this, arguments);
                    };
                }
                function ary(g, f, v) {
                    return f = v ? S : f, f = g && null == f ? g.length : f, createWrap(g, B, S, S, S, S, f);
                }
                function before(g, f) {
                    var v;
                    if ("function" != typeof f) throw new yt(T);
                    return g = toInteger(g), function() {
                        return --g > 0 && (v = f.apply(this, arguments)), g <= 1 && (f = S), v;
                    };
                }
                var xn = baseRest(function(g, f, S) {
                    var v = N;
                    if (S.length) {
                        var _ = replaceHolders(S, getHolder(xn));
                        v |= U;
                    }
                    return createWrap(g, v, f, S, _);
                }), Un = baseRest(function(g, f, S) {
                    var v = N | k;
                    if (S.length) {
                        var _ = replaceHolders(S, getHolder(Un));
                        v |= U;
                    }
                    return createWrap(f, v, g, S, _);
                });
                function curry(g, f, v) {
                    var _ = createWrap(g, F, S, S, S, S, S, f = v ? S : f);
                    return _.placeholder = curry.placeholder, _;
                }
                function curryRight(g, f, v) {
                    var _ = createWrap(g, x, S, S, S, S, S, f = v ? S : f);
                    return _.placeholder = curryRight.placeholder, _;
                }
                function debounce(g, f, v) {
                    var _, C, E, I, b, A, R = 0, P = !1, w = !1, M = !0;
                    if ("function" != typeof g) throw new yt(T);
                    function invokeFunc(f) {
                        var v = _, E = C;
                        return _ = C = S, R = f, I = g.apply(E, v);
                    }
                    function leadingEdge(g) {
                        return R = g, b = on(timerExpired, f), P ? invokeFunc(g) : I;
                    }
                    function remainingWait(g) {
                        var S = f - (g - A);
                        return w ? ui(S, E - (g - R)) : S;
                    }
                    function shouldInvoke(g) {
                        var v = g - A;
                        return A === S || v >= f || v < 0 || w && g - R >= E;
                    }
                    function timerExpired() {
                        var g = Fn();
                        if (shouldInvoke(g)) return trailingEdge(g);
                        b = on(timerExpired, remainingWait(g));
                    }
                    function trailingEdge(g) {
                        return b = S, M && _ ? invokeFunc(g) : (_ = C = S, I);
                    }
                    function cancel() {
                        b !== S && Xi(b), R = 0, _ = A = C = b = S;
                    }
                    function flush() {
                        return b === S ? I : trailingEdge(Fn());
                    }
                    function debounced() {
                        var g = Fn(), v = shouldInvoke(g);
                        if (_ = arguments, C = this, A = g, v) {
                            if (b === S) return leadingEdge(A);
                            if (w) return Xi(b), b = on(timerExpired, f), invokeFunc(A);
                        }
                        return b === S && (b = on(timerExpired, f)), I;
                    }
                    return f = toNumber(f) || 0, isObject(v) && (P = !!v.leading, E = (w = "maxWait" in v) ? di(toNumber(v.maxWait) || 0, f) : E, M = "trailing" in v ? !!v.trailing : M), debounced.cancel = cancel, debounced.flush = flush, debounced;
                }
                var Vn = baseRest(function(g, f) {
                    return baseDelay(g, 1, f);
                }), Bn = baseRest(function(g, f, S) {
                    return baseDelay(g, toNumber(f) || 0, S);
                });
                function flip(g) {
                    return createWrap(g, $);
                }
                function memoize(g, f) {
                    if ("function" != typeof g || null != f && "function" != typeof f) throw new yt(T);
                    var memoized = function() {
                        var S = arguments, v = f ? f.apply(this, S) : S[0], _ = memoized.cache;
                        if (_.has(v)) return _.get(v);
                        var C = g.apply(this, S);
                        return memoized.cache = _.set(v, C) || _, C;
                    };
                    return memoized.cache = new (memoize.Cache || MapCache), memoized;
                }
                function negate(g) {
                    if ("function" != typeof g) throw new yt(T);
                    return function() {
                        var f = arguments;
                        switch(f.length){
                            case 0:
                                return !g.call(this);
                            case 1:
                                return !g.call(this, f[0]);
                            case 2:
                                return !g.call(this, f[0], f[1]);
                            case 3:
                                return !g.call(this, f[0], f[1], f[2]);
                        }
                        return !g.apply(this, f);
                    };
                }
                function once(g) {
                    return before(2, g);
                }
                memoize.Cache = MapCache;
                var Hn = Qi(function(g, f) {
                    var S = (f = 1 == f.length && Kn(f[0]) ? arrayMap(f[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(f, 1), baseUnary(getIteratee()))).length;
                    return baseRest(function(v) {
                        for(var _ = -1, C = ui(v.length, S); ++_ < C;)v[_] = f[_].call(this, v[_]);
                        return apply(g, this, v);
                    });
                }), $n = baseRest(function(g, f) {
                    var v = replaceHolders(f, getHolder($n));
                    return createWrap(g, U, S, f, v);
                }), jn = baseRest(function(g, f) {
                    var v = replaceHolders(f, getHolder(jn));
                    return createWrap(g, V, S, f, v);
                }), Gn = flatRest(function(g, f) {
                    return createWrap(g, H, S, S, S, f);
                });
                function rest(g, f) {
                    if ("function" != typeof g) throw new yt(T);
                    return baseRest(g, f = f === S ? f : toInteger(f));
                }
                function spread(g, f) {
                    if ("function" != typeof g) throw new yt(T);
                    return f = null == f ? 0 : di(toInteger(f), 0), baseRest(function(S) {
                        var v = S[f], _ = castSlice(S, 0, f);
                        return v && arrayPush(_, v), apply(g, this, _);
                    });
                }
                function throttle(g, f, S) {
                    var v = !0, _ = !0;
                    if ("function" != typeof g) throw new yt(T);
                    return isObject(S) && (v = "leading" in S ? !!S.leading : v, _ = "trailing" in S ? !!S.trailing : _), debounce(g, f, {
                        leading: v,
                        maxWait: f,
                        trailing: _
                    });
                }
                function unary(g) {
                    return ary(g, 1);
                }
                function wrap(g, f) {
                    return $n(castFunction(f), g);
                }
                function castArray() {
                    if (!arguments.length) return [];
                    var g = arguments[0];
                    return Kn(g) ? g : [
                        g
                    ];
                }
                function clone(g) {
                    return baseClone(g, M);
                }
                function cloneWith(g, f) {
                    return baseClone(g, M, f = "function" == typeof f ? f : S);
                }
                function cloneDeep(g) {
                    return baseClone(g, P | M);
                }
                function cloneDeepWith(g, f) {
                    return baseClone(g, P | M, f = "function" == typeof f ? f : S);
                }
                function conformsTo(g, f) {
                    return null == f || baseConformsTo(g, f, keys(f));
                }
                function eq(g, f) {
                    return g === f || g != g && f != f;
                }
                var qn = createRelationalOperation(baseGt), Wn = createRelationalOperation(function(g, f) {
                    return g >= f;
                }), zn = baseIsArguments(function() {
                    return arguments;
                }()) ? baseIsArguments : function(g) {
                    return isObjectLike(g) && Rt.call(g, "callee") && !Bt.call(g, "callee");
                }, Kn = _.isArray, Jn = vi ? baseUnary(vi) : baseIsArrayBuffer;
                function isArrayLike(g) {
                    return null != g && isLength(g.length) && !isFunction(g);
                }
                function isArrayLikeObject(g) {
                    return isObjectLike(g) && isArrayLike(g);
                }
                function isBoolean(g) {
                    return !0 === g || !1 === g || isObjectLike(g) && baseGetTag(g) == oe;
                }
                var Yn = ri || stubFalse, Qn = _i ? baseUnary(_i) : baseIsDate;
                function isElement(g) {
                    return isObjectLike(g) && 1 === g.nodeType && !isPlainObject(g);
                }
                function isEmpty(g) {
                    if (null == g) return !0;
                    if (isArrayLike(g) && (Kn(g) || "string" == typeof g || "function" == typeof g.splice || Yn(g) || tr(g) || zn(g))) return !g.length;
                    var f = rn(g);
                    if (f == ge || f == Ce) return !g.size;
                    if (isPrototype(g)) return !baseKeys(g).length;
                    for(var S in g)if (Rt.call(g, S)) return !1;
                    return !0;
                }
                function isEqual(g, f) {
                    return baseIsEqual(g, f);
                }
                function isEqualWith(g, f, v) {
                    var _ = (v = "function" == typeof v ? v : S) ? v(g, f) : S;
                    return _ === S ? baseIsEqual(g, f, S, v) : !!_;
                }
                function isError(g) {
                    if (!isObjectLike(g)) return !1;
                    var f = baseGetTag(g);
                    return f == de || f == ce || "string" == typeof g.message && "string" == typeof g.name && !isPlainObject(g);
                }
                function isFinite1(g) {
                    return "number" == typeof g && ai(g);
                }
                function isFunction(g) {
                    if (!isObject(g)) return !1;
                    var f = baseGetTag(g);
                    return f == ue || f == he || f == se || f == ve;
                }
                function isInteger(g) {
                    return "number" == typeof g && g == toInteger(g);
                }
                function isLength(g) {
                    return "number" == typeof g && g > -1 && g % 1 == 0 && g <= Q;
                }
                function isObject(g) {
                    var f = typeof g;
                    return null != g && ("object" == f || "function" == f);
                }
                function isObjectLike(g) {
                    return null != g && "object" == typeof g;
                }
                var Xn = Ci ? baseUnary(Ci) : baseIsMap;
                function isMatch(g, f) {
                    return g === f || baseIsMatch(g, f, getMatchData(f));
                }
                function isMatchWith(g, f, v) {
                    return v = "function" == typeof v ? v : S, baseIsMatch(g, f, getMatchData(f), v);
                }
                function isNaN1(g) {
                    return isNumber(g) && g != +g;
                }
                function isNative(g) {
                    if (an(g)) throw new nt(E);
                    return baseIsNative(g);
                }
                function isNull(g) {
                    return null === g;
                }
                function isNil(g) {
                    return null == g;
                }
                function isNumber(g) {
                    return "number" == typeof g || isObjectLike(g) && baseGetTag(g) == pe;
                }
                function isPlainObject(g) {
                    if (!isObjectLike(g) || baseGetTag(g) != fe) return !1;
                    var f = Ut(g);
                    if (null === f) return !0;
                    var S = Rt.call(f, "constructor") && f.constructor;
                    return "function" == typeof S && S instanceof S && At.call(S) == Ot;
                }
                var Zn = yi ? baseUnary(yi) : baseIsRegExp;
                function isSafeInteger(g) {
                    return isInteger(g) && g >= -Q && g <= Q;
                }
                var er = Ei ? baseUnary(Ei) : baseIsSet;
                function isString(g) {
                    return "string" == typeof g || !Kn(g) && isObjectLike(g) && baseGetTag(g) == ye;
                }
                function isSymbol(g) {
                    return "symbol" == typeof g || isObjectLike(g) && baseGetTag(g) == Ee;
                }
                var tr = Ti ? baseUnary(Ti) : baseIsTypedArray;
                function isUndefined(g) {
                    return g === S;
                }
                function isWeakMap(g) {
                    return isObjectLike(g) && rn(g) == Ie;
                }
                function isWeakSet(g) {
                    return isObjectLike(g) && baseGetTag(g) == be;
                }
                var ir = createRelationalOperation(baseLt), nr = createRelationalOperation(function(g, f) {
                    return g <= f;
                });
                function toArray(g) {
                    if (!g) return [];
                    if (isArrayLike(g)) return isString(g) ? stringToArray(g) : copyArray(g);
                    if (jt && g[jt]) return iteratorToArray(g[jt]());
                    var f = rn(g);
                    return (f == ge ? mapToArray : f == Ce ? setToArray : values)(g);
                }
                function toFinite(g) {
                    return g ? (g = toNumber(g)) === Y || g === -Y ? (g < 0 ? -1 : 1) * X : g == g ? g : 0 : 0 === g ? g : 0;
                }
                function toInteger(g) {
                    var f = toFinite(g), S = f % 1;
                    return f == f ? S ? f - S : f : 0;
                }
                function toLength(g) {
                    return g ? baseClamp(toInteger(g), 0, ee) : 0;
                }
                function toNumber(g) {
                    if ("number" == typeof g) return g;
                    if (isSymbol(g)) return Z;
                    if (isObject(g)) {
                        var f = "function" == typeof g.valueOf ? g.valueOf() : g;
                        g = isObject(f) ? f + "" : f;
                    }
                    if ("string" != typeof g) return 0 === g ? g : +g;
                    g = baseTrim(g);
                    var S = ct.test(g);
                    return S || ut.test(g) ? ci(g.slice(2), S ? 2 : 8) : lt.test(g) ? Z : +g;
                }
                function toPlainObject(g) {
                    return copyObject(g, keysIn(g));
                }
                function toSafeInteger(g) {
                    return g ? baseClamp(toInteger(g), -Q, Q) : 0 === g ? g : 0;
                }
                function toString(g) {
                    return null == g ? "" : baseToString(g);
                }
                var rr = createAssigner(function(g, f) {
                    if (isPrototype(f) || isArrayLike(f)) copyObject(f, keys(f), g);
                    else for(var S in f)Rt.call(f, S) && assignValue(g, S, f[S]);
                }), ar = createAssigner(function(g, f) {
                    copyObject(f, keysIn(f), g);
                }), sr = createAssigner(function(g, f, S, v) {
                    copyObject(f, keysIn(f), g, v);
                }), or = createAssigner(function(g, f, S, v) {
                    copyObject(f, keys(f), g, v);
                }), lr = flatRest(baseAt);
                function create(g, f) {
                    var S = Gi(g);
                    return null == f ? S : baseAssign(S, f);
                }
                var cr = baseRest(function(g, f) {
                    g = vt(g);
                    var v = -1, _ = f.length, C = _ > 2 ? f[2] : S;
                    for(C && isIterateeCall(f[0], f[1], C) && (_ = 1); ++v < _;)for(var E = f[v], T = keysIn(E), I = -1, b = T.length; ++I < b;){
                        var A = T[I], R = g[A];
                        (R === S || eq(R, It[A]) && !Rt.call(g, A)) && (g[A] = E[A]);
                    }
                    return g;
                }), dr = baseRest(function(g) {
                    return g.push(S, customDefaultsMerge), apply(mr, S, g);
                });
                function findKey(g, f) {
                    return baseFindKey(g, getIteratee(f, 3), baseForOwn);
                }
                function findLastKey(g, f) {
                    return baseFindKey(g, getIteratee(f, 3), baseForOwnRight);
                }
                function forIn(g, f) {
                    return null == g ? g : zi(g, getIteratee(f, 3), keysIn);
                }
                function forInRight(g, f) {
                    return null == g ? g : Ki(g, getIteratee(f, 3), keysIn);
                }
                function forOwn(g, f) {
                    return g && baseForOwn(g, getIteratee(f, 3));
                }
                function forOwnRight(g, f) {
                    return g && baseForOwnRight(g, getIteratee(f, 3));
                }
                function functions(g) {
                    return null == g ? [] : baseFunctions(g, keys(g));
                }
                function functionsIn(g) {
                    return null == g ? [] : baseFunctions(g, keysIn(g));
                }
                function get(g, f, v) {
                    var _ = null == g ? S : baseGet(g, f);
                    return _ === S ? v : _;
                }
                function has(g, f) {
                    return null != g && hasPath(g, f, baseHas);
                }
                function hasIn(g, f) {
                    return null != g && hasPath(g, f, baseHasIn);
                }
                var ur = createInverter(function(g, f, S) {
                    null != f && "function" != typeof f.toString && (f = Mt.call(f)), g[f] = S;
                }, constant(identity)), hr = createInverter(function(g, f, S) {
                    null != f && "function" != typeof f.toString && (f = Mt.call(f)), Rt.call(g, f) ? g[f].push(S) : g[f] = [
                        S
                    ];
                }, getIteratee), gr = baseRest(baseInvoke);
                function keys(g) {
                    return isArrayLike(g) ? arrayLikeKeys(g) : baseKeys(g);
                }
                function keysIn(g) {
                    return isArrayLike(g) ? arrayLikeKeys(g, !0) : baseKeysIn(g);
                }
                function mapKeys(g, f) {
                    var S = {};
                    return f = getIteratee(f, 3), baseForOwn(g, function(g, v, _) {
                        baseAssignValue(S, f(g, v, _), g);
                    }), S;
                }
                function mapValues(g, f) {
                    var S = {};
                    return f = getIteratee(f, 3), baseForOwn(g, function(g, v, _) {
                        baseAssignValue(S, v, f(g, v, _));
                    }), S;
                }
                var pr = createAssigner(function(g, f, S) {
                    baseMerge(g, f, S);
                }), mr = createAssigner(function(g, f, S, v) {
                    baseMerge(g, f, S, v);
                }), fr = flatRest(function(g, f) {
                    var S = {};
                    if (null == g) return S;
                    var v = !1;
                    f = arrayMap(f, function(f) {
                        return f = castPath(f, g), v || (v = f.length > 1), f;
                    }), copyObject(g, getAllKeysIn(g), S), v && (S = baseClone(S, P | w | M, customOmitClone));
                    for(var _ = f.length; _--;)baseUnset(S, f[_]);
                    return S;
                });
                function omitBy(g, f) {
                    return pickBy(g, negate(getIteratee(f)));
                }
                var Sr = flatRest(function(g, f) {
                    return null == g ? {} : basePick(g, f);
                });
                function pickBy(g, f) {
                    if (null == g) return {};
                    var S = arrayMap(getAllKeysIn(g), function(g) {
                        return [
                            g
                        ];
                    });
                    return f = getIteratee(f), basePickBy(g, S, function(g, S) {
                        return f(g, S[0]);
                    });
                }
                function result(g, f, v) {
                    var _ = -1, C = (f = castPath(f, g)).length;
                    for(C || (C = 1, g = S); ++_ < C;){
                        var E = null == g ? S : g[toKey(f[_])];
                        E === S && (_ = C, E = v), g = isFunction(E) ? E.call(g) : E;
                    }
                    return g;
                }
                function set(g, f, S) {
                    return null == g ? g : baseSet(g, f, S);
                }
                function setWith(g, f, v, _) {
                    return _ = "function" == typeof _ ? _ : S, null == g ? g : baseSet(g, f, v, _);
                }
                var vr = createToPairs(keys), _r = createToPairs(keysIn);
                function transform(g, f, S) {
                    var v = Kn(g), _ = v || Yn(g) || tr(g);
                    if (f = getIteratee(f, 4), null == S) {
                        var C = g && g.constructor;
                        S = _ ? v ? new C : [] : isObject(g) && isFunction(C) ? Gi(Ut(g)) : {};
                    }
                    return (_ ? arrayEach : baseForOwn)(g, function(g, v, _) {
                        return f(S, g, v, _);
                    }), S;
                }
                function unset(g, f) {
                    return null == g || baseUnset(g, f);
                }
                function update(g, f, S) {
                    return null == g ? g : baseUpdate(g, f, castFunction(S));
                }
                function updateWith(g, f, v, _) {
                    return _ = "function" == typeof _ ? _ : S, null == g ? g : baseUpdate(g, f, castFunction(v), _);
                }
                function values(g) {
                    return null == g ? [] : baseValues(g, keys(g));
                }
                function valuesIn(g) {
                    return null == g ? [] : baseValues(g, keysIn(g));
                }
                function clamp(g, f, v) {
                    return v === S && (v = f, f = S), v !== S && (v = (v = toNumber(v)) == v ? v : 0), f !== S && (f = (f = toNumber(f)) == f ? f : 0), baseClamp(toNumber(g), f, v);
                }
                function inRange(g, f, v) {
                    return f = toFinite(f), v === S ? (v = f, f = 0) : v = toFinite(v), baseInRange(g = toNumber(g), f, v);
                }
                function random(g, f, v) {
                    if (v && "boolean" != typeof v && isIterateeCall(g, f, v) && (f = v = S), v === S && ("boolean" == typeof f ? (v = f, f = S) : "boolean" == typeof g && (v = g, g = S)), g === S && f === S ? (g = 0, f = 1) : (g = toFinite(g), f === S ? (f = g, g = 0) : f = toFinite(f)), g > f) {
                        var _ = g;
                        g = f, f = _;
                    }
                    if (v || g % 1 || f % 1) {
                        var C = fi();
                        return ui(g + C * (f - g + li("1e-" + ((C + "").length - 1))), f);
                    }
                    return baseRandom(g, f);
                }
                var Cr = createCompounder(function(g, f, S) {
                    return f = f.toLowerCase(), g + (S ? capitalize(f) : f);
                });
                function capitalize(g) {
                    return Rr(toString(g).toLowerCase());
                }
                function deburr(g) {
                    return (g = toString(g)) && g.replace(gt, bi).replace(Jt, "");
                }
                function endsWith(g, f, v) {
                    g = toString(g), f = baseToString(f);
                    var _ = g.length, C = v = v === S ? _ : baseClamp(toInteger(v), 0, _);
                    return (v -= f.length) >= 0 && g.slice(v, C) == f;
                }
                function escape1(g) {
                    return (g = toString(g)) && je.test(g) ? g.replace(He, Ai) : g;
                }
                function escapeRegExp(g) {
                    return (g = toString(g)) && Qe.test(g) ? g.replace(Ye, "\\$&") : g;
                }
                var yr = createCompounder(function(g, f, S) {
                    return g + (S ? "-" : "") + f.toLowerCase();
                }), Er = createCompounder(function(g, f, S) {
                    return g + (S ? " " : "") + f.toLowerCase();
                }), Tr = createCaseFirst("toLowerCase");
                function pad(g, f, S) {
                    g = toString(g);
                    var v = (f = toInteger(f)) ? stringSize(g) : 0;
                    if (!f || v >= f) return g;
                    var _ = (f - v) / 2;
                    return createPadding(Xt(_), S) + g + createPadding(Qt(_), S);
                }
                function padEnd(g, f, S) {
                    g = toString(g);
                    var v = (f = toInteger(f)) ? stringSize(g) : 0;
                    return f && v < f ? g + createPadding(f - v, S) : g;
                }
                function padStart(g, f, S) {
                    g = toString(g);
                    var v = (f = toInteger(f)) ? stringSize(g) : 0;
                    return f && v < f ? createPadding(f - v, S) + g : g;
                }
                function parseInt1(g, f, S) {
                    return S || null == f ? f = 0 : f && (f = +f), pi(toString(g).replace(Xe, ""), f || 0);
                }
                function repeat(g, f, v) {
                    return f = (v ? isIterateeCall(g, f, v) : f === S) ? 1 : toInteger(f), baseRepeat(toString(g), f);
                }
                function replace() {
                    var g = arguments, f = toString(g[0]);
                    return g.length < 3 ? f : f.replace(g[1], g[2]);
                }
                var Ir = createCompounder(function(g, f, S) {
                    return g + (S ? "_" : "") + f.toLowerCase();
                });
                function split(g, f, v) {
                    return v && "number" != typeof v && isIterateeCall(g, f, v) && (f = v = S), (v = v === S ? ee : v >>> 0) ? (g = toString(g)) && ("string" == typeof f || null != f && !Zn(f)) && !(f = baseToString(f)) && hasUnicode(g) ? castSlice(stringToArray(g), 0, v) : g.split(f, v) : [];
                }
                var br = createCompounder(function(g, f, S) {
                    return g + (S ? " " : "") + Rr(f);
                });
                function startsWith(g, f, S) {
                    return g = toString(g), S = null == S ? 0 : baseClamp(toInteger(S), 0, g.length), f = baseToString(f), g.slice(S, S + f.length) == f;
                }
                function template(g, f, v) {
                    var _ = lodash.templateSettings;
                    v && isIterateeCall(g, f, v) && (f = S), g = toString(g), f = sr({}, f, _, customDefaultsAssignIn);
                    var C, E, T = sr({}, f.imports, _.imports, customDefaultsAssignIn), b = keys(T), A = baseValues(T, b), R = 0, P = f.interpolate || pt, w = "__p += '", M = _t((f.escape || pt).source + "|" + P.source + "|" + (P === We ? st : pt).source + "|" + (f.evaluate || pt).source + "|$", "g"), O = "//# sourceURL=" + (Rt.call(f, "sourceURL") ? (f.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ti + "]") + "\n";
                    g.replace(M, function(f, S, v, _, T, I) {
                        return v || (v = _), w += g.slice(R, I).replace(mt, escapeStringChar), S && (C = !0, w += "' +\n__e(" + S + ") +\n'"), T && (E = !0, w += "';\n" + T + ";\n__p += '"), v && (w += "' +\n((__t = (" + v + ")) == null ? '' : __t) +\n'"), R = I + f.length, f;
                    }), w += "';\n";
                    var D = Rt.call(f, "variable") && f.variable;
                    if (D) {
                        if (rt.test(D)) throw new nt(I);
                    } else w = "with (obj) {\n" + w + "\n}\n";
                    w = (E ? w.replace(xe, "") : w).replace(Ue, "$1").replace(Ve, "$1;"), w = "function(" + (D || "obj") + ") {\n" + (D ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (E ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + w + "return __p\n}";
                    var N = Pr(function() {
                        return ft(b, O + "return " + w).apply(S, A);
                    });
                    if (N.source = w, isError(N)) throw N;
                    return N;
                }
                function toLower(g) {
                    return toString(g).toLowerCase();
                }
                function toUpper(g) {
                    return toString(g).toUpperCase();
                }
                function trim(g, f, v) {
                    if ((g = toString(g)) && (v || f === S)) return baseTrim(g);
                    if (!g || !(f = baseToString(f))) return g;
                    var _ = stringToArray(g), C = stringToArray(f);
                    return castSlice(_, charsStartIndex(_, C), charsEndIndex(_, C) + 1).join("");
                }
                function trimEnd(g, f, v) {
                    if ((g = toString(g)) && (v || f === S)) return g.slice(0, trimmedEndIndex(g) + 1);
                    if (!g || !(f = baseToString(f))) return g;
                    var _ = stringToArray(g);
                    return castSlice(_, 0, charsEndIndex(_, stringToArray(f)) + 1).join("");
                }
                function trimStart(g, f, v) {
                    if ((g = toString(g)) && (v || f === S)) return g.replace(Xe, "");
                    if (!g || !(f = baseToString(f))) return g;
                    var _ = stringToArray(g);
                    return castSlice(_, charsStartIndex(_, stringToArray(f))).join("");
                }
                function truncate(g, f) {
                    var v = j, _ = G;
                    if (isObject(f)) {
                        var C = "separator" in f ? f.separator : C;
                        v = "length" in f ? toInteger(f.length) : v, _ = "omission" in f ? baseToString(f.omission) : _;
                    }
                    var E = (g = toString(g)).length;
                    if (hasUnicode(g)) {
                        var T = stringToArray(g);
                        E = T.length;
                    }
                    if (v >= E) return g;
                    var I = v - stringSize(_);
                    if (I < 1) return _;
                    var b = T ? castSlice(T, 0, I).join("") : g.slice(0, I);
                    if (C === S) return b + _;
                    if (T && (I += b.length - I), Zn(C)) {
                        if (g.slice(I).search(C)) {
                            var A, R = b;
                            for(C.global || (C = _t(C.source, toString(ot.exec(C)) + "g")), C.lastIndex = 0; A = C.exec(R);)var P = A.index;
                            b = b.slice(0, P === S ? I : P);
                        }
                    } else if (g.indexOf(baseToString(C), I) != I) {
                        var w = b.lastIndexOf(C);
                        w > -1 && (b = b.slice(0, w));
                    }
                    return b + _;
                }
                function unescape1(g) {
                    return (g = toString(g)) && $e.test(g) ? g.replace(Be, Ri) : g;
                }
                var Ar = createCompounder(function(g, f, S) {
                    return g + (S ? " " : "") + f.toUpperCase();
                }), Rr = createCaseFirst("toUpperCase");
                function words(g, f, v) {
                    return g = toString(g), (f = v ? S : f) === S ? hasUnicodeWord(g) ? unicodeWords(g) : asciiWords(g) : g.match(f) || [];
                }
                var Pr = baseRest(function(g, f) {
                    try {
                        return apply(g, S, f);
                    } catch (g) {
                        return isError(g) ? g : new nt(g);
                    }
                }), wr = flatRest(function(g, f) {
                    return arrayEach(f, function(f) {
                        f = toKey(f), baseAssignValue(g, f, xn(g[f], g));
                    }), g;
                });
                function cond(g) {
                    var f = null == g ? 0 : g.length, S = getIteratee();
                    return g = f ? arrayMap(g, function(g) {
                        if ("function" != typeof g[1]) throw new yt(T);
                        return [
                            S(g[0]),
                            g[1]
                        ];
                    }) : [], baseRest(function(S) {
                        for(var v = -1; ++v < f;){
                            var _ = g[v];
                            if (apply(_[0], this, S)) return apply(_[1], this, S);
                        }
                    });
                }
                function conforms(g) {
                    return baseConforms(baseClone(g, P));
                }
                function constant(g) {
                    return function() {
                        return g;
                    };
                }
                function defaultTo(g, f) {
                    return null == g || g != g ? f : g;
                }
                var Mr = createFlow(), Or = createFlow(!0);
                function identity(g) {
                    return g;
                }
                function iteratee(g) {
                    return baseIteratee("function" == typeof g ? g : baseClone(g, P));
                }
                function matches(g) {
                    return baseMatches(baseClone(g, P));
                }
                function matchesProperty(g, f) {
                    return baseMatchesProperty(g, baseClone(f, P));
                }
                var Dr = baseRest(function(g, f) {
                    return function(S) {
                        return baseInvoke(S, g, f);
                    };
                }), Nr = baseRest(function(g, f) {
                    return function(S) {
                        return baseInvoke(g, S, f);
                    };
                });
                function mixin(g, f, S) {
                    var v = keys(f), _ = baseFunctions(f, v);
                    null != S || isObject(f) && (_.length || !v.length) || (S = f, f = g, g = this, _ = baseFunctions(f, keys(f)));
                    var C = !(isObject(S) && "chain" in S && !S.chain), E = isFunction(g);
                    return arrayEach(_, function(S) {
                        var v = f[S];
                        g[S] = v, E && (g.prototype[S] = function() {
                            var f = this.__chain__;
                            if (C || f) {
                                var S = g(this.__wrapped__);
                                return (S.__actions__ = copyArray(this.__actions__)).push({
                                    func: v,
                                    args: arguments,
                                    thisArg: g
                                }), S.__chain__ = f, S;
                            }
                            return v.apply(g, arrayPush([
                                this.value()
                            ], arguments));
                        });
                    }), g;
                }
                function noConflict() {
                    return hi._ === this && (hi._ = Dt), this;
                }
                function noop() {}
                function nthArg(g) {
                    return g = toInteger(g), baseRest(function(f) {
                        return baseNth(f, g);
                    });
                }
                var kr = createOver(arrayMap), Lr = createOver(arrayEvery), Fr = createOver(arraySome);
                function property(g) {
                    return isKey(g) ? baseProperty(toKey(g)) : basePropertyDeep(g);
                }
                function propertyOf(g) {
                    return function(f) {
                        return null == g ? S : baseGet(g, f);
                    };
                }
                var xr = createRange(), Ur = createRange(!0);
                function stubArray() {
                    return [];
                }
                function stubFalse() {
                    return !1;
                }
                function stubObject() {
                    return {};
                }
                function stubString() {
                    return "";
                }
                function stubTrue() {
                    return !0;
                }
                function times(g, f) {
                    if ((g = toInteger(g)) < 1 || g > Q) return [];
                    var S = ee, v = ui(g, ee);
                    f = getIteratee(f), g -= ee;
                    for(var _ = baseTimes(v, f); ++S < g;)f(S);
                    return _;
                }
                function toPath(g) {
                    return Kn(g) ? arrayMap(g, toKey) : isSymbol(g) ? [
                        g
                    ] : copyArray(cn(toString(g)));
                }
                function uniqueId(g) {
                    var f = ++Pt;
                    return toString(g) + f;
                }
                var Vr = createMathOperation(function(g, f) {
                    return g + f;
                }, 0), Br = createRound("ceil"), Hr = createMathOperation(function(g, f) {
                    return g / f;
                }, 1), $r = createRound("floor");
                function max(g) {
                    return g && g.length ? baseExtremum(g, identity, baseGt) : S;
                }
                function maxBy(g, f) {
                    return g && g.length ? baseExtremum(g, getIteratee(f, 2), baseGt) : S;
                }
                function mean(g) {
                    return baseMean(g, identity);
                }
                function meanBy(g, f) {
                    return baseMean(g, getIteratee(f, 2));
                }
                function min(g) {
                    return g && g.length ? baseExtremum(g, identity, baseLt) : S;
                }
                function minBy(g, f) {
                    return g && g.length ? baseExtremum(g, getIteratee(f, 2), baseLt) : S;
                }
                var jr, Gr = createMathOperation(function(g, f) {
                    return g * f;
                }, 1), qr = createRound("round"), Wr = createMathOperation(function(g, f) {
                    return g - f;
                }, 0);
                function sum(g) {
                    return g && g.length ? baseSum(g, identity) : 0;
                }
                function sumBy(g, f) {
                    return g && g.length ? baseSum(g, getIteratee(f, 2)) : 0;
                }
                return lodash.after = after, lodash.ary = ary, lodash.assign = rr, lodash.assignIn = ar, lodash.assignInWith = sr, lodash.assignWith = or, lodash.at = lr, lodash.before = before, lodash.bind = xn, lodash.bindAll = wr, lodash.bindKey = Un, lodash.castArray = castArray, lodash.chain = chain, lodash.chunk = chunk, lodash.compact = compact, lodash.concat = concat, lodash.cond = cond, lodash.conforms = conforms, lodash.constant = constant, lodash.countBy = Pn, lodash.create = create, lodash.curry = curry, lodash.curryRight = curryRight, lodash.debounce = debounce, lodash.defaults = cr, lodash.defaultsDeep = dr, lodash.defer = Vn, lodash.delay = Bn, lodash.difference = dn, lodash.differenceBy = un, lodash.differenceWith = hn, lodash.drop = drop, lodash.dropRight = dropRight, lodash.dropRightWhile = dropRightWhile, lodash.dropWhile = dropWhile, lodash.fill = fill, lodash.filter = filter, lodash.flatMap = flatMap, lodash.flatMapDeep = flatMapDeep, lodash.flatMapDepth = flatMapDepth, lodash.flatten = flatten, lodash.flattenDeep = flattenDeep, lodash.flattenDepth = flattenDepth, lodash.flip = flip, lodash.flow = Mr, lodash.flowRight = Or, lodash.fromPairs = fromPairs, lodash.functions = functions, lodash.functionsIn = functionsIn, lodash.groupBy = On, lodash.initial = initial, lodash.intersection = gn, lodash.intersectionBy = pn, lodash.intersectionWith = mn, lodash.invert = ur, lodash.invertBy = hr, lodash.invokeMap = Dn, lodash.iteratee = iteratee, lodash.keyBy = Nn, lodash.keys = keys, lodash.keysIn = keysIn, lodash.map = map, lodash.mapKeys = mapKeys, lodash.mapValues = mapValues, lodash.matches = matches, lodash.matchesProperty = matchesProperty, lodash.memoize = memoize, lodash.merge = pr, lodash.mergeWith = mr, lodash.method = Dr, lodash.methodOf = Nr, lodash.mixin = mixin, lodash.negate = negate, lodash.nthArg = nthArg, lodash.omit = fr, lodash.omitBy = omitBy, lodash.once = once, lodash.orderBy = orderBy, lodash.over = kr, lodash.overArgs = Hn, lodash.overEvery = Lr, lodash.overSome = Fr, lodash.partial = $n, lodash.partialRight = jn, lodash.partition = kn, lodash.pick = Sr, lodash.pickBy = pickBy, lodash.property = property, lodash.propertyOf = propertyOf, lodash.pull = fn, lodash.pullAll = pullAll, lodash.pullAllBy = pullAllBy, lodash.pullAllWith = pullAllWith, lodash.pullAt = Sn, lodash.range = xr, lodash.rangeRight = Ur, lodash.rearg = Gn, lodash.reject = reject, lodash.remove = remove, lodash.rest = rest, lodash.reverse = reverse, lodash.sampleSize = sampleSize, lodash.set = set, lodash.setWith = setWith, lodash.shuffle = shuffle, lodash.slice = slice, lodash.sortBy = Ln, lodash.sortedUniq = sortedUniq, lodash.sortedUniqBy = sortedUniqBy, lodash.split = split, lodash.spread = spread, lodash.tail = tail, lodash.take = take, lodash.takeRight = takeRight, lodash.takeRightWhile = takeRightWhile, lodash.takeWhile = takeWhile, lodash.tap = tap, lodash.throttle = throttle, lodash.thru = thru, lodash.toArray = toArray, lodash.toPairs = vr, lodash.toPairsIn = _r, lodash.toPath = toPath, lodash.toPlainObject = toPlainObject, lodash.transform = transform, lodash.unary = unary, lodash.union = vn, lodash.unionBy = _n, lodash.unionWith = Cn, lodash.uniq = uniq, lodash.uniqBy = uniqBy, lodash.uniqWith = uniqWith, lodash.unset = unset, lodash.unzip = unzip, lodash.unzipWith = unzipWith, lodash.update = update, lodash.updateWith = updateWith, lodash.values = values, lodash.valuesIn = valuesIn, lodash.without = yn, lodash.words = words, lodash.wrap = wrap, lodash.xor = En, lodash.xorBy = Tn, lodash.xorWith = In, lodash.zip = bn, lodash.zipObject = zipObject, lodash.zipObjectDeep = zipObjectDeep, lodash.zipWith = An, lodash.entries = vr, lodash.entriesIn = _r, lodash.extend = ar, lodash.extendWith = sr, mixin(lodash, lodash), lodash.add = Vr, lodash.attempt = Pr, lodash.camelCase = Cr, lodash.capitalize = capitalize, lodash.ceil = Br, lodash.clamp = clamp, lodash.clone = clone, lodash.cloneDeep = cloneDeep, lodash.cloneDeepWith = cloneDeepWith, lodash.cloneWith = cloneWith, lodash.conformsTo = conformsTo, lodash.deburr = deburr, lodash.defaultTo = defaultTo, lodash.divide = Hr, lodash.endsWith = endsWith, lodash.eq = eq, lodash.escape = escape1, lodash.escapeRegExp = escapeRegExp, lodash.every = every, lodash.find = wn, lodash.findIndex = findIndex, lodash.findKey = findKey, lodash.findLast = Mn, lodash.findLastIndex = findLastIndex, lodash.findLastKey = findLastKey, lodash.floor = $r, lodash.forEach = forEach, lodash.forEachRight = forEachRight, lodash.forIn = forIn, lodash.forInRight = forInRight, lodash.forOwn = forOwn, lodash.forOwnRight = forOwnRight, lodash.get = get, lodash.gt = qn, lodash.gte = Wn, lodash.has = has, lodash.hasIn = hasIn, lodash.head = head, lodash.identity = identity, lodash.includes = includes, lodash.indexOf = indexOf, lodash.inRange = inRange, lodash.invoke = gr, lodash.isArguments = zn, lodash.isArray = Kn, lodash.isArrayBuffer = Jn, lodash.isArrayLike = isArrayLike, lodash.isArrayLikeObject = isArrayLikeObject, lodash.isBoolean = isBoolean, lodash.isBuffer = Yn, lodash.isDate = Qn, lodash.isElement = isElement, lodash.isEmpty = isEmpty, lodash.isEqual = isEqual, lodash.isEqualWith = isEqualWith, lodash.isError = isError, lodash.isFinite = isFinite1, lodash.isFunction = isFunction, lodash.isInteger = isInteger, lodash.isLength = isLength, lodash.isMap = Xn, lodash.isMatch = isMatch, lodash.isMatchWith = isMatchWith, lodash.isNaN = isNaN1, lodash.isNative = isNative, lodash.isNil = isNil, lodash.isNull = isNull, lodash.isNumber = isNumber, lodash.isObject = isObject, lodash.isObjectLike = isObjectLike, lodash.isPlainObject = isPlainObject, lodash.isRegExp = Zn, lodash.isSafeInteger = isSafeInteger, lodash.isSet = er, lodash.isString = isString, lodash.isSymbol = isSymbol, lodash.isTypedArray = tr, lodash.isUndefined = isUndefined, lodash.isWeakMap = isWeakMap, lodash.isWeakSet = isWeakSet, lodash.join = join, lodash.kebabCase = yr, lodash.last = last, lodash.lastIndexOf = lastIndexOf, lodash.lowerCase = Er, lodash.lowerFirst = Tr, lodash.lt = ir, lodash.lte = nr, lodash.max = max, lodash.maxBy = maxBy, lodash.mean = mean, lodash.meanBy = meanBy, lodash.min = min, lodash.minBy = minBy, lodash.stubArray = stubArray, lodash.stubFalse = stubFalse, lodash.stubObject = stubObject, lodash.stubString = stubString, lodash.stubTrue = stubTrue, lodash.multiply = Gr, lodash.nth = nth, lodash.noConflict = noConflict, lodash.noop = noop, lodash.now = Fn, lodash.pad = pad, lodash.padEnd = padEnd, lodash.padStart = padStart, lodash.parseInt = parseInt1, lodash.random = random, lodash.reduce = reduce, lodash.reduceRight = reduceRight, lodash.repeat = repeat, lodash.replace = replace, lodash.result = result, lodash.round = qr, lodash.runInContext = runInContext, lodash.sample = sample, lodash.size = size, lodash.snakeCase = Ir, lodash.some = some, lodash.sortedIndex = sortedIndex, lodash.sortedIndexBy = sortedIndexBy, lodash.sortedIndexOf = sortedIndexOf, lodash.sortedLastIndex = sortedLastIndex, lodash.sortedLastIndexBy = sortedLastIndexBy, lodash.sortedLastIndexOf = sortedLastIndexOf, lodash.startCase = br, lodash.startsWith = startsWith, lodash.subtract = Wr, lodash.sum = sum, lodash.sumBy = sumBy, lodash.template = template, lodash.times = times, lodash.toFinite = toFinite, lodash.toInteger = toInteger, lodash.toLength = toLength, lodash.toLower = toLower, lodash.toNumber = toNumber, lodash.toSafeInteger = toSafeInteger, lodash.toString = toString, lodash.toUpper = toUpper, lodash.trim = trim, lodash.trimEnd = trimEnd, lodash.trimStart = trimStart, lodash.truncate = truncate, lodash.unescape = unescape1, lodash.uniqueId = uniqueId, lodash.upperCase = Ar, lodash.upperFirst = Rr, lodash.each = forEach, lodash.eachRight = forEachRight, lodash.first = head, mixin(lodash, (jr = {}, baseForOwn(lodash, function(g, f) {
                    Rt.call(lodash.prototype, f) || (jr[f] = g);
                }), jr), {
                    chain: !1
                }), lodash.VERSION = v, arrayEach([
                    "bind",
                    "bindKey",
                    "curry",
                    "curryRight",
                    "partial",
                    "partialRight"
                ], function(g) {
                    lodash[g].placeholder = lodash;
                }), arrayEach([
                    "drop",
                    "take"
                ], function(g, f) {
                    LazyWrapper.prototype[g] = function(v) {
                        v = v === S ? 1 : di(toInteger(v), 0);
                        var _ = this.__filtered__ && !f ? new LazyWrapper(this) : this.clone();
                        return _.__filtered__ ? _.__takeCount__ = ui(v, _.__takeCount__) : _.__views__.push({
                            size: ui(v, ee),
                            type: g + (_.__dir__ < 0 ? "Right" : "")
                        }), _;
                    }, LazyWrapper.prototype[g + "Right"] = function(f) {
                        return this.reverse()[g](f).reverse();
                    };
                }), arrayEach([
                    "filter",
                    "map",
                    "takeWhile"
                ], function(g, f) {
                    var S = f + 1, v = S == z || S == J;
                    LazyWrapper.prototype[g] = function(g) {
                        var f = this.clone();
                        return f.__iteratees__.push({
                            iteratee: getIteratee(g, 3),
                            type: S
                        }), f.__filtered__ = f.__filtered__ || v, f;
                    };
                }), arrayEach([
                    "head",
                    "last"
                ], function(g, f) {
                    var S = "take" + (f ? "Right" : "");
                    LazyWrapper.prototype[g] = function() {
                        return this[S](1).value()[0];
                    };
                }), arrayEach([
                    "initial",
                    "tail"
                ], function(g, f) {
                    var S = "drop" + (f ? "" : "Right");
                    LazyWrapper.prototype[g] = function() {
                        return this.__filtered__ ? new LazyWrapper(this) : this[S](1);
                    };
                }), LazyWrapper.prototype.compact = function() {
                    return this.filter(identity);
                }, LazyWrapper.prototype.find = function(g) {
                    return this.filter(g).head();
                }, LazyWrapper.prototype.findLast = function(g) {
                    return this.reverse().find(g);
                }, LazyWrapper.prototype.invokeMap = baseRest(function(g, f) {
                    return "function" == typeof g ? new LazyWrapper(this) : this.map(function(S) {
                        return baseInvoke(S, g, f);
                    });
                }), LazyWrapper.prototype.reject = function(g) {
                    return this.filter(negate(getIteratee(g)));
                }, LazyWrapper.prototype.slice = function(g, f) {
                    g = toInteger(g);
                    var v = this;
                    return v.__filtered__ && (g > 0 || f < 0) ? new LazyWrapper(v) : (g < 0 ? v = v.takeRight(-g) : g && (v = v.drop(g)), f !== S && (v = (f = toInteger(f)) < 0 ? v.dropRight(-f) : v.take(f - g)), v);
                }, LazyWrapper.prototype.takeRightWhile = function(g) {
                    return this.reverse().takeWhile(g).reverse();
                }, LazyWrapper.prototype.toArray = function() {
                    return this.take(ee);
                }, baseForOwn(LazyWrapper.prototype, function(g, f) {
                    var v = /^(?:filter|find|map|reject)|While$/.test(f), _ = /^(?:head|last)$/.test(f), C = lodash[_ ? "take" + ("last" == f ? "Right" : "") : f], E = _ || /^find/.test(f);
                    C && (lodash.prototype[f] = function() {
                        var f = this.__wrapped__, T = _ ? [
                            1
                        ] : arguments, I = f instanceof LazyWrapper, b = T[0], A = I || Kn(f), interceptor = function(g) {
                            var f = C.apply(lodash, arrayPush([
                                g
                            ], T));
                            return _ && R ? f[0] : f;
                        };
                        A && v && "function" == typeof b && 1 != b.length && (I = A = !1);
                        var R = this.__chain__, P = !!this.__actions__.length, w = E && !R, M = I && !P;
                        if (!E && A) {
                            f = M ? f : new LazyWrapper(this);
                            var O = g.apply(f, T);
                            return O.__actions__.push({
                                func: thru,
                                args: [
                                    interceptor
                                ],
                                thisArg: S
                            }), new LodashWrapper(O, R);
                        }
                        return w && M ? g.apply(this, T) : (O = this.thru(interceptor), w ? _ ? O.value()[0] : O.value() : O);
                    });
                }), arrayEach([
                    "pop",
                    "push",
                    "shift",
                    "sort",
                    "splice",
                    "unshift"
                ], function(g) {
                    var f = Et[g], S = /^(?:push|sort|unshift)$/.test(g) ? "tap" : "thru", v = /^(?:pop|shift)$/.test(g);
                    lodash.prototype[g] = function() {
                        var g = arguments;
                        if (v && !this.__chain__) {
                            var _ = this.value();
                            return f.apply(Kn(_) ? _ : [], g);
                        }
                        return this[S](function(S) {
                            return f.apply(Kn(S) ? S : [], g);
                        });
                    };
                }), baseForOwn(LazyWrapper.prototype, function(g, f) {
                    var S = lodash[f];
                    if (S) {
                        var v = S.name + "";
                        Rt.call(Li, v) || (Li[v] = []), Li[v].push({
                            name: f,
                            func: S
                        });
                    }
                }), Li[createHybrid(S, k).name] = [
                    {
                        name: "wrapper",
                        func: S
                    }
                ], LazyWrapper.prototype.clone = lazyClone, LazyWrapper.prototype.reverse = lazyReverse, LazyWrapper.prototype.value = lazyValue, lodash.prototype.at = Rn, lodash.prototype.chain = wrapperChain, lodash.prototype.commit = wrapperCommit, lodash.prototype.next = wrapperNext, lodash.prototype.plant = wrapperPlant, lodash.prototype.reverse = wrapperReverse, lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue, lodash.prototype.first = lodash.prototype.head, jt && (lodash.prototype[jt] = wrapperToIterator), lodash;
            }, wi = Pi();
            pi ? ((pi.exports = wi)._ = wi, gi._ = wi) : hi._ = wi;
        }).call(_);
    }), w = createCommonjsModule(function(g, f) {
        var S = window;
        !function(f, S) {
            g.exports = S(R, P);
        }(0, (g, f)=>{
            var _window_performance, _window, _window_performance1, _window1, _navigator_mediaDevices;
            var v = {}, _ = {
                exports: v
            }, C = Object.create, E = Object.defineProperty, T = Object.getOwnPropertyDescriptor, I = Object.getOwnPropertyNames, b = Object.getPrototypeOf, A = Object.prototype.hasOwnProperty, __commonJS = (g, f)=>function __require() {
                    return f || (0, g[I(g)[0]])((f = {
                        exports: {}
                    }).exports, f), f.exports;
                }, __export = (g, f)=>{
                for(var S in f)E(g, S, {
                    get: f[S],
                    enumerable: !0
                });
            }, __copyProps = (g, f, S, v)=>{
                if (f && "object" == typeof f || "function" == typeof f) for (let _ of I(f))A.call(g, _) || _ === S || E(g, _, {
                    get: ()=>f[_],
                    enumerable: !(v = T(f, _)) || v.enumerable
                });
                return g;
            }, __toESM = (g, f, S)=>(S = null != g ? C(b(g)) : {}, __copyProps(!f && g && g.__esModule ? S : E(S, "default", {
                    value: g,
                    enumerable: !0
                }), g)), __toCommonJS = (g)=>__copyProps(E({}, "__esModule", {
                    value: !0
                }), g), __decorateClass = (g, f, S, v)=>{
                for(var _, C = v > 1 ? void 0 : v ? T(f, S) : f, I = g.length - 1; I >= 0; I--)(_ = g[I]) && (C = (v ? _(f, S, C) : _(C)) || C);
                return v && C && E(f, S, C), C;
            }, __decorateParam = (g, f)=>(S, v)=>f(S, v, g), w = __commonJS({
                "../node_modules/axios/lib/helpers/bind.js" (g, f) {
                    f.exports = function bind(g, f) {
                        return function wrap() {
                            for(var S = new Array(arguments.length), v = 0; v < S.length; v++)S[v] = arguments[v];
                            return g.apply(f, S);
                        };
                    };
                }
            }), M = __commonJS({
                "../node_modules/axios/lib/utils.js" (g, f) {
                    var S = w(), v = Object.prototype.toString;
                    function isArray4(g) {
                        return "[object Array]" === v.call(g);
                    }
                    function isUndefined7(g) {
                        return void 0 === g;
                    }
                    function isBuffer(g) {
                        return null !== g && !isUndefined7(g) && null !== g.constructor && !isUndefined7(g.constructor) && "function" == typeof g.constructor.isBuffer && g.constructor.isBuffer(g);
                    }
                    function isArrayBuffer(g) {
                        return "[object ArrayBuffer]" === v.call(g);
                    }
                    function isFormData(g) {
                        return "undefined" != typeof FormData && g instanceof FormData;
                    }
                    function isArrayBufferView(g) {
                        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(g) : g && g.buffer && g.buffer instanceof ArrayBuffer;
                    }
                    function isString3(g) {
                        return "string" == typeof g;
                    }
                    function isNumber5(g) {
                        return "number" == typeof g;
                    }
                    function isObject4(g) {
                        return null !== g && "object" == typeof g;
                    }
                    function isDate2(g) {
                        return "[object Date]" === v.call(g);
                    }
                    function isFile(g) {
                        return "[object File]" === v.call(g);
                    }
                    function isBlob(g) {
                        return "[object Blob]" === v.call(g);
                    }
                    function isFunction3(g) {
                        return "[object Function]" === v.call(g);
                    }
                    function isStream(g) {
                        return isObject4(g) && isFunction3(g.pipe);
                    }
                    function isURLSearchParams(g) {
                        return "undefined" != typeof URLSearchParams && g instanceof URLSearchParams;
                    }
                    function trim2(g) {
                        return g.replace(/^\s*/, "").replace(/\s*$/, "");
                    }
                    function isStandardBrowserEnv() {
                        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
                    }
                    function forEach3(g, f) {
                        if (null != g) {
                            if ("object" != typeof g && (g = [
                                g
                            ]), isArray4(g)) for(var S = 0, v = g.length; S < v; S++)f.call(null, g[S], S, g);
                            else for(var _ in g)Object.prototype.hasOwnProperty.call(g, _) && f.call(null, g[_], _, g);
                        }
                    }
                    function merge4() {
                        var g = {};
                        function assignValue(f, S) {
                            "object" == typeof g[S] && "object" == typeof f ? g[S] = merge4(g[S], f) : g[S] = f;
                        }
                        for(var f = 0, S = arguments.length; f < S; f++)forEach3(arguments[f], assignValue);
                        return g;
                    }
                    function deepMerge() {
                        var g = {};
                        function assignValue(f, S) {
                            "object" == typeof g[S] && "object" == typeof f ? g[S] = deepMerge(g[S], f) : g[S] = "object" == typeof f ? deepMerge({}, f) : f;
                        }
                        for(var f = 0, S = arguments.length; f < S; f++)forEach3(arguments[f], assignValue);
                        return g;
                    }
                    function extend3(g, f, v) {
                        return forEach3(f, function assignValue(f, _) {
                            g[_] = v && "function" == typeof f ? S(f, v) : f;
                        }), g;
                    }
                    f.exports = {
                        isArray: isArray4,
                        isArrayBuffer: isArrayBuffer,
                        isBuffer: isBuffer,
                        isFormData: isFormData,
                        isArrayBufferView: isArrayBufferView,
                        isString: isString3,
                        isNumber: isNumber5,
                        isObject: isObject4,
                        isUndefined: isUndefined7,
                        isDate: isDate2,
                        isFile: isFile,
                        isBlob: isBlob,
                        isFunction: isFunction3,
                        isStream: isStream,
                        isURLSearchParams: isURLSearchParams,
                        isStandardBrowserEnv: isStandardBrowserEnv,
                        forEach: forEach3,
                        merge: merge4,
                        deepMerge: deepMerge,
                        extend: extend3,
                        trim: trim2
                    };
                }
            }), O = __commonJS({
                "../node_modules/axios/lib/helpers/buildURL.js" (g, f) {
                    var S = M();
                    function encode(g) {
                        return encodeURIComponent(g).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
                    }
                    f.exports = function buildURL(g, f, v) {
                        if (!f) return g;
                        var _;
                        if (v) _ = v(f);
                        else if (S.isURLSearchParams(f)) _ = f.toString();
                        else {
                            var C = [];
                            S.forEach(f, function serialize(g, f) {
                                null != g && (S.isArray(g) ? f += "[]" : g = [
                                    g
                                ], S.forEach(g, function parseValue(g) {
                                    S.isDate(g) ? g = g.toISOString() : S.isObject(g) && (g = JSON.stringify(g)), C.push(encode(f) + "=" + encode(g));
                                }));
                            }), _ = C.join("&");
                        }
                        if (_) {
                            var E = g.indexOf("#");
                            -1 !== E && (g = g.slice(0, E)), g += (-1 === g.indexOf("?") ? "?" : "&") + _;
                        }
                        return g;
                    };
                }
            }), D = __commonJS({
                "../node_modules/axios/lib/core/InterceptorManager.js" (g, f) {
                    var S = M();
                    function InterceptorManager() {
                        this.handlers = [];
                    }
                    InterceptorManager.prototype.use = function use(g, f) {
                        return this.handlers.push({
                            fulfilled: g,
                            rejected: f
                        }), this.handlers.length - 1;
                    }, InterceptorManager.prototype.eject = function eject(g) {
                        this.handlers[g] && (this.handlers[g] = null);
                    }, InterceptorManager.prototype.forEach = function forEach3(g) {
                        S.forEach(this.handlers, function forEachHandler(f) {
                            null !== f && g(f);
                        });
                    }, f.exports = InterceptorManager;
                }
            }), N = __commonJS({
                "../node_modules/axios/lib/core/transformData.js" (g, f) {
                    var S = M();
                    f.exports = function transformData(g, f, v) {
                        return S.forEach(v, function transform(S) {
                            g = S(g, f);
                        }), g;
                    };
                }
            }), k = __commonJS({
                "../node_modules/axios/lib/cancel/isCancel.js" (g, f) {
                    f.exports = function isCancel(g) {
                        return !(!g || !g.__CANCEL__);
                    };
                }
            }), L = __commonJS({
                "../node_modules/axios/lib/helpers/normalizeHeaderName.js" (g, f) {
                    var S = M();
                    f.exports = function normalizeHeaderName(g, f) {
                        S.forEach(g, function processHeader(S, v) {
                            v !== f && v.toUpperCase() === f.toUpperCase() && (g[f] = S, delete g[v]);
                        });
                    };
                }
            }), F = __commonJS({
                "../node_modules/axios/lib/core/enhanceError.js" (g, f) {
                    f.exports = function enhanceError(g, f, S, v, _) {
                        return g.config = f, S && (g.code = S), g.request = v, g.response = _, g.isAxiosError = !0, g.toJSON = function() {
                            return {
                                message: this.message,
                                name: this.name,
                                description: this.description,
                                number: this.number,
                                fileName: this.fileName,
                                lineNumber: this.lineNumber,
                                columnNumber: this.columnNumber,
                                stack: this.stack,
                                config: this.config,
                                code: this.code
                            };
                        }, g;
                    };
                }
            }), x = __commonJS({
                "../node_modules/axios/lib/core/createError.js" (g, f) {
                    var S = F();
                    f.exports = function createError(g, f, v, _, C) {
                        var E = new Error(g);
                        return S(E, f, v, _, C);
                    };
                }
            }), U = __commonJS({
                "../node_modules/axios/lib/core/settle.js" (g, f) {
                    var S = x();
                    f.exports = function settle(g, f, v) {
                        var _ = v.config.validateStatus;
                        !_ || _(v.status) ? g(v) : f(S("Request failed with status code " + v.status, v.config, null, v.request, v));
                    };
                }
            }), V = __commonJS({
                "../node_modules/axios/lib/helpers/isAbsoluteURL.js" (g, f) {
                    f.exports = function isAbsoluteURL(g) {
                        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(g);
                    };
                }
            }), B = __commonJS({
                "../node_modules/axios/lib/helpers/combineURLs.js" (g, f) {
                    f.exports = function combineURLs(g, f) {
                        return f ? g.replace(/\/+$/, "") + "/" + f.replace(/^\/+/, "") : g;
                    };
                }
            }), H = __commonJS({
                "../node_modules/axios/lib/core/buildFullPath.js" (g, f) {
                    var S = V(), v = B();
                    f.exports = function buildFullPath(g, f) {
                        return g && !S(f) ? v(g, f) : f;
                    };
                }
            }), $ = __commonJS({
                "../node_modules/axios/lib/helpers/parseHeaders.js" (g, f) {
                    var S = M(), v = [
                        "age",
                        "authorization",
                        "content-length",
                        "content-type",
                        "etag",
                        "expires",
                        "from",
                        "host",
                        "if-modified-since",
                        "if-unmodified-since",
                        "last-modified",
                        "location",
                        "max-forwards",
                        "proxy-authorization",
                        "referer",
                        "retry-after",
                        "user-agent"
                    ];
                    f.exports = function parseHeaders(g) {
                        var f, _, C, E = {};
                        return g ? (S.forEach(g.split("\n"), function parser(g) {
                            if (C = g.indexOf(":"), f = S.trim(g.substr(0, C)).toLowerCase(), _ = S.trim(g.substr(C + 1)), f) {
                                if (E[f] && v.indexOf(f) >= 0) return;
                                E[f] = "set-cookie" === f ? (E[f] ? E[f] : []).concat([
                                    _
                                ]) : E[f] ? E[f] + ", " + _ : _;
                            }
                        }), E) : E;
                    };
                }
            }), j = __commonJS({
                "../node_modules/axios/lib/helpers/isValidXss.js" (g, f) {
                    f.exports = function isValidXss(g) {
                        return /(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi.test(g);
                    };
                }
            }), G = __commonJS({
                "../node_modules/axios/lib/helpers/isURLSameOrigin.js" (g, f) {
                    var S = M(), v = j();
                    f.exports = S.isStandardBrowserEnv() ? function standardBrowserEnv() {
                        var g, f = /(msie|trident)/i.test(navigator.userAgent), _ = document.createElement("a");
                        function resolveURL(g) {
                            var S = g;
                            if (v(g)) throw new Error("URL contains XSS injection attempt");
                            return f && (_.setAttribute("href", S), S = _.href), _.setAttribute("href", S), {
                                href: _.href,
                                protocol: _.protocol ? _.protocol.replace(/:$/, "") : "",
                                host: _.host,
                                search: _.search ? _.search.replace(/^\?/, "") : "",
                                hash: _.hash ? _.hash.replace(/^#/, "") : "",
                                hostname: _.hostname,
                                port: _.port,
                                pathname: "/" === _.pathname.charAt(0) ? _.pathname : "/" + _.pathname
                            };
                        }
                        return g = resolveURL(window.location.href), function isURLSameOrigin(f) {
                            var v = S.isString(f) ? resolveURL(f) : f;
                            return v.protocol === g.protocol && v.host === g.host;
                        };
                    }() : function nonStandardBrowserEnv() {
                        return function isURLSameOrigin() {
                            return !0;
                        };
                    }();
                }
            }), q = __commonJS({
                "../node_modules/axios/lib/helpers/cookies.js" (g, f) {
                    var S = M();
                    f.exports = S.isStandardBrowserEnv() ? function standardBrowserEnv() {
                        return {
                            write: function write5(g, f, v, _, C, E) {
                                var T = [];
                                T.push(g + "=" + encodeURIComponent(f)), S.isNumber(v) && T.push("expires=" + new Date(v).toGMTString()), S.isString(_) && T.push("path=" + _), S.isString(C) && T.push("domain=" + C), !0 === E && T.push("secure"), document.cookie = T.join("; ");
                            },
                            read: function read(g) {
                                var f = document.cookie.match(new RegExp("(^|;\\s*)(" + g + ")=([^;]*)"));
                                return f ? decodeURIComponent(f[3]) : null;
                            },
                            remove: function remove6(g) {
                                this.write(g, "", Date.now() - 864e5);
                            }
                        };
                    }() : function nonStandardBrowserEnv() {
                        return {
                            write: function write5() {},
                            read: function read() {
                                return null;
                            },
                            remove: function remove6() {}
                        };
                    }();
                }
            }), W = __commonJS({
                "../node_modules/axios/lib/adapters/xhr.js" (g, f) {
                    var S = M(), v = U(), _ = O(), C = H(), E = $(), T = G(), I = x();
                    f.exports = function xhrAdapter(g) {
                        return new Promise(function dispatchXhrRequest(f, b) {
                            var A = g.data, R = g.headers;
                            S.isFormData(A) && delete R["Content-Type"];
                            var P = new XMLHttpRequest;
                            if (g.auth) {
                                var w = g.auth.username || "", M = g.auth.password || "";
                                R.Authorization = "Basic " + btoa(w + ":" + M);
                            }
                            var O = C(g.baseURL, g.url);
                            if (P.open(g.method.toUpperCase(), _(O, g.params, g.paramsSerializer), !0), P.timeout = g.timeout, P.onreadystatechange = function handleLoad() {
                                if (P && 4 === P.readyState && (0 !== P.status || P.responseURL && 0 === P.responseURL.indexOf("file:"))) {
                                    var S = "getAllResponseHeaders" in P ? E(P.getAllResponseHeaders()) : null, _ = {
                                        data: g.responseType && "text" !== g.responseType ? P.response : P.responseText,
                                        status: P.status,
                                        statusText: P.statusText,
                                        headers: S,
                                        config: g,
                                        request: P
                                    };
                                    v(f, b, _), P = null;
                                }
                            }, P.onabort = function handleAbort() {
                                P && (b(I("Request aborted", g, "ECONNABORTED", P)), P = null);
                            }, P.onerror = function handleError() {
                                b(I("Network Error", g, null, P)), P = null;
                            }, P.ontimeout = function handleTimeout() {
                                var f = "timeout of " + g.timeout + "ms exceeded";
                                g.timeoutErrorMessage && (f = g.timeoutErrorMessage), b(I(f, g, "ECONNABORTED", P)), P = null;
                            }, S.isStandardBrowserEnv()) {
                                var D = q(), N = (g.withCredentials || T(O)) && g.xsrfCookieName ? D.read(g.xsrfCookieName) : void 0;
                                N && (R[g.xsrfHeaderName] = N);
                            }
                            if ("setRequestHeader" in P && S.forEach(R, function setRequestHeader(g, f) {
                                void 0 === A && "content-type" === f.toLowerCase() ? delete R[f] : P.setRequestHeader(f, g);
                            }), S.isUndefined(g.withCredentials) || (P.withCredentials = !!g.withCredentials), g.responseType) try {
                                P.responseType = g.responseType;
                            } catch (f) {
                                if ("json" !== g.responseType) throw f;
                            }
                            "function" == typeof g.onDownloadProgress && P.addEventListener("progress", g.onDownloadProgress), "function" == typeof g.onUploadProgress && P.upload && P.upload.addEventListener("progress", g.onUploadProgress), g.cancelToken && g.cancelToken.promise.then(function onCanceled(g) {
                                P && (P.abort(), b(g), P = null);
                            }), void 0 === A && (A = null), P.send(A);
                        });
                    };
                }
            }), z = __commonJS({
                "../node_modules/axios/lib/defaults.js" (g, f) {
                    var S = M(), v = L(), _ = {
                        "Content-Type": "application/x-www-form-urlencoded"
                    };
                    function setContentTypeIfUnset(g, f) {
                        !S.isUndefined(g) && S.isUndefined(g["Content-Type"]) && (g["Content-Type"] = f);
                    }
                    function getDefaultAdapter() {
                        var g;
                        return ("undefined" != typeof XMLHttpRequest || "undefined" != typeof $lUPho && "[object process]" === Object.prototype.toString.call($lUPho)) && (g = W()), g;
                    }
                    var C = {
                        adapter: getDefaultAdapter(),
                        transformRequest: [
                            function transformRequest(g, f) {
                                return v(f, "Accept"), v(f, "Content-Type"), S.isFormData(g) || S.isArrayBuffer(g) || S.isBuffer(g) || S.isStream(g) || S.isFile(g) || S.isBlob(g) ? g : S.isArrayBufferView(g) ? g.buffer : S.isURLSearchParams(g) ? (setContentTypeIfUnset(f, "application/x-www-form-urlencoded;charset=utf-8"), g.toString()) : S.isObject(g) ? (setContentTypeIfUnset(f, "application/json;charset=utf-8"), JSON.stringify(g)) : g;
                            }
                        ],
                        transformResponse: [
                            function transformResponse(g) {
                                if ("string" == typeof g) try {
                                    g = JSON.parse(g);
                                } catch (g) {}
                                return g;
                            }
                        ],
                        timeout: 0,
                        xsrfCookieName: "XSRF-TOKEN",
                        xsrfHeaderName: "X-XSRF-TOKEN",
                        maxContentLength: -1,
                        validateStatus: function validateStatus(g) {
                            return g >= 200 && g < 300;
                        },
                        headers: {
                            common: {
                                Accept: "application/json, text/plain, */*"
                            }
                        }
                    };
                    S.forEach([
                        "delete",
                        "get",
                        "head"
                    ], function forEachMethodNoData(g) {
                        C.headers[g] = {};
                    }), S.forEach([
                        "post",
                        "put",
                        "patch"
                    ], function forEachMethodWithData(g) {
                        C.headers[g] = S.merge(_);
                    }), f.exports = C;
                }
            }), K = __commonJS({
                "../node_modules/axios/lib/core/dispatchRequest.js" (g, f) {
                    var S = M(), v = N(), _ = k(), C = z();
                    function throwIfCancellationRequested(g) {
                        g.cancelToken && g.cancelToken.throwIfRequested();
                    }
                    f.exports = function dispatchRequest(g) {
                        return throwIfCancellationRequested(g), g.headers = g.headers || {}, g.data = v(g.data, g.headers, g.transformRequest), g.headers = S.merge(g.headers.common || {}, g.headers[g.method] || {}, g.headers), S.forEach([
                            "delete",
                            "get",
                            "head",
                            "post",
                            "put",
                            "patch",
                            "common"
                        ], function cleanHeaderConfig(f) {
                            delete g.headers[f];
                        }), (g.adapter || C.adapter)(g).then(function onAdapterResolution(f) {
                            return throwIfCancellationRequested(g), f.data = v(f.data, f.headers, g.transformResponse), f;
                        }, function onAdapterRejection(f) {
                            return _(f) || (throwIfCancellationRequested(g), f && f.response && (f.response.data = v(f.response.data, f.response.headers, g.transformResponse))), Promise.reject(f);
                        });
                    };
                }
            }), J = __commonJS({
                "../node_modules/axios/lib/core/mergeConfig.js" (g, f) {
                    var S = M();
                    f.exports = function mergeConfig(g, f) {
                        f = f || {};
                        var v = {}, _ = [
                            "url",
                            "method",
                            "params",
                            "data"
                        ], C = [
                            "headers",
                            "auth",
                            "proxy"
                        ], E = [
                            "baseURL",
                            "url",
                            "transformRequest",
                            "transformResponse",
                            "paramsSerializer",
                            "timeout",
                            "withCredentials",
                            "adapter",
                            "responseType",
                            "xsrfCookieName",
                            "xsrfHeaderName",
                            "onUploadProgress",
                            "onDownloadProgress",
                            "maxContentLength",
                            "validateStatus",
                            "maxRedirects",
                            "httpAgent",
                            "httpsAgent",
                            "cancelToken",
                            "socketPath"
                        ];
                        S.forEach(_, function valueFromConfig2(g) {
                            void 0 !== f[g] && (v[g] = f[g]);
                        }), S.forEach(C, function mergeDeepProperties(_) {
                            S.isObject(f[_]) ? v[_] = S.deepMerge(g[_], f[_]) : void 0 !== f[_] ? v[_] = f[_] : S.isObject(g[_]) ? v[_] = S.deepMerge(g[_]) : void 0 !== g[_] && (v[_] = g[_]);
                        }), S.forEach(E, function defaultToConfig2(S) {
                            void 0 !== f[S] ? v[S] = f[S] : void 0 !== g[S] && (v[S] = g[S]);
                        });
                        var T = _.concat(C).concat(E), I = Object.keys(f).filter(function filterAxiosKeys(g) {
                            return -1 === T.indexOf(g);
                        });
                        return S.forEach(I, function otherKeysDefaultToConfig2(S) {
                            void 0 !== f[S] ? v[S] = f[S] : void 0 !== g[S] && (v[S] = g[S]);
                        }), v;
                    };
                }
            }), Y = __commonJS({
                "../node_modules/axios/lib/core/Axios.js" (g, f) {
                    var S = M(), v = O(), _ = D(), C = K(), E = J();
                    function Axios(g) {
                        this.defaults = g, this.interceptors = {
                            request: new _,
                            response: new _
                        };
                    }
                    Axios.prototype.request = function request(g) {
                        "string" == typeof g ? (g = arguments[1] || {}).url = arguments[0] : g = g || {}, (g = E(this.defaults, g)).method ? g.method = g.method.toLowerCase() : this.defaults.method ? g.method = this.defaults.method.toLowerCase() : g.method = "get";
                        var f = [
                            C,
                            void 0
                        ], S = Promise.resolve(g);
                        for(this.interceptors.request.forEach(function unshiftRequestInterceptors(g) {
                            f.unshift(g.fulfilled, g.rejected);
                        }), this.interceptors.response.forEach(function pushResponseInterceptors(g) {
                            f.push(g.fulfilled, g.rejected);
                        }); f.length;)S = S.then(f.shift(), f.shift());
                        return S;
                    }, Axios.prototype.getUri = function getUri(g) {
                        return g = E(this.defaults, g), v(g.url, g.params, g.paramsSerializer).replace(/^\?/, "");
                    }, S.forEach([
                        "delete",
                        "get",
                        "head",
                        "options"
                    ], function forEachMethodNoData(g) {
                        Axios.prototype[g] = function(f, v) {
                            return this.request(S.merge(v || {}, {
                                method: g,
                                url: f
                            }));
                        };
                    }), S.forEach([
                        "post",
                        "put",
                        "patch"
                    ], function forEachMethodWithData(g) {
                        Axios.prototype[g] = function(f, v, _) {
                            return this.request(S.merge(_ || {}, {
                                method: g,
                                url: f,
                                data: v
                            }));
                        };
                    }), f.exports = Axios;
                }
            }), Q = __commonJS({
                "../node_modules/axios/lib/cancel/Cancel.js" (g, f) {
                    function Cancel(g) {
                        this.message = g;
                    }
                    Cancel.prototype.toString = function toString() {
                        return "Cancel" + (this.message ? ": " + this.message : "");
                    }, Cancel.prototype.__CANCEL__ = !0, f.exports = Cancel;
                }
            }), X = __commonJS({
                "../node_modules/axios/lib/cancel/CancelToken.js" (g, f) {
                    var S = Q();
                    function CancelToken(g) {
                        if ("function" != typeof g) throw new TypeError("executor must be a function.");
                        var f;
                        this.promise = new Promise(function promiseExecutor(g) {
                            f = g;
                        });
                        var v = this;
                        g(function cancel(g) {
                            v.reason || (v.reason = new S(g), f(v.reason));
                        });
                    }
                    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
                        if (this.reason) throw this.reason;
                    }, CancelToken.source = function source() {
                        var g;
                        return {
                            token: new CancelToken(function executor(f) {
                                g = f;
                            }),
                            cancel: g
                        };
                    }, f.exports = CancelToken;
                }
            }), Z = __commonJS({
                "../node_modules/axios/lib/helpers/spread.js" (g, f) {
                    f.exports = function spread(g) {
                        return function wrap(f) {
                            return g.apply(null, f);
                        };
                    };
                }
            }), ee = __commonJS({
                "../node_modules/axios/lib/axios.js" (g, f) {
                    var S = M(), v = w(), _ = Y(), C = J();
                    function createInstance(g) {
                        var f = new _(g), C = v(_.prototype.request, f);
                        return S.extend(C, _.prototype, f), S.extend(C, f), C;
                    }
                    var E = createInstance(z());
                    E.Axios = _, E.create = function create(g) {
                        return createInstance(C(E.defaults, g));
                    }, E.Cancel = Q(), E.CancelToken = X(), E.isCancel = k(), E.all = function all(g) {
                        return Promise.all(g);
                    }, E.spread = Z(), f.exports = E, f.exports.default = E;
                }
            }), te = __commonJS({
                "../node_modules/axios/index.js" (g, f) {
                    f.exports = ee();
                }
            }), ie = __commonJS({
                "../node_modules/ua-parser-js/src/ua-parser.js" (g, f) {
                    !function(S, v) {
                        var _ = "1.0.38", C = "", E = "?", T = "function", I = "undefined", b = "object", A = "string", R = "major", P = "model", w = "name", M = "type", O = "vendor", D = "version", N = "architecture", k = "console", L = "mobile", F = "tablet", x = "smarttv", U = "wearable", V = "embedded", B = 500, H = "Amazon", $ = "Apple", j = "ASUS", G = "BlackBerry", q = "Browser", W = "Chrome", z = "Firefox", K = "Google", J = "Huawei", Y = "LG", Q = "Microsoft", X = "Motorola", Z = "Opera", ee = "Samsung", te = "Sharp", ie = "Sony", ne = "Xiaomi", re = "Zebra", ae = "Facebook", se = "Chromium OS", oe = "Mac OS", extend3 = function(g, f) {
                            var S = {};
                            for(var v in g)f[v] && f[v].length % 2 == 0 ? S[v] = f[v].concat(g[v]) : S[v] = g[v];
                            return S;
                        }, enumerize = function(g) {
                            for(var f = {}, S = 0; S < g.length; S++)f[g[S].toUpperCase()] = g[S];
                            return f;
                        }, has2 = function(g, f) {
                            return typeof g === A && -1 !== lowerize(f).indexOf(lowerize(g));
                        }, lowerize = function(g) {
                            return g.toLowerCase();
                        }, majorize = function(g) {
                            return typeof g === A ? g.replace(/[^\d\.]/g, C).split(".")[0] : v;
                        }, trim2 = function(g, f) {
                            if (typeof g === A) return g = g.replace(/^\s\s*/, C), typeof f === I ? g : g.substring(0, B);
                        }, rgxMapper = function(g, f) {
                            for(var S, _, C, E, I, A, R = 0; R < f.length && !I;){
                                var P = f[R], w = f[R + 1];
                                for(S = _ = 0; S < P.length && !I && P[S];)if (I = P[S++].exec(g)) for(C = 0; C < w.length; C++)A = I[++_], typeof (E = w[C]) === b && E.length > 0 ? 2 === E.length ? typeof E[1] == T ? this[E[0]] = E[1].call(this, A) : this[E[0]] = E[1] : 3 === E.length ? typeof E[1] !== T || E[1].exec && E[1].test ? this[E[0]] = A ? A.replace(E[1], E[2]) : v : this[E[0]] = A ? E[1].call(this, A, E[2]) : v : 4 === E.length && (this[E[0]] = A ? E[3].call(this, A.replace(E[1], E[2])) : v) : this[E] = A || v;
                                R += 2;
                            }
                        }, strMapper = function(g, f) {
                            for(var S in f)if (typeof f[S] === b && f[S].length > 0) {
                                for(var _ = 0; _ < f[S].length; _++)if (has2(f[S][_], g)) return S === E ? v : S;
                            } else if (has2(f[S], g)) return S === E ? v : S;
                            return g;
                        }, le = {
                            ME: "4.90",
                            "NT 3.11": "NT3.51",
                            "NT 4.0": "NT4.0",
                            2e3: "NT 5.0",
                            XP: [
                                "NT 5.1",
                                "NT 5.2"
                            ],
                            Vista: "NT 6.0",
                            7: "NT 6.1",
                            8: "NT 6.2",
                            8.1: "NT 6.3",
                            10: [
                                "NT 6.4",
                                "NT 10.0"
                            ],
                            RT: "ARM"
                        }, ce = {
                            browser: [
                                [
                                    /\b(?:crmo|crios)\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Chrome"
                                    ]
                                ],
                                [
                                    /edg(?:e|ios|a)?\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Edge"
                                    ]
                                ],
                                [
                                    /(opera mini)\/([-\w\.]+)/i,
                                    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                                    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /opios[\/ ]+([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        Z + " Mini"
                                    ]
                                ],
                                [
                                    /\bop(?:rg)?x\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        Z + " GX"
                                    ]
                                ],
                                [
                                    /\bopr\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        Z
                                    ]
                                ],
                                [
                                    /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Baidu"
                                    ]
                                ],
                                [
                                    /(kindle)\/([\w\.]+)/i,
                                    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                                    /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                                    /(?:ms|\()(ie) ([\w\.]+)/i,
                                    /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                    /(heytap|ovi)browser\/([\d\.]+)/i,
                                    /(weibo)__([\d\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /\bddg\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "DuckDuckGo"
                                    ]
                                ],
                                [
                                    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "UC" + q
                                    ]
                                ],
                                [
                                    /microm.+\bqbcore\/([\w\.]+)/i,
                                    /\bqbcore\/([\w\.]+).+microm/i,
                                    /micromessenger\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "WeChat"
                                    ]
                                ],
                                [
                                    /konqueror\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Konqueror"
                                    ]
                                ],
                                [
                                    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "IE"
                                    ]
                                ],
                                [
                                    /ya(?:search)?browser\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Yandex"
                                    ]
                                ],
                                [
                                    /slbrowser\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Smart Lenovo " + q
                                    ]
                                ],
                                [
                                    /(avast|avg)\/([\w\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        /(.+)/,
                                        "$1 Secure " + q
                                    ],
                                    D
                                ],
                                [
                                    /\bfocus\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        z + " Focus"
                                    ]
                                ],
                                [
                                    /\bopt\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        Z + " Touch"
                                    ]
                                ],
                                [
                                    /coc_coc\w+\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Coc Coc"
                                    ]
                                ],
                                [
                                    /dolfin\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Dolphin"
                                    ]
                                ],
                                [
                                    /coast\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        Z + " Coast"
                                    ]
                                ],
                                [
                                    /miuibrowser\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "MIUI " + q
                                    ]
                                ],
                                [
                                    /fxios\/([-\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        z
                                    ]
                                ],
                                [
                                    /\bqihu|(qi?ho?o?|360)browser/i
                                ],
                                [
                                    [
                                        w,
                                        "360 " + q
                                    ]
                                ],
                                [
                                    /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        /(.+)/,
                                        "$1 " + q
                                    ],
                                    D
                                ],
                                [
                                    /samsungbrowser\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        ee + " Internet"
                                    ]
                                ],
                                [
                                    /(comodo_dragon)\/([\w\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        /_/g,
                                        " "
                                    ],
                                    D
                                ],
                                [
                                    /metasr[\/ ]?([\d\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Sogou Explorer"
                                    ]
                                ],
                                [
                                    /(sogou)mo\w+\/([\d\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        "Sogou Mobile"
                                    ],
                                    D
                                ],
                                [
                                    /(electron)\/([\w\.]+) safari/i,
                                    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                                    /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /(lbbrowser)/i,
                                    /\[(linkedin)app\]/i
                                ],
                                [
                                    w
                                ],
                                [
                                    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                                ],
                                [
                                    [
                                        w,
                                        ae
                                    ],
                                    D
                                ],
                                [
                                    /(Klarna)\/([\w\.]+)/i,
                                    /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                                    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                                    /safari (line)\/([\w\.]+)/i,
                                    /\b(line)\/([\w\.]+)\/iab/i,
                                    /(alipay)client\/([\w\.]+)/i,
                                    /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                                    /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /\bgsa\/([\w\.]+) .*safari\//i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "GSA"
                                    ]
                                ],
                                [
                                    /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "TikTok"
                                    ]
                                ],
                                [
                                    /headlesschrome(?:\/([\w\.]+)| )/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        W + " Headless"
                                    ]
                                ],
                                [
                                    / wv\).+(chrome)\/([\w\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        W + " WebView"
                                    ],
                                    D
                                ],
                                [
                                    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Android " + q
                                    ]
                                ],
                                [
                                    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Mobile Safari"
                                    ]
                                ],
                                [
                                    /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                                ],
                                [
                                    D,
                                    w
                                ],
                                [
                                    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                                ],
                                [
                                    w,
                                    [
                                        D,
                                        strMapper,
                                        {
                                            "1.0": "/8",
                                            1.2: "/1",
                                            1.3: "/3",
                                            "2.0": "/412",
                                            "2.0.2": "/416",
                                            "2.0.3": "/417",
                                            "2.0.4": "/419",
                                            "?": "/"
                                        }
                                    ]
                                ],
                                [
                                    /(webkit|khtml)\/([\w\.]+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /(navigator|netscape\d?)\/([-\w\.]+)/i
                                ],
                                [
                                    [
                                        w,
                                        "Netscape"
                                    ],
                                    D
                                ],
                                [
                                    /mobile vr; rv:([\w\.]+)\).+firefox/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        z + " Reality"
                                    ]
                                ],
                                [
                                    /ekiohf.+(flow)\/([\w\.]+)/i,
                                    /(swiftfox)/i,
                                    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                    /(firefox)\/([\w\.]+)/i,
                                    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                                    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                    /(links) \(([\w\.]+)/i,
                                    /panasonic;(viera)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /(cobalt)\/([\w\.]+)/i
                                ],
                                [
                                    w,
                                    [
                                        D,
                                        /master.|lts./,
                                        ""
                                    ]
                                ]
                            ],
                            cpu: [
                                [
                                    /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                                ],
                                [
                                    [
                                        N,
                                        "amd64"
                                    ]
                                ],
                                [
                                    /(ia32(?=;))/i
                                ],
                                [
                                    [
                                        N,
                                        lowerize
                                    ]
                                ],
                                [
                                    /((?:i[346]|x)86)[;\)]/i
                                ],
                                [
                                    [
                                        N,
                                        "ia32"
                                    ]
                                ],
                                [
                                    /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                                ],
                                [
                                    [
                                        N,
                                        "arm64"
                                    ]
                                ],
                                [
                                    /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                                ],
                                [
                                    [
                                        N,
                                        "armhf"
                                    ]
                                ],
                                [
                                    /windows (ce|mobile); ppc;/i
                                ],
                                [
                                    [
                                        N,
                                        "arm"
                                    ]
                                ],
                                [
                                    /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                                ],
                                [
                                    [
                                        N,
                                        /ower/,
                                        C,
                                        lowerize
                                    ]
                                ],
                                [
                                    /(sun4\w)[;\)]/i
                                ],
                                [
                                    [
                                        N,
                                        "sparc"
                                    ]
                                ],
                                [
                                    /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                ],
                                [
                                    [
                                        N,
                                        lowerize
                                    ]
                                ]
                            ],
                            device: [
                                [
                                    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ee
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                                    /samsung[- ]([-\w]+)/i,
                                    /sec-(sgh\w+)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ee
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        $
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\((ipad);[-\w\),; ]+apple/i,
                                    /applecoremedia\/[\w\.]+ \((ipad)/i,
                                    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        $
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(macintosh);/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        $
                                    ]
                                ],
                                [
                                    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        te
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        J
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(?:huawei|honor)([-\w ]+)[;\)]/i,
                                    /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        J
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                                    /\b; (\w+) build\/hm\1/i,
                                    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                                    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                                    /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                                    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                                ],
                                [
                                    [
                                        P,
                                        /_/g,
                                        " "
                                    ],
                                    [
                                        O,
                                        ne
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                                    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                                ],
                                [
                                    [
                                        P,
                                        /_/g,
                                        " "
                                    ],
                                    [
                                        O,
                                        ne
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /; (\w+) bui.+ oppo/i,
                                    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "OPPO"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(opd2\d{3}a?) bui/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "OPPO"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /vivo (\w+)(?: bui|\))/i,
                                    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Vivo"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Realme"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                                    /\bmot(?:orola)?[- ](\w*)/i,
                                    /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        X
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        X
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        Y
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                                    /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                                    /\blg-?([\d\w]+) bui/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        Y
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(ideatab[-\w ]+)/i,
                                    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Lenovo"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(?:maemo|nokia).*(n900|lumia \d+)/i,
                                    /nokia[-_ ]?([-\w\.]*)/i
                                ],
                                [
                                    [
                                        P,
                                        /_/g,
                                        " "
                                    ],
                                    [
                                        O,
                                        "Nokia"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(pixel c)\b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        K
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        K
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ie
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /sony tablet [ps]/i,
                                    /\b(?:sony)?sgp\w+(?: bui|\))/i
                                ],
                                [
                                    [
                                        P,
                                        "Xperia Tablet"
                                    ],
                                    [
                                        O,
                                        ie
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    / (kb2005|in20[12]5|be20[12][59])\b/i,
                                    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "OnePlus"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(alexa)webm/i,
                                    /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                                    /(kf[a-z]+)( bui|\)).+silk\//i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        H
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                                ],
                                [
                                    [
                                        P,
                                        /(.+)/g,
                                        "Fire Phone $1"
                                    ],
                                    [
                                        O,
                                        H
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(playbook);[-\w\),; ]+(rim)/i
                                ],
                                [
                                    P,
                                    O,
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b((?:bb[a-f]|st[hv])100-\d)/i,
                                    /\(bb10; (\w+)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        G
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        j
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        j
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(nexus 9)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "HTC"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                                    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                                    /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                                ],
                                [
                                    O,
                                    [
                                        P,
                                        /_/g,
                                        " "
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Acer"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /droid.+; (m[1-5] note) bui/i,
                                    /\bmz-([-\w]{2,})/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Meizu"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Ulefone"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                                    /(hp) ([\w ]+\w)/i,
                                    /(asus)-?(\w+)/i,
                                    /(microsoft); (lumia[\w ]+)/i,
                                    /(lenovo)[-_ ]?([-\w]+)/i,
                                    /(jolla)/i,
                                    /(oppo) ?([\w ]+) bui/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(kobo)\s(ereader|touch)/i,
                                    /(archos) (gamepad2?)/i,
                                    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                                    /(kindle)\/([\w\.]+)/i,
                                    /(nook)[\w ]+build\/(\w+)/i,
                                    /(dell) (strea[kpr\d ]*[\dko])/i,
                                    /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                                    /(trinity)[- ]*(t\d{3}) bui/i,
                                    /(gigaset)[- ]+(q\w{1,9}) bui/i,
                                    /(vodafone) ([\w ]+)(?:\)| bui)/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(surface duo)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        Q
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /droid [\d\.]+; (fp\du?)(?: b|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Fairphone"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(u304aa)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "AT&T"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\bsie-(\w*)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Siemens"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(rct\w+) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "RCA"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(venue[\d ]{2,7}) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Dell"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(q(?:mv|ta)\w+) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Verizon"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Barnes & Noble"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(tm\d{3}\w+) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "NuVision"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(k88) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "ZTE"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(nx\d{3}j) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "ZTE"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(gen\d{3}) b.+49h/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Swiss"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(zur\d{3}) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Swiss"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b((zeki)?tb.*\b) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Zeki"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b([yr]\d{2}) b/i,
                                    /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                                ],
                                [
                                    [
                                        O,
                                        "Dragon Touch"
                                    ],
                                    P,
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(ns-?\w{0,9}) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Insignia"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b((nxa|next)-?\w{0,9}) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "NextBook"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                                ],
                                [
                                    [
                                        O,
                                        "Voice"
                                    ],
                                    P,
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(lvtel\-)?(v1[12]) b/i
                                ],
                                [
                                    [
                                        O,
                                        "LvTel"
                                    ],
                                    P,
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(ph-1) /i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Essential"
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /\b(v(100md|700na|7011|917g).*\b) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Envizen"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b(trio[-\w\. ]+) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "MachSpeed"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\btu_(1491) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Rotor"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(shield[\w ]+) b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Nvidia"
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(sprint) (\w+)/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(kin\.[onetw]{3})/i
                                ],
                                [
                                    [
                                        P,
                                        /\./g,
                                        " "
                                    ],
                                    [
                                        O,
                                        Q
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        re
                                    ],
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        re
                                    ],
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /smart-tv.+(samsung)/i
                                ],
                                [
                                    O,
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /hbbtv.+maple;(\d+)/i
                                ],
                                [
                                    [
                                        P,
                                        /^/,
                                        "SmartTV"
                                    ],
                                    [
                                        O,
                                        ee
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                                ],
                                [
                                    [
                                        O,
                                        Y
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /(apple) ?tv/i
                                ],
                                [
                                    O,
                                    [
                                        P,
                                        $ + " TV"
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /crkey/i
                                ],
                                [
                                    [
                                        P,
                                        W + "cast"
                                    ],
                                    [
                                        O,
                                        K
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /droid.+aft(\w+)( bui|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        H
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /\(dtv[\);].+(aquos)/i,
                                    /(aquos-tv[\w ]+)\)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        te
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /(bravia[\w ]+)( bui|\))/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ie
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /(mitv-\w{5}) bui/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ne
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /Hbbtv.*(technisat) (.*);/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                                    /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                                ],
                                [
                                    [
                                        O,
                                        trim2
                                    ],
                                    [
                                        P,
                                        trim2
                                    ],
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                                ],
                                [
                                    [
                                        M,
                                        x
                                    ]
                                ],
                                [
                                    /(ouya)/i,
                                    /(nintendo) ([wids3utch]+)/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        k
                                    ]
                                ],
                                [
                                    /droid.+; (shield) bui/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Nvidia"
                                    ],
                                    [
                                        M,
                                        k
                                    ]
                                ],
                                [
                                    /(playstation [345portablevi]+)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ie
                                    ],
                                    [
                                        M,
                                        k
                                    ]
                                ],
                                [
                                    /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        Q
                                    ],
                                    [
                                        M,
                                        k
                                    ]
                                ],
                                [
                                    /((pebble))app/i
                                ],
                                [
                                    O,
                                    P,
                                    [
                                        M,
                                        U
                                    ]
                                ],
                                [
                                    /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        $
                                    ],
                                    [
                                        M,
                                        U
                                    ]
                                ],
                                [
                                    /droid.+; (glass) \d/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        K
                                    ],
                                    [
                                        M,
                                        U
                                    ]
                                ],
                                [
                                    /droid.+; (wt63?0{2,3})\)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        re
                                    ],
                                    [
                                        M,
                                        U
                                    ]
                                ],
                                [
                                    /(quest( \d| pro)?)/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        ae
                                    ],
                                    [
                                        M,
                                        U
                                    ]
                                ],
                                [
                                    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                                ],
                                [
                                    O,
                                    [
                                        M,
                                        V
                                    ]
                                ],
                                [
                                    /(aeobc)\b/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        H
                                    ],
                                    [
                                        M,
                                        V
                                    ]
                                ],
                                [
                                    /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                                ],
                                [
                                    P,
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                                ],
                                [
                                    P,
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                                ],
                                [
                                    [
                                        M,
                                        F
                                    ]
                                ],
                                [
                                    /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                                ],
                                [
                                    [
                                        M,
                                        L
                                    ]
                                ],
                                [
                                    /(android[-\w\. ]{0,9});.+buil/i
                                ],
                                [
                                    P,
                                    [
                                        O,
                                        "Generic"
                                    ]
                                ]
                            ],
                            engine: [
                                [
                                    /windows.+ edge\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "EdgeHTML"
                                    ]
                                ],
                                [
                                    /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Blink"
                                    ]
                                ],
                                [
                                    /(presto)\/([\w\.]+)/i,
                                    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                                    /ekioh(flow)\/([\w\.]+)/i,
                                    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                                    /(icab)[\/ ]([23]\.[\d\.]+)/i,
                                    /\b(libweb)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /rv\:([\w\.]{1,9})\b.+(gecko)/i
                                ],
                                [
                                    D,
                                    w
                                ]
                            ],
                            os: [
                                [
                                    /microsoft (windows) (vista|xp)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                                ],
                                [
                                    w,
                                    [
                                        D,
                                        strMapper,
                                        le
                                    ]
                                ],
                                [
                                    /windows nt 6\.2; (arm)/i,
                                    /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                                    /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                                ],
                                [
                                    [
                                        D,
                                        strMapper,
                                        le
                                    ],
                                    [
                                        w,
                                        "Windows"
                                    ]
                                ],
                                [
                                    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                                    /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                                    /cfnetwork\/.+darwin/i
                                ],
                                [
                                    [
                                        D,
                                        /_/g,
                                        "."
                                    ],
                                    [
                                        w,
                                        "iOS"
                                    ]
                                ],
                                [
                                    /(mac os x) ?([\w\. ]*)/i,
                                    /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                                ],
                                [
                                    [
                                        w,
                                        oe
                                    ],
                                    [
                                        D,
                                        /_/g,
                                        "."
                                    ]
                                ],
                                [
                                    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                                ],
                                [
                                    D,
                                    w
                                ],
                                [
                                    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                                    /(blackberry)\w*\/([\w\.]*)/i,
                                    /(tizen|kaios)[\/ ]([\w\.]+)/i,
                                    /\((series40);/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /\(bb(10);/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        G
                                    ]
                                ],
                                [
                                    /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "Symbian"
                                    ]
                                ],
                                [
                                    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        z + " OS"
                                    ]
                                ],
                                [
                                    /web0s;.+rt(tv)/i,
                                    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "webOS"
                                    ]
                                ],
                                [
                                    /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        "watchOS"
                                    ]
                                ],
                                [
                                    /crkey\/([\d\.]+)/i
                                ],
                                [
                                    D,
                                    [
                                        w,
                                        W + "cast"
                                    ]
                                ],
                                [
                                    /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                                ],
                                [
                                    [
                                        w,
                                        se
                                    ],
                                    D
                                ],
                                [
                                    /panasonic;(viera)/i,
                                    /(netrange)mmh/i,
                                    /(nettv)\/(\d+\.[\w\.]+)/i,
                                    /(nintendo|playstation) ([wids345portablevuch]+)/i,
                                    /(xbox); +xbox ([^\);]+)/i,
                                    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                                    /(mint)[\/\(\) ]?(\w*)/i,
                                    /(mageia|vectorlinux)[; ]/i,
                                    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                    /(hurd|linux) ?([\w\.]*)/i,
                                    /(gnu) ?([\w\.]*)/i,
                                    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                                    /(haiku) (\w+)/i
                                ],
                                [
                                    w,
                                    D
                                ],
                                [
                                    /(sunos) ?([\w\.\d]*)/i
                                ],
                                [
                                    [
                                        w,
                                        "Solaris"
                                    ],
                                    D
                                ],
                                [
                                    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                                    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                                    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                                    /(unix) ?([\w\.]*)/i
                                ],
                                [
                                    w,
                                    D
                                ]
                            ]
                        }, UAParser2 = function(g, f) {
                            if (typeof g === b && (f = g, g = v), !(this instanceof UAParser2)) return new UAParser2(g, f).getResult();
                            var _ = typeof S !== I && S.navigator ? S.navigator : v, E = g || (_ && _.userAgent ? _.userAgent : C), k = _ && _.userAgentData ? _.userAgentData : v, x = f ? extend3(ce, f) : ce, U = _ && _.userAgent == E;
                            return this.getBrowser = function() {
                                var g = {};
                                return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.browser), g[R] = majorize(g[D]), U && _ && _.brave && typeof _.brave.isBrave == T && (g[w] = "Brave"), g;
                            }, this.getCPU = function() {
                                var g = {};
                                return g[N] = v, rgxMapper.call(g, E, x.cpu), g;
                            }, this.getDevice = function() {
                                var g = {};
                                return g[O] = v, g[P] = v, g[M] = v, rgxMapper.call(g, E, x.device), U && !g[M] && k && k.mobile && (g[M] = L), U && "Macintosh" == g[P] && _ && typeof _.standalone !== I && _.maxTouchPoints && _.maxTouchPoints > 2 && (g[P] = "iPad", g[M] = F), g;
                            }, this.getEngine = function() {
                                var g = {};
                                return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.engine), g;
                            }, this.getOS = function() {
                                var g = {};
                                return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.os), U && !g[w] && k && k.platform && "Unknown" != k.platform && (g[w] = k.platform.replace(/chrome os/i, se).replace(/macos/i, oe)), g;
                            }, this.getResult = function() {
                                return {
                                    ua: this.getUA(),
                                    browser: this.getBrowser(),
                                    engine: this.getEngine(),
                                    os: this.getOS(),
                                    device: this.getDevice(),
                                    cpu: this.getCPU()
                                };
                            }, this.getUA = function() {
                                return E;
                            }, this.setUA = function(g) {
                                return E = typeof g === A && g.length > B ? trim2(g, B) : g, this;
                            }, this.setUA(E), this;
                        };
                        UAParser2.VERSION = _, UAParser2.BROWSER = enumerize([
                            w,
                            D,
                            R
                        ]), UAParser2.CPU = enumerize([
                            N
                        ]), UAParser2.DEVICE = enumerize([
                            P,
                            O,
                            M,
                            k,
                            L,
                            x,
                            F,
                            U,
                            V
                        ]), UAParser2.ENGINE = UAParser2.OS = enumerize([
                            w,
                            D
                        ]), typeof g !== I ? (typeof f !== I && f.exports && (g = f.exports = UAParser2), g.UAParser = UAParser2) : typeof S !== I && (S.UAParser = UAParser2);
                        var de = typeof S !== I && (S.jQuery || S.Zepto);
                        if (de && !de.ua) {
                            var ue = new UAParser2;
                            de.ua = ue.getResult(), de.ua.get = function() {
                                return ue.getUA();
                            }, de.ua.set = function(g) {
                                ue.setUA(g);
                                var f = ue.getResult();
                                for(var S in f)de.ua[S] = f[S];
                            };
                        }
                    }("object" == typeof window ? window : g);
                }
            }), ne = __commonJS({
                "../node_modules/@skype/hydra_player_sdk/hydra_player_sdk_bundle.js" (g, f) {
                    var S, v;
                    S = g, v = function() {
                        var g, f;
                        return g = {
                            103: function(g, f) {
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.defer = void 0, f.defer = function() {
                                    var g, f;
                                    return {
                                        promise: new Promise(function(S, v) {
                                            g = S, f = v;
                                        }),
                                        resolve: g,
                                        reject: f
                                    };
                                };
                            },
                            10: function(g, f) {
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.default = function() {
                                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(g) {
                                        var f = 16 * Math.random() | 0;
                                        return ("x" === g ? f : 3 & f | 8).toString(16);
                                    });
                                };
                            },
                            171: function(g, f, S) {
                                var v = this && this.__assign || function() {
                                    return v = Object.assign || function(g) {
                                        for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                                        return g;
                                    }, v.apply(this, arguments);
                                }, _ = this && this.__spreadArray || function(g, f, S) {
                                    if (S || 2 === arguments.length) for(var v, _ = 0, C = f.length; _ < C; _++)!v && _ in f || (v || (v = Array.prototype.slice.call(f, 0, _)), v[_] = f[_]);
                                    return g.concat(v || Array.prototype.slice.call(f));
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.LiveStreamStatistic = void 0;
                                var C = S(346), E = S(963), T = S(534), I = function() {
                                    function e3(g, f, S) {
                                        this.name = g, this.details = f, this.failReason = S, this.timeStamp = Date.now();
                                    }
                                    return e3.prototype.getName = function() {
                                        return this.name;
                                    }, e3.prototype.getFailReason = function() {
                                        return this.failReason;
                                    }, e3.prototype.getDetails = function() {
                                        return this.details;
                                    }, e3.prototype.getTimeStamp = function() {
                                        return this.timeStamp;
                                    }, e3;
                                }(), b = function() {
                                    function e3(g, f, S, v) {
                                        this.config = g, this.logFn = f, this.playerDiagnosticsLog = S, this.playerMetadata = v, this.playerEvents = [], this.playbackEvents = [], this.ecdnPluginEvents = [], this.experimentalEvents = [], this.userInitiatedSeekEvents = [], this.userInitiatedPlayEvents = [], this.userInitiatedPauseEvents = [], this.hydraInitResult = null, this.callSetupSucceeded = !1, this.callDropped = !1, this.latestErrorReason = void 0, this.clientNetworkType = void 0, this.maxPlayerPlaybackEventCount = g.maxPlayerPlaybackEventCount || 5, this.maxPlayerDiagnosticsCount = g.maxPlayerDiagnosticsCount || 5, this.maxPlayerMemoryTraceLogCount = g.maxPlayerMemoryTraceLogCount || 100, this.maxPlayerExperimentalEvents = g.maxPlayerExperimentalEvents || 100, this.maxUserInitiatedEventCount = T.getECSSetting(this.config, "maxUserInitiatedEventCount", 100), this.config.debugLogging && (this.playerDiagnosticsLog.memoryLog = []), this.addNetworkTypeEventListener();
                                    }
                                    return e3.prototype.getPlayerDiagnosticSnapshot = function() {
                                        return this.currentPlayerDiagnosticSnapshot;
                                    }, e3.prototype.setHydraInitResult = function(g) {
                                        this.hydraInitResult = g;
                                    }, e3.prototype.registerStatsUpdated = function(g) {
                                        var f = this;
                                        this.currentPlayerDiagnosticSnapshot = g, Object.keys(this.playerDiagnosticsLog).forEach(function(S) {
                                            var v, _ = S, C = null !== (v = f.playerDiagnosticsLog[S]) && void 0 !== v ? v : [];
                                            if (Array.isArray(C)) {
                                                C.push(g[_]);
                                                var E = "memoryLog" === _ && C.length > f.maxPlayerMemoryTraceLogCount, T = "memoryLog" !== _ && C.length > f.maxPlayerDiagnosticsCount;
                                                (E || T) && C.splice(0, 1);
                                            } else f.playerDiagnosticsLog[S] = g[_];
                                        });
                                    }, e3.prototype.registerEventLoadAttempt = function(g, f) {
                                        this.registerScenario(g, f);
                                    }, e3.prototype.registerEventLoadFailed = function(g, f) {
                                        this.completeScenario(g, f);
                                    }, e3.prototype.registerEventLoadSucceeded = function(g, f) {
                                        this.completeScenario(g, void 0, f), g === E.PlayerScenarioType.LoadPlayer && (this.callSetupSucceeded = !0);
                                    }, e3.prototype.registerSdnPluginLoadAttempt = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.SdnPluginLoad, g);
                                    }, e3.prototype.registerSdnPluginLoadFailed = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginLoad, g);
                                    }, e3.prototype.registerSdnPluginLoadSucceeded = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginLoad, void 0, g);
                                    }, e3.prototype.registerSdnPluginInitializeAttempt = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.SdnPluginInitialize, g);
                                    }, e3.prototype.registerSdnPluginInitializeFailed = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginInitialize, g);
                                    }, e3.prototype.registerSdnPluginInitializeSucceeded = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginInitialize, void 0, g);
                                    }, e3.prototype.registerSdnPluginSetSourceAttempt = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.SdnPluginSetSource, g);
                                    }, e3.prototype.registerSdnPluginSetSourceFailed = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginSetSource, g);
                                    }, e3.prototype.registerSdnPluginSetSourceSucceeded = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.SdnPluginSetSource, void 0, g);
                                    }, e3.prototype.registerStreamConnectionAttempt = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.StreamConnection, {
                                            streamUrl: g
                                        });
                                    }, e3.prototype.registerStreamConnectionSucceeded = function(g) {
                                        this.completeScenario(E.PlayerScenarioType.StreamConnection, void 0, {
                                            result: T.stringifyObject(g)
                                        });
                                    }, e3.prototype.registerStreamConnectionFailed = function(g, f) {
                                        this.completeScenario(E.PlayerScenarioType.StreamConnection, g, {
                                            result: T.stringifyObject(f)
                                        });
                                    }, e3.prototype.registerSetSourceAttempt = function(g, f, S) {
                                        var v = g || "";
                                        S && (v = {
                                            src: g || "",
                                            isPrimary: T.stringifyObject(f),
                                            reason: S
                                        }), this.registerScenario(E.PlayerScenarioType.SetSource, v);
                                    }, e3.prototype.registerSetSourceSucceeded = function(g, f, S, v, _) {
                                        this.completeScenario(E.PlayerScenarioType.SetSource, void 0, {
                                            src: g,
                                            isPrimary: T.stringifyObject(f),
                                            switchingDiagnostics: T.stringifyObject(S),
                                            stepDuration: T.stringifyObject(v),
                                            initialSeekToLiveEdge: T.stringifyObject(_)
                                        });
                                    }, e3.prototype.registerSetSourceFailed = function(g, f, S, v, _) {
                                        this.completeScenario(E.PlayerScenarioType.SetSource, g, {
                                            src: T.stringifyObject(f),
                                            isPrimary: T.stringifyObject(S),
                                            switchingDiagnostics: T.stringifyObject(v),
                                            stepDuration: T.stringifyObject(_)
                                        });
                                    }, e3.prototype.registerPlayerDestroyed = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.Destroyed, g), this.completeScenario(E.PlayerScenarioType.Destroyed);
                                    }, e3.prototype.registerPlaybackStateChanged = function(g, f) {
                                        var S, v, _, T, I, b;
                                        if (g !== C.HydraPlayerPlaybackState.CanPlayThrough || this.firstReadyStateTimestamp) {
                                            if (g === C.HydraPlayerPlaybackState.Playing) {
                                                if (this.firstPlayingState || (this.firstPlayingState = {
                                                    timestamp: Date.now()
                                                }, f && (f.edgeLatency && (this.firstPlayingState.edgeLatency = f.edgeLatency), f.bufferLength && (this.firstPlayingState.bufferLength = f.bufferLength))), this.userInitiatedSeekEvents.length > 0) {
                                                    var A = this.userInitiatedSeekEvents[this.userInitiatedSeekEvents.length - 1];
                                                    this.modifyTelemetryEventPayload(A, {
                                                        playingStatePosition: null !== (v = null === (S = this.currentPlayerDiagnosticSnapshot) || void 0 === S ? void 0 : S.currentPlayPosition) && void 0 !== v ? v : -1,
                                                        playingStateTimestamp: Date.now()
                                                    }, !1);
                                                }
                                                if (this.userInitiatedPlayEvents.length > 0) {
                                                    var R = this.userInitiatedPlayEvents[this.userInitiatedPlayEvents.length - 1];
                                                    this.modifyTelemetryEventPayload(R, {
                                                        playingStatePosition: null !== (T = null === (_ = this.currentPlayerDiagnosticSnapshot) || void 0 === _ ? void 0 : _.currentPlayPosition) && void 0 !== T ? T : -1,
                                                        playingStateTimestamp: Date.now()
                                                    }, !1);
                                                }
                                            } else if (g === C.HydraPlayerPlaybackState.Pause && this.userInitiatedPauseEvents.length > 0) {
                                                var P = this.userInitiatedPauseEvents[this.userInitiatedPauseEvents.length - 1];
                                                this.modifyTelemetryEventPayload(P, {
                                                    pauseStatePosition: null !== (b = null === (I = this.currentPlayerDiagnosticSnapshot) || void 0 === I ? void 0 : I.currentPlayPosition) && void 0 !== b ? b : -1,
                                                    pauseStateTimestamp: Date.now()
                                                }, !1);
                                            }
                                        } else this.firstReadyStateTimestamp = Date.now();
                                        this.registerPlaybackEvent(E.TelemetryEventType.StateChanged, g);
                                    }, e3.prototype.registerHydraInputStateChanged = function(g, f) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.HydraInputStateChanged, g, f);
                                    }, e3.prototype.registerHydraOutputStateChanged = function(g, f) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.HydraOutputStateChanged, g, f);
                                    }, e3.prototype.registerPlaybackBuffering = function(g) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.Buffering, g);
                                    }, e3.prototype.registerSdnPluginEvent = function(g) {
                                        var f = this.createTelemetryEvent(E.TelemetryEventType.EcdnPluginEvents, g);
                                        this.ecdnPluginEvents.push(f), this.ecdnPluginEvents.length > this.maxPlayerPlaybackEventCount && this.ecdnPluginEvents.splice(0, 1), this.logTelemetryEvent(f);
                                    }, e3.prototype.registerPlaybackError = function(g, f, S, v) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.Error, {
                                            errorType: g,
                                            details: f,
                                            errorSource: S,
                                            errorReason: v
                                        }), this.latestErrorReason = v;
                                    }, e3.prototype.registerIgnoredPlaybackError = function(g) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.IgnoredError, g);
                                    }, e3.prototype.registerDownloadBitrateChanged = function(g) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.BitrateChangedDownload, g);
                                    }, e3.prototype.registerStreamOptionsConfigured = function(g, f) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.StreamOptionsConfigured, g, f);
                                    }, e3.prototype.registerPlaybackBitrateChanged = function(g) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.BitrateChangedPlayback, g);
                                    }, e3.prototype.registerVolumeChange = function(g) {
                                        this.registerPlaybackEvent(E.TelemetryEventType.Volume, g);
                                    }, e3.prototype.getSnapshotReport = function() {
                                        var g, f, S = [
                                            this.getTotalLoadEvent(),
                                            this.getHydraLoadEvent()
                                        ].concat(this.buildCompleteTelemetryEvent()), _ = this.playbackEvents, C = {};
                                        return this.currentPlayerDiagnosticSnapshot && (C = this.filterAndPrepareTelemetry()), v(v(v(v(v(v(v(v(v(v(v(v(v(v({
                                            isFullReport: !1,
                                            configIds: this.config.configIds || "",
                                            eTag: this.config.eTag || ""
                                        }, this.getPlayerMetadataReport()), {
                                            isIframe: !0,
                                            isFullscreenButtonDisabled: !1,
                                            telemetryTickMs: null !== (f = null === (g = this.currentPlayerDiagnosticSnapshot) || void 0 === g ? void 0 : g.statsInterval) && void 0 !== f ? f : -1
                                        }), this.getHydraInitializationReport()), this.getPlayerInitializationReport(S)), this.getHydraInternalReport(_)), this.getPlaybackReport(_)), this.getBitrateReport(_)), this.getStreamConnectionReport(S)), this.getSdnReport(S)), this.getSetSourceReport(S)), this.getExperimentalEvents()), this.getUserInitiatedSeekEvents()), {
                                            networkType: this.getClientNetworkType(),
                                            callSetupSucceeded: this.callSetupSucceeded,
                                            callDropped: this.callDropped
                                        }), C);
                                    }, e3.prototype.getReport = function() {
                                        var g, f, S, _, C = [
                                            this.getTotalLoadEvent(),
                                            this.getHydraLoadEvent()
                                        ].concat(this.buildCompleteTelemetryEvent()), E = this.playbackEvents;
                                        return v(v(v(v(v(v(v(v(v(v(v(v(v(v(v({
                                            isFullReport: !0,
                                            configIds: this.config.configIds || "",
                                            eTag: this.config.eTag || ""
                                        }, this.getPlayerMetadataReport()), {
                                            isIframe: !0,
                                            isFullscreenButtonDisabled: !1,
                                            telemetryTickMs: null !== (f = null === (g = this.currentPlayerDiagnosticSnapshot) || void 0 === g ? void 0 : g.statsInterval) && void 0 !== f ? f : -1
                                        }), this.getHydraInitializationReport()), this.getPlayerInitializationReport(C)), this.getHydraInternalReport(E)), this.getPlaybackReport(E)), this.getBitrateReport(E)), this.getStreamConnectionReport(C)), this.getSdnReport(C)), this.getSetSourceReport(C)), this.getExperimentalEvents()), this.getUserInitiatedSeekEvents()), {
                                            networkType: this.getClientNetworkType(),
                                            callSetupSucceeded: this.callSetupSucceeded,
                                            callDropped: this.callDropped
                                        }), this.getPlayerDiagnosticLog()), {
                                            eventId: (null === (S = this.currentPlayerDiagnosticSnapshot) || void 0 === S ? void 0 : S.eventId) || "",
                                            templateId: (null === (_ = this.currentPlayerDiagnosticSnapshot) || void 0 === _ ? void 0 : _.templateId) || ""
                                        });
                                    }, e3.prototype.buildCompleteTelemetryEvent = function() {
                                        this.playerEvents.sort(function(g, f) {
                                            return g.getName() !== f.getName() ? E.PlayerScenarioType[g.getName()] - E.PlayerScenarioType[f.getName()] : g.getTimeStamp() - f.getTimeStamp();
                                        });
                                        for(var g, f, S, _, C, T = [], I = 0, b = this.playerEvents; I < b.length; I++){
                                            var A = b[I];
                                            0 === T.length || A.getName() !== T[T.length - 1].name ? T.push({
                                                name: E.PlayerScenarioType[A.getName()],
                                                startTime: A.getTimeStamp(),
                                                duration: 0
                                            }) : A.getName() === T[T.length - 1].name && (T[T.length - 1] = (g = T[T.length - 1], S = (f = A).getFailReason() ? {
                                                failReason: f.getFailReason()
                                            } : {}, _ = f.getDetails() ? {
                                                details: f.getDetails()
                                            } : {}, C = {
                                                name: g.name,
                                                startTime: g.startTime,
                                                duration: f.getTimeStamp() > g.startTime ? f.getTimeStamp() - g.startTime : g.duration
                                            }, v(v(v({}, C), S), _)));
                                        }
                                        return T;
                                    }, e3.prototype.getHydraLoadEvent = function() {
                                        var g, f, S, v = {
                                            name: E.PlayerScenarioType.LoadHydra,
                                            startTime: (null === (g = this.hydraInitResult) || void 0 === g ? void 0 : g.initStartTime) || -1,
                                            duration: (null === (f = this.hydraInitResult) || void 0 === f ? void 0 : f.initDuration) || 0
                                        };
                                        (null === (S = this.hydraInitResult) || void 0 === S ? void 0 : S.errorMsg) && (v.failReason = this.hydraInitResult.errorMsg);
                                        var _ = this.getHydraRuntimeDownloadDetails();
                                        return _ && (v.details = _), v;
                                    }, e3.prototype.getHydraRuntimeDownloadDetails = function() {
                                        if (this.hydraInitResult) {
                                            for(var g = [], f = 0, S = this.hydraInitResult.runtimeDownloadResults; f < S.length; f++){
                                                var v = S[f], _ = {
                                                    success: v.success,
                                                    url: v.url,
                                                    startTime: v.startTime,
                                                    duration: v.duration,
                                                    trackingReference: v.trackingReference,
                                                    timeTakenToDownloadScript: v.timeTakenToDownloadScript
                                                };
                                                v.errorMsg && (_.errorMsg = v.errorMsg), g.push(_);
                                            }
                                            return T.stringifyObject(g);
                                        }
                                        return null;
                                    }, e3.prototype.getTotalLoadEvent = function() {
                                        var g, f, S, v = this.getScenario(E.PlayerScenarioType.LoadPlayer), _ = (null === (g = this.hydraInitResult) || void 0 === g ? void 0 : g.initDuration) || 0, C = v.length > 0 ? v[v.length - 1].getTimeStamp() - v[0].getTimeStamp() : 0, T = v.length > 0 ? v[v.length - 1].getFailReason() : void 0, I = {
                                            name: E.PlayerScenarioType.Load,
                                            startTime: (null === (f = this.hydraInitResult) || void 0 === f ? void 0 : f.initStartTime) || -1,
                                            duration: _ + C
                                        };
                                        return (null === (S = this.hydraInitResult) || void 0 === S ? void 0 : S.errorMsg) ? I.failReason = this.hydraInitResult.errorMsg : T && (I.failReason = T), I;
                                    }, e3.prototype.getPlayerMetadataReport = function() {
                                        return {
                                            playerId: this.playerMetadata.playerId || "",
                                            traceId: this.playerMetadata.playerId ? this.playerMetadata.playerId.replace(/-/g, "") : "",
                                            hydraPlayerRuntimeVersion: this.playerMetadata.hydraPlayerRuntimeVersion || "",
                                            hydraPlayerSdkVersion: this.playerMetadata.hydraPlayerSdkVersion,
                                            player_playerType: this.playerMetadata.hydraPlayerType
                                        };
                                    }, e3.prototype.registerPlaybackEvent = function(g, f, S) {
                                        var v = this.createTelemetryEvent(g, f, S);
                                        g === E.TelemetryEventType.Error && (null == f ? void 0 : f.errorType) !== C.HydraPlayerPlaybackErrorType.PlaybackRetried && (v.fatal = !0, this.callDropped = !0), this.playbackEvents.push(v), this.playbackEvents.length > this.maxPlayerPlaybackEventCount && this.playbackEvents.splice(0, 1), this.logTelemetryEvent(v);
                                    }, e3.prototype.getPlayerDiagnosticLog = function() {
                                        var g = this;
                                        if (!this.currentPlayerDiagnosticSnapshot) return {};
                                        var f = this.currentPlayerDiagnosticSnapshot, S = this.playerDiagnosticsLog, _ = v(v({}, f), S), C = {};
                                        return Object.keys(_).forEach(function(f) {
                                            C["player_".concat(f)] = g.prepareForTelemetry(_[f]);
                                        }), C;
                                    }, e3.prototype.getHydraInitializationReport = function() {
                                        var g, f, S, v;
                                        return {
                                            hydraInit_succeeded: (null === (g = this.hydraInitResult) || void 0 === g ? void 0 : g.initSucceeded) || !1,
                                            hydraInit_startTime: (null === (f = this.hydraInitResult) || void 0 === f ? void 0 : f.initStartTime) || -1,
                                            hydraInit_errorMessage: (null === (S = this.hydraInitResult) || void 0 === S ? void 0 : S.errorMsg) || "",
                                            hydraInit_duration: (null === (v = this.hydraInitResult) || void 0 === v ? void 0 : v.initDuration) || 0
                                        };
                                    }, e3.prototype.getPlayerInitializationReport = function(g) {
                                        var f, S = g.find(function(g) {
                                            return g.name === E.PlayerScenarioType.Load;
                                        }), v = this.playerEvents.find(function(g) {
                                            return g.getName() === E.PlayerScenarioType.StreamConnection;
                                        }), _ = {
                                            init_timeLoadToStreamConnectionEstablished: (S && v ? v.getTimeStamp() - S.startTime : -1) || -1,
                                            init_timeLoadToReady: (S && this.firstReadyStateTimestamp ? this.firstReadyStateTimestamp - S.startTime : -1) || -1,
                                            init_timeLoadToPlaying: (S && (null === (f = this.firstPlayingState) || void 0 === f ? void 0 : f.timestamp) ? this.firstPlayingState.timestamp - S.startTime : -1) || -1,
                                            init_allEvents: this.prepareForTelemetry(g)
                                        };
                                        return this.firstPlayingState && (_.init_firstPlayingStateStatistics = this.prepareForTelemetry(this.firstPlayingState)), _;
                                    }, e3.prototype.getHydraInternalReport = function(g) {
                                        var f = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.HydraInputStateChanged;
                                        }), S = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.HydraOutputStateChanged;
                                        });
                                        return {
                                            hydra_inputStateChangeEvents: this.prepareForTelemetry(f),
                                            hydra_outputStateChangeEvents: this.prepareForTelemetry(S)
                                        };
                                    }, e3.prototype.getPlaybackReport = function(g) {
                                        var f = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.StateChanged;
                                        }), S = f.find(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.CanPlayThrough;
                                        }), v = f.find(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Play;
                                        }), _ = f.find(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Start;
                                        }), T = f.find(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Playing;
                                        }), I = null != S && null != v ? v.timestamp - S.timestamp : -1, b = null != v && null != _ ? _.timestamp - v.timestamp : -1, A = null != _ && null != T ? T.timestamp - _.timestamp : -1, R = f.filter(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Seeked;
                                        }), P = f.filter(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Seeking;
                                        }), w = f.filter(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Pause;
                                        }), M = f.filter(function(g) {
                                            return g.payload === C.HydraPlayerPlaybackState.Waiting;
                                        }), O = [
                                            E.TelemetryEventType.BitrateChangedDownload,
                                            E.TelemetryEventType.BitrateChangedPlayback,
                                            E.TelemetryEventType.Error,
                                            E.TelemetryEventType.Mute,
                                            E.TelemetryEventType.StateChanged,
                                            E.TelemetryEventType.Volume,
                                            E.TelemetryEventType.StreamOptionsConfigured,
                                            E.TelemetryEventType.IgnoredError
                                        ], D = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.Error;
                                        }), N = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.IgnoredError;
                                        }), k = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.Volume || g.eventType === E.TelemetryEventType.Mute;
                                        }), L = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.StreamOptionsConfigured;
                                        }), F = g.filter(function(g) {
                                            return !O.includes(g.eventType);
                                        });
                                        return {
                                            playback_timeReadyToPlay: I,
                                            playback_timePlayToStart: b,
                                            playback_timeStartToPlaying: A,
                                            playback_bufferingEvents: this.prepareForTelemetry(M),
                                            playback_errorEvents: this.prepareForTelemetry(D),
                                            playback_ignoredErrorEvents: this.prepareForTelemetry(N),
                                            playback_pauseEvents: this.prepareForTelemetry(w),
                                            playback_otherEvents: this.prepareForTelemetry(F),
                                            playback_seekedEvents: this.prepareForTelemetry(R),
                                            playback_seekingEvents: this.prepareForTelemetry(P),
                                            playback_stateChangeEvents: this.prepareForTelemetry(f),
                                            playback_volumeEvents: this.prepareForTelemetry(k),
                                            playback_streamOptionsConfiguredEvents: this.prepareForTelemetry(L),
                                            playback_latestErrorReason: this.latestErrorReason || ""
                                        };
                                    }, e3.prototype.getBitrateReport = function(g) {
                                        var f, S, _, C, T = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.BitrateChangedDownload;
                                        }), I = T.sort(function(g) {
                                            return Number(g.payload);
                                        }), b = T.length > 0 ? {
                                            bitrate_downloadChanges: this.prepareForTelemetry(T),
                                            bitrate_downloadChangeCount: T.length > 0 || -1,
                                            bitrate_downloadMin: (null === (f = I[0]) || void 0 === f ? void 0 : f.payload) || -1,
                                            bitrate_downloadMax: (null === (S = I[I.length - 1]) || void 0 === S ? void 0 : S.payload) || -1
                                        } : {}, A = g.filter(function(g) {
                                            return g.eventType === E.TelemetryEventType.BitrateChangedPlayback;
                                        }), R = A.sort(function(g) {
                                            return Number(g.payload);
                                        }), P = A.length > 0 ? {
                                            bitrate_playbackChanges: this.prepareForTelemetry(A),
                                            bitrate_playbackChangeCount: A.length > 0 || -1,
                                            bitrate_playbackMin: (null === (_ = R[0]) || void 0 === _ ? void 0 : _.payload) || -1,
                                            bitrate_playbackMax: (null === (C = R[R.length - 1]) || void 0 === C ? void 0 : C.payload) || -1
                                        } : {};
                                        return v(v({}, b), P);
                                    }, e3.prototype.addNetworkTypeEventListener = function() {
                                        var g, f, S, v, _ = this;
                                        (null === (f = null === (g = window.navigator) || void 0 === g ? void 0 : g.connection) || void 0 === f ? void 0 : f.type) && (null === (v = null === (S = window.navigator) || void 0 === S ? void 0 : S.connection) || void 0 === v || v.addEventListener("change", function() {
                                            _.updateClientNetworkType();
                                        }));
                                    }, e3.prototype.updateClientNetworkType = function() {
                                        this.clientNetworkType = void 0, this.getClientNetworkType();
                                    }, e3.prototype.getClientNetworkType = function() {
                                        var g, f, S, v;
                                        if (void 0 === this.clientNetworkType) {
                                            var _ = "Unknown";
                                            if (null === (f = null === (g = window.navigator) || void 0 === g ? void 0 : g.connection) || void 0 === f ? void 0 : f.type) switch(null === (v = null === (S = window.navigator) || void 0 === S ? void 0 : S.connection) || void 0 === v ? void 0 : v.type){
                                                case "cellular":
                                                    _ = "WWAN";
                                                    break;
                                                case "ethernet":
                                                    _ = "Wired";
                                                    break;
                                                case "wifi":
                                                    _ = "Wireless";
                                                    break;
                                                default:
                                                    _ = "Unknown";
                                            }
                                            this.clientNetworkType = _;
                                        }
                                        return this.clientNetworkType;
                                    }, e3.prototype.getSdnReport = function(g) {
                                        var f, S = g.filter(function(g) {
                                            return [
                                                E.PlayerScenarioType.SdnPluginLoad,
                                                E.PlayerScenarioType.SdnPluginInitialize,
                                                E.PlayerScenarioType.SdnPluginSetSource
                                            ].includes(g.name);
                                        }), v = _(_([], S, !0), this.ecdnPluginEvents, !0), C = S.filter(function(g) {
                                            return void 0 !== g.failReason;
                                        }), T = S.filter(function(g) {
                                            return g.name === E.PlayerScenarioType.SdnPluginLoad;
                                        }).sort(function(g, f) {
                                            return f.startTime - g.startTime;
                                        })[0];
                                        return {
                                            sdn_loaded: !(null == T || void 0 !== T.failReason),
                                            sdn_details: null !== (f = null == T ? void 0 : T.details) && void 0 !== f ? f : "",
                                            sdn_error: C.length > 0 && C[C.length - 1].failReason || "",
                                            sdn_events: this.prepareForTelemetry(v)
                                        };
                                    }, e3.prototype.getStreamConnectionReport = function(g) {
                                        var f = g.filter(function(g) {
                                            return g.name === E.PlayerScenarioType.StreamConnection;
                                        });
                                        return {
                                            stream_connection_events: this.prepareForTelemetry(f)
                                        };
                                    }, e3.prototype.getSetSourceReport = function(g) {
                                        var f = g.filter(function(g) {
                                            return g.name === E.PlayerScenarioType.SetSource;
                                        });
                                        return {
                                            set_source_events: this.prepareForTelemetry(f)
                                        };
                                    }, e3.prototype.registerScenario = function(g, f) {
                                        this.playerEvents.push(new I(g, f));
                                    }, e3.prototype.completeScenario = function(g, f, S) {
                                        this.playerEvents.push(new I(g, S, f));
                                    }, e3.prototype.logTelemetryEvent = function(g) {
                                        this.config.debugLogging && (this.logFn("debug", "PlayerTelemetryEvent: ".concat(JSON.stringify(g))), this.logFn("debug", "PlayerDiagnosticData: ".concat(JSON.stringify(this.currentPlayerDiagnosticSnapshot))));
                                    }, e3.prototype.filterAndPrepareTelemetry = function() {
                                        var g = this, f = new Set;
                                        f.add("serviceLatencyCdg"), f.add("endToEndLatencyCdg"), f.add("videoEdgeLatencyCdg"), f.add("eventId"), f.add("templateId");
                                        var S = {};
                                        return Object.keys(this.currentPlayerDiagnosticSnapshot).forEach(function(v) {
                                            f.has(v) || (S["player_".concat(v)] = g.prepareForTelemetry(g.currentPlayerDiagnosticSnapshot[v]));
                                        }), S;
                                    }, e3.prototype.prepareForTelemetry = function(g) {
                                        return "boolean" == typeof g ? g : "string" == typeof g || void 0 === g ? g || "" : "number" == typeof g ? null != g ? g : -1 : JSON.stringify(g);
                                    }, e3.prototype.getScenario = function(g) {
                                        return this.playerEvents.filter(function(f) {
                                            return f.getName() === g;
                                        });
                                    }, e3.prototype.createTelemetryEvent = function(g, f, S) {
                                        var v, _, C = {
                                            eventType: g,
                                            timestamp: Date.now(),
                                            currentPlayPosition: null !== (_ = null === (v = this.currentPlayerDiagnosticSnapshot) || void 0 === v ? void 0 : v.currentPlayPosition) && void 0 !== _ ? _ : -1
                                        };
                                        return void 0 !== f && (C.payload = this.prepareForTelemetry(f)), C.message = S, C;
                                    }, e3.prototype.modifyTelemetryEventPayload = function(g, f, S) {
                                        try {
                                            if (g.payload) {
                                                var _ = JSON.parse(g.payload);
                                                _ = S ? v(v({}, _), f) : v(v({}, f), _), g.payload = this.prepareForTelemetry(_);
                                            } else g.payload = this.prepareForTelemetry(f);
                                        } catch (f) {
                                            this.logFn("error", "Failed to modify payload for event: ".concat(T.stringifyObject(g), ", error: ").concat(f));
                                        }
                                    }, e3.prototype.registerExperimentalEvent = function(g, f, S) {
                                        var v = this.createTelemetryEvent(g, f, S);
                                        this.experimentalEvents.push(v), this.experimentalEvents.length > this.maxPlayerExperimentalEvents && this.experimentalEvents.splice(0, 1), this.logTelemetryEvent(v);
                                    }, e3.prototype.getExperimentalEvents = function() {
                                        return {
                                            playback_experimentalEvents: this.prepareForTelemetry(this.experimentalEvents)
                                        };
                                    }, e3.prototype.registerUserInitiatedSeek = function(g) {
                                        var f, S, v = {
                                            newCurrentPlayPosition: g,
                                            seekForward: (null !== (S = null === (f = this.currentPlayerDiagnosticSnapshot) || void 0 === f ? void 0 : f.currentPlayPosition) && void 0 !== S ? S : -1) < g
                                        }, _ = this.createTelemetryEvent(E.TelemetryEventType.UserInitiatedSeek, v);
                                        this.userInitiatedSeekEvents.push(_), this.userInitiatedSeekEvents.length > this.maxUserInitiatedEventCount && this.userInitiatedSeekEvents.splice(0, 1);
                                    }, e3.prototype.registerUserInitiatedPlay = function() {
                                        var g = this.createTelemetryEvent(E.TelemetryEventType.UserInitiatedPlay);
                                        this.userInitiatedPlayEvents.push(g), this.userInitiatedPlayEvents.length > this.maxUserInitiatedEventCount && this.userInitiatedPlayEvents.splice(0, 1);
                                    }, e3.prototype.registerUserInitiatedPause = function() {
                                        var g = this.createTelemetryEvent(E.TelemetryEventType.UserInitiatedPause);
                                        this.userInitiatedPauseEvents.push(g), this.userInitiatedPauseEvents.length > this.maxUserInitiatedEventCount && this.userInitiatedPauseEvents.splice(0, 1);
                                    }, e3.prototype.getUserInitiatedSeekEvents = function() {
                                        return {
                                            playback_userInitiatedSeekEvents: this.prepareForTelemetry(this.userInitiatedSeekEvents),
                                            playback_userInitiatedPlayEvents: this.prepareForTelemetry(this.userInitiatedPlayEvents),
                                            playback_userInitiatedPauseEvents: this.prepareForTelemetry(this.userInitiatedPauseEvents)
                                        };
                                    }, e3.prototype.registerPlayBlocked = function(g) {
                                        this.registerScenario(E.PlayerScenarioType.PlayAttemptBlocked, "Called video element play() but it failed with error: ".concat(g)), this.completeScenario(E.PlayerScenarioType.PlayAttemptBlocked);
                                    }, e3;
                                }();
                                f.LiveStreamStatistic = b;
                            },
                            42: function(g, f) {
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.Spinner = void 0;
                                var S = function() {
                                    function e3(g) {
                                        this.container = g, this.spinnerId = "hydra-player-spinner", this.firstSpinnerShowTimestamp = null, this.firstSpinnerHideTimestamp = null, this.spinnerInfoHistory = [], this.maxTimestampHistorySize = 100;
                                        var f = this.container.ownerDocument.getElementById(this.spinnerId);
                                        if (f) return this.spinner = f, void this.show();
                                        var S = this.container.ownerDocument.createElement("style");
                                        S.textContent = "\n            .ml-player-spinner-container {\n                width: 100%;\n                height: 100%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                position: absolute;\n                pointer-events: none;\n            }\n            .ml-player-spinner {\n                width: 3.6rem;\n                height: 3.6rem;\n                display: block;\n                overflow-clip-margin: content-box;\n                overflow: hidden;\n                animation: ml-player-spinner-outer-rotate 3s linear infinite;\n            }\n            .ml-player-spinner-dark-wheel {\n                fill: none;\n                r: 45%;\n                cx: 50%;\n                cy: 50%;\n                stroke: rgb(68, 71, 145);\n                stroke-width: 8px;\n            }\n            .ml-player-spinner-light-wheel {\n                fill: none;\n                r: 45%;\n                cx: 50%;\n                cy: 50%;\n                stroke: rgb(127, 133, 245);\n                stroke-width: 8px;\n                stroke-dasharray: 283;\n                stroke-dashoffset: 280;\n                stroke-linecap: round;\n                transform-origin: 50% 50%;\n                animation: ml-player-spinner-inner-rotate 1.5s cubic-bezier(0.33, 0, 0.67, 1) infinite;\n            }\n            @keyframes ml-player-spinner-outer-rotate {\n                0% {\n                    transform: rotate(0deg);\n                }\n                100% {\n                    transform: rotate(360deg);\n                }\n            }\n            @keyframes ml-player-spinner-inner-rotate {\n                0% {\n                    stroke-dashoffset: 283;\n                    transform: rotate(0deg);\n                }\n                25% {\n                    stroke-dashoffset: 283;\n                    transform: rotate(0deg);\n                }\n                50% {\n                    stroke-dashoffset: 75;\n                    transform: rotate(45deg);\n                }\n                75% {\n                    stroke-dashoffset: 75;\n                    transform: rotate(45deg);\n                }\n                100% {\n                    stroke-dashoffset: 283;\n                    transform: rotate(360deg);\n                }\n            }\n        ", this.container.ownerDocument.head.appendChild(S), this.container.style.position = "relative";
                                        var v = this.container.ownerDocument.createElement("div");
                                        v.classList.add("ml-player-spinner-container"), this.container.appendChild(v), this.spinner = this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "svg"), this.spinner.style.position = "absolute", this.spinner.setAttribute("viewBox", "0 0 100 100"), this.spinner.classList.add("ml-player-spinner"), this.spinner.id = this.spinnerId, v.appendChild(this.spinner);
                                        var _ = this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "circle");
                                        _.classList.add("ml-player-spinner-dark-wheel"), this.spinner.appendChild(_);
                                        var C = this.container.ownerDocument.createElementNS("http://www.w3.org/2000/svg", "circle");
                                        C.classList.add("ml-player-spinner-light-wheel"), this.spinner.appendChild(C), this.show();
                                    }
                                    return Object.defineProperty(e3.prototype, "firstShowTimestamp", {
                                        get: function() {
                                            return this.firstSpinnerShowTimestamp;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), Object.defineProperty(e3.prototype, "firstHideTimestamp", {
                                        get: function() {
                                            return this.firstSpinnerHideTimestamp;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), Object.defineProperty(e3.prototype, "firstSpinnerDuration", {
                                        get: function() {
                                            return this.firstSpinnerShowTimestamp ? this.firstSpinnerHideTimestamp ? this.firstSpinnerHideTimestamp - this.firstSpinnerShowTimestamp : Date.now() - this.firstSpinnerShowTimestamp : null;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), Object.defineProperty(e3.prototype, "visibilityHistory", {
                                        get: function() {
                                            if (this.spinnerInfoHistory.length > 0) {
                                                var g = this.spinnerInfoHistory[this.spinnerInfoHistory.length - 1];
                                                g.hideTimestamp || (g.displayDuration = Date.now() - g.showTimestamp);
                                            }
                                            return this.spinnerInfoHistory;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), e3.prototype.show = function() {
                                        var g = Date.now();
                                        this.firstSpinnerShowTimestamp || (this.firstSpinnerShowTimestamp = g), (0 === this.spinnerInfoHistory.length || this.spinnerInfoHistory[this.spinnerInfoHistory.length - 1].hideTimestamp) && (this.spinnerInfoHistory.push({
                                            showTimestamp: g,
                                            displayDuration: 0
                                        }), this.spinnerInfoHistory.length > this.maxTimestampHistorySize && this.spinnerInfoHistory.splice(0, 1)), this.spinner.style.display = "block";
                                    }, e3.prototype.hide = function() {
                                        var g = Date.now();
                                        if (this.firstSpinnerHideTimestamp || (this.firstSpinnerHideTimestamp = g), this.spinnerInfoHistory.length > 0) {
                                            var f = this.spinnerInfoHistory[this.spinnerInfoHistory.length - 1];
                                            f.hideTimestamp || (f.hideTimestamp = g, f.displayDuration = g - f.showTimestamp);
                                        }
                                        this.spinner.style.display = "none";
                                    }, e3.prototype.isVisible = function() {
                                        return "none" !== this.spinner.style.display;
                                    }, e3;
                                }();
                                f.Spinner = S;
                            },
                            378: function(g, f) {
                                var S, v;
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.MessageType = void 0, (v = S || (f.MessageType = S = {})).Command = "Command", v.CommandSuccessResult = "CommandSuccessResult", v.CommandFailureResult = "CommandFailureResult", v.PlayerEvent = "PlayerEvent", v.InternalPlayerEvent = "InternalPlayerEvent";
                            },
                            963: function(g, f) {
                                var S, v, _;
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.PlayerScenarioType = f.TelemetryEventType = void 0, (_ = S || (f.TelemetryEventType = S = {})).BitrateChangedDownload = "BitrateChangedDownload", _.StreamOptionsConfigured = "StreamOptionsConfigured", _.BitrateChangedPlayback = "BitrateChangedPlayback", _.CaptionsToggled = "CaptionsToggled", _.Error = "Error", _.IgnoredError = "IgnoredError", _.FullscreenChanged = "FullscreenChanged", _.Mute = "Mute", _.PotentialMediaFreeze = "PotentialMediaFreeze", _.StateChanged = "StateChanged", _.HydraInputStateChanged = "HydraInputStateChanged", _.HydraOutputStateChanged = "HydraOutputStateChanged", _.Volume = "Volume", _.Buffering = "Buffering", _.Online = "Online", _.Offline = "Offline", _.NetworkChange = "NetworkChange", _.HlsEvents = "HlsEvents", _.EcdnPluginEvents = "EcdnPluginEvents", _.UserInitiatedSeek = "UserInitiatedSeek", _.UserInitiatedPlay = "UserInitiatedPlay", _.UserInitiatedPause = "UserInitiatedPause", function(g) {
                                    g.LoadHydra = "LoadHydra", g.LoadHlsScript = "LoadHlsScript", g.LoadPlayer = "LoadPlayer", g.Load = "Load", g.LoadHlsAuthCookie = "LoadHlsAuthCookie", g.HlsManifestLoad = "HlsManifestLoad", g.HlsKeyLoad = "HlsKeyLoad", g.LoadHlsFirstFragment = "LoadHlsFirstFragment", g.SetSource = "SetSource", g.SdnPluginLoad = "SdnPluginLoad", g.ThaPluginLoad = "ThaPluginLoad", g.HydraPipelineInitialization = "HydraPipelineInitialization", g.Destroyed = "Destroyed", g.Setup = "Setup", g.StreamConnection = "StreamConnection", g.SdnPluginInitialize = "SdnPluginInitialize", g.SdnPluginSetSource = "SdnPluginSetSource", g.PlayAttemptBlocked = "PlayAttemptBlocked";
                                }(v || (f.PlayerScenarioType = v = {}));
                            },
                            176: function(g, f) {
                                var S, v, _, C, E, T, I, b;
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.MobileInteractionType = f.HydraSupportedSDN = f.HydraPlayerDestroyedReason = f.HydraOutputState = f.HydraInputState = f.HydraPlayerPlaybackErrorSource = f.PlaybackMode = void 0, (b = S || (f.PlaybackMode = S = {})).Live = "Live", b.DVR = "DVR", function(g) {
                                    g.Stream = "Stream", g.HydraPipeline = "HydraPipeline", g.VideoPlayer = "VideoPlayer";
                                }(v || (f.HydraPlayerPlaybackErrorSource = v = {})), function(g) {
                                    g.Idle = "Idle", g.Started = "Started", g.BufferReceived = "BufferReceived", g.Ended = "Ended", g.Stopped = "Stopped", g.Destroyed = "Destroyed";
                                }(_ || (f.HydraInputState = _ = {})), function(g) {
                                    g.Idle = "Idle", g.Attached = "Attached", g.Starting = "Starting", g.Started = "Started", g.BufferReceived = "BufferReceived", g.BufferAppended = "BufferAppended", g.Stopped = "Stopped", g.Destroyed = "Destroyed";
                                }(C || (f.HydraOutputState = C = {})), function(g) {
                                    g.PlayerStopped = "PlayerStopped", g.PlaybackError = "PlaybackError";
                                }(E || (f.HydraPlayerDestroyedReason = E = {})), function(g) {
                                    g.Hive = "hive", g.Kollective = "kollective", g.Ramp = "ramp", g.Peer5 = "peer5", g.Microsoft = "microsoft";
                                }(T || (f.HydraSupportedSDN = T = {})), function(g) {
                                    g[g.DoublePress3Fingers = 0] = "DoublePress3Fingers";
                                }(I || (f.MobileInteractionType = I = {}));
                            },
                            346: function(g, f) {
                                var S, v, _, C, E, T, I, b, A;
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.HttpFetchErrorReason = f.IframeMessages = f.HydraPlayerType = f.HydraPlayerPlaybackErrorType = f.HydraPlayerPlaybackState = f.HydraPlayerSetupErrorType = f.HydraStreamDeliveryPipeline = f.HydraStreamingEventType = void 0, (A = S || (f.HydraStreamingEventType = S = {})).TLE = "TLE", A.Overflow = "Overflow", A.TownHallBasic = "TownHall_Basic", A.TownHallPremium = "TownHall_Premium", A.TownHall = "TownHall", function(g) {
                                    g.AMS = "AMS", g.HLS = "MiddleLaneHttpLiveStreaming", g.Ums = "MiddleLaneUltraLowLatency";
                                }(v || (f.HydraStreamDeliveryPipeline = v = {})), function(g) {
                                    g.MultiplePlayerLoad = "MultiplePlayerLoad", g.PlayerInitializationFailed = "PlayerInitializationFailed", g.InvalidStream = "InvalidStream", g.SetSourceFailed = "SetSourceFailed";
                                }(_ || (f.HydraPlayerSetupErrorType = _ = {})), function(g) {
                                    g.LoadStart = "loadstart", g.LoadedData = "loadeddata", g.LoadedMetadata = "loadedmetadata", g.Start = "start", g.CanPlayThrough = "canplaythrough", g.Play = "play", g.Playing = "playing", g.Pause = "pause", g.Waiting = "waiting", g.Seeking = "seeking", g.Seeked = "seeked", g.Ended = "ended", g.Error = "error", g.Destroyed = "destroyed", g.Initialized = "initialized", g.Stalled = "stalled", g.VolumeChange = "volumechange", g.PlaybackBitrateChanged = "playbackbitratechanged", g.DownloadBitrateChanged = "downloadbitratechanged", g.TimeUpdate = "timeupdate", g.DurationChange = "durationchange", g.HlsKeyLoading = "hlsKeyLoading", g.HlsKeyLoaded = "hlsKeyLoaded", g.HlsKeyLoadedFailed = "hlsKeyLoadedFailed", g.HlsManifestLoading = "hlsManifestLoading", g.HlsManifestLoaded = "hlsManifestLoaded", g.HlsManifestLoadedFailed = "hlsManifestLoadedFailed", g.HlsFirstFragmentLoading = "hlsFragLoading", g.HlsFirstFragmentBuffered = "hlsFragBuffered", g.HlsFirstFragmentLoadFailed = "hlsFirstFragmentLoadFailed", g.HlsFragmentChanged = "hlsFragmentChanged", g.Online = "online", g.Offline = "offline", g.NetworkChange = "networkChange";
                                }(C || (f.HydraPlayerPlaybackState = C = {})), function(g) {
                                    g.UnsupportedPlatform = "UnsupportedPlatform", g.NetworkError = "NetworkError", g.PlaybackRetried = "PlaybackRetried", g.PlaybackError = "PlaybackError", g.Unknown = "Unknown", g.MediaTimeout = "MediaTimeout", g.NoMediaFlow = "NoMediaFlow";
                                }(E || (f.HydraPlayerPlaybackErrorType = E = {})), function(g) {
                                    g[g.Hls = 1] = "Hls", g[g.Ums = 2] = "Ums";
                                }(T || (f.HydraPlayerType = T = {})), function(g) {
                                    g.RequestIceCandidates = "RequestIceCandidates";
                                }(I || (f.IframeMessages = I = {})), function(g) {
                                    g.Unknown = "Unknown", g.ClientNetwork = "ClientNetwork", g.ClientNetworkOrUnreachableServer = "ClientNetworkOrUnreachableServer", g.ServerNetwork = "ServerNetwork", g.ClientAuthIssue = "ClientAuthIssue", g.ServerResourceNotFound = "ServerResourceNotFound";
                                }(b || (f.HttpFetchErrorReason = b = {}));
                            },
                            534: function(g, f, S) {
                                var v = this && this.__awaiter || function(g, f, S, v) {
                                    return new (S || (S = Promise))(function(_, C) {
                                        function o2(g) {
                                            try {
                                                l2(v.next(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function s2(g) {
                                            try {
                                                l2(v.throw(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function l2(g) {
                                            var f;
                                            g.done ? _(g.value) : (f = g.value, f instanceof S ? f : new S(function(g) {
                                                g(f);
                                            })).then(o2, s2);
                                        }
                                        l2((v = v.apply(g, f || [])).next());
                                    });
                                }, _ = this && this.__generator || function(g, f) {
                                    var S, v, _, C, E = {
                                        label: 0,
                                        sent: function() {
                                            if (1 & _[0]) throw _[1];
                                            return _[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                    return C = {
                                        next: s2(0),
                                        throw: s2(1),
                                        return: s2(2)
                                    }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                                        return this;
                                    }), C;
                                    function s2(T) {
                                        return function(I) {
                                            return function(T) {
                                                if (S) throw new TypeError("Generator is already executing.");
                                                for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                                    if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                                    switch(v = 0, _ && (T = [
                                                        2 & T[0],
                                                        _.value
                                                    ]), T[0]){
                                                        case 0:
                                                        case 1:
                                                            _ = T;
                                                            break;
                                                        case 4:
                                                            return E.label++, {
                                                                value: T[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            E.label++, v = T[1], T = [
                                                                0
                                                            ];
                                                            continue;
                                                        case 7:
                                                            T = E.ops.pop(), E.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((_ = (_ = E.trys).length > 0 && _[_.length - 1]) || 6 !== T[0] && 2 !== T[0])) {
                                                                E = 0;
                                                                continue;
                                                            }
                                                            if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                                                E.label = T[1];
                                                                break;
                                                            }
                                                            if (6 === T[0] && E.label < _[1]) {
                                                                E.label = _[1], _ = T;
                                                                break;
                                                            }
                                                            if (_ && E.label < _[2]) {
                                                                E.label = _[2], E.ops.push(T);
                                                                break;
                                                            }
                                                            _[2] && E.ops.pop(), E.trys.pop();
                                                            continue;
                                                    }
                                                    T = f.call(g, E);
                                                } catch (g) {
                                                    T = [
                                                        6,
                                                        g
                                                    ], v = 0;
                                                } finally{
                                                    S = _ = 0;
                                                }
                                                if (5 & T[0]) throw T[1];
                                                return {
                                                    value: T[0] ? T[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                T,
                                                I
                                            ]);
                                        };
                                    }
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.isPlaybackStoppingState = f.tryCallVideoElementPlay = f.sanitizeForFormatSpecifiers = f.addEvent = f.TimeRanges = f.NO_OP_BUFFERED = f.getHttpFetchErrorReason = f.createVideoPlayButton = f.createVideoElement = f.createVideoElementDiv = f.showPlayerControls = f.repeatUntilCancel = f.wait = f.stringifyError = f.stringifyObject = f.getRandomHexString = f.getPlayerSetting = f.getECSSetting = f.retry = f.createIFrame = f.getMajorFromVersion = void 0;
                                var C = S(346);
                                function o(g, f, S, C, E, T, I) {
                                    return v(this, void 0, void 0, function() {
                                        var b, A, R, P, w, M = this;
                                        return _(this, function(O) {
                                            switch(O.label){
                                                case 0:
                                                    return b = 100, A = Date.now(), [
                                                        4,
                                                        l(S, R = {
                                                            trackingRef: "",
                                                            timeTakenToDownloadScript: -1
                                                        }, E, T, I).catch(function(g) {
                                                            return v(M, void 0, void 0, function() {
                                                                var f;
                                                                return _(this, function(v) {
                                                                    switch(v.label){
                                                                        case 0:
                                                                            return f = "Failed to get IFrame source: ".concat(u(g)), C.push({
                                                                                success: !1,
                                                                                url: S,
                                                                                startTime: A,
                                                                                duration: Date.now() - A,
                                                                                trackingReference: R.trackingRef,
                                                                                timeTakenToDownloadScript: R.timeTakenToDownloadScript,
                                                                                errorMsg: f
                                                                            }), C.length > b && C.shift(), [
                                                                                4,
                                                                                Promise.reject(new Error(f))
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                v.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    return P = O.sent(), f.srcdoc = P, w = new Promise(function(g, v) {
                                                        f.onload = function() {
                                                            C.push({
                                                                success: !0,
                                                                url: S,
                                                                startTime: A,
                                                                duration: Date.now() - A,
                                                                trackingReference: R.trackingRef,
                                                                timeTakenToDownloadScript: R.timeTakenToDownloadScript
                                                            }), C.length > b && C.shift(), g();
                                                        }, f.onerror = function(g) {
                                                            var f = "Failed to load HydraPlayer IFrame: ".concat(u(g));
                                                            C.push({
                                                                success: !1,
                                                                url: S,
                                                                startTime: A,
                                                                duration: Date.now() - A,
                                                                trackingReference: R.trackingRef,
                                                                timeTakenToDownloadScript: R.timeTakenToDownloadScript,
                                                                errorMsg: f
                                                            }), C.length > b && C.shift(), v(new Error(f));
                                                        };
                                                    }), g.appendChild(f), [
                                                        4,
                                                        w
                                                    ];
                                                case 2:
                                                    return O.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                }
                                function s(g) {
                                    return v(this, arguments, void 0, function(g, f, S) {
                                        var C = this;
                                        return void 0 === f && (f = 5), void 0 === S && (S = 200), _(this, function(E) {
                                            switch(E.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        g(f).catch(function(E) {
                                                            return v(C, void 0, void 0, function() {
                                                                var C = this;
                                                                return _(this, function(T) {
                                                                    switch(T.label){
                                                                        case 0:
                                                                            return 0 != --f ? [
                                                                                3,
                                                                                2
                                                                            ] : [
                                                                                4,
                                                                                Promise.reject(new Error("[retry] retries exhausted: ".concat(p(E))))
                                                                            ];
                                                                        case 1:
                                                                        case 3:
                                                                            return [
                                                                                2,
                                                                                T.sent()
                                                                            ];
                                                                        case 2:
                                                                            return [
                                                                                4,
                                                                                new Promise(function(T) {
                                                                                    return setTimeout(function() {
                                                                                        T(s(g, f, S).catch(function(g) {
                                                                                            return v(C, void 0, void 0, function() {
                                                                                                return _(this, function(f) {
                                                                                                    switch(f.label){
                                                                                                        case 0:
                                                                                                            return [
                                                                                                                4,
                                                                                                                Promise.reject(new Error("".concat(p(E)).concat(", ", p(g))))
                                                                                                            ];
                                                                                                        case 1:
                                                                                                            return [
                                                                                                                2,
                                                                                                                f.sent()
                                                                                                            ];
                                                                                                    }
                                                                                                });
                                                                                            });
                                                                                        }));
                                                                                    }, S);
                                                                                })
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        E.sent()
                                                    ];
                                            }
                                        });
                                    });
                                }
                                function l(g, f, S, C, E) {
                                    return v(this, void 0, void 0, function() {
                                        var T, I, b, A = this;
                                        return _(this, function(R) {
                                            switch(R.label){
                                                case 0:
                                                    return T = Date.now(), S ? (I = '<script src="'.concat(g, '"></script') + ">", [
                                                        3,
                                                        3
                                                    ]) : [
                                                        3,
                                                        1
                                                    ];
                                                case 1:
                                                    return [
                                                        4,
                                                        c(g, f, C).catch(function(g) {
                                                            return v(A, void 0, void 0, function() {
                                                                return _(this, function(f) {
                                                                    switch(f.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                Promise.reject(g)
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                f.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        })
                                                    ];
                                                case 2:
                                                    b = R.sent(), I = E ? '<script nonce="'.concat(E, '">').concat(b, "</script") + ">" : "<script>".concat(b, "</script") + ">", R.label = 3;
                                                case 3:
                                                    return f.timeTakenToDownloadScript = Date.now() - T, [
                                                        2,
                                                        "\n        <html class style='height: 100%; width: 100%; overflow: hidden'>\n        <head></head>\n        <body class style='height: 100%; width: 100%; margin: 0px'>\n            ".concat(I, "\n        </body>\n        </html>\n    ")
                                                    ];
                                            }
                                        });
                                    });
                                }
                                function c(g, f, S) {
                                    return v(this, void 0, void 0, function() {
                                        var C, E, T, I = this;
                                        return _(this, function(b) {
                                            switch(b.label){
                                                case 0:
                                                    return C = function(g, f) {
                                                        var S, v;
                                                        return f.includes("vz") ? null !== (v = g.headers.get("uuid")) && void 0 !== v ? v : "" : null !== (S = g.headers.get("X-Azure-Ref")) && void 0 !== S ? S : "";
                                                    }, S ? (E = new AbortController, T = setTimeout(function() {
                                                        E.abort();
                                                    }, S), [
                                                        4,
                                                        fetch(g, {
                                                            signal: E.signal,
                                                            cache: "no-cache"
                                                        }).then(function(S) {
                                                            return v(I, void 0, void 0, function() {
                                                                return _(this, function(v) {
                                                                    switch(v.label){
                                                                        case 0:
                                                                            return clearTimeout(T), S.ok ? [
                                                                                3,
                                                                                2
                                                                            ] : [
                                                                                4,
                                                                                Promise.reject(new Error("".concat(S.status)))
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                v.sent()
                                                                            ];
                                                                        case 2:
                                                                            return f.trackingRef = C(S, g), [
                                                                                2,
                                                                                S
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        }).then(function(f) {
                                                            return v(I, void 0, void 0, function() {
                                                                var S = this;
                                                                return _(this, function(C) {
                                                                    switch(C.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                f.text().then(function(C) {
                                                                                    return v(S, void 0, void 0, function() {
                                                                                        return _(this, function(S) {
                                                                                            switch(S.label){
                                                                                                case 0:
                                                                                                    return C ? [
                                                                                                        2,
                                                                                                        C
                                                                                                    ] : [
                                                                                                        3,
                                                                                                        1
                                                                                                    ];
                                                                                                case 1:
                                                                                                    return [
                                                                                                        4,
                                                                                                        Promise.reject(new Error("".concat(f.status, ", script ").concat(g, " contents are null")))
                                                                                                    ];
                                                                                                case 2:
                                                                                                    return [
                                                                                                        2,
                                                                                                        S.sent()
                                                                                                    ];
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                })
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                C.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        }).catch(function(g) {
                                                            return v(I, void 0, void 0, function() {
                                                                return _(this, function(f) {
                                                                    throw clearTimeout(T), g;
                                                                });
                                                            });
                                                        })
                                                    ]) : [
                                                        3,
                                                        2
                                                    ];
                                                case 1:
                                                case 3:
                                                    return [
                                                        2,
                                                        b.sent()
                                                    ];
                                                case 2:
                                                    return [
                                                        4,
                                                        fetch(g, {
                                                            cache: "no-cache"
                                                        }).then(function(S) {
                                                            return v(I, void 0, void 0, function() {
                                                                return _(this, function(v) {
                                                                    switch(v.label){
                                                                        case 0:
                                                                            return S.ok ? [
                                                                                3,
                                                                                2
                                                                            ] : [
                                                                                4,
                                                                                Promise.reject(new Error("".concat(S.status)))
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                v.sent()
                                                                            ];
                                                                        case 2:
                                                                            return f.trackingRef = C(S, g), [
                                                                                2,
                                                                                S
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        }).then(function(f) {
                                                            return v(I, void 0, void 0, function() {
                                                                var S = this;
                                                                return _(this, function(C) {
                                                                    switch(C.label){
                                                                        case 0:
                                                                            return [
                                                                                4,
                                                                                f.text().then(function(C) {
                                                                                    return v(S, void 0, void 0, function() {
                                                                                        return _(this, function(S) {
                                                                                            switch(S.label){
                                                                                                case 0:
                                                                                                    return C ? [
                                                                                                        2,
                                                                                                        C
                                                                                                    ] : [
                                                                                                        3,
                                                                                                        1
                                                                                                    ];
                                                                                                case 1:
                                                                                                    return [
                                                                                                        4,
                                                                                                        Promise.reject(new Error("".concat(f.status, ", script ").concat(g, " contents are null")))
                                                                                                    ];
                                                                                                case 2:
                                                                                                    return [
                                                                                                        2,
                                                                                                        S.sent()
                                                                                                    ];
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                })
                                                                            ];
                                                                        case 1:
                                                                            return [
                                                                                2,
                                                                                C.sent()
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        })
                                                    ];
                                            }
                                        });
                                    });
                                }
                                function d(g, f, S) {
                                    var v, _ = S, C = null === (v = g.ecsSettings) || void 0 === v ? void 0 : v[f];
                                    return typeof C == typeof _ && (_ = C), _;
                                }
                                function u(g) {
                                    try {
                                        if (!g) return "".concat(g);
                                        if (g instanceof Map) return S = {}, g.forEach(function(g, f) {
                                            S[f.toString()] = g;
                                        }), JSON.stringify(S);
                                        var f = g.toString();
                                        return f.endsWith("[object Object]") ? JSON.stringify(g) : f;
                                    } catch (g) {
                                        return "";
                                    }
                                    var S;
                                }
                                function p(g) {
                                    return g instanceof Error ? g.message : u(g);
                                }
                                function y(g) {
                                    return v(this, void 0, void 0, function() {
                                        return _(this, function(f) {
                                            switch(f.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        new Promise(function(f) {
                                                            return setTimeout(f, g);
                                                        })
                                                    ];
                                                case 1:
                                                    return f.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    });
                                }
                                function h(g) {
                                    return g ? g.replace(/%[a-zA-Z]/g, "") : g;
                                }
                                f.getMajorFromVersion = function(g) {
                                    var f = g.match(/^(\d+)\.\d+\.\d+(-.*)?$/);
                                    return f ? f[1] : null;
                                }, f.createIFrame = function(g, f, S) {
                                    return v(this, void 0, void 0, function() {
                                        var C, E, T, I, b, A, R, P, w, M, O = this;
                                        return _(this, function(D) {
                                            switch(D.label){
                                                case 0:
                                                    return C = d(S, "scriptSrcDownload", !1), E = d(S, "allowSameOrigin", !1), T = S.maxRetryCountForLoadingResources, I = S.disableSandbox, b = S.hydraRuntimeFetchTimeout, A = [], (R = g.ownerDocument.createElement("iframe")).id = "player-iframe", I || (E ? null === (w = R.sandbox) || void 0 === w || w.add("allow-scripts", "allow-same-origin") : null === (M = R.sandbox) || void 0 === M || M.add("allow-scripts")), R.allowFullscreen = !0, R.allow = "camera; microphone; autoplay", R.style.height = "100%", R.style.width = "100%", R.style.border = "none", P = function(g) {
                                                        return f[g % f.length];
                                                    }, [
                                                        4,
                                                        s(function(f) {
                                                            return v(O, void 0, void 0, function() {
                                                                var v, E, T;
                                                                return _(this, function(_) {
                                                                    switch(_.label){
                                                                        case 0:
                                                                            return v = P(f), E = null !== (T = S.nonce) && void 0 !== T ? T : "", [
                                                                                4,
                                                                                o(g, R, v, A, C, b, E)
                                                                            ];
                                                                        case 1:
                                                                            return _.sent(), [
                                                                                2
                                                                            ];
                                                                    }
                                                                });
                                                            });
                                                        }, T).then(function() {
                                                            return {
                                                                iframe: R,
                                                                initResult: {
                                                                    isSuccess: !0,
                                                                    runtimeDownloadResults: A
                                                                }
                                                            };
                                                        }).catch(function(g) {
                                                            return v(O, void 0, void 0, function() {
                                                                var S;
                                                                return _(this, function(v) {
                                                                    return S = "Failed to load Hydra player runtime scripts, src: ", f.forEach(function(g) {
                                                                        return S = S.concat(g, ", ");
                                                                    }), S += "errors: ".concat(u(g)), [
                                                                        2,
                                                                        {
                                                                            initResult: {
                                                                                isSuccess: !1,
                                                                                runtimeDownloadResults: A,
                                                                                errorMsg: S
                                                                            }
                                                                        }
                                                                    ];
                                                                });
                                                            });
                                                        })
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        D.sent()
                                                    ];
                                            }
                                        });
                                    });
                                }, f.retry = s, f.getECSSetting = d, f.getPlayerSetting = function(g, f) {
                                    var S;
                                    return void 0 !== (null === (S = g.ecsSettings) || void 0 === S ? void 0 : S[f]) ? g.ecsSettings[f] : g[f];
                                }, f.getRandomHexString = function(g) {
                                    return Array.from(Array(g)).map(function() {
                                        return Math.floor(16 * Math.random()).toString(16);
                                    }).join("");
                                }, f.stringifyObject = u, f.stringifyError = p, f.wait = y, f.repeatUntilCancel = function(g, f, S, C) {
                                    var E = !1, T = C || console.log, I = h(g);
                                    return T("RepeatUntilCancel starting task: ".concat(I)), v(this, void 0, void 0, function() {
                                        var g, v, C;
                                        return _(this, function(_) {
                                            switch(_.label){
                                                case 0:
                                                    return E ? [
                                                        3,
                                                        2
                                                    ] : (g = new Date, f(), v = (new Date).getTime() - g.getTime(), (C = S - v) < 0 && (C = S + C % S, T("Skipping execution for ".concat(I, ", last execution took: ").concat(v, " ms, delayMs: ").concat(S), "warn")), [
                                                        4,
                                                        y(C)
                                                    ]);
                                                case 1:
                                                    return _.sent(), [
                                                        3,
                                                        0
                                                    ];
                                                case 2:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }), function() {
                                        T("RepeatUntilCancel stopping task: ".concat(I)), E = !0;
                                    };
                                }, f.showPlayerControls = function(g) {
                                    return void 0 !== g.allowPlayerControls ? g.allowPlayerControls : g.streamingEventType === C.HydraStreamingEventType.TLE;
                                }, f.createVideoElementDiv = function(g, f, S) {
                                    S("createVideoElementDiv started");
                                    var v = f.ownerDocument.createElement("div");
                                    return v.id = g, v.style.position = "relative", v.style.width = "100%", v.style.height = "100%", f.appendChild(v), S("createVideoElementDiv done"), v;
                                }, f.createVideoElement = function(g, f, S, v, _) {
                                    _("createVideoElement started");
                                    var C = f.ownerDocument.createElement("video");
                                    C.controls = v, C.id = g, C.setAttribute("playsinline", "");
                                    var E = S.videoLang;
                                    E && (C.setAttribute("lang", E), _("createVideoElement: language set to ".concat(E)));
                                    var T = S.videoElementStyles;
                                    if (T) for(var I = 0; I < T.length; I++)C.classList.add(T[I]);
                                    return C.style.width = "100%", C.style.height = "100%", C.style.position = "absolute", C.muted = S.muteVideo, C.addEventListener("contextmenu", function(g) {
                                        g.preventDefault();
                                    }), [
                                        "play",
                                        "pause",
                                        "stop",
                                        "seekbackward",
                                        "seekforward",
                                        "seekto",
                                        "previoustrack",
                                        "nexttrack"
                                    ].forEach(function(g) {
                                        try {
                                            navigator.mediaSession.setActionHandler(g, function() {});
                                        } catch (g) {}
                                    }), f.appendChild(C), _("createVideoElement done"), C;
                                }, f.createVideoPlayButton = function(g, f, S, v, _) {
                                    _("createVideoPlayButton started");
                                    var C = f.ownerDocument.createElement("div");
                                    C.id = g, C.style.width = "0", C.style.height = "0", C.style.position = "absolute";
                                    var E = Math.min(S.offsetWidth, S.offsetHeight) / 3, T = .866 * E;
                                    return C.style.borderTop = (E / 2).toString() + "px solid transparent", C.style.borderBottom = (E / 2).toString() + "px solid transparent", C.style.borderLeft = T.toString() + "px solid rgb(123, 131, 235)", C.style.left = (S.offsetWidth / 2 - T / 2).toString() + "px", C.style.top = (S.offsetHeight / 2 - E / 2).toString() + "px", v || (C.style.display = "none"), f.appendChild(C), _("createVideoPlayButton done"), C;
                                }, f.getHttpFetchErrorReason = function(g) {
                                    return void 0 === g ? C.HttpFetchErrorReason.Unknown : 0 === g ? C.HttpFetchErrorReason.ClientNetworkOrUnreachableServer : 401 === g ? C.HttpFetchErrorReason.ClientAuthIssue : 404 === g ? C.HttpFetchErrorReason.ServerResourceNotFound : g >= 400 && g <= 499 ? C.HttpFetchErrorReason.ClientNetwork : g >= 500 && g <= 599 ? C.HttpFetchErrorReason.ServerNetwork : C.HttpFetchErrorReason.Unknown;
                                }, f.NO_OP_BUFFERED = {
                                    length: 0,
                                    start: function() {
                                        return 0;
                                    },
                                    end: function() {
                                        return 0;
                                    }
                                }, f.TimeRanges = {
                                    toString: function(g) {
                                        for(var f = "", S = g.length, v = 0; v < S; v++)f += "[".concat(g.start(v).toFixed(3), "-").concat(g.end(v).toFixed(3), "]");
                                        return f;
                                    },
                                    range: function(g) {
                                        return g && 0 !== g.length ? [
                                            g.start(g.length - 1),
                                            g.end(g.length - 1)
                                        ] : [
                                            0,
                                            0
                                        ];
                                    },
                                    prevRange: function(g) {
                                        if (g && 2 === g.length) return [
                                            g.start(g.length - 2),
                                            g.end(g.length - 2)
                                        ];
                                    }
                                }, f.addEvent = function(g, f) {
                                    var S = {};
                                    return (null == f ? void 0 : f.detail) && (S = {
                                        detail: f.detail
                                    }), new CustomEvent(g, S);
                                }, f.sanitizeForFormatSpecifiers = h, f.tryCallVideoElementPlay = function(g) {
                                    var f = g.play();
                                    return void 0 !== f ? f : new Promise(function(g) {
                                        return g();
                                    });
                                }, f.isPlaybackStoppingState = function(g) {
                                    return g === C.HydraPlayerPlaybackState.Pause || g === C.HydraPlayerPlaybackState.Ended || g === C.HydraPlayerPlaybackState.Seeking || g === C.HydraPlayerPlaybackState.Waiting || g === C.HydraPlayerPlaybackState.Stalled || g === C.HydraPlayerPlaybackState.Destroyed;
                                };
                            },
                            564: function(g, f) {
                                var S, v, _, C, E, T, I, b, A, R;
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.UmsModality = f.HttpFetchErrorReason = f.IframeMessages = f.HydraPlayerType = f.HydraPlayerPlaybackErrorType = f.HydraPlayerPlaybackState = f.HydraPlayerSetupErrorType = f.HydraStreamDeliveryPipeline = f.HydraStreamingEventType = void 0, (R = S || (f.HydraStreamingEventType = S = {})).TLE = "TLE", R.Overflow = "Overflow", R.TownHallBasic = "TownHall_Basic", R.TownHallPremium = "TownHall_Premium", R.TownHall = "TownHall", function(g) {
                                    g.AMS = "AMS", g.HLS = "MiddleLaneHttpLiveStreaming", g.Ums = "MiddleLaneUltraLowLatency";
                                }(v || (f.HydraStreamDeliveryPipeline = v = {})), function(g) {
                                    g.MultiplePlayerLoad = "MultiplePlayerLoad", g.PlayerInitializationFailed = "PlayerInitializationFailed", g.InvalidStream = "InvalidStream", g.SetSourceFailed = "SetSourceFailed";
                                }(_ || (f.HydraPlayerSetupErrorType = _ = {})), function(g) {
                                    g.LoadStart = "loadstart", g.LoadedData = "loadeddata", g.LoadedMetadata = "loadedmetadata", g.Start = "start", g.CanPlayThrough = "canplaythrough", g.Play = "play", g.Playing = "playing", g.Pause = "pause", g.Waiting = "waiting", g.Seeking = "seeking", g.Seeked = "seeked", g.Ended = "ended", g.Error = "error", g.Destroyed = "destroyed", g.Initialized = "initialized", g.Stalled = "stalled", g.VolumeChange = "volumechange", g.PlaybackBitrateChanged = "playbackbitratechanged", g.DownloadBitrateChanged = "downloadbitratechanged", g.TimeUpdate = "timeupdate", g.DurationChange = "durationchange", g.HlsKeyLoading = "hlsKeyLoading", g.HlsKeyLoaded = "hlsKeyLoaded", g.HlsKeyLoadedFailed = "hlsKeyLoadedFailed", g.HlsManifestLoading = "hlsManifestLoading", g.HlsManifestLoaded = "hlsManifestLoaded", g.HlsManifestLoadedFailed = "hlsManifestLoadedFailed", g.HlsFirstFragmentLoading = "hlsFragLoading", g.HlsFirstFragmentBuffered = "hlsFragBuffered", g.HlsFirstFragmentLoadFailed = "hlsFirstFragmentLoadFailed", g.HlsFragmentChanged = "hlsFragmentChanged", g.Online = "online", g.Offline = "offline", g.NetworkChange = "networkChange";
                                }(C || (f.HydraPlayerPlaybackState = C = {})), function(g) {
                                    g.UnsupportedPlatform = "UnsupportedPlatform", g.NetworkError = "NetworkError", g.PlaybackRetried = "PlaybackRetried", g.PlaybackError = "PlaybackError", g.Unknown = "Unknown", g.MediaTimeout = "MediaTimeout", g.NoMediaFlow = "NoMediaFlow";
                                }(E || (f.HydraPlayerPlaybackErrorType = E = {})), function(g) {
                                    g[g.Hls = 1] = "Hls", g[g.Ums = 2] = "Ums";
                                }(T || (f.HydraPlayerType = T = {})), function(g) {
                                    g.RequestIceCandidates = "RequestIceCandidates";
                                }(I || (f.IframeMessages = I = {})), function(g) {
                                    g.Unknown = "Unknown", g.ClientNetwork = "ClientNetwork", g.ClientNetworkOrUnreachableServer = "ClientNetworkOrUnreachableServer", g.ServerNetwork = "ServerNetwork", g.ClientAuthIssue = "ClientAuthIssue", g.ServerResourceNotFound = "ServerResourceNotFound";
                                }(b || (f.HttpFetchErrorReason = b = {})), function(g) {
                                    g.audio = "Audio", g.video = "Video", g.text = "Text";
                                }(A || (f.UmsModality = A = {}));
                            },
                            521: function(g, f, S) {
                                var v = this && this.__awaiter || function(g, f, S, v) {
                                    return new (S || (S = Promise))(function(_, C) {
                                        function o2(g) {
                                            try {
                                                l2(v.next(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function s2(g) {
                                            try {
                                                l2(v.throw(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function l2(g) {
                                            var f;
                                            g.done ? _(g.value) : (f = g.value, f instanceof S ? f : new S(function(g) {
                                                g(f);
                                            })).then(o2, s2);
                                        }
                                        l2((v = v.apply(g, f || [])).next());
                                    });
                                }, _ = this && this.__generator || function(g, f) {
                                    var S, v, _, C, E = {
                                        label: 0,
                                        sent: function() {
                                            if (1 & _[0]) throw _[1];
                                            return _[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                    return C = {
                                        next: s2(0),
                                        throw: s2(1),
                                        return: s2(2)
                                    }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                                        return this;
                                    }), C;
                                    function s2(T) {
                                        return function(I) {
                                            return function(T) {
                                                if (S) throw new TypeError("Generator is already executing.");
                                                for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                                    if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                                    switch(v = 0, _ && (T = [
                                                        2 & T[0],
                                                        _.value
                                                    ]), T[0]){
                                                        case 0:
                                                        case 1:
                                                            _ = T;
                                                            break;
                                                        case 4:
                                                            return E.label++, {
                                                                value: T[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            E.label++, v = T[1], T = [
                                                                0
                                                            ];
                                                            continue;
                                                        case 7:
                                                            T = E.ops.pop(), E.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((_ = (_ = E.trys).length > 0 && _[_.length - 1]) || 6 !== T[0] && 2 !== T[0])) {
                                                                E = 0;
                                                                continue;
                                                            }
                                                            if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                                                E.label = T[1];
                                                                break;
                                                            }
                                                            if (6 === T[0] && E.label < _[1]) {
                                                                E.label = _[1], _ = T;
                                                                break;
                                                            }
                                                            if (_ && E.label < _[2]) {
                                                                E.label = _[2], E.ops.push(T);
                                                                break;
                                                            }
                                                            _[2] && E.ops.pop(), E.trys.pop();
                                                            continue;
                                                    }
                                                    T = f.call(g, E);
                                                } catch (g) {
                                                    T = [
                                                        6,
                                                        g
                                                    ], v = 0;
                                                } finally{
                                                    S = _ = 0;
                                                }
                                                if (5 & T[0]) throw T[1];
                                                return {
                                                    value: T[0] ? T[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                T,
                                                I
                                            ]);
                                        };
                                    }
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.HydraPlayer = f.getSdkVersion = void 0;
                                var C = S(346), E = S(378), T = S(715), I = S(357), b = S(534), A = S(42), R = S(103), P = S(282), w = S(10);
                                f.getSdkVersion = function() {
                                    return "4.24304.3";
                                };
                                var M = function() {
                                    function e3(g, f) {
                                        this.playerSettings = g, this.eventHandler = f, this.spinner = null, this.telemetryReportHandler = null, this.playerRuntimeUrls = [], this.commandResultsMap = new Map, this.iframeCommunicationHandler = null, this.MAX_COMMAND_RESULTS_MAP_SIZE = 1e4, this.playerInternalEventHandler = new T.HydraPlayerInternalEventHandler;
                                    }
                                    return e3.prototype.dispose = function() {
                                        var g;
                                        null === (g = this.telemetryReportHandler) || void 0 === g || g.addDisposeTelemetry(), this.isIFrameCommunicationActive() && this.callPlayerApi("disposeHydraPlayer");
                                    }, e3.prototype.release = function() {
                                        var g;
                                        null === (g = this.spinner) || void 0 === g || g.hide(), this.contextWindow && this.contextWindow.removeEventListener("message", this.onMessage.bind(this)), this.iframeCommunicationHandler && this.iframeCommunicationHandler.dispose(), this.iframe && this.container && this.container.hasChildNodes() && this.container.removeChild(this.iframe);
                                    }, e3.prototype.setup = function(g) {
                                        return v(this, void 0, void 0, function() {
                                            var f, S, v, E, T, I, R, P;
                                            return _(this, function(_) {
                                                switch(_.label){
                                                    case 0:
                                                        f = Date.now(), this.container = g, S = null, _.label = 1;
                                                    case 1:
                                                        return _.trys.push([
                                                            1,
                                                            14,
                                                            ,
                                                            15
                                                        ]), this.spinner = new A.Spinner(this.container), this.playerInternalEventHandler.setSpinner(this.spinner), [
                                                            4,
                                                            this.initializeIFrame()
                                                        ];
                                                    case 2:
                                                        if (!(S = _.sent()).isSuccess) return [
                                                            3,
                                                            12
                                                        ];
                                                        v = {
                                                            initSucceeded: !0,
                                                            initStartTime: f,
                                                            initDuration: Date.now() - f,
                                                            runtimeDownloadResults: S.runtimeDownloadResults || []
                                                        }, _.label = 3;
                                                    case 3:
                                                        return _.trys.push([
                                                            3,
                                                            5,
                                                            ,
                                                            11
                                                        ]), [
                                                            4,
                                                            this.callPlayerApi("createHydraPlayer", this.playerSettings, v)
                                                        ];
                                                    case 4:
                                                        return _.sent(), [
                                                            3,
                                                            11
                                                        ];
                                                    case 5:
                                                        return E = _.sent(), this.eventHandler.log("warn", "Failed to create HydraPlayer: ".concat(E)), this.playerSettings.playerType !== C.HydraPlayerType.Hls ? [
                                                            3,
                                                            7
                                                        ] : [
                                                            4,
                                                            this.callPlayerApi("createHlsHydraPlayer", this.playerSettings, v)
                                                        ];
                                                    case 6:
                                                        return _.sent(), [
                                                            3,
                                                            10
                                                        ];
                                                    case 7:
                                                        return this.playerSettings.playerType !== C.HydraPlayerType.Ums ? [
                                                            3,
                                                            9
                                                        ] : [
                                                            4,
                                                            this.callPlayerApi("createUmsHydraPlayer", this.playerSettings, v)
                                                        ];
                                                    case 8:
                                                        return _.sent(), [
                                                            3,
                                                            10
                                                        ];
                                                    case 9:
                                                        throw new Error("Cannot create Hydra player - Unknown player type");
                                                    case 10:
                                                        return [
                                                            3,
                                                            11
                                                        ];
                                                    case 11:
                                                        return this.onSetupCompleted(v), [
                                                            2,
                                                            !0
                                                        ];
                                                    case 12:
                                                        throw new Error(S.errorMsg);
                                                    case 13:
                                                        return [
                                                            3,
                                                            15
                                                        ];
                                                    case 14:
                                                        T = _.sent(), I = (0, b.stringifyObject)(T), this.eventHandler.log("error", "Failed to setup HydraPlayer: ".concat(I)), R = {
                                                            initSucceeded: !1,
                                                            initStartTime: f,
                                                            initDuration: Date.now() - f,
                                                            runtimeDownloadResults: (null == S ? void 0 : S.runtimeDownloadResults) || [],
                                                            errorMsg: I
                                                        };
                                                        try {
                                                            null === (P = this.spinner) || void 0 === P || P.hide();
                                                        } catch (g) {
                                                            this.eventHandler.log("error", "Failed to hide spinner: ".concat((0, b.stringifyObject)(g)));
                                                        }
                                                        return this.onSetupCompleted(R), [
                                                            2,
                                                            !1
                                                        ];
                                                    case 15:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    }, e3.prototype.onSetupCompleted = function(g) {
                                        this.telemetryReportHandler = new I.TelemetryReportHandler(this.playerSettings, this.eventHandler.log.bind(this.eventHandler), g, this.spinner), this.playerInternalEventHandler.setTelemetryReportHandler(this.telemetryReportHandler);
                                    }, e3.prototype.getFullTelemetryReport = function() {
                                        var g;
                                        return (null === (g = this.telemetryReportHandler) || void 0 === g ? void 0 : g.getFullTelemetryReport()) || {};
                                    }, e3.prototype.getSnapshotTelemetryReport = function() {
                                        var g;
                                        return (null === (g = this.telemetryReportHandler) || void 0 === g ? void 0 : g.getSnapshotTelemetryReport()) || {};
                                    }, e3.prototype.callPlayerApi = function(g) {
                                        for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                                        return v(this, void 0, void 0, function() {
                                            var S, v, C, T, I;
                                            return _(this, function(_) {
                                                switch(_.label){
                                                    case 0:
                                                        return this.iframe ? [
                                                            3,
                                                            2
                                                        ] : [
                                                            4,
                                                            Promise.reject(new Error("Hydra IFrame not initialized yet"))
                                                        ];
                                                    case 1:
                                                    case 3:
                                                        return [
                                                            2,
                                                            _.sent()
                                                        ];
                                                    case 2:
                                                        if (S = (0, w.default)(), v = {
                                                            msgType: E.MessageType.Command,
                                                            id: S,
                                                            name: g,
                                                            args: f
                                                        }, !this.isIFrameCommunicationActive()) throw new Error("IFrame MessageAPI communication not active");
                                                        if (this.commandResultsMap.size >= this.MAX_COMMAND_RESULTS_MAP_SIZE) throw new Error("Too many Hydra player API commands in progress - skipping this player API call");
                                                        return C = R.defer(), T = {
                                                            name: g,
                                                            id: S
                                                        }, this.commandResultsMap.set(T, C), null === (I = this.iframe.contentWindow) || void 0 === I || I.postMessage(v, "*"), [
                                                            4,
                                                            C.promise
                                                        ];
                                                }
                                            });
                                        });
                                    }, Object.defineProperty(e3.prototype, "contextWindow", {
                                        get: function() {
                                            var g;
                                            return null === (g = this.container) || void 0 === g ? void 0 : g.ownerDocument.defaultView;
                                        },
                                        enumerable: !1,
                                        configurable: !0
                                    }), e3.prototype.isIFrameCommunicationActive = function() {
                                        var g;
                                        return !!(null === (g = this.iframe) || void 0 === g ? void 0 : g.contentWindow) && !!this.contextWindow;
                                    }, e3.prototype.getRuntimeUrls = function(g) {
                                        if (!Array.isArray(this.playerSettings.playerRuntimeJsUrls)) {
                                            var f = (0, b.getMajorFromVersion)(g);
                                            return f && this.playerSettings.playerRuntimeJsUrls[f] || [];
                                        }
                                        return this.playerSettings.playerRuntimeJsUrls;
                                    }, e3.prototype.initializeIFrame = function() {
                                        return v(this, void 0, void 0, function() {
                                            var g;
                                            return _(this, function(f) {
                                                switch(f.label){
                                                    case 0:
                                                        return this.playerSettings.hydraPlayerSdkVersion = "4.24304.3", this.playerRuntimeUrls = this.getRuntimeUrls(this.playerSettings.hydraPlayerSdkVersion), 0 !== this.playerRuntimeUrls.length && this.container ? [
                                                            4,
                                                            (0, b.createIFrame)(this.container, this.playerRuntimeUrls, this.playerSettings)
                                                        ] : [
                                                            2,
                                                            {
                                                                isSuccess: !1,
                                                                runtimeDownloadResults: [],
                                                                errorMsg: "No compatible runtime URLs provided for HydraPlayer SDK version:\n                    ".concat(this.playerSettings.hydraPlayerSdkVersion, ", URLs:\n                    ").concat((0, b.stringifyObject)(this.playerSettings.playerRuntimeJsUrls))
                                                            }
                                                        ];
                                                    case 1:
                                                        return (g = f.sent()).initResult.isSuccess && g.iframe && (this.iframe = g.iframe, this.iframeCommunicationHandler = new P.IframeCommunicationHandler(this.iframe, this.playerSettings, this.eventHandler.log), this.contextWindow.addEventListener("message", this.onMessage.bind(this))), [
                                                            2,
                                                            g.initResult
                                                        ];
                                                }
                                            });
                                        });
                                    }, e3.prototype.onMessage = function(g) {
                                        switch(g.data.msgType){
                                            case E.MessageType.PlayerEvent:
                                                this.processPlayerEvent(g.data);
                                                break;
                                            case E.MessageType.InternalPlayerEvent:
                                                this.processInternalPlayerEvent(g.data);
                                                break;
                                            case E.MessageType.CommandSuccessResult:
                                                this.processCommandSuccessResult(g.data);
                                                break;
                                            case E.MessageType.CommandFailureResult:
                                                this.processCommandFailureResult(g.data);
                                        }
                                    }, e3.prototype.processCommandSuccessResult = function(g) {
                                        var f = this;
                                        this.eventHandler.log("debug", "HydraPlayer command succeeded for ".concat(g.name, " - result: ").concat((0, b.stringifyObject)(g.result))), this.getMapCommandResults(g).forEach(function(S) {
                                            S[1].resolve(g.result), f.commandResultsMap.delete(S[0]);
                                        });
                                    }, e3.prototype.processCommandFailureResult = function(g) {
                                        var f = this;
                                        this.eventHandler.log("debug", "HydraPlayer command failed for ".concat(g.name, " - error: ").concat(g.error.message)), this.getMapCommandResults(g).forEach(function(S) {
                                            S[1].reject(g.error), f.commandResultsMap.delete(S[0]);
                                        });
                                    }, e3.prototype.getMapCommandResults = function(g) {
                                        var f = Array.from(this.commandResultsMap.entries()), S = [];
                                        return g.id ? S = f.filter(function(f) {
                                            return f[0].id === g.id;
                                        }) : g.name && (S = f.filter(function(f) {
                                            return f[0].name === g.name;
                                        })), S;
                                    }, e3.prototype.processPlayerEvent = function(g) {
                                        var f;
                                        null === (f = this.eventHandler[g.name]) || void 0 === f || f.apply(this.eventHandler, g.args);
                                    }, e3.prototype.processInternalPlayerEvent = function(g) {
                                        this.playerInternalEventHandler && this.playerInternalEventHandler[g.name].apply(this, g.args);
                                    }, e3;
                                }();
                                f.HydraPlayer = M;
                            },
                            282: function(g, f, S) {
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.IframeCommunicationHandler = void 0;
                                var v = S(346), _ = S(735), C = function() {
                                    function e3(g, f, S) {
                                        var v = this;
                                        this.iframe = g, this.playerSettings = f, this.logger = S, this.setupMessageListener(), this.candidatesCollector = new _.WebRtcIceCandidateCollector(this.playerSettings), this.candidatesCollector.startCandidatesCollection().catch(function(g) {
                                            v.logger("warn", "Failed to start collecting ICE candidates ".concat(g));
                                        });
                                    }
                                    return e3.prototype.setupMessageListener = function() {
                                        var g;
                                        null === (g = this.iframe.ownerDocument.defaultView) || void 0 === g || g.addEventListener("message", this.processMessage.bind(this));
                                    }, e3.prototype.postMessageToIframe = function(g) {
                                        var f;
                                        null === (f = this.iframe.contentWindow) || void 0 === f || f.postMessage(g, "*");
                                    }, e3.prototype.dispose = function() {
                                        var g;
                                        null === (g = this.iframe.ownerDocument.defaultView) || void 0 === g || g.removeEventListener("message", this.processMessage.bind(this)), this.candidatesCollector && this.candidatesCollector.destroy();
                                    }, e3.prototype.processMessage = function(g) {
                                        var f = this;
                                        g.data === v.IframeMessages.RequestIceCandidates && void 0 === g.data.candidates && this.candidatesCollector.getCandidates().then(function(g) {
                                            var S = JSON.stringify(g.map(function(g) {
                                                return JSON.stringify(g);
                                            }));
                                            f.postMessageToIframe({
                                                topic: v.IframeMessages.RequestIceCandidates,
                                                candidates: S
                                            });
                                        }).catch(function() {
                                            f.postMessageToIframe({
                                                topic: v.IframeMessages.RequestIceCandidates,
                                                candidates: []
                                            });
                                        });
                                    }, e3;
                                }();
                                f.IframeCommunicationHandler = C;
                            },
                            260: function(g, f, S) {
                                var v = this && this.__createBinding || (Object.create ? function(g, f, S, v) {
                                    void 0 === v && (v = S);
                                    var _ = Object.getOwnPropertyDescriptor(f, S);
                                    _ && !("get" in _ ? !f.__esModule : _.writable || _.configurable) || (_ = {
                                        enumerable: !0,
                                        get: function() {
                                            return f[S];
                                        }
                                    }), Object.defineProperty(g, v, _);
                                } : function(g, f, S, v) {
                                    void 0 === v && (v = S), g[v] = f[S];
                                }), _ = this && this.__exportStar || function(g, f) {
                                    for(var S in g)"default" === S || Object.prototype.hasOwnProperty.call(f, S) || v(f, g, S);
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), _(S(521), f), _(S(564), f);
                            },
                            715: function(g, f) {
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.HydraPlayerInternalEventHandler = void 0;
                                var S = function() {
                                    function e3() {
                                        this.spinner = null, this.telemetryReportHandler = null;
                                    }
                                    return e3.prototype.setSpinner = function(g) {
                                        this.spinner = g;
                                    }, e3.prototype.setTelemetryReportHandler = function(g) {
                                        this.telemetryReportHandler = g;
                                    }, e3.prototype.firstPlayerLoadAttemptDone = function() {
                                        var g;
                                        null === (g = this.spinner) || void 0 === g || g.hide();
                                    }, e3.prototype.fullTelemetryReportUpdated = function(g) {
                                        var f;
                                        null === (f = this.telemetryReportHandler) || void 0 === f || f.setFullTelemetryReport(g);
                                    }, e3.prototype.snapshotTelemetryReportUpdated = function(g) {
                                        var f;
                                        null === (f = this.telemetryReportHandler) || void 0 === f || f.setSnapshotTelemetryReport(g);
                                    }, e3;
                                }();
                                f.HydraPlayerInternalEventHandler = S;
                            },
                            357: function(g, f, S) {
                                var v = this && this.__assign || function() {
                                    return v = Object.assign || function(g) {
                                        for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                                        return g;
                                    }, v.apply(this, arguments);
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.TelemetryReportHandler = void 0;
                                var _ = S(346), C = S(176), E = S(963), T = S(171), I = S(534), b = function() {
                                    function e3(g, f, S, v) {
                                        var C = this;
                                        this.logFn = f, this.spinner = v, this.initialLiveStreamStatistic = new T.LiveStreamStatistic(g, function(g, f) {
                                            C.logFn(g, f);
                                        }, {
                                            videoBufferLength: [],
                                            videoCachedLength: [],
                                            videoEdgeLatency: [],
                                            playerHeight: [],
                                            playerWidth: [],
                                            mediaHeight: [],
                                            mediaWidth: [],
                                            windowHeight: [],
                                            windowWidth: [],
                                            playbackRate: [],
                                            currentPlayPosition: [],
                                            statsInterval: []
                                        }, {
                                            hydraPlayerSdkVersion: g.hydraPlayerSdkVersion || "Unknown",
                                            hydraPlayerType: _.HydraPlayerType.Hls
                                        }), this.initialLiveStreamStatistic.setHydraInitResult(S), this.fullTelemetryReport = this.initialLiveStreamStatistic.getReport(), this.snapshotTelemetryReport = this.initialLiveStreamStatistic.getSnapshotReport();
                                    }
                                    return e3.prototype.getFullTelemetryReport = function() {
                                        return this.fullTelemetryReport;
                                    }, e3.prototype.getSnapshotTelemetryReport = function() {
                                        return this.snapshotTelemetryReport;
                                    }, e3.prototype.setFullTelemetryReport = function(g) {
                                        var f, S, _, C, E, T, I;
                                        this.fullTelemetryReport = v(v({}, g), {
                                            init_spinnerShowTimestamp: null !== (S = null === (f = this.spinner) || void 0 === f ? void 0 : f.firstShowTimestamp) && void 0 !== S ? S : -1,
                                            init_spinnerHideTimestamp: null !== (C = null === (_ = this.spinner) || void 0 === _ ? void 0 : _.firstHideTimestamp) && void 0 !== C ? C : -1,
                                            init_spinnerDuration: null !== (T = null === (E = this.spinner) || void 0 === E ? void 0 : E.firstSpinnerDuration) && void 0 !== T ? T : -1,
                                            init_spinnerVisible: (null === (I = this.spinner) || void 0 === I ? void 0 : I.isVisible()) || !1
                                        });
                                    }, e3.prototype.setSnapshotTelemetryReport = function(g) {
                                        var f, S, _, C, E, T, I;
                                        this.snapshotTelemetryReport = v(v({}, g), {
                                            init_spinnerShowTimestamp: null !== (S = null === (f = this.spinner) || void 0 === f ? void 0 : f.firstShowTimestamp) && void 0 !== S ? S : -1,
                                            init_spinnerHideTimestamp: null !== (C = null === (_ = this.spinner) || void 0 === _ ? void 0 : _.firstHideTimestamp) && void 0 !== C ? C : -1,
                                            init_spinnerDuration: null !== (T = null === (E = this.spinner) || void 0 === E ? void 0 : E.firstSpinnerDuration) && void 0 !== T ? T : -1,
                                            init_spinnerVisible: (null === (I = this.spinner) || void 0 === I ? void 0 : I.isVisible()) || !1
                                        });
                                    }, e3.prototype.addDisposeTelemetry = function() {
                                        var g = Date.now();
                                        this.updateInitEventsWithDisposeEvent(this.fullTelemetryReport, g, "full"), this.updateInitEventsWithDisposeEvent(this.snapshotTelemetryReport, g, "snapshot"), this.updateStateChangeEventsWithDisposeEvent(this.fullTelemetryReport, g, "full"), this.updateStateChangeEventsWithDisposeEvent(this.snapshotTelemetryReport, g, "snapshot");
                                    }, e3.prototype.updateInitEventsWithDisposeEvent = function(g, f, S) {
                                        try {
                                            var v = g.init_allEvents, _ = JSON.parse(v);
                                            _[_.length - 1].name !== E.PlayerScenarioType.Destroyed && _.push({
                                                name: E.PlayerScenarioType.Destroyed,
                                                startTime: f,
                                                duration: 0,
                                                details: C.HydraPlayerDestroyedReason.PlayerStopped
                                            }), g.init_allEvents = (0, I.stringifyObject)(_);
                                        } catch (g) {
                                            this.logFn("warn", "Failed to add player destroyed information to init_allEvents telemetry field in ".concat(S, " telemetry report."));
                                        }
                                    }, e3.prototype.updateStateChangeEventsWithDisposeEvent = function(g, f, S) {
                                        try {
                                            var v = g.playback_stateChangeEvents, C = JSON.parse(v);
                                            C[C.length - 1].name !== _.HydraPlayerPlaybackState.Destroyed && C.push({
                                                eventType: E.TelemetryEventType.StateChanged,
                                                timestamp: f,
                                                currentPlayPosition: -1,
                                                payload: _.HydraPlayerPlaybackState.Destroyed
                                            }), g.playback_stateChangeEvents = (0, I.stringifyObject)(C);
                                        } catch (g) {
                                            this.logFn("warn", "Failed to add player destroyed information to playback_stateChangeEvents telemetry field in ".concat(S, " telemetry report."));
                                        }
                                    }, e3;
                                }();
                                f.TelemetryReportHandler = b;
                            },
                            735: function(g, f, S) {
                                var v = this && this.__awaiter || function(g, f, S, v) {
                                    return new (S || (S = Promise))(function(_, C) {
                                        function o2(g) {
                                            try {
                                                l2(v.next(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function s2(g) {
                                            try {
                                                l2(v.throw(g));
                                            } catch (g) {
                                                C(g);
                                            }
                                        }
                                        function l2(g) {
                                            var f;
                                            g.done ? _(g.value) : (f = g.value, f instanceof S ? f : new S(function(g) {
                                                g(f);
                                            })).then(o2, s2);
                                        }
                                        l2((v = v.apply(g, f || [])).next());
                                    });
                                }, _ = this && this.__generator || function(g, f) {
                                    var S, v, _, C, E = {
                                        label: 0,
                                        sent: function() {
                                            if (1 & _[0]) throw _[1];
                                            return _[1];
                                        },
                                        trys: [],
                                        ops: []
                                    };
                                    return C = {
                                        next: s2(0),
                                        throw: s2(1),
                                        return: s2(2)
                                    }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                                        return this;
                                    }), C;
                                    function s2(T) {
                                        return function(I) {
                                            return function(T) {
                                                if (S) throw new TypeError("Generator is already executing.");
                                                for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                                    if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                                    switch(v = 0, _ && (T = [
                                                        2 & T[0],
                                                        _.value
                                                    ]), T[0]){
                                                        case 0:
                                                        case 1:
                                                            _ = T;
                                                            break;
                                                        case 4:
                                                            return E.label++, {
                                                                value: T[1],
                                                                done: !1
                                                            };
                                                        case 5:
                                                            E.label++, v = T[1], T = [
                                                                0
                                                            ];
                                                            continue;
                                                        case 7:
                                                            T = E.ops.pop(), E.trys.pop();
                                                            continue;
                                                        default:
                                                            if (!((_ = (_ = E.trys).length > 0 && _[_.length - 1]) || 6 !== T[0] && 2 !== T[0])) {
                                                                E = 0;
                                                                continue;
                                                            }
                                                            if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                                                E.label = T[1];
                                                                break;
                                                            }
                                                            if (6 === T[0] && E.label < _[1]) {
                                                                E.label = _[1], _ = T;
                                                                break;
                                                            }
                                                            if (_ && E.label < _[2]) {
                                                                E.label = _[2], E.ops.push(T);
                                                                break;
                                                            }
                                                            _[2] && E.ops.pop(), E.trys.pop();
                                                            continue;
                                                    }
                                                    T = f.call(g, E);
                                                } catch (g) {
                                                    T = [
                                                        6,
                                                        g
                                                    ], v = 0;
                                                } finally{
                                                    S = _ = 0;
                                                }
                                                if (5 & T[0]) throw T[1];
                                                return {
                                                    value: T[0] ? T[1] : void 0,
                                                    done: !0
                                                };
                                            }([
                                                T,
                                                I
                                            ]);
                                        };
                                    }
                                }, C = this && this.__spreadArray || function(g, f, S) {
                                    if (S || 2 === arguments.length) for(var v, _ = 0, C = f.length; _ < C; _++)!v && _ in f || (v || (v = Array.prototype.slice.call(f, 0, _)), v[_] = f[_]);
                                    return g.concat(v || Array.prototype.slice.call(f));
                                };
                                Object.defineProperty(f, "__esModule", {
                                    value: !0
                                }), f.WebRtcIceCandidateCollector = void 0;
                                var E = S(103), T = S(534), I = function() {
                                    function e3(g) {
                                        this.playerSettings = g, this.latestCandidates = [], this.newCandidates = [], this.peerConnection = null, this.timeoutId = void 0, this.candidatesCollectionDefer = null, this.delayAfterComplete = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorDelayAfterCompleteMs", 2500), this.delayAfterError = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorDelayAfterErrorMs", 1e3), this.maxRetries = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorMaxRetriesMs", 5), this.retryDelay = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorRetryDelayMs", 100), this.maxCollectionTime = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorMaxCollectionTimeMs", 6e4), this.disabledCollection = (0, T.getECSSetting)(this.playerSettings, "WebRtcIceCandidateCollectorDisableCollection", !1);
                                    }
                                    return e3.prototype.handleIceCandidate = function(g) {
                                        g.candidate && this.newCandidates.push(g.candidate);
                                    }, e3.prototype.handleIceGatheringStateChange = function() {
                                        var g, f;
                                        "complete" === (null === (g = this.peerConnection) || void 0 === g ? void 0 : g.iceGatheringState) && (this.latestCandidates = C([], this.newCandidates, !0), this.newCandidates = [], null === (f = this.candidatesCollectionDefer) || void 0 === f || f.resolve(), this.candidatesCollectionDefer = null, this.destroyConnection(), this.clearCollectionTimeout(), this.startCandidatesCollection(this.delayAfterComplete));
                                    }, e3.prototype.setUpPeerConnection = function() {
                                        return v(this, void 0, void 0, function() {
                                            var g, f, S, v;
                                            return _(this, function(_) {
                                                switch(_.label){
                                                    case 0:
                                                        return _.trys.push([
                                                            0,
                                                            3,
                                                            ,
                                                            4
                                                        ]), this.peerConnection = new RTCPeerConnection, this.peerConnection.createDataChannel("local-ip-hydra-player-ice-candidates"), this.peerConnection.addEventListener("icecandidate", this.handleIceCandidate.bind(this)), this.peerConnection.addEventListener("icegatheringstatechange", this.handleIceGatheringStateChange.bind(this)), [
                                                            4,
                                                            null === (S = this.peerConnection) || void 0 === S ? void 0 : S.createOffer()
                                                        ];
                                                    case 1:
                                                        return g = _.sent(), [
                                                            4,
                                                            null === (v = this.peerConnection) || void 0 === v ? void 0 : v.setLocalDescription(g)
                                                        ];
                                                    case 2:
                                                        return _.sent(), [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        throw f = _.sent(), this.destroyConnection(), new Error("Failure starting collection: ".concat((0, T.stringifyError)(f)));
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    }, e3.prototype.destroyConnection = function() {
                                        this.peerConnection && (this.peerConnection.removeEventListener("icecandidate", this.handleIceCandidate.bind(this)), this.peerConnection.removeEventListener("icegatheringstatechange", this.handleIceGatheringStateChange.bind(this)), this.peerConnection.close(), this.peerConnection = null);
                                    }, e3.prototype.clearCollectionTimeout = function() {
                                        void 0 !== this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0);
                                    }, e3.prototype.destroy = function() {
                                        this.disabledCollection = !0, this.destroyConnection(), this.clearCollectionTimeout(), this.candidatesCollectionDefer && (this.candidatesCollectionDefer.reject(new Error("Collection aborted due to destroy")), this.candidatesCollectionDefer = null);
                                    }, e3.prototype.startCandidatesCollection = function() {
                                        return v(this, arguments, void 0, function(g) {
                                            var f, S = this;
                                            return void 0 === g && (g = 0), _(this, function(C) {
                                                switch(C.label){
                                                    case 0:
                                                        return this.candidatesCollectionDefer || this.disabledCollection ? [
                                                            2
                                                        ] : g > 0 ? [
                                                            4,
                                                            new Promise(function(f) {
                                                                return setTimeout(f, g);
                                                            })
                                                        ] : [
                                                            3,
                                                            2
                                                        ];
                                                    case 1:
                                                        C.sent(), C.label = 2;
                                                    case 2:
                                                        return this.candidatesCollectionDefer = (0, E.defer)(), this.candidatesCollectionDefer.promise.catch(function() {}), f = this.setUpPeerConnection.bind(this), [
                                                            4,
                                                            (0, T.retry)(f, this.maxRetries, this.retryDelay).then(function() {
                                                                S.timeoutId = setTimeout(function() {
                                                                    var g;
                                                                    null === (g = S.candidatesCollectionDefer) || void 0 === g || g.reject(new Error("Collection timed out")), S.candidatesCollectionDefer = null, S.destroyConnection(), S.startCandidatesCollection(S.delayAfterError);
                                                                }, S.maxCollectionTime);
                                                            }).catch(function(g) {
                                                                return v(S, void 0, void 0, function() {
                                                                    var f, S;
                                                                    return _(this, function(v) {
                                                                        switch(v.label){
                                                                            case 0:
                                                                                return f = "Failed to start collection ".concat((0, T.stringifyError)(g)), null === (S = this.candidatesCollectionDefer) || void 0 === S || S.reject(new Error(f)), this.candidatesCollectionDefer = null, [
                                                                                    4,
                                                                                    Promise.reject(new Error(f))
                                                                                ];
                                                                            case 1:
                                                                                return v.sent(), this.startCandidatesCollection(this.delayAfterError), [
                                                                                    2
                                                                                ];
                                                                        }
                                                                    });
                                                                });
                                                            })
                                                        ];
                                                    case 3:
                                                        return C.sent(), [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    }, e3.prototype.getCandidates = function() {
                                        return v(this, void 0, void 0, function() {
                                            return _(this, function(g) {
                                                switch(g.label){
                                                    case 0:
                                                        return 0 === this.latestCandidates.length && this.candidatesCollectionDefer ? [
                                                            4,
                                                            this.candidatesCollectionDefer.promise
                                                        ] : [
                                                            3,
                                                            2
                                                        ];
                                                    case 1:
                                                        g.sent(), g.label = 2;
                                                    case 2:
                                                        return [
                                                            2,
                                                            this.latestCandidates
                                                        ];
                                                }
                                            });
                                        });
                                    }, e3;
                                }();
                                f.WebRtcIceCandidateCollector = I;
                            }
                        }, f = {}, function n(S) {
                            var v = f[S];
                            if (void 0 !== v) return v.exports;
                            var _ = f[S] = {
                                exports: {}
                            };
                            return g[S].call(_.exports, _, _.exports, n), _.exports;
                        }(260);
                    }, "object" == typeof g && "object" == typeof f ? f.exports = v() : "object" == typeof g ? g.hydra_player_sdk = v() : S.hydra_player_sdk = v();
                }
            }), re = __commonJS({
                "../node_modules/pako/lib/utils/common.js" (g) {
                    var f = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                    function _has(g, f) {
                        return Object.prototype.hasOwnProperty.call(g, f);
                    }
                    g.assign = function(g) {
                        for(var f = Array.prototype.slice.call(arguments, 1); f.length;){
                            var S = f.shift();
                            if (S) {
                                if ("object" != typeof S) throw new TypeError(S + "must be non-object");
                                for(var v in S)_has(S, v) && (g[v] = S[v]);
                            }
                        }
                        return g;
                    }, g.shrinkBuf = function(g, f) {
                        return g.length === f ? g : g.subarray ? g.subarray(0, f) : (g.length = f, g);
                    };
                    var S = {
                        arraySet: function(g, f, S, v, _) {
                            if (f.subarray && g.subarray) g.set(f.subarray(S, S + v), _);
                            else for(var C = 0; C < v; C++)g[_ + C] = f[S + C];
                        },
                        flattenChunks: function(g) {
                            var f, S, v, _, C, E;
                            for(v = 0, f = 0, S = g.length; f < S; f++)v += g[f].length;
                            for(E = new Uint8Array(v), _ = 0, f = 0, S = g.length; f < S; f++)C = g[f], E.set(C, _), _ += C.length;
                            return E;
                        }
                    }, v = {
                        arraySet: function(g, f, S, v, _) {
                            for(var C = 0; C < v; C++)g[_ + C] = f[S + C];
                        },
                        flattenChunks: function(g) {
                            return [].concat.apply([], g);
                        }
                    };
                    g.setTyped = function(f) {
                        f ? (g.Buf8 = Uint8Array, g.Buf16 = Uint16Array, g.Buf32 = Int32Array, g.assign(g, S)) : (g.Buf8 = Array, g.Buf16 = Array, g.Buf32 = Array, g.assign(g, v));
                    }, g.setTyped(f);
                }
            }), ae = __commonJS({
                "../node_modules/pako/lib/zlib/trees.js" (g) {
                    var f = re(), S = 4, v = 0, _ = 1, C = 2;
                    function zero(g) {
                        for(var f = g.length; --f >= 0;)g[f] = 0;
                    }
                    var E = 0, T = 1, I = 2, b = 3, A = 258, R = 29, P = 256, w = P + 1 + R, M = 30, O = 19, D = 2 * w + 1, N = 15, k = 16, L = 7, F = 256, x = 16, U = 17, V = 18, B = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        1,
                        1,
                        2,
                        2,
                        2,
                        2,
                        3,
                        3,
                        3,
                        3,
                        4,
                        4,
                        4,
                        4,
                        5,
                        5,
                        5,
                        5,
                        0
                    ], H = [
                        0,
                        0,
                        0,
                        0,
                        1,
                        1,
                        2,
                        2,
                        3,
                        3,
                        4,
                        4,
                        5,
                        5,
                        6,
                        6,
                        7,
                        7,
                        8,
                        8,
                        9,
                        9,
                        10,
                        10,
                        11,
                        11,
                        12,
                        12,
                        13,
                        13
                    ], $ = [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        7
                    ], j = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ], G = 512, q = new Array(2 * (w + 2));
                    zero(q);
                    var W = new Array(2 * M);
                    zero(W);
                    var z = new Array(G);
                    zero(z);
                    var K = new Array(A - b + 1);
                    zero(K);
                    var J = new Array(R);
                    zero(J);
                    var Y, Q, X, Z = new Array(M);
                    function StaticTreeDesc(g, f, S, v, _) {
                        this.static_tree = g, this.extra_bits = f, this.extra_base = S, this.elems = v, this.max_length = _, this.has_stree = g && g.length;
                    }
                    function TreeDesc(g, f) {
                        this.dyn_tree = g, this.max_code = 0, this.stat_desc = f;
                    }
                    function d_code(g) {
                        return g < 256 ? z[g] : z[256 + (g >>> 7)];
                    }
                    function put_short(g, f) {
                        g.pending_buf[g.pending++] = 255 & f, g.pending_buf[g.pending++] = f >>> 8 & 255;
                    }
                    function send_bits(g, f, S) {
                        g.bi_valid > k - S ? (g.bi_buf |= f << g.bi_valid & 65535, put_short(g, g.bi_buf), g.bi_buf = f >> k - g.bi_valid, g.bi_valid += S - k) : (g.bi_buf |= f << g.bi_valid & 65535, g.bi_valid += S);
                    }
                    function send_code(g, f, S) {
                        send_bits(g, S[2 * f], S[2 * f + 1]);
                    }
                    function bi_reverse(g, f) {
                        var S = 0;
                        do S |= 1 & g, g >>>= 1, S <<= 1;
                        while (--f > 0);
                        return S >>> 1;
                    }
                    function bi_flush(g) {
                        16 === g.bi_valid ? (put_short(g, g.bi_buf), g.bi_buf = 0, g.bi_valid = 0) : g.bi_valid >= 8 && (g.pending_buf[g.pending++] = 255 & g.bi_buf, g.bi_buf >>= 8, g.bi_valid -= 8);
                    }
                    function gen_bitlen(g, f) {
                        var S, v, _, C, E, T, I = f.dyn_tree, b = f.max_code, A = f.stat_desc.static_tree, R = f.stat_desc.has_stree, P = f.stat_desc.extra_bits, w = f.stat_desc.extra_base, M = f.stat_desc.max_length, O = 0;
                        for(C = 0; C <= N; C++)g.bl_count[C] = 0;
                        for(I[2 * g.heap[g.heap_max] + 1] = 0, S = g.heap_max + 1; S < D; S++)(C = I[2 * I[2 * (v = g.heap[S]) + 1] + 1] + 1) > M && (C = M, O++), I[2 * v + 1] = C, v > b || (g.bl_count[C]++, E = 0, v >= w && (E = P[v - w]), T = I[2 * v], g.opt_len += T * (C + E), R && (g.static_len += T * (A[2 * v + 1] + E)));
                        if (0 !== O) {
                            do {
                                for(C = M - 1; 0 === g.bl_count[C];)C--;
                                g.bl_count[C]--, g.bl_count[C + 1] += 2, g.bl_count[M]--, O -= 2;
                            }while (O > 0);
                            for(C = M; 0 !== C; C--)for(v = g.bl_count[C]; 0 !== v;)(_ = g.heap[--S]) > b || (I[2 * _ + 1] !== C && (g.opt_len += (C - I[2 * _ + 1]) * I[2 * _], I[2 * _ + 1] = C), v--);
                        }
                    }
                    function gen_codes(g, f, S) {
                        var v, _, C = new Array(N + 1), E = 0;
                        for(v = 1; v <= N; v++)C[v] = E = E + S[v - 1] << 1;
                        for(_ = 0; _ <= f; _++){
                            var T = g[2 * _ + 1];
                            0 !== T && (g[2 * _] = bi_reverse(C[T]++, T));
                        }
                    }
                    function tr_static_init() {
                        var g, f, S, v, _, C = new Array(N + 1);
                        for(S = 0, v = 0; v < R - 1; v++)for(J[v] = S, g = 0; g < 1 << B[v]; g++)K[S++] = v;
                        for(K[S - 1] = v, _ = 0, v = 0; v < 16; v++)for(Z[v] = _, g = 0; g < 1 << H[v]; g++)z[_++] = v;
                        for(_ >>= 7; v < M; v++)for(Z[v] = _ << 7, g = 0; g < 1 << H[v] - 7; g++)z[256 + _++] = v;
                        for(f = 0; f <= N; f++)C[f] = 0;
                        for(g = 0; g <= 143;)q[2 * g + 1] = 8, g++, C[8]++;
                        for(; g <= 255;)q[2 * g + 1] = 9, g++, C[9]++;
                        for(; g <= 279;)q[2 * g + 1] = 7, g++, C[7]++;
                        for(; g <= 287;)q[2 * g + 1] = 8, g++, C[8]++;
                        for(gen_codes(q, w + 1, C), g = 0; g < M; g++)W[2 * g + 1] = 5, W[2 * g] = bi_reverse(g, 5);
                        Y = new StaticTreeDesc(q, B, P + 1, w, N), Q = new StaticTreeDesc(W, H, 0, M, N), X = new StaticTreeDesc(new Array(0), $, 0, O, L);
                    }
                    function init_block(g) {
                        var f;
                        for(f = 0; f < w; f++)g.dyn_ltree[2 * f] = 0;
                        for(f = 0; f < M; f++)g.dyn_dtree[2 * f] = 0;
                        for(f = 0; f < O; f++)g.bl_tree[2 * f] = 0;
                        g.dyn_ltree[2 * F] = 1, g.opt_len = g.static_len = 0, g.last_lit = g.matches = 0;
                    }
                    function bi_windup(g) {
                        g.bi_valid > 8 ? put_short(g, g.bi_buf) : g.bi_valid > 0 && (g.pending_buf[g.pending++] = g.bi_buf), g.bi_buf = 0, g.bi_valid = 0;
                    }
                    function copy_block(g, S, v, _) {
                        bi_windup(g), _ && (put_short(g, v), put_short(g, ~v)), f.arraySet(g.pending_buf, g.window, S, v, g.pending), g.pending += v;
                    }
                    function smaller(g, f, S, v) {
                        var _ = 2 * f, C = 2 * S;
                        return g[_] < g[C] || g[_] === g[C] && v[f] <= v[S];
                    }
                    function pqdownheap(g, f, S) {
                        for(var v = g.heap[S], _ = S << 1; _ <= g.heap_len && (_ < g.heap_len && smaller(f, g.heap[_ + 1], g.heap[_], g.depth) && _++, !smaller(f, v, g.heap[_], g.depth));)g.heap[S] = g.heap[_], S = _, _ <<= 1;
                        g.heap[S] = v;
                    }
                    function compress_block(g, f, S) {
                        var v, _, C, E, T = 0;
                        if (0 !== g.last_lit) do v = g.pending_buf[g.d_buf + 2 * T] << 8 | g.pending_buf[g.d_buf + 2 * T + 1], _ = g.pending_buf[g.l_buf + T], T++, 0 === v ? send_code(g, _, f) : (send_code(g, (C = K[_]) + P + 1, f), 0 !== (E = B[C]) && send_bits(g, _ -= J[C], E), send_code(g, C = d_code(--v), S), 0 !== (E = H[C]) && send_bits(g, v -= Z[C], E));
                        while (T < g.last_lit);
                        send_code(g, F, f);
                    }
                    function build_tree(g, f) {
                        var S, v, _, C = f.dyn_tree, E = f.stat_desc.static_tree, T = f.stat_desc.has_stree, I = f.stat_desc.elems, b = -1;
                        for(g.heap_len = 0, g.heap_max = D, S = 0; S < I; S++)0 !== C[2 * S] ? (g.heap[++g.heap_len] = b = S, g.depth[S] = 0) : C[2 * S + 1] = 0;
                        for(; g.heap_len < 2;)C[2 * (_ = g.heap[++g.heap_len] = b < 2 ? ++b : 0)] = 1, g.depth[_] = 0, g.opt_len--, T && (g.static_len -= E[2 * _ + 1]);
                        for(f.max_code = b, S = g.heap_len >> 1; S >= 1; S--)pqdownheap(g, C, S);
                        _ = I;
                        do S = g.heap[1], g.heap[1] = g.heap[g.heap_len--], pqdownheap(g, C, 1), v = g.heap[1], g.heap[--g.heap_max] = S, g.heap[--g.heap_max] = v, C[2 * _] = C[2 * S] + C[2 * v], g.depth[_] = (g.depth[S] >= g.depth[v] ? g.depth[S] : g.depth[v]) + 1, C[2 * S + 1] = C[2 * v + 1] = _, g.heap[1] = _++, pqdownheap(g, C, 1);
                        while (g.heap_len >= 2);
                        g.heap[--g.heap_max] = g.heap[1], gen_bitlen(g, f), gen_codes(C, b, g.bl_count);
                    }
                    function scan_tree(g, f, S) {
                        var v, _, C = -1, E = f[1], T = 0, I = 7, b = 4;
                        for(0 === E && (I = 138, b = 3), f[2 * (S + 1) + 1] = 65535, v = 0; v <= S; v++)_ = E, E = f[2 * (v + 1) + 1], ++T < I && _ === E || (T < b ? g.bl_tree[2 * _] += T : 0 !== _ ? (_ !== C && g.bl_tree[2 * _]++, g.bl_tree[2 * x]++) : T <= 10 ? g.bl_tree[2 * U]++ : g.bl_tree[2 * V]++, T = 0, C = _, 0 === E ? (I = 138, b = 3) : _ === E ? (I = 6, b = 3) : (I = 7, b = 4));
                    }
                    function send_tree(g, f, S) {
                        var v, _, C = -1, E = f[1], T = 0, I = 7, b = 4;
                        for(0 === E && (I = 138, b = 3), v = 0; v <= S; v++)if (_ = E, E = f[2 * (v + 1) + 1], !(++T < I && _ === E)) {
                            if (T < b) do send_code(g, _, g.bl_tree);
                            while (0 != --T);
                            else 0 !== _ ? (_ !== C && (send_code(g, _, g.bl_tree), T--), send_code(g, x, g.bl_tree), send_bits(g, T - 3, 2)) : T <= 10 ? (send_code(g, U, g.bl_tree), send_bits(g, T - 3, 3)) : (send_code(g, V, g.bl_tree), send_bits(g, T - 11, 7));
                            T = 0, C = _, 0 === E ? (I = 138, b = 3) : _ === E ? (I = 6, b = 3) : (I = 7, b = 4);
                        }
                    }
                    function build_bl_tree(g) {
                        var f;
                        for(scan_tree(g, g.dyn_ltree, g.l_desc.max_code), scan_tree(g, g.dyn_dtree, g.d_desc.max_code), build_tree(g, g.bl_desc), f = O - 1; f >= 3 && 0 === g.bl_tree[2 * j[f] + 1]; f--);
                        return g.opt_len += 3 * (f + 1) + 5 + 5 + 4, f;
                    }
                    function send_all_trees(g, f, S, v) {
                        var _;
                        for(send_bits(g, f - 257, 5), send_bits(g, S - 1, 5), send_bits(g, v - 4, 4), _ = 0; _ < v; _++)send_bits(g, g.bl_tree[2 * j[_] + 1], 3);
                        send_tree(g, g.dyn_ltree, f - 1), send_tree(g, g.dyn_dtree, S - 1);
                    }
                    function detect_data_type(g) {
                        var f, S = 4093624447;
                        for(f = 0; f <= 31; f++, S >>>= 1)if (1 & S && 0 !== g.dyn_ltree[2 * f]) return v;
                        if (0 !== g.dyn_ltree[18] || 0 !== g.dyn_ltree[20] || 0 !== g.dyn_ltree[26]) return _;
                        for(f = 32; f < P; f++)if (0 !== g.dyn_ltree[2 * f]) return _;
                        return v;
                    }
                    zero(Z);
                    var ee = !1;
                    function _tr_init(g) {
                        ee || (tr_static_init(), ee = !0), g.l_desc = new TreeDesc(g.dyn_ltree, Y), g.d_desc = new TreeDesc(g.dyn_dtree, Q), g.bl_desc = new TreeDesc(g.bl_tree, X), g.bi_buf = 0, g.bi_valid = 0, init_block(g);
                    }
                    function _tr_stored_block(g, f, S, v) {
                        send_bits(g, (E << 1) + (v ? 1 : 0), 3), copy_block(g, f, S, !0);
                    }
                    function _tr_align(g) {
                        send_bits(g, T << 1, 3), send_code(g, F, q), bi_flush(g);
                    }
                    function _tr_flush_block(g, f, v, _) {
                        var E, b, A = 0;
                        g.level > 0 ? (g.strm.data_type === C && (g.strm.data_type = detect_data_type(g)), build_tree(g, g.l_desc), build_tree(g, g.d_desc), A = build_bl_tree(g), E = g.opt_len + 3 + 7 >>> 3, (b = g.static_len + 3 + 7 >>> 3) <= E && (E = b)) : E = b = v + 5, v + 4 <= E && -1 !== f ? _tr_stored_block(g, f, v, _) : g.strategy === S || b === E ? (send_bits(g, (T << 1) + (_ ? 1 : 0), 3), compress_block(g, q, W)) : (send_bits(g, (I << 1) + (_ ? 1 : 0), 3), send_all_trees(g, g.l_desc.max_code + 1, g.d_desc.max_code + 1, A + 1), compress_block(g, g.dyn_ltree, g.dyn_dtree)), init_block(g), _ && bi_windup(g);
                    }
                    function _tr_tally(g, f, S) {
                        return g.pending_buf[g.d_buf + 2 * g.last_lit] = f >>> 8 & 255, g.pending_buf[g.d_buf + 2 * g.last_lit + 1] = 255 & f, g.pending_buf[g.l_buf + g.last_lit] = 255 & S, g.last_lit++, 0 === f ? g.dyn_ltree[2 * S]++ : (g.matches++, f--, g.dyn_ltree[2 * (K[S] + P + 1)]++, g.dyn_dtree[2 * d_code(f)]++), g.last_lit === g.lit_bufsize - 1;
                    }
                    g._tr_init = _tr_init, g._tr_stored_block = _tr_stored_block, g._tr_flush_block = _tr_flush_block, g._tr_tally = _tr_tally, g._tr_align = _tr_align;
                }
            }), se = __commonJS({
                "../node_modules/pako/lib/zlib/adler32.js" (g, f) {
                    function adler32(g, f, S, v) {
                        for(var _ = 65535 & g | 0, C = g >>> 16 & 65535 | 0, E = 0; 0 !== S;){
                            S -= E = S > 2e3 ? 2e3 : S;
                            do C = C + (_ = _ + f[v++] | 0) | 0;
                            while (--E);
                            _ %= 65521, C %= 65521;
                        }
                        return _ | C << 16 | 0;
                    }
                    f.exports = adler32;
                }
            }), oe = __commonJS({
                "../node_modules/pako/lib/zlib/crc32.js" (g, f) {
                    function makeTable() {
                        for(var g, f = [], S = 0; S < 256; S++){
                            g = S;
                            for(var v = 0; v < 8; v++)g = 1 & g ? 3988292384 ^ g >>> 1 : g >>> 1;
                            f[S] = g;
                        }
                        return f;
                    }
                    var S = makeTable();
                    function crc32(g, f, v, _) {
                        var C = S, E = _ + v;
                        g ^= -1;
                        for(var T = _; T < E; T++)g = g >>> 8 ^ C[255 & (g ^ f[T])];
                        return -1 ^ g;
                    }
                    f.exports = crc32;
                }
            }), le = __commonJS({
                "../node_modules/pako/lib/zlib/messages.js" (g, f) {
                    f.exports = {
                        2: "need dictionary",
                        1: "stream end",
                        0: "",
                        "-1": "file error",
                        "-2": "stream error",
                        "-3": "data error",
                        "-4": "insufficient memory",
                        "-5": "buffer error",
                        "-6": "incompatible version"
                    };
                }
            }), ce = __commonJS({
                "../node_modules/pako/lib/zlib/deflate.js" (g) {
                    var f, S = re(), v = ae(), _ = se(), C = oe(), E = le(), T = 0, I = 1, b = 3, A = 4, R = 5, P = 0, w = 1, M = -2, O = -3, D = -5, N = -1, k = 1, L = 2, F = 3, x = 4, U = 0, V = 2, B = 8, H = 9, $ = 15, j = 8, G = 286, q = 30, W = 19, z = 2 * G + 1, K = 15, J = 3, Y = 258, Q = Y + J + 1, X = 32, Z = 42, ee = 69, te = 73, ie = 91, ne = 103, ce = 113, de = 666, ue = 1, he = 2, ge = 3, pe = 4, me = 3;
                    function err(g, f) {
                        return g.msg = E[f], f;
                    }
                    function rank(g) {
                        return (g << 1) - (g > 4 ? 9 : 0);
                    }
                    function zero(g) {
                        for(var f = g.length; --f >= 0;)g[f] = 0;
                    }
                    function flush_pending(g) {
                        var f = g.state, v = f.pending;
                        v > g.avail_out && (v = g.avail_out), 0 !== v && (S.arraySet(g.output, f.pending_buf, f.pending_out, v, g.next_out), g.next_out += v, f.pending_out += v, g.total_out += v, g.avail_out -= v, f.pending -= v, 0 === f.pending && (f.pending_out = 0));
                    }
                    function flush_block_only(g, f) {
                        v._tr_flush_block(g, g.block_start >= 0 ? g.block_start : -1, g.strstart - g.block_start, f), g.block_start = g.strstart, flush_pending(g.strm);
                    }
                    function put_byte(g, f) {
                        g.pending_buf[g.pending++] = f;
                    }
                    function putShortMSB(g, f) {
                        g.pending_buf[g.pending++] = f >>> 8 & 255, g.pending_buf[g.pending++] = 255 & f;
                    }
                    function read_buf(g, f, v, E) {
                        var T = g.avail_in;
                        return T > E && (T = E), 0 === T ? 0 : (g.avail_in -= T, S.arraySet(f, g.input, g.next_in, T, v), 1 === g.state.wrap ? g.adler = _(g.adler, f, T, v) : 2 === g.state.wrap && (g.adler = C(g.adler, f, T, v)), g.next_in += T, g.total_in += T, T);
                    }
                    function longest_match(g, f) {
                        var S, v, _ = g.max_chain_length, C = g.strstart, E = g.prev_length, T = g.nice_match, I = g.strstart > g.w_size - Q ? g.strstart - (g.w_size - Q) : 0, b = g.window, A = g.w_mask, R = g.prev, P = g.strstart + Y, w = b[C + E - 1], M = b[C + E];
                        g.prev_length >= g.good_match && (_ >>= 2), T > g.lookahead && (T = g.lookahead);
                        do if (b[(S = f) + E] === M && b[S + E - 1] === w && b[S] === b[C] && b[++S] === b[C + 1]) {
                            C += 2, S++;
                            do ;
                            while (b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && C < P);
                            if (v = Y - (P - C), C = P - Y, v > E) {
                                if (g.match_start = f, E = v, v >= T) break;
                                w = b[C + E - 1], M = b[C + E];
                            }
                        }
                        while ((f = R[f & A]) > I && 0 != --_);
                        return E <= g.lookahead ? E : g.lookahead;
                    }
                    function fill_window(g) {
                        var f, v, _, C, E, T = g.w_size;
                        do {
                            if (C = g.window_size - g.lookahead - g.strstart, g.strstart >= T + (T - Q)) {
                                S.arraySet(g.window, g.window, T, T, 0), g.match_start -= T, g.strstart -= T, g.block_start -= T, f = v = g.hash_size;
                                do _ = g.head[--f], g.head[f] = _ >= T ? _ - T : 0;
                                while (--v);
                                f = v = T;
                                do _ = g.prev[--f], g.prev[f] = _ >= T ? _ - T : 0;
                                while (--v);
                                C += T;
                            }
                            if (0 === g.strm.avail_in) break;
                            if (v = read_buf(g.strm, g.window, g.strstart + g.lookahead, C), g.lookahead += v, g.lookahead + g.insert >= J) for(E = g.strstart - g.insert, g.ins_h = g.window[E], g.ins_h = (g.ins_h << g.hash_shift ^ g.window[E + 1]) & g.hash_mask; g.insert && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[E + J - 1]) & g.hash_mask, g.prev[E & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = E, E++, g.insert--, !(g.lookahead + g.insert < J)););
                        }while (g.lookahead < Q && 0 !== g.strm.avail_in);
                    }
                    function deflate_stored(g, f) {
                        var S = 65535;
                        for(S > g.pending_buf_size - 5 && (S = g.pending_buf_size - 5);;){
                            if (g.lookahead <= 1) {
                                if (fill_window(g), 0 === g.lookahead && f === T) return ue;
                                if (0 === g.lookahead) break;
                            }
                            g.strstart += g.lookahead, g.lookahead = 0;
                            var v = g.block_start + S;
                            if ((0 === g.strstart || g.strstart >= v) && (g.lookahead = g.strstart - v, g.strstart = v, flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                            if (g.strstart - g.block_start >= g.w_size - Q && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                        }
                        return g.insert = 0, f === A ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? ge : pe) : (g.strstart > g.block_start && (flush_block_only(g, !1), g.strm.avail_out), ue);
                    }
                    function deflate_fast(g, f) {
                        for(var S, _;;){
                            if (g.lookahead < Q) {
                                if (fill_window(g), g.lookahead < Q && f === T) return ue;
                                if (0 === g.lookahead) break;
                            }
                            if (S = 0, g.lookahead >= J && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + J - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart), 0 !== S && g.strstart - S <= g.w_size - Q && (g.match_length = longest_match(g, S)), g.match_length >= J) {
                                if (_ = v._tr_tally(g, g.strstart - g.match_start, g.match_length - J), g.lookahead -= g.match_length, g.match_length <= g.max_lazy_match && g.lookahead >= J) {
                                    g.match_length--;
                                    do g.strstart++, g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + J - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart;
                                    while (0 != --g.match_length);
                                    g.strstart++;
                                } else g.strstart += g.match_length, g.match_length = 0, g.ins_h = g.window[g.strstart], g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + 1]) & g.hash_mask;
                            } else _ = v._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++;
                            if (_ && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                        }
                        return g.insert = g.strstart < J - 1 ? g.strstart : J - 1, f === A ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? ge : pe) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? ue : he;
                    }
                    function deflate_slow(g, f) {
                        for(var S, _, C;;){
                            if (g.lookahead < Q) {
                                if (fill_window(g), g.lookahead < Q && f === T) return ue;
                                if (0 === g.lookahead) break;
                            }
                            if (S = 0, g.lookahead >= J && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + J - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart), g.prev_length = g.match_length, g.prev_match = g.match_start, g.match_length = J - 1, 0 !== S && g.prev_length < g.max_lazy_match && g.strstart - S <= g.w_size - Q && (g.match_length = longest_match(g, S), g.match_length <= 5 && (g.strategy === k || g.match_length === J && g.strstart - g.match_start > 4096) && (g.match_length = J - 1)), g.prev_length >= J && g.match_length <= g.prev_length) {
                                C = g.strstart + g.lookahead - J, _ = v._tr_tally(g, g.strstart - 1 - g.prev_match, g.prev_length - J), g.lookahead -= g.prev_length - 1, g.prev_length -= 2;
                                do ++g.strstart <= C && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + J - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart);
                                while (0 != --g.prev_length);
                                if (g.match_available = 0, g.match_length = J - 1, g.strstart++, _ && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                            } else if (g.match_available) {
                                if ((_ = v._tr_tally(g, 0, g.window[g.strstart - 1])) && flush_block_only(g, !1), g.strstart++, g.lookahead--, 0 === g.strm.avail_out) return ue;
                            } else g.match_available = 1, g.strstart++, g.lookahead--;
                        }
                        return g.match_available && (_ = v._tr_tally(g, 0, g.window[g.strstart - 1]), g.match_available = 0), g.insert = g.strstart < J - 1 ? g.strstart : J - 1, f === A ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? ge : pe) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? ue : he;
                    }
                    function deflate_rle(g, f) {
                        for(var S, _, C, E, I = g.window;;){
                            if (g.lookahead <= Y) {
                                if (fill_window(g), g.lookahead <= Y && f === T) return ue;
                                if (0 === g.lookahead) break;
                            }
                            if (g.match_length = 0, g.lookahead >= J && g.strstart > 0 && (_ = I[C = g.strstart - 1]) === I[++C] && _ === I[++C] && _ === I[++C]) {
                                E = g.strstart + Y;
                                do ;
                                while (_ === I[++C] && _ === I[++C] && _ === I[++C] && _ === I[++C] && _ === I[++C] && _ === I[++C] && _ === I[++C] && _ === I[++C] && C < E);
                                g.match_length = Y - (E - C), g.match_length > g.lookahead && (g.match_length = g.lookahead);
                            }
                            if (g.match_length >= J ? (S = v._tr_tally(g, 1, g.match_length - J), g.lookahead -= g.match_length, g.strstart += g.match_length, g.match_length = 0) : (S = v._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++), S && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                        }
                        return g.insert = 0, f === A ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? ge : pe) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? ue : he;
                    }
                    function deflate_huff(g, f) {
                        for(var S;;){
                            if (0 === g.lookahead && (fill_window(g), 0 === g.lookahead)) {
                                if (f === T) return ue;
                                break;
                            }
                            if (g.match_length = 0, S = v._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++, S && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return ue;
                        }
                        return g.insert = 0, f === A ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? ge : pe) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? ue : he;
                    }
                    function Config(g, f, S, v, _) {
                        this.good_length = g, this.max_lazy = f, this.nice_length = S, this.max_chain = v, this.func = _;
                    }
                    function lm_init(g) {
                        g.window_size = 2 * g.w_size, zero(g.head), g.max_lazy_match = f[g.level].max_lazy, g.good_match = f[g.level].good_length, g.nice_match = f[g.level].nice_length, g.max_chain_length = f[g.level].max_chain, g.strstart = 0, g.block_start = 0, g.lookahead = 0, g.insert = 0, g.match_length = g.prev_length = J - 1, g.match_available = 0, g.ins_h = 0;
                    }
                    function DeflateState() {
                        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = B, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new S.Buf16(2 * z), this.dyn_dtree = new S.Buf16(2 * (2 * q + 1)), this.bl_tree = new S.Buf16(2 * (2 * W + 1)), zero(this.dyn_ltree), zero(this.dyn_dtree), zero(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new S.Buf16(K + 1), this.heap = new S.Buf16(2 * G + 1), zero(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new S.Buf16(2 * G + 1), zero(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                    }
                    function deflateResetKeep(g) {
                        var f;
                        return g && g.state ? (g.total_in = g.total_out = 0, g.data_type = V, (f = g.state).pending = 0, f.pending_out = 0, f.wrap < 0 && (f.wrap = -f.wrap), f.status = f.wrap ? Z : ce, g.adler = 2 === f.wrap ? 0 : 1, f.last_flush = T, v._tr_init(f), P) : err(g, M);
                    }
                    function deflateReset(g) {
                        var f = deflateResetKeep(g);
                        return f === P && lm_init(g.state), f;
                    }
                    function deflateSetHeader(g, f) {
                        return g && g.state ? 2 !== g.state.wrap ? M : (g.state.gzhead = f, P) : M;
                    }
                    function deflateInit2(g, f, v, _, C, E) {
                        if (!g) return M;
                        var T = 1;
                        if (f === N && (f = 6), _ < 0 ? (T = 0, _ = -_) : _ > 15 && (T = 2, _ -= 16), C < 1 || C > H || v !== B || _ < 8 || _ > 15 || f < 0 || f > 9 || E < 0 || E > x) return err(g, M);
                        8 === _ && (_ = 9);
                        var I = new DeflateState;
                        return g.state = I, I.strm = g, I.wrap = T, I.gzhead = null, I.w_bits = _, I.w_size = 1 << I.w_bits, I.w_mask = I.w_size - 1, I.hash_bits = C + 7, I.hash_size = 1 << I.hash_bits, I.hash_mask = I.hash_size - 1, I.hash_shift = ~~((I.hash_bits + J - 1) / J), I.window = new S.Buf8(2 * I.w_size), I.head = new S.Buf16(I.hash_size), I.prev = new S.Buf16(I.w_size), I.lit_bufsize = 1 << C + 6, I.pending_buf_size = 4 * I.lit_bufsize, I.pending_buf = new S.Buf8(I.pending_buf_size), I.d_buf = 1 * I.lit_bufsize, I.l_buf = 3 * I.lit_bufsize, I.level = f, I.strategy = E, I.method = v, deflateReset(g);
                    }
                    function deflateInit(g, f) {
                        return deflateInit2(g, f, B, $, j, U);
                    }
                    function deflate(g, S) {
                        var _, E, O, N;
                        if (!g || !g.state || S > R || S < 0) return g ? err(g, M) : M;
                        if (E = g.state, !g.output || !g.input && 0 !== g.avail_in || E.status === de && S !== A) return err(g, 0 === g.avail_out ? D : M);
                        if (E.strm = g, _ = E.last_flush, E.last_flush = S, E.status === Z) {
                            if (2 === E.wrap) g.adler = 0, put_byte(E, 31), put_byte(E, 139), put_byte(E, 8), E.gzhead ? (put_byte(E, (E.gzhead.text ? 1 : 0) + (E.gzhead.hcrc ? 2 : 0) + (E.gzhead.extra ? 4 : 0) + (E.gzhead.name ? 8 : 0) + (E.gzhead.comment ? 16 : 0)), put_byte(E, 255 & E.gzhead.time), put_byte(E, E.gzhead.time >> 8 & 255), put_byte(E, E.gzhead.time >> 16 & 255), put_byte(E, E.gzhead.time >> 24 & 255), put_byte(E, 9 === E.level ? 2 : E.strategy >= L || E.level < 2 ? 4 : 0), put_byte(E, 255 & E.gzhead.os), E.gzhead.extra && E.gzhead.extra.length && (put_byte(E, 255 & E.gzhead.extra.length), put_byte(E, E.gzhead.extra.length >> 8 & 255)), E.gzhead.hcrc && (g.adler = C(g.adler, E.pending_buf, E.pending, 0)), E.gzindex = 0, E.status = ee) : (put_byte(E, 0), put_byte(E, 0), put_byte(E, 0), put_byte(E, 0), put_byte(E, 0), put_byte(E, 9 === E.level ? 2 : E.strategy >= L || E.level < 2 ? 4 : 0), put_byte(E, me), E.status = ce);
                            else {
                                var k = B + (E.w_bits - 8 << 4) << 8;
                                k |= (E.strategy >= L || E.level < 2 ? 0 : E.level < 6 ? 1 : 6 === E.level ? 2 : 3) << 6, 0 !== E.strstart && (k |= X), k += 31 - k % 31, E.status = ce, putShortMSB(E, k), 0 !== E.strstart && (putShortMSB(E, g.adler >>> 16), putShortMSB(E, 65535 & g.adler)), g.adler = 1;
                            }
                        }
                        if (E.status === ee) {
                            if (E.gzhead.extra) {
                                for(O = E.pending; E.gzindex < (65535 & E.gzhead.extra.length) && (E.pending !== E.pending_buf_size || (E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), flush_pending(g), O = E.pending, E.pending !== E.pending_buf_size));)put_byte(E, 255 & E.gzhead.extra[E.gzindex]), E.gzindex++;
                                E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), E.gzindex === E.gzhead.extra.length && (E.gzindex = 0, E.status = te);
                            } else E.status = te;
                        }
                        if (E.status === te) {
                            if (E.gzhead.name) {
                                O = E.pending;
                                do {
                                    if (E.pending === E.pending_buf_size && (E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), flush_pending(g), O = E.pending, E.pending === E.pending_buf_size)) {
                                        N = 1;
                                        break;
                                    }
                                    N = E.gzindex < E.gzhead.name.length ? 255 & E.gzhead.name.charCodeAt(E.gzindex++) : 0, put_byte(E, N);
                                }while (0 !== N);
                                E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), 0 === N && (E.gzindex = 0, E.status = ie);
                            } else E.status = ie;
                        }
                        if (E.status === ie) {
                            if (E.gzhead.comment) {
                                O = E.pending;
                                do {
                                    if (E.pending === E.pending_buf_size && (E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), flush_pending(g), O = E.pending, E.pending === E.pending_buf_size)) {
                                        N = 1;
                                        break;
                                    }
                                    N = E.gzindex < E.gzhead.comment.length ? 255 & E.gzhead.comment.charCodeAt(E.gzindex++) : 0, put_byte(E, N);
                                }while (0 !== N);
                                E.gzhead.hcrc && E.pending > O && (g.adler = C(g.adler, E.pending_buf, E.pending - O, O)), 0 === N && (E.status = ne);
                            } else E.status = ne;
                        }
                        if (E.status === ne && (E.gzhead.hcrc ? (E.pending + 2 > E.pending_buf_size && flush_pending(g), E.pending + 2 <= E.pending_buf_size && (put_byte(E, 255 & g.adler), put_byte(E, g.adler >> 8 & 255), g.adler = 0, E.status = ce)) : E.status = ce), 0 !== E.pending) {
                            if (flush_pending(g), 0 === g.avail_out) return E.last_flush = -1, P;
                        } else if (0 === g.avail_in && rank(S) <= rank(_) && S !== A) return err(g, D);
                        if (E.status === de && 0 !== g.avail_in) return err(g, D);
                        if (0 !== g.avail_in || 0 !== E.lookahead || S !== T && E.status !== de) {
                            var x = E.strategy === L ? deflate_huff(E, S) : E.strategy === F ? deflate_rle(E, S) : f[E.level].func(E, S);
                            if (x !== ge && x !== pe || (E.status = de), x === ue || x === ge) return 0 === g.avail_out && (E.last_flush = -1), P;
                            if (x === he && (S === I ? v._tr_align(E) : S !== R && (v._tr_stored_block(E, 0, 0, !1), S === b && (zero(E.head), 0 === E.lookahead && (E.strstart = 0, E.block_start = 0, E.insert = 0))), flush_pending(g), 0 === g.avail_out)) return E.last_flush = -1, P;
                        }
                        return S !== A ? P : E.wrap <= 0 ? w : (2 === E.wrap ? (put_byte(E, 255 & g.adler), put_byte(E, g.adler >> 8 & 255), put_byte(E, g.adler >> 16 & 255), put_byte(E, g.adler >> 24 & 255), put_byte(E, 255 & g.total_in), put_byte(E, g.total_in >> 8 & 255), put_byte(E, g.total_in >> 16 & 255), put_byte(E, g.total_in >> 24 & 255)) : (putShortMSB(E, g.adler >>> 16), putShortMSB(E, 65535 & g.adler)), flush_pending(g), E.wrap > 0 && (E.wrap = -E.wrap), 0 !== E.pending ? P : w);
                    }
                    function deflateEnd(g) {
                        var f;
                        return g && g.state ? (f = g.state.status) !== Z && f !== ee && f !== te && f !== ie && f !== ne && f !== ce && f !== de ? err(g, M) : (g.state = null, f === ce ? err(g, O) : P) : M;
                    }
                    function deflateSetDictionary(g, f) {
                        var v, C, E, T, I, b, A, R, w = f.length;
                        if (!g || !g.state) return M;
                        if (2 === (T = (v = g.state).wrap) || 1 === T && v.status !== Z || v.lookahead) return M;
                        for(1 === T && (g.adler = _(g.adler, f, w, 0)), v.wrap = 0, w >= v.w_size && (0 === T && (zero(v.head), v.strstart = 0, v.block_start = 0, v.insert = 0), R = new S.Buf8(v.w_size), S.arraySet(R, f, w - v.w_size, v.w_size, 0), f = R, w = v.w_size), I = g.avail_in, b = g.next_in, A = g.input, g.avail_in = w, g.next_in = 0, g.input = f, fill_window(v); v.lookahead >= J;){
                            C = v.strstart, E = v.lookahead - (J - 1);
                            do v.ins_h = (v.ins_h << v.hash_shift ^ v.window[C + J - 1]) & v.hash_mask, v.prev[C & v.w_mask] = v.head[v.ins_h], v.head[v.ins_h] = C, C++;
                            while (--E);
                            v.strstart = C, v.lookahead = J - 1, fill_window(v);
                        }
                        return v.strstart += v.lookahead, v.block_start = v.strstart, v.insert = v.lookahead, v.lookahead = 0, v.match_length = v.prev_length = J - 1, v.match_available = 0, g.next_in = b, g.input = A, g.avail_in = I, v.wrap = T, P;
                    }
                    f = [
                        new Config(0, 0, 0, 0, deflate_stored),
                        new Config(4, 4, 8, 4, deflate_fast),
                        new Config(4, 5, 16, 8, deflate_fast),
                        new Config(4, 6, 32, 32, deflate_fast),
                        new Config(4, 4, 16, 16, deflate_slow),
                        new Config(8, 16, 32, 32, deflate_slow),
                        new Config(8, 16, 128, 128, deflate_slow),
                        new Config(8, 32, 128, 256, deflate_slow),
                        new Config(32, 128, 258, 1024, deflate_slow),
                        new Config(32, 258, 258, 4096, deflate_slow)
                    ], g.deflateInit = deflateInit, g.deflateInit2 = deflateInit2, g.deflateReset = deflateReset, g.deflateResetKeep = deflateResetKeep, g.deflateSetHeader = deflateSetHeader, g.deflate = deflate, g.deflateEnd = deflateEnd, g.deflateSetDictionary = deflateSetDictionary, g.deflateInfo = "pako deflate (from Nodeca project)";
                }
            }), de = __commonJS({
                "../node_modules/pako/lib/utils/strings.js" (g) {
                    var f = re(), S = !0, v = !0;
                    try {
                        String.fromCharCode.apply(null, [
                            0
                        ]);
                    } catch (g) {
                        S = !1;
                    }
                    try {
                        String.fromCharCode.apply(null, new Uint8Array(1));
                    } catch (g) {
                        v = !1;
                    }
                    var _, C = new f.Buf8(256);
                    for(_ = 0; _ < 256; _++)C[_] = _ >= 252 ? 6 : _ >= 248 ? 5 : _ >= 240 ? 4 : _ >= 224 ? 3 : _ >= 192 ? 2 : 1;
                    function buf2binstring(g, _) {
                        if (_ < 65534 && (g.subarray && v || !g.subarray && S)) return String.fromCharCode.apply(null, f.shrinkBuf(g, _));
                        for(var C = "", E = 0; E < _; E++)C += String.fromCharCode(g[E]);
                        return C;
                    }
                    C[254] = C[254] = 1, g.string2buf = function(g) {
                        var S, v, _, C, E, T = g.length, I = 0;
                        for(C = 0; C < T; C++)55296 == (64512 & (v = g.charCodeAt(C))) && C + 1 < T && 56320 == (64512 & (_ = g.charCodeAt(C + 1))) && (v = 65536 + (v - 55296 << 10) + (_ - 56320), C++), I += v < 128 ? 1 : v < 2048 ? 2 : v < 65536 ? 3 : 4;
                        for(S = new f.Buf8(I), E = 0, C = 0; E < I; C++)55296 == (64512 & (v = g.charCodeAt(C))) && C + 1 < T && 56320 == (64512 & (_ = g.charCodeAt(C + 1))) && (v = 65536 + (v - 55296 << 10) + (_ - 56320), C++), v < 128 ? S[E++] = v : v < 2048 ? (S[E++] = 192 | v >>> 6, S[E++] = 128 | 63 & v) : v < 65536 ? (S[E++] = 224 | v >>> 12, S[E++] = 128 | v >>> 6 & 63, S[E++] = 128 | 63 & v) : (S[E++] = 240 | v >>> 18, S[E++] = 128 | v >>> 12 & 63, S[E++] = 128 | v >>> 6 & 63, S[E++] = 128 | 63 & v);
                        return S;
                    }, g.buf2binstring = function(g) {
                        return buf2binstring(g, g.length);
                    }, g.binstring2buf = function(g) {
                        for(var S = new f.Buf8(g.length), v = 0, _ = S.length; v < _; v++)S[v] = g.charCodeAt(v);
                        return S;
                    }, g.buf2string = function(g, f) {
                        var S, v, _, E, T = f || g.length, I = new Array(2 * T);
                        for(v = 0, S = 0; S < T;)if ((_ = g[S++]) < 128) I[v++] = _;
                        else if ((E = C[_]) > 4) I[v++] = 65533, S += E - 1;
                        else {
                            for(_ &= 2 === E ? 31 : 3 === E ? 15 : 7; E > 1 && S < T;)_ = _ << 6 | 63 & g[S++], E--;
                            E > 1 ? I[v++] = 65533 : _ < 65536 ? I[v++] = _ : (_ -= 65536, I[v++] = 55296 | _ >> 10 & 1023, I[v++] = 56320 | 1023 & _);
                        }
                        return buf2binstring(I, v);
                    }, g.utf8border = function(g, f) {
                        var S;
                        for((f = f || g.length) > g.length && (f = g.length), S = f - 1; S >= 0 && 128 == (192 & g[S]);)S--;
                        return S < 0 || 0 === S ? f : S + C[g[S]] > f ? S : f;
                    };
                }
            }), ue = __commonJS({
                "../node_modules/pako/lib/zlib/zstream.js" (g, f) {
                    function ZStream() {
                        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                    }
                    f.exports = ZStream;
                }
            }), he = __commonJS({
                "../node_modules/pako/lib/deflate.js" (g) {
                    var f = ce(), S = re(), v = de(), _ = le(), C = ue(), E = Object.prototype.toString, T = 0, I = 4, b = 0, A = 1, R = 2, P = -1, w = 0, M = 8;
                    function Deflate(g) {
                        if (!(this instanceof Deflate)) return new Deflate(g);
                        this.options = S.assign({
                            level: P,
                            method: M,
                            chunkSize: 16384,
                            windowBits: 15,
                            memLevel: 8,
                            strategy: w,
                            to: ""
                        }, g || {});
                        var T = this.options;
                        T.raw && T.windowBits > 0 ? T.windowBits = -T.windowBits : T.gzip && T.windowBits > 0 && T.windowBits < 16 && (T.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new C, this.strm.avail_out = 0;
                        var I = f.deflateInit2(this.strm, T.level, T.method, T.windowBits, T.memLevel, T.strategy);
                        if (I !== b) throw new Error(_[I]);
                        if (T.header && f.deflateSetHeader(this.strm, T.header), T.dictionary) {
                            var A;
                            if (A = "string" == typeof T.dictionary ? v.string2buf(T.dictionary) : "[object ArrayBuffer]" === E.call(T.dictionary) ? new Uint8Array(T.dictionary) : T.dictionary, (I = f.deflateSetDictionary(this.strm, A)) !== b) throw new Error(_[I]);
                            this._dict_set = !0;
                        }
                    }
                    function deflate(g, f) {
                        var S = new Deflate(f);
                        if (S.push(g, !0), S.err) throw S.msg || _[S.err];
                        return S.result;
                    }
                    function deflateRaw(g, f) {
                        return (f = f || {}).raw = !0, deflate(g, f);
                    }
                    function gzip(g, f) {
                        return (f = f || {}).gzip = !0, deflate(g, f);
                    }
                    Deflate.prototype.push = function(g, _) {
                        var C, P, w = this.strm, M = this.options.chunkSize;
                        if (this.ended) return !1;
                        P = _ === ~~_ ? _ : !0 === _ ? I : T, "string" == typeof g ? w.input = v.string2buf(g) : "[object ArrayBuffer]" === E.call(g) ? w.input = new Uint8Array(g) : w.input = g, w.next_in = 0, w.avail_in = w.input.length;
                        do {
                            if (0 === w.avail_out && (w.output = new S.Buf8(M), w.next_out = 0, w.avail_out = M), (C = f.deflate(w, P)) !== A && C !== b) return this.onEnd(C), this.ended = !0, !1;
                            0 !== w.avail_out && (0 !== w.avail_in || P !== I && P !== R) || ("string" === this.options.to ? this.onData(v.buf2binstring(S.shrinkBuf(w.output, w.next_out))) : this.onData(S.shrinkBuf(w.output, w.next_out)));
                        }while ((w.avail_in > 0 || 0 === w.avail_out) && C !== A);
                        return P === I ? (C = f.deflateEnd(this.strm), this.onEnd(C), this.ended = !0, C === b) : P !== R || (this.onEnd(b), w.avail_out = 0, !0);
                    }, Deflate.prototype.onData = function(g) {
                        this.chunks.push(g);
                    }, Deflate.prototype.onEnd = function(g) {
                        g === b && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = S.flattenChunks(this.chunks)), this.chunks = [], this.err = g, this.msg = this.strm.msg;
                    }, g.Deflate = Deflate, g.deflate = deflate, g.deflateRaw = deflateRaw, g.gzip = gzip;
                }
            }), ge = __commonJS({
                "../node_modules/pako/lib/zlib/inffast.js" (g, f) {
                    var S = 30, v = 12;
                    f.exports = function inflate_fast(g, f) {
                        var _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G;
                        _ = g.state, C = g.next_in, j = g.input, E = C + (g.avail_in - 5), T = g.next_out, G = g.output, I = T - (f - g.avail_out), b = T + (g.avail_out - 257), A = _.dmax, R = _.wsize, P = _.whave, w = _.wnext, M = _.window, O = _.hold, D = _.bits, N = _.lencode, k = _.distcode, L = (1 << _.lenbits) - 1, F = (1 << _.distbits) - 1;
                        e: do {
                            D < 15 && (O += j[C++] << D, D += 8, O += j[C++] << D, D += 8), x = N[O & L];
                            t: for(;;){
                                if (O >>>= U = x >>> 24, D -= U, 0 === (U = x >>> 16 & 255)) G[T++] = 65535 & x;
                                else {
                                    if (!(16 & U)) {
                                        if (0 == (64 & U)) {
                                            x = N[(65535 & x) + (O & (1 << U) - 1)];
                                            continue t;
                                        }
                                        if (32 & U) {
                                            _.mode = v;
                                            break e;
                                        }
                                        g.msg = "invalid literal/length code", _.mode = S;
                                        break e;
                                    }
                                    V = 65535 & x, (U &= 15) && (D < U && (O += j[C++] << D, D += 8), V += O & (1 << U) - 1, O >>>= U, D -= U), D < 15 && (O += j[C++] << D, D += 8, O += j[C++] << D, D += 8), x = k[O & F];
                                    i: for(;;){
                                        if (O >>>= U = x >>> 24, D -= U, !(16 & (U = x >>> 16 & 255))) {
                                            if (0 == (64 & U)) {
                                                x = k[(65535 & x) + (O & (1 << U) - 1)];
                                                continue i;
                                            }
                                            g.msg = "invalid distance code", _.mode = S;
                                            break e;
                                        }
                                        if (B = 65535 & x, D < (U &= 15) && (O += j[C++] << D, (D += 8) < U && (O += j[C++] << D, D += 8)), (B += O & (1 << U) - 1) > A) {
                                            g.msg = "invalid distance too far back", _.mode = S;
                                            break e;
                                        }
                                        if (O >>>= U, D -= U, B > (U = T - I)) {
                                            if ((U = B - U) > P && _.sane) {
                                                g.msg = "invalid distance too far back", _.mode = S;
                                                break e;
                                            }
                                            if (H = 0, $ = M, 0 === w) {
                                                if (H += R - U, U < V) {
                                                    V -= U;
                                                    do G[T++] = M[H++];
                                                    while (--U);
                                                    H = T - B, $ = G;
                                                }
                                            } else if (w < U) {
                                                if (H += R + w - U, (U -= w) < V) {
                                                    V -= U;
                                                    do G[T++] = M[H++];
                                                    while (--U);
                                                    if (H = 0, w < V) {
                                                        V -= U = w;
                                                        do G[T++] = M[H++];
                                                        while (--U);
                                                        H = T - B, $ = G;
                                                    }
                                                }
                                            } else if (H += w - U, U < V) {
                                                V -= U;
                                                do G[T++] = M[H++];
                                                while (--U);
                                                H = T - B, $ = G;
                                            }
                                            for(; V > 2;)G[T++] = $[H++], G[T++] = $[H++], G[T++] = $[H++], V -= 3;
                                            V && (G[T++] = $[H++], V > 1 && (G[T++] = $[H++]));
                                        } else {
                                            H = T - B;
                                            do G[T++] = G[H++], G[T++] = G[H++], G[T++] = G[H++], V -= 3;
                                            while (V > 2);
                                            V && (G[T++] = G[H++], V > 1 && (G[T++] = G[H++]));
                                        }
                                        break;
                                    }
                                }
                                break;
                            }
                        }while (C < E && T < b);
                        C -= V = D >> 3, O &= (1 << (D -= V << 3)) - 1, g.next_in = C, g.next_out = T, g.avail_in = C < E ? E - C + 5 : 5 - (C - E), g.avail_out = T < b ? b - T + 257 : 257 - (T - b), _.hold = O, _.bits = D;
                    };
                }
            }), pe = __commonJS({
                "../node_modules/pako/lib/zlib/inftrees.js" (g, f) {
                    var S = re(), v = 15, _ = 852, C = 592, E = 0, T = 1, I = 2, b = [
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        13,
                        15,
                        17,
                        19,
                        23,
                        27,
                        31,
                        35,
                        43,
                        51,
                        59,
                        67,
                        83,
                        99,
                        115,
                        131,
                        163,
                        195,
                        227,
                        258,
                        0,
                        0
                    ], A = [
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        17,
                        17,
                        18,
                        18,
                        18,
                        18,
                        19,
                        19,
                        19,
                        19,
                        20,
                        20,
                        20,
                        20,
                        21,
                        21,
                        21,
                        21,
                        16,
                        72,
                        78
                    ], R = [
                        1,
                        2,
                        3,
                        4,
                        5,
                        7,
                        9,
                        13,
                        17,
                        25,
                        33,
                        49,
                        65,
                        97,
                        129,
                        193,
                        257,
                        385,
                        513,
                        769,
                        1025,
                        1537,
                        2049,
                        3073,
                        4097,
                        6145,
                        8193,
                        12289,
                        16385,
                        24577,
                        0,
                        0
                    ], P = [
                        16,
                        16,
                        16,
                        16,
                        17,
                        17,
                        18,
                        18,
                        19,
                        19,
                        20,
                        20,
                        21,
                        21,
                        22,
                        22,
                        23,
                        23,
                        24,
                        24,
                        25,
                        25,
                        26,
                        26,
                        27,
                        27,
                        28,
                        28,
                        29,
                        29,
                        64,
                        64
                    ];
                    f.exports = function inflate_table(g, f, w, M, O, D, N, k) {
                        var L, F, x, U, V, B, H, $, j, G = k.bits, q = 0, W = 0, z = 0, K = 0, J = 0, Y = 0, Q = 0, X = 0, Z = 0, ee = 0, te = null, ie = 0, ne = new S.Buf16(v + 1), re = new S.Buf16(v + 1), ae = null, se = 0;
                        for(q = 0; q <= v; q++)ne[q] = 0;
                        for(W = 0; W < M; W++)ne[f[w + W]]++;
                        for(J = G, K = v; K >= 1 && 0 === ne[K]; K--);
                        if (J > K && (J = K), 0 === K) return O[D++] = 20971520, O[D++] = 20971520, k.bits = 1, 0;
                        for(z = 1; z < K && 0 === ne[z]; z++);
                        for(J < z && (J = z), X = 1, q = 1; q <= v; q++)if (X <<= 1, (X -= ne[q]) < 0) return -1;
                        if (X > 0 && (g === E || 1 !== K)) return -1;
                        for(re[1] = 0, q = 1; q < v; q++)re[q + 1] = re[q] + ne[q];
                        for(W = 0; W < M; W++)0 !== f[w + W] && (N[re[f[w + W]]++] = W);
                        if (g === E ? (te = ae = N, B = 19) : g === T ? (te = b, ie -= 257, ae = A, se -= 257, B = 256) : (te = R, ae = P, B = -1), ee = 0, W = 0, q = z, V = D, Y = J, Q = 0, x = -1, U = (Z = 1 << J) - 1, g === T && Z > _ || g === I && Z > C) return 1;
                        for(;;){
                            H = q - Q, N[W] < B ? ($ = 0, j = N[W]) : N[W] > B ? ($ = ae[se + N[W]], j = te[ie + N[W]]) : ($ = 96, j = 0), L = 1 << q - Q, z = F = 1 << Y;
                            do O[V + (ee >> Q) + (F -= L)] = H << 24 | $ << 16 | j | 0;
                            while (0 !== F);
                            for(L = 1 << q - 1; ee & L;)L >>= 1;
                            if (0 !== L ? (ee &= L - 1, ee += L) : ee = 0, W++, 0 == --ne[q]) {
                                if (q === K) break;
                                q = f[w + N[W]];
                            }
                            if (q > J && (ee & U) !== x) {
                                for(0 === Q && (Q = J), V += z, X = 1 << (Y = q - Q); Y + Q < K && !((X -= ne[Y + Q]) <= 0);)Y++, X <<= 1;
                                if (Z += 1 << Y, g === T && Z > _ || g === I && Z > C) return 1;
                                O[x = ee & U] = J << 24 | Y << 16 | V - D | 0;
                            }
                        }
                        return 0 !== ee && (O[V + ee] = q - Q << 24 | 4194304), k.bits = J, 0;
                    };
                }
            }), me = __commonJS({
                "../node_modules/pako/lib/zlib/inflate.js" (g) {
                    var f = re(), S = se(), v = oe(), _ = ge(), C = pe(), E = 0, T = 1, I = 2, b = 4, A = 5, R = 6, P = 0, w = 1, M = 2, O = -2, D = -3, N = -4, k = -5, L = 8, F = 1, x = 2, U = 3, V = 4, B = 5, H = 6, $ = 7, j = 8, G = 9, q = 10, W = 11, z = 12, K = 13, J = 14, Y = 15, Q = 16, X = 17, Z = 18, ee = 19, te = 20, ie = 21, ne = 22, ae = 23, le = 24, ce = 25, de = 26, ue = 27, he = 28, me = 29, fe = 30, Se = 31, ve = 852, _e = 592, Ce = 15;
                    function zswap32(g) {
                        return (g >>> 24 & 255) + (g >>> 8 & 65280) + ((65280 & g) << 8) + ((255 & g) << 24);
                    }
                    function InflateState() {
                        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new f.Buf16(320), this.work = new f.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                    }
                    function inflateResetKeep(g) {
                        var S;
                        return g && g.state ? (S = g.state, g.total_in = g.total_out = S.total = 0, g.msg = "", S.wrap && (g.adler = 1 & S.wrap), S.mode = F, S.last = 0, S.havedict = 0, S.dmax = 32768, S.head = null, S.hold = 0, S.bits = 0, S.lencode = S.lendyn = new f.Buf32(ve), S.distcode = S.distdyn = new f.Buf32(_e), S.sane = 1, S.back = -1, P) : O;
                    }
                    function inflateReset(g) {
                        var f;
                        return g && g.state ? ((f = g.state).wsize = 0, f.whave = 0, f.wnext = 0, inflateResetKeep(g)) : O;
                    }
                    function inflateReset2(g, f) {
                        var S, v;
                        return g && g.state ? (v = g.state, f < 0 ? (S = 0, f = -f) : (S = 1 + (f >> 4), f < 48 && (f &= 15)), f && (f < 8 || f > 15) ? O : (null !== v.window && v.wbits !== f && (v.window = null), v.wrap = S, v.wbits = f, inflateReset(g))) : O;
                    }
                    function inflateInit2(g, f) {
                        var S, v;
                        return g ? (v = new InflateState, g.state = v, v.window = null, (S = inflateReset2(g, f)) !== P && (g.state = null), S) : O;
                    }
                    function inflateInit(g) {
                        return inflateInit2(g, Ce);
                    }
                    var ye, Ee, Te = !0;
                    function fixedtables(g) {
                        if (Te) {
                            var S;
                            for(ye = new f.Buf32(512), Ee = new f.Buf32(32), S = 0; S < 144;)g.lens[S++] = 8;
                            for(; S < 256;)g.lens[S++] = 9;
                            for(; S < 280;)g.lens[S++] = 7;
                            for(; S < 288;)g.lens[S++] = 8;
                            for(C(T, g.lens, 0, 288, ye, 0, g.work, {
                                bits: 9
                            }), S = 0; S < 32;)g.lens[S++] = 5;
                            C(I, g.lens, 0, 32, Ee, 0, g.work, {
                                bits: 5
                            }), Te = !1;
                        }
                        g.lencode = ye, g.lenbits = 9, g.distcode = Ee, g.distbits = 5;
                    }
                    function updatewindow(g, S, v, _) {
                        var C, E = g.state;
                        return null === E.window && (E.wsize = 1 << E.wbits, E.wnext = 0, E.whave = 0, E.window = new f.Buf8(E.wsize)), _ >= E.wsize ? (f.arraySet(E.window, S, v - E.wsize, E.wsize, 0), E.wnext = 0, E.whave = E.wsize) : ((C = E.wsize - E.wnext) > _ && (C = _), f.arraySet(E.window, S, v - _, C, E.wnext), (_ -= C) ? (f.arraySet(E.window, S, v - _, _, 0), E.wnext = _, E.whave = E.wsize) : (E.wnext += C, E.wnext === E.wsize && (E.wnext = 0), E.whave < E.wsize && (E.whave += C))), 0;
                    }
                    function inflate3(g, re) {
                        var se, oe, ge, pe, ve, _e, Ce, ye, Ee, Te, Ie, be, Ae, Re, Pe, we, Me, Oe, De, Ne, ke, Le, Fe, xe, Ue = 0, Ve = new f.Buf8(4), Be = [
                            16,
                            17,
                            18,
                            0,
                            8,
                            7,
                            9,
                            6,
                            10,
                            5,
                            11,
                            4,
                            12,
                            3,
                            13,
                            2,
                            14,
                            1,
                            15
                        ];
                        if (!g || !g.state || !g.output || !g.input && 0 !== g.avail_in) return O;
                        (se = g.state).mode === z && (se.mode = K), ve = g.next_out, ge = g.output, Ce = g.avail_out, pe = g.next_in, oe = g.input, _e = g.avail_in, ye = se.hold, Ee = se.bits, Te = _e, Ie = Ce, Le = P;
                        e: for(;;)switch(se.mode){
                            case F:
                                if (0 === se.wrap) {
                                    se.mode = K;
                                    break;
                                }
                                for(; Ee < 16;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if (2 & se.wrap && 35615 === ye) {
                                    se.check = 0, Ve[0] = 255 & ye, Ve[1] = ye >>> 8 & 255, se.check = v(se.check, Ve, 2, 0), ye = 0, Ee = 0, se.mode = x;
                                    break;
                                }
                                if (se.flags = 0, se.head && (se.head.done = !1), !(1 & se.wrap) || (((255 & ye) << 8) + (ye >> 8)) % 31) {
                                    g.msg = "incorrect header check", se.mode = fe;
                                    break;
                                }
                                if ((15 & ye) !== L) {
                                    g.msg = "unknown compression method", se.mode = fe;
                                    break;
                                }
                                if (Ee -= 4, ke = 8 + (15 & (ye >>>= 4)), 0 === se.wbits) se.wbits = ke;
                                else if (ke > se.wbits) {
                                    g.msg = "invalid window size", se.mode = fe;
                                    break;
                                }
                                se.dmax = 1 << ke, g.adler = se.check = 1, se.mode = 512 & ye ? q : z, ye = 0, Ee = 0;
                                break;
                            case x:
                                for(; Ee < 16;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if (se.flags = ye, (255 & se.flags) !== L) {
                                    g.msg = "unknown compression method", se.mode = fe;
                                    break;
                                }
                                if (57344 & se.flags) {
                                    g.msg = "unknown header flags set", se.mode = fe;
                                    break;
                                }
                                se.head && (se.head.text = ye >> 8 & 1), 512 & se.flags && (Ve[0] = 255 & ye, Ve[1] = ye >>> 8 & 255, se.check = v(se.check, Ve, 2, 0)), ye = 0, Ee = 0, se.mode = U;
                            case U:
                                for(; Ee < 32;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                se.head && (se.head.time = ye), 512 & se.flags && (Ve[0] = 255 & ye, Ve[1] = ye >>> 8 & 255, Ve[2] = ye >>> 16 & 255, Ve[3] = ye >>> 24 & 255, se.check = v(se.check, Ve, 4, 0)), ye = 0, Ee = 0, se.mode = V;
                            case V:
                                for(; Ee < 16;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                se.head && (se.head.xflags = 255 & ye, se.head.os = ye >> 8), 512 & se.flags && (Ve[0] = 255 & ye, Ve[1] = ye >>> 8 & 255, se.check = v(se.check, Ve, 2, 0)), ye = 0, Ee = 0, se.mode = B;
                            case B:
                                if (1024 & se.flags) {
                                    for(; Ee < 16;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    se.length = ye, se.head && (se.head.extra_len = ye), 512 & se.flags && (Ve[0] = 255 & ye, Ve[1] = ye >>> 8 & 255, se.check = v(se.check, Ve, 2, 0)), ye = 0, Ee = 0;
                                } else se.head && (se.head.extra = null);
                                se.mode = H;
                            case H:
                                if (1024 & se.flags && ((be = se.length) > _e && (be = _e), be && (se.head && (ke = se.head.extra_len - se.length, se.head.extra || (se.head.extra = new Array(se.head.extra_len)), f.arraySet(se.head.extra, oe, pe, be, ke)), 512 & se.flags && (se.check = v(se.check, oe, be, pe)), _e -= be, pe += be, se.length -= be), se.length)) break e;
                                se.length = 0, se.mode = $;
                            case $:
                                if (2048 & se.flags) {
                                    if (0 === _e) break e;
                                    be = 0;
                                    do ke = oe[pe + be++], se.head && ke && se.length < 65536 && (se.head.name += String.fromCharCode(ke));
                                    while (ke && be < _e);
                                    if (512 & se.flags && (se.check = v(se.check, oe, be, pe)), _e -= be, pe += be, ke) break e;
                                } else se.head && (se.head.name = null);
                                se.length = 0, se.mode = j;
                            case j:
                                if (4096 & se.flags) {
                                    if (0 === _e) break e;
                                    be = 0;
                                    do ke = oe[pe + be++], se.head && ke && se.length < 65536 && (se.head.comment += String.fromCharCode(ke));
                                    while (ke && be < _e);
                                    if (512 & se.flags && (se.check = v(se.check, oe, be, pe)), _e -= be, pe += be, ke) break e;
                                } else se.head && (se.head.comment = null);
                                se.mode = G;
                            case G:
                                if (512 & se.flags) {
                                    for(; Ee < 16;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    if (ye !== (65535 & se.check)) {
                                        g.msg = "header crc mismatch", se.mode = fe;
                                        break;
                                    }
                                    ye = 0, Ee = 0;
                                }
                                se.head && (se.head.hcrc = se.flags >> 9 & 1, se.head.done = !0), g.adler = se.check = 0, se.mode = z;
                                break;
                            case q:
                                for(; Ee < 32;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                g.adler = se.check = zswap32(ye), ye = 0, Ee = 0, se.mode = W;
                            case W:
                                if (0 === se.havedict) return g.next_out = ve, g.avail_out = Ce, g.next_in = pe, g.avail_in = _e, se.hold = ye, se.bits = Ee, M;
                                g.adler = se.check = 1, se.mode = z;
                            case z:
                                if (re === A || re === R) break e;
                            case K:
                                if (se.last) {
                                    ye >>>= 7 & Ee, Ee -= 7 & Ee, se.mode = ue;
                                    break;
                                }
                                for(; Ee < 3;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                switch(se.last = 1 & ye, Ee -= 1, 3 & (ye >>>= 1)){
                                    case 0:
                                        se.mode = J;
                                        break;
                                    case 1:
                                        if (fixedtables(se), se.mode = te, re === R) {
                                            ye >>>= 2, Ee -= 2;
                                            break e;
                                        }
                                        break;
                                    case 2:
                                        se.mode = X;
                                        break;
                                    case 3:
                                        g.msg = "invalid block type", se.mode = fe;
                                }
                                ye >>>= 2, Ee -= 2;
                                break;
                            case J:
                                for(ye >>>= 7 & Ee, Ee -= 7 & Ee; Ee < 32;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if ((65535 & ye) != (ye >>> 16 ^ 65535)) {
                                    g.msg = "invalid stored block lengths", se.mode = fe;
                                    break;
                                }
                                if (se.length = 65535 & ye, ye = 0, Ee = 0, se.mode = Y, re === R) break e;
                            case Y:
                                se.mode = Q;
                            case Q:
                                if (be = se.length) {
                                    if (be > _e && (be = _e), be > Ce && (be = Ce), 0 === be) break e;
                                    f.arraySet(ge, oe, pe, be, ve), _e -= be, pe += be, Ce -= be, ve += be, se.length -= be;
                                    break;
                                }
                                se.mode = z;
                                break;
                            case X:
                                for(; Ee < 14;){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if (se.nlen = 257 + (31 & ye), ye >>>= 5, Ee -= 5, se.ndist = 1 + (31 & ye), ye >>>= 5, Ee -= 5, se.ncode = 4 + (15 & ye), ye >>>= 4, Ee -= 4, se.nlen > 286 || se.ndist > 30) {
                                    g.msg = "too many length or distance symbols", se.mode = fe;
                                    break;
                                }
                                se.have = 0, se.mode = Z;
                            case Z:
                                for(; se.have < se.ncode;){
                                    for(; Ee < 3;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    se.lens[Be[se.have++]] = 7 & ye, ye >>>= 3, Ee -= 3;
                                }
                                for(; se.have < 19;)se.lens[Be[se.have++]] = 0;
                                if (se.lencode = se.lendyn, se.lenbits = 7, Fe = {
                                    bits: se.lenbits
                                }, Le = C(E, se.lens, 0, 19, se.lencode, 0, se.work, Fe), se.lenbits = Fe.bits, Le) {
                                    g.msg = "invalid code lengths set", se.mode = fe;
                                    break;
                                }
                                se.have = 0, se.mode = ee;
                            case ee:
                                for(; se.have < se.nlen + se.ndist;){
                                    for(; we = (Ue = se.lencode[ye & (1 << se.lenbits) - 1]) >>> 16 & 255, Me = 65535 & Ue, !((Pe = Ue >>> 24) <= Ee);){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    if (Me < 16) ye >>>= Pe, Ee -= Pe, se.lens[se.have++] = Me;
                                    else {
                                        if (16 === Me) {
                                            for(xe = Pe + 2; Ee < xe;){
                                                if (0 === _e) break e;
                                                _e--, ye += oe[pe++] << Ee, Ee += 8;
                                            }
                                            if (ye >>>= Pe, Ee -= Pe, 0 === se.have) {
                                                g.msg = "invalid bit length repeat", se.mode = fe;
                                                break;
                                            }
                                            ke = se.lens[se.have - 1], be = 3 + (3 & ye), ye >>>= 2, Ee -= 2;
                                        } else if (17 === Me) {
                                            for(xe = Pe + 3; Ee < xe;){
                                                if (0 === _e) break e;
                                                _e--, ye += oe[pe++] << Ee, Ee += 8;
                                            }
                                            Ee -= Pe, ke = 0, be = 3 + (7 & (ye >>>= Pe)), ye >>>= 3, Ee -= 3;
                                        } else {
                                            for(xe = Pe + 7; Ee < xe;){
                                                if (0 === _e) break e;
                                                _e--, ye += oe[pe++] << Ee, Ee += 8;
                                            }
                                            Ee -= Pe, ke = 0, be = 11 + (127 & (ye >>>= Pe)), ye >>>= 7, Ee -= 7;
                                        }
                                        if (se.have + be > se.nlen + se.ndist) {
                                            g.msg = "invalid bit length repeat", se.mode = fe;
                                            break;
                                        }
                                        for(; be--;)se.lens[se.have++] = ke;
                                    }
                                }
                                if (se.mode === fe) break;
                                if (0 === se.lens[256]) {
                                    g.msg = "invalid code -- missing end-of-block", se.mode = fe;
                                    break;
                                }
                                if (se.lenbits = 9, Fe = {
                                    bits: se.lenbits
                                }, Le = C(T, se.lens, 0, se.nlen, se.lencode, 0, se.work, Fe), se.lenbits = Fe.bits, Le) {
                                    g.msg = "invalid literal/lengths set", se.mode = fe;
                                    break;
                                }
                                if (se.distbits = 6, se.distcode = se.distdyn, Fe = {
                                    bits: se.distbits
                                }, Le = C(I, se.lens, se.nlen, se.ndist, se.distcode, 0, se.work, Fe), se.distbits = Fe.bits, Le) {
                                    g.msg = "invalid distances set", se.mode = fe;
                                    break;
                                }
                                if (se.mode = te, re === R) break e;
                            case te:
                                se.mode = ie;
                            case ie:
                                if (_e >= 6 && Ce >= 258) {
                                    g.next_out = ve, g.avail_out = Ce, g.next_in = pe, g.avail_in = _e, se.hold = ye, se.bits = Ee, _(g, Ie), ve = g.next_out, ge = g.output, Ce = g.avail_out, pe = g.next_in, oe = g.input, _e = g.avail_in, ye = se.hold, Ee = se.bits, se.mode === z && (se.back = -1);
                                    break;
                                }
                                for(se.back = 0; we = (Ue = se.lencode[ye & (1 << se.lenbits) - 1]) >>> 16 & 255, Me = 65535 & Ue, !((Pe = Ue >>> 24) <= Ee);){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if (we && 0 == (240 & we)) {
                                    for(Oe = Pe, De = we, Ne = Me; we = (Ue = se.lencode[Ne + ((ye & (1 << Oe + De) - 1) >> Oe)]) >>> 16 & 255, Me = 65535 & Ue, !(Oe + (Pe = Ue >>> 24) <= Ee);){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    ye >>>= Oe, Ee -= Oe, se.back += Oe;
                                }
                                if (ye >>>= Pe, Ee -= Pe, se.back += Pe, se.length = Me, 0 === we) {
                                    se.mode = de;
                                    break;
                                }
                                if (32 & we) {
                                    se.back = -1, se.mode = z;
                                    break;
                                }
                                if (64 & we) {
                                    g.msg = "invalid literal/length code", se.mode = fe;
                                    break;
                                }
                                se.extra = 15 & we, se.mode = ne;
                            case ne:
                                if (se.extra) {
                                    for(xe = se.extra; Ee < xe;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    se.length += ye & (1 << se.extra) - 1, ye >>>= se.extra, Ee -= se.extra, se.back += se.extra;
                                }
                                se.was = se.length, se.mode = ae;
                            case ae:
                                for(; we = (Ue = se.distcode[ye & (1 << se.distbits) - 1]) >>> 16 & 255, Me = 65535 & Ue, !((Pe = Ue >>> 24) <= Ee);){
                                    if (0 === _e) break e;
                                    _e--, ye += oe[pe++] << Ee, Ee += 8;
                                }
                                if (0 == (240 & we)) {
                                    for(Oe = Pe, De = we, Ne = Me; we = (Ue = se.distcode[Ne + ((ye & (1 << Oe + De) - 1) >> Oe)]) >>> 16 & 255, Me = 65535 & Ue, !(Oe + (Pe = Ue >>> 24) <= Ee);){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    ye >>>= Oe, Ee -= Oe, se.back += Oe;
                                }
                                if (ye >>>= Pe, Ee -= Pe, se.back += Pe, 64 & we) {
                                    g.msg = "invalid distance code", se.mode = fe;
                                    break;
                                }
                                se.offset = Me, se.extra = 15 & we, se.mode = le;
                            case le:
                                if (se.extra) {
                                    for(xe = se.extra; Ee < xe;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    se.offset += ye & (1 << se.extra) - 1, ye >>>= se.extra, Ee -= se.extra, se.back += se.extra;
                                }
                                if (se.offset > se.dmax) {
                                    g.msg = "invalid distance too far back", se.mode = fe;
                                    break;
                                }
                                se.mode = ce;
                            case ce:
                                if (0 === Ce) break e;
                                if (be = Ie - Ce, se.offset > be) {
                                    if ((be = se.offset - be) > se.whave && se.sane) {
                                        g.msg = "invalid distance too far back", se.mode = fe;
                                        break;
                                    }
                                    be > se.wnext ? (be -= se.wnext, Ae = se.wsize - be) : Ae = se.wnext - be, be > se.length && (be = se.length), Re = se.window;
                                } else Re = ge, Ae = ve - se.offset, be = se.length;
                                be > Ce && (be = Ce), Ce -= be, se.length -= be;
                                do ge[ve++] = Re[Ae++];
                                while (--be);
                                0 === se.length && (se.mode = ie);
                                break;
                            case de:
                                if (0 === Ce) break e;
                                ge[ve++] = se.length, Ce--, se.mode = ie;
                                break;
                            case ue:
                                if (se.wrap) {
                                    for(; Ee < 32;){
                                        if (0 === _e) break e;
                                        _e--, ye |= oe[pe++] << Ee, Ee += 8;
                                    }
                                    if (Ie -= Ce, g.total_out += Ie, se.total += Ie, Ie && (g.adler = se.check = se.flags ? v(se.check, ge, Ie, ve - Ie) : S(se.check, ge, Ie, ve - Ie)), Ie = Ce, (se.flags ? ye : zswap32(ye)) !== se.check) {
                                        g.msg = "incorrect data check", se.mode = fe;
                                        break;
                                    }
                                    ye = 0, Ee = 0;
                                }
                                se.mode = he;
                            case he:
                                if (se.wrap && se.flags) {
                                    for(; Ee < 32;){
                                        if (0 === _e) break e;
                                        _e--, ye += oe[pe++] << Ee, Ee += 8;
                                    }
                                    if (ye !== (4294967295 & se.total)) {
                                        g.msg = "incorrect length check", se.mode = fe;
                                        break;
                                    }
                                    ye = 0, Ee = 0;
                                }
                                se.mode = me;
                            case me:
                                Le = w;
                                break e;
                            case fe:
                                Le = D;
                                break e;
                            case Se:
                                return N;
                            default:
                                return O;
                        }
                        return g.next_out = ve, g.avail_out = Ce, g.next_in = pe, g.avail_in = _e, se.hold = ye, se.bits = Ee, (se.wsize || Ie !== g.avail_out && se.mode < fe && (se.mode < ue || re !== b)) && updatewindow(g, g.output, g.next_out, Ie - g.avail_out), Te -= g.avail_in, Ie -= g.avail_out, g.total_in += Te, g.total_out += Ie, se.total += Ie, se.wrap && Ie && (g.adler = se.check = se.flags ? v(se.check, ge, Ie, g.next_out - Ie) : S(se.check, ge, Ie, g.next_out - Ie)), g.data_type = se.bits + (se.last ? 64 : 0) + (se.mode === z ? 128 : 0) + (se.mode === te || se.mode === Y ? 256 : 0), (0 === Te && 0 === Ie || re === b) && Le === P && (Le = k), Le;
                    }
                    function inflateEnd(g) {
                        if (!g || !g.state) return O;
                        var f = g.state;
                        return f.window && (f.window = null), g.state = null, P;
                    }
                    function inflateGetHeader(g, f) {
                        var S;
                        return g && g.state ? 0 == (2 & (S = g.state).wrap) ? O : (S.head = f, f.done = !1, P) : O;
                    }
                    function inflateSetDictionary(g, f) {
                        var v, _ = f.length;
                        return g && g.state ? 0 !== (v = g.state).wrap && v.mode !== W ? O : v.mode === W && S(1, f, _, 0) !== v.check ? D : updatewindow(g, f, _, _) ? (v.mode = Se, N) : (v.havedict = 1, P) : O;
                    }
                    g.inflateReset = inflateReset, g.inflateReset2 = inflateReset2, g.inflateResetKeep = inflateResetKeep, g.inflateInit = inflateInit, g.inflateInit2 = inflateInit2, g.inflate = inflate3, g.inflateEnd = inflateEnd, g.inflateGetHeader = inflateGetHeader, g.inflateSetDictionary = inflateSetDictionary, g.inflateInfo = "pako inflate (from Nodeca project)";
                }
            }), fe = __commonJS({
                "../node_modules/pako/lib/zlib/constants.js" (g, f) {
                    f.exports = {
                        Z_NO_FLUSH: 0,
                        Z_PARTIAL_FLUSH: 1,
                        Z_SYNC_FLUSH: 2,
                        Z_FULL_FLUSH: 3,
                        Z_FINISH: 4,
                        Z_BLOCK: 5,
                        Z_TREES: 6,
                        Z_OK: 0,
                        Z_STREAM_END: 1,
                        Z_NEED_DICT: 2,
                        Z_ERRNO: -1,
                        Z_STREAM_ERROR: -2,
                        Z_DATA_ERROR: -3,
                        Z_BUF_ERROR: -5,
                        Z_NO_COMPRESSION: 0,
                        Z_BEST_SPEED: 1,
                        Z_BEST_COMPRESSION: 9,
                        Z_DEFAULT_COMPRESSION: -1,
                        Z_FILTERED: 1,
                        Z_HUFFMAN_ONLY: 2,
                        Z_RLE: 3,
                        Z_FIXED: 4,
                        Z_DEFAULT_STRATEGY: 0,
                        Z_BINARY: 0,
                        Z_TEXT: 1,
                        Z_UNKNOWN: 2,
                        Z_DEFLATED: 8
                    };
                }
            }), Se = __commonJS({
                "../node_modules/pako/lib/zlib/gzheader.js" (g, f) {
                    function GZheader() {
                        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                    }
                    f.exports = GZheader;
                }
            }), ve = __commonJS({
                "../node_modules/pako/lib/inflate.js" (g) {
                    var f = me(), S = re(), v = de(), _ = fe(), C = le(), E = ue(), T = Se(), I = Object.prototype.toString;
                    function Inflate(g) {
                        if (!(this instanceof Inflate)) return new Inflate(g);
                        this.options = S.assign({
                            chunkSize: 16384,
                            windowBits: 0,
                            to: ""
                        }, g || {});
                        var b = this.options;
                        b.raw && b.windowBits >= 0 && b.windowBits < 16 && (b.windowBits = -b.windowBits, 0 === b.windowBits && (b.windowBits = -15)), !(b.windowBits >= 0 && b.windowBits < 16) || g && g.windowBits || (b.windowBits += 32), b.windowBits > 15 && b.windowBits < 48 && 0 == (15 & b.windowBits) && (b.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new E, this.strm.avail_out = 0;
                        var A = f.inflateInit2(this.strm, b.windowBits);
                        if (A !== _.Z_OK) throw new Error(C[A]);
                        if (this.header = new T, f.inflateGetHeader(this.strm, this.header), b.dictionary && ("string" == typeof b.dictionary ? b.dictionary = v.string2buf(b.dictionary) : "[object ArrayBuffer]" === I.call(b.dictionary) && (b.dictionary = new Uint8Array(b.dictionary)), b.raw && (A = f.inflateSetDictionary(this.strm, b.dictionary)) !== _.Z_OK)) throw new Error(C[A]);
                    }
                    function inflate3(g, f) {
                        var S = new Inflate(f);
                        if (S.push(g, !0), S.err) throw S.msg || C[S.err];
                        return S.result;
                    }
                    function inflateRaw(g, f) {
                        return (f = f || {}).raw = !0, inflate3(g, f);
                    }
                    Inflate.prototype.push = function(g, C) {
                        var E, T, b, A, R, P = this.strm, w = this.options.chunkSize, M = this.options.dictionary, O = !1;
                        if (this.ended) return !1;
                        T = C === ~~C ? C : !0 === C ? _.Z_FINISH : _.Z_NO_FLUSH, "string" == typeof g ? P.input = v.binstring2buf(g) : "[object ArrayBuffer]" === I.call(g) ? P.input = new Uint8Array(g) : P.input = g, P.next_in = 0, P.avail_in = P.input.length;
                        do {
                            if (0 === P.avail_out && (P.output = new S.Buf8(w), P.next_out = 0, P.avail_out = w), (E = f.inflate(P, _.Z_NO_FLUSH)) === _.Z_NEED_DICT && M && (E = f.inflateSetDictionary(this.strm, M)), E === _.Z_BUF_ERROR && !0 === O && (E = _.Z_OK, O = !1), E !== _.Z_STREAM_END && E !== _.Z_OK) return this.onEnd(E), this.ended = !0, !1;
                            P.next_out && (0 !== P.avail_out && E !== _.Z_STREAM_END && (0 !== P.avail_in || T !== _.Z_FINISH && T !== _.Z_SYNC_FLUSH) || ("string" === this.options.to ? (b = v.utf8border(P.output, P.next_out), A = P.next_out - b, R = v.buf2string(P.output, b), P.next_out = A, P.avail_out = w - A, A && S.arraySet(P.output, P.output, b, A, 0), this.onData(R)) : this.onData(S.shrinkBuf(P.output, P.next_out)))), 0 === P.avail_in && 0 === P.avail_out && (O = !0);
                        }while ((P.avail_in > 0 || 0 === P.avail_out) && E !== _.Z_STREAM_END);
                        return E === _.Z_STREAM_END && (T = _.Z_FINISH), T === _.Z_FINISH ? (E = f.inflateEnd(this.strm), this.onEnd(E), this.ended = !0, E === _.Z_OK) : T !== _.Z_SYNC_FLUSH || (this.onEnd(_.Z_OK), P.avail_out = 0, !0);
                    }, Inflate.prototype.onData = function(g) {
                        this.chunks.push(g);
                    }, Inflate.prototype.onEnd = function(g) {
                        g === _.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = S.flattenChunks(this.chunks)), this.chunks = [], this.err = g, this.msg = this.strm.msg;
                    }, g.Inflate = Inflate, g.inflate = inflate3, g.inflateRaw = inflateRaw, g.ungzip = inflate3;
                }
            }), _e = __commonJS({
                "../node_modules/pako/index.js" (g, f) {
                    var S = {};
                    (0, re().assign)(S, he(), ve(), fe()), f.exports = S;
                }
            }), Ce = __commonJS({
                "../signaling-agent/node_modules/sdp-transform/lib/grammar.js" (g, f) {
                    var S = f.exports = {
                        v: [
                            {
                                name: "version",
                                reg: /^(\d*)$/
                            }
                        ],
                        o: [
                            {
                                name: "origin",
                                reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
                                names: [
                                    "username",
                                    "sessionId",
                                    "sessionVersion",
                                    "netType",
                                    "ipVer",
                                    "address"
                                ],
                                format: "%s %s %d %s IP%d %s"
                            }
                        ],
                        s: [
                            {
                                name: "name"
                            }
                        ],
                        i: [
                            {
                                name: "description"
                            }
                        ],
                        u: [
                            {
                                name: "uri"
                            }
                        ],
                        e: [
                            {
                                name: "email"
                            }
                        ],
                        p: [
                            {
                                name: "phone"
                            }
                        ],
                        z: [
                            {
                                name: "timezones"
                            }
                        ],
                        r: [
                            {
                                name: "repeats"
                            }
                        ],
                        t: [
                            {
                                name: "timing",
                                reg: /^(\d*) (\d*)/,
                                names: [
                                    "start",
                                    "stop"
                                ],
                                format: "%d %d"
                            }
                        ],
                        c: [
                            {
                                name: "connection",
                                reg: /^IN IP(\d) (\S*)/,
                                names: [
                                    "version",
                                    "ip"
                                ],
                                format: "IN IP%d %s"
                            }
                        ],
                        b: [
                            {
                                push: "bandwidth",
                                reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
                                names: [
                                    "type",
                                    "limit"
                                ],
                                format: "%s:%s"
                            }
                        ],
                        m: [
                            {
                                reg: /^(\S*) (\d*) ([\w/]*)(?: (.*))?/,
                                names: [
                                    "type",
                                    "port",
                                    "protocol",
                                    "payloads"
                                ],
                                format: "%s %d %s %s"
                            }
                        ],
                        a: [
                            {
                                push: "rtp",
                                reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
                                names: [
                                    "payload",
                                    "codec",
                                    "rate",
                                    "encoding"
                                ],
                                format: function(g) {
                                    return g.encoding ? "rtpmap:%d %s/%s/%s" : g.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
                                }
                            },
                            {
                                push: "fmtp",
                                reg: /^fmtp:(\d*) ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "config"
                                ],
                                format: "fmtp:%d %s"
                            },
                            {
                                name: "control",
                                reg: /^control:(.*)/,
                                format: "control:%s"
                            },
                            {
                                name: "rtcp",
                                reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
                                names: [
                                    "port",
                                    "netType",
                                    "ipVer",
                                    "address"
                                ],
                                format: function(g) {
                                    return null != g.address ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
                                }
                            },
                            {
                                push: "rtcpFbXMessage",
                                reg: /^rtcp-fb:(\*|\d*) x-message ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "param"
                                ],
                                format: function(g) {
                                    return "rtcp-fb:" + ("*" === g.payload ? "%s" : "%d") + " x-message %s";
                                }
                            },
                            {
                                push: "rtcpFbTrrInt",
                                reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
                                names: [
                                    "payload",
                                    "value"
                                ],
                                format: "rtcp-fb:%d trr-int %d"
                            },
                            {
                                push: "rtcpFb",
                                reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
                                names: [
                                    "payload",
                                    "type",
                                    "subtype"
                                ],
                                format: function(g) {
                                    return null != g.subtype ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
                                }
                            },
                            {
                                push: "ext",
                                reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
                                names: [
                                    "value",
                                    "direction",
                                    "encrypt-uri",
                                    "uri",
                                    "config"
                                ],
                                format: function(g) {
                                    return "extmap:%d" + (g.direction ? "/%s" : "%v") + (g["encrypt-uri"] ? " %s" : "%v") + " %s" + (g.config ? " %s" : "");
                                }
                            },
                            {
                                name: "extmapAllowMixed",
                                reg: /^(extmap-allow-mixed)/
                            },
                            {
                                push: "cryptoscale",
                                reg: /^cryptoscale:(\d*) (client|server) ([\w_]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "id",
                                    "flavor",
                                    "suite",
                                    "config",
                                    "sessionConfig"
                                ],
                                format: function(g) {
                                    return null != g.sessionConfig ? "cryptoscale:%d %s %s %s %s" : "cryptoscale:%d %s %s %s";
                                }
                            },
                            {
                                push: "crypto",
                                reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "id",
                                    "suite",
                                    "config",
                                    "sessionConfig"
                                ],
                                format: function(g) {
                                    return null != g.sessionConfig ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
                                }
                            },
                            {
                                name: "setup",
                                reg: /^setup:(\w*)/,
                                format: "setup:%s"
                            },
                            {
                                name: "connectionType",
                                reg: /^connection:(new|existing)/,
                                format: "connection:%s"
                            },
                            {
                                name: "mid",
                                reg: /^mid:([^\s]*)/,
                                format: "mid:%s"
                            },
                            {
                                name: "msid",
                                reg: /^msid:(.*)/,
                                format: "msid:%s"
                            },
                            {
                                name: "ptime",
                                reg: /^ptime:(\d*(?:\.\d*)*)/,
                                format: "ptime:%d"
                            },
                            {
                                name: "maxptime",
                                reg: /^maxptime:(\d*(?:\.\d*)*)/,
                                format: "maxptime:%d"
                            },
                            {
                                name: "direction",
                                reg: /^(sendrecv|recvonly|sendonly|inactive)/
                            },
                            {
                                name: "icelite",
                                reg: /^(ice-lite)/
                            },
                            {
                                name: "iceUfrag",
                                reg: /^ice-ufrag:(\S*)/,
                                format: "ice-ufrag:%s"
                            },
                            {
                                name: "icePwd",
                                reg: /^ice-pwd:(\S*)/,
                                format: "ice-pwd:%s"
                            },
                            {
                                name: "fingerprint",
                                reg: /^fingerprint:(\S*) (\S*)/,
                                names: [
                                    "type",
                                    "hash"
                                ],
                                format: "fingerprint:%s %s"
                            },
                            {
                                push: "candidates",
                                reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
                                names: [
                                    "foundation",
                                    "component",
                                    "transport",
                                    "priority",
                                    "ip",
                                    "port",
                                    "type",
                                    "raddr",
                                    "rport",
                                    "tcptype",
                                    "generation",
                                    "network-id",
                                    "network-cost"
                                ],
                                format: function(g) {
                                    var f = "candidate:%s %d %s %d %s %d typ %s";
                                    return f += null != g.raddr ? " raddr %s rport %d" : "%v%v", f += null != g.tcptype ? " tcptype %s" : "%v", null != g.generation && (f += " generation %d"), f += null != g["network-id"] ? " network-id %d" : "%v", f += null != g["network-cost"] ? " network-cost %d" : "%v";
                                }
                            },
                            {
                                push: "xCandidatesIpv6",
                                reg: /^x-candidate-ipv6:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?/,
                                names: [
                                    "foundation",
                                    "component",
                                    "transport",
                                    "priority",
                                    "ip",
                                    "port",
                                    "type",
                                    "raddr",
                                    "rport",
                                    "tcptype",
                                    "generation"
                                ],
                                format: function(g) {
                                    var f = "candidate:%s %d %s %d %s %d typ %s";
                                    return f += null != g.raddr ? " raddr %s rport %d" : "%v%v", f += null != g.tcptype ? " tcptype %s" : "%v", null != g.generation && (f += " generation %d"), f;
                                }
                            },
                            {
                                name: "endOfCandidates",
                                reg: /^(end-of-candidates)/
                            },
                            {
                                name: "remoteCandidates",
                                reg: /^remote-candidates:(.*)/,
                                format: "remote-candidates:%s"
                            },
                            {
                                name: "iceOptions",
                                reg: /^ice-options:(\S*)/,
                                format: "ice-options:%s"
                            },
                            {
                                push: "ssrcs",
                                reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
                                names: [
                                    "id",
                                    "attribute",
                                    "value"
                                ],
                                format: function(g) {
                                    var f = "ssrc:%d";
                                    return null != g.attribute && (f += " %s", null != g.value && (f += ":%s")), f;
                                }
                            },
                            {
                                push: "ssrcGroups",
                                reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
                                names: [
                                    "semantics",
                                    "ssrcs"
                                ],
                                format: "ssrc-group:%s %s"
                            },
                            {
                                name: "msidSemantic",
                                reg: /^msid-semantic:\s?(\w*) (\S*)/,
                                names: [
                                    "semantic",
                                    "token"
                                ],
                                format: "msid-semantic: %s %s"
                            },
                            {
                                push: "groups",
                                reg: /^group:(\w*) (.*)/,
                                names: [
                                    "type",
                                    "mids"
                                ],
                                format: "group:%s %s"
                            },
                            {
                                name: "rtcpMux",
                                reg: /^(rtcp-mux)/
                            },
                            {
                                name: "rtcpRsize",
                                reg: /^(rtcp-rsize)/
                            },
                            {
                                name: "sctpmap",
                                reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "sctpmapNumber",
                                    "app",
                                    "maxMessageSize"
                                ],
                                format: function(g) {
                                    return null != g.maxMessageSize ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
                                }
                            },
                            {
                                name: "xGoogleFlag",
                                reg: /^x-google-flag:([^\s]*)/,
                                format: "x-google-flag:%s"
                            },
                            {
                                push: "rids",
                                reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
                                names: [
                                    "id",
                                    "direction",
                                    "params"
                                ],
                                format: function(g) {
                                    return g.params ? "rid:%s %s %s" : "rid:%s %s";
                                }
                            },
                            {
                                push: "imageattrs",
                                reg: new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
                                names: [
                                    "pt",
                                    "dir1",
                                    "attrs1",
                                    "dir2",
                                    "attrs2"
                                ],
                                format: function(g) {
                                    return "imageattr:%s %s %s" + (g.dir2 ? " %s %s" : "");
                                }
                            },
                            {
                                name: "simulcast",
                                reg: new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
                                names: [
                                    "dir1",
                                    "list1",
                                    "dir2",
                                    "list2"
                                ],
                                format: function(g) {
                                    return "simulcast:%s %s" + (g.dir2 ? " %s %s" : "");
                                }
                            },
                            {
                                name: "simulcast_03",
                                reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
                                names: [
                                    "value"
                                ],
                                format: "simulcast: %s"
                            },
                            {
                                name: "framerate",
                                reg: /^framerate:(\d+(?:$|\.\d+))/,
                                format: "framerate:%s"
                            },
                            {
                                name: "sourceFilter",
                                reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
                                names: [
                                    "filterMode",
                                    "netType",
                                    "addressTypes",
                                    "destAddress",
                                    "srcList"
                                ],
                                format: "source-filter: %s %s %s %s %s"
                            },
                            {
                                name: "bundleOnly",
                                reg: /^(bundle-only)/
                            },
                            {
                                name: "label",
                                reg: /^label:(.+)/,
                                format: "label:%s"
                            },
                            {
                                name: "sctpPort",
                                reg: /^sctp-port:(\d+)$/,
                                format: "sctp-port:%s"
                            },
                            {
                                name: "maxMessageSize",
                                reg: /^max-message-size:(\d+)$/,
                                format: "max-message-size:%s"
                            },
                            {
                                push: "tsRefClocks",
                                reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
                                names: [
                                    "clksrc",
                                    "clksrcExt"
                                ],
                                format: function(g) {
                                    return "ts-refclk:%s" + (null != g.clksrcExt ? "=%s" : "");
                                }
                            },
                            {
                                name: "mediaClk",
                                reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
                                names: [
                                    "id",
                                    "mediaClockName",
                                    "mediaClockValue",
                                    "rateNumerator",
                                    "rateDenominator"
                                ],
                                format: function(g) {
                                    var f = "mediaclk:";
                                    return f += null != g.id ? "id=%s %s" : "%v%s", f += null != g.mediaClockValue ? "=%s" : "", f += null != g.rateNumerator ? " rate=%s" : "", f += null != g.rateDenominator ? "/%s" : "";
                                }
                            },
                            {
                                name: "keywords",
                                reg: /^keywds:(.+)$/,
                                format: "keywds:%s"
                            },
                            {
                                name: "content",
                                reg: /^content:(.+)/,
                                format: "content:%s"
                            },
                            {
                                name: "bfcpFloorCtrl",
                                reg: /^floorctrl:(c-only|s-only|c-s)/,
                                format: "floorctrl:%s"
                            },
                            {
                                name: "bfcpConfId",
                                reg: /^confid:(\d+)/,
                                format: "confid:%s"
                            },
                            {
                                name: "bfcpUserId",
                                reg: /^userid:(\d+)/,
                                format: "userid:%s"
                            },
                            {
                                name: "bfcpFloorId",
                                reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
                                names: [
                                    "id",
                                    "mStream"
                                ],
                                format: "floorid:%s mstrm:%s"
                            },
                            {
                                name: "xMediaBw",
                                reg: /^x-mediabw:(\S*) send=(\d*);recv=(\d*)/,
                                names: [
                                    "label",
                                    "sendBw",
                                    "receiveBw"
                                ],
                                format: "x-mediabw:%s send=%d;recv=%d"
                            },
                            {
                                name: "xSsrcRange",
                                reg: /^x-ssrc-range:(\d*)-(\d*)/,
                                names: [
                                    "ssrcMin",
                                    "ssrcMax"
                                ],
                                format: "x-ssrc-range:%d-%d"
                            },
                            {
                                name: "xSource",
                                reg: /^x-source:(\S*)/,
                                format: "x-source:%s"
                            },
                            {
                                name: "xSourceStreamId",
                                reg: /^x-source-streamid:(\S*)/,
                                format: "x-source-streamid:%s"
                            },
                            {
                                name: "xCaps",
                                reg: /^x-caps:(\d*) (\S*)/,
                                names: [
                                    "payloadType",
                                    "value"
                                ],
                                format: "x-caps:%d %s"
                            },
                            {
                                name: "signalingFbXMessage",
                                reg: /^x-signaling-fb:(\*|\d*) x-message ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "param"
                                ],
                                format: function(g) {
                                    return "x-signaling-fb:" + ("*" === g.payload ? "%s" : "%d") + " x-message %s";
                                }
                            },
                            {
                                push: "xMediaSettings",
                                reg: /^x-mediasettings:([\S| ]*)/,
                                names: [
                                    "settings"
                                ],
                                format: "x-mediasettings:%s"
                            },
                            {
                                name: "xDataProtocol",
                                reg: /^x-data-protocol:\s?(.*)/,
                                format: "x-data-protocol:%s"
                            },
                            {
                                push: "invalid",
                                names: [
                                    "value"
                                ]
                            }
                        ]
                    };
                    Object.keys(S).forEach(function(g) {
                        S[g].forEach(function(g) {
                            g.reg || (g.reg = /(.*)/), g.format || (g.format = "%s");
                        });
                    });
                }
            }), ye = __commonJS({
                "../signaling-agent/node_modules/sdp-transform/lib/parser.js" (g) {
                    var toIntIfInt = function(g) {
                        return String(Number(g)) === g ? Number(g) : g;
                    }, attachProperties = function(g, f, S, v) {
                        if (v && !S) f[v] = toIntIfInt(g[1]);
                        else for(var _ = 0; _ < S.length; _ += 1)null != g[_ + 1] && (f[S[_]] = toIntIfInt(g[_ + 1]));
                    }, parseReg = function(g, f, S) {
                        var v = g.name && g.names;
                        g.push && !f[g.push] ? f[g.push] = [] : v && !f[g.name] && (f[g.name] = {});
                        var _ = g.push ? {} : v ? f[g.name] : f;
                        attachProperties(S.match(g.reg), _, g.names, g.name), g.push && f[g.push].push(_);
                    }, f = Ce(), S = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
                    g.parse = function(g) {
                        var v = {}, _ = [], C = v;
                        return g.split(/(\r\n|\r|\n)/).filter(S).forEach(function(g) {
                            var S = g[0], v = g.slice(2);
                            "m" === S && (_.push({
                                rtp: [],
                                fmtp: []
                            }), C = _[_.length - 1]);
                            for(var E = 0; E < (f[S] || []).length; E += 1){
                                var T = f[S][E];
                                if (T.reg.test(v)) return parseReg(T, C, v);
                            }
                        }), v.media = _, v;
                    };
                    var paramReducer = function(g, f) {
                        var S = f.split(/=(.+)/, 2);
                        return 2 === S.length ? g[S[0]] = toIntIfInt(S[1]) : 1 === S.length && f.length > 1 && (g[S[0]] = void 0), g;
                    };
                    g.parseParams = function(g) {
                        return g.split(/;\s?/).reduce(paramReducer, {});
                    }, g.parseFmtpConfig = g.parseParams, g.parsePayloads = function(g) {
                        return g.toString().split(" ").map(Number);
                    }, g.parseRemoteCandidates = function(g) {
                        for(var f = [], S = g.split(" ").map(toIntIfInt), v = 0; v < S.length; v += 3)f.push({
                            component: S[v],
                            ip: S[v + 1],
                            port: S[v + 2]
                        });
                        return f;
                    }, g.parseImageAttributes = function(g) {
                        return g.split(" ").map(function(g) {
                            return g.substring(1, g.length - 1).split(",").reduce(paramReducer, {});
                        });
                    }, g.parseSimulcastStreamList = function(g) {
                        return g.split(";").map(function(g) {
                            return g.split(",").map(function(g) {
                                var f, S = !1;
                                return "~" !== g[0] ? f = toIntIfInt(g) : (f = toIntIfInt(g.substring(1, g.length)), S = !0), {
                                    scid: f,
                                    paused: S
                                };
                            });
                        });
                    };
                }
            }), Ee = __commonJS({
                "../signaling-agent/node_modules/sdp-transform/lib/writer.js" (g, f) {
                    var S = Ce(), v = /%[sdv%]/g, format = function(g) {
                        var f = 1, S = arguments, _ = S.length;
                        return g.replace(v, function(g) {
                            if (f >= _) return g;
                            var v = S[f];
                            switch(f += 1, g){
                                case "%%":
                                    return "%";
                                case "%s":
                                    return String(v);
                                case "%d":
                                    return Number(v);
                                case "%v":
                                    return "";
                            }
                        });
                    }, makeLine = function(g, f, S) {
                        var v = [
                            g + "=" + (f.format instanceof Function ? f.format(f.push ? S : S[f.name]) : f.format)
                        ];
                        if (f.names) for(var _ = 0; _ < f.names.length; _ += 1){
                            var C = f.names[_];
                            f.name ? v.push(S[f.name][C]) : v.push(S[f.names[_]]);
                        }
                        else v.push(S[f.name]);
                        return format.apply(null, v);
                    }, _ = [
                        "v",
                        "o",
                        "s",
                        "i",
                        "u",
                        "e",
                        "p",
                        "c",
                        "b",
                        "t",
                        "r",
                        "z",
                        "a"
                    ], C = [
                        "i",
                        "c",
                        "b",
                        "a"
                    ];
                    f.exports = function(g, f) {
                        f = f || {}, null == g.version && (g.version = 0), null == g.name && (g.name = " "), g.media.forEach(function(g) {
                            null == g.payloads && (g.payloads = "");
                        });
                        var v = f.outerOrder || _, E = f.innerOrder || C, T = [];
                        return v.forEach(function(f) {
                            S[f].forEach(function(S) {
                                S.name in g && null != g[S.name] ? T.push(makeLine(f, S, g)) : S.push in g && null != g[S.push] && g[S.push].forEach(function(g) {
                                    T.push(makeLine(f, S, g));
                                });
                            });
                        }), g.media.forEach(function(g) {
                            T.push(makeLine("m", S.m[0], g)), E.forEach(function(f) {
                                S[f].forEach(function(S) {
                                    S.name in g && null != g[S.name] ? T.push(makeLine(f, S, g)) : S.push in g && null != g[S.push] && g[S.push].forEach(function(g) {
                                        T.push(makeLine(f, S, g));
                                    });
                                });
                            });
                        }), T.join("\r\n") + "\r\n";
                    };
                }
            }), Te = __commonJS({
                "../signaling-agent/node_modules/sdp-transform/lib/index.js" (g) {
                    var f = ye(), S = Ee();
                    g.write = S, g.parse = f.parse, g.parseParams = f.parseParams, g.parseFmtpConfig = f.parseFmtpConfig, g.parsePayloads = f.parsePayloads, g.parseRemoteCandidates = f.parseRemoteCandidates, g.parseImageAttributes = f.parseImageAttributes, g.parseSimulcastStreamList = f.parseSimulcastStreamList;
                }
            }), Ie = __commonJS({
                "../skype-calling-utilities/dist/skype-calling-utilities.bundle.js" (g, f) {
                    var S, v;
                    S = g, v = (g, f)=>{
                        var S = {}, v = {
                            exports: S
                        }, _ = Object.defineProperty, C = Object.getOwnPropertyDescriptor, E = Object.getOwnPropertyNames, T = Object.prototype.hasOwnProperty, __copyProps2 = (g, f, S, v)=>{
                            if (f && "object" == typeof f || "function" == typeof f) for (let I of E(f))T.call(g, I) || I === S || _(g, I, {
                                get: ()=>f[I],
                                enumerable: !(v = C(f, I)) || v.enumerable
                            });
                            return g;
                        }, __toCommonJS2 = (g)=>__copyProps2(_({}, "__esModule", {
                                value: !0
                            }), g), I = {};
                        ((g, f)=>{
                            for(var S in f)_(g, S, {
                                get: f[S],
                                enumerable: !0
                            });
                        })(I, {
                            SlimCoreElectronControlCapturer: ()=>B
                        }), v.exports = __toCommonJS2(I);
                        var b = P;
                        function stringifyObject2(g) {
                            if (!g) return `${g}`;
                            if (g instanceof Map) return mapToString2(g);
                            const f = g.toString();
                            return f.endsWith("[object Object]") ? JSON.stringify(g) : f;
                        }
                        function mapToString2(g) {
                            const f = {};
                            return g.forEach((g, S)=>{
                                f[S.toString()] = g;
                            }), JSON.stringify(f);
                        }
                        var A, R = class {
                            subscribe(g) {
                                return new w(this.subscriptions, g);
                            }
                            dispose(g) {
                                this.subscriptions = [];
                            }
                            raiseEvents(g) {
                                this.subscriptions.slice().forEach((f)=>{
                                    try {
                                        void 0 !== f.eventHandler && g(f.eventHandler);
                                    } catch (g) {
                                        var _this_eventLogger_warn, _this_eventLogger;
                                        (_this_eventLogger = this.eventLogger) === null || _this_eventLogger === void 0 ? void 0 : (_this_eventLogger_warn = _this_eventLogger.warn) === null || _this_eventLogger_warn === void 0 ? void 0 : _this_eventLogger_warn.call(_this_eventLogger, "Event handler exception caught!", stringifyObject2(g));
                                    }
                                });
                            }
                            constructor(g){
                                this.eventLogger = g, this.subscriptions = [];
                            }
                        }, w = class {
                            dispose() {
                                (0, b.remove)(this.subscriptions, (g)=>g === this), this.eventHandler = void 0;
                            }
                            constructor(g, f){
                                this.subscriptions = g, this.eventHandler = f, this.subscriptions.push(this);
                            }
                        }, M = class extends R {
                            changed(g, f) {
                                return this.subscribe({
                                    changed: {
                                        skipEventConfig: f,
                                        handler: g
                                    },
                                    on: void 0
                                });
                            }
                            on(g, f) {
                                return this.subscribe({
                                    changed: void 0,
                                    on: {
                                        name: String(g),
                                        handler: this._toEventCallback(f)
                                    }
                                });
                            }
                            once(g, f, S) {
                                let v;
                                const onceSubscription = (...g)=>{
                                    v.dispose(S), this._toEventCallback(f)(...g);
                                };
                                return v = this.on(g, this._fromEventCallback(onceSubscription)), v;
                            }
                            raiseChanged(g) {
                                this.raiseEvents((f)=>{
                                    if (!f.changed) return;
                                    const { skipEventConfig: S, handler: v } = f.changed;
                                    !this.getShouldSkipChangedEvent(g, S) && v();
                                });
                            }
                            event(g) {
                                return {
                                    raise: this._fromEventCallback((...f)=>this._raiseEventImpl(String(g), ...f))
                                };
                            }
                            _raiseEventImpl(g, ...f) {
                                this.raiseEvents((S)=>S.on && S.on.name === g && S.on.handler(...f));
                            }
                            _toEventCallback(g) {
                                return g;
                            }
                            _fromEventCallback(g) {
                                return g;
                            }
                            getShouldSkipChangedEvent(g, f) {
                                return (g === null || g === void 0 ? void 0 : g.skipDominantSpeakerUpdatesOnCall) ? !!(f === null || f === void 0 ? void 0 : f.skipDominantSpeakerUpdatesOnCall) : !!(g === null || g === void 0 ? void 0 : g.skipParticipantsUpdatesOnCall) && !!(f === null || f === void 0 ? void 0 : f.skipParticipantsUpdatesOnCall);
                            }
                            constructor(g){
                                super(g);
                            }
                        };
                        ((g)=>{
                            const f = 7, S = 3;
                            function encodeMouseEvent(g) {
                                if (!g) return new Uint8Array(0);
                                g.buttonType || (g.buttonType = 0), g.xPos || (g.xPos = 0), g.yPos || (g.yPos = 0), g.wheelRotation || (g.wheelRotation = 0);
                                const S = new ArrayBuffer(f), v = new DataView(S), _ = (3 & g.type) << 0, C = (7 & g.buttonType) << 2, E = (g.buttonDown ? 1 : 0) << 5, T = (g.wheelButtonDown ? 1 : 0) << 6, I = 0;
                                return v.setUint8(0, 1), v.setUint8(1, _ | C | E | T | I), v.setUint16(2, g.xPos, !0), v.setUint16(4, g.yPos, !0), v.setUint8(6, g.wheelRotation), new Uint8Array(S);
                            }
                            function encodeKeyboardEvent(g) {
                                const f = new ArrayBuffer(S), v = new DataView(f), _ = (3 & g.codeType) << 0, C = 0, E = (g.keyUp ? 1 : 0) << 4, T = (g.repeat ? 1 : 0) << 5, I = 0, b = 0;
                                return v.setUint8(0, 0), v.setUint8(1, _ | C | E | T | I | b), v.setUint8(2, g.code), new Uint8Array(f);
                            }
                            function decodeEventType(g) {
                                return g[0];
                            }
                            function decodeMouseEvent(g) {
                                if (1 !== g[0] || g.length !== f) return null;
                                const S = new DataView(g.buffer), v = S.getUint8(1);
                                return {
                                    type: 3 & v,
                                    buttonType: v >> 2 & 7,
                                    buttonDown: !!(v >> 5 & 1),
                                    wheelButtonDown: !!(v >> 6 & 1),
                                    xPos: S.getUint16(2, !0),
                                    yPos: S.getUint16(4, !0),
                                    wheelRotation: S.getUint8(6)
                                };
                            }
                            function decodeKeyboardEvent(g) {
                                if (0 !== g[0] || g.length !== S) return null;
                                const f = new DataView(g.buffer), v = f.getUint8(1);
                                return {
                                    codeType: 3 & v,
                                    code: f.getUint8(2),
                                    repeat: !!(v >> 5 & 1),
                                    keyUp: !!(v >> 4 & 1)
                                };
                            }
                            g.encodeMouseEvent = encodeMouseEvent, g.encodeKeyboardEvent = encodeKeyboardEvent, g.decodeEventType = decodeEventType, g.decodeMouseEvent = decodeMouseEvent, g.decodeKeyboardEvent = decodeKeyboardEvent;
                        })(A || (A = {}));
                        var O = 65535, D = 3e3, N = 250, k = 18, L = 17, F = 16, x = 91, U = 50, V = 30, B = class extends M {
                            get captureMode() {
                                return this._captureMode;
                            }
                            get captureRegion() {
                                return this._captureRegion;
                            }
                            setMouseMoveThrottlingFeatureFlag(g) {
                                this._mouseMoveThrottlingEnabled = g;
                            }
                            dispose(g) {
                                var _this__element_ownerDocument_defaultView, _this__element_ownerDocument;
                                this._logger.info(`dispose causeId: ${g}`), window.clearTimeout(this._pollTimerID), (_this__element_ownerDocument = this._element.ownerDocument) === null || _this__element_ownerDocument === void 0 ? void 0 : (_this__element_ownerDocument_defaultView = _this__element_ownerDocument.defaultView) === null || _this__element_ownerDocument_defaultView === void 0 ? void 0 : _this__element_ownerDocument_defaultView.removeEventListener("resize", this._handleResizeEvents, !1), super.dispose(g);
                            }
                            updateVideoSize(g, f) {
                                this._videoSize.width = g, this._videoSize.height = f, this.updateCaptureRegion();
                            }
                            updateCaptureRegion() {
                                this._captureRegionPreserveAspectRatio ? (this._captureRegion.width = this._element.clientWidth, this._captureRegion.height = this._element.clientWidth * this._videoSize.height / this._videoSize.width, this._captureRegion.height > this._element.clientHeight ? (this._captureRegion.width = this._element.clientHeight * this._videoSize.width / this._videoSize.height, this._captureRegion.height = this._element.clientHeight, this._captureRegion.left = (this._element.clientWidth - this._captureRegion.width) / 2, this._captureRegion.top = 0) : (this._captureRegion.left = 0, this._captureRegion.top = (this._element.clientHeight - this._captureRegion.height) / 2)) : (this._captureRegion.width = this._element.clientWidth, this._captureRegion.height = this._element.clientHeight, this._captureRegion.top = 0, this._captureRegion.left = 0);
                            }
                            setCaptureMode(g) {
                                3 === this._captureMode && 3 !== g && this._syncKeyStates(!0), this._captureMode = g, 0 !== g ? ("none" === this._element.style.pointerEvents && this._logger.warn("Element pointer-events is 'none', event handlers will not work"), this._element.addEventListener("click", this._handleClick), this._element.addEventListener("pointermove", this._handleMouseMove), this._element.addEventListener("pointerdown", this._handleMouseDown), this._element.addEventListener("pointerup", this._handleMouseUp), this._element.addEventListener("pointerenter", this._handleMouseEnter), this._element.addEventListener("pointerleave", this._handleMouseLeave), 3 === g ? (this._element.addEventListener("wheel", this._handleWheel), this._element.addEventListener("keydown", this._handleKeyDown), this._element.addEventListener("keyup", this._handleKeyUp), this._element.addEventListener("contextmenu", this._handleContextMenu), this._element.addEventListener("blur", this._handleLosingFocus)) : (this._element.removeEventListener("wheel", this._handleWheel), this._element.removeEventListener("keydown", this._handleKeyDown), this._element.removeEventListener("keyup", this._handleKeyUp), this._element.removeEventListener("contextmenu", this._handleContextMenu), this._element.removeEventListener("blur", this._handleLosingFocus))) : (this._element.removeEventListener("pointermove", this._handleMouseMove), this._element.removeEventListener("pointerdown", this._handleMouseDown), this._element.removeEventListener("pointerup", this._handleMouseUp), this._element.removeEventListener("pointerenter", this._handleMouseEnter), this._element.removeEventListener("pointerleave", this._handleMouseLeave), this._element.removeEventListener("click", this._handleClick), this._element.removeEventListener("wheel", this._handleWheel), this._element.removeEventListener("keydown", this._handleKeyDown), this._element.removeEventListener("keyup", this._handleKeyUp), this._element.removeEventListener("contextmenu", this._handleContextMenu), this._element.removeEventListener("blur", this._handleLosingFocus));
                            }
                            _ensureCanReceiveKeyboardInput() {
                                this._element.tabIndex = this._element.tabIndex;
                            }
                            _checkElementSize() {
                                this._origElementSize.width === this._element.clientWidth && this._origElementSize.height === this._element.clientHeight || (this.updateCaptureRegion(), this._origElementSize.width = this._element.clientWidth, this._origElementSize.height = this._element.clientHeight), this._pollTimerID = window.setTimeout(()=>{
                                    this._checkElementSize();
                                }, D);
                            }
                            _raiseMouseEvent(g) {
                                this.event("mouseControlEvent").raise(g);
                            }
                            _raiseKeyboardEvent(g) {
                                this.event("keyboardControlEvent").raise(g);
                            }
                            _raiseCaptureEvent(g) {
                                this.event("ctrlCaptureEvent").raise(g);
                            }
                            _normalizeMousePosition(g, f) {
                                f.xPos = (g.offsetX - this._captureRegion.left) / this._captureRegion.width * O, f.yPos = (g.offsetY - this._captureRegion.top) / this._captureRegion.height * O;
                            }
                            _isOnScreenContent(g) {
                                const f = this._captureRegion.left, S = this._captureRegion.left + this._captureRegion.width, v = this._captureRegion.top, _ = this._captureRegion.top + this._captureRegion.height;
                                return f <= g.offsetX && g.offsetX < S && v <= g.offsetY && g.offsetY < _;
                            }
                            _shouldMoveMouse() {
                                if (this._mouseMoveStartTime) {
                                    const g = (new Date).getTime(), f = g - this._mouseMoveStartTime;
                                    if (this._isMouseDown && f >= V || !this._isMouseDown && f >= U) return this._mouseMoveStartTime = g, !0;
                                } else this._mouseMoveStartTime = (new Date).getTime();
                                return !1;
                            }
                            _syncKeyStates(g) {
                                this._raiseKeyboardEvent({
                                    codeType: 1,
                                    code: L,
                                    repeat: !1,
                                    keyUp: g
                                }), this._raiseKeyboardEvent({
                                    codeType: 1,
                                    code: F,
                                    repeat: !1,
                                    keyUp: g
                                }), this._raiseKeyboardEvent({
                                    codeType: 1,
                                    code: k,
                                    repeat: !1,
                                    keyUp: g
                                }), this._raiseKeyboardEvent({
                                    codeType: 1,
                                    code: x,
                                    repeat: !1,
                                    keyUp: g
                                }), this._logger.info("Synced Key states.");
                            }
                            static formatMouseEvent(g) {
                                return A.encodeMouseEvent(g);
                            }
                            static formatKeyboardEvent(g) {
                                return A.encodeKeyboardEvent(g);
                            }
                            constructor(g, f, S = !0, v = 1){
                                var _this__element_ownerDocument_defaultView, _this__element_ownerDocument;
                                super(), this._logger = g, this._element = f, this._captureRegionPreserveAspectRatio = S, this._mouseMoveCount = 0, this._mouseMoveStartTime = 0, this._isMouseDown = !1, this._isMouseOnRenderer = !1, this._captureMode = 0, this._pollTimerID = 0, this._resizeTimerID = 0, this._mouseMoveThrottlingEnabled = !1, this._handleResizeEvents = ()=>{
                                    clearTimeout(this._resizeTimerID), this._resizeTimerID = window.setTimeout(()=>{
                                        this.updateCaptureRegion();
                                    }, N);
                                }, this._handleMouseLeave = (g)=>{
                                    !this._isOnScreenContent(g) && this._isMouseOnRenderer && (this._raiseCaptureEvent(2), this._logger.info("Mouse leaving render region")), this._isMouseOnRenderer = !1;
                                }, this._handleMouseEnter = (g)=>{
                                    this._isOnScreenContent(g) && (this._isMouseOnRenderer = !0, this._raiseCaptureEvent(1), this._logger.info("Mouse entering render region"));
                                }, this._handleLosingFocus = ()=>{
                                    this._syncKeyStates(!0);
                                }, this._handleClick = (g)=>{
                                    this._isOnScreenContent(g) && (this._raiseCaptureEvent(0), this._logger.info("Mouse clicked"));
                                }, this._handleMouseMove = (g)=>{
                                    if (!this._isOnScreenContent(g) && this._isMouseOnRenderer) return this._raiseCaptureEvent(2), this._isMouseOnRenderer = !1, void this._logger.info("Mouse leaving render region");
                                    if (this._isOnScreenContent(g) && !this._isMouseOnRenderer && (this._raiseCaptureEvent(1), this._isMouseOnRenderer = !0, this._logger.info("Mouse entering render region")), 2 !== this._captureMode && 3 !== this._captureMode) return;
                                    if (this._mouseMoveCount++, this._mouseMoveThrottlingEnabled) {
                                        if (!this._isOnScreenContent(g) || !this._shouldMoveMouse()) return;
                                    } else if (!this._isOnScreenContent(g) || this._mouseMoveCount % 2 == 0) return;
                                    const f = {
                                        type: 0
                                    };
                                    this._normalizeMousePosition(g, f), this._raiseMouseEvent(f);
                                }, this._handleMouseDown = (g)=>{
                                    if (2 !== this._captureMode && 3 !== this._captureMode) return;
                                    if (!this._isOnScreenContent(g)) return;
                                    const f = {
                                        type: 2,
                                        buttonType: convertButton(g.button),
                                        buttonDown: !0
                                    };
                                    this._isMouseDown = !0, this._normalizeMousePosition(g, f), this._raiseMouseEvent(f);
                                }, this._handleMouseUp = (g)=>{
                                    if (2 !== this._captureMode && 3 !== this._captureMode) return;
                                    if (!this._isOnScreenContent(g)) return;
                                    const f = {
                                        type: 2,
                                        buttonType: convertButton(g.button),
                                        buttonDown: !1
                                    };
                                    this._isMouseDown = !1, this._normalizeMousePosition(g, f), this._raiseMouseEvent(f);
                                }, this._handleKeyDown = (g)=>{
                                    this._raiseKeyboardEvent({
                                        codeType: 1,
                                        code: g.keyCode,
                                        repeat: g.repeat,
                                        keyUp: !1
                                    }), g.stopPropagation(), g.preventDefault();
                                }, this._handleKeyUp = (g)=>{
                                    this._raiseKeyboardEvent({
                                        codeType: 1,
                                        code: g.keyCode,
                                        repeat: g.repeat,
                                        keyUp: !0
                                    }), g.stopPropagation(), g.preventDefault();
                                }, this._handleWheel = (g)=>{
                                    this._raiseMouseEvent({
                                        type: 1,
                                        wheelRotation: g.deltaY > 0 ? -120 : 120
                                    });
                                }, this._handleContextMenu = (g)=>{
                                    g.preventDefault();
                                }, this._ensureCanReceiveKeyboardInput(), (_this__element_ownerDocument = this._element.ownerDocument) === null || _this__element_ownerDocument === void 0 ? void 0 : (_this__element_ownerDocument_defaultView = _this__element_ownerDocument.defaultView) === null || _this__element_ownerDocument_defaultView === void 0 ? void 0 : _this__element_ownerDocument_defaultView.addEventListener("resize", this._handleResizeEvents, !1), this._captureRegion = {
                                    left: 0,
                                    top: 0,
                                    width: this._element.clientWidth,
                                    height: this._element.clientHeight
                                }, this._videoSize = {
                                    width: Math.floor(f.clientHeight * v),
                                    height: f.clientHeight
                                }, this._origElementSize = {
                                    width: 0,
                                    height: 0
                                }, this._checkElementSize(), this._mouseMoveStartTime = new Date(0).getTime();
                            }
                        };
                        function convertButton(g) {
                            switch(g){
                                case 0:
                                    return 0;
                                case 2:
                                    return 1;
                                case 1:
                                    return 2;
                                default:
                                    return;
                            }
                        }
                        if ("object" == typeof v.exports && "object" == typeof S) {
                            var __cp = (g, f, S, v)=>{
                                if (f && "object" == typeof f || "function" == typeof f) for (let _ of Object.getOwnPropertyNames(f))Object.prototype.hasOwnProperty.call(g, _) || _ === S || Object.defineProperty(g, _, {
                                    get: ()=>f[_],
                                    enumerable: !(v = Object.getOwnPropertyDescriptor(f, _)) || v.enumerable
                                });
                                return g;
                            };
                            v.exports = __cp(v.exports, S);
                        }
                        return v.exports;
                    }, "object" == typeof g && "object" == typeof f ? f.exports = v(R, P) : "object" == typeof g ? g["skype-calling-utilities"] = v(R, P) : S["skype-calling-utilities"] = v(S["@skype/rt-js-bindings"], S.lodash);
                }
            }), be = __commonJS({
                "../node_modules/synctasks/dist/SyncTasks.js" (g) {
                    function fromThenable(g) {
                        var f = Defer();
                        return g.then(function(g) {
                            f.resolve(g);
                        }, function(g) {
                            f.reject(g);
                        }), f.promise().thenAsync(function(g) {
                            return g;
                        });
                    }
                    function isThenable(g) {
                        return null != g && "function" == typeof g.then;
                    }
                    function isCancelable(g) {
                        return null != g && "function" == typeof g.cancel;
                    }
                    function run(f, S) {
                        if (!g.config.catchExceptions) return f();
                        try {
                            return f();
                        } catch (g) {
                            return S(g);
                        }
                    }
                    Object.defineProperty(g, "__esModule", {
                        value: !0
                    }), g.config = {
                        exceptionsToConsole: !0,
                        catchExceptions: !0,
                        traceEnabled: !1,
                        exceptionHandler: void 0,
                        unhandledErrorHandler: function(g) {
                            throw g;
                        }
                    }, g.fromThenable = fromThenable;
                    var f, S, v, _ = [], C = "undefined" != typeof setImmediate;
                    function asyncCallback(g) {
                        _.push(g), 1 === _.length && (C ? setImmediate(resolveAsyncCallbacks) : setTimeout(resolveAsyncCallbacks, 0));
                    }
                    function resolveAsyncCallbacks() {
                        var g = _;
                        _ = [];
                        for(var f = 0; f < g.length; f++)g[f]();
                    }
                    function all(g) {
                        if (0 === g.length) return Resolved2([]);
                        var S, v = Defer(), _ = g.length, C = Array(g.length);
                        v.onCancel(function(S) {
                            g.forEach(function(g) {
                                isCancelable(g) && f.SyncTask.cancelOtherInternal(g, S);
                            });
                        });
                        var checkFinish = function() {
                            0 == --_ && (void 0 !== S ? v.reject(S) : v.resolve(C));
                        };
                        return g.forEach(function(g, f) {
                            isThenable(g) ? g.then(function(g) {
                                C[f] = g, checkFinish();
                            }, function(g) {
                                void 0 === S && (S = void 0 === g || g), checkFinish();
                            }) : (C[f] = g, checkFinish());
                        }), v.promise();
                    }
                    function Defer() {
                        return new f.SyncTask;
                    }
                    function Resolved2(g) {
                        return (new f.SyncTask).resolve(g).promise();
                    }
                    function Rejected(g) {
                        return (new f.SyncTask).reject(g).promise();
                    }
                    function race(g) {
                        var S = Defer(), v = !1;
                        return S.onCancel(function(S) {
                            g.forEach(function(g) {
                                isCancelable(g) && f.SyncTask.cancelOtherInternal(g, S);
                            });
                        }), g.forEach(function(g) {
                            isThenable(g) ? g.then(function(g) {
                                v || (v = !0, S.resolve(g));
                            }, function(g) {
                                v || (v = !0, S.reject(g));
                            }) : v || (v = !0, S.resolve(g));
                        }), S.promise();
                    }
                    function raceTimer(g, f) {
                        var S = Defer(), v = setTimeout(function() {
                            S.resolve({
                                timedOut: !0
                            });
                        }, f);
                        return race([
                            g.then(function(g) {
                                return clearTimeout(v), {
                                    timedOut: !1,
                                    result: g
                                };
                            }),
                            S.promise()
                        ]);
                    }
                    g.asyncCallback = asyncCallback, S = f || (f = {}), v = function() {
                        function SyncTask2() {
                            this._completedSuccess = !1, this._completedFail = !1, this._traceEnabled = !1, this._cancelCallbacks = [], this._wasCanceled = !1, this._wasExplicitlyCanceled = !1, this._resolving = !1, this._storedCallbackSets = [], this._mustHandleError = !0;
                        }
                        return SyncTask2.prototype._addCallbackSet = function(g, f) {
                            var S = this, v = new SyncTask2;
                            return v.onCancel(function(f) {
                                g.wasCanceled = !0, g.cancelContext = f, S._cancelInternal(f);
                            }), g.task = v, this._storedCallbackSets.push(g), f ? this._mustHandleError = !1 : v._mustHandleError = !1, this._resolving || (this._completedSuccess ? this._resolveSuccesses() : this._completedFail && this._resolveFailures()), v.promise();
                        }, SyncTask2.prototype.onCancel = function(g) {
                            return this._completedSuccess || this._completedFail || (this._wasCanceled ? g(this._cancelContext) : this._cancelCallbacks.push(g)), this;
                        }, SyncTask2.prototype.then = function(g, f) {
                            return this._addCallbackSet({
                                successFunc: g,
                                failFunc: f
                            }, !0);
                        }, SyncTask2.prototype.thenAsync = function(g, f) {
                            return this._addCallbackSet({
                                successFunc: g,
                                failFunc: f,
                                asyncCallback: !0
                            }, !0);
                        }, SyncTask2.prototype.catch = function(g) {
                            return this._addCallbackSet({
                                failFunc: g
                            }, !0);
                        }, SyncTask2.prototype.always = function(g) {
                            return this._addCallbackSet({
                                successFunc: g,
                                failFunc: g
                            }, !0);
                        }, SyncTask2.prototype.setTracingEnabled = function(g) {
                            return this._traceEnabled = g, this;
                        }, SyncTask2.prototype.finally = function(g) {
                            return this._addCallbackSet({
                                successFunc: g,
                                failFunc: g
                            }, !1), this;
                        }, SyncTask2.prototype.done = function(g) {
                            return this._addCallbackSet({
                                successFunc: g
                            }, !1), this;
                        }, SyncTask2.prototype.fail = function(g) {
                            return this._addCallbackSet({
                                failFunc: g
                            }, !1), this;
                        }, SyncTask2.prototype.resolve = function(g) {
                            return this._checkState(!0), this._completedSuccess = !0, this._storedResolution = g, this._cancelCallbacks = [], this._resolveSuccesses(), this;
                        }, SyncTask2.prototype.reject = function(g) {
                            return this._checkState(!1), this._completedFail = !0, this._storedErrResolution = g, this._cancelCallbacks = [], this._resolveFailures(), SyncTask2._enforceErrorHandled(this), this;
                        }, SyncTask2.prototype._checkState = function(f) {
                            if (this._completedSuccess || this._completedFail) {
                                this._completeStack && console.error(this._completeStack.message, this._completeStack.stack);
                                var S = "Failed to " + (f ? "resolve" : "reject") + ": the task is already " + (this._completedSuccess ? "resolved" : "rejected");
                                throw new Error(S);
                            }
                            (g.config.traceEnabled || this._traceEnabled) && (this._completeStack = new Error("resolve"));
                        }, SyncTask2._enforceErrorHandled = function(f) {
                            f._mustHandleError && (SyncTask2._rejectedTasks.push(f), SyncTask2._enforceErrorHandledTimer || (SyncTask2._enforceErrorHandledTimer = setTimeout(function() {
                                SyncTask2._enforceErrorHandledTimer = void 0;
                                var f = SyncTask2._rejectedTasks;
                                SyncTask2._rejectedTasks = [], f.forEach(function(f, S) {
                                    f._mustHandleError && g.config.unhandledErrorHandler(f._storedErrResolution);
                                });
                            }, 0)));
                        }, SyncTask2.prototype.cancel = function(g) {
                            if (this._wasExplicitlyCanceled) throw new Error("Already Canceled");
                            this._wasExplicitlyCanceled = !0, this._cancelInternal(g);
                        }, SyncTask2.prototype._cancelInternal = function(g) {
                            var f = this;
                            if (!this._wasCanceled) {
                                this._wasCanceled = !0, this._cancelContext = g;
                                var S = this._cancelCallbacks;
                                this._cancelCallbacks = [], S.length > 0 && S.forEach(function(g) {
                                    f._completedSuccess || f._completedFail || g(f._cancelContext);
                                });
                            }
                        }, SyncTask2.cancelOtherInternal = function(g, f) {
                            var S = g;
                            S._storedCallbackSets && S._cancelInternal ? S._cancelInternal(f) : g.cancel(f);
                        }, SyncTask2.prototype.promise = function() {
                            return this;
                        }, SyncTask2.prototype._resolveSuccesses = function() {
                            var g = this;
                            for(this._resolving = !0; this._storedCallbackSets.length;){
                                var f = this._storedCallbackSets;
                                this._storedCallbackSets = [], f.forEach(function(f) {
                                    f.asyncCallback ? asyncCallback(function() {
                                        return g._resolveSuccessCallback(f);
                                    }) : g._resolveSuccessCallback(f);
                                });
                            }
                            this._resolving = !1;
                        }, SyncTask2.prototype._resolveSuccessCallback = function(g) {
                            var f = this;
                            g.successFunc ? run(function() {
                                var S = g.successFunc(f._storedResolution);
                                isCancelable(S) && (g.wasCanceled ? SyncTask2.cancelOtherInternal(S, g.cancelContext) : g.task.onCancel(function(g) {
                                    return SyncTask2.cancelOtherInternal(S, g);
                                })), isThenable(S) ? S.then(function(f) {
                                    g.task.resolve(f);
                                }, function(f) {
                                    g.task.reject(f);
                                }) : g.task.resolve(S);
                            }, function(S) {
                                f._handleException(S, "SyncTask caught exception in success block: " + S.toString()), g.task.reject(S);
                            }) : g.task.resolve(this._storedResolution);
                        }, SyncTask2.prototype._resolveFailures = function() {
                            var g = this;
                            for(this._resolving = !0; this._storedCallbackSets.length;){
                                var f = this._storedCallbackSets;
                                this._storedCallbackSets = [], f.forEach(function(f) {
                                    f.asyncCallback ? asyncCallback(function() {
                                        return g._resolveFailureCallback(f);
                                    }) : g._resolveFailureCallback(f);
                                });
                            }
                            this._resolving = !1;
                        }, SyncTask2.prototype._resolveFailureCallback = function(g) {
                            var f = this;
                            g.failFunc ? run(function() {
                                var S = g.failFunc(f._storedErrResolution);
                                isCancelable(S) && (g.wasCanceled ? SyncTask2.cancelOtherInternal(S, g.cancelContext) : g.task.onCancel(function(g) {
                                    return SyncTask2.cancelOtherInternal(S, g);
                                })), isThenable(S) ? S.then(function(f) {
                                    g.task.resolve(f);
                                }, function(f) {
                                    g.task.reject(f);
                                }) : g.task.resolve(S);
                            }, function(S) {
                                f._handleException(S, "SyncTask caught exception in failure block: " + S.toString()), g.task.reject(S);
                            }) : g.task.reject(this._storedErrResolution);
                        }, SyncTask2.prototype._handleException = function(f, S) {
                            g.config.exceptionsToConsole && console.error(S), g.config.exceptionHandler && g.config.exceptionHandler(f);
                        }, SyncTask2.prototype.toEs6Promise = function() {
                            var g = this;
                            return new Promise(function(f, S) {
                                return g.then(f, S);
                            });
                        }, SyncTask2._rejectedTasks = [], SyncTask2;
                    }(), S.SyncTask = v, g.all = all, g.Defer = Defer, g.Resolved = Resolved2, g.Rejected = Rejected, g.race = race, g.raceTimer = raceTimer;
                }
            }), Ae = __commonJS({
                "../node_modules/sdp-transform/lib/grammar.js" (g, f) {
                    var S = f.exports = {
                        v: [
                            {
                                name: "version",
                                reg: /^(\d*)$/
                            }
                        ],
                        o: [
                            {
                                name: "origin",
                                reg: /^(\S*) (\d*) (\d*) (\S*) IP(\d) (\S*)/,
                                names: [
                                    "username",
                                    "sessionId",
                                    "sessionVersion",
                                    "netType",
                                    "ipVer",
                                    "address"
                                ],
                                format: "%s %s %d %s IP%d %s"
                            }
                        ],
                        s: [
                            {
                                name: "name"
                            }
                        ],
                        i: [
                            {
                                name: "description"
                            }
                        ],
                        u: [
                            {
                                name: "uri"
                            }
                        ],
                        e: [
                            {
                                name: "email"
                            }
                        ],
                        p: [
                            {
                                name: "phone"
                            }
                        ],
                        z: [
                            {
                                name: "timezones"
                            }
                        ],
                        r: [
                            {
                                name: "repeats"
                            }
                        ],
                        t: [
                            {
                                name: "timing",
                                reg: /^(\d*) (\d*)/,
                                names: [
                                    "start",
                                    "stop"
                                ],
                                format: "%d %d"
                            }
                        ],
                        c: [
                            {
                                name: "connection",
                                reg: /^IN IP(\d) (\S*)/,
                                names: [
                                    "version",
                                    "ip"
                                ],
                                format: "IN IP%d %s"
                            }
                        ],
                        b: [
                            {
                                push: "bandwidth",
                                reg: /^(TIAS|AS|CT|RR|RS):(\d*)/,
                                names: [
                                    "type",
                                    "limit"
                                ],
                                format: "%s:%s"
                            }
                        ],
                        m: [
                            {
                                reg: /^(\S*) (\d*) ([\w/]*)(?: (.*))?/,
                                names: [
                                    "type",
                                    "port",
                                    "protocol",
                                    "payloads"
                                ],
                                format: "%s %d %s %s"
                            }
                        ],
                        a: [
                            {
                                push: "rtp",
                                reg: /^rtpmap:(\d*) ([\w\-.]*)(?:\s*\/(\d*)(?:\s*\/(\S*))?)?/,
                                names: [
                                    "payload",
                                    "codec",
                                    "rate",
                                    "encoding"
                                ],
                                format: function(g) {
                                    return g.encoding ? "rtpmap:%d %s/%s/%s" : g.rate ? "rtpmap:%d %s/%s" : "rtpmap:%d %s";
                                }
                            },
                            {
                                push: "fmtp",
                                reg: /^fmtp:(\d*) ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "config"
                                ],
                                format: "fmtp:%d %s"
                            },
                            {
                                name: "control",
                                reg: /^control:(.*)/,
                                format: "control:%s"
                            },
                            {
                                name: "rtcp",
                                reg: /^rtcp:(\d*)(?: (\S*) IP(\d) (\S*))?/,
                                names: [
                                    "port",
                                    "netType",
                                    "ipVer",
                                    "address"
                                ],
                                format: function(g) {
                                    return null != g.address ? "rtcp:%d %s IP%d %s" : "rtcp:%d";
                                }
                            },
                            {
                                push: "rtcpFbXMessage",
                                reg: /^rtcp-fb:(\*|\d*) x-message ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "param"
                                ],
                                format: function(g) {
                                    return "rtcp-fb:" + ("*" === g.payload ? "%s" : "%d") + " x-message %s";
                                }
                            },
                            {
                                push: "rtcpFbTrrInt",
                                reg: /^rtcp-fb:(\*|\d*) trr-int (\d*)/,
                                names: [
                                    "payload",
                                    "value"
                                ],
                                format: "rtcp-fb:%d trr-int %d"
                            },
                            {
                                push: "rtcpFb",
                                reg: /^rtcp-fb:(\*|\d*) ([\w-_]*)(?: ([\w-_]*))?/,
                                names: [
                                    "payload",
                                    "type",
                                    "subtype"
                                ],
                                format: function(g) {
                                    return null != g.subtype ? "rtcp-fb:%s %s %s" : "rtcp-fb:%s %s";
                                }
                            },
                            {
                                push: "ext",
                                reg: /^extmap:(\d+)(?:\/(\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\S*)(?: (\S*))?/,
                                names: [
                                    "value",
                                    "direction",
                                    "encrypt-uri",
                                    "uri",
                                    "config"
                                ],
                                format: function(g) {
                                    return "extmap:%d" + (g.direction ? "/%s" : "%v") + (g["encrypt-uri"] ? " %s" : "%v") + " %s" + (g.config ? " %s" : "");
                                }
                            },
                            {
                                name: "extmapAllowMixed",
                                reg: /^(extmap-allow-mixed)/
                            },
                            {
                                push: "cryptoscale",
                                reg: /^cryptoscale:(\d*) (client|server) ([\w_]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "id",
                                    "flavor",
                                    "suite",
                                    "config",
                                    "sessionConfig"
                                ],
                                format: function(g) {
                                    return null != g.sessionConfig ? "cryptoscale:%d %s %s %s %s" : "cryptoscale:%d %s %s %s";
                                }
                            },
                            {
                                push: "crypto",
                                reg: /^crypto:(\d*) ([\w_]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "id",
                                    "suite",
                                    "config",
                                    "sessionConfig"
                                ],
                                format: function(g) {
                                    return null != g.sessionConfig ? "crypto:%d %s %s %s" : "crypto:%d %s %s";
                                }
                            },
                            {
                                name: "setup",
                                reg: /^setup:(\w*)/,
                                format: "setup:%s"
                            },
                            {
                                name: "connectionType",
                                reg: /^connection:(new|existing)/,
                                format: "connection:%s"
                            },
                            {
                                name: "mid",
                                reg: /^mid:([^\s]*)/,
                                format: "mid:%s"
                            },
                            {
                                name: "msid",
                                reg: /^msid:(.*)/,
                                format: "msid:%s"
                            },
                            {
                                name: "ptime",
                                reg: /^ptime:(\d*(?:\.\d*)*)/,
                                format: "ptime:%d"
                            },
                            {
                                name: "maxptime",
                                reg: /^maxptime:(\d*(?:\.\d*)*)/,
                                format: "maxptime:%d"
                            },
                            {
                                name: "direction",
                                reg: /^(sendrecv|recvonly|sendonly|inactive)/
                            },
                            {
                                name: "icelite",
                                reg: /^(ice-lite)/
                            },
                            {
                                name: "iceUfrag",
                                reg: /^ice-ufrag:(\S*)/,
                                format: "ice-ufrag:%s"
                            },
                            {
                                name: "icePwd",
                                reg: /^ice-pwd:(\S*)/,
                                format: "ice-pwd:%s"
                            },
                            {
                                name: "fingerprint",
                                reg: /^fingerprint:(\S*) (\S*)/,
                                names: [
                                    "type",
                                    "hash"
                                ],
                                format: "fingerprint:%s %s"
                            },
                            {
                                push: "candidates",
                                reg: /^candidate:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?(?: network-id (\d*))?(?: network-cost (\d*))?/,
                                names: [
                                    "foundation",
                                    "component",
                                    "transport",
                                    "priority",
                                    "ip",
                                    "port",
                                    "type",
                                    "raddr",
                                    "rport",
                                    "tcptype",
                                    "generation",
                                    "network-id",
                                    "network-cost"
                                ],
                                format: function(g) {
                                    var f = "candidate:%s %d %s %d %s %d typ %s";
                                    return f += null != g.raddr ? " raddr %s rport %d" : "%v%v", f += null != g.tcptype ? " tcptype %s" : "%v", null != g.generation && (f += " generation %d"), f += null != g["network-id"] ? " network-id %d" : "%v", f += null != g["network-cost"] ? " network-cost %d" : "%v";
                                }
                            },
                            {
                                push: "xCandidatesIpv6",
                                reg: /^x-candidate-ipv6:(\S*) (\d*) (\S*) (\d*) (\S*) (\d*) typ (\S*)(?: raddr (\S*) rport (\d*))?(?: tcptype (\S*))?(?: generation (\d*))?/,
                                names: [
                                    "foundation",
                                    "component",
                                    "transport",
                                    "priority",
                                    "ip",
                                    "port",
                                    "type",
                                    "raddr",
                                    "rport",
                                    "tcptype",
                                    "generation"
                                ],
                                format: function(g) {
                                    var f = "candidate:%s %d %s %d %s %d typ %s";
                                    return f += null != g.raddr ? " raddr %s rport %d" : "%v%v", f += null != g.tcptype ? " tcptype %s" : "%v", null != g.generation && (f += " generation %d"), f;
                                }
                            },
                            {
                                name: "endOfCandidates",
                                reg: /^(end-of-candidates)/
                            },
                            {
                                name: "remoteCandidates",
                                reg: /^remote-candidates:(.*)/,
                                format: "remote-candidates:%s"
                            },
                            {
                                name: "iceOptions",
                                reg: /^ice-options:(\S*)/,
                                format: "ice-options:%s"
                            },
                            {
                                push: "ssrcs",
                                reg: /^ssrc:(\d*) ([\w_-]*)(?::(.*))?/,
                                names: [
                                    "id",
                                    "attribute",
                                    "value"
                                ],
                                format: function(g) {
                                    var f = "ssrc:%d";
                                    return null != g.attribute && (f += " %s", null != g.value && (f += ":%s")), f;
                                }
                            },
                            {
                                push: "ssrcGroups",
                                reg: /^ssrc-group:([\x21\x23\x24\x25\x26\x27\x2A\x2B\x2D\x2E\w]*) (.*)/,
                                names: [
                                    "semantics",
                                    "ssrcs"
                                ],
                                format: "ssrc-group:%s %s"
                            },
                            {
                                name: "msidSemantic",
                                reg: /^msid-semantic:\s?(\w*) (\S*)/,
                                names: [
                                    "semantic",
                                    "token"
                                ],
                                format: "msid-semantic: %s %s"
                            },
                            {
                                push: "groups",
                                reg: /^group:(\w*) (.*)/,
                                names: [
                                    "type",
                                    "mids"
                                ],
                                format: "group:%s %s"
                            },
                            {
                                name: "rtcpMux",
                                reg: /^(rtcp-mux)/
                            },
                            {
                                name: "rtcpRsize",
                                reg: /^(rtcp-rsize)/
                            },
                            {
                                name: "sctpmap",
                                reg: /^sctpmap:([\w_/]*) (\S*)(?: (\S*))?/,
                                names: [
                                    "sctpmapNumber",
                                    "app",
                                    "maxMessageSize"
                                ],
                                format: function(g) {
                                    return null != g.maxMessageSize ? "sctpmap:%s %s %s" : "sctpmap:%s %s";
                                }
                            },
                            {
                                name: "xGoogleFlag",
                                reg: /^x-google-flag:([^\s]*)/,
                                format: "x-google-flag:%s"
                            },
                            {
                                push: "rids",
                                reg: /^rid:([\d\w]+) (\w+)(?: ([\S| ]*))?/,
                                names: [
                                    "id",
                                    "direction",
                                    "params"
                                ],
                                format: function(g) {
                                    return g.params ? "rid:%s %s %s" : "rid:%s %s";
                                }
                            },
                            {
                                push: "imageattrs",
                                reg: new RegExp("^imageattr:(\\d+|\\*)[\\s\\t]+(send|recv)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*)(?:[\\s\\t]+(recv|send)[\\s\\t]+(\\*|\\[\\S+\\](?:[\\s\\t]+\\[\\S+\\])*))?"),
                                names: [
                                    "pt",
                                    "dir1",
                                    "attrs1",
                                    "dir2",
                                    "attrs2"
                                ],
                                format: function(g) {
                                    return "imageattr:%s %s %s" + (g.dir2 ? " %s %s" : "");
                                }
                            },
                            {
                                name: "simulcast",
                                reg: new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\-_~;,]+)(?:\\s?(send|recv) ([a-zA-Z0-9\\-_~;,]+))?$"),
                                names: [
                                    "dir1",
                                    "list1",
                                    "dir2",
                                    "list2"
                                ],
                                format: function(g) {
                                    return "simulcast:%s %s" + (g.dir2 ? " %s %s" : "");
                                }
                            },
                            {
                                name: "simulcast_03",
                                reg: /^simulcast:[\s\t]+([\S+\s\t]+)$/,
                                names: [
                                    "value"
                                ],
                                format: "simulcast: %s"
                            },
                            {
                                name: "framerate",
                                reg: /^framerate:(\d+(?:$|\.\d+))/,
                                format: "framerate:%s"
                            },
                            {
                                name: "sourceFilter",
                                reg: /^source-filter: *(excl|incl) (\S*) (IP4|IP6|\*) (\S*) (.*)/,
                                names: [
                                    "filterMode",
                                    "netType",
                                    "addressTypes",
                                    "destAddress",
                                    "srcList"
                                ],
                                format: "source-filter: %s %s %s %s %s"
                            },
                            {
                                name: "bundleOnly",
                                reg: /^(bundle-only)/
                            },
                            {
                                name: "label",
                                reg: /^label:(.+)/,
                                format: "label:%s"
                            },
                            {
                                name: "sctpPort",
                                reg: /^sctp-port:(\d+)$/,
                                format: "sctp-port:%s"
                            },
                            {
                                name: "maxMessageSize",
                                reg: /^max-message-size:(\d+)$/,
                                format: "max-message-size:%s"
                            },
                            {
                                push: "tsRefClocks",
                                reg: /^ts-refclk:([^\s=]*)(?:=(\S*))?/,
                                names: [
                                    "clksrc",
                                    "clksrcExt"
                                ],
                                format: function(g) {
                                    return "ts-refclk:%s" + (null != g.clksrcExt ? "=%s" : "");
                                }
                            },
                            {
                                name: "mediaClk",
                                reg: /^mediaclk:(?:id=(\S*))? *([^\s=]*)(?:=(\S*))?(?: *rate=(\d+)\/(\d+))?/,
                                names: [
                                    "id",
                                    "mediaClockName",
                                    "mediaClockValue",
                                    "rateNumerator",
                                    "rateDenominator"
                                ],
                                format: function(g) {
                                    var f = "mediaclk:";
                                    return f += null != g.id ? "id=%s %s" : "%v%s", f += null != g.mediaClockValue ? "=%s" : "", f += null != g.rateNumerator ? " rate=%s" : "", f += null != g.rateDenominator ? "/%s" : "";
                                }
                            },
                            {
                                name: "keywords",
                                reg: /^keywds:(.+)$/,
                                format: "keywds:%s"
                            },
                            {
                                name: "content",
                                reg: /^content:(.+)/,
                                format: "content:%s"
                            },
                            {
                                name: "bfcpFloorCtrl",
                                reg: /^floorctrl:(c-only|s-only|c-s)/,
                                format: "floorctrl:%s"
                            },
                            {
                                name: "bfcpConfId",
                                reg: /^confid:(\d+)/,
                                format: "confid:%s"
                            },
                            {
                                name: "bfcpUserId",
                                reg: /^userid:(\d+)/,
                                format: "userid:%s"
                            },
                            {
                                name: "bfcpFloorId",
                                reg: /^floorid:(.+) (?:m-stream|mstrm):(.+)/,
                                names: [
                                    "id",
                                    "mStream"
                                ],
                                format: "floorid:%s mstrm:%s"
                            },
                            {
                                name: "xMediaBw",
                                reg: /^x-mediabw:(\S*) send=(\d*);recv=(\d*)/,
                                names: [
                                    "label",
                                    "sendBw",
                                    "receiveBw"
                                ],
                                format: "x-mediabw:%s send=%d;recv=%d"
                            },
                            {
                                name: "xSsrcRange",
                                reg: /^x-ssrc-range:(\d*)-(\d*)/,
                                names: [
                                    "ssrcMin",
                                    "ssrcMax"
                                ],
                                format: "x-ssrc-range:%d-%d"
                            },
                            {
                                name: "xSource",
                                reg: /^x-source:(\S*)/,
                                format: "x-source:%s"
                            },
                            {
                                name: "xSourceStreamId",
                                reg: /^x-source-streamid:(\S*)/,
                                format: "x-source-streamid:%s"
                            },
                            {
                                name: "xCaps",
                                reg: /^x-caps:(\d*) (\S*)/,
                                names: [
                                    "payloadType",
                                    "value"
                                ],
                                format: "x-caps:%d %s"
                            },
                            {
                                name: "signalingFbXMessage",
                                reg: /^x-signaling-fb:(\*|\d*) x-message ([\S| ]*)/,
                                names: [
                                    "payload",
                                    "param"
                                ],
                                format: function(g) {
                                    return "x-signaling-fb:" + ("*" === g.payload ? "%s" : "%d") + " x-message %s";
                                }
                            },
                            {
                                push: "xMediaSettings",
                                reg: /^x-mediasettings:([\S| ]*)/,
                                names: [
                                    "settings"
                                ],
                                format: "x-mediasettings:%s"
                            },
                            {
                                name: "xDataProtocol",
                                reg: /^x-data-protocol:\s?(.*)/,
                                format: "x-data-protocol:%s"
                            },
                            {
                                name: "xMultiStream",
                                reg: /^x-multi-stream:(\d*) (\d*) (\d*) (\d*)/,
                                names: [
                                    "numberOfStreams",
                                    "startSsrc",
                                    "ssrcRange",
                                    "ssrcGroupRange"
                                ],
                                format: "x-multi-stream:%d %d %d %d"
                            },
                            {
                                push: "invalid",
                                names: [
                                    "value"
                                ]
                            }
                        ]
                    };
                    Object.keys(S).forEach(function(g) {
                        S[g].forEach(function(g) {
                            g.reg || (g.reg = /(.*)/), g.format || (g.format = "%s");
                        });
                    });
                }
            }), Re = __commonJS({
                "../node_modules/sdp-transform/lib/parser.js" (g) {
                    var toIntIfInt = function(g) {
                        return String(Number(g)) === g ? Number(g) : g;
                    }, attachProperties = function(g, f, S, v) {
                        if (v && !S) f[v] = toIntIfInt(g[1]);
                        else for(var _ = 0; _ < S.length; _ += 1)null != g[_ + 1] && (f[S[_]] = toIntIfInt(g[_ + 1]));
                    }, parseReg = function(g, f, S) {
                        var v = g.name && g.names;
                        g.push && !f[g.push] ? f[g.push] = [] : v && !f[g.name] && (f[g.name] = {});
                        var _ = g.push ? {} : v ? f[g.name] : f;
                        attachProperties(S.match(g.reg), _, g.names, g.name), g.push && f[g.push].push(_);
                    }, f = Ae(), S = RegExp.prototype.test.bind(/^([a-z])=(.*)/);
                    g.parse = function(g) {
                        var v = {}, _ = [], C = v;
                        return g.split(/(\r\n|\r|\n)/).filter(S).forEach(function(g) {
                            var S = g[0], v = g.slice(2);
                            "m" === S && (_.push({
                                rtp: [],
                                fmtp: []
                            }), C = _[_.length - 1]);
                            for(var E = 0; E < (f[S] || []).length; E += 1){
                                var T = f[S][E];
                                if (T.reg.test(v)) return parseReg(T, C, v);
                            }
                        }), v.media = _, v;
                    };
                    var paramReducer = function(g, f) {
                        var S = f.split(/=(.+)/, 2);
                        return 2 === S.length ? g[S[0]] = toIntIfInt(S[1]) : 1 === S.length && f.length > 1 && (g[S[0]] = void 0), g;
                    };
                    g.parseParams = function(g) {
                        return g.split(/;\s?/).reduce(paramReducer, {});
                    }, g.parseFmtpConfig = g.parseParams, g.parsePayloads = function(g) {
                        return g.toString().split(" ").map(Number);
                    }, g.parseRemoteCandidates = function(g) {
                        for(var f = [], S = g.split(" ").map(toIntIfInt), v = 0; v < S.length; v += 3)f.push({
                            component: S[v],
                            ip: S[v + 1],
                            port: S[v + 2]
                        });
                        return f;
                    }, g.parseImageAttributes = function(g) {
                        return g.split(" ").map(function(g) {
                            return g.substring(1, g.length - 1).split(",").reduce(paramReducer, {});
                        });
                    }, g.parseSimulcastStreamList = function(g) {
                        return g.split(";").map(function(g) {
                            return g.split(",").map(function(g) {
                                var f, S = !1;
                                return "~" !== g[0] ? f = toIntIfInt(g) : (f = toIntIfInt(g.substring(1, g.length)), S = !0), {
                                    scid: f,
                                    paused: S
                                };
                            });
                        });
                    };
                }
            }), Pe = __commonJS({
                "../node_modules/sdp-transform/lib/writer.js" (g, f) {
                    var S = Ae(), v = /%[sdv%]/g, format = function(g) {
                        var f = 1, S = arguments, _ = S.length;
                        return g.replace(v, function(g) {
                            if (f >= _) return g;
                            var v = S[f];
                            switch(f += 1, g){
                                case "%%":
                                    return "%";
                                case "%s":
                                    return String(v);
                                case "%d":
                                    return Number(v);
                                case "%v":
                                    return "";
                            }
                        });
                    }, makeLine = function(g, f, S) {
                        var v = [
                            g + "=" + (f.format instanceof Function ? f.format(f.push ? S : S[f.name]) : f.format)
                        ];
                        if (f.names) for(var _ = 0; _ < f.names.length; _ += 1){
                            var C = f.names[_];
                            f.name ? v.push(S[f.name][C]) : v.push(S[f.names[_]]);
                        }
                        else v.push(S[f.name]);
                        return format.apply(null, v);
                    }, _ = [
                        "v",
                        "o",
                        "s",
                        "i",
                        "u",
                        "e",
                        "p",
                        "c",
                        "b",
                        "t",
                        "r",
                        "z",
                        "a"
                    ], C = [
                        "i",
                        "c",
                        "b",
                        "a"
                    ];
                    f.exports = function(g, f) {
                        f = f || {}, null == g.version && (g.version = 0), null == g.name && (g.name = " "), g.media.forEach(function(g) {
                            null == g.payloads && (g.payloads = "");
                        });
                        var v = f.outerOrder || _, E = f.innerOrder || C, T = [];
                        return v.forEach(function(f) {
                            S[f].forEach(function(S) {
                                S.name in g && null != g[S.name] ? T.push(makeLine(f, S, g)) : S.push in g && null != g[S.push] && g[S.push].forEach(function(g) {
                                    T.push(makeLine(f, S, g));
                                });
                            });
                        }), g.media.forEach(function(g) {
                            T.push(makeLine("m", S.m[0], g)), E.forEach(function(f) {
                                S[f].forEach(function(S) {
                                    S.name in g && null != g[S.name] ? T.push(makeLine(f, S, g)) : S.push in g && null != g[S.push] && g[S.push].forEach(function(g) {
                                        T.push(makeLine(f, S, g));
                                    });
                                });
                            });
                        }), T.join("\r\n") + "\r\n";
                    };
                }
            }), we = __commonJS({
                "../node_modules/sdp-transform/lib/index.js" (g) {
                    var f = Re(), S = Pe();
                    g.write = S, g.parse = f.parse, g.parseParams = f.parseParams, g.parseFmtpConfig = f.parseFmtpConfig, g.parsePayloads = f.parsePayloads, g.parseRemoteCandidates = f.parseRemoteCandidates, g.parseImageAttributes = f.parseImageAttributes, g.parseSimulcastStreamList = f.parseSimulcastStreamList;
                }
            }), Me = {};
            __export(Me, {
                HttpRequestDispatcherImplementation: ()=>He,
                generateCauseId: ()=>generateCauseId,
                getOvb: ()=>getOvb,
                getVersion: ()=>getTsCallingVersion,
                pluginlessStackFactory: ()=>oM
            }), _.exports = __toCommonJS(Me);
            var Oe = __toESM(te()), De = 8;
            function generateCauseId() {
                const g = "abcdef0123456789", f = g.length;
                let S = "";
                for(let v = 0; v < De; v++)S += g.charAt(Math.floor(Math.random() * f));
                return S;
            }
            function validateCauseId(g) {
                return new RegExp("^[a-f0-9]{8}$").test(g) && g.length === De;
            }
            var Ne = R, ke = P, Le = class _TsCallingLogger {
                createChild(g) {
                    const f = (0, ke.isFunction)(g) ? g : ()=>g;
                    return new _TsCallingLogger(this.ulLogComponent, this.ulSafeComponent, ()=>this._getPrefix() ? `${this._getPrefix()}/${f()}` : f());
                }
                log(...g) {
                    this._apply((g)=>this.logComponent.debug2(null, g), g);
                }
                debug(...g) {
                    this._apply((g)=>this.logComponent.debug4(null, g), g);
                }
                info(...g) {
                    this._apply((g)=>this.logComponent.debug1(null, g), g);
                }
                warn(...g) {
                    this._apply((g)=>this.logComponent.warn(null, g), g);
                }
                error(...g) {
                    this._apply((g)=>this.logComponent.error(null, g), g);
                }
                _apply(g, f = []) {
                    this._addPrefix(f);
                    g(f.map((g)=>g instanceof DOMException ? g.toString() : g).map((g)=>(0, ke.isObject)(g) ? JSON.stringify(g) : g).join(", "));
                }
                _addPrefix(g) {
                    if (g && g[0]) {
                        const f = `${this._getPrefix()} ${g[0]}`;
                        g[0] = f;
                    }
                }
                constructor(g, f, S = ""){
                    this.ulLogComponent = g, this.ulSafeComponent = f, this._getPrefix = (0, ke.isFunction)(S) ? S : ()=>S, this.logComponent = Ne.LogFactory.instance().component(this.ulLogComponent), Ne.LogFactory.instance().declareComponentSafe(this.ulLogComponent, f);
                }
            }, Fe = R, xe = class {
                constructor(g, f){
                    this.value = g, this.piiKind = f;
                }
            }, Ue = [
                "id",
                " orgid",
                "username",
                "phonenumber"
            ];
            function scrubMriOrOmit(g) {
                return "string" == typeof g ? Fe.pii.Mri(g) : Fe.pii.Omit(g);
            }
            function scrubMriOrOmitList(g) {
                try {
                    return g.map(scrubMriOrOmit);
                } catch (g) {
                    return [];
                }
            }
            function scrubObjectFields(g, f = [
                "id"
            ], S = {
                threadId: 8
            }) {
                if (!g || "object" != typeof g) return g;
                try {
                    let v = createDeepCopy(g);
                    return v = scrubObjectData(v, f, S), v;
                } catch (g) {
                    return {
                        error: "failed to scrub object fields"
                    };
                }
            }
            function scrubMriKeys(g) {
                try {
                    const f = {};
                    return Object.keys(g).forEach((S)=>{
                        const v = scrubMriOrOmit(S);
                        f[v] = g[S];
                    }), f;
                } catch (g) {
                    return {
                        error: "failed to scrub mri keys"
                    };
                }
            }
            function getLoggableMriKeys(g) {
                return JSON.stringify(scrubMriKeys(g));
            }
            function mriOrId(g) {
                return g && Fe.pii.Mri(g);
            }
            function getLoggableThreadId(g) {
                const f = _scrubThreadId(g);
                return f && f.substr(0, 8);
            }
            function _scrubThreadId(g) {
                const f = "99:";
                return g && g.substr(0, 3) === f ? Fe.pii.Omit(g) : g;
            }
            function createDeepCopy(g) {
                if (!g || "object" != typeof g) return g;
                const f = new Set, S = JSON.stringify(g, (g, S)=>{
                    if ("object" == typeof S && null !== S) {
                        if (f.has(S)) return;
                        f.add(S);
                    }
                    return S;
                });
                return JSON.parse(S);
            }
            function scrubObjectData(g, f, S) {
                if (!g || "object" != typeof g) return g;
                const v = {
                    ...g
                };
                for (const [_, C] of Object.entries(g))Array.isArray(C) ? v[_] = C.map((g)=>scrubObjectData(g, f, S)) : "object" == typeof C ? v[_] = scrubObjectData(C, f, S) : "displayname" === _.toLowerCase() ? v[_] = "(redacted)" : C && (f.includes(_) || Ue.includes(_.toLowerCase()) ? v[_] = scrubMriOrOmit(C) : S[_] && "string" == typeof C && (v[_] = C.toString().substring(0, S[_])));
                return v;
            }
            function getMaskingRegex(g) {
                const f = String.raw`[\\]*['|\"]?\s*[\:|=]\s*[\\]*['|\"]?`, S = String.raw`[a-zA-Z\d#.~?!@$%^&*-_()+]+?`;
                return new RegExp(String.raw`(${g}${f})(${S})(\\?['\"])`, "g");
            }
            function replacement(g, f, S, v, _) {
                const C = scrubMriOrOmit(v);
                return String.raw`${f}${C}${_}`;
            }
            function maskUserIdentity(g) {
                if (!g) return null;
                const f = getMaskingRegex("([U|u]ser[N|n]ame|[O|o]rg[I|i]d)");
                return g.replace(f, replacement);
            }
            function maskSensitiveData(g, f = "(redacted)") {
                if (!g) return null;
                const S = getMaskingRegex("([P|p]assword|[T|t]oken|[S|s]ecret|[A|a]uthorization|[D|d]isplay[N|n]ame|[P|p]honeNumber|[A|a]ddress|IP)");
                return maskUserIdentity(g.replace(S, `$1${f}$4`));
            }
            var Ve = __toESM(P), Be = [
                "response",
                "responseText",
                "responseURL",
                "status",
                "state",
                "statusText",
                "timeout",
                "withCredentials",
                "stack",
                "message",
                "name",
                "error",
                "piiSafe",
                "phase",
                "code",
                "participantId",
                "phrase",
                "subCode",
                "reason",
                "conversationType"
            ];
            function getPIISafeObject(g) {
                try {
                    return JSON.parse(JSON.stringify(g, Be, 4));
                } catch (g) {
                    return {
                        error: "failed to parse object"
                    };
                }
            }
            var processStackTrace = (g)=>{
                try {
                    return g.split("\n")[0];
                } catch (g) {
                    return "invalid stack";
                }
            };
            function getPrintableObject(g, f = !1) {
                if (null == g) return "void";
                if (g instanceof Error) return g.toString();
                if (g instanceof String || g instanceof Number || g instanceof Boolean) return g.toString();
                try {
                    return g.stack && (g.stack = processStackTrace(g.stack)), (f ? JSON.stringify(g) : JSON.stringify(g, Be, 4)).replace(/(\r\n\t|\n|\r\t|\s)/gm, "");
                } catch (f) {
                    return `failed to get error information:${g && "function" == typeof g.toString && g.toString()} ${(g === null || g === void 0 ? void 0 : g.response) && JSON.stringify(g.response)}`;
                }
            }
            function safeJsonStringify(g) {
                try {
                    return JSON.stringify(g, null, 2);
                } catch (f) {
                    return `failed to stringify obj ${g}`;
                }
            }
            function truncate(g, f) {
                try {
                    return g.substring(0, f);
                } catch (f) {
                    return g;
                }
            }
            function hasValue(g) {
                return g || !1 === g || "" === g || 0 === g;
            }
            function getPIISafeCallInitOptions(g) {
                let f = {
                    mediaPeerType: g.mediaPeerType,
                    threadId: getLoggableThreadId(g.threadId)
                };
                return hasValue(g.messageId) && (f.messageId = g.messageId), hasValue(g.enableGroupCallMeetupGeneration) && (f.enableGroupCallMeetupGeneration = g.enableGroupCallMeetupGeneration), hasValue(g.endpointMetadata) && (f.endpointMetadata = g.endpointMetadata), hasValue(g.onBehalfOf) && (f.onBehalfOf = scrubMriOrOmit(g.onBehalfOf)), hasValue(g.onBehalfOfUserDisplayName) && (f.onBehalfOfUserDisplayName = g.onBehalfOfUserDisplayName), hasValue(g.emergencyContent) && (f.emergencyContent = g.emergencyContent), hasValue(g.isEmergency) && (f.isEmergency = g.isEmergency), hasValue(g.broadcastContext) && (f.broadcastContext = g.broadcastContext), g.meetingInfo && (f.meetingInfo = {
                    tenantId: g.meetingInfo.tenantId,
                    organizerId: scrubMriOrOmit(g.meetingInfo.organizerId)
                }, hasValue(g.meetingInfo.meetingType) && (f.meetingInfo.meetingType = g.meetingInfo.meetingType), hasValue(g.meetingInfo.replyChainMessageId) && (f.meetingInfo.replyChainMessageId = g.meetingInfo.replyChainMessageId)), g.transferContext && (f.transferContext = {
                    transferorMri: scrubMriOrOmit(g.transferContext.transferorMri),
                    targetMri: scrubMriOrOmit(g.transferContext.targetMri),
                    context: scrubObjectFields(g.transferContext.context)
                }, hasValue(g.transferContext.transferType) && (f.transferContext.transferType = g.transferContext.transferType)), safeJsonStringify(f);
            }
            function getPIISafePayload(g, f) {
                try {
                    let S = scrubObjectFields(g);
                    return Object.keys(g).forEach((v)=>{
                        f.includes(v) ? S[v] = scrubMriOrOmit(g[v]) : "conversationId" === v && (S[v] = getLoggableThreadId(g[v]));
                    }), safeJsonStringify(Ve.omit(S, [
                        "body.gp"
                    ]));
                } catch (g) {
                    return {
                        error: "failed to get safe payload"
                    };
                }
            }
            function getPIISafeRequestResponse(g) {
                try {
                    let f = scrubObjectFields(g, [
                        "id",
                        "groupCallInitiator",
                        "organizerId"
                    ]);
                    return scrubProperty(f, "response.roster.participants"), scrubProperty(f, "response.additionalActionResponses.0.output.roster.participants"), scrubProperty(f, "response.muteUnmuteResponse"), f = Ve.omit(f, [
                        "meetingChatProperties"
                    ]), f = scrubRequestData(f), f;
                } catch (g) {
                    return "failed to return safe response";
                }
            }
            function getPIISafeRequest(g) {
                try {
                    return scrubRequestData(scrubObjectFields(g));
                } catch (g) {
                    return "failed to return safe request";
                }
            }
            function scrubRequestData(g) {
                var _g_config;
                if (g === null || g === void 0 ? void 0 : (_g_config = g.config) === null || _g_config === void 0 ? void 0 : _g_config.data) {
                    let f = g.config.data;
                    f = JSON.parse(f), f = scrubObjectFields(f), g.config.data = safeJsonStringify(f);
                }
                return safeJsonStringify(g);
            }
            function getPIISafeMessage(g) {
                try {
                    let f = scrubObjectFields(g, [
                        "id",
                        "groupCallInitiator"
                    ]);
                    return scrubProperty(f, "body.participants"), safeJsonStringify(f);
                } catch (g) {
                    return "failed to return safe response";
                }
            }
            function getPIISafeEndpointDetails(g) {
                try {
                    return safeJsonStringify(scrubObjectFields(g, [
                        "originalId"
                    ]));
                } catch (g) {
                    return "failed to return safe endpoint details";
                }
            }
            function scrubProperty(g, f) {
                g && Ve.get(g, f) && Ve.set(g, f, scrubMriKeys(Ve.get(g, f)));
            }
            function getRandomizedTimeout(g) {
                const f = Math.floor(11 * Math.random()) + 10;
                return Math.floor(g * (1 - f / 100));
            }
            function isStringBase64(g) {
                if (!g) return !1;
                try {
                    return atob(g), !0;
                } catch (g) {
                    return !1;
                }
            }
            function isPromiseLike(g) {
                return !!g && "function" == typeof g.then;
            }
            function stringifyObject(g) {
                if (!g) return `${g}`;
                if (g instanceof Map) return mapToString(g);
                const f = g.toString();
                return f.endsWith("[object Object]") ? JSON.stringify(g) : f;
            }
            function stringifyRequestResponse(g) {
                try {
                    if (g instanceof XMLHttpRequest) return `status: ${g.status}, URL: ${g.responseURL}, statusText: ${g.responseText}`;
                } catch (g) {}
                return stringifyObject(g);
            }
            function mapToString(g) {
                const f = {};
                return g.forEach((g, S)=>{
                    f[S.toString()] = g;
                }), JSON.stringify(f);
            }
            function stringToBuffer(g) {
                const f = new ArrayBuffer(g.length), S = new Uint8Array(f);
                for(let f = 0; f < g.length; f++)S[f] = g.charCodeAt(f);
                return S;
            }
            function limitArraySize(g, f, S = 0) {
                return g && void 0 !== f && f > -1 && g.length > f && g.splice(S, g.length - f), g;
            }
            function arrayLimitedPush(g, f, S, v = 0) {
                limitArraySize(g, 0 === S ? 0 : S - 1, v), 0 !== S && g.push(f);
            }
            var He = class {
                getRequestOptions(g, f, S, v, _) {
                    return {
                        headers: f || {},
                        timeout: v,
                        payload: S || null,
                        responseType: _
                    };
                }
                getAsync(g, f) {
                    return this.sendRequest(g, f, "GET");
                }
                postAsync(g, f) {
                    return this.sendRequest(g, f, "POST");
                }
                putAsync(g, f) {
                    return this.sendRequest(g, f, "PUT");
                }
                removeAsync(g, f) {
                    return this.sendRequest(g, f, "DELETE");
                }
                async sendRequest(g, f = {
                    headers: {}
                }, S) {
                    const v = this.logger.createChild(`[${f.causeId || generateCauseId()}][Request]`);
                    v.info(`sending, ${S}-${g}`);
                    const _ = Date.now();
                    let C;
                    f.headers = f.headers || {}, f.headers["content-type"] || (f.headers["content-type"] = f.contentType || "application/json");
                    try {
                        const E = Oe.default.request({
                            url: g,
                            method: S,
                            headers: f.headers || {},
                            timeout: "number" == typeof f.timeout ? f.timeout : 45e3,
                            data: f.payload || "",
                            responseType: f.responseType || f.dataType || "json",
                            withCredentials: valueOrDefault(f.withCredentials, !1),
                            cancelToken: new Oe.default.CancelToken((g)=>{
                                C = g;
                            })
                        });
                        isPromiseLike(f.timeout) && f.timeout.then(()=>{
                            v.info("Aborting pending request"), C();
                        }, ()=>{
                            v.info("Timeout promise rejected, ignoring");
                        });
                        const T = await E;
                        return v.info(`success, status=${T.status}`), {
                            response: T.data,
                            request: T.request,
                            duration: Date.now() - _
                        };
                    } catch (g) {
                        if (v.info("failed"), Oe.default.isCancel(g)) throw v.info(`response=${getPIISafeRequestResponse(g.message)}`), {
                            aborted: !0
                        };
                        throw g.response ? v.info(`response=${getPIISafeRequestResponse(g.response)}`) : g.request ? v.info(`no response, request=${getPIISafeRequest(g.request)}`) : v.info(`request not made, error=${getPrintableObject(g)}`), g || new Error("Request failed");
                    }
                }
                constructor(g){
                    g && "function" == typeof g.createChild ? this.logger = g.createChild("RequestDispatcher") : this.logger = new Le("JS.TsCalling.RequestDispatcher", !1);
                }
            };
            function valueOrDefault(g, f) {
                return void 0 !== g ? g : f;
            }
            var $e = P, je = class _InternalLogger {
                getPrefix(g, f) {
                    let S = "";
                    return f && (S += `[${f}]`), g && (S += `[${g}]`), S;
                }
                createChild(g, f) {
                    return new _InternalLogger(this._callingLogger.createChild(g, f));
                }
                createFnLogger(g, f, ...S) {
                    return new _InternalLogger(this._callingLogger.createChild(this.getPrefix(g, f) + S.join(""), !1));
                }
                logSuccess(g) {
                    this._maybeLog("info", `success=${g}}`);
                }
                logFailure(g) {
                    const f = getPrintableObject(g);
                    this._maybeLog("info", `failed=${f}}`);
                }
                log(...g) {
                    this._maybeLog("log", ...g);
                }
                debug(...g) {
                    this._maybeLog("debug", ...g);
                }
                info(...g) {
                    this._maybeLog("info", ...g);
                }
                warn(...g) {
                    this._maybeLog("warn", ...g);
                }
                error(...g) {
                    this._maybeLog("error", ...g);
                }
                constructor(g){
                    this._callingLogger = g, this._maybeLog = (g, ...f)=>{
                        try {
                            this._callingLogger[g](...f);
                        } catch (g) {
                            this._callingLogger.info("[failed to log]", getPrintableObject(g));
                        }
                    };
                }
            }, Ge = P, qe = class {
                subscribe(g) {
                    return new We(this.subscriptions, g);
                }
                dispose(g) {
                    this.subscriptions = [];
                }
                raiseEvents(g) {
                    this.subscriptions.slice().forEach((f)=>{
                        try {
                            void 0 !== f.eventHandler && g(f.eventHandler);
                        } catch (g) {
                            var _this_eventLogger_warn, _this_eventLogger;
                            (_this_eventLogger = this.eventLogger) === null || _this_eventLogger === void 0 ? void 0 : (_this_eventLogger_warn = _this_eventLogger.warn) === null || _this_eventLogger_warn === void 0 ? void 0 : _this_eventLogger_warn.call(_this_eventLogger, "Event handler exception caught!", stringifyObject(g));
                        }
                    });
                }
                constructor(g){
                    this.eventLogger = g, this.subscriptions = [];
                }
            }, We = class {
                dispose() {
                    (0, Ge.remove)(this.subscriptions, (g)=>g === this), this.eventHandler = void 0;
                }
                constructor(g, f){
                    this.subscriptions = g, this.eventHandler = f, this.subscriptions.push(this);
                }
            }, ze = class extends qe {
                changed(g, f) {
                    return this.subscribe({
                        changed: {
                            skipEventConfig: f,
                            handler: g
                        },
                        on: void 0
                    });
                }
                on(g, f) {
                    return this.subscribe({
                        changed: void 0,
                        on: {
                            name: String(g),
                            handler: this._toEventCallback(f)
                        }
                    });
                }
                once(g, f, S) {
                    let v;
                    const onceSubscription = (...g)=>{
                        v.dispose(S), this._toEventCallback(f)(...g);
                    };
                    return v = this.on(g, this._fromEventCallback(onceSubscription)), v;
                }
                raiseChanged(g) {
                    this.raiseEvents((f)=>{
                        if (!f.changed) return;
                        const { skipEventConfig: S, handler: v } = f.changed;
                        !this.getShouldSkipChangedEvent(g, S) && v();
                    });
                }
                event(g) {
                    return {
                        raise: this._fromEventCallback((...f)=>this._raiseEventImpl(String(g), ...f))
                    };
                }
                _raiseEventImpl(g, ...f) {
                    this.raiseEvents((S)=>S.on && S.on.name === g && S.on.handler(...f));
                }
                _toEventCallback(g) {
                    return g;
                }
                _fromEventCallback(g) {
                    return g;
                }
                getShouldSkipChangedEvent(g, f) {
                    return (g === null || g === void 0 ? void 0 : g.skipDominantSpeakerUpdatesOnCall) ? !!(f === null || f === void 0 ? void 0 : f.skipDominantSpeakerUpdatesOnCall) : !!(g === null || g === void 0 ? void 0 : g.skipParticipantsUpdatesOnCall) && !!(f === null || f === void 0 ? void 0 : f.skipParticipantsUpdatesOnCall);
                }
                constructor(g){
                    super(g);
                }
            };
            function getTsCallingVersion() {
                return "2024.50.01.16";
            }
            function getOvb() {
                return "ef4bff739fbd11951fef46ac34392f338219bda6";
            }
            var Ke = P, Je = __toESM(ie()), Ye = {
                OS: {
                    Android: "Android",
                    iOS: "iOS",
                    MacOS: "Mac OS"
                },
                Browsers: {
                    Opera: "Opera",
                    Edge: "Edge",
                    Yandex: "Yandex",
                    Firefox: "Firefox",
                    Safari: "Safari",
                    MobileSafari: "Mobile Safari",
                    WebKit: "WebKit"
                },
                Engines: {
                    Blink: "Blink",
                    EdgeHTML: "EdgeHTML",
                    Gecko: "Gecko",
                    WebKit: "WebKit"
                }
            }, Qe = "Unknown", Xe = "0.0", Ze = class _BrowserInfoProvider {
                static get instance() {
                    return _BrowserInfoProvider._instance || (_BrowserInfoProvider._instance = new _BrowserInfoProvider), _BrowserInfoProvider._instance;
                }
                static isFormFactor(...g) {
                    return g.map((g)=>g.toString()).includes(this.getBrowserInfo().formFactor);
                }
                static isEngine(...g) {
                    return g.map((g)=>g.toString()).includes(this.getBrowserInfo().engine);
                }
                static isBrowser(...g) {
                    return g.map((g)=>g.toString()).includes(this.getBrowserInfo().name);
                }
                static isVersionGreaterOrEqual(g) {
                    const f = this.getBrowserInfo().version, S = g.split(".").map((g)=>parseInt(g, 10)), v = f.split(".").map((g)=>parseInt(g, 10));
                    return v[0] > S[0] || v[0] === S[0] && v[1] >= S[1];
                }
                static getBrowserInfo() {
                    return this.instance.browserInfo;
                }
                static isRemote() {
                    var _window_navigator_mediaDevices;
                    return (_window_navigator_mediaDevices = window.navigator.mediaDevices) === null || _window_navigator_mediaDevices === void 0 ? void 0 : _window_navigator_mediaDevices.isRemote;
                }
                static toString() {
                    const g = this.getBrowserInfo();
                    return `${g.name}/${g.version} ${g.engine} ${g.formFactor}`;
                }
                modifyParserResult(g) {
                    var _g_browser_name;
                    switch(g.engine.name){
                        case Ye.Engines.EdgeHTML:
                            this.browserInfo.engine = "Edge";
                            break;
                        case Ye.Engines.Blink:
                            this.browserInfo.engine = "Chromium";
                            break;
                        case Ye.Engines.WebKit:
                            var _g_browser_name1;
                            ((_g_browser_name1 = g.browser.name) === null || _g_browser_name1 === void 0 ? void 0 : _g_browser_name1.includes("Safari")) || (this.browserInfo.engine = "Chromium");
                            break;
                        case Ye.Engines.Gecko:
                            this.browserInfo.engine = "Firefox";
                    }
                    g.engine.name === Ye.Engines.Blink && g.browser.name === Ye.Browsers.Edge && (this.browserInfo.name = "EdgeAnaheim"), g.engine.name === Ye.Engines.Blink && g.os.name === Ye.OS.Android && (this.browserInfo.version = g.engine.version || Xe), g.browser.name !== Ye.Browsers.Opera && g.browser.name !== Ye.Browsers.Yandex || (this.browserInfo.version = g.engine.version || Xe, g.browser.name === Ye.Browsers.Yandex && (this.browserInfo.name = "YandexBrowser")), (g.os.name === Ye.OS.iOS || ((_g_browser_name = g.browser.name) === null || _g_browser_name === void 0 ? void 0 : _g_browser_name.includes(Ye.Browsers.Safari))) && (this.browserInfo.engine = "Safari"), g.os.name !== Ye.OS.MacOS && g.os.name !== Ye.OS.iOS || g.browser.name !== Ye.Browsers.WebKit || (this.browserInfo.engine = "Safari", this.browserInfo.name = "AppleWebView"), g.os.name === Ye.OS.iOS && (this.browserInfo.version = g.os.version || Xe), g.browser.name === Ye.Browsers.MobileSafari && (this.browserInfo.name = "Safari"), g.ua.includes("maglev") && (this.browserInfo.name = "Maglev", this.browserInfo.version = g.engine.version || Xe), _BrowserInfoProvider.isRemote() && (this.browserInfo.engine = "ChromiumAVD"), g.ua.includes("Cisco") && (this.browserInfo.name = "CiscoOS"), g.ua.includes("ZoomRoom") && (this.browserInfo.name = "ZoomRoom"), g.ua.includes("TeamsSamsungTVBrowser") && (this.browserInfo.name = "SamsungTV");
                }
                constructor(){
                    const g = navigator.userAgent, f = new Je.UAParser(g).getResult();
                    this.browserInfo = {
                        name: f.browser.name || "Unknown",
                        engine: f.engine.name || "Unknown",
                        version: f.browser.version || Xe,
                        formFactor: getFormFactor(f) || "Unknown",
                        osName: f.os.name || Qe,
                        osVersion: f.os.version || Qe
                    }, this.modifyParserResult(f);
                }
            };
            function getFormFactor(g) {
                const f = "136";
                if (getOsSkuInfo() === f) return "Hololens";
                if (/hostAudio-Processing/i.test(g.ua)) return "RoomAudioProcessing";
                const S = g.device.type;
                return "mobile" === S || "tablet" === S ? "Mobile" : void 0 === g.browser.name ? "Unknown" : "Desktop";
            }
            function getOsSkuInfo() {
                const g = "os-sku", f = window.external;
                return (f === null || f === void 0 ? void 0 : f.getHostEnvironmentValue) ? JSON.parse(f.getHostEnvironmentValue(g))[g] : "-1";
            }
            var et = {
                src: [
                    "https://statics.teams.cdn.office.net/hashed/azuremediaplayer.min-d46c9f4.js",
                    "https://statics.teams.cdn.office.net/evergreen-assets/broadcast/player-skin.min.js"
                ],
                css: [
                    "https://statics.teams.cdn.office.net/evergreen-assets/broadcast/player-skin.min.css?v=2",
                    "https://statics.teams.cdn.office.net/evergreen-assets/broadcast/video-player.css?v=3"
                ],
                styles: [
                    "azuremediaplayer",
                    "amp-stream-skin",
                    "amp-big-play-centered"
                ],
                lang: "en-us",
                disableFullscreenButton: !1,
                playerType: 0
            }, tt = {
                src: [
                    "https://azuremdncdnhlsendpoint.azureedge.net/hlsjsv115/hls.js",
                    "https://vzmdncdnendpoint.azureedge.net/hlsjsv115/hls.js"
                ],
                css: [],
                styles: [],
                lang: "en-us",
                disableFullscreenButton: !1,
                muteVideo: !1,
                playerType: 1,
                hydraPlayerWebSdkUrls: [
                    "https://afdhls.playerscript.prod.ml.cdn.office.net/hlsrt2023-1208-2/hydra_player_hls_bundle.js",
                    "https://vzhls.playerscript.prod.ml.cdn.office.net/hlsrt2023-1208-2/hydra_player_hls_bundle.js"
                ]
            }, it = {
                src: [],
                css: [],
                styles: [],
                playerType: 2,
                hydraPlayerWebSdkUrls: [
                    "https://afdhls.playerscript.prod.ml.cdn.office.net/umsrt2023-1207-3/hydra_player_ums_bundle.js",
                    "https://vzhls.playerscript.prod.ml.cdn.office.net/umsrt2023-1207-3/hydra_player_ums_bundle.js"
                ]
            }, nt = class {
                get playerConfig() {
                    return 0 === this.defaultSettings.playerType ? this.defaultSettings.ampSettings.liveStreamPlayerConfiguration : 1 === this.defaultSettings.playerType ? this.defaultSettings.hlsSettings.liveStreamPlayerConfiguration : 2 === this.defaultSettings.playerType ? this.defaultSettings.umsSettings.liveStreamPlayerConfiguration : null;
                }
                get config() {
                    return this.defaultSettings;
                }
                constructor(g, f, S, v){
                    var _f_playerConfig;
                    this.configIds = S, this.logger = v, this.defaultSettings = getSettings(), this.logger.info(`client settings: ${JSON.stringify(f)}`), this.defaultSettings.debug = (f === null || f === void 0 ? void 0 : f.debug) || !1, this.defaultSettings.playerType = (f === null || f === void 0 ? void 0 : (_f_playerConfig = f.playerConfig) === null || _f_playerConfig === void 0 ? void 0 : _f_playerConfig.playerType) || this.defaultSettings.playerType, (f === null || f === void 0 ? void 0 : f.playerConfig) && (0 === this.defaultSettings.playerType ? this.defaultSettings.ampSettings.liveStreamPlayerConfiguration = f.playerConfig : 1 === this.defaultSettings.playerType ? this.defaultSettings.hlsSettings.liveStreamPlayerConfiguration = f.playerConfig : 2 === this.defaultSettings.playerType && (this.defaultSettings.umsSettings.liveStreamPlayerConfiguration = f.playerConfig)), (0, Ke.mergeWith)(this.defaultSettings, g, arrayMergeCustomizer), this.logger.info(`applied settings: ${JSON.stringify(this.defaultSettings)}`);
                }
            }, rt = class {
                getSettings() {
                    return this.defaultSettings;
                }
                constructor(){
                    this.defaultSettings = {
                        allowSdnPlugins: !0,
                        capturePlayerLogs: !0,
                        playerType: 0,
                        loadType: 1,
                        maxPlayerDiagnosticsCount: 50,
                        maxPlayerMemoryTraceLogCount: 1e3,
                        maxPlayerPlaybackEventCount: 50,
                        maxRetryCount: 10,
                        playerTelemetryTickMs: 1e3,
                        removeEmptyDefaultTextTrack: !0,
                        sendSnapshotTelemetry: !1,
                        sendSnapshotTelemetryEveryMs: 1e4,
                        sendInitialTelemetryAfterMs: 6e4,
                        sendTelemetry: !0,
                        textTrackKind: "subtitles",
                        maxRetryCountForLoadingResources: 5,
                        maxVideoTrackHistoryLogCount: 100,
                        hydraRuntimeFetchTimeout: 6e3,
                        ampSettings: {
                            errorCodesEligibleForStreamingUrlSwitch: [
                                4194309,
                                2097564,
                                2097556,
                                2097752,
                                2097753,
                                5242884
                            ],
                            liveStreamPlayerConfiguration: et,
                            sourceResetTimeoutInMs: 1e3,
                            streamingUrlSwitchMaxCount: 2,
                            resetStreamingUrlSwitchCount: !1,
                            useBrowserWindowSizeForBitRate: !0,
                            estimateAbsoluteTime: !0,
                            maxAbsoluteTimeOffsetEstimationResultsLogCount: 100,
                            collectUserInitiatedSeekEventsTelemetry: !0,
                            maxUserInitiatedSeekEventCount: 100,
                            noMediaTimeoutMs: -1
                        },
                        hlsSettings: {
                            liveStreamPlayerConfiguration: tt,
                            timeoutForSwitchingUrl: 9e3,
                            estimateAbsoluteTime: !0,
                            maxAbsoluteTimeOffsetEstimationResultsLogCount: 100,
                            playlistInitialSequenceNumber: 1,
                            skipNonce: !1,
                            maxStreamConnectionResultsLogCount: 100,
                            logHlsJsEvents: !1,
                            logHlsJsEventsEveryMs: 5e3,
                            maxPlayerExperimentalEvents: 100
                        },
                        umsSettings: {
                            liveStreamPlayerConfiguration: it,
                            timeoutForSwitchingUrl: 9e3,
                            maxStreamConnectionResultsLogCount: 100,
                            minTargetEdgeLatency: .2,
                            latencyCompensationThreshold: .5,
                            maxPlayerExperimentalEvents: 100
                        }
                    };
                }
            }, at = class extends rt {
                getSettings() {
                    return this.settings;
                }
                constructor(){
                    super(), this.settings = super.getSettings(), this.settings.loadType = 0, this.settings.allowSdnPlugins = !1, this.settings.umsSettings.minTargetEdgeLatency = .6, this.settings.umsSettings.latencyCompensationThreshold = .9;
                }
            };
            function getSettings() {
                return (Ze.isEngine("Safari") ? new at : new rt).getSettings();
            }
            function arrayMergeCustomizer(g, f) {
                if ((0, Ke.isArray)(g)) return f.slice();
            }
            function isStreamValid(g) {
                return !!g && !!g.url && !!g.decryptionToken;
            }
            function assert(g, f, S) {
                if (!g && !S) throw new Error("Assert failed" + (void 0 !== f ? `: ${f}` : ""));
            }
            var st = class {
                complete() {
                    assert(this.startTime, "not started", this.stopCrash), assert(void 0 === this.duration, "already completed", this.stopCrash), this.duration = Date.now() - this.startTime;
                }
                updateDetails(g, f) {
                    if (this.details && "object" == typeof this.details) for(let S = 0; S < g.length; S++)this.details[g[S]] = f[S];
                }
                fail(g) {
                    this.failReason = g, this.complete();
                }
                set detail(g) {
                    this.details = g;
                }
                getTelemetryEvent() {
                    assert(this.startTime, "not started", this.stopCrash);
                    try {
                        assert(void 0 !== this.duration, "not completed", this.stopCrash);
                    } catch (g) {
                        if ("SetSource" !== this.name && "Load" !== this.name) throw g;
                    }
                    const g = {
                        name: this.name,
                        startTime: this.startTime,
                        duration: this.duration
                    };
                    return this.failReason && (g.failReason = this.failReason), this.details && (g.details = this.details), g;
                }
                start(g) {
                    assert(!this.startTime, "already started", this.stopCrash), this.startTime = Date.now(), this.details = g;
                }
                constructor(g, f, S){
                    this.name = g, this.stopCrash = f, this.start(S);
                }
            }, ot = class {
                getPlayerDiagnosticSnapshot() {
                    return this.currentPlayerDiagnosticSnapshot;
                }
                registerStatsUpdated(g) {
                    this.currentPlayerDiagnosticSnapshot = g, Object.keys(this.playerDiagnosticsLog).forEach((f)=>{
                        const S = f, v = this.playerDiagnosticsLog[f];
                        if (Array.isArray(v)) {
                            v.push(g[S]);
                            const f = "memoryLog" === S && v.length > this.maxPlayerMemoryTraceLogCount, _ = "memoryLog" !== S && v.length > this.maxPlayerDiagnosticsCount;
                            (f || _) && v.splice(0, 1);
                        } else this.playerDiagnosticsLog[f] = g[S];
                    });
                }
                registerEventLoadAttempt(g, f) {
                    this.registerScenario(g, f);
                }
                registerEventLoadFailed(g, f) {
                    this.completeScenario(g, f);
                }
                registerEventLoadSucceeded(g, f) {
                    this.completeScenario(g, void 0, f);
                }
                registerPlayerLoadAttempt() {
                    this.registerScenario("Load");
                }
                registerPlayerLoadSucceeded(g) {
                    this.completeScenario("Load", void 0, g);
                }
                registerPlayerLoadFailed(g) {
                    this.completeScenario("Load", g);
                }
                registerPlayerSetupAttempt() {
                    this.registerScenario("Setup");
                }
                registerPlayerSetupSucceeded() {
                    this.completeScenario("Setup");
                }
                registerPlayerSetupFailed(g) {
                    this.completeScenario("Setup", g);
                }
                registerStreamConnectionAttempt(g) {
                    this.registerScenario("StreamConnection");
                }
                registerStreamConnectionSucceeded() {
                    this.completeScenario("StreamConnection");
                }
                registerStreamConnectionFailed(g) {
                    this.completeScenario("StreamConnection", g);
                }
                registerSetSourceAttempt(g, f) {
                    let S = g;
                    f && (S = {
                        src: g,
                        reason: f
                    }), this.registerScenario("SetSource", S);
                }
                registerSetSourceSucceeded(g) {
                    this.getScenario("SetSource").updateDetails([
                        "src"
                    ], [
                        g
                    ]), this.completeScenario("SetSource");
                }
                registerSetSourcedFailed(g, f) {
                    this.getScenario("SetSource").updateDetails([
                        "src"
                    ], [
                        f
                    ]), this.completeScenario("SetSource", g);
                }
                registerSdnPluginLoad(g, f, S) {
                    this.registerScenario("SdnPluginLoad", g);
                    const v = f ? void 0 : S;
                    this.completeScenario("SdnPluginLoad", v);
                }
                registerPlayerDestroyed(g) {
                    this.registerScenario("Destroyed", g), this.completeScenario("Destroyed");
                }
                registerPlaybackStateChanged(g, f) {
                    let S;
                    if ("Ready" !== g || this.firstReadyStateTimestamp ? "Playing" !== g || this.firstPlayingStateTimestamp || (this.firstPlayingStateTimestamp = Date.now()) : this.firstReadyStateTimestamp = Date.now(), f && "Buffering" === g) f ? S = f.message : this.logger.debug(`Unexpected buffering payload: ${JSON.stringify(f)}`);
                    this.registerPlaybackEvent("StateChanged", g, S);
                }
                registerPlaybackError(g, f) {
                    this.registerPlaybackEvent("Error", {
                        errorType: g,
                        details: f
                    });
                }
                registerDownloadBitratechanged(g) {
                    this.registerPlaybackEvent("BitrateChangedDownload", g);
                }
                registerStreamOptionsConfigured(g, f) {
                    this.registerPlaybackEvent("StreamOptionsConfigured", this.generateCleanedStreamOption(g), f);
                }
                registerPlaybackBitratechanged(g) {
                    this.registerPlaybackEvent("BitrateChangedPlayback", g);
                }
                registerPotentialMediaFreeze(g) {
                    this.registerPlaybackEvent("PotentialMediaFreeze", g);
                }
                registerCaptionToggle(g, f, S) {
                    const v = {
                        isEnabled: g,
                        culture: f,
                        playerTime: S
                    };
                    this.registerPlaybackEvent("CaptionsToggled", v);
                }
                registerFullScreenChange(g) {
                    this.registerPlaybackEvent("FullscreenChanged", g);
                }
                registerMute(g) {
                    this.registerPlaybackEvent("Mute", g);
                }
                registerVolumeChange(g) {
                    this.registerPlaybackEvent("Volume", g);
                }
                getExperimentalEvents() {
                    return {
                        playback_experimentalEvents: this.prepareForTelemetry(this.experimentalEvents)
                    };
                }
                getUserInitiatedSeekEvents() {
                    return {
                        playback_userInitiatedSeekEvents: this.prepareForTelemetry(this.userInitiatedSeekEvents)
                    };
                }
                getSnapshotReport(g = {}) {
                    const f = this.playerEvents.map((g)=>g.getTelemetryEvent()), S = this.playbackEvents;
                    let v = {};
                    var _g_isFinal, _g_disableFullscreenButton;
                    return this.currentPlayerDiagnosticSnapshot && (v = this.filterAndPrepareTelemetry()), {
                        isFullReport: !1,
                        configIds: g.configIds || "",
                        playerId: g.playerId || "",
                        correlationId: g.correlationId || "",
                        traceId: g.correlationId ? g.correlationId.replace(/-/g, "") : "",
                        eTag: g.eTag || "",
                        isFinal: (_g_isFinal = g.isFinal) !== null && _g_isFinal !== void 0 ? _g_isFinal : !1,
                        isIframe: 1 === this.config.loadType,
                        isFullscreenButtonDisabled: (_g_disableFullscreenButton = g.disableFullscreenButton) !== null && _g_disableFullscreenButton !== void 0 ? _g_disableFullscreenButton : !1,
                        threadId: g.threadId || "",
                        telemetryTickMs: this.currentPlayerDiagnosticSnapshot && this.currentPlayerDiagnosticSnapshot.statsInterval ? this.currentPlayerDiagnosticSnapshot.statsInterval : -1,
                        tsCallingVersion: getTsCallingVersion(),
                        ...this.getInitializationReport(f, S),
                        ...this.getPlaybackReport(S),
                        ...this.getBitrateReport(S),
                        ...this.getSdnReport(f),
                        ...this.getSetSourceReport(f),
                        ...this.getExperimentalEvents(),
                        ...this.getUserInitiatedSeekEvents(),
                        networkType: this.getClientNetworkType(),
                        callSetupSucceeded: this.getCallSetupSucceeded(f),
                        callDropped: this.getCallDropped(S),
                        ...v
                    };
                }
                getReport(g = {}) {
                    const f = this.playerEvents.map((g)=>g.getTelemetryEvent()), S = this.playbackEvents;
                    var _g_isFinal, _g_disableFullscreenButton;
                    return {
                        callendReason: g.callendReason,
                        isFullReport: !0,
                        configIds: g.configIds || "",
                        playerId: g.playerId || "",
                        correlationId: g.correlationId || "",
                        traceId: g.correlationId ? g.correlationId.replace(/-/g, "") : "",
                        eTag: g.eTag || "",
                        isFinal: (_g_isFinal = g.isFinal) !== null && _g_isFinal !== void 0 ? _g_isFinal : !1,
                        isIframe: 1 === this.config.loadType,
                        isFullscreenButtonDisabled: (_g_disableFullscreenButton = g.disableFullscreenButton) !== null && _g_disableFullscreenButton !== void 0 ? _g_disableFullscreenButton : !1,
                        threadId: g.threadId || "",
                        telemetryTickMs: this.currentPlayerDiagnosticSnapshot && this.currentPlayerDiagnosticSnapshot.statsInterval ? this.currentPlayerDiagnosticSnapshot.statsInterval : -1,
                        tsCallingVersion: getTsCallingVersion(),
                        ...this.getInitializationReport(f, S),
                        ...this.getPlaybackReport(S),
                        ...this.getBitrateReport(S),
                        ...this.getSdnReport(f),
                        ...this.getSetSourceReport(f),
                        ...this.getExperimentalEvents(),
                        ...this.getUserInitiatedSeekEvents(),
                        networkType: this.getClientNetworkType(),
                        callSetupSucceeded: this.getCallSetupSucceeded(f),
                        callDropped: this.getCallDropped(S),
                        ...this.getPlayerDiagnosticLog()
                    };
                }
                registerExperimentalEvent(g, f, S) {
                    const v = this.createTelemetryEvent(g, f, S);
                    this.experimentalEvents.push(v), this.logTelemetryEvent(v);
                }
                registerUserInitiatedSeek(g) {
                    var _this_currentPlayerDiagnosticSnapshot;
                    const f = (((_this_currentPlayerDiagnosticSnapshot = this.currentPlayerDiagnosticSnapshot) === null || _this_currentPlayerDiagnosticSnapshot === void 0 ? void 0 : _this_currentPlayerDiagnosticSnapshot.currentPlayPosition) ? this.currentPlayerDiagnosticSnapshot.currentPlayPosition : -1) < g.newCurrentPlayPosition, S = {
                        ...g,
                        seekForward: f
                    }, v = this.createTelemetryEvent("UserInitiatedSeek", S);
                    this.userInitiatedSeekEvents.push(v), this.userInitiatedSeekEvents.length > this.maxUserInitiatedSeekEventCount && this.userInitiatedSeekEvents.splice(0, 1);
                }
                createTelemetryEvent(g, f, S) {
                    const v = {
                        eventType: g,
                        timestamp: Date.now(),
                        currentPlayPosition: this.currentPlayerDiagnosticSnapshot && this.currentPlayerDiagnosticSnapshot.currentPlayPosition ? this.currentPlayerDiagnosticSnapshot.currentPlayPosition : -1
                    };
                    return void 0 !== f && (v.payload = this.prepareForTelemetry(f)), v.message = S, v;
                }
                registerPlaybackEvent(g, f, S) {
                    const v = this.createTelemetryEvent(g, f, S);
                    "Error" === g && "PlaybackRetried" !== (f === null || f === void 0 ? void 0 : f.errorType) && (v.fatal = !0), this.playbackEvents.push(v), this.playbackEvents.length > this.maxPlayerPlaybackEventCount && this.playbackEvents.splice(0, 1), this.logTelemetryEvent(v);
                }
                getPlayerDiagnosticLog() {
                    if (!this.currentPlayerDiagnosticSnapshot) return {};
                    const g = {
                        ...this.currentPlayerDiagnosticSnapshot,
                        ...this.playerDiagnosticsLog
                    }, f = {};
                    return Object.keys(g).forEach((S)=>{
                        f[`player_${S}`] = this.prepareForTelemetry(g[S]);
                    }), f;
                }
                getCallSetupSucceeded(g) {
                    const f = g.find((g)=>"Load" === g.name);
                    return !!f && !f.failReason;
                }
                getCallDropped(g) {
                    return !!g.filter((g)=>"Error" === g.eventType).find((g)=>g.fatal);
                }
                getInitializationReport(g, f) {
                    const S = g.find((g)=>"Load" === g.name);
                    return {
                        init_timeLoadToStreamConnectionEstablished: (S && this.initialStreamConnectionEstablishedTimestamp ? this.initialStreamConnectionEstablishedTimestamp - S.startTime : -1) || -1,
                        init_timeLoadToReady: (S && this.firstReadyStateTimestamp ? this.firstReadyStateTimestamp - S.startTime : -1) || -1,
                        init_timeLoadToPlaying: (S && this.firstPlayingStateTimestamp ? this.firstPlayingStateTimestamp - S.startTime : -1) || -1,
                        init_allEvents: this.prepareForTelemetry(g)
                    };
                }
                getPlaybackReport(g) {
                    const f = g.filter((g)=>"StateChanged" === g.eventType), S = f.find((g)=>"Ready" === g.payload), v = f.find((g)=>"Play" === g.payload), _ = f.find((g)=>"Start" === g.payload), C = f.find((g)=>"Playing" === g.payload), E = S && v ? v.timestamp - S.timestamp : -1, T = v && _ ? _.timestamp - v.timestamp : -1, I = _ && C ? C.timestamp - _.timestamp : -1, b = f.filter((g)=>"Seeked" === g.payload), A = f.filter((g)=>"Seeking" === g.payload), R = f.filter((g)=>"Paused" === g.payload), P = f.filter((g)=>"Resume" === g.payload), w = f.filter((g)=>"Buffering" === g.payload), M = [
                        "BitrateChangedDownload",
                        "BitrateChangedPlayback",
                        "Error",
                        "Mute",
                        "StateChanged",
                        "Volume",
                        "StreamOptionsConfigured"
                    ], O = g.filter((g)=>"Error" === g.eventType), D = g.filter((g)=>"Volume" === g.eventType || "Mute" === g.eventType), N = g.filter((g)=>"StreamOptionsConfigured" === g.eventType), k = g.filter((g)=>!M.includes(g.eventType));
                    return {
                        playback_timeReadyToPlay: E,
                        playback_timePlayToStart: T,
                        playback_timeStartToPlaying: I,
                        playback_bufferingEvents: this.prepareForTelemetry(w),
                        playback_errorEvents: this.prepareForTelemetry(O),
                        playback_pauseEvents: this.prepareForTelemetry(R),
                        playback_resumeEvents: this.prepareForTelemetry(P),
                        playback_otherEvents: this.prepareForTelemetry(k),
                        playback_seekedEvents: this.prepareForTelemetry(b),
                        playback_seekingEvents: this.prepareForTelemetry(A),
                        playback_stateChangeEvents: this.prepareForTelemetry(f),
                        playback_volumeEvents: this.prepareForTelemetry(D),
                        playback_streamOptionsConfiguredEvents: this.prepareForTelemetry(N)
                    };
                }
                generateCleanedStreamOption(g) {
                    var _g_stream, _g_stream1, _g_stream2, _g_altStream, _g_altStream1, _g_stream3;
                    return {
                        ...g,
                        stream: {
                            ...g === null || g === void 0 ? void 0 : g.stream,
                            decryptionToken: (g === null || g === void 0 ? void 0 : (_g_stream = g.stream) === null || _g_stream === void 0 ? void 0 : _g_stream.decryptionToken) ? "valid" : "empty",
                            sdnContext: (g === null || g === void 0 ? void 0 : (_g_stream1 = g.stream) === null || _g_stream1 === void 0 ? void 0 : _g_stream1.sdnContext) ? "valid" : "empty",
                            keyAuthorizationToken: (g === null || g === void 0 ? void 0 : (_g_stream2 = g.stream) === null || _g_stream2 === void 0 ? void 0 : _g_stream2.keyAuthorizationToken) ? "valid" : "empty"
                        },
                        altStream: (g === null || g === void 0 ? void 0 : g.altStream) ? {
                            ...g === null || g === void 0 ? void 0 : g.altStream,
                            decryptionToken: (g === null || g === void 0 ? void 0 : (_g_altStream = g.altStream) === null || _g_altStream === void 0 ? void 0 : _g_altStream.decryptionToken) ? "valid" : "empty",
                            sdnContext: (g === null || g === void 0 ? void 0 : (_g_altStream1 = g.altStream) === null || _g_altStream1 === void 0 ? void 0 : _g_altStream1.sdnContext) ? "valid" : "empty",
                            keyAuthorizationToken: (g === null || g === void 0 ? void 0 : (_g_stream3 = g.stream) === null || _g_stream3 === void 0 ? void 0 : _g_stream3.keyAuthorizationToken) ? "valid" : "empty"
                        } : void 0
                    };
                }
                getBitrateReport(g) {
                    const f = g.filter((g)=>"BitrateChangedDownload" === g.eventType), S = f.sort((g)=>Number(g.payload)), v = f.length ? {
                        bitrate_downloadChanges: this.prepareForTelemetry(f),
                        bitrate_downloadChangeCount: f.length || -1,
                        bitrate_downloadMin: S[0].payload || -1,
                        bitrate_downloadMax: S[S.length - 1].payload || -1
                    } : {}, _ = g.filter((g)=>"BitrateChangedPlayback" === g.eventType), C = _.sort((g)=>Number(g.payload));
                    return {
                        ...v,
                        ..._.length ? {
                            bitrate_playbackChanges: this.prepareForTelemetry(_),
                            bitrate_playbackChangeCount: _.length || -1,
                            bitrate_playbackMin: C[0].payload || -1,
                            bitrate_playbackMax: C[C.length - 1].payload || -1
                        } : {}
                    };
                }
                addNetworkTypeEventListener() {
                    var _window_navigator_connection, _window_navigator, _window_navigator_connection1, _window_navigator1;
                    ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.type) && ((_window_navigator1 = window.navigator) === null || _window_navigator1 === void 0 ? void 0 : (_window_navigator_connection1 = _window_navigator1.connection) === null || _window_navigator_connection1 === void 0 ? void 0 : _window_navigator_connection1.addEventListener("change", ()=>this.updateClientNetworkType()));
                }
                updateClientNetworkType() {
                    this.clientNetworkType = void 0, this.getClientNetworkType();
                }
                getClientNetworkType() {
                    if (void 0 === this.clientNetworkType) {
                        var _window_navigator_connection, _window_navigator;
                        let g = "Unknown";
                        if ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.type) {
                            var _window_navigator_connection1, _window_navigator1;
                            const f = (_window_navigator1 = window.navigator) === null || _window_navigator1 === void 0 ? void 0 : (_window_navigator_connection1 = _window_navigator1.connection) === null || _window_navigator_connection1 === void 0 ? void 0 : _window_navigator_connection1.type;
                            switch(f){
                                case "cellular":
                                    g = "WWAN";
                                    break;
                                case "ethernet":
                                    g = "Wired";
                                    break;
                                case "wifi":
                                    g = "Wireless";
                                    break;
                                default:
                                    g = "Unknown";
                            }
                        }
                        this.clientNetworkType = g;
                    }
                    return this.clientNetworkType;
                }
                getSdnReport(g) {
                    const f = g.filter((g)=>"SdnPluginLoad" === g.name), S = f.length ? f[f.length - 1] : void 0;
                    return {
                        sdn_loaded: !(!S || void 0 !== S.failReason),
                        sdn_details: S && S.details || "",
                        sdn_error: S && S.failReason || "",
                        sdn_events: this.prepareForTelemetry(f)
                    };
                }
                getSetSourceReport(g) {
                    const f = g.filter((g)=>"SetSource" === g.name);
                    return {
                        set_source_events: this.prepareForTelemetry(f)
                    };
                }
                registerScenario(g, f) {
                    const S = this.currentScenarioMap.get(g), v = new st(g, this.stopCrash, f);
                    assert(!S, `previous scenario:${stringifyObject(S)} is not completed, new scenario:${stringifyObject(v)}`, this.stopCrash), this.currentScenarioMap.set(g, v), this.playerEvents.push(v);
                }
                getScenario(g) {
                    return this.currentScenarioMap.get(g);
                }
                completeScenario(g, f, S) {
                    const v = this.currentScenarioMap.get(g);
                    assert(v, "no scenario to complete", this.stopCrash), f ? v.fail(f) : ("StreamConnection" !== g || this.initialStreamConnectionEstablishedTimestamp || (this.initialStreamConnectionEstablishedTimestamp = Date.now()), S && (v.detail = S), v.complete()), this.currentScenarioMap.delete(g);
                }
                logTelemetryEvent(g) {
                    this.config.debug && (this.logger.debug(`PlayerTelemetryEvent: ${JSON.stringify(g)}`), this.logger.debug(`PlayerDiagnosticData: ${JSON.stringify(this.currentPlayerDiagnosticSnapshot)}`));
                }
                filterAndPrepareTelemetry() {
                    const g = new Set;
                    g.add("serviceLatencyCdg"), g.add("endToEndLatencyCdg"), g.add("videoEdgeLatencyCdg");
                    const f = {};
                    return Object.keys(this.currentPlayerDiagnosticSnapshot).forEach((S)=>{
                        g.has(S) || (f[`player_${S}`] = this.prepareForTelemetry(this.currentPlayerDiagnosticSnapshot[S]));
                    }), f;
                }
                prepareForTelemetry(g) {
                    return "boolean" == typeof g ? g : "string" == typeof g || void 0 === g ? g || "" : "number" == typeof g ? g !== null && g !== void 0 ? g : -1 : JSON.stringify(g);
                }
                constructor(g, f, S){
                    var _g_ampSettings;
                    this.config = g, this.logger = f, this.playerDiagnosticsLog = S, this.currentScenarioMap = new Map, this.playerEvents = [], this.playbackEvents = [], this.userInitiatedSeekEvents = [], this.experimentalEvents = [], this.clientNetworkType = void 0, this.maxPlayerPlaybackEventCount = g.maxPlayerPlaybackEventCount || 5, this.maxPlayerDiagnosticsCount = g.maxPlayerDiagnosticsCount || 5, this.maxPlayerMemoryTraceLogCount = g.maxPlayerMemoryTraceLogCount || 100, this.maxUserInitiatedSeekEventCount = ((_g_ampSettings = g.ampSettings) === null || _g_ampSettings === void 0 ? void 0 : _g_ampSettings.maxUserInitiatedSeekEventCount) || 100, this.stopCrash = g.stopCrash || !1, this.config.debug && (this.playerDiagnosticsLog.memoryLog = []), this.addNetworkTypeEventListener();
                }
            }, lt = P;
            function asap(g) {
                return new Promise((f)=>{
                    f(g());
                });
            }
            var ct = class {
                get resolve() {
                    return (g)=>{
                        this.isPendingInt = !1, this.resolveInt(g), this.clearTimeout();
                    };
                }
                get reject() {
                    return (g)=>{
                        this.isPendingInt = !1, this.rejectInt(g), this.clearTimeout();
                    };
                }
                get promise() {
                    return this.promiseInt;
                }
                get isPending() {
                    return this.isPendingInt;
                }
                setTimeout(g, f = `deferred timed out after ${g}ms`) {
                    this.isPendingInt && (this.timeoutId = setTimeout(()=>{
                        this.reject(f);
                    }, g));
                }
                clearTimeout() {
                    this.timeoutId && clearTimeout(this.timeoutId);
                }
                constructor(){
                    this.isPendingInt = !0, this.promiseInt = new Promise((g, f)=>{
                        this.resolveInt = g, this.rejectInt = f;
                    });
                }
            };
            function deferWithTimeout(g, f = `deferred timed out after ${g}ms`) {
                const S = new ct;
                return S.setTimeout(g, f), S;
            }
            function delay(g) {
                return new Promise((f)=>setTimeout(f, g));
            }
            var dt = class {
                static build(g, f) {
                    return new ut(g, f);
                }
            }, ut = class {
                start(g) {
                    if (void 0 !== this.timeoutId) throw new Error(`Timer ${this.name} already started`);
                    return this.timeoutId = window.setTimeout(()=>this.ontimeout(), g), this;
                }
                stop() {
                    if (void 0 === this.timeoutId) throw new Error(`Timer ${this.name} is not defined`);
                    clearTimeout(this.timeoutId), this.timeoutId = void 0;
                }
                constructor(g, f){
                    this.ontimeout = g, this.name = f;
                }
            };
            function AmpPlayerF() {
                const g = AmpDiagnosticProviderF(), f = CaptionsControlToggleProviderF();
                let S;
                return (S || (S = {})).CaptionFunctionalityNotSupported = "CaptionFunctionalityNotSupported", class {
                    get contextWindow() {
                        return this.container.ownerDocument.defaultView;
                    }
                    configure(g, f, S) {
                        this.liveStreamOptions = g, this.playerId = S, f && (this.configProvider = f, this.statsInterval = f.config.playerTelemetryTickMs || this.statsInterval, this.maxMemoryTraceLogCount = f.config.maxPlayerMemoryTraceLogCount || this.maxMemoryTraceLogCount);
                    }
                    getIceCandidates() {
                        let g = [];
                        try {
                            var _this_liveStreamOptions_altStream;
                            const f = this.liveStreamOptions.stream.sdnContext || ((_this_liveStreamOptions_altStream = this.liveStreamOptions.altStream) === null || _this_liveStreamOptions_altStream === void 0 ? void 0 : _this_liveStreamOptions_altStream.sdnContext) || "", S = JSON.parse(f), v = JSON.parse(S.sdnConfig);
                            if (!v.RTCIceCandidates) throw new Error("RTCIceCandidates not present in SDN Context");
                            g = v.RTCIceCandidates;
                        } catch (g) {
                            this.log(`getIceCandidates failed: ${JSON.stringify(g.message)}`, "error");
                        }
                        return this.log(`getIceCandidates: ${JSON.stringify(g)}`, "debug"), g;
                    }
                    loadPlayerScript() {
                        let g = Promise.resolve("");
                        const f = this.configProvider.playerConfig.nonce, S = this.configProvider.playerConfig.css;
                        for(let v = 0; v < S.length; v++)g = g.then(()=>this.retry(()=>this.loadCss(this.container.ownerDocument, S[v], f)));
                        return g = g.then(()=>this.loadAmpScript()), g;
                    }
                    loadAmpScript() {
                        var _this_configProvider_playerConfig, _this_configProvider_playerConfig1;
                        this.log("loadPlayerScript started");
                        let g = Promise.resolve("");
                        const f = (_this_configProvider_playerConfig = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig === void 0 ? void 0 : _this_configProvider_playerConfig.nonce, S = ((_this_configProvider_playerConfig1 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig1 === void 0 ? void 0 : _this_configProvider_playerConfig1.src) || [], v = Math.max(2, this.configProvider.config.maxRetryCountForLoadingResources);
                        if (0 === S.length) return Promise.reject("AMP Player Src is empty");
                        for(let _ = 0; _ < S.length; ++_)g = g.then(()=>this.loadScriptPromise(S, _, f, v));
                        return g;
                    }
                    loadScriptPromise(g, f, S, v, _ = "") {
                        return this.retry(()=>this.setScriptByLoad(this.container.ownerDocument, g[f], S), v).then((S)=>`${g[f]}: ${S} `.concat(_)).catch((C)=>this.retry(()=>this.setScriptByBlob(this.container.ownerDocument, g[f], S), v).then((S)=>`${g[f]}: ${S}`.concat(` ${C} `, ` ${_} `)).catch((E)=>this.retry(()=>this.setScriptByInnerHtml(this.container.ownerDocument, g[f], S), 1).then((S)=>`${g[f]}: ${S}`.concat(` ${C} `, `${E} `, ` ${_} `)).catch((C)=>{
                                    let T = _;
                                    return f < g.length && (T = T.concat(`Failed to load script, nonce: ${S}, src: ${g[f]} index: ${f} `), T = T.concat(`${v} attempts LoadFailure `, `${v} attempts BlobFetchFailure: `, E, ", 1 attempt InnerHtmlFailure: ", `${C} `)), Promise.reject(T);
                                })));
                    }
                    retry(g, f = this.configProvider.config.maxRetryCountForLoadingResources, S = 1, v = 200) {
                        return g(f).then((g)=>`${g}, succeeded on load number: ${S} `).catch((_)=>(this.log(`Error loading resource: ${_} -- ${f} retriesLeft`), 0 == --f ? Promise.reject(`${_}`) : new Promise((C)=>setTimeout(()=>C(this.retry(g, f, S + 1).then((g)=>"string" == typeof g ? `${g}, succeeded on load number: ${S}` : g).catch((g)=>Promise.reject(`${_}`.concat(", ", g)))), v))));
                    }
                    setScriptByLoad(g, f, S) {
                        const v = g.createElement("script"), _ = this.getElementLoadPromise(v, f);
                        return v.src = f, S && (v.nonce = S), g.head.appendChild(v), _.then(()=>Promise.resolve("Success: setScriptByLoad"));
                    }
                    setScriptByBlob(g, f, S) {
                        return this.safeResponse(f).then((f)=>f.blob().then((v)=>{
                                if (v) {
                                    const f = URL.createObjectURL(v);
                                    return this.setScriptByLoad(g, f, S).then(()=>Promise.resolve("Success: setScriptByBlob"));
                                }
                                return Promise.reject(`${f.status}, blob is null`);
                            }));
                    }
                    setScriptByInnerHtml(g, f, S) {
                        return this.safeResponse(f).then((f)=>f.text().then((v)=>{
                                if (v) {
                                    const f = document.createElement("script");
                                    return f.innerHTML = v, S && !this.configProvider.config.hlsSettings.skipNonce && (f.nonce = S), g.head.appendChild(f), Promise.resolve("Success: setScriptByInnerHtml");
                                }
                                return Promise.reject(`status code:${f.status}, text is null`);
                            }));
                    }
                    safeResponse(g) {
                        return fetch(g).then((g)=>g.ok ? g : Promise.reject(`${g.status}`));
                    }
                    tryLoadSdnPlugin() {
                        return this.sdnPluginLoaded || !this.liveStreamOptions.sdn ? Promise.resolve() : this.configProvider.config.allowSdnPlugins ? (this.log("tryLoadSdnPlugin started"), this.retry(()=>this.setScriptByLoad(this.container.ownerDocument, this.liveStreamOptions.sdn.url, this.configProvider.playerConfig.nonce)).then(()=>{
                            this.log("SDN script loaded"), this.sdnPluginLoaded = !0, this.log("tryLoadSdnPlugin done");
                        })) : (this.log("Loading SDN plugins is not allowed"), Promise.reject("Loading SDN plugins is not allowed"));
                    }
                    createAmp() {
                        var _this_playerInstance_currentTechName, _this_liveStreamOptions, _this_liveStreamOptions1;
                        this.log("createAmp started"), this.createVideoElement();
                        const S = this.getAmpOptions();
                        if (this.playerInstance = this.contextWindow.amp(this.video.id, S), !this.playerInstance) throw this.log("createAmp failed", "error"), new Error("playerInstance is null");
                        "html5" === ((_this_playerInstance_currentTechName = this.playerInstance.currentTechName()) === null || _this_playerInstance_currentTechName === void 0 ? void 0 : _this_playerInstance_currentTechName.toLowerCase()) && this.configProvider.config.ampSettings.estimateAbsoluteTime && this.isControlsDisabled() ? (this.absoluteTimeOffsetEstimator = new gt(this.log.bind(this)), this.diagnosticProvider = new g(this.playerInstance, this.contextWindow, new Date, this.configProvider, this.absoluteTimeOffsetEstimator), this.absoluteTimeOffsetEstimator.setEstimationResultCallback(this.onAbsoluteTimeOffsetEstimation.bind(this))) : this.diagnosticProvider = new g(this.playerInstance, this.contextWindow, new Date, this.configProvider);
                        const v = {
                            controlsEnabled: !this.isControlsDisabled(),
                            logFn: this.log.bind(this),
                            removeEmptyDefaultTextTrack: this.configProvider.config.removeEmptyDefaultTextTrack
                        };
                        this.diagnosticProvider.setValue("streamingEventType", this.liveStreamOptions.streamingEventType), this.diagnosticProvider.setValue("eventId", ((_this_liveStreamOptions = this.liveStreamOptions) === null || _this_liveStreamOptions === void 0 ? void 0 : _this_liveStreamOptions.eventId) || ""), this.diagnosticProvider.setValue("templateId", ((_this_liveStreamOptions1 = this.liveStreamOptions) === null || _this_liveStreamOptions1 === void 0 ? void 0 : _this_liveStreamOptions1.templateId) || ""), this.diagnosticProvider.setValue("playerControlsEnabled", !this.isControlsDisabled()), this.captionsControl = new f(this.playerInstance, this, v, this.diagnosticProvider), this.registerPlayerEvents(), this.log("createAmp done");
                    }
                    isControlsDisabled() {
                        return void 0 !== this.liveStreamOptions.allowPlayerControls ? !this.liveStreamOptions.allowPlayerControls : "Overflow" === this.liveStreamOptions.streamingEventType || "TownHall_Basic" === this.liveStreamOptions.streamingEventType || "TownHall_Premium" === this.liveStreamOptions.streamingEventType || "TownHall" === this.liveStreamOptions.streamingEventType;
                    }
                    onAbsoluteTimeOffsetEstimation(g) {
                        if (this.diagnosticProvider.appendAbsoluteTimeOffsetEstimation(g), !g.isSuccess) {
                            const g = this.addEvent("CaptionFunctionalityNotSupported", {
                                detail: {
                                    data: {
                                        fatal: !0,
                                        details: "absolute time offset estimation failed - captions will fail"
                                    }
                                }
                            });
                            this.video.dispatchEvent(g);
                        }
                    }
                    addEvent(g, f) {
                        let S = {};
                        return (f === null || f === void 0 ? void 0 : f.detail) && (S = {
                            detail: f.detail
                        }), new CustomEvent(g, S);
                    }
                    setSource(g) {
                        if (this.log("setSource started"), !this.playerInstance) throw this.log("setSource failed: playerInstance is null", "error"), new Error("playerInstance is null");
                        this.videoSourceSetAttemptCount++, this.videoSourceSetAttemptCount > 0 && this.diagnosticProvider.setValue("retryCount", this.videoSourceSetAttemptCount - 1);
                        const f = {
                            src: g.url,
                            type: this.videoSourceType,
                            protectionInfo: g.decryptionToken ? [
                                {
                                    type: "AES",
                                    authenticationToken: g.decryptionToken
                                }
                            ] : null
                        };
                        this.configureSdnSource(f, g), this.diagnosticProvider.setValue("streamUrl", g.url), this.diagnosticProvider.setValue("streamId", this.getStreamIdFromStreamUrl(g.url)), this.diagnosticProvider.setValue("streamDeliveryPipeline", g.streamDeliveryPipeline || ""), this.playerInstance.src([
                            f
                        ], this.getTextTracks()), this.absoluteTimeOffsetEstimator && this.absoluteTimeOffsetEstimator.setManifestFileURL(g.url + "(format=m3u8-aapl-v4)"), this.log("setSource done");
                    }
                    getStreamIdFromStreamUrl(g) {
                        try {
                            const f = new URL(g).pathname;
                            if (f) {
                                const g = f.split("/");
                                if ((g === null || g === void 0 ? void 0 : g.length) > 1) return g[1];
                            }
                            return this.log(`unable to parse stream ID from stream URL: ${g}`, "warn"), "";
                        } catch (e) {
                            return this.log(`cannot parse stream ID from invalid stream URL: ${g}`, "warn"), "";
                        }
                    }
                    setPlayTime(g) {
                        g && (this.log(`setPlayerTime: ${g}`), this.playerInstance.currentTime(g));
                    }
                    dispose() {
                        this.log("dispose started"), this.diagnosticProvider && (this.stopStatsCollection(), this.diagnosticProvider.dispose(), this.diagnosticProvider = null), this.captionsControl && (this.captionsControl.dispose(), this.captionsControl = null), this.playerInstance && (this.removePlayerEventListeners(), this.playerInstance.getMemoryLog(!0), this.playerInstance.dispose(), this.playerInstance = null), this.eventsHandler.ampDisposed(), this.video && (this.removeVideoEventListeners(), this.video.parentNode && this.video.parentNode.removeChild(this.video), this.video = null), this.absoluteTimeOffsetEstimator && (this.absoluteTimeOffsetEstimator.stopStreamAbsoluteTimeOffsetRetrieval(), this.absoluteTimeOffsetEstimator = null), this.log("dispose done"), this.eventsHandler = null;
                    }
                    updatePlaybackDiagnostics() {
                        this.updateTotalPlayingTimeStatistic(), this.updateBufferingRateStatistic(), this.updateVideoTrackHistoryStatistic();
                    }
                    handlePlaybackStopped() {
                        this.isBuffering = !1, this.isPlaying = !1, this.currentVideoPlaybackBitrate = null;
                    }
                    showCaptions(g) {
                        this.log(`showCaptions: ${g}`), this.captionsControl.showCaptions(g);
                    }
                    addCues(g) {
                        g = g.filter((g)=>g.text && 0 !== g.text.trim().length), this.captionsControl.addCues(g);
                    }
                    clearCues() {
                        this.captionsControl.clearCues();
                    }
                    captionsToggled(g, f, S) {
                        this.log(`captionsToggled: ${g} for culture ${f} at ${S}`), this.eventsHandler.message("captionsToggled").send(g, f, S);
                    }
                    createVideoElement() {
                        this.log("createVideoElement started"), this.video = this.container.ownerDocument.createElement("video"), this.video.id = "amp-player", this.video.setAttribute("playsinline", "");
                        const g = this.configProvider.playerConfig.lang;
                        g && (this.video.setAttribute("lang", g), this.log(`createVideoElement: language set to ${g}`));
                        const f = this.configProvider.playerConfig.styles;
                        for(let g = 0; g < f.length; g++)this.video.classList.add(f[g]);
                        this.container.appendChild(this.video), this.log("createVideoElement done");
                    }
                    getAmpOptions() {
                        var _this_configProvider_playerConfig;
                        const g = [];
                        this.configProvider.config.debug ? g.push({
                            target: "memory",
                            maxMemoryTraceCount: this.maxMemoryTraceLogCount
                        }) : g.push({
                            target: "console"
                        });
                        const f = {
                            TraceTargets: g,
                            maxLogLevel: this.configProvider.config.debug ? 3 : 2
                        }, S = {
                            techOrder: [
                                "azureHtml5JS",
                                "html5"
                            ],
                            nativeControlsForTouch: !1,
                            autoplay: !0,
                            preload: "auto",
                            controls: !this.isControlsDisabled(),
                            logo: {
                                enabled: !1
                            },
                            height: "100%",
                            width: "100%",
                            traceConfig: f,
                            disableFullscreenButton: (_this_configProvider_playerConfig = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig === void 0 ? void 0 : _this_configProvider_playerConfig.disableFullscreenButton,
                            staleDataTimeLimitInSec: 30,
                            heuristicProfile: this.contextWindow.amp.Player.HeuristicProfile.HighQuality,
                            customPlayerSettings: {
                                customHeuristicSettings: {
                                    bandwidthTestWithTimeThresholdDuringLive: !1,
                                    windowSizeHeuristics: this.configProvider.config.ampSettings.useBrowserWindowSizeForBitRate,
                                    useBrowserWindowForWindowSizeRule: this.configProvider.config.ampSettings.useBrowserWindowSizeForBitRate,
                                    useVariableFragmentSizeMode: !0
                                }
                            },
                            plugins: {}
                        };
                        return this.initializePluginOptions(S), S;
                    }
                    isStreamValid(g) {
                        return g && !!g.url && !!g.decryptionToken;
                    }
                    initializePluginOptions(g) {
                        if (!this.sdnPluginLoaded || !this.liveStreamOptions.sdn) return;
                        const f = this.isStreamValid(this.liveStreamOptions.stream) ? this.liveStreamOptions.stream : this.liveStreamOptions.altStream;
                        this.log(`initializePluginOptions, receivedSDNContext: ${JSON.stringify(f === null || f === void 0 ? void 0 : f.sdnContext)}`, "info");
                        try {
                            const S = this.liveStreamOptions.correlationId || this.playerId;
                            switch(this.liveStreamOptions.sdn.name){
                                case "hive":
                                    if (g.plugins = {
                                        hive: {
                                            debugLevel: this.configProvider.config.debug ? "debug" : "notice",
                                            telemetryId: S
                                        }
                                    }, f && f.sdnContext) try {
                                        const S = JSON.parse(f.sdnContext);
                                        if (S.sdnConfig) {
                                            const f = JSON.parse(S.sdnConfig);
                                            f.candidateTopicName = "RequestIceCandidates", delete f.RTCIceCandidates, Object.assign(g.plugins.hive, f);
                                        }
                                    } catch (g) {
                                        this.log(`initializePluginOptions, failed to parse Hive sdnConfig Json from sdnContext Json, error: ${g}`, "warn");
                                    }
                                    break;
                                case "kollective":
                                    if (f && f.sdnContext) {
                                        let v = null, _ = null, C = null;
                                        try {
                                            v = this.parseJson(f.sdnContext, "kollective sdn context");
                                        } catch (g) {
                                            this.log(`initializePluginOptions, failed to parse Kollective sdnContext Json, error: ${g}`, "error");
                                        }
                                        if (v) {
                                            try {
                                                _ = this.parseJson(v.playbackinfo, "kollective sdn playback info");
                                            } catch (g) {
                                                this.log(`initializePluginOptions, failed to parse Kollective sdnContext playbackinfo Json, error: ${g}`, "error");
                                            }
                                            try {
                                                C = this.parseJson(v.sdnConfig, "kollective sdn config");
                                            } catch (g) {
                                                this.log(`initializePluginOptions, failed to parse Kollective sdnContext sdnConfig Json, error: ${g}`, "error");
                                            }
                                        }
                                        g.plugins = {
                                            kollectiveSDN: {
                                                playbackInfo: _,
                                                sdnConfig: C,
                                                reportSessionId: S
                                            }
                                        };
                                    }
                                    break;
                                case "ramp":
                                    f && f.sdnContext && (g.plugins = {
                                        RampMOPlugin: this.parseJson(f.sdnContext, "ramp sdn context")
                                    }, this.configProvider.config.debug && (g.plugins.RampMOPlugin.verbose = !0));
                                    break;
                                case "peer5":
                                    f.sdnContext && (g.plugins = {
                                        peer5: this.parseJson(f.sdnContext, "peer5 sdn context")
                                    });
                            }
                        } catch (g) {
                            this.log(`initializePluginOptions failed, error: ${g.message}`, "error");
                        }
                        this.log(`initializePluginOptions, configured plugin options: ${JSON.stringify(g.plugins)}`, "info");
                    }
                    getTextTracks() {
                        const g = [];
                        if (this.isControlsDisabled()) g.push({
                            id: "amp-player_default",
                            kind: "captions",
                            label: "default-text-track",
                            src: "",
                            srclang: "en"
                        });
                        else if (this.liveStreamOptions.supportedSubtitleLanguages) {
                            const f = this.liveStreamOptions.supportedSubtitleLanguages;
                            for(let S = 0; S < f.length; S++)g.push({
                                id: `amp-player_${f[S].culture}`,
                                kind: this.configProvider.config.textTrackKind,
                                label: f[S].name || f[S].culture,
                                src: "",
                                srclang: f[S].culture.substr(0, 2)
                            });
                        }
                        return g;
                    }
                    configureSdnSource(g, f) {
                        if (!this.sdnPluginLoaded || !this.liveStreamOptions.sdn) return;
                        switch(this.liveStreamOptions.sdn.name){
                            case "hive":
                                if (!f.sdnContext) {
                                    g.sdnList = [];
                                    break;
                                }
                                try {
                                    const S = JSON.parse(f.sdnContext);
                                    S.playbackinfo && (g.sdnList = [
                                        {
                                            sdnName: "hive",
                                            sdnUrl: S.playbackinfo
                                        }
                                    ]);
                                } catch (S) {
                                    g.sdnList = [
                                        {
                                            sdnName: "hive",
                                            sdnUrl: f.sdnContext
                                        }
                                    ];
                                }
                                break;
                            case "kollective":
                                if (!f.sdnContext) {
                                    g.sdnList = [];
                                    break;
                                }
                                try {
                                    const S = this.parseJson(f.sdnContext, "kollective sdn list context"), v = this.parseJson(S.playbackinfo, "kollective sdn list playback info"), _ = this.parseJson(S.sdnConfig, "kollective sdn list sdn config");
                                    g.sdnList = [
                                        {
                                            sdnName: "kollectiveSDN",
                                            playbackInfo: v,
                                            sdnConfig: _
                                        }
                                    ];
                                } catch (f) {
                                    return g.sdnList = [], void this.log(`configureSdnSource failed, error: ${f}`, "error");
                                }
                                break;
                            case "ramp":
                            case "peer5":
                                g.sdnList = [];
                                break;
                            default:
                                return;
                        }
                        this.log(`configureSdnSource, configured source context: ${JSON.stringify(g)}`, "info");
                    }
                    registerPlayerEvents() {
                        this.registerPlayerEvent(this.contextWindow.amp.eventName.error, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.error);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.canplaythrough, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.canplaythrough);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.play, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.play);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.playing, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.playing);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.pause, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.pause);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.resume, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.resume);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.start, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.start);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.ended, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.ended);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.seeking, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.seeking);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.seeked, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.seeked);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.loadedmetadata, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.loadedmetadata);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.waiting, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.waiting);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.playbackbitratechanged, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.playbackbitratechanged);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.downloadbitratechanged, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.downloadbitratechanged);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.fullscreenchange, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.fullscreenchange);
                        }), this.registerPlayerEvent("potentialMediaFreeze", ()=>{
                            this.onAmpEvent("potentialMediaFreeze");
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.mute, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.mute);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.unmute, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.unmute);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.volumechange, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.volumechange);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.loadeddata, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.loadeddata);
                        }), this.registerPlayerEvent(this.contextWindow.amp.eventName.loadstart, ()=>{
                            this.onAmpEvent(this.contextWindow.amp.eventName.loadstart);
                        }), Object.values(S).forEach((g)=>{
                            this.registerVideoEvent(g, (f)=>{
                                this.handleUserExperienceErrorEvent(g, f.detail.data.details, f.detail.data.fatal);
                            });
                        }), this.configProvider.config.ampSettings.collectUserInitiatedSeekEventsTelemetry && (this.playerEvents.push("currentTimeChanging"), this.playerInstance.addEventListener("currentTimeChanging", (g, f)=>this.onAmpCurrentTimeChangingEvent(g, f)));
                    }
                    onAmpCurrentTimeChangingEvent(g, f) {
                        if ("currentTimeChanging" !== g.type || !f.time) return;
                        const S = {
                            newCurrentPlayPosition: f.time
                        };
                        this.eventsHandler.message("stateChanged").send("UserInitiatedSeek", S);
                    }
                    registerPlayerEvent(g, f) {
                        this.playerEvents.push(g), this.playerInstance.addEventListener(g, f);
                    }
                    registerVideoEvent(g, f) {
                        this.videoElementEvents.push({
                            name: g,
                            callback: f
                        }), this.video.addEventListener(g, f);
                    }
                    removePlayerEventListeners() {
                        this.playerEvents.forEach((g)=>{
                            this.playerInstance.removeEventListener(g);
                        });
                    }
                    removeVideoEventListeners() {
                        this.videoElementEvents.forEach((g)=>{
                            this.video.removeEventListener(g.name, g.callback);
                        });
                    }
                    onAmpEvent(g) {
                        let f, S;
                        switch(g){
                            case this.contextWindow.amp.eventName.error:
                                S = this.playerInstance.error(), f = {
                                    currentTime: this.playerInstance.currentTime(),
                                    errorCode: S ? S.code : 0,
                                    message: S ? S.message : ""
                                };
                                break;
                            case this.contextWindow.amp.eventName.canplaythrough:
                                this.initializeStatsColletion();
                                break;
                            case this.contextWindow.amp.eventName.loadedmetadata:
                                this.captionsControl.initialize(), this.absoluteTimeOffsetEstimator && this.absoluteTimeOffsetEstimator.restartStreamAbsoluteTimeOffsetRetrieval();
                                break;
                            case this.contextWindow.amp.eventName.fullscreenchange:
                                f = {
                                    isFullscreen: this.playerInstance.isFullscreen()
                                };
                                break;
                            case this.contextWindow.amp.eventName.playbackbitratechanged:
                                f = {
                                    bitrate: this.playerInstance.currentPlaybackBitrate()
                                };
                                break;
                            case this.contextWindow.amp.eventName.downloadbitratechanged:
                                f = {
                                    bitrate: this.playerInstance.currentDownloadBitrate()
                                };
                                break;
                            case this.contextWindow.amp.eventName.seeked:
                                f = {
                                    captionsTimestamp: this.isControlsDisabled() ? this.playerInstance.currentMediaTime() : this.playerInstance.currentTime()
                                };
                                break;
                            case this.contextWindow.amp.eventName.volumechange:
                                f = {
                                    value: this.playerInstance.volume()
                                };
                        }
                        this.updatePlaybackDiagnostics(), this.updatePlayerState(g), this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()), this.eventsHandler.message("stateChanged").send(g, f);
                    }
                    updatePlayerState(g) {
                        this.updatePlayingState(g), this.updateBufferingState(g), this.updateCurrentVideoTrackBitrate(g), g !== this.contextWindow.amp.eventName.ended && g !== this.contextWindow.amp.eventName.error || this.handlePlaybackStopped();
                    }
                    handleUserExperienceErrorEvent(g, f, S) {
                        const v = {
                            currentTime: this.video ? this.video.currentTime : 0,
                            message: f,
                            type: g,
                            errorCode: 0,
                            fatal: S
                        };
                        this.updatePlaybackDiagnostics(), this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()), this.eventsHandler.message("stateChanged").send(this.contextWindow.amp.eventName.error, v);
                    }
                    updatePlayingState(g) {
                        this.isPlaying ? g !== this.contextWindow.amp.eventName.pause && g !== this.contextWindow.amp.eventName.seeking && g !== this.contextWindow.amp.eventName.ended && g !== this.contextWindow.amp.eventName.error && g !== this.contextWindow.amp.eventName.waiting || (this.isPlaying = !1) : g === this.contextWindow.amp.eventName.playing && (this.isPlaying = !0);
                    }
                    updateBufferingState(g) {
                        var _this_playerInstance_currentTechName;
                        this.isBuffering ? (g === this.contextWindow.amp.eventName.pause && "html5" === ((_this_playerInstance_currentTechName = this.playerInstance.currentTechName()) === null || _this_playerInstance_currentTechName === void 0 ? void 0 : _this_playerInstance_currentTechName.toLowerCase()) || g === this.contextWindow.amp.eventName.seeking || g === this.contextWindow.amp.eventName.ended || g === this.contextWindow.amp.eventName.error || g === this.contextWindow.amp.eventName.playing) && (this.isBuffering = !1) : g === this.contextWindow.amp.eventName.waiting && (this.isBuffering = !0);
                    }
                    updateCurrentVideoTrackBitrate(g) {
                        g === this.contextWindow.amp.eventName.playbackbitratechanged && this.playerInstance.currentPlaybackBitrate() !== this.currentVideoPlaybackBitrate && (this.currentVideoPlaybackBitrate = this.playerInstance.currentPlaybackBitrate(), this.updateVideoTrackHistoryStatistic());
                    }
                    initializeStatsColletion() {
                        this.diagnosticProvider.initialize(), this.statsTimer = window.setInterval(()=>{
                            this.eventsHandler && (this.updatePlaybackDiagnostics(), this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()));
                        }, this.statsInterval);
                    }
                    stopStatsCollection() {
                        this.updatePlaybackDiagnostics(), this.eventsHandler.message("statsUpdated").send(this.getPlayerDiagnostics()), -1 !== this.statsTimer && window.clearInterval(this.statsTimer), this.statsTimer = -1;
                    }
                    updateVideoTrackHistoryStatistic() {
                        const g = new Date;
                        if (this.currentVideoPlaybackBitrate) {
                            const f = this.diagnosticProvider.getValue("videoTrackHistory"), S = this.diagnosticProvider.getValue("videoTrackTotalDurations");
                            if (f.length > 0 && this.currentVideoPlaybackBitrate === f[f.length - 1].trackPlaybackBitrate) {
                                if (this.videoTrackHistoryUpdatedTimestamp) {
                                    this.latestVideoTrackDuration += (g.getTime() - this.videoTrackHistoryUpdatedTimestamp.getTime()) / 1e3, f[f.length - 1].durationInSeconds = Number(this.latestVideoTrackDuration.toFixed(0));
                                    const v = this.videoTrackTotalDurations.find((g)=>g.trackPlaybackBitrate === this.currentVideoPlaybackBitrate), _ = S.find((g)=>g.trackPlaybackBitrate === this.currentVideoPlaybackBitrate);
                                    v && _ && (v.totalDurationInSeconds += (g.getTime() - this.videoTrackHistoryUpdatedTimestamp.getTime()) / 1e3, _.totalDurationInSeconds = Number(v.totalDurationInSeconds.toFixed(0)));
                                }
                            } else {
                                const v = this.playerInstance.videoBufferData();
                                let _ = null;
                                v && v.perceivedBandwidth && (_ = v.perceivedBandwidth), f.push({
                                    trackPlaybackBitrate: this.currentVideoPlaybackBitrate,
                                    trackSwitchTimestamp: g.getTime(),
                                    trackSwitchMeasuredBandwidth: this.diagnosticProvider ? this.diagnosticProvider.getAverageMeasuredBandwidth() : null,
                                    trackSwitchMeasuredByteSize: this.diagnosticProvider ? this.diagnosticProvider.getAverageMeasuredVideoDownloadSize() : null,
                                    trackSwitchPerceivedBandwidth: _,
                                    durationInSeconds: 0
                                }), this.latestVideoTrackDuration = 0, f.length > this.configProvider.config.maxVideoTrackHistoryLogCount && f.splice(0, 1);
                                const C = this.videoTrackTotalDurations.find((g)=>g.trackPlaybackBitrate === this.currentVideoPlaybackBitrate);
                                if (!C) {
                                    const g = {
                                        trackPlaybackBitrate: this.currentVideoPlaybackBitrate,
                                        totalDurationInSeconds: 0
                                    }, f = {
                                        trackPlaybackBitrate: this.currentVideoPlaybackBitrate,
                                        totalDurationInSeconds: 0
                                    };
                                    this.videoTrackTotalDurations.push(g), S.push(f);
                                }
                            }
                        }
                        this.videoTrackHistoryUpdatedTimestamp = g;
                    }
                    updateTotalPlayingTimeStatistic() {
                        const g = new Date;
                        this.isPlaying && this.totalPlayingTimeUpdatedTimestamp && (this.totalPlayingTime += g.getTime() - this.totalPlayingTimeUpdatedTimestamp.getTime()), this.totalPlayingTimeUpdatedTimestamp = g, this.diagnosticProvider.setValue("totalPlayingTimeInSeconds", Number((this.totalPlayingTime / 1e3).toFixed(0)));
                    }
                    updateBufferingRateStatistic() {
                        const g = new Date;
                        this.isBuffering && this.bufferingRateStatUpdatedTimestamp && (this.totalBufferingTime += g.getTime() - this.bufferingRateStatUpdatedTimestamp.getTime()), this.bufferingRateStatUpdatedTimestamp = g;
                        const f = this.totalPlayingTime > 0 || this.totalBufferingTime > 0 ? this.totalBufferingTime / (this.totalPlayingTime + this.totalBufferingTime) : 0;
                        this.diagnosticProvider.setValue("bufferingRate", Number(f.toFixed(3)));
                    }
                    getPlayerDiagnostics() {
                        const g = this.diagnosticProvider.getPlayerDiagnosticSnapshot();
                        return g.statsInterval = this.statsInterval, this.configProvider.config.debug && (g.memoryLog = this.playerInstance.getMemoryLog(!0)), g;
                    }
                    log(g, f = "info") {
                        const S = `${`[AmpPlayer${1 === this.configProvider.config.loadType ? "IFrame" : ""}]`}: ${g}`;
                        this.configProvider.config.debug && console.log(S), this.eventsHandler.message("log").send(f, S);
                    }
                    getElementLoadPromise(g, f) {
                        return new Promise((S, v)=>{
                            g.onload = ()=>{
                                S("Element Load success");
                            }, g.onerror = ()=>{
                                v(`Failed to load script: ${f}`);
                            };
                        });
                    }
                    loadCss(g, f, S) {
                        const v = g.createElement("link"), _ = this.getElementLoadPromise(v, f);
                        return v.href = f, v.rel = "stylesheet", S && (v.nonce = S), g.head.appendChild(v), _;
                    }
                    parseJson(g, f) {
                        try {
                            return JSON.parse(g);
                        } catch (g) {
                            throw this.log(`Error parsing JSON for ${f}, error: ${JSON.stringify(g)}`), g;
                        }
                    }
                    constructor(g, f){
                        this.container = g, this.eventsHandler = f, this.videoElementEvents = [], this.playerEvents = [], this.maxMemoryTraceLogCount = 1e4, this.videoSourceType = "application/dash+xml", this.sdnPluginLoaded = !1, this.statsTimer = -1, this.statsInterval = 1e3, this.videoSourceSetAttemptCount = 0, this.totalBufferingTime = 0, this.isBuffering = !1, this.totalPlayingTime = 0, this.isPlaying = !1, this.videoTrackTotalDurations = [];
                    }
                };
            }
            AmpPlayerF();
            function AmpCommunicationHandlerF() {
                const g = AmpPlayerF();
                return class {
                    processMessage(g) {
                        if ("Command" === g.msgType) Promise.resolve().then(()=>this.amp[g.cmd].apply(this.amp, g.args)).then((f)=>{
                            this.pipe && this.pipe.sendMsg({
                                msgType: "CommandResult",
                                cmd: g.cmd,
                                result: JSON.stringify(f)
                            });
                        }).catch((f)=>{
                            this.pipe && this.pipe.sendMsg({
                                msgType: "CommandResult",
                                cmd: g.cmd,
                                error: f
                            });
                        });
                    }
                    message(g) {
                        return {
                            send: this.fromMessage((...f)=>{
                                this.sendMessageImpl(g, f);
                            })
                        };
                    }
                    ampDisposed() {
                        this.pipe.dispose(), this.pipe = null, this.amp = null;
                    }
                    fromMessage(g) {
                        return g;
                    }
                    sendMessageImpl(g, f) {
                        this.pipe.sendMsg({
                            msgType: "PlayerNotification",
                            name: g,
                            args: f
                        });
                    }
                    constructor(f, S){
                        this.pipe = f, this.amp = new g(S, this);
                    }
                };
            }
            var ht = AmpCommunicationHandlerF();
            function IFrameMessageHandlerF() {
                function isCmdResult(g) {
                    return "CommandResult" === g.msgType;
                }
                function getErrorString(g) {
                    let f = "unknown";
                    try {
                        f = "string" == typeof g ? g : "toString" in g && 0 !== g.toString().indexOf("[object") ? g.toString() : JSON.stringify(g);
                    } catch (f) {
                        console.error("Failed to stringify error", g);
                    }
                    return f;
                }
                return class {
                    sendMsg(g) {
                        try {
                            let f = g;
                            isCmdResult(g) && g.error instanceof Event && (console.debug("Stringifying error Event before trying to postMessage:", g), f = {
                                msgType: g.msgType,
                                cmd: g.cmd,
                                error: `Event: ${getErrorString(g.error)}`
                            }), this.postMessage(f);
                        } catch (f) {
                            console.error("Unexpected exception caught from postMessage.\n", "message:", g, "\n", "exception:", f);
                            const S = {
                                msgType: "PlayerNotification",
                                name: "log",
                                args: [
                                    "error",
                                    `Unexpected error with postMessage: ${getErrorString(f)}`
                                ]
                            };
                            throw this.postMessage(S), f;
                        }
                    }
                    registerObserver(g) {
                        this.observer = g;
                    }
                    dispose() {
                        window.removeEventListener("message", this.processMsg), this.observer = null;
                    }
                    processMsg(g) {
                        this.observer.processMessage(g.data);
                    }
                    postMessage(g) {
                        window.parent.postMessage(g, "*");
                    }
                    constructor(){
                        this.processMsg = this.processMsg.bind(this), window.addEventListener("message", this.processMsg);
                    }
                };
            }
            function HlsAbsoluteTimeOffsetEstimatorF() {
                const g = HlsFileParserF();
                return class {
                    get absoluteTimeOffset() {
                        return this.estimatedAbsoluteTimeOffset;
                    }
                    setEstimationResultCallback(g) {
                        this.onAbsoluteTimeOffsetEstimation = g;
                    }
                    restartStreamAbsoluteTimeOffsetRetrieval() {
                        this.stopStreamAbsoluteTimeOffsetRetrieval().then(()=>this.startStreamAbsoluteTimeOffsetRetrieval());
                    }
                    setManifestFileURL(g) {
                        this.cachedManifestUrl = g;
                    }
                    startStreamAbsoluteTimeOffsetRetrieval() {
                        this.playlistFileDownloadPromise = this.retryPlaylistFileDownload(()=>this.estimateStreamTimeFromPlaylist(this.currentManifestUrl)).then(()=>{
                            this.logFn(`Succeeded in downloading playlist files to estimate\n                    absolute stream time offset as: ${this.estimatedAbsoluteTimeOffset}`);
                        }).catch((g)=>{
                            this.logFn(`Failed to download playlist files to estimate absolute stream time offset: ${g.message}`, "error");
                        });
                    }
                    stopStreamAbsoluteTimeOffsetRetrieval() {
                        return this.playlistFileDownloadCancellationFlag = !0, this.playlistFileDownloadPromise.then(()=>{
                            this.playlistFileDownloadCancellationFlag = !1, this.currentManifestUrl = this.cachedManifestUrl, this.cachedManifestUrl = null;
                        });
                    }
                    retryPlaylistFileDownload(g, f = 0) {
                        let S = Promise.resolve();
                        return S = g().then(()=>(this.onAbsoluteTimeOffsetEstimation && this.onAbsoluteTimeOffsetEstimation({
                                timestamp: Date.now(),
                                retries: f,
                                isSuccess: !0,
                                absoluteTimeOffsetEstimation: this.absoluteTimeOffset
                            }), Promise.resolve())).catch((S)=>(f++, this.logFn(`Error loading playlist file: ${S} -- attempt ${f}`), this.onAbsoluteTimeOffsetEstimation && this.onAbsoluteTimeOffsetEstimation({
                                timestamp: Date.now(),
                                retries: f,
                                isSuccess: !1,
                                error: S.message
                            }), f === this.playlistFileDownloadMaxRetryCount ? Promise.reject(new Error(`${S} after ${f} attempts`)) : this.playlistFileDownloadCancellationFlag ? Promise.reject(new Error("cancelling playlist file download")) : new Promise((S)=>setTimeout(()=>S(this.retryPlaylistFileDownload(g, f)), this.playlistFileDownloadRetryWaitTime)))), S;
                    }
                    estimateStreamTimeFromPlaylist(g) {
                        return this.hlsFileParser.getStreamRenditionsUrlsFromManifest(g).then((f)=>{
                            if (0 === f.audioRenditions.length && 0 === f.videoRenditions.length) throw new Error(`Unable to retrieve renditions URLs from manifest: ${g}`);
                            return Promise.all([
                                f.videoRenditions.length > 0 ? this.hlsFileParser.getTextFileContent(f.videoRenditions[0]) : Promise.resolve(null),
                                f.audioRenditions.length > 0 ? this.hlsFileParser.getTextFileContent(f.audioRenditions[0]) : Promise.resolve(null)
                            ]);
                        }).then((g)=>{
                            let f;
                            for(let S = 0; S < g.length; S++){
                                const v = g[S];
                                if (v) {
                                    this.logFn("Using segment duration and sequence number to calculate absolute time offset", "debug");
                                    const g = this.hlsFileParser.getHlsFieldByName("SequenceNumber", v);
                                    if (0 == g.length) throw new Error("Unable to retrieve sequence number from playlist file");
                                    const S = this.hlsFileParser.getHlsFieldByName("SegmentDuration", v, 10);
                                    if (0 == S.length) throw new Error("Unable to retrieve segment durations from playlist file");
                                    const _ = S.map(Number);
                                    _.sort((g, f)=>g - f);
                                    const C = _[Math.floor(_.length / 2)], E = Number(g[0]) * Number(C);
                                    f = f ? Math.max(f, E) : E;
                                }
                            }
                            this.estimatedAbsoluteTimeOffset = f;
                        });
                    }
                    constructor(f){
                        this.playlistFileDownloadPromise = Promise.resolve(), this.playlistFileDownloadRetryWaitTime = 250, this.playlistFileDownloadMaxRetryCount = 20, this.playlistFileDownloadCancellationFlag = !1, this.logFn = (g, S)=>f(`[HlsAbsoluteTimeOffsetEstimator]: ${g}`, S), this.hlsFileParser = new g(f);
                    }
                };
            }
            var gt = HlsAbsoluteTimeOffsetEstimatorF();
            function HlsFileParserF() {
                return class {
                    getHlsFieldByName(g, f, S = 1) {
                        const v = [];
                        for(let _ = 1; _ <= S; _++){
                            const S = this.fieldNameRegexMap[g].exec(f);
                            if (!(S && S.length > 0)) break;
                            v.push(S[1]), f = f.substring(S.index + S[0].length);
                        }
                        return v;
                    }
                    getStreamRenditionsUrlsFromManifest(g) {
                        return g ? this.getTextFileContent(g).then((f)=>{
                            const S = {
                                audioRenditions: [],
                                videoRenditions: []
                            }, v = f.split("\n"), _ = this.getHlsFieldByName("BaseUrl", g);
                            for(let g = 0; g < v.length; g++)if (v[g].includes("#EXT-X-STREAM-INF")) {
                                const f = v[g + 1];
                                f.includes("http") ? S.videoRenditions.push(f) : _.length > 0 && S.videoRenditions.push(`${_[0]}/${f}`);
                            } else if (v[g].includes("EXT-X-MEDIA:TYPE")) {
                                const f = this.getHlsFieldByName("AudioManifestFile", v[g]);
                                if (f.length > 0) {
                                    const g = f[0];
                                    g.includes("http") ? S.audioRenditions.push(g) : _.length > 0 && S.audioRenditions.push(`${_[0]}/${g}`);
                                }
                            }
                            return S;
                        }).catch((g)=>(this.logFn(`Failed to extract stream renditions from manifest, error: ${g.message}`, "error"), {
                                audioRenditions: [],
                                videoRenditions: []
                            })) : (this.logFn("No manifest URL provided to parse"), Promise.resolve({
                            audioRenditions: [],
                            videoRenditions: []
                        }));
                    }
                    getTextFileContent(g) {
                        const f = fetch(g).then((f)=>{
                            if (!f.ok) throw new Error(`http-error ${f.status} when downloading: ${g}`);
                            return f.text();
                        }).catch((g)=>(this.logFn(`Error downloading resource: ${g}`, "error"), Promise.reject(g)));
                        return f;
                    }
                    constructor(g){
                        this.fieldNameRegexMap = {
                            BaseUrl: /(.*)\/.*/,
                            AudioManifestFile: /#EXT-X-MEDIA:TYPE=AUDIO.*URI=\"(.*)\"/,
                            SequenceNumber: /#EXT-X-MEDIA-SEQUENCE:(\d+)/,
                            SegmentDuration: /#EXTINF:(\d+(\.\d+)?)/
                        }, this.logFn = (f, S)=>g(`[HlsFileParser]: ${f}`, S);
                    }
                };
            }
            function AmpDiagnosticProviderF() {
                return class {
                    initialize() {
                        this.playerVideoBuffer = this.playerInstance.videoBufferData(), this.playerAudioBuffer = this.playerInstance.audioBufferData(), this.registerForPlayerBufferEvents();
                    }
                    setValue(g, f) {
                        this.currentDiagnosticSnapshot[g] = f;
                    }
                    getValue(g) {
                        return this.currentDiagnosticSnapshot[g];
                    }
                    appendAbsoluteTimeOffsetEstimation(g) {
                        this.absoluteTimeOffsetEstimationResults.push(g), this.absoluteTimeOffsetEstimationResults.length > this.configProvider.config.ampSettings.maxAbsoluteTimeOffsetEstimationResultsLogCount && this.absoluteTimeOffsetEstimationResults.splice(0, 1);
                    }
                    getPlayerDiagnosticSnapshot() {
                        if (!this.playerInstance) return null;
                        const g = window.screen, f = this.playerInstance.error(), mean5 = (g)=>{
                            const f = g.slice().sort();
                            return f[Math.floor(f.length / 2)];
                        };
                        var _this_playerInstance_currentMediaTime;
                        this.currentDiagnosticSnapshot.errorCode = f && f.code || 0, this.currentDiagnosticSnapshot.currentPlayPosition = this.playerInstance.currentTime(), this.currentDiagnosticSnapshot.currentMediaTime = (_this_playerInstance_currentMediaTime = this.playerInstance.currentMediaTime()) !== null && _this_playerInstance_currentMediaTime !== void 0 ? _this_playerInstance_currentMediaTime : this.playerInstance.currentTime(), this.currentDiagnosticSnapshot.currentAbsoluteTime = this.getCurrentAbsoluteTime(), this.currentDiagnosticSnapshot.absoluteTimeOffsetEstimationResults = this.absoluteTimeOffsetEstimationResults, this.currentDiagnosticSnapshot.estimatedAbsoluteTimeOffset = this.getCurrentAbsoluteTimeOffset(), this.currentDiagnosticSnapshot.playbackBitrate = this.playerInstance.currentPlaybackBitrate(), this.currentDiagnosticSnapshot.downloadBitrate = this.playerInstance.currentDownloadBitrate(), this.currentDiagnosticSnapshot.audioDownloadBitrate = this.lastAudioDownloadBitrate, this.currentDiagnosticSnapshot.perceivedBandwidth = this.playerVideoBuffer ? this.playerVideoBuffer.perceivedBandwidth : 0, this.currentDiagnosticSnapshot.tech = this.playerInstance.currentTechName(), this.currentDiagnosticSnapshot.playerVersion = this.playerInstance.getAmpVersion(), this.currentDiagnosticSnapshot.isP2PSdnUsed = this.isP2PSdnUsed(), this.currentDiagnosticSnapshot.sdnName = this.sdnName(), this.currentDiagnosticSnapshot.heuristicProfile = this.playerInstance.currentHeuristicProfile(), this.currentDiagnosticSnapshot.encryption = this.playerInstance.currentProtectionInfo() ? this.playerInstance.currentProtectionInfo().type : "", this.currentDiagnosticSnapshot.streamType = this.getStreamType(this.currentDiagnosticSnapshot.streamType), this.currentDiagnosticSnapshot.totalDurationInSeconds = this.getTotalDurationInSeconds(), this.currentDiagnosticSnapshot.audioStream = this.getAudioStreamData(), this.currentDiagnosticSnapshot.videoStream = this.getVideoStreamData(), this.currentDiagnosticSnapshot.muted = this.playerInstance.muted(), this.currentDiagnosticSnapshot.volume = this.playerInstance.volume(), this.currentDiagnosticSnapshot.playbackRate = this.playerInstance.playbackRate();
                        const S = this.getPlayerCachedLength(), v = this.getPlayerEdgeLatency();
                        this.currentDiagnosticSnapshot.audioBufferLength = this.playerAudioBuffer ? this.playerAudioBuffer.bufferLevel : 0, this.currentDiagnosticSnapshot.audioCachedLength = S, this.currentDiagnosticSnapshot.audioEdgeLatency = v, this.currentDiagnosticSnapshot.videoBufferLength = this.playerVideoBuffer ? this.playerVideoBuffer.bufferLevel : 0, this.currentDiagnosticSnapshot.videoCachedLength = S, this.currentDiagnosticSnapshot.videoEdgeLatency = v, this.currentDiagnosticSnapshot.livePosition = this.getLivePosition(), this.currentDiagnosticSnapshot.mediaHeight = this.playerInstance.videoHeight(), this.currentDiagnosticSnapshot.mediaWidth = this.playerInstance.videoWidth(), this.currentDiagnosticSnapshot.playerHeight = this.playerInstance.height(), this.currentDiagnosticSnapshot.playerWidth = this.playerInstance.width(), this.currentDiagnosticSnapshot.windowHeight = g ? g.height : 0, this.currentDiagnosticSnapshot.windowWidth = g ? g.width : 0, this.currentDiagnosticSnapshot.isFullscreen = this.playerInstance.isFullscreen(), this.currentDiagnosticSnapshot.avgAudioDownloadLatency = mean5(this.audioDownloadLatencies), this.currentDiagnosticSnapshot.avgVideoDownloadLatency = mean5(this.videoDownloadLatencies), this.currentDiagnosticSnapshot.avgAudioDownloadBytes = mean5(this.audioDownloadBytes), this.currentDiagnosticSnapshot.avgVideoDownloadBytes = mean5(this.videoDownloadBytes), this.currentDiagnosticSnapshot.maxVideoDownloadBytes = Math.max.apply(null, this.videoDownloadBytes), this.currentDiagnosticSnapshot.minVideoDownloadBytes = Math.min.apply(null, this.videoDownloadBytes), this.currentDiagnosticSnapshot.avgAudioDownloadBandwidth = mean5(this.audioDownloadBandwidths), this.currentDiagnosticSnapshot.avgVideoDownloadBandwidth = mean5(this.videoDownloadBandwidths), this.currentDiagnosticSnapshot.audioDownloadFailureCount = this.audioDownloadFailureCount, this.currentDiagnosticSnapshot.audioDownloadSuccessCount = this.audioDownloadSuccessCount, this.currentDiagnosticSnapshot.videoDownloadFailureCount = this.videoDownloadFailureCount, this.currentDiagnosticSnapshot.videoDownloadSuccessCount = this.videoDownloadSuccessCount, this.currentDiagnosticSnapshot.audioDownloadFailures = this.audioDownloadFailures, this.currentDiagnosticSnapshot.videoDownloadFailures = this.videoDownloadFailures, this.currentDiagnosticSnapshot.totalDownloadedBytes = this.totalDownloadedBytes, this.currentDiagnosticSnapshot.retryFrequency = this.getRetryFrequency(), this.currentDiagnosticSnapshot.averageDownloadBitrate = this.getAverageDownloadBitrate();
                        const _ = this.getDiagnosticWritableField();
                        return Object.keys(_).forEach((g)=>{
                            this.currentDiagnosticSnapshot[g] = _[g];
                        }), this.currentDiagnosticSnapshot;
                    }
                    getDiagnosticWritableField() {
                        return {
                            streamUrl: this.currentDiagnosticSnapshot.streamUrl,
                            streamId: this.currentDiagnosticSnapshot.streamId,
                            streamingEventType: this.currentDiagnosticSnapshot.streamingEventType,
                            playerControlsEnabled: this.currentDiagnosticSnapshot.playerControlsEnabled,
                            streamDeliveryPipeline: this.currentDiagnosticSnapshot.streamDeliveryPipeline,
                            retryCount: this.currentDiagnosticSnapshot.retryCount,
                            totalPlayingTimeInSeconds: this.currentDiagnosticSnapshot.totalPlayingTimeInSeconds,
                            bufferingRate: this.currentDiagnosticSnapshot.bufferingRate,
                            videoTrackHistory: this.currentDiagnosticSnapshot.videoTrackHistory,
                            videoTrackTotalDurations: this.currentDiagnosticSnapshot.videoTrackTotalDurations,
                            eventId: this.currentDiagnosticSnapshot.eventId || "",
                            templateId: this.currentDiagnosticSnapshot.templateId || ""
                        };
                    }
                    dispose() {
                        this.unsubscribeFromPlayerBufferEvents();
                    }
                    registerForPlayerBufferEvents() {
                        this.playerVideoBuffer && (this.playerVideoBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted, this.onVideoDownloadCompleted), this.playerVideoBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed, this.onVideoDownloadError)), this.playerAudioBuffer && (this.playerAudioBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted, this.onAudioDownloadCompleted), this.playerAudioBuffer.addEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed, this.onAudioDownloadError));
                    }
                    unsubscribeFromPlayerBufferEvents() {
                        this.playerVideoBuffer && (this.playerVideoBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted, this.onVideoDownloadCompleted), this.playerVideoBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed, this.onVideoDownloadError)), this.playerAudioBuffer && (this.playerAudioBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadcompleted, this.onAudioDownloadCompleted), this.playerAudioBuffer.removeEventListener(this.contextWindow.amp.bufferDataEventName.downloadfailed, this.onAudioDownloadError));
                    }
                    isP2PSdnUsed() {
                        return !!this.sdnName();
                    }
                    sdnName() {
                        const g = "options_";
                        return this.playerInstance[g] && this.playerInstance[g].sdn && this.playerInstance[g].sdn.name;
                    }
                    getStreamType(g) {
                        let f = "";
                        return this.playerInstance && (f = this.playerInstance.isLive() ? "LIVE" : "DVR"), "" === f || "LIVE" === g && f !== g ? g || "" : f;
                    }
                    getCurrentAbsoluteTime() {
                        var _this_playerInstance_currentAbsoluteTime;
                        return this.absoluteTimeOffsetEstimator ? this.absoluteTimeOffsetEstimator.absoluteTimeOffset ? this.absoluteTimeOffsetEstimator.absoluteTimeOffset + this.playerInstance.currentTime() : this.playerInstance.currentTime() : (_this_playerInstance_currentAbsoluteTime = this.playerInstance.currentAbsoluteTime()) !== null && _this_playerInstance_currentAbsoluteTime !== void 0 ? _this_playerInstance_currentAbsoluteTime : this.playerInstance.currentTime();
                    }
                    getCurrentAbsoluteTimeOffset() {
                        return this.getCurrentAbsoluteTime() - this.playerInstance.currentTime();
                    }
                    getTotalDurationInSeconds() {
                        const g = ((new Date).getTime() - this.streamingStartedTimestamp.getTime()) / 1e3;
                        return Number(g.toFixed(0));
                    }
                    onVideoDownloadCompleted() {
                        this.videoDownloadSuccessCount++, this.addToList(this.videoDownloadLatencies, this.playerVideoBuffer.downloadCompleted.totalDownloadMs, this.slidingWindowLengthForLatency), this.addToList(this.videoDownloadBytes, this.playerVideoBuffer.downloadCompleted.totalBytes, this.slidingWindowLengthForDownloadBytes), this.addToList(this.videoDownloadBandwidths, 8 * this.playerVideoBuffer.downloadCompleted.totalBytes * 1e3 / this.playerVideoBuffer.downloadCompleted.totalDownloadMs, this.slidingWindowLengthForDownloadBandwidth), this.totalDownloadedBytes += this.playerVideoBuffer.downloadCompleted.totalBytes;
                    }
                    onAudioDownloadCompleted() {
                        this.audioDownloadSuccessCount++, this.addToList(this.audioDownloadLatencies, this.playerAudioBuffer.downloadCompleted.totalDownloadMs, this.slidingWindowLengthForLatency), this.addToList(this.audioDownloadBytes, this.playerAudioBuffer.downloadCompleted.totalBytes, this.slidingWindowLengthForDownloadBytes), this.addToList(this.audioDownloadBandwidths, 8 * this.playerAudioBuffer.downloadCompleted.totalBytes * 1e3 / this.playerAudioBuffer.downloadCompleted.totalDownloadMs, this.slidingWindowLengthForDownloadBandwidth), this.totalDownloadedBytes += this.playerAudioBuffer.downloadCompleted.totalBytes;
                        const g = this.playerAudioBuffer.downloadCompleted.mediaDownload.bitrate;
                        g !== this.lastAudioDownloadBitrate && (this.lastAudioDownloadBitrate = g);
                    }
                    addToList(g, f, S) {
                        g.push(f), g.length > S && g.shift();
                    }
                    onVideoDownloadError() {
                        this.videoDownloadFailureCount++, this.addDownloadFailureInfo(this.playerVideoBuffer.downloadFailed, this.videoDownloadFailures);
                    }
                    onAudioDownloadError() {
                        this.audioDownloadFailureCount++, this.addDownloadFailureInfo(this.playerAudioBuffer.downloadFailed, this.audioDownloadFailures);
                    }
                    addDownloadFailureInfo(g, f) {
                        const S = {
                            bitrate: g.mediaDownload.bitrate,
                            errorCode: g.code,
                            mediaTime: g.mediaDownload.mediaTime,
                            message: g.message,
                            timestamp: Date.now()
                        };
                        this.addToList(f, S, this.downloadFailuresLimit);
                    }
                    getAudioStreamData() {
                        const g = this.playerInstance.currentAudioStreamList();
                        if (g) try {
                            const f = g.streams[g.enabledIndices[0]];
                            return {
                                bitrate: f.bitrate,
                                codec: f.codec,
                                enabled: f.enabled,
                                name: f.name,
                                language: f.language
                            };
                        } catch (g) {
                            return;
                        }
                    }
                    getVideoStreamData() {
                        const g = this.playerInstance.currentVideoStreamList();
                        if (g) try {
                            const f = g.streams[g.selectedIndex], S = this.playerInstance.currentPlaybackBitrate(), mapTrackData = (g)=>({
                                    bitrate: g.bitrate,
                                    height: g.height,
                                    id: g.id,
                                    selectable: g.selectable,
                                    width: g.width
                                }), v = f.tracks ? f.tracks.map(mapTrackData).find((g)=>g.bitrate === S) : null;
                            return {
                                codec: f.codec,
                                name: f.name,
                                currentTrack: v
                            };
                        } catch (g) {
                            return;
                        }
                    }
                    getLivePosition() {
                        const g = this.playerInstance.buffered();
                        if (0 === g.length) return 0;
                        let f = g.end(0);
                        for(let S = 1; S < g.length; S++)f = Math.max(f, g.end(S));
                        return f;
                    }
                    getAverageDownloadBitrate() {
                        if (this.streamingStartedTimestamp && this.totalDownloadedBytes) {
                            const g = ((new Date).getTime() - this.streamingStartedTimestamp.getTime()) / 1e3;
                            if (g > 0) return 8 * this.totalDownloadedBytes / g;
                        }
                        return 0;
                    }
                    getRetryFrequency() {
                        const g = this.currentDiagnosticSnapshot.retryCount;
                        if (this.streamingStartedTimestamp && g) {
                            const f = ((new Date).getTime() - this.streamingStartedTimestamp.getTime()) / 6e4;
                            if (f > 0) return g / f;
                        }
                        return 0;
                    }
                    getAverageMeasuredBandwidth() {
                        if (0 === this.videoDownloadBandwidths.length) return null;
                        let g = 0;
                        for(let f = 0; f < this.videoDownloadBandwidths.length; f++)g += this.videoDownloadBandwidths[f];
                        return g / this.videoDownloadBandwidths.length;
                    }
                    getAverageMeasuredVideoDownloadSize() {
                        if (0 === this.videoDownloadBytes.length) return null;
                        let g = 0;
                        for(let f = 0; f < this.videoDownloadBytes.length; f++)g += this.videoDownloadBytes[f];
                        return g / this.videoDownloadBytes.length;
                    }
                    getPlayerCachedLength() {
                        const g = this.playerInstance.buffered();
                        let f = 0;
                        for(let S = 0; S < g.length; S++)f += g.end(S) - g.start(S);
                        return f;
                    }
                    getPlayerEdgeLatency() {
                        const g = this.playerInstance.buffered();
                        if (0 === g.length) return 0;
                        let f = g.end(0);
                        for(let S = 1; S < g.length; S++)f = Math.max(f, g.end(S));
                        return f - this.playerInstance.currentTime();
                    }
                    constructor(g, f, S, v, _){
                        this.playerInstance = g, this.contextWindow = f, this.streamingStartedTimestamp = S, this.configProvider = v, this.absoluteTimeOffsetEstimator = _, this.currentDiagnosticSnapshot = {
                            playerType: 0,
                            currentPlayPosition: null,
                            tech: null,
                            perceivedBandwidth: null,
                            playerHeight: null,
                            playerWidth: null,
                            mediaHeight: null,
                            mediaWidth: null,
                            windowHeight: null,
                            windowWidth: null,
                            videoStream: null,
                            audioStream: null,
                            totalDurationInSeconds: null,
                            avgVideoDownloadLatency: null,
                            avgAudioDownloadLatency: null,
                            avgVideoDownloadBytes: null,
                            avgAudioDownloadBytes: null,
                            avgAudioDownloadBandwidth: null,
                            avgVideoDownloadBandwidth: null,
                            maxVideoDownloadBytes: null,
                            minVideoDownloadBytes: null,
                            videoDownloadSuccessCount: null,
                            audioDownloadSuccessCount: null,
                            videoDownloadFailureCount: null,
                            audioDownloadFailureCount: null,
                            videoBufferLength: null,
                            videoCachedLength: null,
                            audioBufferLength: null,
                            audioCachedLength: null,
                            videoEdgeLatency: null,
                            audioEdgeLatency: null,
                            playbackRate: null,
                            playbackBitrate: null,
                            downloadBitrate: null,
                            audioDownloadBitrate: null,
                            audioPlaybackBitrate: null,
                            isFullscreen: null,
                            streamType: null,
                            playerVersion: null,
                            isP2PSdnUsed: null,
                            sdnName: null,
                            livePosition: null,
                            muted: null,
                            volume: null,
                            errorCode: null,
                            currentMediaTime: null,
                            currentAbsoluteTime: null,
                            absoluteTimeOffsetEstimationResults: null,
                            estimatedAbsoluteTimeOffset: null,
                            videoDownloadFailures: null,
                            audioDownloadFailures: null,
                            heuristicProfile: null,
                            encryption: null,
                            retryFrequency: null,
                            averageDownloadBitrate: null,
                            totalDownloadedBytes: 0,
                            streamId: null,
                            streamUrl: null,
                            streamingEventType: null,
                            playerControlsEnabled: null,
                            streamDeliveryPipeline: null,
                            retryCount: 0,
                            totalPlayingTimeInSeconds: 0,
                            bufferingRate: 0,
                            videoTrackHistory: [],
                            videoTrackTotalDurations: [],
                            memoryLog: null,
                            statsInterval: null
                        }, this.videoDownloadLatencies = [], this.audioDownloadLatencies = [], this.audioDownloadBytes = [], this.videoDownloadBytes = [], this.audioDownloadBandwidths = [], this.videoDownloadBandwidths = [], this.videoDownloadSuccessCount = 0, this.audioDownloadSuccessCount = 0, this.videoDownloadFailureCount = 0, this.audioDownloadFailureCount = 0, this.audioDownloadFailures = [], this.videoDownloadFailures = [], this.totalDownloadedBytes = 0, this.slidingWindowLengthForLatency = 5, this.slidingWindowLengthForDownloadBytes = 30, this.slidingWindowLengthForDownloadBandwidth = 10, this.absoluteTimeOffsetEstimationResults = [], this.downloadFailuresLimit = 10, this.onAudioDownloadCompleted = this.onAudioDownloadCompleted.bind(this), this.onAudioDownloadError = this.onAudioDownloadError.bind(this), this.onVideoDownloadCompleted = this.onVideoDownloadCompleted.bind(this), this.onVideoDownloadError = this.onVideoDownloadError.bind(this);
                    }
                };
            }
            function CaptionsControlToggleProviderF() {
                return class {
                    dispose() {
                        this.unsubscribeFromTrackEvents(), this.player = null, this.toggleListener = null;
                    }
                    initialize() {
                        const g = this.getPlayerTextTracksAsArray();
                        if (!this.config.controlsEnabled && g.length > 0) g[0].mode = "showing";
                        else for(let f = 0; f < g.length; f++)g[f].mode = "disabled";
                        this.subscribeOnTrackEvents();
                    }
                    addCues(g) {
                        const f = this.player.getCurrentTextTrack();
                        if (!f) return;
                        const S = this.getCurrentAbsoluteTime() || 1, v = this.getCurrentTime(), _ = this.config.controlsEnabled ? S - v : Math.max(S - v, 0), C = this.isHtml5Tech ? window.VTTCue : window.vttjs && window.vttjs.VTTCue || window.VTTCue;
                        for(let S = 0; S < g.length; S++){
                            const { start: v, end: E, text: T } = g[S], I = 2, b = new C(Number((v - _).toFixed(I)), Number((E - _).toFixed(I)), T);
                            b.size = 100, !this.containsCue(f, b) && f.addCue(b);
                        }
                    }
                    clearCues() {
                        const g = this.player.getCurrentTextTrack();
                        if (g) try {
                            if (g.activeCues && g.removeCue) for(; g.activeCues.length > 0;)g.removeCue(g.activeCues[0]);
                            const f = "setCues_";
                            if (g.cues[f]) {
                                g.cues_ && (g.cues_.length = 0), g.cues[f]([]);
                                const S = Object.getOwnPropertyNames(g.cues);
                                for(let f = 0; f < S.length; f++)"length" !== S[f] && "length_" !== S[f] && "cues_" !== S[f] && delete g.cues[S[f]];
                            }
                        } catch (g) {
                            this.config.logFn(`[clearCues]: ${g}`, "warn");
                        }
                    }
                    showCaptions(g) {
                        this.config.logFn(`[CaptionsControl]: showCaptions(${g})`), g ? this.show() : this.hide();
                    }
                    hide() {
                        this.previouslyVisibleTextTrack = this.player.getCurrentTextTrack(), this.previouslyVisibleTextTrack && (this.previouslyVisibleTextTrack.mode = "disabled"), this.player.captionToggle && this.player.captionToggle.hide && this.player.captionToggle.hide(), this.player.MoreOptionscaptionSubtitleButton && this.player.MoreOptionscaptionSubtitleButton.hide && this.player.MoreOptionscaptionSubtitleButton.hide(), this.player.MoreOptionscaptionSettingsButton && this.player.MoreOptionscaptionSettingsButton.hide && this.player.MoreOptionscaptionSettingsButton.hide();
                    }
                    show() {
                        this.previouslyVisibleTextTrack && (this.previouslyVisibleTextTrack.mode = "showing"), this.player.captionToggle && this.player.captionToggle.show && this.player.captionToggle.show(), this.player.MoreOptionscaptionSubtitleButton && this.player.MoreOptionscaptionSubtitleButton.show && this.player.MoreOptionscaptionSubtitleButton.show(), this.player.MoreOptionscaptionSettingsButton && this.player.MoreOptionscaptionSettingsButton.show && this.player.MoreOptionscaptionSettingsButton.show();
                    }
                    subscribeOnTrackEvents() {
                        const g = this.player.textTracks(), f = "addEventListener";
                        g && g[f] && (this.config.controlsEnabled && g[f]("change", this.onTextTrackChanged), this.isHtml5Tech && this.config.removeEmptyDefaultTextTrack && g[f]("addtrack", this.onAddTrack.bind(this)));
                    }
                    unsubscribeFromTrackEvents() {
                        const g = this.player.textTracks(), f = "removeEventListener";
                        g && g[f] && (this.config.controlsEnabled && g[f]("change", this.onTextTrackChanged), this.isHtml5Tech && this.config.removeEmptyDefaultTextTrack && g[f]("addtrack", this.onAddTrack.bind(this)));
                    }
                    onTextTrackChanged() {
                        const g = this.player.getCurrentTextTrack();
                        if (!g || !this.currentTextTrack || this.currentTextTrack.label !== g.label || this.currentTextTrack.mode !== g.mode) {
                            if (g || this.currentTextTrack) {
                                const f = !!g && "showing" === g.mode, S = this.getCulture(g || this.currentTextTrack), v = this.getCurrentTime();
                                this.toggleListener.captionsToggled(f, S, v), this.config.logFn(`[CaptionsControl]: track changed: culture '${S}', timestamp '${v}'`);
                            }
                            this.currentTextTrack = g;
                        }
                    }
                    onAddTrack(g) {
                        var _this_player_textTracks_, _this_player;
                        const f = g === null || g === void 0 ? void 0 : g.track;
                        "captions" === (f === null || f === void 0 ? void 0 : f.kind) && !f.label && !f.id && ((_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_textTracks_ = _this_player.textTracks_) === null || _this_player_textTracks_ === void 0 ? void 0 : _this_player_textTracks_.removeTrack_(f), this.config.logFn("[CaptionsControl]: removing default empty text track"));
                    }
                    getCurrentTime() {
                        return this.isHtml5Tech ? this.player.currentTime() : (this.config.controlsEnabled ? this.player.currentTime() : this.player.currentMediaTime()) || 1;
                    }
                    getCurrentAbsoluteTime() {
                        return this.diagnosticProvider.getCurrentAbsoluteTime();
                    }
                    getCulture(g) {
                        if (!g) return "";
                        if (g.id) {
                            const f = g.id.split("_")[1];
                            if (f) return f;
                        }
                        return "";
                    }
                    getPlayerTextTracksAsArray() {
                        const g = this.player.textTracks();
                        return g && g["tracks_"] || [];
                    }
                    containsCue(g, f) {
                        return Array.from((g === null || g === void 0 ? void 0 : g.cues) || []).some((g)=>this.areCueEquals(g, f));
                    }
                    areCueEquals(g, f) {
                        function getCueField(g) {
                            return {
                                start: g.start ? g.start : g.startTime,
                                end: g.end ? g.end : g.endTime,
                                text: g.text
                            };
                        }
                        const S = getCueField(g), v = getCueField(f);
                        return S.start === v.start && S.end === v.end && S.text === v.text;
                    }
                    constructor(g, f, S, v){
                        var _this_player_currentTechName;
                        this.player = g, this.toggleListener = f, this.config = S, this.diagnosticProvider = v, this.onTextTrackChanged = this.onTextTrackChanged.bind(this), this.isHtml5Tech = "html5" === ((_this_player_currentTechName = this.player.currentTechName()) === null || _this_player_currentTechName === void 0 ? void 0 : _this_player_currentTechName.toLowerCase());
                    }
                };
            }
            function initIFrame() {
                const g = IFrameMessageHandlerF(), f = AmpCommunicationHandlerF(), S = new g, v = new f(S, document.body);
                S.registerObserver(v);
            }
            function buildAmpEmbeddedSrc() {
                let g = `(${initIFrame.toString()})();`;
                return g += AmpPlayerF.toString() + ";", g += IFrameMessageHandlerF.toString() + ";", g += AmpCommunicationHandlerF.toString() + ";", g += CaptionsControlToggleProviderF.toString() + ";", g += AmpDiagnosticProviderF.toString() + ";", g += HlsAbsoluteTimeOffsetEstimatorF.toString() + ";", g += HlsFileParserF.toString() + ";", g += "//# sourceURL=TsCallingAmpPlayer.js", g;
            }
            var pt = class {
                sendMsg(g) {
                    this.peer.onMsg(g);
                }
                registerObserver(g) {
                    this.observer = g;
                }
                onMsg(g) {
                    this.observer && this.observer.processMessage(g);
                }
                connect(g) {
                    this.peer = g;
                }
                dispose() {
                    this.peer = null, this.observer = null;
                }
            }, mt = class {
                get contextWindow() {
                    return this.container.ownerDocument.defaultView;
                }
                sendMsg(g) {
                    var _this_iframe_contentWindow, _this_iframe;
                    (_this_iframe = this.iframe) === null || _this_iframe === void 0 ? void 0 : (_this_iframe_contentWindow = _this_iframe.contentWindow) === null || _this_iframe_contentWindow === void 0 ? void 0 : _this_iframe_contentWindow.postMessage(g, "*");
                }
                registerObserver(g) {
                    this.observer = g;
                }
                dispose() {
                    this.contextWindow && this.contextWindow.removeEventListener("message", this.processMsg), this.iframe && this.container.hasChildNodes() && this.container.removeChild(this.iframe), this.iframe = null;
                }
                initializeAmpIframe(g) {
                    const f = this.initializeIframe();
                    return this.setAmpIframeContent(g), this.finalizeIframe(f);
                }
                initializeIframe() {
                    const g = new ct;
                    return this.iframe = this.container.ownerDocument.createElement("iframe"), this.iframe.id = "player-iframe", this.iframe.sandbox.add("allow-scripts"), this.iframe.allowFullscreen = !0, this.iframe.allow = "camera; microphone; autoplay", this.iframe.style.height = "100%", this.iframe.style.width = "100%", this.iframe.style.border = "none", this.iframe.onload = ()=>{
                        g.resolve();
                    }, this.iframe.onerror = ()=>{
                        g.reject("iframe load failed");
                    }, g;
                }
                finalizeIframe(g) {
                    return this.container.appendChild(this.iframe), this.processMsg = this.processMsg.bind(this), this.contextWindow.addEventListener("message", this.processMsg), g.promise;
                }
                processMsg(g) {
                    if ("null" === g.origin && g.source === this.iframe.contentWindow && this.observer) {
                        if ("RequestIceCandidates" === g.data) this.observer.processMessage({
                            msgType: "Command",
                            cmd: "getIceCandidates",
                            args: []
                        });
                        else this.observer.processMessage(g.data);
                    }
                }
                setAmpIframeContent(g) {
                    const f = buildAmpEmbeddedSrc(), S = `\n            <html class style='height: 100%; width: 100%; overflow: hidden'>\n            <head></head>\n            <body class style='height: 100%; width: 100%; margin: 0px'>\n                ${g ? `<script nonce='${g}'> ${f}<\/script>` : `<script> ${f}<\/script>`}\n            </body>\n            </html>\n        `;
                    this.iframe.srcdoc = S;
                }
                constructor(g){
                    this.container = g;
                }
            };
            async function setupAmpAndBuildPipe(g, f, S) {
                if (0 === f) {
                    const f = new pt, S = new pt;
                    return f.connect(S), S.connect(f), S.registerObserver(new ht(S, g)), f;
                }
                if (1 === f) {
                    const f = new mt(g);
                    return await f.initializeAmpIframe(S), f;
                }
                throw new Error(`Unsupported communication type ${f}`);
            }
            var ft = class extends ze {
                async initialize(g, f, S, v) {
                    var _S_playerConfig;
                    const _ = {
                        config: S.config,
                        playerConfig: S.playerConfig
                    }, C = ((_S_playerConfig = S.playerConfig) === null || _S_playerConfig === void 0 ? void 0 : _S_playerConfig.nonce) || "";
                    this.pipe = await setupAmpAndBuildPipe(g, S.config.loadType, C), this.pipe.registerObserver(this), await this.message("configure").send(f, _, v);
                }
                message(g) {
                    return {
                        send: this.fromMessage((...f)=>this.sendMessageImpl(g, ...f))
                    };
                }
                dispose() {
                    super.dispose(), this.pipe.sendMsg(this.buildMsg("dispose")), this.pipe.dispose();
                }
                processMessage(g) {
                    let f;
                    switch(g.msgType){
                        case "CommandResult":
                            f = this.getDeferred(g.cmd.toString()), f && (g.error ? (f.reject(g.error), this.logger.warn(`remote command failed: ${String(g.cmd)}, ${g.error}`)) : g.result ? f.resolve(g.result) : f.resolve(), this.processCommandResult(g), this.resultsMap.delete(g.cmd.toString()));
                            break;
                        case "PlayerNotification":
                            {
                                const f = this.event(g.name);
                                f.raise.apply(f, g.args);
                                break;
                            }
                        case "Command":
                            this.processCommand(g).catch((f)=>this.logger.warn(`error while processing command: ${JSON.stringify(g)}: ${f}`));
                            break;
                        default:
                            this.logger.warn(`unexpected message received: ${JSON.stringify(g)}`);
                    }
                }
                async processCommand(g) {
                    if ("getIceCandidates" === g.cmd.toString()) await this.message("getIceCandidates").send();
                    else this.logger.warn(`unsupported command received: ${JSON.stringify(g)}`);
                }
                processCommandResult(g) {
                    if ("getIceCandidates" === g.cmd.toString()) this.pipe.sendMsg({
                        topic: "RequestIceCandidates",
                        candidates: g.result
                    });
                    else this.logger.debug(`ignoring command result for: ${JSON.stringify(g)}`);
                }
                fromMessage(g) {
                    return g;
                }
                sendMessageImpl(g, ...f) {
                    return this.pipe.sendMsg(this.buildMsg(g, f)), this.waitForCompletion(g.toString());
                }
                buildMsg(g, f) {
                    return {
                        msgType: "Command",
                        cmd: g,
                        args: f
                    };
                }
                getDeferred(g) {
                    return this.resultsMap.get(g);
                }
                waitForCompletion(g) {
                    const f = this.getDeferred(g);
                    f && f.reject(new Error(`function ${g} is invoked again, before previous call is completed`));
                    const S = new ct;
                    return this.resultsMap.set(g, S), S.promise;
                }
                constructor(g){
                    super(g), this.logger = g, this.resultsMap = new Map, this.on("log", (g, f)=>{
                        this.logger[g](f);
                    });
                }
            }, St = class extends ze {
                get isRendering() {
                    return !!this.player && this.player.isRendering();
                }
                get streamSize() {
                    return this.player ? this.player.getStreamSize() : {
                        width: 0,
                        height: 0
                    };
                }
                get rendererType() {
                    return 0;
                }
                get frameType() {
                    return -1;
                }
                seek(g) {
                    this.player.seek(g);
                }
                seekToLiveEdge() {
                    this.player.seekToLiveEdge();
                }
                play() {
                    this.player.play();
                }
                pause() {
                    this.player.pause();
                }
                setVolume(g) {
                    this.player.setVolume(g);
                }
                selectVideoTrack(g) {
                    this.player.selectVideoTrack(g);
                }
                dispose() {
                    this.stopPlayer(), super.dispose();
                }
                captions() {
                    return this.player.getCaptionsControl();
                }
                getStats() {
                    throw new Error("Method not implemented.");
                }
                setScalingMode(g, f) {
                    throw new Error("Method not implemented.");
                }
                captureFrame(g, f) {
                    throw new Error("Method not implemented.");
                }
                stopPlayer() {
                    const g = this.player;
                    this.player = null, g && (this.logger.info("stopPlayer"), this.unsubscribeFromPlayerEvents(), g.stop());
                }
                subscribeForPlayerEvents() {
                    this.playerSubs.push(this.player.on("fullscreenToggled", (g)=>this.onFullScreenToggled(g))), this.playerSubs.push(this.player.on("captionsToggled", (g, f, S)=>this.onCaptionsToggled(g, f, S))), this.playerSubs.push(this.player.on("playbackTimeUpdated", (g)=>this.onPlaybackTimeUpdated(g))), this.playerSubs.push(this.player.on("videoTracksChanged", (g)=>this.onVideoTracksChanged(g)));
                }
                unsubscribeFromPlayerEvents() {
                    for (const g of this.playerSubs)g.dispose();
                    this.playerSubs = [];
                }
                onFullScreenToggled(g) {
                    this.event("fullScreenToggled").raise(g);
                }
                onCaptionsToggled(g, f, S) {
                    this.logger.info(`Turned captions ${g ? "ON" : "OFF"} for culture [${f}] at player time [${S}]`), this.event("captionsToggled").raise(g, f, S);
                }
                onPlaybackTimeUpdated(g) {
                    this.event("playbackTimeUpdated").raise(g);
                }
                onVideoTracksChanged(g) {
                    this.event("videoTracksUpdated").raise(g);
                }
                constructor(g, f){
                    super(), this.player = g, this.logger = f, this.playerSubs = [], this.subscribeForPlayerEvents();
                }
            }, vt = class {
                async addCues(g) {
                    await this.player.message("addCues").send(g);
                }
                async clearCues() {
                    await this.player.message("clearCues").send();
                }
                async showCaptions(g) {
                    await this.player.message("showCaptions").send(g);
                }
                getSelectedCulture() {
                    return this.selectedCulture;
                }
                getAvailableCultures() {
                    return this.availableCultures;
                }
                dispose() {
                    this.disposable.dispose(), this.player = null;
                }
                constructor(g, f){
                    this.player = g, this.availableCultures = f, this.selectedCulture = "", this.disposable = this.player.on("captionsToggled", (g, f, S)=>{
                        this.selectedCulture = g ? f : "";
                    });
                }
            };
            function generateGuid() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (g)=>{
                    const f = 16 * Math.random() | 0;
                    return ("x" === g ? f : 3 & f | 8).toString(16);
                });
            }
            function validateGuid(g) {
                return new RegExp("^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$").test(g) && 36 === g.length;
            }
            var _t = [
                2097152,
                2097552,
                2097556,
                2097557,
                2097564,
                2097652,
                2097654,
                2097655,
                2097656,
                2097752,
                3145728,
                4194305,
                4194306,
                4194307,
                4194308,
                4194309,
                5242880,
                5242881,
                5242882,
                5242884,
                5242885,
                5242886
            ], Ct = 2097753, yt = class extends ze {
                get playerId() {
                    return this.id;
                }
                async configure(g) {
                    if (!isStreamValid(g.stream) && !isStreamValid(g.altStream)) return void this.logger.error("Invalid Live Stream configuration provided: no valid primary or alternative stream");
                    this.logger.info("Live Stream configuration provided"), this.liveStreamOptions = g;
                    const f = isStreamValid(g.stream) ? g.stream : g.altStream;
                    if (this.playerInstance && !this.isPlaybackUnsupported) {
                        try {
                            await this.playerInstance.message("configure").send(g);
                        } catch (g) {
                            const f = stringifyObject(g);
                            this.logger.error(`configure failed: ${f}`);
                        }
                        await this.handleStreamInfoUpdate(f);
                    } else this.selectedStreamDetails = f;
                }
                async loadPlayer(g) {
                    if (this.playerInstance) return this.logger.error("playerLoadFailed: cannot load a player while current one is still active"), {
                        setupSucceeded: !1,
                        playerSetupError: {
                            errorType: "MultiplePlayerLoad",
                            errorMessage: "cannot load a player while current one is still active"
                        }
                    };
                    if (!this.liveStreamOptions || !this.selectedStreamDetails || !isStreamValid(this.selectedStreamDetails)) return this.logger.error("playerLoadFailed: empty/invalid primary and alternate stream info configured"), {
                        setupSucceeded: !1,
                        playerSetupError: {
                            errorType: "InvalidStream",
                            errorMessage: "empty/invalid primary and alternate stream info configured"
                        }
                    };
                    this.playerInstance = new ft(this.logger.createChild("AmpPlayerWrapper")), this.playerInstance.on("stateChanged", (g, f)=>this.ampStateChanged(g, f)), this.playerInstance.on("captionsToggled", (g, f, S)=>this.captionsToggled(g, f, S)), this.playerInstance.on("statsUpdated", (g)=>this.liveStreamStatistic.registerStatsUpdated(g));
                    const f = this.configProvider.config.ampSettings.noMediaTimeoutMs;
                    let S;
                    -1 !== f && -1 === this.noMediaTimeoutId && (this.noMediaTimeoutId = self.setTimeout(()=>this.callDropDueToMediaTimeout(), f)), await this.playerInstance.initialize(g, this.liveStreamOptions, this.configProvider, this.id), this.liveStreamStatistic.registerPlayerLoadAttempt(), this.loadSucceeded = !1, this.liveStreamStatistic.registerEventLoadAttempt("LoadScript"), this.srcLoadPromise || (this.srcLoadPromise = this.playerInstance.message("loadPlayerScript").send());
                    try {
                        S = await this.srcLoadPromise;
                    } catch (g) {
                        const f = stringifyObject(g);
                        return this.logger.error(`playerLoadFailed: player scripts load failed: ${f}`), this.liveStreamStatistic.registerEventLoadFailed("LoadScript", `Load Script failed: ${g}`), this.liveStreamStatistic.registerPlayerLoadFailed(`script load failed: ${S}`), this.srcLoadPromise = null, {
                            setupSucceeded: !1,
                            playerSetupError: {
                                errorType: "PlayerScriptLoadFailed",
                                errorMessage: f
                            }
                        };
                    }
                    this.liveStreamStatistic.registerEventLoadSucceeded("LoadScript"), await this.tryLoadSdnPlugin(), this.liveStreamStatistic.registerEventLoadAttempt("CreateAmp");
                    try {
                        await this.playerInstance.message("createAmp").send();
                    } catch (g) {
                        const f = stringifyObject(g);
                        return this.logger.error(`playerLoadFailed: createAmp failed: ${f}`), this.liveStreamStatistic.registerEventLoadFailed("CreateAmp", `createAmp failed: ${g}`), this.liveStreamStatistic.registerPlayerLoadFailed(`create amp failed ${f}, script load: ${S}`), {
                            setupSucceeded: !1,
                            playerSetupError: {
                                errorType: "PlayerInitializationFailed",
                                errorMessage: f
                            }
                        };
                    }
                    this.liveStreamStatistic.registerEventLoadSucceeded("CreateAmp");
                    try {
                        return await this.setPlayerSource(this.selectedStreamDetails), this.loadSucceeded = !0, this.logger.info(`loadPlayer succeeded: ${this.loadSucceeded}`), this.liveStreamStatistic.registerPlayerLoadSucceeded(S), this.playerState = "Initialized", {
                            setupSucceeded: this.loadSucceeded
                        };
                    } catch (g) {
                        const f = stringifyObject(g);
                        return this.loadSucceeded = !1, this.logger.error(`loadPlayer succeeded: ${this.loadSucceeded}: setSource failed: ${f}`), this.liveStreamStatistic.registerPlayerLoadFailed(`setPlayerSource failed; script load: ${S}`), {
                            setupSucceeded: this.loadSucceeded,
                            playerSetupError: {
                                errorType: "SetSourceFailed",
                                errorMessage: f
                            }
                        };
                    }
                }
                getRenderer() {
                    return !this.renderer && this.playerInstance && (this.renderer = new St(this, this.logger.createChild("LiveStreamRenderer"))), this.renderer;
                }
                seek(g) {
                    throw new Error(`Method not implemented - cannot perform video seek operation with args: [timestamp: ${g}]`);
                }
                seekToLiveEdge() {
                    throw new Error("Method not implemented - cannot perform video seek to live edge operation");
                }
                play() {
                    throw new Error("Method not implemented - cannot perform video play operation");
                }
                pause() {
                    throw new Error("Method not implemented - cannot perform video pause operation");
                }
                setVolume(g) {
                    throw new Error(`Method not implemented - cannot set video volume with args: [volume: ${g}]`);
                }
                selectVideoTrack(g) {
                    throw new Error(`Method not implemented - cannot select video track with args: [track: ${g}]`);
                }
                stop() {
                    this.destroy("PlayerStopped");
                }
                getPlaybackState() {
                    return this.playerState;
                }
                getCaptionsTimestamp() {
                    return this.captionsTimestamp;
                }
                getCaptionsControl() {
                    if (!this.captionsControl && this.playerInstance) {
                        const g = this.liveStreamOptions.supportedSubtitleLanguages ? this.liveStreamOptions.supportedSubtitleLanguages.map((g)=>g.culture) : [];
                        this.captionsControl = new vt(this.playerInstance, g);
                    }
                    return this.captionsControl;
                }
                getStreamSize() {
                    const g = this.liveStreamStatistic.getPlayerDiagnosticSnapshot();
                    return g ? {
                        width: g.mediaWidth,
                        height: g.mediaHeight
                    } : {
                        width: 0,
                        height: 0
                    };
                }
                isRendering() {
                    const g = this.getStreamSize();
                    return g.width > 0 && g.height > 0;
                }
                ampStateChanged(g, f) {
                    switch(g){
                        case "error":
                            return this.handlePlaybackError(f);
                        case "canplaythrough":
                            return this.onCanplaythrough();
                        case "play":
                            return this.onPlay();
                        case "playing":
                            return this.onPlaying();
                        case "pause":
                            return this.onPause();
                        case "resume":
                            return this.onResume();
                        case "start":
                            return this.onStart();
                        case "ended":
                            return this.onEnded();
                        case "seeking":
                            return this.onSeeking();
                        case "seeked":
                            return this.onSeeked(f);
                        case "loadedmetadata":
                            return this.onMetadataLoaded();
                        case "waiting":
                            return this.onWaiting();
                        case "playbackbitratechanged":
                            return this.onPlaybackBitrateChanged(f);
                        case "downloadbitratechanged":
                            return this.onDownloadBitrateChanged(f);
                        case "fullscreenchange":
                            return this.onFullscreenChange(f);
                        case "potentialMediaFreeze":
                            return this.onPotentialMediaFreeze();
                        case "mute":
                            return this.onMute();
                        case "unmute":
                            return this.onUnmute();
                        case "volumechange":
                            return this.onVolumeChange(f);
                        case "loadstart":
                            return this.onLoadStart();
                        case "loadeddata":
                            return this.onLoadedData();
                        case "UserInitiatedSeek":
                            return this.onUserInitiatedSeek(f);
                        default:
                            this.logger.warn(`Unknown amp event ${g}`);
                    }
                }
                onUserInitiatedSeek(g) {
                    this.liveStreamStatistic.registerUserInitiatedSeek(g);
                }
                captionsToggled(g, f, S) {
                    this.event("captionsToggled").raise(g, f, S), this.liveStreamStatistic.registerCaptionToggle(g, f, S);
                }
                async tryLoadSdnPlugin() {
                    if (this.sdnPluginLoadPromise) return void this.raiseSdnPluginSkippedEvent("SDN plugin already loaded");
                    if (!this.liveStreamOptions.sdn) return void this.raiseSdnPluginSkippedEvent("No SDNs configured in liveStreamOptions");
                    if (!this.configProvider.config.allowSdnPlugins) return void this.raiseSdnPluginSkippedEvent("Client configured to not allow SDN plugins");
                    switch(this.liveStreamOptions.sdn.name){
                        case "hive":
                        case "kollective":
                        case "ramp":
                        case "peer5":
                            break;
                        default:
                            return this.logger.warn(`unsupported SDN provider: ${this.liveStreamOptions.sdn.name}`), void this.liveStreamStatistic.registerSdnPluginLoad(this.liveStreamOptions.sdn.name, !1, `Unsupported SDN provider: ${this.liveStreamOptions.sdn.name}`);
                    }
                    let g;
                    this.liveStreamStatistic.registerEventLoadAttempt("SdnPluginLoad");
                    try {
                        this.sdnPluginLoadPromise = this.playerInstance.message("tryLoadSdnPlugin").send(), await this.sdnPluginLoadPromise, this.liveStreamStatistic.registerEventLoadSucceeded("SdnPluginLoad", this.liveStreamOptions.sdn.name);
                    } catch (f) {
                        g = stringifyObject(f), this.sdnPluginLoadPromise = void 0, this.logger.error(`loadSdnPlugin failed: ${g}`), this.liveStreamStatistic.registerEventLoadFailed("SdnPluginLoad", g), this.event("sdnPluginLoadFailed").raise(g);
                    }
                }
                raiseSdnPluginSkippedEvent(g) {
                    this.logger.warn(`skipping SDN plugin load: ${g}`), this.event("sdnPluginLoadSkipped").raise(g);
                }
                async setPlayerSource(g) {
                    if (!g) throw this.logger.error("setPlayerSource: streamDetails is undefined"), new Error("setPlayerSource: streamDetails is undefined");
                    if (!this.playerInstance) throw this.logger.error("setPlayerSource: playerInstance is null"), new Error("playerInstance is null");
                    this.logger.info(`setPlayerSource: AMP source set to: [${g.url}]`), this.lastKnownPlayTime = this.getCurrentTime() || this.lastKnownPlayTime;
                    try {
                        this.logger.info("setPlayerSource: src changed"), this.selectedStreamDetails = g, this.liveStreamStatistic.registerSetSourceAttempt(g.url), await this.playerInstance.message("setSource").send(g), this.liveStreamStatistic.registerSetSourceSucceeded();
                    } catch (g) {
                        const f = stringifyObject(g);
                        throw this.logger.error(`setPlayerSource: failed with error [${f}]`), this.liveStreamStatistic.registerSetSourcedFailed(f), g;
                    }
                }
                async handleStreamInfoUpdate(g) {
                    this.loadSucceeded && g.url !== this.selectedStreamDetails.url ? await this.setPlayerSource(g) : this.loadSucceeded && this.playerInstance && this.getCurrentTime() > 0 && this.setPlaybackState("Start");
                }
                async switchStreamingUrl(g, f) {
                    var _this_liveStreamOptions_stream;
                    if (this.streamingUrlSwitchCount >= this.configProvider.config.ampSettings.streamingUrlSwitchMaxCount || !(0, lt.includes)(this.configProvider.config.ampSettings.errorCodesEligibleForStreamingUrlSwitch, g) && !f) return !1;
                    const S = this.selectedStreamDetails.url === ((_this_liveStreamOptions_stream = this.liveStreamOptions.stream) === null || _this_liveStreamOptions_stream === void 0 ? void 0 : _this_liveStreamOptions_stream.url), v = S ? this.liveStreamOptions.altStream : this.liveStreamOptions.stream;
                    return isStreamValid(v) ? (this.isSwitchStreamingUrlOngoing = !0, this.streamingUrlSwitchCount++, this.setPlayerSource(v).then(()=>!0).catch(()=>!1)) : (this.logger.error(`Stream to switch (${S ? "alternative" : "primary"}) is not valid`), !1);
                }
                destroy(g) {
                    this.srcLoadPromise = null, this.sdnPluginLoadPromise = null, this.renderer && (this.renderer.dispose(), this.renderer = null), this.captionsControl && (this.captionsControl.dispose(), this.captionsControl = null), this.playerInstance && (this.liveStreamStatistic.registerPlayerDestroyed(g), this.playerInstance.dispose(), this.playerInstance = null, this.setPlaybackState("Destroyed"));
                }
                getCurrentTime() {
                    const g = this.liveStreamStatistic.getPlayerDiagnosticSnapshot();
                    return g && g.currentPlayPosition || 0;
                }
                onCanplaythrough() {
                    this.setPlaybackState("Ready");
                }
                onPlay() {
                    (this.retryCount > 0 || this.lastKnownPlayTime) && (this.logger.info(`Playing after retry count ${this.retryCount}, Setting current time to ${this.lastKnownPlayTime}`), this.playerInstance.message("setPlayTime").send(this.lastKnownPlayTime), this.retryCount = 0, this.lastKnownPlayTime = void 0), this.setPlaybackState("Play");
                }
                onPlaying() {
                    this.setPlaybackState("Playing");
                }
                onPause() {
                    this.setPlaybackState("Paused");
                }
                onResume() {
                    this.setPlaybackState("Resume");
                }
                onStart() {
                    this.logger.info(`Playback started, retry count: ${this.retryCount}`), this.setPlaybackState("Start"), this.event("playbackStarted").raise(), self.clearTimeout(this.noMediaTimeoutId), this.isSwitchStreamingUrlOngoing && (this.logger.info(`Playback started, switch count: ${this.streamingUrlSwitchCount}`), this.event("urlSwitched").raise(this.selectedStreamDetails === this.liveStreamOptions.altStream), this.isSwitchStreamingUrlOngoing = !1);
                }
                onEnded() {
                    this.setPlaybackState("Ended");
                }
                onSeeking() {
                    this.setPlaybackState("Seeking");
                }
                onSeeked(g) {
                    this.captionsTimestamp = g.captionsTimestamp, this.setPlaybackState("Seeked");
                }
                onMetadataLoaded() {
                    this.setPlaybackState("LoadedMetadata");
                }
                onWaiting() {
                    this.setPlaybackState("Buffering");
                }
                onLoadedData() {
                    this.setPlaybackState("LoadedData");
                }
                onLoadStart() {
                    this.setPlaybackState("LoadStart");
                }
                setPlaybackState(g) {
                    this.playerState = g, this.logger.debug(`playback state changed: ${g}`), this.liveStreamStatistic.registerPlaybackStateChanged(g), this.event("playbackStateChanged").raise();
                }
                onPlaybackBitrateChanged(g) {
                    this.liveStreamStatistic.registerPlaybackBitratechanged(g.bitrate);
                }
                onDownloadBitrateChanged(g) {
                    this.liveStreamStatistic.registerDownloadBitratechanged(g.bitrate);
                }
                onFullscreenChange(g) {
                    this.logger.debug(`fullscreenchange, isFullscreen=${g.isFullscreen}`), this.event("fullscreenToggled").raise(g.isFullscreen), this.liveStreamStatistic.registerFullScreenChange(g.isFullscreen);
                }
                onPotentialMediaFreeze() {
                    this.logger.warn("Player detected a potential media freeze"), this.liveStreamStatistic.registerPotentialMediaFreeze();
                }
                onMute() {
                    this.liveStreamStatistic.registerMute(!0);
                }
                onUnmute() {
                    this.liveStreamStatistic.registerMute(!1);
                }
                onVolumeChange(g) {
                    this.liveStreamStatistic.registerVolumeChange(g.value);
                }
                stringifyPlayerError(g) {
                    return JSON.stringify(g, function(g, f) {
                        return "errorCode" === g ? f.toString(16) : f;
                    });
                }
                async handlePlaybackError(g) {
                    var _g_message;
                    const f = 4194307;
                    this.playerState = "Error", this.lastPlaybackError = g;
                    const S = this.stringifyPlayerError(g);
                    if (this.logger.info(`Playback error ${S}`), !g.errorCode && null == g.fatal) return void this.logger.error("onError: error details are not available");
                    if ((g.errorCode & f) === f) return this.isPlaybackUnsupported = !0, this.raisePlaybackError("UnsupportedPlatform", S), void this.destroy("PlaybackError");
                    this.lastKnownPlayTime = this.getCurrentTime() || this.lastKnownPlayTime;
                    const v = g.errorCode, _ = 268435455 & v;
                    if (this.logger.error(`onError: errorCode: 0x${v.toString(16)}, errorCodeExcludingTech: 0x${_.toString(16)}, message: ${g.message}`), this.retryCount < this.configProvider.config.maxRetryCount && (!1 === g.fatal || -1 !== (0, lt.indexOf)(_t, _))) setTimeout(async ()=>{
                        this.logger.info(`Retry loading stream because of error code: 0x${v.toString(16)}`), this.retryCount++, this.raisePlaybackError("PlaybackRetried", S), this.setPlayerSource(this.selectedStreamDetails);
                    }, this.configProvider.config.ampSettings.sourceResetTimeoutInMs);
                    else await this.switchStreamingUrl(_, g.fatal) ? this.configProvider.config.ampSettings.resetStreamingUrlSwitchCount && (this.streamingUrlSwitchCount = 0) : (_ === Ct || ((_g_message = g.message) === null || _g_message === void 0 ? void 0 : _g_message.includes(Ct.toString(16))) ? this.raisePlaybackError("NetworkError", S) : this.raisePlaybackError("PlaybackError", S), this.destroy("PlaybackError"));
                }
                raisePlaybackError(g, f) {
                    this.liveStreamStatistic.registerPlaybackError(g, f), this.event("playbackError").raise(g, f);
                }
                callDropDueToMediaTimeout() {
                    const g = {
                        currentTime: -1,
                        errorCode: 0,
                        message: JSON.stringify({
                            state: this.playerState,
                            error: this.stringifyPlayerError(this.lastPlaybackError)
                        }),
                        fatal: !0
                    }, f = this.stringifyPlayerError(g);
                    this.raisePlaybackError("MediaTimeout", f), this.destroy("MediaTimeout");
                }
                constructor(g, f, S){
                    super(), this.logger = g, this.liveStreamStatistic = f, this.configProvider = S, this.playerState = "Destroyed", this.retryCount = 0, this.captionsTimestamp = 0, this.isSwitchStreamingUrlOngoing = !1, this.streamingUrlSwitchCount = 0, this.isPlaybackUnsupported = !1, this.noMediaTimeoutId = -1, this.lastPlaybackError = void 0, this.id = generateGuid(), this.logger.info(`AmpLiveStreamPlayer created: ID: ${this.id}`);
                }
            }, Et = __toESM(ne()), Tt = class extends ze {
                async configure(g) {
                    if (this.streamOptions = g, this.threadId = g.threadId, this.playerLoaded) {
                        const g = this.createHydraStreamOptions();
                        await this.hydraPlayer.callPlayerApi("configureHydraPlayer", g);
                    }
                }
                async loadPlayer(g) {
                    if (!await this.hydraPlayer.setup(g)) return {
                        setupSucceeded: !1,
                        playerSetupError: {
                            errorType: "HydraRuntimeLoadFailed",
                            errorMessage: "Failed to create IFrame with Hydra runtime script"
                        }
                    };
                    if (this.streamOptions) {
                        const g = this.createHydraStreamOptions();
                        await this.hydraPlayer.callPlayerApi("configureHydraPlayer", g);
                    } else this.logger.warn("No stream options configured before Hydra player loaded");
                    const f = await this.hydraPlayer.callPlayerApi("loadHydraPlayer");
                    return f.setupSucceeded && (this.playerLoaded = !0, this.startTelemetryGathering()), this.getHydraPlayerSetupResult(f);
                }
                convertStreamDeliveryPipeline(g) {
                    switch(g){
                        case "AMS":
                            return Et.HydraStreamDeliveryPipeline.AMS;
                        case "MiddleLaneHttpLiveStreaming":
                            return Et.HydraStreamDeliveryPipeline.HLS;
                        case "MiddleLaneUltraLowLatency":
                            return Et.HydraStreamDeliveryPipeline.Ums;
                        default:
                            throw new Error(`Unable to convert StreamDeliveryPipeline ${g} to HydraStreamDeliveryPipeline`);
                    }
                }
                convertStreamingEventType(g) {
                    switch(g){
                        case "TLE":
                            return Et.HydraStreamingEventType.TLE;
                        case "Overflow":
                            return Et.HydraStreamingEventType.Overflow;
                        case "TownHall_Basic":
                            return Et.HydraStreamingEventType.TownHallBasic;
                        case "TownHall_Premium":
                            return Et.HydraStreamingEventType.TownHallPremium;
                        case "TownHall":
                            return Et.HydraStreamingEventType.TownHall;
                        default:
                            throw new Error(`Unable to convert StreamingEventType ${g} to HydraStreamingEventType`);
                    }
                }
                addPlayerEventSubscribers() {
                    this.playerSubs.push(this.eventHandler.on("playbackStateChanged", (g)=>{
                        this.onPlaybackStateChanged(g);
                    })), this.playerSubs.push(this.eventHandler.on("playbackError", (g, f)=>{
                        this.onPlaybackError(g, f);
                    })), this.playerSubs.push(this.eventHandler.on("playbackSeeked", (g)=>{
                        this.onPlaybackSeeked(g);
                    })), this.playerSubs.push(this.eventHandler.on("urlSwitched", (g)=>{
                        this.onUrlSwitched(g);
                    })), this.playerSubs.push(this.eventHandler.on("sdnPluginLoadSkipped", (g)=>{
                        this.onSdnPluginLoadSkipped(g);
                    })), this.playerSubs.push(this.eventHandler.on("sdnPluginLoadFailed", (g)=>{
                        this.onSdnPluginLoadFailed(g);
                    })), this.playerSubs.push(this.eventHandler.on("playbackStarted", ()=>{
                        this.onPlaybackStarted();
                    })), this.playerSubs.push(this.eventHandler.on("playbackTimeUpdated", (g)=>{
                        this.onPlaybackTimeUpdated(g);
                    })), this.playerSubs.push(this.eventHandler.on("videoTracksUpdated", (g)=>{
                        this.onVideoTracksUpdated(g);
                    })), this.playerSubs.push(this.eventHandler.on("statsUpdated", (g)=>{
                        this.onStatsUpdated(g);
                    })), this.playerSubs.push(this.eventHandler.on("log", (g, f)=>{
                        this.onLog(g, f);
                    }));
                }
                getTelemetryReport() {
                    var _this_hydraPlayer;
                    return (_this_hydraPlayer = this.hydraPlayer) === null || _this_hydraPlayer === void 0 ? void 0 : _this_hydraPlayer.getFullTelemetryReport();
                }
                getSnapshotTelemetryReport() {
                    var _this_hydraPlayer;
                    return (_this_hydraPlayer = this.hydraPlayer) === null || _this_hydraPlayer === void 0 ? void 0 : _this_hydraPlayer.getSnapshotTelemetryReport();
                }
                startTelemetryGathering() {
                    var _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings, _this_configProvider_config_hydraPlayerHlsSettings, _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1, _this_configProvider_config_hydraPlayerHlsSettings1, _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings, _this_configProvider_config_hydraPlayerUmsSettings, _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1, _this_configProvider_config_hydraPlayerUmsSettings1;
                    this.statsSub = window.setTimeout(async ()=>{
                        clearTimeout(this.statsSub), this.logger.debug(`initial telemetry report after ${this.configProvider.config.sendInitialTelemetryAfterMs} ms`), this.sendTelemetry(!1);
                    }, this.configProvider.config.sendInitialTelemetryAfterMs);
                    let g, f;
                    1 === this.configProvider.playerConfig.playerType ? (g = ((_this_configProvider_config_hydraPlayerHlsSettings = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerHlsSettings_ecsSettings = _this_configProvider_config_hydraPlayerHlsSettings.ecsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings.sendSnapshotTelemetry) || this.configProvider.config.sendSnapshotTelemetry, f = ((_this_configProvider_config_hydraPlayerHlsSettings1 = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings1 === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1 = _this_configProvider_config_hydraPlayerHlsSettings1.ecsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1.sendSnapshotTelemetryEveryMs) || this.configProvider.config.sendSnapshotTelemetryEveryMs) : (g = ((_this_configProvider_config_hydraPlayerUmsSettings = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerUmsSettings_ecsSettings = _this_configProvider_config_hydraPlayerUmsSettings.ecsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings.sendSnapshotTelemetry) || this.configProvider.config.sendSnapshotTelemetry, f = ((_this_configProvider_config_hydraPlayerUmsSettings1 = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings1 === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1 = _this_configProvider_config_hydraPlayerUmsSettings1.ecsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1.sendSnapshotTelemetryEveryMs) || this.configProvider.config.sendSnapshotTelemetryEveryMs), g && (this.diagSub = window.setInterval(async ()=>{
                        this.sendSnapshotTelemetry();
                    }, f));
                }
                getHydraPlayerSetupResult(g) {
                    return {
                        setupSucceeded: g.setupSucceeded,
                        playerSetupError: g.playerSetupError ? {
                            errorType: this.convertHydraPlayerSetupError(g.playerSetupError.errorType),
                            errorMessage: g.playerSetupError.errorMessage
                        } : void 0
                    };
                }
                convertHydraPlayerSetupError(g) {
                    switch(g){
                        case Et.HydraPlayerSetupErrorType.InvalidStream:
                            return "InvalidStream";
                        case Et.HydraPlayerSetupErrorType.MultiplePlayerLoad:
                            return "MultiplePlayerLoad";
                        case Et.HydraPlayerSetupErrorType.PlayerInitializationFailed:
                            return "PlayerInitializationFailed";
                        case Et.HydraPlayerSetupErrorType.SetSourceFailed:
                            return "SetSourceFailed";
                        default:
                            return;
                    }
                }
                getRenderer() {
                    return !this.renderer && this.hydraPlayer && (this.renderer = new St(this, this.logger.createChild("LiveStreamRenderer"))), this.renderer;
                }
                onStatsUpdated(g) {
                    this.playerStats = g;
                }
                getStats() {
                    return this.playerStats;
                }
                onLog(g, f) {
                    this.logger[g](f);
                }
                onPlaybackStateChanged(g) {
                    try {
                        this.playbackState = this.convertHydraPlaybackState(g), this.event("playbackStateChanged").raise();
                    } catch (g) {
                        this.logger.warn(`Not handling playback state changed event: ${stringifyObject(g)}`);
                    }
                }
                convertHydraPlaybackState(g) {
                    switch(g){
                        case Et.HydraPlayerPlaybackState.LoadStart:
                            return "LoadStart";
                        case Et.HydraPlayerPlaybackState.LoadedData:
                            return "LoadedData";
                        case Et.HydraPlayerPlaybackState.LoadedMetadata:
                            return "LoadedMetadata";
                        case Et.HydraPlayerPlaybackState.Start:
                            return "Start";
                        case Et.HydraPlayerPlaybackState.CanPlayThrough:
                            return "Ready";
                        case Et.HydraPlayerPlaybackState.Play:
                            return "Play";
                        case Et.HydraPlayerPlaybackState.Playing:
                            return "Playing";
                        case Et.HydraPlayerPlaybackState.Pause:
                            return "Paused";
                        case Et.HydraPlayerPlaybackState.Waiting:
                            return "Buffering";
                        case Et.HydraPlayerPlaybackState.Seeking:
                            return "Seeking";
                        case Et.HydraPlayerPlaybackState.Seeked:
                            return "Seeked";
                        case Et.HydraPlayerPlaybackState.Ended:
                            return "Ended";
                        case Et.HydraPlayerPlaybackState.Error:
                            return "Error";
                        case Et.HydraPlayerPlaybackState.Destroyed:
                            return "Destroyed";
                        case Et.HydraPlayerPlaybackState.Initialized:
                            return "Initialized";
                        case Et.HydraPlayerPlaybackState.Stalled:
                            return "Stalled";
                        default:
                            throw new Error(`Unable to convert HydraPlayerPlaybackState ${g} to PlaybackState`);
                    }
                }
                onPlaybackError(g, f) {
                    try {
                        const S = this.convertHydraPlaybackErrorType(g);
                        this.event("playbackError").raise(S, f);
                    } catch (g) {
                        this.logger.warn(`Not handling playback error event: ${stringifyObject(g)}`);
                    }
                }
                convertHydraPlaybackErrorType(g) {
                    switch(g){
                        case Et.HydraPlayerPlaybackErrorType.UnsupportedPlatform:
                            return "UnsupportedPlatform";
                        case Et.HydraPlayerPlaybackErrorType.NetworkError:
                            return "NetworkError";
                        case Et.HydraPlayerPlaybackErrorType.PlaybackRetried:
                            return "PlaybackRetried";
                        case Et.HydraPlayerPlaybackErrorType.PlaybackError:
                            return "PlaybackError";
                        case Et.HydraPlayerPlaybackErrorType.MediaTimeout:
                            return "MediaTimeout";
                        case Et.HydraPlayerPlaybackErrorType.Unknown:
                            return "Unknown";
                        default:
                            throw new Error(`Unable to convert HydraPlayerPlaybackErrorType ${g} to PlaybackErrorType`);
                    }
                }
                seek(g) {
                    this.hydraPlayer.callPlayerApi("seekHydraPlayer", g);
                }
                seekToLiveEdge() {
                    this.hydraPlayer.callPlayerApi("seekHydraPlayerToLiveEdge");
                }
                play() {
                    this.hydraPlayer.callPlayerApi("playHydraPlayer");
                }
                pause() {
                    this.hydraPlayer.callPlayerApi("pauseHydraPlayer");
                }
                setVolume(g) {
                    this.hydraPlayer.callPlayerApi("setHydraPlayerVolume", g);
                }
                selectVideoTrack(g) {
                    this.hydraPlayer.callPlayerApi("selectHydraPlayerVideoTrack", g);
                }
                getStreamSize() {
                    return this.playerStats ? {
                        width: this.playerStats.mediaWidth,
                        height: this.playerStats.mediaHeight
                    } : {
                        width: 0,
                        height: 0
                    };
                }
                isRendering() {
                    const g = this.getStreamSize();
                    return g.width > 0 && g.height > 0;
                }
                disposePlayer() {
                    var _this_hydraPlayer;
                    (_this_hydraPlayer = this.hydraPlayer) === null || _this_hydraPlayer === void 0 ? void 0 : _this_hydraPlayer.dispose();
                }
                releasePlayer() {
                    this.hydraPlayer && (this.hydraPlayer.release(), this.hydraPlayer = null);
                }
                stop() {
                    this.clearPlayerEventSubscribers(), this.destroyPlayer();
                }
                destroyPlayer() {
                    this.renderer && (this.renderer.dispose(), this.renderer = null), this.statsSub && (clearTimeout(this.statsSub), this.statsSub = null), this.diagSub && (clearInterval(this.diagSub), this.diagSub = null), this.disposePlayer(), this.sendFinalTelemetry(), this.releasePlayer();
                }
                getPlaybackState() {
                    return this.playbackState;
                }
                getCaptionsTimestamp() {
                    return this.captionsTimestamp;
                }
                sendFinalTelemetry() {
                    this.isFinalTelemetrySent || (this.isFinalTelemetrySent = !0, this.sendTelemetry(!0));
                }
                sendTelemetry(g) {
                    if (this.configProvider.config.sendTelemetry && this.telemetryLogger) {
                        const f = {
                            ...this.getTelemetryReport(),
                            isFinal: g,
                            threadId: this.threadId,
                            tsCallingVersion: getTsCallingVersion(),
                            correlationId: this.streamOptions.correlationId
                        };
                        this.logger.debug("generated live stream report: ", f), this.telemetryLogger.sendEvent({
                            eventName: "live_events",
                            props: f
                        });
                    } else this.logger.info("telemetry not sent");
                }
                sendSnapshotTelemetry() {
                    if (this.telemetryLogger) {
                        const g = {
                            ...this.getSnapshotTelemetryReport(),
                            isFinal: !1,
                            threadId: this.threadId,
                            tsCallingVersion: getTsCallingVersion(),
                            correlationId: this.streamOptions.correlationId
                        };
                        this.logger.debug("sending snapshot telemetry: ", g), this.telemetryLogger.sendEvent({
                            eventName: "live_events",
                            props: g
                        });
                    } else this.logger.error("snapshot telemetry not sent, telemetryLogger is not set");
                }
                clearPlayerEventSubscribers() {
                    for (const g of this.playerSubs)g.dispose();
                    this.playerSubs = [];
                }
                onPlaybackSeeked(g) {
                    this.captionsTimestamp = g;
                }
                onUrlSwitched(g) {
                    this.event("urlSwitched").raise(g);
                }
                onSdnPluginLoadSkipped(g) {
                    this.event("sdnPluginLoadSkipped").raise(g);
                }
                onSdnPluginLoadFailed(g) {
                    this.event("sdnPluginLoadFailed").raise(g);
                }
                onPlaybackStarted() {
                    this.event("playbackStarted").raise();
                }
                onPlaybackTimeUpdated(g) {
                    this.event("playbackTimeUpdated").raise(g);
                }
                onVideoTracksUpdated(g) {
                    this.event("videoTracksChanged").raise(g);
                }
                constructor(g, f, S){
                    super(), this.logger = g, this.telemetryLogger = S, this.playerLoaded = !1, this.playbackState = "Destroyed", this.playerSubs = [], this.isFinalTelemetrySent = !1, this.captionsTimestamp = 0, this.configProvider = f;
                    const v = this.createHydraPlayerSettings();
                    this.eventHandler = this.createEventHandler(), this.addPlayerEventSubscribers(), this.hydraPlayer = new Et.HydraPlayer(v, this.eventHandler);
                }
            }, It = class extends ze {
                playbackStateChanged(g) {
                    this.event("playbackStateChanged").raise(g);
                }
                playbackSeeked(g) {
                    this.event("playbackSeeked").raise(g);
                }
                log(g, f) {
                    this.event("log").raise(g, f);
                }
                playbackError(g, f) {
                    this.event("playbackError").raise(g, f);
                }
                urlSwitched(g) {
                    this.event("urlSwitched").raise(g);
                }
                sdnPluginLoadSkipped(g) {
                    this.event("sdnPluginLoadSkipped").raise(g);
                }
                sdnPluginLoadFailed(g) {
                    this.event("sdnPluginLoadFailed").raise(g);
                }
                statsUpdated(g) {
                    this.event("statsUpdated").raise(g);
                }
                playbackStarted() {
                    this.event("playbackStarted").raise();
                }
                playbackTimeUpdated(g) {
                    this.event("playbackTimeUpdated").raise(g);
                }
                videoTracksUpdated(g) {
                    this.event("videoTracksUpdated").raise(g);
                }
                constructor(){
                    super();
                }
            }, bt = __toESM(ne());
            function GetHlsStreamPlaybackCoordinatesFromStream(g) {
                if (g.playbackCoordinates) return g.playbackCoordinates;
                if (!g.url && !g.hlsUrls) return [];
                const f = [];
                return (g.hlsUrls ? g.hlsUrls : [
                    g.url
                ]).forEach((S)=>{
                    f.push({
                        url: S,
                        sdnContext: g.sdnContext
                    });
                }), f;
            }
            function GetUmsStreamPlaybackCoordinatesFromStream(g) {
                return g.url ? [
                    {
                        url: g.url,
                        sdnContext: g.sdnContext
                    }
                ] : [];
            }
            var At = [
                "https://afdhls.playerscript.prod.ml.cdn.office.net/hlsrt2024-226-1/hydra_player_hls_bundle.js",
                "https://vzhls.playerscript.prod.ml.cdn.office.net/hlsrt2024-226-1/hydra_player_hls_bundle.js"
            ], Rt = class extends Tt {
                createEventHandler() {
                    return new wt;
                }
                createHydraPlayerSettings() {
                    var _this_configProvider_playerConfig, _this_configProvider_playerConfig1, _this_configProvider_playerConfig2, _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings, _this_configProvider_config_hydraPlayerHlsSettings, _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1, _this_configProvider_config_hydraPlayerHlsSettings1, _this_configProvider_config_hydraPlayerHlsSettings2, _this_configProvider_playerConfig3, _this_configProvider_config_hydraPlayerHlsSettings3, _this_configProvider_playerConfig4;
                    var _this_configProvider_config_debug, _this_configProvider_playerConfig_muteVideo, _this_configProvider_config_hydraPlayerHlsSettings_runtimeUrls, _ref, _this_configProvider_playerConfig_nonce;
                    return {
                        playerType: bt.HydraPlayerType.Hls,
                        hydraRuntimeFetchTimeout: this.configProvider.config.hydraRuntimeFetchTimeout,
                        capturePlayerLogs: this.configProvider.config.capturePlayerLogs,
                        allowSdnPlugins: this.configProvider.config.allowSdnPlugins,
                        debugLogging: (_this_configProvider_config_debug = this.configProvider.config.debug) !== null && _this_configProvider_config_debug !== void 0 ? _this_configProvider_config_debug : !1,
                        muteVideo: (_this_configProvider_playerConfig_muteVideo = (_this_configProvider_playerConfig = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig === void 0 ? void 0 : _this_configProvider_playerConfig.muteVideo) !== null && _this_configProvider_playerConfig_muteVideo !== void 0 ? _this_configProvider_playerConfig_muteVideo : !1,
                        videoLang: (_this_configProvider_playerConfig1 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig1 === void 0 ? void 0 : _this_configProvider_playerConfig1.lang,
                        videoElementStyles: (_this_configProvider_playerConfig2 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig2 === void 0 ? void 0 : _this_configProvider_playerConfig2.styles,
                        maxPlayerDiagnosticsCount: this.configProvider.config.maxPlayerDiagnosticsCount,
                        maxPlayerMemoryTraceLogCount: this.configProvider.config.maxPlayerMemoryTraceLogCount,
                        maxPlayerPlaybackEventCount: this.configProvider.config.maxPlayerPlaybackEventCount,
                        maxPlayerExperimentalEvents: this.configProvider.config.hlsSettings.maxPlayerExperimentalEvents,
                        maxRetryCount: this.configProvider.config.maxRetryCount,
                        playerTelemetryTickMs: this.configProvider.config.playerTelemetryTickMs,
                        removeEmptyDefaultTextTrack: this.configProvider.config.removeEmptyDefaultTextTrack,
                        maxRetryCountForLoadingResources: this.configProvider.config.maxRetryCountForLoadingResources,
                        maxVideoTrackHistoryLogCount: this.configProvider.config.maxVideoTrackHistoryLogCount,
                        maxStreamConnectionResultsLogCount: this.configProvider.config.hlsSettings.maxStreamConnectionResultsLogCount,
                        maxAbsoluteTimeOffsetEstimationResultsLogCount: this.configProvider.config.hlsSettings.maxAbsoluteTimeOffsetEstimationResultsLogCount,
                        skipNonce: this.configProvider.config.hlsSettings.skipNonce,
                        configIds: this.configProvider.configIds,
                        estimateAbsoluteTime: this.configProvider.config.hlsSettings.estimateAbsoluteTime,
                        playlistInitialSequenceNumber: this.configProvider.config.hlsSettings.playlistInitialSequenceNumber,
                        timeoutForSwitchingUrl: this.configProvider.config.hlsSettings.timeoutForSwitchingUrl,
                        hlsConfig: this.configProvider.config.hlsSettings.hlsConfig,
                        logHlsJsEvents: this.configProvider.config.hlsSettings.logHlsJsEvents,
                        logHlsJsEventsEveryMs: this.configProvider.config.hlsSettings.logHlsJsEventsEveryMs,
                        switchingPolicy: (_this_configProvider_config_hydraPlayerHlsSettings = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerHlsSettings_ecsSettings = _this_configProvider_config_hydraPlayerHlsSettings.ecsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings.switchingPolicy,
                        enableUuidTrace: this.configProvider.config.hlsSettings.enableUuidTrace,
                        thaScript: this.configProvider.config.hlsSettings.thaScript,
                        enableOffsetComputeBasedOfStreamTime: this.configProvider.config.hlsSettings.enableOffsetComputeBasedOfStreamTime,
                        stopCrash: this.configProvider.config.stopCrash,
                        stopTerminating: this.configProvider.config.hlsSettings.stopTerminating,
                        stallDetectionPolicy: (_this_configProvider_config_hydraPlayerHlsSettings1 = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings1 === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1 = _this_configProvider_config_hydraPlayerHlsSettings1.ecsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings_ecsSettings1.stallDetectionPolicy,
                        playerRuntimeJsUrls: (_ref = (_this_configProvider_config_hydraPlayerHlsSettings_runtimeUrls = (_this_configProvider_config_hydraPlayerHlsSettings2 = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings2 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings2.runtimeUrls) !== null && _this_configProvider_config_hydraPlayerHlsSettings_runtimeUrls !== void 0 ? _this_configProvider_config_hydraPlayerHlsSettings_runtimeUrls : (_this_configProvider_playerConfig3 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig3 === void 0 ? void 0 : _this_configProvider_playerConfig3.hydraPlayerWebSdkUrls) !== null && _ref !== void 0 ? _ref : At,
                        disableSandbox: this.configProvider.config.hlsSettings.disableSandbox,
                        ecsSettings: (_this_configProvider_config_hydraPlayerHlsSettings3 = this.configProvider.config.hydraPlayerHlsSettings) === null || _this_configProvider_config_hydraPlayerHlsSettings3 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerHlsSettings3.ecsSettings,
                        nonce: (_this_configProvider_playerConfig_nonce = (_this_configProvider_playerConfig4 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig4 === void 0 ? void 0 : _this_configProvider_playerConfig4.nonce) !== null && _this_configProvider_playerConfig_nonce !== void 0 ? _this_configProvider_playerConfig_nonce : ""
                    };
                }
                createHydraStreamOptions() {
                    var _this_streamOptions_thaContext_organizer, _this_streamOptions_thaContext_organizer1, _this_streamOptions_thaContext_attendee, _this_streamOptions_thaContext_attendee1;
                    let g = bt.HydraStreamingEventType.TLE;
                    g = this.streamOptions.streamingEventType ? this.convertStreamingEventType(this.streamOptions.streamingEventType) : this.streamOptions.overflow ? bt.HydraStreamingEventType.Overflow : bt.HydraStreamingEventType.TLE;
                    const f = {
                        stream: {
                            playbackCoordinates: GetHlsStreamPlaybackCoordinatesFromStream(this.streamOptions.stream),
                            urls: this.streamOptions.stream.hlsUrls ? this.streamOptions.stream.hlsUrls : [
                                this.streamOptions.stream.url
                            ],
                            keyAuthorizationToken: this.streamOptions.stream.keyAuthorizationToken,
                            keyDeliveryUrl: this.streamOptions.stream.keyDeliveryUrl,
                            sdnContext: this.streamOptions.stream.sdnContext,
                            streamDeliveryPipeline: this.streamOptions.stream.streamDeliveryPipeline ? this.convertStreamDeliveryPipeline(this.streamOptions.stream.streamDeliveryPipeline) : void 0
                        },
                        altStream: this.streamOptions.altStream ? {
                            playbackCoordinates: GetHlsStreamPlaybackCoordinatesFromStream(this.streamOptions.altStream),
                            urls: this.streamOptions.altStream.hlsUrls ? this.streamOptions.altStream.hlsUrls : [
                                this.streamOptions.altStream.url
                            ],
                            keyAuthorizationToken: this.streamOptions.altStream.keyAuthorizationToken,
                            keyDeliveryUrl: this.streamOptions.altStream.keyDeliveryUrl,
                            sdnContext: this.streamOptions.altStream.sdnContext,
                            streamDeliveryPipeline: this.streamOptions.altStream.streamDeliveryPipeline ? this.convertStreamDeliveryPipeline(this.streamOptions.altStream.streamDeliveryPipeline) : void 0
                        } : void 0,
                        supportedSubtitleLanguages: this.streamOptions.supportedSubtitleLanguages,
                        streamingEventType: g,
                        allowPlayerControls: this.streamOptions.allowPlayerControls,
                        sdn: this.streamOptions.sdn ? {
                            name: this.streamOptions.sdn.name,
                            url: this.streamOptions.sdn.url,
                            plugin: this.streamOptions.sdn.plugin
                        } : void 0,
                        thaContext: this.streamOptions.thaContext ? {
                            eventId: this.streamOptions.thaContext.eventId,
                            organizer: {
                                userId: (_this_streamOptions_thaContext_organizer = this.streamOptions.thaContext.organizer) === null || _this_streamOptions_thaContext_organizer === void 0 ? void 0 : _this_streamOptions_thaContext_organizer.userId,
                                tenantId: (_this_streamOptions_thaContext_organizer1 = this.streamOptions.thaContext.organizer) === null || _this_streamOptions_thaContext_organizer1 === void 0 ? void 0 : _this_streamOptions_thaContext_organizer1.tenantId
                            },
                            attendee: {
                                userId: (_this_streamOptions_thaContext_attendee = this.streamOptions.thaContext.attendee) === null || _this_streamOptions_thaContext_attendee === void 0 ? void 0 : _this_streamOptions_thaContext_attendee.userId,
                                tenantId: (_this_streamOptions_thaContext_attendee1 = this.streamOptions.thaContext.attendee) === null || _this_streamOptions_thaContext_attendee1 === void 0 ? void 0 : _this_streamOptions_thaContext_attendee1.tenantId
                            },
                            coOrganizers: this.streamOptions.thaContext.coOrganizers
                        } : void 0
                    };
                    return this.streamOptions.eventId && (f.eventId = this.streamOptions.eventId), this.streamOptions.templateId && (f.templateId = this.streamOptions.templateId), this.streamOptions.meetingMetadata && (f.meetingMetadata = this.streamOptions.meetingMetadata), f;
                }
                onCaptionsToggled(g, f, S) {
                    this.captionsControl && this.captionsControl.toggleCaptions(g, f), this.event("captionsToggled").raise(g, f, S);
                }
                getCaptionsControl() {
                    if (!this.captionsControl && this.hydraPlayer) {
                        var _this_streamOptions;
                        const g = ((_this_streamOptions = this.streamOptions) === null || _this_streamOptions === void 0 ? void 0 : _this_streamOptions.supportedSubtitleLanguages) ? this.streamOptions.supportedSubtitleLanguages.map((g)=>g.culture) : [
                            "en",
                            "es"
                        ];
                        this.captionsControl = new Pt(this.hydraPlayer, g);
                    }
                    return this.captionsControl;
                }
                addPlayerEventSubscribers() {
                    super.addPlayerEventSubscribers(), this.playerSubs.push(this.eventHandler.on("captionsToggled", (g, f, S)=>{
                        this.onCaptionsToggled(g, f, S);
                    }));
                }
                releasePlayer() {
                    super.releasePlayer(), this.captionsControl && (this.captionsControl.dispose(), this.captionsControl = null);
                }
            }, Pt = class {
                async addCues(g) {
                    const f = this.convertCues(g);
                    await this.hydraPlayer.callPlayerApi("addHydraPlayerCues", f);
                }
                convertCues(g) {
                    const f = [];
                    return g.forEach((g)=>{
                        f.push({
                            start: g.start,
                            end: g.end,
                            text: g.text
                        });
                    }), f;
                }
                async clearCues() {
                    await this.hydraPlayer.callPlayerApi("clearHydraPlayerCues");
                }
                async showCaptions(g) {
                    await this.hydraPlayer.callPlayerApi("showHydraPlayerCaptions", g);
                }
                getSelectedCulture() {
                    return this.selectedCulture;
                }
                getAvailableCultures() {
                    return this.availableCultures;
                }
                dispose() {
                    this.hydraPlayer = null;
                }
                toggleCaptions(g, f) {
                    this.selectedCulture = g ? f : "";
                }
                constructor(g, f){
                    this.hydraPlayer = g, this.availableCultures = f, this.selectedCulture = "";
                }
            }, wt = class extends It {
                captionsToggled(g, f, S) {
                    this.event("captionsToggled").raise(g, f, S);
                }
                constructor(){
                    super();
                }
            }, Mt = __toESM(ne()), Ot = class extends Tt {
                get tracks() {
                    return this.trackInfo;
                }
                createEventHandler() {
                    return new Nt;
                }
                createHydraPlayerSettings() {
                    var _this_configProvider_playerConfig, _this_configProvider_playerConfig1, _this_configProvider_playerConfig2, _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings, _this_configProvider_config_hydraPlayerUmsSettings, _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1, _this_configProvider_config_hydraPlayerUmsSettings1, _this_configProvider_config_hydraPlayerUmsSettings2, _this_configProvider_playerConfig3, _this_configProvider_config_hydraPlayerUmsSettings3, _this_configProvider_playerConfig4, _this_configProvider_config_umsSettings;
                    var _this_configProvider_config_debug, _this_configProvider_playerConfig_muteVideo, _this_configProvider_config_hydraPlayerUmsSettings_runtimeUrls, _this_configProvider_playerConfig_nonce, _this_configProvider_config_umsSettings_useLiveUmsCaptions;
                    return {
                        playerType: Mt.HydraPlayerType.Ums,
                        hydraRuntimeFetchTimeout: this.configProvider.config.hydraRuntimeFetchTimeout,
                        allowSdnPlugins: this.configProvider.config.allowSdnPlugins,
                        debugLogging: (_this_configProvider_config_debug = this.configProvider.config.debug) !== null && _this_configProvider_config_debug !== void 0 ? _this_configProvider_config_debug : !1,
                        muteVideo: (_this_configProvider_playerConfig_muteVideo = (_this_configProvider_playerConfig = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig === void 0 ? void 0 : _this_configProvider_playerConfig.muteVideo) !== null && _this_configProvider_playerConfig_muteVideo !== void 0 ? _this_configProvider_playerConfig_muteVideo : !1,
                        videoLang: (_this_configProvider_playerConfig1 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig1 === void 0 ? void 0 : _this_configProvider_playerConfig1.lang,
                        videoElementStyles: (_this_configProvider_playerConfig2 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig2 === void 0 ? void 0 : _this_configProvider_playerConfig2.styles,
                        maxPlayerDiagnosticsCount: this.configProvider.config.maxPlayerDiagnosticsCount,
                        maxPlayerMemoryTraceLogCount: this.configProvider.config.maxPlayerMemoryTraceLogCount,
                        maxPlayerPlaybackEventCount: this.configProvider.config.maxPlayerPlaybackEventCount,
                        maxPlayerExperimentalEvents: this.configProvider.config.umsSettings.maxPlayerExperimentalEvents,
                        maxRetryCount: this.configProvider.config.maxRetryCount,
                        playerTelemetryTickMs: this.configProvider.config.playerTelemetryTickMs,
                        maxRetryCountForLoadingResources: this.configProvider.config.maxRetryCountForLoadingResources,
                        maxVideoTrackHistoryLogCount: this.configProvider.config.maxVideoTrackHistoryLogCount,
                        maxStreamConnectionResultsLogCount: this.configProvider.config.umsSettings.maxStreamConnectionResultsLogCount,
                        configIds: this.configProvider.configIds,
                        timeoutForSwitchingUrl: this.configProvider.config.umsSettings.timeoutForSwitchingUrl,
                        latencyCompensationThreshold: this.configProvider.config.umsSettings.latencyCompensationThreshold,
                        switchingPolicy: (_this_configProvider_config_hydraPlayerUmsSettings = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerUmsSettings_ecsSettings = _this_configProvider_config_hydraPlayerUmsSettings.ecsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings.switchingPolicy,
                        enableUuidTrace: this.configProvider.config.umsSettings.enableUuidTrace,
                        thaScript: this.configProvider.config.umsSettings.thaScript,
                        stopCrash: this.configProvider.config.stopCrash,
                        stopTerminating: this.configProvider.config.umsSettings.stopTerminating,
                        stallDetectionPolicy: (_this_configProvider_config_hydraPlayerUmsSettings1 = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings1 === void 0 ? void 0 : (_this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1 = _this_configProvider_config_hydraPlayerUmsSettings1.ecsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings_ecsSettings1.stallDetectionPolicy,
                        playerRuntimeJsUrls: (_this_configProvider_config_hydraPlayerUmsSettings_runtimeUrls = (_this_configProvider_config_hydraPlayerUmsSettings2 = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings2 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings2.runtimeUrls) !== null && _this_configProvider_config_hydraPlayerUmsSettings_runtimeUrls !== void 0 ? _this_configProvider_config_hydraPlayerUmsSettings_runtimeUrls : (_this_configProvider_playerConfig3 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig3 === void 0 ? void 0 : _this_configProvider_playerConfig3.hydraPlayerWebSdkUrls,
                        disableSandbox: this.configProvider.config.umsSettings.disableSandbox,
                        ecsSettings: (_this_configProvider_config_hydraPlayerUmsSettings3 = this.configProvider.config.hydraPlayerUmsSettings) === null || _this_configProvider_config_hydraPlayerUmsSettings3 === void 0 ? void 0 : _this_configProvider_config_hydraPlayerUmsSettings3.ecsSettings,
                        nonce: (_this_configProvider_playerConfig_nonce = (_this_configProvider_playerConfig4 = this.configProvider.playerConfig) === null || _this_configProvider_playerConfig4 === void 0 ? void 0 : _this_configProvider_playerConfig4.nonce) !== null && _this_configProvider_playerConfig_nonce !== void 0 ? _this_configProvider_playerConfig_nonce : "",
                        useLiveUmsCaptions: (_this_configProvider_config_umsSettings_useLiveUmsCaptions = (_this_configProvider_config_umsSettings = this.configProvider.config.umsSettings) === null || _this_configProvider_config_umsSettings === void 0 ? void 0 : _this_configProvider_config_umsSettings.useLiveUmsCaptions) !== null && _this_configProvider_config_umsSettings_useLiveUmsCaptions !== void 0 ? _this_configProvider_config_umsSettings_useLiveUmsCaptions : !1
                    };
                }
                createHydraStreamOptions() {
                    var _this_streamOptions_thaContext_organizer, _this_streamOptions_thaContext_organizer1, _this_streamOptions_thaContext_attendee, _this_streamOptions_thaContext_attendee1;
                    let g = Mt.HydraStreamingEventType.TLE;
                    g = this.streamOptions.streamingEventType ? this.convertStreamingEventType(this.streamOptions.streamingEventType) : this.streamOptions.overflow ? Mt.HydraStreamingEventType.Overflow : Mt.HydraStreamingEventType.TLE;
                    const f = {
                        stream: {
                            playbackCoordinates: GetUmsStreamPlaybackCoordinatesFromStream(this.streamOptions.stream),
                            urls: [
                                this.streamOptions.stream.url
                            ],
                            decryptionKey: this.streamOptions.stream.decryptionKey,
                            sdnContext: this.streamOptions.stream.sdnContext,
                            streamDeliveryPipeline: this.streamOptions.stream.streamDeliveryPipeline ? this.convertStreamDeliveryPipeline(this.streamOptions.stream.streamDeliveryPipeline) : void 0
                        },
                        altStream: this.streamOptions.altStream ? {
                            playbackCoordinates: GetUmsStreamPlaybackCoordinatesFromStream(this.streamOptions.altStream),
                            urls: [
                                this.streamOptions.altStream.url
                            ],
                            decryptionKey: this.streamOptions.altStream.decryptionKey,
                            sdnContext: this.streamOptions.altStream.sdnContext,
                            streamDeliveryPipeline: this.streamOptions.altStream.streamDeliveryPipeline ? this.convertStreamDeliveryPipeline(this.streamOptions.altStream.streamDeliveryPipeline) : void 0
                        } : void 0,
                        streamingEventType: g,
                        allowPlayerControls: this.streamOptions.allowPlayerControls,
                        sdn: this.streamOptions.sdn ? {
                            name: this.streamOptions.sdn.name,
                            url: this.streamOptions.sdn.url,
                            plugin: this.streamOptions.sdn.plugin
                        } : void 0,
                        thaContext: this.streamOptions.thaContext ? {
                            eventId: this.streamOptions.thaContext.eventId,
                            organizer: {
                                userId: (_this_streamOptions_thaContext_organizer = this.streamOptions.thaContext.organizer) === null || _this_streamOptions_thaContext_organizer === void 0 ? void 0 : _this_streamOptions_thaContext_organizer.userId,
                                tenantId: (_this_streamOptions_thaContext_organizer1 = this.streamOptions.thaContext.organizer) === null || _this_streamOptions_thaContext_organizer1 === void 0 ? void 0 : _this_streamOptions_thaContext_organizer1.tenantId
                            },
                            attendee: {
                                userId: (_this_streamOptions_thaContext_attendee = this.streamOptions.thaContext.attendee) === null || _this_streamOptions_thaContext_attendee === void 0 ? void 0 : _this_streamOptions_thaContext_attendee.userId,
                                tenantId: (_this_streamOptions_thaContext_attendee1 = this.streamOptions.thaContext.attendee) === null || _this_streamOptions_thaContext_attendee1 === void 0 ? void 0 : _this_streamOptions_thaContext_attendee1.tenantId
                            },
                            coOrganizers: this.streamOptions.thaContext.coOrganizers
                        } : void 0
                    };
                    return this.streamOptions.eventId && (f.eventId = this.streamOptions.eventId), this.streamOptions.templateId && (f.templateId = this.streamOptions.templateId), this.streamOptions.meetingMetadata && (f.meetingMetadata = this.streamOptions.meetingMetadata), f;
                }
                addPlayerEventSubscribers() {
                    super.addPlayerEventSubscribers(), this.playerSubs.push(this.eventHandler.on("trackListUpdated", (g)=>{
                        this.onTrackListUpdated(g);
                    })), this.playerSubs.push(this.eventHandler.on("trackSelected", (g)=>{
                        this.onTrackSelected(g);
                    }));
                }
                onTrackListUpdated(g) {
                    this.trackInfo = g;
                    const f = stringifyObject(g);
                    this.logger.info(`[onTrackListUpdated]: Track list updated to: ${f}`);
                }
                onTrackSelected(g) {
                    const f = stringifyObject(g);
                    this.logger.info(`[onTrackSelected]: Track selected: ${f}`);
                }
                getCaptionsControl() {
                    return !this.captionsControl && this.hydraPlayer && (this.captionsControl = new Dt(this.hydraPlayer, this.logger.createChild("CaptionsControl"))), this.captionsControl;
                }
                releasePlayer() {
                    super.releasePlayer(), this.captionsControl && (this.captionsControl.dispose(), this.captionsControl = null);
                }
            }, Dt = class {
                async addCues(g) {
                    this.logger.warn("[addCues]: not implemented for UMS player");
                }
                async clearCues() {
                    this.logger.warn("[clearCues]: not implemented for UMS player");
                }
                async showCaptions(g) {
                    await this.hydraPlayer.callPlayerApi("showHydraPlayerCaptions", g);
                }
                getSelectedCulture() {
                    return this.logger.warn("[getSelectedCulture]: not implemented for UMS player"), "";
                }
                getAvailableCultures() {
                    return this.logger.warn("[getAvailableCultures]: not implemented for UMS player"), [];
                }
                dispose() {
                    this.hydraPlayer = null;
                }
                async selectTextTrack(g) {
                    await this.hydraPlayer.callPlayerApi("selectHydraPlayerTextTrack", g);
                }
                constructor(g, f){
                    this.hydraPlayer = g, this.logger = f;
                }
            }, Nt = class extends It {
                trackListUpdated(g) {
                    this.event("trackListUpdated").raise(g);
                }
                trackSelected(g) {
                    this.event("trackSelected").raise(g);
                }
                constructor(){
                    super();
                }
            }, kt = class extends ze {
                get isStreaming() {
                    return this._isStreaming;
                }
                isActive() {
                    return this.isAvailable && this.isStreaming;
                }
                async start(g, f) {
                    await this.setOptions(f), this.isFinalTelemetrySent = !1;
                    const S = await this.player.loadPlayer(g);
                    if (!S.setupSucceeded) {
                        this.player.stop(), this.logger.error("playerLoadFailed");
                        const g = JSON.stringify(S.playerSetupError);
                        throw this.sendFinalTelemetry(g), new Error(g);
                    }
                    return this._isStreaming = !0, this.liveStreamStatistic && (this.statsSub = window.setTimeout(()=>{
                        clearTimeout(this.statsSub), this.logger.debug(`initial telemetry report after ${this.configProvider.config.sendInitialTelemetryAfterMs} ms`), this.sendTelemetry(!1);
                    }, this.configProvider.config.sendInitialTelemetryAfterMs), this.configProvider.config.sendSnapshotTelemetry && (this.diagSub = window.setInterval(()=>{
                        this.sendSnapshotTelemetry();
                    }, this.configProvider.config.sendSnapshotTelemetryEveryMs))), this.player.getRenderer();
                }
                initializeAmpTelemetry() {
                    const g = {
                        perceivedBandwidth: [],
                        videoBufferLength: [],
                        videoCachedLength: [],
                        videoEdgeLatency: [],
                        playerHeight: [],
                        playerWidth: [],
                        mediaHeight: [],
                        mediaWidth: [],
                        windowHeight: [],
                        windowWidth: [],
                        playbackRate: [],
                        currentPlayPosition: [],
                        currentMediaTime: [],
                        statsInterval: []
                    };
                    this.liveStreamStatistic = new ot(this.configProvider.config, this.logger.createChild("LiveStreamStatistic"), g);
                }
                async stop() {}
                async setOptions(g) {
                    return void 0 !== g.overflow && (g.streamingEventType || (g.streamingEventType = g.overflow ? "Overflow" : "TLE"), delete g.overflow), this.options = g, this.player.configure(g);
                }
                getStats() {
                    var _this_player_getStats, _this_player;
                    return this.liveStreamStatistic ? this.liveStreamStatistic.getPlayerDiagnosticSnapshot() : (_this_player = this.player) === null || _this_player === void 0 ? void 0 : (_this_player_getStats = _this_player.getStats) === null || _this_player_getStats === void 0 ? void 0 : _this_player_getStats.call(_this_player);
                }
                dispose() {
                    this.unsubscribeFromPlayerEvents(), this.player.stop(), this.statsSub && (clearTimeout(this.statsSub), this.statsSub = null), this.diagSub && (clearInterval(this.diagSub), this.diagSub = null), this.logger.debug("stopping live event"), this.sendFinalTelemetry("graceful disposed"), super.dispose();
                }
                sendFinalTelemetry(g) {
                    this.isFinalTelemetrySent || (this.isFinalTelemetrySent = !0, this.sendTelemetry(!0, g));
                }
                sendTelemetry(g, f) {
                    if (this.liveStreamStatistic) {
                        if (this.configProvider.config.sendTelemetry && this.telemetryLogger) {
                            var _this_options, _this_options1, _this_liveStreamStatistic;
                            const S = {
                                configIds: this.configProvider.configIds,
                                playerId: this.player.playerId,
                                correlationId: (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.correlationId,
                                eTag: this.configProvider.etag,
                                isFinal: g,
                                threadId: (_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.threadId,
                                disableFullscreenButton: this.configProvider.playerConfig.disableFullscreenButton,
                                callendReason: f
                            }, v = (_this_liveStreamStatistic = this.liveStreamStatistic) === null || _this_liveStreamStatistic === void 0 ? void 0 : _this_liveStreamStatistic.getReport(S);
                            this.logger.debug("generated live stream report", v), this.telemetryLogger.sendEvent({
                                eventName: "live_events",
                                props: v
                            });
                        } else this.logger.info("telemetry not sent");
                    } else this.logger.info("telemetry not tracked in ILiveStream object");
                }
                sendSnapshotTelemetry() {
                    if (this.liveStreamStatistic) {
                        if (this.telemetryLogger) {
                            var _this_options, _this_options1;
                            const g = this.liveStreamStatistic.getSnapshotReport({
                                configIds: this.configProvider.configIds,
                                playerId: this.player.playerId,
                                correlationId: (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.correlationId,
                                eTag: this.configProvider.etag,
                                isFinal: !1,
                                threadId: (_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.threadId,
                                disableFullscreenButton: this.configProvider.playerConfig.disableFullscreenButton
                            });
                            this.logger.debug("sending snapshot telemetry: ", g), this.telemetryLogger.sendEvent({
                                eventName: "live_events",
                                props: g
                            });
                        } else this.logger.error("snapshot telemetry not sent, telemetryLogger is not set");
                    } else this.logger.info("telemetry not tracked in ILiveStream object");
                }
                subscribeForPlayerEvents() {
                    this.playerSubs.push(this.player.on("playbackStateChanged", ()=>{
                        this.onPlaybackStateChanged();
                    })), this.playerSubs.push(this.player.on("playbackError", (g, f)=>{
                        this.onPlaybackError(g, f);
                    })), this.playerSubs.push(this.player.on("urlSwitched", (g)=>{
                        this.onUrlSwitched(g);
                    })), this.playerSubs.push(this.player.on("sdnPluginLoadSkipped", (g)=>{
                        this.onSdnPluginLoadSkipped(g);
                    })), this.playerSubs.push(this.player.on("sdnPluginLoadFailed", (g)=>{
                        this.onSdnPluginLoadFailed(g);
                    })), this.playerSubs.push(this.player.on("playbackStarted", ()=>{
                        this.onPlaybackStarted();
                    }));
                }
                unsubscribeFromPlayerEvents() {
                    for (const g of this.playerSubs)g.dispose();
                    this.playerSubs = [];
                }
                onPlaybackStarted() {
                    this.event("playbackStarted").raise();
                }
                onPlaybackStateChanged() {
                    const g = this.player.getPlaybackState();
                    switch(g){
                        case "Start":
                            this.event("playbackStarted").raise();
                            break;
                        case "Ended":
                            this.event("playbackNotLive").raise(), this.sendFinalTelemetry("playback ended");
                            break;
                        case "Seeked":
                            this.event("playbackSeeked").raise(this.player.getCaptionsTimestamp());
                            break;
                        default:
                            this.logger.debug(`playbackStateChanged: ${g}`);
                    }
                    this.event("playbackStateChanged").raise(this.player.getPlaybackState());
                }
                onPlaybackError(g, f) {
                    this.event("error").raise(g, f);
                }
                onUrlSwitched(g) {
                    this.event("urlSwitched").raise(g);
                }
                onSdnPluginLoadSkipped(g) {
                    this.event("sdnPluginLoadSkipped").raise(g);
                }
                onSdnPluginLoadFailed(g) {
                    this.event("sdnPluginLoadFailed").raise(g);
                }
                constructor(g, f, S){
                    super(), this.configProvider = g, this.logger = f, this.getTelemetryLogger = S, this.isAvailable = !0, this._isStreaming = !1, this.playerSubs = [], this.isFinalTelemetrySent = !1, this.telemetryLogger = this.getTelemetryLogger(), 1 === this.configProvider.playerConfig.playerType ? this.player = new Rt(this.logger.createChild("HlsHydraLiveStreamPlayer"), this.configProvider, this.telemetryLogger) : 2 === this.configProvider.playerConfig.playerType ? this.player = new Ot(this.logger.createChild("UmsHydraLiveStreamPlayer"), this.configProvider, this.telemetryLogger) : (this.initializeAmpTelemetry(), this.player = new yt(this.logger.createChild("AmpLiveStreamPlayer"), this.liveStreamStatistic, this.configProvider)), this.subscribeForPlayerEvents();
                }
            }, Lt = class {
                configure(g) {
                    this.configuration = g;
                }
                async initialize() {
                    const g = "MDN_MIDDLELANE_TEAMS", f = "liveStream", S = this.ecsConfig.getString(g, f);
                    let v = {};
                    try {
                        v = JSON.parse(S);
                    } catch (S) {
                        this.logger.warn(`failed to parse ECS configuration for ${g}/${f}`);
                    }
                    const _ = this.ecsConfig.getString("ConfigIDs", g);
                    this._configProvider = new nt(v, this.configuration, _, this.logger.createChild("LiveStreamConfigProvider"));
                }
                createLiveStream() {
                    return new kt(this._configProvider, this.logger.createChild("LiveStream"), this.getTelemetryLogger);
                }
                dispose() {}
                constructor(g, f, S){
                    this.ecsConfig = g, this.logger = f, this.getTelemetryLogger = S;
                }
            }, Ft = class extends ze {
                createAudioPlayer() {
                    return null;
                }
                createAudioRenderer() {
                    return null;
                }
                getRawDeviceMediaStream(g) {
                    return null;
                }
                askDevicePermission() {
                    return Promise.resolve({
                        audio: !1,
                        video: !1
                    });
                }
                getPermissionState(g) {
                    return "granted";
                }
                enumerateDevicesAsync() {
                    return Promise.resolve([]);
                }
                getPreferredCamera() {
                    return null;
                }
                selectDevices() {}
                getSelectedDevices() {
                    return {};
                }
                createPreview() {
                    return Promise.resolve(new xt);
                }
                createPreviewRenderer() {
                    return Promise.resolve(new xt);
                }
                createScreenSharingPreviewRenderer() {
                    return Promise.resolve(new xt);
                }
                getDeviceNameAsync() {
                    return Promise.resolve("");
                }
                setDeviceEffectsAsync() {
                    return Promise.resolve();
                }
                getDeviceEffectsCapabilityAsync() {
                    return Promise.resolve(0);
                }
                setBackgroundImageAsync() {
                    return Promise.resolve();
                }
                getImagePropertyAsync() {
                    return Promise.resolve({
                        width: 0,
                        height: 0,
                        uri: " "
                    });
                }
                getMicrophoneGeometryArrayInfoAsync(g) {
                    return Promise.resolve({});
                }
                transformImageAsync() {
                    return Promise.resolve(!1);
                }
                sendMessageDeviceVideoEffectsAsync() {
                    return Promise.resolve({
                        code: 0
                    });
                }
                sendMessageDeviceVideoExtensibilityAsync() {
                    return Promise.resolve({
                        code: 0,
                        type: "Error",
                        response: {
                            details: "The API has not been implemented."
                        }
                    });
                }
                setVideoCaptureConfigAsync() {
                    return Promise.resolve();
                }
                captureVideoFrameWithoutEffectsAsync() {
                    return Promise.resolve(new ImageData(0, 0));
                }
                enableSignLanguageDetectionAsync(g, f) {
                    return Promise.resolve();
                }
                downloadAiModel(g, f) {
                    return Promise.resolve("");
                }
                setAudioProcessingFlags(g) {}
                getSpeakerVolume() {
                    return Promise.resolve(0);
                }
                getSpeakerSystemVolume() {
                    return Promise.resolve(0);
                }
                setSpeakerVolume(g) {
                    return Promise.resolve();
                }
                setSpeakerSystemVolume(g) {
                    return Promise.resolve();
                }
                unmuteMicrophone() {
                    return Promise.resolve();
                }
                unmuteSpeaker() {
                    return Promise.resolve();
                }
                getNrgLevelsForDeviceTuner(g) {
                    return Promise.resolve(0);
                }
                getNrgLevelPollerForDeviceTuner(g) {
                    return Promise.resolve(new Vt);
                }
                setAudioEffectsAsync() {
                    return Promise.resolve();
                }
                getAudioFeatureCapability(g) {
                    return Promise.resolve(0);
                }
                getMicrophoneVolume() {
                    return Promise.resolve(0);
                }
                setMicrophoneVolume(g) {
                    return Promise.resolve();
                }
                setDeviceTelemetryData(g, f, S, v = 0) {
                    return Promise.resolve();
                }
                getSpeakerDeviceDomIdAsync(g, f) {
                    return Promise.reject();
                }
                mapBrowserDevices(g, f) {
                    return Promise.reject();
                }
                getSourceFormats(g) {
                    return Promise.resolve([]);
                }
                enableShellSharing() {
                    return Promise.resolve();
                }
                disableShellSharing() {
                    return Promise.resolve();
                }
                enableParticipantCameras() {
                    return Promise.resolve();
                }
                registerDerivedSource(g, f) {
                    return Promise.resolve();
                }
                unregisterDerivedSource(g) {
                    return Promise.resolve();
                }
                startAudioLoopbackDevice(g) {
                    return Promise.resolve();
                }
                async dispose(g) {
                    return Promise.resolve();
                }
                constructor(){
                    super(...arguments), this.isAudioOutputSelectionSupported = !1;
                }
            }, xt = class extends ze {
                captureFrame() {
                    return Promise.resolve(new Ut);
                }
                getStats() {
                    return Promise.resolve({
                        framesDropped: 0,
                        framesTotal: 0
                    });
                }
                setScalingMode() {
                    return Promise.resolve();
                }
                cameraAutoControl(g) {
                    return Promise.resolve(!1);
                }
                getCameraManualControlStates(g) {
                    return Promise.resolve([]);
                }
                setCameraManualControlStates(g) {
                    return Promise.resolve([]);
                }
                enumerateCameraManualControls() {
                    return Promise.resolve([]);
                }
                isCameraAdvancedControlCapable() {
                    return Promise.resolve(!1);
                }
                dispose() {}
                constructor(){
                    super(...arguments), this.isRendering = !1, this.streamSize = {
                        width: 0,
                        height: 0
                    }, this.rendererType = -1, this.frameType = -1;
                }
            }, Ut = class extends ze {
                getSize() {
                    return {
                        width: 0,
                        height: 0
                    };
                }
                isMirrored() {
                    return !1;
                }
            }, Vt = class {
                getInputLevel() {
                    return 0;
                }
                getInputLevelNormalized(g, f) {
                    return 0;
                }
                dispose() {}
            }, Bt = ze, Ht = "http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01", $t = "http://www.webrtc.org/experiments/rtp-hdrext/abs-send-time", jt = "http://www.webrtc.org/experiments/rtp-hdrext/video-layers-allocation00", Gt = {
                MEDIA_STATE: {
                    send: "sendonly",
                    receive: "recvonly",
                    sendReceive: "sendrecv",
                    inactive: "inactive"
                },
                MEDIA_DIRECTION: {
                    SEND: "send",
                    RECV: "recv"
                },
                MEDIA_DEVICE_KIND: {
                    audioInput: "audioinput",
                    audioOutput: "audiooutput",
                    videoInput: "videoinput",
                    compositeAudio: "compositeAudio",
                    virtualDevice: "virtualDevice"
                },
                MEDIA_DEVICE: {
                    camera: "camera",
                    microphone: "microphone",
                    speaker: "speaker",
                    compositeAudio: "compositeAudio",
                    defaultId: "default",
                    communicationsId: "communications",
                    defaultDeviceLabel: "Default",
                    audioIngestDevice: "audioIngestDevice",
                    virtualDevice: "virtualDevice"
                },
                MEDIA_ERROR: {
                    constraintNotSatisfiedError: "ConstraintNotSatisfiedError",
                    iceConnectionError: "iceConnectionError",
                    srtpError: "srtpError",
                    permissionDeniedError: "permissionDeniedError",
                    internalError: "internalError",
                    sourceUnavailableError: "SourceUnavailableError",
                    devicesNotFoundError: "DevicesNotFoundError",
                    noDeviceSelected: "noDeviceSelected",
                    noNetworkError: "noNetworkError",
                    incompatibleOffer: "IncompatibleOffer",
                    mediaStreamRequestError: "MediaStreamRequestError",
                    extensionNotFoundError: "ExtensionNotFoundError",
                    sharingCancelledError: "SharingCancelledError",
                    permissionDeniedBySystemError: "PermissionsDeniedBySystem",
                    chromeRuntimeNotDefinedError: "ChromeRuntimeNotDefinedError",
                    mediaStreamRequestTimedOut: "MediaStreamRequestTimedout",
                    unsupportedStream: "UnsupportedStream",
                    webGlRendererError: "WebGlRendererError",
                    audioPlaybackError: "audioPlaybackError",
                    unexpectedClose: "unexpectedClose",
                    incompatibleOriginator: "incompatibleOriginator"
                },
                HISTOGRAM_BATCH: {
                    seconds1to3: 2,
                    seconds3to5: 4,
                    seconds5to8: 7,
                    seconds8to15: 14,
                    seconds15to60: 59,
                    seconds60toMax: 1e6
                },
                RENEGOTIATION_ERROR: {
                    local: "local",
                    glare: "glare",
                    signaling: "signaling",
                    media: "media",
                    escalation: "escalation"
                },
                MSI: {
                    unsubscribe: -1,
                    subscribeAny: -2
                },
                MEDIA_LABEL: {
                    audio: "main-audio",
                    video: "main-video",
                    sharing: "applicationsharing-video",
                    data: "data"
                },
                MEDIA_TYPE: {
                    audio: "audio",
                    video: "video",
                    sharing: "sharing",
                    data: "x-data",
                    dataChannel: "application"
                },
                MODALITY: {
                    audio: "audio",
                    video: "video",
                    sharing: "sharing",
                    data: "data"
                },
                TRACK_KIND: {
                    audio: "audio",
                    video: "video"
                },
                ICE_TRANSPORT_POLICY: {
                    all: "all",
                    relay: "relay"
                },
                RENDERER_TYPE: {
                    video: "video",
                    sharing: "sharing"
                },
                CONTENT_TYPE: {
                    SDP: "application/sdp",
                    SDP_NGC: "application/sdp-ngc-1.0"
                },
                ALLOWED_CONTENT_TYPES: {
                    SDP_ONLY: [
                        "application/sdp"
                    ],
                    SDP_NGC: [
                        "application/sdp",
                        "application/sdp-ngc-0.5",
                        "application/sdp-ngc-1.0"
                    ]
                },
                STREAMING_STATE: {
                    created: "created",
                    started: "started",
                    active: "active",
                    inactive: "inactive",
                    stopped: "stopped",
                    removed: "removed",
                    failed: "failed"
                },
                TIME_INTERVAL: {
                    SEC_1: 1
                },
                DISPLAY_SOURCE_ID: "display",
                EMPTY_DEVICE_ID: "0",
                SYSTEM_AUDIO_SOURCE_ID: "system",
                MULTIPLE_RECV_STREAMS: "multipleVideoStreams",
                PROFILES: {
                    udpTlsRtpSavpf: "UDP/TLS/RTP/SAVPF",
                    rtpSavpf: "RTP/SAVPF",
                    rtpSavp: "RTP/SAVP",
                    udpDtlsSctp: "UDP/DTLS/SCTP"
                },
                REPORTING_PROFILE: {
                    RT_PROFILE: "REAL_TIME",
                    BE_PROFILE: "BEST_EFFORT",
                    NRT_PROFILE: "NEAR_REAL_TIME"
                },
                PAYLOAD_TYPE: {
                    DATA_CHANNEL: "webrtc-datachannel",
                    X_DATA: "127 126",
                    MSRTC_RED: 97,
                    MSRTC_CNFB: 120
                },
                VIDEO_CAPABILITIES: {
                    MAX_FS_PATH: "max-fs",
                    MAX_MBPS_PATH: "max-mbps",
                    MAX_FPS_PATH: "max-fps",
                    MAX_BR_PATH: "max-br",
                    SSRC_PATH: "ssrc",
                    RID_PATH: "rid",
                    KEYFRAME_PATH: "KeyFrame",
                    MAX_WIDTH: "max-width",
                    MAX_HEIGHT: "max-height",
                    MAX_STREAMS: "max-streams",
                    MAX_LAYERS: "max-layers",
                    PRIORITY_LAYOUT_MIN_MBPR: "priority-layout-min-mbpr",
                    PRIORITY_LAYOUT_MIN_BITRATE: "priority-layout-min-bitrate",
                    VLA_DEBUG: "vla-debug"
                },
                TRANSPORT_CC: {
                    EXT_URI: Ht,
                    MSSDP_ENCODED_URI: Ht.replace(/\//g, "\\"),
                    ATTRIBUTE: "transport-cc"
                },
                ABS_SEND_TIME: {
                    EXT_URI: $t,
                    MSSDP_ENCODED_URI: $t.replace(/\//g, "\\")
                },
                VLA: {
                    EXT_URI: jt,
                    EXT_URI_NON_ADV: jt + "-non-advertised",
                    DEFAULT_VALUE: 10
                },
                MACROBLOCK_SIZE: 16,
                MAX_FS_1080P: 8160,
                MEDIA_EVENT_FIELDS: {
                    Extensions: [
                        "IceConnectionState",
                        "IceConnectionStatePrevious",
                        "SignalingState",
                        "SignalingStatePrevious"
                    ],
                    metrics: [
                        "ReconnectInProgress",
                        "IceConnectedStateTime",
                        "ErrorType",
                        "ErrorDetail",
                        "InitialNegotiationType",
                        "InitialNegotiationCompleted",
                        "TerminationReason_subCode",
                        "TerminationReason_code"
                    ]
                },
                RES_TABLE: {
                    SEND: [
                        {
                            w: 320,
                            h: 180,
                            fps: 15,
                            minBr: 2e4,
                            maxBr: 175e3
                        },
                        {
                            w: 416,
                            h: 234,
                            fps: 15,
                            minBr: 125e3,
                            maxBr: 5e5
                        },
                        {
                            w: 640,
                            h: 360,
                            fps: 30,
                            minBr: 4e5,
                            maxBr: 575e3
                        },
                        {
                            w: 960,
                            h: 540,
                            fps: 30,
                            minBr: 5e5,
                            maxBr: 1125e3
                        },
                        {
                            w: 1280,
                            h: 720,
                            fps: 30,
                            minBr: 1e6,
                            maxBr: 25e5
                        },
                        {
                            w: 1920,
                            h: 1080,
                            fps: 30,
                            minBr: 175e4,
                            maxBr: 1e8
                        }
                    ],
                    RECV: [
                        {
                            w: 320,
                            h: 180,
                            fps: 15,
                            minBr: 2e4,
                            maxBr: 175e3
                        },
                        {
                            w: 426,
                            h: 240,
                            fps: 15,
                            minBr: 125e3,
                            maxBr: 5e5
                        },
                        {
                            w: 640,
                            h: 360,
                            fps: 30,
                            minBr: 4e5,
                            maxBr: 575e3
                        },
                        {
                            w: 960,
                            h: 540,
                            fps: 30,
                            minBr: 5e5,
                            maxBr: 1125e3
                        },
                        {
                            w: 1280,
                            h: 720,
                            fps: 30,
                            minBr: 1e6,
                            maxBr: 25e5
                        },
                        {
                            w: 1920,
                            h: 1080,
                            fps: 30,
                            minBr: 175e4,
                            maxBr: 1e8
                        }
                    ]
                }
            };
            function forOwn(g, f) {
                for(const S in g)g.hasOwnProperty(S) && f(g[S], S);
            }
            function forOwnRec(g, f) {
                for(const S in g)g.hasOwnProperty(S) && ("object" == typeof g[S] ? forOwnRec(g[S], f) : f(g[S], S, g));
            }
            function isDefined(g) {
                return null != g && !Number.isNaN(g);
            }
            function getMinDefined(g, f) {
                return isDefined(f) ? isDefined(g) ? Math.min(g, f) : f : g;
            }
            function getMaxDefined(g, f) {
                return isDefined(f) ? isDefined(g) ? Math.max(g, f) : f : g;
            }
            function average(g) {
                let f = 0;
                return g.forEach((g)=>f += g), f /= g.length, f;
            }
            function remove2(g, f) {
                let S = !1;
                for(let v = g.length; v-- > 0;)f(g[v], v, g) && (g.splice(v, 1), S = !0);
                return S;
            }
            function compareArraysBy(g, f, S) {
                const v = [];
                return g.forEach((g)=>{
                    f.some((f)=>S(g, f)) || v.push(g);
                }), 0 === v.length && g.length === f.length;
            }
            function values(g) {
                const f = [];
                for(const S in g)g.hasOwnProperty(S) && f.push(g[S]);
                return f;
            }
            function assign(g, f) {
                for(const S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
            }
            function isEmpty(g) {
                return !Object.keys(g).length;
            }
            function keys(g) {
                return Object.keys(g);
            }
            function shallowClone(g) {
                const f = {};
                return forOwn(g, (g, S)=>{
                    f[S] = g;
                }), f;
            }
            function deepClone(g) {
                let f;
                if (!g || "object" != typeof g) return g;
                if (g instanceof Date) return f = new Date, f.setTime(g.getTime()), f;
                if (g instanceof Array) {
                    f = [];
                    for(let S = 0, v = g.length; S < v; S++)f[S] = deepClone(g[S]);
                    return f;
                }
                if (g instanceof Object) return f = {}, forOwn(g, function(g, S) {
                    f[S] = deepClone(g);
                }), f;
                throw new Error("Unable to copy: " + stringifyObject(g));
            }
            function removeUndefinedFields(g) {
                return Object.keys(g).forEach((f)=>{
                    void 0 === g[f] && delete g[f];
                }), g;
            }
            function uniqueId() {
                const segment = ()=>Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
                return segment() + segment() + segment() + "4" + segment().substring(1) + "b" + segment().substring(1) + segment() + segment() + segment();
            }
            function deepEqual(g, f) {
                let S;
                const v = typeof g;
                if (g === f) return !0;
                if (v !== typeof f || "object" !== v && "function" !== v) return !1;
                if (null === g || null === f) return g === f;
                if (g instanceof Date && f instanceof Date) return +g == +f;
                if (g instanceof Map && f instanceof Map) return compareMaps(g, f);
                for(S in g)if (!(S in f) || !deepEqual(g[S], f[S])) return !1;
                for(S in f)if (!(S in g) || !deepEqual(g[S], f[S])) return !1;
                return !0;
            }
            function compareMaps(g, f) {
                let S;
                if (g.size !== f.size) return !1;
                let v = !0;
                return g.forEach((g, _)=>{
                    S = f.get(_), (S !== g || void 0 === S && !f.has(_)) && (v = !1);
                }), v;
            }
            function getMaxSubstring(g, f) {
                return f.reduce((f, S)=>{
                    const v = g.includes(S) ? S.length : 0;
                    return f.length < v ? S : f;
                }, "");
            }
            function assertContentTypeSupported(g, f) {
                if (-1 === f.indexOf(g)) throw {
                    detail: `${g} mediaContent.contentType is not supported`,
                    type: Gt.MEDIA_ERROR.incompatibleOffer
                };
            }
            function throwIfFeatureNotSupported(g, f) {
                g.forEach((g)=>{
                    if ("" !== g && -1 !== f.findIndex((f)=>f === g)) throw {
                        detail: `Required feature '${g}' is not acceptable.`,
                        type: Gt.MEDIA_ERROR.incompatibleOffer
                    };
                });
            }
            function getClosestValue(g, f, S, v = 0) {
                for(let _ = 1; _ < g.length; _++)if (g[_ - 1] + v < f && f <= g[_] + v) return S ? g[_] : g[_ - 1];
                return g[0];
            }
            function isInRange(g, f, S) {
                return f <= g && g <= S;
            }
            function getFrom(g, ...f) {
                for (const S of f)if (S.hasOwnProperty(g)) return S[g];
            }
            function subtractFrom(g, f) {
                return g.filter((g)=>!f.some((f)=>f === g));
            }
            function getLongestCommonContiguousSubstring(g, f) {
                if (g === f) return g;
                let S = 0, v = 0, _ = "";
                for(let C = 0; C < g.length && !(_.length > g.length - C); C++){
                    let E = C;
                    v - S > _.length && (_ = g.substring(S, v), C = v - 1), S = C, v = C;
                    for(let T = 0; T < f.length; T++)E < g.length && f[T] === g[E++] ? v = E : (E = C, v - S > _.length && (_ = g.substring(S, v), C = v - 1), S = C, v = C);
                }
                return _;
            }
            function levenshteinDistance(g, f) {
                const S = new Array(g.length + 1);
                for(let v = 0; v < g.length + 1; v++){
                    S[v] = new Array(f.length + 1);
                    for(let g = 0; g < f.length + 1; g++)S[v][g] = 0;
                }
                for(let f = 1; f < g.length + 1; f++)S[f][0] = f;
                for(let g = 1; g < f.length + 1; g++)S[0][g] = g;
                for(let v = 1; v < g.length + 1; v++)for(let _ = 1; _ < f.length + 1; _++){
                    let C = 1;
                    g[v - 1] === f[_ - 1] && (C = 0), S[v][_] = Math.min(S[v - 1][_] + 1, S[v][_ - 1] + 1, S[v - 1][_ - 1] + C);
                }
                return S[g.length][f.length];
            }
            function getAverage(g) {
                return g.reduce((g, f)=>g + f, 0) / (g.length ? g.length : 1);
            }
            function round(g, f = 3) {
                return g && parseFloat(g.toFixed(f));
            }
            function scrubDeviceLabelPii(g, f) {
                if (!g) return "";
                if (g.length < 3) return g;
                const S = [], v = g.match(/\(([0-9a-zA-Z]+:[0-9a-zA-Z]+)\)/);
                v && S.push(v[1]);
                try {
                    if (f === null || f === void 0 ? void 0 : f.length) {
                        const v = new RegExp(`(${f.join("|")})`, "gi");
                        let _ = v.exec(g);
                        for(; _;)S.push(_[1]), _ = v.exec(g);
                    } else S.push("no_keywords");
                } catch (g) {
                    S.push(`Error: ${stringifyObject(g)}`);
                }
                return 0 === S.length ? "unknown" : S.join(" ");
            }
            function limitArraySize2(g, f, S = 0) {
                return g && void 0 !== f && f > -1 && g.length > f && g.splice(S, g.length - f), g;
            }
            function arrayLimitedPush2(g, f, S, v = 0) {
                limitArraySize2(g, 0 === S ? 0 : S - 1, v), 0 !== S && g.push(f);
            }
            function addGetterFields(g, f) {
                const S = {};
                for(const g in f)S[g] = {
                    get: f[g],
                    configurable: !1,
                    enumerable: !0
                };
                Object.defineProperties(g, S);
            }
            function getLast(g) {
                return (g === null || g === void 0 ? void 0 : g.length) > 0 ? g[g.length - 1] : void 0;
            }
            var qt = ((_window = window) === null || _window === void 0 ? void 0 : (_window_performance = _window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.now) && ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_performance1 = _window1.performance) === null || _window_performance1 === void 0 ? void 0 : _window_performance1.timeOrigin), Wt = qt ? ()=>window.performance.now() : ()=>Date.now(), zt = qt ? window.performance.timeOrigin : 0, Kt = Wt, Jt = zt;
            function rebaseTime(g, f, S) {
                if ((g === null || g === void 0 ? void 0 : g.length) > 0) {
                    const v = [];
                    for (const _ of g){
                        const g = deepClone(_);
                        g[f] = g[f] && g[f] - S, v.push(g);
                    }
                    return v;
                }
                return g;
            }
            function rebaseHistogramTimestamps(g, f) {
                if (!g) return;
                const S = {
                    seconds1to3: [],
                    seconds3to5: [],
                    seconds5to8: [],
                    seconds8to15: [],
                    seconds15to60: [],
                    seconds60toMax: []
                };
                for (const [v, _] of Object.entries(g))for (const g of _)S[v].push(g - f);
                return S;
            }
            function sampleseries(g, f, S = !1) {
                const v = g === null || g === void 0 ? void 0 : g.map(f).filter((g)=>void 0 !== g && !isNaN(g) && null !== g && "" !== g && (!1 === S || 0 !== g));
                return (v === null || v === void 0 ? void 0 : v.length) ? v.join(",") : void 0;
            }
            function sampleseriesArr(g, f, S) {
                const v = g === null || g === void 0 ? void 0 : g.map(f).filter((g)=>void 0 !== g && !isNaN(g) && null !== g && "" !== g).splice(-S);
                return (v === null || v === void 0 ? void 0 : v.length) ? v : void 0;
            }
            function clearObj(g, f) {
                const S = [];
                for (const v of Object.keys(g))f.has(v) || S.push(v);
                for (const f of S)delete g[f];
            }
            function clearMap(g, f) {
                const S = [];
                for (const v of g.keys())f.has(v) || S.push(v);
                for (const f of S)g.delete(f);
            }
            function convertContextProperty(g) {
                return "object" == typeof g ? stringifyObject(g) : g;
            }
            function getPercentilesProviderFromSampleFreqs(g) {
                const f = Object.keys(g).map(Number).sort((g, f)=>g - f), S = f.reduce((f, S)=>{
                    var _g_S;
                    return f + ((_g_S = g[S]) !== null && _g_S !== void 0 ? _g_S : 0);
                }, 0);
                return {
                    getPercentile: (v)=>{
                        const _ = S * v;
                        let C = 0;
                        for (const S of f)if (C += g[S], C >= _) return S;
                    }
                };
            }
            function getHeaderValue(g, f) {
                return g.hasOwnProperty(f) ? g[f] : g.hasOwnProperty(f.toLowerCase()) ? g[f.toLowerCase()] : void 0;
            }
            function parseServiceTokenTypes(g) {
                const f = g.toLowerCase(), S = 'token_types="', v = f.indexOf(S);
                if (-1 === v) return [];
                const _ = f.indexOf('"', v + S.length);
                if (-1 === _) return [];
                const C = f.substring(v + S.length, _).trim();
                if ("" === C) return [];
                return C.split(" ");
            }
            function ceilToMacroblock(g) {
                const f = 16;
                return Math.ceil(g / f) * f;
            }
            function limitRebaseAndStringifyEvents(g, f, S, v) {
                return JSON.stringify(rebaseTime(limitArraySize2(g, f), S, v));
            }
            var Yt = P;
            function createResolutionTable(g) {
                return g.map((g)=>new Qt(g.w, g.h, g.fps, g.minBr, g.maxBr));
            }
            var Qt = class {
                toString() {
                    return this.height ? `${this.height}p` : `${this.fs}fs`;
                }
                constructor(g, f, S = 0, v = 0, _ = 0){
                    this.width = g, this.height = f, this.fps = S, this.minBitrate = v, this.maxBitrate = _, this.fs = Math.ceil(g / Gt.MACROBLOCK_SIZE) * Math.ceil(f / Gt.MACROBLOCK_SIZE);
                }
            }, Xt = class _ResolutionTable {
                static initialize(g) {
                    _ResolutionTable.Send = new _ResolutionTable(g.config.sendResolutionTableOverride), _ResolutionTable.Recv = new _ResolutionTable(g.config.recvResolutionTableOverride), g.on("configUpdated", ()=>{
                        _ResolutionTable.Send = new _ResolutionTable(g.config.sendResolutionTableOverride), _ResolutionTable.Recv = new _ResolutionTable(g.config.recvResolutionTableOverride);
                    });
                }
                get initialResolution() {
                    return this.resolutions[this.resolutions.length - 1];
                }
                getResolutionByFs(g) {
                    return this.getResolutionRecord(void 0, g);
                }
                getMaxFsForHeight(g) {
                    return this.getResolutionRecord(g).fs;
                }
                getResolutionForBitrate(g) {
                    let f = this.resolutions.filter((f)=>f.maxBitrate && f.maxBitrate >= g).shift(), S = this.resolutions.filter((f)=>f.minBitrate && f.minBitrate <= g).pop();
                    return f = f !== null && f !== void 0 ? f : S, S = S !== null && S !== void 0 ? S : f, {
                        lowRes: f,
                        highRes: S
                    };
                }
                getBitrateForResolution(g, f) {
                    const S = this.getResolutionRecord(Math.min(g, f));
                    return {
                        minBitrate: S.minBitrate,
                        maxBitrate: S.maxBitrate
                    };
                }
                getResolutionRecord(g, f) {
                    if (this === _ResolutionTable.Send) {
                        for(let S = this.resolutions.length - 1; S >= 0; S--){
                            if (g && this.resolutions[S].height <= g) return this.resolutions[S];
                            if (f && this.resolutions[S].fs <= f) return this.resolutions[S];
                        }
                        return this.resolutions[0];
                    }
                    for (const S of this.resolutions){
                        if (g && S.height >= g) return S;
                        if (f && S.fs >= f) return S;
                    }
                    return this.resolutions[this.resolutions.length - 1];
                }
                getNextLowerResolution(g, f) {
                    const S = Math.min(g, f), v = this.getResolutionRecord(S), _ = this.resolutions.indexOf(v);
                    return S === Math.min(v.width, v.height) || this === _ResolutionTable.Recv ? this.resolutions[_ - 1] : this.resolutions[_];
                }
                getNextHigherResolution(g, f) {
                    const S = Math.min(g, f), v = this.getResolutionRecord(S), _ = this.resolutions.indexOf(v);
                    return S === Math.min(v.width, v.height) ? this.resolutions[_ + 1] : this === _ResolutionTable.Recv ? this.resolutions[_] : this.resolutions[_ + 1];
                }
                getResolutions() {
                    return this.resolutions;
                }
                constructor(g){
                    g || (this.resolutions = createResolutionTable(Gt.RES_TABLE.SEND)), this.resolutions = createResolutionTable(g);
                }
            };
            Xt.Recv = new Xt(Gt.RES_TABLE.RECV), Xt.Send = new Xt(Gt.RES_TABLE.SEND);
            var Zt = Xt, convertFramesizeToResolution = (g)=>Zt.Send.getResolutionByFs(g).height, convertResolutionToFramesize = (g)=>Zt.Send.getMaxFsForHeight(g), ei = {
                numVideoChannelsGvc: ({ current: g, constraints: f })=>getMaxIncomingStreams(g, f),
                specCompliantSimulcast: ({ current: g, constraints: f })=>getMaxSimulcastLayers(g, f),
                multiviewResolutionLimits: ({ current: g, constraints: f, logger: S })=>getMaxParticipantResolutions(g, f, S),
                enableVla: ({ current: g, settings: f, constraints: S, settingsSuffix: v })=>getVlaEnabledStatus(g, f, S, v),
                allowRemoteVla: ({ current: g, settings: f, constraints: S, settingsSuffix: v })=>getVlaEnabledStatus(g, f, S, v),
                enableNonAdvVla: ({ current: g, settings: f, constraints: S, settingsSuffix: v })=>getVlaEnabledStatus(g, f, S, v),
                outgoingVideoLimit: ({ current: g, settings: f, constraints: S })=>getOutgoingVideoLimit(g, f, S),
                webrtcCameraOpenFs: ({ current: g, settings: f, constraints: S, settingsSuffix: v })=>getMaxFsAccordingToLimit(g, f, S, v),
                webrtcVideoCapabilityMaxFS: ({ current: g, settings: f, constraints: S, settingsSuffix: v })=>getMaxFsAccordingToLimit(g, f, S, v)
            }, convertCallConstraintsToSettings = (g, f, S)=>({
                    ...buildSettings(g, f, S),
                    ...buildSettings(g, f, S, "1on1"),
                    ...buildSettings(g, f, S, "Multiparty")
                }), buildSettings = (g, f, S, v)=>{
                const _ = {};
                for (const C of Object.keys(ei)){
                    const E = `${C}${v !== null && v !== void 0 ? v : ""}`;
                    v && !isDefined(f[E]) || (_[E] = ei[C]({
                        current: f[E],
                        settings: f,
                        constraints: S,
                        settingsSuffix: v,
                        logger: g
                    }));
                }
                return _;
            }, getMaxIncomingStreams = (g, f)=>getMinDefined(g, f.maxIncomingStreams), getMaxParticipantResolutions = (g, f, S)=>{
                const v = f.maxParticipantResolutions;
                if (!v) return g;
                const _ = {
                    more: g.more
                };
                if (Number.isInteger(v)) Object.keys(g).forEach((f)=>{
                    _[f] = getMinDefined(v, g[f]);
                });
                else {
                    const f = Object.keys(v);
                    if (!f.length) return S.warn(`ignoring invalid value provided for maxParticipantResolutions: ${v}}`), g;
                    f.forEach((f)=>{
                        _[f] = getMinDefined(v[f], g[f] || g.more);
                    });
                }
                return _;
            }, getMaxSimulcastLayers = (g, f)=>void 0 !== f.maxSimulcastLayers || g.allowOverride ? {
                    ...g,
                    video: getConstrainedSimulcastConfig(g.video, f),
                    sharing: getConstrainedSimulcastConfig(g.sharing, f)
                } : g, getConstrainedSimulcastConfig = (g, f)=>{
                var _g_layerScaleFactors;
                const S = g === null || g === void 0 ? void 0 : (_g_layerScaleFactors = g.layerScaleFactors) === null || _g_layerScaleFactors === void 0 ? void 0 : _g_layerScaleFactors.filter((g)=>g <= f.maxSimulcastLayers);
                return (S === null || S === void 0 ? void 0 : S.length) > 1 ? {
                    ...g,
                    layerScaleFactors: S
                } : {
                    ...g,
                    enableLocally: !1,
                    allowEnableRemotely: !1
                };
            }, getMaxResolutionFromConstraints = (g)=>{
                var _g_outgoingVideoLimit;
                return getMinDefined((0, Yt.isNumber)(g === null || g === void 0 ? void 0 : g.outgoingVideoLimit) ? g === null || g === void 0 ? void 0 : g.outgoingVideoLimit : g === null || g === void 0 ? void 0 : (_g_outgoingVideoLimit = g.outgoingVideoLimit) === null || _g_outgoingVideoLimit === void 0 ? void 0 : _g_outgoingVideoLimit.maxResolution, g === null || g === void 0 ? void 0 : g.maxOutgoingResolution);
            }, getOutgoingVideoLimit = (g, f, S)=>{
                const { outgoingVideoLimit: v } = S, _ = (0, Yt.isNumber)(v), C = getMaxResolutionFromConstraints(S);
                let E = getMinDefined(g === null || g === void 0 ? void 0 : g.maxResolution, C);
                if (C > 0 && f.maxCameraFsViaCallConstraints > 0) E = getMaxDefined(E, getMinDefined(convertFramesizeToResolution(f.maxCameraFsViaCallConstraints), C));
                const T = getMinDefined(g === null || g === void 0 ? void 0 : g.maxBitrate, _ ? void 0 : v === null || v === void 0 ? void 0 : v.maxBitrate), I = getMinDefined(g === null || g === void 0 ? void 0 : g.maxFramerate, _ ? void 0 : v === null || v === void 0 ? void 0 : v.maxFramerate);
                return {
                    ...g,
                    maxResolution: E,
                    maxBitrate: T,
                    maxFramerate: I
                };
            }, getMaxFsAccordingToLimit = (g, f, S, v)=>{
                if (getMaxResolutionFromConstraints(S) > 0 && f.maxCameraFsViaCallConstraints > 0) {
                    const _ = `outgoingVideoLimit${v !== null && v !== void 0 ? v : ""}`, { maxResolution: C } = getOutgoingVideoLimit(f[_], f, S);
                    return getMaxDefined(g, C ? convertResolutionToFramesize(C) : g);
                }
                return g;
            }, getVlaEnabledStatus = (g, f, S, v)=>{
                var _f_;
                return !((f.specCompliantSimulcast.constraintsDisableVla || ((_f_ = f[`specCompliantSimulcast${v}`]) === null || _f_ === void 0 ? void 0 : _f_.constraintsDisableVla)) && S.maxSimulcastLayers < 2) && g;
            }, ti = class extends Bt {
                get constraints() {
                    return this._constraints;
                }
                get callConstraintsTelemetry() {
                    return this._callConstraintsTelemetry;
                }
                addCallConstraintsTelemetryEvent(g, f) {
                    const S = {
                        timestamp: (new Date).getTime(),
                        type: f,
                        value: g
                    };
                    this._callConstraintsTelemetry.push(S);
                }
                setConstraints(g) {
                    this.logger.debug("Setting new platform call constraints", JSON.stringify(g)), this._constraints = g, this.addCallConstraintsTelemetryEvent(g, "requested"), this.raiseChanged();
                }
                getSettings(g) {
                    return convertCallConstraintsToSettings(this.logger, g, this._constraints);
                }
                constructor(g){
                    super(g), this.logger = g, this._constraints = {}, this._callConstraintsTelemetry = [];
                }
            }, ii = P, ni = '"rtcmedia"';
            function getRelayCredentials(g) {
                return {
                    expires: g.expires,
                    username: g.username,
                    password: g.password,
                    realm: g.realm
                };
            }
            var ri = class {
                watch(g) {
                    const f = {
                        time: Date.now(),
                        duration: -1,
                        version: this.version
                    };
                    return this.reports[g] && (g = `${g}_last`), this.reports[g] = f, {
                        end: (g)=>{
                            g && (f.error = g), f.duration = Date.now() - f.time;
                        }
                    };
                }
                getReports() {
                    return this.reports;
                }
                constructor(g){
                    this.version = g, this.reports = {}, this.version || (this.version = 1);
                }
            };
            function clientToRelayConfig(g) {
                return {
                    Service: g.Service,
                    Relay: g.Relay,
                    Token: g.Token
                };
            }
            var ai = "configFetch", si = "skypeTokenFetch", oi = "trapTokenFetch", li = class {
                setRelayOverride(g) {
                    this.relaysOverride = g;
                }
                setDefaultRelayConfig(g) {
                    var _this_config;
                    (_this_config = this.config) !== null && _this_config !== void 0 ? _this_config : this.config = g;
                }
                async queryRelaysAsync(g = {}) {
                    if (this.logger.info("query relays"), this.relaysOverride.length > 0) return this.relaysOverride;
                    this.updateRelaysPromise || (this.updateRelaysPromise = this.updateRelaysFromConfigAsync());
                    const f = await this.updateRelaysPromise;
                    return f ? "turn" === g.relayType ? f.Turn : g.isRemoteClientLync ? f.Lync : f.Skype : [];
                }
                getAuthTokenStats() {}
                getStats() {
                    return {
                        config: clientToRelayConfig(this.config),
                        stats: this.timers.getReports()
                    };
                }
                updateRelaysFromConfigAsync(g = !1) {
                    const f = this.getConfigAsync().then(()=>this.updateRelaysAsync()).then((g)=>(this.updateRelaysPromise = f, g)).catch((f)=>(this.updateRelaysPromise = null, g ? this.logger.warn("failed to retrieve relays", stringifyRequestResponse(f)) : this.logger.error("failed to retrieve relays", stringifyRequestResponse(f)), null));
                    return f;
                }
                refreshRelaysFromConfig() {
                    this.request.isOnline() ? this.updateRelaysFromConfigAsync() : (this.updateRelaysPromise = null, this.logger.warn("not refreshing relays due to no network connection"));
                }
                updateRelaysAsync() {
                    const g = this.config.Service.tokenUrl;
                    let f;
                    const fetchTrapTokenThroughProvider = async ()=>(f = this.timers.watch(oi), this.context.trapTokenCredentialsProvider()), fetchTrapTokenDirectly = async ()=>{
                        const S = this.timers.watch(si);
                        let v = "";
                        try {
                            v = await this.context.tokenProvider(), this.logger.info("fetching skypeToken");
                        } catch (g) {
                            throw S.end(stringifyRequestResponse(g)), g;
                        }
                        S.end(), f = this.timers.watch(oi);
                        return (await this.request.get(g, {
                            headers: {
                                "X-Skypetoken": v,
                                "api-version": 2
                            }
                        })).response;
                    }, S = this.context.trapTokenCredentialsProvider ? fetchTrapTokenThroughProvider : fetchTrapTokenDirectly;
                    return this.logger.info("Fetch TRAP token " + (this.context.trapTokenCredentialsProvider ? "with provider" : "directly")), S().then((g)=>{
                        f.end();
                        let S = 0;
                        const v = this.config.Token.earlyRefreshMinutes, _ = this.config.Token.earlyRefreshPercentage;
                        this.storeTrapTokens(g), S = Math.max(g.expires - 60 * v, g.expires * _ / 100), setTimeout(this.refreshRelaysFromConfig.bind(this), 1e3 * S);
                        const C = this.config.Relay.Turn.realm ? this.config.Relay.Turn.realm : ni, E = getRelayCredentials(this.getTrapToken(C)), T = {
                            addresses: this.config.Relay.Skype.addresses,
                            fqdns: this.config.Relay.Skype.fqdns,
                            tcpPort: this.config.Relay.Skype.tcpPort,
                            udpPort: this.config.Relay.Skype.udpPort,
                            type: "msturn"
                        }, I = {
                            addresses: this.config.Relay.Lync.addresses,
                            fqdns: this.config.Relay.Lync.fqdns,
                            tcpPort: this.config.Relay.Lync.tcpPort,
                            udpPort: this.config.Relay.Lync.udpPort,
                            type: "msturn"
                        }, b = {
                            addresses: this.config.Relay.Turn.addresses,
                            fqdns: this.config.Relay.Turn.fqdns,
                            tcpPort: this.config.Relay.Turn.tcpPort,
                            udpPort: this.config.Relay.Turn.udpPort,
                            tlsPort: this.config.Relay.Turn.tlsPort,
                            type: "turn"
                        }, A = {
                            Skype: [
                                {
                                    ...T,
                                    ...E
                                }
                            ],
                            Lync: [
                                {
                                    ...I,
                                    ...E
                                }
                            ],
                            Turn: [
                                {
                                    ...b,
                                    ...E
                                }
                            ]
                        };
                        return this.logger.info("relays from trap", [
                            T,
                            I,
                            b
                        ]), A;
                    }).catch((g)=>{
                        throw f && f.end(stringifyRequestResponse(g)), g;
                    });
                }
                storeTrapTokens(g) {
                    if (!(g === null || g === void 0 ? void 0 : g.tokens)) return void this.logger.error("failed to get tokens from trap response");
                    const f = {};
                    g.tokens.forEach((S)=>{
                        f[S.realm] = {
                            expires: g.expires,
                            username: S.username,
                            password: S.password,
                            realm: S.realm
                        };
                    }), this.trapTokens = f;
                }
                getTrapToken(g) {
                    if ("string" == typeof g) {
                        const f = g.replace(/^"|"$/g, ""), S = `"${f}"`, v = this.trapTokens[S] || this.trapTokens[f];
                        if (v) return v;
                    }
                    throw new Error(`token for relay not found, realm: ${g}`);
                }
                async getConfigAsync() {
                    this.logger.info("retrieving configuration");
                    const g = this.timers.watch(ai);
                    try {
                        const f = await this.context.configProvider();
                        g.end(), this.logger.info("retrieved configuration:", f), (0, ii.isEmpty)(f) || (this.config = f), this.logger.info("applied configuration:", this.config);
                    } catch (f) {
                        this.logger.warn("failed to retrieve configuration", stringifyObject(f)), g.end(stringifyRequestResponse(f));
                    }
                }
                constructor(g){
                    this.updateRelaysPromise = null, this.trapTokens = {}, this.relaysOverride = [], this.timers = new ri, this.context = g, this.logger = g.logger.createChild("RM"), this.request = g.request, this.updateRelaysPromise || (this.updateRelaysPromise = this.updateRelaysFromConfigAsync(!0));
                }
            };
            function build(g) {
                return new li(g);
            }
            var ci = P, di = "aadTokenFetch", ui = class {
                setRelayOverride(g) {
                    this.relaysOverride = g;
                }
                setDefaultRelayConfig(g) {
                    var _this_config;
                    (_this_config = this.config) !== null && _this_config !== void 0 ? _this_config : this.config = g, this.updateRelaysPromise || (this.updateRelaysPromise = this.updateRelaysFromConfigAsync(!0));
                }
                setClientSupportsGenericTokenApi(g) {
                    this.authTokenFetcher.supportsGenericTokenApi = g;
                }
                async queryRelaysAsync(g = {}) {
                    if (this.logger.info("query relays"), this.relaysOverride.length > 0) return this.relaysOverride;
                    this.updateRelaysPromise || (this.updateRelaysPromise = this.updateRelaysFromConfigAsync());
                    const f = await this.updateRelaysPromise;
                    return f ? "turn" === g.relayType ? f.Turn : g.isRemoteClientLync ? f.Lync : f.Skype : [];
                }
                getStats() {
                    return {
                        config: clientToRelayConfig(this.config),
                        stats: this.timers.getReports()
                    };
                }
                getAuthTokenStats() {
                    return this.context.authTokenFetcher.getStats();
                }
                updateRelaysFromConfigAsync(g = !1) {
                    const f = this.getConfigAsync().then(()=>this.updateRelaysAsync()).then((g)=>(this.updateRelaysPromise = f, g)).catch((f)=>(this.updateRelaysPromise = null, g ? this.logger.warn("failed to retrieve relays", stringifyRequestResponse(f)) : this.logger.error("failed to retrieve relays", stringifyRequestResponse(f)), null));
                    return f;
                }
                refreshRelaysFromConfig() {
                    this.context.isOnline() ? this.updateRelaysFromConfigAsync() : (this.updateRelaysPromise = null, this.logger.warn("not refreshing relays due to no network connection"));
                }
                async updateRelaysAsync() {
                    var _this_context_configProvider;
                    const g = ((_this_context_configProvider = this.context.configProvider) === null || _this_context_configProvider === void 0 ? void 0 : _this_context_configProvider.useNewTokenApi) ? di : si, f = this.timers.watch(g), S = generateCauseId();
                    this.logger.info(`${S}[RM2] Fetch TRAP token`);
                    try {
                        const g = await this.context.authTokenFetcher.fetchTrapToken(S, this.config);
                        f.end();
                        let v = 0;
                        const _ = this.config.Token.earlyRefreshMinutes, C = this.config.Token.earlyRefreshPercentage;
                        this.storeTrapTokens(g), v = Math.max(g.expires - 60 * _, g.expires * C / 100), setTimeout(this.refreshRelaysFromConfig.bind(this), 1e3 * v);
                        const E = this.config.Relay.Turn.realm ? this.config.Relay.Turn.realm : ni, T = getRelayCredentials(this.getTrapToken(E)), I = {
                            addresses: this.config.Relay.Skype.addresses,
                            fqdns: this.config.Relay.Skype.fqdns,
                            tcpPort: this.config.Relay.Skype.tcpPort,
                            udpPort: this.config.Relay.Skype.udpPort,
                            type: "msturn"
                        }, b = {
                            addresses: this.config.Relay.Lync.addresses,
                            fqdns: this.config.Relay.Lync.fqdns,
                            tcpPort: this.config.Relay.Lync.tcpPort,
                            udpPort: this.config.Relay.Lync.udpPort,
                            type: "msturn"
                        }, A = {
                            addresses: this.config.Relay.Turn.addresses,
                            fqdns: this.config.Relay.Turn.fqdns,
                            tcpPort: this.config.Relay.Turn.tcpPort,
                            udpPort: this.config.Relay.Turn.udpPort,
                            tlsPort: this.config.Relay.Turn.tlsPort,
                            type: "turn"
                        }, R = {
                            Skype: [
                                {
                                    ...I,
                                    ...T
                                }
                            ],
                            Lync: [
                                {
                                    ...b,
                                    ...T
                                }
                            ],
                            Turn: [
                                {
                                    ...A,
                                    ...T
                                }
                            ]
                        };
                        return this.logger.info("relays from trap", [
                            I,
                            b,
                            A
                        ]), R;
                    } catch (g) {
                        throw this.logger.info(`Fetch TRAP token failed with error ${g}`), f && f.end(stringifyRequestResponse(g)), g;
                    }
                }
                storeTrapTokens(g) {
                    const f = {};
                    if (g === null || g === void 0 ? void 0 : g.tokens) g.tokens.forEach((S)=>{
                        f[S.realm] = {
                            expires: g.expires,
                            username: S.username,
                            password: S.password,
                            realm: S.realm
                        };
                    });
                    else {
                        if (!g.realm) return void this.logger.error("failed to get tokens from trap response");
                        f[g.realm] = g;
                    }
                    this.trapTokens = f;
                }
                getTrapToken(g) {
                    if ("string" == typeof g) {
                        const f = g.replace(/^"|"$/g, ""), S = `"${f}"`, v = this.trapTokens[S] || this.trapTokens[f];
                        if (v) return v;
                    }
                    throw new Error(`token for relay not found, realm: ${g}`);
                }
                async getConfigAsync() {
                    this.logger.info("retrieving configuration");
                    const g = this.timers.watch(ai);
                    try {
                        const f = await this.context.relayConfigProvider();
                        g.end(), this.logger.info("retrieved configuration:", f), (0, ci.isEmpty)(f) || (this.config = f), this.logger.info("applied configuration:", this.config);
                    } catch (f) {
                        this.logger.warn("failed to retrieve configuration", stringifyRequestResponse(f)), g.end(stringifyRequestResponse(f));
                    }
                }
                constructor(g){
                    this.updateRelaysPromise = null, this.trapTokens = {}, this.relaysOverride = [], this.timers = new ri(2), this.context = g, this.authTokenFetcher = this.context.authTokenFetcher, this.logger = g.logger.createChild("RM2");
                }
            }, hi = class {
                set supportsGenericTokenApi(g) {
                    this.clientSupportsGenericTokenAPI = g;
                }
                buildHeaders(g, f) {
                    var _this_configProvider;
                    const S = {
                        "api-version": 2
                    };
                    switch(((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.useTokenMigrationHeader) && (S["X-MS-Migration"] = "True"), g){
                        case 4:
                        case 8:
                            return S.Authorization = `Bearer ${f}`, S;
                        case 1:
                            return S["X-Skypetoken"] = f, S;
                        default:
                            throw new Error(`TokenType ${g} is not supported`);
                    }
                }
                serviceSupportedTokenTypes(g) {
                    var _this_configProvider;
                    let f = null;
                    if (void 0 === g) f = this.clientSupportedTokenTypes();
                    else {
                        const S = g === null || g === void 0 ? void 0 : g.toLowerCase();
                        f = this.constructTokenType(S);
                    }
                    return null === f && ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.useSkypeTokenWhenNoAuthenticateHeader) && (f |= 1), f;
                }
                extractWwwauthenticateHeaders(g) {
                    let f = {};
                    if (g) {
                        const S = getHeaderValue(g, "www-authenticate");
                        S && (f = {
                            authenticationHeaders: [
                                S
                            ]
                        });
                    }
                    return f;
                }
                convertStringToTokenType(g) {
                    switch(g){
                        case "cae":
                            return 8;
                        case "aad":
                            return 4;
                        case "skype":
                            return 1;
                        default:
                            return this.logger.info("[authTokenFetcher][convertStringToTokenType]unexpected: unrecognized token type ${tokenType}"), null;
                    }
                }
                getTokenTypeFromHeaders(g, f) {
                    var _this_configProvider;
                    if (!this.clientSupportsGenericTokenAPI) return 1;
                    let S = null;
                    const v = f === null || f === void 0 ? void 0 : f.authenticationHeaders;
                    if (!v && g) ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.useSkypeTokenWhenNoAuthenticateHeader) ? (this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] no www-authenticate header received, fallback to skype token"), S = 1) : (this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] Service has not provided www-authenticate headers. use client supported tokens"), S = this.clientSupportedTokenTypes());
                    else if (v || g) {
                        if (v && g) for (const g of v){
                            var _this_configProvider1;
                            const f = parseServiceTokenTypes(g);
                            if (((_this_configProvider1 = this.configProvider) === null || _this_configProvider1 === void 0 ? void 0 : _this_configProvider1.supportMissingTokenTypesInResponse) && 0 === f.length) this.logger.info("[authTokenFetcher][getAuthHeadersTokenTypes] Service has www-authenticate header, but no token types. Use client supported tokens"), S = this.clientSupportedTokenTypes();
                            else for (const g of f){
                                var _this_configProvider2, _this_configProvider3, _this_configProvider4;
                                const f = this.convertStringToTokenType(g.toLowerCase());
                                ((_this_configProvider2 = this.configProvider) === null || _this_configProvider2 === void 0 ? void 0 : _this_configProvider2.clientSupportsCaeToken) && 8 === f && (S |= 8), ((_this_configProvider3 = this.configProvider) === null || _this_configProvider3 === void 0 ? void 0 : _this_configProvider3.clientSupportsAadToken) && 4 === f && (S |= 4), ((_this_configProvider4 = this.configProvider) === null || _this_configProvider4 === void 0 ? void 0 : _this_configProvider4.clientSupportsSkypeToken) && 1 === f && (S |= 1);
                            }
                        }
                    } else this.logger.info("[authTokenFetcher][getTokenTypeFromHeaders] retrying to fetch token woth client supported tokens"), S = this.clientSupportedTokenTypes();
                    return S;
                }
                constructTokenType(g) {
                    var _this_configProvider, _this_configProvider1, _this_configProvider2;
                    let f = null;
                    return g.includes("aad") && ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.clientSupportsAadToken) && (f |= 4), g.includes("cae") && ((_this_configProvider1 = this.configProvider) === null || _this_configProvider1 === void 0 ? void 0 : _this_configProvider1.clientSupportsCaeToken) && (f |= 8), g.includes("skype") && ((_this_configProvider2 = this.configProvider) === null || _this_configProvider2 === void 0 ? void 0 : _this_configProvider2.clientSupportsSkypeToken) && (f |= 1), f;
                }
                getTokenMetadataForTrapService(g, f, S) {
                    const v = {
                        verb: "POST",
                        path: g
                    }, _ = JSON.stringify(v);
                    let C = null;
                    const E = this.extractWwwauthenticateHeaders(S), T = !!(E === null || E === void 0 ? void 0 : E.authenticationHeaders);
                    return C = S ? this.getTokenTypeFromHeaders(T, E) : this.serviceSupportedTokenTypes(f), this.logger.info(`[authTokenFetcher][getTokenMetadata] return token type=${C}, factoJson=${_}`), {
                        tokenType: C,
                        factorsJson: _,
                        requestMetadataJson: E,
                        isUnauthorized: T
                    };
                }
                clientSupportedTokenTypes() {
                    var _this_configProvider, _this_configProvider1, _this_configProvider2;
                    let g = null;
                    return ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.clientSupportsAadToken) && (g |= 4), ((_this_configProvider1 = this.configProvider) === null || _this_configProvider1 === void 0 ? void 0 : _this_configProvider1.clientSupportsCaeToken) && (g |= 8), ((_this_configProvider2 = this.configProvider) === null || _this_configProvider2 === void 0 ? void 0 : _this_configProvider2.clientSupportsSkypeToken) && (g |= 1), g;
                }
                async handleAuthTokenFailure(g, f, S, v) {
                    this.logger.info("[authTokenFetcher][handleAuthTokenFailure] failed to fetch token, retrying");
                    try {
                        const _ = this.getTokenMetadataForTrapService(f, void 0, S);
                        this.logger.info(`[authTokenFetcher][handleAuthTokenFailure] token request options=${_}`), _.invalidToken = v;
                        return await this.signalingAgentProvider.getSignalingAgent().authTokenManager.getToken(g, !1, _);
                    } catch (g) {
                        var _g_response;
                        const f = {
                            status: (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status) || (g === null || g === void 0 ? void 0 : g.status),
                            error: g,
                            fatal: !0
                        };
                        this.errors.push(stringifyObject(f)), this.logger.error(`[authTokenFetcher] failed to fetch token trough new api with error: ${stringifyObject(f)}, quiting`);
                    }
                }
                getRequestToken(g) {
                    const f = getHeaderValue(g, "X-Skypetoken");
                    if (f) return f;
                    const S = getHeaderValue(g, "Authorization");
                    if (S) {
                        const g = S.split(" ");
                        if (2 === g.length) return g[1];
                    }
                }
                async fetchTrapCredentials(g, f, S) {
                    const v = this.buildHeaders(f, g), _ = await this.request.get(S, {
                        headers: v
                    });
                    return _ === null || _ === void 0 ? void 0 : _.response;
                }
                async fetchTrapTokenWithNewTokenApi(g, f, S) {
                    let v;
                    this.logger.info(`${S}[authTokenFetcher] fetching token through fetchTrapTokenWithNewTokenApi`);
                    const _ = this.getTokenMetadataForTrapService(g, f);
                    try {
                        v = await this.signalingAgentProvider.getSignalingAgent().authTokenManager.getToken(S, !1, _), this.tokenTypeFetched = this.signalingAgentProvider.getSignalingAgent().authTokenManager.getLastTokenType(S);
                        return await this.fetchTrapCredentials(v, this.tokenTypeFetched, g);
                    } catch (f) {
                        var _f_response, _f_response1;
                        const _ = {
                            status: (f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.status) || (f === null || f === void 0 ? void 0 : f.status),
                            error: f,
                            fatal: !1
                        };
                        this.errors.push(stringifyObject(_)), this.logger.error(`${S}[authTokenFetcher] fetchTrapTokenWithNewTokenApi failed with ${stringifyObject(_)}, retrying...`);
                        const C = f === null || f === void 0 ? void 0 : (_f_response1 = f.response) === null || _f_response1 === void 0 ? void 0 : _f_response1.headers;
                        if (C) {
                            const f = this.getRequestToken(C);
                            v = await this.handleAuthTokenFailure(S, g, C, f), this.tokenTypeFetched = this.signalingAgentProvider.getSignalingAgent().authTokenManager.getLastTokenType(S);
                            return await this.fetchTrapCredentials(v, this.tokenTypeFetched, g);
                        }
                        throw f;
                    }
                }
                async fetchTrapTokenThroughProvider() {
                    return this.logger.info("[authTokenFetcher][authTokenFetcher] fetching token through fetchTrapTokenThroughProvider"), this.tokenProviders.trapTokenCredentialsProvider();
                }
                async fetchTrapTokensWithLegacyTokenFetcher(g, f) {
                    this.logger.info(`${f}[authTokenFetcher][authTokenFetcher] fetching token through fetchTrapTokensWithLegacyTokenFetcher`);
                    try {
                        this.tokenTypeFetched = 1;
                        const f = await this.tokenProviders.skypeTokenProvider();
                        return (await this.request.get(g, {
                            headers: {
                                "X-Skypetoken": f,
                                "api-version": 2
                            }
                        })).response;
                    } catch (g) {
                        throw this.errors.push(stringifyObject(g)), this.logger.error(`${f}[authTokenFetcher] fetchTrapTokensWithLegacyTokenFetcher failed with ${stringifyObject(g)}`), g;
                    }
                }
                getStats() {
                    return {
                        tokenType: this.tokenTypeFetched,
                        errors: this.errors
                    };
                }
                async fetchTrapToken(g, f) {
                    var _this_configProvider;
                    let S;
                    this.logger.info(`${g}[AuthTokenFetcher] Start fetching token`);
                    const v = f.Service.tokenUrl, _ = f.Service.supportedTokenTypes;
                    return S = ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.useNewTokenApi) ? this.fetchTrapTokenWithNewTokenApi(v, _, g) : this.tokenProviders.trapTokenCredentialsProvider ? this.fetchTrapTokenThroughProvider() : this.fetchTrapTokensWithLegacyTokenFetcher(v, g), S;
                }
                constructor(g, f, S, v, _){
                    this.signalingAgentProvider = f, this.request = S, this.tokenProviders = v, this.configProvider = _, this.errors = [], this.clientSupportsGenericTokenAPI = !1, this.logger = g.createChild("AuthTokenFetcher");
                }
            }, gi = class {
                getOrCreateRelayManager() {
                    return this.config.relayManager ? this.config.relayManager : this.relayManager || this.createRelayManager();
                }
                setConfigProvider(g) {
                    this.configProvider = g;
                }
                createRelayManager() {
                    var _this_relayManager;
                    return (_this_relayManager = this.relayManager) !== null && _this_relayManager !== void 0 ? _this_relayManager : this.relayManager = this.buildRelayManager(this.config.httpRequestDispatcher, this.config.tokenProvider, this.config.configProvider, this.config.appStateProvider, this.config.trapTokenCredentialsProvider, this.configProvider);
                }
                buildRelayManager(g, f, S, v, _, C) {
                    const E = g || new He(this.logger), T = {
                        get: (g, f)=>E.getAsync(g, E.getRequestOptions("GET", f === null || f === void 0 ? void 0 : f.headers, null, f === null || f === void 0 ? void 0 : f.timeout)),
                        isOnline: v.isOnline
                    };
                    if (this.configProvider.config.useNewTokenApi) {
                        var _this_configProvider;
                        const g = new hi(this.logger, this.signalingAgentProvider, T, {
                            skypeTokenProvider: f,
                            trapTokenCredentialsProvider: _
                        }, C === null || C === void 0 ? void 0 : C.config);
                        return new ui({
                            logger: this.logger,
                            relayConfigProvider: ()=>S.getRelayConfig(),
                            isOnline: v.isOnline,
                            authTokenFetcher: g,
                            configProvider: (_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.config
                        });
                    }
                    return build({
                        logger: this.logger,
                        tokenProvider: f,
                        trapTokenCredentialsProvider: _,
                        configProvider: ()=>S.getRelayConfig(),
                        request: {
                            get: (g, f)=>E.getAsync(g, E.getRequestOptions("GET", f === null || f === void 0 ? void 0 : f.headers, null, f === null || f === void 0 ? void 0 : f.timeout)),
                            isOnline: v.isOnline
                        }
                    });
                }
                constructor(g, f, S){
                    this.config = g, this.signalingAgentProvider = f, this.logger = S;
                }
            }, pi = {
                CALL_SETUP_NATIVE: "skypecosi_concore_native_ts_calling_call_setup_session",
                CALL_IN_CALL_NATIVE: "skypecosi_concore_native_ts_calling_in_call_session",
                REGISTRY_WEB: "skypecosi_concore_web_ts_calling_registry",
                REGISTRY_NATIVE: "skypecosi_concore_native_ts_calling_registry"
            }, mi = {
                PARK: "*11",
                SHARED_LINE: "*12",
                SERVER_HOLD: "*13",
                CALL_PARK: "*14"
            }, fi = {
                totalParticipants: 0,
                preheatedParticipants: 0,
                lobbyParticipants: 0,
                totalPresenters: 0,
                requestingAttentionPresenters: 0,
                totalAttendees: 0,
                requestingAttentionAttendees: 0,
                overflowAttendees: 0
            }, Si = R, vi = 150, _i = 30, Ci = class {
                set variant(g) {
                    this.eventVariant = g;
                }
                recordSuccess(g, f) {
                    this.recordResult("Success", g, f);
                }
                recordFailure(g, f) {
                    this.recordResult("Failure", g, f);
                }
                recordTimeout(g, f) {
                    this.recordResult("Timeout", g, f);
                }
                addData(g) {
                    this.data.push(g);
                }
                isPending() {
                    return "Pending" === this.status;
                }
                getEvent() {
                    const g = {
                        start: this.eventStartTime,
                        duration: this.duration,
                        status: this.status,
                        result: this.result,
                        causeId: this.causeId,
                        resultCauseId: this.resultCauseId,
                        variant: this.eventVariant,
                        data: this.data.map((g)=>this.prepareData(g, !0)).filter((g)=>!!g)
                    };
                    return "Event" === this.type && delete g.status, g.data.length || delete g.data, g.causeId || delete g.causeId, g.resultCauseId || delete g.resultCauseId, g.result || delete g.result, g.variant || delete g.variant, {
                        [this.eventName]: g
                    };
                }
                recordResult(g, f, S) {
                    this.status = g, this.result = this.prepareData(f), this.causeId !== S && (this.resultCauseId = S), this.duration = (new Date).getTime() - this.eventStartTimestamp;
                }
                prepareData(g, f = !1) {
                    if (null == g) return "";
                    if ("string" == typeof g) return scrubMriOrOmit(g);
                    if ("number" == typeof g || "boolean" == typeof g) return String(g);
                    if ("function" == typeof g) return "";
                    if (g instanceof Error) return g.toString();
                    try {
                        return Object.keys(g).length ? f ? g : getPIISafeObject(g) : "";
                    } catch (g) {
                        return "invalid";
                    }
                }
                constructor(g, f, S, v, _){
                    this.eventName = g, this.eventStartTime = f, this.type = S, this.causeId = v, this.status = "Pending", this.eventStartTimestamp = (new Date).getTime(), this.data = [], this.causeId = v === null || v === void 0 ? void 0 : v.substring(0, 8), "Event" === this.type && delete this.status, _ && this.data.push(_);
                }
            }, yi = class {
                recordEvent(g, f, S = generateCauseId()) {
                    this.logger.debug("Event:", g, Si.pii.Omit(f));
                    const v = new Ci(g, this.getEventStartTime(), "Event", S, f);
                    return this.pushToRecordedEvents(v), v;
                }
                recordOperationSuccess(g, f = null, S, v, _) {
                    this.logger.info("Event success:", v, g, Si.pii.Omit(S), Si.pii.Omit(f)), this.recordOperationResult(g, f, "Success", S, v, _);
                }
                recordOperationFailure(g, f, S, v, _) {
                    this.logger.info("Event failure:", g, Si.pii.Omit(S), f), this.recordOperationResult(g, f, "Failure", S, v, _);
                }
                recordOperationTimeout(g, f, S, v, _) {
                    this.logger.info("Event timeout:", g, Si.pii.Omit(S), f), this.recordOperationResult(g, f, "Timeout", S, v, _);
                }
                maybeRecordOperationSuccess(g, f = null, S, v, _) {
                    this.hasOngoingEvent(g, S) && this.recordOperationSuccess(g, f, S, v, _);
                }
                maybeRecordOperationFailure(g, f, S, v, _) {
                    this.hasOngoingEvent(g, S) && this.recordOperationFailure(g, f, S, v, _);
                }
                maybeRecordOperationTimeout(g, f, S, v, _) {
                    this.hasOngoingEvent(g, S) && this.recordOperationTimeout(g, f, S, v, _);
                }
                recordOperationResult(g, f, S, v, _, C) {
                    this.hasOngoingEvent(g, v) || this.recordOperation(g, _, v);
                    let E = this.ongoingOperations[g];
                    switch(v && (E = E[v]), C && E.addData(C), S){
                        case "Success":
                            E.recordSuccess(f, _);
                            break;
                        case "Failure":
                            E.recordFailure(f, _);
                            break;
                        case "Timeout":
                            E.recordTimeout(f, _);
                            break;
                        default:
                            this.logger.error("Unknown operation record state in record operation result.");
                    }
                    v ? delete this.ongoingOperations[g][v] : delete this.ongoingOperations[g];
                }
                recordOperation(g, f, S, v) {
                    this.logger.debug("Event create:", f, g, Si.pii.Omit(S), v);
                    const _ = new Ci(g, this.getEventStartTime(), "Operation", f, v);
                    return this.ongoingOperations[g] || (this.ongoingOperations[g] = {}), S ? this.ongoingOperations[g][S] = _ : this.ongoingOperations[g] = _, this.pushToRecordedEvents(_), _;
                }
                setOperationVariant(g, f, S) {
                    let v;
                    v = S ? this.ongoingOperations[g][S] : this.ongoingOperations[g], v ? v.variant = f : this.logger.error(`Could not find operation ${g} to set variant ${f}`);
                }
                updateOperationData(g, f, S, v) {
                    try {
                        if (!this.ongoingOperations[g]) return void this.recordEvent(g, f, S);
                        v ? this.ongoingOperations[g][v] && this.ongoingOperations[g][v].addData(f) : this.ongoingOperations[g].addData(f);
                    } catch (f) {
                        return void this.logger.info(`Unable to update operation: ${g} data`);
                    }
                }
                pushToRecordedEvents(g) {
                    if (this.maxEventsExceeded && this.maxEventsExceeded() && this.recordedEvents.shift(), this.recordedEvents.push(g), this.perfModule && this.ipcStats.length <= _i) {
                        const g = this.perfModule.getIpcStats();
                        g && this.ipcStats.push({
                            ingestionTime: this.getEventStartTime(),
                            stats: g
                        });
                    }
                }
                hasOngoingEvent(g, f) {
                    return this.ongoingOperations[g] ? !(f && !this.ongoingOperations[g][f]) || (this.logger.warn(`Unable to find event for name\\id ${g}\\${Si.pii.Omit(f)}`), !1) : (this.logger.warn(`Unable to find event for name ${g}`), !1);
                }
                getEventStartTime() {
                    return (new Date).getTime() - this.startTime;
                }
                getEventTimestampBag(g, f) {
                    const S = f ? [
                        f.getEvent()
                    ] : this.recordedEvents.filter((f)=>!g || !f.isPending()).map((g)=>g.getEvent()), v = JSON.stringify({
                        eventStart: this.startTime,
                        events: S
                    });
                    return this.logger.info(`Call eventTimestampBag ${Si.pii.Omit(v)}`), v;
                }
                getIPCStats() {
                    return 0 !== this.ipcStats.length ? JSON.stringify(this.ipcStats) : "";
                }
                removeRecordedEvent(g) {
                    const f = this.recordedEvents.indexOf(g);
                    f > -1 && this.recordedEvents.splice(f, 1);
                }
                constructor(g, f, S, v){
                    this.logger = g, this.startTime = f, this.maxEventsExceeded = S, this.perfModule = v, this.recordedEvents = [], this.ipcStats = [], this.ongoingOperations = {};
                }
            }, Ei = class extends yi {
                setClientType(g) {
                    this.clientType = g;
                }
                setEndpointId(g) {
                    this.endpointId = g;
                }
                setSkypeId(g) {
                    this.skypeId = scrubMriOrOmit(g);
                }
                setApplicationType(g) {
                    this.applicationType = g;
                }
                setRing(g) {
                    this.ring = g;
                }
                setTenantId(g) {
                    this.tenantId = g;
                }
                setUserHexCID(g) {
                    this.userHexCID = g;
                }
                setAcsResourceId(g) {
                    this.acsResourceId = g;
                }
                setRegion(g) {
                    this.region = g;
                }
                setPartition(g) {
                    this.partition = g;
                }
                getEvent(g, f) {
                    const getValue2 = (g)=>void 0 === g ? "" : g;
                    return {
                        EndpointId: getValue2(this.endpointId),
                        SkypeId: getValue2(this.skypeId),
                        ApplicationType: getValue2(this.applicationType),
                        Ring: getValue2(this.ring),
                        TenantId: getValue2(this.tenantId),
                        userHexCID: getValue2(this.userHexCID),
                        AcsResourceId: getValue2(this.acsResourceId),
                        Region: getValue2(this.region),
                        Partition: getValue2(this.partition),
                        TsCallingVersion: getValue2(this.tsCallingVersion),
                        HostName: this.getHostName(),
                        EventTimestampBag: this.getEventTimestampBag(g, f),
                        DiagnosticInfo: this.callEndDiagnosticInfo,
                        ClientType: getValue2(this.clientType)
                    };
                }
                removeNonPendingOperations() {
                    this.recordedEvents = this.recordedEvents.filter((g)=>g.isPending());
                }
                constructor(g, f){
                    super(g, f, ()=>this.recordedEvents.length > vi), this.getHostName = ()=>{
                        try {
                            return "localhost" === location.hostname || "127.0.0.1" === location.hostname ? "localhost" : "<redacted>";
                        } catch (g) {
                            return "unknown";
                        }
                    }, this.tsCallingVersion = getTsCallingVersion(), this.logger = g.createChild("CallRegistryTelemetry");
                }
            }, Ti = class extends yi {
                setClientType(g) {
                    this.clientType = g;
                }
                setCallId(g) {
                    this.currentCallId && (this.previousCallId = this.currentCallId), this.currentCallId = g;
                }
                setConsultativeCallId(g) {
                    this.consultativeCallId = g;
                }
                setEndpointId(g) {
                    this.endpointId = g;
                }
                setParticipantId(g) {
                    this.participantId = g;
                }
                setDisplayName(g) {
                    this.displayName = g;
                }
                setPreheatFlags(g) {
                    this.preheatFlags = g;
                }
                setCallOrigin(g) {
                    this.origin = g;
                }
                setGroupId(g) {
                    this.groupId = g;
                }
                setThreadId(g) {
                    this.threadId = g;
                }
                setBackroomThreadId(g) {
                    this.backroomThreadId = g;
                }
                setStreamThreadId(g) {
                    this.streamThreadId = g;
                }
                setLobbyThreadId(g) {
                    this.lobbyThreadId = g;
                }
                setComplianceRecordingContentLength(g) {
                    this.complianceRecordingContentLength = g;
                }
                setConversationStartTime(g) {
                    this.conversationStartTime = g;
                }
                setMessageId(g) {
                    this.messageId = g;
                }
                setSkypeId(g) {
                    this.skypeId = scrubMriOrOmit(g);
                }
                setApplicationType(g) {
                    this.applicationType = g;
                }
                setRing(g) {
                    this.ring = g;
                }
                setTenantId(g) {
                    this.tenantId = g;
                }
                setUserHexCID(g) {
                    this.userHexCID = g;
                }
                setAcsResourceId(g) {
                    this.acsResourceId = g;
                }
                setRegion(g) {
                    this.region = g;
                }
                setPartition(g) {
                    this.partition = g;
                }
                setFailureType(g) {
                    this.failureType = g;
                }
                setIsCast(g) {
                    this.isCast = g ? "True" : "False";
                }
                setIsHuddleGroupCall(g) {
                    this.isHuddleGroupCall = g ? "True" : "False";
                }
                setIsEmergency(g) {
                    this.isEmergency = g ? "True" : "False";
                }
                setRole(g) {
                    this.isAnonymous = "admin" === g ? "False" : "True";
                }
                setCallType(g) {
                    this.callType = g;
                }
                setConversationType(g) {
                    this.conversationType = g;
                }
                setDirection(g) {
                    this.direction = g;
                }
                setSelfParticipantRole(g) {
                    this.selfParticipantRole = g;
                }
                setTerminationState(g) {
                    this.terminationState = g;
                }
                setTerminationReason(g) {
                    this.terminationReason = g;
                }
                setCallEndDiagnosticInfo(g) {
                    this.callEndDiagnosticInfo = g;
                }
                setStackConfig(g) {
                    this.stackConfig = g;
                }
                setJoinedFrom(g) {
                    this.joinedFrom = g;
                }
                setMeetingCode(g) {
                    this.meetingCode = g;
                }
                setMeetingUrl(g) {
                    this.meetingUrl = g;
                }
                setHasMeetingRegistrationId(g) {
                    this.hasMeetingRegistrationId = g ? "True" : "False";
                }
                setHasParticipantPin(g) {
                    this.hasParticipantPin = g ? "True" : "False";
                }
                getEvent(g, f) {
                    const getValue2 = (g)=>void 0 === g ? "" : g;
                    var _this_displayName;
                    return {
                        CorrelationId: getValue2(this.currentCallId),
                        PreviousCorrelationId: getValue2(this.previousCallId),
                        ConsultativeCallId: getValue2(this.consultativeCallId),
                        EndpointId: getValue2(this.endpointId),
                        SkypeId: getValue2(this.skypeId),
                        ParticipantId: getValue2(this.participantId),
                        DisplayName: new xe((_this_displayName = this.displayName) !== null && _this_displayName !== void 0 ? _this_displayName : "", 1),
                        PreheatFlags: getValue2(this.preheatFlags),
                        CallType: getValue2(this.callType),
                        ConversationType: getValue2(this.conversationType),
                        Direction: getValue2(this.direction),
                        Origin: getValue2(this.origin),
                        SelfParticipantRole: getValue2(this.selfParticipantRole),
                        IsAnonymous: getValue2(this.isAnonymous),
                        GroupId: scrubMriOrOmit(getValue2(this.groupId)),
                        ThreadId: getLoggableThreadId(getValue2(this.threadId)),
                        MessageId: getValue2(this.messageId),
                        ApplicationType: getValue2(this.applicationType),
                        Ring: getValue2(this.ring),
                        TenantId: getValue2(this.tenantId),
                        UserHexCID: getValue2(this.userHexCID),
                        AcsResourceId: getValue2(this.acsResourceId),
                        Region: getValue2(this.region),
                        Partition: getValue2(this.partition),
                        FailureType: getValue2(this.failureType),
                        IsCast: getValue2(this.isCast),
                        IsHuddleGroupCall: getValue2(this.isHuddleGroupCall),
                        IsEmergency: getValue2(this.isEmergency),
                        TsCallingVersion: getValue2(this.tsCallingVersion),
                        TerminationState: getValue2(this.terminationState),
                        TerminationReason: getValue2(this.terminationReason),
                        StackConfig: getValue2(this.stackConfig),
                        EventTimestampBag: this.getEventTimestampBag(g, f),
                        HostName: this.getHostName(),
                        DiagnosticInfo: this.callEndDiagnosticInfo,
                        JoinedFrom: this.joinedFrom,
                        MeetingCode: this.meetingCode,
                        MeetingUrl: this.meetingUrl,
                        HasMeetingRegistrationId: this.hasMeetingRegistrationId,
                        HasParticipantPin: this.hasParticipantPin,
                        IPCStats: this.getIPCStats(),
                        ComplianceRecordingContentLength: getValue2(this.complianceRecordingContentLength),
                        ConversationStartTime: getValue2(this.conversationStartTime),
                        BackroomThreadId: getLoggableThreadId(getValue2(this.backroomThreadId)),
                        StreamThreadId: getLoggableThreadId(getValue2(this.streamThreadId)),
                        LobbyThreadId: getLoggableThreadId(getValue2(this.lobbyThreadId)),
                        ClientType: getValue2(this.clientType)
                    };
                }
                getShortEvent() {
                    const getValue2 = (g)=>void 0 === g ? "" : g;
                    var _this_displayName;
                    return {
                        CorrelationId: getValue2(this.currentCallId),
                        EndpointId: getValue2(this.endpointId),
                        ParticipantId: getValue2(this.participantId),
                        DisplayName: new xe((_this_displayName = this.displayName) !== null && _this_displayName !== void 0 ? _this_displayName : "", 1),
                        CallType: getValue2(this.callType),
                        ConversationType: getValue2(this.conversationType),
                        Direction: getValue2(this.direction),
                        Origin: getValue2(this.origin),
                        SelfParticipantRole: getValue2(this.selfParticipantRole),
                        IsAnonymous: getValue2(this.isAnonymous),
                        ThreadId: getLoggableThreadId(getValue2(this.threadId)),
                        ApplicationType: getValue2(this.applicationType),
                        Ring: getValue2(this.ring),
                        TenantId: getValue2(this.tenantId),
                        UserHexCID: getValue2(this.userHexCID),
                        AcsResourceId: getValue2(this.acsResourceId),
                        Region: getValue2(this.region),
                        TsCallingVersion: getValue2(this.tsCallingVersion),
                        DiagnosticInfo: this.callEndDiagnosticInfo,
                        JoinedFrom: this.joinedFrom,
                        ClientType: getValue2(this.clientType)
                    };
                }
                switchToInCallTelemetry() {
                    this.recordedEvents = this.recordedEvents.filter((g)=>g.isPending()), this.inCallMode = !0;
                }
                getHostName() {
                    try {
                        return location.host;
                    } catch (g) {
                        return "unknown";
                    }
                }
                constructor(g, f, S){
                    super(g, f, ()=>this.inCallMode && this.recordedEvents.length > vi, S), this.inCallMode = !1, this.tsCallingVersion = getTsCallingVersion(), this.logger = g.createChild("CallTelemetry");
                }
            }, getEndpointInformationForTelemetry = (g)=>Array.isArray(g) ? g.map((g)=>({
                        endpointId: g.endpointId,
                        participantId: g.participantId
                    })) : null, calculateJoinedFromForTelemetry = (g, f, S, v, _)=>{
                if (g) {
                    if (g.meetingUrl) return "MeetingUrl";
                    if (g.meetingCode) return "MeetingCode";
                }
                return f || S ? "ThreadContext" : v ? "GroupId" : _ ? "Awareness" : "";
            };
            function sanitizeMeetingCode(g, f, S) {
                if (!g) return S.info(`sanitizeMeetingCode[${f}] empty / undefined meeting code parameter`), g;
                let v = g.replace(/\s/g, "");
                return v = v.replace(/-/g, ""), S.info(`sanitizeMeetingCode[${f}] meetingCode: ${g}, sanitizedMeetingCode: ${v}`), v;
            }
            function getMeetingCodeFromMeetingUrl(g, f, S) {
                if (!g) return S.info(`getMeetingCodeFromMeetingUrl[${f}] empty / undefined meeting Url parameter`), g;
                const v = new URL(g);
                let _ = "";
                if (v && v.pathname && v.pathname.split("/").length >= 2) {
                    const g = v.pathname.split("/");
                    "meet" === g[g.length - 2] && (_ = g[g.length - 1]);
                }
                return S.info(`getMeetingCodeFromMeetingUrl[${f}] meetingUrl: ${g}, meetingUrlObject: ${safeJsonStringify(v)}, meetingCode: ${_}`), _;
            }
            function compareMeetingData(g, f, S, v) {
                const _ = sanitizeMeetingCode(g && g.meetingCode || "", S, v), C = sanitizeMeetingCode(f && f.meetingCode || "", S, v), definedAndEqual = (g, f)=>!!g && !!f && g === f;
                if (definedAndEqual(_, C)) return !0;
                let E = getMeetingCodeFromMeetingUrl(g && g.meetingUrl || "", S, v);
                E = sanitizeMeetingCode(E, S, v);
                let T = getMeetingCodeFromMeetingUrl(f && f.meetingUrl || "", S, v);
                if (T = sanitizeMeetingCode(T, S, v), definedAndEqual(E, T)) return !0;
                if (definedAndEqual(E, C) || definedAndEqual(T, _)) return !0;
                if (g && g.meetingUrl && f && f.meetingUrl) {
                    const S = new URL(g.meetingUrl), v = new URL(f.meetingUrl);
                    if (S.hostname === v.hostname && S.pathname === v.pathname) return !0;
                }
                return !1;
            }
            function noop() {}
            var Ii = {
                CODE: {
                    SUCCESS: 0,
                    MEDIA_ERROR: 410,
                    CLIENT_ERROR_CODE: 499,
                    UNKNOWN_ERROR: 497
                },
                SUB_CODE: {
                    VDI_DISCONNECTED: 3e3,
                    ACTION_NOT_ALLOWED: 3548,
                    INVALID_DATA_TYPE: 3757,
                    ABANDONED: 4990,
                    ENDED_BY_REMOTE_ENDPOINT: 5028,
                    BEACON: 4521,
                    UNKNOWN_FAILURE: 3545,
                    SLIMCORE_CALL_SETUP_FAILURE: 3546
                }
            }, bi = 4294967294, Ai = "_operationIdValue_", Ri = "_causeIdValue_", Pi = "_callStartOptionsValue_", wi = "_clientReasonValue_";
            function callOperation(g, f, S = !1) {
                return operationDecorator(0, g, f, S);
            }
            function participantOperation(g, f) {
                return operationDecorator(1, g, f);
            }
            var operationId = (g, f, S)=>{
                if (g[f][Ai]) throw new Error("can not specify more than one operation id");
                g[f][Ai] = S;
            }, causeId = (g, f, S)=>{
                if (g[f][Ri]) throw new Error("can not specify more than one cause id");
                g[f][Ri] = S;
            }, callStartOptions = (g, f, S)=>{
                if (g[f][Pi]) throw new Error("can not specify options more than once");
                g[f][Pi] = S;
            }, reason = (g, f, S)=>{
                if (g[f][wi]) throw new Error("can not specify reason more than once");
                g[f][wi] = S;
            }, operationDecorator = (g, f, S, v = !1)=>(_, C, E)=>{
                    var __C, __C1, __C2, __C3;
                    const T = E.value, I = (__C = _[C]) === null || __C === void 0 ? void 0 : __C[Ai], b = (__C1 = _[C]) === null || __C1 === void 0 ? void 0 : __C1[Ri], A = (__C2 = _[C]) === null || __C2 === void 0 ? void 0 : __C2[Pi], R = (__C3 = _[C]) === null || __C3 === void 0 ? void 0 : __C3[wi], P = (S === null || S === void 0 ? void 0 : S.type) || "Async";
                    return E.value = function(..._) {
                        const C = this;
                        let E = v ? generateGuid() : generateCauseId();
                        void 0 !== b && (_[b] && (validateCauseId(_[b]) || validateGuid(_[b])) ? E = _[b] : _[b] = E);
                        let w, M = void 0 !== I ? _[I] : void 0;
                        if (void 0 !== M) {
                            if (Array.isArray(M)) try {
                                const g = M.map((g)=>g.toString()).sort().concat().toString();
                                M = getStringHash(g).toString();
                            } catch (e) {
                                const g = `[${M}]${f} failed in array parsing in operationDecorator`, S = {
                                    terminatedReason: 32,
                                    terminatedReasonCode: Ii.CODE.UNKNOWN_ERROR,
                                    terminatedReasonSubCode: Ii.SUB_CODE.UNKNOWN_FAILURE,
                                    errorMessage: g
                                };
                                return Promise.reject(S);
                            }
                            else if (M && "object" == typeof M) try {
                                let g = JSON.stringify(M);
                                S && S.operationIdKey && M.hasOwnProperty(S.operationIdKey) && (g = M[S.operationIdKey]), M = g;
                            } catch (e) {
                                const g = `[${M}]${f} failed in object parsing in operationDecorator`, S = {
                                    terminatedReason: 32,
                                    terminatedReasonCode: Ii.CODE.UNKNOWN_ERROR,
                                    terminatedReasonSubCode: Ii.SUB_CODE.UNKNOWN_FAILURE,
                                    errorMessage: g
                                };
                                return Promise.reject(S);
                            }
                        }
                        void 0 !== R && _[R] && (w = _[R]);
                        const O = getOperationHandler(C, g);
                        if (O.logOperation(E, f), S && S.singular && O.hasPendingOperation(f)) return O.logOperation(E, f, "Not allowed, pending operation exists"), Promise.reject(60);
                        if (S && S.idempotencyLevel && O.getRecord(f) > 0) switch(O.logOperation(E, f, `Called multiple times, handling operation according to specified policy: idempotency=${S.idempotencyLevel}`), S.idempotencyLevel){
                            case "NoOp":
                                return Promise.resolve();
                            case "Error":
                                return Promise.reject(60);
                        }
                        try {
                            void 0 !== A && _[A] && C.processCallStartOptions(_[A], E);
                        } catch (e) {
                            const g = `${f} failed in processCallStartOptions`, S = {
                                terminatedReason: 32,
                                terminatedReasonCode: Ii.CODE.UNKNOWN_ERROR,
                                terminatedReasonSubCode: Ii.SUB_CODE.UNKNOWN_FAILURE,
                                errorMessage: g
                            };
                            return Promise.reject(S);
                        }
                        const D = !(!S || !S.convertError), execute = ()=>"Chained" === P ? O.executeChained(T.bind(this, ..._), f, M, E, D, w, S) : "Sync" === P ? O.executeSync(T.bind(this, ..._), f, M, E, D, w) : O.execute(T.bind(this, ..._), f, M, E, D, w, S);
                        if ("StartCall" !== f && "JoinCall" !== f || O.hasPendingOperation("_CallStartOrJoinInitiated") || O.createPendingOperation("_CallStartOrJoinInitiated").catch(noop), S && S.triggerAttach && (O.hasPendingOperation("_ElectronSlimcoreReady") || O.createPendingOperation("_ElectronSlimcoreReady").catch(noop)), S && "Sync" !== S.type) {
                            const g = S && S.waitFor;
                            if (Array.isArray(g)) return Promise.all(g.map((g)=>g && O.hasPendingOperation(g) && O.waitForOperation(g, void 0, E))).then(execute, execute);
                            if (g && O.hasPendingOperation(g)) return O.waitForOperation(g, void 0, E).then(execute, execute);
                        }
                        return execute();
                    }, E;
                }, getOperationHandler = (g, f)=>{
                if (0 === f) return g._callOperationHandler;
                if (1 === f) return g._participantOperationHandler;
                throw new Error("Unsupported operation handler type!");
            };
            function getStringHash(g) {
                let f = 0;
                for(let S = 0; S < g.length; S++)f = (f << 5) - f + g.charCodeAt(S), f |= 0;
                return f;
            }
            var Mi = class {
                registerPromise(g, f) {
                    let S = !1;
                    const always = ()=>{
                        S = !0;
                    };
                    f.then(always, always);
                    const v = this._endOperationDeferred.promise.catch((f)=>{
                        if (!S) throw new Error(`Operation ${g} did not complete, reason:${f}`);
                    });
                    return Promise.race([
                        v,
                        f
                    ]);
                }
                updateOperationId(g, f) {
                    this._logger.info(`updateOperationId ${g} ${f}`), Object.keys(this._deferredOperationsWithOperationId).forEach((S)=>{
                        S && this._deferredOperationsWithOperationId[S] && (this._logger.info(`_deferredOperationsWithOperationId ${S}`), Object.keys(this._deferredOperationsWithOperationId[S]).forEach((v)=>{
                            v && this._deferredOperationsWithOperationId[S][v] && (this._logger.info(`_deferredOperationsWithOperationId ${v} ${f}`), v === g && (this._deferredOperationsWithOperationId[S][f] = this._deferredOperationsWithOperationId[S][v], delete this._deferredOperationsWithOperationId[S][v]));
                        }));
                    }), Object.keys(this._deferredOperationsWithCauseId).forEach((S)=>{
                        S && this._deferredOperationsWithCauseId[S] && (this._logger.info(`_deferredOperationsWithCauseId ${S}`), Object.keys(this._deferredOperationsWithCauseId[S]).forEach((v)=>{
                            v && this._deferredOperationsWithCauseId[S][v] && (this._logger.info(`_deferredOperationsWithCauseId ${v} ${f}`), v === g && (this._deferredOperationsWithOperationId[S][f] = this._deferredOperationsWithOperationId[S][v], delete this._deferredOperationsWithOperationId[S][v]));
                        }));
                    });
                }
                createPendingOperation(g, f, S = generateCauseId(), v = {}) {
                    const _ = new ct;
                    _.promise.catch(noop);
                    const C = this.getOperationInfoForLogging(S, g, f);
                    let E;
                    if (this._logger.info(`${C}[creating...]`), this._disposed) return this._logger.info(`${C}[create failed, call is disposed]`), Promise.reject(60);
                    if (f) {
                        if (this._deferredOperationsWithOperationId[g] || (this._deferredOperationsWithOperationId[g] = {}), this._deferredOperationsWithOperationId[g][f]) return this._logger.warn(`${C} Deferred operation with given name and operation id is already defined`), Promise.reject(new Error(`Deferred operation with given name is already defined:${g}/${scrubMriOrOmit(f)}`));
                        this._deferredOperationsWithOperationId[g][f] = {
                            deferred: _,
                            causeId: S
                        }, this._deferredOperationsWithCauseId[S] || (this._deferredOperationsWithCauseId[S] = {}), this._deferredOperationsWithCauseId[S][f] = {
                            deferred: _,
                            options: v,
                            operationName: g
                        }, E = this._endOperationDeferred.promise.catch((S)=>{
                            if (this.hasPendingOperationWithOperationId(g, f)) throw new Error(`Operation ${g} ${f} did not complete, reason:${S}`);
                        });
                    } else {
                        if (this._deferredOperations[g]) return this._logger.warn(`${C} Deferred operation with given name is already defined`), Promise.reject(new Error(`Deferred operation with given name is already defined:${g}`));
                        this._deferredOperationsWithCauseId[S] || (this._deferredOperationsWithCauseId[S] = {}), this._deferredOperationsWithCauseId[S][""] = {
                            deferred: _,
                            options: v,
                            operationName: g
                        }, this._deferredOperations[g] = {
                            deferred: _,
                            causeId: S
                        }, E = this._endOperationDeferred.promise.catch((f)=>{
                            if (this.hasPendingOperation(g)) throw new Error(`Operation ${g} did not complete, reason:${f}`);
                        });
                    }
                    return Promise.race([
                        E,
                        _.promise
                    ]);
                }
                hasPendingOperation(g) {
                    return !!this._deferredOperations[g];
                }
                hasAtleastOneOfPendingOperation(g) {
                    for (const f of g)if (this.hasPendingOperation(f)) return !0;
                    return !1;
                }
                hasPendingOperationWithOperationId(g, f) {
                    return !(!f || !this._deferredOperationsWithOperationId[g]) && !!this._deferredOperationsWithOperationId[g][f];
                }
                hasPendingOperationWithCauseId(g, f) {
                    const S = f || "";
                    return this._deferredOperationsWithCauseId[g] && !!this._deferredOperationsWithCauseId[g][S];
                }
                getPendingOperationWithCauseId(g, f) {
                    return this.hasPendingOperationWithCauseId(g, f) ? this._deferredOperationsWithCauseId[g][f].deferred.promise : Promise.reject(`[${g}][${f}]: getPendingOperationWithCauseId for given causeId, operationId`);
                }
                resolveOperationWithCauseId(g, f, S) {
                    const v = f || "";
                    if (this.hasPendingOperationWithCauseId(g, v)) {
                        const f = this._deferredOperationsWithCauseId[g][v], _ = f.deferred.promise;
                        return f.deferred.resolve(S), this._logger.info(`[${g}][${v}] resolved, result=${getPrintableObject(S) || "void"}`), delete this._deferredOperationsWithCauseId[g][v], _;
                    }
                    return Promise.reject(`[${g}][${v}] resolveOperationWithCauseId failed, operation not found`);
                }
                rejectOperationWithCauseId(g, f, S) {
                    const v = f || "";
                    if (this.hasPendingOperationWithCauseId(g, v)) {
                        const f = this._deferredOperationsWithCauseId[g][v], _ = f.deferred.promise;
                        return _.catch(noop), f.deferred.reject(S), this._logger.info(`[${g}][${v}] rejected, result=${getPrintableObject(S) || "void"}`), delete this._deferredOperationsWithCauseId[g][v], _;
                    }
                    return Promise.reject(`[${g}][${v}] rejectOperationWithCauseId failed, operation not found`);
                }
                maybeResolveOperationWithCauseId(g, f, S) {
                    this.hasPendingOperationWithCauseId(g, f) ? this.resolveOperationWithCauseId(g, f, S).catch((f)=>{
                        this._logger.info(`${g}maybeResolveOperationWithCauseId failed, reason=${getPrintableObject(f)}`);
                    }) : this._logger.info(`${g}maybeResolveOperationWithCauseId ignored, operation does not exist`);
                }
                maybeRejectOperationWithCauseId(g, f, S) {
                    this.hasPendingOperationWithCauseId(g, f) ? this.rejectOperationWithCauseId(g, f, S).catch(noop) : this._logger.info(`${g}maybeRejectOperationWithCauseId ignored, operation does not exist`);
                }
                getPendingOperation(g, f, S = generateCauseId()) {
                    return !f && this._deferredOperations[g] ? this._deferredOperations[g].deferred.promise : f && this._deferredOperationsWithOperationId[g] && this._deferredOperationsWithOperationId[g][f] ? this._deferredOperationsWithOperationId[g][f].deferred.promise : Promise.reject(`${this.getOperationInfoForLogging(S, g, f)}: Deferred operation with given name and operation does not exist`);
                }
                waitForOperation(g, f, S = generateCauseId()) {
                    return f && this.hasPendingOperationWithOperationId(g, f) ? this._deferredOperationsWithOperationId[g][f].deferred.promise : this.hasPendingOperation(g) ? this._deferredOperations[g].deferred.promise : Promise.reject(`${this.getOperationInfoForLogging(S, g, f)}failed=wait failed, operation not found`);
                }
                resolveOperation(g, f, S, v = generateCauseId(), _ = !1) {
                    if (!g) return Promise.reject("Unable to resolve deferred operation with empty name");
                    if (S && this.hasPendingOperationWithOperationId(g, S)) {
                        const v = this._deferredOperationsWithOperationId[g][S], C = v.deferred.promise;
                        return v.deferred.resolve(f), this._logger.info(`${this.getOperationInfoForLogging(v.causeId, g, S)}resolved, result=${getPrintableObject(f) || "void"}`), _ || delete this._deferredOperationsWithOperationId[g][S], C;
                    }
                    if (this.hasPendingOperation(g)) {
                        const v = this._deferredOperations[g], C = this._deferredOperations[g].deferred.promise;
                        return this._deferredOperations[g].deferred.resolve(f), this._logger.info(`${this.getOperationInfoForLogging(v.causeId, g, S)}resolved, result=${getPrintableObject(f) || "void"}`), _ || delete this._deferredOperations[g], C;
                    }
                    return Promise.reject(`${this.getOperationInfoForLogging(v, g, S)}failed=resolve failed, operation not found`);
                }
                rejectOperation(g, f, S, v = generateCauseId()) {
                    if (!g) return Promise.reject("Unable to reject deferred operation with empty name");
                    if (S && this.hasPendingOperationWithOperationId(g, S)) {
                        const v = this._deferredOperationsWithOperationId[g][S], _ = v.deferred.promise;
                        return _.catch(noop), v.deferred.reject(f), this._logger.info(`${this.getOperationInfoForLogging(v.causeId, g, S)}rejected, reason=${getPrintableObject(f) || "void"}`), delete this._deferredOperationsWithOperationId[g][S], _;
                    }
                    if (this.hasPendingOperation(g)) {
                        const v = this._deferredOperations[g], _ = v.deferred.promise;
                        return _.catch(noop), v.deferred.reject(f), this._logger.info(`${this.getOperationInfoForLogging(v.causeId, g, S)}rejected, reason=${getPrintableObject(f) || "void"}`), delete this._deferredOperations[g], _;
                    }
                    return Promise.reject(`${this.getOperationInfoForLogging(v, g, S)}failed=reject failed, operation not found`);
                }
                maybeResolveOperation(g, f, S, v = generateCauseId()) {
                    const _ = this.getOperationInfoForLogging(v, g, S);
                    S && this.hasPendingOperationWithOperationId(g, S) || this.hasPendingOperation(g) ? this.resolveOperation(g, f, S, v).catch((g)=>{
                        this._logger.info(`${_}maybeResolveOperation failed, reason=${getPrintableObject(g)}`);
                    }) : this._logger.info(`${_}maybeResolveOperation ignored, operation does not exist`);
                }
                maybeResolveOperations(g, f, S, v = generateCauseId()) {
                    for (const _ of g)this.maybeResolveOperation(_, f, S, v);
                }
                maybeRejectOperation(g, f, S, v = generateCauseId()) {
                    const _ = this.getOperationInfoForLogging(v, g, S);
                    S && this.hasPendingOperationWithOperationId(g, S) || this.hasPendingOperation(g) ? this.rejectOperation(g, f, S, v).catch(noop) : this._logger.info(`${_}maybeRejectOperation ignored, operation does not exist`);
                }
                maybeRejectOperations(g, f, S, v = generateCauseId()) {
                    for (const _ of g)this.maybeRejectOperation(_, f, S, v);
                }
                rejectPendingOperations(g, f = generateCauseId()) {
                    this._disposed = !0, this._logger.info(`[${f}]rejectPendingOperations=${JSON.stringify(g)}`), Object.keys(this._deferredOperations).forEach((S)=>{
                        this.maybeRejectOperation(S, g, void 0, f), this._deferredOperationsWithOperationId[f] && delete this._deferredOperationsWithOperationId[f][""];
                    }), Object.keys(this._deferredOperationsWithOperationId).forEach((S)=>{
                        Object.keys(this._deferredOperationsWithOperationId[S]).forEach((v)=>{
                            this.maybeRejectOperation(S, g, v, f), this._deferredOperationsWithOperationId[f] && delete this._deferredOperationsWithOperationId[f][v];
                        });
                    }), this._deferredOperations = {}, this._deferredOperationsWithOperationId = {}, this._endOperationDeferred.reject(g);
                }
                maybeRejectPendingOperationsWithPredicate(g, f = generateCauseId(), S) {
                    this._logger.info(`[${f}]rejectPendingOperationsWithPredicate`), Object.keys(this._deferredOperationsWithCauseId).forEach((f)=>{
                        Object.keys(this._deferredOperationsWithCauseId[f]).forEach((v)=>{
                            const _ = this._deferredOperationsWithCauseId[f][v];
                            _ && S(_.operationName, _.options) && (this.maybeRejectOperation(_.operationName, g, v), this.maybeRejectOperationWithCauseId(f, v, g));
                        });
                    });
                }
                getOperationInfoForLogging(g, f, S = "") {
                    const v = S ? `[${scrubMriOrOmit(S)}]` : "";
                    return `[${g.substring(0, 8)}][${f}]${v}`;
                }
                constructor(g){
                    this._disposed = !1, this._logger = g.createChild("[ASYNC]"), this._endOperationDeferred = new ct, this._endOperationDeferred.promise.catch((g)=>{
                        this._logger.info("Rejected all operations");
                    }), this._deferredOperations = {}, this._deferredOperationsWithOperationId = {}, this._deferredOperationsWithCauseId = {}, this._logger = g;
                }
            }, Oi = P, Di = class {
                chainPromise(g, f, S = generateCauseId(), v = !1) {
                    const _ = Date.now(), C = (("function" == typeof f ? f() : f) || "").toString();
                    this._actionQueue.push(C), this._logger.info(`[${S}][${C}]enqueueing, queue=[${this._actionQueue}], reset=${v}`);
                    const removeFromQueue = ()=>{
                        this._actionQueue = this._actionQueue.filter((g)=>g !== C);
                    };
                    return v && this.reset(S), this._promise = this._promise.catch(Oi.noop).then(()=>{
                        const f = Date.now() - _;
                        return this._logger.info(`[${S}][${C}]begin, delayMs=${f}`), g();
                    }), this._promise.then(()=>{
                        removeFromQueue();
                        const g = Date.now() - _;
                        this._logger.info(`[${S}][${C}]success, durationMs=${g}`);
                    }, (g)=>{
                        removeFromQueue();
                        const f = Date.now() - _;
                        this._logger.warn(`[${S}][${C}]failed=${safeJsonStringify(g)}, durationMs=${f}`);
                    }), this._promise;
                }
                reset(g) {
                    this._logger.info(`[${g}] resetting`), this._promise = Promise.resolve(void 0);
                }
                constructor(g){
                    this._logger = g, this._promise = Promise.resolve(void 0), this._actionQueue = [];
                }
            };
            function isSessionTerminatedReason(g) {
                return !!(g === null || g === void 0 ? void 0 : g.terminatedReasonCode);
            }
            function convertFromTerminatedReasonFormat(g) {
                return isSessionTerminatedReason(g) ? {
                    code: g.terminatedReasonCode,
                    subCode: g.terminatedReasonSubCode,
                    phrase: g.errorMessage
                } : g;
            }
            function isTransactionEnd(g) {
                return !!(g === null || g === void 0 ? void 0 : g.code);
            }
            function getRejectTransactionEnd(g, f) {
                let S;
                return S = isTransactionEnd(g) ? g : {
                    code: 499,
                    subCode: void 0 !== f ? f : 0,
                    phrase: "string" == typeof g ? g : getPrintableObject(g)
                }, S;
            }
            function getSuccessTransactionEnd() {
                return {
                    code: 0
                };
            }
            var Ni = class {
                get startTime() {
                    return this._startTime;
                }
                constructor(){
                    this.msElapsed = 0, this.isPaused = !1, this._startTime = (new Date).getTime(), this.pause = ()=>{
                        this.isPaused || (this.msElapsed += (new Date).getTime() - this._startTime, this.isPaused = !0);
                    }, this.resume = ()=>{
                        this.isPaused && (this.isPaused = !1, this._startTime = (new Date).getTime());
                    }, this.duration = ()=>this.isPaused ? this.msElapsed : this.msElapsed + (new Date).getTime() - this._startTime, this.durationInMinutes = ()=>{
                        const g = this.duration() / 6e4;
                        return Math.ceil(g);
                    }, this.durationInSeconds = ()=>{
                        const g = this.duration() / 1e3;
                        return Math.ceil(g);
                    };
                }
            };
            function build2() {
                return new Ni;
            }
            var ki = class extends Mi {
                resetOperationChain(g) {
                    this._chainedPromise.reset(g);
                }
                executeSync(g, f, S, v = generateCauseId(), _, C) {
                    const E = this.getOperationInfoForLogging(v, f, S), T = build2();
                    this._logger.info(`${E}API calledSync`);
                    const I = this.callTelemetry.recordOperation(f, v, S, C);
                    let b;
                    try {
                        this._setRecord(f), b = g(), I.recordSuccess(b, v), this.logSuccess(E, b, T);
                    } catch (g) {
                        const f = this.convertToTransactionEndIfErrorOrString(g, _, E);
                        I.recordFailure(f, v), this.logFailure(E, f, T);
                    }
                    return b;
                }
                async executeChained(g, f, S, v = generateCauseId(), _, C, E) {
                    return this.checkPendingOperationAndExecute(g, !0, f, S, v, _, C, E);
                }
                async execute(g, f, S, v = generateCauseId(), _, C, E) {
                    return this.checkPendingOperationAndExecute(g, !1, f, S, v, _, C, E);
                }
                logOperation(g, f, ...S) {
                    const v = S.length && S.map((g)=>this.stringifyForLogging(scrubMriOrOmit(g)));
                    this._logger.info(`[${g.substring(0, 8)}][${f}]API called, ${v ? `with args=${v}` : ""}`);
                }
                rejectPendingOperations(g, f = generateCauseId(), S) {
                    if (S) {
                        for (const g of Object.keys(this._deferredOperations))this.callTelemetry.maybeRecordOperationFailure(g, S, void 0, f);
                        for (const g of Object.keys(this._deferredOperationsWithOperationId))for (const v of Object.keys(this._deferredOperationsWithOperationId[g]))this.callTelemetry.maybeRecordOperationFailure(g, S, v, f);
                    }
                    super.rejectPendingOperations(g, f);
                }
                maybeRejectOperations(g, f, S, v = generateCauseId(), _) {
                    if (_) for (const f of g)this.callTelemetry.maybeRecordOperationFailure(f, _, void 0, v);
                    super.maybeRejectOperations(g, f, S, v);
                }
                checkPendingOperationAndExecute(g, f, S, v, _ = generateCauseId(), C, E, T) {
                    const I = this.getOperationInfoForLogging(_, S, v);
                    let b = null, A = null;
                    return this.hasPendingOperationWithOperationId(S, v) || this.hasPendingOperation(S) ? (this._logger.info(`${I}already pending, returning existing operation`), b = this.waitForOperation(S, v, _)) : A = this.createPendingOperation(S, v, _, T), f ? (this._logger.info(`${I}chained`), this._chainedPromise.chainPromise(()=>b || this.executeInternal(A, _, g, S, v, C, E, T), S, _)) : b || this.executeInternal(A, _, g, S, v, C, E, T);
                }
                _setRecord(g) {
                    this._record.hasOwnProperty(g) || (this._record[g] = 0), this._record[g] += 1;
                }
                getRecord(g) {
                    return this._record[g];
                }
                _recordTelemetryTimeoutAndPublish(g, f, S, v, _, C, E) {
                    const T = g || 60;
                    return window.setTimeout(()=>{
                        if (!this._publishCallback) return void this._logger.warn(`${_} is marked to publish telemetry but no publish callback is defined.`);
                        if (!this.hasPendingOperationWithOperationId(v, E) && !this.hasPendingOperation(v)) return;
                        const g = new Error(`${_} execution did not complete before telemetry timeout of ${T}s.`);
                        this.logTimeout(_, g, C), this.callTelemetry.maybeRecordOperationTimeout(v, g, E, S), this._publishCallback(f), this.callTelemetry.removeRecordedEvent(f);
                    }, 1e3 * T);
                }
                _instantTelemetryPublish(g, f) {
                    this._publishCallback ? (this._publishCallback(f), this.callTelemetry.removeRecordedEvent(f)) : this._logger.warn(`${g} is marked to publish telemetry but no publish callback is defined.`);
                }
                parseInstantTelemetryParameters(g) {
                    let f, S = !1;
                    return g && (S = g.enableInstantTelemetry, f = g.telemetryTimeout), [
                        S,
                        f
                    ];
                }
                async executeInternal(g, f, S, v, _, C, E, T) {
                    const I = this.getOperationInfoForLogging(f, v, _);
                    this._logger.info(`${I} executing operation...`);
                    const b = build2(), A = this.callTelemetry.recordOperation(v, f, _, E), [R, P] = this.parseInstantTelemetryParameters(T);
                    try {
                        var _T_preconditionTags;
                        let g;
                        this._setRecord(v), R && (g = this._recordTelemetryTimeoutAndPublish(P, A, f, v, I, b, _)), (T === null || T === void 0 ? void 0 : (_T_preconditionTags = T.preconditionTags) === null || _T_preconditionTags === void 0 ? void 0 : _T_preconditionTags.length) && this._preconditionFunction && this._preconditionFunction(v, T.preconditionTags);
                        const C = await S();
                        g && clearTimeout(g), this.callTelemetry.maybeRecordOperationSuccess(v, C, _), this.logSuccess(I, C, b), this.maybeResolveOperation(v, C, _, f);
                    } catch (g) {
                        const S = this.convertToTransactionEndIfErrorOrString(g, C, I);
                        this.callTelemetry.maybeRecordOperationFailure(v, convertFromTerminatedReasonFormat(S), _), this.logFailure(I, S, b), this.maybeRejectOperation(v, S, _, f);
                    }
                    return R && this._instantTelemetryPublish(I, A), g;
                }
                getEcsConfig() {
                    return this._ecsConfig;
                }
                constructor(g, f, S, v, _){
                    super(g), this.callTelemetry = f, this._ecsConfig = S, this._publishCallback = v, this._preconditionFunction = _, this._record = {}, this.logSuccess = (g, f, S)=>{
                        this._logger.info(`${g} execution succeeded, result=${f ? getPrintableObject(f) : "void"}, time=${S.duration()}`);
                    }, this.logFailure = (g, f, S)=>{
                        this._logger.info(`${g} execution failed, reason=${this.stringifyForLogging(f)}, time=${S.duration()}`);
                    }, this.logTimeout = (g, f, S)=>{
                        this._logger.info(`${g} execution timed out, reason=${this.stringifyForLogging(f)}, time=${S.duration()}`);
                    }, this.stringifyForLogging = (g)=>{
                        let f;
                        if (g instanceof Error) f = g.toString() || "Unknown Error";
                        else try {
                            f = JSON.stringify(g);
                        } catch (g) {
                            f = "Unable to stringify data";
                        }
                        return f;
                    }, this.convertToTransactionEndIfErrorOrString = (g, f, S)=>{
                        if (this._logger.info(`ecsEnableErrorConversion in operationHandler is: ${this._ecsConfig && this._ecsConfig.enableErrorConversion}`), f && this._ecsConfig && this._ecsConfig.enableErrorConversion && ("string" == typeof g || g instanceof Error)) {
                            const f = getRejectTransactionEnd(g);
                            return this._logger.info(`${S} Error converted from ${g} to ${getPrintableObject(f)}`), f;
                        }
                        return g;
                    }, this._logger = g.createChild("[Operation]"), this._chainedPromise = new Di(this._logger.createChild("[Chained]"));
                }
            }, Li = {
                Cancel: 487,
                Reject: 603,
                NoNgcEndpoint: 480,
                Forbidden: 403,
                PreconditionFailed: 412,
                Success: 0,
                CallRedirected: 302,
                BadRequest: 400,
                NotFound: 404,
                NotAcceptable: 406,
                Timeout: 408,
                Conflict: 409,
                MediaError: 410,
                ConfParticipantCountLimitReached: 413,
                CallAccepted: 450,
                CallForwarded: 451,
                CallForwardedToVoicemail: 452,
                P2pRejectCall: 453,
                P2pFallbackForScreensharing: 460,
                P2pFallbackDueToGroupCall: 461,
                CallLegEndedOnService: 470,
                CallDoesNotExist: 481,
                NotAcceptableHere: 488,
                NetworkError: 490,
                GlareError: 491,
                SkypeTokenError: 495,
                LocalHttpStackError: 496,
                UnknownError: 497,
                LocalError: 498,
                InternalServerError: 500,
                CallModalityFailure: 580,
                ServiceUnavailable: 503
            }, Fi = {
                Success: 0,
                CallRedirectedSuccess: 3020,
                InsufficientCapabilities: 5204,
                PolicyRestriction: 5448,
                UserBlocked: 10005,
                MaxLobbyParticipantLimitReached: 5807,
                MaxParticipantLimitReached: 5808,
                MaxParticipantLimitReached2: 5817,
                SharingStolenError: 10029,
                DowngradeToStreamingClient: 3099,
                MediaDropDuringConnect: 3100,
                MediaDropAfterConnect: 3101,
                MediaAnswerProcessingError: 3102,
                MediaFinalAnswerProcessingError: 3103,
                MediaOfferTimeout: 3104,
                MediaFinalAnswerTimeout: 3105,
                MediaOfferNull: 3106,
                MediaAudioDeviceError: 3107,
                MediaRenegotiationError: 3108,
                MediaPermissionError: 3109,
                MediaUnknownError: 3110,
                MediaOfferProcessingError: 3111,
                MediaWhiteListingIssue: 3112,
                MediaMuteMicrophoneError: 3113,
                MediaMuteSpeakerError: 3114,
                MediaUnmuteMicrophoneError: 3115,
                MediaUnmuteSpeakerError: 3115,
                AttachActionFailed: 4103,
                AttachFailed: 4105,
                PreheatedCallTimedout: 4113,
                RemovedFromConversation: 5e3,
                DeniedInLobby: 5854,
                RemovedFromCall: 5300,
                TimedOutInLobby: 5855,
                AnonymousJoinDisabledByPolicy: 5723,
                B2bJoinDisabledByPolicy: 5724,
                NoLobbyForBroadcastJoin: 5354,
                NotAllowedDueToInformationBarrier: 5810,
                TeamParkPolicyDisabled: 10193,
                BroadcastLimitReached: 800100,
                Suspended: 58e4
            }, xi = {
                [Li.Success]: 1,
                [Li.Cancel]: 12,
                [Li.Reject]: 10,
                [Li.NoNgcEndpoint]: 2,
                [Li.Timeout]: 6,
                [Li.CallAccepted]: 30,
                [Li.CallRedirected]: 75,
                [Li.NotFound]: 24,
                [Li.CallDoesNotExist]: 46,
                [Li.NotAcceptable]: 5,
                [Li.BadRequest]: 5,
                [Li.MediaError]: 4,
                [Li.ConfParticipantCountLimitReached]: 59,
                [Li.CallModalityFailure]: 4,
                [Li.NetworkError]: 3,
                [Li.LocalHttpStackError]: 31,
                [Li.LocalError]: 25,
                [Li.CallForwarded]: 27,
                [Li.CallForwardedToVoicemail]: 28,
                [Li.SkypeTokenError]: 29,
                [Li.InternalServerError]: 7,
                [Li.Conflict]: 7,
                [Li.GlareError]: 7,
                [Li.CallLegEndedOnService]: 7,
                [Li.NotAcceptableHere]: 26,
                [Li.UnknownError]: 32,
                [Li.Forbidden]: 8,
                [Li.PreconditionFailed]: 65
            }, Ui = {
                9401: 33,
                9422: 33,
                6102: 1,
                6423: 14,
                9402: 14,
                9432: 14,
                6519: 3,
                9403: 15,
                9410: 36,
                9411: 37,
                1e3: 2,
                9407: 17,
                13430: 18,
                6009: 19,
                10484: 19,
                10604: 19,
                10404: 19,
                10420: 19,
                10403: 20,
                17401: 20,
                10408: 9,
                10486: 11,
                10600: 11,
                10686: 11,
                10487: 21,
                10500: 3,
                10501: 3,
                10502: 3,
                10503: 3,
                10504: 3,
                10480: 22,
                10482: 22,
                10603: 10,
                13406: 23,
                13416: 23
            }, Vi = {
                500: 39,
                403: 41,
                404: 42,
                480: 40
            }, Bi = {
                INCOMING_SKYPE_NGC_CALL: 107,
                INCOMING_SKYPE_NGC_GVC_CALL: 109,
                INCOMING_PSTN_NGC_CALL: 111,
                INCOMING_SCREENSHARE_WITH_CHAT: 119,
                INCOMING_CALLQUEUE_SUPERVISOR_CONTENT: 125,
                INCOMING_TFL_TFW_CALL: 126
            }, Hi = {
                SHARED_LINE_CALL_RECORD: 121,
                SHARED_LINE_V2_CALL_RECORD: 123,
                MEETING_STARTED_NOTIFICATION: 128
            }, $i = {
                LOG_UPLOAD_EVENT: 120
            }, ji = {
                Unknown: "CallEndReasonUnknown",
                MediaError: "CallEndReasonMediaError",
                MediaOfferTimeout: "CallEndReasonMediaOfferTimeout",
                MediaFinalAnswerTimeout: "CallEndReasonMediaFinalAnswerTimeout",
                MediaAnswerError: "CallEndReasonMediaAnswerError",
                MediaFinalAnswerError: "CallEndReasonFinalAnswerError",
                MediaPermissionError: "CallEndReasonMediaPermissionError",
                MediaRenegotiationError: "CallEndReasonRenegotiationError",
                MediaDropDuringConnect: "CallEndReasonMediaDropDuringConnectError",
                MediaDropAfterConnect: "CallEndReasonMediaDropAfterConnectError",
                MediaOfferProcessingError: "CallEndReasonMediaOfferProcessingError",
                DowngradeToStreamingClient: "DowngradeToStreamingClient",
                IncompatibleOffer: "CallEndReasonIncompatibleOffer",
                MediaWhiteListingIssue: "MediaWhitelistingIssue",
                AudioDeviceError: "CallEndReasonAudioDeviceError",
                AttachFailed: "CallEndReasonAttachFailed",
                BadNotificationPayload: "CallEndReasonBadNotificationPayload",
                RetargetNotSupported: "RetargetNotSupported",
                CallEndReasonLocalUserInitiated: "CallEndReasonLocalUserInitiated",
                EndedByRemoteEndpoint: "EndedByRemoteEndpoint",
                CallEndReasonRedirected: "CallEndReasonRedirected",
                CallEndReasonVDIdisconnect: "CallEndReasonVDIdisconnect",
                CallEndReasonSuspended: "CallEndReasonSuspended"
            }, Gi = ((g)=>(g.GetSignalingMediaTypes = "GetSignalingMediaTypes", g.CallStart = "CallStart", g.WaitForAnswer = "WaitForAnswer", g.WaitForConnect = "WaitForConnect", g.Accept = "Accept", g))(Gi || {}), qi = ((g)=>(g.InitializeMediaSession = "InitializeMediaSession", g.UpdateMediaModalities = "UpdateMediaModalities", g.CreateOffer = "CreateOffer", g.CreateAnswer = "CreateAnswer", g.ProcessAnswer = "ProcessAnswer", g.GetSignalingMediaTypes = "GetSignalingMediaTypes", g.MuteUnmute = "MuteUnmute", g.MuteUnmuteSpeakers = "MuteUnmuteSpeakers", g.StartVideoSafe = "StartVideoSafe", g.CompleteNegotiation = "CompleteNegotiation", g.MuteInput = "MuteInput", g.MuteOutput = "MuteOutput", g.UnmuteInput = "UnmuteInput", g.UnmuteOutput = "UnmuteOutput", g.evaluateEndpointStatesForAccept = "evaluateEndpointStatesForAccept", g.handleEndpointStatesForAccept = "handleEndpointStatesForAccept", g))(qi || {}), Wi = ((g)=>(g.InitializeMediaSession = "InitializeMediaSession", g.ProcessOffer = "ProcessOffer", g.ProcessOfferedModalities = "ProcessOfferedModalities", g.TrySendingProvisionalAnswer = "TrySendingProvisionalAnswer", g))(Wi || {}), zi = P, Ki = __toESM(P), Ji = __toESM(P), Yi = __toESM(_e()), Qi = {
                Success: "Success",
                ExpectedError: "ExpectedError",
                UnexpectedClientError: "UnexpectedClientError",
                UnexpectedServerError: "UnexpectedServerError"
            }, Xi = {
                INCOMING_MESSAGE_ORIGIN: {
                    TROUTER: "Trouter",
                    BROKER: "Broker"
                },
                INVITATION_TYPE: {
                    NUDGE: "nudge"
                },
                KNOWN_PAYLOAD_ENCODINGS: {
                    GZIP: !0
                },
                WEBRTC_NOTIFICATION_TYPE: {
                    CONTROL_VIDEO_STREAMING: "ControlVideoStreaming",
                    DOMINANT_SPEAKER_INFO: "DominantSpeakerInfo",
                    CSRC_INFO: "CsrcInfo"
                },
                PARTICIPANT_AUDIO_STATE: {
                    CONNECTING: "Connecting",
                    RINGING: "Ringing",
                    CONNECTED: "Connected",
                    OTHER: "Other"
                },
                HEADERS: {
                    MESSAGE_ID: "X-Microsoft-Skype-Message-ID",
                    ORIGINAL_MESSAGE_ID: "X-Microsoft-Skype-Original-Message-ID",
                    CONTENT_ENCODING: "X-Microsoft-Skype-Content-Encoding",
                    CORRELATION_ID: "X-Microsoft-Skype-Chain-ID",
                    CONTENT_SHARING_CORRELATION_ID: "X-Microsoft-Skype-ContentSharing-Chain-ID",
                    CLIENT_USER_AGENT: "X-Microsoft-Skype-Client",
                    SKYPE_TOKEN: "X-Skypetoken",
                    AUTHORIZATION: "Authorization",
                    BEARER_KEYWORD: "Bearer",
                    AAD_KEYWORD: "Aad",
                    CAE_KEYWORD: "Cae",
                    SKYPE_KEYWORD: "Skype",
                    CACHE_SKYPE_TOKEN: "X-CacheSkypeToken",
                    AUTHENTICATE: "www-authenticate",
                    TOKEN_MIGRATION: "X-MS-Migration",
                    BROKER_USE_BATCHING_HEADER_NAME: "X-UseBatching",
                    PARTICIPANT_ID: "X-Microsoft-Skype-Participant-ID",
                    CONTENT_TYPE: "Content-Type",
                    RING: "MS-Teams-Ring",
                    REGION: "MS-Teams-Region",
                    PARTITION: "MS-Teams-Partition"
                },
                KNOWN_BOTS: {
                    VOICEMAIL_BOT_ID: "28:14524421-25b4-403a-a0f7-e62d4379cabc"
                },
                HTTP_STACK_ERROR: {
                    NONE: 0,
                    CANNOT_CONNECT: 7,
                    REQUEST_TIMEOUT: 10,
                    ATTEMPT_TIMEOUT: 30,
                    REQUEST_ABORTED: 16,
                    ATTEMPT_ABORTED: 31,
                    ABORTED_OTHER_ATTEMPT_SUCCESSFUL: 32
                },
                HTTP_STATUS_CODES: {
                    UNKNOWN: 0,
                    OK: 200,
                    CREATED: 201,
                    BAD_REQUEST: 400,
                    UNAUTHORIZED: 401,
                    NOT_FOUND: 404,
                    FORBIDDEN: 403,
                    PRECONDITION_FAILED: 412,
                    UNPROCESSABLE_ENTITY: 422,
                    NETWORK_ERROR: 490,
                    SKYPE_TOKEN_ERROR: 495,
                    OFFLINE: 496,
                    TIMEOUT: 498,
                    ABORTED: 498,
                    OTHER: 499,
                    INTERNAL_SERVER_ERROR: 500,
                    CONFLICT: 409,
                    BAD_GATEWAY: 502,
                    SERVICE_UNAVAILABLE: 503,
                    GATEWAY_TIMEOUT: 504
                },
                CALL_END_SKYPE_TOKEN_ERROR: {
                    code: 495,
                    subCode: 4507,
                    phrase: "CallEndReasonSkypeTokenFetchError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_TOKEN_TIMEOUT_ERROR: {
                    code: 499,
                    subCode: 3119,
                    phrase: "CallEndReasonTokenFetchTimeout",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_UNSUPPORTED_TOKEN_ERROR: {
                    code: 499,
                    subCode: 3126,
                    phrase: "CallEndReasonUnsupportedTokenError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_TOKEN_ERROR: {
                    code: 499,
                    subCode: 3127,
                    phrase: "CallEndReasonTokenFetchError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED: {
                    code: 499,
                    subCode: 3128,
                    phrase: "CallEndReasonTokenTimeoutInterActvityRequired",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_LOCAL_HTTP_STACK_ERROR: {
                    code: 496,
                    subCode: 4520,
                    phrase: "LocalHTTPStackError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_UNKNOWN_ERROR: {
                    code: 497,
                    subCode: 3121,
                    phrase: "CallEndReasonUnknownError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_NETWORK_ERROR: {
                    code: 490,
                    subCode: 4502,
                    phrase: "CallEndReasonNetworkError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_DNS_HOST_NAME_RESOLVE_ERROR: {
                    code: 490,
                    subCode: 4522,
                    phrase: "CallEndReasonDnsHostNameResolveError",
                    resultCategories: [
                        Qi.UnexpectedClientError
                    ]
                },
                CALL_END_LOCAL_DECLINE: {
                    code: 486,
                    subCode: 4508,
                    phrase: "LocalDecline",
                    resultCategories: [
                        Qi.Success
                    ]
                },
                RESOURCE_NOT_FOUND_ERROR: {
                    code: 404,
                    subCode: 404,
                    phrase: "ResourceNotFound",
                    resultCategories: [
                        Qi.ExpectedError
                    ]
                },
                CALL_STATUS: {
                    IDLE: "Idle",
                    RINGING: "Ringing",
                    CONNECTING: "Connecting",
                    CONNECTED: "Connected",
                    CONNECTED_FOR_ROSTER_ONLY: "ConnectedForRosterOnly",
                    LOCAL_TERMINATED: "LocalTerminated",
                    REMOTE_TERMINATED: "RemoteTerminated"
                },
                MEDIA_TYPES: {
                    AUDIO: "Audio",
                    VIDEO: "Video",
                    SCREEN_SHARER: "ScreenSharer",
                    SCREEN_VIEWER: "ScreenViewer"
                },
                MUTE_SCOPE: {
                    MYSELF: "Myself",
                    EVERYONE_ELSE: "EveryoneElse",
                    SPECIFIED_PARTICIPANTS: "SpecifiedParticipants"
                },
                URL_BASE: {
                    CALLAGENT: "callAgent"
                },
                LINKS: {
                    HANGUP: "hangup",
                    MEDIA_REJECTION: "mediaRejection",
                    MEDIA_ANSWER: "mediaAnswer",
                    MEDIA_RENEGOTIATION: "mediaRenegotiation",
                    ACCEPT: "accept",
                    ATTACH: "attach",
                    REJECT: "reject",
                    REDIRECT: "redirect",
                    REPLACE: "replace",
                    TRANSFER: "transfer",
                    NEW_OFFER: "newOffer",
                    TRANSFER_ACCEPTANCE: "transferAcceptance",
                    TRANSFER_COMPLETION: "transferCompletion",
                    CONVERSATION_CONTROLLER: "conversationController",
                    ADD_PARTICIPANT: "addParticipant",
                    ADD_PARTICIPANTS_AND_MODALITY: "addParticipantsAndModality",
                    LEAVE: "leave",
                    NOTIFICATION_LINKS: "notificationLinks",
                    REMOVE_PARTICIPANT: "removeParticipant",
                    KEEPALIVE: "keepAlive",
                    ADD_MODALITY: "AddModality",
                    REMOVE_MODALITY: "RemoveModality",
                    CONTENT_SHARING_CONTROLLER: "contentSharingController",
                    CONTENT_SHARING_TAKE_CONTROL: "contentSharingTakeControl",
                    CONTENT_SHARING_UPDATE_SESSION_STATE: "contentSharingUpdateSessionState",
                    CONTENT_SHARING_UPDATE_PARTICIPANT_STATE: "contentSharingUpdateParticipantState",
                    CONTENT_SHARING_NOTIFICATION_LINKS: "contentSharingNotificationLinks",
                    CONTENT_SHARING_LEAVE: "contentSharingLeave",
                    MUTE: "mute",
                    UNMUTE: "unmute",
                    ADMIT: "admit",
                    ADMIT_ALL: "admitAll",
                    CONTROL_VIDEO_STREAMING: "controlVideoStreaming",
                    APPLY_CHANNEL_PARAMETERS: "applyChannelParameters",
                    UPDATE_ENDPOINT_STATE: "updateEndpointState",
                    UPDATE_ENDPOINT_METADATA: "updateEndpointMetadata",
                    LMC_NOTIFICATION_LINKS: "lmcNotificationLinks",
                    UPDATE_PARTICIPANT_ROLE: "updateParticipantRole",
                    PUBLISH_STATE: "publishState",
                    REMOVE_STATE: "removeState",
                    UPDATE_MEETING_SETTINGS: "updateMeetingSettings",
                    SEARCH_PARTICIPANTS: "searchParticipants",
                    GET_ALL_PARTICIPANTS: "getAllParticipants",
                    PARK: "park",
                    UNPARK: "unpark",
                    UPDATE_MEETING_LIVE_STATE: "updateMeetingLiveState",
                    UPDATE_MEETING_GROUPS: "updateMeetingGroups",
                    SET_MEETING_LAYOUT: "setMeetingLayout",
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE: "updateParticipantInterpretationState",
                    JOIN_MEETING_GROUP: "joinMeetingGroup",
                    LEAVE_MEETING_GROUP: "leaveMeetingGroup",
                    SEND_MESSAGE: "sendMessage",
                    UPDATE_PARTICIPANTS_PROPERTIES: "updateParticipantsProperties",
                    UPDATE_MEDIA_DESCRIPTIONS: "updateMediaDescriptions",
                    UPDATE_MEETING_STATES: "updateMeetingStates",
                    UPDATE_MONITOR_SESSION: "monitor"
                },
                CONTENT_TYPE: {
                    JSON: "application/json",
                    SDP: "application/sdp"
                },
                TROUTER_EVENT_TYPE: {
                    SKYPE_SKYPE_CALL: 107,
                    LYNC_SKYPE_CALL: 105
                },
                MISC: {
                    CONVERSATION: "conversation",
                    LOBBY_CALL_CONTROLLER: "lobby",
                    LOBBY_PARTICIPANT_STATE: "lobby"
                },
                SIGNALING_FSM_STATE: {
                    IDLE: "Idle",
                    INCOMING: "Incoming",
                    WAITING_CALL_ACCEPTANCE_ACK: "WaitingCallAcceptanceAck",
                    OUTGOING: "Outgoing",
                    CONNECTED: "Connected",
                    OUTGOING_FOR_ROSTER_ONLY: "OutgoingForRosterOnly",
                    CONNECTED_FOR_ROSTER_ONLY: "ConnectedForRosterOnly"
                },
                MEDIA_RENEGOTIATION_FSM_STATE: {
                    IDLE: "Idle",
                    CALL_CONNECTED: "Connected",
                    INCOMING_RENEGOTIATION: "IncomingRenegotiation",
                    OUTGOING_RENEGOTIATION: "OutgoingRenegotiation",
                    RENEGOTIATION_GLARE: "RenegotiationGlare"
                },
                CONTENT_SHARING_FSM_STATE: {
                    IDLE: "Idle",
                    CONTENT_SHARING_START_INITIATED: "ContentSharingStartInitiated",
                    CONTENT_SHARING_JOIN_INITIATED: "ContentSharingJoinInitiated",
                    CONTENT_SHARING_LEAVE_INITIATED: "ContentSharingLeaveInitiated",
                    CONTENT_SHARING_DELETE_INITIATED: "ContentSharingDeleteInitiated",
                    CONTENT_SHARING_CONNECTED: "ContentSharingConnected"
                },
                TIMEOUT_OPERATIONS: {
                    ADD_PARTICIPANT: "AddParticipant",
                    NUDGE_PARTICIPANT: "NudgeParticipant",
                    REMOVE_PARTICIPANT: "RemoveParticipant",
                    ADMIT_PARTICIPANT: "AdmitParticipant",
                    ADMIT: "Admit",
                    CALL_REDIRECT: "CallRedirect",
                    CALL_ME_BACK: "CallMeBack",
                    INCOMING_CALL_ESTABLISHMENT: "IncomingCallEstablishment",
                    OUTGOING_CALL_ESTABLISHMENT: "OutgoingCallEstablishment",
                    MEDIA_ANSWER: "MediaAnswer",
                    MEDIA_ANSWER_ACKNOWLEDGEMENT: "MediaAnswerAcknowledgement",
                    ADD_MODALITY: "AddModality",
                    UNMUTE: "Unmute",
                    UPDATE_MEETING_ROLE: "UpdateMeetingRole",
                    MAX_PREAHEATED_TIMEOUT: "MaxPreheateadTimeout",
                    PARK_COMPLETION: "ParkCompletion",
                    UNPARK_COMPLETION: "UnparkCompletion",
                    UPDATE_MEETING_LIVE_STATE_COMPLETION: "UpdateMeetingLiveStateCompletion",
                    UPDATE_MEETING_GROUPS_COMPLETION: "UpgradeMeetingGroupsCompletion",
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION: "UpdateParticipantInterpretationStateCompletion",
                    UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION: "UpdateParticipantsPropertiesCompletion",
                    JOIN_MEETING_GROUP_COMPLETION: "JoinMeetingGroupCompletion",
                    LEAVE_MEETING_GROUP_COMPLETION: "LeaveMeetingGroupCompletion",
                    SET_MEETING_LAYOUT_COMPLETION: "SetMeetingLayoutCompletion",
                    SEND_MESSAGE_COMPLETION: "SendMessageCompletion",
                    DISABLE_PREHEAT_ASYNC_TIMEOUT: "DisablePreheatAsyncTimeout",
                    UPDATE_MEETING_STATES_COMPLETION: "UpdateMeetingStatesCompletion",
                    UPDATE_MONITOR_SESSION_COMPLETION: "UpdateMonitorSessionCompletion"
                },
                TIMEOUT_VALUES_IN_SECONDS: {
                    ADD_PARTICIPANT_TIMEOUT: 130,
                    REMOVE_PARTICIPANT_TIMEOUT: 60,
                    INCOMING_CALL_ESTABLISHMENT_TIMEOUT: 75,
                    OUTGOING_CALL_ESTABLISHMENT_TIMEOUT: 90,
                    LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT: 185,
                    MEDIA_ANSWER_TIMEOUT: 35,
                    MEDIA_ANSWER_ACKNOWLEDGEMENT_TIMEOUT: 15,
                    ADD_MODALITY_TIMEOUT: 65,
                    UNMUTE_TIMEOUT: 35,
                    ADMIT_PARTICIPANT_TIMEOUT: 210,
                    ADMIT_TIMEOUT: 60,
                    UPDATE_MEETING_ROLE_TIMEOUT: 15,
                    NUDGE_PARTICIPANT_TIMEOUT: 60,
                    CALL_ME_BACK_TIMEOUT: 120,
                    MAX_PREAHEATED_TIMEOUT: 90,
                    PARK_COMPLETION_TIMEOUT: 45,
                    UNPARK_COMPLETION_TIMEOUT: 45,
                    UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT: 45,
                    UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT: 45,
                    SET_MEETING_LAYOUT_COMPLETION_TIMEOUT: 45,
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION_TIMEOUT: 45,
                    UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION_TIMEOUT: 45,
                    JOIN_MEETING_GROUP_COMPLETION_TIMEOUT: 45,
                    LEAVE_MEETING_GROUP_COMPLETION_TIMEOUT: 45,
                    CONVERSATION_KEEP_ALIVE_TIMEOUT: 2700,
                    TOKEN_REQUIRED_TIMEOUT: 20,
                    SEND_MESSAGE_COMPLETION_TIMEOUT: 15,
                    DISABLE_PREHEAT_TIMEOUT: 45,
                    UPDATE_MEETING_STATES_COMPLETION_TIMEOUT: 45,
                    UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT: 45
                },
                CALL_END_CODE: {
                    REJECT: 603,
                    SUCCESS: 0,
                    CALL_REDIRECTED: 302,
                    CANCEL: 487,
                    TIMEOUT: 408,
                    SERVICE_UNAVAILABLE: 500,
                    BAD_REQUEST: 406,
                    NO_NGC_ENDPOINT: 480,
                    P2P_FALLBACK_FOR_SCREENSHARING: 460,
                    CONFLICT: 409,
                    MEDIA_ERROR: 410,
                    CONF_PARTICIPANT_COUNT_LIMIT_REACHED: 413,
                    CALL_DOES_NOT_EXIST: 481,
                    CALL_ACCEPTED: 450,
                    CALL_FORWARDED: 451,
                    CALL_FORWARDED_TO_VOICEMAIL: 452,
                    P2P_REJECT_CALL: 453,
                    P2P_FALLBACK_DUE_TO_GROUPCALL: 461,
                    CALL_LEG_ENDED_ON_SERVICE: 470,
                    NOT_ACCEPTABLE_HERE: 488,
                    NETWORK_ERROR: 490,
                    UNKNOWN_ERROR: 497,
                    LOCAL_ERROR: 498,
                    CALL_MODALITY_FAILURE: 580,
                    ATC_CONTROLLER_FAILURE: 581,
                    CVA_CONTROLLER_FAILURE: 586,
                    GLARE_ERROR: 491,
                    NOT_FOUND: 404,
                    SKYPE_TOKEN_ERROR: 495,
                    LOCAL_HTTP_STACK_ERROR: 496,
                    HTTP_OTHER_ERROR: 499,
                    DECODING_FAILED: 407,
                    NOT_AUTHORIZED: 403,
                    BAD_SERVICE_RESPONSE: 400
                },
                CALL_END_SUB_CODE: {
                    SUCCESS: 0,
                    CALL_REDIRECTED_SUCCESS: 3020,
                    DOWNGRADE_TO_STREAMING_CLIENT: 3099,
                    MEDIA_DROP_DURING_CONNECT: 3100,
                    MEDIA_DROP_AFTER_CONNECT: 3101,
                    MEDIA_ANSWER_PROCESSING_ERROR: 3102,
                    MEDIA_FINAL_ANSWER_PROCESSING_ERROR: 3103,
                    MEDIA_OFFER_TIMEOUT: 3104,
                    MEDIA_FINAL_ANSWER_TIMEOUT: 3105,
                    MEDIA_OFFER_NULL: 3106,
                    MEDIA_AUDIO_DEVICE_ERROR: 3107,
                    MEDIA_RENEGOTIATION_ERROR: 3108,
                    MEDIA_PERMISSION_ERROR: 3109,
                    MEDIA_UNKNOWN_ERROR: 3110,
                    MEDIA_OFFER_PROCESSING_ERROR: 3111,
                    MEDIA_WHITELISTING_ISSUE: 3112,
                    MEDIA_MUTE_MICROPHONE_ERROR: 3114,
                    MEDIA_MUTE_SPEAKER_ERROR: 3115,
                    MEDIA_UNMUTE_MICROPHONE_ERROR: 3116,
                    MEDIA_UNMUTE_SPEAKER_ERROR: 3117,
                    MEDIA_GLARE_ERROR: 3118,
                    CONVERSATION_TERMINATION_UNKNOWN_ERROR: 3121,
                    CONVERSATION_NOTIFICATION_TIMEOUT: 3125,
                    CALL_NOT_ATTEMPTED: 4500,
                    CONV_URL_NOT_SET: 4501,
                    FAILED_TO_REACH_SERVICE: 4502,
                    PLACE_CALL_FAILED: 4503,
                    ATTACH_CALL_FAILED: 4504,
                    BAD_NOTIFICATION_PAYLOAD: 4505,
                    CALL_ESTABLISHMENT_TIMEOUT: 4506,
                    SKYPE_TOKEN_ERROR: 4507,
                    CONVERSATION_RESOLUTION_CONFLICT: 5704,
                    CALL_PARTICIPANT_REMOVAL_TIMEOUT: 4507,
                    UNMUTE_REQUEST_TIMEOUT: 4509,
                    UNMUTE_REQUEST_REJECTED: 4510,
                    CONFLICT_IN_NG: 4090,
                    CONFLICT_WITH_P2P: 4091,
                    CONVERSATION_END_RECEIVED_FROM_SERVICE: 4100,
                    TRANSFER_COMPLETE_TIMEOUT: 4101,
                    ATTACH_TO_NON_EXISTENT_CALL: 4102,
                    ATTACH_ACTION_FAILED: 4103,
                    ATTACH_FAILED: 4105,
                    CONVERSATION_ESTABLISHMENT_FAILED: 4106,
                    BEFORE_CONNECT: 4107,
                    AFTER_CONNECT: 4108,
                    AFTER_ACCEPT: 4109,
                    TROUTER_CONNECTION_DROPPED: 4111,
                    DUE_TO_CALL_ASSIMILATION: 4112,
                    PREHEATED_CALL_TIMEDOUT: 4113,
                    UNPARK_COMPLETION_TIMEOUT: 4114,
                    PARK_COMPLETION_TIMEOUT: 4115,
                    UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT: 4116,
                    UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT: 4117,
                    SET_MEETING_LAYOUT_COMPLETION_TIMEOUT: 4118,
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT: 4119,
                    JOIN_MEETING_GROUP_TIMEOUT: 4120,
                    LEAVE_MEETING_GROUP_TIMEOUT: 4121,
                    UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT: 4122,
                    UPDATE_MEETING_STATES_COMPLETION_TIMEOUT: 4123,
                    UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT: 4124,
                    MISSING_REQUEST_URI: 4511,
                    MISC_ERROR: 4512,
                    LOCAL_HTTP_STACK_ERROR: 4520,
                    BEACON: 4521,
                    DNS_HOST_NAME_RESOLVE_ERROR: 4522,
                    CONVERSATION_ENDED_NO_NEW_OWNER_FOUND: 5014,
                    UNABLE_TO_GENERATE_MEETUP_ID: 5015,
                    UPDATE_MEETING_ROLE_REJECTED: 5651,
                    UPDATE_MEETING_ROLE_TIMEOUT: 5652,
                    PUBLISH_STATE_LINK_MISSING: 5653,
                    PUBLISH_STATE_INVALID_CONTENT: 5654,
                    PUBLISH_STATE_INVALID_SERVICE_RESPONSE: 5655,
                    REMOVE_STATE_LINK_MISSING: 5656,
                    REMOVE_STATE_MISSING_ARGUMENTS: 5657,
                    UPDATE_MEETING_SETTINGS_LINK_MISSING: 5658,
                    UPDATE_MEETING_SETTINGS_MISSING_ARGUMENTS: 5659,
                    ADMIT_ALL_LINK_MISSING: 5660,
                    ADMIT_TIMEOUT: 5661,
                    CALL_ACCEPTANCE_INVALID_SERVICE_RESPONSE: 5670,
                    ROSTER_HANDLING_INVALID_SERVICE_RESPONSE: 5671,
                    SEARCH_PARTICIPANTS_LINK_MISSING: 5672,
                    SEARCH_PARTICIPANTS_INVALID_SERVICE_RESPONSE: 5673,
                    GET_ALL_PARTICIPANTS_LINK_MISSING: 5674,
                    GET_ALL_PARTICIPANTS_INVALID_SCOPE: 5675,
                    GET_ALL_PARTICIPANTS_INVALID_SERVICE_RESPONSE: 5676,
                    PARK_UNPARK_TYPE_MISSING: 5680,
                    PARK_UNPARK_V2_DISABLED: 5682,
                    UPDATE_PARTICIPANTS_PROPERTIES_LINK_MISSING: 5683,
                    DISABLE_PREHEAT_TIMEOUT: 5684,
                    CALL_ENDED_BY_PLATFORM_AGENT: 7e3,
                    CONVERSATION_TERMINATION_INTERACTION_REQUIRED: 71014
                },
                CALL_END_PHRASE: {
                    UNKNOWN: "CallEndReasonUnknown",
                    MEDIA_ERROR: "CallEndReasonMediaError",
                    MEDIA_OFFER_TIMEOUT: "CallEndReasonMediaOfferTimeout",
                    MEDIA_FINAL_ANSWER_TIMEOUT: "CallEndReasonMediaFinalAnswerTimeout",
                    MEDIA_ANSWER_ERROR: "CallEndReasonMediaAnswerError",
                    MEDIA_FINAL_ANSWER_ERROR: "CallEndReasonFinalAnswerError",
                    MEDIA_PERMISSION_ERROR: "CallEndReasonMediaPermissionError",
                    MEDIA_RENEGOTIATION_ERROR: "CallEndReasonRenegotiationError",
                    MEDIA_DROP_DURING_CONNECT: "CallEndReasonMediaDropDuringConnectError",
                    MEDIA_DROP_AFTER_CONNECT: "CallEndReasonMediaDropAfterConnectError",
                    MEDIA_OFFER_PROCESSING_ERROR: "CallEndReasonMediaOfferProcessingError",
                    MEDIA_WHITELISTING_ISSUE: "MediaWhitelistingIssue",
                    AUDIO_ERROR: "CallEndReasonAudioDeviceError",
                    CONVERSATION_NOTIFICATION_TIMEOUT: "ConversationNotificationTimeout",
                    BAD_NOTIFICATION_PAYLOAD: "BadCallNotificationPayload",
                    NETWORK_ERROR: "CallEndReasonNetworkError",
                    LOCAL_USER_INITIATED: "CallEndReasonLocalUserInitiated",
                    REMOTE_USER_INITIATED: "CallEndReasonRemoteUserInitiated",
                    ESTABLISHMENT_TIMEOUT: "CallEndReasonEstablishmentTimeout",
                    PARTICIPANT_REMOVAL_TIMEOUT: "CallParticipantRemovalTimeout",
                    LOCAL_ERROR: "CallEndReasonLocalError",
                    CALL_UPDATE_ERROR: "CallEndReasonCallUpdateError",
                    CALL_REDIRECT_IS_NOT_ALLOWED: "CallRedirectisNotAllowed",
                    P2P_FORK_CONNECTED: "CallEndReasonP2pForkConnected",
                    P2P_FORK_FORWARDED: "CallEndReasonP2pForkForwarded",
                    P2P_FORK_FORWARDED_TO_VOICEMAIL: "CallEndReasonP2pForkForwardedToVoiceMail",
                    P2P_FALLBACK_FOR_SCREENSHARING: "CallEndReasonP2pFallbackForScreensharing",
                    P2P_FALLBACK_FOR_GROUPCALL: "CallEndReasonP2pFallbackForGroupCall",
                    P2P_FALLBACK_FOR_CALL_ASSIMILATION: "CallEndReasonP2pFallbackForCallAssimilation",
                    P2P_FALLBACK_FOR_TRANSLATION: "CallEndReasonP2pFallbackForCallTranslation",
                    P2P_FORK_REJECTED: "CallEndReasonP2pForkRejected",
                    TROUTER_CONNECTION_DROPPED: "CallEndReasonTrouterConnectionDropped",
                    REMOVED_FROM_CALL: "CallEndReasonRemovedFromCall",
                    TRANSFER_COMPLETION_TIMEOUT: "CallEndReasonTransferCompletionTimeout",
                    CALL_DOES_NOT_EXIST: "CallEndReasonCallDoesNotExist",
                    ATTACH_ACTION_FAILED: "CallEndReasonAttachActionFailed",
                    ATTACH_FAILED: "CallEndReasonAttachFailed",
                    CONVERSATION_ESTABLISHMENT_FAILED: "CallEndReasonConversationEstablishmentFailed",
                    CONV_END_FROM_SERVICE: "CallEndReasonConversationEndReceivedFromService",
                    CONV_END_FROM_SERVICE_WITH_ERROR: "CallEndReasonConversationEndReceivedFromServiceWithError",
                    SERVICE_ERROR: "CallEndReasonServiceError",
                    CONFLICT: "CallEndReasonConflict",
                    CALL_ALREADY_IN_P2P: "CallEndReasonCallAlreadyExistsInP2p",
                    CONV_END_NO_MODALITY: "ConversationEndNoModalityConnected",
                    CONV_END_FOR_ALL_INITIATED: "ConversationEndForAllInitiated",
                    RENEGOTIATION_IN_PROGRESS: "NegotiationIsInProgress",
                    ADD_PARTICIPANT_URL_MISSING: "AddParticipantUrlMissing",
                    ADMIT_PARTICIPANT_URL_MISSING: "AdmitParticipantUrlMissing",
                    ADMIT_ALL_URL_MISSING: "AdmitAllUrlMissing",
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE_URL_MISSING: "UpdateParticipantInterpretationStateUrlMissing",
                    UPDATE_PARTICIPANTS_PROPERTIES_URL_MISSING: "UpdateParticipantsPropertiesUrlMissing",
                    ADMIT_TIMEOUT: "AdmitTimeout",
                    UNABLE_TO_GENERATE_MEETUP_ID: "Unable to generate GroupChat meetup id.",
                    ENDED_BY_PMA: "Call ended by media agent.",
                    OWNERSHIP_RESOLUTION_CONFLICT: "Conversation cannot be created due to a failure to resolve ownership.",
                    CONVERSATION_ENDED_NO_NEW_OWNER_FOUND: "This conversation has ended since we were unable to determine a potential host for the group call.",
                    UNMUTE_REQUEST_TIMEOUT: "UnmuteRequestTimeout",
                    UNMUTE_REQUEST_REJECTED: "UnmuteRequestRejected",
                    UPDATE_MEETING_ROLE_TIMEOUT: "UpdateMeetingRoleTimeout",
                    UPDATE_MEETING_ROLE_REJECTED: "Update meeting role operation failed due to insufficient privileges.",
                    PARK_REQUEST_FAILED: "Park Request Failed",
                    PARK_COMPLETION_TIMEOUT: "ParkCompletionTimeout",
                    PARK_COMPLETION_FAILED: "ParkCompletionFailed",
                    UNPARK_REQUEST_FAILED: "UnparkFailed",
                    UNPARK_COMPLETION_TIMEOUT: "UnparkCompletionTimeout",
                    UNPARK_COMPLETION_FAILED: "UnparkCompletionFailed",
                    BAD_SERVICE_RESPONSE: "BadServiceResponse",
                    UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT: "UpdateMeetingLiveStateCompletionTimeout",
                    UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT: "UpdateMeetingGroupsCompletionTimeout",
                    SET_MEETING_LAYOUT_COMPLETION_TIMEOUT: "SetMeetingLayoutCompletionTimeout",
                    UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT: "UpdateParticipantInterpretationTimeout",
                    JOIN_MEETING_GROUP_TIMEOUT: "JoinMeetingGroupTimeout",
                    LEAVE_MEETING_GROUP_TIMEOUT: "LeaveMeetingGroupTimeout",
                    DOWNGRADE_TO_STREAMING_CLIENT: "DowngradeToStreamingClient",
                    MESSAGE_STATUS_WITH_FAILURE_COUNT: "NotZeroFailureCount",
                    UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT: "UpdateParticipantsPropertiesTimeout",
                    DISABLE_PREHEAT_TIMEOUT: "DisablePreheatTimeout",
                    UPDATE_MEETING_STATES_COMPLETION_TIMEOUT: "UpdateMeetingStatesCompletionTimeout",
                    UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT: "UpdateMonitorSessionCompletionTimeout"
                },
                TRANSACTION_END_CODE: {
                    SUCCESS: 0
                },
                URL_DEFAULTS: {
                    UPLOAD_LOG_URL: "https://api.cc.skype.com/cc/v1/uploadlog/"
                },
                SUCCESS_TRANSACTION_END: {
                    code: 0,
                    resultCategories: [
                        Qi.Success
                    ]
                },
                VALIDATION: {
                    VALIDATION_FAILED: 6e3,
                    NULL_OR_EMPTY: 6001
                }
            }, Zi = {
                REQUEST_TIMEOUT: {
                    status: Xi.HTTP_STATUS_CODES.TIMEOUT,
                    statusText: "Request timed out",
                    readyState: 0,
                    response: Xi.HTTP_STACK_ERROR.REQUEST_TIMEOUT
                },
                ATTEMPT_TIMEOUT: {
                    status: Xi.HTTP_STATUS_CODES.TIMEOUT,
                    statusText: "Attempt timed out",
                    readyState: 0,
                    response: Xi.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT
                },
                REQUEST_ABORTED: {
                    status: Xi.HTTP_STATUS_CODES.ABORTED,
                    statusText: "Request Aborted",
                    readyState: 0,
                    response: Xi.HTTP_STACK_ERROR.REQUEST_ABORTED
                },
                ATTEMPT_ABORTED: {
                    status: Xi.HTTP_STATUS_CODES.ABORTED,
                    statusText: "Attempt Aborted",
                    readyState: 0,
                    response: Xi.HTTP_STACK_ERROR.ATTEMPT_ABORTED
                }
            }, en = {
                MEDIA_ACKNOWLEDGEMENT: "/call/mediaAcknowledgement/",
                MEDIA_REJECTION: "/call/rejection/",
                ACKNOWLEDGEMENT: "/call/acknowledgement/",
                MEDIA_RENEGOTIATION: "/call/mediaRenegotiation/",
                REPLACE: "/call/replacement/",
                PROGRESS: "/call/progress/",
                MEDIA_ANSWER: "/call/mediaAnswer/",
                NEW_MEDIA_OFFER: "/call/newMediaOffer/",
                REDIRECTION: "/call/redirection/",
                BALANCE_UPDATE: "/call/balanceUpdate/",
                ACCEPT: "/call/acceptance/",
                CONTROL_VIDEO_STREAMING: "/call/controlVideoStreaming/",
                DOMINANT_SPEAKER_INFO: "/call/dominantSpeakerInfo/",
                CSRC_INFO: "/call/csrcInfo/",
                END: "/call/end/",
                RETARGET_COMPLETION: "/call/retargetCompletion/",
                TRANSFER: "/call/transfer/",
                TRANSFER_ACCEPTANCE: "/call/transferAcceptance/",
                TRANSFER_COMPLETION: "/call/transferCompletion/",
                PARK_COMPLETION: "/call/holdCompletion/",
                UNPARK_COMPLETION: "/call/resumeCompletion/",
                UPDATE_MEDIA_DESCRIPTIONS: "/call/updateMediaDescriptions",
                MONITOR_COMPLETION: "/call/monitorCompletion/"
            }, tn = {
                CONV_END: "/conversation/conversationEnd/",
                CONV_END_SUBSCRIBE: "/subscribe/conversation/conversationEnd/",
                CONV_END_JOIN: "/join/conversation/conversationEnd/",
                CONV_UPDATE: "/conversation/conversationUpdate/",
                CONV_LOCAL_PARTICIPANT_UPDATE: "/conversation/localParticipantUpdate/",
                CONV_ROSTER_UPDATE: "/conversation/rosterUpdate/",
                CONV_ADD_PARTICIPANT_SUCCESS: "/conversation/addParticipantSuccess/",
                CONV_ADD_PARTICIPANT_FAILURE: "/conversation/addParticipantFailure/",
                CONV_NUDGE_PARTICIPANT_SUCCESS: "/conversation/nudgeParticipantSuccess/",
                CONV_NUDGE_PARTICIPANT_FAILURE: "/conversation/nudgeParticipantFailure/",
                CONV_ADMIT_PARTICIPANT_SUCCESS: "/conversation/admitParticipantSuccess/",
                CONV_ADMIT_PARTICIPANT_FAILURE: "/conversation/admitParticipantFailure/",
                CONV_ADMIT_ALL_STATUS: "/conversation/admitAllStatus/",
                CONV_REMOVE_PARTICIPANT_SUCCESS: "/conversation/removeParticipantSuccess/",
                CONV_REMOVE_PARTICIPANT_FAILURE: "/conversation/removeParticipantFailure/",
                CONV_ADD_MODALITY_SUCCESS: "/conversation/addModalitySuccess/",
                CONV_ADD_MODALITY_FAILURE: "/conversation/addModalityFailure/",
                CONV_CONTENT_SHARING_UPDATE: "/conversation/contentSharingUpdate/",
                CONV_CONTENT_SHARING_END: "/conversation/contentSharingEnd/",
                CONV_BROADCAST_UPDATE: "/conversation/broadcastUpdate/",
                CONV_CONFIRM_UNMUTE: "/conversation/confirmUnmute/",
                CONV_UNMUTE_SUCCESS: "/conversation/unmuteSuccess/",
                CONV_UNMUTE_FAILURE: "/conversation/unmuteFailure/",
                UPDATE_MEETING_LIVE_STATE_STATUS: "/conversation/updateMeetingLiveStateStatus/",
                UPDATE_MEETING_GROUPS_STATUS: "/conversation/updateMeetingGroupsStatus/",
                SET_MEETING_LAYOUT_STATUS: "/conversation/setMeetingLayoutStatus/",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS: "/conversation/updateParticipantInterpretationStateStatus/",
                UPDATE_PARTICIPANT_PROPERTIES_STATUS: "/conversation/updateParticipantPropertiesStatus/",
                JOIN_MEETING_GROUP_STATUS: "/conversation/joinMeetingGroupStatus/",
                LEAVE_MEETING_GROUP_STATUS: "/conversation/leaveMeetingGroupStatus/",
                RECEIVE_MESSAGE: "/conversation/receiveMessage/",
                SEND_MESSAGE_STATUS: "/conversation/sendMessageStatus/",
                DISABLE_PREHEAT_ASYNC_STATUS: "/conversation/disablePreheatAsyncStatus/",
                UPDATE_MEETING_STATES_STATUS: "/conversation/updateMeetingStatesStatus/",
                MUTE_UNMUTE_ASYNC: "/conversation/muteUnmuteAsync/"
            }, nn = {
                ...en,
                ...tn
            }, rn = {
                CALL_NOTIFICATION: "callNotification",
                MEDIA_ANSWER: "mediaAnswer",
                MEDIA_ACKNOWLEDGEMENT: "mediaAcknowledgement",
                CALL_ACCEPTANCE: "callAcceptance",
                CALL_END: "callEnd",
                CALL_PROGRESS: "callProgress",
                CALL_ACCEPTANCE_ACKNOWLEDGEMENT: "callAcceptanceAcknowledgement",
                MEDIA_NEGOTIATION: "mediaNegotiation",
                MEDIA_NEGOTIATION_FAILURE: "mediaNegotiationFailure",
                BALANCE_UPDATE: "balanceUpdate",
                RETARGET_COMPLETED: "retargetCompleted",
                CALL_TRANSFER: "callTransfer",
                TRANSFER_COMPLETION: "transferCompletion",
                TRANSFER_ACCEPTANCE: "transferAcceptance",
                PARK_COMPLETION: "holdCompletion",
                UNPARK_COMPLETION: "resumeCompletion",
                UPDATE_MEETING_LIVE_STATE_RESPONSE: "updateMeetingLiveStateResponse",
                UPDATE_MEETING_GROUPS_RESPONSE: "updateMeetingGroupsResponse",
                SET_MEETING_LAYOUT_RESPONSE: "setMeetingLayoutResponse",
                UPDATE_MEETING_STATES_RESPONSE: "updateMeetingStatesResponse",
                MONITOR_COMPLETION: "monitorCompletion"
            }, an = Xi, sn = __toESM(P), on = class _HttpHeaderImpl {
                isEmpty() {
                    return sn.isEmpty(this.headers);
                }
                set(g, f) {
                    this.headers[this.getLowerCaseName(g)] = f;
                }
                get(g, f) {
                    return f ? _HttpHeaderImpl.getHeaderValue(this.headers, g) || f : _HttpHeaderImpl.getHeaderValue(this.headers, g);
                }
                delete(g) {
                    delete this.headers[g], delete this.headers[g.toLowerCase()];
                }
                hasOwnPropertyCaseInsensitive(g) {
                    return Object.keys(this.headers).filter(function(f) {
                        return f.toUpperCase() === g.toUpperCase();
                    }).length > 0;
                }
                getAll() {
                    return this.headers;
                }
                getLowerCaseName(g) {
                    return _HttpHeaderImpl.useLowerCaseHeaders ? g.toLowerCase() : g;
                }
                static getHeaderValue(g, f) {
                    return g.hasOwnProperty(f) ? g[f] : g.hasOwnProperty(f.toLowerCase()) ? g[f.toLowerCase()] : void 0;
                }
                constructor(g){
                    this.headers = {}, g && Object.keys(g).forEach((f)=>{
                        this.headers[this.getLowerCaseName(f)] = g[f];
                    });
                }
            };
            function get2(g, f, S = causeId2()) {
                return assertNotNullOrEmpty(f, "trailingPath cannot be null"), assertNotNull(g, "signalingSession cannot be null"), assertNotNull(g.baseMessagingChannelUrl, "messaging channel url is not set"), `${g.baseMessagingChannelUrl}${an.URL_BASE.CALLAGENT}/${g.sessionId}/${S}${f}`;
            }
            function getIdFromUrl(g) {
                const f = g.match(new RegExp(`/${escapeRegExp(an.URL_BASE.CALLAGENT)}/+([^/]+)`, "i"));
                return f ? f[1] : null;
            }
            function clientSupportedTokenTypes(g) {
                let f = 1;
                return g.callingServiceSupportsAADTokens && (f |= 4), g.callingServiceSupportsCAETokens && (f |= 8), f;
            }
            function parseServiceTokenTypes2(g) {
                const f = g.toLowerCase(), S = 'token_types="', v = f.indexOf(S);
                if (-1 === v) return [];
                const _ = f.indexOf('"', v + S.length);
                if (-1 === _) return [];
                const C = f.substring(v + S.length, _).trim();
                if ("" === C) return [];
                return C.split(" ");
            }
            function is1to1Mri(g) {
                return !!g.match(/^8:/);
            }
            function stripMri(g) {
                return g.replace(/^\d+:/, "");
            }
            function causeId2() {
                return newGuid().substr(0, 8);
            }
            function newMessageId(g) {
                return g && /^[a-z0-9]{8}$/.test(g) ? g + newGuid().substr(8) : newGuid();
            }
            function newGuid() {
                const g = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", f = "0123456789abcdef";
                let S = "", v = 0, _ = 0;
                for(; _ < 36;){
                    const C = g[_];
                    switch(v = _ % 8 == 0 ? 4294967295 * Math.random() | 0 : v >> 4, C){
                        case "x":
                            S += f[15 & v];
                            break;
                        case "y":
                            S += f[3 & v | 8];
                            break;
                        case "4":
                        case "-":
                            S += C;
                    }
                    _++;
                }
                return S;
            }
            function assert2(g, f) {
                g || throwAssertTransactionEnd("Assert failed" + (void 0 !== f ? `:${f}` : ""));
            }
            function assertNotNullOrEmpty(g, f) {
                (!g || g instanceof String && "" === g || g instanceof Array && 0 === g.length) && throwAssertTransactionEnd("AssertNotNullOrEmpty failed. " + (void 0 !== f ? `: ${f}` : ""));
            }
            function assertNotNull(g, f) {
                g || throwAssertTransactionEnd("AssertNotNull failed. " + (void 0 !== f ? `: ${f}` : ""));
            }
            function assertCallEndReason(g) {
                assertNotNullOrEmpty(g, "callEndReason cannot be null or empty"), (void 0 === g.code || void 0 === g.subCode || void 0 === g.phrase || g.code < 0 || g.subCode < 0 || " " === g.phrase) && throwAssertTransactionEnd(`callEndReason must specify code, subCode and phrase. Invalid reason : ${getPrintableObject(g)}`);
            }
            function throwAssertTransactionEnd(g) {
                throw {
                    code: an.CALL_END_CODE.LOCAL_ERROR,
                    subCode: an.CALL_END_SUB_CODE.MISC_ERROR,
                    phrase: g,
                    resultCategories: [
                        Qi.ExpectedError
                    ]
                };
            }
            function getMediaTypes(g) {
                assertNotNull(g, "MediaTypes passed cannot be null");
                const f = [], S = an.MEDIA_TYPES;
                for (const v of Object.keys(S))arrayContains(g, S[v]) && f.push(S[v]);
                return f;
            }
            function getLinksPayload(g, f) {
                const S = {};
                for (const v of Object.values(f)){
                    const f = v.split("/");
                    S[f[f.length - 2]] = get2(g, v);
                }
                return S;
            }
            function stringEndsWith(g, f) {
                return g.length >= f.length && g.indexOf(f, g.length - f.length) > -1;
            }
            function arrayContains(g, f) {
                const S = f.toString().toLowerCase();
                return g.map((g)=>g.toString().toLowerCase()).indexOf(S) > -1;
            }
            function tryAddNewKeyToHashTable(g, f, S) {
                return !g.hasOwnProperty(f) && (g[f] = S, !0);
            }
            function tryRemoveKeyFromHashTable(g, f) {
                return !!g.hasOwnProperty(f) && (delete g[f], !0);
            }
            function escapeRegExp(g) {
                return g.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
            function tryParse(g) {
                let f = null;
                try {
                    return f = JSON.parse(g), "object" == typeof f ? f : null;
                } catch (g) {
                    return null;
                }
            }
            function getErrorForXHRFailure(g, f) {
                var _S__error;
                if (!g) return {
                    telemetryEndSubCode: an.CALL_END_CODE.UNKNOWN_ERROR,
                    error: an.CALL_END_UNKNOWN_ERROR
                };
                let S;
                if ("object" == typeof g.response) S = g.response;
                else try {
                    S = JSON.parse(g.response);
                } catch (g) {}
                if (g.skypeTokenError) return {
                    telemetryEndSubCode: an.CALL_END_CODE.SKYPE_TOKEN_ERROR,
                    error: an.CALL_END_SKYPE_TOKEN_ERROR
                };
                if (g.tokenTimeoutError && !g.tokenInteractivityRequiredTimeout) return {
                    telemetryEndSubCode: an.CALL_END_CODE.HTTP_OTHER_ERROR,
                    error: an.CALL_END_TOKEN_TIMEOUT_ERROR
                };
                if (g.tokenError) {
                    const f = g.tokenErrorSubCode ? {
                        code: an.CALL_END_TOKEN_ERROR.code,
                        subCode: g.tokenErrorSubCode,
                        phrase: an.CALL_END_TOKEN_ERROR.phrase,
                        resultCategories: an.CALL_END_TOKEN_ERROR.resultCategories
                    } : an.CALL_END_TOKEN_ERROR;
                    return {
                        telemetryEndSubCode: an.CALL_END_CODE.HTTP_OTHER_ERROR,
                        error: f
                    };
                }
                if (g.tokenInteractivityRequiredTimeout) return {
                    telemetryEndSubCode: an.CALL_END_CODE.HTTP_OTHER_ERROR,
                    error: an.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED
                };
                if (S && (S.operationFailure || S.broadcastOperationFailure)) {
                    const g = S.operationFailure || S.broadcastOperationFailure;
                    return {
                        telemetryEndSubCode: g.code,
                        error: g
                    };
                }
                return S && "net::err_name_not_resolved" === ((_S__error = S._error) === null || _S__error === void 0 ? void 0 : _S__error.toLowerCase()) ? {
                    telemetryEndSubCode: an.CALL_END_CODE.NETWORK_ERROR,
                    error: an.CALL_END_DNS_HOST_NAME_RESOLVE_ERROR
                } : (S === null || S === void 0 ? void 0 : S.code) ? {
                    telemetryEndSubCode: S.code,
                    error: S
                } : isNaN(g.status) || g.status !== an.CALL_END_CODE.NOT_FOUND ? !isNaN(g.status) && g.status ? {
                    telemetryEndSubCode: g.status,
                    error: {
                        code: g.status,
                        subCode: isNaN(g.response) ? 0 : g.response,
                        phrase: g.statusText,
                        resultCategories: [
                            Qi.UnexpectedClientError
                        ]
                    }
                } : !isNaN(g.response) && g.response ? {
                    telemetryEndSubCode: 0,
                    error: {
                        code: 0,
                        subCode: g.response,
                        phrase: g.statusText,
                        resultCategories: [
                            Qi.UnexpectedClientError
                        ]
                    }
                } : {
                    telemetryEndSubCode: an.CALL_END_CODE.NETWORK_ERROR,
                    error: an.CALL_END_NETWORK_ERROR
                } : {
                    telemetryEndSubCode: an.CALL_END_CODE.NOT_FOUND,
                    error: an.RESOURCE_NOT_FOUND_ERROR
                };
            }
            function isDuplicateMessage(g, f) {
                if (g && !g.isEmpty() && f) {
                    const S = g.get(an.HEADERS.ORIGINAL_MESSAGE_ID), v = g.get(an.HEADERS.MESSAGE_ID);
                    if (v && arrayContains(f, v) || S && arrayContains(f, S)) return !0;
                    f.length > 9 && f.shift(), f.push(S || v);
                }
                return !1;
            }
            function extractMessageIdFromMessage(g) {
                const f = "unknown";
                return g.headers ? g.headers.get(an.HEADERS.ORIGINAL_MESSAGE_ID, f) : f;
            }
            function extractCauseIdFromMessage(g) {
                try {
                    return g.headers.get(an.HEADERS.ORIGINAL_MESSAGE_ID).replace("-", "").substr(0, 8);
                } catch (g) {
                    return causeId2();
                }
            }
            function cacheMessageResult(g, f, S) {
                if (g && f) {
                    const v = g.get(an.HEADERS.ORIGINAL_MESSAGE_ID) || g.get(an.HEADERS.MESSAGE_ID) || null;
                    v && (f[v] = S);
                }
            }
            function getMessageResultFromCache(g, f) {
                if (g) return f[g.get(an.HEADERS.ORIGINAL_MESSAGE_ID) || g.get(an.HEADERS.MESSAGE_ID) || null] || null;
                return null;
            }
            function isEncodedMessage(g) {
                return g && g.hasOwnPropertyCaseInsensitive(an.HEADERS.CONTENT_ENCODING);
            }
            function isMessageEncodingSupported(g) {
                return g && an.KNOWN_PAYLOAD_ENCODINGS.hasOwnProperty(g.get(an.HEADERS.CONTENT_ENCODING).toUpperCase());
            }
            function parseRawHttpMessage(g) {
                const f = g.split(/\r?\n\r?\n/), S = f[0].split(/\r?\n/), v = f[1].split(/\r?\n/), _ = S.shift().split(" "), C = _[0], E = _[1] || "", T = new on;
                for (const g of S)try {
                    const [f, S] = g.split(":").map((g)=>Ji.trim(g));
                    T.set(f, S);
                } catch (f) {
                    throw new Error(`Malformed header: ${g + f}`);
                }
                return {
                    url: E,
                    headers: T,
                    method: C,
                    body: v.join("")
                };
            }
            function decodeMessage(g) {
                const f = atob(g);
                return Yi.inflate(f, {
                    to: "string"
                });
            }
            function defer() {
                let g, f, S = !0;
                return {
                    isPending: ()=>S,
                    promise: new Promise((S, v)=>{
                        g = S, f = v;
                    }),
                    resolve: (f)=>{
                        S && (g(f), S = !1);
                    },
                    reject: (g)=>{
                        S && (f(g), S = !1);
                    }
                };
            }
            function isTrouterAndNavigatorConnected(g) {
                let f = !1;
                try {
                    if (f = g && 2 === g.state(), navigator.onLine && f) return 3;
                    if (!navigator.onLine && f) return 2;
                    if (navigator.onLine && !f) return 1;
                } catch (e) {}
                return 0;
            }
            function isRetryable(g) {
                return [
                    an.HTTP_STATUS_CODES.UNKNOWN,
                    an.HTTP_STATUS_CODES.UNAUTHORIZED,
                    an.HTTP_STATUS_CODES.NETWORK_ERROR,
                    an.HTTP_STATUS_CODES.OFFLINE,
                    an.HTTP_STATUS_CODES.TIMEOUT,
                    an.HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR,
                    an.HTTP_STATUS_CODES.BAD_GATEWAY,
                    an.HTTP_STATUS_CODES.SERVICE_UNAVAILABLE,
                    an.HTTP_STATUS_CODES.GATEWAY_TIMEOUT
                ].indexOf(g) >= 0;
            }
            function convertStringToTokenType(g, f) {
                switch(g){
                    case an.HEADERS.CAE_KEYWORD.toLowerCase():
                        return 8;
                    case an.HEADERS.AAD_KEYWORD.toLowerCase():
                        return 4;
                    case an.HEADERS.SKYPE_KEYWORD.toLowerCase():
                        return 1;
                    default:
                        return f === null || f === void 0 ? void 0 : f.info("unexpected: unrecognized token type ${tokenType}"), null;
                }
            }
            function getAuthHeadersTokenTypes(g, f, S, v, _) {
                if (!f) return 1;
                const { callingServiceSupportsAADTokens: C, callingServiceSupportsCAETokens: E, supportMissingTokenTypesInResponse: T, useSkypeTokenWhenNoAuthenticateHeader: I } = g, b = _ === null || _ === void 0 ? void 0 : _.authenticationHeaders;
                v === null || v === void 0 ? void 0 : v.info(`[getAuthHeadersTokenTypes] UnauthorizedResponse=${S} and authHeaders=${b}`);
                let A = null;
                if (!b && S) I ? (v === null || v === void 0 ? void 0 : v.info("[getAuthHeadersTokenTypes] no www-authenticate header received, fallback to skype token"), A = 1) : (v === null || v === void 0 ? void 0 : v.info("[getAuthHeadersTokenTypes] Service has not provided www-authenticate headers. use client supported tokens"), A = clientSupportedTokenTypes(g));
                else if (b || S) {
                    if (b && S) for (const f of b){
                        const S = parseServiceTokenTypes2(f);
                        if (T && 0 === S.length) v === null || v === void 0 ? void 0 : v.info("[getAuthHeadersTokenTypes] Service has www-authenticate header, but no token types. Use client supported tokens"), A = clientSupportedTokenTypes(g);
                        else for (const g of S){
                            const f = convertStringToTokenType(g.toLowerCase(), v);
                            E && 8 === f && (A |= 8), C && 4 === f && (A |= 4), 1 === f && (A |= 1);
                        }
                    }
                } else v === null || v === void 0 ? void 0 : v.info("[getAuthHeadersTokenTypes] first time requesting token, request client supported token types"), A = clientSupportedTokenTypes(g);
                return A;
            }
            function getRequestTypeAsString(g) {
                switch(g){
                    case 0:
                        return "GET";
                    case 1:
                        return "POST";
                    case 2:
                        return "PUT";
                    case 3:
                        return "DELETE";
                }
            }
            function extractWwwauthenticateHeaders(g) {
                let f = {};
                if (g) {
                    const S = on.getHeaderValue(g, an.HEADERS.AUTHENTICATE);
                    S && (f = {
                        authenticationHeaders: [
                            S
                        ]
                    });
                }
                return f;
            }
            function getTokenMetadata(g, f, S, v, _ = !1, C, E) {
                E === null || E === void 0 ? void 0 : E.createChild("[utils.ts]");
                const T = {
                    verb: getRequestTypeAsString(S),
                    path: v.url
                }, I = JSON.stringify(T), b = extractWwwauthenticateHeaders(C), A = getAuthHeadersTokenTypes(g, f, _, E, b);
                return E === null || E === void 0 ? void 0 : E.info(`[getTokenMetadata] return token type=${A}, factoJson=${I}, headers=${b === null || b === void 0 ? void 0 : b.authenticationHeaders}`), {
                    tokenType: A,
                    factorsJson: I,
                    requestMetadataJson: b,
                    isUnauthorized: _
                };
            }
            function epochTimeInSecRoundedDown() {
                return Math.floor(Date.now() / 1e3);
            }
            function millieSecondsToSeconds(g) {
                return g / 1e3;
            }
            function secondsToMillieSeconds(g) {
                return 1e3 * g;
            }
            function getRequestToken(g) {
                const f = on.getHeaderValue(g, an.HEADERS.SKYPE_TOKEN);
                if (f) return f;
                const S = on.getHeaderValue(g, an.HEADERS.AUTHORIZATION);
                if (S) {
                    const g = S.split(" ");
                    if (2 === g.length) return g[1];
                }
            }
            function getParkTypeName(g) {
                switch(g){
                    case "none":
                        return "None";
                    case "teamPark":
                        return "TeamPark";
                    case "callPark":
                        return "CallParkV2";
                    case "serverHold":
                        return "ServerHold";
                    case "serverHoldV2":
                        return "MusicOnHoldV2";
                    case "sharedLinePark":
                        return "SharedLinePark";
                    case "sharedLineParkV2":
                        return "SharedLineAppearanceV2";
                    default:
                        return "UnknownType";
                }
            }
            function getPluginlessStateTypeFromWire(g) {
                switch(g){
                    case "raiseHands":
                        return "raiseHands";
                    case "ufd":
                        return "ufd";
                    case "attendeeModalitiesUnrestricted":
                        return "attendeeModalitiesUnrestricted";
                    case "attendeeAudioRestricted":
                        return "attendeeAudioRestricted";
                    case "attendeeVideoRestricted":
                        return "attendeeVideoRestricted";
                    case "attendeeVideoUnrestricted":
                        return "attendeeVideoUnrestricted";
                    case "spotlight":
                        return "spotlight";
                    case "weatherPerson":
                        return "weatherPerson";
                    case "sharingLayoutType":
                        return "sharingLayoutType";
                    case "manageBreakoutRooms":
                        return "manageBreakoutRooms";
                    case "togetherMode":
                        return "togetherMode";
                    case "consentToRecording":
                        return "consentToRecording";
                    case "denyConsentToRecording":
                        return "denyConsentToRecording";
                    case "clientMediaUfd":
                        return "clientMediaUfd";
                    case "serverMediaUfd":
                        return "serverMediaUfd";
                    case "dhhSigner":
                        return "dhhSigner";
                    case "signLanguageInterpreter":
                        return "signLanguageInterpreter";
                    default:
                        throw "Invalid state type when converting PublishType to PublishStateType.";
                }
            }
            function getPluginlessStateType(g) {
                switch(g){
                    case "raiseHands":
                        return "raiseHands";
                    case "ufd":
                        return "ufd";
                    case "attendeeModalitiesUnrestricted":
                        return "attendeeModalitiesUnrestricted";
                    case "attendeeAudioRestricted":
                        return "attendeeAudioRestricted";
                    case "attendeeVideoRestricted":
                        return "attendeeVideoRestricted";
                    case "attendeeVideoUnrestricted":
                        return "attendeeVideoUnrestricted";
                    case "spotlight":
                        return "spotlight";
                    case "weatherPerson":
                        return "weatherPerson";
                    case "sharingLayoutType":
                        return "sharingLayoutType";
                    case "manageBreakoutRooms":
                        return "manageBreakoutRooms";
                    case "togetherMode":
                        return "togetherMode";
                    case "consentToRecording":
                        return "consentToRecording";
                    case "denyConsentToRecording":
                        return "denyConsentToRecording";
                    case "clientMediaUfd":
                        return "clientMediaUfd";
                    case "serverMediaUfd":
                        return "serverMediaUfd";
                    case "dhhSigner":
                        return "dhhSigner";
                    case "signLanguageInterpreter":
                        return "signLanguageInterpreter";
                    default:
                        throw "Invalid state type when converting PublishStateType to PublishType.";
                }
            }
            function getParticipantInvitationData(g) {
                let f = {};
                return g.additionalData && g.customHeaderContext ? f = "object" == typeof g.additionalData ? {
                    ...g.additionalData,
                    customContext: g.customHeaderContext
                } : {
                    additionalData: g.additionalData,
                    customContext: g.customHeaderContext
                } : !g.additionalData && g.customHeaderContext ? f = {
                    customContext: g.customHeaderContext
                } : g.additionalData && !g.customHeaderContext && (f = g.additionalData), f;
            }
            function parseDisplayNameSourceFromWire(g) {
                if (!g) return;
                let f = "unknown";
                return "substrate" === g && (f = "substrate"), f;
            }
            var ln = class _Participant {
                static isInLobby(g, f) {
                    for (const S of g)if (S.endpointId === f && S.isLobby) return !0;
                    return !1;
                }
                static isParticipantServerMuted(g) {
                    for (const f of g)if (f.mediaStreams && !f.mappedTo) {
                        for (const g of f.mediaStreams)if ("audio" === g.type && !0 === g.serverMuted) return !0;
                    }
                    return !1;
                }
                static fromWireParticipant(g) {
                    return assertNotNull(g, "invalid wireParticipant"), assertNotNullOrEmpty(g.id, "participant must have valid Id"), new _Participant({
                        id: g.id,
                        displayName: g.displayName,
                        languageId: g.languageId,
                        acceptedBy: g.acceptedBy
                    });
                }
                static getPluginlessStateTypeFromWire(g) {
                    return getPluginlessStateTypeFromWire(g);
                }
                static findOrCreateTypeState(g, f) {
                    let S = f.typeStates.findIndex((f)=>f.type === g);
                    if (-1 === S) {
                        const v = {
                            participantStates: [],
                            type: g
                        };
                        f.typeStates.push(v), S = f.typeStates.length - 1;
                    }
                    return S;
                }
                static processPublishedStates(g, f) {
                    const S = {
                        typeStates: []
                    };
                    S.typeStates = [];
                    const v = g;
                    return Ki.forEach(v, (g)=>{
                        const v = this.findOrCreateTypeState(this.getPluginlessStateTypeFromWire(g.stateType), S), _ = {
                            id: f,
                            publishedState: {
                                content: g.content,
                                stateId: g.stateId,
                                typeRank: g.typeRank
                            }
                        };
                        S.typeStates[v].participantStates.push(_);
                    }), S;
                }
                static fromRosterEndpoints(g) {
                    let f = [], S = !1, v = !1, _ = !1, C = !1;
                    return f = Object.keys(g).map((f)=>{
                        var _g_f_broadcast;
                        let E, T, I, b = [], A = !1, R = 0;
                        if (g[f].call && (S = !0, b = g[f].call.mediaStreams || null, R = g[f].call.serverMuteVersion || 0, T = g[f].call.appliedInteractivityLevel || "unknown", I = g[f].call.negotiationTag), g[f].lobby && (A = !0, v = !0, b = g[f].lobby.mediaStreams || null), ((_g_f_broadcast = g[f].broadcast) === null || _g_f_broadcast === void 0 ? void 0 : _g_f_broadcast.sessionInformation) && (E = g[f].broadcast.sessionInformation.role || null), g[f].mappedParticipant && (_ = !0, b = g[f].mappedParticipant.mediaStreams || null), !g[f].capabilities && g[f].endpointCapabilities) {
                            const S = g[f].endpointCapabilities;
                            g[f].capabilities = {
                                implicitCallback: 16 & S ? "enabled" : "disabled",
                                cloudAudioVideoConference: 1 & S ? "enabled" : "disabled",
                                cloudScreenSharing: 2 & S ? "enabled" : "disabled",
                                hostlessConference: 4 & S ? "enabled" : "disabled",
                                autoJoinOnConflict: 32 & S ? "enabled" : "disabled",
                                serverMuteUnmute: 64 & S ? "enabled" : "disabled",
                                supportsCompressedServicePayload: 128 & S ? "enabled" : "disabled",
                                cloudMerge: 8 & S ? "enabled" : "disabled"
                            };
                        }
                        return C = C || !!g[f].streamLobby || !!g[f].stream, {
                            endpointId: f,
                            participantId: g[f].participantId || null,
                            clientVersion: g[f].clientVersion || null,
                            endpointMetadata: g[f].endpointMetadata || null,
                            originalId: g[f].originalId || null,
                            contentSharing: g[f].contentSharing || null,
                            capabilities: g[f].capabilities || null,
                            endpointType: g[f].endpointType || "default",
                            deviceType: g[f].deviceType || void 0,
                            clientEndpointCapabilities: g[f].clientEndpointCapabilities || void 0,
                            mediaStreams: b,
                            serverMuteVersion: R,
                            broadcastMeetingRole: E,
                            isLobby: A,
                            endpointState: g[f].endpointState || null,
                            publishedStates: g[f].publishedStates || null,
                            callLinks: g[f].callLinks || null,
                            appliedInteractivityLevel: T || "unknown",
                            mappedTo: g[f].mappedTo || null,
                            meetingGroupDetails: g[f].meetingGroupDetails,
                            streamInformation: g[f].streamInformation,
                            propertyBag: g[f].propertyBag,
                            streamLobby: g[f].streamLobby,
                            stream: g[f].stream,
                            endpointMeetingRoles: g[f].endpointMeetingRoles,
                            negotiationTag: I
                        };
                    }), {
                        endpointDetails: f,
                        participantHasCallModality: S,
                        participantIsInLobby: v,
                        participantHasMappedEndpoint: _,
                        participantHasStreamEndpoint: C
                    };
                }
                static fromRoster(g, f = !1) {
                    assertNotNull(g, `invalid rosterParticipant ${JSON.stringify(g)}`), assertNotNullOrEmpty(g.details.id, "participant must have valid Id");
                    const S = g.endpoints || {}, v = this.fromRosterEndpoints(S), _ = v.endpointDetails, C = v.participantHasCallModality, E = v.participantHasMappedEndpoint, T = v.participantHasStreamEndpoint;
                    let I = v.participantIsInLobby;
                    return C || I || E || f || T ? (C && (I = !1), new _Participant({
                        id: g.details.id,
                        displayName: g.details.displayName,
                        otpIdentity: g.details.otpIdentity,
                        version: g.version || 0,
                        propertyBag: g.details.propertyBag || null,
                        languageId: g.details.languageId,
                        role: g.role || "",
                        tenantId: g.details.tenantId || "",
                        endpointDetails: _ || [],
                        acceptedBy: g.acceptedBy || "",
                        isLobby: I,
                        meetingRole: g.meetingRole,
                        advancedMeetingRole: g.advancedMeetingRole,
                        meetingRoles: g.meetingRoles,
                        participantType: g.details.participantType,
                        publishedStates: g.publishedStates || null,
                        isIdentityMasked: g.details.isIdentityMasked,
                        nonMaskedId: g.details.nonMaskedId || "",
                        nonMaskedObjectId: g.details.nonMaskedObjectId || "",
                        nonMaskedDisplayName: g.details.nonMaskedDisplayName || "",
                        maskedIdSeqNumber: g.details.maskedIdSeqNumber || 0,
                        maskedId: g.details.maskedId || "",
                        joinAsStreamingUser: g.joinAsStreamingUser,
                        enableCaptcha: g.enableCaptcha
                    })) : null;
                }
                static fromRosterSearchResults(g) {
                    assertNotNull(g, `invalid rosterParticipant ${JSON.stringify(g)}`), assertNotNullOrEmpty(g.details.id, "participant must have valid Id");
                    const f = g.endpoints, { endpointDetails: S, participantHasCallModality: v, participantIsInLobby: _, participantHasMappedEndpoint: C, participantHasStreamEndpoint: E } = this.fromRosterEndpoints(f);
                    let T = 0;
                    return v || E ? T = 3 : _ ? T = 10 : C && (T = 3), {
                        id: g.details.id,
                        state: T,
                        tenantId: g.details.tenantId || "",
                        displayName: g.details.displayName,
                        role: g.role || "",
                        meetingRole: g.meetingRole,
                        advancedMeetingRole: g.advancedMeetingRole,
                        meetingRoles: g.meetingRoles,
                        participantType: g.details.participantType,
                        isServerMuted: this.isParticipantServerMuted(S),
                        publishedStates: this.processPublishedStates(g.publishedStates, g.details.id),
                        endpoints: S || [],
                        isIdentityMasked: g.details.isIdentityMasked,
                        nonMaskedId: g.details.nonMaskedId || "",
                        nonMaskedDisplayName: g.details.nonMaskedDisplayName || "",
                        nonMaskedObjectId: g.details.nonMaskedObjectId || "",
                        maskedIdSeqNumber: g.details.maskedIdSeqNumber || 0,
                        maskedId: g.details.maskedId || "",
                        joinAsStreamingUser: g.joinAsStreamingUser
                    };
                }
                constructor(g){
                    this.id = g.id, this.displayName = g.displayName || "", this.otpIdentity = g.otpIdentity, this.version = g.version, this.propertyBag = g.propertyBag, this.languageId = g.languageId || null, this.endpointDetails = g.endpointDetails || [], this.acceptedBy = g.acceptedBy, this.role = g.role, this.tenantId = g.tenantId, this.isLobby = g.isLobby, this.meetingRole = g.meetingRole, this.advancedMeetingRole = g.advancedMeetingRole, this.meetingRoles = g.meetingRoles, this.participantType = g.participantType, this.publishedStates = g.publishedStates, this.isIdentityMasked = g.isIdentityMasked, this.nonMaskedId = g.nonMaskedId, this.nonMaskedDisplayName = g.nonMaskedDisplayName, this.nonMaskedObjectId = g.nonMaskedObjectId, this.maskedIdSeqNumber = g.maskedIdSeqNumber, this.maskedId = g.maskedId, this.joinAsStreamingUser = g.joinAsStreamingUser, this.enableCaptcha = g.enableCaptcha;
                }
            }, cn = {
                HANDLE_MEDIA_ACKNOWLEDGEMENT: "HandleMediaAcknowledgement",
                HANDLE_MEDIA_NEGOTIATION_FAILURE: "HandleMediaNegotiationFailure",
                HANDLE_MEDIA_ANSWER: "HandleMediaAnswer",
                HANDLE_MEDIA_ANSWER_FAILED: "HandleMediaAnswerFailed",
                HANDLE_MEDIA_OFFER: "HandleMediaOffer",
                REJECT_RENEGOTIATION: "RejectRenegotiation",
                HANDLE_RETARGET_COMPLETED: "HandleRetargetCompleted",
                HANDLE_MEDIA_ANSWER_TIMEOUT: "HandleMediaAnswerTimeout",
                HANDLE_MEDIA_ACKNOWLEDGEMENT_TIMEOUT: "HandleMediaAcknowledgementTimeout",
                ACCEPT_RENEGOTIATION: "AcceptRenegotiation",
                START_RENEGOTIATION: "StartRenegotiation",
                MEDIA_FSM_STATE_CHANGED: "MediaFsmStateChanged",
                ADD_MODALITY_TIMEOUT: "AddModalityTimeout",
                ADD_PARTICIPANT: "AddParticipant",
                ADD_PARTICIPANT_TIMEOUT: "AddParticipantTimeout",
                ADD_PARTICIPANT_WITH_REPLACES: "AddParticipantWithReplaces",
                ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT: "AddParticipantWithReplacesTimeout",
                ADD_PARTICIPANTS_AND_MODALITY: "AddParticipantsAndModality",
                ADMIT_PARTICIPANT: "AdmitParticipant",
                ADMIT_PARTICIPANT_TIMEOUT: "AdmitParticipantTimeout",
                ADMIT: "Admit",
                ADMIT_TIMEOUT: "AdmitTimeout",
                ADMIT_FAILURE: "AdmitFailure",
                ADMIT_SUCCESS: "AdmitSuccess",
                CALL_ME_BACK: "CallMeBack",
                CALL_ME_BACK_TIMEOUT: "CallMeBackTimeout",
                REMOVE_PARTICIPANT: "RemoveParticipant",
                REMOVE_PARTICIPANT_OTHERS: "RemoveParticipantOthers",
                REMOVE_PARTICIPANT_SPECIFIED: "RemoveParticipantSpecified",
                REMOVE_PARTICIPANT_TIMEOUT: "RemoveParticipantTimeout",
                HANDLE_ADD_PARTICIPANT_SUCCESS: "HandleAddParticipantSuccess",
                HANDLE_ADD_PARTICIPANT_FAILURE: "HandleAddParticipantFailure",
                HANDLE_ADMIT_PARTICIPANT_SUCCESS: "HandleAdmitParticipantSuccess",
                HANDLE_ADMIT_PARTICIPANT_FAILURE: "HandleAdmitParticipantFailure",
                HANDLE_ADD_PARTICIPANT_MODALITY_FAILURE: "HandleAddParticipantModalityFailure",
                HANDLE_REMOVE_PARTICIPANT_SUCCESS: "HandleRemoveParticipantSuccess",
                HANDLE_REMOVE_PARTICIPANT_FAILURE: "HandleRemoveParticipantFailure",
                HANDLE_ROSTER_UPDATE: "HandleRosterUpdate",
                HANDLE_ROSTER_UPDATE_FAIL: "HandleRosterUpdateFail",
                HANDLE_CONVERSATION_UPDATE: "HandleConversationUpdate",
                HANDLE_LOCAL_PARTICIPANT_UPDATE: "HandleLocalParticipantUpdate",
                SET_SUBJECT: "SetSubject",
                SET_JOINED_FROM: "SetJoinedFrom",
                SET_DEVICETYPE: "SetDeviceType",
                GET_EMERGENCY_CONTENT: "GetEmergencyContent",
                SET_MULTIPARTY: "SetMultiparty",
                SET_GROUPID: "SetGroupId",
                SET_THREADID: "SetThreadId",
                SET_CALLOPTIONS: "SetCallOptions",
                SET_TRANSFER_CONTEXT: "SetTransferContext",
                START_CALL: "StartCall",
                JOIN_CALL: "JoinCall",
                START_OR_JOIN_CALL: "StartOrJoinCall",
                JOIN_CONVERSATION_WITHOUT_CALL_MODALITY: "JoinConversationWithoutCallModality",
                HANDLE_INCOMING_CALL: "HandleIncomingCall",
                END_CALL: "EndCall",
                END_WITH_BEACON: "EndWithBeacon",
                CONFLICTED_CALL: "ConflictedCall",
                SET_PROVISIONAL_ANSWER: "SetProvisionalAnswer",
                SET_PROVISIONAL_ANSWER_FAILED: "SetProvisionalAnswerFailed",
                ACCEPT_CALL: "AcceptCall",
                ACCEPT_CALL_FAILED: "AcceptCallFailed",
                HANDLE_CALL_ACCEPTANCE_ACK: "HandleCallAcceptanceAck",
                HANDLE_CALL_ACCEPTANCE: "HandleCallAcceptance",
                HANDLE_CALL_ACCEPTANCE_SYNC: "HandleCallAcceptanceSync",
                HANDLE_CALL_ACCEPTANCE_FAILED: "HandleCallAcceptanceFailed",
                HANDLE_CALL_ESTABLISHMENT_TIMEOUT: "HandleCallEstablishmentTimeout",
                HANDLE_CALL_END: "HandleCallEnd",
                HANDLE_CALL_PROGRESS: "HandleCallProgress",
                TROUTER_URL_CHANGED: "TrouterUrlChanged",
                TROUTER_STATE_CHANGED: "TrouterStateChanged",
                TROUTER_URL_CHANGED_TO_INVALID: "TrouterUrlChangedToInvalid",
                TROUTER_URL_UPDATE_FAILED: "TrouterUrlUpdateFailed",
                ADD_CONTENT_SHARING_MODALITY: "AddContentSharingModality",
                ACCEPTED_BEFORE_RINGING: "AcceptedBeforeRinging",
                LEAVE_CONTENT_SHARING: "LeaveContentSharing",
                DELETE_CONTENT_SHARING: "DeleteContentSharing",
                TAKE_CONTROL_CONTENT_SHARING: "TakeControlContentSharing",
                UPDATE_SESSION_STATE_CONTENT_SHARING: "UpdateSessionStateContentSharing",
                JOIN_CONTENT_SHARING: "JoinContentSharing",
                UPDATE_PARTICIPANT_STATE_CONTENT_SHARING: "UpdateParticipantStateContentSharing",
                HANDLE_CONTENT_SHARING_UPDATE: "HandleContentSharingUpdate",
                HANDLE_CONTENT_SHARING_END: "HandleContentSharingEnd",
                CONTENT_SHARING_START_FROM_ROSTER: "ContentSharingStartFromRoster",
                CONTENT_SHARING_END_FROM_ROSTER: "ContentSharingEndFromRoster",
                HANDLE_ADD_MODALITY_SUCCESS: "HandleAddModalitySuccess",
                HANDLE_ADD_MODALITY_FAILURE: "HandleAddModalityFailure",
                ADD_BROADCAST_MODALITY: "AddBroadcastModality",
                ADD_MODALITY: "AddModality",
                UPDATE_BROADCAST_DETAILS: "UpdateBroadcastDetails",
                WAITING_FOR_ADD_BROADCAST_MODALITY_COMPLETION: "WaitingForAddBroadcastModalityCompletion",
                WAITING_FOR_ADD_MODALITY_COMPLETION: "WaitingForAddModalityCompletion",
                MUTE: "Mute",
                NUDGE_PARTICIPANT_TIMEOUT: "NudgeParticipantTimeout",
                UNMUTE: "Unmute",
                UNMUTE_TIMEOUT: "UnmuteTimeout",
                HANDLE_UNMUTE_CONFIRM: "HandleUnmuteConfirm",
                HANDLE_UNMUTE_SUCCESS: "HandleUnmuteSuccess",
                HANDLE_UNMUTE_FAILURE: "HandleUnmuteFailure",
                APPROVE_UNMUTE: "ApproveUnmute",
                REJECT_UNMUTE: "RejectUnmute",
                HANDLE_CONTROL_VIDEO_STREAMING: "HandleControlVideoStreaming",
                HANDLE_DOMINANT_SPEAKER_CHANGED_COUNT: "HandleDominantSpeakerChangedCount",
                HANDLE_CSRC_INFO: "HandleCsrcInfo",
                SEND_WEBRTC_MEDIA_NOTIFICATION: "SendWebRtcMediaNotification",
                HANDLE_BALANCE_UPDATE: "HandleBalanceUpdate",
                TRANSFER_CALL: "TransferCall",
                PARK_CALL: "ParkCall",
                CALL_REDIRECT: "CallRedirect",
                CALL_REDIRECT_REQUEST_FAILED: "CallRedirectRequestFailed",
                TRANSFER_COMPLETION_FAILED: "TransferCompletionFailed",
                TRANSFER_REQUEST_RECEIVED: "TransferRequestReceived",
                HANDLE_PARK_REQUESTED: "HandleParkRequested",
                HANDLE_SERVER_HOLD: "HandleServerHold",
                DUPLICATE_MESSAGE_IGNORED: "DuplicateMessageIgnored",
                CORRELATION_ID_UPDATED: "CorrelationIdUpdated",
                UNKNOWN_MESSAGE_TYPE: "UnkownMessageType",
                FAILED_TO_HANDLE_MESSAGE: "FailedToHandleMessage",
                CONNECTIVITY_CHANGED: "ConnectivityChanged",
                TROUTER_DECODE_PAYLOAD_FAILURE: "TrouterDecodePayloadFailure",
                UPDATE_ENDPOINT_STATE: "UpdateEndpointState",
                UPDATE_ENDPOINT_STATE_SUCCESS: "UpdateEndpointStateSuccess",
                UPDATE_ENDPOINT_STATE_FAILURE: "UpdateEndpointStateFailure",
                BROKER_DECODE_PAYLOAD_FAILURE: "BrokerDecodePayloadFailure",
                BROKER_SUBSCRIPTION_TIMEOUT: "BrokerSubscriptionTimeout",
                BROKER_SUBSCRIPTION_SUCCESSFUL: "BrokerSubscriptionSuccessful",
                BROKER_SUBSCRIPTION_FAILED: "BrokerSubscriptionFailed",
                FAILED_TO_HANDLE_TROUTER_MESSAGE: "FailedToHandleTrouterMessage",
                FAILED_TO_HANDLE_BROKER_MESSAGE: "FailedToHandleBrokerMessage",
                BROKER_DISABLED_SUBSCRIBE_URL_PRESENT: "BrokerDisabledSubscribeUrlPresent",
                CONNECTED: "Connected",
                IN_LOBBY: "InLobby",
                STAGING: "Staging",
                MESSAGE_MISSING_BODY: "MessageMissingBody",
                BROADCAST_STATE_CHANGED: "BroadcastStateChanged",
                HANDLE_CALL_NOTIFICATION: "HandleCallNotification",
                HANDLE_INCOMING_CALL_REPLACEMENT: "HandleIncomingCallReplacement",
                HANDLE_PSTN_BALANCE_UPDATE: "HandlePstnBalanceUpdate",
                IGNORE_OLD_ROSTER: "IgnoreOldRoster",
                HANDLE_MEDIA_ACK: "HandleMediaAck",
                HANDLE_MEDIA_PROVISIONAL_ACK: "HandleMediaProvisionalAck",
                UPDATE_CALL_STATUS: "UpdateCallStatus",
                SEND_ATTACH: "SendAttach",
                REQUEST_NEW_OFFER: "RequestNewOffer",
                HANDLE_NEW_OFFER: "HandleNewOffer",
                UPDATE_CONVERSATION_LINKS: "UpdateConversationLinks",
                UPDATE_CONVERSATION_LINKS_SUCCESS: "UpdateConversationLinksSuccess",
                UPDATE_CONVERSATION_LINKS_FAILED: "UpdateConversationLinksFailed",
                PROCESS_INITIAL_OFFER: "ProcessInitialOffer",
                SEND_PROGRESS: "SendProgress",
                SEND_PROGRESS_FAILED: "SendProgressFailed",
                PROCESS_CALL_ACCEPTANCE: "ProcessCallAcceptance",
                ACCEPTANCE_USER_IN_LOBBY: "AcceptanceUserInLobby",
                REJECT_INCOMING_CALL: "RejectIncomingCall",
                SEND_KEEP_ALIVE: "SendKeepAlive",
                SEND_KEEP_ALIVE_FAILED: "SendKeepAliveFailed",
                SEND_CONVERSATION_KEEP_ALIVE_FAILED: "SendConversationKeepAliveFailed",
                START_AUDIO: "StartAudio",
                STOP_AUDIO: "StopAudio",
                UPDATE_MEETING_ROLE: "UpdateMeetingRole",
                UPDATE_MEETING_ROLE_TIMEOUT: "UpdateMeetingRoleTimeout",
                PREHEAT_ENABLING: "EnablingPreheat",
                PREHEAT_DISABLING: "DisablingPreheat",
                PREHEAT_DISABLED: "PreheatDisabled",
                TRANSFER_REQUEST_SENT: "TransferRequestSent",
                CALL_REDIRECT_REQUEST_SENT: "CallRedirectRequestSent",
                TRANSFER_REQUEST_FAILED: "TransferRequestFailed",
                SEND_ACCEPT_TRANSFER: "SendAcceptTransfer",
                SEND_ACCEPT_TRANSFER_FAIL: "SendAcceptTransferFail",
                WAITING_FOR_TRANSFER_COMPLETION: "WaitingForTransferCompletion",
                WAITING_FOR_TRANSFER_COMPLETION_FAIL: "WaitingForTransferCompletionFail",
                WAITING_FOR_TRANSFER_ACCEPTANCE_FAIL: "WaitingForTransferAcceptanceFail",
                WAITING_FOR_TRANSFER_ACCEPTANCE: "WaitingForTransferAcceptance",
                TRANSFER_COMPLETED: "TransferCompleted",
                SEND_COMPLETE_TRANSFER: "SendCompleteTransfer",
                SEND_COMPLETE_TRANSFER_FAILED: "SendCompleteTransferFailed",
                PICKUP_CODE_SET: "PickupCodeSet",
                ADD_PARTICIPANT_WITH_PICKUP_CODE: "AddParticipantWithPickupCode",
                ADD_PARTICIPANT_WITH_PICKUP_CODE_TIMEOUT: "AddParticipantWithPickupCodeTimeout",
                PUBLISH_STATE: "PublishState",
                PUBLISH_STATE_FAILURE: "PublishStateFailure",
                REMOVE_STATE: "RemoveState",
                REMOVE_STATE_FAILURE: "RemoveStateFailure",
                UPDATE_MEETING_SETTINGS: "UpdateMeetingSettings",
                UPDATE_MEETING_SETTINGS_FAILURE: "UpdateMeetingSettingsFailure",
                UPDATE_ENDPOINT_METADATA_SUCCESS: "UpdateEndpointMetadataSuccess",
                UPDATE_ENDPOINT_METADATA_FAILURE: "UpdateEndpointMetadataFailure",
                SEARCH_PARTICIPANTS: "SearchParticipants",
                GET_ALL_PARTICIPANTS: "GetAllParticipants",
                SEARCH_PARTICIPANTS_FAILURE: "SearchParticipantsFailure",
                GET_ALL_PARTICIPANTS_FAILURE: "GetAllParticipantsFailure",
                PARK_REQUEST: "SendParkRequest",
                PARK_REQUEST_FAILED: "ParkRequestFailed",
                WAITING_FOR_PARK_COMPLETION: "WaitingForParkCompletion",
                WAITING_FOR_PARK_COMPLETION_TIMEOUT: "WaitingForParkCompletionTimeout",
                PARK_COMPLETED: "ParkCompleted",
                PARK_FAILED: "ParkFailed",
                SEND_UNPARK_REQUEST: "SendUnparkRequest",
                UNPARK_REQUEST_FAILED: "UnparkRequestFailed",
                WAITING_FOR_UNPARK_COMPLETION: "WaitingForUnparkCompletion",
                WAITING_FOR_UNPARK_COMPLETION_TIMEOUT: "WaitingForUnparkCompletionTimeout",
                UNPARK_COMPLETED: "UnparkCompleted",
                UNPARK_FAILED: "UnparkFailed",
                UPDATE_MEETING_LIVE_STATE: "UpdateMeetingLiveState",
                WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION: "WaitingForUpdateMeetingLiveStateCompletion",
                UPDATE_MEETING_LIVE_STATE_REQUEST_FAILED: "UpdateMeetingLiveStateRequestFailed",
                UPDATE_MEETING_LIVE_STATE_RESPONSE_FAILURE: "UpdateMeetingLiveStateResponseFailure",
                UPDATE_MEETING_LIVE_STATE_RESPONSE_SUCCESS: "UpdateMeetingLiveStateResponseSuccess",
                UPDATE_MEETING_GROUPS: "UpdateMeetingGroups",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE: "UpdateParticipantInterpretationState",
                UPDATE_PARTICIPANTS_PROPERTIES: "UpdateParticipantsProperties",
                JOIN_MEETING_GROUP: "JoinMeetingGroup",
                LEAVE_MEETING_GROUP: "LeaveMeetingGroup",
                INCOMING_PROXIED_MESSAGES: "incomingProxiedMessages",
                WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION: "WaitingForUpdateMeetingGroupsCompletion",
                UPDATE_MEETING_GROUPS_REQUEST_FAILED: "UpdateMeetingGroupsRequestFailed",
                UPDATE_MEETING_GROUPS_REQUEST_COMPLETED: "UpdateMeetingGroupsRequestCompleted",
                UPDATE_MEETING_GROUPS_RESPONSE_FAILURE: "UpdateMeetingGroupsResponseFailure",
                UPDATE_MEETING_GROUPS_RESPONSE_SUCCESS: "UpdateMeetingGroupsResponseSuccess",
                SET_MEETING_LAYOUT: "SetMeetingLayout",
                WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION: "WaitingForSetMeetingLayoutCompletion",
                SET_MEETING_LAYOUT_REQUEST_FAILED: "SetMeetingLayoutRequestFailed",
                SET_MEETING_LAYOUT_RESPONSE_FAILURE: "SetMeetingLayoutResponseFailure",
                SET_MEETING_LAYOUT_RESPONSE_SUCCESS: "SetMeetingLayoutResponseSuccess",
                WAITING_FOR_UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION: "WaitingForUpdateParticipantInterpretationStateCompletion",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT: "UpdateParticipantInterpretationStateTimeout",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_REQUEST_FAILED: "UpdateParticipantInterpretationStateRequestFailed",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_REQUEST_COMPLETED: "UpdateParticipantInterpretationStateRequestCompleted",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_FAILED: "UpdateParticipantInterpretationStateResponseFailed",
                UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_COMPLETED: "UpdateParticipantInterpretationStateResponseCompleted",
                WAITING_FOR_UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION: "WaitingForUpdateParticipantsPropertiesCompletion",
                UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT: "UpdateParticipantsPropertiesTimeout",
                UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED: "UpdateParticipantsPropertiesResponseFailed",
                UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_COMPLETED: "UpdateParticipantsPropertiesResponseCompleted",
                WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION: "WaitingForJoinMeetingGroupCompletion",
                JOIN_MEETING_GROUP_REQUEST_FAILED: "JoinMeetingGroupRequestFailed",
                JOIN_MEETING_GROUP_REQUEST_COMPLETED: "JoinMeetingGroupRequestCompleted",
                JOIN_MEETING_GROUP_RESPONSE_FAILED: "JoinMeetingGroupRequestFailed",
                JOIN_MEETING_GROUP_RESPONSE_COMPLETED: "JoinMeetingGroupRequestCompleted",
                WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION: "WaitingForLeaveMeetingGroupCompletion",
                LEAVE_MEETING_GROUP_REQUEST_FAILED: "LeaveMeetingGroupRequestFailed",
                LEAVE_MEETING_GROUP_REQUEST_COMPLETED: "LeaveMeetingGroupRequestCompleted",
                LEAVE_MEETING_GROUP_RESPONSE_FAILED: "LeaveMeetingGroupRequestFailed",
                LEAVE_MEETING_GROUP_RESPONSE_COMPLETED: "LeaveMeetingGroupRequestCompleted",
                SUBSCRIBE_URL_FOUND: "SubscribeUrlFound",
                SUBSCRIBE_URL_MISSING: "SubscribeUrlMissing",
                SEND_MESSAGE_COMPLETION: "SendMessageCompletion",
                SEND_MESSAGE_TIMEOUT: "SendMessageTimeout",
                DISABLE_PREHEAT_SUCCEEDED: "DiablePreheatSucceeded",
                ASYNC_DISABLE_PREHEAT_SUCCEEDED: "AsyncDisablePreheatSucceeded",
                DISABLE_PREHEAT_FAILED: "DiablePreheatFailed",
                ASYNC_DISABLE_PREHEAT_FAILED: "AsyncDiablePreheatFailed",
                ASYNC_DISABLE_PREHEAT_TIMEOUT: "AsyncDiablePreheatTimeout",
                DISABLE_PREHEAT_RESPONSE_RECEIVED: "DisablePreheatResponseReceived",
                SET_STREAM_INFORMATION_RECEIVED: "StreamInformationReceived",
                UPDATE_MEDIA_DESCRIPTIONS: "UpdateMediaDescriptions",
                UPDATE_MEDIA_DESCRIPTIONS_FAILED: "UpdateMediaDescriptionsFailed",
                NUDGE_TO_JOIN_REALTIME: "NudgeToJoinAsRealtime",
                UPDATE_MEETING_STATES: "UpdateMeetingStates",
                WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION: "WaitingForUpdateMeetingStatesCompletion",
                UPDATE_MEETING_STATES_RESPONSE_SUCCESS: "UpdateMeetingStatesResponseSuccess",
                UPDATE_MEETING_STATES_RESPONSE_FAILURE: "UpdateMeetingStatesResponseFailure",
                UPDATE_MONITOR_SESSION: "UpdateMonitorSession",
                UPDATE_MONITOR_SESSION_REQUEST_FAILED: "UpdateMonitorSessionRequestFailed",
                UPDATE_MONITOR_SESSION_REQUEST_COMPLETED: "UpdateMonitorSessionRequestCompleted",
                UPDATE_MONITOR_SESSION_RESPONSE_FAILED: "UpdateMonitorSessionResponseFailed",
                UPDATE_MONITOR_SESSION_RESPONSE_COMPLETED: "UpdateMonitorSessionResponseCompleted",
                WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION: "WaitingForUpdateMonitorSessionCompletion"
            }, dn = {
                SEND_MEDIA_ANSWER: {
                    name: "SendMediaAnswer",
                    controller: 0
                },
                START_RENEGOTIATION: {
                    name: "StartRenegotiation",
                    controller: 0
                },
                SEND_MEDIA_ACKNOWLEDGEMENT: {
                    name: "SendMediaAcknowledgement",
                    controller: 0
                },
                SEND_MEDIA_REJECTION: {
                    name: "SendMediaRejection",
                    controller: 0
                },
                ADD_PARTICIPANT: {
                    name: "AddParticipant",
                    controller: 1
                },
                ADD_PARTICIPANT_WITH_REPLACES: {
                    name: "AddParticipantWithReplaces",
                    controller: 1
                },
                NUDGE_PARTICIPANT: {
                    name: "NudgeParticipant",
                    controller: 1
                },
                REMOVE_PARTICIPANT_NONE: {
                    name: "RemoveParticipant",
                    controller: 1
                },
                REMOVE_PARTICIPANT_OTHERS: {
                    name: "RemoveParticipantOthers",
                    controller: 1
                },
                REMOVE_PARTICIPANT_SPECIFIED: {
                    name: "RemoveParticipantSpecified",
                    controller: 1
                },
                ADMIT_PARTICIPANT: {
                    name: "AdmitParticipant",
                    controller: 1
                },
                ADMIT: {
                    name: "Admit",
                    controller: 1
                },
                BROKER_SUBSCRIBE: {
                    name: "BrokerSubscribe",
                    controller: 2
                },
                CALL_ME_BACK: {
                    name: "CallMeBack",
                    controller: 1
                },
                SEND_ACCEPTANCE: {
                    name: "SendAcceptance",
                    controller: 0
                },
                SEND_ACCEPTANCE_ACKNOWLEDGEMENT: {
                    name: "SendAcceptanceAcknowledgement",
                    controller: 0
                },
                END_CALL: {
                    name: "EndCall",
                    controller: 1
                },
                CANCEL_CALL: {
                    name: "CancelCall",
                    controller: 1
                },
                REJECT_CALL: {
                    name: "RejectCall",
                    controller: 0
                },
                JOIN_CONVERSATION: {
                    name: "JoinConversation",
                    controller: 1
                },
                JOIN_CONVERSATION_WITHOUT_CALL_MODALITY: {
                    name: "JoinConversationWithoutCallModality",
                    controller: 1
                },
                LEAVE_CONVERSATION: {
                    name: "LeaveConversation",
                    controller: 1
                },
                DELETE_CONVERSATION: {
                    name: "DeleteConversation",
                    controller: 1
                },
                START_CALL: {
                    name: "StartCall",
                    controller: 1
                },
                PLACE_NUDGE_CALL: {
                    name: "PlaceNudgeCall",
                    controller: 5
                },
                UPDATE_CONVERSATION_LINKS: {
                    name: "UpdateConversationLinks",
                    controller: 1
                },
                SEND_CONVERSATION_KEEP_ALIVE: {
                    name: "SendConversationKeepAlive",
                    controller: 1
                },
                SEND_CALL_ATTACH: {
                    name: "SendCallAttach",
                    controller: 0
                },
                SEND_CALL_PROGRESS: {
                    name: "SendCallProgress",
                    controller: 0
                },
                SEND_KEEP_ALIVE: {
                    name: "SendKeepAlive",
                    controller: 0
                },
                ADD_CONTENT_SHARING_MODALITY: {
                    name: "AddContentSharingModality",
                    controller: 1
                },
                DELETE_CONTENT_SHARING: {
                    name: "DeleteContentSharing",
                    controller: 3
                },
                TAKE_CONTROL_CONTENT_SHARING: {
                    name: "TakeControlContentSharing",
                    controller: 3
                },
                UPDATE_SESSION_STATE_CONTENT_SHARING: {
                    name: "UpdateSessionStateContentSharing",
                    controller: 3
                },
                JOIN_CONTENT_SHARING: {
                    name: "JoinContentSharing",
                    controller: 3
                },
                UPDATE_PARTICIPANT_STATE_CONTENT_SHARING: {
                    name: "UpdateParticipantStateContentSharing",
                    controller: 3
                },
                UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS: {
                    name: "UpdateContentSharingNotificationLinks",
                    controller: 3
                },
                MUTE_ALL: {
                    name: "MuteAll",
                    controller: 1
                },
                MUTE_ALL_SYNC: {
                    name: "MuteAllSync",
                    controller: 1
                },
                MUTE_SPECIFIED: {
                    name: "MuteSpecified",
                    controller: 1
                },
                MUTE_SPECIFIED_SYNC: {
                    name: "MuteSpecifiedSync",
                    controller: 1
                },
                MUTE_MYSELF: {
                    name: "MuteMyself",
                    controller: 1
                },
                UNMUTE: {
                    name: "Unmute",
                    controller: 1
                },
                UNMUTE_SYNC: {
                    name: "UnmuteMyselfSync",
                    controller: 1
                },
                SEND_CONTROL_VIDEO_STREAMING: {
                    name: "SendControlVideoStreaming",
                    controller: 0
                },
                SEND_APPLY_CHANNEL_PARAMETERS: {
                    name: "SendApplyChannelParameters",
                    controller: 0
                },
                APPROVE_UNMUTE: {
                    name: "ApproveUnmute",
                    controller: 5
                },
                REJECT_UNMUTE: {
                    name: "RejectUnmute",
                    controller: 5
                },
                SEND_CALL_REDIRECT_REQUEST: {
                    name: "SendCallRedirectRequest",
                    controller: 0
                },
                SEND_TRANSFER_REQUEST: {
                    name: "SendTransferRequest",
                    controller: 0
                },
                SEND_PARK_REQUEST: {
                    name: "SendParkRequest",
                    controller: 0
                },
                SEND_SHARED_LINE_PARK_REQUEST: {
                    name: "SharedLinePark",
                    controller: 0
                },
                SEND_SERVER_HOLD_REQUEST: {
                    name: "ServerHoldRequest",
                    controller: 0
                },
                PARK_REQUEST: {
                    name: "ParkRequest",
                    controller: 0
                },
                SEND_UNPARK_REQUEST: {
                    name: "UnparkRequest",
                    controller: 0
                },
                TRANSFER_ACCEPTANCE: {
                    name: "TransferAcceptance",
                    controller: 0
                },
                TRANSFER_COMPLETION: {
                    name: "TransferCompletion",
                    controller: 0
                },
                TRANSFER_COMPLETION_FAILED: {
                    name: "TransferCompletionFailed",
                    controller: 0
                },
                UPDATE_ENDPOINT_STATE: {
                    name: "UpdateEndpointState",
                    controller: 1
                },
                DISABLE_PREHEAT: {
                    name: "DisablePreheat",
                    controller: 5
                },
                REQUEST_NEW_OFFER: {
                    name: "RequestNewOffer",
                    controller: 0
                },
                UPDATE_ENDPOINT_METADATA: {
                    name: "UpdateEndpointMetadata",
                    controller: 1
                },
                UPDATE_MEETING_ROLE_ATTENDEE: {
                    name: "UpdateMeetingRoleToAttendee",
                    controller: 1
                },
                UPDATE_MEETING_ROLE_PRESENTER: {
                    name: "UpdateMeetingRoleToPresenter",
                    controller: 1
                },
                UPDATE_MEETING_ROLE_ORGANIZER: {
                    name: "UpdateMeetingRoleToOrganizer",
                    controller: 1
                },
                ADD_PARTICIPANT_WITH_PICKUP_CODE: {
                    name: "AddParticipantWithPickupCode",
                    controller: 1
                },
                PUBLISH_STATE: {
                    name: "PublishState",
                    controller: 1
                },
                REMOVE_STATE: {
                    name: "RemoveState",
                    controller: 1
                },
                UPDATE_MEETING_SETTINGS: {
                    name: "UpdateMeetingSettings",
                    controller: 1
                },
                ADD_PARTICIPANTS_AND_MODALITY: {
                    name: "AddParticipantsAndModality",
                    controller: 1
                },
                ADD_BROADCAST_MODALITY: {
                    name: "AddBroadcastModality",
                    controller: 1
                },
                ADD_MODALITY: {
                    name: "AddModality",
                    controller: 1
                },
                SEARCH_PARTICIPANTS: {
                    name: "SearchParticipants",
                    controller: 1
                },
                GET_ALL_PARTICIPANTS: {
                    name: "GetAllParticipants",
                    controller: 1
                },
                UPDATE_MEETING_LIVE_STATE: {
                    name: "UpdateMeetingLiveState",
                    controller: 1
                },
                UPDATE_MEETING_GROUPS: {
                    name: "UpdateMeetingGroups",
                    controller: 1
                },
                SET_MEETING_LAYOUT: {
                    name: "SetMeetingLayout",
                    controller: 1
                },
                UPDATE_PARTICIPANT_INTERPRETATION_STATE: {
                    name: "UpdateParticipantInterpretationState",
                    controller: 1
                },
                JOIN_MEETING_GROUP: {
                    name: "JoinMeetingGroup",
                    controller: 1
                },
                LEAVE_MEETING_GROUP: {
                    name: "LeaveMeetingGroup",
                    controller: 1
                },
                SEND_PROXIED_MESSAGE: {
                    name: "SendProxiedMessage",
                    controller: 1
                },
                UPDATE_PARTICIPANTS_PROPERTIES: {
                    name: "UpdateParticipantsProperties",
                    controller: 1
                },
                UPDATE_MEDIA_DESCRIPTIONS: {
                    name: "UpdateMediaDescriptions",
                    controller: 0
                },
                UPDATE_MEETING_STATES: {
                    name: "UpdateMeetingStates",
                    controller: 1
                },
                UPDATE_MONITOR_SESSION: {
                    name: "UpdateMonitorSession",
                    controller: 0
                }
            }, un = {
                EVENT_SOURCE: {
                    TROUTER: "Trouter",
                    BROKER: "Broker",
                    UDP: "UDP",
                    LOCAL: "Local"
                },
                SOURCE: {
                    NGC_SOURCE: "SkypeConcore"
                },
                EVENT_TYPE: {
                    CONVERSATION_CALL_MODALITY: "skypecosi_concore_web_csa_conversation_callmodality",
                    CONVERSATION_CONTENT_SHARING: "skypecosi_concore_web_csa_conversation_contentsharing",
                    CONVERSATION_HTTP_REQUEST: "skypecosi_concore_web_csa_conversation_httprequest",
                    CONVERSATION_TOKEN: "skypecosi_concore_web_csa_conversation_token"
                },
                EXTENSIONS: {
                    DATA_VERSION: "DataVersion",
                    DIRECTION: "Direction",
                    CONTENT_SHARING_DIRECTION: "ContentSharingDirection",
                    CONNECTED_DURATION_IN_MS: "ConnectedDurationInMsecs",
                    PREHEATED_CALL_SETUP_DURATION_IN_S: "PreheatedCallSetupDurationInSeconds",
                    CALL_CANCELATION_DURATION_IN_S: "CallCancelationDurationInSeconds",
                    IS_PREHEATED: "IsPreheated",
                    TIME_TO_RING_IN_MS: "TimeToRingInMsecs",
                    CALL_TERMINATING_END: "CallTerminatingEnd",
                    NETWORK_REQUESTS_PENDING: "NetworkRequestsPending",
                    NETWORK_REQUESTS_COMPLETED: "NetworkRequestsCompleted",
                    LOCAL_OPERATIONS_PERFORMED: "LocalOperationsPerformed",
                    TROUTER_WAIT_OPERATIONS: "TrouterWaitOperations",
                    CALL_START_TIME: "CallStartTime",
                    CALL_END_TIME: "CallEndTime",
                    IS_GROUP_CALL: "IsGroupCall",
                    IS_HOSTLESS_CALL: "IsHostLessCall",
                    IS_CAST_CALL: "IsCastCall",
                    IS_HUDDLE_GROUP_CALL: "IsHuddleGroupCall",
                    IS_MEETUP_CALL: "IsMeetupCall",
                    IS_ON_BEHALF_OF_CALL: "IsOnBehalfOfCall",
                    IS_SDP_IN_CALL_NOTIFICATION: "SdpInCallNotification",
                    CALL_END_CODE: "Code",
                    CALL_END_SUB_CODE: "SubCode",
                    CALL_PHRASE: "Phrase",
                    CALL_END_RESULT_CATEGORIES: "ResultCategories",
                    CALL_END_CAUSE_ID: "CauseId",
                    CONTENT_SHARING_END_CODE: "ContentSharingEndReasonServiceCode",
                    CONTENT_SHARING_END_SUB_CODE: "ContentSharingEndReasonServiceSubCode",
                    CONVERSATION_SERVICE_URL: "ConversationServiceUrl",
                    CONTENT_SHARING_SERVICE_URL: "ContentSharingServiceUrl",
                    MEETING_INFO: "MeetingInfo",
                    JOINED_FROM: "JoinedFrom",
                    RESULT_VALUE: "ResultValue",
                    RESULT_DETAIL: "ResultDetail",
                    RESULT_CAUSE_ID: "ResultCauseId",
                    RESULT_CODE: "ResultCode",
                    LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS: "LocalOfferAnswerGenerationTimestamps",
                    SELF_PARTICIPANT_ROLE: "SelfParticipantRole",
                    SCENARIO: "Scenario",
                    CALLER_TYPE: "Caller_Type",
                    CALLEE_TYPE: "Callee_Type",
                    CALL_TYPE: "Call_Type",
                    TEST_CONTEXT_ID: "Test_Context_Id",
                    OUTGOING_MODALITIES: "Outgoing_Modalities",
                    INCOMING_MODALITIES: "Incoming_Modalities",
                    OFFERED_MODALITIES: "CallOfferredModalities",
                    ANSWERED_MODALITIES: "CallAnsweredModalities",
                    VBSS_OPERATIONS: "VBSS_Operations",
                    CHANGING_CORRELATION_ID_NEW_ID: "ChangingCorrelationId_NewId",
                    CHANGING_CORRELATION_ID_OLD_ID: "ChangingCorrelationId_OldId",
                    MESSAGING_CHANNEL: "MessagingChannel",
                    EVENT_TIMESTAMP_BAG: "EventTimestampBag",
                    ROSTER_UPDATES_BAG: "RosterUpdatesBag",
                    NETWORK_REQUESTS_BAG: "NetworkRequestBag",
                    CLIENT_INFORMATION: "ClientInformation",
                    ECS_ETAG: "EcsEtag",
                    APPLICATION_TYPE: "ApplicationType",
                    RING: "Ring",
                    TENANT_ID: "TenantId",
                    USER_HEX_CID: "UserHexCID",
                    ACS_RESOURCE_ID: "AcsResourceId",
                    REGION: "Region",
                    PARTITION: "Partition",
                    CALL_END_CLIENT_SUB_CODE: "CallEventCallEndClientSubCode",
                    CALL_END_CLIENT_PHRASE: "CallEventCallEndClientPhrase",
                    MEETING_CODE: "MeetingCode",
                    MEETING_URL: "MeetingJoinUrl",
                    BROADCAST_MEETING_ROLE: "BroadcastMeetingRole",
                    MEETING_ROLE: "MeetingRole",
                    ADVANCED_MEETING_ROLE: "AdvancedMeetingRole",
                    MEETING_ROLES: "MeetingRoles",
                    PARTICIPANT_TYPE: "ParticipantType",
                    AUDIO_ONLY_WATERMARK: "ClientSupportsAudioOnlyWatermark",
                    CLIENT_SUPPORT_WATERMARK: "ClientSupportsWatermark",
                    TARGET_APPLICATION_TYPE: "TargetApplicationType",
                    IS_REINVITELESS: "IsReinviteless",
                    CLIENT_TYPE: "ClientType",
                    CLIENT_SUPPORTS_PREVENT_SCREEN_CAPTURE: "ClientSupportsPreventScreenCapture"
                },
                MESSAGING_CHANNEL: {
                    TROUTER: "Trouter",
                    BROKER: "Broker"
                },
                SIGNALING_CONFIG: "JsCsaConfig",
                SIGNALING_CONFIG_FLAGS: {
                    BROKER_OUTGOING_ENABLED: "BrokerOutgoingEnabled",
                    BROKER_INCOMING_ENABLED: "BrokerIncomingEnabled",
                    BROKER_REQUEST_BATCHING_ENABLED: "BrokerRequestBatchingEnabled",
                    BROKER_EXCLUSIVELY_ENABLED: "BrokerExclusivelyEnabled",
                    SUPPORTS_COMPRESSED_PAYLOAD: "SupportsCompressedPayload",
                    SYNC_TROUTER_RESPONSE: "SyncTrouterResponse",
                    SERVER_MUTE_UNMUTE: "serverMuteUnmute",
                    HANDLE_OFFER_FROM_NOTIFICATION: "handleMediaOfferFromPushNotification",
                    HANDLE_NEW_OFFER_REQUEST: "handleNewOfferRequest",
                    SEND_PROGRESS_FROM_CC: "sendProgressFromCC",
                    INTERNAL_HTTP_DISPATCHER: "internalHttpDispatcher",
                    ENABLE_TOKEN_CACHE: "enableTokenCache",
                    ENABLE_TOKEN_PREFETCH: "enableTokenPrefetch",
                    REQUEST_HEDGING: "requestHedging",
                    SUPPORT_MEDIA_RETARGET_WHILE_INCOMING_RENEGOTIATION: "supportMediaRetargetWhileIncomingRenegotiation",
                    ENABLE_ERROR_CODE_IMPROVEMENTS_FOR_NETWORK_FAILURES: "enableErrorCodeImprovementsForNetworkFailures",
                    ENABLE_CALL_ESTABLISHMENT_TIMEOUTS_FOR_START_OR_JOIN_CALL: "enableCallEstablishmentTimeoutsForStartJoinCall",
                    ENABLE_TOKEN_CACHE_FOR_GENERIC_TOKEN_API: "enableTokenCacheForGenericTokenAPI",
                    ENABLE_LONG_OUTGOING_1TO1_SETUP: "enableLongOutgoing1To1SetupTimeoutForWeb"
                },
                CONTEXT_ID: {
                    CORRELATION_ID: "CorrelationId",
                    SHARED_CORRELATION_ID: "SharedCorrelationId",
                    SIGNALING_SESSION_ID: "SignalingSessionId",
                    GROUP_ID: "GroupId",
                    THREAD_ID: "ThreadId",
                    TEAMS_MESSAGEID: "TeamsMessageId",
                    TEAMS_MEETINGINFO: "TeamsMeetingInfo",
                    ENDPOINT_ID: "EndpointId",
                    PARTICIPANT_ID: "ParticipantId",
                    DATA_VERSION: "DataVersion",
                    CONTENT_SHARING_ID: "ContentSharingSessionId",
                    CONTENT_SHARING_CORRELATION_ID: "ContentSharingCorrelationId"
                },
                CALL_TERMINATING_END: {
                    LOCAL: "Local",
                    REMOTE: "Remote"
                },
                RESULT_VALUE: {
                    SUCCESS: "Success",
                    FAILURE: "Failure"
                },
                DIRECTION: {
                    INCOMING: "Incoming",
                    OUTGOING: "Outgoing"
                },
                ROLE: {
                    CALLER: "caller",
                    CALLEE: "callee",
                    JOIN: "join",
                    JOIN_FOR_ROSTER_ONLY: "joinForRosterOnly",
                    PREHEAT: "preheat"
                },
                VBSS_OPERATION: {
                    START: "Start",
                    STOP: "Stop",
                    REJECTED: "Rejected",
                    REMOTE_START: "RemoteStart",
                    TIMEOUT: "Timeout",
                    CALL_END: "CallEnd"
                },
                LOCAL_OFFER_ANSWER_OPERATIONS: {
                    INITIAL_OFFER_GENERATION_STARTED: "InitialOfferGenerationStarted",
                    INITIAL_OFFER_GENERATION_ENDED: "InitialOfferGenerationEnded",
                    FINAL_ANSWER_PROCESSING_STARTED: "FinalAnswerProcessingStarted",
                    FINAL_ANSWER_PROCESSING_ENDED: "FinalAnswerProcessingEnded",
                    PROVISIONAL_ANSWER_PROCESSING_STARTED: "ProvisonalAnswerProcessingStarted",
                    PROVISIONAL_ANSWER_PROCESSING_ENDED: "ProvisonalAnswerProcessingEnded",
                    NEGOTIATION_COMPLETED: "NegotiationCompleted",
                    INITIAL_OFFER_PROCESSING_STARTED: "InitialOfferProcessingStarted",
                    INITIAL_OFFER_PROCESSING_ENDED: "InitialOfferProcessingEnded",
                    FINAL_ANSWER_GENERATION_STARTED: "FinalAnswerGenerationStarted",
                    FINAL_ANSWER_GENERATION_ENDED: "FinalAnswerGenerationEnded",
                    PROVISIONAL_ANSWER_GENERATION_STARTED: "ProvisionalAnswerGenerationStarted",
                    PROVISIONAL_ANSWER_GENERATION_ENDED: "ProvisionalAnswerGenerationEnded",
                    RENEGOTIATION_OFFER_GENERATION_STARTED: "RenegotiationOfferGenerationStarted",
                    RENEGOTIATION_OFFER_GENERATION_ENDED: "RenegotiationOfferGenerationEnded",
                    RENEGOTIATION_ANSWER_PROCESSING_STARTED: "RenegotiationAnswerProcessingStarted",
                    RENEGOTIATION_ANSWER_PROCESSING_ENDED: "RenegotiationAnswerProcessingEnded",
                    RENEGOTIATION_OFFER_PROCESSING_STARTED: "RenegotiationOfferProcessingStarted",
                    RENEGOTIATION_OFFER_PROCESSING_ENDED: "RenegotiationOfferProcessingEnded",
                    RENEGOTIATION_ANSWER_GENERATION_STARTED: "RenegotiationAnswerGenerationStarted",
                    RENEGOTIATION_ANSWER_GENERATION_ENDED: "RenegotiationAnswerGenerationEnded"
                },
                TROUTER_WAIT_OPERATION: {
                    STARTED: "Started",
                    ENDED: "Ended",
                    FAILED: "Failed"
                },
                TOKEN_TELEMETRY_EVENT: {
                    TOKEN_TELEMETRY: "TokenTelemetry"
                }
            };
            function setDefaultsForSignalingConfig(g) {
                const f = !0, S = "enabled", v = !1, _ = !1, C = !0, E = !0, T = !0, I = !1, b = !1, A = !0, R = !0, P = !0, w = !0, M = !0, O = !1, D = !1, N = !1, k = !1, L = !1, F = !0, x = !0, U = !0, V = 3, B = 4e3, H = !1, $ = !1, j = !1, G = !1, q = !1, W = !0, z = {
                    conversationKeepAliveTimeoutSec: 2700,
                    promotionUnmuteTimeoutSec: 1e4
                }, K = !1, J = !1, Y = !1, Q = !1, X = 3600, Z = 86400, ee = 30, te = !1, ie = !0, ne = !0, re = 60, ae = "https://calling.teams.microsoft.com", se = !0, oe = !1, le = !1, ce = !1, de = !1, ue = !1, he = !1, ge = 0, pe = 0, me = !1, fe = !1, Se = !1, ve = !1, _e = !0, Ce = !1, ye = !1;
                g.cloudScreenSharingFlag = "disabled" === g.cloudScreenSharingFlag ? g.cloudScreenSharingFlag : S, g.isWebRtcEnabled = "undefined" == typeof RTCIceGatherer, g.shouldServiceSendNGCUpgradeMessages = setDefault(g.shouldServiceSendNGCUpgradeMessages, C), g.isGVCOutgoingEnabled = setDefault(g.isGVCOutgoingEnabled, f), g.supportsCompressedServicePayload = setDefault(g.supportsCompressedServicePayload, E), g.supportsSynchronousTrouterResponse = setDefault(g.supportsSynchronousTrouterResponse, T), g.supportsHostlessGroupCalls = setDefault(g.supportsHostlessGroupCalls, A), g.doHostlessCalling = setDefault(g.doHostlessCalling, v), g.brokerExclusively = setDefault(g.brokerExclusively, O), g.brokerEnabledOutgoing = setDefault(g.brokerEnabledOutgoing, P), g.brokerEnabledIncoming = setDefault(g.brokerEnabledIncoming, w), g.brokerRequestBatching = setDefault(g.brokerRequestBatching, M), g.handleMediaOfferFromPushNotification = setDefault(g.handleMediaOfferFromPushNotification, F), g.handleNewOfferRequest = setDefault(g.handleNewOfferRequest, D), g.autoJoinOnConflict = setDefault(g.autoJoinOnConflict, R), g.endConflictedCall = setDefault(g.endConflictedCall, I), g.autoResolveConflictedCall = setDefault(g.autoResolveConflictedCall, b), g.shouldServiceSendCallEventMessages = setDefault(g.shouldServiceSendCallEventMessages, _), g.forceTrouterReconnectOnNetworkOnline = setDefault(g.forceTrouterReconnectOnNetworkOnline, x), g.attemptHttpRequestWithCachedSkypetoken = setDefault(g.attemptHttpRequestWithCachedSkypetoken, U), g.useInternalHttpDispatcher = setDefault(g.useInternalHttpDispatcher, N), g.enableTokenCache = setDefault(g.enableTokenCache, k), g.enableTokenPrefetch = setDefault(g.enableTokenPrefetch, L), g.hedgeDelayMs = setDefault(g.hedgeDelayMs, B), g.hedgeMaxParallelAttempts = setDefault(g.hedgeMaxParallelAttempts, V), g.useInternalHttpDispatcher && (g.httpRequestDispatcher = new He(g.logger)), g.enableQuickSendAcceptanceAck = setDefault(g.enableQuickSendAcceptanceAck, H), g.supportMediaRetargetWhileIncomingRenegotiation = setDefault(g.supportMediaRetargetWhileIncomingRenegotiation, $), g.callingServiceSupportsAADTokens = setDefault(g.callingServiceSupportsAADTokens, K), g.callingServiceSupportsCAETokens = setDefault(g.callingServiceSupportsCAETokens, J), g.aadTokenExpirationTimeInSeconds = setDefault(g.aadTokenExpirationTimeInSeconds, X), g.caeTokenExpirationTimeInSeconds = setDefault(g.caeTokenExpirationTimeInSeconds, Z), g.disableTokenMigrationHeader = setDefault(g.disableTokenMigrationHeader, Y), g.enablePublishTokenTelemetry = setDefault(g.enablePublishTokenTelemetry, Q), g.forceClearExpiredTokens = setDefault(g.forceClearExpiredTokens, te), g.enableRefreshToken = setDefault(g.enableRefreshToken, ie), g.refreshTimeBeforeTokenTimeoutInSeconds = setDefault(g.refreshTimeBeforeTokenTimeoutInSeconds, ee), g.enableCallEstablishmentTimeoutsForStartJoinCall = setDefault(g.enableCallEstablishmentTimeoutsForStartJoinCall, j), g.csaTimeoutConfiguration = mergeObjects(g.csaTimeoutConfiguration, z), g.reportPreviousErrorsForTimeout = setDefault(g.reportPreviousErrorsForTimeout, ce), g.callingTokenLogicalUrl = setDefault(g.callingTokenLogicalUrl, ae), g.enableAsyncDisablePreheat = setDefault(g.enableAsyncDisablePreheat, de), g.forceLowercaseHttpHeaders = setDefault(g.forceLowercaseHttpHeaders, ue), g.enableResolveScreenSharingWhenNegotiationComplete = setDefault(g.enableResolveScreenSharingWhenNegotiationComplete, he), g.maxReinvitelessMediaForVideoForWeb = setDefault(g.maxReinvitelessMediaForVideoForWeb, ge), g.maxReinvitelessMediaForVBSSForWeb = setDefault(g.maxReinvitelessMediaForVBSSForWeb, pe), g.enableRefreshTokenRetry = setDefault(g.enableRefreshTokenRetry, ne), g.enableRefreshTokenRetryInSeconds = setDefault(g.enableRefreshTokenRetryInSeconds, re), g.enableConversationTypeUpdateOnCallEnd = setDefault(g.enableConversationTypeUpdateOnCallEnd, q), g.supportMissingTokenTypesInResponse = setDefault(g.supportMissingTokenTypesInResponse, se), g.useSkypeTokenWhenNoAuthenticateHeader = setDefault(g.useSkypeTokenWhenNoAuthenticateHeader, oe), g.enableAutoPromotion = setDefault(g.enableAutoPromotion, me), g.enableBatchedSendMessageStatus = setDefault(g.enableBatchedSendMessageStatus, Se), g.enableBatchedReceiveMessage = setDefault(g.enableBatchedReceiveMessage, fe), g.enableAddParticipantEnhancements = setDefault(g.enableAddParticipantEnhancements, ve), g.enableTokenCacheForGenericTokenAPI = setDefault(g.enableTokenCacheForGenericTokenAPI, le), g.disableRealTimeModeFromRoster = setDefault(g.disableRealTimeModeFromRoster, _e), g.enableLongOutgoing1To1SetupTimeoutForWeb = setDefault(g.enableLongOutgoing1To1SetupTimeoutForWeb, G), g.checkAttendeeRoleInCreateContentSharing = setDefault(g.checkAttendeeRoleInCreateContentSharing, W), g.enableSpecificErrorCodesForCallEnd = setDefault(g.enableSpecificErrorCodesForCallEnd, Ce), g.enableSplitConversationEndUrl = setDefault(g.enableSplitConversationEndUrl, ye);
            }
            function setDefault(g, f) {
                return null == g ? f : g;
            }
            function mergeObjects(g, f) {
                return (f || g) && {
                    ...f,
                    ...g
                };
            }
            var hn = class {
                getTokenContext(g) {
                    return 4 === g ? this.aadTokenContext : 8 === g ? this.caeTokenContext : 1 === g ? this.skypeTokenContext : void 0;
                }
                getTokenExpiry(g, f) {
                    var _this_aadTokenContext, _this_caeTokenContext, _this_skypeTokenContext;
                    return 4 === g ? (_this_aadTokenContext = this.aadTokenContext) === null || _this_aadTokenContext === void 0 ? void 0 : _this_aadTokenContext.expiryTime : 8 === g ? (_this_caeTokenContext = this.caeTokenContext) === null || _this_caeTokenContext === void 0 ? void 0 : _this_caeTokenContext.expiryTime : 1 === g ? (_this_skypeTokenContext = this.skypeTokenContext) === null || _this_skypeTokenContext === void 0 ? void 0 : _this_skypeTokenContext.expiryTime : (f === null || f === void 0 ? void 0 : f.info("[getTokenExpiry] unrecognized token type, return Number.MAX_VALUE"), Number.MAX_VALUE);
                }
                getToken(g, f, S, v) {
                    var _this_caeTokenContext, _this_aadTokenContext, _this_skypeTokenContext;
                    return 8 & g && ((_this_caeTokenContext = this.caeTokenContext) === null || _this_caeTokenContext === void 0 ? void 0 : _this_caeTokenContext.token) && this.caeTokenContext.token !== v ? {
                        token: this.caeTokenContext.token,
                        tokenType: 8
                    } : 4 & g && ((_this_aadTokenContext = this.aadTokenContext) === null || _this_aadTokenContext === void 0 ? void 0 : _this_aadTokenContext.token) && this.aadTokenContext.token !== v ? {
                        token: this.aadTokenContext.token,
                        tokenType: 4
                    } : 1 & g && ((_this_skypeTokenContext = this.skypeTokenContext) === null || _this_skypeTokenContext === void 0 ? void 0 : _this_skypeTokenContext.token) && this.skypeTokenContext.token !== v ? {
                        token: this.skypeTokenContext.token,
                        tokenType: 1
                    } : (S === null || S === void 0 ? void 0 : S.info(`[getToken] no cached token found of token type: ${g}`), null);
                }
                setToken(g, f, S, v) {
                    switch(g){
                        case 4:
                            this.aadTokenContext.factorsJson = S, this.aadTokenContext.tokenType = g, this.aadTokenContext.token = f, this.aadTokenContext.expiryTime = v;
                            break;
                        case 1:
                            this.skypeTokenContext.factorsJson = S, this.skypeTokenContext.tokenType = g, this.skypeTokenContext.token = f, this.skypeTokenContext.expiryTime = v;
                            break;
                        case 8:
                            this.caeTokenContext.factorsJson = S, this.caeTokenContext.tokenType = g, this.caeTokenContext.token = f, this.caeTokenContext.expiryTime = v;
                            break;
                        default:
                            throw new Error(`Invalid tokenType ${g}`);
                    }
                }
                clearExpiredTokens(g) {
                    var _this_caeTokenContext, _this_aadTokenContext, _this_skypeTokenContext;
                    const f = Math.round(Date.now() / 1e3);
                    ((_this_caeTokenContext = this.caeTokenContext) === null || _this_caeTokenContext === void 0 ? void 0 : _this_caeTokenContext.expiryTime) <= f && (this.resetToken(8), g === null || g === void 0 ? void 0 : g.info("[cacheTokenManager] reset expired cae token")), ((_this_aadTokenContext = this.aadTokenContext) === null || _this_aadTokenContext === void 0 ? void 0 : _this_aadTokenContext.expiryTime) <= f && (this.resetToken(4), g === null || g === void 0 ? void 0 : g.info("[cacheTokenManager] reset expired aad token")), ((_this_skypeTokenContext = this.skypeTokenContext) === null || _this_skypeTokenContext === void 0 ? void 0 : _this_skypeTokenContext.expiryTime) <= f && (this.resetToken(1), g === null || g === void 0 ? void 0 : g.info("[cacheTokenManager] reset expired skype token"));
                }
                resetToken(g) {
                    8 === g ? this.caeTokenContext = {} : 4 === g ? this.aadTokenContext = {} : 1 === g && (this.skypeTokenContext = {});
                }
                constructor(){
                    this.skypeTokenContext = {}, this.aadTokenContext = {}, this.caeTokenContext = {};
                }
            }, gn = class {
                constructor(g){
                    this.timers = {}, this.startTimer = (g, f, S, v)=>{
                        this.logger.info(`startTimer called for :  ${g} with timeoutInSeconds : ${S}s`);
                        const _ = window.setTimeout(f, 1e3 * S), C = v ? `${g}${v}` : g;
                        this.timers[C] = _;
                    }, this.stopTimer = (g, f)=>{
                        this.logger.info(`stopTimer called for : ${g}`);
                        const S = f ? `${g}${f}` : g;
                        this.timers.hasOwnProperty(S) && (clearTimeout(this.timers[S]), delete this.timers[S]);
                    }, this.dispose = ()=>{
                        this.logger.info("timeoutManager :: dispose"), Object.keys(this.timers).forEach((g)=>{
                            this.stopTimer(g);
                        });
                    }, this.logger = g;
                }
            }, pn = 3600, mn = class {
                deletePromisesByTriggeredByRefresh(g, f) {
                    if (this.tokensPromiseMap[g]) {
                        var _S_v;
                        const S = this.tokensPromiseMap[g];
                        for(let v = S.length - 1; v >= 0; v--)((_S_v = S[v]) === null || _S_v === void 0 ? void 0 : _S_v.tokenRequestOptions.triggeredByRefresh) === f && this.tokensPromiseMap[g].splice(v, 1);
                    }
                }
                startTokenRefreshTimer(g) {
                    const f = "startTokenRefreshTimer";
                    if (!this.enableRefreshToken) return void this.logger.info("[startTokenRefreshTimer] token refresh is disabled");
                    if (this.stopTimerFlag) return this.logger.info("[startTokenRefreshTimer] stopTimerFlag=true so cancel timer"), void this.cacheTimers.dispose();
                    this.logger.info(`[startTokenRefreshTimer] starting token refresh timer timeToStartInMilliseconds=${g}`);
                    const S = epochTimeInSecRoundedDown(), v = millieSecondsToSeconds(g), _ = S + v;
                    this.nextRefreshTimePointInSeconds === Number.MAX_VALUE || this.nextRefreshTimePointInSeconds < S || _ < this.nextRefreshTimePointInSeconds ? (this.logger.info("[startTokenRefreshTimer] cancelling current refresh timer to create new one with shorter time"), this.cacheTimers.stopTimer(f), this.nextRefreshTimePointInSeconds = _, this.logger.info(`[startTokenRefreshTimer] start new timer with timeout=${v} at time=${S}`), this.cacheTimers.startTimer(f, ()=>{
                        this.nextRefreshTimePointInSeconds = Number.MAX_VALUE, this.refreshToken();
                    }, v)) : this.logger.info("[startTokenRefreshTimer] no need to set a new refresh timer");
                }
                async refreshTokenWithContext(g) {
                    const f = {
                        triggeredByRefresh: !0
                    }, S = newGuid(), v = {
                        causeId: S
                    }, _ = Date.now();
                    let C, E, T, I = 2;
                    this.logger.info(`[${S}][refreshTokenWithContext] refreshing token tokenType=${g.tokenType} factorsJson=${g.factorsJson}`);
                    let b = null;
                    try {
                        const f = this.onTokenRequired({
                            factorsJson: g.factorsJson,
                            tokenType: g.tokenType,
                            requestMetadataJson: v,
                            invalidToken: void 0,
                            isUnauthorized: void 0,
                            triggeredByRefresh: !0
                        }), _ = await this.timeoutPromiseRace(f, this.enableRefreshTokenRetryInSeconds, "ActiveRefresh Token Timeout");
                        C = Date.now(), T = _ === null || _ === void 0 ? void 0 : _.causeId, b = _ === null || _ === void 0 ? void 0 : _.tokenType, this.lastTokenType = b, this.lastToken = _.token, I = 1, this.logger.info(`[${S}][refreshTokenWithContext] refresh token success for factorsJson ${g.factorsJson} and tokenType ${g.tokenType}`);
                    } catch (f) {
                        E = f, T = E === null || E === void 0 ? void 0 : E.causeId, (f === null || f === void 0 ? void 0 : f.timeOut) ? (this.logger.info(`[${S}][refreshTokenWithContext] refresh token timeout, UI did not respond with token in time ${getPrintableObject(f)}`), I = 5) : (this.logger.info(`[${S}][refreshTokenWithContext] failed to refresh token, UI did not respond with token ${getPrintableObject(f)}`), I = 2), C = Date.now(), this.deletePromisesByTriggeredByRefresh(g.factorsJson, !0);
                    } finally{
                        f && (f.requestCauseId = S, f.responseCauseId = T, f.supportTokenApi = this.clientSupportsGenericTokenAPI, f.requestTokenFactors = g.factorsJson, f.tokenRequestTime = _, f.tokenResponseTime = C, f.tokenRequestStatus = I, f.requestTokenType = g.tokenType, f.foundInCache = !1, f.responseTokenType = b, f.errorCode = E === null || E === void 0 ? void 0 : E.errorCode, f.errorSubCode = E === null || E === void 0 ? void 0 : E.errorSubCode, this.sendTokenTelemetry(f));
                    }
                }
                refreshToken() {
                    if (!this.clientSupportsGenericTokenAPI) return void this.logger.info("[refreshToken] refresh token is not supported due to new Token Api is not enabled");
                    if (!this.enableTokenCacheForGenericTokenAPI) return void this.logger.info("[refreshToken] refresh token is not supported due to caching being disabled");
                    const g = this.cacheTokenManager.getTokenContext(4), f = this.cacheTokenManager.getTokenContext(8), S = this.cacheTokenManager.getTokenContext(1);
                    if (!g && !f && !S) return void this.logger.info("[refreshToken] no cached tokens available to refresh");
                    const v = epochTimeInSecRoundedDown() + this.refreshTimeBeforeTokenTimeoutInSeconds;
                    let _ = Number.MAX_VALUE, C = !1;
                    if (g) {
                        if (g.expiryTime > v) {
                            const f = (g === null || g === void 0 ? void 0 : g.expiryTime) - v;
                            f < _ && (_ = f);
                        } else g.expiryTime <= v && (this.refreshTokenWithContext(g), C = !0);
                    }
                    if (f) {
                        if (f.expiryTime > v) {
                            const g = (f === null || f === void 0 ? void 0 : f.expiryTime) - v;
                            g < _ && (_ = g);
                        } else f.expiryTime <= v && (this.refreshTokenWithContext(f), C = !0);
                    }
                    if (S) {
                        if (S.expiryTime > v) {
                            const g = (S === null || S === void 0 ? void 0 : S.expiryTime) - v;
                            g < _ && (_ = g);
                        } else S.expiryTime <= v && (this.refreshTokenWithContext(S), C = !0);
                    }
                    C && this.enableRefreshTokenRetry && this.enableRefreshTokenRetryInSeconds > 0 && this.enableRefreshTokenRetryInSeconds < _ && (_ = this.enableRefreshTokenRetryInSeconds), _ >= 0 && _ !== Number.MAX_VALUE && this.startTokenRefreshTimer(secondsToMillieSeconds(_));
                }
                async getTokenWithTokenType(g, f = !1, S, v) {
                    this.logger.info(`[${g}][getTokenWithTokenType] call with factorJson=${S === null || S === void 0 ? void 0 : S.factorsJson} and request tokenType ${S === null || S === void 0 ? void 0 : S.tokenType}`);
                    const { factorsJson: _, requestMetadataJson: C, invalidToken: E, isUnauthorized: T } = S || {}, I = Date.now(), b = S === null || S === void 0 ? void 0 : S.tokenType;
                    let A, R, P, w = 2, M = null;
                    this.clearExpiredTokens(), this.startTokenRefreshTimer(1);
                    try {
                        if (f) this.invalidateCachedTokenWithTokenType(b, E, _);
                        else if (this.enableTokenCacheForGenericTokenAPI) {
                            const f = this.cacheTokenManager.getToken(b, _, this.logger, E);
                            if (f === null || f === void 0 ? void 0 : f.token) return this.logger.info(`[${g}][getTokenWithTokenType] returning cached token for factorsJson ${_} and request tokenType ${b}, response tokenType ${f.tokenType}`), w = 3, A = Date.now(), M = f.tokenType, this.lastToken = f.token, this.lastTokenType = M, f;
                        }
                        this.logger.info(`[${g}][getTokenWithTokenType] fetching new token for factorsJson ${_} and tokenType ${b}`);
                        const S = C || {};
                        S.causeId = g;
                        const v = this.onTokenRequired({
                            factorsJson: _,
                            tokenType: b,
                            requestMetadataJson: S,
                            invalidToken: E,
                            isUnauthorized: T,
                            triggeredByRefresh: !1
                        }), I = await this.timeoutPromiseRace(v, an.TIMEOUT_VALUES_IN_SECONDS.TOKEN_REQUIRED_TIMEOUT, "Token not received from UI in time");
                        return A = Date.now(), P = I === null || I === void 0 ? void 0 : I.causeId, M = I === null || I === void 0 ? void 0 : I.tokenType, this.lastToken = I === null || I === void 0 ? void 0 : I.token, this.lastTokenType = M, w = 1, this.logger.info(`[${g}][getTokenWithTokenType] fetching new token success for factorsJson ${_} and tokenType ${b}`), I;
                    } catch (f) {
                        throw this.logger.info(`[${g}][getTokenWithTokenType] failed to fetch token ${getPrintableObject(f)}`), R = f, P = R === null || R === void 0 ? void 0 : R.causeId, R.timeOut && (w = 4), this.deletePromisesByTriggeredByRefresh(_, !1), f;
                    } finally{
                        var _this_logger;
                        const f = !(v === null || v === void 0 ? void 0 : v.tokenTelemetryData), _ = f ? {} : v === null || v === void 0 ? void 0 : v.tokenTelemetryData;
                        _ && (_.requestCauseId = g, _.responseCauseId = P, _.supportTokenApi = this.clientSupportsGenericTokenAPI, _.requestTokenFactors = S === null || S === void 0 ? void 0 : S.factorsJson, _.tokenRequestTime = I, _.tokenResponseTime = A, _.tokenRequestStatus = w, _.requestTokenType = S === null || S === void 0 ? void 0 : S.tokenType, _.foundInCache = 3 === w, _.responseTokenType = M, _.timeToResponse = A ? A - I : A, _.errorCode = R === null || R === void 0 ? void 0 : R.errorCode, _.errorSubCode = R === null || R === void 0 ? void 0 : R.errorSubCode), (!v || f && !v.signalingSession) && ((_this_logger = this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.info("[getTokenWithTokenType] TokenContext is not provided, sending token telemetry to Token table"), this.sendTokenTelemetry(_));
                    }
                }
                async onTokenRequired(g) {
                    const { factorsJson: f, tokenType: S, requestMetadataJson: v, invalidToken: _, isUnauthorized: C, triggeredByRefresh: E } = g;
                    if (this.logger.info(`[onTokenRequired] factorsJson=${f} tokenType=${S}`), !S) return this.logger.info(`[onTokenRequired] factorsJson=${f} with no token type`), Promise.reject({
                        errorCode: an.HTTP_STATUS_CODES.UNAUTHORIZED,
                        errorSubCode: 0,
                        causeId: v === null || v === void 0 ? void 0 : v.causeId
                    });
                    if (this.tokensPromiseMap[f] && !E) {
                        for (const g of this.tokensPromiseMap[f])if (g.tokenRequestOptions.tokenType === S) return this.logger.info(`[onTokenRequired] factorsJson=${f} and tokenType ${S} has pending request`), g.defered.promise;
                    }
                    this.tokensPromiseMap[f] || (this.tokensPromiseMap[f] = []);
                    const T = new ct;
                    return this.tokensPromiseMap[f].push({
                        tokenRequestOptions: g,
                        defered: T
                    }), this.tokenCallback({
                        factorsJson: f,
                        tokenType: S,
                        requestMetadataJson: v,
                        invalidToken: _,
                        isUnauthorized: C
                    }), T.promise;
                }
                setTokenCaching(g, f) {
                    this.tokenCachingEnabled !== g && (this.logger.info(`[authTokenManager]setTokenCaching=${g}`), this.tokenCachingEnabled = g);
                }
                setTokenCachingForGenericTokenAPI(g, f) {
                    this.enableTokenCacheForGenericTokenAPI !== g && (this.logger.info(`[authTokenManager]setTokenCachingForGenericTokenAPI=${g}`), this.enableTokenCacheForGenericTokenAPI = g);
                }
                calculateTokenExpiry(g, f, S) {
                    const { factorsJson: v, tokenType: _ } = f;
                    let C = S - epochTimeInSecRoundedDown(), E = C, T = S;
                    if (C && C > 0 && C > this.refreshTimeBeforeTokenTimeoutInSeconds) {
                        switch(_){
                            case 4:
                                C > this.aadTokenExpirationTimeInSeconds && (C = this.aadTokenExpirationTimeInSeconds);
                                break;
                            case 8:
                                C > this.caeTokenExpirationTimeInSeconds && (C = this.caeTokenExpirationTimeInSeconds);
                                break;
                            default:
                                C > pn && (C = pn);
                        }
                        E = C - this.refreshTimeBeforeTokenTimeoutInSeconds, T = E + epochTimeInSecRoundedDown();
                    }
                    return this.logger.info(`[${g}][calculateTokenExpiry] calculate expiry to ${T} tokenType=${_} factorsJson=${v}`), T;
                }
                addToCache(g, f, S, v) {
                    this.clearExpiredTokens(), this.cacheTokenManager.setToken(g, f, S, v);
                }
                clearExpiredTokens() {
                    this.forceClearExpiredTokens && this.cacheTokenManager.clearExpiredTokens(this.logger);
                }
                async getToken(g, f = !1, S, v) {
                    if (this.clientSupportsGenericTokenAPI) {
                        this.logger.info(`[${g}][getToken] callingTokenAPI is enabled so using new API to fetch it`);
                        const { token: _ } = await this.getTokenWithTokenType(g, f, S, v);
                        return _;
                    }
                    const _ = Date.now();
                    let C, E, T = 2;
                    try {
                        if (f && this.invalidateCachedToken(g), this.cachedToken && this.tokenCachingEnabled) return this.logger.info(`[${g}][getToken] returning cached token`), T = 3, this.lastTokenType = 1, Promise.resolve(this.cachedToken);
                        this.logger.info(`[${g}][getToken] fetching new token`);
                        const S = await this.tokenProvider();
                        return C = Date.now(), S ? (this.tokenCachingEnabled && (this.cachedToken = S), T = 1, this.lastToken = S, this.lastTokenType = 1, this.logger.info(`[${g}][getToken] fetching new token success`), S) : (this.logger.info(`[${g}][getToken] received empty token`), Promise.reject("Received empty token"));
                    } catch (f) {
                        throw this.logger.info(`[${g}][getToken] failed to fetch token=${getPrintableObject(f)}`), E = f, this.cachedToken = "", f;
                    } finally{
                        const f = v === null || v === void 0 ? void 0 : v.tokenTelemetryData;
                        f && (f.requestCauseId = g, f.supportTokenApi = this.clientSupportsGenericTokenAPI, f.requestTokenFactors = S === null || S === void 0 ? void 0 : S.factorsJson, f.tokenRequestTime = _, f.tokenResponseTime = C, f.tokenRequestStatus = T, f.requestTokenType = S === null || S === void 0 ? void 0 : S.tokenType, f.foundInCache = 3 === T, f.responseTokenType = this.lastTokenType, f.timeToResponse = C ? C - _ : C, f.errorCode = E === null || E === void 0 ? void 0 : E.errorCode, f.errorSubCode = E === null || E === void 0 ? void 0 : E.errorSubCode);
                    }
                }
                invalidateCachedToken(g) {
                    this.cachedToken && (this.logger.info(`[${g}][invalidateCachedToken]`), this.cachedToken = "");
                }
                invalidateCachedTokenWithTokenType(g, f, S) {
                    var _this_cacheTokenManager_getToken, _this_cacheTokenManager_getToken1, _this_cacheTokenManager_getToken2;
                    8 === g && ((_this_cacheTokenManager_getToken = this.cacheTokenManager.getToken(8, S, this.logger)) === null || _this_cacheTokenManager_getToken === void 0 ? void 0 : _this_cacheTokenManager_getToken.token) === f && (this.cacheTimers.stopTimer(S, g.toString()), this.cacheTokenManager.resetToken(8)), 4 === g && ((_this_cacheTokenManager_getToken1 = this.cacheTokenManager.getToken(4, S, this.logger)) === null || _this_cacheTokenManager_getToken1 === void 0 ? void 0 : _this_cacheTokenManager_getToken1.token) === f && (this.cacheTimers.stopTimer(S, g.toString()), this.cacheTokenManager.resetToken(4)), 1 === g && ((_this_cacheTokenManager_getToken2 = this.cacheTokenManager.getToken(1, S, this.logger)) === null || _this_cacheTokenManager_getToken2 === void 0 ? void 0 : _this_cacheTokenManager_getToken2.token) === f && (this.cacheTimers.stopTimer(S, g.toString()), this.cacheTokenManager.resetToken(1));
                }
                getLastToken(g) {
                    return this.logger.info(`[${g}][getLastToken]`), this.lastToken;
                }
                async timeoutPromiseRace(g, f, S) {
                    let v;
                    const _ = new Promise((g, _)=>{
                        v = window.setTimeout(()=>{
                            _({
                                phrase: S,
                                timeOut: !0
                            });
                        }, secondsToMillieSeconds(f));
                    });
                    return Promise.race([
                        g.then((g)=>(clearTimeout(v), g)),
                        _
                    ]);
                }
                getLastTokenType(g) {
                    return this.logger.info(`[${g}][getLastTokenType] lastTokenType=${this.lastTokenType}`), this.lastTokenType;
                }
                updateTokenSettings(g) {
                    const { clientSupportsGenericTokenAPI: f, aadTokenExpirationTimeInSeconds: S, caeTokenExpirationTimeInSeconds: v, refreshTimeBeforeTokenTimeoutInSeconds: _, enablePublishTokenTelemetry: C, enableRefreshToken: E, forceClearExpiredTokens: T, enableRefreshTokenRetry: I, enableRefreshTokenRetryInSeconds: b } = g;
                    this.logger.info(`updateTokenSettings ${JSON.stringify(g)}`), this.clientSupportsGenericTokenAPI = f !== null && f !== void 0 ? f : this.clientSupportsGenericTokenAPI, this.aadTokenExpirationTimeInSeconds = S !== null && S !== void 0 ? S : this.aadTokenExpirationTimeInSeconds, this.caeTokenExpirationTimeInSeconds = v !== null && v !== void 0 ? v : this.caeTokenExpirationTimeInSeconds, this.refreshTimeBeforeTokenTimeoutInSeconds = _ !== null && _ !== void 0 ? _ : this.refreshTimeBeforeTokenTimeoutInSeconds, this.enablePublishTokenTelemetry = C !== null && C !== void 0 ? C : this.enablePublishTokenTelemetry, this.forceClearExpiredTokens = T !== null && T !== void 0 ? T : this.forceClearExpiredTokens, this.enableRefreshToken = E !== null && E !== void 0 ? E : this.enableRefreshToken, this.enableRefreshTokenRetry = I !== null && I !== void 0 ? I : this.enableRefreshTokenRetry, this.enableRefreshTokenRetryInSeconds = b !== null && b !== void 0 ? b : this.enableRefreshTokenRetryInSeconds;
                }
                updateToken(g, f, S, v, _) {
                    if (this.logger.info(`[${v}][updateToken] UI replies with a token with factorsJson=${g} updateMetadata=${JSON.stringify(f)} tokenExpirySecSinceEpoch?=${_}`), f.error) {
                        var _f_error, _f_error1, _f_error2;
                        this.logger.info(`[${v}][updateToken] UI replies with error ${f.error} for factorsJson ${g}`);
                        for (const S of this.tokensPromiseMap[g])S.tokenRequestOptions.requestMetadataJson.causeId === v && S.defered.reject({
                            phrase: (_f_error = f.error) === null || _f_error === void 0 ? void 0 : _f_error.phrase,
                            errorCode: (_f_error1 = f.error) === null || _f_error1 === void 0 ? void 0 : _f_error1.code,
                            errorSubCode: (_f_error2 = f.error) === null || _f_error2 === void 0 ? void 0 : _f_error2.subCode,
                            causeId: v
                        });
                        return;
                    }
                    if (!S) {
                        this.logger.info(`[${v}][updateToken] received empty token`);
                        for (const f of this.tokensPromiseMap[g])f.tokenRequestOptions.requestMetadataJson.causeId === v && f.defered.reject({
                            phrase: "Received empty token",
                            causeId: v
                        });
                        return;
                    }
                    if (_ > epochTimeInSecRoundedDown() && this.enableTokenCacheForGenericTokenAPI) {
                        this.logger.info(`[${v}][updateToken] caching Token with tokenType=${f.tokenType}`);
                        const C = {
                            factorsJson: g,
                            tokenType: f.tokenType,
                            invalidToken: S
                        };
                        this.addToCache(f.tokenType, S, g, this.calculateTokenExpiry(v, C, _));
                    }
                    if (!this.tokensPromiseMap[g]) {
                        this.logger.warn(`[updateToken]: UI tries to update token with invalid factorsJson=${g}`);
                        const S = {
                            responseCauseId: v,
                            supportTokenApi: this.clientSupportsGenericTokenAPI,
                            requestTokenFactors: g,
                            tokenResponseTime: Date.now(),
                            tokenRequestStatus: 6,
                            responseTokenType: f.tokenType
                        };
                        return void this.sendTokenTelemetry(S);
                    }
                    if (this.tokensPromiseMap[g]) {
                        var __C;
                        const _ = this.tokensPromiseMap[g];
                        for(let C = _.length - 1; C >= 0; C--)(((__C = _[C]) === null || __C === void 0 ? void 0 : __C.tokenRequestOptions.tokenType) & f.tokenType) > 0 && (_[C].defered.resolve({
                            token: S,
                            tokenType: f.tokenType,
                            causeId: v
                        }), this.tokensPromiseMap[g].splice(C, 1));
                    }
                    if (this.logger.info(`[${v}][updateToken] resolved and upateToken with factorsJson=${g} tokenType=${f.tokenType}`), 0 === this.tokensPromiseMap[g].length && delete this.tokensPromiseMap[g], 4 !== f.tokenType && 8 !== f.tokenType && 1 !== f.tokenType) return;
                    if (Object.keys(this.tokensPromiseMap).length > 0) for (const _ of Object.values(this.tokensPromiseMap))for(let C = _.length - 1; C >= 0; C--){
                        const E = _[C];
                        E.tokenRequestOptions.factorsJson !== g && (E.tokenRequestOptions.tokenType & f.tokenType) > 0 && !E.tokenRequestOptions.isUnauthorized && (E.defered.resolve({
                            token: S,
                            tokenType: f.tokenType,
                            causeId: v
                        }), _.splice(C, 1));
                    }
                    for (const g of Object.keys(this.tokensPromiseMap))0 === this.tokensPromiseMap[g].length && delete this.tokensPromiseMap[g];
                    const C = _ - epochTimeInSecRoundedDown();
                    this.startTokenRefreshTimer(C >= 0 ? secondsToMillieSeconds(C) : 0);
                }
                setTokenRequiredCallBack(g) {
                    this.tokenCallback = g;
                }
                setDisableTimerFlag(g) {
                    this.logger.info(`[setDisableTimerFlag] set disableTimerFlag to ${g}`), this.stopTimerFlag = g;
                }
                sendTokenTelemetry(g) {
                    if (!this.enablePublishTokenTelemetry) return;
                    const f = {};
                    f[un.TOKEN_TELEMETRY_EVENT.TOKEN_TELEMETRY] = JSON.stringify(g), this.telemetryManager ? (this.logger.info("[sendTokenTelemetry] sending token telemetry:", f), this.telemetryManager.sendEvent(un.EVENT_TYPE.CONVERSATION_TOKEN, f)) : this.logger.warn("[sendTokenTelemetry] telemetryManager is undefined, cannot send token telemetry");
                }
                dispose() {
                    this.cacheTimers && this.cacheTimers.dispose();
                }
                constructor(g, f, S, v){
                    this.tokenProvider = f, this.tokenCachingEnabled = !1, this.enableTokenCacheForGenericTokenAPI = !1, this.cachedToken = "", this.lastTokenType = 1, this.lastToken = "", this.clientSupportsGenericTokenAPI = !1, this.stopTimerFlag = !1, this.tokensPromiseMap = {}, this.logger = g.createChild("TokenManager"), S && this.updateTokenSettings(S), this.cacheTimers = new gn(g), this.cacheTokenManager = new hn, this.telemetryManager = v, this.nextRefreshTimePointInSeconds = Number.MAX_VALUE;
                }
            }, fn = {
                build: (g, f, S, v)=>new mn(g, f, S, v)
            }, Sn = class {
                scrubParticipantsList(g) {
                    const f = [];
                    return Array.isArray(g) && g.forEach((g)=>f.push(this.scrubMriOrOmit(g))), f;
                }
                scrubMriOrOmit(g) {
                    return "string" == typeof g ? this.piiScrubber.mri(g) : this.piiScrubber.omit(g);
                }
                getPiiScrubber(g) {
                    return g && "function" == typeof g.omit && "function" == typeof g.mri ? g : {
                        omit: ()=>"<pii:omit/>",
                        mri: ()=>"<pii:mri/>"
                    };
                }
                constructor(g){
                    this.piiScrubber = this.getPiiScrubber(g);
                }
            }, vn = __toESM(P);
            function getMediaLabel(g) {
                switch(g){
                    case 0:
                        return "main-audio";
                    case 1:
                        return "main-video";
                    case 2:
                        return "applicationsharing-video";
                    case 3:
                        return "data";
                }
                throw new Error("Invalid media type");
            }
            function mapMediaTypeStringToMediaType(g) {
                switch(g){
                    case "audio":
                        return 0;
                    case "video":
                        return 1;
                    case "applicationsharing-video":
                        return 2;
                    case "data":
                        return 3;
                    default:
                        return;
                }
            }
            function hasParticipantLegId(g, f) {
                var _g_endpoints_endpointDetails, _g_endpoints;
                var _g_endpoints_endpointDetails_some;
                return (_g_endpoints_endpointDetails_some = (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.some((g)=>g.participantId === f)) !== null && _g_endpoints_endpointDetails_some !== void 0 ? _g_endpoints_endpointDetails_some : !1;
            }
            function findSelfEndpointDetailUsingParticipantLegId(g, f) {
                var _g_endpoints;
                return (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails.find((g)=>g.participantId === f);
            }
            function findParticipantUsingParticipantLegId(g, f) {
                return g.participants.find((g)=>hasParticipantLegId(g, f));
            }
            function hasStagingGroup(g) {
                var _g_meetingGroupDetails;
                return !!(g === null || g === void 0 ? void 0 : (_g_meetingGroupDetails = g.meetingGroupDetails) === null || _g_meetingGroupDetails === void 0 ? void 0 : _g_meetingGroupDetails.groups) && Object.keys(g.meetingGroupDetails.groups).some((g)=>"stagingGroup" === g);
            }
            function getSourceIdForMediaType(g, f) {
                let S = -1;
                try {
                    if (g.endpoints) e: for (const v of g.endpoints.endpointDetails)if (null !== v && void 0 !== v.mediaStreams) {
                        for (const g of v.mediaStreams)if (mapMediaTypeStringToMediaType(g.type) === f) {
                            S = g.sourceId;
                            break e;
                        }
                    } else S = bi;
                } catch (g) {
                    return -1;
                }
                return S;
            }
            function getSourceId(g, f, S) {
                if (!g || !g.endpoints) return -1;
                const v = g.endpoints.endpointDetails.find((g)=>(g === null || g === void 0 ? void 0 : g.participantId) === f);
                if (!v) return getSourceIdForMediaType(g, S);
                if (!v.mediaStreams) return getSourceIdForMediaType(g, S);
                const _ = v.mediaStreams.find(({ type: g })=>mapMediaTypeStringToMediaType(g) === S);
                return _ ? _.sourceId : -1;
            }
            function getParticipantIdForSourceId(g, f, S) {
                try {
                    if (!g.endpoints) return;
                    for (const v of g.endpoints.endpointDetails)if (v === null || v === void 0 ? void 0 : v.mediaStreams) {
                        var _v_participantId;
                        for (const g of v.mediaStreams)if (S === g.sourceId && mapMediaTypeStringToMediaType(g.type) === f) return (_v_participantId = v.participantId) !== null && _v_participantId !== void 0 ? _v_participantId : null;
                    }
                    return;
                } catch (g) {
                    return;
                }
            }
            function isScreenSharerStream(g) {
                return "sendonly" === g.direction && "applicationsharing-video" === g.label;
            }
            function getSharingParticipantLeg(g) {
                var _g_endpoints, _g_endpoints_endpointDetails_find;
                if ((_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails) return 1 === g.endpoints.endpointDetails.length ? g.endpoints.endpointDetails[0].participantId : (_g_endpoints_endpointDetails_find = g.endpoints.endpointDetails.find((g)=>{
                    var _g_mediaStreams;
                    return g === null || g === void 0 ? void 0 : (_g_mediaStreams = g.mediaStreams) === null || _g_mediaStreams === void 0 ? void 0 : _g_mediaStreams.some(isScreenSharerStream);
                })) === null || _g_endpoints_endpointDetails_find === void 0 ? void 0 : _g_endpoints_endpointDetails_find.participantId;
            }
            function processTransactionResponse(g) {
                let f = {};
                if (g.stateId) f.result = g.stateId;
                else if (g.results) {
                    const { results: S } = g;
                    1 === S.length && S[0].stateId && (f.result = S[0].stateId);
                    const v = {};
                    g.results.forEach((g)=>{
                        const { result: S } = g, _ = getParticipantId(g);
                        (void 0 === f.code || S.code > f.code) && (f.code = S.code, f.subCode = S.subCode), v[_] = g;
                    }), f.result = JSON.stringify(v);
                } else g.result && (f = {
                    code: g.result.code,
                    phrase: g.result.phrase,
                    subCode: g.result.subCode,
                    resultCategories: g.result.resultCategories
                }, g.additionalDetail && (f.result = g.additionalDetail));
                return f;
            }
            function getParticipantId(g) {
                return g.participantId || g.participant && g.participant.id;
            }
            var _n = class {
                handleBroadcastStateChanged(g) {
                    const f = g.body;
                    this.broadcastState = f;
                    const S = extractCauseIdFromMessage(g);
                    this.signalingSession.telemetryHelper.recordIncomingEvent(cn.BROADCAST_STATE_CHANGED, g), this.logger.info(`[${S}] broadcast state changed=${this.broadcastState}`), this.updateBroadcastMetadata(S);
                }
                updateBroadcastCallbackUrl(g) {
                    const f = get2(this.signalingSession, nn.CONV_BROADCAST_UPDATE);
                    this.broadcastCallbackUrl !== f && (this.broadcastCallbackUrl = f, this.logger.info(`[${g}] broadcast callback url changed=${this.broadcastCallbackUrl}`), this.updateBroadcastMetadata(g));
                }
                handleBroadcastDetailsChanged(g, f) {
                    this.signalingSession.telemetryHelper.recordEvent(cn.UPDATE_BROADCAST_DETAILS, {
                        causeId: f
                    }), g.activeModalities && g.activeModalities.broadcast && g.activeModalities.broadcast.controller !== this.broadcastControllerUrl && (this.broadcastControllerUrl = g.activeModalities.broadcast.controller, this.broadcastAdditionalData = g.activeModalities.broadcast, this.logger.info(`[${f}] broadcast controller changed=${this.broadcastControllerUrl}`), this.signalingSessionCallback.onBroadcastMeetingConnected(an.SUCCESS_TRANSACTION_END, f), this.updateBroadcastMetadata(f)), !this.broadcastControllerUrl || g.activeModalities && g.activeModalities.broadcast || (this.broadcastControllerUrl = "", this.broadcastContext = null, this.logger.info(`[${f}] broadcast controller changed=${this.broadcastControllerUrl}`), this.updateBroadcastMetadata(f), this.signalingSessionCallback.onBroadcastMeetingEnded(an.SUCCESS_TRANSACTION_END, f));
                }
                handleAddBroadcastModalitySuccess(g, f) {
                    this.logger.info(`[${f}][handleAddBroadcastModalitySuccess]`);
                }
                handleAddBroadcastModalityFailure(g, f) {
                    this.logger.info(`[${f}][handleAddBroadcastModalityFailure]`);
                    const S = {
                        ...g.modalityFailure.broadcast
                    };
                    this.signalingSessionCallback.onBroadcastMeetingEnded(S, f);
                }
                updateBroadcastMetadata(g) {
                    const f = {
                        broadcastControllerUrl: this.broadcastControllerUrl,
                        broadcastStateCallbackUrl: this.broadcastCallbackUrl,
                        broadcastState: this.broadcastState,
                        broadcastAdditionalData: this.broadcastAdditionalData
                    };
                    this.logger.info(`[${g}] update broadcast metadata=${f}`), this.signalingSessionCallback.onBroadcastMeetingUpdated && this.signalingSessionCallback.onBroadcastMeetingUpdated(f, g);
                }
                constructor(g, f){
                    this.broadcastContext = null, this.broadcastControllerUrl = "", this.broadcastCallbackUrl = "", this.broadcastState = null, this.setContext = (g = null)=>{
                        this.logger.info("BroadcastSession :: set broadcast context", g), this.broadcastContext = g;
                    }, this.getContext = ()=>(this.logger.info("BroadcastSession :: get broadcast context", this.broadcastContext || null), this.broadcastContext || null), this.signalingSession = g, this.signalingSessionCallback = f, this.logger = g.logger.createChild(()=>"[Broadcast]");
                }
            }, Cn = "http://broker.invalid/", yn = 30, En = 5, Tn = 1, In = class {
                subscribeToBroker(g) {
                    this._logger.info("subscribeToBroker called."), this._abortPendingRequest(), this._clearAllPendingTimeouts(), this._subscribeToBroker(g, this._currentSubscriptionTimeoutInSec);
                }
                onBrokerMessage(g) {
                    this._logger.info("onBrokerMessage callback added"), this._subscribers.push(g);
                }
                dispose() {
                    this._disposed = !0, this._logger.info("dispose"), this._subscribers = [], this._clearAllPendingTimeouts(), this._abortPendingRequest();
                }
                isNotNetworkErrors(g) {
                    return 490 !== g && 496 !== g && 498 !== g && 499 !== g;
                }
                constructor(g){
                    var _this__signalingSession_signalingAgentConfig_csaTimeoutConfiguration;
                    this._signalingSession = g, this.baseUrl = Cn, this.currentSubscriptionUrl = null, this._currentSubscriptionTimeoutInSec = yn, this._subscribers = [], this._disposed = !1, this._reportedResultCount = 0, this._subscriptionRetryBackoffInSec = En, this._notifySubscribers = (g)=>{
                        this._logger.info("_notifySubscribers"), Promise.resolve().then(()=>{
                            g.split(",").forEach((g)=>{
                                const f = parseRawHttpMessage(decodeMessage(g));
                                let S = f.body;
                                isEncodedMessage(f.headers) && isMessageEncodingSupported(f.headers) && (S = decodeMessage(S));
                                const v = {
                                    url: f.url,
                                    body: JSON.parse(S),
                                    headers: f.headers
                                };
                                this._logger.info("message length=", S.length, "n. of subscribers", this._subscribers.length), this._subscribers.forEach((g)=>g(v));
                            });
                        }).catch((g)=>{
                            this._logger.error("_notifySubscribers, failed to decode message", g), this._signalingSession.telemetryHelper.recordEvent(cn.BROKER_DECODE_PAYLOAD_FAILURE);
                        });
                    }, this._subscribeToBroker = (g, f)=>{
                        if (this._disposed) return void this._logger.warn("_subscribeToBroker, disposed, ignore subscription");
                        const S = causeId2();
                        this._logger.info("_subscribeToBroker, url: ", g, ",timeout in sec", f), this.currentSubscriptionUrl = g, this._currentSubscriptionTimeoutInSec = f, this._clearAllPendingTimeouts(), this._setSubscriptionTimeout(f), this._signalingSession.http.sendGetRequest({
                            url: this.currentSubscriptionUrl,
                            requestName: dn.BROKER_SUBSCRIBE.name,
                            customHeaders: this._getBrokerRequestHeaders(S),
                            payload: null,
                            skipHttpTelemetry: !this._reportSubscriptionInTelemetry(),
                            causeId: causeId2(),
                            operationType: "BrokerSubscribe"
                        }).then(this._handleSubscriptionSuccess).catch(this._handleSubscriptionFailure);
                    }, this._clearAllPendingTimeouts = ()=>{
                        this._cancelRequestTimer && (this._cancelRequestTimer.stop(), this._cancelRequestTimer = null), this._retryRequestTimer && (this._retryRequestTimer.stop(), this._retryRequestTimer = null);
                    }, this._abortPendingRequest = ()=>{
                        this._signalingSession.http.cancelRequestIfPending(dn.BROKER_SUBSCRIBE.name, causeId2());
                    }, this._setSubscriptionTimeout = (g)=>{
                        this._cancelRequestTimer = dt.build(()=>{
                            this._disposed || (this._signalingSession.http.hasPendingRequest(dn.BROKER_SUBSCRIBE.name) ? (this._logger.warn("timeout subscription"), this._signalingSession.telemetryHelper.recordEvent(cn.BROKER_SUBSCRIPTION_TIMEOUT), this._signalingSession.http.cancelRequestIfPending(dn.BROKER_SUBSCRIBE.name, causeId2())) : this._logger.error("Unable to resolve timeout deferred, it is not defined!"));
                        }, "TIMEOUT").start(1e3 * g);
                    }, this._handleSubscriptionSuccess = (g)=>{
                        if (this._disposed) this._logger.warn("_handleSubscriptionSuccess, disposed, ignore subscription success");
                        else if (this._reportSubscriptionInTelemetry(g) && this._signalingSession.telemetryHelper.recordEvent(cn.BROKER_SUBSCRIPTION_SUCCESSFUL), g === null || g === void 0 ? void 0 : g.response) {
                            const f = g.response;
                            this._logger.info("_handleSubscriptionSuccess, response", f), f.message && this._notifySubscribers(f.message);
                            const S = f.nextSubscribeUrl || this.currentSubscriptionUrl, v = f.expirationTimeInSec || this._currentSubscriptionTimeoutInSec;
                            this._subscribeToBroker(S, v);
                        } else this._logger.info("_handleSubscriptionSuccess, empty response");
                    }, this._handleSubscriptionFailure = (g)=>{
                        if (this._disposed) return void this._logger.warn("_handleSubscriptionFailure, disposed, ignore subscription");
                        if (g.status >= 400 && g.status < 500 && 401 !== g.status && this.isNotNetworkErrors(g.status)) return void this._logger.warn(`_handleSubscriptionFailure, received status ${g.status}, stop subscribing`);
                        const f = getPrintableObject(g);
                        this._logger.error("_handleSubscriptionFailure failed, re-subscribing", f), this._reportSubscriptionInTelemetry() && this._signalingSession.telemetryHelper.recordEvent(cn.BROKER_SUBSCRIPTION_FAILED), this._retryRequestTimer = dt.build(()=>{
                            this._subscribeToBroker(this.currentSubscriptionUrl, this._currentSubscriptionTimeoutInSec);
                        }, "RETRY").start(1e3 * this._subscriptionRetryBackoffInSec);
                    }, this._reportSubscriptionInTelemetry = (g)=>(this._reportedResultCount++, this._reportedResultCount <= Tn), this._getBrokerRequestHeaders = (g)=>{
                        const f = new on;
                        return f.set(an.HEADERS.CONTENT_TYPE, an.CONTENT_TYPE.JSON), this._signalingSession.signalingAgentConfig.brokerRequestBatching && f.set(an.HEADERS.BROKER_USE_BATCHING_HEADER_NAME, "1"), f;
                    }, this._logger = this._signalingSession.logger.createChild("Broker"), ((_this__signalingSession_signalingAgentConfig_csaTimeoutConfiguration = this._signalingSession.signalingAgentConfig.csaTimeoutConfiguration) === null || _this__signalingSession_signalingAgentConfig_csaTimeoutConfiguration === void 0 ? void 0 : _this__signalingSession_signalingAgentConfig_csaTimeoutConfiguration.brokerRetryBackOffInSec) && (this._subscriptionRetryBackoffInSec = this._signalingSession.signalingAgentConfig.csaTimeoutConfiguration.brokerRetryBackOffInSec);
                }
            }, bn = class {
                clear(g, f) {
                    const S = f || {
                        code: an.CALL_END_CODE.SUCCESS,
                        subCode: an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: an.CALL_END_PHRASE.LOCAL_USER_INITIATED
                    };
                    Object.keys(this.requests).forEach((f)=>{
                        try {
                            const v = parseInt(f, 10);
                            Object.keys(this.requests[v]).forEach((f)=>{
                                this.rejectOperation(v, f, g, S);
                            });
                        } catch (g) {
                            this.logger.warn(`CallOperations: clear error = ${g}`);
                        }
                    });
                }
                hasOperation(g, f) {
                    return this.requests.hasOwnProperty(g.valueOf()) && this.requests[g.valueOf()].hasOwnProperty(f);
                }
                getAllOperations() {
                    return this.requests;
                }
                getOperation(g, f) {
                    return this.hasOperation(g, f) ? this.requests[g.valueOf()][f] : null;
                }
                setOperation(g, f, S) {
                    return !this.hasOperation(g, f) && (this.hasOwnProperty(g.valueOf()) || (this.requests[g.valueOf()] = {}), this.requests[g.valueOf()][f] = S, !0);
                }
                rejectOperation(g, f, S, v) {
                    if (this.hasOperation(g, f)) {
                        const S = g.valueOf(), _ = this.requests[S][f].promise;
                        delete this.requests[S][f], _.reject(v);
                    }
                }
                resolveOperation(g, f, S, v) {
                    if (this.hasOperation(g, f)) {
                        const v = g.valueOf(), _ = this.requests[v][f].promise;
                        delete this.requests[v][f], _.resolve(S);
                    }
                }
                constructor(g){
                    this.requests = {}, this.logger = g;
                }
            }, An = class {
                dispose(g, f, S) {
                    this.logger.info(`[${S}][dispose]`), this.rejectAllPendingOperations(g, f);
                }
                hasPendingOperation(g, f, S) {
                    return this.logger.info(`[${S}][hasPendingOperation] ${g} ${scrubMriOrOmit(f)}}`), this.localRequests.hasOperation(g, f);
                }
                rejectPendingOperation(g, f, S, v, _) {
                    this.logger.info(`[${_}][rejectPendingOperation] ${g} ${f} reason: ${S} endCode: ${v}`), this.localRequests.rejectOperation(g, f, S, v);
                }
                resolvePendingOperation(g, f, S, v) {
                    this.logger.info(`[${v}][resolvePendingOperation]: ${scrubMriOrOmit(f)}`), this.localRequests.resolveOperation(g, f, S, v);
                }
                setPendingOperation(g, f, S, v) {
                    return this.logger.info(`[${v}][setPendingOperation] ${g} value: ${S}`), this.localRequests.setOperation(g, f, S);
                }
                rejectAllPendingOperations(g, f) {
                    this.logger.info("rejectLocalQueuedOperations"), this.localRequests.clear(g, f);
                }
                constructor(g){
                    this.logger = g, this.localRequests = new bn(g);
                }
            };
            function getPayload(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "content cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            to: []
                        },
                        contentSharing: {
                            identifier: f.contentIdentifier,
                            subject: f.subject,
                            sessionState: f.sessionState,
                            sequenceNumber: f.sequenceNumber,
                            links: {
                                sessionUpdate: get2(g, nn.CONV_CONTENT_SHARING_UPDATE),
                                sessionEnd: get2(g, nn.CONV_CONTENT_SHARING_END)
                            }
                        },
                        links: {
                            addModalitySuccess: get2(g, nn.CONV_ADD_MODALITY_SUCCESS),
                            addModalityFailure: get2(g, nn.CONV_ADD_MODALITY_FAILURE)
                        }
                    }
                };
            }
            function getPayload2(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        contentSharing: {
                            links: {
                                sessionUpdate: get2(g, nn.CONV_CONTENT_SHARING_UPDATE),
                                sessionEnd: get2(g, nn.CONV_CONTENT_SHARING_END)
                            }
                        },
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        }
                    }
                };
            }
            function getPayload3(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f), {
                    payload: {
                        contentSharingTransactionEnd: f,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        }
                    }
                };
            }
            function getPayload4(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        }
                    }
                };
            }
            function getPayload5(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        links: {
                            sessionUpdate: get2(g, nn.CONV_CONTENT_SHARING_UPDATE),
                            sessionEnd: get2(g, nn.CONV_CONTENT_SHARING_END)
                        }
                    }
                };
            }
            function getPayload6(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        }
                    }
                };
            }
            function getPayload7(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "sessionState cannot be null"), assertNotNull(S, "sequenceNumber cannot be null"), {
                    payload: {
                        sessionUpdateSequenceNumber: S,
                        sessionState: f,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        }
                    }
                };
            }
            var Rn = class {
                constructor(){
                    this.msElapsed = 0, this.isPaused = !1, this.startTime = (new Date).getTime(), this.pause = ()=>{
                        this.isPaused || (this.msElapsed += (new Date).getTime() - this.startTime, this.isPaused = !0);
                    }, this.resume = ()=>{
                        this.isPaused && (this.isPaused = !1, this.startTime = (new Date).getTime());
                    }, this.duration = ()=>this.isPaused ? this.msElapsed : this.msElapsed + (new Date).getTime() - this.startTime, this.durationInMinutes = ()=>{
                        const g = this.duration() / 6e4;
                        return Math.ceil(g);
                    }, this.durationInSeconds = ()=>{
                        const g = this.duration() / 1e3;
                        return Math.ceil(g);
                    };
                }
            };
            function build3() {
                return new Rn;
            }
            var Pn = class {
                start(g, f, S, v) {
                    if (this.logger.info(`[${v}][start]`), assertNotNullOrEmpty(g, "Correct addModality url is not provided"), !this.checkState("start", this.FSM_STATES.IDLE, this.addSessionPromise)) return Promise.reject(null);
                    this.addSessionPromise = S, this.confirmInRosterPromise = defer(), this.fsmState = this.FSM_STATES.CONTENT_SHARING_START_INITIATED, this.addTelemetryOperation(dn.ADD_CONTENT_SHARING_MODALITY.name, {
                        causeId: v
                    });
                    const _ = new on;
                    return _.set(an.HEADERS.CONTENT_SHARING_CORRELATION_ID, this.correlationId), this.signalingSession.http.sendPostRequest({
                        url: g,
                        payload: getPayload(this.signalingSession, f),
                        requestName: dn.ADD_CONTENT_SHARING_MODALITY.name,
                        customHeaders: _,
                        onceTrouterReady: ()=>{
                            this.startContentSharingTimer(v);
                        },
                        causeId: v
                    }).then(()=>{
                        this.disposed || (this.presenterMri = this.signalingSession.participantManager.localParticipant.id, this.isPresenter = !0);
                    }).catch((g)=>{
                        const f = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        return this.logger.info(`[${v}][start] error: ${getPrintableObject(f)}`), this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_MODALITY), this.rejectPendingPromise(getPrintableObject(g), f.error)), Promise.reject(null);
                    });
                }
                delete(g, f) {
                    this.logger.info(`[${f}][delete]`);
                    let S = !1;
                    if (this.fsmState === this.FSM_STATES.IDLE) return this.logger.info(`[${f}][delete] skipped because state is already ${this.fsmState}`), g.resolve(), Promise.resolve();
                    if (this.fsmState === this.FSM_STATES.CONTENT_SHARING_START_INITIATED) S = !0, this.rejectPendingPromise("Session delete called before start was finished");
                    else if (!this.checkState("delete", this.FSM_STATES.CONTENT_SHARING_CONNECTED, g)) return Promise.reject(null);
                    S || assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_CONTROLLER], "Correct controller url is not set"), this.removeSessionPromise = g, this.fsmState = this.FSM_STATES.CONTENT_SHARING_DELETE_INITIATED;
                    const v = build3(), _ = this.addTelemetryOperation(dn.DELETE_CONTENT_SHARING.name, {
                        causeId: f
                    });
                    return (S ? Promise.resolve(void 0) : this.signalingSession.http.sendDeleteRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_CONTROLLER],
                        requestName: dn.DELETE_CONTENT_SHARING.name,
                        payload: getPayload3(this.signalingSession, {
                            code: an.CALL_END_CODE.SUCCESS,
                            subCode: an.CALL_END_SUB_CODE.SUCCESS,
                            phrase: an.CALL_END_PHRASE.LOCAL_USER_INITIATED
                        }),
                        causeId: f
                    })).then(()=>{
                        if (!this.disposed) {
                            const g = {
                                success: !0,
                                duration: v.duration()
                            };
                            S && (g.skipReason = "Session delete called before start was finished"), this.updateTelemetryOperation(_, g), this.fsmState = this.FSM_STATES.IDLE, this.resolvePendingPromise();
                        }
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${f}][delete] error: ${getPrintableObject(S)}`), !this.disposed) {
                            const g = {
                                success: !1,
                                duration: v.duration()
                            };
                            this.updateTelemetryOperation(_, g), this.fsmState = this.FSM_STATES.IDLE, this.resolvePendingPromise();
                        }
                        return Promise.reject(null);
                    });
                }
                join(g, f) {
                    if (this.logger.info(`[${f}][join]`), assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_CONTROLLER], "Correct joinContentSharing url is not provided"), !this.checkState("join", this.FSM_STATES.IDLE, g)) return;
                    this.lastUpdateSequenceNumber = -1, this.nextClientSequenceNumberToUse = 1, this.addSessionPromise = g, this.fsmState = this.FSM_STATES.CONTENT_SHARING_JOIN_INITIATED;
                    const S = build3(), v = this.addTelemetryOperation(dn.JOIN_CONTENT_SHARING.name, {
                        causeId: f
                    });
                    this.signalingSession.http.sendPostRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_CONTROLLER],
                        payload: getPayload2(this.signalingSession),
                        requestName: dn.JOIN_CONTENT_SHARING.name,
                        causeId: f
                    }).then((g)=>{
                        if (!this.disposed) {
                            const f = {
                                success: !0,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, f), this.processStartOrJoinSuccess(g.response), this.resolvePendingPromise(g.response);
                        }
                    }).catch((g)=>{
                        const _ = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${f}][join] error: ${getPrintableObject(_)}`), !this.disposed) {
                            const f = {
                                success: !1,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, f);
                            const C = _.error;
                            this.rejectPendingPromise(getPrintableObject(g), C);
                        }
                    });
                }
                takeControl(g, f) {
                    if (this.logger.info(`[${f}][takeControl]`), assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_TAKE_CONTROL], "correct contentSharingTakeControl url is not provided"), !this.checkState("takeControl", this.FSM_STATES.CONTENT_SHARING_CONNECTED, g)) return;
                    const S = build3(), v = this.addTelemetryOperation(dn.TAKE_CONTROL_CONTENT_SHARING.name, {
                        causeId: f
                    });
                    this.signalingSession.http.sendPostRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_TAKE_CONTROL],
                        payload: getPayload4(this.signalingSession),
                        requestName: dn.TAKE_CONTROL_CONTENT_SHARING.name,
                        withoutTrouter: !0,
                        causeId: f
                    }).then((f)=>{
                        if (!this.disposed) {
                            const _ = {
                                success: !0,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, _);
                            const C = {
                                contentIdentifier: f.response.identifier,
                                presenter: f.response.presenter.id,
                                subject: f.response.subject || null,
                                sessionState: f.response.sessionState || null
                            };
                            g.resolve(C);
                        }
                    }).catch((_)=>{
                        const C = getErrorForXHRFailure(_, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${f}][takeControl] error: ${getPrintableObject(C)}`), !this.disposed) {
                            const f = {
                                success: !1,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, f);
                            const E = new Error(getPrintableObject(_));
                            E.endCode = C.error, g.reject(E);
                        }
                    });
                }
                updateSessionState(g, f, S) {
                    if (this.logger.info(`[${S}][updateSessionState]`), assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE], "Correct sendUpdateSessionState url is not provided"), !this.checkState("updateSessionState", this.FSM_STATES.CONTENT_SHARING_CONNECTED, f)) return;
                    const v = build3(), _ = this.addTelemetryOperation(dn.UPDATE_SESSION_STATE_CONTENT_SHARING.name, {
                        causeId: S
                    });
                    this.signalingSession.http.sendPostRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE],
                        payload: getPayload7(this.signalingSession, g, this.nextClientSequenceNumberToUse++),
                        requestName: dn.UPDATE_SESSION_STATE_CONTENT_SHARING.name,
                        causeId: S
                    }).then(()=>{
                        if (!this.disposed) {
                            const g = {
                                success: !0,
                                duration: v.duration()
                            };
                            this.updateTelemetryOperation(_, g), f.resolve();
                        }
                    }).catch((g)=>{
                        const C = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${S}][updateSessionState] error: ${getPrintableObject(C)}`), !this.disposed) {
                            const S = {
                                success: !1,
                                duration: v.duration()
                            };
                            this.updateTelemetryOperation(_, S);
                            const E = new Error(getPrintableObject(g));
                            E.endCode = C.error, f.reject(E);
                        }
                    });
                }
                updateParticipantState(g, f) {
                    if (this.logger.info(`[${f}][updateParticipantState]`), assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE], "correct confirmContentSharingView url is not provided"), !this.checkState("updateParticipantState", this.FSM_STATES.CONTENT_SHARING_CONNECTED, g)) return;
                    const S = build3(), v = this.addTelemetryOperation(dn.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING.name, {
                        causeId: f
                    });
                    this.signalingSession.http.sendPostRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE],
                        payload: getPayload6(this.signalingSession),
                        requestName: dn.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING.name,
                        withoutTrouter: !0,
                        causeId: f
                    }).then(()=>{
                        if (!this.disposed) {
                            const f = {
                                success: !0,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, f), g.resolve();
                        }
                    }).catch((_)=>{
                        const C = getErrorForXHRFailure(_, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${f}][updateParticipantState] error: ${getPrintableObject(C)}`), !this.disposed) {
                            const f = {
                                success: !1,
                                duration: S.duration()
                            };
                            this.updateTelemetryOperation(v, f);
                            const E = new Error(getPrintableObject(_));
                            E.endCode = C.error, g.reject(E);
                        }
                    });
                }
                updateNotificationLinks(g) {
                    if (this.logger.info(`[${g}][updateNotificationLinks]`), assertNotNullOrEmpty(this.links[an.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS], "correct notificationLinks url is not provided"), !this.checkState("updateState", this.FSM_STATES.CONTENT_SHARING_CONNECTED)) return;
                    const f = build3(), S = this.addTelemetryOperation(dn.UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS.name, {
                        causeId: g
                    });
                    this.signalingSession.http.sendPostRequest({
                        url: this.links[an.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS],
                        payload: getPayload5(this.signalingSession),
                        requestName: dn.UPDATE_CONTENT_SHARING_NOTIFICATION_LINKS.name,
                        withoutTrouter: !0,
                        causeId: g
                    }).then(()=>{
                        if (!this.disposed) {
                            const g = {
                                success: !0,
                                duration: f.duration()
                            };
                            this.updateTelemetryOperation(S, g);
                        }
                    }).catch((v)=>{
                        const _ = getErrorForXHRFailure(v, this.signalingSession.signalingAgentConfig);
                        if (this.logger.info(`[${g}][updateNotificationLinks] error: ${getPrintableObject(_)}`), !this.disposed) {
                            const g = {
                                success: !1,
                                duration: f.duration()
                            };
                            this.updateTelemetryOperation(S, g);
                        }
                    });
                }
                confirmInRoster() {
                    this.confirmInRosterPromise && this.confirmInRosterPromise.isPending && (this.logger.info("Confirmed in roster"), this.confirmInRosterPromise.resolve());
                }
                handleAddModalitySuccess(g, f) {
                    return this.logger.info(`[${f}][handleAddModalitySuccess]`), this.checkState("handleAddModalitySuccess", this.FSM_STATES.CONTENT_SHARING_START_INITIATED) ? g.modalitySuccess && g.modalitySuccess.contentSharing ? (this.addTelemetryOperation(cn.HANDLE_ADD_MODALITY_SUCCESS, {
                        causeId: f
                    }), this.processStartOrJoinSuccess(g.modalitySuccess.contentSharing), this.confirmInRosterPromise.promise.then(()=>{
                        delete this.confirmInRosterPromise, this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_MODALITY), this.resolvePendingPromise(g.modalitySuccess.contentSharing);
                    }), !0) : (this.addTelemetryOperation(cn.HANDLE_ADD_MODALITY_SUCCESS, {
                        causeId: f,
                        skipReason: "no content sharing blob"
                    }), this.logger.info(`[${f}][handleAddModalitySuccess] ignored because modalitySuccess was missing or did not contain content sharing blob`), !1) : (this.logger.info(`[${f}][handleAddModalitySuccess] ignored because session is not waiting to start`), !1);
                }
                handleAddModalityFailure(g, f) {
                    this.logger.info(`[${f}][handleAddModalityFailure]`);
                    if (!this.checkState("handleAddModalityFailure", [
                        this.FSM_STATES.CONTENT_SHARING_START_INITIATED,
                        this.FSM_STATES.CONTENT_SHARING_CONNECTED
                    ])) return !1;
                    if (!g.modalityFailure || !g.modalityFailure.contentSharing) return this.addTelemetryOperation(cn.HANDLE_ADD_MODALITY_FAILURE, {
                        causeId: f,
                        skipReason: "no content sharing blob"
                    }), !1;
                    const S = g.modalityFailure.contentSharing;
                    this.addTelemetryOperation(cn.HANDLE_ADD_MODALITY_FAILURE, {
                        reason: S,
                        causeId: f
                    });
                    const v = {
                        ...S
                    };
                    return this.sendTelemetryData(v), this.rejectPendingPromise(v.phrase, v), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_MODALITY), !0;
                }
                handleStartFromRoster(g, f) {
                    this.logger.info(`[${f}][handleStartFromRoster]`), this.addTelemetryOperation(cn.CONTENT_SHARING_START_FROM_ROSTER, {
                        causeId: f
                    });
                }
                handleStopFromRoster(g, f) {
                    this.logger.info(`[${f}][handleStopFromRoster]`), this.addTelemetryOperation(cn.CONTENT_SHARING_END_FROM_ROSTER, {
                        causeId: f
                    }), this.sendTelemetryData(g);
                }
                handleStop(g, f) {
                    if (this.logger.info(`[${f}][handleStop]`), this.isSelfInitiatedAction(g)) return this.logger.info(`[${f}][handleStop]handleStop skipped because session was ended by self`), !1;
                    const S = {
                        ...g.contentSharingTransactionEnd
                    };
                    return this.addTelemetryOperation(cn.HANDLE_CONTENT_SHARING_END, {
                        causeId: f
                    }), this.sendTelemetryData(S), !0;
                }
                handleUpdate(g, f) {
                    return this.logger.info(`[${f}][handleUpdate]`), g.sequenceNumber <= this.lastUpdateSequenceNumber ? (this.logger.info(`handleUpdate skipped because of old sequence number: last received ${this.lastUpdateSequenceNumber}, update contained ${g.sequenceNumber}`), this.addTelemetryOperation(cn.HANDLE_CONTENT_SHARING_UPDATE, {
                        causeId: f,
                        skipReason: "old sequence number"
                    }), !1) : (this.lastUpdateSequenceNumber = g.sequenceNumber, this.isPresenter = g.presenter.id === this.signalingSession.participantManager.localParticipant.id, this.addTelemetryOperation(cn.HANDLE_CONTENT_SHARING_UPDATE, {
                        causeId: f
                    }), !0);
                }
                dispose(g, f) {
                    this.logger.info(`[${f}][dispose]`), this.disposed = !0, this.rejectPendingPromise("call ended", g || {
                        code: an.CALL_END_CODE.SUCCESS,
                        subCode: an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: an.CALL_END_PHRASE.LOCAL_USER_INITIATED
                    }), this.addTelemetryOperation(cn.HANDLE_CALL_END, {
                        causeId: f
                    }), this.sendTelemetryData(g);
                }
                rejectPendingPromise(g, f) {
                    this.logger.info("rejectPendingPromise");
                    const S = new Error(g);
                    f && (S.endCode = f), this.removeSessionPromise && (this.removeSessionPromise.reject(S), this.removeSessionPromise = null), this.addSessionPromise && (this.addSessionPromise.reject(S), this.addSessionPromise = null);
                }
                resolvePendingPromise(g) {
                    this.logger.info("resolvePendingPromise");
                    let f = null;
                    g && (f = {
                        sessionId: g.sessionId,
                        correlationId: g.contentSharingCorrelationId,
                        contentIdentifier: g.identifier,
                        presenter: g.presenter.id,
                        subject: g.subject || null,
                        sessionState: g.sessionState || null
                    }), this.removeSessionPromise && (this.removeSessionPromise.resolve(f), this.removeSessionPromise = null), this.addSessionPromise && (this.addSessionPromise.resolve(f), this.addSessionPromise = null);
                }
                processStartOrJoinSuccess(g) {
                    this.logger.info("processStartOrJoinSuccess"), this.sessionId = g.sessionId, this.fsmState = this.FSM_STATES.CONTENT_SHARING_CONNECTED, this.lastUpdateSequenceNumber = -1, this.links[an.LINKS.CONTENT_SHARING_CONTROLLER] = g.links.contentSharingController, this.links[an.LINKS.CONTENT_SHARING_TAKE_CONTROL] = g.links.takeControl, this.links[an.LINKS.CONTENT_SHARING_UPDATE_SESSION_STATE] = g.links.updateSessionState, this.links[an.LINKS.CONTENT_SHARING_UPDATE_PARTICIPANT_STATE] = g.links.sync, this.links[an.LINKS.CONTENT_SHARING_NOTIFICATION_LINKS] = g.links.notificationLinks, this.links[an.LINKS.CONTENT_SHARING_LEAVE] = g.links.leave;
                }
                checkState(g, f, S) {
                    let v;
                    if (v = "string" == typeof f ? this.fsmState === f : f.indexOf(this.fsmState) > -1, v) return !0;
                    {
                        const v = `${g} requires state ${f}, but state is ${this.fsmState}`;
                        return this.logger.error(v), S && S.reject(v), !1;
                    }
                }
                isSelfInitiatedAction(g) {
                    return g.presenter.participantId === this.signalingSession.participantManager.localParticipant.participantId;
                }
                startContentSharingTimer(g) {
                    this.logger.info("startContentSharingTimer"), this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.ADD_MODALITY, ()=>{
                        this.addTelemetryOperation(cn.ADD_MODALITY_TIMEOUT, {
                            causeId: g
                        }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_MODALITY), this.rejectPendingPromise("timed out waiting for ContentSharing to start", {
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT
                        });
                    }, an.TIMEOUT_VALUES_IN_SECONDS.ADD_MODALITY_TIMEOUT);
                }
                addTelemetryOperation(g, f) {
                    return this.signalingSession.telemetryHelper.addContentSharingOperation(this.correlationId, g, f);
                }
                updateTelemetryOperation(g, f) {
                    this.signalingSession.telemetryHelper.updateContentSharingOperation(this.correlationId, g, f);
                }
                sendTelemetryData(g) {
                    this.signalingSession.telemetryHelper.sendContentSharingTelemetryData(this.correlationId, this.signalingSession.sessionId, this.isPresenter, g, this.links[an.LINKS.CONTENT_SHARING_CONTROLLER], this.sessionId);
                }
                constructor(g, f, S, v){
                    this.signalingSession = g, this.correlationId = f, this.sessionId = null, this.fsmState = an.CONTENT_SHARING_FSM_STATE.IDLE, this.addSessionPromise = null, this.removeSessionPromise = null, this.confirmInRosterPromise = null, this.links = {}, this.lastUpdateSequenceNumber = -1, this.nextClientSequenceNumberToUse = 1, this.disposed = !1, this.isPresenter = !1, this.FSM_STATES = an.CONTENT_SHARING_FSM_STATE, this.logger = g.logger.createChild(()=>`[${this.fsmState}][cs=${this.sessionId}][cc=${this.correlationId}]`), S && (this.sessionId = S), v && (this.links = v);
                }
            }, wn = class {
                startContentSharingAsync(g, f, S, v, _, C, E) {
                    if (this.logger.info(`startContentSharingAsync called for: ${g}`), this.pendingSessionToStart) {
                        const g = "There is already a ContentSharing session start pending";
                        return this.logger.error(g), Promise.reject(new Error(g));
                    }
                    const T = {
                        contentIdentifier: g,
                        subject: S || null,
                        sessionState: f || null,
                        sequenceNumber: 1
                    }, I = defer(), b = new Pn(this.signalingSession, E || newGuid());
                    return this.pendingSessionToStart = b, _ ? (this.logger.info("Call connected, send content sharing request out immediately"), b.start(v, T, I, C)) : (this.logger.info("Content sharing is to be started when startOutgoingCall is called"), b.addSessionPromise = I, b.fsmState = an.CONTENT_SHARING_FSM_STATE.CONTENT_SHARING_START_INITIATED, this.contentSharingToStartCallWith = T), I.promise.then(()=>{
                        this.contentSharingSessions.hasOwnProperty(b.correlationId) || (this.contentSharingSessions[b.correlationId] = b), this.pendingSessionToStart = null;
                    }).catch(()=>{
                        this.pendingSessionToStart = null;
                    }), I.promise;
                }
                joinContentSharingAsync(g, f) {
                    this.logger.info(`[${f}][joinContentSharingAsync]`);
                    const S = defer(), v = this.contentSharingSessions[g];
                    return v ? v.join(S, f) : this.rejectBecauseOfMissingSession(g, S), S.promise;
                }
                updateContentSharingSessionStateAsync(g, f, S) {
                    this.logger.info(`[${S}][updateContentSharingSessionStateAsync][sessionState=${JSON.stringify(f)}]`);
                    const v = defer(), _ = this.contentSharingSessions[g];
                    return _ ? _.updateSessionState(f, v, S) : this.rejectBecauseOfMissingSession(g, v), v.promise;
                }
                takeContentSharingControlAsync(g, f) {
                    this.logger.info(`[${f}][takeContentSharingControlAsync]`);
                    const S = defer(), v = this.contentSharingSessions[g];
                    return v ? v.takeControl(S, f) : this.rejectBecauseOfMissingSession(g, S), S.promise;
                }
                updateContentSharingParticipantStateAsync(g, f) {
                    this.logger.info(`[${f}][updateContentSharingParticipantStateAsync]`);
                    const S = defer(), v = this.contentSharingSessions[g];
                    return v ? v.updateParticipantState(S, f) : this.rejectBecauseOfMissingSession(g, S), S.promise;
                }
                updateContentSharingNotificationLinksAsync(g) {
                    this.logger.info(`[${g}][updateContentSharingNotificationLinksAsync]`);
                    for (const f of Object.keys(this.contentSharingSessions))if (this.contentSharingSessions.hasOwnProperty(f)) {
                        const S = this.contentSharingSessions[f];
                        S && S.updateNotificationLinks(g);
                    }
                }
                getContentSharingInfoToStartSharing() {
                    if (this.contentSharingToStartCallWith) {
                        const g = this.pendingSessionToStart, f = an.CONTENT_SHARING_FSM_STATE.CONTENT_SHARING_START_INITIATED;
                        g && g.fsmState === f || (this.contentSharingToStartCallWith = null, this.pendingSessionToStart = null);
                    }
                    return this.contentSharingToStartCallWith;
                }
                dispose(g, f) {
                    this.logger.info(`[${f}][dispose]`);
                    for (const S of Object.keys(this.contentSharingSessions))if (this.contentSharingSessions.hasOwnProperty(S)) {
                        const v = this.contentSharingSessions[S];
                        v && v.dispose(g, f);
                    }
                }
                handleContentSharingUpdate(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = this.contentSharingSessions[f.contentSharingCorrelationId];
                    v ? v.handleUpdate(f, S) && this.signalingSessionCallback.onContentSharingUpdated({
                        sessionId: f.sessionId,
                        correlationId: f.contentSharingCorrelationId,
                        contentIdentifier: f.identifier,
                        presenter: f.presenter.id,
                        subject: f.subject || null,
                        sessionState: f.sessionState || null
                    }, S) : this.logger.info(`[${S}][handleContentSharingUpdate][failed][reason=no session with correlation ID ${f.correlationId}]`);
                }
                handleAddModalitySuccess(g, f) {
                    this.logger.info(`[${f}][handleAddModalitySuccess]`);
                    const S = this.pendingSessionToStart;
                    S ? S.handleAddModalitySuccess(g, f) : this.logger.info(`[${f}][handleAddModalitySuccess]Ignoring handleAddModalitySuccess because not waiting for one`);
                }
                handleAddModalityFailure(g, f) {
                    this.logger.info(`[${f}][handleAddModalityFailure]`);
                    const S = this.pendingSessionToStart;
                    S ? S.handleAddModalityFailure(g, f) : this.logger.info(`[${f}][handleAddModalityFailure]Ignoring handleAddModalityFailure because not waiting for one`);
                }
                handleIncomingContentSharingFromRoster(g, f, S) {
                    if (this.logger.info(`[${S}] handleIncomingContentSharingFromRoster: isFullRoster ${f} content ${getPrintableObject(g)}`), ("MultiPartyEndpoint" === g.type || f) && this.lastProcessedSequenceNumber > g.sequenceNumber) return void this.logger.info(`[${S}] handleIncomingContentSharingFromRoster invalid roster current sequenceNumber ${g.sequenceNumber} lastProcessedSequenceNumber ${this.lastProcessedSequenceNumber}`);
                    const { sessionsWithPresenters: v, sessionsWithoutPresenters: _ } = this.parseContentSharingSessionsFromRoster(g);
                    this.startSessionsFromRoster(v, S), this.stopSessionsFromRoster(_, S), this.lastProcessedSequenceNumber = g.sequenceNumber;
                }
                handleContentSharingEnd(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info("handleContentSharingEnd : ", getPrintableObject(f));
                    const v = this.contentSharingSessions[f.contentSharingCorrelationId];
                    if (!v) return void this.logger.info("Ignoring contentSharingEnd since there is no corresponding sharing ongoing");
                    if (!v.handleStop(f, S)) return;
                    const _ = {
                        ...f.contentSharingTransactionEnd
                    };
                    this.raiseContentSharingStopped(f.contentSharingCorrelationId, S, f.presenter.id, _);
                }
                parseContentSharingSessionsFromRoster(g) {
                    const f = {}, S = {}, v = new Set;
                    for (const S of Object.keys(g.participants)){
                        const _ = g.participants[S];
                        if ("Delta" === g.type && this.lastProcessedSequenceNumberForParticipant.hasOwnProperty(S) && _.version <= this.lastProcessedSequenceNumberForParticipant[S]) continue;
                        if (_.version = _.version || -1, this.lastProcessedSequenceNumberForParticipant[S] = _.version, v.add(_.details.id), !_.endpoints) continue;
                        const C = this.signalingSession.participantManager.localParticipant.participantId;
                        for (const g of Object.keys(_.endpoints)){
                            var _S_contentSharing;
                            const S = _.endpoints[g], v = S === null || S === void 0 ? void 0 : (_S_contentSharing = S.contentSharing) === null || _S_contentSharing === void 0 ? void 0 : _S_contentSharing.sessionInformation;
                            "presenter" === (v === null || v === void 0 ? void 0 : v.role) && (f[v.contentSharingCorrelationId] = {
                                presenterId: _.details.id,
                                sessionInfo: v,
                                selfEndpointIsPresenter: S.participantId === C
                            });
                        }
                    }
                    for (const g of Object.keys(this.contentSharingSessions))!f[g] && v.has(this.contentSharingSessions[g].presenterMri) && (S[g] = this.contentSharingSessions[g]);
                    return {
                        sessionsWithPresenters: f,
                        sessionsWithoutPresenters: S
                    };
                }
                stopSessionsFromRoster(g, f) {
                    this.logger.info(`[${f}][stopSessionsFromRoster]`);
                    for (const S of Object.keys(g))this.logger.info(`[${f}][stopSessionsFromRoster] stopping session with correlationId ${S}`), this.stopSession(g[S], f);
                }
                stopSession(g, f) {
                    this.logger.info(`[${f}][stopSession] Stopping session ${g.sessionId}`), g.handleStopFromRoster(this.DEFAULT_STOP_REASON, f), this.raiseContentSharingStopped(g.correlationId, f);
                }
                startSessionsFromRoster(g, f) {
                    this.logger.info(`[${f}][startSessionsFromRoster]`);
                    for (const S of Object.keys(g)){
                        this.logger.info(`[${f}][startSessionsFromRoster]`);
                        const v = this.contentSharingSessions[S], _ = g[S];
                        if (this.pendingSessionToStart && this.pendingSessionToStart.correlationId === S ? this.pendingSessionToStart.confirmInRoster() : v && v.confirmInRoster(), v) v && (this.contentSharingSessions[S].presenterMri = _.presenterId, this.logger.info(`[${f}][startSessionsFromRoster]Session ${S} is already present locally`));
                        else {
                            if (_.selfEndpointIsPresenter) {
                                this.logger.info(`[${f}][startSessionsFromRoster]This endpoint is presenting, dont fire callback`);
                                continue;
                            }
                            this.logger.info(`[${f}][startSessionsFromRoster]New sharing session found. Raising ContentSharingStarted`);
                            this.raiseContentSharingStarted(_.presenterId, _.sessionInfo, f).handleStartFromRoster(_.presenterId, f);
                        }
                    }
                }
                raiseContentSharingStopped(g, f, S, v) {
                    this.logger.info(`[${f}][raiseContentSharingStopped]`), this.signalingSessionCallback.onContentSharingStopped({
                        sessionId: this.contentSharingSessions[g].sessionId,
                        correlationId: g,
                        endedBy: S || this.DEFAULT_STOP_ID,
                        reason: v || this.DEFAULT_STOP_REASON
                    }, f), delete this.contentSharingSessions[g];
                }
                raiseContentSharingStarted(g, f, S) {
                    this.logger.info(`[${S}][raiseContentSharingStarted]`);
                    const v = new Pn(this.signalingSession, f.contentSharingCorrelationId, f.contentSharingSessionId, {
                        [an.LINKS.CONTENT_SHARING_CONTROLLER]: f.contentSharingController
                    });
                    v.presenterMri = g, this.contentSharingSessions[v.correlationId] = v;
                    const _ = {
                        sessionId: f.contentSharingSessionId,
                        correlationId: f.contentSharingCorrelationId,
                        contentIdentifier: f.identifier,
                        presenter: g,
                        subject: f.subject || null,
                        sessionState: f.sessionState || null
                    };
                    return this.signalingSessionCallback.onContentSharingStarted(_, S), v;
                }
                rejectBecauseOfMissingSession(g, f) {
                    const S = `There is no ContentSharing session with the correlation ID ${g}`;
                    this.logger.error(S), f && f.reject(new Error(S));
                }
                constructor(g, f){
                    this.contentSharingToStartCallWith = null, this.contentSharingSessions = {}, this.DEFAULT_STOP_REASON = {
                        code: an.CALL_END_CODE.SUCCESS,
                        subCode: an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: an.CALL_END_PHRASE.REMOTE_USER_INITIATED
                    }, this.DEFAULT_STOP_ID = "8:unknown", this.deleteContentSharingAsync = (g, f)=>{
                        this.logger.info(`[${f}][deleteContentSharingAsync]`);
                        const S = defer();
                        let v = this.contentSharingSessions[g];
                        if (this.pendingSessionToStart && this.pendingSessionToStart.correlationId === g && (v = this.pendingSessionToStart), v) {
                            const always = ()=>{
                                this.contentSharingSessions[g] && delete this.contentSharingSessions[g];
                            };
                            v.delete(S, f).then(always, always);
                        } else this.rejectBecauseOfMissingSession(g, S);
                        return S.promise;
                    }, this.signalingSession = g, this.signalingSessionCallback = f, this.logger = g.logger.createChild(()=>"[ContentSharingManager]"), this.lastProcessedSequenceNumber = -1, this.lastProcessedSequenceNumberForParticipant = {};
                }
            }, Mn = {
                Default: {
                    retryIntervalsMs: [
                        200,
                        1e3,
                        5e3
                    ],
                    maxRequestAttempts: 4,
                    perRequestTimeoutMs: 45e3,
                    perAttemptTimeoutMs: 15e3,
                    perRequestTimeoutWithHedgingMs: 45e3,
                    perAttemptTimeoutWithHedgingMs: 3e4,
                    hedgeDelayMs: 4e3
                },
                BrokerSubscribe: {
                    retryIntervalsMs: [
                        100,
                        200,
                        500
                    ],
                    maxRequestAttempts: 4,
                    perRequestTimeoutMs: 3e4,
                    perAttemptTimeoutMs: 3e4,
                    perRequestTimeoutWithHedgingMs: 45e3,
                    perAttemptTimeoutWithHedgingMs: 3e4
                }
            }, On = {
                CallSetup: {
                    requestHedgingCapability: [
                        "disabled"
                    ],
                    hedgeDelayMs: 4e3
                },
                Other: {
                    requestHedgingCapability: [
                        "disabled"
                    ]
                },
                BrokerSubscribe: {
                    requestHedgingCapability: [
                        "disabled"
                    ]
                }
            }, Dn = "HttpRequestDispatcherFactory";
            function reportTokenTelemetryData(g, f, S) {
                var _f_signalingSession_telemetryHelper;
                (f === null || f === void 0 ? void 0 : f.signalingSession) ? (_f_signalingSession_telemetryHelper = f.signalingSession.telemetryHelper) === null || _f_signalingSession_telemetryHelper === void 0 ? void 0 : _f_signalingSession_telemetryHelper.addTokenTelemetry(g, f === null || f === void 0 ? void 0 : f.tokenTelemetryData) : S === null || S === void 0 ? void 0 : S.info("[reportTokenTelemetryData] signaling session is not available, cannot send token telemetry");
            }
            function get3(g, f) {
                const { signalingSession: S, operation: v, causeId: _, data: C, customHeaders: E = {}, forceFetchToken: T, tokenRequestOptions: I } = g;
                if (S.disposed) return Promise.reject("Session already disposed");
                const handleFailure = (g)=>{
                    const f = "string" == typeof g ? new Error(g) : g;
                    throw S.signalingAgent.clientSupportsGenericTokenAPI ? g.timeOut ? f.tokenTimeoutError = !0 : (f.tokenError = !0, f.tokenErrorSubCode = g.errorSubCode) : f.skypeTokenError = !0, f;
                };
                let b = !1;
                const A = {
                    signalingSession: S,
                    tokenTelemetryData: {}
                };
                return S.signalingAgent.authTokenManager.getToken(_, T, I, A).catch((v)=>(reportTokenTelemetryData(g.requestId, A, f), !T && isAppOnline(S) && S.signalingAgentConfig.attemptHttpRequestWithCachedSkypetoken && S.signalingAgent.authTokenManager.getLastToken(_) ? (b = !0, f === null || f === void 0 ? void 0 : f.info(`[${_}][requestBuilder] failed to fetch token, using lastToken`), Promise.resolve(S.signalingAgent.authTokenManager.getLastToken(_))) : (f === null || f === void 0 ? void 0 : f.info(`[${_}][requestBuilder] getToken failed with error ${v}`), handleFailure(v)))).then((T)=>{
                    if (S.disposed) throw new Error("token returned too late. Object is already disposed");
                    reportTokenTelemetryData(g.requestId, A, f);
                    const I = new on;
                    if (I.set(an.HEADERS.CORRELATION_ID, S.correlationId), I.set(an.HEADERS.MESSAGE_ID, newMessageId(_)), I.set(an.HEADERS.CLIENT_USER_AGENT, S.signalingAgentConfig.clientInformation), S.signalingAgent.clientSupportsGenericTokenAPI) {
                        const g = S.signalingAgent.authTokenManager.getLastTokenType(_);
                        switch(S.signalingAgentConfig.disableTokenMigrationHeader || I.set(an.HEADERS.TOKEN_MIGRATION, "True"), g){
                            case 8:
                            case 4:
                                I.set(an.HEADERS.AUTHORIZATION, `${an.HEADERS.BEARER_KEYWORD} ${T}`), I.delete(an.HEADERS.SKYPE_TOKEN);
                                break;
                            case 1:
                                I.set(an.HEADERS.SKYPE_TOKEN, T), I.delete(an.HEADERS.AUTHORIZATION);
                                break;
                            default:
                                throw new Error(`Error in RequestBuilder. TokenType ${g} is not supported`);
                        }
                    } else I.set(an.HEADERS.SKYPE_TOKEN, T);
                    const R = S.participantManager.localParticipant;
                    R && (R.ring && I.set(an.HEADERS.RING, R.ring), R.region && I.set(an.HEADERS.REGION, R.region), R.partition && I.set(an.HEADERS.PARTITION, R.partition));
                    const P = (C === null || C === void 0 ? void 0 : C.payload) ? JSON.stringify(C.payload) : null, w = {
                        headers: {
                            ...I === null || I === void 0 ? void 0 : I.getAll(),
                            ...E
                        },
                        payload: P,
                        usedCachedSkypetoken: b,
                        reporting: {
                            serviceName: v ? `${Dn}-${v}` : Dn
                        }
                    };
                    return S.telemetryHelper.addNetworkOperationStarted(v), w;
                }).catch(handleFailure);
            }
            function isAppOnline(g) {
                const f = isTrouterAndNavigatorConnected(g.signalingAgentConfig.trouterServiceProvider);
                return 3 === f || 1 === f;
            }
            var Nn = 500, kn = 1e4, Ln = 4, Fn = 3e3, xn = 3;
            function build4(g) {
                return new Un(g.causeId, g.logger, g.dispatcher, g.requestType, g.url, g.request, g.attemptFailureCallback, g.authRequiredCallback, g.settings);
            }
            var Un = class {
                sendRequest() {
                    this.stackError = an.HTTP_STACK_ERROR.NONE;
                    const timeoutCallback = ()=>{
                        this.stackError = an.HTTP_STACK_ERROR.REQUEST_TIMEOUT, this.cancelAllAttempts(an.HTTP_STACK_ERROR.REQUEST_TIMEOUT);
                    };
                    return this.logger.info("send api called"), this.requestTimer = dt.build(timeoutCallback, "REQUEST_TIMEOUT").start(this.settings.enableRequestHedging ? this.settings.perRequestTimeoutWithHedgingMs : this.settings.perRequestTimeoutMs), new Promise((g, f)=>{
                        this.resolve = g, this.reject = f, this.scheduleNextRequest(!0);
                    });
                }
                cancelRequest() {
                    this.logger.info("cancelRequest"), this.stackError = an.HTTP_STACK_ERROR.REQUEST_ABORTED, this.cancelAllAttempts(an.HTTP_STACK_ERROR.ATTEMPT_ABORTED);
                }
                cancelOtherAttempts(g) {
                    this.pendingAttempts.splice(g - 1, 1), this.cancelAllAttempts(an.HTTP_STACK_ERROR.ABORTED_OTHER_ATTEMPT_SUCCESSFUL);
                }
                cancelAllAttempts(g) {
                    this.stopHedgeTimer(), this.stopStandardRetryTimer(), this.pendingAttempts.forEach((f)=>{
                        f.status = g, f.cancelDeferred.resolve(), this.stopAttemptTimeoutTimer(f);
                    }), this.stopRequestTimer();
                }
                getRequestMethod(g) {
                    switch(g){
                        case 0:
                            return this.dispatcher.getAsync.bind(this.dispatcher);
                        case 1:
                            return this.dispatcher.postAsync.bind(this.dispatcher);
                        case 2:
                            return this.dispatcher.putAsync.bind(this.dispatcher);
                        case 3:
                            return this.dispatcher.removeAsync.bind(this.dispatcher);
                        default:
                            return null;
                    }
                }
                async queueAttempt(g) {
                    const f = g && this.isNotRetryable(g);
                    if (this.logger.info("queueAttempt"), f || !this.canScheduleNextAttempt()) return this.logger.info(`unable to retry isNotRetryable ${f} ${JSON.stringify(g)}`), this.stopHedgeTimer(), this.stopRequestTimer(), void (this.hasPendingAttempts() || (this.settings.reportPreviousErrorsForTimeout && g === Zi.ATTEMPT_TIMEOUT && this.previousAttempt ? this.reject(this.previousAttempt) : this.reject(g)));
                    if (this.isAuthFailedStatus(g)) {
                        this.logger.info("auth failed"), this.stopHedgeTimer(), this.stopStandardRetryTimer(), this.stopRequestTimer();
                        try {
                            var _g_response, _this_request, _g_response1, _g_response_operationFailure, _g_response2;
                            const f = g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.headers, S = getRequestToken((_this_request = this.request) === null || _this_request === void 0 ? void 0 : _this_request.headers), v = ((_g_response1 = g.response) === null || _g_response1 === void 0 ? void 0 : _g_response1.status) === an.HTTP_STATUS_CODES.UNAUTHORIZED && ((_g_response2 = g.response) === null || _g_response2 === void 0 ? void 0 : (_g_response_operationFailure = _g_response2.operationFailure) === null || _g_response_operationFailure === void 0 ? void 0 : _g_response_operationFailure.subCode) === an.CALL_END_SUB_CODE.CONVERSATION_TERMINATION_INTERACTION_REQUIRED, _ = await this.authRequiredCallback(f, S, {
                                IPCAFailure: v
                            });
                            this.request = _;
                        } catch (f) {
                            return void this.reject(g);
                        }
                    }
                    this.previousAttempt = g, this.hedgeTimer ? this.logger.info("scheduleNextRequest ignored as there's already active hedge timer") : this.scheduleNextRequest(!1);
                }
                attempt() {
                    if (this.logger.info("attempt to send request"), this.stackError === an.HTTP_STACK_ERROR.REQUEST_ABORTED || this.otherAttemptSuccessful) return;
                    const g = (new Date).getTime();
                    this.requestsSent++;
                    const f = this.requestsSent, S = defer();
                    this.request.timeout = S.promise;
                    const v = {
                        cancelDeferred: S,
                        status: an.HTTP_STACK_ERROR.NONE,
                        timeoutTimer: null,
                        pending: !0
                    }, timeoutRequest = ()=>{
                        v.status = an.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT, v.cancelDeferred.resolve();
                    }, _ = dt.build(timeoutRequest, "ATTEMPT_TIMEOUT").start(this.settings.enableRequestHedging ? this.settings.perAttemptTimeoutWithHedgingMs : this.settings.perAttemptTimeoutMs);
                    v.timeoutTimer = _, this.pendingAttempts.push(v);
                    this.getRequestMethod(this.requestType)(this.url, this.request).then((S)=>{
                        if (this.logger.info(`attempt successful, request response=${getPIISafeRequestResponse(S)} status=${this.getRequestFromStatus(S)}`), this.otherAttemptSuccessful) throw "Other attempt succesful";
                        if (this.stackError === an.HTTP_STACK_ERROR.REQUEST_ABORTED) throw "Session disposed";
                        if (!S) throw "Invalid response";
                        v.pending = !1, this.otherAttemptSuccessful = !0, this.stopRequestTimer(), this.stopHedgeTimer(), this.stopAttemptTimeoutTimer(v), this.cancelOtherAttempts(f), this.resolve({
                            success: !0,
                            request: S.request,
                            response: S.response,
                            attempt: this.requestsSent,
                            attemptStartTimestamp: g,
                            attemptResponseTimestamp: (new Date).getTime()
                        });
                    }).catch((f)=>{
                        v.pending = !1, this.stopAttemptTimeoutTimer(v);
                        const S = this.standardizeFailedRequest(f, v);
                        this.logger.info(`attempt failed, request: ${getPIISafeRequest(f)} status=${S.status}`), this.onRequestFailed({
                            abandoned: this.otherAttemptSuccessful,
                            success: !1,
                            request: S,
                            attempt: this.requestsSent,
                            attemptStartTimestamp: g,
                            attemptResponseTimestamp: (new Date).getTime()
                        }), this.queueAttempt(S);
                    });
                }
                getNextDelay(g) {
                    let f;
                    if (g) f = 0;
                    else if (this.settings.enableRequestHedging) f = this.hedgeDelayMs;
                    else {
                        if (!(this.requestsSent <= this.settings.retryIntervalsMs.length)) throw "Unable to get next delay";
                        f = this.settings.retryIntervalsMs[this.requestsSent - 1];
                    }
                    return this.logger.info(`next delay= ${f} ms`), f;
                }
                isRequestWithStatus(g, f) {
                    return !!g && f.indexOf(g.status) > -1;
                }
                isNotRetryable(g) {
                    return !isRetryable(g && g.status);
                }
                isAuthFailedStatus(g) {
                    return this.isRequestWithStatus(g, [
                        an.HTTP_STATUS_CODES.UNAUTHORIZED
                    ]);
                }
                constructor(g, f, S, v, _, C, E, T, I){
                    this.causeId = g, this.logger = f, this.dispatcher = S, this.requestType = v, this.url = _, this.request = C, this.onRequestFailed = E, this.authRequiredCallback = T, this.settings = I, this.requestsSent = 0, this.otherAttemptSuccessful = !1, this.pendingAttempts = [], this.hedgeDelayMs = Fn, this.hedgeMaxParallelAttempts = xn, this.stopStandardRetryTimer = ()=>{
                        this.standardRetryTimer && (this.standardRetryTimer.stop(), this.standardRetryTimer = null);
                    }, this.stopHedgeTimer = ()=>{
                        this.hedgeTimer && (this.hedgeTimer.stop(), this.hedgeTimer = null);
                    }, this.stopAttemptTimeoutTimer = (g)=>{
                        try {
                            g.timeoutTimer && (g.timeoutTimer.stop(), this.logger.info("attempt timer stopped"));
                        } catch (g) {
                            this.logger.info(`stopAttemptTimeoutTimer error ${g}`);
                        }
                    }, this.stopRequestTimer = ()=>{
                        try {
                            this.requestTimer && (this.requestTimer.stop(), this.logger.info("Request timer stopped"));
                        } catch (g) {
                            this.logger.info(`stopRequestTimer error ${g}`);
                        }
                        this.requestTimer = null;
                    }, this.canScheduleNextAttempt = ()=>{
                        if (this.stackError === an.HTTP_STACK_ERROR.REQUEST_ABORTED || this.otherAttemptSuccessful || this.requestsSent >= this.settings.maxRequestAttempts) return this.logger.info(`canScheduleNextAttempt stack error ${this.stackError} otherAttemptSuccessful ${this.otherAttemptSuccessful} exceeded max attempt ${this.requestsSent >= this.settings.maxRequestAttempts}`), !1;
                        if (this.settings.enableRequestHedging) {
                            const g = this.pendingAttempts.length < this.hedgeMaxParallelAttempts;
                            return g || this.logger.info(`canScheduleNextAttempt enableRequestHedging attempts sent: ${this.pendingAttempts.length} max attempts: ${this.hedgeMaxParallelAttempts}`), g;
                        }
                        {
                            const g = this.requestsSent < this.settings.retryIntervalsMs.length;
                            return g || this.logger.info(`canScheduleNextAttempt attempts sent: ${this.requestsSent} max attempts: ${this.settings.retryIntervalsMs.length}`), g;
                        }
                    }, this.scheduleNextRequest = (g)=>{
                        this.settings.enableRequestHedging ? (this.logger.info("scheduleNextRequest with hedging"), this.hedgeTimer = dt.build(()=>{
                            this.attempt(), this.canScheduleNextAttempt() && this.scheduleNextRequest(!1);
                        }, "HEDGE").start(this.getNextDelay(g))) : (this.logger.info("scheduleNextRequest with retry"), this.standardRetryTimer = dt.build(()=>{
                            this.attempt();
                        }, "RETRY").start(this.getNextDelay(g)));
                    }, this.standardizeFailedRequest = (g, f)=>{
                        let S;
                        const v = this.logger.createChild("[standardizeFailedRequest]");
                        try {
                            if (this.stackError === an.HTTP_STACK_ERROR.REQUEST_TIMEOUT) v.info("request timed out"), S = Zi.REQUEST_TIMEOUT;
                            else if (this.stackError === an.HTTP_STACK_ERROR.REQUEST_ABORTED) v.info("request aborted"), S = Zi.REQUEST_ABORTED;
                            else if (f && f.status === an.HTTP_STACK_ERROR.ATTEMPT_TIMEOUT) v.info("request attempt timed out"), S = Zi.ATTEMPT_TIMEOUT;
                            else if (f && [
                                an.HTTP_STACK_ERROR.ATTEMPT_ABORTED,
                                an.HTTP_STACK_ERROR.ABORTED_OTHER_ATTEMPT_SUCCESSFUL
                            ].indexOf(f.status) > -1) v.info("request attempt aborted"), S = Zi.ATTEMPT_ABORTED;
                            else if (g) {
                                var _g_response, _g_body;
                                if (v.info(`request ${getPIISafeRequest(g)}`), "function" == typeof XMLHttpRequest && g instanceof XMLHttpRequest) S = g;
                                else if ("function" == typeof XMLHttpRequest && g && g.request instanceof XMLHttpRequest) {
                                    var _f_request, _f_response, _f_request1, _f_response1;
                                    const f = g;
                                    S = {
                                        response: {
                                            ..."string" == typeof (f === null || f === void 0 ? void 0 : (_f_request = f.request) === null || _f_request === void 0 ? void 0 : _f_request.response) ? f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.data : f === null || f === void 0 ? void 0 : (_f_request1 = f.request) === null || _f_request1 === void 0 ? void 0 : _f_request1.response,
                                            headers: (_f_response1 = f.response) === null || _f_response1 === void 0 ? void 0 : _f_response1.headers
                                        },
                                        status: f.request.status,
                                        statusText: f.request.statusText,
                                        readyState: f.request.readyState
                                    };
                                } else g.status || g.statusCode || g.response ? S = {
                                    response: g.response,
                                    status: [
                                        void 0,
                                        null,
                                        ""
                                    ].indexOf(g.status) > -1 ? g.statusCode : g.status,
                                    statusText: g.statusText,
                                    readyState: g.readyState
                                } : (v.info("Local http stack error"), S = {
                                    response: an.CALL_END_SUB_CODE.LOCAL_HTTP_STACK_ERROR,
                                    status: an.CALL_END_CODE.LOCAL_HTTP_STACK_ERROR,
                                    statusText: "LocalHTTPStackError",
                                    readyState: g.readyState || 0
                                });
                                this.isBrowserOffline() && 0 === S.status && 4 === S.readyState && (v.info("offline"), S = {
                                    response: an.HTTP_STACK_ERROR.CANNOT_CONNECT,
                                    status: an.HTTP_STATUS_CODES.OFFLINE,
                                    statusText: "offline",
                                    readyState: S.readyState
                                }), ((_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.message) && (g.response.message.operationFailure || g.response.message.broadcastOperationFailure) ? S = {
                                    response: g.response.message
                                } : !g.response && ((_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.operationFailure) && (S = {
                                    response: g.body
                                });
                            } else v.info("no response"), S = {
                                response: an.HTTP_STACK_ERROR.NONE,
                                status: an.HTTP_STATUS_CODES.OTHER,
                                statusText: "Empty Response",
                                readyState: 0
                            };
                        } catch (g) {
                            v.info(`Failed to handle error ${g}`), S = {
                                response: "",
                                status: an.HTTP_STATUS_CODES.OTHER,
                                statusText: "FailedToHandleError",
                                readyState: 0
                            };
                        }
                        return S;
                    }, this.hasPendingAttempts = ()=>this.pendingAttempts.some((g)=>g.pending), this.getRequestFromStatus = (g)=>g && g.request && g.request.status || 0, this.isBrowserOffline = ()=>navigator && !1 === navigator.onLine, this.logger = f.createChild(`[${this.causeId}][Dispatcher]`), this.logger.info(`created request, url=${_}`), !isNaN(this.settings.hedgeDelayMs) && this.settings.hedgeDelayMs >= Nn && this.settings.hedgeDelayMs <= kn && (this.hedgeDelayMs = this.settings.hedgeDelayMs), !isNaN(this.settings.hedgeMaxParallelAttempts) && this.settings.hedgeMaxParallelAttempts >= 0 && this.settings.hedgeMaxParallelAttempts <= Ln && (this.hedgeMaxParallelAttempts = this.settings.hedgeMaxParallelAttempts), (isNaN(this.settings.perAttemptTimeoutMs) || this.settings.perAttemptTimeoutMs <= 0) && (this.settings.perAttemptTimeoutMs = 15e3), (isNaN(this.settings.perRequestTimeoutMs) || this.settings.perRequestTimeoutMs <= 0) && (this.settings.perRequestTimeoutMs = 45e3), (isNaN(this.settings.maxRequestAttempts) || this.settings.maxRequestAttempts <= 0) && (this.settings.maxRequestAttempts = 4), (isNaN(this.settings.perRequestTimeoutWithHedgingMs) || this.settings.perRequestTimeoutWithHedgingMs <= 0) && (this.settings.perRequestTimeoutWithHedgingMs = 45e3), (isNaN(this.settings.perAttemptTimeoutWithHedgingMs) || this.settings.perAttemptTimeoutWithHedgingMs <= 0) && (this.settings.perAttemptTimeoutWithHedgingMs = 3e4);
                }
            }, Vn = {
                1: "POST",
                0: "GET",
                2: "PUT",
                3: "DELETE"
            }, Bn = class {
                getInternalHttpDispatcherConfig(g, f = "Other") {
                    let S = {
                        ...Mn.Default,
                        ...On[f],
                        ...Mn[g]
                    };
                    return this.signalingSession && this.signalingSession.signalingAgentConfig && this.signalingSession.signalingAgentConfig.operationTypeHttpDispatcherConfigMap && (S = {
                        ...S,
                        ...this.signalingSession.signalingAgentConfig.operationTypeHttpDispatcherConfigMap[f]
                    }), this.signalingSession && this.signalingSession.signalingAgentConfig && this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap && (S = {
                        ...S,
                        ...this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap.Default,
                        ...this.signalingSession.signalingAgentConfig.requestTypeHttpDispatcherConfigMap[g]
                    }), this.logger.info(`getInternalHttpDispatcherConfig request type: ${g} config: ${safeJsonStringify(S)}`), S;
                }
                shouldEnableRequestHedging(g) {
                    return !!(this.signalingSession.getMeetingInfo() && g.requestHedgingCapability.indexOf("enabledForMeetings") > -1) || !this.signalingSession.multiParty && g.requestHedgingCapability.indexOf("enabledForP2PCalls") > -1 || !!(this.signalingSession.multiParty && g.requestHedgingCapability.indexOf("enabledForGroupCalls") > -1) || g.requestHedgingCapability.indexOf("enabled") > -1;
                }
                constructor(g, f){
                    this.signalingSession = g, this.callStartTime = f, this.pendingRequests = {}, this.sendGetRequest = (g)=>this.sendRequest(0, g), this.sendPostRequest = (g)=>this.sendRequest(1, g), this.sendPutRequest = (g)=>this.sendRequest(2, g), this.sendDeleteRequest = (g)=>this.sendRequest(3, g), this.cancelRequestIfPending = (g, f, S, v)=>{
                        this.logger.info(`[${f}][cancelRequestIfPending]`), this.pendingRequests[g] ? S ? this.hasPendingRequest(g, S) && this.cancelRequest(g, S, f, v) : Object.keys(this.pendingRequests[g]).forEach((S)=>this.cancelRequest(g, S, f, v)) : this.logger.info(`[${f}][cancelRequestIfPending]no pending request with name=${g}`);
                    }, this.cancelAllRequests = (g)=>{
                        this.logger.info(`[${g}][cancelAllRequests]`);
                        const f = [];
                        return Object.keys(this.pendingRequests).forEach((S)=>{
                            Object.keys(this.pendingRequests[S]).forEach((v)=>{
                                f.push(this.cancelRequest(S, v, g));
                            });
                        }), Promise.all(f).catch(()=>{});
                    }, this.hasPendingRequest = (g, f)=>!!this.pendingRequests[g] && Boolean(f ? this.pendingRequests[g][f] : this.pendingRequests[g]), this.cancelRequest = (g, f, S, v)=>{
                        try {
                            return this.pendingRequests[g][f].dispatcher && this.pendingRequests[g][f].dispatcher.cancelRequest(), this.pendingRequests[g][f].aborted = !0, this.pendingRequests[g][f].errorDetails = v, this.logger.info(`[${S}][cancelRequest]Request=${g} aborted ${v ? `with errorDetails ${JSON.stringify(v)}` : ""}`), this.pendingRequests[g][f].requestPromise.catch(()=>{});
                        } catch (v) {
                            return this.logger.warn(`[${S}][cancelRequest]Unable to cancel request=${g}, requestId=${f}`), Promise.resolve();
                        }
                    }, this.buildRequestTelemetry = (g, f, S, v)=>({
                            name: `${Vn[g]}-${f.requestName}`,
                            url: f.url,
                            eventStart: S - this.callStartTime,
                            trouterReady: -1,
                            requestReady: -1,
                            status: -1,
                            attempts: [],
                            rtt: -1,
                            uid: f.requestId,
                            causeId: f.causeId,
                            requestDispatcherConfig: v,
                            enableRequestHedging: this.shouldEnableRequestHedging(v)
                        }), this.addPendingRequest = (g)=>(this.pendingRequests[g.requestName] || (this.pendingRequests[g.requestName] = {}), this.pendingRequests[g.requestName][g.requestId] = {
                            dispatcher: null,
                            requestPromise: null,
                            aborted: !1
                        }, this.pendingRequests[g.requestName][g.requestId]), this.sendRequest = (g, f)=>{
                        if (!f.url) {
                            this.logger.error(f.requestName, "Link does not exist");
                            const g = {
                                code: an.CALL_END_CODE.HTTP_OTHER_ERROR,
                                subCode: an.CALL_END_SUB_CODE.MISSING_REQUEST_URI,
                                phrase: `Link does not exist for requestName: ${f.requestName}.`
                            };
                            return Promise.reject(g);
                        }
                        f.requestId || (f.requestId = newGuid()), f.causeId || (f.causeId = causeId2());
                        let S = !1, v = !1;
                        const _ = this.logger.createChild(`[${f.causeId}][${f.requestName}]`);
                        _.info("[scheduled]");
                        const C = this.getInternalHttpDispatcherConfig(f.requestName, f.operationType);
                        let E;
                        f.skipHttpTelemetry || (f.skipHttpTelemetry = !1);
                        const T = build3(), I = (new Date).getTime(), b = [], A = this.buildRequestTelemetry(g, f, I, C), updateRequestTelemetry = ()=>{
                            this.signalingSession.disposed ? this.logger.info("Unable to record telemetry, session disposed") : this.signalingSession.telemetryHelper.updateNetworkRequest(A);
                        }, deleteRequestTelemetry = ()=>{
                            this.signalingSession.telemetryHelper.deleteNetworkRequest(A);
                        };
                        updateRequestTelemetry();
                        const logRequestAttempt = (g, S, C)=>{
                            var _g_request_response_operationFailure, _g_request_response;
                            if (!(g === null || g === void 0 ? void 0 : g.request)) return void this.logger.warn(f.requestName, "missing request details, unable to record for telemetry!");
                            _.info(`[finished][status=${g.request.status}][statusText=${g.request.statusText}][retryCount=${g.attempt}]`);
                            const E = g.request.status, T = (_g_request_response = g.request.response) === null || _g_request_response === void 0 ? void 0 : (_g_request_response_operationFailure = _g_request_response.operationFailure) === null || _g_request_response_operationFailure === void 0 ? void 0 : _g_request_response_operationFailure.subCode, b = {
                                status: E,
                                statusSubCode: T,
                                start: g.attemptStartTimestamp - I,
                                end: g.attemptResponseTimestamp - I,
                                online: isTrouterAndNavigatorConnected(this.signalingSession.signalingAgentConfig.trouterServiceProvider)
                            };
                            g.abandoned && (b.abandoned = !0), g.request.statusText && (b.statusText = g.request.statusText), !S && v || (A.status = E, A.statusSubCode = C || T), (S || !v && E >= 200 && E < 400) && (v = !0), A.attempts.push(b), updateRequestTelemetry();
                        };
                        if (this.hasPendingRequest(f.requestName, f.requestId)) return this.logger.warn(f.requestName, f.requestId, "is already pending request!!"), this.pendingRequests[f.requestName][f.requestId].requestPromise;
                        E = this.addPendingRequest(f);
                        const recordTelemetryAndCleanup = (g, S, v, C)=>{
                            if (g && f.skipHttpTelemetry) return this.logger.info("Skipping telemetry"), void deleteRequestTelemetry();
                            _.info(`[steps=${b}]`), this.pendingRequests[f.requestName][f.requestId].aborted && (A.aborted = !0), this.hasPendingRequest(f.requestName, f.requestId) ? (delete this.pendingRequests[S][v], Object.keys(this.pendingRequests[S]).length || delete this.pendingRequests[S]) : this.logger.warn("Unable to clean up!"), this.signalingSession.disposed || (C && (A.error = C), A.rtt = T.duration(), this.signalingSession.telemetryHelper.addNetworkOperationCompleted(f.requestName, g, T.duration()), updateRequestTelemetry(), this.signalingSession.telemetryHelper.sendHttpTelemetryData(A.uid));
                        }, checkIfNotDisposed = (g)=>(...S)=>{
                                if (this.signalingSession.disposed) {
                                    const g = `[${f.causeId}][${f.requestName}][failed][reason=Session disposed]`;
                                    throw _.info("[failed][reason=Session disposed]"), new Error(g);
                                }
                                if (this.hasPendingRequest(f.requestName, f.requestId) && this.pendingRequests[f.requestName][f.requestId].aborted) {
                                    let g;
                                    const S = `[${f.causeId}][${f.requestName}][failed][reason=request already aborted]`, v = this.pendingRequests[f.requestName][f.requestId].errorDetails;
                                    throw v ? (g = v, g.phrase = S) : g = S, _.info(`${S}`), new Error(JSON.stringify(g));
                                }
                                return g(...S);
                            }, R = checkIfNotDisposed(()=>(b.push("[waitForTrouter]"), f.withoutTrouter ? Promise.resolve() : this.signalingSession.ensureMessageChannelReady(f.requestName))), P = checkIfNotDisposed(()=>(b.push("[trouterReady]"), A.trouterReady = T.duration(), f.onceTrouterReady && f.onceTrouterReady(), updateRequestTelemetry(), Promise.resolve())), w = checkIfNotDisposed(()=>{
                            var _f_customHeaders;
                            const S = this.signalingSession.signalingAgent.clientSupportsGenericTokenAPI, v = getTokenMetadata(this.signalingSession.signalingAgentConfig, S, g, f, !1, void 0, this.logger);
                            return b.push("[buildRequest]"), get3({
                                signalingSession: this.signalingSession,
                                operation: f.requestName,
                                data: f.payload,
                                customHeaders: (_f_customHeaders = f.customHeaders) === null || _f_customHeaders === void 0 ? void 0 : _f_customHeaders.getAll(),
                                causeId: f.causeId,
                                tokenRequestOptions: v,
                                requestId: f.requestId
                            }, this.logger);
                        }), M = checkIfNotDisposed((g)=>{
                            b.push("[failedToBuildRequestOptions]");
                            const f = {
                                request: {
                                    status: an.HTTP_STATUS_CODES.OTHER,
                                    statusText: "Local error"
                                },
                                attempt: 1,
                                success: !1,
                                attemptResponseTimestamp: (new Date).getTime(),
                                attemptStartTimestamp: (new Date).getTime()
                            };
                            let v;
                            return g && (g.skypeTokenError ? (f.request = {
                                status: an.CALL_END_SKYPE_TOKEN_ERROR.code,
                                statusText: an.CALL_END_SKYPE_TOKEN_ERROR.phrase
                            }, v = an.CALL_END_SKYPE_TOKEN_ERROR.subCode) : g.tokenError ? (f.request = {
                                status: an.CALL_END_TOKEN_ERROR.code,
                                statusText: an.CALL_END_TOKEN_ERROR.phrase
                            }, v = g.errorSubCode && g.errorSubCode > 0 ? g.errorSubCode : an.CALL_END_TOKEN_ERROR.subCode) : g.tokenTimeoutError && (S ? (f.request = {
                                status: an.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.code,
                                statusText: an.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.phrase
                            }, v = an.CALL_END_TOKEN_TIMEOUT_INTERACTIVITY_REQUIRED.subCode, g.tokenInteractivityRequiredTimeout = !0) : (f.request = {
                                status: an.CALL_END_TOKEN_TIMEOUT_ERROR.code,
                                statusText: an.CALL_END_TOKEN_TIMEOUT_ERROR.phrase
                            }, v = an.CALL_END_TOKEN_TIMEOUT_ERROR.subCode))), logRequestAttempt(f, !1, v), Promise.reject(g);
                        }), O = checkIfNotDisposed((g)=>(b.push("[requestBuilt]"), A.requestReady = T.duration(), g.usedCachedSkypetoken && (A.usedCachedSkypetoken = g.usedCachedSkypetoken), updateRequestTelemetry(), Promise.resolve(g))), authRequiredCallback = (v, _, C)=>{
                            var _f_customHeaders;
                            b.push("[authRequired]"), (C === null || C === void 0 ? void 0 : C.IPCAFailure) && (S = !0);
                            const E = this.signalingSession.signalingAgent.clientSupportsGenericTokenAPI, T = getTokenMetadata(this.signalingSession.signalingAgentConfig, E, g, f, !0, v, this.logger);
                            return T.invalidToken = _, get3({
                                signalingSession: this.signalingSession,
                                operation: f.requestName,
                                data: f.payload,
                                customHeaders: (_f_customHeaders = f.customHeaders) === null || _f_customHeaders === void 0 ? void 0 : _f_customHeaders.getAll(),
                                causeId: f.causeId,
                                forceFetchToken: !0,
                                tokenRequestOptions: T,
                                requestId: f.requestId
                            }, this.logger);
                        }, D = checkIfNotDisposed((S)=>{
                            b.push("[sendRequest]");
                            const v = {
                                ...C,
                                enableRequestHedging: this.shouldEnableRequestHedging(C),
                                hedgeDelayMs: C.hedgeDelayMs,
                                hedgeMaxParallelAttempts: this.signalingSession.signalingAgentConfig.hedgeMaxParallelAttempts,
                                retryIntervalsMs: f.disableRetry || !C.retryIntervalsMs ? [] : C.retryIntervalsMs,
                                reportPreviousErrorsForTimeout: this.signalingSession.signalingAgentConfig.reportPreviousErrorsForTimeout
                            }, _ = build4({
                                logger: this.logger,
                                causeId: f.causeId,
                                dispatcher: this.signalingSession.signalingAgentConfig.httpRequestDispatcher,
                                url: f.url,
                                request: S,
                                requestType: g,
                                authRequiredCallback: authRequiredCallback,
                                attemptFailureCallback: (g)=>{
                                    logRequestAttempt(g, !1);
                                },
                                settings: v
                            });
                            return E.dispatcher = _, updateRequestTelemetry(), _.sendRequest();
                        }), N = checkIfNotDisposed(async (g)=>(logRequestAttempt(g, !0), _.info("[success]"), recordTelemetryAndCleanup(!0, f.requestName, f.requestId), g)), onFailure = (g)=>{
                            const S = getPrintableObject(g);
                            return recordTelemetryAndCleanup(!1, f.requestName, f.requestId, S), !g || g.readyState || g.status ? _.info(`[failed][reason=${S}]`) : _.info(`[failed][offline][reason=${S}]`), Promise.reject(g);
                        }, k = Promise.resolve().then(R).then(P).then(w).catch(M).then(O).then(D).then(N).catch(onFailure);
                        return E.requestPromise = k, k;
                    }, this.logger = this.signalingSession.logger.createChild("[HTTP]");
                }
            };
            function getPayload8(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                let v = [];
                S && (v = getMediaTypes(S), g.telemetryHelper.addOutgoingModalities(v));
                const _ = causeId2();
                return {
                    payload: {
                        mediaNegotiation: {
                            callModalities: v,
                            sender: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            links: {
                                mediaAnswer: get2(g, nn.MEDIA_ANSWER, _),
                                rejection: get2(g, nn.MEDIA_REJECTION, _)
                            },
                            mediaContent: f
                        }
                    }
                };
            }
            function getPayload9(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f), {
                    payload: {
                        mediaNegotiationFailure: {
                            sender: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            code: f.code,
                            subCode: f.subCode,
                            phrase: f.phrase
                        },
                        debugContent: {
                            callId: g.correlationId,
                            endpointId: g.participantManager.localParticipant.endpointId
                        }
                    }
                };
            }
            function getPayload10(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                let v = [];
                return S && (v = getMediaTypes(S), g.telemetryHelper.addOutgoingModalities(v)), {
                    payload: {
                        mediaAnswer: {
                            callModalities: v,
                            sender: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            links: {
                                mediaAcknowledgement: get2(g, nn.MEDIA_ACKNOWLEDGEMENT)
                            },
                            clientContentForMediaController: g.webRtcSignalingManager.getClientUrls(),
                            mediaContent: f
                        },
                        debugContent: {
                            callId: g.correlationId,
                            endpointId: g.participantManager.localParticipant.endpointId
                        }
                    }
                };
            }
            var Hn = class {
                rejectAndLog(g, f, S) {
                    this.logger.error(`[${g}][handleMediaNegotiationOffer] Cannot handle the incoming mediaRenegotiation offer in present callstate. Either call not connected or renegotiation in progress. isDuplicateOffer=${f}`), f || this.rejectMediaRenegotiation(S.mediaNegotiation.links.rejection, this.getGlareError(), g);
                }
                setFsmState(g, f) {
                    this.fsmState = g, this.fsmStateCauseId = f, this.logger.info(`[setFsmState]state=${g}`), this.telemetryHelper.recordEvent(cn.MEDIA_FSM_STATE_CHANGED, {
                        state: g,
                        causeId: f
                    });
                }
                raiseMediaRenegotiationOffer(g, f) {
                    this.logger.info(`[${f}][raiseMediaRenegotiationOffer]`), this.links[an.LINKS.MEDIA_ANSWER] = g.mediaNegotiation.links.mediaAnswer, this.links[an.LINKS.MEDIA_REJECTION] = g.mediaNegotiation.links.rejection;
                    let S = [];
                    g.mediaNegotiation.callModalities && g.mediaNegotiation.callModalities.length > 0 && (S = getMediaTypes(g.mediaNegotiation.callModalities), this.signalingSession.telemetryHelper.addIncomingModalities(S), arrayContains(S, an.MEDIA_TYPES.SCREEN_SHARER) && this.signalingSession.telemetryHelper.addVbssOperations(un.VBSS_OPERATION.REMOTE_START));
                    const v = {
                        mediaTypes: S,
                        remoteParticipantId: this.signalingSession.getParticipantIdForOfferAnswer(g.mediaNegotiation.mediaContent),
                        mediaContent: g.mediaNegotiation.mediaContent,
                        renegotiation: !0
                    };
                    this.signalingSessionCallback.onOffer(v, f);
                }
                rejectMediaRenegotiation(g, f, S) {
                    this.logger.info(`[${S}][rejectMediaRenegotiation][rejectionData=${getPIISafeObject(f)}]`);
                    const v = defer();
                    return this.signalingSession.http.sendPostRequest({
                        url: g,
                        payload: getPayload9(this.signalingSession, f),
                        requestName: dn.SEND_MEDIA_REJECTION.name,
                        causeId: S
                    }).then((g)=>{
                        v.resolve(g.response);
                    }).catch((g)=>{
                        const f = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        this.logger.info(`[${S}][rejectMediaRenegotiation] error: ${getPrintableObject(f)}`), v.reject(new Error(`rejectMediaRenegotiation failed because : ${getPrintableObject(g)}`));
                    }), v.promise;
                }
                handleMediaAnswerTimeout(g) {
                    this.logger.info(`[${g}][handleMediaAnswerTimeout]`), this.vbssInitiated && (this.vbssInitiated = !1, this.signalingSession.telemetryHelper.addVbssOperations(un.VBSS_OPERATION.TIMEOUT)), this.signalingSession.telemetryHelper.addIncomingModalities([
                        "Timeout"
                    ]), this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ANSWER_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER), this.handleMediaNegotiationFailureInternal({
                        code: an.CALL_END_CODE.TIMEOUT,
                        subCode: an.CALL_END_SUB_CODE.MEDIA_FINAL_ANSWER_TIMEOUT,
                        phrase: an.CALL_END_PHRASE.MEDIA_FINAL_ANSWER_TIMEOUT
                    }, un.EVENT_SOURCE.LOCAL, g);
                }
                handleMediaAnswerAcknowledgmentTimeout(g) {
                    this.logger.info(`[${g}][handleMediaAnswerAcknowledgmentTimeout]`), this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ACKNOWLEDGEMENT_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT);
                    const f = {
                        reason: "timed out waiting for Media Answer Acknowledgement"
                    };
                    this.signalingSessionCallback.onMediaAcknowledgementFailure(!0, f, g);
                }
                constructor(g, f, S){
                    this.telemetryHelper = S, this.vbssInitiated = !1, this.disposed = !1, this.fsmState = an.MEDIA_RENEGOTIATION_FSM_STATE.IDLE, this.fsmStateCauseId = "", this.links = {}, this.renegotiationOffersSeenSoFar = [], this.isOutgoingRenegotiationInProgress = ()=>this.fsmState === an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION || this.fsmState === an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE, this.isIncomingRenegotiationInProgress = ()=>this.fsmState === an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION || this.fsmState === an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE, this.acceptRenegotiationAsync = (g, f, S)=>{
                        this.logger.info(`[${S}][acceptRenegotiationAsync][mediaTypes=${f}]`), this.signalingSession.telemetryHelper.recordEvent(cn.ACCEPT_RENEGOTIATION, {
                            mediaTypes: f,
                            causeId: S
                        }), assertNotNullOrEmpty(this.links[an.LINKS.MEDIA_ANSWER], "MediaAnswer link not set");
                        const v = defer();
                        switch(this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, S);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION, S);
                                break;
                            default:
                                return this.logger.info(`[${S}][acceptRenegotiationAsync]there is no incoming media renegotiation offer to accept`), v.reject(new Error("there is no incoming media renegotiation offer to accept")), v.promise;
                        }
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT, this.handleMediaAnswerAcknowledgmentTimeout.bind(this, S), an.TIMEOUT_VALUES_IN_SECONDS.MEDIA_ANSWER_ACKNOWLEDGEMENT_TIMEOUT);
                        };
                        return this.signalingSession.http.sendPostRequest({
                            url: this.links[an.LINKS.MEDIA_ANSWER],
                            payload: getPayload10(this.signalingSession, g, f),
                            requestName: dn.SEND_MEDIA_ANSWER.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: S
                        }).then((g)=>{
                            v.resolve(g.response);
                        }).catch((g)=>{
                            const f = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${S}][acceptRenegotiationAsync] error: ${getPrintableObject(f)}`), this.disposed || this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT), v.reject(new Error(`acceptRenegotiationAsync failed because : ${getPrintableObject(g)}`));
                        }), v.promise;
                    }, this.startRenegotiationAsync = (g, f, S, v)=>{
                        this.logger.info(`[${v}][startRenegotiationAsync][mediaTypes=${S}]`), this.signalingSession.telemetryHelper.recordEvent(cn.START_RENEGOTIATION, {
                            causeId: v,
                            mediaTypes: S
                        }), assertNotNullOrEmpty(f, "MediaRenegotiation link not set");
                        const _ = defer();
                        switch(this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION, v);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                return this.logger.info(`[${v}][startRenegotiationAsync][failed] can only be performed with no current outstanding renegotiations, previous negotiation causeId=${this.fsmStateCauseId}`), this.signalingSessionCallback.onMediaRenegotiationRejection(this.getGlareError(), v), Promise.resolve(null);
                            default:
                                return this.logger.info(`[${v}][startRenegotiationAsync][failed] can only be performed on an established call`), _.reject(new Error("media renegotiation can only be performed on an established call")), _.promise;
                        }
                        const C = S && arrayContains(S, an.MEDIA_TYPES.SCREEN_SHARER);
                        C ? (this.vbssInitiated = !0, this.signalingSession.telemetryHelper.addVbssOperations(un.VBSS_OPERATION.START)) : !C && this.vbssInitiated && (this.vbssInitiated = !1, this.signalingSession.telemetryHelper.addVbssOperations(un.VBSS_OPERATION.STOP));
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER, this.handleMediaAnswerTimeout.bind(this), an.TIMEOUT_VALUES_IN_SECONDS.MEDIA_ANSWER_TIMEOUT);
                        };
                        return this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: getPayload8(this.signalingSession, g, S),
                            requestName: dn.START_RENEGOTIATION.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: v
                        }).then((g)=>{
                            _.resolve(g.response);
                        }).catch((g)=>{
                            const f = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                            if (this.logger.info(`[${v}][startRenegotiationAsync] error: ${getPrintableObject(f)}`), !this.disposed) {
                                switch(this.fsmState){
                                    case an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:
                                        this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, v);
                                        break;
                                    case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                        this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION, v);
                                }
                                this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER);
                            }
                            _.reject(new Error(`startRenegotiationAsync failed because : ${getPrintableObject(g)}`));
                        }), _.promise;
                    }, this.handleMediaAcknowledgment = (g, f)=>{
                        this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ACKNOWLEDGEMENT, {
                            causeId: f
                        }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER_ACKNOWLEDGEMENT), this.signalingSession.saveMediaControllerLinksIfAny(g), this.signalingSession.saveUpdatedCallLinksIfAny(g), this.signalingSessionCallback.onMediaAcknowledgementSuccess(!0, f);
                    }, this.onCallConnected = (g)=>{
                        this.logger.info("onCallConnected"), this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, g);
                    }, this.handleMediaNegotiationFailure = (g)=>{
                        const f = extractCauseIdFromMessage(g);
                        this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_MEDIA_NEGOTIATION_FAILURE, g), this.handleMediaNegotiationFailureInternal(g.body.mediaNegotiationFailure, g.origin, f);
                    }, this.handleMediaAnswer = (g, f)=>{
                        switch(this.logger.info(`[${f}][handleMediaAnswer]`), this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ANSWER, {
                            causeId: f
                        }), this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, f);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION, f);
                                break;
                            default:
                                return;
                        }
                        this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER);
                        let S = [];
                        g.mediaAnswer.callModalities && g.mediaAnswer.callModalities.length > 0 && (S = getMediaTypes(g.mediaAnswer.callModalities), this.signalingSession.telemetryHelper.addIncomingModalities(S));
                        const v = {
                            provisional: !1,
                            renegotiation: !0,
                            mediaTypes: S,
                            remoteParticipantId: this.signalingSession.getParticipantIdForOfferAnswer(g.mediaAnswer.mediaContent),
                            mediaContent: g.mediaAnswer.mediaContent
                        };
                        this.signalingSession.http.sendPostRequest({
                            url: g.mediaAnswer.links.mediaAcknowledgement,
                            payload: null,
                            requestName: dn.SEND_MEDIA_ACKNOWLEDGEMENT.name,
                            causeId: f
                        }).catch((g)=>{
                            const S = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${f}][handleMediaAnswer] error: ${getPrintableObject(S)}`), this.signalingSession.disposed || this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ANSWER_FAILED, {
                                causeId: f
                            });
                        }), this.signalingSessionCallback.onAnswer(v, f);
                    }, this.handleMediaNegotiationOffer = (g)=>{
                        const f = g.body, S = g.headers, v = extractCauseIdFromMessage(g);
                        this.logger.info(`[${v}][handleMediaNegotiationOffer]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_MEDIA_OFFER, g);
                        const _ = isDuplicateMessage(S, this.renegotiationOffersSeenSoFar);
                        switch(this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE, v), this.raiseMediaRenegotiationOffer(f, v);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION, v), this.raiseMediaRenegotiationOffer(f, v);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:
                                if (this.signalingSession && this.signalingSession.signalingAgentConfig && this.signalingSession.signalingAgentConfig.supportMediaRetargetWhileIncomingRenegotiation) {
                                    this.raiseMediaRenegotiationOffer(f, v);
                                    break;
                                }
                                this.rejectAndLog(v, _, f);
                                break;
                            default:
                                this.rejectAndLog(v, _, f);
                        }
                    }, this.rejectRenegotiationAsync = (g, f)=>{
                        this.logger.info(`[${f}][rejectRenegotiationAsync]`), this.signalingSession.telemetryHelper.recordEvent(cn.REJECT_RENEGOTIATION, {
                            rejectionData: g,
                            causeId: f
                        }), assertNotNullOrEmpty(this.links[an.LINKS.MEDIA_REJECTION], "MediaRejection link not set");
                        const S = g || {
                            code: an.CALL_END_CODE.NOT_ACCEPTABLE_HERE,
                            subCode: an.CALL_END_SUB_CODE.MEDIA_ANSWER_PROCESSING_ERROR,
                            phrase: an.CALL_END_PHRASE.MEDIA_ANSWER_ERROR
                        };
                        switch(this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION:
                                return this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, f), this.rejectMediaRenegotiation(this.links[an.LINKS.MEDIA_REJECTION], S, f);
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                return this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION, f), this.rejectMediaRenegotiation(this.links[an.LINKS.MEDIA_REJECTION], S, f);
                            default:
                                return this.logger.error(`[${f}][rejectRenegotiationAsync][failed] There is no incoming media renegotiation offer to reject`), Promise.resolve(null);
                        }
                    }, this.handleRetargetCompleted = (g)=>{
                        const f = g.body.retargetCompleted, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleRetargetCompleted][details=${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_RETARGET_COMPLETED, g, getPIISafeObject(f)), 0 === f.code ? this.signalingSessionCallback.onReTargetCompletedSuccess(S) : this.signalingSessionCallback.onReTargetCompletedFailure(f, S);
                    }, this.dispose = ()=>{
                        this.logger.info("mediaRenegotiationManager :: dispose"), this.disposed = !0;
                    }, this.getGlareError = ()=>({
                            code: an.CALL_END_CODE.GLARE_ERROR,
                            subCode: an.CALL_END_SUB_CODE.MEDIA_GLARE_ERROR,
                            phrase: an.CALL_END_PHRASE.RENEGOTIATION_IN_PROGRESS,
                            previousNegotiationCauseId: this.fsmStateCauseId
                        }), this.handleMediaNegotiationFailureInternal = (g, f, S)=>{
                        switch(this.logger.info(`[${S}][handleMediaNegotiationFailureInternal][failureData=${getPIISafeObject(g)}]`), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MEDIA_ANSWER), this.fsmState){
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.OUTGOING_RENEGOTIATION:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.CALL_CONNECTED, S);
                                break;
                            case an.MEDIA_RENEGOTIATION_FSM_STATE.RENEGOTIATION_GLARE:
                                this.setFsmState(an.MEDIA_RENEGOTIATION_FSM_STATE.INCOMING_RENEGOTIATION, S);
                                break;
                            default:
                                return;
                        }
                        this.vbssInitiated && (this.vbssInitiated = !1, this.signalingSession.telemetryHelper.addVbssOperations(un.VBSS_OPERATION.REJECTED)), this.signalingSession.telemetryHelper.addIncomingModalities([
                            "Rejected"
                        ]), this.signalingSessionCallback.onMediaRenegotiationRejection({
                            code: g.code,
                            subCode: g.subCode,
                            phrase: g.phrase
                        }, S);
                    }, this.signalingSession = g, this.signalingSessionCallback = f, this.logger = g.logger.createChild(()=>`[RenegotiationManager][${this.fsmState}][stateCauseId=${this.fsmStateCauseId}]`);
                }
            }, $n = class {
                clear(g, f) {
                    const S = f || {
                        code: an.CALL_END_CODE.SUCCESS,
                        subCode: an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: an.CALL_END_PHRASE.LOCAL_USER_INITIATED
                    };
                    Object.keys(this.requests).forEach((f)=>{
                        this.rejectOperation(f, g, S);
                    });
                }
                hasOperation(g) {
                    return this.requests.hasOwnProperty(g);
                }
                getAllOperations() {
                    return this.requests;
                }
                getOperation(g) {
                    return this.hasOperation(g) ? this.requests[g] : null;
                }
                setOperation(g, f) {
                    return !this.hasOperation(g) && (this.requests[g] = f, !0);
                }
                rejectOperation(g, f, S) {
                    const v = new Error(f);
                    if (S && (v.endCode = S), this.hasOperation(g)) {
                        const f = this.requests[g].promise;
                        delete this.requests[g], f.reject(v);
                    }
                }
                resolveOperation(g, f) {
                    if (this.hasOperation(g)) {
                        const S = this.requests[g].promise;
                        delete this.requests[g], S.resolve(f);
                    }
                }
                constructor(){
                    this.requests = {};
                }
            }, jn = class {
                dispose(g, f, S) {
                    this.logger.info(`[${S}][dispose]`), this.rejectAllPendingOperations(g, f);
                }
                getAllPendingOperations(g, f) {
                    this.logger.info(`[${f}][getAllPendingOperations] ${g}`);
                    const S = this.getOperationTable(g);
                    return S ? S.getAllOperations() : null;
                }
                getPendingOperation(g, f, S) {
                    this.logger.info(`[${S}][getPendingOperation] ${g} ${f}`);
                    const v = this.getOperationTable(g);
                    return v ? v.getOperation(f) : null;
                }
                getRnlMri(g, f) {
                    this.logger.info(`[${f}][getRnlMri] ${g}`);
                    for (const f of g)if (this.participantIdMriMap.has(f)) return this.participantIdMriMap.get(f);
                    return "";
                }
                hasPendingOperation(g, f, S) {
                    this.logger.info(`[${S}][hasPendingOperation] ${g} ${scrubMriOrOmit(f)}`);
                    const v = this.getOperationTable(g);
                    return !!v && v.hasOperation(f);
                }
                rejectPendingOperation(g, f, S, v, _) {
                    this.logger.info(`[${_}][rejectPendingOperation] ${g} ${scrubMriOrOmit(f)} reason: ${S}`);
                    const C = this.getOperationTable(g);
                    C && C.rejectOperation(f, S, v);
                }
                resolvePendingOperation(g, f, S, v) {
                    this.logger.info(`[${v}][resolvePendingOperation]: ${scrubMriOrOmit(f)}`);
                    const _ = this.getOperationTable(g);
                    _ && _.resolveOperation(f, S);
                }
                setPendingOperation(g, f, S, v) {
                    this.logger.info(`[${v}][setPendingOperation] ${g} ${scrubMriOrOmit(f)} value: ${S}`);
                    const _ = this.getOperationTable(g);
                    if (!_) return !1;
                    if (0 === g) {
                        const g = S && S.participant && S.participant.participantId;
                        g && this.participantIdMriMap.set(g, f);
                    }
                    return _.setOperation(f, S);
                }
                setParticipantIdToMriMapping(g, f, S, v) {
                    v ? (this.logger.info(`[${S}][setParticipantIdMriMap] ${mriOrId(g)}: ${scrubMriOrOmit(f)} clear mapping.`), this.participantIdMriMap.delete(g)) : g && f && (this.logger.info(`[${S}][setParticipantIdMriMap] ${mriOrId(g)}: ${scrubMriOrOmit(f)}`), this.participantIdMriMap.set(g, f));
                }
                getOperationTable(g) {
                    switch(g){
                        case 0:
                            return this.localAddParticipantRequests;
                        case 1:
                            return this.localAdmitParticipantRequests;
                        case 2:
                            return this.localCallMeBackRequests;
                        case 4:
                            return this.localRemoveParticipantEndpointRequests;
                        case 3:
                            return this.localRemoveParticipantRequests;
                        case 5:
                            return this.localUpdateParticipantInterpretationStateRequest;
                        default:
                            return null;
                    }
                }
                rejectAllPendingOperations(g, f) {
                    this.logger.info("rejectLocalQueuedOperations"), this.localAddParticipantRequests.clear(g, f), this.localAdmitParticipantRequests.clear(g, f), this.localCallMeBackRequests.clear(g, f), this.localRemoveParticipantRequests.clear(g, f), this.localRemoveParticipantEndpointRequests.clear(g, f), this.localUpdateParticipantInterpretationStateRequest.clear(g, f);
                }
                constructor(g){
                    this.logger = g, this.localAddParticipantRequests = new $n, this.localAdmitParticipantRequests = new $n, this.localCallMeBackRequests = new $n, this.localRemoveParticipantEndpointRequests = new $n, this.localRemoveParticipantRequests = new $n, this.localUpdateParticipantInterpretationStateRequest = new $n, this.participantIdMriMap = new Map;
                }
            };
            function getPayload11(g, f, S, v) {
                assertNotNull(g, "signalingSession cannot be null");
                const _ = S.groupId ? {
                    id: S.groupId
                } : null, C = S.threadId ? {
                    threadId: S.threadId,
                    messageId: S.messageId || null
                } : null;
                let E = [], T = {};
                f && f.length > 0 ? (E = f.map((f)=>({
                        id: f.nonMaskedId ? f.nonMaskedId : f.id,
                        assertedId: f.assertedId,
                        displayName: f.displayName,
                        participantId: f.participantId,
                        replacementDetails: 3 === S.replacementType ? g.getReplacementDetailsByParticipantLegOfCall(S.callIdToReplace, f.id, f.replacementParticipantId) : void 0
                    })), T = {
                    addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                    addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE)
                }) : T = {
                    addModalitySuccess: get2(g, nn.CONV_ADD_MODALITY_SUCCESS),
                    addModalityFailure: get2(g, nn.CONV_ADD_MODALITY_FAILURE)
                };
                const I = {
                    payload: {
                        disableUnmute: S && S.disableUnmute,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            to: E
                        },
                        participantInvitationData: getParticipantInvitationData(S),
                        replacementDetails: 3 === S.replacementType ? void 0 : v,
                        groupContext: _,
                        groupChat: C,
                        links: T
                    }
                };
                return S && S.alternateId && (I.payload.participants.from.alternateId = S.alternateId), (S === null || S === void 0 ? void 0 : S.callingLineIdentity) && (I.payload.participants.from.callingLineIdentity = S.callingLineIdentity), (S === null || S === void 0 ? void 0 : S.clientScenario) && (I.payload.debugContent = {
                    clientScenario: S.clientScenario
                }), I;
            }
            function getPayload12(g, f, S, v) {
                assertNotNull(g, "signalingSession cannot be null");
                const _ = f.map((g)=>(assertNotNull(g, "remoteParticipant cannot be null"), {
                        id: g.id,
                        assertedId: g.assertedId,
                        displayName: g.displayName,
                        participantId: g.participantId
                    }));
                return {
                    payload: {
                        disableUnmute: S && S.disableUnmute,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId,
                                alternateId: S ? S.alternateId : null,
                                callingLineIdentity: S ? S.callingLineIdentity : null
                            },
                            to: _
                        },
                        participantInvitationData: getParticipantInvitationData(S),
                        replacementDetails: v,
                        links: {
                            addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                            addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE)
                        },
                        debugContent: {
                            clientScenario: S.clientScenario
                        }
                    }
                };
            }
            function getPayload13(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "remoteParticipant cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            to: [
                                {
                                    id: f.id,
                                    displayName: f.displayName
                                }
                            ]
                        },
                        links: {
                            admitFailure: get2(g, nn.CONV_ADMIT_PARTICIPANT_FAILURE),
                            admitSuccess: get2(g, nn.CONV_ADMIT_PARTICIPANT_SUCCESS)
                        },
                        debugContent: {
                            causeId: S
                        }
                    }
                };
            }
            function getPayload14(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        mediaTypes: [
                            "audio"
                        ]
                    }
                };
            }
            function getPayload15(g, f, S, v = !1, _ = null) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "muteScope be null"), assertNotNull(S, "participantList cannot be null");
                const C = {
                    from: {
                        id: g.participantManager.localParticipant.id,
                        displayName: g.participantManager.localParticipant.displayName,
                        endpointId: g.participantManager.localParticipant.endpointId,
                        participantId: g.participantManager.localParticipant.participantId,
                        languageId: g.participantManager.localParticipant.languageId
                    },
                    scope: f,
                    muteParticipants: S,
                    mediaTypes: [
                        "audio"
                    ]
                };
                return v && (C.links = {
                    clientCallback: get2(g, nn.MUTE_UNMUTE_ASYNC, _)
                }, C.operationId = _), {
                    payload: C
                };
            }
            function getPayload16(g, f, S, v, _, C) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "participantsIds cannot be null");
                const E = g.groupId ? {
                    id: g.groupId
                } : null, T = v ? {
                    threadId: v,
                    messageId: _ || null
                } : null, I = [];
                return f.forEach((g)=>{
                    const f = {
                        id: g
                    };
                    I.push(f);
                }), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            invitationType: an.INVITATION_TYPE.NUDGE,
                            to: I
                        },
                        participantInvitationData: C,
                        groupContext: E,
                        groupChat: T,
                        links: {
                            nudgeParticipantSuccess: get2(g, nn.CONV_NUDGE_PARTICIPANT_SUCCESS),
                            nudgeParticipantFailure: get2(g, nn.CONV_NUDGE_PARTICIPANT_FAILURE)
                        }
                    }
                };
            }
            function getPayload17(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "participantsIds cannot be null");
                const v = [];
                return f.forEach((g)=>{
                    const f = {
                        id: g
                    };
                    v.push(f);
                }), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            invitationType: an.INVITATION_TYPE.NUDGE,
                            to: v
                        },
                        participantInvitationData: S,
                        links: {
                            nudgeParticipantSuccess: get2(g, nn.CONV_NUDGE_PARTICIPANT_SUCCESS),
                            nudgeParticipantFailure: get2(g, nn.CONV_NUDGE_PARTICIPANT_FAILURE),
                            addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                            addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE)
                        }
                    }
                };
            }
            function getPayload18(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f), {
                    payload: {
                        transactionEnd: f
                    }
                };
            }
            function getPayload19(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "remoteParticipant cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            scope: S,
                            toEndpoints: [
                                {
                                    id: f.id,
                                    endpointId: f.endpointId
                                }
                            ]
                        },
                        links: {
                            removeParticipantSuccess: get2(g, nn.CONV_REMOVE_PARTICIPANT_SUCCESS),
                            removeParticipantFailure: get2(g, nn.CONV_REMOVE_PARTICIPANT_FAILURE)
                        }
                    }
                };
            }
            function getPayload20(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "remoteParticipant cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            to: [
                                {
                                    id: f.id,
                                    displayName: f.displayName
                                }
                            ]
                        },
                        links: {
                            removeParticipantSuccess: get2(g, nn.CONV_REMOVE_PARTICIPANT_SUCCESS),
                            removeParticipantFailure: get2(g, nn.CONV_REMOVE_PARTICIPANT_FAILURE)
                        }
                    }
                };
            }
            function getPayload21(g, f = !1, S = null) {
                assertNotNull(g, "signalingSession cannot be null");
                const v = {
                    from: {
                        id: g.participantManager.localParticipant.id,
                        displayName: g.participantManager.localParticipant.displayName,
                        endpointId: g.participantManager.localParticipant.endpointId,
                        participantId: g.participantManager.localParticipant.participantId,
                        languageId: g.participantManager.localParticipant.languageId
                    },
                    mediaTypes: [
                        "audio"
                    ]
                };
                return f && (v.links = {
                    clientCallback: get2(g, nn.MUTE_UNMUTE_ASYNC, S)
                }, v.operationId = S), {
                    payload: v
                };
            }
            function getPayload22(g, f, S, v = "") {
                assertNotNull(S && "specified" === S, "Only non-null non-empty scope of 'specified' is supported."), assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "participantsIds cannot be null");
                const _ = [];
                return f.forEach((g)=>{
                    const f = {
                        id: g,
                        meetingRole: v
                    };
                    _.push(f);
                }), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        scope: S,
                        to: _
                    }
                };
            }
            function getUpdateParticipantInterpretationStatePayload(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "options cannot be null");
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id
                        },
                        to: f,
                        links: {
                            updateParticipantInterpretationStateStatus: get2(g, nn.UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS)
                        },
                        operationId: S
                    }
                };
            }
            var Gn = __toESM(P), qn = class {
                recordTelemetry(g, f, S) {
                    const v = {
                        participantCountInLastRoster: Object.keys(g.participants || 0).length,
                        participantCountInFirstRoster: this.participantCountInFirstRoster,
                        sequenceNumberOfLastRoster: this.lastRosterUpdateSeqNumber,
                        sequenceNumberOfLastFullRoster: this.lastFullRosterSeqNumber,
                        sequenceNumberOfFirstRoster: this.firstRosterUpdateSeqNumber,
                        rosterType: g.type,
                        isFullRoster: f,
                        maxConcurrentParticipantsDuringLeg: this.maxConcurrentParticipantsDuringLeg,
                        totalParticipantsDuringLifetimeOfLeg: this.tombstoneSequence.size + this.latestRosterVersionForActiveParticipants.size,
                        countOfMissingNotifications: this.getMissingNotificiations()
                    };
                    this.logger.info(`[recordTelemetry] data ${JSON.stringify(v, null, 4)}`), this.participantManager.signalingSession.telemetryHelper.recordRosterEvent(v, cn.HANDLE_ROSTER_UPDATE, S);
                }
                getMissingNotificiations() {
                    const g = this.lastRosterUpdateSeqNumber - this.firstRosterUpdateSeqNumber + 1 - this.rostersInLifetime.size;
                    return g > 0 ? g : 0;
                }
                isParticipantRosterStale(g, f) {
                    if (this.logger.info(`[isParticipantRosterStale], rosterParticipantVersion ${f}`), f) {
                        if (this.tombstoneSequence.has(g)) return f <= this.tombstoneSequence.get(g);
                        if (this.latestRosterVersionForActiveParticipants.has(g)) return f <= this.latestRosterVersionForActiveParticipants.get(g);
                    }
                    return !1;
                }
                handleDeltaRoster(g, f, S, v) {
                    if (this.logger.info(`[${v}][handleDeltaRoster] isFullRoster ${f}`), this.isRosterStaleFromFull(g, v)) return this.participantManager.signalingSession.telemetryHelper.recordEvent(cn.IGNORE_OLD_ROSTER, {
                        lastRosterUpdateSeqNumber: this.lastRosterUpdateSeqNumber,
                        lastFullRosterSeqNumber: this.lastFullRosterSeqNumber,
                        sequenceNumber: g.sequenceNumber,
                        causeId: v
                    }), void this.logger.info(`[${v}][handleRosterUpdate] Ignoring old roster update: received ${g.sequenceNumber}, but already handled full roster ${this.lastFullRosterSeqNumber}`);
                    if (f) {
                        for (const f of Object.keys(S))if (!g.participants.hasOwnProperty(f) && !this.isParticipantRosterStale(f, g.sequenceNumber)) {
                            const _ = new ln({
                                id: f
                            });
                            this.logger.info(`[${v}][handleRosterUpdate] participant missing from delta, full roster`), this.handleRemovedDeltaRosterParticipant(_, g.sequenceNumber, S, v);
                        }
                        this.lastFullRosterSeqNumber = g.sequenceNumber;
                    } else if (!(g === null || g === void 0 ? void 0 : g.participants)) return void this.logger.warn(`[${v}][handleRosterUpdate] participants blob empty in delta roster`);
                    for (const f of Object.keys(g.participants)){
                        const _ = g.participants[f];
                        if (!this.isParticipantRosterStale(f, _.version)) {
                            let g = ln.fromRoster(_);
                            _.state && "active" === _.state ? (this.logger.info(`[${v}][handleDeltaRoster] participant active`), this.handleRosterParticipant(g, S, v), this.tombstoneSequence.has(f) && this.tombstoneSequence.delete(f), this.latestRosterVersionForActiveParticipants.set(f, _.version)) : _.state && "inactive" === _.state ? (g = g || new ln({
                                id: _.details.id
                            }), this.logger.info(`[${v}][handleDeltaRoster] participant inactive`), this.handleRemovedDeltaRosterParticipant(g, _.version, S, v)) : this.logger.info(`[${v}][handleDeltaRoster] unexpected participant state ${_.state}`);
                        }
                    }
                    this.handleRemoveParticipantRequests(this.getActiveParticipants(g.participants), v);
                }
                getRnlMri(g, f) {
                    const S = this.participantManager.participantOperationHandler;
                    if (g) {
                        const v = this.getRnlParticipantIdsFromRoster(g, f);
                        return S.getRnlMri(v, f);
                    }
                    return "";
                }
                handleRemovedDeltaRosterParticipant(g, f, S, v) {
                    const _ = g.id, C = this.getRnlMri(g, v);
                    let E = "";
                    S.hasOwnProperty(_) ? E = _ : S.hasOwnProperty(C) && (E = C), E && this.handleRemovedParticipant(S, E, v), this.tombstoneSequence.set(_, f), this.latestRosterVersionForActiveParticipants.has(_) && this.latestRosterVersionForActiveParticipants.delete(_);
                }
                handleRemovedParticipant(g, f, S) {
                    const v = this.participantManager.signalingSessionCallback, _ = this.participantManager.signalingSession;
                    !1 !== g[f] && (tryRemoveKeyFromHashTable(this.participantManager.connectedRemoteParticipantIds, f), this.logger.info(`[${S}][handleRemovedParticipant] ${scrubMriOrOmit(f)} removed from roster`), v.onParticipantRemoved({
                        id: f
                    }, S), _.clearParticipantCallLinks(f));
                }
                getActiveParticipants(g) {
                    const f = {};
                    for (const S of Object.keys(g))"inactive" !== g[S].state && (f[S] = g[S]);
                    return f;
                }
                handleRosterParticipant(g, f, S) {
                    if (!g) return void this.logger.info(`[handleRosterParticipant][${S}] rosterParticipant processing skipped because null.`);
                    if (g.id === this.participantManager.localParticipant.id) {
                        this.updateLocalParticipant(g, S);
                        const f = this.getLocalEndpoint(), v = !(!(f === null || f === void 0 ? void 0 : f.stream) && !(f === null || f === void 0 ? void 0 : f.streamLobby)), _ = 0 === this.participantManager.signalingSession.callMode;
                        return this.logger.info(`[handleRosterParticipant][${S}] isStreaming:${v} isInitialMode:${_}`), void (v && _ ? this.participantManager.signalingSession.configureStreamingMode(S) : v || this.participantManager.signalingSession.setRealTimeState(1, S));
                    }
                    const v = this.participantManager.participantOperationHandler, _ = this.participantManager.signalingSession, C = this.participantManager.signalingSessionCallback, E = g.id, T = this.getRnlMri(g, S), I = this.getRnlParticipantIdsFromRoster(g, S);
                    _.remoteCaller && -1 !== I.indexOf(_.remoteCaller.participantId) && (g.displayName = _.remoteCaller.displayName), tryAddNewKeyToHashTable(this.participantManager.connectedRemoteParticipantIds, g.id, !0);
                    const b = f.hasOwnProperty(g.id), A = f.hasOwnProperty(T);
                    (b || A) && (f[g.id] = !1), v.hasPendingOperation(0, g.id, S) && this.isParticipantInCall(g) ? (this.logger.info(`participant ${scrubMriOrOmit(g.id)} appears in roster. Resolving AddParticipant request`), _.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, g.id), v.resolvePendingOperation(0, g.id, g, S)) : T && v.hasPendingOperation(0, T, S) && this.isParticipantInCall(g) ? (this.logger.info(`RNL participant ${scrubMriOrOmit(T)} appears in roster. Resolving AddParticipant request`), _.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, T), v.resolvePendingOperation(0, T, g, S)) : v.hasPendingOperation(1, g.id, S) && this.isParticipantInCall(g) && (this.logger.info(`participant: ${scrubMriOrOmit(g.id)} appears in roster. Resolving AdmitParticipant request`), _.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, g.id), v.resolvePendingOperation(1, g.id, g, S));
                    for (const f of g.endpointDetails)v.hasPendingOperation(0, f.participantId, S) && this.isParticipantInCall(g) && (this.logger.info(`participant ${scrubMriOrOmit(g.id)} appears in roster. Resolving AddParticipant request`), _.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, f.participantId), v.resolvePendingOperation(0, f.participantId, g, S));
                    b ? (this.logger.info(`participantIds=[${I}] updated ${scrubMriOrOmit(g.id)}`), C.onParticipantUpdated(g, S), _.setParticipantCallLinks(g)) : A ? (this.logger.info(`RNL participant participantIds=[${I}] removed old ${scrubMriOrOmit(T)} and added new ${scrubMriOrOmit(E)}`), C.onParticipantRemoved({
                        id: T
                    }, S, !0), _.clearParticipantCallLinks(T), C.onParticipantJoined(g, S), _.setParticipantCallLinks(g)) : v.hasPendingOperation(3, g.id, S) ? this.logger.info(`participantIds=[${I}] ignored ${scrubMriOrOmit(g.id)}`) : (this.logger.info(`participantIds=[${I}] joined ${scrubMriOrOmit(g.id)}`), C.onParticipantJoined(g, S), _.setParticipantCallLinks(g));
                }
                getLocalEndpoint() {
                    return Gn.find(this.participantManager.localParticipant.endpointDetails, (g)=>this.participantManager.localParticipant.endpointId === g.endpointId);
                }
                getRnlParticipantIdsFromRoster(g, f) {
                    const S = [];
                    for (const f of g.endpointDetails)S.push(f.participantId);
                    return this.logger.info(`[${f}][getRnlParticipantIdsFromRoster] ${JSON.stringify(S)}`), S;
                }
                isParticipantInCall(g) {
                    var _g_endpointDetails;
                    return ((_g_endpointDetails = g.endpointDetails) === null || _g_endpointDetails === void 0 ? void 0 : _g_endpointDetails[0]) && !g.endpointDetails[0].isLobby;
                }
                updateLocalParticipant(g, f) {
                    const S = this.participantManager.localParticipant, v = this.participantManager.signalingSession, _ = this.participantManager.signalingSessionCallback;
                    v.setParticipantCallLinks(g), this.logger.info(`[${f}][updateLocalParticipant]`);
                    let C = !1;
                    if (g === null || g === void 0 ? void 0 : g.endpointDetails) {
                        const E = Gn.find(g.endpointDetails, (g)=>S.endpointId === g.endpointId), T = Gn.find(S.endpointDetails, (g)=>S.endpointId === g.endpointId);
                        C = hasStagingGroup(E), (E === null || E === void 0 ? void 0 : E.isLobby) && !(T === null || T === void 0 ? void 0 : T.isLobby) ? v.telemetryHelper.recordEvent(cn.IN_LOBBY, {
                            causeId: f
                        }) : !E || E.isLobby || T && !T.isLobby || (C ? v.telemetryHelper.recordEvent(cn.STAGING, {
                            causeId: f
                        }) : v.telemetryHelper.recordEvent(cn.CONNECTED, {
                            causeId: f
                        })), (E === null || E === void 0 ? void 0 : E.broadcastMeetingRole) && S && S.broadcastMeetingRole !== E.broadcastMeetingRole && (S.broadcastMeetingRole = E.broadcastMeetingRole, v.telemetryHelper.setBroadcastMeetingRole(E.broadcastMeetingRole)), _.onMeetingGroupDetailsUpdated(E === null || E === void 0 ? void 0 : E.meetingGroupDetails, f);
                    }
                    if ((g === null || g === void 0 ? void 0 : g.meetingRole) && v.telemetryHelper.setMeetingRole(g.meetingRole), (g === null || g === void 0 ? void 0 : g.advancedMeetingRole) && v.telemetryHelper.setAdvancedMeetingRole(g.advancedMeetingRole), (g === null || g === void 0 ? void 0 : g.meetingRoles) && v.telemetryHelper.setMeetingRoles(g.meetingRoles), (g === null || g === void 0 ? void 0 : g.participantType) && v.telemetryHelper.setParticipantType(g.participantType), g && (S.endpointDetails = g.endpointDetails || [], S.acceptedBy = g.acceptedBy, S.role = g.role, S.meetingRole = g.meetingRole, S.advancedMeetingRole = g.advancedMeetingRole, S.meetingRoles = g.meetingRoles, S.participantType = g.participantType, S.tenantId = g.tenantId, S.isLobby = g.isLobby, S.publishedStates = g.publishedStates, S.isStaging = C, S.version = g.version, S.propertyBag = g.propertyBag, S.isIdentityMasked = g.isIdentityMasked, S.maskedIdSeqNumber = g.maskedIdSeqNumber, S.maskedId = g.maskedId, void 0 !== (g === null || g === void 0 ? void 0 : g.joinAsStreamingUser) && (S.joinAsStreamingUser = g.joinAsStreamingUser), void 0 !== (g === null || g === void 0 ? void 0 : g.enableCaptcha) && (S.enableCaptcha = g.enableCaptcha), void 0 !== (g === null || g === void 0 ? void 0 : g.otpIdentity) && (S.otpIdentity = g.otpIdentity), this.participantManager.localParticipant.fromRoster = !0, _.onSelfParticipantUpdated(S, f)), this.isParticipantInCall(g)) {
                        const S = this.participantManager.participantOperationHandler, _ = this.getRnlMri(g, f);
                        _ && S.hasPendingOperation(0, _, f) && (this.logger.info(`RNL participant ${scrubMriOrOmit(_)} appears in roster. Resolving AddParticipant request`), v.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, _), S.resolvePendingOperation(0, _, g, f));
                    }
                }
                checkForRemovedParticipants(g, f, S) {
                    const v = this.participantManager.signalingSessionCallback, _ = this.participantManager.signalingSession, C = this.participantManager.participantOperationHandler;
                    this.logger.info(`[${S}][checkForRemovedParticipants]`);
                    for (const f of Object.keys(g))g.hasOwnProperty(f) && !1 !== g[f] && !C.hasPendingOperation(0, f, S) && (tryRemoveKeyFromHashTable(this.participantManager.connectedRemoteParticipantIds, f), this.logger.info(`[${S}][checkForRemovedParticipants] ${scrubMriOrOmit(f)} removed from roster`), v.onParticipantRemoved({
                        id: f
                    }, S), _.clearParticipantCallLinks(f));
                    this.handleRemoveParticipantRequests(f, S);
                }
                handleRemoveParticipantRequests(g, f) {
                    const S = this.participantManager.signalingSession, v = this.participantManager.participantOperationHandler;
                    this.logger.info(`handleRemoveParticipantRequests [${f}] dynamicRosterParticipants`);
                    const _ = [];
                    Object.keys(g).forEach((f)=>{
                        const S = ln.fromRoster(g[f]);
                        S && S.endpointDetails && S.endpointDetails.forEach((g)=>{
                            g.originalId && _.push(g.originalId);
                        });
                    });
                    const C = v.getAllPendingOperations(3, f);
                    for (const E of Object.keys(C))-1 !== _.indexOf(E) || g.hasOwnProperty(E) || (this.logger.info(`[${f}][handleRemoveParticipantRequests] ${scrubMriOrOmit(E)} no longer appears in roster. Resolving RemoveParticipant request`), tryRemoveKeyFromHashTable(this.participantManager.connectedRemoteParticipantIds, E), S.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, E), v.resolvePendingOperation(3, E, {
                        id: E
                    }, f));
                }
                constructor(g, f){
                    this.participantManager = g, this.logger = f, this.handleRosterUpdate = (g, f, S, v)=>{
                        if ("Delta" === g.type || "MultiPartyEndpoint" === g.type) {
                            if (void 0 === g.sequenceNumber && (g.sequenceNumber = this.lastRosterUpdateSeqNumber), this.logger.info(`[${v}][handleRosterUpdate][sequenceNumber=${g.sequenceNumber}]`), this.rostersInLifetime.add(g.sequenceNumber), "Delta" === g.type) this.logger.info(`[${v}][handleRosterUpdate], RosterType: Delta, isFullRoster: ${S}`), this.handleDeltaRoster(g, S, f, v);
                            else {
                                if (this.logger.info(`[${v}][handleRosterUpdate], RosterType: MultiPartyEndpoint`), this.isRosterStale(g, v)) return this.participantManager.signalingSession.telemetryHelper.recordEvent(cn.IGNORE_OLD_ROSTER, {
                                    lastRosterUpdateSeqNumber: this.lastRosterUpdateSeqNumber,
                                    sequenceNumber: g.sequenceNumber,
                                    causeId: v
                                }), void this.logger.info(`[${v}][handleRosterUpdate] Ignoring old roster update: received ${g.sequenceNumber}, but already handled ${this.lastRosterUpdateSeqNumber}`);
                                for (const S of Object.keys(g.participants)){
                                    const _ = ln.fromRoster(g.participants[S]);
                                    this.handleRosterParticipant(_, f, v);
                                }
                                this.checkForRemovedParticipants(f, g.participants, v), this.participantManager.signalingSessionCallback.onParticipantCountsUpdated(g.participantCounts, v);
                            }
                            if (g.sequenceNumber > this.lastRosterUpdateSeqNumber) {
                                this.participantManager.signalingSessionCallback.onParticipantCountsUpdated(g.participantCounts, v), this.lastRosterUpdateSeqNumber = g.sequenceNumber, this.firstRosterUpdateSeqNumber < 0 && (this.firstRosterUpdateSeqNumber = this.lastRosterUpdateSeqNumber);
                                const f = Object.keys(g.participants || 0).length;
                                this.participantCountInFirstRoster < 0 && (this.participantCountInFirstRoster = f), this.maxConcurrentParticipantsDuringLeg = Math.max(this.maxConcurrentParticipantsDuringLeg, f);
                            }
                            this.recordTelemetry(g, S, v), this.participantManager.signalingSessionCallback.onRosterHandlingComplete();
                        } else this.logger.warn(`[${v}][handleRosterUpdate][sequenceNumber=${g.sequenceNumber}] invalid roster type ${g.type}`);
                    }, this.isRosterStaleFromFull = (g, f)=>(this.logger.info(`[${f}][isRosterStale] ${g.sequenceNumber < this.lastFullRosterSeqNumber}`), g.sequenceNumber < this.lastFullRosterSeqNumber), this.isRosterStale = (g, f)=>(this.logger.info(`[${f}][isRosterStale] ${g.sequenceNumber < this.lastRosterUpdateSeqNumber}`), g.sequenceNumber < this.lastRosterUpdateSeqNumber), this.updateLocalParticipantFromSubscribe = (g, f)=>{
                        this.logger.info(`[${f}][updateLocalParticipantFromSubscribe]`), this.updateLocalParticipant(g, f);
                    }, this.handleParticipantAcceptedBy = (g, f, S)=>{
                        const v = f.hasOwnProperty(g.id), _ = g.id === g.acceptedBy.id;
                        this.logger.info(`[${S}][RosterManager::handleParticipantAcceptedBy] oldParticipantInRoster: ${v}`);
                        this.participantManager.participantOperationHandler.setParticipantIdToMriMapping(g.participantId, g.id, S, !0), v && !_ && this.handleRemovedDeltaRosterParticipant(new ln({
                            id: g.id
                        }), this.lastRosterUpdateSeqNumber, f, S);
                    }, this.lastRosterUpdateSeqNumber = -1, this.lastFullRosterSeqNumber = -1, this.firstRosterUpdateSeqNumber = -1, this.tombstoneSequence = new Map, this.latestRosterVersionForActiveParticipants = new Map, this.rostersInLifetime = new Set, this.maxConcurrentParticipantsDuringLeg = -1, this.participantCountInFirstRoster = -1;
                }
            }, Wn = class {
                handleUpdateParticipantInterpretationStateCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.operationId;
                    if (this.disposed) return void this.logger.info(`[${S}][handleUpdateParticipantInterpretationStateCompletion] ignored. Call disposed.`);
                    v || this.logger.warn(`[${S}][handleUpdateParticipantInterpretationStateCompletion] operationId is undefined.`), this.logger.info(`[${S}][handleUpdateParticipantInterpretationStateCompletion] starts`);
                    const _ = g.body;
                    if (_.participantInfos) {
                        for (const f of _.participantInfos)if (this.logger.info(f), this.participantOperationHandler.hasPendingOperation(5, f.participant.id, S)) {
                            if (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION, f.participant.id), f.transactionEnd.code === an.TRANSACTION_END_CODE.SUCCESS) this.logger.info(`[${S}]Update participant interpretation state succeeded for: ${this.piiUtils.scrubMriOrOmit(f.participant.id)}`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_COMPLETED, g), this.participantOperationHandler.resolvePendingOperation(5, f.participant.id, void 0, S);
                            else {
                                const v = f.transactionEnd.reason;
                                this.logger.info(`[${S}]Update participant interpretation state failed for: ${this.piiUtils.scrubMriOrOmit(f.participant.id)} reason : ${getPrintableObject(v)}`);
                                const _ = this.getCallEndGivenParticipantFailure(v);
                                this.signalingSession.telemetryHelper.recordIncomingEvent(cn.UPDATE_PARTICIPANT_INTERPRETATION_STATE_RESPONSE_FAILED, g, _), this.participantOperationHandler.rejectPendingOperation(5, f.participant.id, _.phrase, _, S);
                            }
                        }
                    }
                }
                setEnableCaptcha(g, f) {
                    this.logger.info(`[${f}][setEnableCaptcha] value:${g}`), this.localParticipant.enableCaptcha = g, this.signalingSessionCallback.onSelfParticipantUpdated(this.localParticipant, f);
                }
                areParticipantsConnectedToCall(g) {
                    this.logger.info(`areParticipantsConnectedToCall : ${getPrintableObject(g)}`);
                    const f = this.getCurrentParticipantsInCallModality(!0);
                    for (const S of g)if (!f.hasOwnProperty(S)) return this.logger.info(`areParticipantsConnectedToCall : returning false for :${this.piiUtils.scrubMriOrOmit(S)}`), {
                        result: !1,
                        participant: S
                    };
                    return this.logger.info("areParticipantsConnectedToCall : returning true"), {
                        result: !0
                    };
                }
                muteUnmute(g, f, S, v, _, C, E = !1) {
                    const T = this.logger.createFnLogger("muteUnmute", _);
                    assert2(2 !== this.signalingSession.callMode, "mute/unmute operations are not allowed in streaming mode"), T.info(`operation=${g}, isAsync=${E}`), v ? (C && this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UNMUTE, ()=>{
                        if (this.signalingSession && !this.signalingSession.disposed) {
                            this.signalingSession.telemetryHelper.recordEvent(cn.UNMUTE_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UNMUTE);
                            const g = new Error("timed out waiting for response to request");
                            g.endCode = {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.UNMUTE_REQUEST_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.UNMUTE_REQUEST_TIMEOUT
                            }, S.reject(g);
                        }
                    }, an.TIMEOUT_VALUES_IN_SECONDS.UNMUTE_TIMEOUT), E && this._asyncMuteUnmuteDefers.set(_, S), this.signalingSession.http.sendPostRequest({
                        url: v,
                        payload: f,
                        requestName: g,
                        withoutTrouter: !0,
                        causeId: _
                    }).then((f)=>{
                        if (!this.disposed) {
                            if (E) T.info(`Inline response received for async operation, operation id: ${_}.`);
                            else {
                                var _f_response;
                                if ((_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.muteUnmuteResponse) {
                                    const v = {
                                        info: f.response.muteUnmuteResponse,
                                        operationId: f.response.operationId
                                    };
                                    switch(g){
                                        case dn.UNMUTE_SYNC.name:
                                        case dn.MUTE_ALL_SYNC.name:
                                        case dn.MUTE_SPECIFIED_SYNC.name:
                                            S.resolve(v);
                                    }
                                }
                                S.resolve();
                            }
                        }
                    }).catch((g)=>{
                        const f = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        T.info(`operation failed, reason=${getPrintableObject(f)}`), this.disposed || (C && this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UNMUTE), S.reject(f.error));
                    })) : S.reject(new Error(`[${_}][muteUnmute] cannot be performed now, the link is not yet available`));
                }
                sendNetworkRequestForUpdatingMeetingRoles(g, f, S, v, _, C) {
                    if (!S) {
                        const g = `[${_}][sendNetworkRequestForUpdatingMeetingRoles] failed because correct updateMeetingRoleUrl is not provided`;
                        new Error(g).endCode = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,
                            phrase: g
                        }, this.logger.info(g), C.reject();
                    }
                    if (!g) {
                        const g = `[${_}][sendNetworkRequestForUpdatingMeetingRoles] failed because participants list is empty or null`, f = new Error(g);
                        f.endCode = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,
                            phrase: g
                        }, this.logger.info(g), C.reject(f);
                    }
                    const onceTrouterReady = ()=>{
                        this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE, ()=>{
                            if (this.signalingSession && !this.signalingSession.disposed) {
                                this.signalingSession.telemetryHelper.recordEvent(cn.UPDATE_MEETING_ROLE, {
                                    causeId: _
                                }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE);
                                const g = new Error(`[${_}] Timed out waiting for response to request`);
                                g.endCode = {
                                    code: an.CALL_END_CODE.TIMEOUT,
                                    subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_TIMEOUT,
                                    phrase: an.CALL_END_PHRASE.UPDATE_MEETING_ROLE_TIMEOUT
                                }, C.reject(g);
                            }
                        }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_ROLE_TIMEOUT);
                    };
                    this.signalingSession.http.sendPostRequest({
                        url: S,
                        payload: getPayload22(this.signalingSession, g, "specified", f),
                        requestName: v,
                        onceTrouterReady: onceTrouterReady,
                        causeId: _
                    }).then((g)=>{
                        C.resolve(g.response);
                    }).catch((g)=>{
                        const f = getPrintableObject(g);
                        this.logger.info(`[${_}][sendNetworkRequestForUpdatingMeetingRoles] failed: ${f}`);
                        const S = new Error(`[${_}][CS response] Forbidden request`), v = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                        S.code = v.error.code, S.subCode = v.error.subCode, S.phrase = v.error.phrase, this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_ROLE), C.reject(S));
                    });
                }
                sendNetworkRequestForNudgingParticipants(g, f, S, v, _, C, E) {
                    if (f) {
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT, ()=>{
                                this.signalingSession && !this.signalingSession.disposed && (this.signalingSession.telemetryHelper.recordEvent(cn.NUDGE_PARTICIPANT_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT, g ? g.join() : ""));
                            }, an.TIMEOUT_VALUES_IN_SECONDS.NUDGE_PARTICIPANT_TIMEOUT, g ? g.join() : "");
                        }, T = C || _ ? getPayload16(this.signalingSession, g, _, C, E, v) : getPayload17(this.signalingSession, g, v);
                        return this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: T,
                            requestName: dn.NUDGE_PARTICIPANT.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: S
                        }).then(()=>{}).catch((f)=>{
                            const v = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            return this.logger.info(`[${S}][sendNetworkRequestForNudgingParticipant][failed][reason=${getPrintableObject(v)}]`), this.disposed || this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.NUDGE_PARTICIPANT, g ? g.join() : ""), Promise.reject(v.error);
                        });
                    }
                    return this.logger.info(`[${S}][sendNetworkRequestForNudgingParticipant] failed because correct nudgeParticipantUrl is not provided`), Promise.reject("Missing nudgeParticipant url");
                }
                sendNetworkRequestForAddingParticipant(g, f, S, v = causeId2()) {
                    if (f) {
                        let _ = dn.ADD_PARTICIPANT.name, C = cn.ADD_PARTICIPANT_TIMEOUT, E = {};
                        switch(S.replacementType){
                            case 2:
                                _ = dn.ADD_PARTICIPANT_WITH_PICKUP_CODE.name, C = cn.ADD_PARTICIPANT_WITH_PICKUP_CODE_TIMEOUT, E.unparkContent = {
                                    pickupCode: S.pickupCode
                                };
                                break;
                            case 1:
                                _ = dn.ADD_PARTICIPANT_WITH_REPLACES.name, C = cn.ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT, E = this.signalingSession.getCallReplacementDetailsForCall(S.callIdToReplace, v);
                                break;
                            case 3:
                                _ = dn.ADD_PARTICIPANT_WITH_REPLACES.name, C = cn.ADD_PARTICIPANT_WITH_REPLACES_TIMEOUT, E = this.signalingSession.getReplacementDetailsByParticipantLegOfCall(S.callIdToReplace, g[0].id, g[0].replacementParticipantId, v);
                                break;
                            default:
                                _ = dn.ADD_PARTICIPANT.name, C = cn.ADD_PARTICIPANT_TIMEOUT, E = null;
                        }
                        const onceTrouterReady = ()=>{
                            g.forEach((g)=>{
                                const f = 3 === S.replacementType ? g.participantId : g.id;
                                this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, ()=>{
                                    this.signalingSession && !this.signalingSession.disposed && (this.signalingSession.telemetryHelper.recordEvent(C, {
                                        causeId: v
                                    }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, f), this.participantOperationHandler.rejectPendingOperation(0, f, "timed out waiting for participant to show up in roster", {
                                        code: an.CALL_END_CODE.TIMEOUT,
                                        subCode: an.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,
                                        phrase: an.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT
                                    }, v));
                                }, an.TIMEOUT_VALUES_IN_SECONDS.ADD_PARTICIPANT_TIMEOUT, f);
                            });
                        }, T = S.threadId || S.groupId ? getPayload11(this.signalingSession, g, S, E) : getPayload12(this.signalingSession, g, S, E);
                        this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: T,
                            requestName: _,
                            onceTrouterReady: onceTrouterReady,
                            causeId: v
                        }).catch((f)=>{
                            const _ = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${v}][sendNetworkRequestForAddingParticipant] failed:${getPrintableObject(f)}`), this.disposed || g.forEach((g)=>{
                                const C = 3 === S.replacementType ? g.participantId : g.id;
                                this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, C), this.participantOperationHandler.rejectPendingOperation(0, C, f, _.error, v);
                            });
                        });
                    } else this.logger.info(`[${v}][sendNetworkRequestForAddingParticipants] failed because correct addParticipantUrl is not provided`), g.forEach((g)=>{
                        const f = 3 === S.replacementType ? g.participantId : g.id;
                        this.participantOperationHandler.rejectPendingOperation(0, f, "correct addParticipantUrl is not provided", {
                            code: an.CALL_END_CODE.LOCAL_ERROR,
                            subCode: an.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,
                            phrase: an.CALL_END_PHRASE.ADD_PARTICIPANT_URL_MISSING
                        }, v);
                    });
                }
                sendNetworkRequestToUpdateParticipantInterpretationState(g, f, S, v = causeId2()) {
                    if (f) {
                        const _ = dn.UPDATE_PARTICIPANT_INTERPRETATION_STATE.name, C = cn.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT, onceTrouterReady = ()=>{
                            const f = {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_TIMEOUT
                            };
                            g.forEach((g)=>{
                                this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION, ()=>{
                                    this.signalingSession && !this.signalingSession.disposed && (this.logger.info(`[${v}][sendNetworkRequestToUpdateParticipantInterpretationState] timed out`), this.signalingSession.telemetryHelper.recordEvent(C, {
                                        causeId: v
                                    }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION, g.id), this.participantOperationHandler.rejectPendingOperation(5, g.id, "timed out waiting to update particiant interpretation state", f, v));
                                }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION_TIMEOUT, g.id);
                            });
                        }, E = getUpdateParticipantInterpretationStatePayload(this.signalingSession, S, v);
                        this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: E,
                            requestName: _,
                            onceTrouterReady: onceTrouterReady,
                            causeId: v
                        }).catch((f)=>{
                            const S = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${v}][sendNetworkRequestToUpdateParticipantInterpretationState] failed:${getPrintableObject(f)}`), this.disposed || g.forEach((g)=>{
                                this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANT_INTERPRETATION_STATE_COMPLETION, g.id), this.participantOperationHandler.rejectPendingOperation(5, g.id, f, S.error, v);
                            });
                        });
                    } else {
                        this.logger.info(`[${v}][sendNetworkRequestToUpdateParticipantInterpretationState] failed because correct updateParticipantUrl is not provided`);
                        const f = {
                            code: an.CALL_END_CODE.LOCAL_ERROR,
                            subCode: an.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,
                            phrase: an.CALL_END_PHRASE.UPDATE_PARTICIPANT_INTERPRETATION_STATE_URL_MISSING
                        };
                        g.forEach((g)=>{
                            this.participantOperationHandler.rejectPendingOperation(5, g.id, "correct updateParticipantUrl is not provided", f, v);
                        });
                    }
                }
                sendNetworkRequestForCallMeBack(g, f, S) {
                    if (f) {
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.CALL_ME_BACK, ()=>{
                                this.signalingSession && !this.signalingSession.disposed && (this.signalingSession.telemetryHelper.recordEvent(cn.CALL_ME_BACK_TIMEOUT, {
                                    causeId: S
                                }), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.CALL_ME_BACK, g.id), this.participantOperationHandler.rejectPendingOperation(2, g.id, "timed out waiting for call me back success response", {
                                    code: an.CALL_END_CODE.TIMEOUT,
                                    subCode: an.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,
                                    phrase: an.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT
                                }, S));
                            }, an.TIMEOUT_VALUES_IN_SECONDS.CALL_ME_BACK_TIMEOUT, g.id);
                        }, v = {
                            groupId: this.signalingSession.groupId,
                            threadId: this.signalingSession.threadId,
                            messageId: this.signalingSession.teamsMessageId
                        };
                        this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: getPayload11(this.signalingSession, [
                                g
                            ], v),
                            requestName: dn.CALL_ME_BACK.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: S
                        }).catch((f)=>{
                            const v = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${S}][sendNetworkRequestForCallMeBack] failed: ${getPrintableObject(v)}`), this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.CALL_ME_BACK, g.id), this.participantOperationHandler.rejectPendingOperation(2, g.id, f, v.error, S));
                        });
                    } else this.logger.info(`[${S}][sendNetworkRequestForCallMeBack] failed because correct addParticipantUrl is not provided`), this.participantOperationHandler.rejectPendingOperation(2, g.id, "correct addParticipantUrl is not provided", {
                        code: an.CALL_END_CODE.LOCAL_ERROR,
                        subCode: an.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,
                        phrase: an.CALL_END_PHRASE.ADD_PARTICIPANT_URL_MISSING
                    }, S);
                }
                sendNetworkRequestForAdmittingParticipant(g, f, S) {
                    if (f) {
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, ()=>{
                                this.signalingSession && !this.signalingSession.disposed && (this.signalingSession.telemetryHelper.recordEvent(cn.ADMIT_PARTICIPANT_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, g.id), this.participantOperationHandler.rejectPendingOperation(1, g.id, "timed out waiting for participant to show up in roster", {
                                    code: an.CALL_END_CODE.TIMEOUT,
                                    subCode: an.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,
                                    phrase: an.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT
                                }, S));
                            }, an.TIMEOUT_VALUES_IN_SECONDS.ADMIT_PARTICIPANT_TIMEOUT, g.id);
                        };
                        this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: getPayload13(this.signalingSession, g, S),
                            requestName: dn.ADMIT_PARTICIPANT.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: S
                        }).catch((f)=>{
                            const v = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${S}][sendNetworkRequestForAdmittingParticipant][failed][reason=${getPrintableObject(v)}]`), this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, g.id), this.participantOperationHandler.rejectPendingOperation(1, g.id, f, v.error, S));
                        });
                    } else this.logger.info(`[${S}][sendNetworkRequestForAdmittingParticipant] failed because correct admitParticipantUrl is not provided`), this.participantOperationHandler.rejectPendingOperation(1, g.id, "correct admitParticipantUrl is not provided", {
                        code: an.CALL_END_CODE.LOCAL_ERROR,
                        subCode: an.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED,
                        phrase: an.CALL_END_PHRASE.ADMIT_PARTICIPANT_URL_MISSING
                    }, S);
                }
                getCurrentParticipantsInCallModality(g) {
                    var _this_signalingSessionCallback_getRemoteParticipantCollection;
                    const f = {}, S = [
                        an.PARTICIPANT_AUDIO_STATE.CONNECTED
                    ];
                    return g || S.push(an.PARTICIPANT_AUDIO_STATE.CONNECTING, an.PARTICIPANT_AUDIO_STATE.RINGING), (_this_signalingSessionCallback_getRemoteParticipantCollection = this.signalingSessionCallback.getRemoteParticipantCollection()) === null || _this_signalingSessionCallback_getRemoteParticipantCollection === void 0 ? void 0 : _this_signalingSessionCallback_getRemoteParticipantCollection.forEach((g)=>{
                        S.some((f)=>f === g.audioState) && (f[g.mri] = !0);
                    }), f;
                }
                internalHandleRemoveParticipantFailure(g, f, S) {
                    if (this.participantOperationHandler.hasPendingOperation(3, g, S)) {
                        this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, g), this.logger.info(`[${S}][internalHandleRemoveParticipantFailure] failed for ${this.piiUtils.scrubMriOrOmit(g)} reason ${getPrintableObject(f)}`);
                        const v = this.getCallEndGivenParticipantFailure(f);
                        this.participantOperationHandler.rejectPendingOperation(3, g, v.phrase, v, S);
                    }
                }
                internalHandleCallMeBackSuccessHelper(g, f) {
                    if (this.participantOperationHandler.hasPendingOperation(2, g, f)) {
                        const S = {
                            id: g
                        };
                        return this.logger.info(`participant : ${this.piiUtils.scrubMriOrOmit(g)} was successfully added. Resolving CallMeBack request`), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.CALL_ME_BACK, g), this.participantOperationHandler.resolvePendingOperation(2, S.id, S, f), !0;
                    }
                    return !1;
                }
                internalHandleAddParticipantFailure(g, f = causeId2()) {
                    const S = g.body;
                    if (S.participantInfos) S.participantInfos.forEach((S)=>{
                        const v = [
                            S.participant.participantId
                        ], _ = this.participantOperationHandler.getRnlMri(v, f) || S.participant.id;
                        this.rejectAddParticipantFailure(_, S.transactionEnd, g, f);
                    });
                    else if (S.participants) for (const v of Object.keys(S.participants))this.rejectAddParticipantFailure(v, S.participants[v], g, f);
                }
                rejectAddParticipantFailure(g, f, S, v) {
                    const _ = this.getCallEndGivenParticipantFailure(f);
                    this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADD_PARTICIPANT_FAILURE, S, _), this.participantOperationHandler.hasPendingOperation(0, g, v) ? (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, g), this.logger.info(`participantAdd failed for : ${this.piiUtils.scrubMriOrOmit(g)} reason : ${getPrintableObject(f)}`), this.participantOperationHandler.rejectPendingOperation(0, g, _.phrase, _, v)) : this.participantOperationHandler.hasPendingOperation(2, g, v) && (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.CALL_ME_BACK, g), this.logger.info(`callMeBack failed for : ${this.piiUtils.scrubMriOrOmit(g)} reason : ${getPrintableObject(f)}`), this.participantOperationHandler.rejectPendingOperation(2, g, _.phrase, _, v));
                }
                internalHandleAdmitParticipantSuccess(g, f) {
                    const S = g.body;
                    for (const g of S.participants)this.participantOperationHandler.hasPendingOperation(1, g, f) && (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, g), this.logger.info(`Admit participant success for : ${this.piiUtils.scrubMriOrOmit(g)}`), this.participantOperationHandler.resolvePendingOperation(1, g, void 0, f));
                }
                internalHandleAdmitParticipantFailure(g, f) {
                    const S = g.body;
                    for (const v of Object.keys(S.participants))if (this.participantOperationHandler.hasPendingOperation(1, v, f)) {
                        this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT_PARTICIPANT, v);
                        const _ = S.participants[v];
                        this.logger.info(`Admit participant failed for : ${this.piiUtils.scrubMriOrOmit(v)} reason : ${getPrintableObject(_)}`);
                        const C = this.getCallEndGivenParticipantFailure(_);
                        this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADMIT_PARTICIPANT_FAILURE, g, C), this.participantOperationHandler.rejectPendingOperation(1, v, C.phrase, C, f);
                    }
                }
                getCallEndGivenParticipantFailure(g) {
                    let f = {
                        code: g.code,
                        subCode: g.subCode,
                        phrase: g.phrase,
                        resultCategories: g.resultCategories
                    };
                    return g.code === an.CALL_END_CODE.CALL_MODALITY_FAILURE && g.callControllerTransactionEnd ? f = {
                        ...g.callControllerTransactionEnd
                    } : g.code === an.CALL_END_CODE.ATC_CONTROLLER_FAILURE && g.atcControllerTransactionEnd ? f = {
                        ...g.atcControllerTransactionEnd
                    } : g.code === an.CALL_END_CODE.CVA_CONTROLLER_FAILURE && g.cvaControllerTransactionEnd && (f = {
                        ...g.cvaControllerTransactionEnd
                    }), f;
                }
                constructor(g, f, S, v){
                    this.connectedRemoteParticipantIds = {}, this.disposed = !1, this.unmuteApprovalLinks = {}, this._asyncMuteUnmuteDefers = new Map, this.muteAsyncEnabled = !1, this.unmuteAsyncEnabled = !1, this.setLocalParticipantId = (g, f)=>{
                        g && (this.logger.info(`[${f}][setLocalParticipantId][participantId=${g}]`), this.localParticipant.participantId = g, this.signalingSession.telemetryHelper.setParticipantId(this.localParticipant.participantId));
                    }, this.setEnableMuteAsync = (g)=>{
                        this.muteAsyncEnabled = g;
                    }, this.setEnableUnmuteAsync = (g)=>{
                        this.unmuteAsyncEnabled = g;
                    }, this.admitParticipantAsync = (g, f, S)=>{
                        const v = `[${S}][admitParticipantAsync]`;
                        this.logger.info(`${v}${this.piiUtils.scrubMriOrOmit(g.id)}`);
                        const _ = defer();
                        return this.participantOperationHandler.hasPendingOperation(1, g.id, S) ? (this.logger.info(`${v}there is an existing pending request to admit the participant ${this.piiUtils.scrubMriOrOmit(g.id)}`), _.reject(new Error("there is an existing pending request to admit the participant"))) : (this.participantOperationHandler.setPendingOperation(1, g.id, {
                            participant: g,
                            promise: _,
                            causeId: S
                        }, S), this.sendNetworkRequestForAdmittingParticipant(g, f, S)), _.promise;
                    }, this.addParticipantsAsync = (g, f, S, v, _)=>{
                        const C = `[${_}][addParticipantsAsync]`, E = g.map((g)=>this.piiUtils.scrubMriOrOmit(g.id));
                        this.logger.info(`${C} remoteParticipantsIds: ${E}`);
                        const T = [], I = [];
                        return g.forEach((g)=>{
                            const f = defer(), S = 3 === v.replacementType ? g.participantId : g.id;
                            this.connectedRemoteParticipantIds.hasOwnProperty(g.id) ? (this.logger.info(`${C}the given participant is already connected to the call ${this.piiUtils.scrubMriOrOmit(g.id)}`), f.reject(new Error("the given participant is already connected to the call"))) : this.participantOperationHandler.hasPendingOperation(0, S, _) ? (this.logger.info(`${C}there is an existing pending request to add the participant ${this.piiUtils.scrubMriOrOmit(g.id)}`), f.reject(new Error("there is an existing pending request to add the participant"))) : (g.participantId || (g.participantId = newGuid(), this.logger.info(`participantId created ${g.participantId}`)), this.participantOperationHandler.setPendingOperation(0, S, {
                                participant: g,
                                promise: f,
                                causeId: _
                            }, _), T.push(g)), I.push(f.promise);
                        }), S && this.sendNetworkRequestForAddingParticipant(T, f, v, _), I;
                    }, this.nudgeParticipantsAsync = (g, f, S, v, _, C, E, T)=>(this.logger.info(`[${v}][nudgeParticipantAsync] ${this.piiUtils.scrubParticipantsList(g)}`), S ? this.sendNetworkRequestForNudgingParticipants(g, f, v, _, C, E, T) : Promise.reject(`[${v}][nudgeParticipantAsync] Call not started`)), this.updateMeetingRolesAsync = (g, f, S, v = causeId2())=>{
                        const _ = defer();
                        if (!g || g.length < 1) {
                            const g = `[${v}][updateMeetingRolesAsync] participantsInfo cannot be empty or null`, f = new Error(g);
                            f.endCode = {
                                code: an.CALL_END_CODE.REJECT,
                                subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,
                                phrase: g
                            }, this.logger.info(g), _.reject(f);
                        } else if (f) {
                            if (S) {
                                let C;
                                "attendee" === f ? C = dn.UPDATE_MEETING_ROLE_ATTENDEE.name : "presenter" === f ? C = dn.UPDATE_MEETING_ROLE_PRESENTER.name : "organizer" === f ? C = dn.UPDATE_MEETING_ROLE_ORGANIZER.name : _.reject(new Error(`[${v}] Invalid meetingRole value(${f})`)), this.logger.info(`[${v}][updateMeetingRolesAsync][meetingRole=${f}]`), this.signalingSession.ensureMessageChannelReady(C).then(()=>{
                                    this.sendNetworkRequestForUpdatingMeetingRoles(g, f, S, C, v, _);
                                }).catch((g)=>{
                                    const f = getPrintableObject(g);
                                    this.logger.info(`[${v}][updateMeetingRolesAsync][failed][reason=${f}]`);
                                    const S = {
                                        ...getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig).error
                                    };
                                    _.reject(S);
                                });
                            } else {
                                const g = `[${v}][updateMeetingRolesAsync] updateMeetingRoleUrl cannot be empty or null`, f = new Error(g);
                                f.endCode = {
                                    code: an.CALL_END_CODE.REJECT,
                                    subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,
                                    phrase: g
                                }, this.logger.info(g), _.reject(f);
                            }
                        } else {
                            const g = `[${v}][updateMeetingRolesAsync] meetingRole cannot be empty or null`, f = new Error(g);
                            f.endCode = {
                                code: an.CALL_END_CODE.REJECT,
                                subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_ROLE_REJECTED,
                                phrase: g
                            }, this.logger.info(g), _.reject(f);
                        }
                        return _.promise;
                    }, this.updateParticipantInterpretationStateAsync = (g, f, S)=>{
                        const v = `[${S}][updateParticipantInterpretationStateAsync]`, _ = g.map((g)=>this.piiUtils.scrubMriOrOmit(g.id));
                        this.logger.info(`${v} remoteParticipantsIds: ${_}`);
                        const C = [], E = [];
                        return g.forEach((g)=>{
                            const f = defer();
                            this.participantOperationHandler.hasPendingOperation(5, g.id, S) ? (this.logger.info(`${v}there is an existing pending request to update the participant ${this.piiUtils.scrubMriOrOmit(g.id)}`), f.reject(new Error("there is an existing pending request to update the participant"))) : (this.participantOperationHandler.setPendingOperation(5, g.id, {
                                option: g,
                                promise: f,
                                causeId: S
                            }, S), C.push(g)), E.push(f.promise);
                        }), this.sendNetworkRequestToUpdateParticipantInterpretationState(C, f, g, S), E;
                    }, this.callMeBackAsync = (g, f, S)=>{
                        this.logger.info(`[${S}][callMeBackAsync] ${this.piiUtils.scrubMriOrOmit(g.id)}`);
                        const v = defer();
                        return this.connectedRemoteParticipantIds.hasOwnProperty(g.id) ? (this.logger.info(`the given participant is already connected to the call : ${this.piiUtils.scrubMriOrOmit(g.id)}`), v.reject(new Error("the given participant is already connected to the call"))) : this.participantOperationHandler.hasPendingOperation(2, g.id, S) ? (this.logger.info(`there is an existing pending request to call back the participant : ${this.piiUtils.scrubMriOrOmit(g.id)}`), v.reject(new Error("there is an existing pending request to call back the participant"))) : (this.participantOperationHandler.setPendingOperation(2, g.id, {
                            participant: g,
                            promise: v
                        }, S), this.sendNetworkRequestForCallMeBack(g, f, S)), v.promise;
                    }, this.isRosterStale = (g, f)=>this.rosterManager.isRosterStale(g, f), this.removeParticipantAsync = (g, f, S)=>{
                        this.logger.info(`[${S}][removeParticipantAsync] ${this.piiUtils.scrubMriOrOmit(g.id)}`), assertNotNullOrEmpty(f, "correct removeParticipantUrl is not provided");
                        const v = defer();
                        if (this.participantOperationHandler.hasPendingOperation(3, g.id, S)) this.logger.info(`there is an existing pending request to remove the participant ${this.piiUtils.scrubMriOrOmit(g.id)}`), v.reject(new Error("there is an existing pending request to remove the participant"));
                        else {
                            this.participantOperationHandler.setPendingOperation(3, g.id, {
                                participant: g,
                                promise: v
                            }, S);
                            const onceTrouterReady = ()=>{
                                this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, ()=>{
                                    this.signalingSession.telemetryHelper.recordEvent(cn.REMOVE_PARTICIPANT_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, g.id), this.participantOperationHandler.rejectPendingOperation(3, g.id, "timed out waiting for participant to not show up in roster", {
                                        code: an.CALL_END_CODE.TIMEOUT,
                                        subCode: an.CALL_END_SUB_CODE.CALL_PARTICIPANT_REMOVAL_TIMEOUT,
                                        phrase: an.CALL_END_PHRASE.PARTICIPANT_REMOVAL_TIMEOUT
                                    }, S);
                                }, an.TIMEOUT_VALUES_IN_SECONDS.REMOVE_PARTICIPANT_TIMEOUT, g.id);
                            };
                            this.signalingSession.http.sendPostRequest({
                                url: f,
                                payload: getPayload20(this.signalingSession, g),
                                requestName: dn.REMOVE_PARTICIPANT_NONE.name,
                                onceTrouterReady: onceTrouterReady,
                                causeId: S
                            }).catch((f)=>{
                                const v = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                                this.logger.info(`[${S}][removeParticipantAsync][failed][reason=${getPrintableObject(v)}]`), this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, g.id), this.participantOperationHandler.rejectPendingOperation(3, g.id, f, v.error, S));
                            });
                        }
                        return v.promise;
                    }, this.removeParticipantEndpointAsync = (g, f, S, v)=>{
                        this.logger.info(`[${v}][removeParticipantEndpointAsync] ${truncate(g.endpointId, 8)} [endPointScope] ${S}`), assertNotNullOrEmpty(f, "correct removeParticipantUrl is not provided");
                        const _ = defer();
                        let C = "";
                        switch(S){
                            case "all":
                                C = dn.REMOVE_PARTICIPANT_OTHERS.name;
                                break;
                            case "specified":
                                C = dn.REMOVE_PARTICIPANT_SPECIFIED.name;
                                break;
                            default:
                                return Promise.reject(`invalid scope ${S} removeParticipantEndpointAsync`);
                        }
                        this.participantOperationHandler.setPendingOperation(4, g.endpointId, {
                            participant: g,
                            promise: _,
                            scope: S
                        }, v);
                        const onceTrouterReady = ()=>{
                            this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, ()=>{
                                this.signalingSession && !this.signalingSession.disposed && (this.signalingSession.telemetryHelper.recordEvent(cn.REMOVE_PARTICIPANT_TIMEOUT), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, g.endpointId), this.participantOperationHandler.rejectPendingOperation(4, g.endpointId, "timed out waiting for participant endpoint sync response from service", {
                                    code: an.CALL_END_CODE.TIMEOUT,
                                    subCode: an.CALL_END_SUB_CODE.CALL_PARTICIPANT_REMOVAL_TIMEOUT,
                                    phrase: an.CALL_END_PHRASE.PARTICIPANT_REMOVAL_TIMEOUT
                                }, v));
                            }, an.TIMEOUT_VALUES_IN_SECONDS.REMOVE_PARTICIPANT_TIMEOUT, g.endpointId);
                        };
                        return this.signalingSession.http.sendPostRequest({
                            url: f,
                            payload: getPayload19(this.signalingSession, g, S),
                            requestName: C,
                            onceTrouterReady: onceTrouterReady,
                            causeId: v
                        }).then((g)=>{
                            var _g_response;
                            if ((_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.code) {
                                if (-1 !== [
                                    an.HTTP_STATUS_CODES.OK,
                                    an.HTTP_STATUS_CODES.CREATED
                                ].indexOf(g.response.code)) this.logger.info(`[${v}][removeParticipantEndpointAsync][endPointScope] ${S} [passed][reason=${getPrintableObject(g.response)}]`), _.resolve(g.response);
                                else {
                                    const f = new Error("invalid service response for removeParticipantEndpoint");
                                    f.endCode = {
                                        code: g.response.code,
                                        subCode: g.response.subcode,
                                        phrase: g.response.reason
                                    }, this.logger.info(`[${v}][removeParticipantEndpointAsync][endPointScope] ${S} [failed][reason=${getPrintableObject(g.response)}]`), _.reject(f);
                                }
                            }
                            _.resolve();
                        }).catch((f)=>{
                            const _ = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${v}][removeParticipantEndpointAsync][endPointScope] ${S} [failed][reason=${getPrintableObject(_)}]`), this.disposed || (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.REMOVE_PARTICIPANT, g.endpointId), this.participantOperationHandler.rejectPendingOperation(4, g.endpointId, getPrintableObject(f), _.error, v));
                        }), _.promise;
                    }, this.getParticipantsToInitiateCallWith = ()=>{
                        this.logger.info("getParticipantsToInitiateCallWith");
                        const g = [], f = this.participantOperationHandler.getAllPendingOperations(0, causeId2());
                        for (const S of Object.keys(f))f.hasOwnProperty(S) && f[S] && g.push(f[S].participant);
                        return g;
                    }, this.initializeForIncomingCall = (g)=>{
                        this.logger.info("initializeForIncomingCall"), this.participantOperationHandler.dispose("incoming calls cannot add/remove participants until call is connected", null, causeId2());
                    }, this.handleAddParticipantSuccess = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleAddParticipantSuccess(${f.participantInfos ? "new format" : "old format"})]${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADD_PARTICIPANT_SUCCESS, g), this.internalHandleCallMeBackSuccess(f, S) || this.signalingSession.telemetryHelper.recordEvent(cn.HANDLE_ADD_PARTICIPANT_SUCCESS), this.signalingSession.signalingAgentConfig.enableAddParticipantEnhancements && this.internalHandleAcceptedByParticipants(f, S);
                    }, this.handleAddParticipantFailure = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleAddParticipantFailure(${f.participantInfos ? "new format" : "old format"})][${getPrintableObject(f)}]`), f.modalityFailure ? (this.logger.info(`[${S}][handleAddParticipantFailure][modalityFailure=${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADD_PARTICIPANT_MODALITY_FAILURE, g)) : this.internalHandleAddParticipantFailure(g, S);
                    }, this.handleAdmitParticipantSuccess = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleAdmitParticipantSuccess][${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADMIT_PARTICIPANT_SUCCESS, g), f.participants && this.internalHandleAdmitParticipantSuccess(g, S);
                    }, this.handleAdmitParticipantFailure = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleAdmitParticipantFailure][${getPrintableObject(f)}]`), f.participants && this.internalHandleAdmitParticipantFailure(g, S);
                    }, this.handleRemoveParticipantFailure = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleRemoveParticipantFailure][${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_REMOVE_PARTICIPANT_FAILURE, g);
                        for (const g of Object.keys(f.participants))f.participants.hasOwnProperty(g) && this.internalHandleRemoveParticipantFailure(g, f.participants[g], S);
                    }, this.handleRemoveParticipantSuccess = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleRemoveParticipantSuccess][${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_REMOVE_PARTICIPANT_SUCCESS, g);
                    }, this.handleUnmuteConfirmRequest = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g);
                        this.logger.info(`[${S}][handleUnmuteConfirmRequest][${getPrintableObject(f)}]`), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_UNMUTE_CONFIRM, g), this.unmuteApprovalLinks[f.from.id] = {
                            approve: f.links.approveUnmute,
                            reject: f.links.rejectUnmute
                        }, this.signalingSessionCallback.onUnmuteRequested(f.from.id, S);
                    }, this.approveUnmuteRequestAsync = (g, f)=>{
                        this.logger.info(`[${f}][approveUnmuteRequestAsync]`);
                        const S = defer();
                        return this.unmuteApprovalLinks.hasOwnProperty(g) ? (this.signalingSession.ensureMessageChannelReady(dn.APPROVE_UNMUTE.name).then(()=>{
                            this.muteUnmute(dn.APPROVE_UNMUTE.name, getPayload14(this.signalingSession), S, this.unmuteApprovalLinks[g].approve, f);
                        }).catch((g)=>{
                            const v = getPrintableObject(g);
                            this.logger.info(`[${f}][approveUnmuteRequestAsync][failed][reason=${v}]`), S.reject(new Error(g));
                        }), S.promise) : (S.reject(new Error("no unmute links found for given participant")), S.promise);
                    }, this.rejectUnmuteRequestAsync = (g, f, S)=>{
                        this.logger.info(`[${f}][rejectUnmuteRequestAsync]`);
                        const v = defer();
                        if (!this.unmuteApprovalLinks.hasOwnProperty(g)) return v.reject(new Error("no unmute links found for given participant")), v.promise;
                        const _ = S || {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UNMUTE_REQUEST_REJECTED,
                            phrase: an.CALL_END_PHRASE.UNMUTE_REQUEST_REJECTED
                        };
                        return this.signalingSession.ensureMessageChannelReady(dn.REJECT_UNMUTE.name).then(()=>{
                            this.muteUnmute(dn.REJECT_UNMUTE.name, getPayload18(this.signalingSession, _), v, this.unmuteApprovalLinks[g].reject, f);
                        }).catch((g)=>{
                            const S = getPrintableObject(g);
                            this.logger.info(`[${f}][rejectUnmuteRequestAsync][failed][reason=${S}]`), v.reject(new Error(g));
                        }), v.promise;
                    }, this.handleRosterUpdate = (g, f, S)=>{
                        const v = this.getCurrentParticipantsInCallModality(!1);
                        this.rosterManager.handleRosterUpdate(g, v, f, S);
                    }, this.updateLocalParticipantFromSubscribe = (g, f)=>{
                        this.localParticipant.fromRoster || this.rosterManager.updateLocalParticipantFromSubscribe(g, f);
                    }, this.muteAsync = (g, f, S, v)=>{
                        this.logger.info(`[${v}][muteAsync][muteScope=${f}]`);
                        let _ = "specified";
                        const C = [];
                        let E = dn.MUTE_SPECIFIED;
                        switch(f){
                            case an.MUTE_SCOPE.MYSELF:
                                E = dn.MUTE_MYSELF, C.push({
                                    id: this.localParticipant.id
                                });
                                break;
                            case an.MUTE_SCOPE.EVERYONE_ELSE:
                                E = dn.MUTE_ALL_SYNC, _ = "all", S.forEach((g)=>{
                                    C.push({
                                        id: g
                                    });
                                });
                                break;
                            case an.MUTE_SCOPE.SPECIFIED_PARTICIPANTS:
                                assertNotNullOrEmpty(S, `[${v}]array of participantIds must be specified for SPECIFIED_PARTICIPANTS mute scope`), E = dn.MUTE_SPECIFIED_SYNC, S.forEach((g)=>{
                                    C.push({
                                        id: g
                                    });
                                });
                                break;
                            default:
                                assert2(!1, `[${v}]muteScope is a required param. please pass in a valid value.`);
                        }
                        const T = defer();
                        if (f === an.MUTE_SCOPE.SPECIFIED_PARTICIPANTS) {
                            const g = this.areParticipantsConnectedToCall(S);
                            if (!g.result) return T.reject(new Error(`[${v}]specified participant is not connected to call yet. Id = ${g.participant}`)), T.promise;
                        }
                        const I = this.muteAsyncEnabled && (f === an.MUTE_SCOPE.SPECIFIED_PARTICIPANTS || f === an.MUTE_SCOPE.EVERYONE_ELSE);
                        return this.signalingSession.ensureMessageChannelReady(E.name).then(()=>{
                            this.muteUnmute(E.name, getPayload15(this.signalingSession, _, C, I, v), T, g, v, !1, I);
                        }).catch((g)=>{
                            const f = getPrintableObject(g), S = getErrorForXHRFailure(g, this.signalingSession.signalingAgentConfig);
                            this.logger.info(`[${v}][muteAsync][failed][reason=${f}]`), T.reject(S);
                        }), T.promise;
                    }, this.unmuteAsync = (g, f)=>{
                        this.logger.info(`[${f}][unmuteAsync]`);
                        const S = defer();
                        return this.signalingSession.ensureMessageChannelReady(dn.UNMUTE_SYNC.name).then(()=>{
                            this.muteUnmute(dn.UNMUTE_SYNC.name, getPayload21(this.signalingSession, this.unmuteAsyncEnabled, f), S, g, f, !0, this.unmuteAsyncEnabled);
                        }).catch((g)=>{
                            const v = getPrintableObject(g);
                            this.logger.info(`[${f}][unmuteAsync][failed][reason=${v}]`), S.reject(new Error(g));
                        }), S.promise;
                    }, this.dispose = (g, f)=>{
                        this.logger.info(`[${f}][dispose]`), this.disposed = !0, this.participantOperationHandler.dispose("call ended", g, f), this.signalingSession.telemetryHelper.setParticipantId(this.localParticipant.participantId), this._asyncMuteUnmuteDefers.forEach((f, S)=>{
                            f.reject(g);
                        }), this._asyncMuteUnmuteDefers.clear();
                    }, this.handleMuteUnmuteAsyncResponse = (g)=>{
                        const f = extractCauseIdFromMessage(g), S = this.logger.createFnLogger("handleMuteUnmuteAsyncResponse", f);
                        if (!g.body) return void S.error("ignored. Empty message body.");
                        const v = {
                            info: g.body.muteUnmuteResponseAsync,
                            operationId: g.body.operationId
                        };
                        if (S.info(`Received async response for mute/unmute operation, operation id = ${v.operationId}.`), this.disposed) return void S.info("ignored. Call disposed.");
                        if (!v.operationId) return void S.error("operationId is undefined.");
                        const _ = this._asyncMuteUnmuteDefers.get(v.operationId);
                        _ ? (_.resolve(v), this._asyncMuteUnmuteDefers.delete(v.operationId)) : S.warn(`cannot find deferred promise for operation id [${v.operationId}].`);
                    }, this.internalHandleAcceptedByParticipants = (g, f)=>{
                        if (g === null || g === void 0 ? void 0 : g.participantInfos) {
                            const S = g.participantInfos, v = this.getCurrentParticipantsInCallModality(!1);
                            this.logger.info(`[${f}][internalHandleAcceptedByParticipants] handling participants with acceptedBy blob.`);
                            for (const g of S)if (g === null || g === void 0 ? void 0 : g.acceptedBy) {
                                const S = g.id;
                                this.participantOperationHandler.hasPendingOperation(0, S, f) && (this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADD_PARTICIPANT, S), this.logger.info(`[${f}][internalHandleAcceptedByParticipants] ${this.piiUtils.scrubMriOrOmit(S)} added using a different MRI. Resolving operation.`), this.participantOperationHandler.resolvePendingOperation(0, S, void 0, f)), this.rosterManager.handleParticipantAcceptedBy(g, v, f);
                            }
                        }
                    }, this.internalHandleCallMeBackSuccess = (g, f)=>{
                        let S = !1;
                        if (g === null || g === void 0 ? void 0 : g.participantInfos) {
                            const v = g.participantInfos;
                            for (const g of v){
                                const v = g.id;
                                this.internalHandleCallMeBackSuccessHelper(v, f) && (S = !0);
                            }
                        } else if (g === null || g === void 0 ? void 0 : g.participants) for (const v of g.participants)this.internalHandleCallMeBackSuccessHelper(v, f) && (S = !0);
                        return S;
                    }, this.signalingSession = g, this.signalingSessionCallback = f, this.localParticipant = S, this.localParticipant.endpointId || (this.localParticipant.endpointId = this.signalingSession.getEndpointId());
                    const _ = truncate(this.localParticipant.endpointId, 8);
                    this.logger = v.createChild(()=>`[PM][${_}]`), this.piiUtils = g.piiUtils, this.participantOperationHandler = new jn(g.logger.createChild(()=>`[ParticipantOperationHandler][${_}]`)), this.rosterManager = new qn(this, g.logger.createChild(()=>`[RosterManager][${_}]`)), this.localParticipant.participantId || (this.localParticipant.participantId = newGuid()), "string" == typeof g.signalingAgentConfig.languageCode ? this.localParticipant.languageId = g.signalingAgentConfig.languageCode : "function" == typeof g.signalingAgentConfig.languageCode && (this.localParticipant.languageId = g.signalingAgentConfig.languageCode()), g.telemetryHelper.setParticipantId(this.localParticipant.participantId), g.telemetryHelper.setEndPointId(this.localParticipant.endpointId);
                }
            };
            function getPayload23(g, f) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNullOrEmpty(f, "sendMessageOptions cannot be null or empty");
                const S = [];
                for (const v of f){
                    const f = 0 === v.scope ? "all" : "specified", _ = [];
                    v.to && Object.keys(v.to).forEach((g)=>{
                        v.to[g].participantLegIdMap ? Object.keys(v.to[g].participantLegIdMap).forEach((f)=>{
                            _.push({
                                id: g,
                                level: v.to[g].level,
                                endpointId: v.to[g].participantLegIdMap[f].endpointId,
                                participantId: f
                            });
                        }) : _.push({
                            id: g,
                            level: v.to[g].level
                        });
                    }), S.push({
                        links: {
                            sendMessageStatus: get2(g, nn.SEND_MESSAGE_STATUS)
                        },
                        operationId: v.operationId,
                        payload: v.payload,
                        scope: f,
                        to: _,
                        type: v.type
                    });
                }
                var _g_participantManager_localParticipant_languageId;
                return {
                    payload: {
                        from: {
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            id: g.participantManager.localParticipant.id,
                            languageId: (_g_participantManager_localParticipant_languageId = g.participantManager.localParticipant.languageId) !== null && _g_participantManager_localParticipant_languageId !== void 0 ? _g_participantManager_localParticipant_languageId : "",
                            participantId: g.participantManager.localParticipant.participantId
                        },
                        messageContent: S
                    }
                };
            }
            function mapMriToResolveString(g, f) {
                return `${g}-${f}`;
            }
            function mapLegIdToResolveString(g, f) {
                return `${g}-${f}`;
            }
            function mapMriAndPropertyNameToResolveString(g, f, S) {
                return `${g}_${f}_${S}`;
            }
            var zn = class {
                sendProxiedMessageAsync(g, f, S) {
                    this.logger.createChild("sendProxiedMessageAsync", g).info(`Url: ${S}`);
                    const v = [], _ = [];
                    for (const S of f)if (0 !== S.scope) {
                        if (1 === S.scope) {
                            for(const f in S.to)if ("participant" === S.to[f].level) {
                                const C = mapMriToResolveString(f, S.operationId), E = defer();
                                this.mriOperations.set(C, E), v.push(E.promise), _.push(C), this.startTimeout(g, "participant", C);
                            } else if ("endpoint" === S.to[f].level) for(const C in S.to[f].participantLegIdMap){
                                const f = mapLegIdToResolveString(C, S.operationId), E = defer();
                                this.legOperations.set(f, E), v.push(E.promise), _.push(f), this.startTimeout(g, "endpoint", f);
                            }
                        }
                    } else {
                        const f = defer();
                        this.scopeAllOperations.set(S.operationId, f), v.push(f.promise), _.push(S.operationId), this.startTimeout(g, "all", S.operationId);
                    }
                    return this.sendProxiedMessageNetworkRequest(g, f, S, _), v;
                }
                sendProxiedMessageNetworkRequest(g, f, S, v) {
                    const _ = getPayload23(this.signalingSession, f), C = this.logger.createChild("sendProxiedMessageNetworkRequest", g);
                    C.info(`Url: ${S}`), this.signalingSession.http.sendPostRequest({
                        url: S,
                        requestName: dn.SEND_PROXIED_MESSAGE.name,
                        payload: _,
                        causeId: g
                    }).catch((f)=>{
                        const S = getErrorForXHRFailure(f, this.signalingSession.signalingAgentConfig);
                        if (C.info(`failed:${getPrintableObject(f)}`), this.signalingSession.disposed) C.info("signaling session is already disposed.");
                        else for (const f of v){
                            this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, f);
                            let v = null;
                            this.scopeAllOperations.has(f) ? (v = this.scopeAllOperations.get(f), this.scopeAllOperations.delete(f)) : this.mriOperations.has(f) ? (v = this.mriOperations.get(f), this.mriOperations.delete(f)) : this.legOperations.get(f) ? (v = this.legOperations.get(f), this.legOperations.delete(f)) : C.warn(`could not find resolveString:${f} to reject it.`), null !== v && v.reject({
                                transactionEnd: S.error,
                                causeId: g,
                                resolveString: f
                            });
                        }
                    });
                }
                startTimeout(g, f, S) {
                    const v = this.logger.createChild("startTimeout", g);
                    v.info(`Creating timeout for level ${f} message with resolveString ${S}`), this.signalingSession.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, ()=>{
                        this.signalingSession.telemetryHelper.recordEvent(cn.SEND_MESSAGE_TIMEOUT, {
                            causeId: g,
                            resolveString: S
                        }), v.info(`timed out waiting for level [${f}] message with resolveString [${S}]`), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, S);
                        const _ = "all" === f ? this.scopeAllOperations : "participant" === f ? this.mriOperations : "endpoint" === f ? this.legOperations : null;
                        null !== _ ? _.has(S) ? (_.get(S).reject({
                            transactionEnd: {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.CONVERSATION_NOTIFICATION_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.CONVERSATION_NOTIFICATION_TIMEOUT
                            },
                            causeId: g,
                            resolveString: S
                        }), _.delete(S)) : v.warn(`Could not find resolveString [${S}] on map for ${f}. Will not reject promise.`) : v.warn(`Could not find a operations map for ${f}. Will not reject promise.`);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.SEND_MESSAGE_COMPLETION_TIMEOUT, S);
                }
                handleProxiedMessageNotificationItem(g, f, S) {
                    var _g_participantInfos;
                    if (f.info(`Message contains ${(_g_participantInfos = g.participantInfos) === null || _g_participantInfos === void 0 ? void 0 : _g_participantInfos.length} participantInfos.`), 0 === this.scopeAllOperations.size && 0 === this.mriOperations.size && 0 === this.legOperations.size) return void f.info("Received statusMessage but there is no pending operation.");
                    const v = g.operationId;
                    if (this.scopeAllOperations.has(v)) {
                        f.info(`Scope all resolveString:${v}`), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, v);
                        const g = {
                            transactionEnd: {
                                code: 0,
                                subCode: 0,
                                phrase: ""
                            },
                            causeId: S,
                            resolveString: v
                        };
                        return this.scopeAllOperations.get(v).resolve(g), this.scopeAllOperations.delete(v), void this.signalingSession.telemetryHelper.recordEvent(cn.SEND_MESSAGE_COMPLETION, {
                            causeId: S,
                            operationId: v,
                            level: "all"
                        });
                    }
                    for (const _ of g.participantInfos){
                        var __transactionEnd;
                        const g = 0 === ((__transactionEnd = _.transactionEnd) === null || __transactionEnd === void 0 ? void 0 : __transactionEnd.code), C = mapMriToResolveString(_.participant.id, v), E = mapLegIdToResolveString(_.participant.participantId, v);
                        if (C && this.mriOperations.has(C)) {
                            f.info(`Scope mri resolveString:${C}`);
                            const E = {
                                transactionEnd: _.transactionEnd,
                                causeId: S,
                                resolveString: C
                            };
                            g ? this.mriOperations.get(C).resolve(E) : this.mriOperations.get(C).reject(E), this.mriOperations.delete(C), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, C), this.signalingSession.telemetryHelper.recordEvent(cn.SEND_MESSAGE_COMPLETION, {
                                causeId: S,
                                operationId: v,
                                level: "mri"
                            });
                        } else if (E && this.legOperations.has(E)) {
                            f.info(`Scope legId resolveString:${E}`);
                            const C = {
                                transactionEnd: _.transactionEnd,
                                causeId: S,
                                resolveString: E
                            };
                            g ? this.legOperations.get(E).resolve(C) : this.legOperations.get(E).reject(C), this.legOperations.delete(E), this.signalingSession.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SEND_MESSAGE_COMPLETION, E), this.signalingSession.telemetryHelper.recordEvent(cn.SEND_MESSAGE_COMPLETION, {
                                causeId: S,
                                operationId: v,
                                level: "leg"
                            });
                        } else f.warn(`Could not map this participantInfo to any pending operation operationId:${v}`);
                    }
                }
                handleProxiedMessageNotification(g) {
                    var _g_body;
                    const f = extractCauseIdFromMessage(g), S = this.logger.createChild("handleProxiedMessageNotification", f);
                    let v;
                    v = Array.isArray((_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.statuses) ? g.body.statuses : [
                        g.body
                    ], S.info(`Received ${v.length} proxied message notification(s).`);
                    for (const g of v)this.handleProxiedMessageNotificationItem(g, S, f);
                }
                constructor(g){
                    this.signalingSession = g, this.scopeAllOperations = new Map, this.mriOperations = new Map, this.legOperations = new Map, this.logger = g.logger.createChild(()=>"[ProxiedMessageNotificationManager]");
                }
            };
            function getPayload24(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "broadcastContext cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        broadcast: f,
                        links: {
                            addModalitySuccess: get2(g, nn.CONV_ADD_MODALITY_SUCCESS),
                            addModalityFailure: get2(g, nn.CONV_ADD_MODALITY_FAILURE)
                        }
                    }
                };
            }
            function getPayload25(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "broadcastContext cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        groupContext: f.groupContext ? {
                            id: f.groupContext.groupId
                        } : null,
                        groupChat: f.groupChat ? {
                            threadId: f.groupChat.threadId,
                            messageId: f.groupChat.messageId
                        } : null,
                        links: {
                            addModalitySuccess: get2(g, nn.CONV_ADD_MODALITY_SUCCESS),
                            addModalityFailure: get2(g, nn.CONV_ADD_MODALITY_FAILURE)
                        }
                    }
                };
            }
            function getPayload26(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        links: {
                            admitAllStatus: get2(g, nn.CONV_ADMIT_ALL_STATUS)
                        },
                        operationId: f,
                        debugContent: {
                            causeId: f
                        }
                    }
                };
            }
            function getPayload27(g, f, S = !0) {
                assertNotNull(g, "signalingSession cannot be null"), assertNotNull(f, "joinUrl cannot be null");
                const v = {
                    type: "Delta",
                    rosterUpdate: get2(g, nn.CONV_ROSTER_UPDATE)
                }, _ = g.getEndpointCapabilities(), C = {
                    payload: {
                        attach: {
                            requireMediaContent: S,
                            links: {
                                end: get2(g, nn.END)
                            },
                            locationContent: g.getLocationContent(),
                            networkContent: g.getNetworkContent(),
                            areaContent: g.getAreaContent()
                        },
                        capabilities: null,
                        endpointCapabilities: _,
                        additionalActions: [
                            {
                                input: {
                                    capabilities: null,
                                    endpointCapabilities: _,
                                    conversationRequest: {
                                        applicationType: g.participantManager.localParticipant.applicationType,
                                        roster: v,
                                        links: {
                                            conversationEnd: get2(g, g.signalingAgentConfig.enableSplitConversationEndUrl ? nn.CONV_END_JOIN : nn.CONV_END),
                                            conversationUpdate: get2(g, nn.CONV_UPDATE),
                                            localParticipantUpdate: get2(g, nn.CONV_LOCAL_PARTICIPANT_UPDATE),
                                            addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                                            addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE),
                                            receiveMessage: get2(g, nn.RECEIVE_MESSAGE)
                                        }
                                    },
                                    endpointMetadata: g.endpointMetadata,
                                    participants: {
                                        from: {
                                            id: g.participantManager.localParticipant.id,
                                            displayName: g.participantManager.localParticipant.displayName,
                                            endpointId: g.participantManager.localParticipant.endpointId,
                                            participantId: g.participantManager.localParticipant.participantId,
                                            languageId: g.participantManager.localParticipant.languageId
                                        }
                                    }
                                },
                                name: "join",
                                url: f,
                                waitForResponse: !0
                            }
                        ]
                    }
                };
                return g.signalingAgentConfig.ecsEtag && (C.payload.debugContent = {
                    ecsEtag: g.signalingAgentConfig.ecsEtag
                }), C.payload.additionalActions.length > 0 && g.deviceType && "default" !== g.deviceType && (C.payload.additionalActions[0].input.conversationRequest.deviceType = g.deviceType), C;
            }
            function getPayload28(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        callAcceptanceAcknowledgement: {
                            links: {
                                mediaRenegotiation: get2(g, nn.MEDIA_RENEGOTIATION),
                                transfer: get2(g, nn.TRANSFER),
                                replacement: get2(g, nn.REPLACE),
                                balanceUpdate: get2(g, nn.BALANCE_UPDATE),
                                retargetCompletion: get2(g, nn.RETARGET_COMPLETION),
                                controlVideoStreaming: get2(g, nn.CONTROL_VIDEO_STREAMING),
                                updateMediaDescriptions: get2(g, nn.UPDATE_MEDIA_DESCRIPTIONS)
                            }
                        }
                    }
                };
            }
            function getPayload29(g, f, S, v) {
                assertNotNull(g, "signalingSession cannot be null");
                const _ = getMediaTypes(S);
                g.telemetryHelper.addOutgoingModalities(_);
                const C = g.getEndpointCapabilities();
                return {
                    payload: {
                        callAcceptance: {
                            acceptedBy: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            acceptedCallModalities: _,
                            capabilities: null,
                            endpointCapabilities: C,
                            clientEndpointCapabilities: 0 !== v ? v : null,
                            links: {
                                mediaRenegotiation: get2(g, nn.MEDIA_RENEGOTIATION),
                                transfer: get2(g, nn.TRANSFER),
                                replacement: get2(g, nn.REPLACE),
                                balanceUpdate: get2(g, nn.BALANCE_UPDATE),
                                retargetCompletion: get2(g, nn.RETARGET_COMPLETION),
                                controlVideoStreaming: get2(g, nn.CONTROL_VIDEO_STREAMING),
                                updateMediaDescriptions: get2(g, nn.UPDATE_MEDIA_DESCRIPTIONS)
                            },
                            clientContentForMediaController: g.webRtcSignalingManager.getClientUrls(),
                            mediaContent: f,
                            pstnContent: g.pstnContent,
                            callKeepAliveInterval: null
                        }
                    }
                };
            }
            function getPayload30(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        callProgress: {
                            sender: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            status: "ringing",
                            phrase: "ringing"
                        }
                    }
                };
            }
            function getPayload31(g, f, S, v) {
                assertNotNull(g, "signalingSession cannot be null");
                const _ = g.participantManager.localParticipant;
                return {
                    payload: {
                        invitationRedirection: {
                            target: {
                                type: f,
                                endpointType: v,
                                id: S
                            },
                            sender: {
                                id: _.id,
                                endpointId: _.endpointId,
                                participantId: _.participantId,
                                languageId: _.languageId
                            }
                        }
                    }
                };
            }
            function getPayload32(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f);
                const v = {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        conversationTransactionEnd: {
                            reason: "noError",
                            code: an.CALL_END_CODE.SUCCESS,
                            phrase: an.CALL_END_PHRASE.CONV_END_NO_MODALITY
                        },
                        callTransactionEnd: f
                    }
                };
                return S && f.code === an.CALL_END_CODE.CANCEL && (v.payload.callTransactionEnd.callQualityDiagnosticsInformation = S), v;
            }
            function getPayload33(g, f, S, v) {
                var _g_broadcastSession, _v_publishedStates;
                assertNotNull(g, "signalingSession cannot be null");
                let _ = [];
                _ = v.invitationType === an.INVITATION_TYPE.NUDGE && Array.isArray(v.participantsToNudge) ? v.participantsToNudge.map((g)=>({
                        id: g
                    })) : g.participantManager.getParticipantsToInitiateCallWith(), g.signalingAgentConfig.doHostlessCalling || assert2(_.length > 0, "remoteParticipants need to be set before a call can be made");
                const C = {
                    type: "Delta",
                    rosterUpdate: get2(g, nn.CONV_ROSTER_UPDATE)
                }, E = g.groupId ? {
                    id: g.groupId
                } : null, T = g.threadId ? {
                    threadId: g.threadId,
                    messageId: g.teamsMessageId || null
                } : null, I = g.contentSharingManager.getContentSharingInfoToStartSharing(), b = null === I ? null : {
                    identifier: I.contentIdentifier,
                    subject: I.subject,
                    sessionState: I.sessionState,
                    sessionUpdateSequenceNumber: I.sequenceNumber,
                    links: {
                        sessionUpdate: get2(g, nn.CONV_CONTENT_SHARING_UPDATE),
                        sessionEnd: get2(g, nn.CONV_CONTENT_SHARING_END)
                    }
                }, A = (_g_broadcastSession = g.broadcastSession) === null || _g_broadcastSession === void 0 ? void 0 : _g_broadcastSession.getContext(), R = g.getEndpointCapabilities();
                1 === _.length && g.telemetryHelper.setCalleeType(_[0].id), g.numberOfOriginalInvitees = _.length;
                const P = [];
                _.forEach((f)=>{
                    const S = {
                        id: f.id
                    };
                    f.displayName && (S.displayName = f.displayName), f.participantId && (S.participantId = f.participantId), (v.callToVoicemail || g.transferContext && g.transferContext.target && "voicemail" === g.transferContext.target.endpointType) && (S.endpointType = "voicemail"), P.push(S);
                });
                const w = g.transferContext ? g.transferContext.transferor : null, M = g.transferContext ? g.transferContext.transferContext : null, O = {};
                v.callToVoicemail && (v.voicemailResourcePath && (O.localResourcePath = v.voicemailResourcePath), v.voicemailItemId && (O.voicemailItemId = v.voicemailItemId));
                const D = {
                    payload: {
                        conversationRequest: {
                            conversationType: v.conversationType,
                            subject: g.convSubject,
                            suppressDialout: v.suppressDialout,
                            applicationType: v.applicationType,
                            targetApplicationType: v.targetApplicationType,
                            roster: C,
                            properties: {
                                allowConversationWithoutHost: g.signalingAgentConfig.doHostlessCalling,
                                enableGroupCallEventMessages: g.signalingAgentConfig.shouldServiceSendCallEventMessages,
                                enableGroupCallUpgradeMessage: g.signalingAgentConfig.shouldServiceSendNGCUpgradeMessages,
                                enableGroupCallMeetupGeneration: g.enableGroupCallMeetupGeneration
                            },
                            links: {
                                conversationEnd: get2(g, g.signalingAgentConfig.enableSplitConversationEndUrl ? v.subscribe ? nn.CONV_END_SUBSCRIBE : nn.CONV_END_JOIN : nn.CONV_END),
                                conversationUpdate: get2(g, nn.CONV_UPDATE),
                                localParticipantUpdate: get2(g, nn.CONV_LOCAL_PARTICIPANT_UPDATE),
                                addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                                addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE),
                                addModalitySuccess: get2(g, nn.CONV_ADD_MODALITY_SUCCESS),
                                addModalityFailure: get2(g, nn.CONV_ADD_MODALITY_FAILURE),
                                confirmUnmute: get2(g, nn.CONV_CONFIRM_UNMUTE),
                                receiveMessage: get2(g, nn.RECEIVE_MESSAGE)
                            }
                        },
                        broadcast: A,
                        contentSharing: b,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId,
                                meetingRegistrationId: v.meetingRegistrationId,
                                participantPin: v.participantPin
                            },
                            to: P
                        },
                        capabilities: null,
                        endpointCapabilities: R,
                        clientEndpointCapabilities: v.clientEndpointCapabilities ? v.clientEndpointCapabilities : null,
                        endpointMetadata: g.endpointMetadata,
                        groupContext: E,
                        groupChat: T,
                        meetingInfo: g.getMeetingInfo(),
                        meetingData: v.meetingData,
                        meetingPreferences: v.meetingPreferences,
                        endpointState: v.endpointState
                    }
                };
                if (((_v_publishedStates = v.publishedStates) === null || _v_publishedStates === void 0 ? void 0 : _v_publishedStates.publishedStates.length) > 0) {
                    let f = [];
                    f = v.publishedStates.publishedStates.map((f)=>{
                        let S = {};
                        try {
                            S = JSON.parse(f.content);
                        } catch (f) {
                            g.logger.warn("createConversationRequest getPayload() failed to parse state.content");
                        }
                        return {
                            stateType: f.type,
                            level: f.level,
                            content: S,
                            sequenceNumber: g.getPublishStateSequenceNumber()
                        };
                    }), D.payload.publishedStates = f;
                }
                g.deviceType && "default" !== g.deviceType && (D.payload.conversationRequest.deviceType = g.deviceType);
                const N = getMediaTypes(S);
                if (g.telemetryHelper.addOutgoingModalities(N), D.payload.callInvitation = {
                    callModalities: N,
                    replaces: null,
                    transferor: w || null,
                    clientTransferContext: M,
                    customContext: v.customHeaderContext || null,
                    links: {
                        progress: get2(g, nn.PROGRESS),
                        mediaAnswer: get2(g, nn.MEDIA_ANSWER),
                        acceptance: get2(g, nn.ACCEPT),
                        redirection: get2(g, nn.REDIRECTION),
                        end: get2(g, nn.END)
                    },
                    clientContentForMediaController: g.webRtcSignalingManager.getClientUrls(),
                    pstnContent: g.pstnContent,
                    emergencyContent: g.getEmergencyContent(),
                    mediaContent: f,
                    voicemailSettings: O,
                    routingFlags: v.routingFlags,
                    invitationData: v.invitationData,
                    locationContent: g.getLocationContent(),
                    networkContent: g.getNetworkContent(),
                    areaContent: g.getAreaContent()
                }, v.pickupCode && (D.payload.callInvitation.unparkContent = {
                    pickupCode: parseInt(v.pickupCode, 10)
                }), v.onBehalfOf && (D.payload.callInvitation.onBehalfOf = {
                    id: v.onBehalfOf
                }, v.onBehalfOfUserDisplayName && (D.payload.callInvitation.onBehalfOf.displayName = v.onBehalfOfUserDisplayName)), v.callQueueContext && (D.payload.callInvitation.callQueueContext = v.callQueueContext), v.scenario && (D.payload.conversationRequest.scenario = v.scenario), v.alternateId && (D.payload.participants.from.alternateId = v.alternateId), v.callingLineIdentity && (D.payload.participants.from.callingLineIdentity = v.callingLineIdentity), v.invitationType === an.INVITATION_TYPE.NUDGE && (D.payload.participants.invitationType = v.invitationType), g.signalingAgentConfig.ecsEtag && (D.payload.debugContent = {
                    ecsEtag: g.signalingAgentConfig.ecsEtag
                }), v.clientEndpointDebugContent) {
                    D.payload.debugContent || (D.payload.debugContent = {});
                    try {
                        D.payload.debugContent.clientDebugContent = JSON.parse(v.clientEndpointDebugContent);
                    } catch (g) {
                        assert2(!1, `Failed to parse ${v.clientEndpointDebugContent}`);
                    }
                }
                if (v.captchaContentJson) try {
                    D.payload.conversationRequest.captchaContent = JSON.parse(v.captchaContentJson);
                } catch (g) {
                    assert2(!1, `Failed to parse ${v.captchaContentJson}`);
                }
                return v.participationPreferences && (D.payload.participationPreferences = v.participationPreferences), D;
            }
            function getPayload34(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        conversationTransactionEnd: {
                            reason: "noError",
                            code: an.CALL_END_CODE.SUCCESS,
                            phrase: an.CALL_END_PHRASE.CONV_END_FOR_ALL_INITIATED
                        },
                        callTransactionEnd: f
                    }
                };
            }
            function getPayload35(g, f) {
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        scope: f
                    }
                };
            }
            function getPayload36(g, f, S, v, _) {
                var _v_publishedStates;
                assertNotNull(g, "signalingSession cannot be null");
                const C = {
                    type: "Delta",
                    rosterUpdate: get2(g, nn.CONV_ROSTER_UPDATE)
                }, E = g.getEndpointCapabilities(), T = g.groupId ? {
                    id: g.groupId
                } : null, I = g.threadId ? {
                    threadId: g.threadId,
                    messageId: g.teamsMessageId || null
                } : null, b = {
                    payload: {
                        conversationRequest: {
                            conversationType: v.conversationType,
                            subject: g.convSubject,
                            suppressDialout: v.suppressDialout,
                            scenario: v.scenario,
                            applicationType: v.applicationType,
                            roster: C,
                            properties: {
                                allowConversationWithoutHost: g.signalingAgentConfig.doHostlessCalling,
                                enableGroupCallEventMessages: g.signalingAgentConfig.shouldServiceSendCallEventMessages,
                                enableGroupCallUpgradeMessage: g.signalingAgentConfig.shouldServiceSendNGCUpgradeMessages,
                                enableGroupCallMeetupGeneration: g.enableGroupCallMeetupGeneration
                            },
                            links: {
                                conversationEnd: get2(g, g.signalingAgentConfig.enableSplitConversationEndUrl ? v.subscribe ? nn.CONV_END_SUBSCRIBE : nn.CONV_END_JOIN : nn.CONV_END),
                                conversationUpdate: get2(g, nn.CONV_UPDATE),
                                localParticipantUpdate: get2(g, nn.CONV_LOCAL_PARTICIPANT_UPDATE),
                                addParticipantSuccess: get2(g, nn.CONV_ADD_PARTICIPANT_SUCCESS),
                                addParticipantFailure: get2(g, nn.CONV_ADD_PARTICIPANT_FAILURE),
                                receiveMessage: get2(g, nn.RECEIVE_MESSAGE)
                            }
                        },
                        groupContext: T,
                        groupChat: I,
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId,
                                meetingRegistrationId: v.meetingRegistrationId,
                                participantPin: v.participantPin
                            }
                        },
                        capabilities: null,
                        endpointCapabilities: E,
                        clientEndpointCapabilities: v.clientEndpointCapabilities ? v.clientEndpointCapabilities : null,
                        endpointMetadata: g.endpointMetadata,
                        meetingInfo: g.getMeetingInfo(),
                        meetingData: v.meetingData,
                        meetingPreferences: v.meetingPreferences,
                        endpointState: v.endpointState
                    }
                };
                if (((_v_publishedStates = v.publishedStates) === null || _v_publishedStates === void 0 ? void 0 : _v_publishedStates.publishedStates.length) > 0) {
                    let f = [];
                    f = v.publishedStates.publishedStates.map((f)=>{
                        let S = {};
                        try {
                            S = JSON.parse(f.content);
                        } catch (f) {
                            g.logger.warn("joinConversationRequest getPayload() failed to parse state.content");
                        }
                        return {
                            stateType: f.type,
                            level: f.level,
                            content: S,
                            sequenceNumber: g.getPublishStateSequenceNumber()
                        };
                    }), b.payload.publishedStates = f;
                }
                if ((v === null || v === void 0 ? void 0 : v.applyServerMute) && (b.payload.participants.from.applyServerMute = v.applyServerMute.value, v.applyServerMute.mediaTypes && (b.payload.participants.from.mediaTypes = v.applyServerMute.mediaTypes)), g.deviceType && "default" !== g.deviceType && (b.payload.conversationRequest.deviceType = g.deviceType), !v.subscribe) {
                    const _ = getMediaTypes(S);
                    g.telemetryHelper.addOutgoingModalities(_), b.payload.callInvitation = {
                        callModalities: _,
                        replaces: null,
                        transferor: null,
                        links: {
                            progress: get2(g, nn.PROGRESS),
                            mediaAnswer: get2(g, nn.MEDIA_ANSWER),
                            acceptance: get2(g, nn.ACCEPT),
                            redirection: get2(g, nn.REDIRECTION),
                            end: get2(g, nn.END)
                        },
                        clientContentForMediaController: g.webRtcSignalingManager.getClientUrls(),
                        mediaContent: f,
                        pstnContent: g.pstnContent,
                        locationContent: g.getLocationContent(),
                        networkContent: g.getNetworkContent(),
                        areaContent: g.getAreaContent(),
                        sharedLineCallInvitationContent: v.sharedLineCallInvitationContent,
                        invitationData: v.invitationData,
                        callQueueContext: v.callQueueContext
                    };
                }
                if (g.signalingAgentConfig.ecsEtag && (b.payload.debugContent = {
                    ecsEtag: g.signalingAgentConfig.ecsEtag
                }), _ && (b.payload.debugContent || (b.payload.debugContent = {}), b.payload.debugContent.causeId = _), v.clientEndpointDebugContent) {
                    b.payload.debugContent || (b.payload.debugContent = {});
                    try {
                        b.payload.debugContent.clientDebugContent = JSON.parse(v.clientEndpointDebugContent);
                    } catch (g) {
                        assert2(!1, `Failed to parse ${v.clientEndpointDebugContent}`);
                    }
                }
                if (v.captchaContentJson) try {
                    b.payload.conversationRequest.captchaContent = JSON.parse(v.captchaContentJson);
                } catch (g) {
                    assert2(!1, `Failed to parse ${v.captchaContentJson}`);
                }
                return v.callQueueContext && (b.payload.conversationRequest.callQueueContext = v.callQueueContext), v.participationPreferences && (b.payload.participationPreferences = v.participationPreferences), b;
            }
            function getJoinMeetingGroupPayload(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        ..."meetingGroupId" in f && {
                            meetingGroup: f.meetingGroupId
                        },
                        ..."meetingGroupLabel" in f && {
                            meetingGroupLabel: f.meetingGroupLabel
                        },
                        ...f.groupPreferences && {
                            groupPreferences: f.groupPreferences
                        },
                        links: {
                            joinMeetingGroupStatus: get2(g, nn.JOIN_MEETING_GROUP_STATUS)
                        },
                        operationId: S
                    }
                };
            }
            function getPayload37(g, f, S, v) {
                assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f);
                const _ = {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            scope: v && "all" !== v ? void 0 : v
                        },
                        conversationTransactionEnd: {
                            reason: "noError",
                            code: an.CALL_END_CODE.SUCCESS,
                            phrase: an.CALL_END_PHRASE.CONV_END_NO_MODALITY
                        },
                        callTransactionEnd: f
                    }
                };
                return S && f.code === an.CALL_END_CODE.CANCEL && (_.payload.callTransactionEnd.callQualityDiagnosticsInformation = S), _;
            }
            function getLeaveMeetingGroupPayload(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                const { meetingGroupId: v } = f;
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        meetingGroup: v,
                        links: {
                            leaveMeetingGroupStatus: get2(g, nn.LEAVE_MEETING_GROUP_STATUS)
                        },
                        operationId: S
                    }
                };
            }
            function getPayload38(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), assertNotNull(S, "newOfferLink cannot be null"), {
                    payload: {
                        mediaOfferRequirements: {
                            compatibleContentTypes: f,
                            links: {
                                offerReady: get2(g, nn.NEW_MEDIA_OFFER)
                            }
                        }
                    }
                };
            }
            function getPayload39(g, f) {
                return assertNotNull(f, "signalingSession cannot be null"), {
                    payload: {
                        callTransfer: {
                            target: {
                                id: f.participantManager.localParticipant.id
                            },
                            transferor: {
                                details: {
                                    id: f.participantManager.localParticipant.id,
                                    endpointId: f.participantManager.localParticipant.endpointId,
                                    participantId: f.participantManager.localParticipant.participantId,
                                    languageId: f.participantManager.localParticipant.languageId
                                },
                                authorizationToken: null
                            },
                            parkType: g,
                            links: {
                                transferAcceptance: get2(f, nn.TRANSFER_ACCEPTANCE),
                                transferCompletion: get2(f, nn.TRANSFER_COMPLETION)
                            }
                        }
                    }
                };
            }
            function getPayload40(g, f, S) {
                assertNotNull(g, "ParkRequestPayload: signalingSession cannot be null");
                const v = {
                    payload: {
                        hold: {
                            holdType: f,
                            links: {
                                holdCompletion: get2(g, nn.PARK_COMPLETION)
                            }
                        }
                    }
                };
                return S && (v.payload.debugContent = S), v;
            }
            function getPayload41(g) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        callParticipantUpdate: {
                            links: getLinksPayload(g, en),
                            clientContentForMediaController: g.webRtcSignalingManager.getClientUrls()
                        }
                    }
                };
            }
            function getPayload42(g, f, S, v, _, C) {
                const E = {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        publishedState: {
                            content: v,
                            level: S,
                            stateType: f,
                            sequenceNumber: g.getPublishStateSequenceNumber()
                        },
                        scope: _
                    }
                };
                if (C && C.length > 0) {
                    const g = C.map((g)=>({
                            id: g
                        }));
                    E.payload.to = g;
                }
                return E;
            }
            function getPayload43(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), assertCallEndReason(f), {
                    payload: {
                        callEnd: f
                    }
                };
            }
            function getPayload44(g, f, S, v) {
                const _ = {
                    from: {
                        id: g.participantManager.localParticipant.id,
                        displayName: g.participantManager.localParticipant.displayName,
                        endpointId: g.participantManager.localParticipant.endpointId,
                        participantId: g.participantManager.localParticipant.participantId,
                        languageId: g.participantManager.localParticipant.languageId
                    },
                    sequenceNumber: g.getPublishStateSequenceNumber(),
                    scope: f
                };
                return "specified" === f ? _.stateIds = S : _.stateType = v, {
                    payload: _
                };
            }
            function getPayload45(g, f) {
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        searchOptions: f
                    }
                };
            }
            function getPayload46(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId,
                            displayName: g.participantManager.localParticipant.displayName
                        },
                        ...f,
                        links: {
                            setMeetingLayoutStatus: get2(g, nn.SET_MEETING_LAYOUT_STATUS)
                        }
                    }
                };
            }
            function getPayload47() {
                return {
                    payload: {
                        transferAcceptance: {}
                    }
                };
            }
            function getPayload48(g, f, S, v, _) {
                assertNotNull(f, "signalingSession cannot be null"), assertNotNullOrEmpty(g, "transferTarget cannot be null OR empty");
                return {
                    payload: {
                        callTransfer: {
                            target: {
                                id: g,
                                endpointType: "TransferTypeVoicemail" === v ? "voicemail" : void 0
                            },
                            transferor: {
                                details: {
                                    id: f.participantManager.localParticipant.id,
                                    endpointId: f.participantManager.localParticipant.endpointId,
                                    participantId: f.participantManager.localParticipant.participantId,
                                    languageId: f.participantManager.localParticipant.languageId
                                },
                                authorizationToken: null
                            },
                            links: {
                                transferAcceptance: get2(f, nn.TRANSFER_ACCEPTANCE),
                                transferCompletion: get2(f, nn.TRANSFER_COMPLETION)
                            },
                            replacementDetails: S,
                            disableForwardingAndUnanswered: _ && _.disableForwardingAndUnanswered,
                            transferContext: _ && _.clientTransferContext
                        }
                    }
                };
            }
            function getPayload49(g) {
                return {
                    payload: {
                        transferCompletion: g
                    }
                };
            }
            function getPayload50(g, f) {
                assertNotNull(g, "ResumePayload: signalingSession cannot be null");
                const S = {
                    payload: {
                        resume: {
                            links: {
                                resumeCompletion: get2(g, nn.UNPARK_COMPLETION)
                            }
                        }
                    }
                };
                return f && (S.payload.debugContent = f), S;
            }
            function getPayload51(g, f) {
                return assertNotNull(f, "clientMetadataJson cannot be null"), {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        endpointMetadata: f
                    }
                };
            }
            function getPayload52(g, f, S, v, _) {
                assertNotNull(f, "clientStateJson cannot be null");
                const C = {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        endpointState: f
                    }
                };
                if (_) try {
                    C.payload.captchaContent = JSON.parse(_);
                } catch (f) {
                    g.logger.warn("updateEndpointState getPayload() failed to parse captchaContentJson");
                }
                if ((S === null || S === void 0 ? void 0 : S.publishedStates.length) > 0) {
                    let f = [];
                    f = S.publishedStates.map((f)=>{
                        let S = {};
                        try {
                            S = JSON.parse(f.content);
                        } catch (f) {
                            g.logger.warn("updateEndpointState getPayload() failed to parse stateType.content");
                        }
                        return {
                            stateType: f.type,
                            level: f.level,
                            content: S,
                            sequenceNumber: g.getPublishStateSequenceNumber()
                        };
                    }), C.payload.publishedStates = f;
                }
                return v && (C.payload.links = {
                    updateEndpointStateStatus: get2(g, nn.DISABLE_PREHEAT_ASYNC_STATUS)
                }), C;
            }
            function getMeetingGroupsPayload(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                const { scope: v, toGroup: _, fromGroup: C, participants: E } = f;
                "specified" === v && assertNotNull(E, "participantsIds cannot be null");
                const T = {
                    from: {
                        id: g.participantManager.localParticipant.id,
                        endpointId: g.participantManager.localParticipant.endpointId,
                        participantId: g.participantManager.localParticipant.participantId,
                        languageId: g.participantManager.localParticipant.languageId,
                        displayName: g.participantManager.localParticipant.displayName
                    },
                    scope: v,
                    fromGroup: C,
                    toGroup: _,
                    links: {
                        updateMeetingGroupsStatus: get2(g, nn.UPDATE_MEETING_GROUPS_STATUS)
                    },
                    operationId: S
                };
                return E && (T.to = E.map((g)=>({
                        id: g.mri,
                        endpointId: g.endpointId,
                        participantId: g.participantId
                    }))), {
                    payload: T
                };
            }
            function getPayload53(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId,
                            displayName: g.participantManager.localParticipant.displayName
                        },
                        meetingLiveState: f,
                        links: {
                            updateMeetingLiveStateStatus: get2(g, nn.UPDATE_MEETING_LIVE_STATE_STATUS)
                        },
                        operationId: S
                    }
                };
            }
            function getPayload54(g, f) {
                const S = {};
                return void 0 !== f.allowRaiseHands && (S.allowRaiseHands = f.allowRaiseHands), void 0 !== f.attendeeRestrictions && (S.attendeeRestrictions = f.attendeeRestrictions), void 0 !== f.lockMeeting && (S.lockMeeting = f.lockMeeting), void 0 !== f.breakoutRoomsEnabled && (S.breakoutRoomsEnabled = f.breakoutRoomsEnabled), void 0 !== f.allowPresentersToManageBreakoutRooms && (S.allowPresentersToManageBreakoutRooms = f.allowPresentersToManageBreakoutRooms), void 0 !== f.disableMdpClientAudioRecording && (S.disableMdpClientAudioRecording = f.disableMdpClientAudioRecording), void 0 !== f.refreshSettings && (S.refreshSettings = f.refreshSettings), void 0 !== f.aiInterpretationEnabled && (S.aiInterpretationEnabled = f.aiInterpretationEnabled), void 0 !== f.groupCopilotDetails && (S.groupCopilotDetails = f.groupCopilotDetails), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            displayName: g.participantManager.localParticipant.displayName,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId
                        },
                        meetingSettings: S,
                        sequenceNumber: g.getPublishStateSequenceNumber()
                    }
                };
            }
            function getPayload55(g, f, S, v) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        monitorContent: {
                            sequenceId: g.getMonitorSequenceId(),
                            monitorActionType: f,
                            monitorData: S !== null && S !== void 0 ? S : {},
                            links: {
                                monitorCompletion: get2(g, nn.MONITOR_COMPLETION)
                            }
                        },
                        debugContent: {
                            causeId: v
                        }
                    }
                };
            }
            function getPayload56(g) {
                assertNotNull(g, "signalingSession cannot be null");
                const f = {
                    type: "Delta",
                    rosterUpdate: get2(g, tn.CONV_ROSTER_UPDATE)
                };
                return {
                    payload: {
                        participants: {
                            from: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            }
                        },
                        roster: f,
                        links: getLinksPayload(g, tn)
                    }
                };
            }
            function getUpdateParticipantsPropertiesPayload(g, f, S) {
                assertNotNull(g, "signalingSession cannot be null");
                return {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId
                        },
                        to: f,
                        links: {
                            updateParticipantPropertiesStatus: get2(g, nn.UPDATE_PARTICIPANT_PROPERTIES_STATUS)
                        },
                        operationId: S
                    }
                };
            }
            function getPayload57(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        mediaAnswer: {
                            sender: {
                                id: g.participantManager.localParticipant.id,
                                displayName: g.participantManager.localParticipant.displayName,
                                endpointId: g.participantManager.localParticipant.endpointId,
                                participantId: g.participantManager.localParticipant.participantId,
                                languageId: g.participantManager.localParticipant.languageId
                            },
                            mediaContent: f,
                            pstnContent: g.pstnContent
                        }
                    }
                };
            }
            function getPayload58(g, f) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        UpdateMediaDescriptions: {
                            mediaDescriptions: f
                        }
                    }
                };
            }
            function getPayload59(g, f, S) {
                return assertNotNull(g, "signalingSession cannot be null"), {
                    payload: {
                        from: {
                            id: g.participantManager.localParticipant.id,
                            endpointId: g.participantManager.localParticipant.endpointId,
                            participantId: g.participantManager.localParticipant.participantId,
                            languageId: g.participantManager.localParticipant.languageId,
                            displayName: g.participantManager.localParticipant.displayName
                        },
                        meetingStates: f,
                        updateMeetingStatesStatus: get2(g, nn.UPDATE_MEETING_STATES_STATUS),
                        operationId: S
                    }
                };
            }
            var Kn = __toESM(P), Jn = __toESM(Te()), Yn = [
                "CorrelationId",
                "SignalingSessionId",
                "Region",
                "ParticipantId",
                "ClientInformation",
                "ResultCode",
                "ResultDetail",
                "ResultValue",
                "Direction",
                "ClientType",
                "MeetingRoles"
            ], Qn = class {
                createCallModalityEvent(g) {
                    const f = {};
                    f.Type = un.SOURCE.NGC_SOURCE;
                    const setEventPropertyIfRecorded = (S, v = !1)=>{
                        g.hasOwnProperty(S) && (f[S] = v ? JSON.stringify(g[S]) : g[S]);
                    };
                    if (f.ResultDetail = g[un.EXTENSIONS.RESULT_DETAIL], f.ResultValue = g[un.EXTENSIONS.RESULT_VALUE], f.ResultCode = g[un.EXTENSIONS.CALL_END_CODE], f.ResultCauseId = g[un.EXTENSIONS.RESULT_CAUSE_ID], f[un.SIGNALING_CONFIG] = this.getSignalingAgentConfig(), f[un.CONTEXT_ID.CORRELATION_ID] = this.signalingSession.correlationId, f[un.CONTEXT_ID.SIGNALING_SESSION_ID] = this.signalingSession.sessionId, f[un.CONTEXT_ID.ENDPOINT_ID] = g[un.CONTEXT_ID.ENDPOINT_ID], f[un.CONTEXT_ID.PARTICIPANT_ID] = g[un.CONTEXT_ID.PARTICIPANT_ID], f[un.EXTENSIONS.ECS_ETAG] = this.signalingSession.signalingAgentConfig.ecsEtag, f[un.EXTENSIONS.CONVERSATION_SERVICE_URL] = g[un.EXTENSIONS.CONVERSATION_SERVICE_URL], f[un.EXTENSIONS.CALL_START_TIME] = JSON.stringify(g[un.EXTENSIONS.CALL_START_TIME]), f[un.EXTENSIONS.CALL_END_TIME] = JSON.stringify(g[un.EXTENSIONS.CALL_END_TIME]), f[un.EXTENSIONS.MESSAGING_CHANNEL] = JSON.stringify(g[un.EXTENSIONS.MESSAGING_CHANNEL]), f[un.EXTENSIONS.IS_GROUP_CALL] = this.signalingSession.multiParty ? "true" : "false", f[un.EXTENSIONS.IS_HOSTLESS_CALL] = this.signalingSession.isHostLessCall ? "true" : "false", f[un.EXTENSIONS.IS_CAST_CALL] = this.signalingSession.isCastCall ? "true" : "false", f[un.EXTENSIONS.IS_HUDDLE_GROUP_CALL] = this.signalingSession.isHuddleGroupCall ? "true" : "false", f[un.EXTENSIONS.IS_ON_BEHALF_OF_CALL] = this.signalingSession.onBehalfOf ? "true" : "false", f[un.EXTENSIONS.CLIENT_INFORMATION] = g[un.EXTENSIONS.CLIENT_INFORMATION], f[un.EXTENSIONS.IS_SDP_IN_CALL_NOTIFICATION] = g[un.EXTENSIONS.IS_SDP_IN_CALL_NOTIFICATION], f[un.EXTENSIONS.CALL_TERMINATING_END] = g[un.EXTENSIONS.CALL_TERMINATING_END], f[un.EXTENSIONS.CALL_END_CODE] = JSON.stringify(g[un.EXTENSIONS.CALL_END_CODE]), f[un.EXTENSIONS.CALL_END_SUB_CODE] = JSON.stringify(g[un.EXTENSIONS.CALL_END_SUB_CODE]), setEventPropertyIfRecorded(un.CONTEXT_ID.SHARED_CORRELATION_ID), setEventPropertyIfRecorded(un.EXTENSIONS.DIRECTION), setEventPropertyIfRecorded(un.EXTENSIONS.SELF_PARTICIPANT_ROLE), setEventPropertyIfRecorded(un.EXTENSIONS.CONNECTED_DURATION_IN_MS, !0), setEventPropertyIfRecorded(un.EXTENSIONS.TIME_TO_RING_IN_MS, !0), setEventPropertyIfRecorded(un.EXTENSIONS.NETWORK_REQUESTS_COMPLETED), setEventPropertyIfRecorded(un.EXTENSIONS.NETWORK_REQUESTS_PENDING), setEventPropertyIfRecorded(un.EXTENSIONS.LOCAL_OPERATIONS_PERFORMED), setEventPropertyIfRecorded(un.EXTENSIONS.EVENT_TIMESTAMP_BAG), setEventPropertyIfRecorded(un.EXTENSIONS.ROSTER_UPDATES_BAG), setEventPropertyIfRecorded(un.EXTENSIONS.NETWORK_REQUESTS_BAG), setEventPropertyIfRecorded(un.EXTENSIONS.TROUTER_WAIT_OPERATIONS), setEventPropertyIfRecorded(un.EXTENSIONS.LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS), setEventPropertyIfRecorded(un.EXTENSIONS.OUTGOING_MODALITIES), setEventPropertyIfRecorded(un.EXTENSIONS.INCOMING_MODALITIES), setEventPropertyIfRecorded(un.EXTENSIONS.OFFERED_MODALITIES), setEventPropertyIfRecorded(un.EXTENSIONS.ANSWERED_MODALITIES), setEventPropertyIfRecorded(un.EXTENSIONS.VBSS_OPERATIONS), setEventPropertyIfRecorded(un.EXTENSIONS.CALLER_TYPE), setEventPropertyIfRecorded(un.EXTENSIONS.CALLEE_TYPE), setEventPropertyIfRecorded(un.EXTENSIONS.SCENARIO), setEventPropertyIfRecorded(un.EXTENSIONS.PREHEATED_CALL_SETUP_DURATION_IN_S), setEventPropertyIfRecorded(un.EXTENSIONS.CALL_CANCELATION_DURATION_IN_S), setEventPropertyIfRecorded(un.EXTENSIONS.IS_PREHEATED), setEventPropertyIfRecorded(un.EXTENSIONS.ACS_RESOURCE_ID), setEventPropertyIfRecorded(un.EXTENSIONS.CALL_END_RESULT_CATEGORIES), setEventPropertyIfRecorded(un.EXTENSIONS.APPLICATION_TYPE), setEventPropertyIfRecorded(un.EXTENSIONS.RING), setEventPropertyIfRecorded(un.EXTENSIONS.REGION), setEventPropertyIfRecorded(un.EXTENSIONS.PARTITION), setEventPropertyIfRecorded(un.EXTENSIONS.JOINED_FROM), setEventPropertyIfRecorded(un.EXTENSIONS.MEETING_URL), setEventPropertyIfRecorded(un.EXTENSIONS.MEETING_CODE), setEventPropertyIfRecorded(un.EXTENSIONS.USER_HEX_CID), setEventPropertyIfRecorded(un.EXTENSIONS.BROADCAST_MEETING_ROLE), setEventPropertyIfRecorded(un.EXTENSIONS.MEETING_ROLE), setEventPropertyIfRecorded(un.EXTENSIONS.ADVANCED_MEETING_ROLE), setEventPropertyIfRecorded(un.EXTENSIONS.MEETING_ROLES, !0), setEventPropertyIfRecorded(un.EXTENSIONS.PARTICIPANT_TYPE), setEventPropertyIfRecorded(un.EXTENSIONS.AUDIO_ONLY_WATERMARK), setEventPropertyIfRecorded(un.EXTENSIONS.TARGET_APPLICATION_TYPE), setEventPropertyIfRecorded(un.EXTENSIONS.IS_REINVITELESS), setEventPropertyIfRecorded(un.EXTENSIONS.CLIENT_TYPE), this.signalingSession.callType && (f[un.EXTENSIONS.CALL_TYPE] = this.signalingSession.callType), this.signalingSession.signalingAgentConfig.testCall && (f[un.EXTENSIONS.TEST_CONTEXT_ID] = "Test"), this.signalingSession.groupId && (f[un.CONTEXT_ID.GROUP_ID] = scrubMriOrOmit(this.signalingSession.groupId)), this.signalingSession.threadId && (f[un.CONTEXT_ID.THREAD_ID] = getLoggableThreadId(this.signalingSession.threadId)), this.signalingSession.teamsMessageId && (f[un.CONTEXT_ID.TEAMS_MESSAGEID] = this.signalingSession.teamsMessageId), this.signalingSession.getMeetingInfo()) {
                        const g = {
                            ...this.signalingSession.getMeetingInfo()
                        };
                        g.hasOwnProperty("organizerId") && (g.organizerId = scrubMriOrOmit(g.organizerId)), f[un.CONTEXT_ID.TEAMS_MEETINGINFO] = JSON.stringify(g);
                    }
                    return this.signalingSession.multiParty && 0 === this.signalingSession.numberOfOriginalInvitees && g.hasOwnProperty(un.EXTENSIONS.SELF_PARTICIPANT_ROLE) && g[un.EXTENSIONS.SELF_PARTICIPANT_ROLE] === un.ROLE.CALLER && (f[un.EXTENSIONS.IS_MEETUP_CALL] = "true"), f;
                }
                constructor(g, f){
                    var _this_signalingSession_signalingAgentConfig_oneDsTelemetryLogger;
                    this.signalingSession = g, this.logger = f, this.logConversationCallModalityEvent = (g)=>{
                        const f = this.createCallModalityEvent(g);
                        this.logger.info("sending modality telemetry:", this.getStringifiedEventData(f)), f.hostName = this.getHostDomainInfo(), this.telemetryLogger.sendEvent(un.EVENT_TYPE.CONVERSATION_CALL_MODALITY, f);
                    }, this.logConversationContentSharingEvent = (g)=>{
                        g[un.CONTEXT_ID.CORRELATION_ID] = this.signalingSession.correlationId, g[un.EXTENSIONS.ECS_ETAG] = this.signalingSession.signalingAgentConfig.ecsEtag, this.logger.info("sending content sharing telemetry:", this.getStringifiedEventData(g)), g.hostName = this.getHostDomainInfo(), this.telemetryLogger.sendEvent(un.EVENT_TYPE.CONVERSATION_CONTENT_SHARING, g);
                    }, this.logHttpTelemetryEvent = (g)=>{
                        g[un.EXTENSIONS.ECS_ETAG] = this.signalingSession.signalingAgentConfig.ecsEtag, g[un.SIGNALING_CONFIG] = this.getSignalingAgentConfig(), this.logger.info("sending http telemetry:", this.getStringifiedEventData(g)), g.hostName = this.getHostDomainInfo(), this.telemetryLogger.sendEvent(un.EVENT_TYPE.CONVERSATION_HTTP_REQUEST, g);
                    }, this.getHostDomainInfo = ()=>"localhost" === location.hostname || "127.0.0.1" === location.hostname ? "localhost" : "<redacted>", this.getSignalingAgentConfig = ()=>{
                        const g = [], f = this.signalingSession.signalingAgentConfig;
                        return f.supportsCompressedServicePayload && g.push(un.SIGNALING_CONFIG_FLAGS.SUPPORTS_COMPRESSED_PAYLOAD), f.brokerEnabledOutgoing && g.push(un.SIGNALING_CONFIG_FLAGS.BROKER_OUTGOING_ENABLED), f.brokerEnabledIncoming && g.push(un.SIGNALING_CONFIG_FLAGS.BROKER_INCOMING_ENABLED), f.brokerRequestBatching && g.push(un.SIGNALING_CONFIG_FLAGS.BROKER_REQUEST_BATCHING_ENABLED), f.brokerExclusively && g.push(un.SIGNALING_CONFIG_FLAGS.BROKER_EXCLUSIVELY_ENABLED), f.supportsSynchronousTrouterResponse && g.push(un.SIGNALING_CONFIG_FLAGS.SYNC_TROUTER_RESPONSE), f.handleMediaOfferFromPushNotification && g.push(un.SIGNALING_CONFIG_FLAGS.HANDLE_OFFER_FROM_NOTIFICATION), f.handleNewOfferRequest && g.push(un.SIGNALING_CONFIG_FLAGS.HANDLE_NEW_OFFER_REQUEST), f.sendProgressFromCC && g.push(un.SIGNALING_CONFIG_FLAGS.SEND_PROGRESS_FROM_CC), f.useInternalHttpDispatcher && g.push(un.SIGNALING_CONFIG_FLAGS.INTERNAL_HTTP_DISPATCHER), f.enableTokenCache && g.push(un.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_CACHE), f.enableTokenPrefetch && g.push(un.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_PREFETCH), f.supportMediaRetargetWhileIncomingRenegotiation && g.push(un.SIGNALING_CONFIG_FLAGS.SUPPORT_MEDIA_RETARGET_WHILE_INCOMING_RENEGOTIATION), f.enableCallEstablishmentTimeoutsForStartJoinCall && g.push(un.SIGNALING_CONFIG_FLAGS.ENABLE_CALL_ESTABLISHMENT_TIMEOUTS_FOR_START_OR_JOIN_CALL), f.enableTokenCacheForGenericTokenAPI && g.push(un.SIGNALING_CONFIG_FLAGS.ENABLE_TOKEN_CACHE_FOR_GENERIC_TOKEN_API), f.enableLongOutgoing1To1SetupTimeoutForWeb && g.push(un.SIGNALING_CONFIG_FLAGS.ENABLE_LONG_OUTGOING_1TO1_SETUP), g.push(un.SIGNALING_CONFIG_FLAGS.SERVER_MUTE_UNMUTE), g.join(",");
                    }, this.getStringifiedEventData = (g)=>{
                        try {
                            return JSON.stringify(g, Yn, 4);
                        } catch (g) {
                            return "invalid data";
                        }
                    }, this.telemetryLogger = (_this_signalingSession_signalingAgentConfig_oneDsTelemetryLogger = this.signalingSession.signalingAgentConfig.oneDsTelemetryLogger) !== null && _this_signalingSession_signalingAgentConfig_oneDsTelemetryLogger !== void 0 ? _this_signalingSession_signalingAgentConfig_oneDsTelemetryLogger : this.signalingSession.signalingAgentConfig.telemetryManager;
                }
            };
            function getLogger(g, f) {
                return new Qn(g, f);
            }
            var Xn = class {
                fillCommonData(g, f) {
                    f[un.EXTENSIONS.APPLICATION_TYPE] = g.applicationType, f[un.EXTENSIONS.RING] = g.ring, f[un.EXTENSIONS.TENANT_ID] = g.tenantId, f[un.EXTENSIONS.USER_HEX_CID] = g.userHexCID, f[un.EXTENSIONS.ACS_RESOURCE_ID] = g.acsResourceId, f[un.EXTENSIONS.REGION] = g.region, f[un.EXTENSIONS.PARTITION] = g.partition, f[un.EXTENSIONS.CLIENT_TYPE] = g.clientType;
                }
                addChangingCorrelationId(g, f) {
                    this.telemetryData[un.EXTENSIONS.CHANGING_CORRELATION_ID_OLD_ID] = g, this.telemetryData[un.EXTENSIONS.CHANGING_CORRELATION_ID_NEW_ID] = f;
                }
                addSharedCorrelationId(g) {
                    this.telemetryData[un.CONTEXT_ID.SHARED_CORRELATION_ID] = g;
                }
                setMeetingRoles(g) {
                    this.telemetryData[un.EXTENSIONS.MEETING_ROLES] = g;
                }
                sendContentSharingTelemetryData(g, f, S, v, _, C) {
                    const E = {
                        ...this.contentSharingBaseTelemetryData
                    }, T = this.contentSharingOperationsPerformed[g];
                    T && (E[un.EXTENSIONS.EVENT_TIMESTAMP_BAG] = JSON.stringify(T)), E[un.CONTEXT_ID.CONTENT_SHARING_CORRELATION_ID] = g, E[un.CONTEXT_ID.SIGNALING_SESSION_ID] = f, E[un.CONTEXT_ID.CONTENT_SHARING_ID] = C || "", E[un.EXTENSIONS.CONTENT_SHARING_SERVICE_URL] = _, E[un.EXTENSIONS.CONTENT_SHARING_DIRECTION] = S ? un.DIRECTION.OUTGOING : un.DIRECTION.INCOMING, E[un.EXTENSIONS.CALL_END_CODE] = v.code, E[un.EXTENSIONS.CALL_END_SUB_CODE] = v.subCode, E[un.EXTENSIONS.CALL_PHRASE] = v.phrase, E[un.EXTENSIONS.CALL_END_RESULT_CATEGORIES] = this.getResultCategoryString(v.resultCategories), E[un.EXTENSIONS.CALL_END_CAUSE_ID] = v.causeId, E[un.EXTENSIONS.CLIENT_INFORMATION] = this.signalingSession.signalingAgentConfig.clientInformation, delete this.contentSharingOperationsPerformed[g], this.telemetryLogger.logConversationContentSharingEvent(E);
                }
                recordOperation(g) {
                    return `${g}:${this.timeSinceCallStart()}`;
                }
                timeSinceCallStart() {
                    return (new Date).getTime() - this.callStartTime;
                }
                sendCallModalityTelemetryData() {
                    this.vbssStarted && this.addVbssOperations(un.VBSS_OPERATION.CALL_END);
                    const durationMsToS = (g)=>"number" == typeof g ? g / 1e3 : 0;
                    if (this.telemetryData[un.EXTENSIONS.CLIENT_INFORMATION] = this.signalingSession.signalingAgentConfig.clientInformation, this.telemetryData[un.EXTENSIONS.CALL_END_TIME] = (new Date).getTime(), this.connectedStopWatch && (this.telemetryData[un.EXTENSIONS.CONNECTED_DURATION_IN_MS] = this.connectedStopWatch.duration()), this.telemetryData[un.EXTENSIONS.IS_PREHEATED] = this.isPreheated, this.preheatedCallSetupDurationWatch && (this.telemetryData[un.EXTENSIONS.PREHEATED_CALL_SETUP_DURATION_IN_S] = durationMsToS(this.preheatedCallSetupDurationWatch.duration())), this.callCancelationDurationWatch && (this.telemetryData[un.EXTENSIONS.CALL_CANCELATION_DURATION_IN_S] = durationMsToS(this.callCancelationDurationWatch.duration())), this.networkRequestsCompleted.length && (this.telemetryData[un.EXTENSIONS.NETWORK_REQUESTS_COMPLETED] = JSON.stringify(this.networkRequestsCompleted)), this.localOperationsPerformed.length && (this.telemetryData[un.EXTENSIONS.LOCAL_OPERATIONS_PERFORMED] = JSON.stringify(this.localOperationsPerformed)), this.trouterWaitOperations.length && (this.telemetryData[un.EXTENSIONS.TROUTER_WAIT_OPERATIONS] = JSON.stringify(this.trouterWaitOperations)), this.localOfferAnswerGenerationTimestamps.length && (this.telemetryData[un.EXTENSIONS.LOCAL_OFFER_ANSWER_GENERATION_TIMESTAMPS] = JSON.stringify(this.localOfferAnswerGenerationTimestamps)), this.incomingModalities.length && (this.telemetryData[un.EXTENSIONS.INCOMING_MODALITIES] = JSON.stringify(this.incomingModalities)), this.outgoingModalities.length && (this.telemetryData[un.EXTENSIONS.OUTGOING_MODALITIES] = JSON.stringify(this.outgoingModalities)), this.offeredModalities.length && (this.telemetryData[un.EXTENSIONS.OFFERED_MODALITIES] = this.offeredModalities), this.answeredModalities.length && (this.telemetryData[un.EXTENSIONS.ANSWERED_MODALITIES] = this.answeredModalities), this.telemetryData[un.EXTENSIONS.CALL_END_RESULT_CATEGORIES] = this.getResultCategoryString(this.telemetryData[un.EXTENSIONS.CALL_END_RESULT_CATEGORIES]), this.telemetryData[un.EXTENSIONS.IS_SDP_IN_CALL_NOTIFICATION] = this.isSdpInCallNotification.toString(), this.vbssOperations.length && (this.telemetryData[un.EXTENSIONS.VBSS_OPERATIONS] = JSON.stringify(this.vbssOperations)), this.recordedEvents.length) {
                        const g = JSON.stringify({
                            eventStart: this.callStartTime,
                            events: this.recordedEvents
                        });
                        this.telemetryData[un.EXTENSIONS.EVENT_TIMESTAMP_BAG] = g;
                    }
                    if (this.rosterUpdates.length) {
                        const g = JSON.stringify({
                            eventStart: this.callStartTime,
                            events: this.rosterUpdates
                        });
                        this.telemetryData[un.EXTENSIONS.ROSTER_UPDATES_BAG] = g;
                    }
                    const g = [];
                    for (const f of Object.keys(this.networkRequestsStarted))g.push(this.networkRequestsStarted[f]);
                    g.length > 0 && (this.telemetryData[un.EXTENSIONS.NETWORK_REQUESTS_PENDING] = JSON.stringify(g)), this.telemetryData[un.EXTENSIONS.IS_REINVITELESS] = this.isReinviteless, this.telemetryLogger.logConversationCallModalityEvent(this.telemetryData);
                }
                getResultCategoryString(g) {
                    return g && Array.isArray(g) ? g.join(",") : "";
                }
                constructor(g, f, S){
                    this.signalingSession = g, this.callStartTime = S, this.networkRequestsCompleted = [], this.networkRequestsStarted = {}, this.networkRequests = {}, this.localOperationsPerformed = [], this.recordedEvents = [], this.rosterUpdates = [], this.contentSharingOperationsPerformed = {}, this.outgoingModalities = [], this.incomingModalities = [], this.offeredModalities = "", this.answeredModalities = "", this.vbssOperations = [], this.vbssStarted = !1, this.localOfferAnswerGenerationTimestamps = [], this.trouterWaitOperations = [], this.telemetryData = {}, this.contentSharingBaseTelemetryData = {}, this.httpRequestTelemetryData = {}, this.connectedStopWatch = null, this.preheatedCallSetupDurationWatch = null, this.callCancelationDurationWatch = null, this.timeToRingStopWatch = null, this.isSdpInCallNotification = !1, this.isPreheated = 0, this.isReinviteless = 0, this.addBrokerChannel = ()=>{
                        this.setMessagingChannel(un.MESSAGING_CHANNEL.BROKER);
                    }, this.addTrouterChannel = ()=>{
                        this.setMessagingChannel(un.MESSAGING_CHANNEL.TROUTER);
                    }, this.addTrouterWaitOperation = (g)=>{
                        this.trouterWaitOperations.push(this.recordOperation(g));
                    }, this.recordIncomingEvent = (g, f, S)=>{
                        const v = extractCauseIdFromMessage(f), _ = {
                            origin: f.origin,
                            causeId: v,
                            data: S
                        };
                        S || delete _.data, this.recordEvent(g, _);
                    }, this.recordIncomingEventCount = (g)=>{
                        this.localOperationsPerformed.push(this.recordOperation(g));
                        const f = this.recordedEvents.findIndex((f)=>f[g]);
                        if (-1 !== f) this.recordedEvents[f][g] += 1;
                        else {
                            const f = {};
                            f[g] = 1, this.recordedEvents.push(f);
                        }
                    }, this.recordEvent = (g, f)=>{
                        this.logger.debug("Event:", g, f), this.localOperationsPerformed.push(this.recordOperation(g));
                        const S = {};
                        S[g] = this.timeSinceCallStart(), f && (S.data = f), this.recordedEvents.push(S);
                    }, this.recordRosterEvent = (g, f, S)=>{
                        this.localOperationsPerformed.push(this.recordOperation(f));
                        const v = {
                            data: g,
                            causeId: S
                        }, _ = {
                            eventName: this.timeSinceCallStart(),
                            data: v
                        };
                        this.rosterUpdates.push(_);
                    }, this.addOutgoingModalities = (g)=>{
                        g && this.outgoingModalities.push(g);
                    }, this.addIncomingModalities = (g)=>{
                        g && this.incomingModalities.push(g);
                    }, this.setOfferedModalities = (g, f)=>{
                        this.offeredModalities = this.sdpTelemetryFormat(g, f);
                    }, this.setAnsweredModalities = (g, f)=>{
                        this.answeredModalities = this.sdpTelemetryFormat(g, f);
                    }, this.setIsSdpInCallNotification = (g)=>{
                        this.isSdpInCallNotification = g;
                    }, this.addVbssOperations = (g)=>{
                        g && (g === un.VBSS_OPERATION.START ? this.vbssStarted = !0 : this.vbssStarted = !1, this.vbssOperations.push(this.recordOperation(g)));
                    }, this.addNetworkOperationStarted = (g)=>{
                        tryAddNewKeyToHashTable(this.networkRequestsStarted, g, this.recordOperation(g));
                    }, this.addNetworkOperationCompleted = (g, f, S)=>{
                        const v = f ? un.RESULT_VALUE.SUCCESS : un.RESULT_VALUE.FAILURE, _ = S ? `${g}:${v}:${S}` : `${g}:${v}`;
                        this.networkRequestsCompleted.push(this.recordOperation(_)), tryRemoveKeyFromHashTable(this.networkRequestsStarted, g);
                    }, this.updateNetworkRequest = (g)=>{
                        this.networkRequests[g.uid] ? Kn.assign(this.networkRequests[g.uid], g) : this.networkRequests[g.uid] = g;
                    }, this.deleteNetworkRequest = (g)=>{
                        delete this.networkRequests[g.uid];
                    }, this.addContentSharingOperation = (g, f, S)=>{
                        this.contentSharingOperationsPerformed[g] || (this.contentSharingOperationsPerformed[g] = []);
                        const v = {
                            [f]: this.timeSinceCallStart()
                        };
                        this.contentSharingOperationsPerformed[g].push(v);
                        const _ = this.contentSharingOperationsPerformed[g].length - 1;
                        return S && this.updateContentSharingOperation(g, _, S), _;
                    }, this.updateContentSharingOperation = (g, f, S)=>{
                        if (!this.contentSharingOperationsPerformed[g]) return;
                        const v = this.contentSharingOperationsPerformed[g][f], _ = [];
                        for (const g of Object.keys(S))_.push(`${g}: ${S[g]}`);
                        v.data = _.join(", ");
                    }, this.setDirection = (g)=>{
                        this.telemetryData[un.EXTENSIONS.DIRECTION] = g;
                    }, this.setEndPointId = (g)=>{
                        this.telemetryData[un.CONTEXT_ID.ENDPOINT_ID] = g, this.contentSharingBaseTelemetryData[un.CONTEXT_ID.ENDPOINT_ID] = g, this.httpRequestTelemetryData[un.CONTEXT_ID.ENDPOINT_ID] = g;
                    }, this.setParticipantId = (g)=>{
                        this.telemetryData[un.CONTEXT_ID.PARTICIPANT_ID] = g, this.contentSharingBaseTelemetryData[un.CONTEXT_ID.PARTICIPANT_ID] = g, this.httpRequestTelemetryData[un.CONTEXT_ID.PARTICIPANT_ID] = g;
                    }, this.addTokenTelemetry = (g, f)=>{
                        var _this_networkRequests;
                        g ? ((_this_networkRequests = this.networkRequests) === null || _this_networkRequests === void 0 ? void 0 : _this_networkRequests[g]) ? (this.networkRequests[g].tokenTelemetries || (this.networkRequests[g].tokenTelemetries = []), this.networkRequests[g].tokenTelemetries.push(f)) : this.logger.info(`[addTokenTelemtry] httprequest: ${g} is not found in networkRequests`) : this.logger.error("[addTokenTelemetry] httprequest uid is undefined");
                    }, this.setConversationServiceUrl = (g)=>{
                        this.telemetryData[un.EXTENSIONS.CONVERSATION_SERVICE_URL] = g;
                    }, this.setMeetingInfo = (g)=>{
                        g || (this.telemetryData[un.EXTENSIONS.MEETING_INFO] = g);
                    }, this.setJoinedFrom = (g)=>{
                        this.telemetryData[un.EXTENSIONS.JOINED_FROM] = g;
                    }, this.setMeetingCode = (g)=>{
                        this.telemetryData[un.EXTENSIONS.MEETING_CODE] = g;
                    }, this.setMeetingUrl = (g)=>{
                        this.telemetryData[un.EXTENSIONS.MEETING_URL] = g;
                    }, this.setBroadcastMeetingRole = (g)=>{
                        this.telemetryData[un.EXTENSIONS.BROADCAST_MEETING_ROLE] = g;
                    }, this.setMeetingRole = (g)=>{
                        this.telemetryData[un.EXTENSIONS.MEETING_ROLE] = g;
                    }, this.setAdvancedMeetingRole = (g)=>{
                        this.telemetryData[un.EXTENSIONS.ADVANCED_MEETING_ROLE] = g;
                    }, this.setParticipantType = (g)=>{
                        this.telemetryData[un.EXTENSIONS.PARTICIPANT_TYPE] = g;
                    }, this.setSelfParticipantRole = (g)=>{
                        this.telemetryData[un.EXTENSIONS.SELF_PARTICIPANT_ROLE] = g;
                    }, this.setAudioOnlyWatermark = (g)=>{
                        this.telemetryData[un.EXTENSIONS.AUDIO_ONLY_WATERMARK] = g;
                    }, this.setWatermarkSupport = (g)=>{
                        this.telemetryData[un.EXTENSIONS.CLIENT_SUPPORT_WATERMARK] = g;
                    }, this.setClientSupportsPreventScreenCapture = (g)=>{
                        this.telemetryData[un.EXTENSIONS.CLIENT_SUPPORTS_PREVENT_SCREEN_CAPTURE] = g;
                    }, this.setScenario = (g)=>{
                        this.telemetryData[un.EXTENSIONS.SCENARIO] = g;
                    }, this.setTargetApplicationType = (g)=>{
                        g && (this.telemetryData[un.EXTENSIONS.TARGET_APPLICATION_TYPE] = g);
                    }, this.setCallerType = (g)=>{
                        g && (this.telemetryData[un.EXTENSIONS.CALLER_TYPE] = g.split(":", 1)[0]);
                    }, this.setCalleeType = (g)=>{
                        g && (this.telemetryData[un.EXTENSIONS.CALLEE_TYPE] = g.split(":", 1)[0]);
                    }, this.setTerminatingData = (g)=>{
                        this.telemetryData[un.EXTENSIONS.CALL_TERMINATING_END] = g.terminatingEnd, this.telemetryData[un.EXTENSIONS.CALL_END_CODE] = g.endCode || an.CALL_END_CODE.SUCCESS, this.telemetryData[un.EXTENSIONS.CALL_END_SUB_CODE] = g.endSubCode || an.CALL_END_SUB_CODE.SUCCESS, this.telemetryData[un.EXTENSIONS.CALL_PHRASE] = g.phrase || an.CALL_END_PHRASE.UNKNOWN, this.telemetryData[un.EXTENSIONS.RESULT_VALUE] = g.resultValue || un.RESULT_VALUE.SUCCESS, this.telemetryData[un.EXTENSIONS.RESULT_DETAIL] = g.resultDetail || "Call gracefully hungup", this.telemetryData[un.EXTENSIONS.RESULT_CAUSE_ID] = g.causeId || "unknown", this.telemetryData[un.EXTENSIONS.CALL_END_RESULT_CATEGORIES] = g.resultCategories || [], this.telemetryData[un.EXTENSIONS.CALL_END_CLIENT_SUB_CODE] = g.clientReasonSubCode, this.telemetryData[un.EXTENSIONS.CALL_END_CLIENT_PHRASE] = g.clientReasonPhrase;
                    }, this.startCallInitializationWatch = (g)=>{
                        this.timeToRingStopWatch = build3(), g && (this.timeToRingStopWatch.msElapsed += g);
                    }, this.startCallConnectedWatch = ()=>{
                        this.connectedStopWatch = build3();
                    }, this.setIsPreheated = ()=>{
                        this.isPreheated = 1;
                    }, this.startPreheatedCallSetupDurationWatch = ()=>{
                        this.preheatedCallSetupDurationWatch = build3();
                    }, this.stopPreheatedCallSetupDurationWatch = ()=>{
                        this.preheatedCallSetupDurationWatch.pause();
                    }, this.startCallCancelationDurationWatch = ()=>{
                        this.callCancelationDurationWatch = build3();
                    }, this.stopCallCancelationDurationWatch = ()=>{
                        this.callCancelationDurationWatch && this.callCancelationDurationWatch.pause();
                    }, this.getCallCancelationDuration = ()=>this.callCancelationDurationWatch ? this.callCancelationDurationWatch.durationInSeconds() : 0, this.resetCallCancelationDurationWatch = ()=>{
                        this.callCancelationDurationWatch = null;
                    }, this.setOfferAnswerGenerationTimestamps = (g)=>{
                        this.localOfferAnswerGenerationTimestamps.push(this.recordOperation(g));
                    }, this.setTimeToRingDuration = ()=>{
                        this.timeToRingStopWatch && (this.telemetryData[un.EXTENSIONS.TIME_TO_RING_IN_MS] = this.timeToRingStopWatch.duration(), this.timeToRingStopWatch = null);
                    }, this.dispose = ()=>{
                        this.sendCallModalityTelemetryData();
                    }, this.setMessagingChannel = (g)=>{
                        this.telemetryData[un.EXTENSIONS.MESSAGING_CHANNEL] || (this.telemetryData[un.EXTENSIONS.MESSAGING_CHANNEL] = []);
                        this.telemetryData[un.EXTENSIONS.MESSAGING_CHANNEL].some((f)=>-1 !== f.indexOf(g)) || this.telemetryData[un.EXTENSIONS.MESSAGING_CHANNEL].push(this.recordOperation(g));
                    }, this.sendHttpTelemetryData = (g)=>{
                        const f = {
                            ...this.httpRequestTelemetryData
                        };
                        f[un.CONTEXT_ID.CORRELATION_ID] = this.signalingSession.correlationId, f[un.CONTEXT_ID.SIGNALING_SESSION_ID] = this.signalingSession.sessionId, f[un.EXTENSIONS.CLIENT_INFORMATION] = this.signalingSession.signalingAgentConfig.clientInformation;
                        const S = JSON.stringify({
                            eventStart: this.callStartTime,
                            events: this.networkRequests[g]
                        });
                        tryRemoveKeyFromHashTable(this.networkRequests, g), f[un.EXTENSIONS.NETWORK_REQUESTS_BAG] = S, this.telemetryLogger.logHttpTelemetryEvent(f);
                    }, this.sdpTelemetryFormat = (g, f)=>{
                        if (!g) return "";
                        const convertType = (g)=>{
                            switch(g){
                                case "main-audio":
                                    return "Audio";
                                case "main-video":
                                    return "Video";
                                case "applicationsharing-video":
                                    return "AppSharing";
                                default:
                                    return;
                            }
                        }, convertDirection = (g)=>{
                            switch(g){
                                case "inactive":
                                    return "Inactive";
                                case "sendonly":
                                    return f ? "ReceiveFromPeer" : "SendToPeer";
                                case "recvonly":
                                    return f ? "SendToPeer" : "ReceiveFromPeer";
                                default:
                                    return "Bidirectional";
                            }
                        }, S = {
                            "main-audio": 0,
                            "main-video": 0,
                            "applicationsharing-video": 0
                        }, v = [], _ = Jn.parse(g);
                        for (const g of _.media){
                            const f = convertType(g.label);
                            if (!f) continue;
                            const _ = S[g.label]++, C = convertDirection(g.direction);
                            v.push(`${f}[${_}] = ${C}`);
                        }
                        return v.join(", ");
                    }, this.setReinviteless = (g)=>{
                        this.isReinviteless = g ? 1 : 0;
                    }, this.logger = g.logger, this.telemetryLogger = getLogger(g, this.logger), this.telemetryData[un.EXTENSIONS.CALL_START_TIME] = this.callStartTime, this.telemetryData[un.EXTENSIONS.CONVERSATION_SERVICE_URL] = g.signalingAgentConfig.conversationServiceUrl, this.fillCommonData(f, this.telemetryData), this.fillCommonData(f, this.httpRequestTelemetryData), this.fillCommonData(f, this.contentSharingBaseTelemetryData);
                }
            }, Zn = class {
                areClientURLsGenerated() {
                    return this.clientUrlsGenerated;
                }
                getIsDominantSpeakerInfoLinkEnabled() {
                    return this.isDominantSpeakerInfoLinkEnabled;
                }
                setIsDominantSpeakerInfoLinkEnabled(g) {
                    this.isDominantSpeakerInfoLinkEnabled = g;
                }
                handleWebRtcNotification(g, f, S = !0) {
                    assert2(this.isWebRtcCall, "ignoring message in non-webrtc call");
                    const v = this.lastSeenSeqNumbers[g];
                    S && f.sequenceNumber <= v ? this.logger.info(`ignoring ${g} . Last seen seq = ${v} current seq = ${f.sequenceNumber}`) : (f.sequenceNumber <= v && this.logger.info(`let listener to handle older ${g} . Last seen seq = ${v} current seq = ${f.sequenceNumber}`), this.lastSeenSeqNumbers[g] = Math.max(f.sequenceNumber, this.lastSeenSeqNumbers[g]), this.signalingSessionCallback.onWebRtcMediaNotification(g, f));
                }
                constructor(g, f){
                    this.disposed = !1, this.lastSeenSeqNumbers = {}, this.isDominantSpeakerInfoLinkEnabled = !0, this.clientUrlsGenerated = !1, this.getClientUrls = ()=>{
                        this.clientUrlsGenerated = !0;
                        let g = null;
                        return this.isWebRtcCall && (g = {
                            controlVideoStreaming: get2(this.signalingSession, nn.CONTROL_VIDEO_STREAMING),
                            csrcInfo: get2(this.signalingSession, nn.CSRC_INFO)
                        }, this.isDominantSpeakerInfoLinkEnabled && (g.dominantSpeakerInfo = get2(this.signalingSession, nn.DOMINANT_SPEAKER_INFO))), g;
                    }, this.handleDominantSpeakerInfo = (g)=>{
                        const f = g.body;
                        this.logger.debug("handleDominantSpeakerInfo : ", getPrintableObject(f)), this.signalingSession.telemetryHelper.recordIncomingEventCount(cn.HANDLE_DOMINANT_SPEAKER_CHANGED_COUNT), this.handleWebRtcNotification(an.WEBRTC_NOTIFICATION_TYPE.DOMINANT_SPEAKER_INFO, f.dominantSpeakerInformation);
                    }, this.handleControlVideoStreaming = (g)=>{
                        const f = g.body;
                        this.logger.debug("handleControlVideoStreaming: ", getPrintableObject(f)), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_CONTROL_VIDEO_STREAMING, g), this.handleWebRtcNotification(an.WEBRTC_NOTIFICATION_TYPE.CONTROL_VIDEO_STREAMING, f.controlVideoStreaming, !1);
                    }, this.handleCsrcInfo = (g)=>{
                        const f = g.body;
                        this.logger.debug("handleCsrcInfo : ", getPrintableObject(f)), this.signalingSession.telemetryHelper.recordIncomingEvent(cn.HANDLE_CSRC_INFO, g), this.handleWebRtcNotification(an.WEBRTC_NOTIFICATION_TYPE.CSRC_INFO, f.csrcInfo);
                    }, this.sendWebRtcMediaNotificationAsync = ({ operation: g, requestUrl: f, requestBody: S, stackRetry: v = !0 }, _)=>{
                        this.logger.info("sendWebRtcMediaNotificationAsync"), assert2(this.isWebRtcCall, "this is not a webrtc call"), assertNotNullOrEmpty(f, "correct media notification requestUrl is not provided"), assertNotNullOrEmpty(S, "media notification requestBody cannot be null or empty");
                        const C = defer(), E = {
                            url: f,
                            payload: {
                                payload: S
                            },
                            requestName: g,
                            withoutTrouter: !0,
                            causeId: _
                        };
                        return v || (E.disableRetry = !0), this.signalingSession.http.sendPostRequest(E).then(()=>{
                            this.disposed || C.resolve();
                        }).catch((g)=>{
                            const f = getPrintableObject(g);
                            if (this.logger.error(`sendWebRtcMediaNotificationAsync failed because : ${f}`), !this.disposed) {
                                const f = new Error(g);
                                f.endCode = an.CALL_END_NETWORK_ERROR, C.reject(f);
                            }
                        }), C.promise;
                    }, this.dispose = ()=>{
                        this.logger.info("WebRtcSignalingManager :: dispose"), this.disposed = !0;
                    }, this.signalingSession = g, this.signalingSessionCallback = f, this.isWebRtcCall = g.signalingAgentConfig.isWebRtcEnabled, this.logger = g.logger, this.lastSeenSeqNumbers[an.WEBRTC_NOTIFICATION_TYPE.CONTROL_VIDEO_STREAMING] = -1, this.lastSeenSeqNumbers[an.WEBRTC_NOTIFICATION_TYPE.DOMINANT_SPEAKER_INFO] = -1, this.lastSeenSeqNumbers[an.WEBRTC_NOTIFICATION_TYPE.CSRC_INFO] = -1;
                }
            }, er = class {
                onPromotionCompleted(g, f, S) {
                    this.logger.info(`[${S}][onPromotionCompleted] isFailed=${g} error=${getPrintableObject(f)}]`), this.isPromotingToRealtime = !1, this.signalingSessionCallback.onPromotionCompleted(g, f, S);
                }
                setRealTimeState(g, f) {
                    let S = g;
                    (2 === g && 1 === this.realTimeState || 1 === g && 2 === this.realTimeState) && (S = 3), S !== this.realTimeState && (this.logger.info(`[${f}][setRealTimeState] changed: input=${g} old=${this.realTimeState}, new=${S}`), this.realTimeState = S, 3 === S ? this.setCallMode(1, f) : 0 !== this.callMode || 2 !== S && (this.signalingAgentConfig.disableRealTimeModeFromRoster || 1 !== S) || this.setCallMode(1, f));
                }
                setCallMode(g, f) {
                    this.callMode !== g && (this.logger.info(`[${f}][setCallMode] oldMode=${this.callMode}, newMode=${g}`), this.callMode = g, this.signalingSessionCallback.onCallModeChanged(this.callMode, f));
                }
                configureStreamingMode(g) {
                    2 !== this.callMode ? (this.logger.info(`[${g}][configureStreamingMode]`), this.setCallMode(2, g), this.cleanUpDueToStreaming(g), this.onCallStatusChanged(an.CALL_STATUS.CONNECTED, g)) : this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT);
                }
                updateDominantSpeakerHistoryMessageSubscription(g) {
                    this.webRtcSignalingManager.getIsDominantSpeakerInfoLinkEnabled() !== g && (this.logger.info(`Signaling dominant speaker history subscription updated: ${g}`), this.webRtcSignalingManager.setIsDominantSpeakerInfoLinkEnabled(g), this.webRtcSignalingManager.areClientURLsGenerated() && this.updateKeepAliveUrl());
                }
                cleanUpDueToStreaming(g) {
                    var _this_mediaRenegotiationManager;
                    this.setRealTimeState(0, g), this.fsmState = an.SIGNALING_FSM_STATE.CONNECTED, this.isPromotingToRealtime = !1, this.provisionalMediaAnswersSeenSoFar = [], (_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.dispose(), this.mediaRenegotiationManager = new Hn(this, this.signalingSessionCallback, this.telemetryHelper), this.keepAliveTimer && window.clearInterval(this.keepAliveTimer), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT);
                    const f = {
                        code: an.CALL_END_CODE.SUCCESS,
                        subCode: an.CALL_END_SUB_CODE.DOWNGRADE_TO_STREAMING_CLIENT,
                        phrase: an.CALL_END_PHRASE.DOWNGRADE_TO_STREAMING_CLIENT
                    }, S = dn;
                    for (const v of Object.keys(S))0 !== S[v].controller && 4 !== S[v].controller && 3 !== S[v].controller || this.http.cancelRequestIfPending(S[v].name, g, void 0, f);
                }
                updateEndpointMetadata(g, f = causeId2()) {
                    let S = {};
                    try {
                        S = JSON.parse(g);
                    } catch (g) {
                        return Promise.reject("Invalid metadata");
                    }
                    return this.http.sendPutRequest({
                        url: this.links[an.LINKS.UPDATE_ENDPOINT_METADATA],
                        requestName: dn.UPDATE_ENDPOINT_METADATA.name,
                        payload: getPayload51(this, S),
                        causeId: f
                    }).then(()=>{
                        this.telemetryHelper.recordEvent(cn.UPDATE_ENDPOINT_METADATA_SUCCESS, {
                            causeId: f
                        });
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        return this.logger.info(`[${f}][updateEndpointMetadata] error: ${getPrintableObject(S)}`), this.telemetryHelper.recordEvent(cn.UPDATE_ENDPOINT_METADATA_FAILURE, {
                            ...S.error
                        }), Promise.reject(S.error);
                    });
                }
                isOneToOnePSTNCall() {
                    return this.signalingSessionCallback.isOneToOnePstnCall();
                }
                getLocationContent() {
                    return this.isOneToOnePSTNCall() ? tryParse(this.locationInfoContent) : null;
                }
                getNetworkContent() {
                    return this.isOneToOnePSTNCall() ? tryParse(this.networkInfoContent) : null;
                }
                getAreaContent() {
                    return this.isOneToOnePSTNCall() ? tryParse(this.areaContent) : null;
                }
                setLocationInfo(g, f, S) {
                    this.locationInfoContent = g, this.networkInfoContent = f, this.areaContent = S;
                }
                setStreamInformationReceived() {
                    this.disposed || this.streamInformationReceived || (this.streamInformationReceived = !0, this.telemetryHelper.recordEvent(cn.SET_STREAM_INFORMATION_RECEIVED));
                }
                getEndpointCapabilities() {
                    var _this_signalingAgent_accountConfig, _this_signalingAgent, _this_signalingAgent_accountConfig1, _this_signalingAgent1, _this_signalingAgent_accountConfig2, _this_signalingAgent2;
                    let g = 0;
                    return this.signalingAgentConfig.brokerEnabledIncoming && (g |= 16), this.signalingAgentConfig.isGVCJoiningEnabled && (g |= 1), "disabled" !== this.signalingAgentConfig.cloudScreenSharingFlag && (g |= 2), this.signalingAgentConfig.supportsHostlessGroupCalls && (g |= 4), this.signalingAgentConfig.autoJoinOnConflict && (g |= 32), this.signalingAgentConfig.supportsCompressedServicePayload && (g |= 128), this.signalingAgentConfig.enableAutoPromotion && (g |= 65536), this.signalingAgentConfig.enableBatchedSendMessageStatus && (g |= 16384), this.signalingAgentConfig.enableBatchedReceiveMessage && (g |= 8192), g |= 64, g |= 1024, ((_this_signalingAgent = this.signalingAgent) === null || _this_signalingAgent === void 0 ? void 0 : (_this_signalingAgent_accountConfig = _this_signalingAgent.accountConfig) === null || _this_signalingAgent_accountConfig === void 0 ? void 0 : _this_signalingAgent_accountConfig.clientSupportsAudioOnlyWatermark) && (g |= 4096, this.telemetryHelper.setAudioOnlyWatermark(!0)), ((_this_signalingAgent1 = this.signalingAgent) === null || _this_signalingAgent1 === void 0 ? void 0 : (_this_signalingAgent_accountConfig1 = _this_signalingAgent1.accountConfig) === null || _this_signalingAgent_accountConfig1 === void 0 ? void 0 : _this_signalingAgent_accountConfig1.clientSupportsWatermark) && (g |= 2048, this.telemetryHelper.setWatermarkSupport(!0)), ((_this_signalingAgent2 = this.signalingAgent) === null || _this_signalingAgent2 === void 0 ? void 0 : (_this_signalingAgent_accountConfig2 = _this_signalingAgent2.accountConfig) === null || _this_signalingAgent_accountConfig2 === void 0 ? void 0 : _this_signalingAgent_accountConfig2.clientSupportsPreventScreenCapture) && (g |= 131072, this.telemetryHelper.setClientSupportsPreventScreenCapture(!0)), (this.getMaxReinvitelessMediaForVBSSForWeb() || this.getMaxReinvitelessMediaForVideoForWeb()) && (this.telemetryHelper.setReinviteless(this.callUsesMixer), g |= 512), g;
                }
                handleAdmitAllStatus(g) {
                    var _g_body;
                    const f = (_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.transactionResponse, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleAdmitAllStatus][${getPrintableObject(f)}]`);
                    const v = f === null || f === void 0 ? void 0 : f.operationId;
                    if (v && this.callOperationHandler.hasPendingOperation(0, v, S)) {
                        var _f_result, _f_result1, _f_result2;
                        this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT, v);
                        const g = f === null || f === void 0 ? void 0 : (_f_result = f.result) === null || _f_result === void 0 ? void 0 : _f_result.code, _ = f === null || f === void 0 ? void 0 : (_f_result1 = f.result) === null || _f_result1 === void 0 ? void 0 : _f_result1.subCode, C = f === null || f === void 0 ? void 0 : (_f_result2 = f.result) === null || _f_result2 === void 0 ? void 0 : _f_result2.resultCategories, E = f === null || f === void 0 ? void 0 : f.additionalDetail;
                        if (0 === g || g >= 200 && g < 300) {
                            const f = {
                                code: g,
                                subCode: _,
                                resultCategories: C,
                                result: safeJsonStringify(E)
                            };
                            this.telemetryHelper.recordEvent(cn.ADMIT_SUCCESS, {
                                causeId: v,
                                transactionEnd: f
                            }), this.callOperationHandler.resolvePendingOperation(0, v, f, S);
                        } else {
                            const E = {
                                code: g || an.CALL_END_CODE.BAD_REQUEST,
                                subCode: _ || 0,
                                resultCategories: C,
                                result: f,
                                phrase: an.CALL_END_PHRASE.BAD_SERVICE_RESPONSE
                            };
                            this.telemetryHelper.recordEvent(cn.ADMIT_FAILURE, {
                                causeId: v,
                                transactionEnd: E
                            }), this.callOperationHandler.rejectPendingOperation(0, v, "AdmitAllStatus response contains failure", E, S);
                        }
                    } else this.logger.warn(`[${S}][handleAdmitAllStatus] invalid admitAllStatus response or no pending operation. operationId=${v}`);
                }
                sendNetworkRequestForAdmit(g) {
                    const onceTrouterReady = ()=>{
                        this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.ADMIT, ()=>{
                            this.telemetryHelper.recordEvent(cn.ADMIT_TIMEOUT, {
                                causeId: g
                            }), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT, g), this.callOperationHandler.rejectPendingOperation(0, g, "timed out waiting for admit operation", {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.ADMIT_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.ADMIT_TIMEOUT
                            }, g);
                        }, an.TIMEOUT_VALUES_IN_SECONDS.ADMIT_TIMEOUT, g);
                    };
                    this.http.sendPostRequest({
                        url: this.links[an.LINKS.ADMIT_ALL],
                        requestName: dn.ADMIT.name,
                        payload: getPayload26(this, g),
                        causeId: g,
                        onceTrouterReady: onceTrouterReady
                    }).catch((f)=>{
                        const S = getErrorForXHRFailure(f, this.signalingAgentConfig);
                        this.telemetryHelper.recordEvent(cn.ADMIT_FAILURE, {
                            causeId: g,
                            ...S.error
                        }), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.ADMIT, g), this.callOperationHandler.rejectPendingOperation(0, g, f, S.error, g);
                    });
                }
                getConversationType(g, f, S) {
                    return g ? "emergencyGroupCall" : f ? "cast" : S ? "huddleGroupCall" : null;
                }
                getMaxReinvitelessMediaForVideoForWeb() {
                    return this.signalingAgentConfig.maxReinvitelessMediaForVideoForWeb;
                }
                getMaxReinvitelessMediaForVBSSForWeb() {
                    return this.signalingAgentConfig.maxReinvitelessMediaForVBSSForWeb;
                }
                convertParkType(g) {
                    return "teamPark" === g ? "TransferTypeTeamPark" : "sharedLinePark" === g ? "TransferTypeSharedLinePark" : "serverHold" === g ? "TransferTypeServerHold" : (this.logger.info(`convertParkType, parkType: ${g} is unknown`), "none");
                }
                parkByTransfer(g, f) {
                    this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT, ()=>{
                        this.handleCallTransferTimeout(f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT);
                    const S = this.getNetworkRequestName(g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.TRANSFER],
                        requestName: S,
                        payload: getPayload39(g, this),
                        causeId: f
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        return this.logger.info(`[${f}][parkByTransfer] error: ${getPrintableObject(S)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.signalingSessionCallback.onTransferCompleted({
                            transferCompletion: {
                                code: an.CALL_END_CODE.NETWORK_ERROR,
                                reason: getPrintableObject(g)
                            }
                        }, f), this.telemetryHelper.recordEvent(cn.TRANSFER_REQUEST_FAILED, {
                            causeId: f,
                            ...S.error
                        }), Promise.reject(S.error));
                    }), this.telemetryHelper.recordEvent(cn.TRANSFER_REQUEST_SENT, {
                        causeId: f,
                        transferType: this.convertParkType(g)
                    }), Promise.resolve();
                }
                park(g, f) {
                    this.logger.info(`[${f}][park] context ${g}`), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.PARK_COMPLETION, ()=>{
                        this.handleParkError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.PARK_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.PARK_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_PARK_COMPLETION_TIMEOUT, f, g);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.PARK_COMPLETION_TIMEOUT);
                    const S = this.getHoldTypeInRequest(g), v = {
                        causeId: f
                    };
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.PARK],
                        requestName: dn.PARK_REQUEST.name,
                        payload: getPayload40(this, S, v),
                        causeId: f
                    }).then((g)=>{
                        this.logger.info(`[${f}][park] response: ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_PARK_COMPLETION, {
                            causeId: f
                        }), assertNotNull(g.response.holdResponse.links, "server response does not include park links"), this.links[an.LINKS.UNPARK] = g.response.holdResponse.links.resume;
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${f}][park] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleParkError(v.error, cn.PARK_REQUEST_FAILED, f, g), Promise.reject(v.error));
                    }), Promise.resolve();
                }
                getHoldTypeInRequest(g) {
                    switch(g){
                        case "serverHoldV2":
                            return "musicOnHold";
                        case "sharedLineParkV2":
                            return "sharedLineAppearance";
                        case "callPark":
                            return "callPark";
                        default:
                            return null;
                    }
                }
                handleParkError(g, f, S, v) {
                    this.disposed ? this.logger.info("handleParkError ignored") : (this.logger.info(`[${S}] handleParkError reject reason: ${getPrintableObject(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.PARK_COMPLETION), this.signalingSessionCallback.onParkCompleted && (this.telemetryHelper.recordEvent(f, {
                        ...g,
                        parkContext: v,
                        causeId: S
                    }), this.signalingSessionCallback.onParkCompleted(g, S)), this.links[an.LINKS.UNPARK] = void 0);
                }
                handleParkCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.holdCompletion;
                    this.handleOperationCompletionCommon(v, S, void 0, getPrintableObject(f), "handleParkCompletion", an.TIMEOUT_OPERATIONS.PARK_COMPLETION, cn.PARK_COMPLETED, cn.PARK_FAILED, this.signalingSessionCallback.onParkCompleted, this.handleParkError.bind(this));
                }
                handleUnparkError(g, f, S, v) {
                    this.disposed ? this.logger.info("handleUnparkError ignored") : (this.logger.info(`[${S}] handleUnparkError reject reason: ${g}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UNPARK_COMPLETION), this.signalingSessionCallback.onUnparkCompleted && (this.telemetryHelper.recordEvent(f, {
                        ...g,
                        parkContext: v,
                        causeId: S
                    }), this.signalingSessionCallback.onUnparkCompleted(g, S)), this.links[an.LINKS.UNPARK] = void 0);
                }
                handleUnparkCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    if (this.disposed) return void this.logger.info(`[${S}]handleUnparkCompletion ignored`);
                    this.logger.info(`[${S}][handleUnparkCompletion] body ${getPrintableObject(f)}`);
                    const v = f.resumeCompletion;
                    v.code === an.TRANSACTION_END_CODE.SUCCESS ? (this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UNPARK_COMPLETION), this.telemetryHelper.recordEvent(cn.UNPARK_COMPLETED, {
                        ...v,
                        causeId: S
                    }), this.signalingSessionCallback.onUnparkCompleted(v, S), this.links[an.LINKS.UNPARK] = void 0) : this.handleUnparkError(v, cn.UNPARK_FAILED, S);
                }
                getNetworkRequestName(g) {
                    return ({
                        none: null,
                        teamPark: dn.SEND_PARK_REQUEST.name,
                        sharedLinePark: dn.SEND_SHARED_LINE_PARK_REQUEST.name,
                        serverHold: dn.SEND_SERVER_HOLD_REQUEST.name
                    })[g];
                }
                updateMeetingsGroupsAsync(g, f) {
                    this.logger.info(`[${g}][updateMeetingsGroupsAsync] scope=${f.scope}`), this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_GROUPS, {
                        causeId: g,
                        options: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION, ()=>{
                        this.handleUpdateMeetingGroupsError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION, g, g, f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_GROUPS_COMPLETION_TIMEOUT);
                    const S = getMeetingGroupsPayload(this, f, g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.UPDATE_MEETING_GROUPS],
                        requestName: dn.UPDATE_MEETING_GROUPS.name,
                        payload: S,
                        causeId: g
                    }).then((f)=>{
                        this.logger.info(`[${g}][updateMeetingsGroupsAsync] response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_UPDATE_MEETING_GROUPS_COMPLETION, {
                            causeId: g
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${g}][updateMeetingsGroupsAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleUpdateMeetingGroupsError(v.error, cn.UPDATE_MEETING_GROUPS_REQUEST_FAILED, g, g, f), Promise.reject(v.error));
                    });
                }
                updateMonitorSessionAsync(g, f) {
                    this.logger.info(`[${f}][updateMonitorSessionAsync]`), this.telemetryHelper.recordEvent(cn.UPDATE_MONITOR_SESSION, {
                        causeId: f,
                        options: g
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION, ()=>{
                        this.handleUpdateMonitorSessionError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION, f, g);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MONITOR_SESSION_COMPLETION_TIMEOUT);
                    const S = getPayload55(this, g.monitorActionType, g.monitorData, f);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.UPDATE_MONITOR_SESSION],
                        requestName: dn.UPDATE_MONITOR_SESSION.name,
                        payload: S,
                        causeId: f
                    }).then((g)=>{
                        this.logger.info(`[${f}][updateMonitorSessionAsync] response: ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_UPDATE_MONITOR_SESSION_COMPLETION, {
                            causeId: f
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${f}][updateMonitorSessionAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleUpdateMonitorSessionError(v.error, cn.UPDATE_MONITOR_SESSION_REQUEST_FAILED, f, g), Promise.reject(v.error));
                    });
                }
                updateParticipantInterpretationStateAsync(g, f) {
                    return assertNotNullOrEmpty(f, "options should be a non null value"), this.logger.info(`[${g}][updateParticipantInterpretationStateAsync]`), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANT_INTERPRETATION_STATE, {
                        causeId: g,
                        options: f
                    }), this.participantManager.updateParticipantInterpretationStateAsync(f, this.links[an.LINKS.UPDATE_PARTICIPANT_INTERPRETATION_STATE], g);
                }
                async sendProxiedMessageAsync(g, f) {
                    return f && 0 !== f.length ? this.links[an.LINKS.SEND_MESSAGE] ? this.proxiedMessageNotificationManager.sendProxiedMessageAsync(g, f, this.links[an.LINKS.SEND_MESSAGE]) : Promise.reject({
                        code: an.VALIDATION.VALIDATION_FAILED,
                        subCode: an.VALIDATION.NULL_OR_EMPTY,
                        phrase: "missing url for CONSTANTS.LINKS.SEND_MESSAGE"
                    }) : Promise.reject({
                        code: an.VALIDATION.VALIDATION_FAILED,
                        subCode: an.VALIDATION.NULL_OR_EMPTY,
                        phrase: "options should be a non empty array"
                    });
                }
                async updateParticipantsPropertiesAsync(g, f, S, v) {
                    this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES, {
                        causeId: v,
                        updateParticipantsPropertiesContext: g
                    });
                    const _ = this.links[an.LINKS.UPDATE_PARTICIPANTS_PROPERTIES], C = [], E = g.scope;
                    if ("self" === E) {
                        const f = {
                            id: this.participantManager.localParticipant.id,
                            propertyBag: g.propertyBag
                        };
                        C.push(f);
                    } else {
                        if ("specified" !== E) return Promise.reject("This scope is not Supported");
                        {
                            const f = g.participants;
                            for (const g of f){
                                const f = {
                                    id: g.id,
                                    propertyBag: g.propertyBag
                                };
                                C.push(f);
                            }
                        }
                    }
                    return this.sendNetworkRequestForUpdateParticipantsProperties(C, f, _, S, v);
                }
                sendNetworkRequestForUpdateParticipantsProperties(g, f, S, v, _) {
                    const C = this.logger.createChild(`[${_}][sendNetworkRequestForUpdateParticipantsProperties]`, this.correlationId);
                    if (S) {
                        const onceTrouterReady = ()=>{
                            const g = {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT
                            };
                            this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION, ()=>{
                                this.handleUpdateParticipantsPropertiesOnTimeout(f, g, cn.UPDATE_PARTICIPANTS_PROPERTIES_TIMEOUT, v, _);
                            }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION_TIMEOUT, v);
                        }, E = getUpdateParticipantsPropertiesPayload(this, g, v);
                        return this.updateParticipantsPromises[v] = f, this.http.sendPostRequest({
                            url: S,
                            payload: E,
                            requestName: dn.UPDATE_PARTICIPANTS_PROPERTIES.name,
                            onceTrouterReady: onceTrouterReady,
                            causeId: _
                        }).then((g)=>{
                            C.info(`response: ${getPrintableObject(g)}`);
                        }).catch((g)=>{
                            const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            C.info(`failed: ${getPrintableObject(f)}`);
                            const S = {
                                ...f.error
                            };
                            return this.disposed || (this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION, v), delete this.updateParticipantsPromises[v]), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED, {
                                causeId: _,
                                transactionEnd: S
                            }), Promise.reject(S);
                        });
                    }
                    {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_PARTICIPANTS_PROPERTIES_LINK_MISSING,
                            phrase: "updateParticipantsProperties link is missing"
                        };
                        return C.warn(g), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED, {
                            causeId: _,
                            error: g
                        }), Promise.reject(g);
                    }
                }
                checkAndCleanupPromisesForOperationId(g) {
                    this.updateParticipantsPromises[g] && (0 === this.updateParticipantsPromises[g].size ? (delete this.updateParticipantsPromises[g], this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_PARTICIPANTS_PROPERTIES_COMPLETION, g)) : this.logger.info(`remaining promises for the operation  ${g} (count: ${this.updateParticipantsPromises[g].size}):\n                ${this.piiUtils.scrubMriOrOmit(safeJsonStringify(this.updateParticipantsPromises[g]))}`));
                }
                handleUpdateParticipantsPropertiesOnTimeout(g, f, S, v, _) {
                    if (this.disposed) return void this.logger.info("handleUpdateParticipantsPropertiesOnTimeout ignored");
                    this.logger.createChild(`[${_}][handleUpdateParticipantsPropertiesOnTimeout]`, this.correlationId).info(`reason: ${f}`), this.telemetryHelper.recordEvent(S, {
                        ...f,
                        causeId: _
                    });
                    const C = {};
                    g.forEach((g)=>{
                        C[g] = f, this.updateParticipantsPromises[v].delete(g);
                    }), this.checkAndCleanupPromisesForOperationId(v), this.signalingSessionCallback.onUpdateParticipantsPropertiesCompleted(C, v, _);
                }
                joinMeetingGroupAsync(g, f) {
                    this.logger.info(`[${g}][joinMeetingGroupAsync]`), this.telemetryHelper.recordEvent(cn.JOIN_MEETING_GROUP, {
                        causeId: g,
                        options: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION, ()=>{
                        this.handleJoinMeetingGroupError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.JOIN_MEETING_GROUP_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.JOIN_MEETING_GROUP_TIMEOUT
                        }, cn.WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION, g, g, f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.JOIN_MEETING_GROUP_COMPLETION_TIMEOUT);
                    const S = getJoinMeetingGroupPayload(this, f, g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.JOIN_MEETING_GROUP],
                        requestName: dn.JOIN_MEETING_GROUP.name,
                        payload: S,
                        causeId: g
                    }).then((f)=>{
                        this.logger.info(`[${g}][joinMeetingGroupAsync] response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_JOIN_MEETING_GROUP_COMPLETION, {
                            causeId: g
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${g}][joinMeetingGroupAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleJoinMeetingGroupError(v.error, cn.JOIN_MEETING_GROUP_REQUEST_FAILED, g, g, f), Promise.reject(v.error));
                    });
                }
                leaveMeetingGroupAsync(g, f) {
                    this.logger.info(`[${g}][leaveMeetingGroupAsync]`), this.telemetryHelper.recordEvent(cn.LEAVE_MEETING_GROUP, {
                        causeId: g,
                        options: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION, ()=>{
                        this.handleLeaveMeetingGroupError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.LEAVE_MEETING_GROUP_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.LEAVE_MEETING_GROUP_TIMEOUT
                        }, cn.WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION, g, g, f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.LEAVE_MEETING_GROUP_COMPLETION_TIMEOUT);
                    const S = getLeaveMeetingGroupPayload(this, f, g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.LEAVE_MEETING_GROUP],
                        requestName: dn.LEAVE_MEETING_GROUP.name,
                        payload: S,
                        causeId: g
                    }).then((f)=>{
                        this.logger.info(`[${g}][leaveMeetingGroupAsync] response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_LEAVE_MEETING_GROUP_COMPLETION, {
                            causeId: g
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${g}][leaveMeetingGroupAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleLeaveMeetingGroupError(v.error, cn.LEAVE_MEETING_GROUP_REQUEST_FAILED, g, g, f), Promise.reject(v.error));
                    });
                }
                handleUpdateMeetingGroupsError(g, f, S, v, _) {
                    this.disposed ? this.logger.info(`[${S}][handleUpdateMeetingGroupsError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleUpdateMeetingGroupsError] reject reason: ${JSON.stringify(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        updateMeetingGroupsOptions: _,
                        causeId: S
                    }), this.signalingSessionCallback.onUpdateMeetingGroupsCompleted(g, S, v));
                }
                handleUpdateMeetingGroupsCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.updateMeetingGroupsResponse.operationId;
                    if (this.disposed) return void this.logger.info(`[${S}][handleUpdateMeetingGroupsCompletion] ignored. Call disposed.`);
                    v || this.logger.warn(`[${S}][handleUpdateMeetingGroupsCompletion] operationId is undefined.`), this.logger.info(`[${S}][handleUpdateMeetingGroupsCompletion] starts`);
                    const { updateMeetingGroupsResponse: _ } = f, C = processTransactionResponse(_);
                    C.code === an.TRANSACTION_END_CODE.SUCCESS ? (this.logger.info(`[${S}][handleUpdateMeetingGroupsCompletion] update meeting group succeeded`), this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_GROUPS_RESPONSE_SUCCESS, {
                        ...C,
                        causeId: S
                    })) : (this.logger.info(`[${S}][handleUpdateMeetingGroupsCompletion] update meeting group failed code=${C.code} subCode=${C.subCode}`), this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_GROUPS_RESPONSE_FAILURE, {
                        ...C,
                        causeId: S
                    })), this.logger.info(`[${S}][handleUpdateMeetingGroupsCompletion] completes`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_GROUPS_COMPLETION), this.signalingSessionCallback.onUpdateMeetingGroupsCompleted(C, S, v);
                }
                handleJoinMeetingGroupError(g, f, S, v, _) {
                    this.disposed ? this.logger.info(`[${S}][handleJoinedMeetingGroupError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleJoinedMeetingGroupError] reject reason: ${JSON.stringify(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        joinMeetingGroupOptions: _,
                        causeId: S
                    }), this.signalingSessionCallback.onJoinMeetingGroupCompleted(g, S, v));
                }
                handleJoinMeetingGroupCompletion(g) {
                    const f = g.body.joinMeetingGroupResponse, S = extractCauseIdFromMessage(g), v = f.operationId;
                    if (this.disposed) return void this.logger.info(`[${S}][handleJoinMeetingGroupCompletion] ignored. Call disposed.`);
                    v || this.logger.warn(`[${S}][handleJoinMeetingGroupCompletion] operationId is undefined.`), this.logger.info(`[${S}][handleJoinMeetingGroupCompletion] starts`);
                    const _ = processTransactionResponse(f);
                    _.code === an.TRANSACTION_END_CODE.SUCCESS ? (this.logger.info(`[${S}][handleJoinMeetingGroupCompletion] join meeting group succeeded`), this.telemetryHelper.recordEvent(cn.JOIN_MEETING_GROUP_RESPONSE_COMPLETED, {
                        ..._,
                        causeId: S
                    })) : (this.logger.info(`[${S}][handleJoinMeetingGroupCompletion] join meeting group failed code=${_.code} subCode=${_.subCode}`), this.telemetryHelper.recordEvent(cn.JOIN_MEETING_GROUP_RESPONSE_FAILED, {
                        ..._,
                        causeId: S
                    })), this.logger.info(`[${S}][handleJoinMeetingGroupCompletion] complete`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.JOIN_MEETING_GROUP_COMPLETION), this.signalingSessionCallback.onJoinMeetingGroupCompleted(_, S, v);
                }
                handleLeaveMeetingGroupError(g, f, S, v, _) {
                    this.disposed ? this.logger.info(`[${S}][handleLeaveMeetingGroupError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleLeaveMeetingGroupError] reject reason: ${JSON.stringify(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        leaveMeetingGroupOptions: _,
                        causeId: S
                    }), this.signalingSessionCallback.onLeaveMeetingGroupCompleted(g, S, v));
                }
                handleLeaveMeetingGroupCompletion(g) {
                    const f = g.body.leaveMeetingGroupResponse, S = extractCauseIdFromMessage(g), v = f.operationId;
                    if (this.disposed) return void this.logger.info(`[${S}][handleLeaveMeetingGroupCompletion] ignored. Call disposed.`);
                    v || this.logger.warn(`[${S}][handleLeaveMeetingGroupCompletion] operationId is undefined.`), this.logger.info(`[${S}][handleLeaveMeetingGroupCompletion] starts`);
                    const _ = processTransactionResponse(f);
                    _.code === an.TRANSACTION_END_CODE.SUCCESS ? (this.logger.info(`[${S}][handleLeaveMeetingGroupCompletion] leave meeting group succeeded`), this.telemetryHelper.recordEvent(cn.LEAVE_MEETING_GROUP_RESPONSE_COMPLETED, {
                        ..._,
                        causeId: S
                    })) : (this.logger.info(`[${S}][handleLeaveMeetingGroupCompletion] leave meeting group failed code=${_.code} subCode=${_.subCode}`), this.telemetryHelper.recordEvent(cn.LEAVE_MEETING_GROUP_RESPONSE_FAILED, {
                        ..._,
                        causeId: S
                    })), this.logger.info(`[${S}][handleLeaveMeetingGroupCompletion] complete`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.LEAVE_MEETING_GROUP_COMPLETION), this.signalingSessionCallback.onLeaveMeetingGroupCompleted(_, S, v);
                }
                handleDisablePreheatError(g, f, S) {
                    this.disposed ? this.logger.info(`[${S}][handleDisablePreheatError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleDisablePreheatError] reject reason: ${JSON.stringify(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        causeId: S
                    }), this.disablePreheatDefer.isPending() && this.disablePreheatDefer.reject(g));
                }
                handleDisablePreheatCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.transactionEnd;
                    if (this.disposed) this.logger.info(`[${S}][handleDisablePreheatCompletion] ignored. Call disposed.`);
                    else if (this.disablePreheatDefer.isPending()) {
                        if (this.logger.info(`[${S}][handleDisablePreheatCompletion] starts`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT), v.code === an.TRANSACTION_END_CODE.SUCCESS) this.logger.info(`[${S}][handleDisablePreheatCompletion] update endpoint state succeeded`), this.handleEndpointStateUpdated(S, !0);
                        else if (this.logger.info(`[${S}][handleDisablePreheatCompletion] update endpoint state failed code=${v.code} subCode=${v.subCode}`), this.disablePreheatDefer.isPending()) {
                            const g = {
                                response: v
                            };
                            this.disablePreheatDefer.reject(g);
                        }
                    } else this.logger.info(`[${S}][handleDisablePreheatCompletion] ignored. Disable preheat promise is resolved/rejected.`);
                }
                handleReceiveMessage(g) {
                    var _g_body;
                    const f = extractCauseIdFromMessage(g);
                    if (this.disposed) return void this.logger.info(`[${f}][handleReceiveMessage] ignored. Call disposed.`);
                    let S;
                    S = Array.isArray((_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.messageContent) ? g.body.messageContent : [
                        g.body
                    ];
                    let v = "";
                    const _ = [];
                    for(let g = 0; g < S.length; g++){
                        const f = S[g];
                        v += f === null || f === void 0 ? void 0 : f.operationId, g < S.length - 1 && (v += ","), _.push({
                            operationId: f.operationId,
                            messageType: f.type,
                            payload: f.payload,
                            from: {
                                [f.from.id]: {
                                    participantLegIdMap: {
                                        [f.from.participantId]: {
                                            ...f.from.endpointId && {
                                                endpointId: f.from.endpointId
                                            }
                                        }
                                    },
                                    level: "endpoint"
                                }
                            }
                        });
                    }
                    this.logger.info(`[${f}][handleReceiveMessage] complete. OperationIds:${v}`), this.telemetryHelper.recordEvent(cn.INCOMING_PROXIED_MESSAGES, {
                        causeId: f,
                        operationIds: v
                    }), this.signalingSessionCallback.onIncomingProxiedMessages(_, f);
                }
                publishStateAsync(g, f, S, v, _, C) {
                    this.logger.info(`[${S}][publishStateAsync][publishType=${g} publishLevel=${f}]`), this.telemetryHelper.recordEvent(cn.PUBLISH_STATE, {
                        causeId: S,
                        publishType: g,
                        publishLevel: f
                    });
                    const E = this.links[an.LINKS.PUBLISH_STATE];
                    if (!E) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.PUBLISH_STATE_LINK_MISSING,
                            phrase: "publish state link is missing"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    let T = {};
                    try {
                        T = JSON.parse(v);
                    } catch (g) {
                        const f = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_CONTENT,
                            phrase: "publish state content is invalid"
                        };
                        return this.logger.warn(f), Promise.reject(f);
                    }
                    return this.http.sendPostRequest({
                        url: E,
                        requestName: dn.PUBLISH_STATE.name,
                        payload: getPayload42(this, g, f, T, _, C),
                        causeId: S,
                        requestId: S
                    }).then((g)=>{
                        var _g_response;
                        if (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.publishStateResponse) return this.parsePublishStateResult(g, S);
                        {
                            const f = `Invalid CS response which does not contains publishStateResponse. Respone: ${(g === null || g === void 0 ? void 0 : g.response) ? JSON.stringify(g.response) : "no response"}`;
                            throw this.logger.warn(f), {
                                response: {
                                    code: an.CALL_END_CODE.DECODING_FAILED,
                                    subCode: an.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_SERVICE_RESPONSE,
                                    phrase: f
                                }
                            };
                        }
                    }).catch((g)=>{
                        const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${S}][publishStateAsync] error: ${getPrintableObject(f)}`);
                        const v = f.error;
                        return this.telemetryHelper.recordEvent(cn.PUBLISH_STATE_FAILURE, {
                            causeId: S,
                            transactionEnd: v
                        }), Promise.reject(v);
                    });
                }
                getPublishStateSequenceNumber() {
                    return ++this.publishStateSequenceNumber;
                }
                getMonitorSequenceId() {
                    return ++this.monitorSequenceId;
                }
                parsePublishStateResult(g, f) {
                    var _g_response;
                    let S = {};
                    if (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.publishStateResponse) {
                        if (g.response.publishStateResponse.stateId) return g.response.publishStateResponse.stateId;
                        if (g.response.publishStateResponse.results) {
                            if (1 === g.response.publishStateResponse.results.length) {
                                if (g.response.publishStateResponse.results[0].stateId) return g.response.publishStateResponse.results[0].stateId;
                                this.logger.warn("invalid response format");
                            }
                            return g.response.publishStateResponse.results.forEach((g)=>{
                                S[g.participantId] = {
                                    code: g.result.code,
                                    phrase: g.result.phrase,
                                    subCode: g.result.subCode
                                };
                            }), JSON.stringify(S);
                        }
                        if (g.response.publishStateResponse.result) return S = {
                            code: g.response.publishStateResponse.result.code,
                            phrase: g.response.publishStateResponse.result.phrase,
                            subCode: g.response.publishStateResponse.result.subCode,
                            result: g.response.publishStateResponse.additionalDetail
                        }, JSON.stringify(S);
                    }
                    const v = `Invalid CS response which does not contains publishStateResponse. Respone: ${(g === null || g === void 0 ? void 0 : g.response) ? JSON.stringify(g.response) : "no response"}`;
                    throw this.logger.warn(v), {
                        response: {
                            code: an.CALL_END_CODE.DECODING_FAILED,
                            subCode: an.CALL_END_SUB_CODE.PUBLISH_STATE_INVALID_SERVICE_RESPONSE,
                            phrase: v
                        }
                    };
                }
                removeStateAsync(g, f, S, v) {
                    if (this.logger.info(`[${g}][removeStateAsync][scope=${f} publishType=${S} stateIds=${v}]`), this.telemetryHelper.recordEvent(cn.REMOVE_STATE, {
                        causeId: g,
                        scope: f,
                        publishType: S,
                        stateIds: v
                    }), !S && !v) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.REMOVE_STATE_MISSING_ARGUMENTS,
                            phrase: "remove state operation miss arguments"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    const _ = this.links[an.LINKS.REMOVE_STATE];
                    if (!_) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.REMOVE_STATE_LINK_MISSING,
                            phrase: "remove state link is missing"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    return this.http.sendPostRequest({
                        url: _,
                        requestName: dn.REMOVE_STATE.name,
                        payload: getPayload44(this, f, v, S),
                        causeId: g,
                        requestId: g
                    }).then((f)=>this.parseRemoveStateResult(f, g)).catch((f)=>{
                        const S = getErrorForXHRFailure(f, this.signalingAgentConfig);
                        this.logger.info(`[${g}][removeStateAsync] error: ${getPrintableObject(S)}`);
                        const v = S.error;
                        return this.telemetryHelper.recordEvent(cn.REMOVE_STATE_FAILURE, {
                            causeId: g,
                            transactionEnd: v
                        }), Promise.reject(v);
                    });
                }
                parseRemoveStateResult(g, f) {
                    var _g_response;
                    let S = {};
                    return (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.removeStateResponse) && (g.response.removeStateResponse.results ? g.response.removeStateResponse.results.forEach((g)=>{
                        S[g.stateId] = {
                            code: g.result.code,
                            phrase: g.result.phrase,
                            subCode: g.result.subCode
                        };
                    }) : g.response.removeStateResponse.result && (S = {
                        code: g.response.removeStateResponse.result.code,
                        phrase: g.response.removeStateResponse.result.phrase,
                        subCode: g.response.removeStateResponse.result.subCode,
                        result: g.response.removeStateResponse.additionalDetail
                    })), JSON.stringify(S);
                }
                updateMeetingSettingsAsync(g, f) {
                    this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_SETTINGS, {
                        causeId: f,
                        meetingSettings: g
                    });
                    const S = this.links[an.LINKS.UPDATE_MEETING_SETTINGS];
                    if (!S) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_SETTINGS_LINK_MISSING,
                            phrase: "update meeting settings link is missing"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    if (!Object.keys(g).length) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_SETTINGS_MISSING_ARGUMENTS,
                            phrase: "update meeting settings missing arguments"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    return this.http.sendPutRequest({
                        url: S,
                        requestName: dn.UPDATE_MEETING_SETTINGS.name,
                        payload: getPayload54(this, g),
                        causeId: f,
                        requestId: f
                    }).then(()=>{
                        vn.noop();
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][updateMeetingSettingsAsync] error: ${getPrintableObject(S)}`);
                        const v = S.error;
                        throw this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_SETTINGS_FAILURE, {
                            causeId: f,
                            transactionEnd: v
                        }), v;
                    });
                }
                searchParticipantsAsync(g, f) {
                    this.logger.info(`[${f}][searchParticipantsAsync][queryOptions=${g}]`), this.telemetryHelper.recordEvent(cn.SEARCH_PARTICIPANTS, {
                        causeId: f,
                        queryOptions: g
                    });
                    const S = this.links[an.LINKS.SEARCH_PARTICIPANTS];
                    if (!S) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.SEARCH_PARTICIPANTS_LINK_MISSING,
                            phrase: "search participants link is missing"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    return this.http.sendPostRequest({
                        url: S,
                        requestName: dn.SEARCH_PARTICIPANTS.name,
                        payload: getPayload45(this, g),
                        causeId: f,
                        requestId: f
                    }).then((g)=>{
                        var _g_response;
                        if (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.participants) return this.parseSearchParticipantsResult(g, f);
                        {
                            const f = `Invalid CS response which does not contain proper search results. Respone: ${(g === null || g === void 0 ? void 0 : g.response) ? JSON.stringify(g.response) : "no response"}`;
                            throw this.logger.warn(f), {
                                response: {
                                    code: an.CALL_END_CODE.DECODING_FAILED,
                                    subCode: an.CALL_END_SUB_CODE.SEARCH_PARTICIPANTS_INVALID_SERVICE_RESPONSE,
                                    phrase: f
                                }
                            };
                        }
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][searchParticipantsAsync] error: ${getPrintableObject(S)}`);
                        const v = S.error;
                        return this.telemetryHelper.recordEvent(cn.SEARCH_PARTICIPANTS_FAILURE, {
                            causeId: f,
                            transactionEnd: v
                        }), Promise.reject(v);
                    });
                }
                parseSearchParticipantsResult(g, f) {
                    const S = [];
                    if (g === null || g === void 0 ? void 0 : g.response) {
                        const f = g.response.participants;
                        if (f) for (const v of Object.keys(f))S.push(ln.fromRosterSearchResults(g.response.participants[v]));
                    }
                    return {
                        participants: S
                    };
                }
                getAllParticipantsAsync(g, f) {
                    this.logger.info(`[${f}][getAllParticipantsAsync][scope=${g}]`), this.telemetryHelper.recordEvent(cn.GET_ALL_PARTICIPANTS, {
                        causeId: f,
                        scope: g
                    });
                    const S = this.links[an.LINKS.GET_ALL_PARTICIPANTS];
                    if (!S) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_LINK_MISSING,
                            phrase: "get all participants link is missing"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    if ("lobby" !== g) {
                        const g = {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_INVALID_SCOPE,
                            phrase: "get all participants scope is invalid"
                        };
                        return this.logger.warn(g), Promise.reject(g);
                    }
                    return this.http.sendPostRequest({
                        url: S,
                        requestName: dn.GET_ALL_PARTICIPANTS.name,
                        payload: getPayload35(this, g),
                        causeId: f,
                        requestId: f
                    }).then((g)=>{
                        if (g === null || g === void 0 ? void 0 : g.response) return {
                            participants: g.response.participants
                        };
                        {
                            const g = "Invalid CS response which does not contain results.";
                            throw this.logger.warn(g), {
                                response: {
                                    code: an.CALL_END_CODE.DECODING_FAILED,
                                    subCode: an.CALL_END_SUB_CODE.GET_ALL_PARTICIPANTS_INVALID_SERVICE_RESPONSE,
                                    phrase: g
                                }
                            };
                        }
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][getAllParticipantsAsync] error: ${getPrintableObject(S)}`);
                        const v = S.error;
                        return this.telemetryHelper.recordEvent(cn.GET_ALL_PARTICIPANTS_FAILURE, {
                            causeId: f,
                            transactionEnd: v
                        }), Promise.reject(v);
                    });
                }
                resetState() {
                    this.currentCallStatus = null, this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                }
                saveUpdatedCallLinksIfAny(g) {
                    g.links && (this.logger.info(`saveUpdatedCallLinksIfAny, updated call links found, update to new links ${getPrintableObject(g)}`), this.links[an.LINKS.MEDIA_RENEGOTIATION] = g.links.mediaRenegotiation || this.links[an.LINKS.MEDIA_RENEGOTIATION], this.links[an.LINKS.TRANSFER] = g.links.transfer || this.links[an.LINKS.TRANSFER], this.links[an.LINKS.REPLACE] = g.links.replacement || this.links[an.LINKS.REPLACE], this.links[an.LINKS.HANGUP] = g.links.callLeg || this.links[an.LINKS.HANGUP], this.links[an.LINKS.KEEPALIVE] = g.links.callLeg || this.links[an.LINKS.KEEPALIVE], this.links[an.LINKS.PARK] = g.links.hold || this.links[an.LINKS.PARK], this.links[an.LINKS.UPDATE_MEDIA_DESCRIPTIONS] = g.links.updateMediaDescriptions || this.links[an.LINKS.UPDATE_MEDIA_DESCRIPTIONS], this.links[an.LINKS.UPDATE_MONITOR_SESSION] = g.links.monitor || this.links[an.LINKS.UPDATE_MONITOR_SESSION]);
                }
                ensureMessageChannelReady(g) {
                    return this.disposed ? (this.logger.info("ensureMessageChannelReady: error: call already disposed"), Promise.reject(this.getCallNotFoundTransactionEnd())) : this.brokerService ? (this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.STARTED}:${g}`), this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.ENDED}:${g}`), Promise.resolve()) : this.ensureLatestTrouterUrl(g);
                }
                ensureLatestTrouterUrl(g) {
                    return this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.STARTED}:${g}`), this.getTrouterUrlAsync().then((f)=>!f || "string" == typeof f && !f.trim() ? (this.telemetryHelper.recordEvent(cn.TROUTER_URL_CHANGED_TO_INVALID), this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.ENDED}:${g}`), Promise.reject(new Error("Invalid trouter url"))) : this.disposed ? (this.logger.info("ensureLatestTrouterUrl, trouterUrlGetter returned too late. Object is already disposed"), Promise.reject(this.getCallNotFoundTransactionEnd())) : (this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.ENDED}:${g}`), this.baseMessagingChannelUrl = this.currentTrouterUrl = f, Promise.resolve())).catch((f)=>(this.disposed || this.telemetryHelper.addTrouterWaitOperation(`${un.TROUTER_WAIT_OPERATION.FAILED}:${g}`), this.logger.info(`ensureLatestTrouterUrl, failed because:${f}`), Promise.reject(f)));
                }
                signalTransferAcceptedAsync(g, f = causeId2()) {
                    return this.logger.info(`[signalTransferAcceptedAsync][${f}] transferType ${g}`), this.disposed ? (this.logger.info(`[signalTransferAcceptedAsync][${f}] Call already ended, skip acceptance request`), Promise.reject({
                        code: an.CALL_END_CODE.CALL_DOES_NOT_EXIST,
                        reason: null
                    })) : (this.telemetryHelper.recordEvent(cn.SEND_ACCEPT_TRANSFER, {
                        causeId: f,
                        transferType: g
                    }), this.http.sendPostRequest({
                        url: this.links[an.LINKS.TRANSFER_ACCEPTANCE],
                        requestName: dn.TRANSFER_ACCEPTANCE.name,
                        payload: getPayload47(),
                        causeId: f
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        return this.logger.info(`[signalTransferAcceptedAsync][${f}] error: ${getPrintableObject(S)}`), this.telemetryHelper.recordEvent(cn.SEND_ACCEPT_TRANSFER_FAIL, {
                            causeId: f
                        }), Promise.reject(S.error);
                    }));
                }
                signalTransferCompletedAsync(g, f = causeId2()) {
                    return this.logger.info(`[signalTransferCompletedAsync][${f}] rejectReason ${g}`), this.disposed ? (this.logger.info(`[signalTransferCompletedAsync][${f}]  Call already ended by transferor, skip completion request`), Promise.reject({
                        code: an.CALL_END_CODE.CALL_DOES_NOT_EXIST,
                        reason: null
                    })) : (0 !== g.code ? this.telemetryHelper.recordEvent(cn.TRANSFER_COMPLETION_FAILED, {
                        code: g.code,
                        subcode: g.subCode,
                        causeId: f
                    }) : this.telemetryHelper.recordEvent(cn.TRANSFER_COMPLETED, {
                        causeId: f
                    }), this.telemetryHelper.recordEvent(cn.SEND_COMPLETE_TRANSFER, {
                        causeId: f
                    }), this.http.sendPostRequest({
                        url: this.links[an.LINKS.TRANSFER_COMPLETION],
                        requestName: dn.TRANSFER_COMPLETION.name,
                        payload: getPayload49(g),
                        causeId: f
                    }).catch((g)=>{
                        this.telemetryHelper.recordEvent(cn.SEND_COMPLETE_TRANSFER_FAILED, {
                            causeId: f
                        });
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        return this.logger.info(`[signalTransferCompletedAsync][${f}] error: ${getPrintableObject(S)}`), Promise.reject(S.error);
                    }));
                }
                endWithBeacon(g) {
                    if (navigator && navigator.sendBeacon && !this.disposed) {
                        var _this_signalingAgent_authTokenManager, _this_signalingAgent, _this_signalingAgent_authTokenManager1, _this_signalingAgent1;
                        const f = {
                            code: an.CALL_END_CODE.SUCCESS,
                            subCode: an.CALL_END_SUB_CODE.BEACON,
                            phrase: an.CALL_END_PHRASE.LOCAL_USER_INITIATED
                        };
                        this.telemetryHelper.recordEvent(cn.END_WITH_BEACON, {
                            causeId: g
                        });
                        const S = JSON.stringify(getPayload37(this, f).payload), v = -1 === this.links[an.LINKS.LEAVE].indexOf("?") ? "?" : "&", _ = (_this_signalingAgent = this.signalingAgent) === null || _this_signalingAgent === void 0 ? void 0 : (_this_signalingAgent_authTokenManager = _this_signalingAgent.authTokenManager) === null || _this_signalingAgent_authTokenManager === void 0 ? void 0 : _this_signalingAgent_authTokenManager.getLastTokenType(g), C = (_this_signalingAgent1 = this.signalingAgent) === null || _this_signalingAgent1 === void 0 ? void 0 : (_this_signalingAgent_authTokenManager1 = _this_signalingAgent1.authTokenManager) === null || _this_signalingAgent_authTokenManager1 === void 0 ? void 0 : _this_signalingAgent_authTokenManager1.getLastToken(g);
                        let E = "";
                        switch(_){
                            case 4:
                            case 8:
                                this.logger.info(`[endWithBeacon] with tokenType:${_},token size:${C.length},query parameter:access_token`), E = `${this.links[an.LINKS.LEAVE]}${v}access_token=${C}`;
                                break;
                            default:
                                this.logger.info(`[endWithBeacon] with tokenType:${_},token size:${C.length},query parameter:skypeToken`), E = `${this.links[an.LINKS.LEAVE]}${v}skypeToken=${C}`;
                        }
                        return navigator.sendBeacon(E, S);
                    }
                    return !1;
                }
                setFsmState(g) {
                    this.fsmState = g;
                }
                setIsHostless(g, f) {
                    const S = !!g;
                    this.isHostLessCall !== S && (this.logger.info(`[${f}][setIsHostless] isHostless=${S}`), this.isHostLessCall = S);
                }
                hasGroupModality() {
                    return this.threadId || this.groupId;
                }
                processConversationServiceResponseHeaders(g, f) {
                    this.logger.info(`[${f}][processConversationServiceResponseHeaders]`);
                    try {
                        const S = g.request.getResponseHeader(an.HEADERS.CORRELATION_ID) || g.request.getResponseHeader(an.HEADERS.CORRELATION_ID.toLowerCase());
                        this.updateCorrelationId(S, f);
                    } catch (g) {
                        this.logger.info(`[${f}][processConversationServiceResponseHeaders] failed, reason=${getPrintableObject(g)}`);
                    }
                }
                processConversationServiceResponse(g, f, S) {
                    var _g_subscriptionDetails, _g_selfParticipant;
                    const v = this.logger.createChild(`[${f}][processConversationServiceResponse]`);
                    if (v.info(`responseType :${S}`), this.processConversationServiceUpdate(g, f), (_g_subscriptionDetails = g.subscriptionDetails) === null || _g_subscriptionDetails === void 0 ? void 0 : _g_subscriptionDetails.selfParticipant) {
                        const S = ln.fromRoster(g.subscriptionDetails.selfParticipant, !0);
                        v.info("converted selfParticipant to Participant type"), this.participantManager.updateLocalParticipantFromSubscribe(S, f);
                    }
                    ((_g_selfParticipant = g.selfParticipant) === null || _g_selfParticipant === void 0 ? void 0 : _g_selfParticipant.enableCaptcha) && this.participantManager.setEnableCaptcha(!0, f), this.handleBrokerSubscription(g, f), g.roster && this.internalHandleRosterUpdate(g.roster, !0, f), 0 === S && (this.startOrJoinConvResponseReceived = !0, this.handlePendingEndpointState(f));
                }
                processConversationServiceUpdate(g, f) {
                    const S = this.logger.createChild(`[${f}][processConversationServiceUpdate]`);
                    S.info(), this.convJoined = !0;
                    const v = g.sequenceNumber >= 0 ? g.sequenceNumber : -1;
                    v < this.updateSequenceNumber ? S.info(`seqNum=${v} is less than latest seqNum=${this.updateSequenceNumber}`) : (this.updateSequenceNumber = v, this.links[an.LINKS.CONVERSATION_CONTROLLER] = g.conversationController, this.links[an.LINKS.ADD_PARTICIPANT] = g.links.addParticipant, this.links[an.LINKS.ADD_PARTICIPANTS_AND_MODALITY] = g.links.addParticipantAndModality, this.links[an.LINKS.LEAVE] = g.links.leave, this.links[an.LINKS.NOTIFICATION_LINKS] = g.links.notificationLinks, this.links[an.LINKS.REMOVE_PARTICIPANT] = g.links.removeParticipant, this.links[an.LINKS.ADD_MODALITY] = g.links.addModality, this.links[an.LINKS.REMOVE_MODALITY] = g.links.removeModality, this.links[an.LINKS.MUTE] = g.links.mute || null, this.links[an.LINKS.UNMUTE] = g.links.unmute || null, this.links[an.LINKS.ADMIT] = g.links.admit || null, this.links[an.LINKS.ADMIT_ALL] = g.links.admitAll || null, this.links[an.LINKS.UPDATE_ENDPOINT_STATE] = g.links.updateEndpointState || null, this.links[an.LINKS.UPDATE_ENDPOINT_METADATA] = g.links.updateEndpointMetadata || null, this.links[an.LINKS.UPDATE_PARTICIPANT_ROLE] = g.links.updateParticipantRole || null, this.links[an.LINKS.PUBLISH_STATE] = g.links.publishState || null, this.links[an.LINKS.REMOVE_STATE] = g.links.removeState || null, this.links[an.LINKS.UPDATE_MEETING_SETTINGS] = g.links.updateMeetingSettings || null, this.links[an.LINKS.SEARCH_PARTICIPANTS] = g.links.searchParticipants || null, this.links[an.LINKS.GET_ALL_PARTICIPANTS] = g.links.getAllParticipants || null, this.links[an.LINKS.UPDATE_MEETING_LIVE_STATE] = g.links.updateMeetingLiveState || null, this.links[an.LINKS.UPDATE_MEETING_GROUPS] = g.links.updateMeetingGroups || null, this.links[an.LINKS.SET_MEETING_LAYOUT] = g.links.setMeetingLayout || null, this.links[an.LINKS.UPDATE_PARTICIPANT_INTERPRETATION_STATE] = g.links.updateParticipantInterpretationState || null, this.links[an.LINKS.UPDATE_PARTICIPANTS_PROPERTIES] = g.links.updateParticipantProperties || null, this.links[an.LINKS.JOIN_MEETING_GROUP] = g.links.joinMeetingGroup || null, this.links[an.LINKS.LEAVE_MEETING_GROUP] = g.links.leaveMeetingGroup || null, this.links[an.LINKS.SEND_MESSAGE] = g.links.sendMessage || null, this.links[an.LINKS.UPDATE_MEETING_STATES] = g.links.updateMeetingStates || null, this.convSubject = g.subject, g.state && (this.setMultiParty(g.state.isMultiParty, f), this.setIsHostless(g.state.isHostless || !1, f), this.conversationType = g.state.conversationType, this.isCastCall = "cast" === g.state.conversationType, this.isHuddleGroupCall = "huddleGroupCall" === g.state.conversationType), g.activeModalities && g.activeModalities.groupChat && this.updateGroupChatIds(g.activeModalities.groupChat, f), g.activeModalities && g.activeModalities.broadcast && (this.broadcastSession || (this.broadcastSession = new _n(this, this.signalingSessionCallback)), this.broadcastSession.handleBroadcastDetailsChanged(g, f)), this.handleMeetingDetailsChanged(g, f), this.handleMeetingStatesChanged(g, f), this.linkUpdateRequested.conversationLinks ? (S.info("Updating CS links as requested"), this.updateLinks(this.updateConversationLinks, f)) : this.scheduleConversationKeepAlive(), g.meetingData && (this.meetingData = g.meetingData), g.meetingInfo && (this.meetingInfo = g.meetingInfo), g.region && (this.region = g.region), g.callLimits && (this.callLimits = g.callLimits), g.complianceRecordingContent && (this.complianceRecordingContent = g.complianceRecordingContent), g.conversationStartTime && (this.conversationStartTime = g.conversationStartTime), this.signalingSessionCallback.onConversationUpdated({
                        conversationType: this.conversationType,
                        groupId: this.groupId,
                        threadId: this.threadId,
                        teamsMessageId: this.teamsMessageId,
                        isMultiParty: this.multiParty,
                        commandUrlPresence: this.getCommandUrlPresence(),
                        meetingData: this.meetingData,
                        region: this.region,
                        meetingInfo: this.meetingInfo,
                        callLimits: this.callLimits,
                        complianceRecordingContent: this.complianceRecordingContent,
                        conversationStartTime: this.conversationStartTime,
                        isHuddleGroupCall: this.isHuddleGroupCall,
                        backroomThreadId: this.backroomThreadId,
                        streamThreadId: this.streamThreadId,
                        lobbyThreadId: this.lobbyThreadId
                    }, f));
                }
                processLocalParticipantUpdateResponse(g, f) {
                    this.logger.info(`[${f}][processLocalParticipantUpdateResponse]`), g.sequenceNumber && g.sequenceNumber < this.localParticipantUpdateSequenceNumber || (this.breakoutDetails = g.breakoutDetails || {}, this.signalingSessionCallback.onBreakoutDetailsUpdated(this.breakoutDetails, f), !0 === g.nudgeToJoinAsRealtime && (this.telemetryHelper.recordEvent(cn.NUDGE_TO_JOIN_REALTIME, {
                        causeId: f
                    }), this.signalingSessionCallback.onNudgeToJoinRealtime(f)));
                }
                handlePendingEndpointState(g) {
                    this.requestedEndpointStateWhileConnecting && (this.logger.info(`[${g}][handlePendingEndpointState]sending pending endpoint state now that we are connected.`), this.updateEndpointState(this.requestedEndpointStateWhileConnecting, g, this.requestedPublishedStatesWhileConnecting).catch((g)=>{
                        this.isPreheatOnly && this.disablePreheatDefer.isPending() && (this.logger.info("handlePendingEndpointState failed"), this.disablePreheatDefer.reject(g));
                    }));
                }
                handleMeetingDetailsChanged(g, f) {
                    var _this_meetingDetails_meetingCapability;
                    this.logger.info(`[${f}][handleMeetingDetailsChanged]`), g.meetingDetails && !vn.isEqual(g.meetingDetails, this.meetingDetails) && this.signalingSessionCallback.onMeetingDetailsUpdated && (this.meetingDetails = g.meetingDetails, ((_this_meetingDetails_meetingCapability = this.meetingDetails.meetingCapability) === null || _this_meetingDetails_meetingCapability === void 0 ? void 0 : _this_meetingDetails_meetingCapability.meetingLiveState) && (this.meetingLiveStateSequenceNumber = this.meetingDetails.meetingCapability.meetingLiveState.seqNum, this.logger.info(`[${f}][handleMeetingDetailsChanged] update meeting seqNum as ${this.meetingLiveStateSequenceNumber}`)), this.signalingSessionCallback.onMeetingDetailsUpdated(this.meetingDetails, f));
                }
                handleMeetingStatesChanged(g, f) {
                    this.logger.info(`[${f}][handleMeetingStatesChanged]`), this.signalingSessionCallback.onMeetingStatesUpdated && this.signalingSessionCallback.onMeetingStatesUpdated(g.meetingStates, f);
                }
                handleBrokerSubscription(g, f) {
                    this.logger.info(`[${f}][handleBrokerSubscription]`), g.links.subscribe ? (this.telemetryHelper.recordEvent(cn.SUBSCRIBE_URL_FOUND, f), this.brokerService && !vn.isEqual(g.links.subscribe, this.brokerService.currentSubscriptionUrl) ? this.brokerService.subscribeToBroker(g.links.subscribe) : (this.logger.info(`[${f}][handleBrokerSubscription] broker subscribe ignored. Broker is disabled or subscribe url is same.`), this.telemetryHelper.recordEvent(cn.BROKER_DISABLED_SUBSCRIBE_URL_PRESENT, f))) : this.telemetryHelper.recordEvent(cn.SUBSCRIBE_URL_MISSING, f);
                }
                cancelOutgoingCall(g, f) {
                    const S = defer();
                    this.logger.info(`[${f}][cancelOutgoingCall][rejectionData=${g && getPrintableObject(g)}]`);
                    const v = {
                        code: isNaN(g === null || g === void 0 ? void 0 : g.code) ? an.CALL_END_CODE.CANCEL : g.code,
                        subCode: (g === null || g === void 0 ? void 0 : g.subCode) || an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: (g === null || g === void 0 ? void 0 : g.phrase) || an.CALL_END_PHRASE.LOCAL_USER_INITIATED,
                        resultCategories: (g === null || g === void 0 ? void 0 : g.resultCategories) || [
                            Qi.Success
                        ],
                        clientReasonSubCode: g === null || g === void 0 ? void 0 : g.clientReasonSubCode,
                        clientReasonPhrase: g === null || g === void 0 ? void 0 : g.clientReasonPhrase
                    };
                    if (this.signalingAgentConfig.enableSpecificErrorCodesForCallEnd && (v.code = an.CALL_END_CODE.CANCEL, v.subCode = an.CALL_END_SUB_CODE.SUCCESS, v.phrase = an.CALL_END_PHRASE.LOCAL_USER_INITIATED, v.resultCategories = [
                        Qi.Success
                    ]), this.links.hasOwnProperty(an.LINKS.LEAVE)) {
                        this.logger.info(`[${f}][cancelOutgoingCall] cancelling outgoing call`), this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                        const g = {
                            cancelationDuration: this.telemetryHelper.getCallCancelationDuration()
                        }, _ = {
                            terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                            resultDetail: v.phrase || "CancelOutgoingCall",
                            endCode: v.code,
                            endSubCode: v.subCode,
                            causeId: f,
                            clientReasonSubCode: v.clientReasonSubCode,
                            clientReasonPhrase: v.clientReasonPhrase,
                            resultCategories: v.resultCategories
                        };
                        this.http.sendPostRequest({
                            url: this.links[an.LINKS.LEAVE],
                            requestName: dn.CANCEL_CALL.name,
                            payload: getPayload32(this, v, g),
                            causeId: f
                        }).then((g)=>{
                            this.disposed || (this.telemetryHelper.setTerminatingData(_), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, v), this.dispose(v, f)), S.resolve(null);
                        }).catch((g)=>{
                            const C = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            this.logger.info(`[cancelOutgoingCall][${f}] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(C)}`), this.disposed || (this.telemetryHelper.setTerminatingData(_), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, v), this.dispose(v, f)), S.resolve(null);
                        });
                    } else this.logger.info(`[${f}][cancelOutgoingCall] Conversation Service Leave Url is not yet set. Cannot leave conversation. Disposing anyways.`), v.subCode = an.CALL_END_SUB_CODE.CONV_URL_NOT_SET, this.telemetryHelper.setTerminatingData({
                        terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                        resultDetail: v.phrase || "CancelOutgoingCall",
                        endCode: v.code,
                        endSubCode: v.subCode,
                        causeId: f,
                        clientReasonSubCode: v.clientReasonSubCode,
                        clientReasonPhrase: v.clientReasonPhrase,
                        resultCategories: v.resultCategories
                    }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, v), this.dispose(v, f), S.resolve(null);
                    return S.promise;
                }
                terminateEstablishedCall(g, f) {
                    const S = f.causeId || causeId2();
                    this.logger.info(`[${S}][terminateEstablishedCall]`);
                    const v = defer();
                    this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                    const _ = this.convJoined ? dn.LEAVE_CONVERSATION.name : dn.END_CALL.name, C = build3(), E = {
                        code: (g === null || g === void 0 ? void 0 : g.code) || an.CALL_END_CODE.SUCCESS,
                        subCode: (g === null || g === void 0 ? void 0 : g.subCode) || an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: (g === null || g === void 0 ? void 0 : g.phrase) || an.CALL_END_PHRASE.LOCAL_USER_INITIATED,
                        resultCategories: g === null || g === void 0 ? void 0 : g.resultCategories,
                        clientReasonSubCode: g === null || g === void 0 ? void 0 : g.clientReasonSubCode,
                        clientReasonPhrase: g === null || g === void 0 ? void 0 : g.clientReasonPhrase
                    };
                    E.resultCategories = E.resultCategories || [
                        Qi.Success
                    ];
                    const T = {
                        terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                        endCode: E.code,
                        endSubCode: E.subCode,
                        resultDetail: E.phrase || "TerminateEstablishedCall",
                        causeId: S,
                        clientReasonSubCode: E.clientReasonSubCode,
                        clientReasonPhrase: E.clientReasonPhrase,
                        resultCategories: E.resultCategories
                    };
                    return this.leaveConversation(E, f).then(()=>{
                        this.logger.info(`[${S}][terminateEstablishedCall]success`), this.disposed || (this.telemetryHelper.setTerminatingData(T), this.telemetryHelper.addNetworkOperationCompleted(_, !0, C.duration()), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, S, E), this.dispose(E, S)), v.resolve(null);
                    }).catch((g)=>{
                        const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${S}][terminateEstablishedCall][failed] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(f)}]`), this.disposed || (this.telemetryHelper.setTerminatingData(T), this.telemetryHelper.addNetworkOperationCompleted(_, !1, C.duration()), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, S, E), this.dispose(E, S)), v.resolve(null);
                    }), v.promise;
                }
                deleteConversation(g, f) {
                    this.logger.info(`[${f}][deleteConversation]`);
                    const S = defer();
                    this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                    const v = dn.DELETE_CONVERSATION.name, _ = build3(), C = {
                        code: (g === null || g === void 0 ? void 0 : g.code) || an.CALL_END_CODE.SUCCESS,
                        subCode: (g === null || g === void 0 ? void 0 : g.subCode) || an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: (g === null || g === void 0 ? void 0 : g.phrase) || an.CALL_END_PHRASE.CONV_END_FOR_ALL_INITIATED,
                        resultCategories: (g === null || g === void 0 ? void 0 : g.resultCategories) || [
                            Qi.Success
                        ],
                        clientReasonSubCode: g === null || g === void 0 ? void 0 : g.clientReasonSubCode,
                        clientReasonPhrase: g === null || g === void 0 ? void 0 : g.clientReasonPhrase
                    }, E = {
                        terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                        endCode: C.code,
                        endSubCode: C.subCode,
                        resultDetail: C.phrase,
                        causeId: f,
                        clientReasonSubCode: C.clientReasonSubCode,
                        clientReasonPhrase: C.clientReasonPhrase,
                        resultCategories: C.resultCategories
                    };
                    return this.deleteConversationController(C, f).then(()=>{
                        this.logger.info(`[${f}][deleteConversation]success`), this.disposed || (this.telemetryHelper.setTerminatingData(E), this.telemetryHelper.addNetworkOperationCompleted(v, !0, _.duration()), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, C), this.dispose(C, f)), S.resolve(null);
                    }).catch((g)=>{
                        const T = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][deleteConversation][failed] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(T)}`), this.disposed || (this.telemetryHelper.setTerminatingData(E), this.telemetryHelper.addNetworkOperationCompleted(v, !1, _.duration()), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, C), this.dispose(C, f)), S.resolve(null);
                    }), S.promise;
                }
                leaveConversation(g, f) {
                    const S = f.causeId || causeId2();
                    if (this.convJoined) {
                        this.logger.info(`[${S}][leaveConversation]`);
                        const v = {
                            cancelationDuration: this.telemetryHelper.getCallCancelationDuration()
                        };
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.LEAVE],
                            requestName: dn.LEAVE_CONVERSATION.name,
                            payload: getPayload37(this, g, v, f.scope),
                            withoutTrouter: !0,
                            causeId: S
                        });
                    }
                    return this.logger.info(`[${S}][leaveConversation] ignore, not joined to conversation`), Promise.resolve(void 0);
                }
                deleteConversationController(g, f) {
                    return this.convJoined ? (this.logger.info(`[${f}][deleteConversationController]`), this.http.sendDeleteRequest({
                        url: this.links[an.LINKS.CONVERSATION_CONTROLLER],
                        requestName: dn.DELETE_CONVERSATION.name,
                        payload: getPayload34(this, g),
                        withoutTrouter: !0,
                        causeId: f
                    })) : (this.logger.info(`[${f}][deleteConversationController]ignored, not joined to conversation`), Promise.resolve(void 0));
                }
                rejectIncomingCall(g, f) {
                    this.telemetryHelper.recordEvent(cn.REJECT_INCOMING_CALL, f), this.logger.info(`[${f}][rejectIncomingCall]`);
                    const S = defer();
                    this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                    const v = {
                        code: isNaN(g === null || g === void 0 ? void 0 : g.code) ? an.CALL_END_CODE.REJECT : g.code,
                        subCode: (g === null || g === void 0 ? void 0 : g.subCode) || an.CALL_END_SUB_CODE.SUCCESS,
                        phrase: (g === null || g === void 0 ? void 0 : g.phrase) || an.CALL_END_PHRASE.LOCAL_USER_INITIATED,
                        resultCategories: g === null || g === void 0 ? void 0 : g.resultCategories,
                        clientReasonSubCode: g === null || g === void 0 ? void 0 : g.clientReasonSubCode,
                        clientReasonPhrase: g === null || g === void 0 ? void 0 : g.clientReasonPhrase
                    };
                    v.resultCategories = v.resultCategories || [
                        Qi.Success
                    ];
                    const _ = {
                        terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                        endCode: v.code,
                        endSubCode: v.subCode,
                        resultDetail: v.phrase || "RejectCall",
                        causeId: f,
                        clientReasonSubCode: v.clientReasonSubCode,
                        clientReasonPhrase: v.clientReasonPhrase,
                        resultCategories: v.resultCategories
                    };
                    return this.http.sendDeleteRequest({
                        url: this.links[an.LINKS.REJECT],
                        requestName: dn.REJECT_CALL.name,
                        payload: getPayload43(this, v),
                        causeId: f
                    }).then((g)=>{
                        this.disposed || (this.telemetryHelper.setTerminatingData(_), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, v), this.dispose(v, f)), S.resolve(null);
                    }).catch((g)=>{
                        const C = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[rejectIncomingCall][${f}] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(C)}`), this.disposed || (this.telemetryHelper.setTerminatingData(_), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, v), this.dispose(v, f)), S.resolve(null);
                    }), S.promise;
                }
                onCallStatusChanged(g, f, S) {
                    const v = `[${f}][onCallStatusChanged]`;
                    if (this.logger.info(`${v}${this.currentCallStatus}=>${g}]`), this.disposed) this.logger.info(`${v}Call is already disposed!!`);
                    else if (S && this.logger.info(`${v}[statusCode=${getPrintableObject(S)}]`), this.isPromotingToRealtime) g === an.CALL_STATUS.CONNECTED && this.onPromotionCompleted(!1, void 0, f);
                    else if (this.isValidStateTransitions(g)) {
                        this.currentCallStatus = g;
                        const v = {
                            callStatus: g,
                            statusCode: S,
                            causeId: f
                        };
                        this.isPreheatOnly && (v.isPreheatOnly = !0), this.telemetryHelper.recordEvent(cn.UPDATE_CALL_STATUS, v), this.signalingSessionCallback.onCallStatusChanged(g, S, f), this.currentCallStatus === an.CALL_STATUS.CONNECTED && (this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT), this.telemetryHelper.resetCallCancelationDurationWatch(), this.isPreheatOnly && this.startCallPreheatTimer(f));
                    }
                }
                updateMeetingLiveStateAsync(g, f) {
                    this.logger.info(`[${g}][updateMeetingLiveStateAsync][options=${JSON.stringify(f)}]`), this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_LIVE_STATE, {
                        causeId: g,
                        meetingLiveStateOptions: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION, ()=>{
                        this.handleUpdateMeetingLiveStateError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION, g, g, f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_LIVE_STATE_COMPLETION_TIMEOUT);
                    const S = getPayload53(this, {
                        ...f,
                        sequenceNumber: this.meetingLiveStateSequenceNumber
                    }, g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.UPDATE_MEETING_LIVE_STATE],
                        requestName: dn.UPDATE_MEETING_LIVE_STATE.name,
                        payload: S,
                        causeId: g
                    }).then((f)=>{
                        this.logger.info(`[${g}][updateMeetingLiveStateAsync] response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_UPDATE_MEETING_LIVE_STATE_COMPLETION, {
                            causeId: g
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                        return this.logger.info(`[${g}][updateMeetingLiveStateAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleUpdateMeetingLiveStateError(v.error, cn.UPDATE_MEETING_LIVE_STATE_REQUEST_FAILED, g, g, f), Promise.reject(v.error));
                    });
                }
                updateMeetingStatesAsync(g, f) {
                    const S = this.logger.createChild(`[${g}][updateMeetingStatesAsync]`, this.correlationId);
                    if (S.info(`meetingStatesOptions: ${JSON.stringify(f)}`), !f) return Promise.reject({
                        code: an.VALIDATION.VALIDATION_FAILED,
                        subCode: an.VALIDATION.NULL_OR_EMPTY,
                        phrase: "meetingStatesOptions should be a non empty object"
                    });
                    this.telemetryHelper.recordEvent(cn.UPDATE_MEETING_STATES, {
                        causeId: g,
                        meetingStatesOptions: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION, ()=>{
                        for(const S in f.meetingStates)this.handleUpdateMeetingStatesError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION, g, f.operationId + "_" + S);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.UPDATE_MEETING_STATES_COMPLETION_TIMEOUT);
                    const v = getPayload59(this, {
                        ...f.meetingStates
                    }, g);
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.UPDATE_MEETING_STATES],
                        requestName: dn.UPDATE_MEETING_STATES.name,
                        payload: v,
                        causeId: g
                    }).then((f)=>{
                        S.info(`response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_UPDATE_MEETING_STATES_COMPLETION, {
                            causeId: g
                        });
                    }).catch((v)=>{
                        const _ = getErrorForXHRFailure(v, this.signalingAgentConfig);
                        if (S.error(`error: ${getPrintableObject(_)}`), !this.disposed) {
                            for(const S in f.meetingStates)this.handleUpdateMeetingStatesError(_.error, cn.UPDATE_MEETING_STATES_RESPONSE_FAILURE, g, f.operationId + "_" + S);
                            return Promise.reject(_.error);
                        }
                        return Promise.reject(this.getCallNotFoundTransactionEnd());
                    });
                }
                handleUpdateMeetingLiveStateError(g, f, S, v, _) {
                    this.disposed ? this.logger.info(`[${S}][handleUpdateMeetingLiveStateError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleUpdateMeetingLiveStateError] reject reason: ${g}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        updateMeetingGroupsOptions: _,
                        causeId: S
                    }), this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted && this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted(g, S, v));
                }
                handleUpdateMeetingLiveStateCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.updateMeetingLiveStateResponse.result, _ = f.updateMeetingLiveStateResponse.operationId;
                    _ || this.logger.warn(`[${S}][handleUpdateMeetingLiveStateCompletion] operationId is undefined.`), this.logger.info(`[${S}][handleUpdateMeetingLiveStateCompletion] meetingLiveUpdate completes with operationId=${_}`), this.handleOperationCompletionCommon(v, S, _, getPrintableObject(f), "handleUpdateMeetingLiveStateCompletion", an.TIMEOUT_OPERATIONS.UPDATE_MEETING_LIVE_STATE_COMPLETION, cn.UPDATE_MEETING_LIVE_STATE_RESPONSE_SUCCESS, cn.UPDATE_MEETING_LIVE_STATE_RESPONSE_FAILURE, this.signalingSessionCallback.onUpdateMeetingLiveStateCompleted, this.handleUpdateMeetingLiveStateError.bind(this));
                }
                handleUpdateMeetingStatesError(g, f, S, v) {
                    this.disposed ? this.logger.info(`[${S}][handleUpdateMeetingStatesError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleUpdateMeetingStatesError] reject reason: ${g}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        causeId: S
                    }), this.signalingSessionCallback.onUpdateMeetingStatesCompleted && this.signalingSessionCallback.onUpdateMeetingStatesCompleted(g, S, v));
                }
                handleUpdateMeetingStatesCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.updateMeetingStatesResponse, _ = f.operationId, C = this.logger.createChild(`[${S}][handleUpdateMeetingStatesCompletion]`, this.correlationId);
                    _ || C.warn("operationId is undefined.");
                    for (const g of v)C.info(`UpdateMeetingStates completes with operationId=${_}.`), this.handleOperationCompletionCommon(g.transactionEnd, S, _ + "_" + g.meetingStateName, getPrintableObject(f), "handleUpdateMeetingStatesCompletion", an.TIMEOUT_OPERATIONS.UPDATE_MEETING_STATES_COMPLETION, cn.UPDATE_MEETING_STATES_RESPONSE_SUCCESS, cn.UPDATE_MEETING_STATES_RESPONSE_FAILURE, this.signalingSessionCallback.onUpdateMeetingStatesCompleted, this.handleUpdateMeetingStatesError.bind(this));
                }
                handleUpdateMonitorSessionCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleUpdateMeetingStatesCompletion]`, this.correlationId);
                    const v = f.monitorCompletion;
                    this.handleOperationCompletionCommon(v, S, void 0, getPrintableObject(f), "handleUpdateMonitorSessionCompletion", an.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION, cn.UPDATE_MONITOR_SESSION_RESPONSE_COMPLETED, cn.UPDATE_MONITOR_SESSION_RESPONSE_FAILED, this.signalingSessionCallback.onUpdateMonitorSessionCompleted, this.handleUpdateMonitorSessionError.bind(this));
                }
                handleUpdateMonitorSessionError(g, f, S, v) {
                    this.disposed ? this.logger.info(`[${S}][handleUpdateMonitorSessionError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleUpdateMonitorSessionError] reject reason: ${JSON.stringify(g)}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.UPDATE_MONITOR_SESSION_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        monitorOptions: v,
                        causeId: S
                    }), this.signalingSessionCallback.onUpdateMonitorSessionCompleted(g, S));
                }
                setMeetingLayoutAsync(g, f) {
                    this.logger.info(`[${g}][setMeetingLayoutAsync][options=${JSON.stringify(f)}]`), this.telemetryHelper.recordEvent(cn.SET_MEETING_LAYOUT, {
                        causeId: g,
                        setMeetingLayoutOptions: f
                    }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION, ()=>{
                        this.handleSetMeetingLayoutError({
                            code: an.CALL_END_CODE.TIMEOUT,
                            subCode: an.CALL_END_SUB_CODE.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT,
                            phrase: an.CALL_END_PHRASE.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT
                        }, cn.WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION, g, g, f);
                    }, an.TIMEOUT_VALUES_IN_SECONDS.SET_MEETING_LAYOUT_COMPLETION_TIMEOUT);
                    const S = getPayload46(this, {
                        ...f,
                        sequenceNumber: this.meetingLayoutSequenceNumber
                    });
                    return this.http.sendPostRequest({
                        url: this.links[an.LINKS.SET_MEETING_LAYOUT],
                        requestName: dn.SET_MEETING_LAYOUT.name,
                        payload: S,
                        causeId: g
                    }).then((f)=>{
                        this.logger.info(`[${g}][setMeetingLayoutAsync] response: ${getPrintableObject(f)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_SET_MEETING_LAYOUT_COMPLETION, {
                            causeId: g
                        });
                    }).catch((S)=>{
                        const v = getErrorForXHRFailure(S);
                        return this.logger.info(`[${g}][setMeetingLayoutAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleSetMeetingLayoutError(v.error, cn.SET_MEETING_LAYOUT_REQUEST_FAILED, g, g, f), Promise.reject(v.error));
                    });
                }
                handleSetMeetingLayoutError(g, f, S, v, _) {
                    this.disposed ? this.logger.info(`[${S}][handleSetMeetingLayoutError] ignored. Call disposed, err: ${JSON.stringify(g)}`) : (this.logger.info(`[${S}][handleSetMeetingLayoutError] reject reason: ${g}`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION), this.telemetryHelper.recordEvent(f, {
                        ...g,
                        updateMeetingGroupsOptions: _,
                        causeId: S
                    }), this.signalingSessionCallback.onSetMeetingLayoutCompleted && this.signalingSessionCallback.onSetMeetingLayoutCompleted(g, S, v));
                }
                handleSetMeetingLayoutCompletion(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g), v = f.setMeetingLayoutResponse.result, _ = f.setMeetingLayoutResponse.operationId;
                    _ || this.logger.warn(`[${S}][handleSetMeetingLayoutCompletion] operationId is undefined.`), this.handleOperationCompletionCommon(v, S, _, getPrintableObject(f), "handleSetMeetingLayoutCompletion", an.TIMEOUT_OPERATIONS.SET_MEETING_LAYOUT_COMPLETION, cn.SET_MEETING_LAYOUT_RESPONSE_SUCCESS, cn.SET_MEETING_LAYOUT_RESPONSE_FAILURE, this.signalingSessionCallback.onSetMeetingLayoutCompleted, this.handleSetMeetingLayoutError.bind(this));
                }
                handleOperationCompletionCommon(g, f, S, v, _, C, E, T, I, b) {
                    this.disposed ? this.logger.info(`[${f}][${_}] ignored. Call disposed.`) : (this.logger.info(`[${f}][${_}] body ${v}`), g.code === an.TRANSACTION_END_CODE.SUCCESS ? (this.timeoutManager.stopTimer(C), this.telemetryHelper.recordEvent(E, {
                        ...g,
                        causeId: f
                    }), I && I(g, f, S)) : b && b(g, T, f, S));
                }
                isValidStateTransitions(g) {
                    if (this.currentCallStatus === an.CALL_STATUS.LOCAL_TERMINATED && g === an.CALL_STATUS.CONNECTING) return !0;
                    const orderOfCallState = (g)=>{
                        switch(g){
                            case an.CALL_STATUS.IDLE:
                            case an.CALL_STATUS.CONNECTED_FOR_ROSTER_ONLY:
                                return 0;
                            case an.CALL_STATUS.CONNECTING:
                                return 1;
                            case an.CALL_STATUS.RINGING:
                                return 2;
                            case an.CALL_STATUS.CONNECTED:
                                return 3;
                            case an.CALL_STATUS.LOCAL_TERMINATED:
                            case an.CALL_STATUS.REMOTE_TERMINATED:
                                return 4;
                            default:
                                return -1;
                        }
                    };
                    return orderOfCallState(g) > orderOfCallState(this.currentCallStatus);
                }
                handlePSTNBalanceUpdate(g) {
                    const f = g.body.balanceUpdate, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handlePSTNBalanceUpdate]`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_PSTN_BALANCE_UPDATE, g), f.updateBalance ? this.signalingSessionCallback.onPSTNBalanceUpdate(f) : this.logger.info(cn.HANDLE_PSTN_BALANCE_UPDATE, "this was a pstn keepAlive message - ignore");
                }
                handleCallAcceptanceAck(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleCallAcceptanceAck]`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CALL_ACCEPTANCE_ACK, g), this.internalHandleCallAcceptanceAck(f, S);
                }
                internalHandleCallAcceptanceAck(g, f) {
                    var _g_callAcceptanceAcknowledgement_callProperties;
                    this.logger.info(`[${f}][internalHandleCallAcceptanceAck] ${getPrintableObject(g)}`), this.fsmState !== an.SIGNALING_FSM_STATE.CONNECTED && (this.links[an.LINKS.MEDIA_RENEGOTIATION] = g.callAcceptanceAcknowledgement.links.mediaRenegotiation, this.links[an.LINKS.TRANSFER] = g.callAcceptanceAcknowledgement.links.transfer, this.links[an.LINKS.REPLACE] = g.callAcceptanceAcknowledgement.links.replacement, this.links[an.LINKS.HANGUP] = g.callAcceptanceAcknowledgement.links.callLeg, this.links[an.LINKS.KEEPALIVE] = g.callAcceptanceAcknowledgement.links.callLeg, this.links[an.LINKS.PARK] = g.callAcceptanceAcknowledgement.links.hold, this.links[an.LINKS.UPDATE_MEDIA_DESCRIPTIONS] = g.callAcceptanceAcknowledgement.links.updateMediaDescriptions, this.links[an.LINKS.UPDATE_MONITOR_SESSION] = g.callAcceptanceAcknowledgement.links.monitor, this.saveMediaControllerLinksIfAny(g.callAcceptanceAcknowledgement), this.scheduleKeepAlives(g.callAcceptanceAcknowledgement.callKeepAliveInterval), this.signalingSessionCallback.updateIsSharedLineAppearanceV2Activated((_g_callAcceptanceAcknowledgement_callProperties = g.callAcceptanceAcknowledgement.callProperties) === null || _g_callAcceptanceAcknowledgement_callProperties === void 0 ? void 0 : _g_callAcceptanceAcknowledgement_callProperties.isSharedLineAppearanceV2Activated), this.fsmState = an.SIGNALING_FSM_STATE.CONNECTED, this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.INCOMING_CALL_ESTABLISHMENT), this.isPreheatOnly || this.telemetryHelper.startCallConnectedWatch(), this.mediaRenegotiationManager.onCallConnected(f), this.onCallStatusChanged(an.CALL_STATUS.CONNECTED, f), this.linkUpdateRequested.keepAliveLinks && (this.logger.info(`[${f}][internalHandleCallAcceptanceAck] updating CC links as requested`), this.updateLinks(this.updateKeepAliveUrl, f)));
                }
                isFatalException(g) {
                    let f = !0;
                    try {
                        JSON.parse(g.message).code === an.CALL_END_CODE.CONFLICT && (f = !1, this.logger.info("isFatalException: received non-fatal 409 error"));
                    } catch (g) {
                        this.logger.error("isFatalException: failed to parse error");
                    }
                    return f;
                }
                startOrJoinCall(g, f, S, v, _) {
                    if (this.logger.info(`[${S}]startOrJoinCall[${f}]`), this.disposed) return void this.logger.info(`[${S}][${f}] session already disposed, ignore`);
                    this.telemetryHelper.recordEvent(cn.START_OR_JOIN_CALL, {
                        causeId: S,
                        requestName: f
                    }), this.setMultiParty(1 !== this.participantManager.getParticipantsToInitiateCallWith().length, S);
                    const C = this.getConversationUrl() ? this.getConversationUrl() : g.conversationServiceUrl;
                    this.telemetryHelper.setConversationServiceUrl(C), this.logger.info(`options.conversationServiceUrl ${g.conversationServiceUrl} conversationServiceUrl ${C}`), g.isPreheatOnly ? (this.isPreheatOnly = !0, this.telemetryHelper.recordEvent(cn.PREHEAT_ENABLING, {
                        causeId: S
                    }), this.telemetryHelper.setSelfParticipantRole(un.ROLE.PREHEAT), this.telemetryHelper.setIsPreheated()) : this.telemetryHelper.startCallCancelationDurationWatch(), this.mediaTypesToUse = _, this.lastUsedOutgoingMediaContent = v, this.telemetryHelper.setCallerType(this.participantManager.localParticipant.id);
                    const E = !this.multiParty && this.signalingAgentConfig.enableLongOutgoing1To1SetupTimeoutForWeb, T = E ? an.TIMEOUT_VALUES_IN_SECONDS.LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT : an.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT;
                    this.logger.info(`[${S}][${f}]target endpointType = ${this.transferContext && this.transferContext.target ? this.transferContext.target.endpointType : "default"} timeout = ${T} LongerTimeout = ${E}`);
                    const I = g.newCall ? getPayload33(this, v, _, g) : getPayload36(this, v, _, g, S);
                    this.signalingAgentConfig.enableCallEstablishmentTimeoutsForStartJoinCall && this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT, ()=>{
                        this.handleCallEstablishmentTimeout(S);
                    }, T), this.signalingSessionCallback.onTransferredCallAcceptance(S), g.endpointState && (this.latestEndpointState = g.endpointState), this.http.sendPostRequest({
                        url: C,
                        requestName: f,
                        operationType: "CallSetup",
                        payload: I,
                        causeId: S
                    }).then((g)=>{
                        this.disposed || (this.processConversationServiceResponseHeaders(g, S), this.processConversationServiceResponse(g.response, S, 0), this.onCallStatusChanged(an.CALL_STATUS.CONNECTING, S));
                    }).catch((g)=>{
                        if (g.stack && !this.isFatalException(g)) return;
                        const v = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        if (this.logger.info(`[startOrJoinCall][${S}][${f}] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(v)}`), !this.disposed) {
                            if (this.isPromotingToRealtime) return void this.onPromotionCompleted(!0, v.error, S);
                            this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                resultValue: un.RESULT_VALUE.FAILURE,
                                endCode: v.telemetryEndSubCode,
                                endSubCode: v.error.subCode,
                                resultCategories: v.error.resultCategories,
                                resultDetail: v.error.phrase || "StartOrJoinCallFailure",
                                causeId: S
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, S, v.error), this.dispose(v.error, S);
                        }
                    });
                }
                processIncomingCallPayload(g, f) {
                    var _g_callNotification_links, _g_callNotification_links1, _g_callNotification_onBehalfOf, _g_callNotification_onBehalfOf1, _g_callNotification_from, _g_callNotification_mediaContent, _g_callNotification_redirectionProperties;
                    this.remoteUser = ln.fromWireParticipant(g.callNotification.from), this.participantManager.setLocalParticipantId(g.callNotification.to.participantId, f), g ? (g.conversationInvitation && (this.links[an.LINKS.CONVERSATION_CONTROLLER] = g.conversationInvitation.conversationController, this.setMultiParty(g.conversationInvitation.isMultiParty, f), this.setIsHostless(!!g.conversationInvitation.isHostless, f)), g.callNotification && (this.links[an.LINKS.ATTACH] = (_g_callNotification_links = g.callNotification.links) === null || _g_callNotification_links === void 0 ? void 0 : _g_callNotification_links.attach, this.links[an.LINKS.REDIRECT] = (_g_callNotification_links1 = g.callNotification.links) === null || _g_callNotification_links1 === void 0 ? void 0 : _g_callNotification_links1.redirection, this.onBehalfOf = (_g_callNotification_onBehalfOf = g.callNotification.onBehalfOf) === null || _g_callNotification_onBehalfOf === void 0 ? void 0 : _g_callNotification_onBehalfOf.id, this.onBehalfOfUserDisplayName = (_g_callNotification_onBehalfOf1 = g.callNotification.onBehalfOf) === null || _g_callNotification_onBehalfOf1 === void 0 ? void 0 : _g_callNotification_onBehalfOf1.displayName, this.callQueueContext = g.callNotification.callQueueContext, this.callPhoneLineType = g.callNotification.callPhoneLineType, this.callType = g.callNotification.callType, this.incomingCallCallerId = (_g_callNotification_from = g.callNotification.from) === null || _g_callNotification_from === void 0 ? void 0 : _g_callNotification_from.id, this.callUsesMixer = !!((_g_callNotification_mediaContent = g.callNotification.mediaContent) === null || _g_callNotification_mediaContent === void 0 ? void 0 : _g_callNotification_mediaContent.fromMixer), this.isRedirectAllowed = !!((_g_callNotification_redirectionProperties = g.callNotification.redirectionProperties) === null || _g_callNotification_redirectionProperties === void 0 ? void 0 : _g_callNotification_redirectionProperties.isRedirectAllowed), this.callQueueSupervisorContent = g.callNotification.callQueueSupervisorContent, this.bannerContent = g.callNotification.bannerContent), g.debugContent && this.updateCorrelationId(g.debugContent.callId, f), g.callNotification.transferor && (this.transferor = g.callNotification.transferor.details ? g.callNotification.transferor.details.id : null), g.groupChat && this.updateGroupChatIds(g.groupChat, f), g.meetingData && (this.meetingData = g.meetingData), g.meetingInfo && (this.meetingInfo = g.meetingInfo)) : this.logger.info(`[${f}][processIncomingCallPayload] empty incoming payload content`);
                }
                processAttachResponse(g, f, S) {
                    this.telemetryHelper.recordEvent(cn.PROCESS_INITIAL_OFFER, {
                        causeId: S
                    }), this.links[an.LINKS.MEDIA_ANSWER] = f.response.callInvitation.links.mediaAnswer, this.links[an.LINKS.ACCEPT] = f.response.callInvitation.links.acceptance, this.links[an.LINKS.REJECT] = f.response.callInvitation.links.callLeg, this.links[an.LINKS.REDIRECT] = f.response.callInvitation.links.redirection, this.links[an.LINKS.NEW_OFFER] = f.response.callInvitation.links.newOffer, this.signalingAgentConfig.sendProgressFromCC || this.sendProgress(f), this.remoteCaller = f.response.participants.from;
                    const v = this.getInitialMediaOfferFromIncomingCallPayload() || f.response.callInvitation.mediaContent;
                    this.telemetryHelper.setCallerType(this.getParticipantIdForOfferAnswer(v));
                    const _ = getMediaTypes(f.response.callInvitation.callModalities);
                    this.telemetryHelper.addIncomingModalities(_), this.telemetryHelper.setOfferedModalities(v.blob, !0), this.callUsesMixer = v.fromMixer, this.isRedirectAllowed = !(!f.response.callInvitation.redirectionProperties || !f.response.callInvitation.redirectionProperties.isRedirectAllowed), this.signalingSessionCallback.onOffer({
                        subject: g.conversationInvitation.subject,
                        remoteParticipantId: this.getParticipantIdForOfferAnswer(v),
                        remoteEndpointId: f.response.participants.from.endpointId,
                        transferor: f.response.callInvitation.transferor,
                        clientTransferContext: g.callNotification.transferContext,
                        customHeaderContext: f.response.callInvitation.customContext,
                        mediaTypes: _,
                        mediaContent: v,
                        renegotiation: !1,
                        invitationData: f.response.callInvitation.invitationData,
                        riskLevel: f.response.callInvitation.spamProperties && f.response.callInvitation.spamProperties.riskLevel,
                        stirAttestation: f.response.callInvitation.spamProperties && f.response.callInvitation.spamProperties.stirAttestation,
                        isRedirectAllowed: this.isRedirectAllowed
                    }, S);
                }
                sendProgress(g, f = causeId2()) {
                    this.logger.info(`[${f}][sendProgress]`), this.telemetryHelper.recordEvent(cn.SEND_PROGRESS, {
                        causeId: f
                    }), this.http.sendPostRequest({
                        url: g.response.callInvitation.links.progress,
                        requestName: dn.SEND_CALL_PROGRESS.name,
                        payload: getPayload30(this),
                        causeId: f
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][sendProgress] error: ${getPrintableObject(S)}`), this.disposed || this.telemetryHelper.recordEvent(cn.SEND_PROGRESS_FAILED, {
                            causeId: f,
                            ...S.error
                        });
                    });
                }
                handleCallNotification(g) {
                    const f = extractCauseIdFromMessage(g);
                    if (this.logger.info(`[${f}][handleCallNotification]`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CALL_NOTIFICATION, g), !stringEndsWith(g.url, nn.REPLACE)) throw new Error(`[${f}][handleCallNotification]IncomingCallNotification should not be received in handleIncomingMsg`);
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_INCOMING_CALL_REPLACEMENT, g), this.logger.info(`[${f}][handleCallNotification]replacementCallNotification`), this.signalingSessionCallback && this.signalingSessionCallback.onIncomingCallReplacement(g.body, f);
                }
                handleMediaAnswer(g) {
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_MEDIA_ANSWER, g);
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    if (this.logger.info(`[${S}][handleMediaAnswer]`), this.mediaRenegotiationManager.isOutgoingRenegotiationInProgress()) this.mediaRenegotiationManager.handleMediaAnswer(f, S);
                    else if (this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED) ;
                    else if (this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING) {
                        if (isDuplicateMessage(g.headers, this.provisionalMediaAnswersSeenSoFar)) return void this.logger.info(`[${S}][handleMediaAnswer] ignoring provisional answer retried by service`);
                        f.mediaAnswer.sender && (this.remoteUser = f.mediaAnswer.sender), this.resetCallEstablishmentTimeout(S), f.mediaAnswer.noRingBack || (this.telemetryHelper.setTimeToRingDuration(), this.onCallStatusChanged(an.CALL_STATUS.RINGING, S));
                        const v = f.mediaAnswer.mediaContent;
                        this.signalingSessionCallback.onAnswer({
                            provisional: !0,
                            renegotiation: !1,
                            remoteEndpointId: f.mediaAnswer.sender ? f.mediaAnswer.sender.endpointId : newGuid(),
                            remoteParticipantId: this.getParticipantIdForOfferAnswer(v),
                            mediaContent: v
                        }, S);
                    }
                }
                async _sendCallAcceptanceAcknowledgement(g, f) {
                    this.http.sendPostRequest({
                        url: g.body.callAcceptance.links.acknowledgement,
                        requestName: dn.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name,
                        payload: getPayload28(this),
                        causeId: f
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][_sendCallAcceptanceAcknowledgement] error: ${getPrintableObject(S)}`), this.disposed || this.telemetryHelper.recordEvent(cn.HANDLE_CALL_ACCEPTANCE_FAILED, {
                            causeId: f,
                            ...S.error
                        });
                    });
                }
                handleCallAcceptance(g) {
                    const f = extractCauseIdFromMessage(g);
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CALL_ACCEPTANCE, g, {
                        enableQuickSendAcceptanceAck: this.signalingAgentConfig.enableQuickSendAcceptanceAck,
                        causeId: f
                    }), this.logger.info(`[${f}][handleCallAcceptance]enableQuickSendAcceptanceAck:\n            ${this.signalingAgentConfig.enableQuickSendAcceptanceAck}`), this.signalingAgentConfig.enableQuickSendAcceptanceAck ? (this._sendCallAcceptanceAcknowledgement(g, f), this._processCallAcceptance(g, f)) : (this._processCallAcceptance(g, f), this.http.sendPostRequest({
                        url: g.body.callAcceptance.links.acknowledgement,
                        requestName: dn.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name,
                        payload: getPayload28(this),
                        causeId: f
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        this.logger.info(`[${f}][handleCallAcceptance] error: ${getPrintableObject(S)}`), this.disposed || this.telemetryHelper.recordEvent(cn.HANDLE_CALL_ACCEPTANCE_FAILED, {
                            causeId: f,
                            ...S.error
                        });
                    }));
                }
                handleCallAcceptanceSync(g) {
                    const f = extractCauseIdFromMessage(g);
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CALL_ACCEPTANCE_SYNC, g, {
                        enableQuickSendAcceptanceAck: this.signalingAgentConfig.enableQuickSendAcceptanceAck,
                        causeId: f
                    }), this.logger.info(`[${f}][handleCallAcceptanceSync] enableQuickSendAcceptanceAck:\n            ${this.signalingAgentConfig.enableQuickSendAcceptanceAck}`), this.signalingAgentConfig.enableQuickSendAcceptanceAck ? vn.defer(this._processCallAcceptance, g, f) : this._processCallAcceptance(g, f);
                    const S = getPayload28(this).payload;
                    return this.telemetryHelper.addNetworkOperationCompleted(dn.SEND_ACCEPTANCE_ACKNOWLEDGEMENT.name, !0), S;
                }
                getFakeRoster(g) {
                    const f = this.participantManager.getParticipantsToInitiateCallWith();
                    let S;
                    S = 1 === f.length ? f[0].id : g.callAcceptance.acceptedBy.id;
                    const v = {
                        id: S,
                        displayName: g.callAcceptance.acceptedBy.id === S ? g.callAcceptance.acceptedBy.displayName : "",
                        languageId: g.callAcceptance.acceptedBy.languageId
                    }, _ = g.callAcceptance.acceptedBy.endpointId;
                    return {
                        type: "MultiPartyEndpoint",
                        participants: {
                            [S]: {
                                acceptedBy: g.callAcceptance.acceptedBy.id,
                                details: v,
                                endpoints: {
                                    [_]: {
                                        call: {},
                                        contentSharing: {},
                                        capabilities: g.callAcceptance.capabilities,
                                        participantId: g.callAcceptance.acceptedBy.participantId
                                    }
                                }
                            }
                        }
                    };
                }
                processCallAcceptance(g, f) {
                    var _g_callAcceptance_callProperties;
                    this.logger.info(`[${f}][processCallAcceptance] ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.PROCESS_CALL_ACCEPTANCE, {
                        causeId: f
                    }), this.fsmState = an.SIGNALING_FSM_STATE.CONNECTED, this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT), this.isPreheatOnly || this.telemetryHelper.startCallConnectedWatch(), this.mediaRenegotiationManager.onCallConnected(f);
                    let S = !1;
                    g.callAcceptance.controllerName === an.MISC.LOBBY_CALL_CONTROLLER && (this.logger.info(`[${f}][processCallAcceptance] Controller name is lobby so putting user in lobby`), this.participantManager.localParticipant.isLobby = !0, this.participantManager.localParticipant.endpointDetails.push({
                        isLobby: !0,
                        endpointId: this.participantManager.localParticipant.endpointId,
                        participantId: this.participantManager.localParticipant.participantId
                    }), S = !0, this.telemetryHelper.recordEvent(cn.ACCEPTANCE_USER_IN_LOBBY, {
                        causeId: f
                    })), this.participantManager.localParticipant.isStaging = hasStagingGroup(g.callAcceptance), this.signalingSessionCallback.onMeetingGroupDetailsUpdated(g.callAcceptance.meetingGroupDetails, f), this.signalingSessionCallback.updateIsSharedLineAppearanceV2Activated((_g_callAcceptance_callProperties = g.callAcceptance.callProperties) === null || _g_callAcceptance_callProperties === void 0 ? void 0 : _g_callAcceptance_callProperties.isSharedLineAppearanceV2Activated), this.logger.info(`[${f}][processCallAcceptance] for localParticipant, isStaging is set to ${this.participantManager.localParticipant.isStaging}`);
                    let v = this.mediaTypesToUse, _ = newGuid();
                    g.callAcceptance.acceptedBy && (this.remoteUser = ln.fromWireParticipant(g.callAcceptance.acceptedBy), _ = g.callAcceptance.acceptedBy.endpointId), g.callAcceptance.acceptedCallModalities && g.callAcceptance.acceptedCallModalities.length > 0 && (v = g.callAcceptance.acceptedCallModalities);
                    const C = g.callAcceptance.mediaContent;
                    this.callUsesMixer = C.fromMixer;
                    const E = getMediaTypes(v);
                    this.telemetryHelper.addIncomingModalities(E), this.telemetryHelper.setAnsweredModalities(C.blob, !0), this.links[an.LINKS.MEDIA_RENEGOTIATION] = g.callAcceptance.links.mediaRenegotiation, this.links[an.LINKS.TRANSFER] = g.callAcceptance.links.transfer, this.links[an.LINKS.REPLACE] = g.callAcceptance.links.replacement, this.links[an.LINKS.HANGUP] = g.callAcceptance.links.callLeg, this.links[an.LINKS.KEEPALIVE] = g.callAcceptance.links.callLeg, this.links[an.LINKS.PARK] = g.callAcceptance.links.hold, this.links[an.LINKS.UPDATE_MEDIA_DESCRIPTIONS] = g.callAcceptance.links.updateMediaDescriptions, this.links[an.LINKS.UPDATE_MONITOR_SESSION] = g.callAcceptance.links.monitor, this.saveMediaControllerLinksIfAny(g.callAcceptance), this.scheduleKeepAlives(g.callAcceptance.callKeepAliveInterval);
                    const T = this.getParticipantIdForOfferAnswer(C);
                    this.signalingSessionCallback.onAnswer({
                        provisional: !1,
                        renegotiation: !1,
                        remoteEndpointId: _,
                        remoteParticipantId: T,
                        callAcceptedByNGCVoicemail: T === an.KNOWN_BOTS.VOICEMAIL_BOT_ID,
                        mediaTypes: E,
                        mediaContent: C
                    }, f), this.setRealTimeState(2, f), this.onCallStatusChanged(an.CALL_STATUS.CONNECTED, f), S && this.signalingSessionCallback.onSelfParticipantUpdated(this.participantManager.localParticipant, f), this.linkUpdateRequested.keepAliveLinks && (this.logger.info(`[${f}][processCallAcceptance] Updating CC links as requested`), this.updateLinks(this.updateKeepAliveUrl, f));
                }
                updateGroupChatIds(g, f) {
                    const S = this.groupId, v = this.threadId, _ = this.teamsMessageId, C = this.backroomThreadId, E = this.streamThreadId, T = this.lobbyThreadId;
                    this.groupId = g.groupId, this.threadId = g.threadId, this.teamsMessageId = g.messageId, this.backroomThreadId = g.backroomThreadId, this.streamThreadId = g.streamThreadId, this.lobbyThreadId = g.lobbyThreadId, this.groupId === S && this.threadId === v && this.teamsMessageId === _ && this.backroomThreadId === C && this.streamThreadId === E && this.lobbyThreadId === T || this.signalingSessionCallback.onConversationUpdated({
                        conversationType: this.conversationType,
                        groupId: this.groupId,
                        threadId: this.threadId,
                        teamsMessageId: this.teamsMessageId,
                        isMultiParty: this.multiParty,
                        commandUrlPresence: this.getCommandUrlPresence(),
                        meetingData: this.meetingData,
                        region: this.region,
                        meetingInfo: this.meetingInfo,
                        callLimits: this.callLimits,
                        isHuddleGroupCall: this.isHuddleGroupCall,
                        backroomThreadId: this.backroomThreadId,
                        streamThreadId: this.streamThreadId,
                        lobbyThreadId: this.lobbyThreadId
                    }, f);
                }
                handleCallEnd(g, f) {
                    let S = g.body.callEnd || g.body;
                    const v = extractCauseIdFromMessage(g);
                    if (this.logger.info(`[${v}][handleCallEnd][content=${getPrintableObject(S)}]`), this.telemetryHelper.recordEvent(cn.HANDLE_CALL_END, {
                        origin: g.origin,
                        code: S ? S.code : "unknown",
                        subCode: S ? S.subCode : "unknown",
                        resultCategories: S ? S.resultCategories : [],
                        causeId: v
                    }), this.signalingAgentConfig.enableConversationTypeUpdateOnCallEnd && (this.conversationType = (S === null || S === void 0 ? void 0 : S.conversationType) || this.conversationType, this.signalingSessionCallback.onConversationTypeUpdated(this.conversationType, v)), this.fsmState !== an.SIGNALING_FSM_STATE.IDLE) {
                        var _S_conversationUrl;
                        if (S.code === an.CALL_END_CODE.CONFLICT && this.multiParty && ((_S_conversationUrl = S.conversationUrl) === null || _S_conversationUrl === void 0 ? void 0 : _S_conversationUrl.Location)) this.handleConversationResolutionConflict(S, v);
                        else {
                            this.disposing = !0, S.callControllerTransactionEnd && (this.logger.info("handleCallEnd: using CC end details specified in CS end"), S = S.callControllerTransactionEnd), S.broadcastOperationFailure && (this.logger.info("handleCallEnd: using broadcastOperationFailure end details specified in CS end"), S = S.broadcastOperationFailure);
                            const g = S.code === an.CALL_END_CODE.SUCCESS || S.code === an.CALL_END_CODE.CANCEL || S.code === an.CALL_END_CODE.REJECT;
                            this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.REMOTE,
                                resultDetail: S.phrase,
                                resultValue: g ? un.RESULT_VALUE.SUCCESS : un.RESULT_VALUE.FAILURE,
                                endCode: S.code,
                                endSubCode: S.subCode,
                                resultCategories: S ? S.resultCategories : [],
                                causeId: v
                            });
                            const _ = {
                                code: S.code,
                                subCode: S.subCode,
                                phrase: S.phrase,
                                resultCategories: S.resultCategories,
                                pickupCode: ""
                            }, C = this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY || this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY;
                            this.fsmState = an.SIGNALING_FSM_STATE.IDLE, S.acceptedElsewhereBy && (this.acceptedElsewhereBy = {
                                id: S.acceptedElsewhereBy.id,
                                displayName: S.acceptedElsewhereBy.displayName
                            }), S.unparkContent && (S.unparkContent.CallParkAdditionalContext && (this.parkAdditionalContextJson = JSON.stringify(S.unparkContent.CallParkAdditionalContext), this.serverHoldLocation = S.unparkContent.CallParkAdditionalContext.ConversationControllerLocation), S.unparkContent.pickupCode && (_.pickupCode = S.unparkContent.pickupCode));
                            const E = this.signalingAgentConfig.enableSplitConversationEndUrl;
                            E && C === f ? (this.logger.info("fsmstate = SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY or OUTGOING_FOR_ROSTER_ONLY"), this.onCallStatusChanged(an.CALL_STATUS.REMOTE_TERMINATED, v, _), this.dispose(_, v)) : E || (this.onCallStatusChanged(an.CALL_STATUS.REMOTE_TERMINATED, v, _), this.dispose(_, v));
                        }
                    } else this.logger.info(`[${v}][handleCallEnd] not handling incoming callEnd since fsmstate = SIGNALING_FSM_STATE.IDLE`);
                }
                handleConversationResolutionConflict(g, f) {
                    var _this_lastUsedJoinCallOptions;
                    this.logger.info(`[${f}][handleConversationResolutionConflict]`);
                    const S = {
                        ...g,
                        phrase: g.phrase || "Conflict Resolution Error"
                    };
                    if (this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY || this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY) this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.http.cancelRequestIfPending(dn.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY.name, f, void 0, S), this.subscribeToCall(g.conversationUrl.Location, g.correlationId, this.lastUsedJoinCallOptions ? this.lastUsedJoinCallOptions.clientEndpointCapabilities : 0, {
                        meetingData: this.meetingData,
                        meetingPreferences: this.meetingPreferences,
                        additionalEndpointProperties: (_this_lastUsedJoinCallOptions = this.lastUsedJoinCallOptions) === null || _this_lastUsedJoinCallOptions === void 0 ? void 0 : _this_lastUsedJoinCallOptions.additionalEndpointProperties
                    }, f);
                    else {
                        this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT);
                        const v = {
                            meetingData: this.meetingData,
                            meetingPreferences: this.meetingPreferences
                        };
                        if (this.lastUsedJoinCallOptions) {
                            const g = this.lastUsedJoinCallOptions.scenario;
                            v.muted = this.lastUsedJoinCallOptions.muted, v.scenario = `409Redirect${g || ""}`, v.isPreheatOnly = this.lastUsedJoinCallOptions.isPreheatOnly, v.clientEndpointCapabilities = this.lastUsedJoinCallOptions.clientEndpointCapabilities, v.clientEndpointDebugContent = this.lastUsedJoinCallOptions.clientEndpointDebugContent, v.additionalEndpointProperties = this.lastUsedJoinCallOptions.additionalEndpointProperties;
                        } else v.scenario = "409RedirectJoin";
                        this.setInitialTelemetry("JoinCall", {
                            correlationId: g.correlationId,
                            causeId: f,
                            conversationServiceUrl: g.conversationUrl.Location,
                            joinCallOptions: v,
                            offerGenerationTime: void 0
                        }), this.http.cancelRequestIfPending(dn.JOIN_CONVERSATION.name, f, void 0, S), this.http.cancelRequestIfPending(dn.START_CALL.name, f, void 0, S), this.joinGivenConversation(g.conversationUrl.Location, g.correlationId, this.lastUsedOutgoingMediaContent, this.mediaTypesToUse, void 0, v, f);
                    }
                }
                handleCallProgress(g) {
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CALL_PROGRESS, g);
                    const f = extractCauseIdFromMessage(g);
                    this.logger.info(`[${f}][handleCallProgress]`);
                    const S = g.body.callProgress;
                    this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING && (this.telemetryHelper.setTimeToRingDuration(), this.resetCallEstablishmentTimeout(f), this.onCallStatusChanged(an.CALL_STATUS.RINGING, f), "forwarded" === S.status && this.signalingSessionCallback.onCallForwarded({
                        destinationType: S.forwardingDestinationType || "user"
                    }, f));
                }
                resetCallEstablishmentTimeout(g) {
                    const f = this.isOneToOnePSTNCall() ? an.TIMEOUT_VALUES_IN_SECONDS.LONGER_OUTGOING_CALL_ESTABLISHMENT_TIMEOUT : an.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT;
                    this.logger.info(`resetCallEstablishmentTimeout: ${f}s`), this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT, ()=>{
                        this.handleCallEstablishmentTimeout(g);
                    }, f);
                }
                handleMediaAcknowledgement(g) {
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_MEDIA_ACK, g);
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.currentCallStatus !== an.CALL_STATUS.CONNECTED ? this.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_PROVISIONAL_ACK, {
                        causeId: S
                    }) : this.mediaRenegotiationManager.handleMediaAcknowledgment(f, S);
                }
                handleConversationUpdate(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleConversationUpdate]content=${getPrintableObject(f)}`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_CONVERSATION_UPDATE, g), this.processConversationServiceResponse(f, S, 2);
                }
                endBroadcastMeeting(g) {
                    this.logger.info(`[${g}][endBroadcastMeeting]`), this.broadcastSession = null;
                }
                handleLocalParticipantUpdate(g) {
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleLocalParticipantUpdate]content=${getPrintableObject(f)}`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_LOCAL_PARTICIPANT_UPDATE, g), this.processLocalParticipantUpdateResponse(f, S);
                }
                handleAddModalityFailure(g) {
                    var _this_contentSharingManager;
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleAddModalityFailure]`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADD_MODALITY_FAILURE, g), f.modalityFailure.contentSharing ? (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.handleAddModalityFailure(f, S) : f.modalityFailure.groupChat ? this.signalingSessionCallback.onChatModalitySetupFailed({
                        code: f.modalityFailure.groupChat.code,
                        subCode: f.modalityFailure.groupChat.subCode,
                        phrase: f.modalityFailure.groupChat.phrase,
                        resultCategories: f.modalityFailure.groupChat.resultCategories
                    }, S) : f.modalityFailure.broadcast && this.broadcastSession && this.broadcastSession.handleAddBroadcastModalityFailure(f, S);
                }
                handleAddModalitySuccess(g) {
                    var _this_contentSharingManager;
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleAddModalitySuccess]`), this.telemetryHelper.recordIncomingEvent(cn.HANDLE_ADD_MODALITY_SUCCESS, g), f.modalitySuccess.contentSharing ? (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.handleAddModalitySuccess(f, S) : f.modalitySuccess.groupChat ? this.logger.info(`[${S}][handleAddModalitySuccess] group modality ${getPrintableObject(f.modalitySuccess.groupChat)}`) : f.modalitySuccess.broadcast && this.broadcastSession && this.broadcastSession.handleAddBroadcastModalitySuccess(f, S);
                }
                handleTransferRequested(g) {
                    const f = g.body.callTransfer, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleTransferRequested]`), f.parkType ? (this.telemetryHelper.recordIncomingEvent(cn.HANDLE_PARK_REQUESTED, g, {
                        type: f.parkType
                    }), this.telemetryHelper.addSharedCorrelationId(f.sharedCorrelationId)) : "voicemail" === f.target.endpointType ? (this.logger.info(`[${S}][handleTransferRequested] target endpointType = ${f.target.endpointType}`), this.telemetryHelper.recordIncomingEvent(cn.TRANSFER_REQUEST_RECEIVED, g)) : this.telemetryHelper.recordIncomingEvent(cn.TRANSFER_REQUEST_RECEIVED, g), this.links[an.LINKS.TRANSFER_ACCEPTANCE] = f.links.transferAcceptance, this.links[an.LINKS.TRANSFER_COMPLETION] = f.links.transferCompletion, this.signalingSessionCallback.onTransferRequested ? this.signalingSessionCallback.onTransferRequested(f, S) : this.logger.info(`[${S}][handleTransferRequested] failed, no callback defined`);
                }
                handleTransferAcceptance(g) {
                    const f = extractCauseIdFromMessage(g);
                    this.logger.info(`[${f}][handleTransferAcceptance]`), this.telemetryHelper.recordIncomingEvent(cn.WAITING_FOR_TRANSFER_COMPLETION, g), this.signalingSessionCallback.onTransferAccepted ? this.signalingSessionCallback.onTransferAccepted(f) : this.logger.info(`[${f}][handleTransferAcceptance]failed, no callback defined`);
                }
                handleTransferCompletion(g) {
                    var _f_unparkContent;
                    const f = g.body, S = extractCauseIdFromMessage(g);
                    this.logger.info(`[${S}][handleTransferCompletion]`), f.sharedCorrelationId && this.telemetryHelper.addSharedCorrelationId(f.sharedCorrelationId), void 0 !== ((_f_unparkContent = f.unparkContent) === null || _f_unparkContent === void 0 ? void 0 : _f_unparkContent.pickupCode) && (f.unparkContent.pickupCode = f.unparkContent.pickupCode.toString(), this.telemetryHelper.recordIncomingEvent(cn.PICKUP_CODE_SET, g)), this.signalingSessionCallback.onTransferCompleted ? (g.body.transferCompletion && (0 === g.body.transferCompletion.code ? this.telemetryHelper.recordIncomingEvent(cn.TRANSFER_COMPLETED, g) : (this.logger.info(`[${S}][handleTransferCompletion]-1-code: ${f.transferCompletion.code}, message: ${getPrintableObject(g)}`), this.telemetryHelper.recordIncomingEvent(cn.TRANSFER_COMPLETION_FAILED, g, {
                        code: f.transferCompletion.code,
                        subcode: f.transferCompletion.subCode,
                        resultCategories: f.transferCompletion.resultCategories
                    }))), this.signalingSessionCallback.onTransferCompleted(f, S)) : (g.body.transferCompletion && (g.body.transferCompletion.code === an.CALL_END_CODE.NETWORK_ERROR ? this.telemetryHelper.recordIncomingEvent(cn.WAITING_FOR_TRANSFER_COMPLETION_FAIL, g) : this.telemetryHelper.recordIncomingEvent(cn.TRANSFER_COMPLETION_FAILED, g, {
                        code: f.transferCompletion.code,
                        subcode: f.transferCompletion.subCode,
                        resultCategories: f.transferCompletion.resultCategories
                    })), this.logger.info(`[${S}][handleTransferCompletion]failed, no callback defined`));
                }
                handleRosterUpdate(g, f) {
                    const S = g.body, v = extractCauseIdFromMessage(g);
                    this.disposing || this.disposed ? this.logger.info(`[${v}][handleRosterUpdate]failed=ignore call ending or ended`) : this.internalHandleRosterUpdate(S, f, v);
                }
                handleNewMediaOffer(g) {
                    const f = extractCauseIdFromMessage(g);
                    this.telemetryHelper.recordIncomingEvent(cn.HANDLE_NEW_OFFER, g);
                    const S = g.body.mediaOfferReady.mediaContent;
                    this.callUsesMixer = S.fromMixer, this.signalingSessionCallback.onNewOffer({
                        mediaContent: S,
                        renegotiation: !1
                    }, f);
                }
                internalHandleRosterUpdate(g, f, S) {
                    if (g && "Delta" !== g.type && "MultiPartyEndpoint" !== g.type) this.logger.warn(`[${S}][internalHandleRosterUpdate] roster.type=${g.type} is invalid`);
                    else {
                        this.logger.info(`[${S}][internalHandleRosterUpdate]`);
                        try {
                            var _this_contentSharingManager;
                            this.participantManager.handleRosterUpdate(g, f, S), (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.handleIncomingContentSharingFromRoster(g, f, S);
                        } catch (f) {
                            const v = {
                                code: an.CALL_END_CODE.BAD_SERVICE_RESPONSE,
                                subCode: an.CALL_END_SUB_CODE.ROSTER_HANDLING_INVALID_SERVICE_RESPONSE,
                                phrase: f === null || f === void 0 ? void 0 : f.toString()
                            };
                            throw this.logger.info(`[${S}][internalHandleRosterUpdate] ${safeJsonStringify(v)}`), this.telemetryHelper.recordRosterEvent(g, cn.HANDLE_ROSTER_UPDATE_FAIL, S), v;
                        }
                    }
                }
                scheduleKeepAlives(g) {
                    const f = .9 * g * 1e3;
                    this.logger.info(`scheduleKeepAlives: every ${f} milliseconds`), this.keepAliveInterval = f, this.keepAliveTimer = window.setInterval(this.sendKeepAlive.bind(this), this.keepAliveInterval);
                }
                scheduleConversationKeepAlive() {
                    if (!this.conversationKeepAliveTimer && !this.disposed) {
                        if (!this.conversationKeepAliveInterval) {
                            const g = getRandomizedTimeout(1e3 * this.signalingAgentConfig.csaTimeoutConfiguration.conversationKeepAliveTimeoutSec);
                            this.logger.info(`sendConversationKeepAlive: every ${g} milliseconds`), this.conversationKeepAliveInterval = g;
                        }
                        this.conversationKeepAliveTimer = window.setInterval(this.sendConversationKeepAlive.bind(this), this.conversationKeepAliveInterval);
                    }
                }
                sendConversationKeepAlive() {
                    this.logger.info("sendConversationKeepAlive"), this.disposed ? this.logger.info("sendConversationKeepAlive ignored") : (this.logger.info("sendConversationKeepAlive keepAlive count = " + this.conversationKeepAliveCount++), this.sendToUpdateConversationLinks(!0));
                }
                sendKeepAlive() {
                    this.logger.info("sendKeepAlive"), this.disposed ? this.logger.info("sendKeepAlive ignored") : (this.logger.info("sendKeepAlive keepAlive count = " + this.keepAliveCount++), this.sendToKeepAliveUrl(null));
                }
                sendToUpdateConversationLinks(g, f = causeId2()) {
                    if (this.disposed) return Promise.resolve();
                    const S = this.logger.createChild(`[${f}][sendToUpdateConversationLinks]`, this.correlationId), v = g ? getPayload56(this) : {}, _ = g ? dn.UPDATE_CONVERSATION_LINKS.name : dn.SEND_CONVERSATION_KEEP_ALIVE.name, C = this.links[an.LINKS.NOTIFICATION_LINKS];
                    return S.info(`shouldUpdateUrl: ${g}, url: ${C}, payload: ${getPrintableObject(v)}`), C ? (this.conversationKeepAliveTimer && (window.clearInterval(this.conversationKeepAliveTimer), this.conversationKeepAliveTimer = 0), this.http.sendPostRequest({
                        url: C,
                        payload: v,
                        withoutTrouter: !0,
                        requestName: _,
                        causeId: f
                    }).then((g)=>{
                        this.disposed || (this.telemetryHelper.recordEvent(cn.UPDATE_CONVERSATION_LINKS_SUCCESS, {
                            causeId: f
                        }), this.processConversationServiceResponse(g.response, f, 2));
                    }).catch((g)=>{
                        const S = getErrorForXHRFailure(g, this.signalingAgentConfig), v = isRetryable(S.error.code);
                        this.logger.info(`[${f}][updateConversationLinks] error: ${getPrintableObject(S)}, retryable: ${v}`), this.disposed || (this.telemetryHelper.recordEvent(cn.UPDATE_CONVERSATION_LINKS_FAILED, {
                            causeId: f,
                            ...S.error
                        }), v ? this.scheduleConversationKeepAlive() : this.links[an.LINKS.NOTIFICATION_LINKS] = null);
                    })) : Promise.resolve();
                }
                sendToKeepAliveUrl(g, f = causeId2()) {
                    const S = this.logger.createChild(`[${f}][sendToKeepAliveUrl]`, this.correlationId);
                    return S.info(`payload: ${getPrintableObject(g)}`), window.clearInterval(this.keepAliveTimer), this.disposed ? Promise.resolve() : (this.telemetryHelper.recordEvent(cn.SEND_KEEP_ALIVE), this.http.sendPostRequest({
                        url: this.links[an.LINKS.KEEPALIVE],
                        payload: g,
                        requestName: dn.SEND_KEEP_ALIVE.name,
                        withoutTrouter: !0,
                        causeId: f
                    }).then(()=>{
                        this.restartKeepAliveInterval(f);
                    }).catch((g)=>{
                        const v = getErrorForXHRFailure(g, this.signalingAgentConfig);
                        S.info(`error: ${getPrintableObject(v)}`), this.restartKeepAliveInterval(f, !0, v.error);
                    }));
                }
                handleCallEstablishmentTimeout(g, f, S) {
                    const v = {
                        code: an.CALL_END_CODE.TIMEOUT,
                        subCode: f || an.CALL_END_SUB_CODE.CALL_ESTABLISHMENT_TIMEOUT,
                        phrase: S || an.CALL_END_PHRASE.ESTABLISHMENT_TIMEOUT,
                        resultCategories: [
                            Qi.UnexpectedClientError
                        ]
                    };
                    this.isPromotingToRealtime ? this.onPromotionCompleted(!0, v, g) : (this.telemetryHelper.recordEvent(cn.HANDLE_CALL_ESTABLISHMENT_TIMEOUT), this.telemetryHelper.setTerminatingData({
                        terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                        resultValue: un.RESULT_VALUE.FAILURE,
                        resultDetail: v.phrase,
                        endCode: v.code,
                        endSubCode: v.subCode,
                        causeId: g,
                        resultCategories: v.resultCategories
                    }), this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, g, v), this.dispose(v, g));
                }
                handleCallTransferTimeout(g, f) {
                    if (this.disposed) return void this.logger.info("Transfer: handleCallTransferTimeout ignored");
                    const S = {
                        code: an.CALL_END_CODE.TIMEOUT,
                        phrase: an.CALL_END_PHRASE.TRANSFER_COMPLETION_TIMEOUT
                    };
                    this.signalingSessionCallback.onTransferCompleted && (!1 === f ? this.telemetryHelper.recordEvent(cn.TRANSFER_COMPLETION_FAILED, {
                        code: an.CALL_END_CODE.TIMEOUT,
                        subcode: an.CALL_END_SUB_CODE.TRANSFER_COMPLETE_TIMEOUT,
                        causeId: g
                    }) : !0 === f && this.telemetryHelper.recordEvent(cn.WAITING_FOR_TRANSFER_ACCEPTANCE_FAIL, {
                        causeId: g
                    }), this.signalingSessionCallback.onTransferCompleted({
                        transferCompletion: S
                    }, g));
                }
                checkCorrelationIdChange(g, f) {
                    if (g && g.headers) {
                        const S = g.headers.get(an.HEADERS.CORRELATION_ID);
                        if (S && S.length) {
                            const v = [
                                nn.CONV_CONTENT_SHARING_UPDATE,
                                nn.CONV_CONTENT_SHARING_END
                            ].some((f)=>g.url && stringEndsWith(g.url, f));
                            this.correlationId === S || v || (this.logger.info(`[${f}]checkCorrelationIdChange:${this.correlationId} => ${S}`), this.telemetryHelper.addChangingCorrelationId(this.correlationId, S), this.updateCorrelationId(S, f));
                        }
                    }
                }
                getCommandUrlPresence() {
                    let g = 0;
                    return this.links[an.LINKS.MUTE] && (g |= 1), this.links[an.LINKS.UNMUTE] && (g |= 2), g;
                }
                getCallNotFoundTransactionEnd() {
                    return {
                        code: an.CALL_END_CODE.CALL_DOES_NOT_EXIST,
                        subCode: 0,
                        phrase: an.CALL_END_PHRASE.CALL_DOES_NOT_EXIST
                    };
                }
                dispose(g, f) {
                    this.disposed || (this.logger.info(`[${f}][dispose] end reason ${getPrintableObject(g)}`), this.disposed = !0, this.disposing = !1, this.tearDownConnectionCheck(), this.conversationKeepAliveTimer && (window.clearInterval(this.conversationKeepAliveTimer), this.conversationKeepAliveTimer = 0), this.keepAliveTimer && window.clearInterval(this.keepAliveTimer), this.brokerService && this.brokerService.dispose(), this.http.cancelAllRequests(f).then(()=>{
                        var _this_mediaRenegotiationManager, _this_contentSharingManager;
                        this.signalingAgent.onCallCompleted(this.sessionId, f), this.signalingAgentConfig.trouterUrlGetter && this.signalingAgentConfig.trouterUrlGetter.trouterUrl.changed.off(this.onTrouterUrlChanged), this.signalingAgentConfig.trouterServiceProvider && this.signalingAgentConfig.trouterServiceProvider.offStateChanged(this.onTrouterStateChanged), this.timeoutManager.dispose(), this.timeoutManager = null, this.participantManager.dispose(g, f), this.callOperationHandler.dispose("call ended", g, f), this.participantManager = null, (_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.dispose(), this.mediaRenegotiationManager = null, (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.dispose(g, f), this.contentSharingManager = null, this.telemetryHelper.dispose(), this.telemetryHelper = null, this.webRtcSignalingManager.dispose(), this.webRtcSignalingManager = null;
                    }));
                }
                constructor(g, f, S, v, _, C){
                    this.disposed = !1, this.convSubject = null, this.groupId = null, this.threadId = null, this.incomingCallCallerId = null, this.incomingCallPayload = null, this.multiParty = !0, this.isIncomingCall = !1, this.isHostLessCall = !1, this.isCastCall = !1, this.isHuddleGroupCall = !1, this.numberOfOriginalInvitees = 0, this.teamsMessageId = null, this.enableGroupCallMeetupGeneration = !1, this.meetingInfo = null, this.meetingDetails = null, this.emergencyContent = null, this.transferContext = null, this.callType = "default", this.callMode = 0, this.transferor = null, this.onBehalfOf = null, this.onBehalfOfUserDisplayName = null, this.callQueueContext = null, this.callQueueSupervisorContent = null, this.bannerContent = null, this.callPhoneLineType = null, this.endpointMetadata = {}, this.sessionId = newGuid(), this.remoteCaller = null, this.acceptedElsewhereBy = null, this.parkAdditionalContextJson = null, this.serverHoldLocation = null, this.breakoutDetails = null, this.callLimits = null, this.complianceRecordingContent = null, this.backroomThreadId = null, this.streamThreadId = null, this.lobbyThreadId = null, this.conversationStartTime = null, this.realTimeState = 0, this.disposing = !1, this.links = {}, this.provisionalMediaAnswersSeenSoFar = [], this.incomingTrouterMessagesSeenSoFar = [], this.incomingBrokerMessagesSeenSoFar = [], this.currentCallStatus = null, this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.convJoined = !1, this.keepAliveTimer = null, this.keepAliveInterval = null, this.keepAliveCount = 1, this.conversationKeepAliveTimer = null, this.conversationKeepAliveInterval = null, this.conversationKeepAliveCount = 1, this.remoteUser = null, this.mediaTypesToUse = null, this.lastUsedOutgoingMediaContent = null, this.lastUsedJoinCallOptions = null, this.originalRoleBeforePreheat = "", this.endpointStateSequenceNumber = 0, this.publishStateSequenceNumber = 0, this.monitorSequenceId = 0, this.requestedPublishedStatesWhileConnecting = null, this.linkUpdateRequested = {
                        conversationLinks: !1,
                        keepAliveLinks: !1
                    }, this.incomingMessageSyncResponseCache = {}, this.isPreheatOnly = !1, this.callStartTime = (new Date).getTime(), this.callUsesMixer = !1, this.disablePreheatDefer = defer(), this.participantReplacementDetails = {}, this.meetingLiveStateSequenceNumber = 0, this.meetingLayoutSequenceNumber = 0, this.localParticipantUpdateSequenceNumber = 0, this.isRedirectAllowed = !1, this.updateSequenceNumber = -1, this.isPromotingToRealtime = !1, this.streamInformationReceived = !1, this.startOrJoinConvResponseReceived = !1, this.updateParticipantsPromises = {}, this.updateEndpointState = (g, f = causeId2(), S, v)=>{
                        var _E_endpointProperties;
                        this.logger.info(`[${f}][requestedEndpointState=${getPrintableObject(g, !0)}][captchaContentJson=${v}]`);
                        const _ = this.links[an.LINKS.UPDATE_ENDPOINT_STATE], C = this.getEndpointState();
                        this.logger.info(`[${f}][currentEndpointState=${getPrintableObject(C, !0)}] startOrJoinConvResponseReceived=${this.startOrJoinConvResponseReceived}`);
                        const E = {
                            ...C,
                            ...g,
                            endpointStateSequenceNumber: ++this.endpointStateSequenceNumber
                        };
                        this.telemetryHelper.recordEvent(cn.UPDATE_ENDPOINT_STATE, {
                            newEndpointState: E,
                            causeId: f
                        });
                        const T = 0 === (E === null || E === void 0 ? void 0 : (_E_endpointProperties = E.endpointProperties) === null || _E_endpointProperties === void 0 ? void 0 : _E_endpointProperties.preheatProperties) && this.isPreheatOnly;
                        if (T && (this.telemetryHelper.recordEvent(cn.PREHEAT_DISABLING, {
                            causeId: f
                        }), this.telemetryHelper.startPreheatedCallSetupDurationWatch(), this.telemetryHelper.startCallCancelationDurationWatch()), 2 === this.callMode && T) return this.logger.info(`[${f}][updateEndpointState skipped as mode is streaming]`), this.handleEndpointStateUpdated(f, !0), Promise.resolve();
                        if (!this.startOrJoinConvResponseReceived) return this.logger.info(`[${f}][updateEndpointState will be queued as we don't have a link yet]`), this.requestedEndpointStateWhileConnecting = g, this.requestedPublishedStatesWhileConnecting = S, T ? this.disablePreheatDefer.promise : Promise.resolve();
                        if (!this.shouldUpdateEndpointState(C, E) && !this.http.hasPendingRequest(dn.UPDATE_ENDPOINT_STATE.name)) return this.logger.info(`[${f}][updateEndpointState will ignore current update as there is nothing new to send]`), Promise.resolve();
                        if (!_) return this.logger.info(`[${f}][updateEndpointState operation cannot be performed now, the link is not yet available]`), Promise.reject("No link");
                        this.latestEndpointState = E;
                        const I = this.signalingAgentConfig.enableAsyncDisablePreheat && T;
                        I && this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.DISABLE_PREHEAT_ASYNC_TIMEOUT, ()=>{
                            const g = {
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.DISABLE_PREHEAT_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.DISABLE_PREHEAT_TIMEOUT
                            };
                            this.disablePreheatDefer.isPending() && this.disablePreheatDefer.reject({
                                response: g
                            });
                        }, an.TIMEOUT_VALUES_IN_SECONDS.DISABLE_PREHEAT_TIMEOUT);
                        const b = this.http.sendPostRequest({
                            url: _,
                            requestName: dn.UPDATE_ENDPOINT_STATE.name,
                            payload: getPayload52(this, E, S, I, v),
                            causeId: f
                        }).then(()=>(I && (this.logger.info(`[${f}][updateEndpointState] asyncDisablePreheat: true`), this.telemetryHelper.recordEvent(cn.DISABLE_PREHEAT_RESPONSE_RECEIVED, {
                                causeId: f
                            })), Promise.resolve())).catch((g)=>{
                            if (!I) throw g;
                            this.disablePreheatDefer.reject(g);
                        });
                        return (I ? this.disablePreheatDefer.promise : b).then(()=>{
                            this.logger.info(`[${f}][updateEndpointState] asyncDisablePreheat: ${I}`), this.telemetryHelper.recordEvent(I ? cn.ASYNC_DISABLE_PREHEAT_SUCCEEDED : cn.DISABLE_PREHEAT_SUCCEEDED, {
                                causeId: f
                            }), this.disposed || this.handleEndpointStateUpdated(f, T);
                        }).catch((g)=>{
                            const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            return this.logger.info(`[${f}][updateEndpointState] error: ${getPrintableObject(S)}`), T && (this.handleDisablePreheatError(S.error, I ? cn.ASYNC_DISABLE_PREHEAT_FAILED : cn.DISABLE_PREHEAT_FAILED, f), this.stopCallPreheatTimer(), this.terminateEstablishedCall({
                                code: S.error.code,
                                subCode: S.error.subCode,
                                phrase: S.error.phrase
                            }, {
                                forEveryone: !1,
                                causeId: f
                            })), Promise.reject(S.error);
                        });
                    }, this.setParticipantCallLinks = (g)=>{
                        g && g.endpointDetails && (this.participantReplacementDetails[g.id] = {}, g.endpointDetails.forEach((f)=>{
                            f && f.callLinks && (this.participantReplacementDetails[g.id][f.participantId] = f.callLinks);
                        }));
                    }, this.clearParticipantCallLinks = (g)=>{
                        var _this_participantReplacementDetails;
                        ((_this_participantReplacementDetails = this.participantReplacementDetails) === null || _this_participantReplacementDetails === void 0 ? void 0 : _this_participantReplacementDetails.hasOwnProperty(g)) && delete this.participantReplacementDetails[g];
                    }, this.getReplacementDetailsByParticipantLeg = (g, f, S = causeId2())=>{
                        var _this_participantReplacementDetails;
                        return this.logger.info(`[${S}]getReplacementDetailsByParticipantLeg: participantMri ${this.piiUtils.scrubMriOrOmit(g)} participantLegId ${f}`), ((_this_participantReplacementDetails = this.participantReplacementDetails) === null || _this_participantReplacementDetails === void 0 ? void 0 : _this_participantReplacementDetails.hasOwnProperty(g)) && this.participantReplacementDetails[g].hasOwnProperty(f) ? {
                            replaces: this.participantReplacementDetails[g][f].replacement,
                            replacementTargetParticipantId: f
                        } : (this.logger.info(`[${S}]getReplacementDetailsByParticipantLeg: unable to find replacement details for participantLegId ${f}`), {});
                    }, this.getReplacementDetailsByParticipantLegOfCall = (g, f, S, v = causeId2())=>{
                        this.logger.info(`[${v}]getReplacementDetailsByParticipantLegOfCall: callId ${g} participantMri ${this.piiUtils.scrubMriOrOmit(f)} participantLegId ${S}`);
                        const _ = this.signalingAgent.getSignalingSession(g);
                        return _ ? _.getReplacementDetailsByParticipantLeg(f, S, v) : {};
                    }, this.getMriByParticipantLegOfCall = (g, f, S)=>{
                        this.logger.info(`[${S}]getMriByParticipantLegOfCall: callId: ${g} participantLegId ${f}`);
                        const v = this.signalingAgent.getSignalingSession(g);
                        return v ? v.getMriByParticipantLeg(f, S) : "";
                    }, this.getMriByParticipantLeg = (g, f)=>{
                        var _this_participantReplacementDetails_f;
                        this.logger.info(`getMriByParticipantLeg[${f}] participantLegId ${g}`);
                        for (const f of Object.keys(this.participantReplacementDetails))if (f && this.participantReplacementDetails.hasOwnProperty(f) && ((_this_participantReplacementDetails_f = this.participantReplacementDetails[f]) === null || _this_participantReplacementDetails_f === void 0 ? void 0 : _this_participantReplacementDetails_f.hasOwnProperty(g))) return f;
                        return "";
                    }, this.handleEndpointStateUpdated = (g, f)=>{
                        this.requestedEndpointStateWhileConnecting = null, this.requestedPublishedStatesWhileConnecting = null, f && this.handlePreheatDisabled(g);
                    }, this.handlePreheatDisabled = (g)=>{
                        this.isPreheatOnly = !1, this.telemetryHelper.setSelfParticipantRole(this.originalRoleBeforePreheat), this.telemetryHelper.recordEvent(cn.PREHEAT_DISABLED, {
                            causeId: g
                        }), this.telemetryHelper.resetCallCancelationDurationWatch(), this.telemetryHelper.stopPreheatedCallSetupDurationWatch(), this.telemetryHelper.startCallConnectedWatch(), this.stopCallPreheatTimer(), this.disablePreheatDefer.isPending() && this.disablePreheatDefer.resolve();
                    }, this.shouldUpdateEndpointState = (g, f)=>{
                        var _g_endpointProperties, _f_endpointProperties;
                        if (!f) return !1;
                        const S = f.state && f.state.isMuted ? 1 : 0, v = f.endpointProperties && 1 === f.endpointProperties.preheatProperties ? 1 : 0, _ = g && g.state && g.state.isMuted ? 1 : 0, C = g && g.endpointProperties && 1 === g.endpointProperties.preheatProperties ? 1 : 0, E = g === null || g === void 0 ? void 0 : (_g_endpointProperties = g.endpointProperties) === null || _g_endpointProperties === void 0 ? void 0 : _g_endpointProperties.additionalEndpointProperties, T = f === null || f === void 0 ? void 0 : (_f_endpointProperties = f.endpointProperties) === null || _f_endpointProperties === void 0 ? void 0 : _f_endpointProperties.additionalEndpointProperties;
                        return !!(S ^ _ || v ^ C || T !== E);
                    }, this.setInitialTelemetry = (g, f)=>{
                        let S, v;
                        switch(g){
                            case "Subscribe":
                                this.telemetryHelper.recordEvent(cn.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY, {
                                    causeId: f.causeId,
                                    correlationId: f.correlationId
                                }), this.telemetryHelper.setDirection(un.DIRECTION.OUTGOING), this.telemetryHelper.setSelfParticipantRole(un.ROLE.JOIN_FOR_ROSTER_ONLY), this.telemetryHelper.setConversationServiceUrl(f.conversationServiceUrl || this.signalingAgentConfig.conversationServiceUrl), this.telemetryHelper.setCallerType(this.participantManager.localParticipant.id);
                                break;
                            case "Acknowledge":
                                this.telemetryHelper.recordEvent(cn.HANDLE_INCOMING_CALL, {
                                    causeId: f.causeId
                                }), this.telemetryHelper.setDirection(un.DIRECTION.INCOMING), this.telemetryHelper.setSelfParticipantRole(un.ROLE.CALLEE), this.telemetryHelper.setCalleeType(this.participantManager.localParticipant.id);
                                break;
                            case "JoinCall":
                                S = this.gatherTelemetryForStartOrJoin(f.joinCallOptions, f.causeId, f.offerGenerationTime), this.telemetryHelper.recordEvent(cn.JOIN_CALL, S), this.telemetryHelper.setDirection(un.DIRECTION.OUTGOING), this.telemetryHelper.setSelfParticipantRole(un.ROLE.JOIN);
                                break;
                            case "StartCall":
                            case "StartCallToVoiceMail":
                            case "StartCallWithNudge":
                            case "StartCallAndUnpark":
                                v = this.gatherTelemetryForStartOrJoin(f.callStartOptions, f.causeId, f.offerGenerationTime), this.telemetryHelper.recordEvent(cn.START_CALL, v), this.telemetryHelper.setDirection(un.DIRECTION.OUTGOING), this.telemetryHelper.setSelfParticipantRole(un.ROLE.CALLER), this.telemetryHelper.startCallInitializationWatch(f.offerGenerationTime), this.telemetryHelper.setMeetingInfo(this.getMeetingInfo());
                        }
                    }, this.getParticipantIdForOfferAnswer = (g)=>{
                        assertNotNull(g, "mediaContent should be a non null value"), this.logger.info("getParticipantIdForOfferAnswer");
                        let f = null;
                        return !this.remoteUser || this.groupId || this.threadId || g.newOffer || g.escalationOccurring || (f = this.remoteUser.id), f;
                    }, this.getMeetingInfo = ()=>this.meetingInfo, this.getEmergencyContent = ()=>(this.telemetryHelper.recordEvent(cn.GET_EMERGENCY_CONTENT), this.emergencyContent), this.getEndpointId = ()=>this.signalingAgent.endpointId, this.getConversationUrl = ()=>this.links[an.LINKS.CONVERSATION_CONTROLLER], this.setJoinedFrom = (g)=>{
                        !this.disposed && g && (this.telemetryHelper.recordEvent(cn.SET_JOINED_FROM), this.telemetryHelper.setJoinedFrom(g));
                    }, this.setMeetingCode = (g)=>{
                        !this.disposed && g && this.telemetryHelper.setMeetingCode(g);
                    }, this.setMeetingUrl = (g)=>{
                        !this.disposed && g && this.telemetryHelper.setMeetingUrl(g);
                    }, this.setSubject = (g)=>{
                        this.disposed || (this.telemetryHelper.recordEvent(cn.SET_SUBJECT), assertNotNull(g, "subject should be a non null value"), this.convSubject = g);
                    }, this.setDeviceType = (g)=>{
                        this.disposed || (this.telemetryHelper.recordEvent(cn.SET_DEVICETYPE), g && (this.deviceType = g, this.logger.info("setDeviceType", this.deviceType)));
                    }, this.setOfferAnswerGenerationTimestamps = (g)=>{
                        this.disposed || this.telemetryHelper.setOfferAnswerGenerationTimestamps(g);
                    }, this.setTimeToRingDuration = ()=>{
                        this.disposed || this.telemetryHelper.setTimeToRingDuration();
                    }, this.setGroupId = (g)=>{
                        this.telemetryHelper.recordEvent(cn.SET_GROUPID), this.groupId !== g && g && (assert2(!this.groupId, "conversation groupId has already been set. It cannot be overwritten"), this.groupId = g);
                    }, this.setThreadId = (g)=>{
                        this.telemetryHelper.recordEvent(cn.SET_THREADID), assertNotNull(g, "threadId should be a non null value"), this.threadId !== g && (assert2(!this.threadId, "conversation threadId has already been set. It cannot be overwritten"), this.threadId = g);
                    }, this.setCallOptions = (g)=>{
                        if (assertNotNull(g, "callOptions should be a non null value"), this.logger.info("setCallOptions", getPrintableObject(g)), this.telemetryHelper.recordEvent(cn.SET_CALLOPTIONS), g) {
                            this.teamsMessageId = g.teamsMessageId, this.meetingInfo = g.meetingInfo || null, this.emergencyContent = g.emergencyContent || null, this.enableGroupCallMeetupGeneration = g.enableGroupCallMeetupGeneration || !1, g.broadcastContext && (this.broadcastSession = new _n(this, this.signalingSessionCallback), this.broadcastSession.setContext(g.broadcastContext));
                            try {
                                this.endpointMetadata = JSON.parse(g.endpointMetadata);
                            } catch (g) {
                                this.logger.warn("Unable to parse endpoint metadata");
                            }
                        }
                    }, this.setTransferContext = (g)=>{
                        assertNotNull(g, "transferContext should not be null"), this.logger.info("Transfer: setTransferContext", scrubObjectFields(g)), this.telemetryHelper.recordEvent(cn.SET_TRANSFER_CONTEXT), this.transferContext = g;
                    }, this.muteAsync = (g, f, S = causeId2())=>(assert2(2 !== this.callMode || g !== an.MUTE_SCOPE.MYSELF, "mute self operation is not allowed in streaming mode"), this.logger.info(`[${S}][muteAsync][scope=${g}]`), this.telemetryHelper.recordEvent(cn.MUTE, {
                            causeId: S
                        }), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, `[${S}]mute operation for all or specified only allowed in a connected call`), this.participantManager.muteAsync(this.links[an.LINKS.MUTE], g, f, S)), this.unmuteAsync = (g = causeId2())=>(assert2(2 !== this.callMode, "unmute operation is not allowed in streaming mode"), this.logger.info(`[${g}][unmuteAsync]`), this.telemetryHelper.recordEvent(cn.UNMUTE, {
                            causeId: g
                        }), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "unmute operation only allowed in a connected call"), this.participantManager.unmuteAsync(this.links[an.LINKS.UNMUTE], g)), this.recordTelemetryForStartAudio = (g, f)=>(this.telemetryHelper.recordEvent(cn.START_AUDIO, {
                            mediaNegotiationStatus: g,
                            causeId: f
                        }), Promise.resolve(null)), this.recordTelemetryForStopAudio = (g, f)=>(this.telemetryHelper.recordEvent(cn.STOP_AUDIO, {
                            mediaNegotiationStatus: g,
                            causeId: f
                        }), Promise.resolve(null)), this.rejectUnmuteRequestAsync = (g, f = causeId2(), S)=>(assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "rejectUnmute operation only allowed in a connected call"), assertNotNullOrEmpty(g, "requestor must be specified"), this.logger.info(`[${f}][rejectUnmuteRequestAsync][rejectionReason=${S}]`), this.telemetryHelper.recordEvent(cn.REJECT_UNMUTE, {
                            causeId: f,
                            rejectionReason: S
                        }), this.participantManager.rejectUnmuteRequestAsync(g, f, S)), this.approveUnmuteRequestAsync = (g, f = causeId2())=>(assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "approveUnmute operation only allowed in a connected call"), assertNotNullOrEmpty(g, "requestor must be specified"), this.logger.info(`[${f}][approveUnmuteRequestAsync]`), this.telemetryHelper.recordEvent(cn.APPROVE_UNMUTE, {
                            causeId: f
                        }), this.participantManager.approveUnmuteRequestAsync(g, f)), this.sendWebRtcMediaNotificationAsync = (g, f, S = causeId2())=>(assert2(2 !== this.callMode, "sendWebRtcMediaNotification operation is not allowed in streaming mode"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "webRtc media notification can only be sent in a connected call"), this.telemetryHelper.recordEvent(cn.SEND_WEBRTC_MEDIA_NOTIFICATION, {
                            causeId: S
                        }), 0 === g ? this.webRtcSignalingManager.sendWebRtcMediaNotificationAsync({
                            operation: dn.SEND_APPLY_CHANNEL_PARAMETERS.name,
                            requestUrl: this.links[an.LINKS.APPLY_CHANNEL_PARAMETERS],
                            requestBody: f,
                            stackRetry: !1
                        }, S) : this.webRtcSignalingManager.sendWebRtcMediaNotificationAsync({
                            operation: dn.SEND_CONTROL_VIDEO_STREAMING.name,
                            requestUrl: this.links[an.LINKS.CONTROL_VIDEO_STREAMING],
                            requestBody: f
                        }, S)), this.addParticipantsAsync = (g, f, S = causeId2())=>{
                        assertNotNullOrEmpty(g, "remoteParticipants should be a non null value"), assert2(this.isCallOngoing() || this.isCallIdleOrRosterOnly(), "remoteParticipants can only be added before starting an outgoing call or to an ongoing call"), this.logger.info(`[${S}][addParticipantsAsync][addParticipantOptions=${getPrintableObject(f)}]\n            [remoteParticipantId=${g.map((g)=>this.piiUtils.scrubMriOrOmit(g.id))}]`);
                        let v = cn.ADD_PARTICIPANT;
                        switch(f.replacementType){
                            case 2:
                                v = cn.ADD_PARTICIPANT_WITH_PICKUP_CODE;
                                break;
                            case 1:
                            case 3:
                                v = cn.ADD_PARTICIPANT_WITH_REPLACES;
                                break;
                            default:
                                v = cn.ADD_PARTICIPANT;
                        }
                        this.telemetryHelper.recordEvent(v, {
                            causeId: S
                        }), f.groupId = this.groupId || f.groupId, f.threadId = this.threadId || f.threadId;
                        const _ = f.threadId || f.groupId ? this.links[an.LINKS.ADD_PARTICIPANTS_AND_MODALITY] : this.links[an.LINKS.ADD_PARTICIPANT], C = this.participantManager.addParticipantsAsync(g, _, this.isCallConnectedOrConnectedForRoster(), f, S);
                        return this.currentCallStatus || this.setMultiParty(1 !== this.participantManager.getParticipantsToInitiateCallWith().length, S), C;
                    }, this.addGroupModalityAsync = (g, f)=>{
                        assert2(this.isCallOngoing(), "GroupModality can only be added before starting an outgoing call or to an ongoing call"), this.logger.info(`[${f}][addGroupModalityAsync][addGroupModalityOptions=${getPrintableObject(g)}]`);
                        const S = cn.ADD_PARTICIPANTS_AND_MODALITY;
                        this.telemetryHelper.recordEvent(S, {
                            causeId: f
                        });
                        const v = getPayload11(this, null, g);
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.ADD_PARTICIPANTS_AND_MODALITY],
                            payload: v,
                            requestName: dn.ADD_PARTICIPANTS_AND_MODALITY.name,
                            causeId: f
                        }).then(()=>{
                            vn.noop();
                        }).catch((g)=>{
                            const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            this.logger.info(`[${f}][sendNetworkRequestForAddingParticipant] failed:${getPrintableObject(S)}`);
                            throw S.error;
                        });
                    }, this.addModalityAsync = (g, f)=>{
                        assert2(this.isCallOngoing(), "GroupModality can only be added before starting an outgoing call or to an ongoing call"), this.logger.info(`[${f}][addModalityAsync][modalityContext=${getPrintableObject(g)}]`), this.telemetryHelper.recordEvent(cn.ADD_MODALITY, {
                            causeId: f
                        });
                        const S = getPayload25(this, g);
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.ADD_MODALITY],
                            payload: S,
                            requestName: dn.ADD_MODALITY.name,
                            causeId: f
                        }).then((g)=>(this.logger.info(`[${f}][addModalityAsync] response: ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_ADD_MODALITY_COMPLETION, {
                                causeId: f
                            }), an.SUCCESS_TRANSACTION_END)).catch((g)=>{
                            const S = getErrorForXHRFailure(g);
                            return this.logger.info(`[${f}][sendNetworkRequestForAddModalityAsync] failed:${getPrintableObject(S)}`), Promise.reject(S.error);
                        });
                    }, this.addBroadcastModalityAsync = (g, f)=>{
                        if (assert2(this.isCallOngoing(), "BroadcastModality can only be added before starting an outgoing call or to an ongoing call"), this.logger.info(`[${f}][addBroadcastModalityAsync][addBroadcastContext=${getPrintableObject(this.addBroadcastModalityAsync)}]`), this.telemetryHelper.recordEvent(cn.ADD_BROADCAST_MODALITY, {
                            causeId: f
                        }), this.broadcastSession) {
                            const g = "There is already a broadcast session";
                            return this.logger.info(g), Promise.resolve(an.SUCCESS_TRANSACTION_END);
                        }
                        this.broadcastSession = new _n(this, this.signalingSessionCallback), this.broadcastSession.setContext(g);
                        const S = getPayload24(this, g);
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.ADD_MODALITY],
                            payload: S,
                            requestName: dn.ADD_BROADCAST_MODALITY.name,
                            causeId: f
                        }).then((g)=>(this.logger.info(`[${f}][addBroadcastModalityAsync] response: ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_ADD_BROADCAST_MODALITY_COMPLETION, {
                                causeId: f
                            }), an.SUCCESS_TRANSACTION_END)).catch((g)=>{
                            const S = getErrorForXHRFailure(g);
                            return this.logger.info(`[${f}][sendNetworkRequestForAddBroadcastModalityAsync] failed:${getPrintableObject(S)}`), this.endBroadcastMeeting(f), Promise.reject(S.error);
                        });
                    }, this.nudgeParticipantsAsync = (g)=>{
                        if (assertNotNull(g.participantsIds, "ParticipantsIds should be a non null value"), assert2(this.isCallOngoing(), "Participants can only be nudged before starting an outgoing call or to an ongoing call"), this.logger.info(`[${g.causeId}][nudgeParticipantsAsync][participantsIds=${this.piiUtils.scrubParticipantsList(g.participantsIds)}][invitationData=${g.invitationData}]`), void 0 === g.participantsIds || g.participantsIds.length < 1) return Promise.reject("List of participants to nudge is empty");
                        this.telemetryHelper.recordEvent(cn.ADD_PARTICIPANT, {
                            withNudge: an.INVITATION_TYPE.NUDGE,
                            causeId: g.causeId
                        });
                        const f = this.groupId || g.newGroupId, S = this.threadId || g.newThreadId, v = this.teamsMessageId || g.newMessageId, _ = S || f ? this.links[an.LINKS.ADD_PARTICIPANTS_AND_MODALITY] : this.links[an.LINKS.ADD_PARTICIPANT];
                        return this.participantManager.nudgeParticipantsAsync(g.participantsIds, _, this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING || this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, g.causeId, g.invitationData, f, S, v);
                    }, this.callMeBackAsync = (g, f = causeId2())=>(assertNotNull(g, "remoteParticipant should be a non null value"), this.logger.info(`[${f}][callMeBackAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(g.id)}]`), this.telemetryHelper.recordEvent(cn.CALL_ME_BACK, {
                            causeId: f
                        }), this.hasGroupModality() || assert2(!1, "threadId/groupId must be set before using call me back"), this.participantManager.callMeBackAsync(g, this.links[an.LINKS.ADD_PARTICIPANTS_AND_MODALITY], f)), this.removeParticipantAsync = (g, f = causeId2(), S = "none")=>{
                        switch(assertNotNull(g, "remoteParticipant should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "participants can only be removed from an ongoing call"), this.logger.info(`[${f}][removeParticipantAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(g.id)}] [removeEndpointScope] ${S}`), S){
                            case "all":
                                this.telemetryHelper.recordEvent(cn.REMOVE_PARTICIPANT_OTHERS, {
                                    causeId: f
                                });
                                break;
                            case "specified":
                                this.telemetryHelper.recordEvent(cn.REMOVE_PARTICIPANT_SPECIFIED, {
                                    causeId: f
                                });
                                break;
                            default:
                                this.telemetryHelper.recordEvent(cn.REMOVE_PARTICIPANT, {
                                    causeId: f
                                });
                        }
                        return "none" !== S && g.endpointId ? this.participantManager.removeParticipantEndpointAsync(g, this.links[an.LINKS.REMOVE_PARTICIPANT], S, f) : this.participantManager.removeParticipantAsync(g, this.links[an.LINKS.REMOVE_PARTICIPANT], f);
                    }, this.admitParticipantAsync = (g, f = causeId2())=>(assertNotNull(g, "remoteParticipant should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "remoteParticipants can only be admitted to an ongoing call"), this.hasGroupModality() || assert2(!1, "threadId/groupId must be set before admitting more participants to connected call"), this.logger.info(`[${f}][admitParticipantAsync][remoteParticipantId=${this.piiUtils.scrubMriOrOmit(g.id)}]`), this.telemetryHelper.recordEvent(cn.ADMIT_PARTICIPANT, {
                            causeId: f
                        }), this.participantManager.admitParticipantAsync(g, this.links[an.LINKS.ADMIT], f)), this.admitAsync = (g)=>{
                        if (this.logger.info(`[${g}][admitAsync]`), this.telemetryHelper.recordEvent(cn.ADMIT, {
                            causeId: g
                        }), !this.links[an.LINKS.ADMIT_ALL]) {
                            const f = {
                                code: an.CALL_END_CODE.REJECT,
                                subCode: an.CALL_END_SUB_CODE.ADMIT_ALL_LINK_MISSING,
                                phrase: an.CALL_END_PHRASE.ADMIT_ALL_URL_MISSING
                            };
                            return this.telemetryHelper.recordEvent(cn.ADMIT_FAILURE, {
                                causeId: g,
                                transactionEnd: f
                            }), this.logger.warn(`admitAsync error ${getPrintableObject(f)}`), Promise.reject(f);
                        }
                        const f = defer();
                        return this.callOperationHandler.setPendingOperation(0, g, {
                            promise: f,
                            causeId: g
                        }, g), this.sendNetworkRequestForAdmit(g), f.promise;
                    }, this.updateMeetingRolesAsync = (g, f, S = causeId2())=>(assertNotNull(g, "participants array should be a non null value"), assertNotNull(f, "meetingRole should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "remote participant roles can only be updated in an ongoing call"), this.logger.info(`[${S}][updateMeetingRolesAsync][participants=${this.piiUtils.scrubMriOrOmit(g)}]`), this.participantManager.updateMeetingRolesAsync(g, f, this.links[an.LINKS.UPDATE_PARTICIPANT_ROLE], S)), this.startContentSharingAsync = (g, f, S, v, _ = causeId2())=>(assertNotNull(g, "contentIdentifier should be a non null value"), assert2(this.isCallOngoing(), "contentSharing can only be added before starting an outgoing call or to an ongoing call"), this.logger.info(`[${_}][startContentSharingAsync]`), this.telemetryHelper.recordEvent(cn.ADD_CONTENT_SHARING_MODALITY, {
                            causeId: _
                        }), this.contentSharingManager.startContentSharingAsync(g, f, S, this.links[an.LINKS.ADD_MODALITY], this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, _, v)), this.deleteContentSharingAsync = (g, f = causeId2())=>(this.logger.info(`[${f}][deleteContentSharingAsync][correlationId=${g}]`), this.telemetryHelper.recordEvent(cn.DELETE_CONTENT_SHARING, {
                            causeId: f,
                            correlationId: g
                        }), this.contentSharingManager.deleteContentSharingAsync(g, f)), this.joinContentSharingAsync = (g, f = causeId2())=>(this.logger.info(`[${f}][joinContentSharingAsync][correlationId=${g}]`), this.telemetryHelper.recordEvent(cn.JOIN_CONTENT_SHARING, {
                            causeId: f,
                            correlationId: g
                        }), this.contentSharingManager.joinContentSharingAsync(g, f)), this.updateContentSharingSessionStateAsync = (g, f, S = causeId2())=>(assertNotNull(f, "sessionState should be a non null value"), this.telemetryHelper.recordEvent(cn.UPDATE_SESSION_STATE_CONTENT_SHARING, {
                            causeId: S,
                            correlationId: g
                        }), this.logger.info(`[${S}][updateContentSharingSessionStateAsync][correlationId=${g}][sessionState=${f}]`), this.contentSharingManager.updateContentSharingSessionStateAsync(g, f, S)), this.takeContentSharingControlAsync = (g, f = causeId2())=>(this.telemetryHelper.recordEvent(cn.TAKE_CONTROL_CONTENT_SHARING, {
                            causeId: f,
                            correlationId: g
                        }), this.logger.info(`[${f}][takeContentSharingControlAsync][correlationId=${g}]`), this.contentSharingManager.takeContentSharingControlAsync(g, f)), this.updateContentSharingParticipantStateAsync = (g, f = causeId2())=>(this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANT_STATE_CONTENT_SHARING, {
                            causeId: f
                        }), this.logger.info(`[${f}][updateContentSharingParticipantStateAsync][correlationId=${g}]`), this.contentSharingManager.updateContentSharingParticipantStateAsync(g, f)), this.configureEndpointStateForStartOrJoin = (g)=>{
                        const f = {
                            endpointStateSequenceNumber: this.endpointStateSequenceNumber
                        };
                        let S = !1;
                        if (g && (g.muted && (S = !0, Object.assign(f, {
                            state: {
                                isMuted: g.muted
                            }
                        })), g.isPreheatOnly || g.additionalEndpointProperties)) {
                            const v = {};
                            S = !0, g.isPreheatOnly && (v.preheatProperties = 1), g.additionalEndpointProperties && (v.additionalEndpointProperties = g.additionalEndpointProperties), Object.assign(f, {
                                endpointProperties: v
                            });
                        }
                        if (S) return f;
                    }, this.gatherTelemetryForStartOrJoin = (g, f, S)=>{
                        const v = {
                            causeId: f
                        };
                        return g && (g.invitationType === an.INVITATION_TYPE.NUDGE && (v.withNudge = g.invitationType === an.INVITATION_TYPE.NUDGE), g.parkContext && (v.unpark = !0, v.context = g.parkContext), g.isPreheatOnly && (v.isPreheatOnly = !0), g.targetApplicationType && (v.targetApplicationType = g.targetApplicationType, this.telemetryHelper.setTargetApplicationType(g.targetApplicationType))), v;
                    }, this.startOutgoingCall = (g, f, S, v, _ = causeId2())=>{
                        if (assertNotNull(g, "mediaContent should be a non null value"), assertNotNull(g.blob, "outgoingSdp should be a non null value"), assert2(this.isCallIdleOrRosterOnly(), "a call is already in progress"), this.logger.info(`[${_}][startOutgoingCall][start] applicationType=${this.participantManager.localParticipant.applicationType}`), this.disposed) return void this.logger.warn(`[${_}][startOutgoingCall][failed][reason=Session disposed]`);
                        this.lastUsedJoinCallOptions = {
                            muted: S ? S.muted : null,
                            scenario: S ? S.scenario : null,
                            isPreheatOnly: S ? S.isPreheatOnly : null,
                            clientEndpointCapabilities: S ? S.clientEndpointCapabilities : null,
                            clientEndpointDebugContent: S ? S.clientEndpointDebugContent : null
                        }, this.originalRoleBeforePreheat = un.ROLE.CALLER, S && S.scenario && this.telemetryHelper.setScenario(S.scenario), this.logger.info(`[${_}][startOutgoingCall]options=${getPrintableObject(this.gatherTelemetryForStartOrJoin(S, _, v))}`), this.isBrokerEnabledForOutgoingCall() && this.setupBrokerChannel(), this.callUsesMixer = !(!S || !S.callUsesMixer), this.fsmState = an.SIGNALING_FSM_STATE.OUTGOING, this.meetingData = S === null || S === void 0 ? void 0 : S.meetingData, this.meetingPreferences = S === null || S === void 0 ? void 0 : S.meetingPreferences;
                        const C = {
                            newCall: !0,
                            suppressDialout: S && S.suppressDialout || !1,
                            conversationServiceUrl: this.signalingAgentConfig.conversationServiceUrl,
                            onBehalfOf: S ? S.onBehalfOf : null,
                            onBehalfOfUserDisplayName: S ? S.onBehalfOfUserDisplayName : null,
                            callQueueContext: S ? S.callQueueContext : null,
                            callToVoicemail: !!S && S.callToVoicemail,
                            voicemailResourcePath: S ? S.voicemailResourcePath : null,
                            voicemailItemId: S ? S.voicemailItemId : null,
                            endpointState: this.configureEndpointStateForStartOrJoin(S),
                            invitationType: S && S.invitationType ? S.invitationType : null,
                            participantsToNudge: S && Array.isArray(S.participantsToNudge) ? S.participantsToNudge : null,
                            routingFlags: S ? S.routingFlags : null,
                            parkContext: S ? S.parkContext : null,
                            pickupCode: S ? S.pickupCode : null,
                            scenario: S ? S.scenario : null,
                            isPreheatOnly: !!S && S.isPreheatOnly,
                            applicationType: this.participantManager.localParticipant.applicationType,
                            clientEndpointCapabilities: S ? S.clientEndpointCapabilities : 0,
                            clientEndpointDebugContent: S ? S.clientEndpointDebugContent : null,
                            invitationData: S ? S.invitationData : null,
                            conversationType: S ? this.getConversationType(S.isEmergency, S.castCall, S.isHuddleGroupCall) : null,
                            meetingData: this.meetingData,
                            meetingPreferences: this.meetingPreferences,
                            alternateId: S ? S.alternateId : null,
                            meetingRegistrationId: S ? S.meetingRegistrationId : null,
                            participantPin: S ? S.participantPin : null,
                            publishedStates: S ? S.publishedStates : null,
                            targetApplicationType: S ? S.targetApplicationType : null,
                            captchaContentJson: S ? S.captchaContentJson : null,
                            customHeaderContext: S ? S.customHeaderContext : null,
                            participationPreferences: S ? S.participationPreferences : null
                        };
                        this.isCastCall = S && S.castCall, this.isHuddleGroupCall = S && S.isHuddleGroupCall, this.onBehalfOf = C.onBehalfOf, this.onBehalfOfUserDisplayName = C.onBehalfOfUserDisplayName, this.callQueueContext = C.callQueueContext, this.startOrJoinCall(C, dn.START_CALL.name, _, g, f);
                    }, this.joinGivenConversation = (g, f, S, v, _, C = {}, E = causeId2())=>{
                        if (assertNotNull(f, "correlationId should be a non null value"), assertNotNullOrEmpty(g || this.getConversationUrl(), "conversationUrl should be a non null value"), assertNotNull(S, "mediaContent should be a non null value"), assertNotNull(S.blob, "outgoingSdp should be a non null value"), this.isPromotingToRealtime = 2 === this.callMode, assert2(this.isCallIdleOrRosterOnly() || this.isPromotingToRealtime, "a call is already in progress"), this.logger.info(`[${E}][joinGivenConversation][start][correlationId=${f}] applicationType=${this.participantManager.localParticipant.applicationType}`), this.disposed) return void this.logger.warn(`[${E}][joinGivenConversation][failed][reason=Session disposed]`);
                        const T = this.gatherTelemetryForStartOrJoin(C, E, _);
                        this.lastUsedJoinCallOptions = C, this.originalRoleBeforePreheat = un.ROLE.JOIN, this.telemetryHelper.startCallInitializationWatch(_), C && C.scenario && this.telemetryHelper.setScenario(C.scenario), this.logger.info(`[${E}][joinGivenConversation]options=${getPrintableObject(T)}`), this.isBrokerEnabledForIncomingCall() && this.setupBrokerChannel(), this.fsmState = an.SIGNALING_FSM_STATE.OUTGOING, this.updateCorrelationId(f, E), this.meetingData = C === null || C === void 0 ? void 0 : C.meetingData, this.meetingPreferences = C === null || C === void 0 ? void 0 : C.meetingPreferences;
                        const I = {
                            newCall: !1,
                            suppressDialout: !0,
                            conversationServiceUrl: g,
                            endpointState: this.configureEndpointStateForStartOrJoin(C),
                            scenario: C ? C.scenario : null,
                            isPreheatOnly: !!C && C.isPreheatOnly,
                            applicationType: this.participantManager.localParticipant.applicationType,
                            clientEndpointCapabilities: C ? C.clientEndpointCapabilities : 0,
                            clientEndpointDebugContent: C ? C.clientEndpointDebugContent : null,
                            conversationType: C ? this.getConversationType(C.isEmergency, !1) : null,
                            meetingPreferences: this.meetingPreferences,
                            meetingData: this.meetingData,
                            meetingRegistrationId: C === null || C === void 0 ? void 0 : C.meetingRegistrationId,
                            participantPin: C === null || C === void 0 ? void 0 : C.participantPin,
                            sharedLineCallInvitationContent: C === null || C === void 0 ? void 0 : C.sharedLineCallInvitationContent,
                            applyServerMute: C === null || C === void 0 ? void 0 : C.applyServerMute,
                            publishedStates: C === null || C === void 0 ? void 0 : C.publishedStates,
                            invitationData: C === null || C === void 0 ? void 0 : C.invitationData,
                            captchaContentJson: C === null || C === void 0 ? void 0 : C.captchaContentJson,
                            callQueueContext: C === null || C === void 0 ? void 0 : C.callQueueContext,
                            participationPreferences: C === null || C === void 0 ? void 0 : C.participationPreferences
                        };
                        this.isCastCall = !1, this.startOrJoinCall(I, dn.JOIN_CONVERSATION.name, E, S, v);
                    }, this.subscribeToCall = (g, f, S = 0, v, _ = causeId2())=>{
                        var _this_lastUsedJoinCallOptions;
                        assertNotNull(f, "correlationId should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.IDLE, "a call is already in progress");
                        let C = g;
                        return C || (C = this.signalingAgentConfig.conversationServiceUrl, this.logger.info(`conversationServiceUrl passed is empty. so it is set to ${C}`)), assertNotNullOrEmpty(C, "conversationUrl should be a non null value"), this.logger.info(`[${_}][subscribeToCall][start][correlationId=${f}] applicationType=${this.participantManager.localParticipant.applicationType}`), this.disposed ? (this.logger.warn(`[${_}][subscribeToCall][failed][reason=Session disposed]`), Promise.reject(an.CALL_END_CODE.CALL_DOES_NOT_EXIST)) : (this.isBrokerEnabledForIncomingCall() && this.setupBrokerChannel(), this.lastUsedJoinCallOptions = v || {}, this.lastUsedJoinCallOptions.clientEndpointCapabilities = S || ((_this_lastUsedJoinCallOptions = this.lastUsedJoinCallOptions) === null || _this_lastUsedJoinCallOptions === void 0 ? void 0 : _this_lastUsedJoinCallOptions.clientEndpointCapabilities), this.meetingData = v === null || v === void 0 ? void 0 : v.meetingData, this.meetingPreferences = v === null || v === void 0 ? void 0 : v.meetingPreferences, this.fsmState = an.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY, this.updateCorrelationId(f, _), this.http.sendPostRequest({
                            url: C,
                            requestName: dn.JOIN_CONVERSATION_WITHOUT_CALL_MODALITY.name,
                            operationType: "CallSetup",
                            payload: getPayload36(this, null, null, {
                                subscribe: !0,
                                clientEndpointCapabilities: S,
                                ...v,
                                applicationType: this.participantManager.localParticipant.applicationType,
                                endpointState: this.configureEndpointStateForStartOrJoin({
                                    additionalEndpointProperties: v === null || v === void 0 ? void 0 : v.additionalEndpointProperties
                                })
                            }, _),
                            causeId: _
                        }).then((g)=>{
                            this.disposed || (this.fsmState = an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY, this.processConversationServiceResponseHeaders(g, _), this.processConversationServiceResponse(g.response, _, 1), this.onCallStatusChanged(an.CALL_STATUS.CONNECTED_FOR_ROSTER_ONLY, _));
                        }).catch((g)=>{
                            if (g.stack && !this.isFatalException(g)) return Promise.resolve();
                            const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            return this.logger.info(`[${_}][subscribeToCall] error: ${getPrintableObject(g)} xhrError: ${getPrintableObject(f)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                resultValue: un.RESULT_VALUE.FAILURE,
                                endCode: f.telemetryEndSubCode,
                                endSubCode: f.error.subCode,
                                resultCategories: f.error.resultCategories,
                                resultDetail: f.error.phrase || "SubscribeFailure",
                                causeId: _
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, _, f.error), Promise.reject(f.error));
                        }));
                    }, this.getCallReplacementDetailsForCall = (g, f = causeId2())=>{
                        this.logger.info(`[${f}] getCallReplacementDetailsForCall callId ${g}`);
                        const S = this.signalingAgent.getSignalingSession(g);
                        return S ? S.getCallReplacementDetails(f) : {
                            replaces: ""
                        };
                    }, this.getCallReplacementDetails = (g = causeId2())=>(this.logger.info(`[${g}] getCallReplacementDetails`), {
                            replaces: this.links[an.LINKS.REPLACE]
                        }), this.transferCallAsync = (g, f, S, v, _ = causeId2())=>{
                        this.logger.info(`[${_}] transferCallAsync: transferTargetMri: ${this.piiUtils.scrubMriOrOmit(g)} transferType ${f} callTransferOptions: ${safeJsonStringify(v)}`), this.transferHelper(g, f, S, v, _);
                    }, this.redirectCall = (g, f = causeId2(), S)=>{
                        const { id: v, endpointType: _, type: C } = g.redirectOptions;
                        if (this.logger.info(`[${f}] redirectCall: targetId: ${this.piiUtils.scrubMriOrOmit(v)} targetEndpointType ${_}`), !this.isRedirectAllowed) {
                            const g = {
                                code: an.CALL_END_CODE.REJECT,
                                phrase: an.CALL_END_PHRASE.CALL_REDIRECT_IS_NOT_ALLOWED
                            };
                            return Promise.reject(g);
                        }
                        this.telemetryHelper.recordEvent(cn.CALL_REDIRECT, {
                            causeId: f
                        });
                        const E = getPayload31(this, C, v, _);
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.REDIRECT],
                            requestName: dn.SEND_CALL_REDIRECT_REQUEST.name,
                            payload: E,
                            causeId: f
                        }).then((v)=>(this.logger.info(`[${f}][redirectCall] succeeds. Leaving the call...`), this.telemetryHelper.recordEvent(cn.CALL_REDIRECT_REQUEST_SENT, {
                                causeId: f,
                                targetEndpointType: _
                            }), this.terminateEstablishedCall(S, g))).catch((g)=>{
                            const v = getErrorForXHRFailure(g);
                            this.logger.info(`[${f}][redirectCall] error: ${getPrintableObject(v)}`);
                            const C = v.error;
                            return this.telemetryHelper.recordEvent(cn.CALL_REDIRECT_REQUEST_FAILED, {
                                causeId: f,
                                transactionEnd: C,
                                endpointType: _
                            }), this.disposed || (this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                endCode: S.code,
                                endSubCode: S.subCode,
                                clientReasonSubCode: S.clientReasonSubCode,
                                clientReasonPhrase: S.clientReasonPhrase,
                                resultDetail: S.phrase || "RedirectCall",
                                resultCategories: S.resultCategories,
                                causeId: f
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, S), this.dispose(S, f)), Promise.reject(C);
                        });
                    }, this.transferHelper = (g, f, S, v, _ = causeId2())=>{
                        assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "call is not connected yet");
                        let C = !1;
                        this.logger.info(`[${_}][transferHelper][replacementDetails=${getPrintableObject(S)}] disableForwardingAndUnanswered=${v && v.disableForwardingAndUnanswered}`), this.telemetryHelper.recordEvent(cn.TRANSFER_CALL, {
                            causeId: _
                        }), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.OUTGOING_CALL_ESTABLISHMENT, ()=>{
                            this.handleCallTransferTimeout(_, C);
                        }, an.TIMEOUT_VALUES_IN_SECONDS.OUTGOING_CALL_ESTABLISHMENT_TIMEOUT), this.http.sendPostRequest({
                            url: this.links[an.LINKS.TRANSFER],
                            requestName: dn.SEND_TRANSFER_REQUEST.name,
                            payload: getPayload48(g, this, S, f, v),
                            causeId: _
                        }).then(()=>{
                            this.telemetryHelper.recordEvent(cn.WAITING_FOR_TRANSFER_ACCEPTANCE, {
                                causeId: _
                            }), C = !0;
                        }).catch((g)=>{
                            const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            this.logger.info(`[${_}][transferCallAsync] error: ${getPrintableObject(f)}`), this.disposed || (this.signalingSessionCallback.onTransferCompleted({
                                transferCompletion: {
                                    code: an.CALL_END_CODE.NETWORK_ERROR,
                                    reason: getPrintableObject(g)
                                }
                            }, _), this.telemetryHelper.recordEvent(cn.TRANSFER_REQUEST_FAILED, {
                                causeId: _,
                                ...f.error
                            }));
                        }), this.telemetryHelper.recordEvent(cn.TRANSFER_REQUEST_SENT, {
                            causeId: _,
                            transferType: f
                        });
                    }, this.consultTransferCallAsync = (g, f, S, v, _)=>{
                        let C, E;
                        if (this.logger.info(`[${v}] consultTransferCallAsync: transferTargetMri: ${this.piiUtils.scrubMriOrOmit(f)} transferTargetParticipantLegId: ${S}`), S ? (E = this.getMriByParticipantLegOfCall(g, S, v), C = this.getReplacementDetailsByParticipantLegOfCall(g, f, S, v)) : (E = f, C = this.getCallReplacementDetailsForCall(g, v)), !E || !C) {
                            const _ = C ? "target mri corresponding not found" : `unable to retrieve replacementDetails for transferTargetCallId: ${g}, transferTargetMri: ${f}, transferTargetParticipantLegId: ${S}`;
                            return this.logger.info(`[${v}] consultTransferCallAsync: error: ${_}`), void this.signalingSessionCallback.onTransferCompleted({
                                transferCompletion: {
                                    code: an.CALL_END_CODE.BAD_REQUEST,
                                    reason: _
                                }
                            }, v);
                        }
                        this.transferHelper(E, "TransferTypeStandard", C, _, v);
                    }, this.isParkByTransfer = (g, f)=>{
                        const S = [
                            "serverHold",
                            "sharedLinePark",
                            "teamPark"
                        ].indexOf(g) > -1;
                        return this.logger.info(`[${f}][isParkByTransfer][context=${g}] result = ${S}`), S;
                    }, this.parkCallAsync = (g, f = causeId2())=>{
                        if (g && "none" === g) throw {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,
                            phrase: "Unpark context is missing or none"
                        };
                        return assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "call is not connected yet"), this.logger.info(`[${f}][parkCallAsync][context=${g}]`), this.telemetryHelper.recordEvent(cn.PARK_CALL, {
                            causeId: f,
                            parkType: getParkTypeName(g)
                        }), this.isParkByTransfer(g, f) ? this.parkByTransfer(g, f) : this.park(g, f);
                    }, this.unparkAsync = (g, f = causeId2())=>{
                        if (g && "none" === g) throw {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,
                            phrase: "Unpark context is missing or none"
                        };
                        if (!this.links[an.LINKS.UNPARK]) throw {
                            code: an.CALL_END_CODE.REJECT,
                            subCode: an.CALL_END_SUB_CODE.PARK_UNPARK_TYPE_MISSING,
                            phrase: "Unpark link not available"
                        };
                        this.logger.info(`[${f}][unparkAsync][context=${g}]`), this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.UNPARK_COMPLETION, ()=>{
                            this.handleUnparkError({
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.UNPARK_COMPLETION_TIMEOUT,
                                phrase: an.CALL_END_PHRASE.UNPARK_COMPLETION_TIMEOUT
                            }, cn.WAITING_FOR_UNPARK_COMPLETION_TIMEOUT, f, g);
                        }, an.TIMEOUT_VALUES_IN_SECONDS.UNPARK_COMPLETION_TIMEOUT);
                        const S = {
                            causeId: f
                        };
                        return this.http.sendPostRequest({
                            url: this.links[an.LINKS.UNPARK],
                            requestName: dn.SEND_UNPARK_REQUEST.name,
                            payload: getPayload50(this, S),
                            causeId: f
                        }).then((g)=>(this.logger.info(`[${f}][unparkAsync] response: ${getPrintableObject(g)}`), this.telemetryHelper.recordEvent(cn.WAITING_FOR_UNPARK_COMPLETION, {
                                causeId: f
                            }), Promise.resolve())).catch((S)=>{
                            const v = getErrorForXHRFailure(S, this.signalingAgentConfig);
                            return this.logger.info(`[${f}][unparkAsync] error: ${getPrintableObject(v)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.handleUnparkError(v.error, cn.UNPARK_REQUEST_FAILED, f, g), Promise.reject(v.error));
                        });
                    }, this.handleUpdateParticipantsPropertiesCompletion = (g)=>{
                        const f = g.body, S = extractCauseIdFromMessage(g), v = this.logger.createChild(`[${S}][handleUpdateParticipantsPropertiesCompletion]`, this.correlationId), _ = {};
                        if (this.disposed) v.info("ignored. Call disposed.");
                        else {
                            if (f.operationId || v.warn("operationId is undefined."), v.info("starts"), f.participantInfos) for (const g of f.participantInfos){
                                if (!g.participant.id) {
                                    v.warn("participant id is undefined."), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED, "participant id is undefined in response, property");
                                    continue;
                                }
                                if (!g.participant.key) {
                                    v.warn("property name (key) is undefined."), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_FAILED, "property name (key) is undefined in response");
                                    continue;
                                }
                                const C = mapMriAndPropertyNameToResolveString(g.participant.id, f.operationId, g.participant.key), E = {
                                    code: g.transactionEnd.code,
                                    subCode: g.transactionEnd.subCode,
                                    phrase: g.transactionEnd.phrase,
                                    resultCategories: g.transactionEnd.resultCategories
                                };
                                v.info(`Update participants properties completed for: ${this.piiUtils.scrubMriOrOmit(g.participant.id)} with transactionEnd ${getPrintableObject(E)}`), this.telemetryHelper.recordEvent(cn.UPDATE_PARTICIPANTS_PROPERTIES_RESPONSE_COMPLETED, {
                                    causeId: S,
                                    resolveId: this.piiUtils.scrubMriOrOmit(C),
                                    property: g.participant.key,
                                    result: getPrintableObject(E)
                                }), _[C] = E, this.updateParticipantsPromises[f.operationId].delete(C);
                            }
                            this.checkAndCleanupPromisesForOperationId(f.operationId), this.signalingSessionCallback.onUpdateParticipantsPropertiesCompleted(_, f.operationId, S);
                        }
                    }, this.getCallStatus = ()=>this.currentCallStatus, this.processIncomingCallRequest = (g, f, S = causeId2())=>{
                        assertNotNull(g, "request should be a non null value"), assertNotNullOrEmpty(g.body, "request should have a valid body"), assertNotNullOrEmpty(g.body.gp || g.body.cp, "request body should have payload"), assert2(this.isCallIdleOrRosterOnly(), "a call is already in progress");
                        const v = this.logger.createChild(`[${S}][processIncomingCallRequest]`);
                        if (this.callUsesMixer = g.fromMixer, v.info("[start]"), this.disposed) return void v.warn("processIncomingCallRequest canceled");
                        this.telemetryHelper.startCallInitializationWatch(), this.isIncomingCall = !0, this.isBrokerEnabledForIncomingCall() && this.setupBrokerChannel(), this.fsmState = an.SIGNALING_FSM_STATE.INCOMING, this.participantManager.initializeForIncomingCall();
                        let _ = {};
                        try {
                            f && (_ = JSON.parse(f));
                        } catch (g) {
                            v.warn("Unable to parse endpoint metadata");
                        }
                        this.endpointMetadata = _;
                        try {
                            var _g_body;
                            let f;
                            if ((g === null || g === void 0 ? void 0 : (_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.gp) && !isStringBase64(g.body.gp)) v.info("unencoded payload, skipping decoding."), f = g.body.gp;
                            else {
                                const S = g.body.gp ? atob(g.body.gp) : decodeMessage(g.body.cp);
                                f = JSON.parse(S);
                            }
                            if (!f.callNotification) throw v.info("[failed][reason=CallNotification missing]"), new Error("CallNotification is missing");
                            v.info(`incoming call payload: ${safeJsonStringify(scrubObjectFields(f))}`), this.processIncomingCallPayload(f, S), this.incomingCallPayload = f;
                        } catch (g) {
                            this.endIncomingCallBecauseOfInvalidPayload(S);
                        }
                    }, this.sendAttachToCall = (g = causeId2())=>(this.logger.info(`[${g}][sendAttachToCall]`), this.incomingCallPayload ? (this.onCallStatusChanged(an.CALL_STATUS.IDLE, g), this.sendAttachToCallInternal(g)) : (this.endIncomingCallBecauseOfInvalidPayload(g), Promise.reject(an.CALL_END_SUB_CODE.BAD_NOTIFICATION_PAYLOAD))), this.supportsNewOfferRequest = ()=>this.signalingAgentConfig.handleNewOfferRequest, this.requestNewOffer = (g, f = causeId2())=>(this.telemetryHelper.recordEvent(cn.REQUEST_NEW_OFFER, {
                            compatibleContentTypes: g,
                            causeId: f
                        }), this.signalingAgentConfig.handleNewOfferRequest ? (assertNotNullOrEmpty(this.links[an.LINKS.NEW_OFFER], "newOffer link should be a non null value"), this.http.sendPostRequest({
                            url: this.links[an.LINKS.NEW_OFFER],
                            requestName: dn.REQUEST_NEW_OFFER.name,
                            payload: getPayload38(this, g, this.links[an.LINKS.NEW_OFFER]),
                            causeId: f
                        }).then((g)=>this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : Promise.resolve(g)).catch((g)=>{
                            const S = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            return this.logger.info(`[requestNewOffer][${f}] error ${getPrintableObject(S)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                resultValue: un.RESULT_VALUE.FAILURE,
                                endCode: S.telemetryEndSubCode,
                                endSubCode: S.error.subCode,
                                resultCategories: S.error.resultCategories,
                                resultDetail: S.error.phrase || "RequestNewOfferFailure",
                                causeId: f
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, f, S.error), this.dispose(S.error, f), Promise.reject(S.error));
                        })) : Promise.reject("Disabled")), this.endAsync = (g, f = {})=>{
                        var _this_mediaRenegotiationManager, _this_mediaRenegotiationManager1;
                        f.causeId = f.causeId || causeId2();
                        const S = f.causeId;
                        if (this.logger.info(`[${S}][endAsync][rejectionData=${g && getPrintableObject(g)}][endCallForAll=${f.forEveryone}]`), this.disposed) return this.logger.warn(`[${S}][endAsync] canceled but session already disposed`), Promise.resolve(null);
                        if (this.disposing = !0, this.telemetryHelper.recordEvent(cn.END_CALL, g ? {
                            code: g.code,
                            subCode: g.subCode,
                            causeId: S,
                            callEndClientSubCode: g.clientReasonSubCode,
                            callEndClientPhrase: g.clientReasonPhrase
                        } : {
                            causeId: S
                        }), f.preventAllCallbacks) {
                            const g = Object.keys(this.signalingSessionCallback);
                            for (const f of g)this.signalingSessionCallback[f] = vn.noop;
                        }
                        const v = ((_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.isIncomingRenegotiationInProgress()) || ((_this_mediaRenegotiationManager1 = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager1 === void 0 ? void 0 : _this_mediaRenegotiationManager1.isOutgoingRenegotiationInProgress());
                        if (this.telemetryHelper.stopCallCancelationDurationWatch(), this.fsmState === an.SIGNALING_FSM_STATE.INCOMING) return g.code === an.CALL_END_CODE.CALL_REDIRECTED ? this.redirectCall(f, S, g) : this.rejectIncomingCall(g, S);
                        if (this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING || this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY) return this.cancelOutgoingCall(g, S);
                        if (this.fsmState === an.SIGNALING_FSM_STATE.WAITING_CALL_ACCEPTANCE_ACK) return this.rejectIncomingCall(g, S);
                        if ((this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED || v) && f.forEveryone) return this.deleteConversation(g, S);
                        if (this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED || this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY || v) return this.terminateEstablishedCall(g, f);
                        {
                            this.logger.info(`[${S}][endAsync] there is no call to cancel or end or reject in current state`);
                            const f = {
                                code: isNaN(g === null || g === void 0 ? void 0 : g.code) ? an.CALL_END_CODE.NOT_FOUND : g.code,
                                subCode: isNaN(g === null || g === void 0 ? void 0 : g.subCode) ? an.CALL_END_SUB_CODE.CALL_NOT_ATTEMPTED : g.subCode,
                                phrase: (g === null || g === void 0 ? void 0 : g.phrase) || an.CALL_END_PHRASE.CALL_DOES_NOT_EXIST,
                                resultCategories: (g === null || g === void 0 ? void 0 : g.resultCategories) || [
                                    Qi.ExpectedError
                                ],
                                clientReasonSubCode: g === null || g === void 0 ? void 0 : g.clientReasonSubCode,
                                clientReasonPhrase: g === null || g === void 0 ? void 0 : g.clientReasonPhrase
                            };
                            return this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                resultDetail: f.phrase || "CallDoesNotExist",
                                endCode: f.code,
                                endSubCode: f.subCode,
                                resultCategories: f.resultCategories,
                                causeId: S,
                                clientReasonSubCode: f.clientReasonSubCode,
                                clientReasonPhrase: f.clientReasonPhrase
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, S, f), this.dispose(f, S), Promise.resolve(null);
                        }
                    }, this.handleIncomingMsgAsync = (g, f = an.INCOMING_MESSAGE_ORIGIN.TROUTER)=>{
                        assertNotNull(g, "incoming message should be a non null value");
                        const S = extractMessageIdFromMessage(g), v = defer(), _ = g.body, C = g.url, E = {
                            ...g,
                            origin: f
                        }, T = extractCauseIdFromMessage(E);
                        if (this.logger.info(`[${T}][handleIncomingMsgAsync][url=${C}][messageId=${S}]`), !_) return this.logger.info(`[${T}][handleIncomingMsgAsync][failed][reason=received message with no body]`), this.telemetryHelper.recordEvent(cn.MESSAGE_MISSING_BODY, {
                            origin: f,
                            messageId: S,
                            causeId: T
                        }), v.reject(new Error("received message with no body")), v.promise;
                        if (this.disposed) return this.logger.info(`[${T}][handleIncomingMsgAsync][failed][reason=call is disposed]`), v.reject(this.getCallNotFoundTransactionEnd()), v.promise;
                        if (this.isDuplicatedIncomingMessage(E)) return this.logger.info(`[${T}][handleIncomingMsgAsync][failed][reason=duplicate]`), this.telemetryHelper.recordEvent(cn.DUPLICATE_MESSAGE_IGNORED, {
                            origin: f,
                            messageId: S,
                            causeId: T
                        }), v.resolve(new Error("Message was already handled")), v.promise;
                        this.checkCorrelationIdChange(g, T);
                        const I = {
                            [rn.CALL_NOTIFICATION]: (g)=>{
                                this.handleCallNotification(g);
                            },
                            [rn.MEDIA_ANSWER]: (g)=>{
                                this.handleMediaAnswer(g);
                            },
                            [rn.MEDIA_ACKNOWLEDGEMENT]: (g)=>{
                                this.handleMediaAcknowledgement(g);
                            },
                            [rn.CALL_ACCEPTANCE]: (g)=>{
                                this.handleCallAcceptance(g);
                            },
                            [rn.CALL_END]: (g)=>{
                                this.handleCallEnd(g, !1);
                            },
                            [rn.CALL_PROGRESS]: (g)=>{
                                this.handleCallProgress(g);
                            },
                            [rn.CALL_ACCEPTANCE_ACKNOWLEDGEMENT]: (g)=>{
                                this.handleCallAcceptanceAck(g);
                            },
                            [rn.MEDIA_NEGOTIATION]: (g)=>{
                                var _this_mediaRenegotiationManager;
                                (_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.handleMediaNegotiationOffer(g);
                            },
                            [rn.MEDIA_NEGOTIATION_FAILURE]: (g)=>{
                                var _this_mediaRenegotiationManager;
                                (_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.handleMediaNegotiationFailure(g);
                            },
                            [rn.BALANCE_UPDATE]: (g)=>{
                                this.handlePSTNBalanceUpdate(g);
                            },
                            [rn.RETARGET_COMPLETED]: (g)=>{
                                var _this_mediaRenegotiationManager;
                                (_this_mediaRenegotiationManager = this.mediaRenegotiationManager) === null || _this_mediaRenegotiationManager === void 0 ? void 0 : _this_mediaRenegotiationManager.handleRetargetCompleted(g);
                            },
                            [rn.CALL_TRANSFER]: (g)=>{
                                this.handleTransferRequested(g);
                            },
                            [rn.TRANSFER_COMPLETION]: (g)=>{
                                this.handleTransferCompletion(g);
                            },
                            [rn.TRANSFER_ACCEPTANCE]: (g)=>{
                                this.handleTransferAcceptance(g);
                            },
                            [rn.PARK_COMPLETION]: (g)=>{
                                this.handleParkCompletion(g);
                            },
                            [rn.UNPARK_COMPLETION]: (g)=>{
                                this.handleUnparkCompletion(g);
                            },
                            [rn.UPDATE_MEETING_LIVE_STATE_RESPONSE]: (g)=>{
                                this.handleUpdateMeetingLiveStateCompletion(g);
                            },
                            [rn.UPDATE_MEETING_GROUPS_RESPONSE]: (g)=>{
                                this.handleUpdateMeetingGroupsCompletion(g);
                            },
                            [rn.SET_MEETING_LAYOUT_RESPONSE]: (g)=>{
                                this.handleSetMeetingLayoutCompletion(g);
                            },
                            [rn.UPDATE_MEETING_STATES_RESPONSE]: (g)=>{
                                this.handleUpdateMeetingStatesCompletion(g);
                            },
                            [rn.MONITOR_COMPLETION]: (g)=>{
                                this.handleUpdateMonitorSessionCompletion(g);
                            }
                        }, b = {
                            [nn.CONTROL_VIDEO_STREAMING]: (g)=>{
                                this.webRtcSignalingManager.handleControlVideoStreaming(g);
                            },
                            [nn.DOMINANT_SPEAKER_INFO]: (g)=>{
                                this.webRtcSignalingManager.handleDominantSpeakerInfo(g);
                            },
                            [nn.CSRC_INFO]: (g)=>{
                                this.webRtcSignalingManager.handleCsrcInfo(g);
                            },
                            [nn.CONV_ROSTER_UPDATE]: (g)=>{
                                this.handleRosterUpdate(g, !1);
                            },
                            [nn.NEW_MEDIA_OFFER]: (g)=>{
                                this.handleNewMediaOffer(g);
                            },
                            [nn.CONV_ADD_PARTICIPANT_SUCCESS]: (g)=>{
                                this.participantManager.handleAddParticipantSuccess(g);
                            },
                            [nn.CONV_ADD_PARTICIPANT_FAILURE]: (g)=>{
                                this.participantManager.handleAddParticipantFailure(g);
                            },
                            [nn.CONV_ADMIT_PARTICIPANT_SUCCESS]: (g)=>{
                                this.participantManager.handleAdmitParticipantSuccess(g);
                            },
                            [nn.CONV_ADMIT_PARTICIPANT_FAILURE]: (g)=>{
                                this.participantManager.handleAdmitParticipantFailure(g);
                            },
                            [nn.CONV_ADMIT_ALL_STATUS]: (g)=>{
                                this.handleAdmitAllStatus(g);
                            },
                            [nn.CONV_REMOVE_PARTICIPANT_SUCCESS]: (g)=>{
                                this.participantManager.handleRemoveParticipantSuccess(g);
                            },
                            [nn.CONV_REMOVE_PARTICIPANT_FAILURE]: (g)=>{
                                this.participantManager.handleRemoveParticipantFailure(g);
                            },
                            [nn.CONV_CONFIRM_UNMUTE]: (g)=>{
                                this.participantManager.handleUnmuteConfirmRequest(g);
                            },
                            [nn.CONV_UPDATE]: (g)=>{
                                this.handleConversationUpdate(g);
                            },
                            [nn.CONV_LOCAL_PARTICIPANT_UPDATE]: (g)=>{
                                this.handleLocalParticipantUpdate(g);
                            },
                            [nn.CONV_ADD_MODALITY_SUCCESS]: (g)=>{
                                this.handleAddModalitySuccess(g);
                            },
                            [nn.CONV_ADD_MODALITY_FAILURE]: (g)=>{
                                this.handleAddModalityFailure(g);
                            },
                            [nn.CONV_BROADCAST_UPDATE]: (g)=>{
                                this.broadcastSession.handleBroadcastStateChanged(g);
                            },
                            [nn.CONV_CONTENT_SHARING_UPDATE]: (g)=>{
                                var _this_contentSharingManager;
                                (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.handleContentSharingUpdate(g);
                            },
                            [nn.CONV_CONTENT_SHARING_END]: (g)=>{
                                var _this_contentSharingManager;
                                (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.handleContentSharingEnd(g);
                            },
                            [nn.CONV_END]: (g)=>{
                                this.handleCallEnd(g, !1);
                            },
                            [nn.CONV_END_JOIN]: (g)=>{
                                this.handleCallEnd(g, !1);
                            },
                            [nn.CONV_END_SUBSCRIBE]: (g)=>{
                                this.handleCallEnd(g, !0);
                            },
                            [nn.UPDATE_PARTICIPANT_INTERPRETATION_STATE_STATUS]: (g)=>{
                                this.participantManager.handleUpdateParticipantInterpretationStateCompletion(g);
                            },
                            [nn.UPDATE_PARTICIPANT_PROPERTIES_STATUS]: (g)=>{
                                this.handleUpdateParticipantsPropertiesCompletion(g);
                            },
                            [nn.JOIN_MEETING_GROUP_STATUS]: (g)=>{
                                this.handleJoinMeetingGroupCompletion(g);
                            },
                            [nn.LEAVE_MEETING_GROUP_STATUS]: (g)=>{
                                this.handleLeaveMeetingGroupCompletion(g);
                            },
                            [nn.RECEIVE_MESSAGE]: (g)=>{
                                this.handleReceiveMessage(g);
                            },
                            [nn.SEND_MESSAGE_STATUS]: (g)=>{
                                this.proxiedMessageNotificationManager.handleProxiedMessageNotification(g);
                            },
                            [nn.DISABLE_PREHEAT_ASYNC_STATUS]: (g)=>{
                                this.handleDisablePreheatCompletion(g);
                            },
                            [nn.MUTE_UNMUTE_ASYNC]: (g)=>{
                                this.participantManager.handleMuteUnmuteAsyncResponse(g);
                            }
                        };
                        try {
                            const g = Object.keys(I).filter((g)=>_.hasOwnProperty(g))[0], f = this.signalingAgentConfig.enableSplitConversationEndUrl && (stringEndsWith(E.url, nn.CONV_END_JOIN) || stringEndsWith(E.url, nn.CONV_END_SUBSCRIBE)) ? Object.keys(b).filter((g)=>E.url && stringEndsWith(E.url, g))[1] : Object.keys(b).filter((g)=>E.url && stringEndsWith(E.url, g))[0];
                            g ? I[g](E) : f ? b[f](E) : (this.telemetryHelper.recordEvent(cn.UNKNOWN_MESSAGE_TYPE, {
                                messageId: S
                            }), this.logger.info(`[${T}][handleIncomingMsgAsync][failed][reason=received unknown message]`)), v.resolve(!0);
                        } catch (g) {
                            this.telemetryHelper.recordEvent(cn.FAILED_TO_HANDLE_MESSAGE, {
                                messageId: S,
                                error: getPrintableObject(g)
                            }), this.logger.info(`[${T}][handleIncomingMsgAsync][failed][reason=${g.message}]`), v.reject(new Error(g.message));
                        }
                        return v.promise;
                    }, this.canHandleIncomingMsgSync = (g)=>{
                        if (this.signalingAgentConfig.supportsSynchronousTrouterResponse) {
                            const f = g.body;
                            return Boolean(f.callAcceptance);
                        }
                        return !1;
                    }, this.handleIncomingMsgSync = (g)=>{
                        const f = extractMessageIdFromMessage(g), S = g.body, v = g.url, _ = an.INCOMING_MESSAGE_ORIGIN.TROUTER, C = {
                            ...g,
                            origin: _
                        }, E = extractCauseIdFromMessage(C);
                        this.logger.info(`[${E}][handleIncomingMsgSync][url=${v}][messageId=${f}]`);
                        const T = C.headers;
                        let I = an.HTTP_STATUS_CODES.OK, b = "";
                        const A = new on;
                        if (isDuplicateMessage(T, this.incomingTrouterMessagesSeenSoFar)) {
                            this.logger.info(`[${E}][handleIncomingMsgSync][failed][reason=duplicate]`);
                            const g = getMessageResultFromCache(T, this.incomingMessageSyncResponseCache);
                            if (g) return this.logger.info(`[${E}][handleIncomingMsgSync][cachedResponse]`), g;
                            this.telemetryHelper.recordEvent(cn.DUPLICATE_MESSAGE_IGNORED, {
                                origin: _,
                                messageId: f,
                                causeId: E
                            }), this.logger.info(`[${E}][handleIncomingMsgSync][failed][reason=cachedResponseNotFound]`), I = an.HTTP_STATUS_CODES.BAD_REQUEST;
                        } else if (S) {
                            if (S.callAcceptance) try {
                                b = safeJsonStringify(this.handleCallAcceptanceSync(C));
                            } catch (g) {
                                this.telemetryHelper.recordEvent(cn.FAILED_TO_HANDLE_MESSAGE, {
                                    messageId: f,
                                    origin: _,
                                    causeId: E,
                                    error: getPrintableObject(g)
                                }), this.logger.info(`[${E}][handleIncomingMsgSync][failed][reason=${g === null || g === void 0 ? void 0 : g.message}]`), I = an.HTTP_STATUS_CODES.BAD_REQUEST;
                            }
                        } else this.logger.info(`[${E}][handleIncomingMsgSync][failed][reason=received message with no body]`), this.telemetryHelper.recordEvent(cn.MESSAGE_MISSING_BODY, {
                            origin: _,
                            messageId: f,
                            causeId: E
                        }), I = an.HTTP_STATUS_CODES.BAD_REQUEST;
                        T && (T.get(an.HEADERS.CORRELATION_ID) && A.set(an.HEADERS.CORRELATION_ID, T.get(an.HEADERS.CORRELATION_ID)), T.get(an.HEADERS.MESSAGE_ID) && A.set(an.HEADERS.MESSAGE_ID, T.get(an.HEADERS.MESSAGE_ID)));
                        const R = {
                            resultCode: I,
                            responseBody: b,
                            responseHeaders: A.getAll()
                        };
                        return cacheMessageResult(T, this.incomingMessageSyncResponseCache, R), this.logger.info(`[${E}][handleIncomingMsgSync][success][resultCode=${I}]`), R;
                    }, this.acceptRenegotiationAsync = (g, f, S = causeId2())=>(assertNotNull(g.blob, "finalSdp should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"), this.logger.info(`[${S}][acceptRenegotiationAsync][mediaTypes=${f}]`), this.mediaRenegotiationManager.acceptRenegotiationAsync(g, f, S)), this.setProvisionalAnswerAsync = (g, f = causeId2())=>{
                        assertNotNull(g.blob, "sdp should be a non null value"), this.telemetryHelper.recordEvent(cn.SET_PROVISIONAL_ANSWER, {
                            causeId: f
                        });
                        const S = defer();
                        return this.fsmState !== an.SIGNALING_FSM_STATE.INCOMING ? (this.logger.info(`[setProvisionalAnswerAsync][${f}] there is no incoming call to set provisional answer on.`), S.reject(new Error("there is no incoming call to set provisional answer on.")), S.promise) : (this.http.sendPostRequest({
                            url: this.links[an.LINKS.MEDIA_ANSWER],
                            requestName: dn.SEND_MEDIA_ANSWER.name,
                            payload: getPayload57(this, g),
                            causeId: f
                        }).then((g)=>{
                            this.disposed || this.onCallStatusChanged(an.CALL_STATUS.CONNECTING, f), S.resolve(null), this.disposed || (this.telemetryHelper.recordEvent(cn.HANDLE_MEDIA_ACKNOWLEDGEMENT, {
                                causeId: f
                            }), this.telemetryHelper.setTimeToRingDuration(), this.onCallStatusChanged(an.CALL_STATUS.RINGING, f), this.signalingSessionCallback.onMediaAcknowledgementSuccess(!1, f));
                        }).catch((g)=>{
                            const v = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            this.logger.info(`[setProvisionalAnswerAsync][${f}] error: ${getPrintableObject(v)}`), this.disposed ? S.reject(this.getCallNotFoundTransactionEnd()) : (this.telemetryHelper.recordEvent(cn.SET_PROVISIONAL_ANSWER_FAILED, {
                                causeId: f
                            }), S.reject(v.error));
                        }), S.promise);
                    }, this.startRenegotiationAsync = (g, f, S = causeId2())=>(assertNotNull(g, "mediaContent should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"), this.logger.info(`[${S}][startRenegotiationAsync]`), this.mediaRenegotiationManager.startRenegotiationAsync(g, this.links[an.LINKS.MEDIA_RENEGOTIATION], f, S)), this.updateMediaDescriptionsAsync = (g = causeId2(), f)=>{
                        assertNotNull(f, "mediaDescriptions should be a non null value"), assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "updateMediaDescriptions operations are only allowed when the call is connected");
                        const S = this.links[an.LINKS.UPDATE_MEDIA_DESCRIPTIONS];
                        return assertNotNull(S, "updateMediaDescriptionsUrl should be a non null value"), this.telemetryHelper.recordEvent(cn.UPDATE_MEDIA_DESCRIPTIONS, {
                            causeId: g
                        }), this.http.sendPostRequest({
                            url: S,
                            requestName: dn.UPDATE_MEDIA_DESCRIPTIONS.name,
                            payload: getPayload58(this, f),
                            causeId: g
                        }).catch((f)=>{
                            const S = getErrorForXHRFailure(f, this.signalingAgentConfig);
                            return this.logger.info(`[updateMediaDescriptionsAsync][${g}] error: ${getPrintableObject(S)}`), this.disposed ? Promise.reject(this.getCallNotFoundTransactionEnd()) : (this.telemetryHelper.recordEvent(cn.UPDATE_MEDIA_DESCRIPTIONS_FAILED, {
                                causeId: g
                            }), Promise.reject(S.error));
                        });
                    }, this.acceptAsync = (g, f, S, v = causeId2())=>{
                        assertNotNull(g, "mediaContent should be a non null value"), assertNotNull(g.blob, "outgoingSdp should be a non null value"), this.logger.info(`[${v}][acceptAsync][mediaTypes=${f}]`), this.telemetryHelper.recordEvent(cn.ACCEPT_CALL, {
                            causeId: v
                        }), this.telemetryHelper.setAnsweredModalities(g.blob);
                        const _ = defer();
                        return this.fsmState !== an.SIGNALING_FSM_STATE.INCOMING ? (this.logger.warn("acceptAsync, there is no incoming call to accept"), _.reject(new Error("there is no incoming call to accept")), _.promise) : (this.fsmState = an.SIGNALING_FSM_STATE.WAITING_CALL_ACCEPTANCE_ACK, this.http.sendPostRequest({
                            url: this.links[an.LINKS.ACCEPT],
                            requestName: dn.SEND_ACCEPTANCE.name,
                            payload: getPayload29(this, g, f, S),
                            causeId: v
                        }).then((g)=>{
                            this.disposed || (this.currentCallStatus === an.CALL_STATUS.IDLE && (this.telemetryHelper.setTimeToRingDuration(), this.telemetryHelper.recordEvent(cn.ACCEPTED_BEFORE_RINGING, {
                                causeId: v
                            }), this.onCallStatusChanged(an.CALL_STATUS.CONNECTING, v)), g.response.callAcceptanceAcknowledgement && (this.logger.info("acceptAsync, handling inlined callAcceptanceAcknowledgement"), this.internalHandleCallAcceptanceAck(g.response, v))), _.resolve(null);
                        }).catch((g)=>{
                            const f = getErrorForXHRFailure(g, this.signalingAgentConfig);
                            this.logger.info(`[acceptAsync][${v}] error: ${getPrintableObject(f)}`), this.disposed ? _.reject(this.getCallNotFoundTransactionEnd()) : (this.fsmState = an.SIGNALING_FSM_STATE.INCOMING, this.telemetryHelper.recordEvent(cn.ACCEPT_CALL_FAILED, {
                                causeId: v,
                                xhrError: f
                            }), _.reject(f.error));
                        }), _.promise);
                    }, this.rejectRenegotiationAsync = (g, f = causeId2())=>(assert2(this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED, "Renegotiation operations are only allowed when the call is connected and no disconnect operation is in flight"), this.logger.info(`[${f}][rejectRenegotiationAsync][rejectionData=${g}]`), this.mediaRenegotiationManager.rejectRenegotiationAsync(g, f)), this.saveMediaControllerLinksIfAny = (g)=>{
                        g.links && (this.links[an.LINKS.CONTROL_VIDEO_STREAMING] = g.links.controlVideoStreaming || this.links[an.LINKS.CONTROL_VIDEO_STREAMING], this.links[an.LINKS.APPLY_CHANNEL_PARAMETERS] = g.links.applyChannelParameters || this.links[an.LINKS.APPLY_CHANNEL_PARAMETERS]);
                    }, this.getInitialMediaOfferFromIncomingCallPayload = (g = causeId2())=>{
                        var _this_incomingCallPayload_callNotification, _this_incomingCallPayload;
                        if (!this.signalingAgentConfig.handleMediaOfferFromPushNotification) return null;
                        const f = ((_this_incomingCallPayload = this.incomingCallPayload) === null || _this_incomingCallPayload === void 0 ? void 0 : (_this_incomingCallPayload_callNotification = _this_incomingCallPayload.callNotification) === null || _this_incomingCallPayload_callNotification === void 0 ? void 0 : _this_incomingCallPayload_callNotification.mediaContent) ? this.incomingCallPayload.callNotification.mediaContent : null;
                        return this.telemetryHelper.setIsSdpInCallNotification(!!f), f;
                    }, this.updateCorrelationId = (g, f = causeId2())=>{
                        if (this.logger.info(`[${f}][updateCorrelationId][old=${this.correlationId}][new=${g}]`), this.correlationId !== g && !this.disposed) {
                            const S = this.correlationId;
                            this.correlationId = g, this.telemetryHelper && this.telemetryHelper.recordEvent && this.telemetryHelper.recordEvent(cn.CORRELATION_ID_UPDATED, {
                                newId: this.correlationId,
                                oldId: S,
                                causeId: f
                            }), this.signalingSessionCallback && this.signalingSessionCallback.onCorrelationIdUpdated && this.signalingSessionCallback.onCorrelationIdUpdated(this.correlationId, f);
                        }
                    }, this.endIncomingCallBecauseOfInvalidPayload = (g)=>{
                        this.logger.info(`[${g}][endIncomingCallBecauseOfInvalidPayload]`), this.fsmState = an.SIGNALING_FSM_STATE.IDLE;
                        const f = {
                            code: an.CALL_END_CODE.BAD_REQUEST,
                            subCode: an.CALL_END_SUB_CODE.BAD_NOTIFICATION_PAYLOAD,
                            phrase: an.CALL_END_PHRASE.BAD_NOTIFICATION_PAYLOAD,
                            resultCategories: [
                                Qi.UnexpectedServerError
                            ]
                        };
                        this.telemetryHelper.setTerminatingData({
                            terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                            resultValue: un.RESULT_VALUE.FAILURE,
                            endCode: f.code,
                            endSubCode: f.subCode,
                            resultDetail: f.phrase || "EndIncomingCall",
                            resultCategories: f.resultCategories,
                            causeId: g
                        }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, g, f), this.dispose(f, g);
                    }, this.isDuplicatedIncomingMessage = (g)=>g.origin === an.INCOMING_MESSAGE_ORIGIN.BROKER && isDuplicateMessage(g.headers, this.incomingBrokerMessagesSeenSoFar) || g.origin === an.INCOMING_MESSAGE_ORIGIN.TROUTER && isDuplicateMessage(g.headers, this.incomingTrouterMessagesSeenSoFar), this.getEndpointState = ()=>{
                        let g;
                        return g = this.startOrJoinConvResponseReceived ? {
                            ...this.latestEndpointState
                        } : {
                            ...this.requestedEndpointStateWhileConnecting
                        }, g;
                    }, this.setMultiParty = (g, f)=>{
                        const S = !!g;
                        this.multiParty !== S && (this.telemetryHelper.recordEvent(cn.SET_MULTIPARTY, {
                            isMultiparty: S,
                            causeId: f
                        }), this.multiParty = S);
                    }, this.setupTrouterChannel = ()=>{
                        this.logger.info(`Broker config: outgoing=${this.signalingAgentConfig.brokerEnabledOutgoing ? "enabled" : "disabled"}incoming=${this.signalingAgentConfig.brokerEnabledIncoming ? "enabled" : "disabled"}batching=${this.signalingAgentConfig.brokerRequestBatching ? "enabled" : "disabled"}exclusive=${this.signalingAgentConfig.brokerExclusively ? "enabled" : "disabled"}`);
                        const setTrouterUrl = (g)=>{
                            g && "string" == typeof g && g.trim() && (this.baseMessagingChannelUrl = this.previousTrouterUrl = this.currentTrouterUrl = g.trim(), this.telemetryHelper.addTrouterChannel());
                        };
                        this.brokerExclusiveEnabled() || (this.signalingAgentConfig.trouterServiceProvider ? (2 === this.signalingAgentConfig.trouterServiceProvider.state() && this.signalingAgentConfig.trouterServiceProvider.getTrouterUrlAsync().then(setTrouterUrl), this.signalingAgentConfig.trouterServiceProvider.onStateChanged(this.onTrouterStateChanged)) : (setTrouterUrl(this.signalingAgentConfig.trouterUrlGetter.trouterUrl()), this.signalingAgentConfig.trouterUrlGetter.trouterUrl.changed(this.onTrouterUrlChanged)));
                    }, this.isTrouterDisconnected = ()=>{
                        try {
                            return 3 === this.signalingAgentConfig.trouterServiceProvider.state();
                        } catch (g) {
                            return !1;
                        }
                    }, this.forceTrouterConnectionCheck = ()=>{
                        try {
                            return void this.signalingAgentConfig.trouterServiceProvider.checkConnection(!1);
                        } catch (g) {
                            return;
                        }
                    }, this.navigatorOnlineCallback = ()=>{
                        this.disposed || (this.reportConnectivityStatus(), this.isTrouterDisconnected() && this.signalingAgentConfig.forceTrouterReconnectOnNetworkOnline && this.forceTrouterConnectionCheck());
                    }, this.navigatorOfflineCallback = ()=>{
                        this.reportConnectivityStatus();
                    }, this.reportConnectivityStatus = ()=>{
                        if (!this.disposed) {
                            const g = isTrouterAndNavigatorConnected(this.signalingAgentConfig.trouterServiceProvider);
                            this.logger.info(`[Connectivity] status=${g}`), this.telemetryHelper.recordEvent(cn.CONNECTIVITY_CHANGED, {
                                status: g
                            });
                        }
                    }, this.onTrouterStateChanged = (g, f)=>{
                        const S = causeId2();
                        this.logger.info(`[${S}][onTrouterStateChanged][state=${g}]`), this.disposed ? this.logger.info("onTrouterStateChanged ignored") : (this.reportConnectivityStatus(), 2 === g && (this.telemetryHelper.addTrouterChannel(), this.updateLinksToTrouter(cn.TROUTER_STATE_CHANGED, S)));
                    }, this.setupConnectionCheck = ()=>{
                        try {
                            navigator && navigator.onLine && window && window.addEventListener && (window.addEventListener("online", this.navigatorOnlineCallback), window.addEventListener("offline", this.navigatorOfflineCallback));
                        } catch (g) {
                            return;
                        }
                    }, this.tearDownConnectionCheck = ()=>{
                        try {
                            navigator && navigator.onLine && window && window.removeEventListener && (window.removeEventListener("online", this.navigatorOnlineCallback), window.removeEventListener("offline", this.navigatorOfflineCallback));
                        } catch (g) {
                            return;
                        }
                    }, this.getTrouterUrlAsync = ()=>this.signalingAgentConfig.trouterServiceProvider ? this.signalingAgentConfig.trouterServiceProvider.getTrouterUrlAsync() : this.signalingAgentConfig.trouterUrlGetter.getTrouterUrlAsync(), this.brokerExclusiveEnabled = ()=>this.signalingAgentConfig.brokerEnabledOutgoing && this.signalingAgentConfig.brokerEnabledIncoming && this.signalingAgentConfig.brokerExclusively, this.isBrokerEnabledForOutgoingCall = ()=>this.signalingAgentConfig.brokerEnabledOutgoing, this.isBrokerEnabledForIncomingCall = ()=>this.signalingAgentConfig.brokerEnabledIncoming, this.setupBrokerChannel = ()=>{
                        this.brokerService || (this.logger.info("setupBrokerChannel, Enable broker"), this.brokerService = new In(this), this.brokerService.onBrokerMessage((g)=>{
                            this.logger.info("setupBrokerChannel, message from broker", getPIISafeMessage(g)), this.handleIncomingMsgAsync(g, an.INCOMING_MESSAGE_ORIGIN.BROKER).catch((g)=>{
                                this.telemetryHelper.recordEvent(cn.FAILED_TO_HANDLE_BROKER_MESSAGE), this.logger.info("setupBrokerChannel, Failed to handle message from broker", g);
                            });
                        }), this.baseMessagingChannelUrl || (this.telemetryHelper.addBrokerChannel(), this.baseMessagingChannelUrl = this.brokerService.baseUrl));
                    }, this.onTrouterUrlChanged = ()=>{
                        const g = causeId2();
                        this.logger.info(`[${g}][onTrouterUrlChanged]`), this.disposed ? this.logger.info("onTrouterUrlChanged ignored") : this.getTrouterUrlAsync().then((f)=>{
                            this.telemetryHelper.recordEvent(cn.TROUTER_URL_CHANGED, {
                                url: f
                            }), this.telemetryHelper.addTrouterChannel(), this.updateLinksToTrouter(cn.TROUTER_URL_CHANGED, g);
                        }).catch((g)=>{
                            this.logger.info(`Failed to update links to trouter: ${g}`);
                        });
                    }, this.updateLinksToTrouter = (g, f)=>{
                        this.logger.info(`[${f}][updateLinksToTrouter][tag=${g}]`), this.ensureLatestTrouterUrl(g).then(()=>{
                            var _this_contentSharingManager;
                            this.previousTrouterUrl !== this.currentTrouterUrl ? (this.previousTrouterUrl = this.currentTrouterUrl, this.updateConversationLinks(), this.updateKeepAliveUrl(), (_this_contentSharingManager = this.contentSharingManager) === null || _this_contentSharingManager === void 0 ? void 0 : _this_contentSharingManager.updateContentSharingNotificationLinksAsync(f), this.broadcastSession && this.broadcastSession.updateBroadcastCallbackUrl(f)) : this.logger.info(`[${f}][updateLinksToTrouter]skip updating links, url did not change`);
                        }).catch((g)=>{
                            this.disposed || this.telemetryHelper.recordEvent(cn.TROUTER_URL_UPDATE_FAILED, {
                                causeId: f
                            }), this.logger.info(`[${f}][updateLinksToTrouter][failed][reason=${getPrintableObject(g)}]`);
                        });
                    }, this.updateLinks = (g, f)=>{
                        this.ensureLatestTrouterUrl(cn.TROUTER_URL_CHANGED).then(()=>{
                            g(f);
                        }).catch((g)=>{
                            this.disposed || this.telemetryHelper.recordEvent(cn.TROUTER_URL_UPDATE_FAILED, {
                                causeId: f
                            }), this.logger.warn("Failed to update links");
                        });
                    }, this.startCallPreheatTimer = (g)=>{
                        this.timeoutManager.startTimer(an.TIMEOUT_OPERATIONS.MAX_PREAHEATED_TIMEOUT, ()=>{
                            this.handleCallEstablishmentTimeout(g, an.CALL_END_SUB_CODE.PREHEATED_CALL_TIMEDOUT, "Preheat timed out!"), this.terminateEstablishedCall({
                                code: an.CALL_END_CODE.TIMEOUT,
                                subCode: an.CALL_END_SUB_CODE.PREHEATED_CALL_TIMEDOUT,
                                phrase: "Preheat timed out!"
                            }, {
                                forEveryone: !1,
                                causeId: g
                            });
                        }, an.TIMEOUT_VALUES_IN_SECONDS.MAX_PREAHEATED_TIMEOUT);
                    }, this.stopCallPreheatTimer = ()=>{
                        this.timeoutManager.stopTimer(an.TIMEOUT_OPERATIONS.MAX_PREAHEATED_TIMEOUT);
                    }, this.updateKeepAliveUrl = ()=>{
                        this.logger.info("updateKeepAliveUrl"), this.links.hasOwnProperty(an.LINKS.KEEPALIVE) ? (this.linkUpdateRequested.keepAliveLinks = !1, this.logger.info("updateKeepAliveUrl, sending request"), this.sendToKeepAliveUrl(getPayload41(this))) : this.linkUpdateRequested.keepAliveLinks = !0;
                    }, this.updateConversationLinks = (g = causeId2())=>{
                        this.logger.info(`[${g}][updateConversationLinks]`), this.telemetryHelper.recordEvent(cn.UPDATE_CONVERSATION_LINKS, {
                            causeId: g
                        }), this.links.hasOwnProperty(an.LINKS.NOTIFICATION_LINKS) ? (this.linkUpdateRequested.conversationLinks = !1, this.logger.info("updateConversationLinks, sending request"), this.sendToUpdateConversationLinks(!0)) : this.linkUpdateRequested.conversationLinks = !0;
                    }, this.sendAttachToCallInternal = (g = causeId2())=>{
                        this.telemetryHelper.recordEvent(cn.SEND_ATTACH, {
                            causeId: g
                        }), this.logger.info(`[${g}][sendAttachToCallInternal]`);
                        const f = new on;
                        return this.signalingAgentConfig.sendProgressFromCC && f.set(an.HEADERS.CACHE_SKYPE_TOKEN, "1"), this.http.sendPostRequest({
                            url: this.incomingCallPayload.callNotification.links.attach,
                            customHeaders: f,
                            requestName: dn.SEND_CALL_ATTACH.name,
                            payload: getPayload27(this, this.incomingCallPayload.conversationInvitation.conversationController, !this.getInitialMediaOfferFromIncomingCallPayload()),
                            causeId: g
                        }).then((f)=>{
                            if (!this.disposed) {
                                this.processAttachResponse(this.incomingCallPayload, f, g);
                                const S = f.response.additionalActionResponses;
                                S && S.length > 0 && this.processConversationServiceResponse(S[0].output, g, 0), this.onCallStatusChanged(an.CALL_STATUS.RINGING, g), this.telemetryHelper.setTimeToRingDuration(), this.handleBrokerSubscription(f.response.callInvitation, g);
                            }
                        }).catch((f)=>{
                            const S = getErrorForXHRFailure(f, this.signalingAgentConfig);
                            this.logger.info(`[${g}][sendAttachToCallInternal] error: ${getPrintableObject(f)} xhrError: ${getPrintableObject(S)}`), this.disposed || (this.fsmState = an.SIGNALING_FSM_STATE.IDLE, this.telemetryHelper.setTerminatingData({
                                terminatingEnd: un.CALL_TERMINATING_END.LOCAL,
                                resultValue: un.RESULT_VALUE.FAILURE,
                                endCode: S.telemetryEndSubCode,
                                endSubCode: S.error.subCode,
                                resultCategories: S.error.resultCategories,
                                resultDetail: S.error.phrase || "SendAttachtoCallFailure",
                                causeId: g
                            }), this.onCallStatusChanged(an.CALL_STATUS.LOCAL_TERMINATED, g, S.error), this.dispose(S.error, g));
                        });
                    }, this._processCallAcceptance = (g, f)=>{
                        if (this.logger.info(`[${f}][_processCallAcceptance]`), this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING) {
                            this.processCallAcceptance(g.body, f), this.telemetryHelper.setTimeToRingDuration();
                            try {
                                this.multiParty || this.callUsesMixer || this.participantManager.handleRosterUpdate(this.getFakeRoster(g.body), !0, f);
                            } catch (S) {
                                const v = {
                                    code: an.CALL_END_CODE.BAD_SERVICE_RESPONSE,
                                    subCode: an.CALL_END_SUB_CODE.CALL_ACCEPTANCE_INVALID_SERVICE_RESPONSE,
                                    phrase: S === null || S === void 0 ? void 0 : S.toString()
                                };
                                throw this.logger.info(`[${f}][_processCallAcceptance] ${safeJsonStringify(v)}`), this.telemetryHelper.recordRosterEvent(g, cn.HANDLE_ROSTER_UPDATE_FAIL, f), v;
                            }
                        }
                    }, this.restartKeepAliveInterval = (g, f = !1, S)=>{
                        this.disposed || (window.clearInterval(this.keepAliveTimer), f && (this.telemetryHelper.recordEvent(cn.SEND_KEEP_ALIVE_FAILED, S), (S === null || S === void 0 ? void 0 : S.code) === an.RESOURCE_NOT_FOUND_ERROR.code) ? this.logger.info(`[${g}][restartKeepAliveInterval] keepAlive stopped since last request returned NOT_FOUND.`) : this.keepAliveTimer = window.setInterval(this.sendKeepAlive.bind(this), this.keepAliveInterval));
                    }, this.isCallOngoing = ()=>this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED || this.fsmState === an.SIGNALING_FSM_STATE.IDLE, this.isCallIdleOrRosterOnly = ()=>this.fsmState === an.SIGNALING_FSM_STATE.IDLE || this.fsmState === an.SIGNALING_FSM_STATE.OUTGOING_FOR_ROSTER_ONLY || this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY, this.isCallConnectedOrConnectedForRoster = ()=>this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED || this.fsmState === an.SIGNALING_FSM_STATE.CONNECTED_FOR_ROSTER_ONLY, C && (this.callStartTime = C), this.signalingSessionCallback = f, this.signalingAgentConfig = S, this.signalingAgent = _, this.urlIdentifier = v, this.piiUtils = new Sn(S.piiScrubber), this.isHostLessCall = S.doHostlessCalling || !1, this.logger = S.logger.createChild(()=>`CSA[${this.correlationId}][${this.fsmState}]`, this.correlationId, !0), this.updateCorrelationId(v), this.logger.info(`[endpointId=${truncate(this.signalingAgent.endpointId, 8)}]`), this.logger.info(`[participantId=${g.participantId}]`), this.callOperationHandler = new An(this.logger.createChild(()=>`[CallOperationHandler][${g.participantId}]`)), this.http = new Bn(this, this.callStartTime), this.telemetryHelper = new Xn(this, g, this.callStartTime), this.mediaRenegotiationManager = new Hn(this, f, this.telemetryHelper), this.participantManager = new Wn(this, f, g, new je(this.logger)), this.proxiedMessageNotificationManager = new zn(this), this.timeoutManager = new gn(this.logger), this.contentSharingManager = new wn(this, f), this.webRtcSignalingManager = new Zn(this, f), this.pstnContent = {
                        emergencyCallCountry: S.emergencyCallCountry || "",
                        platformName: S.clientInformation,
                        publicApiCall: !1
                    }, this.setupTrouterChannel(), this.setupConnectionCheck();
                }
            };
            function build5(g, f, S, v, _, C) {
                return new er(g, f, S, v, _, C);
            }
            var tr = class {
                updateSignalingAgentConfig(g) {
                    var _this_authTokenManager;
                    const f = causeId2(), S = JSON.stringify(g, (g, f)=>g ? String(f) : f);
                    this.logger.info(`[${f}] updateSignalingAgentConfig, SignalingAgentConfig: ${S}`), this.logger.info(`[${f}] ecsEtag=${g.ecsEtag}`), setDefaultsForSignalingConfig(g), this.updatedSignalingAgentConfig = g, (_this_authTokenManager = this.authTokenManager) === null || _this_authTokenManager === void 0 ? void 0 : _this_authTokenManager.updateTokenSettings({
                        aadTokenExpirationTimeInSeconds: g.aadTokenExpirationTimeInSeconds,
                        caeTokenExpirationTimeInSeconds: g.caeTokenExpirationTimeInSeconds,
                        refreshTimeBeforeTokenTimeoutInSeconds: g.refreshTimeBeforeTokenTimeoutInSeconds,
                        disableTokenMigrationHeader: g.disableTokenMigrationHeader,
                        enablePublishTokenTelemetry: g.enablePublishTokenTelemetry,
                        forceClearExpiredTokens: g.forceClearExpiredTokens,
                        enableRefreshToken: g.enableRefreshToken,
                        enableRefreshTokenRetry: g.enableRefreshTokenRetry,
                        enableRefreshTokenRetryInSeconds: g.enableRefreshTokenRetryInSeconds
                    }), on.useLowerCaseHeaders = g.forceLowercaseHttpHeaders;
                }
                updateUrls(g, f, S) {
                    this.logger.info(`updateUrls: conversationServiceUrl: ${g}, uploadLogRequestUrl: ${f}, enforceUrls: ${S}`), this.updatedSignalingAgentConfig = this.updatedSignalingAgentConfig || this.signalingAgentConfig, S || !this.updatedSignalingAgentConfig.isConversationServiceUrlFromEcs ? this.updatedSignalingAgentConfig.conversationServiceUrl = g || this.updatedSignalingAgentConfig.conversationServiceUrl : this.updatedSignalingAgentConfig.conversationServiceUrl = this.updatedSignalingAgentConfig.conversationServiceUrl || g, S || !this.updatedSignalingAgentConfig.isUploadLogRequestUrlFromEcs ? this.updatedSignalingAgentConfig.uploadLogRequestUrl = f || this.updatedSignalingAgentConfig.uploadLogRequestUrl : this.updatedSignalingAgentConfig.uploadLogRequestUrl = this.updatedSignalingAgentConfig.uploadLogRequestUrl || f;
                }
                update(g) {
                    this.logger.info(`update accountConfiguration ${JSON.stringify(g)}`), g && g.clientSupportsGenericTokenAPI !== this.clientSupportsGenericTokenAPI && (this.clientSupportsGenericTokenAPI = g.clientSupportsGenericTokenAPI, this.authTokenManager.updateTokenSettings({
                        clientSupportsGenericTokenAPI: this.clientSupportsGenericTokenAPI
                    })), this.accountConfig = g;
                }
                sendPushAsync(g, f, S, v, _ = causeId2()) {
                    const C = new Sn(this.signalingAgentConfig.piiScrubber), E = `sendPush[local participant mri = ${C.scrubMriOrOmit(g)}][recipientList = ${C.scrubMriOrOmit(f)}][headers = ${S})][causeId = ${_}]`;
                    if (!(g === null || g === void 0 ? void 0 : g.id)) return this.logger.info(`${E} Empty localParticipantId`), Promise.reject("invalid localParticipantId");
                    if (!f || 0 === f.length || f.every((g)=>g && "" === g.id)) return this.logger.info(`${E} Empty recipientList`), Promise.reject("invalid recipientList");
                    if (!S) return this.logger.info(`${E} Empty headers`), Promise.reject("invalid headers");
                    if (!v || null === tryParse(v)) return this.logger.info(`${E} Invalid body.`), Promise.reject("invalid body");
                    const T = {
                        ...tryParse(v),
                        To: Array.from(f, (g)=>g.id),
                        From: g.id
                    }, I = new on(S);
                    I.hasOwnPropertyCaseInsensitive(an.HEADERS.CORRELATION_ID) || I.set(an.HEADERS.CORRELATION_ID, generateGuid()), I.hasOwnPropertyCaseInsensitive(an.HEADERS.MESSAGE_ID) || I.set(an.HEADERS.MESSAGE_ID, generateGuid()), I.hasOwnPropertyCaseInsensitive(an.HEADERS.PARTICIPANT_ID) || I.set(an.HEADERS.PARTICIPANT_ID, generateGuid()), I.hasOwnPropertyCaseInsensitive(an.HEADERS.CONTENT_TYPE) || I.set(an.HEADERS.CONTENT_TYPE, "application/json"), I.hasOwnPropertyCaseInsensitive(an.HEADERS.CLIENT_USER_AGENT) && I.set(an.HEADERS.CLIENT_USER_AGENT, I.get(an.HEADERS.CLIENT_USER_AGENT) + `/TsCallingVersion=${getTsCallingVersion()}/Ovb=${getOvb()}`);
                    const b = this.signalingAgentConfig.httpRequestDispatcher.getRequestOptions("POST", I === null || I === void 0 ? void 0 : I.getAll(), JSON.stringify(T), 3e4);
                    return new Promise((g, f)=>{
                        this.signalingAgentConfig.httpRequestDispatcher.postAsync(this.signalingAgentConfig.uploadLogRequestUrl || an.URL_DEFAULTS.UPLOAD_LOG_URL, b).then(()=>{
                            g();
                        }).catch((g)=>{
                            f(g);
                        });
                    });
                }
                getSignalingSession(g) {
                    for (const f of Object.keys(this.signalingSessions)){
                        const S = this.signalingSessions[f];
                        if (S.correlationId === g) return S;
                    }
                    return null;
                }
                updateToken(g, f, S, v, _) {
                    this.authTokenManager.updateToken(g, f, S, v, _);
                }
                setTokenRequiredCallBack(g) {
                    this.authTokenManager.setTokenRequiredCallBack(g);
                }
                resetAuthTokenManager() {
                    this.setTokenRequiredCallBack(null), this.authTokenManager.setDisableTimerFlag(!0), this.authTokenManager.dispose();
                }
                checkConfigChange(g) {
                    this.updatedSignalingAgentConfig && this.updatedSignalingAgentConfig !== this.signalingAgentConfig && (this.signalingAgentConfig = this.updatedSignalingAgentConfig, this.updatedSignalingAgentConfig = null, this.applyAuthTokenCacheConfig(g));
                }
                constructor(g){
                    this.endpointId = newGuid(), this.signalingSessions = {}, this.clientSupportsGenericTokenAPI = !1, this.getNewSignalingSession = (g, f, S, v)=>{
                        const _ = causeId2();
                        assertNotNull(g, "selfParticipant should be a non null value"), assertNotNull(f, "signalingSessionCallback should be a non null value");
                        const C = S || newGuid();
                        assertNotNullOrEmpty(C, "signalingSession id generated cannot be null or empty"), this.checkConfigChange(_);
                        const E = build5(g, f, this.signalingAgentConfig, C, this, v), T = E.sessionId;
                        return this.signalingSessions[T] = E, this.logger.info(`[${_}]Created new signalingSession with correlation ID ${C} and session ID ${T}`), E;
                    }, this.resolvePotentialCallConflict = (g)=>{
                        const f = causeId2();
                        let S;
                        if (this.logger.info(`[${f}][resolvePotentialCallConflict]`), !g.multiParty) return Object.keys(this.signalingSessions).forEach((f)=>{
                            this.isSessionInConflictingState(this.signalingSessions[f], !g.isIncomingCall) && (S = g.isIncomingCall ? this.compareAndGetConflictingSession(g, this.signalingSessions[f]) : this.compareAndGetConflictingSession(this.signalingSessions[f], g));
                        }), S ? (this.logger.info("Call conflict done, conflicting session callId=", S.correlationId, "urlIdentifier=", S.urlIdentifier), S.telemetryHelper.recordEvent(cn.CONFLICTED_CALL), this.signalingAgentConfig.endConflictedCall ? (this.endConflictedSession(S, f), S) : void 0) : void 0;
                    }, this.handleIncomingNotification = (g)=>{
                        if (assertNotNull(g, "request should be a non null value"), this.logger.info(`handleIncomingNotification to : ${g.url}`), !g.body && !g.rawBody) return this.logger.error("request has no body"), this.buildNotificationResponse(an.HTTP_STATUS_CODES.BAD_REQUEST);
                        let f = an.HTTP_STATUS_CODES.OK;
                        const S = getIdFromUrl(g.url);
                        if (S) {
                            const v = this.signalingSessions.hasOwnProperty(S);
                            if (this.logger.info(`Is session found:${v}`), v) {
                                const f = this.signalingSessions[S];
                                if (g.headers = new on(g.headers), isEncodedMessage(g.headers)) try {
                                    if (!isMessageEncodingSupported(g.headers)) throw new Error("Unsupported encoding");
                                    const f = decodeMessage(g.rawBody), S = JSON.parse(f);
                                    g.body = S;
                                } catch (g) {
                                    return f.telemetryHelper.recordEvent(cn.TROUTER_DECODE_PAYLOAD_FAILURE), this.buildNotificationResponse(an.HTTP_STATUS_CODES.BAD_REQUEST);
                                }
                                if (f.canHandleIncomingMsgSync(g)) return f.handleIncomingMsgSync(g);
                                window.setTimeout(()=>{
                                    if (this.signalingSessions.hasOwnProperty(S)) {
                                        const f = this.signalingSessions[S];
                                        f.handleIncomingMsgAsync(g).catch((g)=>{
                                            f && f.telemetryHelper && f.telemetryHelper.recordEvent(cn.FAILED_TO_HANDLE_TROUTER_MESSAGE), this.logger.error(`handling IncomingMsg failed with error: ${g}`);
                                        });
                                    }
                                }, 0);
                            } else this.logger.info(`Incoming message for session ID ${S}, but session was not found!`), f = an.HTTP_STATUS_CODES.NOT_FOUND;
                        } else this.logger.error(`Could not retrieve session ID from Url path. Path = ${g.url}`), f = an.HTTP_STATUS_CODES.BAD_REQUEST;
                        const v = this.buildNotificationResponse(f);
                        return this.logger.info(`Result code:${getPrintableObject(v)}`), v;
                    }, this.onCallCompleted = (g, f)=>{
                        this.signalingSessions.hasOwnProperty(g) ? (delete this.signalingSessions[g], this.logger.info(`[${f}][onCallCompleted] Session ID ${g} found. Deleted from signalingSession table`)) : this.logger.info(`[${f}][onCallCompleted] Session ID ${g} not found. Could not delete from signalingSession table`);
                    }, this.applyAuthTokenCacheConfig = (g)=>{
                        this.signalingAgentConfig.enableTokenCache ? (this.authTokenManager.setTokenCaching(!0, g), this.signalingAgentConfig.enableTokenPrefetch && this.authTokenManager.getToken(g).then(()=>{
                            this.logger.info(`[${g}] token prefetch success`);
                        }).catch((f)=>{
                            this.logger.info(`[${g}] token prefetch failure, error=${getPrintableObject(f)}`);
                        })) : this.authTokenManager.setTokenCaching(!1, g), this.signalingAgentConfig.enableTokenCacheForGenericTokenAPI ? this.authTokenManager.setTokenCachingForGenericTokenAPI(!0, g) : this.authTokenManager.setTokenCachingForGenericTokenAPI(!1, g);
                    }, this.endConflictedSession = (g, f)=>{
                        this.logger.info("Call conflict, ending signalingSession with callId=", g.correlationId, "urlIdentifier=", g.urlIdentifier), g.endAsync({
                            code: an.CALL_END_CODE.CONFLICT,
                            subCode: an.CALL_END_SUB_CODE.CONFLICT_IN_NG,
                            phrase: an.CALL_END_PHRASE.CONFLICT
                        }, {
                            forEveryone: !1,
                            causeId: f
                        });
                    }, this.compareAndGetConflictingSession = (g, f)=>{
                        if (!is1to1Mri(g.incomingCallCallerId) || !is1to1Mri(f.participantManager.localParticipant.id)) return;
                        const S = stripMri(g.incomingCallCallerId), v = stripMri(f.participantManager.getParticipantsToInitiateCallWith().length && f.participantManager.getParticipantsToInitiateCallWith()[0].id), _ = stripMri(f.participantManager.localParticipant.id);
                        return v === S ? _ > S ? g : f : void 0;
                    }, this.isSessionInConflictingState = (g, f)=>{
                        if (!g) return this.logger.info("Call conflict, ignore, session already disposed"), !1;
                        const S = [
                            an.CALL_STATUS.IDLE,
                            an.CALL_STATUS.CONNECTING,
                            an.CALL_STATUS.RINGING
                        ];
                        return !g.multiParty && S.indexOf(g.getCallStatus()) > -1 && (f && g.isIncomingCall || !f && !g.isIncomingCall);
                    }, this.buildNotificationResponse = (g, f)=>this.signalingAgentConfig.supportsSynchronousTrouterResponse ? {
                            resultCode: g,
                            responseBody: f
                        } : g, setDefaultsForSignalingConfig(g), this.signalingAgentConfig = g, this.logger = g.logger.createChild("SignalingAgent"), assertNotNull(g, "signalingAgentConfig should be a non null value"), this.logger.info(g.isWebRtcEnabled ? "webRTC enabled" : "ORTC enabled");
                    const f = {
                        aadTokenExpirationTimeInSeconds: g.aadTokenExpirationTimeInSeconds,
                        caeTokenExpirationTimeInSeconds: g.caeTokenExpirationTimeInSeconds,
                        disableTokenMigrationHeader: g.disableTokenMigrationHeader,
                        enablePublishTokenTelemetry: g.enablePublishTokenTelemetry,
                        refreshTimeBeforeTokenTimeoutInSeconds: g.refreshTimeBeforeTokenTimeoutInSeconds,
                        forceClearExpiredTokens: g.forceClearExpiredTokens,
                        enableRefreshToken: g.enableRefreshToken,
                        enableRefreshTokenRetry: g.enableRefreshTokenRetry,
                        enableRefreshTokenRetryInSeconds: g.enableRefreshTokenRetryInSeconds
                    };
                    this.authTokenManager = fn.build(this.logger, g.skypeToken, f, g.telemetryManager), this.applyAuthTokenCacheConfig(causeId2()), on.useLowerCaseHeaders = g.forceLowercaseHttpHeaders;
                }
            }, ir = /;aliases=.*$/i, nr = "8:", rr = ";aliases=", ar = "2:", sr = "4:";
            function stripMriAliases(g) {
                return g ? g.replace(ir, "") : g;
            }
            function generateAliasedMri(g, f) {
                let S = g;
                return f && (S += rr + ar + f), S;
            }
            var isOneOfPhaseErrors = (g, f)=>f && void 0 !== f.phase && !!g[f.phase], isPhaseError = (g, f)=>f && void 0 !== f.phase && f.phase === g;
            function createPhaseExecutor(g) {
                const f = {}, recordPhaseStep = (g)=>{
                    const S = {
                        status: "Pending"
                    };
                    f[g] = S;
                }, recordStepDoneTelemetry = (g, S)=>{
                    f[g].t = S, delete f[g].status;
                }, recordStepFailedTelemetry = (g, S, v)=>{
                    f[g].status = "Failed", f[g].t = S, f[g].reason = getPrintableObject(v);
                };
                return {
                    execute: async (S, v)=>{
                        const _ = g.createChild(`[phase=${S}]`);
                        recordPhaseStep(S), _.info("started");
                        const C = (new Date).getTime();
                        try {
                            const g = await v(), f = +new Date - C;
                            return _.logSuccess(`done, time=${f}`), recordStepDoneTelemetry(S, f), g;
                        } catch (g) {
                            const v = +new Date - C;
                            throw _.logFailure(`time=${v}, error=${getPrintableObject(g)}`), recordStepFailedTelemetry(S, v, g), {
                                phase: S,
                                error: g,
                                phases: f
                            };
                        }
                    },
                    executeSync: (S, v)=>{
                        const _ = g.createChild(`[phase=${S}]`);
                        _.info("started"), recordPhaseStep(S);
                        const C = (new Date).getTime();
                        try {
                            const g = v(), f = +new Date - C;
                            return recordStepDoneTelemetry(S, f), _.logSuccess(`done, time=${f}`), g;
                        } catch (g) {
                            const v = +new Date - C;
                            throw _.logFailure(`time=${v}, error=${getPrintableObject(g)}`), recordStepFailedTelemetry(S, v, g), {
                                phase: S,
                                error: g,
                                phases: f
                            };
                        }
                    },
                    getTelemetryData: ()=>f
                };
            }
            function callStateIsAnyOf(g, f) {
                return -1 !== f.indexOf(g);
            }
            var or, lr, cr, dr = {
                0: [
                    1,
                    2,
                    8,
                    6,
                    10,
                    11,
                    9
                ],
                1: [
                    2,
                    6,
                    7,
                    10,
                    13
                ],
                2: [
                    1,
                    3,
                    6,
                    7,
                    9,
                    10,
                    13,
                    14
                ],
                3: [
                    6,
                    7,
                    4,
                    5,
                    10,
                    13
                ],
                8: [
                    1,
                    11,
                    10,
                    2,
                    9,
                    6,
                    7
                ],
                4: [
                    6,
                    7,
                    3,
                    5,
                    10,
                    13
                ],
                5: [
                    6,
                    7,
                    3,
                    4,
                    10,
                    13
                ],
                9: [
                    3,
                    6,
                    7,
                    10,
                    13
                ],
                10: [
                    3,
                    6,
                    7,
                    9,
                    4,
                    5,
                    13,
                    15
                ],
                13: [
                    3,
                    6,
                    7,
                    4,
                    5
                ],
                14: [
                    3,
                    6,
                    7,
                    10,
                    13
                ],
                15: [
                    3,
                    6,
                    7,
                    4,
                    5,
                    13
                ],
                11: [
                    12,
                    1,
                    2,
                    6,
                    7
                ],
                12: [
                    2,
                    6,
                    7
                ],
                6: [
                    7
                ],
                7: []
            };
            ((g)=>{
                let f;
                var S;
                let v;
                var _;
                let C;
                var E;
                let T;
                var I;
                (S = f = g.VideoEffectType || (g.VideoEffectType = {})).Off = "off", S.BackgroundBlur = "blur", S.BackgroundReplacement = "replacement", S.PresenterMode = "presenterMode", S.None = "none", (_ = v = g.PowerPreference || (g.PowerPreference = {})).Default = "default", _.HighPerformance = "high-performance", _.LowPower = "low-power", (E = C = g.ProcessorType || (g.ProcessorType = {})).Wasm = "Wasm", E.Webgl2 = "Webgl2", (I = T = g.EffectQualityChangeReason || (g.EffectQualityChangeReason = {}))[I.ExternalParam = 0] = "ExternalParam", I[I.Performance = 1] = "Performance", I[I.RendererSize = 2] = "RendererSize";
            })(or || (or = {})), ((g)=>{
                let f;
                var S;
                let v;
                var _;
                let C;
                var E;
                let T;
                var I;
                let b;
                var A;
                (S = f = g.CallType || (g.CallType = {}))[S.P2P = 0] = "P2P", S[S.Conference = 1] = "Conference", S[S.PSTN = 2] = "PSTN", S[S.BroadcastingConf = 3] = "BroadcastingConf", (_ = v = g.AudioUsageMode || (g.AudioUsageMode = {}))[_.Default = 0] = "Default", _[_.LongRangeSpeaker = 1] = "LongRangeSpeaker", _[_.Auditorium = 2] = "Auditorium", (E = C = g.AecPerfProfile || (g.AecPerfProfile = {}))[E.Normal = 0] = "Normal", E[E.Soc = 1] = "Soc", E[E.Mobile = 2] = "Mobile", E[E.NoisyTimestamps = 3] = "NoisyTimestamps", (I = T = g.VqeMode || (g.VqeMode = {}))[I.Off = 0] = "Off", I[I.SkypeNS = 1] = "SkypeNS", I[I.SkypeAEC = 2] = "SkypeAEC", I[I.SkypeVQE = 3] = "SkypeVQE", I[I.DeepNS = 4] = "DeepNS", I[I.DeepVQE = 5] = "DeepVQE", (A = b = g.AudioEffectType || (g.AudioEffectType = {})).Off = "Off", A.NoiseSuppressionDeep = "Deep NS", A.NoiseSuppressionClassic = "Classic NS", A.EchoCancellationClassic = "Classic AEC", A.VoiceQualityEnhancementClassic = "Classic VQE", A.VoiceQualityEnhancementDeep = "Deep VQE";
            })(lr || (lr = {})), ((g)=>{
                let f;
                var S;
                let v;
                var _;
                (S = f = g.FrameType || (g.FrameType = {}))[S.None = 0] = "None", S[S.Software = 1] = "Software", S[S.Hardware = 2] = "Hardware", (_ = v = g.LogLevel || (g.LogLevel = {}))[_.Default = 0] = "Default", _[_.Debug = 1] = "Debug", _[_.Info = 2] = "Info", _[_.Warning = 3] = "Warning", _[_.Error = 4] = "Error";
            })(cr || (cr = {}));
            var ur = P, hr = ((g)=>(g[g.CallStateChanged = 0] = "CallStateChanged", g[g.TrouterStateChanged = 1] = "TrouterStateChanged", g[g.MultiPartyModeSet = 2] = "MultiPartyModeSet", g[g.MediaRetargetSucceeded = 3] = "MediaRetargetSucceeded", g[g.MediaRetargetFailed = 4] = "MediaRetargetFailed", g))(hr || {}), gr = ((g)=>(g[g.StartModality = 0] = "StartModality", g[g.StopModality = 1] = "StopModality", g[g.StreamStateChanged = 2] = "StreamStateChanged", g[g.NegotiationStateChanged = 3] = "NegotiationStateChanged", g))(gr || {}), pr = ((g)=>(g[g.SelectSource = 0] = "SelectSource", g[g.AttachSource = 1] = "AttachSource", g[g.DetachSource = 2] = "DetachSource", g))(pr || {}), mr = ((g)=>(g[g.Available = 0] = "Available", g[g.Subscribe = 1] = "Subscribe", g[g.Subscribed = 2] = "Subscribed", g[g.Unsubscribe = 3] = "Unsubscribe", g[g.Unsubscribed = 4] = "Unsubscribed", g[g.RenderingStarted = 5] = "RenderingStarted", g[g.RenderingStopped = 6] = "RenderingStopped", g))(mr || {}), fr = class {
            };
            fr.agentEnvironmentId = "agent_environment_id", fr.correlationId = "CorrelationId", fr.participantId = "participant_id", fr.displayName = "display_name", fr.tenantId = "TenantId", fr.userHexCID = "UserHexCID", fr.acsResourceId = "AcsResourceId", fr.endpointId = "endpoint_id", fr.mediaLegId = "media_leg_id", fr.webMediaConfigIds = "web_media_config_ids", fr.tsCallingVersion = "ts_calling_version";
            var Sr = class {
            };
            Sr.diagnostics = "MediaDiagnostic", Sr.qoeStats = "QoE", Sr.webrtcSession = "webrtc_session", Sr.webrtcSessionInitial = "webrtc_session_initial", Sr.realtimeTelemetry = "realtimetelemetry", Sr.webrtcMediaSession = "webrtc_call_session", Sr.mediaSession = "pluginless_modality_session", Sr.callSession = "pluginless_call_session";
            var vr = class {
                setLocalUserId(g) {
                    this.localUserId = g;
                }
                start() {
                    this.ended || (this.startTime = Date.now());
                }
                end(g = 0) {
                    this.ended || (this.ended = !0, this.resultCode = g);
                }
                asStatsRecord(g = {}) {
                    if ((0, ur.isEmpty)(this.events)) return null;
                    const f = (0, ur.uniqBy)(this.events, (g)=>JSON.stringify(g)).map((g)=>{
                        const f = {
                            [g.type]: g.timestamp - this.startTime
                        };
                        return (0, ur.isEmpty)(g.data) || (f.data = g.data), f;
                    });
                    return {
                        name: this.eventName,
                        record: (0, ur.assign)({
                            LocalUser: this.localUserId,
                            ResultCode: String(this.resultCode),
                            EventTimestampBag: JSON.stringify({
                                eventStart: this.startTime,
                                events: f
                            })
                        }, g)
                    };
                }
                add(g) {
                    !this.ended && g.type && ((0, ur.isUndefined)(this.startTime) && (this.startTime = Date.now()), (0, ur.isUndefined)(g.timestamp) && (g.timestamp = Date.now()), this.events.push(g));
                }
                constructor(g){
                    this.eventName = g, this.ended = !1, this.events = [];
                }
            }, _r = class _CallStats extends vr {
                callStateChanged(g) {
                    super.add({
                        type: hr[0],
                        data: _CallStats.callStateToString[g] || g
                    });
                }
                event(g) {
                    super.add({
                        type: hr[g]
                    });
                }
                constructor(){
                    super(Sr.callSession);
                }
            };
            _r.callStateToString = {
                0: "None",
                1: "Notified",
                2: "Connecting",
                3: "Connected",
                4: "LocalHold",
                5: "RemoteHold",
                6: "Disconnecting",
                7: "Disconnected",
                8: "Observing",
                10: "Lobby"
            };
            var Cr = _r, yr = class _MediaModalityStats extends vr {
                addEvent(g, f) {
                    super.add({
                        type: g,
                        data: f
                    });
                }
                lifecycle(g) {
                    this.addEvent(gr[g]);
                }
                streamStateChanged(g, f = this.streamDirection) {
                    const S = gr[2];
                    this.addEvent(S, {
                        state: _MediaModalityStats.streamStateToString[g],
                        direction: _MediaModalityStats.streamDirectionToString[f]
                    });
                }
                negotiationStateChanged(g, f, S = this.streamDirection) {
                    const v = gr[3];
                    this.addEvent(v, {
                        state: _MediaModalityStats.negotiationStateToString[g],
                        reason: f
                    });
                }
                asStatsRecord(g = {}) {
                    return super.asStatsRecord((0, ur.assign)({
                        MediaType: _MediaModalityStats.mediaTypeToString[this.mediaType],
                        Role: _MediaModalityStats.mediaDirectionToRole[this.mediaDirection]
                    }, g));
                }
                constructor(g, f){
                    super(Sr.mediaSession), this.mediaType = g, this.mediaDirection = f, this.streamDirection = _MediaModalityStats.mediaDirectionToStream[this.mediaDirection];
                }
            };
            yr.negotiationStateToString = {
                started: "NegotiationStarted",
                rejected: "NegotiationRejected",
                completed: "NegotiationCompleted"
            }, yr.streamStateToString = {
                created: "StreamCreated",
                started: "StreamStarted",
                active: "StreamActive",
                inactive: "StreamInactive",
                stopped: "StreamStopped",
                removed: "StreamRemoved",
                failed: "StreamFailed",
                cancelled: "StreamCancelled"
            }, yr.streamDirectionToString = {
                send: "Send",
                receive: "Receive"
            }, yr.mediaTypeToString = {
                0: "Audio",
                1: "Video",
                2: "ScreenShare",
                3: "Data"
            }, yr.mediaDirectionToRole = {
                1: "Receiver",
                2: "Sender",
                4: "Bidirectional"
            }, yr.mediaDirectionToStream = {
                1: "receive",
                2: "send"
            };
            var Er = yr, Tr = class extends Er {
                start() {
                    super.start(), super.lifecycle(0);
                }
                stop() {
                    super.lifecycle(1);
                }
                constructor(){
                    super(0, 4);
                }
            }, Ir = class extends Er {
                start() {
                    super.start(), super.lifecycle(0);
                }
                stop() {
                    super.lifecycle(1);
                }
                event(g) {
                    super.addEvent(pr[g]);
                }
                constructor(g){
                    super(g, 2), this.mediaType = g;
                }
            }, br = class extends Er {
                newRendererId() {
                    return this.rendererCounter += 1, String(this.rendererCounter);
                }
                event(g, f, S) {
                    super.addEvent(mr[g], (0, ur.isUndefined)(S) ? {
                        rendererId: f
                    } : {
                        rendererId: f,
                        sourceId: S
                    });
                }
                asStatsRecord() {
                    return super.asStatsRecord({
                        TargetUser: this.remoteParticipantId
                    });
                }
                constructor(g, f){
                    super(g, 1), this.mediaType = g, this.remoteParticipantId = f, this.rendererCounter = 0;
                }
            }, Ar = class {
                setLocalUserId(g) {
                    this.localUserId = g;
                }
                get call() {
                    return this.callStats || this.startCall();
                }
                get audio() {
                    return this.audioStats || this.newSession(0);
                }
                get video() {
                    return this.videoStats || this.newSession(1);
                }
                get screenShare() {
                    return this.sharingStats || this.newSession(2);
                }
                renderer(g, f) {
                    let S = this.renderingStats[f];
                    return S || (S = this.renderingStats[f] = this.receive(g, f)), S;
                }
                startCall() {
                    return this.callStats ? this.callStats : (this.callStats = new Cr, this.callStats.start(), this.addStats(this.callStats));
                }
                endCall(g = 0) {
                    this.ended = !0, this.call.end(g), this.allStats.forEach((g)=>g.end()), this.cleanUp();
                }
                cleanUp() {
                    this.audioStats && (this.audioStats.stop(), this.audioStats = null), this.videoStats && (this.videoStats.stop(), this.videoStats = null), this.sharingStats && (this.sharingStats.stop(), this.sharingStats = null);
                }
                newSession(g) {
                    let f;
                    switch(g){
                        case 0:
                            f = this.audioStats = new Tr;
                            break;
                        case 1:
                            f = this.videoStats = new Ir(g);
                            break;
                        case 2:
                            f = this.sharingStats = new Ir(g);
                    }
                    return this.addStats(f);
                }
                receive(g, f) {
                    const S = new br(g, f);
                    return S.start(), this.addStats(S);
                }
                buildStatsRecords() {
                    return this.allStats.map((g)=>g.asStatsRecord()).filter((g)=>!!g);
                }
                addStats(g) {
                    return this.ended || (this.allStats.push(g), g.setLocalUserId(this.localUserId)), g;
                }
                constructor(){
                    this.allStats = [], this.ended = !1;
                }
            }, Rr = class _CallTelemetryBuilder {
                setCallId(g) {
                    this.callId = g;
                }
                setTenantId(g) {
                    this.tenantId = g;
                }
                setUserHexCID(g) {
                    this.userHexCID = g;
                }
                setParticipantId(g) {
                    this.participantId = g;
                }
                setDisplayName(g) {
                    this.displayName = g;
                }
                setEndpointId(g) {
                    this.endpointId = g;
                }
                setMediaLegId(g) {
                    this.mediaLegId = g;
                }
                setMediaStats(g) {
                    this.mediaStats = g;
                }
                setAcsResourceId(g) {
                    this.acsResourceId = g;
                }
                appendDataChannelInfo(g) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && g && (this.mediaStats.data.DataHandlers = g);
                }
                appendSharingControlInfo(g) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && (this.mediaStats.data.SharingControlEnabled = g ? "true" : "false");
                }
                appendMediaControlPlaneInfo(g) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && g && (this.mediaStats.data.MediaControlPlane = g);
                }
                appendTerminationInfo(g, f) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && (this.mediaStats.data.TerminatedReason = `${g}`, this.mediaStats.data.TerminatedState = `${f}`);
                }
                appendPictureInPictureInfo(g) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && g && (this.mediaStats.data.PictureInPicture = g);
                }
                appendCallDeviceManagerInfo(g) {
                    var _this_mediaStats;
                    ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.data) && g && (this.mediaStats.data.CallDeviceManager = g);
                }
                async buildVDItelemetryReport(g) {
                    const { transport: f, rpc: S, rpcRemote: v, transportRemote: _ } = await g.getStats(this.startTime);
                    return {
                        CallId: this.callId,
                        ParticipantId: this.participantId,
                        Transport: JSON.stringify(f),
                        Rpc: JSON.stringify(S),
                        Rpc_Remote: JSON.stringify(v),
                        Transport_Remote: JSON.stringify(_)
                    };
                }
                buildFromMediaStats() {
                    var _this_mediaStats;
                    return "WebRtcMediaStats" === ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.type) ? [
                        this.buildEvent(this.mediaStats.data, Sr.webrtcSession)
                    ] : [];
                }
                buildShortCallEvent(g) {
                    const f = {};
                    return f[fr.correlationId] = this.callId || "", f[fr.participantId] = this.participantId || "", f[fr.displayName] = new xe(this.displayName || "", 1), f[fr.tenantId] = this.tenantId || "", f[fr.tsCallingVersion] = this.tsCallingVersion || "", f.metrics_TerminationReason_code = new xe(g.data.metrics.TerminationReason_code, 0), f.metrics_TerminationReason_subCode = new xe(g.data.metrics.TerminationReason_subCode, 0), f.metrics_eventType = new xe(g.eventType, 0), [
                        {
                            eventName: Sr.webrtcMediaSession,
                            props: this.buildProps(g.data, null, f)
                        }
                    ];
                }
                buildMediaTelemetry() {
                    if (!this.mediaStats) return;
                    const g = this.buildEvent(this.mediaStats.data, null).props, f = {};
                    return Object.keys(g).forEach((S)=>{
                        void 0 === g[S].piiKind ? f[S] = g[S] : f[S] = g[S].value;
                    }), f;
                }
                buildMidCallTelemetry(g) {
                    if (!this.mediaStats) return [];
                    const f = this.buildEvent(this.mediaStats.data, Sr.webrtcSession), S = f.props, v = g.reduce((g, f)=>(S[f] && (g[f] = S[f]), g), {});
                    return [
                        {
                            eventName: f.eventName,
                            props: v
                        }
                    ];
                }
                buildFromCallSetupStats(g) {
                    var _this_mediaStats;
                    return "WebRtcMediaStats" === ((_this_mediaStats = this.mediaStats) === null || _this_mediaStats === void 0 ? void 0 : _this_mediaStats.type) ? (this.mediaStats.data.trouterUrl = g, [
                        this.buildEvent(this.mediaStats.data, Sr.webrtcSessionInitial)
                    ]) : [];
                }
                buildFromLocalStats() {
                    return this.localStats.buildStatsRecords().map((g)=>this.buildEvent(g.record, g.name));
                }
                buildEvent(g, f) {
                    const S = {};
                    return S[fr.agentEnvironmentId] = _CallTelemetryBuilder.agentEnvironmentId, S[fr.correlationId] = this.callId || "", S[fr.tenantId] = this.tenantId || "", S[fr.userHexCID] = this.userHexCID || "", S[fr.participantId] = this.participantId || "", S[fr.displayName] = new xe(this.displayName || "", 1), S[fr.endpointId] = this.endpointId || "", S[fr.mediaLegId] = this.mediaLegId || "", S[fr.webMediaConfigIds] = this.webMediaConfigIds || "", S[fr.tsCallingVersion] = this.tsCallingVersion || "", S[fr.acsResourceId] = this.acsResourceId || "", {
                        eventName: f,
                        props: this.buildProps(g, null, S)
                    };
                }
                normalizeKey(g) {
                    return g.replace(/[^a-zA-Z0-9._]/g, "_");
                }
                buildProps(g, f, S) {
                    return Object.keys(g).forEach((v)=>{
                        const _ = this.normalizeKey(v), C = f ? `${f}_${_}` : _, E = g[v];
                        if ((0, ur.isString)(E)) S[C] = this.getPiiAwareValue(v, E);
                        else if ((0, ur.isArray)(E)) {
                            if (E.length > 0) {
                                const g = E, f = g.map((g)=>g.value).toString();
                                S[C] = new xe(f, g[0].type);
                            }
                        } else if ((0, ur.isObject)(E)) {
                            if (E.__VALUE__) {
                                const g = E;
                                (0, ur.isBoolean)(g.value) && (g.value = g.value ? "true" : "false"), S[C] = new xe(g.value, g.type);
                            } else this.buildProps(E, C, S);
                        }
                    }), S;
                }
                getPiiAwareValue(g, f) {
                    return _CallTelemetryBuilder.piiProps.hasOwnProperty(g) ? new xe(f, _CallTelemetryBuilder.piiProps[g]) : f;
                }
                build() {
                    return (0, ur.flatten)([
                        this.buildFromMediaStats(),
                        this.buildFromLocalStats()
                    ]);
                }
                constructor(){
                    this.startTime = Date.now(), this.localStats = new Ar, this.tsCallingVersion = getTsCallingVersion();
                }
            };
            Rr.agentEnvironmentId = generateGuid(), Rr.piiProps = {
                IPAddr: 13,
                MACAddr: 13,
                IPAddress: 13,
                OpaqueData: 0,
                LocalSite: 13,
                RemoteSite: 13,
                BaseAddress: 13,
                LocalAddress: 13,
                RemoteAddress: 13,
                NetworkName: 12,
                LocalUser: 10,
                TargetUser: 10,
                [fr.displayName]: 1
            };
            var Pr = Rr, wr = P;
            function convertReason(g) {
                return g ? getTerminationCode(g.code, g.subCode) : 0;
            }
            function convertSignalingEndpointDetails(g, f) {
                const S = {
                    clientVersion: g.clientVersion,
                    participantId: g.participantId,
                    endpointId: g.endpointId,
                    endpointType: g.endpointType,
                    endpointMetadata: g.endpointMetadata,
                    originalId: g.originalId,
                    capabilities: g.capabilities,
                    clientEndpointCapabilities: g.clientEndpointCapabilities,
                    mappedTo: g.mappedTo,
                    meetingGroupDetails: g.meetingGroupDetails,
                    endpointMeetingRoles: g.endpointMeetingRoles
                };
                return g.mediaStreams && (S.mediaStreams = g.mediaStreams), g.appliedInteractivityLevel && (S.appliedInteractivityLevel = g.appliedInteractivityLevel), g.deviceType && (S.deviceType = g.deviceType), g.streamInformation && 32 & f && (S.streamInformation = g.streamInformation), g.propertyBag && (S.propertyBag = g.propertyBag), g.negotiationTag && (S.negotiationTag = g.negotiationTag), S;
            }
            function getTerminationCode(g, f = null) {
                if (g === Li.Success) switch(f){
                    case Fi.RemovedFromConversation:
                    case Fi.RemovedFromCall:
                        return 44;
                    case Fi.DeniedInLobby:
                        return 55;
                    case Fi.TimedOutInLobby:
                        return 56;
                    default:
                        return 1;
                }
                if (null !== f && f >= 2e5 && f <= 299999) {
                    const g = f - 2e5;
                    return Ui[g] ? Ui[g] : 0;
                }
                return null !== f && f >= 4e5 && f <= 499999 ? Vi[g] ? Vi[g] : 43 : g === Li.Forbidden ? f === Fi.UserBlocked ? 64 : f === Fi.PolicyRestriction ? 62 : f === Fi.AnonymousJoinDisabledByPolicy ? 66 : f === Fi.NoLobbyForBroadcastJoin ? 67 : f === Fi.NotAllowedDueToInformationBarrier ? 68 : f === Fi.TeamParkPolicyDisabled ? 70 : f === Fi.B2bJoinDisabledByPolicy ? 71 : (Li.Success, 8) : g === Li.PreconditionFailed && f === Fi.InsufficientCapabilities ? 63 : g === Li.ServiceUnavailable ? f === Fi.BroadcastLimitReached ? 69 : 48 : g === Li.InternalServerError ? 7 : g === Li.ConfParticipantCountLimitReached ? f === Fi.MaxLobbyParticipantLimitReached ? 73 : 59 : xi[g] ? xi[g] : g;
            }
            function getCSAEndCode(g) {
                if (1 === g) return Li.Success;
                const f = Object.keys(xi).filter((f)=>xi[f] === g);
                if (f.length >= 1) for (const S of f){
                    const f = parseInt(S);
                    if (f && xi[f] === g) return f;
                }
                return Li.UnknownError;
            }
            function getMediaState(g, f) {
                if (void 0 !== f && 3 !== f && 1 !== f) return {
                    mediaType: g,
                    isDisabled: 0 === f,
                    label: getMediaLabel(g)
                };
            }
            function getCallStartOptions(g) {
                if (g.sendMediaModalities) return g;
                const f = {
                    mediaStates: []
                };
                let S = getMediaState(0, g.audioDirection ? g.audioDirection : 4);
                return S && f.mediaStates.push(S), S = getMediaState(1, g.withVideo ? 4 : g.videoDirection), S && f.mediaStates.push(S), S = getMediaState(2, g.screenshareDirection ? g.screenshareDirection : 1), S && f.mediaStates.push(S), g.sendMediaModalities = f, g;
            }
            function convertRedirectOptions(g) {
                const f = convertRedirectionTargetIdType(g.type), S = convertRedirectionEndpointType(g.endpointType);
                return {
                    type: f,
                    id: g.id,
                    endpointType: S
                };
            }
            function convertRedirectionTargetIdType(g) {
                if ("mri" === g) return "mri";
                throw "Unknown RedirectionTargetIdType";
            }
            function convertRedirectionEndpointType(g) {
                switch(g){
                    case "voicemail":
                        return "voicemail";
                    case "default":
                        return "default";
                    default:
                        throw "Unknown RedirectionEndpointType";
                }
            }
            var Mr = class {
                isDisabled(g) {
                    var _this_mediaStateConfiguration;
                    if ((_this_mediaStateConfiguration = this.mediaStateConfiguration) === null || _this_mediaStateConfiguration === void 0 ? void 0 : _this_mediaStateConfiguration.mediaStates) {
                        const f = this.mediaStateConfiguration.mediaStates.find((f)=>f.mediaType === g);
                        return !!f && !!f.isDisabled;
                    }
                    return !1;
                }
                isInactiveOrDisabled(g) {
                    var _this_mediaStateConfiguration;
                    if ((_this_mediaStateConfiguration = this.mediaStateConfiguration) === null || _this_mediaStateConfiguration === void 0 ? void 0 : _this_mediaStateConfiguration.mediaStates) {
                        const f = this.mediaStateConfiguration.mediaStates.find((f)=>f.mediaType === g);
                        return !f || !!f.isDisabled;
                    }
                    return !1;
                }
                isSending(g) {
                    var _this_mediaStateConfiguration;
                    if ((_this_mediaStateConfiguration = this.mediaStateConfiguration) === null || _this_mediaStateConfiguration === void 0 ? void 0 : _this_mediaStateConfiguration.mediaStates) return !!this.mediaStateConfiguration.mediaStates.find((f)=>f.mediaType === g && !f.isDisabled);
                    return !1;
                }
                disableModality(g) {
                    this.setModality(g, !0);
                }
                enableModality(g) {
                    this.setModality(g, !1);
                }
                removeModality(g) {
                    var _this_mediaStateConfiguration;
                    ((_this_mediaStateConfiguration = this.mediaStateConfiguration) === null || _this_mediaStateConfiguration === void 0 ? void 0 : _this_mediaStateConfiguration.mediaStates) && (0, wr.remove)(this.mediaStateConfiguration.mediaStates, (f)=>f.mediaType === g);
                }
                setCallAcceptOptions(g) {
                    const f = this.isDisabled(1), S = this.isDisabled(2), v = this.isSending(3);
                    if (g.sendMediaModalities) this.mediaStateConfiguration = g.sendMediaModalities;
                    else {
                        void 0 === g.answerMediaType && (g.answerMediaType = g.withVideo ? 1 : 0);
                        const f = {
                            mediaStates: []
                        };
                        switch(g.answerMediaType){
                            case 0:
                                f.mediaStates.push(getMediaState(0, 4));
                                break;
                            case 1:
                                f.mediaStates.push(getMediaState(0, 4)), f.mediaStates.push(getMediaState(1, 4));
                                break;
                            case 2:
                                f.mediaStates.push(getMediaState(1, 0));
                        }
                        this.mediaStateConfiguration = f;
                    }
                    f && this.setModality(1, !0), S && this.setModality(2, !0), v && this.setModality(3, !1), g.sendMediaModalities = this.mediaStateConfiguration;
                }
                setModality(g, f) {
                    var _this_mediaStateConfiguration;
                    if ((_this_mediaStateConfiguration = this.mediaStateConfiguration) === null || _this_mediaStateConfiguration === void 0 ? void 0 : _this_mediaStateConfiguration.mediaStates) {
                        const S = this.mediaStateConfiguration.mediaStates.find((f)=>f.mediaType === g);
                        S ? S.isDisabled = f : this.mediaStateConfiguration.mediaStates.push({
                            mediaType: g,
                            isDisabled: f,
                            label: getMediaLabel(g)
                        });
                    }
                }
                constructor(g){
                    this.mediaStateConfiguration = g;
                }
            };
            function hasValue2(g) {
                return g || !1 === g || "" === g || 0 === g;
            }
            function scrubCallOptions(g) {
                const f = {};
                hasValue2(g.callStartTime) && (f.callStartTime = g.callStartTime), hasValue2(g.callVoicemailStartOptions) && (f.callVoicemailStartOptions = g.callVoicemailStartOptions), hasValue2(g.invitationType) && (f.invitationType = g.invitationType), hasValue2(g.meetingPreferences) && (f.meetingPreferences = g.meetingPreferences), hasValue2(g.parkContext) && (f.parkContext = g.parkContext), hasValue2(g.pickupCode) && (f.pickupCode = g.pickupCode), hasValue2(g.participantsToNudge) && (f.participantsToNudgeSize = g.participantsToNudge.length);
                const S = g.callStartOptions;
                if (S) {
                    const g = {};
                    hasValue2(S.additionalEndpointProperties) && (g.additionalEndpointProperties = S.additionalEndpointProperties), hasValue2(S.clientEndpointCapabilities) && (g.clientEndpointCapabilities = S.clientEndpointCapabilities), hasValue2(S.connectionType) && (g.connectionType = S.connectionType), hasValue2(S.invitationDataJson) && (g.invitationDataJson = S.invitationDataJson), hasValue2(S.isCast) && (g.isCast = S.isCast), hasValue2(S.isHuddleGroupCall) && (g.isHuddleGroupCall = S.isHuddleGroupCall), hasValue2(S.label) && (g.label = S.label), hasValue2(S.maxVideoChannels) && (g.maxVideoChannels = S.maxVideoChannels), hasValue2(S.maxVbssChannels) && (g.maxVbssChannels = S.maxVbssChannels), hasValue2(S.mediaConfiguration) && (g.mediaConfiguration = S.mediaConfiguration), hasValue2(S.muteFlags) && (g.muteFlags = S.muteFlags), hasValue2(S.muted) && (g.muted = S.muted), hasValue2(S.negotiationTag) && (g.negotiationTag = S.negotiationTag), hasValue2(S.preheatFlags) && (g.preheatFlags = S.preheatFlags), hasValue2(S.ringOthers) && (g.ringOthers = S.ringOthers), hasValue2(S.routingFlags) && (g.routingFlags = S.routingFlags), hasValue2(S.scenario) && (g.scenario = S.scenario), hasValue2(S.screenshareDirection) && (g.screenshareDirection = S.screenshareDirection), hasValue2(S.sendMediaModalities) && (g.sendMediaModalities = S.sendMediaModalities), hasValue2(S.sharedLineCallInvitationContentJson) && (g.sharedLineCallInvitationContentJson = S.sharedLineCallInvitationContentJson), hasValue2(S.targetApplicationType) && (g.targetApplicationType = S.targetApplicationType), hasValue2(S.captchaContentJson) && (g.captchaContentJson = S.captchaContentJson), hasValue2(S.callQueueContext) && (g.callQueueContext = S.callQueueContext), hasValue2(S.clientEndpointDebugContent) && (g.clientEndpointDebugContentSize = S.clientEndpointDebugContent.length), hasValue2(S.alternateId) && (g.alternateId = scrubMriOrOmit(S.alternateId)), hasValue2(S.callKey) && (g.callKeySize = S.callKey.length), hasValue2(S.encryptedKey) && (g.encryptedKeySize = S.encryptedKey.length), f.callStartOptions = g;
                }
                return f;
            }
            function getAgentMediaType(g) {
                switch(g){
                    case 0:
                        return "Audio";
                    case 1:
                        return "Video";
                    case 2:
                        return "ScreenShare";
                }
                throw new Error("MediaType required");
            }
            function getSkypeMediaType(g) {
                switch(g){
                    case "Audio":
                        return 0;
                    case "Video":
                        return 1;
                    case "ScreenShare":
                        return 2;
                }
                throw new Error("MediaType required");
            }
            function mapMonitorActionType(g) {
                switch(g){
                    case 0:
                        return "Monitor";
                    case 1:
                        return "Whisper";
                    case 2:
                        return "Barge";
                    case 3:
                        return "Takeover";
                    default:
                        return;
                }
            }
            var Or = {
                NEGOTIATION_COMPLETED: "NegotiationCompleted",
                INITIAL: {
                    OFFER_GENERATION_STARTED: "InitialOfferGenerationStarted",
                    OFFER_GENERATION_ENDED: "InitialOfferGenerationEnded",
                    ANSWER_PROCESSING_STARTED: "InitialAnswerProcessingStarted",
                    ANSWER_PROCESSING_ENDED: "InitialAnswerProcessingEnded",
                    OFFER_PROCESSING_STARTED: "InitialOfferProcessingStarted",
                    OFFER_PROCESSING_ENDED: "InitialOfferProcessingEnded",
                    ANSWER_GENERATION_STARTED: "InitialAnswerGenerationStarted",
                    ANSWER_GENERATION_ENDED: "InitialAnswerGenerationEnded"
                },
                RENEGOTIATION: {
                    OFFER_GENERATION_STARTED: "RenegotiationOfferGenerationStarted",
                    OFFER_GENERATION_ENDED: "RenegotiationOfferGenerationEnded",
                    ANSWER_PROCESSING_STARTED: "RenegotiationAnswerProcessingStarted",
                    ANSWER_PROCESSING_ENDED: "RenegotiationAnswerProcessingEnded",
                    OFFER_PROCESSING_STARTED: "RenegotiationOfferProcessingStarted",
                    OFFER_PROCESSING_ENDED: "RenegotiationOfferProcessingEnded",
                    ANSWER_GENERATION_STARTED: "RenegotiationAnswerGenerationStarted",
                    ANSWER_GENERATION_ENDED: "RenegotiationAnswerGenerationEnded"
                }
            }, Dr = class {
                enableTeamsRealTimeTelemetry() {
                    this.mediaSession.enableTeamsRealTimeTelemetry();
                }
                getMediaStatsReport() {
                    return this.mediaSession.getMediaStatsReport();
                }
                processOfferAsync(g, f) {
                    return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_PROCESSING_STARTED), this.mediaSession.processOfferAsync(g, f).then((g)=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_PROCESSING_ENDED), g));
                }
                createAnswerAsync(g, f) {
                    return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_GENERATION_STARTED), this.mediaSession.createAnswerAsync(g, f).then((f)=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_GENERATION_ENDED), g || (this.operationNames = Or.RENEGOTIATION), f));
                }
                createOfferAsync(g, f) {
                    return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_GENERATION_STARTED), this.mediaSession.createOfferAsync(g, f).then((g)=>(this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.OFFER_GENERATION_ENDED), g));
                }
                processAnswerAsync(g, f, S, v = !1) {
                    return this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_PROCESSING_STARTED), this.mediaSession.processAnswerAsync(g, f, S, v).then(()=>{
                        this.signalingSession.setOfferAnswerGenerationTimestamps(this.operationNames.ANSWER_PROCESSING_ENDED), this.operationNames = Or.RENEGOTIATION;
                    });
                }
                completeNegotiationAsync(g) {
                    return this.mediaSession.completeNegotiationAsync(g).then((g)=>(this.signalingSession.setOfferAnswerGenerationTimestamps(Or.NEGOTIATION_COMPLETED), g));
                }
                sendDtmf(g) {
                    return this.mediaSession.sendDtmf ? this.mediaSession.sendDtmf(g) : Promise.reject("Not Implemented");
                }
                reconnectAsync(g, f = !1, S) {
                    return this.mediaSession.reconnectAsync(g, f, S);
                }
                completeEscalationAsync(g) {
                    return this.mediaSession.completeEscalationAsync(g);
                }
                rejectEscalationAsync(g, f) {
                    return this.mediaSession.rejectEscalationAsync(g, f);
                }
                getAcceptedTypes() {
                    return this.mediaSession.getAcceptedTypes();
                }
                getLocalMediaTrackId(g) {
                    return this.mediaSession.getLocalMediaTrackId ? this.mediaSession.getLocalMediaTrackId(g) : null;
                }
                processNotification(g, f) {
                    this.mediaSession.processNotification(g, f);
                }
                constructor(g, f){
                    this.mediaSession = g, this.signalingSession = f, this.operationNames = Or.INITIAL, this.configureModalitiesAsync = this.mediaSession.configureModalitiesAsync.bind(this.mediaSession), this.getAllowedModalities = this.mediaSession.getAllowedModalities.bind(this.mediaSession), this.rejectNegotiationAsync = this.mediaSession.rejectNegotiationAsync.bind(this.mediaSession), this.createRemoteRenderer = this.mediaSession.createRemoteRenderer.bind(this.mediaSession), this.getStatsAsync = this.mediaSession.getStatsAsync.bind(this.mediaSession), this.getLastKnownStats = this.mediaSession.getLastKnownStats.bind(this.mediaSession), this.getCallTechnicalInfo = this.mediaSession.getCallTechnicalInfo.bind(this.mediaSession), this.muteHold = this.mediaSession.muteHold.bind(this.mediaSession), this.muteInputAsync = this.mediaSession.muteInputAsync.bind(this.mediaSession), this.unmuteInputAsync = this.mediaSession.unmuteInputAsync.bind(this.mediaSession), this.muteOutputAsync = this.mediaSession.muteOutputAsync.bind(this.mediaSession), this.unmuteOutputAsync = this.mediaSession.unmuteOutputAsync.bind(this.mediaSession), this.getSpeakerVolume = this.mediaSession.getSpeakerVolume.bind(this.mediaSession), this.setSpeakerVolume = this.mediaSession.setSpeakerVolume.bind(this.mediaSession), this.terminate = this.mediaSession.terminate.bind(this.mediaSession), this.createAudioElement = this.mediaSession.createAudioElement.bind(this.mediaSession), this.getSessionConfig = this.mediaSession.getSessionConfig.bind(this.mediaSession), this.getDiagnostics = this.mediaSession.getDiagnostics.bind(this.mediaSession), this.getIncomingRawAudioStream = this.mediaSession.getIncomingRawAudioStream.bind(this.mediaSession), this.getUnmixedAudioProvider = this.mediaSession.getUnmixedAudioProvider.bind(this.mediaSession), this.useNullAudioStreamClient = this.mediaSession.useNullAudioStreamClient.bind(this.mediaSession), this.getSubscriptionManager = this.mediaSession.getSubscriptionManager.bind(this.mediaSession), this.configureSpatialAudio = this.mediaSession.configureSpatialAudio.bind(this.mediaSession), this.setParticipantSpatialAudioPositions = this.mediaSession.setParticipantSpatialAudioPositions.bind(this.mediaSession), this.setCallConstraints = this.mediaSession.setCallConstraints.bind(this.mediaSession), this.startMediaDescriptionsUpdateAsync = this.mediaSession.startMediaDescriptionsUpdateAsync.bind(this.mediaSession), this.completeMediaDescriptionsUpdateAsync = this.mediaSession.completeMediaDescriptionsUpdateAsync.bind(this.mediaSession), this.rejectMediaDescriptionsUpdateAsync = this.mediaSession.rejectMediaDescriptionsUpdateAsync.bind(this.mediaSession), this.registerRemoteQualityStateChangedEvent = this.mediaSession.registerRemoteQualityStateChangedEvent.bind(this.mediaSession), this.getMediaControlPlaneInstance = this.mediaSession.getMediaControlPlaneInstance.bind(this.mediaSession);
                }
            };
            function handleServerMutedVersion(g, f, S) {
                if (void 0 === (f === null || f === void 0 ? void 0 : f.serverMuteVersion) || void 0 === (S === null || S === void 0 ? void 0 : S.serverMuteVersion) || S.serverMuteVersion >= f.serverMuteVersion) return;
                const v = S && S.mediaStreams, _ = v && v.filter((g)=>"audio" === g.type || "audio-teleconferencing" === g.type), C = f && f.mediaStreams, E = C && C.filter((g)=>"audio" === g.type || "audio-teleconferencing" === g.type);
                _ && _.length && (S.serverMuteVersion = f.serverMuteVersion, _[0].serverMuted = E[0].serverMuted, g.info(`handleServerMutedVersion: patching server muted state in audio streams updated:${JSON.stringify(_[0])} as we encountered stale muteServerVersion. Updated to ${f.serverMuteVersion}`));
            }
            function handleMuteUnmuteParticipantInfo(g, f, S, v) {
                if ("success" !== S.reason || void 0 === f || S.serverMuteVersion <= f.serverMuteVersion) return g.info(`handleMuteUnmuteParticipantInfo: ignoring updating since we encountered invalid state: ${S.reason} serverMuteVersion: ${S.serverMuteVersion}`), !1;
                const _ = f && f.mediaStreams, C = _ && _.filter((g)=>"audio" === g.type || "audio-teleconferencing" === g.type);
                return !!C && (C[0].serverMuted = v, f.serverMuteVersion = S.serverMuteVersion, g.info(`handleMuteUnmuteParticipantInfo: updating since we encountered valid state serverMuteVersion: ${S.serverMuteVersion} to: ${v} streams: ${C[0].sourceId}`), !0);
            }
            var Nr = R;
            function scrub(g, f, S, v) {
                const _ = JSON.stringify(g), C = JSON.parse(_);
                return C && (scrubOneTypeOfParams(g, C, f, Nr.pii.Omit), scrubOneTypeOfParams(g, C, S, Nr.pii.Mri), scrubOneTypeOfParams(g, C, v, Nr.pii.UserName)), JSON.stringify(C);
            }
            function scrubOneTypeOfParams(g, f, S, v) {
                S === null || S === void 0 ? void 0 : S.forEach((S)=>{
                    g[S] && (f[S] = v(g[S]));
                });
            }
            function scrubSignalingParticipant(g) {
                return `id=${Nr.pii.Mri(g.id)}, participantId=${g.participantId}`;
            }
            function scrubITransferContext(g) {
                const f = [], S = [
                    "transferorMri",
                    "targetMri"
                ];
                return scrub(scrubObjectFields(g), f, S);
            }
            var kr = P, Lr = S.setImmediate ? (g)=>{
                S.setImmediate(g);
            } : (g)=>{
                (0, kr.defer)(g);
            }, Fr = class _DeferHandler {
                setLogger(g) {
                    this._logger = g.createChild("[DeferHandler]");
                }
                setDeferToQueueMicrotask(g) {
                    g && S.queueMicrotask ? _DeferHandler.defer = (g)=>S.queueMicrotask(g) : _DeferHandler.defer = Lr;
                }
                createDeferRunner(g) {
                    const f = {};
                    return (S)=>this.runDeferred(f, S, g);
                }
                runDeferredWithoutDedup(g, f) {
                    const S = {};
                    this.runDeferred(S, g, f);
                }
                runDeferred(g, f, S) {
                    var _this__logger;
                    this.deferredOperations.has(g) || (this.deferredOperations.set(g, f), S && this.deferredOperationsNames.push(" " + S), this.isRunning || (this.isRunning = !0, this._startDeferalTime = Date.now(), this.causeId = generateCauseId(), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`[${this.causeId}]Deferring operations`), _DeferHandler.defer(()=>{
                        var _this__logger;
                        this._timeToRun = Date.now() - this._startDeferalTime, this.deferredOperations.forEach((g)=>{
                            _DeferHandler.runWithTryCatch(g);
                        }), this.deferredOperations.clear(), this.isRunning = !1, (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`[${this.causeId}]Deferred operations ran after ${this._timeToRun}ms | Completed after ${Date.now() - this._startDeferalTime}ms | Operations:${this.deferredOperationsNames}`), this.deferredOperationsNames = [];
                    })));
                }
                static runWithTryCatch(g) {
                    try {
                        g && g();
                    } catch (g) {}
                }
                constructor(){
                    this.deferredOperations = new Map, this.deferredOperationsNames = [], this.isRunning = !1;
                }
            };
            Fr.defer = Lr;
            var xr = Fr, Ur = class {
            };
            Ur.instance = new xr;
            var Vr = P, Br = {
                send: "sendonly",
                receive: "recvonly",
                sendReceive: "sendrecv"
            }, Hr = {
                audio: "audio",
                video: "video",
                sharing: "applicationsharing-video",
                audioteleconference: "audio-teleconferencing"
            }, $r = class extends ze {
                set isStreaming(g) {
                    this.currentIsStreaming = g, this.logger.info(`isStreaming has changed to ${this.currentIsStreaming}`), this.raiseChanged();
                }
                get isStreaming() {
                    return this.currentIsStreaming;
                }
                update({ sourceId: g = null, direction: f = Br.receive, participantId: S = null, endpointId: v = null } = {}, _, C) {
                    var _this_mediaSession, _this_mediaSession_getDisabledModalities, _this_mediaSession1;
                    this.logger.info(`[${_}][update before]  sourceId=${g}, direction=${f}, isAvailable=${this.isAvailable}, participantId=${S}, endpointId=${truncate(v, 8)}, ${this.negotiationTag ? `, negotiationTag=${this.negotiationTag}` : ""}`), this.id = g;
                    const E = f === Br.sendReceive || f === Br.send;
                    this.isAvailable !== E && (this.negotiationTag = C === null || C === void 0 ? void 0 : C.get(v)), this.isAvailable = E, ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.streamAvailabilityConsiderModalities) && this.getIsModalityDisabled() && (this.logger.info(`Disabling current modality, disabled: ${JSON.stringify(((_this_mediaSession1 = this.mediaSession) === null || _this_mediaSession1 === void 0 ? void 0 : (_this_mediaSession_getDisabledModalities = _this_mediaSession1.getDisabledModalities) === null || _this_mediaSession_getDisabledModalities === void 0 ? void 0 : _this_mediaSession_getDisabledModalities.call(_this_mediaSession1)) || "")}`), this.isAvailable = !1), this.participantId = S, this.endpointId = v, this.logger.info(`[${_}][update after]  sourceId=${g}, direction=${f}, isAvailable=${this.isAvailable}, participantId=${S}, endpointId=${truncate(v, 8)}, ${this.negotiationTag ? `, negotiationTag=${this.negotiationTag}` : ""}`), this.raiseChanged();
                }
                setMediaSession(g, f) {
                    var _g_getAllowedModalities;
                    const S = (g === null || g === void 0 ? void 0 : (_g_getAllowedModalities = g.getAllowedModalities) === null || _g_getAllowedModalities === void 0 ? void 0 : _g_getAllowedModalities.call(g)) || {};
                    this.logger.info(`[${f}][setMediaSession] ${JSON.stringify(S)}`), this.mediaSession = g, g ? this.mediaSessionInitPromise.resolve() : this.mediaSessionInitPromise.reject(new Error("MediaSession is null"));
                }
                isActive() {
                    return this.isAvailable && this.isStreaming;
                }
                getIsModalityDisabled() {
                    return !1;
                }
                constructor(g, f, S){
                    super(f), this.mediaSession = g, this.isAvailable = !1, this.mediaSessionInitPromise = new ct, this.currentIsStreaming = !1, g && this.mediaSessionInitPromise.resolve(), this.id = S, this.logger = f.createChild(`Stream[${this.id}]`);
                }
            }, jr = class extends $r {
            }, Gr = P, qr = class extends $r {
                getStreamOptions() {
                    return this.streamOptions;
                }
                getDiagnosticData() {
                    return JSON.stringify({
                        id: this.id,
                        type: this.type,
                        rank: this.rank,
                        isAvailable: this.isAvailable,
                        isStreaming: this.isStreaming
                    });
                }
                getStats() {
                    const g = this.player.getSnapshotTelemetryReport(), f = {
                        isAvailable: this.isAvailable,
                        isStreaming: this.isStreaming,
                        ...g
                    };
                    return (0, Gr.isEqual)(this.lastStreamStats, f) || (this.streamStatsUpdatedTimestamp = Date.now(), this.lastStreamStats = f), {
                        id: this.id,
                        type: this.type,
                        timestampUpdated: this.streamStatsUpdatedTimestamp,
                        rank: this.rank,
                        ...this.lastStreamStats
                    };
                }
                stop() {
                    return Promise.resolve(void 0);
                }
                async start(g) {
                    if (this.logger.info("[start]: Starting UMS stream"), !this.renderer) {
                        await this.player.configure(this.streamOptions);
                        if (!(await this.player.loadPlayer(g)).setupSucceeded) return this.player.stop(), this.logger.error("[start]: Failed to load UMS player"), Promise.reject("Failed to load UMS player");
                        this.renderer = this.player.getRenderer();
                    }
                    return this.isStreaming = !0, this.renderer;
                }
                sendSnapshotTelemetry() {
                    const g = this.player.getSnapshotTelemetryReport();
                    this.logger.debug(`[sendSnapshotTelemetry] sending snapshot telemetry report: ${JSON.stringify(g)}`);
                    const f = {
                        ...this.callInfo,
                        ...g
                    };
                    this.telemetryLogger.sendEvent({
                        eventName: "live_events",
                        props: f
                    });
                }
                sendTelemetry(g) {
                    if (this.finalTelemetrySent) return;
                    g && (this.finalTelemetrySent = !0);
                    const f = this.player.getTelemetryReport();
                    this.logger.debug(`[sendTelemetry] sending telemetry report: ${JSON.stringify(f)}`);
                    const S = {
                        ...this.callInfo,
                        ...f
                    };
                    this.telemetryLogger.sendEvent({
                        eventName: "live_events",
                        props: S
                    });
                }
                constructor(g, f, S, v, _, C){
                    super(void 0, g, f), this.configProvider = S, this.streamOptions = v, this.telemetryLogger = _, this.callInfo = C, this.type = 2, this.finalTelemetrySent = !1, this.player = new Ot(g.createChild("UmsHydraLiveStreamPlayer"), this.configProvider, this.telemetryLogger), this.isAvailable = !0;
                }
            };
            function toMediaAgentScalingMode(g) {
                switch(g){
                    case 1:
                        return "crop";
                    case 0:
                        return "stretch";
                    default:
                        return "fit";
                }
            }
            var Wr = class extends ze {
                get rendererType() {
                    return 0;
                }
                captureFrame() {
                    if (this.renderer.captureFrame) return this.renderer.captureFrame();
                    throw new Error("Not implemented yet");
                }
                async getStats() {
                    if (this.renderer.getStats) return this.renderer.getStats();
                    throw new Error("Renderer does not support stats");
                }
                async setScalingMode(g) {
                    this.renderer.setScalingMode(toMediaAgentScalingMode(g));
                }
                async cameraAutoControl(g) {
                    throw new Error("Not implemented");
                }
                async getCameraManualControlStates(g) {
                    throw new Error("Not implemented");
                }
                async setCameraManualControlStates(g) {
                    throw new Error("Not implemented");
                }
                async enumerateCameraManualControls() {
                    throw new Error("Not implemented");
                }
                async isCameraAdvancedControlCapable() {
                    throw new Error("Not implemented");
                }
                onVideoSizeChanged(g, f) {
                    this.streamSize = {
                        width: g,
                        height: f
                    }, this.event("videoSizeChanged").raise(g, f), this.raiseChanged();
                }
                constructor(){
                    super(...arguments), this.isRendering = !1, this.frameType = -1;
                }
            }, zr = class extends Wr {
                onVideoSizeChanged(g, f) {
                    this.isRendering = g > 0 && f > 0, super.onVideoSizeChanged(g, f);
                }
                setVideoMirroring(g) {
                    this.renderer.setVideoMirroring(g);
                }
                startVideoAsync() {
                    return this.renderer.startVideoAsync();
                }
                dispose() {
                    this.renderer && (this.renderer.dispose(), this.renderer = null);
                }
                constructor(g, f, S){
                    super(), this.renderer = f.createPreviewRenderer(g, S), this.renderer.on("onVideoSizeChanged", (g, f)=>this.onVideoSizeChanged(g, f));
                }
            }, Kr = class extends Wr {
                toString() {
                    return `rvr:${this.rendererId}`;
                }
                onVideoStateChanged(g) {
                    this.rendererStats.streamStateChanged(g.stream);
                }
                onVideoSizeChanged(g, f) {
                    this.configProvider.config.videoIsRenderingCheck && this.setIsRendering(g > 0 && f > 0), super.onVideoSizeChanged(g, f);
                }
                setIsRendering(g) {
                    this.isRendering !== g && (this.isRendering = g, this.logger.info(`isRendering has changed to ${this.isRendering}`), this.rendererStats.event(this.isRendering ? 5 : 6, this.rendererId), this.isRendering && !this.firstFrameRendered && (this.firstFrameRendered = !0, this.event("firstFrameRendered").raise()));
                }
                onIsRenderingChanged(g) {
                    this.setIsRendering(g), this.raiseChanged();
                }
                subscribeVideoAsync(g) {
                    this.currentVideoStream = g, this.rendererStats.event(1, this.rendererId, g.id);
                    const f = this.renderer.subscribeVideoAsync(g.id, 1 === g.type);
                    return this.subscriptionActive = !0, f.then(()=>{
                        this.rendererStats.event(2, this.rendererId, g.id), this.watchStream(g);
                    }), f;
                }
                watchStream(g) {
                    this.changeSub && this.changeSub.dispose(), this.changeSub = g.changed(()=>{
                        g.isAvailable ? this.subscriptionActive || this.subscribeVideoAsync(g) : (this.subscriptionActive = !1, this.rendererStats.event(3, this.rendererId), this.renderer.unsubscribeNow(), this.rendererStats.event(4, this.rendererId));
                    });
                }
                dispose() {
                    this.renderer && (this.subscriptionActive && (this.rendererStats.event(3, this.rendererId), this.currentVideoStream && !this.currentVideoStream.isAvailable && this.renderer.unsubscribeNow()), this.renderer.dispose(), this.subscriptionActive && this.rendererStats.event(4, this.rendererId), this.renderer = null, this.currentVideoStream = null), this.changeSub && (this.changeSub.dispose(), this.changeSub = null);
                }
                constructor(g, f, S, v, _){
                    super(), this.logger = g, this.target = f, this.rendererStats = v, this.configProvider = _, this.subscriptionActive = !1, this.firstFrameRendered = !1, this.rendererId = v.newRendererId(), this.renderer = S.createRemoteRenderer(f), this.renderer.on("onVideoSizeChanged", (g, f)=>this.onVideoSizeChanged(g, f)), this.renderer.on("onVideoStateChanged", (g)=>this.onVideoStateChanged(g)), this.renderer.on("onIsRenderingChanged", (g)=>this.onIsRenderingChanged(g));
                }
            }, Jr = class extends ze {
                get isDisposed() {
                    return this.isClientDisposed;
                }
                notifyStreamChange() {
                    this.logger.info(`clientId:${this.clientId} - Stream changed`), this.raiseChanged(), this.event("notifiedOnStreamChanged").raise(this.clientId);
                }
                async getMediaStream() {
                    return this.checkDisposed(), this.logger.info(`clientId:${this.clientId} - Stream requested`), this.event("rawStreamRequested").raise(this.clientId), this.getRawStream();
                }
                dispose() {
                    var _this_disposeStream, _this;
                    this.checkDisposed(), (_this_disposeStream = (_this = this).disposeStream) === null || _this_disposeStream === void 0 ? void 0 : _this_disposeStream.call(_this), this.isClientDisposed = !0, this.event("clientDisposed").raise(this.clientId), super.dispose(), this.logger.info(`clientId:${this.clientId} - Raw stream client disposed`);
                }
                checkDisposed() {
                    if (this.isClientDisposed) throw new Error("Raw stream client is already disposed");
                }
                constructor(g, f, S){
                    super(S), this.getRawStream = g, this.disposeStream = f, this.logger = S, this.isClientDisposed = !1, this.clientId = uniqueId();
                }
            }, Yr = class {
                client() {
                    return this.rawBaseClient;
                }
                updateAndNotifyClient(g) {
                    this.rawBaseClient && (this.stream = g, this.rawBaseClient.notifyStreamChange());
                }
                dispose() {
                    this.rawBaseClient = null, this.stream = null;
                }
                constructor(g, f){
                    this.stream = g, this.rawBaseClient = new Jr(async ()=>this.stream, ()=>this.dispose(), f);
                }
            }, Qr = class {
                client() {
                    return this.rawBaseClient;
                }
                createSubscription() {
                    var _this_rawBaseClient;
                    ((_this_rawBaseClient = this.rawBaseClient) === null || _this_rawBaseClient === void 0 ? void 0 : _this_rawBaseClient.isDisposed) ? this.logger.error("createSubscription skipped, raw stream client disposed: stream already exists") : (this.logger.info("createSubscription: Creating new subscription"), this.subscriptionClient = this.subscriptionManager.subscribeVideo(this.modality, this.videoStream.mediaSourceId), this.setClientSubscription(), this.subscriptionActive = !0);
                }
                unsubscribeVideo() {
                    var _this_subscriptionClient, _this_subscriptionClient1;
                    this.logger.info("unsubscribeVideo: Disposing subcription"), (_this_subscriptionClient = this.subscriptionClient) === null || _this_subscriptionClient === void 0 ? void 0 : _this_subscriptionClient.unsubscribe(), (_this_subscriptionClient1 = this.subscriptionClient) === null || _this_subscriptionClient1 === void 0 ? void 0 : _this_subscriptionClient1.dispose(), this.subscriptionClient = null;
                }
                setClientSubscription() {
                    this.logger.info("setClientSubscription: setting onMediaStreamChanged callback"), this.subscriptionClient.setOnMediaStreamChangedHandler(()=>{
                        var _this_rawBaseClient;
                        return (_this_rawBaseClient = this.rawBaseClient) === null || _this_rawBaseClient === void 0 ? void 0 : _this_rawBaseClient.notifyStreamChange();
                    });
                }
                constructor(g, f, S){
                    this.videoStream = g, this.subscriptionManager = f, this.logger = S, this.subscriptionActive = !1, this.modality = 0 === g.type ? Gt.MODALITY.video : Gt.MODALITY.sharing, this.createSubscription(), this.rawBaseClient = new Jr(async ()=>{
                        var _this_subscriptionClient;
                        return (_this_subscriptionClient = this.subscriptionClient) === null || _this_subscriptionClient === void 0 ? void 0 : _this_subscriptionClient.subscribedStream;
                    }, ()=>this.unsubscribeVideo(), S), this.videoStream.changed(()=>{
                        var _this_rawBaseClient;
                        ((_this_rawBaseClient = this.rawBaseClient) === null || _this_rawBaseClient === void 0 ? void 0 : _this_rawBaseClient.isDisposed) || (this.logger.info(`isAvailable: ${g.isAvailable}, subscriptionActive: ${this.subscriptionActive}`), g.isAvailable ? this.subscriptionActive || this.createSubscription() : (this.subscriptionActive = !1, this.unsubscribeVideo()));
                    });
                }
            }, Xr = class {
                dispose() {
                    this.logger.info("dispose"), this.handlerMap.forEach((g)=>g.client().dispose()), this.handlerMap.clear();
                }
                handlerAdded(g) {
                    const f = g.client();
                    f.on("clientDisposed", ()=>this.deleteRawStreamManagerById(f.clientId)), this.handlerMap.set(f.clientId, g);
                }
                deleteRawStreamManagerById(g) {
                    this.handlerMap.delete(g);
                }
                constructor(g){
                    this.logger = g, this.handlerMap = new Map;
                }
            }, Zr = class extends Xr {
                streamChanged(g) {
                    this.handlerMap.forEach((f)=>f.updateAndNotifyClient(g));
                }
                createIRawStreamClient(g, f) {
                    const S = new Yr(g, this.logger);
                    super.handlerAdded(S);
                    const v = S.client();
                    return this.logger.info(`[${f}] - clientId:${v.clientId}, client created`), v;
                }
                updateHandlers(g) {
                    g.forEach((g, f)=>{
                        this.handlerMap.has(f) || this.handlerMap.set(f, g);
                    });
                }
                constructor(g){
                    super(g);
                }
            }, ea = class extends Xr {
                createIRawStreamClient(g, f, S) {
                    const v = new Qr(g, f, this.logger);
                    super.handlerAdded(v);
                    const _ = v.client();
                    return this.logger.info(`[${S}] - clientId:${_.clientId}, client created`), _;
                }
                constructor(g){
                    super(g);
                }
            }, ta = P, ia = class extends $r {
                get mediaSourceId() {
                    return this.id;
                }
                getDiagnosticData() {
                    return JSON.stringify({
                        id: this.id,
                        msi: this.mediaSourceId,
                        rank: this.rank,
                        type: this.type,
                        isAvailable: this.isAvailable,
                        isStreaming: this.isStreaming
                    });
                }
                getStats() {
                    const g = {
                        isAvailable: this.isAvailable,
                        isStreaming: this.isStreaming
                    };
                    return (0, ta.isEqual)(this.lastStreamStats, g) || (this.streamStatsUpdatedTimestamp = Date.now(), this.lastStreamStats = g), {
                        id: this.id,
                        type: this.type,
                        timestampUpdated: this.streamStatsUpdatedTimestamp,
                        msi: this.mediaSourceId,
                        rank: this.rank,
                        ...this.lastStreamStats
                    };
                }
                stop() {
                    return this.mediaSessionInitPromise.reject(new Error("Video stream stopped")), Promise.resolve(void 0);
                }
                getRawStream(g = generateCauseId()) {
                    this.logger.info(`[${g}] - getRawStream called for incoming video stream`);
                    return this.rawIncomingVideoStreamManager.createIRawStreamClient(this, this.mediaSession.getSubscriptionManager(), g);
                }
                start(g, f) {
                    return this.logger.info(`video start: target=${g}, options=${JSON.stringify(f)}`), this.mediaSessionInitPromise.promise.then(()=>{
                        var _this_mediaSession;
                        return new Kr(this.logger.createChild("RemoteVideoRenderer"), g, this.mediaSession, this.rendererStats, (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig());
                    }).then((g)=>(f && g.setScalingMode(f.scalingMode), this.logger.info(`subscribeVideoAsync: videoRenderer=${g}, id=${this.id}`), g.subscribeVideoAsync(this).catch((f)=>{
                            throw g.dispose(), f;
                        }).then(()=>(this.isStreaming = !0, g))));
                }
                update(g, f, S) {
                    this.logger.info(`[${f}][update] stream=${JSON.stringify(g)}`);
                    const v = this.isAvailable;
                    super.update(g, f, S), this.isAvailable && this.isAvailable !== v && this.rendererStats.event(0);
                }
                getIsModalityDisabled() {
                    var _this_mediaSession_getDisabledModalities, _this_mediaSession;
                    return !!((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getDisabledModalities = _this_mediaSession.getDisabledModalities) === null || _this_mediaSession_getDisabledModalities === void 0 ? void 0 : _this_mediaSession_getDisabledModalities.call(_this_mediaSession).video);
                }
                constructor(g, f, S, v){
                    super(g, S, v), this.rendererStats = f, this.rawIncomingVideoStreamManager = new ea(this.logger.createChild(`rawVideoStream, [sourceId:${this.id}]`)), this.type = 0;
                }
            }, na = class extends ia {
                getIsModalityDisabled() {
                    var _this_mediaSession_getDisabledModalities, _this_mediaSession;
                    return !!((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getDisabledModalities = _this_mediaSession.getDisabledModalities) === null || _this_mediaSession_getDisabledModalities === void 0 ? void 0 : _this_mediaSession_getDisabledModalities.call(_this_mediaSession).sharing);
                }
                constructor(g, f, S, v){
                    super(g, f, S, v), this.type = 1;
                }
            }, ra = 1, aa = 2, sa = 3, oa = class _PluginlessCallStreamManager extends ze {
                setMediaSession(g, f) {
                    this.logger.info(`[${f}][setMediaSession]`), this.mediaSession = g;
                    [
                        [
                            this.audio
                        ],
                        this.streams[0],
                        this.streams[1]
                    ].forEach((S)=>S.forEach((S)=>S.setMediaSession(g, f)));
                }
                updateStreams(g, f, S) {
                    this.logger.info(`[${f}][updateStreams]`);
                    const filterAndSortStreams = (f)=>g.filter((g)=>g.type === f).sort(_PluginlessCallStreamManager.compareStreams);
                    let v = filterAndSortStreams(Hr.audio);
                    0 === v.length && (v = filterAndSortStreams(Hr.audioteleconference)), v.length > 0 && (this.audioSourceIds = v.map((g)=>g.sourceId));
                    const _ = v[0];
                    _ && this.audio.update(_, f), this.updateMediaStreams(filterAndSortStreams(Hr.video), 0, f, S), this.updateMediaStreams(filterAndSortStreams(Hr.sharing), 1, f, S);
                }
                hasAudioSource(g) {
                    return this.audioSourceIds.some((f)=>f === g) || this.audio.id === g;
                }
                useUmsStream(g, f, S, v, _, C) {
                    this.logger.info(`[${C}][useUmsStream] Updating ums streams`);
                    const E = this.getUmsInformation(g, v), T = this.streams[2], I = T.filter((g)=>!E.some((f)=>_PluginlessCallStreamManager.compareUmsStreams(g, f)));
                    I.forEach((g)=>(0, Vr.remove)(T, g)), I.length && this.logger.info(`[${C}][useUmsStream] Removing ${I.length} ums streams`), E.forEach((g)=>{
                        let v = T.find((f)=>_PluginlessCallStreamManager.compareUmsStreams(f, g));
                        v || (v = new qr(this.logger.createChild("UmsStream"), this.lastUmsStreamId++, f, g, _, S), this.logger.info(`[${C}][useUmsStream] Adding ums stream with metadata: ${JSON.stringify(g)}`), T.push(v));
                    });
                }
                getUmsStreamMetadata(g, f) {
                    let S = null, v = null;
                    if (S = g.find(function(g) {
                        return "MiddleLaneUltraLowLatency" === g.deliveryPipelineType && f === g.isPrimary;
                    }), S) {
                        const g = S.urls;
                        if (g && g.length > 0) {
                            var _S_decryptionKey, _S_decryptionKey1;
                            S.identifier || this.logger.warn(`[getUmsStreamMetadata]: no ums stream identifier found, isPrimary: ${f}`);
                            const _ = (_S_decryptionKey = S.decryptionKey) === null || _S_decryptionKey === void 0 ? void 0 : _S_decryptionKey.id, C = (_S_decryptionKey1 = S.decryptionKey) === null || _S_decryptionKey1 === void 0 ? void 0 : _S_decryptionKey1.value;
                            _ && C || this.logger.warn(`[getUmsStreamMetadata]: no valid ums stream decryption key found, isPrimary: ${f}`);
                            const E = S.deliveryPipelineType || void 0;
                            v = {
                                url: g[0],
                                streamDeliveryPipeline: E,
                                decryptionKey: _ && C ? {
                                    id: _,
                                    value: C
                                } : null
                            };
                        } else this.logger.info(`[getUmsStreamMetadata]: no ums URLs found, isPrimary: ${f}`);
                    } else this.logger.info(`[getUmsStreamMetadata]: no ums stream information found, isPrimary: ${f}`);
                    return v;
                }
                getUmsInformation(g, f) {
                    const S = [];
                    let v = null, _ = null;
                    for(const f in g){
                        const S = g[f].streams;
                        if (S) {
                            if (v) this.logger.info(`[getUmsInformation]: primary ums stream already found, skipping finding primary stream for participant: ${f}`);
                            else {
                                const g = this.getUmsStreamMetadata(S, !0);
                                g ? v = g : this.logger.info(`[getUmsInformation]: no primary ums stream found for participant: ${f}`);
                            }
                            if (_) this.logger.info(`[getUmsInformation]: alternate ums stream already found, skipping finding alternate stream for participant: ${f}`);
                            else {
                                const g = this.getUmsStreamMetadata(S, !1);
                                g ? _ = g : this.logger.info(`[getUmsInformation]: no alternate ums stream found for participant: ${f}`);
                            }
                        } else this.logger.warn(`[getUmsInformation]: no stream information found for participant: ${f}`);
                    }
                    return (v || _) && S.push({
                        stream: v,
                        altStream: _,
                        threadId: f
                    }), S;
                }
                static compareStreams(g, f) {
                    const S = "sendonly" === g.direction || "sendrecv" === g.direction, v = "sendonly" === f.direction || "sendrecv" === f.direction;
                    return S && !v ? -1 : v && !S ? 1 : f.sourceId - g.sourceId;
                }
                static compareUmsStreams(g, f) {
                    const S = g.getStreamOptions();
                    return _PluginlessCallStreamManager.compareUmsStreamMetadata(S.stream, f.stream) && _PluginlessCallStreamManager.compareUmsStreamMetadata(S.altStream, f.altStream);
                }
                static compareUmsStreamMetadata(g, f) {
                    return !g && !f || !(!g && f || g && !f) && g.decryptionKey.id === f.decryptionKey.id && g.decryptionKey.value === f.decryptionKey.value && g.url === f.url;
                }
                updateMediaStreams(g, f, S, v) {
                    const _ = this.streams[f], C = _.filter((f)=>!g.some((g)=>g.sourceId === f.id));
                    C.forEach((g)=>(0, Vr.remove)(_, g)), C.length && this.logger.info(`[${S}][updateMediaStreams] Removing ${C.length} streams of type ${f}`), g.forEach((C, E)=>{
                        let T = _.find((g)=>g.id === C.sourceId);
                        T || (0 === f ? T = new ia(this.mediaSession, this.localStats.receive(1, this.participantId), this.logger, C.sourceId) : 1 === f && (T = new na(this.mediaSession, this.localStats.receive(2, this.participantId), this.logger, C.sourceId)), this.logger.info(`[${S}][updateMediaStreams] Adding stream ${C.sourceId} of type ${f}`), _.push(T), T.changed(()=>this.event("streamChanged").raise())), T.update(C, S, v), T.rank = g.length - E;
                    });
                }
                constructor(g, f, S, v){
                    var _this_mediaSession_getSessionConfig, _this_mediaSession;
                    super(), this.participantId = g, this.mediaSession = f, this.localStats = S, this.audioSourceIds = [], this.streams = {}, this.lastUmsStreamId = 1;
                    const _ = S.receive(1, g), C = S.receive(2, g);
                    this.audio = new jr(f, v, ra);
                    const E = new ia(f, _, v, aa), T = new na(f, C, v, sa), I = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getSessionConfig = _this_mediaSession.getSessionConfig()) === null || _this_mediaSession_getSessionConfig === void 0 ? void 0 : _this_mediaSession_getSessionConfig.config.participantStreamInitialSubscriptions;
                    I && (E.changed(()=>this.event("streamChanged").raise()), T.changed(()=>this.event("streamChanged").raise())), this.streams[0] = [
                        E
                    ], this.streams[1] = [
                        T
                    ], this.streams[2] = [], this.logger = v.createChild("PluginlessCallStreamManager");
                }
            }, la = {
                0: [
                    1
                ],
                1: [
                    2,
                    6,
                    3,
                    4,
                    5,
                    7,
                    8
                ],
                2: [
                    6,
                    3,
                    4,
                    8
                ],
                3: [
                    1,
                    4,
                    5,
                    8
                ],
                7: [
                    3,
                    4,
                    8
                ],
                4: [],
                5: [
                    3,
                    4,
                    8
                ],
                6: [
                    3,
                    4
                ],
                8: [
                    3,
                    5,
                    4
                ]
            }, ca = {
                0: "Disconnected",
                1: "Connecting",
                2: "Ringing",
                3: "Connected",
                5: "Connected",
                4: "Disconnected",
                7: "Connecting"
            }, da = class extends ze {
                get audio() {
                    return this.streamManager.audio;
                }
                get streams() {
                    return this.streamManager.streams;
                }
                getDiagnosticData() {
                    return JSON.stringify({
                        id: scrubMriOrOmit(this.id),
                        state: this.state,
                        isServerMuted: this.isServerMuted
                    });
                }
                async getDiagnosticDataAsync() {
                    return this.getDiagnosticData();
                }
                isSameParticipantsMri(g) {
                    return this.id === g;
                }
                setMediaSession(g, f = generateCauseId()) {
                    this.streamManager.setMediaSession(g, f);
                }
                applyCachedMediaStreams(g = generateCauseId()) {
                    var _this_cachedMediaStreams;
                    const f = this.logger.createFnLogger("applyCachedMediaStreams", g);
                    ((_this_cachedMediaStreams = this.cachedMediaStreams) === null || _this_cachedMediaStreams === void 0 ? void 0 : _this_cachedMediaStreams.length) ? (f.info("applying cachedMediaStreams"), this.updateStreams(this.cachedMediaStreams, g, !1)) : f.info("cachedMediaStreams is empty");
                }
                updateStreams(g, f = generateCauseId(), S = !1, v) {
                    this.logger.createFnLogger("updateStreams", f).info(`isStreamingMode=${S} mediaStreams=${safeJsonStringify(g)}`), (g === null || g === void 0 ? void 0 : g.length) && (this.cachedMediaStreams = g), S || (this.streamManager.updateStreams(g, f, v), this.raiseChangedDeferred());
                }
                hasAudioSource(g) {
                    return this.streamManager.hasAudioSource(g);
                }
                raiseChangedDeferred() {
                    this._raiseChangeDeferRunner(()=>this.raiseChanged());
                }
                updateIsServerMuted() {
                    if (!Object.values(this.filteredParticipantEndpointDetails).length) return void this._updateIsServerMuted(!1);
                    let g = !1;
                    Object.values(this.filteredParticipantEndpointDetails).forEach((f)=>{
                        var _filterAndSortStreams, _filterAndSortStreams1, _f_endpointState;
                        const filterAndSortStreams = (g)=>{
                            var _f_mediaStreams;
                            return (_f_mediaStreams = f.mediaStreams) === null || _f_mediaStreams === void 0 ? void 0 : _f_mediaStreams.filter((f)=>f.type === g).sort(oa.compareStreams);
                        };
                        let S = (_filterAndSortStreams = filterAndSortStreams(Hr.audio)) === null || _filterAndSortStreams === void 0 ? void 0 : _filterAndSortStreams[0];
                        S || (S = (_filterAndSortStreams1 = filterAndSortStreams(Hr.audioteleconference)) === null || _filterAndSortStreams1 === void 0 ? void 0 : _filterAndSortStreams1[0]);
                        const v = !!(S === null || S === void 0 ? void 0 : S.serverMuted), _ = (_f_endpointState = f.endpointState) === null || _f_endpointState === void 0 ? void 0 : _f_endpointState.state;
                        !1 !== v || !1 !== !!(_ === null || _ === void 0 ? void 0 : _.isMuted) || (g = !0);
                    });
                    const f = !g;
                    this._updateIsServerMuted(f);
                }
                _updateIsServerMuted(g) {
                    g !== this.isServerMuted && (this.isServerMuted = g, this.logger.info(`_updateIsServerMuted updating to: ${this.isServerMuted}`), this.raiseChanged());
                }
                updateVoiceLevel(g) {
                    this.voiceLevel !== g && (this.voiceLevel = g, this.raiseChanged());
                }
                setState(g, f, S) {
                    if (this.state === g) return;
                    const v = this.logger.createFnLogger("setState", S);
                    if (3 === this.state && 6 === g) return void v.info("Ignore Connected->EarlyMedia transition, it is a race between media and signaling");
                    const _ = la[this.state].indexOf(g) >= 0;
                    this.recordTelemetryForStateChange(S, g, f, !_), _ ? (v.info(`state=${this.state}->${g} reason=${this.stateReason}->${f}`), this.state = g, this.stateReason = f, this.raiseChangedDeferred()) : v.logFailure(`Invalid state transition ${this.state}->${g} attempted`);
                }
                processParticipantDetails(g, f, S) {
                    var _g_endpointDetails;
                    const v = this.logger.createFnLogger("processParticipantDetails", "");
                    this.role = g.role, this.meetingRole = g.meetingRole, this.advancedMeetingRole = g.advancedMeetingRole, this.meetingRoles = g.meetingRoles, this.participantType = g.participantType, this.displayName = g.displayName, this.tenantId = g.tenantId, this.propertyBag = g.propertyBag, this.version = g.version, this.otpIdentity = g.otpIdentity, this.isIdentityMasked = !!g.isIdentityMasked, this.nonMaskedId = g.nonMaskedId, this.nonMaskedDisplayName = g.nonMaskedDisplayName, this.nonMaskedObjectId = g.nonMaskedObjectId, this.maskedIdSeqNumber = g.maskedIdSeqNumber, this.maskedId = g.maskedId, this.joinAsStreamingUser = g.joinAsStreamingUser, ((_g_endpointDetails = g.endpointDetails) === null || _g_endpointDetails === void 0 ? void 0 : _g_endpointDetails.length) && (this.endpoints = {
                        endpointDetails: []
                    }, this.participantCapabilities = {
                        canConference: !1,
                        canShareScreen: !1,
                        canMerge: !0
                    }, this.checkIfIncomingServerMutedIsUpdated(g), this.filteredParticipantEndpointDetails = {}, g.endpointDetails.forEach((g)=>{
                        const v = convertSignalingEndpointDetails(g, f);
                        if (this.endpoints.endpointDetails.push(v), !v.mappedTo) {
                            if (this.filteredParticipantEndpointDetails[g.participantId] = {
                                endpointId: g.endpointId,
                                serverMuteVersion: g.serverMuteVersion,
                                endpointState: g.endpointState,
                                mediaStreams: g.mediaStreams
                            }, g.capabilities && (this.participantCapabilities.canConference || "enabled" !== g.capabilities.cloudAudioVideoConference || (this.participantCapabilities.canConference = !0), this.participantCapabilities.canShareScreen || "enabled" !== g.capabilities.cloudScreenSharing || (this.participantCapabilities.canShareScreen = !0), this.participantCapabilities.canMerge || "enabled" !== g.capabilities.cloudMerge || (this.participantCapabilities.canMerge = !0)), this.contentSharingRole = 0, g.contentSharing && g.contentSharing.sessionInformation) {
                                const f = g.contentSharing.sessionInformation;
                                "attendee" === f.role ? this.contentSharingRole = 1 : "presenter" === f.role && (this.contentSharingRole = 2);
                            }
                            v.streamInformation && S && S();
                        }
                    }), this.updateIsServerMuted(), v.info(`endpointDetails=${getPIISafeEndpointDetails(this.endpoints)}`), this.raiseChangedDeferred());
                }
                toCafeParticipant() {
                    return {
                        audioState: ca[this.state],
                        mri: this.mri
                    };
                }
                getSourceIdForMediaType(g) {
                    const f = getSourceIdForMediaType(this, g);
                    return -1 === f && this.logger.warn("getSourceIdForMediaType failed"), f;
                }
                useUmsStream(g, f, S, v, _, C) {
                    this.streamManager.useUmsStream(g, f, S, v, _, C), this.raiseChangedDeferred();
                }
                hasSourceId(g, f) {
                    return void 0 !== getParticipantIdForSourceId(this, g, f);
                }
                constructor(g, f, S, v, _, C = generateCauseId(), E = []){
                    super(S), this.mri = g, this.callTelemetry = _, this.cachedMediaStreams = E, this.state = 0, this.voiceLevel = 0, this.isServerMuted = !1, this.endpointType = "default", this.balanceUpdates = {}, this._raiseChangeDeferRunner = Ur.instance.createDeferRunner("CallParticipant.RaiseChange"), this.filteredParticipantEndpointDetails = {}, this.recordTelemetryForStateChange = (g, f, S, v)=>{
                        if (v) {
                            var _this_endpoints_endpointDetails, _this_endpoints;
                            const v = "_SetParticipantStateInvalid", _ = {
                                state: f,
                                reason: S,
                                endpoints: []
                            };
                            ((_this_endpoints = this.endpoints) === null || _this_endpoints === void 0 ? void 0 : (_this_endpoints_endpointDetails = _this_endpoints.endpointDetails) === null || _this_endpoints_endpointDetails === void 0 ? void 0 : _this_endpoints_endpointDetails.length) && (_.endpoints = getEndpointInformationForTelemetry(this.endpoints.endpointDetails)), this.callTelemetry.recordEvent(v, _, g);
                        }
                    }, this.checkIfIncomingServerMutedIsUpdated = (g)=>{
                        g.endpointDetails.forEach((g)=>{
                            const f = this.filteredParticipantEndpointDetails[g.participantId];
                            void 0 !== f && handleServerMutedVersion(this.logger, f, g);
                        });
                    }, this.handleServerMutedInfoUpdate = (g)=>{
                        let f = !1;
                        for (const S of g){
                            const g = this.filteredParticipantEndpointDetails[S.participantId];
                            handleMuteUnmuteParticipantInfo(this.logger, g, S, !0) && (f = !0);
                        }
                        f && this.updateIsServerMuted();
                    }, this.id = this.mri, this.logger = S.createChild(()=>`ICallParticipant[${scrubMriOrOmit(this.id)}][${this.state}]`), this.logger.info(`[${C}]created`), this.streamManager = new oa(this.id, f, v, this.logger), this.streamManager.on("streamChanged", ()=>this.raiseChanged());
                }
            }, ua = class extends ze {
                get contentSharingStatus() {
                    return this.status;
                }
                set contentSharingStatus(g) {
                    if (this._logger.info(`[set contentSharingStatus][currentStatus=${this.status}][newStatus=${g}]`), this.callTelemetry.recordEvent("_SetContentSharingStatus", {
                        newStatus: g,
                        oldStatus: this.status
                    }), this.status !== g && 7 !== this.status && 8 !== this.status) {
                        if (this._logger.info(`[set contentSharingStatus] Changing content sharing status to: ${g}`), this.status = g, 7 === this.status) {
                            const g = {
                                terminatedReason: 12,
                                terminatedReasonCode: 0,
                                terminatedReasonSubCode: 0,
                                errorMessage: "[set contentSharingStatus] Content sharing is disconnected"
                            };
                            this._callOperationHandler.maybeResolveOperation("StopContentSharing"), this._callOperationHandler.rejectPendingOperations(g);
                        }
                        if (2 === this.status || 5 === this.status) {
                            const g = {
                                terminatedReason: 60,
                                terminatedReasonCode: 0,
                                terminatedReasonSubCode: 0,
                                errorMessage: "Content sharing cannot be ended when not presenting"
                            };
                            this._callOperationHandler.maybeRejectOperation("StopContentSharing", g);
                        }
                        3 === this.status && (this._callOperationHandler.maybeResolveOperation("StartContentSharing"), this._callOperationHandler.maybeResolveOperation("TakeContentSharingControl")), this.raiseChanged();
                    }
                }
                get contentSharingState() {
                    return this.state;
                }
                set contentSharingState(g) {
                    this.state !== g && (this.state = g, this.raiseChanged());
                }
                startContentSharing(g = generateCauseId()) {
                    const f = this._logger.createFnLogger("StartContentSharing", g);
                    if (0 !== this.contentSharingStatus) {
                        const S = `[${g}][startContentSharing][failed][reason=InvalidState]`, v = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: S
                        };
                        return f.logFailure(`state=${this.contentSharingStatus}, reason=${S}`), Promise.reject(v);
                    }
                    return this.signalingSession.startContentSharingAsync(this.contentSharingIdentity, this.contentSharingState, this.subject, this.contentSharingGuid, g).then((g)=>{
                        this.sessionId = g.sessionId, this.contentSharingStatus = 3, this.presenterId = this.signalingSession.participantManager.localParticipant.id;
                    }).catch((S)=>this.handleOperationFailure(S, {
                            causeId: g,
                            operation: "StartContentSharing",
                            updateStatusTo: 8
                        }, f)), this._callOperationHandler.waitForOperation("StartContentSharing");
                }
                joinContentSharing(g = generateCauseId()) {
                    const f = this._logger.createFnLogger("JoinContentSharing", g);
                    if (2 !== this.contentSharingStatus) {
                        const S = `[${g}][joinContentSharing][failed][reason=InvalidState]`, v = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: S
                        };
                        return f.logFailure(`state=${this.contentSharingStatus}, reason=${S}`), Promise.reject(v);
                    }
                    return this.signalingSession.joinContentSharingAsync(this.contentSharingGuid, g).then((g)=>(this.contentSharingStatus = 4, this.contentSharingState = g.sessionState, this.presenterId = g.presenter, Promise.resolve())).catch((S)=>this.handleOperationFailure(S, {
                            causeId: g,
                            operation: "JoinContentSharing",
                            updateStatusTo: 8
                        }, f));
                }
                updateContentSharingSessionState(g, f, S = generateCauseId()) {
                    const v = this._logger.createFnLogger("UpdateContentSharingSessionState", S);
                    if (3 !== this.contentSharingStatus) {
                        const g = `[${S}][updateContentSharingSessionState][failed][reason=InvalidState]`, f = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: g
                        };
                        return v.logFailure(`state=${this.contentSharingStatus}, reason=${g}`), Promise.reject(f);
                    }
                    return this.signalingSession.updateContentSharingSessionStateAsync(this.contentSharingGuid, f, S).then(()=>Promise.resolve()).catch((f)=>this.handleOperationFailure(f, {
                            causeId: S,
                            operation: "UpdateContentSharingSessionState",
                            operationId: g
                        }, v));
                }
                takeContentSharingControl(g = generateCauseId()) {
                    const f = this._logger.createFnLogger("TakeContentSharingControl", g);
                    if (5 !== this.contentSharingStatus) {
                        const S = `[${g}][updateContentSharingSessionState][failed][reason=InvalidState]`, v = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: S
                        };
                        return f.logFailure(`state=${this.contentSharingStatus}, reason=${S}`), Promise.reject(v);
                    }
                    return this.signalingSession.takeContentSharingControlAsync(this.contentSharingGuid, g).then(()=>{
                        this.contentSharingStatus = 3, this.presenterId = this.signalingSession.participantManager.localParticipant.id;
                    }).catch((S)=>this.handleOperationFailure(S, {
                            causeId: g,
                            operation: "TakeContentSharingControl"
                        }, f)), this._callOperationHandler.waitForOperation("TakeContentSharingControl");
                }
                updateContentSharingParticipantStateToViewer(g = generateCauseId()) {
                    const f = this._logger.createFnLogger("UpdateParticipantState", g);
                    if (4 !== this.contentSharingStatus) {
                        const S = `[${g}][updateContentSharingSessionState][failed][reason=InvalidState]`, v = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: S
                        };
                        return f.logFailure(`state=${this.contentSharingStatus}, reason=${S}`), Promise.reject(v);
                    }
                    return this.signalingSession.updateContentSharingParticipantStateAsync(this.contentSharingGuid, g).then(()=>(this.contentSharingStatus = this.presenterId === this.signalingSession.participantManager.localParticipant.id ? 3 : 5, Promise.resolve())).catch((S)=>this.handleOperationFailure(S, {
                            causeId: g,
                            operation: "UpdateParticipantState"
                        }, f));
                }
                stopContentSharing(g = generateCauseId()) {
                    const f = this._logger.createFnLogger("StopContentSharing", g);
                    if (2 === this.contentSharingStatus || 4 === this.contentSharingStatus || 5 === this.contentSharingStatus) {
                        const S = `[${g}][stopContentSharing][failed][reason=InvalidState]`, v = {
                            terminatedReason: 60,
                            terminatedReasonCode: 0,
                            terminatedReasonSubCode: 0,
                            errorMessage: S
                        };
                        return f.logFailure(`state=${this.contentSharingStatus}, reason=${S}`), Promise.reject(v);
                    }
                    return this.signalingSession.deleteContentSharingAsync(this.contentSharingGuid, g).then(()=>(this.contentSharingStatus = 7, this._callOperationHandler.waitForOperation("StopContentSharing"))).catch((S)=>this.handleOperationFailure(S, {
                            causeId: g,
                            operation: "StopContentSharing"
                        }, f));
                }
                dispose(g = generateCauseId()) {
                    const f = {
                        terminatedReason: 12,
                        terminatedReasonCode: 0,
                        terminatedReasonSubCode: 0,
                        errorMessage: "Call ended"
                    };
                    this._callOperationHandler.rejectPendingOperations(f, g), this.contentSharingStatus = 7, this.contentSharingState = "", super.dispose();
                }
                rejectContentSharing(g = {
                    terminatedReason: 12,
                    terminatedReasonCode: 0,
                    terminatedReasonSubCode: 0,
                    errorMessage: "[rejectContentSharing] Content sharing is disconnected"
                }) {
                    if (7 !== this.status && 8 !== this.status) throw new Error(`Tried to reject content sharing with status=${this.status}`);
                    this._callOperationHandler.maybeResolveOperation("StopContentSharing"), this._callOperationHandler.rejectPendingOperations(g);
                }
                getTerminatedReasonFromError(g) {
                    var _g_endCode, _g_endCode1;
                    const f = (g === null || g === void 0 ? void 0 : (_g_endCode = g.endCode) === null || _g_endCode === void 0 ? void 0 : _g_endCode.code) || 0, S = {
                        terminatedReason: 32,
                        terminatedReasonCode: f,
                        terminatedReasonSubCode: (g === null || g === void 0 ? void 0 : (_g_endCode1 = g.endCode) === null || _g_endCode1 === void 0 ? void 0 : _g_endCode1.subCode) || 0,
                        errorMessage: g
                    };
                    switch(f){
                        case Li.NotFound:
                            S.terminatedReason = 34, S.errorMessage = "Active session not found on server";
                            break;
                        case Li.Forbidden:
                            S.terminatedReason = 8, S.errorMessage = "Failed due to insufficient permissions";
                    }
                    return S;
                }
                constructor(g, f, S, v, _, C = "", E, T){
                    super(), this.callTelemetry = g, this.signalingSession = S, this.contentSharingGuid = v, this.contentSharingIdentity = _, this.state = C, this.subject = E, this.handleOperationFailure = (g, f, S)=>{
                        S.logFailure(g);
                        const v = this.getTerminatedReasonFromError(g);
                        return f.updateStatusTo && (this.contentSharingStatus = f.updateStatusTo, this.rejectContentSharing(v)), Promise.reject(v);
                    }, this._logger = f.createChild(()=>`[ContentSharingSession][${this.contentSharingGuid}]`), this.contentSharingStatus = 0, this.contentSharingTerminationReason = null, this.contentSharingState = C, this._callOperationHandler = new ki(this._logger, this.callTelemetry), T && (this.sessionId = T);
                }
            };
            __decorateClass([
                callOperation("StartContentSharing"),
                __decorateParam(0, causeId)
            ], ua.prototype, "startContentSharing", 1), __decorateClass([
                callOperation("JoinContentSharing"),
                __decorateParam(0, causeId)
            ], ua.prototype, "joinContentSharing", 1), __decorateClass([
                callOperation("UpdateContentSharingSessionState"),
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ua.prototype, "updateContentSharingSessionState", 1), __decorateClass([
                callOperation("TakeContentSharingControl"),
                __decorateParam(0, causeId)
            ], ua.prototype, "takeContentSharingControl", 1), __decorateClass([
                callOperation("UpdateParticipantState"),
                __decorateParam(0, causeId)
            ], ua.prototype, "updateContentSharingParticipantStateToViewer", 1), __decorateClass([
                callOperation("StopContentSharing", {
                    waitFor: "StartContentSharing"
                }),
                __decorateParam(0, causeId)
            ], ua.prototype, "stopContentSharing", 1);
            var ha, ga = class {
                constructor(g){
                    this.value = g, this.next = void 0;
                }
            }, pa = class {
                enqueue(g) {
                    const f = new ga(g);
                    this.front ? (this.rear.next = f, this.rear = f) : (this.front = f, this.rear = f), this.length++;
                }
                dequeue() {
                    if (!this.front) return;
                    const g = this.front;
                    return this.front === this.rear ? (this.front = void 0, this.rear = void 0) : this.front = this.front.next, this.length--, g.value;
                }
                peek() {
                    var _this_front;
                    return (_this_front = this.front) === null || _this_front === void 0 ? void 0 : _this_front.value;
                }
                size() {
                    return this.length;
                }
                back() {
                    var _this_rear;
                    return (_this_rear = this.rear) === null || _this_rear === void 0 ? void 0 : _this_rear.value;
                }
                constructor(){
                    this.length = 0;
                }
            }, ma = P, fa = class {
                enqueue(g) {
                    this.heap.push(g), this.bubbleUp();
                }
                dequeue() {
                    const g = this.peek();
                    if (void 0 !== g) {
                        const g = this.heap.pop();
                        this.size() > 0 && (this.heap[0] = g, this.bubbleDown());
                    }
                    return g;
                }
                peek() {
                    return this.heap[0];
                }
                size() {
                    return this.heap.length;
                }
                bubbleUp() {
                    let g = this.size() - 1, f = this.getParentIndex(g);
                    for(; !this.isRoot(g) && this.comparator(this.heap[g], this.heap[f]);)[this.heap[f], this.heap[g]] = [
                        this.heap[g],
                        this.heap[f]
                    ], g = f, f = this.getParentIndex(g);
                }
                bubbleDown() {
                    if (this.size() <= 1) return;
                    let g = this.getRootIndex(), f = this.getLeftIndex(g), S = this.getRightIndex(g);
                    for(; this.heap[f] && this.comparator(this.heap[f], this.heap[g]) || this.heap[S] && this.comparator(this.heap[S], this.heap[g]);)!this.heap[S] || this.comparator(this.heap[f], this.heap[S]) ? ([this.heap[g], this.heap[f]] = [
                        this.heap[f],
                        this.heap[g]
                    ], g = f) : ([this.heap[g], this.heap[S]] = [
                        this.heap[S],
                        this.heap[g]
                    ], g = S), f = this.getLeftIndex(g), S = this.getRightIndex(g);
                }
                getRootIndex() {
                    return 0;
                }
                isRoot(g) {
                    return 0 === g;
                }
                getLeftIndex(g) {
                    return 2 * g + 1;
                }
                getRightIndex(g) {
                    return 2 * g + 2;
                }
                getParentIndex(g) {
                    return Math.floor((g - 1) / 2);
                }
                constructor(g){
                    this.comparator = g, this.heap = [];
                }
            }, Sa = class {
                canSend(g) {
                    if (0 === this.maxDataRate && 0 === this.maxPacketRate) return !0;
                    const f = Kt();
                    if (this.maxPacketRate && this.packetsEndTimeForPacketRate > f + this.rateLimiterCheckInterval) return !1;
                    if (this.maxDataRate && this.packetsEndTimeForBitrate > f + this.rateLimiterCheckInterval) return !1;
                    const S = this.maxPacketRate ? 1e3 / this.maxPacketRate : 0, v = this.maxDataRate ? g.length / this.maxDataRate * 1e3 : 0;
                    return this.packetsEndTimeForPacketRate = Math.max(this.packetsEndTimeForPacketRate, f) + S, this.packetsEndTimeForBitrate = Math.max(this.packetsEndTimeForBitrate, f) + v, !0;
                }
                constructor(g, f, S){
                    this.maxPacketRate = f, this.rateLimiterCheckInterval = S, this.maxDataRate = 0, this.packetsEndTimeForPacketRate = 0, this.packetsEndTimeForBitrate = 0, this.maxDataRate = g / 8;
                }
            }, va = class {
                getMaxBitrate(g) {
                    var _this_dataIds_get;
                    var _this_dataIds_get_maxBitrate;
                    return (_this_dataIds_get_maxBitrate = (_this_dataIds_get = this.dataIds.get(g)) === null || _this_dataIds_get === void 0 ? void 0 : _this_dataIds_get.maxBitrate) !== null && _this_dataIds_get_maxBitrate !== void 0 ? _this_dataIds_get_maxBitrate : this.maxBitrate;
                }
                getMaxPacketRate(g) {
                    var _this_dataIds_get;
                    var _this_dataIds_get_maxPacketRate;
                    return (_this_dataIds_get_maxPacketRate = (_this_dataIds_get = this.dataIds.get(g)) === null || _this_dataIds_get === void 0 ? void 0 : _this_dataIds_get.maxPacketRate) !== null && _this_dataIds_get_maxPacketRate !== void 0 ? _this_dataIds_get_maxPacketRate : this.maxPacketRate;
                }
                getMaxQueueSize(g) {
                    var _this_dataIds_get;
                    var _this_dataIds_get_maxQueueSize;
                    return (_this_dataIds_get_maxQueueSize = (_this_dataIds_get = this.dataIds.get(g)) === null || _this_dataIds_get === void 0 ? void 0 : _this_dataIds_get.maxQueueSize) !== null && _this_dataIds_get_maxQueueSize !== void 0 ? _this_dataIds_get_maxQueueSize : this.maxQueueSize;
                }
                getConfig(g) {
                    const f = this.dataIds.get(g) || {
                        dataId: g
                    };
                    var _f_maxBitrate, _f_maxPacketRate, _f_maxQueueSize, _f_priorityWeight;
                    return f.maxBitrate = (_f_maxBitrate = f.maxBitrate) !== null && _f_maxBitrate !== void 0 ? _f_maxBitrate : this.maxBitrate, f.maxPacketRate = (_f_maxPacketRate = f.maxPacketRate) !== null && _f_maxPacketRate !== void 0 ? _f_maxPacketRate : this.maxPacketRate, f.maxQueueSize = (_f_maxQueueSize = f.maxQueueSize) !== null && _f_maxQueueSize !== void 0 ? _f_maxQueueSize : this.maxQueueSize, f.priorityWeight = (_f_priorityWeight = f.priorityWeight) !== null && _f_priorityWeight !== void 0 ? _f_priorityWeight : 1, f;
                }
                constructor(g){
                    this.dataIds = new Map, this.maxBitrate = g.config.webrtcDataChannel.maxBitrate, this.maxPacketRate = g.config.webrtcDataChannel.maxPacketRate, this.maxQueueSize = g.config.webrtcDataChannel.maxQueueSize, g.config.webrtcDataChannel.dataIds.forEach((g)=>{
                        this.dataIds.set(g.dataId, g);
                    });
                }
            }, _a = class {
                enqueue(g) {
                    if (0 === g.length) return 0;
                    const f = (0, ma.sumBy)(g, (g)=>g.length), S = this.dataIdConfig.maxQueueSize;
                    if (S && this.stats.remainingBytes + f > S) throw new Error(`dataId ${this.dataIdConfig.dataId} send queue is full`);
                    const v = this.getCurrentTime();
                    let _ = 0;
                    return 0 === this.packets.size() ? (this.startTime = v, this.finishTime = v, this.timeOffset = 0, _ = v) : _ = this.finishTime, g.forEach((g)=>{
                        _ += g.length * this.dataIdConfig.priorityWeight, this.packets.enqueue({
                            finishTime: _,
                            packet: g
                        }), this.stats.remainingBytes += g.length, this.stats.remainingPackets++;
                    }), this.finishTime = _, f;
                }
                dequeue() {
                    const g = this.peek();
                    if (void 0 !== g) {
                        if (!this.rateLimiter.canSend(g.packet)) return;
                        this.packets.dequeue(), this.stats.remainingBytes -= g.packet.length, this.stats.remainingPackets--;
                    }
                    return g;
                }
                updateTimeOffset() {
                    this.packets.size() ? this.timeOffset = this.getCurrentTime() - this.startTime : (this.startTime = this.getCurrentTime(), this.finishTime = this.startTime, this.timeOffset = 0);
                }
                peek() {
                    if (0 === this.packets.size()) return;
                    const g = this.packets.peek();
                    return {
                        finishTime: g.finishTime + this.timeOffset,
                        packet: g.packet
                    };
                }
                getConfig() {
                    return this.dataIdConfig;
                }
                getStats() {
                    return (0, ma.clone)(this.stats);
                }
                constructor(g, f, S){
                    this.dataIdConfig = f, this.rateLimiterCheckInterval = S, this.timeOffset = 0, this.packets = new pa, this.startTime = g(), this.finishTime = this.startTime, this.rateLimiter = new Sa(f.maxBitrate, f.maxPacketRate, this.rateLimiterCheckInterval), this.getCurrentTime = g, this.stats = {
                        bufferSize: f.maxQueueSize,
                        remainingBytes: 0,
                        remainingPackets: 0
                    };
                }
            }, Ca = class {
                getPacketsToSend(g) {
                    if (0 === this.virtualTimeQueue.size()) return [];
                    const f = [], S = [];
                    for(; g >= 0 && this.virtualTimeQueue.size();){
                        const v = this.virtualTimeQueue.peek();
                        if (v.size > g) break;
                        this.virtualTimeQueue.dequeue();
                        const _ = v.dataId, C = this.senders.get(_);
                        if (void 0 !== C.peek()) {
                            const v = C.dequeue();
                            if (void 0 !== v) {
                                f.push(v.packet), this.sendStats.remainingBytes -= v.packet.length, g -= v.packet.length, this.sendStats.remainingPackets--, this.currentVirtualClock = Math.max(this.currentVirtualClock, v.finishTime);
                                const S = C.peek();
                                S && this.virtualTimeQueue.enqueue({
                                    dataId: _,
                                    minTime: S.finishTime,
                                    size: S.packet.length
                                });
                            } else S.push(_);
                        }
                    }
                    return S.forEach((g)=>{
                        const f = this.senders.get(g);
                        f.updateTimeOffset();
                        const S = f.peek();
                        S && this.virtualTimeQueue.enqueue({
                            dataId: g,
                            minTime: S.finishTime,
                            size: S.packet.length
                        });
                    }), f;
                }
                appendPackets(g, f) {
                    let S = this.senders.get(g);
                    void 0 === S && (S = new _a(()=>this.currentVirtualClock, this.dataIdConfigManager.getConfig(g), this.rateLimiterCheckInterval), this.senders.set(g, S));
                    const v = S.getStats(), _ = S.enqueue(f);
                    if (this.sendStats.remainingBytes += _, this.sendStats.remainingPackets += f.length, 0 === v.remainingPackets) {
                        const f = S.peek();
                        void 0 !== f && this.virtualTimeQueue.enqueue({
                            dataId: g,
                            minTime: f.finishTime,
                            size: f.packet.length
                        });
                    }
                }
                getStats(g) {
                    if (void 0 === g) return (0, ma.clone)(this.sendStats);
                    const f = this.senders.get(g);
                    return void 0 === f ? {
                        bufferSize: this.dataIdConfigManager.getMaxQueueSize(g),
                        remainingBytes: 0,
                        remainingPackets: 0
                    } : f.getStats();
                }
                constructor(g){
                    this.senders = new Map, this.currentVirtualClock = 0, this.dataIdConfigManager = new va(g), this.virtualTimeQueue = new fa((g, f)=>g.minTime < f.minTime), this.sendStats = {
                        bufferSize: 0,
                        remainingBytes: 0,
                        remainingPackets: 0
                    }, this.rateLimiterCheckInterval = g.config.webrtcDataChannel.rateLimiterCheckInterval;
                }
            }, ya = class {
                recordProtocolEvent(g, f, S) {
                    this.data.protocolCounters[S] || (this.data.protocolCounters[S] = {});
                    const v = this.data.protocolCounters[S];
                    switch(v[g] || (v[g] = {
                        successful: 0,
                        failed: 0,
                        fragmented: 0,
                        dismissed: 0
                    }), f){
                        case 0:
                            v[g].successful++;
                            break;
                        case 1:
                            v[g].failed++;
                            break;
                        case 2:
                            v[g].fragmented++;
                            break;
                        case 3:
                            v[g].dismissed++;
                    }
                }
                recordError(g) {
                    this.data.error = g;
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g){
                    var _g_maxPacketLifeTime, _g_maxRetransmits;
                    this.data = {
                        protocolCounters: {},
                        id: void 0,
                        label: void 0,
                        ordered: void 0,
                        negotiated: void 0
                    }, this.data.id = g.id, this.data.label = g.label, this.data.ordered = g.ordered, this.data.negotiated = g.negotiated, this.data.protocol = g.protocol || void 0, this.data.maxPacketLifeTime = (_g_maxPacketLifeTime = g.maxPacketLifeTime) !== null && _g_maxPacketLifeTime !== void 0 ? _g_maxPacketLifeTime : void 0, this.data.maxRetransmits = (_g_maxRetransmits = g.maxRetransmits) !== null && _g_maxRetransmits !== void 0 ? _g_maxRetransmits : void 0;
                }
            }, Ea = class {
                depacketize(g) {
                    const f = new DataView(g.buffer), S = 63 & f.getUint8(2);
                    if (S !== this.dataId) throw new Error(`Invalid packet dataId: ${this.dataId} !== ${S}`);
                    const v = 11, _ = ((15 & f.getUint8(0)) << 8) + f.getUint8(1), C = 128 & f.getUint8(2), E = f.getUint16(3), T = f.getUint8(5), I = f.getUint32(6), b = f.getUint8(10);
                    if (C) {
                        this.pendingFragments.length && this.logger.warn(`Unfinished message: dataId: ${this.dataId} seqNum: ${E}`), this.remainingPackets = T, 0 !== T && this.diagnostics.recordProtocolEvent("recv", 2, S), this.pendingFragments = [], this.sourceId = I, this.recipients = [];
                        for(let g = 0; g < b; g++){
                            const S = f.getUint32(v + 4 * g);
                            this.recipients.push(S);
                        }
                    } else {
                        if (0 === this.pendingFragments.length) return this.logger.safe.error(`No start flag dataId: ${this.dataId} seqNum: ${E}`), this.diagnostics.recordProtocolEvent("recv", 3, S), null;
                        if (this.nextSeqNum !== E) return this.logger.safe.error(`Invalid sequence number: dataId: ${this.dataId} seqNum: ${E}`), this.diagnostics.recordProtocolEvent("recv", 3, S), null;
                        this.remainingPackets -= 1;
                    }
                    if (this.nextSeqNum = E + 1 & 65535, this.pendingFragments.push(g.slice(_)), 0 === this.remainingPackets) {
                        const g = this.pendingFragments.reduce((g, f)=>g + f.length, 0), f = new Uint8Array(g);
                        let S = 0;
                        for (const g of this.pendingFragments)f.set(g, S), S += g.length;
                        return this.pendingFragments = [], {
                            dataId: this.dataId,
                            sourceId: this.sourceId,
                            data: f,
                            recipients: this.recipients
                        };
                    }
                    return null;
                }
                constructor(g, f, S){
                    this.dataId = g, this.diagnostics = f, this.logger = S, this.pendingFragments = [];
                }
            }, Ta = class {
                packetize(g) {
                    if (g.dataId !== this.dataId) throw new Error(`Invalid dataId: ${this.dataId} !== ${g.dataId}`);
                    const f = 11, S = f + 4 * g.recipients.length, v = new Uint8Array(g.data.length + S), _ = new DataView(v.buffer);
                    _.setUint8(0, 16 + (S >> 8)), _.setUint8(1, 255 & S), _.setUint8(2, 128 | 63 & g.dataId), _.setUint16(3, this.seqNum), _.setUint8(5, 0), _.setUint32(6, g.sourceId), _.setUint8(10, g.recipients.length);
                    for(let S = 0; S < g.recipients.length; S++)_.setUint32(f + 4 * S, g.recipients[S]);
                    return v.set(g.data, S), this.seqNum += 1, [
                        v
                    ];
                }
                constructor(g){
                    this.dataId = g, this.seqNum = 0;
                }
            }, Ia = class {
                packetize(g) {
                    if (g.dataId !== this.dataId) throw new Error(`Invalid dataId: ${this.dataId} !== ${g.dataId}`);
                    const f = 11, S = f + 4 * g.recipients.length, v = [], _ = this.fragmentationSize - S;
                    if (_ < 0) throw new Error(`message dataId: ${this.dataId} payload size: ${S} exceeds limit`);
                    let C = g.data.length ? Math.ceil(g.data.length / _) : 1;
                    const E = C - 1;
                    E > 0 && this.diagnostics.recordProtocolEvent("send", 2, this.dataId);
                    let T = g.data.length, I = !0, b = 0;
                    for(; C > 0;){
                        const A = Math.min(T, _), R = new Uint8Array(A + S), P = new DataView(R.buffer);
                        P.setUint8(0, 16 + (S >> 8)), P.setUint8(1, 255 & S), I ? (I = !1, P.setUint8(2, 128 | 63 & g.dataId)) : P.setUint8(2, 63 & g.dataId), P.setUint16(3, this.seqNum), P.setUint8(5, E), P.setUint32(6, g.sourceId), P.setUint8(10, g.recipients.length);
                        for(let S = 0; S < g.recipients.length; S++)P.setUint32(f + 4 * S, g.recipients[S]);
                        R.set(g.data.slice(b, b + A), S), b += A, v.push(R), this.seqNum += 1, C -= 1, T -= A;
                    }
                    return v;
                }
                constructor(g, f, S){
                    this.dataId = g, this.fragmentationSize = f, this.diagnostics = S, this.seqNum = 0;
                }
            }, ba = class extends Bt {
                getDataIdStats(g) {
                    var _this_sendScheduler;
                    return (_this_sendScheduler = this.sendScheduler) === null || _this_sendScheduler === void 0 ? void 0 : _this_sendScheduler.getStats(g);
                }
                get state() {
                    return this.stateInternal;
                }
                set sourceId(g) {
                    this.sourceIdInternal = g;
                }
                setDataChannel(g) {
                    this.dataChannel && (this.logger.info(`Replacing internal data channel ${this.label}:${this.dataChannel.id} with ${g.label}:${g.id} with settings ${stringifyObject(this.getDataChannelSettings(g))}`), this.unsubscribeOnDataChannelEvents(), this.dataChannel.close()), this.dataChannel = g, this.diagnostics = this.sessionDiagnostics.newDataChannelDiagnostics(g), this.subscribeOnDataChannelEvents();
                }
                dispose() {
                    this.logger.info("dispose"), this.dataChannel && (this.logger.info(`dataChannel.close ${this.dataChannel.id}`), this.unsubscribeOnDataChannelEvents(), this.dataChannel.close(), this.dataChannel = null, this.setState("Destroyed"), super.dispose());
                }
                sendMessage(g, f = this.sourceIdInternal, S, v = []) {
                    try {
                        this.packetizers.has(g) || (this.fragmentationSize ? this.packetizers.set(g, new Ia(g, this.fragmentationSize, this.diagnostics)) : this.packetizers.set(g, new Ta(g)));
                        const _ = this.packetizers.get(g).packetize({
                            dataId: g,
                            sourceId: f,
                            data: S,
                            recipients: v
                        });
                        void 0 !== this.sendScheduler ? (this.sendScheduler.appendPackets(g, _), this.scheduleSend()) : _.forEach((g)=>{
                            this.dataChannel.send(g);
                        }), this.diagnostics.recordProtocolEvent("send", 0, g);
                    } catch (f) {
                        throw this.logger.unsafe.warn(`Failed to construct protocol message: ${stringifyObject(f)}`), this.diagnostics.recordProtocolEvent("send", 1, g), f;
                    }
                }
                scheduleSend() {
                    if ("Connected" !== this.state) return;
                    const sendPacket = (g)=>{
                        try {
                            this.dataChannel.send(g);
                        } catch (g) {
                            return this.logger.unsafe.warn(`Failed to send message: ${stringifyObject(g)}`), !1;
                        }
                        return !0;
                    };
                    if (this.dataChannel.bufferedAmount <= this.dataChannel.bufferedAmountLowThreshold) {
                        const g = Date.now();
                        let f = this.bufferedAmountHighThreshold - this.dataChannel.bufferedAmount;
                        for(; this.pendingPackets.size();){
                            const g = this.pendingPackets.peek();
                            if (g.length > f) break;
                            if (!sendPacket(g)) break;
                            this.pendingPackets.dequeue(), f -= g.length;
                        }
                        if (0 === this.pendingPackets.size() && f > 0) {
                            const g = this.sendScheduler.getPacketsToSend(f);
                            for (const f of g)if (!1 === sendPacket(f) && !1 === this.discardOnSendFailure) {
                                this.pendingPackets.enqueue(f);
                                break;
                            }
                        }
                        if (this.dataChannel.bufferedAmount <= this.dataChannel.bufferedAmountLowThreshold) {
                            if (this.sendScheduleTimer) return;
                            if (this.sendScheduler.getStats().remainingPackets > 0) {
                                const f = Math.max(g + this.rateLimiterCheckInterval - Date.now(), 20);
                                this.sendScheduleTimer = window.setTimeout(()=>{
                                    this.sendScheduleTimer = 0, this.scheduleSend();
                                }, f);
                            }
                        }
                    }
                }
                subscribeOnDataChannelEvents() {
                    this.dataChannel.binaryType = "arraybuffer", this.dataChannel.onmessage = (g)=>{
                        const f = new Uint8Array(g.data), S = 63 & f[2];
                        try {
                            this.depacketizers.has(S) || this.depacketizers.set(S, new Ea(S, this.diagnostics, this.logger));
                            const g = this.depacketizers.get(S).depacketize(f);
                            g && (this.diagnostics.recordProtocolEvent("recv", 0, S), this.event("onmessage").raise(S, g.sourceId, g.data));
                        } catch (g) {
                            this.logger.unsafe.warn(`Failed to parse incoming message: ${stringifyObject(g)}`), this.diagnostics.recordProtocolEvent("recv", 1, S);
                        }
                    }, this.dataChannel.onerror = (g)=>{
                        var _g_error;
                        const f = g === null || g === void 0 ? void 0 : g.target, S = stringifyObject((_g_error = g === null || g === void 0 ? void 0 : g.error) !== null && _g_error !== void 0 ? _g_error : g);
                        this.logger.safe.warn(`onerror: label:${f.label} id:${f.id} ${S} `), this.diagnostics.recordError(S);
                    }, "open" === this.dataChannel.readyState && this.dataChannel.id % 2 == 0 && (this.logger.safe.info(`readyState is already 'open' label:${this.dataChannel.label} id:${this.dataChannel.id}`), this.setState("Connected")), this.dataChannel.onopen = (g)=>{
                        const f = g.target;
                        this.logger.safe.info(`onopen label:${f.label} id:${f.id}`), f.id % 2 == 0 && this.setState("Connected");
                    }, this.dataChannel.onclose = (g)=>{
                        const f = g.target;
                        this.logger.safe.info(`onclose label:${f.label} id:${f.id}`), this.setState("Closed");
                    }, this.dataChannel.onclosing = (g)=>{
                        const f = g.target;
                        this.logger.safe.debug(`onclosing label:${f.label} id:${f.id}`), this.setState("Closed");
                    }, void 0 !== this.sendScheduler && (this.dataChannel.bufferedAmountLowThreshold = this.bufferedAmountLowThreshold, this.dataChannel.onbufferedamountlow = ()=>{
                        this.scheduleSend();
                    });
                }
                unsubscribeOnDataChannelEvents() {
                    this.dataChannel.onmessage = null, this.dataChannel.onerror = null, this.dataChannel.onopen = null, this.dataChannel.onclose = null, this.dataChannel.onclosing = null, this.dataChannel.onbufferedamountlow = null;
                }
                setState(g) {
                    this.stateInternal = g, this.event("onStateChanged").raise(), "Connected" === g && void 0 !== this.sendScheduler && this.scheduleSend();
                }
                getDataChannelSettings(g) {
                    return {
                        ordered: g.ordered,
                        maxRetransmits: g.maxRetransmits,
                        maxPacketLifeTime: g.maxPacketLifeTime
                    };
                }
                constructor(g, f, S, v){
                    super(), this.dataChannel = g, this.sessionDiagnostics = f, this.stateInternal = "Created", this.packetizers = new Map, this.depacketizers = new Map, this.sendScheduleTimer = 0, this.pendingPackets = new pa, this.sourceIdInternal = bi, this.label = g.label, this.diagnostics = this.sessionDiagnostics.newDataChannelDiagnostics(g), this.logger = S.createChild(`[WebRtcDataChannel ${this.label}]`), this.logger.safe.info(`Created with settings ${stringifyObject(this.getDataChannelSettings(g))}`), this.bufferedAmountLowThreshold = v.config.webrtcDataChannel.bufferedAmountLowThreshold, this.bufferedAmountHighThreshold = v.config.webrtcDataChannel.bufferedAmountHighThreshold, this.fragmentationSize = v.config.webrtcDataChannel.enableFragmentation ? v.config.webrtcDataChannel.fragmentationSize : 0, v.config.webrtcDataChannel.enableSendScheduler && (this.sendScheduler = new Ca(v)), this.rateLimiterCheckInterval = v.config.webrtcDataChannel.rateLimiterCheckInterval, this.discardOnSendFailure = v.config.webrtcDataChannel.discardOnSendFailure, this.subscribeOnDataChannelEvents();
                }
            }, Aa = "main-channel", Ra = class extends Bt {
                get state() {
                    return this._state;
                }
                getDataChannel(g) {
                    if (!this.dataChannel) {
                        this.logger.safe.info(`[${g}] creating new dataChannel`);
                        try {
                            const g = this.configProvider.config.dataChannelDebugInitSettings || {};
                            this.dataChannel = new ba(this.pc.createDataChannel(Aa, g), this.diagnostics, this.logger, this.configProvider), this.subscribeForDataChannelEvents();
                        } catch (f) {
                            const S = stringifyObject(f);
                            return this.logger.safe.error(`[${g}] createDataChannel failed: ${S}`), this.diagnostics.createChannelFailReason = S, this.setState("Failed"), null;
                        }
                    }
                    return this.dataChannel;
                }
                updateDataModalityState(g) {
                    "Failed" !== this._state && "Disabled" !== this._state && (g === Gt.MEDIA_STATE.sendReceive ? this.setState("Active") : g === Gt.MEDIA_STATE.inactive && this.setState("Inactive"));
                }
                disable() {
                    this.setState("Disabled");
                }
                dispose() {
                    this.stopDataChannel(), this.pc = null, super.dispose();
                }
                subscribeOnDatachannel() {
                    this.pc.ondatachannel = (g)=>{
                        this.onDataChannel(g.channel);
                    };
                }
                onDataChannel(g) {
                    this.logger.safe.info(`onDataChannel id=${g.id} label=${g.label}`), g.id % 2 == 0 ? this.dataChannel ? (this.logger.safe.info("Found existing data channel, replacing"), this.dataChannel.setDataChannel(g)) : (this.dataChannel = new ba(g, this.diagnostics, this.logger, this.configProvider), this.subscribeForDataChannelEvents()) : this.logger.safe.info(`onDataChannel ignoring id ${g.id}`);
                }
                subscribeForDataChannelEvents() {
                    this.dataChannel.on("onStateChanged", ()=>{
                        "Closed" === this.dataChannel.state && (this.stopDataChannel(), this.setState("Inactive"));
                    });
                }
                setState(g) {
                    if (this._state !== g) {
                        this.diagnostics.dataChannelSessionState = g;
                        const f = generateCauseId();
                        this._state = g, this.logger.safe.info(`[${f}] SessionDataChannelState changed, state=${this._state}`), "Inactive" === this._state || "Disabled" === this._state ? this.stopDataChannel() : "Active" === this._state && this.getDataChannel(f), this.event("onStateChanged").raise(this._state);
                    }
                }
                stopDataChannel() {
                    this.dataChannel && (this.logger.safe.info("stopDataChannel"), this.dataChannel.dispose(), this.dataChannel = null);
                }
                constructor(g, f, S, v){
                    const _ = S.createChild("PluginlessDataChannel");
                    super(_), this.pc = g, this.diagnostics = f, this.configProvider = v, this._state = "Inactive", this.logger = _, this.subscribeOnDatachannel();
                }
            }, Pa = class extends ze {
                get state() {
                    return this._state;
                }
                registerSessionDataChannel(g, f) {
                    this.sessionDataChannel && this.stop(f), this.sessionDataChannel = g, this.subscribeForSessionDataChannelEvents();
                }
                setDataChannelSourceId(g) {
                    this.logger.debug(`setDataChannelSourceId ${g}`), this.mainChannel && (this.mainChannel.sourceId = g), this.sourceId = g;
                }
                requestDataChannelHandler(g) {
                    return this.sessionDataChannel.getDataChannel(g);
                }
                async sendUserEvents(g, f) {
                    if (!this.mainChannel) throw this.logger.info("sendUserEvents() no data channel available"), new Error("Main DataChannel is not active");
                    {
                        const S = f ? f.map((g)=>parseInt(g, 10)) : [];
                        this.mainChannel.sendMessage(0, this.sourceId, (new TextEncoder).encode(g), S);
                    }
                }
                async addHandler(g, f) {
                    var _this_mainChannel;
                    if (this.logger.info(`Adding handler with dataId ${g}`), this.dataHandlers.get(g)) throw new Error(`Data Id ${g} is already registered`);
                    const S = {
                        isStarted: !1,
                        handler: f
                    };
                    this.dataHandlers.set(g, S), this.recordDataHandlerEvent(g, "added"), "Connected" === ((_this_mainChannel = this.mainChannel) === null || _this_mainChannel === void 0 ? void 0 : _this_mainChannel.state) && this.startHandler(g, S);
                }
                async removeHandler(g) {
                    if (this.logger.info(`Removing handler with dataId ${g}`), !this.dataHandlers.has(g)) throw new Error(`Handler associated with Data Id ${g} is not attached`);
                    const f = this.dataHandlers.get(g);
                    f.isStarted && this.stopHandler(g, f), this.dataHandlers.delete(g);
                }
                async updateNegotiationTag(g) {}
                getTelemetry() {
                    if (!this.dataHandlerTelemetry.size) return "";
                    const g = {};
                    for (const [f, S] of this.dataHandlerTelemetry)g[f] = S;
                    return JSON.stringify(g);
                }
                start(g) {
                    this.mainChannel ? this.logger.info(`[${g}] already started`) : (this.logger.info(`[${g}] starting`), this.mainChannel = this.sessionDataChannel.getDataChannel(g), this.subscribeForMainDataChannelEvents());
                }
                stop(g) {
                    this.mainChannel && (this.logger.info(`[${g}] stopping`), this.mainChannel.dispose(), this.mainChannel = null);
                }
                dispose() {
                    this.stop(void 0), this.sessionDataChannel = null, super.dispose();
                }
                setConfigProviderView(g) {
                    this.configProviderView = g;
                }
                subscribeForMainDataChannelEvents() {
                    this.mainChannel.on("onmessage", (g, f, S)=>{
                        this.dataHandlers.has(g) && (this.recordDataHandlerEvent(g, "recvd"), this.dataHandlers.get(g).handler.onDataReceived(g, S, f)), this.event("remoteUserEventsReceived").raise(g.toString(), (new TextDecoder).decode(S));
                    }), this.onMainChannelStateChanged(), this.mainChannel.on("onStateChanged", ()=>this.onMainChannelStateChanged());
                }
                onMainChannelStateChanged() {
                    if (this.mainChannel) switch(this.mainChannel.state){
                        case "Connected":
                            this.startHandlers();
                            break;
                        case "Closed":
                        case "Destroyed":
                            this.stopHandlers();
                    }
                }
                startHandlers() {
                    for (const [g, f] of this.dataHandlers.entries())f.isStarted || this.startHandler(g, f);
                }
                stopHandlers() {
                    for (const [g, f] of this.dataHandlers.entries())f.isStarted && this.stopHandler(g, f);
                }
                startHandler(g, f) {
                    this.logger.info(`Starting dataHandler id: ${g}`), f.handler.onStarted(g, (f, S)=>(this.recordDataHandlerEvent(g, "sent"), this.sendMessage(g, f, S)), ()=>{
                        var _this_mainChannel;
                        const f = (_this_mainChannel = this.mainChannel) === null || _this_mainChannel === void 0 ? void 0 : _this_mainChannel.getDataIdStats(g);
                        if (void 0 !== f) {
                            const g = {
                                bufferSize: f.bufferSize,
                                remainingBytes: f.remainingBytes,
                                remainingPackets: f.remainingPackets
                            };
                            return Promise.resolve(g);
                        }
                        return Promise.reject(new Error(`Stats of dataId ${g} is not available`));
                    }), f.isStarted = !0, this.recordDataHandlerEvent(g, "started");
                }
                stopHandler(g, f) {
                    this.logger.info(`Stopping dataHandler id: ${g}`), f.handler.onStopped(g), f.isStarted = !1, this.recordDataHandlerEvent(g, "removed");
                }
                subscribeForSessionDataChannelEvents() {
                    this.sessionDataChannel.on("onStateChanged", (g)=>{
                        const f = generateCauseId();
                        switch(g){
                            case "Active":
                                this.start(f), this.setState("Active");
                                break;
                            case "Inactive":
                                this.stop(f), this.setState("Inactive");
                                break;
                            case "Failed":
                                this.stop(f), this.setState("Failed");
                                break;
                            case "Disabled":
                                this.stop(f), this.setState("Disabled");
                                break;
                            default:
                                this.logger.warn(`[${f}] unhandled SessionDataChannelState ${g}`);
                        }
                    });
                }
                recordDataHandlerEvent(g, f) {
                    this.dataHandlerTelemetry.has(g) || this.dataHandlerTelemetry.set(g, [
                        {}
                    ]);
                    const S = this.dataHandlerTelemetry.get(g);
                    let v = S[S.length - 1];
                    if ("added" === f && void 0 !== v.added) {
                        var _this_configProviderView;
                        v = {}, S.push(v);
                        var _this_configProviderView_config_maxStoredDataChannelValues;
                        const g = (_this_configProviderView_config_maxStoredDataChannelValues = (_this_configProviderView = this.configProviderView) === null || _this_configProviderView === void 0 ? void 0 : _this_configProviderView.config.maxStoredDataChannelValues) !== null && _this_configProviderView_config_maxStoredDataChannelValues !== void 0 ? _this_configProviderView_config_maxStoredDataChannelValues : 15;
                        S.length > g && S.shift();
                    }
                    switch(f){
                        case "added":
                        case "started":
                        case "removed":
                            v[f] = Date.now() - this.startTime;
                            break;
                        case "recvd":
                        case "sent":
                            v[f] = isNaN(v[f]) ? 1 : v[f] + 1;
                    }
                }
                setState(g) {
                    this._state !== g && (this._state = g, this.logger.info(`PluginlessDataChannelState changed, state=${this._state}`), this.event("onDataChannelStateUpdated").raise(this._state));
                }
                constructor(g){
                    super(), this.mainChannel = null, this.sourceId = bi, this._state = "Inactive", this.dataHandlers = new Map, this.dataHandlerTelemetry = new Map, this.startTime = Date.now(), this.sendMessage = async (g, f, S)=>{
                        if (!this.mainChannel || "Connected" !== this.mainChannel.state || "Active" !== this.state) throw new Error("No active data channel to send data from");
                        this.mainChannel.sendMessage(g, this.sourceId, f, S);
                    }, this.logger = g.createChild("PluginlessDataChannel");
                }
            }, wa = __toESM(Ie());
            ((g)=>{
                const f = 7, S = 3;
                function encodeMouseEvent(g) {
                    if (!g) return new Uint8Array(0);
                    g.buttonType || (g.buttonType = 0), g.xPos || (g.xPos = 0), g.yPos || (g.yPos = 0), g.wheelRotation || (g.wheelRotation = 0);
                    const S = new ArrayBuffer(f), v = new DataView(S), _ = (3 & g.type) << 0, C = (7 & g.buttonType) << 2, E = (g.buttonDown ? 1 : 0) << 5, T = (g.wheelButtonDown ? 1 : 0) << 6, I = 0;
                    return v.setUint8(0, 1), v.setUint8(1, _ | C | E | T | I), v.setUint16(2, g.xPos, !0), v.setUint16(4, g.yPos, !0), v.setUint8(6, g.wheelRotation), new Uint8Array(S);
                }
                function encodeKeyboardEvent(g) {
                    const f = new ArrayBuffer(S), v = new DataView(f), _ = (3 & g.codeType) << 0, C = 0, E = (g.keyUp ? 1 : 0) << 4, T = (g.repeat ? 1 : 0) << 5, I = 0, b = 0;
                    return v.setUint8(0, 0), v.setUint8(1, _ | C | E | T | I | b), v.setUint8(2, g.code), new Uint8Array(f);
                }
                function decodeEventType(g) {
                    return g[0];
                }
                function decodeMouseEvent(g) {
                    if (1 !== g[0] || g.length !== f) return null;
                    const S = new DataView(g.buffer), v = S.getUint8(1);
                    return {
                        type: 3 & v,
                        buttonType: v >> 2 & 7,
                        buttonDown: !!(v >> 5 & 1),
                        wheelButtonDown: !!(v >> 6 & 1),
                        xPos: S.getUint16(2, !0),
                        yPos: S.getUint16(4, !0),
                        wheelRotation: S.getUint8(6)
                    };
                }
                function decodeKeyboardEvent(g) {
                    if (0 !== g[0] || g.length !== S) return null;
                    const f = new DataView(g.buffer), v = f.getUint8(1);
                    return {
                        codeType: 3 & v,
                        code: f.getUint8(2),
                        repeat: !!(v >> 5 & 1),
                        keyUp: !!(v >> 4 & 1)
                    };
                }
                g.encodeMouseEvent = encodeMouseEvent, g.encodeKeyboardEvent = encodeKeyboardEvent, g.decodeEventType = decodeEventType, g.decodeMouseEvent = decodeMouseEvent, g.decodeKeyboardEvent = decodeKeyboardEvent;
            })(ha || (ha = {}));
            var Ma = P, Oa = R, Da = 3e4, Na = 1e4, ka = 2e3, La = 6, Fa = "", xa = class extends yi {
                setCallId(g) {
                    this.callId = g;
                }
                setEndpointId(g) {
                    this.endpointId = g;
                }
                setParticipantId(g) {
                    this.participantId = g;
                }
                setTenantId(g) {
                    this.tenantId = g;
                }
                setUserHexCID(g) {
                    this.userHexCID = g;
                }
                callStateChanged(g) {
                    this.recordEvent("CallState", {
                        state: g
                    });
                }
                dataChannelAvailable(g) {
                    g ? this.recordEvent("DataChannelAvailable") : this.recordEvent("DataChannelUnavailable");
                }
                shutdownSession(g) {
                    this.negotiationTag && this.negotiationTag !== g ? this.recordEvent("ShutdownByOtherSession", null, g) : this.recordEvent("Shutdown");
                }
                recordProtocolMessage(g, f) {
                    g || (f in this.messagesFromUnknownSender || (this.messagesFromUnknownSender[f] = 0), this.messagesFromUnknownSender[f]++);
                }
                constructor(g, f, S, v, _, C){
                    super(g, f, ()=>this.recordedEvents.length > 100), this.negotiationTag = S, this.callId = v, this.participantId = _, this.endpointId = C, this.messagesFromUnknownSender = {}, this.tsCallingVersion = getTsCallingVersion();
                }
            }, Ua = class extends xa {
                startHandshake(g) {
                    this.recordOperation("AvailableHandshake", g);
                }
                delayHandshakeSending(g, f, S) {
                    const v = {
                        delay: f,
                        maxDelay: S
                    };
                    this.updateOperationData("AvailableHandshake", v, g);
                }
                handshakeSucceeded(g, f) {
                    const S = {
                        retries: f
                    };
                    this.recordOperationSuccess("AvailableHandshake", S, null, g);
                }
                handshakeFailed(g, f, S) {
                    const v = {
                        retries: f,
                        reason: toAvailableHandshakeTerminatedString(S)
                    };
                    this.recordOperationFailure("AvailableHandshake", v, null, g);
                }
                requestControl(g) {
                    this.recordOperation("ControlRequest", g, g);
                }
                requestControlAccepted(g) {
                    this.recordOperationSuccess("ControlRequest", g, g);
                }
                requestControlRejected(g, f) {
                    const S = {
                        reason: toControlTerminatedReason(f)
                    };
                    2 === f ? this.recordOperationTimeout("ControlRequest", S, g, g) : this.recordOperationFailure("ControlRequest", S, g, g);
                }
                controlGiven(g, f) {
                    this.recordEvent("ControlGiven", {
                        sharerSourceId: f
                    }, g);
                }
                controlTerminated(g, f, S) {
                    const v = {
                        sharerSourceId: S,
                        reason: toControlTerminatedReason(f)
                    };
                    this.recordEvent("ControlTerminated", v, g);
                }
                getEvent(g, f) {
                    const getValue2 = (g)=>void 0 === g ? "" : g;
                    return {
                        CorrelationId: getValue2(this.callId),
                        ParticipantId: getValue2(this.participantId),
                        EndpointId: getValue2(this.endpointId),
                        NegotiationTag: getValue2(this.negotiationTag),
                        TsCallingVersion: getValue2(this.tsCallingVersion),
                        TenantId: getValue2(this.tenantId),
                        SharerParticipantId: getValue2(this.sharerParticipantId),
                        SharerClientVersion: getValue2(this.sharerClientVersion),
                        EventTimestampBag: super.getEventTimestampBag(g, f),
                        ProtocolMessages: JSON.stringify({
                            UnknownSender: this.messagesFromUnknownSender
                        })
                    };
                }
                constructor(g, f, S, v, _, C, E){
                    super(g, f, S, v, _, C);
                    const T = getSharingParticipantLeg(E);
                    if (T) {
                        this.sharerParticipantId = T;
                        const g = (0, Ma.find)(E.endpoints.endpointDetails, (g)=>g.participantId === T);
                        g && (this.sharerClientVersion = g.clientVersion);
                    }
                }
            }, Va = class extends xa {
                availableAckChanged(g) {
                    g ? this.recordEvent("AvailableAckEnabled") : this.recordEvent("AvailableAckDisabled");
                }
                controlRequest(g, f) {
                    this.recordOperation("ControlRequest", g, g);
                }
                controlRequestAccept(g, f) {
                    const S = {
                        status: "accepting",
                        participantId: f
                    };
                    this.updateOperationData("ControlRequest", S, g, g);
                }
                controlRequestAccepted(g, f) {
                    const S = {
                        participantId: f
                    };
                    this.recordOperationSuccess("ControlRequest", S, g, g);
                }
                controlRequestRejected(g, f, S) {
                    const v = {
                        reason: toControlTerminatedReason(f),
                        participantId: S
                    };
                    4 === f ? this.recordOperationTimeout("ControlRequest", v, g, g) : this.recordOperationFailure("ControlRequest", v, g, g);
                }
                giveControl(g, f) {
                    this.recordOperation("GiveControl", g, g);
                }
                giveControlSucceeded(g, f) {
                    const S = {
                        participantId: f
                    };
                    this.recordOperationSuccess("GiveControl", S, g, g);
                }
                giveControlFailed(g, f) {
                    const S = {
                        reason: toControlTerminatedReason(f)
                    };
                    4 === f ? this.recordOperationTimeout("GiveControl", S, g, g) : this.recordOperationFailure("GiveControl", S, g, g);
                }
                controlTerminated(g, f, S) {
                    const v = {
                        controllerSourceId: S,
                        reason: toControlTerminatedReason(f)
                    };
                    this.recordEvent("ControlTerminated", v, g);
                }
                getEvent(g, f) {
                    const getValue2 = (g)=>void 0 === g ? "" : g;
                    return {
                        CorrelationId: getValue2(this.callId),
                        ParticipantId: getValue2(this.participantId),
                        EndpointId: getValue2(this.endpointId),
                        NegotiationTag: getValue2(this.negotiationTag),
                        TsCallingVersion: getValue2(this.tsCallingVersion),
                        TenantId: getValue2(this.tenantId),
                        EventTimestampBag: this.getEventTimestampBag(g, f),
                        ProtocolMessages: JSON.stringify({
                            UnknownSender: this.messagesFromUnknownSender
                        })
                    };
                }
                constructor(g, f, S, v, _, C){
                    super(g, f, S, v, _, C);
                }
            }, Ba = class extends ze {
                setAdapters(g, f, S) {
                    this._controlInjector = g, this._rendererAdapter = f, this._dataChannelAdapter = S, this._dataChannelAdapter.on("stateChange", (g)=>{
                        this._onDataChannelStatusChanged(g);
                    }), this._dataChannelAdapter.on("protocolMessage", (g, f, S, v)=>this.processProtocolMessage(g, f, S, v)), this._dataChannelAdapter.on("controlMessage", (g, f)=>this.processControlMessage(g, f));
                }
                testSetControlInjector(g) {}
                enableScreenSharingControl(g, f, S, v) {
                    if (this._logger.info(`enableScreenSharingControl() enabled=${g} disabledReason=${f}`), this._availableAckEnabled !== g || this._allowControlForUser !== v) {
                        if (this._allowControlForUser = v, g) this._raiseScreenSharingControlCapableEvent(!0, Fa);
                        else {
                            if (0 === f) {
                                const g = {
                                    reason: 2,
                                    detail: S
                                };
                                this.event("sharingControlError").raise(g);
                            }
                            this._raiseScreenSharingControlCapableEvent(!1, Fa);
                        }
                        this._availableAckEnabled !== g && this._recordSharerSessionTelemetry((f)=>f.availableAckChanged(g), !1), this._availableAckEnabled = g;
                    }
                }
                _canEnableGiveControl() {
                    return this._controlInjector.canBeEnabled();
                }
                setRaiseRenderedAtViewer(g) {
                    this._raiseRenderedAtViewer = g;
                }
                setScreenSharingControlFeatureFlag(g, f) {
                    this._logger.info(`setScreenSharingControlFeatureFlag() enabled=${g} clientConfiguration=${JSON.stringify(f)}`), this._enabled = g, this._availableAckEnabled = g, this._clientConfiguration = {
                        ...f
                    }, this._enabled && this._handleCallState(this._callState);
                }
                isScreenSharingControlEnabled() {
                    return this._enabled;
                }
                isInternalViewerControlEnabled() {
                    return !this._clientConfiguration.externalViewerControlInitialization;
                }
                isInternalSharerControlEnabled() {
                    return !this._clientConfiguration.externalSharerControlInitialization;
                }
                _disposeRenderer(g) {
                    this._disposeControlCapturer(g);
                    for (const g of this._screenSharingVideoRendererSubscriptions)g.dispose();
                    this._screenSharingVideoRendererSubscriptions = [], this._screenSharingVideoRenderer = null;
                }
                setRenderer(g, f) {
                    this._logger.info("setRenderer");
                    const S = generateCauseId();
                    if (this._disposeRenderer(S), !g) return Promise.resolve();
                    const v = f || this._rendererAdapter.getTarget(g);
                    return asap(()=>{
                        this._setViewingRenderer(g, v);
                    });
                }
                _isDataChannelActive() {
                    return this._dataChannelAdapter.isActive() && this._dataChannelAvailable;
                }
                _raiseScreenSharingControlCapableEvent(g, f, S) {
                    if (this._enabled && this._isDataChannelActive()) {
                        this._logger.info(`_raiseScreenSharingControlCapableEvent() enabled=true, capable=${g}, role=${this.role}`);
                        const v = {
                            capable: g,
                            id: f,
                            disabledBySharer: S
                        };
                        this.event("sharingControlCapable").raise(v);
                    } else {
                        this._logger.info(`_raiseScreenSharingControlCapableEvent() enabled=false, capable=${g}, role=${this.role}`);
                        const S = {
                            capable: !1,
                            id: f
                        };
                        this.event("sharingControlCapable").raise(S);
                    }
                }
                initControlForSharer(g) {
                    this._logger.info(`initControlForSharer() negotiationTag: ${g}`), this._isSharing() && this._logger.warn("initControlForSharer() when already sharing"), this._resetControlState(), this._screenSharingVideoRenderer = null, this._disposeControlCapturer(), this._logger.info(`role is changing from=${this.role} to=1`), this.role = 1, this._availableHandshakeSent = !1, this._raiseScreenSharingControlCapableEvent(this._canEnableGiveControl(), Fa), this._initiateSharerSessionTelemetry(g);
                }
                enableControlInjector(g) {
                    this._logger.info(`enableControlInjector() trackId: ${g}`), this._canEnableGiveControl() ? this._controlInjector.enableInjector(g).catch((g)=>{
                        const f = {
                            reason: 0,
                            detail: JSON.stringify({
                                errorMsg: g
                            })
                        };
                        this.event("sharingControlError").raise(f);
                    }) : this._logger.info("enableControlInjector() give control cannot be enabled");
                }
                shutdownControlForSharer() {
                    if (this._logger.info("shutdownControlForSharer()"), this._isSharing() || this._logger.warn("shutdownControlForSharer() when not sharing"), this._controlRequest) {
                        this._logger.warn("Rejecting pending control requests");
                        const g = this._getDataSourceIdForParticipantLeg(this._controlRequest), f = this._controlRequest;
                        this._clearControlRequest(), this._raiseControlRequestCanceled(f), this._sendControlRejectRequest(f.causeId, 5, g);
                    }
                    if (this._controllerParticipant) {
                        const g = {
                            inControl: !1,
                            id: this._controllerParticipant.participant.id,
                            terminatedReason: 5
                        };
                        this._recordSharerSessionTelemetry((f)=>f.controlTerminated(this._controlCauseId, g.terminatedReason, this._controllerSourceId)), this.event("sharingControlChanged").raise(g);
                    }
                    this._finalizeSharerSessionTelemetry(), this._teardownSharerRemoteControl(), this._controlInjector.disableInjector().catch((g)=>{
                        const f = {
                            reason: 0,
                            detail: JSON.stringify({
                                errorMsg: g
                            })
                        };
                        this.event("sharingControlError").raise(f);
                    }), this._resetControlState(), this._resetParticipantSubscriptions(), this._availableAckEnabled = this._enabled, this._logger.info(`role is changing from=${this.role} to=0`), this.role = 0;
                }
                _resetParticipantSubscriptions() {
                    this._logger.info("resetParticipantSubscriptions() Stopping tracking all participant state changes"), (0, Ma.each)(this._participantSubscriptions, (g)=>{
                        g.dispose();
                    }), this._participantSubscriptions = {};
                }
                _initiateViewerSessionTelemetry(g, f, S) {
                    if (!S && !f) return null;
                    if (!S && (0, Ma.find)(this._completedViewerSessions, (g)=>f === g)) return null;
                    if (this._currentViewerSessionTelemetry) {
                        if (this._currentViewerSessionTelemetry.negotiationTag === f) return null;
                        this._finalizeViewerSessionTelemetry(f);
                    }
                    return this._logger.info(`Initiating new viewer session telemetry for ${f}`), this._currentViewerSessionTelemetry = new Ua(this._logger, (new Date).getTime(), f, this._callId, this._participantId, this._endpointId, g), this._currentViewerSessionTelemetry.callStateChanged(this._callState), this._isDataChannelActive() && this._currentViewerSessionTelemetry.dataChannelAvailable(!0), this._currentViewerSessionTelemetry;
                }
                _recordViewerSessionTelemetry(g, f = !0) {
                    this._currentViewerSessionTelemetry ? g && g(this._currentViewerSessionTelemetry) : f && this._logger.error("Cannot record telemetry without current session");
                }
                _finalizeViewerSessionTelemetry(g) {
                    if (!this._currentViewerSessionTelemetry) return;
                    this._currentViewerSessionTelemetry.shutdownSession(g);
                    const f = this._currentViewerSessionTelemetry.getEvent();
                    this._sendTelemetryEvent("mdsc_gtc_viewer_session", f), this._currentViewerSessionTelemetry.negotiationTag && this._completedViewerSessions.push(this._currentViewerSessionTelemetry.negotiationTag), this._currentViewerSessionTelemetry.messagesFromUnknownSender && Object.keys(this._currentViewerSessionTelemetry.messagesFromUnknownSender).length && Oa.RootToolsManager.logExternalForDDL("ScreenSharingControl_viewer: messages received from unkonwn sender", JSON.stringify(f.ProtocolMessages)), this._currentViewerSessionTelemetry = null;
                }
                _initiateSharerSessionTelemetry(g) {
                    if (this._currentSharerSessionTelemetry) {
                        if (this._currentSharerSessionTelemetry.negotiationTag === g) return null;
                        this._finalizeSharerSessionTelemetry(this._currentSharerSessionTelemetry.negotiationTag);
                    }
                    this._logger.info(`Initiating new sharer session telemetry for ${g}`), this._currentSharerSessionTelemetry = new Va(this._logger, (new Date).getTime(), g, this._callId, this._participantId, this._endpointId), this._isDataChannelActive() && this._currentSharerSessionTelemetry.dataChannelAvailable(!0);
                }
                _recordSharerSessionTelemetry(g, f = !0) {
                    this._currentSharerSessionTelemetry ? g && g(this._currentSharerSessionTelemetry) : f && this._logger.error("Cannot record telemetry without current session");
                }
                _finalizeSharerSessionTelemetry(g) {
                    if (!this._currentSharerSessionTelemetry) return;
                    this._currentSharerSessionTelemetry.shutdownSession(g);
                    const f = this._currentSharerSessionTelemetry.getEvent();
                    this._sendTelemetryEvent("mdsc_gtc_sharer_session", f), this._currentSharerSessionTelemetry.messagesFromUnknownSender && Object.keys(this._currentSharerSessionTelemetry.messagesFromUnknownSender).length && Oa.RootToolsManager.logExternalForDDL("ScreenSharingControl_sharer: messages received from unkonwn sender", JSON.stringify(f.ProtocolMessages)), this._currentSharerSessionTelemetry = null;
                }
                _sendTelemetryEvent(g, f) {
                    var _this__telemetryLoggers_media, _this__telemetryLoggers;
                    this._logger.info(`Sending event ${g}: `), Object.keys(f).forEach((g)=>{
                        this._logger.info(`     ${g} => ${f[g]}`);
                    }), (_this__telemetryLoggers = this._telemetryLoggers) === null || _this__telemetryLoggers === void 0 ? void 0 : (_this__telemetryLoggers_media = _this__telemetryLoggers.media) === null || _this__telemetryLoggers_media === void 0 ? void 0 : _this__telemetryLoggers_media.sendEvent({
                        eventName: g,
                        props: f
                    });
                }
                _recordProtocolMessage(g, f) {
                    this._currentViewerSessionTelemetry && this._currentViewerSessionTelemetry.recordProtocolMessage(g, f), this._currentSharerSessionTelemetry && this._currentSharerSessionTelemetry.recordProtocolMessage(g, f);
                }
                reportSharingSessionChangeForViewer(g, f) {
                    f && this._initiateViewerSessionTelemetry(g, f, !1);
                }
                initControlForViewer(g, f) {
                    if (this._logger.info(`initControlForViewer(${scrubMriOrOmit(g === null || g === void 0 ? void 0 : g.id)}, ${f})`), g) {
                        if (this._isViewing() && this._logger.warn("initControlForViewer: called when already viewing"), 3 !== this._callState) return this._logger.info(`initControlForViewer: postponed until call is connected, callState=${this._callState}`), this._pendingNegotiationTag = f, void (this._pendingSharer = g);
                        this._logger.info(`role is changing from=${this.role} to=2`), this.role = 2, this._sharerParticipant ? this._sharerParticipant.id !== g.id && (this._logger.info(`initControlForViewer: sharer switched, new sharer id=${scrubMriOrOmit(g.id)}`), this._availableHandshakeSent = !1, 4 === this.controlState && this._terminateControl(!1)) : (this._logger.info(`initControlForViewer: setting sharer to id=${scrubMriOrOmit(g.id)}`), this._sharerParticipant = g, this._availableHandshakeSent = !1), this._initiateViewerSessionTelemetry(g, f, !0), this._enabled && this._isDataChannelActive() && !this._availableHandshakeSent && (this._resetControlState(), this._sharerParticipant = g, this._logger.info("initControlForViewer: sending Available message to sharer"), this._startAvailableHandshake());
                    } else this._logger.warn("initControlForViewer: Sharer undefined, ignoring");
                }
                shutdownControlForViewer(g) {
                    var _this__sharerParticipant;
                    if (this._logger.info(`shutdownControlForViewer() isViewing: ${this._isViewing()}`), this._pendingSharer = null, (!g || g.id === ((_this__sharerParticipant = this._sharerParticipant) === null || _this__sharerParticipant === void 0 ? void 0 : _this__sharerParticipant.id)) && this._isViewing()) {
                        if (this._logger.info(`shutdownControlForViewer: sharerParticipant id=${g ? scrubMriOrOmit(g.id) : null}`), 1 === this.controlState) {
                            if (this._sharerParticipant) {
                                const g = this._getSharerDataSourceId();
                                this._sendRequest({
                                    action: 2,
                                    terminatedReason: 6,
                                    causeId: this._controlCauseId
                                }, g);
                            } else this._logger.warn("shutdownControlForViewer: sharer participant is null");
                            const g = {
                                inControl: !1,
                                id: Fa,
                                terminatedReason: 6
                            };
                            this._requestControlPromise ? this._requestControlPromise.reject(new Error(JSON.stringify({
                                controlInfo: g,
                                details: ""
                            }))) : this._logger.error("shutdownControlForViewer: Unexpected, no promise could be resolved, controlState=RequestSent");
                        } else if (4 === this.controlState) {
                            const g = {
                                inControl: !1,
                                id: Fa,
                                terminatedReason: 6
                            };
                            this._recordViewerSessionTelemetry((f)=>f.controlTerminated(this._controlCauseId, g.terminatedReason, this._controllerSourceId)), this.event("sharingControlChanged").raise(g);
                        }
                        this._teardownViewerRemoteControl(), this._resetControlState(), this._screenSharingVideoRenderer = null, this._terminateAvailableHandshake && this._terminateAvailableHandshake(2), this._availableHandshakeSent = !1, this._finalizeViewerSessionTelemetry(), 2 === this.role ? (this._logger.info(`_raiseScreenSharingControlCapableEvent  with user role=${this.role}, MRI=${Fa}, isCapable=false`), this._raiseScreenSharingControlCapableEvent(!1, Fa)) : this._logger.warn(`can't call _raiseScreenSharingControlCapableEvent, role=${this.role}`), this._logger.info(`role is changing from=${this.role} to=0`), this.role = 0;
                    }
                }
                _resetControlRequest(g) {
                    this._clearControlRequest(), this._controlRequest = g, this._registerParticipantListener(g), 3 === g.participantState && (this._logger.info(`participantState: Connected, raising: sharingIncomingControlRequest for participantId: ${scrubMriOrOmit(g.participant.id)}`), this.event("sharingIncomingControlRequest").raise(g.participant.id));
                }
                _clearControlRequest() {
                    this._logger.info("_clearControlRequest()"), this._stopListeningToParticipantChanges(this._controlRequest), this._controlRequest = null;
                }
                _stopListeningToParticipantChanges(g) {
                    this._controlRequestSubscription && (this._logger.info(`_stopListeningToParticipantChanges: stopping tracking changes for ${scrubMriOrOmit(g.participant.id)}`), this._controlRequestSubscription.dispose(), this._controlRequestSubscription = null);
                }
                _registerParticipantListener(g) {
                    this._logger.info(`_registerParticipantListener: tracking changes for ${scrubMriOrOmit(g.participant.id)}`), this._logger.info(`request.participantState: ${g.participantState} | request.participant.state: ${g.participant.state}`), this._controlRequestSubscription = g.participant.changed(()=>{
                        if (g.participant.state !== g.participantState) switch(this._logger.info(`request.participantState about to changed from: ${g.participantState} to: ${g.participant.state}`), g.participantState = g.participant.state, g.participantState){
                            case 3:
                                this.event("sharingIncomingControlRequest").raise(g.participant.id), this._logger.info(`participantState: Connected, raising: sharingIncomingControlRequest for participantId: ${scrubMriOrOmit(g.participant.id)}`);
                                break;
                            case 0:
                            case 5:
                            case 4:
                                this.denyControlRequest().catch((g)=>{
                                    this._logger.info(`It is ok if denyControlRequest rejects here as screensharing may have just been stopped. Err: ${g}`);
                                }), this._logger.info(`_registerParticipantListener: participant ${scrubMriOrOmit(g.participant.id)} is no longer connected. resetting`), this._clearControlRequest(), this._raiseControlRequestCanceled(g);
                                break;
                            case 1:
                            case 2:
                            case 6:
                            case 7:
                                this._logger.info(`participantState: ${g.participantState}, participantId: ${scrubMriOrOmit(g.participant.id)}`);
                                break;
                            default:
                                this._logger.error(`_registerParticipantListener: Unexpected participantState ${g.participantState} unhandled`);
                        }
                    });
                }
                _resetControllerParticipant(g) {
                    var _g_causeId;
                    this._controllerParticipantSubscription && (this._logger.info(`_resetControllerParticipant: stopping tracking changes for ${scrubMriOrOmit(this._controllerParticipant.participant.id)}`), this._controllerParticipantSubscription.dispose(), this._controllerParticipantSubscription = null), g && (this._logger.info(`_resetControllerParticipant: tracking changes for ${scrubMriOrOmit(g.participant.id)}`), this._controllerParticipantSubscription = g.participant.changed(()=>{
                        3 !== g.participant.state && this.handleParticipantRemoved(g.participant.id);
                    })), this._controlCauseId = (_g_causeId = g === null || g === void 0 ? void 0 : g.causeId) !== null && _g_causeId !== void 0 ? _g_causeId : null, this._controllerParticipant = g;
                }
                handleParticipantRemoved(g) {
                    if (this._participantSubscriptions[g] && (this._logger.info(`handleParticipantRemoved(): Stopping tracking state changes for ${scrubMriOrOmit(g)}`), this._participantSubscriptions[g].dispose(), delete this._participantSubscriptions[g]), this._isSharing()) {
                        if (this._controllerParticipant && this._controllerParticipant.participant.id === g) {
                            this._logger.info("handleParticipantRemoved: controller left call, tearing down control session"), this._teardownSharerRemoteControl(), this.controlState = 0;
                            const f = 5;
                            this._recordSharerSessionTelemetry((g)=>g.controlTerminated(this._controlCauseId, f, this._controllerSourceId)), this._resetControllerParticipant();
                            const S = {
                                inControl: !1,
                                id: g,
                                terminatedReason: f
                            };
                            this.event("sharingControlChanged").raise(S);
                        }
                        this._raiseScreenSharingControlCapableEvent(!1, g);
                    } else if (this._sharerParticipant && this._sharerParticipant.id === g && 4 === this.controlState) {
                        this._logger.info("handleParticipantRemoved: sharer left call, tearing down control session"), this._teardownViewerRemoteControl(), this.controlState = 0;
                        const g = {
                            inControl: !1,
                            id: Fa,
                            terminatedReason: 6
                        };
                        this.event("sharingControlChanged").raise(g);
                    }
                }
                callStateChanged(g) {
                    this._callState = g, this._recordViewerSessionTelemetry((f)=>f.callStateChanged(g), !1), this._recordSharerSessionTelemetry((f)=>f.callStateChanged(g), !1), this.isScreenSharingControlEnabled() && this._handleCallState(g);
                }
                setIsEscalationInProgress(g) {
                    this.isEscalationInProgress = g;
                }
                _getHandshakeDelay() {
                    var _this__config_handshakeSendDelay, _f_endpoints;
                    if (!((_this__config_handshakeSendDelay = this._config.handshakeSendDelay) === null || _this__config_handshakeSendDelay === void 0 ? void 0 : _this__config_handshakeSendDelay.minParticipantThreshold)) return 0;
                    let g = 0;
                    if (this._call.participants.length >= this._config.handshakeSendDelay.minParticipantThreshold) for (const f of this._call.participants)((_f_endpoints = f.endpoints) === null || _f_endpoints === void 0 ? void 0 : _f_endpoints.endpointDetails.some((g)=>"interactive" === g.appliedInteractivityLevel)) && g++;
                    if (g <= this._config.handshakeSendDelay.minParticipantThreshold) return 0;
                    const f = Math.ceil((g - this._config.handshakeSendDelay.minParticipantThreshold) / this._config.handshakeSendDelay.increaseEveryN);
                    return Math.min(this._config.handshakeSendDelay.maxDelay, f * this._config.handshakeSendDelay.delayPerN);
                }
                _handleCallState(g) {
                    switch(g){
                        case 3:
                            this._handleCallConnected();
                            break;
                        case 7:
                            this._handleCallDisconnected();
                            break;
                        case 4:
                        case 5:
                            this.shutdownControlForViewer();
                    }
                }
                _handleCallConnected() {
                    this._logger.info("_handleCallConnected()"), this._pendingSharer && (this.initControlForViewer(this._pendingSharer, this._pendingNegotiationTag), this._pendingSharer = null);
                }
                _handleCallDisconnected() {
                    this._logger.info("_handleCallDisconnected()"), this._isSharing() ? this.shutdownControlForSharer() : this.shutdownControlForViewer();
                }
                _videoSizeChanged(g, f) {
                    null !== this._controlCapturer && this._controlCapturer.updateVideoSize(g, f);
                }
                _onRenderStarted() {
                    const g = {
                        action: 11,
                        terminatedReason: 0
                    };
                    if (this._sharerParticipant) {
                        const f = this._getSharerDataSourceId();
                        this._sendRequest(g, f);
                    } else this._logger.error("Attempted to send sharing rendered message to null sharerParticipant");
                }
                _setViewingRenderer(g, f) {
                    try {
                        this._screenSharingVideoRenderer = g, this._screenSharingVideoRendererSubscriptions.push(this._rendererAdapter.subscribeVideoSizeChangedEvent(this._screenSharingVideoRenderer, (g, f)=>{
                            this._videoSizeChanged(g, f);
                        })), this._screenSharingVideoRendererSubscriptions.push(this._rendererAdapter.subscribeRenderStartedEvent(this._screenSharingVideoRenderer, ()=>{
                            this._onRenderStarted();
                        }));
                        let S = 1;
                        g.streamSize && g.streamSize.width > 0 && g.streamSize.height > 0 && (S = g.streamSize.width / g.streamSize.height), this._controlCapturer = new wa.SlimCoreElectronControlCapturer(this._logger, f, !0, S), 4 === this.controlState ? (this._logger.info("_setViewingRenderer: detected local state is controlling"), this._setupViewerRemoteControl()) : this._teardownViewerRemoteControl();
                    } catch (g) {
                        this._logger.error(`_setViewingRenderer: unable to set _screenSharingVideoRenderer error=${g}`);
                    }
                }
                _onDataChannelStatusChanged(g) {
                    this._logger.info(`_onDataChannelStatusChanged(): Data channel status=${g}, isEscalationInProgress=${this.isEscalationInProgress}`), g ? this._dataChannelAvailable || (this._dataChannelAvailable = !0, this._recordViewerSessionTelemetry((g)=>g.dataChannelAvailable(!0), !1), this._recordSharerSessionTelemetry((g)=>g.dataChannelAvailable(!0), !1), this._enabled && (this._isViewing() ? this._availableHandshakeSent || (this._sharerParticipant ? (this._logger.info("_onDataChannelStatusChanged: sending Available message to sharer"), this._startAvailableHandshake()) : this._logger.error("Unexpected null _sharerParticipant trying to send Available to sharer")) : this._isSharing() && (this.isEscalationInProgress || this._raiseScreenSharingControlCapableEvent(!0, Fa)))) : this._dataChannelAvailable && (this._recordViewerSessionTelemetry((g)=>g.dataChannelAvailable(!1), !1), this._recordSharerSessionTelemetry((g)=>g.dataChannelAvailable(!1), !1), this._dataChannelAvailable = !1, this._availableHandshakeSent = !1, this._terminateAvailableHandshake && this._terminateAvailableHandshake(3), this.isEscalationInProgress || this._raiseScreenSharingControlCapableEvent(!1, Fa));
                }
                _isSharing() {
                    return 1 === this.role;
                }
                _isViewing() {
                    return 2 === this.role;
                }
                _handleAvailableRequest(g, f, S) {
                    if (this._isSharing()) return this._enabled && this._availableAckEnabled && this._canEnableGiveControl() ? (f === null || f === void 0 ? void 0 : f.id) ? void (this._allowControlForUser && "function" == typeof this._allowControlForUser ? this._allowControlForUser(f).then((v)=>{
                        v ? this._acceptAvailableRequest(g.handshakeId, f, S) : this._rejectAvailableRequest(g.handshakeId, S, 1);
                    }) : this._acceptAvailableRequest(g.handshakeId, f, S)) : (this._logger.info("Unknown sender. Rejecting available ack"), void this._rejectAvailableRequest(g.handshakeId, S, 10)) : (this._logger.info(`Rejecting available ack - enabled=${this._enabled}, availableAck=${this._availableAckEnabled}, controlInjector=${this._canEnableGiveControl()}`), void this._rejectAvailableRequest(g.handshakeId, S, 9));
                    this._logger.warn(`Ignoring available request since role=${this.role} is not sharing. Expecting for viewer side retries`);
                }
                _acceptAvailableRequest(g, f, S) {
                    this._raiseScreenSharingControlCapableEvent(!0, f.id), this._participantSubscriptions[f.id] || (this._logger.info(`Tracking participant status for ${scrubMriOrOmit(f.id)}`), this._participantSubscriptions[f.id] = f.changed(()=>{
                        3 !== f.state && (this._logger.info(`Participant ${scrubMriOrOmit(f.id)} is not connected. removing`), this.handleParticipantRemoved(f.id));
                    })), this._logger.info(`Acking Available for handShake:${S}:${g}`), this.event("controlAvailableHandshake").raise(g, S, 3), this._sendRequest({
                        action: 9,
                        terminatedReason: 0,
                        handshakeId: g
                    }, S);
                }
                _rejectAvailableRequest(g, f, S) {
                    this._logger.info(`Rejecting Available for handShake:${f}:${g}`), this.event("controlAvailableHandshake").raise(g, f, 7, this._getAvailableHandshakeTerminatedFromControlTerminated(S)), this._sendRequest({
                        action: 10,
                        terminatedReason: S,
                        handshakeId: g
                    }, f);
                }
                processProtocolMessage(g, f, S, v) {
                    return asap(()=>{
                        this._processProtocolMessage(g, f, S, v);
                    });
                }
                _raiseControlRequestCanceled(g) {
                    this.event("sharingIncomingControlRequestCancelled").raise(g.participant.id);
                }
                _handleControlRequest(g, f, S, v) {
                    this._recordSharerSessionTelemetry((g)=>g.controlRequest(v, S)), this._enabled ? this._controlRequest ? (this._logger.warn("Sharer is already processing a control request...rejecting new requests"), this._sendControlRejectRequest(v, 3, f)) : this._controllerParticipant && this._controllerParticipant.participant === g ? this._controllerParticipant.participantId && this._controllerParticipant.participantId !== S ? (this._logger.warn(`rejecting control request from second endpoint. participantId: ${S}`), this._sendControlRejectRequest(v, 3, f)) : (this._logger.warn("Got control request for someone already in control"), this._resetControllerParticipant(), this._resetControlRequest({
                        participant: g,
                        participantState: g.state,
                        participantId: S,
                        causeId: v
                    })) : g ? (this._logger.info(`resetControlRequest for participantId: ${S}`), this._resetControlRequest({
                        participant: g,
                        participantState: g.state,
                        participantId: S,
                        causeId: v
                    })) : this._logger.error("Got ControlRequest message but could not find a sender participant, ignoring") : (this._logger.warn("Sharer control is disabled - rejecting request"), this._sendControlRejectRequest(v, 9, f));
                }
                _handleAcceptRequest(g, f) {
                    if (1 === this.controlState) {
                        const S = this._sendRequest({
                            action: 5,
                            terminatedReason: 0
                        }, f);
                        this._logger.info(`_handleAcceptRequest controlMessage.action: ${toControlActionString(g.action)} _sendRequest isSent: ${S}`), S ? (this._setupViewerRemoteControl(), this.controlState = 4, this._requestControlPromise ? this._requestControlPromise.resolve() : this._logger.error(`Unexpected, no promise could be resolved - controlState=RequestSent action=${toControlActionString(g.action)}`), this._recordViewerSessionTelemetry((g)=>g.requestControlAccepted(this._controlCauseId))) : this._requestControlPromise ? this._requestControlPromise.reject(new Error(JSON.stringify({
                            controlInfo: void 0,
                            details: "request control is accepted, but failed to send ack"
                        }))) : this._logger.error(`Unexpected, no promise could be resolved - controlState=${toControlStateString(this.controlState)} action=${toControlActionString(g.action)}`), this._cancelRequestControlTimer();
                    } else this._logger.warn(`AcceptRequest message received in controlState=${toControlStateString(this.controlState)}`);
                }
                _handleRejectRequest(g) {
                    if (1 === this.controlState) {
                        this._logger.info(`_handleRejectRequest: controlState: ${toControlStateString(this.controlState)}, about to be changed to: ${toControlStateString(0)}`), this.controlState = 0;
                        const f = {
                            inControl: !1,
                            id: Fa,
                            terminatedReason: g.terminatedReason
                        };
                        this._requestControlPromise ? this._requestControlPromise.reject(new Error(JSON.stringify({
                            controlInfo: f,
                            details: ""
                        }))) : this._logger.error(`Unexpected, no promise could be resolved - controlState=RequestSent action=${toControlActionString(g.action)}`), this._recordViewerSessionTelemetry((f)=>f.requestControlRejected(this._controlCauseId, g.terminatedReason)), this._cancelRequestControlTimer(), this._controlCauseId = null;
                    } else this._logger.warn(`RejectRequest message received in controlState=${toControlStateString(this.controlState)} reason=${g.terminatedReason}`);
                }
                _handleCancelControlRequest(g, f) {
                    if (this._logger.info(`_handleCancelControlRequest action=${toControlActionString(g.action)} sender=${f}, controlRequest participantId: ${this._controlRequest.participantId}, controlRequest participantState: ${this._controlRequest.participantState}:`), this._controlRequest) {
                        const S = this._controlRequest;
                        this._logger.info(`_handleCancelControlRequest action=${toControlActionString(g.action)} sender=${f}, about to raise: _raiseControlRequestCanceled state: ${this._controlRequest.participantState} `), this._recordSharerSessionTelemetry((S)=>S.controlRequestRejected(g.causeId, g.terminatedReason, f)), this._clearControlRequest(), this._raiseControlRequestCanceled(S);
                    }
                }
                _handleGiveControl(g, f, S) {
                    const v = this._sendRequest({
                        action: 5,
                        terminatedReason: 0
                    }, f);
                    if (this._logger.info(`_handleGiveControl: controlMessage.action: ${toControlActionString(g.action)} _sendRequest isSent: ${v}`), this._controlCauseId = g.causeId, v) {
                        this._setupViewerRemoteControl(), this._logger.info(`controlState: ${toControlStateString(this.controlState)}, about to be changed to: ${toControlStateString(4)}`), this.controlState = 4, this._recordViewerSessionTelemetry((g)=>g.controlGiven(this._controlCauseId, f));
                        const S = {
                            inControl: !0,
                            id: Fa,
                            terminatedReason: g.terminatedReason
                        };
                        this.event("sharingControlChanged").raise(S);
                    }
                }
                _handleAck(g, f, S) {
                    if (2 === this.controlState) {
                        if (this._controllerParticipant && this._controllerParticipant.participant === f) {
                            const f = this._getDataSourceIdForParticipantLeg(this._controllerParticipant);
                            S !== f && this._logger.warn(`acknowledging source id: ${S} does not match requesting source id: ${f}`), this._logger.info(`Setting up remote control for controller source id=${f}`), this._setupSharerRemoteControl(f), this._logger.info(`controlState: ${toControlStateString(this.controlState)}, about to be changed to: ${toControlStateString(3)}`), this.controlState = 3;
                            const v = {
                                inControl: !0,
                                id: this._controllerParticipant.participant.id,
                                terminatedReason: g.terminatedReason
                            };
                            this.event("sharingControlChanged").raise(v), this._grantControlPromise ? (this._grantControlPromise.resolve(), this._cancelGrantControlTimer(), this._recordSharerSessionTelemetry((g)=>g.giveControlSucceeded(this._controlCauseId, f))) : this._acceptControlPromise ? (this._acceptControlPromise.resolve(), this._cancelAcceptControlTimer(), this._recordSharerSessionTelemetry((g)=>g.controlRequestAccepted(this._controlCauseId, f))) : this._logger.error(`Unexpected, no promise could be resolved - controlState=WaitingForControlAck action=${toControlActionString(g.action)}`);
                        } else f ? this._logger.warn(`Ignoring ack from participant that does not match controller id=${scrubMriOrOmit(f.id)}`) : this._logger.warn(`Ignoring ack from null participant source id=${S}`);
                    } else 5 === this.controlState ? (this._logger.info(`controlState: ${toControlStateString(this.controlState)}, about to be changed to: ${toControlStateString(0)}`), this.controlState = 0, this._resetControllerParticipant(), this._terminateControlPromise ? (this._terminateControlPromise.resolve(), this._cancelTerminateControlTimer()) : this._logger.error(`Unexpected, no promise could be resolved - controlState=WaitingForTerminateAck action=${toControlActionString(g.action)}`)) : this._logger.warn(`Unexpected ack in control controlState=${toControlStateString(this.controlState)}`);
                }
                _handleTerminate(g, f, S) {
                    let v;
                    this._isViewing() ? (this._teardownViewerRemoteControl(), v = Fa, this._recordViewerSessionTelemetry((f)=>f.controlTerminated(this._controlCauseId, g.terminatedReason, S))) : (this._teardownSharerRemoteControl(), f ? v = f.id : this._logger.error("Got terminate message but could not find a sender participant!"), this._recordSharerSessionTelemetry((f)=>f.controlTerminated(this._controlCauseId, g.terminatedReason, S))), this._logger.info(`controlMessage action: ${toControlActionString(g.action)}, controllerId: ${v}`), this._logger.info(`controlState: ${toControlStateString(this.controlState)}, about to be changed to: ${toControlStateString(0)}`), this.controlState = 0, this._resetControllerParticipant();
                    const _ = {
                        inControl: !1,
                        id: v,
                        terminatedReason: g.terminatedReason
                    };
                    this.event("sharingControlChanged").raise(_), 8 === g.action && this._sendRequest({
                        action: 5,
                        terminatedReason: 0
                    }, S);
                }
                _handleAvailableAck(g) {
                    this._terminateAvailableHandshake && (this._logger.info(`_handleAvailableAck: terminate available handshake reason: 1,handshakeId: ${g.handshakeId}`), this._terminateAvailableHandshake(1, g.handshakeId)), 2 === this.role ? this._raiseScreenSharingControlCapableEvent(!0, Fa) : this._logger.info(`Ignoring AvailableAck as viewer session is not initialized, role: ${this.role}`);
                }
                _handleAvailableNack(g) {
                    this._logger.info(`_handleAvailableNack: action=${toControlActionString(g.action)} terminate reason: ${toControlTerminatedReason(g.terminatedReason)}`), this._viewerSessionLastTerminatedReason = g.terminatedReason, 10 !== g.terminatedReason ? (this._terminateAvailableHandshake && (this._terminateAvailableHandshake(this._getAvailableHandshakeTerminatedFromControlTerminated(g.terminatedReason), g.handshakeId), this._logger.info(`_handleAvailableNack: terminateAvailableHandshake reason=${toControlTerminatedReason(g.terminatedReason)}`)), 1 === g.terminatedReason ? (this._logger.warn("_handleAvailableNack: control terminate reason: SharerDenied"), this._raiseScreenSharingControlCapableEvent(!0, Fa, !0)) : this._raiseScreenSharingControlCapableEvent(!1, Fa)) : this._logger.warn("_handleAvailableNack: control terminate reason: UnknownSender");
                }
                _handleRenderedAtViewer(g, f) {
                    this._raiseRenderedAtViewer && (f ? (this._logger.info(`raiseRenderedAtViewer senderId=${scrubMriOrOmit(f.id)}, action=${toControlActionString(g.action)}`), this._raiseRenderedAtViewer(f.id)) : this._logger.error("Got RenderedAtViewer message but could not find a sender participant!"));
                }
                _processProtocolMessage(g, f, S, v) {
                    let _;
                    this._recordProtocolMessage(f, v);
                    try {
                        _ = JSON.parse(g);
                    } catch (g) {
                        return void this._logger.error("Error parsing controlMessage");
                    }
                    switch(f || this._logger.warn(`protocol message from unknown sender with sourceId=${v}`), this._logger.info(`_processProtocolMessage action=${toControlActionString(_.action)}, sourceId=${v}`), _.action){
                        case 0:
                            this._handleAvailableRequest(_, f, v);
                            break;
                        case 1:
                            this._handleControlRequest(f, v, S, _.causeId);
                            break;
                        case 3:
                            this._handleAcceptRequest(_, v);
                            break;
                        case 4:
                            this._handleRejectRequest(_);
                            break;
                        case 2:
                            this._handleCancelControlRequest(_, v);
                            break;
                        case 6:
                            this._handleGiveControl(_, v, f);
                            break;
                        case 5:
                            this._handleAck(_, f, v);
                            break;
                        case 8:
                        case 7:
                            this._handleTerminate(_, f, v);
                            break;
                        case 9:
                            this._handleAvailableAck(_);
                            break;
                        case 10:
                            this._handleAvailableNack(_);
                            break;
                        case 11:
                            this._handleRenderedAtViewer(_, f);
                            break;
                        default:
                            this._logger.error(`Unknown request action received on control protocol data sink, action=${toControlActionString(_.action)}`);
                    }
                }
                _getAvailableHandshakeTerminatedFromControlTerminated(g) {
                    switch(g){
                        case 10:
                            return 6;
                        case 1:
                            return 7;
                        default:
                            return 0;
                    }
                }
                _sendRequest(g, f) {
                    if (f < 0) return this._logger.warn(`Unexpected: invalid sourceID=${f}`), !1;
                    this._logger.info(`_sendRequest() action=${toControlActionString(g.action)} recipient sourceid=${f}`);
                    const S = {
                        type: 0,
                        message: JSON.stringify(g)
                    }, v = [
                        f
                    ];
                    return this._dataChannelAdapter.sendProtocolMessage(stringToBuffer(JSON.stringify(S)), v), !0;
                }
                async processControlMessage(g, f) {
                    if (f === this._controllerSourceId) {
                        if (3 === this.controlState) return this._processControlMessage(g, f);
                        this._logger.debug(`Ignoring control message, wrong controlState. Expected: RemoteControlling, got: ${toControlStateString(this.controlState)}`);
                    } else this._logger.debug(`Ignoring control message, wrong sourceId. Expected: ${f}, got: ${this._controllerSourceId}`);
                }
                _processControlMessage(g, f) {
                    return this._controlInjector.injectRawInput(g, f);
                }
                _resetControlState() {
                    this._logger.info("_resetControlState()"), this.controlState = 0, this._resetControllerParticipant(), this._sharerParticipant = null, this._controlCauseId = null, this._clearControlRequest(), this._cancelRequestControlTimer(), this._cancelAcceptControlTimer(), this._cancelGrantControlTimer(), this._cancelTerminateControlTimer();
                }
                _setupSharerRemoteControl(g) {
                    this._logger.info(`_setupSharerRemoteControl() sourceId=${g}`), this._controllerSourceId = g, this._controlInjector.showVirtualCursor(g).catch((f)=>{
                        const S = {
                            reason: 3,
                            detail: JSON.stringify({
                                sourceId: g,
                                errorMsg: f
                            })
                        };
                        this.event("sharingControlError").raise(S);
                    });
                }
                _teardownSharerRemoteControl() {
                    this._logger.info("_teardownSharerRemoteControl()"), this._controllerSourceId = null, this._controlInjector.showVirtualCursor(0).catch((g)=>{
                        const f = {
                            reason: 3,
                            detail: JSON.stringify({
                                sourceId: 0,
                                errorMsg: g
                            })
                        };
                        this.event("sharingControlError").raise(f);
                    });
                }
                _setupViewerRemoteControl() {
                    this._logger.info("_setupViewerRemoteControl()"), this._setCapturerMode(3);
                }
                _teardownViewerRemoteControl() {
                    this._logger.info("_teardownViewerRemoteControl()"), this._setCapturerMode(0);
                }
                _clearCapturerEventSubscriptions() {
                    this._logger.info("_clearCapturerEventSubscriptions()"), this._captureEventSubscription && (this._captureEventSubscription.dispose(), this._captureEventSubscription = null), this._mouseControlEventSubscription && (this._mouseControlEventSubscription.dispose(), this._mouseControlEventSubscription = null), this._keyboardControlEventSubscription && (this._keyboardControlEventSubscription.dispose(), this._keyboardControlEventSubscription = null);
                }
                sendRemoteControlEvent(g, f) {
                    if (f) switch(g){
                        case "mouseControlEvent":
                            this._sendControlEvent(ha.encodeMouseEvent(f));
                            break;
                        case "keyboardControlEvent":
                            this._sendControlEvent(ha.encodeKeyboardEvent(f));
                            break;
                        default:
                            return void this._logger.error("sendRemoteControlEvent: Invalid type=", g);
                    }
                    else this._logger.error("sendRemoteControlEvent: Invalid argument.");
                }
                _sendControlEvent(g) {
                    if (!this._isDataChannelActive() || !this._sharerParticipant || 4 !== this.controlState) return void this._logger.error(`_sendControlEvent: Dropping message - No data channel or wrong controlState. dataConnected: ${this._isDataChannelActive()} controlState: ${toControlStateString(this.controlState)})`);
                    const f = [
                        this._getSharerDataSourceId()
                    ];
                    this._dataChannelAdapter.sendControlMessage(g, f);
                }
                _setCapturerMode(g) {
                    this._logger.info(`_setCapturerMode() capturerMode=${g}`), this._controlCapturer ? (this._controlCapturer.setCaptureMode(g), this._clearCapturerEventSubscriptions(), 1 === g ? this._captureEventSubscription = this._controlCapturer.on("ctrlCaptureEvent", (g)=>{
                        0 === g && this.event("sharingRendererClicked").raise();
                    }) : 2 === g ? this._captureEventSubscription = this._controlCapturer.on("ctrlCaptureEvent", (g)=>{
                        1 === g ? this.event("sharingRendererMouseEntering").raise() : 2 === g && this.event("sharingRendererMouseLeaving").raise();
                    }) : 3 === g && (this._mouseControlEventSubscription = this._controlCapturer.on("mouseControlEvent", (g)=>{
                        this._sendControlEvent(ha.encodeMouseEvent(g));
                    }), this._keyboardControlEventSubscription = this._controlCapturer.on("keyboardControlEvent", (g)=>{
                        this._sendControlEvent(ha.encodeKeyboardEvent(g));
                    }), this._captureEventSubscription = this._controlCapturer.on("ctrlCaptureEvent", (g)=>{
                        1 === g ? this.event("sharingRendererMouseEntering").raise() : 2 === g && this.event("sharingRendererMouseLeaving").raise();
                    }))) : this._logger.info("_controlCapturer not set, relying on external controlCapturer");
                }
                setPointerImage(g, f) {
                    return this._logger.warn("setPointerImage is deprecated. Use setLocalPointerImage or setRemotePointerImage"), g ? this.setRemotePointerImage(g, f) : this.setLocalPointerImage(f);
                }
                setLocalPointerImage(g) {
                    return 0 === g.length ? Promise.reject(new Error("setLocalPointerImage invalid image length")) : this._setPointerImage(0, g);
                }
                async setRemotePointerImage(g, f) {
                    if (!g) throw new Error("setRemotePointerImage participant is null");
                    if (0 === f.length) throw new Error("setRemotePointerImage invalid image length");
                    const S = this._getParticipantsDataSourceIds(g);
                    if (0 === S.length) throw new Error("setRemotePointerImage unable to map participant to sourceIds");
                    this._logger.info(`set pointer image for ${S.length} sources`);
                    for (const g of S)await this._setPointerImage(g, f);
                }
                _setPointerImage(g, f) {
                    return this._isSharing() || this._logger.warn("_setPointerImage called when not sharing"), this._controlInjector.setPointerImage(g, f);
                }
                startPointerMode() {
                    return this._enabled ? this._isDataChannelActive() ? 0 !== this.controlState ? Promise.reject(new Error(`startPointerMode called in bad control controlState=${toControlStateString(this.controlState)}`)) : this._isViewing() ? asap(()=>{
                        this._setCapturerMode(2);
                    }) : Promise.reject(new Error("startPointerMode when not viewing")) : Promise.reject(new Error("startPointerMode when data channel not active")) : Promise.reject(new Error("startPointerMode when feature not enabled"));
                }
                stopPointerMode() {
                    return 0 !== this.controlState ? Promise.reject(new Error(`stopPointerMode called in bad control controlState=${toControlStateString(this.controlState)}`)) : this._isViewing() ? asap(()=>{
                        this._setCapturerMode(1);
                    }) : Promise.reject(new Error("stopPointerMode when not viewing"));
                }
                _startAvailableHandshake() {
                    var _this__sharerParticipant;
                    const g = this._getSharerDataSourceId(), f = generateGuid(), S = this._getHandshakeDelay(), v = Math.floor(Math.random() * S);
                    if (this._logger.info(`_startAvailableHandshake() - handshakeId: ${g}:${f} ${v > 0 ? `delay: ${v}ms maxDelay: ${S}ms` : ""}}`), this._terminateAvailableHandshake && (this._logger.warn("Replacing existing availble handshake"), this._terminateAvailableHandshake(4)), this._recordViewerSessionTelemetry((g)=>g.startHandshake(f)), g < 0) this._logger.warn(`_startAvailableHandshake() - sharer: ${scrubMriOrOmit((_this__sharerParticipant = this._sharerParticipant) === null || _this__sharerParticipant === void 0 ? void 0 : _this__sharerParticipant.id)} has no data channel, retrying later`), this._waitForAvailableAck(f);
                    else {
                        const sendAvailableHandshake = ()=>{
                            this.event("controlAvailableHandshake").raise(f, g, 1);
                            this._sendRequest({
                                action: 0,
                                terminatedReason: 0,
                                handshakeId: f
                            }, g) || this._logger.error("Failed to send Available message to sharer, will retry after backoff"), this._waitForAvailableAck(f);
                        };
                        v > 0 ? (this._delayedSendHandshakeTimer = window.setTimeout(sendAvailableHandshake, v), this._recordViewerSessionTelemetry((g)=>g.delayHandshakeSending(f, v, S))) : sendAvailableHandshake();
                    }
                    this._availableHandshakeSent = !0, this._terminateAvailableHandshake = (S = 0, v)=>{
                        this._logger.info(`_terminateAvailableHandshake() - handshakeId: ${g}:${f}, status: ${S}`), 1 === S ? this._recordViewerSessionTelemetry((g)=>g.handshakeSucceeded(f, this._retryAttempt)) : (this._logger.error(`GTC handshake terminated with code ${S}, last terminated reason: ${toControlTerminatedReason(this._viewerSessionLastTerminatedReason)}`), Oa.RootToolsManager.logExternalForDDL(`GTC handshake terminated with code ${S},`, this._viewerSessionLastTerminatedReason.toString()), this._recordViewerSessionTelemetry((g)=>g.handshakeFailed(f, this._retryAttempt, S))), this._terminateAvailableHandshake = null, this.event("controlAvailableHandshake").raise(f, g, 1 === S ? 5 : 6, S), v && v !== f && this._logger.warn(`AvailableSeries: Got handshake from another series - expected: ${f}, received: ${v}`), this._availableAckTimer && (clearTimeout(this._availableAckTimer), this._availableAckTimer = null), this._delayedSendHandshakeTimer && (clearTimeout(this._delayedSendHandshakeTimer), this._delayedSendHandshakeTimer = null), this._retryAttempt = 0;
                    };
                }
                _waitForAvailableAck(g) {
                    this._logger.info("_waitForAvailableAck()"), this._availableAckTimer = window.setTimeout(()=>{
                        var _this__sharerParticipant;
                        this._logger.warn(`No Ack received for Available message from attempt=${this._retryAttempt}`), this._availableAckTimer = null;
                        const f = this._getSharerDataSourceId();
                        if (this._retryAttempt <= La) f >= 0 ? (this._logger.info(`Re-sending Available message handshakeId: ${f}:${g}`), this.event("controlAvailableHandshake").raise(g, f, 2), this._sendRequest({
                            action: 0,
                            terminatedReason: 0,
                            handshakeId: g
                        }, f)) : this._logger.warn(`_waitForAvailableAck() - sharer: ${scrubMriOrOmit((_this__sharerParticipant = this._sharerParticipant) === null || _this__sharerParticipant === void 0 ? void 0 : _this__sharerParticipant.id)} has no data channel, retrying later`), this._waitForAvailableAck(g);
                        else {
                            if (this._logger.error("Reached Available retry limit! Control capability will be false"), this._terminateAvailableHandshake) this._terminateAvailableHandshake(5);
                            else {
                                const g = {
                                    reason: 4,
                                    detail: JSON.stringify({
                                        sourceId: f,
                                        errorMsg: `Timed out after ${this._retryAttempt} tries`
                                    })
                                };
                                this.event("sharingControlError").raise(g);
                            }
                            this._raiseScreenSharingControlCapableEvent(!1, Fa);
                        }
                    }, ka * ++this._retryAttempt);
                }
                requestControl() {
                    return this._enabled ? this._isDataChannelActive() ? 0 !== this.controlState ? Promise.reject(new Error(`requestControl called in bad controlState=${toControlStateString(this.controlState)}`)) : this._isViewing() ? this._sharerParticipant ? this._requestControlPromise ? Promise.reject(new Error("request control promise has not been resolved yet while requesting control")) : this._terminateControlPromise ? Promise.reject(new Error("terminate control promise has not been resolved yet while requesting control")) : this._requestControl() : Promise.reject(new Error("requestControl unexpected null sharer")) : Promise.reject(new Error("requestControl when not viewing")) : Promise.reject(new Error("requestControl when data channel not active")) : Promise.reject(new Error("requestControl when feature not enabled"));
                }
                _requestControl() {
                    const g = this._controlCauseId = generateCauseId();
                    this._logger.info(`_requestControl(), controlState: ${this.controlState}, controlCauseId: ${g}`), this._requestControlPromise = new ct;
                    const always = ()=>{
                        this._requestControlPromise = null;
                    };
                    this._requestControlPromise.promise.then(always, always);
                    const f = this._getSharerDataSourceId();
                    if (!this._sendRequest({
                        action: 1,
                        terminatedReason: 0,
                        causeId: g
                    }, f)) {
                        const g = {
                            inControl: !1,
                            id: Fa,
                            terminatedReason: 7
                        };
                        return this._requestControlPromise.reject(new Error), this._logger.error("_requestControl(): failed to send the request."), Promise.reject(new Error(JSON.stringify({
                            controlInfo: g,
                            details: ""
                        })));
                    }
                    return this._recordViewerSessionTelemetry((f)=>f.requestControl(g)), this.controlState = 1, this._requestControlTimer = window.setTimeout(()=>{
                        if (1 === this.controlState) {
                            this.controlState = 0, this._controlCauseId = null, this._logger.warn("No response to control request - canceling");
                            this._sendRequest({
                                action: 2,
                                terminatedReason: 2,
                                causeId: g
                            }, f) || this._logger.error("Failed to send the cancel control request");
                            const S = {
                                inControl: !1,
                                id: Fa,
                                terminatedReason: 2
                            };
                            this._recordViewerSessionTelemetry((f)=>f.requestControlRejected(g, S.terminatedReason)), this._requestControlPromise ? this._requestControlPromise.reject(new Error(JSON.stringify({
                                controlInfo: S,
                                details: "we did not get any response to the control - terminating control"
                            }))) : this._logger.error("Unexpected, no promise could be resolved - controlState=RequestSent");
                        } else this._requestControlPromise ? this._requestControlPromise.reject(new Error(JSON.stringify({
                            controlInfo: void 0,
                            details: "request control - times out in bad state - do nothing"
                        }))) : this._logger.error(`Unexpected, no promise could be resolved - controlState=${toControlStateString(this.controlState)}`);
                        this._requestControlTimer = null;
                    }, Da), this._requestControlPromise.promise;
                }
                _cancelRequestControlTimer() {
                    this._requestControlTimer && (this._requestControlPromise && this._requestControlPromise.reject(new Error("cancelled by _cancelRequestControlTimer")), clearTimeout(this._requestControlTimer), this._requestControlTimer = null);
                }
                cancelControl() {
                    return this._enabled ? this._isDataChannelActive() ? 1 !== this.controlState ? Promise.reject(new Error(`cancelControl called in bad state=${toControlStateString(this.controlState)}`)) : this._isViewing() ? this._sharerParticipant ? this._requestControlPromise ? this._terminateControlPromise ? Promise.reject(new Error("Terminate control promise has not been resolved yet while cancelling control")) : this._cancelControl() : Promise.reject(new Error("Request control promise has been resolved while cancelling control")) : Promise.reject(new Error("cancelControl unexpected null sharer")) : Promise.reject(new Error("cancelControl when not viewing")) : Promise.reject(new Error("cancelControl when data channel not active")) : Promise.reject(new Error("cancelControl when feature not enabled"));
                }
                _cancelControl() {
                    this._logger.info("_cancelControl()");
                    const g = this._getSharerDataSourceId();
                    if (1 !== this.controlState) return Promise.reject(new Error("Cancel control - in bad state - do nothing"));
                    this._cancelRequestControlTimer(), this.controlState = 0, this._logger.info("Viewer cancels the control");
                    if (!this._sendRequest({
                        action: 2,
                        terminatedReason: 8,
                        causeId: this._controlCauseId
                    }, g)) return Promise.reject(new Error("Failed to send cancel control request"));
                    {
                        const g = {
                            inControl: !1,
                            id: Fa,
                            terminatedReason: 8
                        };
                        this._recordViewerSessionTelemetry((f)=>f.requestControlRejected(this._controlCauseId, g.terminatedReason)), this._controlCauseId = null, this._requestControlPromise.reject(new Error(JSON.stringify({
                            controlInfo: g,
                            details: ""
                        })));
                    }
                    return new Promise((g, f)=>{
                        g();
                    });
                }
                acceptControlRequest() {
                    return this._enabled ? this._isDataChannelActive() ? this._controlRequest ? this._isSharing() ? this._acceptControlPromise ? Promise.reject(new Error("Accept control promise has not been resolved yet while accepting control")) : this._grantControlPromise ? Promise.reject(new Error("Grant control promise has not been resolved yet while accepting control")) : this._terminateControlPromise ? Promise.reject(new Error("Terminate control promise has not been resolved yet while accepting control")) : this._acceptControlRequest() : Promise.reject(new Error("acceptControlRequest when not sharing")) : Promise.reject(new Error("acceptControlRequest while no control request pending")) : Promise.reject(new Error("acceptControlRequest when data channel not active")) : Promise.reject(new Error("acceptControlRequest when feature not enabled"));
                }
                async _acceptControlRequest() {
                    this._logger.info("_acceptControlRequest()"), this._acceptControlPromise = new ct;
                    const always = ()=>{
                        this._acceptControlPromise = null;
                    };
                    if (this._acceptControlPromise.promise.then(always, always), this._controllerParticipant) {
                        this._logger.warn("_acceptControlRequest called while another participant already has control - terminating control");
                        try {
                            await this._terminateControl(!1);
                        } catch (g) {
                            this._logger.error("_acceptControlRequest: failed to gracefully terminate control of previous controller", g);
                        }
                        this._resetControllerParticipant();
                    }
                    const g = this._getDataSourceIdForParticipantLeg(this._controlRequest), f = this._controlRequest.participant.id, S = this._controlRequest.causeId;
                    return this._sendControlAcceptRequest(S, g) ? (this._resetControllerParticipant(this._controlRequest), this._clearControlRequest(), this.controlState = 2, this._acceptControlTimer = window.setTimeout(()=>{
                        if (2 === this.controlState) {
                            this.controlState = 0, this._resetControllerParticipant(), this._logger.error("No ack received when accepting control request - terminating control");
                            this._sendRequest({
                                action: 7,
                                terminatedReason: 4,
                                causeId: S
                            }, g) || this._logger.error("Failed to send the TerminateNoAck request");
                            const v = {
                                inControl: !1,
                                id: f,
                                terminatedReason: 4
                            };
                            this._recordSharerSessionTelemetry((f)=>f.controlRequestRejected(S, v.terminatedReason, g)), this.event("sharingControlChanged").raise(v), this._acceptControlPromise ? this._acceptControlPromise.reject(new Error("No ack received when accept control - terminating control")) : this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForControlAck");
                        } else this._acceptControlPromise ? this._acceptControlPromise.reject(new Error("accept control - times out in bad state - do nothing")) : this._logger.error(`Unexpected, no promise could be resolved - controlState=${toControlStateString(this.controlState)}`);
                        this._acceptControlTimer = null;
                    }, Na), this._acceptControlPromise.promise) : (this._logger.error("Failed to send the accept control request"), this._acceptControlPromise.reject(new Error), Promise.reject(new Error("Failed to send the accept control request!")));
                }
                _sendControlAcceptRequest(g, f) {
                    const S = this._sendRequest({
                        action: 3,
                        terminatedReason: 0,
                        causeId: g
                    }, f);
                    return this._recordSharerSessionTelemetry((S)=>S.controlRequestAccept(g, f)), S;
                }
                _sendControlRejectRequest(g, f, S) {
                    const v = this._sendRequest({
                        action: 4,
                        terminatedReason: f
                    }, S);
                    return this._recordSharerSessionTelemetry((v)=>v.controlRequestRejected(g, f, S)), v;
                }
                _cancelAcceptControlTimer() {
                    this._acceptControlTimer && (this._acceptControlPromise && this._acceptControlPromise.reject(new Error("cancelled by _cancelAcceptControlTimer")), clearTimeout(this._acceptControlTimer), this._acceptControlTimer = null);
                }
                denyControlRequest() {
                    return this._enabled ? this._isDataChannelActive() ? this._controlRequest ? this._isSharing() ? this._acceptControlPromise ? Promise.reject(new Error("Accept control promise has not been resolved yet while denying control")) : this._grantControlPromise ? Promise.reject(new Error("Grant control promise has not been resolved yet while denying control")) : this._terminateControlPromise ? Promise.reject(new Error("Terminate control promise has not been resolved yet while denying control")) : this._denyControlRequest() : Promise.reject(new Error("denyControlRequest when not sharing")) : Promise.reject(new Error("denyControlRequest while no control request pending")) : Promise.reject(new Error("denyControlRequest when data channel not active")) : Promise.reject(new Error("denyControlRequest when feature not enabled"));
                }
                _denyControlRequest() {
                    this._logger.info("_denyControlRequest()");
                    const g = this._getDataSourceIdForParticipantLeg(this._controlRequest), f = this._controlRequest.causeId;
                    this._clearControlRequest();
                    return this._sendControlRejectRequest(f, 1, g) ? Promise.resolve() : Promise.reject(new Error("Failed to send the deny control requst"));
                }
                grantControl(g) {
                    return this._enabled ? this._isDataChannelActive() ? this._controlRequest ? Promise.reject(new Error("grantControl called while control request pending")) : this._isSharing() ? g ? this._acceptControlPromise ? Promise.reject(new Error("Accept control promise has not been resolved yet while granting control")) : this._grantControlPromise ? Promise.reject(new Error("Grant control promise has not been resolved yet while granting control")) : this._terminateControlPromise ? Promise.reject(new Error("Terminate control promise has not been resolved yet while granting control")) : this._grantControl(g) : Promise.reject(new Error("grantControl null participant")) : Promise.reject(new Error("grantControl when not sharing")) : Promise.reject(new Error("grantControl when data channel not active")) : Promise.reject(new Error("grantControl when feature not enabled"));
                }
                _grantControl(g) {
                    this._logger.info("_grantControl()"), this._grantControlPromise = new ct;
                    const always = ()=>{
                        this._grantControlPromise = null;
                    };
                    if (this._grantControlPromise.promise.then(always, always), 3 === this.controlState) {
                        if (this._controllerParticipant.participant === g) return this._logger.warn("_grantControl called for participant who already has control"), this._grantControlPromise.resolve(), new Promise((g, f)=>{
                            g();
                        });
                        {
                            this._logger.warn("_grantControl called while another participant already has control - terminating control"), this._teardownSharerRemoteControl();
                            const g = this._getDataSourceIdForParticipantLeg(this._controllerParticipant);
                            this._sendRequest({
                                action: 7,
                                terminatedReason: 5
                            }, g) || this._logger.error("Failed to send the terminateNoAck request");
                        }
                    }
                    const f = this._mapParticipantToSourceId(g), S = generateCauseId(), v = this._sendRequest({
                        action: 6,
                        terminatedReason: 0,
                        causeId: S
                    }, f);
                    if (this._recordSharerSessionTelemetry((g)=>g.giveControl(S, f)), !v) return this._logger.error("Failed to send the grant control request"), this._grantControlPromise.reject(new Error), Promise.reject(new Error("Failed to send the grant control request!"));
                    const _ = this._getParticipantIdForDataSourceId(g, f);
                    return this._resetControllerParticipant({
                        participant: g,
                        participantState: g.state,
                        participantId: _,
                        causeId: S
                    }), this.controlState = 2, this._grantControlTimer = window.setTimeout(()=>{
                        if (2 === this.controlState) {
                            this.controlState = 0, this._resetControllerParticipant(), this._logger.error("No ack received when granting control - terminating control");
                            this._sendRequest({
                                action: 7,
                                terminatedReason: 4
                            }, f) || this._logger.error("Failed to send the terminateNoAck request"), this._recordSharerSessionTelemetry((g)=>g.giveControlFailed(S, 4)), this._grantControlPromise ? this._grantControlPromise.reject(new Error("No ack received when granting control - terminating control")) : this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForControlAck");
                        } else this._grantControlPromise ? this._grantControlPromise.reject(new Error("Grant control - times out in bad state - do nothing")) : this._logger.error(`Unexpected, no promise could be resolved - controlState=${toControlStateString(this.controlState)}`);
                        this._grantControlTimer = null;
                    }, Na), this._grantControlPromise.promise;
                }
                _cancelGrantControlTimer() {
                    this._grantControlTimer && (this._grantControlPromise && this._grantControlPromise.reject(new Error("cancelled by _cancelGrantControlTimer")), clearTimeout(this._grantControlTimer), this._grantControlTimer = null);
                }
                _mapParticipantToSourceId(g) {
                    return this._dataChannelAdapter.isActive() ? getSourceIdForMediaType(g, 3) : (this._logger.error("Null data channel cannot map participant to source id"), -1);
                }
                _getParticipantsDataSourceIds(g) {
                    const f = [];
                    try {
                        var _g_endpoints;
                        if (g === null || g === void 0 ? void 0 : (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails) {
                            if (1 === g.endpoints.endpointDetails.length) {
                                const S = g.endpoints.endpointDetails[0];
                                if (!(S === null || S === void 0 ? void 0 : S.mediaStreams)) return f.push(bi), f;
                            }
                            for (const S of g.endpoints.endpointDetails)if (S === null || S === void 0 ? void 0 : S.mediaStreams) {
                                for (const g of S.mediaStreams)if (3 === mapMediaTypeStringToMediaType(g.type)) {
                                    if (f.push(g.sourceId), f.length >= 8) return this._logger.error("Excessive amount of data streams"), f;
                                    break;
                                }
                            }
                        }
                    } catch (g) {
                        this._logger.error(`_getParticipantsDataSourceIds caught exception error=${g}`);
                    }
                    return f;
                }
                _getParticipantIdForDataSourceId(g, f) {
                    return getParticipantIdForSourceId(g, 3, f);
                }
                _getDataSourceIdForParticipantId(g, f) {
                    return this._dataChannelAdapter.isActive() ? getSourceId(g, f, 3) : (this._logger.error("Null data channel cannot map participant to source id"), -1);
                }
                _getDataSourceIdForParticipantLeg(g) {
                    return this._getDataSourceIdForParticipantId(g.participant, g.participantId);
                }
                _getSharerDataSourceId() {
                    const g = getSharingParticipantLeg(this._sharerParticipant);
                    return g ? this._getDataSourceIdForParticipantId(this._sharerParticipant, g) : (this._logger.warn("Unable to identify the sharer participantId, falling back to first data channel"), this._mapParticipantToSourceId(this._sharerParticipant));
                }
                terminateControl(g) {
                    if (this._isViewing()) {
                        if (4 !== this.controlState) return Promise.reject(new Error("terminateControl called while not in control"));
                        if (!this._sharerParticipant) return Promise.reject(new Error("terminateControl called but _sharerParticipant is null"));
                    } else {
                        if (!this._isSharing()) return Promise.reject(new Error("terminateControl called but not sharing nor viewing"));
                        if (!this._controllerParticipant) return Promise.reject(new Error("terminateControl called but controllerParticipant is null"));
                    }
                    return this._requestControlPromise ? Promise.reject(new Error("Request control promise has not been resolved yet while terminating control")) : this._acceptControlPromise ? Promise.reject(new Error("Accept control promise has not been resolved yet while terminating control")) : this._grantControlPromise ? Promise.reject(new Error("Grant control promise has not been resolved yet while terminating control")) : this._terminateControlPromise ? Promise.reject(new Error("Terminate control promise has not been resolved yet while terminating control")) : this._terminateControl(!0, g);
                }
                _terminateControl(g, f) {
                    this._logger.info("_terminateControl()"), this._terminateControlPromise = new ct;
                    const always = ()=>{
                        this._terminateControlPromise = null;
                    };
                    this._terminateControlPromise.promise.then(always, always);
                    let S = 0;
                    const v = g ? 8 : 7;
                    let _, C;
                    if (this._isViewing()) {
                        if (4 !== this.controlState) return this._logger.error("Local viewer called terminateControl when not controlling"), this._terminateControlPromise.reject(new Error), Promise.reject(new Error("Local viewer called terminateControl when not controlling"));
                        this._teardownViewerRemoteControl(), S = f !== null && f !== void 0 ? f : 6, _ = this._getSharerDataSourceId(), this._recordViewerSessionTelemetry((g)=>g.controlTerminated(this._controlCauseId, S, _)), C = Fa, this._logger.info(`Terminating remote control reason: ${toControlTerminatedReason(S)},  recipient: ${_}, controllerId: ${C}`);
                    } else {
                        if (3 !== this.controlState || !this._controllerParticipant) return this._logger.error("Local sharer called terminateControl when no one is in control"), this._terminateControlPromise.reject(new Error), Promise.reject(new Error("Local sharer called terminateControl when no one is in control"));
                        this._teardownSharerRemoteControl(), S = f !== null && f !== void 0 ? f : 5, _ = this._getDataSourceIdForParticipantLeg(this._controllerParticipant), this._recordSharerSessionTelemetry((g)=>g.controlTerminated(this._controlCauseId, S, _)), C = scrubMriOrOmit(this._controllerParticipant.participant.id), this._logger.info(`Terminating control on the sharer side, reason: ${toControlTerminatedReason(S)}, recipient: ${_}, controllerId: ${C}`);
                    }
                    const E = {
                        action: v,
                        terminatedReason: S
                    };
                    if (!this._sendRequest(E, _)) {
                        if (g) return this._logger.error("Failed to send the terminate control request"), this._terminateControlPromise.reject(new Error), Promise.reject(new Error("Failed to send the grant control request!"));
                        this._logger.error("Failed to send the terminateNoAck request");
                    }
                    this.controlState = g ? 5 : 0;
                    const T = {
                        inControl: !1,
                        id: C,
                        terminatedReason: E.terminatedReason
                    };
                    return this._logger.info(`raising event sharingControlChanged reason=${toControlTerminatedReason(T.terminatedReason)} controlState=${toControlStateString(this.controlState)}`), this.event("sharingControlChanged").raise(T), g ? (this._terminateControlTimer = window.setTimeout(()=>{
                        if (5 === this.controlState) {
                            this.controlState = 0, this._resetControllerParticipant(), this._logger.error("No ack received when terminating control - resending terminate request");
                            this._sendRequest({
                                action: 7,
                                terminatedReason: 4
                            }, _) || this._logger.error("Failed to send the terminateNoAck request"), this._terminateControlPromise ? this._terminateControlPromise.reject(new Error("No ack received when terminating control - resending terminate request")) : this._logger.error("Unexpected, no promise could be resolved - controlState=WaitingForTerminateAck");
                        } else this._terminateControlPromise ? this._terminateControlPromise.reject(new Error("terminate control - times out in bad state - do nothing")) : this._logger.error(`Unexpected, no promise could be resolved - controlState=${toControlStateString(this.controlState)}`);
                        this._terminateControlTimer = null;
                    }, Na), this._terminateControlPromise.promise) : (this._terminateControlPromise.resolve(), new Promise((g, f)=>{
                        g();
                    }));
                }
                _cancelTerminateControlTimer() {
                    this._terminateControlTimer && (this._terminateControlPromise && this._terminateControlPromise.reject(new Error("cancelled by _cancelTerminateControlTimer")), clearTimeout(this._terminateControlTimer), this._terminateControlTimer = null, this._logger.info("_cancelTerminateControlTimer()"));
                }
                _disposeControlCapturer(g = generateCauseId()) {
                    this._logger.info(`_disposeControlCapturer causeId: ${g}`), this._clearCapturerEventSubscriptions(), this._controlCapturer && (this._controlCapturer.dispose(g), this._controlCapturer = null);
                }
                dispose(g) {
                    this._logger.info(`dispose causeId: ${g}`), this._dataChannelAdapter.dispose(g), this._resetControlState(), this._disposeRenderer(g), this._cancelRequestControlTimer(), this._cancelAcceptControlTimer(), this._cancelGrantControlTimer(), this._cancelTerminateControlTimer(), this._terminateAvailableHandshake && this._terminateAvailableHandshake(2), this._call = null, this._resetParticipantSubscriptions(), this._finalizeViewerSessionTelemetry(), this._finalizeSharerSessionTelemetry(), super.dispose(g);
                }
                constructor(g, f, S, v){
                    super(g), this._logger = g, this._call = f, this._telemetryLoggers = S, this._config = v, this.controlState = 0, this.role = 0, this._enabled = !1, this._availableAckEnabled = !0, this._clientConfiguration = {}, this._dataChannelAvailable = !1, this._availableHandshakeSent = !1, this._controlRequest = null, this._controlRequestSubscription = null, this._controlCauseId = null, this._controllerParticipant = null, this._controllerParticipantSubscription = null, this._controllerSourceId = null, this._screenSharingVideoRenderer = null, this._screenSharingVideoRendererSubscriptions = [], this._sharerParticipant = null, this._pendingSharer = null, this._controlCapturer = null, this._captureEventSubscription = null, this._mouseControlEventSubscription = null, this._keyboardControlEventSubscription = null, this._requestControlTimer = null, this._grantControlTimer = null, this._acceptControlTimer = null, this._terminateControlTimer = null, this._delayedSendHandshakeTimer = null, this._availableAckTimer = null, this._retryAttempt = 0, this._raiseRenderedAtViewer = null, this._participantSubscriptions = {}, this._viewerSessionLastTerminatedReason = 0, this._completedViewerSessions = [], this.isEscalationInProgress = !1, this._logger.info("constructor"), this._callId = this._call.callId, this._call.on("callIdChanged", (g)=>{
                        this._callId = g, this._currentViewerSessionTelemetry && this._currentViewerSessionTelemetry.setCallId(g), this._currentSharerSessionTelemetry && this._currentSharerSessionTelemetry.setCallId(g);
                    }), this._participantId = this._call.participantId, this._call.on("callLegIdChanged", (g)=>{
                        this._participantId = g, this._currentViewerSessionTelemetry && this._currentViewerSessionTelemetry.setParticipantId(g), this._currentSharerSessionTelemetry && this._currentSharerSessionTelemetry.setParticipantId(g);
                    }), this._endpointId = this._call.endpointId;
                }
            };
            function toAvailableHandshakeTerminatedString(g) {
                switch(g){
                    case 1:
                        return "Succeeded";
                    case 2:
                        return "Shutdown";
                    case 3:
                        return "DataChannel";
                    case 4:
                        return "Replaced";
                    case 5:
                        return "TimedOut";
                    case 6:
                        return "UnknownSender";
                    case 7:
                        return "SharerDenied";
                    default:
                        return "Unknown";
                }
            }
            function toControlActionString(g) {
                switch(g){
                    case 0:
                        return "Available";
                    case 1:
                        return "ControlRequest";
                    case 2:
                        return "CancelControlRequest";
                    case 3:
                        return "AcceptRequest";
                    case 4:
                        return "RejectRequest";
                    case 5:
                        return "Ack";
                    case 6:
                        return "GiveControl";
                    case 7:
                        return "TerminateNoAck";
                    case 8:
                        return "Terminate";
                    case 9:
                        return "AvailableAck";
                    case 10:
                        return "AvailableNack";
                    case 11:
                        return "RenderedAtViewer";
                    default:
                        return "Unknown";
                }
            }
            function toControlStateString(g) {
                switch(g){
                    case 0:
                        return "None";
                    case 1:
                        return "RequestSent";
                    case 2:
                        return "WaitingForControlAck";
                    case 3:
                        return "RemoteControlling";
                    case 4:
                        return "LocalControlling";
                    case 5:
                        return "WaitingForTerminateAck";
                    default:
                        return "Unknown";
                }
            }
            function toControlTerminatedReason(g) {
                switch(g){
                    case 0:
                        return "None";
                    case 1:
                        return "SharerDenied";
                    case 2:
                        return "SharerNoResponse";
                    case 3:
                        return "SharerBusy";
                    case 4:
                        return "AckTimeout";
                    case 5:
                        return "SharerTerminated";
                    case 6:
                        return "ViewerTerminated";
                    case 7:
                        return "DataChannelError";
                    case 8:
                        return "ViewerCancelled";
                    case 9:
                        return "SharerControlDisabled";
                    case 10:
                        return "UnknownSender";
                    case 11:
                        return "MultipleSharers";
                    default:
                        return "Unknown";
                }
            }
            var Ha = ((g)=>(g[g.LEFT = 0] = "LEFT", g[g.RIGHT = 1] = "RIGHT", g[g.MIDDLE = 2] = "MIDDLE", g[g.BACK = 3] = "BACK", g[g.FORWARD = 4] = "FORWARD", g))(Ha || {}), $a = ((g)=>(g[g.SCAN_CODE = 0] = "SCAN_CODE", g[g.VIRTUAL_KEY = 1] = "VIRTUAL_KEY", g[g.RECOGNITION_INPUT = 2] = "RECOGNITION_INPUT", g))($a || {}), ja = class {
                toEdgeControlMouseEvent(g) {
                    let f;
                    switch(g.type){
                        case 0:
                            return {
                                event: this.toMouseMoveEvent(g),
                                apiName: "injectMouseMoveEvent"
                            };
                        case 1:
                            return {
                                event: this.toMouseWheelEvent(g),
                                apiName: "injectMouseWheelEvent"
                            };
                        case 2:
                            return {
                                event: this.toMouseButtonPressedEvent(g),
                                apiName: "injectMouseButtonEvent"
                            };
                        default:
                            throw f = `Uncovered mouse control event type. Event: ${g}`, this.logger.error(f), Error(f);
                    }
                }
                toEdgeControlKeyboardEvent(g) {
                    return {
                        event: {
                            repeat: g.repeat,
                            keyUp: g.keyUp,
                            codeType: $a[g.codeType],
                            keyCode: g.code
                        },
                        apiName: "injectKeyEvent"
                    };
                }
                toMouseMoveEvent(g) {
                    return {
                        xPos: g.xPos,
                        yPos: g.yPos
                    };
                }
                toMouseWheelEvent(g) {
                    return {
                        wheelButtonDown: g.wheelButtonDown,
                        wheelRotation: g.wheelRotation
                    };
                }
                toMouseButtonPressedEvent(g) {
                    return {
                        xPos: g.xPos,
                        yPos: g.yPos,
                        button: Ha[g.buttonType],
                        buttonDown: g.buttonDown
                    };
                }
                constructor(g){
                    this.logger = g;
                }
            };
            async function pngBase64ToBitmap(g, f, S) {
                return new Promise((v, _)=>{
                    const C = $cf5b5da7977a3fc4$require$Buffer.from(g, "base64"), E = document.createElement("canvas").getContext("2d"), T = new Blob([
                        C
                    ], {
                        type: "image/png"
                    });
                    let I = new Image;
                    I.onload = ()=>{
                        E.drawImage(I, 0, 0, I.width, I.height, 0, 0, f, S);
                        const g = E.getImageData(0, 0, f, S);
                        window.URL.revokeObjectURL(I.src), I = null, v(Array.from(g.data));
                    }, I.onerror = (g)=>{
                        _(g);
                    }, I.src = window.URL.createObjectURL(T);
                });
            }
            var Ga = "ncbjelpjchkpbikbpkcchkhkblodoama", qa = class {
                async sendInjectInputEventMessage(g, f) {
                    return this.logger.info("EdgeControlInjectorApi - sendInjectInputEventMessage"), new Promise((S, v)=>{
                        window.top.chrome.runtime.sendMessage(Ga, {
                            api: g,
                            deviceId: this.virtualInputDeviceId,
                            event: f
                        }, (g)=>{
                            g.error ? v(g.error.message) : S(0);
                        });
                    });
                }
                async createInputDeviceId(g, f, S) {
                    this.virtualInputDeviceId && this.logger.warn("EdgeControlInjectorApi - createInputDeviceId virtual input already exists.");
                    try {
                        this.virtualInputDeviceId = await this.sendCreateInputDeviceMessage(g, S);
                    } catch (g) {
                        this.logger.error(`EdgeControlInjectorApi - createInputDevice failed, error: ${JSON.stringify(g)}`), f();
                    }
                }
                async sendSetLocalUserAvatarMessage(g) {
                    const f = await this.generateAvatarBitmap(g);
                    return new Promise((g, S)=>{
                        const v = window.top;
                        f && v.chrome.runtime.sendMessage(Ga, {
                            api: "setLocalUserAvatar",
                            avatarBitmap: f
                        }, (f)=>{
                            f.error ? S(f.error.message) : g();
                        });
                    });
                }
                async sendCloseVirtualInputDeviceMessage() {
                    const g = this.virtualInputDeviceId;
                    return g ? (this.logger.info("EdgeControlInjectorApi - sendCloseVirtualInputDeviceMessage called"), new Promise((f, S)=>{
                        const v = window.top;
                        v.chrome.runtime.sendMessage(Ga, {
                            api: "closeInputDevice",
                            deviceId: g
                        }, (g)=>{
                            g ? g.error ? S(g.error.message) : (this.virtualInputDeviceId = null, f(g.deviceId)) : S(v.chrome.runtime.lastError.message);
                        });
                    })) : (this.logger.info("EdgeControlInjectorApi - VirtualInputDevice does not exists, nothing to close."), Promise.resolve());
                }
                async sendCreateInputDeviceMessage(g, f) {
                    this.logger.info("EdgeControlInjectorApi - sendCreateInputDeviceMessage called");
                    const S = await this.generateAvatarBitmap(f);
                    return new Promise((f, v)=>{
                        const _ = window.top, messageCallback = (g)=>{
                            g ? g.deviceId ? f(g.deviceId) : g.error ? v(g.error.message) : v("Error: Unexpected response from API") : v(_.chrome.runtime.lastError.message);
                        };
                        S ? _.chrome.runtime.sendMessage(Ga, {
                            api: "createInputDevice",
                            mediaStreamTrackId: g,
                            avatarBitmap: S
                        }, messageCallback) : _.chrome.runtime.sendMessage(Ga, {
                            api: "createInputDevice",
                            mediaStreamTrackId: g
                        }, messageCallback);
                    });
                }
                async generateAvatarBitmap(g) {
                    if (!g) return null;
                    try {
                        const f = 32;
                        return {
                            width: f,
                            height: f,
                            data: await pngBase64ToBitmap(g, f, f)
                        };
                    } catch (g) {
                        return this.logger.error(`EdgeControlInjectorApi - generateAvatarBitmap error: ${JSON.stringify(g)}, continue without avatar.`), null;
                    }
                }
                constructor(g){
                    this.logger = g;
                }
            };
            async function sendIsVirtualInputSupportedMessage(g) {
                return new Promise((f, S)=>{
                    g.info("EdgeControlInjectorApi - sendIsVirtualInputSupportedMessage");
                    const v = window.top;
                    v.chrome.runtime.sendMessage(Ga, {
                        api: "isVirtualInputSupported"
                    }, (g)=>{
                        var _v_chrome_runtime_lastError;
                        g ? g.error ? f(g.error.message) : f(g) : S((_v_chrome_runtime_lastError = v.chrome.runtime.lastError) === null || _v_chrome_runtime_lastError === void 0 ? void 0 : _v_chrome_runtime_lastError.message);
                    });
                });
            }
            var Wa, za, Ka = class {
                showVirtualCursor(g, f) {
                    if (this.logger.info(`EdgeControlInjector - showVirtualCursor, id: ${g} sharingTrackId: ${this.sharingTrackId}`), f) {
                        this.edgeApi.createInputDeviceId(this.sharingTrackId, this.onInitErrorCallback, this.images[g]);
                        const f = this.images[0];
                        f ? this.edgeApi.sendSetLocalUserAvatarMessage(f) : this.logger.error("EdgeControllerInjector - local avatar is missing, continue without local avatar");
                    } else this.edgeApi.sendCloseVirtualInputDeviceMessage();
                }
                setAvatar(g, f) {
                    this.logger.info(`${g} EdgeControlInjector - setAvatar, id: ${g}, data: ${JSON.stringify(f)}`), this.images[g] = f;
                }
                async injectMouseEvent(g, f) {
                    this.logger.info(`${g} EdgeControlInjector - injectMouseEvent ${JSON.stringify(f)}`);
                    const S = this.controlEventConverter.toEdgeControlMouseEvent(f);
                    return this.edgeApi.sendInjectInputEventMessage(S.apiName, S.event);
                }
                async injectKeyboardEvent(g, f) {
                    const S = this.controlEventConverter.toEdgeControlKeyboardEvent(f);
                    return this.edgeApi.sendInjectInputEventMessage(S.apiName, S.event);
                }
                injectClipboardText(g, f) {
                    return this.logger.info(`${g} EdgeControlInjector - injectClipboardText is unimplemented`), Promise.resolve(0);
                }
                dispose(g) {
                    this.logger.info("EdgeControlInjector - dispose"), this.edgeApi.sendCloseVirtualInputDeviceMessage();
                }
                constructor(g, f, S){
                    this.logger = g, this.sharingTrackId = f, this.onInitErrorCallback = S, this.images = new Map, this.controlEventConverter = new ja(g), this.edgeApi = new qa(this.logger);
                }
            }, Ja = "undefined" != typeof navigator && void 0 !== ((_navigator_mediaDevices = navigator.mediaDevices) === null || _navigator_mediaDevices === void 0 ? void 0 : _navigator_mediaDevices.getUserMedia), Ya = ((g)=>(g.AVD = "43", g.Citrix = "44", g.VMware = "45", g))(Ya || {});
            function setAgentPlatformInfo(g = "") {
                const f = g.match(new RegExp("^SkypeSpaces/(\\d+)/"));
                (f === null || f === void 0 ? void 0 : f.length) && Object.values(Ya).includes(f[1]) && (za = f[1]), overrideGetUserMediaIfNeeded();
            }
            function isVdiPlatform() {
                return !!za;
            }
            function getVdiPlatform() {
                return za;
            }
            function overrideGetUserMediaIfNeeded() {
                "undefined" != typeof window && "undefined" != typeof navigator && (void 0 !== navigator.webkitGetUserMedia && "undefined" != typeof webkitRTCPeerConnection && isVdiPlatform() ? (window.RTCPeerConnection = webkitRTCPeerConnection, navigator.getUserMedia = (g, f, S)=>{
                    const polyfillDeviceId = (g)=>{
                        var _g_deviceId;
                        (g === null || g === void 0 ? void 0 : (_g_deviceId = g.deviceId) === null || _g_deviceId === void 0 ? void 0 : _g_deviceId.exact) && (g.mandatory || (g.mandatory = {}), g.mandatory.sourceId = g.deviceId.exact, delete g.deviceId);
                    };
                    return g && (polyfillDeviceId(g.audio), polyfillDeviceId(g.video)), navigator.webkitGetUserMedia(g, f, S);
                }) : Ja && overrideGumSourceFromWebkit());
            }
            function overrideGumSourceFromWebkit() {
                navigator.getUserMedia = function(g, f, S) {
                    return navigator.mediaDevices.getUserMedia(g).then(f).catch(S);
                };
            }
            "undefined" != typeof window && "undefined" != typeof navigator && (Wa = window, window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL, window.MediaStream = window.MediaStream || window.webkitMediaStream || window.mozMediaStream || window.msMediaStream, window.AudioContext = window.AudioContext || window.webkitAudioContext);
            var Qa = {
                window: Wa
            }, Xa = class {
                static create(g, f) {
                    return g.config.enableGiveControl ? isVdiPlatform() || window.ControlInjector ? new es(f) : Ze.isBrowser("EdgeAnaheim") ? new Za(f) : new ts(f) : new ts(f);
                }
                async enableInjector(g) {
                    this.injector && this.logger.warn("Control injector already present when enabling injector");
                    try {
                        this.injector = this.createInjector(g);
                    } catch (g) {
                        throw this.logger.error(`Control injector creation failed: ${g}`), g;
                    }
                    this.pendingPointerImages.forEach((g, f)=>{
                        this.injector.setAvatar(f, g);
                    }), this.pendingPointerImages.clear();
                }
                async disableInjector() {
                    this.injector || this.logger.warn("Control injector not present when disabling injector"), this.logger.info("ControlInjector disposed"), this.injector.dispose(), this.injector = null;
                }
                async setPointerImage(g, f) {
                    this.injector ? this.injector.setAvatar(g, f) : this.pendingPointerImages.set(g, f);
                }
                async showVirtualCursor(g) {
                    if (this.logger.info(`showVirtualCursor ${g} ${this.activeSourceId}`), !this.injector) throw new Error("Control injector not present");
                    g ? (this.activeSourceId && this.injector.showVirtualCursor(this.activeSourceId, !1), this.injector.showVirtualCursor(g, !0), this.activeSourceId = g) : this.activeSourceId && (this.injector.showVirtualCursor(this.activeSourceId, !1), this.activeSourceId = 0);
                }
                async injectRawInput(g, f) {
                    if (!this.injector) throw new Error("Control injector not present");
                    const S = this.injector;
                    return new Promise((v, _)=>{
                        let C, E;
                        const T = ha.decodeEventType(g);
                        switch(T){
                            case 1:
                                C = ha.decodeMouseEvent(g), S.injectMouseEvent(f, C).then((g)=>0 === g ? v() : _());
                                break;
                            case 0:
                                E = ha.decodeKeyboardEvent(g), S.injectKeyboardEvent(f, E).then((g)=>0 === g ? v() : _());
                                break;
                            default:
                                this.logger.error(`Invalid event type in raw input: ${T}`), _();
                        }
                    });
                }
                constructor(g){
                    this.logger = g, this.activeSourceId = 0, this.pendingPointerImages = new Map;
                }
            }, Za = class extends Xa {
                canBeEnabled() {
                    return this.edgeVirtualInputSupported;
                }
                createInjector(g) {
                    if (!this.edgeVirtualInputSupported) return void this.logger.info("Edge doesn't support give control");
                    const f = new Ka(this.logger, g, ()=>{
                        this.logger.error("An error occured, disabling control injector."), this.disableInjector();
                    });
                    return this.logger.info("Edge ControlInjector created"), f;
                }
                constructor(g){
                    super(g.createChild("EdgeControlInjector")), this.edgeVirtualInputSupported = !1, sendIsVirtualInputSupportedMessage(g).then((f)=>{
                        this.edgeVirtualInputSupported = f, g.info(`Edge supports virtual input device: ${JSON.stringify(this.edgeVirtualInputSupported)}`);
                    }).catch((f)=>{
                        g.info(`Edge IsVirtualInputSupported: ${JSON.stringify(f)}`);
                    });
                }
            }, es = class extends Xa {
                canBeEnabled() {
                    return !!window.ControlInjector;
                }
                createInjector(g) {
                    const f = window.ControlInjector(g);
                    return this.logger.info("Window ControlInjector created"), f;
                }
                constructor(g){
                    super(g.createChild("WindowControlInjector"));
                }
            }, ts = class extends Xa {
                canBeEnabled() {
                    return !1;
                }
                createInjector() {
                    throw new Error("Control injector creation is disabled");
                }
                constructor(g){
                    super(g.createChild("NoopControlInjector"));
                }
            }, is = class {
                getTarget(g) {
                    return g.target;
                }
                subscribeVideoSizeChangedEvent(g, f) {
                    const S = g;
                    return S.streamSize && f(S.streamSize.width, S.streamSize.height), S.renderer.on("onVideoSizeChanged", f);
                }
                subscribeRenderStartedEvent(g, f) {
                    return g.renderer.on("onVideoStarted", (g, S)=>f());
                }
                constructor(g){
                    this.logger = g, this.logger.info("RendererAdapter");
                }
            };
            function bufferToString(g) {
                return String.fromCharCode.apply(null, g);
            }
            var ns = class extends ze {
                isActive() {
                    return !(!this.protocolSendFunc || !this.controlSendFunc);
                }
                sendProtocolMessage(g, f) {
                    return this.protocolSendFunc ? this.protocolSendFunc(g, f) : (this.logger.error("Cannot send protocol message, ProtocolHandler hasn't started"), Promise.resolve());
                }
                sendControlMessage(g, f) {
                    return this.controlSendFunc ? this.controlSendFunc(g, f) : (this.logger.error("Cannot send control message, ControlHandler hasn't started"), Promise.resolve());
                }
                getProtocolHandler() {
                    return {
                        onStarted: async (g, f)=>{
                            this.logger.info(`ProtocolHandler started for ${g}`), this.protocolSendFunc = f, this.isActive() && this.event("stateChange").raise(!0);
                        },
                        onStopped: async (g)=>{
                            this.logger.info(`ProtocolHandler stopped for ${g}`);
                            const f = this.isActive();
                            this.protocolSendFunc = null, f && this.event("stateChange").raise(!1);
                        },
                        onDataReceived: async (g, f, S)=>{
                            if (1 === g) {
                                const g = JSON.parse(bufferToString(f)), v = this._call.mapDataChannelSourceIdToParticipant(S);
                                let _;
                                return v && (_ = getParticipantIdForSourceId(v, 3, S)), this.event("protocolMessage").raise(g.message, v, _, S);
                            }
                        }
                    };
                }
                getControlHandler() {
                    return {
                        onStarted: async (g, f)=>{
                            this.logger.info(`ControlHandler started for ${g}`), this.controlSendFunc = f, this.isActive() && this.event("stateChange").raise(!0);
                        },
                        onStopped: async (g)=>{
                            this.logger.info(`ControlHandler stopped for ${g}`);
                            const f = this.isActive();
                            this.controlSendFunc = null, f && this.event("stateChange").raise(!1);
                        },
                        onDataReceived: async (g, f, S)=>{
                            if (2 === g) return this.event("controlMessage").raise(f, S);
                        }
                    };
                }
                constructor(g, f){
                    super(g), this.logger = g, this._call = f;
                }
            }, rs = class extends Ba {
                setupDataHandlers() {
                    this.dataChannel.addHandler(1, this.getProtocolHandler()), this.dataChannel.addHandler(2, this.getControlHandler());
                }
                startOrStopControlForViewer(g, f, S) {
                    if (g && "nonInteractive" !== (S === null || S === void 0 ? void 0 : S.appliedInteractivityLevel)) {
                        if (f && 0 === this.role) {
                            var _f_streams__find;
                            const g = (_f_streams__find = f.streams[1].find((g)=>g.isAvailable)) === null || _f_streams__find === void 0 ? void 0 : _f_streams__find.negotiationTag;
                            this.initControlForViewer(f, g);
                        }
                    } else 2 === this.role && this.shutdownControlForViewer();
                }
                getProtocolHandler() {
                    return this._dataChannelAdapter.getProtocolHandler();
                }
                getControlHandler() {
                    return this._dataChannelAdapter.getControlHandler();
                }
                constructor(g, f, S, v, _, C){
                    const E = {}, T = _.getEcsConfig("SkypeCalling", "gtcHandshakeSendDelay");
                    if (T) try {
                        E.handshakeSendDelay = JSON.parse(T);
                    } catch (f) {
                        g.error(`Failed to parse ecs config gtcAvailableAckDelay: ${stringifyObject(f)}`);
                    }
                    super(g.createChild("ScreenSharingControl"), S, v, E), this.dataChannel = f;
                    const I = Xa.create(C, g), b = new is(this._logger), A = new ns(this._logger, S);
                    this.setAdapters(I, b, A);
                }
            };
            function createParticipantListFromMriMap(g) {
                const f = [];
                for(const S in g)if (g[S].participantLegIdMap) for(const v in g[S].participantLegIdMap){
                    const _ = g[S].participantLegIdMap[v].endpointId;
                    f.push({
                        id: S,
                        mri: S,
                        participantId: v,
                        ..._ && {
                            endpointId: _
                        }
                    });
                }
                else f.push({
                    id: S,
                    mri: S
                });
                return f;
            }
            function mapParticipantScope(g) {
                switch(g){
                    case 1:
                        return "specified";
                    case 0:
                        return "all";
                    case 3:
                        return "attendees";
                    case 2:
                        return "presenters";
                    case 4:
                        return "self";
                    default:
                        return "none";
                }
            }
            var as = {};
            __export(as, {
                addReceiveDirectionality: ()=>addReceiveDirectionality,
                allowDataChannel: ()=>allowDataChannel,
                areNegotiatedDirectionsAcceptable: ()=>areNegotiatedDirectionsAcceptable,
                areNegotiatedDirectionsFulfilled: ()=>areNegotiatedDirectionsFulfilled,
                areSendDirectionsFulfilled: ()=>areSendDirectionsFulfilled,
                canUseWebrtc1_0: ()=>canUseWebrtc1_0,
                convertToCodecInfo: ()=>convertToCodecInfo,
                getAllowedCodecs: ()=>getAllowedCodecs,
                getSrtpInfo: ()=>getSrtpInfo,
                hasReceiveDirectionality: ()=>hasReceiveDirectionality,
                hasSendDirectionality: ()=>hasSendDirectionality,
                invertModalities: ()=>invertModalities,
                ipAddressConverter: ()=>ipAddressConverter,
                ipV4RegExp: ()=>os,
                ipV6RegExp: ()=>ls,
                ipv4AddressConverter: ()=>ipv4AddressConverter,
                ipv6AddressConverter: ()=>ipv6AddressConverter,
                isOnHold: ()=>isOnHold,
                mediaTypeToModality: ()=>mediaTypeToModality,
                modalityToMediaType: ()=>modalityToMediaType,
                negotiateDirectionality: ()=>negotiateDirectionality,
                negotiateModalities: ()=>negotiateModalities,
                parseCandidateString: ()=>parseCandidateString,
                preferSdesSrtp: ()=>preferSdesSrtp,
                printMediaStream: ()=>printMediaStream,
                removeChangedSendDirection: ()=>removeChangedSendDirection,
                removeSendDirectionality: ()=>removeSendDirectionality,
                scrubConstraints: ()=>scrubConstraints,
                scrubDevices: ()=>scrubDevices,
                scrubObjectExcludingFields: ()=>scrubObjectExcludingFields,
                scrubObjectFields: ()=>scrubObjectFields2,
                scrubSelectedDevices: ()=>scrubSelectedDevices,
                sendStreamsToModalities: ()=>sendStreamsToModalities
            });
            var ss = class _UserAgentConfig extends Bt {
                get isAudioOutputSelectionSupported() {
                    return this.isAudioOutputSelectionSupportedValue;
                }
                get isBrowserRollbackSupported() {
                    return this.isRollbackSupportedValue;
                }
                static hasApplyConstraints() {
                    return void 0 !== MediaStreamTrack.prototype.applyConstraints;
                }
                static hasPermissionsApi() {
                    return void 0 !== navigator.permissions && !Ze.isBrowser("Firefox");
                }
                static get hardwareConcurrency() {
                    return window.navigator.hardwareConcurrency;
                }
                static get unmaskedGlRenderer() {
                    if (this.renderer) return this.renderer === Gt.MEDIA_ERROR.webGlRendererError ? void 0 : this.renderer;
                    try {
                        const g = document.createElement("canvas").getContext("webgl"), f = g === null || g === void 0 ? void 0 : g.getExtension("WEBGL_debug_renderer_info"), S = f && g.getParameter(f.UNMASKED_RENDERER_WEBGL);
                        return this.renderer = S, S;
                    } catch (e) {
                        return void (this.renderer = Gt.MEDIA_ERROR.webGlRendererError);
                    }
                }
                async isRollbackSupported() {
                    let g;
                    try {
                        if (g = Qa.window.RTCPeerConnection && new Qa.window.RTCPeerConnection({
                            sdpSemantics: "unified-plan"
                        }), g) {
                            const f = await g.createOffer();
                            await g.setLocalDescription(f), await g.setLocalDescription({
                                type: "rollback"
                            }), this.isRollbackSupportedValue = !0;
                        }
                    } catch (g) {
                        this.isRollbackSupportedValue = !1;
                    } finally{
                        g === null || g === void 0 ? void 0 : g.close();
                    }
                }
                static async isCodecsSupported(g) {
                    const f = {
                        format: "annexb"
                    }, S = 1280, v = 720, _ = [
                        "no-preference",
                        "prefer-software",
                        "prefer-hardware"
                    ], C = [];
                    for (const E of g)for (const g of _){
                        var _window_VideoEncoder, _window_VideoDecoder;
                        const _ = await ((_window_VideoEncoder = window.VideoEncoder) === null || _window_VideoEncoder === void 0 ? void 0 : _window_VideoEncoder.isConfigSupported({
                            codec: E,
                            hardwareAcceleration: g,
                            hevc: f,
                            width: S,
                            height: v
                        })), T = await ((_window_VideoDecoder = window.VideoDecoder) === null || _window_VideoDecoder === void 0 ? void 0 : _window_VideoDecoder.isConfigSupported({
                            codec: E,
                            hardwareAcceleration: g,
                            hevc: f
                        }));
                        if (_ || T) {
                            const g = {
                                name: E,
                                mode: _ === null || _ === void 0 ? void 0 : _.config.hardwareAcceleration,
                                encode: _ === null || _ === void 0 ? void 0 : _.supported,
                                decode: T === null || T === void 0 ? void 0 : T.supported
                            };
                            C.push(g);
                        }
                    }
                    return C;
                }
                static async hasH264CodecSupport(g) {
                    const f = "v=0\no=- 596983 0 IN IP4 127.0.0.1\ns=session\nc=IN IP4 0.0.0.0\nt=0 0\na=msid-semantic: WMS *\nm=video 3480 RTP/SAVPF 107 99\na=rtpmap:107 H264/90000\na=rtpmap:99 rtx/90000\na=fmtp:107 max-fs=240;max-mbps=3600;max-br=208;max-fps=1500;profile-level-id=42C02A;packetization-mode=1\na=fmtp:99 apt=107\na=setup:actpass\na=mid:video\na=recvonly\na=rtcp-mux\na=ice-ufrag:CvYq\na=ice-pwd:axsjsa0GOz3kz6TuGvNgJZWO\na=fingerprint:sha-256 34:DF:5C:15:60:FF:28:3E:E8:96:4B:F8:85:61:E4:C0:57:D1:60:82:21:FD:BC:D2:90:41:06:FA:03:FD:12:A2\n", S = Qa.window.RTCPeerConnection && new Qa.window.RTCPeerConnection;
                    if (!S) return !1;
                    try {
                        return await S.setRemoteDescription({
                            sdp: f,
                            type: "offer"
                        }), !0;
                    } catch (f) {
                        return g.error("H264 not supported", f), !1;
                    } finally{
                        try {
                            S.close();
                        } catch (g) {}
                    }
                }
                static hasMediaApi() {
                    return navigator.getUserMedia && "undefined" != typeof RTCPeerConnection;
                }
                static hasCapabilitiesApi() {
                    var _Qa_window_RTCRtpReceiver;
                    return !!((_Qa_window_RTCRtpReceiver = Qa.window.RTCRtpReceiver) === null || _Qa_window_RTCRtpReceiver === void 0 ? void 0 : _Qa_window_RTCRtpReceiver.getCapabilities);
                }
                static isAudioOutputSelectionSupportedByBrowser() {
                    var _Qa_window_HTMLAudioElement, _Qa_window;
                    return !!((_Qa_window = Qa.window) === null || _Qa_window === void 0 ? void 0 : (_Qa_window_HTMLAudioElement = _Qa_window.HTMLAudioElement) === null || _Qa_window_HTMLAudioElement === void 0 ? void 0 : _Qa_window_HTMLAudioElement.prototype.setSinkId);
                }
                updateConfig() {
                    const g = _UserAgentConfig.isAudioOutputSelectionSupportedByBrowser();
                    g !== this.isAudioOutputSelectionSupportedValue && (this.isAudioOutputSelectionSupportedValue = g, this.event("isAudioOutputSelectionSupportedChanged").raise());
                }
                static hasUnifiedPlanSupport() {
                    let g;
                    try {
                        g = Qa.window.RTCPeerConnection && new Qa.window.RTCPeerConnection({
                            sdpSemantics: "unified-plan"
                        });
                    } catch (g) {
                        return !1;
                    }
                    let f = !1;
                    return g && (f = !!g.addTransceiver, g.close()), f;
                }
                static hasEncodedStreamsApi() {
                    return !!RTCRtpReceiver.prototype.createEncodedStreams || _UserAgentConfig.hasScriptTransformApi();
                }
                static hasScriptTransformApi() {
                    return !!window.RTCRtpScriptTransform;
                }
                static isWakeLockSupported() {
                    return !!window.navigator.wakeLock;
                }
                constructor(g){
                    super(), this.isAudioOutputSelectionSupportedValue = !1, g.on("configUpdated", ()=>this.updateConfig()), this.updateConfig(), this.isRollbackSupported();
                }
            }, os = RegExp(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:[0-9]{1,5})?$/), ls = RegExp(/^\[?(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|:((:[0-9a-fA-F]{1,4}){1,5}|:)((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,5}([0-9a-fA-F]{1,4})?:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\]?(?::\d{1,5})?$/);
            function invertDirectionality(g) {
                switch(g){
                    case Gt.MEDIA_STATE.send:
                        return Gt.MEDIA_STATE.receive;
                    case Gt.MEDIA_STATE.receive:
                        return Gt.MEDIA_STATE.send;
                    default:
                        return g;
                }
            }
            function negotiateDirectionality(g, f) {
                const S = hasSendDirectionality(g) && hasSendDirectionality(f), v = hasReceiveDirectionality(g) && hasReceiveDirectionality(f);
                return S && v ? Gt.MEDIA_STATE.sendReceive : S ? Gt.MEDIA_STATE.send : v ? Gt.MEDIA_STATE.receive : g === Gt.MEDIA_STATE.inactive && f || g && f === Gt.MEDIA_STATE.inactive ? Gt.MEDIA_STATE.inactive : void 0;
            }
            function invertModalities(g) {
                const f = {}, S = invertDirectionality(g.audio);
                S && (f.audio = S);
                const v = invertDirectionality(g.video);
                v && (f.video = v);
                const _ = invertDirectionality(g.sharing);
                _ && (f.sharing = _);
                const C = invertDirectionality(g.data);
                return C && (f.data = C), f;
            }
            function removeSendDirectionality(g) {
                return g === Gt.MEDIA_STATE.sendReceive ? Gt.MEDIA_STATE.receive : void 0;
            }
            function hasSendDirectionality(g) {
                return g === Gt.MEDIA_STATE.send || g === Gt.MEDIA_STATE.sendReceive;
            }
            function hasReceiveDirectionality(g) {
                return g === Gt.MEDIA_STATE.receive || g === Gt.MEDIA_STATE.sendReceive;
            }
            function addReceiveDirectionality(g) {
                return hasReceiveDirectionality(g) ? g : g === Gt.MEDIA_STATE.send ? Gt.MEDIA_STATE.sendReceive : Gt.MEDIA_STATE.receive;
            }
            function isOnHold(g) {
                return !(g.audio !== Gt.MEDIA_STATE.inactive || g.video && g.video !== Gt.MEDIA_STATE.inactive || g.sharing && g.sharing !== Gt.MEDIA_STATE.inactive);
            }
            function negotiateModalities(g, f) {
                const S = {}, v = negotiateDirectionality(g.audio, f.audio);
                v && (S.audio = v);
                const _ = negotiateDirectionality(g.video, f.video);
                _ && (S.video = _);
                const C = negotiateDirectionality(g.sharing, f.sharing);
                C && (S.sharing = C);
                const E = negotiateDirectionality(g.data, f.data);
                return E && (S.data = E), S;
            }
            function isNegotiatedDirectionAcceptable(g, f, S) {
                const v = hasSendDirectionality(g) && hasSendDirectionality(f) || !hasSendDirectionality(g) && !hasSendDirectionality(S), _ = !S || hasReceiveDirectionality(g) && hasReceiveDirectionality(f) || !hasReceiveDirectionality(g) && !hasReceiveDirectionality(S);
                return v && _;
            }
            function areNegotiatedDirectionsAcceptable(g, f, S) {
                return isNegotiatedDirectionAcceptable(g.audio, f.audio, S.audio) && isNegotiatedDirectionAcceptable(g.video, f.video, S.video) && isNegotiatedDirectionAcceptable(g.sharing, f.sharing, S.sharing) && isNegotiatedDirectionAcceptable(g.data, f.data, S.data);
            }
            function areNegotiatedDirectionsFulfilled(g, f) {
                function isNegotiatedDirectionFulfilled(g, f) {
                    const S = hasSendDirectionality(g) === hasSendDirectionality(f), v = hasReceiveDirectionality(g) === hasReceiveDirectionality(f) || hasReceiveDirectionality(g) && !f;
                    return S && v;
                }
                return isNegotiatedDirectionFulfilled(g.audio, f.audio) && isNegotiatedDirectionFulfilled(g.video, f.video) && isNegotiatedDirectionFulfilled(g.sharing, f.sharing) && isNegotiatedDirectionFulfilled(g.data, f.data);
            }
            function areSendDirectionsFulfilled(g, f) {
                const isSendDirectionFulfilled = (g, f)=>hasSendDirectionality(g) === hasSendDirectionality(f);
                return isSendDirectionFulfilled(g.audio, f.audio) && isSendDirectionFulfilled(g.video, f.video) && isSendDirectionFulfilled(g.sharing, f.sharing) && isSendDirectionFulfilled(g.data, f.data);
            }
            function getSrtpInfo(g) {
                const f = {
                    dtls: !1,
                    sdes: !1
                };
                return f.dtls = !!g.fingerprint, g.media.forEach((g)=>{
                    f.dtls = f.dtls || !!g.fingerprint, f.sdes = f.sdes || !!g.crypto;
                }), f;
            }
            function removeChangedSendDirection(g, f) {
                if (!f || isEmpty(f)) return g;
                const S = {};
                return forOwn(g, (g, v)=>{
                    v === Gt.MODALITY.data ? S[v] = removeChangedDataSendDirection(g, f[v]) : S[v] = removeChangedMediaSendDirection(g, f[v]);
                }), S;
            }
            function removeChangedMediaSendDirection(g, f) {
                return hasSendDirectionality(g) && !hasSendDirectionality(f) ? removeSendDirectionality(g) || f : g;
            }
            function removeChangedDataSendDirection(g, f) {
                return hasSendDirectionality(g) && !hasSendDirectionality(f) ? f : g;
            }
            function parseCandidateString(g) {
                const f = (g || "").split(" ");
                return {
                    component: f[1],
                    protocol: f[2],
                    priority: f[3],
                    ip: f[4],
                    port: f[5],
                    type: f[7]
                };
            }
            function modalityToMediaType(g) {
                switch(g){
                    case "audio":
                        return "Audio";
                    case "video":
                        return "Video";
                    case "sharing":
                        return "ScreenShare";
                    default:
                        return null;
                }
            }
            function mediaTypeToModality(g) {
                switch(g){
                    case "Audio":
                        return "audio";
                    case "Video":
                        return "video";
                    case "ScreenShare":
                        return "sharing";
                    default:
                        return null;
                }
            }
            function sendStreamsToModalities(g) {
                const f = {};
                return keys(g).forEach((S)=>f[S] = !!g[S]), f;
            }
            function scrubObjectFields2(g, f, S) {
                if (!g) return g;
                const v = {
                    ...g
                };
                for (const [_, C] of Object.entries(g))"object" == typeof C ? v[_] = scrubObjectFields2(C, f) : C && f.includes(_) && (v[_] = S ? S(C) : scrubMriOrOmit(C));
                return v;
            }
            function scrubObjectExcludingFields(g, f, S) {
                if (!g) return g;
                const v = {
                    ...g
                };
                for (const [_, C] of Object.entries(g))"object" == typeof C ? v[_] = scrubObjectExcludingFields(C, f) : C && !f.includes(_) && (v[_] = S ? S(C) : scrubMriOrOmit(C));
                return v;
            }
            function scrubSelectedDevices(g) {
                return g ? scrubObjectExcludingFields(g, []) : g;
            }
            function scrubDevices(g, f) {
                if (!g) return g;
                const S = scrubObjectFields2(g, [
                    "deviceId",
                    "groupId",
                    "guid"
                ]);
                return scrubObjectFields2(S, [
                    "label"
                ], (g)=>scrubDeviceLabelPii(g, f));
            }
            function scrubConstraints(g) {
                return scrubObjectFields2(g, [
                    "sourceId",
                    "deviceId"
                ]);
            }
            function preferSdesSrtp(g, f) {
                return !(!g.config.webrtcForceSdesForS1 || !g.config.checkSupportForWebrtc_1_0 || g.mediaConfig.simulcastSessionEnabled) || (f ? g.config.preferSdesSrtpPstn : g.config.preferSdesSrtp);
            }
            function canUseWebrtc1_0(g) {
                return !g || ss.hasUnifiedPlanSupport();
            }
            function allowDataChannel(g) {
                return !!g.configProvider.mediaConfig.simulcastSessionEnabled && (g.config.isPstnCall ? g.configProvider.config.enableDataChannelPstn : g.configProvider.config.enableDataChannel);
            }
            function getAllowedCodecs(g, f) {
                switch(f){
                    case Gt.MEDIA_TYPE.audio:
                        return g.config.allowedAudioCodecs;
                    case Gt.MEDIA_TYPE.video:
                        return g.config.allowedVideoCodecs;
                    default:
                        return [];
                }
            }
            function convertToCodecInfo(g) {
                return g.map((g)=>{
                    const f = {
                        codec: g.mimeType.split("/").pop(),
                        rate: g.clockRate
                    };
                    return g.channels && (f.encoding = g.channels), g.sdpFmtpLine && (f.fmtpLine = g.sdpFmtpLine), f;
                });
            }
            function printMediaStream(g) {
                return `${g === null || g === void 0 ? void 0 : g.id}:${JSON.stringify(g === null || g === void 0 ? void 0 : g.getTracks().map((g)=>g.id))}}`;
            }
            function ipAddressConverter(g) {
                try {
                    if (os.test(g)) return ipv4AddressConverter(g);
                    if (ls.test(g)) return ipv6AddressConverter(g);
                } catch (f) {
                    return g;
                }
                return g;
            }
            function ipv6AddressConverter(g) {
                let f, S = g.lastIndexOf("]") + 1, v = "", _ = "";
                S > 0 ? (f = g.substring(0, S), _ = g.substring(S)) : (f = g, S = f.length);
                const C = f.lastIndexOf(":");
                if (f.includes(".")) {
                    const g = ipv4AddressConverter(f.substring(C + 1, S - 1 - C));
                    v = f.substring(0, C + 1) + g;
                } else C < f.length - 1 || ":" === f[C - 1] && f.match(/:/g).length < 7 ? v = f.substring(0, C + 1) + "x" : 7 === f.match(/:/g).length && (v = f.substring(0, C) + "0:x");
                return v ? _ ? v + "]" + _ : "[" === g.substring(0, 1) ? (v = v.substring(1), v) : v : g;
            }
            function ipv4AddressConverter(g) {
                const f = g.substring(0, g.lastIndexOf(".") + 1) + "x", S = g.lastIndexOf(":");
                return S > 0 ? f + g.substring(S) : f;
            }
            function getStreamInformation(g) {
                let f = [];
                return g.forEach((g)=>{
                    try {
                        let S = f.find((f)=>f.participantId === g.participantId && f.endpointId === g.endpointId);
                        S || (S = {
                            participantId: g.participantId,
                            endpointId: g.endpointId
                        }, f.push(S)), "audio" !== g.type && "audioteleconference" !== g.type || (S.serverMuted = g.serverMuted), S[g.type] = g.direction;
                    } catch (g) {
                        f = [];
                    }
                }), f;
            }
            var cs = P, ds = P, us = {
                maxOutgoingResolution: ({ settings: g })=>getMaxOutgoingResolution(g),
                maxParticipantResolutions: ({ settings: g })=>getMaxParticipantResolutions2(g),
                maxIncomingStreams: ({ settings: g })=>getMaxIncomingStreams2(g),
                maxSimulcastLayers: ({ settings: g })=>getMaxSimulcastLayers2(g),
                outgoingVideoLimit: ({ settings: g, constraints: f })=>getOutgoingVideoLimit2(g, f)
            }, convertSettingsToCallConstraints = (g, f, S)=>(g.info(`Converting settings to constraints and mapping, [requestedConstraints=${JSON.stringify(S)}], [settings=${JSON.stringify(f)}]`), convertConstraints((0, ds.cloneDeep)(S), (0, ds.cloneDeep)(f))), convertConstraints = (g, f)=>Object.keys(g).reduce((S, v)=>{
                    const _ = us[v] ? us[v]({
                        constraints: g,
                        settings: f
                    }) : void 0;
                    return _ && (S[v] = _), S;
                }, {}), getMaxParticipantResolutions2 = (g)=>g.multiviewResolutionLimits, getMaxOutgoingResolution = (g)=>{
                var _g_outgoingVideoLimit;
                return (_g_outgoingVideoLimit = g.outgoingVideoLimit) === null || _g_outgoingVideoLimit === void 0 ? void 0 : _g_outgoingVideoLimit.maxResolution;
            }, getOutgoingVideoLimit2 = (g, f)=>{
                const S = f === null || f === void 0 ? void 0 : f.outgoingVideoLimit;
                if (!S) return;
                const { outgoingVideoLimit: v = {} } = deepClone(g);
                if ("number" == typeof S) return v === null || v === void 0 ? void 0 : v.maxResolution;
                const _ = Object.keys(S).reduce((g, f)=>{
                    const S = v === null || v === void 0 ? void 0 : v[f];
                    return S && (g[f] = S), g;
                }, {});
                return Object.keys(_).length ? _ : void 0;
            }, getMaxIncomingStreams2 = (g)=>g.numVideoChannelsGvc, getMaxSimulcastLayers2 = (g)=>{
                var _f_video, _f_sharing;
                const f = g.specCompliantSimulcast, S = (_f_video = f.video) === null || _f_video === void 0 ? void 0 : _f_video.layerScaleFactors, v = (_f_sharing = f.sharing) === null || _f_sharing === void 0 ? void 0 : _f_sharing.layerScaleFactors, _ = (S === null || S === void 0 ? void 0 : S.length) ? Math.max(...S) : 1, C = (v === null || v === void 0 ? void 0 : v.length) ? Math.max(...S) : 1;
                return Math.min(_, C);
            }, hs = P, isVideoLimit = (g)=>{
                const f = [
                    "maxResolution",
                    "maxBitrate",
                    "maxFramerate"
                ], isValidVideoLimitKey = (g)=>f.includes(g), S = Object.entries(g);
                return 0 !== S.length && S.every(([g, f])=>(0, hs.isNumber)(f) && isValidVideoLimitKey(g));
            }, isVideoLimitOrResolution = (g)=>!!(0, hs.isNumber)(g) || !!isVideoLimit(g) && !isEmpty(g), gs = {
                maxIncomingStreams: hs.isNumber,
                maxSimulcastLayers: hs.isNumber,
                maxOutgoingResolution: hs.isNumber,
                maxParticipantResolutions: (g)=>!!isDefined(g) && (!!(0, hs.isNumber)(g) || "more" in g && Object.values(g).every((g)=>(0, hs.isNumber)(g))),
                outgoingVideoLimit: (g)=>!!isDefined(g) && isVideoLimitOrResolution(g)
            }, removeInvalidConstraints = (g)=>(g = JSON.parse(JSON.stringify(g)), Object.entries(gs).reduce((f, [S, v])=>(v(g[S]) && (f[S] = g[S]), f), {}));
            function arrayMergeCustomizer2(g, f) {
                if (Array.isArray(g)) return f.slice();
            }
            var deepMergeConstraints = (g, f)=>{
                for(const S in f){
                    const v = g[S], _ = f[S];
                    g[S] = "object" == typeof _ ? deepMergeConstraints({
                        ...v
                    }, _) : getMinDefined(v, _);
                }
                return g;
            }, ps = class {
                get config() {
                    return this.settings;
                }
                get mediaConfig() {
                    return this._mediaConfig;
                }
                get userAgentConfig() {
                    return this._userAgentConfig;
                }
                get countryCode() {
                    return this._countryCode;
                }
                addCallConstraintsTelemetryEvent(g, f) {
                    const S = {
                        timestamp: (new Date).getTime(),
                        type: f,
                        value: g
                    };
                    arrayLimitedPush2(this.callConstraintsTelemetry, S, this.config.numCallConstraintsEvents);
                }
                getCallConstraintsTelemetry() {
                    return this.callConstraintsTelemetry;
                }
                getCallConstraints() {
                    return this.mergedConstraints;
                }
                setCallConstraints(g = {}) {
                    this.addCallConstraintsTelemetryEvent(g, "requested"), this.logger.safe.debug("Saving new call constraints", JSON.stringify(g));
                    const f = this.transformConstraints(removeInvalidConstraints(g));
                    return this.logger.safe.debug("Validated call constraints", JSON.stringify(f)), this.mergedConstraints = this.mergeConstraintsWithGlobal(f), this.settings = this.mergeSettings((0, cs.cloneDeep)(this.defaultSettings)), convertSettingsToCallConstraints(this.logger, this.settings, f);
                }
                getIceTransportPolicy() {
                    return this.settings.iceTransportPolicyForced || this.iceTransportPolicy;
                }
                setIceTransportPolicy(g) {
                    this.validIceTransportPolicies.includes(g) ? (this.logger.info(`Setting transport policy to ${this.iceTransportPolicy}`), this.iceTransportPolicy = g) : this.logger.debug(`Unknown incoming transport policy, using ${this.iceTransportPolicy}`);
                }
                overrideMaxSessionBandwidth(g) {
                    return this.defaultSettings.maxBandwidthInKbps !== g && (this.defaultSettings.maxBandwidthInKbps = g, this.settings.maxBandwidthInKbps = g, this.mediaConfig.maxBandwidthInKbps = g, !0);
                }
                transformConstraints(g) {
                    const f = (0, cs.cloneDeep)(g);
                    return "maxOutgoingResolution" in f && (f.outgoingVideoLimit = {
                        maxResolution: f.maxOutgoingResolution
                    }, delete f.maxOutgoingResolution), "number" == typeof f.outgoingVideoLimit && (f.outgoingVideoLimit = {
                        maxResolution: f.outgoingVideoLimit
                    }), f;
                }
                mergeConstraintsTelemetryWithGlobal() {
                    this.platformCallConstraintsProvider.callConstraintsTelemetry.forEach((g)=>arrayLimitedPush2(this.callConstraintsTelemetry, g, this.defaultSettings.numCallConstraintsEvents));
                }
                mergeConstraintsWithGlobal(g = {}) {
                    const f = this.transformConstraints(this.platformCallConstraintsProvider.constraints);
                    if (!Object.keys(f).length) return g;
                    const S = (0, cs.cloneDeep)(g);
                    return deepMergeConstraints(S, f), this.logger.safe.debug(`Merging call constraints ${JSON.stringify(g)} and global constraints ${JSON.stringify(f)}. Result: ${JSON.stringify(S)}`), S;
                }
                mergeSettings(g) {
                    if (!g.enablePlatformCallConstraints || !g.enablePlatformCallConstraintsPerCall) return g;
                    const f = convertCallConstraintsToSettings(this.logger, g, this.mergedConstraints);
                    return this.logger.safe.info(`Merging settings with platform call constraints: ${stringifyObject(f)}`), (0, cs.assign)({}, g, f, arrayMergeCustomizer2);
                }
                constructor(g, f, S, v, _, C, E){
                    this.logger = g, this.defaultSettings = f, this._mediaConfig = S, this._userAgentConfig = v, this._countryCode = _, this.platformCallConstraintsProvider = C, this.currentCallConstraints = E, this.mergedConstraints = {}, this.callConstraintsTelemetry = [], this.iceTransportPolicy = Gt.ICE_TRANSPORT_POLICY.all, this.validIceTransportPolicies = [
                        Gt.ICE_TRANSPORT_POLICY.all,
                        Gt.ICE_TRANSPORT_POLICY.relay
                    ], this.mergeConstraintsTelemetryWithGlobal(), this.mergedConstraints = this.mergeConstraintsWithGlobal(this.currentCallConstraints), this.settings = this.mergeSettings((0, cs.cloneDeep)(this.defaultSettings));
                }
            }, ms = P, fs = [
                Gt.MODALITY.audio,
                Gt.MODALITY.video,
                Gt.MODALITY.sharing
            ], Ss = class {
                getTransceivers() {
                    return this.peerConnection.getTransceivers().filter(isActiveTransceiver);
                }
                assureTransceivers(g) {
                    this.assureNegotiatedOrder(), this.addModalities(g), this.logTransceiversInfo("assureTransceivers"), this.setDirections(g);
                }
                syncTransceivers(g) {
                    this.syncWithMediaEntities(), this.setDirections(g);
                }
                assureNegotiatedOrder() {
                    const g = this.getTransceivers();
                    this.mediaManager.getMediaEntities().forEach((f)=>{
                        if (-1 === fs.indexOf(f.getModality())) return;
                        isActiveTransceiverInPc(this.entityTransceiverMap.get(f), g) || this.createTransceiverForEntity(f);
                    });
                }
                addModalities(g) {
                    const f = this.mediaManager.isEmpty();
                    this.isMultiparty || !f || this.isPstnCall || (g.video = g.video || "inactive", g.sharing = g.sharing || "inactive"), this.configProvider.config.webrctRemoveVideoModalitiesForPstn && this.isPstnCall && !this.isParkedCall && (delete g.video, delete g.sharing);
                    for (const S of fs){
                        if (this.mediaManager.getMediaEntitiesByModality(S)[0] || !g[S]) continue;
                        const v = S === Gt.MODALITY.video ? this.numVideoChannels : 1;
                        (0, ms.times)(v, (g)=>{
                            const v = this.mediaManager.createMediaEntity(S);
                            v.setExtension("reinviteless", f && this.reinvitelessContext.maxStreamsForModality[S] > g), this.createTransceiverForEntity(v);
                        });
                    }
                }
                createTransceiverForEntity(g) {
                    const f = g.getModality();
                    this.logger.safe.info(`createTransceiver: modality=${f}`);
                    const S = f === Gt.MODALITY.audio ? Gt.MEDIA_TYPE.audio : Gt.MEDIA_TYPE.video, v = g.getSimulcastContext(), _ = this.createTransceiver(S, v);
                    this.setCodecPreferences(_, S, !0), this.setExtensionPreferences(_, f), this.entityTransceiverMap.set(g, _), g.setExtension("unnegotiatedModality", !0);
                }
                setCodecPreferences(g, f, S) {
                    const v = getAllowedCodecs(this.configProvider, f);
                    if (!(v === null || v === void 0 ? void 0 : v.length) || !ss.hasCapabilitiesApi() || this.configProvider.config.filterCodecsInSdp) return;
                    const _ = Qa.window.RTCRtpReceiver.getCapabilities(f);
                    if (!_) return;
                    const C = [];
                    if (S) for (const g of v){
                        const f = _.codecs.filter((f)=>isCodecsMatch(g, f));
                        C.push(...f);
                    }
                    else for (const g of _.codecs)v.some((f)=>isCodecsMatch(f, g)) && C.push(g);
                    C.length && g.setCodecPreferences && g.setCodecPreferences(C);
                }
                setExtensionPreferences(g, f) {
                    var _this_configProvider_config_headerExtensionsToUpdate;
                    if (!((_this_configProvider_config_headerExtensionsToUpdate = this.configProvider.config.headerExtensionsToUpdate) === null || _this_configProvider_config_headerExtensionsToUpdate === void 0 ? void 0 : _this_configProvider_config_headerExtensionsToUpdate[f])) return;
                    if (!g.getHeaderExtensionsToNegotiate || !g.setHeaderExtensionsToNegotiate) return void this.logger.safe.debug("setExtensionPreferences: transceiver.setHeaderExtensionsToNegotiate is not supported");
                    const S = this.configProvider.config.headerExtensionsToUpdate[f], v = g.getHeaderExtensionsToNegotiate();
                    for (const g of v){
                        const f = S.find((f)=>f.uri === g.uri);
                        f && (g.direction = f.direction);
                    }
                    try {
                        g.setHeaderExtensionsToNegotiate(v);
                    } catch (g) {
                        this.logger.safe.error(`setExtensionPreferences: transceiver.setHeaderExtensionsToNegotiate failed, err ${stringifyObject(g)}`);
                    }
                }
                async createSender(g, f, S) {
                    const v = await this.associateTrackWithTransceiver(g, f, S);
                    if (!v) throw new Error(`Transceiver for modality=${S} is not found`);
                    const _ = this.findEntityForTransceiver(v), C = S !== Gt.MODALITY.sharing || (_ === null || _ === void 0 ? void 0 : _.getExtension("reinviteless")) ? Gt.MEDIA_STATE.sendReceive : Gt.MEDIA_STATE.send;
                    return v.direction = C, this.logger.safe.info(`Replace track completed direction:${v.direction} for transceiver mid=${v.mid}`), v.sender;
                }
                removeSender(g) {
                    this.removeSenderInternal(g, !1);
                }
                async removeSenderAsync(g) {
                    return this.removeSenderInternal(g, !0);
                }
                removeSenderInternal(g, f) {
                    var _g_track, _g_track1;
                    if ("closed" === (this.peerConnection.connectionState || this.peerConnection.iceConnectionState)) return void this.logger.safe.info("Not removing sender from pc, connection is closed");
                    const S = this.getTransceivers().find((f)=>f.sender === g);
                    if (!S) throw new Error(`Transceiver for sender with track=${(_g_track = g.track) === null || _g_track === void 0 ? void 0 : _g_track.id} is not found`);
                    const v = this.findEntityForTransceiver(S), _ = !!(v === null || v === void 0 ? void 0 : v.getExtension("reinviteless"));
                    this.logger.safe.info(`Remove sender with track=${(_g_track1 = g.track) === null || _g_track1 === void 0 ? void 0 : _g_track1.id} for transceiver mid=${S.mid}, reinviteless=${_}, doAsync=${f}`);
                    let C = Promise.resolve();
                    return _ && f ? C = S.sender.replaceTrack(null) : this.peerConnection.removeTrack(g), f ? C : void 0;
                }
                createTransceiver(g, f) {
                    const S = {
                        direction: "inactive"
                    };
                    return this.addSimulcastEnvelopeIfNeeded(S, f), this.peerConnection.addTransceiver(g, S);
                }
                addSimulcastEnvelopeIfNeeded(g, f) {
                    (f === null || f === void 0 ? void 0 : f.shouldUseSimulcast()) && (g.sendEncodings = (0, ms.times)(f.config.layerScaleFactors.length, (g)=>{
                        var _this_configProvider_config_specCompliantSimulcast, _f_config_layerScalabilityModes;
                        const S = {
                            rid: `${f.ridList[g]}`,
                            scaleResolutionDownBy: f.config.layerScaleFactors[g]
                        };
                        if (((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.disableTilde) && (S.active = !1), ((_f_config_layerScalabilityModes = f.config.layerScalabilityModes) === null || _f_config_layerScalabilityModes === void 0 ? void 0 : _f_config_layerScalabilityModes.length) > 0) {
                            const v = f.config.layerScalabilityModes[g];
                            void 0 !== v && v.length > 0 ? S.scalabilityMode = v : this.logger.safe.warn(`Scalability mode was not set for rid: ${S.rid}`);
                        }
                        return this.logger.safe.debug(`Added layer ${g} with rid: ${S.rid} SF: ${S.scaleResolutionDownBy} SM: ${S.scalabilityMode}`), S;
                    }));
                }
                async associateTrackWithTransceiver(g, f, S) {
                    const v = this.findAvailableTransceiverToSend(S);
                    if (v) {
                        this.logger.safe.info(`Associate track=${g === null || g === void 0 ? void 0 : g.id} (${S}) with existing transceiver mid=${v.mid}`);
                        try {
                            if (this.configProvider.config.disableSendersTroughSetParameters && (S === Gt.MODALITY.video || S === Gt.MODALITY.sharing)) {
                                const g = v.sender.getParameters();
                                g.encodings.forEach((g)=>g.active = !1), await v.sender.setParameters(g);
                            }
                            await v.sender.replaceTrack(g), this.configProvider.config.useSetStreamsForSender && v.sender.setStreams && v.sender.setStreams(f);
                        } catch (g) {
                            throw this.logger.safe.error(`replaceTrack failed, err ${JSON.stringify(g)}`), g;
                        }
                        return v;
                    }
                    return null;
                }
                syncWithMediaEntities() {
                    const g = this.getTransceivers();
                    this.mediaManager.getMediaEntities().forEach((f)=>{
                        let S = this.entityTransceiverMap.get(f);
                        S = isActiveTransceiverInPc(S, g) ? S : g.find((g)=>g.mid === f.getMid()), this.entityTransceiverMap.set(f, S);
                    }), this.logTransceiversInfo("syncWithMediaEntities");
                }
                getTransceiversByModality(g) {
                    return this.mediaManager.getMediaEntitiesByModality(g).map((g)=>this.entityTransceiverMap.get(g)).filter(isActiveTransceiver);
                }
                setDirections(g) {
                    const f = !isOnHold(g);
                    for (const S of fs)for (const [v, _] of this.getTransceiversByModality(S).entries()){
                        const C = this.findEntityForTransceiver(_);
                        if ((C === null || C === void 0 ? void 0 : C.getExtension("reinviteless")) && f) {
                            _.direction = "sendrecv";
                            continue;
                        }
                        const E = g[S] || Gt.MEDIA_STATE.inactive;
                        _.direction = 0 === v && _.currentDirection ? E : removeSendDirectionality2(E);
                    }
                    this.logTransceiversInfo("setDirections");
                }
                handleMediaEntitiesRollback(g, f) {
                    g.forEach((g)=>{
                        const S = this.entityTransceiverMap.get(g), v = f.find((f)=>f.getMid() === g.getMid());
                        this.entityTransceiverMap.set(v, S);
                    }), this.logTransceiversInfo("handleMediaEntitiesRollback");
                }
                findAvailableTransceiverToSend(g) {
                    const f = this.mediaManager.getMediaEntitiesByModality(g)[0];
                    return this.entityTransceiverMap.get(f);
                }
                findEntityForTransceiver(g) {
                    for (const [f, S] of this.entityTransceiverMap)if (S === g) return f;
                }
                logTransceiversInfo(g) {
                    let f = `${g}: transceivers details:`;
                    for (const g of fs){
                        const S = this.getTransceiversByModality(g);
                        f += ` ${g}(${S.length}) [${S.map((g)=>`mid=${g.mid}, direction=${g.direction}`).join(";")}]`;
                    }
                    this.logger.safe.debug(f);
                }
                constructor(g, f, S, v, _){
                    this.peerConnection = f, this.mediaManager = S, this.reinvitelessContext = _, this.entityTransceiverMap = new Map, this.logger = g.createChild("TM"), this.configProvider = v.configProvider, this.isMultiparty = v.config.isConference, this.isPstnCall = v.config.isPstnCall, this.isParkedCall = v.config.isParkedCall, this.numVideoChannels = this.isMultiparty && this.configProvider.config.numVideoChannelsGvc || 1, v.configProvider.config.enableRollbackHandler && this.mediaManager.setRollbackUpdateHandler(this.handleMediaEntitiesRollback.bind(this));
                }
            };
            function isCodecsMatch(g, f) {
                return !(!(0, ms.isUndefined)(g.channels) && g.channels !== f.channels) && !(!(0, ms.isUndefined)(g.clockRate) && g.clockRate !== f.clockRate) && !(!(0, ms.isUndefined)(g.mimeType) && g.mimeType.toLowerCase() !== f.mimeType.toLowerCase()) && !(!(0, ms.isUndefined)(g.sdpFmtpLine) && -1 === f.sdpFmtpLine.toLowerCase().indexOf(g.sdpFmtpLine.toLowerCase()));
            }
            function removeSendDirectionality2(g) {
                let f = g;
                return hasSendDirectionality(g) && (f = removeSendDirectionality(g)), f || Gt.MEDIA_STATE.inactive;
            }
            function isActiveTransceiver(g) {
                return g && "stopped" !== g.direction && !g.stopped;
            }
            function isActiveTransceiverInPc(g, f) {
                return isActiveTransceiver(g) && -1 !== f.indexOf(g);
            }
            var vs = class extends Bt {
                async initialize() {
                    return this.configProvider.config.useInsertableStreams && this.workerProvider && ss.hasEncodedStreamsApi() && (this.worker = new Bs(this.workerProvider, this.logger)), this.worker ? this.worker.initialize() : Promise.resolve();
                }
                initTransformsCollection(g, f, S) {
                    const v = ss.hasScriptTransformApi() || this.workerProvider;
                    if (!(this.configProvider.config.useInsertableStreams && ss.hasEncodedStreamsApi() && (!v || this.isWorkerLoaded()) && null !== g.track)) return null;
                    if (!this.transformsCollections.has(g)) {
                        const v = this.worker ? new Cs(this.worker, g) : new _s(g);
                        this.transformsCollections.set(g, {
                            collection: v,
                            mediaType: S,
                            objType: f
                        });
                    }
                    const _ = this.transformsCollections.get(g);
                    return this.event("onTransformsCollectionCreated").raise(_), _.collection;
                }
                clearTransformsCollection(g) {
                    const f = this.transformsCollections.get(g);
                    f && (this.event("onTransformsCollectionCleared").raise(f), f.collection.clearTransforms());
                }
                dispose() {
                    var _this_worker;
                    for (const g of this.transformsCollections.values())this.event("onTransformsCollectionCleared").raise(g), g.collection.clearTransforms();
                    this.transformsCollections.clear(), (_this_worker = this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.dispose(), super.dispose();
                }
                isWorkerLoaded() {
                    var _this_worker;
                    return !!((_this_worker = this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.isWorkerLoaded());
                }
                constructor(g, f, S){
                    super(), this.configProvider = g, this.workerProvider = f, this.logger = S, this.transformsCollections = new Map;
                }
            }, _s = class {
                addTransform(g) {
                    g.createBaseInstance(this.streamTransformer);
                }
                clearTransforms() {
                    this.streamTransformer.clearTransforms();
                }
                constructor(g){
                    const { readable: f, writable: S } = g.createEncodedStreams();
                    this.streamTransformer = new Js(f, S);
                }
            }, Cs = class {
                addTransform(g) {
                    g.createWorkerInstance(this.workerHandler, this.clientId);
                }
                clearTransforms() {
                    this.workerHandler.sendTransformCommand(this.clientId, {
                        operation: "clear"
                    });
                }
                constructor(g, f){
                    if (this.workerHandler = g, this.clientId = f.track.id, ss.hasScriptTransformApi()) return void (f.transform = new RTCRtpScriptTransform(this.workerHandler.worker, {
                        clientId: this.clientId
                    }));
                    const { readable: S, writable: v } = f.createEncodedStreams(), _ = [
                        S,
                        v
                    ];
                    this.workerHandler.sendTransformCommand(this.clientId, {
                        operation: "init",
                        readable: S,
                        writable: v
                    }, _);
                }
            }, ys = class {
                get stream() {
                    return this.destination.stream;
                }
                isSingleInputStream() {
                    var _this_mixerImp;
                    return 0 === ((_this_mixerImp = this.mixerImp) === null || _this_mixerImp === void 0 ? void 0 : _this_mixerImp.mixerType);
                }
                dispose() {
                    this.audioContext.close(), this.audioContext = null;
                }
                stopMixing() {
                    var _this_mixerImp;
                    this.disabled = !0, (_this_mixerImp = this.mixerImp) === null || _this_mixerImp === void 0 ? void 0 : _this_mixerImp.reset();
                }
                startMixing(g) {
                    var _this_mixerImp;
                    this.disabled = !1, (_this_mixerImp = this.mixerImp) === null || _this_mixerImp === void 0 ? void 0 : _this_mixerImp.setupMixer(this.audioContext, this.destination, g);
                }
                setMixerType(g, f) {
                    var _this_mixerImp, _this_mixerImp1;
                    ((_this_mixerImp = this.mixerImp) === null || _this_mixerImp === void 0 ? void 0 : _this_mixerImp.mixerType) !== g && ((_this_mixerImp1 = this.mixerImp) === null || _this_mixerImp1 === void 0 ? void 0 : _this_mixerImp1.reset(), this.mixerImp = this.createMixer(g), this.disabled || this.mixerImp.setupMixer(this.audioContext, this.destination, f));
                }
                setStreamSources(g) {
                    var _this_mixerImp_setStreamSources, _this_mixerImp;
                    this.disabled || ((_this_mixerImp_setStreamSources = (_this_mixerImp = this.mixerImp).setStreamSources) === null || _this_mixerImp_setStreamSources === void 0 ? void 0 : _this_mixerImp_setStreamSources.call(_this_mixerImp, g));
                }
                setParticipantSpatialAudioPositions(g) {
                    var _this_mixerImp_setParticipantSpatialAudioPositions, _this_mixerImp;
                    (_this_mixerImp_setParticipantSpatialAudioPositions = (_this_mixerImp = this.mixerImp).setParticipantSpatialAudioPositions) === null || _this_mixerImp_setParticipantSpatialAudioPositions === void 0 ? void 0 : _this_mixerImp_setParticipantSpatialAudioPositions.call(_this_mixerImp, g);
                }
                createMixer(g) {
                    switch(g){
                        case 0:
                            return new Ts;
                        case 1:
                            return new Is(this.logger.createChild("MixingStreamsMixer"));
                        case -1:
                            return new Es;
                        default:
                            throw new Error(`unknown mixer type: ${g}`);
                    }
                }
                constructor(g, f = !1){
                    this.logger = g, this.disabled = f, this.audioContext = new AudioContext, this.destination = this.audioContext.createMediaStreamDestination();
                }
            }, Es = class {
                reset() {}
                setupMixer(g, f, S) {}
                constructor(){
                    this.mixerType = -1;
                }
            }, Ts = class {
                reset() {
                    this.sourceNode.disconnect();
                }
                setupMixer(g, f, S) {
                    this.sourceNode = g.createMediaStreamSource(S[0]), this.sourceNode.connect(f);
                }
                constructor(){
                    this.mixerType = 0;
                }
            }, Is = class {
                reset() {
                    this.logger.safe.info("resetting SpatialMultiStreamMixer");
                    for (const g of this.sourceNodes)g.disconnect();
                    this.sourceNodes = [];
                    for (const g of this.pannerNodes)g.disconnect();
                    this.pannerNodes = [];
                }
                setupMixer(g, f, S) {
                    (this.sourceNodes.length || this.pannerNodes.length) && this.reset();
                    for (const v of S){
                        const S = g.createMediaStreamSource(v), _ = new PannerNode(g, {
                            panningModel: "HRTF"
                        });
                        S.connect(_), _.connect(f), this.sourceNodes.push(S), this.pannerNodes.push(_);
                    }
                    this.logger.safe.info(`setupMixer is done for ${S.length} streams.`);
                }
                setStreamSources(g) {
                    for(let f = 0; f < g.length; f++)this.setStreamPosition(f, g[f]);
                }
                setParticipantSpatialAudioPositions(g) {
                    this.sourcePositions = new Map(g.map((g)=>[
                            g.sourceId,
                            g
                        ]));
                }
                setStreamPosition(g, f) {
                    var _this_sourcePositions_get;
                    const S = (_this_sourcePositions_get = this.sourcePositions.get(f)) !== null && _this_sourcePositions_get !== void 0 ? _this_sourcePositions_get : {
                        sourceId: f,
                        x: 0,
                        y: 0
                    }, v = this.pannerNodes[g];
                    v ? (v.positionX.value = S.x, v.positionY.value = S.y) : this.logger.warn(`panner node for stream ${g} is not found`);
                }
                constructor(g){
                    this.logger = g, this.sourcePositions = new Map, this.sourceNodes = [], this.pannerNodes = [], this.mixerType = 1;
                }
            }, bs = class extends Bt {
                get streams() {
                    return this.mediaStreams;
                }
                get comfortNoiseStream() {
                    return this.cnStream;
                }
                get configured() {
                    return this.isConfigured;
                }
                get active() {
                    return this.isNegotiated;
                }
                get codec() {
                    return this.activeCodec;
                }
                setupStreams(g, f) {
                    this.logger.safe.debug(`setup ${g} streams with extra Comfort Noise stream: ${f}`), this.mediaStreams = [];
                    const S = [];
                    for(; g--;){
                        const g = new MediaStreamTrackGenerator({
                            kind: "audio"
                        });
                        S.push(g), this.streams.push(new MediaStream([
                            g
                        ]));
                    }
                    const v = f ? new MediaStreamTrackGenerator({
                        kind: "audio"
                    }) : null;
                    return this.cnStream = v ? new MediaStream([
                        v
                    ]) : null, this.event("onStreamsChanged").raise(), {
                        streams: S.map((g)=>g.writable),
                        cnStream: v === null || v === void 0 ? void 0 : v.writable
                    };
                }
                setStreamSources(g) {
                    this.isNegotiated && this.event("onStreamSourcesUpdated").raise(g);
                }
                setConfiguredState(g) {
                    this.isConfigured !== g && (this.isConfigured = g, this.event("onConfiguredStateChanged").raise(this.isConfigured));
                }
                setNegotiatedState(g) {
                    this.isNegotiated !== g && (this.isNegotiated = g, this.event("onActiveStateChanged").raise(this.isNegotiated));
                }
                setDetectedCodec(g) {
                    this.activeCodec !== g && (this.activeCodec = g, this.event("onActiveCodecChanged").raise(this.activeCodec));
                }
                constructor(g){
                    super(), this.logger = g, this.mediaStreams = [], this.cnStream = null, this.isConfigured = !1, this.isNegotiated = !1, this.activeCodec = "None";
                }
            }, As = 0, Rs = {
                MUCHv2: {
                    CODEC: {
                        NAME: "x-much2",
                        RATE: 48e3,
                        ENCODING: 2
                    },
                    SUBSTITUTION: {
                        NAME: "L16",
                        RATE: 48e3,
                        ENCODING: 2
                    },
                    PT: 113
                },
                SatinFB: {
                    CODEC: {
                        NAME: "SATINFB",
                        RATE: 48e3,
                        ENCODING: 2
                    },
                    SUBSTITUTION: {
                        NAME: "L16",
                        RATE: 48e3,
                        ENCODING: 2
                    },
                    PT: 109
                }
            }, Ps = class {
                dispose() {
                    this.worker.unsubscribeClient(this.clientId), this.worker.sendTransformCommand(this.clientId, {
                        operation: "clear"
                    });
                }
                processMsg(g) {
                    if (this.listener && g.name in this.listener) return this.listener[g.name].apply(this.listener, g.args);
                    throw `unexpected message received for transform type ${this.transformType}: ${JSON.stringify(g)}`;
                }
                constructor(g, f, S, v){
                    this.worker = g, this.clientId = f, this.transformType = S, this.listener = v, this.worker.subscribeClient(this.clientId, this.transformType, (g)=>this.processMsg(g)), this.worker.sendTransformCommand(this.clientId, {
                        operation: "add",
                        transformType: this.transformType
                    });
                }
            };
            function createAudioWasmDecoderProxy(g, f, S) {
                return new ws(g, f, S);
            }
            var ws = class extends Ps {
                init(g, f) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "init",
                            args: [
                                g,
                                f
                            ]
                        }
                    });
                }
                setCodec(g, f) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "setCodec",
                            args: [
                                g,
                                f
                            ]
                        }
                    });
                }
                passWriteableStreams(g, f) {
                    const S = g.concat(f);
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "passWriteableStreams",
                            args: [
                                g,
                                f
                            ]
                        }
                    }, S);
                }
                setAvailableStreams(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "setAvailableStreams",
                            args: [
                                g
                            ]
                        }
                    });
                }
                setRecvPayloads(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "setRecvPayloads",
                            args: [
                                g
                            ]
                        }
                    });
                }
                debugLogging(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "debugLogging",
                            args: [
                                g
                            ]
                        }
                    });
                }
                sendApiRecordingData() {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "sendApiRecordingData",
                            args: []
                        }
                    });
                }
                constructor(g, f, S){
                    super(g, f, 2, S);
                }
            }, Ms = class extends Bt {
                get stream() {
                    return this.streamMixer.stream;
                }
                dispose() {
                    var _this_imp;
                    super.dispose(), this.streamMixer.dispose(), (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.dispose(), this.removeWebMA();
                }
                activateTransform(g) {
                    this.logger.safe.debug("Activating WASM decoder transform"), g.addTransform(this);
                }
                deactivateTransform() {
                    this.logger.safe.debug("Deactivating WASM decoder transform"), this.imp.dispose(), this.imp = null, this.initCompleted = !1, this.codec = "None", this.streamMixer.setMixerType(-1, []);
                }
                createBaseInstance(g) {
                    this.logger.warn("WASM decoder could only be instantiated in worker");
                }
                createWorkerInstance(g, f) {
                    this.imp = createAudioWasmDecoderProxy(g, f, this), this.imp.init(this.enabledApiRecording, this.wasmHealerPullStrategy);
                }
                setCodec(g) {
                    if (this.logger.safe.debug(`Setting codec to ${g}`), !this.initCompleted) return this.logger.safe.debug("Decoder is not initialized yet, postponing codec setting"), void (this.codec = g);
                    this.codec !== g && (this.codec = g, this.setCodecInternal());
                }
                setRecvPayloads(g) {
                    this.recvPayloads = g, this.initCompleted ? this.imp.setRecvPayloads(g) : this.logger.safe.debug("Decoder is not initialized yet, postponing Recv payload setting");
                }
                negotiationCompleted(g) {
                    var _this_imp;
                    this.logger.safe.debug(`Negotiation completed, negotiated=${g}`), this.unmixedAudioProvider.setNegotiatedState(g), g || (this.codec = "None", (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.setCodec(this.codec, this.streamMixer.isSingleInputStream()));
                }
                setParticipantSpatialAudioPositions(g) {
                    this.streamMixer.setParticipantSpatialAudioPositions(g);
                }
                disableStreamsMixer(g) {
                    var _this_unmixedAudioProvider_comfortNoiseStream;
                    g ? this.streamMixer.stopMixing() : this.streamMixer.startMixing(this.unmixedAudioProvider.streams.concat((_this_unmixedAudioProvider_comfortNoiseStream = this.unmixedAudioProvider.comfortNoiseStream) !== null && _this_unmixedAudioProvider_comfortNoiseStream !== void 0 ? _this_unmixedAudioProvider_comfortNoiseStream : []));
                }
                getStatsProvider() {
                    return this.statsProvider;
                }
                getUnmixedAudioProvider() {
                    return this.unmixedAudioProvider;
                }
                configureSpatialAudio(g) {
                    this.unmixedAudioProvider.setConfiguredState(g);
                }
                async storeApiRecording() {
                    var _this_recordingCompletePromise;
                    if (this.enabledApiRecording && this.initCompleted) return (_this_recordingCompletePromise = this.recordingCompletePromise) === null || _this_recordingCompletePromise === void 0 ? void 0 : _this_recordingCompletePromise.resolve(), this.recordingCompletePromise = new ct, this.imp.sendApiRecordingData(), this.recordingCompletePromise.promise;
                }
                initDone(g, f) {
                    if (this.healerCapabilities = f, this.logger.safe.info(`Init done, errorCode=${g}`), 0 !== g) return void this.event("initFailed").raise(g);
                    this.logger.safe.info(`healerCapabilities=${JSON.stringify(f)}`), this.initCompleted = !0;
                    const S = Math.floor(this.healerCapabilities.maxNumStreamsPerPacket * this.maxNumOfStreamsFactor), v = this.unmixedAudioProvider.setupStreams(S, !0);
                    this.imp.passWriteableStreams(v.streams, v.cnStream), this.setCodecInternal(), this.imp.setRecvPayloads(this.recvPayloads);
                }
                usedDecoderChanged(g) {
                    this.logger.safe.info(`Used decoder changed to custom=${g}, configured codec=${this.codec}`), this.event("usedDecoderChanged").raise(g), this.unmixedAudioProvider.setDetectedCodec(this.codec);
                }
                packetReceived(g, f, S, v) {
                    this.statsProvider.ssrc = f, this.statsProvider.addPushStats(g, v), this.contributingSources.length === S.length && this.contributingSources.every((g, f)=>g === S[f]) || (this.contributingSources = S, this.event("contributingSourcesChanged").raise(S));
                }
                newDataWrittenToStreams(g) {
                    var _this_imp;
                    const f = Array.from(new Int32Array(g));
                    this.unmixedAudioProvider.setStreamSources(f), this.streamMixer.setStreamSources(f);
                    const S = f.reduce((g, f, S)=>(f === As && g.push(S), g), []);
                    (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.setAvailableStreams(S);
                }
                packetDecoded(g, f, S) {
                    this.statsProvider.addPullStats(g, f, S, S.extra.samplingRatekHz * this.healerCapabilities.frameLengthMs);
                }
                apiRecordingAvailable(g, f, S) {
                    var _this_recordingCompletePromise;
                    if (this.logger.safe.debug(`API recording available: errorCode=${g}, name=${f}, buffer length=${S.byteLength}`), (_this_recordingCompletePromise = this.recordingCompletePromise) === null || _this_recordingCompletePromise === void 0 ? void 0 : _this_recordingCompletePromise.resolve(), 0 === S.byteLength) return;
                    const v = new Blob([
                        S
                    ], {
                        type: "application/octet-stream"
                    }), _ = URL.createObjectURL(v), C = document.createElement("a");
                    C.href = _, C.download = f, C.click();
                }
                setCodecInternal() {
                    var _this_unmixedAudioProvider_comfortNoiseStream;
                    this.streamMixer.setMixerType(getStreamGeneratorType(this.codec), this.unmixedAudioProvider.streams.concat((_this_unmixedAudioProvider_comfortNoiseStream = this.unmixedAudioProvider.comfortNoiseStream) !== null && _this_unmixedAudioProvider_comfortNoiseStream !== void 0 ? _this_unmixedAudioProvider_comfortNoiseStream : [])), this.imp.setCodec(this.codec, this.streamMixer.isSingleInputStream()), this.statsProvider.codecName = this.codec;
                }
                injectWebMA() {
                    const g = window.webMA;
                    g && (g.wasmDecoder = {
                        debugLogging: (g)=>{
                            var _this_imp;
                            return (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.debugLogging(g);
                        },
                        sendApiRecordingData: ()=>{
                            var _this_imp;
                            return (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.sendApiRecordingData();
                        }
                    });
                }
                removeWebMA() {
                    const g = window.webMA;
                    g && delete g.wasmDecoder;
                }
                constructor(g, f, S, v){
                    var _f_config_useInsertableStreams_audioWasmCodec, _f_config_useInsertableStreams;
                    super(), this.logger = g, this.maxNumOfStreamsFactor = S, this.statsProvider = new Os, this.contributingSources = [], this.unmixedAudioProvider = new bs(this.logger), this.codec = "None", this.recvPayloads = [], this.initCompleted = !1, this.enabledApiRecording = !1;
                    try {
                        this.enabledApiRecording = "true" === localStorage.getItem("enableApiRecording");
                    } catch (e) {}
                    this.streamMixer = new ys(this.logger, v), this.unmixedAudioProvider.setConfiguredState(!!f.mediaConfig.spatialAudioEnabled), this.wasmHealerPullStrategy = ((_f_config_useInsertableStreams = f.config.useInsertableStreams) === null || _f_config_useInsertableStreams === void 0 ? void 0 : (_f_config_useInsertableStreams_audioWasmCodec = _f_config_useInsertableStreams.audioWasmCodec) === null || _f_config_useInsertableStreams_audioWasmCodec === void 0 ? void 0 : _f_config_useInsertableStreams_audioWasmCodec.wasmHealerPullStrategy) || -1, this.injectWebMA();
                }
            };
            function getStreamGeneratorType(g) {
                switch(g){
                    case "SatinFB":
                        return 0;
                    case "MUCHv2":
                        return 1;
                    case "None":
                        return -1;
                    default:
                        throw new Error(`unknown codec: ${g}`);
                }
            }
            var Os = class {
                get codecName() {
                    return this.codec;
                }
                set codecName(g) {
                    this.codec = g;
                }
                addPushStats(g, f) {
                    this.decoderStats.pushCount++, this.decoderStats.pushErrCount += 0 !== g ? 1 : 0, this.inboudStats.jitterBufferDelay += f.webrtc.jitterBufferDelay, this.customHealerStats.packetDurationInMs = f.extra.packetDurationInMs, this.packetPushProccesingTimes.addSample(f.extra.processingTime), this.customHealerStats.cnpPushCount = f.extra.totalCountCNPackets, this.customHealerStats.redPacketsCount += 0 !== f.extra.redundancyTimestampOffset ? 1 : 0;
                }
                addPullStats(g, f, S, v) {
                    var _;
                    var _f;
                    this.decoderStats.pullCount++, this.decoderStats.pullErrCount += 0 !== g ? 1 : 0, this.inboudStats.audioLevel = S.webrtc.audioLevel, this.inboudStats.totalAudioEnergy = S.webrtc.totalAudioEnergy, this.inboudStats.jitterBufferEmittedCount = S.webrtc.jitterBufferEmittedCount, this.inboudStats.totalSamplesReceived = S.webrtc.totalSamplesReceived, this.inboudStats.concealedSamples = S.webrtc.concealedSamples, this.inboudStats.silentConcealedSamples = S.webrtc.silentConcealedSamples, this.numOfStreamsCounter.addSample(f), this.customHealerStats.FECPayloadDecodedSamples = S.extra.FECPayloadDecodedSamples, this.customHealerStats.numSamplesPerFrame = v, this.customHealerStats.pullAdspPayloadType = S.extra.pullAdspPayloadType, this.customHealerStats.concealSamples = S.extra.concealSamples, this.customHealerStats.stretchSamples = S.extra.stretchSamples, this.customHealerStats.healedSamples = S.extra.healedSamples, this.customHealerStats.decodedSamples = S.extra.decodeSamples, this.packetPullProccesingTimes.addSample(S.extra.processingTime), this.customHealerStats.cnpPullCount = S.extra.totalCountCNGeneratedFrames, this.customHealerStats.cngSamples = S.extra.cngSamples, (_f = (_ = this.pullProcessingTimePerStreamNumber)[f]) !== null && _f !== void 0 ? _f : _[f] = new Ds(0, 200), this.pullProcessingTimePerStreamNumber[f].addSample(S.extra.processingTime), this.packetPullTimings.addSample(S.pullTiming);
                }
                getWebRtcCompatibleStats() {
                    return this.inboudStats;
                }
                getWasmStats() {
                    this.customHealerStats.pushProcessingTimes = this.packetPushProccesingTimes.getFrequencies(), this.customHealerStats.pullProcessingTimes = this.packetPullProccesingTimes.getFrequencies(), this.customHealerStats.pullNumOfStreamsCounter = this.numOfStreamsCounter.getFrequencies(), this.customHealerStats.pullTimings = this.packetPullTimings.getFrequencies();
                    for (const g of Object.keys(this.pullProcessingTimePerStreamNumber))this.customHealerStats.pullProcessingTimePerStreamNumber[g] = this.pullProcessingTimePerStreamNumber[g].getFrequencies();
                    return this.customHealerStats;
                }
                getDecoderStats() {
                    return this.decoderStats;
                }
                constructor(){
                    this.customHealerStats = {
                        numSamplesPerFrame: 0,
                        FECPayloadDecodedSamples: 0,
                        concealSamples: 0,
                        stretchSamples: 0,
                        healedSamples: 0,
                        decodedSamples: 0,
                        redPacketsCount: 0,
                        pushProcessingTimes: {},
                        pullProcessingTimes: {},
                        pullProcessingTimePerStreamNumber: {},
                        pullTimings: {},
                        pullNumOfStreamsCounter: {}
                    }, this.inboudStats = {
                        silentConcealedSamples: 0,
                        concealedSamples: 0,
                        totalSamplesReceived: 0,
                        audioLevel: 0,
                        jitterBufferDelay: 0,
                        jitterBufferEmittedCount: 0
                    }, this.decoderStats = {
                        pushCount: 0,
                        pushErrCount: 0,
                        pullCount: 0,
                        pullErrCount: 0
                    }, this.packetPushProccesingTimes = new Ds(0, 1e3), this.packetPullProccesingTimes = new Ds(0, 1e3), this.numOfStreamsCounter = new Ds(0, 10), this.pullProcessingTimePerStreamNumber = {}, this.packetPullTimings = new Ds(0, 1e3);
                }
            }, Ds = class {
                addSample(g) {
                    if (void 0 === g) return;
                    const f = Math.min(this.maxSample, Math.max(this.minSample, g));
                    var _this_frequencyDict_f;
                    this.frequencyDict[f] = ((_this_frequencyDict_f = this.frequencyDict[f]) !== null && _this_frequencyDict_f !== void 0 ? _this_frequencyDict_f : 0) + 1;
                }
                getFrequencies() {
                    return {
                        ...this.frequencyDict
                    };
                }
                constructor(g, f){
                    this.minSample = g, this.maxSample = f, this.frequencyDict = {};
                }
            };
            function createAudioWasmEncoderProxy(g, f, S) {
                return new Ns(g, f, S);
            }
            var Ns = class extends Ps {
                init(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "init",
                            args: [
                                g
                            ]
                        }
                    });
                }
                setCodec(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "setCodec",
                            args: [
                                g
                            ]
                        }
                    });
                }
                debugLogging(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "debugLogging",
                            args: [
                                g
                            ]
                        }
                    });
                }
                constructor(g, f, S){
                    super(g, f, 3, S);
                }
            }, ks = [
                "SatinFB"
            ], Ls = class extends Bt {
                dispose() {
                    var _this_imp;
                    super.dispose(), (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.dispose(), this.removeWebMA();
                }
                activateTransform(g) {
                    this.logger.safe.debug("Activating WASM encoder transform"), g.addTransform(this);
                }
                deactivateTransform() {
                    this.logger.safe.debug("Deactivating WASM encoder transform"), this.imp.dispose(), this.imp = null, this.encodersInitCodes = void 0, this.codec = "None";
                }
                createBaseInstance(g) {
                    this.logger.warn("WASM encoder could only be instantiated in worker");
                }
                createWorkerInstance(g, f) {
                    this.imp = createAudioWasmEncoderProxy(g, f, this), this.imp.init(ks);
                }
                setCodec(g) {
                    if (this.logger.safe.debug(`Setting codec to ${g}`), !this.encodersInitCodes) return this.logger.safe.debug("Encoder is not initialized yet, postponing codec setting"), void (this.codec = g);
                    this.codec !== g && (this.codec = g, this.setCodecInternal());
                }
                isCodecAllowed(g) {
                    return ks.includes(g);
                }
                negotiationCompleted(g) {
                    var _this_imp;
                    g || (this.codec = "None", (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.setCodec(this.codec));
                }
                initDone(g) {
                    this.logger.safe.info(`initDone: ${JSON.stringify(g)}`), this.encodersInitCodes = g, this.setCodecInternal();
                }
                packetEncoded(g) {
                    0 !== g && this.logger.safe.info(`encode failed: ${g}`);
                }
                setCodecInternal() {
                    var _this_encodersInitCodes_this_codec;
                    const g = (_this_encodersInitCodes_this_codec = this.encodersInitCodes[this.codec]) !== null && _this_encodersInitCodes_this_codec !== void 0 ? _this_encodersInitCodes_this_codec : -2147024809;
                    if ("None" !== this.codec && 0 !== g) return this.logger.safe.error(`WASM encoder is failed to init codec ${this.codec}, err code: ${g}`), void this.event("initCodecFailed").raise(g);
                    this.imp.setCodec(this.codec);
                }
                injectWebMA() {
                    const g = window.webMA;
                    g && (g.wasmEncoder = {
                        debugLogging: (g)=>{
                            var _this_imp;
                            return (_this_imp = this.imp) === null || _this_imp === void 0 ? void 0 : _this_imp.debugLogging(g);
                        }
                    });
                }
                removeWebMA() {
                    const g = window.webMA;
                    g && delete g.wasmEncoder;
                }
                constructor(g){
                    super(), this.logger = g, this.codec = "None", this.injectWebMA();
                }
            }, Fs = P, xs = class extends Bt {
                get decoder() {
                    return this.decoderImp;
                }
                get encoder() {
                    return this.encoderImp;
                }
                init(g, f) {
                    var _this_codecConfig;
                    if (!g || !this.codecContext || !((_this_codecConfig = this.codecConfig) === null || _this_codecConfig === void 0 ? void 0 : _this_codecConfig.enable)) return;
                    this.isEnabled = !0;
                    const S = this.codecConfig.maxNumOfStreamsFactor || 1;
                    this.decoderImp = new Ms(this.logger.createChild("AudioWasmDecoder"), this.configProvider, S, f), this.codecConfig.enableSend && (this.encoderImp = new Ls(this.logger.createChild("AudioWasmEncoder"))), this.subscribeToStreamManagerEvents(this.encStreamsManager), this.subscribeToCodecsEvents();
                }
                dispose() {
                    var _this_decoderImp, _this_encoderImp;
                    super.dispose(), this.unsubscribeFromEvents(), (_this_decoderImp = this.decoderImp) === null || _this_decoderImp === void 0 ? void 0 : _this_decoderImp.dispose(), (_this_encoderImp = this.encoderImp) === null || _this_encoderImp === void 0 ? void 0 : _this_encoderImp.dispose();
                }
                getSessionEvents() {
                    return this.sessionStats.getSessionEvents();
                }
                prepareForNegotiation(g) {
                    var _this_decoderImp_getUnmixedAudioProvider, _this_decoderImp, _this_codecConfig, _this_encoder, _this_decoderImp1, _this_encoderImp;
                    if (!this.isEnabled) return;
                    const f = ((_this_decoderImp = this.decoderImp) === null || _this_decoderImp === void 0 ? void 0 : (_this_decoderImp_getUnmixedAudioProvider = _this_decoderImp.getUnmixedAudioProvider()) === null || _this_decoderImp_getUnmixedAudioProvider === void 0 ? void 0 : _this_decoderImp_getUnmixedAudioProvider.configured) ? "MUCHv2" : this.codecConfig.codec || "None";
                    this.codecContext.codec !== f && (this.codecContext.initSendFailed = !1), this.codecContext.lastUsedCodec = this.codecContext.codec, this.codecContext.codec = f, this.codecContext.enabledLocally = !this.codecContext.initFailed && "None" !== f, this.codecContext.enabledForSend = this.codecContext.enabledLocally && !this.codecContext.initSendFailed && !!((_this_codecConfig = this.codecConfig) === null || _this_codecConfig === void 0 ? void 0 : _this_codecConfig.enableSend) && ((_this_encoder = this.encoder) === null || _this_encoder === void 0 ? void 0 : _this_encoder.isCodecAllowed(f)), this.logger.safe.info(`Audio codec state: context=${JSON.stringify(this.codecContext)}`), this.codecContext.initFailed || !g && this.codecContext.disabledRemotely || (this.sessionStats.toggleState("None" !== f), (_this_decoderImp1 = this.decoderImp) === null || _this_decoderImp1 === void 0 ? void 0 : _this_decoderImp1.setCodec(f), (_this_encoderImp = this.encoderImp) === null || _this_encoderImp === void 0 ? void 0 : _this_encoderImp.setCodec(this.codecContext.enabledForSend ? f : "None"));
                }
                negotiationCompleted() {
                    var _this_decoderImp, _this_encoderImp;
                    if (!this.isEnabled) return !1;
                    const g = this.codecContext.enabledLocally && !this.codecContext.disabledRemotely;
                    return (_this_decoderImp = this.decoderImp) === null || _this_decoderImp === void 0 ? void 0 : _this_decoderImp.negotiationCompleted(g), (_this_encoderImp = this.encoderImp) === null || _this_encoderImp === void 0 ? void 0 : _this_encoderImp.negotiationCompleted(g), this.sessionStats.negotiationCompleted(g, this.codecContext.enabledForSend), g;
                }
                configureSpatialAudio(g, f) {
                    var _this_decoderImp;
                    if (!this.isEnabled) return !1;
                    (_this_decoderImp = this.decoderImp) === null || _this_decoderImp === void 0 ? void 0 : _this_decoderImp.configureSpatialAudio(g);
                    return (g && "MUCHv2" !== this.codecContext.codec || !g && "MUCHv2" === this.codecContext.codec) && this.event("negotiationNeeded").raise(f), !0;
                }
                subscribeToStreamManagerEvents(g) {
                    this.subs.push(g.on("onTransformsCollectionCreated", (g)=>this.handleTransformsCollectionCreated(g)), g.on("onTransformsCollectionCleared", (g)=>this.handleTransformsCollectionCleared(g)));
                }
                handleTransformsCollectionCreated(g) {
                    "Audio" === g.mediaType && (this.decoderImp && "Receiver" === g.objType ? this.decoderImp.activateTransform(g.collection) : this.encoderImp && "Sender" === g.objType && this.encoderImp.activateTransform(g.collection));
                }
                handleTransformsCollectionCleared(g) {
                    "Audio" === g.mediaType && (this.decoderImp && "Receiver" === g.objType ? this.decoderImp.deactivateTransform() : this.encoderImp && "Sender" === g.objType && this.encoderImp.deactivateTransform());
                }
                subscribeToCodecsEvents() {
                    this.decoderImp && this.subs.push(this.decoderImp.on("initFailed", (g)=>this.handleCodecInitFailed("decoder", g))), this.encoderImp && this.subs.push(this.encoderImp.on("initCodecFailed", (g)=>this.handleCodecInitFailed("encoder", g)));
                }
                unsubscribeFromEvents() {
                    this.subs.forEach((g)=>g.dispose()), this.subs = [];
                }
                handleCodecInitFailed(g, f) {
                    "decoder" === g ? this.codecContext.initFailed = !0 : this.codecContext.initSendFailed = !0;
                    const S = generateCauseId();
                    this.logger.safe.warn(`[${S}] Audio ${g} init failed ${f}`), this.sessionStats.initFailed(f, g), this.event("negotiationNeeded").raise(S);
                }
                constructor(g, f, S){
                    var _this_configProvider_config_useInsertableStreams;
                    super(), this.encStreamsManager = g, this.logger = f, this.configProvider = S, this.isEnabled = !1, this.sessionStats = new Vs, this.subs = [], this.codecContext = this.configProvider.mediaConfig.audioCodecContext, this.codecConfig = (_this_configProvider_config_useInsertableStreams = this.configProvider.config.useInsertableStreams) === null || _this_configProvider_config_useInsertableStreams === void 0 ? void 0 : _this_configProvider_config_useInsertableStreams.audioWasmCodec;
                }
            }, Us = class _AudioCodecSessionStats {
                toggleState(g) {
                    this.sessionEvents.toggleCount++, this.inProgressNegotiation = {
                        ts: Date.now(),
                        enabled: g,
                        negotiated: !1,
                        sendEnabled: !1
                    }, arrayLimitedPush2(this.sessionEvents.negotiationAttempts, this.inProgressNegotiation, _AudioCodecSessionStats.maxStoreNegotiations);
                }
                negotiationCompleted(g, f) {
                    this.inProgressNegotiation && (this.sessionEvents.negotiatedCount += g ? 1 : 0, this.sessionEvents.failedNegotiationCount += this.inProgressNegotiation.enabled && !g ? 1 : 0, this.inProgressNegotiation.negotiated = g, this.inProgressNegotiation.sendEnabled = f, this.inProgressNegotiation = void 0);
                }
                initFailed(g, f) {
                    "decoder" === f ? this.sessionEvents.decoderInitError = g : this.sessionEvents.encoderInitError = g;
                }
                getSessionEvents() {
                    return (0, Fs.clone)(this.sessionEvents);
                }
                constructor(){
                    this.sessionEvents = {
                        negotiationAttempts: [],
                        toggleCount: 0,
                        negotiatedCount: 0,
                        failedNegotiationCount: 0,
                        decoderInitError: 0,
                        encoderInitError: 0
                    };
                }
            };
            Us.maxStoreNegotiations = 5;
            var Vs = Us, Bs = class {
                initialize() {
                    return Promise.race([
                        this.initDefer.promise,
                        delay(5e3).then(()=>{
                            var _this_loaded;
                            (_this_loaded = this.loaded) !== null && _this_loaded !== void 0 ? _this_loaded : this.logger.safe.warn("worker initialization timeout");
                        })
                    ]);
                }
                isWorkerLoaded() {
                    return this.loaded;
                }
                sendTransformCommand(g, f, S = []) {
                    var _this_worker;
                    const v = {
                        type: "transform",
                        clientId: g,
                        payload: f
                    };
                    (_this_worker = this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.postMessage(v, S);
                }
                subscribeClient(g, f, S) {
                    var _this_clientsMap_get;
                    const v = (_this_clientsMap_get = this.clientsMap.get(g)) !== null && _this_clientsMap_get !== void 0 ? _this_clientsMap_get : new Map;
                    v.set(f, S), this.clientsMap.set(g, v);
                }
                unsubscribeClient(g) {
                    this.clientsMap.delete(g);
                }
                dispose() {
                    var _this_worker, _this_worker1;
                    const g = {
                        type: "generic",
                        payload: {
                            operation: "dispose"
                        }
                    };
                    (_this_worker = this.worker) === null || _this_worker === void 0 ? void 0 : _this_worker.postMessage(g), (_this_worker1 = this.worker) === null || _this_worker1 === void 0 ? void 0 : _this_worker1.terminate();
                }
                handleEvent(g) {
                    switch(g.type){
                        case "init":
                            this.initDefer.resolve(), this.loaded = !0, this.logger.safe.info("worker initialized");
                            break;
                        case "transform":
                            {
                                const f = this.clientsMap.get(g.payload.clientId), S = f === null || f === void 0 ? void 0 : f.get(g.payload.event.transformType);
                                S ? S(g.payload.event) : this.logger.safe.error(`received event for unknown Client ${g.payload.clientId} or transformType ${g.payload.event.transformType}: ${g.payload.event.name}`);
                            }
                            break;
                        case "log":
                            switch(g.level){
                                case "debug":
                                    this.logger.safe.debug(g.msg);
                                    break;
                                case "info":
                                    this.logger.safe.info(g.msg);
                                    break;
                                case "warn":
                                    this.logger.safe.warn(g.msg);
                                    break;
                                case "error":
                                    this.logger.safe.error(g.msg);
                                    break;
                                default:
                                    this.logger.safe.error(`unknown log level ${g.level}`);
                            }
                            break;
                        default:
                            this.logger.safe.error(`received unsupported event from worker ${g.type}`);
                    }
                }
                constructor(g, f){
                    this.logger = f, this.clientsMap = new Map, this.loaded = !1, this.initDefer = new ct;
                    try {
                        this.worker = g.getWorker(this.logger), this.worker.onmessage = (g)=>this.handleEvent(g.data), this.worker.onerror = (g)=>{
                            this.logger.safe.error(`error inside worker: ${g.message}`), this.initDefer.resolve();
                        };
                    } catch (g) {
                        this.logger.safe.error("failed to create worker"), this.initDefer.resolve();
                    }
                }
            }, Hs = 7, $s = 31, js = class {
                transform(g) {
                    return this.processChunk(g), g;
                }
                dispose() {}
                getStartCodeSize(g) {
                    const f = g.getUint32(0);
                    return 1 === f ? 4 : 256 == (4294967040 & f) ? 3 : 0;
                }
                processChunk(g) {
                    if ("key" !== g.type) return;
                    const f = this.isH264KeyFrame(g.data) ? `${this.getH264Profile(g.data)}(H264)` : "unknown";
                    this.logger.info(`keyframe metadata: ${JSON.stringify(g.getMetadata())}, profile=${f}`);
                }
                isH264KeyFrame(g) {
                    if (g.byteLength < 7) return !1;
                    const f = new DataView(g), S = this.getStartCodeSize(f);
                    return !!S && (f.getUint8(S) & $s) === Hs;
                }
                getH264Profile(g) {
                    const f = new DataView(g), S = this.getStartCodeSize(f);
                    return (16777215 & f.getUint32(S)).toString(16);
                }
                constructor(g){
                    this.logger = g, this.transformType = 0;
                }
            }, Gs = class extends Ps {
                constructor(g, f){
                    super(g, f, 0, void 0);
                }
            }, qs = class {
                createBaseInstance(g) {
                    this.imp = new js(this.logger.safe), g.addTransform(this.imp);
                }
                createWorkerInstance(g, f) {
                    this.imp = new Gs(g, f);
                }
                constructor(g){
                    this.logger = g;
                }
            }, Ws = class {
                transform(g) {
                    return this.muted ? null : g;
                }
                mute(g) {
                    this.muted = g;
                }
                dispose() {}
                constructor(){
                    this.transformType = 1, this.muted = !1;
                }
            }, zs = class extends Ps {
                mute(g) {
                    this.worker.sendTransformCommand(this.clientId, {
                        operation: "invoke",
                        func: {
                            transformType: this.transformType,
                            name: "mute",
                            args: [
                                g
                            ]
                        }
                    });
                }
                constructor(g, f){
                    super(g, f, 1, void 0);
                }
            }, Ks = class {
                createBaseInstance(g) {
                    this.imp = new Ws, g.addTransform(this.imp);
                }
                createWorkerInstance(g, f) {
                    this.imp = new zs(g, f);
                }
                mute(g) {
                    this.logger.safe.info(`Dropping audio chunks: ${g}`), this.imp.mute(g);
                }
                constructor(g){
                    this.logger = g;
                }
            }, Js = class {
                clearTransforms() {
                    for (const g of this.transforms)g.dispose();
                    this.transforms = [];
                }
                addTransform(g) {
                    this.transforms.push(g);
                }
                getTransform(g) {
                    return this.transforms.find((f)=>f.transformType === g);
                }
                constructor(g, f){
                    this.transforms = [];
                    const S = new TransformStream({
                        transform: (g, f)=>{
                            let S = g;
                            for (const g of this.transforms)if (S = g.transform(S), !S) return;
                            f.enqueue(S);
                        }
                    });
                    g.pipeThrough(S).pipeTo(f);
                }
            }, Ys = class extends ze {
                get streams() {
                    var _this_sessionAudioProvider;
                    var _this_sessionAudioProvider_streams;
                    return (_this_sessionAudioProvider_streams = (_this_sessionAudioProvider = this.sessionAudioProvider) === null || _this_sessionAudioProvider === void 0 ? void 0 : _this_sessionAudioProvider.streams) !== null && _this_sessionAudioProvider_streams !== void 0 ? _this_sessionAudioProvider_streams : [];
                }
                get comfortNoiseStream() {
                    var _this_sessionAudioProvider;
                    var _this_sessionAudioProvider_comfortNoiseStream;
                    return (_this_sessionAudioProvider_comfortNoiseStream = (_this_sessionAudioProvider = this.sessionAudioProvider) === null || _this_sessionAudioProvider === void 0 ? void 0 : _this_sessionAudioProvider.comfortNoiseStream) !== null && _this_sessionAudioProvider_comfortNoiseStream !== void 0 ? _this_sessionAudioProvider_comfortNoiseStream : null;
                }
                get configured() {
                    var _this_sessionAudioProvider;
                    var _this_sessionAudioProvider_configured;
                    return (_this_sessionAudioProvider_configured = (_this_sessionAudioProvider = this.sessionAudioProvider) === null || _this_sessionAudioProvider === void 0 ? void 0 : _this_sessionAudioProvider.configured) !== null && _this_sessionAudioProvider_configured !== void 0 ? _this_sessionAudioProvider_configured : !1;
                }
                get active() {
                    var _this_sessionAudioProvider;
                    var _this_sessionAudioProvider_active;
                    return (_this_sessionAudioProvider_active = (_this_sessionAudioProvider = this.sessionAudioProvider) === null || _this_sessionAudioProvider === void 0 ? void 0 : _this_sessionAudioProvider.active) !== null && _this_sessionAudioProvider_active !== void 0 ? _this_sessionAudioProvider_active : !1;
                }
                get codec() {
                    var _this_sessionAudioProvider;
                    var _this_sessionAudioProvider_codec;
                    return (_this_sessionAudioProvider_codec = (_this_sessionAudioProvider = this.sessionAudioProvider) === null || _this_sessionAudioProvider === void 0 ? void 0 : _this_sessionAudioProvider.codec) !== null && _this_sessionAudioProvider_codec !== void 0 ? _this_sessionAudioProvider_codec : "None";
                }
                setSessionStreamsProvider(g) {
                    this.unsubscribeFromStreamEvents(), this.sessionAudioProvider = g, this.subscribeForStreamEvents(), this.event("onStreamsChanged").raise(), this.event("onActiveStateChanged").raise(this.active);
                }
                dispose() {
                    super.dispose(), this.unsubscribeFromStreamEvents();
                }
                subscribeForStreamEvents() {
                    this.sessionAudioProvider && this.subs.push(this.sessionAudioProvider.on("onStreamsChanged", ()=>this.event("onStreamsChanged").raise()), this.sessionAudioProvider.on("onStreamSourcesUpdated", (g)=>this.event("onStreamSourcesUpdated").raise(g)), this.sessionAudioProvider.on("onConfiguredStateChanged", (g)=>this.event("onConfiguredStateChanged").raise(g)), this.sessionAudioProvider.on("onActiveStateChanged", (g)=>this.event("onActiveStateChanged").raise(g)), this.sessionAudioProvider.on("onActiveCodecChanged", (g)=>this.event("onActiveCodecChanged").raise(g)));
                }
                unsubscribeFromStreamEvents() {
                    this.subs.forEach((g)=>g.dispose()), this.subs = [];
                }
                constructor(){
                    super(), this.subs = [];
                }
            }, Qs = class extends ze {
                get isVirtualDeviceEnabled() {
                    return this.allowVirtualDeviceInCall;
                }
                selectDevices(g) {
                    var _this_selectedVirtualDevice_camera, _this_selectedVirtualDevice_screenshare;
                    const f = this.defaultDeviceManager.getRegisteredDevices(), S = f.find((f)=>f.id === g.camera), v = f.find((f)=>f.id === g.screenshare);
                    this.logger.info(`Selecting virtual devices, camera: ${S === null || S === void 0 ? void 0 : S.id}, screenshare: ${v === null || v === void 0 ? void 0 : v.id}`);
                    const _ = {
                        camera: (_this_selectedVirtualDevice_camera = this.selectedVirtualDevice.camera) === null || _this_selectedVirtualDevice_camera === void 0 ? void 0 : _this_selectedVirtualDevice_camera.id,
                        screenshare: (_this_selectedVirtualDevice_screenshare = this.selectedVirtualDevice.screenshare) === null || _this_selectedVirtualDevice_screenshare === void 0 ? void 0 : _this_selectedVirtualDevice_screenshare.id
                    };
                    g.camera !== _.camera || g.screenshare !== _.screenshare ? (this.selectedVirtualDevice = {
                        camera: S,
                        screenshare: v
                    }, this.addToCallStat({
                        type: "VirtualDeviceSelected",
                        payload: this.selectedVirtualDevice
                    }), this.event("onSelectedVirtualDevicesChanged").raise(g, _)) : this.logger.info("Virtual Device did not change.");
                }
                getSelectedDevices() {
                    return Object.entries(this.selectedVirtualDevice).reduce((g, [f, S])=>(g[f] = S === null || S === void 0 ? void 0 : S.id, g), {});
                }
                getDeviceManager(g) {
                    return this.allowVirtualDeviceInCall ? this.getDeviceManagersForVirtualDevice(g)[0] : this.defaultDeviceManager;
                }
                getDeviceManagersForVirtualDevice(g) {
                    return "Video" === g && this.selectedVirtualDevice.camera ? (this.logger.info(`Using Virtual Device (DM), type: ${g}`), this.selectedVirtualDevice.camera.getDeviceManagers()) : "ScreenShare" === g && this.selectedVirtualDevice.screenshare ? (this.logger.info(`Using Virtual Device (DM), type: ${g}`), this.selectedVirtualDevice.screenshare.getDeviceManagers()) : (this.logger.info(`Using default DM, type: ${g}`), [
                        this.defaultDeviceManager
                    ]);
                }
                getDefaultDeviceManager() {
                    return this.defaultDeviceManager;
                }
                dispose() {
                    this.stats = [], this.subs.forEach((g)=>g.dispose()), super.dispose();
                }
                hasDevice(g) {
                    var _this_selectedVirtualDevice_camera, _this_selectedVirtualDevice_screenshare;
                    var _this_selectedVirtualDevice_camera_getDeviceManagers, _this_selectedVirtualDevice_screenshare_getDeviceManagers;
                    return this.defaultDeviceManager.id === g || [
                        ...(_this_selectedVirtualDevice_camera_getDeviceManagers = (_this_selectedVirtualDevice_camera = this.selectedVirtualDevice.camera) === null || _this_selectedVirtualDevice_camera === void 0 ? void 0 : _this_selectedVirtualDevice_camera.getDeviceManagers()) !== null && _this_selectedVirtualDevice_camera_getDeviceManagers !== void 0 ? _this_selectedVirtualDevice_camera_getDeviceManagers : [],
                        ...(_this_selectedVirtualDevice_screenshare_getDeviceManagers = (_this_selectedVirtualDevice_screenshare = this.selectedVirtualDevice.screenshare) === null || _this_selectedVirtualDevice_screenshare === void 0 ? void 0 : _this_selectedVirtualDevice_screenshare.getDeviceManagers()) !== null && _this_selectedVirtualDevice_screenshare_getDeviceManagers !== void 0 ? _this_selectedVirtualDevice_screenshare_getDeviceManagers : []
                    ].some((f)=>(f === null || f === void 0 ? void 0 : f.id) === g);
                }
                addToCallStat(g) {
                    const f = this.stats.push(g);
                    this.callStats.appendCallDeviceManagerInfo({
                        events: JSON.stringify(f)
                    });
                }
                handleRegisteredDeviceChange() {
                    const g = this.defaultDeviceManager.getRegisteredDevices(), { camera: f, screenshare: S } = this.selectedVirtualDevice;
                    let v = !1, _ = !1;
                    f && (v = g.some((g)=>g.id === f.id), this.logger.info(`Selected camera(${f.id}) in call, isCameraValid:${v}`)), S && (_ = g.some((g)=>g.id === S.id), this.logger.info(`Selected SS(${S.id}) in call, isScreenShareValid:${_}`)), this.selectDevices({
                        camera: v ? f.id : void 0,
                        screenshare: _ ? S.id : void 0
                    });
                }
                isModalityEnabled(g) {
                    return this.isMediaSending(getSkypeMediaType(g));
                }
                constructor(g, f, S, v, _){
                    super(), this.allowVirtualDeviceInCall = g, this.defaultDeviceManager = f, this.logger = S, this.callStats = v, this.isMediaSending = _, this.stats = [], this.selectedVirtualDevice = {
                        camera: void 0,
                        screenshare: void 0
                    }, this.subs = [
                        this.defaultDeviceManager.on("onVirtualDevicesChanged", ()=>this.handleRegisteredDeviceChange())
                    ], this.logger.info(`allowVirtualDeviceInCall: ${g}`);
                }
            }, Xs = class {
                raiseIfNeeded(g, f, S) {
                    if (!this.shouldBeRaised(g, f)) return;
                    clearTimeout(this.debounceMap.get(g.type));
                    const v = setTimeout(S, this.configProvider.config.remoteUFD.debounceTime, this.getState(g));
                    this.debounceMap.set(g.type, v);
                }
                dispose() {
                    for (const g of this.debounceMap.values())clearTimeout(g);
                    this.debounceMap.clear();
                }
                shouldBeRaised(g, f) {
                    var _this_configProvider_config_remoteUFD;
                    return !!((_this_configProvider_config_remoteUFD = this.configProvider.config.remoteUFD) === null || _this_configProvider_config_remoteUFD === void 0 ? void 0 : _this_configProvider_config_remoteUFD.enabled) && !(f > this.configProvider.config.remoteUFD.maxParticipantNumber) && !!this.configProvider.config.remoteUFD.list[g.type];
                }
                getState(g) {
                    return {
                        type: "clientMediaUfd",
                        level: "endpoint",
                        content: JSON.stringify(g)
                    };
                }
                constructor(g, f){
                    var _this_configProvider_config_remoteUFD;
                    this.logger = g, this.configProvider = f, this.debounceMap = new Map, ((_this_configProvider_config_remoteUFD = this.configProvider.config.remoteUFD) === null || _this_configProvider_config_remoteUFD === void 0 ? void 0 : _this_configProvider_config_remoteUFD.enabled) && Object.keys(this.configProvider.config.remoteUFD.list).length && this.logger.info(`Remote UFDs list: ${JSON.stringify(this.configProvider.config.remoteUFD.list)}`);
                }
            }, Zs = {
                reconnect: {
                    metrics: [
                        "ReconnectAttempts",
                        "ReconnectConnectedCount",
                        "RetargetCompletedCount",
                        "TerminationReason_code",
                        "TerminationReason_subCode",
                        "UFDs"
                    ],
                    Extensions: [
                        "StartTime",
                        "EndTime"
                    ]
                },
                rejectNegotiation: {
                    metrics: [
                        "NetworkEvents",
                        "ErrorDetail",
                        "UFDs",
                        "RollbackNegotiation",
                        "TerminationReason_code",
                        "TerminationReason_subCode"
                    ],
                    Extensions: [
                        "IceConnectionState",
                        "IceConnectionStatePrevious",
                        "StartTime",
                        "EndTime"
                    ]
                },
                visibilityHidden: Gt.MEDIA_EVENT_FIELDS
            }, eo = class extends ze {
                setDiagnosticsReport(g) {
                    this.diagnosticsReport = g;
                }
                setEventType(g) {
                    if (!this.configProvider.config.smallCallTelemetry.enable) return;
                    const f = Object.keys(this.configProvider.config.smallCallTelemetry.mediaUFDEventDictionary), S = this.getLastKnownMediaSessionStats();
                    if (S && (f === null || f === void 0 ? void 0 : f.forEach((f)=>{
                        if (f === g) {
                            const v = this.configProvider.config.smallCallTelemetry.mediaUFDEventDictionary[f], _ = {
                                eventType: g,
                                data: this.buildFromDictionary(S, v)
                            };
                            this.setTerminationCodeAndSubCodeToSuccess(_.data), this.event("sendSmallCallTelemetry").raise(_);
                        }
                    }), "reconnect" === g || "rejectNegotiation" === g || "visibilityHidden" === g)) {
                        const f = {
                            eventType: g,
                            data: this.buildFromDictionary(S, Zs[g])
                        };
                        void 0 === f.data.metrics.TerminationReason_code && this.setTerminationCodeAndSubCodeToSuccess(f.data), this.event("sendSmallCallTelemetry").raise(f);
                    }
                }
                getEndCallSmallTelemetry(g) {
                    const f = this.getLastKnownMediaSessionStats(), S = this.buildFromDictionary(f, Gt.MEDIA_EVENT_FIELDS);
                    return g && (S.metrics.TerminationReason_code = Ii.CODE.SUCCESS, S.metrics.TerminationReason_subCode = Ii.SUB_CODE.BEACON), {
                        eventType: g ? "tabClosed" : "endCall",
                        data: S
                    };
                }
                getLastKnownMediaSessionStats() {
                    var _this_diagnosticsReport_rawRootRef_sessions_;
                    if (!this.diagnosticsReport) return;
                    const g = this.diagnosticsReport.rawRootRef.sessions.length;
                    return this.diagnosticsReport.getSessionTelemetry((_this_diagnosticsReport_rawRootRef_sessions_ = this.diagnosticsReport.rawRootRef.sessions[g - 1]) === null || _this_diagnosticsReport_rawRootRef_sessions_ === void 0 ? void 0 : _this_diagnosticsReport_rawRootRef_sessions_.sessionId);
                }
                buildFromDictionary(g, f) {
                    const S = {
                        Extensions: {},
                        metrics: {}
                    };
                    if (!g) return S;
                    for(const v in f)g[v] && (S[v] = {}, f[v].forEach((f)=>{
                        void 0 !== g[v][f] && (S[v][f] = g[v][f]);
                    }));
                    return S;
                }
                setTerminationCodeAndSubCodeToSuccess(g) {
                    void 0 === g.metrics.TerminationReason_code && (g.metrics.TerminationReason_code = Ii.CODE.SUCCESS, g.metrics.TerminationReason_subCode = Ii.CODE.SUCCESS);
                }
                constructor(g){
                    super(), this.configProvider = g;
                }
            }, to = [
                1,
                2,
                9,
                10,
                11,
                12,
                30,
                27,
                28
            ], io = "remote", no = "remote", ro = class extends ze {
                constructor(g, f){
                    super(), this.isStreaming = g, this.mediaType = f;
                }
            }, ao = class _PluginlessCall extends ze {
                get callMode() {
                    return this._callMode;
                }
                get callId() {
                    return this._callId;
                }
                get endpointId() {
                    return this._endpointId;
                }
                get isHostless() {
                    return this.signalingSession.isHostLessCall;
                }
                get transferState() {
                    return this._transferState;
                }
                get parkState() {
                    return this._parkState;
                }
                get capabilities() {
                    return this._capabilities;
                }
                get publishedStates() {
                    return this._publishedStates;
                }
                get dataChannelAdapter() {
                    return this.dataChannel;
                }
                get participantId() {
                    try {
                        var _this_signalingSession_participantManager_localParticipant, _this_signalingSession_participantManager, _this_signalingSession;
                        const g = (_this_signalingSession = this.signalingSession) === null || _this_signalingSession === void 0 ? void 0 : (_this_signalingSession_participantManager = _this_signalingSession.participantManager) === null || _this_signalingSession_participantManager === void 0 ? void 0 : (_this_signalingSession_participantManager_localParticipant = _this_signalingSession_participantManager.localParticipant) === null || _this_signalingSession_participantManager_localParticipant === void 0 ? void 0 : _this_signalingSession_participantManager_localParticipant.participantId;
                        this._participantId = g || this._participantId;
                    } catch (g) {
                        this.logger.error("Error updating participantId");
                    }
                    return this._participantId;
                }
                get displayName() {
                    return this.localSignalingParticipant.displayName;
                }
                get role() {
                    return this.localSignalingParticipant.role;
                }
                get meetingRole() {
                    return this.localSignalingParticipant.meetingRole;
                }
                get advancedMeetingRole() {
                    return this.localSignalingParticipant.advancedMeetingRole;
                }
                get meetingRoles() {
                    return this.localSignalingParticipant.meetingRoles;
                }
                get maskedIdentityDetails() {
                    return {
                        isIdentityMasked: this.localSignalingParticipant.isIdentityMasked,
                        maskedIdSeqNumber: this.localSignalingParticipant.maskedIdSeqNumber,
                        maskedId: this.localSignalingParticipant.maskedId
                    };
                }
                get participantType() {
                    return this.localSignalingParticipant.participantType;
                }
                get isMuted() {
                    return 2 === this._muteState || 3 === this._muteState;
                }
                get tenantId() {
                    return this.localSignalingParticipant.tenantId;
                }
                get mediaLegId() {
                    return this._mediaLegId;
                }
                get isIncomingOneOnOneVideoCall() {
                    return this.isOneToOneCall() && this.isSomeoneStreamingVideo;
                }
                get mediaStreams() {
                    return this.streamManager.streams;
                }
                get origin() {
                    return this._origin;
                }
                get propertyBag() {
                    return this.localSignalingParticipant.propertyBag;
                }
                get version() {
                    return this.localSignalingParticipant.version;
                }
                get isAudioStreamConnected() {
                    return this._isAudioStreamConnected;
                }
                set isAudioStreamConnected(g) {
                    this._isAudioStreamConnected !== g && (this._isAudioStreamConnected = g, this._wasAudioStreamConnected = this._wasAudioStreamConnected || g, this.raiseChanged());
                }
                setMeetingRole(g) {
                    g !== this.localSignalingParticipant.meetingRole && (this.logger.info(`changing self role to [${g}]`), this.localSignalingParticipant.meetingRole = g, this.event("meetingRoleUpdated").raise(g));
                }
                setAdvancedMeetingRole(g) {
                    g !== this.localSignalingParticipant.advancedMeetingRole && (this.logger.info(`changing self advanced meeting role to [${g}]`), this.localSignalingParticipant.advancedMeetingRole = g, this.event("advancedMeetingRoleUpdated").raise(g));
                }
                setMeetingRoles(g) {
                    (0, zi.isEqual)(g, this.localSignalingParticipant.meetingRoles) || (this.logger.info(`changing self meeting roles to [${g}]`), this.localSignalingParticipant.meetingRoles = g, this.event("meetingRolesUpdated").raise(g));
                }
                setParticipantType(g) {
                    g !== this.localSignalingParticipant.participantType && (this.logger.info(`changing self participant user type to [${g}]`), this.localSignalingParticipant.participantType = g, this.event("participantTypeUpdated").raise(g));
                }
                setPropertyBag(g) {
                    g && !(0, zi.isEqual)(g, this.localSignalingParticipant.propertyBag) && (this.logger.info(`changing self participant property bag to [${g}]`), this.localSignalingParticipant.propertyBag = g, this.event("propertyBagUpdated").raise(g));
                }
                setPropertyRosterVersion(g) {
                    g !== this.localSignalingParticipant.version && (this.logger.info(`changing self participant property version to [${g}]`), this.localSignalingParticipant.version = g, this.event("propertyRosterVersionUpdated").raise(g));
                }
                setMaskedIdentityDetails(g = !1, f, S) {
                    this.localSignalingParticipant.isIdentityMasked === g && this.localSignalingParticipant.maskedIdSeqNumber === f && this.localSignalingParticipant.maskedId === S || (this.localSignalingParticipant.isIdentityMasked = g, this.localSignalingParticipant.maskedIdSeqNumber = f, this.localSignalingParticipant.maskedId = S, this.logger.info(`self participant masked identity details updated to [${JSON.stringify(this.maskedIdentityDetails)}]`), this.event("maskedIdentityDetailsUpdated").raise(this.maskedIdentityDetails));
                }
                setIsSomeoneStreamingVideo(g) {
                    this.logger.debug(`setting isSomeoneStreamingVideo to [${g}]`), this.isSomeoneStreamingVideo = g;
                }
                setJoinAsStreamingUser(g) {
                    g !== this.joinAsStreamingUser && (this.logger.info(`setting self join as streaming user to [${g}]`), this.joinAsStreamingUser = g);
                }
                setOtpIdentity(g) {
                    g !== this.otpIdentity && (this.logger.info("setting self participant optIdentity"), this.otpIdentity = g);
                }
                get spamRiskLevel() {
                    return this._spamRiskLevel;
                }
                set spamRiskLevel(g) {
                    g && (this._spamRiskLevel = g);
                }
                get spamStirAttestation() {
                    return this._spamStirAttestation;
                }
                set spamStirAttestation(g) {
                    g && (this._spamStirAttestation = g);
                }
                getScreenHandle(g) {
                    if (!this.sharedScreenHandle) {
                        const f = !!this.mediaSession && this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled, S = !!this.mediaSession && this.mediaSession.getSessionConfig().config.enableAudioSharing && !this.mediaSession.getSessionConfig().config.requireUserActionForAudioSharing, v = this.mediaStateConfigurationHelper.isSending(0) && S && f, _ = 3 === (g === null || g === void 0 ? void 0 : g.getType()) ? g === null || g === void 0 ? void 0 : g.getDeviceId() : void 0, C = this.callDeviceManager.getDeviceManager(getAgentMediaType(2));
                        C.setAudioSharingRequested(v), this.sharedScreenHandle = C.createDevicesHandle({
                            audio: v,
                            sharing: !0
                        }, "pluginlessCall:getScreenHandle()", _), this.sharedScreenHandle.on("onStreamStateChanged", (g, f)=>this.onSharingStreamStateChanged(g));
                    }
                    return this.sharedScreenHandle;
                }
                setCallOrigin(g) {
                    this.logger.info(`Set call origin to ${g}`), this._origin = g, this.callTelemetry.setCallOrigin(g), this.callTelemetry.recordEvent("_SetCallOrigin", {
                        origin: g
                    });
                }
                setMediaLegId(g) {
                    this._mediaLegId = g, this.callStats.setMediaLegId(g);
                }
                setCallId(g) {
                    this.callTelemetry.setCallId(g), this.callStats.setCallId(g), this._callId = g;
                }
                setEndpointId(g) {
                    this._endpointId = g, this.logger.info(`[endpointId=${truncate(this._endpointId, 8)}]`), this.callTelemetry.setEndpointId(g), this.callStats.setEndpointId(g);
                }
                setFailureType(g) {
                    this.callTelemetry.setFailureType(g), this.failureType = g;
                }
                setParticipantId(g) {
                    this._participantId = g, this.logger.info(`[participantId=${this._participantId}]`), this.callTelemetry.setParticipantId(this.participantId);
                }
                setDisplayName(g, f = generateCauseId()) {
                    this.logger.info(`[${f}][setDisplayName] displayName=${truncate(g, 4)}`), this.localSignalingParticipant.displayName = g, "anonymous" === this.participantType && (this.callStats.setDisplayName(g), this.callTelemetry.setDisplayName(g));
                }
                setCallerMri(g) {
                    this.callerMri = g, this.logger.info(`[callerMri=${scrubMriOrOmit(this.callerMri)}]`);
                }
                setDisplayNameSource(g) {
                    this.displayNameSource = g, this.logger.info(`[displayNameSource=${this.displayNameSource}]`);
                }
                setTransferorMri(g) {
                    const f = stripMriAliases(g);
                    f !== this.transferorMri && (this.transferorMri = f, this.logger.info(`transferorMri: ${scrubMriOrOmit(this.transferorMri)}`), this.raiseChanged());
                }
                setGroupId(g, f = generateCauseId()) {
                    this.logger.info(`[${f}][setGroupId] groupId=${scrubMriOrOmit(g)}`), this.groupId !== g && (this.groupId = g, this.callTelemetry.setGroupId(g), this.event("groupIdChanged").raise(g));
                }
                setMeetingData(g) {
                    if (g) {
                        if (g.meetingCode && (!this.meetingData || this.meetingData && g.meetingCode !== this.meetingData.meetingCode)) {
                            const f = g.meetingCode;
                            this.logger.info(`[setMeetingData] meetingCode=${!!f}`), this.callTelemetry.setMeetingCode(f), this.signalingSession.setMeetingCode(f);
                        }
                        if (g.meetingUrl && (!this.meetingData || this.meetingData && g.meetingUrl !== this.meetingData.meetingUrl)) {
                            const f = g.meetingUrl.split("?")[0];
                            this.logger.info(`[setMeetingData] meetingUrl=${!!g.meetingUrl}`), this.callTelemetry.setMeetingUrl(f), this.signalingSession.setMeetingUrl(f);
                        }
                    }
                    this.meetingData = g;
                }
                setHuddleGroupCall(g) {
                    this.isHuddleGroupCall !== !!g && (this.logger.info(`[setHuddleGroupCall] new isHuddleGroupCall=${g}`), this.isHuddleGroupCall = g, this.callTelemetry.setIsHuddleGroupCall(!0));
                }
                onConversationStartTimeChanged(g, f = generateCauseId()) {
                    if (this.logger.info(`onConversationStartTimeChanged: Conv start time=${g}`), g && this._rawConversationStartTime !== g) {
                        this.logger.info(`[${f}][onConversationStartTimeChanged] rawConvStartTime=${g}`);
                        try {
                            this.conversationStartTime = new Date(g), this._rawConversationStartTime = g, this.callTelemetry.setConversationStartTime(g);
                        } catch (f) {
                            this.logger.warn(`Failed to parse the raw conv start timestamp. Error: ${f}, rawConvStartTime: ${g}`);
                        }
                    }
                }
                setComplianceRecordingContent(g, f) {
                    try {
                        if (!(0, zi.isEqual)(this.complianceRecordingContent, f)) {
                            this.complianceRecordingContent = f;
                            const S = f ? JSON.stringify(f) : "";
                            this.callTelemetry.setComplianceRecordingContentLength(S.length), this.logger.info(`[${g}][setComplianceRecordingContent] complianceRecordingContentLength=${S.length}`);
                        }
                    } catch (f) {
                        this.logger.error(`[${g}][setComplianceRecordingContent] ${f}`);
                    }
                }
                setThreadId(g, f = generateCauseId()) {
                    this.threadId !== g && (this.logger.info(`[${f}][setThreadId] threadId=${getLoggableThreadId(g)}`), this.threadId = g, this.callTelemetry.setThreadId(g));
                }
                setBackroomThreadId(g, f = generateCauseId()) {
                    this.backroomThreadId !== g && (this.logger.info(`[${f}][setBackroomThreadId] backroomThreadId=${getLoggableThreadId(g)}`), this.backroomThreadId = g, this.callTelemetry.setBackroomThreadId(g));
                }
                setStreamThreadId(g, f = generateCauseId()) {
                    this.streamThreadId !== g && (this.logger.info(`[${f}][setStreamThreadId] streamThreadId=${getLoggableThreadId(g)}`), this.streamThreadId = g, this.callTelemetry.setStreamThreadId(g));
                }
                setLobbyThreadId(g, f = generateCauseId()) {
                    this.lobbyThreadId !== g && (this.logger.info(`[${f}][setLobbyThreadId] lobbyThreadId=${getLoggableThreadId(g)}`), this.lobbyThreadId = g, this.callTelemetry.setLobbyThreadId(g));
                }
                setMessageId(g, f = generateCauseId()) {
                    this.logger.info(`[${f}][setMessageId] messageId=${scrubMriOrOmit(g)}`), this.messageId = g, this.callTelemetry.setMessageId(g);
                }
                setSkypeId(g, f = generateCauseId()) {
                    this.skypeId !== g && (this.logger.info(`[${f}][setSkypeId]`), this.skypeId = g, this.callTelemetry.setSkypeId(g));
                }
                setCallType(g, f) {
                    const S = this.logger.createFnLogger("setCallType", f);
                    S.info(`current=${this.callType}, newValue: ${g}`), 2 !== this.callType || 1 !== g ? g !== this.callType && (this.callType = g, this.callTelemetry.setCallType(g), 2 === g && this.callStats.localStats.call.event(2), this.raiseChanged()) : S.logFailure("De-escalating to P2P should not happen!");
                }
                setConversationType(g, f) {
                    this.logger.createFnLogger("setConversationType", f).info(`current=${this.conversationType}, newValue=${g}`), g !== this.conversationType && (this.conversationType = g, this.callTelemetry.setConversationType(g), this.raiseChanged());
                }
                setCallUsesMixer(g, f) {
                    var _this_mediaSession;
                    this.callUsesMixer !== !!g && (this.logger.info(`[${f}][setCallUsesMixer] new value=${g}`), this.callUsesMixer = g, this.callTelemetry.recordEvent("_CallUsesMixer", {
                        newValue: g
                    }, f), this.dataChannel.setConfigProviderView((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig()));
                }
                setIsEscalationInProgress(g, f) {
                    this.logger.info(`[${f}][setIsEscalationInProgress] currentValue=${this.isEscalationInProgress}, newValue=${g}`), this.isEscalationInProgress = g, this.allowScreenSharingControl() && this.screenSharingControl.setIsEscalationInProgress(g), this.callTelemetry.recordEvent("_EscalationInProgress", void 0, f);
                }
                setFromApplicationType(g, f) {
                    g && (this.fromApplicationType = g, this.callTelemetry.recordEvent("_SetFromApplicationType", {
                        fromApplicationType: g
                    }, f));
                }
                setEnableCaptcha(g) {
                    g !== this.localSignalingParticipant.enableCaptcha && (this.logger.info(`setting self participant to enable captcha to [${g}]`), this.localSignalingParticipant.enableCaptcha = g, this.enableCaptcha = g);
                }
                processCallStartOptions(g, f) {
                    const S = this.logger.createFnLogger("_ProcessCallStartOptions", f);
                    try {
                        1 & g.preheatFlags && (this.isPreheatEnabled = !0);
                    } catch (g) {
                        S.logFailure(g);
                    }
                }
                getlocalScreenShareStream() {
                    return (0, zi.find)(this.localMediaStreams, (g)=>2 === g.mediaType);
                }
                setMeetingLayout(g, f) {
                    throw new Error("Method not implemented.");
                }
                async selectDevices(g) {
                    this.callDeviceManager.isVirtualDeviceEnabled ? this.callDeviceManager.selectDevices(g) : this.logger.error("allowVirtualDeviceInCall not enabled.");
                }
                async getSelectDevices() {
                    return this.callDeviceManager.getSelectedDevices();
                }
                createStage(g) {
                    throw new Error("Method not implemented.");
                }
                updateDisplayName(g) {
                    this.logger.info("updating displayName"), this.setDisplayName(g), this.signalingSession.participantManager.localParticipant.displayName = g;
                }
                init(g) {
                    if (this.logger.info(`init callInitOptions:${getPIISafeCallInitOptions(g)}`), this.signalingSessionCallOptions = {
                        teamsMessageId: g.messageId,
                        enableGroupCallMeetupGeneration: g.enableGroupCallMeetupGeneration,
                        meetingInfo: g.meetingInfo,
                        emergencyContent: g.emergencyContent ? JSON.parse(g.emergencyContent) : void 0,
                        broadcastContext: g.broadcastContext,
                        endpointMetadata: g.endpointMetadata
                    }, this.setMessageId(g.messageId), this.onBehalfOfMri = g.onBehalfOf, this.onBehalfOfUserDisplayName = g.onBehalfOfUserDisplayName, g.threadId && (this.setThreadId(g.threadId), this.signalingSession.setThreadId(g.threadId)), this.groupId && this.signalingSession.setGroupId(this.groupId), this.signalingSession.setCallOptions(this.signalingSessionCallOptions), g.transferContext) {
                        switch(this.logger.info("Transfer: Call.init, set transferContext", scrubITransferContext(g.transferContext)), this.signalingSession.setTransferContext(g.transferContext.context), g.transferContext.transferType){
                            case 1:
                                this.setCallOrigin(2);
                                break;
                            case 0:
                                this.setCallOrigin(1);
                                break;
                            case 2:
                                this.setCallOrigin(3);
                                break;
                            default:
                                throw new Error(`TransferType: ${g.transferContext.transferType} doesn't have a switch option`);
                        }
                        g.transferContext.context.callAcceptanceCallback ? this._transferredCallAcceptanceCallback = g.transferContext.context.callAcceptanceCallback : this.logger.info("[failed]Transfer: Missing transferred call acceptance callback"), g.transferContext.transferorMri && this.setTransferorMri(g.transferContext.transferorMri);
                    }
                    this.setIsEmergency(!!g.isEmergency), this.raiseChanged();
                }
                async initAsync(g) {
                    return this.init(g);
                }
                getIncomingRawAudioStream(g = generateCauseId()) {
                    if (!this.mediaSession) throw this.logger.error("can not execute getIncomingRawAudioStream as there is no mediaSession"), new Error("NoMediaSession");
                    return this.mediaSession.getIncomingRawAudioStream(g);
                }
                getUnmixedAudioProvider() {
                    return this.unmixedAudioProvider ? Promise.resolve(this.unmixedAudioProvider) : Promise.reject("No audio provider available");
                }
                setDeviceManager(g) {}
                async startVideo(g, f = generateCauseId()) {
                    return this.startStopVideo(!0, f, g);
                }
                async stopVideo(g, f = generateCauseId()) {
                    return this.startStopVideo(!1, f, g);
                }
                async dumpVideoSourceImages() {
                    return Promise.reject(60);
                }
                async hold(g, f = generateCauseId(), S, v) {
                    const _ = this.logger.createFnLogger("Hold", f);
                    return _.info(`[Hold][${f}] negotiationTag ${g} hold options: ${safeJsonStringify(S)}`), 4 === this.state ? (_.logFailure("Trying to put a call on hold which is already held state, early resolving the promise"), Promise.resolve(void 0)) : (S === null || S === void 0 ? void 0 : S.isLocal) ? this.localHold(f, S, v) : this.holdWithRenegotiate(f, S);
                }
                async holdWithRenegotiate(g, f) {
                    return this.isValidHoldResumeCallState(this.state) ? this.setHold(!0, g, f) : (this.logger.logFailure(`[Hold][${g}] Trying to hold a call in an invalid state: ${this.state}`), Promise.reject(`Trying to hold a call in an invalid state: ${this.state}`));
                }
                async localHold(g, f, S) {
                    return this.isValidHoldResumeCallState(this.state) ? this.setHold(!0, g, f, S) : (this.logger.logFailure(`[LocalHold][${g}] Trying to hold a call in an invalid state: ${this.state}`), Promise.reject(`Trying to hold a call in an invalid state: ${this.state}`));
                }
                async unhold(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("Unhold", f);
                    return 3 === this.state ? (S.logFailure("Trying to resume a call which is already in connected state, early resolving the promise"), Promise.resolve(void 0)) : 4 === this.state ? (S.info(`current hold state ${this.requestedHoldState}`), this.setHold(!1, f)) : (S.logFailure(`Trying to resume a call in an invalid state: ${this.state}`), Promise.reject(`Trying to resume a call in an invalid state: ${this.state}`));
                }
                canMerge(g, f) {
                    const S = g.isOneToOneCall(), v = 3 === this.state, _ = 4 === g.state, C = S && v && _;
                    return this.logger.info(`[${f}][canMerge] Call ${g.callId} isOneToOne ${S} isCallConnected ${v} call.state ${this.state} isMergeOnHold ${_} mergeCall.state ${g.state} CanMerge result: ${C}`), C;
                }
                async updateEndpointMetadata(g, f = generateCauseId()) {
                    return this.signalingSession.updateEndpointMetadata(g, f);
                }
                async sendDtmfTone(g) {
                    if (this.mediaSession) {
                        const f = this.toneToString(g);
                        return f ? (this.logger.info(`[${causeId}][sendDtmfTone]DtmfTone: <omitted>`), Promise.resolve(this.mediaSession.sendDtmf(f))) : Promise.reject(new Error("Unsupported DtmfTone"));
                    }
                    return Promise.reject(new Error("no mediaSession"));
                }
                async setAudioUsageMode(g) {
                    return Promise.reject(60);
                }
                async setAudioMidcallConfig(g, f) {
                    return Promise.reject(60);
                }
                async setAudioMidcallConfigJson(g, f = generateCauseId()) {
                    var _this_mediaSession;
                    if (!g) return Promise.reject(60);
                    isDefined(g.enableSpatialAudio) && ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.configureSpatialAudio(g.enableSpatialAudio, f)), g.noiseSuppressionMode && await this.setNoiseSuppressionMode(g.noiseSuppressionMode, g.enableAEC);
                }
                async setParticipantSpatialAudioPositions(g, f = generateCauseId()) {
                    var _this_mediaSession;
                    const S = g.map((g)=>{
                        var _this_participants_find;
                        return {
                            sourceId: (_this_participants_find = this.participants.find((f)=>f.id === g.participantId)) === null || _this_participants_find === void 0 ? void 0 : _this_participants_find.audio.id,
                            x: g.x,
                            y: g.y
                        };
                    });
                    return (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.setParticipantSpatialAudioPositions(S, f);
                }
                async setNoiseSuppressionMode(g, f) {
                    return this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe || this.mediaSession.getSessionConfig().config.wasmdns.enableNoiseSuppression ? "Auto" === g ? this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe ? this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaSession.getSessionConfig().config.wasmvqe.defaultVqeMode)) : this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(this.mediaSession.getSessionConfig().config.wasmdns.noiseSuppressionMode, f))) : this.mediaSession.getSessionConfig().config.wasmvqe.enableVqe ? this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(g, this.mediaSession.getSessionConfig().config.wasmvqe.enableAec))) : this.mediaAgent.getDeviceManager().setAudioEffects(this.mediaAgent.getDeviceManager().effectsManager.vqeModeToAudioEffectType(this.mediaAgent.getDeviceManager().effectsManager.nsModeToVqeMode(g, f))) : Promise.resolve();
                }
                setInitialTelemetry(g, f, S, v) {
                    let _, C, E, T, I;
                    switch(g){
                        case "Subscribe":
                        case "SubscribeWithMeetingData":
                            this.callTelemetry.setDirection("Outgoing"), this.callTelemetry.setSelfParticipantRole("SUBSCRIBE"), S || this.callTelemetry.setOperationVariant(g, "CCWM"), this.signalingSession.setInitialTelemetry(g, {
                                correlationId: this.callId,
                                causeId: v,
                                conversationServiceUrl: S
                            });
                            break;
                        case "Acknowledge":
                            0 !== this.state && 8 !== this.state && this.callTelemetry.maybeRecordOperationSuccess(g, {
                                code: 4
                            }), this.callTelemetry.setDirection("Incoming"), this.callTelemetry.setSelfParticipantRole("callee"), this.signalingSession.setInitialTelemetry(g, {
                                causeId: v
                            });
                            break;
                        case "JoinCall":
                        case "JoinWithMeetingData":
                            this.callTelemetry.setDirection("Incoming"), this.callTelemetry.setSelfParticipantRole("join"), 1 & f.callStartOptions.preheatFlags && this.callTelemetry.setOperationVariant(g, "Preheat"), _ = this.telemetryDataFromCallStartOptions(f.callStartOptions), _ && this.callTelemetry.updateOperationData(g, _, v), C = 1 == (1 & f.callStartOptions.muteFlags), E = 1 == (1 & f.callStartOptions.preheatFlags), T = {
                                muted: C,
                                isPreheatOnly: E
                            }, this.signalingSession.setInitialTelemetry(g, {
                                correlationId: this.callId,
                                causeId: v,
                                conversationServiceUrl: S,
                                joinCallOptions: T,
                                offerGenerationTime: Date.now() - f.callStartTime
                            });
                            break;
                        case "StartCall":
                        case "StartWithMeetingData":
                            this.callTelemetry.setDirection("Outgoing"), this.callTelemetry.setSelfParticipantRole("caller"), 1 & f.callStartOptions.preheatFlags && this.callTelemetry.setOperationVariant(g, "Preheat"), _ = this.telemetryDataFromCallStartOptions(f.callStartOptions), _ && this.callTelemetry.updateOperationData(g, _, v), I = f.callStartOptions, this.signalingSession.setInitialTelemetry(g, {
                                correlationId: this.callId,
                                causeId: v,
                                conversationServiceUrl: S,
                                callStartOptions: I,
                                offerGenerationTime: Date.now() - f.callStartTime
                            });
                            break;
                        case "StartCallToVoiceMail":
                        case "StartCallWithNudge":
                        case "StartCallAndUnpark":
                            this.callTelemetry.setDirection("Outgoing"), this.callTelemetry.setSelfParticipantRole("caller"), this.signalingSession.setInitialTelemetry(g, {
                                correlationId: this.callId,
                                causeId: v,
                                conversationServiceUrl: S,
                                startCallOptions: f.callStartOptions,
                                offerGenerationTime: Date.now() - f.callStartTime
                            });
                    }
                }
                async setHold(g, f, S, v) {
                    const _ = this.logger.createFnLogger("setHold", f, `hold=${g}`);
                    if (!this.canToggleAudio || this.callHoldResumeDeferred) return Promise.reject(new Error("can not set hold as it is already in progress"));
                    this.callHoldResumeDeferred = new ct, this.isHoldInProgress = g, this.canToggleAudio = !1, this.canToggleVideo = !1, this.canToggleScreenSharing = !1, this.requestedHoldState = g;
                    const always = ()=>{
                        this.canToggleAudio = !0, this.canToggleScreenSharing = !0, this.canToggleVideo = !0;
                    };
                    _.info(`start, holdOptions: ${JSON.stringify(S)}`);
                    const C = this.callHoldResumeDeferred.promise, E = g ? "Hold" : "Unhold", T = {
                        debugContent: {
                            clientScenario: this.convertClientScenario(v)
                        }
                    };
                    try {
                        if (g ? this.isMuteOnHold = S && S.isLocal && 5 !== this.state : this.prepareModalitiesForResume(f), !this.isMuteOnHold) {
                            const g = await this.updateMediaModalities(void 0, f);
                            this.updateMediaState(g, f), this.updateScreenSharingState(g, f);
                        }
                        g && (this.prepareModalitiesForHold(f), 5 === this.state && this.finishCallHoldResume(), this.setCallState(4, f)), this.isMuteOnHold && this.setMuteOnHold(g, f), always();
                        const v = {
                            code: 0,
                            subCode: 0,
                            phrase: ""
                        };
                        this.callTelemetry.recordOperationSuccess(E, v, null, f, T);
                    } catch (S) {
                        var _this_callHoldResumeDeferred;
                        this.callTelemetry.recordOperationFailure(E, {
                            error: getPIISafeObject(S)
                        }, null, f, T), _.logFailure(S), always(), (_this_callHoldResumeDeferred = this.callHoldResumeDeferred) === null || _this_callHoldResumeDeferred === void 0 ? void 0 : _this_callHoldResumeDeferred.reject(new Error(`Failed setting hold state to ${g}`)), this.callHoldResumeDeferred = null;
                    }
                    return C;
                }
                transferCall(g) {
                    return this.logger.warn("transferCall is deprecated, please use callBlindTransfer instead"), this.callBlindTransfer(g);
                }
                callBlindTransfer(g, f = generateCauseId(), S) {
                    return this.executeCallTransfer(g, f, 0, S);
                }
                callSafeTransfer(g, f = generateCauseId(), S) {
                    return this.executeCallTransfer(g, f, 0, S);
                }
                transferCallToVoicemail(g, f = generateCauseId()) {
                    return this.executeCallTransfer(g.transferTargetMri, f, 2, void 0);
                }
                callConsultativeTransfer(g, f = generateCauseId(), S, v) {
                    const _ = this.logger.createFnLogger("ConsultativeTransfer", f);
                    let C;
                    g.participants.length > 1 ? (C = this.getParticipantByLegId(S, g), C || (_.warn("getParticipantByLegId did not find a match in the participants list, defaulting to first participant"), C = g.participants[0])) : C = g.participants[0];
                    const E = C && C.acceptedBy || C && C.id;
                    return _.info(`transferTargetParticipantLegId: ${S} targetMri: ${scrubMriOrOmit(E)}`), this.executeConsultCallTransfer(g.callId, E, S, f, v);
                }
                async consultativeTransferWithPickupCode(g, f) {
                    const S = this.logger.createFnLogger("ConsultativeTransferWithPickupCode", f);
                    if (S.info(`pickup code: ${g}`), !g || isNaN(Number(g))) return S.info("pickup code cannot be empty"), Promise.reject(getRejectTransactionEnd("TransactionDisallowed"));
                    const v = this._callOperationHandler.createPendingOperation("_CallTransferInProgress", void 0, f, {
                        preconditionTags: [
                            "NOT_SUPPORTED_IN_STREAMING_MODE"
                        ]
                    }), _ = `4:${mi.SERVER_HOLD}`, C = {
                        unparkContent: {
                            pickupCode: Number(g)
                        }
                    }, E = {
                        disableForwardingAndUnanswered: !1
                    };
                    return this.signalingSession.transferCallAsync(_, "TransferTypeStandard", C, E, f), v;
                }
                callRedirect(g, f = generateCauseId()) {
                    return this.logger.createFnLogger("CallRedirect", f).info(`redirectOptions: ${JSON.stringify(g)}`), this.stopInternal({
                        terminatedReason: 75,
                        redirectOptions: g,
                        causeId: f
                    }).then(()=>({
                            code: Li.CallRedirected,
                            subCode: Fi.CallRedirectedSuccess,
                            phrase: ji.CallEndReasonRedirected,
                            resultCategories: [
                                "Success"
                            ]
                        }));
                }
                convertParkContext(g) {
                    switch(g){
                        case 1:
                            return "sharedLinePark";
                        case 4:
                            return "sharedLineParkV2";
                        case 0:
                            return "teamPark";
                        case 3:
                            return "serverHoldV2";
                        case 5:
                            return "callPark";
                        default:
                            return "serverHold";
                    }
                }
                convertClientScenario(g) {
                    switch(g){
                        case 0:
                            return "breakoutRoom";
                        case 1:
                            return "musicOnHoldV2";
                        case 2:
                            return "sharedLineAppearanceV2";
                        default:
                            return;
                    }
                }
                park(g, f = generateCauseId()) {
                    const S = this.convertParkContext(g);
                    return this.logger.info(`[${f}] [ParkCall] start -  context ${g} parkType ${S}`), 5 === g ? (this.callTelemetry.recordOperation(`${getParkTypeName(S)}`, f), this._pendingParkPromise = this._callOperationHandler.createPendingOperation("CallParkV2", void 0, f)) : this._pendingParkPromise = this._callOperationHandler.waitForOperation("ParkCall"), "serverHoldV2" !== S && "callPark" !== S && this._setParkState(1), this.signalingSession.parkCallAsync(S, f).catch((g)=>{
                        this.logger.info(`[${f}] [ParkCall] error in parkCallAsync (synchronous error) : ${getPIISafeObject(g)}. Hold promise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("ParkCall", {
                            error: getPIISafeObject(g)
                        }, f);
                    }), this._pendingParkPromise;
                }
                async unpark(g, f) {
                    const S = this.convertParkContext(g);
                    return this.logger.info(`[${f}] [UnparkCall] start -  context ${g} parkType ${S}`), this._pendingUnparkPromise = this._callOperationHandler.waitForOperation("UnparkCall"), this.signalingSession.unparkAsync(S, f).catch((g)=>{
                        this.logger.info(`[${f}] [UnparkCall] error in unparkAsync (synchronous error) : ${getPIISafeObject(g)}. Unhold promise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("UnparkCall", {
                            error: getPIISafeObject(g)
                        }, f);
                    }), this._pendingUnparkPromise;
                }
                getServerHoldLocation() {
                    return this._pendingParkPromise.then(()=>(this.logger.info(`getServerHoldLocation ${this.serverHoldLocation}`), this.serverHoldLocation));
                }
                getParkAdditionalContextJson() {
                    return this._pendingParkPromise.then(()=>(this.logger.info(`getParkAdditionalContextJson ${this.parkAdditionalContextJson}`), this.parkAdditionalContextJson));
                }
                getJoinBlob() {
                    return Promise.resolve(JSON.stringify({
                        conversationUrl: this.signalingSession.getConversationUrl(),
                        conversationId: this.callId
                    }));
                }
                getTechnicalInformationJson() {
                    return Promise.resolve(JSON.stringify(this.mediaSession.getCallTechnicalInfo()));
                }
                isOneToOneCall(g = !1) {
                    if (g) {
                        const g = (this.state, [
                            0,
                            1
                        ]);
                        return 1 === this.callType && g.includes(this.participants.length);
                    }
                    return 1 === this.callType && 1 === this.participants.length;
                }
                setMuteOnHold(g, f) {
                    this.mediaSession.muteHold(g, f), g || (this.computeCallState(f), this.isMuteOnHold = !1), this.finishCallHoldResume();
                }
                finishCallHoldResume(g) {
                    var _this_callHoldResumeDeferred, _this_callHoldResumeDeferred1;
                    g ? (_this_callHoldResumeDeferred = this.callHoldResumeDeferred) === null || _this_callHoldResumeDeferred === void 0 ? void 0 : _this_callHoldResumeDeferred.reject(g) : (_this_callHoldResumeDeferred1 = this.callHoldResumeDeferred) === null || _this_callHoldResumeDeferred1 === void 0 ? void 0 : _this_callHoldResumeDeferred1.resolve(), this.isHoldInProgress = !1, this.callHoldResumeDeferred = null;
                }
                computeCallState(g) {
                    let f = 3;
                    this._callInLobby ? f = 10 : this.signalingSession.participantManager.localParticipant.isStaging && (f = 13), this.logger.info(`[${g}][computeCallState] the call state will be set to ${f}`), this.setCallState(f, g);
                }
                async prepareModalitiesForResume(g) {
                    this.mediaStateConfigurationHelper.isSending(1) && await this.turnOnLocalVideoPreview(g);
                }
                async prepareModalitiesForHold(g) {
                    await this.turnOffLocalVideoPreview(g);
                }
                updateMediaState(g, f) {
                    this.setVideoOn(g.video === this.mediaAgent.constants.MEDIA_STATE.sendReceive || g.video === this.mediaAgent.constants.MEDIA_STATE.send, f), this.setAudioOn(g.audio === this.mediaAgent.constants.MEDIA_STATE.sendReceive || g.audio === this.mediaAgent.constants.MEDIA_STATE.send, f);
                }
                updateScreenSharingState(g, f) {
                    this.setScreenSharingOn(g.sharing === this.mediaAgent.constants.MEDIA_STATE.send, f);
                }
                onSharingStreamStateChanged(g) {
                    const f = generateCauseId();
                    this.logger.info(`[${f}] Sharing stream state moved to ${g}`);
                    const S = {
                        mediaType: 2,
                        mediaDirection: 1,
                        mediaStreamState: _PluginlessCall.streamingStatetoMediaStreamState(g)
                    };
                    this.event("mediaStreamStateChanged").raise(S), this.callStats.localStats.screenShare.streamStateChanged(g), "stopped" === g && (this.canToggleScreenSharing = !0, this.stopScreenSharing(), "screenSharingCall" !== this.conversationType || this.participants.some((g)=>3 === g.state) || this.stop(!0, f));
                }
                async startScreenSharing(g, f, S, v = generateCauseId()) {
                    this.allowScreenSharingControl() && (this.screenSharingControl.isInternalViewerControlEnabled() && this.screenSharingControl.shutdownControlForViewer(), this.screenSharingControl.isInternalSharerControlEnabled() && this.screenSharingControl.initControlForSharer(S));
                    const _ = this.logger.createFnLogger("StartScreenSharing", v);
                    return _.info(`started. negotiationTag is ${S}`), this.canToggleScreenSharing ? this.isScreenSharingOn ? (_.logSuccess("Resolving early because screen sharing is already on"), Promise.resolve()) : (this.screenSharingRenegotiationDeferred && (_.logFailure("called before the renegotiation deferred for the previous one has been closed"), this.screenSharingRenegotiationDeferred.resolve()), this.screenSharingRenegotiationDeferred = new ct, this.callStats.localStats.newSession(2), this.callStats.localStats.screenShare.start(), this.mediaStateConfigurationHelper.isDisabled(2) && _.info("sharing modality was skipped till now. Adding it now"), this.canToggleScreenSharing = !1, this.callStats.localStats.screenShare.event(0), this.getScreenHandle(g).acquire().then(()=>(_.logSuccess("sharing stream acquired"), this.mediaStateConfigurationHelper.enableModality(2), this.allowDataChannel() && this.mediaStateConfigurationHelper.enableModality(3), this._delayedElevationPending && !this._delayedElevationQueued ? this.triggerDelayedReconnectIfNeeded(v) : Promise.resolve())).then(()=>this.updateMediaModalities(void 0, v, S)).then(()=>(_.logSuccess("updateMediaModalities done"), this.callStats.localStats.screenShare.negotiationStateChanged("started"), this.setScreenSharingOn(!0, v), this.canToggleScreenSharing = !0, this.screenSharingRenegotiationDeferred.promise)).then(()=>{
                        this.enableControlInjector(), this.callStats.localStats.screenShare.negotiationStateChanged("completed");
                    }).catch((g)=>{
                        this.callTelemetry.updateOperationData("StartScreenSharing", {
                            error: getPIISafeObject(g)
                        }, v), this.setScreenSharingOn(!1, v), this.mediaStateConfigurationHelper.removeModality(2), this.canToggleScreenSharing = !0, this.disposeSharingScreenHandle();
                        const f = g.error;
                        throw f && f.code === Li.GlareError ? (this.callStats.localStats.screenShare.negotiationStateChanged("rejected", "glare"), _.logFailure("starting screen sharing failure with reason glare")) : "ScreenSharingStopped" === g.reason ? (this.callStats.localStats.screenShare.negotiationStateChanged("rejected", "sharingStopped"), _.logFailure("expected starting screen sharing failure with reason stopped")) : (this.callStats.localStats.screenShare.negotiationStateChanged("rejected", "other"), _.logFailure(g)), g;
                    })) : Promise.reject(new Error("cannot start screen sharing"));
                }
                async stopScreenSharing(g, f, S = generateCauseId()) {
                    const v = this.logger.createFnLogger("StopScreenSharing", S);
                    if (v.info(`started. negotiationTag is ${f}`), !this.canToggleScreenSharing) throw v.logFailure("cannot stop screen sharing"), new Error("cannot stop screen sharing");
                    if (this.isScreenSharingOn || this._callOperationHandler.hasPendingOperation("StartScreenSharing")) {
                        this.screenSharingRenegotiationDeferred && (this.screenSharingRenegotiationDeferred.reject({
                            reason: "ScreenSharingStopped"
                        }), this.screenSharingRenegotiationDeferred = null), this.mediaStateConfigurationHelper.removeModality(2), this.canToggleScreenSharing = !1, this.allowScreenSharingControl() && this.screenSharingControl.shutdownControlForSharer(), await this.updateMediaModalities(void 0, S, f), this.canToggleScreenSharing = !0, this.callStats.localStats.screenShare.stop(), this.disposeSharingScreenHandle(), this.mediaAgent.getDeviceManager().shareSystemSound(!1), this.mediaAgent.getDeviceManager().setAudioSharingRequested(!1);
                        try {
                            this.setScreenSharingOn(!1, S);
                        } catch (g) {
                            throw v.logFailure(g), this.callTelemetry.updateOperationData("StopScreenSharing", {
                                error: getPIISafeObject(g)
                            }, S), g;
                        }
                    } else v.logFailure("screensharing is not on, ignore this operation");
                }
                async startDataChannel(g, f = generateCauseId()) {
                    if (!this.allowDataChannel()) throw new Error("startDataChannel is disabled since ECS flag prohibits it");
                    this.mediaStateConfigurationHelper.enableModality(3), await this.updateMediaModalities({}, f);
                }
                async stopDataChannel(g, f = generateCauseId()) {
                    if (!this.allowDataChannel()) throw new Error("stopDataChannel is disabled since ECS flag prohibits it");
                    this.mediaStateConfigurationHelper.removeModality(3), await this.updateMediaModalities({}, f);
                }
                allowDataChannel() {
                    return this.mediaSession ? !!this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled && (this.isOneToOnePSTNCall() ? this.mediaSession.getSessionConfig().config.enableDataChannelPstn : this.mediaSession.getSessionConfig().config.enableDataChannel) : (this.logger.warn("datachannel not allowed as there is no mediaSession"), !1);
                }
                isInitialSignalingDSHSubscriptionEnabled() {
                    var _this_mediaSession_getSessionConfig, _this_mediaSession;
                    const g = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getSessionConfig = _this_mediaSession.getSessionConfig()) === null || _this_mediaSession_getSessionConfig === void 0 ? void 0 : _this_mediaSession_getSessionConfig.config;
                    return g ? !this.allowDataChannel() || g.enableInitialSignalingDSHSubscription : (this.logger.warn("Initial signaling dsh subscription is enabled as there is no mediaSession, sessionConfig or sessionConfig.config"), !0);
                }
                allowScreenSharingControl() {
                    var _this_screenSharingControl;
                    return ((_this_screenSharingControl = this.screenSharingControl) === null || _this_screenSharingControl === void 0 ? void 0 : _this_screenSharingControl.isScreenSharingControlEnabled()) && this.allowDataChannel();
                }
                updateSignalingDSHMessageSubscription(g) {
                    var _this_mediaSession_getDiagnostics, _this_mediaSession;
                    this.signalingSession.updateDominantSpeakerHistoryMessageSubscription(g), g && ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getDiagnostics = _this_mediaSession.getDiagnostics) === null || _this_mediaSession_getDiagnostics === void 0 ? void 0 : _this_mediaSession_getDiagnostics.call(_this_mediaSession).dshDiagnostics.setCurrentActiveStrategy("signaling"));
                }
                async sendUserEvents(g, f) {
                    return this.dataChannel.sendUserEvents(g, f);
                }
                async shareSystemSound(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("ShareSystemSounds", f, `shareSystemSound=${g}`);
                    if (!(!!this.mediaSession && this.mediaSession.getSessionConfig().mediaConfig.simulcastSessionEnabled && this.mediaSession.getSessionConfig().config.enableAudioSharing && this.mediaSession.getSessionConfig().config.requireUserActionForAudioSharing)) return S.error("shareSystemSound not allowed"), Promise.reject(60);
                    try {
                        return void this.mediaAgent.getDeviceManager().shareSystemSound(g);
                    } catch (e) {
                        return S.error("shareSystemSound failed with device error"), Promise.reject(58);
                    }
                }
                async mute(g = generateGuid()) {
                    return this.isMuted ? Promise.reject(getRejectTransactionEnd("TransactionDisallowed")) : this.muteUnmute(!0, g);
                }
                async unmute(g = generateGuid()) {
                    return this._callOperationHandler.hasPendingOperation("_PromotionToRealtime") && await this._callOperationHandler.waitForOperation("_PromotionToRealtime"), this.muteUnmute(!1, g);
                }
                async muteSpeaker(g = generateCauseId()) {
                    return this.muteUnmuteSpeaker(!0, g);
                }
                async unmuteSpeaker(g = generateCauseId()) {
                    return this.muteUnmuteSpeaker(!1, g);
                }
                async getSpeakerVolume(g = generateCauseId()) {
                    return await this.mediaSession.getSpeakerVolume(g);
                }
                async setSpeakerVolume(g, f = generateCauseId()) {
                    return this.mediaSession.setSpeakerVolume(g, f);
                }
                async muteParticipants(g, f, S = generateGuid()) {
                    const v = this.logger.createFnLogger("MuteParticipants", S, `muteScope=${g}`);
                    v.info(`callParticipants count=${f.length}`);
                    const _ = _PluginlessCall.convertMuteScope(g);
                    if (void 0 === _) return v.logFailure(`Unrecognized ${g}`), Promise.reject(new Error("Unrecognized muteScope"));
                    if (callStateIsAnyOf(this.state, [
                        11,
                        12
                    ])) return v.logFailure("Can not mute/unmute during preheat call"), Promise.reject(60);
                    const C = [];
                    return f.forEach((g)=>{
                        C.push(g.id);
                    }), this.signalingSession.muteAsync(_, C, S).then((g)=>this.handleParticipantsMutedUpdated(g, S)).catch((g)=>(this.callTelemetry.updateOperationData("MuteParticipants", {
                            error: getPIISafeObject(g)
                        }, S), v.logFailure(g), (g === null || g === void 0 ? void 0 : g.endCode) ? Promise.reject(g.endCode) : Promise.reject(g)));
                }
                async startAudio(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("StartAudio", f);
                    if (this.receiveOnlyAudioOnCallStart = !1, 3 !== this.state) return S.logFailure("Cannot startAudio when call is not connected"), Promise.reject(60);
                    if (this.mediaStateConfigurationHelper.enableModality(0), this.callUsesMixer && this.mediaStateConfigurationHelper.removeModality(1), this.mediaStateConfigurationHelper.isSending(1)) try {
                        await this.turnOnLocalVideoPreview(f);
                    } catch (g) {
                        return S.logFailure(g), Promise.reject(25);
                    }
                    const v = await this.startStopAudio(!0, f);
                    return await this.signalingSession.recordTelemetryForStartAudio(v), {
                        code: v
                    };
                }
                async stopAudio(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("StopAudio", f);
                    if (3 !== this.state) return S.logFailure("Cannot stopAudio when call is not connected"), Promise.reject(60);
                    this.mediaStateConfigurationHelper.removeModality(0);
                    const v = await this.startStopAudio(!1, f);
                    return await this.turnOffLocalVideoPreview(f), await this.signalingSession.recordTelemetryForStopAudio(v), {
                        code: v
                    };
                }
                assimilate(g, f, S, v = generateCauseId()) {
                    return Promise.reject(new Error("Not implemented"));
                }
                async merge(g, f, S = generateCauseId()) {
                    const v = this.logger.createFnLogger("MergeCall", S);
                    v.error(`merge callId ${g.callId} callMergeOptions ${JSON.stringify(f)}`);
                    const _ = this.canMerge(g, S);
                    if (!_) return v.info(`Error. ${getPrintableObject(_)}`), Promise.reject(getRejectTransactionEnd("TransactionDisallowed"));
                    const C = [];
                    g.participants.forEach((g)=>{
                        C.push(this._callOperationHandler.createPendingOperation("MergeCall", g.id, S));
                    });
                    return (await this.mergeCallByAddParticipantWithReplaces(f, g.participants, g, 1, "MergeCall", S, C, void 0))[0];
                }
                async mergeParticipants(g, f, S, v, _) {
                    const C = this.logger.createFnLogger("MergeParticipants", v), E = [];
                    if (!g) return Promise.reject(getRejectTransactionEnd("Invalid callToMerge"));
                    if (0 === f.length) return Promise.reject(getRejectTransactionEnd("Invalid participantIds"));
                    const T = [];
                    for (const S of f){
                        let f = findParticipantUsingParticipantLegId(g, S);
                        if (!f && findSelfEndpointDetailUsingParticipantLegId(g, S) && (C.info("found self endpoint, use localSignalingParticipant"), f = this.localSignalingParticipant), f) {
                            const g = generateGuid(), _ = {
                                id: f.id,
                                participantId: g,
                                replacementParticipantId: S,
                                nonMaskedId: f.nonMaskedId
                            };
                            E.push(_), T.push(this._callOperationHandler.createPendingOperation("MergeParticipant", g, v));
                        } else {
                            const g = {
                                code: 406,
                                subCode: 5201,
                                phrase: `participantLegId ${S} is invalid!`
                            };
                            T.push(Promise.reject(getRejectTransactionEnd(g)));
                        }
                    }
                    return this.mergeCallByAddParticipantWithReplaces(S, E, g, 3, "MergeParticipant", v, T, _);
                }
                async mergeWithPickupCode(g, f, S = generateCauseId()) {
                    const v = this.logger.createFnLogger("MergeWithPickupCode", S);
                    if (v.info(`mergeWithPickupCode: pickup code: ${g}, groupId: ${scrubMriOrOmit(f.groupId)}, threadId: ${getLoggableThreadId(f.threadId)} messageId: ${f.messageId}`), !g || isNaN(Number(g))) return v.info("mergeWithPickupCode: pickup code cannot be empty"), Promise.reject(getRejectTransactionEnd("mergeWithPickupCode: pickup code cannot be empty"));
                    const _ = {
                        additionalData: f.additionalData,
                        groupId: f.groupId,
                        threadId: f.threadId,
                        messageId: f.messageId,
                        replacementType: 2,
                        pickupCode: Number(g)
                    }, C = {
                        id: `4:${mi.SERVER_HOLD}`
                    };
                    return Promise.resolve().then(()=>Promise.all(this.signalingSession.addParticipantsAsync([
                            C
                        ], _, S))).then((g)=>(g.length > 0 && this.signalingNotifications.onParticipantJoined(g[0], S), Promise.resolve({
                            code: 0,
                            subCode: 0,
                            phrase: "TransactionComplete"
                        }))).catch((g)=>{
                        v.logFailure(`Participant was not added to call, error=${getPrintableObject(g)}`);
                        const f = this._handleParticipantOperationFailure("MergeWithPickupCode", g, S, null, !0).reason;
                        return Promise.reject(g ? g.endCode : f || 0);
                    });
                }
                async setMaxVideoChannels(g) {
                    return Promise.reject(60);
                }
                async setMaxVbssChannels(g) {
                    return Promise.reject(60);
                }
                async stop(g = !1, f = generateCauseId(), S, v) {
                    var _this_mediaSession_getSessionConfig, _this_mediaSession, _this_mediaSession_getSessionConfig1, _this_mediaSession1;
                    const _ = this.logger.createFnLogger("StopAudio", f);
                    if (6 === this.state) return _.logFailure("Trying to stop a call which is already Disconnecting"), Promise.reject(new Error("cannot stop call in Disconnecting state"));
                    if (7 === this.state) return _.logFailure("Trying to stop a call which is already Disconnected"), Promise.reject(new Error("cannot stop call in Disconnected state"));
                    if (this.disposedPromise) return _.logFailure("Call already ended"), Promise.reject("Call already ended");
                    let C = 0;
                    1 === this.state && (C = 10);
                    const E = v ? {
                        clientReasonSubCode: v.clientSubCode,
                        clientReasonPhrase: v.clientPhrase
                    } : {};
                    (v === null || v === void 0 ? void 0 : v.clientSubCode) === Ii.SUB_CODE.VDI_DISCONNECTED && ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getSessionConfig = _this_mediaSession.getSessionConfig()) === null || _this_mediaSession_getSessionConfig === void 0 ? void 0 : _this_mediaSession_getSessionConfig.config.vdiDisconnectedTracking.enabled) && ((_this_mediaSession1 = this.mediaSession) === null || _this_mediaSession1 === void 0 ? void 0 : (_this_mediaSession_getSessionConfig1 = _this_mediaSession1.getSessionConfig()) === null || _this_mediaSession_getSessionConfig1 === void 0 ? void 0 : _this_mediaSession_getSessionConfig1.config.vdiDisconnectedTracking.clientPhrases.includes(v === null || v === void 0 ? void 0 : v.clientPhrase)) && (E.code = Ii.CODE.MEDIA_ERROR, E.subCode = Ii.SUB_CODE.VDI_DISCONNECTED, E.phrase = ji.CallEndReasonVDIdisconnect, E.resultCategories = [
                        "UnexpectedClientError"
                    ], C = 4);
                    const T = {
                        terminatedReason: C,
                        forEveryone: g,
                        causeId: f,
                        ...S,
                        rejectReason: E
                    };
                    return this.stopInternal(T);
                }
                publishState(g, f) {
                    const S = getPluginlessStateType(g.type), v = this.getPluginlessPublishLevel(g.level), _ = g.participantIds && g.participantIds.length > 0 ? "specified" : void 0;
                    return this.callTelemetry.setOperationVariant("PublishState", "specified" === _ ? `${S}Specified` : `${S}None`, f), this.signalingSession.publishStateAsync(S, v, f, g.content, _, g.participantIds);
                }
                publishStatesForEveryone(g, f) {
                    const S = getPluginlessStateType(g.type), v = this.getPluginlessPublishLevel(g.level), _ = "all";
                    return this.callTelemetry.setOperationVariant("PublishState", `${S}All`), this.signalingSession.publishStateAsync(S, v, f, g.content, _);
                }
                removeState(g, f) {
                    return this.signalingSession.removeStateAsync(f, "specified", void 0, g.stateIds).then((g)=>Promise.resolve());
                }
                removeStatesForEveryone(g, f) {
                    const S = getPluginlessStateType(g.type);
                    return this.signalingSession.removeStateAsync(f, "all", S, void 0).then((g)=>Promise.resolve());
                }
                updateMeetingSettings(g, f) {
                    return this.signalingSession.updateMeetingSettingsAsync({
                        allowRaiseHands: g.allowRaiseHands,
                        attendeeRestrictions: g.attendeeRestrictions,
                        lockMeeting: g.lockMeeting,
                        breakoutRoomsEnabled: g.breakoutRoomsEnabled,
                        allowPresentersToManageBreakoutRooms: g.allowPresentersToManageBreakoutRooms,
                        disableMdpClientAudioRecording: g.disableMdpClientAudioRecording,
                        refreshSettings: g.refreshSettings,
                        aiInterpretationEnabled: g.aiInterpretationEnabled,
                        groupCopilotDetails: g.groupCopilotDetails
                    }, f);
                }
                updateMeetingGroups(g, f) {
                    this.logger.info(`[UpdateMeetingGroups][${g}] options ${safeJsonStringify(f)}`);
                    const S = this._callOperationHandler.waitForOperation("UpdateMeetingGroups", g), v = {
                        fromGroup: f.fromGroup,
                        toGroup: f.toGroup,
                        scope: mapParticipantScope(f.scope)
                    };
                    return f.participants && (v.participants = createParticipantListFromMriMap(f.participants)), this.signalingSession.updateMeetingsGroupsAsync(g, v).catch((f)=>{
                        this.logger.info(`[${g}] [UpdateMeetingGroups] error in updateMeetingGroups (synchronous error) : ${getPIISafeObject(f)}. updateMeetingGroupsPromise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("UpdateMeetingGroups", {
                            error: getPIISafeObject(f)
                        }, g);
                    }), S;
                }
                updateMeetingLiveState(g, f) {
                    return this.logger.info(`[UpdateMeetingLiveState][${g}] options ${safeJsonStringify(f)}`), this.signalingSession.updateMeetingLiveStateAsync(g, f).catch((f)=>{
                        this.logger.info(`[${g}] [UpdateMeetingLiveState] error in updateMeetingLiveState (synchronous error) : ${getPIISafeObject(f)}. promise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("UpdateMeetingLiveState", {
                            error: getPIISafeObject(f)
                        }, g);
                    }), this._callOperationHandler.waitForOperation("UpdateMeetingLiveState", g);
                }
                updateMeetingStates(g, f = generateCauseId()) {
                    var S;
                    this.logger.info(`[UpdateMeetingStates][${f}]`);
                    const v = {}, _ = [];
                    g.operationId = g.operationId || f;
                    for (const C of Object.keys(g.meetingStates)){
                        const E = g.operationId + "_" + C;
                        _.push(E);
                        const T = this._callOperationHandler.createPendingOperation("UpdateMeetingStates", E, f);
                        var _v_;
                        (_v_ = v[S = g.operationId]) !== null && _v_ !== void 0 ? _v_ : v[S] = {}, v[g.operationId][C] = T, this.callTelemetry.recordOperation("UpdateMeetingStates", f, E);
                    }
                    return Promise.resolve().then(()=>this.signalingSession.updateMeetingStatesAsync(f, g)).then((g)=>{
                        for (const S of _)this.callTelemetry.updateOperationData("UpdateMeetingStates", {
                            data: getPIISafeObject(g)
                        }, f, S);
                    }).catch((g)=>{
                        for (const S of _)this.callTelemetry.updateOperationData("UpdateMeetingStates", {
                            error: getPIISafeObject(g)
                        }, f, S);
                        this.logger.logFailure(g);
                    }).then(()=>v);
                }
                async updateParticipantInterpretationState(g, f) {
                    if (this.logger.info(`[UpdateParticipantInterpretationState][${g}] options ${safeJsonStringify(f)}`), 0 === f.length) return Promise.reject(getRejectTransactionEnd("Invalid UpdateParticipantInterpretationState options"));
                    const S = this.signalingSession.updateParticipantInterpretationStateAsync(g, f), v = [];
                    f.forEach((f)=>{
                        v.push(this._callOperationHandler.createPendingOperation("UpdateParticipantInterpretationState", f.id, g));
                    });
                    for(let v = 0; v < S.length; v++){
                        const _ = S[v], C = f[v];
                        _.then(()=>{
                            this.logger.logSuccess(`updateParticipantInterpretationState succeeded for [id=${scrubMriOrOmit(C.id)}]`);
                            const f = {
                                code: 0,
                                subCode: 0,
                                phrase: ""
                            };
                            this.callTelemetry.recordOperationSuccess("UpdateParticipantInterpretationState", f, C.id, g), this._callOperationHandler.maybeResolveOperation("UpdateParticipantInterpretationState", f, C.id, g);
                        }).catch((f)=>{
                            this.logger.error(`[${g}] [UpdateParticipantInterpretationState] error in updateParticipantInterpretationState (synchronous error) : ${getPIISafeObject(f)}. updateParticipantInterpretationStatePromise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("UpdateParticipantInterpretationState", {
                                error: getPIISafeObject(f)
                            }, g);
                            const S = this._handleParticipantOperationFailure("UpdateParticipantInterpretationState", f, g, C.id).reason, v = (f === null || f === void 0 ? void 0 : f.endCode) || S || 0;
                            this._callOperationHandler.maybeRejectOperation("UpdateParticipantInterpretationState", v, C.id, g);
                        });
                    }
                    return Promise.resolve(v);
                }
                async updateParticipantsProperties(g, f) {
                    const S = this.logger.createFnLogger("UpdateParticipantsProperties", f);
                    if (S.info(`options ${scrubMriOrOmit(safeJsonStringify(g))}`), !g) return Promise.reject(getRejectTransactionEnd("Invalid input: UpdateParticipantsPropertiesContext"));
                    const v = {}, _ = g.scope, C = g.operationId, E = new Set;
                    if ("self" === _) {
                        const S = this.signalingSession.participantManager.localParticipant.id;
                        for(const _ in g.propertyBag){
                            const g = mapMriAndPropertyNameToResolveString(S, C, _), T = this.createUpdateParticipantPromise(g, f);
                            v[g] = {
                                [S]: T
                            }, E.add(g), this.callTelemetry.recordOperation("UpdateParticipantsProperties", f, scrubMriOrOmit(g));
                        }
                    } else {
                        if ("specified" !== _ || !this._isUpdatePropertiesSpecifiedAllowedByEcs) return Promise.reject("This scope is not supported.");
                        {
                            const S = g.participants;
                            for (const g of S){
                                const S = g.id;
                                for(const _ in g.propertyBag){
                                    const g = mapMriAndPropertyNameToResolveString(S, C, _), T = this.createUpdateParticipantPromise(g, f);
                                    v[g] = {
                                        [S]: T
                                    }, E.add(g), this.callTelemetry.recordOperation("UpdateParticipantsProperties", f, scrubMriOrOmit(g));
                                }
                            }
                        }
                    }
                    return S.info(`promises created: ${scrubMriOrOmit(safeJsonStringify(v))}`), this.signalingSession.updateParticipantsPropertiesAsync(g, E, C, f).catch((g)=>{
                        const _ = getPrintableObject(g);
                        S.info(`[failed][reason=${_}]`);
                        const C = {
                            ...g
                        };
                        this.callTelemetry.updateOperationData("UpdateParticipantsProperties", {
                            error: getPIISafeObject(_)
                        }, f);
                        for (const g of Object.keys(v))this._callOperationHandler.maybeRejectOperation("UpdateParticipantsProperties", C, g, f);
                    }), Promise.resolve().then(()=>v);
                }
                joinMeetingGroup(g, f) {
                    this.logger.info(`[JoinMeetingGroup][${g}] options ${safeJsonStringify(f)}`);
                    const S = this._callOperationHandler.waitForOperation("JoinMeetingGroup", g), v = {
                        ..."meetingGroupId" in f && {
                            meetingGroupId: f.meetingGroupId
                        },
                        ..."meetingGroupLabel" in f && {
                            meetingGroupLabel: f.meetingGroupLabel
                        },
                        ...f.groupPreferences && {
                            groupPreferences: f.groupPreferences
                        }
                    };
                    return this.signalingSession.joinMeetingGroupAsync(g, v).catch((f)=>{
                        const S = getPIISafeObject(f);
                        this.logger.info(`[${g}] [JoinMeetingGroup] error in joinMeetingGroup (synchronous error) : ${S}. joinMeetingGroupPromise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("JoinMeetingGroup", {
                            error: S
                        }, g);
                    }), S;
                }
                leaveMeetingGroup(g, f) {
                    this.logger.info(`[LeaveMeetingGroup][${g}] options ${safeJsonStringify(f)}`);
                    const S = this._callOperationHandler.waitForOperation("LeaveMeetingGroup", g), v = {
                        meetingGroupId: f.meetingGroupId
                    };
                    return this.signalingSession.leaveMeetingGroupAsync(g, v).catch((f)=>{
                        const S = getPIISafeObject(f);
                        this.logger.info(`[${g}] [LeaveMeetingGroup] error in leaveMeetingGroup (synchronous error) : ${S}. leaveMeetingGroupPromise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("LeaveMeetingGroup", {
                            error: S
                        }, g);
                    }), S;
                }
                sendMessages(g, f) {
                    var S, v;
                    this.logger.info(`[SendMessages][${g}]`);
                    const _ = {};
                    for (const C of f)if (0 === C.scope) {
                        const f = this._callOperationHandler.createPendingOperation("SendMessages", C.operationId, g);
                        _[C.operationId] = {
                            all: f
                        }, this.callTelemetry.recordOperation("SendMessages", g, C.operationId);
                    } else if (1 === C.scope) {
                        for(const f in C.to)if ("participant" === C.to[f].level) {
                            const v = mapMriToResolveString(f, C.operationId), E = this._callOperationHandler.createPendingOperation("SendMessages", v, g);
                            var __;
                            (__ = _[S = C.operationId]) !== null && __ !== void 0 ? __ : _[S] = {}, _[C.operationId][f] = E, this.callTelemetry.recordOperation("SendMessages", g, v);
                        } else if ("endpoint" === C.to[f].level) for(const S in C.to[f].participantLegIdMap){
                            const f = mapLegIdToResolveString(S, C.operationId), E = this._callOperationHandler.createPendingOperation("SendMessages", f, g);
                            var __1;
                            (__1 = _[v = C.operationId]) !== null && __1 !== void 0 ? __1 : _[v] = {}, _[C.operationId][S] = E, this.callTelemetry.recordOperation("SendMessages", g, f);
                        }
                    }
                    return this.signalingSession.sendProxiedMessageAsync(g, f).then((g)=>{
                        for (const f of g)f.then((g)=>{
                            this._callOperationHandler.maybeResolveOperation("SendMessages", g.transactionEnd, g.resolveString, g.causeId);
                        }).catch((g)=>{
                            this._callOperationHandler.maybeRejectOperation("SendMessages", g.transactionEnd, g.resolveString, g.causeId);
                        });
                        return _;
                    });
                }
                async updateMonitorSession(g, f = generateCauseId()) {
                    this.logger.info(`updateMonitorSession: monitorActionType: ${g.monitorActionType}, monitorData: ${g.monitorData}`);
                    const S = mapMonitorActionType(g.monitorActionType);
                    if (void 0 === S) {
                        const f = {
                            code: Ii.CODE.CLIENT_ERROR_CODE,
                            subCode: Ii.SUB_CODE.INVALID_DATA_TYPE,
                            phrase: `Invalid monitor action type ${g.monitorActionType}`
                        };
                        return Promise.reject(f);
                    }
                    const v = {
                        monitorActionType: S,
                        monitorData: g.monitorData
                    }, _ = this._callOperationHandler.waitForOperation("UpdateMonitorSession", "", f);
                    return this.signalingSession.updateMonitorSessionAsync(v, f).catch((g)=>{
                        const S = getPIISafeObject(g);
                        this.logger.info(`[${f}] [UpdateMonitorSession] error in updateMonitorSession (synchronous error): ${JSON.stringify(S)}. updateMonitorSessionPromise will be rejected by signaling callback`), this.callTelemetry.updateOperationData("UpdateMonitorSession", {
                            error: S
                        }, f);
                    }), _;
                }
                switchInterpreterGroup(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                setLiveInterpretationAttributes(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                async updateMeetingRoles(g, f, S = generateCauseId()) {
                    return 3 === this.state && this.signalingSession.hasOwnProperty("updateMeetingRolesAsync") ? this.signalingSession.updateMeetingRolesAsync(g, f, S) : Promise.reject({
                        code: Ii.CODE.CLIENT_ERROR_CODE,
                        subCode: Ii.SUB_CODE.ACTION_NOT_ALLOWED,
                        phrase: "ActionNotAllowed"
                    });
                }
                stopInternal(g) {
                    const f = this.logger.createFnLogger("stopInternal", g.causeId), S = g.terminatedReason || 0;
                    let v = g.rejectReason && (g.rejectReason.code || g.rejectReason.subCode) ? g.rejectReason : this.getRejectionInfoFromTerminatedReason(S);
                    if (g.rejectReason && (v || (v = {}), v.clientReasonSubCode = g.rejectReason.clientReasonSubCode, v.clientReasonPhrase = g.rejectReason.clientReasonPhrase), f.info(`started, terminatedReason=${S}, rejectReason=${safeJsonStringify(v)}`), 6 === this.state) return f.logFailure("Trying to stop a call which is already Disconnecting"), this.disconnectingPromise;
                    if (7 === this.state) return f.logFailure("Trying to stop a call which is already Disconnected"), this.disconnectingPromise;
                    this.setCallState(6, g.causeId, S);
                    const _ = {
                        causeId: g.causeId,
                        forEveryone: g.forEveryone,
                        scope: this.mapEndpointScope(g.scope),
                        redirectOptions: g.redirectOptions && convertRedirectOptions(g.redirectOptions)
                    };
                    return 1 === g.scope && (v.code = Ii.CODE.SUCCESS, v.subCode = Ii.SUB_CODE.ENDED_BY_REMOTE_ENDPOINT, v.phrase = ji.EndedByRemoteEndpoint), this.disconnectingPromise = Promise.all([
                        this.cleanUpMedia(g.causeId, v).then(()=>{
                            this.callTelemetry.recordOperationSuccess("_MediaCleanUp");
                        }).catch((S)=>{
                            throw f.logFailure(`cleanUpMedia failed with reason=${getPrintableObject(S)}`), this.callTelemetry.recordOperationFailure("_MediaCleanUp", {
                                error: getPIISafeObject(S)
                            }, g.causeId), S;
                        }),
                        this.signalingSession.endAsync(v, _).catch((g)=>{
                            throw f.logFailure(`endAsync failed with reason=${getPrintableObject(g)}`), g;
                        })
                    ]).catch((S)=>{
                        throw f.logFailure(S), this.cleanUp(g.causeId, v), S;
                    }).then(()=>this.cleanUp(g.causeId, v)).catch((f)=>{
                        throw this.callTelemetry.updateOperationData("StopCall", {
                            error: getPIISafeObject(f)
                        }, g.causeId), this.setCallState(7, g.causeId, S), f;
                    }), this.disconnectingPromise;
                }
                async cleanUp(g, f) {
                    return this.logger.info(`[${g}][cleanup]start`), this.disposedPromise || (this.disposedPromise = this.cleanUpFinalize(g, f), this._getCallEndOperation().catch(noop).then(()=>{
                        const f = {
                            code: Ii.CODE.CLIENT_ERROR_CODE,
                            subCode: Ii.SUB_CODE.ABANDONED
                        };
                        this._callOperationHandler.rejectPendingOperations(61, g, f), this._participantOperationHandler.rejectPendingOperations(47, g, f);
                    })), this.disposedPromise;
                }
                async cleanUpMedia(g, f) {
                    return this.mediaDisposedPromise || (this.callTelemetry.recordOperation("_MediaCleanUp", g), this.mediaDisposedPromise = (async ()=>{
                        var _this_callDeviceManager, _this_participants, _this_screenSharingRenegotiationDeferred, _S_getSessionConfig_config, _S_getSessionConfig;
                        (_this_callDeviceManager = this.callDeviceManager) === null || _this_callDeviceManager === void 0 ? void 0 : _this_callDeviceManager.dispose(), this.callDeviceManager = null, this.turnOffLocalVideoPreview(g), this.localVideoContainer = null, this.disposeContentSharingSessions(), this.disposeSharingScreenHandle();
                        const S = this.mediaSession;
                        if (this.reportMediaStats = !!S, !S) return;
                        this.unmixedAudioProvider.dispose(), this.dataChannel.dispose(), this.screenSharingControl.dispose(g), this.remoteUFDHandler.dispose(), this.mediaSession = null, this.streamManager.setMediaSession(null, g), (_this_participants = this.participants) === null || _this_participants === void 0 ? void 0 : _this_participants.forEach((f)=>{
                            f.setMediaSession(null, g);
                        });
                        const v = S.terminate(g, f);
                        this.isVideoOn = !1, this.setMediaStream(this.isVideoOn, !1, 1), this.setMediaStream(!1, !1, 2), this.setMediaStream(!1, !1, 0), this.isScreenSharingOn = !1, (_this_screenSharingRenegotiationDeferred = this.screenSharingRenegotiationDeferred) === null || _this_screenSharingRenegotiationDeferred === void 0 ? void 0 : _this_screenSharingRenegotiationDeferred.reject(f), this.screenSharingRenegotiationDeferred = null, this.mediaStateConfigurationHelper.removeModality(1), this.mediaStateConfigurationHelper.removeModality(0), this.mediaStateConfigurationHelper.removeModality(3), this.mediaStateConfigurationHelper.removeModality(2), (S === null || S === void 0 ? void 0 : (_S_getSessionConfig = S.getSessionConfig()) === null || _S_getSessionConfig === void 0 ? void 0 : (_S_getSessionConfig_config = _S_getSessionConfig.config) === null || _S_getSessionConfig_config === void 0 ? void 0 : _S_getSessionConfig_config.useOneDsLogger) && S.getSessionConfig().config.addTelemetryReportingCallback && window.removeEventListener("beforeunload", this.beforeUnloadTelemetrySender);
                        try {
                            await v;
                        } finally{
                            var _S_getMediaControlPlaneInstance;
                            await this.collectCallStats(S), this.callStats.appendMediaControlPlaneInfo(JSON.stringify((_S_getMediaControlPlaneInstance = S.getMediaControlPlaneInstance()) === null || _S_getMediaControlPlaneInstance === void 0 ? void 0 : _S_getMediaControlPlaneInstance.getTelemetryReport()));
                        }
                    })()), this.mediaDisposedPromise;
                }
                async cleanUpFinalize(g, f) {
                    var _this_mediaSession;
                    try {
                        await this.cleanUpMedia(g, f);
                    } catch (f) {
                        this.logger.info(`[${g}][cleanUpMedia] failure: ${getPrintableObject(f)}`), this.callTelemetry.recordOperationFailure("_MediaCleanUp", {
                            error: getPIISafeObject(f)
                        }, g);
                    }
                    this.callTelemetry.recordOperationSuccess("_MediaCleanUp");
                    const S = this.reportCallEndStats(this.reportMediaStats);
                    ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.waitReportStatsAtCallStop) && await S;
                }
                async createContentSharingSession(g, f, S, v, _ = generateCauseId()) {
                    if (this.signalingSession.signalingAgentConfig.checkAttendeeRoleInCreateContentSharing) {
                        if ("attendee" === (this.advancedMeetingRole || this.meetingRole)) {
                            const g = {
                                terminatedReason: 8,
                                terminatedReasonCode: 403,
                                terminatedReasonSubCode: 0,
                                errorMessage: "Failed due to insufficient permissions"
                            };
                            return Promise.reject(g);
                        }
                    }
                    const C = new ua(this.callTelemetry, this.logger, this.signalingSession, g, f, v, S);
                    return this.contentSharingSessions.push(C), C.changed(()=>this.removeContentSessionIfEnded(C)), this.event("contentSharingChanged").raise(), Promise.resolve(C);
                }
                stopWithBeacon(g = generateCauseId()) {
                    var _this_mediaSession_getSessionConfig_config, _this_mediaSession_getSessionConfig, _this_mediaSession, _this_mediaSession_getSessionConfig_config1, _this_mediaSession_getSessionConfig1, _this_mediaSession1;
                    if (6 === this.state || 7 === this.state) return !0;
                    ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getSessionConfig = _this_mediaSession.getSessionConfig()) === null || _this_mediaSession_getSessionConfig === void 0 ? void 0 : (_this_mediaSession_getSessionConfig_config = _this_mediaSession_getSessionConfig.config) === null || _this_mediaSession_getSessionConfig_config === void 0 ? void 0 : _this_mediaSession_getSessionConfig_config.enableCallStateChangesOnPageClose) && (this.callEndDiagnosticsInfo = {
                        callControllerCode: Ii.CODE.SUCCESS,
                        callControllerSubCode: Ii.SUB_CODE.BEACON
                    }, this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo), this.setCallState(6, g, 1));
                    const f = this.signalingSession.endWithBeacon(g);
                    return ((_this_mediaSession1 = this.mediaSession) === null || _this_mediaSession1 === void 0 ? void 0 : (_this_mediaSession_getSessionConfig1 = _this_mediaSession1.getSessionConfig()) === null || _this_mediaSession_getSessionConfig1 === void 0 ? void 0 : (_this_mediaSession_getSessionConfig_config1 = _this_mediaSession_getSessionConfig1.config) === null || _this_mediaSession_getSessionConfig_config1 === void 0 ? void 0 : _this_mediaSession_getSessionConfig_config1.enableCallStateChangesOnPageClose) && this.setCallState(7, g, 1), f;
                }
                disposeContentSharingSessions() {
                    this.contentSharingSessions.forEach((g)=>{
                        g.dispose(), this.removeContentSessionIfEnded(g);
                    }), this.event("contentSharingChanged").raise();
                }
                isPreheatedOnly() {
                    return !!(12 === this.state || 2 === this.state && this._callOperationHandler.hasPendingOperation("JoinPreheatedCall") || 9 === this.state && this._callOperationHandler.hasPendingOperation("JoinPreheatedCall"));
                }
                removeContentSessionIfEnded(g) {
                    7 !== g.contentSharingStatus && 8 !== g.contentSharingStatus || (this.logger.info("stopping the content sharing session."), (0, zi.remove)(this.contentSharingSessions, (f)=>f.contentSharingGuid === g.contentSharingGuid).length && this.event("contentSharingChanged").raise());
                }
                getRejectionInfoFromTerminatedReason(g) {
                    switch(g){
                        case 53:
                            return {
                                code: Li.MediaError,
                                subCode: Fi.MediaWhiteListingIssue,
                                phrase: ji.MediaWhiteListingIssue
                            };
                        case 4:
                            return {
                                code: Li.MediaError,
                                subCode: this._wasAudioStreamConnected ? Fi.MediaDropAfterConnect : Fi.MediaDropDuringConnect,
                                phrase: this._wasAudioStreamConnected ? ji.MediaDropAfterConnect : ji.MediaDropDuringConnect
                            };
                        case 47:
                            return {
                                code: Li.MediaError,
                                subCode: Fi.MediaOfferProcessingError,
                                phrase: ji.MediaOfferProcessingError
                            };
                        case 38:
                            return {
                                code: Li.MediaError,
                                subCode: Fi.MediaRenegotiationError,
                                phrase: ji.RetargetNotSupported
                            };
                        case 10:
                            return {
                                code: Li.Reject,
                                subCode: Fi.Success,
                                phrase: ji.CallEndReasonLocalUserInitiated
                            };
                        case 25:
                            return {
                                code: Li.UnknownError,
                                subCode: Fi.MediaUnknownError,
                                phrase: ji.MediaError
                            };
                        case 58:
                            return {
                                code: Li.MediaError,
                                subCode: Fi.MediaPermissionError,
                                phrase: ji.MediaPermissionError
                            };
                        case 7:
                            return {
                                code: Li.UnknownError,
                                subCode: Fi.Success,
                                phrase: ji.Unknown
                            };
                        case 0:
                        case 1:
                            return {
                                code: Li.Success,
                                subCode: Fi.Success,
                                phrase: ji.CallEndReasonLocalUserInitiated
                            };
                        case 75:
                            return {
                                code: Li.CallRedirected,
                                subCode: Fi.CallRedirectedSuccess,
                                phrase: ji.CallEndReasonRedirected,
                                resultCategories: [
                                    "Success"
                                ]
                            };
                        case 77:
                            return {
                                code: Li.Success,
                                subCode: Fi.Suspended,
                                phrase: ji.CallEndReasonSuspended
                            };
                    }
                    return null;
                }
                async acknowledge(g, f, S = generateCauseId()) {
                    const v = this.logger.createFnLogger("Acknowledge", S), _ = Date.now();
                    if (this.setInitialTelemetry("Acknowledge", {
                        callStartTime: _
                    }, "", S), 0 !== this.state && 8 !== this.state) throw new Error(`Trying to acknowledge a call that has already been acted on ${this.state}`);
                    v.info(`isMultiParty=${g.isMultiParty}`), v.info(`fromMixer=${g.fromMixer}`), v.info(`participantId=${g.participantId}`), v.info(`callType=${g.callType}`), this.attachToCallAndGetOffer = new ct, this.setCallType(g.isMultiParty ? 2 : 1, S), this.setCallUsesMixer(!!g.fromMixer, S), this.setCallerMri(stripMriAliases(g.callerId)), this.setDisplayNameSource(g.displayNameSource), this.setTransferorMri(g.transferorId), this.transferorType = g.transferorType, this.transferorDisplayName = g.transferorDisplayName, this.incomingCallType = g.callType, this.consultativeCallId = g.consultativeCallId, this.callQueueInfo = g.callQueueInfo, this.setFromApplicationType(g.fromApplicationType, S), this.callStats.localStats.startCall();
                    const C = createPhaseExecutor(v);
                    try {
                        C.executeSync("ProcessIncomingCallRequest", ()=>this.signalingSession.processIncomingCallRequest(g, f, S)), this.setParticipantId(this.participantId);
                        if (C.executeSync("ResolvePotentialConflict", ()=>this.signalingAgent.resolvePotentialCallConflict(this.signalingSession)) === this.signalingSession) return Promise.reject({
                            code: 7,
                            success: !1
                        });
                        const mediaSetup = async ()=>{
                            C.executeSync("InitializeMediaSession", ()=>this.initializeMediaSession(S)), this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled());
                            const g = this.signalingSession.getInitialMediaOfferFromIncomingCallPayload();
                            this.callStats.setParticipantId(this.participantId), this.onBehalfOfMri = this.signalingSession.onBehalfOf, this.onBehalfOfUserDisplayName = this.signalingSession.onBehalfOfUserDisplayName, this.callQueueContext = this.signalingSession.callQueueContext, this.callQueueSupervisorContent = this.signalingSession.callQueueSupervisorContent, this.bannerContent = this.signalingSession.bannerContent, this.callPhoneLineType = this.signalingSession.callPhoneLineType;
                            const f = await C.execute("WaitForMediaOffer", ()=>g ? Promise.resolve(g) : this.attachToCallAndGetOffer.promise);
                            let _;
                            try {
                                _ = await C.execute("ProcessOffer", ()=>this.mediaSession.processOfferAsync(f, S));
                            } catch (g) {
                                _ = await this._handleOfferProcessingError(g, S, v);
                            }
                            await C.execute("ProcessOfferedModalities", ()=>this._processOfferedModalities(_, S));
                        }, _ = (()=>C.execute("SendAttach", ()=>this.signalingSession.sendAttachToCall(S)).then(()=>this.setCallState(1, S)))();
                        return await Promise.all([
                            _,
                            mediaSetup()
                        ]).catch(async (g)=>{
                            throw await _, g;
                        }), await C.execute("TrySendingProvisionalAnswer", ()=>this._trySendProvisionalMediaAnswer(S)), C.executeSync("OnAcknowledgeSuccess", ()=>this._onAcknowledgeSuccess(v, C.getTelemetryData(), S));
                    } catch (g) {
                        return this._onAcknowledgeError(g, S, v, C.getTelemetryData());
                    }
                }
                _onMessageIdChanged(g, f) {
                    g && this.messageId !== g && this.setMessageId(g, f);
                }
                async accept(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("Accept", f);
                    if (S.info(`accept, answerMediaType: ${g.answerMediaType},\n                            withVideo: ${g.withVideo},\n                            muted: ${g.muted},\n                            getSendMediaModalities: ${JSON.stringify(g.sendMediaModalities)},\n                            clientEndpointCapabilities: ${g.clientEndpointCapabilities},\n                            muteFlags: ${g.muteFlags}`), 1 !== this.state) throw new Error("Only calls in Notified state can be accepted");
                    this.setCallOptions({
                        callStartOptions: g,
                        callStartTime: Date.now()
                    }), this.setSessionIceTransportPolicy(g === null || g === void 0 ? void 0 : g.mediaConfiguration);
                    const v = this._callOperationHandler.createPendingOperation("_ConnectCall", void 0, f);
                    this.callStats.localStats.audio.start();
                    const _ = createPhaseExecutor(S);
                    this.mediaSession.createAudioElement(f);
                    const C = g.muted || 1 == (1 & g.muteFlags), E = 2 == (2 & g.muteFlags);
                    this.setMuted(C ? 2 : this.isServerMuted ? 1 : 0, f), this.setSpeakerMuted(E, f), this.setCallState(2, f), this.connectCallPromise = this._callOperationHandler.waitForOperation("Accept");
                    try {
                        g.forceAudioSendModalityWithNullStream && this.mediaSession.useNullAudioStreamClient(), this.mediaStateConfigurationHelper.setCallAcceptOptions(g), this.mediaStateConfigurationHelper.isSending(1) && await _.execute("StartVideoSafe", ()=>this.startVideoSafe(f)), this.mediaStateConfigurationHelper.isSending(0) && this.setAudioOn(!0, f);
                        const C = await _.execute("UpdateMediaModalities", ()=>this.updateMediaModalities(void 0, f)), E = _.executeSync("GetSignalingMediaTypes", ()=>this.getSignalingMediaTypes(C)), T = await _.execute("evaluateEndpointStatesForAccept", ()=>this.evaluateEndpointStatesForAccept(2 === this._muteState, g === null || g === void 0 ? void 0 : g.additionalEndpointProperties, f));
                        await _.execute("MuteUnmuteSpeakers", ()=>this.muteUnmuteSpeaker(this.isSpeakerMuted, f));
                        const I = _.execute("handleEndpointStatesForAccept", ()=>this.handleEndpointStatesForAccept(T, f));
                        S.info("Queued the handleEndpointStatesForAccept");
                        const b = await _.execute("CreateAnswer", ()=>this.mediaSession.createAnswerAsync(!1, f));
                        await _.execute("Accept", ()=>this.signalingSession.acceptAsync(b, E, g.clientEndpointCapabilities, f)), await _.execute("WaitForConnect", ()=>v), this.handleRemoteParticipantStateInOneToOneCall(f), await _.execute("CompleteNegotiation", ()=>this.completeNegotiationAsync(f)), await I, this.callTelemetry.updateOperationData("Accept", {
                            phases: _.getTelemetryData()
                        }, f);
                    } catch (g) {
                        var _this_mediaSession;
                        let v = 7, _ = {};
                        throw this.callTelemetry.updateOperationData("Accept", this.getTelemetryFromPhaseExecution(g), f), (g === null || g === void 0 ? void 0 : g.error) && (_ = {
                            ...g.error
                        }), isOneOfPhaseErrors(qi, g) && (v = 47), ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.stopCallOnAcceptFailure) && this.stopInternal({
                            terminatedReason: v,
                            causeId: f,
                            rejectReason: _
                        }), g.terminatedReason = v, S.logFailure(g), g;
                    }
                }
                async reject(g = generateCauseId(), f) {
                    const S = f ? {
                        clientReasonSubCode: f.clientSubCode,
                        clientReasonPhrase: f.clientPhrase
                    } : {};
                    return 1 !== this.state ? Promise.reject(60) : this.stopInternal({
                        terminatedReason: 10,
                        causeId: g,
                        rejectReason: S
                    });
                }
                async join(g, f = {}, S = generateCauseId()) {
                    const v = Date.now();
                    return this.setInitialTelemetry("JoinCall", {
                        callStartOptions: f,
                        callStartTime: v
                    }, g.conversationUrl, S), this.setCallerMri(stripMriAliases(g.groupCallInitiator)), this.connectCallPromise = this._callOperationHandler.waitForOperation("JoinCall"), this.joinOrStartCall({
                        callStartOptions: getCallStartOptions(f),
                        callStartTime: v
                    }, this.joinGivenConversation, S, g.conversationUrl);
                }
                async joinPreheatedCall(g, f) {
                    const S = this.logger.createFnLogger("JoinPreheatedCall", f), v = this.isServerMuted || 1 == (1 & g.muteFlags), _ = 2 == (2 & g.muteFlags), C = createPhaseExecutor(S);
                    this.connectCallPromise = this._callOperationHandler.waitForOperation("JoinPreheatedCall");
                    try {
                        const S = {
                            endpointProperties: {
                                preheatProperties: 0
                            }
                        };
                        this.setCallState(2, f), !this.isCallModeStreaming() && v && (S.state = {
                            isMuted: !0
                        }), await this.signalingSession.updateEndpointState(S, f, g.publishedStates, g.captchaContentJson), this.computeCallState(f), this.isCallModeStreaming() || (v || (await C.execute("UnmuteInput", ()=>this.mediaSession.unmuteInputAsync(f)), this.setMuted(0, f)), _ || (await C.execute("UnmuteOutput", ()=>this.mediaSession.unmuteOutputAsync(f)), this.setSpeakerMuted(!1, f)));
                    } catch (g) {
                        const v = 7;
                        let _;
                        return S.logFailure(`error: ${v} ${getPrintableObject(g)}`), isTransactionEnd(g) ? _ = g : isPhaseError("UnmuteInput", g) ? _ = {
                            code: Li.LocalError,
                            subCode: Fi.MediaUnmuteMicrophoneError,
                            phrase: getPrintableObject(g),
                            causeId: f
                        } : isPhaseError("UnmuteOutput", g) && (_ = {
                            code: Li.LocalError,
                            subCode: Fi.MediaUnmuteSpeakerError,
                            phrase: getPrintableObject(g),
                            causeId: f
                        }), this.callTelemetry.updateOperationData("JoinPreheatedCall", {
                            phases: C.getTelemetryData(),
                            error: getPIISafeObject(g)
                        }, f), this.stopInternal({
                            causeId: f,
                            terminatedReason: v,
                            rejectReason: _
                        }), Promise.reject(_);
                    }
                }
                async start(g = {}, f = generateCauseId()) {
                    const S = Date.now();
                    return this.setCallerMri(nr + this.currentUserSkypeIdentity.id), this.setInitialTelemetry("StartCall", {
                        callStartOptions: g,
                        callStartTime: S
                    }, "", f), this.connectCallPromise = this._callOperationHandler.waitForOperation("StartCall"), this.joinOrStartCall({
                        callStartOptions: getCallStartOptions(g),
                        callStartTime: S
                    }, this.startOutgoingCall, f);
                }
                async startCallToVoicemail(g, f = generateCauseId()) {
                    const S = Date.now();
                    return this.setCallerMri(nr + this.currentUserSkypeIdentity.id), this.setInitialTelemetry("StartCallToVoiceMail", {
                        callVoicemailStartOptions: g,
                        callStartTime: S
                    }, "", f), this.connectCallPromise = this._callOperationHandler.waitForOperation("StartCallToVoiceMail"), this.joinOrStartCall({
                        callVoicemailStartOptions: g,
                        callStartTime: S
                    }, this.startVM, f);
                }
                async joinCallWithoutCallModality(g, f = {}, S = generateCauseId()) {
                    const v = Date.now();
                    this.setCallerMri(g.groupCallInitiator), this.setCallType(2, S);
                    const _ = {
                        callStartOptions: getCallStartOptions(f),
                        callStartTime: v
                    };
                    return this.setInitialTelemetry("Subscribe", _, g.conversationUrl, S), 0 !== this.state ? (this.logger.info(`[${S}][joinCallWithoutCallModality]Trying to subscribe to a call that has already been acted on`), Promise.reject(60)) : (this.setCallOptions(_), this.setCallState(8, S), this.signalingSession.subscribeToCall(g.conversationUrl, this.callId, f.clientEndpointCapabilities, {
                        meetingRegistrationId: f.meetingRegistrationId,
                        participantPin: f.participantPin,
                        clientEndpointDebugContent: f.clientEndpointDebugContent,
                        additionalEndpointProperties: f.additionalEndpointProperties
                    }, S).catch((g)=>isTransactionEnd(g) ? (this.logger.info(`[${S}][joinCallWithoutCallModality] ${getPrintableObject(g)}`), Promise.reject(g)) : Promise.reject(convertReason(g))), this._callOperationHandler.waitForOperation("Subscribe", void 0, S));
                }
                startWithMeetingData(g, f) {
                    const S = Date.now();
                    return this.setCallerMri(nr + this.currentUserSkypeIdentity.id), this.setInitialTelemetry("StartWithMeetingData", {
                        callStartOptions: f,
                        callStartTime: S
                    }, "", g), this.connectCallPromise = this._callOperationHandler.waitForOperation("StartWithMeetingData"), this.joinOrStartCall({
                        callStartOptions: getCallStartOptions(f),
                        callStartTime: S,
                        meetingPreferences: {
                            shouldResurrect: f.shouldResurrect
                        }
                    }, this.startOutgoingCall, g);
                }
                joinWithMeetingData(g, f, S) {
                    const v = Date.now();
                    return this.setInitialTelemetry("JoinWithMeetingData", {
                        callStartOptions: S,
                        callStartTime: v
                    }, f.conversationUrl, g), this.setCallerMri(stripMriAliases(f.groupCallInitiator)), this.connectCallPromise = this._callOperationHandler.waitForOperation("JoinWithMeetingData"), this.joinOrStartCall({
                        callStartOptions: getCallStartOptions(S),
                        callStartTime: v,
                        meetingPreferences: {
                            shouldResurrect: S.shouldResurrect
                        }
                    }, this.joinGivenConversation, g, f.conversationUrl);
                }
                subscribeWithMeetingData(g, f, S) {
                    const v = Date.now();
                    this.setCallerMri(f.groupCallInitiator), this.setCallType(2, g);
                    const _ = {
                        callStartOptions: getCallStartOptions(S),
                        callStartTime: v
                    };
                    return this.setInitialTelemetry("SubscribeWithMeetingData", _, f.conversationUrl, g), 0 !== this.state ? (this.logger.info(`[${g}][subscribeWithMeetingData]Trying to subscribe to a call that has already been acted on`), Promise.reject(60)) : (this.setCallOptions(_), this.setCallState(8, g), this.signalingSession.subscribeToCall(f.conversationUrl, this.callId, S.clientEndpointCapabilities, {
                        meetingPreferences: {
                            shouldResurrect: S.shouldResurrect
                        },
                        meetingData: this.meetingData,
                        meetingRegistrationId: S.meetingRegistrationId,
                        participantPin: S.participantPin,
                        additionalEndpointProperties: S.additionalEndpointProperties
                    }, g).catch((f)=>isTransactionEnd(f) ? (this.logger.info(`[${g}][subscribeWithMeetingData] ${getPrintableObject(f)}`), Promise.reject(f)) : Promise.reject(convertReason(f))), this._callOperationHandler.waitForOperation("SubscribeWithMeetingData", void 0, g));
                }
                async startCallWithNudge(g, f = {}, S = generateCauseId()) {
                    this.setCallerMri(nr + this.currentUserSkypeIdentity.id), this.connectCallPromise = this._callOperationHandler.waitForOperation("StartCallWithNudge");
                    const v = Date.now();
                    if (this.logger.info(`[${S}][startCallWithNudge]startCallWithNudge for participants: ${scrubMriOrOmitList(g)}`), this.participants.length) return Promise.reject(48);
                    if (f.isCast && f.isHuddleGroupCall) return this.logger.logFailure(`isCast: ${f.isCast} isHuddleGroupCall: ${f.isHuddleGroupCall}`), Promise.reject(new Error("isCast or isHuddleGroupCall can only be set exclusively."));
                    const _ = {};
                    return _.callStartOptions = getCallStartOptions(f), _.invitationType = an.INVITATION_TYPE.NUDGE, _.participantsToNudge = g, _.callStartTime = v, this.setInitialTelemetry("StartCallWithNudge", _, "", S), this.joinOrStartCall(_, this.startOutgoingCall, S);
                }
                async startAndUnpark(g, f, S = {}, v = generateCauseId()) {
                    this.setCallerMri(nr + this.currentUserSkypeIdentity.id);
                    const _ = this.logger.createFnLogger("StartCallAndUnpark", v), C = Date.now();
                    this.setInitialTelemetry("StartCallAndUnpark", {
                        callStartTime: C
                    }, "", v), _.info(`startAndUnpark for context: ${g}, pickupCode :${f}`), this.connectCallPromise = this._callOperationHandler.waitForOperation("StartCallAndUnpark");
                    const E = {};
                    switch(E.callStartOptions = getCallStartOptions(S), E.pickupCode = f, E.parkContext = mi.SERVER_HOLD, g){
                        case 0:
                            E.parkContext = mi.PARK;
                            break;
                        case 1:
                            E.parkContext = mi.SHARED_LINE;
                            break;
                        case 5:
                            E.parkContext = mi.CALL_PARK;
                            break;
                        case 2:
                            E.parkContext = mi.SERVER_HOLD;
                            break;
                        default:
                            throw new Error(`[startAndUnpark] unsupported ParkContext name: ${g}`);
                    }
                    return this.addParticipant(`4:${E.parkContext}`).catch((g)=>_.logFailure("Failed to add participant to unparked call")), this.joinOrStartCall(E, this.startOutgoingCall, v);
                }
                async admitParticipant(g, f = generateCauseId()) {
                    const S = generateAliasedMri(g), v = this.getParticipant(S), _ = this._getParticipantLegId(v), C = _ ? {
                        participantLegId: _
                    } : {};
                    if (v && 7 !== v.state) {
                        const S = {
                            code: 0,
                            subCode: 3552,
                            phrase: "Participant is not in lobby state"
                        };
                        return this.callTelemetry.maybeRecordOperationSuccess("AdmitParticipant", S, g, f, C), Promise.reject(S);
                    }
                    return this.admitParticipantToCall(S, f, _);
                }
                admit(g, f) {
                    return this.signalingSession.admitAsync(f);
                }
                async callMeBack(g, f, S = generateCauseId()) {
                    const v = generateAliasedMri(`${nr}${this.currentUserSkypeIdentity.id}`, this.currentUserSkypeIdentity.sipUri);
                    return this.addCallMeBackParticipant(g, f || v, S);
                }
                async addParticipant(g, f = {}, S = generateCauseId()) {
                    return (await this.addParticipantsImpl([
                        g
                    ], f, S, "addParticipant"))[0];
                }
                async addParticipants(g, f = {}, S = generateCauseId()) {
                    return this.addParticipantsImpl(g, f, S, "addParticipants");
                }
                async addParticipantsImpl(g, f = {}, S = generateCauseId(), v) {
                    if (this.logger.info(`[${S}][${v}] start`), this.isEmergency && 0 === this.state && (0 !== this.participants.length || 1 !== g.length)) return Promise.reject(new Error("Only 1 participant (the emergency operator) may be added to unstarted emergency calls"));
                    if (f.participantInvitationData) try {
                        JSON.stringify(f.participantInvitationData);
                    } catch (g) {
                        throw this.logger.info(`[${S}][${v}] ${g}`), g;
                    }
                    const _ = [], C = [];
                    if (g.forEach((g)=>{
                        const f = this.getOrCreateParticipant(g, S, !0);
                        0 === f.state || 4 === f.state ? (C.push(f), _.push(this._participantOperationHandler.createPendingOperation("AddParticipant", f.id, S))) : 3 === f.state ? _.push(Promise.resolve(f)) : this._participantOperationHandler.hasPendingOperationWithOperationId("AddParticipant", f.id) && _.push(this._participantOperationHandler.waitForOperation("AddParticipant", f.id));
                    }), 0 === C.length) return Promise.resolve(_);
                    const E = !!f.disableUnmute, T = this.addParticipantsToCall(C, S, f.participantInvitationData, f.groupId, f.threadId, f.messageId, E, f.alternateId, f.customHeaderContext, f.callingLineIdentity);
                    return (0, zi.zip)(T, C).forEach(async ([g, f])=>{
                        try {
                            await g;
                            const v = this._getParticipantLegId(this.getParticipant(f.id)), _ = v ? {
                                participantLegId: v
                            } : {};
                            this.callTelemetry.recordOperationSuccess("AddParticipant", {
                                code: 0,
                                subCode: 0,
                                phrase: ""
                            }, f.id, S, _), this._participantOperationHandler.maybeResolveOperation("AddParticipant", f, f.id, S);
                        } catch (g) {
                            this._participantOperationHandler.maybeRejectOperation("AddParticipant", g, f.id, S);
                        }
                    }), this.raiseChanged(this._participantChangedEventSkipConfig), Promise.resolve(_);
                }
                async nudgeParticipants(g, f, S = {}, v = generateCauseId()) {
                    return 2 !== this.state && 3 !== this.state ? Promise.reject(48) : this.signalingSession.nudgeParticipantsAsync({
                        participantsIds: f,
                        causeId: v,
                        invitationData: S.participantInvitationData,
                        newGroupId: S.groupId,
                        newThreadId: S.threadId,
                        newMessageId: S.messageId
                    });
                }
                mapRemoveEndpointScope(g) {
                    switch(g){
                        case 0:
                            return "specified";
                        case 1:
                            return "all";
                        default:
                            return "none";
                    }
                }
                mapEndpointScope(g) {
                    return 1 === g ? "all" : "none";
                }
                async removeParticipant(g, f = generateCauseId(), S, v) {
                    const _ = this.logger.createFnLogger("removeParticipant", f);
                    _.info("start");
                    const C = this.mapRemoveEndpointScope(v);
                    return this.signalingSession.removeParticipantAsync({
                        id: g,
                        endpointId: S
                    }, f, C).catch((S)=>{
                        _.logFailure(`Participant was not removed from call, error=${S}`);
                        const v = this._handleParticipantOperationFailure("RemoveParticipant", S, f, g).reason;
                        return Promise.reject(v || 38);
                    });
                }
                async cancelNudge(g, f) {
                    throw new Error("Method not implemented.");
                }
                async searchParticipants(g, f) {
                    return this.signalingSession.searchParticipantsAsync(g.searchQueryOptions, f);
                }
                async getAllParticipants(g, f) {
                    return this.signalingSession.getAllParticipantsAsync(g.scope, f);
                }
                set dominantSpeakerInfo(g) {
                    this.internalDominantSpeakerInfo = g;
                }
                get dominantSpeakerInfo() {
                    var _this_mediaSession;
                    return this.internalDominantSpeakerInfo ? this.internalDominantSpeakerInfo : ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.emptyInitialDSH) ? {
                        speakerList: [],
                        timestamp: null,
                        noCurrentDominantSpeaker: !1
                    } : {
                        speakerList: this.participants.filter((g)=>3 === g.state).map((g)=>g.id),
                        timestamp: null,
                        noCurrentDominantSpeaker: !1
                    };
                }
                set slowedDownActiveTalkerInfo(g) {
                    var _this_internalSlowedDownActiveTalkerInfo;
                    (0, zi.isEqual)((_this_internalSlowedDownActiveTalkerInfo = this.internalSlowedDownActiveTalkerInfo) === null || _this_internalSlowedDownActiveTalkerInfo === void 0 ? void 0 : _this_internalSlowedDownActiveTalkerInfo.speakerList, g.speakerList) || (this.internalSlowedDownActiveTalkerInfo = g, this.raiseChanged());
                }
                get slowedDownActiveTalkerInfo() {
                    return this.internalSlowedDownActiveTalkerInfo;
                }
                startVideoSafe(g) {
                    return this.startVideo(g).catch((f)=>{
                        this.logger.info(JSON.stringify(f), "startVideoSafe", g);
                    });
                }
                async joinOrStartCall(g, f, S, v) {
                    var _g_callStartOptions, _g_callStartOptions1, _g_callStartOptions2;
                    const _ = this.logger.createFnLogger("joinOrStartCall", S);
                    if (0 !== this.state && 8 !== this.state && !g.isPromotingToRealtime) {
                        const g = "Trying to start a call that has already been acted on";
                        return _.logFailure(g), Promise.reject(60);
                    }
                    if (this.signalingAgent.resolvePotentialCallConflict(this.signalingSession) === this.signalingSession) return Promise.reject(57);
                    this.callStats.localStats.startCall();
                    const C = 8 === this.state || 1 !== this.participants.length;
                    _.info(`isMultiparty=${C}, reason: participants.length=${this.participants.length}`), this.setCallType(C ? 2 : 1, S), this.setCallUsesMixer(C, S), this.setCallOptions(g);
                    const E = g.callStartOptions || {};
                    if (1 == (1 & E.preheatFlags)) this.setMuted(2, S), this.setSpeakerMuted(!0, S), this.setCallState(11, S);
                    else {
                        const g = !!E && (E.muted || 1 == (1 & E.muteFlags)), f = (E === null || E === void 0 ? void 0 : E.muteFlags) ? 2 == (2 & E.muteFlags) : this.isSpeakerMuted;
                        this.setMuted(g ? 2 : this.isServerMuted ? 1 : 0, S), this.setSpeakerMuted(f, S), this.setCallState(2, S);
                    }
                    const T = calculateJoinedFromForTelemetry(this.meetingData, this.threadId, this.messageId, this.groupId, !!v);
                    this.callTelemetry.setJoinedFrom(T), this.signalingSession.setJoinedFrom(T), this.setHuddleGroupCall(!!((_g_callStartOptions = g.callStartOptions) === null || _g_callStartOptions === void 0 ? void 0 : _g_callStartOptions.isHuddleGroupCall));
                    const I = this._callOperationHandler.createPendingOperation("_ConnectCall", "", S);
                    return I.catch(noop), await this.joinOrStartWithMedia(g, f, g.callStartTime, I, S, v), ((_g_callStartOptions1 = g.callStartOptions) === null || _g_callStartOptions1 === void 0 ? void 0 : _g_callStartOptions1.meetingRegistrationId) && this.callTelemetry.setHasMeetingRegistrationId(!0), ((_g_callStartOptions2 = g.callStartOptions) === null || _g_callStartOptions2 === void 0 ? void 0 : _g_callStartOptions2.participantPin) && this.callTelemetry.setHasParticipantPin(!0), I;
                }
                setSessionIceTransportPolicy(g) {
                    var _this_mediaSession_getSessionConfig_setIceTransportPolicy, _this_mediaSession, _this_mediaSession_getSessionConfig;
                    const f = g === null || g === void 0 ? void 0 : g.connectionType;
                    let S = Gt.ICE_TRANSPORT_POLICY.all;
                    switch(f){
                        case "AllSupported":
                            S = Gt.ICE_TRANSPORT_POLICY.all;
                            break;
                        case "NoDirectConnection":
                            S = Gt.ICE_TRANSPORT_POLICY.relay;
                    }
                    (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getSessionConfig_setIceTransportPolicy = (_this_mediaSession_getSessionConfig = _this_mediaSession.getSessionConfig()).setIceTransportPolicy) === null || _this_mediaSession_getSessionConfig_setIceTransportPolicy === void 0 ? void 0 : _this_mediaSession_getSessionConfig_setIceTransportPolicy.call(_this_mediaSession_getSessionConfig, S);
                }
                async joinOrStartWithMedia(g, f, S, v, _, C) {
                    var _g_callStartOptions;
                    const E = this.logger.createFnLogger("joinOrStartWithMedia", _);
                    this.callStats.localStats.audio.start();
                    const T = g.callStartOptions, I = T && 1 & T.preheatFlags;
                    if (this._startCallPhase = createPhaseExecutor(E), ((_g_callStartOptions = g.callStartOptions) === null || _g_callStartOptions === void 0 ? void 0 : _g_callStartOptions.sendMediaModalities) && (this.mediaStateConfigurationHelper = new Mr(g.callStartOptions.sendMediaModalities)), this._preferredMpLocation) {
                        g.callStartOptions = g.callStartOptions || {};
                        const f = g.callStartOptions.clientEndpointDebugContent ? JSON.parse(g.callStartOptions.clientEndpointDebugContent) : {};
                        g.callStartOptions.clientEndpointDebugContent = JSON.stringify({
                            preferredMpLocation: this._preferredMpLocation,
                            ...f
                        });
                    }
                    try {
                        var _g_callStartOptions1, _this_mediaSession, _this_screenSharingControl;
                        T && !I && this.mediaStateConfigurationHelper.isInactiveOrDisabled(0) && this.mediaStateConfigurationHelper.isSending(2) && (this.setCallUsesMixer(!0, _), await this.getScreenHandle().acquire()), this.mediaStateConfigurationHelper.isSending(0) && this.setAudioOn(!0, _), this.callUsesMixer || this.mediaStateConfigurationHelper.disableModality(2), E.info(`skipSharingModality=${!this.callUsesMixer}`), this._startCallPhase.executeSync("InitializeMediaSession", ()=>this.initializeMediaSession(_, T === null || T === void 0 ? void 0 : T.mediaConfiguration)), this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled()), this.mediaSession.getSessionConfig().config.alwaysNegotiateDataChannel && this.mediaStateConfigurationHelper.enableModality(3), this.setSessionIceTransportPolicy(g === null || g === void 0 ? void 0 : (_g_callStartOptions1 = g.callStartOptions) === null || _g_callStartOptions1 === void 0 ? void 0 : _g_callStartOptions1.mediaConfiguration), this.mediaSession.createAudioElement(_), this.callUsesMixer || C || this.isOneToOnePSTNCall() || g.callVoicemailStartOptions || this.setIsSomeoneStreamingVideo(!0);
                        const b = this._callOperationHandler.createPendingOperation("_WaitForAnswer", "", _, {
                            preconditionTags: [
                                "NOT_SUPPORTED_IN_STREAMING_MODE"
                            ]
                        });
                        b.catch(noop);
                        let A = !1;
                        g.isPromotingToRealtime ? (this.isSpeakerMuted = !0, A = !0, await this._startCallPhase.execute("MuteInput", ()=>this.mediaSession.muteInputAsync(_)), await this._startCallPhase.execute("MuteOutput", ()=>this.mediaSession.muteOutputAsync(_))) : T && (I ? (A = !0, await this._startCallPhase.execute("MuteInput", ()=>this.mediaSession.muteInputAsync(_)), await this._startCallPhase.execute("MuteOutput", ()=>this.mediaSession.muteOutputAsync(_)), this.setMuted(2, _), this.setCallUsesMixer(!0, _)) : this.mediaStateConfigurationHelper.isSending(1) && await this._startCallPhase.execute("StartVideoSafe", ()=>this.startVideoSafe(_))), (T === null || T === void 0 ? void 0 : T.forceAudioSendModalityWithNullStream) && this.mediaSession.useNullAudioStreamClient();
                        const R = await this._startCallPhase.execute("UpdateMediaModalities", ()=>this.updateMediaModalities(void 0, _));
                        if (!((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.createOfferAsync)) throw {
                            error: "NoMediaSession",
                            phase: "CreateOffer"
                        };
                        const P = await this._startCallPhase.execute("CreateOffer", ()=>this.mediaSession.createOfferAsync(_)), w = this._startCallPhase.executeSync("GetSignalingMediaTypes", ()=>this.getSignalingMediaTypes(this.calculateModalityDirections({}, _)));
                        if (this.mediaStateConfigurationHelper.isSending(2) && this.updateScreenSharingState(R, _), A || (await this._startCallPhase.execute("MuteUnmute", ()=>this.muteUnmute(2 === this._muteState, _)), await this._startCallPhase.execute("MuteUnmuteSpeakers", ()=>this.muteUnmuteSpeaker(this.isSpeakerMuted, _))), this._startCallPhase.executeSync("CallStart", ()=>f(_, g, P, w, S, C)), await this._startCallPhase.execute("WaitForConnect", ()=>v), !this.isCallModeStreaming() || g.isPromotingToRealtime) {
                            var _this_mediaSession1;
                            const g = await this._startCallPhase.execute("WaitForAnswer", ()=>b);
                            if (!((_this_mediaSession1 = this.mediaSession) === null || _this_mediaSession1 === void 0 ? void 0 : _this_mediaSession1.processAnswerAsync)) throw {
                                error: "NoMediaSession",
                                phase: "ProcessAnswer"
                            };
                            await this._startCallPhase.execute("ProcessAnswer", ()=>this.mediaSession.processAnswerAsync(g, _, !1)), await this._startCallPhase.execute("CompleteNegotiation", ()=>this.completeNegotiationAsync(_));
                        }
                        this.callTelemetry.updateOperationData("_ConnectCall", {
                            phases: this._startCallPhase.getTelemetryData()
                        }, _), this._startCallPhase = void 0, 2 !== (T === null || T === void 0 ? void 0 : T.screenshareDirection) && 4 !== (T === null || T === void 0 ? void 0 : T.screenshareDirection) || (((_this_screenSharingControl = this.screenSharingControl) === null || _this_screenSharingControl === void 0 ? void 0 : _this_screenSharingControl.isInternalSharerControlEnabled()) && this.screenSharingControl.initControlForSharer(""), this.enableControlInjector());
                    } catch (g) {
                        this.catchJoinOrStartCallError(g, _, E);
                    }
                }
                catchJoinOrStartCallError(g, f, S) {
                    let v, _ = 0;
                    throw S.logFailure(getPrintableObject(g)), (g === null || g === void 0 ? void 0 : g.error) && (v = {
                        ...g.error
                    }), isPhaseError("MuteInput", g) ? (_ = 7, v = {
                        code: Li.LocalError,
                        subCode: Fi.MediaMuteMicrophoneError,
                        phrase: getPrintableObject(g),
                        causeId: f
                    }) : isPhaseError("MuteOutput", g) ? (_ = 7, v = {
                        code: Li.LocalError,
                        subCode: Fi.MediaMuteSpeakerError,
                        phrase: getPrintableObject(g),
                        causeId: f
                    }) : (g === null || g === void 0 ? void 0 : g.type) === this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer || isOneOfPhaseErrors(qi, g) ? _ = 47 : (g === null || g === void 0 ? void 0 : g.type) === this.mediaAgent.constants.MEDIA_ERROR.permissionDeniedError ? (_ = 58, v = {
                        code: Li.MediaError,
                        subCode: Fi.MediaPermissionError,
                        phrase: getPrintableObject(g),
                        causeId: f
                    }) : isPhaseError("WaitForAnswer", g) || isPhaseError("WaitForConnect", g) ? _ = g.error : isOneOfPhaseErrors(Gi, g) && (_ = 7), this.callTelemetry.updateOperationData("_ConnectCall", this.getTelemetryFromPhaseExecution(g), f), this._startCallPhase = void 0, this.callSetupFailed = !0, Promise.all([
                        this._callOperationHandler.maybeRejectOperation("_WaitForAnswer", _, "", f),
                        this._callOperationHandler.maybeRejectOperation("_ConnectCall", _, "", f)
                    ]).then(()=>{
                        this.isPromotingToRealtime() || this.stopInternal({
                            causeId: f,
                            terminatedReason: _,
                            rejectReason: v
                        });
                    }).catch(noop), _;
                }
                addCallMeBackParticipant(g, f, S) {
                    const v = this._participantOperationHandler.waitForOperation("CallMeBack", g), _ = this.logger.createFnLogger("CallMeBack", S), C = {
                        id: g,
                        assertedId: f
                    };
                    return this.signalingSession.callMeBackAsync(C).then(()=>{
                        _.logSuccess(`successfully executed call me back, participantId = ${scrubMriOrOmit(g)}`), this._participantOperationHandler.resolveOperation("CallMeBack", 0, g);
                    }).catch((v)=>{
                        _.logFailure(`Call me back failed, participantId = ${scrubMriOrOmit(g)}, error = ${v}`), this._handleParticipantOperationFailure("CallMeBack", v, S, f, !1);
                        const C = this._processError(v);
                        let E = {};
                        C && (E = {
                            ...C
                        }), E.failureReason = C.reason ? C.reason : 11, this._participantOperationHandler.rejectOperation("CallMeBack", E, g);
                    }), v;
                }
                addParticipantsToCall(g, f, S, v, _, C, E, T, I, b) {
                    const A = this.logger.createFnLogger("addParticipantsToCall", f);
                    g.forEach((g)=>{
                        g.setState(1, void 0, f);
                    });
                    const R = g.map((g)=>({
                            id: g.mri
                        }));
                    A.info(`participantIds=${g.map((g)=>scrubMriOrOmit(g.id))}, disableUnmute=${E}`);
                    const P = {
                        additionalData: S,
                        groupId: v,
                        threadId: _,
                        messageId: C,
                        disableUnmute: E,
                        alternateId: T,
                        customHeaderContext: I,
                        callingLineIdentity: b
                    };
                    try {
                        const g = this.signalingSession.addParticipantsAsync(R, P, f);
                        return (0, zi.zip)(g, R).map(async ([g, S])=>{
                            try {
                                const v = await g;
                                this.signalingNotifications.onParticipantJoined(v, f);
                                const _ = this._getParticipantLegId(this.getParticipant(S.id)), C = _ ? {
                                    participantLegId: _
                                } : {};
                                this.callTelemetry.recordOperationSuccess("AddParticipant", {
                                    code: 0,
                                    subCode: 0,
                                    phrase: ""
                                }, v.id, f, C);
                            } catch (g) {
                                const v = this._handleParticipantOperationFailure("AddParticipant", g, f, S.id).reason;
                                throw this._removeParticipant(S, f, v), v;
                            }
                        });
                    } catch (g) {
                        return A.logFailure(`Participants was not added to call, error=${g}`), (0, zi.range)(R.length).map(()=>Promise.reject(1));
                    }
                }
                async mergeCallByAddParticipantWithReplaces(g, f, S, v, _, C, E, T) {
                    const I = this.logger.createFnLogger("mergeCallByAddParticipantWithReplaces", C), b = this.convertClientScenario(T), A = {
                        additionalData: g.additionalData,
                        groupId: g.groupId,
                        threadId: g.threadId,
                        messageId: g.messageId,
                        callIdToReplace: S.callId,
                        replacementType: v,
                        clientScenario: b
                    }, R = await this.signalingSession.addParticipantsAsync(f, A, C);
                    for(let g = 0; g < R.length; g++){
                        const S = 3 === v ? f[g].participantId : f[g].id;
                        try {
                            await R[g], I.logSuccess(` [participantInfos id =${scrubMriOrOmit(f[g].id)}]`);
                            const v = {
                                debugContent: {
                                    replacementParticipantLegId: f[g].replacementParticipantId || void 0,
                                    clientScenario: b
                                },
                                participantLegId: f[g].participantId
                            }, E = {
                                code: 0,
                                subCode: 0,
                                phrase: ""
                            };
                            this.callTelemetry.recordOperationSuccess(_, E, S, C, v), this._callOperationHandler.maybeResolveOperation(_, E, S, C);
                        } catch (v) {
                            I.logFailure(`Participant was not added to call, error=${getPIISafeObject(v)}`);
                            const E = this._handleParticipantOperationFailure(_, v, C, S, !0, b).reason;
                            this._removeParticipant(f[g], C, E);
                            const T = v ? v.endCode : E || 0;
                            this._callOperationHandler.maybeRejectOperation(_, T, S, C);
                        }
                    }
                    return Promise.resolve(E);
                }
                admitParticipantToCall(g, f, S) {
                    const v = this.logger.createFnLogger("admitParticipantToCall", f), _ = {
                        id: g
                    };
                    return v.info("start"), this.signalingSession.admitParticipantAsync(_, f).then((_)=>{
                        v.info(`successfully admitted participant to call, participantId = ${scrubMriOrOmit(g)}`);
                        const C = S ? {
                            participantLegId: S
                        } : {}, E = {
                            code: 0,
                            subCode: 0,
                            phrase: ""
                        };
                        this.callTelemetry.recordOperationSuccess("AdmitParticipant", E, g, f, C);
                    }).catch((S)=>{
                        v.logFailure(`Participant was not admitted to call, error=${S}`);
                        const _ = this._handleParticipantOperationFailure("AdmitParticipant", S, f, g);
                        return Promise.reject(_);
                    });
                }
                _processError(g) {
                    let f;
                    const S = {
                        reason: f
                    };
                    if (g === null || g === void 0 ? void 0 : g.endCode) {
                        const v = getTerminationCode(g.endCode.code, g.endCode.subCode);
                        f = _PluginlessCall.getParticipantReasonFromTerminatedReason(v), S.reason = f, S.code = g.endCode.code, S.subCode = g.endCode.subCode, S.resultCategories = g.endCode.resultCategories, S.phrase = g.endCode.phrase;
                    } else S.phrase = `${g}`;
                    return this.logger.info(`_processError error=${g} telemetryData=${JSON.stringify(S)}`), S;
                }
                _handleParticipantOperationFailure(g, f, S, v, _ = !0, C) {
                    this.callTelemetry.updateOperationData(g, {
                        error: getPIISafeObject(f)
                    }, S, v);
                    const E = this._processError(f), T = this.getParticipant(v);
                    E.code && T && (T.callEndDiagnosticsInfo = {
                        callControllerCode: E.code,
                        callControllerSubCode: E.subCode,
                        phrase: E.phrase,
                        resultCategories: E.resultCategories
                    });
                    try {
                        if (_) {
                            const f = {
                                debugContent: {
                                    clientScenario: C
                                },
                                participantLegId: this._getParticipantLegId(T) || void 0
                            };
                            this.callTelemetry.recordOperationFailure(g, E, v, S, f);
                        }
                    } catch (g) {
                        this.logger.info(`_handleParticipantOperationFailure error during recordOperationFailure ${g}`);
                    }
                    return E;
                }
                _getParticipantLegId(g) {
                    return (0, zi.has)(g, "endpoints.endpointDetails") && g.endpoints.endpointDetails.length && g.endpoints.endpointDetails[0].participantId ? g.endpoints.endpointDetails[0].participantId : null;
                }
                isOneToOnePSTNCall(g = !1) {
                    const f = this.signalingSession.isIncomingCall ? this.callerMri : this.participants.length > 0 ? this.participants[0].id : "";
                    return this.isOneToOneCall(g) && (0, zi.startsWith)(f, sr) && (!this.incomingCallType || !this.callUsesMixer);
                }
                isParkedCall() {
                    var _this_callOptions;
                    return this.isOneToOnePSTNCall() && !!((_this_callOptions = this.callOptions) === null || _this_callOptions === void 0 ? void 0 : _this_callOptions.parkContext);
                }
                async updateMediaModalities(g = {}, f = generateCauseId(), S) {
                    let v;
                    const _ = this.logger.createFnLogger("updateMediaModalities", f);
                    return _.info(`callUsesMixer=${this.callUsesMixer},isSomeoneSharing=${this.isSomeoneSharing},isSomeoneStreamingVideo=${this.isSomeoneStreamingVideo}`), _.info(`options=${safeJsonStringify(g)},requestHoldState=${this.requestedHoldState},requestedScreenSharingState=${this.mediaStateConfigurationHelper.isSending(2)}`), v = g.modalityOverride ? g.modalityOverride : this.requestedHoldState && !this.isMuteOnHold ? this.getMediaModalitiesForHold(f) : this.calculateModalityDirections(g === null || g === void 0 ? void 0 : g.offered, f), _.info(`modalities=${safeJsonStringify(v)}`), await this.mediaSession.configureModalitiesAsync(v, f, S), v;
                }
                calculateModalityDirections(g = {}, f) {
                    const S = this.logger.createFnLogger("calculateModalityDirections", f);
                    S.info(`callUsesMixer=${this.callUsesMixer}, isEscalationInProgress=${this.isEscalationInProgress}`);
                    const v = {
                        audio: this.calculateAudioDirection(g.audio, S),
                        video: this.calculateVideoDirection(g.video, S),
                        sharing: this.calculateSharingDirection(g.sharing, S),
                        data: this.calculateDataDirection(g.data, S)
                    };
                    return S.info(`done, modalities=${safeJsonStringify(v)}`), this.deleteExtraneousModalities(v, f), v;
                }
                calculateAudioDirection(g, f) {
                    if (f.info(`calculateAudioDirection, offer=${g}, requestedAudioState=${this.mediaStateConfigurationHelper.isSending(0)}`), this.receiveOnlyAudioOnCallStart) return f.info("calculateAudioDirection, direction=recvonly, receiveOnlyAudioOnCallStart=true"), "recvonly";
                    if (this.mediaStateConfigurationHelper.isInactiveOrDisabled(0) || "inactive" === g) return "inactive";
                    return this.mediaSession.getAllowedModalities().audio.some((g)=>g === Br.send || g === Br.sendReceive) ? "sendrecv" : "sendonly" === g ? "inactive" : "recvonly";
                }
                calculateVideoDirection(g, f) {
                    const S = this.mediaStateConfigurationHelper.isSending(1);
                    if (f.info(`calculateVideoDirection, offer=${g}, requestedVideoState=${S}, isSomeoneStreamingVideo=${this.isSomeoneStreamingVideo}`), this.mediaStateConfigurationHelper.isInactiveOrDisabled(0)) return "inactive";
                    let v = S, _ = this.isSomeoneStreamingVideo || this.callUsesMixer || this.isEscalationInProgress;
                    return g && (v = v && ("sendrecv" === g || "sendonly" === g), _ = _ && ("sendrecv" === g || "recvonly" === g)), v ? "sendrecv" : _ ? "recvonly" : "inactive";
                }
                calculateSharingDirection(g, f) {
                    return f.info(`calculateSharingDirection, offer=${g}, requestedScreenSharingState=${this.mediaStateConfigurationHelper.isSending(2)}, isSomeoneSharing=${this.isSomeoneSharing}`), "inactive" === g ? "inactive" : this.mediaStateConfigurationHelper.isSending(2) ? "sendonly" : this.isSomeoneSharing || this.callUsesMixer || this.isEscalationInProgress ? "recvonly" : void 0;
                }
                calculateDataDirection(g, f) {
                    const S = this.mediaStateConfigurationHelper.isSending(3);
                    if (f.info(`calculateDataDirection, offer=${g}, dataEnabled=${S}`), this.allowDataChannel()) return S ? "inactive" === g ? "inactive" : "sendrecv" : void 0;
                    f.info("calculateDataDirection, disabling data since ECS flag prohibits it");
                }
                getMediaModalitiesForHold(g) {
                    this.logger.info(`[${g}][getMediaModalitiesForHold]`);
                    const f = "inactive", S = {
                        audio: f,
                        video: f,
                        data: this.allowDataChannel() ? f : void 0,
                        sharing: f
                    };
                    return this.deleteExtraneousModalities(S, g), S;
                }
                deleteExtraneousModalities(g, f) {
                    !hasSendDirectionality(g.video) && this.mediaStateConfigurationHelper.isDisabled(1) && (this.logger.info(`[${f}][deleteExtraneousModalities] skipping videoModality`), delete g.video), !hasSendDirectionality(g.sharing) && this.mediaStateConfigurationHelper.isDisabled(2) && (this.logger.info(`[${f}][deleteExtraneousModalities] skipping sharingModality`), delete g.sharing);
                }
                getSignalingMediaTypes(g) {
                    const isSendActive = (g)=>g === this.mediaAgent.constants.MEDIA_STATE.send || g === this.mediaAgent.constants.MEDIA_STATE.sendReceive, f = [];
                    return g.audio && g.audio !== this.mediaAgent.constants.MEDIA_STATE.inactive && f.push("Audio"), isSendActive(g.video) && f.push("Video"), g.sharing === this.mediaAgent.constants.MEDIA_STATE.send ? f.push("ScreenSharer") : g.sharing === this.mediaAgent.constants.MEDIA_STATE.receive && f.push("ScreenViewer"), f;
                }
                enableControlInjector() {
                    if (this.allowScreenSharingControl()) {
                        if (this.getlocalScreenShareStream()) {
                            var _this_mediaSession;
                            var _this_mediaSession_getLocalMediaTrackId;
                            const g = (_this_mediaSession_getLocalMediaTrackId = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getLocalMediaTrackId("ScreenShare")) !== null && _this_mediaSession_getLocalMediaTrackId !== void 0 ? _this_mediaSession_getLocalMediaTrackId : "";
                            this.screenSharingControl.enableControlInjector(g);
                        } else this.logger.warn("enableControlInjector: no local screenshare stream found");
                    }
                }
                createCallDeviceManager() {
                    return new Qs(this.mediaAgent.getConfigProvider().config.allowVirtualDeviceInCall, this.mediaAgent.getDeviceManager(), this.logger.createChild("CallDeviceManager"), this.callStats, (g)=>this.isMediaSending(g));
                }
                initializeSignalingSession(g) {
                    if (this.signalingSession) return void this.logger.info("Session already exists!");
                    const f = an.CALL_STATUS;
                    if (this.localSignalingParticipant = {
                        id: generateAliasedMri(`${nr}${this.currentUserSkypeIdentity.id}`, this.currentUserSkypeIdentity.sipUri),
                        displayName: this.currentUserSkypeIdentity.displayName,
                        endpointDetails: [],
                        languageId: null,
                        participantId: g,
                        endpointId: null
                    }, this.accountConfiguration) {
                        if (this.localSignalingParticipant.applicationType = this.accountConfiguration.applicationType, this.callTelemetry.setApplicationType(this.accountConfiguration.applicationType), this.localSignalingParticipant.ring = this.accountConfiguration.ring, this.callTelemetry.setRing(this.accountConfiguration.ring), this.localSignalingParticipant.region = this.accountConfiguration.region, this.callTelemetry.setRegion(this.accountConfiguration.region), this.localSignalingParticipant.userHexCID = this.accountConfiguration.userHexCID, this.callTelemetry.setUserHexCID(this.accountConfiguration.userHexCID), this.localSignalingParticipant.partition = this.accountConfiguration.partition, this.callTelemetry.setPartition(this.accountConfiguration.partition), this.localSignalingParticipant.acsResourceId = this.accountConfiguration.acsResourceId, this.callTelemetry.setAcsResourceId(this.accountConfiguration.acsResourceId), this.callStats.setAcsResourceId(this.accountConfiguration.acsResourceId), this.accountConfiguration.serviceUrls) {
                            const g = this.accountConfiguration.serviceUrls.calling_conversationServiceUrl, f = this.accountConfiguration.serviceUrls.calling_uploadLogRequestUrl;
                            this.signalingAgent.updateUrls(g, f, this.accountConfiguration.enforceUrls);
                        }
                        this.localSignalingParticipant.clientType = this.accountConfiguration.clientType, this.callTelemetry.setClientType(this.accountConfiguration.clientType);
                    }
                    this.callStats.localStats.setLocalUserId(this.localSignalingParticipant.id), this._callOperationHandler && this._callOperationHandler.resetOperationChain(), this.signalingNotifications = {
                        onPromotionCompleted: (g, f, S)=>{
                            this.logger.info(`[${S}][onPromotionCompleted] isFailed=${g} reason=${safeJsonStringify(f)} callMode=${this.callMode}`);
                            const v = g ? f : {
                                code: 0,
                                subCode: 0
                            };
                            if (this.callTelemetry.recordEvent("PromotionCompleted", {
                                reason: v
                            }, S), g) {
                                var _this_promotionCompletedDeferred;
                                const g = convertReason(f);
                                this._callOperationHandler.maybeRejectOperation("_WaitForAnswer", g, "", S), this._callOperationHandler.maybeRejectOperation("_CallStartOrJoinInitiated", g, "", S), this._callOperationHandler.maybeRejectOperation("_ConnectCall", g, "", S), (_this_promotionCompletedDeferred = this.promotionCompletedDeferred) === null || _this_promotionCompletedDeferred === void 0 ? void 0 : _this_promotionCompletedDeferred.reject(g);
                            } else this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated", void 0, void 0, S), this._callOperationHandler.maybeResolveOperation("_ConnectCall", void 0, void 0, S);
                            this.participants.forEach((g)=>{
                                g.applyCachedMediaStreams(S);
                            });
                        },
                        onCallStatusChanged: (g, S, v = generateCauseId())=>{
                            const _ = this.logger.createFnLogger("onCallStatusChanged", v);
                            let C = `[status=${g}]`;
                            if (S && (C += `[reason=${safeJsonStringify(S)}]`, void 0 !== S.code && (this.callEndDiagnosticsInfo = {
                                callControllerCode: S.code,
                                callControllerSubCode: S.subCode,
                                phrase: S.phrase,
                                resultCategories: S.resultCategories
                            }, (S.overflowJoinInformation || S.registrationInformation) && (this.callEndDiagnosticsInfo.additionalDiagnostics = {
                                overflowInformation: S.overflowJoinInformation,
                                registrationInformation: S.registrationInformation
                            }))), _.info(C), this.callTelemetry.recordEvent("_SignalingStateChanged", {
                                status: g,
                                reason: S
                            }, v), g === f.CONNECTING) this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated", void 0, void 0, v);
                            else if (g === f.RINGING) 2 === this.audioStreamState ? (this.setCallState(9, v), this.participants.forEach((g)=>g.setState(6, void 0, v))) : this.participants.forEach((g)=>g.setState(2, void 0, v)), this._callOperationHandler.maybeResolveOperation("Subscribe", void 0, void 0, v);
                            else if (g === f.CONNECTED_FOR_ROSTER_ONLY) this._callOperationHandler.maybeResolveOperation("Subscribe", void 0, void 0, v), this._callOperationHandler.maybeResolveOperation("SubscribeWithMeetingData", void 0, void 0, v);
                            else if (g === f.CONNECTED) {
                                this._callIsSetupComplete = !0;
                                const g = this.getLocalSignalingEndpointDetails();
                                ((g === null || g === void 0 ? void 0 : g.isLobby) || (g === null || g === void 0 ? void 0 : g.streamLobby)) && (this._callInLobby = !0, this.updateCapabilities(v, !0));
                                const f = this.signalingSession.participantManager.localParticipant.isStaging;
                                if (11 === this.state) this.setCallState(12, v);
                                else if (this._callOperationHandler.hasPendingOperation("JoinPreheatedCall")) _.info("wait for joinPreheatedCall to resolved");
                                else if (this._callInLobby) _.info("[inLobby] Override Connected state from signaling agent"), this.setCallState(10, v);
                                else if (f) this.setCallState(13, v);
                                else {
                                    if (3 === this.state && !this._callOperationHandler.hasPendingOperation("_CallStartOrJoinInitiated") && !this._callOperationHandler.hasPendingOperation("_ConnectCall")) return void _.info("Return: Don't re-send setup telemetry if call was already connected and operations are completed");
                                    this.setCallState(3, v), this.handleRemoteParticipantStateInOneToOneCall(v);
                                }
                                this._callOperationHandler.maybeResolveOperation("_CallStartOrJoinInitiated", void 0, void 0, v), this._callOperationHandler.maybeResolveOperation("_ConnectCall", void 0, void 0, v), this.reportTsCallingTelemetry(!0);
                            } else if (g === f.LOCAL_TERMINATED || g === f.REMOTE_TERMINATED) {
                                var _this_mediaSession;
                                let C = this.callSetupFailed ? 7 : convertReason(S);
                                if (8 === this.state && this._callOperationHandler.hasAtleastOneOfPendingOperation([
                                    "StartCall",
                                    "JoinCall",
                                    "StartWithMeetingData",
                                    "JoinWithMeetingData"
                                ])) return this.signalingSession.resetState(), this._callOperationHandler.maybeRejectOperation("Subscribe", C, void 0, v), this._callOperationHandler.maybeRejectOperation("SubscribeWithMeetingData", C, void 0, v), void _.info("Subscribe failed, there is pending start/join operation, ignore call end message");
                                if (1 !== C && (S === null || S === void 0 ? void 0 : S.code) === Li.MediaError && (S === null || S === void 0 ? void 0 : S.subCode) === Fi.MediaPermissionError && (C = 58, _.info(`[terminated][reason=${safeJsonStringify(S)}]`)), (2 === this.state || 6 === this.state || 8 === this.state) && this._callOperationHandler.hasAtleastOneOfPendingOperation([
                                    "StartCall",
                                    "JoinCall",
                                    "StartWithMeetingData",
                                    "JoinWithMeetingData",
                                    "Subscribe",
                                    "SubscribeWithMeetingData"
                                ])) {
                                    const g = {
                                        code: this.callEndDiagnosticsInfo.callControllerCode,
                                        subCode: this.callEndDiagnosticsInfo.callControllerSubCode,
                                        phrase: this.callEndDiagnosticsInfo.phrase,
                                        reason: C
                                    };
                                    this._callOperationHandler.maybeRejectOperations([
                                        "Accept",
                                        "JoinCall",
                                        "JoinWithMeetingData",
                                        "JoinPreheatedCall",
                                        "StartCall",
                                        "StartCallAndUnpark",
                                        "StartCallToVoiceMail",
                                        "StartCallWithNudge",
                                        "StartWithMeetingData",
                                        "Subscribe",
                                        "SubscribeWithMeetingData"
                                    ], C, void 0, v, g);
                                }
                                this.signalingSession.acceptedElsewhereBy && (this.acceptedElsewhereBy = {
                                    id: this.signalingSession.acceptedElsewhereBy.id,
                                    displayName: this.signalingSession.acceptedElsewhereBy.displayName
                                }), this.signalingSession.parkAdditionalContextJson && (this.parkAdditionalContextJson = this.signalingSession.parkAdditionalContextJson), this.signalingSession.serverHoldLocation && (this.serverHoldLocation = this.signalingSession.serverHoldLocation), this._callOperationHandler.hasPendingOperation("CallParkV2") && S.pickupCode && 0 === S.code && this._callOperationHandler.resolveOperation("CallParkV2", "" + S.pickupCode, void 0, v), 1 !== C && this.mediaRelayWhiteListingIssue && (C = 53, _.info(`[terminated][reason=${safeJsonStringify(S)}]`)), this._callOperationHandler.maybeRejectOperation("CallParkV2", C, "", v), this._callOperationHandler.maybeRejectOperation("_WaitForAnswer", C, "", v), this._callOperationHandler.maybeRejectOperation("_ConnectCall", C, "", v);
                                const E = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.setDisconnectAfterCleanUp;
                                if (E ? this.setTerminatedReason(C) : this.setCallState(7, v, C), this.participants.forEach((g)=>g.setState(4, void 0, v)), !this.disconnectingPromise) {
                                    const C = {
                                        ...S,
                                        remoteTerminated: g === f.REMOTE_TERMINATED
                                    };
                                    this.disconnectingPromise = this.cleanUp(v, C).catch((g)=>{
                                        _.logFailure(`Error when cleaning up the call, callId = ${this.callId}, error = ${g}`);
                                    });
                                }
                                E && this.disconnectingPromise.finally(()=>{
                                    7 !== this.state && this.setCallState(7, v, C);
                                });
                            }
                        },
                        onOffer: (g, f = generateCauseId())=>{
                            var _g_transferor_details, _g_transferor, _g_transferor1, _g_transferor_details1, _g_transferor2;
                            const S = this.logger.createFnLogger("onOffer", f);
                            S.info(`${safeJsonStringify((0, zi.omit)(scrubObjectFields(g), "mediaContent", "remoteParticipantId"))}`), this.setMediaLegId(g.mediaContent.mediaLegId), this.callTelemetry.recordEvent("_WebOnOffer", this.prepareTelemetryForOfferAnswer(g), f), ((_g_transferor = g.transferor) === null || _g_transferor === void 0 ? void 0 : (_g_transferor_details = _g_transferor.details) === null || _g_transferor_details === void 0 ? void 0 : _g_transferor_details.id) && this.setTransferorMri(g.transferor.details.id), ((_g_transferor1 = g.transferor) === null || _g_transferor1 === void 0 ? void 0 : _g_transferor1.transferorType) && (this.transferorType = g.transferor.transferorType), ((_g_transferor2 = g.transferor) === null || _g_transferor2 === void 0 ? void 0 : (_g_transferor_details1 = _g_transferor2.details) === null || _g_transferor_details1 === void 0 ? void 0 : _g_transferor_details1.displayName) && (this.transferorDisplayName = g.transferor.details.displayName), this.clientTransferContext = g.clientTransferContext, this.customHeaderContext = g.customHeaderContext, this.invitationData = g.invitationData, this.spamRiskLevel = g.riskLevel, this.spamStirAttestation = g.stirAttestation, g.mediaContent.isTwoPartyToMultiPartyEscalation && this.setIsEscalationInProgress(!0, f), g.renegotiation ? this.requestedHoldState && this._pendingParkPromise ? this.renegotiateIncoming(g.mediaContent, f) : this._delayedElevationPending || this._delayedElevationQueued ? (this.signalingSession.rejectRenegotiationAsync({}, f), this.triggerDelayedReconnectIfNeeded(f, "onOffer")) : this._callOperationHandler.executeChained(()=>this.renegotiateIncoming(g.mediaContent, f), "_RenegotiateIncoming", f, f, void 0, void 0, {
                                preconditionTags: [
                                    "NOT_SUPPORTED_IN_STREAMING_MODE"
                                ]
                            }) : (S.info("resolving attach / offer promise"), this.attachToCallAndGetOffer.resolve(g.mediaContent));
                        },
                        onNewOffer: (g, f = generateCauseId())=>{
                            const S = this.logger.createFnLogger("onNewOffer", f);
                            this.newOfferRequestDeferred ? (S.info("onNewOffer"), this.newOfferRequestDeferred.resolve(g.mediaContent)) : S.info("callback received but new offer was not requested");
                        },
                        onAnswer: (g, f = generateCauseId())=>{
                            const S = this.logger.createFnLogger("onAnswer", f);
                            if (S.info(`${safeJsonStringify((0, zi.omit)(g, "mediaContent", "remoteParticipantId"))}`), this.setMediaLegId(g.mediaContent.mediaLegId), this.callTelemetry.recordEvent("_WebOnAnswer", this.prepareTelemetryForOfferAnswer(g), f), g.renegotiation) S.info("resolving previous renegotiation promise"), this.renegotiationAnswerDeferred.resolve(g.mediaContent);
                            else if (S.info("resolving final answer promise"), g.provisional) {
                                const S = this.isOneToOnePSTNCall() && (0, zi.startsWith)(g.remoteParticipantId, sr);
                                this.mediaSession.processAnswerAsync(g.mediaContent, f, !0, S);
                            } else this._callOperationHandler.maybeResolveOperation("_WaitForAnswer", g.mediaContent, void 0, f), this.handleRemoteParticipantStateInOneToOneCall(f);
                            g.provisional || !g.mediaContent.fromMixer || this.callUsesMixer || this._callOperationHandler.executeChained(async ()=>{
                                this.setCallUsesMixer(!0, f), this.mediaStateConfigurationHelper.isDisabled(2) && this.mediaStateConfigurationHelper.removeModality(2), await this.updateMediaModalities(void 0, f);
                                const g = !(this.isSomeoneSharing || this.isScreenSharingOn || this.isVideoOn);
                                return (this.isOneToOnePSTNCall() ? this.mediaSession.getSessionConfig().config.callElevationDelayReconnectPSTN : this.mediaSession.getSessionConfig().config.callElevationDelayReconnect) && g ? (S.info("Delayed elevation: pending"), this._delayedElevationPending = !0, Promise.resolve()) : this.mediaSession.reconnectAsync(f, !0);
                            }, "_CallEscalatedToConference", f, f, void 0, void 0, {
                                preconditionTags: [
                                    "NOT_SUPPORTED_IN_STREAMING_MODE"
                                ]
                            });
                        },
                        onMediaAcknowledgementSuccess: (g, f = generateCauseId())=>{
                            this.logger.info(`isRenegotiation: ${g}`, "onMediaAcknowledgementSuccess", f), this._callOperationHandler.resolveOperation("_MediaAcknowledgment", void 0, void 0, f);
                        },
                        onMediaAcknowledgementFailure: (g, f, S = generateCauseId())=>{
                            this.logger.createFnLogger("onMediaAcknowledgementFailure", S).logFailure(safeJsonStringify(f)), this._callOperationHandler.rejectOperation("_MediaAcknowledgment", f, S);
                        },
                        onMediaRenegotiationRejection: (g, f = generateCauseId())=>{
                            this.logger.createFnLogger("onMediaRenegotiationRejection", f).logFailure(safeJsonStringify(g)), this.renegotiationAnswerDeferred.reject(g);
                        },
                        onRosterHandlingComplete: ()=>{
                            this.logger.info(`[onRosterHandlingComplete] ${this._publishedStatesModified}`), 0 !== this._publishedStatesModified && (this.processPublishedStates(), this._publishedStatesModified = 0);
                        },
                        onMeetingGroupDetailsUpdated: (g, f = generateCauseId())=>{
                            this.meetingGroupDetails !== g && (this.callTelemetry.recordEvent("_UpdateMeetingGroupDetails", g, f), this.logger.info(`[${f}][onMeetingGroupDetailsUpdated] update meetingGroupDetails from ${JSON.stringify(this.meetingGroupDetails)} to ${JSON.stringify(g)}`), this.meetingGroupDetails = g, this.raiseChanged());
                        },
                        onSelfParticipantUpdated: (g, f = generateCauseId())=>{
                            this.logger.info(`[${f}][onSelfParticipantUpdated]`), this.updateLocalParticipant(g, f), this.raiseChanged();
                        },
                        onParticipantMriUpdated: (g, f, S = generateCauseId())=>{
                            this.logger.info(`[${S}][onParticipantMriUpdated]`);
                            const v = this.getParticipant(g);
                            v && (v.id = f, this.raiseChangedDeferred());
                        },
                        onParticipantUpdated: (g, f = generateCauseId())=>{
                            this.logger.info(`[${f}][onParticipantUpdated]: ${scrubSignalingParticipant(g)}`);
                            const S = this.getOrCreateParticipant(g.id, f, !0);
                            S.displayName = g.displayName;
                            const v = _PluginlessCall.getStreamsFromEndpoints(g.endpointDetails), _ = (0, zi.some)(g.endpointDetails, (g)=>g === null || g === void 0 ? void 0 : g.streamInformation);
                            this.callUsesMixer || v.length > 0 || _ ? (this.updateParticipantStreams(S, g, v, f), this.updateCallParticipantFromSignalingParticipant(S, g, f)) : S.setState(3, void 0, f), S.processParticipantDetails(g, this.getSelfClientEndpointCapabilities(), ()=>{
                                var _this_signalingSession;
                                (_this_signalingSession = this.signalingSession) === null || _this_signalingSession === void 0 ? void 0 : _this_signalingSession.setStreamInformationReceived();
                            }), this.updatePublishedStates(g), this.calculateIsSomeoneStreaming(f), this.raiseChangedDeferred();
                        },
                        onParticipantRemoved: (g, f = generateCauseId(), S = !1)=>{
                            if (this.logger.info(`[${f}][onParticipantRemoved]`), S) {
                                const S = this.getParticipant(g.id);
                                this.callTelemetry.recordOperationSuccess("_ParticipantJoined", null, S === null || S === void 0 ? void 0 : S.id, f, {
                                    participantJoinedButReplaced: "Participant joined with original MRI and replaced with participant of RNL MRI"
                                });
                            } else this.callTelemetry.recordOperationSuccess("RemoveParticipant", null, g.id, f), this._participantOperationHandler.maybeRejectOperation("AddParticipant", 1, g.id, f);
                            this._removeParticipant(g, f), this.removePublishedStatesByParticipant(g.id), this.calculateIsSomeoneStreaming(f);
                        },
                        onParticipantJoined: (g, f = generateCauseId())=>{
                            this.logger.info(`[${f}][onParticipantJoined]`);
                            const S = !this.getParticipant(g.id), v = this.getOrCreateParticipant(g.id, f, !1);
                            v.displayName = g.displayName, 0 === v.state && v.setState(1, void 0, f);
                            const _ = _PluginlessCall.filterVirtualEndpoints(g.endpointDetails), C = _PluginlessCall.getStreamsFromEndpoints(_), E = (0, zi.some)(g.endpointDetails, (g)=>g === null || g === void 0 ? void 0 : g.streamInformation);
                            this.callUsesMixer || C.length > 0 || E ? (this.updateParticipantStreams(v, g, C, f), this.updateCallParticipantFromSignalingParticipant(v, g, f), this.calculateIsSomeoneStreaming(f)) : (this.handleRemoteParticipantJoinedInOneToOneCall(g, f), this.handleRemoteParticipantStateInObservingCall(v, g, f), g.acceptedBy && g.acceptedBy !== g.id && (v.acceptedBy = g.acceptedBy)), this.callTelemetry.recordOperationSuccess("_ParticipantJoined", getEndpointInformationForTelemetry(g.endpointDetails), v.id, f), v.processParticipantDetails(g, this.getSelfClientEndpointCapabilities(), ()=>{
                                var _this_signalingSession;
                                (_this_signalingSession = this.signalingSession) === null || _this_signalingSession === void 0 ? void 0 : _this_signalingSession.setStreamInformationReceived();
                            }), this.updatePublishedStates(g), S && this.event("participantAdded").raise(v), this.raiseChangedDeferred();
                        },
                        onCallModeChanged: (g, f)=>{
                            var _this_promotionCompletedDeferred;
                            this.callTelemetry.recordEvent("_CallModeChanged", {
                                newCallMode: g,
                                oldCallMode: this._callMode
                            }, f), this.logger.info(`onCallModeChanged[${f}]: new=${g} old=${this._callMode} `), g && this._callMode !== g && (this._callMode = g, this.isCallModeStreaming() && this.cleanUpDueToStreaming(f), 1 === this._callMode && (this.participants.forEach((g)=>{
                                g.applyCachedMediaStreams(f);
                            }), (_this_promotionCompletedDeferred = this.promotionCompletedDeferred) === null || _this_promotionCompletedDeferred === void 0 ? void 0 : _this_promotionCompletedDeferred.resolve()), this.monitorCallStart(), this.updateCapabilities(f), this.raiseChanged());
                        },
                        getRemoteParticipantCollection: ()=>this.participants.map((g)=>g.toCafeParticipant()),
                        onReTargetCompletedSuccess: (g)=>{
                            const f = this.logger.createFnLogger("onReTargetCompletedSuccess", g);
                            f.info(`started, isEscalationInProgress=${this.isEscalationInProgress}`), this.callTelemetry.recordEvent("_WebRetargetSuccess", void 0, g), this.callStats.localStats.call.event(3);
                            const S = this.isEscalationInProgress;
                            this.screenSharingControl && this.screenSharingControl.shutdownControlForViewer(), this.updateSignalingDSHMessageSubscription(this.isInitialSignalingDSHSubscriptionEnabled()), this.mediaSession.completeEscalationAsync(g).then(()=>(f.logSuccess("completeEscalationAsync"), this.callTelemetry.recordEvent("_WebOnEscalationSuccess", void 0, g), this.handleCallEscalation(S, g), this.updateMediaStatus(g))).catch((S)=>{
                                f.logFailure(`completeEscalationAsync, error=${getPrintableObject(S)}`), this.setIsEscalationInProgress(!1, g), this.callTelemetry.recordEvent("_WebOnEscalationFailure", getPIISafeObject(S), g), this.stopInternal({
                                    causeId: g,
                                    terminatedReason: 47
                                });
                            });
                        },
                        onReTargetCompletedFailure: (g, f)=>{
                            this.logger.createFnLogger("onReTargetCompletedFailure", f).logFailure(`reason=${getPrintableObject(g)}, isEscalationInProgress=${this.isEscalationInProgress}`), this.callTelemetry.recordEvent("_WebRetargetFailure", getPIISafeObject(g), f), this.isEscalationInProgress && (this.setIsEscalationInProgress(!1, f), this.setCallUsesMixer(!1, f), this.updateMediaStatus(f)), this.callStats.localStats.call.event(4), this.mediaSession.rejectEscalationAsync(g, f);
                        },
                        onChatModalitySetupFailed: (g)=>{
                            this.logger.debug(`onChatModalitySetupFailed: ${g}`);
                        },
                        onConversationUpdated: (g, f)=>{
                            this.logger.info(`onConversationUpdated[${f}]: ${JSON.stringify(scrubObjectFields(g, [
                                "organizerId",
                                "meetingData"
                            ]))}`), this.setConversationType(g.conversationType, f), this._onMessageIdChanged(g.teamsMessageId, f), this.setGroupId(g.groupId, f), this.setThreadId(g.threadId, f), this.setBackroomThreadId(g.backroomThreadId, f), this.setStreamThreadId(g.streamThreadId, f), this.setLobbyThreadId(g.lobbyThreadId, f), this.setCallType(g.isMultiParty ? 2 : 1, f), this._commandUrlPresence = g.commandUrlPresence, this.updateCapabilities(f), this.region = g.region, this.setMeetingData(g.meetingData), this.meetingInfo = g.meetingInfo, this.callLimits = g.callLimits, this.setComplianceRecordingContent(f, g.complianceRecordingContent), this.setHuddleGroupCall(g.isHuddleGroupCall), this.onConversationStartTimeChanged(g.conversationStartTime, f), this.raiseChanged();
                        },
                        onMeetingDetailsUpdated: (g)=>{
                            var _this_meetingDetails_meetingCapability;
                            this.meetingDetails = g, this.mediaSession && !this.enableRealtimeTelemetry && ((_this_meetingDetails_meetingCapability = this.meetingDetails.meetingCapability) === null || _this_meetingDetails_meetingCapability === void 0 ? void 0 : _this_meetingDetails_meetingCapability.enableRealtimeTelemetry) && (this.mediaSession.enableTeamsRealTimeTelemetry(), this.enableRealtimeTelemetry = !0), this.raiseChanged();
                        },
                        onMeetingStatesUpdated: (g)=>{
                            (0, zi.isEqual)(g, this.meetingStates) || (this.meetingStates = g, this.logger.info(`[onMeetingStatesUpdated] meetingStates updated to ${JSON.stringify(this.meetingStates)}`), this.raiseChanged());
                        },
                        onParticipantCountsUpdated: (g)=>{
                            var _this_mediaSession;
                            (0, zi.isEqual)(g, this.participantCounts) || (this.participantCounts = {
                                ...fi,
                                ...g
                            }, this.event("participantCountsUpdated").raise(this.participantCounts), (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.processNotification("ParticipantCountChanged", {
                                count: g.totalParticipants
                            }));
                        },
                        updateIsSharedLineAppearanceV2Activated: (g)=>{
                            this.isSharedLineAppearanceV2Activated !== g && (this.logger.info(`_updateIsSharedLineAppearanceV2Activated: new value is ${g}`), this.isSharedLineAppearanceV2Activated = g, this.event("sharedLineAppearanceV2ActivatedChanged").raise(this.isSharedLineAppearanceV2Activated));
                        },
                        onBroadcastMeetingUpdated: (g)=>{
                            g && (this.broadcastMeeting && this.broadcastMeeting.metadataChanged(JSON.stringify(g)), this.broadcastMetadata = g, this.raiseChanged());
                        },
                        onBroadcastMeetingConnected: (g, f)=>{
                            this.logger.info(`[${f}][onBroadcastMeetingConnected]`), this._callOperationHandler.hasPendingOperation("AddBroadcastModality") && (0 === g.code ? this._callOperationHandler.resolveOperation("AddBroadcastModality", g, f) : this._callOperationHandler.rejectOperation("AddBroadcastModality", g, f));
                        },
                        onBroadcastMeetingEnded: (g, f)=>{
                            this.logger.info(`[${f}][onBroadcastMeetingEnded]`), this._callOperationHandler.hasPendingOperation("AddBroadcastModality") && this._callOperationHandler.rejectOperation("AddBroadcastModality", g, f), this.signalingSession.endBroadcastMeeting(f);
                        },
                        onTransferRequested: (g, f)=>{
                            const S = this.logger.createFnLogger("onTransferRequested", f);
                            S.info("Transfer: onTransferRequested, target participant", scrubSignalingParticipant(g.target));
                            let v = "", _ = "", C = 0;
                            "voicemail" === g.target.endpointType && (C = 2);
                            try {
                                v = g.target.id, _ = g.transferor.details.id, g && g.parkType && "none" !== g.parkType && (C = 1);
                            } catch (g) {
                                return S.logFailure(g), this.callTelemetry.recordEvent("_OnTransferRequestedInvalid"), void this.signalingSession.signalTransferCompletedAsync({
                                    code: getCSAEndCode(7)
                                });
                            }
                            const E = this.convertToTransferType(C, g.parkType), T = {
                                transferContext: {
                                    transferorMri: _,
                                    targetMri: v,
                                    transferType: C,
                                    context: {
                                        target: g.target,
                                        transferor: g.transferor,
                                        transferContext: g.transferContext,
                                        newCallModalities: g.newCallModalities,
                                        links: g.links,
                                        replacementDetails: g.replacementDetails,
                                        isConsultative: g.isConsultative,
                                        callAcceptanceCallback: ()=>{
                                            S.logSuccess("Transfer: callAcceptanceCallback called"), this.signalingSession.signalTransferAcceptedAsync(E);
                                        }
                                    }
                                },
                                onCompleted: (g)=>{
                                    S.logSuccess("Transfer: onCompleted called"), this.signalingSession.signalTransferCompletedAsync({
                                        code: getCSAEndCode(g)
                                    });
                                }
                            };
                            this.callTelemetry.recordEvent("_OnTransferRequested", {
                                transferType: C
                            }), this.event("transferRequested").raise(T);
                        },
                        onTransferredCallAcceptance: (g)=>{
                            const f = this.logger.createFnLogger("onTransferredCallAcceptance", g);
                            this._transferredCallAcceptanceCallback && (f.info("[Transfer] Invoke call acceptance callback for original call"), this._transferredCallAcceptanceCallback());
                        },
                        onTransferAccepted: (g)=>{
                            this.logger.info("Transfer: onTransferAccepted"), this._callOperationHandler.hasPendingOperation("_CallTransferInProgress") && this._setTransferState(2), this._callOperationHandler.hasPendingOperation("BlindTransfer") && this._callOperationHandler.maybeResolveOperation("_CallTransferInProgress", void 0, void 0, g), this._callOperationHandler.hasPendingOperation("ParkCall") && this._setParkState(2);
                        },
                        onTransferCompleted: (g, f)=>{
                            const S = this.logger.createFnLogger("onTransferCompleted", f);
                            S.info("Transfer: onTransferCompleted");
                            const v = g.transferCompletion, _ = convertReason(v);
                            if (v && (S.info(`Transfer: Call Transfer Code: ${v.code}`), 0 === v.code)) {
                                var _g_unparkContent_CallParkAdditionalContext, _g_unparkContent, _g_unparkContent1;
                                if (this._callOperationHandler.hasPendingOperation("_CallTransferInProgress") && (this._callOperationHandler.resolveOperation("_CallTransferInProgress", void 0, void 0, f), this._setTransferState(3)), this._callOperationHandler.hasPendingOperation("ConsultativeTransferWithPickupCode")) {
                                    const g = {
                                        code: 0,
                                        subCode: 0,
                                        phrase: "TransactionComplete"
                                    };
                                    this._callOperationHandler.resolveOperation("ConsultativeTransferWithPickupCode", g, void 0, f), this._setTransferState(3);
                                }
                                this._callOperationHandler.hasPendingOperation("ParkCall") && (((_g_unparkContent = g.unparkContent) === null || _g_unparkContent === void 0 ? void 0 : (_g_unparkContent_CallParkAdditionalContext = _g_unparkContent.CallParkAdditionalContext) === null || _g_unparkContent_CallParkAdditionalContext === void 0 ? void 0 : _g_unparkContent_CallParkAdditionalContext.ConversationControllerLocation) && (this.serverHoldLocation = g.unparkContent.CallParkAdditionalContext.ConversationControllerLocation), void 0 !== ((_g_unparkContent1 = g.unparkContent) === null || _g_unparkContent1 === void 0 ? void 0 : _g_unparkContent1.pickupCode) ? (this._callOperationHandler.resolveOperation("ParkCall", g.unparkContent.pickupCode, void 0, f), S.logSuccess(`pickupCode=${g.unparkContent.pickupCode}`), this._setParkState(3)) : (this._callOperationHandler.rejectOperation("ParkCall", 32, f), S.logFailure(`terminatedReason=${_}`), this._setParkState(4)));
                            } else {
                                if (this._callOperationHandler.hasPendingOperation("_CallTransferInProgress") && (this._callOperationHandler.rejectOperation("_CallTransferInProgress", _, void 0, f), S.logFailure(`terminatedReason=${_}`), this.transferDiagnosticsInfo = {
                                    callControllerCode: v.code,
                                    callControllerSubCode: v.subCode,
                                    phrase: v.phrase,
                                    resultCategories: v.resultCategories
                                }, this._setTransferState(4)), this._callOperationHandler.hasPendingOperation("ConsultativeTransferWithPickupCode")) {
                                    const g = {
                                        code: v.code,
                                        subCode: v.subCode,
                                        resultCategories: v.resultCategories
                                    };
                                    this._callOperationHandler.rejectOperation("ConsultativeTransferWithPickupCode", g, void 0, f);
                                }
                                this._callOperationHandler.hasPendingOperation("ParkCall") && (this._callOperationHandler.rejectOperation("ParkCall", _, void 0, f), S.logFailure(`terminatedReason=${_}`), this.transferDiagnosticsInfo = {
                                    callControllerCode: v.code,
                                    callControllerSubCode: v.subCode,
                                    phrase: v.phrase,
                                    resultCategories: v.resultCategories
                                }, this._setParkState(4));
                            }
                        },
                        onParkCompleted: (g, f)=>{
                            var _g_unparkContent, _g_unparkContent1, _g_unparkContent_CallParkAdditionalContext, _g_unparkContent2;
                            this.logger.createFnLogger("onParkCompleted", f).info(`transactionEnd ${getPrintableObject(g)}`), this._callOperationHandler.hasPendingOperation("CallParkV2") ? 0 === g.code && void 0 !== ((_g_unparkContent = g.unparkContent) === null || _g_unparkContent === void 0 ? void 0 : _g_unparkContent.pickupCode) ? (this._callOperationHandler.resolveOperation("CallParkV2", "" + ((_g_unparkContent1 = g.unparkContent) === null || _g_unparkContent1 === void 0 ? void 0 : _g_unparkContent1.pickupCode), void 0, f), this.callTelemetry.maybeRecordOperationSuccess("CallParkV2"), this.serverHoldLocation = (_g_unparkContent2 = g.unparkContent) === null || _g_unparkContent2 === void 0 ? void 0 : (_g_unparkContent_CallParkAdditionalContext = _g_unparkContent2.CallParkAdditionalContext) === null || _g_unparkContent_CallParkAdditionalContext === void 0 ? void 0 : _g_unparkContent_CallParkAdditionalContext.ConversationControllerLocation, this.parkAdditionalContextJson = JSON.stringify(g.unparkContent.CallParkAdditionalContext)) : this._callOperationHandler.rejectOperation("CallParkV2", g, f) : this._callOperationHandler.hasPendingOperation("ParkCall") && (0 === g.code ? (this._callOperationHandler.resolveOperation("ParkCall", "", void 0, f), this._setParkState(3)) : (this._callOperationHandler.rejectOperation("ParkCall", g, f), this._setParkState(4)));
                        },
                        onUnparkCompleted: (g, f)=>{
                            this.logger.createFnLogger("onUnparkCompleted", f).info(`transactionEnd ${getPrintableObject(g)}`), this._callOperationHandler.hasPendingOperation("UnparkCall") && (0 === g.code ? this._callOperationHandler.resolveOperation("UnparkCall", g, void 0, f) : this._callOperationHandler.rejectOperation("UnparkCall", g, f));
                        },
                        onIncomingCallReplacement: (g, f)=>{
                            const S = this.logger.createFnLogger("onIncomingCallReplacement", f);
                            this.callTelemetry.recordEvent("_onIncomingCallReplacement", {}, f), g.callNotification.callType = "replaces", g.callNotification.consultativeCallId = this.callId, S.info(`consultativeCallId=${this.callId}`), g.body = {
                                gp: g,
                                evt: Bi.INCOMING_SKYPE_NGC_CALL,
                                nsp: void 0
                            }, this.event("replacementRequested").raise(g);
                        },
                        onContentSharingStopped: (g)=>{
                            this.logger.debug("ScreenSharing: onContentSharingStopped");
                            for (const f of this.contentSharingSessions)f.contentSharingGuid === g.correlationId && (f.contentSharingStatus = 7);
                        },
                        onContentSharingStarted: (g)=>{
                            this.logger.debug("ScreenSharing: onContentSharingStarted");
                            const f = new ua(this.callTelemetry, this.logger.createChild("ContentSharingSession"), this.signalingSession, g.correlationId || generateGuid(), g.contentIdentifier, g.sessionState, g.subject, g.sessionId);
                            f.contentSharingStatus = 2, this.contentSharingSessions.push(f), f.changed(()=>this.removeContentSessionIfEnded(f)), this.event("contentSharingChanged").raise();
                        },
                        onContentSharingUpdated: (g)=>{
                            this.logger.debug("ScreenSharing: onContentSharingUpdated");
                            const f = (0, zi.find)(this.contentSharingSessions, (f)=>f.contentSharingGuid === g.correlationId);
                            f ? (g.presenter && (f.presenterId = g.presenter), g.subject && f.subject !== g.subject && (f.subject = g.subject), g.sessionState && f.contentSharingState !== g.sessionState && (f.contentSharingState = g.sessionState), 3 === f.contentSharingStatus && this.localSignalingParticipant.id !== g.presenter ? f.contentSharingStatus = 5 : 5 === f.contentSharingStatus && this.localSignalingParticipant.id === g.presenter && (f.contentSharingStatus = 3)) : this.logger.warn("onContentSharingUpdated: session not found");
                        },
                        onWebRtcMediaNotification: (g, f)=>{
                            var _this_mediaSession;
                            (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.processNotification(g, f);
                        },
                        onCorrelationIdUpdated: (g, f)=>this.checkForCallIdUpdate(g, f),
                        onUnmuteRequested: (g)=>{},
                        onCallForwarded: (g)=>{
                            g && g.destinationType !== this.forwardingDestinationType && (this.forwardingDestinationType = g.destinationType, this.raiseChanged());
                        },
                        onPSTNBalanceUpdate: (g)=>{},
                        isOneToOnePstnCall: ()=>this.isOneToOnePSTNCall(),
                        onUpdateMeetingLiveStateCompleted: (g, f, S)=>{
                            this.logger.info(`[onUpdateMeetingLiveStateCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "UpdateMeetingLiveState", S);
                        },
                        onUpdateMeetingStatesCompleted: (g, f, S)=>{
                            this.logger.info(`[onUpdateMeetingStatesCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "UpdateMeetingStates", S);
                        },
                        onUpdateMeetingGroupsCompleted: (g, f, S)=>{
                            this.logger.info(`[onUpdateMeetingGroupsCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "UpdateMeetingGroups", S);
                        },
                        onSetMeetingLayoutCompleted: (g, f, S)=>{
                            this.logger.info(`[onSetMeetingLayoutCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "SetMeetingLayout", S);
                        },
                        onJoinMeetingGroupCompleted: (g, f, S)=>{
                            this.logger.info(`[onJoinMeetingGroupCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "JoinMeetingGroup", S);
                        },
                        onLeaveMeetingGroupCompleted: (g, f, S)=>{
                            this.logger.info(`[onJoinMeetingGroupCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "LeaveMeetingGroup", S);
                        },
                        onBreakoutDetailsUpdated: (g, f)=>{
                            this.logger.info(`[onBreakoutDetailsUpdated] [${f}]`), this.breakoutDetails = g, this.raiseChanged();
                        },
                        onIncomingProxiedMessages: (g, f)=>{
                            this.logger.info(`[onIncomingProxiedMessages] [${f}] payload ${getPrintableObject(g, !0)}`), this.event("incomingProxiedMessages").raise(g);
                        },
                        onUpdateParticipantsPropertiesCompleted: (g, f, S)=>{
                            this.logger.createFnLogger("onUpdateParticipantsPropertiesCompleted", S).info(`promisesToResolve ${scrubMriOrOmit(safeJsonStringify(g))}`);
                            for (const f of Object.keys(g))g[f].code === Ii.CODE.SUCCESS ? this._callOperationHandler.maybeResolveOperation("UpdateParticipantsProperties", g[f], f, S) : this._callOperationHandler.maybeRejectOperation("UpdateParticipantsProperties", g[f], f, S);
                        },
                        onUpdateMonitorSessionCompleted: (g, f)=>{
                            this.logger.info(`[onUpdateMonitorSessionCompleted] [${f}] transactionEnd ${getPrintableObject(g)}`), this.onOperationCompleteCommonHandler(g, f, "UpdateMonitorSession");
                        },
                        onNudgeToJoinRealtime: (g)=>{
                            this.logger.info("[onNudgeToJoinRealtime]", g), this.callTelemetry.recordEvent("NudgeToJoinRealTime", g), this.canPromoteToRealTime(1) && this.promoteToRealtime(1, g).then(()=>this.logger.info(`[onNudgeToJoinRealtime][${g}] completed`)).catch((f)=>this.logger.info(`[onNudgeToJoinRealtime][${g}] failed to auto promote: ${getPrintableObject(f)}`));
                        },
                        onConversationTypeUpdated: (g, f)=>{
                            this.logger.info(`[onConversationTypeUpdated] [${f}] conversationType ${g}`), this.setConversationType(g, f);
                        }
                    };
                    const S = Object.create(this.localSignalingParticipant);
                    this.signalingSession = this.signalingAgent.getNewSignalingSession(S, this.signalingNotifications, this.callId, this._callCreationTime), this.signalingSession.participantManager.setEnableMuteAsync(this._enableMuteAsync), this.signalingSession.participantManager.setEnableUnmuteAsync(this._enableUnmuteAsync), this.accountConfiguration && this.accountConfiguration.deviceType && this.signalingSession.setDeviceType(this.accountConfiguration.deviceType), this.setCallId(this.callId || this.signalingSession.correlationId), this.signalingSession.participantManager && this.signalingSession.participantManager.localParticipant && (this.setDisplayName(this.signalingSession.participantManager.localParticipant.displayName), this.setEndpointId(this.signalingSession.participantManager.localParticipant.endpointId), this.setParticipantId(this.signalingSession.participantManager.localParticipant.participantId), this.callStats.setParticipantId(this.participantId));
                }
                updateParticipantStreams(g, f, S, v) {
                    const _ = _PluginlessCall.getNegotiationTagsFromEndpoints(f.endpointDetails);
                    g.updateStreams(S, v, this.isCallModeStreaming(), _);
                    const C = this.getStreamInformationMap(f);
                    this.logger.info(`[updateParticipantStreams]: streaming mode with new streamInfoMap: ${safeJsonStringify(C)}`);
                    const E = {
                        callId: this.callId,
                        participantId: this.participantId,
                        endpointId: this.endpointId
                    };
                    this.meetingData && (E.meetingId = this.meetingData.meetingCode);
                    const T = this.telemetryLoggers ? this.telemetryLoggers.tlePlayer : null;
                    g.useUmsStream(C, this._liveStreamConfigProvider, E, this.threadId, T, v);
                }
                cleanUpDueToStreaming(g) {
                    var _this_renegotiationAnswerDeferred, _this_newOfferRequestDeferred;
                    this.logger.info(`cleanUpDueToStreaming[${g}]: cleaning streams and media and canceling cc operations`), this.cancelAllCallingOperationsDueToStreaming(g);
                    const f = {
                        code: Li.Success,
                        subCode: Fi.DowngradeToStreamingClient,
                        phrase: ji.DowngradeToStreamingClient
                    };
                    this.participants.forEach((f)=>f.updateStreams([], g)), this.cleanUpMedia(g, f).then(()=>{
                        this.callTelemetry.recordOperationSuccess("_MediaCleanUp");
                    }).catch((f)=>{
                        this.callTelemetry.recordOperationFailure("_MediaCleanUp", {
                            error: getPIISafeObject(f)
                        }, g);
                    }).finally(()=>{
                        this.mediaDisposedPromise = null;
                    }), this.finishCallHoldResume(f), (_this_renegotiationAnswerDeferred = this.renegotiationAnswerDeferred) === null || _this_renegotiationAnswerDeferred === void 0 ? void 0 : _this_renegotiationAnswerDeferred.reject(f), (_this_newOfferRequestDeferred = this.newOfferRequestDeferred) === null || _this_newOfferRequestDeferred === void 0 ? void 0 : _this_newOfferRequestDeferred.reject(f), this._parkState = 0, this._transferState = 0, this.isServerMuted || (this._muteState = 0), this.isSpeakerMuted = !1, this.requestedHoldState = !1, this.isMuteOnHold = !1;
                }
                cancelAllCallingOperationsDueToStreaming(g) {
                    this._callOperationHandler.maybeRejectPendingOperationsWithPredicate(74, g, (g, f)=>(0, zi.some)(f === null || f === void 0 ? void 0 : f.preconditionTags, (g)=>"NOT_SUPPORTED_IN_STREAMING_MODE" === g));
                }
                onOperationCompleteCommonHandler(g, f, S, v) {
                    0 === g.code ? this._callOperationHandler.maybeResolveOperation(S, g, v, f) : this._callOperationHandler.maybeRejectOperation(S, g, v, f);
                }
                convertToTransferType(g, f) {
                    let S = "none";
                    return 1 === g && f && "none" !== f ? "teamPark" === f ? S = "TransferTypeTeamPark" : "sharedLinePark" === f ? S = "TransferTypeSharedLinePark" : "serverHold" === f && (S = "TransferTypeServerHold") : 0 === g ? S = "TransferTypeStandard" : 2 === g ? S = "TransferTypeVoicemail" : this.logger.info(`Irrelevant combination of transferTye: ${g} and parkType: ${f}`), S;
                }
                raiseChangedDeferred(g) {
                    (!this.raiseChangedDefer || this.raiseChangedDefer.isSkippable && !g) && (Ur.instance.runDeferredWithoutDedup(()=>{
                        delete this.raiseChangedDefer, this.raiseChanged(g);
                    }, "Call.raiseChanged"), this.raiseChangedDefer = {
                        isSkippable: !!g
                    });
                }
                static getStreamsFromEndpoints(g) {
                    if (!g) return [];
                    const f = _PluginlessCall.filterVirtualEndpoints(g);
                    return f.forEach((g)=>(0, zi.forEach)(g.mediaStreams, (f)=>{
                            f.participantId = g.participantId, f.endpointId = g.endpointId;
                        })), (0, zi.flatMap)(f, (g)=>g && g.mediaStreams || []);
                }
                preconditions(g, f) {
                    this.logger.info(`check call mode currentMode is ${this.callMode} operationName is ${g}`), (0, zi.some)(f, (g)=>"NOT_SUPPORTED_IN_STREAMING_MODE" === g) && this.isCallModeStreaming(!0);
                }
                mapCallSetupIntent(g) {
                    switch(g){
                        case 0:
                            return "None";
                        case 1:
                            return "AutoPromotion";
                        case 2:
                            return "PromotionWithAudio";
                        case 3:
                            return "PromotionWithVideo";
                        default:
                            return "Unknown";
                    }
                }
                async promoteToRealtime(g, f) {
                    this.logger.info(`[${f}][promoteToRealtime] started with intent=${g}`);
                    const S = this.getPromoteToRealtimeCallOptions(g, this.callOptions);
                    this.callTelemetry.updateOperationData("_PromotionToRealtime", {
                        intent: g
                    }, f), this.callTelemetry.recordEvent("StartPromotion", {
                        intent: this.mapCallSetupIntent(g)
                    }, f);
                    try {
                        this.promotionCompletedDeferred = new ct, await Promise.all([
                            this.joinOrStartCall(S, this.joinGivenConversation, f, void 0),
                            this.promotionCompletedDeferred.promise
                        ]);
                    } catch (g) {
                        throw this.logger.logFailure(`[${f}][promoteToRealtime] failed with reason=${getPrintableObject(g)}`), this.cleanUpDueToStreaming(f), this.signalingSession.cleanUpDueToStreaming(f), g;
                    }
                }
                async promoteToRealtimeAndUnmute(g) {
                    return this.logger.info(`[${g}][promoteToRealtimeAndUnmute]`), this.isPromotingToRealtime() ? (this.logger.info(`[${g}][promoteToRealtimeAndUnmute] already promoting to realtime.`), this._callOperationHandler.waitForOperation("_PromotionToRealtime").then(()=>this.muteUnmute(!1, g))) : this.canPromoteToRealTime(2) ? (this.unmutePendingPromise = new ct, setTimeout(()=>{
                        var _this_unmutePendingPromise;
                        (_this_unmutePendingPromise = this.unmutePendingPromise) === null || _this_unmutePendingPromise === void 0 ? void 0 : _this_unmutePendingPromise.reject("promoteToRealtime unmute timed out");
                    }, 1e3 * this.signalingSession.signalingAgentConfig.csaTimeoutConfiguration.promotionUnmuteTimeoutSec), Promise.all([
                        this.promoteToRealtime(2, g),
                        this.unmutePendingPromise.promise
                    ]).then(()=>{}).finally(()=>this.unmutePendingPromise = null)) : Promise.reject("manual promotion with audio is not allowed");
                }
                isPromotingToRealtime() {
                    return this._callOperationHandler.hasPendingOperation("_PromotionToRealtime");
                }
                getPromoteToRealtimeCallOptions(g, f) {
                    let S, v = 1;
                    1 === g ? S = {
                        value: !0,
                        mediaTypes: [
                            "audio"
                        ]
                    } : 3 === g ? (S = {
                        value: !0,
                        mediaTypes: [
                            "audio"
                        ]
                    }, v = 4) : 2 === g && (S = {
                        value: !1
                    });
                    const _ = {
                        ...f.callStartOptions,
                        sendMediaModalities: {
                            mediaStates: [
                                getMediaState(0, 4),
                                getMediaState(1, v)
                            ].filter((g)=>null != g)
                        },
                        preheatFlags: 0
                    };
                    return {
                        ...f,
                        callStartOptions: _,
                        applyServerMute: S,
                        isPromotingToRealtime: !0,
                        callStartTime: Date.now()
                    };
                }
                canPromoteToRealTime(g) {
                    const f = this.logger.createChild("[canPromoteToRealTime]");
                    return f.info(`[promoteType:${g}]`), this.isCallModeStreaming() ? this.isPromotingToRealtime() ? (f.info("already promoting to realtime"), !1) : 1 === g || 2 === g : (f.info("cant promote since call mode is not streaming"), !1);
                }
                isCallModeStreaming(g = !1) {
                    if (2 === this.callMode) {
                        if (!g) return !0;
                        throw this.logger.info("reject check callmode"), {
                            code: 499,
                            subCode: 3551,
                            phrase: "TransactionNotAllowedForStreamMode"
                        };
                    }
                    return !1;
                }
                setCallOptions(g) {
                    var _g_callStartOptions;
                    this.receiveOnlyAudioOnCallStart = !!((_g_callStartOptions = g.callStartOptions) === null || _g_callStartOptions === void 0 ? void 0 : _g_callStartOptions.receiveOnlyAudioOnCallStart), this.callOptions = g, this.logger.info(`callOptions: ${safeJsonStringify(scrubCallOptions(g))}`);
                }
                getSelfClientEndpointCapabilities() {
                    var _this_callOptions_callStartOptions, _this_callOptions;
                    return (_this_callOptions = this.callOptions) === null || _this_callOptions === void 0 ? void 0 : (_this_callOptions_callStartOptions = _this_callOptions.callStartOptions) === null || _this_callOptions_callStartOptions === void 0 ? void 0 : _this_callOptions_callStartOptions.clientEndpointCapabilities;
                }
                getLocalSignalingEndpointDetails() {
                    return (0, zi.find)(this.localSignalingParticipant.endpointDetails, (g)=>(g === null || g === void 0 ? void 0 : g.endpointId) === this._endpointId);
                }
                getStreamInformationMap(g) {
                    var _this_accountConfiguration;
                    const f = {};
                    return g && ((_this_accountConfiguration = this.accountConfiguration) === null || _this_accountConfiguration === void 0 ? void 0 : _this_accountConfiguration.clientSupportsUms) && (0, zi.forEach)(g.endpointDetails, (g)=>{
                        (g === null || g === void 0 ? void 0 : g.streamInformation) && g.participantId && g.participantId !== this._participantId && (f[g.participantId] = g.streamInformation);
                    }), f;
                }
                updateSATInfo(g = []) {
                    var _this_mediaSession;
                    const f = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.slowedDownTalkerInfoAggregationTime;
                    if (!f || f < 0) return;
                    const S = Date.now(), v = S - 1e3 * f;
                    this.activeTalkersHistory = this.activeTalkersHistory.filter(({ timestamp: g })=>g > v).concat({
                        speakers: g.map((g)=>g.id),
                        timestamp: S
                    });
                    const _ = Object.entries(this.activeTalkersHistory.reduce((g, { speakers: f })=>{
                        var _g_S;
                        for (const S of f)(_g_S = g[S]) !== null && _g_S !== void 0 ? _g_S : g[S] = 0, g[S]++;
                        return g;
                    }, {})).sort(([, g], [, f])=>f - g).map(([g])=>g);
                    this.slowedDownActiveTalkerInfo = {
                        speakerList: _,
                        timestamp: new Date(S)
                    };
                }
                setPlatformCallConstraints(g) {
                    this.setCallConstraints(g).catch((g)=>{
                        this.logger.error(g);
                    });
                }
                setCallConstraints(g) {
                    return this.mediaSession ? (this.logger.info(`Applying platform constraints to current call ${JSON.stringify(g)}`), this.mediaSession.setCallConstraints(g, generateCauseId())) : (this.logger.info("Saving platform constraints until media session is created"), this.temporaryCallConstraints = g, new Promise((g, f)=>{
                        this.resolveTemporaryCallConstraints = g, this.rejectTemporaryCallConstraints = f;
                    }));
                }
                initializeMediaSession(g, f) {
                    var _this_mediaAgent, _this_mediaSession_getSessionConfig;
                    if (this.mediaSession) return;
                    const S = this.logger.createFnLogger("initializeMediaSession", g), v = ((g, f)=>{
                        const S = {};
                        return Object.keys(f).forEach((v)=>{
                            S[v] = (...S)=>f[v] && g() && f[v](...S);
                        }), S;
                    })(()=>!this.isCallModeStreaming() || this.isPromotingToRealtime(), {
                        onSessionErrorOccurred: (g, f = generateCauseId())=>{
                            S.error(`[${f}][onSessionErrorOccurred]: ${safeJsonStringify(g)}`);
                            const v = [
                                this.mediaAgent.constants.MEDIA_ERROR.iceConnectionError,
                                this.mediaAgent.constants.MEDIA_ERROR.internalError
                            ];
                            (0, zi.includes)(v, g.type) && this.event("mediaConnectionFailed").raise(), this.callTelemetry.recordEvent("SessionError", {
                                type: g.type
                            }, f);
                        },
                        onNegotiationRequired: (g = generateCauseId(), f)=>{
                            this.executeNegotiation(g, "onNegotiationRequired", !0, f);
                        },
                        onContributingSourcesChanged: (g)=>{
                            var _this_mediaSession;
                            const f = (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.contributingSourcesLogInterval, v = f && Date.now() >= this.lastContributingSourceReport + f, _ = v ? new Map(g.map((g)=>[
                                    g,
                                    "<unknown>"
                                ])) : new Map, C = [];
                            for (const f of this.participants){
                                const S = g.some((g)=>f.hasAudioSource(g)), E = S ? 1 : 0;
                                f.updateVoiceLevel(E), S && (C.push(f), v && _.set(f.audio.id, scrubMriOrOmit(f.id)));
                            }
                            this.updateSATInfo(C), v && (S.info(`[onContributingSourcesChanged], ${g.length ? Array.from(_).join(";") : "none"}`), this.lastContributingSourceReport = Date.now());
                        },
                        onDominantSpeakerChanged: (g, f)=>{
                            const v = generateCauseId(), _ = [], C = [];
                            g.forEach((g)=>{
                                const f = (0, zi.find)(this.participants, (f)=>f.hasAudioSource(g));
                                f ? (_.push(f.id), C.push(scrubMriOrOmit(f.id))) : C.push(this.streamManager.audio.id === g ? "<self>" : "<unknown>");
                            }), S.info(`[${v}][onDominantSpeakerChanged], msidList = ${g} => speakerList = ${C}, timestamp = ${f}`), this.dominantSpeakerInfo = {
                                speakerList: _,
                                timestamp: f,
                                noCurrentDominantSpeaker: !1
                            }, this.event("dominantSpeakerChanged").raise(), this.raiseChanged(this._dominantSpeakerChangedEventSkipConfig);
                        },
                        onAudioStateChanged: (g, f)=>{
                            var _this_mediaSession;
                            const S = generateCauseId(), v = this.logger.createFnLogger("onAudioStateChanged", S);
                            v.info(safeJsonStringify(g)), this.callStats.localStats.audio.streamStateChanged(g.stream, g.direction);
                            const _ = _PluginlessCall.streamingStatetoMediaStreamState(g.stream);
                            if (this.audioStreamState = _, !_) return;
                            this.callTelemetry.recordEvent("AudioStateChanged", {
                                state: g,
                                reason: f
                            }, S), 2 === _ && 2 === this.state && (this.setCallState(9, S), this.participants.forEach((g)=>g.setState(6, void 0, S)));
                            const C = {
                                mediaType: 0,
                                mediaDirection: _PluginlessCall.streamingDirectionToMediaDirectionMapping(g.direction),
                                mediaStreamState: _
                            };
                            this.event("mediaStreamStateChanged").raise(C), !this.isCallSetupTelemetrySent && ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.sendCallStartupTelemetry) && this.sendCallSetupTelemetry(), 0 === C.mediaDirection && (this.isAudioStreamConnected = (0, zi.includes)([
                                2,
                                1
                            ], C.mediaStreamState));
                            if ((0, zi.includes)([
                                3,
                                4
                            ], C.mediaStreamState)) {
                                v.logFailure(`audio stream state changed to ${g.stream} with reason ${f}`);
                                if (!f || [
                                    "timeout",
                                    "connection-dropped",
                                    "connectivity-check-failure",
                                    "suspended"
                                ].indexOf(f) >= 0) {
                                    this.event("mediaConnectionFailed").raise();
                                    const g = "suspended" === f ? 77 : this.mediaRelayWhiteListingIssue ? 53 : 4;
                                    this.mediaRelayWhiteListingIssue && this.callTelemetry.recordEvent("_MediaWhiteListingIssueDetected"), this.stopInternal({
                                        causeId: S,
                                        terminatedReason: g
                                    });
                                }
                            }
                        },
                        onQualityChanged: (g)=>{
                            var _this_participantCounts;
                            const f = {
                                type: _PluginlessCall.convertQualityEventType(g.type),
                                value: _PluginlessCall.convertQualityLevel(g.value),
                                isLocalSource: g.isLocalSource,
                                mediaType: _PluginlessCall.convertMediaType(g.mediaType)
                            };
                            this.muteUnmuteWorkaround(f), 32 === f.type && (this.mediaRelayWhiteListingIssue = 3 === f.value, this.mediaRelayWhiteListingIssue && this.event("mediaConnectionWhitelistingWarning").raise()), 5 === f.type && 3 === f.value && this.trouterService.checkConnection(!0), this.callTelemetry.recordEvent("AudioQualityChanged", f), this.remoteUFDHandler.raiseIfNeeded(g, (_this_participantCounts = this.participantCounts) === null || _this_participantCounts === void 0 ? void 0 : _this_participantCounts.totalParticipants, (g)=>{
                                this.publishState(g, generateCauseId());
                            }), this.event("callQualityChanged").raise(f);
                        },
                        onOptimalVideoReceiversCountChanged: (g)=>{
                            S.debug(`onOptimalVideoReceiversCountChanged: ${g}`), this.optimalVideoCount !== g && (this.optimalVideoCount = g, this.raiseChanged());
                        },
                        onDataChannelUpdated: (g)=>{
                            const f = generateCauseId();
                            S.debug(`[${f}] onDataChannelUpdated`), this.dataChannel.registerSessionDataChannel(g, f);
                        },
                        onUpdateMediaDescriptionsRequired: (g, f)=>{
                            this.executeNegotiation(g, "onUpdateMediaDescriptionsRequired", !1, f);
                        },
                        onRealtimeTelemetryReport: ()=>{
                            this.reportTelemetryEvents([
                                {
                                    eventName: Sr.realtimeTelemetry,
                                    props: {
                                        user_object_id: {
                                            value: nr + this.currentUserSkypeIdentity.id,
                                            piiKind: 10
                                        },
                                        display_name: {
                                            value: this.displayName,
                                            piiKind: 1
                                        },
                                        call_context_id: {
                                            value: this.signalingSession.correlationId,
                                            piiKind: 0
                                        },
                                        participant_id: {
                                            value: this.participantId,
                                            piiKind: 0
                                        },
                                        media_leg_id: {
                                            value: this.mediaLegId,
                                            piiKind: 0
                                        },
                                        DiagnosticLevel: {
                                            value: 255,
                                            piiKind: 0
                                        },
                                        eventpdclevel: {
                                            value: 2,
                                            piiKind: 0
                                        },
                                        eventpriority: {
                                            value: 5,
                                            piiKind: 0
                                        },
                                        call_technical_info: {
                                            value: JSON.stringify(this.mediaSession.getCallTechnicalInfo()),
                                            piiKind: 0
                                        }
                                    }
                                }
                            ], "realtimeMedia", "mdsc");
                        },
                        onTransportConnected: ()=>{
                            this.allowDataChannel() || this.mediaStateConfigurationHelper.isSending(3) || this.isInitialSignalingDSHSubscriptionEnabled() || !this.callUsesMixer || this.updateSignalingDSHMessageSubscription(!0), this.unmixedAudioProvider.setSessionStreamsProvider(this.mediaSession.getUnmixedAudioProvider()), this.event("transportConnected").raise();
                        },
                        onTransportDisconnected: ()=>{
                            this.event("transportDisconnected").raise();
                        },
                        onTransportFailed: ()=>{
                            this.event("transportFailed").raise();
                        },
                        onUpdateSignalingDSHMessageSubscription: (g)=>this.updateSignalingDSHMessageSubscription(g)
                    });
                    this.callTelemetry.recordEvent("CreatingConference", "", g), this.callDeviceManager || (S.info(`[${g}][initializeMediaSession] Creating new callDeviceManager`), this.callDeviceManager = this.createCallDeviceManager());
                    const _ = {
                        maxReinvitelessMediaForVBSSMultiparty: this.signalingSession.getMaxReinvitelessMediaForVBSSForWeb(),
                        maxReinvitelessMediaForVideoMultiparty: this.signalingSession.getMaxReinvitelessMediaForVideoForWeb()
                    };
                    this.callTelemetry.recordEvent("_ReinvitelessConfig", {
                        reinvitelessConfig: _
                    }, g);
                    const C = (_this_mediaAgent = this.mediaAgent) === null || _this_mediaAgent === void 0 ? void 0 : _this_mediaAgent.getConfigProvider().config.identifyOneToOneCallWithoutParticipants;
                    this.mediaSession = new Dr(this.mediaAgent.createSession(v, this.signalingSession, {
                        isConference: this.callUsesMixer,
                        isPstnCall: this.isOneToOnePSTNCall(C),
                        isParkedCall: this.isParkedCall(),
                        reinvitelessConfig: _
                    }, this.callDeviceManager, this.smallCallTelemetry, f), this.signalingSession), this.temporaryCallConstraints && (S.info(`Applying saved call constraints to current call ${JSON.stringify(this.temporaryCallConstraints)}`), this.mediaSession.setCallConstraints(this.temporaryCallConstraints, generateCauseId()).then(this.resolveTemporaryCallConstraints).catch(this.rejectTemporaryCallConstraints).finally(()=>{
                        this.temporaryCallConstraints = void 0, this.rejectTemporaryCallConstraints = void 0, this.resolveTemporaryCallConstraints = void 0;
                    })), this.dataChannel.setConfigProviderView(this.mediaSession.getSessionConfig()), this.callTelemetry.recordEvent("CreatedConference", "", g), this.streamManager.setMediaSession(this.mediaSession, g), this.participants.forEach((f)=>{
                        f.setMediaSession(this.mediaSession, g);
                    });
                    const E = (_this_mediaSession_getSessionConfig = this.mediaSession.getSessionConfig()) === null || _this_mediaSession_getSessionConfig === void 0 ? void 0 : _this_mediaSession_getSessionConfig.config;
                    (E === null || E === void 0 ? void 0 : E.useOneDsLogger) && (E === null || E === void 0 ? void 0 : E.addTelemetryReportingCallback) && (this.beforeUnloadTelemetrySender = ()=>{
                        this.sendLastKnownStats();
                    }, window.addEventListener("beforeunload", this.beforeUnloadTelemetrySender)), this.screenSharingControl && this.allowDataChannel() && this.screenSharingControl.setupDataHandlers(), this.unmixedAudioProvider = new Ys;
                }
                executeNegotiation(g, f, S, v) {
                    const _ = this.logger.createFnLogger(f, g);
                    if (this.isCallModeStreaming() || this.isEscalationInProgress) return void _.info(`ignored due to being in streaming=${this.isCallModeStreaming()},\n                isEscalationInProgress=${this.isEscalationInProgress}`);
                    const C = generateCauseId();
                    3 === this.state || 4 === this.state || 5 === this.state || 10 === this.state || this.isPreheatedOnly() ? (_.info(`started, state: ${this.state}, runNegotiation: ${S}`), S ? (this.callTelemetry.recordEvent("NegotiationRequired", "", g), this._callOperationHandler.executeChained(()=>this.renegotiateOutgoing(g, v), "_RenegotiateOutgoing", C, g, void 0, void 0, {
                        preconditionTags: [
                            "NOT_SUPPORTED_IN_STREAMING_MODE"
                        ]
                    })) : (this.callTelemetry.recordEvent("UpdateMediaDescriptions", "", g), this._callOperationHandler.executeChained(()=>this.updateMediaDescriptions(g, v), "_UpdateMediaDescriptions", void 0, g, void 0, void 0, {
                        preconditionTags: [
                            "NOT_SUPPORTED_IN_STREAMING_MODE"
                        ]
                    }))) : _.info(`not started, state: ${this.state}`);
                }
                async muteUnmuteWorkaround(g) {
                    var _this_mediaSession;
                    if (((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.enableMuteSpeakerUnmuteSpeakerWorkaround) && !this.isSpeakerMuted && 25 === g.type && 3 === g.value && 0 === g.mediaType) {
                        this.logger.log("Performing muteSpeaker->unmuteSpeaker workaround");
                        const g = generateCauseId();
                        await this.muteSpeaker(g), await this.unmuteSpeaker(g);
                    }
                }
                sendLastKnownStats() {
                    if (this.tsCallingTelemetryReported) return;
                    this.callEndDiagnosticsInfo = {
                        callControllerCode: Ii.CODE.SUCCESS,
                        callControllerSubCode: Ii.SUB_CODE.BEACON
                    }, this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo);
                    const g = this.callTelemetry.getShortEvent();
                    g.Code = this.callEndDiagnosticsInfo.callControllerCode, g.SubCode = this.callEndDiagnosticsInfo.callControllerSubCode;
                    let f = "csa_conversation_callmodality";
                    if (this.reportTelemetryEvents([
                        {
                            eventName: f,
                            props: g
                        }
                    ], "signaling", "skypecosi_concore_web"), f = this._callIsSetupComplete ? "in_call_session" : "call_setup_session", this.reportTelemetryEvents([
                        {
                            eventName: f,
                            props: this.callTelemetry.getEvent(!0)
                        }
                    ], "signaling", "skypecosi_concore_web_ts_calling"), this.mediaSession) {
                        const g = this.mediaSession.getLastKnownStats(!0);
                        this.callStats.setMediaStats(g), this.reportSmallCallEvent(null, !0), this.reportTelemetryEvents(this.callStats.buildFromLocalStats(), "signaling", "skypecosi_concore_web");
                    }
                    this.reportVDITelemetryEvents();
                }
                reportSmallCallEvent(g, f) {
                    var _this_smallCallTelemetry;
                    this.reportTelemetryEvents(this.callStats.buildShortCallEvent(g !== null && g !== void 0 ? g : (_this_smallCallTelemetry = this.smallCallTelemetry) === null || _this_smallCallTelemetry === void 0 ? void 0 : _this_smallCallTelemetry.getEndCallSmallTelemetry(f)), "media", "mdsc");
                }
                invertDirectionality(g) {
                    switch(g){
                        case this.mediaAgent.constants.MEDIA_STATE.sendReceive:
                            return Br.sendReceive;
                        case this.mediaAgent.constants.MEDIA_STATE.send:
                            return Br.receive;
                        case this.mediaAgent.constants.MEDIA_STATE.receive:
                            return Br.send;
                        default:
                            return null;
                    }
                }
                completeNegotiationAsync(g) {
                    const f = this.logger.createFnLogger("completeNegotiationAsync", g), S = this.mediaSession.completeNegotiationAsync(g).then((S)=>{
                        var _S_activeModalities;
                        f.info(`activeModalities=${S && Object.keys(S.activeModalities)}`);
                        const v = this.mediaSession.getSessionConfig().config.avoidFakeStreamsDuringEscalation && this.isEscalationInProgress;
                        if (!this.callUsesMixer && !v) {
                            var _f_endpoints, _f_endpoints_endpointDetails__mediaStreams;
                            if (this.mediaStateConfigurationHelper.isSending(3) && S.initiator) {
                                const f = S.offeredModalities.data === this.mediaAgent.constants.MEDIA_STATE.sendReceive, v = S.activeModalities.data === this.mediaAgent.constants.MEDIA_STATE.sendReceive;
                                f && !v && (this.logger.info(`[${g}][completeNegotiationAsync] Disabling data modality as it was not wanted by remote`), this.mediaStateConfigurationHelper.removeModality(3));
                            }
                            const f = this.participants[0], v = (f === null || f === void 0 ? void 0 : (_f_endpoints = f.endpoints) === null || _f_endpoints === void 0 ? void 0 : _f_endpoints.endpointDetails.length) && ((_f_endpoints_endpointDetails__mediaStreams = f.endpoints.endpointDetails[0].mediaStreams) === null || _f_endpoints_endpointDetails__mediaStreams === void 0 ? void 0 : _f_endpoints_endpointDetails__mediaStreams.length);
                            if (f && !v) {
                                const prepareStreamData = (g, f, S)=>({
                                        participantId: no,
                                        endpointId: io,
                                        type: g,
                                        direction: this.invertDirectionality(f),
                                        sourceId: S,
                                        serverMuted: !1
                                    }), v = [];
                                v.push(prepareStreamData(Hr.audio, S.activeModalities.audio, ra)), S.activeModalities.video && v.push(prepareStreamData(Hr.video, S.activeModalities.video, aa)), S.activeModalities.sharing && v.push(prepareStreamData(Hr.sharing, S.activeModalities.sharing, sa)), f.updateStreams(v, g), !this.callIsHeld() && this.calculateIsSomeoneStreaming(g);
                            }
                        }
                        if (f.logSuccess(safeJsonStringify(S)), this.mediaAgent.getConfigProvider().config.syncMuteStateWithAudioDirection && (S === null || S === void 0 ? void 0 : (_S_activeModalities = S.activeModalities) === null || _S_activeModalities === void 0 ? void 0 : _S_activeModalities.audio)) {
                            const f = S.activeModalities.audio === this.mediaAgent.constants.MEDIA_STATE.receive || S.activeModalities.audio === this.mediaAgent.constants.MEDIA_STATE.inactive;
                            this.setMuted(f ? 2 : this.isServerMuted ? 1 : 0, g);
                        }
                        return S;
                    });
                    return S.catch((S)=>{
                        f.logFailure(S), this.callTelemetry.recordEvent("_CompleteNegotiationFailed", {
                            e: S
                        }, g);
                    }), S;
                }
                async renegotiateOutgoing(g, f) {
                    this.renegotiationAnswerDeferred = new ct;
                    const S = this.logger.createFnLogger("renegotiateOutgoing", g), v = this.inLocalHold() ? this.getMediaModalitiesForHold(g) : this.calculateModalityDirections({}, g);
                    if (this._delayedElevationPending && !this._delayedElevationQueued) {
                        if (hasSendDirectionality(v.video) || hasSendDirectionality(v.sharing)) return S.info("mediaModalities", v), void await this.triggerDelayedReconnectIfNeeded(g, "renegotiateOutgoing");
                        S.info("Delayed elevation (renegotiateOutgoing): no outgoing video or sharing, skipping elevation for now");
                    }
                    S.info("start");
                    const _ = createPhaseExecutor(S);
                    try {
                        try {
                            const S = await _.execute("MediaCreateOffer", ()=>this.mediaSession.createOfferAsync(g, f)), C = this.getSignalingMediaTypes(v);
                            await _.execute("SignalingStartNegotiation", ()=>this.signalingSession.startRenegotiationAsync(S, C, g));
                            const E = await _.execute("SignalingRenegotiationAnswer", ()=>this.renegotiationAnswerDeferred.promise);
                            await _.execute("MediaProcessAnswer", ()=>this.mediaSession.processAnswerAsync(E, g, !1));
                            const T = await _.execute("CompleteNegotiation", ()=>this.completeNegotiationAsync(g));
                            this.onNegotiationCompletion(T, !0, v, g, _.getTelemetryData());
                        } catch (f) {
                            var _f_error_message;
                            if (S.logFailure(f), !f.phase) throw this.callTelemetry.recordEvent("OutgoingNegotiationFailure", f, g), f;
                            let _ = "unknown";
                            const C = this.mediaAgent.constants.RENEGOTIATION_ERROR;
                            if (_ = C.local, "SignalingRenegotiationAnswer" === f.phase || "SignalingStartNegotiation" === f.phase) {
                                const g = 415;
                                _ = f.error.code === Li.GlareError ? C.glare : f.error.code === g ? C.media : C.signaling;
                            } else "MediaCreateOffer" === f.phase && f.error.type === this.mediaAgent.constants.MEDIA_ERROR.noNetworkError && (_ = C.media);
                            if (this.callTelemetry.recordEvent("OutgoingNegotiationFailure", this.getTelemetryFromPhaseExecution(f), g), (_f_error_message = f.error.message) === null || _f_error_message === void 0 ? void 0 : _f_error_message.includes("The requested call does not exist")) throw new Error("Call drop due to remote replying with call not found");
                            S.logFailure(_);
                            const E = {
                                type: _,
                                detail: f.error
                            };
                            await this.mediaSession.rejectNegotiationAsync(E, g), this.onNegotiationFailure(f, _, g, v);
                        }
                    } catch (f) {
                        S.logFailure(f), this.callTelemetry.recordEvent("NegotiationFatalError", getPIISafeObject(f), g), this.stopInternal({
                            causeId: g,
                            terminatedReason: 47
                        });
                    }
                }
                async renegotiateIncoming(g, f) {
                    this.mediaAcknowledgmentOperation = this._callOperationHandler.createPendingOperation("_MediaAcknowledgment", null, f, {
                        preconditionTags: [
                            "NOT_SUPPORTED_IN_STREAMING_MODE"
                        ]
                    }), this.mediaAcknowledgmentOperation.catch(noop);
                    const S = this.logger.createFnLogger("renegotiateIncoming", f);
                    if (S.info("start"), g.newOffer && !this.mediaAgent.getCapabilities().retargeting) return S.logFailure("Retarget offer received, but pluginless has no support for retarget"), void this.stopInternal({
                        causeId: f,
                        terminatedReason: 38
                    });
                    const v = createPhaseExecutor(S);
                    try {
                        const S = await v.execute("MediaProcessOffer", ()=>this.mediaSession.processOfferAsync(g, f));
                        this.handleOfferedModalities(S, f), 2 === this.getRenegotiationOfferType(S) && await this.prepareModalitiesForResume(f);
                        const _ = await this.updateMediaModalities({
                            offered: S
                        }, f);
                        1 === this.getRenegotiationOfferType(S) && await this.prepareModalitiesForHold(f), this.updateMediaState(_, f), this.isRenegotiationHoldOrResume(_) && this.updateScreenSharingState(_, f);
                        const C = await v.execute("MediaCreateAnswer", ()=>this.mediaSession.createAnswerAsync(!1, f)), E = this.getSignalingMediaTypes(_);
                        await v.execute("SignalingAcceptRenegotiation", ()=>this.signalingSession.acceptRenegotiationAsync(C, E, f)), await v.execute("SignalingMediaAcknowledgement", ()=>this.mediaAcknowledgmentOperation);
                        const T = await v.execute("CompleteNegotiation", ()=>this.completeNegotiationAsync(f));
                        this.onNegotiationCompletion(T, !1, S, f, v.getTelemetryData());
                    } catch (g) {
                        try {
                            if (!g.phase || "CompleteNegotiation" === g.phase) throw this.callTelemetry.recordEvent("IncomingNegotiationFailure", g, f), g;
                            const v = g;
                            this.callTelemetry.recordEvent("IncomingNegotiationFailure", this.getTelemetryFromPhaseExecution(g), f);
                            const _ = {
                                type: this.mediaAgent.constants.RENEGOTIATION_ERROR.local,
                                detail: g.error
                            };
                            if ("SignalingAcceptRenegotiation" === v.phase || "SignalingMediaAcknowledgement" === v.phase) return S.logFailure("Error in renegotiateIncoming() -> rejecting media negotiation"), _.type = this.mediaAgent.constants.RENEGOTIATION_ERROR.signaling, this._callOperationHandler.maybeRejectOperation("_MediaAcknowledgment", _, void 0, f), void await this.mediaSession.rejectNegotiationAsync(_, f);
                            this._callOperationHandler.maybeRejectOperation("_MediaAcknowledgment", _, void 0, f), await this.mediaSession.rejectNegotiationAsync(_, f), await this.signalingSession.rejectRenegotiationAsync(void 0, f);
                        } catch (g) {
                            S.logFailure(g), this.callTelemetry.recordEvent("NegotiationFatalError", getPIISafeObject(g), f), this.stopInternal({
                                causeId: f,
                                terminatedReason: 47
                            });
                        }
                    }
                }
                async updateMediaDescriptions(g, f) {
                    const S = this.logger.createFnLogger("updateMediaDescriptions", g);
                    S.info("start");
                    try {
                        var __appliedModalities;
                        const v = await this.mediaSession.startMediaDescriptionsUpdateAsync(g, f);
                        S.info(`send updateMediaDesriptions, descriptions=${safeJsonStringify(v)}`), await this.signalingSession.updateMediaDescriptionsAsync(g, v);
                        const _ = await this.mediaSession.completeMediaDescriptionsUpdateAsync(g);
                        if (this.mediaAgent.getConfigProvider().config.syncMuteStateWithAudioDirection && (_ === null || _ === void 0 ? void 0 : (__appliedModalities = _.appliedModalities) === null || __appliedModalities === void 0 ? void 0 : __appliedModalities.audio)) {
                            const f = _.appliedModalities.audio === this.mediaAgent.constants.MEDIA_STATE.receive || _.appliedModalities.audio === this.mediaAgent.constants.MEDIA_STATE.inactive;
                            this.setMuted(f ? 2 : this.isServerMuted ? 1 : 0, g);
                        }
                        this.onUpdateMediaDescriptionsCompletion(_, g);
                    } catch (f) {
                        S.logFailure(f), this.callTelemetry.recordEvent("UpdateMediaDescriptionsFailure", f, g);
                        const v = await this.mediaSession.rejectMediaDescriptionsUpdateAsync(g, !0);
                        this.onUpdateMediaDescriptionsFailure(f, v, g);
                    }
                }
                handleCallEscalation(g, f) {
                    const S = this.logger.createFnLogger("handleCallEscalation", f);
                    if (S.info(`current callType=${this.callType}, escalationInProgress=${g}, isEscalationInProgress=${this.isEscalationInProgress}`), g) {
                        const g = this.participants[0];
                        g && g.audio.participantId === no ? g.updateStreams([
                            {
                                type: Hr.audio,
                                direction: "inactive",
                                sourceId: null,
                                serverMuted: !1
                            },
                            {
                                type: Hr.video,
                                direction: "inactive",
                                sourceId: null,
                                serverMuted: !1
                            },
                            {
                                type: Hr.sharing,
                                direction: "inactive",
                                sourceId: null,
                                serverMuted: !1
                            }
                        ], f) : S.info("no 1-1 participant found, stream update ignored"), this.setCallType(2, f), this.setCallUsesMixer(!0, f), this.setIsEscalationInProgress(!1, f), this.callTelemetry.recordEvent("_EscalationCompleted", void 0, f), this.raiseChanged();
                    }
                }
                async reportTsCallingTelemetry(g) {
                    if (this.tsCallingTelemetryReported) return;
                    await this.connectCallPromise.catch(noop);
                    const f = g ? "call_setup_session" : "in_call_session";
                    this.callTelemetry.setCallEndDiagnosticInfo(this.callEndDiagnosticsInfo), this.reportTelemetryEvents([
                        {
                            eventName: f,
                            props: this.callTelemetry.getEvent(g)
                        }
                    ], "signaling", "skypecosi_concore_web_ts_calling"), g ? this.callTelemetry.switchToInCallTelemetry() : this.tsCallingTelemetryReported = !0;
                }
                async sendMidCallTelemetry(g) {
                    this.mediaSession && (g === null || g === void 0 ? void 0 : g.length) && (this.callStats.setMediaStats(await this.mediaSession.getStatsAsync(!0)), this.appendInfoToCallStats(), this.reportTelemetryEvents(this.callStats.buildMidCallTelemetry(g), "media", "mdsc_mid_call_telemetry"));
                }
                sendCallSetupTelemetry() {
                    this.mediaSession && (this.collectCallStats(this.mediaSession), this.reportCallSetupStats(), this.isCallSetupTelemetrySent = !0);
                }
                collectCallStats(g) {
                    const always = ()=>this.collectMediaStatsDeferred.resolve();
                    return g.getStatsAsync(!1).then((g)=>this.callStats.setMediaStats(g)).then(always, always);
                }
                reportCallSetupStats() {
                    this.collectMediaStatsDeferred.promise.then(()=>{
                        this.reportTelemetryEvents(this.callStats.buildFromCallSetupStats(this.signalingSession.baseMessagingChannelUrl), "media", "mdsc"), this.event("statsReported").raise(), this.collectMediaStatsDeferred = new ct;
                    });
                }
                async reportCallEndStats(g) {
                    var _this_mediaAgent_getConfigProvider_config_smallCallTelemetry, _this_mediaAgent_getConfigProvider_config;
                    this.callTelemetry.setTerminationState(this.state), this.callTelemetry.setTerminationReason(this.terminatedReason), this.callStats.localStats.endCall(this.terminatedReason), g && ((_this_mediaAgent_getConfigProvider_config = this.mediaAgent.getConfigProvider().config) === null || _this_mediaAgent_getConfigProvider_config === void 0 ? void 0 : (_this_mediaAgent_getConfigProvider_config_smallCallTelemetry = _this_mediaAgent_getConfigProvider_config.smallCallTelemetry) === null || _this_mediaAgent_getConfigProvider_config_smallCallTelemetry === void 0 ? void 0 : _this_mediaAgent_getConfigProvider_config_smallCallTelemetry.enable) && this.reportSmallCallEvent(null), this.reportTelemetryEvents(this.callStats.buildFromLocalStats(), "signaling", "skypecosi_concore_web"), this.reportTsCallingTelemetry(!this._callIsSetupComplete), g && (await this.collectMediaStatsDeferred.promise, this.callStats.appendTerminationInfo(this.terminatedReason, this.state), this.appendInfoToCallStats(), this.reportTelemetryEvents(this.callStats.buildFromMediaStats(), "media", "mdsc")), this.reportVDITelemetryEvents(), this.event("statsReported").raise(), this.collectMediaStatsDeferred = new ct;
                }
                async reportVDITelemetryEvents() {
                    this.vdi3diagnostics && this.reportTelemetryEvents([
                        {
                            eventName: "vdi_webrtc_session",
                            props: await this.callStats.buildVDItelemetryReport(this.vdi3diagnostics)
                        }
                    ], "media", "mdsc");
                }
                reportTelemetryEvents(g, f, S) {
                    const v = this.telemetryLoggers ? this.telemetryLoggers[f] : null;
                    v ? g.forEach((g)=>v.sendEvent({
                            eventName: `${S ? `${S}_` : ""}${g.eventName}`,
                            props: g.props
                        })) : this.logger.debug(`reportTelemetryEvents no logger for tenant ${f}`);
                }
                onLocalPreviewSizeChanged(g, f) {
                    this.logger.debug(`onLocalPreviewSizeChanged: ${g}x${f}`);
                }
                onLocalPreviewStateChanged(g) {
                    this.logger.debug(`onLocalPreviewStateChanged: ${g}`), this.callStats.localStats.video.streamStateChanged(g.stream);
                }
                async configureVideoModalitiesAsync(g, f, S) {
                    if (!this.mediaSession) return this.logger.warn("Tried to configure modalities after call end"), Promise.resolve();
                    g && this._delayedElevationPending && !this._delayedElevationQueued && await this.triggerDelayedReconnectIfNeeded(f, "configureVideoModalitiesAsync"), await this.updateMediaModalities(void 0, f, S), g || this.turnOffLocalVideoPreview(f), this.setVideoOn(g, f);
                }
                turnOffLocalVideoPreview(g) {
                    return this.localVideoRenderer && (this.localVideoRenderer.dispose(), this.localVideoRenderer = null), this.disposeLocalVideoHandle(), Promise.resolve(void 0);
                }
                turnOnLocalVideoPreview(g) {
                    var _this_mediaSession;
                    return ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.useDeviceHandleForLocalVideo) ? this.acquireLocalVideo(g) : (this.localVideoContainer || (this.localVideoContainer = document.createElement("div")), this.turnOnLocalVideoPreviewUsingRenderer(g));
                }
                acquireLocalVideo(g) {
                    const f = this.logger.createFnLogger("_StartPreviewVideo", g);
                    if (!this.mediaStateConfigurationHelper.isSending(1)) return Promise.reject("could not start video preview, not configured to send");
                    try {
                        this.disposeLocalVideoHandle();
                        const g = this.callDeviceManager.getDeviceManager(getAgentMediaType(1));
                        return this.localVideoHandle = g.createDevicesHandle({
                            video: !0
                        }, "pluginlessCall:acquireLocalVideo()"), this.localVideoHandle.on("onStreamStateChanged", (g)=>this.onLocalPreviewStateChanged({
                                stream: g
                            })), this.localVideoHandle.acquire();
                    } catch (g) {
                        return f.logFailure(g), void this.disposeLocalVideoHandle();
                    }
                }
                turnOnLocalVideoPreviewUsingRenderer(g) {
                    const f = this.logger.createFnLogger("_StartPreviewVideo", g), S = this.mediaStateConfigurationHelper.isSending(1);
                    if (!S || !this.localVideoContainer) return Promise.reject(`could not start video preview: requestedVideoState=${S}, localVideoContainer=${this.localVideoContainer}`);
                    this.turnOffLocalVideoPreview(g);
                    const v = asap(()=>{
                        this.localVideoRenderer = this.callDeviceManager.getDeviceManager(getAgentMediaType(1)).createPreviewRenderer(this.localVideoContainer, "Video"), this.localVideoRenderer.on("onVideoSizeChanged", (g, f)=>this.onLocalPreviewSizeChanged(g, f)), this.localVideoRenderer.on("onVideoStateChanged", (g)=>this.onLocalPreviewStateChanged(g));
                    }).then(()=>this.localVideoRenderer.startVideoAsync(g));
                    return v.catch((g)=>f.logFailure(g)), v;
                }
                async startStopVideo(g, f, S) {
                    const v = this.logger.createFnLogger(g ? "startVideo" : "stopVideo", f);
                    return v.info("start"), this.canToggleVideo ? (g ? (this.callStats.localStats.newSession(1), this.callStats.localStats.video.start()) : this.callStats.localStats.video.stop(), g && this.mediaStateConfigurationHelper.isDisabled(1) && v.info("Video modality was skipped till now. Adding it now."), g ? this.mediaStateConfigurationHelper.enableModality(1) : this.mediaStateConfigurationHelper.removeModality(1), this.canToggleVideo = !1, this.videoTogglePromise = (async ()=>{
                        try {
                            let v = !1;
                            g && (await this.turnOnLocalVideoPreview(f), v = !0), await this.configureVideoModalitiesAsync(v, f, S);
                        } catch (g) {
                            throw v.logFailure(g), this.mediaStateConfigurationHelper.removeModality(1), await this.configureVideoModalitiesAsync(!1, f, S), g;
                        } finally{
                            this.canToggleVideo = !0;
                        }
                    })(), this.videoTogglePromise) : g === this.mediaStateConfigurationHelper.isSending(1) ? (await this.videoTogglePromise, void this.turnOnLocalVideoPreview(f)) : (v.logFailure(`video switching is in progress ${g}]`), Promise.reject({
                        reason: 1
                    }));
                }
                async startStopAudio(g, f) {
                    const S = this.logger.createFnLogger(g ? "startAudio" : "stopAudio", f);
                    try {
                        const g = await this.updateMediaModalities(void 0, f);
                        this.updateMediaState(g, f);
                    } catch (g) {
                        return S.logFailure(g), 9;
                    }
                    return 0;
                }
                updateEndpointStateForMute(g, f) {
                    try {
                        this.signalingSession.updateEndpointState({
                            state: {
                                isMuted: g
                            }
                        }, f).catch((g)=>{
                            this.logger.logFailure(`updateEndpointStateForMute failure: ${g}`);
                        });
                    } catch (g) {
                        this.logger.logFailure(`updateEndpointStateForMute failure: ${g}`);
                    }
                }
                async handleServerMutedState(g) {
                    const f = this.logger.createFnLogger(`handleServerMutedState, isServerMuted=${!!this.isServerMuted}`, g);
                    if (!this.isServerMuted) {
                        const S = 3 === this._muteState;
                        if (1 === this._muteState || S) try {
                            var _this_unmutePendingPromise;
                            f.info("is unmuting, as we are no longer server muted"), await this.handleMuteUnmuteOnMediaSession(!1, g), this.setMuted(0, g), (_this_unmutePendingPromise = this.unmutePendingPromise) === null || _this_unmutePendingPromise === void 0 ? void 0 : _this_unmutePendingPromise.resolve(), S && this.updateEndpointStateForMute(!1, g);
                        } catch (g) {
                            throw f.logFailure(g), g;
                        }
                    }
                    if (this.isServerMuted && 0 === this._muteState) {
                        f.info("is muting, as we are unmuted");
                        try {
                            await this.handleMuteUnmuteOnMediaSession(!0, g), this.setMuted(1, g);
                        } catch (g) {
                            throw f.logFailure(g), g;
                        }
                    }
                }
                async handleMuteUnmuteOnMediaSession(g, f) {
                    var _this_mediaSession, _this_mediaSession1, _this_mediaSession2;
                    const S = this.logger.createFnLogger(`handleMuteUnmuteOnMediaSession, value=${!!g}`, f);
                    if (((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getAllowedModalities) && !this.isServerMuted) {
                        const v = this.isMuted || this.isServerMuted, _ = this.mediaSession.getAllowedModalities().audio.some((g)=>g === Br.send || g === Br.sendReceive);
                        (v && _ || !v && !_) && (S.info(`updating audio modalities: Muted ${v} -> ${g}; audioAllowed = ${_}`), await this.updateMediaModalities(void 0, f));
                    }
                    return g ? (S.info("mediaSession.muteInputAsync"), await ((_this_mediaSession1 = this.mediaSession) === null || _this_mediaSession1 === void 0 ? void 0 : _this_mediaSession1.muteInputAsync(f))) : g || (S.info("mediaSession.unmuteInputAsync"), await ((_this_mediaSession2 = this.mediaSession) === null || _this_mediaSession2 === void 0 ? void 0 : _this_mediaSession2.unmuteInputAsync(f))), Promise.resolve();
                }
                canMuteOthers() {
                    var _this_meetingRoles, _this_endpoints_endpointDetails_find_endpointMeetingRoles, _this_endpoints_endpointDetails_find, _this_endpoints;
                    const g = this._enableUserMeetingRolesCheckForClientCapability && ((_this_meetingRoles = this.meetingRoles) === null || _this_meetingRoles === void 0 ? void 0 : _this_meetingRoles.some((g)=>"attendee" === g)) || "attendee" === (this.advancedMeetingRole || this.meetingRole), f = this._enableEndpointMeetingRoleCheckForClientCapability && !!((_this_endpoints = this.endpoints) === null || _this_endpoints === void 0 ? void 0 : (_this_endpoints_endpointDetails_find = _this_endpoints.endpointDetails.find((g)=>this._endpointId === g.endpointId)) === null || _this_endpoints_endpointDetails_find === void 0 ? void 0 : (_this_endpoints_endpointDetails_find_endpointMeetingRoles = _this_endpoints_endpointDetails_find.endpointMeetingRoles) === null || _this_endpoints_endpointDetails_find_endpointMeetingRoles === void 0 ? void 0 : _this_endpoints_endpointDetails_find_endpointMeetingRoles.some((g)=>"attendee" === g));
                    return !g && !f;
                }
                updateCapabilities(g, f = !1) {
                    let S = !1, v = !1;
                    callStateIsAnyOf(this.state, [
                        11,
                        12
                    ]) || (this.isServerMuted && !this._callInLobby ? 2 & this._commandUrlPresence && (S = !0) : this.isMuted && (S = !0), v = !!(1 & this._commandUrlPresence) && this.canMuteOthers()), this._capabilities.canUnmuteSelf === S && this._capabilities.canMuteOthers === v || (this._capabilities.canUnmuteSelf = S, this._capabilities.canMuteOthers = v, this.logger.info(`[${g}][updateCapabilities] Computed self capabilities: ${JSON.stringify(this._capabilities)}`), f && this.raiseChanged());
                }
                async evaluateEndpointStatesForAccept(g, f, S) {
                    const v = this.logger.createFnLogger(`evaluateEndpointStatesForAccept, isMuted=${!!g}`, S), _ = {};
                    try {
                        await this.handleMuteUnmuteOnMediaSession(g, S), Object.assign(_, {
                            state: {
                                isMuted: g
                            }
                        }), v.info("is updating endpointState for mute"), f && (Object.assign(_, {
                            endpointProperties: {
                                additionalEndpointProperties: f
                            }
                        }), v.info("is updating endpointState for additionalEndpointProperties"));
                    } catch (g) {
                        throw v.logFailure(g), getRejectTransactionEnd(g);
                    }
                    return _;
                }
                async handleEndpointStatesForAccept(g, f) {
                    const S = this.logger.createFnLogger("handleEndpointStatesForAccept", f);
                    try {
                        await this.signalingSession.updateEndpointState(g, f);
                    } catch (g) {
                        throw S.logFailure(g), getRejectTransactionEnd(g);
                    }
                }
                async muteUnmute(g, f) {
                    const S = this.logger.createFnLogger(`muteUnmute, value=${!!g} isServerMuted=${this.isServerMuted} inLobby=${this._callInLobby}`, f);
                    if (callStateIsAnyOf(this.state, [
                        11,
                        12
                    ])) return S.logFailure("Can not mute/unmute during preheat call"), Promise.reject(getRejectTransactionEnd("TransactionDisallowed"));
                    const v = !g && (!this.isServerMuted || this._callInLobby);
                    try {
                        if ((g || v) && await this.handleMuteUnmuteOnMediaSession(g, f), g) this.setMuted(2, f), S.info("is updating endpointState for mute"), this.updateEndpointStateForMute(!0, f);
                        else {
                            if (!v) return S.info("is unmuting on server"), 2 === this._muteState && this.setMuted(3, f), this.isCallModeStreaming() ? this.promoteToRealtimeAndUnmute(f) : this.signalingSession.unmuteAsync(f).then((g)=>{
                                this.handleSelfUnmuteUpdatedInfo(g, f);
                            });
                            S.info("is updating endpointState for unmute"), this.setMuted(0, f), this.updateEndpointStateForMute(!1, f);
                        }
                    } catch (g) {
                        throw S.logFailure(g), getRejectTransactionEnd(g);
                    }
                }
                async muteUnmuteSpeaker(g, f) {
                    this.setSpeakerMuted(g, f), this.mediaSession && (g ? await this.mediaSession.muteOutputAsync(f) : await this.mediaSession.unmuteOutputAsync(f));
                }
                getParticipant(g) {
                    return this.participants.filter((f)=>f.isSameParticipantsMri(g))[0];
                }
                getOrCreateParticipant(g, f, S) {
                    let v = this.getParticipant(g);
                    return v || (v = new da(g, this.mediaSession, this.logger, this.callStats.localStats, this.callTelemetry, f), v.changed(()=>this.onParticipantChanged(v)), this.participants.push(v), S && this.event("participantAdded").raise(v), this.monitorCallStart(), v);
                }
                onParticipantChanged(g) {
                    this.event("participantUpdated").raise(g), this.raiseChangedDeferred(this._participantChangedEventSkipConfig);
                }
                setCallState(g, f, S = 0) {
                    if (this.state === g) return;
                    const v = this.logger.createFnLogger("setCallState", f);
                    v.info(`currentState=${this.state}, newState=${g}, terminatedReason=${this.terminatedReason}`);
                    (dr[this.state].indexOf(g) >= 0 || (v.logFailure("invalid state transition"), 7 === g)) && (this.callTelemetry.recordEvent("_SetCallState", {
                        state: g,
                        reason: S
                    }, f), this.state = g, this.callStats.localStats.call.callStateChanged(g), 6 === g && this._startCallPhase && (this.callTelemetry.updateOperationData("_ConnectCall", {
                        phases: this._startCallPhase.getTelemetryData()
                    }, f), this._startCallPhase = void 0), 7 === g && this.setTerminatedReason(S), 3 === g && (this.callGotConnected = !0, this.callHeldAt = null), this.callIsHeld() && !this.callHeldAt && (this.callHeldAt = new Date), v.logSuccess(`changed to ${g}, terminatedReason: ${this.terminatedReason}, failureType=${this.failureType}`), this.screenSharingControl.callStateChanged(this.state), this.monitorCallStart(), this.event("callStateChanged").raise(), this.updateCapabilities(f), this.raiseChanged(), this.callTelemetry.recordEvent("_RaiseCallStateChangeEvent", {
                        state: g,
                        reason: S
                    }, f));
                }
                setTerminatedReason(g) {
                    if (this.terminatedReason = g, !(0, zi.includes)(to, g)) {
                        const g = 44 === this.terminatedReason, f = 55 === this.terminatedReason, S = 56 === this.terminatedReason;
                        this.setFailureType(!this.callGotConnected || !this._wasAudioStreamConnected || g || f || S ? 0 : 1);
                    }
                }
                setMediaStream(g, f, S) {
                    if (g) {
                        if (!(0, zi.find)(this.localMediaStreams, (g)=>g.mediaType === S)) {
                            const g = new ro(f, S);
                            this.logger.info(`setMediaStream ${JSON.stringify(g)}`), this.localMediaStreams.push(g);
                        }
                    } else this.logger.info(`setMediaStream removing ${S}`), (0, zi.remove)(this.localMediaStreams, (g)=>g.mediaType === S);
                }
                setVideoOn(g, f) {
                    this.logger.info(`[${f}]videoOn=${g}`), this.isVideoOn = g, this.setMediaStream(this.isVideoOn, !0, 1), this.callTelemetry.recordEvent("_SetLocalVideo", {
                        value: g
                    }, f), this.raiseChanged();
                }
                setAudioOn(g, f) {
                    this.logger.info(`[${f}]audioOn=${g}`), this.setMediaStream(g, !0, 0), this.callTelemetry.recordEvent("_SetLocalAudio", {
                        value: g
                    }, f);
                }
                setScreenSharingOn(g, f) {
                    this.logger.info(`[${f}]screenSharingOn=${g}`), this.isScreenSharingOn = g, this.setMediaStream(this.isScreenSharingOn, this.isScreenSharingOn, 2), this.callTelemetry.recordEvent("_SetScreenSharing", {
                        screenSharingOn: g
                    }, f), this.event("userActivityChanged").raise(), this.raiseChanged();
                }
                disposeSharingScreenHandle() {
                    this.sharedScreenHandle && (this.sharedScreenHandle.dispose(), this.sharedScreenHandle = null);
                }
                disposeLocalVideoHandle() {
                    var _this_localVideoHandle;
                    (_this_localVideoHandle = this.localVideoHandle) === null || _this_localVideoHandle === void 0 ? void 0 : _this_localVideoHandle.dispose(), this.localVideoHandle = null;
                }
                setMuted(g, f) {
                    this._muteState !== g && (this._muteState = g, this.callTelemetry.recordEvent("_SetMuted", {
                        isMuted: g
                    }, f), this.logger.info(`[${f}]participantMuteState:${g}, isMuted: ${this.isMuted}`), this.updateCapabilities(f), this.raiseChanged(), this.event("muteStateChanged").raise(this.isMuted, f));
                }
                setSpeakerMuted(g, f) {
                    this.logger.info(`[${f}]speakerMute=${g}]`), this.isSpeakerMuted = g, this.raiseChanged();
                }
                monitorCallStart() {
                    3 !== this.state || !this.participants.length && 2 !== this.callMode || this.callStartedAt || (this.callStartedAt = new Date);
                }
                _removeParticipant(g, f, S = 0) {
                    const v = this.logger.createFnLogger("removeParticipant", f);
                    v.info(`mri=${scrubSignalingParticipant(g)}`);
                    const _ = (0, zi.remove)(this.participants, (f)=>f.isSameParticipantsMri(g.id))[0];
                    _ ? (_.setState(4, S, f), this.event("participantRemoved").raise(_)) : v.logFailure(`unable to remove participant ${scrubMriOrOmit(g.id)}`), this.raiseChanged(this._participantChangedEventSkipConfig);
                }
                setIsSomeoneSharing(g, f) {
                    var _this_mediaSession, _this_screenSharingControl;
                    const S = this.isSomeoneSharing !== g && !(g && this.screenSharingRenegotiationDeferred && this.callUsesMixer);
                    S && (this.isSomeoneSharing = g);
                    let v = S;
                    if (this.callUsesMixer && ((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getSessionConfig().config.enableStopSharingWithIncomingOffer) && (v || (v = f)), v && this.isSomeoneSharing && this.isScreenSharingOn && (this.stopScreenSharing(), this.logger.info("sharingStolen: Cleaning up local screenshare because remote screenshare is running"), this.event("sharingStolen").raise()), this.allowScreenSharingControl() && ((_this_screenSharingControl = this.screenSharingControl) === null || _this_screenSharingControl === void 0 ? void 0 : _this_screenSharingControl.isInternalViewerControlEnabled())) {
                        const g = this.localSignalingParticipant.endpointDetails.find((g)=>this._endpointId === g.endpointId), f = this.participants.find((g)=>g.streams[1].some((g)=>g.isAvailable));
                        this.screenSharingControl.startOrStopControlForViewer(this.isSomeoneSharing, f, g);
                    }
                }
                handleOfferedModalities(g, f) {
                    const S = this.mediaAgent.constants.MEDIA_STATE, v = this.logger.createFnLogger("handleOfferedModalities", f);
                    try {
                        v.info(`offeredModalities=${safeJsonStringify(g)}`);
                    } catch (g) {
                        v.logFailure(g);
                    }
                    g.hasOwnProperty("video") || this.mediaStateConfigurationHelper.isSending(1) ? g.hasOwnProperty("video") && !this.mediaStateConfigurationHelper.isSending(1) && this.mediaStateConfigurationHelper.removeModality(1) : this.mediaStateConfigurationHelper.disableModality(1), g.hasOwnProperty("sharing") || this.mediaStateConfigurationHelper.isSending(2) || this.mediaStateConfigurationHelper.disableModality(2), g.sharing !== S.receive || this.mediaStateConfigurationHelper.isSending(2) || this.mediaStateConfigurationHelper.removeModality(2), g.data === S.sendReceive && this.allowDataChannel() && this.mediaStateConfigurationHelper.enableModality(3), this.isReivitelessEnabled() || (this.setIsSomeoneSharing(g.sharing === S.receive, !0), this.setIsSomeoneStreamingVideo(g.video === S.receive || g.video === S.sendReceive));
                }
                getRenegotiationOfferType(g) {
                    if (g) {
                        if (5 === this.state) {
                            if ("sendrecv" === g.audio) return 2;
                        } else if (this.modalitiesAreHold(g)) return 1;
                    }
                    return 0;
                }
                isRenegotiationHoldOrResume(g) {
                    return 1 === this.getRenegotiationOfferType(g) || 2 === this.getRenegotiationOfferType(g);
                }
                isReivitelessEnabled() {
                    return (this.signalingSession.getMaxReinvitelessMediaForVideoForWeb() > 0 || this.signalingSession.getMaxReinvitelessMediaForVBSSForWeb() > 0) && this.callUsesMixer;
                }
                isValidHoldResumeCallState(g) {
                    return [
                        3,
                        5,
                        10,
                        13
                    ].includes(g);
                }
                onNegotiationCompletion(g, f, S = {}, v, _) {
                    var _g_activeModalities;
                    const C = this.logger.createFnLogger("onNegotiationCompletion", v);
                    C.info(`byLocal=${f}, result=${safeJsonStringify(g)}`), this.callTelemetry.recordEvent("NegotiationCompletion", {
                        phaseTelemetryBag: _,
                        ...this.prepareNegotiationResultForTelemtry(g)
                    }, v);
                    const E = this.isOneToOneCall();
                    if (E && !this.callUsesMixer) {
                        const f = this.modalitiesAreHold(g.activeModalities) ? 5 : 3;
                        this.participants[0].setState(f, void 0, v), C.info(`isOneToOneCall: participant[0] state set to ${f}`);
                    }
                    const T = this.modalitiesAreHold(g.configuredModalities), I = this.modalitiesAreHold(g.activeModalities);
                    let b;
                    const A = this.signalingSession.participantManager.localParticipant.isStaging;
                    C.info(`isStaging= ${A}`), this.requestedHoldState ? (T && I || C.info(`Not expected modalities when processing local hold: ${T} ${I}`), 4 !== this.state && C.info(`Not expected state when processing local hold: ${this.state}, switching back to LocalHold`)) : f || this.callHoldResumeDeferred ? !T && I ? b = 5 : T || I || this._callInLobby || this.isPreheatedOnly() || (b = A ? 13 : 3) : 4 === this.state || this._callInLobby || this.isPreheatedOnly() || (b = E && 5 === this.participants[0].state ? 5 : A ? 13 : 3), b && this.setCallState(b, v), this.callHoldResumeDeferred && (C.info(`isHoldInProgress=${this.isHoldInProgress}, state=${this.state}, completed=${I}`), this.isHoldInProgress ? I && this.finishCallHoldResume() : this.inLocalHold() || this.finishCallHoldResume(this.isValidHoldResumeCallState(b) ? void 0 : new Error(`Call state changed to ${b} instead of Connected, Lobby, Staging or RemoteHold`))), this.requestedHoldState || (this.setIsSomeoneSharing((0, zi.some)(this.participants, (g)=>(0, zi.some)(g.streams[1], (g)=>g.isAvailable))), this.setIsSomeoneStreamingVideo((0, zi.some)(this.participants, (g)=>(0, zi.some)(g.streams[0], (g)=>g.isAvailable))));
                    const R = S && S.sharing === this.mediaAgent.constants.MEDIA_STATE.send, P = (g === null || g === void 0 ? void 0 : (_g_activeModalities = g.activeModalities) === null || _g_activeModalities === void 0 ? void 0 : _g_activeModalities.sharing) === this.mediaAgent.constants.MEDIA_STATE.send;
                    if (this.resolveScreenSharingRenegotiation(v, R, P, g.isComplete), this.retryOutgoingRenegotiation.retry) {
                        const g = this.retryOutgoingRenegotiation.causeId;
                        this._callOperationHandler.executeChained(()=>this.updateMediaModalities(void 0, g), "_Renegotiate", g, g, void 0, void 0, {
                            preconditionTags: [
                                "NOT_SUPPORTED_IN_STREAMING_MODE"
                            ]
                        }), this.retryOutgoingRenegotiation.retry = !1;
                    }
                }
                onUpdateMediaDescriptionsFailure(g, f, S) {
                    const v = (f === null || f === void 0 ? void 0 : f.requestedModalities.sharing) === this.mediaAgent.constants.MEDIA_STATE.send;
                    this.screenSharingRenegotiationDeferred && v && (this.screenSharingRenegotiationDeferred.reject(g), this.screenSharingRenegotiationDeferred = null);
                }
                onUpdateMediaDescriptionsCompletion(g, f) {
                    var _g_requestedModalities, _g_appliedModalities;
                    this.logger.createFnLogger("onUpdateMediaDescriptionsCompletion", f).info(`result=${safeJsonStringify(g)}`), this.callTelemetry.recordEvent("UpdateMediaDescriptionsCompletion", g, f);
                    const S = (g === null || g === void 0 ? void 0 : (_g_requestedModalities = g.requestedModalities) === null || _g_requestedModalities === void 0 ? void 0 : _g_requestedModalities.sharing) === this.mediaAgent.constants.MEDIA_STATE.send, v = (g === null || g === void 0 ? void 0 : (_g_appliedModalities = g.appliedModalities) === null || _g_appliedModalities === void 0 ? void 0 : _g_appliedModalities.sharing) === this.mediaAgent.constants.MEDIA_STATE.send;
                    this.resolveScreenSharingRenegotiation(f, S, v, !0);
                }
                resolveScreenSharingRenegotiation(g, f, S, v) {
                    const _ = this.logger.createFnLogger("resolveScreenShareRenegotiation", g);
                    if (_.info(`invoked with wasSharingOfferred: ${f}, isSharingActive: ${S}, isComplete: ${v}`), this.screenSharingRenegotiationDeferred) {
                        if (f && S) _.info("resolving screenSharingRenegotiationDeferred"), this.screenSharingRenegotiationDeferred.resolve(), this.screenSharingRenegotiationDeferred = null;
                        else if (this._enableResolveScreenSharingWhenNegotiationComplete && v && !this.retryOutgoingRenegotiation.retry && this.canToggleScreenSharing) {
                            const g = new Error(`screenSharing error: wasSharingOfferred: ${f}, isSharingActive: ${S}`);
                            _.info(`reject screenSharingRenegotiationDeferred ${g}`), this.screenSharingRenegotiationDeferred.reject(g), this.screenSharingRenegotiationDeferred = null;
                        }
                    }
                }
                async updateMediaStatus(g) {
                    if (this.calculateIsSomeoneStreaming(g), this.mediaSession) {
                        const f = await this.updateMediaModalities(void 0, g);
                        this.callTelemetry.updateOperationData("_UpdateLocalMediaStatus", f, g);
                    }
                }
                calculateIsSomeoneStreaming(g) {
                    let f = !1, S = !1;
                    for (const g of this.participants)if (f || (f = (0, zi.some)(g.streams[1], (g)=>g.isAvailable)), S || (S = (0, zi.some)(g.streams[0], (g)=>g.isAvailable)), f && S) break;
                    this._delayedElevationPending && (f || S) && this.triggerDelayedReconnectIfNeeded(g, "roster update"), this.setIsSomeoneSharing(f), this.setIsSomeoneStreamingVideo(S);
                }
                async triggerDelayedReconnectIfNeeded(g, f = "") {
                    var _this_mediaSession_getDiagnostics, _this_mediaSession;
                    const onReconnectCompleted = ()=>{
                        var _this_mediaSession_getDiagnostics, _this_mediaSession;
                        this._delayedElevationPending = !1, this._delayedElevationQueued = !1, (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getDiagnostics = _this_mediaSession.getDiagnostics()) === null || _this_mediaSession_getDiagnostics === void 0 ? void 0 : _this_mediaSession_getDiagnostics.registerElevation("completed");
                    };
                    this.logger.info(`Delayed elevation (${f}): pending=${this._delayedElevationPending} queued=${this._delayedElevationQueued}`), this._delayedElevationPending && !this._delayedElevationQueued ? (this._delayedElevationQueued = !0, this._callOperationHandler.maybeRejectOperations([
                        "_RenegotiateIncoming",
                        "_RenegotiateOutgoing",
                        "_Renegotiate"
                    ]), (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getDiagnostics = _this_mediaSession.getDiagnostics()) === null || _this_mediaSession_getDiagnostics === void 0 ? void 0 : _this_mediaSession_getDiagnostics.registerElevation("attempted"), await this.mediaSession.reconnectAsync(g, !0, onReconnectCompleted)) : this.logger.info(`Delayed elevation: was not queued, pending=${this._delayedElevationPending} isQueued=${this._delayedElevationQueued}`);
                }
                onNegotiationFailure(g, f, S, v) {
                    const _ = v && v.sharing === this.mediaAgent.constants.MEDIA_STATE.send;
                    if (f === this.mediaAgent.constants.RENEGOTIATION_ERROR.glare) return this.screenSharingRenegotiationDeferred && _ && this.callStats.localStats.screenShare.negotiationStateChanged("rejected", "glare"), void (this.retryOutgoingRenegotiation = {
                        retry: !0,
                        causeId: S
                    });
                    const C = new Error(`Error in renegotiateOutgoing() -> rejecting hold for callId = ${this.callId}, reason=${f}`);
                    C.innerError = g, this.finishCallHoldResume(C), this.screenSharingRenegotiationDeferred && _ && (this.screenSharingRenegotiationDeferred.reject(g), this.screenSharingRenegotiationDeferred = null);
                }
                static getParticipantReasonFromTerminatedReason(g) {
                    switch(g){
                        case 1:
                            return 0;
                        case 9:
                            return 2;
                        case 10:
                            return 3;
                        case 2:
                            return 4;
                        case 24:
                            return 8;
                        case 3:
                            return 9;
                        case 4:
                            return 10;
                        case 14:
                            return 12;
                        case 0:
                        default:
                            return 11;
                        case 15:
                            return 13;
                        case 16:
                            return 14;
                        case 17:
                            return 15;
                        case 18:
                            return 16;
                        case 19:
                            return 17;
                        case 20:
                            return 18;
                        case 11:
                            return 19;
                        case 21:
                            return 20;
                        case 22:
                            return 21;
                        case 23:
                            return 22;
                        case 33:
                            return 25;
                        case 36:
                            return 26;
                        case 37:
                            return 27;
                        case 41:
                            return 30;
                        case 39:
                            return 28;
                        case 42:
                            return 31;
                        case 40:
                            return 29;
                        case 43:
                            return 32;
                        case 44:
                            return 33;
                        case 45:
                            return 34;
                        case 46:
                            return 35;
                        case 47:
                            return 36;
                        case 48:
                            return 37;
                        case 49:
                            return 38;
                        case 50:
                            return 39;
                        case 51:
                            return 40;
                        case 52:
                            return 41;
                        case 54:
                            return 42;
                        case 55:
                            return 44;
                        case 56:
                            return 45;
                        case 12:
                            return 23;
                        case 59:
                            return 46;
                        case 73:
                            return 59;
                        case 61:
                            return 47;
                        case 60:
                            return 48;
                        case 62:
                            return 49;
                        case 63:
                            return 50;
                        case 64:
                            return 5;
                        case 65:
                            return 51;
                        case 8:
                            return 52;
                    }
                }
                isRemoteParticipantInStaging(g) {
                    if (!g.endpointDetails) return !1;
                    for (const f of g.endpointDetails)if (!hasStagingGroup(f)) return !1;
                    return !0;
                }
                updateCallParticipantFromSignalingParticipant(g, f, S) {
                    if ((0, zi.every)(f.endpointDetails, (g)=>(g === null || g === void 0 ? void 0 : g.isLobby) || (g === null || g === void 0 ? void 0 : g.streamLobby))) return void g.setState(7, void 0, S);
                    const v = (0, zi.some)(f.endpointDetails, (g)=>g === null || g === void 0 ? void 0 : g.streamInformation), _ = f.endpointDetails && (0, zi.some)(f.endpointDetails, (g)=>g.mappedTo), C = _PluginlessCall.filterVirtualEndpoints(f.endpointDetails), E = C && C[0].mediaStreams, T = this.isRemoteParticipantInStaging(f);
                    if (E && E.length > 0) {
                        const f = E.every((g)=>"inactive" === g.direction);
                        let v = f ? 5 : T ? 8 : 3;
                        1 !== this.state || f || this.callUsesMixer || (v = 2), this.logger.info(`[updateCallParticipantFromSignalingParticipant]: with mediaStreams is not empty, ParticipantState is set to ${v}`), g.setState(v, void 0, S);
                    } else if (E || _ || v) {
                        const f = T ? 8 : 3;
                        this.logger.info(`[updateCallParticipantFromSignalingParticipant]: ParticipantState is set to ${f}, mediaStreams=${!!E}, hasMappedEndpoints=${_}, hasPlayerStreams=${v}`), g.setState(f, void 0, S);
                    }
                }
                handleSelfServerMutedState(g) {
                    const f = _PluginlessCall.filterVirtualEndpoints(this.localSignalingParticipant.endpointDetails), S = (0, zi.find)(f, (g)=>this._endpointId === g.endpointId), v = S && S.mediaStreams, _ = v && v.filter((g)=>"audio" === g.type || "audio-teleconferencing" === g.type), C = S && (S.stream || S.streamLobby);
                    if (C) {
                        var _C_serverMuted;
                        const f = (_C_serverMuted = C.serverMuted) !== null && _C_serverMuted !== void 0 ? _C_serverMuted : !1;
                        S.serverMuteVersion = 0, f !== this.isServerMuted && (this.isServerMuted = f, this.callTelemetry.recordEvent("_SelfParticipantUpdated", {
                            isServerMuted: this.isServerMuted
                        }), this.logger.info(`updateLocalParticipant: server muted set to ${f}`), this.event("serverMutedChanged").raise(f, g), this.updateCapabilities(g, !0), this.isServerMuted && this.setMuted(1, g));
                    } else if (_ && _.length > 0) {
                        const f = _.some((g)=>g.serverMuted);
                        f !== this.isServerMuted && (this.isServerMuted = f, this.callTelemetry.recordEvent("_SelfParticipantUpdated", {
                            isServerMuted: this.isServerMuted
                        }), this.logger.info(`updateLocalParticipant: server muted set to ${f}`), this.event("serverMutedChanged").raise(f, g), this.updateCapabilities(g, !0), this.handleServerMutedState(g));
                    }
                }
                checkIfIncomingServerMutedIsUpdated(g) {
                    const f = (0, zi.find)(this.localSignalingParticipant.endpointDetails, (g)=>g.participantId === this.localSignalingParticipant.participantId);
                    if (void 0 === f) return;
                    const S = (0, zi.find)(g.endpointDetails, (g)=>g.participantId === this.localSignalingParticipant.participantId);
                    handleServerMutedVersion(this.logger, f, S);
                }
                convertWiredPublishedState(g) {
                    if (!g) return;
                    const f = getPluginlessStateTypeFromWire(g.stateType);
                    return {
                        content: g.content,
                        stateType: f,
                        typeRank: g.typeRank,
                        stateId: g.stateId
                    };
                }
                updatePublishedStateModified(g, f) {
                    g !== this.currentUserSkypeIdentity.id || f && f !== this.participantId ? this._publishedStatesModified = 2 | this._publishedStatesModified : this._publishedStatesModified = 1 | this._publishedStatesModified;
                }
                updatePublishedStates(g) {
                    try {
                        let f = [];
                        (0, zi.forEach)(g.publishedStates, (g)=>{
                            f.push(this.convertWiredPublishedState(g));
                        }), (0, zi.isEqual)(this._participantPublishedStatesMap[g.id], f) || (0 !== f.length || void 0 !== this._participantPublishedStatesMap[g.id] && null !== this._participantPublishedStatesMap[g.id]) && (this._participantPublishedStatesMap[g.id] = f, this.updatePublishedStateModified(g.id));
                        const S = [];
                        (0, zi.forEach)(g.endpointDetails, (v)=>{
                            S.push(v.participantId), f = [], (0, zi.forEach)(v.publishedStates, (S)=>{
                                const _ = this.convertWiredPublishedState(S);
                                if (this._endpointPublishedStatesMap[g.id] || (this._endpointPublishedStatesMap[g.id] = {}, this._endpointPublishedStatesMap[g.id][v.participantId] = []), "clientMediaUfd" === _.stateType) try {
                                    const g = JSON.parse(JSON.stringify(_.content));
                                    this.mediaSession.registerRemoteQualityStateChangedEvent(g, v.participantId);
                                } catch (g) {
                                    this.logger.error(`Error while parsing state.content for ClientMediaUFD: ${g}`);
                                }
                                f.push(_);
                            }), this._endpointPublishedStatesMap[g.id] && !(0, zi.isEqual)(this._endpointPublishedStatesMap[g.id][v.participantId], f) && (0 !== f.length || null !== this._endpointPublishedStatesMap[g.id][v.participantId] && void 0 !== this._endpointPublishedStatesMap[g.id][v.participantId]) && (this._endpointPublishedStatesMap[g.id][v.participantId] = f, this.updatePublishedStateModified(g.id, v.participantId));
                        }), this._endpointPublishedStatesMap[g.id] && Object.keys(this._endpointPublishedStatesMap[g.id]).forEach((f)=>{
                            S.some((g)=>g === f) || (delete this._endpointPublishedStatesMap[g.id][f], this.updatePublishedStateModified(g.id, f));
                        });
                    } catch (g) {
                        this.logger.error(`updatePublishedStates ${JSON.stringify(g)}`);
                    }
                    this.logger.info(`updatePublishedStates ${getLoggableMriKeys(this._participantPublishedStatesMap)}`), this.logger.info(`updatePublishedStates ${getLoggableMriKeys(this._endpointPublishedStatesMap)}`);
                }
                removePublishedStatesByParticipant(g) {
                    this._endpointPublishedStatesMap[g] && delete this._endpointPublishedStatesMap[g], this._participantPublishedStatesMap[g] && delete this._participantPublishedStatesMap[g], this.updatePublishedStateModified(g);
                }
                findOrCreateTypeState(g) {
                    let f = this._publishedStates.typeStates.findIndex((f)=>f.type === g);
                    if (-1 === f) {
                        const S = {
                            participantStates: [],
                            type: g
                        };
                        this._publishedStates.typeStates.push(S), f = this._publishedStates.typeStates.length - 1;
                    }
                    return f;
                }
                processPublishedStates() {
                    this.logger.info(`processPublishedStates ${getLoggableMriKeys(this._participantPublishedStatesMap)}`), this.logger.info(`processPublishedStates ${getLoggableMriKeys(this._endpointPublishedStatesMap)}`);
                    try {
                        this._publishedStates || (this._publishedStates = {
                            typeStates: []
                        }), this._publishedStates.typeStates = [];
                        for (const g of Object.keys(this._participantPublishedStatesMap)){
                            const f = this._participantPublishedStatesMap[g];
                            (0, zi.forEach)(f, (f)=>{
                                const S = this.findOrCreateTypeState(f.stateType), v = {
                                    id: g,
                                    publishedState: {
                                        content: f.content,
                                        stateId: f.stateId,
                                        typeRank: f.typeRank
                                    }
                                };
                                this._publishedStates.typeStates[S].participantStates.push(v);
                            });
                        }
                        for (const g of Object.keys(this._endpointPublishedStatesMap))for (const f of Object.keys(this._endpointPublishedStatesMap[g]))this._endpointPublishedStatesMap[g][f].forEach((S)=>{
                            const v = this.findOrCreateTypeState(S.stateType), _ = {
                                id: f,
                                publishedState: {
                                    content: S.content,
                                    stateId: S.stateId,
                                    typeRank: S.typeRank
                                }
                            }, C = {
                                id: g,
                                endpoints: [
                                    _
                                ]
                            }, E = this._publishedStates.typeStates[v].participantStates.filter((f)=>f.id === g);
                            E && E.length > 0 ? (E[0].endpoints || (E[0].endpoints = []), E[0].endpoints.push(_)) : this._publishedStates.typeStates[v].participantStates.push(C);
                        });
                        this.event("publishedStatesChanged").raise(this._publishedStates), this.raiseChanged();
                    } catch (g) {
                        this.logger.error(`processPublishedStates ${g}}`);
                    }
                }
                updateLocalParticipant(g, f) {
                    var _this_screenSharingControl;
                    const S = this.logger.createFnLogger("updateLocalParticipant", f);
                    this.checkIfIncomingServerMutedIsUpdated(g), this.localSignalingParticipant.endpointDetails = g.endpointDetails, this.localSignalingParticipant.role = g.role, this.setMeetingRole(g.meetingRole), this.setAdvancedMeetingRole(g.advancedMeetingRole), this.setMeetingRoles(g.meetingRoles), this.setParticipantType(g.participantType), this.setDisplayName(g.displayName), this.setPropertyBag(g.propertyBag), this.setPropertyRosterVersion(g.version), this.setMaskedIdentityDetails(g.isIdentityMasked, g.maskedIdSeqNumber, g.maskedId), this.setOtpIdentity(g.otpIdentity), this.localSignalingParticipant.tenantId = g.tenantId, this.localSignalingParticipant.isLobby = g.isLobby, g.joinAsStreamingUser && (this.localSignalingParticipant.joinAsStreamingUser = g.joinAsStreamingUser, this.setJoinAsStreamingUser(g.joinAsStreamingUser)), void 0 !== g.enableCaptcha && this.setEnableCaptcha(g.enableCaptcha), this.callTelemetry.setTenantId(g.tenantId), this.callStats.setTenantId(g.tenantId);
                    const v = this.localSignalingParticipant.isLobby;
                    g.endpointDetails && this.updateLocalParticipantEndpoints(g.endpointDetails), this.updatePublishedStates(g), this.handleSelfServerMutedState(f);
                    const _ = this.getLocalSignalingEndpointDetails();
                    this._callInLobby = v || !!(_ === null || _ === void 0 ? void 0 : _.streamLobby), this.signalingSession.participantManager.localParticipant.isStaging = g.isStaging;
                    const C = this.signalingSession.participantManager.localParticipant.isStaging;
                    S.info(`callInLobby = ${v}, callSetupComplete = ${this._callIsSetupComplete}, callIsHeld = ${this.callIsHeld()}, isStaging = ${C}`), !this._callIsSetupComplete || this.callIsHeld() || callStateIsAnyOf(this.state, [
                        11,
                        12
                    ]) || (v ? this.setCallState(10, f) : C && callStateIsAnyOf(this.state, [
                        3,
                        13,
                        10,
                        9,
                        2
                    ]) ? this.setCallState(13, f) : this.setCallState(3, f));
                    const E = _PluginlessCall.getStreamsFromEndpoints(g.endpointDetails);
                    if (this.callTelemetry.recordEvent("_UpdateLocalParticipantStream", getStreamInformation(E), f), this.streamManager.updateStreams(E, f), this.updateCapabilities(f, !0), this.allowScreenSharingControl() && ((_this_screenSharingControl = this.screenSharingControl) === null || _this_screenSharingControl === void 0 ? void 0 : _this_screenSharingControl.isInternalViewerControlEnabled())) {
                        const f = g.endpointDetails.find((g)=>this._endpointId === g.endpointId), S = this.participants.find((g)=>g.streams[1].some((g)=>g.isAvailable));
                        this.screenSharingControl.startOrStopControlForViewer(this.isSomeoneSharing, S, f);
                    }
                }
                modalitiesAreHold(g) {
                    return !(g.audio && "inactive" !== g.audio || g.video && "inactive" !== g.video || g.sharing && "inactive" !== g.sharing);
                }
                toneToString(g) {
                    switch(g){
                        case 0:
                            return "0";
                        case 1:
                            return "1";
                        case 2:
                            return "2";
                        case 3:
                            return "3";
                        case 4:
                            return "4";
                        case 5:
                            return "5";
                        case 6:
                            return "6";
                        case 7:
                            return "7";
                        case 8:
                            return "8";
                        case 9:
                            return "9";
                        case 10:
                            return "*";
                        case 11:
                            return "#";
                        default:
                            return null;
                    }
                }
                static streamingStatetoMediaStreamState(g) {
                    switch(g){
                        case "started":
                            return 0;
                        case "active":
                            return 2;
                        case "inactive":
                            return 1;
                        case "stopped":
                            return 3;
                        default:
                            return 4;
                    }
                }
                static streamingDirectionToMediaDirectionMapping(g) {
                    switch(g){
                        case "send":
                            return 1;
                        case "receive":
                            return 0;
                        default:
                            return;
                    }
                }
                static convertMuteScope(g) {
                    switch(g){
                        case 0:
                            return "EveryoneElse";
                        case 1:
                            return "SpecifiedParticipants";
                        default:
                            return;
                    }
                }
                callIsHeld() {
                    return 4 === this.state || 5 === this.state;
                }
                inLocalHold() {
                    return this.isHoldInProgress || 4 === this.state;
                }
                telemetryDataFromCallStartOptions(g) {
                    const f = {};
                    return g.muteFlags && (f.muteMicrophone = !!(1 & g.muteFlags), f.muteSpeaker = !!(2 & g.muteFlags)), Object.keys(f).length ? f : void 0;
                }
                reconnect() {
                    const g = generateCauseId();
                    return this.mediaSession.reconnectAsync(g);
                }
                async provideCallQualityFeedback(g, f, S, v) {}
                async showCQFInfo(g, f) {
                    throw new Error("Not implemented");
                }
                async isCqfRendered(g) {}
                async provideCallQualityFeedbackEx(g, f, S, v, _, C) {}
                testTriggerMediaRelayWhiteListingIssue() {
                    this.logger.info("Simulating media relay whitelisting issue for test purposes");
                    const g = this.mediaSession.mediaSession.callback, f = {
                        type: "NetworkRelaysNotReachable",
                        value: "Bad",
                        isLocalSource: !0,
                        mediaType: "Audio"
                    };
                    g.onQualityChanged(f);
                    const S = {
                        direction: "send",
                        stream: "failed",
                        content: "audio"
                    };
                    g.onAudioStateChanged(S);
                }
                async getMediaTelemetry(g = !1) {
                    return this.mediaSession && (this.callStats.setMediaStats(await this.mediaSession.getStatsAsync(g)), this.appendInfoToCallStats()), this.callStats.buildMediaTelemetry();
                }
                getMediaSessionStats() {
                    var _this_mediaSession;
                    return (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getMediaStatsReport();
                }
                async getMediaSessionStatsAsync() {
                    var _this_mediaSession;
                    return (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getMediaStatsReport();
                }
                getDiagnosticsForE2E() {
                    var _this_mediaSession;
                    return (_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : _this_mediaSession.getDiagnostics().e2eDiagnostics;
                }
                appendInfoToCallStats() {
                    var _this_screenSharingControl, _this_mediaSession_getMediaControlPlaneInstance, _this_mediaSession;
                    this.callStats.appendDataChannelInfo(this.dataChannel.getTelemetry()), this.callStats.appendSharingControlInfo((_this_screenSharingControl = this.screenSharingControl) === null || _this_screenSharingControl === void 0 ? void 0 : _this_screenSharingControl.isScreenSharingControlEnabled()), this.callStats.appendMediaControlPlaneInfo(JSON.stringify((_this_mediaSession = this.mediaSession) === null || _this_mediaSession === void 0 ? void 0 : (_this_mediaSession_getMediaControlPlaneInstance = _this_mediaSession.getMediaControlPlaneInstance()) === null || _this_mediaSession_getMediaControlPlaneInstance === void 0 ? void 0 : _this_mediaSession_getMediaControlPlaneInstance.getTelemetryReport()));
                }
                getMediaLogs() {
                    return this.mediaAgent.getMediaLogs();
                }
                testSetCallState(g) {
                    this.logger.info(`Overwriting call state for test purposes: ${this.state} -> ${g} `), this.state = g;
                }
                testSetCallType(g) {
                    this.logger.info(`Overwriting call state for test purposes: ${this.callType} -> ${g} `), this.callType = g;
                }
                addGroupModality(g, f = generateCauseId()) {
                    const S = this.logger.createFnLogger("AddGroupModality", f);
                    if (!g.threadId && !g.groupId) return Promise.reject(getRejectTransactionEnd("No threadId/groupId was provided."));
                    if (6 === this.state || 7 === this.state) return S.info(`Not adding modality because CallState is ${this.state} groupId=${scrubMriOrOmit(g.groupId)}, threadId = ${getLoggableThreadId(g.threadId)} messageId = ${g.messageId}`), Promise.reject(getRejectTransactionEnd("TransactionDisallowed"));
                    let v;
                    if (g.additionalData) try {
                        v = JSON.stringify(g.additionalData);
                    } catch (f) {
                        S.logFailure(`additionalData: ${g.additionalData} is not valid Json, error: ${f}`);
                        const v = {
                            code: Li.BadRequest,
                            subCode: 0,
                            phrase: `additionalData is not valid Json, error: ${f}`
                        };
                        return Promise.reject(v);
                    }
                    if (S.info(`groupId=${scrubMriOrOmit(g.groupId)}, threadId = ${getLoggableThreadId(g.threadId)} messageId = ${g.messageId} additionalData = ${scrubMriOrOmit(v)}`), this._enableAddModalityGeneric) {
                        const v = {
                            groupContext: {
                                id: g.groupId
                            },
                            groupChat: {
                                threadId: g.threadId,
                                messageId: g.messageId
                            }
                        };
                        return this.signalingSession.addModalityAsync(v, f).catch((g)=>(S.logFailure(getPrintableObject(g)), Promise.reject(g)));
                    }
                    {
                        const _ = {
                            groupId: g.groupId,
                            threadId: g.threadId,
                            messageId: g.messageId,
                            additionalData: v
                        };
                        return this.signalingSession.addGroupModalityAsync(_, f).catch((g)=>(S.logFailure(getPrintableObject(g)), Promise.reject(g)));
                    }
                }
                addBroadcastModality(g, f) {
                    const S = this.logger.createFnLogger("AddBroadcastModality", f);
                    return Promise.resolve().then(()=>{
                        this.signalingSession.addBroadcastModalityAsync(g, f);
                    }).catch((g)=>(S.logFailure(getPrintableObject(g)), Promise.reject(getRejectTransactionEnd(g)))).then(()=>this._callOperationHandler.waitForOperation("AddBroadcastModality")).catch((g)=>{
                        throw this.callTelemetry.updateOperationData("AddBroadcastModality", {
                            error: getPIISafeObject(g)
                        }, f), S.logFailure(g), g;
                    });
                }
                static convertQualityEventType(g) {
                    switch(g){
                        case "NetworkSendQuality":
                            return 1;
                        case "NetworkRecvQuality":
                            return 2;
                        case "NetworkDelay":
                            return 3;
                        case "NetworkBandwidthLow":
                            return 4;
                        case "NetworkReconnect":
                            return 5;
                        case "NetworkPacketLoss":
                            return 6;
                        case "NetworkJitter":
                            return 7;
                        case "NetworkRateMatching":
                            return 8;
                        case "DeviceCaptureNotFunctioning":
                            return 9;
                        case "DeviceRenderNotFunctioning":
                            return 10;
                        case "DeviceRenderGlitches":
                            return 11;
                        case "DeviceLowSNR":
                            return 12;
                        case "DeviceLowSpeechLevel":
                            return 13;
                        case "DeviceClipping":
                            return 14;
                        case "DeviceEcho":
                            return 15;
                        case "DeviceNearEndToEchoRatio":
                            return 16;
                        case "DeviceHalfDuplexAec":
                            return 17;
                        case "DeviceMultipleEndpoints":
                            return 18;
                        case "DeviceHowling":
                            return 19;
                        case "DeviceRenderZeroVolume":
                            return 20;
                        case "DeviceRenderMute":
                            return 21;
                        case "NetworkSendCatastrophic":
                            return 22;
                        case "NetworkRecvCatastrophic":
                            return 23;
                        case "CpuInsufficient":
                            return 24;
                        case "DeviceCaptureMute":
                            return 25;
                        case "DeviceCaptureNotMuteButSilent":
                            return 26;
                        case "DeviceSpeakWhileMuted":
                            return 27;
                        case "VideoVbssRendered":
                            return 28;
                        case "NetworkEthernetInterfaceUsed":
                            return 29;
                        case "NetworkWlanInterfaceUsed":
                            return 30;
                        case "NetworkWwanInterfaceUsed":
                            return 31;
                        case "NetworkRelaysNotReachable":
                            return 32;
                        case "VideoCapturerDeviceStartFailed":
                            return 33;
                        case "VideoCapturerDeviceStartTimedOut":
                            return 34;
                        case "VideoCapturerDeviceStartFailureLackSystemRes":
                            return 35;
                        case "VideoCapturerDeviceStartFailureMFResConflict":
                            return 36;
                        case "NoNetwork":
                            return 37;
                        case "NetworkNotWorking":
                            return 38;
                        case "DeviceCaptureNotFunctioningDeviceInUse":
                            return 39;
                        case "DeviceRenderNotFunctioningDeviceInUse":
                            return 40;
                        case "VideoCaptureDeviceFreeze":
                            return 45;
                        case "ZeroCaptureDevicesEnumerated":
                            return 43;
                        case "ZeroRenderDevicesEnumerated":
                            return 44;
                        case "VideoCapturePermissionDenied":
                            return 47;
                        case "ScreenshareRecordingDisabled":
                            return 55;
                        case "AudioCapturePermissionDenied":
                            return 46;
                        case "VideoCaptureFreezeRecovered":
                            return 48;
                        case "DeviceRenderHowling":
                            return 49;
                        case "PresentationAudioLoopbackDeviceState":
                            return 53;
                        case "RemoteNetworkConnectivityIssue":
                            return 52;
                        case "AudioCaptureUltrasoundDetected":
                            return 54;
                        case "MusicModeNotAvailable":
                            return 57;
                        case "CameraLighting":
                            return 61;
                        case "AudioLoopbackDeviceReady":
                            return 63;
                        case "NoRequiredVideoCodecs":
                            return 64;
                        case "SpatialAudioMUCHUnavailable":
                            return 65;
                        case "AudioMixMUCHUnavailable":
                            return 80;
                        default:
                            return;
                    }
                }
                static convertQualityLevel(g) {
                    switch(g){
                        case "Unknown":
                            return 0;
                        case "Good":
                            return 1;
                        case "Poor":
                            return 2;
                        case "Bad":
                            return 3;
                        default:
                            return;
                    }
                }
                static convertMediaType(g) {
                    switch(g){
                        case "Audio":
                            return 0;
                        case "Video":
                            return 1;
                        case "ScreenShare":
                            return 2;
                        case "Data":
                            return 3;
                        default:
                            return;
                    }
                }
                getPluginlessPublishLevel(g) {
                    switch(g){
                        case "user":
                            return "user";
                        case "endpoint":
                            return "endpoint";
                        default:
                            throw "Invalid level type.";
                    }
                }
                setIsEmergency(g) {
                    this.logger.info(`Set isEmergency:${g}`), this.isEmergency = g, this.callTelemetry.setIsEmergency(g);
                }
                static filterVirtualEndpoints(g) {
                    return g && (0, zi.filter)(g, (g)=>!g.mappedTo);
                }
                mapDataChannelSourceIdToParticipant(g) {
                    let f = null;
                    return f = 1 === this.callType ? this.participants[0] : (0, zi.find)(this.participants, (f)=>f.hasSourceId(3, g)), (f === null || f === void 0 ? void 0 : f.id) ? this.logger.info(`ParticipantId: ${scrubMriOrOmit(f.id)} to SourceId: ${g}`) : this.logger.warn(`No Participant found for SourceId: ${g}`), f;
                }
                getDataChannelSourceId() {
                    const g = (0, zi.find)(this.endpoints.endpointDetails, (g)=>null !== g && g.participantId === this._participantId);
                    if (!g) return this.logger.warn(`No participantLeg found for participantId: ${this._participantId}`), -1;
                    if (!g.mediaStreams) return this.logger.warn(`ParticipantLeg ${this._participantId} does not have valid mediaStreams`), -1;
                    const f = (0, zi.find)(g.mediaStreams, (g)=>3 === mapMediaTypeStringToMediaType(g.type));
                    return f ? f.sourceId : (this.logger.warn(`participantLeg ${this._participantId} has no data channel`), -1);
                }
                initializeLiveStreamConfigProvider() {
                    const g = "MDN_MIDDLELANE_TEAMS", f = "liveStream", S = this.ecsProvider.getEcsConfig(g, f), v = this.ecsProvider.getEcsConfig("ConfigIDs", g);
                    this._liveStreamConfigProvider = new nt(S, null, v, this.logger.createChild("LiveStreamConfigProvider"));
                }
                isMediaSending(g) {
                    return this.mediaStateConfigurationHelper.isSending(g);
                }
                async setAudioStreamConnectedAsync(g) {
                    this.isAudioStreamConnected = g;
                }
                async setSpamRiskLevelAsync(g) {
                    this.spamRiskLevel = g;
                }
                async setSpamStirAttestationAsync(g) {
                    this.spamStirAttestation = g;
                }
                async setDominantSpeakerInfoAsync(g) {
                    this.dominantSpeakerInfo = g;
                }
                async setSlowedDownActiveTalkerInfoAsync(g) {
                    this.slowedDownActiveTalkerInfo = g;
                }
                constructor(g, f, S, v, _, C, E, T, I, b, A, R, P, w, M, O, D, N){
                    super(S), this.signalingAgent = g, this.mediaAgent = f, this.logger = S, this.telemetryLoggers = v, this.currentUserSkypeIdentity = _, this.groupId = C, this.threadId = E, this.ecsProvider = b, this.trouterService = A, this.accountConfiguration = R, this.vdi3diagnostics = N, this.participants = [], this.isServerMuted = !1, this.isSpeakerMuted = !1, this.isVideoOn = !1, this.isScreenSharingOn = !1, this.callStartedAt = null, this.callHeldAt = null, this.conversationStartTime = null, this.callType = -1, this.failureType = 2, this.isEmergency = !1, this.contentSharingSessions = [], this.endpoints = {
                        endpointDetails: []
                    }, this.isPreheatEnabled = !1, this.localMediaStreams = [], this.enableRealtimeTelemetry = !1, this.isSharedLineAppearanceV2Activated = !1, this.enableCaptcha = !1, this.requestedHoldState = !1, this.mediaStateConfigurationHelper = new Mr({
                        mediaStates: [
                            getMediaState(0, 4)
                        ]
                    }), this.canToggleAudio = !0, this.canToggleVideo = !0, this.connectCallPromise = Promise.resolve(), this.canToggleScreenSharing = !0, this.callUsesMixer = !1, this.isEscalationInProgress = !1, this.retryOutgoingRenegotiation = {
                        retry: !1,
                        causeId: ""
                    }, this.isHoldInProgress = !1, this.isMuteOnHold = !1, this.callSetupFailed = !1, this.isSomeoneSharing = !1, this.isSomeoneStreamingVideo = !1, this.activeTalkersHistory = [], this.callGotConnected = !1, this.mediaRelayWhiteListingIssue = !1, this.signalingSessionCallOptions = null, this.tsCallingTelemetryReported = !1, this.isCallSetupTelemetrySent = !1, this._isAudioStreamConnected = !1, this._wasAudioStreamConnected = !1, this._callInLobby = !1, this._callIsSetupComplete = !1, this._transferState = 0, this._parkState = 0, this._muteState = 0, this._callCreationTime = (new Date).getTime(), this._commandUrlPresence = 0, this._capabilities = {
                        canMuteOthers: !1,
                        canUnmuteSelf: !1
                    }, this._spamRiskLevel = null, this._spamStirAttestation = null, this._callMode = 0, this._isUpdatePropertiesSpecifiedAllowedByEcs = !1, this._deferUsingMicrotask = !1, this._enableResolveScreenSharingWhenNegotiationComplete = !1, this._publishedStatesModified = 0, this._participantPublishedStatesMap = {}, this._endpointPublishedStatesMap = {}, this._participantChangedEventSkipConfig = {
                        skipParticipantsUpdatesOnCall: !0
                    }, this._dominantSpeakerChangedEventSkipConfig = {
                        skipDominantSpeakerUpdatesOnCall: !0
                    }, this.receiveOnlyAudioOnCallStart = !1, this.lastContributingSourceReport = Date.now(), this.instanceNumber = _PluginlessCall.instanceCount++ % 1e3, this._enableMuteAsync = !1, this._enableUnmuteAsync = !1, this._enableEndpointMeetingRoleCheckForClientCapability = !1, this._enableUserMeetingRolesCheckForClientCapability = !1, this._enableAddModalityGeneric = !1, this._delayedElevationPending = !1, this._delayedElevationQueued = !1, this.startVM = (g, f, S, v, _)=>this.signalingSession.startOutgoingCall(S, v, {
                            voicemailResourcePath: f.callVoicemailStartOptions.voicemailResourcePath,
                            voicemailItemId: f.callVoicemailStartOptions.voicemailItemId,
                            callToVoicemail: !0
                        }, Date.now() - _, g), this.getSignalingSessionCallOptions = (g)=>{
                        var _g_callStartOptions, _g_callStartOptions1, _g_callStartOptions2, _g_callStartOptions3, _g_callStartOptions4, _g_callStartOptions5, _g_callStartOptions6, _g_callStartOptions7, _g_callStartOptions8;
                        const f = {
                            suppressDialout: !g.callStartOptions.ringOthers,
                            isPreheatOnly: 1 == (1 & g.callStartOptions.preheatFlags),
                            onBehalfOf: this.onBehalfOfMri,
                            onBehalfOfUserDisplayName: this.onBehalfOfUserDisplayName,
                            callQueueContext: (_g_callStartOptions = g.callStartOptions) === null || _g_callStartOptions === void 0 ? void 0 : _g_callStartOptions.callQueueContext,
                            muted: 1 == (1 & g.callStartOptions.muteFlags),
                            invitationType: g.invitationType,
                            participantsToNudge: g.participantsToNudge,
                            routingFlags: g.callStartOptions && g.callStartOptions.routingFlags,
                            parkContext: g.parkContext,
                            pickupCode: g.pickupCode,
                            scenario: g.callStartOptions && g.callStartOptions.scenario,
                            callUsesMixer: this.callUsesMixer,
                            clientEndpointCapabilities: g.callStartOptions.clientEndpointCapabilities,
                            clientEndpointDebugContent: g.callStartOptions.clientEndpointDebugContent,
                            isEmergency: this.isEmergency,
                            meetingData: this.meetingData,
                            meetingPreferences: g.meetingPreferences,
                            alternateId: g.callStartOptions ? g.callStartOptions.alternateId : null,
                            meetingRegistrationId: g.callStartOptions ? g.callStartOptions.meetingRegistrationId : "",
                            participantPin: g.callStartOptions ? g.callStartOptions.participantPin : "",
                            additionalEndpointProperties: ((_g_callStartOptions1 = g.callStartOptions) === null || _g_callStartOptions1 === void 0 ? void 0 : _g_callStartOptions1.additionalEndpointProperties) || null,
                            publishedStates: ((_g_callStartOptions2 = g.callStartOptions) === null || _g_callStartOptions2 === void 0 ? void 0 : _g_callStartOptions2.publishedStates) || null,
                            targetApplicationType: (_g_callStartOptions3 = g.callStartOptions) === null || _g_callStartOptions3 === void 0 ? void 0 : _g_callStartOptions3.targetApplicationType,
                            isHuddleGroupCall: (_g_callStartOptions4 = g.callStartOptions) === null || _g_callStartOptions4 === void 0 ? void 0 : _g_callStartOptions4.isHuddleGroupCall,
                            captchaContentJson: (_g_callStartOptions5 = g.callStartOptions) === null || _g_callStartOptions5 === void 0 ? void 0 : _g_callStartOptions5.captchaContentJson,
                            customHeaderContext: (_g_callStartOptions6 = g.callStartOptions) === null || _g_callStartOptions6 === void 0 ? void 0 : _g_callStartOptions6.customHeaderContext,
                            participationPreferences: (_g_callStartOptions7 = g.callStartOptions) === null || _g_callStartOptions7 === void 0 ? void 0 : _g_callStartOptions7.participationPreferences,
                            callingLineIdentity: g.callStartOptions ? g.callStartOptions.callingLineIdentity : null
                        }, S = (_g_callStartOptions8 = g.callStartOptions) === null || _g_callStartOptions8 === void 0 ? void 0 : _g_callStartOptions8.invitationDataJson;
                        if (S) try {
                            f.invitationData = JSON.parse(S);
                        } catch (g) {
                            throw new Error(`Invalid JSON in invitationData: ${S}`);
                        }
                        return f;
                    }, this.startOutgoingCall = (g, f, S, v, _)=>this.signalingSession.startOutgoingCall(S, v, this.getSignalingSessionCallOptions(f), Date.now() - _, g), this.joinGivenConversation = (g, f, S, v, _, C)=>{
                        var _f_callStartOptions, _f_callStartOptions1, _f_callStartOptions2;
                        const E = 1 == (1 & f.callStartOptions.muteFlags), T = 1 == (1 & f.callStartOptions.preheatFlags), I = (_f_callStartOptions = f.callStartOptions) === null || _f_callStartOptions === void 0 ? void 0 : _f_callStartOptions.invitationDataJson, b = (_f_callStartOptions1 = f.callStartOptions) === null || _f_callStartOptions1 === void 0 ? void 0 : _f_callStartOptions1.sharedLineCallInvitationContentJson;
                        this.logger.info(`[${g}][joinGivenConversation] muted=${E}, isPreheatOnly=${T},\n            sharedLineCallInvitationContentJson=${b}, invitationDataJson=${I}`);
                        const A = {
                            muted: E,
                            isPreheatOnly: T,
                            clientEndpointCapabilities: f.callStartOptions.clientEndpointCapabilities,
                            clientEndpointDebugContent: f.callStartOptions.clientEndpointDebugContent,
                            isEmergency: this.isEmergency,
                            meetingData: this.meetingData,
                            meetingPreferences: f.meetingPreferences,
                            meetingRegistrationId: f.callStartOptions ? f.callStartOptions.meetingRegistrationId : "",
                            participantPin: f.callStartOptions ? f.callStartOptions.participantPin : "",
                            additionalEndpointProperties: f === null || f === void 0 ? void 0 : (_f_callStartOptions2 = f.callStartOptions) === null || _f_callStartOptions2 === void 0 ? void 0 : _f_callStartOptions2.additionalEndpointProperties,
                            applyServerMute: f === null || f === void 0 ? void 0 : f.applyServerMute,
                            publishedStates: f === null || f === void 0 ? void 0 : f.callStartOptions.publishedStates,
                            invitationData: f === null || f === void 0 ? void 0 : f.callStartOptions.invitationDataJson,
                            captchaContentJson: f === null || f === void 0 ? void 0 : f.callStartOptions.captchaContentJson,
                            callQueueContext: f === null || f === void 0 ? void 0 : f.callStartOptions.callQueueContext,
                            participationPreferences: f === null || f === void 0 ? void 0 : f.callStartOptions.participationPreferences
                        };
                        if (b) try {
                            A.sharedLineCallInvitationContent = JSON.parse(b);
                        } catch (g) {
                            throw new Error(`Invalid JSON in sharedLineCallInvitationContent: ${b}`);
                        }
                        if (I) try {
                            A.invitationData = JSON.parse(I);
                        } catch (g) {
                            throw new Error(`Invalid JSON in invitationDataJson: ${I}`);
                        }
                        return this.signalingSession.joinGivenConversation(C, this.callId, S, v, Date.now() - _, A, g);
                    }, this.getParticipantByLegId = (g, f, S)=>{
                        this.logger.info(`getMriByParticipantLegId[${S}] participantLegId ${g}`);
                        for (const S of f.participants)for (const f of S.endpoints.endpointDetails)if (f && f.participantId && f.participantId === g) return S;
                        return null;
                    }, this.executeCallTransfer = (g, f, S, v)=>{
                        this._setTransferState(1);
                        const _ = this._callOperationHandler.createPendingOperation("_CallTransferInProgress", void 0, f, {
                            preconditionTags: [
                                "NOT_SUPPORTED_IN_STREAMING_MODE"
                            ]
                        });
                        return 0 === S ? this.signalingSession.transferCallAsync(g, "TransferTypeStandard", void 0, v, f) : 2 === S && this.signalingSession.transferCallAsync(g, "TransferTypeVoicemail", void 0, v, f), _;
                    }, this.executeConsultCallTransfer = (g, f, S, v, _)=>{
                        this._setTransferState(1);
                        const C = this._callOperationHandler.createPendingOperation("_CallTransferInProgress", void 0, v, {
                            preconditionTags: [
                                "NOT_SUPPORTED_IN_STREAMING_MODE"
                            ]
                        });
                        return this.signalingSession.consultTransferCallAsync(g, f, S, v, _), C;
                    }, this.createUpdateParticipantPromise = (g, f)=>this._callOperationHandler.createPendingOperation("UpdateParticipantsProperties", g, f), this._getCallEndOperation = ()=>this._callOperationHandler.hasPendingOperation("StopCall") ? this._callOperationHandler.waitForOperation("StopCall") : this._callOperationHandler.hasPendingOperation("Reject") ? this._callOperationHandler.waitForOperation("Reject") : this._callOperationHandler.hasPendingOperation("CallRedirect") ? this._callOperationHandler.waitForOperation("CallRedirect") : Promise.resolve(), this._onAcknowledgeError = (g, f, S, v)=>{
                        S.logFailure(g);
                        let _, C = {
                            code: 2,
                            success: !1,
                            fatal: !0
                        }, E = 7;
                        throw isPhaseError("SendAttach", g) && (_ = {
                            code: Li.InternalServerError,
                            subCode: Fi.AttachFailed,
                            phrase: ji.AttachFailed
                        }), isPhaseError("ProcessIncomingCallRequest", g) && (_ = {
                            code: Li.NotAcceptable,
                            subCode: Fi.AttachActionFailed,
                            phrase: ji.BadNotificationPayload
                        }, C = {
                            code: 0,
                            success: !1,
                            fatal: !0
                        }), isOneOfPhaseErrors(Wi, g) && (E = 47), (g === null || g === void 0 ? void 0 : g.error) && g.error.type === this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer && (_ = {
                            code: Li.MediaError,
                            subCode: Fi.MediaOfferProcessingError,
                            phrase: ji.IncompatibleOffer
                        }), this.callTelemetry.updateOperationData("Acknowledge", {
                            phases: v,
                            error: getPIISafeObject(g)
                        }, f), this._callOperationHandler.maybeRejectOperation("Acknowledge", C, void 0, f), this.stopInternal({
                            rejectReason: _,
                            causeId: f,
                            terminatedReason: E
                        }), C;
                    }, this._onAcknowledgeSuccess = (g, f, S)=>(g.logSuccess("success"), this.callTelemetry.updateOperationData("Acknowledge", {
                            phases: f
                        }, S), {
                            code: 1,
                            success: !0
                        }), this._processOfferedModalities = (g, f)=>{
                        this.handleOfferedModalities(g, f);
                        const S = this.callUsesMixer ? void 0 : {
                            modalityOverride: g
                        };
                        return this.updateMediaModalities(S, f);
                    }, this._handleOfferProcessingError = (g, f, S)=>{
                        var _g_error;
                        return S.logFailure(`handleOfferProcessingError=${g}`), (g === null || g === void 0 ? void 0 : (_g_error = g.error) === null || _g_error === void 0 ? void 0 : _g_error.type) === this.mediaAgent.constants.MEDIA_ERROR.incompatibleOffer ? (this.callTelemetry.recordEvent("IncompatibleOffer", void 0, f), this.signalingSession.supportsNewOfferRequest() ? (this.newOfferRequestDeferred = new ct, this.attachToCallAndGetOffer.promise.then(()=>this.mediaSession.rejectNegotiationAsync(g.error, f)).then(()=>this.signalingSession.requestNewOffer(this.mediaSession.getAcceptedTypes(), f)).then(()=>this.newOfferRequestDeferred.promise).then((g)=>this.mediaSession.processOfferAsync(g, f)).catch((g)=>(this.callTelemetry.recordEvent("NewOfferFailed", getPrintableObject(g), f), Promise.reject(g)))) : Promise.reject(g)) : Promise.reject(g);
                    }, this._trySendProvisionalMediaAnswer = (g)=>Promise.resolve(void 0).then(()=>this.mediaSession.createAnswerAsync(!0, g)).then((g)=>g.blob ? (this.mediaAcknowledgmentOperation = this._callOperationHandler.createPendingOperation("_MediaAcknowledgment", void 0, generateCauseId(), {
                                preconditionTags: [
                                    "NOT_SUPPORTED_IN_STREAMING_MODE"
                                ]
                            }), this.signalingSession.setProvisionalAnswerAsync(g).then(()=>this.mediaAcknowledgmentOperation)) : Promise.resolve(void 0)), this.checkForCallIdUpdate = (g, f)=>{
                        if (this.callId !== g) {
                            this.logger.info(`[${f}][checkForCallIdUpdate] old=${this.callId}, new=${g}`), this.setCallId(g);
                            try {
                                this.event("callIdChanged").raise(this.callId);
                            } catch (g) {
                                this.logger.error(`Error raising call ID change: ${g}`);
                            }
                            this.raiseChanged();
                        }
                    }, this.handleRemoteParticipantStateInOneToOneCall = (g)=>{
                        if (!this.callUsesMixer && 3 === this.state) {
                            const f = this.participants[0];
                            f && f.setState(3, void 0, g);
                        }
                    }, this.handleRemoteParticipantJoinedInOneToOneCall = (g, f)=>{
                        if (!this.callUsesMixer && 3 === this.state) {
                            const S = this.participants.filter((f)=>f.id === g.id)[0];
                            S ? S.setState(3, void 0, f) : this.logger.logFailure(`[${f}][handleRemoteParticipantJoinedInOneToOneCall]unable to find particpant ${scrubMriOrOmit(g.id)}`);
                        }
                    }, this.handleRemoteParticipantStateInObservingCall = (g, f, S)=>{
                        const v = f.isLobby;
                        if (8 === this.state) {
                            const f = v ? 7 : 3;
                            g.setState(f, void 0, S);
                        }
                    }, this.getTelemetryFromPhaseExecution = (g)=>{
                        const f = {
                            phase: g.phase,
                            phases: g.phases,
                            code: g.error && g.error.code,
                            subCode: g.error && g.error.subCode,
                            message: g.error && g.error.message,
                            error: g.error
                        };
                        return (f.code || f.message) && delete f.error, f;
                    }, this._setTransferState = (g)=>{
                        this.transferState !== g && (this.logger.info(`Transfer: state set: ${g}`), this._transferState = g, this.callTelemetry.recordEvent("_SetTransferState", {
                            state: g
                        }), this.raiseChanged());
                    }, this._setParkState = (g)=>{
                        this.parkState !== g && (this.logger.info(`Parking: state set: ${g}`), this._parkState = g, this.callTelemetry.recordEvent("_SetParkState", {
                            state: g
                        }), this.raiseChanged());
                    }, this.prepareNegotiationResultForTelemtry = (g)=>({
                            isComplete: g.isComplete,
                            activeModalities: g.activeModalities,
                            configuredModalities: g.configuredModalities,
                            initiator: scrubMriOrOmit(g.initiator),
                            attemptedModalities: g.attemptedModalities,
                            offeredModalities: g.offeredModalities
                        }), this.prepareTelemetryForOfferAnswer = (g)=>g && g.mediaContent && {
                            isRenegotiation: !!g.renegotiation,
                            isEscalation: !!g.mediaContent.isTwoPartyToMultiPartyEscalation,
                            mediaTypes: g.mediaTypes,
                            newOffer: g.mediaContent.newOffer
                        }, this.updateLocalParticipantEndpoints = (g)=>{
                        const f = this.logger.createFnLogger("updateLocalParticipantEndpoints", ""), S = [];
                        (0, zi.forEach)(g, (g)=>{
                            const f = convertSignalingEndpointDetails(g, this.getSelfClientEndpointCapabilities());
                            S.push(f);
                        }), this.endpoints.endpointDetails = S;
                        const v = this.getDataChannelSourceId();
                        -1 !== v && this.dataChannel && this.dataChannel.setDataChannelSourceId(v), f.info(`selfEndpointDetails=${getPIISafeEndpointDetails(this.endpoints)}`);
                    }, this.handleParticipantsMutedUpdated = (g, f)=>{
                        const S = this.logger.createFnLogger("handleParticipantsMutedUpdated", f);
                        if (void 0 !== (g === null || g === void 0 ? void 0 : g.info)) {
                            this.logger.info(`handleParticipantsMutedUpdated: number of infos: ${Object.keys(g.info).length}`);
                            for (const f of Object.keys(g.info)){
                                const v = this.getParticipant(f);
                                v ? v.handleServerMutedInfoUpdate(g.info[f]) : S.info(`Cannot find local participant ${scrubMriOrOmit(f)}`);
                            }
                        } else S.info("Ignored, no mute participant info.");
                    }, this.handleSelfUnmuteUpdatedInfo = (g, f)=>{
                        const S = this.logger.createFnLogger("handleSelfUnmuteUpdatedInfo", f);
                        if (void 0 !== (g === null || g === void 0 ? void 0 : g.info)) for (const v of Object.keys(g.info)){
                            const _ = g.info[v];
                            if (v === this.localSignalingParticipant.id) {
                                const g = (0, zi.find)(_, (g)=>g.participantId === this.localSignalingParticipant.participantId);
                                if (void 0 === g) {
                                    S.info(`Cannot find local participant ${scrubMriOrOmit(v)}`);
                                    continue;
                                }
                                const C = (0, zi.find)(this.localSignalingParticipant.endpointDetails, (f)=>f.participantId === g.participantId);
                                handleMuteUnmuteParticipantInfo(this.logger, C, g, !1) && this.handleSelfServerMutedState(f);
                            }
                        }
                        else S.info("Ignored, no unmute participant info.");
                    }, this.state = 0, this.terminatedReason = 0, this.callStats = new Pr, this.callDeviceManager = this.createCallDeviceManager(), this.callTelemetry = new Ti(this.logger, this._callCreationTime), this.collectMediaStatsDeferred = new ct, this.setCallId(T), this.setGroupId(C), this.setThreadId(E), this.setMessageId(P), this.setSkypeId(this.currentUserSkypeIdentity.id), this.setParticipantId(I), this.setCallOrigin(0), this.logger = this.logger.createChild(()=>{
                        const g = (this.endpointId || "").substr(0, 8), f = (this.participantId || "").substr(0, 8);
                        return `Web/${this.instanceNumber}[${this.callId}][${g}][${f}][${this.state}]`;
                    }), this._enableMuteAsync = this.ecsProvider.getEcsConfig("SkypeCalling", "enableAsyncMute"), this._enableUnmuteAsync = this.ecsProvider.getEcsConfig("SkypeCalling", "enableAsyncUnmute"), this._enableEndpointMeetingRoleCheckForClientCapability = this.ecsProvider.getEcsConfig("SkypeCalling", "enableEndpointMeetingRoleCheckForClientCapability"), this._enableUserMeetingRolesCheckForClientCapability = this.ecsProvider.getEcsConfig("SkypeCalling", "enableUserMeetingRolesCheckForClientCapability"), this._enableAddModalityGeneric = this.ecsProvider.getEcsConfig("SkypeCalling", "enableAddModalityGeneric"), this.initializeSignalingSession(I), this.signalingSession.setLocationInfo(w, M, D), this.streamManager = new oa(this.participantId, null, this.callStats.localStats, this.logger), this.mediaAgent && (this.dataChannel = new Pa(this.logger), this.dataChannel.on("remoteUserEventsReceived", (g, f)=>this.event("remoteUserEventsReceived").raise(g, f)), this.dataChannel.on("onDataChannelStateUpdated", (g)=>{
                        "Failed" === g && (this.logger.error("onDataChannelStateUpdated: datachannel creation failed, will remove data modality"), this.mediaStateConfigurationHelper.removeModality(3), this.updateSignalingDSHMessageSubscription(!0), this.updateMediaModalities());
                    }), this.screenSharingControl = new rs(this.logger, this.dataChannel, this, this.telemetryLoggers, this.ecsProvider, this.mediaAgent.getConfigProvider()), this.mediaAgent.handleSendMidCallTelemetry(this.sendMidCallTelemetry.bind(this)), this.remoteUFDHandler = new Xs(this.logger.createChild("remoteUFDHandler"), this.mediaAgent.getConfigProvider()), this.smallCallTelemetry = new eo(this.mediaAgent.getConfigProvider()), this.smallCallTelemetry.on("sendSmallCallTelemetry", (g)=>this.reportSmallCallEvent(g)));
                    const k = {
                        enableErrorConversion: this.ecsProvider.getEcsConfig("SkypeCalling", "enableErrorConversion")
                    };
                    this._deferUsingMicrotask = this.ecsProvider.getEcsConfig("SkypeCalling", "deferUsingMicrotask"), Ur.instance.setDeferToQueueMicrotask(this._deferUsingMicrotask), Ur.instance.setLogger(S), this.logger.info(`operationHandlerEcsConfig: ${JSON.stringify(k)}`), this._preferredMpLocation = this.ecsProvider.getEcsConfig("SkypeCalling", "preferredMpLocation"), this.logger.debug(`preferredMpLocation: ${this._preferredMpLocation}`), this._isUpdatePropertiesSpecifiedAllowedByEcs = this.ecsProvider.getEcsConfig("SkypeCalling", "enableUpdateParticipantsSpecified"), this._enableResolveScreenSharingWhenNegotiationComplete = this.ecsProvider.getEcsConfig("SkypeCalling", "enableResolveScreenSharingWhenNegotiationComplete"), this._callOperationHandler = new ki(this.logger, this.callTelemetry, k, void 0, (g, f)=>{
                        this.preconditions(g, f);
                    }), this._participantOperationHandler = new ki(this.logger, this.callTelemetry, k), this.setMeetingData(O), this.initializeLiveStreamConfigProvider();
                }
            };
            ao.instanceCount = 0, ao.getNegotiationTagsFromEndpoints = (g)=>{
                if (!g) return;
                const f = new Map;
                return ao.filterVirtualEndpoints(g).forEach((g)=>{
                    f.set(g.endpointId, g.negotiationTag);
                }), f;
            }, __decorateClass([
                callOperation("Initialize", {
                    type: "Sync",
                    convertError: !0,
                    idempotencyLevel: "NoOp"
                })
            ], ao.prototype, "init", 1), __decorateClass([
                callOperation("StartVideo", {
                    waitFor: "_UpdateMediaDescriptions",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "startVideo", 1), __decorateClass([
                callOperation("StopVideo", {
                    waitFor: "_UpdateMediaDescriptions",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "stopVideo", 1), __decorateClass([
                callOperation("DumpVideoSourceImages")
            ], ao.prototype, "dumpVideoSourceImages", 1), __decorateClass([
                __decorateParam(1, causeId)
            ], ao.prototype, "hold", 1), __decorateClass([
                callOperation("Hold", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "holdWithRenegotiate", 1), __decorateClass([
                callOperation("LocalHold", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "localHold", 1), __decorateClass([
                callOperation("Unhold", {
                    waitFor: [
                        "Hold",
                        "LocalHold"
                    ],
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "unhold", 1), __decorateClass([
                callOperation("UpdateEndpointMetadata"),
                __decorateParam(1, causeId)
            ], ao.prototype, "updateEndpointMetadata", 1), __decorateClass([
                callOperation("SendDtmfTone", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                })
            ], ao.prototype, "sendDtmfTone", 1), __decorateClass([
                callOperation("SetAudioUsage")
            ], ao.prototype, "setAudioUsageMode", 1), __decorateClass([
                callOperation("SetAudioMidcallConfig")
            ], ao.prototype, "setAudioMidcallConfig", 1), __decorateClass([
                callOperation("SetAudioMidcallConfigJon", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "setAudioMidcallConfigJson", 1), __decorateClass([
                callOperation("SetParticipantSpatialAudioPositions", {
                    waitFor: "_ElectronSlimcoreReady",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "setParticipantSpatialAudioPositions", 1), __decorateClass([
                callOperation("BlindTransfer", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "callBlindTransfer", 1), __decorateClass([
                callOperation("SafeTransfer", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "callSafeTransfer", 1), __decorateClass([
                callOperation("TransferToVoicemail", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "transferCallToVoicemail", 1), __decorateClass([
                callOperation("ConsultativeTransfer", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "callConsultativeTransfer", 1), __decorateClass([
                callOperation("ConsultativeTransferWithPickupCode", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                })
            ], ao.prototype, "consultativeTransferWithPickupCode", 1), __decorateClass([
                callOperation("CallRedirect", {
                    singular: !0,
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "callRedirect", 1), __decorateClass([
                callOperation("ParkCall", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "park", 1), __decorateClass([
                callOperation("UnparkCall", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "unpark", 1), __decorateClass([
                callOperation("getTechnicalInformationJson", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                })
            ], ao.prototype, "getTechnicalInformationJson", 1), __decorateClass([
                callOperation("StartScreenSharing", {
                    waitFor: "_UpdateMediaDescriptions",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(3, causeId)
            ], ao.prototype, "startScreenSharing", 1), __decorateClass([
                callOperation("StopScreenSharing", {
                    waitFor: "_UpdateMediaDescriptions",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(2, causeId)
            ], ao.prototype, "stopScreenSharing", 1), __decorateClass([
                callOperation("StartDataChannel", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "startDataChannel", 1), __decorateClass([
                callOperation("StopDataChannel", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "stopDataChannel", 1), __decorateClass([
                callOperation("ShareSystemSounds", {
                    waitFor: "_UpdateMediaDescriptions",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "shareSystemSound", 1), __decorateClass([
                callOperation("Mute", {
                    waitFor: "JoinPreheatedCall",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }, !0),
                __decorateParam(0, causeId)
            ], ao.prototype, "mute", 1), __decorateClass([
                callOperation("Unmute", {
                    waitFor: [
                        "JoinPreheatedCall"
                    ]
                }, !0),
                __decorateParam(0, causeId)
            ], ao.prototype, "unmute", 1), __decorateClass([
                callOperation("MuteSpeaker", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "muteSpeaker", 1), __decorateClass([
                callOperation("UnmuteSpeaker", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "unmuteSpeaker", 1), __decorateClass([
                callOperation("GetSpeakerVolume", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "getSpeakerVolume", 1), __decorateClass([
                callOperation("SetSpeakerVolume", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "setSpeakerVolume", 1), __decorateClass([
                callOperation("MuteParticipants", void 0, !0),
                __decorateParam(2, causeId)
            ], ao.prototype, "muteParticipants", 1), __decorateClass([
                callOperation("StartAudio", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "startAudio", 1), __decorateClass([
                callOperation("StopAudio", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "stopAudio", 1), __decorateClass([
                callOperation("Assimilate"),
                __decorateParam(3, causeId)
            ], ao.prototype, "assimilate", 1), __decorateClass([
                __decorateParam(2, causeId)
            ], ao.prototype, "merge", 1), __decorateClass([
                callOperation("MergeParticipants"),
                __decorateParam(1, operationId),
                __decorateParam(3, causeId)
            ], ao.prototype, "mergeParticipants", 1), __decorateClass([
                callOperation("MergeWithPickupCode"),
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ao.prototype, "mergeWithPickupCode", 1), __decorateClass([
                callOperation("SetMaxVideoChannels")
            ], ao.prototype, "setMaxVideoChannels", 1), __decorateClass([
                callOperation("SetMaxVbssChannels")
            ], ao.prototype, "setMaxVbssChannels", 1), __decorateClass([
                callOperation("StopCall"),
                __decorateParam(1, causeId),
                __decorateParam(3, reason)
            ], ao.prototype, "stop", 1), __decorateClass([
                callOperation("PublishState"),
                __decorateParam(1, operationId)
            ], ao.prototype, "publishState", 1), __decorateClass([
                callOperation("PublishState"),
                __decorateParam(1, operationId)
            ], ao.prototype, "publishStatesForEveryone", 1), __decorateClass([
                callOperation("RemoveState"),
                __decorateParam(1, operationId)
            ], ao.prototype, "removeState", 1), __decorateClass([
                callOperation("RemoveState"),
                __decorateParam(1, operationId)
            ], ao.prototype, "removeStatesForEveryone", 1), __decorateClass([
                callOperation("UpdateMeetingSettings"),
                __decorateParam(1, operationId)
            ], ao.prototype, "updateMeetingSettings", 1), __decorateClass([
                callOperation("UpdateMeetingGroups"),
                __decorateParam(0, operationId)
            ], ao.prototype, "updateMeetingGroups", 1), __decorateClass([
                callOperation("UpdateMeetingLiveState"),
                __decorateParam(0, operationId)
            ], ao.prototype, "updateMeetingLiveState", 1), __decorateClass([
                callOperation("UpdateMeetingStates"),
                __decorateParam(1, operationId)
            ], ao.prototype, "updateMeetingStates", 1), __decorateClass([
                callOperation("UpdateParticipantInterpretationState"),
                __decorateParam(0, operationId)
            ], ao.prototype, "updateParticipantInterpretationState", 1), __decorateClass([
                callOperation("UpdateParticipantsProperties")
            ], ao.prototype, "updateParticipantsProperties", 1), __decorateClass([
                callOperation("JoinMeetingGroup"),
                __decorateParam(0, operationId)
            ], ao.prototype, "joinMeetingGroup", 1), __decorateClass([
                callOperation("LeaveMeetingGroup"),
                __decorateParam(0, operationId)
            ], ao.prototype, "leaveMeetingGroup", 1), __decorateClass([
                callOperation("SendMessages"),
                __decorateParam(0, operationId)
            ], ao.prototype, "sendMessages", 1), __decorateClass([
                callOperation("UpdateMonitorSession"),
                __decorateParam(1, causeId)
            ], ao.prototype, "updateMonitorSession", 1), __decorateClass([
                callOperation("SwitchInterpreterGroup")
            ], ao.prototype, "switchInterpreterGroup", 1), __decorateClass([
                callOperation("SetLiveInterpretationAttributes")
            ], ao.prototype, "setLiveInterpretationAttributes", 1), __decorateClass([
                callOperation("UpdateMeetingRole")
            ], ao.prototype, "updateMeetingRoles", 1), __decorateClass([
                callOperation("CreateContentSharingSession"),
                __decorateParam(4, causeId)
            ], ao.prototype, "createContentSharingSession", 1), __decorateClass([
                callOperation("StopCallWithBeacon", {
                    type: "Sync"
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "stopWithBeacon", 1), __decorateClass([
                callOperation("Acknowledge", {
                    type: "Chained",
                    convertError: !0,
                    idempotencyLevel: "Error",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(2, causeId)
            ], ao.prototype, "acknowledge", 1), __decorateClass([
                callOperation("Accept", {
                    type: "Chained",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "accept", 1), __decorateClass([
                callOperation("Reject", {
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(0, causeId),
                __decorateParam(1, reason)
            ], ao.prototype, "reject", 1), __decorateClass([
                callOperation("JoinCall", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                }),
                __decorateParam(1, callStartOptions),
                __decorateParam(2, causeId)
            ], ao.prototype, "join", 1), __decorateClass([
                callOperation("JoinPreheatedCall", {
                    waitFor: "_CallStartOrJoinInitiated"
                })
            ], ao.prototype, "joinPreheatedCall", 1), __decorateClass([
                callOperation("StartCall", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                }),
                __decorateParam(0, callStartOptions),
                __decorateParam(1, causeId)
            ], ao.prototype, "start", 1), __decorateClass([
                callOperation("StartCallToVoiceMail", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                }),
                __decorateParam(1, causeId)
            ], ao.prototype, "startCallToVoicemail", 1), __decorateClass([
                callOperation("Subscribe", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                }),
                __decorateParam(2, causeId)
            ], ao.prototype, "joinCallWithoutCallModality", 1), __decorateClass([
                callOperation("StartWithMeetingData", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                })
            ], ao.prototype, "startWithMeetingData", 1), __decorateClass([
                callOperation("JoinWithMeetingData", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                })
            ], ao.prototype, "joinWithMeetingData", 1), __decorateClass([
                callOperation("SubscribeWithMeetingData", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                })
            ], ao.prototype, "subscribeWithMeetingData", 1), __decorateClass([
                callOperation("StartCallWithNudge", {
                    type: "Chained",
                    idempotencyLevel: "Error"
                }),
                __decorateParam(1, callStartOptions),
                __decorateParam(2, causeId)
            ], ao.prototype, "startCallWithNudge", 1), __decorateClass([
                callOperation("StartCallAndUnpark", {
                    type: "Chained",
                    idempotencyLevel: "Error",
                    preconditionTags: [
                        "NOT_SUPPORTED_IN_STREAMING_MODE"
                    ]
                }),
                __decorateParam(2, callStartOptions),
                __decorateParam(3, causeId)
            ], ao.prototype, "startAndUnpark", 1), __decorateClass([
                participantOperation("AdmitParticipant"),
                __decorateParam(0, operationId),
                __decorateParam(1, causeId)
            ], ao.prototype, "admitParticipant", 1), __decorateClass([
                callOperation("Admit")
            ], ao.prototype, "admit", 1), __decorateClass([
                participantOperation("CallMeBack"),
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ao.prototype, "callMeBack", 1), __decorateClass([
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ao.prototype, "addParticipant", 1), __decorateClass([
                participantOperation("AddParticipants"),
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ao.prototype, "addParticipants", 1), __decorateClass([
                __decorateParam(0, operationId),
                __decorateParam(2, causeId)
            ], ao.prototype, "addParticipantsImpl", 1), __decorateClass([
                participantOperation("NudgeParticipants"),
                __decorateParam(0, operationId),
                __decorateParam(3, causeId)
            ], ao.prototype, "nudgeParticipants", 1), __decorateClass([
                participantOperation("RemoveParticipant"),
                __decorateParam(0, operationId),
                __decorateParam(1, causeId)
            ], ao.prototype, "removeParticipant", 1), __decorateClass([
                participantOperation("CancelNudge"),
                __decorateParam(0, operationId),
                __decorateParam(0, causeId)
            ], ao.prototype, "cancelNudge", 1), __decorateClass([
                callOperation("SearchParticipants"),
                __decorateParam(1, operationId),
                __decorateParam(1, causeId)
            ], ao.prototype, "searchParticipants", 1), __decorateClass([
                callOperation("GetAllParticipants"),
                __decorateParam(1, operationId),
                __decorateParam(1, causeId)
            ], ao.prototype, "getAllParticipants", 1), __decorateClass([
                callOperation("_PromotionToRealtime"),
                __decorateParam(1, causeId)
            ], ao.prototype, "promoteToRealtime", 1), __decorateClass([
                __decorateParam(0, causeId)
            ], ao.prototype, "turnOffLocalVideoPreview", 1), __decorateClass([
                callOperation("_StartPreviewVideo"),
                __decorateParam(0, causeId)
            ], ao.prototype, "turnOnLocalVideoPreview", 1), __decorateClass([
                __decorateParam(0, causeId)
            ], ao.prototype, "acquireLocalVideo", 1), __decorateClass([
                __decorateParam(0, causeId)
            ], ao.prototype, "turnOnLocalVideoPreviewUsingRenderer", 1), __decorateClass([
                callOperation("_UpdateLocalMediaStatus", {
                    type: "Chained"
                }),
                __decorateParam(0, causeId)
            ], ao.prototype, "updateMediaStatus", 1), __decorateClass([
                __decorateParam(0, causeId)
            ], ao.prototype, "calculateIsSomeoneStreaming", 1), __decorateClass([
                callOperation("_Reconnect")
            ], ao.prototype, "reconnect", 1), __decorateClass([
                callOperation("AddGroupModality"),
                __decorateParam(1, causeId)
            ], ao.prototype, "addGroupModality", 1), __decorateClass([
                callOperation("AddBroadcastModality")
            ], ao.prototype, "addBroadcastModality", 1);
            var so = ao;
            function decode(g) {
                const f = new TextDecoder("utf-8"), S = atob(g), v = Uint8Array.from(S, (g)=>g.charCodeAt(0));
                return f.decode(v);
            }
            var oo = __toESM(_e()), lo = new RegExp("/callAgent/", "i"), co = class {
                handleMessage(g) {
                    if (!g.eventId) {
                        if (g.url.search(lo) > -1) {
                            const f = this.signalingAgentProvider.getSignalingAgent().handleIncomingNotification(g);
                            return "number" == typeof f ? {
                                isHandled: !0,
                                resultCode: f
                            } : {
                                isHandled: !0,
                                resultCode: f.resultCode,
                                responseBody: f.responseBody,
                                responseHeaders: f.responseHeaders
                            };
                        }
                        return {
                            isHandled: !1
                        };
                    }
                    if (g.eventId in $i) {
                        this.callRegistry.logUploadNotification(g);
                        const f = this.signalingAgentProvider.getSignalingAgent().handleIncomingNotification(g);
                        return "number" == typeof f ? {
                            isHandled: !0,
                            resultCode: f
                        } : {
                            isHandled: !0,
                            resultCode: f.resultCode,
                            responseBody: f.responseBody,
                            responseHeaders: f.responseHeaders
                        };
                    }
                    return {
                        isHandled: !1
                    };
                }
                constructor(g, f){
                    this.signalingAgentProvider = g, this.callRegistry = f;
                }
            }, uo = class {
                handleMessage(g) {
                    const f = this.handleIncomingCall(g);
                    return f ? {
                        isHandled: f,
                        resultCode: 200
                    } : {
                        isHandled: f
                    };
                }
                handleIncomingCall(g) {
                    const f = generateCauseId(), S = this.logger.createFnLogger("handleIncomingCall", f);
                    if (this.isProxiableNotification(g)) return this.callRegistry.proxyPushNotification(g), !0;
                    if (!this.isIncomingCallMessage(g)) return !1;
                    let v;
                    try {
                        var _g_body;
                        if ((g === null || g === void 0 ? void 0 : (_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.gp) && !isStringBase64(g.body.gp)) S.info("unencoded payload, skipping decoding."), v = g.body.gp;
                        else {
                            const f = decodeNotificationPayload(g, S);
                            v = JSON.parse(f);
                        }
                        v.body = g.body;
                    } catch (g) {
                        return S.logFailure(`Error parsing notification payload: ${g}`), !1;
                    }
                    const _ = this.isCallTransferNotification(g) ? this.buildTransferCallPayload(v) : this.buildNGCCallPayload(v);
                    if (!_) return !1;
                    if (this.callRegistry.calls.some((g)=>g.callId === _.convoCallId && g.participantId === _.participantId)) return S.logFailure(`Duplicate call filtered because it was in the call registry, callId = ${_.convoCallId}, participantId = ${_.participantId}`), !1;
                    const C = this.isCallReplacementNotification(g);
                    if (S.log(`replacementCall=${C}`), !C && this.recentInvitations.some((g)=>g.convoCallId === _.convoCallId && g.participantId === _.participantId)) return S.logFailure(`Duplicate call filtered because it was in the recent calls list, callId = ${_.convoCallId}, participantId = ${_.participantId}`), !1;
                    5 === this.recentInvitations.length && this.recentInvitations.shift(), this.recentInvitations.push({
                        convoCallId: _.convoCallId,
                        participantId: _.participantId
                    });
                    let E = this.callRegistry.calls.find((g)=>g.callId === _.convoCallId && 8 === g.state);
                    return E || (E = _.groupId ? this.callRegistry.createCallWithGroupId(_.groupId, _.convoCallId, _.participantId, f) : this.callRegistry.createCall(_.conversationId, _.convoCallId, _.participantId, void 0, f)), E.init({
                        threadId: _.conversationId,
                        messageId: _.messageId,
                        mediaPeerType: 2
                    }), this.callRegistry.testEndpointMetadata ? E.acknowledge(_, this.callRegistry.testEndpointMetadata, f) : E.acknowledge(_, void 0, f), !0;
                }
                isIncomingCallMessage(g) {
                    var _this_ecsProvider;
                    return Object.keys(Bi).some((f)=>Bi[f] === g.eventId) ? g.eventId !== Bi.INCOMING_TFL_TFW_CALL || ((_this_ecsProvider = this.ecsProvider) === null || _this_ecsProvider === void 0 ? void 0 : _this_ecsProvider.getEcsConfig("SkypeCalling", "enableTFWTFLOneToOneCall")) : this.isCallTransferNotification(g);
                }
                isCallTransferNotification(g) {
                    return g.callNotification && ("transfer" === g.callNotification.callType || "replaces" === g.callNotification.callType);
                }
                isCallReplacementNotification(g) {
                    return g.callNotification && "replaces" === g.callNotification.callType;
                }
                isProxiableNotification(g) {
                    return Object.keys(Hi).some((f)=>Hi[f] === g.eventId);
                }
                buildTransferCallPayload(g) {
                    var _g_conversationInvitation;
                    const f = {
                        body: g.body,
                        callerId: g.callNotification.from.id,
                        displayNameSource: parseDisplayNameSourceFromWire(g.callNotification.from.displayNameSource),
                        groupId: null,
                        conversationId: null,
                        convoCallId: g.debugContent.callId,
                        isMultiParty: (_g_conversationInvitation = g.conversationInvitation) === null || _g_conversationInvitation === void 0 ? void 0 : _g_conversationInvitation.isMultiParty,
                        fromMixer: g.callNotification.fromMixer,
                        ngcCall: !0,
                        participantId: g.callNotification.to.participantId,
                        transferorId: g.callNotification.transferor && g.callNotification.transferor.details && g.callNotification.transferor.details.id,
                        transferorType: g.callNotification.transferor && g.callNotification.transferor.transferorType,
                        transferorDisplayName: g.callNotification.transferor && g.callNotification.transferor.details && g.callNotification.transferor.details.displayName,
                        callType: g.callNotification.callType,
                        consultativeCallId: g.callNotification.consultativeCallId,
                        messageId: null,
                        callQueueInfo: g.callNotification.applicationContent,
                        videoCall: void 0,
                        launchTime: void 0,
                        pushReceivedTime: void 0,
                        registrationId: void 0
                    };
                    return this.logger.info("Incoming transfer paylod", getPIISafePayload(f, [
                        "callerId",
                        "transferorId"
                    ])), f;
                }
                buildNGCCallPayload(g) {
                    var _g_groupContext, _g_groupChat, _g_groupChat1;
                    if (!g.callNotification) return this.logger.error("Missing callNotification in parsed incoming NGC call payload"), null;
                    const f = {
                        groupId: (_g_groupContext = g.groupContext) === null || _g_groupContext === void 0 ? void 0 : _g_groupContext.id,
                        conversationId: (_g_groupChat = g.groupChat) === null || _g_groupChat === void 0 ? void 0 : _g_groupChat.threadId,
                        messageId: (_g_groupChat1 = g.groupChat) === null || _g_groupChat1 === void 0 ? void 0 : _g_groupChat1.messageId,
                        callerId: g.callNotification.from.id,
                        displayNameSource: parseDisplayNameSourceFromWire(g.callNotification.from.displayNameSource),
                        isMultiParty: g.conversationInvitation.isMultiParty,
                        fromMixer: g.callNotification.fromMixer,
                        convoCallId: g.debugContent.callId,
                        participantId: g.debugContent.participantId,
                        ngcCall: !0,
                        body: g.body,
                        transferorId: g.callNotification.transferor && g.callNotification.transferor.details && g.callNotification.transferor.details.id,
                        transferorType: g.callNotification.transferor && g.callNotification.transferor.transferorType,
                        transferorDisplayName: g.callNotification.transferor && g.callNotification.transferor.details && g.callNotification.transferor.details.displayName,
                        callType: g.callNotification.callType,
                        callQueueInfo: g.callNotification.applicationContent,
                        videoCall: void 0,
                        launchTime: void 0,
                        pushReceivedTime: void 0,
                        registrationId: void 0,
                        fromApplicationType: g.callNotification.fromApplicationType
                    };
                    return this.logger.info("Incoming NGC paylod", getPIISafePayload(f, [
                        "callerId",
                        "transferorId"
                    ])), f;
                }
                constructor(g, f, S){
                    this.callRegistry = g, this.recentInvitations = [], this.logger = f.createChild("IncomingCallMessageHandler"), this.ecsProvider = S;
                }
            }, ho = class extends ze {
                init(g, f, S = generateCauseId()) {
                    return this.logger.createFnLogger("init", S).info("init"), this.login(g);
                }
                uninit() {
                    return this.logout();
                }
                login(g, f = generateCauseId()) {
                    return this.logger.createFnLogger("login", f).info("login"), this.skypeIdentity = g, this.identity = this.skypeIdentity.id, this.initialize(f);
                }
                initialize(g = generateCauseId(), f) {
                    const S = this.logger.createFnLogger("initialize", g), v = f && f.applicationType ? f.applicationType : "null";
                    S.info(`initialize with applicationType: ${v}`), this.accountConfiguration = f, this.accountConfiguration && this.event("accountConfigurationReceived").raise(this.accountConfiguration), this.signalingAgentProvider.getSignalingAgent().update(f), this.incomingCallMessageHandler = new uo(this, this.logger, this.ecsProvider), this.trouterService.registerMessageHandler(new co(this.signalingAgentProvider, this)), this.trouterService.registerMessageHandler(this.incomingCallMessageHandler), S.info("Call registry init, endpointMetadata", this.testEndpointMetadata);
                    try {
                        this.windowUninitListener = ()=>{
                            this._disregardWindowUninitEvents || this.stopCallsWithBeacon();
                        }, window.addEventListener(this._windowUninitEvent, this.windowUninitListener);
                    } catch (g) {
                        S.logFailure(`Not adding beforeunload listener: ${g}`);
                    }
                    return Promise.resolve(void 0);
                }
                logout(g = generateCauseId()) {
                    const f = this.logger.createFnLogger("logout", g);
                    f.info("logout");
                    try {
                        this.trouterService.clearMessageHandlers(), window.removeEventListener(this._windowUninitEvent, this.windowUninitListener);
                    } catch (g) {
                        f.info(`Not removing beforeunload listener: ${g}`);
                    }
                    return Promise.resolve(void 0);
                }
                _publishTelemetry(g) {
                    var _this_telemetryLoggers;
                    if (!((_this_telemetryLoggers = this.telemetryLoggers) === null || _this_telemetryLoggers === void 0 ? void 0 : _this_telemetryLoggers.signaling)) return;
                    this.registryTelemetry.setSkypeId(this.identity);
                    try {
                        const g = this.signalingAgentProvider.getSignalingAgent();
                        this.registryTelemetry.setEndpointId(g.endpointId);
                    } catch (g) {
                        this.logger.warn("Could not get end point ID from signaling agent for call registry telemetry.");
                    }
                    this.accountConfiguration && (this.registryTelemetry.setAcsResourceId(this.accountConfiguration.acsResourceId), this.registryTelemetry.setApplicationType(this.accountConfiguration.applicationType), this.registryTelemetry.setPartition(this.accountConfiguration.partition), this.registryTelemetry.setRegion(this.accountConfiguration.region), this.registryTelemetry.setRing(this.accountConfiguration.ring), this.registryTelemetry.setTenantId(this.accountConfiguration.tenantId), this.registryTelemetry.setUserHexCID(this.accountConfiguration.userHexCID), this.registryTelemetry.setClientType(this.accountConfiguration.clientType));
                    const f = pi.REGISTRY_WEB;
                    this.telemetryLoggers.signaling.sendEvent({
                        eventName: f,
                        props: this.registryTelemetry.getEvent(null, g)
                    });
                }
                async dispose(g = generateCauseId()) {
                    const f = this.logger.createFnLogger("dispose", g);
                    if (f.info("dispose"), this.isDisposing) return f.warn("call registry is already in disposing stage!"), this._disposedPromise.promise;
                    this.isDisposing = !0;
                    const always = ()=>{
                        this.calls = [], this.event("disposed").raise(), super.dispose(), this._disposedPromise.resolve();
                    }, S = this.calls.map((g)=>g.stop()), logout = ()=>this.logout();
                    return this.clearCallSubscription(), this.signalingAgentProvider.getSignalingAgent().resetAuthTokenManager(), Promise.all(S).then(logout, logout).then(always, always), this._disposedPromise.promise;
                }
                get disposePromise() {
                    return this._disposedPromise.promise;
                }
                createCallAsync(g) {
                    var _this_mediaAgent;
                    const f = this.logger.createFnLogger("createCallAsync", g.causeId), S = `callId:${g.callId}, localParticipantId: ${scrubMriOrOmit(g.localParticipantId)},\n            causeId:${g.causeId}, type:${g.type}, `;
                    switch(g.type){
                        case "MeetingData":
                            var _g_meetingData, _g_meetingData1;
                            S.concat(`meetingUrl:${!!((_g_meetingData = g.meetingData) === null || _g_meetingData === void 0 ? void 0 : _g_meetingData.meetingUrl)}, meetingCode:${!!((_g_meetingData1 = g.meetingData) === null || _g_meetingData1 === void 0 ? void 0 : _g_meetingData1.meetingCode)}`);
                            break;
                        case "GroupId":
                            S.concat(`groupId:${scrubMriOrOmit(g.groupId)}`);
                            break;
                        case "ThreadId":
                            S.concat(`threadId:${getLoggableThreadId(g.threadId)}, messageId:${g.messageId}`);
                            break;
                        default:
                            throw new Error("Invalid type in passing parameter.");
                    }
                    f.info(S);
                    const v = ((_this_mediaAgent = this.mediaAgent) === null || _this_mediaAgent === void 0 ? void 0 : _this_mediaAgent.getConfig().useOneDsLogger) ? this.oneDsTelemetryLoggers : this.telemetryLoggers, _ = this._getCurrentCall(g, f);
                    if (_) {
                        if (6 === _.state) {
                            const g = new ct;
                            return this._disconnectingPromiseDefers.set(_.callId, g), g.promise;
                        }
                        return Promise.resolve(_);
                    }
                    return Promise.resolve(this._createNewCall(g, v, f));
                }
                createCallWithMeetingData(g, f, S, v) {
                    var _this_mediaAgent;
                    const _ = this.logger.createFnLogger("createCallWithMeetingData", v);
                    if (_.info(`meetingData:${!!g}, callId:${f}, localParticipantId: ${scrubMriOrOmit(S)}`), !g) return _.info("meetingData cannot be null"), null;
                    const C = this._generateCreateCallOptions(v, f, S, null, null, null, g), E = this._getCurrentCall(C, _);
                    if (E) return E;
                    const T = ((_this_mediaAgent = this.mediaAgent) === null || _this_mediaAgent === void 0 ? void 0 : _this_mediaAgent.getConfig().useOneDsLogger) ? this.oneDsTelemetryLoggers : this.telemetryLoggers;
                    return this._createNewCall(C, T, _);
                }
                createCall(g, f, S, v, _ = generateCauseId()) {
                    return this._createCall(g, f, S, v, _);
                }
                createCallWithGroupId(g, f, S, v) {
                    return this._createCall("", f, S, void 0, v, g);
                }
                _createNewCall(g, f, S) {
                    let v = null, _ = null, C = null, E = null;
                    switch(g.type){
                        case "MeetingData":
                            E = g.meetingData;
                            break;
                        case "GroupId":
                            v = g.groupId;
                            break;
                        case "ThreadId":
                            _ = g.threadId, C = g.messageId;
                    }
                    const T = new so(this.signalingAgentProvider.getSignalingAgent(), this.mediaAgent, new je(this.callingLogger), f, this.skypeIdentity, v, _, g.callId, g.localParticipantId, this.ecsProvider, this.trouterService, this.accountConfiguration, C, this.locationInfoContent, this.networkInfoContent, E, this.areaContent, this.vdi3diagnostics);
                    T.on("callStateChanged", async ()=>{
                        if (7 === T.state && this._createNewCallInDisconnectedState) {
                            const v = this._disconnectingPromiseDefers.get(T.callId);
                            v && (this._disconnectingPromiseDefers.delete(T.callId), v.resolve(this._createNewCall(g, f, S))), this._invokeDeleteCallInDisconnectedState && setTimeout(()=>{
                                this.deleteCall(T);
                            }, 0);
                        }
                    }), this.calls.push(T), this.event("callAdded").raise(T), this.raiseChanged(), S.info(`Created new call with id ${T.callId}`);
                    const I = T.on("replacementRequested", (g)=>{
                        this.incomingCallMessageHandler.handleMessage(g);
                    });
                    return this.addCallSubscriptionToMap(T, I), T;
                }
                _getCurrentCall(g, f) {
                    let S = null;
                    return "MeetingData" === g.type && (S = this.getCallUsingMeetingData(g.meetingData, g.callId, g.localParticipantId, void 0, void 0, g.causeId), S) ? (f.info("Call Registry has an entry for this call's meeting data"), S) : (S = this.getCall(g.callId, g.localParticipantId, g.causeId), S ? (f.info("Call Registry has an entry for this callId, participantId"), S) : "ThreadId" === g.type && (S = this.getCallUsingThreadIdMessageId(g.threadId, g.callId, g.messageId, g.causeId), S) ? (f.info("Call Registry has an entry for this threadId, messageId"), S) : "GroupId" === g.type && (S = this.calls.find((f)=>f.groupId === g.groupId), S) ? (f.info("Call Registry has an entry for this groupId"), S) : S);
                }
                _generateCreateCallOptions(g, f, S, v, _, C, E) {
                    let T = null;
                    return T = v ? {
                        type: "GroupId",
                        callId: f,
                        localParticipantId: S,
                        causeId: g,
                        groupId: v
                    } : _ ? {
                        type: "ThreadId",
                        callId: f,
                        localParticipantId: S,
                        causeId: g,
                        threadId: _,
                        messageId: C
                    } : {
                        type: "MeetingData",
                        callId: f,
                        localParticipantId: S,
                        causeId: g,
                        meetingData: E
                    }, T;
                }
                _createCall(g, f, S, v, _ = generateCauseId(), C) {
                    var _this_mediaAgent;
                    const E = this.logger.createFnLogger("createCall", _);
                    E.info(`threadId:${getLoggableThreadId(g)}, callId:${f}, localParticipantId: ${scrubMriOrOmit(S)}, messageId:${v}, groupId:${scrubMriOrOmit(C)}`);
                    const T = this._generateCreateCallOptions(_, f, S, C, g, v, null), I = this._getCurrentCall(T, E);
                    if (I) return I;
                    const b = ((_this_mediaAgent = this.mediaAgent) === null || _this_mediaAgent === void 0 ? void 0 : _this_mediaAgent.getConfig().useOneDsLogger) ? this.oneDsTelemetryLoggers : this.telemetryLoggers;
                    return this._createNewCall(T, b, E);
                }
                getCall(g, f, S = generateCauseId()) {
                    const v = this.logger.createFnLogger(`getCall[callId=${g}][participantId=${scrubMriOrOmit(f)}]`, S);
                    if (!g) return v.logFailure("callId is undefined"), null;
                    const _ = this.calls.find((f)=>f.callId === g);
                    return _ && v.info("Call Registry already has an entry for this call"), _;
                }
                async deleteCallAsync(g) {
                    return asap(()=>this.deleteCall(g));
                }
                deleteCall(g) {
                    const f = this.calls.indexOf(g);
                    return -1 !== f && (this.callSubscriptionsMap.get(g).forEach((g)=>{
                        g.dispose();
                    }), this.callSubscriptionsMap.delete(g), this.calls.splice(f, 1), this.event("callRemoved").raise(g), this.raiseChanged(), !0);
                }
                async setConfiguration(g) {
                    this.accountConfiguration = g, this.accountConfiguration && this.event("accountConfigurationReceived").raise(this.accountConfiguration), this.signalingAgentProvider.getSignalingAgent().update(g);
                }
                updateDisplayName(g) {
                    return this.skypeIdentity.displayName = g, this.calls.forEach((f)=>{
                        f.updateDisplayName(g);
                    }), Promise.resolve();
                }
                fireIntent(g, f) {
                    return Promise.resolve();
                }
                getCallState(g, f) {
                    return Promise.reject("Not implemented");
                }
                getSetup() {}
                getEcsConfig() {
                    return Promise.reject();
                }
                updateSkypeToken(g) {
                    this.logger.debug("CallRegistry.updateSkypeToken() called but not supported in the current set up.");
                }
                updateToken(g, f, S, v, _) {
                    this.logger.info(`[updateToken], causeId = ${v} tokenType = ${f.tokenType}, factorsJson = ${g}, tokenExpiredTime = ${_}`);
                    try {
                        return this.signalingAgentProvider.getSignalingAgent().updateToken(g, f, S, v, _), Promise.resolve(getSuccessTransactionEnd());
                    } catch (f) {
                        return this.logger.info(`Failed to update token with ${g}, error is ${f}`), Promise.reject(getRejectTransactionEnd(`Failed to update token with ${g}, error is ${f}`));
                    }
                }
                onTokenRequired(g) {
                    const { requestMetadataJson: f, factorsJson: S, tokenType: v, invalidToken: _ } = g;
                    this.logger.info(`[onTokenRequired], tokenType ${v}, factorsJson ${S}, requestMetadataJson ${JSON.stringify(f)}`), this.event("tokenRequired").raise(S, v, f, _);
                }
                debugInformation(g) {
                    const f = g ? `CallInformation\n * CallId=${g.callId}` : void 0;
                    return Promise.resolve(f);
                }
                setLocationInfo(g, f, S = generateCauseId()) {
                    if (this.logger.info(`setLocationInfo, ${S}, infoType:${g}, contentJson ${f ? "is set" : "is undefined"}`), f) try {
                        JSON.parse(f);
                    } catch (g) {
                        return Promise.reject(`invalid contentJson: ${g}`);
                    }
                    return this.locationInfoType = g, 1 === this.locationInfoType && (this.locationInfoContent = f, this.logger.info(`locationInfoContent set to ${this.locationInfoContent}`)), 2 === this.locationInfoType && (this.networkInfoContent = f, this.logger.info(`networkInfoContent set to ${this.networkInfoContent}`)), 3 === this.locationInfoType && (this.areaContent = f, this.logger.info(`areaContent set to ${this.areaContent}`)), this.event("locationInfoSet").raise(g, f), Promise.resolve();
                }
                createDownloader() {
                    return null;
                }
                async getUnassembledLocalRecordingSessions(g = generateCauseId()) {
                    return Promise.reject("Not implemented");
                }
                submitBrbReport(g, f) {
                    return Promise.reject("Not implemented");
                }
                extendBrbFeedback(g, f) {
                    return Promise.reject("Not implemented");
                }
                proxyPushNotification(g) {
                    this.logger.info(`Proxying push notification with event ID ${g.eventId}`);
                    try {
                        const f = {
                            eventId: g.eventId,
                            payload: decodeNotificationPayload(g, this.logger)
                        };
                        this.event("proxiedPushNotification").raise(f);
                    } catch (g) {
                        this.logger.error(`Error proxying push notification: ${g}`);
                    }
                }
                logUploadNotification(g) {
                    this.logger.info(`Log upload notification with event ID ${g.eventId}`);
                    try {
                        const f = {
                            eventId: g.eventId,
                            payload: decodeNotificationPayload(g, this.logger)
                        };
                        this.event("logUploadNotification").raise(f);
                    } catch (g) {
                        this.logger.error(`Error raising log upload notification: ${g}`);
                    }
                }
                sendPush(g, f, S, v) {
                    const _ = {
                        id: g
                    }, C = [];
                    return f.forEach((g)=>{
                        C.push({
                            id: g
                        });
                    }), this.signalingAgentProvider.getSignalingAgent().sendPushAsync(_, C, S, v);
                }
                enableWindowUninitEventHandler() {
                    this._disregardWindowUninitEvents = !1;
                }
                disableWindowUninitEventHandler() {
                    this._disregardWindowUninitEvents = !0;
                }
                async enableWindowUninitEventHandlerAsync() {
                    this.enableWindowUninitEventHandler();
                }
                async disableWindowUninitEventHandlerAsync() {
                    this.disableWindowUninitEventHandler();
                }
                getCallUsingThreadIdMessageId(g, f, S, v) {
                    this.logger.info(`[getCallUsingThreadIdMessageId][${v}] threadID: ${getLoggableThreadId(g)} callId: ${f} messageId: ${S}`);
                    let _ = null;
                    return g && (_ = this.calls.find((v)=>v.threadId === g && (f && v.callId === f || null != S && v.messageId === S)), _) ? (this.logger.logFailure(`[getCallUsingThreadIdMessageId][${v}]Call Registry already has an entry for threadId: ${getLoggableThreadId(_.threadId)}, callId: ${_.callId}, messageId: ${_.messageId}`), _) : _;
                }
                getCallUsingMeetingData(g, f, S, v, _, C = generateCauseId()) {
                    const E = this.logger.createFnLogger("getCallUsingMeetingData", C);
                    if (E.info(`[callId=${f}][participantId=${scrubMriOrOmit(S)}] meetingData: ${!!g} \n            threadId: ${getLoggableThreadId(v)} messageId: ${_}`), !f) return E.logFailure("callId is undefined"), null;
                    let T;
                    for (const S of this.calls){
                        if (S.callId === f) {
                            T = S;
                            break;
                        }
                        if (compareMeetingData(S.meetingData, g, C, this.logger)) {
                            T = S;
                            break;
                        }
                    }
                    return T;
                }
                stopCallsWithBeacon() {
                    for (const g of this.calls)g.stopWithBeacon();
                }
                addCallSubscriptionToMap(g, f) {
                    this.callSubscriptionsMap.set(g, (this.callSubscriptionsMap.get(g) || []).concat(f));
                }
                clearCallSubscription() {
                    this.callSubscriptionsMap.forEach((g)=>{
                        g.forEach((g)=>{
                            g.dispose();
                        });
                    }), this.callSubscriptionsMap.clear();
                }
                constructor(g, f, S, v, _, C = null, E, T, I){
                    super(), this.trouterService = g, this.signalingAgentProvider = f, this.mediaAgent = S, this.callingLogger = v, this.telemetryLoggers = _, this.ecsProvider = C, this.skypeIdentity = E, this.oneDsTelemetryLoggers = T, this.vdi3diagnostics = I, this.calls = [], this.isDisposing = !1, this._disposedPromise = new ct, this.testEndpointMetadata = null, this._disconnectingPromiseDefers = new Map, this.skypeIdentity && (this.identity = this.skypeIdentity.id), this.callSubscriptionsMap = new Map, this.logger = new je(this.callingLogger).createChild(`CallRegistry/${generateCauseId()}`), this.registryTelemetry = new Ei(this.logger, (new Date).getTime()), this._callOperationHandler || (this._callOperationHandler = new ki(this.logger, this.registryTelemetry, {}, (g)=>{
                        this._publishTelemetry(g);
                    }));
                    const b = this.mediaAgent.getConfig().disconnectOnPageHide;
                    this._windowUninitEvent = b ? "pagehide" : "beforeunload", this.signalingAgentProvider.getSignalingAgent().setTokenRequiredCallBack(this.onTokenRequired.bind(this)), this._createNewCallInDisconnectedState = this.ecsProvider.getEcsConfig("SkypeCalling", "createNewCallInDisconnectedState"), this._invokeDeleteCallInDisconnectedState = this.ecsProvider.getEcsConfig("SkypeCalling", "invokeDeleteCallInDisconnectedState");
                }
            };
            function decodeNotificationPayload(g, f) {
                var _g_body, _g_body1;
                const S = f.createFnLogger("decodeNotificationPayload");
                let v = "{}";
                if (g === null || g === void 0 ? void 0 : (_g_body = g.body) === null || _g_body === void 0 ? void 0 : _g_body.gp) S.info("using notification.body.gp"), v = decode(g.body.gp);
                else if (g === null || g === void 0 ? void 0 : (_g_body1 = g.body) === null || _g_body1 === void 0 ? void 0 : _g_body1.cp) {
                    S.info("using notification.body.cp");
                    const f = atob(g.body.cp);
                    v = oo.inflate(f, {
                        to: "string"
                    });
                }
                return v;
            }
            __decorateClass([
                callOperation("Initialize", {
                    enableInstantTelemetry: !0
                })
            ], ho.prototype, "initialize", 1), __decorateClass([
                callOperation("Logout", {
                    enableInstantTelemetry: !0
                })
            ], ho.prototype, "logout", 1);
            var go = P, po = class {
                get childDeviceManagers() {
                    return this.deviceManager.getRegisteredDevices();
                }
                createPreview(g, f, S, v) {
                    return this.executeOnVirtualDeviceManager((v)=>S(g, f, v, "Video"), v);
                }
                getRawDeviceMediaStream(g, f, S) {
                    return this.executeOnVirtualDeviceManager((S)=>S.getRawDeviceMediaStream(g, f), S);
                }
                setDeviceEffectsAsync(g, f) {
                    return this.executeOnVirtualDeviceManager((g)=>g.setVideoEffects(f), g);
                }
                setRawMediaStream(g, f, S) {
                    this.executeOnVirtualDeviceManager((S)=>S.setRawMediaStream(g, f), S);
                }
                unsetRawMediaStream(g, f) {
                    this.executeOnVirtualDeviceManager((f)=>f.unsetRawMediaStream(g), f);
                }
                getVirtualDevice(g) {
                    return this.childDeviceManagers.find((f)=>f.id === g);
                }
                executeOnVirtualDeviceManager(g, f) {
                    return this.getVirtualDevice(f).getDeviceManagers().map((f)=>g(f));
                }
                constructor(g){
                    this.deviceManager = g;
                }
            }, mo = "default_output_device", fo = class _DeviceManagerAdapter extends ze {
                get isAudioOutputSelectionSupported() {
                    return this._deviceManager.isAudioOutputSelectionSupported;
                }
                getPermissionState(g) {
                    return "camera" === g ? this.getPermissionStateHelper(this._deviceManager.getPermissionState("camera")) : "microphone" === g ? this.getPermissionStateHelper(this._deviceManager.getPermissionState("microphone")) : "unknown";
                }
                askDevicePermission(g) {
                    return this._deviceManager.askDevicePermission ? this._deviceManager.askDevicePermission(g) : Promise.resolve({
                        audio: !0,
                        video: !0
                    });
                }
                enumerateDevicesAsync() {
                    return this._deviceManager.enumerateDevicesAsync().then((g)=>this._mapDevices(g));
                }
                getPreferredCamera() {
                    throw new Error("Not implemented");
                }
                selectDevices(g) {
                    if (Object.keys(g).some((g)=>this.isVirtualDevice(g))) throw new Error("Virtual Device selection on DM is not supported");
                    const f = (0, go.assign)({}, this._deviceManager.getSelectedDevices(), g);
                    this._deviceManager.selectDevices(f);
                }
                selectDevicesAsync(g) {
                    return asap(()=>this.selectDevices(g));
                }
                getSelectedDevices() {
                    return this._deviceManager.getSelectedDevices();
                }
                getSelectedDevicesAsync() {
                    return asap(()=>this.getSelectedDevices());
                }
                getDeviceNameAsync(g) {
                    return this._deviceManager.getDeviceNameAsync(g);
                }
                getSpeakerDeviceDomIdAsync(g, f) {
                    return this._deviceManager.getSpeakerDeviceDomIdAsync(g);
                }
                mapBrowserDevices(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                async setDeviceEffectsAsync(g, f) {
                    if (!this.isVirtualDevice(g)) return this._deviceManager.setVideoEffects(f);
                    Promise.all(this.virtualDeviceAdapter.setDeviceEffectsAsync(g, f));
                }
                getDeviceEffectsCapabilityAsync(g, f) {
                    return this._deviceManager.effectsManager.getEffectsCapability("Video");
                }
                setBackgroundImageAsync(g, f, S) {
                    return this._deviceManager.effectsManager.configure("Video", {
                        imagePath: f,
                        headers: S
                    });
                }
                getImagePropertyAsync(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                getMicrophoneGeometryArrayInfoAsync(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                transformImageAsync(g, f, S, v) {
                    return Promise.reject(new Error("Not implemented"));
                }
                setAudioProcessingFlags(g) {
                    return this._deviceManager.setAudioProcessingFlags(g);
                }
                async sendMessageDeviceVideoEffectsAsync(g, f) {
                    return await this._deviceManager.sendMessageDeviceVideoEffectsAsync(g, f);
                }
                sendMessageDeviceVideoExtensibilityAsync(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                setVideoCaptureConfigAsync(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                captureVideoFrameWithoutEffectsAsync(g, f, S) {
                    return Promise.reject(new Error("Not implemented"));
                }
                enableSignLanguageDetectionAsync(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                downloadAiModel(g, f) {
                    return Promise.reject(new Error("Not implemented"));
                }
                getSpeakerVolume() {
                    return Promise.reject(new Error("Not implemented"));
                }
                getSpeakerSystemVolume() {
                    return Promise.reject(new Error("Not implemented"));
                }
                setSpeakerVolume(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                setSpeakerSystemVolume(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                unmuteMicrophone() {
                    return Promise.reject(new Error("Not implemented"));
                }
                unmuteSpeaker() {
                    return Promise.reject(new Error("Not implemented"));
                }
                getNrgLevelsForDeviceTuner(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                async getNrgLevelPollerForDeviceTuner(g) {
                    return await this._deviceManager.getNrgLevelPollerForDeviceTuner();
                }
                setAudioEffectsAsync(g, f) {
                    return this._deviceManager.setAudioEffects(f);
                }
                getAudioFeatureCapability(g) {
                    return this._deviceManager.effectsManager.getEffectsCapability("Audio");
                }
                getAudioFeatureProviderName() {
                    return Promise.resolve(this._deviceManager.effectsManager.getAudioEffectsProviderName());
                }
                getMicrophoneVolume() {
                    return Promise.reject(new Error("Not implemented"));
                }
                setMicrophoneVolume(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                setDeviceTelemetryData(g, f, S, v = 0) {
                    return Promise.reject(new Error("Not implemented"));
                }
                getSourceFormats(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                enableShellSharing() {
                    return Promise.reject(new Error("Not implemented"));
                }
                disableShellSharing() {
                    return Promise.reject(new Error("Not implemeted"));
                }
                enableParticipantCameras() {
                    return Promise.reject(new Error("Not implemeted"));
                }
                registerDerivedSource(g, f) {
                    return Promise.reject(new Error("Not implemeted"));
                }
                unregisterDerivedSource(g) {
                    return Promise.reject(new Error("Not implemeted"));
                }
                async createPreview(g, f, S) {
                    if ("camera" === f.kind && this.isVirtualDevice(f.device)) return this.virtualDeviceAdapter.createPreview(g, S, this.getRenderer, f.device)[0];
                    if ("sharing" === f.kind) return this.createScreenSharingPreviewRenderer(g, S);
                    if ("camera" !== f.kind || !(0, go.isUndefined)(f.device)) throw new Error("Not yet supported");
                    return this.createPreviewRenderer(g, S);
                }
                async createPreviewRenderer(g, f) {
                    return this.getRenderer(g, f, this._deviceManager, "Video");
                }
                async createScreenSharingPreviewRenderer(g, f) {
                    return this.getRenderer(g, f, this._deviceManager, "ScreenShare");
                }
                getRawDeviceMediaStream(g, f, S) {
                    const v = getAgentMediaType(g);
                    return this.isVirtualDevice(S) ? this.virtualDeviceAdapter.getRawDeviceMediaStream(v, f, S)[0] : this._deviceManager.getRawDeviceMediaStream(v, f);
                }
                setRawMediaStream(g, f, S) {
                    const v = getAgentMediaType(f);
                    return this.isVirtualDevice(S) ? this.virtualDeviceAdapter.setRawMediaStream(g, v, S) : this._deviceManager.setRawMediaStream(g, v);
                }
                unsetRawMediaStream(g, f) {
                    const S = getAgentMediaType(g);
                    return this.isVirtualDevice(f) ? this.virtualDeviceAdapter.unsetRawMediaStream(S, f) : this._deviceManager.unsetRawMediaStream(S);
                }
                createAudioRenderer() {
                    return this._deviceManager.createAudioRenderer();
                }
                startAudioLoopbackDevice(g) {
                    return Promise.reject(new Error("Not implemented"));
                }
                async dispose(g) {
                    return this._deviceManager.dispose(g);
                }
                async registerCompositeVideoDevice(g, f, S) {
                    return this._deviceManager.registerVirtualDevice(g, f, S);
                }
                async unregisterCompositeVideoDevice(g) {
                    return this._deviceManager.unregisterVirtualDevice(g);
                }
                async createAudioPlayer() {
                    return Promise.reject(new Error("Not implemented"));
                }
                _raiseDevicesChanged(g) {
                    (g ? Promise.resolve(g) : this.enumerateDevicesAsync()).then((g)=>{
                        this.raiseChanged(), this.event("devicesChanged").raise(g);
                    });
                }
                getPermissionStateHelper(g) {
                    switch(g){
                        case "granted":
                            return "granted";
                        case "denied":
                            return "denied";
                        case "prompt":
                            return "prompt";
                        default:
                            return "unknown";
                    }
                }
                _mapDevices(g) {
                    return g === null || g === void 0 ? void 0 : g.map((g)=>this._mapDeviceDesc(g));
                }
                _mapDeviceDesc(g) {
                    const f = _DeviceManagerAdapter._mapDeviceType(g.kind);
                    if (6 === f) return {
                        id: g.id,
                        label: g.label,
                        kind: f,
                        position: 0,
                        defaultVideoId: g.id,
                        devicesIds: []
                    };
                    if (1 === f) return {
                        id: g.id,
                        browserId: g.browserId,
                        label: g.label,
                        kind: f,
                        position: _DeviceManagerAdapter._mapCameraPosition(g.position)
                    };
                    if (4 === f) return {
                        id: null,
                        browserId: null,
                        label: g.label,
                        kind: f,
                        formFactor: g.formFactor,
                        isPcInternalDevice: g.isPcInternalDevice,
                        microphoneId: g.microphoneId,
                        speakerId: g.speakerId
                    };
                    return {
                        id: g.id,
                        browserId: g.browserId === mo ? "default" : g.browserId,
                        label: g.label,
                        kind: f,
                        isSystemDefault: !!g.isSystemDefault
                    };
                }
                static _mapDeviceType(g) {
                    switch(g){
                        case "camera":
                            return 1;
                        case "microphone":
                            return 2;
                        case "speaker":
                            return 3;
                        case "compositeAudio":
                            return 4;
                        case "virtualDevice":
                            return 6;
                        default:
                            throw new Error(`Invalid device type '${g}'`);
                    }
                }
                static _mapCameraPosition(g) {
                    switch(g){
                        case "front":
                            return 1;
                        case "back":
                            return 2;
                        case "external":
                            return 3;
                        default:
                            return 0;
                    }
                }
                isVirtualDevice(g) {
                    return g && this._deviceManager.getRegisteredDevices().some((f)=>f.id === g);
                }
                async getRenderer(g, f, S, v) {
                    const _ = new zr(g, S, v);
                    try {
                        await _.startVideoAsync(), f && (_.setScalingMode(f.scalingMode), _.setVideoMirroring(!f.ignoreMirroring));
                    } catch (g) {
                        throw _.dispose(), g;
                    }
                    return _;
                }
                constructor(g){
                    super(), this._deviceManager = g, this.virtualDeviceAdapter = new po(this._deviceManager), g.on("onDevicesChanged", (g)=>{
                        const f = this._deviceManager.getDeviceDescriptions(g), S = this._mapDevices(f);
                        this._raiseDevicesChanged(S);
                    }), g.on("onSelectedDevicesChanged", (g)=>this._raiseDevicesChanged()), g.on("onPermissionStateChanged", ()=>this.event("onPermissionStateChanged").raise()), g.on("onVideoEffectsEvent", (g, f)=>this.event("videoEffectsEvent").raise(g, f)), g.on("onVideoEffectApplied", ()=>this.event("videoEffectApplied").raise()), g.on("onEffectsError", (g, f, S)=>this.event("onEffectsError").raise(getSkypeMediaType(g), f, S));
                }
            }, So = R, vo = R, _o = class extends vo.AbstractLogAppender {
                log(g, f, S, v) {
                    if (!this._logger) return;
                    const _ = g.level <= vo.LogLevel.Debug4 ? this._logger.debug : g.level <= vo.LogLevel.Debug2 ? this._logger.log : g.level <= vo.LogLevel.Debug1 ? this._logger.info : g.level <= vo.LogLevel.Warning ? this._logger.warn : this._logger.error;
                    _ && _.apply(this._logger, [
                        this.formatter().format(g, f, S, v)
                    ]);
                }
                constructor(g){
                    super(new vo.StandardLogFormatter(vo.SLF_Flags.Component)), this._logger = g;
                }
            }, Co = R, yo = __toESM(be()), Eo = [
                "CorrelationId",
                "agent_environment_id",
                "UserInfo_TenantId",
                "participant_id",
                "endpoint_id",
                "mediaLegId",
                "metrics_ConfigIds",
                "ts_calling_version",
                "uiVersion"
            ], To = {
                video: [
                    ...Eo,
                    "Extensions_WebRTCStats_ssrc_video_recv_framesDecoded",
                    "Extensions_WebRTCStats_ssrc_video_recv_packetsReceived",
                    "Extensions_WebRTCStats_ssrc_video_recv_ssrc",
                    "Extensions_WebRTCStats_ssrc_video_recv_bytesReceived",
                    "Extensions_WebRTCStats_ssrc_video_recv_googFrameRateDecoded",
                    "Extensions_Video_SubscriptionEvents",
                    "Extensions_Video_recv_ResolutionDurations",
                    "Extensions_Video_recv_StreamsMax",
                    "Extensions_Video_recv_frameRateAvg",
                    "Extensions_Video_recv_DurationSeconds",
                    "Extensions_Video_recv_FreezeHistogram",
                    "Extensions_Video_recv_FreezeTimestamps",
                    "Extensions_WebRTCStats_ssrc_video_recv_keyFramesDecoded",
                    "Extensions_Video_recv_TotalFreezeDurationMs",
                    "Extensions_Video_recv_packetsLostRateMax",
                    "metrics_ReconnectAttempts",
                    "metrics_ReconnectConnectedCount",
                    "metrics_RetargetCompletedCount",
                    "metrics_UFDs",
                    "Payload"
                ],
                sharing: [
                    ...Eo,
                    "Extensions_WebRTCStats_ssrc_sharing_recv_framesDecoded",
                    "Extensions_WebRTCStats_ssrc_sharing_recv_packetsReceived",
                    "Extensions_WebRTCStats_ssrc_sharing_recv_ssrc",
                    "Extensions_WebRTCStats_ssrc_sharing_recv_bytesReceived",
                    "Extensions_WebRTCStats_ssrc_sharing_recv_googFrameRateDecoded",
                    "Extensions_WebRTCStats_ssrc_sharing_recv_keyFramesDecoded",
                    "Extensions_Sharing_SubscriptionEvents",
                    "Extensions_Sharing_recv_ResolutionDurations",
                    "Extensions_Sharing_recv_StreamsMax",
                    "Extensions_Sharing_recv_frameRateAvg",
                    "Extensions_Sharing_recv_DurationSeconds",
                    "Extensions_Sharing_recv_FreezeHistogram",
                    "Extensions_Sharing_recv_FreezeTimestamps",
                    "Extensions_Sharing_recv_TotalFreezeDurationMs",
                    "Extensions_Sharing_recv_packetsLostRateMax",
                    "metrics_ReconnectAttempts",
                    "metrics_ReconnectConnectedCount",
                    "metrics_RetargetCompletedCount",
                    "metrics_UFDs",
                    "Payload"
                ]
            }, Io = class extends ze {
                send(g) {
                    g && setTimeout(()=>{
                        this.event("sendMidCallTelemetry").raise(To[g]);
                    }, this.stabilizationTimeInAvg);
                }
                constructor(){
                    super(...arguments), this.stabilizationTimeInAvg = 2e4;
                }
            }, bo = class extends ze {
                fetchEcsConfig(g, f) {
                    return yo.Resolved().then(()=>this._ecsProvider.getEcsConfig(g, f));
                }
                sendTelemetry(g, f) {
                    this._telemetryService.getGenericTelemetryLogger && g ? this._telemetryService.getGenericTelemetryLogger(g).sendEvent({
                        eventName: "rt_log",
                        props: f
                    }) : this._telemetryService.sendEvents([
                        {
                            eventName: "rt_log",
                            props: f
                        }
                    ]);
                }
                sendMidCallTelemetry(g) {
                    Object.keys(To).includes(g) && this.event("onMidCallTelemetry").raise(g);
                }
                constructor(g, f){
                    super(), this._telemetryService = g, this._ecsProvider = f, this._ecsProvider.on("OnECSChanged", ()=>Co.RootToolsManager.OnEcsChange());
                }
            };
            function initLogger(g, f, S) {
                if (!So.RootToolsManager.isDelegateSet()) {
                    const v = new bo(g.telemetryService, f);
                    if (So.RootToolsManager.setDelegate(v), v.on("onMidCallTelemetry", (g)=>S.send(g)), g.logger) {
                        const f = new _o(g.logger);
                        So.LogFactory.instance().addAppender(f);
                    }
                }
                g.logger = new Le("JS.TsCalling.Pluginless", !0), g.mediaAgentFactoryConfig.logger = new Le("JS.TsCalling.MediaAgentUnsafe", !1), g.mediaAgentFactoryConfig.safeLogger = new Le("JS.TsCalling.MediaAgent", !0), g.signalingAgentConfig.logger = new Le("JS.TsCalling.SignalingAgent", !0);
            }
            var Ao = P, Ro = class _NoopLogger {
                logInfo() {}
                logFailure() {}
                logSuccess() {}
                log(...g) {}
                debug(...g) {}
                info(...g) {}
                warn(...g) {}
                error(...g) {}
                useConsoleLogger() {
                    this._useConsoleLogger = !0;
                    const logWithConsole = (...g)=>{
                        console.info(this._prefix || "", ...g);
                    };
                    this.log = logWithConsole, this.debug = logWithConsole, this.info = logWithConsole, this.warn = logWithConsole, this.error = logWithConsole, (0, Ao.each)(this._children, (g)=>g.useConsoleLogger());
                }
                constructor(g){
                    this._prefix = g, this._children = [], this._useConsoleLogger = !1, this.createChild = (g, f)=>{
                        const S = "function" == typeof g ? "" : g, v = new _NoopLogger((this._prefix || "") + S);
                        return this._children.push(v), this._useConsoleLogger && v.useConsoleLogger(), v;
                    }, this.createFnLogger = (g, f, ...S)=>{
                        const v = `[${f}][${g}]`, _ = new _NoopLogger((this._prefix || "") + v);
                        return this._children.push(_), this._useConsoleLogger && _.useConsoleLogger(), _;
                    };
                }
            }, Po = class {
                get audio() {
                    return this.getCapability("audio");
                }
                get video() {
                    return this.getCapability("video");
                }
                get screensharing() {
                    return this.getCapability("screensharing");
                }
                get retargeting() {
                    return this.getCapability("retargeting");
                }
                dispose() {
                    this.configProviderSub && this.configProviderSub.dispose();
                }
                updateCapabilityOverrides() {
                    let g;
                    this.configProvider.config.capabilities && (g = this.configProvider.config.capabilities), this.overrides = g || {};
                }
                hasMediaCapture() {
                    return !!this.window.navigator.getUserMedia;
                }
                getCapability(g) {
                    return void 0 !== this.overrides[g] ? !!this.overrides[g] : this.hasMediaCapture() && this.hasWebRtc();
                }
                hasWebRtc() {
                    return void 0 !== this.window.RTCPeerConnection;
                }
                constructor(g){
                    this.configProvider = g, this.window = Qa.window, this.updateCapabilityOverrides(), this.configProviderSub = g.on("configUpdated", ()=>this.updateCapabilityOverrides());
                }
            }, wo = class _UFDManager extends Bt {
                signalEvent(g, f, S = "Audio", v = !0, _ = generateCauseId(), C, E) {
                    const T = {
                        type: g,
                        value: f,
                        isLocalSource: v,
                        mediaType: S,
                        deviceManagerId: C,
                        diagnosticData: E
                    }, I = this.getEventKey(T), b = this.eventStates.get(I);
                    (!b || b.value !== f || this.configProvider.config.alwaysRaiseBadDeviceEvents && "Good" !== f) && (b || "Good" !== f) && (this.eventStates.set(I, T), this.shouldRaiseEvent(T, b) && (this.logger.safe.info(`[${_}] Raising UFD ${g} for ${S}: ${f}`), this.event("onQualityChanged").raise(T)));
                }
                signalDeviceEvent(g, f, S, v) {
                    const _ = _UFDManager.getQualityEventType(g, S, this.configProvider);
                    _ ? this.signalEvent(_, f, S, void 0, generateCauseId(), v) : this.logger.warn(`Unknown device quality event type: ${g}`);
                }
                raisePendingWhitelistingUFD() {
                    this.lastWhitelistingUFD && (this.logger.safe.debug(`Raising whitelisting UFD ${this.lastWhitelistingUFD.type}: ${this.lastWhitelistingUFD.value}`), this.event("onQualityChanged").raise(this.lastWhitelistingUFD), this.cancelPendingWhitelistingUFD());
                }
                cancelPendingWhitelistingUFD() {
                    if (this.lastWhitelistingUFD) {
                        const g = this.getEventKey(this.lastWhitelistingUFD);
                        this.eventStates.delete(g);
                    }
                    this.lastWhitelistingUFD = void 0;
                }
                setSwMute(g) {
                    if (this.swMuted = g, g) {
                        const g = this.eventStates.get(this.getEventKey({
                            type: "DeviceSpeakWhileMuted",
                            mediaType: "Audio"
                        }));
                        g && "Good" !== g.value && this.event("onQualityChanged").raise(g);
                    }
                }
                applyCurrentState(g) {
                    this.cancelPendingWhitelistingUFD();
                    let f = 0;
                    for (const S of this.eventStates.values())"Good" !== S.value && (g(S), f++);
                    f > 0 && this.logger.safe.info(`Applied ${f} UFDs`);
                }
                reset() {
                    this.logger.safe.info("Resetting UFD states");
                    for (const [g, f] of this.eventStates.entries())_UFDManager.persistent.has(f.type) || this.eventStates.delete(g);
                    this.lastWhitelistingUFD = void 0, this.swMuted = !1;
                }
                getEventKey(g) {
                    return `${g.type}:${g.mediaType}`;
                }
                shouldRaiseEvent(g, f) {
                    return "NetworkRelaysNotReachable" === g.type ? (this.lastWhitelistingUFD = g, !1) : !!("DeviceSpeakWhileMuted" !== g.type || this.swMuted || "Good" === g.value && "Good" !== (f === null || f === void 0 ? void 0 : f.value)) && !("NetworkRecvQuality" === g.type && !this.configProvider.config.webrtcStatNetworkDetectionEnabled) && !(this.configProvider.config.alwaysRaiseBadDeviceEvents && !_UFDManager.deviceQualityEvents.has(g.type) && g.value === (f === null || f === void 0 ? void 0 : f.value));
                }
                static getQualityEventType(g, f, S) {
                    switch(g){
                        case 0:
                            return "Audio" === f ? "DeviceCaptureNotFunctioning" : "VideoCapturerDeviceStartFailed";
                        case 1:
                            return "DeviceRenderNotFunctioning";
                        case 2:
                            return "Audio" === f ? "DeviceCaptureNotFunctioning" : "VideoCapturerDeviceStartTimedOut";
                        case 3:
                            return "DeviceCaptureMute";
                        case 4:
                            switch(f){
                                case "ScreenShare":
                                    return "ScreenshareRecordingDisabled";
                                case "Audio":
                                    return S.config.enableSignalingAudioPermissionDeniedUFD ? "AudioCapturePermissionDenied" : "DeviceCaptureNotMuteButSilent";
                                case "Video":
                                    return "VideoCapturePermissionDenied";
                                default:
                                    return;
                            }
                        default:
                            return;
                    }
                }
                constructor(g, f){
                    super(g), this.logger = g, this.configProvider = f, this.eventStates = new Map, this.swMuted = !1, this.logger.safe.info("Initialized");
                }
            };
            wo.persistent = new Set([
                "ZeroCaptureDevicesEnumerated",
                "ZeroRenderDevicesEnumerated"
            ]), wo.deviceQualityEvents = new Set([
                "DeviceCaptureNotFunctioning",
                "VideoCapturerDeviceStartFailed",
                "DeviceCaptureNotFunctioning",
                "VideoCapturerDeviceStartTimedOut",
                "DeviceCaptureMute",
                "ScreenshareRecordingDisabled",
                "DeviceCaptureNotMuteButSilent",
                "VideoCapturePermissionDenied"
            ]);
            var Mo = wo, Oo = P, Do = "function", No = "object", ko = "undefined", Lo = "prototype", Fo = Object, xo = Fo[Lo];
            function _pureAssign(g, f) {
                return g || f;
            }
            function _pureRef(g, f) {
                return g[f];
            }
            var Uo, Vo = void 0, Bo = null, Ho = "", $o = "function", jo = "object", Go = "prototype", qo = "__proto__", Wo = "undefined", zo = "constructor", Ko = "Symbol", Jo = "_polyfill", Yo = "length", Qo = "name", Xo = "call", Zo = "toString", el = _pureAssign(Object), tl = _pureRef(el, Go), il = _pureAssign(String), nl = _pureRef(il, Go), rl = _pureAssign(Math), al = _pureAssign(Array), sl = _pureRef(al, Go), ol = _pureRef(sl, "slice");
            function safe(g, f) {
                try {
                    return {
                        v: g.apply(this, f)
                    };
                } catch (g) {
                    return {
                        e: g
                    };
                }
            }
            function safeGet(g, f) {
                var S = safe(g);
                return S.e ? f : S.v;
            }
            function _createIs(g) {
                return function(f) {
                    return typeof f === g;
                };
            }
            function _createObjIs(g) {
                var f = "[object " + g + "]";
                return function(g) {
                    return !(!g || objToString(g) !== f);
                };
            }
            function objToString(g) {
                return tl[Zo].call(g);
            }
            function isUndefined4(g) {
                return typeof g === Wo || g === Wo;
            }
            function isNullOrUndefined(g) {
                return g === Bo || isUndefined4(g);
            }
            function isStrictNullOrUndefined(g) {
                return g === Bo || !isDefined2(g);
            }
            function isDefined2(g) {
                return !!g || g !== Vo;
            }
            function isPrimitive(g) {
                return g === Bo || isPrimitiveType(typeof g);
            }
            function isPrimitiveType(g) {
                return !Uo && (Uo = [
                    "string",
                    "number",
                    "boolean",
                    Wo,
                    "symbol",
                    "bigint"
                ]), g !== jo && -1 !== Uo.indexOf(g);
            }
            var ll = _createIs("string"), cl = _createIs($o);
            function isObject3(g) {
                return !(!g && isNullOrUndefined(g)) && !!g && typeof g === jo;
            }
            var dl = _pureRef(al, "isArray"), ul = _createObjIs("Date"), hl = _createIs("number"), gl = _createIs("boolean"), pl = _createObjIs("Error");
            function isPromiseLike2(g) {
                return !!(g && g.then && cl(g.then));
            }
            function isTruthy(g) {
                return !(!g || safeGet(function() {
                    return !(g && 0 + g);
                }, !g));
            }
            var ml = _pureRef(el, "getOwnPropertyDescriptor");
            function objHasOwnProperty(g, f) {
                return !!g && tl.hasOwnProperty[Xo](g, f);
            }
            var fl = _pureAssign(_pureRef(el, "hasOwn"), polyObjHasOwn);
            function polyObjHasOwn(g, f) {
                return objHasOwnProperty(g, f) || !!ml(g, f);
            }
            function objForEachKey(g, f, S) {
                if (g && isObject3(g)) {
                    for(var v in g)if (fl(g, v) && -1 === f[Xo](S || g, v, g[v])) break;
                }
            }
            var Sl = {
                e: "enumerable",
                c: "configurable",
                v: "value",
                w: "writable",
                g: "get",
                s: "set"
            };
            function _createProp(g) {
                var f = {};
                if (f[Sl.c] = !0, f[Sl.e] = !0, g.l) {
                    f.get = function() {
                        return g.l.v;
                    };
                    var S = ml(g.l, "v");
                    S && S.set && (f.set = function(f) {
                        g.l.v = f;
                    });
                }
                return objForEachKey(g, function(g, S) {
                    f[Sl[g]] = isUndefined4(S) ? f[Sl[g]] : S;
                }), f;
            }
            var vl = _pureRef(el, "defineProperty"), _l = _pureRef(el, "defineProperties");
            function objDefine(g, f, S) {
                return vl(g, f, _createProp(S));
            }
            function objDefineProps(g, f) {
                var S = {};
                return objForEachKey(f, function(g, f) {
                    S[g] = _createProp(f);
                }), _l(g, S);
            }
            function _createKeyValueMap(g, f, S, v, _) {
                var C = {};
                return objForEachKey(g, function(g, v) {
                    _assignMapValue(C, g, f ? v : g, _), _assignMapValue(C, v, S ? v : g, _);
                }), v ? v(C) : C;
            }
            function _assignMapValue(g, f, S, v) {
                vl(g, f, {
                    value: S,
                    enumerable: !0,
                    writable: !!v
                });
            }
            var Cl = _pureAssign(il), yl = "[object Error]";
            function dumpObj(g, f) {
                var S = Ho, v = tl[Zo][Xo](g);
                v === yl && (g = {
                    stack: Cl(g.stack),
                    message: Cl(g.message),
                    name: Cl(g.name)
                });
                try {
                    S = (S = JSON.stringify(g, Bo, f ? "number" == typeof f ? f : 4 : Vo)) && S.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") || Cl(g);
                } catch (g) {
                    S = " - " + dumpObj(g, f);
                }
                return v + ": " + S;
            }
            function throwError(g) {
                throw new Error(g);
            }
            function throwTypeError(g) {
                throw new TypeError(g);
            }
            var El = _pureRef(el, "freeze");
            function _doNothing(g) {
                return g;
            }
            function _getProto(g) {
                return g[qo] || Bo;
            }
            var Tl = _pureRef(el, "assign"), Il = _pureRef(el, "keys");
            function objDeepFreeze(g) {
                return El && objForEachKey(g, function(g, f) {
                    (dl(f) || isObject3(f)) && objDeepFreeze(f);
                }), bl(g);
            }
            var bl = _pureAssign(El, _doNothing), Al = _pureAssign(_pureRef(el, "getPrototypeOf"), _getProto);
            function createEnum(g) {
                return _createKeyValueMap(g, 1, 0, bl);
            }
            function createEnumKeyMap(g) {
                return _createKeyValueMap(g, 0, 0, bl);
            }
            function createSimpleMap(g) {
                var f = {};
                return objForEachKey(g, function(g, S) {
                    _assignMapValue(f, g, S[1]), _assignMapValue(f, S[0], S[1]);
                }), bl(f);
            }
            function createTypeMap(g) {
                return createSimpleMap(g);
            }
            var Rl, Pl = createEnumKeyMap({
                asyncIterator: 0,
                hasInstance: 1,
                isConcatSpreadable: 2,
                iterator: 3,
                match: 4,
                matchAll: 5,
                replace: 6,
                search: 7,
                species: 8,
                split: 9,
                toPrimitive: 10,
                toStringTag: 11,
                unscopables: 12
            }), wl = "__tsUtils$gblCfg";
            function _getGlobalValue() {
                var g;
                return typeof globalThis !== Wo && (g = globalThis), g || typeof self === Wo || (g = self), g || typeof window === Wo || (g = window), g || typeof S === Wo || (g = S), g;
            }
            function _getGlobalConfig() {
                if (!Rl) {
                    var g = safe(_getGlobalValue).v || {};
                    Rl = g[wl] = g[wl] || {};
                }
                return Rl;
            }
            var Ml = _unwrapFunctionWithPoly;
            function _unwrapFunctionWithPoly(g, f, S) {
                var v = f && f[g];
                return function(f) {
                    var _ = f && f[g] || v;
                    if (_ || S) {
                        var C = arguments;
                        return (_ || S).apply(f, _ ? ol[Xo](C, 1) : C);
                    }
                    throwTypeError('"' + Cl(g) + '" not defined for ' + dumpObj(f));
                };
            }
            function _unwrapProp(g) {
                return function(f) {
                    return f[g];
                };
            }
            var Ol = _pureRef(rl, "max"), Dl = Ml("slice", nl), Nl = Ml("substring", nl), kl = _unwrapFunctionWithPoly("substr", nl, polyStrSubstr);
            function polyStrSubstr(g, f, S) {
                return isNullOrUndefined(g) && throwTypeError("Invalid " + dumpObj(g)), S < 0 ? Ho : ((f = f || 0) < 0 && (f = Ol(f + g[Yo], 0)), isUndefined4(S) ? Dl(g, f) : Dl(g, f, f + S));
            }
            function strLeft(g, f) {
                return Nl(g, 0, f);
            }
            var Ll, Fl, xl, Ul = "_urid";
            function _globalSymbolRegistry() {
                if (!Ll) {
                    var g = _getGlobalConfig();
                    Ll = g.gblSym = g.gblSym || {
                        k: {},
                        s: {}
                    };
                }
                return Ll;
            }
            function polyNewSymbol(g) {
                var f = {
                    description: Cl(g),
                    toString: function() {
                        return Ko + "(" + g + ")";
                    }
                };
                return f[Jo] = !0, f;
            }
            function polySymbolFor(g) {
                var f = _globalSymbolRegistry();
                if (!fl(f.k, g)) {
                    var S = polyNewSymbol(g), v = Il(f.s).length;
                    S[Ul] = function() {
                        return v + "_" + S[Zo]();
                    }, f.k[g] = S, f.s[S[Ul]()] = Cl(g);
                }
                return f.k[g];
            }
            function polyGetKnownSymbol(g) {
                var f;
                !Fl && (Fl = {});
                var S = Pl[g];
                return S && (f = Fl[S] = Fl[S] || polyNewSymbol(Ko + "." + S)), f;
            }
            function _initTestHooks() {
                xl = _getGlobalConfig();
            }
            function getLazy(g) {
                var f = {};
                return !xl && _initTestHooks(), f.b = xl.lzy, vl(f, "v", {
                    configurable: !0,
                    get: function() {
                        var S = g();
                        return xl.lzy || vl(f, "v", {
                            value: S
                        }), f.b = xl.lzy, S;
                    }
                }), f;
            }
            function createCachedValue(g) {
                return vl({
                    toJSON: function() {
                        return g;
                    }
                }, "v", {
                    value: g
                });
            }
            var Vl, Bl = "window";
            function _getGlobalInstFn(g, f) {
                var S;
                return function() {
                    return !xl && _initTestHooks(), (!S || xl.lzy) && (S = createCachedValue(safe(g, f).v)), S.v;
                };
            }
            function getGlobal(g) {
                return !xl && _initTestHooks(), (!Vl || !1 === g || xl.lzy) && (Vl = createCachedValue(safe(_getGlobalValue).v || Bo)), Vl.v;
            }
            function getInst(g, f) {
                var S = Vl && !1 !== f ? Vl.v : getGlobal(f);
                return S && S[g] ? S[g] : g === Bl ? $l() : Bo;
            }
            function hasDocument() {
                return !!Hl();
            }
            var Hl = _getGlobalInstFn(getInst, [
                "document"
            ]);
            function hasWindow() {
                return !!$l();
            }
            var $l = _getGlobalInstFn(getInst, [
                Bl
            ]);
            function hasNavigator() {
                return !!Wl();
            }
            var jl, Gl, ql, Wl = _getGlobalInstFn(getInst, [
                "navigator"
            ]), zl = _getGlobalInstFn(function() {
                return !!safe(function() {
                    return $lUPho && ($lUPho.versions || {}).node;
                }).v;
            });
            function _initSymbol() {
                return jl = createCachedValue(safe(getInst, [
                    Ko
                ]).v);
            }
            function _getSymbolKey(g) {
                var f = (xl.lzy ? 0 : jl) || _initSymbol();
                return f.v ? f.v[g] : Vo;
            }
            function hasSymbol() {
                return !!getSymbol();
            }
            function getSymbol() {
                return !xl && _initTestHooks(), ((xl.lzy ? 0 : jl) || _initSymbol()).v;
            }
            function getKnownSymbol(g, f) {
                var S = Pl[g];
                !xl && _initTestHooks();
                var v = (xl.lzy ? 0 : jl) || _initSymbol();
                return v.v ? v.v[S || g] : f ? Vo : polyGetKnownSymbol(g);
            }
            function newSymbol(g, f) {
                !xl && _initTestHooks();
                var S = (xl.lzy ? 0 : jl) || _initSymbol();
                return S.v ? S.v(g) : f ? Bo : polyNewSymbol(g);
            }
            function symbolFor(g) {
                return !xl && _initTestHooks(), ((Gl = (xl.lzy ? 0 : Gl) || createCachedValue(safe(_getSymbolKey, [
                    "for"
                ]).v)).v || polySymbolFor)(g);
            }
            function isIterator(g) {
                return !!g && cl(g.next);
            }
            function isIterable(g) {
                return !isStrictNullOrUndefined(g) && cl(g[getKnownSymbol(3)]);
            }
            function iterForOf(g, f, S) {
                if (g && (isIterator(g) || (!ql && (ql = createCachedValue(getKnownSymbol(3))), g = g[ql.v] ? g[ql.v]() : null), isIterator(g))) {
                    var v = Vo, _ = Vo;
                    try {
                        for(var C = 0; !(_ = g.next()).done && -1 !== f[Xo](S || g, _.value, C, g);)C++;
                    } catch (f) {
                        v = {
                            e: f
                        }, g.throw && (_ = Bo, g.throw(v));
                    } finally{
                        try {
                            _ && !_.done && g.return && g.return(_);
                        } finally{
                            if (v) throw v.e;
                        }
                    }
                }
            }
            function fnApply(g, f, S) {
                return g.apply(f, S);
            }
            function arrAppend(g, f) {
                return !isUndefined4(f) && g && (dl(f) ? fnApply(g.push, g, f) : isIterator(f) || isIterable(f) ? iterForOf(f, function(f) {
                    g.push(f);
                }) : g.push(f)), g;
            }
            function arrForEach(g, f, S) {
                if (g) for(var v = g[Yo] >>> 0, _ = 0; _ < v && (!(_ in g) || -1 !== f[Xo](S || g, g[_], _, g)); _++);
            }
            var Kl = Ml("indexOf", sl);
            function arrSlice(g, f, S) {
                return (g && g.slice || ol).apply(g, ol[Xo](arguments, 1));
            }
            function polyArrIncludes(g, f, S) {
                return -1 !== Kl(g, f, S);
            }
            var Jl, Yl = _unwrapFunctionWithPoly("includes", sl, polyArrIncludes), Ql = _pureAssign(_pureRef(el, "create"), polyObjCreate);
            function polyObjCreate(g) {
                if (!g) return {};
                var f = typeof g;
                function tempFunc() {}
                return f !== jo && f !== $o && throwTypeError("Prototype must be an Object or function: " + dumpObj(g)), tempFunc[Go] = g, new tempFunc;
            }
            function objSetPrototypeOf(g, f) {
                return (el.setPrototypeOf || function(g, f) {
                    var S;
                    !Jl && (Jl = createCachedValue(((S = {})[qo] = [], S instanceof Array))), Jl.v ? g[qo] = f : objForEachKey(f, function(f, S) {
                        return g[f] = S;
                    });
                })(g, f);
            }
            function _createCustomError(g, f, S) {
                function __() {
                    this[zo] = f, safe(objDefine, [
                        this,
                        Qo,
                        {
                            v: g,
                            c: !0,
                            e: !1
                        }
                    ]);
                }
                return safe(objDefine, [
                    f,
                    Qo,
                    {
                        v: g,
                        c: !0,
                        e: !1
                    }
                ]), (f = objSetPrototypeOf(f, S))[Go] = S === Bo ? Ql(S) : (__[Go] = S[Go], new __), f;
            }
            function _setName(g, f) {
                f && (g[Qo] = f);
            }
            function createCustomError(g, f, S) {
                var v = S || Error, _ = v[Go][Qo], C = Error.captureStackTrace;
                return _createCustomError(g, function() {
                    var S = this, E = arguments;
                    try {
                        safe(_setName, [
                            v,
                            g
                        ]);
                        var T = fnApply(v, S, ol[Xo](E)) || S;
                        if (T !== S) {
                            var I = Al(S);
                            I !== Al(T) && objSetPrototypeOf(T, I);
                        }
                        return C && C(T, S[zo]), f && f(T, E), T;
                    } finally{
                        safe(_setName, [
                            v,
                            _
                        ]);
                    }
                }, v);
            }
            function utcNow() {
                return (Date.now || polyUtcNow)();
            }
            function polyUtcNow() {
                return (new Date).getTime();
            }
            function _createTrimFn(g) {
                return function _doTrim(f) {
                    return isNullOrUndefined(f) && throwTypeError("strTrim called [" + dumpObj(f) + "]"), f && f.replace && (f = f.replace(g, Ho)), f;
                };
            }
            var Xl, Zl, ec, tc = _unwrapFunctionWithPoly("trim", nl, _createTrimFn(/^\s+|(?=\s)\s+$/g));
            function isPlainObject(g) {
                if (!g || typeof g !== jo) return !1;
                ec || (ec = !hasWindow() || $l());
                var f = !1;
                if (g !== ec) {
                    Zl || (Xl = Function[Go][Zo], Zl = Xl[Xo](el));
                    try {
                        var S = Al(g);
                        (f = !S) || (objHasOwnProperty(S, zo) && (S = S[zo]), f = S && typeof S === $o && Xl[Xo](S) === Zl);
                    } catch (g) {}
                }
                return f;
            }
            function _defaultDeepCopyHandler(g) {
                return g.value && plainObjDeepCopyHandler(g), !0;
            }
            var ic = [
                arrayDeepCopyHandler,
                plainObjDeepCopyHandler,
                functionDeepCopyHandler,
                dateDeepCopyHandler
            ];
            function _getSetVisited(g, f, S, v) {
                var _;
                return arrForEach(g, function(g) {
                    if (g.k === f) return _ = g, -1;
                }), _ || (_ = {
                    k: f,
                    v: f
                }, g.push(_), v(_)), _.v;
            }
            function _deepCopy(g, f, S, v) {
                var _ = S.handler, C = S.path ? v ? S.path.concat(v) : S.path : [], E = {
                    handler: S.handler,
                    src: S.src,
                    path: C
                }, T = typeof f, I = !1, b = !1;
                f && T === jo ? I = isPlainObject(f) : b = f === Bo || isPrimitiveType(T);
                var A = {
                    type: T,
                    isPrim: b,
                    isPlain: I,
                    value: f,
                    result: f,
                    path: C,
                    origin: S.src,
                    copy: function(f, v) {
                        return _deepCopy(g, f, v ? E : S, v);
                    },
                    copyTo: function(f, S) {
                        return _copyProps(g, f, S, E);
                    }
                };
                return A.isPrim ? _ && _[Xo](S, A) ? A.result : f : _getSetVisited(g, f, C, function(g) {
                    objDefine(A, "result", {
                        g: function() {
                            return g.v;
                        },
                        s: function(f) {
                            g.v = f;
                        }
                    });
                    for(var f = 0, v = _; !(v || (f < ic.length ? ic[f++] : _defaultDeepCopyHandler))[Xo](S, A);)v = Bo;
                });
            }
            function _copyProps(g, f, S, v) {
                if (!isNullOrUndefined(S)) for(var _ in S)f[_] = _deepCopy(g, S[_], v, _);
                return f;
            }
            function objCopyProps(g, f, S) {
                return _copyProps([], g, f, {
                    handler: S,
                    src: f,
                    path: []
                });
            }
            function objDeepCopy(g, f) {
                return _deepCopy([], g, {
                    handler: f,
                    src: g
                });
            }
            function arrayDeepCopyHandler(g) {
                var f = g.value;
                if (dl(f)) {
                    var S = g.result = [];
                    return S.length = f.length, g.copyTo(S, f), !0;
                }
                return !1;
            }
            function dateDeepCopyHandler(g) {
                var f = g.value;
                return !!ul(f) && (g.result = new Date(f.getTime()), !0);
            }
            function functionDeepCopyHandler(g) {
                return g.type === $o;
            }
            function plainObjDeepCopyHandler(g) {
                var f = g.value;
                if (f && g.isPlain) {
                    var S = g.result = {};
                    return g.copyTo(S, f), !0;
                }
                return !1;
            }
            function _doExtend(g, f) {
                return arrForEach(f, function(f) {
                    objCopyProps(g, f);
                }), g;
            }
            function deepExtend(g, f, S, v, _, C, E) {
                return _doExtend(objDeepCopy(g) || {}, ol[Xo](arguments));
            }
            var nc = _unwrapProp(Yo);
            function perfNow() {
                return utcNow();
            }
            var rc = _unwrapFunctionWithPoly("endsWith", nl, polyStrEndsWith);
            function polyStrEndsWith(g, f, S) {
                ll(g) || throwTypeError("'" + dumpObj(g) + "' is not a string");
                var v = ll(f) ? f : Cl(f), _ = !isUndefined4(S) && S < g[Yo] ? S : g[Yo];
                return Nl(g, _ - v[Yo], _) === v;
            }
            var ac = Ml("indexOf", nl), sc = _unwrapFunctionWithPoly("startsWith", nl, polyStrStartsWith);
            function polyStrStartsWith(g, f, S) {
                ll(g) || throwTypeError("'" + dumpObj(g) + "' is not a string");
                var v = ll(f) ? f : Cl(f), _ = S > 0 ? S : 0;
                return Nl(g, _, _ + v[Yo]) === v;
            }
            var oc = "ref", lc = "unref", cc = "hasRef", dc = "enabled";
            function _createTimerHandler(g, f, S) {
                var v, _ = !0, C = g ? f(Bo) : Bo;
                function _unref() {
                    return _ = !1, C && C[lc] && C[lc](), v;
                }
                function _cancel() {
                    C && S(C), C = Bo;
                }
                function _refresh() {
                    return C = f(C), _ || _unref(), v;
                }
                function _setEnabled(g) {
                    !g && C && _cancel(), g && !C && _refresh();
                }
                return (v = {
                    cancel: _cancel,
                    refresh: _refresh
                })[cc] = function() {
                    return C && C[cc] ? C[cc]() : _;
                }, v[oc] = function() {
                    return _ = !0, C && C[oc] && C[oc](), v;
                }, v[lc] = _unref, {
                    h: v = vl(v, dc, {
                        get: function() {
                            return !!C;
                        },
                        set: _setEnabled
                    }),
                    dn: function() {
                        C = Bo;
                    }
                };
            }
            function _createTimeoutWith(g, f, S) {
                var v = dl(f), _ = v ? f.length : 0, C = (_ > 0 ? f[0] : v ? Vo : f) || setTimeout, E = (_ > 1 ? f[1] : Vo) || clearTimeout, T = S[0];
                S[0] = function() {
                    I.dn(), fnApply(T, Vo, ol[Xo](arguments));
                };
                var I = _createTimerHandler(g, function(g) {
                    if (g) {
                        if (g.refresh) return g.refresh(), g;
                        fnApply(E, Vo, [
                            g
                        ]);
                    }
                    return fnApply(C, Vo, S);
                }, function(g) {
                    fnApply(E, Vo, [
                        g
                    ]);
                });
                return I.h;
            }
            function scheduleTimeout(g, f) {
                return _createTimeoutWith(!0, Vo, ol[Xo](arguments));
            }
            function scheduleTimeoutWith(g, f, S) {
                return _createTimeoutWith(!0, g, ol[Xo](arguments, 1));
            }
            function createTimeout(g, f) {
                return _createTimeoutWith(!1, Vo, ol[Xo](arguments));
            }
            (getGlobal() || {}).Symbol, (getGlobal() || {}).Reflect;
            var uc, hc = "hasOwnProperty", extendStaticsFn = function(g, f) {
                return (extendStaticsFn = Fo.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(g, f) {
                    g.__proto__ = f;
                } || function(g, f) {
                    for(var S in f)f[hc](S) && (g[S] = f[S]);
                })(g, f);
            };
            function __extendsFn(g, f) {
                function __() {
                    this.constructor = g;
                }
                typeof f !== Do && null !== f && throwTypeError("Class extends value " + String(f) + " is not a constructor or null"), extendStaticsFn(g, f), g[Lo] = null === f ? Ql(f) : (__[Lo] = f[Lo], new __);
            }
            function __spreadArrayFn(g, f) {
                for(var S = 0, v = f.length, _ = g.length; S < v; S++, _++)g[_] = f[S];
                return g;
            }
            var gc = "constructor", pc = "prototype", mc = "function", fc = "_dynInstFuncs", Sc = "_isDynProxy", vc = "_dynClass", _c = "_dynCls$", Cc = "_dynInstChk", yc = Cc, Ec = "_dfOpts", Tc = "_unknown_", Ic = "__proto__", bc = "_dyn" + Ic, Ac = "__dynProto$Gbl", Rc = "_dynInstProto", Pc = "useBaseInst", wc = "setInstFuncs", Mc = Object, Oc = Mc.getPrototypeOf, Dc = Mc.getOwnPropertyNames, Nc = getGlobal(), kc = Nc[Ac] || (Nc[Ac] = {
                o: (uc = {}, uc[wc] = !0, uc[Pc] = !0, uc),
                n: 1e3
            });
            function _isObjectOrArrayPrototype(g) {
                return g && (g === Mc[pc] || g === Array[pc]);
            }
            function _isObjectArrayOrFunctionPrototype(g) {
                return _isObjectOrArrayPrototype(g) || g === Function[pc];
            }
            function _getObjProto(g) {
                var f;
                if (g) {
                    if (Oc) return Oc(g);
                    var S = g[Ic] || g[pc] || (g[gc] ? g[gc][pc] : null);
                    f = g[bc] || S, objHasOwnProperty(g, bc) || (delete g[Rc], f = g[bc] = g[Rc] || g[bc], g[Rc] = S);
                }
                return f;
            }
            function _forEachProp(g, f) {
                var S = [];
                if (Dc) S = Dc(g);
                else for(var v in g)"string" == typeof v && objHasOwnProperty(g, v) && S.push(v);
                if (S && S.length > 0) for(var _ = 0; _ < S.length; _++)f(S[_]);
            }
            function _isDynamicCandidate(g, f, S) {
                return f !== gc && typeof g[f] === mc && (S || objHasOwnProperty(g, f)) && f !== Ic && f !== pc;
            }
            function _throwTypeError(g) {
                throwTypeError("DynamicProto: " + g);
            }
            function _getInstanceFuncs(g) {
                var f = Ql(null);
                return _forEachProp(g, function(S) {
                    !f[S] && _isDynamicCandidate(g, S, !1) && (f[S] = g[S]);
                }), f;
            }
            function _hasVisited(g, f) {
                for(var S = g.length - 1; S >= 0; S--)if (g[S] === f) return !0;
                return !1;
            }
            function _getBaseFuncs(g, f, S, v) {
                function _instFuncProxy(g, f, S) {
                    var _ = f[S];
                    if (_[Sc] && v) {
                        var C = g[fc] || {};
                        !1 !== C[yc] && (_ = (C[f[vc]] || {})[S] || _);
                    }
                    return function() {
                        return _.apply(g, arguments);
                    };
                }
                var _ = Ql(null);
                _forEachProp(S, function(g) {
                    _[g] = _instFuncProxy(f, S, g);
                });
                for(var C = _getObjProto(g), E = []; C && !_isObjectArrayOrFunctionPrototype(C) && !_hasVisited(E, C);)_forEachProp(C, function(g) {
                    !_[g] && _isDynamicCandidate(C, g, !Oc) && (_[g] = _instFuncProxy(f, C, g));
                }), E.push(C), C = _getObjProto(C);
                return _;
            }
            function _getInstFunc(g, f, S, v) {
                var _ = null;
                if (g && objHasOwnProperty(S, vc)) {
                    var C = g[fc] || Ql(null);
                    if ((_ = (C[S[vc]] || Ql(null))[f]) || _throwTypeError("Missing [" + f + "] " + mc), !_[Cc] && !1 !== C[yc]) {
                        for(var E = !objHasOwnProperty(g, f), T = _getObjProto(g), I = []; E && T && !_isObjectArrayOrFunctionPrototype(T) && !_hasVisited(I, T);){
                            var b = T[f];
                            if (b) {
                                E = b === v;
                                break;
                            }
                            I.push(T), T = _getObjProto(T);
                        }
                        try {
                            E && (g[f] = _), _[Cc] = 1;
                        } catch (g) {
                            C[yc] = !1;
                        }
                    }
                }
                return _;
            }
            function _getProtoFunc(g, f, S) {
                var v = f[g];
                return v === S && (v = _getObjProto(f)[g]), typeof v !== mc && _throwTypeError("[" + g + "] is not a " + mc), v;
            }
            function _populatePrototype(g, f, S, v, _) {
                function _createDynamicPrototype(g, f) {
                    var dynProtoProxy = function() {
                        return (_getInstFunc(this, f, g, dynProtoProxy) || _getProtoFunc(f, g, dynProtoProxy)).apply(this, arguments);
                    };
                    return dynProtoProxy[Sc] = 1, dynProtoProxy;
                }
                if (!_isObjectOrArrayPrototype(g)) {
                    var C = S[fc] = S[fc] || Ql(null);
                    if (!_isObjectOrArrayPrototype(C)) {
                        var E = C[f] = C[f] || Ql(null);
                        !1 !== C[yc] && (C[yc] = !!_), _isObjectOrArrayPrototype(E) || _forEachProp(S, function(f) {
                            _isDynamicCandidate(S, f, !1) && S[f] !== v[f] && (E[f] = S[f], delete S[f], (!objHasOwnProperty(g, f) || g[f] && !g[f][Sc]) && (g[f] = _createDynamicPrototype(g, f)));
                        });
                    }
                }
            }
            function _checkPrototype(g, f) {
                if (Oc) {
                    for(var S = [], v = _getObjProto(f); v && !_isObjectArrayOrFunctionPrototype(v) && !_hasVisited(S, v);){
                        if (v === g) return !0;
                        S.push(v), v = _getObjProto(v);
                    }
                    return !1;
                }
                return !0;
            }
            function _getObjName(g, f) {
                return objHasOwnProperty(g, pc) ? g.name || f || Tc : ((g || {})[gc] || {}).name || f || Tc;
            }
            function dynamicProto(g, f, S, v) {
                objHasOwnProperty(g, pc) || _throwTypeError("theClass is an invalid class definition.");
                var _ = g[pc];
                _checkPrototype(_, f) || _throwTypeError("[" + _getObjName(g) + "] not in hierarchy of [" + _getObjName(f) + "]");
                var C = null;
                objHasOwnProperty(_, vc) ? C = _[vc] : (C = _c + _getObjName(g, "_") + "$" + kc.n, kc.n++, _[vc] = C);
                var E = dynamicProto[Ec], T = !!E[Pc];
                T && v && void 0 !== v[Pc] && (T = !!v[Pc]);
                var I = _getInstanceFuncs(f);
                S(f, _getBaseFuncs(_, f, I, T));
                var b = !!Oc && !!E[wc];
                b && v && (b = !!v[wc]), _populatePrototype(_, C, f, I, !1 !== b);
            }
            dynamicProto[Ec] = kc.o;
            var Lc, Fc = createEnum, xc = createTypeMap, Uc = Fc({
                Unknown: 0,
                NonRetryableStatus: 1,
                InvalidEvent: 2,
                SizeLimitExceeded: 3,
                KillSwitch: 4,
                QueueFull: 5
            }), Vc = "toLowerCase", Bc = "blkVal", Hc = "length", $c = "rdOnly", jc = "notify", Gc = "warnToConsole", qc = "throwInternal", Wc = "setDf", zc = "watch", Kc = "logger", Jc = "apply", Yc = "push", Qc = "splice", Xc = "hdlr", Zc = "cancel", ed = "initialize", td = "identifier", id = "removeNotificationListener", nd = "addNotificationListener", rd = "isInitialized", ad = "getNotifyMgr", sd = "getPlugin", od = "pollInternalLogs", ld = "name", cd = "time", dd = "processNext", ud = "getProcessTelContext", hd = "enabled", gd = "stopPollingInternalLogs", pd = "unload", md = "onComplete", fd = "version", Sd = "loggingLevelConsole", vd = "createNew", _d = "teardown", Cd = "messageId", yd = "message", Ed = "isAsync", Td = "diagLog", Id = "_doTeardown", bd = "update", Ad = "getNext", Rd = "setNextPlugin", Pd = "protocol", wd = "userAgent", Md = "split", Od = "nodeType", Dd = "replace", Nd = "logInternalMessage", kd = "type", Ld = "handler", Fd = "status", xd = "getResponseHeader", Ud = "getAllResponseHeaders", Vd = "isChildEvt", Bd = "data", Hd = "getCtx", $d = "setCtx", jd = "complete", Gd = "urlString", qd = "sendPOST", Wd = "headers", zd = "timeout", Kd = "setRequestHeader", Jd = "traceId", Yd = "spanId", Qd = "traceFlags";
            function throwAggregationError(g, f) {
                Lc || (Lc = createCustomError("AggregationError", function(g, f) {
                    f[Hc] > 1 && (g.errors = f[1]);
                }));
                var S = g || "One or more errors occurred.";
                throw arrForEach(f, function(g, f) {
                    S += "\n".concat(f, " > ").concat(dumpObj(g));
                }), new Lc(S, f || []);
            }
            var Xd = "Promise", Zd = "rejected";
            function doAwaitResponse(g, f) {
                return doAwait(g, function(g) {
                    return f ? f({
                        status: "fulfilled",
                        rejected: !1,
                        value: g
                    }) : g;
                }, function(g) {
                    return f ? f({
                        status: Zd,
                        rejected: !0,
                        reason: g
                    }) : g;
                });
            }
            function doAwait(g, f, S, v) {
                var _ = g;
                try {
                    if (isPromiseLike2(g)) (f || S) && (_ = g.then(f, S));
                    else try {
                        f && (_ = f(g));
                    } catch (g) {
                        if (!S) throw g;
                        _ = S(g);
                    }
                } finally{
                    v && doFinally(_, v);
                }
                return _;
            }
            function doFinally(g, f) {
                var S = g;
                return f && (isPromiseLike2(g) ? S = g.finally ? g.finally(f) : g.then(function(g) {
                    return f(), g;
                }, function(g) {
                    throw f(), g;
                }) : f()), S;
            }
            var eu, tu = [
                "pending",
                "resolving",
                "resolved",
                Zd
            ], iu = "dispatchEvent";
            function _hasInitEventFn(g) {
                var f;
                return g && g.createEvent && (f = g.createEvent("Event")), !!f && f.initEvent;
            }
            function emitEvent(g, f, S, v) {
                var _ = Hl();
                !eu && (eu = createCachedValue(!!safe(_hasInitEventFn, [
                    _
                ]).v));
                var C = eu.v ? _.createEvent("Event") : v ? new Event(f) : {};
                if (S && S(C), eu.v && C.initEvent(f, !1, !0), C && g[iu]) g[iu](C);
                else {
                    var E = g["on" + f];
                    if (E) E(C);
                    else {
                        var T = getInst("console");
                        T && (T.error || T.log)(f, dumpObj(C));
                    }
                }
            }
            var nu, ru = "unhandledRejection", au = ru.toLowerCase(), su = [], ou = 0, lu = 10;
            function dumpFnObj(g) {
                return cl(g) ? g.toString() : dumpObj(g);
            }
            function _createPromise(g, f, S) {
                var v, _, C = arrSlice(arguments, 3), E = 0, T = !1, I = [], b = ou++, A = !1, R = null;
                function _then(f, S) {
                    try {
                        return su.push(b), A = !0, R && R.cancel(), R = null, g(function(g, _) {
                            I.push(function() {
                                try {
                                    var C = 2 === E ? f : S, T = isUndefined4(C) ? v : cl(C) ? C(v) : C;
                                    isPromiseLike2(T) ? T.then(g, _) : C ? g(T) : 3 === E ? _(T) : g(T);
                                } catch (g) {
                                    _(g);
                                }
                            }), T && _processQueue();
                        }, C);
                    } finally{
                        su.pop();
                    }
                }
                function _catch(g) {
                    return _then(void 0, g);
                }
                function _finally(g) {
                    var f = g, S = g;
                    return cl(g) && (f = function(f) {
                        return g && g(), f;
                    }, S = function(f) {
                        throw g && g(), f;
                    }), _then(f, S);
                }
                function _strState() {
                    return tu[E];
                }
                function _processQueue() {
                    if (I.length > 0) {
                        var g = I.slice();
                        I = [], A = !0, R && R.cancel(), R = null, f(g);
                    }
                }
                function _createSettleIfFn(g, f) {
                    return function(S) {
                        if (E === f) {
                            if (2 === g && isPromiseLike2(S)) return E = 1, void S.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
                            E = g, T = !0, v = S, _processQueue(), A || 3 !== g || R || (R = scheduleTimeout(_notifyUnhandledRejection, lu));
                        }
                    };
                }
                function _notifyUnhandledRejection() {
                    if (!A) {
                        if (A = !0, zl()) $lUPho.emit(ru, v, _);
                        else {
                            var g = $l() || getGlobal();
                            !nu && (nu = createCachedValue(safe(getInst, [
                                Xd + "RejectionEvent"
                            ]).v)), emitEvent(g, au, function(g) {
                                return objDefine(g, "promise", {
                                    g: function() {
                                        return _;
                                    }
                                }), g.reason = v, g;
                            }, !!nu.v);
                        }
                    }
                }
                function _toString() {
                    return "IPromise " + _strState() + (T ? " - " + dumpFnObj(v) : "");
                }
                return vl(_ = {
                    then: _then,
                    catch: _catch,
                    finally: _finally
                }, "state", {
                    get: _strState
                }), hasSymbol() && (_[getKnownSymbol(11)] = "IPromise"), _.toString = _toString, function _initialize() {
                    cl(S) || throwTypeError(Xd + ": executor is not a function - " + dumpFnObj(S));
                    var g = _createSettleIfFn(3, 0);
                    try {
                        S.call(_, _createSettleIfFn(2, 0), g);
                    } catch (f) {
                        g(f);
                    }
                }(), _;
            }
            function _createAllPromise(g) {
                return function(f) {
                    var S = arrSlice(arguments, 1);
                    return g(function(g, S) {
                        try {
                            var v = [], _ = 1;
                            iterForOf(f, function(f, C) {
                                f && (_++, doAwait(f, function(f) {
                                    v[C] = f, 0 == --_ && g(v);
                                }, S));
                            }), 0 === --_ && g(v);
                        } catch (g) {
                            S(g);
                        }
                    }, S);
                };
            }
            function _createResolvedPromise(g) {
                return function(f) {
                    var S = arrSlice(arguments, 1);
                    return isPromiseLike2(f) ? f : g(function(g) {
                        g(f);
                    }, S);
                };
            }
            function _createRejectedPromise(g) {
                return function(f) {
                    var S = arrSlice(arguments, 1);
                    return g(function(g, S) {
                        S(f);
                    }, S);
                };
            }
            function syncItemProcessor(g) {
                arrForEach(g, function(g) {
                    try {
                        g();
                    } catch (g) {}
                });
            }
            function timeoutItemProcessor(g) {
                var f = hl(g) ? g : 0;
                return function(g) {
                    scheduleTimeout(function() {
                        syncItemProcessor(g);
                    }, f);
                };
            }
            function createAsyncPromise(g, f) {
                return _createPromise(createAsyncPromise, timeoutItemProcessor(f), g, f);
            }
            var cu, du, uu = _createAllPromise(createAsyncPromise), hu = _createResolvedPromise(createAsyncPromise), gu = _createRejectedPromise(createAsyncPromise);
            function createNativePromise(g, f) {
                !cu && (cu = createCachedValue(safe(getInst, [
                    Xd
                ]).v || null));
                var S = cu.v;
                if (!S) return createAsyncPromise(g);
                cl(g) || throwTypeError(Xd + ": executor is not a function - " + dumpObj(g));
                var v = 0;
                function _strState() {
                    return tu[v];
                }
                var _ = new S(function(f, S) {
                    function _resolve(g) {
                        v = 2, f(g);
                    }
                    function _reject(g) {
                        v = 3, S(g);
                    }
                    g(_resolve, _reject);
                });
                return vl(_, "state", {
                    get: _strState
                }), _;
            }
            function createPromise(g, f) {
                return !du && (du = createCachedValue(createNativePromise)), du.v.call(this, g, f);
            }
            var pu, mu, fu = _createAllPromise(createPromise), Su = "reject", vu = "Rejected", _u = 0, Cu = {};
            function _rejectDone() {}
            function _createError(g, f, S) {
                !Cu[g] && (Cu[g] = createCustomError(g));
                var v = utcNow();
                return new Cu[g]("Task [".concat(f.id, "] ").concat(S || "", "- ").concat(f.st ? "Running" : "Waiting", ": ").concat(_calcTime(v, f.st || f.cr)));
            }
            function _calcTime(g, f) {
                return (g - f || "0") + " ms";
            }
            function _abortStaleTasks(g, f) {
                var S = utcNow() - f;
                arrForEach(g, function(g) {
                    (g && !g.rj && g.st && g.st < S || !g.st && g.cr && g.cr < S) && g && g[Su](g.rj || _createError("Aborted", g, "Stale "));
                });
            }
            function _removeTask(g, f) {
                var S = Kl(g, f);
                -1 !== S && g.splice(S, 1);
            }
            function _addDebugState(g, f, S) {
                mu = mu || {
                    toString: function() {
                        return "[[SchedulerState]]";
                    }
                }, vl(g, pu = pu || {
                    toString: function() {
                        return "[[SchedulerName]]";
                    }
                }, {
                    get: f
                }), vl(g, mu, {
                    get: S
                });
            }
            function createTaskScheduler(g, f) {
                var S, v, _ = [], C = [], E = 6e5, T = E / 10, I = 0, b = (f ? f + "." : "") + _u++;
                g = g || createPromise;
                var _startBlockedTimer = function() {
                    var g = nc(_) + nc(C) > 0;
                    E > 0 && (v || (v = scheduleTimeout(function() {
                        _abortStaleTasks(_, E), _abortStaleTasks(C, E), v && (v.enabled = nc(_) + nc(C) > 0);
                    }, T)).unref(), v && (v.enabled = g));
                }, _queueTask = function(f, v, _) {
                    var C, E = b + "." + I++;
                    v && (E += "-(" + v + ")");
                    var T = ((C = {
                        id: E,
                        cr: utcNow(),
                        to: _
                    })[Su] = function(g) {
                        T.rj = g || _createError(vu, T), T[Su] = _rejectDone;
                    }, C);
                    return T.p = S ? _waitForPreviousTask(T, S, f) : g(_runTask(T, f)), S = T, T.p;
                }, _runTask = function(g, f) {
                    return g.st = utcNow(), _.push(g), _startBlockedTimer(), function(S, v) {
                        var _promiseReject = function(f) {
                            g.rj = g.rj || f || _createError(vu, g), g[Su] = _rejectDone, _doCleanup(g), S = null, v && v(f), v = null;
                        }, _ = g.id;
                        if (g.rj) _promiseReject(g.rj);
                        else {
                            g[Su] = _promiseReject;
                            try {
                                var C = f(_);
                                g.to && isPromiseLike2(C) && (g.t = scheduleTimeout(function() {
                                    _promiseReject(_createError("Timeout", g));
                                }, g.to)), doAwait(C, function(f) {
                                    _doCleanup(g);
                                    try {
                                        S && S(f);
                                    } catch (g) {
                                        v && v(g);
                                    }
                                    v = null, S = null;
                                }, _promiseReject);
                            } catch (g) {
                                _promiseReject(g);
                            }
                        }
                    };
                }, _waitForPreviousTask = function(f, S, v) {
                    return C.push(f), _startBlockedTimer(), g(function(g, _) {
                        doAwaitResponse(S.p, function() {
                            _removeTask(C, f), _runTask(f, v)(g, _);
                        });
                    });
                }, _doCleanup = function(g) {
                    _removeTask(_, g), g.t && g.t.cancel(), g.t = null, S && S === g && (S = null, nc(_) + nc(C) === 0 && (v && v.cancel(), v = null));
                }, A = {
                    idle: !0,
                    queue: _queueTask,
                    setStaleTimeout: function(g, f) {
                        v && v.cancel(), v = null, E = g, T = f || g / 10, _startBlockedTimer();
                    }
                };
                return objDefine(A, "idle", {
                    g: function() {
                        return nc(_) + nc(C) === 0;
                    }
                }), _addDebugState(A, function() {
                    return b;
                }, function() {
                    return {
                        l: S,
                        r: _,
                        w: C
                    };
                }), A;
            }
            getKnownSymbol(11);
            var yu = void 0, Eu = "", Tu = "channels", Iu = "core", bu = "createPerfMgr", Au = "disabled", Ru = "extensionConfig", Pu = "extensions", wu = "processTelemetry", Mu = "priority", Ou = "eventsSent", Du = "eventsDiscarded", Nu = "eventsSendRequest", ku = "perfEvent", Lu = "offlineEventsStored", Fu = "offlineBatchSent", xu = "offlineBatchDrop", Uu = "getPerfMgr", Vu = "domain", Bu = "path", Hu = "Not dynamic - ", $u = /-([a-z])/g, ju = /([^\w\d_$])/g, Gu = /^(\d+[\w\d_$])/;
            function isNotNullOrUndefined(g) {
                return !isNullOrUndefined(g);
            }
            function normalizeJsName(g) {
                var f = g;
                return f && ll(f) && (f = (f = (f = f[Dd]($u, function(g, f) {
                    return f.toUpperCase();
                }))[Dd](ju, "_"))[Dd](Gu, function(g, f) {
                    return "_" + f;
                })), f;
            }
            function strContains(g, f) {
                return !(!g || !f) && -1 !== ac(g, f);
            }
            function toISOString(g) {
                return g && g.toISOString() || "";
            }
            function getExceptionName(g) {
                return pl(g) ? g[ld] : Eu;
            }
            function setValue(g, f, S, v, _) {
                var C = S;
                return g && ((C = g[f]) === S || _ && !_(C) || v && !v(S) || (C = S, g[f] = C)), C;
            }
            function getSetValue(g, f, S) {
                var v;
                return g ? !(v = g[f]) && isNullOrUndefined(v) && (v = isUndefined4(S) ? {} : S, g[f] = v) : v = isUndefined4(S) ? {} : S, v;
            }
            function _createProxyFunction(g, f) {
                var S = null, v = null;
                return cl(g) ? S = g : v = g, function() {
                    var g = arguments;
                    if (S && (v = S()), v) return v[f][Jc](v, g);
                };
            }
            function proxyFunctionAs(g, f, S, v, _) {
                g && f && S && (!1 !== _ || isUndefined4(g[f])) && (g[f] = _createProxyFunction(S, v));
            }
            function proxyFunctions(g, f, S, v) {
                return g && f && isObject3(g) && dl(S) && arrForEach(S, function(S) {
                    ll(S) && proxyFunctionAs(g, S, f, S, v);
                }), g;
            }
            function optimizeObject(g) {
                return g && Tl && (g = Fo(Tl({}, g))), g;
            }
            function objExtend(g, f, S, v, _, C) {
                var E = arguments, T = E[0] || {}, I = E[Hc], b = !1, A = 1;
                for(I > 0 && gl(T) && (b = T, T = E[A] || {}, A++), isObject3(T) || (T = {}); A < I; A++){
                    var R = E[A], P = dl(R), w = isObject3(R);
                    for(var M in R)if (P && M in R || w && fl(R, M)) {
                        var O = R[M], D = void 0;
                        if (b && O && ((D = dl(O)) || isPlainObject(O))) {
                            var N = T[M];
                            D ? dl(N) || (N = []) : isPlainObject(N) || (N = {}), O = objExtend(b, N, O);
                        }
                        void 0 !== O && (T[M] = O);
                    }
                }
                return T;
            }
            function getResponseText(g) {
                try {
                    return g.responseText;
                } catch (g) {}
                return null;
            }
            function formatErrorMessageXdr(g, f) {
                return g ? "XDomainRequest,Response:" + getResponseText(g) : f;
            }
            function formatErrorMessageXhr(g, f) {
                return g ? "XMLHttpRequest,Status:" + g[Fd] + ",Response:" + getResponseText(g) || g.response || "" : f;
            }
            function prependTransports(g, f) {
                return f && (hl(f) ? g = [
                    f
                ].concat(g) : dl(f) && (g = f.concat(g))), g;
            }
            var qu = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", Wu = "withCredentials", zu = "timeout";
            function openXhr(g, f, S, v, _, C) {
                function _wrapSetXhrProp(g, f, S) {
                    try {
                        g[f] = S;
                    } catch (g) {}
                }
                void 0 === v && (v = !1), void 0 === _ && (_ = !1);
                var E = new XMLHttpRequest;
                return v && _wrapSetXhrProp(E, qu, v), S && _wrapSetXhrProp(E, Wu, S), E.open(g, f, !_), S && _wrapSetXhrProp(E, Wu, S), !_ && C && _wrapSetXhrProp(E, zu, C), E;
            }
            function convertAllHeadersToMap(g) {
                var f = {};
                ll(g) && arrForEach(tc(g)[Md](/[\r\n]+/), function(g) {
                    if (g) {
                        var S = g.indexOf(": ");
                        if (-1 !== S) {
                            var v = tc(g.substring(0, S))[Vc](), _ = tc(g.substring(S + 1));
                            f[v] = _;
                        } else f[tc(g)] = 1;
                    }
                });
                return f;
            }
            function _appendHeader(g, f, S) {
                if (!g[S] && f && f[xd]) {
                    var v = f[xd](S);
                    v && (g[S] = tc(v));
                }
                return g;
            }
            var Ku = "kill-duration", Ju = "kill-duration-seconds", Yu = "time-delta-millis";
            function _getAllResponseHeaders(g, f) {
                var S = {};
                return g[Ud] ? S = convertAllHeadersToMap(g[Ud]()) : f && (S = _appendHeader(S, g, Yu), S = _appendHeader(S, g, Ku), S = _appendHeader(S, g, Ju)), S;
            }
            var Qu = "location", Xu = "console", Zu = "JSON", eh = "crypto", th = "msCrypto", ih = "ReactNative", nh = "msie", rh = "trident/", ah = "XMLHttpRequest", sh = null, oh = null, lh = !1, ch = null, dh = null;
            function _hasProperty(g, f) {
                var S = !1;
                if (g) {
                    try {
                        if (!(S = f in g)) {
                            var v = g[Lo];
                            v && (S = f in v);
                        }
                    } catch (g) {}
                    if (!S) try {
                        S = !isUndefined4((new g)[f]);
                    } catch (g) {}
                }
                return S;
            }
            function getLocation(g) {
                if (g && lh) {
                    var f = getInst("__mockLocation");
                    if (f) return f;
                }
                return typeof location === No && location ? location : getInst(Qu);
            }
            function getConsole() {
                return typeof console !== ko ? console : getInst(Xu);
            }
            function hasJSON() {
                return Boolean(typeof JSON === No && JSON || null !== getInst(Zu));
            }
            function getJSON() {
                return hasJSON() ? JSON || getInst(Zu) : null;
            }
            function getCrypto() {
                return getInst(eh);
            }
            function getMsCrypto() {
                return getInst(th);
            }
            function isReactNative() {
                var g = Wl();
                return !(!g || !g.product) && g.product === ih;
            }
            function isIE() {
                var g = Wl();
                if (g && (g[wd] !== oh || null === sh)) {
                    var f = ((oh = g[wd]) || Eu)[Vc]();
                    sh = strContains(f, nh) || strContains(f, rh);
                }
                return sh;
            }
            function isBeaconsSupported(g) {
                return null !== dh && !1 !== g || (dh = hasNavigator() && Boolean(Wl().sendBeacon)), dh;
            }
            function isFetchSupported(g) {
                var f = !1;
                try {
                    f = !!getInst("fetch");
                    var S = getInst("Request");
                    f && g && S && (f = _hasProperty(S, "keepalive"));
                } catch (g) {}
                return f;
            }
            function useXDomainRequest() {
                return null === ch && (ch = typeof XDomainRequest !== ko) && isXhrSupported() && (ch = ch && !_hasProperty(getInst(ah), "withCredentials")), ch;
            }
            function isXhrSupported() {
                var g = !1;
                try {
                    g = !!getInst(ah);
                } catch (g) {}
                return g;
            }
            var uh = 4294967296, hh = 4294967295, gh = 123456789, ph = 987654321, mh = !1, fh = gh, Sh = ph;
            function _mwcSeed(g) {
                g < 0 && (g >>>= 0), fh = gh + g & hh, Sh = ph - g & hh, mh = !0;
            }
            function _autoSeedMwc() {
                try {
                    var g = 2147483647 & utcNow();
                    _mwcSeed((Math.random() * uh ^ g) + g);
                } catch (g) {}
            }
            function random32(g) {
                var f = 0, S = getCrypto() || getMsCrypto();
                return S && S.getRandomValues && (f = S.getRandomValues(new Uint32Array(1))[0] & hh), 0 === f && isIE() && (mh || _autoSeedMwc(), f = mwcRandom32() & hh), 0 === f && (f = Math.floor(uh * Math.random() | 0)), g || (f >>>= 0), f;
            }
            function mwcRandom32(g) {
                var f = ((Sh = 36969 * (65535 & Sh) + (Sh >> 16) & hh) << 16) + (65535 & (fh = 18e3 * (65535 & fh) + (fh >> 16) & hh)) >>> 0 & hh | 0;
                return g || (f >>>= 0), f;
            }
            function newId(g) {
                void 0 === g && (g = 22);
                for(var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S = random32() >>> 0, v = 0, _ = Eu; _[Hc] < g;)v++, _ += f.charAt(63 & S), S >>>= 6, 5 === v && (S = (random32() << 2 & 4294967295 | 3 & S) >>> 0, v = 0);
                return _;
            }
            var vh = "3.2.1", _h = "." + newId(6), Ch = 0;
            function _canAcceptData(g) {
                return 1 === g[Od] || 9 === g[Od] || !+g[Od];
            }
            function _getCache(g, f) {
                var S = f[g.id];
                if (!S) {
                    S = {};
                    try {
                        _canAcceptData(f) && objDefine(f, g.id, {
                            e: !1,
                            v: S
                        });
                    } catch (g) {}
                }
                return S;
            }
            function createUniqueNamespace(g, f) {
                return void 0 === f && (f = !1), normalizeJsName(g + Ch++ + (f ? "." + vh : Eu) + _h);
            }
            function createElmNodeData(g) {
                var f = {
                    id: createUniqueNamespace("_aiData-" + (g || Eu) + "." + vh),
                    accept: function(g) {
                        return _canAcceptData(g);
                    },
                    get: function(g, S, v, _) {
                        var C = g[f.id];
                        return C ? C[normalizeJsName(S)] : (_ && ((C = _getCache(f, g))[normalizeJsName(S)] = v), v);
                    },
                    kill: function(g, f) {
                        if (g && g[f]) try {
                            delete g[f];
                        } catch (g) {}
                    }
                };
                return f;
            }
            function _isConfigDefaults(g) {
                return g && isObject3(g) && (g.isVal || g.fb || fl(g, "v") || fl(g, "mrg") || fl(g, "ref") || g.set);
            }
            function _getDefault(g, f, S) {
                var v, _ = S.dfVal || isDefined2;
                if (f && S.fb) {
                    var C = S.fb;
                    dl(C) || (C = [
                        C
                    ]);
                    for(var E = 0; E < C[Hc]; E++){
                        var T = C[E], I = f[T];
                        if (_(I) ? v = I : g && (_(I = g.cfg[T]) && (v = I), g.set(g.cfg, Cl(T), I)), _(v)) break;
                    }
                }
                return !_(v) && _(S.v) && (v = S.v), v;
            }
            function _resolveDefaultValue(g, f, S) {
                var v, _ = S;
                (S && _isConfigDefaults(S) && (_ = _getDefault(g, f, S)), _) && (_isConfigDefaults(_) && (_ = _resolveDefaultValue(g, f, _)), dl(_) ? (v = [])[Hc] = _[Hc] : isPlainObject(_) && (v = {}), v && (objForEachKey(_, function(S, _) {
                    _ && _isConfigDefaults(_) && (_ = _resolveDefaultValue(g, f, _)), v[S] = _;
                }), _ = v));
                return _;
            }
            function _applyDefaultValue(g, f, S, v) {
                var _, C, E, T, I, b, A, R, P = v;
                _isConfigDefaults(P) ? (_ = P.isVal, C = P.set, b = P[$c], A = P[Bc], T = P.mrg, !(I = P.ref) && isUndefined4(I) && (I = !!T), E = _getDefault(g, f, P)) : E = v, A && g[Bc](f, S);
                var w = !0, M = f[S];
                !M && isNullOrUndefined(M) || (R = M, w = !1, _ && R !== E && !_(R) && (R = E, w = !0), C && (w = (R = C(R, E, f)) === E)), w ? R = E ? _resolveDefaultValue(g, f, E) : E : (isPlainObject(R) || dl(E)) && T && E && (isPlainObject(E) || dl(E)) && objForEachKey(E, function(f, S) {
                    _applyDefaultValue(g, R, f, S);
                }), g.set(f, S, R), I && g.ref(f, S), b && g[$c](f, S);
            }
            var yh = symbolFor("[[ai_dynCfg_1]]"), Eh = symbolFor("[[ai_blkDynCfg_1]]"), Th = symbolFor("[[ai_frcDynCfg_1]]");
            function _cfgDeepCopy(g) {
                var f;
                if (g && (dl(g) ? (f = [])[Hc] = g[Hc] : isPlainObject(g) && (f = {}), f)) return objForEachKey(g, function(g, S) {
                    f[g] = _cfgDeepCopy(S);
                }), f;
                return g;
            }
            function getDynamicConfigHandler(g) {
                if (g) {
                    var f = g[yh] || g;
                    if (f.cfg && (f.cfg === g || f.cfg[yh] === f)) return f;
                }
                return null;
            }
            function blockDynamicConversion(g) {
                if (g && (isPlainObject(g) || dl(g))) try {
                    g[Eh] = !0;
                } catch (g) {}
                return g;
            }
            function _canMakeDynamic(g, f, S) {
                var v = !1;
                return S && !g[f.blkVal] && ((v = S[Th]) || S[Eh] || (v = isPlainObject(S) || dl(S))), v;
            }
            function throwInvalidAccess(g) {
                throwTypeError("InvalidAccess:" + g);
            }
            var Ih = [
                "push",
                "pop",
                "shift",
                "unshift",
                "splice"
            ], _throwDynamicError = function(g, f, S, v) {
                g && g[qc](3, 108, "".concat(S, " [").concat(f, "] failed - ") + dumpObj(v));
            };
            function _patchArray(g, f, S) {
                dl(f) && arrForEach(Ih, function(v) {
                    var _ = f[v];
                    f[v] = function() {
                        for(var v = [], C = 0; C < arguments.length; C++)v[C] = arguments[C];
                        var E = _[Jc](this, v);
                        return _makeDynamicObject(g, f, S, "Patching"), E;
                    };
                });
            }
            function _getOwnPropGetter(g, f) {
                var S = ml(g, f);
                return S && S.get;
            }
            function _createDynamicProperty(g, f, S, v) {
                var _ = {
                    n: S,
                    h: [],
                    trk: function(f) {
                        f && f.fn && (-1 === Kl(_.h, f) && _.h[Yc](f), g.trk(f, _));
                    },
                    clr: function(g) {
                        var f = Kl(_.h, g);
                        -1 !== f && _.h[Qc](f, 1);
                    }
                }, C = !0, E = !1;
                function _getProperty() {
                    C && (E = E || _canMakeDynamic(_getProperty, g, v), v && !v[yh] && E && (v = _makeDynamicObject(g, v, S, "Converting")), C = !1);
                    var f = g.act;
                    return f && _.trk(f), v;
                }
                function _setProperty(T) {
                    if (v !== T) {
                        _getProperty[g.ro] && !g.upd && throwInvalidAccess("[" + S + "] is read-only:" + dumpObj(f)), C && (E = E || _canMakeDynamic(_getProperty, g, v), C = !1);
                        var I = E && _getProperty[g.rf];
                        if (E) {
                            if (I) {
                                objForEachKey(v, function(g) {
                                    v[g] = T ? T[g] : yu;
                                });
                                try {
                                    objForEachKey(T, function(f, S) {
                                        _setDynamicProperty(g, v, f, S);
                                    }), T = v;
                                } catch (f) {
                                    _throwDynamicError((g.hdlr || {})[Kc], S, "Assigning", f), E = !1;
                                }
                            } else v && v[yh] && objForEachKey(v, function(f) {
                                var S = _getOwnPropGetter(v, f);
                                if (S) {
                                    var _ = S[g.prop];
                                    _ && _.chng();
                                }
                            });
                        }
                        if (T !== v) {
                            var b = T && _canMakeDynamic(_getProperty, g, T);
                            !I && b && (T = _makeDynamicObject(g, T, S, "Converting")), v = T, E = b;
                        }
                        g.add(_);
                    }
                }
                _getProperty[g.prop] = {
                    chng: function() {
                        g.add(_);
                    }
                }, objDefine(f, _.n, {
                    g: _getProperty,
                    s: _setProperty
                });
            }
            function _setDynamicProperty(g, f, S, v) {
                if (f) {
                    var _ = _getOwnPropGetter(f, S);
                    _ && !!_[g.prop] ? f[S] = v : _createDynamicProperty(g, f, S, v);
                }
                return f;
            }
            function _setDynamicPropertyState(g, f, S, v) {
                if (f) {
                    var _ = _getOwnPropGetter(f, S), C = _ && !!_[g.prop], E = v && v[0], T = v && v[1], I = v && v[2];
                    if (!C) {
                        if (I) try {
                            blockDynamicConversion(f);
                        } catch (f) {
                            _throwDynamicError((g.hdlr || {})[Kc], S, "Blocking", f);
                        }
                        try {
                            _setDynamicProperty(g, f, S, f[S]), _ = _getOwnPropGetter(f, S);
                        } catch (f) {
                            _throwDynamicError((g.hdlr || {})[Kc], S, "State", f);
                        }
                    }
                    E && (_[g.rf] = E), T && (_[g.ro] = T), I && (_[g.blkVal] = !0);
                }
                return f;
            }
            function _makeDynamicObject(g, f, S, v) {
                try {
                    objForEachKey(f, function(S, v) {
                        _setDynamicProperty(g, f, S, v);
                    }), f[yh] || (vl(f, yh, {
                        get: function() {
                            return g[Xc];
                        }
                    }), _patchArray(g, f, S));
                } catch (f) {
                    _throwDynamicError((g.hdlr || {})[Kc], S, v, f);
                }
                return f;
            }
            var bh = "[[ai_", Ah = "]]";
            function _createState(g) {
                var f, S, v = newSymbol(bh + "get" + g.uid + Ah), _ = newSymbol(bh + "ro" + g.uid + Ah), C = newSymbol(bh + "rf" + g.uid + Ah), E = newSymbol(bh + "blkVal" + g.uid + Ah), T = newSymbol(bh + "dtl" + g.uid + Ah), I = null, b = null;
                function _useHandler(f, v) {
                    var _ = S.act;
                    try {
                        S.act = f, f && f[T] && (arrForEach(f[T], function(g) {
                            g.clr(f);
                        }), f[T] = []), v({
                            cfg: g.cfg,
                            set: g.set.bind(g),
                            setDf: g[Wc].bind(g),
                            ref: g.ref.bind(g),
                            rdOnly: g[$c].bind(g)
                        });
                    } catch (f) {
                        var C = g[Kc];
                        throw C && C[qc](1, 107, dumpObj(f)), f;
                    } finally{
                        S.act = _ || null;
                    }
                }
                function _notifyWatchers() {
                    if (I) {
                        var g = I;
                        I = null, b && b[Zc](), b = null;
                        var f = [];
                        if (arrForEach(g, function(g) {
                            if (g && (g[T] && (arrForEach(g[T], function(f) {
                                f.clr(g);
                            }), g[T] = null), g.fn)) try {
                                _useHandler(g, g.fn);
                            } catch (g) {
                                f[Yc](g);
                            }
                        }), I) try {
                            _notifyWatchers();
                        } catch (g) {
                            f[Yc](g);
                        }
                        f[Hc] > 0 && throwAggregationError("Watcher error(s): ", f);
                    }
                }
                function _addWatcher(g) {
                    if (g && g.h[Hc] > 0) {
                        I || (I = []), b || (b = scheduleTimeout(function() {
                            b = null, _notifyWatchers();
                        }, 0));
                        for(var f = 0; f < g.h[Hc]; f++){
                            var S = g.h[f];
                            S && -1 === Kl(I, S) && I[Yc](S);
                        }
                    }
                }
                function _trackHandler(g, f) {
                    if (g) {
                        var S = g[T] = g[T] || [];
                        -1 === Kl(S, f) && S[Yc](f);
                    }
                }
                return (f = {
                    prop: v,
                    ro: _,
                    rf: C
                })[Bc] = E, f[Xc] = g, f.add = _addWatcher, f[jc] = _notifyWatchers, f.use = _useHandler, f.trk = _trackHandler, S = f;
            }
            function _createAndUseHandler(g, f) {
                var S = {
                    fn: f,
                    rm: function() {
                        S.fn = null, g = null, f = null;
                    }
                };
                return objDefine(S, "toJSON", {
                    v: function() {
                        return "WatcherHandler" + (S.fn ? "" : "[X]");
                    }
                }), g.use(S, f), S;
            }
            function _createDynamicHandler(g, f, S) {
                var v, _ = getDynamicConfigHandler(f);
                if (_) return _;
                var C, E = createUniqueNamespace("dyncfg", !0), T = f && !1 !== S ? f : _cfgDeepCopy(f);
                function _notifyWatchers() {
                    C[jc]();
                }
                function _setValue(f, S, v) {
                    try {
                        f = _setDynamicProperty(C, f, S, v);
                    } catch (f) {
                        _throwDynamicError(g, S, "Setting value", f);
                    }
                    return f[S];
                }
                function _watch(g) {
                    return _createAndUseHandler(C, g);
                }
                function _block(g, f) {
                    C.use(null, function(S) {
                        var v = C.upd;
                        try {
                            isUndefined4(f) || (C.upd = f), g(S);
                        } finally{
                            C.upd = v;
                        }
                    });
                }
                function _ref(g, f) {
                    var S;
                    return _setDynamicPropertyState(C, g, f, (S = {}, S[0] = !0, S))[f];
                }
                function _rdOnly(g, f) {
                    var S;
                    return _setDynamicPropertyState(C, g, f, (S = {}, S[1] = !0, S))[f];
                }
                function _blkPropValue(g, f) {
                    var S;
                    return _setDynamicPropertyState(C, g, f, (S = {}, S[2] = !0, S))[f];
                }
                function _applyDefaults(g, f) {
                    return f && objForEachKey(f, function(f, S) {
                        _applyDefaultValue(I, g, f, S);
                    }), g;
                }
                var I = ((v = {
                    uid: null,
                    cfg: T
                })[Kc] = g, v[jc] = _notifyWatchers, v.set = _setValue, v[Wc] = _applyDefaults, v[zc] = _watch, v.ref = _ref, v[$c] = _rdOnly, v[Bc] = _blkPropValue, v._block = _block, v);
                return objDefine(I, "uid", {
                    c: !1,
                    e: !1,
                    w: !1,
                    v: E
                }), _makeDynamicObject(C = _createState(I), T, "config", "Creating"), I;
            }
            function _logInvalidAccess(g, f) {
                g ? (g[Gc](f), g[qc](2, 108, f)) : throwInvalidAccess(f);
            }
            function createDynamicConfig(g, f, S, v) {
                var _ = _createDynamicHandler(S, g || {}, v);
                return f && _[Wc](_.cfg, f), _;
            }
            function onConfigChange(g, f, S) {
                var v = g[yh] || g;
                return !v.cfg || v.cfg !== g && v.cfg[yh] !== v ? (_logInvalidAccess(S, Hu + dumpObj(g)), createDynamicConfig(g, null, S)[zc](f)) : v[zc](f);
            }
            function runTargetUnload(g, f) {
                if (g && g[pd]) return g[pd](f);
            }
            function doUnloadAll(g, f, S) {
                var v;
                return S || (v = createPromise(function(g) {
                    S = g;
                })), g && nc(g) > 0 ? doAwaitResponse(runTargetUnload(g[0], f), function() {
                    doUnloadAll(arrSlice(g, 1), f, S);
                }) : S(), v;
            }
            var Rh = 500, Ph = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
            function cfgDfMerge(g) {
                return {
                    mrg: !0,
                    v: g
                };
            }
            function cfgDfString(g) {
                return {
                    isVal: ll,
                    v: Cl(g || Eu)
                };
            }
            var wh, Mh, Oh = [
                Ou,
                Du,
                Nu,
                ku
            ], Dh = null;
            function _listenerProxyFunc(g, f) {
                return function() {
                    var S = arguments, v = getDebugExt(f);
                    if (v) {
                        var _ = v.listener;
                        _ && _[g] && _[g][Jc](_, S);
                    }
                };
            }
            function _getExtensionNamespace() {
                var g = getInst("Microsoft");
                return g && (Dh = g.ApplicationInsights), Dh;
            }
            function getDebugExt(g) {
                var f = Dh;
                return f || !0 === g.disableDbgExt || (f = Dh || _getExtensionNamespace()), f ? f.ChromeDbgExt : null;
            }
            function getDebugListener(g) {
                if (!wh) {
                    wh = {};
                    for(var f = 0; f < Oh[Hc]; f++)wh[Oh[f]] = _listenerProxyFunc(Oh[f], g);
                }
                return wh;
            }
            var Nh = "warnToConsole", kh = "AI (Internal): ", Lh = "AI: ", Fh = "AITR_", xh = {
                loggingLevelConsole: 0,
                loggingLevelTelemetry: 1,
                maxMessageLimit: 25,
                enableDebug: !1
            }, Uh = ((Mh = {})[0] = null, Mh[1] = "errorToConsole", Mh[2] = Nh, Mh[3] = "debugToConsole", Mh);
            function _sanitizeDiagnosticText(g) {
                return g ? '"' + g[Dd](/\"/g, Eu) + '"' : Eu;
            }
            function _logToConsole(g, f) {
                var S = getConsole();
                if (S) {
                    var v = "log";
                    S[g] && (v = g), cl(S[v]) && S[v](f);
                }
            }
            var Vh = function() {
                function _InternalLogMessage3(g, f, S, v) {
                    void 0 === S && (S = !1);
                    var _ = this;
                    _[Cd] = g, _[yd] = (S ? Lh : kh) + g;
                    var C = Eu;
                    hasJSON() && (C = getJSON().stringify(v));
                    var E = (f ? " message:" + _sanitizeDiagnosticText(f) : Eu) + (v ? " props:" + _sanitizeDiagnosticText(C) : Eu);
                    _[yd] += E;
                }
                return _InternalLogMessage3.dataType = "MessageData", _InternalLogMessage3;
            }();
            function safeGetLogger(g, f) {
                return (g || {})[Kc] || new $h(f);
            }
            var Bh, Hh, $h = function() {
                function DiagnosticLogger3(g) {
                    this.identifier = "DiagnosticLogger", this.queue = [];
                    var f, S, v, _, C, E = 0, T = {};
                    dynamicProto(DiagnosticLogger3, this, function(I) {
                        function _logInternalMessage3(g, f) {
                            if (!_areInternalMessagesThrottled()) {
                                var _ = !0, C = Fh + f[Cd];
                                if (T[C] ? _ = !1 : T[C] = !0, _ && (g <= S && (I.queue[Yc](f), E++, _debugExtMsg(1 === g ? "error" : "warn", f)), E === v)) {
                                    var b = "Internal events throttle limit per PageView reached for this app.", A = new Vh(23, b, !1);
                                    I.queue[Yc](A), 1 === g ? I.errorToConsole(b) : I[Gc](b);
                                }
                            }
                        }
                        function _setDefaultsFromConfig(g) {
                            return onConfigChange(createDynamicConfig(g, xh, I).cfg, function(g) {
                                var C = g.cfg;
                                f = C[Sd], S = C.loggingLevelTelemetry, v = C.maxMessageLimit, _ = C.enableDebug;
                            });
                        }
                        function _areInternalMessagesThrottled() {
                            return E >= v;
                        }
                        function _debugExtMsg(f, S) {
                            var v = getDebugExt(g || {});
                            v && v[Td] && v[Td](f, S);
                        }
                        C = _setDefaultsFromConfig(g || {}), I.consoleLoggingLevel = function() {
                            return f;
                        }, I[qc] = function(g, S, v, C, E) {
                            void 0 === E && (E = !1);
                            var b = new Vh(S, v, E, C);
                            if (_) throw dumpObj(b);
                            var A = Uh[g] || Nh;
                            if (isUndefined4(b[yd])) _debugExtMsg("throw" + (1 === g ? "Critical" : "Warning"), b);
                            else {
                                if (E) {
                                    var R = +b[Cd];
                                    !T[R] && f >= g && (I[A](b[yd]), T[R] = !0);
                                } else f >= g && I[A](b[yd]);
                                _logInternalMessage3(g, b);
                            }
                        }, I.debugToConsole = function(g) {
                            _logToConsole("debug", g), _debugExtMsg("warning", g);
                        }, I[Gc] = function(g) {
                            _logToConsole("warn", g), _debugExtMsg("warning", g);
                        }, I.errorToConsole = function(g) {
                            _logToConsole("error", g), _debugExtMsg("error", g);
                        }, I.resetInternalMessageCount = function() {
                            E = 0, T = {};
                        }, I[Nd] = _logInternalMessage3, I[pd] = function(g) {
                            C && C.rm(), C = null;
                        };
                    });
                }
                return DiagnosticLogger3.__ieDyn = 1, DiagnosticLogger3;
            }();
            function _getLogger(g) {
                return g || new $h;
            }
            function _throwInternal(g, f, S, v, _, C) {
                void 0 === C && (C = !1), _getLogger(g)[qc](f, S, v, _, C);
            }
            function _warnToConsole(g, f) {
                _getLogger(g)[Gc](f);
            }
            var jh, Gh = "toGMTString", qh = "toUTCString", Wh = "cookie", zh = "expires", Kh = "isCookieUseDisabled", Jh = "disableCookiesUsage", Yh = "_ckMgr", Qh = null, Xh = null, Zh = null, eg = {}, tg = {}, ig = ((Bh = {
                cookieCfg: cfgDfMerge((Hh = {}, Hh[Vu] = {
                    fb: "cookieDomain",
                    dfVal: isNotNullOrUndefined
                }, Hh.path = {
                    fb: "cookiePath",
                    dfVal: isNotNullOrUndefined
                }, Hh.enabled = yu, Hh.ignoreCookies = yu, Hh.blockedCookies = yu, Hh)),
                cookieDomain: yu,
                cookiePath: yu
            })[Jh] = yu, Bh);
            function _getDoc() {
                !jh && (jh = getLazy(function() {
                    return Hl();
                }));
            }
            function _gblCookieMgr(g, f) {
                var S = createCookieMgr[Yh] || tg[Yh];
                return S || (S = createCookieMgr[Yh] = createCookieMgr(g, f), tg[Yh] = S), S;
            }
            function _isMgrEnabled(g) {
                return !g || g.isEnabled();
            }
            function _isIgnoredCookie(g, f) {
                return !!(f && g && dl(g.ignoreCookies)) && -1 !== Kl(g.ignoreCookies, f);
            }
            function _isBlockedCookie(g, f) {
                return !!(f && g && dl(g.blockedCookies) && -1 !== Kl(g.blockedCookies, f)) || _isIgnoredCookie(g, f);
            }
            function _isCfgEnabled(g, f) {
                var S = f[hd];
                if (isNullOrUndefined(S)) {
                    var v = void 0;
                    isUndefined4(g[Kh]) || (v = !g[Kh]), isUndefined4(g[Jh]) || (v = !g[Jh]), S = v;
                }
                return S;
            }
            function safeGetCookieMgr(g, f) {
                var S;
                if (g) S = g.getCookieMgr();
                else if (f) {
                    var v = f.cookieCfg;
                    S = v && v[Yh] ? v[Yh] : createCookieMgr(f);
                }
                return S || (S = _gblCookieMgr(f, (g || {})[Kc])), S;
            }
            function createCookieMgr(g, f) {
                var S, v, _, C, E, T, I, b, A;
                g = createDynamicConfig(g || tg, null, f).cfg, E = onConfigChange(g, function(f) {
                    f[Wc](f.cfg, ig), v = f.ref(f.cfg, "cookieCfg"), _ = v[Bu] || "/", C = v[Vu], T = !1 !== _isCfgEnabled(g, v), I = v.getCookie || _getCookieValue, b = v.setCookie || _setCookieValue, A = v.delCookie || _setCookieValue;
                }, f);
                var R = ((S = {
                    isEnabled: function() {
                        var S = !1 !== _isCfgEnabled(g, v) && T && areCookiesSupported(f), _ = tg[Yh];
                        return S && _ && R !== _ && (S = _isMgrEnabled(_)), S;
                    },
                    setEnabled: function(g) {
                        T = !1 !== g, v[hd] = g;
                    },
                    set: function(g, f, S, E, T) {
                        var I = !1;
                        if (_isMgrEnabled(R) && !_isBlockedCookie(v, g)) {
                            var A = {}, P = tc(f || Eu), w = ac(P, ";");
                            if (-1 !== w && (P = tc(strLeft(f, w)), A = _extractParts(Nl(f, w + 1))), setValue(A, Vu, E || C, isTruthy, isUndefined4), !isNullOrUndefined(S)) {
                                var M = isIE();
                                if (isUndefined4(A[zh])) {
                                    var O = utcNow() + 1e3 * S;
                                    if (O > 0) {
                                        var D = new Date;
                                        D.setTime(O), setValue(A, zh, _formatDate(D, M ? Gh : qh) || _formatDate(D, M ? Gh : qh) || Eu, isTruthy);
                                    }
                                }
                                M || setValue(A, "max-age", Eu + S, null, isUndefined4);
                            }
                            var N = getLocation();
                            N && "https:" === N[Pd] && (setValue(A, "secure", null, null, isUndefined4), null === Xh && (Xh = !uaDisallowsSameSiteNone((Wl() || {})[wd])), Xh && setValue(A, "SameSite", "None", null, isUndefined4)), setValue(A, Bu, T || _, null, isUndefined4), b(g, _formatCookieValue(P, A)), I = !0;
                        }
                        return I;
                    },
                    get: function(g) {
                        var f = Eu;
                        return _isMgrEnabled(R) && !_isIgnoredCookie(v, g) && (f = I(g)), f;
                    },
                    del: function(g, f) {
                        var S = !1;
                        return _isMgrEnabled(R) && (S = R.purge(g, f)), S;
                    },
                    purge: function(g, S) {
                        var v, _ = !1;
                        if (areCookiesSupported(f)) {
                            var C = ((v = {})[Bu] = S || "/", v[zh] = "Thu, 01 Jan 1970 00:00:01 GMT", v);
                            isIE() || (C["max-age"] = "0"), A(g, _formatCookieValue(Eu, C)), _ = !0;
                        }
                        return _;
                    }
                })[pd] = function(g) {
                    E && E.rm(), E = null;
                }, S);
                return R[Yh] = R, R;
            }
            function areCookiesSupported(g) {
                if (null === Qh) {
                    Qh = !1, !jh && _getDoc();
                    try {
                        var f = jh.v || {};
                        Qh = void 0 !== f[Wh];
                    } catch (f) {
                        _throwInternal(g, 2, 68, "Cannot access document.cookie - " + getExceptionName(f), {
                            exception: dumpObj(f)
                        });
                    }
                }
                return Qh;
            }
            function _extractParts(g) {
                var f = {};
                g && g[Hc] && arrForEach(tc(g)[Md](";"), function(g) {
                    if (g = tc(g || Eu)) {
                        var S = ac(g, "=");
                        -1 === S ? f[g] = null : f[tc(strLeft(g, S))] = tc(Nl(g, S + 1));
                    }
                });
                return f;
            }
            function _formatDate(g, f) {
                return cl(g[f]) ? g[f]() : null;
            }
            function _formatCookieValue(g, f) {
                var S = g || Eu;
                return objForEachKey(f, function(g, f) {
                    S += "; " + g + (isNullOrUndefined(f) ? Eu : "=" + f);
                }), S;
            }
            function _getCookieValue(g) {
                var f = Eu;
                if (!jh && _getDoc(), jh.v) {
                    var S = jh.v[Wh] || Eu;
                    Zh !== S && (eg = _extractParts(S), Zh = S), f = tc(eg[g] || Eu);
                }
                return f;
            }
            function _setCookieValue(g, f) {
                !jh && _getDoc(), jh.v && (jh.v[Wh] = g + "=" + f);
            }
            function uaDisallowsSameSiteNone(g) {
                return !!ll(g) && (!(!strContains(g, "CPU iPhone OS 12") && !strContains(g, "iPad; CPU OS 12")) || !!(strContains(g, "Macintosh; Intel Mac OS X 10_14") && strContains(g, "Version/") && strContains(g, "Safari")) || !(!strContains(g, "Macintosh; Intel Mac OS X 10_14") || !rc(g, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) || !(!strContains(g, "Chrome/5") && !strContains(g, "Chrome/6")) || !(!strContains(g, "UnrealEngine") || strContains(g, "Chrome")) || !(!strContains(g, "UCBrowser/12") && !strContains(g, "UCBrowser/11")));
            }
            var ng = {
                perfEvtsSendAll: !1
            };
            function _runScheduledListeners(g) {
                g.h = null;
                var f = g.cb;
                g.cb = [], arrForEach(f, function(g) {
                    safe(g.fn, [
                        g.arg
                    ]);
                });
            }
            function _runListeners(g, f, S, v) {
                arrForEach(g, function(g) {
                    g && g[f] && (S ? (S.cb[Yc]({
                        fn: v,
                        arg: g
                    }), S.h = S.h || scheduleTimeout(_runScheduledListeners, 0, S)) : safe(v, [
                        g
                    ]));
                });
            }
            var rg = function() {
                function NotificationManager3(g) {
                    var f, S;
                    this.listeners = [];
                    var v = [], _ = {
                        h: null,
                        cb: []
                    }, C = createDynamicConfig(g, ng);
                    S = C[zc](function(g) {
                        f = !!g.cfg.perfEvtsSendAll;
                    }), dynamicProto(NotificationManager3, this, function(g) {
                        objDefine(g, "listeners", {
                            g: function() {
                                return v;
                            }
                        }), g[nd] = function(g) {
                            v[Yc](g);
                        }, g[id] = function(g) {
                            for(var f = Kl(v, g); f > -1;)v[Qc](f, 1), f = Kl(v, g);
                        }, g[Ou] = function(g) {
                            _runListeners(v, Ou, _, function(f) {
                                f[Ou](g);
                            });
                        }, g[Du] = function(g, f) {
                            _runListeners(v, Du, _, function(S) {
                                S[Du](g, f);
                            });
                        }, g[Nu] = function(g, f) {
                            _runListeners(v, Nu, f ? _ : null, function(S) {
                                S[Nu](g, f);
                            });
                        }, g[ku] = function(g) {
                            g && (!f && g[Vd]() || _runListeners(v, ku, null, function(f) {
                                g[Ed] ? scheduleTimeout(function() {
                                    return f[ku](g);
                                }, 0) : f[ku](g);
                            }));
                        }, g[Lu] = function(g) {
                            g && g[Hc] && _runListeners(v, Lu, _, function(f) {
                                f[Lu](g);
                            });
                        }, g[Fu] = function(g) {
                            g && g[Bd] && _runListeners(v, Fu, _, function(f) {
                                f[Fu](g);
                            });
                        }, g[xu] = function(g, f) {
                            if (g > 0) {
                                var S = f || 0;
                                _runListeners(v, xu, _, function(f) {
                                    f[xu](g, S);
                                });
                            }
                        }, g[pd] = function(g) {
                            var f, _finishUnload = function() {
                                S && S.rm(), S = null, v = [], _.h && _.h[Zc](), _.h = null, _.cb = [];
                            };
                            if (_runListeners(v, "unload", null, function(S) {
                                var v = S[pd](g);
                                v && (f || (f = []), f[Yc](v));
                            }), f) return createPromise(function(g) {
                                return doAwaitResponse(fu(f), function() {
                                    _finishUnload(), g();
                                });
                            });
                            _finishUnload();
                        };
                    });
                }
                return NotificationManager3.__ieDyn = 1, NotificationManager3;
            }(), ag = "ctx", sg = "ParentContextKey", og = "ChildrenContextKey", lg = null, cg = function() {
                function PerfEvent3(g, f, S) {
                    var v, _ = this;
                    (_.start = utcNow(), _[ld] = g, _[Ed] = S, _[Vd] = function() {
                        return !1;
                    }, cl(f)) && objDefine(_, "payload", {
                        g: function() {
                            return !v && cl(f) && (v = f(), f = null), v;
                        }
                    });
                    _[Hd] = function(g) {
                        return g ? g === PerfEvent3[sg] || g === PerfEvent3[og] ? _[g] : (_[ag] || {})[g] : null;
                    }, _[$d] = function(g, f) {
                        if (g) {
                            if (g === PerfEvent3[sg]) _[g] || (_[Vd] = function() {
                                return !0;
                            }), _[g] = f;
                            else if (g === PerfEvent3[og]) _[g] = f;
                            else (_[ag] = _[ag] || {})[g] = f;
                        }
                    }, _[jd] = function() {
                        var g = 0, f = _[Hd](PerfEvent3[og]);
                        if (dl(f)) for(var S = 0; S < f[Hc]; S++){
                            var v = f[S];
                            v && (g += v[cd]);
                        }
                        _[cd] = utcNow() - _.start, _.exTime = _[cd] - g, _[jd] = function() {};
                    };
                }
                return PerfEvent3.ParentContextKey = "parent", PerfEvent3.ChildrenContextKey = "childEvts", PerfEvent3;
            }(), dg = function() {
                function PerfManager3(g) {
                    this.ctx = {}, dynamicProto(PerfManager3, this, function(f) {
                        f.create = function(g, f, S) {
                            return new cg(g, f, S);
                        }, f.fire = function(f) {
                            f && (f[jd](), g && cl(g[ku]) && g[ku](f));
                        }, f[$d] = function(g, S) {
                            g && ((f[ag] = f[ag] || {})[g] = S);
                        }, f[Hd] = function(g) {
                            return (f[ag] || {})[g];
                        };
                    });
                }
                return PerfManager3.__ieDyn = 1, PerfManager3;
            }(), ug = "CoreUtils.doPerf";
            function doPerf(g, f, S, v, _) {
                if (g) {
                    var C = g;
                    if (C[Uu] && (C = C[Uu]()), C) {
                        var E = void 0, T = C[Hd](ug);
                        try {
                            if (E = C.create(f(), v, _)) {
                                if (T && E[$d] && (E[$d](cg[sg], T), T[Hd] && T[$d])) {
                                    var I = T[Hd](cg[og]);
                                    I || (I = [], T[$d](cg[og], I)), I[Yc](E);
                                }
                                return C[$d](ug, E), S(E);
                            }
                        } catch (g) {
                            E && E[$d] && E[$d]("exception", g);
                        } finally{
                            E && C.fire(E), C[$d](ug, T);
                        }
                    }
                }
                return S();
            }
            function getGblPerfMgr() {
                return lg;
            }
            function newGuid2() {
                var g = generateW3CId();
                return Nl(g, 0, 8) + "-" + Nl(g, 8, 12) + "-" + Nl(g, 12, 16) + "-" + Nl(g, 16, 20) + "-" + Nl(g, 20);
            }
            function generateW3CId() {
                for(var g, f = [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f"
                ], S = Eu, v = 0; v < 4; v++)S += f[15 & (g = random32())] + f[g >> 4 & 15] + f[g >> 8 & 15] + f[g >> 12 & 15] + f[g >> 16 & 15] + f[g >> 20 & 15] + f[g >> 24 & 15] + f[g >> 28 & 15];
                var _ = f[8 + (3 & random32()) | 0];
                return kl(S, 0, 8) + kl(S, 9, 4) + "4" + kl(S, 13, 3) + _ + kl(S, 16, 3) + kl(S, 19, 12);
            }
            var hg = "00000000000000000000000000000000", gg = "0000000000000000";
            function _isValid(g, f, S) {
                return !(!g || g[Hc] !== f || g === S) && !!g.match(/^[\da-f]*$/i);
            }
            function isValidTraceId(g) {
                return _isValid(g, 32, hg);
            }
            function isValidSpanId(g) {
                return _isValid(g, 16, gg);
            }
            var pg = createElmNodeData("plugin");
            function _getPluginState(g) {
                return pg.get(g, "state", {}, !0);
            }
            function initializePlugins(g, f) {
                for(var S, v = [], _ = null, C = g[Ad](); C;){
                    var E = C[sd]();
                    if (E) {
                        _ && _[Rd] && E[wu] && _[Rd](E);
                        var T = !!(S = _getPluginState(E))[rd];
                        E[rd] && (T = E[rd]()), T || v[Yc](E), _ = E, C = C[Ad]();
                    }
                }
                arrForEach(v, function(v) {
                    var _ = g[Iu]();
                    v[ed](g.getCfg(), _, f, g[Ad]()), S = _getPluginState(v), v[Iu] || S[Iu] || (S[Iu] = _), S[rd] = !0, delete S[_d];
                });
            }
            function sortPlugins(g) {
                return g.sort(function(g, f) {
                    var S = 0;
                    if (f) {
                        var v = f[wu];
                        g[wu] ? S = v ? g[Mu] - f[Mu] : 1 : v && (S = -1);
                    } else S = g ? 1 : -1;
                    return S;
                });
            }
            function createDistributedTraceContext(g) {
                var f = {};
                return {
                    getName: function() {
                        return f[ld];
                    },
                    setName: function(S) {
                        g && g.setName(S), f[ld] = S;
                    },
                    getTraceId: function() {
                        return f[Jd];
                    },
                    setTraceId: function(S) {
                        g && g.setTraceId(S), isValidTraceId(S) && (f[Jd] = S);
                    },
                    getSpanId: function() {
                        return f[Yd];
                    },
                    setSpanId: function(S) {
                        g && g.setSpanId(S), isValidSpanId(S) && (f[Yd] = S);
                    },
                    getTraceFlags: function() {
                        return f[Qd];
                    },
                    setTraceFlags: function(S) {
                        g && g.setTraceFlags(S), f[Qd] = S;
                    }
                };
            }
            var mg, fg = "TelemetryPluginChain", Sg = "_hasRun", vg = "_getTelCtx", _g = 0;
            function _getNextProxyStart(g, f, S) {
                for(; g;){
                    if (g[sd]() === S) return g;
                    g = g[Ad]();
                }
                return createTelemetryProxyChain([
                    S
                ], f.config || {}, f);
            }
            function _createInternalContext(g, f, S, v) {
                var _ = null, C = [];
                f || (f = createDynamicConfig({}, null, S[Kc])), null !== v && (_ = v ? _getNextProxyStart(g, S, v) : g);
                var E = {
                    _next: _moveNext,
                    ctx: {
                        core: function() {
                            return S;
                        },
                        diagLog: function() {
                            return safeGetLogger(S, f.cfg);
                        },
                        getCfg: function() {
                            return f.cfg;
                        },
                        getExtCfg: _resolveExtCfg,
                        getConfig: _getConfig,
                        hasNext: function() {
                            return !!_;
                        },
                        getNext: function() {
                            return _;
                        },
                        setNext: function(g) {
                            _ = g;
                        },
                        iterate: _iterateChain,
                        onComplete: _addOnComplete
                    }
                };
                function _addOnComplete(g, f) {
                    for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                    g && C[Yc]({
                        func: g,
                        self: isUndefined4(f) ? E.ctx : f,
                        args: S
                    });
                }
                function _moveNext() {
                    var g = _;
                    if (_ = g ? g[Ad]() : null, !g) {
                        var f = C;
                        f && f[Hc] > 0 && (arrForEach(f, function(g) {
                            try {
                                g.func.call(g.self, g.args);
                            } catch (g) {
                                _throwInternal(S[Kc], 2, 73, "Unexpected Exception during onComplete - " + dumpObj(g));
                            }
                        }), C = []);
                    }
                    return g;
                }
                function _getExtCfg(g, S) {
                    var v = null, _ = f.cfg;
                    if (_ && g) {
                        var C = _[Ru];
                        !C && S && (C = {}), _[Ru] = C, (C = f.ref(_, Ru)) && (!(v = C[g]) && S && (v = {}), C[g] = v, v = f.ref(C, g));
                    }
                    return v;
                }
                function _resolveExtCfg(g, S) {
                    var v = _getExtCfg(g, !0);
                    return S && objForEachKey(S, function(g, S) {
                        if (isNullOrUndefined(v[g])) {
                            var _ = f.cfg[g];
                            !_ && isNullOrUndefined(_) || (v[g] = _);
                        }
                        _applyDefaultValue(f, v, g, S);
                    }), f[Wc](v, S);
                }
                function _getConfig(g, S, v) {
                    var _;
                    void 0 === v && (v = !1);
                    var C = _getExtCfg(g, !1), E = f.cfg;
                    return !C || !C[S] && isNullOrUndefined(C[S]) ? !E[S] && isNullOrUndefined(E[S]) || (_ = E[S]) : _ = C[S], _ || !isNullOrUndefined(_) ? _ : v;
                }
                function _iterateChain(g) {
                    for(var f; f = E._next();){
                        var S = f[sd]();
                        S && g(S);
                    }
                }
                return E;
            }
            function createProcessTelemetryContext(g, f, S, v) {
                var _ = createDynamicConfig(f), C = _createInternalContext(g, _, S, v), E = C.ctx;
                function _processNext(g) {
                    var f = C._next();
                    return f && f[wu](g, E), !f;
                }
                function _createNew(g, f) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain(g, _.cfg, S, f)), createProcessTelemetryContext(g || E[Ad](), _.cfg, S, f);
                }
                return E[dd] = _processNext, E[vd] = _createNew, E;
            }
            function createProcessTelemetryUnloadContext(g, f, S) {
                var v = createDynamicConfig(f.config), _ = _createInternalContext(g, v, f, S), C = _.ctx;
                function _processNext(g) {
                    var f = _._next();
                    return f && f[pd](C, g), !f;
                }
                function _createNew(g, S) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain(g, v.cfg, f, S)), createProcessTelemetryUnloadContext(g || C[Ad](), f, S);
                }
                return C[dd] = _processNext, C[vd] = _createNew, C;
            }
            function createProcessTelemetryUpdateContext(g, f, S) {
                var v = createDynamicConfig(f.config), _ = _createInternalContext(g, v, f, S).ctx;
                function _processNext(g) {
                    return _.iterate(function(f) {
                        cl(f[bd]) && f[bd](_, g);
                    });
                }
                function _createNew(g, S) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain(g, v.cfg, f, S)), createProcessTelemetryUpdateContext(g || _[Ad](), f, S);
                }
                return _[dd] = _processNext, _[vd] = _createNew, _;
            }
            function createTelemetryProxyChain(g, f, S, v) {
                var _ = null, C = !v;
                if (dl(g) && g[Hc] > 0) {
                    var E = null;
                    arrForEach(g, function(g) {
                        if (C || v !== g || (C = !0), C && g && cl(g[wu])) {
                            var T = createTelemetryPluginProxy(g, f, S);
                            _ || (_ = T), E && E._setNext(T), E = T;
                        }
                    });
                }
                return v && !_ ? createTelemetryProxyChain([
                    v
                ], f, S) : _;
            }
            function createTelemetryPluginProxy(g, f, S) {
                var v, _ = null, C = cl(g[wu]), E = cl(g[Rd]), T = {
                    getPlugin: function() {
                        return g;
                    },
                    getNext: function() {
                        return _;
                    },
                    processTelemetry: _processTelemetry,
                    unload: _unloadPlugin,
                    update: _updatePlugin,
                    _id: v = g ? g[td] + "-" + g[Mu] + "-" + _g++ : "Unknown-0-" + _g++,
                    _setNext: function(g) {
                        _ = g;
                    }
                };
                function _getTelCtx() {
                    var v;
                    return g && cl(g[vg]) && (v = g[vg]()), v || (v = createProcessTelemetryContext(T, f, S)), v;
                }
                function _processChain(f, S, C, E, T) {
                    var I = !1, b = g ? g[td] : fg, A = f[Sg];
                    return A || (A = f[Sg] = {}), f.setNext(_), g && doPerf(f[Iu](), function() {
                        return b + ":" + C;
                    }, function() {
                        A[v] = !0;
                        try {
                            var g = _ ? _._id : Eu;
                            g && (A[g] = !1), I = S(f);
                        } catch (g) {
                            var E = !_ || A[_._id];
                            E && (I = !0), _ && E || _throwInternal(f[Td](), 1, 73, "Plugin [" + b + "] failed during " + C + " - " + dumpObj(g) + ", run flags: " + dumpObj(A));
                        }
                    }, E, T), I;
                }
                function _processTelemetry(f, S) {
                    function _callProcessTelemetry(S) {
                        if (!g || !C) return !1;
                        var v = _getPluginState(g);
                        return !v[_d] && !v[Au] && (E && g[Rd](_), g[wu](f, S), !0);
                    }
                    _processChain(S = S || _getTelCtx(), _callProcessTelemetry, "processTelemetry", function() {
                        return {
                            item: f
                        };
                    }, !f.sync) || S[dd](f);
                }
                function _unloadPlugin(f, S) {
                    function _callTeardown() {
                        var v = !1;
                        if (g) {
                            var _ = _getPluginState(g), C = g[Iu] || _[Iu];
                            !g || C && C !== f.core() || _[_d] || (_[Iu] = null, _[_d] = !0, _[rd] = !1, g[_d] && !0 === g[_d](f, S) && (v = !0));
                        }
                        return v;
                    }
                    _processChain(f, _callTeardown, "unload", function() {}, S[Ed]) || f[dd](S);
                }
                function _updatePlugin(f, S) {
                    function _callUpdate() {
                        var v = !1;
                        if (g) {
                            var _ = _getPluginState(g), C = g[Iu] || _[Iu];
                            !g || C && C !== f.core() || _[_d] || g[bd] && !0 === g[bd](f, S) && (v = !0);
                        }
                        return v;
                    }
                    _processChain(f, _callUpdate, "update", function() {}, !1) || f[dd](S);
                }
                return bl(T);
            }
            function createUnloadHandlerContainer() {
                var g = [];
                function _addHandler(f) {
                    f && g[Yc](f);
                }
                function _runHandlers(f, S) {
                    arrForEach(g, function(g) {
                        try {
                            g(f, S);
                        } catch (g) {
                            _throwInternal(f[Td](), 2, 73, "Unexpected error calling unload handler - " + dumpObj(g));
                        }
                    }), g = [];
                }
                return {
                    add: _addHandler,
                    run: _runHandlers
                };
            }
            function createUnloadHookContainer() {
                var g = [];
                function _doUnload(f) {
                    var S = g;
                    g = [], arrForEach(S, function(g) {
                        try {
                            (g.rm || g.remove).call(g);
                        } catch (g) {
                            _throwInternal(f, 2, 73, "Unloading:" + dumpObj(g));
                        }
                    });
                }
                function _addHook(f) {
                    f && arrAppend(g, f);
                }
                return {
                    run: _doUnload,
                    add: _addHook
                };
            }
            var Cg = "getPlugin", yg = ((mg = {})[Ru] = {
                isVal: isNotNullOrUndefined,
                v: {}
            }, mg), Eg = function() {
                function BaseTelemetryPlugin3() {
                    var g, f, S, v, _, C = this;
                    function _getTelCtx(g) {
                        void 0 === g && (g = null);
                        var v = g;
                        if (!v) {
                            var _ = f || createProcessTelemetryContext(null, {}, C[Iu]);
                            v = S && S[Cg] ? _[vd](null, S[Cg]) : _[vd](null, S);
                        }
                        return v;
                    }
                    function _setDefaults(g, v, _) {
                        createDynamicConfig(g, yg, safeGetLogger(v)), !_ && v && (_ = v[ud]()[Ad]());
                        var E = S;
                        S && S[Cg] && (E = S[Cg]()), C[Iu] = v, f = createProcessTelemetryContext(_, g, v, E);
                    }
                    function _initDefaults() {
                        g = !1, C[Iu] = null, f = null, S = null, _ = createUnloadHookContainer(), v = createUnloadHandlerContainer();
                    }
                    _initDefaults(), dynamicProto(BaseTelemetryPlugin3, C, function(f) {
                        f[ed] = function(f, S, v, _) {
                            _setDefaults(f, S, _), g = !0;
                        }, f[_d] = function(g, C) {
                            var E, T = f[Iu];
                            if (T && (!g || T === g[Iu]())) {
                                var I, b = !1, A = g || createProcessTelemetryUnloadContext(null, T, S && S[Cg] ? S[Cg]() : S), R = C || ((E = {
                                    reason: 0
                                })[Ed] = !1, E);
                                return f[Id] && !0 === f[Id](A, R, _unloadCallback) ? I = !0 : _unloadCallback(), I;
                            }
                            function _unloadCallback() {
                                b || (b = !0, v.run(A, C), _.run(A[Td]()), !0 === I && A[dd](R), _initDefaults());
                            }
                        }, f[bd] = function(g, v) {
                            var _ = f[Iu];
                            if (_ && (!g || _ === g[Iu]())) {
                                var C, E = !1, T = g || createProcessTelemetryUpdateContext(null, _, S && S[Cg] ? S[Cg]() : S), I = v || {
                                    reason: 0
                                };
                                return f._doUpdate && !0 === f._doUpdate(T, I, _updateCallback) ? C = !0 : _updateCallback(), C;
                            }
                            function _updateCallback() {
                                E || (E = !0, _setDefaults(T.getCfg(), T.core(), T[Ad]()));
                            }
                        }, proxyFunctionAs(f, "_addUnloadCb", function() {
                            return v;
                        }, "add"), proxyFunctionAs(f, "_addHook", function() {
                            return _;
                        }, "add"), objDefine(f, "_unloadHooks", {
                            g: function() {
                                return _;
                            }
                        });
                    }), C[Td] = function(g) {
                        return _getTelCtx(g)[Td]();
                    }, C[rd] = function() {
                        return g;
                    }, C.setInitialized = function(f) {
                        g = f;
                    }, C[Rd] = function(g) {
                        S = g;
                    }, C[dd] = function(g, f) {
                        f ? f[dd](g) : S && cl(S[wu]) && S[wu](g, null);
                    }, C._getTelCtx = _getTelCtx;
                }
                return BaseTelemetryPlugin3.__ieDyn = 1, BaseTelemetryPlugin3;
            }();
            function _addInitializer(g, f, S) {
                var v = {
                    id: f,
                    fn: S
                };
                return arrAppend(g, v), {
                    remove: function() {
                        arrForEach(g, function(f, S) {
                            if (f.id === v.id) return g[Qc](S, 1), -1;
                        });
                    }
                };
            }
            function _runInitializers(g, f, S) {
                for(var v = !1, _ = g[Hc], C = 0; C < _; ++C){
                    var E = g[C];
                    if (E) try {
                        if (!1 === E.fn[Jc](null, [
                            f
                        ])) {
                            v = !0;
                            break;
                        }
                    } catch (g) {
                        _throwInternal(S, 2, 64, "Telemetry initializer failed: " + getExceptionName(g), {
                            exception: dumpObj(g)
                        }, !0);
                    }
                }
                return !v;
            }
            var Tg, Ig = function(g) {
                function TelemetryInitializerPlugin2() {
                    var f, S, v = g.call(this) || this;
                    function _initDefaults() {
                        f = 0, S = [];
                    }
                    return v.identifier = "TelemetryInitializerPlugin", v.priority = 199, _initDefaults(), dynamicProto(TelemetryInitializerPlugin2, v, function(g, v) {
                        g.addTelemetryInitializer = function(g) {
                            return _addInitializer(S, f++, g);
                        }, g[wu] = function(f, v) {
                            _runInitializers(S, f, v ? v[Td]() : g[Td]()) && g[dd](f, v);
                        }, g[Id] = function() {
                            _initDefaults();
                        };
                    }), v;
                }
                return __extendsFn(TelemetryInitializerPlugin2, g), TelemetryInitializerPlugin2.__ieDyn = 1, TelemetryInitializerPlugin2;
            }(Eg), bg = "Plugins must provide initialize method", Ag = "_notificationManager", Rg = "SDK is still unloading...", Pg = "SDK is not initialized", wg = objDeepFreeze(((Tg = {
                cookieCfg: {}
            })[Pu] = {
                rdOnly: !0,
                ref: !0,
                v: []
            }, Tg[Tu] = {
                rdOnly: !0,
                ref: !0,
                v: []
            }, Tg[Ru] = {
                ref: !0,
                v: {}
            }, Tg[bu] = yu, Tg.loggingLevelConsole = 0, Tg.diagnosticLogInterval = yu, Tg));
            function _createPerfManager(g, f) {
                return new dg(f);
            }
            function _validateExtensions(g, f, S) {
                var v, _ = [], C = [], E = {};
                return arrForEach(S, function(S) {
                    (isNullOrUndefined(S) || isNullOrUndefined(S[ed])) && throwError(bg);
                    var v = S[Mu], T = S[td];
                    S && v && (isNullOrUndefined(E[v]) ? E[v] = T : _warnToConsole(g, "Two extensions have same priority #" + v + " - " + E[v] + ", " + T)), !v || v < f ? _[Yc](S) : C[Yc](S);
                }), (v = {})[Iu] = _, v[Tu] = C, v;
            }
            function _isPluginPresent(g, f) {
                var S = !1;
                return arrForEach(f, function(f) {
                    if (f === g) return S = !0, -1;
                }), S;
            }
            function _deepMergeConfig(g, f, S, v) {
                S && objForEachKey(S, function(S, _) {
                    v && isPlainObject(_) && isPlainObject(f[S]) && _deepMergeConfig(g, f[S], _, v), v && isPlainObject(_) && isPlainObject(f[S]) ? _deepMergeConfig(g, f[S], _, v) : g.set(f, S, _);
                });
            }
            function _findWatcher(g, f) {
                var S = null, v = -1;
                return arrForEach(g, function(g, _) {
                    if (g.w === f) return S = g, v = _, -1;
                }), {
                    i: v,
                    l: S
                };
            }
            function _addDelayedCfgListener(g, f) {
                var S = _findWatcher(g, f).l;
                return S || (S = {
                    w: f,
                    rm: function() {
                        var S = _findWatcher(g, f);
                        -1 !== S.i && g[Qc](S.i, 1);
                    }
                }, g[Yc](S)), S;
            }
            function _registerDelayedCfgListener(g, f, S) {
                arrForEach(f, function(f) {
                    var v = onConfigChange(g, f.w, S);
                    delete f.w, f.rm = function() {
                        v.rm();
                    };
                });
            }
            function _initDebugListener(g, f, S, v) {
                return f.add(g[zc](function(g) {
                    var f = g.cfg.disableDbgExt;
                    !0 === f && v && (S[id](v), v = null), S && !v && !0 !== f && (v = getDebugListener(g.cfg), S[nd](v));
                })), v;
            }
            function _createUnloadHook(g) {
                return objDefine({
                    rm: function() {
                        g.rm();
                    }
                }, "toJSON", {
                    v: function() {
                        return "aicore::onCfgChange<" + JSON.stringify(g) + ">";
                    }
                });
            }
            var Mg = function() {
                function AppInsightsCore4() {
                    var g, f, S, v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j;
                    dynamicProto(AppInsightsCore4, this, function(G) {
                        function _startLogPoller(f) {
                            H && H[hd] || j || (f || S && S.queue[Hc] > 0) && ($ || ($ = !0, _addUnloadHook(g[zc](function(g) {
                                var f = g.cfg.diagnosticLogInterval;
                                f && f > 0 || (f = 1e4);
                                var S = !1;
                                H && (S = H[hd], H[Zc]()), (H = createTimeout(_flushInternalLogs, f)).unref(), H[hd] = S;
                            }))), H[hd] = !0);
                            return H;
                        }
                        function _setPluginVersions() {
                            var g = {};
                            V = [];
                            var _addPluginVersions = function(f) {
                                f && arrForEach(f, function(f) {
                                    if (f[td] && f[fd] && !g[f.identifier]) {
                                        var S = f[td] + "=" + f[fd];
                                        V[Yc](S), g[f.identifier] = f;
                                    }
                                });
                            };
                            _addPluginVersions(R), A && arrForEach(A, function(g) {
                                _addPluginVersions(g);
                            }), _addPluginVersions(b);
                        }
                        function _initDefaults() {
                            f = !1, (g = createDynamicConfig({}, wg, G[Kc])).cfg[Sd] = 1, objDefine(G, "config", {
                                g: function() {
                                    return g.cfg;
                                },
                                s: function(g) {
                                    G.updateCfg(g, !1);
                                }
                            }), objDefine(G, "pluginVersionStringArr", {
                                g: function() {
                                    return V || _setPluginVersions(), V;
                                }
                            }), objDefine(G, "pluginVersionString", {
                                g: function() {
                                    return B || (V || _setPluginVersions(), B = V.join(";")), B || Eu;
                                }
                            }), objDefine(G, "logger", {
                                g: function() {
                                    return S || (S = new $h(g.cfg), g[Kc] = S), S;
                                },
                                s: function(f) {
                                    g[Kc] = f, S !== f && (runTargetUnload(S, !1), S = f);
                                }
                            }), G[Kc] = new $h(g.cfg), U = [];
                            var k = G.config[Pu] || [];
                            k.splice(0, k[Hc]), arrAppend(k, U), w = new Ig, v = [], runTargetUnload(_, !1), _ = null, C = null, E = null, runTargetUnload(T, !1), T = null, I = null, b = [], A = null, R = null, P = !1, M = null, O = createUniqueNamespace("AIBaseCore", !0), D = createUnloadHandlerContainer(), L = null, F = null, N = createUnloadHookContainer(), x = [], B = null, V = null, j = !1, H = null, $ = !1;
                        }
                        function _createTelCtx() {
                            var f = createProcessTelemetryContext(_getPluginChain(), g.cfg, G);
                            return f[md](_startLogPoller), f;
                        }
                        function _initPluginChain(g) {
                            var f = _validateExtensions(G[Kc], Rh, b);
                            I = null, B = null, V = null, R = sortPlugins(arrAppend(R = (A || [])[0] || [], f[Tu]));
                            var S = arrAppend(sortPlugins(f[Iu]), R);
                            U = bl(S);
                            var v = G.config[Pu] || [];
                            v.splice(0, v[Hc]), arrAppend(v, U);
                            var _ = _createTelCtx();
                            R && R[Hc] > 0 && initializePlugins(_[vd](R), S), initializePlugins(_, S), g && _doUpdate(g);
                        }
                        function _getPlugin(g) {
                            var f = null, S = null, v = [];
                            return arrForEach(U, function(f) {
                                if (f[td] === g && f !== w) return S = f, -1;
                                f.getChannel && v[Yc](f);
                            }), !S && v[Hc] > 0 && arrForEach(v, function(f) {
                                if (!(S = f.getChannel(g))) return -1;
                            }), S && (f = {
                                plugin: S,
                                setEnabled: function(g) {
                                    _getPluginState(S)[Au] = !g;
                                },
                                isEnabled: function() {
                                    var g = _getPluginState(S);
                                    return !g[_d] && !g[Au];
                                },
                                remove: function(g, f) {
                                    var v;
                                    void 0 === g && (g = !0);
                                    var _ = [
                                        S
                                    ], C = ((v = {
                                        reason: 1
                                    })[Ed] = g, v);
                                    _removePlugins(_, C, function(g) {
                                        g && _initPluginChain({
                                            reason: 32,
                                            removed: _
                                        }), f && f(g);
                                    });
                                }
                            }), f;
                        }
                        function _getPluginChain() {
                            if (!I) {
                                var f = (U || []).slice();
                                -1 === Kl(f, w) && f[Yc](w), I = createTelemetryProxyChain(sortPlugins(f), g.cfg, G);
                            }
                            return I;
                        }
                        function _removePlugins(f, S, v) {
                            if (f && f[Hc] > 0) {
                                var _ = createProcessTelemetryUnloadContext(createTelemetryProxyChain(f, g.cfg, G), G);
                                _[md](function() {
                                    var g = !1, S = [];
                                    arrForEach(b, function(v, _) {
                                        _isPluginPresent(v, f) ? g = !0 : S[Yc](v);
                                    }), b = S, B = null, V = null;
                                    var _ = [];
                                    A && (arrForEach(A, function(S, v) {
                                        var C = [];
                                        arrForEach(S, function(S) {
                                            _isPluginPresent(S, f) ? g = !0 : C[Yc](S);
                                        }), _[Yc](C);
                                    }), A = _), v && v(g), _startLogPoller();
                                }), _[dd](S);
                            } else v(!1);
                        }
                        function _flushInternalLogs() {
                            if (S && S.queue) {
                                var g = S.queue.slice(0);
                                S.queue[Hc] = 0, arrForEach(g, function(g) {
                                    var f, S = ((f = {})[ld] = M || "InternalMessageId: " + g[Cd], f.iKey = F, f[cd] = toISOString(new Date), f.baseType = Vh.dataType, f.baseData = {
                                        message: g[yd]
                                    }, f);
                                    G.track(S);
                                });
                            }
                        }
                        function _flushChannels(g, f, S, v) {
                            var _ = 1, C = !1, E = null;
                            function doCallback() {
                                _--, C && 0 === _ && (E && E[Zc](), E = null, f && f(C), f = null);
                            }
                            (v = v || 5e3, R && R[Hc] > 0) && _createTelCtx()[vd](R).iterate(function(f) {
                                if (f.flush) {
                                    _++;
                                    var C = !1;
                                    f.flush(g, function() {
                                        C = !0, doCallback();
                                    }, S) || C || (g && null == E ? E = scheduleTimeout(function() {
                                        E = null, doCallback();
                                    }, v) : doCallback());
                                }
                            });
                            return C = !0, doCallback(), !0;
                        }
                        function _initPerfManager() {
                            var f;
                            _addUnloadHook(g[zc](function(g) {
                                if (g.cfg.enablePerfMgr) {
                                    var S = g.cfg[bu];
                                    f !== S && (S || (S = _createPerfManager), getSetValue(g.cfg, bu, S), f = S, E = null), C || E || !cl(S) || (E = S(G, G[ad]()));
                                } else E = null, f = null;
                            }));
                        }
                        function _doUpdate(g) {
                            var f = createProcessTelemetryUpdateContext(_getPluginChain(), G);
                            f[md](_startLogPoller), G._updateHook && !0 === G._updateHook(f, g) || f[dd](g);
                        }
                        function _logOrThrowError(g) {
                            var f = G[Kc];
                            f ? (_throwInternal(f, 2, 73, g), _startLogPoller()) : throwError(g);
                        }
                        function _notifyInvalidEvent(g) {
                            var f = G[ad]();
                            f && f[Du]([
                                g
                            ], 2);
                        }
                        function _addUnloadHook(g) {
                            N.add(g);
                        }
                        _initDefaults(), G._getDbgPlgTargets = function() {
                            return [
                                U
                            ];
                        }, G[rd] = function() {
                            return f;
                        }, G[ed] = function(v, C, E, T) {
                            P && throwError(Rg), G[rd]() && throwError("Core cannot be initialized more than once"), v = (g = createDynamicConfig(v, wg, E || G[Kc], !1)).cfg, _addUnloadHook(g[zc](function(g) {
                                F = g.cfg.instrumentationKey;
                                var f = g.ref(g.cfg, Ru);
                                objForEachKey(f, function(S) {
                                    g.ref(f, S);
                                }), isNullOrUndefined(F) && throwError("Please provide instrumentation key");
                            })), k = _initDebugListener(g, N, (_ = T) && G[ad](), k), _initPerfManager(), G[Kc] = E;
                            var I = v[Pu];
                            if ((b = [])[Yc].apply(b, __spreadArrayFn(__spreadArrayFn([], C, !1), I)), A = v[Tu], _initPluginChain(null), R && 0 !== R[Hc] || throwError("No " + Tu + " available"), A && A[Hc] > 1) {
                                var w = G[sd]("TeeChannelController");
                                w && w.plugin || _throwInternal(S, 1, 28, "TeeChannel required");
                            }
                            _registerDelayedCfgListener(v, x, S), x = null, f = !0, G.releaseQueue(), G[od]();
                        }, G.getChannels = function() {
                            var g = [];
                            return R && arrForEach(R, function(f) {
                                g[Yc](f);
                            }), bl(g);
                        }, G.track = function(g) {
                            doPerf(G[Uu](), function() {
                                return "AppInsightsCore:track";
                            }, function() {
                                null === g && (_notifyInvalidEvent(g), throwError("Invalid telemetry item")), !g[ld] && isNullOrUndefined(g[ld]) && (_notifyInvalidEvent(g), throwError("telemetry name required")), g.iKey = g.iKey || F, g[cd] = g[cd] || toISOString(new Date), g.ver = g.ver || "4.0", !P && G[rd]() ? _createTelCtx()[dd](g) : v[Yc](g);
                            }, function() {
                                return {
                                    item: g
                                };
                            }, !g.sync);
                        }, G[ud] = _createTelCtx, G[ad] = function() {
                            return _ || (_ = new rg(g.cfg), G[Ag] = _), _;
                        }, G[nd] = function(g) {
                            G.getNotifyMgr()[nd](g);
                        }, G[id] = function(g) {
                            _ && _[id](g);
                        }, G.getCookieMgr = function() {
                            return T || (T = createCookieMgr(g.cfg, G[Kc])), T;
                        }, G.setCookieMgr = function(g) {
                            T !== g && (runTargetUnload(T, !1), T = g);
                        }, G[Uu] = function() {
                            return C || E || getGblPerfMgr();
                        }, G.setPerfMgr = function(g) {
                            C = g;
                        }, G.eventCnt = function() {
                            return v[Hc];
                        }, G.releaseQueue = function() {
                            if (f && v[Hc] > 0) {
                                var g = v;
                                v = [], arrForEach(g, function(g) {
                                    _createTelCtx()[dd](g);
                                });
                            }
                        }, G[od] = function(g) {
                            return M = g || null, j = !1, H && H[Zc](), _startLogPoller(!0);
                        }, G[gd] = function() {
                            j = !0, H && H[Zc](), _flushInternalLogs();
                        }, proxyFunctions(G, function() {
                            return w;
                        }, [
                            "addTelemetryInitializer"
                        ]), G[pd] = function(g, v, C) {
                            var E;
                            void 0 === g && (g = !0), f || throwError(Pg), P && throwError(Rg);
                            var I, b = ((E = {
                                reason: 50
                            })[Ed] = g, E.flushComplete = !1, E);
                            g && !v && (I = createPromise(function(g) {
                                v = g;
                            }));
                            var A = createProcessTelemetryUnloadContext(_getPluginChain(), G);
                            function _doUnload(g) {
                                b.flushComplete = g, P = !0, D.run(A, b), G[gd](), A[dd](b);
                            }
                            return A[md](function() {
                                N.run(G[Kc]), doUnloadAll([
                                    T,
                                    _,
                                    S
                                ], g, function() {
                                    _initDefaults(), v && v(b);
                                });
                            }, G), _flushInternalLogs(), _flushChannels(g, _doUnload, 6, C), I;
                        }, G[sd] = _getPlugin, G.addPlugin = function(g, f, S, v) {
                            if (!g) return v && v(!1), void _logOrThrowError(bg);
                            var _ = _getPlugin(g[td]);
                            if (_ && !f) return v && v(!1), void _logOrThrowError("Plugin [" + g[td] + "] is already loaded!");
                            var C = {
                                reason: 16
                            };
                            function _addPlugin(f) {
                                b[Yc](g), C.added = [
                                    g
                                ], _initPluginChain(C), v && v(!0);
                            }
                            if (_) {
                                var E = [
                                    _.plugin
                                ];
                                _removePlugins(E, {
                                    reason: 2,
                                    isAsync: !!S
                                }, function(g) {
                                    g ? (C.removed = E, C.reason |= 32, _addPlugin()) : v && v(!1);
                                });
                            } else _addPlugin();
                        }, G.updateCfg = function(f, S) {
                            var v;
                            if (void 0 === S && (S = !0), G[rd]()) {
                                v = {
                                    reason: 1,
                                    cfg: g.cfg,
                                    oldCfg: deepExtend({}, g.cfg),
                                    newConfig: deepExtend({}, f),
                                    merge: S
                                }, f = v.newConfig;
                                var _ = g.cfg;
                                f[Pu] = _[Pu], f[Tu] = _[Tu];
                            }
                            g._block(function(g) {
                                var v = g.cfg;
                                _deepMergeConfig(g, v, f, S), S || objForEachKey(v, function(S) {
                                    fl(f, S) || g.set(v, S, yu);
                                }), g[Wc](v, wg);
                            }, !0), g[jc](), v && _doUpdate(v);
                        }, G.evtNamespace = function() {
                            return O;
                        }, G.flush = _flushChannels, G.getTraceCtx = function(g) {
                            return L || (L = createDistributedTraceContext()), L;
                        }, G.setTraceCtx = function(g) {
                            L = g || null;
                        }, G.addUnloadHook = _addUnloadHook, proxyFunctionAs(G, "addUnloadCb", function() {
                            return D;
                        }, "add"), G.onCfgChange = function(S) {
                            return _createUnloadHook(f ? onConfigChange(g.cfg, S, G[Kc]) : _addDelayedCfgListener(x, S));
                        }, G.getWParam = function() {
                            return hasDocument() || g.cfg.enableWParam ? 0 : -1;
                        };
                    });
                }
                return AppInsightsCore4.__ieDyn = 1, AppInsightsCore4;
            }(), Og = "", Dg = "&NoResponseBody=true", Ng = "POST", kg = function() {
                function SenderPostManager3() {
                    var g, f, S, v, _, C, E, T, I, b, A, R, P, w = 0;
                    dynamicProto(SenderPostManager3, this, function(M, O) {
                        var D = !0;
                        function _onSuccess(g, f) {
                            _doOnComplete(f, 200, {}, g);
                        }
                        function _onError(g, f) {
                            _throwInternal(S, 2, 26, "Failed to send telemetry.", {
                                message: g
                            }), _doOnComplete(f, 400, {});
                        }
                        function _onNoPayloadUrl(g) {
                            _onError("No endpoint url is provided for the batch", g);
                        }
                        function _getSenderInterface(g, f) {
                            for(var S, v = 0, _ = null, C = 0; null == _ && C < g[Hc];)v = g[C], T || 1 !== v ? 2 !== v || !isFetchSupported(f) || f && A ? 3 !== v || !isBeaconsSupported() || (f ? b : I) || (_ = _beaconSender) : _ = _doFetchSender : useXDomainRequest() ? _ = _xdrSender : isXhrSupported() && (_ = _xhrSender), C++;
                            return _ ? ((S = {
                                _transport: v,
                                _isSync: f
                            })[qd] = _, S) : null;
                        }
                        function _doOnComplete(g, f, S, v) {
                            try {
                                g && g(f, S, v);
                            } catch (g) {}
                        }
                        function _doBeaconSend(g, f) {
                            var S = Wl(), _ = g[Gd];
                            if (!_) return _onNoPayloadUrl(f), !0;
                            _ = g[Gd] + (R ? Dg : Og);
                            var C = g[Bd], E = v ? C : new Blob([
                                C
                            ], {
                                type: "text/plain;charset=UTF-8"
                            });
                            return S.sendBeacon(_, E);
                        }
                        function _beaconSender(g, f, C) {
                            var T = g[Bd];
                            try {
                                if (T) {
                                    if (_doBeaconSend(g, f)) _onSuccess(Og, f);
                                    else {
                                        var I = _ && _.beaconOnRetry;
                                        I && cl(I) ? I(g, f, _doBeaconSend) : (E && E[qd](g, f, !0), _throwInternal(S, 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
                                    }
                                }
                            } catch (g) {
                                v && _warnToConsole(S, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj(g)), _doOnComplete(f, v ? 0 : 400, {}, Og);
                            }
                        }
                        function _xhrSender(f, S, C) {
                            var E, T, I, b = f[Wd] || {};
                            !C && g && (E = createPromise(function(g, f) {
                                T = g, I = f;
                            })), v && C && f.disableXhrSync && (C = !1);
                            var A = f[Gd];
                            if (!A) return _onNoPayloadUrl(S), void (T && T(!1));
                            var R = openXhr(Ng, A, D, !0, C, f[zd]);
                            function _doOnReadyFunc(g) {
                                var C = _ && _.xhrOnComplete;
                                if (C && cl(C)) C(g, S, f);
                                else {
                                    var E = getResponseText(g);
                                    _doOnComplete(S, g[Fd], _getAllResponseHeaders(g, v), E);
                                }
                            }
                            return v || R[Kd]("Content-type", "application/json"), arrForEach(Il(b), function(g) {
                                R[Kd](g, b[g]);
                            }), R.onreadystatechange = function() {
                                v || (_doOnReadyFunc(R), 4 === R.readyState && T && T(!0));
                            }, R.onload = function() {
                                v && _doOnReadyFunc(R);
                            }, R.onerror = function(g) {
                                _doOnComplete(S, v ? R[Fd] : 400, _getAllResponseHeaders(R, v), v ? Og : formatErrorMessageXhr(R)), I && I(g);
                            }, R.ontimeout = function() {
                                _doOnComplete(S, v ? R[Fd] : 500, _getAllResponseHeaders(R, v), v ? Og : formatErrorMessageXhr(R)), T && T(!1);
                            }, R.send(f[Bd]), E;
                        }
                        function _doFetchSender(f, S, C) {
                            var E, T, I, b, A = f[Gd], M = f[Bd], O = v ? M : new Blob([
                                M
                            ], {
                                type: "application/json"
                            }), N = new Headers, k = M[Hc], L = !1, F = !1, x = f[Wd] || {}, U = ((E = {
                                method: Ng,
                                body: O
                            })[Ph] = !0, E);
                            f.headers && Il(f.headers)[Hc] > 0 && (arrForEach(Il(x), function(g) {
                                N.append(g, x[g]);
                            }), U[Wd] = N), D && v && (U.credentials = "include"), C && (U.keepalive = !0, w += k, v ? 2 === f._sendReason && (L = !0, R && (A += Dg)) : L = !0);
                            var V = new Request(A, U);
                            try {
                                V[Ph] = !0;
                            } catch (g) {}
                            if (!C && g && (T = createPromise(function(g, f) {
                                I = g, b = f;
                            })), !A) return _onNoPayloadUrl(S), void (I && I(!1));
                            function _handleError(g) {
                                _doOnComplete(S, v ? 0 : 400, {}, v ? Og : g);
                            }
                            function _onFetchComplete(g, f, v) {
                                var C = g[Fd], E = _.fetchOnComplete;
                                E && cl(E) ? E(g, S, v || Og, f) : _doOnComplete(S, C, {}, v || Og);
                            }
                            try {
                                doAwaitResponse(fetch(v ? A : V, v ? U : null), function(g) {
                                    if (C && (w -= k, k = 0), !F) {
                                        if (F = !0, g.rejected) _handleError(g.reason && g.reason[yd]), b && b(g.reason);
                                        else {
                                            var S = g.value;
                                            try {
                                                v || S.ok ? v && !S.body ? (_onFetchComplete(S, null, Og), I && I(!0)) : doAwaitResponse(S.text(), function(g) {
                                                    _onFetchComplete(S, f, g.value), I && I(!0);
                                                }) : (_handleError(S.statusText), I && I(!1));
                                            } catch (g) {
                                                _handleError(dumpObj(g)), b && b(g);
                                            }
                                        }
                                    }
                                });
                            } catch (g) {
                                F || (_handleError(dumpObj(g)), b && b(g));
                            }
                            return L && !F && (F = !0, _doOnComplete(S, 200, {}), I && I(!0)), v && !F && f[zd] > 0 && P && P.set(function() {
                                F || (F = !0, _doOnComplete(S, 500, {}), I && I(!0));
                            }, f[zd]), T;
                        }
                        function _xdrSender(g, f, C) {
                            var E = $l(), T = new XDomainRequest, I = g[Bd];
                            T.onload = function() {
                                var S = getResponseText(T), v = _ && _.xdrOnComplete;
                                v && cl(v) ? v(T, f, g) : _doOnComplete(f, 200, {}, S);
                            }, T.onerror = function() {
                                _doOnComplete(f, 400, {}, v ? Og : formatErrorMessageXdr(T));
                            }, T.ontimeout = function() {
                                _doOnComplete(f, 500, {});
                            }, T.onprogress = function() {};
                            var b = E && E.location && E.location[Pd] || "", A = g[Gd];
                            if (A) {
                                if (!v && 0 !== A.lastIndexOf(b, 0)) {
                                    var R = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                                    return _throwInternal(S, 2, 40, ". " + R), void _onError(R, f);
                                }
                                var w = v ? A : A[Dd](/^(https?:)/, "");
                                T.open(Ng, w), g[zd] && (T[zd] = g[zd]), T.send(I), v && C ? P && P.set(function() {
                                    T.send(I);
                                }, 0) : T.send(I);
                            } else _onNoPayloadUrl(f);
                        }
                        function _initDefaults() {
                            w = 0, f = !1, g = !1, S = null, v = null, _ = null, C = null, E = null, T = !1, I = !1, b = !1, A = !1, R = !1, P = null;
                        }
                        _initDefaults(), M[ed] = function(g, v) {
                            S = v, f && _throwInternal(S, 1, 28, "Sender is already initialized"), M.SetConfig(g), f = !0;
                        }, M._getDbgPlgTargets = function() {
                            return [
                                f,
                                v,
                                C,
                                g
                            ];
                        }, M.SetConfig = function(f) {
                            try {
                                if (_ = f.senderOnCompleteCallBack || {}, C = !!f.disableCredentials, v = !!f.isOneDs, g = !!f.enableSendPromise, T = !!f.disableXhr, I = !!f.disableBeacon, b = !!f.disableBeaconSync, P = f.timeWrapper, R = !!f.addNoResponse, A = !!f.disableFetchKeepAlive, E = {
                                    sendPOST: _xhrSender
                                }, v || (D = !1), C) {
                                    var S = getLocation();
                                    S && S.protocol && "file:" === S.protocol[Vc]() && (D = !1);
                                }
                                return !0;
                            } catch (g) {}
                            return !1;
                        }, M.getSyncFetchPayload = function() {
                            return w;
                        }, M.getSenderInst = function(g, f) {
                            return g && g[Hc] ? _getSenderInterface(g, f) : null;
                        }, M.getFallbackInst = function() {
                            return E;
                        }, M[Id] = function(g, f) {
                            _initDefaults();
                        };
                    });
                }
                return SenderPostManager3.__ieDyn = 1, SenderPostManager3;
            }(), Lg = "on", Fg = "attachEvent", xg = "addEventListener", Ug = "detachEvent", Vg = "removeEventListener", Bg = "events", Hg = "visibilitychange", $g = "pagehide", jg = "pageshow", Gg = "unload", qg = "beforeunload", Wg = createUniqueNamespace("aiEvtPageHide"), zg = createUniqueNamespace("aiEvtPageShow"), Kg = /\.[\.]+/g, Jg = /[\.]+$/, Yg = 1, Qg = createElmNodeData("events"), Xg = /^([^.]*)(?:\.(.+)|)/;
            function _normalizeNamespace(g) {
                return g && g[Dd] ? g[Dd](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, Eu) : g;
            }
            function _getEvtNamespace(g, f) {
                var S;
                if (f) {
                    var v = Eu;
                    dl(f) ? (v = Eu, arrForEach(f, function(g) {
                        (g = _normalizeNamespace(g)) && ("." !== g[0] && (g = "." + g), v += g);
                    })) : v = _normalizeNamespace(f), v && ("." !== v[0] && (v = "." + v), g = (g || Eu) + v);
                }
                var _ = Xg.exec(g || Eu) || [];
                return (S = {})[kd] = _[1], S.ns = (_[2] || Eu).replace(Kg, ".").replace(Jg, Eu)[Md](".").sort().join("."), S;
            }
            function _getRegisteredEvents(g, f, S) {
                void 0 === S && (S = !0);
                var v = Qg.get(g, Bg, {}, S), _ = v[f];
                return _ || (_ = v[f] = []), _;
            }
            function _doDetach(g, f, S, v) {
                g && f && f[kd] && (g[Vg] ? g[Vg](f[kd], S, v) : g[Ug] && g[Ug](Lg + f[kd], S));
            }
            function _doAttach(g, f, S, v) {
                var _ = !1;
                return g && f && f[kd] && S && (g[xg] ? (g[xg](f[kd], S, v), _ = !0) : g[Fg] && (g[Fg](Lg + f[kd], S), _ = !0)), _;
            }
            function _doUnregister(g, f, S, v) {
                for(var _ = f[Hc]; _--;){
                    var C = f[_];
                    C && (S.ns && S.ns !== C.evtName.ns || v && !v(C) || (_doDetach(g, C.evtName, C[Ld], C.capture), f[Qc](_, 1)));
                }
            }
            function _unregisterEvents(g, f, S) {
                if (f[kd]) _doUnregister(g, _getRegisteredEvents(g, f[kd]), f, S);
                else {
                    var v = Qg.get(g, Bg, {});
                    objForEachKey(v, function(v, _) {
                        _doUnregister(g, _, f, S);
                    }), 0 === Il(v)[Hc] && Qg.kill(g, Bg);
                }
            }
            function mergeEvtNamespace(g, f) {
                return f ? _getEvtNamespace("xx", dl(f) ? [
                    g
                ].concat(f) : [
                    g,
                    f
                ]).ns[Md](".") : g;
            }
            function eventOn(g, f, S, v, _) {
                var C;
                void 0 === _ && (_ = !1);
                var E = !1;
                if (g) try {
                    var T = _getEvtNamespace(f, v);
                    if ((E = _doAttach(g, T, S, _)) && Qg.accept(g)) {
                        var I = ((C = {
                            guid: Yg++,
                            evtName: T
                        })[Ld] = S, C.capture = _, C);
                        _getRegisteredEvents(g, T.type)[Yc](I);
                    }
                } catch (g) {}
                return E;
            }
            function eventOff(g, f, S, v, _) {
                if (void 0 === _ && (_ = !1), g) try {
                    var C = _getEvtNamespace(f, v), E = !1;
                    _unregisterEvents(g, C, function(g) {
                        return !((!C.ns || S) && g[Ld] !== S) && (E = !0, !0);
                    }), E || _doDetach(g, C, S, _);
                } catch (g) {}
            }
            function addEventHandler(g, f, S) {
                var v = !1, _ = $l();
                _ && (v = eventOn(_, g, f, S), v = eventOn(_.body, g, f, S) || v);
                var C = Hl();
                return C && (v = eventOn(C, g, f, S) || v), v;
            }
            function removeEventHandler(g, f, S) {
                var v = $l();
                v && (eventOff(v, g, f, S), eventOff(v.body, g, f, S));
                var _ = Hl();
                _ && eventOff(_, g, f, S);
            }
            function _addEventListeners(g, f, S, v) {
                var _ = !1;
                return f && g && g[Hc] > 0 && arrForEach(g, function(g) {
                    g && (S && -1 !== Kl(S, g) || (_ = addEventHandler(g, f, v) || _));
                }), _;
            }
            function addEventListeners(g, f, S, v) {
                var _ = !1;
                return f && g && dl(g) && !(_ = _addEventListeners(g, f, S, v)) && S && S[Hc] > 0 && (_ = _addEventListeners(g, f, null, v)), _;
            }
            function removeEventListeners(g, f, S) {
                g && dl(g) && arrForEach(g, function(g) {
                    g && removeEventHandler(g, f, S);
                });
            }
            function addPageUnloadEventListener(g, f, S) {
                return addEventListeners([
                    qg,
                    Gg,
                    $g
                ], g, f, S);
            }
            function removePageUnloadEventListener(g, f) {
                removeEventListeners([
                    qg,
                    Gg,
                    $g
                ], g, f);
            }
            function addPageHideEventListener(g, f, S) {
                function _handlePageVisibility(f) {
                    var S = Hl();
                    g && S && "hidden" === S.visibilityState && g(f);
                }
                var v = mergeEvtNamespace(Wg, S), _ = _addEventListeners([
                    $g
                ], g, f, v);
                return f && -1 !== Kl(f, Hg) || (_ = _addEventListeners([
                    Hg
                ], _handlePageVisibility, f, v) || _), !_ && f && (_ = addPageHideEventListener(g, null, S)), _;
            }
            function removePageHideEventListener(g, f) {
                var S = mergeEvtNamespace(Wg, f);
                removeEventListeners([
                    $g
                ], g, S), removeEventListeners([
                    Hg
                ], null, S);
            }
            function addPageShowEventListener(g, f, S) {
                function _handlePageVisibility(f) {
                    var S = Hl();
                    g && S && "visible" === S.visibilityState && g(f);
                }
                var v = mergeEvtNamespace(zg, S), _ = _addEventListeners([
                    jg
                ], g, f, v);
                return !(_ = _addEventListeners([
                    Hg
                ], _handlePageVisibility, f, v) || _) && f && (_ = addPageShowEventListener(g, null, S)), _;
            }
            function removePageShowEventListener(g, f) {
                var S = mergeEvtNamespace(zg, f);
                removeEventListeners([
                    jg
                ], g, S), removeEventListeners([
                    Hg
                ], null, S);
            }
            var Zg, ep = "", tp = "https://browser.events.data.microsoft.com/OneCollector/1.0/", ip = "version", np = "properties", rp = "initialize", ap = "logger", sp = "indexOf", op = "timings", lp = "pollInternalLogs", cp = "value", dp = "kind", up = "length", hp = "processTelemetryStart", gp = "1DS-Web-JS-4.2.1", pp = xo.hasOwnProperty, mp = ((Zg = {})[0] = 0, Zg[2] = 6, Zg[1] = 1, Zg[3] = 7, Zg[4098] = 6, Zg[4097] = 1, Zg[4099] = 7, Zg);
            function isValueAssigned(g) {
                return !(g === ep || isNullOrUndefined(g));
            }
            function getTenantId(g) {
                if (g) {
                    var f = ac(g, "-");
                    if (f > -1) return strLeft(g, f);
                }
                return ep;
            }
            function isLatency(g) {
                return !!(g && hl(g) && g >= 1 && g <= 4);
            }
            function sanitizeProperty(g, f, S) {
                if (!f && !isValueAssigned(f) || "string" != typeof g) return null;
                var v = typeof f;
                if ("string" === v || "number" === v || "boolean" === v || dl(f)) f = {
                    value: f
                };
                else if ("object" !== v || pp.call(f, "value")) {
                    if (isNullOrUndefined(f[cp]) || f[cp] === ep || !ll(f[cp]) && !hl(f[cp]) && !gl(f[cp]) && !dl(f[cp])) return null;
                } else f = {
                    value: S ? JSON.stringify(f) : f
                };
                if (dl(f[cp]) && !isArrayValid(f[cp])) return null;
                if (!isNullOrUndefined(f[dp])) {
                    if (dl(f[cp]) || !isValueKind(f[dp])) return null;
                    f[cp] = f[cp].toString();
                }
                return f;
            }
            function getCommonSchemaMetaData(g, f, S) {
                var v = -1;
                if (!isUndefined4(g)) {
                    if (f > 0 && (32 === f ? v = 8192 : f <= 13 && (v = f << 5)), isDataType(S)) -1 === v && (v = 0), v |= S;
                    else {
                        var _ = mp[getFieldValueType(g)] || -1;
                        -1 !== v && -1 !== _ ? v |= _ : 6 === _ && (v = _);
                    }
                }
                return v;
            }
            function getCookieValue(g, f, S) {
                var v;
                return void 0 === S && (S = !0), g && (v = g.get(f), S && v && decodeURIComponent && (v = decodeURIComponent(v))), v || ep;
            }
            function createGuid(g) {
                void 0 === g && (g = "D");
                var f = newGuid2();
                return "B" === g ? f = "{" + f + "}" : "P" === g ? f = "(" + f + ")" : "N" === g && (f = f.replace(/-/g, ep)), f;
            }
            function extend(g, f, S, v, _) {
                var C = {}, E = !1, T = 0, I = arguments[up], b = arguments;
                for(gl(b[0]) && (E = b[0], T++); T < I; T++)objForEachKey(b[T], function(g, f) {
                    E && f && isObject3(f) ? dl(f) ? (C[g] = C[g] || [], arrForEach(f, function(f, S) {
                        f && isObject3(f) ? C[g][S] = extend(!0, C[g][S], f) : C[g][S] = f;
                    })) : C[g] = extend(!0, C[g], f) : C[g] = f;
                });
                return C;
            }
            var fp = perfNow;
            function isValueKind(g) {
                return 0 === g || g > 0 && g <= 13 || 32 === g;
            }
            function isDataType(g) {
                return g >= 0 && g <= 9;
            }
            function isArrayValid(g) {
                return g[up] > 0;
            }
            function setProcessTelemetryTimings(g, f) {
                var S = g;
                S[op] = S[op] || {}, S[op][hp] = S[op][hp] || {}, S[op][hp][f] = fp();
            }
            function getFieldValueType(g) {
                var f = 0;
                if (null != g) {
                    var S = typeof g;
                    "string" === S ? f = 1 : "number" === S ? f = 2 : "boolean" === S ? f = 3 : S === No && (f = 4, dl(g) ? (f = 4096, g[up] > 0 && (f |= getFieldValueType(g[0]))) : pp.call(g, "value") && (f = 8192 | getFieldValueType(g[cp])));
                }
                return f;
            }
            function isChromium() {
                return !!getInst("chrome");
            }
            function isGreaterThanZero(g) {
                return g > 0;
            }
            var Sp = objDeepFreeze({
                endpointUrl: tp,
                propertyStorageOverride: {
                    isVal: _chkPropOverride
                }
            });
            function _chkPropOverride(g) {
                return !g || g.getProperty && g.setProperty || throwError("Invalid property storage override passed."), !0;
            }
            var vp = function(g) {
                function AppInsightsCore4() {
                    var f = g.call(this) || this;
                    return dynamicProto(AppInsightsCore4, f, function(g, f) {
                        g[rp] = function(S, v, _, C) {
                            doPerf(g, function() {
                                return "AppInsightsCore.initialize";
                            }, function() {
                                try {
                                    f[rp](createDynamicConfig(S, Sp, _ || g[ap], !1).cfg, v, _, C);
                                } catch (f) {
                                    var E = g[ap], T = dumpObj(f);
                                    -1 !== T[sp]("channels") && (T += "\n - Channels must be provided through config.channels only!"), _throwInternal(E, 1, 514, "SDK Initialization Failed - no telemetry will be sent: " + T);
                                }
                            }, function() {
                                return {
                                    config: S,
                                    extensions: v,
                                    logger: _,
                                    notificationManager: C
                                };
                            });
                        }, g.track = function(S) {
                            doPerf(g, function() {
                                return "AppInsightsCore.track";
                            }, function() {
                                var v = S;
                                if (v) {
                                    v[op] = v[op] || {}, v[op].trackStart = fp(), isLatency(v.latency) || (v.latency = 1);
                                    var _ = v.ext = v.ext || {};
                                    _.sdk = _.sdk || {}, _.sdk.ver = gp;
                                    var C = v.baseData = v.baseData || {};
                                    C[np] = C[np] || {};
                                    var E = C[np];
                                    E[ip] = E[ip] || g.pluginVersionString || ep;
                                }
                                f.track(v);
                            }, function() {
                                return {
                                    item: S
                                };
                            }, !S.sync);
                        }, g[lp] = function(g) {
                            return f[lp](g || "InternalLog");
                        };
                    }), f;
                }
                return __extendsFn(AppInsightsCore4, g), AppInsightsCore4.__ieDyn = 1, AppInsightsCore4;
            }(Mg), _p = Fc({
                Normal: 1,
                CostDeferred: 2,
                RealTime: 3,
                Immediate: 4
            }), Cp = Fc({
                Normal: 1,
                Critical: 2
            }), yp = "REAL_TIME", Ep = "NEAR_REAL_TIME", Tp = "BEST_EFFORT", Ip = "", bp = "drop", Ap = "send", Rp = "requeue", Pp = "rspFail", wp = "oth", Mp = "no-cache, no-store", Op = "application/x-json-stream", Dp = "cache-control", Np = "content-type", kp = "kill-tokens", Lp = "kill-duration", Fp = "time-delta-millis", xp = "client-version", Up = "client-id", Vp = "time-delta-to-apply-millis", Bp = "upload-time", Hp = "apikey", $p = "AuthMsaDeviceTicket", jp = "WebAuthToken", Gp = "AuthXToken", qp = "NoResponseBody", Wp = "msfpc", zp = "trace", Kp = "user", Jp = "allowRequestSending", Yp = "firstRequestSent", Qp = "shouldAddClockSkewHeaders", Xp = "getClockSkewHeaderValue", Zp = "setClockSkew", em = "length", tm = "concat", im = "iKey", nm = "count", rm = "events", am = "push", sm = "split", om = "splice", lm = "toLowerCase", cm = "hdrs", dm = "useHdrs", um = "initialize", hm = "setTimeoutOverride", gm = "clearTimeoutOverride", pm = "payloadPreprocessor", mm = "overrideEndpointUrl", fm = "avoidOptions", Sm = "disableEventTimings", vm = "stringifyObjects", _m = "enableCompoundKey", Cm = "disableXhrSync", ym = "disableFetchKeepAlive", Em = "addNoResponse", Tm = "excludeCsMetaData", Im = "useSendBeacon", bm = "alwaysUseXhrOverride", Am = "unloadTransports", Rm = "serializeOfflineEvt", Pm = "getOfflineRequestDetails", wm = "createPayload", Mm = "createOneDSPayload", Om = "payloadBlob", Dm = "headers", Nm = "_thePayload", km = "urlString", Lm = "batches", Fm = "sendType", xm = "addHeader", Um = "canSendRequest", Vm = "sendQueuedRequests", Bm = "isCompletelyIdle", Hm = "setUnloading", $m = "isTenantKilled", jm = "sendSynchronousBatch", Gm = "_transport", qm = "getWParam", Wm = "isBeacon", zm = "timings", Km = "isTeardown", Jm = "isSync", Ym = "data", Qm = "timeout", Xm = "_sendReason", Zm = "setKillSwitchTenants", ef = "_backOffTransmission", tf = "identifier", nf = "disableOptimizeObj", rf = "ignoreMc1Ms0CookieProcessing", af = "eventsLimitInMem", sf = "autoFlushEventsLimit", of = "disableAutoBatchFlushLimit", lf = "overrideInstrumentationKey", cf = "disableTelemetry", df = "baseData", uf = "sendAttempt", hf = "latency", gf = "sync";
            function _getEventMsfpc(g) {
                var f = (g.ext || {}).intweb;
                return f && isValueAssigned(f[Wp]) ? f[Wp] : null;
            }
            function _getMsfpc(g) {
                for(var f = null, S = 0; null === f && S < g[em]; S++)f = _getEventMsfpc(g[S]);
                return f;
            }
            var pf = function() {
                function EventBatch2(g, f) {
                    var S = f ? [][tm](f) : [], v = this, _ = _getMsfpc(S);
                    v[im] = function() {
                        return g;
                    }, v.Msfpc = function() {
                        return _ || Ip;
                    }, v[nm] = function() {
                        return S[em];
                    }, v[rm] = function() {
                        return S;
                    }, v.addEvent = function(g) {
                        return !!g && (S[am](g), _ || (_ = _getEventMsfpc(g)), !0);
                    }, v[sm] = function(f, v) {
                        var C;
                        if (f < S[em]) {
                            var E = S[em] - f;
                            isNullOrUndefined(v) || (E = v < E ? v : E), C = S[om](f, E), _ = _getMsfpc(S);
                        }
                        return new EventBatch2(g, C);
                    };
                }
                return EventBatch2.create = function(g, f) {
                    return new EventBatch2(g, f);
                }, EventBatch2;
            }(), mf = function() {
                function ClockSkewManager2() {
                    var g = !0, f = !0, S = !0, v = "use-collector-delta", _ = !1;
                    dynamicProto(ClockSkewManager2, this, function(C) {
                        C[Jp] = function() {
                            return g;
                        }, C[Yp] = function() {
                            S && (S = !1, _ || (g = !1));
                        }, C[Qp] = function() {
                            return f;
                        }, C[Xp] = function() {
                            return v;
                        }, C[Zp] = function(S) {
                            _ || (S ? (v = S, f = !0, _ = !0) : f = !1, g = !0);
                        };
                    });
                }
                return ClockSkewManager2.__ieDyn = 1, ClockSkewManager2;
            }(), ff = 1e3, Sf = function() {
                function KillSwitch2() {
                    var g = {};
                    function _normalizeTenants(g) {
                        var f = [];
                        return g && arrForEach(g, function(g) {
                            f[am](tc(g));
                        }), f;
                    }
                    dynamicProto(KillSwitch2, this, function(f) {
                        f[Zm] = function(f, S) {
                            if (f && S) try {
                                var v = _normalizeTenants(f[sm](","));
                                if ("this-request-only" === S) return v;
                                for(var _ = parseInt(S, 10) * ff, C = 0; C < v[em]; ++C)g[v[C]] = utcNow() + _;
                            } catch (g) {
                                return [];
                            }
                            return [];
                        }, f[$m] = function(f) {
                            var S = g, v = tc(f);
                            return void 0 !== S[v] && S[v] > utcNow() || (delete S[v], !1);
                        };
                    });
                }
                return KillSwitch2.__ieDyn = 1, KillSwitch2;
            }(), vf = .8, _f = 1.2, Cf = 3e3, yf = 6e5;
            function retryPolicyShouldRetryForStatus(g) {
                return !(g >= 300 && g < 500 && 429 != g || 501 == g || 505 == g);
            }
            function retryPolicyGetMillisToBackoffForRetry(g) {
                var f = 0, S = Cf * vf, v = Cf * _f, _ = Math.floor(Math.random() * (v - S)) + S;
                return f = Math.pow(2, g) * _, Math.min(f, yf);
            }
            var Ef, Tf = 20, If = 3984588, bf = 65e3, Af = 2e6, Rf = Math.min(Af, bf), Pf = "metadata", wf = "f", Mf = /\./, Of = function() {
                function Serializer2(g, f, S, v, _, C) {
                    var E = "data", T = "baseData", I = "ext", b = !!v, A = !0, R = f, P = {}, w = !!C, M = _ || getCommonSchemaMetaData;
                    dynamicProto(Serializer2, this, function(f) {
                        function _isReservedField(g, f) {
                            var S = P[g];
                            return void 0 === S && (g.length >= 7 && (S = sc(g, "ext.metadata") || sc(g, "ext.web")), P[g] = S), S;
                        }
                        function _processPathKeys(g, f, v, _, C, E, T) {
                            objForEachKey(g, function(g, I) {
                                var A = null;
                                if (I || isValueAssigned(I)) {
                                    var P = v, w = g, M = C, O = f;
                                    if (b && !_ && Mf.test(g)) {
                                        var D = g.split("."), N = D.length;
                                        if (N > 1) {
                                            M && (M = M.slice());
                                            for(var k = 0; k < N - 1; k++){
                                                var L = D[k];
                                                O = O[L] = O[L] || {}, P += "." + L, M && M.push(L);
                                            }
                                            w = D[N - 1];
                                        }
                                    }
                                    if (A = !(_ && _isReservedField(P)) && R && R.handleField(P, w) ? R.value(P, w, I, S) : sanitizeProperty(w, I, S)) {
                                        var F = A.value;
                                        if (O[w] = F, E && E(M, w, A), T && "object" == typeof F && !dl(F)) {
                                            var x = M;
                                            x && (x = x.slice()).push(w), _processPathKeys(I, F, P + "." + w, _, x, E, T);
                                        }
                                    }
                                }
                            });
                        }
                        f.createPayload = function(g, f, S, v, _, C) {
                            return {
                                apiKeys: [],
                                payloadBlob: Ip,
                                overflow: null,
                                sizeExceed: [],
                                failedEvts: [],
                                batches: [],
                                numEvents: 0,
                                retryCnt: g,
                                isTeardown: f,
                                isSync: S,
                                isBeacon: v,
                                sendType: C,
                                sendReason: _
                            };
                        }, f.appendPayload = function(S, v, _) {
                            var C = S && v && !S.overflow;
                            return C && doPerf(g, function() {
                                return "Serializer:appendPayload";
                            }, function() {
                                for(var g = v.events(), C = S.payloadBlob, E = S.numEvents, T = !1, I = [], b = [], A = S.isBeacon, R = A ? bf : If, P = A ? Rf : Af, w = 0, M = 0; w < g.length;){
                                    var O = g[w];
                                    if (O) {
                                        if (E >= _) {
                                            S.overflow = v.split(w);
                                            break;
                                        }
                                        var D = f.getEventBlob(O);
                                        if (D && D.length <= P) {
                                            var N = D.length;
                                            if (C.length + N > R) {
                                                S.overflow = v.split(w);
                                                break;
                                            }
                                            C && (C += "\n"), C += D, ++M > Tf && (kl(C, 0, 1), M = 0), T = !0, E++;
                                        } else D ? I.push(O) : b.push(O), g.splice(w, 1), w--;
                                    }
                                    w++;
                                }
                                if (I.length > 0 && S.sizeExceed.push(pf.create(v.iKey(), I)), b.length > 0 && S.failedEvts.push(pf.create(v.iKey(), b)), T) {
                                    S.batches.push(v), S.payloadBlob = C, S.numEvents = E;
                                    var k = v.iKey();
                                    -1 === Kl(S.apiKeys, k) && S.apiKeys.push(k);
                                }
                            }, function() {
                                return {
                                    payload: S,
                                    theBatch: {
                                        iKey: v.iKey(),
                                        evts: v.events()
                                    },
                                    max: _
                                };
                            }), C;
                        }, f.getEventBlob = function(f) {
                            try {
                                return doPerf(g, function() {
                                    return "Serializer.getEventBlob";
                                }, function() {
                                    var g = {};
                                    g.name = f.name, g.time = f.time, g.ver = f.ver, g.iKey = "o:" + getTenantId(f.iKey);
                                    var S, v = {};
                                    w || (S = function(g, f, S) {
                                        _addJSONPropertyMetaData(M, v, g, f, S);
                                    });
                                    var _ = f[I];
                                    _ && (g[I] = v, objForEachKey(_, function(g, f) {
                                        _processPathKeys(f, v[g] = {}, "ext." + g, !0, null, null, !0);
                                    }));
                                    var C = g[E] = {};
                                    C.baseType = f.baseType;
                                    var b = C[T] = {};
                                    return _processPathKeys(f.baseData, b, T, !1, [
                                        T
                                    ], S, A), _processPathKeys(f.data, C, E, !1, [], S, A), JSON.stringify(g);
                                }, function() {
                                    return {
                                        item: f
                                    };
                                });
                            } catch (g) {
                                return null;
                            }
                        };
                    });
                }
                return Serializer2.__ieDyn = 1, Serializer2;
            }();
            function _addJSONPropertyMetaData(g, f, S, v, _) {
                if (_ && f) {
                    var C = g(_.value, _.kind, _.propertyType);
                    if (C > -1) {
                        var E = f[Pf];
                        E || (E = f[Pf] = {
                            f: {}
                        });
                        var T = E[wf];
                        if (T || (T = E[wf] = {}), S) for(var I = 0; I < S.length; I++){
                            var b = S[I];
                            T[b] || (T[b] = {
                                f: {}
                            });
                            var A = T[b][wf];
                            A || (A = T[b][wf] = {}), T = A;
                        }
                        T = T[v] = {}, dl(_.value) ? T.a = {
                            t: C
                        } : T.t = C;
                    }
                }
            }
            function createTimeoutWrapper(g, f) {
                return {
                    set: function(S, v) {
                        for(var _ = [], C = 2; C < arguments.length; C++)_[C - 2] = arguments[C];
                        return scheduleTimeoutWith([
                            g,
                            f
                        ], S, v, _);
                    }
                };
            }
            var Df = "sendAttempt", Nf = "&" + qp + "=true", kf = "?cors=true&" + Np[lm]() + "=" + Op, Lf = ((Ef = {})[1] = Rp, Ef[100] = Rp, Ef[200] = "sent", Ef[8004] = bp, Ef[8003] = bp, Ef), Ff = {}, xf = {};
            function _addCollectorHeaderQsMapping(g, f, S) {
                Ff[g] = f, !1 !== S && (xf[f] = g);
            }
            function _hasHeader(g, f) {
                var S = !1;
                if (g && f) {
                    var v = Il(g);
                    if (v && v[em] > 0) for(var _ = f[lm](), C = 0; C < v[em]; C++){
                        var E = v[C];
                        if (E && objHasOwnProperty(f, E) && E[lm]() === _) {
                            S = !0;
                            break;
                        }
                    }
                }
                return S;
            }
            function _addRequestDetails(g, f, S, v) {
                f && S && S[em] > 0 && (v && Ff[f] ? (g[cm][Ff[f]] = S, g[dm] = !0) : g.url += "&" + f + "=" + S);
            }
            function _addQueryStringParameter(g, f, S) {
                for(var v = 0; v < g[em]; v++)if (g[v].name === f) return void (g[v].value = S);
                g[am]({
                    name: f,
                    value: S
                });
            }
            function _removeQueryStringParameter(g, f) {
                for(var S = 0; S < g[em]; S++)if (g[S].name === f) return void g[om](S, 1);
            }
            _addCollectorHeaderQsMapping($p, $p, !1), _addCollectorHeaderQsMapping(xp, xp), _addCollectorHeaderQsMapping(Up, "Client-Id"), _addCollectorHeaderQsMapping(Hp, Hp), _addCollectorHeaderQsMapping(Vp, Vp), _addCollectorHeaderQsMapping(Bp, Bp), _addCollectorHeaderQsMapping(Gp, Gp);
            var Uf = function() {
                function HttpManager2(g, f, S, v) {
                    var _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G, q, W, z, K, J, Y, Q = !1;
                    dynamicProto(HttpManager2, this, function(X) {
                        _initDefaults();
                        var Z = !0;
                        function _getSenderInterface(g, f) {
                            try {
                                return Y && Y.getSenderInst(g, f);
                            } catch (g) {}
                            return null;
                        }
                        function _getSendPostMgrConfig() {
                            try {
                                return {
                                    enableSendPromise: !1,
                                    isOneDs: !0,
                                    disableCredentials: !Z,
                                    disableXhr: !1,
                                    disableBeacon: !Q,
                                    disableBeaconSync: !Q,
                                    disableFetchKeepAlive: B,
                                    timeWrapper: K,
                                    addNoResponse: $,
                                    senderOnCompleteCallBack: {
                                        xdrOnComplete: _xdrOncomplete,
                                        fetchOnComplete: _fetchOnComplete,
                                        xhrOnComplete: _xhrOnComplete,
                                        beaconOnRetry: _onBeaconRetry
                                    }
                                };
                            } catch (g) {}
                            return null;
                        }
                        function _xdrOncomplete(g, f, S) {
                            var v = getResponseText(g);
                            _doOnComplete(f, 200, {}, v), _handleCollectorResponse(v);
                        }
                        function _initDefaults() {
                            var g;
                            _ = null, C = new Sf, E = !1, T = new mf, Q = !1, I = 0, b = null, A = null, R = null, P = null, w = !0, M = [], O = {}, D = [], N = null, k = !1, L = null, F = !1, x = !1, U = g, V = g, B = g, H = g, $ = g, j = [], G = g, q = g, W = [], z = !1, K = createTimeoutWrapper(), J = !1, Y = null;
                        }
                        function _fetchOnComplete(g, f, S, v) {
                            var handleResponse = function(g, S, v) {
                                _doOnComplete(f, g, S, v), _handleCollectorResponse(v);
                            }, _ = {}, C = g[Dm];
                            C && C.forEach(function(g, f) {
                                _[f] = g;
                            }), handleResponse(g.status, _, S || Ip);
                        }
                        function _xhrOnComplete(g, f, S) {
                            var v = getResponseText(g);
                            _doOnComplete(f, g.status, _getAllResponseHeaders(g, !0), v), _handleCollectorResponse(v);
                        }
                        function _doOnComplete(g, f, S, v) {
                            try {
                                g(f, S, v);
                            } catch (g) {
                                _throwInternal(A, 2, 518, dumpObj(g));
                            }
                        }
                        function _onBeaconRetry(g, f, S) {
                            var v = 200, _ = g[Nm], C = g[km] + ($ ? Nf : Ip);
                            try {
                                var E = Wl();
                                if (_) {
                                    var T = !!P.getPlugin("LocalStorage"), I = [], b = [];
                                    arrForEach(_[Lm], function(g) {
                                        if (I && g && g[nm]() > 0) for(var f = g[rm](), S = 0; S < f[em]; S++){
                                            if (!E.sendBeacon(C, N.getEventBlob(f[S]))) {
                                                I[am](g[sm](S));
                                                break;
                                            }
                                            b[am](g[S]);
                                        }
                                        else I[am](g[sm](0));
                                    }), b[em] > 0 && (_.sentEvts = b), T || _sendBatchesNotification(I, 8003, _[Fm], !0);
                                } else v = 0;
                            } catch (g) {
                                _warnToConsole(A, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj(g)), v = 0;
                            } finally{
                                _doOnComplete(f, v, {}, Ip);
                            }
                        }
                        function _isBeaconPayload(g) {
                            return 2 === g || 3 === g;
                        }
                        function _adjustSendType(g) {
                            return F && _isBeaconPayload(g) && (g = 2), g;
                        }
                        function _hasIdleConnection() {
                            return !E && I < f;
                        }
                        function _clearQueue() {
                            var g = D;
                            return D = [], g;
                        }
                        function _canSendPayload(g, f, S) {
                            var v = !1;
                            return g && g[em] > 0 && !E && R[f] && N && (v = 0 !== f || _hasIdleConnection() && (S > 0 || T[Jp]())), v;
                        }
                        function _createDebugBatches(g) {
                            var f = {};
                            return g && arrForEach(g, function(g, S) {
                                f[S] = {
                                    iKey: g[im](),
                                    evts: g[rm]()
                                };
                            }), f;
                        }
                        function _sendBatches(f, S, v, _, T) {
                            if (f && 0 !== f[em]) {
                                if (E) _sendBatchesNotification(f, 1, _);
                                else {
                                    _ = _adjustSendType(_);
                                    try {
                                        var I = f, b = 0 !== _;
                                        doPerf(P, function() {
                                            return "HttpManager:_sendBatches";
                                        }, function(E) {
                                            E && (f = f.slice(0));
                                            for(var I = [], A = null, P = fp(), w = R[_] || (b ? R[1] : R[0]), M = w && w[Gm], O = H && (F || _isBeaconPayload(_) || 3 === M || w._isSync && 2 === M); _canSendPayload(f, _, S);){
                                                var k = f.shift();
                                                k && k[nm]() > 0 && (C.isTenantKilled(k[im]()) ? I[am](k) : (A = A || N[wm](S, v, b, O, T, _), N.appendPayload(A, k, g) ? null !== A.overflow && (f = [
                                                    A.overflow
                                                ][tm](f), A.overflow = null, _doPayloadSend(A, P, fp(), T), P = fp(), A = null) : (_doPayloadSend(A, P, fp(), T), P = fp(), f = [
                                                    k
                                                ][tm](f), A = null)));
                                            }
                                            A && _doPayloadSend(A, P, fp(), T), f[em] > 0 && (D = f[tm](D)), _sendBatchesNotification(I, 8004, _);
                                        }, function() {
                                            return {
                                                batches: _createDebugBatches(I),
                                                retryCount: S,
                                                isTeardown: v,
                                                isSynchronous: b,
                                                sendReason: T,
                                                useSendBeacon: _isBeaconPayload(_),
                                                sendType: _
                                            };
                                        }, !b);
                                    } catch (g) {
                                        _throwInternal(A, 2, 48, "Unexpected Exception sending batch: " + dumpObj(g));
                                    }
                                }
                            }
                        }
                        function _buildRequestDetails(g, f) {
                            var S = {
                                url: _,
                                hdrs: {},
                                useHdrs: !1
                            };
                            f ? (S[cm] = extend(S[cm], O), S.useHdrs = Il(S.hdrs)[em] > 0) : objForEachKey(O, function(g, f) {
                                xf[g] ? _addRequestDetails(S, xf[g], f, !1) : (S[cm][g] = f, S[dm] = !0);
                            }), _addRequestDetails(S, Up, "NO_AUTH", f), _addRequestDetails(S, xp, gp, f);
                            var v = Ip;
                            arrForEach(g.apiKeys, function(g) {
                                v[em] > 0 && (v += ","), v += g;
                            }), _addRequestDetails(S, Hp, v, f), _addRequestDetails(S, Bp, utcNow().toString(), f);
                            var C = _getMsfpc3(g);
                            if (isValueAssigned(C) && (S.url += "&ext.intweb.msfpc=" + C), T[Qp]() && _addRequestDetails(S, Vp, T[Xp](), f), P[qm]) {
                                var E = P[qm]();
                                E >= 0 && (S.url += "&w=" + E);
                            }
                            for(var I = 0; I < M[em]; I++)S.url += "&" + M[I].name + "=" + M[I].value;
                            return S;
                        }
                        function _setTimingValue(g, f, S) {
                            g[f] = g[f] || {}, g[f][b.identifier] = S;
                        }
                        function _doPayloadSend(g, f, S, v) {
                            if (g && g.payloadBlob && g.payloadBlob[em] > 0) {
                                var _ = !!G, C = R[g.sendType];
                                !_isBeaconPayload(g[Fm]) && g[Wm] && 2 === g.sendReason && (C = R[2] || R[3] || C);
                                var E = x;
                                (g.isBeacon || 3 === C[Gm]) && (E = !1);
                                var b = _buildRequestDetails(g, E);
                                E = E || b[dm];
                                var M = fp();
                                doPerf(P, function() {
                                    return "HttpManager:_doPayloadSend";
                                }, function() {
                                    for(var R = 0; R < g.batches[em]; R++)for(var O = g[Lm][R][rm](), D = 0; D < O[em]; D++){
                                        var N = O[D];
                                        if (k) {
                                            var L = N[zm] = N[zm] || {};
                                            _setTimingValue(L, "sendEventStart", M), _setTimingValue(L, "serializationStart", f), _setTimingValue(L, "serializationCompleted", S);
                                        }
                                        N[Df] > 0 ? N[Df]++ : N[Df] = 1;
                                    }
                                    _sendBatchesNotification(g[Lm], 1e3 + (v || 0), g[Fm], !0);
                                    var F = {
                                        data: g[Om],
                                        urlString: b.url,
                                        headers: b[cm],
                                        _thePayload: g,
                                        _sendReason: v,
                                        timeout: U,
                                        disableXhrSync: V,
                                        disableFetchKeepAlive: B
                                    };
                                    E && (_hasHeader(F[Dm], Dp) || (F[Dm][Dp] = Mp), _hasHeader(F[Dm], Np) || (F[Dm][Np] = Op));
                                    var x = null;
                                    C && (x = function(f) {
                                        T[Yp]();
                                        var onComplete = function(f, S) {
                                            _retryRequestIfNeeded(f, S, g, v);
                                        }, S = g[Km] || g[Jm];
                                        try {
                                            C.sendPOST(f, onComplete, S), q && q(F, f, S, g[Wm]);
                                        } catch (g) {
                                            _warnToConsole(A, "Unexpected exception sending payload. Ex:" + dumpObj(g)), _doOnComplete(onComplete, 0, {});
                                        }
                                    }), doPerf(P, function() {
                                        return "HttpManager:_doPayloadSend.sender";
                                    }, function() {
                                        if (x) {
                                            if (0 === g[Fm] && I++, _ && !g.isBeacon && 3 !== C[Gm]) {
                                                var f = {
                                                    data: F[Ym],
                                                    urlString: F[km],
                                                    headers: extend({}, F[Dm]),
                                                    timeout: F[Qm],
                                                    disableXhrSync: F[Cm],
                                                    disableFetchKeepAlive: F[ym]
                                                }, S = !1;
                                                doPerf(P, function() {
                                                    return "HttpManager:_doPayloadSend.sendHook";
                                                }, function() {
                                                    try {
                                                        G(f, function(g) {
                                                            S = !0, w || g[Nm] || (g[Nm] = g[Nm] || F[Nm], g[Xm] = g[Xm] || F[Xm]), x(g);
                                                        }, g.isSync || g[Km]);
                                                    } catch (g) {
                                                        S || x(F);
                                                    }
                                                });
                                            } else x(F);
                                        }
                                    });
                                }, function() {
                                    return {
                                        thePayload: g,
                                        serializationStart: f,
                                        serializationCompleted: S,
                                        sendReason: v
                                    };
                                }, g[Jm]);
                            }
                            g.sizeExceed && g.sizeExceed[em] > 0 && _sendBatchesNotification(g.sizeExceed, 8003, g[Fm]), g.failedEvts && g.failedEvts[em] > 0 && _sendBatchesNotification(g.failedEvts, 8002, g[Fm]);
                        }
                        function _addEventCompletedTimings(g, f) {
                            k && arrForEach(g, function(g) {
                                _setTimingValue(g[zm] = g[zm] || {}, "sendEventCompleted", f);
                            });
                        }
                        function _retryRequestIfNeeded(g, f, v, _) {
                            var E = 9e3, b = null, A = !1, R = !1;
                            try {
                                var P = !0;
                                if (typeof g !== ko) {
                                    if (f) {
                                        T[Zp](f[Fp]);
                                        var w = f[Lp] || f["kill-duration-seconds"];
                                        arrForEach(C[Zm](f[kp], w), function(g) {
                                            arrForEach(v[Lm], function(f) {
                                                if (f[im]() === g) {
                                                    b = b || [];
                                                    var S = f[sm](0);
                                                    v.numEvents -= S[nm](), b[am](S);
                                                }
                                            });
                                        });
                                    }
                                    if (200 == g || 204 == g) return void (E = 200);
                                    (!retryPolicyShouldRetryForStatus(g) || v.numEvents <= 0) && (P = !1), E = 9e3 + g % 1e3;
                                }
                                if (P) {
                                    E = 100;
                                    var M = v.retryCnt;
                                    0 === v[Fm] && (M < S ? (A = !0, _doAction(function() {
                                        0 === v[Fm] && I--, _sendBatches(v[Lm], M + 1, v[Km], F ? 2 : v[Fm], 5);
                                    }, F, retryPolicyGetMillisToBackoffForRetry(M))) : (R = !0, F && (E = 8001)));
                                }
                            } finally{
                                A || (T[Zp](), _handleRequestFinished(v, E, _, R)), _sendBatchesNotification(b, 8004, v[Fm]);
                            }
                        }
                        function _handleRequestFinished(g, f, S, v) {
                            try {
                                v && b[ef]();
                                var _ = g[Lm];
                                200 === f && (_ = g.sentEvts || g[Lm], v || g[Jm] || b._clearBackOff(), _addCompleteTimings(_)), _sendBatchesNotification(_, f, g[Fm], !0);
                            } finally{
                                0 === g[Fm] && (I--, 5 !== S && X.sendQueuedRequests(g[Fm], S));
                            }
                        }
                        function _addCompleteTimings(g) {
                            if (k) {
                                var f = fp();
                                arrForEach(g, function(g) {
                                    g && g[nm]() > 0 && _addEventCompletedTimings(g[rm](), f);
                                });
                            }
                        }
                        function _doAction(g, f, S) {
                            f ? g() : K.set(g, S);
                        }
                        function _getMsfpc3(g) {
                            for(var f = 0; f < g.batches[em]; f++){
                                var S = g[Lm][f].Msfpc();
                                if (S) return encodeURIComponent(S);
                            }
                            return Ip;
                        }
                        function _handleCollectorResponse(g) {
                            var f = W;
                            try {
                                for(var S = 0; S < f[em]; S++)try {
                                    f[S](g);
                                } catch (g) {
                                    _throwInternal(A, 1, 519, "Response handler failed: " + g);
                                }
                                if (g) {
                                    var v = JSON.parse(g);
                                    isValueAssigned(v.webResult) && isValueAssigned(v.webResult[Wp]) && L.set("MSFPC", v.webResult[Wp], 31536e3);
                                }
                            } catch (g) {}
                        }
                        function _sendBatchesNotification(g, f, S, _) {
                            if (g && g[em] > 0 && v) {
                                var C = v[_getNotificationAction(f)];
                                if (C) {
                                    var E = 0 !== S;
                                    doPerf(P, function() {
                                        return "HttpManager:_sendBatchesNotification";
                                    }, function() {
                                        _doAction(function() {
                                            try {
                                                C.call(v, g, f, E, S);
                                            } catch (g) {
                                                _throwInternal(A, 1, 74, "send request notification failed: " + g);
                                            }
                                        }, _ || E, 0);
                                    }, function() {
                                        return {
                                            batches: _createDebugBatches(g),
                                            reason: f,
                                            isSync: E,
                                            sendSync: _,
                                            sendType: S
                                        };
                                    }, !E);
                                }
                            }
                        }
                        function _getNotificationAction(g) {
                            var f = Lf[g];
                            return isValueAssigned(f) || (f = wp, g >= 9e3 && g <= 9999 ? f = Pp : g >= 8e3 && g <= 8999 ? f = bp : g >= 1e3 && g <= 1999 && (f = Ap)), f;
                        }
                        X[um] = function(g, f, S) {
                            z || (P = f, L = f.getCookieMgr(), A = (b = S).diagLog(), arrAppend(j, onConfigChange(g, function(g) {
                                var v, C = g.cfg, E = g.cfg.extensionConfig[S.identifier];
                                K = createTimeoutWrapper(E[hm], E[gm]), isValueAssigned(C.anonCookieName) ? _addQueryStringParameter(M, "anoncknm", C.anonCookieName) : _removeQueryStringParameter(M, "anoncknm"), G = E[pm], q = E.payloadListener;
                                var T = E.httpXHROverride, I = E[mm] ? E[mm] : C.endpointUrl;
                                _ = I + kf, x = !!isUndefined4(E[fm]) || !E[fm], k = !E[Sm];
                                var b = E.valueSanitizer, O = E[vm], D = !!C[_m];
                                isUndefined4(E[_m]) || (D = !!E[_m]), U = E.xhrTimeout, V = !!E[Cm], B = !!E[ym], $ = !1 !== E[Em], J = !!E[Tm], f.getPlugin("LocalStorage") && (B = !0), Q = !isReactNative(), N = new Of(P, b, O, D, getCommonSchemaMetaData, J), isNullOrUndefined(E[Im]) || (Q = !!E[Im]);
                                var L = _getSendPostMgrConfig();
                                Y ? Y.SetConfig(L) : (Y = new kg)[um](L, A);
                                var F = T, j = E[bm] ? T : null, W = E[bm] ? T : null, z = [
                                    3,
                                    2
                                ];
                                if (!T) {
                                    w = !1;
                                    var X = [];
                                    isReactNative() ? (X = [
                                        2,
                                        1
                                    ], z = [
                                        2,
                                        1,
                                        3
                                    ]) : X = [
                                        1,
                                        2,
                                        3
                                    ], (T = _getSenderInterface(X = prependTransports(X, E.transports), !1)) || _warnToConsole(A, "No available transport to send events"), F = _getSenderInterface(X, !0);
                                }
                                j || (j = _getSenderInterface(z = prependTransports(z, E[Am]), !0)), H = !w && (Q && isBeaconsSupported() || !B && isFetchSupported(!0)), (v = {})[0] = T, v[1] = F || _getSenderInterface([
                                    1,
                                    2,
                                    3
                                ], !0), v[2] = j || F || _getSenderInterface([
                                    1
                                ], !0), v[3] = W || _getSenderInterface([
                                    2,
                                    3
                                ], !0) || F || _getSenderInterface([
                                    1
                                ], !0), R = v;
                            })), z = !0);
                        }, X.addResponseHandler = function(g) {
                            return W[am](g), {
                                rm: function() {
                                    var f = W.indexOf(g);
                                    f >= 0 && W[om](f, 1);
                                }
                            };
                        }, X[Rm] = function(g) {
                            try {
                                if (N) return N.getEventBlob(g);
                            } catch (g) {}
                            return Ip;
                        }, X[Pm] = function() {
                            try {
                                return _buildRequestDetails(N && N[wm](0, !1, !1, !1, 1, 0), x);
                            } catch (g) {}
                            return null;
                        }, X[Mm] = function(f, S) {
                            try {
                                var v = [];
                                arrForEach(f, function(g) {
                                    S && (g = optimizeObject(g));
                                    var f = pf.create(g[im], [
                                        g
                                    ]);
                                    v[am](f);
                                });
                                for(var _ = null; v[em] > 0 && N;){
                                    var C = v.shift();
                                    C && C[nm]() > 0 && (_ = _ || N[wm](0, !1, !1, !1, 1, 0), N.appendPayload(_, C, g));
                                }
                                var E = _buildRequestDetails(_, x), T = {
                                    data: _[Om],
                                    urlString: E.url,
                                    headers: E[cm],
                                    timeout: U,
                                    disableXhrSync: V,
                                    disableFetchKeepAlive: B
                                };
                                return x && (_hasHeader(T[Dm], Dp) || (T[Dm][Dp] = Mp), _hasHeader(T[Dm], Np) || (T[Dm][Np] = Op)), T;
                            } catch (g) {}
                            return null;
                        }, X._getDbgPlgTargets = function() {
                            return [
                                R[0],
                                C,
                                N,
                                R
                            ];
                        }, X[xm] = function(g, f) {
                            O[g] = f;
                        }, X.removeHeader = function(g) {
                            delete O[g];
                        }, X[Um] = function() {
                            return _hasIdleConnection() && T[Jp]();
                        }, X[Vm] = function(g, f) {
                            isUndefined4(g) && (g = 0), F && (g = _adjustSendType(g), f = 2), _canSendPayload(D, g, 0) && _sendBatches(_clearQueue(), 0, !1, g, f || 0);
                        }, X[Bm] = function() {
                            return !E && 0 === I && 0 === D[em];
                        }, X[Hm] = function(g) {
                            F = g;
                        }, X.addBatch = function(g) {
                            if (g && g[nm]() > 0) {
                                if (C.isTenantKilled(g[im]())) return !1;
                                D[am](g);
                            }
                            return !0;
                        }, X.teardown = function() {
                            D[em] > 0 && _sendBatches(_clearQueue(), 0, !0, 2, 2), arrForEach(j, function(g) {
                                g && g.rm && g.rm();
                            }), j = [];
                        }, X.pause = function() {
                            E = !0;
                        }, X.resume = function() {
                            E = !1, X[Vm](0, 4);
                        }, X[jm] = function(g, f, S) {
                            g && g[nm]() > 0 && (isNullOrUndefined(f) && (f = 1), F && (f = _adjustSendType(f), S = 2), _sendBatches([
                                g
                            ], 0, !1, f, S || 0));
                        };
                    });
                }
                return HttpManager2.__ieDyn = 1, HttpManager2;
            }(), Vf = .25, Bf = 500, Hf = 20, $f = 6, jf = 2, Gf = 4, qf = 2, Wf = 1, zf = 1e4, Kf = "eventsDiscarded", Jf = "", Yf = void 0, Qf = objDeepFreeze({
                eventsLimitInMem: {
                    isVal: isGreaterThanZero,
                    v: zf
                },
                immediateEventLimit: {
                    isVal: isGreaterThanZero,
                    v: 500
                },
                autoFlushEventsLimit: {
                    isVal: isGreaterThanZero,
                    v: 0
                },
                disableAutoBatchFlushLimit: !1,
                httpXHROverride: {
                    isVal: isOverrideFn,
                    v: Yf
                },
                overrideInstrumentationKey: Yf,
                overrideEndpointUrl: Yf,
                disableTelemetry: !1,
                ignoreMc1Ms0CookieProcessing: !1,
                setTimeoutOverride: Yf,
                clearTimeoutOverride: Yf,
                payloadPreprocessor: Yf,
                payloadListener: Yf,
                disableEventTimings: Yf,
                valueSanitizer: Yf,
                stringifyObjects: Yf,
                enableCompoundKey: Yf,
                disableOptimizeObj: !1,
                transports: Yf,
                unloadTransports: Yf,
                useSendBeacon: Yf,
                disableFetchKeepAlive: Yf,
                avoidOptions: !1,
                xhrTimeout: Yf,
                disableXhrSync: Yf,
                alwaysUseXhrOverride: !1,
                maxEventRetryAttempts: {
                    isVal: hl,
                    v: $f
                },
                maxUnloadEventRetryAttempts: {
                    isVal: hl,
                    v: jf
                },
                addNoResponse: Yf,
                excludeCsMetaData: Yf
            });
            function isOverrideFn(g) {
                return g && g.sendPOST;
            }
            var Xf, Zf = function(g) {
                function PostChannel2() {
                    var f, S = g.call(this) || this;
                    S.identifier = "PostChannel", S.priority = 1011, S.version = "4.2.1";
                    var v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G = !1, q = [], W = !1, z = 0, K = 0, J = {}, Y = yp;
                    return dynamicProto(PostChannel2, S, function(g, S) {
                        function _removeUnloadHandlers() {
                            removePageUnloadEventListener(null, F), removePageHideEventListener(null, F), removePageShowEventListener(null, F);
                        }
                        function _hookWParam(g) {
                            var f = g[qm];
                            g[qm] = function() {
                                var S = 0;
                                return U && (S |= 2), S | f.call(g);
                            };
                        }
                        function _batch(g) {
                            var f = Jf;
                            return g && g[em] && arrForEach(g, function(g) {
                                f && (f += "\n"), f += g;
                            }), f;
                        }
                        function _serialize(g) {
                            var f = Jf;
                            try {
                                _cleanEvent(g), f = A[Rm](g);
                            } catch (g) {}
                            return f;
                        }
                        function _handleUnloadEvents(g) {
                            "beforeunload" !== (g || $l().event).type && (N = !0, A[Hm](N)), _releaseAllQueues(2, 2);
                        }
                        function _handleShowEvents(g) {
                            N = !1, A[Hm](N);
                        }
                        function _cleanEvent(g) {
                            g.ext && g.ext[zp] && delete g.ext[zp], g.ext && g.ext[Kp] && g.ext[Kp].id && delete g.ext[Kp].id, D && (g.ext = optimizeObject(g.ext), g[df] && (g[df] = optimizeObject(g[df])), g[Ym] && (g[Ym] = optimizeObject(g[Ym])));
                        }
                        function _addEventToQueues(g, f) {
                            if (g[uf] || (g[uf] = 0), g[hf] || (g[hf] = 1), _cleanEvent(g), g[gf]) {
                                if (I || W) g[hf] = 3, g[gf] = !1;
                                else if (A) return D && (g = optimizeObject(g)), void A[jm](pf.create(g[im], [
                                    g
                                ]), !0 === g[gf] ? 1 : g[gf], 3);
                            }
                            var S = g[hf], v = K, E = C;
                            4 === S && (v = z, E = _);
                            var T = !1;
                            if (v < E) T = !_addEventToProperQueue(g, f);
                            else {
                                var b = 1, R = Hf;
                                4 === S && (b = 4, R = 1), T = !0, _dropEventWithLatencyOrLess(g[im], g[hf], b, R) && (T = !_addEventToProperQueue(g, f));
                            }
                            T && _notifyEvents(Kf, [
                                g
                            ], Uc.QueueFull);
                        }
                        function _sendEventsForLatencyAndAbove(g, f, S) {
                            var v = _queueBatches(g, f, S);
                            return A[Vm](f, S), v;
                        }
                        function _hasEvents() {
                            return K > 0;
                        }
                        function _scheduleTimer() {
                            if (M >= 0 && _queueBatches(M, 0, O) && A[Vm](0, O), z > 0 && !T && !W) {
                                var g = J[Y][2];
                                g >= 0 && (T = _createTimer(function() {
                                    T = null, _sendEventsForLatencyAndAbove(4, 0, 1), _scheduleTimer();
                                }, g));
                            }
                            var f = J[Y][1];
                            !E && !v && f >= 0 && !W && (_hasEvents() ? E = _createTimer(function() {
                                E = null, _sendEventsForLatencyAndAbove(0 === b ? 3 : 1, 0, 1), b++, b %= 2, _scheduleTimer();
                            }, f) : b = 0);
                        }
                        function _initDefaults() {
                            f = null, G = !1, q = [], v = null, W = !1, z = 0, _ = 500, K = 0, C = zf, J = {}, Y = yp, E = null, T = null, I = 0, b = 0, R = {}, P = 0, H = !1, w = 0, M = -1, O = null, D = !0, N = !1, k = $f, L = jf, F = null, $ = null, j = !1, x = createTimeoutWrapper(), A = new Uf(Bf, qf, Wf, {
                                requeue: _requeueEvents,
                                send: _sendingEvent,
                                sent: _eventsSentEvent,
                                drop: _eventsDropped,
                                rspFail: _eventsResponseFail,
                                oth: _otherEvent
                            }), _initializeProfiles(), _clearQueues(), _setAutoLimits();
                        }
                        function _createTimer(g, f) {
                            0 === f && I && (f = 1);
                            var S = 1e3;
                            return I && (S = retryPolicyGetMillisToBackoffForRetry(I - 1)), x.set(g, f * S);
                        }
                        function _clearScheduledTimer() {
                            return null !== E && (E.cancel(), E = null, b = 0, !0);
                        }
                        function _releaseAllQueues(g, f) {
                            _clearScheduledTimer(), v && (v.cancel(), v = null), W || _sendEventsForLatencyAndAbove(1, g, f);
                        }
                        function _clearQueues() {
                            R[4] = {
                                batches: [],
                                iKeyMap: {}
                            }, R[3] = {
                                batches: [],
                                iKeyMap: {}
                            }, R[2] = {
                                batches: [],
                                iKeyMap: {}
                            }, R[1] = {
                                batches: [],
                                iKeyMap: {}
                            };
                        }
                        function _getEventBatch(g, f, S) {
                            var v = R[f];
                            v || (v = R[f = 1]);
                            var _ = v.iKeyMap[g];
                            return !_ && S && (_ = pf.create(g), v.batches[am](_), v.iKeyMap[g] = _), _;
                        }
                        function _performAutoFlush(f, S) {
                            A[Um]() && !I && (P > 0 && K > P && (S = !0), S && null == v && g.flush(f, function() {}, 20));
                        }
                        function _addEventToProperQueue(g, f) {
                            D && (g = optimizeObject(g));
                            var S = g[hf], v = _getEventBatch(g[im], S, !0);
                            return !!v.addEvent(g) && (4 !== S ? (K++, f && 0 === g[uf] && _performAutoFlush(!g.sync, w > 0 && v[nm]() >= w)) : z++, !0);
                        }
                        function _dropEventWithLatencyOrLess(g, f, S, v) {
                            for(; S <= f;){
                                var _ = _getEventBatch(g, f, !0);
                                if (_ && _[nm]() > 0) {
                                    var C = _[sm](0, v), E = C[nm]();
                                    if (E > 0) return 4 === S ? z -= E : K -= E, _notifyBatchEvents(Kf, [
                                        C
                                    ], Uc.QueueFull), !0;
                                }
                                S++;
                            }
                            return _resetQueueCounts(), !1;
                        }
                        function _resetQueueCounts() {
                            for(var g = 0, f = 0, _loop_1 = function(S) {
                                var v = R[S];
                                v && v[Lm] && arrForEach(v[Lm], function(v) {
                                    4 === S ? g += v[nm]() : f += v[nm]();
                                });
                            }, S = 1; S <= 4; S++)_loop_1(S);
                            K = f, z = g;
                        }
                        function _queueBatches(f, S, v) {
                            var _ = !1, C = 0 === S;
                            return !C || A[Um]() ? doPerf(g.core, function() {
                                return "PostChannel._queueBatches";
                            }, function() {
                                for(var g = [], S = 4; S >= f;){
                                    var v = R[S];
                                    v && v.batches && v.batches[em] > 0 && (arrForEach(v[Lm], function(f) {
                                        A.addBatch(f) ? _ = _ || f && f[nm]() > 0 : g = g[tm](f[rm]()), 4 === S ? z -= f[nm]() : K -= f[nm]();
                                    }), v[Lm] = [], v.iKeyMap = {}), S--;
                                }
                                g[em] > 0 && _notifyEvents(Kf, g, Uc.KillSwitch), _ && M >= f && (M = -1, O = 0);
                            }, function() {
                                return {
                                    latency: f,
                                    sendType: S,
                                    sendReason: v
                                };
                            }, !C) : (M = M >= 0 ? Math.min(M, f) : f, O = Math.max(O, v)), _;
                        }
                        function _flushImpl(g, f) {
                            _sendEventsForLatencyAndAbove(1, 0, f), _resetQueueCounts(), _waitForIdleManager(function() {
                                g && g(), q[em] > 0 ? v = _createTimer(function() {
                                    v = null, _flushImpl(q.shift(), f);
                                }, 0) : (v = null, _scheduleTimer());
                            });
                        }
                        function _waitForIdleManager(g) {
                            A[Bm]() ? g() : v = _createTimer(function() {
                                v = null, _waitForIdleManager(g);
                            }, Vf);
                        }
                        function _resetTransmitProfiles() {
                            _clearScheduledTimer(), _initializeProfiles(), Y = yp, _scheduleTimer();
                        }
                        function _initializeProfiles() {
                            (J = {})[yp] = [
                                2,
                                1,
                                0
                            ], J[Ep] = [
                                6,
                                3,
                                0
                            ], J[Tp] = [
                                18,
                                9,
                                0
                            ];
                        }
                        function _requeueEvents(f, S) {
                            var v = [], _ = k;
                            N && (_ = L), arrForEach(f, function(f) {
                                f && f[nm]() > 0 && arrForEach(f[rm](), function(f) {
                                    f && (f[gf] && (f[hf] = 4, f[gf] = !1), f[uf] < _ ? (setProcessTelemetryTimings(f, g[tf]), _addEventToQueues(f, !1)) : v[am](f));
                                });
                            }), v[em] > 0 && _notifyEvents(Kf, v, Uc.NonRetryableStatus), N && _releaseAllQueues(2, 2);
                        }
                        function _callNotification(f, S) {
                            var v = B || {}, _ = v[f];
                            if (_) try {
                                _.apply(v, S);
                            } catch (S) {
                                _throwInternal(g.diagLog(), 1, 74, f + " notification failed: " + S);
                            }
                        }
                        function _notifyEvents(g, f) {
                            for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                            f && f[em] > 0 && _callNotification(g, [
                                f
                            ][tm](S));
                        }
                        function _notifyBatchEvents(g, f) {
                            for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                            f && f[em] > 0 && arrForEach(f, function(f) {
                                f && f[nm]() > 0 && _callNotification(g, [
                                    f.events()
                                ][tm](S));
                            });
                        }
                        function _sendingEvent(g, f, S) {
                            g && g[em] > 0 && _callNotification("eventsSendRequest", [
                                f >= 1e3 && f <= 1999 ? f - 1e3 : 0,
                                !0 !== S
                            ]);
                        }
                        function _eventsSentEvent(g, f) {
                            _notifyBatchEvents("eventsSent", g, f), _scheduleTimer();
                        }
                        function _eventsDropped(g, f) {
                            _notifyBatchEvents(Kf, g, f >= 8e3 && f <= 8999 ? f - 8e3 : Uc.Unknown);
                        }
                        function _eventsResponseFail(g) {
                            _notifyBatchEvents(Kf, g, Uc.NonRetryableStatus), _scheduleTimer();
                        }
                        function _otherEvent(g, f) {
                            _notifyBatchEvents(Kf, g, Uc.Unknown), _scheduleTimer();
                        }
                        function _setAutoLimits() {
                            w = V ? 0 : Math.max(Bf * (qf + 1), C / 6);
                        }
                        _initDefaults(), g._getDbgPlgTargets = function() {
                            return [
                                A,
                                f
                            ];
                        }, g[um] = function(v, E, T) {
                            doPerf(E, function() {
                                return "PostChannel:initialize";
                            }, function() {
                                S[um](v, E, T), B = E.getNotifyMgr();
                                try {
                                    F = mergeEvtNamespace(createUniqueNamespace(g[tf]), E.evtNamespace && E.evtNamespace()), g._addHook(onConfigChange(v, function(S) {
                                        var v = S.cfg, T = createProcessTelemetryContext(null, v, E);
                                        f = T.getExtCfg(g[tf], Qf), x = createTimeoutWrapper(f[hm], f[gm]), D = !f[nf] && isChromium(), U = f[rf], _hookWParam(E), C = f[af], _ = f.immediateEventLimit, P = f[sf], k = f.maxEventRetryAttempts, L = f.maxUnloadEventRetryAttempts, V = f[of], _setAutoLimits(), $ = f[lf], j = !!f[cf], H && _removeUnloadHandlers();
                                        var I = v.disablePageUnloadEvents || [];
                                        H = addPageUnloadEventListener(_handleUnloadEvents, I, F), H = addPageHideEventListener(_handleUnloadEvents, I, F) || H, H = addPageShowEventListener(_handleShowEvents, v.disablePageShowEvents, F) || H;
                                    })), A[um](v, g.core, g);
                                } catch (f) {
                                    throw g.setInitialized(!1), f;
                                }
                            }, function() {
                                return {
                                    theConfig: v,
                                    core: E,
                                    extensions: T
                                };
                            });
                        }, g.processTelemetry = function(f, S) {
                            setProcessTelemetryTimings(f, g[tf]), S = S || g._getTelCtx(S);
                            var v = f;
                            j || G || ($ && (v[im] = $), _addEventToQueues(v, !0), N ? _releaseAllQueues(2, 2) : _scheduleTimer()), g.processNext(v, S);
                        }, g.getOfflineSupport = function() {
                            try {
                                var g = A && A[Pm]();
                                if (A) return {
                                    getUrl: function() {
                                        return g ? g.url : null;
                                    },
                                    serialize: _serialize,
                                    batch: _batch,
                                    shouldProcess: function(g) {
                                        return !j;
                                    },
                                    createPayload: function(g) {
                                        return null;
                                    },
                                    createOneDSPayload: function(g) {
                                        if (A[Mm]) return A[Mm](g, D);
                                    }
                                };
                            } catch (g) {}
                            return null;
                        }, g._doTeardown = function(g, f) {
                            _releaseAllQueues(2, 2), G = !0, A.teardown(), _removeUnloadHandlers(), _initDefaults();
                        }, g.setEventQueueLimits = function(g, S) {
                            f[af] = C = isGreaterThanZero(g) ? g : zf, f[sf] = P = isGreaterThanZero(S) ? S : 0, _setAutoLimits();
                            var v = K > g;
                            if (!v && w > 0) for(var _ = 1; !v && _ <= 3; _++){
                                var E = R[_];
                                E && E[Lm] && arrForEach(E[Lm], function(g) {
                                    g && g[nm]() >= w && (v = !0);
                                });
                            }
                            _performAutoFlush(!0, v);
                        }, g.pause = function() {
                            _clearScheduledTimer(), W = !0, A.pause();
                        }, g.resume = function() {
                            W = !1, A.resume(), _scheduleTimer();
                        }, g._loadTransmitProfiles = function(g) {
                            _resetTransmitProfiles(), objForEachKey(g, function(g, f) {
                                var S = f[em];
                                if (S >= 2) {
                                    var v = S > 2 ? f[2] : 0;
                                    if (f[om](0, S - 2), f[1] < 0 && (f[0] = -1), f[1] > 0 && f[0] > 0) {
                                        var _ = f[0] / f[1];
                                        f[0] = Math.ceil(_) * f[1];
                                    }
                                    v >= 0 && f[1] >= 0 && v > f[1] && (v = f[1]), f[am](v), J[g] = f;
                                }
                            });
                        }, g.flush = function(g, f, S) {
                            var _;
                            if (void 0 === g && (g = !0), !W) {
                                if (S = S || 1, g) f || (_ = createPromise(function(g) {
                                    f = g;
                                })), null == v ? (_clearScheduledTimer(), _queueBatches(1, 0, S), v = _createTimer(function() {
                                    v = null, _flushImpl(f, S);
                                }, 0)) : q[am](f);
                                else {
                                    var C = _clearScheduledTimer();
                                    _sendEventsForLatencyAndAbove(1, 1, S), f && f(), C && _scheduleTimer();
                                }
                            }
                            return _;
                        }, g.setMsaAuthTicket = function(g) {
                            A[xm]($p, g);
                        }, g.setAuthPluginHeader = function(g) {
                            A[xm](jp, g);
                        }, g.removeAuthPluginHeader = function() {
                            A.removeHeader(jp);
                        }, g.hasEvents = _hasEvents, g._setTransmitProfile = function(g) {
                            Y !== g && void 0 !== J[g] && (_clearScheduledTimer(), Y = g, _scheduleTimer());
                        }, proxyFunctions(g, function() {
                            return A;
                        }, [
                            "addResponseHandler"
                        ]), g[ef] = function() {
                            I < Gf && (I++, _clearScheduledTimer(), _scheduleTimer());
                        }, g._clearBackOff = function() {
                            I && (I = 0, _clearScheduledTimer(), _scheduleTimer());
                        };
                    }), S;
                }
                return __extendsFn(PostChannel2, g), PostChannel2.__ieDyn = 1, PostChannel2;
            }(Eg), eS = "locale", tS = "ver", iS = "browser", nS = "browserVer", rS = "popSample", aS = "eventFlags", sS = "name", oS = "serviceName", lS = xc({
                UserExt: [
                    0,
                    "user"
                ],
                DeviceExt: [
                    1,
                    "device"
                ],
                TraceExt: [
                    2,
                    "trace"
                ],
                WebExt: [
                    3,
                    "web"
                ],
                AppExt: [
                    4,
                    "app"
                ],
                OSExt: [
                    5,
                    "os"
                ],
                SdkExt: [
                    6,
                    "sdk"
                ],
                IntWebExt: [
                    7,
                    "intweb"
                ],
                UtcExt: [
                    8,
                    "utc"
                ],
                LocExt: [
                    9,
                    "loc"
                ],
                CloudExt: [
                    10,
                    "cloud"
                ],
                DtExt: [
                    11,
                    "dt"
                ]
            }), cS = xc({
                id: [
                    0,
                    "id"
                ],
                ver: [
                    1,
                    tS
                ],
                appName: [
                    2,
                    sS
                ],
                locale: [
                    3,
                    eS
                ],
                expId: [
                    4,
                    "expId"
                ],
                env: [
                    5,
                    "env"
                ]
            }), dS = xc({
                domain: [
                    0,
                    "domain"
                ],
                browser: [
                    1,
                    iS
                ],
                browserVer: [
                    2,
                    nS
                ],
                screenRes: [
                    3,
                    "screenRes"
                ],
                userConsent: [
                    4,
                    "userConsent"
                ],
                consentDetails: [
                    5,
                    "consentDetails"
                ]
            }), uS = xc({
                locale: [
                    0,
                    eS
                ],
                localId: [
                    1,
                    "localId"
                ],
                id: [
                    2,
                    "id"
                ]
            }), hS = xc({
                osName: [
                    0,
                    sS
                ],
                ver: [
                    1,
                    tS
                ]
            }), gS = xc({
                ver: [
                    0,
                    tS
                ],
                seq: [
                    1,
                    "seq"
                ],
                installId: [
                    2,
                    "installId"
                ],
                epoch: [
                    3,
                    "epoch"
                ]
            }), pS = xc({
                msfpc: [
                    0,
                    "msfpc"
                ],
                anid: [
                    1,
                    "anid"
                ],
                serviceName: [
                    2,
                    oS
                ]
            }), mS = xc({
                popSample: [
                    0,
                    rS
                ],
                eventFlags: [
                    1,
                    aS
                ]
            }), fS = xc({
                tz: [
                    0,
                    "tz"
                ]
            }), SS = xc({
                sessionId: [
                    0,
                    "sesId"
                ]
            }), vS = xc({
                localId: [
                    0,
                    "localId"
                ],
                deviceClass: [
                    1,
                    "deviceClass"
                ],
                make: [
                    2,
                    "make"
                ],
                model: [
                    3,
                    "model"
                ]
            }), _S = xc({
                role: [
                    0,
                    "role"
                ],
                roleInstance: [
                    1,
                    "roleInstance"
                ],
                roleVer: [
                    2,
                    "roleVer"
                ]
            }), CS = xc({
                traceId: [
                    0,
                    "traceID"
                ],
                traceName: [
                    1,
                    sS
                ],
                parentId: [
                    2,
                    "parentID"
                ]
            }), yS = xc({
                traceId: [
                    0,
                    "traceId"
                ],
                spanId: [
                    1,
                    "spanId"
                ],
                traceFlags: [
                    2,
                    "traceFlags"
                ]
            });
            function canUseLocalStorage() {
                return void 0 === Xf && (Xf = !!_getVerifiedStorageObject(0)), Xf;
            }
            function _getLocalStorageObject() {
                return canUseLocalStorage() ? _getVerifiedStorageObject(0) : null;
            }
            function _getVerifiedStorageObject(g) {
                var f, S, v = null;
                try {
                    var _ = getGlobal();
                    if (!_) return null;
                    S = new Date, (v = 0 === g ? _.localStorage : _.sessionStorage) && cl(v.setItem) && (v.setItem(S, S), f = v.getItem(S) !== S, v.removeItem(S), f && (v = null));
                } catch (g) {
                    v = null;
                }
                return v;
            }
            function setStorage(g, f, S) {
                var v = _getLocalStorageObject();
                if (null !== v) try {
                    return v.setItem(f, S), !0;
                } catch (f) {
                    Xf = !1, _throwInternal(g, 1, 504, "Browser failed write to local storage. " + f);
                }
                return !1;
            }
            function getStorage(g, f) {
                var S = _getLocalStorageObject();
                if (null !== S) try {
                    return S.getItem(f);
                } catch (f) {
                    Xf = !1, _throwInternal(g, 1, 503, "Browser failed read of local storage. " + f);
                }
                return null;
            }
            function _getId() {
                return this.getId();
            }
            function _setId(g) {
                this.setId(g);
            }
            var ES = function() {
                function Session3() {
                    dynamicProto(Session3, this, function(g) {
                        g.setId = function(f) {
                            g.customId = f;
                        }, g.getId = function() {
                            return ll(g.customId) ? g.customId : g.automaticId;
                        };
                    });
                }
                return Session3._staticInit = void objDefine(Session3.prototype, "id", {
                    g: _getId,
                    s: _setId
                }), Session3;
            }(), TS = "ai_session", IS = function() {
                function SessionManager2(g, f, S) {
                    var v, _, C, E = safeGetLogger(g), T = safeGetCookieMgr(g);
                    dynamicProto(SessionManager2, this, function(g) {
                        var I = onConfigChange(f, function() {
                            C = f, g.config = C;
                        });
                        function _initializeAutomaticSession() {
                            var f = T.get(_());
                            if (f && cl(f.split)) _initializeAutomaticSessionWithData(f);
                            else {
                                var S = getStorage(E, _());
                                S && _initializeAutomaticSessionWithData(S);
                            }
                            g.automaticSession.getId() || _renew();
                        }
                        function _initializeAutomaticSessionWithData(f) {
                            var S = g.automaticSession, v = f.split("|");
                            v.length > 0 && S.setId(v[0]);
                            try {
                                if (v.length > 1) {
                                    var _ = +v[1];
                                    S.acquisitionDate = +new Date(_), S.acquisitionDate = S.acquisitionDate > 0 ? S.acquisitionDate : 0;
                                }
                                if (v.length > 2) {
                                    var C = +v[2];
                                    S.renewalDate = +new Date(C), S.renewalDate = S.renewalDate > 0 ? S.renewalDate : 0;
                                }
                            } catch (g) {
                                _throwInternal(E, 1, 510, "Error parsing ai_session cookie, session will be reset: " + g);
                            }
                            0 === S.renewalDate && _throwInternal(E, 2, 517, "AI session renewal date is 0, session will be reset.");
                        }
                        function _renew() {
                            var f = g.automaticSession, S = (new Date).getTime(), v = g.config.sessionAsGuid;
                            !isUndefined4(v) && v ? gl(v) ? f.setId(createGuid()) : f.setId(createGuid(v)) : f.setId(newId(C.idLength || 22)), f.acquisitionDate = S, f.renewalDate = S, _setCookie(f.getId(), f.acquisitionDate, f.renewalDate), canUseLocalStorage() || _throwInternal(E, 2, 505, "Browser does not support local storage. Session durations will be inaccurate.");
                        }
                        function _setCookie(f, S, C) {
                            var E = S + g.config.sessionExpirationMs, I = C + g.config.sessionRenewalMs, b = new Date, A = [
                                f,
                                S,
                                C
                            ];
                            E < I ? b.setTime(E) : b.setTime(I);
                            var R = g.config.cookieDomain || null;
                            T.set(_(), A.join("|") + ";expires=" + b.toUTCString(), null, R), v = (new Date).getTime();
                        }
                        function _setStorage(g, f, S) {
                            setStorage(E, _(), [
                                g,
                                f,
                                S
                            ].join("|"));
                        }
                        S && S.add(I), _ = function() {
                            return g.config.namePrefix ? TS + g.config.namePrefix : TS;
                        }, g.automaticSession = new ES, g.update = function() {
                            g.automaticSession.getId() || _initializeAutomaticSession();
                            var f = g.automaticSession, S = g.config, _ = (new Date).getTime(), C = _ - f.acquisitionDate > S.sessionExpirationMs, E = _ - f.renewalDate > S.sessionRenewalMs;
                            if (C || E) _renew();
                            else (!v || _ - v > SessionManager2.cookieUpdateInterval) && (f.renewalDate = _, _setCookie(f.getId(), f.acquisitionDate, f.renewalDate));
                        }, g.backup = function() {
                            var f = g.automaticSession;
                            _setStorage(f.getId(), f.acquisitionDate, f.renewalDate);
                        };
                    });
                }
                return SessionManager2.cookieUpdateInterval = 6e4, SessionManager2;
            }(), bS = [
                "AX",
                "EX",
                "SF",
                "CS",
                "CF",
                "CT",
                "CU",
                "DC",
                "DF",
                "H5",
                "HL",
                "WS",
                "WP"
            ];
            function _validateAppExpId(g, f) {
                void 0 === f && (f = bS);
                var S = null;
                if (g) for(var v = g.split(","), _ = 0; _ < v.length; _++)_isValidAppFlightId(v[_], f) && (S ? S += "," + v[_] : S = v[_]);
                return S;
            }
            function _isValidAppFlightId(g, f) {
                if (void 0 === f && (f = bS), !g || g.length < 4) return !1;
                for(var S = !1, v = 256, _ = g.substring(0, 3).toString().toUpperCase(), C = 0; C < f.length; C++)if (f[C] + ":" === _ && g.length <= v) {
                    S = !0;
                    break;
                }
                return S;
            }
            function _getExpId() {
                return this.getExpId();
            }
            var AS = function() {
                function Application2(g, f, S) {
                    var v, _ = null, C = bS.slice(0), E = "Treatments", T = null;
                    dynamicProto(Application2, this, function(I) {
                        if (_populateDefaults(g), hasDocument()) {
                            var b = Hl().documentElement;
                            b && (I.locale = b.lang);
                        }
                        function _getMetaDataFromDOM(g) {
                            var f, S = {}, v = Hl();
                            if (v) {
                                f = v && v.querySelectorAll("meta");
                                for(var _ = 0; _ < f.length; _++){
                                    var C = f[_];
                                    if (C.name) {
                                        if (0 === C.name.toLowerCase().indexOf(g)) S[C.name.replace(g, "")] = C.content;
                                    }
                                }
                            }
                            return S;
                        }
                        function _setAppExpId(g) {
                            g !== _ && (_ = _validateAppExpId(g, C));
                        }
                        function _readExpIdFromCookie() {
                            return _setAppExpId(getCookieValue(v, E)), _;
                        }
                        function _readExpIdFromCoreData(g) {
                            return _setAppExpId(g), _;
                        }
                        function _populateDefaults(g) {
                            var _ = onConfigChange(g, function() {
                                v = f && f.getCookieMgr(), T = g || {}, I.env = T.env || _getMetaDataFromDOM("awa-").env;
                            });
                            S && S.add(_);
                        }
                        I.getExpId = function() {
                            return T.expId ? _readExpIdFromCoreData(T.expId) : _readExpIdFromCookie();
                        };
                    });
                }
                return Application2.validateAppExpId = _validateAppExpId, Application2._staticInit = void objDefine(Application2.prototype, "expId", {
                    g: _getExpId
                }), Application2;
            }(), RS = function() {
                function Cloud2() {}
                return Cloud2;
            }(), PS = function() {
                function Device3() {}
                return Device3;
            }();
            function _getMsfpc2() {
                return this.getMsfpc();
            }
            function _getAnid() {
                return this.getAnid();
            }
            var wS = function() {
                function IntWeb2(g, f, S) {
                    var v;
                    dynamicProto(IntWeb2, this, function(_) {
                        function _populateDefaults(g) {
                            var C = onConfigChange(g, function() {
                                v = f && f.getCookieMgr();
                                var S = g || {};
                                S.serviceName && (_.serviceName = S.serviceName);
                            });
                            S && S.add(C);
                        }
                        _populateDefaults(g), _.getMsfpc = function() {
                            return getCookieValue(v, "MSFPC");
                        }, _.getAnid = function() {
                            return getCookieValue(v, "ANON").slice(0, 34);
                        };
                    });
                }
                var g;
                return IntWeb2._staticInit = (objDefine(g = IntWeb2.prototype, "msfpc", {
                    g: _getMsfpc2
                }), void objDefine(g, "anid", {
                    g: _getAnid
                })), IntWeb2;
            }(), MS = function() {
                function Loc2() {
                    var g = (new Date).getTimezoneOffset(), f = g % 60, S = (g - f) / 60, v = "+";
                    S > 0 && (v = "-"), S = Math.abs(S), f = Math.abs(f), this.tz = v + (S < 10 ? "0" + S : S.toString()) + ":" + (f < 10 ? "0" + f : f.toString());
                }
                return Loc2;
            }(), OS = {
                WIN: /(windows|win32)/i,
                WINRT: / arm;/i,
                WINPHONE: /windows\sphone\s\d+\.\d+/i,
                OSX: /(macintosh|mac os x)/i,
                IOS: /(ipad|iphone|ipod)(?=.*like mac os x)/i,
                LINUX: /(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)/i,
                ANDROID: /android/i,
                CROS: /CrOS/i
            }, DS = {
                5.1: "XP",
                "6.0": "Vista",
                6.1: "7",
                6.2: "8",
                6.3: "8.1",
                "10.0": "10"
            }, NS = "([\\d,.]+)", kS = "([\\d,_,.]+)", LS = "Unknown", FS = [
                {
                    r: OS.WINPHONE,
                    os: "Windows Phone"
                },
                {
                    r: OS.WINRT,
                    os: "Windows RT"
                },
                {
                    r: OS.WIN,
                    os: "Windows"
                },
                {
                    r: OS.IOS,
                    os: "iOS"
                },
                {
                    r: OS.ANDROID,
                    os: "Android"
                },
                {
                    r: OS.LINUX,
                    os: "Linux"
                },
                {
                    r: OS.CROS,
                    os: "Chrome OS"
                },
                {
                    s: "x11",
                    os: "Unix"
                },
                {
                    s: "blackberry",
                    os: "BlackBerry"
                },
                {
                    s: "symbian",
                    os: "Symbian"
                },
                {
                    s: "nokia",
                    os: "Nokia"
                },
                {
                    r: OS.OSX,
                    os: "Mac OS X"
                }
            ];
            function _getOsName(g) {
                for(var f = 0; f < FS.length; f++){
                    var S = FS[f];
                    if (S.r && g.match(S.r)) return S.os;
                    if (S.s && -1 !== g.indexOf(S.s)) return S.os;
                }
                return LS;
            }
            function _getOsVersion(g, f) {
                return "Windows" === f ? _getGenericOsVersion(g, "Windows NT") : "Android" === f ? _getGenericOsVersion(g, f) : "Mac OS X" === f ? _getMacOsxVersion(g) : "iOS" === f ? _getIosVersion(g) : LS;
            }
            function _getGenericOsVersion(g, f) {
                var S = g.match(new RegExp(f + " " + NS));
                return S ? DS[S[1]] ? DS[S[1]] : S[1] : LS;
            }
            function _getMacOsxVersion(g) {
                var f = g.match(new RegExp("Mac OS X " + kS));
                if (f) {
                    var S = f[1].replace(/_/g, ".");
                    if (S) {
                        var v = _getDelimiter(S);
                        return v ? S.split(v)[0] : S;
                    }
                }
                return LS;
            }
            function _getIosVersion(g) {
                var f = g.match(new RegExp("OS " + kS));
                if (f) {
                    var S = f[1].replace(/_/g, ".");
                    if (S) {
                        var v = _getDelimiter(S);
                        return v ? S.split(v)[0] : S;
                    }
                }
                return LS;
            }
            function _getDelimiter(g) {
                return g.indexOf(".") > -1 ? "." : g.indexOf("_") > -1 ? "_" : null;
            }
            var xS = function() {
                function OperatingSystem2(g, f) {
                    var S = this, v = null, _ = null, C = null, E = null, _setSysName = function(g) {
                        C = g;
                    }, _setSysVer = function(g) {
                        E = g;
                    }, _getSysName = function() {
                        return C || v;
                    }, _getSysVer = function() {
                        return E || _;
                    }, T = onConfigChange(g, function() {
                        if ((g || {}).populateOperatingSystemInfo) {
                            var f = Wl() || {}, S = g.userAgent || f.userAgent || "", C = (g.userAgentData || {}).platform || (f.userAgentData || {}).platform;
                            if (S) {
                                var E = _getOsName(S.toLowerCase());
                                v = E, _ = _getOsVersion(S, E);
                            }
                            v && v !== LS || !ll(C) || (v = C);
                        }
                    });
                    f && f.add(T), objDefine(S, "name", {
                        s: _setSysName,
                        g: _getSysName
                    }), objDefine(S, "ver", {
                        s: _setSysVer,
                        g: _getSysVer
                    });
                }
                return OperatingSystem2;
            }(), US = "MicrosoftApplicationsTelemetryDeviceId";
            function _saveData(g, f, S, v) {
                f ? f.setProperty(S, v) : g.set(S, v, 31536e3);
            }
            function _getData(g, f, S) {
                return f ? f.getProperty(S) || "" : getCookieValue(g, S);
            }
            var VS = function() {
                function Sdk2(g, f, S) {
                    var v, _ = 0;
                    dynamicProto(Sdk2, this, function(C) {
                        C.seq = _, C.epoch = random32(!1).toString(), C.getSequenceId = function() {
                            return ++_;
                        };
                        var E = onConfigChange(g, function(g) {
                            v = f && f.getCookieMgr();
                            var S = g.cfg.propertyStorageOverride;
                            if (v.isEnabled() || S) {
                                var _ = _getData(v, S, US);
                                _ || (_ = newGuid2()), _saveData(v, S, US, _), C.installId = _;
                            } else v.purge(US);
                        });
                        S && S.add(E);
                    });
                }
                return Sdk2.__ieDyn = 1, Sdk2;
            }(), BS = function() {
                function Trace2(g, f, S, v, _) {
                    var C = this;
                    C.traceId = f || generateW3CId();
                    var E = onConfigChange(g, function() {
                        var f = g;
                        if (f.enableDistributedTracing && !S && (S = generateW3CId().substring(0, 16)), C.parentId = C.parentId || S, f.enableApplicationInsightsTrace && !v) {
                            var _ = getLocation();
                            _ && _.pathname && (v = _.pathname);
                        }
                        C.name = C.name || v;
                    });
                    _ && _.add(E);
                }
                return Trace2;
            }(), HS = "setLocalId";
            function _getLocalId() {
                return this.getLocalId();
            }
            function _setLocalId(g) {
                this[HS](g);
            }
            var $S = function() {
                function User2(g, f, S, v) {
                    var _, C, E;
                    dynamicProto(User2, this, function(T) {
                        if (_populateDefaults(f), "undefined" != typeof navigator) {
                            var I = navigator;
                            T.locale = I.userLanguage || I.language;
                        }
                        function _populateMuidFromCookie() {
                            if (!_.hashIdentifiers && !_.dropIdentifiers) {
                                var g = getCookieValue(E, "MUID");
                                g && (C = "t:" + g);
                            }
                            return C;
                        }
                        function _populateDefaults(f) {
                            var I = onConfigChange(f, function() {
                                if (E = S && S.getCookieMgr(), _ = f, C = null, E && E.isEnabled() && (_populateMuidFromCookie(), _.enableApplicationInsightsUser)) {
                                    var v = getCookieValue(E, User2.userCookieName);
                                    if (v) {
                                        var I = v.split(User2.cookieSeparator);
                                        I.length > 0 && (T.id = I[0]);
                                    }
                                    if (!T.id) {
                                        T.id = newId(g && !isUndefined4(g.idLength) ? g.idLength : 22);
                                        var b = toISOString(new Date);
                                        T.accountAcquisitionDate = b;
                                        var A = [
                                            T.id,
                                            b
                                        ], R = _.cookieDomain ? _.cookieDomain : void 0;
                                        E.set(User2.userCookieName, A.join(User2.cookieSeparator), 31536e3, R);
                                    }
                                }
                            });
                            v && v.add(I);
                        }
                        T.getLocalId = function() {
                            return C || _populateMuidFromCookie();
                        }, T[HS] = function(g) {
                            C = g;
                        };
                    });
                }
                return User2.cookieSeparator = "|", User2.userCookieName = "ai_user", User2._staticInit = void objDefine(User2.prototype, "localId", {
                    g: _getLocalId,
                    s: _setLocalId
                }), User2;
            }(), jS = 1048576, GS = 2097152, qS = 4194304, WS = function() {
                function Utc2(g, f) {
                    var S = this;
                    S.popSample = 100;
                    var v = onConfigChange(g, function() {
                        S.eventFlags = 0, g.hashIdentifiers && (S.eventFlags = S.eventFlags | jS), g.dropIdentifiers && (S.eventFlags = S.eventFlags | GS), g.scrubIpOnly && (S.eventFlags = S.eventFlags | qS);
                    });
                    f && f.add(v);
                }
                return Utc2;
            }(), zS = [
                "Required",
                "Analytics",
                "SocialMedia",
                "Advertising"
            ], KS = "([\\d,.]+)", JS = "Unknown", YS = "Edg/", QS = [
                {
                    ua: "OPR/",
                    b: "Opera"
                },
                {
                    ua: "PhantomJS",
                    b: "PhantomJS"
                },
                {
                    ua: "Edge",
                    b: "Edge"
                },
                {
                    ua: YS,
                    b: "Edge"
                },
                {
                    ua: "Electron",
                    b: "Electron"
                },
                {
                    ua: "Chrome",
                    b: "Chrome"
                },
                {
                    ua: "Trident",
                    b: "MSIE"
                },
                {
                    ua: "MSIE ",
                    b: "MSIE"
                },
                {
                    ua: "Firefox",
                    b: "Firefox"
                },
                {
                    ua: "Safari",
                    b: "Safari"
                },
                {
                    ua: "SkypeShell",
                    b: "SkypeShell"
                }
            ], XS = [
                {
                    br: "Microsoft Edge",
                    b: "Edge"
                },
                {
                    br: "Google Chrome",
                    b: "Chrome"
                },
                {
                    br: "Opera",
                    b: "Opera"
                }
            ];
            function _userAgentContainsString(g, f) {
                return f.indexOf(g) > -1;
            }
            function _getBrandVersion(g, f) {
                for(var S = 0; S < f.length; S++)if (g == f[S].brand) return f[S].version;
                return null;
            }
            function _getBrowserName(g) {
                if (g) for(var f = 0; f < QS.length; f++){
                    if (_userAgentContainsString(QS[f].ua, g)) return QS[f].b;
                }
                return JS;
            }
            function _getBrowserVersion(g, f) {
                return "MSIE" === f ? _getIeVersion(g) : _getOtherVersion(f, g);
            }
            function _getIeVersion(g) {
                var f = g.match(new RegExp("MSIE " + KS));
                if (f) return f[1];
                var S = g.match(new RegExp("rv:" + KS));
                return S ? S[1] : void 0;
            }
            function _getOtherVersion(g, f) {
                "Safari" === g ? g = "Version" : "Edge" === g && _userAgentContainsString(YS, f) && (g = "Edg");
                var S = f.match(new RegExp(g + "/" + KS));
                return S || "Opera" === g && (S = f.match(new RegExp("OPR/" + KS))) ? S[1] : JS;
            }
            function _getScreenResolution() {
                var g = {
                    h: 0,
                    w: 0
                }, f = $l();
                return f && f.screen && (g.h = screen.height, g.w = screen.width), g;
            }
            function _getUserConsent() {
                return this.getUserConsent();
            }
            var ZS = function() {
                function Web2(g, f, S) {
                    var v = safeGetCookieMgr(f), _ = g || {}, C = null, E = null, T = null, I = null, b = null, A = null, R = null;
                    dynamicProto(Web2, this, function(f) {
                        _populateDefaults(g);
                        var P = getLocation();
                        if (P) {
                            var w = P.hostname;
                            w && (f.domain = "file:" === P.protocol ? "local" : w);
                        }
                        var M = _getScreenResolution();
                        function _parseUserAgent(g, f) {
                            if (dl(f)) try {
                                for(var S = 0; S < XS.length; S++){
                                    var v = _getBrandVersion(XS[S].br, f);
                                    if (v) return b = XS[S].b, void (A = v);
                                }
                            } catch (g) {}
                            if (g) {
                                var _ = _getBrowserName(g);
                                b = _, A = _getBrowserVersion(g, _);
                            }
                        }
                        function _setBrowser(g) {
                            T = g;
                        }
                        function _setBrowserVer(g) {
                            I = g;
                        }
                        function _getBrowser() {
                            return T || b;
                        }
                        function _getBrowserVer() {
                            return I || A;
                        }
                        f.screenRes = M.w + "X" + M.h, f.getUserConsent = function() {
                            return _.userConsented || !!getCookieValue(v, _.userConsentCookieName || "MSCC");
                        }, f.getUserConsentDetails = function() {
                            var g = null;
                            try {
                                var f = _.callback;
                                if (f && f.userConsentDetails) {
                                    var S = f.userConsentDetails();
                                    if (S) {
                                        g = _.disableConsentDetailsSanitize ? S : {};
                                        for(var v = 0; v < zS.length; v++){
                                            var C = zS[v];
                                            g[C] = S[C] || !1;
                                        }
                                    }
                                }
                                return null !== R && ((g = g || {}).GPC_DataSharingOptIn = !!R), g ? JSON.stringify(g) : null;
                            } catch (g) {}
                        };
                        var _getGpcDataSharing = function() {
                            return R;
                        }, _setGpcDataSharing = function(g) {
                            R = gl(g) ? g : null, _.gpcDataSharingOptIn = R;
                        };
                        function _populateDefaults(g) {
                            var f = onConfigChange(g, function() {
                                if ((_ = g).populateBrowserInfo) {
                                    var f = _.userAgent, S = (_.userAgentData || {}).brands;
                                    if (f !== C || S !== E) {
                                        if (!f || !S || 0 === S.length) {
                                            var v = Wl();
                                            v && (f = f || v.userAgent || "", S = S || (v.userAgentData || {}).brands);
                                        }
                                        _parseUserAgent(f, S), C = f, E = S;
                                    }
                                }
                                R = gl(_.gpcDataSharingOptIn) ? _.gpcDataSharingOptIn : null;
                            });
                            S && S.add(f);
                        }
                        objDefineProps(f, {
                            userConsent: {
                                g: f.getUserConsent
                            },
                            browser: {
                                s: _setBrowser,
                                g: _getBrowser
                            },
                            browserVer: {
                                s: _setBrowserVer,
                                g: _getBrowserVer
                            },
                            gpcDataSharingOptIn: {
                                g: _getGpcDataSharing,
                                s: _setGpcDataSharing
                            }
                        });
                    });
                }
                return Web2._staticInit = void objDefine(Web2.prototype, "userConsent", {
                    g: _getUserConsent
                }), Web2;
            }();
            function _applyExtValues(g, f, S, v, _) {
                var C = f.ext[lS[g]];
                if (C) try {
                    objForEachKey(v, function(g, f) {
                        if (ll(f) || hl(f) || gl(f)) {
                            var v = C[S[g]];
                            !_ && (v || ll(v) || hl(v) || gl(v)) && (f = v), C[S[g]] = f;
                        }
                    });
                } catch (g) {}
                return C;
            }
            var ev, tv = function() {
                function TelemetryContext4(g, f, S, v) {
                    dynamicProto(TelemetryContext4, this, function(_) {
                        _.app = new AS(f, S, v), _.cloud = new RS, _.user = new $S(g, f, S, v), _.os = new xS(f, v), _.web = new ZS(f, S, v);
                        var C = new VS(g, S, v), E = new wS(f, S, v), T = new WS(f, v);
                        _.loc = new MS, _.device = new PS;
                        var I = new IS(S, f, v);
                        _.session = new ES;
                        var b = void 0, A = createDistributedTraceContextFromTraceCtx(new BS(f, b, b, b, v), _getTraceCtx()), R = !(f || {}).eventContainExtFields;
                        function _getSessionId() {
                            var g = _.session;
                            if (g && ll(g.customId)) return g.customId;
                            I.update();
                            var f = I.automaticSession;
                            if (f) {
                                var S = f.getId();
                                S && ll(S) && (g.automaticId = S);
                            }
                            return g.automaticId;
                        }
                        function _getTraceCtx() {
                            var g = A;
                            return S && S.getTraceCtx && (g = S.getTraceCtx(!1) || A), g;
                        }
                        _.getTraceCtx = function() {
                            return A;
                        }, _.getSessionId = _getSessionId, _.applyApplicationContext = function(g) {
                            var f, S = _.app;
                            _applyExtValues(4, g, cS, ((f = {})[0] = S.id, f[1] = S.ver, f[2] = S.name, f[3] = S.locale, f[4] = S.getExpId(), f[5] = S.env, f), R);
                        }, _.applyUserContext = function(g) {
                            var f, S = _.user;
                            _applyExtValues(0, g, uS, ((f = {})[1] = S.getLocalId(), f[0] = S.locale, f[2] = S.id, f), R);
                        }, _.applyWebContext = function(g) {
                            var f, S = _.web;
                            _applyExtValues(3, g, dS, ((f = {})[0] = S.domain, f[1] = S.browser, f[2] = S.browserVer, f[3] = S.screenRes, f[5] = S.getUserConsentDetails(), f[4] = S.getUserConsent(), f), R);
                        }, _.applyOsContext = function(g) {
                            var f, S = _.os;
                            _applyExtValues(5, g, hS, ((f = {})[0] = S.name, f[1] = S.ver, f), R);
                        }, _.applySdkContext = function(g) {
                            var f;
                            _applyExtValues(6, g, gS, ((f = {})[2] = C.installId, f[1] = C.getSequenceId(), f[3] = C.epoch, f), R);
                        }, _.applyIntWebContext = function(g) {
                            var f;
                            _applyExtValues(7, g, pS, ((f = {})[0] = E.getMsfpc(), f[1] = E.getAnid(), f[2] = E.serviceName, f), R);
                        }, _.applyUtcContext = function(g) {
                            var f, S = ((f = {})[0] = T.popSample, f);
                            T.eventFlags > 0 && (S[1] = T.eventFlags), _applyExtValues(8, g, mS, S, R);
                        }, _.applyLocContext = function(g) {
                            var f;
                            _applyExtValues(9, g, fS, ((f = {})[0] = _.loc.tz, f), R);
                        }, _.applySessionContext = function(g) {
                            var f;
                            _applyExtValues(4, g, SS, ((f = {})[0] = _getSessionId(), f), R);
                        }, _.applyDeviceContext = function(g) {
                            var f, S = _.device;
                            _applyExtValues(1, g, vS, ((f = {})[0] = S.localId, f[2] = S.make, f[3] = S.model, f[1] = S.deviceClass, f), R);
                        }, _.applyCloudContext = function(g) {
                            var f, S = _.cloud;
                            _applyExtValues(10, g, _S, ((f = {})[0] = S.role, f[1] = S.roleInstance, f[2] = S.roleVer, f), R);
                        }, _.applyAITraceContext = function(g) {
                            var S;
                            if (f.enableApplicationInsightsTrace) {
                                var v = _getTraceCtx();
                                v && _applyExtValues(2, g, CS, ((S = {})[0] = v.getTraceId(), S[1] = v.getName(), S[2] = v.getSpanId(), S), !1);
                            }
                        }, _.applyDistributedTraceContext = function(g) {
                            var f, S = _getTraceCtx();
                            if (S) {
                                var v = ((f = {})[0] = S.getTraceId(), f[1] = S.getSpanId(), f), _ = S.getTraceFlags();
                                isNullOrUndefined(_) || (v[2] = _), _applyExtValues(11, g, yS, v, !1);
                            }
                        };
                    });
                }
                return TelemetryContext4.__ieDyn = 1, TelemetryContext4;
            }();
            function createDistributedTraceContextFromTraceCtx(g, f) {
                var S = g || {};
                return {
                    getName: function() {
                        return S.name;
                    },
                    setName: function(g) {
                        f && f.setName(g), S.name = g;
                    },
                    getTraceId: function() {
                        return S.traceId;
                    },
                    setTraceId: function(g) {
                        f && f.setTraceId(g), isValidTraceId(g) && (S.traceId = g);
                    },
                    getSpanId: function() {
                        return S.parentId;
                    },
                    setSpanId: function(g) {
                        f && f.setSpanId(g), isValidSpanId(g) && (S.parentId = g);
                    },
                    getTraceFlags: function() {
                        return S.traceFlags;
                    },
                    setTraceFlags: function(g) {
                        f && f.setTraceFlags(g), S.traceFlags = g;
                    }
                };
            }
            var iv = [
                lS[4],
                lS[0],
                lS[3],
                lS[5],
                lS[6],
                lS[7],
                lS[8],
                lS[9],
                lS[1],
                lS[2],
                lS[11],
                lS[10]
            ], nv = objDeepFreeze({
                populateBrowserInfo: !1,
                populateOperatingSystemInfo: !1,
                userAgent: cfgDfString(),
                userAgentData: cfgDfMerge({
                    brands: ev,
                    mobile: ev,
                    platform: ev
                }),
                userConsentCookieName: cfgDfString(),
                userConsented: !1,
                serviceName: cfgDfString(),
                env: cfgDfString(),
                expId: cfgDfString(),
                sessionRenewalMs: 18e5,
                sessionExpirationMs: 864e5,
                sessionAsGuid: null,
                cookieDomain: cfgDfString(),
                namePrefix: cfgDfString(),
                enableApplicationInsightsTrace: !1,
                enableApplicationInsightsUser: !1,
                hashIdentifiers: !1,
                dropIdentifiers: !1,
                scrubIpOnly: !1,
                callback: cfgDfMerge({
                    userConsentDetails: null
                }),
                gpcDataSharingOptIn: ev,
                idLength: 22,
                enableDistributedTracing: !1,
                eventContainExtFields: !1
            }), rv = function(g) {
                function PropertiesPlugin2() {
                    var f, S, v, _ = g.call(this) || this;
                    return _.identifier = "SystemPropertiesCollector", _.priority = 3, _.version = "4.2.1", dynamicProto(PropertiesPlugin2, _, function(g, _) {
                        function _initDefaults() {
                            f = null, S = {};
                        }
                        function _populateDefaults(S) {
                            var _ = g.identifier, C = g.core;
                            g._addHook(onConfigChange(S, function() {
                                var g = createProcessTelemetryContext(null, S, C);
                                v = g.getExtCfg(_, nv);
                            })), f = new tv(S, v, C, g._unloadHooks), C && C.setTraceCtx && C.setTraceCtx(f.getTraceCtx());
                        }
                        function _addPropertiesIfAbsent(g, f) {
                            g && objForEachKey(g, function(g, S) {
                                f[g] || (f[g] = S);
                            });
                        }
                        _initDefaults(), g.initialize = function(g, f, S) {
                            _.initialize(g, f, S), _populateDefaults(g);
                        }, g.processTelemetry = function(_, C) {
                            setProcessTelemetryTimings(_, g.identifier), C = g._getTelCtx(C);
                            var E = _.ext = _.ext ? _.ext : {};
                            _.data = _.data ? _.data : {}, arrForEach(iv, function(g) {
                                E[g] = E[g] || {};
                            }), f && (f.applyUtcContext(_), f.applyApplicationContext(_), f.applyUserContext(_), f.applyWebContext(_), f.applyOsContext(_), f.applySdkContext(_), f.applyIntWebContext(_), f.applyLocContext(_), f.applySessionContext(_), f.applyDeviceContext(_), v.enableApplicationInsightsTrace && f.applyAITraceContext(_), v.enableDistributedTracing && f.applyDistributedTraceContext(_), f.applyCloudContext(_)), arrForEach(Il(E), function(g) {
                                0 === Il(E[g]).length && delete E[g];
                            }), _addPropertiesIfAbsent(S, _.data), g.processNext(_, C);
                        }, g.getPropertiesContext = function() {
                            return f;
                        }, g.setProperty = function(g, f) {
                            S[g] = f;
                        }, g._doTeardown = function(g, S) {
                            var v = (g || {}).core();
                            if (v && v.getTraceCtx && f) {
                                var _ = v.getTraceCtx(!1);
                                _ && _ === f.getTraceCtx() && v.setTraceCtx(null);
                            }
                            _initDefaults();
                        }, g._getDbgPlgTargets = function() {
                            return [
                                v
                            ];
                        };
                    }), _;
                }
                return __extendsFn(PropertiesPlugin2, g), PropertiesPlugin2.__ieDyn = 1, PropertiesPlugin2;
            }(Eg), av = function() {
                function BaseContext2(g) {
                    this._setOverride = function(f, S) {
                        g.setOverride(f, S);
                    }, this._getOverride = function(f) {
                        return g.getOverride(f);
                    };
                }
                return BaseContext2;
            }(), sv = function(g) {
                function ApplicationContext2(f, S, v) {
                    var _ = g.call(this, f) || this, C = _;
                    C.setId = function(g) {
                        C._setOverride(cS.id, g);
                    }, C.getId = function() {
                        return C._getOverride(cS.id);
                    }, C.setVer = function(g) {
                        C._setOverride(cS.ver, g);
                    }, C.getVer = function() {
                        return C._getOverride(cS.ver);
                    }, C.setName = function(g) {
                        C._setOverride(cS.appName, g);
                    }, C.getName = function() {
                        return C._getOverride(cS.appName);
                    }, C.setLocale = function(g) {
                        C._setOverride(cS.locale, g);
                    }, C.getLocale = function() {
                        return C._getOverride(cS.locale);
                    }, C.setEnv = function(g) {
                        C._setOverride(cS.env, g);
                    }, C.getEnv = function() {
                        return C._getOverride(cS.env);
                    }, C.setExpId = function(g) {
                        C._setOverride(cS.expId, AS.validateAppExpId(g));
                    }, C.getExpId = function() {
                        return C._getOverride(cS.expId);
                    };
                    var E = onConfigChange(S, function() {
                        S && (isUndefined4(S.env) || C.setEnv(S.env), isNullOrUndefined(S.expId) || C.setExpId(S.expId));
                    });
                    return v && v.add(E), _;
                }
                return __extendsFn(ApplicationContext2, g), ApplicationContext2;
            }(av), ov = function(g) {
                function CloudContext2(f) {
                    var S = g.call(this, f) || this, v = S;
                    return v.setRole = function(g) {
                        v._setOverride(_S.role, g);
                    }, v.getRole = function() {
                        return v._getOverride(_S.role);
                    }, v.setRoleInstance = function(g) {
                        v._setOverride(_S.roleInstance, g);
                    }, v.getRoleInstance = function() {
                        return v._getOverride(_S.roleInstance);
                    }, v.setRoleVer = function(g) {
                        v._setOverride(_S.roleVer, g);
                    }, v.getRoleVer = function() {
                        return v._getOverride(_S.roleVer);
                    }, S;
                }
                return __extendsFn(CloudContext2, g), CloudContext2;
            }(av), lv = function(g) {
                function DataContext2(f) {
                    var S = g.call(this, f) || this, v = S;
                    return v.setProperty = function(g, f) {
                        v._setOverride(g, f);
                    }, v.getProperty = function(g) {
                        return v._getOverride(g);
                    }, S;
                }
                return __extendsFn(DataContext2, g), DataContext2;
            }(av), cv = function(g) {
                function DeviceContext2(f) {
                    var S = g.call(this, f) || this, v = S;
                    return v.setLocalId = function(g) {
                        v._setOverride(vS.localId, g);
                    }, v.getLocalId = function() {
                        return v._getOverride(vS.localId);
                    }, v.setDeviceClass = function(g) {
                        v._setOverride(vS.deviceClass, g);
                    }, v.getDeviceClass = function() {
                        return v._getOverride(vS.deviceClass);
                    }, v.setMake = function(g) {
                        v._setOverride(vS.make, g);
                    }, v.getMake = function() {
                        return v._getOverride(vS.make);
                    }, v.setModel = function(g) {
                        v._setOverride(vS.model, g);
                    }, v.getModel = function() {
                        return v._getOverride(vS.model);
                    }, S;
                }
                return __extendsFn(DeviceContext2, g), DeviceContext2;
            }(av), dv = function(g) {
                function LocContext2(f) {
                    var S = g.call(this, f) || this, v = S;
                    return v.setTz = function(g) {
                        v._setOverride(fS.tz, g);
                    }, v.getTz = function() {
                        return v._getOverride(fS.tz);
                    }, S;
                }
                return __extendsFn(LocContext2, g), LocContext2;
            }(av), uv = function(g) {
                function OperatingSystemContext2(f, S, v) {
                    var _ = g.call(this, f) || this, C = _, E = null;
                    C.setOsName = function(g) {
                        C._setOverride(hS.osName, g);
                    }, C.getOsName = function() {
                        return C._getOverride(hS.osName);
                    }, C.setVer = function(g) {
                        C._setOverride(hS.ver, g);
                    }, C.getVer = function() {
                        return C._getOverride(hS.ver);
                    };
                    var T = onConfigChange(S, function() {
                        !E && S.userAgent && S.populateOperatingSystemInfo && (E = new xS(S, v)), E && (C.setOsName(E.name), C.setVer(E.ver));
                    });
                    return v && v.add(T), _;
                }
                return __extendsFn(OperatingSystemContext2, g), OperatingSystemContext2;
            }(av);
            function _getEventRoot(g, f) {
                if (g) for(var S = 0; S < f.length; S++){
                    var v = f[S];
                    isNullOrUndefined(g[v]) && (g[v] = {}), g = g[v];
                }
                return g;
            }
            function _setOverride(g, f, S) {
                if (g && f) {
                    var v = f.split("."), _ = v[v.length - 1];
                    v.length > 1 && (g = _getEventRoot(g, v.slice(0, -1))), isNullOrUndefined(S) ? isUndefined4(g[_]) || delete g[_] : g[_] = S;
                }
            }
            var hv, gv, pv = function() {
                function OverrideContainer2(g) {
                    var f = this, S = [];
                    f.setOverride = function(g, f) {
                        g && S.push({
                            key: g,
                            value: f
                        });
                    }, f.hasOverride = function(g) {
                        var f = !1;
                        return arrForEach(S, function(S) {
                            S.key === g && (f = !0);
                        }), f;
                    }, f.getOverride = function(g) {
                        var f;
                        return arrForEach(S, function(S) {
                            S.key === g && (f = S.value);
                        }), f;
                    }, f.applyOverrides = function(f, v) {
                        if (S.length > 0) try {
                            var _ = _getEventRoot(f, g);
                            arrForEach(S, function(g) {
                                _setOverride(_, g.key, g.value);
                            });
                        } catch (g) {}
                    };
                }
                return OverrideContainer2;
            }(), mv = function(g) {
                function UserContext2(f) {
                    var S = g.call(this, f) || this, v = S;
                    return v.setLocalId = function(g) {
                        v._setOverride(uS.localId, g);
                    }, v.getLocalId = function() {
                        return v._getOverride(uS.localId);
                    }, v.setLocale = function(g) {
                        v._setOverride(uS.locale, g);
                    }, v.getLocale = function() {
                        return v._getOverride(uS.locale);
                    }, v.setId = function(g) {
                        v._setOverride(uS.id, g);
                    }, v.getId = function() {
                        return v._getOverride(uS.id);
                    }, S;
                }
                return __extendsFn(UserContext2, g), UserContext2;
            }(av), fv = function(g) {
                function WebContext2(f, S, v) {
                    var _ = g.call(this, f) || this, C = _;
                    C.setDomain = function(g) {
                        C._setOverride(dS.domain, g);
                    }, C.getDomain = function() {
                        return C._getOverride(dS.domain);
                    }, C.setBrowser = function(g) {
                        C._setOverride(dS.browser, g);
                    }, C.getBrowser = function() {
                        return C._getOverride(dS.browser);
                    }, C.setBrowserVer = function(g) {
                        C._setOverride(dS.browserVer, g);
                    }, C.getBrowserVer = function() {
                        return C._getOverride(dS.browserVer);
                    }, C.setScreenRes = function(g) {
                        C._setOverride(dS.screenRes, g);
                    }, C.getScreenRes = function() {
                        return C._getOverride(dS.screenRes);
                    }, C.setUserConsent = function(g) {
                        C._setOverride(dS.userConsent, g);
                    }, C.getUserContext = function() {
                        return C._getOverride(dS.userConsent);
                    };
                    var E = onConfigChange(S, function() {
                        S && (isUndefined4(S.userConsented) || C.setUserConsent(S.userConsented));
                    });
                    return v && v.add(E), _;
                }
                return __extendsFn(WebContext2, g), WebContext2;
            }(av), Sv = "ext", vv = "data", _v = function() {
                function OverrideContext2(g, f, S, v) {
                    var _ = this, C = {};
                    function _getContainer(g) {
                        for(var f = "", S = 0; S < g.length; S++)f && (f += "_"), f += g[S];
                        return isUndefined4(C[f]) && (C[f] = new pv(g)), f ? C[f] : null;
                    }
                    _.data = new lv(_getContainer([
                        vv
                    ])), _.app = new sv(_getContainer([
                        Sv,
                        lS.AppExt
                    ]), f, v), _.user = new mv(_getContainer([
                        Sv,
                        lS.UserExt
                    ])), _.os = new uv(_getContainer([
                        Sv,
                        lS.OSExt
                    ]), f, v), _.web = new fv(_getContainer([
                        Sv,
                        lS.WebExt
                    ]), f, v), _.device = new cv(_getContainer([
                        Sv,
                        lS.DeviceExt
                    ])), _.loc = new dv(_getContainer([
                        Sv,
                        lS.LocExt
                    ])), _.cloud = new ov(_getContainer([
                        Sv,
                        lS.CloudExt
                    ])), _.applyOverrides = function(g, f) {
                        var S = Il(C);
                        S && S.length > 0 && arrForEach(S, function(S) {
                            C[S].applyOverrides(g, f);
                        });
                    };
                }
                return OverrideContext2;
            }(), Cv = void 0, yv = objDeepFreeze({
                env: Cv,
                expId: Cv,
                populateOperatingSystemInfo: !1,
                userAgent: Cv,
                userAgentData: cfgDfMerge({
                    brands: Cv,
                    mobile: Cv,
                    platform: Cv
                }),
                userConsented: Cv
            }), Ev = "OverridePropertiesPlugin", Tv = function(g) {
                function OverridePropertiesPlugin2() {
                    var f = g.call(this) || this;
                    f.identifier = Ev, f.priority = 4, f.version = "4.2.1";
                    var S = null;
                    return dynamicProto(OverridePropertiesPlugin2, f, function(g, v) {
                        g.initialize = function(f, S, _) {
                            v.initialize(f, S, _), g._baseInit(f, S, _);
                        }, g.processTelemetry = function(S, v) {
                            setProcessTelemetryTimings(S, f.identifier), v = g._getTelCtx(v);
                            var _ = g.getOverrideContext();
                            _ && _.applyOverrides(S, v), g.processNext(S, v);
                        }, g._baseInit = function(v, _, C) {
                            S = new _v(v, f._getTelCtx().getExtCfg(f.identifier, yv), _, g._unloadHooks);
                        }, g.setProperty = function(g, f) {
                            S && S.data.setProperty(g, f);
                        }, g.getOverrideContext = function() {
                            return S;
                        };
                    }), f;
                }
                return __extendsFn(OverridePropertiesPlugin2, g), OverridePropertiesPlugin2.__ieDyn = 1, OverridePropertiesPlugin2;
            }(Eg), Iv = "_dropInst", bv = [
                "channelConfiguration",
                "propertyStorageOverride"
            ];
            function _fixupExtensionConfig(g) {
                if (g && dl(g.extensionConfig)) {
                    var f = g.extensionConfig, S = {};
                    objForEachKey(f, function(g, f) {
                        cl(f) || sc(g, "Symbol(") || (S[g] = f);
                    }), g.extensionConfig = S;
                }
                return g;
            }
            function _copyObjProperties(g, f) {
                if (f) for(var S = Il(f), v = 0; v < S.length; v++){
                    var _ = S[v];
                    fl(g, _) || sc(_, "Symbol(") || (g[_] = f[_]);
                }
            }
            function _proxyReadonlyProperty(g, f, S) {
                var v;
                return objDefine(g, f, {
                    g: function() {
                        return isPrimitive(S) ? S : (dl(S) ? (dl(v) || (v = []), v.length = S.length) : isObject3(v) || (v = {}), objForEachKey(S, function(g, f) {
                            sc(g, "Symbol(") || _proxyReadonlyProperty(v, g, f);
                        }), v);
                    }
                });
            }
            function _isChannel(g) {
                return g.pause && g.teardown && g.flush;
            }
            function _getEndpointUrl(g, f) {
                var S = null;
                if (f) {
                    f.endpointUrl && (S = f.endpointUrl);
                    var v = (f.extensionConfig || {})[g] || {};
                    v.overrideEndpointUrl && (S = v.overrideEndpointUrl);
                }
                return S;
            }
            var Av = objDeepFreeze({
                cookieCfg: {},
                channelConfiguration: cfgDfMerge({}),
                propertyConfiguration: cfgDfMerge({}),
                extensions: {
                    rdOnly: !0,
                    ref: !0,
                    v: [],
                    blkVal: !0
                },
                channels: {
                    rdOnly: !0,
                    ref: !0,
                    v: [],
                    blkVal: !0
                },
                extensionConfig: cfgDfMerge({}),
                createPerfMgr: gv,
                loggingLevelConsole: 0
            }), Rv = objDeepFreeze({
                propertyConfiguration: cfgDfMerge({}),
                cookieCfg: cfgDfMerge({}),
                extensions: {
                    rdOnly: !0,
                    ref: !0,
                    v: [],
                    blkVal: !0
                },
                channels: {
                    rdOnly: !0,
                    ref: !0,
                    v: [],
                    blkVal: !0
                },
                extensionConfig: cfgDfMerge((hv = {}, hv[Ev] = cfgDfMerge({}), hv)),
                createPerfMgr: gv,
                loggingLevelConsole: 0
            }), Pv = function(g) {
                function ChildNotificationManager2(f, S) {
                    var v = g.call(this) || this;
                    return dynamicProto(ChildNotificationManager2, v, function(g, v) {
                        function _getEvents(g) {
                            var S = [];
                            return g && arrForEach(g, function(g) {
                                g.iKey === f && S.push(g);
                            }), S;
                        }
                        function _hasListeners(f) {
                            if (g[f] && g.listeners) for(var S = 0; S < g.listeners.length; S++){
                                var v = g.listeners[S];
                                if (v && v[f]) return !0;
                            }
                            return !1;
                        }
                        var _ = {
                            eventsSent: function(f) {
                                if (_hasListeners("eventsSent")) {
                                    var S = _getEvents(f);
                                    S.length > 0 && g.eventsSent(S);
                                }
                            },
                            eventsDiscarded: function(f, S) {
                                if (_hasListeners("eventsDiscarded")) {
                                    var v = _getEvents(f);
                                    v.length > 0 && g.eventsDiscarded(v, S);
                                }
                            },
                            eventsSendRequest: function(f, S) {
                                _hasListeners("eventsSendRequest") && g.eventsSendRequest(f, S);
                            },
                            perfEvent: function(f) {
                                _hasListeners("perfEvent") && g.perfEvent(f);
                            }
                        };
                        S.addNotificationListener(_);
                    }), v;
                }
                return __extendsFn(ChildNotificationManager2, g), ChildNotificationManager2.__ieDyn = 1, ChildNotificationManager2;
            }(rg), wv = function() {
                function ApplicationInsightsManager2() {
                    var g, f, S, v, _, C, E, T, I, b, A, R, P, w, M = null, O = null;
                    dynamicProto(ApplicationInsightsManager2, this, function(D) {
                        function _initDefaults() {
                            g = createDynamicConfig({}, Av, null), f = [], S = null, v = null, _ = [], C = [], E = {}, T = null, I = null, b = null, R = null, P = null, w = !1, g.cfg.loggingLevelConsole = 1, A = new $h(g.cfg), objDefine(D, "sharedConfig", {
                                g: function() {
                                    return w && _initializeSharedInstance(), g.cfg;
                                }
                            });
                        }
                        function _registerPlugin(f, S) {
                            var v;
                            if (void 0 === S && (S = null), f) {
                                (_isChannel(f) ? C : _).push(f);
                                var E = f.identifier, T = g.cfg.extensionConfig;
                                g.setDf(T, ((v = {})[E] = {
                                    ref: !0,
                                    v: S || {}
                                }, v));
                            }
                            return f;
                        }
                        function _initializeSharedChannels() {
                            var f = g.cfg, S = f.channels, v = new Zf, _ = v.identifier, C = !1;
                            I = null, b = null, arrForEach(S, function(g) {
                                C || arrForEach(g, function(g) {
                                    if (!cl(g) && (_registerPlugin(g), g.identifier === _)) return I = g, C = !0, -1;
                                });
                            }), C || (I = _registerPlugin(v, f.channelConfiguration), S.length > 0 ? arrAppend(S[0], I) : f.channels.push([
                                I
                            ]));
                        }
                        function _initializeSharedExtensions(S) {
                            var v = g.cfg;
                            f = [], T = _registerPlugin(new rv, v.propertyConfiguration), f.push(T), v.extensions && arrForEach(v.extensions, function(g) {
                                cl(g) || _registerPlugin(g);
                            }), S && arrForEach(S, function(g) {
                                g && !cl(g) && f.push(_registerPlugin(g));
                            });
                        }
                        function _initializeSharedInstance() {
                            S || (w || _throwInternal(D.diagLog(), 2, 520, "The Shared Manager is not yet created, the returned shared instance will be overwritten"), g.cfg.instrumentationKey = g.cfg.instrumentationKey || "_not_defined_", v = new rg, (S = new Mv(D, D.diagLog(), v)).initialize(g.cfg, f), S.isInitialized() && (objDefineProps((g = getDynamicConfigHandler(S.config)).cfg, {
                                channelConfiguration: {
                                    g: function() {
                                        return g.cfg.extensionConfig[I.identifier];
                                    }
                                },
                                propertyConfiguration: {
                                    g: function() {
                                        return g.cfg.extensionConfig[T.identifier];
                                    }
                                }
                            }), I && (b = _getEndpointUrl(I.identifier, g.cfg))), M && S.setCookieMgr(M));
                        }
                        function _createInstanceConfig(f, S) {
                            var v = [], _ = g.cfg, C = {};
                            if (objForEachKey(_.extensionConfig, function(g, f) {
                                g === I.identifier || g === T.identifier || sc(g, "Symbol(") || (g !== Ev ? _proxyReadonlyProperty(C, g, f) : (C[g] = {}, _copyObjProperties(C[g], f)));
                            }), S) {
                                S.extensions && S.extensions.length > 0 && (v = arrAppend(v, S.extensions));
                                var E = S.extensionConfig;
                                E && (fl(E, I.identifier) && Il(E).length > 0 && _throwInternal(D.diagLog(), 2, 511, "Instances cannot override the shared Post channel configuration, the shared will be used!"), _copyObjProperties(C, E));
                            }
                            var b = {
                                instrumentationKey: f,
                                channels: _createMergedChannels(S),
                                extensions: v,
                                extensionConfig: C
                            };
                            return _copyObjProperties(b, S), b;
                        }
                        function _createMergedChannels(f) {
                            var S = g.cfg, v = [
                                []
                            ];
                            return S.channels && arrForEach(S.channels, function(g, f) {
                                cl(g) || (v[f] = v[f] || [], v[f] = v[f].concat(g));
                            }), f && f.channels && arrForEach(f.channels, function(g, f) {
                                cl(g) || (v[f] = v[f] || [], v[f] = v[f].concat(g));
                            }), v;
                        }
                        function _createMergedExtensions(g) {
                            var S = [];
                            return f && f.length > 0 && (S = S.concat(f)), g && g.length > 0 && (S = S.concat(g)), S;
                        }
                        function _unloadInstance(g, f, S, v) {
                            var _ = E[g];
                            _ && (_.inst && _.inst.isInitialized() ? _.inst.unload(f, function(f) {
                                S && S(g, f);
                            }, v) : S && S(g, {
                                reason: 50,
                                isAsync: f,
                                flushComplete: !1
                            }));
                        }
                        _initDefaults(), D.diagLog = function() {
                            return A || (A = new $h(g.cfg)), A;
                        }, D.getCookieMgr = function() {
                            return _initializeSharedInstance(), M || S.getCookieMgr();
                        }, D.setCookieMgr = function(g) {
                            M = g, S && S.setCookieMgr(g);
                        }, D.getPerfMgr = function() {
                            return P || g && g.cfg.enablePerfMgr && (P = O || new dg(D.getNotifyMgr())), P;
                        }, D.setPerfMgr = function(g) {
                            O = g, P = g;
                        }, D.create = function(f, v) {
                            w ? _throwInternal(D.diagLog(), 2, 514, "Shared Manager has already been initialized.") : (g = createDynamicConfig(_fixupExtensionConfig(f ? objExtend({}, f) : {}), Av, null), S = null, _initializeSharedChannels(), _initializeSharedExtensions(v), w = !0);
                        }, D.getInst = function(g) {
                            return (E[g] || {}).inst;
                        }, D.newInst = function(f, _, C) {
                            var T = D.getInst(f);
                            if (T) return _throwInternal(D.diagLog(), 2, 514, "Instance already exists for [" + f + "]"), T;
                            if (_initializeSharedInstance(), S.isInitialized()) {
                                var A = _createInstanceConfig(f, _);
                                if (I) {
                                    var R = _getEndpointUrl(I.identifier, A);
                                    b && R && b !== R && _throwInternal(D.diagLog(), 2, 511, "The endpointUrl mismatch, shared Url [" + b + "] is different from configured [" + R + "] shared will be used!");
                                }
                                var P = new Pv(f, v);
                                if (T = new Mv(D, D.diagLog(), P), E[f] = {
                                    iKey: f,
                                    inst: T,
                                    notifyMgr: P
                                }, T.setPerfMgr(D.getPerfMgr()), T.initialize(A, _createMergedExtensions(C)), T.isInitialized()) {
                                    var w = T.config;
                                    objDefineProps(w, {
                                        propertyConfiguration: {
                                            g: function() {
                                                return w.extensionConfig[Ev];
                                            }
                                        }
                                    });
                                    try {
                                        delete w.endpointUrl, delete w.channelConfiguration, delete w.propertyStorageOverride;
                                    } catch (g) {
                                        _throwInternal(D.diagLog(), 2, 108, "Failed to remove unused defaults!");
                                    }
                                    objForEachKey(g.cfg, function(g, f) {
                                        fl(w, g) || sc(g, "Symbol(") || Yl(bv, g) || _proxyReadonlyProperty(w, g, f);
                                    });
                                } else _throwInternal(D.diagLog(), 2, 520, "Failed to initialize new instance!"), T = null, delete E[f];
                            }
                            return T;
                        }, D.getSharedPlugin = function(g) {
                            _initializeSharedInstance();
                            var f = null, v = S.getPlugin(g);
                            return v && (f = v.plugin), f;
                        }, D.getPropertyManager = function() {
                            return _initializeSharedInstance(), T;
                        }, D.getPostChannel = function() {
                            return _initializeSharedInstance(), I;
                        }, D.getNotifyMgr = function() {
                            return R || (R = new rg), R;
                        }, D.unload = function(g, f, v) {
                            var _, C = Il(E), T = C.length + 1, I = {
                                reason: 50,
                                isAsync: g,
                                flushComplete: !1
                            };
                            function _doUnload(g, S) {
                                0 === --T && (_initDefaults(), f && f(S));
                            }
                            return g && !f && (_ = createPromise(function(g) {
                                f = g;
                            })), S && (arrForEach(C, function(f) {
                                _unloadInstance(f, g, function(g, f) {
                                    _doUnload(g, f);
                                }, v);
                            }), S.isInitialized() && (S.unload(g, function(g) {
                                _doUnload(null, I = g);
                            }, v), S = null)), _doUnload(null, I), _;
                        }, D.addUnloadHook = function(g) {
                            _initializeSharedInstance(), S.addUnloadHook(g);
                        }, D.addSharedPlugin = function(g, f, v, _) {
                            return _initializeSharedInstance(), S.addPlugin(g, f, v, _);
                        }, D.updateCfg = function(g, f) {
                            return _initializeSharedInstance(), S.updateCfg(g, f);
                        }, D.evtNamespace = function() {
                            return _initializeSharedInstance(), S.evtNamespace();
                        }, D.addUnloadCb = function(g) {
                            _initializeSharedInstance(), S.addUnloadCb(g);
                        }, D.onCfgChange = function(g) {
                            return _initializeSharedInstance(), S.onCfgChange(g);
                        }, D[Iv] = function(g) {
                            g && E.iKey && delete E[g];
                        };
                    });
                }
                return ApplicationInsightsManager2.__ieDyn = 1, ApplicationInsightsManager2;
            }(), Mv = function(g) {
                function ApplicationInsights3(f, S, v) {
                    var _, C = g.call(this) || this, E = f;
                    return dynamicProto(ApplicationInsights3, C, function(g, f) {
                        g.getSharedPropertyManager = function() {
                            return E.getPropertyManager();
                        }, g.getSharedPostChannel = function() {
                            return E.getPostChannel();
                        }, g.getOverridePropertyManager = function() {
                            return _;
                        }, g.initialize = function(C, E) {
                            doPerf(g, function() {
                                return "ApplicationInsights:initialize";
                            }, function() {
                                var T = [
                                    _ = new Tv
                                ];
                                E && (T = T.concat(E));
                                var I = C.propertyConfiguration || {};
                                if (C.propertyConfiguration) try {
                                    delete C.propertyConfiguration;
                                } catch (g) {
                                    C.propertyConfiguration = {};
                                }
                                C.extensionConfig = C.extensionConfig || {}, C.extensionConfig[_.identifier] = I, C = createDynamicConfig(C, Rv, S || g.logger, !1).cfg;
                                try {
                                    f.initialize(C, T, S, v);
                                } catch (f) {
                                    _throwInternal(g.logger, 1, 514, "Failed to initialize SDK." + dumpObj(f));
                                }
                            }, function() {
                                return {
                                    config: C,
                                    extensions: E
                                };
                            });
                        }, g.unload = function(S, v, _) {
                            return E[Iv] && E[Iv]((g.config || {}).instrumentationKey), f.unload(S, v, _);
                        };
                    }), C;
                }
                return __extendsFn(ApplicationInsights3, g), ApplicationInsights3.__ieDyn = 1, ApplicationInsights3;
            }(vp), Ov = class {
                getSeed() {
                    const g = localStorage.getItem(this.key), f = parseInt(g);
                    return isNaN(f) ? void 0 : f;
                }
                saveSeed(g) {
                    localStorage.setItem(this.key, g.toString());
                }
                static localStorageAvailable() {
                    try {
                        const g = window.localStorage, f = "someKey", S = "someValue";
                        return g.setItem(f, S), g.removeItem(f), !0;
                    } catch (g) {
                        return !1;
                    }
                }
                constructor(g){
                    this.key = g.config.bwSeedOptions.localStorageKey || "bwSeed";
                    const f = localStorage.getItem(this.key);
                    parseInt(f) || localStorage.setItem(this.key, g.config.bwSeedOptions.constValue.toString());
                }
            }, Dv = class _BandwidthMemoryStorage {
                getSeed() {
                    return _BandwidthMemoryStorage.value;
                }
                saveSeed(g) {
                    _BandwidthMemoryStorage.value = g;
                }
                constructor(g){
                    var _BandwidthMemoryStorage_value;
                    (_BandwidthMemoryStorage_value = _BandwidthMemoryStorage.value) !== null && _BandwidthMemoryStorage_value !== void 0 ? _BandwidthMemoryStorage_value : _BandwidthMemoryStorage.value = g.config.bwSeedOptions.constValue;
                }
            }, Nv = class {
                addValue(g) {}
                getAggregated() {
                    return this.value;
                }
                constructor(g){
                    this.value = g;
                }
            }, kv = class {
                addValue(g) {
                    this.value = g;
                }
                getAggregated() {
                    return this.value;
                }
            }, Lv = class {
                clear() {
                    this.items = [];
                }
                constructor(g){
                    this.size = g, this.items = [];
                }
            }, Fv = class extends Lv {
                get isFull() {
                    return this.items.length >= this.size;
                }
                add(g) {
                    return this.isFull && this.items.shift(), this.items.push(g), !0;
                }
            }, xv = class extends Lv {
                add(g) {
                    return !(this.items.length >= this.size) && (this.items.push(g), !0);
                }
            }, Uv = class {
                addValue(g) {
                    this.values.add(g);
                }
                getAggregated() {
                    return Math.floor(average(this.values.items));
                }
                constructor(g){
                    this.values = new Fv(g);
                }
            }, Vv = class {
                get avg() {
                    return 0 !== this.duration ? this.total / this.duration : 0;
                }
                get maxSample() {
                    return this.max;
                }
                get minNonZeroSample() {
                    return this.minNonZero;
                }
                captureSample(g) {
                    (g || 0 === g) && (this.total += g, this.duration++, this.max = Math.max(g, this.max), 0 !== g && (this.minNonZero = Math.min(g, this.minNonZero)));
                }
                constructor(){
                    this.total = 0, this.duration = 0, this.max = 0, this.minNonZero = Number.MAX_SAFE_INTEGER;
                }
            }, Bv = class {
                get min() {
                    const g = Object.keys(this.sampleCounts).map(Number).filter((g)=>g > 0);
                    return g.length > 0 ? Math.min(...g) : 0;
                }
                get max() {
                    const g = Object.keys(this.sampleCounts).map(Number);
                    return g.length > 0 ? Math.max(...g) : 0;
                }
                get mode() {
                    const g = Object.keys(this.sampleCounts).map(Number);
                    return g.length > 0 ? g.reduce((g, f)=>this.sampleCounts[f] > this.sampleCounts[g] ? f : g, g[0]) : 0;
                }
                captureSample(g) {
                    var f;
                    if (void 0 !== g) {
                        const S = `${g}`;
                        var _S;
                        (_S = (f = this.sampleCounts)[S]) !== null && _S !== void 0 ? _S : f[S] = 0, this.sampleCounts[S]++;
                    }
                }
                constructor(){
                    this.sampleCounts = {};
                }
            }, Hv = class {
                get delta() {
                    if (void 0 !== this.cur && void 0 !== this.last) return this.cur - this.last;
                }
                captureSample(g, f) {
                    void 0 !== g && (void 0 !== this.cur && (this.last = this.cur), this.cur = g);
                }
            }, $v = class {
                get delta() {
                    if (void 0 !== this.currentSample && void 0 !== this.prevSample) {
                        let g = 1;
                        return void 0 !== this.currentTimestamp && void 0 !== this.prevTimestamp && (g = (this.currentTimestamp - this.prevTimestamp) / 1e3), g && round((this.currentSample - this.prevSample) / g, this.precision);
                    }
                }
                captureSample(g, f) {
                    if (this.currentTimestamp !== f) {
                        if (void 0 === g) return this.prevSample = void 0, this.currentSample = void 0, this.prevTimestamp = void 0, void (this.currentTimestamp = void 0);
                        void 0 !== this.currentSample && (this.prevSample = this.currentSample), this.prevTimestamp = this.currentTimestamp, this.currentTimestamp = f, this.currentSample = g;
                    }
                }
                constructor(g = 0){
                    this.precision = g;
                }
            }, jv = class {
                get elapsed() {
                    return round((Date.now() - this.startTime) / 1e3, 0);
                }
                constructor(){
                    this.startTime = Date.now();
                }
            }, Gv = class {
                get active() {
                    return !!this.current;
                }
                get ongoingDuration() {
                    var _this_current;
                    return ((_this_current = this.current) === null || _this_current === void 0 ? void 0 : _this_current.elapsed) || 0;
                }
                get avgDuration() {
                    return this.averager.avg;
                }
                get longestDuration() {
                    return this.averager.maxSample;
                }
                get numEvents() {
                    return this.eventCount;
                }
                get totalDuration() {
                    return this.current ? this.totalActiveDuration + this.current.elapsed : this.totalActiveDuration;
                }
                get timestamps() {
                    return deepClone(this.timestampBuckets);
                }
                get counts() {
                    return deepClone(this.countBuckets);
                }
                set active(g) {
                    if (!this.current && g) this.current = new jv;
                    else if (this.current && !g) {
                        const g = this.current.elapsed;
                        this.averager.captureSample(g), this.totalActiveDuration += g;
                        for (const f of Object.keys(Gt.HISTOGRAM_BATCH))if (g <= Gt.HISTOGRAM_BATCH[f]) {
                            this.countBuckets[f]++, this.timestampBuckets[f].push(this.current.startTime);
                            break;
                        }
                        this.eventCount++, this.current = void 0;
                    }
                }
                constructor(){
                    this.eventCount = 0, this.totalActiveDuration = 0, this.countBuckets = {
                        seconds1to3: 0,
                        seconds3to5: 0,
                        seconds5to8: 0,
                        seconds8to15: 0,
                        seconds15to60: 0,
                        seconds60toMax: 0
                    }, this.timestampBuckets = {
                        seconds1to3: [],
                        seconds3to5: [],
                        seconds5to8: [],
                        seconds8to15: [],
                        seconds15to60: [],
                        seconds60toMax: []
                    }, this.averager = new Vv;
                }
            }, qv = class {
                get durations() {
                    return deepClone(this.sampleDurations);
                }
                get sortedDurations() {
                    return Object.keys(this.sampleDurations).sort((g, f)=>this.sampleDurations[f] - this.sampleDurations[g]);
                }
                get durationRatios() {
                    const g = {};
                    let f = 0;
                    for(const g in this.sampleDurations)f += this.sampleDurations[g];
                    for(const S in this.sampleDurations)g[S] = round(this.sampleDurations[S] / f * 100);
                    return g;
                }
                get changeCount() {
                    return this.sampleChangeCount;
                }
                captureSample(g) {
                    this.sampleDurations[g] || (this.sampleDurations[g] = 0), this.sampleDurations[g]++, g !== this.lastSample && (this.sampleChangeCount++, this.lastSample = g);
                }
                constructor(){
                    this.sampleChangeCount = 0, this.sampleDurations = {};
                }
            }, Wv = class {
                captureSample(g) {
                    const f = Date.now();
                    if (g > 0 && this.lastSampleTimestamp > 0) {
                        const S = f - this.lastSampleTimestamp;
                        if (this.lastSampleTimestamp = f, S < 0 || S > this.validTimeBetweenFramesArrival || g > this.invalidFPSAboveMax) return;
                        const v = S / g;
                        this.fpsHarmonicSumWeigtsTs += S, this.fpsHarmonicWeigtedSumsFramePerDelayTs += S * v;
                    }
                    (this.lastSampleTimestamp < 0 || 0 === g) && (this.lastSampleTimestamp = f);
                }
                get harmonicMean() {
                    return this.fpsHarmonicWeigtedSumsFramePerDelayTs > 0 ? 1e3 * this.fpsHarmonicSumWeigtsTs / this.fpsHarmonicWeigtedSumsFramePerDelayTs : 0;
                }
                constructor(g, f){
                    this.validTimeBetweenFramesArrival = g, this.invalidFPSAboveMax = f, this.lastSampleTimestamp = -1, this.fpsHarmonicSumWeigtsTs = 0, this.fpsHarmonicWeigtedSumsFramePerDelayTs = 0;
                }
            }, zv = class {
                isReportComplete() {
                    return this.samples.length === this.samplesNum;
                }
                getReport() {
                    return this.lastReport;
                }
                captureSample(g) {
                    void 0 === g || g < 0 || (arrayLimitedPush2(this.samples, g, this.samplesNum), this.sortedSamples = deepClone(this.samples).sort((g, f)=>g - f), this.lastReport = {
                        avg: this.getAvg(),
                        median: this.calculatePercentile(50),
                        p90: this.calculatePercentile(90),
                        max: this.calculatePercentile(100),
                        volatilityPercent: this.getVolatility()
                    });
                }
                getAvg() {
                    return average(this.samples);
                }
                getVolatility() {
                    const g = this.getAvg();
                    if (0 === g) return 0;
                    let f = 0;
                    this.samples.forEach((S)=>{
                        f += Math.abs(S - g);
                    });
                    return round(f / this.samples.length * 100 / g, 2);
                }
                calculatePercentile(g) {
                    if (g < 0 || g > 100) throw new Error("Percentile must be between 0 and 100");
                    const f = g / 100 * (this.sortedSamples.length - 1), S = Math.floor(f), v = Math.ceil(f), _ = f - S;
                    return v >= this.sortedSamples.length ? this.sortedSamples[S] : this.sortedSamples[S] * (1 - _) + this.sortedSamples[v] * _;
                }
                constructor(g){
                    this.samplesNum = g, this.samples = [], this.sortedSamples = [], this.lastReport = {
                        avg: -1,
                        max: -1,
                        median: -1,
                        p90: -1,
                        volatilityPercent: -1
                    };
                }
            }, Kv = class {
                captureSample(g) {
                    !g || g.avg < 0 || (this.reportAggr = {
                        avg: this.reportAggr.avg + g.avg,
                        max: Math.max(this.reportAggr.max, g.max),
                        median: this.reportAggr.median + g.median,
                        p90: this.reportAggr.p90 + g.p90,
                        volatilityPercent: this.reportAggr.volatilityPercent + g.volatilityPercent
                    }, this.duration++);
                }
                getReport() {
                    if (0 !== this.duration) return {
                        avg: this.reportAggr.avg / this.duration,
                        max: this.reportAggr.max,
                        median: this.reportAggr.median / this.duration,
                        p90: this.reportAggr.p90 / this.duration,
                        volatilityPercent: this.reportAggr.volatilityPercent / this.duration
                    };
                }
                constructor(){
                    this.duration = 0, this.reportAggr = {
                        avg: 0,
                        max: 0,
                        median: 0,
                        p90: 0,
                        volatilityPercent: 0
                    };
                }
            }, Jv = class {
                get isOvershooting() {
                    return !!this.current;
                }
                get events() {
                    return this.current ? [
                        ...this.past,
                        this.current
                    ] : this.past;
                }
                get totalDuration() {
                    return this.totalOvershootDuration;
                }
                captureSample(g, f) {
                    const S = round(g - f);
                    S > this.allowedOvershoot && (0 === this.lastAllowed || f === this.lastAllowed || !this.current && f > this.lastAllowed) ? (this.totalOvershootDuration++, this.current ? (this.current.min = Math.min(this.current.min, S), this.current.max = Math.max(this.current.max, S)) : this.current = {
                        timestamp: Date.now(),
                        min: S,
                        max: S,
                        type: this.overshootType
                    }) : this.current && (this.current.duration = Date.now() - this.current.timestamp, this.past.push(this.current), this.current = void 0), this.lastAllowed = f;
                }
                constructor(g, f = 0){
                    this.overshootType = g, this.allowedOvershoot = f, this.past = [], this.totalOvershootDuration = 0, this.lastAllowed = 0;
                }
            }, Yv = class {
                calculate(g, f) {
                    if (void 0 === g || void 0 === f) return;
                    const S = g - this.prevReceived, v = f - this.prevLost;
                    if (S + v < this.minPackets) return;
                    this.prevReceived = g, this.prevLost = f;
                    const _ = v * (this.disableNormalization ? 1 : this.minPackets) / (v + S);
                    return _ > (this.disableNormalization ? 1 : this.minPackets) ? 0 : _;
                }
                constructor(g = !1){
                    this.disableNormalization = g, this.prevLost = 0, this.prevReceived = 0, this.minPackets = 100;
                }
            }, Qv = class {
                captureSample(g) {
                    g && this.capturedSamples.push(g);
                }
                calculateStd() {
                    if (!this.capturedSamples.length) return;
                    const g = this.capturedSamples.reduce((g, f)=>g + f, 0) / this.capturedSamples.length, f = this.capturedSamples.map((f)=>(f - g) ** 2), S = f.reduce((g, f)=>g + f, 0) / f.length;
                    return round(Math.sqrt(S), 2);
                }
                getFirst() {
                    return this.capturedSamples[0];
                }
                getLast() {
                    if (this.capturedSamples.length) return this.capturedSamples[this.capturedSamples.length - 1];
                }
                calculatePercentile(g) {
                    if (!this.capturedSamples.length) return;
                    const f = this.capturedSamples.sort((g, f)=>g - f), S = (f.length - 1) * g, v = Math.floor(S), _ = S - v;
                    return void 0 !== f[v + 1] ? f[v] + _ * (f[v + 1] - f[v]) : f[v];
                }
                constructor(){
                    this.capturedSamples = [];
                }
            };
            function isPowerEfficient(g) {
                if (!g) return;
                const f = [
                    "libvpx",
                    "ffmpeg"
                ];
                let S = !0;
                for (const v of f)if (g.toLowerCase().includes(v)) {
                    S = !1;
                    break;
                }
                return S;
            }
            var Xv = class {
                captureSample(g) {
                    void 0 !== g && arrayLimitedPush2(this.capturedSamples, g, this.samplesCount);
                }
                getRate() {
                    if (!this.capturedSamples.length) return;
                    const g = this.samplesCount / this.capturedSamples.length;
                    return this.capturedSamples.reduce((g, f)=>g + f) * g / this.samplesCount;
                }
                constructor(g){
                    this.samplesCount = g, this.capturedSamples = [];
                }
            }, Zv = class {
                captureSample(g, f) {
                    g === this.curWidth && f === this.curHeight || (arrayLimitedPush2(this.resolutionSwitches, `${g}x${f}`, this.limit), this.curWidth = g, this.curHeight = f);
                }
                get switches() {
                    if (this.resolutionSwitches.length) return this.resolutionSwitches;
                }
                constructor(g = 5){
                    this.limit = g, this.curWidth = 0, this.curHeight = 0, this.resolutionSwitches = [];
                }
            };
            function calcMacroblockRate(g, f, S) {
                return g && f ? Math.ceil(g / Gt.MACROBLOCK_SIZE) * Math.ceil(f / Gt.MACROBLOCK_SIZE) * S : 0;
            }
            var e_ = class {
                captureSample(g, f) {
                    this.macroblockRateAveragerReceived.captureSample(g), this.macroblockRateAveragerDecoded.captureSample(f);
                    let S = this.maxDecoderLoss;
                    g && (S = (g - f) / g * 100), this.decoderLoss = S, this.maxDecoderLoss = Math.max(S, this.maxDecoderLoss);
                }
                getReport() {
                    return {
                        macroblockRateReceivedMax: this.macroblockRateAveragerReceived.maxSample,
                        macroblockRateReceivedAvg: this.macroblockRateAveragerReceived.avg,
                        macroblockRateDecodedMax: this.macroblockRateAveragerDecoded.maxSample,
                        macroblockRateDecodedAvg: this.macroblockRateAveragerDecoded.avg,
                        macroblockRateMaxDecoderLossPercent: Math.floor(this.maxDecoderLoss),
                        macroblockRateDecoderLossPercent: Math.floor(this.decoderLoss)
                    };
                }
                constructor(){
                    this.macroblockRateAveragerReceived = new Vv, this.macroblockRateAveragerDecoded = new Vv, this.maxDecoderLoss = 0, this.decoderLoss = 0;
                }
            }, t_ = class {
                captureSample(g, f) {
                    var S, v;
                    const _ = g.split("/").pop();
                    var _f, __;
                    return void 0 === this.activeMsi || this.activeMsi !== f ? (this.activeMsi = f, this.previousCodec = _, void ((_f = (S = this.codecReport)[f]) !== null && _f !== void 0 ? _f : S[f] = {
                        [_]: 1,
                        codecSwitchCounter: 0
                    })) : this.previousCodec !== _ ? ((__ = (v = this.codecReport[f])[_]) !== null && __ !== void 0 ? __ : v[_] = 0, this.codecReport[f][_]++, this.codecReport[f].codecSwitchCounter++, void (this.previousCodec = _)) : void this.codecReport[f][_]++;
                }
                get report() {
                    return this.codecReport;
                }
                constructor(){
                    this.codecReport = {};
                }
            }, i_ = class {
                addValue(g) {
                    this.bandwidthAverager.captureSample(g);
                }
                getAggregated() {
                    return Math.floor(this.bandwidthAverager.avg);
                }
                constructor(){
                    this.bandwidthAverager = new Vv;
                }
            }, n_ = -1, r_ = class {
                getSeed() {
                    var _this_storage_getSeed;
                    const g = (_this_storage_getSeed = this.storage.getSeed()) !== null && _this_storage_getSeed !== void 0 ? _this_storage_getSeed : n_;
                    return this.cappingValue > 0 ? Math.min(Math.max(g, this.minValue), this.cappingValue) : Math.max(g, this.minValue);
                }
                saveSeed(g) {
                    this.aggregator.addValue(g);
                    const f = this.aggregator.getAggregated();
                    this.storage.saveSeed(f);
                }
                getAggregator() {
                    switch(this.configProvider.config.bwSeedOptions.aggregation){
                        case "avg":
                            return this.configProvider.config.bwSeedOptions.aggregateLastN > 0 ? new Uv(this.configProvider.config.bwSeedOptions.aggregateLastN) : new i_;
                        case "last":
                            return new kv;
                        default:
                            return new Nv(this.configProvider.config.bwSeedOptions.constValue);
                    }
                }
                getStorage() {
                    return this.configProvider.config.bwSeedOptions.useLocalStorage && Ov.localStorageAvailable() ? new Ov(this.configProvider) : new Dv(this.configProvider);
                }
                constructor(g){
                    var _this_configProvider_config_bwSeedOptions_minValue;
                    this.configProvider = g, this.aggregator = this.getAggregator(), this.storage = this.getStorage(), this.cappingValue = this.configProvider.config.bwSeedOptions.cappingValue, this.minValue = (_this_configProvider_config_bwSeedOptions_minValue = this.configProvider.config.bwSeedOptions.minValue) !== null && _this_configProvider_config_bwSeedOptions_minValue !== void 0 ? _this_configProvider_config_bwSeedOptions_minValue : n_;
                }
            }, a_ = P;
            function adjustResolutionToAspectRatio(g, f) {
                const S = g.width / g.height, v = (0, a_.clone)(g);
                return S > f ? v.width = Math.floor(g.height * f) : S < f && (v.height = Math.floor(g.width / f)), v;
            }
            var s_ = class _ConstraintsObject {
                clone() {
                    const g = deepClone(this.video), f = deepClone(this.audio);
                    return new _ConstraintsObject(f, g, this.withTimeout, this.withEffect, this.withOverridenStream);
                }
                constructor(g, f, S = !0, v = !1, _){
                    this.audio = g, this.video = f, this.withTimeout = S, this.withEffect = v, this.withOverridenStream = _;
                }
            }, o_ = class {
                dispose() {}
                updateVideoConstraints(g, f, S) {
                    const v = this.calculateConstraints(f, S);
                    this.logger.safe.info(`Calculated constraints: ${JSON.stringify(v)} from capabilities: ${JSON.stringify(f)}`);
                    const _ = v.resolution, C = v.fps, E = _ && (!isInRange(_.width, g.video.minWidth, g.video.maxWidth) || !isInRange(_.height, g.video.minHeight, g.video.maxHeight)), T = g.video.fps !== C;
                    if (!E && !T) return g;
                    const I = g.clone();
                    return E && this.setResolution(I, _), T && (I.video.fps = C), I;
                }
                updateResolution(g, f) {
                    const S = g.clone();
                    return this.setResolution(S, f), S;
                }
                setResolution(g, f) {
                    g.video.maxWidth = f.width, g.video.minWidth = f.width, g.video.maxHeight = f.height, g.video.minHeight = f.height;
                }
                getKey(g) {
                    return g.video ? isEmpty(g.video) ? "video" : g.video.deviceId && g.video.minWidth && g.video.minHeight ? `${g.video.deviceId}x${g.video.minWidth}x${g.video.minHeight}` : g.video.minWidth && g.video.minHeight ? `${g.video.minWidth}x${g.video.minHeight}` : g.video.deviceId ? `${g.video.deviceId}` : (this.logger.safe.error(`Cannot create key for constraints: ${scrubConstraints(g)}`), "") : "audio";
                }
                convertConstraints(g, f = {}) {
                    if (!g) return null;
                    const S = deepClone(f);
                    return (g === null || g === void 0 ? void 0 : g.deviceId) && (S.deviceId = g.deviceId), S;
                }
                constructor(g){
                    this.logger = g;
                }
            }, l_ = class {
                getResolutionTable(g, f) {
                    const S = this.constraintToMaxResolution(g, f);
                    return this.generateResolutionTable(S);
                }
                constraintToMaxResolution(g, f) {
                    const S = this.getPortraitOrLandscapeMaxResolution(g), v = adjustResolutionToAspectRatio({
                        width: g.width,
                        height: g.height
                    }, f), _ = S.width / v.width, C = S.height / v.height, E = Math.min(_, C);
                    return this.resizeResolution(v, E);
                }
                resizeResolution(g, f) {
                    return {
                        width: Math.round(g.width * f),
                        height: Math.round(g.height * f)
                    };
                }
                getPortraitOrLandscapeMaxResolution(g) {
                    return g.width > g.height ? {
                        width: this.MAX_SHARING_WIDTH,
                        height: this.MAX_SHARING_HEIGHT
                    } : {
                        width: this.MAX_SHARING_HEIGHT,
                        height: this.MAX_SHARING_WIDTH
                    };
                }
                ceilToMackroblockSize(g) {
                    const f = g.width, S = g.height;
                    return {
                        width: Math.ceil(f / Gt.MACROBLOCK_SIZE) * Gt.MACROBLOCK_SIZE,
                        height: Math.ceil(S / Gt.MACROBLOCK_SIZE) * Gt.MACROBLOCK_SIZE
                    };
                }
                generateResolutionTable(g) {
                    return [
                        1,
                        2 / 3,
                        1 / 3,
                        1 / 6
                    ].map((f)=>this.resizeResolution(g, f)).map((g)=>this.ceilToMackroblockSize(g));
                }
                constructor(){
                    this.MAX_SHARING_WIDTH = 1920, this.MAX_SHARING_HEIGHT = 1080;
                }
            }, c_ = class {
                calculateConstraints(g, f) {
                    this.initialAspectRatio || (this.initialAspectRatio = f.width / f.height);
                    const S = this.resolutionTableCalculator.getResolutionTable(f, this.initialAspectRatio);
                    let v = {
                        resolution: S[S.length - 1],
                        fps: this.FPS_TABLE[this.FPS_TABLE.length - 1]
                    };
                    return S.some((f)=>{
                        const S = this.getFs(f);
                        return this.FPS_TABLE.some((_)=>{
                            const C = this.getMbps(S, _);
                            return S <= g.maxFs && _ <= g.maxFps && C <= g.maxMbps && (v = {
                                resolution: f,
                                fps: _
                            }, !0);
                        });
                    }) ? this.logger.safe.info(`Calculated resolution: ${JSON.stringify(v)}`) : this.logger.safe.error(`None of available resolutions are suitable: ${JSON.stringify(S)}. Fallback to: ${JSON.stringify(v)}`), v;
                }
                getMbps(g, f) {
                    return g * f;
                }
                getFs(g) {
                    return Math.ceil(g.width / Gt.MACROBLOCK_SIZE) * Math.ceil(g.height / Gt.MACROBLOCK_SIZE);
                }
                constructor(g){
                    this.logger = g, this.FPS_TABLE = [
                        15,
                        7.5,
                        3.75,
                        1.875
                    ], this.resolutionTableCalculator = new l_, this.initialAspectRatio = null;
                }
            }, d_ = class {
                ensureValidity(g) {
                    this.throwIfMissing(g);
                    const f = this.calculateMissing(g);
                    return this.maxCapabilities && this.applyMaxCapabilities(f), this.logger.safe.info(`Validating capabilities ${JSON.stringify(f)}`), f;
                }
                throwIfMissing(g) {
                    if (!g.maxFs && !g.maxMbps && !g.maxFps || g.maxFs && !g.maxMbps && !g.maxFps || !g.maxFs && g.maxMbps && !g.maxFps || !g.maxFs && !g.maxMbps && g.maxFps) throw new Error(`Missing video capabilities ${JSON.stringify(g)}`);
                }
                calculateMissing(g) {
                    const f = shallowClone(g);
                    return !g.maxFs && g.maxMbps && g.maxFps && (f.maxFs = g.maxMbps / g.maxFps), g.maxFs && !g.maxMbps && g.maxFps && (f.maxMbps = g.maxFs * g.maxFps), g.maxFs && g.maxMbps && !g.maxFps && (f.maxFps = g.maxMbps / g.maxFs), f;
                }
                applyMaxCapabilities(g) {
                    this.maxCapabilities.maxFs && (g.maxFs = Math.min(g.maxFs, this.maxCapabilities.maxFs)), this.maxCapabilities.maxMbps && (g.maxMbps = Math.min(g.maxMbps, this.maxCapabilities.maxMbps)), this.maxCapabilities.maxFps && (g.maxFps = Math.min(g.maxFps, this.maxCapabilities.maxFps));
                }
                constructor(g, f){
                    this.logger = g, this.maxCapabilities = f;
                }
            }, u_ = 8160, h_ = 15, g_ = class extends o_ {
                createConstraintsObject(g) {
                    if (!g.sharing) throw new Error(`Sharing constraints are not presented: ${JSON.stringify(g)}`);
                    const f = this.convertConstraints(g.sharing, this.initialConstraints), S = g.audio ? g.audio : null;
                    return (S === null || S === void 0 ? void 0 : S.deviceId) === Gt.SYSTEM_AUDIO_SOURCE_ID && delete S.deviceId, new s_(S, f, !1, !1, g.withOverridenStream);
                }
                generatePolicies(g) {
                    return [
                        g
                    ];
                }
                calculateConstraints(g, f) {
                    this.logger.safe.info(`Stream resolution is ${JSON.stringify(f)}`);
                    const S = this.validator.ensureValidity(g);
                    return this.constraintsCalculator.calculateConstraints(S, f);
                }
                constructor(g, f){
                    super(g), this.initialConstraints = {
                        maxWidth: 1920,
                        minWidth: 1920,
                        maxHeight: 1080,
                        minHeight: 1080,
                        fps: 15
                    }, this.maxCapabilities = {
                        maxFs: u_,
                        maxFps: h_
                    }, this.validator = new d_(this.logger.createChild("CV"), this.maxCapabilities), this.constraintsCalculator = new c_(this.logger.createChild("CC")), f.config.resizeModeForSharing && (this.initialConstraints.resizeMode = f.config.resizeModeForSharing);
                }
            }, p_ = class extends g_ {
                constructor(g, f, S){
                    super(g, S);
                    const v = f.screen.width / f.screen.height;
                    v < 1 && ([this.initialConstraints.maxWidth, this.initialConstraints.maxHeight] = [
                        this.initialConstraints.maxHeight,
                        this.initialConstraints.maxWidth
                    ], [this.initialConstraints.minWidth, this.initialConstraints.minHeight] = [
                        this.initialConstraints.minHeight,
                        this.initialConstraints.minWidth
                    ]);
                    let _ = adjustResolutionToAspectRatio({
                        width: this.initialConstraints.maxWidth,
                        height: this.initialConstraints.maxHeight
                    }, v);
                    [this.initialConstraints.maxWidth, this.initialConstraints.maxHeight] = [
                        _.width,
                        _.height
                    ], _ = adjustResolutionToAspectRatio({
                        width: this.initialConstraints.minWidth,
                        height: this.initialConstraints.minHeight
                    }, v), [this.initialConstraints.minWidth, this.initialConstraints.minHeight] = [
                        _.width,
                        _.height
                    ];
                }
            }, m_ = class extends o_ {
                get currentMaxFS() {
                    var _this_streamConstraintsMaxFS;
                    return (_this_streamConstraintsMaxFS = this.streamConstraintsMaxFS) !== null && _this_streamConstraintsMaxFS !== void 0 ? _this_streamConstraintsMaxFS : this.configProvider.config.webrtcCameraOpenFs;
                }
                createConstraintsObject(g) {
                    const f = {};
                    void 0 !== g.audioProcessingFlags && (Ze.isEngine("Chromium", "ChromiumAVD") ? (f.autoGainControl = !!(1 & g.audioProcessingFlags), f.echoCancellation = !!(2 & g.audioProcessingFlags), f.noiseSuppression = !!(4 & g.audioProcessingFlags), this.configProvider.config.useGoogPrefixAudioConstraints && (f.googAutoGainControl = !!(1 & g.audioProcessingFlags), f.googAutoGainControl2 = !!(1 & g.audioProcessingFlags), f.googEchoCancellation = !!(2 & g.audioProcessingFlags), f.googHighpassFilter = !!(4 & g.audioProcessingFlags), f.googNoiseSuppression = !!(4 & g.audioProcessingFlags), f.googTypingNoiseDetection = !!(4 & g.audioProcessingFlags))) : Ze.isEngine("Safari", "Firefox") ? (f.autoGainControl = !!(1 & g.audioProcessingFlags), f.echoCancellation = !!(2 & g.audioProcessingFlags), f.noiseSuppression = !!(4 & g.audioProcessingFlags)) : this.logger.warn(`Unsupported browser engine for audio processing flags ${Ze.getBrowserInfo().engine}`));
                    const S = this.convertConstraints(g.audio, f);
                    this.streamConstraintsMaxFS = g.videoMaxFS;
                    const v = this.convertConstraints(g.video, this.initialVideoConstraints(this.currentMaxFS));
                    return new s_(S, v, g.withTimeout, g.withEffect, g.withOverridenStream);
                }
                calculateConstraints(g) {
                    const f = Math.min(g.maxFs, this.currentMaxFS);
                    return {
                        resolution: Zt.Send.getResolutionByFs(f),
                        fps: g.maxFps
                    };
                }
                initialVideoConstraints(g) {
                    const f = Zt.Send.getResolutionByFs(g);
                    return {
                        maxWidth: f.width,
                        minWidth: f.width,
                        maxHeight: f.height,
                        minHeight: f.height,
                        fps: this.configProvider.config.maxCameraOpenFps
                    };
                }
                constructor(g, f){
                    super(f), this.configProvider = g;
                }
            }, f_ = class {
                static getProvider(g, f, S) {
                    if ("ScreenShare" === g) {
                        const g = S.createChild("SharingCP");
                        return Ze.isBrowser("Safari") ? new p_(g, Qa.window, f) : new g_(g, f);
                    }
                    return new m_(f, S.createChild("VideoCP"));
                }
            }, S_ = class {
                getMediaError() {
                    let g;
                    switch(this.error.name){
                        case "SourceUnavailableError":
                        case "TrackStartError":
                        case "NotReadableError":
                        case "AbortError":
                            g = {
                                type: Gt.MEDIA_ERROR.sourceUnavailableError,
                                detail: `media device is already used by another process: ${stringifyObject(this.error)}`
                            };
                            break;
                        case "ConstraintNotSatisfiedError":
                        case "OverconstrainedError":
                            g = {
                                type: Gt.MEDIA_ERROR.constraintNotSatisfiedError,
                                detail: `could not obtain constrained media stream: ${stringifyObject(this.error)}`
                            };
                            break;
                        case "DevicesNotFoundError":
                        case "NotFoundError":
                            g = this.configProvider.config.permissionDeniedUFDWorkaround ? {
                                type: Gt.MEDIA_ERROR.permissionDeniedBySystemError,
                                detail: `no system permissions: ${stringifyObject(this.error)}`
                            } : {
                                type: Gt.MEDIA_ERROR.devicesNotFoundError,
                                detail: `specified device not found: ${stringifyObject(this.error)}`
                            };
                            break;
                        case "NotAllowedError":
                            g = this.permissionDeniedBySystemErrorMsg.some((g)=>g === this.error.message) ? {
                                type: Gt.MEDIA_ERROR.permissionDeniedBySystemError,
                                detail: `no system permissions: ${stringifyObject(this.error)}`
                            } : {
                                type: Gt.MEDIA_ERROR.permissionDeniedError,
                                detail: `permission to use media device was denied: ${stringifyObject(this.error)}`
                            };
                            break;
                        case "PermissionDeniedError":
                        case "PermissionDismissedError":
                            g = {
                                type: Gt.MEDIA_ERROR.permissionDeniedError,
                                detail: `permission to use media device was denied: ${stringifyObject(this.error)}`
                            };
                            break;
                        case Gt.MEDIA_ERROR.extensionNotFoundError:
                            g = {
                                type: Gt.MEDIA_ERROR.extensionNotFoundError,
                                detail: `extension is not found: ${stringifyObject(this.error)}`
                            };
                            break;
                        case Gt.MEDIA_ERROR.chromeRuntimeNotDefinedError:
                            g = {
                                type: Gt.MEDIA_ERROR.chromeRuntimeNotDefinedError,
                                detail: `chrome runtime is not defined: ${stringifyObject(this.error)}`
                            };
                            break;
                        case Gt.MEDIA_ERROR.sharingCancelledError:
                            g = this.getSharingCancelledError(this.error);
                            break;
                        case Gt.MEDIA_ERROR.mediaStreamRequestTimedOut:
                            g = {
                                type: Gt.MEDIA_ERROR.mediaStreamRequestTimedOut,
                                detail: "Media Stream request timed out."
                            };
                            break;
                        default:
                            g = this.error.message === Gt.MEDIA_ERROR.sharingCancelledError ? this.getSharingCancelledError(this.error) : {
                                type: Gt.MEDIA_ERROR.mediaStreamRequestError,
                                detail: `media stream request error: ${stringifyObject(this.error)}`
                            };
                    }
                    return g.isAudio = !!this.constraints.audio, g.detail += ` constraints: ${stringifyObject(scrubConstraints(this.constraints))}`, g.message = g.detail, g;
                }
                getSharingCancelledError(g) {
                    return {
                        type: Gt.MEDIA_ERROR.sharingCancelledError,
                        detail: `screen sharing cancelled: ${stringifyObject(g)}`
                    };
                }
                constructor(g, f, S){
                    this.error = g, this.constraints = f, this.configProvider = S, this.permissionDeniedBySystemErrorMsg = [
                        "Permission denied by system",
                        "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."
                    ];
                }
            }, v_ = class {
                static isSupported() {
                    return !0;
                }
                getStream(g) {
                    const f = this.constraintsAdapter.toGumConstraints(g);
                    return this.logger.safe.info(`Constraints to be applied: ${JSON.stringify(scrubConstraints(f))}`), new Promise((g, S)=>{
                        Qa.window.navigator.getUserMedia(f, g, S);
                    }).catch((f)=>{
                        throw new S_(f, g, this.configProvider).getMediaError();
                    });
                }
                applyConstraints(g, f) {
                    var _g_getVideoTracks;
                    if (!(g === null || g === void 0 ? void 0 : (_g_getVideoTracks = g.getVideoTracks()) === null || _g_getVideoTracks === void 0 ? void 0 : _g_getVideoTracks[0])) return Promise.reject("No video tracks found");
                    const S = g.getVideoTracks()[0];
                    return this.applyConstraintsForTrack(S, f);
                }
                applyConstraintsForTrack(g, f) {
                    const S = this.constraintsAdapter.toTrackConstraints(f);
                    return g.applyConstraints ? (this.logger.safe.info(`Apply constraints: ${JSON.stringify(S)} on ${JSON.stringify(g.id)}`), g.applyConstraints(S).catch((g)=>{
                        throw new S_(g, f, this.configProvider).getMediaError();
                    })) : Promise.reject("track.applyConstraints() is not supported");
                }
                constructor(g, f){
                    this.logger = g, this.configProvider = f;
                }
            }, C_ = class {
                toGumConstraints(g) {
                    const f = {};
                    return g.audio && (f.audio = deepClone(g.audio), f.audio.deviceId && delete f.audio.deviceId, g.audio.deviceId && g.audio.deviceId !== Gt.MEDIA_DEVICE.defaultId && (f.audio.deviceId = g.audio.deviceId)), g.video && (f.video = {
                        mandatory: {}
                    }, g.video.deviceId && (f.video.mandatory.sourceId = g.video.deviceId), g.video.minWidth && (f.video.mandatory.minWidth = g.video.minWidth), g.video.maxWidth && (f.video.mandatory.maxWidth = g.video.maxWidth), g.video.minHeight && (f.video.mandatory.minHeight = g.video.minHeight), g.video.maxHeight && (f.video.mandatory.maxHeight = g.video.maxHeight), g.video.fps && (f.video.mandatory.maxFrameRate = g.video.fps, this.configProvider.config.setMinFpsForWebkit && (f.video.mandatory.minFrameRate = this.configProvider.config.minCameraOpenFps, f.video.mandatory.idealFrameRate = g.video.fps)), isEmpty(f.video.mandatory) && delete f.video.mandatory), f;
                }
                toTrackConstraints(g) {
                    const f = {};
                    return g.video && (g.video.minWidth && (f.width = g.video.minWidth), g.video.minHeight && (f.height = g.video.minHeight), g.video.fps && (f.frameRate = g.video.fps)), f;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, y_ = class {
                toGumConstraints(g) {
                    const f = {};
                    if (g.audio && (f.audio = deepClone(g.audio), f.audio.deviceId && delete f.audio.deviceId, g.audio.deviceId && g.audio.deviceId !== Gt.MEDIA_DEVICE.defaultId && (f.audio.deviceId = {
                        exact: g.audio.deviceId
                    })), g.video) {
                        f.video = {
                            width: {},
                            height: {},
                            frameRate: {}
                        }, g.video.deviceId && (f.video.deviceId = {
                            exact: g.video.deviceId
                        }), g.video.minWidth && (f.video.width.min = g.video.minWidth), g.video.maxWidth && (f.video.width.max = g.video.maxWidth), g.video.minHeight && (f.video.height.min = g.video.minHeight), g.video.maxHeight && (f.video.height.max = g.video.maxHeight), g.video.fps && (f.video.frameRate.max = g.video.fps, f.video.frameRate.min = this.configProvider.config.minCameraOpenFps, f.video.frameRate.ideal = g.video.fps);
                        for(const g in f.video)isEmpty(f.video[g]) && delete f.video[g];
                    }
                    return f;
                }
                toTrackConstraints(g) {
                    const f = {};
                    return g.video && (g.video.minWidth && (f.width = g.video.minWidth), g.video.minHeight && (f.height = g.video.minHeight), g.video.fps && (f.frameRate = g.video.fps)), f;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, E_ = class {
                toGumConstraints(g) {
                    if (!(g === null || g === void 0 ? void 0 : g.video)) throw new Error(`constraints cannot be applied: ${g}`);
                    const f = {
                        video: {}
                    }, S = g.video.deviceId && g.video.deviceId !== Gt.DISPLAY_SOURCE_ID;
                    return g.video.resizeMode && (f.video.resizeMode = g.video.resizeMode), S && (f.video.deviceId = {
                        exact: g.video.deviceId
                    }), g.video.maxWidth && (f.video.width = {
                        max: g.video.maxWidth
                    }, S && (f.video.width.ideal = g.video.maxWidth)), g.video.maxHeight && (f.video.height = {
                        max: g.video.maxHeight
                    }, S && (f.video.height.ideal = g.video.maxHeight)), g.video.fps && (f.video.frameRate = g.video.fps), g.audio && (f.audio = !g.audio.deviceId || {
                        deviceId: {
                            exact: g.audio.deviceId
                        }
                    }), f;
                }
                toTrackConstraints(g) {
                    const f = navigator.mediaDevices.getSupportedConstraints();
                    if (!f) throw new Error("Constraints are not supported by browser");
                    const S = {};
                    return f.width && g.video.minWidth && (S.width = g.video.minWidth), f.height && g.video.minHeight && (S.height = g.video.minHeight), f.frameRate && g.video.fps && (S.frameRate = g.video.fps), S.resizeMode = g.video.resizeMode, S;
                }
            }, T_ = class extends v_ {
                getStream(g) {
                    if (!g.withTimeout || !this.configProvider.config.gumRequestTimeout) return super.getStream(g);
                    const f = this.startGumRequestTimer(g), S = super.getStream(g).then((f)=>{
                        if (!this.timeoutId) throw this.stopStreamAfterTimeout(f, g), this.getMediaStreamTimeoutError(g);
                        return this.stopGumRequestTimer(), f;
                    });
                    return Promise.race([
                        f,
                        S
                    ]).catch((g)=>{
                        throw this.stopGumRequestTimer(), g;
                    });
                }
                getMediaStreamTimeoutError(g) {
                    const f = {
                        name: Gt.MEDIA_ERROR.mediaStreamRequestTimedOut,
                        message: `Media stream request timed out. Constraints: ${stringifyObject(scrubConstraints(g))}`
                    };
                    return new S_(f, g, this.configProvider).getMediaError();
                }
                startGumRequestTimer(g) {
                    return new Promise((f, S)=>{
                        this.timeoutId = window.setTimeout(()=>{
                            this.timeoutId = null, S(this.getMediaStreamTimeoutError(g));
                        }, this.configProvider.config.gumRequestTimeout);
                    });
                }
                stopGumRequestTimer() {
                    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null);
                }
                stopStreamAfterTimeout(g, f) {
                    this.logger.safe.info(`Stopping media stream acquired after timeout: ${JSON.stringify(g.id)} with constraints: ${JSON.stringify(f)}`);
                    try {
                        g.getTracks().forEach((g)=>{
                            this.logger.safe.info(`Track is stopped: ${JSON.stringify(g.id)}`), g.stop();
                        }), this.logger.safe.info(`Media stream stopped: ${g.id}`);
                    } catch (g) {
                        this.logger.safe.warn(`Failed to stop media stream: ${stringifyObject(g)}`);
                    }
                }
                constructor(g, f){
                    if (super(f.createChild("WebRTCProvider"), g), this.timeoutId = null, void 0 !== navigator.webkitGetUserMedia && void 0 !== webkitRTCPeerConnection && isVdiPlatform()) {
                        if (!this.configProvider.config.overrideGumFromWebkit || !Ja) return void (this.constraintsAdapter = new C_(g));
                        this.logger.safe.info("Overriding getUserMedia from webkit"), overrideGumSourceFromWebkit();
                    }
                    this.constraintsAdapter = new y_(g);
                }
            }, I_ = class extends v_ {
                static isSupported() {
                    return !!window.navigator.mediaDevices.getDisplayMedia;
                }
                getStream(g) {
                    const f = this.constraintsAdapter.toGumConstraints(g);
                    return this.logger.safe.info(`Constraints to be used: ${JSON.stringify(f)}`), Promise.resolve().then(()=>{
                        var _g_video, _g_video1;
                        return ((_g_video = g.video) === null || _g_video === void 0 ? void 0 : _g_video.deviceId) && ((_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : _g_video1.deviceId) !== Gt.DISPLAY_SOURCE_ID ? Qa.window.navigator.mediaDevices.getUserMedia(f) : Qa.window.navigator.mediaDevices.getDisplayMedia(f);
                    }).catch((f)=>{
                        throw new S_(f, g, this.configProvider).getMediaError();
                    });
                }
                constructor(g, f){
                    super(g.createChild("WebRTCDispProvider"), f), this.constraintsAdapter = new E_;
                }
            }, b_ = class {
                getStream(g) {
                    throw this.getError(g);
                }
                applyConstraints(g, f) {
                    throw this.getError(f);
                }
                applyConstraintsForTrack(g, f) {
                    throw this.getError(f);
                }
                getError(g) {
                    return {
                        type: Gt.MEDIA_ERROR.unsupportedStream,
                        detail: this.detail,
                        message: this.detail,
                        isAudio: !!g.audio
                    };
                }
                constructor(g){
                    this.detail = g;
                }
            }, A_ = class {
                static getStreamProvider(g, f, S) {
                    return "ScreenShare" === g ? I_.isSupported() ? new I_(S, f) : (S.error("GUM stream provider cannot be created for display stream"), new b_("Sharing not supported")) : new T_(f, S);
                }
            }, R_ = [
                30,
                15,
                7.5,
                3.75,
                1.875
            ];
            function getResolutionForStream(g) {
                return g && g.getVideoTracks()[0] ? getResolutionForTrack(g.getVideoTracks()[0]) : null;
            }
            function getResolutionForTrack(g) {
                if (g && g.getSettings) {
                    const f = g.getSettings();
                    if (f) return {
                        width: f.width,
                        height: f.height
                    };
                }
                return null;
            }
            function getFrameRateForStream(g) {
                return g && g.getVideoTracks()[0] ? getFrameRateForTrack(g.getVideoTracks()[0]) : 0;
            }
            function getFrameRateForTrack(g) {
                if (g && g.getSettings) {
                    const f = g.getSettings();
                    if (f) return getClosestValue(R_, f.frameRate, !0);
                }
                return 0;
            }
            var P_ = class extends Bt {
                get rawTrack() {
                    return this.mediaTrack;
                }
                get rawStream() {
                    return this.rawMediaStream || (this.rawMediaStream = new MediaStream([
                        this.mediaTrack
                    ]), this.configProvider.config.reassignMediaStreamAudioTrackAfterCreation && this.rawMediaStream.getAudioTracks().length > 0 && (this.rawMediaStream.removeTrack(this.rawMediaStream.getAudioTracks()[0]), this.rawMediaStream.addTrack(this.mediaTrack))), this.rawMediaStream;
                }
                get deviceId() {
                    return this.masterStream.deviceId;
                }
                get mediaType() {
                    return this.masterStream.mediaType;
                }
                get originalMediaStream() {
                    return this.masterStream.getOriginalMediaStream();
                }
                getCurrentConstraints() {
                    return this.currentConstraints;
                }
                dispose(g) {
                    this._isDisposed || (this._isDisposed = !0, this.logger.safe.info(`dispose: ${g}`), this.logger = this.logger.createChild("DISPOSED"), this.event("onStreamClientDisposing").raise(this), this.mediaTrack && (this.unsubscribeFromMediaTrackEvents(), this.mediaTrack = null), this.masterStream && (this.unsubscribeFromMasterStreamEvents(), this.masterStream.disposeClient(this), this.masterStream = null), this.unsubscribeFromMixerTrackEvents(), super.dispose(), this.event("onStreamClientDisposed").raise(this));
                }
                async applyCapabilities(g) {
                    if (!this.mediaTrack) return !1;
                    const f = this.constraintsProvider.updateVideoConstraints(this.currentConstraints, g, this.getResolution());
                    if (!f || !this.configProvider.config.recoverOnStreamUnmute && this.currentConstraints === f) return !1;
                    const applyConstraints = async (g)=>{
                        try {
                            return await this.streamProvider.applyConstraintsForTrack(this.mediaTrack, f), this.currentConstraints = f, !0;
                        } catch (f) {
                            if (g) throw this.logger.safe.error(`Apply constraints error: ${JSON.stringify(f)}`), f;
                            return this.logger.safe.warn(`Apply constraints failed and will be re-tried, error ${JSON.stringify(f)}`), !1;
                        }
                    }, S = this.currentConstraints.withEffect && this.configProvider.config.effectsApplyConstraintsRetryMs;
                    return !await applyConstraints(!S) && S && (await delay(this.configProvider.config.effectsApplyConstraintsRetryMs), await applyConstraints(!0)), !0;
                }
                start() {
                    return this.masterStream.start();
                }
                clone(g) {
                    return this.masterStream || this.logger.safe.error(`clone: master stream is null, reason: ${g}`), this.masterStream.getClient(`streamclient: ${g}`);
                }
                setMuted(g, f) {
                    this.isMuted = g, this.applyState(f);
                }
                setHold(g, f) {
                    this.isHold = g, this.applyState(f);
                }
                isSameStream(g) {
                    return this.parentId === g.parentId;
                }
                getResolution() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = {
                        width: this.currentConstraints.video.minWidth,
                        height: this.currentConstraints.video.minHeight
                    }, f = getResolutionForTrack(this.mediaTrack), S = (f === null || f === void 0 ? void 0 : f.width) ? f : g, v = `Track resolution is ${S.width}x${S.height}.`;
                    return (f === null || f === void 0 ? void 0 : f.width) ? this.logger.safe.info(v) : this.logger.safe.error(`${v}. Resolution not found, assuming default resolution.'`), S;
                }
                getFrameRate() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = getFrameRateForTrack(this.mediaTrack);
                    return 0 === g ? this.logger.safe.error("Stream frame rate is not avalable, returning 0") : this.logger.safe.info(`Stream fps is ${g}`), g;
                }
                update(g) {
                    g ? this.mediaTrack ? this.logger.safe.error(`Media track is already created: ${this.mediaTrack.id}`) : (this.mediaTrack = this.getTrackByMediaType(g, this.mediaType), this.updateTrackConstraints(), this.subscribeOnMediaTrackEvents(this.mediaTrack), this.hasMasterAudio = g && g.getAudioTracks().length > 0, this.hasMasterVideo = g && g.getVideoTracks().length > 0, this.hasMasterAudio && this.hasMasterVideo && (this.rawMediaStream = g), this.logger.safe.info(`Updated: ${printMediaStream(g)}`)) : this.logger.safe.error("No master media stream, skipping update");
                }
                resetEffectsOutputConstraints(g) {
                    this.masterStream.resetEffectsOutputConstraints(g);
                }
                async updateTrackConstraints() {
                    if ("ScreenShare" !== this.mediaType) return;
                    const g = this.masterStream.getResolution();
                    if (g) {
                        const f = this.currentConstraints.clone();
                        f.video.maxWidth = g.width, f.video.minWidth = g.width, f.video.maxHeight = g.height, f.video.minHeight = g.height;
                        try {
                            await this.streamProvider.applyConstraintsForTrack(this.mediaTrack, f), this.currentConstraints = f;
                        } catch (g) {
                            this.logger.safe.error(`Apply constraints error: ${JSON.stringify(g)}`);
                        }
                    }
                }
                getTrackByMediaType(g, f) {
                    return "Audio" === f ? g.getAudioTracks()[0] : g.getVideoTracks()[0];
                }
                applyState(g) {
                    var _this_mediaTrack;
                    void 0 !== ((_this_mediaTrack = this.mediaTrack) === null || _this_mediaTrack === void 0 ? void 0 : _this_mediaTrack.enabled) && (this.mediaTrack.enabled = !this.isMuted && !this.isHold, this.logger.safe.info(`[${g}] Track ${JSON.stringify(this.mediaTrack.id)} enabled state set to => ${this.mediaTrack.enabled}`));
                }
                subscribeOnMediaTrackEvents(g) {
                    g.onended = (f)=>{
                        this.logger.safe.info(`Track ${g.id} ended: ${JSON.stringify(f)}`), this.event("onStreamClientEnded").raise(this, f);
                    }, g.onmute = ()=>{
                        this.logger.safe.info(`Track ${g.id} muted`), this.event("onStreamClientMuted").raise(this, !0);
                    }, g.onunmute = ()=>{
                        this.logger.safe.info(`Track ${g.id} unmuted`), this.event("onStreamClientMuted").raise(this, !1);
                    };
                }
                unsubscribeFromMediaTrackEvents() {
                    this.mediaTrack.onended = null, this.mediaTrack.onmute = null, this.mediaTrack.onunmute = null;
                }
                unsubscribeFromMixerTrackEvents() {
                    this.mixerSubscriptions.forEach((g)=>g.dispose()), this.mixerSubscriptions = [];
                }
                subscribeOnMasterStreamEvents() {
                    this.masterStreamSubscriptions.push(this.masterStream.on("onStreamStarted", (g, f)=>this.event("onStreamClientStarted").raise(this, f)), this.masterStream.on("onStreamError", (g, f)=>this.event("onStreamClientError").raise(this, f)), this.masterStream.on("onStreamTrackMuted", (g, f)=>this.event("onStreamClientMuted").raise(this, f)), this.masterStream.on("onStreamDisposing", (g)=>this.dispose()), this.masterStream.on("onStreamQualityChanged", (g, f, S, v)=>this.event("onStreamQualityChanged").raise(this, f, S, v)), this.masterStream.on("onStreamTrackEnded", (g, f)=>this.event("onStreamClientEnded").raise(this, f)));
                }
                unsubscribeFromMasterStreamEvents() {
                    this.masterStreamSubscriptions.forEach((g)=>g.dispose()), this.masterStreamSubscriptions = [];
                }
                hasAudio() {
                    return this.hasMasterAudio;
                }
                hasVideo() {
                    return this.hasMasterVideo;
                }
                isActive() {
                    var _this_mediaTrack, _this_mediaTrack1, _this_mediaTrack2;
                    return ((_this_mediaTrack = this.mediaTrack) === null || _this_mediaTrack === void 0 ? void 0 : _this_mediaTrack.enabled) && !((_this_mediaTrack1 = this.mediaTrack) === null || _this_mediaTrack1 === void 0 ? void 0 : _this_mediaTrack1.muted) && "live" === ((_this_mediaTrack2 = this.mediaTrack) === null || _this_mediaTrack2 === void 0 ? void 0 : _this_mediaTrack2.readyState);
                }
                onVideoStreamQualityChanged(g, f, S) {
                    this.logger.safe.debug(`onStreamQualityChanged: ${JSON.stringify(g)}@${f}, reason=${S}`), this.masterStream.onVideoStreamQualityChanged(g, f, S);
                }
                isDisposed() {
                    return this._isDisposed;
                }
                constructor(g, f, S, v, _, C, E){
                    super(E), this.id = g, this.masterStream = f, this.currentConstraints = S, this.constraintsProvider = v, this.streamProvider = _, this.configProvider = C, this._isDisposed = !1, this.masterStreamSubscriptions = [], this.mixerSubscriptions = [], this.parentId = f.id, this.logger = E.createChild(`C:${this.parentId}:${this.id}`), this.subscribeOnMasterStreamEvents();
                }
            }, w_ = class extends Bt {
                getClient() {
                    const g = new P_(this.clientId++, this.stream, this.constraints, this.constraintsProvider, this.gumStreamProvider, this.configProvider, this.logger);
                    return this.addClient(g), g;
                }
                disposeClient(g) {
                    this.removeClient(g), this.clients.length || this.event("onAllClientsDisposed").raise();
                }
                dispose() {
                    this.mediaStreamSubscription.dispose(), this.clients.length && this.logger.safe.error(`Not all clients are disposed! ${JSON.stringify(this.clients.map((g)=>g.id))}`), this.streams.forEach((g)=>this.disposeStream(g)), super.dispose();
                }
                getOrCreateStream() {
                    const g = this.streams.length ? this.streams[this.streams.length - 1] : this.stream.rawStream;
                    if (!g) return null;
                    const f = g.clone();
                    return this.logger.safe.info(`Cloned: ${printMediaStream(g)} -> ${printMediaStream(f)}`), this.resetStream(f), this.streams.push(f), f;
                }
                addClient(g) {
                    this.updateClient(g), this.clients.push(g);
                }
                updateClient(g) {
                    const f = this.getOrCreateStream();
                    f && g.update(f);
                }
                removeClient(g) {
                    const f = this.clients.indexOf(g);
                    this.clients.splice(f, 1);
                }
                addStream() {
                    this.clients.forEach((g)=>this.updateClient(g));
                }
                disposeStream(g) {
                    g.getTracks().forEach((g)=>{
                        this.logger.safe.info(`Stopping track: ${JSON.stringify(g.id)}`), g.stop();
                    });
                }
                onStreamAcquired() {
                    this.addStream();
                }
                resetStream(g) {
                    g.getTracks().forEach((g)=>{
                        this.logger.safe.info(`Resetting state for track: ${g.id}`), g.enabled = !0;
                    });
                }
                constructor(g, f, S, v, _, C){
                    super(C), this.stream = g, this.constraints = f, this.constraintsProvider = S, this.gumStreamProvider = v, this.configProvider = _, this.logger = C, this.clients = [], this.streams = [], this.clientId = 0, this.mediaStreamSubscription = this.stream.on("onStreamAcquired", ()=>this.onStreamAcquired());
                }
            }, M_ = class {
                getPolicies(g) {
                    if (g.audio && !g.video && this.hasAudioProcessingConstraints(g)) return [
                        g,
                        new s_({
                            deviceId: g.audio.deviceId
                        }, null)
                    ];
                    if (!g.video) return [
                        g
                    ];
                    const f = this.getSuitableResolutions(g).map((f)=>this.getConstraintsForResolution(g, f)), S = g.audio, v = {
                        deviceId: g.video.deviceId
                    }, _ = new s_(S, v, g.withTimeout);
                    return f.push(_), f;
                }
                getSuitableResolutions(g) {
                    return Zt.Send.getResolutions().filter((f)=>f.width <= g.video.maxWidth && f.height <= g.video.maxHeight).reverse();
                }
                getConstraintsForResolution(g, f) {
                    const S = g.clone();
                    return S.video.minWidth = f.width, S.video.minHeight = f.height, S;
                }
                hasAudioProcessingConstraints(g) {
                    const f = g && g.audio;
                    return f && (void 0 !== f.echoCancellation || void 0 !== f.autoGainControl || void 0 !== f.noiseSuppression);
                }
                constructor(){}
            }, O_ = class {
                static getStrategy(g, f, S, v, _, C) {
                    return C ? new L_(S, v) : "Video" === g ? new k_(f, S, v, _) : new N_(f, S, v);
                }
            }, D_ = class {
                getStream(g) {
                    return this.logger.safe.info(`Requesting stream with constraints: ${JSON.stringify(scrubConstraints(g))}`), this.serialQueue.add(()=>this.request(g));
                }
                constructor(g, f, S){
                    this.gumStreamProvider = g, this.serialQueue = f, this.logger = S;
                }
            }, N_ = class extends D_ {
                request(g) {
                    return this.gumStreamProvider.getStream(g);
                }
                constructor(g, f, S){
                    super(g, f, S.createChild("SimpleStrat"));
                }
            }, k_ = class extends D_ {
                request(g) {
                    const f = this.policyGenerator.getPolicies(g);
                    return this.makeRequests(f);
                }
                makeRequests(g) {
                    const f = g[0];
                    return this.logger.safe.info(`Requesting media stream with policy: ${JSON.stringify(f)}`), this.makeRequestWithPolicy(f).catch((f)=>{
                        const S = g.slice(1);
                        if (S.length && Gt.MEDIA_ERROR.constraintNotSatisfiedError === f.type) return this.logger.safe.warn("Could not obtain constrained media stream, will attempt weaker policy"), this.makeRequests(S);
                        throw f;
                    });
                }
                makeRequestWithPolicy(g) {
                    return this.gumStreamProvider.getStream(g);
                }
                constructor(g, f, S, v){
                    super(g, f, S.createChild("MultStrat")), this.policyGenerator = new M_;
                }
            }, L_ = class extends D_ {
                request(g) {
                    return new Promise((f, S)=>f(g.withOverridenStream));
                }
                constructor(g, f){
                    super(null, g, f.createChild("WithOveriddenStreamStart"));
                }
            }, F_ = class _SimulcastMediaStream extends Bt {
                get rawStream() {
                    return this.mediaStream;
                }
                get deviceId() {
                    var _this_originalMediaStream_getTracks__getSettings, _this_originalMediaStream_getTracks__getSettings1, _this_originalMediaStream_getTracks_, _this_originalMediaStream_getTracks;
                    return this.originalMediaStream ? (_this_originalMediaStream_getTracks = this.originalMediaStream.getTracks()) === null || _this_originalMediaStream_getTracks === void 0 ? void 0 : (_this_originalMediaStream_getTracks_ = _this_originalMediaStream_getTracks[0]) === null || _this_originalMediaStream_getTracks_ === void 0 ? void 0 : (_this_originalMediaStream_getTracks__getSettings1 = _this_originalMediaStream_getTracks_.getSettings) === null || _this_originalMediaStream_getTracks__getSettings1 === void 0 ? void 0 : (_this_originalMediaStream_getTracks__getSettings = _this_originalMediaStream_getTracks__getSettings1.call(_this_originalMediaStream_getTracks_)) === null || _this_originalMediaStream_getTracks__getSettings === void 0 ? void 0 : _this_originalMediaStream_getTracks__getSettings.deviceId : null;
                }
                start() {
                    return this.mediaStreamStartPromise || (this.mediaStreamStartPromise = this.startStream(this.currentConstraints)), this.mediaStreamStartPromise;
                }
                dispose(g) {
                    this.event("onStreamDisposing").raise(this), this.stopMediaStream(g).catch((g)=>{
                        this.event("onStreamError").raise(this, g);
                    }).finally(()=>{
                        this.constraintsProvider = null, this.serialQueue = null, this.configProvider = null, this.logger = this.logger.createChild("DISPOSED"), this.clientGenerationStrategy.dispose(), this.event("onStreamDisposed").raise(this), super.dispose();
                    });
                }
                disposeClient(g) {
                    this.clientGenerationStrategy.disposeClient(g);
                }
                getClient(g) {
                    return this.logger.safe.debug(`getClient: ${g}`), this.clientGenerationStrategy.getClient();
                }
                getOriginalMediaStream() {
                    return this.originalMediaStream;
                }
                getResolution() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = {
                        width: this.currentConstraints.video.minWidth,
                        height: this.currentConstraints.video.minHeight
                    }, f = getResolutionForStream(this.mediaStream), S = f !== null && f !== void 0 ? f : g, v = `Stream resolution is ${S.width}x${S.height}.`;
                    return f ? this.logger.safe.info(v) : this.logger.safe.error(`${v}. Resolution not found, assuming default resolution.'`), S;
                }
                getFrameRate() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = getFrameRateForStream(this.mediaStream);
                    return 0 === g ? this.logger.safe.error("Stream frame rate is not avalable, returning 0") : this.logger.safe.info(`Stream fps is ${g}`), g;
                }
                getMediaType(g) {
                    if (g.sharing) return "ScreenShare";
                    if (g.video) return "Video";
                    if (g.audio) return "Audio";
                    throw new Error(`Media type is not defined: ${JSON.stringify(g)}`);
                }
                resetEffectsOutputConstraints(g) {
                    const f = getResolutionForStream(this.originalMediaStream);
                    this.effectManager.resetOutputConstraints("Video", {
                        width: Math.min(g.width, f.width || Number.MAX_SAFE_INTEGER),
                        height: Math.min(g.height, f.height || Number.MAX_SAFE_INTEGER)
                    });
                }
                initialize(g) {
                    this.constraintsProvider = f_.getProvider(this.mediaType, this.configProvider, this.logger), this.currentConstraints = this.constraintsProvider.createConstraintsObject(g), this.gumStreamProvider = A_.getStreamProvider(this.mediaType, this.configProvider, this.logger), this.mediaStreamRequestStrategy = O_.getStrategy(this.mediaType, this.gumStreamProvider, this.serialQueue, this.logger, this.configProvider, !!this.currentConstraints.withOverridenStream), this.clientGenerationStrategy = new w_(this, this.currentConstraints, this.constraintsProvider, this.gumStreamProvider, this.configProvider, this.logger), this.clientGenerationStrategy.on("onAllClientsDisposed", ()=>this.onAllClientsDisposed());
                }
                onAllClientsDisposed() {
                    this.logger.safe.info("All clients are disposed, disposing master stream"), this.dispose();
                }
                async startStream(g) {
                    try {
                        await this.getOrCreateMediaStream(g), this.event("onStreamStarted").raise(this, this.currentConstraints);
                    } catch (g) {
                        throw this.event("onStreamError").raise(this, g), g;
                    }
                }
                async getOrCreateMediaStream(g) {
                    if (this.mediaStream) return Promise.resolve();
                    const f = this.getRequestStartTimestamp(), S = await this.mediaStreamRequestStrategy.getStream(g);
                    return this.gumRequestTime = this.getRequestDuration(f), this.handleMediaStreamRequestSuccess(S, g);
                }
                async handleMediaStreamRequestSuccess(g, f) {
                    this.logger.safe.info(`Media stream acquired: ${printMediaStream(g)} with constraints: ${JSON.stringify(scrubConstraints(f))}`), this.originalMediaStream = g, this.subscribeToTrackEvents(this.originalMediaStream), this.currentConstraints = f, this.mediaStream = await this.applyEffects(g), this.applyState(this.mediaStream), this.event("onStreamAcquired").raise(this, this.gumRequestTime, "Audio" !== this.mediaType && this.getResolution() || void 0);
                }
                async applyEffects(g) {
                    switch(this.mediaType){
                        case "Video":
                            return this.getVideoEffectStream(g);
                        case "Audio":
                            return this.startNoiseSuppression(g);
                        case "ScreenShare":
                            return this.delayScreenShare(g);
                    }
                    return g;
                }
                async delayScreenShare(g) {
                    return this.configProvider.config.useDelayedScreenShareStream ? this.effectManager.startEffect("ScreenShare", g) : g;
                }
                async startNoiseSuppression(g) {
                    return this.configProvider.config.applyAudioEffectOnDemand && !this.currentConstraints.withEffect ? g : (this.logger.safe.info(`ECS keys for wasmvqe are: ${JSON.stringify(this.configProvider.config.wasmvqe)}`), this.logger.safe.info(`ECS keys for wasmdns are: ${JSON.stringify(this.configProvider.config.wasmdns)}`), await this.effectManager.startEffect("Audio", g));
                }
                async getVideoEffectStream(g) {
                    if (!this.currentConstraints.withEffect || this.currentConstraints.withOverridenStream && this.configProvider.config.useRawMediaApiForVideoEffects) return g;
                    this.sub = this.effectManager.on("onVideoStreamQualityChanged", (g, f, S)=>this.onVideoStreamQualityChanged(g, f, S));
                    const f = await this.effectManager.startEffect("Video", g);
                    return this.logger.safe.info(`Media stream switched: ${printMediaStream(g)} -> ${printMediaStream(f)}`), f;
                }
                subscribeToTrackEvents(g) {
                    const f = g ? this.getTrackByMediaType(g, this.mediaType) : null;
                    f && (f.onended = (g)=>{
                        this.logger.safe.info(`Track ${f.id} ended: ${JSON.stringify(g)}`), this.event("onStreamTrackEnded").raise(this, g);
                    }, f.onmute = ()=>{
                        this.logger.safe.info(`Track ${f.id} muted`), this.event("onStreamTrackMuted").raise(this, !0);
                    }, f.onunmute = ()=>{
                        this.logger.safe.info(`Track ${f.id} unmute`), this.event("onStreamTrackMuted").raise(this, !1);
                    });
                }
                unsubscribeFromTrackEvents(g) {
                    const f = g ? this.getTrackByMediaType(g, this.mediaType) : null;
                    f && (f.onended = null, f.onmute = null, f.onunmute = null);
                }
                getTrackByMediaType(g, f) {
                    return "Audio" === f ? g.getAudioTracks()[0] : g.getVideoTracks()[0];
                }
                removeVideoEffectStream() {
                    var _this_sub;
                    (_this_sub = this.sub) === null || _this_sub === void 0 ? void 0 : _this_sub.dispose(), this.effectManager.stopEffect("Video", this.mediaStream);
                }
                applyState(g) {
                    var _g_getAudioTracks;
                    (_g_getAudioTracks = g.getAudioTracks()) === null || _g_getAudioTracks === void 0 ? void 0 : _g_getAudioTracks.forEach((g)=>this.applyAudioState(g));
                    const f = g.getVideoTracks()[0];
                    this.applyVideoState(f);
                }
                applyAudioState(g) {
                    g && (this.hasNonDefaultAudioProcessingConstraints() || "ScreenShare" === this.mediaType ? this.applyContentHint(g, "music") : this.configProvider.config.defaultAudioContentHint && this.applyContentHint(g, this.configProvider.config.defaultAudioContentHint), g.muted && this.event("onStreamTrackMuted").raise(this, !0), this.logger.safe.info(`Audio track added: ${JSON.stringify(g.id)}`));
                }
                applyVideoState(g) {
                    g && ("ScreenShare" === this.mediaType && this.configProvider.config.webrtcDisplayStreamContentHint && this.applyContentHint(g, this.configProvider.config.webrtcDisplayStreamContentHint), this.logger.safe.info(`Video track added: ${JSON.stringify(g.id)}`));
                }
                applyContentHint(g, f) {
                    this.logger.safe.info(`Apply content hint: ${f}`), g.contentHint = f;
                }
                hasNonDefaultAudioProcessingConstraints() {
                    const g = this.currentConstraints.audio;
                    if (g) {
                        const f = this.configProvider.config.defaultAudioProcessingFlags;
                        let S;
                        return void 0 === g.echoCancellation && void 0 === g.autoGainControl && void 0 === g.noiseSuppression || (S = 0, void 0 !== g.echoCancellation && (S += g.echoCancellation ? 2 : 0), void 0 !== g.autoGainControl && (S += g.autoGainControl ? 1 : 0), void 0 !== g.noiseSuppression && (S += g.noiseSuppression ? 4 : 0)), S !== f;
                    }
                    return !1;
                }
                getRequestStartTimestamp() {
                    return Date.now();
                }
                getRequestDuration(g) {
                    return 0 === g ? 0 : Date.now() - g;
                }
                stopMediaStream(g) {
                    return this.mediaStreamStartPromise ? (this.logger.safe.info(`Queueing media stream stop: ${g}`), this.serialQueue.add(()=>this.stopMediaStreamInternal())) : Promise.resolve();
                }
                stopOneMediaStream(g) {
                    try {
                        g.getTracks().forEach((g)=>{
                            this.logger.safe.info(`Track is stopped: ${JSON.stringify(g.id)}`), g.stop();
                        }), this.logger.safe.info(`Media stream stopped: ${g.id}`);
                    } catch (g) {
                        this.logger.safe.warn(`Failed to stop media stream: ${stringifyObject(g)}`);
                    }
                }
                stopMediaStreamInternal() {
                    "Video" === this.mediaType && this.configProvider.config.enableVideoEffects && this.removeVideoEffectStream(), this.mediaStream && (this.stopOneMediaStream(this.mediaStream), this.mediaStream = null), this.originalMediaStream && (this.stopOneMediaStream(this.originalMediaStream), this.unsubscribeFromTrackEvents(this.originalMediaStream), this.originalMediaStream = null);
                }
                onVideoStreamQualityChanged(g, f, S) {
                    this.logger.safe.debug(`onStreamQualityChanged: ${JSON.stringify(g)}@${f}, reason=${S}`), this.event("onStreamQualityChanged").raise(this, g, f, S);
                }
                constructor(g, f, S, v, _){
                    super(v), this.serialQueue = f, this.configProvider = S, this.effectManager = _, this.gumRequestTime = 0, this.id = _SimulcastMediaStream.streamId++, this.logger = v.createChild(`MediaStream:${this.id}`), this.mediaType = this.getMediaType(g), this.initialize(g);
                }
            };
            F_.streamId = 0;
            var x_ = F_, U_ = class {
                static getStrategy(g) {
                    switch(g.config.diagnostics.performanceMonitoring.monitoringStrategy){
                        case "decodeTime":
                        default:
                            return new V_(g);
                        case "renderedFps":
                            return new B_(g);
                        case "rendererVolatility":
                            return new H_(g);
                    }
                }
            }, V_ = class {
                checkQuality(g) {
                    let f = !1, S = !1;
                    const v = Zt.Recv.getResolutionRecord(Math.min(g.frameHeight, g.frameWidth)).height, _ = this.decodeThresholds[v] || this.defaultThreshold, C = g.decodeTimeTracker.getReport();
                    return C.median > _.maxDecodeTime && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) || 1), f = !0), C.median < _.maxDecodeTime && this.badPerfCount.get(g.msi) && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) - 1), S = !0), f ? 0 : S ? 2 : 1;
                }
                constructor(g){
                    this.configProvider = g, this.decodeThresholds = this.configProvider.config.diagnostics.performanceMonitoring.decodeThresholds, this.defaultThreshold = this.configProvider.config.diagnostics.performanceMonitoring.defaultThrehold, this.badPerfCount = new Map;
                }
            }, B_ = class {
                checkQuality(g) {
                    let f = !1, S = !1;
                    const v = Zt.Recv.getResolutionRecord(Math.min(g.frameHeight, g.frameWidth)).height, _ = this.fpsDiffThresholds[v] || this.defaultFpsDiffThreshold, C = g.incomingFps.getReport(), E = g.rendererFps.getReport(), T = C.median - E.median;
                    return T >= _.fpsDiff && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) || 1), f = !0), T < _.fpsDiff && this.badPerfCount.get(g.msi) && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) - 1), S = !0), f ? 0 : S ? 2 : 1;
                }
                constructor(g){
                    this.configProvider = g, this.fpsDiffThresholds = this.configProvider.config.diagnostics.performanceMonitoring.fpsDiffThresholds, this.defaultFpsDiffThreshold = this.configProvider.config.diagnostics.performanceMonitoring.defaultFpsDiffThreshold, this.badPerfCount = new Map;
                }
            }, H_ = class {
                checkQuality(g) {
                    let f = !1, S = !1;
                    const v = Zt.Recv.getResolutionRecord(Math.min(g.frameHeight, g.frameWidth)).height, _ = this.volatilityThresholds[v] || this.defaultVolatilityThreshold, C = g.rendererFps.getReport(), E = g.incomingFps.getReport(), T = Math.abs(C.volatilityPercent - E.volatilityPercent);
                    return _ && T >= _ && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) || 1), f = !0), T < _ && this.badPerfCount.get(g.msi) && (this.badPerfCount.set(g.msi, this.badPerfCount.get(g.msi) - 1), S = !0), f ? 0 : S ? 2 : 1;
                }
                constructor(g){
                    this.configProvider = g, this.volatilityThresholds = this.configProvider.config.diagnostics.performanceMonitoring.volatilityThresholds, this.defaultVolatilityThreshold = this.configProvider.config.diagnostics.performanceMonitoring.defaultVolatilityThreshold, this.badPerfCount = new Map;
                }
            }, $_ = class {
                client() {
                    return this.rawBaseClient;
                }
                disposeActiveMediaStreamClient() {
                    var _this_activeRawInputMediaStreamClient;
                    this.logger.info("Disposing active media stream client"), (_this_activeRawInputMediaStreamClient = this.activeRawInputMediaStreamClient) === null || _this_activeRawInputMediaStreamClient === void 0 ? void 0 : _this_activeRawInputMediaStreamClient.dispose("Disposed by RawDeviceStreamManager"), this.activeRawInputMediaStreamClient = null;
                }
                async getStream() {
                    var _this_activeRawInputMediaStreamClient_originalMediaStream, _this_activeRawInputMediaStreamClient;
                    return ((_this_activeRawInputMediaStreamClient = this.activeRawInputMediaStreamClient) === null || _this_activeRawInputMediaStreamClient === void 0 ? void 0 : (_this_activeRawInputMediaStreamClient_originalMediaStream = _this_activeRawInputMediaStreamClient.originalMediaStream) === null || _this_activeRawInputMediaStreamClient_originalMediaStream === void 0 ? void 0 : _this_activeRawInputMediaStreamClient_originalMediaStream.active) ? (this.logger.info("Returning stream from active mediaStreamClient"), this.activeRawInputMediaStreamClient.originalMediaStream) : (this.activeRawInputMediaStreamClient = await this.streamClient(), await this.activeRawInputMediaStreamClient.start(), this.activeRawInputMediaStreamClient.originalMediaStream);
                }
                constructor(g, f){
                    this.streamClient = g, this.logger = f, this.rawBaseClient = new Jr(()=>this.getStream(), ()=>{
                        var _this_activeRawInputMediaStreamClient;
                        return (_this_activeRawInputMediaStreamClient = this.activeRawInputMediaStreamClient) === null || _this_activeRawInputMediaStreamClient === void 0 ? void 0 : _this_activeRawInputMediaStreamClient.dispose();
                    }, f);
                }
            }, j_ = class {
                dispose(g) {
                    this.logger.info(`disposing IRawStream ${g}`), this.handlerMap.get(g).forEach((g)=>g.client().dispose());
                }
                disposeAll() {
                    this.logger.info("Dispose All clients"), this.handlerMap.forEach((g)=>g.forEach((g)=>g.client().dispose()));
                }
                notifyChange(g) {
                    this.handlerMap.get(g).forEach((g)=>{
                        g.disposeActiveMediaStreamClient(), g.client().notifyStreamChange();
                    });
                }
                createIRawStreamClient(g, f) {
                    this.logger.info(`Create new IRawStream client for ${f}`);
                    const S = new $_(g, this.logger);
                    this.handlerAdded(S, f);
                    return S.client();
                }
                handlerAdded(g, f) {
                    const S = g.client();
                    this.setClientSubscription(S, f), this.handlerMap.get(f).set(S.clientId, g);
                }
                deleteRawStreamManagerById(g, f) {
                    this.logger.info(`Deleting from map: ${f}`), this.handlerMap.get(f).delete(g);
                }
                setClientSubscription(g, f) {
                    this.logger.info(`Setting subscription on IRawStream client for ${f}`), g.on("clientDisposed", (S)=>{
                        this.deleteRawStreamManagerById(g.clientId, f), this.raiseTelemetryEvent("IRawStream_client_disposed", {
                            mediaType: f,
                            clientId: S
                        });
                    }), g.on("rawStreamRequested", (g)=>{
                        this.raiseTelemetryEvent("IRawStream_media_stream_changed", {
                            mediaType: f,
                            clientId: g
                        });
                    }), g.on("notifiedOnStreamChanged", (g)=>this.raiseTelemetryEvent("IRawStream_media_stream_changed", {
                            mediaType: f,
                            clientId: g
                        }));
                }
                constructor(g, f){
                    this.logger = g, this.raiseTelemetryEvent = f, this.handlerMap = new Map([
                        [
                            "Audio",
                            new Map
                        ],
                        [
                            "Video",
                            new Map
                        ],
                        [
                            "ScreenShare",
                            new Map
                        ]
                    ]);
                }
            }, G_ = class extends Bt {
                get muted() {
                    return this.isMuted;
                }
                async setMuted(g, f) {
                    return this.isMuted = g, g ? this.stopStream(f) : this.startStream(f);
                }
                async getSpeakerVolume(g) {
                    var _this_audio;
                    var _this_audio_volume;
                    const f = (_this_audio_volume = (_this_audio = this.audio) === null || _this_audio === void 0 ? void 0 : _this_audio.volume) !== null && _this_audio_volume !== void 0 ? _this_audio_volume : 0;
                    return this.logger.safe.info(`[${g}] get speaker volume: ${f}`), f;
                }
                async setSpeakerVolume(g, f) {
                    this.assureAudioElement(f), this.audio.volume = g, this.logger.safe.info(`[${f}] set speaker volume: ${g}`);
                }
                get canPlay() {
                    return this.stream && this.isPlayingAllowed;
                }
                getStream() {
                    return this.stream;
                }
                getDeviceId() {
                    return this.deviceId;
                }
                async play(g) {
                    if (this.stream = g, this.isPlayingAllowed = !0, !this.isMuted) return this.startStream();
                }
                stop() {
                    this.stopStream(), this.isPlayingAllowed = !1;
                }
                async setOutputDevice(g, f = generateCauseId()) {
                    if (this.audio) {
                        if (this.configProvider.config.disableAudioOutputSelection) this.logger.safe.warn(`[${f}] audio-output selection is disabled, disableAudioOutputSelection: true`);
                        else if (this.audio.setSinkId) {
                            if (g && g !== this.currentSinkId) {
                                var _this_audioRendererDiagnostics;
                                this.logger.safe.info(`[${f}] setting audio output device ID to ${scrubMriOrOmit(g)}`), this.deviceId = g;
                                try {
                                    this.configProvider.config.audioSetSinkIdWorkaround && this.stream && !this.stream.active ? (this.audio.srcObject = null, await this.audio.setSinkId(g), this.audio.srcObject = this.stream) : await this.audio.setSinkId(g), this.currentSinkId = g;
                                } catch (g) {
                                    this.logger.safe.warn(`[${f}] setSinkId operation was aborted with error ${stringifyObject(g)}`);
                                }
                                this.configProvider.config.audioRendererRestartOnDeviceError && this.hadPlaybackError && !this.isMuted && ((_this_audioRendererDiagnostics = this.audioRendererDiagnostics) === null || _this_audioRendererDiagnostics === void 0 ? void 0 : _this_audioRendererDiagnostics.registerReopenRequest(g), this.logger.safe.info(`[${f}] audio playback error happened, restarting audio stream on new device`), await this.startStream(f), this.hadPlaybackError = !1);
                            }
                        } else this.logger.safe.warn(`[${f}] setting output device is not supported`);
                    } else this.deviceId = g;
                }
                dispose() {
                    this.logger.safe.info("dispose"), super.dispose(), this.audio && (this.stop(), this.stream = void 0, this.audio.removeEventListener("error", this.onAudioError), this.audio.removeEventListener("pause", this.onAudioPaused), this.audio.removeEventListener("play", this.onAudioPlayed), this.window.document.body.removeChild(this.audio), this.event("onAudioElementRemoved").raise(this.audio), this.currentSinkId = void 0, this.audio = void 0), this.detachGainNode();
                }
                async startStream(g = generateCauseId()) {
                    if (this.canPlay) try {
                        var _this_stream;
                        await this.assureAudioElement(g), this.logger.safe.info(`[${g}] attaching stream to renderer: ${(_this_stream = this.stream) === null || _this_stream === void 0 ? void 0 : _this_stream.id}`), this.configProvider.config.speakerGainLevel && this.reattachToGainNode(this.stream, this.configProvider.config.speakerGainLevel), this.audio.srcObject = this.stream, await this.audio.play();
                    } catch (f) {
                        this.logger.safe.warn(`[${g}] play operation was aborted with error ${stringifyObject(f)}`);
                    }
                }
                async assureAudioElement(g = generateCauseId()) {
                    if (!this.audio) return this.logger.safe.info(`[${g}] creating audio element`), this.audio = this.window.document.createElement("audio"), this.audio.addEventListener("error", this.onAudioError), this.audio.addEventListener("pause", this.onAudioPaused), this.audio.addEventListener("play", this.onAudioPlayed), this.window.document.body.appendChild(this.audio), this.audio.autoplay = !0, this.event("onAudioElementAdded").raise(this.audio), this.setOutputDevice(this.deviceId, g);
                }
                stopStream(g = generateCauseId()) {
                    var _this_stream, _this_stream1;
                    this.audio && this.canPlay && (this.detachGainNode(), this.configProvider.config.audioRendererUsePauseOnDetach ? (this.logger.safe.info(`[${g}] Pausing with stream: ${(_this_stream = this.stream) === null || _this_stream === void 0 ? void 0 : _this_stream.id}`), this.audio.pause()) : (this.logger.safe.info(`[${g}] Detaching from stream: ${(_this_stream1 = this.stream) === null || _this_stream1 === void 0 ? void 0 : _this_stream1.id}`), this.audio.srcObject = null));
                }
                attachToGainNode(g, f) {
                    this.audioContext = new Qa.window.AudioContext, this.sourceNode = this.audioContext.createMediaStreamSource(g), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = f, this.sourceNode.connect(this.gainNode), this.gainNode.connect(this.audioContext.destination);
                }
                detachGainNode() {
                    var _this_sourceNode, _this_gainNode, _this_audioContext;
                    (_this_sourceNode = this.sourceNode) === null || _this_sourceNode === void 0 ? void 0 : _this_sourceNode.disconnect(), this.sourceNode = void 0, (_this_gainNode = this.gainNode) === null || _this_gainNode === void 0 ? void 0 : _this_gainNode.disconnect(), this.gainNode = void 0, (_this_audioContext = this.audioContext) === null || _this_audioContext === void 0 ? void 0 : _this_audioContext.close(), this.audioContext = void 0;
                }
                reattachToGainNode(g, f) {
                    this.detachGainNode(), this.attachToGainNode(g, f);
                }
                constructor(g, f, S){
                    super(g), this.logger = g, this.configProvider = f, this.audioRendererDiagnostics = S, this.window = Qa.window, this.isMuted = !1, this.isPlayingAllowed = !1, this.hadPlaybackError = !1, this.onAudioError = (g)=>{
                        const f = g && g.target || this.audio;
                        if (this.hadPlaybackError = !0, f === null || f === void 0 ? void 0 : f.error) {
                            const g = f.error.code, S = `error with rendering audio code: ${g}, message: ${f.error.message}`;
                            this.event("onAudioPlaybackError").raise(g, Gt.MEDIA_ERROR.audioPlaybackError, S), this.logger.safe.error(S);
                        } else this.logger.safe.error("error with audio rendering");
                    }, this.onAudioPaused = async ()=>{
                        if (this.configProvider.config.audioRendererRestartOnPause && this.canPlay && !this.isMuted) {
                            const g = generateCauseId();
                            this.logger.safe.info(`[${g}] audio playback is paused by OS, resuming it`), await this.startStream(g);
                        }
                    }, this.onAudioPlayed = ()=>{
                        var _this_audioRendererDiagnostics;
                        (_this_audioRendererDiagnostics = this.audioRendererDiagnostics) === null || _this_audioRendererDiagnostics === void 0 ? void 0 : _this_audioRendererDiagnostics.registerSuccessfullReopen(this.deviceId), this.logger.safe.info("Audio element started playing");
                    };
                }
            }, q_ = class {
                add(g, f = generateCauseId()) {
                    let S;
                    S = g instanceof ct ? ()=>g.promise : g;
                    const v = this.queue.then(S);
                    return this.queue = v.catch((g)=>{
                        if (this.queue) {
                            let S = "";
                            g instanceof TypeError && (S = g.stack), this.logger.safe.error(`[${f}] Error from promiseQueue! ${stringifyObject(g)} ${S}`);
                        }
                    }), v;
                }
                dispose() {
                    this.queue = null;
                }
                constructor(g){
                    this.logger = g, this.queue = Promise.resolve();
                }
            }, W_ = P, z_ = ((g)=>(g[g.NONE = 0] = "NONE", g[g.VIDEO = 1] = "VIDEO", g[g.AUDIO = 2] = "AUDIO", g))(z_ || {});
            function getRecvOverlayStats(g, f, S) {
                var _g_renderer;
                var _g_extensions, _f_codec, _f_extensions;
                const { ssrc: v, keyFramesDecoded: _, nackCount: C, firCount: E, pliCount: T, decoderImplementation: I, packetsLost: b } = g.inboundRTP, { frameRateReceived: A, frameRateDecoded: R, bitrate: P, decodeTime: w, isFrozen: M } = (_g_extensions = g.extensions) !== null && _g_extensions !== void 0 ? _g_extensions : {}, { sourceId: O, msid: D, streamSize: N, rendererSize: k } = S, L = ((_g_renderer = g.renderer) === null || _g_renderer === void 0 ? void 0 : _g_renderer.modality) === Gt.MODALITY.sharing, { audioLevel: F } = f.inboundRTP, { mimeType: x } = (_f_codec = f.codec) !== null && _f_codec !== void 0 ? _f_codec : {}, { healedRatio: U, lossRate: V } = (_f_extensions = f.extensions) !== null && _f_extensions !== void 0 ? _f_extensions : {};
                return {
                    streamSize: {
                        overlayTab: 1,
                        format: "{0}x{1}",
                        values: [
                            N === null || N === void 0 ? void 0 : N.width,
                            N === null || N === void 0 ? void 0 : N.height
                        ],
                        undefinedFallback: 0
                    },
                    rendererSize: {
                        overlayTab: 1,
                        format: "{0}x{1}",
                        values: [
                            k === null || k === void 0 ? void 0 : k.width,
                            k === null || k === void 0 ? void 0 : k.height
                        ],
                        undefinedFallback: 0
                    },
                    ssrc: {
                        overlayTab: 1,
                        values: [
                            v
                        ]
                    },
                    msid: {
                        overlayTab: 1,
                        text: "sourceId/msid",
                        format: "{0}/{1}",
                        values: [
                            O(),
                            D()
                        ]
                    },
                    fps: {
                        overlayTab: 1,
                        text: "FPS(r/d)",
                        format: "{0}/{1}",
                        values: [
                            A,
                            R
                        ],
                        highlightUndefined: !0,
                        lowerThreshold: 1,
                        upperThreshold: 45,
                        allowedDeviationThreshold: .2,
                        suppressHighlighting: L
                    },
                    bitrate: {
                        overlayTab: 1,
                        format: "{0} kbps",
                        values: [
                            toKbps(P)
                        ],
                        lowerThreshold: 24,
                        suppressHighlighting: L
                    },
                    decodeTime: {
                        overlayTab: 1,
                        format: "{0} ms",
                        values: [
                            w
                        ],
                        upperThreshold: 15,
                        highlightUndefined: !0,
                        suppressHighlighting: L
                    },
                    keyFramesDecoded: {
                        overlayTab: 1,
                        text: "KFs",
                        values: [
                            _
                        ]
                    },
                    nacksFirsPlisSent: {
                        overlayTab: 1,
                        text: "N/F/P",
                        format: "{0}/{1}/{2}",
                        values: [
                            C,
                            E,
                            T
                        ],
                        undefinedFallback: 0,
                        highlightChange: !0
                    },
                    packetsLost: {
                        overlayTab: 1,
                        text: "lost",
                        values: [
                            b
                        ],
                        undefinedFallback: 0,
                        highlightChange: !0
                    },
                    codecImplementationName: {
                        overlayTab: 1,
                        text: "decoder",
                        values: [
                            I
                        ],
                        highlightUndefined: !0
                    },
                    isFrozen: {
                        overlayTab: 1,
                        values: [
                            M ? "YES" : "NO"
                        ],
                        fixedValueThreshold: "NO"
                    },
                    audioCodec: {
                        overlayTab: 2,
                        values: [
                            x === null || x === void 0 ? void 0 : x.split("/").pop()
                        ]
                    },
                    audioLevel: {
                        overlayTab: 2,
                        values: [
                            round(F, 4)
                        ]
                    },
                    healedRatio: {
                        overlayTab: 2,
                        values: [
                            round(U, 4)
                        ],
                        upperThreshold: .2
                    },
                    lossRate: {
                        overlayTab: 2,
                        values: [
                            round(V, 4)
                        ],
                        upperThreshold: .1
                    }
                };
            }
            function getSendOverlayStats(g, f) {
                var _g_mediaSource, _g_mediaSource1, _g_transport_selectedCandidatePair, _g_transport;
                var _g_extensions, _f_codec, _f_extensions, _f_mediaSource;
                const { rid: S, ssrc: v, frameWidth: _, frameHeight: C, framesPerSecond: E, keyFramesEncoded: T, nackCount: I, firCount: b, pliCount: A, encoderImplementation: R, qualityLimitationReason: P } = g.outboundRTP, { cameraOpenResolution: w, bitrate: M, encodeTime: O, frameRateEncoded: D, frameRateSent: N, qp: k } = (_g_extensions = g.extensions) !== null && _g_extensions !== void 0 ? _g_extensions : {}, { mimeType: L } = (_f_codec = f.codec) !== null && _f_codec !== void 0 ? _f_codec : {}, { lossRate: F } = (_f_extensions = f.extensions) !== null && _f_extensions !== void 0 ? _f_extensions : {}, { audioLevel: x } = (_f_mediaSource = f.mediaSource) !== null && _f_mediaSource !== void 0 ? _f_mediaSource : {};
                return {
                    rid: {
                        overlayTab: 1,
                        values: [
                            S
                        ],
                        hideUndefined: !0
                    },
                    cameraSize: {
                        overlayTab: 1,
                        format: "{0}x{1}",
                        values: [
                            w === null || w === void 0 ? void 0 : w.width,
                            w === null || w === void 0 ? void 0 : w.height
                        ]
                    },
                    inputSize: {
                        overlayTab: 1,
                        format: "{0}x{1}",
                        values: [
                            (_g_mediaSource = g.mediaSource) === null || _g_mediaSource === void 0 ? void 0 : _g_mediaSource.width,
                            (_g_mediaSource1 = g.mediaSource) === null || _g_mediaSource1 === void 0 ? void 0 : _g_mediaSource1.height
                        ]
                    },
                    sentSize: {
                        overlayTab: 1,
                        format: "{0}x{1}",
                        values: [
                            _,
                            C
                        ]
                    },
                    ssrc: {
                        overlayTab: 1,
                        values: [
                            v
                        ]
                    },
                    fps: {
                        overlayTab: 1,
                        text: "FPS(i/e/s)",
                        format: "{0}/{1}/{2}",
                        values: [
                            E,
                            D,
                            N
                        ],
                        lowerThreshold: 7,
                        upperThreshold: 45,
                        allowedDeviationThreshold: .2
                    },
                    bitrate: {
                        overlayTab: 1,
                        format: "{0} kbps",
                        values: [
                            toKbps(M)
                        ],
                        lowerThreshold: 24
                    },
                    encodeTime: {
                        overlayTab: 1,
                        format: "{0} ms",
                        values: [
                            O
                        ],
                        upperThreshold: 15
                    },
                    keyFramesEncoded: {
                        overlayTab: 1,
                        text: "KFs",
                        values: [
                            T
                        ]
                    },
                    qp: {
                        overlayTab: 1,
                        values: [
                            k
                        ]
                    },
                    nacksFirsPlisRecv: {
                        overlayTab: 1,
                        text: "N/F/P",
                        format: "{0}/{1}/{2}",
                        values: [
                            I,
                            b,
                            A
                        ],
                        undefinedFallback: 0,
                        highlightChange: !0
                    },
                    codecImplementationName: {
                        overlayTab: 1,
                        text: "encoder",
                        values: [
                            R
                        ],
                        highlightUndefined: !0
                    },
                    qualityLimitationReason: {
                        overlayTab: 1,
                        text: "limited",
                        values: [
                            P
                        ],
                        fixedValueThreshold: "none"
                    },
                    bwe: {
                        overlayTab: 1,
                        format: "{0} kbps",
                        values: [
                            toKbps((_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate)
                        ],
                        lowerThreshold: 100
                    },
                    audioCodec: {
                        overlayTab: 2,
                        values: [
                            L === null || L === void 0 ? void 0 : L.split("/").pop()
                        ]
                    },
                    audioLevel: {
                        overlayTab: 2,
                        values: [
                            round(x, 4)
                        ]
                    },
                    lossRate: {
                        overlayTab: 2,
                        values: [
                            round(F, 4)
                        ]
                    }
                };
            }
            function toKbps(g) {
                return g && Math.floor((g || 0) / 1e3);
            }
            var K_ = class {
                dispose() {
                    this.topElement.removeChild(this.table), this.container.removeChild(this.topElement), this.table = null, this.topElement = null, this.container = null;
                }
                createTableColumn(g, f) {
                    for (const S of Object.keys(g)){
                        const v = g[S];
                        v.overlayTab === this.overlayTab && (v.hideUndefined && v.values.every((g)=>!g) || this.createTableRow(S, v, f));
                    }
                }
                createTableRow(g, f, S) {
                    this.elements[g] || (this.elements[g] = document.createElement("tr"), this.table.appendChild(this.elements[g]));
                    const v = `${g}-title`, _ = `${g}-${S}`, C = this.formatValue(f), E = this.previousSamples[_] !== C;
                    this.previousSamples[_] = C;
                    const T = isOutlier(f) || !(!f.highlightChange || !E);
                    this.elements[v] || (this.createTableCell(v, g, !1), this.elements[v].innerText = f.text ? f.text : g), this.createTableCell(_, g, !f.suppressHighlighting && T), this.elements[_].innerText = C;
                }
                clearTable() {
                    for(; this.table.hasChildNodes();)this.table.removeChild(this.table.lastChild);
                    this.elements = {};
                }
                getOverlayTab() {
                    return this.overlayTab;
                }
                addElementStyle(g, f) {
                    this.elements[g].style.color = f ? "#F72F35" : "#FBF719", this.elements[g].style.fontSize = "smaller", this.elements[g].style.lineHeight = "1", this.elements[g].style.padding = "0px 1px 0px 1px", this.elements[g].style.maxWidth = "60px", this.elements[g].style.overflow = "hidden", this.elements[g].style.whiteSpace = "nowrap", this.elements[g].style.textOverflow = "ellipsis";
                }
                formatValue(g) {
                    var _f_;
                    const { values: f, format: S, undefinedFallback: v = "N/A" } = g;
                    var _f__toString;
                    return S ? S.replace(this.formatRegexPattern, (g, S)=>{
                        var _f_S;
                        var _f_S_toString;
                        return (_f_S_toString = f === null || f === void 0 ? void 0 : (_f_S = f[S]) === null || _f_S === void 0 ? void 0 : _f_S.toString()) !== null && _f_S_toString !== void 0 ? _f_S_toString : v.toString();
                    }) : (_f__toString = f === null || f === void 0 ? void 0 : (_f_ = f[0]) === null || _f_ === void 0 ? void 0 : _f_.toString()) !== null && _f__toString !== void 0 ? _f__toString : v.toString();
                }
                constructor(g){
                    this.container = g, this.formatRegexPattern = new RegExp(/{(\d+)}/g), this.elements = {}, this.previousSamples = {}, this.overlayTab = 1, this.createTableCell = (g, f, S)=>{
                        this.elements[g] = document.createElement("td"), this.elements[g].title = g, this.addElementStyle(g, S), this.elements[f].appendChild(this.elements[g]);
                    }, this.topElement = g.ownerDocument.createElement("div"), this.topElement.classList.add("vdi-occlusion"), this.topElement.style.position = "absolute", this.topElement.style.top = "0px", this.topElement.style.left = "0px", this.topElement.style.zIndex = "100", this.topElement.style.transform = "inherit", this.topElement.style.backgroundColor = "rgba(0, 0, 0, 0.25)", this.topElement.style.pointerEvents = "all", this.topElement.style.minWidth = "15px", this.topElement.style.minHeight = "15px", this.topElement.style.cursor = "pointer", this.topElement.onclick = ()=>{
                        this.overlayTab = getNextTab(this.overlayTab);
                    }, this.container.appendChild(this.topElement), this.table = document.createElement("table"), this.table.style.borderCollapse = "collapse", this.table.style.fontSize = "smaller", this.topElement.appendChild(this.table);
                }
            }, J_ = class {
                setStats(g, f) {
                    this.overlay && (this.overlay.clearTable(), this.overlay.createTableColumn(getRecvOverlayStats(g, f, this.rendererStats), g.inboundRTP.id));
                }
                dispose() {
                    var _this_overlay;
                    this.subs.forEach((g)=>g.dispose()), this.subs = [], (_this_overlay = this.overlay) === null || _this_overlay === void 0 ? void 0 : _this_overlay.dispose(), this.overlay = null, this.container = null, this.renderer = null;
                }
                constructor(g, f, S){
                    this.container = f, this.renderer = S, this.subs = [], g && !this.overlay && (this.overlay = new K_(this.container), this.rendererStats = {
                        msid: ()=>this.renderer.getLocalMsi(),
                        sourceId: ()=>this.renderer.getMsi()
                    }, this.subs.push(this.renderer.on("onVideoSizeChanged", (g, f)=>this.rendererStats.streamSize = {
                            width: g,
                            height: f
                        })), this.subs.push(this.renderer.on("onRendererSizeChanged", (g, f)=>this.rendererStats.rendererSize = {
                            width: Math.ceil(f.width),
                            height: Math.ceil(f.height)
                        })));
                }
            }, Y_ = class {
                setStats(g, f) {
                    if (!this.overlay) return;
                    if (this.overlay.clearTable(), 2 === this.overlay.getOverlayTab()) return void this.overlay.createTableColumn(getSendOverlayStats(g, f), g.outboundRTP.id);
                    var _g_altLayouts;
                    const S = [
                        g,
                        ...(_g_altLayouts = g.altLayouts) !== null && _g_altLayouts !== void 0 ? _g_altLayouts : []
                    ];
                    for (const g of S)this.overlay.createTableColumn(getSendOverlayStats(g, f), g.outboundRTP.id);
                }
                dispose() {
                    var _this_overlay;
                    (_this_overlay = this.overlay) === null || _this_overlay === void 0 ? void 0 : _this_overlay.dispose(), this.overlay = null, this.container = null;
                }
                constructor(g, f){
                    this.container = f, g && !this.overlay && (this.overlay = new K_(this.container));
                }
            };
            function getNextTab(g) {
                const f = Object.keys(z_).filter((g)=>isNaN(Number(g))), S = (g + 1) % f.length;
                return z_[f[S]];
            }
            function isOutlier(g) {
                const { values: f, lowerThreshold: S, upperThreshold: v, highlightUndefined: _, fixedValueThreshold: C, allowedDeviationThreshold: E } = g;
                for (const g of f){
                    if (void 0 === g && null === g && _) return !0;
                    if (C && C !== g) return !0;
                    if (null == g || !(0, W_.isNumber)(g)) return !1;
                    if (S && Number(g) <= S) return !0;
                    if (v && Number(g) >= v) return !0;
                    if (E) {
                        const S = (0, W_.mean)(f), v = S * E;
                        if (Math.abs(Number(g) - S) > v) return !0;
                    }
                }
                return !1;
            }
            function getObjectFitValue(g) {
                switch(g){
                    case "crop":
                        return "cover";
                    case "stretch":
                        return "fill";
                    default:
                        return "contain";
                }
            }
            var Q_ = class _VideoRendererBase extends Bt {
                getVideoElement() {
                    return this.video;
                }
                dispose() {
                    super.dispose(), this.isVideoAttached && (this.container.removeChild(this.video), this.isVideoAttached = !1), this.detachEventListeners(), this.attachMediaStream(null), this.video = null, this.stream = null, this.canvas = null, this.context = null;
                }
                attachMediaStream(g) {
                    this.stream !== g && (this.stream && (this.video.srcObject = null), g && (this.video.hidden = 0 === g.getVideoTracks().length, this.video.srcObject = g, this.isVideoAttached || (this.container.appendChild(this.video), this.isVideoAttached = !0)), this.stream = g);
                }
                setScalingMode(g) {
                    this.video.style.objectFit = getObjectFitValue(g);
                }
                getMediaStream() {
                    return this.stream;
                }
                getTrackId() {
                    var _this_stream_getTracks_, _this_stream;
                    var _this_stream_getTracks__id;
                    return (_this_stream_getTracks__id = (_this_stream = this.stream) === null || _this_stream === void 0 ? void 0 : (_this_stream_getTracks_ = _this_stream.getTracks()[0]) === null || _this_stream_getTracks_ === void 0 ? void 0 : _this_stream_getTracks_.id) !== null && _this_stream_getTracks__id !== void 0 ? _this_stream_getTracks__id : void 0;
                }
                async captureFrame() {
                    var _g_getVideoTracks_, _g_getVideoTracks, _g_getVideoTracks1;
                    const g = this.stream;
                    if (!g) throw this.logger.safe.error("Mediastream not found"), new Error("Mediastream not found");
                    const f = (_g_getVideoTracks1 = g.getVideoTracks) === null || _g_getVideoTracks1 === void 0 ? void 0 : (_g_getVideoTracks = _g_getVideoTracks1.call(g)) === null || _g_getVideoTracks === void 0 ? void 0 : (_g_getVideoTracks_ = _g_getVideoTracks[0]) === null || _g_getVideoTracks_ === void 0 ? void 0 : _g_getVideoTracks_.getSettings(), S = f === null || f === void 0 ? void 0 : f.width, v = f === null || f === void 0 ? void 0 : f.height;
                    if (!S || !v) throw this.logger.safe.error("Failed to get video track width/height"), new Error("Failed to get video track width/height");
                    const _ = this.getImageData(S, v);
                    return {
                        getSize: ()=>({
                                width: S,
                                height: v
                            }),
                        isMirrored: ()=>!1,
                        getImageData: ()=>_
                    };
                }
                playVideo() {
                    var _this_video;
                    ((_this_video = this.video) === null || _this_video === void 0 ? void 0 : _this_video.paused) && this.video.play().catch((g)=>{
                        this.logger.safe.error(`Play video error: ${g}`);
                    });
                }
                getImageData(g, f) {
                    var _this_canvas, _this_context;
                    if ((_this_canvas = this.canvas) !== null && _this_canvas !== void 0 ? _this_canvas : this.canvas = this.container.ownerDocument.createElement("canvas"), (_this_context = this.context) !== null && _this_context !== void 0 ? _this_context : this.context = this.canvas.getContext("2d"), !this.context) throw this.logger.safe.error("Failed to get canvas 2d context"), new Error("Failed to get canvas 2d context");
                    this.canvas.width = g, this.canvas.height = f, this.context.drawImage(this.video, 0, 0, g, f);
                    return this.context.getImageData(0, 0, g, f);
                }
                attachEventListeners() {
                    this.video.addEventListener("loadedmetadata", this.onVideoDataUpdated), this.video.addEventListener("timeupdate", this.onVideoDataUpdated), this.video.addEventListener("error", this.onVideoError), this.video.addEventListener("pause", this.onVideoPaused), this.video.addEventListener("contextmenu", this.onContextMenu), this.video.addEventListener("play", this.onVideoPlayed);
                }
                detachEventListeners() {
                    this.video.removeEventListener("loadedmetadata", this.onVideoDataUpdated), this.video.removeEventListener("timeupdate", this.onVideoDataUpdated), this.video.removeEventListener("error", this.onVideoError), this.video.removeEventListener("pause", this.onVideoPaused), this.video.removeEventListener("contextmenu", this.onContextMenu), this.video.removeEventListener("play", this.onVideoPlayed);
                }
                constructor(g, f, S){
                    const v = f.createChild("" + _VideoRendererBase.rendererId++);
                    super(v), this.container = g, this.configProvider = S, this.video = this.container.ownerDocument.createElement("video"), this.lastNotifiedVideoWidth = 0, this.lastNotifiedVideoHeight = 0, this.isVideoAttached = !1, this.onVideoDataUpdated = ()=>{
                        let g = this.video.videoWidth, f = this.video.videoHeight;
                        (g < 32 || f < 32) && (g = f = 0), this.lastNotifiedVideoWidth === g && this.lastNotifiedVideoHeight === f || (this.lastNotifiedVideoWidth = g, this.lastNotifiedVideoHeight = f, this.event("onVideoSizeChanged").raise(g, f)), this.playVideo();
                    }, this.onVideoError = ()=>{
                        this.logger.safe.info(`onVideoError: error with video rendering: ${JSON.stringify(this.video.error) || "no video"}`), this.event("onVideoRendererStateChanged").raise({
                            timestamp: Date.now(),
                            state: "onError",
                            payload: JSON.stringify(this.video.error) || "no video"
                        });
                    }, this.onVideoPaused = ()=>{
                        this.logger.safe.info("onVideoPaused: video playback is paused"), this.event("onVideoRendererStateChanged").raise({
                            timestamp: Date.now(),
                            state: "onVideoPaused"
                        }), this.playVideo();
                    }, this.onVideoPlayed = ()=>{
                        this.logger.safe.info("onVideoPlayed"), this.event("onVideoRendererStateChanged").raise({
                            timestamp: Date.now(),
                            state: "onVideoPlayed"
                        });
                    }, this.onContextMenu = (g)=>{
                        g.preventDefault();
                    }, this.logger = v, this.video.style.width = "100%", this.video.style.height = "100%", this.video.setAttribute("playsinline", "true"), this.video.disablePictureInPicture = !0, this.video.autoplay = !0, this.video.muted = !0, this.attachEventListeners(), this.logger.safe.info("created");
                }
            };
            Q_.rendererId = 0;
            var X_ = Q_, Z_ = class extends X_ {
                dispose() {
                    this.logger.safe.info("dispose"), this.isDisposed = !0, this.event("onRendererDisposed").raise(this), super.dispose(), this.mediaStream && (this.mediaStream.dispose(), this.mediaStream = null), this.overlayStats.dispose();
                }
                setVideoMirroring(g) {
                    this.configProvider.config.localPreviewMirroringSupported && (this.getVideoElement().style.transform = g ? "scaleX(-1)" : void 0);
                }
                startVideoAsync(g = generateCauseId()) {
                    return this.logger.safe.info(`[${g}] starting local video`), this.event("onRendererStarted").raise(this), this.serialQueue.add(()=>this.restartVideo(), g);
                }
                updateStreamAsync(g = generateCauseId()) {
                    return this.logger.safe.info(`[${g}] updating local video`), this.serialQueue.add(()=>this.restartVideo(), g);
                }
                onDiagnosticUpdated(g) {
                    var _g_video_send, _g_video, _g_audio_send, _g_audio;
                    ((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length) && ((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : (_g_audio_send = _g_audio.send) === null || _g_audio_send === void 0 ? void 0 : _g_audio_send.length) && this.overlayStats.setStats(g.video.send[0], g.audio.send[0]);
                }
                async restartVideo() {
                    try {
                        let g;
                        if ("Video" === this.mediaType) g = await this.mediaStreamProvider.getVideoStream(!1, "localVideoRenderer");
                        else {
                            if ("ScreenShare" !== this.mediaType) throw new Error("Not yet supported");
                            g = await this.mediaStreamProvider.getDisplayStream("localSSRenderer");
                        }
                        if (await g.start(), this.isDisposed) throw g.dispose(), new Error("local video renderer is disposed");
                        this.attachStream(g);
                    } catch (g) {
                        throw this.mediaStreamProvider.raiseTelemetryEvent("video_preview_error", {
                            mediaType: this.mediaType,
                            error: stringifyObject(g)
                        }), g;
                    }
                }
                attachStream(g) {
                    if (this.mediaStream !== g) {
                        var _this_mediaStream;
                        if (((_this_mediaStream = this.mediaStream) === null || _this_mediaStream === void 0 ? void 0 : _this_mediaStream.parentId) !== (g === null || g === void 0 ? void 0 : g.parentId)) {
                            this.logger.safe.info(`attach media stream ${g === null || g === void 0 ? void 0 : g.id}`);
                            try {
                                this.mediaStream && (this.mediaStream.dispose(), this.mediaStream = null), g && super.attachMediaStream(g.rawStream), this.mediaStream = g;
                            } catch (f) {
                                throw g && g.dispose(), f;
                            }
                        } else g.dispose();
                    }
                }
                constructor(g, f, S, v, _){
                    super(g, S.createChild("local"), v), this.mediaStreamProvider = f, this.mediaType = _, this.isDisposed = !1, this.serialQueue = new q_(this.logger.createChild("rendererQueue")), this.logger.safe.info("ctor"), this.overlayStats = new Y_(this.configProvider.config.showStatsInCall, g);
                }
            }, eC = class extends Bt {
                get id() {
                    return this.originalId;
                }
                get parentId() {
                    return this.originalId;
                }
                get rawStream() {
                    return this.gumStream;
                }
                get rawTrack() {
                    return this.getTrackByMediaType(this.rawStream, this.mediaType);
                }
                get deviceId() {
                    return this.mediaStream.deviceId;
                }
                update(g) {
                    g && (this.gumStream = g, this.enableDisableTracks());
                }
                dispose() {
                    this._isDisposed ? this.logger.safe.info("already disposed") : (this._isDisposed = !0, this.logger.safe.info("dispose"), this.logger = this.logger.createChild("DISPOSED"), this.event("onStreamClientDisposing").raise(this), this.mediaStream && (this.mediaStream.disposeClient(this), this.unsubscribeFromMediaStreamEvents(), this.mediaStream = null), this.event("onStreamClientDisposed").raise(this));
                }
                clone() {
                    const g = this.mediaStream.getClient();
                    return this.isMuted && g.setMuted(!0), this.isHold && g.setHold(!0), g;
                }
                applyCapabilities(g) {
                    return this.mediaStream.applyCapabilities(g);
                }
                setMuted(g, f = generateCauseId()) {
                    this.isMuted = g || this.mediaStream.getMuted(), this.logger.safe.info(`[${f}] setMuted => ${this.isMuted}`), this.enableDisableTracks();
                }
                setHold(g) {
                    this.isHold = g, this.enableDisableTracks();
                }
                start() {
                    return this.mediaStream.start();
                }
                hasAudio() {
                    return this.mediaStream.hasAudio();
                }
                hasVideo() {
                    return this.mediaStream.hasVideo();
                }
                hasDisplay() {
                    return this.mediaStream.hasDisplay();
                }
                isSameStream(g) {
                    return this.parentId === g.parentId;
                }
                getResolution() {
                    return this.mediaStream.getResolution();
                }
                getFrameRate() {
                    return this.mediaStream.getFrameRate();
                }
                isActive() {
                    return !0;
                }
                isDisposed() {
                    return this._isDisposed;
                }
                subscribeOnMediaStreamEvents() {
                    this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamStarted", (g, f)=>{
                        this.event("onStreamClientStarted").raise(this, f);
                    })), this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamError", (g, f)=>{
                        this.event("onStreamClientError").raise(this, f);
                    })), this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamTrackMuted", (g, f)=>{
                        this.event("onStreamClientMuted").raise(this, f);
                    })), this.mediaStreamSubscriptions.push(this.mediaStream.on("onStreamTrackEnded", (g, f)=>{
                        this.event("onStreamClientEnded").raise(this, f);
                    }));
                }
                unsubscribeFromMediaStreamEvents() {
                    this.mediaStreamSubscriptions.forEach((g)=>g.dispose()), this.mediaStreamSubscriptions = [];
                }
                enableDisableTracks() {
                    this.gumStream ? this.gumStream.getTracks().forEach((g)=>{
                        void 0 !== g.enabled && (g.enabled = !this.isMuted && !this.isHold, this.logger.safe.info(`Track ${JSON.stringify(g.id)} enabled state set to => ${g.enabled}`));
                    }) : this.logger.safe.warn("gumStream stream doesn't exist");
                }
                getTrackByMediaType(g, f) {
                    return "Audio" === f ? g.getAudioTracks()[0] : g.getVideoTracks()[0];
                }
                constructor(g, f, S){
                    super(S), this.mediaStream = g, this.logger = S, this.mediaStreamSubscriptions = [], this.isHold = !1, this.isMuted = this.mediaStream.getMuted(), this._isDisposed = !1, this.originalId = g.id, this.subscribeOnMediaStreamEvents(), this.update(f), this.logger.safe.info("ctor"), this.mediaType = this.mediaStream.mediaType;
                }
            }, tC = class _MediaStreamInternal extends Bt {
                get id() {
                    return this.streamId;
                }
                get rawStream() {
                    return this.currentGumStream;
                }
                get deviceId() {
                    var _this_rawStream_getTracks__getSettings, _this_rawStream_getTracks__getSettings1, _this_rawStream_getTracks_, _this_rawStream_getTracks, _this_rawStream;
                    var _this_rawStream_getTracks__getSettings_deviceId;
                    return (_this_rawStream_getTracks__getSettings_deviceId = (_this_rawStream = this.rawStream) === null || _this_rawStream === void 0 ? void 0 : (_this_rawStream_getTracks = _this_rawStream.getTracks()) === null || _this_rawStream_getTracks === void 0 ? void 0 : (_this_rawStream_getTracks_ = _this_rawStream_getTracks[0]) === null || _this_rawStream_getTracks_ === void 0 ? void 0 : (_this_rawStream_getTracks__getSettings1 = _this_rawStream_getTracks_.getSettings) === null || _this_rawStream_getTracks__getSettings1 === void 0 ? void 0 : (_this_rawStream_getTracks__getSettings = _this_rawStream_getTracks__getSettings1.call(_this_rawStream_getTracks_)) === null || _this_rawStream_getTracks__getSettings === void 0 ? void 0 : _this_rawStream_getTracks__getSettings.deviceId) !== null && _this_rawStream_getTracks__getSettings_deviceId !== void 0 ? _this_rawStream_getTracks__getSettings_deviceId : null;
                }
                applyCapabilities(g) {
                    if (this.currentGumStream) {
                        const f = this.constraintsProvider.updateVideoConstraints(this.currentConstraints, g, this.getResolution());
                        if (!f) return Promise.resolve(!1);
                        if (this.currentConstraints !== f) {
                            this.currentConstraints = f;
                            const g = this.currentConstraints;
                            return this.hasDisplay() ? this.applyConstraints(this.currentConstraints).then(()=>deepEqual(this.currentConstraints, g)).catch((g)=>(this.logger.safe.error(`Apply constraints error: ${stringifyObject(g)}`), !1)) : this.applyConstraintsInternal().then(()=>deepEqual(this.currentConstraints, g));
                        }
                    }
                    return Promise.resolve(!1);
                }
                getClient() {
                    let g;
                    this.currentGumStream ? (g = this.getClone(), this.clientGumStreams.push({
                        [this.constraintsProvider.getKey(this.currentConstraints)]: g
                    })) : this.clientGumStreams.push({});
                    const f = new eC(this, g, this.logger.createChild("Client:" + this.clientId++));
                    return this.clients.push(f), f;
                }
                getClone() {
                    return this.hasDisplay() ? this.currentGumStream : this.currentGumStream.clone();
                }
                setMuted(g) {
                    this.isMuted = g, this.clients.forEach((f)=>{
                        f.setMuted(g);
                    }), this.enableDisableTracks();
                }
                getMuted() {
                    return this.isMuted;
                }
                setHold(g) {
                    this.isHold = g, this.clients.forEach((f)=>{
                        f.setHold(g);
                    }), this.enableDisableTracks();
                }
                start() {
                    return this.mediaStreamStartPromise || (this.mediaStreamStartPromise = this.startStream(this.currentConstraints)), this.mediaStreamStartPromise;
                }
                dispose() {
                    for(let g = this.clients.length - 1; g >= 0; g--)this.clients[g].dispose();
                }
                disposeClient(g) {
                    const f = this.clients.indexOf(g);
                    f >= 0 && (this.clients.splice(f, 1), this.streamsDump.push(this.clientGumStreams[f]), this.clientGumStreams.splice(f, 1), 0 === this.clients.length) && this.disposeStream();
                }
                async disposeStream() {
                    this.event("onStreamDisposing").raise(this);
                    try {
                        await this.stopGumStream(), this.event("onStreamDisposed").raise(this);
                    } catch (g) {
                        this.event("onStreamError").raise(this, g);
                    }
                    this.constraintsProvider = null, this.serialQueue = null, this.configProvider = null, this.logger = this.logger.createChild("DISPOSED"), super.dispose();
                }
                hasAudio() {
                    return !!this.currentGumStream && 0 !== this.currentGumStream.getAudioTracks().length;
                }
                hasVideo() {
                    return !!this.currentGumStream && 0 !== this.currentGumStream.getVideoTracks().length && this.currentConstraints.video && this.currentConstraints.video.deviceId !== Gt.DISPLAY_SOURCE_ID;
                }
                hasDisplay() {
                    return !!this.currentGumStream && 0 !== this.currentGumStream.getVideoTracks().length && this.currentConstraints.video && this.currentConstraints.video.deviceId === Gt.DISPLAY_SOURCE_ID;
                }
                getVideoDeviceId() {
                    return this.currentConstraints.video.deviceId;
                }
                getResolution() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = {
                        width: this.currentConstraints.video.minWidth,
                        height: this.currentConstraints.video.minHeight
                    }, f = getResolutionForStream(this.currentGumStream), S = f !== null && f !== void 0 ? f : g, v = `Stream resolution is ${S.width}x${S.height}.`;
                    return f ? this.logger.safe.info(v) : this.logger.safe.error(`${v}. Resolution not found, assuming default resolution.'`), S;
                }
                getFrameRate() {
                    if (![
                        "Video",
                        "ScreenShare",
                        "PanoramicVideo"
                    ].some((g)=>g === this.mediaType)) return null;
                    const g = getFrameRateForStream(this.currentGumStream);
                    return 0 === g ? this.logger.safe.error("Stream frame rate is not avalable, returning 0") : this.logger.safe.info(`Stream fps is ${g}`), g;
                }
                async startStream(g) {
                    let f;
                    f = g.video ? this.applyConstraintsInternal() : this.updateGumStreamInternal(g);
                    try {
                        await f, this.event("onStreamStarted").raise(this, g);
                    } catch (g) {
                        throw this.event("onStreamError").raise(this, g), g;
                    }
                }
                getMediaType(g) {
                    if (g.sharing) return "ScreenShare";
                    if (g.video) return "Video";
                    if (g.audio) return "Audio";
                    throw new Error(`Media type is not defined: ${JSON.stringify(g)}`);
                }
                updateClients(g) {
                    const f = this.constraintsProvider.getKey(g);
                    this.clients.forEach((g, S)=>{
                        this.clientGumStreams[S][f] || (this.clientGumStreams[S][f] = this.getClone()), g.update(this.clientGumStreams[S][f]);
                    });
                }
                applyConstraints(g) {
                    const f = this.getGumStreamProvider();
                    return Promise.all(this.clients.map((S)=>f.applyConstraints(S.rawStream, g))).then(()=>{});
                }
                applyConstraintsInternal() {
                    return new Promise((g, f)=>{
                        this.logger.safe.info(`applying stream constraints: ${JSON.stringify(scrubConstraints(this.currentConstraints))}`);
                        const S = new ct;
                        this.clients.forEach((g)=>{
                            g.onApplyConstraints && g.onApplyConstraints(S.promise);
                        });
                        const v = this.serialQueue.add(()=>{
                            const g = (new M_).getPolicies(this.currentConstraints);
                            return this.mediaStreamStartPromise = this.updateGumStreamInternal(g[0]), g.slice(1).forEach((g)=>{
                                this.mediaStreamStartPromise = this.mediaStreamStartPromise.catch((f)=>{
                                    if (Gt.MEDIA_ERROR.constraintNotSatisfiedError === f.type) return this.logger.safe.warn("could not obtain constrained media stream, will attempt weaker policy"), this.updateGumStreamInternal(g);
                                    throw f.constraints = g, f;
                                });
                            }), this.mediaStreamStartPromise;
                        }).then(()=>{
                            S.resolve();
                        }).catch((g)=>{
                            throw this.logger.safe.error(`failed to apply constraints: ${JSON.stringify(scrubConstraints(g.constraints))} error: ${stringifyObject(g)}`), S.reject(g), g;
                        });
                        g(v);
                    });
                }
                enableDisableTracks() {
                    this.currentGumStream && this.currentGumStream.getTracks().forEach((g)=>{
                        void 0 !== g.enabled && (g.enabled = !("audio" === g.kind && this.isMuted || this.isHold), this.logger.safe.info(`control media stream track kind: ${g.kind} enabled: ${g.enabled} muted: ${g.muted}`));
                    });
                }
                getGumStreamProvider() {
                    return A_.getStreamProvider(this.mediaType, this.configProvider, this.logger.createChild("MSProvider"));
                }
                async updateGumStreamInternal(g) {
                    this.logger.safe.info(`querying user media for stream: ${JSON.stringify(g)}`), this.logger.safe.info("Getting GUM stream");
                    const f = await this.getGumStream(g);
                    this.logger.safe.info("Updating gum stream audio tracks"), this.updateGumStreamAudioTracks(f), this.currentGumStream = f, this.logger.safe.info("Updating stream constraints"), this.updateConstraints(g, f), this.logger.safe.info("Caching GUM stream"), this.cacheGumStream(this.currentConstraints, f), this.updateClients(this.currentConstraints), this.updateGumStreamVideoTracks(f), this.enableDisableTracks(), this.logger.safe.info("media stream updated");
                    const S = this.stopRequestCalculation();
                    this.event("onStreamAcquired").raise(this, S, (this.hasVideo() || this.hasDisplay()) && this.getResolution() || void 0);
                }
                async getGumStream(g) {
                    const f = this.gumStreams[this.constraintsProvider.getKey(g)];
                    if (f) return f;
                    const S = this.getGumStreamProvider();
                    return this.startRequestCalculation(), S.getStream(g);
                }
                updateGumStreamAudioTracks(g) {
                    g.getAudioTracks().forEach((g)=>{
                        g.onended = (g)=>{
                            var _g_error;
                            this.logger.safe.info(`Audio stream track ended: ${JSON.stringify(((_g_error = g.error) === null || _g_error === void 0 ? void 0 : _g_error.name) || g)}`), this.event("onStreamTrackEnded").raise(this, g);
                        }, g.onmute = ()=>{
                            this.logger.safe.info("Audio stream track muted"), this.event("onStreamTrackMuted").raise(this, !0);
                        }, g.onunmute = ()=>{
                            this.logger.safe.info("Audio stream track unmuted"), this.event("onStreamTrackMuted").raise(this, !1);
                        }, g.muted && this.event("onStreamTrackMuted").raise(this, !0), this.logger.safe.info(`Audio track added: ${JSON.stringify(g.id)}`);
                    });
                }
                updateGumStreamVideoTracks(g) {
                    const [f] = g.getVideoTracks();
                    f && (f.onmute = (g)=>{
                        this.logger.safe.error(`Video stream track muted: ${JSON.stringify(scrubConstraints(this.currentConstraints))}; ${JSON.stringify(g)}`);
                    }, f.onended = (g)=>{
                        this.logger.safe.info(`Video stream track ended: ${JSON.stringify(scrubConstraints(this.currentConstraints))}; ${JSON.stringify((g === null || g === void 0 ? void 0 : g.error.name) || g)}`), this.event("onStreamTrackEnded").raise(this, g);
                    }, this.hasDisplay() && this.configProvider.config.webrtcDisplayStreamContentHint && this.applyContentHint(f, this.configProvider.config.webrtcDisplayStreamContentHint), this.logger.safe.info(`Video track added: ${JSON.stringify(f.id)}`));
                }
                cacheGumStream(g, f) {
                    const S = this.constraintsProvider.getKey(g);
                    this.gumStreams[S] !== f && (this.gumStreams[S] && (this.logger.safe.info(`Stream cache hit for ${S}, stopping old stream`), this.stopOneGumStream(this.gumStreams[S])), this.gumStreams[S] = f);
                }
                updateConstraints(g, f) {
                    this.currentConstraints = g.video ? this.constraintsProvider.updateResolution(g, this.getResolution()) : g, this.logger.safe.info(`Stream constraints updated: ${JSON.stringify(this.currentConstraints)}`);
                }
                applyContentHint(g, f) {
                    [
                        "",
                        "text",
                        "detail",
                        "motion"
                    ].indexOf(f) < 0 ? this.logger.safe.error(`Cannot apply content hint: ${f}`) : (this.logger.safe.info(`Apply content hint: ${f}`), g.contentHint = f);
                }
                startRequestCalculation() {
                    this.gumStartTime = Date.now();
                }
                stopRequestCalculation() {
                    if (0 === this.gumStartTime) return 0;
                    const g = Date.now() - this.gumStartTime;
                    return this.gumStartTime = 0, g;
                }
                stopGumStream() {
                    return this.mediaStreamStartPromise ? (this.logger.safe.info("queueing media stream stop"), this.serialQueue.add(()=>{
                        this.stopGumStreamInternal();
                    })) : Promise.resolve();
                }
                stopOneGumStream(g) {
                    try {
                        g.getTracks().forEach((g)=>{
                            this.logger.safe.info(`Track is stopped: ${JSON.stringify(g.id)}`), g.onended = null, g.onmute = null, g.stop();
                        }), this.logger.safe.info("media stream stopped");
                    } catch (g) {
                        this.logger.safe.warn(`failed to stop media stream: ${stringifyObject(g)}`);
                    }
                }
                stopGumStreamInternal() {
                    this.currentGumStream && ([
                        ...this.clientGumStreams,
                        ...this.streamsDump,
                        this.gumStreams
                    ].forEach((g)=>{
                        forOwn(g, (g)=>{
                            this.stopOneGumStream(g);
                        });
                    }), this.gumStreams = {}, this.clientGumStreams = [], this.streamsDump = [], this.currentGumStream = null);
                }
                constructor(g, f, S, v){
                    super(S), this.streamConstraints = g, this.serialQueue = f, this.configProvider = v, this.clientId = 0, this.clients = [], this.gumStreams = {}, this.clientGumStreams = [], this.streamsDump = [], this.isMuted = !1, this.isHold = !1, this.gumStartTime = 0, this.streamId = _MediaStreamInternal.streamGeneration++, this.logger = S.createChild(`MediaStream:${this.streamId}`), this.mediaType = this.getMediaType(this.streamConstraints), this.constraintsProvider = f_.getProvider(this.mediaType, this.configProvider, this.logger), this.currentConstraints = this.constraintsProvider.createConstraintsObject(g);
                }
            };
            tC.streamGeneration = 0;
            var iC = tC, nC = class _MediaStreamManager extends Bt {
                getMediaStream(g, f) {
                    this.logger.safe.info(`retrieving media stream: ${JSON.stringify(scrubConstraints(g))}`), this.cachedStreamsMap.size || (this.couldUseWebrtc_1_0 = canUseWebrtc1_0(this.configProvider.config.checkSupportForWebrtc_1_0));
                    let S = this.getSuitableStream(g);
                    S || (this.logger.safe.info(`cached stream is not found. Creating a new one with constraints: ${stringifyObject(scrubConstraints(g))}`), S = this.createCachedStream(g)), this.logger.safe.info(`starting cached stream id=${S.id}`, f);
                    const v = S.getClient(f);
                    return v.start().catch((g)=>{
                        this.logger.safe.error(`could not start media stream: ${S.id}, total streams: ${this.cachedStreamsMap.size}, error: ${stringifyObject(g)}`), this.removeStream(S);
                    }), v;
                }
                dispose() {
                    this.cachedStreamsSubs && (this.cachedStreamsSubs.forEach((g)=>{
                        g.forEach((g)=>{
                            g.dispose();
                        });
                    }), this.cachedStreamsSubs = null), this.cachedStreamsMap && (this.cachedStreamsMap.forEach((g)=>g.dispose("MSM dispose")), this.cachedStreamsMap = null), this.mediaStreamSerialQueue && (this.mediaStreamSerialQueue.dispose(), this.mediaStreamSerialQueue = null), super.dispose();
                }
                getCachedStreams() {
                    return this.cachedStreamsMap;
                }
                getActiveConstraints() {
                    const g = {
                        audio: !1,
                        video: !1,
                        sharing: !1
                    };
                    return this.cachedStreamsMap.forEach((f, S)=>{
                        S.audio && (g.audio = !0), S.video && (g.video = !0), S.sharing && (g.sharing = !0);
                    }), g;
                }
                onDevicesChanged(g) {
                    this.configProvider.config.enablePermissionsWorkaround && _MediaStreamManager.isDeviceListEmpty(g) ? this.logger.safe.info("Device list is empty, permission workaround enabled") : this.cachedStreamsMap.forEach((f, S)=>{
                        if (!S.sharing) {
                            const f = this.isDeviceOutdated(S.audio, g), v = this.isDeviceOutdated(S.video, g);
                            (f || v) && this.cachedStreamsMap.delete(S);
                        }
                    });
                }
                getSuitableStream(g) {
                    let f;
                    return this.cachedStreamsMap.forEach((S, v)=>{
                        this.isSuitable(this.addDeviceIdIfNecessary(S, v), g) && (f = v);
                    }), f && this.cachedStreamsMap.get(f);
                }
                addDeviceIdIfNecessary(g, f) {
                    if (!g.deviceId) return f;
                    const S = this.cloneStreamConstraints(f);
                    return f.audio && void 0 === f.audio.deviceId && (S.audio.deviceId = g.deviceId), f.video && void 0 === f.video.deviceId && (S.video.deviceId = g.deviceId), f.sharing && (S.sharing.deviceId = Gt.DISPLAY_SOURCE_ID), S;
                }
                cloneStreamConstraints(g) {
                    return {
                        ...deepClone(g),
                        withOverridenStream: g.withOverridenStream
                    };
                }
                createCachedStream(g) {
                    const f = this.createStream(g);
                    return this.event("onStreamCreated").raise(f.id, f.mediaType), this.subscribeOnStreamEvents(f), this.logger.safe.info(`created media stream, id: ${f.id} total: ${this.cachedStreamsMap.size}`), this.cachedStreamsMap.set(g, f), f;
                }
                disposeCurrentDeviceStream(g) {
                    for (const [f, S] of this.cachedStreamsMap.entries())g.sharing || f.sharing || (_MediaStreamManager.deviceChanged(g.audio, f.audio) || _MediaStreamManager.deviceChanged(g.video, f.video)) && S.dispose("MSM dispose oneStreamPerDeviceType");
                }
                createStream(g) {
                    return this.configProvider.config.oneStreamPerDeviceType && this.couldUseWebrtc_1_0 && this.disposeCurrentDeviceStream(g), this.configProvider.config.webrtcSimulcastSessionEnabled && ss.hasApplyConstraints() && this.couldUseWebrtc_1_0 ? new x_(g, this.mediaStreamSerialQueue, this.configProvider, this.logger, this.effectsManager) : new iC(g, this.mediaStreamSerialQueue, this.logger, this.configProvider);
                }
                subscribeOnStreamEvents(g) {
                    const f = [];
                    f.push(g.on("onStreamAcquired", (g, f, S)=>this.onStreamAcquired(g, f, S))), f.push(g.on("onStreamDisposing", (g)=>this.onStreamDisposing(g))), this.cachedStreamsSubs.set(g, f);
                }
                unsubscribeFromStreamEvents(g) {
                    this.cachedStreamsSubs.get(g).forEach((g)=>g.dispose()), this.cachedStreamsSubs.delete(g);
                }
                removeStream(g) {
                    this.logger.safe.info(`release media stream generation: ${g.id} cached: ${this.cachedStreamsMap.size}`), this.cachedStreamsSubs.has(g) ? (this.unsubscribeFromStreamEvents(g), this.cachedStreamsMap.delete(this.getConstraintsForStream(g)), this.getStreamsCountByType("Audio") || this.effectsManager.stopEffect("Audio"), this.cachedStreamsMap.size || this.event("onAllStreamsRemoved").raise()) : this.logger.safe.warn(`skipping unknown stream ${g.id}`);
                }
                getConstraintsForStream(g) {
                    let f;
                    return this.cachedStreamsMap.forEach((S, v)=>{
                        g === S && (f = v);
                    }), f;
                }
                isSuitable(g, f) {
                    var _g_withOverridenStream, _f_withOverridenStream;
                    const S = !(!g.withOverridenStream || !f.withOverridenStream), v = S || f.sharing || this.isAcceptable(g.audio, f.audio) && g.audioProcessingFlags === f.audioProcessingFlags, _ = S || this.isAcceptable(g.video, f.video), C = this.configProvider.config.requireUserActionForAudioSharing && f.sharing && !!g.audio != !!f.audio, E = this.isAcceptable(g.sharing, f.sharing), T = E && this.isAcceptable(g.audio, f.audio), I = C ? T : E, b = g.withEffect === f.withEffect, A = ((_g_withOverridenStream = g.withOverridenStream) === null || _g_withOverridenStream === void 0 ? void 0 : _g_withOverridenStream.id) === ((_f_withOverridenStream = f.withOverridenStream) === null || _f_withOverridenStream === void 0 ? void 0 : _f_withOverridenStream.id);
                    return !f.force && v && _ && I && b && A;
                }
                isAcceptable(g, f) {
                    return !g && !f || g && f && g.deviceId === f.deviceId;
                }
                isDeviceOutdated(g, f) {
                    return (g === null || g === void 0 ? void 0 : g.deviceId) && !f.some((f)=>f.deviceId === g.deviceId);
                }
                onStreamDisposing(g) {
                    this.logger.safe.info(`onStreamDisposing event ${g.id}`), this.event("onStreamDisposing").raise(g.id, g.mediaType), this.removeStream(g);
                }
                onStreamAcquired(g, f, S) {
                    const v = "Audio" === g.mediaType ? void 0 : !!g.rawStream.getAudioTracks()[0], _ = "ScreenShare" === g.mediaType ? this.getSharingSource(g) : void 0;
                    this.event("onStreamAcquired").raise(g.id, g.mediaType, f, S, v, _);
                }
                getSharingSource(g) {
                    const f = g.rawStream.getVideoTracks()[0], S = f.getConstraints();
                    if (S === null || S === void 0 ? void 0 : S.deviceId) return "camera";
                    const v = f.getSettings();
                    var _v_displaySurface;
                    return (_v_displaySurface = v === null || v === void 0 ? void 0 : v.displaySurface) !== null && _v_displaySurface !== void 0 ? _v_displaySurface : "unknown";
                }
                static deviceChanged(g, f) {
                    return !(!g || !f) && g.deviceId !== f.deviceId;
                }
                static isDeviceListEmpty(g) {
                    return g.every((g)=>"" === g.label);
                }
                getStreamsCountByType(g) {
                    let f = 0;
                    return this.cachedStreamsMap.forEach((S)=>{
                        f += S.mediaType === g ? 1 : 0;
                    }), f;
                }
                constructor(g, f, S){
                    super(g), this.logger = g, this.configProvider = f, this.effectsManager = S, this.cachedStreamsSubs = new Map, this.cachedStreamsMap = new Map, this.mediaStreamSerialQueue = new q_(this.logger), this.couldUseWebrtc_1_0 = !1;
                }
            }, rC = class {
                set permissionStates(g) {
                    this.data.permissionStates = g;
                }
                setSelectedDevices(g, f) {
                    var _g_microphone, _g_camera, _g_speaker, _g_microphone1, _g_camera1, _g_speaker1;
                    const S = {
                        microphone: scrubDeviceLabelPii((_g_microphone = g.microphone) === null || _g_microphone === void 0 ? void 0 : _g_microphone.label, this.configProvider.config.devices.piiSafeWords),
                        camera: scrubDeviceLabelPii((_g_camera = g.camera) === null || _g_camera === void 0 ? void 0 : _g_camera.label, this.configProvider.config.devices.piiSafeWords),
                        speaker: scrubDeviceLabelPii((_g_speaker = g.speaker) === null || _g_speaker === void 0 ? void 0 : _g_speaker.label, this.configProvider.config.devices.piiSafeWords)
                    };
                    this.rawUsedDevices = {
                        microphone: (_g_microphone1 = g.microphone) === null || _g_microphone1 === void 0 ? void 0 : _g_microphone1.label,
                        camera: (_g_camera1 = g.camera) === null || _g_camera1 === void 0 ? void 0 : _g_camera1.label,
                        speaker: (_g_speaker1 = g.speaker) === null || _g_speaker1 === void 0 ? void 0 : _g_speaker1.label
                    }, this.data.usedDevices && (this.data.deviceSelectionChangeCount++, f && this.data.deviceSelectionChangeCountFromInterface++), this.data.usedDevices = S;
                }
                setDeviceList(g, f, S) {
                    this.data.deviceList = g.map((g)=>({
                            label: scrubDeviceLabelPii(g.label, this.configProvider.config.devices.piiSafeWords),
                            kind: g.type
                        })), S && (this.data.deviceDebugStrings = deepClone(S)), this.data.devicesCount.microphone = g.filter((g)=>"microphone" === g.type).length, this.data.devicesCount.camera = g.filter((g)=>"camera" === g.type).length, this.data.devicesCount.speaker = g.filter((g)=>"speaker" === g.type).length, this.data.devicesCount.compositeAudio = g.filter((g)=>"compositeAudio" === g.type).length, this.data.devicesChangeCount++, f && this.data.devicesPollChangeCount++;
                }
                registerDeviceTelemetryEvent(g) {
                    if ("stream_acquired" === g.eventType) {
                        const f = g.payload;
                        "Video" === f.mediaType && (this.data.latestCameraOpenResolution = f.resolution);
                    }
                    "Audio" === g.payload.mediaType && ("stream_acquired" === g.eventType && (this.data.audioSourceNumOfReopenRequests++, this.data.audioSourceNumOfSuccessfulReopens++), "stream_error" === g.eventType && this.data.audioSourceNumOfReopenRequests++), arrayLimitedPush(this.data.deviceTelemetryEvents, g, this.configProvider.config.diagnostics.collectionLimits.numDeviceEvents);
                }
                logAudioDeviceError(g, f) {
                    switch(g){
                        case "reconnect_on_audio_playback_error":
                            {
                                const g = this.getAudioPlaybackErrorCode(f.error);
                                this.registerAudioRenderError(g);
                                break;
                            }
                        case "enumeration_failed":
                            this.registerAudioRenderError(1), this.registerAudioCaptureError(1);
                            break;
                        case "permissions_state_changed":
                            "denied" === f.microphone && this.registerAudioCaptureError(0x800000000000);
                            break;
                        case "stream_ended_error":
                            this.registerAudioCaptureError(4194304);
                    }
                }
                getAudioPlaybackErrorCode(g) {
                    switch(g){
                        case 3:
                            return 4194304;
                        case 4:
                            return 128;
                        default:
                            return 0x8000000000000000;
                    }
                }
                registerVideoEffectsEvent(g) {
                    arrayLimitedPush(this.data.videoEffectsEvents, g, this.configProvider.config.diagnostics.collectionLimits.numVideoEffectsEvents);
                }
                registerAudioEffectsEvent(g) {
                    arrayLimitedPush(this.data.audioEffectsEvents, g, this.configProvider.config.diagnostics.collectionLimits.numAudioEffectsEvents);
                }
                registerWorkerEvent(g) {
                    arrayLimitedPush(this.data.workerEvents, g, this.configProvider.config.diagnostics.collectionLimits.numWorkerEvents);
                }
                registerAudioCaptureError(g) {
                    const f = {
                        timestamp: Date.now(),
                        audioDeviceErrorFlag: g
                    };
                    arrayLimitedPush(this.data.audioCaptureDeviceErrorFlags, f, this.configProvider.config.diagnostics.collectionLimits.numAudioCaptureErrors);
                }
                registerAudioRenderError(g) {
                    const f = {
                        timestamp: Date.now(),
                        audioDeviceErrorFlag: g
                    };
                    arrayLimitedPush(this.data.audioRenderDeviceErrorFlags, f, this.configProvider.config.diagnostics.collectionLimits.numAudioRenderErrors);
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g){
                    this.configProvider = g, this.data = {
                        deviceList: [],
                        deviceSelectionChangeCount: 0,
                        deviceSelectionChangeCountFromInterface: 0,
                        permissionStates: {
                            microphone: "unknown",
                            camera: "unknown"
                        },
                        devicesCount: {
                            microphone: 0,
                            camera: 0,
                            speaker: 0,
                            compositeAudio: 0,
                            audioIngestDevice: 0,
                            virtualDevice: 0
                        },
                        devicesChangeCount: 0,
                        devicesPollChangeCount: 0,
                        deviceTelemetryEvents: [],
                        videoEffectsEvents: [],
                        audioEffectsEvents: [],
                        workerEvents: [],
                        audioSourceNumOfReopenRequests: 0,
                        audioSourceNumOfSuccessfulReopens: 0,
                        audioRenderDeviceErrorFlags: [],
                        audioCaptureDeviceErrorFlags: []
                    }, Object.defineProperty(this.data, "rawUsedDevices", {
                        get: ()=>this.rawUsedDevices,
                        configurable: !1,
                        enumerable: !1
                    });
                }
            }, aC = class {
                toDeviceDesc() {
                    return {
                        id: this.guid,
                        browserId: this.deviceId,
                        label: this.label,
                        kind: this.type
                    };
                }
                getType(g) {
                    switch(g){
                        case Gt.MEDIA_DEVICE_KIND.audioInput:
                            return Gt.MEDIA_DEVICE.microphone;
                        case Gt.MEDIA_DEVICE_KIND.audioOutput:
                            return Gt.MEDIA_DEVICE.speaker;
                        case Gt.MEDIA_DEVICE_KIND.videoInput:
                            return Gt.MEDIA_DEVICE.camera;
                        case Gt.MEDIA_DEVICE_KIND.compositeAudio:
                            return Gt.MEDIA_DEVICE.compositeAudio;
                        case Gt.MEDIA_DEVICE_KIND.virtualDevice:
                            return Gt.MEDIA_DEVICE.virtualDevice;
                        default:
                            throw new Error(`Device kind to recognized: ${g}`);
                    }
                }
                constructor(g, f, S, v, _){
                    this.deviceId = g, this.label = f, this.kind = S, this.groupId = v, this.capabilities = _, this.type = this.getType(this.kind), this.guid = `${this.type}:${this.deviceId}`, this.isSystemDefault = this.deviceId === Gt.MEDIA_DEVICE.defaultId;
                }
            }, sC = class extends aC {
                constructor(g, f, S, v){
                    super(g, f, S, v);
                }
            }, oC = class extends aC {
                toDeviceDesc() {
                    const g = super.toDeviceDesc();
                    return g.isSystemDefault = this.isSystemDefault, g;
                }
                constructor(g, f, S, v, _){
                    super(g, f, S, v, _);
                }
            }, lC = class extends aC {
                toDeviceDesc() {
                    const g = super.toDeviceDesc();
                    return g.position = this.position, g;
                }
                constructor(g, f, S, v, _){
                    if (super(g, f, S, v, _), this.position = "unknown", _ && _.facingMode && 1 === _.facingMode.length) switch(_.facingMode[0]){
                        case "user":
                            this.position = "front";
                            break;
                        case "environment":
                            this.position = "back";
                    }
                }
            }, cC = class extends aC {
                get micDeviceId() {
                    return this.micDevice.guid;
                }
                get speakerDeviceId() {
                    return this.speakerDevice.guid;
                }
                toDeviceDesc() {
                    const g = super.toDeviceDesc();
                    return g.microphoneId = this.micDeviceId, g.speakerId = this.speakerDeviceId, g.formFactor = this.formFactor, g.isPcInternalDevice = this.isPcInternalDevice, g;
                }
                constructor(g, f, S, v, _, C){
                    super(null, S, v, ""), this.micDevice = g, this.speakerDevice = f, this.formFactor = _, this.isPcInternalDevice = C, this.guid = null, this.isSystemDefault = !1;
                }
            };
            function createDevice(g) {
                const f = g.getCapabilities && g.getCapabilities();
                switch(f && (delete f.groupId, delete f.deviceId), g.kind){
                    case Gt.MEDIA_DEVICE_KIND.audioInput:
                    case Gt.MEDIA_DEVICE_KIND.audioOutput:
                        return new oC(g.deviceId, g.label, g.kind, g.groupId, f);
                    case Gt.MEDIA_DEVICE_KIND.videoInput:
                        return new lC(g.deviceId, g.label, g.kind, g.groupId, f);
                    default:
                        throw new Error(`Device kind is not recognized: ${g.kind}`);
                }
            }
            function createCompositeAudioDevice(g, f, S) {
                return new cC(g, f, S, "compositeAudio", 0, !1);
            }
            function createDefaultDevice(g) {
                const f = {
                    deviceId: Gt.MEDIA_DEVICE.defaultId,
                    label: Gt.MEDIA_DEVICE.defaultDeviceLabel,
                    kind: getKind(g),
                    groupId: "",
                    toJSON: ()=>JSON.stringify(f)
                };
                return createDevice(f);
            }
            function getKind(g) {
                switch(g){
                    case Gt.MEDIA_DEVICE.microphone:
                        return Gt.MEDIA_DEVICE_KIND.audioInput;
                    case Gt.MEDIA_DEVICE.speaker:
                        return Gt.MEDIA_DEVICE_KIND.audioOutput;
                    case Gt.MEDIA_DEVICE.camera:
                        return Gt.MEDIA_DEVICE_KIND.videoInput;
                    default:
                        throw new Error(`Device type to recognized: ${g}`);
                }
            }
            function compilePrimitiveDeviceList(g, f, S, v, _ = {
                str: ""
            }) {
                _.str += `|input(${f.length})`;
                let C = [];
                const E = [
                    v.config.devices.blacklist[g],
                    v.defaultConfig.devices.blacklist[g]
                ];
                for (const g of E)try {
                    const S = new RegExp(g, "i");
                    C = f.filter((f)=>g && f.label.match(S) ? (_.str += `|-blacklisted(${f.label})`, !1) : f.deviceId !== Gt.MEDIA_DEVICE.communicationsId || (_.str += "|-communications", !1));
                    break;
                } catch (S) {
                    _.str += `|filterError('${g}', ${stringifyObject(S)})`, C = f;
                }
                if (C.length) {
                    const f = deductDefaultDevice(S, C, _);
                    if (f && (f.isSystemDefault = !0, _.str += `|default(${scrubMriOrOmit(f.guid)})`), f && f.deviceId !== Gt.MEDIA_DEVICE.defaultId && C.length > 1 && (C = C.filter((g)=>g.deviceId !== Gt.MEDIA_DEVICE.defaultId || (_.str += "|-defaultId", !1))), g === Gt.MEDIA_DEVICE.camera || f || (_.str += "|+syntheticDefault", C.unshift(createDefaultDevice(g))), S.forEach((g)=>{
                        const f = C.find((f)=>f.guid === g.guid);
                        f && !f.label && g.label && (_.str += `|migrateLabel(${scrubMriOrOmit(f.guid)})`, f.label = g.label);
                    }), g === Gt.MEDIA_DEVICE.speaker) {
                        const g = C.filter((g)=>"" === g.label);
                        g.length > 1 && g.length === C.length && (C = f ? [
                            f
                        ] : [
                            C[0]
                        ], _.str += `|-filteredEmptyLabels(${g.length})`);
                    }
                }
                return C;
            }
            function deductDefaultDevice(g, f, S) {
                if (1 === f.length) return S.str += "|default:only", f[0];
                const v = f.find((g)=>g.isSystemDefault && g.deviceId === Gt.MEDIA_DEVICE.defaultId);
                if (!v) return S.str += "|default:noSynthetic", f.find((g)=>g.isSystemDefault) || f[0];
                {
                    const _ = f.filter((g)=>g !== v);
                    if (1 === _.length) return S.str += "|default:firstNonDefault", _[0];
                    if ("" !== v.groupId) {
                        const g = _.filter((g)=>g.groupId === v.groupId);
                        if (1 === g.length) return S.str += `|default:groupId(${scrubMriOrOmit(g[0].guid)})`, g[0];
                    }
                    const C = _.map((g)=>g.label), E = getMaxSubstring(v.label, C), T = _.find((g)=>g.label === E);
                    if (T) return S.str += `|default:label(${scrubMriOrOmit(T.guid)})`, T;
                    const I = g.find((g)=>g.isSystemDefault);
                    if (I) {
                        const g = _.find((g)=>g.deviceId === I.deviceId);
                        if (g) return S.str += `|default:previousList(${scrubMriOrOmit(g.guid)})`, g;
                    }
                }
                return S.str += "|default:anyOrNull", f.find((g)=>g.isSystemDefault) || null;
            }
            function compileAudioDeviceList(g, f, S = .5, v = {
                str: ""
            }) {
                const _ = [];
                if (g.length && f.length) {
                    const C = getGroupedPairs(g.filter((g)=>"" !== g.groupId), f.filter((g)=>"" !== g.groupId), v);
                    C.length && (_.push(...C.map((g)=>createCompositeAudioDevice(g.microphone, g.speaker, createCompositeDeviceLabel(g.microphone.label, g.speaker.label)))), v.str += `|directMatched(${_.length})`);
                    const E = _.length;
                    _.push(...composeAudioDevicesFromLabels(g.filter((g)=>!_.some((f)=>f.micDeviceId === g.guid)), f.filter((g)=>!_.some((f)=>f.speakerDeviceId === g.guid)), S, v)), v.str += `|otherMatched(${_.length - E})`;
                }
                return _;
            }
            function getGroupedPairs(g, f, S = {
                str: ""
            }) {
                const v = new Set;
                for (const S of [
                    ...g,
                    ...f
                ])v.add(S.groupId);
                const _ = [];
                for (const C of v.values()){
                    let v = g.filter((g)=>g.groupId === C), E = f.filter((g)=>g.groupId === C);
                    if (v && E) {
                        if (1 === v.length && 1 === E.length) _.push({
                            microphone: v[0],
                            speaker: E[0]
                        }), S.str += `|pairSimple(${scrubMriOrOmit(v[0].guid)}, ${scrubMriOrOmit(E[0].guid)})`;
                        else if (v.length > 1 || E.length > 1) {
                            let g = getMostSimilarPair(v, E);
                            for(; g;)S.str += `|pairComplex(${scrubMriOrOmit(g.microphone.guid)}, ${scrubMriOrOmit(g.speaker.guid)})`, _.push(g), v = v.filter((f)=>f !== g.microphone), E = E.filter((f)=>f !== g.speaker), g = getMostSimilarPair(v, E);
                        }
                    }
                }
                return _;
            }
            function getMostSimilarPair(g, f) {
                let S = 999, v = null;
                if (g.length > 0 && f.length > 0) for (const _ of g)for (const g of f){
                    const f = levenshteinDistance(_.label, g.label);
                    f < S && (S = f, v = {
                        microphone: _,
                        speaker: g
                    });
                }
                return v;
            }
            function composeAudioDevicesFromLabels(g, f, S, v) {
                const _ = [];
                return g.length && f.length ? (g.forEach((g)=>{
                    const C = f.filter((f)=>f.groupId === g.groupId);
                    if (!C.length) return void (v.str += `|lbl_nocand(${scrubMriOrOmit(g.guid)})`);
                    let E = getLongestCommonContiguousSubstring(g.label, C[0].label).length;
                    const T = C.sort((f, S)=>{
                        const v = getLongestCommonContiguousSubstring(g.label, f.label), _ = getLongestCommonContiguousSubstring(g.label, S.label);
                        return v.length > E && (E = v.length), _.length > E && (E = _.length), _.length - v.length;
                    });
                    if (T.length) {
                        const f = E / g.label.length;
                        f > S && (_.push(createCompositeAudioDevice(g, T[0], createCompositeDeviceLabel(g.label, T[0].label))), v.str += `|lbl_matched(${scrubMriOrOmit(g.guid)} & ${scrubMriOrOmit(T[0].guid)}, ${Math.round(1e4 * f) / 100}%)`);
                    }
                }), _) : _;
            }
            function createCompositeDeviceLabel(g, f) {
                if (g === f) return g;
                let S = getLongestCommonContiguousSubstring(g, f);
                S = S.trim().replace(/^\((.+)\)$/, "$1");
                let v = "", _ = "", C = 0;
                const E = [
                    countBraces(g),
                    countBraces(f)
                ];
                if (0 === E[0] || 0 === E[1]) return S;
                for(let g = 0; g < S.length; g++)if ("(" === S[g]) C++, _ += S[g];
                else if (")" === S[g]) {
                    if (!(C > 0)) break;
                    C--, _ += S[g], v += _, _ = "";
                } else C > 0 ? _ += S[g] : v += S[g];
                const T = countBraces(v);
                return T !== E[0] && T !== E[1] || (v = v.replace(/\w+\s?\((.+)\)/, "$1"), v = createCompositeDeviceLabel(S, v)), v.trim();
            }
            function countBraces(g) {
                const f = [
                    "(",
                    ")"
                ];
                let S = 0;
                for(let v = 0; v < g.length; v++)f.some((f)=>g[v] === f) && S++;
                return S;
            }
            var dC = {
                microphone: "",
                camera: "",
                speaker: "",
                compositeAudio: "",
                audioIngestDevice: "",
                virtualDevice: ""
            }, uC = class extends Bt {
                get devices() {
                    const g = [];
                    return this.lists.forEach((f)=>g.push(...f)), g;
                }
                getDevicesByType(g) {
                    var _this_lists_get;
                    return (_this_lists_get = this.lists.get(g)) !== null && _this_lists_get !== void 0 ? _this_lists_get : [];
                }
                updateDevices(g, f = !1) {
                    if (deepEqual(this.latestRawList, g)) return;
                    this.latestRawList = g;
                    const S = this.devices;
                    this.debugInfo.microphone = "microphone", this.debugInfo.camera = "camera", this.debugInfo.speaker = "speaker", this.debugInfo.compositeAudio = "compositeAudio", this.updatePrimitiveDeviceList(Gt.MEDIA_DEVICE.microphone, g.filter((g)=>g.type === Gt.MEDIA_DEVICE.microphone)), this.updatePrimitiveDeviceList(Gt.MEDIA_DEVICE.camera, g.filter((g)=>g.type === Gt.MEDIA_DEVICE.camera)), this.lists.get(Gt.MEDIA_DEVICE.speaker) && (this.updatePrimitiveDeviceList(Gt.MEDIA_DEVICE.speaker, g.filter((g)=>g.type === Gt.MEDIA_DEVICE.speaker)), this.lists.get(Gt.MEDIA_DEVICE.compositeAudio) && this.updateCompositeAudioDeviceList(this.lists.get(Gt.MEDIA_DEVICE.microphone), this.lists.get(Gt.MEDIA_DEVICE.speaker)));
                    const v = this.lists.get(Gt.MEDIA_DEVICE.compositeAudio) || [];
                    this.lists.set(Gt.MEDIA_DEVICE.microphone, this.orderDeviceList(this.lists.get(Gt.MEDIA_DEVICE.microphone), v)), this.lists.get(Gt.MEDIA_DEVICE.speaker) && this.lists.set(Gt.MEDIA_DEVICE.speaker, this.orderDeviceList(this.lists.get(Gt.MEDIA_DEVICE.speaker), v));
                    const _ = this.lists.get(Gt.MEDIA_DEVICE.microphone);
                    this.setTopItemToDefault(_);
                    const C = this.lists.get(Gt.MEDIA_DEVICE.speaker);
                    this.setTopItemToDefault(C), deepEqual(S, this.devices) || (this.logger.safe.info("Device lists updated and changed"), this.logger.safe.info(this.debugInfo.microphone), this.logger.safe.info(this.debugInfo.camera), this.logger.safe.info(this.debugInfo.speaker), this.logger.safe.info(this.debugInfo.compositeAudio), this.event("onDevicesChanged").raise(this.devices, f));
                }
                updateVirtualDeviceList(g) {
                    const f = this.lists.get(Gt.MEDIA_DEVICE.virtualDevice), S = g.map((g)=>new sC(g.id, g.label, "virtualDevice", ""));
                    deepEqual(f, S) ? this.logger.safe.info("Device lists did not change.") : (this.lists.set(Gt.MEDIA_DEVICE.virtualDevice, S), this.event("onDevicesChanged").raise(this.devices, !1));
                }
                updateActiveMicrophone(g) {
                    if (!g || g.deviceId === Gt.MEDIA_DEVICE.defaultId) return;
                    const f = this.lists.get(Gt.MEDIA_DEVICE.microphone), S = f.findIndex((g)=>g.isSystemDefault);
                    -1 !== S && f[S] !== g ? (this.logger.safe.info("Removing synthetic default microphone"), g.isSystemDefault = !0, f.splice(S, 1), this.lists.set(Gt.MEDIA_DEVICE.microphone, f), this.event("onDevicesChanged").raise(this.devices, !1)) : g.isSystemDefault = !0;
                }
                updatePrimitiveDeviceList(g, f) {
                    const S = {
                        str: this.debugInfo[g]
                    };
                    this.lists.set(g, compilePrimitiveDeviceList(g, f, this.lists.get(g) || [], this.configProvider, S)), this.debugInfo[g] = S.str;
                }
                updateCompositeAudioDeviceList(g, f) {
                    const S = {
                        str: this.debugInfo.compositeAudio
                    };
                    this.lists.set(Gt.MEDIA_DEVICE.compositeAudio, compileAudioDeviceList(g, f, this.configProvider.config.devices.compositeLabelMatchingThreshold, S)), this.debugInfo.compositeAudio = S.str;
                }
                orderDeviceList(g, f) {
                    return g.sort((g, S)=>this.getDevicePriority(S, this.getCompositeAudioDeviceCounterpart(S, f)) - this.getDevicePriority(g, this.getCompositeAudioDeviceCounterpart(g, f)));
                }
                getCompositeAudioDeviceCounterpart(g, f) {
                    const S = f.find((f)=>f.micDeviceId === g.guid || f.speakerDeviceId === g.guid);
                    return S ? S[g.type === Gt.MEDIA_DEVICE.speaker ? "micDevice" : "speakerDevice"] : null;
                }
                getDevicePriority(g, f) {
                    let S = 0;
                    return this.configProvider.config.devices.overrideDefault && f && (!g.isSystemDefault && f.isSystemDefault ? (this.debugInfo[g.type] += `|overrideDefault(${scrubMriOrOmit(g.guid)})`, S += 10) : g.isSystemDefault && !f.isSystemDefault && "microphone" === g.type && (S += 15)), g.isSystemDefault && (S += 5), f && (S += 1, f.isSystemDefault && (S += 2)), S;
                }
                setTopItemToDefault(g) {
                    (g === null || g === void 0 ? void 0 : g.length) && (g.forEach((g)=>g.isSystemDefault = !1), g[0].isSystemDefault = !0);
                }
                onConfigUpdated() {
                    let g = !1;
                    this.configProvider.userAgentConfig.isAudioOutputSelectionSupported ? this.lists.has(Gt.MEDIA_DEVICE.speaker) || (this.lists.set(Gt.MEDIA_DEVICE.speaker, []), this.lists.set(Gt.MEDIA_DEVICE.compositeAudio, []), g = !0) : (this.lists.has(Gt.MEDIA_DEVICE.speaker) && (this.lists.delete(Gt.MEDIA_DEVICE.speaker), g = !0), this.lists.has(Gt.MEDIA_DEVICE.compositeAudio) && (this.lists.delete(Gt.MEDIA_DEVICE.compositeAudio), g = !0)), g && (this.logger.safe.info("Updating device list due to config update"), this.updateDevices(this.latestRawList || []));
                }
                constructor(g, f){
                    super(f), this.configProvider = g, this.logger = f, this.debugInfo = dC, this.lists = new Map, this.lists.set(Gt.MEDIA_DEVICE.microphone, []), this.lists.set(Gt.MEDIA_DEVICE.camera, []), this.configProvider.userAgentConfig.isAudioOutputSelectionSupported && (this.lists.set(Gt.MEDIA_DEVICE.speaker, []), this.lists.set(Gt.MEDIA_DEVICE.compositeAudio, [])), g.userAgentConfig.on("isAudioOutputSelectionSupportedChanged", ()=>this.onConfigUpdated()), this.logger.safe.info("Initialized");
                }
            }, hC = class _DeviceEnumerator extends Bt {
                startDevicePolling(g) {
                    this.pollingInterval = g ? _DeviceEnumerator.configProvider.config.devices.pollingIntervalIdle : _DeviceEnumerator.configProvider.config.devices.pollingIntervalActive, _DeviceEnumerator.updatePollingTask();
                }
                stopDevicePolling(g) {
                    this.pollingInterval = g ? 0 : _DeviceEnumerator.configProvider.config.devices.pollingIntervalIdle, _DeviceEnumerator.updatePollingTask();
                }
                dispose() {
                    super.dispose(), this.stopDevicePolling(!0), _DeviceEnumerator.enumeratorUsers.delete(this), 0 === _DeviceEnumerator.enumeratorUsers.size && (_DeviceEnumerator.logger.safe.info("disposing"), _DeviceEnumerator.initializeCalled = !1, _DeviceEnumerator.isDeviceListAvailable = new ct, _DeviceEnumerator.list = void 0, _DeviceEnumerator.window.navigator.mediaDevices.ondevicechange = void 0);
                }
                static get isPolling() {
                    return 0 !== _DeviceEnumerator.currentPollingInterval;
                }
                static initialize(g, f, S) {
                    _DeviceEnumerator.initializeCalled || (_DeviceEnumerator.initializeCalled = !0, _DeviceEnumerator.window = Qa.window, _DeviceEnumerator.configProvider = f, _DeviceEnumerator.logger = S, _DeviceEnumerator.list = new uC(f, S.createChild("DeviceList")), f.userAgentConfig.on("isAudioOutputSelectionSupportedChanged", ()=>_DeviceEnumerator.enumerateDevices()), f.on("configUpdated", ()=>{
                        void 0 !== f.config.devices.pollingIntervalIdle && null !== _DeviceEnumerator.pollingTimer && g.startDevicePolling(!0);
                    }), f.config.devices.pollingIntervalIdle && f.config.devices.idlePollingOnStart && g.startDevicePolling(!0), _DeviceEnumerator.window.navigator.mediaDevices && (_DeviceEnumerator.window.navigator.mediaDevices.ondevicechange = ()=>{
                        S.safe.info("enumerating due to ondevicechange callback"), _DeviceEnumerator.enumerateDevices().catch((g)=>{
                            S.safe.error(`unable to enumerate ondevicechange: ${stringifyObject(g)}`);
                        });
                    }), _DeviceEnumerator.enumerateDevices());
                }
                static async enumerateDevices(g = !1) {
                    var _DeviceEnumerator_window_navigator_mediaDevices, _DeviceEnumerator_window_navigator;
                    if (!((_DeviceEnumerator_window_navigator = _DeviceEnumerator.window.navigator) === null || _DeviceEnumerator_window_navigator === void 0 ? void 0 : (_DeviceEnumerator_window_navigator_mediaDevices = _DeviceEnumerator_window_navigator.mediaDevices) === null || _DeviceEnumerator_window_navigator_mediaDevices === void 0 ? void 0 : _DeviceEnumerator_window_navigator_mediaDevices.enumerateDevices)) {
                        const g = new Error("device enumeration unsupported");
                        throw _DeviceEnumerator.isDeviceListAvailable.isPending && _DeviceEnumerator.isDeviceListAvailable.reject(g), g;
                    }
                    if (_DeviceEnumerator.enumerateDevicesPromise && !g) return _DeviceEnumerator.logger.safe.info("enumeration request postponed"), void (_DeviceEnumerator.hasPendingUpdate = !0);
                    try {
                        if (!_DeviceEnumerator.enumerateDevicesPromise) {
                            if (_DeviceEnumerator.configProvider.config.devices.enumerateDevicesTimeout) {
                                const g = deferWithTimeout(_DeviceEnumerator.configProvider.config.devices.enumerateDevicesTimeout);
                                _DeviceEnumerator.enumerateDevicesPromise = g.promise, _DeviceEnumerator.window.navigator.mediaDevices.enumerateDevices().then(g.resolve, g.reject);
                            } else _DeviceEnumerator.enumerateDevicesPromise = _DeviceEnumerator.window.navigator.mediaDevices.enumerateDevices();
                        }
                        const f = await _DeviceEnumerator.enumerateDevicesPromise;
                        _DeviceEnumerator.list.updateDevices(f.map((g)=>createDevice(g)), g), _DeviceEnumerator.isDeviceListAvailable.isPending && _DeviceEnumerator.isDeviceListAvailable.resolve();
                    } catch (g) {
                        const f = stringifyObject(g);
                        throw _DeviceEnumerator.logger.safe.warn(`error with enumerating devices: ${f}`), _DeviceEnumerator.raiseFailedEnumeration(f), g;
                    } finally{
                        _DeviceEnumerator.enumerateDevicesPromise = void 0, _DeviceEnumerator.hasPendingUpdate && (_DeviceEnumerator.hasPendingUpdate = !1, _DeviceEnumerator.logger.safe.info("running postponed enumeration"), _DeviceEnumerator.enumerateDevices());
                    }
                }
                static updatePollingTask() {
                    let g = Number.MAX_SAFE_INTEGER;
                    for (const f of _DeviceEnumerator.enumeratorUsers.values())f.pollingInterval < g && (g = f.pollingInterval);
                    if (g === Number.MAX_SAFE_INTEGER && (g = 0), (_DeviceEnumerator.pollingTimer || _DeviceEnumerator.currentPollingInterval !== g) && _DeviceEnumerator.pollingTimer && (_DeviceEnumerator.window.clearTimeout(_DeviceEnumerator.pollingTimer), _DeviceEnumerator.pollingTimer = void 0), _DeviceEnumerator.currentPollingInterval = g, 0 === g) return;
                    const pollingTask = async ()=>{
                        if (_DeviceEnumerator.currentPollingInterval) try {
                            await _DeviceEnumerator.enumerateDevices(!0), _DeviceEnumerator.pollingTimer = _DeviceEnumerator.window.setTimeout(pollingTask, _DeviceEnumerator.currentPollingInterval);
                        } catch (g) {
                            throw _DeviceEnumerator.pollingTimer = null, g;
                        }
                    };
                    _DeviceEnumerator.logger.safe.info(`starting device polling with interval ${g}ms`), _DeviceEnumerator.pollingTimer = 1, pollingTask();
                }
                static raiseFailedEnumeration(g) {
                    for (const f of _DeviceEnumerator.enumeratorUsers.values())f.event("onDeviceEnumerationfailed").raise(g);
                }
                constructor(g, f){
                    super(f), this.pollingInterval = 0, _DeviceEnumerator.enumeratorUsers.add(this), _DeviceEnumerator.initialize(this, g, f);
                }
            };
            hC.isDeviceListAvailable = new ct, hC.initializeCalled = !1, hC.currentPollingInterval = 0, hC.hasPendingUpdate = !1, hC.enumeratorUsers = new Set;
            var gC = hC, pC = class extends Bt {
                get selectedDevices() {
                    return deepClone(this.currentlySelectedDevices);
                }
                selectDevices(g) {
                    let f = !1;
                    if (forOwn(g, (g, S)=>{
                        var _this_currentlySelectedDevices_S;
                        const v = this.getDeviceToSelect(S, this.deviceList.getDevicesByType("audioIngestDevice" === S ? "microphone" : S), g);
                        "camera" === S && (this.userSelectedDevices[S] = (v === null || v === void 0 ? void 0 : v.guid) || this.userSelectedDevices[S]), (v === null || v === void 0 ? void 0 : v.guid) !== ((_this_currentlySelectedDevices_S = this.currentlySelectedDevices[S]) === null || _this_currentlySelectedDevices_S === void 0 ? void 0 : _this_currentlySelectedDevices_S.guid) && (this.userSelectedDevices[S] = (v === null || v === void 0 ? void 0 : v.guid) || this.userSelectedDevices[S], f = !0), this.currentlySelectedDevices[S] = v;
                    }), f) {
                        const g = values(this.currentlySelectedDevices).map((g)=>JSON.stringify(scrubDevices(g, this.configProvider.config.devices.piiSafeWords)));
                        this.logger.safe.info(`Changed from public interface: ${g}`), this.event("onSelectedDevicesChanged").raise(this.selectedDevices, !0);
                    }
                }
                getDeviceToSelect(g, f, S) {
                    let v;
                    const _ = this.userSelectedDevices[g];
                    return S ? v = f.find((g)=>g.guid === S) : _ && (v = f.find((g)=>g.guid === _)), "audioIngestDevice" === g ? v : v || f[0];
                }
                onDevicesChanged(g) {
                    let f = !1;
                    if (Object.keys(this.currentlySelectedDevices).forEach((S)=>{
                        const v = "audioIngestDevice" === S ? "microphone" : S, _ = g.filter((g)=>g.type === v);
                        if (_.length > 0) {
                            var _this_currentlySelectedDevices_S;
                            const g = this.getDeviceToSelect(S, _);
                            (g === null || g === void 0 ? void 0 : g.guid) !== ((_this_currentlySelectedDevices_S = this.currentlySelectedDevices[S]) === null || _this_currentlySelectedDevices_S === void 0 ? void 0 : _this_currentlySelectedDevices_S.guid) && (this.currentlySelectedDevices[S] = g, f = !0);
                        } else this.currentlySelectedDevices[S] && (this.currentlySelectedDevices[S] = null, f = !0);
                    }), f) {
                        const g = values(this.currentlySelectedDevices).map((g)=>JSON.stringify(scrubDevices(g, this.configProvider.config.devices.piiSafeWords)));
                        this.logger.safe.info(`Changed due to device list change: ${g}`), this.event("onSelectedDevicesChanged").raise(this.selectedDevices, !1);
                    }
                }
                constructor(g, f, S){
                    super(S), this.deviceList = g, this.configProvider = f, this.logger = S, this.userSelectedDevices = {
                        microphone: null,
                        camera: null,
                        speaker: null
                    }, this.currentlySelectedDevices = {
                        microphone: null,
                        camera: null,
                        speaker: null,
                        audioIngestDevice: null
                    }, this.deviceList.on("onDevicesChanged", (g)=>this.onDevicesChanged(g)), g.devices.length > 0 && this.onDevicesChanged(g.devices), this.logger.safe.info("Initialized");
                }
            }, mC = class extends Bt {
                acquire() {
                    return this.mediaStream ? this.mediaStream.start().then(()=>this.logger.safe.info("Stream acquired")).catch((g)=>{
                        throw this.logger.safe.warn(`Failed to acquire the stream: ${stringifyObject(g)}`), g;
                    }) : Promise.reject("Disposed");
                }
                dispose() {
                    this.logger.safe.info("Disposing stream"), this.unsubscribeFromMediaStreamEvents(), this.mediaStream && (this.mediaStream.dispose(), this.mediaStream = null), super.dispose();
                }
                subscribeOnMediaStreamEvents(g) {
                    this.subs = [
                        g.on("onStreamClientStarted", ()=>this.event("onStreamStateChanged").raise("active")),
                        g.on("onStreamClientMuted", (g, f)=>this.event("onStreamStateChanged").raise(f ? "inactive" : "active")),
                        g.on("onStreamClientEnded", ()=>this.event("onStreamStateChanged").raise("stopped")),
                        g.on("onStreamClientError", (g, f)=>{
                            const S = f.type === Gt.MEDIA_ERROR.permissionDeniedError || f.type === Gt.MEDIA_ERROR.sharingCancelledError;
                            this.event("onStreamStateChanged").raise(S ? "cancelled" : "failed");
                        })
                    ];
                }
                unsubscribeFromMediaStreamEvents() {
                    this.subs.forEach((g)=>g.dispose()), this.subs = [];
                }
                constructor(g, f){
                    super(g), this.logger = g, this.mediaStream = f, this.subs = [], this.subscribeOnMediaStreamEvents(f);
                }
            }, fC = [
                Gt.MEDIA_STATE.inactive,
                Gt.MEDIA_STATE.receive,
                Gt.MEDIA_STATE.send,
                Gt.MEDIA_STATE.sendReceive
            ], SC = [
                Gt.MEDIA_STATE.inactive,
                Gt.MEDIA_STATE.receive
            ], vC = class extends Bt {
                async initialize() {
                    !ss.hasPermissionsApi() || "unknown" !== this.currentState.microphone && "unknown" !== this.currentState.camera ? "unknown" !== this.currentState.microphone && "unknown" !== this.currentState.camera || this.logger.safe.warn(`Permissions API is not supported in this browser. Microphone: ${this.currentState.microphone}, camera: ${this.currentState.camera}`) : (this.logger.safe.info("Initializing"), await this.registerPermissionTracker("microphone"), await this.registerPermissionTracker("camera"));
                }
                getPermissionState(g) {
                    return this.currentState[g] || "unknown";
                }
                isPermissionKnown(g) {
                    const f = this.getPermissionState(g);
                    return "unknown" !== f && "prompt" !== f;
                }
                get browserPermittedModalities() {
                    return this.permittedModalities;
                }
                get knownPermissionStates() {
                    return deepClone(this.currentState);
                }
                update(g, f) {
                    const S = deepClone(f);
                    g.audio || delete S.audio, g.video || delete S.video;
                    const v = deepClone(this.permittedModalities);
                    forOwn(S, (g, f)=>{
                        this.permittedModalities[f] = g ? fC : SC;
                    }), deepEqual(v, this.permittedModalities) || this.event("onDevicesPermissionChanged").raise();
                }
                async askDevicePermission(g) {
                    const f = g ? deepClone(g) : {
                        audio: !0,
                        video: this.deviceManager.hasCamera()
                    };
                    if (this.accessIssuePermissionOther = {
                        audio: !1,
                        video: !1
                    }, this.configProvider.config.permissions.rememberNegative && (f.audio = f.audio && this.permittedModalities.audio === fC, f.video = f.video && this.permittedModalities.video === fC), f.sharing) throw new Error("askDevicePermission does not support sharing constraints.");
                    const S = {
                        audio: !1,
                        video: !1
                    };
                    this.lastGum = {
                        audio: !1,
                        video: !1
                    };
                    const resolve = async (S, v, _)=>{
                        const C = {
                            audio: !!S.audio,
                            video: !!S.video,
                            sharing: !0
                        };
                        return !(this.configProvider.config.permissions.adpRequestAVLast && f.audio && f.video) || this.lastGum.audio && this.lastGum.video || (this.logger.safe.info("Prompting for audio and video to ensure omnibar state"), await this.askDevicePermissionPrompt({
                            audio: !0,
                            video: !0
                        }, !1)), this.update(f, C), this.deviceManager.raiseTelemetryEvent("ask_device_permission", {
                            constraints: g,
                            resultConstraints: S,
                            error: _,
                            reason: v
                        }), C;
                    };
                    await this.initialize();
                    const v = this.getPermissionState("microphone"), _ = this.getPermissionState("camera");
                    if (this.logger.safe.info(`Permission state { audio: ${v}, video: ${_} }`), this.configProvider.config.permissions.useNegativeInAdp && (!f.audio || "denied" === v) && (!f.video || "denied" === _)) return resolve(S, "navigator_permissions_denied");
                    if (this.configProvider.config.permissions.usePositiveInAdp && (!f.audio || f.audio && "granted" === v) && (!f.video || f.video && "granted" === _)) return resolve(f, "navigator_permissions_granted");
                    try {
                        return resolve(this.getConstrainsWithPermissionError(await this.askDevicePermissionPrompt(f, this.configProvider.config.permissions.adpFallback)), "stream_acquisition");
                    } catch (g) {
                        return resolve(S, "stream_acquisition", g);
                    }
                }
                async askDevicePermissionPrompt(g, f = !0) {
                    const S = {
                        audio: !1,
                        video: !1
                    };
                    try {
                        const f = this.deviceManager.getMediaStream(g);
                        return f && (this.lastGum = deepClone(g), await f.start(), S.audio = f.hasAudio(), S.video = f.hasVideo(), this.disposeLater(f)), S;
                    } catch (v) {
                        if (g.audio && g.video && f) {
                            try {
                                S.video = this.configProvider.config.permissions.adpFallbackVideo && (await this.askDevicePermissionPrompt({
                                    video: !0
                                })).video;
                            } catch (g) {
                                g.type !== Gt.MEDIA_ERROR.permissionDeniedError && g.type !== Gt.MEDIA_ERROR.permissionDeniedBySystemError && (this.accessIssuePermissionOther.video = !0);
                            }
                            try {
                                S.audio = this.configProvider.config.permissions.adpFallbackAudio && (await this.askDevicePermissionPrompt({
                                    audio: !0
                                })).audio;
                            } catch (g) {
                                g.type !== Gt.MEDIA_ERROR.permissionDeniedError && g.type !== Gt.MEDIA_ERROR.permissionDeniedBySystemError && (this.accessIssuePermissionOther.audio = !0);
                            }
                        } else if (f) throw v;
                        return S;
                    }
                }
                getConstrainsWithPermissionError(g) {
                    return this.configProvider.config.permissions.disableOnPermissionDeniedOnly ? {
                        audio: this.accessIssuePermissionOther.audio || g.audio,
                        video: this.accessIssuePermissionOther.video || g.video
                    } : g;
                }
                disposeLater(g) {
                    setTimeout(()=>{
                        g.dispose();
                    }, this.configProvider.config.mediaStreamHoldInterval);
                }
                async registerPermissionTracker(g) {
                    if (!this.registeredTrackers.has(g)) try {
                        const f = await this.window.navigator.permissions.query({
                            name: g
                        });
                        this.handlePermissionStateChanged(g, f.state), f.onchange = ()=>this.handlePermissionStateChanged(g, f.state), this.registeredTrackers.add(g);
                    } catch (f) {
                        this.logger.safe.error(`Error querying permissions for ${g}: ${stringifyObject(f)}`);
                    }
                }
                handlePermissionStateChanged(g, f) {
                    if (this.logger.safe.info(`Permission state for ${g} changed ${this.currentState[g]} -> ${f}`), this.configProvider.config.permissions.enumerateDevicesAfterChange) {
                        this.logger.safe.info(`enumerateDevicesAfterChange: ${JSON.stringify(this.configProvider.config.permissions)}`), gC.logger.safe.info("enumerating due to permission change");
                        try {
                            gC.enumerateDevices();
                        } catch (g) {
                            gC.logger.safe.error(`unable to enumerate on permission change: ${stringifyObject(g)}`);
                        }
                    }
                    this.currentState[g] = f, this.deviceManager.raiseTelemetryEvent("permissions_state_changed", this.knownPermissionStates), this.deviceManager.handlePermissionStateChange();
                }
                constructor(g, f, S){
                    super(S), this.configProvider = g, this.deviceManager = f, this.logger = S, this.currentState = {
                        microphone: "unknown",
                        camera: "unknown"
                    }, this.lastGum = {
                        audio: !1,
                        video: !1
                    }, this.registeredTrackers = new Set, this.accessIssuePermissionOther = {
                        audio: !1,
                        video: !1
                    }, this.window = Qa.window, this.permittedModalities = {
                        audio: fC,
                        video: fC,
                        sharing: fC
                    }, this.initialize();
                }
            }, _C = class extends ze {
                getDeviceManagers() {
                    return this.dms;
                }
                dispose() {
                    var _this_dms;
                    super.dispose(), (_this_dms = this.dms) === null || _this_dms === void 0 ? void 0 : _this_dms.forEach((g)=>g.dispose()), this.dms = null;
                }
                subscribeToDeviceManagers(g) {
                    g.forEach((g, f)=>{
                        g.on("onVideoEffectsEvent", (...f)=>this.eventHandler("onVideoEffectsEvent", g, ()=>this.event("onVideoEffectsEvent").raise(...f))), g.on("onVideoEffectApplied", (...f)=>this.eventHandler("onVideoEffectApplied", g, ()=>this.event("onVideoEffectApplied").raise(...f))), g.on("onDeviceTelemetryEvent", (g)=>this.event("onDeviceTelemetryEvent").raise({
                                deviceId: `${this.id}/${f}`,
                                ...g
                            })), g.on("onVideoEffectsTelemetryEvent", (g)=>this.event("onVideoEffectsTelemetryEvent").raise({
                                deviceId: `${this.id}/${f}`,
                                ...g
                            })), g.on("onDevicesPermissionChanged", ()=>this.event("onDevicesPermissionChanged").raise(`${this.id}/${f}`)), g.on("onStreamUpdateRequested", (...g)=>this.event("onStreamUpdateRequested").raise(...g));
                    });
                }
                eventHandler(g, f, S) {
                    let v = this.receivedEvents.get(g);
                    v !== null && v !== void 0 ? v : v = new Set, v.add(f);
                    if (this.dms.every((g)=>v.has(g))) return S(), void v.clear();
                    this.receivedEvents.set(g, v);
                }
                constructor(g, f = uniqueId()){
                    super(), this.dms = g, this.label = f, this.id = uniqueId(), this.receivedEvents = new Map, this.subscribeToDeviceManagers(g);
                }
            }, sequentialize = ()=>(g, f, S)=>{
                    const v = S.value;
                    return S.value = function(...g) {
                        return this.serialQueue.add(v.bind(this, ...g));
                    }, S;
                }, CC = class {
                isWasmEffectSupported() {
                    return this.configProvider.config.webcv.useWasmEffects ? !!window.MediaStreamTrackProcessor || (this.logger.info("wasmEffects disabled, insertable streams are not supported"), !1) : (this.logger.info("wasmEffects disabled by feature flag"), !1);
                }
                isWebgl2EffectSupported() {
                    return this.isCurrentRendererSupported() && this.isWebGL2Supported();
                }
                isCurrentRendererSupported() {
                    const g = this.configProvider.config.webcv.webGLUnsupportedRenderers;
                    let f = !1;
                    const S = ss.unmaskedGlRenderer;
                    return S && !g.some((g)=>g === S) ? f = !0 : (this.statistics.setError("RendererIsNotSupported", `Blacklisted from ${JSON.stringify(g)}`), this.logger.info(`Unsupported renderer: ${stringifyObject(S)}`)), f;
                }
                isWebGL2Supported() {
                    try {
                        const g = document.createElement("canvas").getContext("webgl2");
                        if (!g) return this.statistics.setError("WebGL2IsNotSupported"), this.logger.info("WebGL2 context is not supported"), !1;
                        const f = g.getSupportedExtensions(), S = this.configProvider.config.webcv.webGLRequiredExtensions.filter((g)=>!f.includes(g));
                        if (S.length > 0) return this.statistics.setError("WebGL2RequiredExtensionsNotSupported", "Required WebGL2 extensions not supported."), this.logger.info(`Unsupported WebGL2 extensions: ${stringifyObject(S)}`), !1;
                    } catch (g) {
                        return this.statistics.setError("WebGL2IsNotSupported", `Error: ${stringifyObject(g)}`), this.logger.error(`isWebGL2Supported: ${stringifyObject(g)}`), !1;
                    }
                    return !0;
                }
                constructor(g, f, S){
                    this.configProvider = g, this.statistics = f, this.logger = S;
                }
            }, yC = class {
                startLoadTimer() {
                    this.loadStartTimestamp = Date.now();
                }
                stopLoadTimer() {
                    this.loadDuration = Date.now() - this.loadStartTimestamp;
                }
                clearErrors() {
                    this.error.clear();
                }
                setError(g, f) {
                    this.error.add({
                        type: g,
                        message: f
                    });
                }
                getReport() {
                    return {
                        loadDuration: this.loadDuration,
                        error: this.error.items
                    };
                }
                constructor(g){
                    this.error = new xv(g);
                }
            }, EC = class extends Bt {
                get isEffectEnabled() {
                    return 0 !== this.currentEffect || 0 !== this.queryMessageProcessor.payload.effectType;
                }
                async init() {
                    if (!this.effectProvider) try {
                        this.effectProvider = await this.initializeVideoEffectProvider();
                    } catch (g) {
                        throw Error(g);
                    }
                }
                async dispose() {
                    this.logger.safe.debug("Dispose"), this.effectProvider && (this.effectProviderSubs.forEach((g)=>g.dispose()), this.effectProviderSubs = null, await this.effectProvider.disposeAsync()), super.dispose();
                }
                async configure(g) {
                    if (this.logger.safe.debug(`Set config: ${JSON.stringify(g)}`), this.effectConfig = {
                        backgroundImageUrl: g.imagePath,
                        headers: g.headers
                    }, this.effectProvider) return this.effectProvider.configureEffect(this.effectConfig);
                    this.logger.safe.debug("WebCV is not initialized. Do nothing");
                }
                async setEffectAsync(g) {
                    if (this.currentEffect === g) return void this.logger.safe.debug(`Effect ${this.currentEffect} is already set`);
                    this.effectProvider || (this.logger.safe.debug("Initializing effect provider"), await this.init()), this.logger.safe.debug(`Set effect: ${g}`);
                    const f = this.getWebCVEffect(g);
                    if (!f) throw new Error(`Effect with type ${g} is not supported`);
                    if (this.shouldCollectStats(g) && this.notifyAboutLastSessionStats("EffectChanged"), this.currentEffect = g, this.effectProvider) try {
                        await this.effectProvider.setEffectAsync(f);
                    } catch (g) {
                        throw await this.handleFailedProcessing(), this.notifyError("FailedToInitialize", `Failed to apply ${f}, error:${stringifyObject(g)}`), g;
                    }
                    else this.logger.safe.debug("WebCV is not initialized. Do nothing");
                }
                async processingVideoEffectMessage(g) {
                    let f = {
                        code: 0,
                        response: {
                            effects: []
                        },
                        type: "EnableEffects"
                    };
                    try {
                        await this.init();
                    } catch (g) {
                        return this.logger.error(`Failed to initialize WebCV, error:${stringifyObject(g)}`), this.notifyError("FailedToInitialize", `Initialization failed, error:${stringifyObject(g)}`), f;
                    }
                    const S = this.currentEffect;
                    this.logger.info(`Processing video effect request type: ${JSON.stringify(g.type)}`), f = await this.queryMessageProcessor.processVideoEffectMessage(g), this.queryMessageProcessor.reconfigure && (await this.configure({
                        imagePath: this.queryMessageProcessor.payload.imageConfig.backgroundImageUrl,
                        headers: this.queryMessageProcessor.payload.imageConfig.headers
                    }), this.queryMessageProcessor.reconfigure = !1);
                    try {
                        this.shouldCollectStats(S) && this.notifyAboutLastSessionStats("EffectChanged"), await this.effectProvider.setEffectAsync(this.getWebCVEffect(this.queryMessageProcessor.payload.effectType), this.queryMessageProcessor.payload);
                    } catch (e) {
                        this.logger.error("Failed to apply video effect");
                    }
                    return f;
                }
                async setSourceAsync(g) {
                    if (this.logger.safe.debug(`Set source: ${g ? g.id : "no stream"}`), !this.effectProvider) return this.logger.safe.debug("WebCV is not initialized. Do nothing"), g;
                    let f = g;
                    try {
                        f = await this.effectProvider.setSourceAsync(g);
                    } catch (g) {
                        await this.handleFailedProcessing(), this.notifyError("FailedToInitialize", `Failed to set source, error:${stringifyObject(g)}`);
                    }
                    return f;
                }
                async removeSourceAsync(g) {
                    if (this.logger.safe.debug(`Remove source: ${g ? g.id : "no stream"}`), this.effectProvider) return this.effectProvider.removeSourceAsync(g);
                    this.logger.safe.debug("WebCV is not initialized. Do nothing");
                }
                async getEffectsCapability() {
                    let g = 0;
                    const f = await this.getCapability();
                    this.logger.safe.debug(`Get capabilty with return: ${JSON.stringify(f)}`);
                    for (const S of f)g |= S;
                    return g;
                }
                getStats(g) {
                    if (!this.effectProvider) return;
                    const f = this.effectProvider.getStats(), S = this.statistics.getReport();
                    return f || S.error.length ? {
                        timestamp: Date.now(),
                        statsReason: g,
                        ...this.createTelemetryEvent(f, S)
                    } : void 0;
                }
                getVersion() {
                    var _this_effectProvider_getVersion, _this_effectProvider;
                    var _this_effectProvider_getVersion1;
                    return (_this_effectProvider_getVersion1 = (_this_effectProvider = this.effectProvider) === null || _this_effectProvider === void 0 ? void 0 : (_this_effectProvider_getVersion = _this_effectProvider.getVersion) === null || _this_effectProvider_getVersion === void 0 ? void 0 : _this_effectProvider_getVersion.call(_this_effectProvider)) !== null && _this_effectProvider_getVersion1 !== void 0 ? _this_effectProvider_getVersion1 : "Unknown";
                }
                async resetOutputConstraints(g, f = or.EffectQualityChangeReason.ExternalParam) {
                    var _this_effectProvider;
                    const S = {
                        ...this.configProvider.config.webcv.qualityConfig
                    };
                    return S.outputResolution = g.height, (_this_effectProvider = this.effectProvider) === null || _this_effectProvider === void 0 ? void 0 : _this_effectProvider.configureStreamProcessor(S, or.EffectQualityChangeReason.ExternalParam);
                }
                createTelemetryEvent(g, f) {
                    return {
                        payload: {
                            version: this.getVersion(),
                            ...f,
                            ...g,
                            isWasmEnabled: this.processorType === or.ProcessorType.Wasm
                        }
                    };
                }
                notifyError(g, f) {
                    this.statistics.setError(g, f), this.notifyAboutLastSessionStats("EffectError");
                }
                notifyAboutLastSessionStats(g) {
                    const f = this.getStats(g);
                    f && this.event("onVideoEffectTelemetryEvent").raise(f);
                }
                async initializeVideoEffectProvider() {
                    var _g_getVersion;
                    if (!this.webcvProvider) return this.logger.safe.debug("WebCV provider is not set"), null;
                    this.statistics.startLoadTimer();
                    const g = await this.webcvProvider.getVideoEffectProvider();
                    if (this.statistics.stopLoadTimer(), !g) return this.statistics.setError("FailedToInitialize"), this.logger.safe.warn("WebCV is not initialized"), null;
                    this.logger.safe.debug(`WebCV v${(_g_getVersion = g.getVersion) === null || _g_getVersion === void 0 ? void 0 : _g_getVersion.call(g)} is initialized`);
                    const f = await this.webcvProvider.getModelConfig();
                    return await g.configureModel(f), this.configProvider.config.webcv.loadWorkerCallback = this.wasmLoader.getWorkerFunction("wasmcv"), this.configProvider.config.webcv.loadTimerWorkerCallback = this.wasmLoader.getWorkerFunction("timer"), await g.configure({
                        ...this.configProvider.config.webcv,
                        processorType: this.processorType
                    }), this.effectConfig && await g.configureEffect(this.effectConfig), this.effectProviderSubs = [
                        g.on("onEffectApplied", ()=>this.event("onMediaStreamUpdateRequested").raise("Video")),
                        g.on("onEffectStopped", ()=>this.notifyAboutLastSessionStats("EffectStopped")),
                        g.on("onVideoEffectQualityChanged", (g)=>this.event("onVideoEffectQualityChanged").raise(g)),
                        g.on("onVideoStreamQualityChanged", (g)=>this.event("onVideoStreamQualityChanged").raise(g.resolution, g.fps, g.reason)),
                        g.on("onCapabilitiesChanged", ()=>this.event("onVideoEffectCapabilitiesChanged").raise()),
                        g.on("onFirstFrameProcessed", ()=>this.onFirstFrameProcessed()),
                        g.on("onErrorNotified", (g)=>this.notifyError("WebcvProcessorError", g)),
                        g.on("videoFreezeDetected", (g)=>this.event("videoFreezeDetected").raise(g))
                    ], g;
                }
                async getCapability() {
                    if (!this.configProvider.config.enableVideoEffects) return this.logger.debug("Video effects disabled"), [
                        0
                    ];
                    if (!this.webcvProvider) return this.logger.debug("WebCVProvider is not configured"), [
                        0
                    ];
                    const g = new CC(this.configProvider, this.statistics, this.logger.createChild("CapabilityChecker"));
                    let f = [
                        0
                    ];
                    return g.isWasmEffectSupported() ? (f = [
                        0,
                        1,
                        16,
                        262144,
                        512,
                        2048
                    ], this.processorType = or.ProcessorType.Wasm) : g.isWebgl2EffectSupported() && (f = [
                        0,
                        1,
                        16
                    ], this.processorType = or.ProcessorType.Webgl2), f;
                }
                getWebCVEffect(g) {
                    return this.videoEffectToWebCVEffectMapping[g] || or.VideoEffectType.None;
                }
                onFirstFrameProcessed() {
                    this.event("onVideoEffectApplied").raise(), this.logger.safe.debug("onVideoEffectApplied event raised");
                }
                async handleFailedProcessing() {
                    this.currentEffect = 0;
                    try {
                        await this.effectProvider.setEffectAsync(or.VideoEffectType.Off);
                    } catch (g) {
                        this.notifyError("WebcvProcessorError", `Failed to handle error state, error:${stringifyObject(g)}`);
                    }
                }
                shouldCollectStats(g) {
                    return 0 !== this.currentEffect && 0 !== g && this.currentEffect !== g;
                }
                constructor(g, f, S, v){
                    super(S), this.webcvProvider = g, this.configProvider = f, this.logger = S, this.wasmLoader = v, this.serialQueue = new q_(this.logger), this.videoEffectToWebCVEffectMapping = {
                        0: or.VideoEffectType.Off,
                        1: or.VideoEffectType.BackgroundBlur,
                        16: or.VideoEffectType.BackgroundReplacement,
                        512: or.VideoEffectType.PresenterMode,
                        256: or.VideoEffectType.None,
                        2048: or.VideoEffectType.None,
                        262144: or.VideoEffectType.None
                    }, this.currentEffect = 0, this.effectProviderSubs = [], this.statistics = new yC(this.configProvider.config.effectsTelemetryBufferSize), this.processorType = or.ProcessorType.Webgl2, this.queryMessageProcessor = new TC(this.configProvider, this.logger);
                }
            };
            __decorateClass([
                sequentialize()
            ], EC.prototype, "init", 1), __decorateClass([
                sequentialize()
            ], EC.prototype, "dispose", 1), __decorateClass([
                sequentialize()
            ], EC.prototype, "configure", 1), __decorateClass([
                sequentialize()
            ], EC.prototype, "setSourceAsync", 1), __decorateClass([
                sequentialize()
            ], EC.prototype, "removeSourceAsync", 1), __decorateClass([
                sequentialize()
            ], EC.prototype, "getEffectsCapability", 1);
            var TC = class {
                get payload() {
                    return this.currentEffectPayload.effectType = this.currentEffects, this.currentEffectPayload;
                }
                get reconfigure() {
                    return this.shouldReconfigure;
                }
                set reconfigure(g) {
                    this.shouldReconfigure = g;
                }
                async processVideoEffectMessage(g) {
                    switch(g.type){
                        case "EnableEffects":
                            return await this.processEnableEffectsMessage(g);
                        case "DisableEffects":
                            return await this.processDisableEffectsMessage(g);
                        case "QueryEffects":
                            return await this.processQueryEffectsMessage(g);
                        default:
                            return this.logger.error(`Unsupported video effect message type: ${g.type}`), null;
                    }
                }
                async processEnableEffectsMessage(g) {
                    const f = {
                        code: 0,
                        response: {
                            effects: []
                        },
                        type: "EnableEffects"
                    };
                    for(let S = 0; S < g.request.effects.length; S++){
                        const v = g.request.effects[S];
                        switch(v.type){
                            case "BackgroundModification":
                                if ("Blur" === v.options.variant) {
                                    this.currentEffects |= 1;
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "Blur"
                                        }
                                    };
                                    f.response.effects.push(g), this.currentEffects &= -262673;
                                } else if ("Replacement" === v.options.variant) {
                                    var _v_options;
                                    this.currentEffects |= 16;
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "Replacement",
                                            location: v.options.location
                                        }
                                    };
                                    this.shouldReconfigure = !0, this.currentEffectPayload.imageConfig = {
                                        backgroundImageUrl: v.options.location,
                                        headers: (_v_options = v.options) === null || _v_options === void 0 ? void 0 : _v_options.headers
                                    }, f.response.effects.push(g), this.currentEffects &= -262658;
                                } else if ("WeatherPerson" === v.options.variant) {
                                    if (!this.configProvider.config.webcv.useWasmEffects) {
                                        this.logger.error("WeatherPerson effect is not supported on non wasm effect provider");
                                        break;
                                    }
                                    this.currentEffects |= 512;
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "WeatherPerson"
                                        }
                                    };
                                    f.response.effects.push(g), this.currentEffects &= -262162;
                                } else if ("Bokeh" === v.options.variant) {
                                    if (!this.configProvider.config.webcv.useWasmEffects) {
                                        this.logger.error("Bokeh effect is not supported on non wasm effect provider");
                                        break;
                                    }
                                    this.currentEffects |= 262144;
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "Bokeh"
                                        }
                                    };
                                    f.response.effects.push(g), this.currentEffects &= -530;
                                }
                                break;
                            case "TouchUp":
                                this.logger.error("TouchUp effect is not supported on non wasm effect provider");
                                break;
                            case "AutoAdjust":
                                if (!this.configProvider.config.webcv.useWasmEffects) {
                                    this.logger.error("AutoAdjust effect is not supported on non wasm effect provider");
                                    break;
                                }
                                this.currentEffects |= 2048, f.response.effects.push({
                                    type: "AutoAdjust"
                                });
                        }
                    }
                    return f;
                }
                async processQueryEffectsMessage(g) {
                    const f = {
                        code: 0,
                        response: {
                            effects: []
                        },
                        type: "QueryEffects"
                    };
                    if (1 & this.currentEffects) {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Blur"
                            },
                            state: "On"
                        };
                        f.response.effects.push(g);
                    } else {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Blur"
                            },
                            state: "Off"
                        };
                        f.response.effects.push(g);
                    }
                    if (262144 & this.currentEffects && this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Bokeh"
                            },
                            state: "On"
                        };
                        f.response.effects.push(g);
                    } else if (this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Bokeh"
                            },
                            state: "Off"
                        };
                        f.response.effects.push(g);
                    } else {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Bokeh"
                            },
                            state: "Unavailable"
                        };
                        f.response.effects.push(g);
                    }
                    if (16 & this.currentEffects) {
                        var _this_currentEffectPayload, _this_currentEffectPayload1;
                        const g = {
                            variant: "Replacement",
                            location: ""
                        };
                        ((_this_currentEffectPayload = this.currentEffectPayload) === null || _this_currentEffectPayload === void 0 ? void 0 : _this_currentEffectPayload.imageConfig) && (g.location = (_this_currentEffectPayload1 = this.currentEffectPayload) === null || _this_currentEffectPayload1 === void 0 ? void 0 : _this_currentEffectPayload1.imageConfig.backgroundImageUrl);
                        const S = {
                            type: "BackgroundModification",
                            options: g,
                            state: "On"
                        };
                        f.response.effects.push(S);
                    } else {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "Replacement",
                                location: ""
                            },
                            state: "Off"
                        };
                        f.response.effects.push(g);
                    }
                    if (512 & this.currentEffects && this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "WeatherPerson"
                            },
                            state: "On"
                        };
                        f.response.effects.push(g);
                    } else if (this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "WeatherPerson"
                            },
                            state: "Off"
                        };
                        f.response.effects.push(g);
                    } else {
                        const g = {
                            type: "BackgroundModification",
                            options: {
                                variant: "WeatherPerson"
                            },
                            state: "Unavailable"
                        };
                        f.response.effects.push(g);
                    }
                    if (256 & this.currentEffects) {
                        const g = {
                            type: "TouchUp",
                            state: "Unavailable",
                            options: {
                                strength: 0
                            }
                        };
                        f.response.effects.push(g);
                    }
                    if (2048 & this.currentEffects && this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "AutoAdjust",
                            state: "On"
                        };
                        f.response.effects.push(g);
                    } else if (this.configProvider.config.webcv.useWasmEffects) {
                        const g = {
                            type: "AutoAdjust",
                            state: "Off"
                        };
                        f.response.effects.push(g);
                    } else {
                        const g = {
                            type: "AutoAdjust",
                            state: "Unavailable"
                        };
                        f.response.effects.push(g);
                    }
                    return f;
                }
                async processDisableEffectsMessage(g) {
                    const f = {
                        code: 0,
                        response: {
                            effects: []
                        },
                        type: "DisableEffects"
                    }, S = g, v = {
                        effects: []
                    };
                    for(let g = 0; g < S.request.effects.length; g++){
                        const f = S.request.effects[g];
                        switch(f.type){
                            case "BackgroundModification":
                                if ("Blur" === f.options.variant) {
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "Blur"
                                        }
                                    };
                                    v.effects.push(g), this.currentEffects &= -2;
                                }
                                if ("Bokeh" === f.options.variant) {
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "Bokeh"
                                        }
                                    };
                                    v.effects.push(g), this.currentEffects &= -262145;
                                }
                                if ("Replacement" === f.options.variant) {
                                    var _this_payload, _this_payload1;
                                    const g = {
                                        variant: "Replacement",
                                        location: ""
                                    };
                                    void 0 !== ((_this_payload = this.payload) === null || _this_payload === void 0 ? void 0 : _this_payload.imageConfig) && (g.location = (_this_payload1 = this.payload) === null || _this_payload1 === void 0 ? void 0 : _this_payload1.imageConfig.backgroundImageUrl);
                                    const f = {
                                        type: "BackgroundModification",
                                        options: g
                                    };
                                    v.effects.push(f), this.currentEffects &= -17;
                                }
                                if ("WeatherPerson" === f.options.variant) {
                                    const g = {
                                        type: "BackgroundModification",
                                        options: {
                                            variant: "WeatherPerson"
                                        }
                                    };
                                    v.effects.push(g), this.currentEffects &= -513;
                                }
                                break;
                            case "TouchUp":
                                this.logger.error("TouchUp effect is not supported now"), v.effects.push({
                                    type: "TouchUp",
                                    options: {
                                        strength: 0
                                    }
                                }), this.currentEffects &= -257, this.currentEffectPayload.softfocusStrength = 0;
                                break;
                            case "AutoAdjust":
                                v.effects.push({
                                    type: "AutoAdjust"
                                }), this.currentEffects &= -2049;
                        }
                    }
                    return f.response = v, f;
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f, this.currentEffects = 0, this.currentEffectPayload = {
                        effectType: 0
                    }, this.shouldReconfigure = !1;
                }
            }, IC = class extends Bt {
                get isEffectEnabled() {
                    return this.currentEffect !== lr.AudioEffectType.Off;
                }
                shouldFallbackToNativeProcessing() {
                    return !!this.configProvider.config.enableAudioProcessingFallback && (this.configProvider.config.wasmvqe.enableVqe || this.configProvider.config.wasmdns.enableNoiseSuppression ? this.hasError ? (this.logger.safe.info("shouldFallbackToNativeProcessing: error was encountred initializing the package"), !0) : this.configProvider.config.wasmvqe.enableVqe && !this.wasmVqeProvider ? (this.logger.safe.info("shouldFallbackToNativeProcessing: VQE provider is enabled but not loaded"), !0) : !(!this.configProvider.config.wasmdns.enableNoiseSuppression || this.wasmdnsProvider && this.wasmaecProvider) && (this.logger.safe.info("shouldFallbackToNativeProcessing: DNS/AEC provider is enabled but not loaded"), !0) : (this.logger.safe.info("shouldFallbackToNativeProcessing: custom processing is not enabled"), !0));
                }
                nsModeToVqeMode(g, f) {
                    switch(g){
                        case "High":
                            return f ? lr.VqeMode.DeepVQE : lr.VqeMode.DeepNS;
                        case "Low":
                            return f ? lr.VqeMode.SkypeVQE : lr.VqeMode.SkypeNS;
                        default:
                            return f ? lr.VqeMode.SkypeAEC : lr.VqeMode.Off;
                    }
                }
                vqeModeToNsMode(g) {
                    switch(g){
                        case lr.VqeMode.DeepVQE:
                        case lr.VqeMode.DeepNS:
                            return "High";
                        case lr.VqeMode.SkypeVQE:
                        case lr.VqeMode.SkypeNS:
                            return "Low";
                        case lr.VqeMode.SkypeAEC:
                        case lr.VqeMode.Off:
                        default:
                            return "Off";
                    }
                }
                vqeModeToAudioEffectType(g) {
                    switch(g){
                        case lr.VqeMode.DeepVQE:
                            return 16;
                        case lr.VqeMode.DeepNS:
                            return 2;
                        case lr.VqeMode.SkypeVQE:
                            return 8;
                        case lr.VqeMode.SkypeNS:
                            return 1;
                        case lr.VqeMode.SkypeAEC:
                            return 4;
                        case lr.VqeMode.Off:
                        default:
                            return 0;
                    }
                }
                audioEffectTypeToVqeMode(g) {
                    switch(g){
                        case 16:
                            return lr.VqeMode.DeepVQE;
                        case 2:
                            return lr.VqeMode.DeepNS;
                        case 8:
                            return lr.VqeMode.SkypeVQE;
                        case 1:
                            return lr.VqeMode.SkypeNS;
                        case 4:
                            return lr.VqeMode.SkypeAEC;
                        default:
                            return lr.VqeMode.Off;
                    }
                }
                async initializeProvider() {
                    if (this.configProvider.config.wasmvqe.enableVqe && !this.vqeProvider) return this.logger.safe.debug("Initializing VQE provider ..."), void (this.vqeProvider = await this.initializeAudioEffectProvider(lr.AudioEffectType.VoiceQualityEnhancementDeep));
                    this.configProvider.config.wasmdns.enableNoiseSuppression && !this.dnsProvider && (this.logger.safe.debug("Initializing DNS provider ..."), this.dnsProvider = await this.initializeAudioEffectProvider(lr.AudioEffectType.NoiseSuppressionDeep)), this.configProvider.config.wasmdns.enableNoiseSuppression && !this.aecProvider && (this.logger.safe.debug("Initializing AEC provider ..."), this.aecProvider = await this.initializeAudioEffectProvider(lr.AudioEffectType.EchoCancellationClassic));
                }
                async configureEffect(g) {
                    this.statistics.clearErrors();
                    let f = g;
                    if (!f) {
                        let g = this.configProvider.mediaConfig.noiseSuppressionMode;
                        this.logger.safe.info(`Configuring the audio effect manager for Noise Suppression mode: ${g}`), "Auto" === g && (g = this.configProvider.config.wasmvqe.enableVqe ? this.vqeModeToNsMode(this.configProvider.config.wasmvqe.defaultVqeMode) : this.configProvider.config.wasmdns.noiseSuppressionMode, this.logger.safe.info(`Overriding 'Auto' with ${g}`)), f = {
                            ...this.configProvider.config.wasmdns,
                            ...this.configProvider.config.wasmvqe
                        }, f.noiseSuppressionMode = g;
                    }
                    if (await this.getEffectsCapability(), this.configProvider.config.wasmvqe.enableVqe) try {
                        var _this_wasmLoader_audioWorklet, _this_wasmLoader, _this_wasmLoader_audioWorklet1, _this_wasmLoader1;
                        if (!this.vqeProvider) return void this.logger.safe.error("VQE provider is not initialized");
                        this.userNoiseSuppressionMode && (f.defaultVqeMode = this.userNoiseSuppressionMode), f.loadAudioWorkletCallback = (_this_wasmLoader = this.wasmLoader) === null || _this_wasmLoader === void 0 ? void 0 : (_this_wasmLoader_audioWorklet = _this_wasmLoader.audioWorklet) === null || _this_wasmLoader_audioWorklet === void 0 ? void 0 : _this_wasmLoader_audioWorklet.getWasmVqeWorklet, f.loadWasmWorkerCallback = (_this_wasmLoader1 = this.wasmLoader) === null || _this_wasmLoader1 === void 0 ? void 0 : (_this_wasmLoader_audioWorklet1 = _this_wasmLoader1.audioWorklet) === null || _this_wasmLoader_audioWorklet1 === void 0 ? void 0 : _this_wasmLoader_audioWorklet1.getWasmVqeWorker, this.logger.safe.debug("Configuring VQE audio effects ..."), await this.vqeProvider.configureEffect(f), this.logger.safe.debug(`The audio effects were configured as follows: ${stringifyObject(f)}, and current capability is ${this.currentEffectCapability}.`);
                    } catch (g) {
                        this.notifyError("FailedToInitialize", `Audio effect provider configuration failed (${g}), while trying to use this configuration: ${stringifyObject(f)},\n                    under the following capability: ${this.currentEffectCapability}.`), this.requestStreamUpdate(!1, !0);
                    }
                    else if (this.configProvider.config.wasmdns.enableNoiseSuppression) {
                        f.noiseSuppressionMode || (this.logger.safe.debug("configureEffect was called without a noiseSuppressionMode. Using noiseSuppressionMode from config provider ..."), f.noiseSuppressionMode = this.configProvider.mediaConfig.noiseSuppressionMode), this.currentEffect = this.noiseSuppressionModeToWasmDnsEffectMapping[f.noiseSuppressionMode], this.logger.safe.debug(`currentEffect is ${this.currentEffect}`);
                        try {
                            var _this_wasmLoader_audioWorklet2, _this_wasmLoader2, _this_wasmLoader_audioWorklet3, _this_wasmLoader3;
                            if (!this.dnsProvider || !this.aecProvider) return void this.logger.safe.debug("DNS & AEC providers not initialized");
                            this.logger.safe.debug("Configuring DNS/AEC audio effects ..."), f.loadAudioWorkletCallback = (_this_wasmLoader2 = this.wasmLoader) === null || _this_wasmLoader2 === void 0 ? void 0 : (_this_wasmLoader_audioWorklet2 = _this_wasmLoader2.audioWorklet) === null || _this_wasmLoader_audioWorklet2 === void 0 ? void 0 : _this_wasmLoader_audioWorklet2.getWasmDnsWorklet, await this.dnsProvider.configureEffect(f), f.loadAudioWorkletCallback = (_this_wasmLoader3 = this.wasmLoader) === null || _this_wasmLoader3 === void 0 ? void 0 : (_this_wasmLoader_audioWorklet3 = _this_wasmLoader3.audioWorklet) === null || _this_wasmLoader_audioWorklet3 === void 0 ? void 0 : _this_wasmLoader_audioWorklet3.getWasmAecWorklet, await this.aecProvider.configureEffect(f), this.logger.safe.debug(`The audio effects were configured as follows: ${stringifyObject(f)}, and current capability is ${this.currentEffectCapability}.`);
                        } catch (g) {
                            this.notifyError("FailedToInitialize", `Audio effect provider configuration failed (${g}), while trying to use this configuration: ${stringifyObject(f)},\n                    under the following capability: ${this.currentEffectCapability}.`), this.requestStreamUpdate(!1, !0);
                        }
                    }
                }
                async setSourceAsync(g) {
                    var _this_vqeProvider, _this_vqeProvider1, _this_vqeProvider2, _this_dnsProvider, _this_dnsProvider1, _this_dnsProvider2, _this_aecProvider;
                    if (this.logger.safe.debug(`Set source: ${g ? g.id : "no stream"}, currentEffect = ${this.currentEffect}`), this.stopped || (this.stop(), this.stopped = !1), this.shouldFallbackToNativeProcessing()) return this.logger.safe.info("No custom audio effect is used. Fallback to native audio processing"), g;
                    if (await this.initializeProvider(), await this.configureEffect(), !(this.vqeProvider || this.dnsProvider && this.aecProvider)) {
                        const f = this.vqeProvider ? this.dnsProvider ? "AEC" : "DNS" : "VQE";
                        return this.statistics.setError("FailedToInitialize", `setSourceAsync: audio effect provider not initialized (${f}).`), this.logger.safe.warn(`Unable to configure audio effects: audio effect provider not initialized (${f}).`), g;
                    }
                    if (!this.configProvider.config.wasmvqe.enableVqe && !this.configProvider.config.wasmdns.enableNoiseSuppression) return g;
                    if (this.effectProviderSubs = [
                        (_this_vqeProvider = this.vqeProvider) === null || _this_vqeProvider === void 0 ? void 0 : _this_vqeProvider.on("onEffectStopped", ()=>this.notifyAboutLastSessionStats()),
                        (_this_vqeProvider1 = this.vqeProvider) === null || _this_vqeProvider1 === void 0 ? void 0 : _this_vqeProvider1.on("onMetricsUpdated", ()=>this.notifyAboutLastSessionStats()),
                        (_this_vqeProvider2 = this.vqeProvider) === null || _this_vqeProvider2 === void 0 ? void 0 : _this_vqeProvider2.on("onErrorNotified", (g, f)=>this.notifyError("WasmVqeProcessorError", g, f)),
                        (_this_dnsProvider = this.dnsProvider) === null || _this_dnsProvider === void 0 ? void 0 : _this_dnsProvider.on("onEffectStopped", ()=>this.notifyAboutLastSessionStats()),
                        (_this_dnsProvider1 = this.dnsProvider) === null || _this_dnsProvider1 === void 0 ? void 0 : _this_dnsProvider1.on("onMetricsUpdated", ()=>this.notifyAboutLastSessionStats()),
                        (_this_dnsProvider2 = this.dnsProvider) === null || _this_dnsProvider2 === void 0 ? void 0 : _this_dnsProvider2.on("onErrorNotified", (g)=>this.notifyError("WasmDnsProcessorError", g)),
                        (_this_aecProvider = this.aecProvider) === null || _this_aecProvider === void 0 ? void 0 : _this_aecProvider.on("onErrorNotified", (g)=>this.notifyError("WasmAecProcessorError", g))
                    ], this.configProvider.config.wasmvqe.enableVqe) try {
                        const f = await this.vqeProvider.setSourceAsync(g);
                        return this.aecRefStream && (this.logger.safe.debug(`Setting the reference stream to: ${this.aecRefStream.id}`), this.vqeProvider.setRefStream(this.aecRefStream)), f;
                    } catch (f) {
                        return this.notifyError("WasmVqeProcessorError", `setSourceAsync: Failed to asynchronously set source for VQE (${f})`), g;
                    }
                    let f = g;
                    try {
                        var _this_aecProvider_setRefStream, _this_aecProvider1;
                        f = await this.aecProvider.setSourceAsync(g), this.aecRefStream && (this.logger.safe.debug(`Setting the reference stream to: ${this.aecRefStream.id}`), (_this_aecProvider_setRefStream = (_this_aecProvider1 = this.aecProvider).setRefStream) === null || _this_aecProvider_setRefStream === void 0 ? void 0 : _this_aecProvider_setRefStream.call(_this_aecProvider1, this.aecRefStream));
                    } catch (g) {
                        this.notifyError("WasmAecProcessorError", `setSourceAsync: Failed to asynchronously set source for AEC (${g})`);
                    }
                    try {
                        return await this.dnsProvider.setSourceAsync(f);
                    } catch (g) {
                        this.notifyError("WasmDnsProcessorError", `setSourceAsync: Failed to asynchronously set source for DNS (${g})`);
                    }
                    return f;
                }
                async setAecRefStream(g) {
                    try {
                        var _this_aecRefStream;
                        if ((g === null || g === void 0 ? void 0 : g.id) === ((_this_aecRefStream = this.aecRefStream) === null || _this_aecRefStream === void 0 ? void 0 : _this_aecRefStream.id)) return void this.logger.safe.debug(`Ref stream with id: ${g ? g.id : "Null"} is already set`);
                        if (this.logger.safe.debug(`Setting the reference stream to: ${g ? g.id : "Null"}`), !(this.vqeProvider || this.dnsProvider && this.aecProvider)) {
                            const g = this.vqeProvider ? this.dnsProvider ? "AEC" : "DNS" : "VQE";
                            return this.statistics.setError("FailedToInitialize", `setAecRefStream: audio effect provider not initialized (${g}).`), void this.logger.safe.warn(`Unable to setAecRefStream for audio effects: audio effect provider not initialized (${g}).`);
                        }
                        this.configProvider.config.wasmvqe.enableVqe ? this.vqeProvider.setRefStream(g) : this.configProvider.config.wasmdns.enableNoiseSuppression && this.aecProvider.setRefStream(g);
                    } catch (g) {
                        this.notifyError("WasmVqeProcessorError", `setRefStream: Failed to set reference stream for echo cancellation (${g})`);
                    }
                    this.aecRefStream = g;
                }
                async setEffectAsync(g) {
                    const f = this.audioEffectToWasmAudioEffectType[g];
                    if (this.currentEffect === f) return;
                    const S = this.currentEffect === lr.AudioEffectType.Off || f === lr.AudioEffectType.Off;
                    if (this.currentEffect = f, this.userNoiseSuppressionMode = this.audioEffectTypeToVqeMode(g), await this.initializeProvider(), await this.configureEffect(), !(this.vqeProvider || this.dnsProvider && this.aecProvider)) {
                        const g = this.vqeProvider ? this.dnsProvider ? "AEC" : "DNS" : "VQE";
                        throw this.notifyError("FailedToInitialize", `setEffectAsync: audio effect provider not initialized (${g}).`), Error("FailedToInitialize");
                    }
                    try {
                        this.configProvider.config.wasmvqe.enableVqe ? await this.vqeProvider.setEffectAsync(f) : this.configProvider.config.wasmdns.enableNoiseSuppression && (await this.dnsProvider.setEffectAsync(f), await this.aecProvider.setEffectAsync(f)), this.configProvider.config.applyAudioEffectOnDemand && this.configProvider.config.wasmvqe.enableVqe && S && this.requestStreamUpdate(!0), this.logger.safe.debug(`The audio effect was set to '${f}'`);
                    } catch (g) {
                        throw this.notifyError("WasmVqeProcessorError", `setEffectAsync: Failed to apply '${f}' audio effect, error: ${stringifyObject(g)}`), g;
                    }
                }
                stop() {
                    try {
                        var _this_dnsProvider, _this_aecProvider, _this_vqeProvider, _this_effectProviderSubs;
                        this.aecRefStream = null, (_this_dnsProvider = this.dnsProvider) === null || _this_dnsProvider === void 0 ? void 0 : _this_dnsProvider.dispose(), this.dnsProvider = null, (_this_aecProvider = this.aecProvider) === null || _this_aecProvider === void 0 ? void 0 : _this_aecProvider.dispose(), this.aecProvider = null, (_this_vqeProvider = this.vqeProvider) === null || _this_vqeProvider === void 0 ? void 0 : _this_vqeProvider.dispose(), this.vqeProvider = null, (_this_effectProviderSubs = this.effectProviderSubs) === null || _this_effectProviderSubs === void 0 ? void 0 : _this_effectProviderSubs.forEach((g)=>g === null || g === void 0 ? void 0 : g.dispose()), this.effectProviderSubs = null, this.stopped = !0, this.logger.safe.debug("The audio effects provider was stopped.");
                    } catch (g) {
                        this.logger.safe.error(`Failed to stop the audio effects provider (${g})`);
                    }
                }
                dispose() {
                    try {
                        this.hasError = !1, this.stop(), super.dispose(), this.logger.safe.debug("The audio effects provider was disposed.");
                    } catch (g) {
                        this.logger.safe.error(`dispose: Failed to dispose the audio effects provider (${g})`);
                    }
                }
                async getEffectsCapability() {
                    return this.currentEffectCapability = 0, this.configProvider.config.wasmvqe.enableVqe ? (this.currentEffectCapability |= 1, this.currentEffectCapability |= 2, this.configProvider.config.wasmvqe.enableAec && (this.currentEffectCapability |= 4, this.currentEffectCapability |= 8, this.currentEffectCapability |= 16)) : this.configProvider.config.wasmdns.enableNoiseSuppression && (this.currentEffectCapability |= 1, this.currentEffectCapability |= 2, this.currentEffectCapability |= 4), this.currentEffectCapability;
                }
                getVersion() {
                    var _this_dnsProvider, _this_aecProvider, _this_vqeProvider;
                    var _this_dnsProvider_getVersion, _this_aecProvider_getVersion, _this_vqeProvider_getVersion;
                    return `${`WasmDns ${(_this_dnsProvider_getVersion = (_this_dnsProvider = this.dnsProvider) === null || _this_dnsProvider === void 0 ? void 0 : _this_dnsProvider.getVersion()) !== null && _this_dnsProvider_getVersion !== void 0 ? _this_dnsProvider_getVersion : "Unknown"}`} / ${`WasmAec ${(_this_aecProvider_getVersion = (_this_aecProvider = this.aecProvider) === null || _this_aecProvider === void 0 ? void 0 : _this_aecProvider.getVersion()) !== null && _this_aecProvider_getVersion !== void 0 ? _this_aecProvider_getVersion : "Unknown"}`} / ${`WasmVqe ${(_this_vqeProvider_getVersion = (_this_vqeProvider = this.vqeProvider) === null || _this_vqeProvider === void 0 ? void 0 : _this_vqeProvider.getVersion()) !== null && _this_vqeProvider_getVersion !== void 0 ? _this_vqeProvider_getVersion : "Unknown"}`}`;
                }
                getStats() {
                    var _this_vqeProvider, _this_dnsProvider;
                    const g = this.configProvider.config.wasmvqe.enableVqe ? (_this_vqeProvider = this.vqeProvider) === null || _this_vqeProvider === void 0 ? void 0 : _this_vqeProvider.getStats() : (_this_dnsProvider = this.dnsProvider) === null || _this_dnsProvider === void 0 ? void 0 : _this_dnsProvider.getStats();
                    return g ? (g.userNoiseSuppressionMethod = this.userNoiseSuppressionMode, {
                        timestamp: Date.now(),
                        ...this.createTelemetryEvent(g)
                    }) : null;
                }
                async initializeAudioEffectProvider(g) {
                    var _f_getVersion, _f_getVersion1, _f_getVersion2;
                    if (!this.wasmVqeProvider && g === lr.AudioEffectType.VoiceQualityEnhancementDeep) return this.statistics.setError("FailedToInitialize", "initializeAudioEffectProvider: WasmVqe package not available."), this.logger.safe.warn("WasmVqe package not available."), null;
                    if (!this.wasmdnsProvider && g === lr.AudioEffectType.NoiseSuppressionDeep) return this.statistics.setError("FailedToInitialize", "initializeAudioEffectProvider: WasmDns package not available."), this.logger.safe.warn("WasmDns package not available."), null;
                    if (!this.wasmaecProvider && g === lr.AudioEffectType.EchoCancellationClassic) return this.statistics.setError("FailedToInitialize", "initializeAudioEffectProvider: WasmAec package not available."), this.logger.safe.warn("WasmAec package not available."), null;
                    let f;
                    this.statistics.startLoadTimer();
                    try {
                        this.configProvider.config.wasmvqe.enableVqe && g === lr.AudioEffectType.VoiceQualityEnhancementDeep && (f = await this.wasmVqeProvider.getAudioEffectProvider()), this.configProvider.config.wasmdns.enableNoiseSuppression && g === lr.AudioEffectType.NoiseSuppressionDeep && (f = await this.wasmdnsProvider.getAudioEffectProvider()), this.configProvider.config.wasmdns.enableNoiseSuppression && g === lr.AudioEffectType.EchoCancellationClassic && (f = await this.wasmaecProvider.getAudioEffectProvider());
                    } catch (g) {
                        this.logger.safe.warn(`initializeAudioEffectProvider: Failed to initialize the audio effect provider (${g})`), this.statistics.setError("FailedToInitialize", `initializeAudioEffectProvider: Failed to initialize the audio effect provider (${g})`);
                    }
                    return this.statistics.stopLoadTimer(), f ? (g === lr.AudioEffectType.VoiceQualityEnhancementDeep && this.logger.safe.debug(`WasmVqe v${(_f_getVersion = f.getVersion) === null || _f_getVersion === void 0 ? void 0 : _f_getVersion.call(f)} initialized!`), g === lr.AudioEffectType.NoiseSuppressionDeep && this.logger.safe.debug(`WasmDns v${(_f_getVersion1 = f.getVersion) === null || _f_getVersion1 === void 0 ? void 0 : _f_getVersion1.call(f)} initialized!`), g === lr.AudioEffectType.EchoCancellationClassic && this.logger.safe.debug(`WasmAec v${(_f_getVersion2 = f.getVersion) === null || _f_getVersion2 === void 0 ? void 0 : _f_getVersion2.call(f)} initialized!`), f) : (this.logger.safe.warn("Unitialized Wasm audio effect provider."), null);
                }
                createTelemetryEvent(g) {
                    return {
                        payload: {
                            audioEffectsCapability: this.currentEffectCapability,
                            version: this.getVersion(),
                            ...this.statistics.getReport(),
                            ...g
                        }
                    };
                }
                notifyError(g, f, S = !1) {
                    this.logger.error(`Audio effect error: ${g}, message: ${f}`), this.statistics.setError(g, f), this.notifyAboutLastSessionStats(), S && this.requestStreamUpdate(!1, !0), this.event("onEffectsError").raise("Audio", g, f);
                }
                notifyAboutLastSessionStats() {
                    const g = this.getStats();
                    g && this.event("onAudioEffectTelemetryEvent").raise(g);
                }
                requestStreamUpdate(g = !1, f = !1) {
                    (g || this.configProvider.config.enableAudioProcessingFallback && !this.hasError) && (this.hasError = f, this.event("onMediaStreamUpdateRequested").raise("Audio"));
                }
                constructor(g, f, S, v, _, C){
                    super(_), this.wasmdnsProvider = g, this.wasmaecProvider = f, this.wasmVqeProvider = S, this.configProvider = v, this.logger = _, this.wasmLoader = C, this.serialQueue = new q_(this.logger), this.stopped = !0, this.hasError = !1, this.statistics = new yC(this.configProvider.config.effectsTelemetryBufferSize), this.currentEffect = lr.AudioEffectType.Off, this.currentEffectCapability = 0, this.audioEffectToWasmAudioEffectType = {
                        0: lr.AudioEffectType.Off,
                        1: lr.AudioEffectType.NoiseSuppressionClassic,
                        2: lr.AudioEffectType.NoiseSuppressionDeep,
                        4: lr.AudioEffectType.EchoCancellationClassic,
                        8: lr.AudioEffectType.VoiceQualityEnhancementClassic,
                        16: lr.AudioEffectType.VoiceQualityEnhancementDeep
                    }, this.noiseSuppressionModeToWasmDnsEffectMapping = {
                        Off: lr.AudioEffectType.Off,
                        High: lr.AudioEffectType.NoiseSuppressionDeep,
                        Low: lr.AudioEffectType.NoiseSuppressionClassic
                    };
                }
            };
            __decorateClass([
                sequentialize()
            ], IC.prototype, "setSourceAsync", 1), __decorateClass([
                sequentialize()
            ], IC.prototype, "setAecRefStream", 1), __decorateClass([
                sequentialize()
            ], IC.prototype, "setEffectAsync", 1), __decorateClass([
                sequentialize()
            ], IC.prototype, "stop", 1), __decorateClass([
                sequentialize()
            ], IC.prototype, "dispose", 1);
            var bC = class {
                async setSourceAsync(g) {
                    let f = document.createElement("video");
                    return f.srcObject = g, this.logger.info(`Stream settings before play: ${JSON.stringify(this.getSettings(g))}`), await f.play(), this.logger.info(`Stream settings after play: ${JSON.stringify(this.getSettings(g))}`), f.pause(), f.srcObject = null, f.remove(), f = null, g;
                }
                getSettings(g) {
                    var _g_getVideoTracks_, _g_getVideoTracks;
                    return (_g_getVideoTracks = g.getVideoTracks()) === null || _g_getVideoTracks === void 0 ? void 0 : (_g_getVideoTracks_ = _g_getVideoTracks[0]) === null || _g_getVideoTracks_ === void 0 ? void 0 : _g_getVideoTracks_.getSettings();
                }
                constructor(g){
                    this.logger = g;
                }
            }, AC = class extends Bt {
                isEffectEnabled(g) {
                    switch(g){
                        case "Video":
                            var _this_videoEffectManager;
                            return (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.isEffectEnabled;
                        case "Audio":
                            var _this_audioEffectManager;
                            return (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.isEffectEnabled;
                        default:
                            return !1;
                    }
                }
                shouldFallbackToNativeProcessing(g) {
                    var _this_audioEffectManager;
                    return "Audio" === g && ((_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.shouldFallbackToNativeProcessing());
                }
                addEffectManager(g, f) {
                    switch(g){
                        case "Audio":
                            this.addAudioEffectManagerAndSubscribe(f);
                            break;
                        case "Video":
                            this.addVideoEffectManagerAndSubscribe(f);
                            break;
                        case "ScreenShare":
                            this.delayedScreenShareEffectManager = new bC(this.logger.createChild("DelayedScreenShareEffectManager"));
                    }
                }
                async startEffect(g, f) {
                    switch(g){
                        case "Audio":
                            return this.audioEffectManager.setSourceAsync(f);
                        case "Video":
                            return this.videoEffectManager.setSourceAsync(f);
                        case "ScreenShare":
                            return this.delayedScreenShareEffectManager.setSourceAsync(f);
                        default:
                            return f;
                    }
                }
                async setEffectType(g, f) {
                    switch(g){
                        case "Audio":
                            var _this_audioEffectManager;
                            return (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.setEffectAsync(f);
                        case "Video":
                            var _this_videoEffectManager;
                            return (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.setEffectAsync(f);
                    }
                }
                async processingVideoEffectMessage(g) {
                    return this.videoEffectManager.processingVideoEffectMessage(g);
                }
                stopEffect(g, f) {
                    switch(g){
                        case "Audio":
                            var _this_audioEffectManager;
                            this.logger.safe.info("stopping audio effect"), (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.stop();
                            break;
                        case "Video":
                            var _this_videoEffectManager;
                            this.logger.safe.info("stopping video effect"), (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.removeSourceAsync(f);
                    }
                }
                resetOutputConstraints(g, f, S) {
                    var _this_videoEffectManager;
                    if ("Video" === g) (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.resetOutputConstraints(f, S);
                }
                getStats(g, f) {
                    switch(g){
                        case "Audio":
                            var _this_audioEffectManager;
                            return (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.getStats();
                        case "Video":
                            var _this_videoEffectManager;
                            return (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.getStats(f);
                        default:
                            return;
                    }
                }
                async configure(g, f) {
                    var _this_videoEffectManager;
                    if ("Video" === g) return (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.configure(f);
                }
                async getEffectsCapability(g) {
                    switch(g){
                        case "Audio":
                            var _this_audioEffectManager;
                            return (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.getEffectsCapability();
                        case "Video":
                            var _this_videoEffectManager;
                            return (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.getEffectsCapability();
                        default:
                            return 0;
                    }
                }
                setAecRefStream(g) {
                    return this.audioEffectManager.setAecRefStream(g);
                }
                vqeModeToAudioEffectType(g) {
                    return this.audioEffectManager.vqeModeToAudioEffectType(g);
                }
                nsModeToVqeMode(g, f) {
                    return this.audioEffectManager.nsModeToVqeMode(g, f);
                }
                getAudioEffectsProviderName() {
                    let g = "None";
                    return this.configProvider.config.wasmvqe.enableVqe ? g = "DeepVqe" : this.configProvider.config.wasmdns.enableNoiseSuppression && (g = "DNS"), g;
                }
                dispose() {
                    var _this_audioEffectManager, _this_videoEffectManager;
                    super.dispose(), (_this_audioEffectManager = this.audioEffectManager) === null || _this_audioEffectManager === void 0 ? void 0 : _this_audioEffectManager.dispose(), this.audioEffectManager = null, (_this_videoEffectManager = this.videoEffectManager) === null || _this_videoEffectManager === void 0 ? void 0 : _this_videoEffectManager.dispose(), this.videoEffectManager = null;
                }
                addAudioEffectManagerAndSubscribe(g) {
                    this.audioEffectManager || (this.audioEffectManager = new IC(g.wasmdnsProvider, g.wasmaecProvider, g.wasmVqeProvider, this.configProvider, this.logger.createChild("AudioEffectManager"), g.wasmLoader), this.audioEffectManager.on("onAudioEffectTelemetryEvent", (g)=>{
                        this.event("onAudioEffectTelemetryEvent").raise(g);
                    }), this.audioEffectManager.on("onMediaStreamUpdateRequested", (g)=>{
                        this.event("onMediaStreamUpdateRequested").raise(g);
                    }), this.audioEffectManager.on("onEffectsError", (g, f, S)=>{
                        this.event("onEffectsError").raise(g, f, S);
                    }));
                }
                addVideoEffectManagerAndSubscribe(g) {
                    this.videoEffectManager || (this.videoEffectManager = new EC(g.webcvProvider, this.configProvider, this.logger.createChild("VideoEffectManager"), g.wasmLoader), this.videoEffectManager.on("onMediaStreamUpdateRequested", (g)=>{
                        this.event("onMediaStreamUpdateRequested").raise(g);
                    }), this.videoEffectManager.on("onVideoEffectQualityChanged", (g)=>{
                        this.event("onVideoEffectQualityChanged").raise(g);
                    }), this.videoEffectManager.on("onVideoStreamQualityChanged", (g, f, S)=>{
                        this.event("onVideoStreamQualityChanged").raise(g, f, S);
                    }), this.videoEffectManager.on("onVideoEffectCapabilitiesChanged", ()=>{
                        this.event("onVideoEffectCapabilitiesChanged").raise();
                    }), this.videoEffectManager.on("onVideoEffectTelemetryEvent", (g)=>{
                        this.event("onVideoEffectTelemetryEvent").raise(g);
                    }), this.videoEffectManager.on("onVideoEffectApplied", ()=>{
                        this.event("onVideoEffectApplied").raise();
                    }), this.videoEffectManager.on("videoFreezeDetected", (g)=>{
                        this.event("videoFreezeDetected").raise(g);
                    }));
                }
                constructor(g, f){
                    super(), this.configProvider = g, this.logger = f;
                }
            }, RC = class {
                dispose() {
                    this.sourceNode.disconnect(), this.audioContext.close(), this.audioContext = null, this.sourceNode = null, this.analyzerNode = null, this.freqs = null;
                }
                getData(g) {
                    var _this_analyzerNode, _this_analyzerNode1;
                    return 1 === g ? (_this_analyzerNode = this.analyzerNode) === null || _this_analyzerNode === void 0 ? void 0 : _this_analyzerNode.getByteFrequencyData(this.freqs) : 0 === g && ((_this_analyzerNode1 = this.analyzerNode) === null || _this_analyzerNode1 === void 0 ? void 0 : _this_analyzerNode1.getByteTimeDomainData(this.freqs)), this.freqs;
                }
                getDataFloat(g) {
                    var _this_analyzerNode, _this_analyzerNode1;
                    return 1 === g ? (_this_analyzerNode = this.analyzerNode) === null || _this_analyzerNode === void 0 ? void 0 : _this_analyzerNode.getFloatFrequencyData(this.ffreqs) : 0 === g && ((_this_analyzerNode1 = this.analyzerNode) === null || _this_analyzerNode1 === void 0 ? void 0 : _this_analyzerNode1.getFloatTimeDomainData(this.ffreqs)), this.ffreqs;
                }
                getInputLevel() {
                    var _this_analyzerNode;
                    return (_this_analyzerNode = this.analyzerNode) === null || _this_analyzerNode === void 0 ? void 0 : _this_analyzerNode.getByteFrequencyData(this.freqs), getAverage(this.freqs);
                }
                getInputLevelNormalized(g = 65535, f = 255) {
                    return Math.floor(this.getInputLevel() * g / f);
                }
                createAnalyserNode(g) {
                    const f = this.audioContext.createAnalyser();
                    return f.fftSize = 1024, f.smoothingTimeConstant = .1, g.connect(f), f;
                }
                constructor(g){
                    this.audioContext = new Qa.window.AudioContext, g ? (this.sourceNode = this.audioContext.createMediaStreamSource(g), this.analyzerNode = this.createAnalyserNode(this.sourceNode), this.freqs = new Uint8Array(this.analyzerNode.frequencyBinCount), this.ffreqs = new Float32Array(this.analyzerNode.frequencyBinCount)) : (this.freqs = new Uint8Array(0), this.ffreqs = new Float32Array(0));
                }
            }, PC = class _AudioStreamAnalyzerWrapper {
                getInputLevel() {
                    return this.audioStreamAnalyzer.getDataFloat(0).reduce((g, f)=>Math.max(Math.abs(f), g), 0);
                }
                getInputLevelNormalized(g, f) {
                    throw new Error("Method not implemented.");
                }
                dispose(g) {
                    var _this_rawStream;
                    this.logger.safe.info(`[${g}] AudioStreamAnalyzerWrapper disposed`), this.audioStreamAnalyzer.dispose(), (_this_rawStream = this.rawStream) === null || _this_rawStream === void 0 ? void 0 : _this_rawStream.dispose();
                }
                static async init(g, f) {
                    try {
                        const S = g.getRawDeviceMediaStream("Audio"), v = await S.getMediaStream(), _ = new RC(v), C = new _AudioStreamAnalyzerWrapper(f, _, S);
                        return C.rawStream.changed(async ()=>{
                            const g = await S.getMediaStream();
                            C.audioStreamAnalyzer.dispose(), C.audioStreamAnalyzer = new RC(g);
                        }), f.safe.info("AudioStreamAnalyzerWrapper created"), C;
                    } catch (g) {
                        f.safe.warn(`failed to acquire audio stream for mic level: ${g}`);
                        const S = new RC;
                        return new _AudioStreamAnalyzerWrapper(f, S);
                    }
                }
                constructor(g, f, S){
                    this.logger = g, this.audioStreamAnalyzer = f, this.rawStream = S;
                }
            }, wC = class _DeviceManager extends Bt {
                get deviceList() {
                    return gC.list.devices;
                }
                get isDeviceListAvailable() {
                    return gC.isDeviceListAvailable;
                }
                get isAudioOutputSelectionSupported() {
                    return this.configProvider.userAgentConfig.isAudioOutputSelectionSupported;
                }
                get effectsManager() {
                    return this.effectsManagerInternal;
                }
                createPreviewRenderer(g, f) {
                    const S = new Z_(g, this, this.logger.createChild("videorenderer"), this.configProvider, f);
                    return this.domOverrides.onMediaElementAdded && this.domOverrides.onMediaElementAdded(S.getVideoElement()), this.subscribeOnRendererEvents(S), S;
                }
                async askDevicePermission(g) {
                    await this.isDeviceListAvailable.promise;
                    const f = await this.permissionManager.askDevicePermission(g);
                    if (this.configProvider.config.devices.enumerateDevicesAfterADP) try {
                        await gC.enumerateDevices();
                    } catch (g) {
                        this.logger.safe.warn(`Post-ADP device enumeration failed: ${stringifyObject(g)}`);
                    }
                    return f;
                }
                getPermissionState(g) {
                    return this.permissionManager.getPermissionState(g);
                }
                handlePermissionStateChange() {
                    this.diagnostics && (this.diagnostics.permissionStates = this.permissionManager.knownPermissionStates), this.event("onPermissionStateChanged").raise();
                }
                onMediaStreamUpdateRequested(g, f = !1) {
                    if ("Video" === g && (this.updateRenderersAsync(), this.effectsManager.isEffectEnabled("Video"))) return this.logger.safe.info("onStreamUpdateRequested will be called after the first frame is proccessed of the video effect stream"), void this.effectsManager.once("onVideoEffectApplied", ()=>this.event("onStreamUpdateRequested").raise(g));
                    this.event("onStreamUpdateRequested").raise(g, f);
                }
                createAudioRenderer() {
                    const g = new G_(this.logger.createChild("CustomAudioRenderer"), this.configProvider), f = uniqueId();
                    this.clientAudioRenderers.set(f, g);
                    const S = g.play.bind(g), v = g.stop.bind(g);
                    return this.raiseTelemetryEvent("custom_audio_renderer_created", this.getSelectedDevices()), {
                        play: S,
                        stop: v,
                        dispose: ()=>{
                            var _this_clientAudioRenderers_get;
                            (_this_clientAudioRenderers_get = this.clientAudioRenderers.get(f)) === null || _this_clientAudioRenderers_get === void 0 ? void 0 : _this_clientAudioRenderers_get.dispose(), this.clientAudioRenderers.delete(f);
                        },
                        setMuted: (f, S = generateCauseId())=>g.setMuted(f, S),
                        isMuted: ()=>g.muted
                    };
                }
                setAudioSharingRequested(g) {
                    this.audioSharingRequested = g;
                }
                createDevicesHandle(g, f, S) {
                    var _this_customDeviceMediaStreamMap_get;
                    const v = g.sharing ? "ScreenShare" : g.video ? "Video" : "Audio";
                    return new mC(this.logger.createChild("DevicesHandle"), this.getMediaStream({
                        ...g,
                        ...S && {
                            deviceId: S
                        },
                        withTimeout: !1,
                        withEffect: !1,
                        audioProcessingFlags: this.audioProcessingFlags,
                        force: !1,
                        withOverridenStream: ((_this_customDeviceMediaStreamMap_get = this.customDeviceMediaStreamMap.get(v)) === null || _this_customDeviceMediaStreamMap_get === void 0 ? void 0 : _this_customDeviceMediaStreamMap_get.active) && this.customDeviceMediaStreamMap.get(v)
                    }, f));
                }
                shareSystemSound(g) {
                    this.configProvider.config.postponeAudioMixerForAudioSharing && (this.audioSharingRequested = g, this.event("onAudioSharingToggled").raise(g));
                }
                getAllowedModalities() {
                    const g = shallowClone(this.permissionManager.browserPermittedModalities);
                    return this.hasDeviceType("microphone") || (g.audio = [
                        Gt.MEDIA_STATE.inactive,
                        Gt.MEDIA_STATE.receive
                    ]), this.hasDeviceType("camera") || (g.video = [
                        Gt.MEDIA_STATE.inactive,
                        Gt.MEDIA_STATE.receive
                    ]), g;
                }
                getRawDeviceMediaStream(g, f) {
                    if ("ScreenShare" !== g && !this.hasDeviceType(this.getDeviceType(g))) throw new Error("NoInputDevice");
                    this.audioSharingRequested = f;
                    const S = this.getStreamHandlerByType(g);
                    if (!S) return this.logger.safe.debug(`method not found for ${g}`), null;
                    const v = this.rawDeviceStreamManager.createIRawStreamClient(S, g);
                    return this.raiseTelemetryEvent("IRawStream_client_created", g), v;
                }
                setRawMediaStream(g, f) {
                    if (!g) throw this.logger.error(`Could not set ${g} as to ${f}`), new Error("InvalidStream");
                    this.customDeviceMediaStreamMap.set(f, g), this.onMediaStreamUpdateRequested(f), this.raiseTelemetryEvent("set_raw_outgoing_media_stream", f);
                }
                unsetRawMediaStream(g) {
                    this.customDeviceMediaStreamMap.get(g) ? (this.customDeviceMediaStreamMap.delete(g), this.onMediaStreamUpdateRequested(g), this.raiseTelemetryEvent("unset_raw_outgoing_media_stream", g)) : this.logger.safe.debug("no custom stream");
                }
                async setVideoEffects(g) {
                    return this.effectsManager.setEffectType("Video", g);
                }
                async sendMessageDeviceVideoEffectsAsync(g, f) {
                    return this.effectsManager.processingVideoEffectMessage(f);
                }
                async setAudioEffects(g) {
                    return this.effectsManager.setEffectType("Audio", g);
                }
                async getAudioStream(g, f, S = !1) {
                    var _this_customDeviceMediaStreamMap_get;
                    const v = this.configProvider.config.devices.enumerateBeforeGettingStream;
                    return v && ("always" !== v && gC.isPolling || await gC.enumerateDevices()), this.getMediaStream({
                        audio: !0,
                        withTimeout: this.permissionManager.isPermissionKnown("microphone"),
                        withEffect: !S && this.effectsManager.isEffectEnabled("Audio"),
                        audioProcessingFlags: this.getAudioProcessingFlags(),
                        force: g,
                        withOverridenStream: !S && ((_this_customDeviceMediaStreamMap_get = this.customDeviceMediaStreamMap.get("Audio")) === null || _this_customDeviceMediaStreamMap_get === void 0 ? void 0 : _this_customDeviceMediaStreamMap_get.active) && this.customDeviceMediaStreamMap.get("Audio")
                    }, f);
                }
                async getVideoStream(g, f, S = !1, v) {
                    var _this_customDeviceMediaStreamMap_get;
                    const _ = this.configProvider.config.devices.enumerateBeforeGettingStream;
                    return _ && ("always" !== _ && gC.isPolling || await gC.enumerateDevices()), this.getMediaStream({
                        video: !0,
                        withTimeout: this.permissionManager.isPermissionKnown("camera"),
                        withEffect: !S && this.configProvider.config.enableVideoEffects && this.effectsManager.isEffectEnabled("Video"),
                        force: g,
                        withOverridenStream: !S && ((_this_customDeviceMediaStreamMap_get = this.customDeviceMediaStreamMap.get("Video")) === null || _this_customDeviceMediaStreamMap_get === void 0 ? void 0 : _this_customDeviceMediaStreamMap_get.active) && this.customDeviceMediaStreamMap.get("Video"),
                        videoMaxFS: v
                    }, f);
                }
                getDisplayStream(g, f = !1) {
                    var _this_customDeviceMediaStreamMap_get;
                    const S = !(!this.configProvider.config.enableAudioSharing || !this.audioSharingRequested);
                    return this.getMediaStream({
                        audio: S,
                        sharing: !0,
                        withTimeout: !1,
                        withEffect: !1,
                        audioProcessingFlags: S ? 0 : void 0,
                        force: !1,
                        withOverridenStream: !f && ((_this_customDeviceMediaStreamMap_get = this.customDeviceMediaStreamMap.get("ScreenShare")) === null || _this_customDeviceMediaStreamMap_get === void 0 ? void 0 : _this_customDeviceMediaStreamMap_get.active) && this.customDeviceMediaStreamMap.get("ScreenShare")
                    }, g);
                }
                async enumerateDevicesAsync() {
                    return await this.isDeviceListAvailable.promise, this.getDeviceDescriptions(this.deviceList);
                }
                async getDeviceNameAsync(g) {
                    await this.isDeviceListAvailable.promise;
                    const f = this.deviceList.find((f)=>f.guid === g);
                    var _f_label;
                    return (_f_label = f === null || f === void 0 ? void 0 : f.label) !== null && _f_label !== void 0 ? _f_label : "";
                }
                async getSpeakerDeviceDomIdAsync(g) {
                    await this.isDeviceListAvailable.promise;
                    const f = this.deviceList.find((f)=>f.guid === g);
                    var _f_deviceId;
                    return (_f_deviceId = f === null || f === void 0 ? void 0 : f.deviceId) !== null && _f_deviceId !== void 0 ? _f_deviceId : "";
                }
                selectDevices(g) {
                    return this.pendingDevices ? (this.logger.safe.info(`Overriding device selection until enumeration is complete with ${JSON.stringify(scrubSelectedDevices(this.pendingDevices))}`), void (this.pendingDevices = g)) : this.isDeviceListAvailable.isPending ? (this.logger.safe.info("Postponing device selection until enumeration is complete"), this.pendingDevices = g, void this.isDeviceListAvailable.promise.then(()=>{
                        this.logger.safe.info("Performing postponed device selection");
                        const g = this.pendingDevices;
                        this.pendingDevices = null, this.selectDevices(g);
                    })) : void this.deviceSelection.selectDevices(g);
                }
                getSelectedDevices() {
                    return this.toSelectedDevices(this.deviceSelection.selectedDevices);
                }
                setAudioProcessingFlags(g) {
                    g !== this.audioProcessingFlags && (this.logger.debug(`Setting audio processing flags: ${this.audioProcessingFlags} -> ${g}`), this.audioProcessingFlags = g, this.event("onStreamUpdateRequested").raise("Audio"));
                }
                getOutputDeviceId() {
                    var _this_selectedDevices_speaker;
                    return (_this_selectedDevices_speaker = this.selectedDevices.speaker) === null || _this_selectedDevices_speaker === void 0 ? void 0 : _this_selectedDevices_speaker.deviceId;
                }
                getDeviceDescriptions(g) {
                    return (g || this.deviceList).map((g)=>g.toDeviceDesc());
                }
                getDevicesCount() {
                    return this.deviceList.reduce((g, f)=>(g[f.type]++, g), {
                        camera: 0,
                        speaker: 0,
                        microphone: 0,
                        compositeAudio: 0,
                        virtualDevice: 0,
                        audioIngestDevice: 0
                    });
                }
                async getKnownPermissionStates() {
                    return await this.permissionManager.initialize(), this.permissionManager.knownPermissionStates;
                }
                getLocalVideoRenderers() {
                    return this.activeRenderers;
                }
                dispose() {
                    var _this_deviceManagerSubscriptions, _this_virtualDeviceSubs, _this_virtualDeviceSubs1, _this_virtualDeviceRecord, _this_activeVideoEffectSub, _this_activeVideoStreamForEffect;
                    (_this_deviceManagerSubscriptions = this.deviceManagerSubscriptions) === null || _this_deviceManagerSubscriptions === void 0 ? void 0 : _this_deviceManagerSubscriptions.forEach((g)=>g.dispose()), this.deviceManagerSubscriptions = null, (_this_virtualDeviceSubs = this.virtualDeviceSubs) === null || _this_virtualDeviceSubs === void 0 ? void 0 : _this_virtualDeviceSubs.forEach((g)=>g.forEach((g)=>g.dispose())), (_this_virtualDeviceSubs1 = this.virtualDeviceSubs) === null || _this_virtualDeviceSubs1 === void 0 ? void 0 : _this_virtualDeviceSubs1.clear(), this.virtualDeviceSubs = null, (_this_virtualDeviceRecord = this.virtualDeviceRecord) === null || _this_virtualDeviceRecord === void 0 ? void 0 : _this_virtualDeviceRecord.forEach((g)=>g.dispose()), this.virtualDeviceRecord = null, this.unsubscribeFromStreamManagerEvents(), this.deviceEnumerator.dispose(), this.mediaStreamManager.dispose(), (_this_activeVideoEffectSub = this.activeVideoEffectSub) === null || _this_activeVideoEffectSub === void 0 ? void 0 : _this_activeVideoEffectSub.dispose(), (_this_activeVideoStreamForEffect = this.activeVideoStreamForEffect) === null || _this_activeVideoStreamForEffect === void 0 ? void 0 : _this_activeVideoStreamForEffect.dispose(), this.disposeRawStreamAccess(), this.disposeClientAudioRenderer(), this.effectsManager.dispose(), super.dispose();
                }
                async registerVirtualDevice(g, f) {
                    const S = g.length ? g.map(({ id: g }, f)=>{
                        const S = this.createChildDeviceManager(this.logger.createChild(`VirtualDevice-${f}`));
                        return S.selectDevices({
                            camera: g
                        }), S;
                    }) : [
                        this.createChildDeviceManager(this.logger.createChild("VirtualDevice"))
                    ], v = new _C(S, f), _ = v.id, C = [
                        v.on("onVideoEffectApplied", (...g)=>this.event("onVideoEffectApplied").raise(...g)),
                        v.on("onVideoEffectsEvent", (...g)=>this.event("onVideoEffectsEvent").raise(...g)),
                        v.on("onDeviceTelemetryEvent", (...g)=>this.event("onDeviceTelemetryEvent").raise(...g)),
                        v.on("onVideoEffectsTelemetryEvent", (...g)=>this.event("onVideoEffectsTelemetryEvent").raise(...g)),
                        v.on("onDevicesPermissionChanged", (...g)=>this.event("onDevicesPermissionChanged").raise(...g)),
                        v.on("onStreamUpdateRequested", (...g)=>this.event("onStreamUpdateRequested").raise(...g))
                    ];
                    return this.virtualDeviceSubs.set(_, C), this.virtualDeviceRecord.set(_, v), gC.list.updateVirtualDeviceList(this.getRegisteredDevices()), this.raiseTelemetryEvent("register_virtual_device", {
                        deviceCount: S.length,
                        id: _
                    }), this.event("onVirtualDevicesChanged").raise(), _;
                }
                async unregisterVirtualDevice(g) {
                    this.virtualDeviceRecord.has(g) ? (this.virtualDeviceSubs.get(g).forEach((g)=>g.dispose()), this.virtualDeviceSubs.delete(g), this.virtualDeviceRecord.get(g).dispose(), this.virtualDeviceRecord.delete(g), gC.list.updateVirtualDeviceList(this.getRegisteredDevices()), this.event("onVirtualDevicesChanged").raise(), this.raiseTelemetryEvent("unregister_virtual_device", {
                        id: g
                    })) : this.logger.error(`No virtual device found with id ${g}`);
                }
                getRegisteredDevices() {
                    return Array.from(this.virtualDeviceRecord.values());
                }
                async getNrgLevelPollerForDeviceTuner() {
                    return await PC.init(this, this.logger);
                }
                getAudioProcessingFlags() {
                    var _this_audioProcessingFlags;
                    if (!this.effectsManager.shouldFallbackToNativeProcessing("Audio")) return (_this_audioProcessingFlags = this.audioProcessingFlags) !== null && _this_audioProcessingFlags !== void 0 ? _this_audioProcessingFlags : this.configProvider.config.defaultAudioProcessingFlags;
                }
                disposeClientAudioRenderer() {
                    this.clientAudioRenderers.size && (this.clientAudioRenderers.forEach((g)=>{
                        g.dispose();
                    }), this.clientAudioRenderers.clear(), this.raiseTelemetryEvent("custom_audio_renderer_disposed", this.getSelectedDevices()));
                }
                disposeRawStreamAccess() {
                    this.rawDeviceStreamManager.disposeAll(), this.rawDeviceStreamManager = null;
                }
                toSelectedDevices(g) {
                    return Object.entries(g).reduce((g, [f, S])=>(S && (g[f] = S.guid), g), {});
                }
                getStreamConstraints(g) {
                    return {
                        deviceId: (g === null || g === void 0 ? void 0 : g.deviceId) || void 0
                    };
                }
                hasDeviceType(g) {
                    return values(this.deviceList).some((f)=>f.type === g);
                }
                getConstraints(g) {
                    if (!g.audio && !g.video && !g.sharing) throw new Error("requesting nothing");
                    if (this.logger.safe.info(`retrieving media stream: ${JSON.stringify(g)}`), g.sharing) {
                        let f;
                        const S = this.selectedDevices.audioIngestDevice;
                        return f = S && g.deviceId ? {
                            deviceId: S.deviceId
                        } : g.audio && !g.deviceId ? {
                            deviceId: Gt.SYSTEM_AUDIO_SOURCE_ID
                        } : void 0, {
                            audio: f,
                            sharing: {
                                deviceId: g.deviceId || Gt.DISPLAY_SOURCE_ID
                            },
                            withTimeout: g.withTimeout,
                            withEffect: !1,
                            audioProcessingFlags: g.audioProcessingFlags,
                            force: !1,
                            withOverridenStream: g.withOverridenStream
                        };
                    }
                    const f = this.selectedDevices.microphone, S = this.selectedDevices.camera, v = g.audio && f, _ = g.video && S;
                    if (!v && !_) throw {
                        type: Gt.MEDIA_ERROR.noDeviceSelected,
                        detail: `audio requested ${g.audio}, video requested: ${g.video} Devices: ${JSON.stringify(this.deviceList.map((g)=>JSON.stringify(scrubDevices(g, this.configProvider.config.devices.piiSafeWords))))}`
                    };
                    const C = this.getStreamConstraints(f), E = this.getStreamConstraints(S);
                    let T = g.audioProcessingFlags;
                    return void 0 !== T && g.audio && !g.video && (f === null || f === void 0 ? void 0 : f.capabilities) && (f.capabilities.echoCancellation && !f.capabilities.echoCancellation.includes(!!(2 & T)) && (T ^= 2), f.capabilities.autoGainControl && !f.capabilities.autoGainControl.includes(!!(1 & T)) && (T ^= 1), f.capabilities.noiseSuppression && !f.capabilities.noiseSuppression.includes(!!(4 & T)) && (T ^= 4)), T !== g.audioProcessingFlags && this.logger.safe.warn(`Unable to fulfill processing flags ${g.audioProcessingFlags}, using ${T} instead`), {
                        audio: g.audio ? C : void 0,
                        video: g.video ? E : void 0,
                        withTimeout: g.withTimeout,
                        withEffect: g.withEffect,
                        audioProcessingFlags: T,
                        force: g.force,
                        withOverridenStream: g.withOverridenStream,
                        videoMaxFS: g.videoMaxFS
                    };
                }
                getMediaStream(g, f) {
                    const S = this.getConstraints(g), v = this.mediaStreamManager.getMediaStream(S, f);
                    return this.subscribeOnStreamEvents(v), v.start().then(()=>{
                        const f = v.hasAudio(), S = v.hasVideo();
                        f && this.signalDeviceGood("Audio", v.rawTrack.muted), S && this.signalDeviceGood(v.mediaType, v.rawTrack.muted), this.permissionManager.update(g, g);
                    }).catch((f)=>this.handleUserMediaError(g, f)), v;
                }
                signalDeviceGood(g, f) {
                    this.ufdManager.signalDeviceEvent(0, "Good", g, this.id), this.ufdManager.signalDeviceEvent(2, "Good", g, this.id), this.ufdManager.signalDeviceEvent(4, "Good", g, this.id), f || "Audio" !== g && !this.configProvider.config.raiseVideoMuteUfd || this.ufdManager.signalDeviceEvent(3, "Good", g, this.id);
                }
                handleUserMediaError(g, f) {
                    const S = this.getMediaType(g), v = g.audio && g.video, signalUFD = (g, f)=>{
                        !v && this.ufdManager.signalDeviceEvent(g, f, S, this.id);
                    }, logAudioError = (g)=>{
                        !v && "Audio" === S && this.diagnostics.registerAudioRenderError(g);
                    };
                    switch(f.type){
                        case Gt.MEDIA_ERROR.permissionDeniedError:
                            "ScreenShare" !== S && (signalUFD(4, "Bad"), logAudioError(0x800000000000), this.configProvider.config.permissions.persistOnDeniedError && this.refreshPermissions(g));
                            break;
                        case Gt.MEDIA_ERROR.permissionDeniedBySystemError:
                            signalUFD(4, "Bad"), logAudioError(0x800000000000);
                            break;
                        case Gt.MEDIA_ERROR.sourceUnavailableError:
                            signalUFD(0, "Bad"), logAudioError(512);
                            break;
                        case Gt.MEDIA_ERROR.mediaStreamRequestTimedOut:
                            signalUFD(2, "Bad"), logAudioError(35184372088832);
                            break;
                        default:
                            this.logger.safe.error(`getMediaStream() error: ${stringifyObject(f)}`), signalUFD(0, "Bad"), logAudioError(4194304);
                    }
                }
                refreshPermissions(g) {
                    const f = g.audio && !g.video, S = !g.audio && g.video;
                    f ? this.permissionManager.update({
                        audio: !0
                    }, {
                        audio: !1
                    }) : S && this.permissionManager.update({
                        video: !0
                    }, {
                        video: !1
                    });
                }
                getMediaType(g) {
                    if (g.sharing) return "ScreenShare";
                    if (g.video) return "Video";
                    if (g.audio) return "Audio";
                    throw new Error(`mediaType is not defined for this constraint ${JSON.stringify(g)}`);
                }
                subscribeOnStreamEvents(g) {
                    const f = [];
                    f.push(g.on("onStreamClientStarted", (g, f)=>this.onStreamStarted(g, f))), f.push(g.on("onStreamClientDisposing", (g)=>this.onStreamDisposing(g))), f.push(g.on("onStreamClientEnded", (g, f)=>this.onStreamEnded(g, f))), f.push(g.on("onStreamClientMuted", (g, f)=>this.onStreamMuted(g, f))), f.push(g.on("onStreamClientError", (g, f)=>this.onStreamError(g, f))), this.configProvider.config.useRawMediaApiForVideoEffects && f.push(g.on("onStreamClientDisposed", (g)=>this.removeVideoEffectStream(g))), this.streamSubscriptions.set(g, f);
                }
                async removeVideoEffectStream(g) {
                    if (g.getCurrentConstraints().withEffect) {
                        var _this_activeVideoEffectSub, _this_activeVideoStreamForEffect;
                        this.logger.safe.info(`this.activeVideoEffectSub: ${this.activeVideoEffectSub} to be disposed`), (_this_activeVideoEffectSub = this.activeVideoEffectSub) === null || _this_activeVideoEffectSub === void 0 ? void 0 : _this_activeVideoEffectSub.dispose();
                        const g = await ((_this_activeVideoStreamForEffect = this.activeVideoStreamForEffect) === null || _this_activeVideoStreamForEffect === void 0 ? void 0 : _this_activeVideoStreamForEffect.getMediaStream());
                        this.effectsManager.stopEffect("Video", g);
                    }
                }
                unsubscribeFromStreamEvents(g) {
                    this.streamSubscriptions.has(g) && (this.streamSubscriptions.get(g).forEach((g)=>g.dispose()), this.streamSubscriptions.delete(g));
                }
                subscribeOnRendererEvents(g) {
                    const f = [];
                    f.push(g.on("onRendererDisposed", (g)=>this.onRendererDisposed(g))), f.push(g.on("onRendererStarted", (g)=>this.onRendererStarted(g))), this.rendererSubscriptions.set(g, f);
                }
                unsubscribeFromRendererEvents(g) {
                    this.rendererSubscriptions.has(g) && (this.rendererSubscriptions.get(g).forEach((g)=>g.dispose()), this.rendererSubscriptions.delete(g));
                }
                subscribeOnStreamManagerEvents() {
                    this.streamManagerSubscriptions = [], this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onAllStreamsRemoved", ()=>this.onAllStreamsRemoved())), this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamAcquired", (g, f, S, v, _, C)=>this.onStreamAcquired(g, f, S, v, _, C))), this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamCreated", (g, f)=>this.onStreamCreated(g, f))), this.streamManagerSubscriptions.push(this.mediaStreamManager.on("onStreamDisposing", (g, f)=>this.onMasterStreamDisposing(g, f)));
                }
                subscribeOnDeviceEnumeratorEvents() {
                    this.deviceEnumerator.on("onDeviceEnumerationfailed", (g)=>this.raiseTelemetryEvent("enumeration_failed", {
                            error: g
                        }));
                }
                unsubscribeFromStreamManagerEvents() {
                    this.streamManagerSubscriptions.forEach((g)=>g.dispose());
                }
                async updateRenderersAsync() {
                    try {
                        await Promise.all(this.activeRenderers.map((g)=>g.updateStreamAsync())), this.logger.safe.info("Renderers updates finished");
                    } catch (g) {
                        this.logger.safe.error(`Error updating renderers: ${stringifyObject(g)}`);
                    }
                }
                onSelectedDevicesChanged(g, f) {
                    const S = this.selectedDevices;
                    this.selectedDevices = g, this.diagnostics.setSelectedDevices(g, f);
                    if (!("camera" in S ^ "camera" in this.selectedDevices || "microphone" in S ^ "microphone" in this.selectedDevices)) {
                        const g = this.toSelectedDevices(this.selectedDevices), f = this.toSelectedDevices(S);
                        this.event("onSelectedDevicesChanged").raise(g, f), g.microphone !== f.microphone && this.rawDeviceStreamManager.notifyChange("Audio"), g.camera !== f.camera && this.rawDeviceStreamManager.notifyChange("Video"), this.clientAudioRenderers.forEach((g)=>{
                            g.setOutputDevice(this.getOutputDeviceId());
                        });
                    }
                    const v = this.configProvider.config.devices.piiSafeWords;
                    this.raiseTelemetryEvent("selected_devices_changed", {
                        microphone: this.selectedDevices.microphone && scrubDeviceLabelPii(this.selectedDevices.microphone.label, v),
                        camera: this.selectedDevices.camera && scrubDeviceLabelPii(this.selectedDevices.camera.label, v),
                        speaker: this.selectedDevices.speaker && scrubDeviceLabelPii(this.selectedDevices.speaker.label, v),
                        fromInterface: f
                    }), this.updateRenderersAsync();
                }
                onDevicesChanged(g, f) {
                    this.event("onDevicesChanged").raise(g, f), this.mediaStreamManager.onDevicesChanged(g), this.diagnostics.setDeviceList(g, f, this.getDeviceListDebugInfo());
                    const S = this.getDevicesCount(), v = S.microphone > 0, _ = S.speaker > 0;
                    this.ufdManager.signalEvent("ZeroCaptureDevicesEnumerated", v ? "Good" : "Bad"), v || this.diagnostics.registerAudioCaptureError(1), this.isAudioOutputSelectionSupported && (this.ufdManager.signalEvent("ZeroRenderDevicesEnumerated", _ ? "Good" : "Bad"), _ || this.diagnostics.registerAudioRenderError(1));
                    const C = new Map;
                    let E = 1;
                    this.raiseTelemetryEvent("devices_changed", {
                        devices: g.map((g)=>{
                            const f = C.get(g.groupId) || E++;
                            return C.set(g.groupId, f), {
                                label: scrubDeviceLabelPii(g.label, this.configProvider.config.devices.piiSafeWords),
                                isSystemDefault: g.isSystemDefault,
                                kind: g.kind,
                                type: g.type,
                                capabilities: g.capabilities,
                                groupId: `${f}`
                            };
                        }),
                        debug: this.getDeviceListDebugInfo()
                    });
                }
                getDeviceListDebugInfo() {
                    return gC.list.debugInfo;
                }
                raiseTelemetryEvent(g, f) {
                    this.logger.safe.info(`Device event: ${g}: ${JSON.stringify(this.scrubPayload(g, f))}`);
                    const S = {
                        eventType: g,
                        timestamp: Date.now(),
                        payload: f
                    };
                    this.diagnostics.registerDeviceTelemetryEvent(deepClone(S)), this.diagnostics.logAudioDeviceError(g, f), this.event("onDeviceTelemetryEvent").raise(S);
                }
                scrubPayload(g, f) {
                    if ("devices_changed" === g) return {
                        devices: values(f.devices).map((g)=>scrubDevices(g, this.configProvider.config.devices.piiSafeWords)),
                        debug: f.debug
                    };
                    return f;
                }
                async onStreamStarted(g, f) {
                    if (this.permissionManager.browserPermittedModalities.audio.some((g)=>g === Gt.MEDIA_STATE.send) || this.permissionManager.browserPermittedModalities.video.some((g)=>g === Gt.MEDIA_STATE.send)) try {
                        await gC.enumerateDevices();
                    } catch (g) {
                        this.logger.safe.warn(`onStreamStarted device enumeration failed: ${stringifyObject(g)}`);
                    }
                    if (g.rawTrack) {
                        switch(g.mediaType){
                            case "Audio":
                                this.deviceEnumerator.startDevicePolling(), this.updateActiveMicrophone(g, f);
                                break;
                            case "Video":
                                this.deviceEnumerator.startDevicePolling();
                        }
                        this.configProvider.config.useRawMediaApiForVideoEffects && g.getCurrentConstraints().withEffect && (this.activeVideoEffectSub = this.effectsManager.on("onVideoStreamQualityChanged", (f, S, v)=>g.onVideoStreamQualityChanged(f, S, v)));
                    } else this.logger.safe.warn(`stream:${g.id} is already disposed`);
                }
                updateActiveMicrophone(g, f) {
                    if (g.deviceId) {
                        const S = this.deviceList.find((f)=>f.deviceId === g.deviceId);
                        if (!S && "default" !== g.deviceId) return void this.logger.safe.error("Active device not found", `Device id from track: '${scrubMriOrOmit(g.deviceId)}', known devices: [${this.deviceList.map((g)=>JSON.stringify(scrubDevices(g, this.configProvider.config.devices.piiSafeWords)))}]}`, JSON.stringify(scrubConstraints(f)));
                        S && "default" !== g.deviceId && f.audio && f.audio.deviceId === Gt.MEDIA_DEVICE.defaultId && gC.list.updateActiveMicrophone(S);
                    }
                }
                onStreamDisposing(g) {
                    this.unsubscribeFromStreamEvents(g);
                }
                onStreamMuted(g, f) {
                    ("Audio" === g.mediaType || this.configProvider.config.raiseVideoMuteUfd) && this.ufdManager.signalDeviceEvent(3, f ? "Bad" : "Good", g.mediaType, this.id), "Audio" === g.mediaType && this.event("onAudioStreamMuted").raise(f), this.raiseTelemetryEvent(f ? "stream_muted" : "stream_unmuted", g.mediaType);
                }
                onStreamEnded(g, f) {
                    f.error ? (this.raiseTelemetryEvent("stream_ended_error", {
                        mediaType: g.mediaType,
                        error: {
                            type: f.error.name,
                            detail: f.error.message
                        }
                    }), "SourceUnavailableError" === f.error.name && this.ufdManager.signalDeviceEvent(0, "Bad", "Audio", this.id)) : ("Audio" !== g.mediaType && "Video" !== g.mediaType || this.ufdManager.signalDeviceEvent(0, "Bad", g.mediaType, this.id), this.raiseTelemetryEvent("stream_ended", g.mediaType));
                }
                onStreamError(g, f) {
                    this.raiseTelemetryEvent("stream_error", {
                        mediaType: g.mediaType,
                        error: f
                    });
                }
                onAllStreamsRemoved() {
                    this.deviceEnumerator.stopDevicePolling(), this.audioSharingRequested = !1;
                }
                onStreamAcquired(g, f, S, v, _, C) {
                    0 !== S && this.raiseTelemetryEvent("stream_acquired", {
                        id: g,
                        mediaType: f,
                        timestamp: S,
                        resolution: v,
                        withAudio: _,
                        source: C
                    });
                }
                onStreamCreated(g, f) {
                    this.raiseTelemetryEvent("stream_created", {
                        id: g,
                        mediaType: f
                    });
                }
                onMasterStreamDisposing(g, f) {
                    this.raiseTelemetryEvent("stream_disposed", {
                        id: g,
                        mediaType: f
                    });
                }
                onRendererDisposed(g) {
                    var _this_domOverrides_onMediaElementRemoved, _this_domOverrides;
                    remove2(this.activeRenderers, (f)=>f === g), (_this_domOverrides_onMediaElementRemoved = (_this_domOverrides = this.domOverrides).onMediaElementRemoved) === null || _this_domOverrides_onMediaElementRemoved === void 0 ? void 0 : _this_domOverrides_onMediaElementRemoved.call(_this_domOverrides, g.getVideoElement()), this.unsubscribeFromRendererEvents(g);
                }
                onRendererStarted(g) {
                    this.activeRenderers.push(g), this.event("onLocalRendererStarted").raise(g);
                }
                onVideoEffectsQualityEventHandler(g) {
                    const f = this.deviceSelection.selectedDevices.camera;
                    if (f === null || f === void 0 ? void 0 : f.deviceId) {
                        const S = {
                            type: "onVideoEffectQualityChanged",
                            payload: {
                                message: g.message,
                                effectType: g.effectType
                            }
                        };
                        this.event("onVideoEffectsEvent").raise(f.deviceId, S);
                    }
                }
                getDeviceType(g) {
                    if ("Video" === g) return "camera";
                    if ("Audio" === g) return "microphone";
                    throw new Error(`DeviceType for mediaType: ${g} doesn't exist`);
                }
                getStreamHandlerByType(g) {
                    return "Video" === g ? ()=>this.getVideoStream(!1, "rawStream", !0) : "Audio" === g ? ()=>this.getAudioStream(!1, "rawStream", !0) : "ScreenShare" === g ? ()=>Promise.resolve(this.getDisplayStream("rawStream", !0)) : null;
                }
                constructor(g, f, S, v, _, C, E, T, I, b){
                    super(g), this.logger = g, this.configProvider = f, this.diagnostics = S, this.domOverrides = v, this.ufdManager = _, this.id = uniqueId(), this.virtualDeviceRecord = new Map, this.deviceEnumerator = new gC(this.configProvider, this.logger.createChild("DeviceEnumerator")), this.deviceSelection = new pC(gC.list, this.configProvider, this.logger.createChild("DeviceSelection")), this.permissionManager = new vC(this.configProvider, {
                        getMediaStream: (g)=>this.getMediaStream({
                                ...g,
                                withEffect: !1,
                                withTimeout: !0,
                                force: !1,
                                audioProcessingFlags: g.audio && !g.video ? this.getAudioProcessingFlags() : void 0
                            }, "permissionManager"),
                        hasCamera: ()=>this.hasDeviceType("camera"),
                        raiseTelemetryEvent: (g, f)=>this.raiseTelemetryEvent(g, f),
                        getActiveConstraints: ()=>this.mediaStreamManager.getActiveConstraints(),
                        handlePermissionStateChange: ()=>this.handlePermissionStateChange()
                    }, this.logger.createChild("PermissionManager")), this.activeRenderers = [], this.selectedDevices = {
                        camera: null,
                        microphone: null,
                        speaker: null,
                        audioIngestDevice: null
                    }, this.pendingDevices = null, this.deviceManagerSubscriptions = [], this.streamManagerSubscriptions = [], this.streamSubscriptions = new Map, this.rendererSubscriptions = new Map, this.rawDeviceStreamManager = new j_(this.logger.createChild("RawDeviceStream"), this.raiseTelemetryEvent.bind(this)), this.customDeviceMediaStreamMap = new Map, this.clientAudioRenderers = new Map, this.audioSharingRequested = !1, this.virtualDeviceSubs = new Map, this.effectsManagerInternal = new AC(this.configProvider, this.logger.createChild("EffectsManager")), this.effectsManagerInternal.addEffectManager("Audio", {
                        wasmdnsProvider: E,
                        wasmaecProvider: T,
                        wasmVqeProvider: I,
                        wasmLoader: b
                    }), this.effectsManagerInternal.addEffectManager("Video", {
                        webcvProvider: C,
                        wasmLoader: b
                    }), this.effectsManagerInternal.addEffectManager("ScreenShare", null), this.mediaStreamManager = new nC(this.logger.createChild("MediaStreamManager"), this.configProvider, this.effectsManager), this.deviceManagerSubscriptions = [
                        this.permissionManager.on("onDevicesPermissionChanged", ()=>this.event("onDevicesPermissionChanged").raise()),
                        gC.list.on("onDevicesChanged", (g, f)=>this.onDevicesChanged(g, f)),
                        this.deviceSelection.on("onSelectedDevicesChanged", (g, f)=>this.onSelectedDevicesChanged(g, f)),
                        this.effectsManager.on("onAudioEffectTelemetryEvent", (g)=>{
                            this.diagnostics.registerAudioEffectsEvent(deepClone(g)), this.event("onAudioEffectsTelemetryEvent").raise(g);
                        }),
                        this.effectsManager.on("onMediaStreamUpdateRequested", (g)=>this.onMediaStreamUpdateRequested(g, !0)),
                        this.effectsManager.on("onVideoEffectQualityChanged", (g)=>this.onVideoEffectsQualityEventHandler(g)),
                        this.effectsManager.on("onVideoEffectTelemetryEvent", (g)=>{
                            this.diagnostics.registerVideoEffectsEvent(deepClone(g)), this.event("onVideoEffectsTelemetryEvent").raise(g);
                        }),
                        this.effectsManager.on("onVideoEffectApplied", ()=>{
                            this.raiseTelemetryEvent("video_effect_applied", {}), this.event("onVideoEffectApplied").raise();
                        }),
                        this.effectsManager.on("onEffectsError", (g, f, S)=>this.event("onEffectsError").raise(g, f, S))
                    ], this.subscribeOnStreamManagerEvents(), this.subscribeOnDeviceEnumeratorEvents(), this.deviceList.length && this.onSelectedDevicesChanged(this.deviceSelection.selectedDevices, !1), this.createChildDeviceManager = (g)=>new _DeviceManager(g, f, new rC(f), v, _, C, E, T, I, b);
                }
            };
            function getPlatformConfig() {
                return Ze.isEngine("ChromiumAVD") ? new DC : Ze.isEngine("Safari") ? new NC : Ze.isEngine("Firefox") ? new kC : isVdiPlatform() ? new LC : Ze.isEngine("Chromium") ? new FC : new MC;
            }
            var MC = class {
                getInitialSettings() {
                    return {
                        resizeModeForSharing: "none",
                        enableAudioProcessingFallback: !0,
                        allowVirtualDeviceInCall: !1,
                        activeSpeaker: {
                            timeToPromote: 1e4
                        },
                        dtmf: {
                            toneDuration: 200,
                            toneGap: 100
                        },
                        mediaStreamHoldInterval: 5e3,
                        webrtcContributingSourcesPollingStartDelay: 1e3,
                        webrtcContributingSourcesPollingInterval: 1e3,
                        webrtcContributingSourcesPollingEmptySources: 0,
                        webrtcIceGatheringTimeoutMs: 2e4,
                        webrtcAllowedMediaContentType: Gt.ALLOWED_CONTENT_TYPES.SDP_NGC,
                        webrtcMediaContentType: Gt.CONTENT_TYPE.SDP,
                        useNGC1webrtcContentType: !1,
                        webrtcScreensharingCapabilityMaxFS: 8160,
                        webrtcScreensharingCapabilityMaxFPS: 1500,
                        webrtcStatHwSilentDetectionDuration: 5,
                        webrtcStatHwSilentDetectionLevel: 14,
                        webrtcStatPollInterval: 1e3,
                        webrtcStatStoredRecordsNumber: 60,
                        webrtcStatNetworkDetectionDuration: 10,
                        webrtcHealedRatioWindowSize: 5,
                        webrtcHealedRatioExtendedWindowSize: 20,
                        webrtcStatNetworkDetectionHysteresis: .01,
                        webrtcStatNetworkDetectionBadLevel: .17,
                        webrtcStatNetworkDetectionGoodLevel: .15,
                        webrtcMinAudioSamplesRecvForNetworkRecvQuality: 48e4,
                        webrtcVideoCapabilityCheckIntervalMin: 2e4,
                        webrtcVideoCapabilityCheckIntervalMinMultiparty: 5e3,
                        webrtcVideoCapabilityCheckIntervalMax: 3e4,
                        webrtcVideoCapabilityCheckIntervalMaxMultiparty: 5500,
                        webrtcScreensharingCapabilityCheckIntervalMin: 0,
                        webrtcScreensharingCapabilityCheckIntervalMax: 0,
                        webrtcVideoCapabilityMaxFS: 3600,
                        webrtcVideoCapabilityMaxFPS: 3e3,
                        webrtcMultiPartyRecvVideoMaxFS: 3600,
                        webrtcRecvVideoMaxFS: 8160,
                        webrtcCameraOpenFs: 3600,
                        minCameraOpenFps: 15,
                        maxCameraOpenFps: 30,
                        maxCameraFsViaCallConstraints: -1,
                        webrtcMultipartyMaxScalingFs: 3600,
                        webrtcMaxScalingFs: 8160,
                        webrtcVideoScaling: !1,
                        webrtcVideoScalingMultiparty: !0,
                        enableOptimalVideoCount: !1,
                        ovcBandwidthPerVideoReceiver: 2e5,
                        ovcSlidingWindowPercentile: .3,
                        ovcSlidingWindowSamples: 20,
                        nonEstimatedDefaultVideoReceiversCount: 4,
                        ovcMaxCount: 4,
                        ovcMaxCountXL: 4,
                        ovcMaxCountMultiStream: 16,
                        ovcXLParticipantsCount: 100,
                        ovcIgnoreFirstSamples: 10,
                        ovcAvailableConcurrencyForBiggerGrid: 4,
                        ovcMemoryForBiggerGrid: 2,
                        ovcRampUpCooldown: 15e3,
                        ovcRampDownCooldown: 1e4,
                        webrtcStatNetworkDetectionEnabled: !0,
                        webrtcUseNewStatsApi: !0,
                        useAudioAnalyzer: !0,
                        webrtcVideoSubscriptionDisposeTimeout: 2e3,
                        webrtcCompareContentTypeInOffer: !0,
                        iceServerTransport: "udp,tcp,tls",
                        iceHostCandidateOnly: !0,
                        iceUdpAddressType: "ip",
                        iceTcpAddressType: "ip",
                        renegotiationAttempts: 3,
                        reconnectTimeLimit: 9e4,
                        initialReconnectTimeLimit: 0,
                        maxReconnectDelayTime: 5,
                        waitForRelayOnReconnect: !0,
                        relayWaitSaneTimeoutMs: 25e3,
                        reconnectOnDisconnect: !1,
                        reconnectWithNoRelays: !1,
                        reconnectWithProbes: !1,
                        reconnectWaitTimeAfterProbe: 1e3,
                        reconnectOnPcClose: !0,
                        reconnectWakeupTimeLimit: 18e4,
                        webrtcSpeakingWhileMutedDetectionWindow: 3,
                        webrtcSpeakingWhileMutedBadDuration: 3,
                        webrtcSpeakingWhileMutedDetectionLevel: 4e3,
                        webrtcNegotiateDisabledDataModality: !1,
                        recoverableMediaErrors: [
                            Gt.MEDIA_ERROR.iceConnectionError,
                            Gt.MEDIA_ERROR.noNetworkError,
                            Gt.MEDIA_ERROR.srtpError,
                            Gt.MEDIA_ERROR.incompatibleOffer,
                            Gt.MEDIA_ERROR.internalError
                        ].join(","),
                        forceReconnectErrors: [
                            Gt.MEDIA_ERROR.audioPlaybackError
                        ].join(","),
                        sendCallStartupTelemetry: !0,
                        webrtcMultiPartyRecvVideoSignaling: !0,
                        webrtcVideoDelayThreshold: 10,
                        webrtcEndOfCallFreezeThreshold: 3,
                        webrtcSubscriptionEventLimit: 300,
                        webrtcHandleRollback: !0,
                        webrtcHandleRemoteRollback: !0,
                        losingConnectivityTimeoutMs: -1,
                        iceCandidateFilterMDns: !0,
                        webrtcInjectTransportCCAudio: !1,
                        webrtcInjectTransportCCAudioMultiparty: !0,
                        webrtcRejectedFeatures: "byPass",
                        webrtcRequiredFeatures: "nonByPass",
                        webrtcSimulcastSessionEnabled: !1,
                        webrtcSimulcastStreamsCountForVideo: 1,
                        webrtcSimulcastStreamsCountForSharing: 1,
                        webrtcFmtParamListSupported: !0,
                        webrtcNegotiatedSsrcRangeForVideo: 0,
                        webrtcNegotiatedSsrcRangeForSharing: 0,
                        webrtcNegotiatedSsrcRangeForVideoOneToOne: 0,
                        webrtcNegotiatedSsrcRangeForSharingOneToOne: 0,
                        webrtcAllowRestoreKeyframe: !1,
                        webrtcEnabledCustomBwEstimationForVideo: !1,
                        webrtcDisabledSenderBitrate: 1e3,
                        maxStoredPreferredResolutionCount: 4,
                        maxStoredQualityLimitationReasonEvents: 30,
                        maxStoredUFDCount: 50,
                        simulcastTelemetryLayoutsPerSession: 5,
                        simulcastTelemetryNumModalitySessions: 3,
                        simulcastTelemetryNumFMTP: 10,
                        maxSendVideoCapabilities: {
                            enableForVideo: !1,
                            enableForSharing: !1,
                            useMaximumWidthHeight: !1,
                            sendMaxMbps: !1,
                            sendMaxFs: !1
                        },
                        maxReportedOvershootingEvents: 20,
                        broadcastMode: {
                            townHallScenarioNames: [
                                "premiumtownhall",
                                "basetownhall"
                            ]
                        },
                        performanceFallbackMaxFsFor1080pSend: 3600,
                        permissions: {
                            usePositiveInAdp: !1,
                            useNegativeInAdp: !1,
                            adpFallback: !0,
                            adpFallbackAudio: !0,
                            adpFallbackVideo: !0,
                            adpRequestAVLast: !0,
                            rememberNegative: !1,
                            persistOnDeniedError: !0,
                            disableOnPermissionDeniedOnly: !0,
                            enumerateDevicesAfterChange: !0
                        },
                        devices: {
                            blacklist: {
                                microphone: "stereo mix \\(",
                                camera: "(ir camera|avstream media device)",
                                speaker: "stereo mix \\("
                            },
                            overrideDefault: !1,
                            compositeLabelMatchingThreshold: .5,
                            piiSafeWords: [
                                "airpod",
                                "bluetooth",
                                "hands-free",
                                "stereo",
                                "wireless",
                                "citrix hdx",
                                "remote audio",
                                "vmware",
                                "built-in",
                                "integrated",
                                "internal",
                                "teams",
                                "high definition",
                                "facetime",
                                "macbook",
                                "smartaudio",
                                "front",
                                "rear",
                                "back",
                                "iphone",
                                "ipad",
                                "display",
                                "displayport",
                                "dp",
                                "hdmi",
                                "amd",
                                "nvidia",
                                "intel",
                                "analog",
                                "digital",
                                "dock",
                                "line( in| out)?",
                                "s/pdif",
                                "external",
                                "thunderbolt\\d*",
                                "usb",
                                "panoramic",
                                "desktop",
                                "capture",
                                "cable",
                                "cam",
                                "virtual",
                                "manycam",
                                "snap camera",
                                "obs",
                                "vb-audio",
                                "vaio",
                                "effect",
                                "sink",
                                "source",
                                "default",
                                "test"
                            ],
                            pollingIntervalActive: 3e3,
                            enumerateDevicesTimeout: 25e3,
                            enumerateDevicesAfterADP: !1,
                            setSinkImmediately: !1,
                            enumerateBeforeGettingStream: "always"
                        },
                        useGoogPrefixAudioConstraints: !0,
                        multiviewResolutionLimits: {
                            1: 720,
                            2: 720,
                            3: 540,
                            4: 360,
                            more: 360
                        },
                        maxSpotlightResolution: 1080,
                        excludeUnsizedRenderersFromMultiviewResolutionLimits: !1,
                        multiviewResolutionLimitUpdateThrottleDelay: 300,
                        useMultiviewLimitsOnInitialRequest: !0,
                        useApplyChannelParametersForSourceRequests: !0,
                        maxVideoFreezeTimestampsInBucket: 5,
                        webrtcSendBandwidthIgnoredUpdateLimit: 6,
                        webrtcSendBandwidthThreshold: .1,
                        checkSupportForWebrtc_1_0: !1,
                        webrtcLastAppliedVideoCapabilitiesCount: 5,
                        webrtcLastAppliedVideoCapabilitiesSequenceCount: 5,
                        gumRequestTimeout: 2e4,
                        overrideGumFromWebkit: !1,
                        setMinFpsForWebkit: !1,
                        videoCaptureFreezeTimeout: 5e3,
                        webrtcCloseAfterIceFailure: !0,
                        audioBandwidthInKbps: 90,
                        maxBandwidthInKbps: 7e3,
                        maxBandwidthInKbpsFallback: 7e3,
                        videoBandwidthAllocation: .3,
                        enableQosSupport: !1,
                        forceUnbundledTransport: !1,
                        allowedAudioCodecs: [],
                        allowedVideoCodecs: [],
                        allowedVideoCodecsMultiparty: [
                            {
                                clockRate: 9e4,
                                mimeType: "video/H264"
                            },
                            {
                                clockRate: 9e4,
                                mimeType: "video/rtx"
                            }
                        ],
                        filterCodecsInSdp: !1,
                        filterCodecsInSdpMultiparty: !0,
                        filterCodecsInSdpV2: !1,
                        reduceRtcpFbInSdp: [],
                        reduceRtcpFbInSdpMultiparty: [
                            "goog-remb",
                            "transport-cc",
                            "ccm/fir",
                            "nack",
                            "nack/pli"
                        ],
                        subscribeToSsrcForVideo: !1,
                        audioRendererUsePauseOnDetach: !0,
                        audioRendererRestartOnPause: !1,
                        audioRendererRestartOnDeviceError: !0,
                        disableAudioOutputSelection: !1,
                        preferSdesSrtp: !1,
                        preferSdesSrtpPstn: !1,
                        useLocalStorageForOneDs: !0,
                        oneDSDisabledPageUnloadEvents: [],
                        oneDSLocalStorage: {
                            sendStaleEvents: !1,
                            accessThresholdInMs: 6e5
                        },
                        oneDSNotificationManager: {
                            blockNotificationsOnPageUnload: !1,
                            blockEventsDiscardedNotifications: !1
                        },
                        useOneDsLogger: !1,
                        addTelemetryReportingCallback: !0,
                        eventsLimitInMem: 200,
                        eventLatency: _p.Normal,
                        eventLatencyRealTime: _p.RealTime,
                        enableCompoundKey: !1,
                        telemetryTenants: {
                            signaling: "53fdaa090eb946b5a1d6cbdeb4f2ef66-bcbf6380-2590-41cc-ae60-9e467cd51835-7413",
                            media: "1cae5691997646c98b01d15beddae7a3-ce16e198-bc32-420f-ac64-42bb916111af-6865",
                            realtimeMedia: "5aea257f81424f5d8574e57a50974ead-d3a768ce-590c-4595-ab85-3dd046114290-6701",
                            tlePlayer: "2efdf03d07594586a5977c404e185186-71b046c4-f48f-4ba7-96d3-2a74b54e1d46-7326"
                        },
                        transmitProfileName: "REAL_TIME",
                        transmitProfileTimings: [],
                        waitReportStatsAtCallStop: !1,
                        oneStreamPerDeviceType: !1,
                        enableWebRtcInternalsLogs: !1,
                        enableMultiViewStats: !0,
                        webrtcBWJumpLowerLimit: 1e5,
                        webrtcBWJumpUpperLimit: 3e5,
                        uplinkBWStabilizationSlidingWindowSize: 10,
                        uplinkBWStabilizationMaxDeviation: .1,
                        uplinkBWStabilizationMinBandwidth: 1e5,
                        downlinkBWStabilizationSlidingWindowSize: 10,
                        downlinkBWStabilizationMaxDeviation: .1,
                        downlinkBWStabilizationMinBandwidth: 1e5,
                        maxKeyFrameTimestampsInBucket: 5,
                        enableAudioSharing: !1,
                        audioSharingContextOptions: {
                            sampleRate: 48e3
                        },
                        enableStopSharingWithIncomingOffer: !0,
                        enableDevtoolsAPI: !1,
                        enableDataChannel: !1,
                        enableDataChannelMultiparty: !0,
                        enableDataChannelPstn: !1,
                        alwaysNegotiateDataChannel: !0,
                        webrtcDataChannel: {
                            enableFragmentation: !1,
                            fragmentationSize: 0,
                            enableSendScheduler: !1,
                            rateLimiterCheckInterval: 250,
                            discardOnSendFailure: !1,
                            bufferedAmountLowThreshold: 65535,
                            bufferedAmountHighThreshold: 262144,
                            maxBitrate: 0,
                            maxPacketRate: 0,
                            maxQueueSize: 524288,
                            dataIds: []
                        },
                        acceptDisabledDataModality: !0,
                        rejectUnbundledDataModality: !0,
                        sctpPort: 5e3,
                        removeRtcpRsizeFromLocalSdp: !1,
                        enableGiveControl: !1,
                        maxStoredDataChannelValues: 15,
                        mediaControlPlaneConfig: {
                            enableBweNotifications: !0,
                            enableDominantSpeakerHistory: !0,
                            enableSourceRequests: !0,
                            enableSendBandwidthNotificationsEnabled: !1,
                            sourceRequestsMessagesTimeout: 1e4,
                            storedSRRecordsCount: 60,
                            verboseTelemetry: !1,
                            sendBeforeAck: !1,
                            handshakeTimeout: 1e4,
                            setResendingMechanism: !1
                        },
                        localPreviewMirroringSupported: !1,
                        enableVideoEffects: !0,
                        useRawMediaApiForVideoEffects: !1,
                        forceKeyFrameV2ScaleFactor: 1.1,
                        effectsTelemetryBufferSize: 20,
                        useDelayedScreenShareStream: !1,
                        applyAudioEffectOnDemand: !1,
                        wasmdns: {
                            pTime: 10,
                            goodPerfThreshold: 8,
                            poorPerfThreshold: 10,
                            badPerfThreshold: 12,
                            perfWindowLength: 10,
                            enableNoiseSuppression: !1,
                            noiseSuppressionMode: "Off",
                            backgroundMode: !1
                        },
                        wasmvqe: {
                            enableAec: !1,
                            enableVqe: !1,
                            backgroundMode: !1,
                            performanceThresholdMs: 8,
                            performanceWindowDurationSecs: 10,
                            defaultVqeMode: lr.VqeMode.Off,
                            callType: lr.CallType.Conference,
                            audioUsageMode: lr.AudioUsageMode.Default,
                            performanceProfile: lr.AecPerfProfile.Normal
                        },
                        webcv: {
                            qualityConfig: {
                                outputFps: {
                                    min: 15,
                                    max: 30
                                },
                                outputResolution: 720,
                                preserveResolution: !0,
                                degradationLadder: [
                                    {
                                        resolution: {
                                            width: 1920,
                                            height: 1080
                                        },
                                        fps: {
                                            min: 15,
                                            max: 30
                                        }
                                    },
                                    {
                                        resolution: {
                                            width: 1280,
                                            height: 720
                                        },
                                        fps: {
                                            min: 15,
                                            max: 30
                                        }
                                    },
                                    {
                                        resolution: {
                                            width: 960,
                                            height: 540
                                        },
                                        fps: {
                                            min: 15,
                                            max: 30
                                        }
                                    },
                                    {
                                        resolution: {
                                            width: 640,
                                            height: 360
                                        },
                                        fps: {
                                            min: 13,
                                            max: 30
                                        }
                                    },
                                    {
                                        resolution: {
                                            width: 416,
                                            height: 234
                                        },
                                        fps: {
                                            min: 10,
                                            max: 20
                                        }
                                    },
                                    {
                                        resolution: {
                                            width: 320,
                                            height: 180
                                        },
                                        fps: {
                                            min: 10,
                                            max: 20
                                        }
                                    }
                                ],
                                initialLadderResolution: 720,
                                improvementFpsThresholdPercent: 20,
                                statsIntervalSec: 5,
                                enableMaskPropagation: !1,
                                maskPropagationFramesInterval: 30
                            },
                            powerPreference: or.PowerPreference.HighPerformance,
                            useInsertableStreams: !1,
                            webGLUnsupportedRenderers: [
                                "Google SwiftShader"
                            ],
                            webGLRequiredExtensions: [
                                "EXT_color_buffer_float",
                                "WEBGL_debug_renderer_info",
                                "OES_texture_float_linear"
                            ],
                            usePreheat: !1,
                            useSharedArrayBuffer: !0,
                            useWasmEffects: !1,
                            processorType: or.ProcessorType.Webgl2
                        },
                        insertFakeCandidateIfNeeded: !0,
                        useSdpCapabilitiesLegacySession: !0,
                        useSdpCapabilities: !0,
                        enableH264SpsPpsIdrKeyframe: !0,
                        disableMsSdp: !1,
                        disableSdes: !1,
                        disableIceReinvite: !1,
                        iceDisconnectedTimeoutMs: 3e4,
                        enableLocalVideoConstraints: !0,
                        webrtcAudioChannelSignalingFeedback: "app recv:dsh",
                        webrtcVideoChannelSignalingFeedback: "app send:src recv:src,vc",
                        webrtcResolutionManagerCooldownTimeout: 15e3,
                        webrtcResolutionManagerRetryDelay: 5e3,
                        webrtcNativeCpuOveruseDisabled: !1,
                        webrtcDisplayStreamContentHint: "text",
                        h264SendProfileOverride: "42C02A",
                        learnCodecSendCapabilitiesFromSenderApi: !1,
                        addFmtpToInitialSubscription: !0,
                        h264SubscribeProfile: "64001f",
                        notRenderingTimeInterval: {
                            video: 3,
                            sharing: 10
                        },
                        notRenderingLowBitrateThreshold: 6,
                        notRenderingLowFramerateThreshold: 3,
                        isBytesRecvUsedInIsRenderingCalculation: !0,
                        useConnectionState: !0,
                        transportStateFailedFix: !1,
                        useDtlsTrasportConnectionCheck: !1,
                        enableNetworkRecvQualityUFD: !0,
                        enableNetworkSendQualityUFD: !0,
                        enableSignalingAudioPermissionDeniedUFD: !1,
                        webrtcJitterLowThreshold: .2,
                        webrtcJitterHighThreshold: .35,
                        webrtcJitterSticknessTime: 5e3,
                        webrtcLossRateLowThreshold: .2,
                        webrtcLossRateHighThreshold: .3,
                        webrtcLossRateSticknessTime: 5e3,
                        webrtcMinPacketsSentForNetworkSendQuality: 200,
                        webrtcLossRateWindowSize: 3,
                        webrtcJitterWindowSize: 3,
                        networkSendQualityDiagnostics: !1,
                        networkRecvQualityDiagnostics: !1,
                        webrtcJitterExtendedWindowSize: 6,
                        webrtcLossRateExtendedWindowSize: 6,
                        freezeMinDuration: 128,
                        freezeIntervalFrequency: 1e3,
                        disableNormalizationToCalculatePacketLossRate: !1,
                        healedRatioPrecision: 8,
                        jitterPrecision: 3,
                        requestNewStreamOnUnmute: !0,
                        raiseVideoMuteUfd: !1,
                        useMediaQualityController: !1,
                        useMediaQualityControllerForceKeyFrame: !1,
                        bandwidthAllocatorV2: {
                            sharingLadder: [
                                8e4,
                                5e5,
                                8e5,
                                1e6,
                                12e5,
                                25e5,
                                3e6
                            ],
                            videoLadders: [
                                {
                                    maxFS: 240,
                                    ladder: [
                                        4e4,
                                        7e4,
                                        1e5,
                                        15e4,
                                        25e4,
                                        3e5,
                                        35e4
                                    ]
                                }
                            ],
                            defaultVideoMaxFS: 240
                        },
                        layoutControlTimeout: 1e4,
                        extmapAllowMixed: !1,
                        enableVla: !1,
                        allowRemoteVla: !1,
                        enableNonAdvVla: !1,
                        specCompliantSimulcast: {},
                        specCompliantSimulcastMultiparty: {
                            video: {
                                enableLocally: !1,
                                allowEnableRemotely: !1,
                                layerScaleFactors: [
                                    1
                                ],
                                minFsForSimulcast: [
                                    920
                                ],
                                useApplyConstraints: !1
                            },
                            sharing: {
                                enableLocally: !1,
                                allowEnableRemotely: !1,
                                layerScaleFactors: [
                                    1
                                ]
                            },
                            allowOverride: !1,
                            constraintsDisableVla: !0,
                            collectResolutionInfo: !0,
                            maxBrControlEnabled: !1,
                            allowedBweOvershootRatio: 1,
                            allowResLimit: !1,
                            disableTilde: !1
                        },
                        enforceOpusFmtpMultiparty: {
                            usedtx: 1
                        },
                        videoIsRenderingCheck: !1,
                        fixSdpForPartialIceRestart: !1,
                        mapSsrcToTrackForStats: !1,
                        enableVideoOrientationExtension: !1,
                        speakerGainLevel: 0,
                        ignoreClosedDtlsTransportState: !1,
                        disconnectOnPageHide: !1,
                        renderThroughCanvas: !1,
                        isRenderingBasedOnRawStatistics: !1,
                        enableDevicePixelRatio: !0,
                        useSetParametersToApplyCapabilities: !1,
                        useSetParametersToApplySSCapabilities: !1,
                        enablePlatformCallConstraints: !1,
                        enablePlatformCallConstraintsPerCall: !1,
                        enableDynamicCallConstraints: !0,
                        numCallConstraintsEvents: 6,
                        setParametersMaxBitrateUndefined: !1,
                        onAddTrackRemoveOtherTracks: !0,
                        avoidFakeStreamsDuringEscalation: !0,
                        navConnectionPollingInterval: 1e3,
                        navConnectionNumSamplesToCollect: 60,
                        acceptProvisionalAnswer: !1,
                        acceptProvisionalAnswerPstn: !0,
                        acceptProvisionalAnswerFromPstnOnly: !0,
                        createProvisionalAnswer: {
                            enabled: !1,
                            enabledPstn: !1,
                            forceRecvonly: !1,
                            streamsBeforeSetFullRD: !1,
                            setProperAnswerType: !1,
                            connectTransport: !0,
                            audioState: "active",
                            dtlsRole: "",
                            dtlsRolePstn: ""
                        },
                        disableIncomingDtlsRoleOverride: !1,
                        disableOutgoingDtlsRoleOverride: !1,
                        statsAllowAnyVideoSendTrack: !1,
                        pictureInPicture: {
                            enablePictureInPicture: !1,
                            aspectRatioHorizontal: 16,
                            aspectRatioVertical: 9,
                            maxActiveStreams: 1,
                            minStreamGridCellWidth: 160,
                            dominantStreamChangeDebounce: 3e3,
                            statisticsBufferSize: 20,
                            multiStreamWorkerURL: ""
                        },
                        showStatsInCall: !1,
                        useSetStreamsForSender: !0,
                        addPrefixForMsidInSdp: !1,
                        enableMuteSpeakerUnmuteSpeakerWorkaround: !1,
                        alwaysRaiseBadDeviceEvents: !1,
                        removeRecvStreamOnEnded: !0,
                        requiredVideoCodecs: [
                            "h264"
                        ],
                        primaryVideoCodecs: [
                            "h264",
                            "vp8",
                            "vp9"
                        ],
                        removeUnsupportedVideoModality: !1,
                        enableActiveSpeakerBasedDSH: !0,
                        enableInitialSignalingDSHSubscription: !0,
                        enableSignalingDSHFallback: !1,
                        emptyInitialDSH: !0,
                        bwPercentiles: [
                            5,
                            50,
                            95
                        ],
                        enableTimerTracker: !0,
                        diagnostics: {
                            sideBySide: !0,
                            useForTelemetry: !1,
                            collectWhileNotConnected: !1,
                            traceLogging: !1,
                            collectionLimits: {
                                numDeviceEvents: 200,
                                numVideoEffectsEvents: 100,
                                numAudioEffectsEvents: 100,
                                numOvershootEvents: 100,
                                numIsRenderingEvents: 100,
                                numStatsReports: 600,
                                numStatsErrors: 100,
                                numSubscriptionEvents: 100,
                                numPerformanceEvents: 50,
                                numUFDs: 100,
                                numNativeSessions: 3,
                                numSessions: 3,
                                numNetworkEvents: 50,
                                numReconnects: 50,
                                numCapabilitiesRequested: 60,
                                numCapabilitiesApplied: 60,
                                numAudioCaptureErrors: 100,
                                numAudioRenderErrors: 100,
                                maxVideoStatsAfterSubscription: 30,
                                numResolutionSwitches: 10,
                                numSamplesForE2E: 4,
                                numWorkerEvents: 50,
                                numTransportStateEvents: 100,
                                numElevation: 5
                            },
                            telemetryLimits: {
                                numDeviceEvents: 50,
                                numVideoEffectsEvents: 30,
                                numAudioEffectsEvents: 30,
                                numWorkerEvents: 30,
                                numOvershootEvents: 20,
                                numIsRenderingEvents: 4,
                                numPreferredResolutions: 3,
                                numSubscriptionEvents: 100,
                                numPerformanceEvents: 30,
                                numUFDs: 50,
                                numAggregatedSamples: 60,
                                numStatsErrors: 20,
                                numCapabilitiesRequested: 5,
                                numCapabilitiesApplied: 3,
                                maxVideoStatsAfterSubscription: 30,
                                numNetworkEvents: 20,
                                numReconnects: 10,
                                numRendererStateChangedEvents: 10
                            },
                            teamsRealtimeTelemetry: {
                                pollingInterval: 15
                            },
                            performanceMonitoring: {
                                usePerfConstrainedOvc: !1,
                                useCpuSample: !1,
                                useComputePressure: !1,
                                fluctuationSamplesNum: 5,
                                enableRemoteVideoCalculator: !1,
                                enableLowerResolution: !1,
                                monitoringStrategy: "decodeTime",
                                decodeThresholds: {
                                    1080: {
                                        fps: 30,
                                        maxDecodeTime: 20
                                    },
                                    720: {
                                        fps: 30,
                                        maxDecodeTime: 15
                                    },
                                    540: {
                                        fps: 30,
                                        maxDecodeTime: 11
                                    },
                                    360: {
                                        fps: 30,
                                        maxDecodeTime: 9
                                    },
                                    234: {
                                        fps: 15,
                                        maxDecodeTime: 10
                                    },
                                    180: {
                                        fps: 15,
                                        maxDecodeTime: 10
                                    }
                                },
                                defaultThrehold: {
                                    fps: 30,
                                    maxDecodeTime: 60
                                },
                                fpsDiffThresholds: {
                                    1080: {
                                        fps: 30,
                                        fpsDiff: 4
                                    },
                                    720: {
                                        fps: 30,
                                        fpsDiff: 4
                                    },
                                    540: {
                                        fps: 30,
                                        fpsDiff: 4
                                    },
                                    360: {
                                        fps: 30,
                                        fpsDiff: 4
                                    },
                                    234: {
                                        fps: 15,
                                        fpsDiff: 2
                                    },
                                    180: {
                                        fps: 15,
                                        fpsDiff: 2
                                    }
                                },
                                defaultFpsDiffThreshold: {
                                    fps: 30,
                                    fpsDiff: 10
                                },
                                volatilityThresholds: {
                                    1080: 10,
                                    720: 10,
                                    540: 10,
                                    360: 10,
                                    234: 5,
                                    180: 5
                                },
                                defaultVolatilityThreshold: 10,
                                remoteVideoTrackInterval: 10,
                                telemetryResolutionRequestSpanMs: 5e3,
                                cpuMetricCollector: 3
                            },
                            features: {
                                takeFreezeTelemetryFromGathererV2: !0,
                                useLastSampleDeltaPerSecondConverter: !1,
                                useNewerStatisticsMetrics: !1,
                                useNewNetworkUFD: !1,
                                useNewSpeakingWhileMutedUFD: !0,
                                useNewSendBandwidthCalculation: !0,
                                useNewStatsForLocalVideoStreamWatcher: !0,
                                useFallbackToNewExtensions: !0,
                                logContributingSourcesError: !0,
                                useTwoSampleVBSSFreezeDetection: !1,
                                useNewSimulcastTelemetryExtension: !1
                            }
                        },
                        requireUserActionForAudioSharing: !1,
                        postponeAudioMixerForAudioSharing: !1,
                        reassignMediaStreamAudioTrackAfterCreation: !1,
                        deactiveAudioSender: !1,
                        webrtcForceSdesForS1: !1,
                        webrctRemoveVideoModalitiesForPstn: !1,
                        removeSendersOnConfigureModalities: !0,
                        negotiationParallelStreamAcquisitionCreateOffer: !1,
                        negotiationParallelStreamAcquisitionCreateAnswer: !1,
                        streamAvailabilityConsiderModalities: !0,
                        setBWSeed: !0,
                        bwSeedOptions: {
                            mids: [
                                "*"
                            ],
                            aggregation: "last",
                            aggregateLastN: null,
                            constValue: 6e5,
                            minValue: -1,
                            cappingValue: 15e5,
                            useLocalStorage: !0,
                            localStorageKey: "bwSeed"
                        },
                        stopCallOnAcceptFailure: !0,
                        allowMediaBypass: !0,
                        enablePermissionsWorkaround: !1,
                        disposeSendersSync: !1,
                        disposeStreamsSync: !1,
                        maxVideoStatsAfterSubscription: 30,
                        ecsConfigTimeout: 2e4,
                        contributingSourcesLogInterval: 1e4,
                        useNewTokenApi: !1,
                        audioRendererFailedReconnectTimes: 0,
                        audioRendererFailedRetryCodes: [
                            3
                        ],
                        effectsApplyConstraintsRetryMs: 1e3,
                        isSpotlightEnabled: !0,
                        addAudioStreamBeforeConnection: !1,
                        redReceiveEnabled: !1,
                        mediaEventDictionary: Gt.MEDIA_EVENT_FIELDS,
                        smallCallTelemetry: {
                            enable: !1,
                            mediaUFDEventDictionary: {}
                        },
                        applySenderParamsBeforeStart: !0,
                        reuseLastSetParameters: !0,
                        hevcCodecs: [
                            "hev1.1.6.L120.90",
                            "hev1.1.4.L93.B0",
                            "hev1.1.6.L93.B0"
                        ],
                        useInactiveAudioTrack: !1,
                        enableRollbackHandler: !1,
                        callElevationDelayReconnect: !1,
                        callElevationDelayReconnectPSTN: !1,
                        enableCachingFMTP: !0,
                        enableCachingFMTPAwait: !1,
                        enableCachingFMTPDelay: 0,
                        setDisconnectAfterCleanUp: !1,
                        sendResolutionTableOverride: Gt.RES_TABLE.SEND,
                        recvResolutionTableOverride: Gt.RES_TABLE.RECV,
                        maxSendVideoCapabilitiesMultiparty: {
                            enableForVideo: !0,
                            enableForSharing: !1,
                            useMaximumWidthHeight: !0,
                            sendMaxMbps: !1,
                            sendMaxFs: !1
                        },
                        participantStreamInitialSubscriptions: !0,
                        holdRetryActivationDelay: -1,
                        holdSkipActivation: !0,
                        recoverOnStreamUnmute: !1,
                        isAv1Allowed: !1,
                        audioSharingMemoryLeakFix: !0,
                        h264SdpProfileMultiparty: "64001f",
                        rejectIncompatibleOriginator: !0,
                        coeffOfValidTimeDelayBetweenFramesArrival: 2,
                        invalidFPSAboveMax: 40,
                        useWakeLockApi: !0,
                        noRequiredCodecsWorkaround: !1,
                        vdiDisconnectedTracking: {
                            enabled: !0,
                            clientPhrases: [
                                "failure"
                            ]
                        },
                        multiStreamSupported: !1,
                        nonMultiStreamChannels: 9,
                        useTokenMigrationHeader: !1,
                        clientSupportsAadToken: !1,
                        clientSupportsCaeToken: !1,
                        clientSupportsSkypeToken: !0,
                        supportMissingTokenTypesInResponse: !0,
                        useSkypeTokenWhenNoAuthenticateHeader: !1,
                        useKeyFrameApi: !1,
                        enablePlayVideoOnStreamUnmuteWorkaround: !1,
                        useDeviceHandleForLocalVideo: !0,
                        enableCallStateChangesOnPageClose: !0,
                        remoteUFD: {
                            enabled: !1,
                            maxParticipantNumber: 20,
                            debounceTime: 1e3,
                            list: {}
                        },
                        fixOpusComfortNoise: !1,
                        streamModalitiesExcludeData: !0,
                        muteDuringRemotePranswer: !0,
                        syncMuteStateWithAudioDirection: !1,
                        permissionDeniedUFDWorkaround: !1,
                        audioSetSinkIdWorkaround: !1,
                        identifyOneToOneCallWithoutParticipants: !1,
                        emptyIceCandidateMarksGatheredAnswerer: !1,
                        disableSendersTroughSetParameters: !1,
                        maxNumberOfPinnedVideos: 1
                    };
                }
                getEnforcedSettings() {
                    return {};
                }
            }, OC = class extends MC {
                getInitialSettings() {
                    const g = super.getInitialSettings();
                    return g.oneStreamPerDeviceType = !0, g.removeUnsupportedVideoModality = !0, g.webrtcPranswerWaitForMediaPollingInterval = 100, g.diagnostics.features.useLastSampleDeltaPerSecondConverter = !0, Ze.isFormFactor("Mobile") && (g.webrtcCameraOpenFs = 920, g.webrtcVideoCapabilityMaxFS = 920), g;
                }
            }, DC = class extends MC {
                getEnforcedSettings() {
                    return {
                        useAudioAnalyzer: !1,
                        enableAudioSharing: !1
                    };
                }
            }, NC = class extends OC {
                getEnforcedSettings() {
                    const g = {
                        webrtcSimulcastSessionEnabled: !0,
                        webrtcAllowRestoreKeyframe: !0,
                        permissions: {
                            usePositiveInAdp: !1,
                            useNegativeInAdp: !1,
                            adpFallback: !0,
                            adpFallbackAudio: !0,
                            adpFallbackVideo: !1,
                            adpRequestAVLast: !1,
                            rememberNegative: !1
                        },
                        devices: {
                            pollingIntervalIdle: 1e4
                        },
                        audioRendererRestartOnPause: !0,
                        subscribeToSsrcForVideo: !0,
                        noRequiredCodecsWorkaround: !0,
                        degradationPreference: "maintain-framerate"
                    };
                    return Ze.isVersionGreaterOrEqual("15.0") || (g.statsAllowAnyVideoSendTrack = !0), Ze.isVersionGreaterOrEqual("16.0") && Ze.isFormFactor("Mobile") && (g.enablePermissionsWorkaround = !0), Ze.isVersionGreaterOrEqual("17.0") && Ze.isFormFactor("Mobile") && (g.recoverOnStreamUnmute = !0, g.enablePlayVideoOnStreamUnmuteWorkaround = !0), g;
                }
            }, kC = class extends OC {
                getEnforcedSettings() {
                    return {
                        webrtcSimulcastSessionEnabled: !0,
                        webrtcAllowRestoreKeyframe: !0,
                        useDtlsTrasportConnectionCheck: !0,
                        videoIsRenderingCheck: !1,
                        fixSdpForPartialIceRestart: !0,
                        mapSsrcToTrackForStats: !0,
                        ignoreClosedDtlsTransportState1on1: !0,
                        subscribeToSsrcForVideo1on1: !0,
                        devices: {
                            enumerateDevicesTimeout: 0,
                            pollingIntervalIdle: 1e4,
                            idlePollingOnStart: !0
                        },
                        webrtcInjectTransportCCAudioMultiparty: !1,
                        videoCaptureFreezeTimeout: 0,
                        filterCodecsInSdp: !0,
                        useSetParametersToApplyCapabilities: !0,
                        removeRecvStreamOnEnded: !0,
                        webrtcDisabledSenderBitrate: 0,
                        disableAudioOutputSelection: !0,
                        permissionDeniedUFDWorkaround: !0
                    };
                }
            }, LC = class extends MC {
                getEnforcedSettings() {
                    return {
                        checkSupportForWebrtc_1_0: !0,
                        requireUserActionForAudioSharing: !0,
                        webrtcSimulcastSessionEnabled: !0,
                        webrtcAllowRestoreKeyframe: !0,
                        useAudioAnalyzer: !1,
                        enablePlatformCallConstraints: !0,
                        specCompliantSimulcastMultiparty: {
                            video: {
                                layerScaleFactors: [
                                    1,
                                    2
                                ],
                                enableLocally: !0,
                                allowEnableRemotely: !0,
                                useApplyConstraints: !1,
                                minFsForSimulcast: [
                                    920
                                ]
                            },
                            maxBrControlEnabled: !0,
                            allowResLimit: !0,
                            allowOverride: !0,
                            disableTilde: !1
                        },
                        extmapAllowMixedMultiparty: !0,
                        enableVlaMultiparty: !0,
                        allowRemoteVlaMultiparty: !0,
                        enableNonAdvVlaMultiparty: !0,
                        useMediaQualityControllerMultiparty: !0,
                        useSdpCapabilities: !1,
                        webrtcPranswerWaitForMediaPollingInterval: "45" === getVdiPlatform() ? null : 250
                    };
                }
            }, FC = class extends OC {
                getEnforcedSettings() {
                    const g = {};
                    return Ze.isVersionGreaterOrEqual("74.0") && (g.webrtcSimulcastSessionEnabled = !0, g.webrtcAllowRestoreKeyframe = !0, g.enableAudioSharing = !0), Ze.isVersionGreaterOrEqual("122.0") && (g.useKeyFrameApi = !0), Ze.isFormFactor("RoomAudioProcessing") && (g.defaultAudioProcessingFlags = 0, g.wasmvqe = {
                        enableAec: !1,
                        enableVqe: !1,
                        backgroundMode: !1
                    }, g.wasmdns = {
                        enableNoiseSuppression: !1,
                        backgroundMode: !1
                    }), Ze.isBrowser("CiscoOS") && (g.waitReportStatsAtCallStop = !0), Ze.isFormFactor("Mobile") && (g.enableAudioSharing = !1, g.audioRendererFailedReconnectTimes = 3, g.devices = {
                        pollingIntervalIdle: 1e4
                    }), Ze.isBrowser("SamsungTV") && (g.useSetParametersToApplyCapabilities = !0), Ze.isVersionGreaterOrEqual("98.0") && Ze.isFormFactor("Desktop") && (g.specCompliantSimulcastMultiparty = {
                        video: {
                            layerScaleFactors: [
                                1,
                                2
                            ],
                            enableLocally: !0,
                            allowEnableRemotely: !0,
                            useApplyConstraints: !0,
                            minFsForSimulcast: [
                                920
                            ]
                        },
                        maxBrControlEnabled: !0,
                        allowResLimit: !0,
                        disableTilde: !1
                    }, g.extmapAllowMixedMultiparty = !0, g.enableVlaMultiparty = !0, g.allowRemoteVlaMultiparty = !0, g.enableNonAdvVlaMultiparty = !0, g.useMediaQualityControllerMultiparty = !0), Ze.isVersionGreaterOrEqual("100.0") && (g.redReceiveEnabledMultiparty = !0), g.webcv = {
                        useWasmEffects: !0,
                        processorType: or.ProcessorType.Wasm
                    }, g;
                }
            }, xC = class {
                setMediaConfiguration(g, f) {
                    this.maxBandwidthInKbps = Math.floor((g.maxBandwidthInBps || 0) / 1e3), this.isTransportUnbundled = this.settings.forceUnbundledTransport || this.settings.enableQosSupport && (g.enableMediaQoS || !!g.mediaPortRanges), this._mediaPortRanges = g.mediaPortRanges, this.simulcastSessionEnabled = this.settings.webrtcSimulcastSessionEnabled && canUseWebrtc1_0(this.settings.checkSupportForWebrtc_1_0), this._noiseSuppressionMode = g.noiseSuppressionMode || "Auto", this._enableMediaBypass = this.settings.allowMediaBypass && g.enableMediaBypass, this.webrtcRejectedFeatures = this._enableMediaBypass ? "" : this.settings.webrtcRejectedFeatures, this.webrtcRequiredFeatures = this._enableMediaBypass ? "" : this.settings.webrtcRequiredFeatures, this.spatialAudioEnabled = f ? f.spatialAudioEnabled : g.enableSpatialAudio;
                }
                get mediaBypassEnabled() {
                    return this._enableMediaBypass;
                }
                get noiseSuppressionMode() {
                    return this._noiseSuppressionMode;
                }
                get maxBandwidthInKbps() {
                    return this._maxBandwidthInKbps;
                }
                set maxBandwidthInKbps(g) {
                    this._maxBandwidthInKbps = g, this.settings.maxBandwidthInKbps && (this._maxBandwidthInKbps = Math.min(this.settings.maxBandwidthInKbps, this._maxBandwidthInKbps || Number.MAX_SAFE_INTEGER));
                }
                get audioPortRange() {
                    if (this.isTransportUnbundled && this._mediaPortRanges && this._mediaPortRanges.audioMin && this._mediaPortRanges.audioMax) return {
                        min: this._mediaPortRanges.audioMin,
                        max: this._mediaPortRanges.audioMax
                    };
                }
                get videoPortRange() {
                    if (this.isTransportUnbundled && this._mediaPortRanges && this._mediaPortRanges.videoMin && this._mediaPortRanges.videoMax) return {
                        min: this._mediaPortRanges.videoMin,
                        max: this._mediaPortRanges.videoMax
                    };
                }
                get audioCodecContext() {
                    var _this_settings_useInsertableStreams_audioWasmCodec, _this_settings_useInsertableStreams;
                    return ((_this_settings_useInsertableStreams = this.settings.useInsertableStreams) === null || _this_settings_useInsertableStreams === void 0 ? void 0 : (_this_settings_useInsertableStreams_audioWasmCodec = _this_settings_useInsertableStreams.audioWasmCodec) === null || _this_settings_useInsertableStreams_audioWasmCodec === void 0 ? void 0 : _this_settings_useInsertableStreams_audioWasmCodec.enable) ? this.audioContext : void 0;
                }
                constructor(g){
                    this.settings = g, this.isTransportUnbundled = !1, this.webrtcRejectedFeatures = "", this.webrtcRequiredFeatures = "", this.spatialAudioEnabled = !1, this._maxBandwidthInKbps = 0, this._noiseSuppressionMode = "Auto", this._enableMediaBypass = !1, this.audioContext = {
                        enabledLocally: !1,
                        disabledRemotely: !1,
                        enabledForSend: !1,
                        initFailed: !1,
                        initSendFailed: !1,
                        codec: "None",
                        lastUsedCodec: "None"
                    };
                }
            }, UC = class extends Bt {
                getCallConstraints() {
                    return this.platformCallConstraintsProvider.constraints;
                }
                setCallConstraints(g) {
                    return this.platformCallConstraintsProvider.setConstraints(g), g;
                }
                getCallConstraintsTelemetry() {
                    return this.logger.error("Not supported globally, returning empty array"), [];
                }
                addCallConstraintsTelemetryEvent(g, f) {
                    this.logger.error("Not supported globally");
                }
                overrideMaxSessionBandwidth(g) {
                    return this.logger.error("Not supported globally"), !1;
                }
                getIceTransportPolicy() {
                    return this.logger.warn(`Not supported globally, returning default ${Gt.ICE_TRANSPORT_POLICY.all}`), Gt.ICE_TRANSPORT_POLICY.all;
                }
                setIceTransportPolicy(g) {
                    this.logger.error("Not supported globally");
                }
                getConfigReceivedOrTimeout() {
                    return this.configReceivedDefer.promise;
                }
                getConfigView(g, f) {
                    const S = g ? "Multiparty" : "1on1", v = Object.entries((0, Oo.cloneDeep)(this.settings)).reduce((g, [f, v])=>(g[f] = v, f.endsWith(S) && (g[f.replace(S, "")] = v), g), {}), _ = new xC(v);
                    return _.setMediaConfiguration(this.mediaConfiguration, f === null || f === void 0 ? void 0 : f.mediaConfig), new ps(this.logger.createChild("ConfigProviderView"), v, _, this.userAgentConfig, this.countryCode, this.platformCallConstraintsProvider, f === null || f === void 0 ? void 0 : f.getCallConstraints());
                }
                updateConfig(g, f, S, v) {
                    this.etag = f || this.etag, this.configIds = S || this.configIds, this.country = v || this.country, this.event("newConfigReceived").raise(g, f, S), this.settingsWithoutOverrides = (0, Oo.mergeWith)({}, this.settingsWithoutOverrides, g, arrayMergeCustomizer2), this.updateSettings(), this.configReceivedTimeout && (window.clearTimeout(this.configReceivedTimeout), this.configReceivedTimeout = void 0), this.configReceivedDefer.resolve();
                }
                updateSessionCount(g) {
                    this.sessionCount = g, 0 === g && this.pendingSettings && (this.logSettings("Applying pending configuration", this.pendingSettings), this.updateSettings(this.pendingSettings), this.pendingSettings = null), g > 0 && this.configReceivedTimeout && this.configReceivedDefer.resolve();
                }
                get config() {
                    return this.settings;
                }
                get stackConfig() {
                    return this.stackSettings;
                }
                get consoleOverrides() {
                    return this._consoleOverrides;
                }
                get defaultConfig() {
                    return this.initialSettings;
                }
                get userAgentConfig() {
                    return this.uaConfig;
                }
                get countryCode() {
                    return this.country;
                }
                setMediaConfiguration(g) {
                    this.mediaConfiguration = g, this.mediaSettings.setMediaConfiguration(g);
                }
                get mediaConfig() {
                    return this.mediaSettings;
                }
                get ETag() {
                    return this.etag;
                }
                get ecsConfigIds() {
                    return this.configIds;
                }
                setConsoleOverrides(g) {
                    this._consoleOverrides = (0, Oo.mergeWith)({}, this._consoleOverrides, g, arrayMergeCustomizer2), this.updateSettings();
                }
                setConsoleOverride(g, f) {
                    this._consoleOverrides[g] = f, this.updateSettings();
                }
                clearConsoleOverride(g) {
                    delete this._consoleOverrides[g], this.updateSettings();
                }
                clearAllConsoleOverrides() {
                    this._consoleOverrides = {}, this.updateSettings();
                }
                updateSettings(g = this.settingsWithoutOverrides) {
                    if (this.sessionCount > 0) return this.pendingSettings = g, void this.logSettings("pendingSettings updated", g);
                    this.settings = this.mergeSettings(g), this.event("configUpdated").raise(), this.logSettings("Settings updated", this.settings);
                }
                logSettings(g, f) {
                    const S = Object.entries(f).reduce((g, [f, S])=>(S !== this.initialSettings[f] && (g[f] = S), g), {});
                    this.logger.safe.info(`${g}: ${JSON.stringify(S)}`);
                }
                mergeSettings(g) {
                    if (!(g.enablePlatformCallConstraints || this._consoleOverrides.enablePlatformCallConstraints)) return this.mergeSettingsWithConsoleOverrides(g);
                    let f = g;
                    const { setConsoleOverridesBeforeCallConstraints: S } = this._consoleOverrides;
                    return S && (f = this.mergeSettingsWithConsoleOverrides(f)), f = this.mergeSettingsWithPlatformConstraints(f), S || (f = this.mergeSettingsWithConsoleOverrides(f)), f;
                }
                mergeSettingsWithConsoleOverrides(g) {
                    return this.logger.safe.info(`Merging settings with console overrides: ${stringifyObject(this._consoleOverrides)}`), (0, Oo.mergeWith)({}, g, this._consoleOverrides, arrayMergeCustomizer2);
                }
                mergeSettingsWithPlatformConstraints(g) {
                    const f = this.platformCallConstraintsProvider.getSettings(g);
                    return this.logger.safe.info(`Merging settings with platform call constraints: ${stringifyObject(f)}`), (0, Oo.assign)({}, g, f, arrayMergeCustomizer2);
                }
                constructor(g, f, S = {}){
                    super(g), this.logger = g, this.platformCallConstraintsProvider = f, this.platformConfig = getPlatformConfig(), this.sessionCount = 0, this._consoleOverrides = {}, this.uaConfig = new ss(this), this.mediaConfiguration = {}, this.configReceivedDefer = new ct, this.logger.info(`initializing configProvider ${this.constructor.name} from BrowserInfo: ${Ze.toString()}`), this.initialSettings = (0, Oo.mergeWith)({}, (0, Oo.cloneDeep)(this.platformConfig.getInitialSettings()), (0, Oo.cloneDeep)(S), this.platformConfig.getEnforcedSettings(), arrayMergeCustomizer2), this.settings = this.initialSettings, this.settingsWithoutOverrides = this.initialSettings, this.stackSettings = (0, Oo.cloneDeep)(S), this.mediaSettings = new xC(this.settings), this.platformCallConstraintsProvider.changed(()=>{
                        this.updateSettings();
                        const g = this.platformCallConstraintsProvider.constraints, f = this.logger.createChild("SettingsToCallConstraintsConverter"), S = convertSettingsToCallConstraints(f, this.settings, g);
                        this.platformCallConstraintsProvider.addCallConstraintsTelemetryEvent(S, "applied");
                    }), this.configReceivedTimeout = window.setTimeout(()=>{
                        this.configReceivedTimeout = void 0, this.configReceivedDefer.resolve();
                    }, this.settings.ecsConfigTimeout), this.logger.safe.info("Initialized");
                }
            }, VC = class {
                contributingSourcesChanged() {
                    this.data.changedCountContributingSources++;
                }
                setCurrentActiveStrategy(g) {
                    this.data.activeStrategy = g;
                }
                resetState() {
                    return this.data.lastMsgOrigin = void 0, this;
                }
                recordHistoryEvent(g, f) {
                    var S, v;
                    var _;
                    this.data.changedCountDSH++, (_ = (S = this.data)[v = f + "DSH"]) !== null && _ !== void 0 ? _ : S[v] = {
                        count: 0,
                        duplicateCount: 0
                    }, this.data.lastMsgOrigin = f;
                    const _1 = this.data[f + "DSH"];
                    var __firstMsgTime;
                    _1.count++, (__firstMsgTime = _1.firstMsgTime) !== null && __firstMsgTime !== void 0 ? __firstMsgTime : _1.firstMsgTime = Date.now(), deepEqual(this.data.lastHistory, g) && _1.duplicateCount++, this.data.lastHistory = g, this.data.lastMsgDate = Date.now();
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(){
                    this.data = {
                        clientDSH: void 0,
                        signalingDSH: void 0,
                        serverDSH: void 0,
                        activeStrategy: void 0,
                        lastMsgOrigin: void 0,
                        changedCountContributingSources: 0,
                        changedCountDSH: 0
                    };
                }
            }, BC = class {
                dispose() {
                    this.receiver = null, this.mediaStream = null;
                }
                getId() {
                    return this.mediaStream.id;
                }
                getModality() {
                    return this.modality;
                }
                getMsi() {
                    return this.msi;
                }
                getMediaStream() {
                    return this.mediaStream;
                }
                getReceiver() {
                    return this.receiver;
                }
                getSourceStreamId() {
                    return this.sourceStreamId;
                }
                getSubstreamIndex() {
                    return this.substreamIndex;
                }
                requestSource(g) {
                    this.msi = g;
                    const f = this.operations.then(()=>{
                        let f;
                        return this.videoCapabilities && (this.videoCapabilities.resetToInitial(), this.getMaxAllowedVideoFS && this.videoCapabilities.setMaxFS(Math.min(this.getMaxAllowedVideoFS(), this.videoCapabilities.getMaxFS())), f = this.videoCapabilities.buildFmtp(), this.videoCapabilities.resetToInitial()), this.controller.requestSource(this.mediaStream.id, g, f);
                    });
                    return this.operations = f.catch(()=>{}), f;
                }
                constructor(g, f, S, v, _, C, E, T){
                    this.mediaStream = g, this.receiver = f, this.modality = S, this.sourceStreamId = v, this.controller = _, this.videoCapabilities = C, this.getMaxAllowedVideoFS = E, this.substreamIndex = T, this.msi = -1, this.operations = Promise.resolve();
                }
            }, HC = class {
                get subscribedStream() {
                    var _this_subscription_stream;
                    return (_this_subscription_stream = this.subscription.stream) === null || _this_subscription_stream === void 0 ? void 0 : _this_subscription_stream.getMediaStream();
                }
                get msi() {
                    return this.checkDisposed(), this.subscription.msi;
                }
                get modality() {
                    return this.checkDisposed(), this.subscription.modality;
                }
                get localMsi() {
                    return this.checkDisposed(), this.subscription.localMsi;
                }
                setOnMediaStreamChangedHandler(g) {
                    this.checkDisposed(), this.mediaStreamChanged = g, this.subscription.isStreamReady && this.notifyMediaStreamChanged();
                }
                setOnErrorHandler(g) {
                    this.checkDisposed(), this.error = g;
                }
                dispose() {
                    this.subscription && (this.subscription.dispose(generateCauseId(), this), this.subscription = null);
                }
                unsubscribe() {
                    this.subscription && (this.subscription.unsubscribe(), this.subscription = null);
                }
                notifyMediaStreamChanged() {
                    if (this.mediaStreamChanged) {
                        const g = this.subscription.stream, f = this.subscription.isStreamReady;
                        this.mediaStreamChanged(g && f ? g.getMediaStream() : null);
                    }
                }
                notifyError(g) {
                    this.error && this.error(g);
                }
                checkDisposed() {
                    if (!this.subscription) throw new Error("subscription disposed");
                }
                constructor(g){
                    this.subscription = g;
                }
            }, $C = class extends Bt {
                createClient() {
                    const g = new HC(this);
                    return this.clients.push(g), g;
                }
                get isStreamReady() {
                    return this.streamReady;
                }
                get localMsi() {
                    var _this_subStream;
                    return (_this_subStream = this.subStream) === null || _this_subStream === void 0 ? void 0 : _this_subStream.getSourceStreamId();
                }
                get isInactive() {
                    return !this.clients.length;
                }
                get stream() {
                    return this.subStream;
                }
                set stream(g) {
                    try {
                        if (g === this.subStream) return;
                        this.subStream && (this.unsubscribe(!1), this.notifyStreamChanged()), this.subStream = g, g && (this.streamReady = !1, g.requestSource(this.msi).then(()=>{
                            this.streamReady = !0, this.notifyStreamChanged();
                        }).catch((g)=>{
                            this.notifyError(g);
                        }));
                    } catch (g) {
                        this.event("onFailed").raise(this, g);
                    }
                }
                notifyError(g) {
                    this.clients.forEach((f)=>{
                        f.notifyError(g);
                    }), this.event("onFailed").raise(this, g);
                }
                dispose(g, f) {
                    f ? (remove2(this.clients, (g)=>g === f), this.isInactive && (this.disposeTimeout = window.setTimeout(()=>{
                        this.disposeTimeout = null, this.unsubscribeIfInactive();
                    }, this.disposeDelay))) : (this.clients = [], this.unsubscribe());
                }
                unsubscribeIfInactive() {
                    this.isInactive && (this.disposeTimeout && clearTimeout(this.disposeTimeout), this.unsubscribe());
                }
                unsubscribe(g = !0) {
                    this.subStream && (this.subStream.requestSource(-1).catch(()=>{}), this.streamReady = !1, this.subStream = null), g && this.event("onDisposed").raise(this);
                }
                notifyStreamChanged() {
                    this.clients.forEach((g)=>g.notifyMediaStreamChanged()), this.event("onStreamChanged").raise();
                }
                constructor(g, f, S){
                    super(), this.modality = g, this.msi = f, this.disposeDelay = S, this.clients = [], this.streamReady = !1;
                }
            }, jC = class extends Bt {
                getSubscriptionsCount() {
                    return this.videoSubscriptions.filter((g)=>g.isStreamReady).length;
                }
                setStreamProvider(g) {
                    this.streamProvider = g, this.streamProvider.setOnStreamsChangedHandler(()=>this.streamsChanged());
                }
                setLogger(g) {
                    this.logger = g;
                }
                subscribeVideo(g, f = -2) {
                    let S = this.videoSubscriptions.find((S)=>S.msi === f && S.modality === g), v = this.getAvailableStream(g);
                    if (S) !S.stream && v ? this.assignStream(S, v) : this.logger.safe.info(`subscription #${f} for modality ${g} already exists, stream assigned: ${!!S.stream}`);
                    else {
                        const _ = Date.now();
                        this.disposeInactiveSubscriptionIfNeeded(g), v = this.getAvailableStream(g);
                        const C = v === null || v === void 0 ? void 0 : v.getSourceStreamId();
                        this.logger.safe.info(`creating new subscription #${f} for modality ${g}`), this.event("onSubscriptionChanged").raise(1, g, f, C, null), this.diagnostics.addSubscribe(g, f, C), S = new $C(g, f, this.configProvider.config.webrtcVideoSubscriptionDisposeTimeout);
                        const E = [];
                        E.push(S.on("onDisposed", (g)=>this.onSubscriptionDisposed(g))), E.push(S.on("onStreamChanged", ()=>{
                            var _S_stream;
                            const v = (_S_stream = S.stream) === null || _S_stream === void 0 ? void 0 : _S_stream.getId(), C = S.localMsi;
                            if (this.updateTrackIds(), S.isStreamReady) {
                                const S = Date.now();
                                this.event("onSubscriptionChanged").raise(2, g, f, C, S - _, v), this.diagnostics.addSubscribed(g, f, C, S - _);
                            }
                        })), E.push(S.on("onFailed", (g, f)=>this.onSubscriptionFailed(g, f))), this.subscriptionEvents.set(S, E), this.videoSubscriptions.push(S), v ? this.assignStream(S, v) : this.logger.safe.info(`waiting for available stream for subscription #${f}`);
                    }
                    return S.createClient();
                }
                dispose() {
                    const g = generateCauseId();
                    this.videoSubscriptions.concat().forEach((f)=>f.dispose(g)), this.streamProvider.setOnStreamsChangedHandler(null), super.dispose(), this.logger.safe.info("disposed");
                }
                reriseSubscribeEvents() {
                    this.logger.safe.info(`rerising subscription events: ${this.videoSubscriptions.length}`);
                    const g = [];
                    this.videoSubscriptions.forEach((f)=>{
                        const S = f.modality, v = f.msi, _ = f.localMsi;
                        this.event("onSubscriptionChanged").raise(1, S, v, _), this.diagnostics.addSubscribe(S, v, _), g.push(...this.getSubscriptionVideoTrackIds(f));
                    }), this.diagnostics.subscribedTrackIds = g;
                }
                setDiagnostics(g) {
                    this.diagnostics = g !== null && g !== void 0 ? g : new GC(this.configProvider, (g)=>{
                        this.logger.safe.warn(`Unhandled stats error from inactive subscription manager: ${g}`);
                    });
                }
                streamChangedByMsi(g) {
                    this.logger.safe.info(`streams changed, subscriptions active: ${this.videoSubscriptions.length}`);
                    const f = this.videoSubscriptions.find((f)=>f.msi === g);
                    f ? this.assignSubscriptionToStream(f) : this.logger.safe.error(`Subscription for msi ${g} not found`);
                }
                mcpSourceRequestsAvailable() {
                    this.isMcpSrAvailable = !0;
                }
                streamsChanged() {
                    this.logger.safe.info(`streams changed, subscriptions active: ${this.videoSubscriptions.length}`), this.videoSubscriptions.forEach((g)=>{
                        this.assignSubscriptionToStream(g);
                    });
                }
                assignSubscriptionToStream(g) {
                    const f = !g.stream || this.isStreamRemoved(g.stream);
                    if (this.logger.safe.info(`Subscription for ${g.modality} #${g.msi} needs new stream: ${f}`), !f) return;
                    const S = this.getAvailableStream(g.modality);
                    S ? this.assignStream(g, S) : this.resignStream(g);
                }
                getAvailableStream(g) {
                    let f = this.streamProvider.getStreams();
                    return "video" === g && !this.isMcpSrAvailable && this.configProvider.config.multiStreamSupported && (f = f.filter((g)=>void 0 === g.getSubstreamIndex())), f.find((f)=>g === f.getModality() && -1 === f.getMsi());
                }
                isStreamRemoved(g) {
                    return !this.streamProvider.getStreams().some((f)=>f === g);
                }
                assignStream(g, f) {
                    this.logger.safe.info(`assigning stream #${f.getId()} to subscription #${g.msi}`), g.stream = f;
                }
                resignStream(g) {
                    if (g.stream) this.logger.safe.info(`removing stream from subscription #${g.msi}`), g.stream = null;
                    else {
                        const f = this.streamProvider.getStreams().filter((f)=>g.modality === f.getModality() && -1 !== f.getMsi()).length;
                        this.logger.safe.warn(`no stream available for ${g.modality} #${g.msi}, ${g.modality} used stream count: ${f}`);
                    }
                }
                disposeInactiveSubscriptionIfNeeded(g) {
                    var _this_videoSubscriptions_find;
                    this.getAvailableStream(g) || ((_this_videoSubscriptions_find = this.videoSubscriptions.find((f)=>f.modality === g && f.isInactive)) === null || _this_videoSubscriptions_find === void 0 ? void 0 : _this_videoSubscriptions_find.unsubscribeIfInactive());
                }
                onSubscriptionDisposed(g) {
                    const f = generateCauseId(), S = g.modality, v = g.msi, _ = g.localMsi;
                    this.event("onSubscriptionChanged").raise(3, S, v, _), this.diagnostics.addUnsubscribe(S, v, _), this.logger.safe.info(`disposing subscription for ${S} #${v}`), remove2(this.videoSubscriptions, (f)=>f === g), this.streamsChanged(), this.updateTrackIds(), this.subscriptionEvents.has(g) && (this.subscriptionEvents.get(g).forEach((g)=>g.dispose(f)), this.subscriptionEvents.delete(g));
                }
                updateTrackIds() {
                    const g = [], f = [];
                    this.videoSubscriptions.forEach((S)=>{
                        var _S_stream;
                        if (!S.isStreamReady) return;
                        const v = (_S_stream = S.stream) === null || _S_stream === void 0 ? void 0 : _S_stream.getId().split("-")[1];
                        f.push(v), g.push(...this.getSubscriptionVideoTrackIds(S));
                    }), this.event("onTrackIdsChanged").raise(g), this.diagnostics.subscribedTrackIds = g, this.configProvider.config.subscribeToSsrcForVideo && this.event("onTrackSsrcChanged").raise(f);
                }
                getSubscriptionVideoTrackIds(g) {
                    var _g_stream_getMediaStream, _g_stream;
                    var _g_stream_getMediaStream_getVideoTracks_map;
                    return (_g_stream_getMediaStream_getVideoTracks_map = g === null || g === void 0 ? void 0 : (_g_stream = g.stream) === null || _g_stream === void 0 ? void 0 : (_g_stream_getMediaStream = _g_stream.getMediaStream()) === null || _g_stream_getMediaStream === void 0 ? void 0 : _g_stream_getMediaStream.getVideoTracks().map((g)=>g.id)) !== null && _g_stream_getMediaStream_getVideoTracks_map !== void 0 ? _g_stream_getMediaStream_getVideoTracks_map : [];
                }
                onSubscriptionFailed(g, f) {
                    this.event("onSubscriptionFailed").raise(-1, g.modality, g.msi, g.localMsi, f), this.diagnostics.addFailed(g.modality, g.msi, g.localMsi, stringifyObject(f));
                }
                constructor(g, f, S, v){
                    var _this_diagnostics;
                    super(g), this.configProvider = f, this.diagnostics = v, this.videoSubscriptions = [], this.isMcpSrAvailable = !1, this.subscriptionEvents = new Map, this.setLogger(g), (_this_diagnostics = this.diagnostics) !== null && _this_diagnostics !== void 0 ? _this_diagnostics : this.diagnostics = new GC(this.configProvider, ()=>{}), this.setStreamProvider(S), this.logger.safe.info("created");
                }
            }, GC = class {
                set subscribedTrackIds(g) {
                    this.data.subscribedTrackIds = g;
                }
                addSubscribe(g, f, S) {
                    const v = this.getModalityData(g);
                    if (v) {
                        const g = {
                            evt: 1,
                            msi: f,
                            localMsi: S,
                            ts: Date.now()
                        };
                        arrayLimitedPush2(v.events, g, this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents), v.counters.attempted++;
                    }
                }
                addSubscribed(g, f, S, v) {
                    const _ = this.getModalityData(g);
                    if (_) {
                        const g = {
                            evt: 2,
                            msi: f,
                            localMsi: S,
                            ts: Date.now(),
                            duration: v
                        };
                        arrayLimitedPush2(_.events, g, this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents), _.counters.subscribed++;
                    }
                }
                addUnsubscribe(g, f, S) {
                    const v = this.getModalityData(g);
                    if (v) {
                        const g = {
                            evt: 3,
                            msi: f,
                            localMsi: S,
                            ts: Date.now()
                        };
                        arrayLimitedPush2(v.events, g, this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents), v.counters.unsubscribed++;
                    }
                }
                addFailed(g, f, S, v) {
                    const _ = this.getModalityData(g);
                    if (_) {
                        const g = {
                            evt: -1,
                            msi: f,
                            localMsi: S,
                            ts: Date.now(),
                            error: v
                        };
                        arrayLimitedPush2(_.events, g, this.configProvider.config.diagnostics.collectionLimits.numSubscriptionEvents), _.counters.failed++;
                    }
                }
                getObjectRef() {
                    return this.data;
                }
                getModalityData(g) {
                    switch(g){
                        case Gt.MEDIA_TYPE.video:
                            return this.data.video;
                        case Gt.MEDIA_TYPE.sharing:
                            return this.data.sharing;
                        default:
                            return void this.addStatsError(`Unsupported modality ${g}`);
                    }
                }
                constructor(g, f){
                    this.configProvider = g, this.addStatsError = f, this.data = {
                        video: {
                            events: [],
                            counters: {
                                attempted: 0,
                                subscribed: 0,
                                unsubscribed: 0,
                                failed: 0
                            }
                        },
                        sharing: {
                            events: [],
                            counters: {
                                attempted: 0,
                                subscribed: 0,
                                unsubscribed: 0,
                                failed: 0
                            }
                        },
                        subscribedTrackIds: []
                    };
                }
            }, qC = class {
                onMaxCapabilitiesRequested(g) {
                    const f = {
                        causeId: g.causeId,
                        events: [
                            {
                                eventType: "req",
                                timestamp: Date.now(),
                                capabilities: g.capabilities,
                                isSimulcast: g.isSimulcastEnabled
                            }
                        ]
                    };
                    try {
                        if (g.modality === Gt.MODALITY.video) {
                            arrayLimitedPush2(this.data.videoMaxCapabilitiesEvents, f, this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesRequested), this.data.currentVideoSsrcRequestedCapabilities = {};
                            var _f_ssrc;
                            for (const f of g.capabilities)this.data.currentVideoSsrcRequestedCapabilities[`${(_f_ssrc = f.ssrc) !== null && _f_ssrc !== void 0 ? _f_ssrc : 0}`] = f;
                        } else if (g.modality === Gt.MODALITY.sharing) {
                            arrayLimitedPush2(this.data.sharingMaxCapabilitiesEvents, f, this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesRequested), this.data.currentSharingSsrcRequestedCapabilities = {};
                            var _f_ssrc1;
                            for (const f of g.capabilities)this.data.currentSharingSsrcRequestedCapabilities[`${(_f_ssrc1 = f.ssrc) !== null && _f_ssrc1 !== void 0 ? _f_ssrc1 : 0}`] = f;
                        }
                    } catch (g) {
                        var _this_addStatsError, _this;
                        (_this_addStatsError = (_this = this).addStatsError) === null || _this_addStatsError === void 0 ? void 0 : _this_addStatsError.call(_this, "onMaxCapabilitiesRequested", stringifyObject(g));
                    }
                }
                onMaxCapabilitiesApplied(g) {
                    try {
                        const f = this.getEventForCause(g.modality, g.causeId), S = {
                            eventType: "app",
                            timestamp: Date.now(),
                            capabilities: g.capabilities,
                            error: `${g.error}` || "none"
                        };
                        if (f && (arrayLimitedPush2(f.events, S, this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied, 1), g.error && (g.modality === Gt.MODALITY.video ? arrayLimitedPush2(this.data.videoMaxCapabilitiesErrors, f, this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied, 1) : g.modality === Gt.MODALITY.sharing && arrayLimitedPush2(this.data.sharingMaxCapabilitiesErrors, f, this.configProvider.config.diagnostics.collectionLimits.numCapabilitiesApplied, 1))), g.modality === Gt.MODALITY.video) {
                            this.data.currentVideoSsrcAppliedCapabilities = {};
                            var _f_ssrc;
                            for (const f of g.capabilities)this.data.currentVideoSsrcAppliedCapabilities[`${(_f_ssrc = f.ssrc) !== null && _f_ssrc !== void 0 ? _f_ssrc : 0}`] = f;
                        } else if (g.modality === Gt.MODALITY.sharing) {
                            this.data.currentSharingSsrcAppliedCapabilities = {};
                            var _f_ssrc1;
                            for (const f of g.capabilities)this.data.currentSharingSsrcAppliedCapabilities[`${(_f_ssrc1 = f.ssrc) !== null && _f_ssrc1 !== void 0 ? _f_ssrc1 : 0}`] = f;
                        }
                    } catch (g) {
                        var _this_addStatsError, _this;
                        (_this_addStatsError = (_this = this).addStatsError) === null || _this_addStatsError === void 0 ? void 0 : _this_addStatsError.call(_this, "onMaxCapabilitiesApplied", stringifyObject(g));
                    }
                }
                addVideoControlMessage(g = !1) {
                    this.data.numVideoControlMessages++, g && this.data.numOutOfOrderVideoControlMessages++;
                }
                getObjectRef() {
                    return this.data;
                }
                registerWebcamFreeze() {
                    this.data.numWebcamFreezeIntervals++;
                }
                registerProcessedStreamFreeze() {
                    this.data.numProcessedStreamFreezeIntervals++;
                }
                getEventForCause(g, f) {
                    return (g === Gt.MODALITY.video ? this.data.videoMaxCapabilitiesEvents : this.data.sharingMaxCapabilitiesEvents).find((g)=>g.causeId === f);
                }
                constructor(g, f){
                    this.configProvider = g, this.addStatsError = f, this.data = {
                        videoMaxCapabilitiesEvents: [],
                        videoMaxCapabilitiesErrors: [],
                        sharingMaxCapabilitiesEvents: [],
                        sharingMaxCapabilitiesErrors: [],
                        currentVideoSsrcRequestedCapabilities: {},
                        currentVideoSsrcAppliedCapabilities: {},
                        currentSharingSsrcRequestedCapabilities: {},
                        currentSharingSsrcAppliedCapabilities: {},
                        numVideoControlMessages: 0,
                        numOutOfOrderVideoControlMessages: 0,
                        numWebcamFreezeIntervals: 0,
                        numProcessedStreamFreezeIntervals: 0
                    };
                }
            }, WC = class {
                setTimeToFirstFrame(g, f) {
                    -1 !== g && (f === Gt.MODALITY.video && -1 === this.data.firstTimeToFirstFrameVideo ? this.data.firstTimeToFirstFrameVideo = g : f === Gt.MODALITY.sharing && -1 === this.data.firstTimeToFirstFrameSharing && (this.data.firstTimeToFirstFrameSharing = g));
                }
                setTimeToFirstFrameSinceSubscriptionStart(g, f) {
                    -1 !== g && (f === Gt.MODALITY.video && -1 === this.data.timeToFirstFrameSinceSubscriptionStartVideo ? this.data.timeToFirstFrameSinceSubscriptionStartVideo = g : f === Gt.MODALITY.sharing && -1 === this.data.timeToFirstFrameSinceSubscriptionStartSharing && (this.data.timeToFirstFrameSinceSubscriptionStartSharing = g));
                }
                setIsRendering(g, f) {
                    this.data.isRenderingEvents[f] && arrayLimitedPush2(this.data.isRenderingEvents[f], {
                        isRendering: g,
                        ts: Date.now()
                    }, this.configProvider.config.diagnostics.collectionLimits.numIsRenderingEvents);
                }
                setPreferredResolution(g, f) {
                    (g.width || g.height) && (this.data.preferredResolution[f] = g);
                }
                newRendererDiagnostics() {
                    const g = new zC(this, this.configProvider), f = g.on("onDisposed", ()=>{
                        this.removeDeadRenderers(), f.dispose();
                    });
                    return this.data.renderers.push(g.getObjectRef()), g;
                }
                getObjectRef() {
                    return this.data;
                }
                removeDeadRenderers() {
                    this.data.renderers = this.data.renderers.filter((g)=>g.alive);
                }
                constructor(g){
                    this.configProvider = g, this.data = {
                        renderers: [],
                        firstTimeToFirstFrameVideo: -1,
                        firstTimeToFirstFrameSharing: -1,
                        timeToFirstFrameSinceSubscriptionStartVideo: -1,
                        timeToFirstFrameSinceSubscriptionStartSharing: -1,
                        isRenderingEvents: {
                            video: [],
                            sharing: []
                        },
                        preferredResolution: {
                            video: void 0,
                            sharing: void 0
                        }
                    };
                }
            }, zC = class extends Bt {
                set trackId(g) {
                    this.data.trackId = g;
                }
                set rendererSize(g) {
                    this.data.rendererSize = g, g.toString = ()=>`${g.width}x${g.height}`, this.managerDiagnostics.setPreferredResolution(g, this.data.modality);
                }
                set msi(g) {
                    this.data.msi = g;
                }
                set modality(g) {
                    this.data.modality = g;
                }
                set isRendering(g) {
                    this.data.isRendering = g, this.managerDiagnostics.setIsRendering(g, this.data.modality);
                }
                set timeToFirstFrame(g) {
                    this.data.timeToFirstFrame = g, this.managerDiagnostics.setTimeToFirstFrame(g, this.data.modality);
                }
                set timeToFirstFrameSinceSubscriptionStart(g) {
                    this.data.timeToFirstFrameSinceSubscriptionStart = g, this.managerDiagnostics.setTimeToFirstFrameSinceSubscriptionStart(g, this.data.modality);
                }
                addFreezeDuration(g) {
                    this.data.totalFreezeDuration += g;
                }
                addStateChange(g) {
                    arrayLimitedPush2(this.data.rendererStates, g, this.configProvider.config.diagnostics.telemetryLimits.numRendererStateChangedEvents);
                }
                dispose() {
                    this.isAlive = !1, this.event("onDisposed").raise();
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g, f){
                    super(), this.managerDiagnostics = g, this.configProvider = f, this.isAlive = !0, this.data = {
                        alive: !0,
                        totalFreezeDuration: 0,
                        isRendering: !1,
                        timeToFirstFrame: -1,
                        timeToFirstFrameSinceSubscriptionStart: -1,
                        rendererStates: []
                    }, delete this.data.alive, Object.defineProperty(this.data, "alive", {
                        get: ()=>this.isAlive,
                        enumerable: !1,
                        configurable: !1
                    });
                }
            }, KC = P, JC = __toESM(we()), YC = P;
            function fmtParamsToString(g) {
                let f = "";
                return forOwn(g, (g, S)=>{
                    f += (f ? ";" : "") + S, void 0 !== g && (f += `=${g}`);
                }), f;
            }
            var QC = class {
                setIfMissing(g, f) {
                    this.contains(g) || (this.parameters[g] = f);
                }
                removeIfPresent(g) {
                    this.contains(g) && delete this.parameters[g];
                }
                get(g) {
                    return this.parameters[g];
                }
                names() {
                    return Object.keys(this.parameters);
                }
                contains(g) {
                    return this.parameters.hasOwnProperty(g);
                }
                toString() {
                    return fmtParamsToString(this.parameters);
                }
                constructor(g){
                    this.parameters = {}, g && g.split(";").forEach((g)=>{
                        const f = g.split("=");
                        this.parameters[f[0]] = f[1];
                    });
                }
            };
            function updatePayload(g, f, S) {
                if (!g.rtp) return;
                const v = g.rtp.filter((g)=>g.payload === f)[0];
                v && forOneCodec(g, {
                    codec: v.codec,
                    rate: v.rate,
                    payload: v.payload,
                    encoding: v.encoding
                }, (g)=>(g.rtp.payload = S, g));
            }
            function findAvailablePayload(g) {
                const f = new Set;
                var _S_rtp;
                for (const S of g.media)for (const g of (_S_rtp = S.rtp) !== null && _S_rtp !== void 0 ? _S_rtp : [])f.add(g.payload);
                const S = [
                    96,
                    127
                ];
                for(let g = S[0]; g <= S[1]; g++)if (!f.has(g)) return g;
                const v = [
                    35,
                    64
                ];
                for(let g = v[0]; g <= v[1]; g++)if (!f.has(g)) return g;
                return -1;
            }
            function findAllAvailablePayloads(g, f) {
                const S = new Set, v = [];
                var _f_rtp;
                for (const f of g.media)for (const g of (_f_rtp = f.rtp) !== null && _f_rtp !== void 0 ? _f_rtp : [])S.add(g.payload);
                for(let g = f[0]; g <= f[1]; g++)S.has(g) || v.push(g);
                return v;
            }
            function forOneCodec(g, f, S, v) {
                forCodec(g, f, !0, v, S);
            }
            function forAllCodecs(g, f, S, v) {
                forCodec(g, f, !1, v, S);
            }
            function forCodec(g, f, S, v = !0, _) {
                if (g.rtp) {
                    for(let C = 0; C < g.rtp.length; C++){
                        const E = g.rtp[C], T = E.payload;
                        if (f.codec.toLowerCase() !== E.codec.toLowerCase() || f.rate !== E.rate || f.encoding !== E.encoding || f.payload && f.payload !== E.payload) continue;
                        const I = {
                            rtp: E
                        };
                        g.fmtp || (g.fmtp = []);
                        const b = g.fmtp.find((g)=>E.payload === g.payload);
                        I.fmtp = b, g.rtcpFb || (g.rtcpFb = []), I.rtcpFb = g.rtcpFb.filter((g)=>g.payload === E.payload);
                        const A = I.rtcpFb.length > 0;
                        if (null === _(I)) g.payloads = g.payloads.toString().split(" ").filter((g)=>E.payload !== +g).join(" "), g.fmtp = g.fmtp.filter((g)=>E.payload !== g.payload), g.rtcpFb = g.rtcpFb.filter((g)=>E.payload !== g.payload), g.rtp[C] = null;
                        else {
                            if (I.rtp.payload !== T) {
                                const f = I.rtp.payload;
                                g.payloads = g.payloads.toString().split(" ").map((g)=>+g === T ? f : +g).join(" "), I.fmtp && (I.fmtp.payload = f), I.rtcpFb && I.rtcpFb.forEach((g)=>g.payload = f), v && g.fmtp.filter((g)=>g.config && g.config.indexOf(`apt=${T}`) > -1).forEach((g)=>g.config = g.config.replace(`apt=${T}`, `apt=${f}`));
                            }
                            !b && I.fmtp && g.fmtp.push(I.fmtp), !A && I.rtcpFb && I.rtcpFb.forEach((f)=>g.rtcpFb.push(f));
                        }
                        if (S) break;
                    }
                    g.rtp = g.rtp.filter((g)=>!!g);
                }
            }
            function removeCodec(g, f) {
                if (!g.rtp) return;
                let S = -1;
                if (g.rtp.forEach(function(g, v) {
                    f.codec.toLowerCase() !== g.codec.toLowerCase() || f.rate !== g.rate || f.encoding !== g.encoding || f.payload && f.payload !== g.payload || (S = v);
                }), S >= 0 && g.rtp.length > 1) {
                    var _g_fmtp;
                    const f = g.rtp[S].payload;
                    g.rtp.splice(S, 1), g.payloads = g.payloads.split(" ").filter((g)=>f !== +g).join(" "), g.fmtp = (_g_fmtp = g.fmtp) === null || _g_fmtp === void 0 ? void 0 : _g_fmtp.filter((g)=>f !== g.payload);
                }
            }
            function addCodec(g, f) {
                g.rtp.unshift({
                    payload: f.payload,
                    codec: f.codec,
                    rate: f.rate,
                    encoding: f.encoding
                }), g.payloads = `${f.payload} ${g.payloads}`;
            }
            function isCodecsMatch2(g, f, S) {
                if (!(0, YC.isUndefined)(g.rate) && g.rate !== f.rate) return !1;
                if (!(0, YC.isUndefined)(g.codec) && g.codec.toLowerCase() !== f.codec.toLowerCase()) return !1;
                if (!(0, YC.isUndefined)(g.encoding)) {
                    if (!(0, YC.isUndefined)(f.encoding) && g.encoding !== f.encoding) return !1;
                    if ((0, YC.isUndefined)(f.encoding) && 1 !== g.encoding) return !1;
                }
                if (!(0, YC.isUndefined)(g.fmtpLine)) {
                    const v = S === null || S === void 0 ? void 0 : S.find((S)=>S.payload === f.payload && -1 !== S.config.toLowerCase().indexOf(g.fmtpLine.toLowerCase()));
                    return !!v;
                }
                return !0;
            }
            function isPayloadMatch(g, f) {
                return f === g || "*" === f;
            }
            function filterCodecs(g, f, S, v) {
                var _g_rtp, _g_fmtp, _g_rtcpFb;
                if (!((_g_rtp = g.rtp) === null || _g_rtp === void 0 ? void 0 : _g_rtp.length)) return;
                let _ = g.rtp.filter((S)=>f.some((f)=>isCodecsMatch2(f, S, g.fmtp)));
                g.type === Gt.MEDIA_TYPE.video && (_ = _.filter((f)=>{
                    var _g_fmtp;
                    const S = (_g_fmtp = g.fmtp) === null || _g_fmtp === void 0 ? void 0 : _g_fmtp.find((g)=>g.payload === f.payload && g.config.startsWith("apt="));
                    if (S) {
                        const g = +S.config.split(";")[0].split("=")[1];
                        return _.some((f)=>f.payload === g);
                    }
                    return !0;
                })), _.length ? (g.rtp = _, S && (g.rtp = (0, YC.flatten)(f.map((f)=>g.rtp.filter((S)=>isCodecsMatch2(f, S, g.fmtp))))), g.payloads = g.rtp.map((g)=>g.payload).join(" "), g.fmtp = (_g_fmtp = g.fmtp) === null || _g_fmtp === void 0 ? void 0 : _g_fmtp.filter((f)=>g.rtp.some((g)=>isPayloadMatch(g.payload, f.payload))), g.rtcpFb = (_g_rtcpFb = g.rtcpFb) === null || _g_rtcpFb === void 0 ? void 0 : _g_rtcpFb.filter((f)=>g.rtp.some((g)=>isPayloadMatch(g.payload, f.payload)))) : v && v.warn("Empty rtp list after filtering");
            }
            function getModalityForMedia(g) {
                if (g.label) switch(g.label){
                    case Gt.MEDIA_LABEL.audio:
                        return "Audio";
                    case Gt.MEDIA_LABEL.video:
                        return "Video";
                    case Gt.MEDIA_LABEL.sharing:
                        return "ScreenShare";
                    case Gt.MEDIA_LABEL.data:
                        return "Data";
                }
                else switch(g.type){
                    case Gt.MEDIA_TYPE.audio:
                        return "Audio";
                    case Gt.MEDIA_TYPE.video:
                        return "Video";
                    case Gt.MEDIA_TYPE.data:
                    case Gt.MEDIA_TYPE.dataChannel:
                        return "Data";
                }
                return null;
            }
            function getModality(g) {
                if (g.label) switch(g.label){
                    case Gt.MEDIA_LABEL.audio:
                        return Gt.MODALITY.audio;
                    case Gt.MEDIA_LABEL.video:
                        return Gt.MODALITY.video;
                    case Gt.MEDIA_LABEL.sharing:
                        return Gt.MODALITY.sharing;
                    case Gt.MEDIA_LABEL.data:
                        return Gt.MODALITY.data;
                }
                else switch(g.type){
                    case Gt.MEDIA_TYPE.audio:
                        return Gt.MODALITY.audio;
                    case Gt.MEDIA_TYPE.video:
                        return Gt.MODALITY.video;
                    case Gt.MEDIA_TYPE.data:
                    case Gt.MEDIA_TYPE.dataChannel:
                        return Gt.MODALITY.data;
                }
                return null;
            }
            function getLabelForModality(g) {
                switch(g){
                    case Gt.MODALITY.audio:
                        return Gt.MEDIA_LABEL.audio;
                    case Gt.MODALITY.video:
                        return Gt.MEDIA_LABEL.video;
                    case Gt.MODALITY.sharing:
                        return Gt.MEDIA_LABEL.sharing;
                    case Gt.MODALITY.data:
                        return Gt.MEDIA_LABEL.data;
                    default:
                        return null;
                }
            }
            function getModalities(g) {
                return g.media.reduce((g, f)=>{
                    if (0 !== f.port) {
                        const S = getModality(f);
                        if (!(S in g)) {
                            const v = f.direction ? f.direction.toLowerCase() : Gt.MEDIA_STATE.sendReceive;
                            g[S] = v;
                        }
                    }
                    return g;
                }, {});
            }
            function getTypeFromModality(g) {
                switch(g){
                    case Gt.MODALITY.audio:
                        return Gt.MEDIA_TYPE.audio;
                    case Gt.MODALITY.video:
                    case Gt.MODALITY.sharing:
                        return Gt.MEDIA_TYPE.video;
                    case Gt.MODALITY.data:
                        return Gt.MEDIA_TYPE.data;
                    default:
                        return null;
                }
            }
            function getBundle(g) {
                var _g_groups;
                const f = (_g_groups = g.groups) === null || _g_groups === void 0 ? void 0 : _g_groups.find((g)=>"BUNDLE" === g.type);
                if (f) {
                    var _f_mids;
                    const S = (_f_mids = f.mids) === null || _f_mids === void 0 ? void 0 : _f_mids.toString().split(" ")[0];
                    return g.media.find((g)=>{
                        const f = "number" == typeof g.mid ? g.mid.toString() : g.mid;
                        return S === f;
                    }) || null;
                }
                return null;
            }
            function isMediaDisabled(g) {
                return 0 === g.port;
            }
            function getRecvCapabilitiesForMedia(g) {
                let f;
                return g && forOneCodec(g, {
                    codec: "h264",
                    rate: 9e4
                }, (g)=>{
                    var _g_fmtp;
                    ((_g_fmtp = g.fmtp) === null || _g_fmtp === void 0 ? void 0 : _g_fmtp.config) && (f = parseVideoCapabilitiesFromFmtpConfig(g.fmtp.config));
                }), f;
            }
            function getNextAvailableMid(g) {
                const f = g.media.map((g)=>parseFloat(g.mid || "0"));
                for(let g = 1; g <= Math.max(...f) + 1; g++)if (!f.includes(g)) return g.toString();
                return "-1";
            }
            function parseVideoCapabilitiesFromFmtpConfig(g) {
                const f = new QC(g);
                return {
                    maxFs: +f.get(Gt.VIDEO_CAPABILITIES.MAX_FS_PATH),
                    maxMbps: +f.get(Gt.VIDEO_CAPABILITIES.MAX_MBPS_PATH),
                    maxFps: +f.get(Gt.VIDEO_CAPABILITIES.MAX_FPS_PATH) / 100,
                    maxBr: 1200 * +f.get(Gt.VIDEO_CAPABILITIES.MAX_BR_PATH)
                };
            }
            function getMultiStreamCountFromSdp(g) {
                const f = /a=x-multi-stream:(\d+)/, S = g.match(f);
                if (S) return parseInt(S[1]);
            }
            var XC = P;
            function CandidateTransform() {
                const g = [
                    {
                        jsep: "active",
                        msSdp: "tcp-act"
                    },
                    {
                        jsep: "passive",
                        msSdp: "tcp-pass"
                    },
                    {
                        jsep: "so",
                        msSdp: "tcp-so"
                    }
                ];
                function transformBundle(g, f) {
                    if (g.port && !g.candidates.length) {
                        const S = getBundle(f);
                        S && (g.port = S.port, g.connection = S.connection);
                    }
                }
                function transformCandidate(g, f) {
                    delete g.generation, delete g["network-id"], delete g["network-cost"], g.transport.match(/tcp/i) && transformTcpCandidate(g, f);
                }
                function transformTcpCandidate(f, S) {
                    g.some(function(g) {
                        if (S) {
                            if (g.msSdp === f.transport.toLowerCase()) return f.transport = "tcp", f.tcptype = g.jsep, !0;
                        } else if (f.tcptype && g.jsep === f.tcptype.toLowerCase()) return f.transport = g.msSdp, delete f.tcptype, !0;
                        return !1;
                    });
                }
                function isDefault(g, f, S) {
                    const v = f.connection || S.connection, isSame = function(g, f, S) {
                        return g.port === S && g.ip === f;
                    };
                    return !!v && (1 === g.component ? isSame(g, v.ip, f.port) : !!f.rtcp && isSame(g, f.rtcp.ip || v.ip, f.rtcp.port));
                }
                this.fromMsSdp = function(g) {
                    g.candidates = g.candidates || [], g.xCandidatesIpv6 && (g.xCandidatesIpv6.forEach(function(f) {
                        g.candidates.push(f);
                    }), delete g.xCandidatesIpv6), g.candidates.forEach(function(g) {
                        transformCandidate(g, !0);
                    });
                }, this.toMsSdp = function(g, f) {
                    g.candidates = g.candidates || [], g.candidates.sort(function(S, v) {
                        return S.foundation !== v.foundation ? S.foundation - v.foundation : S.component !== v.component ? S.component - v.component : +isDefault(v, g, f) - +isDefault(S, g, f);
                    }), g.candidates = g.candidates.filter(function(f, S) {
                        transformCandidate(f, !1);
                        const v = g.candidates[S - 1];
                        return !v || v.component !== f.component || v.foundation !== f.foundation;
                    }), transformBundle(g, f);
                };
            }
            var ZC = {
                build: ()=>new CandidateTransform
            }, ey = class {
                toMsSdp(g, f) {
                    "offer" === f ? g.rtcp && (g.rtcp = {
                        port: g.port
                    }) : delete g.rtcp;
                }
            }, ty = {
                build: ()=>new ey
            }, iy = {
                STREAM_ID: {
                    audio: "mainAudio",
                    video: "mainVideo",
                    sharing: "applicationsharingVideo"
                },
                STREAM_ID_DELIMITER: "-"
            }, ny = [
                {
                    label: Gt.MEDIA_LABEL.audio,
                    id: iy.STREAM_ID.audio
                },
                {
                    label: Gt.MEDIA_LABEL.video,
                    id: iy.STREAM_ID.video
                },
                {
                    label: Gt.MEDIA_LABEL.sharing,
                    id: iy.STREAM_ID.sharing
                }
            ].reduce((g, f)=>(g[f.label] = f.id, g), {}), ry = uniqueId(), ay = class {
                fromMsSdp(g) {
                    if (0 === g.port) return;
                    const f = "-";
                    if (!this.isRecvOnly(g) || this.configuration.unifiedPlanEnabled) {
                        if (g.msid) {
                            g.ssrcs && 1 === g.ssrcs.length && (this.addStream(g, g.ssrcs[0].id, g.ssrcs[0].value, g.msid), g.ssrcs.shift());
                            const S = g.msid.split(" ");
                            (this.configuration.addPrefixForMsid || S[0] === f) && (g.msid = this.getMsidValue(S[0], S[1] || S[0], g.label));
                        }
                        if (g.ssrcs) this.updateMsids(g.ssrcs, (S, v)=>this.configuration.addPrefixForMsid || S === f ? this.getMsidValue(S, v, g.label) : `${S} ${v}`);
                        else {
                            const f = this.getFlowSsrcs(g);
                            f.length > 0 ? f.forEach((S)=>{
                                this.addStream(g, S, ry, this.getMsidValue(f[0], f[0], g.label));
                            }) : g.xSsrcRange && this.addStream(g, g.xSsrcRange.ssrcMin, ry, this.getMsidValue(g.xSsrcRange.ssrcMin, g.xSsrcRange.ssrcMin, g.label));
                        }
                    }
                    delete g.xSsrcRange;
                }
                toMsSdp(g, f) {
                    var _g_ssrcs;
                    if (0 === g.port) return;
                    let S;
                    ((_g_ssrcs = g.ssrcs) === null || _g_ssrcs === void 0 ? void 0 : _g_ssrcs[0]) && (S = g.ssrcs[0].id), void 0 !== S && (g.xMultiStream || (g.xSsrcRange = {
                        ssrcMin: S,
                        ssrcMax: S + f
                    }));
                }
                getFlowSsrcs(g) {
                    if (g.ssrcGroups && g.type === Gt.MEDIA_TYPE.video) {
                        let f;
                        if (g.ssrcGroups.some((g)=>"FID" === g.semantics && (f = g, !0)), f) return f.ssrcs.split(" ").map((g)=>+g);
                    }
                    return [];
                }
                addStream(g, f, S, v) {
                    g.ssrcs = g.ssrcs || [], g.ssrcs.push({
                        attribute: "cname",
                        id: f,
                        value: S
                    }), g.ssrcs.push({
                        attribute: "msid",
                        id: f,
                        value: v
                    });
                }
                updateMsids(g, f) {
                    g.filter((g)=>"msid" === g.attribute).forEach((g)=>{
                        const S = g.value.split(" ");
                        g.value = f(S[0], S[1] || S[0]);
                    });
                }
                getMsidValue(g, f, S) {
                    const v = this.getMsidPrefix(S);
                    return v + g + " " + v + f;
                }
                getMsidPrefix(g) {
                    return ny[g] ? ny[g] + iy.STREAM_ID_DELIMITER : "";
                }
                isRecvOnly(g) {
                    return "recvonly" === g.direction;
                }
                constructor(g){
                    this.configuration = g;
                }
            }, sy = {
                audio: "main-audio",
                video: "main-video"
            }, oy = class {
                toMsSdp(g, f) {
                    return g.msidSemantic = {
                        semantic: "WMS",
                        token: "*"
                    }, g.media.forEach((S, v)=>{
                        if (S.protocol = Gt.PROFILES.rtpSavp, S.label = S.label || this.getLabel(S.type), isMediaDisabled(S)) {
                            for(const g in S)S.hasOwnProperty(g) && [
                                "type",
                                "port",
                                "protocol",
                                "payloads"
                            ].indexOf(g) < 0 && delete S[g];
                            S.payloads = "34";
                        }
                        const _ = this.getSsrcRangeForIndex(S.direction, v);
                        this.streamTransform.toMsSdp(S, _), S.crypto && S.crypto.forEach(function(g) {
                            g.config += "|2^31";
                        }), 0 !== S.port && g.fingerprint && (S.fingerprint = g.fingerprint), this.candidateTransform.toMsSdp(S, g), this.rtcpTransform.toMsSdp(S, f), S.invalid && (this.logger.unsafe.error(`Unknown SDP attributes! ${JSON.stringify(S.invalid)}`), delete S.invalid), this.transformExtensions(S, !1), 0 !== S.port && (S.type === Gt.MEDIA_TYPE.audio && this.context.configProvider.config.webrtcAudioChannelSignalingFeedback ? S.signalingFbXMessage = {
                            payload: "*",
                            param: this.context.configProvider.config.webrtcAudioChannelSignalingFeedback
                        } : S.type === Gt.MEDIA_TYPE.video && this.context.configProvider.config.webrtcVideoChannelSignalingFeedback && (S.signalingFbXMessage = {
                            payload: "*",
                            param: this.context.configProvider.config.webrtcVideoChannelSignalingFeedback
                        }));
                    }), delete g.fingerprint, g;
                }
                fromMsSdp(g, f) {
                    for(let S = g.media.length - 1; S >= 0; --S){
                        var _v_ssrcs;
                        const v = g.media[S];
                        if ((((_v_ssrcs = v.ssrcs) === null || _v_ssrcs === void 0 ? void 0 : _v_ssrcs[0]) || v.xSsrcRange) && (g.msidSemantic = {
                            semantic: "WMS",
                            token: "*"
                        }), isMediaDisabled(v)) v.direction || (v.direction = "inactive");
                        else {
                            if (this.streamTransform.fromMsSdp(v), delete v.cryptoscale, v.fingerprint && (!this.isOffer(f) || this.context.configProvider.config.disableIncomingDtlsRoleOverride && v.setup || (v.setup = "actpass")), v.crypto) for(let g = v.crypto.length - 1; g >= 0; --g){
                                const f = v.crypto[g];
                                f.config.match(/.*\|\d+:\d+/) ? v.crypto.splice(g, 1) : f.config = f.config.replace(/(.*)\|2\^\d+/, "$1");
                            }
                            v.remoteCandidates && (delete v.candidates, delete v.xCandidatesIpv6, delete v.remoteCandidates), this.candidateTransform.fromMsSdp(v), v.rtcpFbXMessage && delete v.rtcpFbXMessage, v.invalid && this.logger.unsafe.info(`Unknown SDP attributes! ${JSON.stringify(v.invalid)}`), this.transformExtensions(v, !0);
                        }
                    }
                    return g;
                }
                transformExtensions(g, f) {
                    const S = [
                        {
                            name: Gt.ABS_SEND_TIME.EXT_URI,
                            encoded: Gt.ABS_SEND_TIME.MSSDP_ENCODED_URI
                        },
                        {
                            name: Gt.TRANSPORT_CC.EXT_URI,
                            encoded: Gt.TRANSPORT_CC.MSSDP_ENCODED_URI
                        }
                    ];
                    g.ext && g.ext.forEach(function(g) {
                        S.some(function(S) {
                            const v = f ? S.encoded : S.name, _ = f ? S.name : S.encoded;
                            return v === g.uri && (g.uri = _, !0);
                        });
                    });
                }
                isOffer(g) {
                    return "offer" === g;
                }
                getLabel(g) {
                    return sy.hasOwnProperty(g) && sy[g] || "undefined";
                }
                getSsrcRangeForIndex(g, f) {
                    const S = this.mediaManager.getMediaEntities()[f], v = S === null || S === void 0 ? void 0 : S.getSimulcastContext();
                    return hasSendDirectionality(g) && v ? v.getSsrcRange() : 0;
                }
                constructor(g, f){
                    this.context = g, this.mediaManager = f, this.logger = this.context.logger, this.candidateTransform = ZC.build(), this.streamTransform = new ay(this.context.configuration), this.rtcpTransform = ty.build();
                }
            }, ly = 4294967040, cy = class {
                nextAudioStreamSsrc() {
                    return this.nextSsrc(0);
                }
                nextVideoStreamSsrc() {
                    return this.nextSsrc(99);
                }
                nextSsrc(g) {
                    let f = this.ssrc;
                    do f = this.ssrc, this.ssrc = (this.ssrc + g + 1) % ly, 0 === this.ssrc && (this.ssrc = 1);
                    while (f + g > ly);
                    return {
                        min: f,
                        max: f + g
                    };
                }
                constructor(){
                    this.ssrc = Math.floor(Math.random() * (ly - 1)) + 1;
                }
            }, dy = P, uy = class {
                get ridList() {
                    return this.config ? (0, dy.times)(this.config.layerScaleFactors.length, (g)=>g + 1) : [];
                }
                localDescriptionIsApplied() {
                    this.isLocalDescSet = !0;
                }
                enableInLocalDesc() {
                    this.enabledLocally = !0;
                }
                shouldBeEnabledInLocalDesc() {
                    return !!this.config && (this.config.enableLocally || this.enabledRemotely);
                }
                enableInRemoteDesc() {
                    this.enabledRemotely = !0;
                }
                shouldBeEnabledInRemoteDesc() {
                    return !!this.config && (this.enabledLocally || this.config.allowEnableRemotely && this.isMidRidHeaderExtPresented() && !this.isLocalDescSet);
                }
                shouldUseSimulcast() {
                    return this.shouldBeEnabledInLocalDesc();
                }
                getSsrcRange() {
                    return this.shouldUseSimulcast() ? 99 : 0;
                }
                isMidRidHeaderExtPresented() {
                    const g = this.mediaEntity.getRtpHeaderExtensions();
                    return g === null || g === void 0 ? void 0 : g.some((g)=>"mid" === g.headerType || "rid" === g.headerType || "rrid" === g.headerType);
                }
                constructor(g, f, S){
                    this.mediaEntity = g, this.logger = f, this.configProvider = S, this.activeRids = [], this.isLocalDescSet = !1, this.enabledLocally = !1, this.enabledRemotely = !1;
                    const v = modalityToMediaType(this.mediaEntity.getModality());
                    this.config = getSimulcastConfigForMediaType(v, this.configProvider), this.config ? this.logger.safe.debug(`Adding simulcast info to ${g.getModality()} with mid: ${g.getMid()}, config: ${JSON.stringify(this.config)}`) : this.logger.safe.debug(`Simulcast is disabled for ${g.getModality()}`);
                }
            };
            function getSimulcastConfigForMediaType(g, f) {
                var _f_config_specCompliantSimulcast, _f_config_specCompliantSimulcast1;
                return "Video" === g ? (_f_config_specCompliantSimulcast = f.config.specCompliantSimulcast) === null || _f_config_specCompliantSimulcast === void 0 ? void 0 : _f_config_specCompliantSimulcast.video : "ScreenShare" === g ? (_f_config_specCompliantSimulcast1 = f.config.specCompliantSimulcast) === null || _f_config_specCompliantSimulcast1 === void 0 ? void 0 : _f_config_specCompliantSimulcast1.sharing : null;
            }
            var hy = P, gy = [
                2812,
                4218,
                8437,
                16875,
                33750,
                67500,
                108e3,
                135e3,
                198e3,
                244800,
                27e4,
                352500,
                52e4
            ], py = class {
                setMaxFS(g, f) {
                    return !(this.maxFS === g || (this.maxFS = g, !f)) && (f(this), !0);
                }
                getMaxFS() {
                    return this.maxFS;
                }
                getMaxFPS() {
                    return this.maxFPS;
                }
                getMaxMBPS() {
                    return this.calculateMbps(this.maxFS, this.maxFPS);
                }
                calculateMbps(g, f) {
                    return getClosestValue(gy, g * f / 100, !0);
                }
                resetToInitial() {
                    this.maxFS = this.initialMaxFS, this.maxFPS = this.initialMaxFPS;
                }
                fmtpParams() {
                    return {
                        "max-fs": this.getMaxFS(),
                        "max-mbps": this.getMaxMBPS(),
                        "max-fps": this.getMaxFPS()
                    };
                }
                buildFmtp() {
                    const g = [];
                    let f = this.fmtpParams();
                    return this.h264SubscribeProfile && (f["profile-level-id"] = this.h264SubscribeProfile), g.push(f), this.isAv1Allowed && (f = this.fmtpParams(), f.codec = "AV1", g.push(f)), g;
                }
                constructor(g, f, S, v){
                    this.initialMaxFS = g, this.initialMaxFPS = f, this.isAv1Allowed = S, this.h264SubscribeProfile = v, this.maxFS = g, this.maxFPS = f;
                }
            }, my = class _MediaEntity {
                toString() {
                    var _this_localRecvCapabilities;
                    return `MediaEntity: ${this.entity.modality} \nmid: ${this.entity.mid} localRecvCaps: ${JSON.stringify((_this_localRecvCapabilities = this.localRecvCapabilities) === null || _this_localRecvCapabilities === void 0 ? void 0 : _this_localRecvCapabilities.buildFmtp())}  remoteRecvCaps: ${JSON.stringify(this.remoteRecvCapabilities)}  localSsrc: ${this.getLocalSsrc()} remoteSsrc: ${this.getRemoteSsrc()} localTrackId: ${this.getLocalTrackId()} remoteStreamId: ${this.getRemoteStreamId()} remoteTrackId: ${this.getRemoteTrackId()} xSourceStreamId: ${this.getXSourceStreamId()} subStreamIndex: ${this.getSubstreamIndex()} extensions: ${JSON.stringify(this.entity.extensions)} rtpExt: ${JSON.stringify(this.entity.rtpExt)}         `;
                }
                static getVideoCababilities(g, f, S) {
                    if (g !== Gt.MEDIA_TYPE.video) return null;
                    let v, _;
                    f === Gt.MODALITY.sharing ? (v = S.config.webrtcScreensharingCapabilityMaxFS, _ = S.config.webrtcScreensharingCapabilityMaxFPS) : (v = S.config.webrtcVideoCapabilityMaxFS, _ = S.config.webrtcVideoCapabilityMaxFPS, S.config.useMultiviewLimitsOnInitialRequest && S.config.multiviewResolutionLimits[1] && (v = Zt.Send.getMaxFsForHeight(S.config.multiviewResolutionLimits[1])));
                    const C = S.config.isAv1Allowed && f === Gt.MODALITY.sharing;
                    return new py(v, _, C, S.config.h264SubscribeProfile);
                }
                static create(g, f, S) {
                    const v = getTypeFromModality(f), _ = new _MediaEntity({
                        modality: f,
                        mid: S,
                        mtype: v,
                        extensions: {}
                    }, g);
                    return _.localRecvCapabilities = _MediaEntity.getVideoCababilities(v, f, g), _;
                }
                clone() {
                    const g = new _MediaEntity((0, hy.cloneDeep)(this.entity), this.configProvider);
                    return g.setSimulcastContext(this.simulcastContext), g.localRecvCapabilities = this.localRecvCapabilities, g.remoteRecvCapabilities = this.remoteRecvCapabilities, g.supportedSendProfiles = this.supportedSendProfiles, g;
                }
                getModality() {
                    return this.entity.modality;
                }
                getType() {
                    return this.entity.mtype;
                }
                getMid() {
                    return this.entity.mid;
                }
                disable() {
                    this.entity.mid = null;
                }
                update(g, f) {
                    this.entity.modality !== g && (this.localRecvCapabilities = _MediaEntity.getVideoCababilities(this.entity.mtype, g, this.configProvider)), this.entity.modality = g, this.entity.mid = f, this.isEnabled() && this.setExtension("rollback", !1);
                }
                isDisabled() {
                    return !this.entity.mid;
                }
                isEnabled() {
                    return !!this.entity.mid;
                }
                getLocalRecvCapabilities() {
                    return this.localRecvCapabilities;
                }
                getRemoteRecvCapabilities() {
                    return {
                        sourceId: this.getXSourceStreamId(),
                        capabilities: this.remoteRecvCapabilities ? [
                            this.remoteRecvCapabilities
                        ] : []
                    };
                }
                setRemoteRecvCapabilities(g) {
                    this.remoteRecvCapabilities = g;
                }
                getRemoteStreamId() {
                    return this.entity.remoteStreamId;
                }
                setRemoteStreamId(g) {
                    this.entity.remoteStreamId = g;
                }
                setRemoteSsrc(g) {
                    this.entity.remoteSsrc = g;
                }
                getRemoteSsrc() {
                    return this.entity.remoteSsrc;
                }
                setLocalSsrc(g) {
                    this.entity.localSsrc = g;
                }
                getLocalSsrc() {
                    return this.entity.localSsrc;
                }
                getRemoteTrackId() {
                    return this.entity.remoteTrackId;
                }
                setRemoteTrackId(g) {
                    this.entity.remoteTrackId = g;
                }
                getXSourceStreamId() {
                    return this.entity.xSourceStreamId;
                }
                setXSourceStreamId(g) {
                    this.entity.xSourceStreamId = g;
                }
                setLocalTrackId(g) {
                    this.entity.localTrackId = g;
                }
                getLocalTrackId() {
                    return this.entity.localTrackId;
                }
                setSubStreamIndex(g) {
                    this.entity.subStreamIndex = g;
                }
                getSubstreamIndex() {
                    return this.entity.subStreamIndex;
                }
                getExtension(g) {
                    return this.entity.extensions[g];
                }
                setExtension(g, f) {
                    this.entity.extensions[g] = f;
                }
                getRtpHeaderExtensions() {
                    return this.entity.rtpExt;
                }
                setRtpHeaderExtensions(g) {
                    this.entity.rtpExt = g;
                }
                setSimulcastContext(g) {
                    this.simulcastContext = g;
                }
                getSimulcastContext() {
                    return this.simulcastContext;
                }
                addSupportedSendProfile(g, f) {
                    void 0 === this.supportedSendProfiles[g] && (this.supportedSendProfiles[g] = new Set), this.supportedSendProfiles[g].add(f);
                }
                isSendProfileSupported(g, f) {
                    const S = this.supportedSendProfiles[g];
                    if (void 0 !== S) {
                        const g = f.slice(0, 2);
                        for (const f of S)if (f.startsWith(g)) return !0;
                    }
                    return !1;
                }
                serialize() {
                    return deepClone(this.entity);
                }
                constructor(g, f){
                    this.entity = g, this.configProvider = f, this.supportedSendProfiles = {};
                }
            }, fy = {
                toffset: "toffset",
                "abs-send-time": "abs-send-time",
                "video-orientation": "video-orientation",
                "draft-holmer-rmcat-transport-wide-cc-extensions-01": "transport-cc",
                "video-content-type": "video-content-type",
                "video-timing": "video-timing",
                "color-space": "color-space",
                "video-layers-allocation00": "vla",
                "video-layers-allocation00-non-advertised": "non-adv-vla",
                mid: "mid",
                "rtp-stream-id": "rid",
                "repaired-rtp-stream-id": "rrid",
                "fast_bandwidth_feedback#version_3": "fast_bandwidth_feedback#version_3",
                "frame-counters-gvc": "frame-counters-gvc"
            }, Sy = class {
                fromOffer(g, f, S = !1) {
                    this.logger.safe.debug(`fromOffer, modalities: ${JSON.stringify(f)} disableOnly: ${S}`), this.updateMediaEntitiesFromModel(g, S), this.updateSharingEntity(!!f.sharing), g.media.forEach((g)=>{
                        this.logger.safe.debug(`Media entity for mid: ${g.mid}, ${this.getMediaEntityByMid(g.mid)}`);
                        const f = this.getMediaEntityByMid(g.mid);
                        f && this.saveLocalSsrc(f, g);
                    });
                }
                fromRemote(g, f) {
                    const S = 0 === this.mediaEntities.length;
                    this.updateMediaEntitiesFromModel(g, !1, f), g.media.forEach((g, f)=>{
                        const S = this.getMediaEntityByMid(g.mid);
                        S && (this.saveRemoteMsid(S, g), this.saveRemoteSsrc(S, g), this.saveRtpHeaderExtensions(S, g), S.setXSourceStreamId(g.xSourceStreamId || this.generateSourceStreamId(f)), S.setRemoteRecvCapabilities(getRecvCapabilitiesForMedia(g)), S.setSubStreamIndex(g.subStreamIndex)), this.logger.safe.debug(`Media entity for mid: ${g.mid}, ${S}`);
                    }), S && this.updateReinvitelessState(g);
                }
                isEmpty() {
                    return 0 === this.mediaEntities.length;
                }
                createMediaEntity(g, f) {
                    const S = my.create(this.configProvider, g, f);
                    return this.logger.safe.debug(`Creating media entity for modality: ${g}, mid: ${f}`), this.context.useSimulcast && !this.mediaEntities.find((f)=>f.getModality() === g) && this.setSimulcastContext(S), S.setExtension("reinviteless", !1), this.mediaEntities.push(S), S;
                }
                getMediaEntities() {
                    return this.mediaEntities;
                }
                getMediaEntity(g) {
                    return this.mediaEntities[g];
                }
                getMediaEntityByMid(g) {
                    return this.mediaEntities.find((f)=>f.getMid() === g);
                }
                getMediaEntitiesByModality(g) {
                    return this.mediaEntities.filter((f)=>f.getModality() === g);
                }
                getMediaEntitiesByMediaType(g) {
                    const f = modalityToMediaType(g);
                    return this.getMediaEntitiesByModality(f);
                }
                getMediaEntityByRemoteStreamId(g) {
                    return this.mediaEntities.find((f)=>f.getRemoteStreamId() === g);
                }
                getMediaEntityByLocalTrackId(g) {
                    return this.mediaEntities.find((f)=>f.getLocalTrackId() === g);
                }
                getMediaEntityByXSourceStreamId(g) {
                    return this.mediaEntities.find((f)=>f.getXSourceStreamId() === g);
                }
                reset() {
                    this.mediaEntities = [], this.rollbackHandlers = [];
                }
                syncModalities(g, f, S = !1) {
                    this.logger.safe.debug(`syncModalities, modalities: ${JSON.stringify(f)}, disableOnly: ${S},`), this.fromOffer(g, f, S);
                }
                setLocalTracksInfo(g) {
                    this.mediaTracks = g;
                }
                getLocalTracksInfo() {
                    return this.mediaTracks;
                }
                backup() {
                    this.logger.safe.debug("backup"), this.mediaEntitiesBackup = [], this.mediaEntities.forEach((g)=>{
                        this.mediaEntitiesBackup.push(g.clone());
                    });
                }
                commit() {
                    this.mediaEntitiesBackup = [], this.mediaEntities.forEach((g)=>{
                        g.setExtension("unnegotiatedModality", !1);
                    });
                }
                rollback() {
                    this.logger.safe.debug(`rollback, if backup exists: ${!!this.mediaEntitiesBackup.length}`), this.mediaEntitiesBackup.length && (this.rollbackHandlers.forEach((g)=>g(this.mediaEntities, this.mediaEntitiesBackup)), this.mediaEntities.forEach((g, f)=>{
                        this.mediaEntitiesBackup[f] ? this.mediaEntities[f] = this.mediaEntitiesBackup[f] : (g.disable(), g.setExtension("rollback", !0));
                    }));
                }
                updateMediaEntitiesWithLocalTracks() {
                    this.mediaTracks ? (this.mediaEntities.forEach((g)=>g.setLocalTrackId(null)), this.mediaTracks.forEach((g)=>{
                        const f = this.getMediaEntitiesByModality(g.modality)[0];
                        f ? (this.logger.safe.debug(`Setting local track id ${g.trackId} for modality ${g.modality}`), f.setLocalTrackId(g.trackId)) : this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(g.modality)}`);
                    })) : this.logger.safe.debug("No mediaTracks, not updating local tracks for media entities");
                }
                updateMediaEntitiesWithActivityState(g, f) {
                    this.logger.safe.debug(`Updating activity indexes for ${g} to ${JSON.stringify(f)}`);
                    const S = mediaTypeToModality(g), v = this.getMediaEntitiesByModality(S)[0];
                    if (!v) return void this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(S)}`);
                    const _ = v.getSimulcastContext();
                    _ && (_.activeRids = f);
                }
                setRollbackUpdateHandler(g) {
                    this.rollbackHandlers.push(g);
                }
                saveRtpHeaderExtensions(g, f) {
                    var _f_ext;
                    if (g.isDisabled()) return void g.setRtpHeaderExtensions(void 0);
                    const S = (_f_ext = f.ext) === null || _f_ext === void 0 ? void 0 : _f_ext.map((g)=>this.getHeaderExtension(g));
                    this.logger.safe.debug(`RTP header ext for mid=${f.mid}, modality=${g.getModality()}: ${JSON.stringify(S)}`), g.setRtpHeaderExtensions(S);
                }
                getHeaderExtension(g) {
                    let f = "unknown";
                    for (const [S, v] of Object.entries(fy))if (g.uri.endsWith(S)) {
                        f = v;
                        break;
                    }
                    return {
                        headerType: f,
                        value: g.value
                    };
                }
                saveRemoteMsid(g, f) {
                    if (isMediaDisabled(f)) g.setRemoteStreamId(null);
                    else if (f.msid) g.setRemoteStreamId(f.msid.split(" ")[0]);
                    else if (f.ssrcs) {
                        const S = f.ssrcs.find((g)=>"msid" === g.attribute);
                        S ? g.setRemoteStreamId(S.value.split(" ")[0]) : this.logger.safe.warn(`No ssrc msid for media of type ${f.type} with mid ${f.mid}`);
                    }
                }
                saveRemoteSsrc(g, f) {
                    var _f_ssrcs;
                    if ((_f_ssrcs = f.ssrcs) === null || _f_ssrcs === void 0 ? void 0 : _f_ssrcs.length) {
                        const S = f.ssrcs[0];
                        g.setRemoteSsrc(+S.id);
                    }
                }
                saveLocalSsrc(g, f) {
                    var _f_ssrcs_, _f_ssrcs;
                    const S = (_f_ssrcs = f.ssrcs) === null || _f_ssrcs === void 0 ? void 0 : (_f_ssrcs_ = _f_ssrcs[0]) === null || _f_ssrcs_ === void 0 ? void 0 : _f_ssrcs_.id;
                    if (!hasSendDirectionality(f.direction)) return this.logger.safe.debug(`set local SSRC to ${S}`), void g.setLocalSsrc(+S);
                    this.logger.safe.debug("has no send direction");
                    const v = S || g.getLocalSsrc() || this.ssrcGenerator.nextVideoStreamSsrc().min;
                    g.setLocalSsrc(+v);
                }
                updateMediaEntitiesFromModel(g, f, S) {
                    g.media.forEach((g, v)=>{
                        if (this.mediaEntities[v]) {
                            if (isMediaDisabled(g)) this.logger.safe.debug(`Disabling media entity for mid: ${g.mid}`), this.mediaEntities[v].disable();
                            else {
                                const f = g.mid || this.mediaEntities[v].getMid(), S = this.mediaEntities[v].getModality();
                                this.logger.safe.debug(`Updating media entity for mid: ${f}, modality: ${S}`), this.mediaEntities[v].update(S, f), this.logger.safe.debug(`updated entity: ${this.mediaEntities[v]}`);
                            }
                        } else f || this.createMediaEntity(getModality(g), g.mid || v.toString());
                        this.mediaEntities[v] && S && !(this.mediaEntities[v].getModality() in S) && (this.logger.safe.debug(`Disabling media entity for mid: ${g.mid} as it is not found in modalities ${JSON.stringify(S)}`), this.mediaEntities[v].disable());
                    });
                }
                updateSharingEntity(g) {
                    if (g && !this.getMediaEntitiesByModality(Gt.MODALITY.sharing).length) {
                        const g = this.getMediaEntitiesByModality(Gt.MODALITY.video).pop();
                        g.update(Gt.MODALITY.sharing, g.getMid());
                    }
                }
                setSimulcastContext(g) {
                    if (!g || g.getSimulcastContext()) return;
                    const f = new uy(g, this.logger.createChild(`SimContext:${g.getModality()}`), this.configProvider);
                    g.setSimulcastContext(f);
                }
                generateSourceStreamId(g) {
                    return g + 10;
                }
                updateReinvitelessState(g) {
                    const f = {
                        [Gt.MODALITY.audio]: 0,
                        [Gt.MODALITY.video]: 0,
                        [Gt.MODALITY.sharing]: 0
                    };
                    for (const S of g.media){
                        const g = getModality(S);
                        void 0 !== f[g] && f[g]++;
                        const v = this.getMediaEntityByMid(S.mid);
                        if (v) {
                            var _this_context_reinviteltessContext;
                            const _ = ((_this_context_reinviteltessContext = this.context.reinviteltessContext) === null || _this_context_reinviteltessContext === void 0 ? void 0 : _this_context_reinviteltessContext.maxStreamsForModality[g]) >= (f === null || f === void 0 ? void 0 : f[g]) && (!S.direction || "sendrecv" === S.direction);
                            v.setExtension("reinviteless", _);
                        }
                    }
                }
                constructor(g){
                    this.context = g, this.mediaEntities = [], this.mediaEntitiesBackup = [], this.mediaTracks = [], this.ssrcGenerator = new cy, this.rollbackHandlers = [], this.logger = g.logger.createChild("MM2"), this.configProvider = g.configProvider;
                }
            }, vy = class {
                modify(g) {
                    for (const f of this.modifierList)f.modify(g);
                }
                constructor(g){
                    this.modifierList = g;
                }
            }, _y = class {
                build(g) {
                    switch(g.sdpSource){
                        case 0:
                            return new vy([
                                new uE(this.context.configProvider),
                                new jy(this.context.configProvider),
                                new EE(this.mediaManager, this.context.configProvider),
                                new yE(this.mediaManager),
                                new Zy(this.context.configProvider),
                                new Jy(this.context.configProvider),
                                new dE(this.context.configProvider, this.mediaManager, g.sdpType, !1, this.context.getLogger().createChild("OverrideH264SendProfile")),
                                new Wy(this.mediaManager, this.context.configProvider, g.sdpType),
                                new qy(this.mediaManager, this.context.configProvider, this.context.config.isConference, !1),
                                new DE(this.context.configProvider, g.sdpType),
                                new sE(this.context.configProvider)
                            ]);
                        case 2:
                            return new vy([
                                new by(this.mediaManager, this.modalities),
                                new Gy,
                                new Ay(this.mediaManager, !0),
                                new mE(this.context.configProvider, this.mediaManager),
                                new Ny(this.modalities, this.mediaManager),
                                new iE,
                                new Xy,
                                new eE,
                                new tE(this.context.configProvider),
                                new Qy(this.context.configProvider),
                                new cE(this.context.configProvider),
                                new dE(this.context.configProvider, this.mediaManager, g.sdpType, !0, this.context.getLogger().createChild("OverrideH264SendProfile")),
                                new Ly,
                                new Ey(this.context),
                                new _E(this.mediaManager, this.context.configProvider),
                                new $y(this.context.configProvider),
                                new RE,
                                new AE(this.context.configProvider),
                                new TE(this.context.configProvider),
                                new Uy(this.mediaManager, this.modalities, this.context.configProvider),
                                new Dy(this.context),
                                new PE(this.context.configProvider),
                                new My(this.context.configProvider),
                                new Wy(this.mediaManager, this.context.configProvider, g.sdpType),
                                new zy(this.mediaManager, this.context.configProvider, g.sdpType),
                                new qy(this.mediaManager, this.context.configProvider, this.context.config.isConference, !0),
                                new rE(this.context.configProvider, this.context.getLogger()),
                                new xy,
                                new ME(this.context.configProvider),
                                new sE(this.context.configProvider),
                                new NE(g, this.context),
                                new SE(this.context.configProvider),
                                new gE(this.context.configProvider)
                            ]);
                        case 1:
                            return new vy([
                                new Py(this.context, this.modalities.data),
                                new Ay(this.mediaManager, !1),
                                new Vy(this.context.configProvider),
                                new by(this.mediaManager, this.modalities),
                                new Fy(this.mediaManager),
                                new Xy,
                                new Yy(this.context.configProvider),
                                new Ty(this.mediaManager, "offer" === g.sdpType, this.context.configProvider),
                                new CE(this.mediaManager, this.context.getLogger()),
                                new bE(this.context.configProvider, this.mediaManager),
                                new ky(this.context.config.isConference, this.cname),
                                new By(this.mediaManager),
                                new Hy,
                                new hE(this.context.configProvider),
                                new Oy(this.context.configProvider),
                                new wE(this.context.configProvider),
                                new OE(this.context.configProvider),
                                new zy(this.mediaManager, this.context.configProvider, g.sdpType),
                                new lE(this.mediaManager, this.context.configProvider, g.sdpType),
                                new gE(this.context.configProvider)
                            ]);
                    }
                }
                constructor(g, f, S, v){
                    this.context = g, this.mediaManager = f, this.modalities = S, this.cname = v;
                }
            }, Cy = class {
                modify(g) {
                    this.msSdpT.toMsSdp(g, this.sessionType);
                }
                constructor(g, f, S){
                    this.context = g, this.mediaManager = f, this.sessionType = S, this.msSdpT = new oy(this.context, this.mediaManager);
                }
            }, yy = class {
                modify(g) {
                    this.msSdpT.fromMsSdp(g, this.sessionType);
                }
                constructor(g, f, S){
                    this.context = g, this.mediaManager = f, this.sessionType = S, this.msSdpT = new oy(this.context, this.mediaManager);
                }
            }, Ey = class {
                modify(g) {
                    const f = preferSdesSrtp(this.context.configProvider, this.context.config.isPstnCall), S = getSrtpInfo(g), v = g.media.find((g)=>!!g.crypto);
                    g.media.forEach((g)=>{
                        g.type !== Gt.MEDIA_TYPE.dataChannel && (!f && g.fingerprint && g.crypto && delete g.crypto, g.protocol = !S.dtls || S.sdes && f ? Gt.PROFILES.rtpSavpf : Gt.PROFILES.udpTlsRtpSavpf, isMediaDisabled(g) && g.protocol === Gt.PROFILES.rtpSavpf && v && (g.crypto = v.crypto));
                    });
                }
                constructor(g){
                    this.context = g;
                }
            }, Ty = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        const S = g.setup, v = this.mediaManager.getMediaEntities()[f], _ = v.getExtension("setup");
                        S && v.isEnabled() && ("actpass" !== S ? v.setExtension("setup", S) : this.isOffer && void 0 !== _ && "actpass" !== _ && !this.configProvider.config.disableOutgoingDtlsRoleOverride && (g.setup = _));
                    });
                }
                constructor(g, f, S){
                    this.mediaManager = g, this.isOffer = f, this.configProvider = S;
                }
            }, Iy = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        g.direction === Gt.MEDIA_STATE.sendReceive && (g.direction = Gt.MEDIA_STATE.receive), g.direction === Gt.MEDIA_STATE.send && (g.direction = Gt.MEDIA_STATE.inactive);
                    });
                }
            }, by = class {
                modify(g) {
                    let f = 0;
                    g.media.forEach((g, S)=>{
                        const v = parseInt(g.mid, 10);
                        !isNaN(v) && v >= f && (f = v + 1);
                    }), g.media.forEach((S, v)=>{
                        const _ = this.mediaManager.getMediaEntities()[v];
                        if (isMediaDisabled(S) || _.isDisabled() || !(_.getModality() in this.modalities)) {
                            const C = _.getExtension("midApplied") ? void 0 : S.mid || "" + f++;
                            0 === v ? S.direction = Gt.MEDIA_STATE.inactive : g.media[v] = disabledMedia(S.type, void 0, S.protocol, C);
                        }
                    });
                }
                constructor(g, f){
                    this.mediaManager = g, this.modalities = f;
                }
            }, Ay = class {
                modify(g) {
                    const f = this.mediaManager.getMediaEntities();
                    for(let S = 0; S < f.length; S++){
                        const v = f[S], _ = g.media[S];
                        if (v.getExtension("rollback")) {
                            if (_ && !this.remote) g.media[S] = null;
                            else if (!_ && this.remote) {
                                const f = v.getType() === Gt.MEDIA_TYPE.data ? Gt.MEDIA_TYPE.dataChannel : v.getType(), S = f === Gt.MEDIA_TYPE.dataChannel ? Gt.PROFILES.udpDtlsSctp : Gt.PROFILES.udpTlsRtpSavpf;
                                g.media.push(disabledMedia(f, void 0, S, void 0));
                            }
                        }
                    }
                    g.media = g.media.filter((g)=>g);
                }
                constructor(g, f){
                    this.mediaManager = g, this.remote = f;
                }
            }, Ry = class {
                modify(g) {
                    this.mediaManager.getMediaEntities().forEach((f, S)=>{
                        const v = g.media[S];
                        f.getModality() !== Gt.MODALITY.data || v && v.type === Gt.MEDIA_TYPE.dataChannel || g.media.splice(S, 0, disabledMedia(Gt.MEDIA_TYPE.data, Gt.MEDIA_LABEL.data, Gt.PROFILES.rtpSavp, void 0));
                    });
                }
                constructor(g){
                    this.mediaManager = g;
                }
            }, Py = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        g.type === Gt.MEDIA_TYPE.dataChannel && (g.type = Gt.MEDIA_TYPE.data, g.payloads = Gt.PAYLOAD_TYPE.X_DATA);
                    }), allowDataChannel(this.context) && getEnabledMedia(g, Gt.MEDIA_TYPE.data).forEach((f)=>{
                        f.rtp = f.rtp || [], f.fmtp = f.fmtp || [], f.rtp.push({
                            codec: "x-data",
                            payload: 127,
                            rate: 9e4
                        }), f.rtp.push({
                            codec: "rtx",
                            payload: 126,
                            rate: 9e4
                        }), f.fmtp.push({
                            payload: 126,
                            config: "apt=127"
                        });
                        const S = this.getNonOverlappingSsrc(g);
                        f.xSsrcRange = {
                            ssrcMin: S,
                            ssrcMax: S
                        }, f.rtcpMux = "rtcp-mux", f.xDataProtocol = "sctp", f.direction = this.direction;
                    });
                }
                getNonOverlappingSsrc(g) {
                    let f, S = !0;
                    do f = Math.floor(4294967293 * Math.random()) + 2, getEnabledMedia(g).forEach((g)=>{
                        var _g_ssrcs_, _g_ssrcs;
                        (g === null || g === void 0 ? void 0 : (_g_ssrcs = g.ssrcs) === null || _g_ssrcs === void 0 ? void 0 : (_g_ssrcs_ = _g_ssrcs[0]) === null || _g_ssrcs_ === void 0 ? void 0 : _g_ssrcs_.id) === f && (S = !1);
                    });
                    while (!S);
                    return f;
                }
                constructor(g, f){
                    this.context = g, this.direction = f;
                }
            }, wy = class {
                modify(g) {
                    if (this.configProvider.config.enableVideoOrientationExtension) for (const f of getEnabledMedia(g, Gt.MEDIA_TYPE.video))this.modifyMedia(f);
                }
                constructor(g){
                    this.configProvider = g, this.uri = "urn:3gpp:video-orientation", this.value = 13;
                }
            }, My = class extends wy {
                modifyMedia(g) {
                    var _g_ext;
                    (_g_ext = g.ext) !== null && _g_ext !== void 0 ? _g_ext : g.ext = [];
                    g.ext.some((g)=>g.uri === this.uri) || g.ext.push({
                        value: this.getAvailableValue(g.ext),
                        uri: this.uri
                    });
                }
                getAvailableValue(g) {
                    const f = g.map((g)=>g.value);
                    return f.includes(this.value) ? Math.max(...f) + 1 : this.value;
                }
            }, Oy = class extends wy {
                modifyMedia(g) {
                    var _g_ext;
                    g.ext = (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.filter((g)=>g.uri !== this.uri);
                }
            }, Dy = class {
                modify(g) {
                    var _g_groups;
                    const f = (_g_groups = g.groups) === null || _g_groups === void 0 ? void 0 : _g_groups.find((g)=>"BUNDLE" === g.type);
                    for(let S = g.media.length - 1; S >= 0; S--){
                        const v = g.media[S];
                        if (v.type === Gt.MEDIA_TYPE.data) {
                            var _f_mids;
                            const _ = this.context.configProvider.config.rejectUnbundledDataModality && !this.context.configProvider.mediaConfig.isTransportUnbundled && !(f === null || f === void 0 ? void 0 : (_f_mids = f.mids) === null || _f_mids === void 0 ? void 0 : _f_mids.toString().includes(v.mid)), C = allowDataChannel(this.context);
                            var _v_sctpPort;
                            C || this.context.configProvider.config.acceptDisabledDataModality ? (v.port = C && !_ ? v.port : 0, v.payloads = Gt.PAYLOAD_TYPE.DATA_CHANNEL, v.type = Gt.MEDIA_TYPE.dataChannel, v.protocol = Gt.PROFILES.udpDtlsSctp, (_v_sctpPort = v.sctpPort) !== null && _v_sctpPort !== void 0 ? _v_sctpPort : v.sctpPort = this.context.configProvider.config.sctpPort, delete v.xDataProtocol, delete v.rtp, delete v.fmtp, delete v.rtcp, delete v.rtcpMux, delete v.ext, delete v.ssrcs, delete v.ssrcGroups, delete v.xSsrcRange) : g.media.splice(S, 1);
                        }
                    }
                }
                constructor(g){
                    this.context = g;
                }
            }, Ny = class {
                modify(g) {
                    getEnabledMedia(g).forEach((g)=>{
                        const f = getModality(g), S = this.mediaManager.getMediaEntityByMid(g.mid);
                        !(this.modalities[f] !== Gt.MEDIA_STATE.send || S.getExtension("reinviteless") || g.direction && g.direction.toLowerCase() === Gt.MEDIA_STATE.receive) && (g.direction = Gt.MEDIA_STATE.receive);
                    });
                }
                constructor(g, f){
                    this.modalities = g, this.mediaManager = f;
                }
            }, ky = class {
                modify(g) {
                    this.isMultiparty && getEnabledMedia(g).forEach((g)=>{
                        var _g_ssrcs;
                        const f = g.direction;
                        f !== Gt.MEDIA_STATE.receive && f !== Gt.MEDIA_STATE.inactive || (((_g_ssrcs = g.ssrcs) === null || _g_ssrcs === void 0 ? void 0 : _g_ssrcs[0]) ? g.ssrcs = [
                            {
                                id: g.ssrcs[0].id,
                                attribute: "cname",
                                value: this.cname
                            }
                        ] : g.type === Gt.MEDIA_TYPE.audio ? g.ssrcs = [
                            {
                                id: 4195875351,
                                attribute: "cname",
                                value: this.cname
                            }
                        ] : g.type === Gt.MEDIA_TYPE.video && (g.ssrcs = [
                            {
                                id: 1,
                                attribute: "cname",
                                value: this.cname
                            }
                        ]));
                    });
                }
                constructor(g, f){
                    this.isMultiparty = g, this.cname = f;
                }
            }, Ly = class {
                modify(g) {
                    const f = new Set;
                    getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        g.ssrcs && g.ssrcs.length > 1 && f.add(+g.ssrcs[0].id);
                    });
                    const S = getEnabledMedia(g, Gt.MEDIA_TYPE.video).find((g)=>g.direction === Gt.MEDIA_STATE.sendReceive || g.direction === Gt.MEDIA_STATE.send);
                    getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        const v = g.direction;
                        if ((v === Gt.MEDIA_STATE.receive || v === Gt.MEDIA_STATE.inactive) && g.ssrcs && 1 === g.ssrcs.length) {
                            const v = g.ssrcs[0].id;
                            (1 === v || S && S.ssrcs[0].id === v || !S && f.has(v)) && (delete g.ssrcs, delete g.ssrcGroups);
                        }
                    });
                }
            }, Fy = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        const S = this.mediaManager.getMediaEntities()[f];
                        g.label = getLabelForModality(S.getModality());
                    });
                }
                constructor(g){
                    this.mediaManager = g;
                }
            }, xy = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        delete g.label;
                    });
                }
            }, Uy = class {
                modify(g) {
                    var _g_bandwidth;
                    let f = this.configProvider.mediaConfig.maxBandwidthInKbps;
                    const S = (_g_bandwidth = g.bandwidth) === null || _g_bandwidth === void 0 ? void 0 : _g_bandwidth.find((g)=>"CT" === g.type);
                    S && (!f || f > +S.limit) && (f = +S.limit);
                    const v = this.configProvider.config.audioBandwidthInKbps || 0, _ = Math.max(f - v, 0), C = this.configProvider.config.videoBandwidthAllocation && hasSendDirectionality(this.modalities.video) && hasSendDirectionality(this.modalities.sharing);
                    getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        if (delete g.bandwidth, _) {
                            let f = _;
                            if (C) {
                                const S = this.mediaManager.getMediaEntityByMid(g.mid).getModality() === Gt.MODALITY.video ? this.configProvider.config.videoBandwidthAllocation : 1 - this.configProvider.config.videoBandwidthAllocation;
                                f = Math.round(_ * S);
                            }
                            g.bandwidth = [
                                {
                                    limit: f,
                                    type: "AS"
                                }
                            ];
                        }
                    });
                }
                constructor(g, f, S){
                    this.mediaManager = g, this.modalities = f, this.configProvider = S;
                }
            }, Vy = class {
                modify(g) {
                    const f = this.configProvider.mediaConfig.maxBandwidthInKbps;
                    f && (g.bandwidth = [
                        {
                            limit: f,
                            type: "CT"
                        }
                    ]);
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, By = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        const S = this.mediaManager.getMediaEntities()[f], v = S.getExtension("iceUfrag");
                        S.setExtension("iceRestart", !!g.iceUfrag && !!v && v !== g.iceUfrag), S.setExtension("iceUfrag", g.iceUfrag);
                    });
                }
                constructor(g){
                    this.mediaManager = g;
                }
            }, Hy = class {
                modify(g) {
                    const f = new Set([
                        "urn:ietf:params:rtp-hdrext:csrc-audio-level",
                        "http://www.webrtc.org/experiments/rtp-hdrext/playout-delay"
                    ]);
                    getEnabledMedia(g).forEach((g)=>{
                        g.ext && (g.ext = g.ext.filter((g)=>!f.has(g.uri)));
                    });
                }
            }, $y = class {
                modify(g) {
                    this.configProvider.config.extmapAllowMixed && (g.extmapAllowMixed = "extmap-allow-mixed");
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, jy = class {
                modify(g) {
                    this.configProvider.config.extmapAllowMixed || delete g.extmapAllowMixed;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, Gy = class {
                modify(g) {
                    getEnabledMedia(g).forEach((g)=>{
                        delete g.signalingFbXMessage;
                    });
                }
            }, qy = class {
                modify(g) {
                    if (this.configProvider.config.isAv1Allowed && this.isConference) {
                        const f = findAllAvailablePayloads(g, [
                            96,
                            127
                        ]);
                        this.mediaManager.getMediaEntities().forEach((S, v)=>{
                            let _ = 0;
                            const C = g.media[v];
                            if (S.getModality() !== Gt.MODALITY.audio) {
                                if (!this.remote) {
                                    const g = changeCodecPayload(C, {
                                        codec: "AV1",
                                        rate: 9e4
                                    }, f, !0, _);
                                    _ = f.length - 1, g.forEach((g)=>{
                                        changeCodecPayload(C, {
                                            codec: "rtx",
                                            rate: 9e4,
                                            payload: g + 1
                                        }, f, !1, _), _--;
                                    });
                                }
                                this.remote && this.configProvider.config.av1LevelIndex && forAllCodecs(C, {
                                    codec: "AV1",
                                    rate: 9e4
                                }, (g)=>{
                                    const replaceLevelIdx = (g, f)=>g.replace(/level-idx=\d+((\.\d+)+)?/g, `level-idx=${f}`);
                                    g.fmtp.config = replaceLevelIdx(g.fmtp.config, this.configProvider.config.av1LevelIndex);
                                });
                            }
                        });
                    }
                }
                constructor(g, f, S, v){
                    this.mediaManager = g, this.configProvider = f, this.isConference = S, this.remote = v;
                }
            }, Wy = class {
                modify(g) {
                    this.configProvider.config.filterCodecsInSdpV2 || this.baseModifier.modify(g);
                }
                constructor(g, f, S){
                    this.mediaManager = g, this.configProvider = f, this.sdpType = S, this.baseModifier = new Ky(this.mediaManager, this.configProvider, this.sdpType, !1);
                }
            }, zy = class {
                modify(g) {
                    this.configProvider.config.filterCodecsInSdpV2 && this.baseModifier.modify(g);
                }
                constructor(g, f, S){
                    this.mediaManager = g, this.configProvider = f, this.sdpType = S, this.baseModifier = new Ky(this.mediaManager, this.configProvider, this.sdpType, !0);
                }
            }, Ky = class {
                modify(g) {
                    this.configProvider.config.filterCodecsInSdp && "offer" === this.sdpType && this.mediaManager.getMediaEntities().forEach((f, S)=>{
                        const v = g.media[S];
                        if (!v) return;
                        const _ = getAllowedCodecs(this.configProvider, v.type);
                        if (!_.length) return;
                        filterCodecs(v, convertToCodecInfo(_), !!f.getExtension("unnegotiatedModality") || this.alwaysReorder, null);
                    });
                }
                constructor(g, f, S, v = !1){
                    this.mediaManager = g, this.configProvider = f, this.sdpType = S, this.alwaysReorder = v;
                }
            }, Jy = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = this.configProvider.mediaConfig.audioCodecContext;
                    f && S && (S.codec !== S.lastUsedCodec && "None" !== S.lastUsedCodec && this.removeSubstitutionCodecIfNeeded(f, S.lastUsedCodec), S.enabledLocally && !S.disabledRemotely && this.addSubstitutionCodecIfNeeded(f, S.codec, g));
                }
                addSubstitutionCodecIfNeeded(g, f, S) {
                    if (this.isSubstitutionCodecAdded(g, f)) return;
                    const v = findAvailablePayload(S);
                    if (-1 === v) return;
                    const _ = getCustomCodecParams(f, "SUBSTITUTION");
                    changePayloadType(S, _.payload, v), addCodec(g, _);
                }
                removeSubstitutionCodecIfNeeded(g, f) {
                    removeCodec(g, getCustomCodecParams(f, "SUBSTITUTION"));
                }
                isSubstitutionCodecAdded(g, f) {
                    let S = !1;
                    return forOneCodec(g, getCustomCodecParams(f, "SUBSTITUTION"), ()=>{
                        S = !0;
                    }), S;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, Yy = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = this.configProvider.mediaConfig.audioCodecContext;
                    if (f && S && S.enabledLocally && !S.disabledRemotely) {
                        const g = getCustomCodecParams(S.codec, "SUBSTITUTION"), v = getCustomCodecParams(S.codec, "CODEC");
                        forOneCodec(f, g, (g)=>{
                            g.rtp.codec = v.codec, g.rtp.rate = v.rate, g.rtp.encoding = v.encoding, "SatinFB" === S.codec && (g.fmtp = {
                                payload: v.payload,
                                config: "decoderversion=1"
                            });
                        });
                    }
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, Qy = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = this.configProvider.mediaConfig.audioCodecContext;
                    if (!f || !(S === null || S === void 0 ? void 0 : S.enabledLocally)) return;
                    const v = getCustomCodecParams(S.codec, "CODEC"), _ = getCustomCodecParams(S.codec, "SUBSTITUTION");
                    let C = !1;
                    forOneCodec(f, v, (g)=>{
                        S.enabledForSend && (g.rtp.codec = _.codec, g.rtp.rate = _.rate, g.rtp.encoding = _.encoding, g.fmtp = {
                            payload: v.payload,
                            config: "ptime=20"
                        }), C = !0;
                    }), S.disabledRemotely = !C;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, Xy = class {
                modify(g) {
                    removeCodec(g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), {
                        codec: "CN",
                        rate: 16e3
                    });
                }
            }, Zy = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = this.configProvider.mediaConfig.audioCodecContext;
                    if (this.configProvider.config.fixOpusComfortNoise) {
                        if (!f || S && (!S.enabledLocally || S.disabledRemotely)) return;
                    } else if (!f || !(S === null || S === void 0 ? void 0 : S.enabledLocally) || S.disabledRemotely) return;
                    let v = !1;
                    const _ = {
                        codec: "CN",
                        rate: 48e3
                    };
                    if (forOneCodec(f, _, ()=>{
                        v = !0;
                    }), v) return;
                    const C = findAvailablePayload(g);
                    -1 !== C && (this.configProvider.config.fixOpusComfortNoise ? _.payload = C : (changePayloadType(g, Gt.PAYLOAD_TYPE.MSRTC_CNFB, C), _.payload = Gt.PAYLOAD_TYPE.MSRTC_CNFB), addCodec(f, _));
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, eE = class {
                modify(g) {
                    removeCodec(g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), {
                        codec: "g722",
                        rate: 8e3,
                        encoding: 2
                    });
                }
            }, tE = class {
                modify(g) {
                    const f = this.configProvider.config.enforceOpusFmtp;
                    if (f) forOneCodec(g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), {
                        codec: "opus",
                        rate: 48e3,
                        encoding: 2
                    }, (g)=>{
                        g.fmtp || (g.fmtp = {
                            payload: g.rtp.payload
                        });
                        const S = new QC(g.fmtp.config);
                        Object.keys(f).forEach((g)=>{
                            S.removeIfPresent(g), S.setIfMissing(g, `${f[g]}`);
                        }), g.fmtp.config = S.toString();
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, iE = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio);
                    if (f && isMediaDisabled(f)) {
                        const S = g.media.find((g)=>!!g.iceUfrag);
                        S && (f.port = 9, f.direction = "inactive", f.iceUfrag = S.iceUfrag, f.icePwd = S.icePwd, f.rtcpMux = "rtcp-mux", S.crypto && (f.crypto = S.crypto), S.fingerprint && (f.fingerprint = S.fingerprint, f.setup = S.setup), f.rtp = [
                            {
                                payload: 0,
                                codec: "PCMU",
                                rate: 8e3
                            }
                        ], f.payloads = "0");
                    }
                }
            }, nE = class {
                modify(g) {
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = [
                        "cn",
                        "telephone-event"
                    ], v = f.rtp.filter((g)=>-1 !== this.otherPartyCodecs.indexOf(g.codec.toLowerCase()) && -1 === S.indexOf(g.codec.toLowerCase()));
                    if (0 === v.length) throw new Error("there is no matching primary audio codec");
                    f.rtp.filter((g)=>g !== v[0] && -1 === S.indexOf(g.codec.toLowerCase())).forEach((g)=>{
                        removeCodec(f, g);
                    });
                }
                constructor(g){
                    this.otherPartyCodecs = g;
                }
            }, rE = class {
                modify(g) {
                    this.configProvider.config.webrtcInjectTransportCCAudio && getEnabledMedia(g, Gt.MEDIA_TYPE.audio).forEach((g)=>{
                        var _g_ext, _g_rtp, _g_rtcpFb;
                        const f = (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.find((g)=>g.uri === Gt.TRANSPORT_CC.EXT_URI);
                        if (!f) return void this.logger.safe.info("transport-cc ext not present in sdp, skipping injecting transport-cc attribute for audio");
                        const S = (_g_rtp = g.rtp) === null || _g_rtp === void 0 ? void 0 : _g_rtp.find((g)=>"opus" === g.codec.toLowerCase());
                        if (!S) return void this.logger.safe.info("opus codec not found, skipping injecting transport-cc attribute for audio");
                        const v = S.payload, _ = (_g_rtcpFb = g.rtcpFb) === null || _g_rtcpFb === void 0 ? void 0 : _g_rtcpFb.find((g)=>g.type === Gt.TRANSPORT_CC.ATTRIBUTE && g.payload === v);
                        _ ? this.logger.safe.info("opus codec already has transport-cc attribute") : (g.rtcpFb = g.rtcpFb || [], g.rtcpFb.push({
                            payload: v,
                            type: Gt.TRANSPORT_CC.ATTRIBUTE
                        }), this.logger.safe.info("injected transport-cc attribute"));
                    });
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f;
                }
            }, aE = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        if (isMediaDisabled(g) || g.type !== Gt.MEDIA_TYPE.video) return;
                        const S = this.mediaManager.getMediaEntities()[f];
                        forOneCodec(g, {
                            codec: "h264",
                            rate: 9e4
                        }, (g)=>{
                            const f = S.getLocalRecvCapabilities();
                            if (!f) return;
                            g.fmtp || (g.fmtp = {
                                payload: g.rtp.payload
                            });
                            const v = new QC(g.fmtp.config);
                            this.configProvider.config.h264SdpProfile ? (v.removeIfPresent("profile-level-id"), v.setIfMissing("profile-level-id", this.configProvider.config.h264SdpProfile)) : v.setIfMissing("profile-level-id", "42C02A"), v.setIfMissing("max-fs", f.getMaxFS().toString()), v.setIfMissing("max-mbps", f.getMaxMBPS().toString()), v.setIfMissing("max-fps", f.getMaxFPS().toString()), g.fmtp.config = v.toString();
                        });
                    });
                }
                constructor(g, f){
                    this.mediaManager = g, this.configProvider = f;
                }
            }, sE = class {
                modify(g) {
                    if (!this.configProvider.config.removeRtcpRsizeFromLocalSdp) return;
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio);
                    (f === null || f === void 0 ? void 0 : f.rtcpRsize) && delete f.rtcpRsize;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, oE = class {
                modify(g) {
                    if (!this.configProvider.config.multiStreamSupported || this.configProvider.config.numVideoChannelsGvc < this.configProvider.config.nonMultiStreamChannels) return;
                    let f = 0;
                    for(let S = 0; S < g.media.length; S++)if ("Video" === getModalityForMedia(g.media[S])) {
                        if (g.media[S].xMultiStream) break;
                        f++;
                    }
                    const S = g.media.findIndex((g)=>g.xMultiStream), v = g.media[S];
                    if (!v) return;
                    const _ = v.xMultiStream.startSsrc, C = v.xMultiStream.ssrcGroupRange, E = v.xMultiStream.ssrcRange;
                    delete v.xMultiStream;
                    const T = this.configProvider.config.numVideoChannelsGvc - f - 1;
                    v.subStreamIndex = T;
                    const I = [];
                    for(let f = 0; f < T; f++){
                        const T = (0, XC.cloneDeep)(v);
                        T.mid = getNextAvailableMid(g), T.xSourceStreamId = v.xSourceStreamId, T.subStreamIndex = f, I.push(T.mid);
                        const b = _ + f * E;
                        T.ssrcGroups = [
                            {
                                ssrcs: `${b} ${b + C}`,
                                semantics: "FID"
                            }
                        ], T.xSsrcRange = {
                            ssrcMin: b,
                            ssrcMax: b + E - 1
                        }, g.media.splice(S + f, 0, T);
                    }
                    const b = _ + T * E;
                    v.ssrcGroups = [
                        {
                            ssrcs: `${b} ${b + C}`,
                            semantics: "FID"
                        }
                    ], v.xSsrcRange = {
                        ssrcMin: b,
                        ssrcMax: b + E - 1
                    };
                    const A = g.groups.find((g)=>g.mids.includes(v.mid));
                    A.mids = `${A.mids} ${I.join(" ")}`;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, lE = class {
                modify(g) {
                    const f = 1;
                    if (!this.configProvider.config.multiStreamSupported || this.configProvider.config.numVideoChannelsGvc <= this.configProvider.config.nonMultiStreamChannels + f) return;
                    const S = this.mediaManager.getMediaEntitiesByModality(Gt.MODALITY.video);
                    let v = -1, _ = -1;
                    if (S.forEach((f, S)=>{
                        const C = g.media.findIndex((g)=>g.mid === f.getMid());
                        S === this.configProvider.config.nonMultiStreamChannels - 1 && (_ = C), v = C;
                    }), -1 === v || -1 === _) return;
                    const C = g.media[v];
                    g.media.splice(_ + 1, v - _ - 1);
                    const E = this.configProvider.config.numVideoChannelsGvc - this.configProvider.config.nonMultiStreamChannels;
                    C.xMultiStream = {
                        numberOfStreams: E,
                        startSsrc: 1,
                        ssrcRange: 1,
                        ssrcGroupRange: 1
                    }, "answer" === this.type && (C.xMultiStream.numberOfStreams = Math.min(E, this.configProvider.mediaConfig.multiStreamChannelsOffered), C.ssrcGroups && delete C.ssrcGroups, C.xSsrcRange && delete C.xSsrcRange);
                }
                constructor(g, f, S){
                    this.mediaManager = g, this.configProvider = f, this.type = S;
                }
            }, cE = class {
                modify(g) {
                    getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        forOneCodec(g, {
                            codec: "h264",
                            rate: 9e4
                        }, (g)=>{
                            if (g.fmtp) {
                                const f = new QC, S = new QC(g.fmtp.config);
                                [
                                    "level-asymmetry-allowed",
                                    "packetization-mode",
                                    "profile-level-id"
                                ].forEach((g)=>{
                                    if (S.contains(g)) {
                                        let v = S.get(g);
                                        "profile-level-id" === g && (v = this.configProvider.config.h264SendProfileOverride || v), f.setIfMissing(g, v);
                                    }
                                }), g.fmtp.config = f.toString();
                            }
                        });
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, dE = class {
                process(g, f, S) {
                    getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        getModalityForMedia(g) === f && forOneCodec(g, {
                            codec: "h264",
                            rate: 9e4
                        }, (f)=>{
                            if (f.fmtp) {
                                const v = new QC(f.fmtp.config), _ = new QC;
                                let C = !1;
                                for (const f of v.names()){
                                    let E = v.get(f);
                                    if ("profile-level-id" === f) {
                                        const f = this.mediaManager.getMediaEntities().filter((f)=>f.getModality() === getModality(g)).filter((g)=>g.isEnabled()), v = S(f, E);
                                        typeof v == typeof E && v !== E && (E = v, C = !0);
                                    }
                                    _.setIfMissing(f, E);
                                }
                                C && (f.fmtp.config = _.toString());
                            }
                        });
                    });
                }
                modify(g) {
                    const f = this.configProvider.config.preferredH264SendProfileFallback, S = this.configProvider.config.preferredH264SharingSendProfile, v = this.configProvider.config.preferredH264VideoSendProfile;
                    if (this.remote) {
                        const override = (g)=>(S, v)=>S.some((f)=>f.isSendProfileSupported("H264", g)) ? (this.log.safe.info(`Overriding H264 send profile: ${v} => ${g}`), g) : (this.log.safe.info(`Applying fallback H264 profile: ${v} => ${f}`), f);
                        v && this.process(g, "Video", override(v)), S && this.process(g, "ScreenShare", override(S));
                    } else "answer" === this.sdpType && (v || S) && this.configProvider.config.enableFallbackH264SendProfileForLocalAnswer && this.process(g, "Video", (g, _)=>_ === v || _ === S ? (this.log.safe.info(`Restoring fallback profile in local answer: ${_} => ${f}`), f) : _);
                }
                constructor(g, f, S, v, _){
                    this.configProvider = g, this.mediaManager = f, this.sdpType = S, this.remote = v, this.log = _;
                }
            }, uE = class {
                modify(g) {
                    this.configProvider.config.enableH264SpsPpsIdrKeyframe && getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        forAllCodecs(g, {
                            codec: "h264",
                            rate: 9e4
                        }, (g)=>{
                            if (g.fmtp) {
                                const f = new QC(g.fmtp.config);
                                f.setIfMissing("sps-pps-idr-in-keyframe", "1"), g.fmtp.config = f.toString();
                            }
                        });
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, hE = class {
                modify(g) {
                    this.configProvider.config.enableH264SpsPpsIdrKeyframe && getEnabledMedia(g, Gt.MEDIA_TYPE.video).forEach((g)=>{
                        forAllCodecs(g, {
                            codec: "h264",
                            rate: 9e4
                        }, (g)=>{
                            if (g.fmtp) {
                                const f = new QC(g.fmtp.config);
                                f.removeIfPresent("sps-pps-idr-in-keyframe"), g.fmtp.config = f.toString();
                            }
                        });
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, gE = class {
                modify(g) {
                    const f = (g.groups || []).findIndex((g)=>"BUNDLE" === g.type), S = g.groups ? g.groups[f] : void 0;
                    S && (this.configProvider.mediaConfig.isTransportUnbundled ? (S.mids = this.createBundleFromMedia(getEnabledMedia(g, Gt.MEDIA_TYPE.video)), S.mids || g.groups.splice(f, 1)) : S.mids = this.createBundleFromMedia(getEnabledMedia(g)));
                }
                createBundleFromMedia(g) {
                    return g.map((g)=>{
                        var _g_mid;
                        return (_g_mid = g.mid) === null || _g_mid === void 0 ? void 0 : _g_mid.toString();
                    }).filter((g)=>g).join(" ");
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, pE = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        isMediaDisabled(g) && g.bundleOnly && (g.port = 9, delete g.invalid);
                    });
                }
            }, mE = class {
                modify(g) {
                    var _g_groups;
                    if (!this.configProvider.mediaConfig.isTransportUnbundled && !((_g_groups = g.groups) === null || _g_groups === void 0 ? void 0 : _g_groups.find((g)=>"BUNDLE" === g.type))) {
                        let f = !1;
                        if (g.media.forEach((g, S)=>{
                            const v = this.mediaManager.getMediaEntities()[S];
                            !f && v.isEnabled() ? (g.mid = v.getMid(), f = !0) : (v.disable(), g.port = 0);
                        }), f) {
                            g.groups || (g.groups = []);
                            const f = {
                                type: "BUNDLE"
                            };
                            g.groups.push(f);
                        }
                    }
                }
                constructor(g, f){
                    this.configProvider = g, this.mediaManager = f;
                }
            }, fE = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        const f = !!g.candidates;
                        if (g.candidates && (g.candidates = g.candidates.filter((g)=>{
                            let f = !0, S = !0, v = !0;
                            return this.configProvider.config.iceCandidateType && (f = !!g.type.match(new RegExp(this.configProvider.config.iceCandidateType, "i"))), this.configProvider.config.iceCandidateTransport && (S = !!g.transport.match(new RegExp(this.configProvider.config.iceCandidateTransport, "i"))), this.configProvider.config.iceCandidateFilterMDns && (v = !this.isMdns(g.ip), v || this.logger.safe.info(`Filtering out mDNS candidate ${scrubMriOrOmit(g.ip)}:${scrubMriOrOmit(g.port)}`)), f && S && v;
                        })), f && g.connection && this.configProvider.config.iceCandidateFilterMDns && (g.candidates && 0 !== g.candidates.length || (g.candidates = [
                            getDummyCandidate(g.port)
                        ]), this.isMdns(g.connection.ip) || !this.hasMatchingCandidate(g))) {
                            const f = this.getDefaultCandidate(g);
                            g.connection.ip = f.ip, g.port = f.port;
                        }
                    });
                }
                hasMatchingCandidate(g) {
                    const f = g.connection;
                    return f && !!g.candidates.find(this.createIpAndPortMatcher(f.ip, g.port));
                }
                getDefaultCandidate(g) {
                    return g.candidates.slice().sort((g, f)=>g.type === f.type ? 0 : "host" === g.type || "relay" === f.type ? 1 : "relay" === g.type || "host" === f.type ? -1 : 0)[0];
                }
                isMdns(g) {
                    return g.indexOf(".local") > -1 || g.indexOf(".encrypted") > -1;
                }
                createIpAndPortMatcher(g, f) {
                    return (S)=>S.ip === g && S.port === f;
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f;
                }
            }, SE = class {
                modify(g) {
                    this.configProvider.config.useOneRelayCandidateForRemoteSDP && g.media.forEach((g)=>{
                        if (g.candidates) {
                            const f = g.candidates.filter((g)=>!!g.type.match(new RegExp("relay", "i")));
                            f.length > 0 && (g.candidates = f.slice(0, 1));
                        }
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, vE = class {
                modify(g) {
                    const f = getEnabledMedia(g)[0];
                    f && (f.candidates = [
                        getDummyCandidate()
                    ]);
                }
            }, _E = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        this.fromMsSdp(g, f);
                    });
                }
                fromMsSdp(g, f) {
                    var _this_configProvider_config_specCompliantSimulcast;
                    if (isMediaDisabled(g) || g.rids && g.simulcast) return;
                    const S = this.mediaManager.getMediaEntities()[f], v = S === null || S === void 0 ? void 0 : S.getSimulcastContext();
                    (v === null || v === void 0 ? void 0 : v.shouldBeEnabledInRemoteDesc()) && (v.enableInRemoteDesc(), g.simulcast = {
                        dir1: "recv",
                        list1: ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.disableTilde) ? v.ridList.map((g)=>`${g}`).join(";") : v.ridList.map((g)=>`${v.activeRids.includes(g) ? "" : "~"}${g}`).join(";")
                    }, g.rids = v.ridList.map((g)=>({
                            id: g,
                            direction: "recv"
                        })));
                }
                constructor(g, f){
                    this.mediaManager = g, this.configProvider = f;
                }
            }, CE = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        this.toMsSdp(g, f);
                    });
                }
                toMsSdp(g, f) {
                    const S = this.mediaManager.getMediaEntities()[f], v = S === null || S === void 0 ? void 0 : S.getSimulcastContext();
                    v && (v.localDescriptionIsApplied(), v.shouldBeEnabledInLocalDesc() && (v.enableInLocalDesc(), this.removeSimulcastEnvelope(g), this.addStreamSsrc(g, S.getLocalSsrc())));
                }
                removeSimulcastEnvelope(g) {
                    g.rids && delete g.rids, g.simulcast && delete g.simulcast;
                }
                addStreamSsrc(g, f) {
                    if (!f) return;
                    if (g.ssrcs) return void this.logger.safe.debug(`Media mid: ${g.mid} already contains ssrc: ${JSON.stringify(g.ssrcs)}`);
                    const S = f;
                    this.setSsrc(g, S);
                }
                setSsrc(g, f) {
                    g.ssrcs = [
                        {
                            id: f,
                            attribute: "fake_attribute",
                            value: "fake_value"
                        }
                    ];
                }
                constructor(g, f){
                    this.mediaManager = g, this.logger = f;
                }
            }, yE = class {
                modify(g) {
                    g.media.forEach((g, f)=>{
                        var _S_getSimulcastContext;
                        const S = this.mediaManager.getMediaEntities()[f], v = S === null || S === void 0 ? void 0 : S.getLocalTrackId();
                        (!g.msid && (S === null || S === void 0 ? void 0 : (_S_getSimulcastContext = S.getSimulcastContext()) === null || _S_getSimulcastContext === void 0 ? void 0 : _S_getSimulcastContext.shouldUseSimulcast()) && v || (S === null || S === void 0 ? void 0 : S.getExtension("reinviteless"))) && (g.msid = `- ${v !== null && v !== void 0 ? v : f}`);
                    });
                }
                constructor(g){
                    this.mediaManager = g;
                }
            }, EE = class {
                modify(g) {
                    var _S_find, _S_find1, _find;
                    var _ref;
                    const f = this.mediaManager.getMediaEntities(), S = (0, XC.flatMap)(f, (g)=>g.getRtpHeaderExtensions()), v = (_S_find = S.find((g)=>"vla" === (g === null || g === void 0 ? void 0 : g.headerType))) === null || _S_find === void 0 ? void 0 : _S_find.value, _ = (_S_find1 = S.find((g)=>"non-adv-vla" === (g === null || g === void 0 ? void 0 : g.headerType))) === null || _S_find1 === void 0 ? void 0 : _S_find1.value, C = (_ref = v !== null && v !== void 0 ? v : _) !== null && _ref !== void 0 ? _ref : (_find = (0, XC.flatMap)(g.media, (g)=>g.ext || []).find((g)=>g.uri === Gt.VLA.EXT_URI)) === null || _find === void 0 ? void 0 : _find.value, E = getFreeValueForExt(g, this.configProvider.config.extmapAllowMixed, Gt.VLA.DEFAULT_VALUE);
                    g.media.forEach((g, S)=>{
                        var _g_ext, _f_S, __find, __find1;
                        const v = getModalityForMedia(g);
                        if (!(this.configProvider.config.enableVla && ("Video" === v || "ScreenShare" === v))) return;
                        if ((_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.find((g)=>g.uri === Gt.VLA.EXT_URI)) return;
                        var __find_value;
                        const _ = (_f_S = f[S]) === null || _f_S === void 0 ? void 0 : _f_S.getRtpHeaderExtensions(), T = _ ? (__find_value = (__find = _.find((g)=>"vla" === g.headerType)) === null || __find === void 0 ? void 0 : __find.value) !== null && __find_value !== void 0 ? __find_value : (__find1 = _.find((g)=>"non-adv-vla" === g.headerType)) === null || __find1 === void 0 ? void 0 : __find1.value : C !== null && C !== void 0 ? C : E;
                        T && (g.ext = g.ext || [], g.ext.push({
                            value: T,
                            uri: Gt.VLA.EXT_URI
                        }));
                    });
                }
                constructor(g, f){
                    this.mediaManager = g, this.configProvider = f;
                }
            }, TE = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        var _g_ext;
                        const f = getModalityForMedia(g);
                        if (this.configProvider.config.allowRemoteVla && ("Video" === f || "ScreenShare" === f)) return;
                        const S = (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.findIndex((g)=>g.uri === Gt.VLA.EXT_URI);
                        S > -1 && g.ext.splice(S, 1);
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, IE = class {
                modify(g, f, S) {
                    g.media.forEach((g)=>{
                        var _g_ext, _g_ext1;
                        const v = getModalityForMedia(g);
                        if (!(this.configProvider.config.enableNonAdvVla && ("Video" === v || "ScreenShare" === v)) || ((_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.find((g)=>g.uri === S))) return;
                        const _ = (_g_ext1 = g.ext) === null || _g_ext1 === void 0 ? void 0 : _g_ext1.find((g)=>g.uri === f);
                        _ && (_.uri = S);
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, bE = class extends IE {
                modify(g) {
                    const f = this.mediaManager.getMediaEntities();
                    (0, XC.flatMap)(f, (g)=>g.getRtpHeaderExtensions()).some((g)=>"vla" === (g === null || g === void 0 ? void 0 : g.headerType)) || super.modify(g, Gt.VLA.EXT_URI, Gt.VLA.EXT_URI_NON_ADV);
                }
                constructor(g, f){
                    super(g), this.mediaManager = f;
                }
            }, AE = class extends IE {
                modify(g) {
                    super.modify(g, Gt.VLA.EXT_URI_NON_ADV, Gt.VLA.EXT_URI);
                }
                constructor(g){
                    super(g);
                }
            }, RE = class {
                modify(g) {
                    g.media.forEach((g)=>{
                        var _g_ext;
                        (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.forEach((g)=>g.uri = this.normalizeSlashesInUri(g.uri));
                    });
                }
                normalizeSlashesInUri(g) {
                    return g.replace(/\\/g, "/");
                }
            }, PE = class {
                modify(g) {
                    if (this.configProvider.config.fixSdpForPartialIceRestart) {
                        const [{ iceUfrag: f, icePwd: S } = {}] = g.media;
                        void 0 !== f && void 0 !== S && g.media.forEach((g)=>{
                            g.iceUfrag = f, g.icePwd = S;
                        });
                    }
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, wE = class {
                modify(g) {
                    var _this_configProvider_config_reduceRtcpFbInSdp;
                    if ((_this_configProvider_config_reduceRtcpFbInSdp = this.configProvider.config.reduceRtcpFbInSdp) === null || _this_configProvider_config_reduceRtcpFbInSdp === void 0 ? void 0 : _this_configProvider_config_reduceRtcpFbInSdp.length) for (const f of getEnabledMedia(g, Gt.MEDIA_TYPE.video))f.rtcpFb = f.rtcpFb && this.getFbList(f.rtcpFb);
                }
                getFbList(g) {
                    const f = [], S = [];
                    for (const v of g){
                        const g = v.subtype ? `${v.type}/${v.subtype}` : `${v.type}`;
                        f.includes(g) || (this.configProvider.config.reduceRtcpFbInSdp.includes(g) ? (f.push(g), S.push({
                            ...v,
                            payload: "*"
                        })) : S.push(v));
                    }
                    return S;
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, ME = class {
                modify(g) {
                    if (!this.configProvider.config.redReceiveEnabled) return;
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio);
                    let S = 0;
                    forOneCodec(f, {
                        codec: "opus",
                        rate: 48e3,
                        encoding: 2
                    }, (g)=>{
                        S = g.rtp.payload;
                    });
                    const v = {
                        codec: "RED",
                        rate: 8e3
                    };
                    forOneCodec(f, v, (g)=>{
                        g.rtp.rate = 48e3, g.rtp.encoding = 2, S && (g.fmtp = {
                            payload: g.rtp.payload,
                            config: `${S}/${S}`
                        });
                    }), removeCodec(f, v);
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, OE = class {
                modify(g) {
                    if (!this.configProvider.config.redReceiveEnabled) return;
                    forOneCodec(g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), {
                        codec: "red",
                        rate: 48e3,
                        encoding: 2
                    }, (g)=>{
                        g.rtp.codec = "RED", g.rtp.rate = 8e3, delete g.rtp.encoding;
                    });
                }
                constructor(g){
                    this.configProvider = g;
                }
            }, DE = class {
                modify(g) {
                    if (!this.configProvider.config.redReceiveEnabled || "offer" !== this.sdpType) return;
                    const f = g.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = {
                        codec: "red",
                        rate: 48e3,
                        encoding: 2
                    };
                    let v = 0;
                    if (forOneCodec(f, S, (g)=>{
                        v = g.rtp.payload;
                    }), v === Gt.PAYLOAD_TYPE.MSRTC_RED) return;
                    const _ = findAvailablePayload(g);
                    -1 !== _ && (changePayloadType(g, Gt.PAYLOAD_TYPE.MSRTC_RED, _), forOneCodec(f, S, (g)=>{
                        g.rtp.payload = Gt.PAYLOAD_TYPE.MSRTC_RED;
                    }));
                }
                constructor(g, f){
                    this.configProvider = g, this.sdpType = f;
                }
            }, NE = class {
                modify(g) {
                    if ("answer" !== this.modification.sdpType) {
                        if ("offer" === this.modification.sdpType && 2 === this.modification.sdpSource) {
                            if (this.modification.isOrWasProvisional) {
                                const f = this.context.config.isPstnCall ? this.context.configProvider.config.createProvisionalAnswer.dtlsRolePstn : this.context.configProvider.config.createProvisionalAnswer.dtlsRole;
                                if (!f) return;
                                this.logger.debug(`Configured DTLS role override: ${f}`), g.media.forEach((g, S)=>{
                                    const v = g.setup;
                                    "inactive" !== g.direction && (v && "actpass" !== v ? this.logger.warn(`Remote DTLS role is ${v}, cannot change`) : (g.setup = f, this.logger.debug(`Remote DTLS role changed from ${v} to ${g.setup} for mid=${g.mid}`)));
                                });
                            }
                        } else this.logger.error(`Tried to apply invalid change to DTLS role: ${this.modification.sdpType} ${this.modification.sdpSource}`);
                    }
                }
                constructor(g, f){
                    this.modification = g, this.context = f, this.logger = f.getLogger().createChild("IncomingDtlsRoleModifier");
                }
            };
            function disabledMedia(g, f, S, v) {
                const _ = {
                    type: g,
                    port: 0,
                    label: f,
                    payloads: g === Gt.MEDIA_TYPE.dataChannel || g === Gt.MEDIA_TYPE.data ? Gt.PAYLOAD_TYPE.DATA_CHANNEL : "36",
                    protocol: S,
                    connection: {
                        ip: "10.10.10.10",
                        version: 4
                    }
                };
                return v && (_.mid = v), _;
            }
            function getEnabledMedia(g, f = null) {
                return g.media.filter((g)=>!(isMediaDisabled(g) || f && g.type !== f));
            }
            function getDummyCandidate(g = 1234) {
                return {
                    component: 1,
                    ip: "10.10.10.10",
                    foundation: "1755259772",
                    priority: 2122197247,
                    port: g !== 9 ? g : 1234,
                    transport: "UDP",
                    type: "host"
                };
            }
            function getFreeValueForExt(g, f, S, v = !1) {
                const _ = (0, XC.flatMap)(g.media, (g)=>g.ext || []).map((g)=>g.value);
                if (0 === _.length) return S;
                const C = 2, E = 14;
                if (v && !_.includes(S)) return S;
                let T;
                for(let g = C; g <= E; g++)if (!_.includes(g)) {
                    T = g;
                    break;
                }
                return !T && f && (T = Math.max(..._) + 1), T;
            }
            function getCustomCodecParams(g, f) {
                var _Rs_g;
                if (!((_Rs_g = Rs[g]) === null || _Rs_g === void 0 ? void 0 : _Rs_g[f])) throw `unsupported codec ${g} or type ${f}`;
                const S = Rs[g][f];
                return {
                    codec: S.NAME,
                    rate: S.RATE,
                    encoding: S.ENCODING,
                    payload: Rs[g].PT
                };
            }
            function changePayloadType(g, f, S) {
                for (const v of g.media)updatePayload(v, f, S);
            }
            function changeCodecPayload(g, f, S, v, _) {
                const C = new Set;
                return forAllCodecs(g, f, (g)=>{
                    var _S__;
                    g.rtp.payload < 96 && (C.add(g.rtp.payload), g.rtp.payload = (_S__ = S[_]) !== null && _S__ !== void 0 ? _S__ : g.rtp.payload, _++);
                }, v), C;
            }
            var kE = class _SessionDescription {
                getSdp() {
                    return JC.write(this.sdpModel);
                }
                clone() {
                    return new _SessionDescription(this.context, this.sessionType, this.sdp, this.remote);
                }
                getModalities() {
                    return this.modalities || getModalities(this.sdpModel);
                }
                updateModalities(g) {
                    this.logger.debug("updateModalities", g), this.modalities = g;
                }
                getSrtpInfo() {
                    return getSrtpInfo(this.sdpModel);
                }
                getVideoCodecs() {
                    const g = {};
                    return this.sdpModel.media.forEach((f)=>{
                        "video" === f.type && f.rtp.map((g)=>g.codec.toLowerCase()).forEach((f)=>g[f] = !0);
                    }), Object.keys(g);
                }
                usePrimaryAudioCodecOnly(g) {
                    new nE(g).modify(this.sdpModel);
                }
                isCodecSwitchSupported() {
                    return !this.sdpModel.media.some((g)=>g.type === Gt.MEDIA_TYPE.audio && g.xMediaSettings && this.containsMediaSetting(g.xMediaSettings, "codecswitchunsupported"));
                }
                toLocal() {
                    return this.sdpModel = this.sdpTransform.toLocal(this.sdpModel, this.mediaManager, this.sessionType), this.getSdp();
                }
                toOffer() {
                    return this.toOfferAnswer();
                }
                toAnswer() {
                    return this.toOfferAnswer();
                }
                toOfferAnswer() {
                    const g = "offer" === this.sessionType;
                    return new fE(this.context.configProvider, this.logger).modify(this.sdpModel), (new pE).modify(this.sdpModel), g && this.mediaManager.isEmpty() && this.mediaManager.fromOffer(this.sdpModel, this.modalities), this.mediaManager.syncModalities(this.sdpModel, this.modalities, !g), this.sdpModel = g ? this.sdpTransform.toOffer(this.sdpModel, this.mediaManager, this.modalities) : this.sdpTransform.toAnswer(this.sdpModel, this.mediaManager, this.modalities), this.context.configProvider.config.disableMsSdp || new Cy(this.context, this.mediaManager, this.sessionType).modify(this.sdpModel), new aE(this.mediaManager, this.context.configProvider).modify(this.sdpModel), this.modalities = getModalities(this.sdpModel), this.getSdp();
                }
                setModalities(g) {
                    this.modalities = g, this.mediaManager.fromRemote(this.sdpModel, this.modalities);
                }
                toRemote(g = !1) {
                    return this.sdpModel = this.sdpTransform.toRemote(this.sdpModel, this.mediaManager, this.modalities, this.sessionType, g), this.getSdp();
                }
                getVideoRecvCapabilities() {
                    return getRecvCapabilitiesForMedia(this.getMediaByLabel(Gt.MEDIA_LABEL.video));
                }
                getSharingRecvCapabilities() {
                    return getRecvCapabilitiesForMedia(this.getMediaByLabel(Gt.MEDIA_LABEL.sharing));
                }
                getMediaByType(g) {
                    return this.sdpModel.media.find((f)=>f.type === g);
                }
                isUnbundled() {
                    var _this_sdpModel_groups;
                    const g = (_this_sdpModel_groups = this.sdpModel.groups) === null || _this_sdpModel_groups === void 0 ? void 0 : _this_sdpModel_groups.find((g)=>"BUNDLE" === g.type), f = this.sdpModel.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), S = this.sdpModel.media.find((g)=>g.type === Gt.MEDIA_TYPE.video);
                    return g ? !g.mids.toString().split(" ").find((g)=>g === f.mid) : !!S;
                }
                couldBeUnbundled() {
                    var _this_sdpModel_groups;
                    return !((_this_sdpModel_groups = this.sdpModel.groups) === null || _this_sdpModel_groups === void 0 ? void 0 : _this_sdpModel_groups.find((g)=>"BUNDLE" === g.type)) || this.hasUnbundledIceCandidates();
                }
                containsMediaSetting(g, f) {
                    return g.some((g)=>-1 !== g.settings.indexOf(f));
                }
                getMediaByLabel(g) {
                    return this.sdpModel.media.find((f)=>f.label === g);
                }
                hasIceCandidatesForMediaType(g, f = "") {
                    const S = this.sdpModel.media ? this.sdpModel.media.filter((f)=>f.type === g && !!f.candidates && 0 !== f.candidates.length) : [];
                    return f ? S.some((g)=>!!g.candidates && g.candidates.some((g)=>g.type === f)) : !!S.length;
                }
                hasIceCandidates() {
                    return this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.audio) || this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.video);
                }
                hasRelayIceCandidates() {
                    return this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.audio, "relay") || this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.video, "relay");
                }
                hasUnbundledIceCandidates() {
                    const g = this.sdpModel.media.filter((g)=>g.type === Gt.MEDIA_TYPE.video && 0 !== g.port);
                    return this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.audio) && (!g.length || this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.video));
                }
                hasUnbundledRelayIceCandidates() {
                    const g = this.sdpModel.media.filter((g)=>g.type === Gt.MEDIA_TYPE.video && 0 !== g.port);
                    return this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.audio, "relay") && (!g.length || this.hasIceCandidatesForMediaType(Gt.MEDIA_TYPE.video, "relay"));
                }
                isIceRestart() {
                    return this.mediaManager.getMediaEntities().some((g)=>g.getExtension("iceRestart"));
                }
                isMSRTC() {
                    return !!this.sdpModel.xMediaBw;
                }
                insertFakeCandidateIfNeeded() {
                    return !this.hasIceCandidates() && ((new vE).modify(this.sdpModel), !0);
                }
                forceRecvonly() {
                    (new Iy).modify(this.sdpModel);
                }
                getBweType() {
                    var _g_ext;
                    const g = this.sdpModel.media.find((g)=>0 !== g.port && g.type === Gt.MEDIA_TYPE.video);
                    if (!g) return "Unknown";
                    const f = (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.find((g)=>g.uri === Gt.TRANSPORT_CC.EXT_URI || g.uri === Gt.TRANSPORT_CC.MSSDP_ENCODED_URI);
                    return f ? "SSBWE" : "REMB";
                }
                fixDataModality() {
                    new Ry(this.mediaManager).modify(this.sdpModel);
                }
                getPayloadsForMedia(g) {
                    const f = this.sdpModel.media.find((f)=>f.type === g && 0 !== f.port);
                    var _f_rtp;
                    return (_f_rtp = f === null || f === void 0 ? void 0 : f.rtp) !== null && _f_rtp !== void 0 ? _f_rtp : [];
                }
                constructor(g, f, S, v){
                    this.context = g, this.sessionType = f, this.sdp = S, this.remote = v, this.mediaManager = this.context.mediaManager, this.sdpTransform = this.context.sdpTransform, this.logger = this.context.logger.createChild("SessionDescr"), this.sdpModel = JC.parse(this.sdp), v && new oE(this.context.configProvider).modify(this.sdpModel), this.sdpModel.media.forEach((g)=>{
                        (0, KC.isUndefined)(g.mid) || (g.mid = g.mid.toString());
                    }), this.remote && !this.context.configProvider.config.disableMsSdp && new yy(g, this.mediaManager, f).modify(this.sdpModel);
                }
            }, LE = class {
                createLocalOffer(g) {
                    return new kE(this.context, "offer", g);
                }
                createRemoteOffer(g) {
                    return new kE(this.context, "offer", g, !0);
                }
                createLocalAnswer(g) {
                    return new kE(this.context, "answer", g);
                }
                createRemoteAnswer(g) {
                    return new kE(this.context, "answer", g, !0);
                }
                constructor(g){
                    this.context = g;
                }
            }, FE = class {
                static build(g) {
                    return new LE(g = g || {});
                }
            };
            function getSrtpReport(g) {
                let f = "";
                return g.dtls && (f += "dtls"), g.sdes && (f += "sdes"), f;
            }
            var xE = class {
                setCandidateDetails(g) {
                    "host" === g.type && "udp" === g.protocol ? this.setIPAddressInfo(g.ip) : "srflx" === g.type && this.setReflexiveLocalIP(g.ip);
                }
                setOfferedModalities(g) {
                    this.offeredModalities = g, this.activeModalities = g;
                }
                setNegotiatedModalities(g) {
                    this.negotiatedModalities = g, this.activeModalities = g;
                }
                setNegotiatedSrtpInfo(g) {
                    this.info.NegotiatedSrtp = getSrtpReport(g);
                }
                setOfferedSrtpInfo(g) {
                    this.info.OfferedSrtp = getSrtpReport(g);
                }
                setIceConnectionState(g) {
                    this.info.IceConnectionStatePrevious = this.info.IceConnectionState, this.info.IceConnectionState = g;
                }
                setSignalingConnectionState(g) {
                    this.info.SignalingStatePrevious = this.info.SignalingState, this.info.SignalingState = g;
                }
                setRelayCandidateInfo(g) {
                    this.info.RelayCandidate = JSON.stringify(g);
                }
                fillExtensionInfo(g) {
                    assign(g, this.info);
                }
                setIceTransportPolicy(g) {
                    this.info.IceTransportPolicy = g;
                }
                setIceServers(g) {
                    const f = g.map((g)=>{
                        const f = {
                            ...g
                        };
                        return f.username && (f.username = "true"), f.credential && (f.credential = "true"), f;
                    });
                    this.info.IceServers = JSON.stringify(f);
                }
                setFakeIceCandidate(g) {
                    this.info.FakeIceCandidate = g;
                }
                setBweType(g) {
                    "Unknown" !== g && (this.info.BweType = g);
                }
                setSdpSemantics(g) {
                    this.info.SdpSemantics = g;
                }
                setBundlePolicy(g) {
                    this.info.BundlePolicy = g;
                }
                setEncodedStreamWorkerLoaded(g) {
                    this.info.EncodedStreamWorker = g;
                }
                setAudioCodecEvents(g) {
                    this.info.AudioCodecEvents = JSON.stringify(g);
                }
                setIPAddressInfo(g) {
                    this.info.NumberOfInterfaces += 1, "none" === this.info.IPAddress && (this.info.IPAddress = g);
                }
                setReflexiveLocalIP(g) {
                    "none" === this.info.ReflexiveLocalIP && (this.info.ReflexiveLocalIP = g);
                }
                constructor(){
                    this.info = {
                        OfferedSrtp: "none",
                        NegotiatedSrtp: "none",
                        IceConnectionState: "none",
                        IceConnectionStatePrevious: "none",
                        SignalingState: "none",
                        SignalingStatePrevious: "none",
                        RelayCandidate: "none",
                        IceTransportPolicy: "none",
                        IceServers: "none",
                        FakeIceCandidate: !1,
                        BweType: "none",
                        SdpSemantics: "none",
                        BundlePolicy: "none",
                        IPAddress: "none",
                        ReflexiveLocalIP: "none",
                        NumberOfInterfaces: 0,
                        EncodedStreamWorker: !1,
                        AudioCodecEvents: "none"
                    };
                }
            }, UE = class {
                handleInputLevel(g, f) {
                    this.isActiveScreenSharing && ("ScreenShare" === g && f > 0 && (this.presentationAPIUserDuration += Gt.TIME_INTERVAL.SEC_1), "Audio" === g && f > 0 && (this.presentationAudioDuration += Gt.TIME_INTERVAL.SEC_1));
                }
                updateScreenSharingStream(g, f) {
                    "ScreenShare" === f && (this.isActiveScreenSharing = !!g);
                }
                getPresentationAudioDuration() {
                    return this.presentationAudioDuration;
                }
                getPresentationAudioAPIUserDuration() {
                    return this.presentationAPIUserDuration;
                }
                constructor(){
                    this.presentationAPIUserDuration = 0, this.presentationAudioDuration = 0, this.isActiveScreenSharing = !1;
                }
            }, VE = class _TimerTracker {
                mark(g, f) {
                    const S = Kt();
                    this.sharedState.mark.set(g, {
                        name: g,
                        ts: S,
                        startTime: round(Jt + S),
                        details: f
                    });
                }
                measure(g, f) {
                    const S = this.sharedState.mark.get(f.start), v = this.sharedState.mark.get(f.end);
                    if (S && v) {
                        const _ = {
                            ...f,
                            parentName: this.name === g ? "" : this.name
                        };
                        this.sharedState.measure.push({
                            name: g,
                            details: _,
                            duration: round(v.ts - S.ts),
                            startTime: S.startTime
                        });
                    }
                }
                markAndMeasure(g, f, S, v) {
                    !1 === this.sharedState.mark.has(f) && this.mark(f, S);
                    const _ = this.sharedState.mark.get(g), C = this.sharedState.mark.get(f);
                    if (_ && C) {
                        const g = {
                            ...v,
                            parentName: this.name === f ? "" : this.name
                        };
                        this.sharedState.measure.push({
                            name: f,
                            details: g,
                            duration: round(C.ts - _.ts),
                            startTime: _.startTime
                        });
                    }
                }
                clone(g) {
                    const f = new _TimerTracker(`${this.name}|${g}`);
                    return f.setSharedState(this.sharedState), f;
                }
                setSharedState(g) {
                    this.sharedState = g;
                }
                getReport() {
                    return this.sharedState.measure.map((g)=>({
                            name: g.name,
                            duration: g.duration,
                            ts: g.startTime,
                            parentName: g.details.parentName
                        }));
                }
                constructor(g){
                    this.name = g, this.sharedState = {
                        mark: new Map,
                        measure: []
                    };
                }
            }, BE = class _NoopTracker {
                mark() {}
                measure() {}
                markAndMeasure() {}
                clone() {
                    return new _NoopTracker;
                }
                getReport() {
                    return [];
                }
            }, HE = class {
                getTimerTracker(g, f) {
                    if (!this.enableTimerTracker) return new BE;
                    const S = new VE(g);
                    if (this.timerTrackers[g]) {
                        const f = this.timerTrackerOptions[g];
                        if (f === null || f === void 0 ? void 0 : f.first) return new BE;
                        (f === null || f === void 0 ? void 0 : f.last) && (this.timerTrackers[g] = [
                            S
                        ]), (f === null || f === void 0 ? void 0 : f.all) && this.timerTrackers[g].push(S);
                    } else this.timerTrackers[g] = [
                        S
                    ], this.timerTrackerOptions[g] = f;
                    return S;
                }
                getReport() {
                    if (this.enableTimerTracker) return Object.keys(this.timerTrackers).reduce((g, f)=>{
                        var _this_timerTrackers_f_;
                        const S = this.timerTrackerOptions[f];
                        return (S.first || S.last) && (g[f] = [
                            (_this_timerTrackers_f_ = this.timerTrackers[f][0]) === null || _this_timerTrackers_f_ === void 0 ? void 0 : _this_timerTrackers_f_.getReport()
                        ]), S.all && (g[f] = Object.values(this.timerTrackers[f]).map((g)=>g === null || g === void 0 ? void 0 : g.getReport())), g;
                    }, {});
                }
                constructor(g){
                    this.enableTimerTracker = g, this.timerTrackers = {}, this.timerTrackerOptions = {};
                }
            }, $E = class {
                getTimerTracker(g, f) {
                    return this.timerTrackerManager.getTimerTracker(g, f);
                }
                set offeredModalities(g) {
                    this.data.offeredModalities = g, this.data.activeModalities = g, this.sessionInfo.setOfferedModalities(g);
                }
                set negotiatedModalities(g) {
                    this.data.negotiatedModalities = g, this.data.activeModalities = g, this.sessionInfo.setNegotiatedModalities(g);
                }
                set fakeCandidate(g) {
                    var f;
                    (f = this.data).fakeCandidate || (f.fakeCandidate = g), this.sessionInfo.setFakeIceCandidate(g);
                }
                set bweType(g) {
                    this.data.bweType = g, this.sessionInfo.setBweType(g);
                }
                set negotiatedSrtp(g) {
                    this.data.negotiatedSrtp = getSrtpReport2(g), this.sessionInfo.setNegotiatedSrtpInfo(g);
                }
                set offeredSrtp(g) {
                    this.data.offeredSrtp = getSrtpReport2(g), this.sessionInfo.setOfferedSrtpInfo(g);
                }
                set meetingScenario(g) {
                    this.data.meetingScenario = g;
                }
                set isTownHall(g) {
                    this.data.isTownHall = g;
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g, f){
                    this.configProvider = g, this.sessionInfo = f, this.data = {
                        fakeCandidate: !1,
                        bweType: "Unknown",
                        offeredSrtp: "unknown",
                        negotiatedSrtp: "unknown",
                        callSetupTimeReport: {}
                    }, this.timerTrackerManager = new HE(this.configProvider.config.enableTimerTracker), addGetterFields(this.data, {
                        callSetupTimeReport: ()=>this.timerTrackerManager.getReport()
                    });
                }
            };
            function getSrtpReport2(g) {
                let f = "";
                return g.dtls && (f += "dtls"), g.sdes && (f += "sdes"), f;
            }
            var jE = class {
                registerReopenRequest(g) {
                    this.reopenRequestDeviceIds.has(g) || (this.data.sinkNumOfReopenRequests++, this.reopenRequestDeviceIds.add(g));
                }
                registerSuccessfullReopen(g) {
                    this.reopenRequestDeviceIds.has(g) && (this.data.sinkNumOfSuccessfulReopens++, this.reopenRequestDeviceIds.delete(g));
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g){
                    this.data = g, this.reopenRequestDeviceIds = new Set;
                }
            }, GE = class {
                dispose() {
                    for (const g of Object.values(this.stateTrackers))g.dispose();
                }
                set hasConnectionState(g) {
                    this.data.hasConnectionState = g;
                }
                set transportState(g) {
                    this.data.transportStatePrevious = this.data.transportState, this.data.transportState = g, this.addStateEvent("transport", this.data.transportStatePrevious, this.data.transportState);
                }
                set signalingState(g) {
                    this.data.signalingStatePrevious = this.data.signalingState, this.data.signalingState = g, this.addStateEvent("signaling", this.data.signalingStatePrevious, this.data.signalingState);
                }
                set iceConnectionState(g) {
                    this.data.iceConnectionStatePrevious = this.data.iceConnectionState, this.data.iceConnectionState = g, this.addStateEvent("ice", this.data.iceConnectionStatePrevious, this.data.iceConnectionState);
                }
                set connectionState(g) {
                    this.data.connectionStatePrevious = this.data.connectionState, this.data.connectionState = g, this.addStateEvent("connection", this.data.connectionStatePrevious, this.data.connectionState);
                }
                set dtlsTransportState(g) {
                    this.data.dtlsTtransportStatePrevious = this.data.dtlsTransportState, this.data.dtlsTransportState = g, this.addStateEvent("dtlsTransport", this.data.dtlsTtransportStatePrevious, this.data.dtlsTransportState);
                }
                set provisional(g) {
                    this.addStateEvent("provisional", `${this.data.isProvisional}`, `${g}`), this.data.isProvisional = g;
                }
                scheduleDoOnConnected(g, f, S, v) {
                    this.scheduledCallbacks.set(g, `${f}: ${S ? "p" : ""}${v ? "n" : ""}`), this.addCallbackEvent(f, S, v), this.data.numCallbacksScheduled++;
                }
                runDoOnConnected(g, f = !1) {
                    this.scheduledCallbacks.get(g) && this.scheduledCallbacks.delete(g), this.data.numCallbacksExecuted++, f && this.data.numCallbacksExecutedImmediately++;
                }
                getObjectRef() {
                    return this.data;
                }
                addCallbackEvent(g, f, S) {
                    arrayLimitedPush(this.data.events, {
                        evType: "callback",
                        timestamp: Date.now(),
                        logName: g,
                        allowProvisional: f,
                        mayRunImmediately: S
                    }, this.configProvider.config.diagnostics.collectionLimits.numTransportStateEvents);
                }
                addStateEvent(g, f, S) {
                    arrayLimitedPush(this.data.events, {
                        evType: "stateChanged",
                        timestamp: Date.now(),
                        changedState: g,
                        previous: f,
                        current: S
                    }, this.configProvider.config.diagnostics.collectionLimits.numTransportStateEvents);
                    var _this_stateTrackers_g;
                    const v = (_this_stateTrackers_g = this.stateTrackers[g]) !== null && _this_stateTrackers_g !== void 0 ? _this_stateTrackers_g : new qE;
                    v.state = S, this.stateTrackers[g] = v;
                }
                constructor(g){
                    this.configProvider = g, this.data = {
                        signalingState: "none",
                        signalingStatePrevious: "none",
                        iceConnectionState: "none",
                        iceConnectionStatePrevious: "none",
                        numCallbacksScheduled: 0,
                        numCallbacksExecuted: 0,
                        numCallbacksExecutedImmediately: 0,
                        scheduledCallbacks: [],
                        events: [],
                        timers: {}
                    }, this.scheduledCallbacks = new Map, this.stateTrackers = {}, addGetterFields(this.data, {
                        scheduledCallbacks: ()=>this.scheduledCallbacks.values(),
                        timers: ()=>{
                            const g = {};
                            for (const f of Object.keys(this.stateTrackers))g[f] = this.stateTrackers[f].durations;
                            return g;
                        }
                    });
                }
            }, qE = class {
                set state(g) {
                    var _this_running;
                    if (this.stateInternal === g) return;
                    (_this_running = this.running) === null || _this_running === void 0 ? void 0 : _this_running.stop();
                    var _this_stopwatches_g;
                    const f = (_this_stopwatches_g = this.stopwatches[g]) !== null && _this_stopwatches_g !== void 0 ? _this_stopwatches_g : new QE;
                    this.stopwatches[g] = f, f.start(), this.running = f, this.stateInternal = g;
                }
                get durations() {
                    const g = {};
                    for(const f in this.stopwatches){
                        const S = this.stopwatches[f];
                        g[f] = S.elapsed;
                    }
                    return g;
                }
                dispose() {
                    var _this_running;
                    (_this_running = this.running) === null || _this_running === void 0 ? void 0 : _this_running.stop(), this.running = void 0;
                }
                constructor(){
                    this.stopwatches = {};
                }
            }, WE = /profile-level-id=(.{6})/, zE = class {
                get deviceManager() {
                    return this.dmDiagnostics;
                }
                get audioLevel() {
                    var _this_analyzer;
                    return (_this_analyzer = this.analyzer) === null || _this_analyzer === void 0 ? void 0 : _this_analyzer.getInputLevelNormalized();
                }
                get reflexiveLocalIP() {
                    return this.data.reflexiveLocalIP;
                }
                set bandwidthDiagnostic(g) {
                    this.bandwidthStatsRef = g;
                }
                get callIsMuted() {
                    var _this_getSessionRef, _this;
                    return (_this_getSessionRef = (_this = this).getSessionRef) === null || _this_getSessionRef === void 0 ? void 0 : _this_getSessionRef.call(_this).callIsMuted;
                }
                get sharingAudioLevel() {
                    var _this_analyzerSharing;
                    return (_this_analyzerSharing = this.analyzerSharing) === null || _this_analyzerSharing === void 0 ? void 0 : _this_analyzerSharing.getInputLevelNormalized();
                }
                set relayCandidateInfo(g) {
                    this.data.relayCandidate = JSON.stringify(g);
                }
                set iceTransportPolicy(g) {
                    this.data.iceTransportPolicy = g;
                }
                set reinvitelessContext(g) {
                    this.data.reinvitelessContext = g;
                }
                set iceServers(g) {
                    const f = g.map((g)=>{
                        const f = {
                            ...g
                        };
                        return f.username && (f.username = "true"), f.credential && (f.credential = "true"), f;
                    });
                    this.data.iceServers = JSON.stringify(f);
                }
                set sdpSemantics(g) {
                    this.data.sdpSemantics = g;
                }
                set isCodecsSupported(g) {
                    this.data.codecSupport = g;
                }
                set bundlePolicy(g) {
                    this.data.bundlePolicy = g;
                }
                set latestRawReport(g) {
                    this.data.latestRawReport = g;
                }
                set recvVideoStreamsCount(g) {
                    this.data.recvVideoStreamCount = g;
                }
                set aggregatedStatsRef(g) {
                    this.data.aggregatedModalityStats = g;
                }
                set multiViewStats(g) {
                    this.data.multiViewStats = g;
                }
                set videoCapabilities(g) {
                    if (!(g === null || g === void 0 ? void 0 : g.codecs)) return;
                    const f = [];
                    g.codecs.forEach((g)=>{
                        if ("h264" === g.mimeType && g.sdpFmtpLine) {
                            var _WE_exec;
                            const S = (_WE_exec = WE.exec(g.sdpFmtpLine)) === null || _WE_exec === void 0 ? void 0 : _WE_exec[1];
                            S && f.push(S);
                        }
                    }), this.data.H264Profiles = [
                        ...new Set(this.data.H264Profiles.concat(f))
                    ];
                }
                setSupportedH264Profiles(g, f) {
                    if (!(g === null || g === void 0 ? void 0 : g.codecs) && !(f === null || f === void 0 ? void 0 : f.codecs)) return;
                    const extractProfiles = (g)=>{
                        var _g_codecs;
                        const f = [];
                        return (_g_codecs = g.codecs) === null || _g_codecs === void 0 ? void 0 : _g_codecs.forEach((g)=>{
                            if ("h264" === g.mimeType && g.sdpFmtpLine) {
                                var _WE_exec;
                                const S = (_WE_exec = WE.exec(g.sdpFmtpLine)) === null || _WE_exec === void 0 ? void 0 : _WE_exec[1];
                                S && !f.includes(S) && f.push(S);
                            }
                        }), f;
                    };
                    this.data.h264CodecCapabilities.sendProfiles = extractProfiles(g), this.data.h264CodecCapabilities.receiveProfiles = extractProfiles(f);
                }
                set sentBWSeed(g) {
                    var f;
                    var _initialBWSeed;
                    (_initialBWSeed = (f = this.data).initialBWSeed) !== null && _initialBWSeed !== void 0 ? _initialBWSeed : f.initialBWSeed = g, this.data.sentBWSeed = g;
                }
                reportedSendBandwidthLayouts(g) {
                    arrayLimitedPush2(this.data.reportedSendBandwidthLayouts, g, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                }
                set maxSessionBandwidth(g) {
                    this.data.maxSessionBandwidth = g;
                }
                set bwStabilizationTime(g) {
                    this.data.bwStabilizationTime = g;
                }
                set bwDownlinkStabilizationTime(g) {
                    this.data.bwDownlinkStabilizationTime = g;
                }
                set statsOnSubscribed(g) {
                    this.data.statsOnSubscribed = g;
                }
                set loopIntervalMax(g) {
                    this.data.loopIntervalMax = g;
                }
                set loopIntervalMedian(g) {
                    this.data.loopIntervalMedian = g;
                }
                set fetchTimeMax(g) {
                    this.data.fetchTimeMax = g;
                }
                set fetchTimeMedian(g) {
                    this.data.fetchTimeMedian = g;
                }
                set simulcastReport(g) {
                    this.data.simulcast = g;
                }
                setTotalVideoRecvMblocksRates(g) {
                    this.data.totalVideoRecvMblocksRates = g;
                }
                set dataChannelSessionState(g) {
                    this.data.dataChannelSessionState = g;
                }
                set createChannelFailReason(g) {
                    this.data.dataChannelCreationError = g;
                }
                setCandidateDetails(g) {
                    "host" === g.type && "udp" === g.protocol ? (this.data.numInterfaces++, this.data.IPAddress || (this.data.IPAddress = g.ip)) : "srflx" !== g.type || this.data.reflexiveLocalIP || (this.data.reflexiveLocalIP = g.ip);
                }
                setAudioSendStream(g, f) {
                    if (this.configProvider.config.useAudioAnalyzer) {
                        var _this_analyzerSharing, _this_analyzer;
                        const S = new RC(g.rawStream);
                        "ScreenShare" === f && g.hasAudio() ? ((_this_analyzerSharing = this.analyzerSharing) === null || _this_analyzerSharing === void 0 ? void 0 : _this_analyzerSharing.dispose(), this.analyzerSharing = S) : "Audio" === f && ((_this_analyzer = this.analyzer) === null || _this_analyzer === void 0 ? void 0 : _this_analyzer.dispose(), this.analyzer = S);
                    }
                }
                addNetworkInfo(g) {
                    arrayLimitedPush2(this.data.networkInfo, g, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                }
                addIceCandidateError(g) {
                    this.data.iceCandidateErrors.push(g);
                }
                clearIceCandidateErrors() {
                    this.data.iceCandidateErrors = [];
                }
                registerEarlyMediaPoll() {
                    this.data.earlyMediaNumStatsPolls++;
                }
                addReportedReceiveBandwidth(g) {
                    arrayLimitedPush2(this.data.reportedReceiveBandwidth, g, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                }
                addOvcSubscriptionReport(g, f, S) {
                    const v = this.data.ovcToSubscriptionEvents[this.data.ovcToSubscriptionEvents.length - 1];
                    (v === null || v === void 0 ? void 0 : v.ovc.count) !== g && arrayLimitedPush2(this.data.ovcToSubscriptionEvents, {
                        ovc: {
                            ts: Date.now(),
                            count: g,
                            subsCount: f,
                            ...S
                        },
                        subs: []
                    }, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                }
                addSubscriptionToOvcEvent(g) {
                    const f = this.data.ovcToSubscriptionEvents[this.data.ovcToSubscriptionEvents.length - 1];
                    f && f.subs.push({
                        ts: Date.now(),
                        count: g
                    });
                }
                addStatsReport(g) {
                    arrayLimitedPush2(this.data.statsReports, g, this.configProvider.config.diagnostics.collectionLimits.numStatsReports);
                }
                addStatsError(g, f) {
                    const S = this.data.statsErrors.find((S)=>S.error === f && S.origin === g);
                    S ? S.count++ : arrayLimitedPush2(this.data.statsErrors, {
                        origin: g,
                        error: f,
                        count: 1
                    }, this.configProvider.config.diagnostics.collectionLimits.numStatsErrors), this.addSessionStatsError(`nativeSession:${g}`, f);
                }
                setPresentationAudioOnScreenSharing(g, f) {
                    this.presentationAudioTelemetry.updateScreenSharingStream(g, f);
                }
                handlePresentationAudioInputLevel() {
                    this.presentationAudioTelemetry.handleInputLevel("Audio", this.audioLevel), this.presentationAudioTelemetry.handleInputLevel("ScreenShare", this.sharingAudioLevel);
                }
                terminate() {
                    var _this_analyzer, _this_analyzerSharing;
                    this.data.endTime = Date.now(), (_this_analyzer = this.analyzer) === null || _this_analyzer === void 0 ? void 0 : _this_analyzer.dispose(), this.analyzer = null, (_this_analyzerSharing = this.analyzerSharing) === null || _this_analyzerSharing === void 0 ? void 0 : _this_analyzerSharing.dispose(), this.analyzerSharing = null;
                }
                newQualityManagerDiagnostics() {
                    const g = new qC(this.configProvider, (g, f)=>this.addStatsError(`qualityManagerDiagnostics:${g}`, f));
                    return this.data.qualityManager = g.getObjectRef(), g;
                }
                newRemoteVideoManagerDiagnostics() {
                    const g = new WC(this.configProvider);
                    return this.data.remoteVideoManager = g.getObjectRef(), g;
                }
                newNegotiationDiagnostics(g) {
                    const f = new $E(this.configProvider, g);
                    return this.data.negotiation = f.getObjectRef(), f;
                }
                newSubscriptionManagerDiagnostics() {
                    const g = new GC(this.configProvider, (g)=>this.addStatsError("subscriptionManagerDiagnostics", g));
                    return this.data.subscriptionManager = g.getObjectRef(), g;
                }
                newDataChannelDiagnostics(g) {
                    const f = new ya(g);
                    return this.data.dataChannel = f.getObjectRef(), f;
                }
                newTransportStateDiagnostics() {
                    const g = new GE(this.configProvider);
                    return this.data.transportState = g.getObjectRef(), g;
                }
                set encodedStreamWorker(g) {
                    this.data.encodedStreamWorker = g;
                }
                set audioCodecEvents(g) {
                    this.data.audioCodecEvents = g;
                }
                getObjectRef() {
                    return this.data;
                }
                registerVideoPerformanceEvent(g, f, S) {
                    const v = {
                        type: f,
                        perfEvent: g,
                        resRequestEvent: null,
                        resChangedEvent: [],
                        perfConstrainedOvc: S
                    };
                    arrayLimitedPush2(this.data.videoPerformanceEvent, v, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                }
                registerLocalVideoPerformanceEvent(g) {
                    arrayLimitedPush2(this.data.localVideoPerformanceEvents, {
                        timestamp: Date.now(),
                        description: g.description,
                        activeModalities: g.activeModalities,
                        isTransient: g.isTransient
                    }, this.configProvider.config.diagnostics.collectionLimits.numPerformanceEvents);
                }
                registerResolutionChangeRequest(g) {
                    const f = this.data.videoPerformanceEvent[this.data.videoPerformanceEvent.length - 1];
                    f && (f.resRequestEvent = g);
                }
                registerResolutionChangeEvent(g) {
                    var _f_resRequestEvent;
                    const f = this.data.videoPerformanceEvent[this.data.videoPerformanceEvent.length - 1];
                    g.ts - (f === null || f === void 0 ? void 0 : (_f_resRequestEvent = f.resRequestEvent) === null || _f_resRequestEvent === void 0 ? void 0 : _f_resRequestEvent.ts) < this.configProvider.config.diagnostics.performanceMonitoring.telemetryResolutionRequestSpanMs && f.resChangedEvent.push(g);
                }
                set contributingSourcesError(g) {
                    this.data.contributingSourcesError = g;
                }
                newAudioRendererDiagnostics() {
                    var _this_getSessionRef, _this;
                    return this.data.audioRenderer = (_this_getSessionRef = (_this = this).getSessionRef) === null || _this_getSessionRef === void 0 ? void 0 : _this_getSessionRef.call(_this).audioRenderer, this.data.audioRenderer ? new jE(this.data.audioRenderer) : null;
                }
                constructor(g, f, S = ()=>{}, v = ()=>this, _ = ()=>{}, C = new VC, E){
                    this.configProvider = g, this.dmDiagnostics = f, this.addSessionStatsError = S, this.newNativeSession = v, this.commitNativeSession = _, this.dshDiagnostics = C, this.getSessionRef = E, this.data = {
                        startTime: Date.now(),
                        duration: 0,
                        relayCandidate: "none",
                        iceTransportPolicy: "none",
                        iceServers: "none",
                        sdpSemantics: "none",
                        bundlePolicy: "none",
                        iceCandidateErrors: [],
                        H264Profiles: [],
                        h264CodecCapabilities: {
                            sendProfiles: [],
                            receiveProfiles: []
                        },
                        numInterfaces: 0,
                        statsReports: [],
                        aggregatedModalityStats: {},
                        multiViewStats: [],
                        networkInfo: [],
                        statsErrors: [],
                        statsOnSubscribed: {},
                        negotiation: {},
                        recvVideoStreamCount: {
                            min: 0,
                            max: 0,
                            mode: 0
                        },
                        reportedReceiveBandwidth: [],
                        reportedSendBandwidthLayouts: [],
                        encodedStreamWorker: !1,
                        audioCodecEvents: "none",
                        totalVideoRecvMblocksRates: {
                            macroblockRateReceivedMax: 0,
                            macroblockRateReceivedAvg: 0,
                            macroblockRateDecodedMax: 0,
                            macroblockRateDecodedAvg: 0,
                            macroblockRateMaxDecoderLossPercent: 0,
                            macroblockRateDecoderLossPercent: 0
                        },
                        loopIntervalMax: -1,
                        loopIntervalMedian: -1,
                        fetchTimeMax: -1,
                        fetchTimeMedian: -1,
                        videoPerformanceEvent: [],
                        localVideoPerformanceEvents: [],
                        ovcToSubscriptionEvents: [],
                        presentationAPIUserDuration: 0,
                        presentationAudioDuration: 0,
                        earlyMediaNumStatsPolls: 0,
                        audioRenderer: null
                    }, this.presentationAudioTelemetry = new UE, addGetterFields(this.data, {
                        duration: ()=>this.data.endTime ? this.data.endTime - this.data.startTime : Date.now() - this.data.startTime,
                        bandwidthReport: ()=>{
                            var _this_bandwidthStatsRef;
                            return (_this_bandwidthStatsRef = this.bandwidthStatsRef) === null || _this_bandwidthStatsRef === void 0 ? void 0 : _this_bandwidthStatsRef.getBandwidthReport();
                        },
                        presentationAPIUserDuration: ()=>this.presentationAudioTelemetry.getPresentationAudioAPIUserDuration(),
                        presentationAudioDuration: ()=>this.presentationAudioTelemetry.getPresentationAudioDuration()
                    }), Object.defineProperty(this.data, "IPAddress", {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }), Object.defineProperty(this.data, "reflexiveLocalIP", {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    });
                }
            }, KE = Symbol("sessionDiagnosticsRef"), JE = class {
                get telemetryReport() {
                    const g = {
                        type: "WebRtcMediaStats",
                        data: this.diagnosticsReport.getSessionTelemetry(this.data.sessionId)
                    }, f = {};
                    return forOwnRec(g.data, (g, S, v)=>{
                        let _ = 0;
                        os.test(g) ? (_ = 13, f[S] = "IPv4") : ls.test(g) && (_ = 4, f[S] = "IPv6"), v[S] = {
                            type: _,
                            value: g,
                            __VALUE__: !0
                        };
                    }), g.data.metrics.piiFields = {
                        type: 0,
                        value: JSON.stringify(f),
                        __VALUE__: !0
                    }, g;
                }
                get mediaStatsReport() {
                    return this.diagnosticsReport.getMediaSessionStats(this.data.sessionId);
                }
                get realtimeTelemetryReport() {
                    return this.diagnosticsReport.getTeamsRealtimeTelemetry(this.data.sessionId);
                }
                get e2eDiagnostics() {
                    return this.diagnosticsReport.getDiagnosticsForE2eTests(this.data.sessionId);
                }
                set relayManager(g) {
                    this._relayManager = g;
                }
                set isMultiParty(g) {
                    this.data.isMultiParty = g;
                }
                set mediaLegId(g) {
                    this.data.mediaLegId = g.process();
                }
                set ETag(g) {
                    this.data.ETag = g;
                }
                set configIds(g) {
                    this.data.configIds = g;
                }
                set reconnect(g) {
                    this.data.reconnect = g;
                }
                set relay(g) {
                    this.data.relay = {
                        address: g.addresses.join(),
                        expires: g.expires,
                        realm: g.realm,
                        credentials: !(!g.username || !g.password),
                        ports: [
                            g.udpPort ? `udp:${g.udpPort}` : "",
                            g.tcpPort ? `tcp:${g.tcpPort}` : "",
                            g.tlsPort ? `tls:${g.tlsPort}` : ""
                        ].join(","),
                        fqdns: g.fqdns ? g.fqdns.join() : "none"
                    };
                }
                set sessionError(g) {
                    this.data.error = g;
                }
                set dtmfResult(g) {
                    g ? this.data.dtmfSuccessCount++ : this.data.dtmfFailureCount++;
                }
                set swMute(g) {
                    g ? this.swMuteTracker.start() : this.swMuteTracker.stop(), this.updateCommonMute();
                }
                set speakerMute(g) {
                    g ? this.speakerMuteTracker.start() : this.speakerMuteTracker.stop();
                }
                set hwSilent(g) {
                    g ? this.hwSilentTracker.start() : this.hwSilentTracker.stop();
                }
                set isSpeaking(g) {
                    g ? this.isSpeakingTracker.start() : this.isSpeakingTracker.stop();
                }
                set iceInitTime(g) {
                    this.data.iceInitTime || (this.data.iceInitTime = g);
                }
                set finalAnswerTime(g) {
                    this.data.finalAnswerTime || (this.data.finalAnswerTime = g);
                }
                set iceConnectedStateTimestamp(g) {
                    this.data.iceConnectedStateTime || (this.data.iceConnectedStateTime = g);
                }
                set allowedModalities(g) {
                    this.data.allowedAudioSend = g.audio.some((g)=>hasSendDirectionality(g)), this.data.allowedVideoSend = g.video.some((g)=>hasSendDirectionality(g)), this.data.allowedScreensharingSend = g.sharing.some((g)=>hasSendDirectionality(g));
                }
                negotiationStart(g) {
                    var f;
                    var _initialNegotiationType;
                    (_initialNegotiationType = (f = this.data).initialNegotiationType) !== null && _initialNegotiationType !== void 0 ? _initialNegotiationType : f.initialNegotiationType = g, this.data.negotiationCount++;
                }
                negotiationCompleted(g) {
                    this.data.initialNegotiationCompleted = !0, this.data.activeModalities = g, this.data.error = void 0;
                }
                negotiationRejected() {
                    this.data.rejectedNegotiationCount++;
                }
                registerRollbackEvent(g) {
                    this.data.rollbackNegotiation.push({
                        type: g.type,
                        attempt: this.data.rollbackNegotiation.length + 1,
                        error: g.error
                    });
                }
                registerRawMediaAccess(g, f, S) {
                    var _this_data_rawMedia_g;
                    const v = (_this_data_rawMedia_g = this.data.rawMedia[g]) === null || _this_data_rawMedia_g === void 0 ? void 0 : _this_data_rawMedia_g[f];
                    if (v) {
                        var _this_rawMediaTimers_g;
                        v.numAttempts++;
                        const _ = (_this_rawMediaTimers_g = this.rawMediaTimers[g]) === null || _this_rawMediaTimers_g === void 0 ? void 0 : _this_rawMediaTimers_g[f];
                        S ? _ === null || _ === void 0 ? void 0 : _.start() : _ === null || _ === void 0 ? void 0 : _.stop();
                    }
                }
                registerQualityStateChangedEvent(g) {
                    switch(g.type){
                        case "NoNetwork":
                            "Good" === g.value ? this.data.noIceCandidatesEventCount.good++ : this.data.noIceCandidatesEventCount.bad++;
                            break;
                        case "NetworkRelaysNotReachable":
                            "Good" === g.value ? this.data.noRelayIceCandidatesEventCount.good++ : this.data.noRelayIceCandidatesEventCount.bad++;
                            break;
                        case "DeviceCaptureNotFunctioning":
                            this.deviceCaptureTracker.updateLevel(g.value), "Good" === g.value ? this.data.microphoneInUseEventCount.good++ : this.data.microphoneInUseEventCount.bad++;
                            break;
                        case "DeviceRenderNotFunctioning":
                            this.deviceRenderTracker.updateLevel(g.value);
                            break;
                        case "VideoCapturerDeviceStartFailed":
                            "Good" === g.value ? this.data.cameraInUseEventCount.good++ : this.data.cameraInUseEventCount.bad++;
                            break;
                        case "DeviceCaptureMute":
                            "Bad" === g.value ? this.osMuteTracker.start() : this.osMuteTracker.stop(), this.updateCommonMute();
                            break;
                        case "NetworkRecvQuality":
                            this.networkRecvTracker.updateLevel(g.value);
                            break;
                        case "NetworkSendQuality":
                            this.networkSendTracker.updateLevel(g.value);
                            break;
                        case "ZeroCaptureDevicesEnumerated":
                            this.zeroCaptureTracker.updateLevel(g.value);
                            break;
                        case "ZeroRenderDevicesEnumerated":
                            this.zeroRenderTracker.updateLevel(g.value);
                            break;
                        case "VideoCaptureDeviceFreeze":
                            "Good" === g.value ? this.data.cameraFreezeEventCount.end++ : this.data.cameraFreezeEventCount.start++;
                    }
                    "DeviceSpeakWhileMuted" !== g.type && arrayLimitedPush2(this.data.ufds, {
                        ...g,
                        timestamp: Date.now()
                    }, this.configProvider.config.diagnostics.collectionLimits.numUFDs);
                }
                registerRemoteQualityStateChangedEvent(g, f) {
                    arrayLimitedPush2(this.data.remoteUfds, {
                        ...g,
                        participantId: f,
                        timestamp: Date.now()
                    }, this.configProvider.config.diagnostics.collectionLimits.numUFDs);
                }
                registerTransportConnected() {
                    this.transportDisconnected && (this.transportDisconnected = !1, this.data.transportReconnectedCount++);
                }
                registerTransportDisconnected() {
                    this.transportDisconnected = !0;
                }
                registerTransportFailed() {
                    this.transportDisconnected = !1;
                }
                terminated(g) {
                    this.commonMuteTracker.stop(), this.swMuteTracker.stop(), this.osMuteTracker.stop(), this.speakerMuteTracker.stop(), this.hwSilentTracker.stop(), this.isSpeakingTracker.stop(), this.rawMediaTimers.audio.recv.stop(), this.rawMediaTimers.audio.send.stop(), this.networkSendTracker.dispose(), this.networkRecvTracker.dispose(), this.zeroCaptureTracker.dispose(), this.zeroRenderTracker.dispose(), this.deviceCaptureTracker.dispose(), this.data.terminationReason = deepClone(g), this.data.terminationTime = Date.now(), this.durationTimer.stop(), this.dmFragmenter.terminated(this.dmDiagnostics);
                }
                addStatsError(g, f) {
                    const S = this.data.statsErrors.find((S)=>S.error === f && S.origin === g);
                    var _S_count;
                    this.logger.safe.error(`Stats error from '${g}': ${f} (${(_S_count = S === null || S === void 0 ? void 0 : S.count) !== null && _S_count !== void 0 ? _S_count : 1})`), S ? S.count++ : arrayLimitedPush2(this.data.statsErrors, {
                        origin: g,
                        error: f,
                        count: 1
                    }, this.configProvider.config.diagnostics.collectionLimits.numStatsErrors);
                }
                newNativeSessionDiag(g = !0) {
                    let f;
                    return f = new zE(this.configProvider, this.dmDiagnostics, (g, f)=>this.addStatsError(g, f), (g)=>this.newNativeSessionDiag(g), ()=>this.pushNativeSessionDiag(f.getObjectRef()), this.dshDiagnostics.resetState(), ()=>this.getObjectRef()), g && arrayLimitedPush2(this.data.webrtcSessions, f.getObjectRef(), this.configProvider.config.diagnostics.collectionLimits.numNativeSessions), f;
                }
                pushNativeSessionDiag(g) {
                    arrayLimitedPush2(this.data.webrtcSessions, g, this.configProvider.config.diagnostics.collectionLimits.numNativeSessions);
                }
                getObjectRef() {
                    return this.data;
                }
                updateCommonMute() {
                    this.swMuteTracker.isRunning || this.osMuteTracker.isRunning ? this.commonMuteTracker.start() : this.swMuteTracker.isRunning || this.osMuteTracker.isRunning || this.commonMuteTracker.stop();
                }
                registerElevation(g) {
                    arrayLimitedPush(this.data.elevation, {
                        event: g,
                        timestamp: Date.now()
                    }, this.configProvider.config.diagnostics.collectionLimits.numElevation);
                }
                constructor(g, f, S, v, _, C){
                    this.logger = g, this.configProvider = f, this.diagnosticsReport = S, this.dmDiagnostics = v, this.dshDiagnostics = new VC, this.data = {
                        creationTime: Date.now(),
                        callNumber: 0,
                        sessionId: "unknown",
                        isMultiParty: !1,
                        dtmfSuccessCount: 0,
                        dtmfFailureCount: 0,
                        iceInitTime: 0,
                        iceConnectedStateTime: 0,
                        negotiationCount: 0,
                        rejectedNegotiationCount: 0,
                        initialNegotiationCompleted: !1,
                        finalAnswerTime: 0,
                        transportReconnectedCount: 0,
                        rollbackNegotiation: [],
                        activeModalities: {},
                        allowedAudioSend: !0,
                        allowedVideoSend: !0,
                        allowedScreensharingSend: !0,
                        noIceCandidatesEventCount: {
                            good: 0,
                            bad: 0
                        },
                        noRelayIceCandidatesEventCount: {
                            good: 0,
                            bad: 0
                        },
                        microphoneInUseEventCount: {
                            good: 0,
                            bad: 0
                        },
                        cameraInUseEventCount: {
                            good: 0,
                            bad: 0
                        },
                        cameraFreezeEventCount: {
                            start: 0,
                            end: 0
                        },
                        rawMedia: {
                            audio: {
                                recv: {
                                    numAttempts: 0,
                                    durationRatio: 0
                                },
                                send: {
                                    numAttempts: 0,
                                    durationRatio: 0
                                }
                            }
                        },
                        ufds: [],
                        remoteUfds: [],
                        statsErrors: [],
                        webrtcSessions: [],
                        isOngoing: !1,
                        duration: 0,
                        callMutedRatio: 0,
                        callOsMuted: 0,
                        callHwSilent: 0,
                        callSwMuted: 0,
                        callIsMuted: !1,
                        callSpeakerMuted: 0,
                        callIsSpeaking: 0,
                        networkRecvUFD: void 0,
                        networkSendUFD: void 0,
                        zeroCaptureDevicesRatio: 0,
                        zeroRenderDevicesRatio: 0,
                        deviceRenderFailuresRatio: 0,
                        deviceCaptureFailuresRatio: 0,
                        deviceManager: void 0,
                        relayTimers: void 0,
                        authTokenFetcherStats: void 0,
                        dominantSpeaker: this.dshDiagnostics.getObjectRef(),
                        [KE]: this,
                        callConstraints: [],
                        audioRenderer: {
                            sinkNumOfReopenRequests: 0,
                            sinkNumOfSuccessfulReopens: 0
                        },
                        elevation: []
                    }, this.transportDisconnected = !1, this.commonMuteTracker = new QE, this.swMuteTracker = new QE, this.osMuteTracker = new QE, this.speakerMuteTracker = new QE, this.hwSilentTracker = new QE, this.isSpeakingTracker = new QE, this.networkRecvTracker = new XE, this.networkSendTracker = new XE, this.zeroCaptureTracker = new XE, this.zeroRenderTracker = new XE, this.deviceRenderTracker = new XE, this.deviceCaptureTracker = new XE, this.rawMediaTimers = {
                        audio: {
                            send: new QE,
                            recv: new QE
                        }
                    }, this.dmFragmenter = new YE(this.dmDiagnostics), this.durationTimer = new QE, this.data.callNumber = _, this.data.sessionId = C, this.durationTimer.start(), addGetterFields(this.data, {
                        isOngoing: ()=>void 0 === this.data.terminationTime,
                        duration: ()=>this.durationTimer.elapsed,
                        callMutedRatio: ()=>getDurationRatio(this.commonMuteTracker.elapsed, this.data.duration),
                        callOsMuted: ()=>this.osMuteTracker.elapsed,
                        callHwSilent: ()=>this.hwSilentTracker.elapsed,
                        callSwMuted: ()=>this.swMuteTracker.elapsed,
                        callIsMuted: ()=>this.swMuteTracker.isRunning,
                        callSpeakerMuted: ()=>this.speakerMuteTracker.elapsed,
                        callIsSpeaking: ()=>this.isSpeakingTracker.elapsed,
                        zeroCaptureDevicesRatio: ()=>this.zeroCaptureTracker.getRatio("Bad"),
                        zeroRenderDevicesRatio: ()=>this.zeroRenderTracker.getRatio("Bad"),
                        deviceRenderFailuresRatio: ()=>this.deviceRenderTracker.getRatio("Bad"),
                        deviceCaptureFailuresRatio: ()=>this.deviceCaptureTracker.getRatio("Bad"),
                        networkRecvUFD: ()=>({
                                good: this.networkRecvTracker.getCount("Good"),
                                poor: this.networkRecvTracker.getCount("Poor"),
                                bad: this.networkRecvTracker.getCount("Bad"),
                                goodRatio: this.networkRecvTracker.getRatio("Good"),
                                poorRatio: this.networkRecvTracker.getRatio("Poor"),
                                badRatio: this.networkRecvTracker.getRatio("Bad")
                            }),
                        networkSendUFD: ()=>({
                                good: this.networkSendTracker.getCount("Good"),
                                poor: this.networkSendTracker.getCount("Poor"),
                                bad: this.networkSendTracker.getCount("Bad"),
                                goodRatio: this.networkSendTracker.getRatio("Good"),
                                poorRatio: this.networkSendTracker.getRatio("Poor"),
                                badRatio: this.networkSendTracker.getRatio("Bad")
                            }),
                        deviceManager: ()=>this.dmFragmenter.getFragment(this.dmDiagnostics),
                        relayTimers: ()=>{
                            var _this__relayManager;
                            return (_this__relayManager = this._relayManager) === null || _this__relayManager === void 0 ? void 0 : _this__relayManager.getStats();
                        },
                        authTokenFetcherStats: ()=>{
                            var _this__relayManager;
                            return (_this__relayManager = this._relayManager) === null || _this__relayManager === void 0 ? void 0 : _this__relayManager.getAuthTokenStats();
                        },
                        callConstraints: ()=>this.configProvider.getCallConstraintsTelemetry()
                    }), addGetterFields(this.data.rawMedia.audio.recv, {
                        durationRatio: ()=>getDurationRatio(this.rawMediaTimers.audio.recv.elapsed, this.data.duration)
                    }), addGetterFields(this.data.rawMedia.audio.send, {
                        durationRatio: ()=>getDurationRatio(this.rawMediaTimers.audio.send.elapsed, this.data.duration)
                    });
                }
            }, YE = class {
                getFragment(g) {
                    var _this_fragmentTerminated;
                    const f = (_this_fragmentTerminated = this.fragmentTerminated) !== null && _this_fragmentTerminated !== void 0 ? _this_fragmentTerminated : g;
                    return {
                        devicesChangeCount: f.devicesChangeCount - this.fragmentBase.devicesChangeCount,
                        deviceSelectionChangeCount: f.deviceSelectionChangeCount - this.fragmentBase.deviceSelectionChangeCount,
                        deviceSelectionChangeCountFromInterface: f.deviceSelectionChangeCountFromInterface - this.fragmentBase.deviceSelectionChangeCountFromInterface,
                        devicesPollChangeCount: f.devicesPollChangeCount - this.fragmentBase.devicesPollChangeCount,
                        audioSourceNumOfSuccessfulReopens: f.audioSourceNumOfSuccessfulReopens - this.fragmentBase.audioSourceNumOfSuccessfulReopens || void 0,
                        audioSourceNumOfReopenRequests: f.audioSourceNumOfReopenRequests - this.fragmentBase.audioSourceNumOfReopenRequests || void 0,
                        audioCaptureDeviceErrorFlag: g.audioCaptureDeviceErrorFlags.filter((g)=>g.timestamp > this.initTimestamp && g.timestamp < this.terminatedTimestamp).reduce((g, f)=>Number(BigInt(g) | BigInt(f.audioDeviceErrorFlag)), 0),
                        audioRenderDeviceErrorFlag: g.audioRenderDeviceErrorFlags.filter((g)=>g.timestamp > this.initTimestamp && g.timestamp < this.terminatedTimestamp).reduce((g, f)=>Number(BigInt(g) | BigInt(f.audioDeviceErrorFlag)), 0)
                    };
                }
                terminated(g) {
                    this.fragmentTerminated = this.sanitizeDiagnostics(g), this.terminatedTimestamp = Date.now();
                }
                sanitizeDiagnostics(g) {
                    return {
                        devicesChangeCount: g.devicesChangeCount,
                        deviceSelectionChangeCount: g.deviceSelectionChangeCount,
                        deviceSelectionChangeCountFromInterface: g.deviceSelectionChangeCountFromInterface,
                        devicesPollChangeCount: g.devicesPollChangeCount,
                        audioSourceNumOfSuccessfulReopens: g.audioSourceNumOfSuccessfulReopens,
                        audioSourceNumOfReopenRequests: g.audioSourceNumOfReopenRequests,
                        audioCaptureDeviceErrorFlag: 0,
                        audioRenderDeviceErrorFlag: 0
                    };
                }
                constructor(g){
                    this.initTimestamp = Number.MIN_SAFE_INTEGER, this.terminatedTimestamp = Number.MAX_SAFE_INTEGER, this.fragmentBase = this.sanitizeDiagnostics(g), this.initTimestamp = Date.now();
                }
            }, QE = class {
                get isRunning() {
                    return !!this.startTime;
                }
                get elapsed() {
                    return Math.round(this.startTime ? this.elapsedInternal + Kt() - this.startTime : this.elapsedInternal);
                }
                get count() {
                    return this.countInternal;
                }
                start() {
                    this.startTime || (this.startTime = Kt(), this.countInternal++);
                }
                stop() {
                    this.startTime && (this.elapsedInternal += Kt() - this.startTime, this.startTime = 0);
                }
                constructor(){
                    this.startTime = 0, this.elapsedInternal = 0, this.countInternal = 0;
                }
            }, XE = class {
                updateLevel(g) {
                    this.currentLevel !== g && (this.getStopWatch(this.currentLevel).stop(), this.currentLevel = g, this.getStopWatch(this.currentLevel).start());
                }
                getCount(g) {
                    const f = this.stopWatches[g];
                    return f ? f.count : 0;
                }
                getRatio(g) {
                    return getDurationRatio(this.getStopWatch(g).elapsed, Math.round((this.endTime || Kt()) - this.startTime));
                }
                dispose(g) {
                    this.getStopWatch(this.currentLevel).stop(), this.endTime = Kt();
                }
                getStopWatch(g) {
                    let f = this.stopWatches[g];
                    return f || (f = new QE, this.stopWatches[g] = f), f;
                }
                constructor(){
                    this.currentLevel = "Good", this.stopWatches = {}, this.startTime = Kt(), this.getStopWatch(this.currentLevel).start();
                }
            };
            function getDurationRatio(g, f) {
                return g / (f || 1);
            }
            function compileAudioReport(g, f, S) {
                var _g_audio, _g_audio1, _g_audio2, _f_codec, _f_track, _f_transport, _f_transport1, _f_transport2, _f_transport3, _f_transport_selectedCandidatePair, _f_transport4, _g_audio3, _g_audio4, _f_transport_selectedCandidatePair_remoteCandidate, _f_transport_selectedCandidatePair1, _f_transport5, _g_audio5, _f_transport_selectedCandidatePair_localCandidate, _f_transport_selectedCandidatePair2, _f_transport6, _f_transport_selectedCandidatePair_localCandidate1, _f_transport_selectedCandidatePair3, _f_transport7, _f_transport_selectedCandidatePair4, _f_transport8, _g_audio6, _g_audio7, _f_transport_selectedCandidatePair5, _f_transport9, _f_transport_selectedCandidatePair6, _f_transport10, _g_audio8, _g_audio9, _f_transport_selectedCandidatePair_remoteCandidate1, _f_transport_selectedCandidatePair7, _f_transport11, _f_transport_selectedCandidatePair_localCandidate2, _f_transport_selectedCandidatePair8, _f_transport12, _g_audio10, _f_transport_selectedCandidatePair_localCandidate3, _f_transport_selectedCandidatePair9, _f_transport13, _f_transport_selectedCandidatePair_localCandidate4, _f_transport_selectedCandidatePair10, _f_transport14, _f_transport_selectedCandidatePair_remoteCandidate2, _f_transport_selectedCandidatePair11, _f_transport15, _f_transport_selectedCandidatePair_remoteCandidate3, _f_transport_selectedCandidatePair12, _f_transport16, _g_audio11, _f_transport_selectedCandidatePair13, _f_transport17, _g_audio12, _g_audio13, _g_audio14, _S_codec, _S_track, _S_transport, _S_transport1, _S_transport2, _S_transport3, _S_transport_selectedCandidatePair, _S_transport4, _g_audio15, _g_audio16, _S_transport_selectedCandidatePair_remoteCandidate, _S_transport_selectedCandidatePair1, _S_transport5, _g_audio17, _S_transport_selectedCandidatePair_localCandidate, _S_transport_selectedCandidatePair2, _S_transport6, _S_transport_selectedCandidatePair_localCandidate1, _S_transport_selectedCandidatePair3, _S_transport7, _S_transport_selectedCandidatePair4, _S_transport8, _g_audio18, _g_audio19, _S_transport_selectedCandidatePair5, _S_transport9, _S_transport_selectedCandidatePair6, _S_transport10, _g_audio20, _g_audio21, _S_transport_selectedCandidatePair_remoteCandidate1, _S_transport_selectedCandidatePair7, _S_transport11, _S_transport_selectedCandidatePair_localCandidate2, _S_transport_selectedCandidatePair8, _S_transport12, _g_audio22, _S_transport_selectedCandidatePair_localCandidate3, _S_transport_selectedCandidatePair9, _S_transport13, _S_transport_selectedCandidatePair_localCandidate4, _S_transport_selectedCandidatePair10, _S_transport14, _S_transport_selectedCandidatePair_remoteCandidate2, _S_transport_selectedCandidatePair11, _S_transport15, _S_transport_selectedCandidatePair_remoteCandidate3, _S_transport_selectedCandidatePair12, _S_transport16, _g_audio23, _S_transport_selectedCandidatePair13, _S_transport17;
                var _f_inboundRTP_mediaType, _f_transport_selectedCandidatePair_localCandidate_ip, _f_transport_selectedCandidatePair_remoteCandidate_ip, _S_outboundRTP_mediaType, _S_transport_selectedCandidatePair_localCandidate_ip, _S_transport_selectedCandidatePair_remoteCandidate_ip;
                return removeUndefinedFields({
                    recv: removeUndefinedFields({
                        id: f === null || f === void 0 ? void 0 : f.inboundRTP.id,
                        ssrc: f === null || f === void 0 ? void 0 : f.inboundRTP.ssrc,
                        mediaType: (_f_inboundRTP_mediaType = f === null || f === void 0 ? void 0 : f.inboundRTP.mediaType) !== null && _f_inboundRTP_mediaType !== void 0 ? _f_inboundRTP_mediaType : f === null || f === void 0 ? void 0 : f.inboundRTP.kind,
                        bytesReceived: sampleseries((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : _g_audio.recv, (g)=>g.inboundRTP.bytesReceived),
                        packetsReceived: sampleseries((_g_audio1 = g.audio) === null || _g_audio1 === void 0 ? void 0 : _g_audio1.recv, (g)=>g.inboundRTP.packetsReceived),
                        packetsLost: sampleseries((_g_audio2 = g.audio) === null || _g_audio2 === void 0 ? void 0 : _g_audio2.recv, (g)=>g.inboundRTP.packetsLost),
                        googCodecName: f === null || f === void 0 ? void 0 : (_f_codec = f.codec) === null || _f_codec === void 0 ? void 0 : _f_codec.mimeType.split("/").pop(),
                        googTrackId: f === null || f === void 0 ? void 0 : (_f_track = f.track) === null || _f_track === void 0 ? void 0 : _f_track.trackIdentifier,
                        transport_id: f === null || f === void 0 ? void 0 : (_f_transport = f.transport) === null || _f_transport === void 0 ? void 0 : _f_transport.id,
                        transportId: f === null || f === void 0 ? void 0 : f.inboundRTP.transportId,
                        transport_selectedCandidatePairId: f === null || f === void 0 ? void 0 : (_f_transport1 = f.transport) === null || _f_transport1 === void 0 ? void 0 : _f_transport1.selectedCandidatePairId,
                        transport_dtlsCipher: f === null || f === void 0 ? void 0 : (_f_transport2 = f.transport) === null || _f_transport2 === void 0 ? void 0 : _f_transport2.dtlsCipher,
                        transport_srtpCipher: f === null || f === void 0 ? void 0 : (_f_transport3 = f.transport) === null || _f_transport3 === void 0 ? void 0 : _f_transport3.srtpCipher,
                        pair_id: f === null || f === void 0 ? void 0 : (_f_transport4 = f.transport) === null || _f_transport4 === void 0 ? void 0 : (_f_transport_selectedCandidatePair = _f_transport4.selectedCandidatePair) === null || _f_transport_selectedCandidatePair === void 0 ? void 0 : _f_transport_selectedCandidatePair.id,
                        pair_responsesSent: sampleseries((_g_audio3 = g.audio) === null || _g_audio3 === void 0 ? void 0 : _g_audio3.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesSent;
                        }),
                        pair_requestsReceived: sampleseries((_g_audio4 = g.audio) === null || _g_audio4 === void 0 ? void 0 : _g_audio4.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsReceived;
                        }),
                        pair_googRemoteCandidateType: f === null || f === void 0 ? void 0 : (_f_transport5 = f.transport) === null || _f_transport5 === void 0 ? void 0 : (_f_transport_selectedCandidatePair1 = _f_transport5.selectedCandidatePair) === null || _f_transport_selectedCandidatePair1 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_remoteCandidate = _f_transport_selectedCandidatePair1.remoteCandidate) === null || _f_transport_selectedCandidatePair_remoteCandidate === void 0 ? void 0 : _f_transport_selectedCandidatePair_remoteCandidate.candidateType,
                        pair_consentRequestsSent: sampleseries((_g_audio5 = g.audio) === null || _g_audio5 === void 0 ? void 0 : _g_audio5.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.consentRequestsSent;
                        }),
                        pair_googTransportType: f === null || f === void 0 ? void 0 : (_f_transport6 = f.transport) === null || _f_transport6 === void 0 ? void 0 : (_f_transport_selectedCandidatePair2 = _f_transport6.selectedCandidatePair) === null || _f_transport_selectedCandidatePair2 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_localCandidate = _f_transport_selectedCandidatePair2.localCandidate) === null || _f_transport_selectedCandidatePair_localCandidate === void 0 ? void 0 : _f_transport_selectedCandidatePair_localCandidate.protocol,
                        pair_googLocalCandidateType: f === null || f === void 0 ? void 0 : (_f_transport7 = f.transport) === null || _f_transport7 === void 0 ? void 0 : (_f_transport_selectedCandidatePair3 = _f_transport7.selectedCandidatePair) === null || _f_transport_selectedCandidatePair3 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_localCandidate1 = _f_transport_selectedCandidatePair3.localCandidate) === null || _f_transport_selectedCandidatePair_localCandidate1 === void 0 ? void 0 : _f_transport_selectedCandidatePair_localCandidate1.candidateType,
                        pair_googWritable: f === null || f === void 0 ? void 0 : (_f_transport8 = f.transport) === null || _f_transport8 === void 0 ? void 0 : (_f_transport_selectedCandidatePair4 = _f_transport8.selectedCandidatePair) === null || _f_transport_selectedCandidatePair4 === void 0 ? void 0 : _f_transport_selectedCandidatePair4.writable,
                        pair_requestsSent: sampleseries((_g_audio6 = g.audio) === null || _g_audio6 === void 0 ? void 0 : _g_audio6.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsSent;
                        }),
                        pair_googRtt: sampleseries((_g_audio7 = g.audio) === null || _g_audio7 === void 0 ? void 0 : _g_audio7.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return 1e3 * ((_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.currentRoundTripTime);
                        }, !0),
                        pair_googActiveConnection: f === null || f === void 0 ? void 0 : (_f_transport9 = f.transport) === null || _f_transport9 === void 0 ? void 0 : (_f_transport_selectedCandidatePair5 = _f_transport9.selectedCandidatePair) === null || _f_transport_selectedCandidatePair5 === void 0 ? void 0 : _f_transport_selectedCandidatePair5.nominated,
                        pair_packetsDiscardedOnSend: f === null || f === void 0 ? void 0 : (_f_transport10 = f.transport) === null || _f_transport10 === void 0 ? void 0 : (_f_transport_selectedCandidatePair6 = _f_transport10.selectedCandidatePair) === null || _f_transport_selectedCandidatePair6 === void 0 ? void 0 : _f_transport_selectedCandidatePair6.packetsDiscardedOnSend,
                        pair_bytesReceived: sampleseries((_g_audio8 = g.audio) === null || _g_audio8 === void 0 ? void 0 : _g_audio8.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesReceived;
                        }),
                        pair_responsesReceived: sampleseries((_g_audio9 = g.audio) === null || _g_audio9 === void 0 ? void 0 : _g_audio9.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesReceived;
                        }),
                        pair_remoteCandidateId: f === null || f === void 0 ? void 0 : (_f_transport11 = f.transport) === null || _f_transport11 === void 0 ? void 0 : (_f_transport_selectedCandidatePair7 = _f_transport11.selectedCandidatePair) === null || _f_transport_selectedCandidatePair7 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_remoteCandidate1 = _f_transport_selectedCandidatePair7.remoteCandidate) === null || _f_transport_selectedCandidatePair_remoteCandidate1 === void 0 ? void 0 : _f_transport_selectedCandidatePair_remoteCandidate1.id,
                        pair_localCandidateId: f === null || f === void 0 ? void 0 : (_f_transport12 = f.transport) === null || _f_transport12 === void 0 ? void 0 : (_f_transport_selectedCandidatePair8 = _f_transport12.selectedCandidatePair) === null || _f_transport_selectedCandidatePair8 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_localCandidate2 = _f_transport_selectedCandidatePair8.localCandidate) === null || _f_transport_selectedCandidatePair_localCandidate2 === void 0 ? void 0 : _f_transport_selectedCandidatePair_localCandidate2.id,
                        pair_packetsSent: sampleseries((_g_audio10 = g.audio) === null || _g_audio10 === void 0 ? void 0 : _g_audio10.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.packetsSent;
                        }),
                        pair_googLocalAddress: (_f_transport_selectedCandidatePair_localCandidate_ip = f === null || f === void 0 ? void 0 : (_f_transport13 = f.transport) === null || _f_transport13 === void 0 ? void 0 : (_f_transport_selectedCandidatePair9 = _f_transport13.selectedCandidatePair) === null || _f_transport_selectedCandidatePair9 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_localCandidate3 = _f_transport_selectedCandidatePair9.localCandidate) === null || _f_transport_selectedCandidatePair_localCandidate3 === void 0 ? void 0 : _f_transport_selectedCandidatePair_localCandidate3.ip) !== null && _f_transport_selectedCandidatePair_localCandidate_ip !== void 0 ? _f_transport_selectedCandidatePair_localCandidate_ip : f === null || f === void 0 ? void 0 : (_f_transport14 = f.transport) === null || _f_transport14 === void 0 ? void 0 : (_f_transport_selectedCandidatePair10 = _f_transport14.selectedCandidatePair) === null || _f_transport_selectedCandidatePair10 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_localCandidate4 = _f_transport_selectedCandidatePair10.localCandidate) === null || _f_transport_selectedCandidatePair_localCandidate4 === void 0 ? void 0 : _f_transport_selectedCandidatePair_localCandidate4.address,
                        pair_googRemoteAddress: (_f_transport_selectedCandidatePair_remoteCandidate_ip = f === null || f === void 0 ? void 0 : (_f_transport15 = f.transport) === null || _f_transport15 === void 0 ? void 0 : (_f_transport_selectedCandidatePair11 = _f_transport15.selectedCandidatePair) === null || _f_transport_selectedCandidatePair11 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_remoteCandidate2 = _f_transport_selectedCandidatePair11.remoteCandidate) === null || _f_transport_selectedCandidatePair_remoteCandidate2 === void 0 ? void 0 : _f_transport_selectedCandidatePair_remoteCandidate2.ip) !== null && _f_transport_selectedCandidatePair_remoteCandidate_ip !== void 0 ? _f_transport_selectedCandidatePair_remoteCandidate_ip : f === null || f === void 0 ? void 0 : (_f_transport16 = f.transport) === null || _f_transport16 === void 0 ? void 0 : (_f_transport_selectedCandidatePair12 = _f_transport16.selectedCandidatePair) === null || _f_transport_selectedCandidatePair12 === void 0 ? void 0 : (_f_transport_selectedCandidatePair_remoteCandidate3 = _f_transport_selectedCandidatePair12.remoteCandidate) === null || _f_transport_selectedCandidatePair_remoteCandidate3 === void 0 ? void 0 : _f_transport_selectedCandidatePair_remoteCandidate3.address,
                        pair_bytesSent: sampleseries((_g_audio11 = g.audio) === null || _g_audio11 === void 0 ? void 0 : _g_audio11.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesSent;
                        }),
                        pair_googReadable: f === null || f === void 0 ? void 0 : (_f_transport17 = f.transport) === null || _f_transport17 === void 0 ? void 0 : (_f_transport_selectedCandidatePair13 = _f_transport17.selectedCandidatePair) === null || _f_transport_selectedCandidatePair13 === void 0 ? void 0 : _f_transport_selectedCandidatePair13.nominated
                    }),
                    send: removeUndefinedFields({
                        id: S === null || S === void 0 ? void 0 : S.outboundRTP.id,
                        ssrc: S === null || S === void 0 ? void 0 : S.outboundRTP.ssrc,
                        mediaType: (_S_outboundRTP_mediaType = S === null || S === void 0 ? void 0 : S.outboundRTP.mediaType) !== null && _S_outboundRTP_mediaType !== void 0 ? _S_outboundRTP_mediaType : S === null || S === void 0 ? void 0 : S.outboundRTP.kind,
                        bytesSent: sampleseries((_g_audio12 = g.audio) === null || _g_audio12 === void 0 ? void 0 : _g_audio12.send, (g)=>g.outboundRTP.bytesSent),
                        packetsSent: sampleseries((_g_audio13 = g.audio) === null || _g_audio13 === void 0 ? void 0 : _g_audio13.send, (g)=>g.outboundRTP.packetsSent),
                        packetsLost: sampleseries((_g_audio14 = g.audio) === null || _g_audio14 === void 0 ? void 0 : _g_audio14.send, (g)=>{
                            var _g_remoteInboundRTP;
                            return (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsLost;
                        }),
                        googCodecName: S === null || S === void 0 ? void 0 : (_S_codec = S.codec) === null || _S_codec === void 0 ? void 0 : _S_codec.mimeType.split("/").pop(),
                        googTrackId: S === null || S === void 0 ? void 0 : (_S_track = S.track) === null || _S_track === void 0 ? void 0 : _S_track.trackIdentifier,
                        transport_id: S === null || S === void 0 ? void 0 : (_S_transport = S.transport) === null || _S_transport === void 0 ? void 0 : _S_transport.id,
                        transportId: S === null || S === void 0 ? void 0 : S.outboundRTP.transportId,
                        transport_selectedCandidatePairId: S === null || S === void 0 ? void 0 : (_S_transport1 = S.transport) === null || _S_transport1 === void 0 ? void 0 : _S_transport1.selectedCandidatePairId,
                        transport_dtlsCipher: S === null || S === void 0 ? void 0 : (_S_transport2 = S.transport) === null || _S_transport2 === void 0 ? void 0 : _S_transport2.dtlsCipher,
                        transport_srtpCipher: S === null || S === void 0 ? void 0 : (_S_transport3 = S.transport) === null || _S_transport3 === void 0 ? void 0 : _S_transport3.srtpCipher,
                        pair_id: S === null || S === void 0 ? void 0 : (_S_transport4 = S.transport) === null || _S_transport4 === void 0 ? void 0 : (_S_transport_selectedCandidatePair = _S_transport4.selectedCandidatePair) === null || _S_transport_selectedCandidatePair === void 0 ? void 0 : _S_transport_selectedCandidatePair.id,
                        pair_responsesSent: sampleseries((_g_audio15 = g.audio) === null || _g_audio15 === void 0 ? void 0 : _g_audio15.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesSent;
                        }),
                        pair_requestsReceived: sampleseries((_g_audio16 = g.audio) === null || _g_audio16 === void 0 ? void 0 : _g_audio16.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsReceived;
                        }),
                        pair_googRemoteCandidateType: S === null || S === void 0 ? void 0 : (_S_transport5 = S.transport) === null || _S_transport5 === void 0 ? void 0 : (_S_transport_selectedCandidatePair1 = _S_transport5.selectedCandidatePair) === null || _S_transport_selectedCandidatePair1 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate = _S_transport_selectedCandidatePair1.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate.candidateType,
                        pair_consentRequestsSent: sampleseries((_g_audio17 = g.audio) === null || _g_audio17 === void 0 ? void 0 : _g_audio17.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.consentRequestsSent;
                        }),
                        pair_googTransportType: S === null || S === void 0 ? void 0 : (_S_transport6 = S.transport) === null || _S_transport6 === void 0 ? void 0 : (_S_transport_selectedCandidatePair2 = _S_transport6.selectedCandidatePair) === null || _S_transport_selectedCandidatePair2 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate = _S_transport_selectedCandidatePair2.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate.protocol,
                        pair_googLocalCandidateType: S === null || S === void 0 ? void 0 : (_S_transport7 = S.transport) === null || _S_transport7 === void 0 ? void 0 : (_S_transport_selectedCandidatePair3 = _S_transport7.selectedCandidatePair) === null || _S_transport_selectedCandidatePair3 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate1 = _S_transport_selectedCandidatePair3.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate1 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate1.candidateType,
                        pair_googWritable: S === null || S === void 0 ? void 0 : (_S_transport8 = S.transport) === null || _S_transport8 === void 0 ? void 0 : (_S_transport_selectedCandidatePair4 = _S_transport8.selectedCandidatePair) === null || _S_transport_selectedCandidatePair4 === void 0 ? void 0 : _S_transport_selectedCandidatePair4.writable,
                        pair_requestsSent: sampleseries((_g_audio18 = g.audio) === null || _g_audio18 === void 0 ? void 0 : _g_audio18.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsSent;
                        }),
                        pair_googRtt: sampleseries((_g_audio19 = g.audio) === null || _g_audio19 === void 0 ? void 0 : _g_audio19.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return 1e3 * ((_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.currentRoundTripTime);
                        }, !0),
                        pair_googActiveConnection: S === null || S === void 0 ? void 0 : (_S_transport9 = S.transport) === null || _S_transport9 === void 0 ? void 0 : (_S_transport_selectedCandidatePair5 = _S_transport9.selectedCandidatePair) === null || _S_transport_selectedCandidatePair5 === void 0 ? void 0 : _S_transport_selectedCandidatePair5.nominated,
                        pair_packetsDiscardedOnSend: S === null || S === void 0 ? void 0 : (_S_transport10 = S.transport) === null || _S_transport10 === void 0 ? void 0 : (_S_transport_selectedCandidatePair6 = _S_transport10.selectedCandidatePair) === null || _S_transport_selectedCandidatePair6 === void 0 ? void 0 : _S_transport_selectedCandidatePair6.packetsDiscardedOnSend,
                        pair_bytesReceived: sampleseries((_g_audio20 = g.audio) === null || _g_audio20 === void 0 ? void 0 : _g_audio20.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesReceived;
                        }),
                        pair_responsesReceived: sampleseries((_g_audio21 = g.audio) === null || _g_audio21 === void 0 ? void 0 : _g_audio21.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesReceived;
                        }),
                        pair_remoteCandidateId: S === null || S === void 0 ? void 0 : (_S_transport11 = S.transport) === null || _S_transport11 === void 0 ? void 0 : (_S_transport_selectedCandidatePair7 = _S_transport11.selectedCandidatePair) === null || _S_transport_selectedCandidatePair7 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate1 = _S_transport_selectedCandidatePair7.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate1 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate1.id,
                        pair_localCandidateId: S === null || S === void 0 ? void 0 : (_S_transport12 = S.transport) === null || _S_transport12 === void 0 ? void 0 : (_S_transport_selectedCandidatePair8 = _S_transport12.selectedCandidatePair) === null || _S_transport_selectedCandidatePair8 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate2 = _S_transport_selectedCandidatePair8.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate2 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate2.id,
                        pair_packetsSent: sampleseries((_g_audio22 = g.audio) === null || _g_audio22 === void 0 ? void 0 : _g_audio22.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.packetsSent;
                        }),
                        pair_googLocalAddress: (_S_transport_selectedCandidatePair_localCandidate_ip = S === null || S === void 0 ? void 0 : (_S_transport13 = S.transport) === null || _S_transport13 === void 0 ? void 0 : (_S_transport_selectedCandidatePair9 = _S_transport13.selectedCandidatePair) === null || _S_transport_selectedCandidatePair9 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate3 = _S_transport_selectedCandidatePair9.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate3 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate3.ip) !== null && _S_transport_selectedCandidatePair_localCandidate_ip !== void 0 ? _S_transport_selectedCandidatePair_localCandidate_ip : S === null || S === void 0 ? void 0 : (_S_transport14 = S.transport) === null || _S_transport14 === void 0 ? void 0 : (_S_transport_selectedCandidatePair10 = _S_transport14.selectedCandidatePair) === null || _S_transport_selectedCandidatePair10 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate4 = _S_transport_selectedCandidatePair10.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate4 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate4.address,
                        pair_googRemoteAddress: (_S_transport_selectedCandidatePair_remoteCandidate_ip = S === null || S === void 0 ? void 0 : (_S_transport15 = S.transport) === null || _S_transport15 === void 0 ? void 0 : (_S_transport_selectedCandidatePair11 = _S_transport15.selectedCandidatePair) === null || _S_transport_selectedCandidatePair11 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate2 = _S_transport_selectedCandidatePair11.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate2 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate2.ip) !== null && _S_transport_selectedCandidatePair_remoteCandidate_ip !== void 0 ? _S_transport_selectedCandidatePair_remoteCandidate_ip : S === null || S === void 0 ? void 0 : (_S_transport16 = S.transport) === null || _S_transport16 === void 0 ? void 0 : (_S_transport_selectedCandidatePair12 = _S_transport16.selectedCandidatePair) === null || _S_transport_selectedCandidatePair12 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate3 = _S_transport_selectedCandidatePair12.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate3 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate3.address,
                        pair_bytesSent: sampleseries((_g_audio23 = g.audio) === null || _g_audio23 === void 0 ? void 0 : _g_audio23.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesSent;
                        }),
                        pair_googReadable: S === null || S === void 0 ? void 0 : (_S_transport17 = S.transport) === null || _S_transport17 === void 0 ? void 0 : (_S_transport_selectedCandidatePair13 = _S_transport17.selectedCandidatePair) === null || _S_transport_selectedCandidatePair13 === void 0 ? void 0 : _S_transport_selectedCandidatePair13.nominated
                    })
                });
            }
            function compileVideoTelemetryReport(g, f, S, v) {
                var _f_g, _f_g1, _f_g2, _S_codec, _S_track, _S_transport, _S_transport1, _S_transport2, _S_transport3, _S_transport_selectedCandidatePair, _S_transport4, _f_g3, _f_g4, _S_transport_selectedCandidatePair_remoteCandidate, _S_transport_selectedCandidatePair1, _S_transport5, _f_g5, _S_transport_selectedCandidatePair_localCandidate, _S_transport_selectedCandidatePair2, _S_transport6, _S_transport_selectedCandidatePair_localCandidate1, _S_transport_selectedCandidatePair3, _S_transport7, _S_transport_selectedCandidatePair4, _S_transport8, _f_g6, _f_g7, _S_transport_selectedCandidatePair5, _S_transport9, _S_transport_selectedCandidatePair6, _S_transport10, _f_g8, _f_g9, _S_transport_selectedCandidatePair_remoteCandidate1, _S_transport_selectedCandidatePair7, _S_transport11, _S_transport_selectedCandidatePair_localCandidate2, _S_transport_selectedCandidatePair8, _S_transport12, _f_g10, _S_transport_selectedCandidatePair_localCandidate3, _S_transport_selectedCandidatePair9, _S_transport13, _S_transport_selectedCandidatePair_localCandidate4, _S_transport_selectedCandidatePair10, _S_transport14, _S_transport_selectedCandidatePair_remoteCandidate2, _S_transport_selectedCandidatePair11, _S_transport15, _S_transport_selectedCandidatePair_remoteCandidate3, _S_transport_selectedCandidatePair12, _S_transport16, _f_g11, _S_transport_selectedCandidatePair13, _S_transport17, _f_g12, _f_g13, _f_g14, _f_g15, _f_g16, _f_g17, _f_g18, _f_g19, _f_g20, _f_g21, _S_extensions, _f_g22, _f_g23, _f_g24, _v_codec, _v_track, _v_transport, _v_transport1, _v_transport2, _v_transport3, _v_transport_selectedCandidatePair, _v_transport4, _f_g25, _f_g26, _v_transport_selectedCandidatePair_remoteCandidate, _v_transport_selectedCandidatePair1, _v_transport5, _f_g27, _v_transport_selectedCandidatePair_localCandidate, _v_transport_selectedCandidatePair2, _v_transport6, _v_transport_selectedCandidatePair_localCandidate1, _v_transport_selectedCandidatePair3, _v_transport7, _v_transport_selectedCandidatePair4, _v_transport8, _f_g28, _f_g29, _v_transport_selectedCandidatePair5, _v_transport9, _v_transport_selectedCandidatePair6, _v_transport10, _f_g30, _f_g31, _v_transport_selectedCandidatePair_remoteCandidate1, _v_transport_selectedCandidatePair7, _v_transport11, _v_transport_selectedCandidatePair_localCandidate2, _v_transport_selectedCandidatePair8, _v_transport12, _f_g32, _v_transport_selectedCandidatePair_localCandidate3, _v_transport_selectedCandidatePair9, _v_transport13, _v_transport_selectedCandidatePair_localCandidate4, _v_transport_selectedCandidatePair10, _v_transport14, _v_transport_selectedCandidatePair_remoteCandidate2, _v_transport_selectedCandidatePair11, _v_transport15, _v_transport_selectedCandidatePair_remoteCandidate3, _v_transport_selectedCandidatePair12, _v_transport16, _f_g33, _v_transport_selectedCandidatePair13, _v_transport17, _f_g34, _f_g35, _f_g36, _f_g37, _f_g38, _v_mediaSource, _v_mediaSource1, _f_g39, _f_g40, _f_g41, _f_g42, _f_g43, _f_g44, _v_remoteInboundRTP, _f_g45;
                var _S_inboundRTP_mediaType, _S_transport_selectedCandidatePair_localCandidate_ip, _S_transport_selectedCandidatePair_remoteCandidate_ip, _v_outboundRTP_mediaType, _v_transport_selectedCandidatePair_localCandidate_ip, _v_transport_selectedCandidatePair_remoteCandidate_ip;
                return removeUndefinedFields({
                    recv: removeUndefinedFields({
                        id: S === null || S === void 0 ? void 0 : S.inboundRTP.id,
                        ssrc: S === null || S === void 0 ? void 0 : S.inboundRTP.ssrc,
                        mediaType: (_S_inboundRTP_mediaType = S === null || S === void 0 ? void 0 : S.inboundRTP.mediaType) !== null && _S_inboundRTP_mediaType !== void 0 ? _S_inboundRTP_mediaType : S === null || S === void 0 ? void 0 : S.inboundRTP.kind,
                        bytesReceived: sampleseries((_f_g = f[g]) === null || _f_g === void 0 ? void 0 : _f_g.recv, (g)=>g.inboundRTP.bytesReceived),
                        packetsReceived: sampleseries((_f_g1 = f[g]) === null || _f_g1 === void 0 ? void 0 : _f_g1.recv, (g)=>g.inboundRTP.packetsReceived),
                        packetsLost: sampleseries((_f_g2 = f[g]) === null || _f_g2 === void 0 ? void 0 : _f_g2.recv, (g)=>g.inboundRTP.packetsLost),
                        googCodecName: S === null || S === void 0 ? void 0 : (_S_codec = S.codec) === null || _S_codec === void 0 ? void 0 : _S_codec.mimeType.split("/").pop(),
                        codecImplementationName: S === null || S === void 0 ? void 0 : S.inboundRTP.decoderImplementation,
                        googTrackId: S === null || S === void 0 ? void 0 : (_S_track = S.track) === null || _S_track === void 0 ? void 0 : _S_track.trackIdentifier,
                        transport_id: S === null || S === void 0 ? void 0 : (_S_transport = S.transport) === null || _S_transport === void 0 ? void 0 : _S_transport.id,
                        transportId: S === null || S === void 0 ? void 0 : S.inboundRTP.transportId,
                        transport_selectedCandidatePairId: S === null || S === void 0 ? void 0 : (_S_transport1 = S.transport) === null || _S_transport1 === void 0 ? void 0 : _S_transport1.selectedCandidatePairId,
                        transport_dtlsCipher: S === null || S === void 0 ? void 0 : (_S_transport2 = S.transport) === null || _S_transport2 === void 0 ? void 0 : _S_transport2.dtlsCipher,
                        transport_srtpCipher: S === null || S === void 0 ? void 0 : (_S_transport3 = S.transport) === null || _S_transport3 === void 0 ? void 0 : _S_transport3.srtpCipher,
                        pair_id: S === null || S === void 0 ? void 0 : (_S_transport4 = S.transport) === null || _S_transport4 === void 0 ? void 0 : (_S_transport_selectedCandidatePair = _S_transport4.selectedCandidatePair) === null || _S_transport_selectedCandidatePair === void 0 ? void 0 : _S_transport_selectedCandidatePair.id,
                        pair_responsesSent: sampleseries((_f_g3 = f[g]) === null || _f_g3 === void 0 ? void 0 : _f_g3.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesSent;
                        }),
                        pair_requestsReceived: sampleseries((_f_g4 = f[g]) === null || _f_g4 === void 0 ? void 0 : _f_g4.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsReceived;
                        }),
                        pair_googRemoteCandidateType: S === null || S === void 0 ? void 0 : (_S_transport5 = S.transport) === null || _S_transport5 === void 0 ? void 0 : (_S_transport_selectedCandidatePair1 = _S_transport5.selectedCandidatePair) === null || _S_transport_selectedCandidatePair1 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate = _S_transport_selectedCandidatePair1.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate.candidateType,
                        pair_consentRequestsSent: sampleseries((_f_g5 = f[g]) === null || _f_g5 === void 0 ? void 0 : _f_g5.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.consentRequestsSent;
                        }),
                        pair_googTransportType: S === null || S === void 0 ? void 0 : (_S_transport6 = S.transport) === null || _S_transport6 === void 0 ? void 0 : (_S_transport_selectedCandidatePair2 = _S_transport6.selectedCandidatePair) === null || _S_transport_selectedCandidatePair2 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate = _S_transport_selectedCandidatePair2.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate.protocol,
                        pair_googLocalCandidateType: S === null || S === void 0 ? void 0 : (_S_transport7 = S.transport) === null || _S_transport7 === void 0 ? void 0 : (_S_transport_selectedCandidatePair3 = _S_transport7.selectedCandidatePair) === null || _S_transport_selectedCandidatePair3 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate1 = _S_transport_selectedCandidatePair3.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate1 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate1.candidateType,
                        pair_googWritable: S === null || S === void 0 ? void 0 : (_S_transport8 = S.transport) === null || _S_transport8 === void 0 ? void 0 : (_S_transport_selectedCandidatePair4 = _S_transport8.selectedCandidatePair) === null || _S_transport_selectedCandidatePair4 === void 0 ? void 0 : _S_transport_selectedCandidatePair4.writable,
                        pair_requestsSent: sampleseries((_f_g6 = f[g]) === null || _f_g6 === void 0 ? void 0 : _f_g6.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsSent;
                        }),
                        pair_googRtt: sampleseries((_f_g7 = f[g]) === null || _f_g7 === void 0 ? void 0 : _f_g7.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return 1e3 * ((_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.currentRoundTripTime);
                        }, !0),
                        pair_googActiveConnection: S === null || S === void 0 ? void 0 : (_S_transport9 = S.transport) === null || _S_transport9 === void 0 ? void 0 : (_S_transport_selectedCandidatePair5 = _S_transport9.selectedCandidatePair) === null || _S_transport_selectedCandidatePair5 === void 0 ? void 0 : _S_transport_selectedCandidatePair5.nominated,
                        pair_packetsDiscardedOnSend: S === null || S === void 0 ? void 0 : (_S_transport10 = S.transport) === null || _S_transport10 === void 0 ? void 0 : (_S_transport_selectedCandidatePair6 = _S_transport10.selectedCandidatePair) === null || _S_transport_selectedCandidatePair6 === void 0 ? void 0 : _S_transport_selectedCandidatePair6.packetsDiscardedOnSend,
                        pair_bytesReceived: sampleseries((_f_g8 = f[g]) === null || _f_g8 === void 0 ? void 0 : _f_g8.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesReceived;
                        }),
                        pair_responsesReceived: sampleseries((_f_g9 = f[g]) === null || _f_g9 === void 0 ? void 0 : _f_g9.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesReceived;
                        }),
                        pair_remoteCandidateId: S === null || S === void 0 ? void 0 : (_S_transport11 = S.transport) === null || _S_transport11 === void 0 ? void 0 : (_S_transport_selectedCandidatePair7 = _S_transport11.selectedCandidatePair) === null || _S_transport_selectedCandidatePair7 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate1 = _S_transport_selectedCandidatePair7.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate1 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate1.id,
                        pair_localCandidateId: S === null || S === void 0 ? void 0 : (_S_transport12 = S.transport) === null || _S_transport12 === void 0 ? void 0 : (_S_transport_selectedCandidatePair8 = _S_transport12.selectedCandidatePair) === null || _S_transport_selectedCandidatePair8 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate2 = _S_transport_selectedCandidatePair8.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate2 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate2.id,
                        pair_packetsSent: sampleseries((_f_g10 = f[g]) === null || _f_g10 === void 0 ? void 0 : _f_g10.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.packetsSent;
                        }),
                        pair_googLocalAddress: (_S_transport_selectedCandidatePair_localCandidate_ip = S === null || S === void 0 ? void 0 : (_S_transport13 = S.transport) === null || _S_transport13 === void 0 ? void 0 : (_S_transport_selectedCandidatePair9 = _S_transport13.selectedCandidatePair) === null || _S_transport_selectedCandidatePair9 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate3 = _S_transport_selectedCandidatePair9.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate3 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate3.ip) !== null && _S_transport_selectedCandidatePair_localCandidate_ip !== void 0 ? _S_transport_selectedCandidatePair_localCandidate_ip : S === null || S === void 0 ? void 0 : (_S_transport14 = S.transport) === null || _S_transport14 === void 0 ? void 0 : (_S_transport_selectedCandidatePair10 = _S_transport14.selectedCandidatePair) === null || _S_transport_selectedCandidatePair10 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_localCandidate4 = _S_transport_selectedCandidatePair10.localCandidate) === null || _S_transport_selectedCandidatePair_localCandidate4 === void 0 ? void 0 : _S_transport_selectedCandidatePair_localCandidate4.address,
                        pair_googRemoteAddress: (_S_transport_selectedCandidatePair_remoteCandidate_ip = S === null || S === void 0 ? void 0 : (_S_transport15 = S.transport) === null || _S_transport15 === void 0 ? void 0 : (_S_transport_selectedCandidatePair11 = _S_transport15.selectedCandidatePair) === null || _S_transport_selectedCandidatePair11 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate2 = _S_transport_selectedCandidatePair11.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate2 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate2.ip) !== null && _S_transport_selectedCandidatePair_remoteCandidate_ip !== void 0 ? _S_transport_selectedCandidatePair_remoteCandidate_ip : S === null || S === void 0 ? void 0 : (_S_transport16 = S.transport) === null || _S_transport16 === void 0 ? void 0 : (_S_transport_selectedCandidatePair12 = _S_transport16.selectedCandidatePair) === null || _S_transport_selectedCandidatePair12 === void 0 ? void 0 : (_S_transport_selectedCandidatePair_remoteCandidate3 = _S_transport_selectedCandidatePair12.remoteCandidate) === null || _S_transport_selectedCandidatePair_remoteCandidate3 === void 0 ? void 0 : _S_transport_selectedCandidatePair_remoteCandidate3.address,
                        pair_bytesSent: sampleseries((_f_g11 = f[g]) === null || _f_g11 === void 0 ? void 0 : _f_g11.recv, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesSent;
                        }),
                        pair_googReadable: S === null || S === void 0 ? void 0 : (_S_transport17 = S.transport) === null || _S_transport17 === void 0 ? void 0 : (_S_transport_selectedCandidatePair13 = _S_transport17.selectedCandidatePair) === null || _S_transport_selectedCandidatePair13 === void 0 ? void 0 : _S_transport_selectedCandidatePair13.nominated,
                        framesDecoded: sampleseries((_f_g12 = f[g]) === null || _f_g12 === void 0 ? void 0 : _f_g12.recv, (g)=>g.inboundRTP.framesDecoded),
                        googFrameHeightReceived: sampleseries((_f_g13 = f[g]) === null || _f_g13 === void 0 ? void 0 : _f_g13.recv, (g)=>g.inboundRTP.frameHeight),
                        googFrameWidthReceived: sampleseries((_f_g14 = f[g]) === null || _f_g14 === void 0 ? void 0 : _f_g14.recv, (g)=>g.inboundRTP.frameWidth),
                        googFrameRateReceived: sampleseries((_f_g15 = f[g]) === null || _f_g15 === void 0 ? void 0 : _f_g15.recv, (g)=>{
                            var _g_extensions;
                            return ((_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateReceived) || 0;
                        }),
                        googNacksSent: sampleseries((_f_g16 = f[g]) === null || _f_g16 === void 0 ? void 0 : _f_g16.recv, (g)=>g.inboundRTP.nackCount),
                        googPlisSent: sampleseries((_f_g17 = f[g]) === null || _f_g17 === void 0 ? void 0 : _f_g17.recv, (g)=>g.inboundRTP.pliCount),
                        keyFramesDecoded: sampleseries((_f_g18 = f[g]) === null || _f_g18 === void 0 ? void 0 : _f_g18.recv, (g)=>g.inboundRTP.keyFramesDecoded),
                        googFirsSent: sampleseries((_f_g19 = f[g]) === null || _f_g19 === void 0 ? void 0 : _f_g19.recv, (g)=>g.inboundRTP.firCount),
                        googJitterBufferMs: sampleseries((_f_g20 = f[g]) === null || _f_g20 === void 0 ? void 0 : _f_g20.recv, (g)=>{
                            var _g_extensions;
                            return (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.jitterBufferMs;
                        }),
                        googFrameRateDecoded: sampleseries((_f_g21 = f[g]) === null || _f_g21 === void 0 ? void 0 : _f_g21.recv, (g)=>{
                            var _g_extensions;
                            return ((_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateDecoded) || 0;
                        }),
                        googFrameRateOutput: S === null || S === void 0 ? void 0 : (_S_extensions = S.extensions) === null || _S_extensions === void 0 ? void 0 : _S_extensions.trackRecvFps,
                        jitter: S === null || S === void 0 ? void 0 : S.inboundRTP.jitter
                    }),
                    send: removeUndefinedFields({
                        id: v === null || v === void 0 ? void 0 : v.outboundRTP.id,
                        ssrc: v === null || v === void 0 ? void 0 : v.outboundRTP.ssrc,
                        mediaType: (_v_outboundRTP_mediaType = v === null || v === void 0 ? void 0 : v.outboundRTP.mediaType) !== null && _v_outboundRTP_mediaType !== void 0 ? _v_outboundRTP_mediaType : v === null || v === void 0 ? void 0 : v.outboundRTP.kind,
                        bytesSent: sampleseries((_f_g22 = f[g]) === null || _f_g22 === void 0 ? void 0 : _f_g22.send, (g)=>g.outboundRTP.bytesSent),
                        packetsSent: sampleseries((_f_g23 = f[g]) === null || _f_g23 === void 0 ? void 0 : _f_g23.send, (g)=>g.outboundRTP.packetsSent),
                        packetsLost: sampleseries((_f_g24 = f[g]) === null || _f_g24 === void 0 ? void 0 : _f_g24.send, (g)=>{
                            var _g_remoteInboundRTP;
                            return (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsLost;
                        }),
                        googCodecName: v === null || v === void 0 ? void 0 : (_v_codec = v.codec) === null || _v_codec === void 0 ? void 0 : _v_codec.mimeType.split("/").pop(),
                        codecImplementationName: v === null || v === void 0 ? void 0 : v.outboundRTP.encoderImplementation,
                        googTrackId: v === null || v === void 0 ? void 0 : (_v_track = v.track) === null || _v_track === void 0 ? void 0 : _v_track.trackIdentifier,
                        transport_id: v === null || v === void 0 ? void 0 : (_v_transport = v.transport) === null || _v_transport === void 0 ? void 0 : _v_transport.id,
                        transportId: v === null || v === void 0 ? void 0 : v.outboundRTP.transportId,
                        transport_selectedCandidatePairId: v === null || v === void 0 ? void 0 : (_v_transport1 = v.transport) === null || _v_transport1 === void 0 ? void 0 : _v_transport1.selectedCandidatePairId,
                        transport_dtlsCipher: v === null || v === void 0 ? void 0 : (_v_transport2 = v.transport) === null || _v_transport2 === void 0 ? void 0 : _v_transport2.dtlsCipher,
                        transport_srtpCipher: v === null || v === void 0 ? void 0 : (_v_transport3 = v.transport) === null || _v_transport3 === void 0 ? void 0 : _v_transport3.srtpCipher,
                        pair_id: v === null || v === void 0 ? void 0 : (_v_transport4 = v.transport) === null || _v_transport4 === void 0 ? void 0 : (_v_transport_selectedCandidatePair = _v_transport4.selectedCandidatePair) === null || _v_transport_selectedCandidatePair === void 0 ? void 0 : _v_transport_selectedCandidatePair.id,
                        pair_responsesSent: sampleseries((_f_g25 = f[g]) === null || _f_g25 === void 0 ? void 0 : _f_g25.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesSent;
                        }),
                        pair_requestsReceived: sampleseries((_f_g26 = f[g]) === null || _f_g26 === void 0 ? void 0 : _f_g26.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsReceived;
                        }),
                        pair_googRemoteCandidateType: v === null || v === void 0 ? void 0 : (_v_transport5 = v.transport) === null || _v_transport5 === void 0 ? void 0 : (_v_transport_selectedCandidatePair1 = _v_transport5.selectedCandidatePair) === null || _v_transport_selectedCandidatePair1 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_remoteCandidate = _v_transport_selectedCandidatePair1.remoteCandidate) === null || _v_transport_selectedCandidatePair_remoteCandidate === void 0 ? void 0 : _v_transport_selectedCandidatePair_remoteCandidate.candidateType,
                        pair_consentRequestsSent: sampleseries((_f_g27 = f[g]) === null || _f_g27 === void 0 ? void 0 : _f_g27.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.consentRequestsSent;
                        }),
                        pair_googTransportType: v === null || v === void 0 ? void 0 : (_v_transport6 = v.transport) === null || _v_transport6 === void 0 ? void 0 : (_v_transport_selectedCandidatePair2 = _v_transport6.selectedCandidatePair) === null || _v_transport_selectedCandidatePair2 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_localCandidate = _v_transport_selectedCandidatePair2.localCandidate) === null || _v_transport_selectedCandidatePair_localCandidate === void 0 ? void 0 : _v_transport_selectedCandidatePair_localCandidate.protocol,
                        pair_googLocalCandidateType: v === null || v === void 0 ? void 0 : (_v_transport7 = v.transport) === null || _v_transport7 === void 0 ? void 0 : (_v_transport_selectedCandidatePair3 = _v_transport7.selectedCandidatePair) === null || _v_transport_selectedCandidatePair3 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_localCandidate1 = _v_transport_selectedCandidatePair3.localCandidate) === null || _v_transport_selectedCandidatePair_localCandidate1 === void 0 ? void 0 : _v_transport_selectedCandidatePair_localCandidate1.candidateType,
                        pair_googWritable: v === null || v === void 0 ? void 0 : (_v_transport8 = v.transport) === null || _v_transport8 === void 0 ? void 0 : (_v_transport_selectedCandidatePair4 = _v_transport8.selectedCandidatePair) === null || _v_transport_selectedCandidatePair4 === void 0 ? void 0 : _v_transport_selectedCandidatePair4.writable,
                        pair_requestsSent: sampleseries((_f_g28 = f[g]) === null || _f_g28 === void 0 ? void 0 : _f_g28.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.requestsSent;
                        }),
                        pair_googRtt: sampleseries((_f_g29 = f[g]) === null || _f_g29 === void 0 ? void 0 : _f_g29.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return 1e3 * ((_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.currentRoundTripTime);
                        }, !0),
                        pair_googActiveConnection: v === null || v === void 0 ? void 0 : (_v_transport9 = v.transport) === null || _v_transport9 === void 0 ? void 0 : (_v_transport_selectedCandidatePair5 = _v_transport9.selectedCandidatePair) === null || _v_transport_selectedCandidatePair5 === void 0 ? void 0 : _v_transport_selectedCandidatePair5.nominated,
                        pair_packetsDiscardedOnSend: v === null || v === void 0 ? void 0 : (_v_transport10 = v.transport) === null || _v_transport10 === void 0 ? void 0 : (_v_transport_selectedCandidatePair6 = _v_transport10.selectedCandidatePair) === null || _v_transport_selectedCandidatePair6 === void 0 ? void 0 : _v_transport_selectedCandidatePair6.packetsDiscardedOnSend,
                        pair_bytesReceived: sampleseries((_f_g30 = f[g]) === null || _f_g30 === void 0 ? void 0 : _f_g30.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesReceived;
                        }),
                        pair_responsesReceived: sampleseries((_f_g31 = f[g]) === null || _f_g31 === void 0 ? void 0 : _f_g31.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.responsesReceived;
                        }),
                        pair_remoteCandidateId: v === null || v === void 0 ? void 0 : (_v_transport11 = v.transport) === null || _v_transport11 === void 0 ? void 0 : (_v_transport_selectedCandidatePair7 = _v_transport11.selectedCandidatePair) === null || _v_transport_selectedCandidatePair7 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_remoteCandidate1 = _v_transport_selectedCandidatePair7.remoteCandidate) === null || _v_transport_selectedCandidatePair_remoteCandidate1 === void 0 ? void 0 : _v_transport_selectedCandidatePair_remoteCandidate1.id,
                        pair_localCandidateId: v === null || v === void 0 ? void 0 : (_v_transport12 = v.transport) === null || _v_transport12 === void 0 ? void 0 : (_v_transport_selectedCandidatePair8 = _v_transport12.selectedCandidatePair) === null || _v_transport_selectedCandidatePair8 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_localCandidate2 = _v_transport_selectedCandidatePair8.localCandidate) === null || _v_transport_selectedCandidatePair_localCandidate2 === void 0 ? void 0 : _v_transport_selectedCandidatePair_localCandidate2.id,
                        pair_packetsSent: sampleseries((_f_g32 = f[g]) === null || _f_g32 === void 0 ? void 0 : _f_g32.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.packetsSent;
                        }),
                        pair_googLocalAddress: (_v_transport_selectedCandidatePair_localCandidate_ip = v === null || v === void 0 ? void 0 : (_v_transport13 = v.transport) === null || _v_transport13 === void 0 ? void 0 : (_v_transport_selectedCandidatePair9 = _v_transport13.selectedCandidatePair) === null || _v_transport_selectedCandidatePair9 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_localCandidate3 = _v_transport_selectedCandidatePair9.localCandidate) === null || _v_transport_selectedCandidatePair_localCandidate3 === void 0 ? void 0 : _v_transport_selectedCandidatePair_localCandidate3.ip) !== null && _v_transport_selectedCandidatePair_localCandidate_ip !== void 0 ? _v_transport_selectedCandidatePair_localCandidate_ip : v === null || v === void 0 ? void 0 : (_v_transport14 = v.transport) === null || _v_transport14 === void 0 ? void 0 : (_v_transport_selectedCandidatePair10 = _v_transport14.selectedCandidatePair) === null || _v_transport_selectedCandidatePair10 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_localCandidate4 = _v_transport_selectedCandidatePair10.localCandidate) === null || _v_transport_selectedCandidatePair_localCandidate4 === void 0 ? void 0 : _v_transport_selectedCandidatePair_localCandidate4.address,
                        pair_googRemoteAddress: (_v_transport_selectedCandidatePair_remoteCandidate_ip = v === null || v === void 0 ? void 0 : (_v_transport15 = v.transport) === null || _v_transport15 === void 0 ? void 0 : (_v_transport_selectedCandidatePair11 = _v_transport15.selectedCandidatePair) === null || _v_transport_selectedCandidatePair11 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_remoteCandidate2 = _v_transport_selectedCandidatePair11.remoteCandidate) === null || _v_transport_selectedCandidatePair_remoteCandidate2 === void 0 ? void 0 : _v_transport_selectedCandidatePair_remoteCandidate2.ip) !== null && _v_transport_selectedCandidatePair_remoteCandidate_ip !== void 0 ? _v_transport_selectedCandidatePair_remoteCandidate_ip : v === null || v === void 0 ? void 0 : (_v_transport16 = v.transport) === null || _v_transport16 === void 0 ? void 0 : (_v_transport_selectedCandidatePair12 = _v_transport16.selectedCandidatePair) === null || _v_transport_selectedCandidatePair12 === void 0 ? void 0 : (_v_transport_selectedCandidatePair_remoteCandidate3 = _v_transport_selectedCandidatePair12.remoteCandidate) === null || _v_transport_selectedCandidatePair_remoteCandidate3 === void 0 ? void 0 : _v_transport_selectedCandidatePair_remoteCandidate3.address,
                        pair_bytesSent: sampleseries((_f_g33 = f[g]) === null || _f_g33 === void 0 ? void 0 : _f_g33.send, (g)=>{
                            var _g_transport_selectedCandidatePair, _g_transport;
                            return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.bytesSent;
                        }),
                        pair_googReadable: v === null || v === void 0 ? void 0 : (_v_transport17 = v.transport) === null || _v_transport17 === void 0 ? void 0 : (_v_transport_selectedCandidatePair13 = _v_transport17.selectedCandidatePair) === null || _v_transport_selectedCandidatePair13 === void 0 ? void 0 : _v_transport_selectedCandidatePair13.nominated,
                        framesEncoded: sampleseries((_f_g34 = f[g]) === null || _f_g34 === void 0 ? void 0 : _f_g34.send, (g)=>g.outboundRTP.framesEncoded),
                        googNacksReceived: sampleseries((_f_g35 = f[g]) === null || _f_g35 === void 0 ? void 0 : _f_g35.send, (g)=>g.outboundRTP.nackCount),
                        googPlisReceived: sampleseries((_f_g36 = f[g]) === null || _f_g36 === void 0 ? void 0 : _f_g36.send, (g)=>g.outboundRTP.pliCount),
                        googFirsReceived: sampleseries((_f_g37 = f[g]) === null || _f_g37 === void 0 ? void 0 : _f_g37.send, (g)=>g.outboundRTP.firCount),
                        keyFramesEncoded: sampleseries((_f_g38 = f[g]) === null || _f_g38 === void 0 ? void 0 : _f_g38.send, (g)=>g.outboundRTP.keyFramesEncoded),
                        googFrameHeightInput: v === null || v === void 0 ? void 0 : (_v_mediaSource = v.mediaSource) === null || _v_mediaSource === void 0 ? void 0 : _v_mediaSource.height,
                        googFrameWidthInput: v === null || v === void 0 ? void 0 : (_v_mediaSource1 = v.mediaSource) === null || _v_mediaSource1 === void 0 ? void 0 : _v_mediaSource1.width,
                        googFrameRateInput: sampleseries((_f_g39 = f[g]) === null || _f_g39 === void 0 ? void 0 : _f_g39.send, (g)=>{
                            var _g_mediaSource;
                            return (_g_mediaSource = g.mediaSource) === null || _g_mediaSource === void 0 ? void 0 : _g_mediaSource.framesPerSecond;
                        }),
                        googFrameHeightSent: sampleseries((_f_g40 = f[g]) === null || _f_g40 === void 0 ? void 0 : _f_g40.send, (g)=>g.outboundRTP.frameHeight),
                        googFrameWidthSent: sampleseries((_f_g41 = f[g]) === null || _f_g41 === void 0 ? void 0 : _f_g41.send, (g)=>g.outboundRTP.frameWidth),
                        googFrameRateSent: sampleseries((_f_g42 = f[g]) === null || _f_g42 === void 0 ? void 0 : _f_g42.send, (g)=>{
                            var _g_extensions;
                            return (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateSent;
                        }),
                        googRtt: sampleseries((_f_g43 = f[g]) === null || _f_g43 === void 0 ? void 0 : _f_g43.send, (g)=>{
                            var _g_remoteInboundRTP;
                            var _g_remoteInboundRTP_roundTripTime;
                            return 1e3 * ((_g_remoteInboundRTP_roundTripTime = (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.roundTripTime) !== null && _g_remoteInboundRTP_roundTripTime !== void 0 ? _g_remoteInboundRTP_roundTripTime : 0);
                        }, !0),
                        hugeFramesSent: v === null || v === void 0 ? void 0 : v.outboundRTP.hugeFramesSent,
                        qpSum: sampleseries((_f_g44 = f[g]) === null || _f_g44 === void 0 ? void 0 : _f_g44.send, (g)=>g.outboundRTP.qpSum),
                        qualityLimitationDurations: v ? JSON.stringify(v === null || v === void 0 ? void 0 : v.outboundRTP.qualityLimitationDurations) : void 0,
                        qualityLimitationReason: v === null || v === void 0 ? void 0 : v.outboundRTP.qualityLimitationReason,
                        qualityLimitationResolutionChanges: v === null || v === void 0 ? void 0 : v.outboundRTP.qualityLimitationResolutionChanges,
                        jitter: v === null || v === void 0 ? void 0 : (_v_remoteInboundRTP = v.remoteInboundRTP) === null || _v_remoteInboundRTP === void 0 ? void 0 : _v_remoteInboundRTP.jitter,
                        retransmittedPacketsSent: sampleseries((_f_g45 = f[g]) === null || _f_g45 === void 0 ? void 0 : _f_g45.send, (g)=>g.outboundRTP.retransmittedPacketsSent)
                    })
                });
            }
            function compileExtensionsTelemetryReport(g, f, S) {
                var __audio, __audio1, __video, __video1, __sharing, __sharing1, _g_qualityManager, _g_qualityManager1, _g_qualityManager2, _g_qualityManager3, _g_statsOnSubscribed_video, _g_statsOnSubscribed_sharing, _g_transportState, _g_transportState1, _g_transportState2, _g_transportState3, _g_qualityManager4, _g_qualityManager5, _g_qualityManager6, _g_qualityManager7, _C_transport_extensions, _C_transport, _C_transport_extensions1, _C_transport1, _C_aggregated, _E_aggregated, _T_aggregated, _I_aggregated, __video2, __video3, __video4, __video5, _I_transport_extensions, _I_transport, _C_aggregated1, _C_aggregated2, _C_aggregated3, _C_aggregated4, _C_aggregated5, _E_aggregated1, _E_aggregated2, __audio2, _E_aggregated3, _T_aggregated1, _T_aggregated2, _T_aggregated3, _T_aggregated4, _T_extensions, _T_aggregated5, _T_aggregated6, _T_aggregated7, _T_aggregated8, _T_aggregated9, _g_remoteVideoManager, _g_remoteVideoManager1, _T_aggregated10, _T_aggregated11, _T_aggregated12, _T_aggregated13, _T_aggregated14, _g_remoteVideoManager2, _T_aggregated15, _g_remoteVideoManager_preferredResolution_video, _g_remoteVideoManager3, _g_subscriptionManager, _g_subscriptionManager1, _I_aggregated1, _I_aggregated2, _I_extensions, _I_aggregated3, _I_aggregated4, _I_aggregated5, _I_aggregated6, _I_aggregated7, _I_aggregated8, _I_aggregated9, _I_aggregated10, _I_aggregated11, _I_extensions_cameraOpenResolution, _I_extensions1, _I_extensions_cameraOpenResolution1, _I_extensions2, _I_aggregated12, _I_aggregated13, _g_simulcast, _b_aggregated, _b_aggregated1, _b_aggregated2, _b_aggregated3, _b_extensions, _b_aggregated4, _b_aggregated5, _b_aggregated6, _b_aggregated7, _g_remoteVideoManager4, _g_remoteVideoManager5, _b_aggregated8, _b_aggregated9, _b_aggregated10, _b_aggregated11, _b_aggregated12, _b_aggregated13, _g_remoteVideoManager6, _g_remoteVideoManager_preferredResolution_sharing, _g_remoteVideoManager7, _g_subscriptionManager2, _g_subscriptionManager3, _A_aggregated, _A_aggregated1, _A_aggregated2, _A_aggregated3, _A_aggregated4, _A_aggregated5, _A_aggregated6, _A_aggregated7, _A_aggregated8, _A_aggregated9, _A_aggregated10, _A_aggregated11, _A_aggregated12, _g_simulcast1, _g_dataChannel, _g_dataChannel1, _g_dataChannelSessionState;
                const v = f.config.diagnostics.telemetryLimits, _ = g.aggregatedModalityStats, C = getLast((__audio = _.audio) === null || __audio === void 0 ? void 0 : __audio.recv), E = getLast((__audio1 = _.audio) === null || __audio1 === void 0 ? void 0 : __audio1.send), T = getLast((__video = _.video) === null || __video === void 0 ? void 0 : __video.recv), I = getLast((__video1 = _.video) === null || __video1 === void 0 ? void 0 : __video1.send), b = getLast((__sharing = _.sharing) === null || __sharing === void 0 ? void 0 : __sharing.recv), A = getLast((__sharing1 = _.sharing) === null || __sharing1 === void 0 ? void 0 : __sharing1.send), getMaxCapsEvents = (S)=>S && limitArraySize2(deepClone(S).map((f)=>rebaseTime(limitArraySize2(f.events, v.numCapabilitiesApplied, 1), "timestamp", g.startTime)), f.config.diagnostics.telemetryLimits.numCapabilitiesRequested), R = getMaxCapsEvents((_g_qualityManager = g.qualityManager) === null || _g_qualityManager === void 0 ? void 0 : _g_qualityManager.videoMaxCapabilitiesEvents), P = getMaxCapsEvents((_g_qualityManager1 = g.qualityManager) === null || _g_qualityManager1 === void 0 ? void 0 : _g_qualityManager1.videoMaxCapabilitiesErrors), w = getMaxCapsEvents((_g_qualityManager2 = g.qualityManager) === null || _g_qualityManager2 === void 0 ? void 0 : _g_qualityManager2.sharingMaxCapabilitiesEvents), M = getMaxCapsEvents((_g_qualityManager3 = g.qualityManager) === null || _g_qualityManager3 === void 0 ? void 0 : _g_qualityManager3.sharingMaxCapabilitiesErrors), O = "REMB" !== g.negotiation.bweType ? g.bandwidthReport : void 0, D = "REMB" === g.negotiation.bweType ? g.bandwidthReport : void 0, N = [], k = [];
                var _g_IPAddress, _g_reflexiveLocalIP, _sampleseries, _sampleseries1;
                return (_g_statsOnSubscribed_video = g.statsOnSubscribed.video) === null || _g_statsOnSubscribed_video === void 0 ? void 0 : _g_statsOnSubscribed_video.forEach((g)=>N.push(g)), (_g_statsOnSubscribed_sharing = g.statsOnSubscribed.sharing) === null || _g_statsOnSubscribed_sharing === void 0 ? void 0 : _g_statsOnSubscribed_sharing.forEach((g)=>k.push(g)), removeUndefinedFields({
                    BundlePolicy: g.bundlePolicy,
                    FakeIceCandidate: g.negotiation.fakeCandidate,
                    h264AvailableProfiles: JSON.stringify(g.H264Profiles),
                    h264CodecCapabilities: JSON.stringify(g.h264CodecCapabilities),
                    IceConnectionState: (_g_transportState = g.transportState) === null || _g_transportState === void 0 ? void 0 : _g_transportState.iceConnectionState,
                    IceConnectionStatePrevious: (_g_transportState1 = g.transportState) === null || _g_transportState1 === void 0 ? void 0 : _g_transportState1.iceConnectionStatePrevious,
                    IceServers: g.iceServers,
                    IceTransportPolicy: g.iceTransportPolicy,
                    NegotiatedSrtp: JSON.stringify(g.negotiation.negotiatedSrtp),
                    OfferedSrtp: JSON.stringify(g.negotiation.offeredSrtp),
                    RelayCandidate: g.relayCandidate,
                    SdpSemantics: g.sdpSemantics,
                    iceCandidateErrors: JSON.stringify(g.iceCandidateErrors),
                    SignalingState: (_g_transportState2 = g.transportState) === null || _g_transportState2 === void 0 ? void 0 : _g_transportState2.signalingState,
                    SignalingStatePrevious: (_g_transportState3 = g.transportState) === null || _g_transportState3 === void 0 ? void 0 : _g_transportState3.signalingStatePrevious,
                    WebRTCStats_statsErrors: JSON.stringify(S),
                    MaxSessionBandwidth: g.maxSessionBandwidth,
                    Bandwidth_uplinkStabilizationTime: JSON.stringify(g.bwStabilizationTime),
                    Bandwidth_downlinkStabilizationTime: JSON.stringify(g.bwDownlinkStabilizationTime),
                    totalVideoControlMessages: (_g_qualityManager4 = g.qualityManager) === null || _g_qualityManager4 === void 0 ? void 0 : _g_qualityManager4.numVideoControlMessages,
                    outOfOrderVideoControlMessages: (_g_qualityManager5 = g.qualityManager) === null || _g_qualityManager5 === void 0 ? void 0 : _g_qualityManager5.numOutOfOrderVideoControlMessages,
                    webcamFreezeIntervals: (_g_qualityManager6 = g.qualityManager) === null || _g_qualityManager6 === void 0 ? void 0 : _g_qualityManager6.numWebcamFreezeIntervals,
                    processedStreamFreezeIntervals: (_g_qualityManager7 = g.qualityManager) === null || _g_qualityManager7 === void 0 ? void 0 : _g_qualityManager7.numProcessedStreamFreezeIntervals,
                    IPAddress: (_g_IPAddress = g.IPAddress) !== null && _g_IPAddress !== void 0 ? _g_IPAddress : "none",
                    ReflexiveLocalIP: (_g_reflexiveLocalIP = g.reflexiveLocalIP) !== null && _g_reflexiveLocalIP !== void 0 ? _g_reflexiveLocalIP : "none",
                    NumberOfInterfaces: g.numInterfaces,
                    StartTime: g.startTime,
                    EndTime: g.endTime,
                    AudioTransportRecvBitrate: C === null || C === void 0 ? void 0 : (_C_transport = C.transport) === null || _C_transport === void 0 ? void 0 : (_C_transport_extensions = _C_transport.extensions) === null || _C_transport_extensions === void 0 ? void 0 : _C_transport_extensions.recvBWAvg,
                    AudioTransportSendBitrate: C === null || C === void 0 ? void 0 : (_C_transport1 = C.transport) === null || _C_transport1 === void 0 ? void 0 : (_C_transport_extensions1 = _C_transport1.extensions) === null || _C_transport_extensions1 === void 0 ? void 0 : _C_transport_extensions1.sendBWAvg,
                    AudioPayloadRecvBitrate: C === null || C === void 0 ? void 0 : (_C_aggregated = C.aggregated) === null || _C_aggregated === void 0 ? void 0 : _C_aggregated.bitrateAvg,
                    AudioPayloadSendBitrate: E === null || E === void 0 ? void 0 : (_E_aggregated = E.aggregated) === null || _E_aggregated === void 0 ? void 0 : _E_aggregated.bitrateAvg,
                    VideoPayloadRecvBitrate: T === null || T === void 0 ? void 0 : (_T_aggregated = T.aggregated) === null || _T_aggregated === void 0 ? void 0 : _T_aggregated.bitrateAvg,
                    VideoPayloadSendBitrate: I === null || I === void 0 ? void 0 : (_I_aggregated = I.aggregated) === null || _I_aggregated === void 0 ? void 0 : _I_aggregated.bitrateAvg,
                    WebRTCStats_bweStat_googAvailableReceiveBandwidth: (_sampleseries = sampleseries((__video2 = _.video) === null || __video2 === void 0 ? void 0 : __video2.recv, (g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableIncomingBitrate;
                    })) !== null && _sampleseries !== void 0 ? _sampleseries : sampleseries((__video3 = _.video) === null || __video3 === void 0 ? void 0 : __video3.send, (g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableIncomingBitrate;
                    }),
                    WebRTCStats_bweStat_googAvailableSendBandwidth: (_sampleseries1 = sampleseries((__video4 = _.video) === null || __video4 === void 0 ? void 0 : __video4.send, (g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate;
                    })) !== null && _sampleseries1 !== void 0 ? _sampleseries1 : sampleseries((__video5 = _.video) === null || __video5 === void 0 ? void 0 : __video5.recv, (g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate;
                    }),
                    Bandwidth_jumpsHistogram: JSON.stringify(I === null || I === void 0 ? void 0 : (_I_transport = I.transport) === null || _I_transport === void 0 ? void 0 : (_I_transport_extensions = _I_transport.extensions) === null || _I_transport_extensions === void 0 ? void 0 : _I_transport_extensions.bwJumpsHistogram),
                    StartCallBWESendSide: JSON.stringify(O === null || O === void 0 ? void 0 : O.startOfTheCall),
                    EndCallBWESendSide: JSON.stringify(O === null || O === void 0 ? void 0 : O.endOfTheCall),
                    BWEStdSendSide: JSON.stringify(O === null || O === void 0 ? void 0 : O.std),
                    BwPercentilesSendSide: JSON.stringify(O === null || O === void 0 ? void 0 : O.bwPercentiles),
                    AvgBwSendSide: JSON.stringify(O === null || O === void 0 ? void 0 : O.avgBwe),
                    StartCallBWE: JSON.stringify(D === null || D === void 0 ? void 0 : D.startOfTheCall),
                    EndCallBWE: JSON.stringify(D === null || D === void 0 ? void 0 : D.endOfTheCall),
                    BWEStd: JSON.stringify(D === null || D === void 0 ? void 0 : D.std),
                    BwPercentiles: JSON.stringify(D === null || D === void 0 ? void 0 : D.bwPercentiles),
                    AvgBw: JSON.stringify(D === null || D === void 0 ? void 0 : D.avgBwe),
                    WebRTCStats_ssrc: removeUndefinedFields({
                        audio: compileAudioReport(_, C, E),
                        video: compileVideoTelemetryReport("video", _, T, I),
                        sharing: compileVideoTelemetryReport("sharing", _, b, A)
                    }),
                    Audio_recv_jitterBufferAvgSize: C === null || C === void 0 ? void 0 : (_C_aggregated1 = C.aggregated) === null || _C_aggregated1 === void 0 ? void 0 : _C_aggregated1.avgJitterBufferSize,
                    Audio_recv_packetsLostRateMax: round(C === null || C === void 0 ? void 0 : (_C_aggregated2 = C.aggregated) === null || _C_aggregated2 === void 0 ? void 0 : _C_aggregated2.lossRateMax, 6),
                    Audio_recv_jitterAvg: C === null || C === void 0 ? void 0 : (_C_aggregated3 = C.aggregated) === null || _C_aggregated3 === void 0 ? void 0 : _C_aggregated3.jitterAvg,
                    Audio_recv_networkAvgLossRate: round(C === null || C === void 0 ? void 0 : (_C_aggregated4 = C.aggregated) === null || _C_aggregated4 === void 0 ? void 0 : _C_aggregated4.networkAvgLossRate, 6),
                    Audio_recv_packetsLostAvg: C === null || C === void 0 ? void 0 : (_C_aggregated5 = C.aggregated) === null || _C_aggregated5 === void 0 ? void 0 : _C_aggregated5.packetsLostAvg,
                    Audio_send_rttAvg: (E === null || E === void 0 ? void 0 : (_E_aggregated1 = E.aggregated) === null || _E_aggregated1 === void 0 ? void 0 : _E_aggregated1.rttAvg) && round(1e3 * E.aggregated.rttAvg),
                    Audio_send_rttMax: (E === null || E === void 0 ? void 0 : (_E_aggregated2 = E.aggregated) === null || _E_aggregated2 === void 0 ? void 0 : _E_aggregated2.rttMax) && round(1e3 * E.aggregated.rttMax),
                    Audio_send_RawInputVolume: sampleseries((__audio2 = _.audio) === null || __audio2 === void 0 ? void 0 : __audio2.send, (g)=>{
                        var _g_aggregated;
                        return (_g_aggregated = g.aggregated) === null || _g_aggregated === void 0 ? void 0 : _g_aggregated.rawInputVolume;
                    }),
                    Audio_send_packetsLostRateMax: round(E === null || E === void 0 ? void 0 : (_E_aggregated3 = E.aggregated) === null || _E_aggregated3 === void 0 ? void 0 : _E_aggregated3.lossRateMax, 6),
                    Audio_send_presentationAPIUserDuration: g.presentationAPIUserDuration,
                    Audio_send_presentationDuration: g.presentationAudioDuration,
                    Video_recv_DurationSeconds: T === null || T === void 0 ? void 0 : (_T_aggregated1 = T.aggregated) === null || _T_aggregated1 === void 0 ? void 0 : _T_aggregated1.duration,
                    Video_recv_FreezeHistogram: JSON.stringify(T === null || T === void 0 ? void 0 : (_T_aggregated2 = T.aggregated) === null || _T_aggregated2 === void 0 ? void 0 : _T_aggregated2.freezeCountHistogram),
                    Video_recv_FreezeTimestamps: JSON.stringify(rebaseHistogramTimestamps(T === null || T === void 0 ? void 0 : (_T_aggregated3 = T.aggregated) === null || _T_aggregated3 === void 0 ? void 0 : _T_aggregated3.freezeTimestampsHistogram, g.startTime)),
                    Video_recv_LongestFreezeDuration: T === null || T === void 0 ? void 0 : (_T_aggregated4 = T.aggregated) === null || _T_aggregated4 === void 0 ? void 0 : _T_aggregated4.longestFreeze,
                    Video_recv_OngoingFreeze: T === null || T === void 0 ? void 0 : (_T_extensions = T.extensions) === null || _T_extensions === void 0 ? void 0 : _T_extensions.isFrozen,
                    Video_recv_OngoingFreezeDuration: T === null || T === void 0 ? void 0 : (_T_aggregated5 = T.aggregated) === null || _T_aggregated5 === void 0 ? void 0 : _T_aggregated5.ongoingFreezeDuration,
                    Video_recv_TotalFreezeDuration: T === null || T === void 0 ? void 0 : (_T_aggregated6 = T.aggregated) === null || _T_aggregated6 === void 0 ? void 0 : _T_aggregated6.totalFreezeDuration,
                    Video_recv_RecvAvgFreezeDuration: T === null || T === void 0 ? void 0 : (_T_aggregated7 = T.aggregated) === null || _T_aggregated7 === void 0 ? void 0 : _T_aggregated7.avgFreezeDuration,
                    Video_recv_NumResolutionSwitches: T === null || T === void 0 ? void 0 : (_T_aggregated8 = T.aggregated) === null || _T_aggregated8 === void 0 ? void 0 : _T_aggregated8.numResolutionSwitches,
                    Video_recv_ResolutionDurations: JSON.stringify(T === null || T === void 0 ? void 0 : (_T_aggregated9 = T.aggregated) === null || _T_aggregated9 === void 0 ? void 0 : _T_aggregated9.resolutionDurations),
                    Video_recv_StreamsMax: g.recvVideoStreamCount.max,
                    Video_recv_StreamsMin: g.recvVideoStreamCount.min,
                    Video_recv_StreamsMode: g.recvVideoStreamCount.mode,
                    Video_recv_TimeToFirstFrame: (_g_remoteVideoManager = g.remoteVideoManager) === null || _g_remoteVideoManager === void 0 ? void 0 : _g_remoteVideoManager.firstTimeToFirstFrameVideo,
                    Video_recv_TimeToFirstFrameSinceSubscriptionStart: (_g_remoteVideoManager1 = g.remoteVideoManager) === null || _g_remoteVideoManager1 === void 0 ? void 0 : _g_remoteVideoManager1.firstTimeToFirstFrameVideo,
                    Video_recv_bitrateAvg: T === null || T === void 0 ? void 0 : (_T_aggregated10 = T.aggregated) === null || _T_aggregated10 === void 0 ? void 0 : _T_aggregated10.bitrateAvg,
                    Video_recv_bitrateMax: T === null || T === void 0 ? void 0 : (_T_aggregated11 = T.aggregated) === null || _T_aggregated11 === void 0 ? void 0 : _T_aggregated11.bitrateMax,
                    Video_recv_frameRateAvg: T === null || T === void 0 ? void 0 : (_T_aggregated12 = T.aggregated) === null || _T_aggregated12 === void 0 ? void 0 : _T_aggregated12.avgFrameRate,
                    Video_recv_jitterBufferAvgSize: T === null || T === void 0 ? void 0 : (_T_aggregated13 = T.aggregated) === null || _T_aggregated13 === void 0 ? void 0 : _T_aggregated13.avgJitterBufferSize,
                    Video_recv_packetsLostRateMax: round(T === null || T === void 0 ? void 0 : (_T_aggregated14 = T.aggregated) === null || _T_aggregated14 === void 0 ? void 0 : _T_aggregated14.lossRateMax, 6),
                    Video_recv_isRenderingEvents: JSON.stringify(limitArraySize2((_g_remoteVideoManager2 = g.remoteVideoManager) === null || _g_remoteVideoManager2 === void 0 ? void 0 : _g_remoteVideoManager2.isRenderingEvents.video, v.numIsRenderingEvents)),
                    Video_recv_FpsHarmonicAverage: T === null || T === void 0 ? void 0 : (_T_aggregated15 = T.aggregated) === null || _T_aggregated15 === void 0 ? void 0 : _T_aggregated15.fpsHarmonicAverage,
                    Video_recv_PreferredResolution: (_g_remoteVideoManager3 = g.remoteVideoManager) === null || _g_remoteVideoManager3 === void 0 ? void 0 : (_g_remoteVideoManager_preferredResolution_video = _g_remoteVideoManager3.preferredResolution.video) === null || _g_remoteVideoManager_preferredResolution_video === void 0 ? void 0 : _g_remoteVideoManager_preferredResolution_video.toString(),
                    Video_recv_statsOnSubscribed: JSON.stringify(N),
                    Video_SubscriptionEvents: JSON.stringify(rebaseTime((_g_subscriptionManager = g.subscriptionManager) === null || _g_subscriptionManager === void 0 ? void 0 : _g_subscriptionManager.video.events, "ts", g.startTime)),
                    Video_SubscriptionCounters: JSON.stringify((_g_subscriptionManager1 = g.subscriptionManager) === null || _g_subscriptionManager1 === void 0 ? void 0 : _g_subscriptionManager1.video.counters),
                    Video_send_CaptureFramerateAvg: I === null || I === void 0 ? void 0 : (_I_aggregated1 = I.aggregated) === null || _I_aggregated1 === void 0 ? void 0 : _I_aggregated1.captureFramerateAvg,
                    Video_send_DurationSeconds: I === null || I === void 0 ? void 0 : (_I_aggregated2 = I.aggregated) === null || _I_aggregated2 === void 0 ? void 0 : _I_aggregated2.duration,
                    Video_send_FreezeIntervals: I === null || I === void 0 ? void 0 : (_I_extensions = I.extensions) === null || _I_extensions === void 0 ? void 0 : _I_extensions.captureFreezeIntervalsCount,
                    Video_send_MaxCapabilities: JSON.stringify(R),
                    Video_send_MaxCapabilitiesErrors: JSON.stringify(P),
                    Video_send_OvershootDurations: JSON.stringify({
                        fs: I === null || I === void 0 ? void 0 : (_I_aggregated3 = I.aggregated) === null || _I_aggregated3 === void 0 ? void 0 : _I_aggregated3.totalFsOvershootDuration,
                        fps: I === null || I === void 0 ? void 0 : (_I_aggregated4 = I.aggregated) === null || _I_aggregated4 === void 0 ? void 0 : _I_aggregated4.totalFpsOvershootDuration,
                        br: I === null || I === void 0 ? void 0 : (_I_aggregated5 = I.aggregated) === null || _I_aggregated5 === void 0 ? void 0 : _I_aggregated5.totalBrOvershootDuration
                    }),
                    Video_send_OvershootEvents: limitRebaseAndStringifyEvents(I === null || I === void 0 ? void 0 : (_I_aggregated6 = I.aggregated) === null || _I_aggregated6 === void 0 ? void 0 : _I_aggregated6.overshootEvents, v.numOvershootEvents, "timestamp", g.startTime),
                    Video_send_QpAvg: I === null || I === void 0 ? void 0 : (_I_aggregated7 = I.aggregated) === null || _I_aggregated7 === void 0 ? void 0 : _I_aggregated7.qpAvg,
                    Video_send_bitrateAvg: I === null || I === void 0 ? void 0 : (_I_aggregated8 = I.aggregated) === null || _I_aggregated8 === void 0 ? void 0 : _I_aggregated8.bitrateAvg,
                    Video_send_bitrateMax: I === null || I === void 0 ? void 0 : (_I_aggregated9 = I.aggregated) === null || _I_aggregated9 === void 0 ? void 0 : _I_aggregated9.bitrateMax,
                    Video_send_frameRateAvg: I === null || I === void 0 ? void 0 : (_I_aggregated10 = I.aggregated) === null || _I_aggregated10 === void 0 ? void 0 : _I_aggregated10.frameRateAvg,
                    Video_send_AllocateBWAvg: I === null || I === void 0 ? void 0 : (_I_aggregated11 = I.aggregated) === null || _I_aggregated11 === void 0 ? void 0 : _I_aggregated11.bweAvg,
                    Video_send_CameraOpenWidth: I === null || I === void 0 ? void 0 : (_I_extensions1 = I.extensions) === null || _I_extensions1 === void 0 ? void 0 : (_I_extensions_cameraOpenResolution = _I_extensions1.cameraOpenResolution) === null || _I_extensions_cameraOpenResolution === void 0 ? void 0 : _I_extensions_cameraOpenResolution.width,
                    Video_send_CameraOpenHeight: I === null || I === void 0 ? void 0 : (_I_extensions2 = I.extensions) === null || _I_extensions2 === void 0 ? void 0 : (_I_extensions_cameraOpenResolution1 = _I_extensions2.cameraOpenResolution) === null || _I_extensions_cameraOpenResolution1 === void 0 ? void 0 : _I_extensions_cameraOpenResolution1.height,
                    Video_send_packetsLostRateMax: round(I === null || I === void 0 ? void 0 : (_I_aggregated12 = I.aggregated) === null || _I_aggregated12 === void 0 ? void 0 : _I_aggregated12.lossRateMax, 6),
                    Video_send_resolutionSwitches: JSON.stringify(I === null || I === void 0 ? void 0 : (_I_aggregated13 = I.aggregated) === null || _I_aggregated13 === void 0 ? void 0 : _I_aggregated13.resolutionSwitches),
                    Video_send_performanceEvents: JSON.stringify(limitArraySize2(rebaseTime(g.localVideoPerformanceEvents, "timestamp", g.startTime), v.numPerformanceEvents)),
                    Video_send_Simulcast: JSON.stringify((_g_simulcast = g.simulcast) === null || _g_simulcast === void 0 ? void 0 : _g_simulcast.video),
                    Sharing_recv_DurationSeconds: b === null || b === void 0 ? void 0 : (_b_aggregated = b.aggregated) === null || _b_aggregated === void 0 ? void 0 : _b_aggregated.duration,
                    Sharing_recv_FreezeHistogram: JSON.stringify(b === null || b === void 0 ? void 0 : (_b_aggregated1 = b.aggregated) === null || _b_aggregated1 === void 0 ? void 0 : _b_aggregated1.freezeCountHistogram),
                    Sharing_recv_FreezeTimestamps: JSON.stringify(rebaseHistogramTimestamps(b === null || b === void 0 ? void 0 : (_b_aggregated2 = b.aggregated) === null || _b_aggregated2 === void 0 ? void 0 : _b_aggregated2.freezeTimestampsHistogram, g.startTime)),
                    Sharing_recv_LongestFreezeDuration: b === null || b === void 0 ? void 0 : (_b_aggregated3 = b.aggregated) === null || _b_aggregated3 === void 0 ? void 0 : _b_aggregated3.longestFreeze,
                    Sharing_recv_OngoingFreeze: b === null || b === void 0 ? void 0 : (_b_extensions = b.extensions) === null || _b_extensions === void 0 ? void 0 : _b_extensions.isFrozen,
                    Sharing_recv_TotalFreezeDuration: b === null || b === void 0 ? void 0 : (_b_aggregated4 = b.aggregated) === null || _b_aggregated4 === void 0 ? void 0 : _b_aggregated4.totalFreezeDuration,
                    Sharing_recv_RecvAvgFreezeDuration: b === null || b === void 0 ? void 0 : (_b_aggregated5 = b.aggregated) === null || _b_aggregated5 === void 0 ? void 0 : _b_aggregated5.avgFreezeDuration,
                    Sharing_recv_NumResolutionSwitches: b === null || b === void 0 ? void 0 : (_b_aggregated6 = b.aggregated) === null || _b_aggregated6 === void 0 ? void 0 : _b_aggregated6.numResolutionSwitches,
                    Sharing_recv_ResolutionDurations: JSON.stringify(b === null || b === void 0 ? void 0 : (_b_aggregated7 = b.aggregated) === null || _b_aggregated7 === void 0 ? void 0 : _b_aggregated7.resolutionDurations),
                    Sharing_recv_StreamsMax: g.recvVideoStreamCount.max,
                    Sharing_recv_StreamsMin: g.recvVideoStreamCount.min,
                    Sharing_recv_StreamsMode: g.recvVideoStreamCount.mode,
                    Sharing_recv_TimeToFirstFrame: (_g_remoteVideoManager4 = g.remoteVideoManager) === null || _g_remoteVideoManager4 === void 0 ? void 0 : _g_remoteVideoManager4.firstTimeToFirstFrameSharing,
                    Sharing_recv_TimeToFirstFrameSinceSubscriptionStart: (_g_remoteVideoManager5 = g.remoteVideoManager) === null || _g_remoteVideoManager5 === void 0 ? void 0 : _g_remoteVideoManager5.firstTimeToFirstFrameVideo,
                    Sharing_recv_bitrateAvg: b === null || b === void 0 ? void 0 : (_b_aggregated8 = b.aggregated) === null || _b_aggregated8 === void 0 ? void 0 : _b_aggregated8.bitrateAvg,
                    Sharing_recv_bitrateMax: b === null || b === void 0 ? void 0 : (_b_aggregated9 = b.aggregated) === null || _b_aggregated9 === void 0 ? void 0 : _b_aggregated9.bitrateMax,
                    Sharing_recv_frameRateAvg: b === null || b === void 0 ? void 0 : (_b_aggregated10 = b.aggregated) === null || _b_aggregated10 === void 0 ? void 0 : _b_aggregated10.avgFrameRate,
                    Sharing_recv_jitterBufferAvgSize: b === null || b === void 0 ? void 0 : (_b_aggregated11 = b.aggregated) === null || _b_aggregated11 === void 0 ? void 0 : _b_aggregated11.avgJitterBufferSize,
                    Sharing_recv_packetsLostRateMax: round(b === null || b === void 0 ? void 0 : (_b_aggregated12 = b.aggregated) === null || _b_aggregated12 === void 0 ? void 0 : _b_aggregated12.lossRateMax, 6),
                    Sharing_recv_FpsHarmonicAverage: b === null || b === void 0 ? void 0 : (_b_aggregated13 = b.aggregated) === null || _b_aggregated13 === void 0 ? void 0 : _b_aggregated13.fpsHarmonicAverage,
                    Sharing_recv_isRenderingEvents: JSON.stringify(limitArraySize2((_g_remoteVideoManager6 = g.remoteVideoManager) === null || _g_remoteVideoManager6 === void 0 ? void 0 : _g_remoteVideoManager6.isRenderingEvents.sharing, v.numIsRenderingEvents)),
                    Sharing_recv_PreferredResolution: (_g_remoteVideoManager7 = g.remoteVideoManager) === null || _g_remoteVideoManager7 === void 0 ? void 0 : (_g_remoteVideoManager_preferredResolution_sharing = _g_remoteVideoManager7.preferredResolution.sharing) === null || _g_remoteVideoManager_preferredResolution_sharing === void 0 ? void 0 : _g_remoteVideoManager_preferredResolution_sharing.toString(),
                    Sharing_recv_statsOnSubscribed: JSON.stringify(k),
                    Sharing_SubscriptionEvents: JSON.stringify(rebaseTime((_g_subscriptionManager2 = g.subscriptionManager) === null || _g_subscriptionManager2 === void 0 ? void 0 : _g_subscriptionManager2.sharing.events, "ts", g.startTime)),
                    Sharing_SubscriptionCounters: JSON.stringify((_g_subscriptionManager3 = g.subscriptionManager) === null || _g_subscriptionManager3 === void 0 ? void 0 : _g_subscriptionManager3.sharing.counters),
                    Sharing_send_CaptureFramerateAvg: A === null || A === void 0 ? void 0 : (_A_aggregated = A.aggregated) === null || _A_aggregated === void 0 ? void 0 : _A_aggregated.captureFramerateAvg,
                    Sharing_send_DurationSeconds: A === null || A === void 0 ? void 0 : (_A_aggregated1 = A.aggregated) === null || _A_aggregated1 === void 0 ? void 0 : _A_aggregated1.duration,
                    Sharing_send_MaxCapabilities: JSON.stringify(w),
                    Sharing_send_MaxCapabilitiesErrors: JSON.stringify(M),
                    Sharing_send_OvershootDurations: JSON.stringify({
                        fs: A === null || A === void 0 ? void 0 : (_A_aggregated2 = A.aggregated) === null || _A_aggregated2 === void 0 ? void 0 : _A_aggregated2.totalFsOvershootDuration,
                        fps: A === null || A === void 0 ? void 0 : (_A_aggregated3 = A.aggregated) === null || _A_aggregated3 === void 0 ? void 0 : _A_aggregated3.totalFpsOvershootDuration,
                        br: A === null || A === void 0 ? void 0 : (_A_aggregated4 = A.aggregated) === null || _A_aggregated4 === void 0 ? void 0 : _A_aggregated4.totalBrOvershootDuration
                    }),
                    Sharing_send_resolutionSwitches: A === null || A === void 0 ? void 0 : (_A_aggregated5 = A.aggregated) === null || _A_aggregated5 === void 0 ? void 0 : _A_aggregated5.resolutionSwitches,
                    Sharing_send_OvershootEvents: limitRebaseAndStringifyEvents(A === null || A === void 0 ? void 0 : (_A_aggregated6 = A.aggregated) === null || _A_aggregated6 === void 0 ? void 0 : _A_aggregated6.overshootEvents, v.numOvershootEvents, "timestamp", g.startTime),
                    Sharing_send_QpAvg: A === null || A === void 0 ? void 0 : (_A_aggregated7 = A.aggregated) === null || _A_aggregated7 === void 0 ? void 0 : _A_aggregated7.qpAvg,
                    Sharing_send_bitrateAvg: A === null || A === void 0 ? void 0 : (_A_aggregated8 = A.aggregated) === null || _A_aggregated8 === void 0 ? void 0 : _A_aggregated8.bitrateAvg,
                    Sharing_send_bitrateMax: A === null || A === void 0 ? void 0 : (_A_aggregated9 = A.aggregated) === null || _A_aggregated9 === void 0 ? void 0 : _A_aggregated9.bitrateMax,
                    Sharing_send_frameRateAvg: A === null || A === void 0 ? void 0 : (_A_aggregated10 = A.aggregated) === null || _A_aggregated10 === void 0 ? void 0 : _A_aggregated10.frameRateAvg,
                    Sharing_send_AllocateBWAvg: A === null || A === void 0 ? void 0 : (_A_aggregated11 = A.aggregated) === null || _A_aggregated11 === void 0 ? void 0 : _A_aggregated11.bweAvg,
                    Sharing_send_packetsLostRateMax: round(A === null || A === void 0 ? void 0 : (_A_aggregated12 = A.aggregated) === null || _A_aggregated12 === void 0 ? void 0 : _A_aggregated12.lossRateMax, 6),
                    Sharing_send_Simulcast: JSON.stringify((_g_simulcast1 = g.simulcast) === null || _g_simulcast1 === void 0 ? void 0 : _g_simulcast1.sharing),
                    Data_ProtocolCounters: JSON.stringify((_g_dataChannel = g.dataChannel) === null || _g_dataChannel === void 0 ? void 0 : _g_dataChannel.protocolCounters),
                    Data_Error: (_g_dataChannel1 = g.dataChannel) === null || _g_dataChannel1 === void 0 ? void 0 : _g_dataChannel1.error,
                    Data_SessionState: (_g_dataChannelSessionState = g.dataChannelSessionState) === null || _g_dataChannelSessionState === void 0 ? void 0 : _g_dataChannelSessionState.toString(),
                    Data_CreateChannelError: g.dataChannelCreationError,
                    multipleVideoStreams: JSON.stringify(rebaseTime(g.multiViewStats, "startTime", g.startTime)),
                    ReportedReceiveBandwidth: JSON.stringify(g.reportedReceiveBandwidth),
                    ReportedSendBandwidth: JSON.stringify(g.reportedSendBandwidthLayouts),
                    OvcToSubscriptions: JSON.stringify(g.ovcToSubscriptionEvents),
                    EncodedStreamWorker: g.encodedStreamWorker,
                    AudioCodecEvents: JSON.stringify(g.audioCodecEvents),
                    HevcCodecSupport: JSON.stringify(g.codecSupport),
                    MeetingScenario: JSON.stringify(g.negotiation.meetingScenario),
                    IsTownHall: g.negotiation.isTownHall,
                    InitialBWSeed: g.initialBWSeed,
                    SentBWSeed: g.sentBWSeed,
                    videoPerformanceEvent: JSON.stringify(g.videoPerformanceEvent),
                    EarlyMedia_NumStatsPolls: g.earlyMediaNumStatsPolls
                });
            }
            var videoSendStatsFieldConverter = (g)=>{
                var _g_codec_mimeType, _g_codec, _g_extensions, _g_remoteInboundRTP, _g_extensions1, _g_remoteInboundRTP1, _g_extensions2, _g_remoteInboundRTP2, _g_mediaSource, _g_mediaSource1, _g_mediaSource2, _g_extensions3, _g_extensions4, _g_altLayouts;
                return removeUndefinedFields({
                    id: g.outboundRTP.ssrc.toString(),
                    codecName: (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : (_g_codec_mimeType = _g_codec.mimeType) === null || _g_codec_mimeType === void 0 ? void 0 : _g_codec_mimeType.split("/").pop().toUpperCase(),
                    bitrate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate,
                    jitter: (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.jitter,
                    packets: g.outboundRTP.packetsSent,
                    packetsPerSecond: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.packetsPerSecond,
                    packetsLost: (_g_remoteInboundRTP1 = g.remoteInboundRTP) === null || _g_remoteInboundRTP1 === void 0 ? void 0 : _g_remoteInboundRTP1.packetsLost,
                    packetsLostPerSecond: (_g_extensions2 = g.extensions) === null || _g_extensions2 === void 0 ? void 0 : _g_extensions2.packetsLostPerSecond,
                    rtt: (_g_remoteInboundRTP2 = g.remoteInboundRTP) === null || _g_remoteInboundRTP2 === void 0 ? void 0 : _g_remoteInboundRTP2.roundTripTime,
                    frameRateInput: (_g_mediaSource = g.mediaSource) === null || _g_mediaSource === void 0 ? void 0 : _g_mediaSource.framesPerSecond,
                    frameWidthInput: (_g_mediaSource1 = g.mediaSource) === null || _g_mediaSource1 === void 0 ? void 0 : _g_mediaSource1.width,
                    frameHeightInput: (_g_mediaSource2 = g.mediaSource) === null || _g_mediaSource2 === void 0 ? void 0 : _g_mediaSource2.height,
                    framesEncoded: g.outboundRTP.framesEncoded,
                    frameRateEncoded: (_g_extensions3 = g.extensions) === null || _g_extensions3 === void 0 ? void 0 : _g_extensions3.frameRateEncoded,
                    framesSent: g.outboundRTP.framesSent,
                    frameRateSent: (_g_extensions4 = g.extensions) === null || _g_extensions4 === void 0 ? void 0 : _g_extensions4.frameRateSent,
                    frameWidthSent: g.outboundRTP.frameWidth,
                    frameHeightSent: g.outboundRTP.frameHeight,
                    keyFramesEncoded: g.outboundRTP.keyFramesEncoded,
                    nackCount: g.outboundRTP.nackCount,
                    firCount: g.outboundRTP.firCount,
                    pliCount: g.outboundRTP.pliCount,
                    transportId: g.outboundRTP.transportId,
                    altLayouts: (_g_altLayouts = g.altLayouts) === null || _g_altLayouts === void 0 ? void 0 : _g_altLayouts.map(videoSendStatsFieldConverter)
                });
            }, videoRecvStatsFieldConverter = (g)=>{
                var _g_codec_mimeType, _g_codec, _g_extensions, _g_extensions1, _g_extensions2, _g_remoteOutboundRTP, _g_renderer, _g_extensions3, _g_extensions4, _g_extensions5, _g_extensions6, _g_extensions7, _g_extensions8;
                return removeUndefinedFields({
                    id: g.inboundRTP.ssrc.toString(),
                    codecName: (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : (_g_codec_mimeType = _g_codec.mimeType) === null || _g_codec_mimeType === void 0 ? void 0 : _g_codec_mimeType.split("/").pop().toUpperCase(),
                    bitrate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate,
                    jitter: g.inboundRTP.jitter,
                    packets: g.inboundRTP.packetsReceived,
                    packetsPerSecond: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.packetsPerSecond,
                    packetsLost: g.inboundRTP.packetsLost,
                    packetsLostPerSecond: (_g_extensions2 = g.extensions) === null || _g_extensions2 === void 0 ? void 0 : _g_extensions2.packetsLostPerSecond,
                    packetsDiscarded: g.inboundRTP.packetsDiscarded,
                    rtt: (_g_remoteOutboundRTP = g.remoteOutboundRTP) === null || _g_remoteOutboundRTP === void 0 ? void 0 : _g_remoteOutboundRTP.roundTripTime,
                    msi: (_g_renderer = g.renderer) === null || _g_renderer === void 0 ? void 0 : _g_renderer.msi,
                    jitterBufferMs: (_g_extensions3 = g.extensions) === null || _g_extensions3 === void 0 ? void 0 : _g_extensions3.jitterBufferMs,
                    frameRateOutput: (_g_extensions4 = g.extensions) === null || _g_extensions4 === void 0 ? void 0 : _g_extensions4.frameRateDecoded,
                    frameRateDecoded: (_g_extensions5 = g.extensions) === null || _g_extensions5 === void 0 ? void 0 : _g_extensions5.frameRateDecoded,
                    frameRateReceived: (_g_extensions6 = g.extensions) === null || _g_extensions6 === void 0 ? void 0 : _g_extensions6.frameRateReceived,
                    frameWidthReceived: g.inboundRTP.frameWidth,
                    frameHeightReceived: g.inboundRTP.frameHeight,
                    longestFreezeDuration: (_g_extensions7 = g.extensions) === null || _g_extensions7 === void 0 ? void 0 : _g_extensions7.longestFreeze,
                    totalFreezeDuration: (_g_extensions8 = g.extensions) === null || _g_extensions8 === void 0 ? void 0 : _g_extensions8.totalFreezeDuration,
                    framesReceived: g.inboundRTP.framesReceived,
                    framesDropped: g.inboundRTP.framesDropped,
                    framesDecoded: g.inboundRTP.framesDecoded,
                    keyFramesDecoded: g.inboundRTP.keyFramesDecoded,
                    nackCount: g.inboundRTP.nackCount,
                    firCount: g.inboundRTP.firCount,
                    pliCount: g.inboundRTP.pliCount,
                    transportId: g.inboundRTP.transportId
                });
            }, audioSendStatsFieldConverter = (g)=>{
                var _g_codec_mimeType, _g_codec, _g_extensions, _g_remoteInboundRTP, _g_extensions1, _g_remoteInboundRTP1, _g_extensions2, _g_remoteInboundRTP2, _g_remoteInboundRTP3, _g_mediaSource;
                return removeUndefinedFields({
                    id: g.outboundRTP.ssrc.toString(),
                    codecName: (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : (_g_codec_mimeType = _g_codec.mimeType) === null || _g_codec_mimeType === void 0 ? void 0 : _g_codec_mimeType.split("/").pop().toUpperCase(),
                    bitrate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate,
                    jitter: (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.jitter,
                    packets: g.outboundRTP.packetsSent,
                    packetsPerSecond: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.packetsPerSecond,
                    packetsLost: (_g_remoteInboundRTP1 = g.remoteInboundRTP) === null || _g_remoteInboundRTP1 === void 0 ? void 0 : _g_remoteInboundRTP1.packetsLost,
                    packetsLostPerSecond: (_g_extensions2 = g.extensions) === null || _g_extensions2 === void 0 ? void 0 : _g_extensions2.packetsLostPerSecond,
                    packetsDiscarded: (_g_remoteInboundRTP2 = g.remoteInboundRTP) === null || _g_remoteInboundRTP2 === void 0 ? void 0 : _g_remoteInboundRTP2.packetsDiscarded,
                    rtt: (_g_remoteInboundRTP3 = g.remoteInboundRTP) === null || _g_remoteInboundRTP3 === void 0 ? void 0 : _g_remoteInboundRTP3.roundTripTime,
                    audioLevel: (_g_mediaSource = g.mediaSource) === null || _g_mediaSource === void 0 ? void 0 : _g_mediaSource.audioLevel,
                    transportId: g.outboundRTP.transportId
                });
            }, audioRecvStatsFieldConverter = (g)=>{
                var _g_codec_mimeType, _g_codec, _g_extensions, _g_extensions1, _g_extensions2, _g_remoteOutboundRTP, _g_extensions3, _g_extensions4;
                return removeUndefinedFields({
                    id: g.inboundRTP.ssrc.toString(),
                    codecName: (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : (_g_codec_mimeType = _g_codec.mimeType) === null || _g_codec_mimeType === void 0 ? void 0 : _g_codec_mimeType.split("/").pop().toUpperCase(),
                    bitrate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate,
                    jitter: g.inboundRTP.jitter,
                    packets: g.inboundRTP.packetsReceived,
                    packetsPerSecond: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.packetsPerSecond,
                    packetsLost: g.inboundRTP.packetsLost,
                    packetsLostPerSecond: (_g_extensions2 = g.extensions) === null || _g_extensions2 === void 0 ? void 0 : _g_extensions2.packetsLostPerSecond,
                    packetsDiscarded: g.inboundRTP.packetsDiscarded,
                    rtt: (_g_remoteOutboundRTP = g.remoteOutboundRTP) === null || _g_remoteOutboundRTP === void 0 ? void 0 : _g_remoteOutboundRTP.roundTripTime,
                    jitterBufferMs: (_g_extensions3 = g.extensions) === null || _g_extensions3 === void 0 ? void 0 : _g_extensions3.jitterBufferMs,
                    audioLevel: g.inboundRTP.audioLevel,
                    healedRatio: (_g_extensions4 = g.extensions) === null || _g_extensions4 === void 0 ? void 0 : _g_extensions4.healedRatio,
                    transportId: g.inboundRTP.transportId
                });
            }, dataChannelStatsFieldConverter = (g)=>{
                var _g_extensions, _g_extensions1, _g_extensions2, _g_extensions3;
                return removeUndefinedFields({
                    id: g.id,
                    state: g.state,
                    dataChannelIdentifier: g.dataChannelIdentifier,
                    messagesSent: g.messagesSent,
                    bytesSent: g.bytesSent,
                    messagesReceived: g.messagesReceived,
                    bytesReceived: g.bytesReceived,
                    sendBitrate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.sendBitrate,
                    recvBitrate: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.recvBitrate,
                    messagesSentPerSecond: (_g_extensions2 = g.extensions) === null || _g_extensions2 === void 0 ? void 0 : _g_extensions2.sendMessageRate,
                    messagesReceivedPerSecond: (_g_extensions3 = g.extensions) === null || _g_extensions3 === void 0 ? void 0 : _g_extensions3.recvMessageRate
                });
            }, transportStatsFieldConverter = (g)=>{
                var _g_selectedCandidatePair, _g_selectedCandidatePair1, _g_selectedCandidatePair2, _g_selectedCandidatePair_localCandidate, _g_selectedCandidatePair3, _g_selectedCandidatePair_localCandidate1, _g_selectedCandidatePair4, _g_selectedCandidatePair_remoteCandidate, _g_selectedCandidatePair5;
                var _g_selectedCandidatePair_localCandidate_candidateType, _g_selectedCandidatePair_remoteCandidate_candidateType;
                return removeUndefinedFields({
                    id: g.id,
                    rtt: (_g_selectedCandidatePair = g.selectedCandidatePair) === null || _g_selectedCandidatePair === void 0 ? void 0 : _g_selectedCandidatePair.currentRoundTripTime,
                    availableIncomingBitrate: (_g_selectedCandidatePair1 = g.selectedCandidatePair) === null || _g_selectedCandidatePair1 === void 0 ? void 0 : _g_selectedCandidatePair1.availableIncomingBitrate,
                    availableOutgoingBitrate: (_g_selectedCandidatePair2 = g.selectedCandidatePair) === null || _g_selectedCandidatePair2 === void 0 ? void 0 : _g_selectedCandidatePair2.availableOutgoingBitrate,
                    relayProtocol: (_g_selectedCandidatePair3 = g.selectedCandidatePair) === null || _g_selectedCandidatePair3 === void 0 ? void 0 : (_g_selectedCandidatePair_localCandidate = _g_selectedCandidatePair3.localCandidate) === null || _g_selectedCandidatePair_localCandidate === void 0 ? void 0 : _g_selectedCandidatePair_localCandidate.relayProtocol,
                    candidateType: `${(_g_selectedCandidatePair_localCandidate_candidateType = (_g_selectedCandidatePair4 = g.selectedCandidatePair) === null || _g_selectedCandidatePair4 === void 0 ? void 0 : (_g_selectedCandidatePair_localCandidate1 = _g_selectedCandidatePair4.localCandidate) === null || _g_selectedCandidatePair_localCandidate1 === void 0 ? void 0 : _g_selectedCandidatePair_localCandidate1.candidateType) !== null && _g_selectedCandidatePair_localCandidate_candidateType !== void 0 ? _g_selectedCandidatePair_localCandidate_candidateType : ""}:${(_g_selectedCandidatePair_remoteCandidate_candidateType = (_g_selectedCandidatePair5 = g.selectedCandidatePair) === null || _g_selectedCandidatePair5 === void 0 ? void 0 : (_g_selectedCandidatePair_remoteCandidate = _g_selectedCandidatePair5.remoteCandidate) === null || _g_selectedCandidatePair_remoteCandidate === void 0 ? void 0 : _g_selectedCandidatePair_remoteCandidate.candidateType) !== null && _g_selectedCandidatePair_remoteCandidate_candidateType !== void 0 ? _g_selectedCandidatePair_remoteCandidate_candidateType : ""}`
                });
            };
            function compileAudioSendReport(g) {
                var _g_audio;
                var _g_audio_send;
                return ((_g_audio_send = (_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : _g_audio.send) !== null && _g_audio_send !== void 0 ? _g_audio_send : []).map(audioSendStatsFieldConverter);
            }
            function compileAudioRecvReport(g) {
                var _g_audio;
                var _g_audio_recv;
                return ((_g_audio_recv = (_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : _g_audio.recv) !== null && _g_audio_recv !== void 0 ? _g_audio_recv : []).map(audioRecvStatsFieldConverter);
            }
            function compileVideoSendReport(g) {
                var _g_video_send, _g_video;
                if (!((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length)) return [];
                return g.video.send.map(videoSendStatsFieldConverter);
            }
            function compileVideoRecvReport(g) {
                var _g_video;
                var _g_video_recv;
                return ((_g_video_recv = (_g_video = g.video) === null || _g_video === void 0 ? void 0 : _g_video.recv) !== null && _g_video_recv !== void 0 ? _g_video_recv : []).map(videoRecvStatsFieldConverter);
            }
            function compileScreenShareSendReport(g) {
                var _g_sharing_send, _g_sharing;
                if (!((_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : (_g_sharing_send = _g_sharing.send) === null || _g_sharing_send === void 0 ? void 0 : _g_sharing_send.length)) return [];
                return g.sharing.send.map(videoSendStatsFieldConverter);
            }
            function compileScreenShareRecvReport(g) {
                var _g_sharing;
                var _g_sharing_recv;
                return ((_g_sharing_recv = (_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : _g_sharing.recv) !== null && _g_sharing_recv !== void 0 ? _g_sharing_recv : []).map(videoRecvStatsFieldConverter);
            }
            function compileDataChannelReport(g) {
                var _g_data;
                return ((_g_data = g.data) !== null && _g_data !== void 0 ? _g_data : []).map(dataChannelStatsFieldConverter);
            }
            function compileTransportReport(g) {
                var _g_transports;
                return Object.values((_g_transports = g.transports) !== null && _g_transports !== void 0 ? _g_transports : {}).map(transportStatsFieldConverter);
            }
            function compileMediaStatsReport(g) {
                return {
                    audio: {
                        send: compileAudioSendReport(g),
                        recv: compileAudioRecvReport(g)
                    },
                    video: {
                        send: compileVideoSendReport(g),
                        recv: compileVideoRecvReport(g)
                    },
                    screenShare: {
                        send: compileScreenShareSendReport(g),
                        recv: compileScreenShareRecvReport(g)
                    },
                    data: compileDataChannelReport(g),
                    transports: compileTransportReport(g)
                };
            }
            function compileMediaStatsReportExtensions(g, f) {
                var _g_subscriptionManager, _g_subscriptionManager1, _g_remoteVideoManager, _g_remoteVideoManager1, _g_remoteVideoManager2, _g_remoteVideoManager3;
                const S = g.qualityManager && limitArraySize2(deepClone(g.qualityManager.videoMaxCapabilitiesEvents), f.config.diagnostics.telemetryLimits.numCapabilitiesRequested), v = g.qualityManager && limitArraySize2(deepClone(g.qualityManager.sharingMaxCapabilitiesEvents), f.config.diagnostics.telemetryLimits.numCapabilitiesRequested);
                return removeUndefinedFields({
                    Video_SubscriptionEvents: JSON.stringify((_g_subscriptionManager = g.subscriptionManager) === null || _g_subscriptionManager === void 0 ? void 0 : _g_subscriptionManager.video.events),
                    Sharing_SubscriptionEvents: JSON.stringify((_g_subscriptionManager1 = g.subscriptionManager) === null || _g_subscriptionManager1 === void 0 ? void 0 : _g_subscriptionManager1.sharing.events),
                    Video_send_MaxCapabilities: JSON.stringify(S),
                    Sharing_send_MaxCapabilities: JSON.stringify(v),
                    RelayCandidate: g.relayCandidate,
                    Video_recv_TimeToFirstFrame: (_g_remoteVideoManager = g.remoteVideoManager) === null || _g_remoteVideoManager === void 0 ? void 0 : _g_remoteVideoManager.firstTimeToFirstFrameVideo,
                    Sharing_recv_TimeToFirstFrame: (_g_remoteVideoManager1 = g.remoteVideoManager) === null || _g_remoteVideoManager1 === void 0 ? void 0 : _g_remoteVideoManager1.firstTimeToFirstFrameSharing,
                    Video_recv_TimeToFirstFrameSinceSubscriptionStart: (_g_remoteVideoManager2 = g.remoteVideoManager) === null || _g_remoteVideoManager2 === void 0 ? void 0 : _g_remoteVideoManager2.timeToFirstFrameSinceSubscriptionStartVideo,
                    Sharing_recv_TimeToFirstFrameSinceSubscriptionStart: (_g_remoteVideoManager3 = g.remoteVideoManager) === null || _g_remoteVideoManager3 === void 0 ? void 0 : _g_remoteVideoManager3.timeToFirstFrameSinceSubscriptionStartSharing,
                    IceServers: g.iceServers
                });
            }
            function compileMediaStatsReportMetrics(g, f, S) {
                return removeUndefinedFields({
                    DeviceEvents: JSON.stringify(rebaseTime(S.deviceManager.deviceTelemetryEvents.filter((g)=>g.timestamp > f), "timestamp", g.creationTime)),
                    IceConnectedStateTime: 1e4 * g.iceConnectedStateTime
                });
            }
            function compileMetricsTelemetryReport(g, f, S, v) {
                var _g_error, _g_error1, _g_error2, _g_terminationReason, _g_terminationReason1, _g_terminationReason2, _g_terminationReason3, _g_terminationReason4, _g_terminationReason5, _g_reconnect, _g_reconnect1, _g_reconnect2, _g_reconnect3, _g_reconnect4, _g_reconnect5, _g_reconnect6, _g_reconnect7, _g_reconnect8, _g_reconnect9, _g_reconnect10, _g_reconnect11, _getLast, _S_configuration_mediaConfig, _S_configuration_mediaConfig1, _S_deviceManager_usedDevices, _S_deviceManager_usedDevices1, _S_deviceManager_usedDevices2;
                const _ = v.config.diagnostics.telemetryLimits, C = g.webrtcSessions[g.webrtcSessions.length - 1];
                var _g_error_type, _g_error_detail, _S_configuration_mediaConfig_enableMediaQoS;
                return removeUndefinedFields({
                    MediaLegId: g.mediaLegId,
                    CreationTime: getHpTimeFromMillis(g.creationTime),
                    CallNumber: g.callNumber,
                    SessionId: g.sessionId,
                    MultiParty: g.isMultiParty,
                    ErrorType: (_g_error_type = (_g_error = g.error) === null || _g_error === void 0 ? void 0 : _g_error.type) !== null && _g_error_type !== void 0 ? _g_error_type : "none",
                    ErrorDetail: (_g_error_detail = (_g_error1 = g.error) === null || _g_error1 === void 0 ? void 0 : _g_error1.detail) !== null && _g_error_detail !== void 0 ? _g_error_detail : "none",
                    IncompatibleOffer: ((_g_error2 = g.error) === null || _g_error2 === void 0 ? void 0 : _g_error2.type) === Gt.MEDIA_ERROR.incompatibleOffer,
                    TerminationTime: getHpTimeFromMillis(g.terminationTime),
                    TerminationReason_code: (_g_terminationReason = g.terminationReason) === null || _g_terminationReason === void 0 ? void 0 : _g_terminationReason.code,
                    TerminationReason_subCode: (_g_terminationReason1 = g.terminationReason) === null || _g_terminationReason1 === void 0 ? void 0 : _g_terminationReason1.subCode,
                    TerminationReason_phrase: (_g_terminationReason2 = g.terminationReason) === null || _g_terminationReason2 === void 0 ? void 0 : _g_terminationReason2.phrase,
                    TerminationReason_remoteTerminated: (_g_terminationReason3 = g.terminationReason) === null || _g_terminationReason3 === void 0 ? void 0 : _g_terminationReason3.remoteTerminated,
                    TerminationReason_clientReasonPhrase: (_g_terminationReason4 = g.terminationReason) === null || _g_terminationReason4 === void 0 ? void 0 : _g_terminationReason4.clientReasonPhrase,
                    TerminationReason_clientReasonSubCode: (_g_terminationReason5 = g.terminationReason) === null || _g_terminationReason5 === void 0 ? void 0 : _g_terminationReason5.clientReasonSubCode,
                    CallDuration: getHpTimeFromMillis(g.duration),
                    IceInitTime: getHpTimeFromMillis(g.iceInitTime),
                    IceConnectedStateTime: getHpTimeFromMillis(g.iceConnectedStateTime),
                    NegotiationCount: g.negotiationCount,
                    RejectedNegotiationCount: g.rejectedNegotiationCount,
                    InitialNegotiationCompleted: g.initialNegotiationCompleted,
                    InitialNegotiationType: g.initialNegotiationType,
                    FinalAnswerTime: getHpTimeFromMillis(g.finalAnswerTime),
                    TransportReconnectedCount: g.transportReconnectedCount,
                    RollbackNegotiation: JSON.stringify(g.rollbackNegotiation),
                    Relay: g.relay ? JSON.stringify(g.relay) : void 0,
                    ActiveModalities: JSON.stringify(g.activeModalities),
                    AllowedAudioSend: g.allowedAudioSend,
                    AllowedVideoSend: g.allowedVideoSend,
                    AllowedScreensharingSend: g.allowedScreensharingSend,
                    RelayManager: JSON.stringify(g.relayTimers),
                    AuthTokenStats: JSON.stringify(g.authTokenFetcherStats),
                    CallMutedRatio: g.callMutedRatio,
                    CallOsMuted: getHpTimeFromMillis(g.callOsMuted),
                    CallHwSilent: getHpTimeFromMillis(g.callHwSilent),
                    CallSwMuted: getHpTimeFromMillis(g.callSwMuted),
                    CallSpeakerMuted: getHpTimeFromMillis(g.callSpeakerMuted),
                    CallIsSpeaking: getHpTimeFromMillis(g.callIsSpeaking),
                    DtmfSuccess: g.dtmfSuccessCount,
                    DtmfFailure: g.dtmfFailureCount,
                    ContributingSourcesError: C.contributingSourcesError,
                    ReconnectInProgress: (_g_reconnect = g.reconnect) === null || _g_reconnect === void 0 ? void 0 : _g_reconnect.isReconnecting,
                    RetargetIncomingCount: (_g_reconnect1 = g.reconnect) === null || _g_reconnect1 === void 0 ? void 0 : _g_reconnect1.retargetCount.incoming,
                    RetargetOutgoingCount: (_g_reconnect2 = g.reconnect) === null || _g_reconnect2 === void 0 ? void 0 : _g_reconnect2.retargetCount.outgoing,
                    RetargetCompletedCount: (_g_reconnect3 = g.reconnect) === null || _g_reconnect3 === void 0 ? void 0 : _g_reconnect3.retargetCount.completed,
                    RetargetRejectedCount: (_g_reconnect4 = g.reconnect) === null || _g_reconnect4 === void 0 ? void 0 : _g_reconnect4.retargetCount.rejected,
                    EscalationAttemptedCount: (_g_reconnect5 = g.reconnect) === null || _g_reconnect5 === void 0 ? void 0 : _g_reconnect5.escalationCount.attempted,
                    EscalationCompletedCount: (_g_reconnect6 = g.reconnect) === null || _g_reconnect6 === void 0 ? void 0 : _g_reconnect6.escalationCount.completed,
                    EscalationRejectedCount: (_g_reconnect7 = g.reconnect) === null || _g_reconnect7 === void 0 ? void 0 : _g_reconnect7.escalationCount.rejected,
                    Elevation: JSON.stringify(g.elevation),
                    ReconnectAttemptedCount: (_g_reconnect8 = g.reconnect) === null || _g_reconnect8 === void 0 ? void 0 : _g_reconnect8.reconnectCount.attempted,
                    ReconnectConnectedCount: (_g_reconnect9 = g.reconnect) === null || _g_reconnect9 === void 0 ? void 0 : _g_reconnect9.reconnectCount.connected,
                    ReconnectAttempts: limitRebaseAndStringifyEvents((_g_reconnect10 = g.reconnect) === null || _g_reconnect10 === void 0 ? void 0 : _g_reconnect10.records, _.numReconnects, "startTime", g.creationTime),
                    NetworkEvents: limitRebaseAndStringifyEvents((_g_reconnect11 = g.reconnect) === null || _g_reconnect11 === void 0 ? void 0 : _g_reconnect11.tmpRecords, _.numNetworkEvents, "startTime", g.creationTime),
                    NoIceCandidatesGoodEventCount: g.noIceCandidatesEventCount.good,
                    NoIceCandidatesBadEventCount: g.noIceCandidatesEventCount.bad,
                    NoRelayIceCandidatesGoodEventCount: g.noRelayIceCandidatesEventCount.good,
                    NoRelayIceCandidatesBadEventCount: g.noRelayIceCandidatesEventCount.bad,
                    MicrophoneInUseGoodEventCount: g.microphoneInUseEventCount.good,
                    MicrophoneInUseBadEventCount: g.microphoneInUseEventCount.bad,
                    CameraInUseGoodEventCount: g.cameraInUseEventCount.good,
                    CameraInUseBadEventCount: g.cameraInUseEventCount.bad,
                    CameraFreezeStartEventCount: g.cameraFreezeEventCount.start,
                    CameraFreezeEndEventCount: g.cameraFreezeEventCount.end,
                    NetworkRecvGood: g.networkRecvUFD.good,
                    NetworkRecvGoodRatio: g.networkRecvUFD.goodRatio,
                    NetworkRecvPoor: g.networkRecvUFD.poor,
                    NetworkRecvPoorRatio: g.networkRecvUFD.poorRatio,
                    NetworkRecvBad: g.networkRecvUFD.bad,
                    NetworkRecvBadRatio: g.networkRecvUFD.badRatio,
                    NetworkSendGood: g.networkSendUFD.good,
                    NetworkSendGoodRatio: g.networkSendUFD.goodRatio,
                    NetworkSendPoor: g.networkSendUFD.poor,
                    NetworkSendPoorRatio: g.networkSendUFD.poorRatio,
                    NetworkSendBad: g.networkSendUFD.bad,
                    NetworkSendBadRatio: g.networkSendUFD.badRatio,
                    Connection_Downlink: sampleseries(C.networkInfo, (g)=>g.downlink),
                    Connection_EffectiveType: sampleseries(C.networkInfo, (g)=>g.effectiveType),
                    Connection_Rtt: sampleseries(C.networkInfo, (g)=>g.rtt),
                    Connection_SaveData: (_getLast = getLast(C.networkInfo)) === null || _getLast === void 0 ? void 0 : _getLast.saveData,
                    RawOutputAudioAccessAttempted: g.rawMedia.audio.recv.numAttempts,
                    RawOutputAudioAccessDurationRatio: g.rawMedia.audio.recv.durationRatio,
                    RawInputAudioOverrideAttempted: g.rawMedia.audio.send.numAttempts,
                    RawInputAudioOverrideDurationRatio: g.rawMedia.audio.send.durationRatio,
                    ZeroCaptureDevicesEnumeratedEventRatio: g.zeroCaptureDevicesRatio,
                    ZeroRenderDevicesEnumeratedEventRatio: g.zeroRenderDevicesRatio,
                    DeviceCaptureNotFunctioningEventRatio: g.deviceCaptureFailuresRatio,
                    DeviceRenderNotFunctioningEventRatio: g.deviceRenderFailuresRatio,
                    UFDs: limitRebaseAndStringifyEvents(g.ufds, _.numUFDs, "timestamp", g.creationTime),
                    remoteUFDs: limitRebaseAndStringifyEvents(g.remoteUfds, _.numUFDs, "timestamp", g.creationTime),
                    MediaQosEnabled: (_S_configuration_mediaConfig_enableMediaQoS = (_S_configuration_mediaConfig = S.configuration.mediaConfig) === null || _S_configuration_mediaConfig === void 0 ? void 0 : _S_configuration_mediaConfig.enableMediaQoS) !== null && _S_configuration_mediaConfig_enableMediaQoS !== void 0 ? _S_configuration_mediaConfig_enableMediaQoS : !1,
                    PortRangeConfigured: !!((_S_configuration_mediaConfig1 = S.configuration.mediaConfig) === null || _S_configuration_mediaConfig1 === void 0 ? void 0 : _S_configuration_mediaConfig1.mediaPortRanges),
                    hardwareConcurrency: S.configuration.userAgentConfig.hardwareConcurrency,
                    ETag: g.ETag,
                    ConfigIds: g.configIds,
                    GPUName: S.configuration.userAgentConfig.unmaskedGlRenderer,
                    PermissionStates: JSON.stringify(S.deviceManager.permissionStates),
                    DeviceList: JSON.stringify(S.deviceManager.deviceList),
                    DeviceListDebug: JSON.stringify(S.deviceManager.deviceDebugStrings),
                    DevicesChangeCount: g.deviceManager.devicesChangeCount,
                    DevicesPollChangeCount: g.deviceManager.devicesPollChangeCount,
                    DeviceSelectionChangeCount: g.deviceManager.deviceSelectionChangeCount,
                    DeviceSelectionChangeFromInterfaceCount: g.deviceManager.deviceSelectionChangeCountFromInterface,
                    DevicesCount: JSON.stringify(S.deviceManager.devicesCount),
                    UsedMicrophone: (_S_deviceManager_usedDevices = S.deviceManager.usedDevices) === null || _S_deviceManager_usedDevices === void 0 ? void 0 : _S_deviceManager_usedDevices.microphone,
                    UsedSpeaker: (_S_deviceManager_usedDevices1 = S.deviceManager.usedDevices) === null || _S_deviceManager_usedDevices1 === void 0 ? void 0 : _S_deviceManager_usedDevices1.speaker,
                    UsedCamera: (_S_deviceManager_usedDevices2 = S.deviceManager.usedDevices) === null || _S_deviceManager_usedDevices2 === void 0 ? void 0 : _S_deviceManager_usedDevices2.camera,
                    DeviceEvents: limitRebaseAndStringifyEvents(S.deviceManager.deviceTelemetryEvents.filter((g)=>g.timestamp > f), _.numDeviceEvents, "timestamp", g.creationTime),
                    VideoEffects: limitRebaseAndStringifyEvents(S.deviceManager.videoEffectsEvents.filter((g)=>g.timestamp > f), _.numVideoEffectsEvents, "timestamp", g.creationTime),
                    AudioEffects: limitRebaseAndStringifyEvents(S.deviceManager.audioEffectsEvents.filter((g)=>g.timestamp > f), _.numAudioEffectsEvents, "timestamp", g.creationTime),
                    WorkerEvents: limitRebaseAndStringifyEvents(S.deviceManager.workerEvents.filter((g)=>g.timestamp > f), _.numWorkerEvents, "timestamp", g.creationTime),
                    MediaByPassEnabled: !!S.configuration.mediaConfig.enableMediaBypass,
                    CallConstraints: JSON.stringify(g.callConstraints),
                    DominantSpeaker: JSON.stringify(generateDominantSpeakerReport(g.dominantSpeaker, g.terminationTime)),
                    AudioSourceNumOfReopenRequests: g.deviceManager.audioSourceNumOfReopenRequests || void 0,
                    AudioSourceNumOfSuccessfulReopens: g.deviceManager.audioSourceNumOfSuccessfulReopens || void 0,
                    AudioCaptureErrorCodeFlagsInit: g.deviceManager.audioCaptureDeviceErrorFlag,
                    AudioRenderErrorCodeFlagsInit: g.deviceManager.audioRenderDeviceErrorFlag,
                    AudioSinkNumOfReopenRequests: g.audioRenderer.sinkNumOfReopenRequests,
                    AudioSinkNumOfSuccessfulReopens: g.audioRenderer.sinkNumOfSuccessfulReopens,
                    CallSetupTimeTracker: JSON.stringify(g.webrtcSessions[0].negotiation.callSetupTimeReport),
                    LastSessionSetupTimeTracker: g.webrtcSessions.length > 1 ? JSON.stringify(C.negotiation.callSetupTimeReport) : void 0
                });
            }
            function getHpTimeFromMillis(g) {
                return 1e4 * g;
            }
            function generateDominantSpeakerReport(g, f = Number(new Date)) {
                if (!g) return;
                const S = deepClone(g);
                return g.lastMsgDate && (g.timeSinceLastMsg = g.lastMsgDate - f), delete S.lastMsgDate, delete S.lastHistory, removeUndefinedFields(S);
            }
            function getValue(g, f, S = 0) {
                const v = f.filter((g)=>void 0 !== g);
                let _;
                switch(g){
                    case "Difference":
                        _ = v[v.length - 1] - v[0];
                        break;
                    case "Average":
                        _ = v.reduce((g, f)=>g + f, 0) / v.length;
                        break;
                    case "LastValue":
                        _ = v[v.length - 1];
                }
                return _ || 0 === _ ? `${"number" == typeof _ ? +_.toFixed(S) : _}` : void 0;
            }
            function filterStats(g, f, S) {
                return (S ? g.map((g)=>{
                    var _g_f;
                    return g === null || g === void 0 ? void 0 : (_g_f = g[f]) === null || _g_f === void 0 ? void 0 : _g_f[S];
                }) : g.map((g)=>g === null || g === void 0 ? void 0 : g[f])).filter((g)=>void 0 !== g).reduce((g, f)=>g.concat(f), []);
            }
            function findTransportStats(g) {
                const f = g.find((g)=>g === null || g === void 0 ? void 0 : g.transports);
                return f ? f.transports[Object.keys(f.transports)[0]] : void 0;
            }
            function getVideoProcessing(g) {
                var _g__extensions, _g_;
                const f = (_g_ = g[g.length - 1]) === null || _g_ === void 0 ? void 0 : (_g__extensions = _g_.extensions) === null || _g__extensions === void 0 ? void 0 : _g__extensions.powerEfficient;
                return void 0 === f ? "" : f ? "hw" : "sw";
            }
            function getMediaDirection(g, f) {
                return g & f ? "Bidirectional" : g ? "ReceiveFromPeer" : f ? "SendToPeer" : "Inactive";
            }
            function getSendActivityState(g) {
                var _g__extensions, _g_, _g__extensions1, _g_1;
                const f = (_g_ = g[g.length - 1]) === null || _g_ === void 0 ? void 0 : (_g__extensions = _g_.extensions) === null || _g__extensions === void 0 ? void 0 : _g__extensions.callIsMuted, S = (_g_1 = g[g.length - 1]) === null || _g_1 === void 0 ? void 0 : (_g__extensions1 = _g_1.extensions) === null || _g__extensions1 === void 0 ? void 0 : _g__extensions1.rawInputVolume;
                return f ? "0" : !f && S > 0 ? "2" : f || 0 !== S ? void 0 : "1";
            }
            function compileAudioReport2(g, f) {
                var _getValue, _getValue1, __selectedCandidatePair_localCandidate, __selectedCandidatePair, __selectedCandidatePair_localCandidate1, __selectedCandidatePair1, __extensions, __selectedCandidatePair_localCandidate2, __selectedCandidatePair2;
                const S = filterStats(g, "audio", "send"), v = filterStats(g, "audio", "recv"), _ = findTransportStats(g);
                if (S.length || v.length) return removeUndefinedFields({
                    mediaType: "Audio",
                    mediaDirection: getMediaDirection(v.length, S.length),
                    "Received BW estimate": getValue("Average", v.map((g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return g === null || g === void 0 ? void 0 : (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableIncomingBitrate;
                    })),
                    "Recv Loss Rate (Avg)": getValue("LastValue", v.map((g)=>{
                        var _g_extensions;
                        return (g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.lossRate) / 100;
                    }), 3),
                    "Rtp Packets Received": getValue("Difference", v.map((g)=>g === null || g === void 0 ? void 0 : g.inboundRTP.packetsReceived)),
                    "Rtp Packet Sent": getValue("Difference", S.map((g)=>g === null || g === void 0 ? void 0 : g.outboundRTP.packetsSent)),
                    "Sent BW estimate": getValue("Average", S.map((g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return g === null || g === void 0 ? void 0 : (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate;
                    })),
                    "Send Audio Codec": (_getValue = getValue("LastValue", S.map((g)=>{
                        var _g_codec;
                        return g === null || g === void 0 ? void 0 : (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : _g_codec.mimeType;
                    }))) === null || _getValue === void 0 ? void 0 : _getValue.split("/").pop(),
                    "Send RTT (Avg)": getValue("LastValue", S.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.rttAvg;
                    })),
                    "Audio NW jitter avg": getValue("LastValue", v.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.jitterAvg;
                    }), 3),
                    "Audio send bps": getValue("Average", S.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate;
                    })),
                    "JB delay (ms)": getValue("LastValue", v.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.jitterBufferDelayMs;
                    })),
                    "Recv Audio Codec": (_getValue1 = getValue("LastValue", v.map((g)=>{
                        var _g_codec;
                        return g === null || g === void 0 ? void 0 : (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : _g_codec.mimeType;
                    }))) === null || _getValue1 === void 0 ? void 0 : _getValue1.split("/").pop(),
                    "Current Render Device Name": f === null || f === void 0 ? void 0 : f.speaker,
                    "Current Capture Device Name": f === null || f === void 0 ? void 0 : f.microphone,
                    "Latest Network Type": _ === null || _ === void 0 ? void 0 : (__selectedCandidatePair = _.selectedCandidatePair) === null || __selectedCandidatePair === void 0 ? void 0 : (__selectedCandidatePair_localCandidate = __selectedCandidatePair.localCandidate) === null || __selectedCandidatePair_localCandidate === void 0 ? void 0 : __selectedCandidatePair_localCandidate.networkType,
                    "Latest Transport Protocol": _ === null || _ === void 0 ? void 0 : (__selectedCandidatePair1 = _.selectedCandidatePair) === null || __selectedCandidatePair1 === void 0 ? void 0 : (__selectedCandidatePair_localCandidate1 = __selectedCandidatePair1.localCandidate) === null || __selectedCandidatePair_localCandidate1 === void 0 ? void 0 : __selectedCandidatePair_localCandidate1.protocol,
                    "Latest Reflexive Address": ipAddressConverter(_ === null || _ === void 0 ? void 0 : (__extensions = _.extensions) === null || __extensions === void 0 ? void 0 : __extensions.reflexiveLocalIP),
                    "Local Address": ipAddressConverter(_ === null || _ === void 0 ? void 0 : (__selectedCandidatePair2 = _.selectedCandidatePair) === null || __selectedCandidatePair2 === void 0 ? void 0 : (__selectedCandidatePair_localCandidate2 = __selectedCandidatePair2.localCandidate) === null || __selectedCandidatePair_localCandidate2 === void 0 ? void 0 : __selectedCandidatePair_localCandidate2.ip),
                    "Local short-term Healed Data Ratio": getValue("LastValue", v.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.healedRatio;
                    })),
                    "Send activity (0=muted; 1=inactive; 2=active)": getSendActivityState(S)
                });
            }
            function formatVideoStats(g) {
                const f = {}, formatStats = (S)=>{
                    g.map((g)=>{
                        var _g_video;
                        return g === null || g === void 0 ? void 0 : (_g_video = g.video) === null || _g_video === void 0 ? void 0 : _g_video[S];
                    }).forEach((g)=>{
                        g === null || g === void 0 ? void 0 : g.forEach((g)=>{
                            var _g_mediaEntity;
                            var v;
                            const _ = g === null || g === void 0 ? void 0 : (_g_mediaEntity = g.mediaEntity) === null || _g_mediaEntity === void 0 ? void 0 : _g_mediaEntity.remoteSsrc;
                            var _f__, _S;
                            (_f__ = f[_]) !== null && _f__ !== void 0 ? _f__ : f[_] = {}, (_S = (v = f[_])[S]) !== null && _S !== void 0 ? _S : v[S] = [], f[_][S].push(g);
                        });
                    });
                };
                return formatStats("recv"), formatStats("send"), f;
            }
            function compileVideoReport(g, f) {
                const S = [], v = formatVideoStats(g);
                for (const { send: g, recv: _ } of Object.values(v)){
                    let v = {
                        mediaType: "Camera",
                        mediaDirection: getMediaDirection(_ === null || _ === void 0 ? void 0 : _.length, g === null || g === void 0 ? void 0 : g.length)
                    };
                    _ && (v = {
                        ...v,
                        ...compileVideoRecvReport2(_)
                    }), g && (v = {
                        ...v,
                        ...compileVideoSendReport2(g, f)
                    }), S.push(removeUndefinedFields(v));
                }
                return S;
            }
            function compileVideoSendReport2(g, f) {
                var _getValue;
                const S = (_getValue = getValue("LastValue", g.map((g)=>{
                    var _g_codec;
                    return g === null || g === void 0 ? void 0 : (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : _g_codec.mimeType;
                }))) === null || _getValue === void 0 ? void 0 : _getValue.split("/").pop(), v = S ? S + ` ${getVideoProcessing(g)}` : void 0;
                return {
                    "Rtp Packet Sent": getValue("Difference", g.map((g)=>g === null || g === void 0 ? void 0 : g.outboundRTP.packetsSent)),
                    "Sent BW estimate": getValue("Average", g.map((g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return g === null || g === void 0 ? void 0 : (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate;
                    })),
                    "Send Current Bitrate": getValue("Average", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate;
                    })),
                    "Allocated Send Bandwidth Average": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrateAvg;
                    })),
                    "Send Actual Height": getValue("LastValue", g.map((g)=>g === null || g === void 0 ? void 0 : g.outboundRTP.frameHeight)),
                    "Send Actual Width": getValue("LastValue", g.map((g)=>g === null || g === void 0 ? void 0 : g.outboundRTP.frameWidth)),
                    "Send Current Frame Rate": getValue("Average", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateSent;
                    })),
                    "Send RTT (Avg)": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.rttAvg;
                    })),
                    "Sent Codec Name": v,
                    "Webcam Freeze Intervals": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.captureFreezeIntervalsCount;
                    })),
                    "Current Capture Device Name": f === null || f === void 0 ? void 0 : f.camera,
                    "Number of Sync Frame Request per Minute": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.pliRate;
                    }))
                };
            }
            function compileVideoRecvReport2(g) {
                var _getValue;
                const f = getValue("LastValue", g.map((g)=>{
                    var _g_mediaEntity;
                    return g === null || g === void 0 ? void 0 : (_g_mediaEntity = g.mediaEntity) === null || _g_mediaEntity === void 0 ? void 0 : _g_mediaEntity.xSourceStreamId;
                })), S = (_getValue = getValue("LastValue", g.map((g)=>{
                    var _g_codec;
                    return g === null || g === void 0 ? void 0 : (_g_codec = g.codec) === null || _g_codec === void 0 ? void 0 : _g_codec.mimeType;
                }))) === null || _getValue === void 0 ? void 0 : _getValue.split("/").pop(), v = S ? S + ` ${getVideoProcessing(g)}` : void 0;
                return {
                    "Recv Loss Rate (Avg)": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.lossRate;
                    }), 3),
                    "Received BW estimate": getValue("Average", g.map((g)=>{
                        var _g_transport_selectedCandidatePair, _g_transport;
                        return g === null || g === void 0 ? void 0 : (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableIncomingBitrate;
                    })),
                    "Receive Current Bitrate": getValue("Average", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.bitrate;
                    })),
                    "Rtp Packets Received": getValue("Difference", g.map((g)=>g === null || g === void 0 ? void 0 : g.inboundRTP.packetsReceived)),
                    "Receive Actual Height": getValue("LastValue", g.map((g)=>g === null || g === void 0 ? void 0 : g.inboundRTP.frameHeight)),
                    "Receive Actual Width": getValue("LastValue", g.map((g)=>g === null || g === void 0 ? void 0 : g.inboundRTP.frameWidth)),
                    "Receive Current Frame Rate": getValue("Average", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateReceived;
                    })),
                    "Received Codec Name": v,
                    "Received Total Freeze Fraction (ms per min)": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.totalFreezeFraction;
                    })),
                    videoSourceId: f ? parseInt(f) : void 0,
                    "Received Fps Time Weighted Harmonic Average": getValue("LastValue", g.map((g)=>{
                        var _g_extensions;
                        return g === null || g === void 0 ? void 0 : (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.fpsHarmonicAverage;
                    }))
                };
            }
            function compileSharingReport(g) {
                const f = filterStats(g, "sharing", "send"), S = filterStats(g, "sharing", "recv");
                if (!S.length && !f.length) return;
                let v = {
                    mediaType: "AppSharing",
                    mediaDirection: "Bidirectional",
                    "Render Device Name": ""
                };
                return S.length && (v = {
                    ...v,
                    ...compileVideoRecvReport2(S)
                }), f.length && (v = {
                    ...v,
                    ...compileVideoSendReport2(f, {
                        microphone: void 0,
                        camera: "Screen sharing",
                        speaker: void 0
                    })
                }), removeUndefinedFields(v);
            }
            function compileReports(g, f, S) {
                const v = compileAudioReport2(g, f);
                v && S.channels.push(v);
                const _ = compileVideoReport(g, f);
                _.length && S.channels.push(..._);
                const C = compileSharingReport(g);
                C && S.channels.push(C);
            }
            function compileTeamsRealtimeTelemetryReport(g, f) {
                const S = filterStats(g, "inactiveTracks"), v = {
                    channels: []
                };
                return compileReports(g, f, v), S.length && compileReports(S, void 0, v), v;
            }
            function compileVideoReportForE2E(g, f, S, v, _) {
                var _f_g, _f_g1, _f_g2, _S_codec, _S_aggregated, _f_g3, _f_g4, _f_g5, _f_g6, _f_g7, _f_g8, _f_g9, _v_codec, _f_g10, _v_mediaSource, _v_mediaSource1, _f_g11, _f_g12, _f_g13;
                var _S_inboundRTP_mediaType, _v_outboundRTP_mediaType;
                return removeUndefinedFields({
                    recv: removeUndefinedFields({
                        id: S === null || S === void 0 ? void 0 : S.inboundRTP.id,
                        ssrc: S === null || S === void 0 ? void 0 : S.inboundRTP.ssrc,
                        mediaType: (_S_inboundRTP_mediaType = S === null || S === void 0 ? void 0 : S.inboundRTP.mediaType) !== null && _S_inboundRTP_mediaType !== void 0 ? _S_inboundRTP_mediaType : S === null || S === void 0 ? void 0 : S.inboundRTP.kind,
                        bytes: sampleseriesArr((_f_g = f[g]) === null || _f_g === void 0 ? void 0 : _f_g.recv, (g)=>g.inboundRTP.bytesReceived, _),
                        packets: sampleseriesArr((_f_g1 = f[g]) === null || _f_g1 === void 0 ? void 0 : _f_g1.recv, (g)=>g.inboundRTP.packetsReceived, _),
                        packetsLost: sampleseriesArr((_f_g2 = f[g]) === null || _f_g2 === void 0 ? void 0 : _f_g2.recv, (g)=>g.inboundRTP.packetsLost, _),
                        codec: S === null || S === void 0 ? void 0 : (_S_codec = S.codec) === null || _S_codec === void 0 ? void 0 : _S_codec.mimeType.split("/").pop(),
                        codecReport: S === null || S === void 0 ? void 0 : (_S_aggregated = S.aggregated) === null || _S_aggregated === void 0 ? void 0 : _S_aggregated.codecReport,
                        framesDecoded: sampleseriesArr((_f_g3 = f[g]) === null || _f_g3 === void 0 ? void 0 : _f_g3.recv, (g)=>g.inboundRTP.framesDecoded, _),
                        height: sampleseriesArr((_f_g4 = f[g]) === null || _f_g4 === void 0 ? void 0 : _f_g4.recv, (g)=>g.inboundRTP.frameHeight, _),
                        width: sampleseriesArr((_f_g5 = f[g]) === null || _f_g5 === void 0 ? void 0 : _f_g5.recv, (g)=>g.inboundRTP.frameWidth, _),
                        frameRate: sampleseriesArr((_f_g6 = f[g]) === null || _f_g6 === void 0 ? void 0 : _f_g6.recv, (g)=>{
                            var _g_extensions;
                            return (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateReceived;
                        }, _)
                    }),
                    send: removeUndefinedFields({
                        id: v === null || v === void 0 ? void 0 : v.outboundRTP.id,
                        ssrc: v === null || v === void 0 ? void 0 : v.outboundRTP.ssrc,
                        mediaType: (_v_outboundRTP_mediaType = v === null || v === void 0 ? void 0 : v.outboundRTP.mediaType) !== null && _v_outboundRTP_mediaType !== void 0 ? _v_outboundRTP_mediaType : v === null || v === void 0 ? void 0 : v.outboundRTP.kind,
                        bytes: sampleseriesArr((_f_g7 = f[g]) === null || _f_g7 === void 0 ? void 0 : _f_g7.send, (g)=>g.outboundRTP.bytesSent, _),
                        packets: sampleseriesArr((_f_g8 = f[g]) === null || _f_g8 === void 0 ? void 0 : _f_g8.send, (g)=>g.outboundRTP.packetsSent, _),
                        packetsLost: sampleseriesArr((_f_g9 = f[g]) === null || _f_g9 === void 0 ? void 0 : _f_g9.send, (g)=>{
                            var _g_remoteInboundRTP;
                            return (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsLost;
                        }, _),
                        codec: v === null || v === void 0 ? void 0 : (_v_codec = v.codec) === null || _v_codec === void 0 ? void 0 : _v_codec.mimeType.split("/").pop(),
                        framesEncoded: sampleseriesArr((_f_g10 = f[g]) === null || _f_g10 === void 0 ? void 0 : _f_g10.send, (g)=>g.outboundRTP.framesEncoded, _),
                        heightInput: v === null || v === void 0 ? void 0 : (_v_mediaSource = v.mediaSource) === null || _v_mediaSource === void 0 ? void 0 : _v_mediaSource.height,
                        widthInput: v === null || v === void 0 ? void 0 : (_v_mediaSource1 = v.mediaSource) === null || _v_mediaSource1 === void 0 ? void 0 : _v_mediaSource1.width,
                        height: sampleseriesArr((_f_g11 = f[g]) === null || _f_g11 === void 0 ? void 0 : _f_g11.send, (g)=>g.outboundRTP.frameHeight, _),
                        width: sampleseriesArr((_f_g12 = f[g]) === null || _f_g12 === void 0 ? void 0 : _f_g12.send, (g)=>g.outboundRTP.frameWidth, _),
                        frameRate: sampleseriesArr((_f_g13 = f[g]) === null || _f_g13 === void 0 ? void 0 : _f_g13.send, (g)=>{
                            var _g_extensions;
                            return (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateSent;
                        }, _)
                    })
                });
            }
            function compileAudioReportForE2E(g, f, S, v) {
                var _g_audio, _g_audio1, _g_audio2, _f_codec, _g_audio3, _g_audio4, _g_audio5, _g_audio6, _S_codec, _g_audio7;
                var _f_inboundRTP_mediaType, _S_outboundRTP_mediaType;
                return removeUndefinedFields({
                    recv: removeUndefinedFields({
                        id: f === null || f === void 0 ? void 0 : f.inboundRTP.id,
                        ssrc: f === null || f === void 0 ? void 0 : f.inboundRTP.ssrc,
                        mediaType: (_f_inboundRTP_mediaType = f === null || f === void 0 ? void 0 : f.inboundRTP.mediaType) !== null && _f_inboundRTP_mediaType !== void 0 ? _f_inboundRTP_mediaType : f === null || f === void 0 ? void 0 : f.inboundRTP.kind,
                        bytes: sampleseriesArr((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : _g_audio.recv, (g)=>g.inboundRTP.bytesReceived, v),
                        packets: sampleseriesArr((_g_audio1 = g.audio) === null || _g_audio1 === void 0 ? void 0 : _g_audio1.recv, (g)=>g.inboundRTP.packetsReceived, v),
                        packetsLost: sampleseriesArr((_g_audio2 = g.audio) === null || _g_audio2 === void 0 ? void 0 : _g_audio2.recv, (g)=>g.inboundRTP.packetsLost, v),
                        codec: f === null || f === void 0 ? void 0 : (_f_codec = f.codec) === null || _f_codec === void 0 ? void 0 : _f_codec.mimeType.split("/").pop(),
                        audioLevel: sampleseriesArr((_g_audio3 = g.audio) === null || _g_audio3 === void 0 ? void 0 : _g_audio3.recv, (g)=>Math.floor(65535 * g.inboundRTP.audioLevel), v)
                    }),
                    send: removeUndefinedFields({
                        id: S === null || S === void 0 ? void 0 : S.outboundRTP.id,
                        ssrc: S === null || S === void 0 ? void 0 : S.outboundRTP.ssrc,
                        mediaType: (_S_outboundRTP_mediaType = S === null || S === void 0 ? void 0 : S.outboundRTP.mediaType) !== null && _S_outboundRTP_mediaType !== void 0 ? _S_outboundRTP_mediaType : S === null || S === void 0 ? void 0 : S.outboundRTP.kind,
                        bytes: sampleseriesArr((_g_audio4 = g.audio) === null || _g_audio4 === void 0 ? void 0 : _g_audio4.send, (g)=>g.outboundRTP.bytesSent, v),
                        packets: sampleseriesArr((_g_audio5 = g.audio) === null || _g_audio5 === void 0 ? void 0 : _g_audio5.send, (g)=>g.outboundRTP.packetsSent, v),
                        packetsLost: sampleseriesArr((_g_audio6 = g.audio) === null || _g_audio6 === void 0 ? void 0 : _g_audio6.send, (g)=>{
                            var _g_remoteInboundRTP;
                            return (_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsLost;
                        }, v),
                        codec: S === null || S === void 0 ? void 0 : (_S_codec = S.codec) === null || _S_codec === void 0 ? void 0 : _S_codec.mimeType.split("/").pop(),
                        audioLevel: sampleseriesArr((_g_audio7 = g.audio) === null || _g_audio7 === void 0 ? void 0 : _g_audio7.send, (g)=>Math.floor(65535 * g.aggregated.audioLevel), v)
                    })
                });
            }
            function compileE2EDiagReport(g, f, S, v, _) {
                var _C_audio, _C_audio1, _C_video, _C_video1, _C_sharing, _C_sharing1, _g_statsOnSubscribed_video, _g_statsOnSubscribed_sharing;
                const C = g.aggregatedModalityStats, E = getLast((_C_audio = C.audio) === null || _C_audio === void 0 ? void 0 : _C_audio.recv), T = getLast((_C_audio1 = C.audio) === null || _C_audio1 === void 0 ? void 0 : _C_audio1.send), I = getLast((_C_video = C.video) === null || _C_video === void 0 ? void 0 : _C_video.recv), b = getLast((_C_video1 = C.video) === null || _C_video1 === void 0 ? void 0 : _C_video1.send), A = getLast((_C_sharing = C.sharing) === null || _C_sharing === void 0 ? void 0 : _C_sharing.recv), R = getLast((_C_sharing1 = C.sharing) === null || _C_sharing1 === void 0 ? void 0 : _C_sharing1.send), P = [], w = [];
                return (_g_statsOnSubscribed_video = g.statsOnSubscribed.video) === null || _g_statsOnSubscribed_video === void 0 ? void 0 : _g_statsOnSubscribed_video.forEach((g)=>P.push(g)), (_g_statsOnSubscribed_sharing = g.statsOnSubscribed.sharing) === null || _g_statsOnSubscribed_sharing === void 0 ? void 0 : _g_statsOnSubscribed_sharing.forEach((g)=>w.push(g)), removeUndefinedFields({
                    multipleVideoStreams: g.multiViewStats,
                    WebRTCStats_ssrc: removeUndefinedFields({
                        audio: compileAudioReportForE2E(C, E, T, _),
                        video: compileVideoReportForE2E("video", C, I, b, _),
                        sharing: compileVideoReportForE2E("sharing", C, A, R, _)
                    }),
                    CallSwMuted: 1e3 * f.callSwMuted,
                    DeviceEvents: rebaseTime(S.deviceManager.deviceTelemetryEvents.filter((g)=>g.timestamp > v), "timestamp", f.creationTime),
                    VideoEffects: rebaseTime(S.deviceManager.videoEffectsEvents.filter((g)=>g.timestamp > v), "timestamp", f.creationTime),
                    AudioEffects: rebaseTime(S.deviceManager.audioEffectsEvents.filter((g)=>g.timestamp > v), "timestamp", f.creationTime),
                    statsErrors: f.statsErrors,
                    WorkerEvents: rebaseTime(S.deviceManager.workerEvents.filter((g)=>g.timestamp > v), "timestamp", f.creationTime)
                });
            }
            var ZE = class {
                get rawRootRef() {
                    return this.rootRef;
                }
                getSessionTelemetry(g) {
                    const f = this.rootRef.sessions.find((f)=>f.sessionId === g), S = {
                        metrics: {},
                        Extensions: {}
                    };
                    if (!f) return;
                    const v = Kt();
                    try {
                        var _g_terminationTime;
                        const g = f.callNumber > 1 ? this.rootRef.sessions.find((g)=>f.callNumber - 1 === g.callNumber) : void 0, v = (_g_terminationTime = g === null || g === void 0 ? void 0 : g.terminationTime) !== null && _g_terminationTime !== void 0 ? _g_terminationTime : 0, _ = f.webrtcSessions[f.webrtcSessions.length - 1];
                        S.metrics = compileMetricsTelemetryReport(f, v, this.rootRef, this.configProvider), S.Extensions = compileExtensionsTelemetryReport(_, this.configProvider, f.statsErrors);
                    } catch (g) {
                        f[KE].addStatsError("DiagnosticsReport:getSessionTelemetry", stringifyObject(g)), S.Extensions.WebRTCStats_statsErrors = JSON.stringify(f.statsErrors);
                    }
                    return S.metrics.ReportGenerationTimeMs = round(Kt() - v), S;
                }
                getTeamsRealtimeTelemetry(g) {
                    const f = this.rootRef.sessions.find((f)=>f.sessionId === g);
                    if (f) try {
                        const g = f.webrtcSessions[f.webrtcSessions.length - 1], S = this.configProvider.config.diagnostics.teamsRealtimeTelemetry.pollingInterval;
                        return compileTeamsRealtimeTelemetryReport(g.statsReports.slice(g.statsReports.length - S), this.rootRef.deviceManager.rawUsedDevices);
                    } catch (g) {
                        throw f[KE].addStatsError("DiagnosticsReport:getRealTimeTelemetry", stringifyObject(g)), g;
                    }
                }
                getMediaSessionStats(g) {
                    const f = this.rootRef.sessions.find((f)=>f.sessionId === g);
                    if (f) try {
                        var _g_terminationTime;
                        const g = f.callNumber > 1 ? this.rootRef.sessions.find((g)=>f.callNumber - 1 === g.callNumber) : void 0, S = (_g_terminationTime = g === null || g === void 0 ? void 0 : g.terminationTime) !== null && _g_terminationTime !== void 0 ? _g_terminationTime : 0, v = f.webrtcSessions[f.webrtcSessions.length - 1], _ = (v === null || v === void 0 ? void 0 : v.statsReports.length) ? v.statsReports[v.statsReports.length - 1] : void 0, C = _ ? compileMediaStatsReport(_) : void 0;
                        return C && (C.extensions = compileMediaStatsReportExtensions(v, this.configProvider), C.metrics = compileMediaStatsReportMetrics(f, S, this.rootRef)), C;
                    } catch (g) {
                        throw f[KE].addStatsError("DiagnosticsReport:getMediaSessionStats", stringifyObject(g)), g;
                    }
                }
                getDiagnosticsForE2eTests(g) {
                    const f = this.rootRef.sessions.find((f)=>f.sessionId === g);
                    let S = {
                        statsErrors: []
                    };
                    if (f) {
                        try {
                            var _v_terminationTime;
                            const g = f.webrtcSessions[f.webrtcSessions.length - 1], v = f.callNumber > 1 ? this.rootRef.sessions.find((g)=>f.callNumber - 1 === g.callNumber) : void 0, _ = (_v_terminationTime = v === null || v === void 0 ? void 0 : v.terminationTime) !== null && _v_terminationTime !== void 0 ? _v_terminationTime : 0;
                            S = compileE2EDiagReport(g, f, this.rootRef, _, this.configProvider.config.diagnostics.collectionLimits.numSamplesForE2E);
                        } catch (g) {
                            const v = "DiagnosticsReport:getDiagnosticsForE2eTests", _ = stringifyObject(g);
                            f[KE].addStatsError(v, _), arrayLimitedPush2(S.statsErrors, {
                                origin: v,
                                error: _,
                                count: 1
                            }, this.configProvider.config.diagnostics.collectionLimits.numStatsErrors);
                        }
                        return S;
                    }
                }
                constructor(g, f){
                    this.rootRef = g, this.configProvider = f;
                }
            }, eT = class {
                get reportGenerator() {
                    return this.diagnosticsReport;
                }
                get rootRef() {
                    return this.root;
                }
                set mediaConfig(g) {
                    this.root.configuration.mediaConfig = g;
                }
                newSession(g, f, S) {
                    this.root.configuration.userAgentConfig.hasUnifiedPlanSupport = this.configProvider.mediaConfig.simulcastSessionEnabled;
                    const v = new JE(S, g, this.diagnosticsReport, this.root.deviceManager, ++this.root.numTotalSessions, f);
                    return arrayLimitedPush2(this.root.sessions, v.getObjectRef(), this.configProvider.config.diagnostics.collectionLimits.numSessions), v;
                }
                constructor(g, f){
                    this.configProvider = g, this.deviceManagerDiagnostics = f, this.root = {
                        creationTime: Date.now(),
                        numTotalSessions: 0,
                        deviceManager: this.deviceManagerDiagnostics.getObjectRef(),
                        configuration: {
                            stackConfig: this.configProvider.stackConfig,
                            defaultConfig: this.configProvider.defaultConfig,
                            mediaConfig: {},
                            userAgentConfig: {
                                isAudioOutputSelectionSupported: this.configProvider.userAgentConfig.isAudioOutputSelectionSupported,
                                isBrowserRollbackSupported: this.configProvider.userAgentConfig.isBrowserRollbackSupported,
                                hardwareConcurrency: ss.hardwareConcurrency,
                                unmaskedGlRenderer: ss.unmaskedGlRenderer,
                                hasMediaApi: ss.hasMediaApi(),
                                hasCapabilitiesApi: ss.hasCapabilitiesApi(),
                                hasUnifiedPlanSupport: void 0
                            },
                            consoleOverrides: this.configProvider.consoleOverrides,
                            fullConfig: deepClone(this.configProvider.config),
                            ecsConfigUpdates: []
                        },
                        browserInfo: Ze.getBrowserInfo(),
                        sessions: []
                    }, this.diagnosticsReport = new ZE(this.root, this.configProvider), this.configProvider.on("newConfigReceived", (g, f, S)=>{
                        this.root.configuration.ecsConfigUpdates.push({
                            timestamp: Date.now(),
                            etag: f,
                            configIds: S,
                            config: g
                        });
                    }), this.configProvider.on("configUpdated", ()=>{
                        this.root.configuration.consoleOverrides = this.configProvider.consoleOverrides, this.root.configuration.fullConfig = deepClone(this.configProvider.config);
                    });
                }
            }, tT = class _JamaLogger {
                warn(...g) {
                    this.unsafe.warn(...g);
                }
                error(...g) {
                    this.unsafe.error(...g);
                }
                debug(...g) {
                    this.unsafe.debug(...g);
                }
                info(...g) {
                    this.unsafe.info(...g);
                }
                createChild(g) {
                    return new _JamaLogger(this.safe.createChild(g), this.unsafe.createChild(g));
                }
                constructor(g, f){
                    this.safe = g, this.unsafe = f, this.safe || (this.safe = this.unsafe);
                }
            }, iT = P, nT = class {
                get isExtensionAvailable() {
                    return "unavailable" !== this.loggingState;
                }
                async updateSessionCount(g) {
                    this.isExtensionAvailable && (0 === this.connectionCount && 1 === g ? ("stopped" === this.loggingState && await this.discardLogs(), await this.initialStartLogging()) : 0 === g && await this.stopLogging(), this.connectionCount = g);
                }
                async collect() {
                    return this.isExtensionAvailable ? this.collectPromise ? this.collectPromise : this.collectPromise = new Promise(async (g)=>{
                        try {
                            this.connectionCount > 0 && (this.logger.safe.info(`Stopping logger for gathering, open connections: ${this.connectionCount}`), await this.stopLogging()), await this.storeLogs();
                            const f = await this.gatherFromStorage();
                            this.connectionCount > 0 && await this.continueLogging(), g(f.length > 0 ? f.join("\r\n") : "");
                        } catch (f) {
                            this.logger.safe.error("Error while collecting logs", f), g(JSON.stringify(f));
                        }
                        this.collectPromise = void 0;
                    }) : "";
                }
                async initialStartLogging() {
                    try {
                        await this.startLogging();
                    } catch (g) {
                        if (g === null || g === void 0 ? void 0 : g.includes("A log is already open")) try {
                            const f = g.match(/State=(\w+)/);
                            await this.cleanState(f === null || f === void 0 ? void 0 : f[1]), await this.startLogging();
                        } catch (g) {
                            this.logger.safe.error("Error while starting logging at cleanup phase", g), this.loggingState = "unknown";
                        }
                        else this.logger.safe.error("Error while starting logging", g), this.loggingState = "unavailable";
                    }
                }
                async continueLogging() {
                    try {
                        await this.startLogging();
                    } catch (g) {
                        this.logger.safe.error("Error while continuing logging", g), this.loggingState = "stopped";
                    }
                }
                async startLogging() {
                    await this.sendMessage(this.extensionId, {
                        method: "logging.start"
                    }), this.logger.safe.info("Logging started"), this.loggingState = "started";
                }
                async cleanState(g) {
                    try {
                        if ("started" === g) await this.stopLogging(), await this.discardLogs();
                        else {
                            if ("stopped" !== g) throw new Error(`Unexpected logging state: ${g}`);
                            await this.discardLogs();
                        }
                    } catch (g) {
                        this.logger.safe.error("Error while cleaning state", g);
                    }
                }
                async stopLogging() {
                    try {
                        await this.sendMessage(this.extensionId, {
                            method: "logging.stop"
                        }), this.logger.safe.info("Logging stopped"), this.loggingState = "stopped";
                    } catch (g) {
                        this.logger.safe.error("Error while stopping logging", g);
                    }
                }
                async discardLogs() {
                    try {
                        await this.sendMessage(this.extensionId, {
                            method: "logging.discard"
                        }), this.logger.safe.info("Logs discarded"), this.loggingState = "closed";
                    } catch (g) {
                        this.logger.safe.error("Error while discarding logs", g);
                    }
                }
                async storeLogs() {
                    try {
                        await this.sendMessage(this.extensionId, {
                            method: "logging.store",
                            logId: this.logId
                        }), this.logger.safe.info(`Logs stored to ${this.logId}`), this.loggingState = "closed";
                    } catch (g) {
                        this.logger.safe.error("Error while storing logs", g);
                    }
                }
                async gatherFromStorage() {
                    const g = [];
                    let f = {
                        offset: 0
                    };
                    do f = await this.sendMessage(this.editorExtensionId, {
                        api: "getWebRtcLog",
                        logId: this.logId,
                        offset: f.offset
                    }), g.push(f.data), this.logger.safe.info(`Batch gathered with offset: ${f.offset}, moreData: ${f.moreData}`);
                    while (f.moreData);
                    return this.logger.safe.info("Finished gathering"), g;
                }
                sendMessage(g, f) {
                    return new Promise((S, v)=>{
                        const _ = chrome.runtime;
                        _.sendMessage(g, f, (g)=>{
                            if (!g || (g === null || g === void 0 ? void 0 : g.error)) {
                                const S = g ? JSON.stringify(g.error) : _.lastError;
                                v(`sendMessage ${JSON.stringify(f)} failed with error: ${S}`);
                            }
                            S(g);
                        });
                    });
                }
                constructor(g){
                    this.logger = g, this.extensionId = "nkeimhogjdpnpccoofpliimaahmaaome", this.editorExtensionId = "ncbjelpjchkpbikbpkcchkhkblodoama", this.logId = "TeamsWebRTCLogs", this.loggingState = "unknown", this.connectionCount = 0;
                    window.webRtcInternalsCollector = this;
                }
            }, rT = (()=>{
                let g;
                function getInstance(f, S) {
                    var _chrome;
                    return (S === null || S === void 0 ? void 0 : S.config.enableWebRtcInternalsLogs) && Ze.isBrowser("EdgeAnaheim") && !!((_chrome = chrome) === null || _chrome === void 0 ? void 0 : _chrome.runtime) ? (g || (g = new nT(f)), g) : (f.safe.info("WebRTC internal logging is disabled"), {
                        collect: ()=>Promise.resolve(""),
                        updateSessionCount: ()=>Promise.resolve()
                    });
                }
                return {
                    getInstance: getInstance
                };
            })(), aT = rT, sT = class {
                getId() {
                    return 0;
                }
                getDeviceId() {
                    return Gt.EMPTY_DEVICE_ID;
                }
                getPreviewAsync(g, f) {
                    return Promise.resolve(null);
                }
                getDescription() {
                    return "display";
                }
                getType() {
                    return 1;
                }
                getIcon(g, f) {
                    return Promise.resolve(null);
                }
            }, oT = class {
                getId() {
                    return 0;
                }
                getDeviceId() {
                    return this.descr.browserId;
                }
                getPreviewAsync(g, f) {
                    return Promise.resolve(null);
                }
                getDescription() {
                    return this.descr.label;
                }
                getType() {
                    return 3;
                }
                getIcon(g, f) {
                    return Promise.resolve(null);
                }
                constructor(g){
                    this.descr = g;
                }
            }, lT = class {
                onScreensChanged(g) {
                    return {
                        dispose: ()=>{}
                    };
                }
                enumerateScreensAsync() {
                    return Promise.resolve([
                        this.sharingSource
                    ]);
                }
                enumerateWindowsAsync() {
                    return Promise.resolve([]);
                }
                async enumerateCamerasAsync() {
                    return (await this.deviceManager.enumerateDevicesAsync()).filter((g)=>"camera" === g.kind).map((g)=>new oT(g));
                }
                constructor(g){
                    this.deviceManager = g, this.sharingSource = new sT;
                }
            }, cT = class {
                registerState(g) {
                    var _f_events_;
                    const f = "connected" === g ? this.activeTmpRecord : this.getTmpRecord();
                    f && ((_f_events_ = f.events[f.events.length - 1]) === null || _f_events_ === void 0 ? void 0 : _f_events_.type) !== g && (f.events.push({
                        type: g,
                        time: Date.now() - f.startTime
                    }), "networkOnline" === g ? this.data.networkRecoveredCount++ : "connected" === g && this.data.disconnectedRecoveredCount++, "reconnect" !== g && "connected" !== g || (f.endTime = Date.now() - f.startTime, this.activeTmpRecord = null));
                }
                registerReconnectAttempt(g) {
                    this.activeRecord && (this.activeAttempt = {
                        direction: g,
                        startTime: Date.now() - this.activeRecord.startTime,
                        status: !1
                    }, this.data.isReconnecting = !0, this.activeRecord.attempts.push(this.activeAttempt));
                }
                registerReconnectAttemptStatus(g) {
                    "completed" === g && (this.data.isReconnecting = !1), this.activeAttempt && this.activeRecord && (this.activeAttempt.endTime = Date.now() - this.activeRecord.startTime, this.activeAttempt.status = "completed" === g);
                }
                registerReconnect(g) {
                    if (this.data.reconnectCount[g]++, this.data.isReconnecting = "attempted" === g, "attempted" === g) {
                        if (this.activeRecord) return;
                        this.activeRecord = {
                            startTime: Date.now(),
                            attempts: []
                        }, this.data.records.push(this.activeRecord);
                    } else if ("connected" === g) {
                        if (!this.activeRecord) return;
                        this.activeTmpRecord && this.registerState("connected"), this.activeRecord.endTime = Date.now() - this.activeRecord.startTime, this.activeRecord = void 0, this.activeAttempt = void 0;
                    }
                }
                registerRetarget(g) {
                    this.data.retargetCount[g]++;
                }
                registerEscalation(g) {
                    this.data.escalationCount[g]++;
                }
                getObject() {
                    return this.data;
                }
                getTmpRecord() {
                    return (!this.activeTmpRecord || this.activeTmpRecord.endTime > 0) && (this.activeTmpRecord = {
                        startTime: Date.now(),
                        events: []
                    }, this.data.tmpRecords.push(this.activeTmpRecord)), this.activeTmpRecord;
                }
                constructor(){
                    this.data = {
                        records: [],
                        tmpRecords: [],
                        isReconnecting: !1,
                        networkRecoveredCount: 0,
                        disconnectedRecoveredCount: 0,
                        reconnectCount: {
                            attempted: 0,
                            connected: 0
                        },
                        retargetCount: {
                            incoming: 0,
                            outgoing: 0,
                            completed: 0,
                            rejected: 0
                        },
                        escalationCount: {
                            attempted: 0,
                            completed: 0,
                            rejected: 0
                        }
                    };
                }
            }, dT = class {
                process(g) {
                    return this.mediaLegId = g || this.mediaLegId || uniqueId().toUpperCase(), this.mediaLegId;
                }
                constructor(){}
            }, uT = class {
                initialize() {}
                setRelayOverride() {}
                async queryRelaysAsync(g) {
                    const f = await this.relayManager.queryRelaysAsync(g);
                    return f.length > 0 && (this.diagnostics.relay = f[0]), f;
                }
                getStats() {
                    var _this_relayManager_getStats, _this_relayManager;
                    var _this_relayManager_getStats1;
                    return (_this_relayManager_getStats1 = (_this_relayManager_getStats = (_this_relayManager = this.relayManager).getStats) === null || _this_relayManager_getStats === void 0 ? void 0 : _this_relayManager_getStats.call(_this_relayManager)) !== null && _this_relayManager_getStats1 !== void 0 ? _this_relayManager_getStats1 : {
                        stats: {
                            unavailable: "1"
                        }
                    };
                }
                getAuthTokenStats() {
                    return this.relayManager.getAuthTokenStats();
                }
                constructor(g, f){
                    this.relayManager = g, this.diagnostics = f;
                }
            }, hT = class {
                registerState(g) {
                    var _this_diag;
                    (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerState(g);
                }
                registerReconnectAttempt(g) {
                    var _this_diag;
                    this.stats.registerReconnectAttempt(g), (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerReconnectAttempt(g);
                }
                registerReconnectAttemptStatus(g) {
                    var _this_diag;
                    switch(g){
                        case "completed":
                            this.stats.registerReconnectAttemptCompleted();
                            break;
                        case "rejected":
                            this.stats.registerReconnectAttemptRejected();
                    }
                    (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerReconnectAttemptStatus(g);
                }
                registerReconnect(g) {
                    var _this_diag;
                    switch(g){
                        case "attempted":
                            this.stats.registerReconnectAttempted();
                            break;
                        case "connected":
                            this.stats.registerReconnectConnected();
                    }
                    (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerReconnect(g);
                }
                registerRetarget(g) {
                    var _this_diag;
                    switch(g){
                        case "completed":
                            this.stats.registerRetargetCompleted();
                            break;
                        case "rejected":
                            this.stats.registerRetargetRejected();
                            break;
                        case "incoming":
                            this.stats.registerRetargetIncoming();
                            break;
                        case "outgoing":
                            this.stats.registerRetargetOutgoing();
                    }
                    (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerRetarget(g);
                }
                registerEscalation(g) {
                    var _this_diag;
                    switch(g){
                        case "attempted":
                            this.stats.registerEscalationStart();
                            break;
                        case "completed":
                            this.stats.registerEscalationCompleted();
                            break;
                        case "rejected":
                            this.stats.registerEscalationRejected();
                    }
                    (_this_diag = this.diag) === null || _this_diag === void 0 ? void 0 : _this_diag.registerEscalation(g);
                }
                constructor(g, f, S){
                    this.stats = g, this.diag = f, S && f && (S.reconnect = f.getObject());
                }
            }, gT = class {
                flush() {
                    this.queue.forEach((g)=>{
                        g.method.apply(null, g.args);
                    }), this.clear();
                }
                clear() {
                    this.queue = [];
                }
                genCallback(g) {
                    return (...f)=>this.queue.push({
                            method: g,
                            args: f
                        });
                }
                constructor(g){
                    this.initialCallbacks = g, this.queueCallbacks = {
                        onTerminated: this.genCallback(this.initialCallbacks.onTerminated),
                        onSessionErrorOccurred: this.genCallback(this.initialCallbacks.onSessionErrorOccurred),
                        onNegotiationRequired: this.genCallback(this.initialCallbacks.onNegotiationRequired),
                        onAudioStateChanged: this.genCallback(this.initialCallbacks.onAudioStateChanged),
                        onAudioHwSilentChanged: this.genCallback(this.initialCallbacks.onAudioHwSilentChanged),
                        onTransportDisconnected: this.genCallback(this.initialCallbacks.onTransportDisconnected),
                        onTransportConnected: this.genCallback(this.initialCallbacks.onTransportConnected),
                        onTransportInitialized: this.genCallback(this.initialCallbacks.onTransportInitialized),
                        onTransportFailed: this.genCallback(this.initialCallbacks.onTransportFailed),
                        onUpdateMediaDescriptionsRequired: this.genCallback(this.initialCallbacks.onUpdateMediaDescriptionsRequired),
                        onTeamsRealtimeTelemetryReport: this.genCallback(this.initialCallbacks.onTeamsRealtimeTelemetryReport)
                    }, this.queue = [];
                }
            }, pT = class {
                async ensureOnline() {
                    if (0 === this.relayConfig.length) return this.logger.safe.warn("No TURN servers defined"), 0;
                    if (this.probeDeferred) return this.probeDeferred.promise;
                    this.logger.safe.info(`Starting TURN probes with ${JSON.stringify(this.relayConfig[0].urls)}`), this.checkStart = Date.now();
                    let g = 0;
                    this.probeDeferred = new ct;
                    const check = async ()=>{
                        await this.performCheck() && this.finalize();
                    }, spawnCheckAndScheduleNext = ()=>{
                        check(), g < 3e3 && (g += 1e3), this.probeTimer = setTimeout(spawnCheckAndScheduleNext, g);
                    };
                    return spawnCheckAndScheduleNext(), this.probeDeferred.promise;
                }
                finalize() {
                    this.probeTimer && (clearTimeout(this.probeTimer), this.probeTimer = 0), this.probeDeferred && (this.probeDeferred.resolve(Date.now() - this.checkStart), this.probeDeferred = null);
                }
                dispose() {
                    this.finalize();
                }
                async performCheck() {
                    this.logger.safe.info("Probing...");
                    const g = this.tryCreatePc();
                    if (!g) return !1;
                    g.createDataChannel("probe");
                    const f = new ct;
                    function finalize(S) {
                        g.onicecandidate = void 0, g.close(), f.resolve(S);
                    }
                    let S = !1;
                    return g.onicecandidate = (g)=>{
                        const f = g.candidate;
                        if (!f) return S || this.logger.safe.info("still offline"), void finalize(S);
                        var _f_type;
                        const v = (_f_type = f.type) !== null && _f_type !== void 0 ? _f_type : parseCandidateString(f.candidate).type;
                        "srflx" !== v && "relay" !== v || (this.logger.safe.info(`Back online through ${v} candidate`), S = !0, "srflx" === v && (this.ipFromRelay = f.address, finalize(!0)));
                    }, await g.setLocalDescription(await g.createOffer()), f.promise;
                }
                tryCreatePc() {
                    try {
                        return new Qa.window.RTCPeerConnection({
                            iceServers: this.relayConfig
                        });
                    } catch (g) {
                        return this.logger.safe.info(`Failed to create PC, errCode=${g.code}`), null;
                    }
                }
                constructor(g, f){
                    this.relayConfig = g, this.logger = f;
                }
            }, createIceServers = (g, f)=>g.reduce((g, S)=>{
                    const v = [], _ = S.addresses && S.addresses[0], C = S.fqdns && S.fqdns.length > 0, E = f.iceUdpAddressType, T = f.iceTcpAddressType, I = f.iceServerTransport;
                    if (!_ && !C) return g;
                    if (I.includes("udp") && S.udpPort) {
                        const g = !C || "fqdn" !== E && _ ? _ : S.fqdns[0];
                        v.push(`turn:${g}:${S.udpPort}?transport=udp`);
                    }
                    if (I.includes("tcp") && S.tcpPort) {
                        const g = !C || "fqdn" !== T && _ ? _ : S.fqdns[0];
                        v.push(`turn:${g}:${S.tcpPort}?transport=tcp`);
                    }
                    return I.includes("tls") && S.tlsPort && C && v.push(`turns:${S.fqdns[0]}:${S.tlsPort}`), g.concat({
                        urls: v,
                        credential: S.password,
                        username: S.username
                    });
                }, []), createProbeIceServers = (g, f)=>g.reduce((g, S)=>{
                    const v = [], _ = S.addresses && S.addresses[0], C = S.fqdns && S.fqdns.length > 0, E = f.iceUdpAddressType, T = f.iceServerTransport;
                    if (!_ && !C) return g;
                    if (T.includes("udp") && S.udpPort) {
                        const g = !C || "fqdn" !== E && _ ? _ : S.fqdns[0];
                        v.push(`stun:${g}:${S.udpPort}`);
                    }
                    return T.includes("tls") && S.tlsPort && C && v.push(`turns:${S.fqdns[0]}:${S.tlsPort}`), g.concat({
                        urls: v,
                        credential: S.password,
                        username: S.username
                    });
                }, []), mT = class {
                get isOnline() {
                    return !this.isOnlineDeferred;
                }
                async createRelayProber() {
                    if (!this._relayProber) {
                        const g = Date.now(), f = createProbeIceServers(await this.relayManager.queryRelaysAsync({
                            relayType: "turn"
                        }), this.configProvider.config), S = Date.now() - g;
                        this.logger.safe.info(`RelayProber configuration fetched in ${S} ms`), S > 5e3 && this.diagnostics.registerState("relayConfigFetched"), this._relayProber = new pT(f, this.logger.createChild("RelayProber"));
                    }
                    return this._relayProber;
                }
                dispose() {
                    var _this__relayProber, _this_isOnlineDeferred;
                    this.isDisposing = !0, window.removeEventListener("online", this.onOnline), window.removeEventListener("offline", this.onOffline), (_this__relayProber = this._relayProber) === null || _this__relayProber === void 0 ? void 0 : _this__relayProber.dispose(), (_this_isOnlineDeferred = this.isOnlineDeferred) === null || _this_isOnlineDeferred === void 0 ? void 0 : _this_isOnlineDeferred.reject(new Error("dispose")), this.reconnectTimer && this.resetReconnectTimer();
                }
                get settings() {
                    return (this.reconnectSession || this.session).getSessionConfig().config;
                }
                getCurrentSession() {
                    return this.reconnectSession || this.session;
                }
                getMainSession() {
                    return this.session || this.reconnectSession;
                }
                getReconnectSession() {
                    return this.reconnectSession;
                }
                async onIceDisconnect(g) {
                    var _this_session_transportStateProvider;
                    if (this.wasConnected) this.raiseReconnectEvent("Bad", g);
                    else if (!this.settings.reconnectWithNoRelays && !this.session.hasRelayCandidates()) return void this.onReconnectFailed("no relays", g);
                    if (this.isDisconnected = !0, !this.isReconnecting() && !this.isWaitingForNetwork) return this.logger.safe.info(`[${g}] reconnect attempt after iceDisconnect error`), ((_this_session_transportStateProvider = this.session.transportStateProvider) === null || _this_session_transportStateProvider === void 0 ? void 0 : _this_session_transportStateProvider.isFailed) && this.diagnostics.registerState("failed"), this.diagnostics.registerReconnect("attempted"), this.reconnectAsync(g);
                }
                onTransportDisconnect(g) {
                    this.isDisconnected = !0, this.wasConnected && (this.diagnostics.registerState("disconnected"), this.handleTmpConnectivityLoss(g));
                }
                onConnected(g) {
                    var _this__relayProber;
                    this.isDisconnected = !1, this.logger.safe.info(`[${g}] set allow UFD`), this.diagnostics.registerState("connected"), this.raiseReconnectEvent("Good", g), this.wasConnected = !0, (_this__relayProber = this._relayProber) === null || _this__relayProber === void 0 ? void 0 : _this__relayProber.finalize();
                }
                onNegotiationCompletedAsync(g) {
                    return this.logger.safe.info(`[${g}] handle negotiation completed`), this.setSignalingState(!0), this.isReconnecting() && (this.diagnostics.registerRetarget("completed"), 2 === this.escalationType && this.blockCurrentSession(g)), Promise.resolve();
                }
                async onSessionErrorOccurred(g, f) {
                    this.logger.safe.info(`[${f}] handle session error`, stringifyObject(g)), await this.rejectReconnect(f), this.isReconnectAllowed() ? await this.scheduleReconnectRetry(f, !1, !1) : this.callback.onSessionErrorOccurred(g, f, this.wasConnected);
                }
                onNegotiationRejection(g, f) {
                    this.logger.safe.info(`[${f}] handle negotiation rejection`), this.diagnostics.registerRetarget("rejected");
                    const S = 1 === this.escalationType;
                    return this.rejectReconnect(f).then(()=>{
                        const v = g.type === Gt.RENEGOTIATION_ERROR.glare && S;
                        (g.type !== Gt.RENEGOTIATION_ERROR.glare || S) && (this.isRecoverableError(g.type) || v ? this.scheduleReconnectRetry(f, v, S) : this.onReconnectFailed(stringifyObject(g), f));
                    });
                }
                async ensureNetwork(g) {
                    const f = this.isOnline;
                    if (!this.isOnline) {
                        this.logger.safe.info(`[${g}] waiting for network...`);
                        try {
                            await this.isOnlineDeferred.promise;
                        } catch (f) {
                            return void this.logger.safe.info(`${g} call disposed while waiting for network`);
                        }
                        this.logger.safe.info(`[${g}] network seems up`);
                    }
                    if (this.isDisconnected) {
                        const S = await this.createRelayProber(), v = await S.ensureOnline();
                        this.logger.safe.info(`[${g}] probing complete in ${v} ms`), this.diagnostics.registerState("relaysUp"), f && v < 1e3 && this.logger.safe.info(`[${g}] looks like network failed on remote side, recovery was quick`);
                    }
                }
                oldSessionIsOnline(g) {
                    var _this_session_transportStateProvider, _this_session;
                    return !!((_this_session = this.session) === null || _this_session === void 0 ? void 0 : (_this_session_transportStateProvider = _this_session.transportStateProvider) === null || _this_session_transportStateProvider === void 0 ? void 0 : _this_session_transportStateProvider.isConnected) && (this.logger.safe.info(`[${g}] old session recovered`), this.isReconnecting() || this.diagnostics.registerReconnect("connected"), !0);
                }
                async waitForNetworkAndTryLightweightRecovery(g) {
                    var _this_session_transportStateProvider, _this_session_transportStateProvider1;
                    const f = this.oldSessionIsOnline(g);
                    if (f || !this.settings.reconnectWithProbes) return f;
                    this.setReconnectTimer(), this.isWaitingForNetwork = !0;
                    const S = this.getMaxNetworkWaitTime();
                    return this.logger.safe.info(`[${g}] can wait up to ${S} ms`), await Promise.race([
                        this.ensureNetwork(g),
                        delay(S)
                    ]), this.isWaitingForNetwork = !1, this.session && (((_this_session_transportStateProvider = this.session.transportStateProvider) === null || _this_session_transportStateProvider === void 0 ? void 0 : _this_session_transportStateProvider.isConnected) || ((_this_session_transportStateProvider1 = this.session.transportStateProvider) === null || _this_session_transportStateProvider1 === void 0 ? void 0 : _this_session_transportStateProvider1.isFailed) || (this.logger.safe.info(`[${g}] giving session a moment to recover`), await delay(this.settings.reconnectWaitTimeAfterProbe)), this.oldSessionIsOnline(g)) ? (this.resetReconnectTimer(), !0) : this.checkIfTimerFailed(g) ? (this.logger.safe.info(`[${g}] session reconnect timer reached during network checks`), !0) : !!this.isDisposing && (this.logger.safe.info(`[${g}] session is disposed`), !0);
                }
                reconnectAsync(g, f = !1, S = !1, v) {
                    var _this_context_getSmallCallTelemetry;
                    return this.logger.safe.info(`[${g}] queueing reconnect, force=${f}, escalation=${S}`), this.diagnostics.registerReconnectAttempt(S ? "local escalation" : "out"), (_this_context_getSmallCallTelemetry = this.context.getSmallCallTelemetry()) === null || _this_context_getSmallCallTelemetry === void 0 ? void 0 : _this_context_getSmallCallTelemetry.setEventType("reconnect"), this._isReconnectScheduled = !0, S && (this.escalationType = 1, this.onReconnectCompleted = v), this.sessionOperationQueue.queueOperation(async ()=>{
                        if (this._isReconnectScheduled = !1, !f) {
                            if (await this.waitForNetworkAndTryLightweightRecovery(g)) return void this.sessionOperationQueue.completeCurrentOperation();
                        }
                        if (this.isReconnecting()) return this.logger.safe.info(`[${g}] ongoing reconnect is in progress`), void this.sessionOperationQueue.completeCurrentOperation();
                        this.diagnostics.registerState("reconnect"), await this.initReconnect(g), await this.reconnectSession.configureModalitiesAsync(this.getConfiguredModalities(), g), this.sessionOperationQueue.completeCurrentOperation();
                    }, g);
                }
                async acceptReconnectStartAsync(g, f) {
                    return this.logger.safe.info(`[${f}] accepting reconnect`), this.diagnostics.registerRetarget("incoming"), g ? (this.escalationType = 2, this.diagnostics.registerEscalation("attempted")) : (!this.isReconnecting() && this.isDisconnected ? this.diagnostics.registerReconnect("attempted") : this.isReconnecting() && await this.rejectReconnect(f), this.diagnostics.registerState("reconnect"), this.diagnostics.registerReconnectAttempt("in")), this.initReconnect(f);
                }
                acceptReconnectFinish(g) {
                    const f = this.getConfiguredModalities();
                    return this.reconnectSession.configureModalitiesAsync(f, g).then(()=>f);
                }
                isReconnecting() {
                    return !!this.reconnectSession;
                }
                isReconnectScheduled() {
                    return this._isReconnectScheduled;
                }
                cleanUp() {
                    this.sessionCallbacks = null, this.reconnectSession = null;
                }
                async terminateAsync(g) {
                    try {
                        var _this_session;
                        await ((_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.terminate(g, {}));
                    } catch (e) {}
                    try {
                        await this.terminateReconnectSessionAsync(g, !0);
                    } catch (e) {}
                    this.cleanUp();
                }
                completeReconnect(g) {
                    return this.logger.safe.info(`[${g}] completing reconnect`), 2 === this.escalationType && (this.unblockCurrentSession(g), this.diagnostics.registerEscalation("completed")), this.escalationType = 0, this.reconnectSession && (this.context.config.isConference = this.isReconnectConference, this.disposeActiveSession(g), this.session = this.reconnectSession, this.reconnectManagerMessageQueue.clear(), this.diagnostics.registerReconnectAttemptStatus("completed"), this._isSignalingStable || this.diagnostics.registerRetarget("completed"), this.isDisconnected && this.diagnostics.registerReconnect("connected"), this.resetReconnectTimer(), this.reconnectDelayTime = 0, this.reconnectSession = null, this.negotiationPausePromise = null, this.session.callbacks = this.sessionCallbacks || {}), Promise.resolve();
                }
                async rejectReconnect(g) {
                    this.logger.safe.info(`[${g}] rejecting reconnect`), this.setSignalingState(!1), 2 === this.escalationType && this.diagnostics.registerEscalation("rejected"), this.escalationType = 0, this.reconnectSession && (await this.terminateReconnectSessionAsync(g, !1), this.diagnostics.registerReconnectAttemptStatus("rejected")), this.session && (this.reconnectManagerMessageQueue.flush(), this.session.callbacks = this.sessionCallbacks, this.unblockCurrentSession(g));
                }
                configureModalitiesAsync(g, f, S) {
                    this.lastKnownConfiguredModalities = g;
                    const v = [];
                    return this.session && v.push(this.session.configureModalitiesAsync(g, f, S)), this.reconnectSession && v.push(this.reconnectSession.configureModalitiesAsync(g, f, S)), Promise.all(v).then(()=>Promise.resolve());
                }
                canSendDtmf() {
                    return this.getMainSession().canSendDtmf();
                }
                muteHold(g, f) {
                    this.getMainSession().muteHold(g, f);
                }
                muteInputAsync(g) {
                    return this.getMainSession().muteInputAsync(g);
                }
                unmuteInputAsync(g) {
                    return this.getMainSession().unmuteInputAsync(g);
                }
                muteOutputAsync(g) {
                    return this.getMainSession().muteOutputAsync(g);
                }
                unmuteOutputAsync(g) {
                    return this.getMainSession().unmuteOutputAsync(g);
                }
                async getSpeakerVolume(g) {
                    return this.getMainSession().getSpeakerVolume(g);
                }
                async setSpeakerVolume(g, f) {
                    return this.getMainSession().setSpeakerVolume(g, f);
                }
                _deviceSelectionChanged() {
                    this.session && this.session.deviceSelectionChanged(), this.reconnectSession && this.reconnectSession.deviceSelectionChanged();
                }
                disposeActiveSession(g) {
                    if (this.session && this.isReconnecting()) {
                        this.logger.safe.info(`[${g}] About to dispose current session...`);
                        const f = this.session;
                        return this.lastKnownConfiguredModalities = this.session.getConfiguredModalities(), f.callbacks = this.reconnectManagerMessageQueue.queueCallbacks, f.move(this.reconnectSession, g), this.session = null, f.terminate(g, {}, !1);
                    }
                    return Promise.resolve();
                }
                registerRetargetOutgoing() {
                    this.diagnostics.registerRetarget("outgoing");
                }
                isSignalingStable() {
                    return this._isSignalingStable;
                }
                getConfiguredModalities() {
                    return this.getMainSession().getConfiguredModalities() || this.lastKnownConfiguredModalities;
                }
                checkIfTimerFailed(g) {
                    var _this_session_transportStateProvider;
                    return !(this.isReconnectAllowed() || this.session && !((_this_session_transportStateProvider = this.session.transportStateProvider) === null || _this_session_transportStateProvider === void 0 ? void 0 : _this_session_transportStateProvider.isFailed)) && (this.onReconnectFailed("the time limit was reached", g), !0);
                }
                async scheduleReconnectRetry(g, f, S) {
                    const v = this.getReconnectDelayTime();
                    if (this.logger.safe.info(`[${g}] scheduling reconnect retry attempt in ${v}`), await delay(v), f || !this.checkIfTimerFailed(g)) return this.reconnectAsync(g, S, S, this.onReconnectCompleted);
                }
                isRecoverableError(g) {
                    return Gt.RENEGOTIATION_ERROR.media === g || Gt.RENEGOTIATION_ERROR.signaling === g;
                }
                async resetReconnectSession(g) {
                    this.logger.safe.info(`[${g}] Resetting reconnect session. Session exists: old: ${!!this.session}, new: ${!!this.reconnectSession}`), this.isReconnectConference = 0 !== this.escalationType || this.context.config.isConference;
                    const f = 0 !== this.escalationType || this.context.config.isConference && this.wasConnected && !this.isDisconnected, S = this.getMainSession(), v = this.configProvider.getConfigView(this.isReconnectConference, S.getSessionConfig()), _ = S.clone(f, v);
                    _.callbacks = {
                        ...this.sessionCallbacks,
                        onTransportConnected: (g)=>{
                            var _this_onReconnectCompleted, _this;
                            2 !== this.escalationType && this.completeReconnect(g), (_this_onReconnectCompleted = (_this = this).onReconnectCompleted) === null || _this_onReconnectCompleted === void 0 ? void 0 : _this_onReconnectCompleted.call(_this), this.raiseReconnectEvent("Good", g), this.sessionCallbacks.onTransportConnected(g);
                        }
                    }, this.session && (this.session.callbacks = {
                        ...this.reconnectManagerMessageQueue.queueCallbacks,
                        onSessionErrorOccurred: (g, f)=>(g.type !== Gt.MEDIA_ERROR.iceConnectionError && this.reconnectManagerMessageQueue.queueCallbacks.onSessionErrorOccurred(g, f), Promise.resolve())
                    }), this.reconnectSession && (this.reconnectSession.move(_, g), this.logger.safe.info(`[${g}] reconnect session still exists during reconnect clone operation`), await this.terminateReconnectSessionAsync(g, !1)), this.logger.safe.info(`[${g}] New session reset.`), this.reconnectSession = _;
                }
                async initReconnect(g) {
                    this.logger.safe.info(`[${g}] initiate reconnect`), this.setReconnectTimer(), await this.resetReconnectSession(g), this.setSignalingState(!1), this.session && (this.blockCurrentSession(g), await Promise.all([
                        this.reconnectSession.muteInputAsync(g),
                        this.reconnectSession.muteOutputAsync(g)
                    ]));
                }
                blockCurrentSession(g) {
                    this.logger.safe.debug(`[${g}] blocking current session negotiations`), this.negotiationPausePromise = this.session.pauseNegotiations(g);
                }
                unblockCurrentSession(g) {
                    this.negotiationPausePromise && (this.logger.safe.debug(`[${g}] unblocking current session negotiations`), this.negotiationPausePromise.resolve(), this.negotiationPausePromise = null);
                }
                raiseReconnectEvent(g, f) {
                    this.ufdManager.signalEvent("NetworkReconnect", g, "Audio", !0, f);
                }
                async terminateReconnectSessionAsync(g, f) {
                    if (this.reconnectSession) {
                        const S = new gT(this.sessionCallbacks);
                        this.reconnectSession.callbacks = {
                            ...S.queueCallbacks,
                            onTerminated: f ? this.sessionCallbacks.onTerminated : S.queueCallbacks.onTerminated
                        }, await this.reconnectSession.terminate(g, {}, !1), S.clear(), this.reconnectSession = null;
                    }
                }
                setReconnectTimer() {
                    const g = this.wasConnected ? this.settings.reconnectTimeLimit : this.settings.initialReconnectTimeLimit;
                    g > 0 && !this.reconnectTimer && (this.reconnectTimerStart = Date.now(), this.reconnectTimer = window.setTimeout(()=>this.resetReconnectTimer(), g));
                }
                resetReconnectTimer() {
                    clearTimeout(this.reconnectTimer), this.reconnectTimer = null;
                }
                isReconnectAllowed() {
                    return !!this.reconnectTimer && !this.isDisposing;
                }
                getReconnectDelayTime() {
                    return 1e3 * Math.min(++this.reconnectDelayTime, this.settings.maxReconnectDelayTime);
                }
                getMaxNetworkWaitTime() {
                    const g = this.reconnectTimerStart > 0 ? Date.now() - this.reconnectTimerStart : 0;
                    return Math.max(this.settings.reconnectTimeLimit - g, 0);
                }
                onReconnectFailed(g, f) {
                    this.callback.onSessionErrorOccurred({
                        type: Gt.MEDIA_ERROR.iceConnectionError,
                        detail: `Reconnect failed, error - ${stringifyObject(g)}`
                    }, f, this.wasConnected);
                }
                setSignalingState(g) {
                    this._isSignalingStable = g;
                }
                async handleTmpConnectivityLoss(g) {
                    this.logger.safe.info(`[${g}] Session went into disconnected state, giving it ${this.settings.losingConnectivityTimeoutMs}ms to recover`), -1 !== this.settings.losingConnectivityTimeoutMs && (await delay(this.settings.losingConnectivityTimeoutMs), this.isDisconnected && this.raiseReconnectEvent("Poor", g)), this.isDisconnected && this.settings.reconnectOnDisconnect && (this.logger.safe.info(`[${g}] Session is still down, triggering reconnect`), this.onIceDisconnect(g));
                }
                constructor(g, f, S, v, _, C, E, T){
                    this.session = g, this.context = f, this.diagnostics = S, this.sessionOperationQueue = v, this.callback = _, this.sessionCallbacks = C, this.configProvider = E, this.relayManager = T, this.wasConnected = !1, this.isDisconnected = !1, this.isReconnectConference = !1, this.escalationType = 0, this._isSignalingStable = !0, this.reconnectDelayTime = 0, this._isReconnectScheduled = !1, this.isDisposing = !1, this.isWaitingForNetwork = !1, this.onOnline = ()=>{
                        var _this_isOnlineDeferred;
                        this.logger.safe.info("onOnline: Network is up"), this.diagnostics.registerState("networkOnline"), (_this_isOnlineDeferred = this.isOnlineDeferred) === null || _this_isOnlineDeferred === void 0 ? void 0 : _this_isOnlineDeferred.resolve(), this.isOnlineDeferred = null;
                    }, this.onOffline = ()=>{
                        this.logger.safe.info("onOffline: Network is down"), this.diagnostics.registerState("networkOffline"), this.isOnlineDeferred = new ct;
                    }, this.logger = f.getLogger().createChild("ReconnectManagerV2"), this.ufdManager = f.getUfdManager(), this.session.callbacks = C, this.reconnectManagerMessageQueue = new gT(C), window.addEventListener("online", this.onOnline), window.addEventListener("offline", this.onOffline);
                }
            }, fT = class {
                set mediaLegId(g) {
                    this.stats.setMediaLegId(g.process()), this.diagnostics && (this.diagnostics.mediaLegId = g);
                }
                set isMultiParty(g) {
                    g && this.stats.setMultiParty(), this.diagnostics && (this.diagnostics.isMultiParty = g);
                }
                set allowedModalities(g) {
                    this.stats.setSendModalities(g), this.diagnostics && (this.diagnostics.allowedModalities = g);
                }
                set sessionError(g) {
                    this.stats.setError(g), this.diagnostics && (this.diagnostics.sessionError = g);
                }
                set finalAnswerTime(g) {
                    this.stats.setFinalAnswerTimestamp(g), this.diagnostics && (this.diagnostics.finalAnswerTime = g);
                }
                set dtmfResult(g) {
                    this.stats.dtmfResult(g), this.diagnostics && (this.diagnostics.dtmfResult = g);
                }
                set swMute(g) {
                    this.stats.setSwMute(g), this.diagnostics && (this.diagnostics.swMute = g);
                }
                set speakerMute(g) {
                    this.stats.setSpeakerMute(g), this.diagnostics && (this.diagnostics.speakerMute = g);
                }
                set hwSilent(g) {
                    this.stats.setHwSilent(g), this.diagnostics && (this.diagnostics.hwSilent = g);
                }
                set isSpeaking(g) {
                    this.stats.setSpeakingState(g), this.diagnostics && (this.diagnostics.isSpeaking = g);
                }
                set iceConnectedStateTimestamp(g) {
                    this.stats.setIceConnectedStateTimestamp(g), this.diagnostics && (this.diagnostics.iceConnectedStateTimestamp = g);
                }
                set iceInitTime(g) {
                    this.stats.setIceInitTimestamp(g), this.diagnostics && (this.diagnostics.iceInitTime = g);
                }
                set ETag(g) {
                    this.stats.setETag(g), this.diagnostics && (this.diagnostics.ETag = g);
                }
                set configIds(g) {
                    this.stats.setConfigIds(g), this.diagnostics && (this.diagnostics.configIds = g);
                }
                set relay(g) {
                    this.stats.setRelay(g), this.diagnostics && (this.diagnostics.relay = g);
                }
                negotiationStart(g) {
                    var _this_diagnostics;
                    switch((_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.negotiationStart(g), g){
                        case "Offering":
                            this.stats.negotiation.offering.started();
                            break;
                        case "Answering":
                            this.stats.negotiation.answering.started();
                    }
                }
                negotiationCompleted(g) {
                    var _this_diagnostics;
                    this.stats.negotiation.current.completed(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.negotiationCompleted(g);
                }
                negotiationRejected() {
                    var _this_diagnostics;
                    this.stats.negotiation.current.rejected(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.negotiationRejected();
                }
                registerTransportConnected() {
                    var _this_diagnostics;
                    this.stats.registerTransportConnected(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerTransportConnected();
                }
                registerTransportDisconnected() {
                    var _this_diagnostics;
                    this.stats.registerTransportDisconnected(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerTransportDisconnected();
                }
                registerTransportFailed() {
                    var _this_diagnostics;
                    this.stats.registerTransportFailed(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerTransportFailed();
                }
                registerRollbackEvent(g) {
                    var _this_diagnostics;
                    this.stats.registerRollbackEvent(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerRollbackEvent(g);
                }
                registerRawMediaAccess(g, f, S) {
                    var _this_diagnostics;
                    "send" === f ? this.stats.registerSetInputRawMedia(S) : this.stats.registerOutputRawMediaAccess(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerRawMediaAccess(g, f, S);
                }
                registerQualityStateChangedEvent(g) {
                    var _this_diagnostics;
                    this.stats.registerQualityStateChangedEvent(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerQualityStateChangedEvent(g);
                }
                terminated(g) {
                    var _this_diagnostics;
                    this.stats.terminated(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.terminated(g);
                }
                registerRemoteQualityStateChangedEvent(g, f) {
                    var _this_diagnostics;
                    this.stats.registerRemoteQualityStateChangedEvent(g, f), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerRemoteQualityStateChangedEvent(g, f);
                }
                constructor(g, f){
                    this.stats = g, this.diagnostics = f;
                }
            }, ST = class {
                queueOperation(g, f = generateCauseId()) {
                    this.logger.safe.info(`[${f}] queueing operation`);
                    const S = new ct, v = this.operationQueue.add(()=>(this.currentOperationDeferred = S, g()), f);
                    return this.operationQueue.add(S, f), v;
                }
                completeCurrentOperation() {
                    this.currentOperationDeferred && (this.logger.safe.info("completing operation"), this.currentOperationDeferred.resolve());
                }
                constructor(g){
                    this.logger = g, this.operationQueue = null, this.currentOperationDeferred = null, this.operationQueue = new q_(this.logger);
                }
            }, vT = class extends Bt {
                async requestWakeLock() {
                    if (ss.isWakeLockSupported() && this.configProvider.config.useWakeLockApi) try {
                        this.wakeLock = await window.navigator.wakeLock.request("screen");
                    } catch (g) {
                        this.logger.safe.info(`Wakelock request failed - ${g.message}`);
                    }
                }
                enableTeamsRealTimeTelemetry() {
                    this.realtimeTelemetryInterval || (this.logger.safe.info("teams realtime telemetry is enabled"), this.getSessionCallbacks().onTeamsRealtimeTelemetryReport(), this.realtimeTelemetryInterval = window.setInterval(()=>{
                        this.getSessionCallbacks().onTeamsRealtimeTelemetryReport();
                    }, 1e3 * this.configProvider.config.diagnostics.teamsRealtimeTelemetry.pollingInterval));
                }
                getMediaStatsReport() {
                    var _this_diagnostics;
                    return (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.mediaStatsReport;
                }
                createOfferAsync(g, f) {
                    return this.sessionOperationQueue.queueOperation(async ()=>{
                        this.diagnosticsWrapper.negotiationStart("Offering");
                        try {
                            const S = await this.getCurrentSession().createOfferAsync(g, f);
                            return this.updateSelectedDevices(), S.mediaLegId = this.mediaLegId.process(S.mediaLegId), this.diagnosticsWrapper.mediaLegId = this.mediaLegId, this.reconnectManager.isReconnecting() && !this.reconnectManager.isSignalingStable() && (this.reconnectManager.registerRetargetOutgoing(), S.newOffer = !0), S;
                        } catch (g) {
                            throw this.diagnosticsWrapper.sessionError = g, g;
                        }
                    }, g);
                }
                registerRemoteQualityStateChangedEvent(g, f) {
                    this.diagnosticsWrapper.registerRemoteQualityStateChangedEvent(g, f);
                }
                setCallConstraints(g, f) {
                    return this.getCurrentSession().setCallConstraints(g, f);
                }
                processOfferAsync(g, f) {
                    return this.sessionOperationQueue.queueOperation(async ()=>{
                        this.diagnosticsWrapper.negotiationStart("Answering"), g.mediaLegId = this.mediaLegId.process(g.mediaLegId);
                        try {
                            g.newOffer && await this.reconnectManager.acceptReconnectStartAsync(g.escalationOccurring, f);
                            const S = await this.getCurrentSession().processOfferAsync(g, f);
                            if (g.newOffer) {
                                const g = await this.reconnectManager.acceptReconnectFinish(f);
                                return S.sharing === Gt.MEDIA_STATE.sendReceive && (S.sharing = g.sharing === Gt.MEDIA_STATE.send ? Gt.MEDIA_STATE.send : Gt.MEDIA_STATE.receive), S;
                            }
                            return S;
                        } catch (g) {
                            throw this.diagnosticsWrapper.sessionError = g, g;
                        }
                    }, f);
                }
                async processAnswerAsync(g, f, S, v) {
                    try {
                        return this.configProvider.config.muteDuringRemotePranswer && (S && !this.callMuteState && (this.logger.safe.info(`[${f}] Muting input before processing full answer`), await this.muteInputAsync(f), this.lastMuteFromPranswer = !0), !S && this.lastMuteFromPranswer && (this.logger.safe.info(`[${f}] Unmuting input before processing full answer`), await this.unmuteInputAsync(f), this.lastMuteFromPranswer = !1)), await this.getCurrentSession().processAnswerAsync(g, f, S, v);
                    } catch (g) {
                        throw this.lastMuteFromPranswer = !1, this.diagnosticsWrapper.sessionError = g, g;
                    }
                }
                async completeNegotiationAsync(g) {
                    this.rejectedNegotiations = 0;
                    try {
                        var _this_diagnosticsWrapper_negotiationCompleted, _this_diagnosticsWrapper;
                        const f = await this.getCurrentSession().completeNegotiationAsync(g);
                        return this.negotiationState = f, this.diagnosticsWrapper.finalAnswerTime = Date.now(), (_this_diagnosticsWrapper_negotiationCompleted = (_this_diagnosticsWrapper = this.diagnosticsWrapper).negotiationCompleted) === null || _this_diagnosticsWrapper_negotiationCompleted === void 0 ? void 0 : _this_diagnosticsWrapper_negotiationCompleted.call(_this_diagnosticsWrapper, f.activeModalities), await this.reconnectManager.onNegotiationCompletedAsync(g), this.sessionOperationQueue.completeCurrentOperation(), this.negotiationState;
                    } catch (g) {
                        throw this.diagnosticsWrapper.sessionError = g, g;
                    }
                }
                ignoreNotReconnectError(g) {
                    var _g_detail;
                    return ((_g_detail = g.detail) === null || _g_detail === void 0 ? void 0 : _g_detail.type) !== Gt.MEDIA_ERROR.incompatibleOriginator;
                }
                async rejectNegotiationAsync(g, f) {
                    this.logger.safe.info(`[${f}] rejectNegotiationAsync`, g);
                    try {
                        if (this.reconnectManager.isReconnecting() && this.ignoreNotReconnectError(g)) return await this.reconnectManager.onNegotiationRejection(g, f), this.registerNegotiationRejection(this.negotiationState), this.sessionOperationQueue.completeCurrentOperation(), this.negotiationState;
                        {
                            const S = await this.getCurrentSession().rejectNegotiationAsync(g, f, this.isRenegotiationAllowed(g.type));
                            return this.sessionOperationQueue.completeCurrentOperation(), this.registerNegotiationRejection(S), S;
                        }
                    } catch (g) {
                        throw this.diagnosticsWrapper.sessionError = g, g;
                    }
                }
                completeEscalationAsync(g) {
                    return this.reconnectManager.completeReconnect(g);
                }
                rejectEscalationAsync(g) {
                    return this.reconnectManager.rejectReconnect(g);
                }
                async terminate(g, f) {
                    this.logger.safe.info(`terminate reject reason: ${JSON.stringify(f || "")}`), this.registerVideoEffectsTelemetryEvent(this.deviceManager.effectsManager.getStats("Video", "StatsQuery")), this.registerAudioEffectsTelemetryEvent(this.deviceManager.effectsManager.getStats("Audio")), this.statistics.setPermissionStates(await this.deviceManager.getKnownPermissionStates()), this.diagnosticsWrapper.terminated(f);
                    const always = ()=>this.cleanUp();
                    return this.reconnectManager.terminateAsync(g).then(always, always);
                }
                async getStatsAsync(g) {
                    var _this_diagnostics;
                    return this.configProvider.config.diagnostics.useForTelemetry ? (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.telemetryReport : this.getMainSession().getStatsAsync(g).then((g)=>this.prepareStats(g));
                }
                getLastKnownStats(g = !1) {
                    var _this_diagnostics;
                    return this.configProvider.config.diagnostics.useForTelemetry ? (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.telemetryReport : this.prepareStats(this.getMainSession().getLastKnownStats(g), g);
                }
                getCallTechnicalInfo() {
                    var _this_diagnostics;
                    return (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.realtimeTelemetryReport;
                }
                async createAnswerAsync(g, f) {
                    try {
                        const S = await this.getCurrentSession().createAnswerAsync(g, f);
                        return this.updateSelectedDevices(), S.mediaLegId = this.mediaLegId.process(S.mediaLegId), this.diagnosticsWrapper.mediaLegId = this.mediaLegId, S;
                    } catch (g) {
                        throw this.diagnosticsWrapper.sessionError = g, g;
                    }
                }
                configureModalitiesAsync(g, f, S) {
                    return forOwn(g, (f, S)=>{
                        f || delete g[S];
                    }), this.reconnectManager.configureModalitiesAsync(g, f, S);
                }
                getAllowedModalities() {
                    return this.deviceManager.getAllowedModalities();
                }
                createRemoteRenderer(g) {
                    return this.getMainSession().createRemoteRenderer(g);
                }
                async sendDtmf(g) {
                    try {
                        const f = await this.getMainSession().sendDtmf(g);
                        return this.diagnosticsWrapper.dtmfResult = !0, f;
                    } catch (g) {
                        throw this.diagnosticsWrapper.dtmfResult = !1, g;
                    }
                }
                canSendDtmf() {
                    return this.reconnectManager.canSendDtmf();
                }
                muteHold(g, f) {
                    this.reconnectManager.muteHold(g, f);
                }
                muteInputAsync(g) {
                    return this.callMuteState = !0, this.diagnosticsWrapper.swMute = !0, this.ufdManager.setSwMute(!0), this.lastMuteFromPranswer = !1, this.reconnectManager.muteInputAsync(g);
                }
                unmuteInputAsync(g) {
                    return this.callMuteState = !1, this.diagnosticsWrapper.swMute = !1, this.ufdManager.setSwMute(!1), this.lastMuteFromPranswer = !1, this.reconnectManager.unmuteInputAsync(g);
                }
                muteOutputAsync(g) {
                    return this.diagnosticsWrapper.speakerMute = !0, this.reconnectManager.muteOutputAsync(g);
                }
                unmuteOutputAsync(g) {
                    return this.diagnosticsWrapper.speakerMute = !1, this.reconnectManager.unmuteOutputAsync(g);
                }
                async getSpeakerVolume(g) {
                    return this.reconnectManager.getSpeakerVolume(g);
                }
                async setSpeakerVolume(g, f) {
                    return this.reconnectManager.setSpeakerVolume(g, f);
                }
                getAcceptedTypes() {
                    return this.reconnectManager.getCurrentSession().getAcceptedTypes();
                }
                useNullAudioStreamClient() {
                    this.getCurrentSession().useNullAudioStreamClient();
                }
                createAudioElement(g) {
                    this.getCurrentSession().createAudioElement(g);
                }
                getIncomingRawAudioStream(g) {
                    return this.diagnosticsWrapper.registerRawMediaAccess("audio", "recv", !0), this.getCurrentSession().getIncomingRawAudioStream(g);
                }
                getUnmixedAudioProvider() {
                    return this.getCurrentSession().getUnmixedAudioProvider();
                }
                deviceSelectionChanged() {
                    this.updateSelectedDevices(), this.reconnectManager._deviceSelectionChanged();
                }
                registerDeviceTelemetryEvent(g) {
                    this.getCurrentSession().onDeviceEvent(g), this.statistics.registerDeviceTelemetryEvent(g);
                }
                registerVideoEffectsTelemetryEvent(g) {
                    this.statistics.registerVideoEffectsTelemetryEvent(g);
                }
                registerAudioEffectsTelemetryEvent(g) {
                    this.statistics.registerAudioEffectsTelemetryEvent(g);
                }
                reconnectAsync(g, f = !1, S) {
                    return this.reconnectManager.reconnectAsync(g, !0, f, S);
                }
                isReconnecting() {
                    return this.reconnectManager.isReconnecting();
                }
                getRelayManager() {
                    var _this_relayManager;
                    return (_this_relayManager = this.relayManager) !== null && _this_relayManager !== void 0 ? _this_relayManager : this.relayManager = new uT(this.context.maContext.getRelayManager(), this.diagnosticsWrapper);
                }
                getSessionConfig() {
                    return this.reconnectManager.getCurrentSession().getSessionConfig();
                }
                getDiagnostics() {
                    return this.diagnostics;
                }
                getLocalMediaTrackId(g) {
                    return this.reconnectManager.getMainSession().getLocalMediaTrackId(g);
                }
                getSubscriptionManager() {
                    return this.getCurrentSession().getSubscriptionManager();
                }
                getDisabledModalities() {
                    return this.getCurrentSession().getDisabledModalities();
                }
                configureSpatialAudio(g, f) {
                    this.getCurrentSession().configureSpatialAudio(g, f);
                }
                setParticipantSpatialAudioPositions(g, f) {
                    this.getCurrentSession().setParticipantSpatialAudioPositions(g, f);
                }
                startMediaDescriptionsUpdateAsync(g, f) {
                    return this.getCurrentSession().startMediaDescriptionsUpdateAsync(g, f);
                }
                completeMediaDescriptionsUpdateAsync(g) {
                    return this.getCurrentSession().completeMediaDescriptionsUpdateAsync(g);
                }
                rejectMediaDescriptionsUpdateAsync(g, f) {
                    return this.getCurrentSession().rejectMediaDescriptionsUpdateAsync(g, f);
                }
                processNotification(g, f) {
                    this.getCurrentSession().processNotification(g, f);
                }
                getMediaControlPlaneInstance() {
                    return this.getCurrentSession().getMediaControlPlaneInstance();
                }
                async cleanUp() {
                    this.callback = null, this.deviceManagerDisposables.forEach((g)=>g.dispose()), this.ufdManagerDisposable.dispose(), this.reconnectManager.dispose(), this.pcClosedInfo = null, document.removeEventListener("visibilitychange", this.visibilityChangedHandler), window.clearInterval(this.realtimeTelemetryInterval), this.wakeLock && (await this.wakeLock.release(), this.wakeLock = null);
                }
                updateSelectedDevices() {
                    const g = this.deviceManager.getSelectedDevices(), getDeviceName = (g)=>g ? this.deviceManager.getDeviceNameAsync(g).then((g)=>scrubDeviceLabelPii(g, this.configProvider.config.devices.piiSafeWords)) : Promise.resolve("none");
                    Promise.all([
                        getDeviceName(g.microphone),
                        getDeviceName(g.speaker),
                        getDeviceName(g.camera)
                    ]).then(([g, f, S])=>{
                        this.statistics.setUsedDevices({
                            microphone: g,
                            speaker: f,
                            camera: S
                        });
                    });
                }
                getCurrentSession() {
                    return this.reconnectManager.getCurrentSession();
                }
                getMainSession() {
                    return this.reconnectManager.getMainSession();
                }
                setAudioStreamState(g, f, S) {
                    this.isAudioStateValid(g) ? this.raiseAudioStateChanged(g, f, S) : this.logger.safe.error(`[${f}] audio state transition is invalid: ${this.audioStreamState} -> ${g}`);
                }
                isAudioStateValid(g) {
                    return this.audioStreamStates[this.audioStreamState].indexOf(g) >= -1;
                }
                raiseAudioStateChanged(g, f, S) {
                    if (this.logger.safe.info(`[${f}] audio state changed to ${g}`), this.callback.onAudioStateChanged) {
                        const f = {
                            content: "audio",
                            direction: "receive",
                            stream: g
                        };
                        this.callback.onAudioStateChanged(f, S);
                    }
                }
                getReconnectManagerCallbacks() {
                    return {
                        onSessionErrorOccurred: (g, f, S)=>{
                            this.isNetworkMediaError(g) && !S && this.ufdManager.raisePendingWhitelistingUFD(), this.endCallOnFailure(g, f);
                        }
                    };
                }
                isNetworkMediaError(g) {
                    return g.type === Gt.MEDIA_ERROR.iceConnectionError || g.type === Gt.MEDIA_ERROR.noNetworkError;
                }
                isRecoverableMediaError(g) {
                    return this.recoverableErrors.includes(g.type);
                }
                startReconnect(g = generateCauseId()) {
                    return this.reconnectManager.onIceDisconnect(g);
                }
                shouldForceReconnect(g) {
                    return this.forceReconnectErrors.includes(g.type);
                }
                isUnexpectedPcClose(g) {
                    return g.type === Gt.MEDIA_ERROR.unexpectedClose;
                }
                getSessionCallbacks() {
                    return this.sessionCallbacks || (this.sessionCallbacks = {
                        onTerminated: ()=>{
                            this.logger.safe.warn("call onTerminated"), this.event("onTerminated").raise(this);
                        },
                        onSessionErrorOccurred: (g, f = generateCauseId())=>this.isUnexpectedPcClose(g) ? this.handlePcClosed(g, f) : this.shouldForceReconnect(g) ? this.reconnectManager.reconnectAsync(f, !0) : this.isRecoverableMediaError(g) ? this.reconnectManager.isReconnecting() ? this.reconnectManager.onSessionErrorOccurred(g, f) : this.startReconnect(f) : (this.endCallOnFailure(g, f), Promise.resolve()),
                        onNegotiationRequired: (g, f)=>this.callback.onNegotiationRequired(g, f),
                        onAudioHwSilentChanged: (g)=>{
                            this.diagnosticsWrapper.hwSilent = g;
                        },
                        onAudioStateChanged: (g, f)=>{
                            this.setAudioStreamState(g, f);
                        },
                        onTransportConnected: (g = generateCauseId())=>{
                            var _this_callback;
                            this.logger.safe.info(`[${g}] Transport connectivity established`), this.ufdManager.cancelPendingWhitelistingUFD(), this.reconnectManager.onConnected(g), this.diagnosticsWrapper.registerTransportConnected(), this.diagnosticsWrapper.iceConnectedStateTimestamp = Date.now(), (_this_callback = this.callback) === null || _this_callback === void 0 ? void 0 : _this_callback.onTransportConnected(g);
                        },
                        onTransportDisconnected: (g = generateCauseId())=>{
                            var _this_callback_onTransportDisconnected, _this_callback;
                            this.logger.safe.warn(`[${g}] Transport connectivity lost`), this.reconnectManager.onTransportDisconnect(g), this.diagnosticsWrapper.registerTransportDisconnected(), (_this_callback = this.callback) === null || _this_callback === void 0 ? void 0 : (_this_callback_onTransportDisconnected = _this_callback.onTransportDisconnected) === null || _this_callback_onTransportDisconnected === void 0 ? void 0 : _this_callback_onTransportDisconnected.call(_this_callback, g);
                        },
                        onTransportFailed: ()=>{
                            var _this_callback_onTransportFailed, _this_callback;
                            this.diagnosticsWrapper.registerTransportFailed(), (_this_callback = this.callback) === null || _this_callback === void 0 ? void 0 : (_this_callback_onTransportFailed = _this_callback.onTransportFailed) === null || _this_callback_onTransportFailed === void 0 ? void 0 : _this_callback_onTransportFailed.call(_this_callback);
                        },
                        onTransportInitialized: ()=>{
                            this.diagnosticsWrapper.iceInitTime = Date.now();
                        },
                        onUpdateMediaDescriptionsRequired: (g, f)=>this.callback.onUpdateMediaDescriptionsRequired(g, f),
                        onTeamsRealtimeTelemetryReport: ()=>this.callback.onRealtimeTelemetryReport()
                    }), this.sessionCallbacks;
                }
                registerNegotiationRejection(g) {
                    var _this_diagnosticsWrapper_negotiationRejected, _this_diagnosticsWrapper;
                    this.rejectedNegotiations++, (_this_diagnosticsWrapper_negotiationRejected = (_this_diagnosticsWrapper = this.diagnosticsWrapper).negotiationRejected) === null || _this_diagnosticsWrapper_negotiationRejected === void 0 ? void 0 : _this_diagnosticsWrapper_negotiationRejected.call(_this_diagnosticsWrapper), g.rollback && this.diagnosticsWrapper.registerRollbackEvent(g.rollback);
                }
                isRenegotiationAllowed(g) {
                    return this.rejectedNegotiations < this.context.configProvider.config.renegotiationAttempts && !this.reconnectManager.isReconnectScheduled && (Gt.RENEGOTIATION_ERROR.signaling === g || Gt.RENEGOTIATION_ERROR.media === g);
                }
                prepareStats(g, f = !1) {
                    var _this_diagnostics_telemetryReport, _this_diagnostics, _g_data_Extensions, _this_diagnostics_telemetryReport1, _this_diagnostics1;
                    this.statistics.setDeviceList(this.deviceManager.getDeviceDescriptions(), this.deviceManager.getDeviceListDebugInfo()), this.statistics.setRelayManagerTimers(this.getRelayManager().getStats()), this.statistics.setVideoEffectStats(this.context.callDeviceManager.getDeviceManager("Video").effectsManager.getStats("Video", "StatsQuery")), this.statistics.setAudioEffectStats(this.deviceManager.effectsManager.getStats("Audio"));
                    const S = this.statistics.generateStatistics(g, this.mediaLegId, f);
                    return this.configProvider.config.diagnostics.features.useNewerStatisticsMetrics && (S.data.metrics = (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : (_this_diagnostics_telemetryReport = _this_diagnostics.telemetryReport) === null || _this_diagnostics_telemetryReport === void 0 ? void 0 : _this_diagnostics_telemetryReport.data.metrics), !((_g_data_Extensions = g.data.Extensions) === null || _g_data_Extensions === void 0 ? void 0 : _g_data_Extensions.StartTime) && this.configProvider.config.diagnostics.features.useFallbackToNewExtensions && (S.data.Extensions = (_this_diagnostics1 = this.diagnostics) === null || _this_diagnostics1 === void 0 ? void 0 : (_this_diagnostics_telemetryReport1 = _this_diagnostics1.telemetryReport) === null || _this_diagnostics_telemetryReport1 === void 0 ? void 0 : _this_diagnostics_telemetryReport1.data.Extensions), S;
                }
                deviceListChanged(g) {
                    g && this.statistics.deviceChangedByPoll(), this.statistics.devicesChanged(), this.statistics.setDevicesCount(this.deviceManager.getDevicesCount());
                }
                qualityChanged(g) {
                    var _this_context_getSmallCallTelemetry, _this_callback;
                    const f = g.deviceManagerId;
                    !f || this.context.callDeviceManager.hasDevice(f) ? ((_this_context_getSmallCallTelemetry = this.context.getSmallCallTelemetry()) === null || _this_context_getSmallCallTelemetry === void 0 ? void 0 : _this_context_getSmallCallTelemetry.setEventType(g.type), ((_this_callback = this.callback) === null || _this_callback === void 0 ? void 0 : _this_callback.onQualityChanged) && (this.diagnosticsWrapper.registerQualityStateChangedEvent(g), "DeviceSpeakWhileMuted" === g.type && (this.diagnosticsWrapper.isSpeaking = "Good" !== g.value), this.callback.onQualityChanged(g))) : this.logger.info(`${f} - is not added to Call, skipping UFD.`);
                }
                endCallOnFailure(g, f, S) {
                    this.callback && (this.callback.onSessionErrorOccurred && this.callback.onSessionErrorOccurred(g, f), this.diagnosticsWrapper.sessionError = g, this.setAudioStreamState(Gt.STREAMING_STATE.failed, f, S));
                }
                async handlePcClosed(g, f) {
                    const S = this.configProvider.config.reconnectWakeupTimeLimit;
                    return this.logger.safe.info(`[${f}] handle unexpected PC closed event`, `visibilityState=${document.visibilityState}, wakeupLimit=${this.configProvider.config.reconnectWakeupTimeLimit}`), "visible" === document.visibilityState ? this.startReconnect(f) : S ? void (this.pcClosedInfo = {
                        timestamp: Date.now(),
                        causeId: f,
                        mediaError: g
                    }) : this.endCallOnFailure(g, f, "suspended");
                }
                constructor(g, f, S, v, _, C, E, T = S.getLogger().createChild("SessionV2", f)){
                    super(T), this.context = S, this.callback = v, this.statistics = _, this.configProvider = C, this.diagnostics = E, this.logger = T, this.audioStreamStates = {
                        [Gt.STREAMING_STATE.inactive]: [
                            Gt.STREAMING_STATE.started,
                            Gt.STREAMING_STATE.active,
                            Gt.STREAMING_STATE.failed
                        ],
                        [Gt.STREAMING_STATE.started]: [
                            Gt.STREAMING_STATE.active,
                            Gt.STREAMING_STATE.removed,
                            Gt.STREAMING_STATE.stopped,
                            Gt.STREAMING_STATE.failed
                        ],
                        [Gt.STREAMING_STATE.active]: [
                            Gt.STREAMING_STATE.removed,
                            Gt.STREAMING_STATE.stopped,
                            Gt.STREAMING_STATE.failed
                        ]
                    }, this.mediaLegId = new dT, this.rejectedNegotiations = 0, this.negotiationState = null, this.audioStreamState = Gt.STREAMING_STATE.inactive, this.deviceManagerDisposables = [], this.visibilityChangedHandler = ()=>{
                        var _this_context_getSmallCallTelemetry;
                        if (this.logger.safe.debug(`document.visibilityState changed: ${document.visibilityState}`), "visible" === document.visibilityState && this.pcClosedInfo) {
                            const g = this.pcClosedInfo;
                            this.pcClosedInfo = null, Date.now() < g.timestamp + this.configProvider.config.reconnectWakeupTimeLimit ? (this.logger.safe.info(`[${g.causeId}] start reconnect after wakeup`), this.startReconnect(g.causeId)) : (this.logger.safe.info(`[${g.causeId}] terminate a call after wakeup because allowed time limit for reconnect exceeded`), this.endCallOnFailure(g.mediaError, g.causeId));
                        }
                        "hidden" === document.visibilityState && ((_this_context_getSmallCallTelemetry = this.context.getSmallCallTelemetry()) === null || _this_context_getSmallCallTelemetry === void 0 ? void 0 : _this_context_getSmallCallTelemetry.setEventType("visibilityHidden"));
                    }, this.ufdManager = S.getUfdManager(), this.ufdManagerDisposable = this.ufdManager.on("onQualityChanged", (g)=>this.qualityChanged(g)), this.sessionOperationQueue = new ST(this.logger), this.mediaLegId = new dT, this.diagnosticsWrapper = new fT(this.statistics, this.diagnostics), this.statistics.setId(f), this.diagnosticsWrapper.mediaLegId = this.mediaLegId, this.diagnosticsWrapper.ETag = this.configProvider.ETag, this.diagnosticsWrapper.configIds = this.configProvider.ecsConfigIds, this.diagnosticsWrapper.isMultiParty = !!S.config.isConference, this.recoverableErrors = this.configProvider.config.recoverableMediaErrors.split(","), this.forceReconnectErrors = this.configProvider.config.forceReconnectErrors.split(",");
                    const I = this.getSessionCallbacks();
                    g.callbacks = I, g.relayManagerProvider = this, this.reconnectManager = new mT(g, S, new hT(this.statistics, this.diagnostics ? new cT : void 0, this.diagnostics), this.sessionOperationQueue, this.getReconnectManagerCallbacks(), I, this.configProvider, this.getRelayManager()), this.deviceManager = this.context.callDeviceManager.getDefaultDeviceManager(), this.deviceManagerDisposables.push(this.deviceManager.on("onDevicesPermissionChanged", ()=>this.diagnosticsWrapper.allowedModalities = this.getAllowedModalities())), this.deviceManagerDisposables.push(this.deviceManager.on("onSelectedDevicesChanged", ()=>this.deviceSelectionChanged())), this.deviceManagerDisposables.push(this.deviceManager.on("onDevicesChanged", (g, f)=>this.deviceListChanged(f))), this.statistics.setDevicesCount(this.deviceManager.getDevicesCount()), this.diagnostics && (this.diagnostics.relayManager = this.getRelayManager()), this.ufdManager.applyCurrentState((g)=>this.qualityChanged(g)), document.addEventListener("visibilitychange", this.visibilityChangedHandler), this.requestWakeLock();
                }
            }, _T = class {
                getReport() {
                    return this.records.length ? JSON.stringify(this.records) : "";
                }
                isReconnecting() {
                    return this.reconnectState;
                }
                onReconnectStart() {
                    this.reconnectState = !0, this.activeRecord || (this.activeRecord = {
                        attempts: [],
                        endTime: null,
                        startTime: Date.now() - this.creationTime
                    }, this.records.push(this.activeRecord));
                }
                onReconnectAttempt(g) {
                    if (!this.activeRecord) return null;
                    this.activeAttempt = {
                        direction: g,
                        status: !1,
                        endTime: null,
                        startTime: this.getTimestamp()
                    }, this.reconnectState = !0, this.activeRecord.attempts.push(this.activeAttempt);
                }
                onReconnectConnected() {
                    if (!this.activeRecord) return null;
                    this.reconnectState = !1, this.activeRecord.endTime = this.getTimestamp(), this.activeRecord = this.activeAttempt = null;
                }
                onReconnectCompleted() {
                    this.reconnectState = !1, this.resolveReconnectAttempt(!0);
                }
                onReconnectRejected() {
                    this.resolveReconnectAttempt(!1);
                }
                resolveReconnectAttempt(g) {
                    this.activeAttempt && this.activeRecord && (this.activeAttempt.status = g, this.activeAttempt.endTime = this.getTimestamp());
                }
                getTimestamp() {
                    return Date.now() - this.creationTime - this.activeRecord.startTime;
                }
                constructor(g){
                    this.creationTime = g, this.records = [], this.activeRecord = null, this.activeAttempt = null, this.reconnectState = !1;
                }
            }, CT = window.navigator, yT = class {
                updateLevel(g) {
                    this.currentLevel !== g && (this.getStopWatch(this.currentLevel).stop(), this.currentLevel = g, this.getStopWatch(this.currentLevel).start());
                }
                getCount(g) {
                    const f = this.stopWatches[g];
                    return f ? f.count : 0;
                }
                getElapsed(g) {
                    const f = this.stopWatches[g];
                    return f ? f.elapsed : 0;
                }
                getStopWatch(g) {
                    let f = this.stopWatches[g];
                    return f || (f = new QE, this.stopWatches[g] = f), f;
                }
                constructor(g = "Good"){
                    this.stopWatches = [], this.currentLevel = g, this.getStopWatch(g).start();
                }
            }, ET = RegExp(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\:[0-9]{2,5})?$/), TT = RegExp(/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))(:[0-9]{2,5})?$/), IT = class {
                terminated(g) {
                    this.terminationReason = deepClone(g), this.terminationTime = Date.now(), this.durationTimer.stop(), this.osMute.stop(), this.swMute.stop(), this.hwSilent.stop(), this.isSpeaking.stop(), this.mute.stop(), this.speakerMute.stop(), this.rawInputAudioOverride.timer.stop(), this.rawOutputAudioAccess.timer.stop(), clearInterval(this.navigatorConnectionInterval);
                }
                setMultiParty() {
                    this.multiParty = !0;
                }
                updateCommonMute() {
                    this.swMute.isRunning || this.osMute.isRunning ? this.mute.start() : this.mute.stop();
                }
                setDeviceList(g, f) {
                    this.deviceList = g.map((g)=>({
                            label: scrubDeviceLabelPii(g.label, this.configProvider.config.devices.piiSafeWords),
                            kind: g.kind
                        })), f && (this.deviceDebugStrings = deepClone(f));
                }
                setPermissionStates(g) {
                    this.permissionStates = g;
                }
                setSwMute(g) {
                    g ? this.swMute.start() : this.swMute.stop(), this.updateCommonMute();
                }
                setSpeakerMute(g) {
                    g ? this.speakerMute.start() : this.speakerMute.stop();
                }
                setHwSilent(g) {
                    g ? this.hwSilent.start() : this.hwSilent.stop();
                }
                setSpeakingState(g) {
                    g ? this.isSpeaking.start() : this.isSpeaking.stop();
                }
                setETag(g) {
                    this.ETag = g;
                }
                setConfigIds(g) {
                    this.configIds = g;
                }
                setVideoEffectStats(g) {
                    g && this.videoEffectsTelemetryEvents.add(g);
                }
                setAudioEffectStats(g) {
                    g && this.audioEffectsTelemetryEvents.add(g);
                }
                registerQualityStateChangedEvent(g) {
                    switch(g.type){
                        case "NoNetwork":
                            "Good" === g.value ? this.noIceCandidatesGoodEventCount++ : this.noIceCandidatesBadEventCount++;
                            break;
                        case "NetworkRelaysNotReachable":
                            "Good" === g.value ? this.noRelayIceCandidatesGoodEventCount++ : this.noRelayIceCandidatesBadEventCount++;
                            break;
                        case "DeviceCaptureNotFunctioning":
                            "Good" === g.value ? this.microphoneInUseGoodEventCount++ : this.microphoneInUseBadEventCount++;
                            break;
                        case "VideoCapturerDeviceStartFailed":
                            "Good" === g.value ? this.cameraInUseGoodEventCount++ : this.cameraInUseBadEventCount++;
                            break;
                        case "DeviceCaptureMute":
                            "Audio" === g.mediaType && ("Bad" === g.value ? this.osMute.start() : this.osMute.stop(), this.updateCommonMute());
                            break;
                        case "NetworkRecvQuality":
                            this.networkRecv.updateLevel(g.value);
                            break;
                        case "NetworkSendQuality":
                            this.networkSend.updateLevel(g.value);
                            break;
                        case "VideoCaptureDeviceFreeze":
                            "Good" === g.value ? this.cameraFreezeEndEventCount++ : this.cameraFreezeStartEventCount++;
                    }
                    "DeviceSpeakWhileMuted" !== g.type && this.ufds.push({
                        ...g,
                        timestamp: Date.now() - this.creationTime
                    }), this.ufds.length > this.configProvider.config.maxStoredUFDCount && this.ufds.shift();
                }
                registerRemoteQualityStateChangedEvent(g, f) {
                    arrayLimitedPush2(this.remoteUfds, {
                        ...g,
                        participantId: f,
                        timestamp: Date.now()
                    }, this.configProvider.config.diagnostics.collectionLimits.numUFDs);
                }
                registerRetargetIncoming() {
                    this.retargetIncomingCount++;
                }
                registerRetargetOutgoing() {
                    this.retargetOutgoingCount++;
                }
                registerRetargetCompleted() {
                    this.retargetCompletedCount++;
                }
                registerRetargetRejected() {
                    this.retargetRejectedCount++;
                }
                registerEscalationStart() {
                    this.escalationAttemptedCount++;
                }
                registerEscalationCompleted() {
                    this.escalationCompletedCount++;
                }
                registerEscalationRejected() {
                    this.escalationRejectedCount++;
                }
                registerRollbackEvent(g) {
                    g && this.rollbackNegotiation.push({
                        type: g.type,
                        attempt: this.rollbackNegotiation.length + 1,
                        error: g.error ? g.error : ""
                    });
                }
                registerReconnectAttempted() {
                    this.reconnectAttemptedCount++, this.reconnectStats.onReconnectStart();
                }
                registerReconnectConnected() {
                    this.reconnectConnectedCount++, this.reconnectStats.onReconnectConnected();
                }
                registerDeviceTelemetryEvent(g) {
                    g.timestamp = g.timestamp - this.creationTime, this.deviceTelemetryEvents.push(g);
                }
                registerVideoEffectsTelemetryEvent(g) {
                    g && (g.timestamp = g.timestamp - this.creationTime, this.videoEffectsTelemetryEvents.add(g));
                }
                registerAudioEffectsTelemetryEvent(g) {
                    if (g) {
                        g.timestamp = g.timestamp - this.creationTime;
                        const f = this.audioEffectsTelemetryEvents.items.pop();
                        f && this.audioEffectsChanged(f, g) && this.audioEffectsTelemetryEvents.add(f), this.audioEffectsTelemetryEvents.add(g);
                    }
                }
                audioEffectsChanged(g, f) {
                    return g.payload.fallback !== f.payload.fallback || void 0 !== f.payload.userNoiseSuppressionMethod && g.payload.userNoiseSuppressionMethod !== f.payload.userNoiseSuppressionMethod || void 0 !== f.payload.userAudioEffect && g.payload.userAudioEffect !== f.payload.userAudioEffect;
                }
                registerReconnectAttempt(g) {
                    this.reconnectStats.onReconnectAttempt(g);
                }
                registerReconnectAttemptCompleted() {
                    this.reconnectStats.onReconnectCompleted();
                }
                registerReconnectAttemptRejected() {
                    this.reconnectStats.onReconnectRejected();
                }
                setMediaLegId(g) {
                    this.mediaLegId = g;
                }
                setId(g) {
                    this.sessionId = g;
                }
                setError(g) {
                    g.type === Gt.MEDIA_ERROR.incompatibleOffer && (this.incompatibleOffer = !0), this.mediaError.type = g.type || Gt.MEDIA_ERROR.internalError, this.mediaError.detail = g.detail || g.toString();
                }
                setRelay(g) {
                    this.relay = {
                        address: g.addresses.join(),
                        expires: g.expires,
                        realm: g.realm,
                        credentials: !(!g.username || !g.password),
                        ports: [
                            g.udpPort ? `udp:${g.udpPort}` : "",
                            g.tcpPort ? `tcp:${g.tcpPort}` : "",
                            g.tlsPort ? `tls:${g.tlsPort}` : ""
                        ].join(","),
                        fqdns: g.fqdns ? g.fqdns.join() : "none"
                    };
                }
                setRelayManagerTimers(g) {
                    this.relayManagerTimers = g;
                }
                setSendModalities(g) {
                    this.allowedAudioSend = g.audio.some((g)=>hasSendDirectionality(g)), this.allowedVideoSend = g.video.some((g)=>hasSendDirectionality(g)), this.allowedScreensharingSend = g.sharing.some((g)=>hasSendDirectionality(g));
                }
                setIceInitTimestamp(g) {
                    this.iceInitTime || (this.iceInitTime = g);
                }
                setFinalAnswerTimestamp(g) {
                    this.finalAnswerTime || (this.finalAnswerTime = g);
                }
                setIceConnectedStateTimestamp(g) {
                    this.iceConnectedStateTime || (this.iceConnectedStateTime = g);
                }
                dtmfResult(g) {
                    g ? ++this.dtmfSuccess : ++this.dtmfFailure;
                }
                setUsedDevices(g) {
                    this.usedDevices && JSON.stringify(g) !== JSON.stringify(this.usedDevices) && this.deviceSelectionChangeCount++, this.usedDevices = g;
                }
                setDevicesCount(g) {
                    this.devicesCount = g;
                }
                setMediaQosEnabled(g) {
                    this.mediaQosEnabled = g;
                }
                setPortRangeConfigured(g) {
                    this.portRangeConfigured = g;
                }
                devicesChanged() {
                    this.devicesChangeCount++;
                }
                deviceChangedByPoll() {
                    this.devicesPollChangeCount++;
                }
                registerOutputRawMediaAccess() {
                    this.rawOutputAudioAccess.attempt++, this.rawOutputAudioAccess.timer.start();
                }
                registerSetInputRawMedia(g) {
                    this.rawInputAudioOverride.attempt++, g ? this.rawInputAudioOverride.timer.start() : this.rawInputAudioOverride.timer.stop();
                }
                getReport() {
                    var _this_sessionDiagnostics_getObjectRef_reconnect, _this_sessionDiagnostics, _CT_connection, _this_sessionDiagnostics1;
                    const g = this.usedDevices || {
                        microphone: "none",
                        speaker: "none",
                        camera: "none"
                    };
                    return {
                        RawOutputAudioAccessDurationRatio: this.getDurationRatio(this.rawOutputAudioAccess.timer.elapsed),
                        RawOutputAudioAccessAttempted: this.rawOutputAudioAccess.attempt,
                        RawInputAudioOverrideDurationRatio: this.getDurationRatio(this.rawInputAudioOverride.timer.elapsed),
                        RawInputAudioOverrideAttempted: this.rawInputAudioOverride.attempt,
                        SessionId: this.sessionId,
                        CallNumber: this.callNumber,
                        NoIceCandidatesBadEventCount: this.noIceCandidatesBadEventCount,
                        NoIceCandidatesGoodEventCount: this.noIceCandidatesGoodEventCount,
                        NoRelayIceCandidatesBadEventCount: this.noRelayIceCandidatesBadEventCount,
                        NoRelayIceCandidatesGoodEventCount: this.noRelayIceCandidatesGoodEventCount,
                        CameraInUseBadEventCount: this.cameraInUseBadEventCount,
                        CameraInUseGoodEventCount: this.cameraInUseGoodEventCount,
                        MicrophoneInUseBadEventCount: this.microphoneInUseBadEventCount,
                        MicrophoneInUseGoodEventCount: this.microphoneInUseGoodEventCount,
                        CameraFreezeStartEventCount: this.cameraFreezeStartEventCount,
                        CameraFreezeEndEventCount: this.cameraFreezeEndEventCount,
                        RetargetIncomingCount: this.retargetIncomingCount,
                        RetargetOutgoingCount: this.retargetOutgoingCount,
                        RetargetCompletedCount: this.retargetCompletedCount,
                        RetargetRejectedCount: this.retargetRejectedCount,
                        ReconnectAttemptedCount: this.reconnectAttemptedCount,
                        ReconnectConnectedCount: this.reconnectConnectedCount,
                        EscalationAttemptedCount: this.escalationAttemptedCount,
                        EscalationCompletedCount: this.escalationCompletedCount,
                        EscalationRejectedCount: this.escalationRejectedCount,
                        CreationTime: this.getHpTimeFromMillis(this.creationTime),
                        InitTime: this.getHpTimeFromMillis(this.creationTime),
                        TerminationTime: this.getHpTimeFromMillis(this.terminationTime),
                        CallDuration: this.getHpTimeFromMillis(this.getCurrentDuration()),
                        InitialNegotiationType: this.initialNegotiationType || "none",
                        InitialNegotiationCompleted: this.initialNegotiationCompleted,
                        ActiveModalities: JSON.stringify(this.activeModalities),
                        NegotiationCount: this.negotiationCount,
                        RejectedNegotiationCount: this.rejectedNegotiationCount,
                        MediaLegId: this.mediaLegId,
                        MultiParty: this.multiParty,
                        ErrorType: this.mediaError.type,
                        ErrorDetail: this.mediaError.detail,
                        TerminationReason: this.terminationReason,
                        IncompatibleOffer: this.incompatibleOffer,
                        DtmfSuccess: this.dtmfSuccess,
                        DtmfFailure: this.dtmfFailure,
                        Relay: this.relay ? JSON.stringify(this.relay) : "none",
                        RelayManager: this.relayManagerTimers ? JSON.stringify(this.relayManagerTimers) : "none",
                        AllowedAudioSend: this.allowedAudioSend,
                        AllowedVideoSend: this.allowedVideoSend,
                        AllowedScreensharingSend: this.allowedScreensharingSend,
                        IceInitTime: this.getHpTimeFromMillis(this.iceInitTime),
                        FinalAnswerTime: this.getHpTimeFromMillis(this.finalAnswerTime),
                        IceConnectedStateTime: this.getHpTimeFromMillis(this.iceConnectedStateTime),
                        UsedMicrophone: g.microphone,
                        UsedSpeaker: g.speaker,
                        UsedCamera: g.camera,
                        DeviceSelectionChangeCount: this.deviceSelectionChangeCount,
                        DevicesChangeCount: this.devicesChangeCount,
                        DevicesPollChangeCount: this.devicesPollChangeCount,
                        DevicesCount: this.devicesCount ? JSON.stringify(this.devicesCount) : "none",
                        ETag: this.ETag || "",
                        ConfigIds: this.configIds ? Array.isArray(this.configIds) ? this.configIds.join(",") : this.configIds : "",
                        CallMutedRatio: this.getDurationRatio(this.mute.elapsed),
                        CallOsMuted: this.getHpTimeFromMillis(this.osMute.elapsed),
                        CallHwSilent: this.getHpTimeFromMillis(this.hwSilent.elapsed),
                        CallSwMuted: this.getHpTimeFromMillis(this.swMute.elapsed),
                        CallSpeakerMuted: this.getHpTimeFromMillis(this.speakerMute.elapsed),
                        CallIsSpeaking: this.getHpTimeFromMillis(this.isSpeaking.elapsed),
                        NetworkRecvGood: this.networkRecv.getCount("Good") - 1,
                        NetworkRecvPoor: this.networkRecv.getCount("Poor"),
                        NetworkRecvBad: this.networkRecv.getCount("Bad"),
                        NetworkSendGood: this.networkSend.getCount("Good") - 1,
                        NetworkSendPoor: this.networkSend.getCount("Poor"),
                        NetworkSendBad: this.networkSend.getCount("Bad"),
                        NetworkRecvGoodRatio: this.getDurationRatio(this.networkRecv.getElapsed("Good")),
                        NetworkRecvPoorRatio: this.getDurationRatio(this.networkRecv.getElapsed("Poor")),
                        NetworkRecvBadRatio: this.getDurationRatio(this.networkRecv.getElapsed("Bad")),
                        NetworkSendGoodRatio: this.getDurationRatio(this.networkSend.getElapsed("Good")),
                        NetworkSendPoorRatio: this.getDurationRatio(this.networkSend.getElapsed("Poor")),
                        NetworkSendBadRatio: this.getDurationRatio(this.networkSend.getElapsed("Bad")),
                        DeviceEvents: JSON.stringify(this.deviceTelemetryEvents),
                        DeviceList: JSON.stringify(this.deviceList),
                        DeviceListDebug: JSON.stringify(this.deviceDebugStrings),
                        VideoEffects: JSON.stringify(this.videoEffectsTelemetryEvents.items),
                        AudioEffects: JSON.stringify(this.audioEffectsTelemetryEvents.items),
                        PermissionStates: JSON.stringify(this.permissionStates),
                        ReconnectAttempts: this.reconnectStats.getReport(),
                        NetworkEvents: JSON.stringify(rebaseTime(limitArraySize2((_this_sessionDiagnostics = this.sessionDiagnostics) === null || _this_sessionDiagnostics === void 0 ? void 0 : (_this_sessionDiagnostics_getObjectRef_reconnect = _this_sessionDiagnostics.getObjectRef().reconnect) === null || _this_sessionDiagnostics_getObjectRef_reconnect === void 0 ? void 0 : _this_sessionDiagnostics_getObjectRef_reconnect.tmpRecords, this.configProvider.config.diagnostics.telemetryLimits.numNetworkEvents), "startTime", this.creationTime)),
                        ReconnectInProgress: this.reconnectStats.isReconnecting(),
                        TransportReconnectedCount: this.transportReconnectedCount,
                        UFDs: JSON.stringify(this.ufds),
                        remoteUFDs: JSON.stringify(this.remoteUfds),
                        MediaQosEnabled: this.mediaQosEnabled,
                        PortRangeConfigured: this.portRangeConfigured,
                        RollbackNegotiation: JSON.stringify(this.rollbackNegotiation),
                        hardwareConcurrency: ss.hardwareConcurrency,
                        GPUName: ss.unmaskedGlRenderer,
                        Connection_Downlink: sampleseries(this.connectionDownlinkSeries.items, (g)=>g),
                        Connection_EffectiveType: sampleseries(this.connectionEffectiveTypeSeries.items, (g)=>g),
                        Connection_Rtt: sampleseries(this.connectionRttSeries.items, (g)=>g),
                        Connection_SaveData: CT === null || CT === void 0 ? void 0 : (_CT_connection = CT.connection) === null || _CT_connection === void 0 ? void 0 : _CT_connection.saveData,
                        MediaByPassEnabled: !!this.configProvider.mediaConfig.mediaBypassEnabled,
                        CallConstraints: JSON.stringify(this.configProvider.getCallConstraintsTelemetry()),
                        DominantSpeaker: JSON.stringify(generateDominantSpeakerReport((_this_sessionDiagnostics1 = this.sessionDiagnostics) === null || _this_sessionDiagnostics1 === void 0 ? void 0 : _this_sessionDiagnostics1.getObjectRef().dominantSpeaker, this.terminationTime))
                    };
                }
                generateStatistics(g, f, S = !1) {
                    var _this_sessionDiagnostics;
                    if (this.setMediaLegId(f.process()), "WebRtcMediaStats" !== g.type) throw new Error(`Unknown stats type - ${g.type}`);
                    if (S) {
                        const g = this.deviceTelemetryEvents.length;
                        this.deviceTelemetryEvents.splice(0, g - 1), this.deviceDebugStrings = dC, this.audioEffectsTelemetryEvents.clear();
                    }
                    g.data.metrics = this.getReport();
                    const v = (_this_sessionDiagnostics = this.sessionDiagnostics) === null || _this_sessionDiagnostics === void 0 ? void 0 : _this_sessionDiagnostics.getObjectRef().statsErrors;
                    if (v === null || v === void 0 ? void 0 : v.length) {
                        var _g_data_Extensions_WebRTCStats, _g_data_Extensions;
                        if ((_g_data_Extensions = g.data.Extensions) === null || _g_data_Extensions === void 0 ? void 0 : (_g_data_Extensions_WebRTCStats = _g_data_Extensions.WebRTCStats) === null || _g_data_Extensions_WebRTCStats === void 0 ? void 0 : _g_data_Extensions_WebRTCStats.statsErrors) {
                            const f = JSON.parse(g.data.Extensions.WebRTCStats.statsErrors);
                            f.push(...v), g.data.Extensions.WebRTCStats.statsErrors = JSON.stringify(f);
                        } else g.data.Extensions.WebRTCStats.statsErrors = JSON.stringify(v);
                    }
                    const _ = {};
                    return forOwnRec(g.data, (g, f, S)=>{
                        let v = 0;
                        ET.test(g) ? (v = 13, _[f] = "IPv4") : TT.test(g) && (v = 4, _[f] = "IPv6"), S[f] = {
                            type: v,
                            value: g,
                            __VALUE__: !0
                        };
                    }), g.data.metrics.piiFields = {
                        type: 0,
                        value: JSON.stringify(_),
                        __VALUE__: !0
                    }, g;
                }
                registerTransportConnected() {
                    this.transportDisconnected && (this.transportDisconnected = !1, this.transportReconnectedCount++);
                }
                registerTransportDisconnected() {
                    this.transportDisconnected = !0;
                }
                registerTransportFailed() {
                    this.transportDisconnected = !1;
                }
                resetError() {
                    this.setError({
                        type: "none",
                        detail: "none"
                    });
                }
                offering() {
                    return {
                        started: ()=>{
                            this.currentNegotiationType = "Offering", this.negotiationStarted();
                        }
                    };
                }
                answering() {
                    return {
                        started: ()=>{
                            this.currentNegotiationType = "Answering", this.negotiationStarted();
                        }
                    };
                }
                negotiationStarted() {
                    this.initialNegotiationType = this.initialNegotiationType || this.currentNegotiationType, ++this.negotiationCount;
                }
                current() {
                    return {
                        completed: (g)=>{
                            this.initialNegotiationCompleted = !0, this.activeModalities = g, this.resetError();
                        },
                        rejected: ()=>{
                            ++this.rejectedNegotiationCount;
                        }
                    };
                }
                getDurationRatio(g) {
                    const f = this.getCurrentDuration();
                    return g / (0 !== f ? f : 1);
                }
                getCurrentDuration() {
                    return this.durationTimer.elapsed;
                }
                getHpTimeFromMillis(g) {
                    return 1e4 * g;
                }
                constructor(g, f, S){
                    this.configProvider = g, this.callNumber = f, this.sessionDiagnostics = S, this.negotiation = {
                        offering: this.offering(),
                        answering: this.answering(),
                        current: this.current()
                    }, this.creationTime = Date.now(), this.negotiationCount = 0, this.initialNegotiationCompleted = !1, this.activeModalities = {}, this.multiParty = !1, this.noIceCandidatesGoodEventCount = 0, this.noIceCandidatesBadEventCount = 0, this.noRelayIceCandidatesGoodEventCount = 0, this.noRelayIceCandidatesBadEventCount = 0, this.cameraInUseBadEventCount = 0, this.cameraInUseGoodEventCount = 0, this.microphoneInUseBadEventCount = 0, this.microphoneInUseGoodEventCount = 0, this.cameraFreezeStartEventCount = 0, this.cameraFreezeEndEventCount = 0, this.networkRecv = new yT, this.networkSend = new yT, this.retargetIncomingCount = 0, this.retargetOutgoingCount = 0, this.retargetCompletedCount = 0, this.retargetRejectedCount = 0, this.reconnectAttemptedCount = 0, this.reconnectConnectedCount = 0, this.escalationAttemptedCount = 0, this.escalationCompletedCount = 0, this.escalationRejectedCount = 0, this.durationTimer = new QE, this.terminationReason = {}, this.terminationTime = 0, this.sessionId = "0", this.rejectedNegotiationCount = 0, this.mediaError = {
                        type: "none",
                        detail: "none"
                    }, this.incompatibleOffer = !1, this.dtmfSuccess = 0, this.dtmfFailure = 0, this.relay = null, this.relayManagerTimers = null, this.allowedAudioSend = !0, this.allowedVideoSend = !0, this.allowedScreensharingSend = !0, this.iceInitTime = 0, this.finalAnswerTime = 0, this.iceConnectedStateTime = 0, this.usedDevices = null, this.deviceSelectionChangeCount = 0, this.devicesChangeCount = 0, this.devicesPollChangeCount = 0, this.mute = new QE, this.osMute = new QE, this.hwSilent = new QE, this.isSpeaking = new QE, this.swMute = new QE, this.speakerMute = new QE, this.deviceTelemetryEvents = [], this.videoEffectsTelemetryEvents = new Fv(this.configProvider.config.effectsTelemetryBufferSize), this.audioEffectsTelemetryEvents = new Fv(this.configProvider.config.effectsTelemetryBufferSize), this.devicesCount = null, this.reconnectStats = new _T(this.creationTime), this.transportDisconnected = !1, this.transportReconnectedCount = 0, this.ufds = [], this.remoteUfds = [], this.mediaQosEnabled = !1, this.portRangeConfigured = !1, this.rollbackNegotiation = [], this.rawOutputAudioAccess = {
                        attempt: 0,
                        timer: new QE
                    }, this.rawInputAudioOverride = {
                        attempt: 0,
                        timer: new QE
                    }, this.connectionEffectiveTypeSeries = new Fv(this.configProvider.config.navConnectionNumSamplesToCollect), this.connectionRttSeries = new Fv(this.configProvider.config.navConnectionNumSamplesToCollect), this.connectionDownlinkSeries = new Fv(this.configProvider.config.navConnectionNumSamplesToCollect), this.navigatorConnectionInterval = setInterval(()=>{
                        const g = CT === null || CT === void 0 ? void 0 : CT.connection;
                        g && ("number" == typeof g.downlink && this.connectionDownlinkSeries.add(g.downlink), "number" == typeof g.rtt && this.connectionRttSeries.add(g.rtt), "number" == typeof g.effectiveType && this.connectionEffectiveTypeSeries.add(g.effectiveType));
                    }, this.configProvider.config.navConnectionPollingInterval), this.durationTimer.start();
                }
            }, bT = class {
                setStrategy(g) {
                    var _this_dshStrategy, _this_diagnostics;
                    this.disposeStrategy(), this.dshStrategy = g, (_this_dshStrategy = this.dshStrategy) === null || _this_dshStrategy === void 0 ? void 0 : _this_dshStrategy.setOnDominantSpeakerChanged(this.onDominantSpeakerHistoryChanged.bind(this)), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.setCurrentActiveStrategy("client");
                }
                onContributingSourcesChanged(g) {
                    var _this_diagnostics, _this_dshStrategy;
                    this.onActiveSpeakersChanged(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.contributingSourcesChanged(), (_this_dshStrategy = this.dshStrategy) === null || _this_dshStrategy === void 0 ? void 0 : _this_dshStrategy.setSources(g);
                }
                onDominantSpeakerHistoryChanged(g, f) {
                    var _this_diagnostics;
                    this.onDominantSpeakersChanged(g), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.recordHistoryEvent(g, f), "client" !== f && this.dshStrategy && (this.logger.safe.info("Disposing client DSH strategy and switching to MP provided DSH"), this.disposeStrategy());
                }
                dispose() {
                    this.disposeStrategy(), this.onActiveSpeakersChanged = null, this.onDominantSpeakersChanged = null;
                }
                disposeStrategy() {
                    var _this_dshStrategy;
                    (_this_dshStrategy = this.dshStrategy) === null || _this_dshStrategy === void 0 ? void 0 : _this_dshStrategy.dispose(), this.dshStrategy = null;
                }
                constructor(g, f, S, v){
                    this.onActiveSpeakersChanged = g, this.onDominantSpeakersChanged = f, this.logger = S, this.diagnostics = v;
                }
            }, AT = class {
                add(g) {
                    this.streams.some((f)=>f.getId() === g.getId()) || (this.streams.push(g), this.listener.streamAdded(g));
                }
                remove(g) {
                    let f;
                    remove2(this.streams, (S)=>S.getId() === g && (f = S, !0)) && this.listener.streamRemoved(f);
                }
                getStreams() {
                    return this.streams;
                }
                clear() {
                    this.streams.forEach((g)=>g.dispose()), this.streams = [];
                }
                constructor(g){
                    this.listener = g, this.streams = [];
                }
            }, RT = __toESM(we()), PT = class {
                getControlItem() {
                    return this.controlItem;
                }
                setControlItem(g) {
                    this.controlItem = g;
                }
                dispose() {
                    this.controlItem = null;
                }
                setVideoControlMessage(g) {
                    this.controlItem = this.messageToControlItem(g), this.logger.safe.info(`BW limit requested to ${this.controlItem.bandwidth}`);
                }
                modifyDescriptor(g) {
                    if (!this.controlItem) return g;
                    const f = RT.parse(g.sdp);
                    if (!f.media[1]) return this.logger.unsafe.warn("video modality is disabled, skipping sdp modification, ", g), g;
                    const S = this.getCurrentResolutionBitrate();
                    this.logger.safe.info(`Select the BW limit as min of requested ${this.controlItem.bandwidth} and Current Resolution Max BR ${S}`);
                    const v = this.getSessionBitrate(f), _ = Math.min(S, this.controlItem.bandwidth, v);
                    if (f.media[1].bandwidth) f.media[1].bandwidth[0].limit = _;
                    else {
                        const g = {
                            limit: _,
                            type: "AS"
                        };
                        f.media[1].bandwidth = [
                            g
                        ];
                    }
                    return g.sdp = RT.write(f), g;
                }
                messageToControlItem(g) {
                    const f = new QC(g.controlVideoStreaming.controlInfo[0].fmtParams), S = "max-br", v = 1.2;
                    if (!f.contains(S)) return null;
                    const _ = Math.round(+f.get(S) * v);
                    return {
                        sourceId: g.controlVideoStreaming.controlInfo[0].sourceId,
                        streamMsid: g.controlVideoStreaming.controlInfo[0].streamMsid,
                        bandwidth: _
                    };
                }
                getCurrentResolutionBitrate() {
                    const g = this.qualityManager.getCurrentResolution(), f = Zt.Send.getResolutionByFs(g);
                    return g && f ? Math.floor(Zt.Send.getBitrateForResolution(f.width, f.height).maxBitrate / 1e3) : Number.MAX_VALUE;
                }
                getSessionBitrate(g) {
                    let f = Number.MAX_SAFE_INTEGER;
                    return this.configProvider.mediaConfig.maxBandwidthInKbps && (f = this.configProvider.mediaConfig.maxBandwidthInKbps), g.bandwidth && (f = Math.min(+g.bandwidth[0].limit, f)), f - (this.configProvider.config.audioBandwidthInKbps || 0);
                }
                constructor(g, f, S){
                    this.logger = g, this.qualityManager = f, this.configProvider = S;
                }
            }, wT = class {
                modifyDescriptor(g) {
                    const f = RT.parse(g.sdp);
                    return RT.parse(this.pc.localDescription.sdp).media.forEach((g, S)=>{
                        const v = f.media[S];
                        (isMediaDisabled(g) && !g.bundleOnly || !v || isMediaDisabled(v)) && (this.logger.safe.info(`Adding disabled media ${g.type}, position ${S}`), f.media[S] = disabledMedia(g.type, void 0, g.protocol, void 0));
                    }), new gE(this.configProvider).modify(f), g.sdp = RT.write(f), g;
                }
                constructor(g, f, S){
                    this.pc = g, this.configProvider = f, this.logger = S.createChild("MediaRollbackModifier");
                }
            }, MT = class {
                processStats(g) {
                    if (!g) return;
                    const f = new Set;
                    if (g.send) {
                        this.diagnostics.handlePresentationAudioInputLevel();
                        for (const S of g.send)try {
                            f.add(S.outboundRTP.id);
                            var _this_sendExtenders_get;
                            let g = (_this_sendExtenders_get = this.sendExtenders.get(S.outboundRTP.id)) !== null && _this_sendExtenders_get !== void 0 ? _this_sendExtenders_get : new NT(this.diagnostics, this.configProvider);
                            S.outboundRTP.bytesSent < g.lastBytes && (g = new NT(this.diagnostics, this.configProvider)), this.sendExtenders.set(S.outboundRTP.id, g), g.processSample(S);
                        } catch (g) {
                            this.diagnostics.addStatsError("AudioStatsProcessor:send", stringifyObject(g));
                        }
                    }
                    if (clearMap(this.sendExtenders, f), f.clear(), g.recv) for (const S of g.recv)try {
                        f.add(S.inboundRTP.id);
                        var _this_recvExtenders_get;
                        let g = (_this_recvExtenders_get = this.recvExtenders.get(S.inboundRTP.id)) !== null && _this_recvExtenders_get !== void 0 ? _this_recvExtenders_get : new OT(this.configProvider);
                        S.inboundRTP.bytesReceived < g.lastBytes && (g = new OT(this.configProvider)), this.recvExtenders.set(S.inboundRTP.id, g), g.processSample(S);
                    } catch (g) {
                        this.diagnostics.addStatsError("AudioStatsProcessor:recv", stringifyObject(g));
                    }
                    clearMap(this.recvExtenders, f);
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.recvExtenders = new Map, this.sendExtenders = new Map;
                }
            }, OT = class {
                processSample(g) {
                    let f, S, v, _, C;
                    var _this_lossRateCalculator_calculate;
                    const E = (_this_lossRateCalculator_calculate = this.lossRateCalculator.calculate(g.inboundRTP.packetsReceived, g.inboundRTP.packetsLost)) !== null && _this_lossRateCalculator_calculate !== void 0 ? _this_lossRateCalculator_calculate : 0;
                    this.lastBytes = g.inboundRTP.bytesReceived, this.bytesReceivedDiff.captureSample(g.inboundRTP.bytesReceived, g.inboundRTP.timestamp), this.totalSamplesReceivedDiff.captureSample(g.inboundRTP.totalSamplesReceived, g.inboundRTP.timestamp), this.concealedSamplesDiff.captureSample(g.inboundRTP.concealedSamples, g.inboundRTP.timestamp), this.silentConcealedSamplesDiff.captureSample(g.inboundRTP.silentConcealedSamples, g.inboundRTP.timestamp);
                    const T = this.bytesReceivedDiff.delta && 8 * this.bytesReceivedDiff.delta;
                    this.packetsDelta.captureSample(g.inboundRTP.packetsReceived, g.inboundRTP.timestamp), this.packetsLostDelta.captureSample(g.inboundRTP.packetsLost, g.inboundRTP.timestamp);
                    const I = g.inboundRTP.jitterBufferDelay && g.inboundRTP.jitterBufferEmittedCount && round(g.inboundRTP.jitterBufferDelay / g.inboundRTP.jitterBufferEmittedCount * 1e3, 0);
                    if (this.jitterAverager.captureSample(1e3 * g.inboundRTP.jitter), this.jitterBufferDelayAverager.captureSample(g.inboundRTP.jitterBufferDelay), f = this.totalSamplesReceivedDiff.delta && this.concealedSamplesDiff.delta && this.silentConcealedSamplesDiff.delta && round((this.concealedSamplesDiff.delta - this.silentConcealedSamplesDiff.delta) / this.totalSamplesReceivedDiff.delta), g.customHealerStats) {
                        g.customHealerStats.numSamplesPerFrame && (_ = g.customHealerStats.decodedSamples / g.customHealerStats.numSamplesPerFrame, C = g.customHealerStats.cngSamples / g.customHealerStats.numSamplesPerFrame), f = g.customHealerStats.healedSamples / (g.customHealerStats.decodedSamples + g.customHealerStats.healedSamples), v = g.customHealerStats.concealSamples && g.customHealerStats.concealSamples / (g.customHealerStats.decodedSamples + g.customHealerStats.healedSamples), S = g.customHealerStats.stretchSamples && g.customHealerStats.stretchSamples / (g.customHealerStats.decodedSamples + g.customHealerStats.healedSamples);
                        const E = g.customHealerStats.packetDurationInMs && g.customHealerStats.packetDurationInMs > 100 ? 100 : g.customHealerStats.packetDurationInMs;
                        this.concealedRatioAverager.captureSample(v), this.stretchedRatioAverager.captureSample(S), this.codecSwitchesTracker.captureSample(`${g.customHealerStats.pullAdspPayloadType}`), this.packetDurationTracker.captureSample(`${E}`);
                    }
                    g.extensions = {
                        lossRate: E,
                        packetsPerSecond: this.packetsDelta.delta,
                        packetsLostPerSecond: this.packetsLostDelta.delta,
                        duration: this.duration,
                        healedRatio: f,
                        jitterBufferMs: I,
                        bitrate: T || 0,
                        customHealerStats: g.customHealerStats && {
                            concealedDataRatio: v,
                            concealedDataRatioMax: this.concealedRatioAverager.maxSample,
                            stretchedDataRatio: S,
                            stretchedDataRatioMax: this.stretchedRatioAverager.maxSample,
                            numberOfDecodedFrames: _,
                            usageMetricsCodecId: this.codecSwitchesTracker.sortedDurations,
                            percentageOfPtime: this.packetDurationTracker.durationRatios,
                            pushPacketProcessingTimes: g.customHealerStats.pushProcessingTimes,
                            pullPacketProcessingTimes: g.customHealerStats.pullProcessingTimes,
                            pullProcessingTimePerStreamNumber: g.customHealerStats.pullProcessingTimePerStreamNumber,
                            pullTimings: g.customHealerStats.pullTimings,
                            cnpPushCount: g.customHealerStats.cnpPushCount,
                            cnpPullCount: g.customHealerStats.cnpPullCount,
                            numberOfCNFrames: C,
                            redPacketsCount: g.customHealerStats.redPacketsCount,
                            pullNumOfStreamsCounter: g.customHealerStats.pullNumOfStreamsCounter
                        },
                        jitterAvg: round(this.jitterAverager.avg),
                        jitterBufferDelayMs: round(this.jitterBufferDelayAverager.avg)
                    }, this.duration++;
                }
                constructor(g){
                    this.configProvider = g, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.duration = 0, this.lossRateCalculator = new Yv(this.configProvider.config.disableNormalizationToCalculatePacketLossRate), this.bytesReceivedDiff = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.totalSamplesReceivedDiff = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.concealedSamplesDiff = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.silentConcealedSamplesDiff = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsLostDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.concealedRatioAverager = new Vv, this.stretchedRatioAverager = new Vv, this.codecSwitchesTracker = new qv, this.packetDurationTracker = new qv, this.jitterAverager = new Vv, this.jitterBufferDelayAverager = new Vv, this.lastBytes = 0;
                }
            }, DT = class {
                processSample(g, f, S) {
                    const v = g[0], _ = {
                        inboundRTP: v.inboundRTP
                    };
                    if (v.transport && Object.defineProperty(_, "transport", {
                        value: v.transport,
                        configurable: !1,
                        enumerable: !1
                    }), v.codec && (_.codec = v.codec), v.track && (_.track = v.track), v.remoteOutboundRTP && (_.remoteOutboundRTP = v.remoteOutboundRTP), v.extensions) {
                        this.lossRateAverager.captureSample(v.extensions.lossRate), this.bitrateAverager.captureSample(v.extensions.bitrate), this.healedRatioAverager.captureSample(v.extensions.healedRatio), this.jitterBufferAverager.captureSample(v.extensions.jitterBufferMs), this.jitterAverager.captureSample(1e3 * v.inboundRTP.jitter), this.jitterBufferDelayAverager.captureSample(v.inboundRTP.jitterBufferDelay);
                        const g = v.inboundRTP.packetsReceived + v.inboundRTP.packetsLost;
                        _.aggregated = {
                            lossRateMax: this.lossRateAverager.maxSample,
                            lossRateAvg: this.lossRateAverager.avg,
                            networkAvgLossRate: g > 0 ? v.inboundRTP.packetsLost / g : 0,
                            packetsLostAvg: this.duration > 0 ? v.inboundRTP.packetsLost / this.duration : 0,
                            duration: this.duration,
                            bitrateAvg: round(this.bitrateAverager.avg, 0),
                            bitrateMax: round(this.bitrateAverager.maxSample, 0),
                            jitterAvg: this.jitterAverager.avg,
                            avgJitterBufferSize: this.jitterBufferAverager.avg,
                            healedRatioAvg: this.healedRatioAverager.avg,
                            healedRatioMax: this.healedRatioAverager.maxSample,
                            customHealerStats: v.extensions.customHealerStats && {
                                concealedDataRatio: v.extensions.customHealerStats.concealedDataRatio,
                                concealedDataRatioMax: v.extensions.customHealerStats.concealedDataRatioMax,
                                stretchedDataRatio: v.extensions.customHealerStats.stretchedDataRatio,
                                stretchedDataRatioMax: v.extensions.customHealerStats.stretchedDataRatioMax,
                                numberOfDecodedFrames: v.extensions.customHealerStats.numberOfDecodedFrames,
                                usageMetricsCodecId: v.extensions.customHealerStats.usageMetricsCodecId,
                                percentageOfPtime: v.extensions.customHealerStats.percentageOfPtime,
                                pushPacketProcessingTimes: v.extensions.customHealerStats.pushPacketProcessingTimes,
                                pullPacketProcessingTimes: v.extensions.customHealerStats.pullPacketProcessingTimes,
                                pullProcessingTimePerStreamNumber: v.extensions.customHealerStats.pullProcessingTimePerStreamNumber,
                                pullTimings: v.extensions.customHealerStats.pullTimings,
                                cnpPushCount: v.extensions.customHealerStats.cnpPushCount,
                                cnpPullCount: v.extensions.customHealerStats.cnpPullCount,
                                numberOfCNFrames: v.extensions.customHealerStats.numberOfCNFrames,
                                redPacketsCount: v.extensions.customHealerStats.redPacketsCount,
                                pullNumOfStreamsCounter: v.extensions.customHealerStats.pullNumOfStreamsCounter
                            }
                        }, this.duration++;
                    }
                    arrayLimitedPush2(f, _, S);
                }
                constructor(){
                    this.duration = 0, this.lossRateAverager = new Vv, this.bitrateAverager = new Vv, this.jitterBufferAverager = new Vv, this.jitterAverager = new Vv, this.jitterBufferDelayAverager = new Vv, this.healedRatioAverager = new Vv;
                }
            }, NT = class {
                processSample(g) {
                    var _g_remoteInboundRTP, _g_remoteInboundRTP1, _g_remoteInboundRTP2, _g_remoteInboundRTP3, _g_remoteInboundRTP4;
                    var _this_lossRateCalculator_calculate;
                    const f = (_this_lossRateCalculator_calculate = this.lossRateCalculator.calculate((_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsReceived, (_g_remoteInboundRTP1 = g.remoteInboundRTP) === null || _g_remoteInboundRTP1 === void 0 ? void 0 : _g_remoteInboundRTP1.packetsLost)) !== null && _this_lossRateCalculator_calculate !== void 0 ? _this_lossRateCalculator_calculate : 0;
                    this.packetsDelta.captureSample(g.outboundRTP.packetsSent, g.outboundRTP.timestamp), this.packetsLostDelta.captureSample((_g_remoteInboundRTP2 = g.remoteInboundRTP) === null || _g_remoteInboundRTP2 === void 0 ? void 0 : _g_remoteInboundRTP2.packetsLost, (_g_remoteInboundRTP3 = g.remoteInboundRTP) === null || _g_remoteInboundRTP3 === void 0 ? void 0 : _g_remoteInboundRTP3.timestamp), this.lastBytes = g.outboundRTP.bytesSent, this.bytesSendDiff.captureSample(g.outboundRTP.bytesSent, g.outboundRTP.timestamp);
                    const S = this.bytesSendDiff.delta;
                    var _g_remoteInboundRTP_roundTripTime;
                    this.rttAverager.captureSample(1e3 * ((_g_remoteInboundRTP_roundTripTime = (_g_remoteInboundRTP4 = g.remoteInboundRTP) === null || _g_remoteInboundRTP4 === void 0 ? void 0 : _g_remoteInboundRTP4.roundTripTime) !== null && _g_remoteInboundRTP_roundTripTime !== void 0 ? _g_remoteInboundRTP_roundTripTime : 0)), g.extensions = {
                        lossRate: f,
                        packetsPerSecond: this.packetsDelta.delta,
                        packetsLostPerSecond: this.packetsLostDelta.delta,
                        duration: this.duration,
                        bitrate: S ? 8 * S : 0,
                        rttAvg: round(this.rttAverager.avg),
                        callIsMuted: this.diagnostics.callIsMuted,
                        rawInputVolume: this.diagnostics.audioLevel
                    }, this.duration++;
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.duration = 0, this.lossRateCalculator = new Yv(this.configProvider.config.disableNormalizationToCalculatePacketLossRate), this.packetsDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsLostDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.bytesSendDiff = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.rttAverager = new Vv, this.lastBytes = 0;
                }
            }, kT = class {
                processSample(g, f, S) {
                    var _v_remoteInboundRTP, _v_track, _v_mediaSource;
                    const v = g[0], _ = {
                        outboundRTP: v.outboundRTP
                    };
                    var _v_track_audioLevel;
                    v.transport && Object.defineProperty(_, "transport", {
                        value: v.transport,
                        configurable: !1,
                        enumerable: !1
                    }), v.codec && (_.codec = v.codec), v.track && (_.track = v.track), v.mediaSource && (_.mediaSource = v.mediaSource), v.remoteInboundRTP && (_.remoteInboundRTP = v.remoteInboundRTP), v.extensions && (this.lossRateAverager.captureSample(v.extensions.lossRate), this.bitrateAverager.captureSample(v.extensions.bitrate), this.rttAverager.captureSample((_v_remoteInboundRTP = v.remoteInboundRTP) === null || _v_remoteInboundRTP === void 0 ? void 0 : _v_remoteInboundRTP.roundTripTime), _.aggregated = {
                        duration: this.duration,
                        lossRateMax: this.lossRateAverager.maxSample,
                        bitrateAvg: round(this.bitrateAverager.avg, 0),
                        bitrateMax: round(this.bitrateAverager.maxSample, 0),
                        rttAvg: round(this.rttAverager.avg),
                        rttMax: round(this.rttAverager.maxSample),
                        rawInputVolume: this.diagnostics.audioLevel,
                        audioLevel: (_v_track_audioLevel = (_v_track = v.track) === null || _v_track === void 0 ? void 0 : _v_track.audioLevel) !== null && _v_track_audioLevel !== void 0 ? _v_track_audioLevel : (_v_mediaSource = v.mediaSource) === null || _v_mediaSource === void 0 ? void 0 : _v_mediaSource.audioLevel
                    }, this.duration++), arrayLimitedPush2(f, _, S);
                }
                constructor(g){
                    this.diagnostics = g, this.duration = 0, this.lossRateAverager = new Vv, this.bitrateAverager = new Vv, this.rttAverager = new Vv;
                }
            }, LT = P, FT = class {
                processStats(g) {
                    if (!g) return;
                    const f = new Set;
                    if (g.send && (0, LT.flatMap)(g.send, (g)=>{
                        var _g_altLayouts;
                        return [
                            g,
                            ...(_g_altLayouts = g.altLayouts) !== null && _g_altLayouts !== void 0 ? _g_altLayouts : []
                        ];
                    }).forEach((g)=>{
                        try {
                            f.add(g.outboundRTP.id);
                            var _this_sendExtenders_get;
                            let S = (_this_sendExtenders_get = this.sendExtenders.get(g.outboundRTP.id)) !== null && _this_sendExtenders_get !== void 0 ? _this_sendExtenders_get : new VT(this.diagnostics, this.configProvider);
                            g.outboundRTP.bytesSent < S.lastBytes && (S = new VT(this.diagnostics, this.configProvider)), this.sendExtenders.set(g.outboundRTP.id, S), S.processSample(g);
                        } catch (g) {
                            this.diagnostics.addStatsError("VideoStatsProcessor:send", stringifyObject(g));
                        }
                    }), clearMap(this.sendExtenders, f), f.clear(), g.recv) for (const S of g.recv)try {
                        f.add(S.inboundRTP.id);
                        var _this_recvExtenders_get;
                        let g = (_this_recvExtenders_get = this.recvExtenders.get(S.inboundRTP.id)) !== null && _this_recvExtenders_get !== void 0 ? _this_recvExtenders_get : new xT(this.configProvider);
                        S.inboundRTP.bytesReceived < g.lastBytes && (g = new xT(this.configProvider)), this.recvExtenders.set(S.inboundRTP.id, g), g.processSample(S);
                    } catch (g) {
                        this.diagnostics.addStatsError("VideoStatsProcessor:recv", stringifyObject(g));
                    }
                    clearMap(this.recvExtenders, f);
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.recvExtenders = new Map, this.sendExtenders = new Map;
                }
            }, xT = class {
                processSample(g) {
                    var _g_track, _g_renderer, _g_mediaEntity;
                    var _this_lossRateCalculator_calculate;
                    const f = (_this_lossRateCalculator_calculate = this.lossRateCalculator.calculate(g.inboundRTP.packetsReceived, g.inboundRTP.packetsLost)) !== null && _this_lossRateCalculator_calculate !== void 0 ? _this_lossRateCalculator_calculate : 0;
                    var _g_inboundRTP_framesReceived;
                    this.framesReceivedDelta.captureSample(g.inboundRTP.framesReceived, g.inboundRTP.timestamp), this.framesDecodedDelta.captureSample(g.inboundRTP.framesDecoded, g.inboundRTP.timestamp), this.trackFramesDelta.captureSample((_g_inboundRTP_framesReceived = g.inboundRTP.framesReceived) !== null && _g_inboundRTP_framesReceived !== void 0 ? _g_inboundRTP_framesReceived : (_g_track = g.track) === null || _g_track === void 0 ? void 0 : _g_track.framesReceived, g.inboundRTP.timestamp), this.packetsDelta.captureSample(g.inboundRTP.packetsReceived, g.inboundRTP.timestamp), this.packetsLostDelta.captureSample(g.inboundRTP.packetsLost, g.inboundRTP.timestamp);
                    const S = this.framesReceivedDelta.delta, v = this.framesDecodedDelta.delta;
                    this.harmonicDecodedFps.captureSample(v), this.decodeTimeDelta.captureSample(g.inboundRTP.totalDecodeTime, g.inboundRTP.timestamp);
                    var _g_renderer_timeToFirstFrame;
                    const _ = this.decodeTimeDelta.delta && v && round(this.decodeTimeDelta.delta / v * 1e3, 2), C = v > 0 && S > 0, E = (_g_renderer_timeToFirstFrame = (_g_renderer = g.renderer) === null || _g_renderer === void 0 ? void 0 : _g_renderer.timeToFirstFrame) !== null && _g_renderer_timeToFirstFrame !== void 0 ? _g_renderer_timeToFirstFrame : C ? 0 : -1;
                    this.freezeHistogram.active = -1 !== E && -1 !== this.prevTimeToFirstFrame && !C, "sharing" === ((_g_mediaEntity = g.mediaEntity) === null || _g_mediaEntity === void 0 ? void 0 : _g_mediaEntity.modality) && this.configProvider.config.diagnostics.features.useTwoSampleVBSSFreezeDetection && (this.freezeHistogram.active = this.freezeHistogram.active && !this.hasPrevFramerate), this.prevTimeToFirstFrame = E, this.hasPrevFramerate = C, this.lastBytes = g.inboundRTP.bytesReceived, this.bytesReceivedDelta.captureSample(g.inboundRTP.bytesReceived, g.inboundRTP.timestamp);
                    var _g_inboundRTP_jitterBufferDelay;
                    const T = this.bytesReceivedDelta.delta, I = g.inboundRTP.jitterBufferEmittedCount && round(((_g_inboundRTP_jitterBufferDelay = g.inboundRTP.jitterBufferDelay) !== null && _g_inboundRTP_jitterBufferDelay !== void 0 ? _g_inboundRTP_jitterBufferDelay : 0) / g.inboundRTP.jitterBufferEmittedCount * 1e3), b = calcMacroblockRate(g.inboundRTP.frameWidth, g.inboundRTP.frameHeight, S || 0), A = calcMacroblockRate(g.inboundRTP.frameWidth, g.inboundRTP.frameHeight, v || 0);
                    this.macroblockStatsTracker.captureSample(b, A), g.extensions = {
                        lossRate: f,
                        packetsPerSecond: this.packetsDelta.delta,
                        packetsLostPerSecond: this.packetsLostDelta.delta,
                        duration: this.duration,
                        frameRateReceived: S,
                        frameRateDecoded: v,
                        trackRecvFps: this.trackFramesDelta.delta,
                        decodeTime: _ || 0,
                        jitterBufferMs: I,
                        bitrate: T ? 8 * T : 0,
                        isFrozen: this.freezeHistogram.active,
                        macroblockRateReceived: b,
                        macroblockRateDecoded: A,
                        macroblockRateStats: this.macroblockStatsTracker.getReport(),
                        longestFreeze: this.freezeHistogram.longestDuration,
                        totalFreezeDuration: this.freezeHistogram.totalDuration,
                        powerEfficient: void 0 !== g.inboundRTP.powerEfficientDecoder ? g.inboundRTP.powerEfficientDecoder : isPowerEfficient(g.inboundRTP.decoderImplementation),
                        totalFreezeFraction: this.duration ? this.freezeHistogram.totalDuration / this.duration : 0,
                        fpsHarmonicAverage: round(this.harmonicDecodedFps.harmonicMean)
                    }, this.duration++;
                }
                constructor(g){
                    this.configProvider = g, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.duration = 0, this.lossRateCalculator = new Yv(this.configProvider.config.disableNormalizationToCalculatePacketLossRate), this.bytesReceivedDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.framesReceivedDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.framesDecodedDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.trackFramesDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.decodeTimeDelta = this.useLastSampleDeltaPerSecondConverter ? new $v(2) : new Hv, this.packetsDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsLostDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.freezeHistogram = new Gv, this.harmonicDecodedFps = new Wv(this.configProvider.config.webrtcStatPollInterval * this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival, this.configProvider.config.invalidFPSAboveMax), this.prevTimeToFirstFrame = -1, this.hasPrevFramerate = !1, this.lastBytes = 0, this.macroblockStatsTracker = new e_;
                }
            }, UT = class {
                processSample(g, f, S) {
                    var _this_configProvider, _v_mediaEntity, _v_renderer, _this_codecCalculator;
                    const v = g.sort((g, f)=>f.inboundRTP.frameHeight * f.inboundRTP.frameWidth - g.inboundRTP.frameHeight * g.inboundRTP.frameWidth)[0], _ = {
                        inboundRTP: v.inboundRTP
                    };
                    var _v_inboundRTP_jitter, _v_extensions_frameRateReceived;
                    v.transport && Object.defineProperty(_, "transport", {
                        value: v.transport,
                        configurable: !1,
                        enumerable: !1
                    }), v.codec && (_.codec = v.codec, ((_this_configProvider = this.configProvider) === null || _this_configProvider === void 0 ? void 0 : _this_configProvider.config.isAv1Allowed) && "sharing" === ((_v_mediaEntity = v.mediaEntity) === null || _v_mediaEntity === void 0 ? void 0 : _v_mediaEntity.modality) && this.codecCalculator.captureSample(v.codec.mimeType, (_v_renderer = v.renderer) === null || _v_renderer === void 0 ? void 0 : _v_renderer.msi)), v.track && (_.track = v.track), v.remoteOutboundRTP && (_.remoteOutboundRTP = v.remoteOutboundRTP), v.extensions && (_.extensions = v.extensions), v.extensions && (this.harmonicDecodedFps.captureSample(v.extensions.frameRateDecoded), this.lossRateAverager.captureSample(v.extensions.lossRate), this.bitrateAverager.captureSample(v.extensions.bitrate), this.jitterAverager.captureSample(1e3 * ((_v_inboundRTP_jitter = v.inboundRTP.jitter) !== null && _v_inboundRTP_jitter !== void 0 ? _v_inboundRTP_jitter : 0)), this.frameRateAverager.captureSample((_v_extensions_frameRateReceived = v.extensions.frameRateReceived) !== null && _v_extensions_frameRateReceived !== void 0 ? _v_extensions_frameRateReceived : v.extensions.frameRateDecoded), this.freezeHistogram.active = v.extensions.isFrozen, v.inboundRTP.frameWidth && v.inboundRTP.frameHeight && this.resolutionDurations.captureSample(`${v.inboundRTP.frameWidth}x${v.inboundRTP.frameHeight}`), _.aggregated = {
                        lossRateMax: this.lossRateAverager.maxSample,
                        duration: this.duration,
                        avgFrameRate: round(this.frameRateAverager.avg),
                        fpsHarmonicAverage: round(this.harmonicDecodedFps.harmonicMean),
                        avgJitterBufferSize: round(this.jitterAverager.avg),
                        bitrateAvg: round(this.bitrateAverager.avg, 0),
                        bitrateMax: round(this.bitrateAverager.maxSample, 0),
                        bitrateMinNonZero: round(this.bitrateAverager.minNonZeroSample, 0),
                        ongoingFreezeDuration: this.freezeHistogram.ongoingDuration,
                        numFreezes: this.freezeHistogram.numEvents,
                        avgFreezeDuration: round(this.freezeHistogram.avgDuration),
                        longestFreeze: this.freezeHistogram.longestDuration,
                        totalFreezeDuration: this.freezeHistogram.totalDuration,
                        freezeCountHistogram: this.freezeHistogram.counts,
                        freezeTimestampsHistogram: this.freezeHistogram.timestamps,
                        numResolutionSwitches: this.resolutionDurations.changeCount,
                        resolutionDurations: this.resolutionDurations.durations,
                        resolutionDurationRatios: this.resolutionDurations.durationRatios,
                        macroblockRateStats: v.extensions.macroblockRateStats,
                        codecReport: (_this_codecCalculator = this.codecCalculator) === null || _this_codecCalculator === void 0 ? void 0 : _this_codecCalculator.report
                    }, this.duration++), arrayLimitedPush2(f, _, S);
                }
                constructor(g){
                    this.configProvider = g, this.duration = 0, this.lossRateAverager = new Vv, this.bitrateAverager = new Vv, this.jitterAverager = new Vv, this.frameRateAverager = new Vv, this.freezeHistogram = new Gv, this.harmonicDecodedFps = new Wv(this.configProvider.config.webrtcStatPollInterval * this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival, this.configProvider.config.invalidFPSAboveMax), this.resolutionDurations = new qv, this.codecCalculator = new t_;
                }
            }, VT = class {
                processSample(g) {
                    var _g_remoteInboundRTP, _g_remoteInboundRTP1, _g_remoteInboundRTP2, _g_remoteInboundRTP3, _g_remoteInboundRTP4, _g_mediaSource, _g_mediaEntity, _this_diagnostics_deviceManager;
                    const f = this.lossRateCalculator.calculate((_g_remoteInboundRTP = g.remoteInboundRTP) === null || _g_remoteInboundRTP === void 0 ? void 0 : _g_remoteInboundRTP.packetsReceived, (_g_remoteInboundRTP1 = g.remoteInboundRTP) === null || _g_remoteInboundRTP1 === void 0 ? void 0 : _g_remoteInboundRTP1.packetsLost);
                    this.lossRateAverager.captureSample(f), this.plisDelta.captureSample(g.outboundRTP.pliCount), this.pliRate.captureSample(this.plisDelta.delta), this.packetsDelta.captureSample(g.outboundRTP.packetsSent, g.outboundRTP.timestamp), this.packetsLostDelta.captureSample((_g_remoteInboundRTP2 = g.remoteInboundRTP) === null || _g_remoteInboundRTP2 === void 0 ? void 0 : _g_remoteInboundRTP2.packetsLost, (_g_remoteInboundRTP3 = g.remoteInboundRTP) === null || _g_remoteInboundRTP3 === void 0 ? void 0 : _g_remoteInboundRTP3.timestamp), this.lastBytes = g.outboundRTP.bytesSent, this.bytesSendDelta.captureSample(g.outboundRTP.bytesSent, g.outboundRTP.timestamp);
                    const S = this.bytesSendDelta.delta, v = S ? 8 * S : void 0;
                    var _g_remoteInboundRTP_roundTripTime;
                    this.bitrateAverager.captureSample(v), this.rttAverager.captureSample(1e3 * ((_g_remoteInboundRTP_roundTripTime = (_g_remoteInboundRTP4 = g.remoteInboundRTP) === null || _g_remoteInboundRTP4 === void 0 ? void 0 : _g_remoteInboundRTP4.roundTripTime) !== null && _g_remoteInboundRTP_roundTripTime !== void 0 ? _g_remoteInboundRTP_roundTripTime : 0)), this.encodedFramesDelta.captureSample(g.outboundRTP.framesEncoded, g.outboundRTP.timestamp);
                    const _ = this.encodedFramesDelta.delta;
                    this.sentFramesDelta.captureSample(g.outboundRTP.framesSent, g.outboundRTP.timestamp);
                    const C = this.sentFramesDelta.delta || 0;
                    this.harmonicEncodedFps.captureSample(_);
                    const E = (_g_mediaSource = g.mediaSource) === null || _g_mediaSource === void 0 ? void 0 : _g_mediaSource.framesPerSecond;
                    0 === E && void 0 !== this.lastCaptureFramerate && this.lastCaptureFramerate > 0 && this.captureFreezeIntervalsCount++, this.lastCaptureFramerate = E;
                    const T = _ > 0 && C > 0;
                    this.freezeHistogram.active = !T, "sharing" === ((_g_mediaEntity = g.mediaEntity) === null || _g_mediaEntity === void 0 ? void 0 : _g_mediaEntity.modality) && this.configProvider.config.diagnostics.features.useTwoSampleVBSSFreezeDetection && (this.freezeHistogram.active = this.freezeHistogram.active && !this.hasPrevFramerate), this.hasPrevFramerate = T, this.encodeTimeDelta.captureSample(g.outboundRTP.totalEncodeTime, g.outboundRTP.timestamp);
                    const I = this.encodeTimeDelta.delta && _ && round(this.encodeTimeDelta.delta / _ * 1e3, 2);
                    this.qpDelta.captureSample(g.outboundRTP.qpSum, g.outboundRTP.timestamp);
                    const b = this.qpDelta.delta && _ && round(this.qpDelta.delta / _, 2);
                    g.outboundRTP.frameWidth && g.outboundRTP.frameHeight && this.resolutionSwitcherTracker.captureSample(g.outboundRTP.frameWidth, g.outboundRTP.frameHeight);
                    var _g_appliedCapabilities;
                    const A = (_this_diagnostics_deviceManager = this.diagnostics.deviceManager) === null || _this_diagnostics_deviceManager === void 0 ? void 0 : _this_diagnostics_deviceManager.latestCameraOpenResolution, R = (_g_appliedCapabilities = g.appliedCapabilities) !== null && _g_appliedCapabilities !== void 0 ? _g_appliedCapabilities : g.requestedCapabilities;
                    R && (void 0 !== g.outboundRTP.frameHeight && void 0 !== g.outboundRTP.frameWidth && this.fsOvershoot.captureSample(g.outboundRTP.frameHeight / 16 * (g.outboundRTP.frameWidth / 16), R.maxFs), this.fpsOvershoot.captureSample(C, R.maxFps), R.maxBr && this.brOvershoot.captureSample(v, R.maxBr));
                    const P = [
                        ...this.fsOvershoot.events,
                        ...this.brOvershoot.events,
                        ...this.fpsOvershoot.events
                    ];
                    P.sort((g, f)=>g.timestamp - f.timestamp), g.extensions = {
                        cameraOpenResolution: A,
                        lossRate: f,
                        packetsPerSecond: this.packetsDelta.delta,
                        packetsLostPerSecond: this.packetsLostDelta.delta,
                        duration: this.duration,
                        pliRate: this.pliRate.getRate(),
                        frameRateEncoded: this.encodedFramesDelta.delta,
                        frameRateSent: C,
                        bitrate: v || 0,
                        encodeTime: I || 0,
                        qp: b || 0,
                        isFrozen: this.freezeHistogram.active,
                        longestFreeze: this.freezeHistogram.longestDuration,
                        totalFreezeDuration: this.freezeHistogram.totalDuration,
                        ongoingFreezeDuration: this.freezeHistogram.ongoingDuration,
                        freezeCountHistogram: this.freezeHistogram.counts,
                        captureFreezeIntervalsCount: this.captureFreezeIntervalsCount,
                        isFsOvershooting: this.fsOvershoot.isOvershooting,
                        isFpsOvershooting: this.fpsOvershoot.isOvershooting,
                        isBrOvershooting: this.brOvershoot.isOvershooting,
                        totalFsOvershootDuration: this.fsOvershoot.totalDuration,
                        totalFpsOvershootDuration: this.fpsOvershoot.totalDuration,
                        totalBrOvershootDuration: this.brOvershoot.totalDuration,
                        overshootEvents: P,
                        powerEfficient: void 0 !== g.outboundRTP.powerEfficientEncoder ? g.outboundRTP.powerEfficientEncoder : isPowerEfficient(g.outboundRTP.encoderImplementation),
                        bitrateAvg: round(this.bitrateAverager.avg, 0),
                        rttAvg: round(this.rttAverager.avg)
                    }, this.duration++;
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.duration = 0, this.lossRateCalculator = new Yv(this.configProvider.config.disableNormalizationToCalculatePacketLossRate), this.lossRateAverager = new Vv, this.freezeHistogram = new Gv, this.hasPrevFramerate = !1, this.captureFreezeIntervalsCount = 0, this.bytesSendDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.encodedFramesDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.sentFramesDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.packetsLostDelta = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.harmonicEncodedFps = new Wv(this.configProvider.config.webrtcStatPollInterval * this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival, this.configProvider.config.invalidFPSAboveMax), this.encodeTimeDelta = this.useLastSampleDeltaPerSecondConverter ? new $v(2) : new Hv, this.qpDelta = this.useLastSampleDeltaPerSecondConverter ? new $v(3) : new Hv, this.fsOvershoot = new Jv("fs"), this.fpsOvershoot = new Jv("fps", 1), this.brOvershoot = new Jv("br"), this.plisDelta = new Hv, this.pliRate = new Xv(60), this.resolutionSwitcherTracker = new Zv(this.configProvider.config.diagnostics.collectionLimits.numResolutionSwitches), this.bitrateAverager = new Vv, this.rttAverager = new Vv, this.lastBytes = 0;
                }
            }, BT = class {
                processSample(g, f, S) {
                    g.length > 1 && g.sort((g, f)=>{
                        var _g_appliedCapabilities, _f_appliedCapabilities;
                        const S = (_g_appliedCapabilities = g.appliedCapabilities) !== null && _g_appliedCapabilities !== void 0 ? _g_appliedCapabilities : g.requestedCapabilities, v = (_f_appliedCapabilities = f.appliedCapabilities) !== null && _f_appliedCapabilities !== void 0 ? _f_appliedCapabilities : f.requestedCapabilities;
                        return (S === null || S === void 0 ? void 0 : S.maxMbps) && (v === null || v === void 0 ? void 0 : v.maxMbps) ? v.maxMbps - S.maxMbps : 0;
                    });
                    const v = g[0], _ = {
                        outboundRTP: v.outboundRTP
                    };
                    if (v.transport && Object.defineProperty(_, "transport", {
                        value: v.transport,
                        configurable: !1,
                        enumerable: !1
                    }), v.codec && (_.codec = v.codec), v.track && (_.track = v.track), v.mediaSource && (_.mediaSource = v.mediaSource), v.remoteInboundRTP && (_.remoteInboundRTP = v.remoteInboundRTP), v.extensions && (_.extensions = v.extensions), v.extensions) {
                        var _v_transport_selectedCandidatePair, _v_transport, _v_remoteInboundRTP, _v_mediaSource, _v_extensions;
                        this.lossRateAverager.captureSample(v.extensions.lossRate), this.bitrateAverager.captureSample(v.extensions.bitrate), this.sendBWEAverager.captureSample((_v_transport = v.transport) === null || _v_transport === void 0 ? void 0 : (_v_transport_selectedCandidatePair = _v_transport.selectedCandidatePair) === null || _v_transport_selectedCandidatePair === void 0 ? void 0 : _v_transport_selectedCandidatePair.availableOutgoingBitrate), this.rttAverager.captureSample((_v_remoteInboundRTP = v.remoteInboundRTP) === null || _v_remoteInboundRTP === void 0 ? void 0 : _v_remoteInboundRTP.roundTripTime), this.framerateAverager.captureSample(v.extensions.frameRateSent);
                        const g = (_v_mediaSource = v.mediaSource) === null || _v_mediaSource === void 0 ? void 0 : _v_mediaSource.framesPerSecond;
                        this.captureFpsAverager.captureSample(g), 0 === g && void 0 !== this.lastCaptureFps && this.lastCaptureFps > 0 && this.captureFreezeIntervalsCount++, this.lastCaptureFps = g, v.outboundRTP.frameWidth && v.outboundRTP.frameHeight && this.resolutionDurations.captureSample(`${v.outboundRTP.frameWidth}x${v.outboundRTP.frameHeight}`);
                        var _v_appliedCapabilities;
                        const f = (_v_appliedCapabilities = v.appliedCapabilities) !== null && _v_appliedCapabilities !== void 0 ? _v_appliedCapabilities : v.requestedCapabilities;
                        f && (void 0 !== v.outboundRTP.frameHeight && void 0 !== v.outboundRTP.frameWidth && this.fsOvershoot.captureSample(v.outboundRTP.frameHeight / 16 * (v.outboundRTP.frameWidth / 16), f.maxFs), this.fpsOvershoot.captureSample(v.extensions.frameRateSent, f.maxFps), f.maxBr && this.brOvershoot.captureSample((_v_extensions = v.extensions) === null || _v_extensions === void 0 ? void 0 : _v_extensions.bitrate, f.maxBr)), this.harmonicEncodedFps.captureSample(v.extensions.frameRateEncoded);
                        const S = [
                            ...this.fsOvershoot.events,
                            ...this.fpsOvershoot.events,
                            ...this.brOvershoot.events
                        ];
                        S.sort((g, f)=>g.timestamp - f.timestamp), _.aggregated = {
                            lossRateMax: this.lossRateAverager.maxSample,
                            duration: this.duration,
                            frameRateAvg: round(this.framerateAverager.avg),
                            captureFramerateAvg: round(this.captureFpsAverager.avg),
                            fpsHarmonicAverage: round(this.harmonicEncodedFps.harmonicMean),
                            qpAvg: round(v.outboundRTP.qpSum / v.outboundRTP.framesSent),
                            rttAvg: round(this.rttAverager.avg),
                            bitrateAvg: round(this.bitrateAverager.avg, 0),
                            bitrateMax: round(this.bitrateAverager.maxSample, 0),
                            bitrateMinNonZero: round(this.bitrateAverager.minNonZeroSample, 0),
                            bweAvg: round(this.sendBWEAverager.avg, 0),
                            captureFreezeIntervalsCount: this.captureFreezeIntervalsCount,
                            numResolutionSwitches: this.resolutionDurations.changeCount,
                            resolutionDurations: this.resolutionDurations.durations,
                            resolutionDurationRatios: this.resolutionDurations.durationRatios,
                            isFsOvershooting: this.fsOvershoot.isOvershooting,
                            isFpsOvershooting: this.fpsOvershoot.isOvershooting,
                            isBrOvershooting: this.brOvershoot.isOvershooting,
                            totalFsOvershootDuration: this.fsOvershoot.totalDuration,
                            totalFpsOvershootDuration: this.fpsOvershoot.totalDuration,
                            totalBrOvershootDuration: this.brOvershoot.totalDuration,
                            overshootEvents: S
                        }, this.duration++;
                    }
                    arrayLimitedPush2(f, _, S);
                }
                constructor(g){
                    this.configProvider = g, this.duration = 0, this.lossRateAverager = new Vv, this.bitrateAverager = new Vv, this.sendBWEAverager = new Vv, this.rttAverager = new Vv, this.framerateAverager = new Vv, this.captureFpsAverager = new Vv, this.captureFreezeIntervalsCount = 0, this.lastCaptureFps = void 0, this.resolutionDurations = new qv, this.fsOvershoot = new Jv("fs"), this.fpsOvershoot = new Jv("fps", 1), this.brOvershoot = new Jv("br"), this.harmonicEncodedFps = new Wv(this.configProvider.config.webrtcStatPollInterval * this.configProvider.config.coeffOfValidTimeDelayBetweenFramesArrival, this.configProvider.config.invalidFPSAboveMax);
                }
            }, HT = class {
                processStats(g) {
                    const f = new Set;
                    for(const S in g)try {
                        f.add(S);
                        var _this_extenders_get;
                        const v = g[S], _ = (_this_extenders_get = this.extenders.get(v.id)) !== null && _this_extenders_get !== void 0 ? _this_extenders_get : new $T(this.configProvider, this.diagnostics);
                        this.extenders.set(v.id, _), _.processSample(v);
                    } catch (g) {
                        this.diagnostics.addStatsError("TransportStatsProcessor", stringifyObject(g));
                    }
                    clearMap(this.extenders, f);
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.extenders = new Map;
                }
            }, $T = class {
                processSample(g) {
                    var _g_selectedCandidatePair, _g_selectedCandidatePair1, _g_selectedCandidatePair2, _g_selectedCandidatePair3, _g_selectedCandidatePair4, _g_selectedCandidatePair5, _g_selectedCandidatePair6;
                    this.sendBWEAverager.captureSample((_g_selectedCandidatePair = g.selectedCandidatePair) === null || _g_selectedCandidatePair === void 0 ? void 0 : _g_selectedCandidatePair.availableOutgoingBitrate), this.recvBWEAverager.captureSample((_g_selectedCandidatePair1 = g.selectedCandidatePair) === null || _g_selectedCandidatePair1 === void 0 ? void 0 : _g_selectedCandidatePair1.availableIncomingBitrate), this.sendBW.captureSample((_g_selectedCandidatePair2 = g.selectedCandidatePair) === null || _g_selectedCandidatePair2 === void 0 ? void 0 : _g_selectedCandidatePair2.bytesSent, (_g_selectedCandidatePair3 = g.selectedCandidatePair) === null || _g_selectedCandidatePair3 === void 0 ? void 0 : _g_selectedCandidatePair3.timestamp), this.recvBW.captureSample((_g_selectedCandidatePair4 = g.selectedCandidatePair) === null || _g_selectedCandidatePair4 === void 0 ? void 0 : _g_selectedCandidatePair4.bytesReceived, (_g_selectedCandidatePair5 = g.selectedCandidatePair) === null || _g_selectedCandidatePair5 === void 0 ? void 0 : _g_selectedCandidatePair5.timestamp);
                    const f = this.sendBW.delta, S = this.recvBW.delta, v = f ? 8 * f : void 0, _ = S ? 8 * S : void 0;
                    this.sendBWAverager.captureSample(v), this.recvBWAverager.captureSample(_);
                    const C = (_g_selectedCandidatePair6 = g.selectedCandidatePair) === null || _g_selectedCandidatePair6 === void 0 ? void 0 : _g_selectedCandidatePair6.availableOutgoingBitrate;
                    C && (this.bwJumpsHistogramCollector.active = this.bwJumpsHistogramCollector.active && C < this.configProvider.config.webrtcBWJumpUpperLimit || C < this.configProvider.config.webrtcBWJumpLowerLimit), g.extensions = {
                        sendBWEAvg: round(this.sendBWEAverager.avg, 0),
                        sendBWEMax: round(this.sendBWEAverager.maxSample, 0),
                        recvBWEAvg: round(this.recvBWEAverager.avg, 0),
                        recvBWEMax: round(this.recvBWEAverager.maxSample, 0),
                        sendBitrate: v,
                        recvBitrate: _,
                        sendBWAvg: round(this.sendBWAverager.avg, 0),
                        sendBWMax: round(this.sendBWAverager.maxSample, 0),
                        recvBWAvg: round(this.recvBWAverager.avg, 0),
                        recvBWMax: round(this.recvBWAverager.maxSample, 0),
                        bwJumpsHistogram: this.bwJumpsHistogramCollector.counts,
                        reflexiveLocalIP: this.diagnostics.reflexiveLocalIP
                    };
                }
                constructor(g, f){
                    this.configProvider = g, this.diagnostics = f, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.bwJumpsHistogramCollector = new Gv, this.sendBWEAverager = new Vv, this.recvBWEAverager = new Vv, this.sendBW = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.recvBW = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.sendBWAverager = new Vv, this.recvBWAverager = new Vv;
                }
            }, jT = class {
                processStats(g) {
                    if (!g) return;
                    const f = new Set;
                    for (const S of g)try {
                        f.add(S.id);
                        var _this_extenders_get;
                        const g = (_this_extenders_get = this.extenders.get(S.id)) !== null && _this_extenders_get !== void 0 ? _this_extenders_get : new GT(this.configProvider);
                        this.extenders.set(S.id, g), g.processSample(S);
                    } catch (g) {
                        this.diagnostics.addStatsError("DataChannelStatsProcessor", stringifyObject(g));
                    }
                    clearMap(this.extenders, f);
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.extenders = new Map;
                }
            }, GT = class {
                processSample(g) {
                    this.sendBytesDeltaCalculator.captureSample(g.bytesSent, g.timestamp), this.recvBytesDeltaCalculator.captureSample(g.bytesReceived, g.timestamp);
                    const f = this.sendBytesDeltaCalculator.delta, S = this.recvBytesDeltaCalculator.delta, v = f ? 8 * f : void 0, _ = S ? 8 * S : void 0;
                    this.sendMessagesDeltaCalculator.captureSample(g.messagesSent, g.timestamp), this.recvMessagesDeltaCalculator.captureSample(g.messagesReceived, g.timestamp);
                    const C = this.sendMessagesDeltaCalculator.delta, E = this.recvMessagesDeltaCalculator.delta;
                    g.extensions = {
                        sendBitrate: v,
                        recvBitrate: _,
                        sendMessageRate: C,
                        recvMessageRate: E
                    };
                }
                constructor(g){
                    this.configProvider = g, this.useLastSampleDeltaPerSecondConverter = this.configProvider.config.diagnostics.features.useLastSampleDeltaPerSecondConverter, this.sendBytesDeltaCalculator = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.recvBytesDeltaCalculator = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.sendMessagesDeltaCalculator = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv, this.recvMessagesDeltaCalculator = this.useLastSampleDeltaPerSecondConverter ? new $v : new Hv;
                }
            }, qT = class {
                prepareCollectingStatsOnSubscribed(g) {
                    this.count = 0, this.videoStatsEvent.push({
                        ts: Date.now(),
                        framesDecoded: [],
                        bytesReceived: [],
                        height: [],
                        msi: g
                    });
                }
                captureStatsOnSubscribed(g, f, S, v) {
                    if (this.count >= this.collecVideoStatsAfterSubscription) return;
                    const _ = getLast(this.videoStatsEvent);
                    _ && (_.framesDecoded.push(g), _.bytesReceived.push(f), void 0 !== S && _.height.push(S)), this.count++;
                }
                getStatsOnSubscribed() {
                    return this.videoStatsEvent;
                }
                constructor(g){
                    this.collecVideoStatsAfterSubscription = g, this.videoStatsEvent = [], this.count = 0;
                }
            }, WT = class {
                processBandwidth(g, f, S) {
                    this.currentModality ? this.handleStopEvent(f, S) : this.handleStartEvent(f, S), this.inProcess && (this.stabilizationTime++, this.slidingWindow.add(g), this.inProcess = !this.slidingWindow.isFull || !this.isBandwidthStable());
                }
                getReport(g = !1) {
                    if (void 0 !== this.stabilizationTime) return {
                        time: this.inProcess ? this.stabilizationTime : Math.max(this.stabilizationTime - this.slidingWindowSize, 0),
                        bandwidth: g ? round(this.averageBandwidth, 2) : this.averageBandwidth,
                        finished: !this.inProcess,
                        modality: this.previousModality
                    };
                }
                handleStartEvent(g, f) {
                    this.currentModality = this.GetModalityString(g), f && this.currentModality && !this.previousModality && (this.previousModality = this.currentModality, this.stabilizationTime = 0, this.slidingWindow.clear(), this.inProcess = !0);
                }
                handleStopEvent(g, f) {
                    f && (this.directionalityCheck(g.audio) || this.directionalityCheck(g.video) || this.directionalityCheck(g.sharing)) || (this.currentModality = null, this.inProcess = !1);
                }
                GetModalityString(g) {
                    return [
                        this.directionalityCheck(g.audio) ? Gt.MODALITY.audio : null,
                        this.directionalityCheck(g.video) ? Gt.MODALITY.video : null,
                        this.directionalityCheck(g.sharing) ? Gt.MODALITY.sharing : null
                    ].filter(Boolean).join(", ");
                }
                isBandwidthStable() {
                    if (this.averageBandwidth = average(this.slidingWindow.items), this.averageBandwidth < this.minBandwidth) return !1;
                    {
                        const g = this.averageBandwidth * this.maxDeviation, f = this.averageBandwidth - g, S = this.averageBandwidth + g;
                        return this.slidingWindow.items.every((g)=>isInRange(g, f, S));
                    }
                }
                constructor(g, f, S, v){
                    this.slidingWindowSize = g, this.maxDeviation = f, this.minBandwidth = S, this.directionalityCheck = v, this.slidingWindow = new Fv(this.slidingWindowSize), this.currentModality = null, this.previousModality = null, this.inProcess = !1;
                }
            }, zT = class {
                processStats(g) {
                    var _f_reportedReceiveBandwidth, _v_selectedCandidatePair, _g_audio_send, _g_audio, _g_video_send, _g_video, _g_sharing_send, _g_sharing, _g_audio_recv, _g_audio1, _g_video_recv, _g_video1, _g_sharing_recv, _g_sharing1, _v_selectedCandidatePair1;
                    const f = this.diagnostics.getObjectRef(), S = f === null || f === void 0 ? void 0 : f.negotiation.activeModalities;
                    if (!S || !g.transports) return;
                    const v = g.transports[Object.keys(g.transports)[0]], _ = f === null || f === void 0 ? void 0 : (_f_reportedReceiveBandwidth = f.reportedReceiveBandwidth) === null || _f_reportedReceiveBandwidth === void 0 ? void 0 : _f_reportedReceiveBandwidth[f.reportedReceiveBandwidth.length - 1], C = v === null || v === void 0 ? void 0 : (_v_selectedCandidatePair = v.selectedCandidatePair) === null || _v_selectedCandidatePair === void 0 ? void 0 : _v_selectedCandidatePair.availableOutgoingBitrate, E = ((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : (_g_audio_send = _g_audio.send) === null || _g_audio_send === void 0 ? void 0 : _g_audio_send.length) > 0 || ((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length) > 0 || ((_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : (_g_sharing_send = _g_sharing.send) === null || _g_sharing_send === void 0 ? void 0 : _g_sharing_send.length) > 0, T = ((_g_audio1 = g.audio) === null || _g_audio1 === void 0 ? void 0 : (_g_audio_recv = _g_audio1.recv) === null || _g_audio_recv === void 0 ? void 0 : _g_audio_recv.length) > 0 || ((_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : (_g_video_recv = _g_video1.recv) === null || _g_video_recv === void 0 ? void 0 : _g_video_recv.length) > 0 || ((_g_sharing1 = g.sharing) === null || _g_sharing1 === void 0 ? void 0 : (_g_sharing_recv = _g_sharing1.recv) === null || _g_sharing_recv === void 0 ? void 0 : _g_sharing_recv.length) > 0;
                    this.bweType !== (f === null || f === void 0 ? void 0 : f.negotiation.bweType) && (this.bandwidthCalculator = new Qv, this.bandwidthAvg = new Vv, this.bweType = f === null || f === void 0 ? void 0 : f.negotiation.bweType);
                    const I = "REMB" === (f === null || f === void 0 ? void 0 : f.negotiation.bweType) ? "availableIncomingBitrate" : "availableOutgoingBitrate", b = v === null || v === void 0 ? void 0 : (_v_selectedCandidatePair1 = v.selectedCandidatePair) === null || _v_selectedCandidatePair1 === void 0 ? void 0 : _v_selectedCandidatePair1[I];
                    this.bandwidthCalculator.captureSample(b), this.bandwidthAvg.captureSample(b);
                    try {
                        this.uplinkStabilizationTelemetry.processBandwidth(C, S, E), this.downlinkStabilizationTelemetry.processBandwidth(_, S, T);
                    } catch (g) {
                        this.diagnostics.addStatsError("BandwidthStatsProcessor", stringifyObject(g));
                    }
                }
                getStabilizedReport(g = !1) {
                    return this.uplinkStabilizationTelemetry.getReport(g);
                }
                getDownlinkStabilizedReport(g = !1) {
                    return this.downlinkStabilizationTelemetry.getReport(g);
                }
                calculateBwPercentiles() {
                    if (!this.bandwidthCalculator.getFirst()) return;
                    const g = this.configProvider.config.bwPercentiles, f = {};
                    return g.forEach((g)=>{
                        Object.defineProperty(f, g, {
                            value: this.bandwidthCalculator.calculatePercentile(g / 100),
                            enumerable: !0
                        });
                    }), f;
                }
                getBandwidthReport() {
                    return {
                        startOfTheCall: this.bandwidthCalculator.getFirst(),
                        endOfTheCall: this.bandwidthCalculator.getLast(),
                        std: this.bandwidthCalculator.calculateStd(),
                        bwPercentiles: this.calculateBwPercentiles(),
                        avgBwe: round(this.bandwidthAvg.avg, 2)
                    };
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.uplinkStabilizationTelemetry = new WT(this.configProvider.config.uplinkBWStabilizationSlidingWindowSize, this.configProvider.config.uplinkBWStabilizationMaxDeviation, this.configProvider.config.uplinkBWStabilizationMinBandwidth, hasSendDirectionality), this.downlinkStabilizationTelemetry = new WT(this.configProvider.config.downlinkBWStabilizationSlidingWindowSize, this.configProvider.config.downlinkBWStabilizationMaxDeviation, this.configProvider.config.downlinkBWStabilizationMinBandwidth, hasReceiveDirectionality), this.bandwidthCalculator = new Qv, this.bandwidthAvg = new Vv;
                }
            }, KT = class {
                processStats(g) {
                    var _g_video_send, _g_video, _g_sharing_send, _g_sharing;
                    if ((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length) {
                        var _f_altLayouts;
                        const f = g.video.send[0], S = [
                            f,
                            ...(_f_altLayouts = f.altLayouts) !== null && _f_altLayouts !== void 0 ? _f_altLayouts : []
                        ];
                        this.processSimulcastStream(S, this.videoSimulcastStreamsData), this.videoLayoutProcessor.processLayout(S);
                    }
                    if ((_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : (_g_sharing_send = _g_sharing.send) === null || _g_sharing_send === void 0 ? void 0 : _g_sharing_send.length) {
                        var _f_altLayouts1;
                        const f = g.sharing.send[0], S = [
                            f,
                            ...(_f_altLayouts1 = f.altLayouts) !== null && _f_altLayouts1 !== void 0 ? _f_altLayouts1 : []
                        ];
                        this.processSimulcastStream(S, this.sharingSimulcastStreamsData), this.sharingLayoutProcessor.processLayout(S);
                    }
                    this.diagnostics.simulcastReport = this.getSimulcastDiagnostics();
                }
                processSimulcastStream(g, f) {
                    const { numAggregatedSamples: S } = this.configProvider.config.diagnostics.telemetryLimits;
                    for (const v of g){
                        var _v_extensions, _v_extensions1, _v_extensions2, _v_extensions3, _v_extensions4, _v_extensions5, _v_extensions6;
                        const g = v.outboundRTP.rid;
                        if (!g) continue;
                        var _f_g;
                        (_f_g = f[g]) !== null && _f_g !== void 0 ? _f_g : f[g] = {
                            sentLayerProcessor: new QT,
                            appliedLayerProcessor: new QT,
                            requestedLayerProcessor: new QT,
                            encoderProcessor: new YT,
                            debugResolutionTracker: new qv,
                            outboundStats: [],
                            report: {
                                ssrc: v.outboundRTP.ssrc,
                                time: {
                                    requested: 0,
                                    applied: 0,
                                    sent: 0
                                },
                                duration: {
                                    requested: 0,
                                    applied: 0,
                                    sent: 0
                                },
                                restarts: {
                                    requested: 0,
                                    applied: 0,
                                    sent: 0
                                },
                                resolution: {
                                    requested: {},
                                    applied: {},
                                    sent: {}
                                },
                                framerate: {
                                    requested: {},
                                    applied: {},
                                    sent: {}
                                },
                                bitrate: {
                                    requested: {},
                                    applied: {},
                                    sent: {}
                                },
                                encoder: {},
                                stats: {},
                                overshootEvents: []
                            }
                        };
                        const _ = f[g], { sentLayer: C, requestedLayer: E, appliedLayer: T } = this.getLayers(v);
                        _.sentLayerProcessor.processLayer(C), _.appliedLayerProcessor.processLayer(T), _.requestedLayerProcessor.processLayer(E), _.encoderProcessor.processVideo(v), T && C && _.debugResolutionTracker.captureSample(`${T.width}x${T.height}:${C.width}x${C.height}`), arrayLimitedPush(_.outboundStats, v.outboundRTP, S), _.report.time.sent = _.sentLayerProcessor.getTime(), _.report.time.applied = _.appliedLayerProcessor.getTime(), _.report.time.requested = _.requestedLayerProcessor.getTime(), _.report.duration.sent = _.sentLayerProcessor.getDuration(), _.report.duration.applied = _.appliedLayerProcessor.getDuration(), _.report.duration.requested = _.requestedLayerProcessor.getDuration(), _.report.restarts.sent = _.sentLayerProcessor.getRestarts(), _.report.restarts.applied = _.appliedLayerProcessor.getRestarts(), _.report.restarts.requested = _.requestedLayerProcessor.getRestarts(), _.report.resolution.sent = _.sentLayerProcessor.getResolutionDurations(), _.report.resolution.applied = _.appliedLayerProcessor.getResolutionDurations(), _.report.resolution.requested = _.requestedLayerProcessor.getResolutionDurations(), _.report.resolution.debug = _.debugResolutionTracker.durations, _.report.framerate.sent = _.sentLayerProcessor.getFpsDurations(), _.report.framerate.applied = _.appliedLayerProcessor.getFpsDurations(), _.report.framerate.requested = _.requestedLayerProcessor.getFpsDurations(), _.report.bitrate.sent = _.sentLayerProcessor.getBitrateDurations(), _.report.bitrate.applied = _.appliedLayerProcessor.getBitrateDurations(), _.report.bitrate.requested = _.requestedLayerProcessor.getBitrateDurations(), _.report.encoder = _.encoderProcessor.getEncoderReport(), _.report.stats.fir = sampleseries(_.outboundStats, (g)=>g.firCount), _.report.stats.nack = sampleseries(_.outboundStats, (g)=>g.nackCount), _.report.stats.pli = sampleseries(_.outboundStats, (g)=>g.pliCount), _.report.stats.packetsSent = sampleseries(_.outboundStats, (g)=>g.packetsSent), _.report.overshootEvents = (_v_extensions = v.extensions) === null || _v_extensions === void 0 ? void 0 : _v_extensions.overshootEvents, _.report.totalBrOvershootDuration = (_v_extensions1 = v.extensions) === null || _v_extensions1 === void 0 ? void 0 : _v_extensions1.totalBrOvershootDuration, _.report.totalFpsOvershootDuration = (_v_extensions2 = v.extensions) === null || _v_extensions2 === void 0 ? void 0 : _v_extensions2.totalFpsOvershootDuration, _.report.totalFsOvershootDuration = (_v_extensions3 = v.extensions) === null || _v_extensions3 === void 0 ? void 0 : _v_extensions3.totalFsOvershootDuration, _.report.totalFreezeDuration = (_v_extensions4 = v.extensions) === null || _v_extensions4 === void 0 ? void 0 : _v_extensions4.totalFreezeDuration, _.report.ongoingFreezeDuration = (_v_extensions5 = v.extensions) === null || _v_extensions5 === void 0 ? void 0 : _v_extensions5.ongoingFreezeDuration, _.report.freezeHistogram = (_v_extensions6 = v.extensions) === null || _v_extensions6 === void 0 ? void 0 : _v_extensions6.freezeCountHistogram;
                    }
                }
                getSimulcastDiagnostics() {
                    if (!isEmpty(this.videoSimulcastStreamsData) || !isEmpty(this.sharingSimulcastStreamsData)) return {
                        video: {
                            streams: Object.fromEntries(Object.entries(this.videoSimulcastStreamsData).map(([g, { report: f }])=>[
                                    g,
                                    f
                                ])),
                            layouts: this.videoLayoutProcessor.getLayoutReport()
                        },
                        sharing: {
                            streams: Object.fromEntries(Object.entries(this.sharingSimulcastStreamsData).map(([g, { report: f }])=>[
                                    g,
                                    f
                                ])),
                            layouts: this.sharingLayoutProcessor.getLayoutReport()
                        }
                    };
                }
                getLayers(g) {
                    var _g_mediaEntity, _g_mediaEntity1, _g_extensions, _g_extensions1;
                    const f = g.outboundRTP.rid, S = this.diagnostics.getObjectRef().qualityManager, findCurrentCapability = (g)=>Object.values(g).find((g)=>g.rid === f), v = "sharing" === ((_g_mediaEntity = g.mediaEntity) === null || _g_mediaEntity === void 0 ? void 0 : _g_mediaEntity.modality) ? findCurrentCapability(S.currentSharingSsrcAppliedCapabilities) : findCurrentCapability(S.currentVideoSsrcAppliedCapabilities), _ = "sharing" === ((_g_mediaEntity1 = g.mediaEntity) === null || _g_mediaEntity1 === void 0 ? void 0 : _g_mediaEntity1.modality) ? findCurrentCapability(S.currentSharingSsrcRequestedCapabilities) : findCurrentCapability(S.currentVideoSsrcRequestedCapabilities);
                    return {
                        sentLayer: g.outboundRTP.frameHeight && {
                            height: g.outboundRTP.frameHeight,
                            width: g.outboundRTP.frameWidth,
                            framerate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateSent,
                            bitrate: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.bitrate
                        },
                        appliedLayer: v && convertStreamSenderParamsToLayer(v),
                        requestedLayer: _ && convertStreamSenderParamsToLayer(_)
                    };
                }
                constructor(g, f){
                    this.diagnostics = g, this.configProvider = f, this.videoSimulcastStreamsData = {}, this.videoLayoutProcessor = new JT(this.diagnostics, Gt.MODALITY.video), this.sharingSimulcastStreamsData = {}, this.sharingLayoutProcessor = new JT(this.diagnostics, Gt.MODALITY.sharing);
                }
            }, JT = class {
                processLayout(g) {
                    const getLayoutResolution = (g)=>g.filter((g)=>g.width && g.height).sort((g, f)=>g.height - f.height).map((g)=>`${g.width}x${g.height}`).join(":"), mapCapabilities = (g)=>Object.values(g).map(convertStreamSenderParamsToLayer), f = getLayoutResolution(g.map((g)=>{
                        var _g_extensions, _g_extensions1;
                        return {
                            height: g.outboundRTP.frameHeight,
                            width: g.outboundRTP.frameWidth,
                            framerate: (_g_extensions = g.extensions) === null || _g_extensions === void 0 ? void 0 : _g_extensions.frameRateSent,
                            bitrate: (_g_extensions1 = g.extensions) === null || _g_extensions1 === void 0 ? void 0 : _g_extensions1.bitrate
                        };
                    })), S = this.diagnostics.getObjectRef().qualityManager, v = "sharing" === this.modality ? S.currentSharingSsrcAppliedCapabilities : S.currentVideoSsrcAppliedCapabilities, _ = "sharing" === this.modality ? S.currentSharingSsrcRequestedCapabilities : S.currentVideoSsrcRequestedCapabilities, C = getLayoutResolution(mapCapabilities(v)), E = getLayoutResolution(mapCapabilities(_));
                    f && this.sentResolutionTracker.captureSample(f), E && this.requestedResolutionTracker.captureSample(E), C && this.appliedResolutionTracker.captureSample(C), C && f && this.debugResolutionTracker.captureSample(`${C}:${f}`);
                }
                getLayoutReport() {
                    return {
                        requested: this.requestedResolutionTracker.durations,
                        sent: this.sentResolutionTracker.durations,
                        applied: this.appliedResolutionTracker.durations,
                        debug: this.debugResolutionTracker.durations
                    };
                }
                constructor(g, f){
                    this.diagnostics = g, this.modality = f, this.sentResolutionTracker = new qv, this.requestedResolutionTracker = new qv, this.appliedResolutionTracker = new qv, this.debugResolutionTracker = new qv;
                }
            }, YT = class {
                processVideo(g) {
                    var f, S;
                    const { encoderImplementation: v, frameWidth: _, frameHeight: C, rid: E } = g.outboundRTP, { encodeTime: T } = g.extensions;
                    if (!v || !C) return;
                    const I = getEncoderName(v, E), b = `${_}x${C}`;
                    var _I;
                    (_I = (f = this.report)[I]) !== null && _I !== void 0 ? _I : f[I] = {
                        resolutionTracker: new qv,
                        encodingHistograms: {},
                        report: {
                            resolution: {},
                            encodeTime: {},
                            restarts: 0
                        }
                    };
                    const A = this.report[I];
                    var _b;
                    A.resolutionTracker.captureSample(b), (_b = (S = A.encodingHistograms)[b]) !== null && _b !== void 0 ? _b : S[b] = new qv, A.encodingHistograms[b].captureSample(bucketizeEncodeTime(T)), A.report.resolution = A.resolutionTracker.durations, A.report.encodeTime[b] = A.encodingHistograms[b].durations, this.prevEncoder && this.prevEncoder !== I && A.report.restarts++, this.prevEncoder = I;
                }
                getEncoderReport() {
                    return Object.fromEntries(Object.entries(this.report).map(([g, { report: f }])=>[
                            g,
                            f
                        ]));
                }
                constructor(){
                    this.report = {};
                }
            }, QT = class {
                processLayer(g) {
                    g ? (this.startedAt || (this.startedAt = Kt()), this.durationTracker.start(), this.resolutionTracker.captureSample(`${g.width}x${g.height}`), this.fpsTracker.captureSample(bucketizeFramerate(g.framerate)), this.bitrateTracker.captureSample(bucketizeBitrate(g.bitrate))) : this.durationTracker.stop();
                }
                getResolutionDurations() {
                    return this.resolutionTracker.durations;
                }
                getFpsDurations() {
                    return this.fpsTracker.durations;
                }
                getBitrateDurations() {
                    return this.bitrateTracker.durations;
                }
                getRestarts() {
                    return Math.max(0, this.durationTracker.count - 1);
                }
                getTime() {
                    return this.startedAt;
                }
                getDuration() {
                    return this.durationTracker.elapsed;
                }
                constructor(){
                    this.resolutionTracker = new qv, this.fpsTracker = new qv, this.bitrateTracker = new qv, this.durationTracker = new QE, this.startedAt = 0;
                }
            };
            function convertStreamSenderParamsToLayer(g) {
                const f = {
                    ...Zt.Send.getResolutionByFs(g.maxFs)
                };
                if (405 === g.maxFs) f.width = 426, f.height = 240;
                return {
                    width: f.width,
                    height: f.height,
                    framerate: g.maxFps,
                    bitrate: g.maxBr
                };
            }
            function getEncoderName(g, f) {
                if (g.startsWith("SimulcastEncoderAdapter")) {
                    const S = g.indexOf("(") + 1, v = {}, _ = g.indexOf(")");
                    var _v_f;
                    g.substring(S, _).split(",").forEach((g, f)=>{
                        v[`${f + 1}`] = g.trim();
                    }), g = (_v_f = v[f]) !== null && _v_f !== void 0 ? _v_f : "Unknown";
                }
                switch(g){
                    case "OpenH264":
                        return "H264:SW";
                    case "ExternalEncoder":
                    case "MediaFoundationVideoEncodeAccelerator":
                    case "VideoToolbox":
                    case "WMFVideoEncoder":
                    case "VTVideoEncoder":
                    case "VaapiVideoEncodeAccelerator":
                        return "H264:HW";
                    default:
                        return "H264:Other";
                }
            }
            function bucketizeBitrate(g) {
                return bucketize(g, [
                    {
                        limit: 4e6,
                        label: "4M+"
                    },
                    {
                        limit: 25e5,
                        label: "2.5M-4M"
                    },
                    {
                        limit: 15e5,
                        label: "1.5M-2.5M"
                    },
                    {
                        limit: 1e6,
                        label: "1M-1.5M"
                    },
                    {
                        limit: 8e5,
                        label: "800k-1M"
                    },
                    {
                        limit: 5e5,
                        label: "500k-800k"
                    },
                    {
                        limit: 25e4,
                        label: "250k-500k"
                    },
                    {
                        limit: 1e5,
                        label: "100k-250k"
                    },
                    {
                        limit: 5e4,
                        label: "50k-100k"
                    },
                    {
                        limit: 1e4,
                        label: "10k-50k"
                    },
                    {
                        limit: 0,
                        label: "0-10k"
                    }
                ]);
            }
            function bucketizeFramerate(g) {
                return bucketize(g, [
                    {
                        limit: 60,
                        label: "60+"
                    },
                    {
                        limit: 30,
                        label: "31-60"
                    },
                    {
                        limit: 15,
                        label: "16-30"
                    },
                    {
                        limit: 7,
                        label: "8-15"
                    },
                    {
                        limit: 3,
                        label: "4-7"
                    },
                    {
                        limit: 1,
                        label: "1-3"
                    }
                ]);
            }
            function bucketizeEncodeTime(g) {
                return bucketize(g, [
                    {
                        limit: 100,
                        label: "100+ ms"
                    },
                    {
                        limit: 30,
                        label: "30-100 ms"
                    },
                    {
                        limit: 10,
                        label: "10-30 ms"
                    },
                    {
                        limit: 5,
                        label: "5-10 ms"
                    },
                    {
                        limit: 2,
                        label: "2-5 ms"
                    },
                    {
                        limit: 1,
                        label: "1-2 ms"
                    }
                ]);
            }
            function bucketize(g, f) {
                for (const { limit: S, label: v } of f)if (g > S) return v;
                return `${g}`;
            }
            var XT = class {
                processStats(g) {
                    var _g_video_recv, _g_video;
                    this.dataChannelStatsProcessor.processStats(g.data), this.transportStatsProcessor.processStats(g.transports), this.audioStatsProcessor.processStats(g.audio), this.videoStatsProcessor.processStats(g.video), this.sharingStatsProcessor.processStats(g.sharing), this.bandwidthStatsProcessor.processStats(g), this.diagnostics.bwStabilizationTime = this.bandwidthStatsProcessor.getStabilizedReport(!0), this.diagnostics.bwDownlinkStabilizationTime = this.bandwidthStatsProcessor.getDownlinkStabilizedReport(!0), this.recvVideoStreamsCounter.captureSample((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_recv = _g_video.recv) === null || _g_video_recv === void 0 ? void 0 : _g_video_recv.length), this.diagnostics.recvVideoStreamsCount = {
                        min: this.recvVideoStreamsCounter.min,
                        max: this.recvVideoStreamsCounter.max,
                        mode: this.recvVideoStreamsCounter.mode
                    };
                    try {
                        this.processAggregated(g);
                    } catch (g) {
                        this.diagnostics.addStatsError("webrtcStatistics:processAggregated", stringifyObject(g));
                    }
                    try {
                        var _g_video1;
                        var _g_video_recv1;
                        this.processMultiview((_g_video_recv1 = (_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : _g_video1.recv) !== null && _g_video_recv1 !== void 0 ? _g_video_recv1 : []);
                    } catch (g) {
                        this.diagnostics.addStatsError("webrtcStatistics:processMultiview", stringifyObject(g));
                    }
                    try {
                        this.simulcastStatsProcessor.processStats(g);
                    } catch (g) {
                        this.diagnostics.addStatsError("webrtcStatistics:processSimulcastStats", stringifyObject(g));
                    }
                    try {
                        var _navigator;
                        const g = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.connection;
                        g && this.diagnostics.addNetworkInfo({
                            downlink: g.downlink,
                            rtt: g.rtt,
                            effectiveType: g.effectiveType,
                            saveData: g.saveData
                        });
                    } catch (g) {
                        this.diagnostics.addStatsError("webrtcStatistics:processStats(networkInfo)", stringifyObject(g));
                    }
                    try {
                        var _g_video2;
                        this.processMacroblockRateStats((_g_video2 = g.video) === null || _g_video2 === void 0 ? void 0 : _g_video2.recv);
                    } catch (g) {
                        this.diagnostics.addStatsError("webrtcStatistics: processMacroblockRateStats", stringifyObject(g));
                    }
                }
                signalNoConnection() {
                    this.transportStatsProcessor = new HT(this.diagnostics, this.configProvider), this.audioStatsProcessor = new MT(this.diagnostics, this.configProvider), this.videoStatsProcessor = new FT(this.diagnostics, this.configProvider), this.sharingStatsProcessor = new FT(this.diagnostics, this.configProvider);
                }
                processMultiview(g) {
                    const f = new Set;
                    for (const S of g){
                        var _S_renderer, _S_extensions, _S_extensions1, _S_renderer1, _S_renderer_rendererSize, _S_renderer2, _S_renderer_rendererSize1, _S_renderer3, _S_renderer4, _S_renderer5, _S_renderer6, _S_renderer7, _S_extensions2;
                        const g = S.inboundRTP.id;
                        f.add(g);
                        let v = this.multiviewData[g];
                        var _S_inboundRTP_jitter;
                        v && this.multiviewKeySet.has(g) ? v.stats.duration++ : (v = {
                            bitrateAverager: new Vv,
                            jitterAverager: new Vv,
                            frameRateAverager: new Vv,
                            freezeHistogram: new Gv,
                            resolutionDurations: new qv,
                            isRenderingEvents: [],
                            statsOnSubscribed: new qT(this.configProvider.config.diagnostics.telemetryLimits.maxVideoStatsAfterSubscription),
                            stats: {
                                ssrc: S.inboundRTP.ssrc,
                                startTime: Date.now(),
                                duration: 0,
                                framesDecoded: [],
                                bytesReceived: [],
                                height: [],
                                width: []
                            }
                        }, v.statsOnSubscribed.prepareCollectingStatsOnSubscribed((_S_renderer = S.renderer) === null || _S_renderer === void 0 ? void 0 : _S_renderer.msi), this.multiviewData[g] = v), v.statsOnSubscribed.captureStatsOnSubscribed(S.inboundRTP.framesDecoded, S.inboundRTP.bytesReceived, S.inboundRTP.frameHeight), v.bitrateAverager.captureSample((_S_extensions = S.extensions) === null || _S_extensions === void 0 ? void 0 : _S_extensions.bitrate), v.jitterAverager.captureSample(1e3 * ((_S_inboundRTP_jitter = S.inboundRTP.jitter) !== null && _S_inboundRTP_jitter !== void 0 ? _S_inboundRTP_jitter : 0)), v.frameRateAverager.captureSample(S.extensions.frameRateReceived), v.freezeHistogram.active = (_S_extensions1 = S.extensions) === null || _S_extensions1 === void 0 ? void 0 : _S_extensions1.isFrozen, S.inboundRTP.frameWidth && S.inboundRTP.frameHeight && v.resolutionDurations.captureSample(`${S.inboundRTP.frameWidth}x${S.inboundRTP.frameHeight}`);
                        var _S_renderer_isRendering;
                        const _ = (_S_renderer_isRendering = (_S_renderer1 = S.renderer) === null || _S_renderer1 === void 0 ? void 0 : _S_renderer1.isRendering) !== null && _S_renderer_isRendering !== void 0 ? _S_renderer_isRendering : !1;
                        (!v.isRenderingEvents.length && _ || v.isRenderingEvents.length && getLast(v.isRenderingEvents).isRendering !== _) && arrayLimitedPush2(v.isRenderingEvents, {
                            isRendering: _,
                            ts: Date.now()
                        }, this.configProvider.config.diagnostics.collectionLimits.numIsRenderingEvents), v.stats.frameRateAvg = round(v.frameRateAverager.avg), v.stats.bitrateAvg = round(v.bitrateAverager.avg, 0), v.stats.bitrateMax = round(v.bitrateAverager.maxSample, 0), v.stats.bitrateMinNonZero = round(v.bitrateAverager.minNonZeroSample), v.stats.freezeHistogram = v.freezeHistogram.counts, v.stats.freezeTimestamps = v.freezeHistogram.timestamps, v.stats.avgFreezeDuration = round(v.freezeHistogram.avgDuration), v.stats.totalFreezeDuration = v.freezeHistogram.totalDuration, v.stats.ongoingFreeze = v.freezeHistogram.active, v.stats.ongoingFreezeDuration = v.freezeHistogram.ongoingDuration, v.stats.numResolutionSwitches = v.resolutionDurations.changeCount, v.stats.rendererSize = `${(_S_renderer2 = S.renderer) === null || _S_renderer2 === void 0 ? void 0 : (_S_renderer_rendererSize = _S_renderer2.rendererSize) === null || _S_renderer_rendererSize === void 0 ? void 0 : _S_renderer_rendererSize.width}x${(_S_renderer3 = S.renderer) === null || _S_renderer3 === void 0 ? void 0 : (_S_renderer_rendererSize1 = _S_renderer3.rendererSize) === null || _S_renderer_rendererSize1 === void 0 ? void 0 : _S_renderer_rendererSize1.height}`, v.stats.resolutionDurations = v.resolutionDurations.durations, v.stats.timeToFirstFrame = (_S_renderer4 = S.renderer) === null || _S_renderer4 === void 0 ? void 0 : _S_renderer4.timeToFirstFrame, v.stats.timeToFirstFrameSinceSubscriptionStart = (_S_renderer5 = S.renderer) === null || _S_renderer5 === void 0 ? void 0 : _S_renderer5.timeToFirstFrameSinceSubscriptionStart, v.stats.isRenderingEvents = v.isRenderingEvents, v.stats.statsOnSubscribed = v.statsOnSubscribed.getStatsOnSubscribed(), v.stats.msi = (_S_renderer6 = S.renderer) === null || _S_renderer6 === void 0 ? void 0 : _S_renderer6.msi, v.stats.rendererStates = (_S_renderer7 = S.renderer) === null || _S_renderer7 === void 0 ? void 0 : _S_renderer7.rendererStates, arrayLimitedPush2(v.stats.framesDecoded, S.inboundRTP.framesDecoded, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples), arrayLimitedPush2(v.stats.bytesReceived, S.inboundRTP.bytesReceived, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples), arrayLimitedPush2(v.stats.height, S.inboundRTP.frameHeight, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples), arrayLimitedPush2(v.stats.width, S.inboundRTP.frameWidth, this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples);
                        var _S_extensions_macroblockRateStats;
                        const C = (_S_extensions_macroblockRateStats = (_S_extensions2 = S.extensions) === null || _S_extensions2 === void 0 ? void 0 : _S_extensions2.macroblockRateStats) !== null && _S_extensions_macroblockRateStats !== void 0 ? _S_extensions_macroblockRateStats : {};
                        for(const g in C)v.stats[g] = round(C[g], 0);
                    }
                    this.diagnostics.multiViewStats = Object.values(this.multiviewData).map((g)=>g.stats), this.multiviewKeySet = f;
                }
                processAggregated(g) {
                    for (const f of [
                        "audio",
                        "video",
                        "sharing"
                    ])if (g[f]) for(const S in g[f])this.processAggregatedModality(g, f, S);
                }
                processAggregatedModality(g, f, S) {
                    var _g_f_S, _g_f;
                    var v, _;
                    var _g_f_S_length;
                    const C = (_g_f_S_length = (_g_f = g[f]) === null || _g_f === void 0 ? void 0 : (_g_f_S = _g_f[S]) === null || _g_f_S === void 0 ? void 0 : _g_f_S.length) !== null && _g_f_S_length !== void 0 ? _g_f_S_length : 0;
                    var _f, _S;
                    C > 0 && ((_f = (v = this.aggregatedModalityStats)[f]) !== null && _f !== void 0 ? _f : v[f] = {}, (_S = (_ = this.aggregatedModalityStats[f])[S]) !== null && _S !== void 0 ? _S : _[S] = [], C > 1 && ("audio" === f || "sharing" === f) && this.diagnostics.addStatsError("webrtcStatistics:processAggregatedModality", `Multiple ${f} ${S} streams: ${C}`), this.statsAggregators[f][S].processSample(g[f][S], this.aggregatedModalityStats[f][S], this.configProvider.config.diagnostics.telemetryLimits.numAggregatedSamples), "sharing" !== f && "video" !== f || "recv" !== S || this.processStatsOnSubscribed(g[f][S], f));
                }
                processStatsOnSubscribed(g, f) {
                    const S = new Set;
                    for (const v of g)if (v.inboundRTP) {
                        var _v_renderer, _this_statsOnSubscribedData_f, _v_renderer1;
                        const g = `${v.inboundRTP.id}x${(_v_renderer = v.renderer) === null || _v_renderer === void 0 ? void 0 : _v_renderer.msi}`;
                        let _ = (_this_statsOnSubscribedData_f = this.statsOnSubscribedData[f]) === null || _this_statsOnSubscribedData_f === void 0 ? void 0 : _this_statsOnSubscribedData_f[g];
                        S.add(g), _ || (_ = new qT(this.configProvider.config.diagnostics.telemetryLimits.maxVideoStatsAfterSubscription), _.prepareCollectingStatsOnSubscribed((_v_renderer1 = v.renderer) === null || _v_renderer1 === void 0 ? void 0 : _v_renderer1.msi), this.statsOnSubscribedData[f][g] = _, this.statsOnSubscribed[f].push(..._.getStatsOnSubscribed())), _.captureStatsOnSubscribed(v.inboundRTP.framesDecoded, v.inboundRTP.bytesReceived);
                    }
                    clearObj(this.statsOnSubscribedData[f], S);
                }
                processMacroblockRateStats(g) {
                    var _v_extensions, _v_extensions1;
                    if (!(g === null || g === void 0 ? void 0 : g.length)) return;
                    let f = 0, S = 0;
                    for (const v of g)f += (_v_extensions = v.extensions) === null || _v_extensions === void 0 ? void 0 : _v_extensions.macroblockRateReceived, S += (_v_extensions1 = v.extensions) === null || _v_extensions1 === void 0 ? void 0 : _v_extensions1.macroblockRateDecoded;
                    this.macroblockStatsTracker.captureSample(f, S), this.diagnostics.setTotalVideoRecvMblocksRates(this.macroblockStatsTracker.getReport());
                }
                constructor(g, f){
                    this.configProvider = g, this.diagnostics = f, this.dataChannelStatsProcessor = new jT(this.diagnostics, this.configProvider), this.transportStatsProcessor = new HT(this.diagnostics, this.configProvider), this.audioStatsProcessor = new MT(this.diagnostics, this.configProvider), this.videoStatsProcessor = new FT(this.diagnostics, this.configProvider), this.sharingStatsProcessor = new FT(this.diagnostics, this.configProvider), this.bandwidthStatsProcessor = new zT(this.diagnostics, this.configProvider), this.simulcastStatsProcessor = new KT(this.diagnostics, this.configProvider), this.macroblockStatsTracker = new e_, this.statsAggregators = {
                        audio: {
                            recv: new DT,
                            send: new kT(this.diagnostics)
                        },
                        video: {
                            recv: new UT(this.configProvider),
                            send: new BT(this.configProvider)
                        },
                        sharing: {
                            recv: new UT(this.configProvider),
                            send: new BT(this.configProvider)
                        }
                    }, this.aggregatedModalityStats = {}, this.recvVideoStreamsCounter = new Bv, this.multiviewData = {}, this.multiviewKeySet = new Set, this.statsOnSubscribedData = {
                        video: {},
                        sharing: {}
                    }, this.statsOnSubscribed = {
                        video: [],
                        sharing: []
                    }, this.diagnostics.aggregatedStatsRef = this.aggregatedModalityStats, this.diagnostics.statsOnSubscribed = this.statsOnSubscribed, this.diagnostics.bandwidthDiagnostic = this.bandwidthStatsProcessor;
                }
            }, ZT = P, eI = class {
                setAudioDecoderStatsProvider(g) {
                    this.audioDecoderStatsProvider = g;
                }
                signalNoConnection() {
                    this.webrtcStats.signalNoConnection();
                }
                processRawReport(g) {
                    this.diagnostics.latestRawReport = g;
                    const f = {
                        loopTime: -1,
                        fetchTime: -1,
                        convertTime: -1,
                        processingTime: -1,
                        legacyProcessingTime: -1
                    };
                    try {
                        let S = Kt(), v = S;
                        const _ = this.convertStatsReport(g);
                        return _.perfCounters = f, S = Kt(), f.convertTime = S - v, v = S, this.webrtcStats.processStats(_), this.diagnostics.addStatsReport(_), S = Kt(), f.processingTime = S - v, _;
                    } catch (g) {
                        const f = stringifyObject(g);
                        return this.logger.safe.error(`Error processing raw stats: ${f}`), void this.diagnostics.addStatsError("StatisticsGatherer:processRawReport", f);
                    }
                }
                setSsrcTrackPair(g, f) {
                    null === f ? this.ssrcToRecvTrackMap.delete(g) : this.ssrcToRecvTrackMap.set(g, f);
                }
                convertStatsReport(g) {
                    const f = {
                        transports: this.processTransportStats(g)
                    };
                    return this.appendPcStats(g, f), this.appendSendMediaStats(g, f), this.appendRecvMediaStats(g, f), g["data-channel"] && (f.data = Object.values(g["data-channel"])), f;
                }
                processTransportStats(g) {
                    if (g.transport) {
                        const f = {};
                        for(const S in g.transport){
                            const v = g.transport[S];
                            if (f[S] = shallowClone(v), v.selectedCandidatePairId) {
                                const _ = shallowClone(g["candidate-pair"][v.selectedCandidatePairId]);
                                _.localCandidate = g["local-candidate"][_.localCandidateId], _.remoteCandidate = g["remote-candidate"][_.remoteCandidateId], f[S].selectedCandidatePair = _;
                            }
                            v.localCertificateId && g.certificate && (f[S].localCertificate = g.certificate[v.localCertificateId]), v.remoteCertificateId && g.certificate && (f[S].remoteCertificate = g.certificate[v.remoteCertificateId]);
                        }
                        return f;
                    }
                    if (g["candidate-pair"]) {
                        const f = {};
                        for(const S in g["candidate-pair"]){
                            const v = shallowClone(g["candidate-pair"][S]);
                            v.selected && (v.localCandidate = g["local-candidate"][v.localCandidateId], v.remoteCandidate = g["remote-candidate"][v.remoteCandidateId], f.faketransport = {
                                id: "faketransport",
                                timestamp: v.timestamp,
                                type: "transport",
                                selectedCandidatePair: v,
                                selectedCandidatePairId: v.id
                            });
                        }
                        return f;
                    }
                }
                appendPcStats(g, f) {
                    let S = "";
                    g["peer-connection"] && (Object.keys(g["peer-connection"]).forEach((g)=>{
                        "" === S ? S = g : (this.logger.safe.error(`Unexpected second peer connection stats id ${g}, also found ${S}`), this.diagnostics.addStatsError("StatisticsGatherer", "Unexpected second peer connection stats"));
                    }), f.peerConnection = g["peer-connection"][S]);
                }
                appendSendMediaStats(g, f) {
                    var S, v, _, C;
                    for(const E in g["outbound-rtp"]){
                        var _I_track, _I_mediaSource, _this_diagnostics_getObjectRef_negotiation_activeModalities;
                        const T = g["outbound-rtp"][E], I = {
                            outboundRTP: T
                        };
                        var _T_transportId;
                        T.codecId && g.codec && (I.codec = g.codec[T.codecId]), Object.defineProperty(I, "transport", {
                            value: f.transports[(_T_transportId = T.transportId) !== null && _T_transportId !== void 0 ? _T_transportId : "faketransport"],
                            configurable: !1,
                            enumerable: !1
                        }), T.remoteId && g["remote-inbound-rtp"] && (I.remoteInboundRTP = g["remote-inbound-rtp"][T.remoteId]), T.mediaSourceId && g["media-source"] && (I.mediaSource = g["media-source"][T.mediaSourceId]), T.trackId && g.track && (I.track = g.track[T.trackId]);
                        var _I_track_trackIdentifier, _getEntityByLocalTrack, _ref;
                        const b = (_ref = (_getEntityByLocalTrack = getEntityByLocalTrack(this.mediaManager, (_I_track_trackIdentifier = (_I_track = I.track) === null || _I_track === void 0 ? void 0 : _I_track.trackIdentifier) !== null && _I_track_trackIdentifier !== void 0 ? _I_track_trackIdentifier : (_I_mediaSource = I.mediaSource) === null || _I_mediaSource === void 0 ? void 0 : _I_mediaSource.trackIdentifier, T.rid)) !== null && _getEntityByLocalTrack !== void 0 ? _getEntityByLocalTrack : getEntityByLocalSSRC(this.mediaManager, T.ssrc, T.rid)) !== null && _ref !== void 0 ? _ref : getMediaEntityByMid(this.mediaManager, I.outboundRTP.mid, T.rid);
                        if (!(b === null || b === void 0 ? void 0 : b.getLocalTrackId())) continue;
                        I.mediaEntity = b.serialize(), !I.mediaSource && I.mediaEntity && g["media-source"] && (I.mediaSource = Object.values(g["media-source"]).find((g)=>g.trackIdentifier === I.mediaEntity.localTrackId));
                        const A = "video" === T.kind ? "sharing" === (b === null || b === void 0 ? void 0 : b.getModality()) ? "sharing" : "video" : T.kind;
                        var _A, _send, _f_inactiveTracks, _A1, _send1;
                        if ((_A = (S = this.activeChannels)[A]) !== null && _A !== void 0 ? _A : S[A] = {}, (_send = (v = this.activeChannels[A]).send) !== null && _send !== void 0 ? _send : v.send = {}, hasSendDirectionality((_this_diagnostics_getObjectRef_negotiation_activeModalities = this.diagnostics.getObjectRef().negotiation.activeModalities) === null || _this_diagnostics_getObjectRef_negotiation_activeModalities === void 0 ? void 0 : _this_diagnostics_getObjectRef_negotiation_activeModalities[A])) {
                            if (f[A] || (f[A] = {}), f[A].send || (f[A].send = []), "video" === T.kind) {
                                var _getRequestedCapabilitiesBySsrc;
                                const g = (_getRequestedCapabilitiesBySsrc = getRequestedCapabilitiesBySsrc(this.diagnostics, A, T.ssrc)) !== null && _getRequestedCapabilitiesBySsrc !== void 0 ? _getRequestedCapabilitiesBySsrc : getRequestedCapabilitiesBySsrc(this.diagnostics, A, 0);
                                g && (I.requestedCapabilities = g);
                                var _getAppliedCapabilitiesBySsrc;
                                const S = (_getAppliedCapabilitiesBySsrc = getAppliedCapabilitiesBySsrc(this.diagnostics, A, T.ssrc)) !== null && _getAppliedCapabilitiesBySsrc !== void 0 ? _getAppliedCapabilitiesBySsrc : getAppliedCapabilitiesBySsrc(this.diagnostics, A, 0);
                                S && (I.appliedCapabilities = S);
                                const v = f[A].send.find((g)=>g.outboundRTP.trackId === I.outboundRTP.trackId);
                                if (v) {
                                    const g = parseInt(v.outboundRTP.rid, 10) > parseInt(I.outboundRTP.rid, 10);
                                    if (!v.altLayouts && g && (v.altLayouts = []), g) v.altLayouts.push(I);
                                    else {
                                        I.altLayouts = [], I.altLayouts.push(v);
                                        const g = f[A].send.indexOf(v);
                                        f[A].send[g] = I;
                                    }
                                    continue;
                                }
                            }
                            this.activeChannels[A].send[T.id] = I, f[A].send.push(I);
                        } else this.activeChannels[A].send[T.id] && "sharing" !== A && ((_f_inactiveTracks = f.inactiveTracks) !== null && _f_inactiveTracks !== void 0 ? _f_inactiveTracks : f.inactiveTracks = {}, (_A1 = (_ = f.inactiveTracks)[A]) !== null && _A1 !== void 0 ? _A1 : _[A] = {}, (_send1 = (C = f.inactiveTracks[A]).send) !== null && _send1 !== void 0 ? _send1 : C.send = [], f.inactiveTracks[A].send.push(this.activeChannels[A].send[T.id]));
                    }
                }
                appendRecvMediaStats(g, f) {
                    var _this_diagnostics_getObjectRef_subscriptionManager;
                    var S, v, _, C;
                    const E = (_this_diagnostics_getObjectRef_subscriptionManager = this.diagnostics.getObjectRef().subscriptionManager) === null || _this_diagnostics_getObjectRef_subscriptionManager === void 0 ? void 0 : _this_diagnostics_getObjectRef_subscriptionManager.subscribedTrackIds;
                    for(const T in g["inbound-rtp"]){
                        var _this_audioDecoderStatsProvider, _b_track, _this_diagnostics_getObjectRef_negotiation_activeModalities;
                        const I = g["inbound-rtp"][T], b = {
                            inboundRTP: I
                        };
                        var _I_transportId, _I_transportId1, _I_transportId2;
                        I.codecId && g.codec && (b.codec = g.codec[I.codecId]), "audio" === I.kind && b.inboundRTP.ssrc === ((_this_audioDecoderStatsProvider = this.audioDecoderStatsProvider) === null || _this_audioDecoderStatsProvider === void 0 ? void 0 : _this_audioDecoderStatsProvider.ssrc) && (this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("replacing recv audio stats with custom audio decoder stats"), b.codec || (b.codec = {
                            transportId: (_I_transportId = I.transportId) !== null && _I_transportId !== void 0 ? _I_transportId : "faketransport",
                            id: "fakeCodec",
                            payloadType: 999,
                            timestamp: I.timestamp,
                            type: "codec",
                            mimeType: "unk"
                        }), b.codec.mimeType = this.audioDecoderStatsProvider.codecName, b.inboundRTP = (0, ZT.merge)(b.inboundRTP, this.audioDecoderStatsProvider.getWebRtcCompatibleStats()), b.customHealerStats = this.audioDecoderStatsProvider.getWasmStats()), f.transports[(_I_transportId1 = I.transportId) !== null && _I_transportId1 !== void 0 ? _I_transportId1 : "faketransport"] && Object.defineProperty(b, "transport", {
                            value: f.transports[(_I_transportId2 = I.transportId) !== null && _I_transportId2 !== void 0 ? _I_transportId2 : "faketransport"],
                            configurable: !1,
                            enumerable: !1
                        }), I.remoteId && g["remote-outbound-rtp"] && (b.remoteOutboundRTP = g["remote-outbound-rtp"][I.remoteId]);
                        var _b_inboundRTP_trackIdentifier;
                        const A = (_b_inboundRTP_trackIdentifier = b.inboundRTP.trackIdentifier) !== null && _b_inboundRTP_trackIdentifier !== void 0 ? _b_inboundRTP_trackIdentifier : this.ssrcToRecvTrackMap.get(I.ssrc);
                        if (I.trackId || A) {
                            var _b_track1;
                            I.trackId && g.track ? b.track = g.track[I.trackId] : A && (b.track = {
                                id: "ssrcToTrackId",
                                kind: I.kind,
                                timestamp: I.timestamp,
                                type: "track",
                                trackIdentifier: A
                            });
                            const f = getRendererDiagnosticsByTrack(this.diagnostics, (_b_track1 = b.track) === null || _b_track1 === void 0 ? void 0 : _b_track1.trackIdentifier);
                            f && (b.renderer = f);
                        }
                        var _getEntityByRemoteTrack;
                        const R = (_getEntityByRemoteTrack = getEntityByRemoteTrack(this.mediaManager, (_b_track = b.track) === null || _b_track === void 0 ? void 0 : _b_track.trackIdentifier)) !== null && _getEntityByRemoteTrack !== void 0 ? _getEntityByRemoteTrack : getEntityByRemoteSSRC(this.mediaManager, I.ssrc);
                        if (!R) continue;
                        b.mediaEntity = R.serialize();
                        const P = "video" === I.kind && b.track ? "sharing" === (R === null || R === void 0 ? void 0 : R.getModality()) ? "sharing" : "video" : I.kind;
                        var _P, _recv, _f_inactiveTracks, _P1, _recv1;
                        (_P = (S = this.activeChannels)[P]) !== null && _P !== void 0 ? _P : S[P] = {}, (_recv = (v = this.activeChannels[P]).recv) !== null && _recv !== void 0 ? _recv : v.recv = {}, "video" !== I.kind || E.some((g)=>{
                            var _b_track;
                            return g && g === ((_b_track = b.track) === null || _b_track === void 0 ? void 0 : _b_track.trackIdentifier);
                        }) ? hasReceiveDirectionality((_this_diagnostics_getObjectRef_negotiation_activeModalities = this.diagnostics.getObjectRef().negotiation.activeModalities) === null || _this_diagnostics_getObjectRef_negotiation_activeModalities === void 0 ? void 0 : _this_diagnostics_getObjectRef_negotiation_activeModalities[P]) && (f[P] || (f[P] = {}), f[P].recv || (f[P].recv = []), this.activeChannels[P].recv[I.id] = b, f[P].recv.push(b)) : this.activeChannels[P].recv[I.id] && "sharing" !== P && ((_f_inactiveTracks = f.inactiveTracks) !== null && _f_inactiveTracks !== void 0 ? _f_inactiveTracks : f.inactiveTracks = {}, (_P1 = (_ = f.inactiveTracks)[P]) !== null && _P1 !== void 0 ? _P1 : _[P] = {}, (_recv1 = (C = f.inactiveTracks[P]).recv) !== null && _recv1 !== void 0 ? _recv1 : C.recv = [], f.inactiveTracks[P].recv.push(this.activeChannels[P].recv[I.id]));
                    }
                }
                constructor(g, f, S, v){
                    this.logger = g, this.configProvider = f, this.diagnostics = S, this.mediaManager = v, this.webrtcStats = new XT(this.configProvider, this.diagnostics), this.ssrcToRecvTrackMap = new Map, this.activeChannels = {};
                }
            };
            function verifyRidIfPresent(g, f) {
                var _g_getSimulcastContext;
                return !f || ((_g_getSimulcastContext = g.getSimulcastContext()) === null || _g_getSimulcastContext === void 0 ? void 0 : _g_getSimulcastContext.activeRids.map(String).some((g)=>g === f));
            }
            function getEntityByRemoteSSRC(g, f) {
                return g.getMediaEntities().find((g)=>g.getRemoteSsrc() === f);
            }
            function getEntityByRemoteTrack(g, f) {
                const S = g.getMediaEntities();
                return void 0 !== f ? S.find((g)=>g.getRemoteTrackId() === f) : void 0;
            }
            function getEntityByLocalSSRC(g, f, S) {
                return g.getMediaEntities().find((g)=>g.getLocalSsrc() === f && verifyRidIfPresent(g, S));
            }
            function getEntityByLocalTrack(g, f, S) {
                const v = g.getMediaEntities();
                return f ? v.find((g)=>g.getLocalTrackId() === f && verifyRidIfPresent(g, S)) : void 0;
            }
            function getRequestedCapabilitiesBySsrc(g, f, S) {
                const v = g.getObjectRef().qualityManager;
                return "video" === f ? v === null || v === void 0 ? void 0 : v.currentVideoSsrcRequestedCapabilities[`${S}`] : "sharing" === f ? v === null || v === void 0 ? void 0 : v.currentSharingSsrcRequestedCapabilities[`${S}`] : void 0;
            }
            function getAppliedCapabilitiesBySsrc(g, f, S) {
                const v = g.getObjectRef().qualityManager;
                return "video" === f ? v === null || v === void 0 ? void 0 : v.currentVideoSsrcAppliedCapabilities[`${S}`] : "sharing" === f ? v === null || v === void 0 ? void 0 : v.currentSharingSsrcAppliedCapabilities[`${S}`] : void 0;
            }
            function getRendererDiagnosticsByTrack(g, f) {
                var _g_getObjectRef_remoteVideoManager;
                return (_g_getObjectRef_remoteVideoManager = g.getObjectRef().remoteVideoManager) === null || _g_getObjectRef_remoteVideoManager === void 0 ? void 0 : _g_getObjectRef_remoteVideoManager.renderers.find((g)=>g.trackId === f);
            }
            function getMediaEntityByMid(g, f, S) {
                const v = g.getMediaEntities();
                return f ? v.find((g)=>g.getMid() === f && verifyRidIfPresent(g, S)) : void 0;
            }
            var tI = class {
                constructor(){
                    this.googCandidatePair = {}, this.ssrc = {}, this.googComponent = {}, this.VideoBwe = {
                        bweforvideo: {}
                    };
                }
            }, iI = class {
                build(g) {
                    return this.statistics = new tI, this.constructGoogCandidatePair(g), this.constructGoogSsrc(g), this.constructGoogComponent(g), this.constructDataChannel(g), this.constructBwe(g), this.statistics;
                }
                setSsrcTrackPair(g, f) {
                    null === f ? this.ssrcTrackMap.delete(g) : this.ssrcTrackMap.set(g, f);
                }
                setAudioDecoderStatsProvider(g) {
                    this.audioDecoderStatsProvider = g;
                }
                constructGoogSsrc(g) {
                    const f = {};
                    if (g.hasOwnProperty("outbound-rtp")) {
                        const S = g["outbound-rtp"];
                        Object.keys(S).forEach((v)=>{
                            const _ = `ssrc_${S[v].ssrc}_send`, C = this.constructSendSsrc(g, S[v]);
                            f[_] = C;
                        });
                    }
                    if (g.hasOwnProperty("inbound-rtp")) {
                        const S = g["inbound-rtp"];
                        Object.keys(S).forEach((v)=>{
                            const _ = `ssrc_${S[v].ssrc}_recv`, C = this.constructRecvSsrc(g, S[v]);
                            f[_] = C;
                        });
                    }
                    this.statistics.ssrc = f;
                }
                constructSendSsrc(g, f) {
                    var _g_remoteinboundrtp;
                    var _v_trackIdentifier, _ref;
                    const S = f.trackId ? g.track[f.trackId] : null, v = f.mediaSourceId ? g["media-source"][f.mediaSourceId] : null, _ = (_g_remoteinboundrtp = g["remote-inbound-rtp"]) === null || _g_remoteinboundrtp === void 0 ? void 0 : _g_remoteinboundrtp[f.remoteId], C = `ssrc_${f.ssrc}_send`, E = (_ref = (_v_trackIdentifier = v === null || v === void 0 ? void 0 : v.trackIdentifier) !== null && _v_trackIdentifier !== void 0 ? _v_trackIdentifier : S === null || S === void 0 ? void 0 : S.trackIdentifier) !== null && _ref !== void 0 ? _ref : this.ssrcTrackMap.get(f.ssrc);
                    var _f_mediaType;
                    let T = {
                        id: C,
                        ssrc: f.ssrc,
                        mediaType: (_f_mediaType = f.mediaType) !== null && _f_mediaType !== void 0 ? _f_mediaType : f.kind,
                        bytesSent: f.bytesSent,
                        bytesSentDiff: this.calculateDiff(C, f.bytesSent, 4),
                        packetsSent: f.packetsSent,
                        packetsLost: _ === null || _ === void 0 ? void 0 : _.packetsLost,
                        jitter: _ === null || _ === void 0 ? void 0 : _.jitter,
                        googRtt: this.getRtt(_),
                        googCodecName: this.getCodec(g, f.codecId),
                        transportId: f.transportId,
                        googTrackId: E
                    };
                    return "audio" === T.mediaType && (T = {
                        ...T,
                        ...this.constructAudioSendSsrc(f, v)
                    }), "video" === T.mediaType && (T = {
                        ...T,
                        ...this.constructVideoSendSsrc(f, v, C, S)
                    }), removeUndefinedFields(T);
                }
                constructAudioSendSsrc(g, f) {
                    return {
                        audioInputLevel: f === null || f === void 0 ? void 0 : f.audioLevel,
                        totalAudioEnergy: f === null || f === void 0 ? void 0 : f.totalAudioEnergy,
                        fecPacketsSent: g.fecPacketsSent
                    };
                }
                constructVideoSendSsrc(g, f, S, v) {
                    var _g_framesSent, _g_frameHeight, _g_frameWidth, _g_hugeFramesSent;
                    return {
                        framesEncoded: g.framesEncoded,
                        googFrameRateEncoded: this.calculateDiff(S, g.framesEncoded, 2),
                        googFrameRateSent: this.calculateDiff(S, (_g_framesSent = g.framesSent) !== null && _g_framesSent !== void 0 ? _g_framesSent : v === null || v === void 0 ? void 0 : v.framesSent, 1),
                        googFrameRateInput: f === null || f === void 0 ? void 0 : f.framesPerSecond,
                        googFrameHeightSent: (_g_frameHeight = g.frameHeight) !== null && _g_frameHeight !== void 0 ? _g_frameHeight : v === null || v === void 0 ? void 0 : v.frameHeight,
                        googFrameWidthSent: (_g_frameWidth = g.frameWidth) !== null && _g_frameWidth !== void 0 ? _g_frameWidth : v === null || v === void 0 ? void 0 : v.frameWidth,
                        googFrameHeightInput: f === null || f === void 0 ? void 0 : f.height,
                        googFrameWidthInput: f === null || f === void 0 ? void 0 : f.width,
                        hugeFramesSent: (_g_hugeFramesSent = g.hugeFramesSent) !== null && _g_hugeFramesSent !== void 0 ? _g_hugeFramesSent : v === null || v === void 0 ? void 0 : v.hugeFramesSent,
                        keyFramesEncoded: g.keyFramesEncoded,
                        qpSum: g.qpSum,
                        qp: this.calculateDiff(S, g.qpSum, 8),
                        googPlisReceived: g.pliCount,
                        googFirsReceived: g.firCount,
                        googNacksReceived: g.nackCount,
                        qualityLimitationDurations: g.qualityLimitationDurations,
                        qualityLimitationReason: g.qualityLimitationReason,
                        qualityLimitationResolutionChanges: g.qualityLimitationResolutionChanges,
                        codecImplementationName: g.encoderImplementation,
                        rid: g.rid,
                        encodeTime: g.totalEncodeTime && Math.round(1e3 * this.calculateDiff(S, g.totalEncodeTime, 6))
                    };
                }
                constructRecvSsrc(g, f) {
                    var _f_trackIdentifier, _ref;
                    const S = f.trackId ? g.track[f.trackId] : null, v = `ssrc_${f.ssrc}_recv`, _ = (_ref = (_f_trackIdentifier = f.trackIdentifier) !== null && _f_trackIdentifier !== void 0 ? _f_trackIdentifier : S === null || S === void 0 ? void 0 : S.trackIdentifier) !== null && _ref !== void 0 ? _ref : this.ssrcTrackMap.get(f.ssrc);
                    var _f_mediaType;
                    let C = {
                        id: v,
                        ssrc: f.ssrc,
                        mediaType: (_f_mediaType = f.mediaType) !== null && _f_mediaType !== void 0 ? _f_mediaType : f.kind,
                        bytesReceived: f.bytesReceived,
                        bytesReceivedDiff: this.calculateDiff(v, f.bytesReceived, 5),
                        packetsReceived: f.packetsReceived,
                        packetsLost: f.packetsLost,
                        jitter: f.jitter,
                        googJitterBufferMs: f.jitterBufferEmittedCount && Math.round(f.jitterBufferDelay / f.jitterBufferEmittedCount * 1e3),
                        googCodecName: this.getCodec(g, f.codecId),
                        googTrackId: _,
                        transportId: f.transportId
                    };
                    return "audio" === C.mediaType && (C = {
                        ...C,
                        ...this.constructAudioRecvSsrc(f, S)
                    }), "video" === C.mediaType && (C = {
                        ...C,
                        ...this.constructVideoRecvSsrc(f, v, S)
                    }), removeUndefinedFields(C);
                }
                constructAudioRecvSsrc(g, f) {
                    var _this_audioDecoderStatsProvider, _this_audioDecoderStatsProvider1, _this_audioDecoderStatsProvider2;
                    var _S_audioLevel, _S_totalAudioEnergy;
                    const S = ((_this_audioDecoderStatsProvider = this.audioDecoderStatsProvider) === null || _this_audioDecoderStatsProvider === void 0 ? void 0 : _this_audioDecoderStatsProvider.ssrc) === g.ssrc ? (_this_audioDecoderStatsProvider1 = this.audioDecoderStatsProvider) === null || _this_audioDecoderStatsProvider1 === void 0 ? void 0 : _this_audioDecoderStatsProvider1.getWebRtcCompatibleStats() : g, v = {
                        audioOutputLevel: (_S_audioLevel = S.audioLevel) !== null && _S_audioLevel !== void 0 ? _S_audioLevel : f === null || f === void 0 ? void 0 : f.audioLevel,
                        totalAudioEnergy: (_S_totalAudioEnergy = S.totalAudioEnergy) !== null && _S_totalAudioEnergy !== void 0 ? _S_totalAudioEnergy : f === null || f === void 0 ? void 0 : f.totalAudioEnergy,
                        concealedSamples: S.concealedSamples,
                        silentConcealedSamples: S.silentConcealedSamples,
                        totalSamplesReceived: S.totalSamplesReceived,
                        healedRatio: S.totalSamplesReceived && (S.concealedSamples - S.silentConcealedSamples) / S.totalSamplesReceived,
                        fecPacketsReceived: S.fecPacketsReceived,
                        fecPacketsDiscarded: S.fecPacketsDiscarded,
                        packetsDiscarded: S.packetsDiscarded
                    };
                    if (((_this_audioDecoderStatsProvider2 = this.audioDecoderStatsProvider) === null || _this_audioDecoderStatsProvider2 === void 0 ? void 0 : _this_audioDecoderStatsProvider2.ssrc) === g.ssrc) {
                        v.googJitterBufferMs = S.jitterBufferEmittedCount && Math.round(S.jitterBufferDelay / S.jitterBufferEmittedCount * 1e3), v.googCodecName = this.audioDecoderStatsProvider.codecName;
                        const g = this.audioDecoderStatsProvider.getDecoderStats();
                        v.pushCount = g.pushCount, v.pushErrCount = g.pushErrCount, v.pullCount = g.pullCount, v.pullErrCount = g.pullErrCount;
                    }
                    return v;
                }
                constructVideoRecvSsrc(g, f, S) {
                    var _g_framesReceived, _g_frameHeight, _g_frameWidth;
                    return {
                        framesDecoded: g.framesDecoded,
                        googFrameRateDecoded: this.calculateDiff(f, g.framesDecoded, 3),
                        googFrameRateReceived: this.calculateDiff(f, (_g_framesReceived = g.framesReceived) !== null && _g_framesReceived !== void 0 ? _g_framesReceived : S === null || S === void 0 ? void 0 : S.framesReceived, 0),
                        googFrameHeightReceived: (_g_frameHeight = g.frameHeight) !== null && _g_frameHeight !== void 0 ? _g_frameHeight : S === null || S === void 0 ? void 0 : S.frameHeight,
                        googFrameWidthReceived: (_g_frameWidth = g.frameWidth) !== null && _g_frameWidth !== void 0 ? _g_frameWidth : S === null || S === void 0 ? void 0 : S.frameWidth,
                        keyFramesDecoded: g.keyFramesDecoded,
                        googPlisSent: g.pliCount,
                        googFirsSent: g.firCount,
                        googNacksSent: g.nackCount,
                        codecImplementationName: g.decoderImplementation,
                        decodeTime: g.totalDecodeTime && Math.round(1e3 * this.calculateDiff(f, g.totalDecodeTime, 7))
                    };
                }
                constructGoogCandidatePair(g) {
                    const f = g["candidate-pair"];
                    f && Object.keys(f).forEach((S)=>{
                        const v = this.constructPair(g, f[S]);
                        this.statistics.googCandidatePair[v.id] = v;
                    });
                }
                constructPair(g, f) {
                    const S = g["local-candidate"][f.localCandidateId], v = g["remote-candidate"][f.remoteCandidateId];
                    return removeUndefinedFields({
                        bytesReceived: f.bytesReceived,
                        bytesSent: f.bytesSent,
                        googTransportType: S.protocol,
                        googRtt: f.currentRoundTripTime ? Math.round(1e3 * f.currentRoundTripTime) : void 0,
                        googLocalAddress: `${S.ip ? S.ip : S.address}:${S.port}`,
                        googLocalCandidateType: S.candidateType,
                        localRelayProtocol: S.relayProtocol,
                        localNetworkType: S.networkType,
                        googRemoteAddress: `${v.ip ? v.ip : v.address}:${v.port}`,
                        googRemoteCandidateType: v.candidateType,
                        googActiveConnection: f.nominated,
                        requestsReceived: f.requestsReceived,
                        requestsSent: f.requestsSent,
                        responsesReceived: f.responsesReceived,
                        responsesSent: f.responsesSent,
                        consentRequestsSent: f.consentRequestsSent,
                        id: f.id,
                        remoteCandidateId: f.remoteCandidateId,
                        localCandidateId: f.localCandidateId,
                        googWritable: f.writable,
                        selected: f.selected,
                        packetsDiscardedOnSend: f.packetsDiscardedOnSend
                    });
                }
                constructGoogComponent(g) {
                    g.transport && Object.keys(g.transport).forEach((f)=>{
                        this.statistics.googComponent[f] = {
                            id: f,
                            selectedCandidatePairId: g.transport[f].selectedCandidatePairId
                        };
                    });
                }
                constructDataChannel(g) {
                    if (!g.hasOwnProperty("data-channel")) return;
                    const f = g["data-channel"];
                    this.statistics.data = Object.keys(f).map((g)=>{
                        const S = f[g];
                        return {
                            bytesReceived: S.bytesReceived,
                            bytesSent: S.bytesSent,
                            dataChannelIdentifier: S.dataChannelIdentifier,
                            label: S.label,
                            messagesReceived: S.messagesReceived,
                            messagesSent: S.messagesSent,
                            protocol: S.protocol,
                            state: S.state,
                            timestamp: S.timestamp,
                            type: S.type
                        };
                    });
                }
                constructBwe(g) {
                    var _Object_values, _g_transport, _g_candidatepair;
                    var _g_outboundrtp;
                    const f = (_Object_values = Object.values((_g_outboundrtp = g["outbound-rtp"]) !== null && _g_outboundrtp !== void 0 ? _g_outboundrtp : {})) === null || _Object_values === void 0 ? void 0 : _Object_values.find((g)=>{
                        var _g_mediaType;
                        const f = (_g_mediaType = g.mediaType) !== null && _g_mediaType !== void 0 ? _g_mediaType : g.kind;
                        return "audio" === f || "video" === f;
                    });
                    if (!f) return;
                    const S = (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : _g_transport[f.transportId];
                    if (!S) return;
                    const v = (_g_candidatepair = g["candidate-pair"]) === null || _g_candidatepair === void 0 ? void 0 : _g_candidatepair[S.selectedCandidatePairId];
                    if (!v) return;
                    const _ = {
                        googAvailableSendBandwidth: v.availableOutgoingBitrate,
                        googAvailableReceiveBandwidth: v.availableIncomingBitrate
                    };
                    this.statistics.VideoBwe.bweforvideo = removeUndefinedFields(_);
                }
                getRtt(g) {
                    const f = g === null || g === void 0 ? void 0 : g.roundTripTime;
                    return f ? Math.round(1e3 * f) : void 0;
                }
                getCodec(g, f) {
                    if (f && g.codec && g.codec[f]) return g.codec[f].mimeType.split("/").pop();
                }
                calculateDiff(g, f, S) {
                    if (void 0 === f) return;
                    let v = f;
                    const _ = this.statsDiffMap.has(g) ? this.statsDiffMap.get(g) : new Map;
                    if (_.has(S)) {
                        const g = _.get(S);
                        g <= f && (v = f - g);
                    }
                    return _.set(S, f), this.statsDiffMap.set(g, _), isNaN(v) ? void 0 : v;
                }
                constructor(){
                    this.statistics = new tI, this.statsDiffMap = new Map, this.ssrcTrackMap = new Map;
                }
            }, nI = P, rI = P, aI = class {
                captureHealedRatioSamples(g, f, S) {
                    !g || !f || !S || g.length <= this.networkDetectionDuration || f.length <= this.networkDetectionDuration || S.length <= this.networkDetectionDuration || this.setHealedRatioPerDuration(g, f, S);
                }
                getHealedRatioMax() {
                    return this.healedRatioMax;
                }
                getHealedRatioAvg() {
                    return this.healedRatioDuration ? this.healedRatioTotal / this.healedRatioDuration : 0;
                }
                getHealedRatio() {
                    return this.healedRatio;
                }
                getTotalSamplesReceivedDiff() {
                    return this.totalSamplesReceivedDiff;
                }
                setHealedRatioPerDuration(g, f, S) {
                    const v = -1 - this.networkDetectionDuration, _ = Math.max((0, rI.last)(g) - (0, rI.nth)(g, v), 0), C = Math.max((0, rI.last)(f) - (0, rI.nth)(f, v), 0);
                    this.totalSamplesReceivedDiff = Math.max((0, rI.last)(S) - (0, rI.nth)(S, v), 0), 0 !== this.totalSamplesReceivedDiff && (this.healedRatio = (_ - C) / this.totalSamplesReceivedDiff, this.healedRatioDuration++, this.healedRatioTotal += this.healedRatio, this.healedRatioMax = Math.max(this.healedRatioMax, this.healedRatio), this.networkRecvQualityDiagnostics && (this.concealedSamplesAccumulator.add((0, rI.last)(g)), this.silentConcealedSamplesAccumulator.add((0, rI.last)(f)), this.totalSamplesReceivedAccumulator.add((0, rI.last)(S)), this.concealedSamplesDiffAccumulator.add(_), this.silentConcealedSamplesDiffAccumulator.add(C), this.totalSamplesReceivedDiffAccumulator.add(this.totalSamplesReceivedDiff), this.healedRatioAccumulator.add(this.healedRatio)));
                }
                getDiagnostics(g) {
                    return {
                        quality: (0, rI.last)(g),
                        qualityLevels: g,
                        concealedSamples: this.concealedSamplesAccumulator.items,
                        silentConcealedSamples: this.silentConcealedSamplesAccumulator.items,
                        totalSamplesReceived: this.totalSamplesReceivedAccumulator.items,
                        concealedSamplesDiff: this.concealedSamplesDiffAccumulator.items,
                        silentConcealedSamplesDiff: this.silentConcealedSamplesDiffAccumulator.items,
                        totalSamplesReceivedDiff: this.totalSamplesReceivedDiffAccumulator.items,
                        healedRatio: this.healedRatioAccumulator.items.map((g)=>round(g))
                    };
                }
                constructor(g){
                    this.healedRatio = 0, this.healedRatioMax = 0, this.healedRatioDuration = 0, this.healedRatioTotal = 0, this.totalSamplesReceivedDiff = 0;
                    const f = g.config;
                    this.networkDetectionDuration = f.webrtcStatNetworkDetectionDuration, this.networkRecvQualityDiagnostics = f.networkRecvQualityDiagnostics, this.networkRecvQualityDiagnostics && (this.healedRatioAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.concealedSamplesAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.silentConcealedSamplesAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.totalSamplesReceivedAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.concealedSamplesDiffAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.silentConcealedSamplesDiffAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize), this.totalSamplesReceivedDiffAccumulator = new Fv(f.webrtcHealedRatioExtendedWindowSize));
                }
            }, sI = class {
                captureJitterBuffer(g) {
                    this.jitterBufferDuration += Gt.TIME_INTERVAL.SEC_1, this.jitterBufferTotal += g;
                }
                captureJitter(g) {
                    const f = 1e3 * g;
                    this.jitterTotal += f, this.jitterMax = Math.max(f, this.jitterMax), this.jitterDuration += Gt.TIME_INTERVAL.SEC_1;
                }
                getJitterAvg() {
                    return this.jitterDuration ? round(this.jitterTotal / this.jitterDuration) : 0;
                }
                getAvgJitterBuffer() {
                    return this.jitterBufferDuration ? Math.round(this.jitterBufferTotal / this.jitterBufferDuration) : 0;
                }
                captureRtt(g) {
                    if (null !== g) {
                        const f = parseInt(g);
                        this.rttDuration += Gt.TIME_INTERVAL.SEC_1, this.rttTotal += f, this.rttMax = Math.max(this.rttMax, f);
                    }
                }
                getAvgRtt() {
                    return this.rttDuration ? round(this.rttTotal / this.rttDuration) : 0;
                }
                getMaxRtt() {
                    return this.rttMax;
                }
                getJitterMax() {
                    return this.jitterMax;
                }
                updateSendStream(g, f) {
                    var _g_rawStream;
                    if (!this.configProvider.config.useAudioAnalyzer) return;
                    const S = this.audioAnalyzers.get(f);
                    S && (S.dispose(), this.audioAnalyzers.delete(f)), (g === null || g === void 0 ? void 0 : (_g_rawStream = g.rawStream) === null || _g_rawStream === void 0 ? void 0 : _g_rawStream.getAudioTracks().length) && this.audioAnalyzers.set(f, new RC(g.rawStream));
                }
                getInputLevel(g) {
                    const f = this.audioAnalyzers.get(g);
                    return f === null || f === void 0 ? void 0 : f.getInputLevelNormalized();
                }
                constructor(g){
                    this.configProvider = g, this.audioAnalyzers = new Map, this.jitterBufferDuration = 0, this.jitterBufferTotal = 0, this.jitterTotal = 0, this.jitterDuration = 0, this.rttDuration = 0, this.rttTotal = 0, this.rttMax = 0, this.jitterMax = 0;
                }
            }, oI = class {
                recordSendBandwidth(g) {
                    this.currentDropDuration && g < this.dropGoodBandwidth || g < this.dropBadBandwidth ? this.initiateDrop() : this.currentDropDuration && g > this.dropGoodBandwidth && this.recoverDrop();
                }
                getReport() {
                    const g = shallowClone(this.dropDurationCounts);
                    return this.currentDropDuration && (g.ongoingDuration = this.currentDropDuration), g;
                }
                initiateDrop() {
                    this.currentDropDuration ? this.currentDropDuration++ : this.currentDropDuration = 1;
                }
                recoverDrop() {
                    for (const g of Object.keys(Gt.HISTOGRAM_BATCH))if (this.currentDropDuration <= Gt.HISTOGRAM_BATCH[g]) {
                        this.dropDurationCounts[g] += 1, this.currentDropDuration = 0;
                        break;
                    }
                }
                constructor(g, f){
                    this.dropBadBandwidth = g, this.dropGoodBandwidth = f, this.dropDurationCounts = {}, Object.keys(Gt.HISTOGRAM_BATCH).forEach((g)=>{
                        this.dropDurationCounts[g] = 0;
                    });
                }
            }, lI = P, cI = class {
                onSample(g, f) {
                    let S = this.curInLowerRange;
                    this.curInLowerRange ? g > this.highThreshold && (S = !1) : g < this.lowThreshold && (S = !0);
                    const v = this.stateTracker.onNewState(this.getQuality(S), f);
                    return v !== this.getQuality(this.curInLowerRange) && (this.curInLowerRange = S), v;
                }
                getQuality(g) {
                    return g === this.isLowerBetter ? "Good" : "Bad";
                }
                constructor(g, f, S, v){
                    this.lowThreshold = g, this.highThreshold = f, this.isLowerBetter = S, this.curInLowerRange = S, this.stateTracker = new dI(v);
                }
            }, dI = class {
                onNewState(g, f) {
                    return "Good" !== g && "Bad" !== g ? this.curState : 0 === this.stickinessTime ? g : g === this.curState ? (this.stickTimerStarted = 0, this.curState) : ("Bad" === this.curState ? 0 === this.stickTimerStarted ? this.stickTimerStarted = f : f - this.stickTimerStarted > this.stickinessTime && (this.curState = g, this.stickTimerStarted = 0) : (this.curState = g, this.stickTimerStarted = 0), this.curState);
                }
                constructor(g){
                    this.stickinessTime = g;
                }
            }, uI = class {
                getLatestSendQuality(g, f, S) {
                    if (this.dataAccumulator.add(g), this.dataAccumulator.items.length >= this.windowSize) {
                        const g = this.dataAccumulator.items.slice(-this.windowSize), S = (0, lI.mean)(g);
                        return this.addDiagnosticData && this.avgAccumulator.add(S), this.stateProcessor.onSample(S, f);
                    }
                    return S;
                }
                getData() {
                    return this.dataAccumulator.items.map((g)=>round(g));
                }
                getAggregatedData() {
                    return this.avgAccumulator.items.map((g)=>round(g));
                }
                constructor(g, f, S, v){
                    this.stateProcessor = g, this.windowSize = f, this.extendedWindowSize = S, this.addDiagnosticData = v, this.dataAccumulator = new Fv(S), this.avgAccumulator = new Fv(S);
                }
            }, hI = class {
                calculateNetworkSendQualityLevel(g, f, S, v) {
                    if (!g || !f) return {
                        quality: v
                    };
                    if (g.length < 2 || f.length < 2 || (0, lI.last)(g) < this.configProvider.config.webrtcMinPacketsSentForNetworkSendQuality) return {
                        quality: v
                    };
                    const _ = Date.now(), C = (0, lI.last)(S), E = this.jitterCalculator.getLatestSendQuality(C, _, v), [T, I] = g.slice(-2), [b, A] = f.slice(-2), R = this.getLossRate(I, T, A, b), P = this.lossRateCalculator.getLatestSendQuality(R, _, v), w = "Good" === E && "Good" === P ? "Good" : "Bad";
                    return this.sendDiagnosticsEnabled && (this.sendAccumulator.add(I), this.lostAccumulator.add(A), this.sendQualityAccumulator.add(w)), this.sendDiagnosticsEnabled ? {
                        quality: w,
                        packetsSend: this.sendAccumulator.items,
                        packetsLost: this.lostAccumulator.items,
                        packetsSendDiff: this.sendDiffAccumulator.items,
                        packetsLostDiff: this.lostDiffAccumulator.items,
                        lossRates: this.lossRateCalculator.getData(),
                        lossRatesAggregated: this.lossRateCalculator.getAggregatedData(),
                        jitter: this.jitterCalculator.getData(),
                        jitterAggregated: this.jitterCalculator.getAggregatedData(),
                        qualityLevels: this.sendQualityAccumulator.items
                    } : {
                        quality: w
                    };
                }
                calculateNetworkRecvQualityLevel(g) {
                    if (this.newStatsApi) {
                        const f = g;
                        return this.calculateNetworkRecvQualityLevelNewStatsApi(f.concealedSamples, f.silentConcealedSamples, f.totalSamplesReceived, f.oldNetworkLevel);
                    }
                    {
                        const f = g;
                        return this.calculateNetworkRecvQualityLevelLegacyStatsApi(f.googDecodingCTN, f.googDecodingPLC, f.oldNetworkLevel);
                    }
                }
                calculateNetworkRecvQualityLevelLegacyStatsApi(g, f, S) {
                    const v = this.configProvider.config.webrtcStatNetworkDetectionDuration;
                    if (!g || !f || g.length < 2 * v) return {
                        quality: S
                    };
                    let _ = g.length - 1 - v;
                    const C = g[g.length - 1];
                    for(; _ >= 0 && C - g[_] < 100 * v;)_--;
                    if (_ < 0) return {
                        quality: S
                    };
                    const E = C - g[_], T = f[f.length - 1] - f[_];
                    if (E <= 0) return {
                        quality: S
                    };
                    const I = T / E;
                    return {
                        quality: this.getRecvQuality(I, S)
                    };
                }
                calculateNetworkRecvQualityLevelNewStatsApi(g, f, S, v) {
                    const _ = this.configProvider.config.webrtcStatNetworkDetectionDuration;
                    if (!g || g.length <= _ || !f || f.length <= _ || !S || S.length <= _) return {
                        quality: v
                    };
                    if ((0, lI.last)(S) < this.configProvider.config.webrtcMinAudioSamplesRecvForNetworkRecvQuality) return {
                        quality: v
                    };
                    if (0 === this.webrtcHealedRatio.getTotalSamplesReceivedDiff()) return {
                        quality: v
                    };
                    const C = this.webrtcHealedRatio.getHealedRatio(), E = this.getRecvQuality(C, v);
                    if (this.recvDiagnosticsEnabled) {
                        this.recvQualityAccumulator.add(E);
                        return this.webrtcHealedRatio.getDiagnostics(this.recvQualityAccumulator.items);
                    }
                    return {
                        quality: E
                    };
                }
                getRecvQuality(g, f) {
                    return g < this.networkDetectionGoodLevelLow ? "Good" : g < this.networkDetectionGoodLevelHigh ? "Good" === f ? "Good" : "Poor" : g < this.networkDetectionBadLevelLow ? "Poor" : g < this.networkDetectionBadLevelHigh ? "Bad" === f ? "Bad" : "Poor" : "Bad";
                }
                getLossRate(g, f, S, v) {
                    const _ = g - f, C = S - v, E = _ + C;
                    return this.sendDiagnosticsEnabled && (this.sendDiffAccumulator.add(_), this.lostDiffAccumulator.add(C), this.totalAccumulator.add(E)), E > 0 ? C / E : 0;
                }
                constructor(g, f, S){
                    this.configProvider = g, this.newStatsApi = f, this.webrtcHealedRatio = S, this.sendAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.lostAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.sendDiffAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.lostDiffAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.totalAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.sendQualityAccumulator = new Fv(this.configProvider.config.webrtcLossRateExtendedWindowSize), this.sendDiagnosticsEnabled = this.configProvider.config.networkSendQualityDiagnostics, this.recvDiagnosticsEnabled = this.configProvider.config.networkRecvQualityDiagnostics, this.recvQualityAccumulator = new Fv(this.configProvider.config.webrtcHealedRatioExtendedWindowSize);
                    const v = Number(this.configProvider.config.webrtcStatNetworkDetectionHysteresis);
                    this.networkDetectionBadLevelHigh = Number(this.configProvider.config.webrtcStatNetworkDetectionBadLevel) + v / 2, this.networkDetectionBadLevelLow = this.networkDetectionBadLevelHigh - v, this.networkDetectionGoodLevelHigh = Number(this.configProvider.config.webrtcStatNetworkDetectionGoodLevel) + v / 2, this.networkDetectionGoodLevelLow = this.networkDetectionGoodLevelHigh - v;
                    const _ = new cI(g.config.webrtcJitterLowThreshold, g.config.webrtcJitterHighThreshold, !0, g.config.webrtcJitterSticknessTime), C = new cI(g.config.webrtcLossRateLowThreshold, g.config.webrtcLossRateHighThreshold, !0, g.config.webrtcLossRateSticknessTime);
                    this.jitterCalculator = new uI(_, g.config.webrtcJitterWindowSize, g.config.webrtcJitterExtendedWindowSize, this.sendDiagnosticsEnabled), this.lossRateCalculator = new uI(C, g.config.webrtcLossRateWindowSize, g.config.webrtcLossRateExtendedWindowSize, this.sendDiagnosticsEnabled);
                }
            }, gI = class {
                setQualityLimitationReason(g) {
                    this.lastQualityLimitationReason !== g && this.qualityLimitationReasonEvents.push({
                        event: g,
                        startTime: Date.now(),
                        endTime: Date.now()
                    }), this.qualityLimitationReasonEvents.length > this.configProvider.config.maxStoredQualityLimitationReasonEvents && this.qualityLimitationReasonEvents.shift(), this.lastQualityLimitationReason = g;
                }
                getQualityLimitationReasonEvents() {
                    return this.qualityLimitationReasonEvents.reduce((g, f, S)=>{
                        var _this_qualityLimitationReasonEvents_;
                        var _this_qualityLimitationReasonEvents__startTime;
                        return "none" === f.event ? g : [
                            ...g,
                            {
                                ...f,
                                endTime: (_this_qualityLimitationReasonEvents__startTime = (_this_qualityLimitationReasonEvents_ = this.qualityLimitationReasonEvents[S + 1]) === null || _this_qualityLimitationReasonEvents_ === void 0 ? void 0 : _this_qualityLimitationReasonEvents_.startTime) !== null && _this_qualityLimitationReasonEvents__startTime !== void 0 ? _this_qualityLimitationReasonEvents__startTime : Date.now()
                            }
                        ];
                    }, []);
                }
                constructor(g){
                    this.configProvider = g, this.qualityLimitationReasonEvents = [];
                }
            }, pI = class {
                captureSample(g, f) {
                    const S = Date.now() / 1e3;
                    if (0 !== this.bitrateData[g].lastTimestamp && f > this.bitrateData[g].lastBytes) {
                        const v = S - this.bitrateData[g].lastTimestamp, _ = 8 * (f - this.bitrateData[g].lastBytes) / v;
                        this.onBitrateSample(g, _);
                    }
                    this.bitrateData[g].lastTimestamp = S, this.bitrateData[g].lastBytes = f;
                }
                getMax(g) {
                    return Math.round(this.bitrateData[g].maxSample);
                }
                getAvg(g) {
                    return 0 === this.bitrateData[g].nSamples ? 0 : Math.round(this.bitrateData[g].bitrateTotal / this.bitrateData[g].nSamples);
                }
                stopCapture(g) {
                    this.bitrateData[g].lastBytes = 0, this.bitrateData[g].lastTimestamp = 0;
                }
                onBitrateSample(g, f) {
                    f > this.bitrateData[g].maxSample && (this.bitrateData[g].maxSample = f), this.bitrateData[g].bitrateTotal += f, this.bitrateData[g].nSamples++;
                }
                captureAllocateBandwidth(g) {
                    if (g) {
                        const f = parseInt(g[g.length - 1]);
                        this.bitrateData[Gt.MEDIA_DIRECTION.SEND].allocateBW += f, this.bitrateData[Gt.MEDIA_DIRECTION.SEND].allocateBWSamples += 1;
                    }
                }
                getAllocateBandwidthAvg() {
                    const g = this.bitrateData[Gt.MEDIA_DIRECTION.SEND].allocateBW, f = this.bitrateData[Gt.MEDIA_DIRECTION.SEND].allocateBWSamples;
                    if (g > 0 && f > 0) return Math.floor(g / f);
                }
                constructor(){
                    this.bitrateData = {
                        [Gt.MEDIA_DIRECTION.SEND]: {
                            lastBytes: 0,
                            lastTimestamp: 0,
                            maxSample: 0,
                            bitrateTotal: 0,
                            nSamples: 0,
                            allocateBW: 0,
                            allocateBWSamples: 0
                        },
                        [Gt.MEDIA_DIRECTION.RECV]: {
                            lastBytes: 0,
                            lastTimestamp: 0,
                            maxSample: 0,
                            bitrateTotal: 0,
                            nSamples: 0
                        }
                    };
                }
            }, mI = class {
                setMaxCapabilitiesApplied(g) {
                    this.events.push({
                        eventType: "app",
                        timestamp: Date.now(),
                        capabilities: g.capabilities,
                        error: g.error ? `${g.error}` : "none"
                    }), this.maxAppliedCapabilitiesCount && this.events.length > this.maxAppliedCapabilitiesCount + 1 && this.events.splice(1, 1);
                }
                getEvents() {
                    return this.events;
                }
                constructor(g, f){
                    this.maxAppliedCapabilitiesCount = f, this.events = [], this.events.push({
                        eventType: "req",
                        timestamp: Date.now(),
                        capabilities: g.capabilities,
                        isSimulcast: g.isSimulcastEnabled
                    });
                }
            }, fI = class {
                setMaxCapabilitesRequested(g) {
                    const f = new mI(g, this.configProvider.config.webrtcLastAppliedVideoCapabilitiesCount);
                    this.events.push({
                        causeId: g.causeId,
                        seq: f
                    }), this.recordResolutionChange(g), this.configProvider.config.webrtcLastAppliedVideoCapabilitiesSequenceCount && this.events.length > this.configProvider.config.webrtcLastAppliedVideoCapabilitiesSequenceCount && this.events.shift();
                }
                setMaxCapabilitesApplied(g) {
                    const f = this.events.find((f)=>f.causeId === g.causeId);
                    f ? (f.seq.setMaxCapabilitiesApplied(g), g.error && this.errors.push(f)) : this.logger.safe.warn(`Requested capabilities with id ${g.causeId} not found`);
                }
                getEvents() {
                    return this.events.map((g)=>({
                            causeId: g.causeId,
                            events: g.seq.getEvents()
                        }));
                }
                getErrors() {
                    return this.errors.map((g)=>({
                            causeId: g.causeId,
                            events: g.seq.getEvents()
                        }));
                }
                getResolutionRecords() {
                    var _this_configProvider_config_specCompliantSimulcast;
                    if ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.collectResolutionInfo) return {
                        req: this.resolutionChangeRequestRecords,
                        count: this.resolutionChangeCounterByRid
                    };
                }
                recordResolutionChange(g) {
                    var _this_configProvider_config_specCompliantSimulcast;
                    if ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.collectResolutionInfo) {
                        const f = Object.keys(this.currentResolutionsByRid), getRid = (g)=>g.rid || "default";
                        [
                            ...f,
                            ...g.capabilities.map((g)=>getRid(g))
                        ].forEach((f)=>{
                            const S = g.capabilities.find((g)=>getRid(g) === f), v = this.currentResolutionsByRid[f] || 0, _ = (S === null || S === void 0 ? void 0 : S.maxFs) || 0;
                            if (v === _) return;
                            this.resolutionChangeRequestRecords[f] || (this.resolutionChangeRequestRecords[f] = [], this.resolutionChangeCounterByRid[f] = 0);
                            const C = this.resolutionChangeRequestRecords[f].find((g)=>g.from === v && g.to === _);
                            C ? C.counter++ : this.resolutionChangeRequestRecords[f].push({
                                from: v,
                                to: _,
                                counter: 1
                            }), this.currentResolutionsByRid[f] = _, this.resolutionChangeCounterByRid[f]++;
                        });
                    }
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f, this.resolutionChangeRequestRecords = {}, this.currentResolutionsByRid = {}, this.resolutionChangeCounterByRid = {}, this.events = [], this.errors = [];
                }
            }, SI = class {
                analyzeDelay(g, f) {
                    if (f && "" !== f) {
                        this.delayCur.length === g && this.delayCur.shift();
                        const S = parseInt(f);
                        this.delayCur.push(S), this.delayTotal += S, this.delayEventCount += Gt.TIME_INTERVAL.SEC_1;
                    }
                }
                getDelayCur() {
                    if (this.delayCur.length > 0) {
                        const g = this.delayCur.reduce((g, f)=>g + f) / this.delayCur.length;
                        return g < 0 ? 0 : g;
                    }
                }
                getDelayAvg() {
                    if (this.delayEventCount > 0 && this.delayTotal > 0) {
                        const g = this.delayTotal / this.delayEventCount;
                        return g < 0 ? 0 : g;
                    }
                }
                constructor(){
                    this.delayCur = [], this.delayTotal = 0, this.delayEventCount = 0;
                }
            }, vI = class {
                gatherFreezeData({ frameRateDecoded: g, frameRateRecv: f, bytesReceived: S, mediaType: v }) {
                    if (g) {
                        const _ = parseInt(g[g.length - 1], 10), C = (f === null || f === void 0 ? void 0 : f.length) > 0 ? parseInt(f[f.length - 1], 10) : void 0;
                        void 0 !== S && "ScreenShare" !== v && this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation && !this.configProvider.config.isRenderingBasedOnRawStatistics && this.calculateBitrate(S, _), -1 === this.recvTotalFreezeDuration && (this.recvTotalFreezeDuration = 0), _ > 0 && (this.mediaStarted = !0), 0 !== _ && 0 !== C || !this.mediaStarted ? _ > 0 && (void 0 === C || C > 0) && this.recvFreezeIsOngoing && this.stopRecvDataGathering(!1) : (this.recvFreezeIsOngoing || (this.recvCurrentFreezeStartTimestamp = Date.now() - this.startTime), this.recvFreezeIsOngoing = !0, this.recvCurrentFreezeDuration += Gt.TIME_INTERVAL.SEC_1, this.recvTotalFreezeDuration += Gt.TIME_INTERVAL.SEC_1);
                    }
                }
                getIsRendering(g) {
                    return this.recvCurrentFreezeDuration < g && this.currentLowBitrateDuration < g && this.mediaStarted;
                }
                detectCaptureFreeze(g) {
                    if (g) {
                        const f = parseInt(g[g.length - 1], 10);
                        this.previousInputFrame > 0 && 0 === f && (this.sendCameraFreezeIntervalsCount += 1), this.previousInputFrame = f;
                    }
                }
                getSendCameraFreezeIntervals() {
                    return this.sendCameraFreezeIntervalsCount > 0 ? this.sendCameraFreezeIntervalsCount : void 0;
                }
                stopRecvDataGathering(g = !0) {
                    this.finalFreezeIsOngoing = this.recvFreezeIsOngoing, this.recvFreezeIsOngoing = !1, g && (this.mediaStarted = !1), this.recvCurrentFreezeDuration > 0 && (this.populateLongestRecvFreezeDuration(), this.populateRecvFreezeDurationCounts(), this.recvFreezeDurations.push(this.recvCurrentFreezeDuration), this.recvFreezeCount += 1), this.finalRecvCurrentFreezeDuration = this.recvCurrentFreezeDuration, this.recvCurrentFreezeDuration = 0;
                }
                getRecvFreezeDurationCounts() {
                    return this.recvFreezeCount > 0 ? JSON.stringify(this.receiveFreezeDurationCounts) : void 0;
                }
                getRecvFreezeDurationTimestamps(g) {
                    if (0 === this.recvFreezeCount) return;
                    const f = {};
                    return Object.keys(this.receiveFreezeDurationTimestamps).forEach((S)=>{
                        const v = this.receiveFreezeDurationTimestamps[S].length;
                        f[S] = v > g ? this.receiveFreezeDurationTimestamps[S].slice(v - g) : this.receiveFreezeDurationTimestamps[S];
                    }), JSON.stringify(f);
                }
                getRecvFreezeIsOngoing(g) {
                    return this.finalRecvCurrentFreezeDuration >= g && this.finalFreezeIsOngoing;
                }
                getRecvTotalFreezeDuration() {
                    return this.recvTotalFreezeDuration >= 0 ? this.recvTotalFreezeDuration : void 0;
                }
                getRecvAvgFreezeDuration() {
                    if (this.recvTotalFreezeDuration > 0 && this.recvFreezeCount > 0) return this.recvTotalFreezeDuration / this.recvFreezeCount;
                }
                getLongestRecvFreezeDuration() {
                    return this.longestRecvFreezeDuration > 0 ? this.longestRecvFreezeDuration : void 0;
                }
                populateRecvFreezeDurationCounts() {
                    for (const g of Object.keys(Gt.HISTOGRAM_BATCH))if (this.recvCurrentFreezeDuration <= Gt.HISTOGRAM_BATCH[g]) {
                        this.receiveFreezeDurationCounts[g] += 1, this.receiveFreezeDurationTimestamps[g].push(this.recvCurrentFreezeStartTimestamp);
                        break;
                    }
                    this.recvCurrentFreezeStartTimestamp = 0;
                }
                populateLongestRecvFreezeDuration() {
                    this.recvCurrentFreezeDuration > this.longestRecvFreezeDuration && (this.longestRecvFreezeDuration = this.recvCurrentFreezeDuration);
                }
                calculateBitrate(g, f) {
                    const S = 125, v = (g - this.lastBytesRecv) / S;
                    this.lastBytesRecv = g, v < this.configProvider.config.notRenderingLowBitrateThreshold && f < this.configProvider.config.notRenderingLowFramerateThreshold ? this.currentLowBitrateDuration++ : this.currentLowBitrateDuration = 0;
                }
                constructor(g, f){
                    this.configProvider = g, this.startTime = f, this.recvTotalFreezeDuration = -1, this.recvFreezeDurations = [], this.recvFreezeIsOngoing = !1, this.recvCurrentFreezeDuration = 0, this.recvFreezeCount = 0, this.receiveFreezeDurationCounts = {}, this.longestRecvFreezeDuration = 0, this.sendCameraFreezeIntervalsCount = 0, this.previousInputFrame = 0, this.recvCurrentFreezeStartTimestamp = 0, this.receiveFreezeDurationTimestamps = {}, this.finalFreezeIsOngoing = !1, this.finalRecvCurrentFreezeDuration = 0, this.mediaStarted = !1, this.lastBytesRecv = 0, this.currentLowBitrateDuration = 0, Object.keys(Gt.HISTOGRAM_BATCH).forEach((g)=>{
                        this.receiveFreezeDurationCounts[g] = 0, this.receiveFreezeDurationTimestamps[g] = [];
                    });
                }
            }, _I = class {
                captureMediaData(g, f, S) {
                    const v = this.mediaData[g];
                    if (g === Gt.MEDIA_DIRECTION.SEND && (this.gatheringSendData = !0), f) {
                        const g = parseInt(f[f.length - 1], 10);
                        v.totalFrameCount += g;
                    }
                    if (S) {
                        -1 === v.totalMediaDuration && (v.totalMediaDuration = 0);
                        const g = parseInt(S[S.length - 1], 10);
                        v.mediaStarted || g > 0 && (v.mediaStarted = !0, v.mediaStartTimestamp = new Date);
                    }
                    v.mediaStarted && (v.totalMediaDuration += Gt.TIME_INTERVAL.SEC_1);
                }
                captureFrameRate(g) {
                    const f = this.mediaData[Gt.MEDIA_DIRECTION.SEND];
                    if (g) {
                        const S = parseInt(g[g.length - 1], 10);
                        f.cameraFrameRate += S;
                    }
                }
                stopRecvDataGathering() {
                    const g = this.mediaData[Gt.MEDIA_DIRECTION.RECV], f = (new Date).getTime();
                    g.timeSinceLastDecode = g.totalMediaDuration > 0 ? Math.round((f - g.mediaStartTimestamp.getTime()) / 1e3) : 0, g.mediaStarted = !1;
                }
                isGatheringSendData() {
                    return this.gatheringSendData;
                }
                stopSendDataGathering() {
                    const g = this.mediaData[Gt.MEDIA_DIRECTION.SEND], f = new Date;
                    g.timeSinceLastDecode = g.totalMediaDuration > 0 ? Math.round((f.getTime() - g.mediaStartTimestamp.getTime()) / 1e3) : 0, this.gatheringSendData = !1, g.mediaStarted = !1;
                }
                getAvgFrameRate(g) {
                    const f = this.mediaData[g];
                    if (f.totalMediaDuration > 0 && f.totalFrameCount > 0) return f.totalFrameCount / f.totalMediaDuration;
                }
                getTotalDuration(g) {
                    const f = this.mediaData[g];
                    return f.totalMediaDuration >= 0 ? f.totalMediaDuration : void 0;
                }
                getTimeSinceLastDecode(g) {
                    const f = this.mediaData[g];
                    return f.timeSinceLastDecode > 0 ? f.timeSinceLastDecode : void 0;
                }
                getSendCameraFramerate() {
                    const g = this.mediaData[Gt.MEDIA_DIRECTION.SEND];
                    if (g.totalMediaDuration > 0) return g.cameraFrameRate / g.totalMediaDuration;
                }
                constructor(){
                    this.mediaData = {
                        [Gt.MEDIA_DIRECTION.SEND]: {
                            totalMediaDuration: -1,
                            totalFrameCount: 0,
                            mediaStartTimestamp: new Date,
                            mediaStarted: !1,
                            timeSinceLastDecode: 0,
                            cameraFrameRate: 0
                        },
                        [Gt.MEDIA_DIRECTION.RECV]: {
                            totalMediaDuration: -1,
                            totalFrameCount: 0,
                            mediaStartTimestamp: new Date,
                            mediaStarted: !1,
                            timeSinceLastDecode: 0,
                            cameraFrameRate: 0
                        }
                    }, this.gatheringSendData = !1;
                }
            }, CI = {
                fs: 0,
                fps: 1
            }, yI = class {
                setMaxCapabilities(g) {
                    g.forEach((g)=>{
                        if (g.ssrc || 0 === g.ssrc) {
                            this.finishIfActive(g.ssrc), this.allowed.set(g.ssrc, {
                                fs: g.maxFs + CI.fs,
                                fps: g.maxFps + CI.fps
                            });
                            const f = this.lastParams.get(g.ssrc);
                            f && this.setCurrentParams(g.ssrc, f.fs, f.fps);
                        }
                    });
                }
                setCurrentParams(g, f, S) {
                    this.lastParams.set(g, {
                        fs: f,
                        fps: S
                    });
                    const v = this.getAllowedParams(g);
                    v && (f > v.fs || S > v.fps) ? (this.captureOvershoot(g, S, v.fps, "fps"), this.captureOvershoot(g, f, v.fs, "fs")) : v && this.finishIfActive(g);
                }
                flush() {
                    this.currentEvents.forEach((g, f)=>this.finishIfActive(f));
                }
                getEvents() {
                    const g = [
                        ...deepClone(this.finishedEvents)
                    ], f = Date.now();
                    return this.currentEvents.forEach((S)=>S.forEach((S)=>g.push({
                                ssrc: S.ssrc,
                                timestamp: S.timestamp,
                                duration: f - S.timestamp,
                                overshootType: S.overshootType,
                                amount: S.amount
                            }))), g;
                }
                captureOvershoot(g, f, S, v) {
                    const _ = this.currentEvents.get(g) || [], C = _.findIndex((g)=>g.overshootType === v), E = _[C], T = f - S, I = CI[v];
                    T <= I && E ? (E.duration = Date.now() - E.timestamp, this.finishedEvents.push(E), this.logger.debug(`stopped overshooting ${v} by ${E.amount}`), _.splice(C, 1)) : T > I && !E ? (this.logger.safe.info(`overshooting ${v} by ${f - S}`), _.push({
                        ssrc: g,
                        timestamp: Date.now(),
                        duration: -1,
                        overshootType: v,
                        amount: {
                            min: T,
                            max: T
                        }
                    })) : T > I && E && (E.amount = {
                        min: Math.min(E.amount.min, T),
                        max: Math.max(E.amount.max, T)
                    }), _.length ? this.currentEvents.set(g, _) : this.currentEvents.has(g) && this.currentEvents.delete(g);
                }
                getAllowedParams(g) {
                    const f = this.allowed.get(g);
                    return f || this.allowed.get(0);
                }
                finishIfActive(g) {
                    const f = this.currentEvents.get(g);
                    if (f) {
                        const S = Date.now();
                        f.forEach((f)=>{
                            f.duration = S - f.timestamp, this.finishedEvents.push(f), this.logger.debug(`finished overshooting ${f.overshootType} by min:${f.amount.min} max:${f.amount.max} for ${f.duration}ms for ssrc ${g}`);
                        }), this.currentEvents.delete(g);
                    }
                }
                constructor(g){
                    this.logger = g, this.allowed = new Map, this.lastParams = new Map, this.currentEvents = new Map, this.finishedEvents = [];
                }
            }, EI = class {
                captureQpData(g, f, S) {
                    const v = this.qpData[g];
                    if (S && S.length > 0) {
                        const g = parseInt(S[S.length - 1], 10);
                        g > 0 && (v.frames = g);
                    }
                    if (f) {
                        const g = parseInt(f, 10);
                        g > 0 && (v.qpSum = g);
                    }
                }
                getQpAverage(g) {
                    const f = this.qpData[g];
                    if (f.qpSum > 0 && f.frames > 0) return f.qpSum / f.frames;
                }
                constructor(){
                    this.qpData = {
                        [Gt.MEDIA_DIRECTION.SEND]: {
                            frames: 0,
                            qpSum: 0
                        },
                        [Gt.MEDIA_DIRECTION.RECV]: {
                            frames: 0,
                            qpSum: 0
                        }
                    };
                }
            }, TI = class {
                get resolutionSwitchCount() {
                    return this.resolutionChangedCount;
                }
                get resolutionDurationRatios() {
                    return this.countResolutionDurationRatio(this.resDurations);
                }
                get preferredResolutionDurationRatios() {
                    return this.countResolutionDurationRatio(this.preferredResolutionDurations);
                }
                get preferredResolution() {
                    return this.preferredResolutions;
                }
                captureSample(g) {
                    g && g.width && g.height && (this.isResolutionChanged(this.lastResolution, g) && this.resolutionChanged(g), this.updateResolutionDuration(this.getResolutionKey(g), this.resDurations)), this.lastPreferredResolution && this.updatePreferredResolutionDurations();
                }
                capturePreferredResolution(g, f) {
                    const S = this.getResolutionKey(g);
                    this.preferredResolution.includes(S) || (this.preferredResolutions.length >= f && this.preferredResolutions.shift(), this.preferredResolutions.push(S)), this.isResolutionChanged(this.lastPreferredResolution, g) && (this.preferredResolutionChanged(g), this.updatePreferredResolutionDurations());
                }
                getResolutionKey(g) {
                    return `${g.width}x${g.height}`;
                }
                isResolutionChanged(g, f) {
                    return !g || g.width !== f.width || g.height !== f.height;
                }
                countResolutionDurationRatio(g) {
                    const f = {};
                    let S = 0;
                    for(const f in g)S += g[f];
                    for(const v in g)f[v] = round(g[v] / S * 100, 2);
                    return f;
                }
                updatePreferredResolutionDurations() {
                    this.updateResolutionDuration(this.getResolutionKey(this.lastPreferredResolution), this.preferredResolutionDurations);
                }
                updateResolutionDuration(g, f) {
                    f[g] || (f[g] = 0), f[g]++;
                }
                preferredResolutionChanged(g) {
                    this.lastPreferredResolution = g;
                }
                resolutionChanged(g) {
                    this.lastResolution = g, this.resolutionChangedCount++;
                }
                constructor(){
                    this.resolutionChangedCount = 0, this.resDurations = {}, this.preferredResolutionDurations = {}, this.preferredResolutions = [];
                }
            }, II = class {
                countRecvStreams(g) {
                    const f = `${g}`;
                    this.streamsTimers.hasOwnProperty(f) || (this.streamsTimers[f] = 0), this.streamsTimers[f]++;
                }
                getStreamCounts() {
                    const g = {
                        min: void 0,
                        max: void 0,
                        mode: void 0
                    }, f = Object.keys(this.streamsTimers).map(Number);
                    return 0 === f.length || 1 === f.length && 0 === f[0] || (g.min = Math.min(...f.filter((g)=>g > 0)), g.max = Math.max(...f), g.mode = f.reduce((g, f)=>this.streamsTimers[f] > this.streamsTimers[g] ? f : g, f[0])), g;
                }
                constructor(){
                    this.streamsTimers = {};
                }
            }, bI = class {
                addSubscriptionEvent(g) {
                    switch(this.subscriptionEvents.length > this.configProvider.config.webrtcSubscriptionEventLimit && this.subscriptionEvents.shift(), this.subscriptionEvents.push(g), g.evt){
                        case 1:
                            this.subscriptionCounters.attempted++;
                            break;
                        case 2:
                            this.subscriptionCounters.subscribed++;
                            break;
                        case 3:
                            this.subscriptionCounters.unsubscribed++;
                            break;
                        case -1:
                            this.subscriptionCounters.failed++;
                    }
                }
                getSubscriptionEvents() {
                    return this.subscriptionEvents.length > 0 ? {
                        events: this.subscriptionEvents
                    } : void 0;
                }
                getSubscriptionCounters() {
                    return this.subscriptionEvents.length > 0 ? this.subscriptionCounters : void 0;
                }
                constructor(g){
                    this.configProvider = g, this.subscriptionEvents = [], this.subscriptionCounters = {
                        attempted: 0,
                        subscribed: 0,
                        unsubscribed: 0,
                        failed: 0
                    };
                }
            }, AI = class {
                get trackId() {
                    return this.currentTrackId;
                }
                set trackId(g) {
                    this.currentTrackId = g;
                }
                get isRecvDataGatheringEnabled() {
                    return this.subscriptionCounter > 0;
                }
                startStopRecvDataGathering(g) {
                    this.logger.safe.info("Receive data gathering is " + (g ? "enabled" : "disabled")), g ? this.subscriptionCounter++ : this.subscriptionCounter--, this.subscriptionCounter < 0 && this.logger.safe.error(`Subscription counter should not be less than 0. Actual value is ${this.subscriptionCounter}`), 0 === this.subscriptionCounter && this.stopRecvGathering();
                }
                stopDataGathering() {
                    this.stopRecvGathering(), this.stopSendGathering();
                }
                stopRecvGathering() {
                    this.videoFreezeTelemetry.stopRecvDataGathering(), this.videoGeneralTelemetry.stopRecvDataGathering(), this.videoBitrate.stopCapture(Gt.MEDIA_DIRECTION.RECV);
                }
                isSendGathering() {
                    return this.videoGeneralTelemetry.isGatheringSendData();
                }
                stopSendGathering() {
                    this.videoGeneralTelemetry.stopSendDataGathering(), this.videoBitrate.stopCapture(Gt.MEDIA_DIRECTION.SEND), this.videoOvershoot.flush();
                }
                gatherRecvFreezeData(g, f, S) {
                    this.videoFreezeTelemetry.gatherFreezeData({
                        frameRateDecoded: g,
                        frameRateRecv: f,
                        bytesReceived: S,
                        mediaType: this.mediaType
                    });
                }
                detectCaptureFreeze(g) {
                    this.videoFreezeTelemetry.detectCaptureFreeze(g);
                }
                getRecvFreezeDurationCounts() {
                    return this.videoFreezeTelemetry.getRecvFreezeDurationCounts();
                }
                getRecvFreezeDurationTimestamps() {
                    return this.videoFreezeTelemetry.getRecvFreezeDurationTimestamps(this.configProvider.config.maxVideoFreezeTimestampsInBucket);
                }
                getRecvTotalFreezeDuration() {
                    return this.videoFreezeTelemetry.getRecvTotalFreezeDuration();
                }
                setRecvTotalFreezeDurationMs(g) {
                    this.recvTotalFreezeDurationMs = void 0 !== g ? this.recvTotalFreezeDurationMs += g : void 0;
                }
                analyzeDelay(g, f) {
                    this.videoDelayTelemetry.analyzeDelay(g, f);
                }
                getDelayCur() {
                    return this.videoDelayTelemetry.getDelayCur();
                }
                getDelayAvg() {
                    return this.videoDelayTelemetry.getDelayAvg();
                }
                addSubscriptionEvent(g) {
                    this.videoSubscriptionEvents.addSubscriptionEvent(g);
                }
                getSubscriptionEvents() {
                    return this.videoSubscriptionEvents.getSubscriptionEvents();
                }
                getSubscriptionCounters() {
                    return this.videoSubscriptionEvents.getSubscriptionCounters();
                }
                captureQpData(g, f, S) {
                    this.videoQPEvents.captureQpData(g, f, S);
                }
                getQpAverage(g) {
                    return this.videoQPEvents.getQpAverage(g);
                }
                captureMediaData(g, f, S) {
                    this.videoGeneralTelemetry.captureMediaData(g, f, S);
                }
                getIsRendering() {
                    const g = this.configProvider.config.notRenderingTimeInterval["Video" === this.mediaType ? "video" : "sharing"];
                    return this.videoFreezeTelemetry.getIsRendering(g);
                }
                captureFrameRate(g) {
                    this.videoGeneralTelemetry.captureFrameRate(g);
                }
                getTotalDuration(g) {
                    return this.videoGeneralTelemetry.getTotalDuration(g);
                }
                captureResolutionSample(g) {
                    this.videoResolutionTelemetry.captureSample(g);
                }
                countRecvStreams(g) {
                    this.videoStreamsCounters.countRecvStreams(g);
                }
                captureBitrateSample(g, f) {
                    this.videoBitrate.captureSample(g, f);
                }
                captureAllocateBandwidth(g) {
                    this.videoBitrate.captureAllocateBandwidth(g);
                }
                capturePreferredResolution(g, f) {
                    this.videoResolutionTelemetry.capturePreferredResolution(g, f);
                }
                setMaxCapabilitesRequested(g, f = !1) {
                    var _g_capabilities_;
                    this.videoMaxCapabilities.setMaxCapabilitesRequested(g), f || 1 === g.capabilities.length && !((_g_capabilities_ = g.capabilities[0]) === null || _g_capabilities_ === void 0 ? void 0 : _g_capabilities_.ssrc) || this.setMaxCapabilitiesOvershoot(g.capabilities);
                }
                setMaxCapabilitesApplied(g, f = !1) {
                    var _g_capabilities_;
                    this.videoMaxCapabilities.setMaxCapabilitesApplied(g), f || 1 === g.capabilities.length && !((_g_capabilities_ = g.capabilities[0]) === null || _g_capabilities_ === void 0 ? void 0 : _g_capabilities_.ssrc) || this.setMaxCapabilitiesOvershoot(g.capabilities);
                }
                getMaxCapabilitiesEvents() {
                    const g = this.videoMaxCapabilities.getEvents();
                    return JSON.stringify(g);
                }
                getMaxCapabilitiesResolutionChanges() {
                    const g = this.videoMaxCapabilities.getResolutionRecords();
                    return g ? JSON.stringify(g) : "";
                }
                getMaxCapabilitiesErrors() {
                    const g = this.videoMaxCapabilities.getErrors();
                    return g ? JSON.stringify(g) : "";
                }
                setCurrentParameters(g, f, S) {
                    this.videoOvershoot.setCurrentParams(g, f.height / 16 * (f.width / 16), S);
                }
                setMaxCapabilitiesOvershoot(g) {
                    this.videoOvershoot.setMaxCapabilities(g);
                }
                getOvershootEvents() {
                    let g = this.videoOvershoot.getEvents();
                    return g = g.slice(Math.max(0, g.length - (this.configProvider.config.maxReportedOvershootingEvents + 1)), g.length), g.forEach((g)=>g.timestamp = g.timestamp - this.startTime), JSON.stringify(g);
                }
                getOvershootTotalDurations() {
                    const g = this.videoOvershoot.getEvents();
                    return g.forEach((g)=>g.timestamp = g.timestamp - this.startTime), JSON.stringify({
                        fs: g.reduce((g, f)=>"fs" === f.overshootType ? g + f.duration : g, 0),
                        fps: g.reduce((g, f)=>"fps" === f.overshootType ? g + f.duration : g, 0)
                    });
                }
                setQualityLimitationReason(g) {
                    this.videoQualityLimitations.setQualityLimitationReason(g);
                }
                getQualityLimitationReasonEvents() {
                    return this.videoQualityLimitations.getQualityLimitationReasonEvents();
                }
                captureTimeToFirstFrame(g, f) {
                    -1 !== g && (this.timeToFirstFrame = g, this.timeToFirstFrameSinceSubscriptionStart = f);
                }
                getTimeToFirstFrame() {
                    return this.timeToFirstFrame;
                }
                setIsRendering(g) {
                    arrayLimitedPush2(this.isRenderingEvents, {
                        isRendering: g,
                        ts: Date.now()
                    }, this.configProvider.config.diagnostics.telemetryLimits.numIsRenderingEvents);
                }
                setMsi(g) {
                    this.msi = g;
                }
                setLocalMsi(g) {
                    this.localMsi = g;
                }
                prepareCollectingStatsOnSubscribed(g) {
                    this.videoStatsOnSubscribed.prepareCollectingStatsOnSubscribed(g);
                }
                captureStatsOnSubscribed(g, f) {
                    this.videoStatsOnSubscribed.captureStatsOnSubscribed(g, f);
                }
                calculateResolutinSwitches(g, f) {
                    this.videoResolutionSwitchTracker.captureSample(g, f);
                }
                getReport(g, f, S = !1) {
                    const v = {};
                    if (v[f + "DurationSeconds"] = this.getTotalDuration(g), v[f + "QpAvg"] = this.getQpAverage(g), v[f + "frameRateAvg"] = this.videoGeneralTelemetry.getAvgFrameRate(g), v[f + "bitrateAvg"] = this.videoBitrate.getAvg(g), v[f + "bitrateMax"] = this.videoBitrate.getMax(g), g === Gt.MEDIA_DIRECTION.SEND) v[f + "DelayCur"] = this.getDelayCur(), v[f + "DelayAvg"] = this.getDelayAvg(), v[f + "TimeSinceLastEncodeStart"] = this.videoGeneralTelemetry.getTimeSinceLastDecode(g), v[f + "AllocateBWAvg"] = this.videoBitrate.getAllocateBandwidthAvg(), v[f + "CaptureFramerateAvg"] = this.videoGeneralTelemetry.getSendCameraFramerate(), v[f + "FreezeIntervals"] = this.videoFreezeTelemetry.getSendCameraFreezeIntervals(), v[f + "MaxCapabilities"] = S ? "" : this.getMaxCapabilitiesEvents(), v[f + "MaxCapabilitiesErrors"] = S ? "" : this.getMaxCapabilitiesErrors(), v[f + "OvershootEvents"] = this.getOvershootEvents(), v[f + "OvershootDurations"] = this.getOvershootTotalDurations(), v[f + "qualityLimitationReasonEvents"] = JSON.stringify(this.getQualityLimitationReasonEvents()), v[f + "MaxCapabilitiesResolutions"] = this.getMaxCapabilitiesResolutionChanges(), v[f + "ResolutionsSwitches"] = this.videoResolutionSwitchTracker.switches ? JSON.stringify(this.videoResolutionSwitchTracker.switches) : "";
                    else if (g === Gt.MEDIA_DIRECTION.RECV) {
                        v[f + "TimeSinceLastDecodeStart"] = this.videoGeneralTelemetry.getTimeSinceLastDecode(g), v[f + "FreezeHistogram"] = this.getRecvFreezeDurationCounts(), v[f + "FreezeTimestamps"] = this.getRecvFreezeDurationTimestamps(), v[f + "LongestFreezeDuration"] = this.videoFreezeTelemetry.getLongestRecvFreezeDuration(), v[f + "RecvAvgFreezeDuration"] = this.videoFreezeTelemetry.getRecvAvgFreezeDuration(), v[f + "TotalFreezeDuration"] = this.getRecvTotalFreezeDuration(), v[f + "TotalFreezeDurationMs"] = this.recvTotalFreezeDurationMs, v[f + "OngoingFreeze"] = this.videoFreezeTelemetry.getRecvFreezeIsOngoing(this.configProvider.config.webrtcEndOfCallFreezeThreshold), v[f + "NumResolutionSwitches"] = this.videoResolutionTelemetry.resolutionSwitchCount, v[f + "PreferredResolution"] = this.videoResolutionTelemetry.preferredResolution, v[f + "PreferredResolutionDurations"] = JSON.stringify(this.videoResolutionTelemetry.preferredResolutionDurationRatios), v[f + "ResolutionDurations"] = JSON.stringify(this.videoResolutionTelemetry.resolutionDurationRatios);
                        const S = this.videoStreamsCounters.getStreamCounts();
                        v[f + "StreamsMin"] = S.min, v[f + "StreamsMax"] = S.max, v[f + "StreamsMode"] = S.mode, v[f + "TimeToFirstFrame"] = this.timeToFirstFrame, v[f + "TimeToFirstFrameSinceSubscriptionStart"] = this.timeToFirstFrameSinceSubscriptionStart, v[f + "LocalMsi"] = this.localMsi, v[f + "Msi"] = this.msi, v[f + "isRenderingEvents"] = JSON.stringify(this.isRenderingEvents), v[f + "statsOnSubscribed"] = JSON.stringify(this.videoStatsOnSubscribed.getStatsOnSubscribed());
                    }
                    return v;
                }
                constructor(g, f, S, v = "Video"){
                    var _this_configProvider_config_diagnostics_collectionLimits, _this_configProvider_config_diagnostics;
                    this.startTime = g, this.configProvider = f, this.logger = S, this.mediaType = v, this.subscriptionCounter = 0, this.videoFreezeTelemetry = new vI(this.configProvider, this.startTime), this.videoDelayTelemetry = new SI, this.videoSubscriptionEvents = new bI(this.configProvider), this.videoQPEvents = new EI, this.videoResolutionTelemetry = new TI, this.videoGeneralTelemetry = new _I, this.videoStreamsCounters = new II, this.videoBitrate = new pI, this.videoMaxCapabilities = new fI(this.configProvider, this.logger), this.videoOvershoot = new yI(this.logger), this.videoQualityLimitations = new gI(this.configProvider), this.videoStatsOnSubscribed = new qT(this.configProvider.config.maxVideoStatsAfterSubscription), this.videoResolutionSwitchTracker = new Zv((_this_configProvider_config_diagnostics = this.configProvider.config.diagnostics) === null || _this_configProvider_config_diagnostics === void 0 ? void 0 : (_this_configProvider_config_diagnostics_collectionLimits = _this_configProvider_config_diagnostics.collectionLimits) === null || _this_configProvider_config_diagnostics_collectionLimits === void 0 ? void 0 : _this_configProvider_config_diagnostics_collectionLimits.numResolutionSwitches), this.timeToFirstFrame = -1, this.timeToFirstFrameSinceSubscriptionStart = -1, this.currentTrackId = "", this.recvTotalFreezeDurationMs = 0, this.isRenderingEvents = [];
                }
            }, RI = Symbol("mslbase"), PI = Symbol("mslsamples"), wI = class {
                get collectedSessions() {
                    return this.collectedModalitySessions;
                }
                get highestFidelitySSRC() {
                    if (!this.currentModalitySession) return;
                    let g;
                    for(const f in this.currentLayouts)g = this.getHigherFidelitySSRC(f, g);
                    return parseInt(g);
                }
                processStats(g) {
                    var _g_ssrc;
                    const f = Object.values((_g_ssrc = g.ssrc) !== null && _g_ssrc !== void 0 ? _g_ssrc : {}).filter((g)=>{
                        var _this_lastMaxCapabilitiesEvent;
                        return g.rid && g.ssrc && g.googFrameHeightInput && ((_this_lastMaxCapabilitiesEvent = this.lastMaxCapabilitiesEvent) === null || _this_lastMaxCapabilitiesEvent === void 0 ? void 0 : _this_lastMaxCapabilitiesEvent.capabilities.some((f)=>f.rid === g.rid));
                    }), S = new Map(f.map((g)=>[
                            `${g.ssrc}`,
                            g.rid
                        ]));
                    for(const g in this.currentLayouts)S.has(g) || this.collectLayout(g);
                    !this.currentModalitySession && S.size > 0 && (this.currentModalitySession = {
                        timestamp: Date.now() - this.startTimestamp,
                        duration: 0,
                        numLayouts: 0,
                        layouts: []
                    }, this.logger.safe.info("Modality session started")), f.forEach((g)=>{
                        this.currentLayouts[`${g.ssrc}`] || this.addLayout(g);
                    }), 0 === S.size && this.currentModalitySession && this.collectSession(), f.forEach((g)=>this.processLayoutData(g));
                }
                setMaxCapabilities(g, f) {
                    if (this.lastMaxCapabilitiesEvent = g, Object.keys(this.currentLayouts).length) for (const S of g.capabilities){
                        const v = Object.values(this.currentLayouts).find((g)=>g.rid === S.rid);
                        v && (f ? (arrayLimitedPush2(v.fmtp, {
                            ...S,
                            timestamp: Date.now() - this.startTimestamp - this.currentModalitySession.timestamp - v.timestamp,
                            causeId: g.causeId
                        }, this.configProvider.config.simulcastTelemetryNumFMTP), v.gatherer.setMaxCapabilitesApplied(g)) : v.gatherer.setMaxCapabilitesRequested(g), v.gatherer.setMaxCapabilitiesOvershoot([
                            S
                        ]));
                    }
                }
                finish() {
                    this.logger.safe.info("Finishing statistics gathering");
                    for(const g in this.currentLayouts)this.collectLayout(g);
                    this.currentModalitySession && this.collectSession();
                }
                addLayout(g) {
                    var _this_lastMaxCapabilitiesEvent, _this_lastMaxCapabilitiesEvent1;
                    const f = `${g.ssrc}`, S = g.rid, v = (_this_lastMaxCapabilitiesEvent = this.lastMaxCapabilitiesEvent) === null || _this_lastMaxCapabilitiesEvent === void 0 ? void 0 : _this_lastMaxCapabilitiesEvent.capabilities.find((g)=>g.rid === S);
                    this.logger.safe.info(`Adding layout for ssrc ${f} rid ${S}`);
                    const _ = Date.now() - this.startTimestamp - this.currentModalitySession.timestamp, C = new AI(_, this.configProvider, this.logger.createChild(`Telemetry#${f}`));
                    this.currentLayouts[f] = {
                        ssrc: g.ssrc,
                        rid: S,
                        fmtp: [
                            {
                                ...v,
                                timestamp: _,
                                causeId: (_this_lastMaxCapabilitiesEvent1 = this.lastMaxCapabilitiesEvent) === null || _this_lastMaxCapabilitiesEvent1 === void 0 ? void 0 : _this_lastMaxCapabilitiesEvent1.causeId
                            }
                        ],
                        timestamp: _,
                        duration: 0,
                        gatherer: C,
                        [RI]: {
                            firCount: g.googFirsReceived,
                            nackCount: g.googNacksReceived,
                            pliCount: g.googPlisReceived,
                            framesEncoded: g.framesEncoded,
                            bytesSent: g.bytesSent,
                            packetsSent: g.packetsSent,
                            packetsLost: g.packetsLost,
                            qpSum: g.qpSum
                        },
                        [PI]: {
                            firCount: [],
                            nackCount: [],
                            pliCount: [],
                            framesEncoded: [],
                            bytesSent: [],
                            packetsSent: [],
                            packetsLost: [],
                            qpSum: [],
                            frameHeightInput: [],
                            frameHeightSent: [],
                            frameRateInput: [],
                            frameRateSent: []
                        }
                    }, C.setMaxCapabilitiesOvershoot([
                        v
                    ]), this.currentModalitySession.numLayouts++;
                }
                processLayoutData(g) {
                    const f = `${g.ssrc}`, S = this.currentLayouts[f];
                    this.processMediaStats(S, g), S.gatherer.captureMediaData(Gt.MEDIA_DIRECTION.SEND, [
                        String(g.googFrameRateSent)
                    ], [
                        String(g.framesEncoded)
                    ]), S.gatherer.captureFrameRate([
                        String(g.googFrameRateInput)
                    ]), S.gatherer.captureQpData(Gt.MEDIA_DIRECTION.SEND, String(g.qpSum), [
                        String(g.framesEncoded)
                    ]), S.gatherer.captureBitrateSample(Gt.MEDIA_DIRECTION.SEND, g.bytesSent), S.gatherer.detectCaptureFreeze([
                        String(g.googFrameRateInput)
                    ]), S.gatherer.setCurrentParameters(g.ssrc, {
                        width: g.googFrameWidthSent,
                        height: g.googFrameHeightSent
                    }, g.googFrameRateSent);
                }
                processMediaStats(g, f) {
                    const S = g[RI], v = f.googFirsReceived - S.firCount, _ = f.googNacksReceived - S.nackCount, C = f.googPlisReceived - S.pliCount, E = f.framesEncoded - S.framesEncoded, T = f.bytesSent - S.bytesSent, I = f.packetsSent - S.packetsSent, b = f.packetsLost - S.packetsLost, A = f.qpSum - S.qpSum, R = g[PI], P = this.configProvider.config.webrtcStatStoredRecordsNumber;
                    arrayLimitedPush2(R.firCount, v, P), arrayLimitedPush2(R.nackCount, _, P), arrayLimitedPush2(R.pliCount, C, P), arrayLimitedPush2(R.framesEncoded, E, P), arrayLimitedPush2(R.bytesSent, T, P), arrayLimitedPush2(R.packetsSent, I, P), arrayLimitedPush2(R.packetsLost, b, P), arrayLimitedPush2(R.qpSum, A, P), arrayLimitedPush2(R.frameHeightInput, f.googFrameHeightInput, P), arrayLimitedPush2(R.frameHeightSent, f.googFrameHeightSent, P), arrayLimitedPush2(R.frameRateInput, f.googFrameRateInput, P), arrayLimitedPush2(R.frameRateSent, f.googFrameRateSent, P);
                }
                collectLayout(g) {
                    this.logger.safe.info(`Collecting layout for ssrc ${g}`), this.currentLayouts[g].duration = Date.now() - this.startTimestamp - this.currentModalitySession.timestamp - this.currentLayouts[g].timestamp, this.currentLayouts[g].gatherer.isSendGathering() && this.currentLayouts[g].gatherer.stopSendGathering();
                    const f = this.currentLayouts[g].gatherer.getReport(Gt.MEDIA_DIRECTION.SEND, "", !1);
                    for(const S in f)this.currentLayouts[g][S] = f[S];
                    for(const f in this.currentLayouts[g][PI])this.currentLayouts[g][f] = sampleseries(this.currentLayouts[g][PI][f], (g)=>g);
                    delete this.currentLayouts[g].gatherer, arrayLimitedPush2(this.currentModalitySession.layouts, this.currentLayouts[g], this.configProvider.config.simulcastTelemetryLayoutsPerSession), delete this.currentLayouts[g];
                }
                collectSession() {
                    this.logger.safe.info("Collecting session");
                    for(const g in this.currentLayouts)this.collectLayout(g);
                    this.currentModalitySession.duration = Date.now() - this.startTimestamp - this.currentModalitySession.timestamp, arrayLimitedPush2(this.collectedModalitySessions, this.currentModalitySession, this.configProvider.config.simulcastTelemetryNumModalitySessions), this.currentModalitySession = void 0, this.lastMaxCapabilitiesEvent = void 0;
                }
                getHigherFidelitySSRC(g, f) {
                    if (!g || !f) return g || f;
                    const [S] = this.currentLayouts[g].fmtp.slice(-1), [v] = this.currentLayouts[f].fmtp.slice(-1);
                    var _S_maxMbps, _v_maxMbps;
                    return ((_S_maxMbps = S === null || S === void 0 ? void 0 : S.maxMbps) !== null && _S_maxMbps !== void 0 ? _S_maxMbps : 0) > 0 && ((_v_maxMbps = v === null || v === void 0 ? void 0 : v.maxMbps) !== null && _v_maxMbps !== void 0 ? _v_maxMbps : 0) > 0 ? S.maxMbps > v.maxMbps ? g : f : g || f;
                }
                constructor(g, f){
                    this.logger = g, this.configProvider = f, this.currentLayouts = {}, this.collectedModalitySessions = [], this.startTimestamp = Date.now();
                }
            }, MI = [
                "googFrameHeightReceived",
                "googFrameWidthReceived",
                "googFrameHeightSent",
                "googFrameWidthSent",
                "googFrameRateInput",
                "googFrameRateSent",
                "googNacksSent",
                "googNacksReceived",
                "googPlisSent",
                "googPlisReceived",
                "googFirsSent",
                "googFirsReceived",
                "framesDecoded",
                "googFrameRateDecoded",
                "googFrameRateReceived",
                "framesEncoded",
                "packetsLost",
                "packetsSent",
                "packetsReceived",
                "bytesReceived",
                "bytesSent",
                "googEncodeUsagePercent",
                "audioInputLevel",
                "audioOutputLevel",
                "googDecodingCTN",
                "googDecodingPLC",
                "keyFramesEncoded",
                "keyFramesDecoded",
                "googRtt",
                "concealedSamples",
                "silentConcealedSamples",
                "totalSamplesReceived",
                "healedRatio",
                "jitter",
                "googJitterBufferMs",
                "qpSum",
                "fecPacketsReceived",
                "fecPacketsDiscarded",
                "fecPacketsSent",
                "packetsDiscarded",
                "pushCount",
                "pushErrCount",
                "pullCount",
                "pullErrCount"
            ], OI = [
                "bytesSent",
                "bytesReceived",
                "googRtt",
                "packetsSent",
                "requestsSent",
                "consentRequestsSent",
                "responsesSent",
                "requestsReceived",
                "responsesReceived"
            ], DI = [
                "googAvailableReceiveBandwidth",
                "googAvailableSendBandwidth",
                "googTransmitBitrate"
            ];
            function catchStatsErrors(g, f, S) {
                const v = S.value;
                S.value = function(...g) {
                    try {
                        return v.apply(this, g);
                    } catch (g) {
                        this.processStatsError(f, g);
                    }
                };
            }
            var NI = 10, kI = class {
                get currentVideoRecvTrackId() {
                    var _this_extensions_WebRTCStats_ssrc_video_recv;
                    return (_this_extensions_WebRTCStats_ssrc_video_recv = this.extensions.WebRTCStats.ssrc_video_recv) === null || _this_extensions_WebRTCStats_ssrc_video_recv === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_video_recv.googTrackId;
                }
                get currentSharingRecvTrackId() {
                    var _this_extensions_WebRTCStats_ssrc_sharing_recv;
                    return (_this_extensions_WebRTCStats_ssrc_sharing_recv = this.extensions.WebRTCStats.ssrc_sharing_recv) === null || _this_extensions_WebRTCStats_ssrc_sharing_recv === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_sharing_recv.googTrackId;
                }
                get isMultiViewVideoTelemetry() {
                    return Object.getOwnPropertyNames(this.multiViewVideoTelemetry).length > 0;
                }
                onDeviceEvent(g) {
                    if ("stream_acquired" === g.eventType) {
                        const f = g.payload;
                        "Video" === f.mediaType && (this.cameraOpenResolution = f.resolution);
                    }
                }
                onMaxCapabilitiesRequested(g) {
                    (g.modality === Gt.MODALITY.video ? this.videoTelemetry : this.sharingTelemetry).setMaxCapabilitesRequested(g);
                    (g.modality === Gt.MODALITY.video ? this.simulcastVideo : this.simulcastSharing).setMaxCapabilities(g, !1);
                }
                onMaxCapabilitiesApplied(g) {
                    (g.modality === Gt.MODALITY.video ? this.videoTelemetry : this.sharingTelemetry).setMaxCapabilitesApplied(g);
                    (g.modality === Gt.MODALITY.video ? this.simulcastVideo : this.simulcastSharing).setMaxCapabilities(g, !0);
                }
                setSubscribedTrackIds(g) {
                    this.subscribedTrackIds = g || [];
                }
                setSubscribedTrackSsrc(g) {
                    this.subscribedTrackSsrc = g || [];
                }
                addSubscriptionEvent(g, f, S, v, _, C, E) {
                    const T = {
                        evt: g,
                        ts: Date.now() - this.extensions.StartTime,
                        msi: S,
                        localMsi: v,
                        duration: C
                    };
                    _ && (T.error = stringifyObject(_));
                    const I = this.getHandlerForModality(f);
                    if (I.addSubscriptionEvent(T), E && this.setMSIDsPair(S, v, E), 1 === g || 3 === g) {
                        const f = 1 === g;
                        I.startStopRecvDataGathering(f);
                    }
                    2 === g && I.prepareCollectingStatsOnSubscribed(S);
                }
                setMSIDsPair(g, f, S) {
                    const v = `ssrc_${S.replace(/\D/g, "")}_recv`;
                    this.MSIDsPairs[v] = {
                        msi: g,
                        localMsi: f
                    };
                }
                getHandlerForModality(g) {
                    switch(g){
                        case Gt.MODALITY.video:
                            return this.videoTelemetry;
                        case Gt.MODALITY.sharing:
                            return this.sharingTelemetry;
                        default:
                            throw new Error(`Handler not found for modality: ${g}`);
                    }
                }
                setTerminated() {
                    this.extensions.EndTime = (new Date).getTime(), this.terminated = !0;
                }
                startWaitingForStreamStart(g) {
                    this.streamStartDetection || this.sessionInfo.setOfferedModalities(g), this.streamStartDetection = !0;
                }
                processStatsDict(g) {
                    if (this.processSimulcastStats(g), this.constructWebRtcReportForSingleStream(this.extensions.WebRTCStats, g), this.streamStartDetection && (this.setStartTime(this.sessionInfo.offeredModalities) || this.terminated) && (this.streamStartDetection = !1), Object.keys(this.missedInitialPreferredResolution).length > 0 && (this.currentVideoRecvTrackId || this.currentSharingRecvTrackId) && this.setMissedInitialPreferredResolution(), this.constructWebRTCDataReport(this.extensions.WebRTCStats, g), this.calculateHwSilentState(), this.calculateSpeakingState(), this.setHealedRatioSamples(), this.calculateNetworkRecvQualityLevel(), this.calculateNetworkSendQualityLevel(), this.sessionInfo.activeModalities && (this.processBandwidthStats(), this.processAudioStats(), this.processVideoStatsRecv(this.videoTelemetry, this.extensions.WebRTCStats.ssrc_video_recv, !0), this.processVideoStatsSend(this.videoTelemetry, this.extensions.WebRTCStats.ssrc_video_send), this.processSharingStats(), this.processStreamsCounters()), this.configProvider.config.enableMultiViewStats) {
                        const f = this.extensions.WebRTCStats[Gt.MULTIPLE_RECV_STREAMS] ? this.extensions.WebRTCStats[Gt.MULTIPLE_RECV_STREAMS] : {};
                        this.constructWebRtcReportForMultipleStreams(f, g);
                        for (const g of Object.keys(f)){
                            const S = f[g];
                            this.processVideoStatsRecv(this.multiViewVideoTelemetry[g], S);
                        }
                        this.extensions.WebRTCStats[Gt.MULTIPLE_RECV_STREAMS] = f;
                    }
                    this.extensions.WebRTCStats.statsErrors = JSON.stringify(this.statsErrors);
                }
                setTimeToFirstFrame(g, f, S) {
                    S in this.timeToFirstFrame || (this.timeToFirstFrame[S] = g, this.timeToFirstFrameSinceSubscriptionStart[S] = f);
                }
                getCurrentTimeToFirstFrame(g) {
                    return this.timeToFirstFrame[g] ? this.timeToFirstFrame[g] : -1;
                }
                getCurrentTimeToFirstFrameSinceSubscriptionStart(g) {
                    return this.timeToFirstFrameSinceSubscriptionStart[g] ? this.timeToFirstFrameSinceSubscriptionStart[g] : -1;
                }
                getVideoTelemetryBySsrc(g) {
                    let f;
                    return this.extensions.WebRTCStats.ssrc_video_recv && this.extensions.WebRTCStats.ssrc_video_recv.id === g ? f = this.videoTelemetry : this.extensions.WebRTCStats.ssrc_sharing_recv && this.extensions.WebRTCStats.ssrc_sharing_recv.id === g ? f = this.sharingTelemetry : this.isMultiViewVideoTelemetry && (f = this.multiViewVideoTelemetry[g]), f;
                }
                getIsRendering(g) {
                    const f = this.getVideoTelemetryBySsrc(g);
                    return f ? f.getIsRendering() : void 0;
                }
                setFreezeDuration(g, f) {
                    for (const S of Object.keys(this.multiViewVideoTelemetry))this.multiViewVideoTelemetry[S].trackId === f && this.isSubscribed(f) && this.multiViewVideoTelemetry[S].setRecvTotalFreezeDurationMs(g);
                    this.currentSharingRecvTrackId === f && this.isSubscribed(f) && this.sharingTelemetry.setRecvTotalFreezeDurationMs(g), this.currentVideoRecvTrackId === f && this.isSubscribed(f) && this.videoTelemetry.setRecvTotalFreezeDurationMs(g);
                }
                addVideoControlMessage(g) {
                    this.totalVideoControlMessages++, g && this.outOfOrderVideoControlMessages++;
                }
                setStreamSenderStarted(g, f) {
                    this.streamSenderStarted[g] = f;
                }
                addReportedReceiveBandwidth(g) {
                    this.limitCaptureAmount(this.extensions, "ReportedReceiveBandwidth", g);
                }
                setHealedRatioSamples() {
                    var _this_extensions_WebRTCStats_ssrc_audio_recv, _this_extensions_WebRTCStats, _this_extensions, _this_extensions_WebRTCStats_ssrc_audio_recv1, _this_extensions_WebRTCStats1, _this_extensions1, _this_extensions_WebRTCStats_ssrc_audio_recv2, _this_extensions_WebRTCStats2, _this_extensions2;
                    this.audioHealedRatioTelemetry.captureHealedRatioSamples((_this_extensions = this.extensions) === null || _this_extensions === void 0 ? void 0 : (_this_extensions_WebRTCStats = _this_extensions.WebRTCStats) === null || _this_extensions_WebRTCStats === void 0 ? void 0 : (_this_extensions_WebRTCStats_ssrc_audio_recv = _this_extensions_WebRTCStats.ssrc_audio_recv) === null || _this_extensions_WebRTCStats_ssrc_audio_recv === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_recv.concealedSamples, (_this_extensions1 = this.extensions) === null || _this_extensions1 === void 0 ? void 0 : (_this_extensions_WebRTCStats1 = _this_extensions1.WebRTCStats) === null || _this_extensions_WebRTCStats1 === void 0 ? void 0 : (_this_extensions_WebRTCStats_ssrc_audio_recv1 = _this_extensions_WebRTCStats1.ssrc_audio_recv) === null || _this_extensions_WebRTCStats_ssrc_audio_recv1 === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_recv1.silentConcealedSamples, (_this_extensions2 = this.extensions) === null || _this_extensions2 === void 0 ? void 0 : (_this_extensions_WebRTCStats2 = _this_extensions2.WebRTCStats) === null || _this_extensions_WebRTCStats2 === void 0 ? void 0 : (_this_extensions_WebRTCStats_ssrc_audio_recv2 = _this_extensions_WebRTCStats2.ssrc_audio_recv) === null || _this_extensions_WebRTCStats_ssrc_audio_recv2 === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_recv2.totalSamplesReceived);
                }
                processSimulcastStats(g) {
                    this.simulcastVideo.processStats(g), this.simulcastSharing.processStats(g);
                }
                processBandwidthStats() {
                    var _this_extensions_WebRTCStats_bweStat;
                    const g = (_this_extensions_WebRTCStats_bweStat = this.extensions.WebRTCStats.bweStat) === null || _this_extensions_WebRTCStats_bweStat === void 0 ? void 0 : _this_extensions_WebRTCStats_bweStat.googAvailableSendBandwidth;
                    if (g) {
                        const f = this.streamSenderStarted.Video || this.streamSenderStarted.ScreenShare;
                        this.bandwidthTelemetry.recordSendBandwidth(g[g.length - 1]), this.stabilizationTelemetry.processBandwidth(parseInt(g[g.length - 1]), this.sessionInfo.activeModalities, f);
                    }
                }
                processAudioStats() {
                    var _this_extensions_WebRTCStats_ssrc_audio_recv, _this_extensions_WebRTCStats_ssrc_audio_recv1, _this_extensions_WebRTCStats_ssrc_audio_send;
                    if (this.extensions.WebRTCStats.ssrc_audio_send && this.limitCaptureAmount(this.extensions, "Audio_send_RawInputVolume", this.audioTelemetry.getInputLevel("Audio")), void 0 !== ((_this_extensions_WebRTCStats_ssrc_audio_recv = this.extensions.WebRTCStats.ssrc_audio_recv) === null || _this_extensions_WebRTCStats_ssrc_audio_recv === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_recv.googJitterBufferMs) && this.audioTelemetry.captureJitterBuffer((0, nI.last)(this.extensions.WebRTCStats.ssrc_audio_recv.googJitterBufferMs)), void 0 !== ((_this_extensions_WebRTCStats_ssrc_audio_recv1 = this.extensions.WebRTCStats.ssrc_audio_recv) === null || _this_extensions_WebRTCStats_ssrc_audio_recv1 === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_recv1.jitter) && this.audioTelemetry.captureJitter((0, nI.last)(this.extensions.WebRTCStats.ssrc_audio_recv.jitter)), (_this_extensions_WebRTCStats_ssrc_audio_send = this.extensions.WebRTCStats.ssrc_audio_send) === null || _this_extensions_WebRTCStats_ssrc_audio_send === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_send.googRtt) {
                        const g = this.extensions.WebRTCStats.ssrc_audio_send.googRtt;
                        this.audioTelemetry.captureRtt(g[g.length - 1]);
                    }
                }
                stopGatheringIfNeeded(g, f, S, v) {
                    const _ = `${f}${S}`;
                    v !== this.lastSSRCs.get(_) && (this.lastSSRCs.set(_, v), f === Gt.MEDIA_DIRECTION.SEND ? g.stopSendGathering() : g.stopRecvGathering());
                }
                processVideoStatsSend(g, f) {
                    var _this_extensions_WebRTCStats_bweStat, _this_configProvider_config_specCompliantSimulcast;
                    f && hasSendDirectionality(this.sessionInfo.activeModalities.video) ? (this.stopGatheringIfNeeded(g, Gt.MEDIA_DIRECTION.SEND, "Video", f.ssrc), g.captureMediaData(Gt.MEDIA_DIRECTION.SEND, f.googFrameRateSent, f.framesEncoded), g.captureFrameRate(f.googFrameRateInput), g.analyzeDelay(this.videoDelayTimePeriod, f.googAvgEncodeMs), g.captureQpData(Gt.MEDIA_DIRECTION.SEND, f.qpSum, f.framesEncoded), g.captureBitrateSample(Gt.MEDIA_DIRECTION.SEND, this.getLastSampleInt(f.bytesSent)), g.detectCaptureFreeze(f.googFrameRateInput), g.captureAllocateBandwidth((_this_extensions_WebRTCStats_bweStat = this.extensions.WebRTCStats.bweStat) === null || _this_extensions_WebRTCStats_bweStat === void 0 ? void 0 : _this_extensions_WebRTCStats_bweStat.googAvailableSendBandwidth), g.setCurrentParameters(parseInt(f.ssrc), {
                        width: this.getLastSampleInt(f.googFrameWidthSent),
                        height: this.getLastSampleInt(f.googFrameHeightSent)
                    }, this.getLastSampleInt(f.googFrameRateSent)), g.setQualityLimitationReason(f.qualityLimitationReason), ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.collectResolutionInfo) && g.calculateResolutinSwitches(this.getLastSampleInt(f.googFrameWidthSent), this.getLastSampleInt(f.googFrameHeightSent))) : g.isSendGathering() && (g.stopSendGathering(), this.lastSSRCs.delete(`${Gt.MEDIA_DIRECTION.SEND}Video`));
                }
                processVideoStatsRecv(g, f, S = !1) {
                    f && hasReceiveDirectionality(this.sessionInfo.activeModalities.video) && this.videoTelemetry.isRecvDataGatheringEnabled ? (S && this.stopGatheringIfNeeded(g, Gt.MEDIA_DIRECTION.RECV, "Video", f.ssrc), g.trackId = f.googTrackId, g.gatherRecvFreezeData(f.googFrameRateDecoded, f.googFrameRateReceived, this.getLastSampleInt(f.bytesReceived)), g.captureMediaData(Gt.MEDIA_DIRECTION.RECV, f.googFrameRateReceived, f.googFrameRateDecoded), g.captureTimeToFirstFrame(this.getCurrentTimeToFirstFrame(f.googTrackId), this.getCurrentTimeToFirstFrameSinceSubscriptionStart(f.googTrackId)), g.captureQpData(Gt.MEDIA_DIRECTION.RECV, f.qpSum, f.framesDecoded), g.captureBitrateSample(Gt.MEDIA_DIRECTION.RECV, this.getLastSampleInt(f.bytesReceived)), g.captureResolutionSample({
                        width: this.getLastSampleInt(f.googFrameWidthReceived),
                        height: this.getLastSampleInt(f.googFrameHeightReceived)
                    }), g.captureStatsOnSubscribed(this.getLastSampleInt(f.framesDecoded), this.getLastSampleInt(f.bytesReceived))) : S && this.lastSSRCs.delete(`${Gt.MEDIA_DIRECTION.RECV}Video`);
                }
                processSharingStats() {
                    var _this_extensions_WebRTCStats_bweStat;
                    const g = this.extensions.WebRTCStats.ssrc_sharing_send, f = this.extensions.WebRTCStats.ssrc_sharing_recv;
                    g && hasSendDirectionality(this.sessionInfo.activeModalities.sharing) ? (this.stopGatheringIfNeeded(this.sharingTelemetry, Gt.MEDIA_DIRECTION.SEND, "Sharing", g.ssrc), this.sharingTelemetry.captureMediaData(Gt.MEDIA_DIRECTION.SEND, g.googFrameRateSent, g.framesEncoded), this.sharingTelemetry.captureFrameRate(g.googFrameRateInput), this.sharingTelemetry.analyzeDelay(this.videoDelayTimePeriod, g.googAvgEncodeMs), this.sharingTelemetry.captureQpData(Gt.MEDIA_DIRECTION.SEND, g.qpSum, g.framesEncoded), this.sharingTelemetry.captureBitrateSample(Gt.MEDIA_DIRECTION.SEND, this.getLastSampleInt(g.bytesSent)), this.sharingTelemetry.detectCaptureFreeze(g.googFrameRateInput), this.sharingTelemetry.captureAllocateBandwidth((_this_extensions_WebRTCStats_bweStat = this.extensions.WebRTCStats.bweStat) === null || _this_extensions_WebRTCStats_bweStat === void 0 ? void 0 : _this_extensions_WebRTCStats_bweStat.googAvailableSendBandwidth), this.sharingTelemetry.setCurrentParameters(parseInt(g.ssrc), {
                        width: this.getLastSampleInt(g.googFrameWidthSent),
                        height: this.getLastSampleInt(g.googFrameHeightSent)
                    }, this.getLastSampleInt(g.googFrameRateSent)), this.limitCaptureAmount(this.extensions, "Sharing_send_RawInputVolume", this.audioTelemetry.getInputLevel("ScreenShare"))) : this.sharingTelemetry.isSendGathering() && (this.sharingTelemetry.stopSendGathering(), this.lastSSRCs.delete(`${Gt.MEDIA_DIRECTION.SEND}Sharing`)), f && hasReceiveDirectionality(this.sessionInfo.activeModalities.sharing) && this.sharingTelemetry.isRecvDataGatheringEnabled ? (this.stopGatheringIfNeeded(this.sharingTelemetry, Gt.MEDIA_DIRECTION.RECV, "Sharing", f.ssrc), this.sharingTelemetry.trackId = f.googTrackId, this.sharingTelemetry.gatherRecvFreezeData(f.googFrameRateDecoded, f.googFrameRateReceived), this.sharingTelemetry.captureMediaData(Gt.MEDIA_DIRECTION.RECV, f.googFrameRateReceived, f.googFrameRateDecoded), this.sharingTelemetry.captureTimeToFirstFrame(this.getCurrentTimeToFirstFrame(f.googTrackId), this.getCurrentTimeToFirstFrameSinceSubscriptionStart(f.googTrackId)), this.sharingTelemetry.captureQpData(Gt.MEDIA_DIRECTION.RECV, f.qpSum, f.framesDecoded), this.sharingTelemetry.captureBitrateSample(Gt.MEDIA_DIRECTION.RECV, this.getLastSampleInt(f.bytesReceived)), this.sharingTelemetry.captureResolutionSample({
                        width: this.getLastSampleInt(f.googFrameWidthReceived),
                        height: this.getLastSampleInt(f.googFrameHeightReceived)
                    }), this.sharingTelemetry.captureStatsOnSubscribed(this.getLastSampleInt(f.framesDecoded), this.getLastSampleInt(f.bytesReceived))) : this.lastSSRCs.delete(`${Gt.MEDIA_DIRECTION.RECV}Sharing`);
                }
                processStreamsCounters() {
                    const g = this.extensions.WebRTCStats.recvCounters;
                    g && (this.videoTelemetry.countRecvStreams(g[Gt.MODALITY.video]), this.sharingTelemetry.countRecvStreams(g[Gt.MODALITY.sharing]));
                }
                setMissedInitialPreferredResolution() {
                    forOwn(this.missedInitialPreferredResolution, (g, f)=>{
                        this.setPreferredResolution(f, g);
                    }), this.missedInitialPreferredResolution = {};
                }
                setPreferredResolution(g, f, S) {
                    if ((S === Gt.MEDIA_TYPE.video && !this.currentVideoRecvTrackId || S === Gt.MEDIA_TYPE.sharing && !this.currentSharingRecvTrackId) && (this.missedInitialPreferredResolution[g] = f), this.currentVideoRecvTrackId === g && this.videoTelemetry.capturePreferredResolution(f, this.maxStoredPreferredResolutions), this.currentSharingRecvTrackId === g && this.sharingTelemetry.capturePreferredResolution(f, this.maxStoredPreferredResolutions), this.isMultiViewVideoTelemetry) {
                        const S = this.multiViewVideoTelemetry[this.getSsrcIdFromMultipleVideoStream(g)];
                        S && S.capturePreferredResolution(f, this.maxStoredPreferredResolutions);
                    }
                }
                setIsRendering(g, f, S) {
                    var _this_multiViewVideoTelemetry_this_getSsrcIdFromMultipleVideoStream;
                    f === Gt.MEDIA_TYPE.video && this.videoTelemetry.setIsRendering(g), f === Gt.MEDIA_TYPE.sharing && this.sharingTelemetry.setIsRendering(g), this.isMultiViewVideoTelemetry && ((_this_multiViewVideoTelemetry_this_getSsrcIdFromMultipleVideoStream = this.multiViewVideoTelemetry[this.getSsrcIdFromMultipleVideoStream(S)]) === null || _this_multiViewVideoTelemetry_this_getSsrcIdFromMultipleVideoStream === void 0 ? void 0 : _this_multiViewVideoTelemetry_this_getSsrcIdFromMultipleVideoStream.setIsRendering(g));
                }
                setMaxSessionBandwidth(g) {
                    this.extensions.MaxSessionBandwidth = g;
                }
                isSubscribed(g, f) {
                    let S = this.subscribedTrackIds.some((f)=>f === g);
                    return !S && this.configProvider.config.subscribeToSsrcForVideo && (S = this.subscribedTrackSsrc.some((g)=>g === `${f}`)), S || !this.multiparty && this.configProvider.config.subscribeToSsrcForVideo;
                }
                getReport(g = !1, f = !1) {
                    try {
                        f && this.resetPairValues(), g || (this.videoTelemetry.stopDataGathering(), this.sharingTelemetry.stopDataGathering());
                        const S = this.videoTelemetry.getTotalDuration(Gt.MEDIA_DIRECTION.RECV), v = this.videoTelemetry.getTotalDuration(Gt.MEDIA_DIRECTION.SEND), _ = this.sharingTelemetry.getTotalDuration(Gt.MEDIA_DIRECTION.RECV), C = this.sharingTelemetry.getTotalDuration(Gt.MEDIA_DIRECTION.SEND);
                        if (S >= 0 && (forOwn(this.videoTelemetry.getReport(Gt.MEDIA_DIRECTION.RECV, "Video_recv_", f), (g, f)=>this.extensions[f] = g), !isEmpty(this.multiViewVideoTelemetry))) {
                            const g = [];
                            for (const S of Object.keys(this.multiViewVideoTelemetry)){
                                const v = {
                                    id: S
                                };
                                forOwn(this.multiViewVideoTelemetry[S].getReport(Gt.MEDIA_DIRECTION.RECV, "Video", f), (g, f)=>{
                                    void 0 !== g && (v[f] = g);
                                }), g.push(v);
                            }
                            this.extensions[Gt.MULTIPLE_RECV_STREAMS] = JSON.stringify(g);
                        }
                        _ >= 0 && forOwn(this.sharingTelemetry.getReport(Gt.MEDIA_DIRECTION.RECV, "Sharing_recv_", f), (g, f)=>this.extensions[f] = g), v >= 0 && (forOwn(this.videoTelemetry.getReport(Gt.MEDIA_DIRECTION.SEND, "Video_send_", f), (g, f)=>this.extensions[f] = g), this.extensions.Bandwidth_jumpsHistogram = JSON.stringify(this.bandwidthTelemetry.getReport()), this.extensions.Bandwidth_uplinkStabilizationTime = JSON.stringify(this.stabilizationTelemetry.getReport(!0)), this.extensions.Video_send_CameraOpenWidth = this.cameraOpenResolution.width, this.extensions.Video_send_CameraOpenHeight = this.cameraOpenResolution.height), C >= 0 && forOwn(this.sharingTelemetry.getReport(Gt.MEDIA_DIRECTION.SEND, "Sharing_send_", f), (g, f)=>this.extensions[f] = g), g || f || (this.simulcastVideo.finish(), this.extensions.Video_send_Simulcast = JSON.stringify(this.simulcastVideo.collectedSessions), this.simulcastSharing.finish(), this.extensions.Sharing_send_Simulcast = JSON.stringify(this.simulcastSharing.collectedSessions)), this.iceCandidateErrors.length > 0 && (this.extensions.iceCandidateErrors = JSON.stringify(this.iceCandidateErrors)), this.extensions.Audio_recv_jitterBufferAvgSize = this.audioTelemetry.getAvgJitterBuffer(), this.extensions.Audio_recv_jitterMax = this.audioTelemetry.getJitterMax(), this.extensions.Audio_recv_jitterAvg = this.audioTelemetry.getJitterAvg(), this.extensions.Video_SubscriptionEvents = f ? "" : JSON.stringify(this.videoTelemetry.getSubscriptionEvents()), this.extensions.Video_SubscriptionCounters = f ? "" : JSON.stringify(this.videoTelemetry.getSubscriptionCounters()), this.extensions.Sharing_SubscriptionEvents = f ? "" : JSON.stringify(this.sharingTelemetry.getSubscriptionEvents()), this.extensions.Sharing_SubscriptionCounters = f ? "" : JSON.stringify(this.sharingTelemetry.getSubscriptionCounters()), this.extensions.Audio_recv_healedRatioMax = this.audioHealedRatioTelemetry.getHealedRatioMax(), this.extensions.Audio_recv_healedRatioAvg = this.audioHealedRatioTelemetry.getHealedRatioAvg(), this.extensions.Audio_send_rttAvg = this.audioTelemetry.getAvgRtt(), this.extensions.Audio_send_rttMax = this.audioTelemetry.getMaxRtt();
                        for (const g of Object.keys(this.extensions))void 0 === this.extensions[g] && delete this.extensions[g];
                        delete this.extensions.WebRTCStats[Gt.MULTIPLE_RECV_STREAMS], this.sessionInfo.fillExtensionInfo(this.extensions);
                        return Object.keys(this.extensions.WebRTCStats).length > 0 && !this.extensions.WebRTCStats.hasStatsError && this.calculateAverages(), this.extensions.H264_available_profiles = this.h264AvailableProfiles.join(), this.extensions.H264_codec_capabilities = JSON.stringify(this.h264CodecCapabilities), this.extensions.Video_recv_MSIDs = Array.from(this.MSIDs), this.totalVideoControlMessages > 0 && (this.extensions.totalVideoControlMessages = this.totalVideoControlMessages, this.extensions.outOfOrderVideoControlMessages = this.outOfOrderVideoControlMessages), deepClone(this.report);
                    } catch (g) {
                        throw this.processStatsError("Report", g), {
                            error: g,
                            partialReport: deepClone(this.report)
                        };
                    }
                }
                getAudioHwSilent() {
                    return this.hwSilent;
                }
                getSpeakingState() {
                    return this.isSpeaking;
                }
                getNetworkSendLevel() {
                    return this.networkSendLevel;
                }
                getNetworkRecvLevel() {
                    return this.networkRecvLevel;
                }
                addIceCandidateError(g) {
                    this.iceCandidateErrors.push(g);
                }
                clearIceCandidateErrors() {
                    this.iceCandidateErrors = [];
                }
                addH264AvailableProfiles(g) {
                    this.h264AvailableProfiles = [
                        ...new Set(this.h264AvailableProfiles.concat(g))
                    ];
                }
                setSupportedH264Profiles(g, f) {
                    this.h264CodecCapabilities.sendProfiles = g, this.h264CodecCapabilities.receiveProfiles = f;
                }
                updateSendStream(g, f) {
                    this.audioTelemetry.updateSendStream(g, f);
                }
                getTimerTracker(g, f) {
                    return this.timerTrackerManager.getTimerTracker(g, f);
                }
                resetPairValues() {
                    Object.keys(this.extensions.WebRTCStats).forEach((g)=>{
                        delete this.extensions.WebRTCStats[g].pair;
                    });
                }
                limitCaptureAmount(g, f, S) {
                    void 0 !== S && (g[f] = Array.isArray(g[f]) ? g[f] : [], g[f].push(S), g[f].length > this.storedRecordsNumber && g[f].shift());
                }
                setStartTime(g) {
                    const f = this.extensions.WebRTCStats;
                    if (!f.ssrc_audio_send || !f.ssrc_audio_recv) return !1;
                    const setupCounter = (g, f)=>!g || f && -1 === f ? f : (new Date).getTime();
                    return this.extensions.TimerAudioPayloadRecvBitrate = hasReceiveDirectionality(g.audio) ? setupCounter(f.ssrc_audio_recv.bytesReceived, this.extensions.TimerAudioPayloadRecvBitrate) : -1, this.extensions.TimerAudioPayloadSendBitrate = hasSendDirectionality(g.audio) ? setupCounter(f.ssrc_audio_send.bytesSent, this.extensions.TimerAudioPayloadSendBitrate) : -1, this.extensions.TimerAudioTransportRecvBitrate = hasReceiveDirectionality(g.audio) ? setupCounter(f.ssrc_audio_recv.bytesReceived, this.extensions.TimerAudioTransportRecvBitrate) : -1, this.extensions.TimerAudioTransportSendBitrate = hasSendDirectionality(g.audio) ? setupCounter(f.ssrc_audio_send.bytesSent, this.extensions.TimerAudioTransportSendBitrate) : -1, !(!f.ssrc_video_send || !f.ssrc_video_recv) && (this.extensions.TimerVideoPayloadRecvBitrate = hasReceiveDirectionality(g.video) ? setupCounter(f.ssrc_video_recv.bytesReceived, this.extensions.TimerVideoPayloadRecvBitrate) : -1, this.extensions.TimerVideoPayloadSendBitrate = hasSendDirectionality(g.video) ? setupCounter(f.ssrc_video_send.bytesSent, this.extensions.TimerVideoSendBitrate) : -1, !!(this.extensions.TimerVideoPayloadRecvBitrate && this.extensions.TimerVideoPayloadSendBitrate && this.extensions.TimerAudioPayloadRecvBitrate && this.extensions.TimerAudioPayloadSendBitrate && this.extensions.TimerAudioTransportRecvBitrate && this.extensions.TimerAudioTransportSendBitrate));
                }
                calculateAverages() {
                    const g = this.extensions.EndTime, doTheCalc = (f, S)=>f && g - S > 0 && 0 !== S && -1 !== S ? Math.round(8 * f / (g - S)) : 0, getCounter = (g)=>{
                        const f = g.split(".").reduce((g, f)=>null == g ? g : g[f], this.extensions.WebRTCStats);
                        return Array.isArray(f) ? f[f.length - 1] : f;
                    };
                    this.extensions.AudioPayloadRecvBitrate = doTheCalc(getCounter("ssrc_audio_recv.bytesReceived"), this.extensions.TimerAudioPayloadRecvBitrate), this.extensions.AudioPayloadSendBitrate = doTheCalc(getCounter("ssrc_audio_send.bytesSent"), this.extensions.TimerAudioPayloadSendBitrate), this.extensions.VideoPayloadRecvBitrate = doTheCalc(getCounter("ssrc_video_recv.bytesReceived"), this.extensions.TimerVideoPayloadRecvBitrate), this.extensions.VideoPayloadSendBitrate = doTheCalc(getCounter("ssrc_video_send.bytesSent"), this.extensions.TimerVideoPayloadSendBitrate), this.extensions.AudioTransportRecvBitrate = doTheCalc(getCounter("ssrc_audio_send.pair.bytesReceived"), this.extensions.TimerAudioTransportRecvBitrate), this.extensions.AudioTransportSendBitrate = doTheCalc(getCounter("ssrc_audio_send.pair.bytesSent"), this.extensions.TimerAudioTransportSendBitrate);
                }
                addFilteredFields(g, f, S = []) {
                    for(const v in f)if (f.hasOwnProperty(v) && "type" !== v) {
                        if (-1 !== S.indexOf(v)) {
                            const S = g[v] || [];
                            S.push(this.formatFields(f, v)), S.length > this.storedRecordsNumber && S.shift(), g[v] || (g[v] = S);
                        } else g[v] = f[v];
                    }
                }
                formatFields(g, f) {
                    const S = g[f];
                    switch(f){
                        case "audioInputLevel":
                        case "audioOutputLevel":
                            return this.newStatsApi ? Math.floor(65535 * S) : 2 * S;
                        case "googJitterBufferMs":
                            return parseInt(S);
                        case "healedRatio":
                            return round(parseFloat(S), this.configProvider.config.healedRatioPrecision);
                        case "jitter":
                            return round(parseFloat(S), this.configProvider.config.jitterPrecision);
                        default:
                            return S;
                    }
                }
                processSource(g, f, S) {
                    let v;
                    if (this.addFilteredFields(g, f, MI), f.transportId) {
                        var _S_googComponent, _S_googCandidatePair;
                        const _ = (_S_googComponent = S.googComponent) === null || _S_googComponent === void 0 ? void 0 : _S_googComponent[f.transportId];
                        g.transport || (g.transport = {}), _ && (this.addFilteredFields(g.transport, _), _.selectedCandidatePairId && (v = (_S_googCandidatePair = S.googCandidatePair) === null || _S_googCandidatePair === void 0 ? void 0 : _S_googCandidatePair[_.selectedCandidatePairId]));
                    } else v = Object.values(S.googCandidatePair).find((g)=>g.selected);
                    v && (g.pair || (g.pair = {}), this.addFilteredFields(g.pair, v, OI));
                }
                getWebrtcReport(g, f, S, v) {
                    const _ = g.ssrc[S], C = v ? _.id.replace(/[0-9]+/, v) : _.id;
                    f[C] ? _.ssrc !== f[C].ssrc && (C.endsWith("video_send") ? this.videoTelemetry.stopSendGathering() : C.endsWith("video_recv") ? this.videoTelemetry.stopRecvGathering() : C.endsWith("sharing_send") ? this.sharingTelemetry.stopSendGathering() : C.endsWith("sharing_recv") && this.sharingTelemetry.stopRecvGathering()) : f[C] = {}, this.processSource(f[C], _, g);
                }
                constructWebRTCDataReport(g, f) {
                    var _f_data;
                    if (!((_f_data = f.data) === null || _f_data === void 0 ? void 0 : _f_data.length)) return;
                    const S = f.data.sort((g, f)=>f.timestamp - g.timestamp), v = S.find((g)=>"open" === g.state);
                    g.data = v || S[0];
                }
                constructWebRtcReportForSingleStream(g, f) {
                    var _f_VideoBwe;
                    if (!f.ssrc) return;
                    const S = this.selectSsrcsToCollect(f.ssrc);
                    g.recvCounters = S.recvCounters, delete S.recvCounters, delete S.multiRecv, forOwn(S, (S)=>{
                        forOwn(S, (S, v)=>{
                            this.getWebrtcReport(f, g, S, v);
                        });
                    }), ((_f_VideoBwe = f.VideoBwe) === null || _f_VideoBwe === void 0 ? void 0 : _f_VideoBwe.bweforvideo) && (g.bweStat || (g.bweStat = {}), this.addFilteredFields(g.bweStat, f.VideoBwe.bweforvideo, DI));
                }
                constructWebRtcReportForMultipleStreams(g, f) {
                    if (!f.ssrc) return;
                    this.selectSsrcsToCollect(f.ssrc).multiRecv.forEach((S)=>this.getWebrtcReport(f, g, S));
                }
                getMediaType(g, f) {
                    var _g_googTrackId;
                    let S = f ? f.getModality() : g.mediaType;
                    return ((_g_googTrackId = g.googTrackId) === null || _g_googTrackId === void 0 ? void 0 : _g_googTrackId.match("applicationsharing")) && S !== Gt.MEDIA_TYPE.sharing && (S = Gt.MEDIA_TYPE.sharing), S;
                }
                selectSsrcsToCollect(g) {
                    const f = {
                        send: {},
                        recv: {},
                        recvCounters: {
                            video: 0,
                            sharing: 0
                        },
                        multiRecv: []
                    };
                    if (!this.sessionInfo.activeModalities) return f;
                    let S = [];
                    for (const v of Object.keys(g)){
                        const _ = g[v], C = _.googTrackId;
                        if (!C && _.mediaType !== Gt.MEDIA_TYPE.audio) continue;
                        const E = this.getMediaEntity(C, _), T = this.getMediaType(_, E), I = E === null || E === void 0 ? void 0 : E.getXSourceStreamId();
                        if (v.endsWith("send")) switch(T){
                            case Gt.MEDIA_TYPE.audio:
                                hasSendDirectionality(this.sessionInfo.activeModalities.audio) && (f.send.audio = v);
                                break;
                            case Gt.MEDIA_TYPE.video:
                                if (this.extensions.Video_send_SourceId = I, this.simulcastVideo.highestFidelitySSRC) {
                                    this.simulcastVideo.highestFidelitySSRC === _.ssrc && (f.send.video = v);
                                    break;
                                }
                                this.streamSenderStarted.Video && hasSendDirectionality(this.sessionInfo.activeModalities.video) && (E === null || E === void 0 ? void 0 : E.getLocalTrackId()) && ((E === null || E === void 0 ? void 0 : E.getLocalTrackId()) === _.googTrackId || this.configProvider.config.statsAllowAnyVideoSendTrack && !f.send.video) && (!_.rid || "1" === _.rid) && (f.send.video = v);
                                break;
                            case Gt.MEDIA_TYPE.sharing:
                                if (this.simulcastSharing.highestFidelitySSRC) {
                                    this.simulcastSharing.highestFidelitySSRC === _.ssrc && (f.send.sharing = v);
                                    break;
                                }
                                this.streamSenderStarted.ScreenShare && hasSendDirectionality(this.sessionInfo.activeModalities.sharing) && (E === null || E === void 0 ? void 0 : E.getLocalTrackId()) === _.googTrackId && (f.send.sharing = v);
                                break;
                            default:
                                this.logger.warn(`Unknown media type '${T}'`);
                        }
                        else if (v.endsWith("recv")) switch(T){
                            case Gt.MEDIA_TYPE.audio:
                                hasReceiveDirectionality(this.sessionInfo.activeModalities.audio) && (f.recv.audio = v);
                                break;
                            case Gt.MEDIA_TYPE.video:
                                void 0 !== I && this.MSIDs.add(I), this.isSubscribed(_.googTrackId, _.ssrc) && hasReceiveDirectionality(this.sessionInfo.activeModalities.video) && (S.push(_), +_.googFrameRateReceived > 0 && f.recvCounters[Gt.MODALITY.video]++);
                                break;
                            case Gt.MEDIA_TYPE.sharing:
                                this.isSubscribed(_.googTrackId, _.ssrc) && hasReceiveDirectionality(this.sessionInfo.activeModalities.sharing) && (f.recv.sharing = v, +_.googFrameRateReceived > 0 && f.recvCounters[Gt.MODALITY.sharing]++);
                                break;
                            default:
                                this.logger.warn(`Unknown media type '${T}'`);
                        }
                    }
                    if (S.length > 0) {
                        S = S.sort((g, f)=>+f.googFrameHeightReceived - +g.googFrameHeightReceived);
                        const g = S.find((g)=>g.mediaType === Gt.MEDIA_TYPE.video);
                        g && (f.recv.video = g.id), this.multiparty && this.configProvider.config.enableMultiViewStats && (f.multiRecv = S.map((g)=>g.id), f.multiRecv.forEach((g)=>{
                            var _this_MSIDsPairs_g, _this_MSIDsPairs_g1, _this_MSIDsPairs_g2;
                            this.multiViewVideoTelemetry[g] || (this.multiViewVideoTelemetry[g] = new AI(this.extensions.StartTime, this.configProvider, this.logger.createChild(`Video[${g}]`, "Video")), this.multiViewVideoTelemetry[g].setMsi((_this_MSIDsPairs_g = this.MSIDsPairs[g]) === null || _this_MSIDsPairs_g === void 0 ? void 0 : _this_MSIDsPairs_g.msi), this.multiViewVideoTelemetry[g].setLocalMsi((_this_MSIDsPairs_g1 = this.MSIDsPairs[g]) === null || _this_MSIDsPairs_g1 === void 0 ? void 0 : _this_MSIDsPairs_g1.localMsi), this.multiViewVideoTelemetry[g].prepareCollectingStatsOnSubscribed((_this_MSIDsPairs_g2 = this.MSIDsPairs[g]) === null || _this_MSIDsPairs_g2 === void 0 ? void 0 : _this_MSIDsPairs_g2.msi));
                        }));
                    }
                    return f;
                }
                getMediaEntityForTrack(g) {
                    if (g) return this.mediaManager.getMediaEntities().find((f)=>f.getLocalTrackId() === g || f.getRemoteTrackId() === g);
                }
                getMediaEntityByRemoteSsrc(g) {
                    if (g) return this.mediaManager.getMediaEntities().find((f)=>f.getRemoteSsrc() === +g);
                }
                getMediaEntity(g, f) {
                    const S = `${f.ssrc}`, v = f.id;
                    let _ = this.getMediaEntityForTrack(g);
                    return !_ && this.configProvider.config.subscribeToSsrcForVideo && v.endsWith("recv") && (_ = this.getMediaEntityByRemoteSsrc(S)), _;
                }
                calculateHwSilentState() {
                    var _this_extensions_WebRTCStats_ssrc_audio_send;
                    const g = (_this_extensions_WebRTCStats_ssrc_audio_send = this.extensions.WebRTCStats.ssrc_audio_send) === null || _this_extensions_WebRTCStats_ssrc_audio_send === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_send.audioInputLevel;
                    if (!g || g.length < 2 * this.hwSilentDetectionDuration) return;
                    let f = !0;
                    for(let S = g.length - this.hwSilentDetectionDuration - 1; S < g.length; S++)if (g[S] > this.hwSilentDetectionLevel) {
                        f = !1;
                        break;
                    }
                    this.hwSilent !== f && (this.hwSilent = f, this.logger.safe.info(`HW silent changed to ${this.hwSilent}`));
                }
                calculateSpeakingState() {
                    var _this_extensions_WebRTCStats_ssrc_audio_send;
                    const g = this.newStatsApi && this.configProvider.config.useAudioAnalyzer ? this.extensions.Audio_send_RawInputVolume : (_this_extensions_WebRTCStats_ssrc_audio_send = this.extensions.WebRTCStats.ssrc_audio_send) === null || _this_extensions_WebRTCStats_ssrc_audio_send === void 0 ? void 0 : _this_extensions_WebRTCStats_ssrc_audio_send.audioInputLevel;
                    if (!g || g.length <= this.speakingWhileMutedBadDuration) return;
                    let f = !1;
                    for(let S = g.length - this.speakingWhileMutedBadDuration; S < g.length; S++)if (g[S] > this.speakingWhileMutedDetectionLevel) {
                        f = !0;
                        break;
                    }
                    this.isSpeaking = f;
                }
                calculateNetworkRecvQualityLevel() {
                    var _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingCTN, _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingPLC, _this_extensions_WebRTCStats_ssrc_audio_recv_concealedSamples, _this_extensions_WebRTCStats_ssrc_audio_recv_silentConcealedSamples, _this_extensions_WebRTCStats_ssrc_audio_recv_totalSamplesReceived;
                    this.configProvider.config.enableNetworkRecvQualityUFD && this.extensions.WebRTCStats.ssrc_audio_recv && (this.networkRecvLevel = this.networkQualityTelemetry.calculateNetworkRecvQualityLevel({
                        googDecodingCTN: (_this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingCTN = this.extensions.WebRTCStats.ssrc_audio_recv.googDecodingCTN) !== null && _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingCTN !== void 0 ? _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingCTN : [],
                        googDecodingPLC: (_this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingPLC = this.extensions.WebRTCStats.ssrc_audio_recv.googDecodingPLC) !== null && _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingPLC !== void 0 ? _this_extensions_WebRTCStats_ssrc_audio_recv_googDecodingPLC : [],
                        concealedSamples: (_this_extensions_WebRTCStats_ssrc_audio_recv_concealedSamples = this.extensions.WebRTCStats.ssrc_audio_recv.concealedSamples) !== null && _this_extensions_WebRTCStats_ssrc_audio_recv_concealedSamples !== void 0 ? _this_extensions_WebRTCStats_ssrc_audio_recv_concealedSamples : [],
                        silentConcealedSamples: (_this_extensions_WebRTCStats_ssrc_audio_recv_silentConcealedSamples = this.extensions.WebRTCStats.ssrc_audio_recv.silentConcealedSamples) !== null && _this_extensions_WebRTCStats_ssrc_audio_recv_silentConcealedSamples !== void 0 ? _this_extensions_WebRTCStats_ssrc_audio_recv_silentConcealedSamples : [],
                        totalSamplesReceived: (_this_extensions_WebRTCStats_ssrc_audio_recv_totalSamplesReceived = this.extensions.WebRTCStats.ssrc_audio_recv.totalSamplesReceived) !== null && _this_extensions_WebRTCStats_ssrc_audio_recv_totalSamplesReceived !== void 0 ? _this_extensions_WebRTCStats_ssrc_audio_recv_totalSamplesReceived : [],
                        oldNetworkLevel: this.networkRecvLevel.quality
                    }));
                }
                calculateNetworkSendQualityLevel() {
                    this.extensions.WebRTCStats.ssrc_audio_send && (this.networkSendLevel = this.networkQualityTelemetry.calculateNetworkSendQualityLevel(this.extensions.WebRTCStats.ssrc_audio_send.packetsSent, this.extensions.WebRTCStats.ssrc_audio_send.packetsLost, this.extensions.WebRTCStats.ssrc_audio_send.jitter, this.networkSendLevel.quality));
                }
                processStatsError(g, f) {
                    const S = stringifyObject(f);
                    this.logger.safe.error(`webrtcStatistics error [${g}]: ${S}`);
                    const v = this.statsErrors.find((f)=>f.error === S && f.origin === g);
                    v ? v.count++ : this.statsErrors.push({
                        origin: g,
                        error: S,
                        count: 1
                    }), this.statsErrors.length > NI && this.statsErrors.splice(1);
                }
                getLastSampleInt(g) {
                    return "number" == typeof g ? g : g && parseInt(g[g.length - 1]) || 0;
                }
                getSsrcIdFromMultipleVideoStream(g) {
                    let f;
                    const S = this.extensions.WebRTCStats[Gt.MULTIPLE_RECV_STREAMS] || {};
                    for(const v in S){
                        const _ = S[v];
                        if (_ && _.googTrackId === g) {
                            f = v;
                            break;
                        }
                    }
                    return f;
                }
                constructor(g, f, S, v, _, C){
                    this.logger = g, this.sessionInfo = f, this.configProvider = S, this.mediaManager = v, this.multiparty = _, this.newStatsApi = C, this.statsErrors = [], this.subscribedTrackIds = [], this.iceCandidateErrors = [], this.terminated = !1, this.hwSilent = !1, this.isSpeaking = !1, this.networkSendLevel = {
                        quality: "Good"
                    }, this.networkRecvLevel = {
                        quality: "Good"
                    }, this.audioTelemetry = new sI(this.configProvider), this.cameraOpenResolution = {
                        width: 0,
                        height: 0
                    }, this.streamSenderStarted = {}, this.totalVideoControlMessages = 0, this.outOfOrderVideoControlMessages = 0, this.subscribedTrackSsrc = [], this.multiViewVideoTelemetry = {}, this.h264AvailableProfiles = [], this.h264CodecCapabilities = {
                        sendProfiles: [],
                        receiveProfiles: []
                    }, this.timeToFirstFrame = {}, this.timeToFirstFrameSinceSubscriptionStart = {}, this.missedInitialPreferredResolution = {}, this.MSIDs = new Set, this.MSIDsPairs = {}, this.timerTrackerManager = new HE(this.configProvider.config.enableTimerTracker), this.extensions = {
                        WebRTCStats: {},
                        AudioTransportRecvBitrate: 0,
                        AudioTransportSendBitrate: 0,
                        AudioPayloadSendBitrate: 0,
                        AudioPayloadRecvBitrate: 0,
                        VideoPayloadSendBitrate: 0,
                        VideoPayloadRecvBitrate: 0,
                        TimerAudioTransportRecvBitrate: 0,
                        TimerAudioTransportSendBitrate: 0,
                        TimerAudioPayloadRecvBitrate: 0,
                        TimerAudioPayloadSendBitrate: 0,
                        TimerVideoPayloadRecvBitrate: 0,
                        TimerVideoPayloadSendBitrate: 0,
                        StartTime: Date.now(),
                        EndTime: Date.now(),
                        Audio_recv_jitterBufferAvgSize: 0,
                        Audio_recv_jitterMax: 0,
                        Audio_recv_jitterAvg: 0,
                        Audio_send_rttAvg: 0,
                        Audio_send_rttMax: 0,
                        MaxSessionBandwidth: 0,
                        Video_recv_MSIDs: [],
                        Audio_send_presentationUserAPIDuration: "",
                        Audio_send_presentationDuration: ""
                    }, this.report = {
                        type: "WebRtcMediaStats",
                        data: {
                            Extensions: this.extensions
                        }
                    }, this.lastSSRCs = new Map, this.videoTelemetry = new AI(this.extensions.StartTime, this.configProvider, this.logger.createChild("Video"), "Video"), this.sharingTelemetry = new AI(this.extensions.StartTime, this.configProvider, this.logger.createChild("Sharing"), "ScreenShare"), this.bandwidthTelemetry = new oI(this.configProvider.config.webrtcBWJumpLowerLimit, this.configProvider.config.webrtcBWJumpUpperLimit), this.stabilizationTelemetry = new WT(this.configProvider.config.uplinkBWStabilizationSlidingWindowSize, this.configProvider.config.uplinkBWStabilizationMaxDeviation, this.configProvider.config.uplinkBWStabilizationMinBandwidth, hasSendDirectionality), this.storedRecordsNumber = Number(this.configProvider.config.webrtcStatStoredRecordsNumber), this.hwSilentDetectionDuration = Number(this.configProvider.config.webrtcStatHwSilentDetectionDuration), this.hwSilentDetectionLevel = Number(this.configProvider.config.webrtcStatHwSilentDetectionLevel), this.audioHealedRatioTelemetry = new aI(this.configProvider), this.networkQualityTelemetry = new hI(this.configProvider, this.newStatsApi, this.audioHealedRatioTelemetry), this.speakingWhileMutedBadDuration = Number(this.configProvider.config.webrtcSpeakingWhileMutedBadDuration), this.speakingWhileMutedDetectionLevel = Number(this.configProvider.config.webrtcSpeakingWhileMutedDetectionLevel), this.videoDelayTimePeriod = this.configProvider.config.webrtcVideoDelayThreshold, this.maxStoredPreferredResolutions = this.configProvider.config.maxStoredPreferredResolutionCount, this.simulcastVideo = new wI(this.logger.createChild("simulcastVideo"), this.configProvider), this.simulcastSharing = new wI(this.logger.createChild("simulcastSharing"), this.configProvider);
                }
            };
            __decorateClass([
                catchStatsErrors
            ], kI.prototype, "onDeviceEvent", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "onMaxCapabilitiesRequested", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "onMaxCapabilitiesApplied", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "addSubscriptionEvent", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processSimulcastStats", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processBandwidthStats", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processAudioStats", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processVideoStatsSend", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processVideoStatsRecv", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processSharingStats", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processStreamsCounters", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "setMissedInitialPreferredResolution", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "setPreferredResolution", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "setIsRendering", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "setMaxSessionBandwidth", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "setStartTime", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "calculateAverages", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "addFilteredFields", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "formatFields", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "processSource", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "getWebrtcReport", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "constructWebRTCDataReport", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "constructWebRtcReportForSingleStream", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "constructWebRtcReportForMultipleStreams", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "selectSsrcsToCollect", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "calculateHwSilentState", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "calculateSpeakingState", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "calculateNetworkRecvQualityLevel", 1), __decorateClass([
                catchStatsErrors
            ], kI.prototype, "calculateNetworkSendQualityLevel", 1);
            var LI = "VideoBwe", FI = "bweforvideo", xI = "googAvailableReceiveBandwidth", UI = "googAvailableSendBandwidth", VI = "mediaType", BI = "framesDecoded", HI = "googFrameRateDecoded", $I = "googFrameRateReceived", jI = "googFrameRateInput", GI = "googTrackId";
            function unwrapResults(g) {
                const f = {};
                return g.result().forEach((g)=>{
                    g.names().forEach((S)=>{
                        f[g.type] = f[g.type] || {}, f[g.type][g.id] = f[g.type][g.id] || {}, f[g.type][g.id][S] = g.stat(S);
                    }), f[g.type][g.id].id = g.id;
                }), f;
            }
            var qI = class extends Bt {
                setAudioDecoderStatsProvider(g) {
                    var _this_statisticsMapper;
                    (_this_statisticsMapper = this.statisticsMapper) === null || _this_statisticsMapper === void 0 ? void 0 : _this_statisticsMapper.setAudioDecoderStatsProvider(g);
                }
                get sessionInfo() {
                    return this._sessionInfo;
                }
                get isDisposed() {
                    return null === this.pc && 0 === this.interval;
                }
                initialize(g) {
                    this.pc = g;
                }
                startWaitingForStreamStart(g) {
                    this.webRtcStatistics.startWaitingForStreamStart(g);
                }
                onDeviceEvent(g) {
                    this.webRtcStatistics.onDeviceEvent(g);
                }
                onMaxCapabilitiesRequested(g) {
                    this.webRtcStatistics.onMaxCapabilitiesRequested(g);
                }
                onMaxCapabilitiesApplied(g) {
                    this.webRtcStatistics.onMaxCapabilitiesApplied(g);
                }
                onSendersChanged(g, f) {
                    this.webRtcStatistics.setStreamSenderStarted(g, f);
                }
                addSubscriptionEvent(g, f, S, v, _, C, E) {
                    this.webRtcStatistics.addSubscriptionEvent(g, f, S, v, _, C, E);
                }
                setSubscribedTrackIds(g) {
                    this.webRtcStatistics.setSubscribedTrackIds(g);
                }
                setSubscribedTrackSsrc(g) {
                    this.webRtcStatistics.setSubscribedTrackSsrc(g);
                }
                setPreferredResolution(g, f, S) {
                    this.webRtcStatistics.setPreferredResolution(g, f, S);
                }
                setIsRendering(g, f, S) {
                    this.webRtcStatistics.setIsRendering(g, f, S);
                }
                setMaxSessionBandwidth(g) {
                    this.webRtcStatistics.setMaxSessionBandwidth(g);
                }
                setTerminated() {
                    this.webRtcStatistics.setTerminated();
                }
                addIceCandidateError(g) {
                    this.webRtcStatistics.addIceCandidateError(g);
                }
                clearIceCandidateErrors() {
                    this.webRtcStatistics.clearIceCandidateErrors();
                }
                updateSendStream(g, f) {
                    this.webRtcStatistics.updateSendStream(g, f);
                }
                getTimerTracker(g, f) {
                    return this.webRtcStatistics.getTimerTracker(g, f);
                }
                setH264AvailableProfiles(g) {
                    if (!(g === null || g === void 0 ? void 0 : g.codecs)) return;
                    let f = [];
                    g.codecs.forEach((g)=>{
                        if ("h264" === g.mimeType && g.sdpFmtpLine) {
                            const S = /profile-level-id=(.{6})/.exec(g.sdpFmtpLine);
                            (S === null || S === void 0 ? void 0 : S[1]) && (f = f.concat(S[1]));
                        }
                    }), this.webRtcStatistics.addH264AvailableProfiles(f);
                }
                setSupportedH264Profiles(g, f) {
                    if (!(g === null || g === void 0 ? void 0 : g.codecs) && !(f === null || f === void 0 ? void 0 : f.codecs)) return;
                    const extractProfiles = (g)=>{
                        var _g_codecs;
                        const f = [];
                        return (_g_codecs = g.codecs) === null || _g_codecs === void 0 ? void 0 : _g_codecs.forEach((g)=>{
                            if ("h264" === g.mimeType && g.sdpFmtpLine) {
                                var _exec;
                                const S = (_exec = /profile-level-id=(.{6})/.exec(g.sdpFmtpLine)) === null || _exec === void 0 ? void 0 : _exec[1];
                                S && !f.includes(S) && f.push(S);
                            }
                        }), f;
                    }, S = extractProfiles(g), v = extractProfiles(f);
                    this.webRtcStatistics.setSupportedH264Profiles(S, v);
                }
                processRawReport(g) {
                    this.processStatsDict(this.statisticsMapper.build(g));
                }
                processLegacyReport(g) {
                    this.processStatsDict(unwrapResults(g));
                }
                getReport(g, f = !1) {
                    const S = this.webRtcStatistics.getReport(g, f);
                    return this.addStreamInfoForE2ETests(S), S;
                }
                dispose() {
                    this.interval && (this.window.clearInterval(this.interval), this.interval = 0), this.pc = null;
                }
                getLastStatistics() {
                    return this.statistics;
                }
                setTimeToFirstFrame(g, f, S) {
                    this.webRtcStatistics.setTimeToFirstFrame(g, f, S);
                }
                setFreezeDuration(g, f) {
                    this.webRtcStatistics.setFreezeDuration(g, f);
                }
                addVideoControlMessage(g = !1) {
                    this.webRtcStatistics.addVideoControlMessage(g);
                }
                setSsrcTrackPair(g, f) {
                    this.statisticsMapper.setSsrcTrackPair(g, f);
                }
                updateStatsWithLocalSsrcTrackInfo() {
                    for (const g of this.mediaManager.getMediaEntities()){
                        const f = g.getLocalSsrc();
                        f && this.statisticsMapper.setSsrcTrackPair(f, g.getLocalTrackId());
                    }
                }
                addReportedReceiveBandwidth(g) {
                    this.webRtcStatistics.addReportedReceiveBandwidth(g);
                }
                addStreamInfoForE2ETests(g) {
                    const f = this._sessionInfo.negotiatedModalities;
                    if (f && !this.isDisposed) try {
                        g.localStreams = this.getSendersReport(this.pc.getSenders(), {
                            audio: hasSendDirectionality(f.audio),
                            video: hasSendDirectionality(f.video)
                        }), g.remoteStreams = this.getReceiversReport(this.pc.getReceivers(), {
                            audio: hasReceiveDirectionality(f.audio),
                            video: hasReceiveDirectionality(f.video)
                        });
                    } catch (g) {
                        this.logger.safe.warn(`addStreamInfoForE2ETests failed: ${stringifyObject(g)}`);
                    }
                }
                getReceiversReport(g, f) {
                    const S = [];
                    return g.forEach((g)=>{
                        const v = {
                            tracks: []
                        };
                        S.push(v), g.track && ("audio" === g.track.kind && f.audio || "video" === g.track.kind && f.video) && v.tracks.push({
                            stream: void 0,
                            track: g.track
                        });
                    }), S;
                }
                getSendersReport(g, f) {
                    const S = [], v = {
                        tracks: []
                    };
                    return S.push(v), g.forEach((g)=>{
                        g.track && ("audio" === g.track.kind && f.audio || "video" === g.track.kind && f.video) && v.tracks.push({
                            stream: void 0,
                            track: g.track
                        });
                    }), S;
                }
                processStatsDict(g) {
                    var _g_LI;
                    this.webRtcStatistics.processStatsDict(g);
                    let f = 0, S = 0;
                    const v = (_g_LI = g[LI]) === null || _g_LI === void 0 ? void 0 : _g_LI[FI];
                    v && (f = Number(v[xI]), S = Number(v[UI]));
                    const _ = 1e3 * ((this.configProvider.mediaConfig.maxBandwidthInKbps || Math.floor(Number.MAX_SAFE_INTEGER / 1e3)) - (this.configProvider.config.audioBandwidthInKbps || 0)), C = isNaN(f) ? 0 : f, E = isNaN(S) ? 0 : S, T = {
                        estimatedReceiveBandwidth: Math.min(C, _),
                        estimatedSendBandwidth: Math.min(E, _),
                        remoteVideoStreams: {},
                        localVideoStreams: {},
                        isSpeaking: this.webRtcStatistics.getSpeakingState(),
                        audioHwSilent: this.webRtcStatistics.getAudioHwSilent(),
                        networkSendLevel: this.webRtcStatistics.getNetworkSendLevel(),
                        networkRecvLevel: this.webRtcStatistics.getNetworkRecvLevel()
                    };
                    forOwn(g.ssrc, (g)=>{
                        if ("video" !== g[VI]) return;
                        const f = g[GI], S = g.id;
                        -1 !== S.indexOf("_recv") ? (T.remoteVideoStreams[f] = {
                            trackId: f,
                            frameRateReceived: Number(g[$I]),
                            frameRateDecoded: Number(g[HI]),
                            framesDecoded: Number(g[BI])
                        }, this.configProvider.config.isRenderingBasedOnRawStatistics || (T.remoteVideoStreams[f].isRendering = this.webRtcStatistics.getIsRendering(S))) : f && -1 !== S.indexOf("_send") && (T.localVideoStreams[f] = {
                            trackId: f,
                            ssrc: Number(g.ssrc),
                            frameRateInput: Number(g[jI])
                        });
                    }), deepEqual(this.statistics, T) || (this.statistics = T, this.notifyStatisticsChanged());
                }
                notifyStatisticsChanged() {
                    this.event("onStatisticsChanged").raise(this.statistics);
                }
                constructor(g, f, S, v){
                    super(), this.logger = g, this.configProvider = f, this.mediaManager = S, this.window = Qa.window, this._sessionInfo = new xE, this.statisticsMapper = new iI, this.useNewStatsApi = this.configProvider.config.webrtcUseNewStatsApi && this.configProvider.mediaConfig.simulcastSessionEnabled, this.webRtcStatistics = new kI(this.logger.createChild("WebrtcStatistics"), this._sessionInfo, this.configProvider, S, v, this.useNewStatsApi);
                }
            }, WI = class extends Bt {
                initialize(g) {
                    var _this_interval;
                    this.pc = g, this.gathererV1.initialize(g), (_this_interval = this.interval) !== null && _this_interval !== void 0 ? _this_interval : this.interval = this.window.setInterval(()=>this.processStats(), this.configProvider.config.webrtcStatPollInterval);
                }
                setAudioDecoderStatsProvider(g) {
                    var _this_gathererV2;
                    this.gathererV1.setAudioDecoderStatsProvider(g), (_this_gathererV2 = this.gathererV2) === null || _this_gathererV2 === void 0 ? void 0 : _this_gathererV2.setAudioDecoderStatsProvider(g);
                }
                dispose() {
                    super.dispose(), this.interval && (this.window.clearInterval(this.interval), this.interval = void 0), this.gathererV1.dispose(), this.pc = void 0;
                }
                get isDisposed() {
                    return !this.pc && void 0 === this.interval;
                }
                async processStats() {
                    var _this_gathererV2;
                    if (this.configProvider.config.diagnostics.collectWhileNotConnected) {
                        if (!this.pc || "closed" === this.pc.iceConnectionState) return;
                    } else if (!this.pc || "connected" !== this.pc.iceConnectionState && "completed" !== this.pc.iceConnectionState) return void ((_this_gathererV2 = this.gathererV2) === null || _this_gathererV2 === void 0 ? void 0 : _this_gathererV2.signalNoConnection());
                    if (this.useNewStatsApi) {
                        var _this_gathererV21;
                        const g = Kt(), f = void 0 === this.loopTimer ? -1 : g - this.loopTimer;
                        this.loopTimer = g, this.loopIntervalTracker.captureSample(f), this.loopIntervalAggregator.captureSample(this.loopIntervalTracker.getReport());
                        const S = this.loopIntervalAggregator.getReport();
                        S && (this.diagnostics.loopIntervalMax = S.max, this.diagnostics.loopIntervalMedian = S.median);
                        const v = {};
                        (await this.pc.getStats()).forEach((g)=>{
                            this.cleanupPii(g);
                            const f = g.type;
                            var _v_f;
                            delete g.type, (_v_f = v[f]) !== null && _v_f !== void 0 ? _v_f : v[f] = {}, v[f][g.id] = g;
                        });
                        const _ = Kt() - g;
                        this.fetchTimeTracker.captureSample(_), this.fetchTimeAggregator.captureSample(this.fetchTimeTracker.getReport());
                        const C = this.fetchTimeAggregator.getReport();
                        C && (this.diagnostics.fetchTimeMax = C.max, this.diagnostics.fetchTimeMedian = C.median);
                        const E = (_this_gathererV21 = this.gathererV2) === null || _this_gathererV21 === void 0 ? void 0 : _this_gathererV21.processRawReport(v);
                        let T = Kt();
                        this.gathererV1.processRawReport(v), T = Kt() - T, E && (this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("Raising onDiagnosticUpdated event"), this.event("onDiagnosticUpdated").raise(E)), (E === null || E === void 0 ? void 0 : E.perfCounters) && (E.perfCounters.loopTime = f, E.perfCounters.fetchTime = _, E.perfCounters.legacyProcessingTime = T);
                    } else this.pc.getStats((g)=>{
                        g.result && this.gathererV1.processLegacyReport(g);
                    });
                }
                cleanupPii(g) {
                    switch(g.type){
                        case "local-candidate":
                        case "remote-candidate":
                            {
                                const f = g;
                                Object.defineProperty(f, "address", {
                                    enumerable: !1
                                }), Object.defineProperty(f, "url", {
                                    enumerable: !1
                                }), Object.defineProperty(f, "relatedAddress", {
                                    enumerable: !1
                                }), Object.defineProperty(f, "ip", {
                                    enumerable: !1
                                }), Object.defineProperty(f, "usernameFragment", {
                                    enumerable: !1
                                });
                                break;
                            }
                        case "certificate":
                            {
                                const f = g;
                                Object.defineProperty(f, "fingerprint", {
                                    enumerable: !1
                                }), Object.defineProperty(f, "base64Certificate", {
                                    enumerable: !1
                                });
                                break;
                            }
                    }
                }
                get sessionInfo() {
                    return this.gathererV1.sessionInfo;
                }
                onMaxCapabilitiesApplied(g) {
                    this.gathererV1.onMaxCapabilitiesApplied(g);
                }
                clearIceCandidateErrors() {
                    this.gathererV1.clearIceCandidateErrors();
                }
                setSsrcTrackPair(g, f) {
                    var _this_gathererV2;
                    this.gathererV1.setSsrcTrackPair(g, f), (_this_gathererV2 = this.gathererV2) === null || _this_gathererV2 === void 0 ? void 0 : _this_gathererV2.setSsrcTrackPair(g, f);
                }
                addSubscriptionEvent(g, f, S, v, _, C, E) {
                    this.gathererV1.addSubscriptionEvent(g, f, S, v, _, C, E);
                }
                setSubscribedTrackSsrc(g) {
                    this.gathererV1.setSubscribedTrackSsrc(g);
                }
                addIceCandidateError(g) {
                    this.gathererV1.addIceCandidateError(g);
                }
                setH264AvailableProfiles(g) {
                    this.gathererV1.setH264AvailableProfiles(g);
                }
                setSupportedH264Profiles(g, f) {
                    this.gathererV1.setSupportedH264Profiles(g, f);
                }
                setTerminated() {
                    this.gathererV1.setTerminated();
                }
                onDeviceEvent(g) {
                    this.gathererV1.onDeviceEvent(g);
                }
                getReport(g, f = !1) {
                    const S = this.gathererV1.getReport(g, f);
                    if (this.gathererV2 && this.configProvider.config.diagnostics.sideBySide) {
                        var _v_dataChannel, _v_dataChannel1, _v_dataChannelSessionState, _v_aggregatedModalityStats_video, _v_aggregatedModalityStats, _v_aggregatedModalityStats_audio, _v_aggregatedModalityStats1, _v_aggregatedModalityStats_sharing, _v_aggregatedModalityStats2, _v_aggregatedModalityStats_video1, _v_aggregatedModalityStats3, _v_aggregatedModalityStats_sharing1, _v_aggregatedModalityStats4, _R_aggregated, _w_aggregated, _R_extensions_fpsHarmonicAverage, _P_extensions_fpsHarmonicAverage, _P_aggregated, _v_aggregatedModalityStats_sharing2, _v_aggregatedModalityStats5, _R_aggregated1, _R_aggregated2, _R_extensions, _R_aggregated3, _R_aggregated4, _R_aggregated5, _R_aggregated6, _P_aggregated1, _P_aggregated2, _P_extensions, _P_aggregated3, _P_aggregated4, _P_aggregated5, _P_aggregated6, _w_aggregated1, _w_aggregated2, _R_aggregated7, _P_aggregated7, _M_aggregated, _O_aggregated, _v_simulcast, _v_simulcast1;
                        const g = this.loopIntervalAggregator.getReport();
                        g && (S.data.Extensions.LoopIntervalMax = `${round(g.max, 1)}`, S.data.Extensions.LoopIntervalMedian = `${round(g.median, 1)}`);
                        const f = this.fetchTimeAggregator.getReport();
                        f && (S.data.Extensions.FetchTimeMax = `${round(f.max, 1)}`, S.data.Extensions.FetchTimeMedian = `${round(f.median, 1)}`);
                        const v = this.diagnostics.getObjectRef();
                        S.data.Extensions.multipleVideoStreams = JSON.stringify(rebaseTime(v.multiViewStats, "startTime", v.startTime)), S.data.Extensions.OvcToSubscriptions = JSON.stringify(v.ovcToSubscriptionEvents), S.data.Extensions.videoPerformanceEvent = JSON.stringify(v.videoPerformanceEvent);
                        const _ = v.bandwidthReport;
                        "REMB" === v.negotiation.bweType ? (S.data.Extensions.StartCallBWE = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.startOfTheCall), S.data.Extensions.EndCallBWE = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.endOfTheCall), S.data.Extensions.BWEStd = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.std), S.data.Extensions.BwPercentiles = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.bwPercentiles), S.data.Extensions.AvgBwe = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.avgBwe)) : (S.data.Extensions.StartCallBWESendSide = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.startOfTheCall), S.data.Extensions.EndCallBWESendSide = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.endOfTheCall), S.data.Extensions.BWEStdSendSide = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.std), S.data.Extensions.BwPercentilesSendSide = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.bwPercentiles), S.data.Extensions.AvgBwSendSide = JSON.stringify(_ === null || _ === void 0 ? void 0 : _.avgBwe)), S.data.Extensions.InitialBWSeed = JSON.stringify(v.initialBWSeed), S.data.Extensions.SentBWSeed = JSON.stringify(v.sentBWSeed), S.data.Extensions.Bandwidth_downlinkStabilizationTime = JSON.stringify(v.bwDownlinkStabilizationTime), S.data.Extensions.ReinvitelessContext = JSON.stringify(v.reinvitelessContext), S.data.Extensions.ReportedSendBandwidth = JSON.stringify(v.reportedSendBandwidthLayouts), S.data.Extensions.Data_ProtocolCounters = JSON.stringify((_v_dataChannel = v.dataChannel) === null || _v_dataChannel === void 0 ? void 0 : _v_dataChannel.protocolCounters), S.data.Extensions.Data_Error = (_v_dataChannel1 = v.dataChannel) === null || _v_dataChannel1 === void 0 ? void 0 : _v_dataChannel1.error, S.data.Extensions.Data_SessionState = (_v_dataChannelSessionState = v.dataChannelSessionState) === null || _v_dataChannelSessionState === void 0 ? void 0 : _v_dataChannelSessionState.toString(), S.data.Extensions.Data_CreateChannelError = v.dataChannelCreationError;
                        var _R_aggregated_macroblockRateStats, _w_aggregated_customHealerStats;
                        const C = ((_v_aggregatedModalityStats = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats === void 0 ? void 0 : (_v_aggregatedModalityStats_video = _v_aggregatedModalityStats.video) === null || _v_aggregatedModalityStats_video === void 0 ? void 0 : _v_aggregatedModalityStats_video.recv) || [], E = ((_v_aggregatedModalityStats1 = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats1 === void 0 ? void 0 : (_v_aggregatedModalityStats_audio = _v_aggregatedModalityStats1.audio) === null || _v_aggregatedModalityStats_audio === void 0 ? void 0 : _v_aggregatedModalityStats_audio.recv) || [], T = ((_v_aggregatedModalityStats2 = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats2 === void 0 ? void 0 : (_v_aggregatedModalityStats_sharing = _v_aggregatedModalityStats2.sharing) === null || _v_aggregatedModalityStats_sharing === void 0 ? void 0 : _v_aggregatedModalityStats_sharing.recv) || [], I = ((_v_aggregatedModalityStats3 = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats3 === void 0 ? void 0 : (_v_aggregatedModalityStats_video1 = _v_aggregatedModalityStats3.video) === null || _v_aggregatedModalityStats_video1 === void 0 ? void 0 : _v_aggregatedModalityStats_video1.send) || [], b = ((_v_aggregatedModalityStats4 = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats4 === void 0 ? void 0 : (_v_aggregatedModalityStats_sharing1 = _v_aggregatedModalityStats4.sharing) === null || _v_aggregatedModalityStats_sharing1 === void 0 ? void 0 : _v_aggregatedModalityStats_sharing1.send) || [], A = S.data.Extensions.WebRTCStats, R = C[C.length - 1], P = T[T.length - 1], w = E[E.length - 1], M = I[I.length - 1], O = b[b.length - 1], D = (_R_aggregated_macroblockRateStats = R === null || R === void 0 ? void 0 : (_R_aggregated = R.aggregated) === null || _R_aggregated === void 0 ? void 0 : _R_aggregated.macroblockRateStats) !== null && _R_aggregated_macroblockRateStats !== void 0 ? _R_aggregated_macroblockRateStats : {}, N = (_w_aggregated_customHealerStats = w === null || w === void 0 ? void 0 : (_w_aggregated = w.aggregated) === null || _w_aggregated === void 0 ? void 0 : _w_aggregated.customHealerStats) !== null && _w_aggregated_customHealerStats !== void 0 ? _w_aggregated_customHealerStats : {};
                        if (N === null || N === void 0 ? void 0 : N.pullPacketProcessingTimes) {
                            const g = getPercentilesProviderFromSampleFreqs(N.pullPacketProcessingTimes);
                            N.pullPacketProcessingTimeP50 = g.getPercentile(.5), N.pullPacketProcessingTimeP95 = g.getPercentile(.95);
                        }
                        if (N === null || N === void 0 ? void 0 : N.pushPacketProcessingTimes) {
                            const g = getPercentilesProviderFromSampleFreqs(N.pushPacketProcessingTimes);
                            N.pushPacketProcessingTimeP50 = g.getPercentile(.5), N.pushPacketProcessingTimeP95 = g.getPercentile(.95);
                        }
                        for(const g in D)S.data.Extensions[`Video_recv_${g}`] = `${round(D[g], 0)}`;
                        for(const g in v.totalVideoRecvMblocksRates)S.data.Extensions[`totalVideoRecv_${g}`] = `${round(v.totalVideoRecvMblocksRates[g], 0)}`;
                        for(const g in N)if (void 0 !== N[g]) {
                            const f = "number" != typeof N[g] ? JSON.stringify(N[g]) : N[g];
                            S.data.Extensions[`Audio_recv_customHealer_${g}`] = f;
                        }
                        S.data.Extensions.MeetingScenario = JSON.stringify(v.negotiation.meetingScenario), S.data.Extensions.IsTownHall = JSON.stringify(v.negotiation.isTownHall), S.data.Extensions.Audio_send_presentationAPIUserDuration = JSON.stringify(v.presentationAPIUserDuration), S.data.Extensions.Audio_send_presentationDuration = JSON.stringify(v.presentationAudioDuration), S.data.Extensions.CodecSupport = JSON.stringify(v.codecSupport), S.data.Extensions.Video_recv_FpsHarmonicAverage = R === null || R === void 0 ? void 0 : (_R_extensions_fpsHarmonicAverage = R.extensions.fpsHarmonicAverage) === null || _R_extensions_fpsHarmonicAverage === void 0 ? void 0 : _R_extensions_fpsHarmonicAverage.toString(), S.data.Extensions.Sharing_recv_FpsHarmonicAverage = P === null || P === void 0 ? void 0 : (_P_extensions_fpsHarmonicAverage = P.extensions.fpsHarmonicAverage) === null || _P_extensions_fpsHarmonicAverage === void 0 ? void 0 : _P_extensions_fpsHarmonicAverage.toString(), S.data.Extensions.Sharing_recv_CodecReport = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_aggregated = P.aggregated) === null || _P_aggregated === void 0 ? void 0 : _P_aggregated.codecReport), S.data.Extensions.Video_send_performanceEvents = JSON.stringify(limitArraySize2(rebaseTime(v.localVideoPerformanceEvents, "timestamp", v.startTime), this.configProvider.config.diagnostics.telemetryLimits.numPerformanceEvents)), (A === null || A === void 0 ? void 0 : A.ssrc_sharing_send) && ((A === null || A === void 0 ? void 0 : A.ssrc_sharing_send).retransmittedPacketsSent = sampleseries((_v_aggregatedModalityStats5 = v.aggregatedModalityStats) === null || _v_aggregatedModalityStats5 === void 0 ? void 0 : (_v_aggregatedModalityStats_sharing2 = _v_aggregatedModalityStats5.sharing) === null || _v_aggregatedModalityStats_sharing2 === void 0 ? void 0 : _v_aggregatedModalityStats_sharing2.send, (g)=>g.outboundRTP.retransmittedPacketsSent)), this.configProvider.config.diagnostics.features.takeFreezeTelemetryFromGathererV2 && (C.length && (S.data.Extensions.Video_recv_FreezeHistogram = JSON.stringify((_R_aggregated1 = R.aggregated) === null || _R_aggregated1 === void 0 ? void 0 : _R_aggregated1.freezeCountHistogram), S.data.Extensions.Video_recv_LongestFreezeDuration = JSON.stringify(R === null || R === void 0 ? void 0 : (_R_aggregated2 = R.aggregated) === null || _R_aggregated2 === void 0 ? void 0 : _R_aggregated2.longestFreeze), S.data.Extensions.Video_recv_OngoingFreeze = JSON.stringify(R === null || R === void 0 ? void 0 : (_R_extensions = R.extensions) === null || _R_extensions === void 0 ? void 0 : _R_extensions.isFrozen), S.data.Extensions.Video_recv_OngoingFreezeDuration = JSON.stringify(R === null || R === void 0 ? void 0 : (_R_aggregated3 = R.aggregated) === null || _R_aggregated3 === void 0 ? void 0 : _R_aggregated3.ongoingFreezeDuration), S.data.Extensions.Video_recv_TotalFreezeDuration = JSON.stringify(R === null || R === void 0 ? void 0 : (_R_aggregated4 = R.aggregated) === null || _R_aggregated4 === void 0 ? void 0 : _R_aggregated4.totalFreezeDuration), S.data.Extensions.Video_recv_RecvAvgFreezeDuration = JSON.stringify(R === null || R === void 0 ? void 0 : (_R_aggregated5 = R.aggregated) === null || _R_aggregated5 === void 0 ? void 0 : _R_aggregated5.avgFreezeDuration), S.data.Extensions.Video_recv_FreezeTimestamps = JSON.stringify(rebaseHistogramTimestamps(R === null || R === void 0 ? void 0 : (_R_aggregated6 = R.aggregated) === null || _R_aggregated6 === void 0 ? void 0 : _R_aggregated6.freezeTimestampsHistogram, v.startTime))), T.length && (S.data.Extensions.Sharing_recv_FreezeHistogram = JSON.stringify((_P_aggregated1 = P.aggregated) === null || _P_aggregated1 === void 0 ? void 0 : _P_aggregated1.freezeCountHistogram), S.data.Extensions.Sharing_recv_LongestFreezeDuration = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_aggregated2 = P.aggregated) === null || _P_aggregated2 === void 0 ? void 0 : _P_aggregated2.longestFreeze), S.data.Extensions.Sharing_recv_OngoingFreeze = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_extensions = P.extensions) === null || _P_extensions === void 0 ? void 0 : _P_extensions.isFrozen), S.data.Extensions.Sharing_recv_OngoingFreezeDuration = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_aggregated3 = P.aggregated) === null || _P_aggregated3 === void 0 ? void 0 : _P_aggregated3.ongoingFreezeDuration), S.data.Extensions.Sharing_recv_TotalFreezeDuration = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_aggregated4 = P.aggregated) === null || _P_aggregated4 === void 0 ? void 0 : _P_aggregated4.totalFreezeDuration), S.data.Extensions.Sharing_recv_RecvAvgFreezeDuration = JSON.stringify(P === null || P === void 0 ? void 0 : (_P_aggregated5 = P.aggregated) === null || _P_aggregated5 === void 0 ? void 0 : _P_aggregated5.avgFreezeDuration), S.data.Extensions.Sharing_recv_FreezeTimestamps = JSON.stringify(rebaseHistogramTimestamps(P === null || P === void 0 ? void 0 : (_P_aggregated6 = P.aggregated) === null || _P_aggregated6 === void 0 ? void 0 : _P_aggregated6.freezeTimestampsHistogram, v.startTime)))), S.data.Extensions.EarlyMedia = {
                            NumStatsPolls: `${v.earlyMediaNumStatsPolls}`
                        }, S.data.Extensions.Audio_recv_packetsLostRateMax = `${round(w === null || w === void 0 ? void 0 : (_w_aggregated1 = w.aggregated) === null || _w_aggregated1 === void 0 ? void 0 : _w_aggregated1.lossRateMax, 6) || 0}`, S.data.Extensions.Audio_recv_networkAvgLossRate = `${round(w === null || w === void 0 ? void 0 : (_w_aggregated2 = w.aggregated) === null || _w_aggregated2 === void 0 ? void 0 : _w_aggregated2.networkAvgLossRate, 6) || 0}`, S.data.Extensions.Video_recv_packetsLostRateMax = `${round(R === null || R === void 0 ? void 0 : (_R_aggregated7 = R.aggregated) === null || _R_aggregated7 === void 0 ? void 0 : _R_aggregated7.lossRateMax, 6) || 0}`, S.data.Extensions.Sharing_recv_packetsLostRateMax = `${round(P === null || P === void 0 ? void 0 : (_P_aggregated7 = P.aggregated) === null || _P_aggregated7 === void 0 ? void 0 : _P_aggregated7.lossRateMax, 6) || 0}`, S.data.Extensions.Video_send_packetsLostRateMax = `${round(M === null || M === void 0 ? void 0 : (_M_aggregated = M.aggregated) === null || _M_aggregated === void 0 ? void 0 : _M_aggregated.lossRateMax, 6) || 0}`, S.data.Extensions.Sharing_send_packetsLostRateMax = `${round(O === null || O === void 0 ? void 0 : (_O_aggregated = O.aggregated) === null || _O_aggregated === void 0 ? void 0 : _O_aggregated.lossRateMax, 6) || 0}`, this.configProvider.config.diagnostics.features.useNewSimulcastTelemetryExtension && (S.data.Extensions.Video_send_Simulcast = JSON.stringify((_v_simulcast = v.simulcast) === null || _v_simulcast === void 0 ? void 0 : _v_simulcast.video), S.data.Extensions.Sharing_send_Simulcast = JSON.stringify((_v_simulcast1 = v.simulcast) === null || _v_simulcast1 === void 0 ? void 0 : _v_simulcast1.sharing));
                    }
                    return removeUndefinedFields(S);
                }
                startWaitingForStreamStart(g) {
                    this.gathererV1.startWaitingForStreamStart(g);
                }
                getTimerTracker(g, f) {
                    return this.gathererV1.getTimerTracker(g, f);
                }
                getLastStatistics() {
                    return this.gathererV1.getLastStatistics();
                }
                updateSendStream(g, f) {
                    this.gathererV1.updateSendStream(g, f);
                }
                setSubscribedTrackIds(g) {
                    this.gathererV1.setSubscribedTrackIds(g);
                }
                setMaxSessionBandwidth(g) {
                    this.gathererV1.setMaxSessionBandwidth(g);
                }
                updateStatsWithLocalSsrcTrackInfo() {
                    this.gathererV1.updateStatsWithLocalSsrcTrackInfo();
                }
                onSendersChanged(g, f) {
                    this.gathererV1.onSendersChanged(g, f);
                }
                setPreferredResolution(g, f, S) {
                    this.gathererV1.setPreferredResolution(g, f, S);
                }
                setIsRendering(g, f, S) {
                    this.gathererV1.setIsRendering(g, f, S);
                }
                setTimeToFirstFrame(g, f, S) {
                    this.gathererV1.setTimeToFirstFrame(g, f, S);
                }
                setFreezeDuration(g, f) {
                    this.gathererV1.setFreezeDuration(g, f);
                }
                addVideoControlMessage(g) {
                    this.gathererV1.addVideoControlMessage(g);
                }
                onMaxCapabilitiesRequested(g) {
                    this.gathererV1.onMaxCapabilitiesRequested(g);
                }
                addReportedReceiveBandwidth(g) {
                    this.gathererV1.addReportedReceiveBandwidth(g);
                }
                constructor(g, f, S, v, _){
                    super(), this.logger = g, this.configProvider = f, this.diagnostics = S, this.mediaManager = v, this.window = Qa.window, this.useNewStatsApi = this.configProvider.config.webrtcUseNewStatsApi && this.configProvider.mediaConfig.simulcastSessionEnabled, this.loopIntervalTracker = new zv(this.configProvider.config.diagnostics.performanceMonitoring.fluctuationSamplesNum), this.loopIntervalAggregator = new Kv, this.fetchTimeTracker = new zv(this.configProvider.config.diagnostics.performanceMonitoring.fluctuationSamplesNum), this.fetchTimeAggregator = new Kv, this.gathererV1 = new qI(this.logger.createChild("V1"), this.configProvider, this.mediaManager, _), this.gathererV1.on("onStatisticsChanged", (g)=>this.event("onStatisticsChanged").raise(g)), this.useNewStatsApi && f.config.diagnostics.sideBySide && (this.gathererV2 = new eI(this.logger.createChild("V2"), this.configProvider, this.diagnostics, this.mediaManager));
                }
            }, zI = 101, KI = [
                48e3,
                32e3,
                24e3,
                16e3,
                12e3
            ], JI = class {
                fixTelephoneEvent(g) {
                    let f;
                    return KI.forEach((f)=>{
                        removeCodec(g, {
                            codec: "telephone-event",
                            rate: f
                        });
                    }), updatePayload(g, zI, 999), forOneCodec(g, {
                        codec: "telephone-event",
                        rate: 8e3
                    }, (g)=>(f = g.rtp.payload, g.rtp.payload = zI, g)), updatePayload(g, 999, f || zI), f;
                }
                toLocal(g, f, S) {
                    const v = f.isEmpty(), _ = deepClone(g);
                    let C;
                    return _.media.forEach((g)=>{
                        if ("audio" === g.type) v && (C = this.fixTelephoneEvent(g)), fixComfortNoise(g);
                        else {
                            C && updatePayload(g, zI, C);
                            const S = f.getLocalSsrcs().get(getModality(g));
                            this.enforceFixedSsrc(g, S);
                        }
                        const _ = getAllowedCodecs(this.configProvider, g.type);
                        "offer" === S && filterCodecs2(g, _, v, this.logger);
                    }), new uE(this.configProvider).modify(_), delete _.extmapAllowMixed, _;
                }
                toOffer(g, f, S) {
                    return this.fromNative(g, f, S, !0);
                }
                toAnswer(g, f, S) {
                    return this.fromNative(g, f, S, !1);
                }
                toRemote(g, f, S, v) {
                    const _ = deepClone(g);
                    let C, E, T = this.configProvider.mediaConfig.maxBandwidthInKbps;
                    _.bandwidth && (!T || T > +g.bandwidth[0].limit) && (T = +g.bandwidth[0].limit), _.media.forEach((g, S)=>{
                        f.getMediaEntity(S).isDisabled() && g.type !== Gt.MEDIA_TYPE.audio && (g.port = 0);
                    });
                    let I = getBundle2(_);
                    if (!I) {
                        let g = !1;
                        _.media.forEach((S, v)=>{
                            const _ = f.getMediaEntity(v);
                            !g && _.isEnabled() ? (S.mid = _.getMid(), g = !0) : (_.disable(), S.port = 0);
                        }), g && (_.groups || (_.groups = []), I = {
                            type: "BUNDLE"
                        }, _.groups.push(I));
                    }
                    _.media.forEach((g)=>{
                        const f = getModality(g);
                        S[f] === Gt.MEDIA_STATE.send && (g.direction && g.direction.toLowerCase() === Gt.MEDIA_STATE.receive || (g.direction = Gt.MEDIA_STATE.receive));
                    });
                    const b = _.media.filter((g)=>g.type === Gt.MEDIA_TYPE.video);
                    if (b.length > 0) {
                        const g = b.filter((g)=>0 !== g.port);
                        if (g.length > 0) {
                            E = deepClone(g[0]), E.bandwidth && delete E.bandwidth;
                            const f = this.configProvider.config.audioBandwidthInKbps ? this.configProvider.config.audioBandwidthInKbps : 0;
                            T && T - f > 0 && (E.bandwidth = [
                                {
                                    limit: T - f,
                                    type: "AS"
                                }
                            ]), E.mid = "video", E.direction = null, delete E.label, E.ssrcs = [], E.ssrcGroups = [], delete E.msid, g.forEach((g)=>{
                                g.ssrcs && (E.ssrcs = E.ssrcs.concat(g.ssrcs)), g.ssrcGroups && (E.ssrcGroups = E.ssrcGroups.concat(g.ssrcGroups)), E.direction = mergeDirections(E.direction, g.direction || Gt.MEDIA_STATE.sendReceive);
                            }), removeUnifiedPlanExtensions(E);
                        } else E = disabledMedia2(Gt.MEDIA_TYPE.video, void 0, b[0].protocol, b[0].payloads);
                    }
                    const A = _.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio);
                    if (A) {
                        if (0 !== A.port) C = deepClone(A), C.mid = "audio", delete C.label, removeG722Codec(C), fixComfortNoise(C), removeUnifiedPlanExtensions(C);
                        else {
                            C = disabledMedia2(Gt.MEDIA_TYPE.audio, void 0, A.protocol, A.payloads);
                            const g = _.media.find((g)=>!!g.iceUfrag);
                            g && (C.port = 9, C.direction = "inactive", C.mid = "audio", C.iceUfrag = g.iceUfrag, C.icePwd = g.icePwd, C.rtcpMux = "rtcp-mux", g.crypto && (C.crypto = g.crypto), g.fingerprint && (C.fingerprint = g.fingerprint, C.setup = g.setup), C.rtp = [
                                {
                                    payload: 0,
                                    codec: "PCMU",
                                    rate: 8e3
                                }
                            ], C.payloads = "0");
                        }
                    }
                    _.media.forEach((g, f)=>{
                        g.type === Gt.MEDIA_TYPE.data && (g.type = Gt.MEDIA_TYPE.dataChannel, g.payloads = Gt.PAYLOAD_TYPE.DATA_CHANNEL, g.protocol = Gt.PROFILES.udpDtlsSctp, g.mid = "data", delete g.xDataProtocol, delete g.direction, isMediaDisabled(g) && (_.media[f] = disabledMedia2(g.type, void 0, g.protocol, g.payloads)));
                    });
                    const R = allowDataChannel(this.context) ? _.media.find((g)=>g.type === Gt.MEDIA_TYPE.dataChannel) : null;
                    _.media = [
                        C,
                        E,
                        R
                    ].filter((g)=>g), f.getMediaEntities()[0].getModality() !== Gt.MODALITY.audio && _.media.reverse();
                    const P = preferSdesSrtp(this.context.configProvider, this.context.config.isPstnCall), w = getSrtpInfo(g);
                    return _.media.forEach((g)=>{
                        g.type !== Gt.MEDIA_TYPE.dataChannel && (!P && g.fingerprint && g.crypto && delete g.crypto, g.protocol = !w.dtls || w.sdes && P ? Gt.PROFILES.rtpSavpf : Gt.PROFILES.udpTlsRtpSavpf);
                    }), "offer" === v && (filterCodecs2(C, this.configProvider.config.allowedAudioCodecs, !1, this.logger), filterCodecs2(E, this.configProvider.config.allowedVideoCodecs, !1, this.logger)), fixBundling(_, this.configProvider.mediaConfig.isTransportUnbundled), _;
                }
                splitMedia(g, f, S, v, _) {
                    const C = g.getMid(), E = g.getModality(), T = deepClone(f);
                    if (T.label = getLabelForModality(E), T.direction = v, T.mid = C, T.ssrcs = [], T.ssrcGroups = [], g.getModality() === Gt.MODALITY.data) return T.type = Gt.MEDIA_TYPE.data, T.payloads = Gt.PAYLOAD_TYPE.X_DATA, T;
                    const I = S.filter((g)=>g.modality === E);
                    if (I && I.length) {
                        const g = [];
                        f.ssrcs && (I.forEach((S)=>{
                            const v = f.ssrcs.filter((g)=>"msid" === g.attribute && S.trackId === getTrackId(g.value)).map((g)=>g.id);
                            g.push(...v);
                        }), T.ssrcs = f.ssrcs.filter((f)=>g.indexOf(+f.id) > -1), T.ssrcs.forEach((g)=>{
                            "cname" === g.attribute && (g.value = this.cname);
                        })), f.ssrcGroups && (T.ssrcGroups = f.ssrcGroups.filter((f)=>f.ssrcs.split(" ").find((f)=>g.indexOf(+f) > -1)));
                    } else {
                        var __f_type_ssrcs;
                        if (v === Gt.MEDIA_STATE.send || v === Gt.MEDIA_STATE.sendReceive) return disabledMedia2(f.type, getLabelForModality(E), f.protocol, f.payloads);
                        v !== Gt.MEDIA_STATE.receive && v !== Gt.MEDIA_STATE.inactive || (((__f_type_ssrcs = _[f.type].ssrcs) === null || __f_type_ssrcs === void 0 ? void 0 : __f_type_ssrcs[0]) ? T.ssrcs = [
                            {
                                id: _[f.type].ssrcs[0].id,
                                attribute: "cname",
                                value: this.cname
                            }
                        ] : f.type === Gt.MEDIA_TYPE.audio ? T.ssrcs = [
                            {
                                id: 4195875351,
                                attribute: "cname",
                                value: this.cname
                            }
                        ] : f.type === Gt.MEDIA_TYPE.video && (T.ssrcs = [
                            {
                                id: 1,
                                attribute: "cname",
                                value: this.cname
                            }
                        ]));
                    }
                    return T;
                }
                fromNative(g, f, S, v) {
                    const _ = deepClone(g), C = this.configProvider.mediaConfig.maxBandwidthInKbps;
                    C && (_.bandwidth = [
                        {
                            limit: C,
                            type: "CT"
                        }
                    ]), new hE(this.configProvider).modify(_);
                    const E = _.media.find((g)=>g.type === Gt.MEDIA_TYPE.audio), T = _.media.find((g)=>g.type === Gt.MEDIA_TYPE.video), I = _.media.find((g)=>g.type === Gt.MEDIA_TYPE.dataChannel), b = {};
                    b[Gt.MODALITY.audio] = E, b[Gt.MODALITY.video] = T, b[Gt.MODALITY.sharing] = T, b[Gt.MODALITY.data] = I || this.dataMedia;
                    const A = {};
                    A[Gt.MEDIA_TYPE.audio] = E, A[Gt.MEDIA_TYPE.video] = T, A[Gt.MEDIA_TYPE.data] = I || this.dataMedia;
                    const R = {};
                    return R[Gt.MODALITY.audio] = f.getMediaEntitiesByModality(Gt.MODALITY.audio)[0], R[Gt.MODALITY.video] = f.getMediaEntitiesByModality(Gt.MODALITY.video)[0], R[Gt.MODALITY.sharing] = f.getMediaEntitiesByModality(Gt.MODALITY.sharing)[0], R[Gt.MODALITY.data] = f.getMediaEntitiesByModality(Gt.MODALITY.data)[0], _.media = [], f.getMediaEntities().forEach((g)=>{
                        let C, E = S[g.getModality()];
                        !g.isEnabled() || 0 === b[g.getModality()].port || g !== R[g.getModality()] && E === Gt.MEDIA_STATE.send ? (C = disabledMedia2(g.getType(), getLabelForModality(g.getModality()), b[g.getModality()].protocol, b[g.getModality()].payloads), b[g.getModality()].payloads === Gt.PAYLOAD_TYPE.DATA_CHANNEL && (C.payloads = Gt.PAYLOAD_TYPE.DATA_CHANNEL)) : (E !== Gt.MEDIA_STATE.inactive && g !== R[g.getModality()] && (E = Gt.MEDIA_STATE.receive), C = this.splitMedia(g, b[g.getModality()], f.getLocalTracksInfo(), E, A), g !== R[g.getModality()] && (C.candidates = []));
                        const T = b[g.getModality()].setup;
                        T && ("actpass" !== T ? g.setExtension("setup", T) : v && void 0 !== g.getExtension("setup") && (C.setup = "actpass" !== g.getExtension("setup") ? g.getExtension("setup") : T));
                        const I = b[g.getModality()].iceUfrag, P = g.getExtension("iceUfrag");
                        g.setExtension("iceRestart", !!I && !!P && P !== I), g.setExtension("iceUfrag", I), isMediaDisabled(C) && g.disable(), _.media.push(C);
                    }), new Py(this.context, S.data).modify(_), fixBundling(_, this.configProvider.mediaConfig.isTransportUnbundled), _;
                }
                enforceFixedSsrc(g, f) {
                    let S = -1;
                    if (!g.ssrcs) return;
                    const v = [];
                    if (g.ssrcs.forEach((g)=>{
                        "msid" === g.attribute && v.push({
                            ssrc: g.id,
                            trackId: getTrackId(g.value)
                        });
                    }), g.ssrcs.forEach((g)=>{
                        "cname" === g.attribute && S++, f && (g.id = this.getVideoSSRC(S, f));
                    }), g.ssrcGroups) {
                        const f = g.ssrcs.filter((g)=>"cname" === g.attribute).map((g)=>g.id);
                        g.ssrcGroups.forEach((g, S)=>{
                            g.ssrcs = [
                                f[2 * S],
                                f[2 * S + 1]
                            ].join(" ");
                        });
                    }
                }
                getVideoSSRC(g, f) {
                    return g % 2 == 1 ? f + 50 : f;
                }
                constructor(g){
                    this.context = g, this.cname = uniqueId(), this.dataMedia = {
                        type: Gt.MEDIA_TYPE.data,
                        protocol: Gt.PROFILES.rtpSavp,
                        port: 0
                    }, this.configProvider = g.configProvider, this.logger = g.getLogger().createChild("WebkitSdpTrans");
                }
            };
            function removeG722Codec(g) {
                removeCodec(g, {
                    codec: "g722",
                    rate: 8e3,
                    encoding: 2
                });
            }
            function removeUnifiedPlanExtensions(g) {
                const f = new Set([
                    "urn:ietf:params:rtp-hdrext:sdes:mid",
                    "urn:ietf:params:rtp-hdrext:sdes:rtp-stream-id",
                    "urn:ietf:params:rtp-hdrext:sdes:repaired-rtp-stream-id"
                ]);
                g.ext && (g.ext = g.ext.filter((g)=>!f.has(g.uri)));
            }
            function fixComfortNoise(g) {
                removeCodec(g, {
                    codec: "CN",
                    rate: 16e3
                });
            }
            function getBundle2(g) {
                return g.groups ? g.groups.find((g)=>"BUNDLE" === g.type) : null;
            }
            function fixBundling(g, f) {
                var _g_groups;
                const S = (_g_groups = g.groups) === null || _g_groups === void 0 ? void 0 : _g_groups.findIndex((g)=>"BUNDLE" === g.type), v = g.groups ? g.groups[S] : void 0;
                v && (f ? (v.mids = g.media.filter((g)=>g.type === Gt.MEDIA_TYPE.video).map((g)=>g.mid).filter((g)=>g).join(" "), v.mids || delete g.groups[S]) : v.mids = g.media.map((g)=>g.mid).filter((g)=>g).join(" "));
            }
            function disabledMedia2(g, f, S, v) {
                return {
                    type: g,
                    port: 0,
                    label: f,
                    payloads: v,
                    protocol: S
                };
            }
            function getTrackId(g) {
                return g.split(" ")[1];
            }
            function mergeDirections(g, f) {
                return g === Gt.MEDIA_STATE.sendReceive || f === Gt.MEDIA_STATE.sendReceive ? Gt.MEDIA_STATE.sendReceive : g === f ? g : g && f && g !== f ? Gt.MEDIA_STATE.sendReceive : g || f;
            }
            function filterCodecs2(g, f, S, v) {
                if (!f.length || !(g === null || g === void 0 ? void 0 : g.port)) return;
                filterCodecs(g, convertToCodecInfo(f), S, v);
            }
            var YI = __toESM(we()), QI = class {
                getCapabilities(g) {
                    const f = RTCRtpReceiver.getCapabilities(g);
                    return f.codecs.forEach((g)=>{
                        g.mimeType = g.mimeType.toLowerCase().split("/").pop();
                    }), Promise.resolve(f);
                }
            }, XI = class {
                getCapabilities(g) {
                    const f = RTCRtpSender.getCapabilities(g);
                    return f.codecs.forEach((g)=>{
                        g.mimeType = g.mimeType.toLowerCase().split("/").pop();
                    }), Promise.resolve(f);
                }
            }, ZI = class {
                async getCapabilities(g) {
                    if ("video" !== g && "audio" !== g) return Promise.reject(new Error(`capabilities for ${g} are not supported`));
                    if (!this.selfGlobal.gatherTask) {
                        const g = new ct;
                        this.selfGlobal.gatherTask = g.promise;
                        const f = void 0 !== Qa.window.webkitRTCPeerConnection, S = f ? new Qa.window.webkitRTCPeerConnection(null) : new Qa.window.RTCPeerConnection(null), createOfferWrapper = (g)=>f ? new Promise((f, v)=>{
                                S.createOffer(f, v, g);
                            }) : (this.noRequiredCodecsWorkaround && S.addTrack(S.addTransceiver("video").receiver.track), S.createOffer(g));
                        try {
                            const f = await createOfferWrapper({
                                offerToReceiveVideo: 1,
                                offerToReceiveAudio: 1
                            }), v = {};
                            YI.parse(f.sdp).media.forEach((g)=>{
                                v[g.type] = g.rtp.map((f)=>{
                                    const S = {
                                        mimeType: f.codec.toLowerCase()
                                    };
                                    if ("video" === g.type) {
                                        var _g_fmtp;
                                        const v = (_g_fmtp = g.fmtp) === null || _g_fmtp === void 0 ? void 0 : _g_fmtp.find((g)=>g.payload === f.payload);
                                        S.sdpFmtpLine = v === null || v === void 0 ? void 0 : v.config;
                                    }
                                    return S;
                                });
                            }), S.close(), g.resolve(v);
                        } catch (f) {
                            this.selfGlobal.gatherTask = null, S.close(), g.reject(f);
                        }
                    }
                    return this.selfGlobal.gatherTask.then((f)=>({
                            codecs: f[g]
                        }));
                }
                constructor(g, f){
                    this.noRequiredCodecsWorkaround = f, this.selfGlobal = g.global.capabilityGatherer = g.global.capabilityGatherer || {}, this.getCapabilities("video");
                }
            }, eb = {
                build: (g, f, S = !1, v = !1)=>v ? new XI : !f && ss.hasCapabilitiesApi() ? new QI : new ZI(g, S)
            }, tb = __toESM(we()), ib = "rollback";
            function SessionDescription2() {
                const g = [].slice.apply(arguments);
                let f = g[0] && isRollback(g[0].type);
                g.splice(0, f ? 1 : 0, null);
                const S = new (Function.prototype.bind.apply(Qa.window.RTCSessionDescription, g)), v = Object.getOwnPropertyDescriptor(Qa.window.RTCSessionDescription.prototype, "type");
                return Object.defineProperty(S, "type", {
                    get: ()=>f ? ib : v.get.call(S),
                    set (g) {
                        f = isRollback(g), f || v.set.call(S, g);
                    }
                }), S;
            }
            function isRollback(g) {
                return ib === g;
            }
            var nb = {
                build: ()=>SessionDescription2
            }, rb = [
                {
                    codec: "telephone-event",
                    rate: 8e3
                },
                {
                    codec: "cn",
                    rate: 16e3
                }
            ];
            function PeerConnection(g) {
                const f = [], S = nb.build(), v = [].slice.apply(arguments);
                v.splice(0, 1, null), overrideSetting("iceTransportPolicy", "iceTransports");
                const _ = new (Function.prototype.bind.apply(Qa.window.webkitRTCPeerConnection, v));
                function overrideSetting(g, f) {
                    var _v_;
                    ((_v_ = v[1]) === null || _v_ === void 0 ? void 0 : _v_[g]) && (v[1][f] = v[1][g]);
                }
                function shim() {
                    shimPromises(), shimSetRemoteDescription(), shimCreateAnswer(), shimCreateOffer(), shimSenders();
                }
                function shimPromises() {
                    [
                        {
                            name: "createOffer",
                            reverseArgs: !0
                        },
                        "createAnswer",
                        "setRemoteDescription",
                        "setLocalDescription"
                    ].forEach(function(g) {
                        const f = g.name || g, S = _[f];
                        _[f] = function() {
                            const f = arguments;
                            return new Promise(function(v, C) {
                                const E = [
                                    v,
                                    C
                                ];
                                f.length > 0 && E.splice(g.reverseArgs ? E.length : 0, 0, f[0]), S.apply(_, E);
                            });
                        };
                    });
                }
                function Sender(g, f) {
                    let S;
                    Object.defineProperty(this, "dtmf", {
                        get: ()=>"audio" === g.kind ? (S = S || _.createDTMFSender(g), S) : null
                    }), this.track = g, this._stream = f;
                }
                function shimSenders() {
                    _.getSenders && _.addTrack && _.removeTrack || (_.getSenders = function() {
                        return f.slice();
                    }, _.addTrack = function(g, S) {
                        if (!g || !S) throw new Error("both media track and stream need to be provided");
                        _.getLocalStreams().some(function(g) {
                            return g.id === S.id;
                        }) || _.addStream(S);
                        let v = f.find(function(f) {
                            return f.track.id === g.id;
                        });
                        return v || (v = new Sender(g, S), f.push(v)), v;
                    }, _.removeTrack = function(g) {
                        _.getLocalStreams().filter(function(f) {
                            return f.id === g._stream.id;
                        }).forEach(function(g) {
                            _.removeStream(g);
                        }), remove2(f, (f)=>f === g);
                    });
                }
                function shimCreateOffer() {
                    const g = _.createOffer;
                    _.createOffer = function(f) {
                        const S = arguments;
                        return f && f.offerToReceiveVideo > 1 && (f.offerToReceiveVideo = 1), g.apply(_, S);
                    };
                }
                function shimSetRemoteDescription() {
                    [
                        "createOffer",
                        "createAnswer",
                        "setLocalDescription"
                    ].forEach(function(f) {
                        const S = _[f];
                        _[f] = function() {
                            const f = arguments;
                            return g.getCapabilities("video").then(function() {
                                return S.apply(S, f);
                            });
                        };
                    });
                    const f = _.setRemoteDescription;
                    _.setRemoteDescription = function(S) {
                        return g.getCapabilities("video").then(function(g) {
                            const v = g.codecs, _ = tb.parse(S.sdp);
                            return _.media.forEach(function(g) {
                                if ("video" === g.type) g.rtp.some(function(g) {
                                    return v.some(function(f) {
                                        return g.codec.toLowerCase() === f.mimeType;
                                    });
                                }) ? suppressH264FormatParameters(g) : g.port = 0;
                                if (!hasDtls(g)) {
                                    const f = getBundle(_);
                                    f ? g.crypto = f.crypto : g.port || _.media.some(function(f) {
                                        return !!f.port && (g.crypto = f.crypto, !0);
                                    });
                                }
                            }), S.sdp = tb.write(_), f(S);
                        });
                    };
                }
                function shimCreateAnswer() {
                    const g = _.createAnswer;
                    _.createAnswer = function() {
                        const f = arguments;
                        return g.apply(_, f).then(function(g) {
                            var __localDescription;
                            if (!((__localDescription = _.localDescription) === null || __localDescription === void 0 ? void 0 : __localDescription.sdp)) return g;
                            const f = tb.parse(_.localDescription.sdp), v = [];
                            if (f.media.forEach(function(g) {
                                rb.forEach(function(f) {
                                    forOneCodec(g, f, function(g) {
                                        v.push(g);
                                    });
                                });
                            }), v.length) {
                                const f = tb.parse(g.sdp);
                                let _ = !1;
                                f.media.forEach(function(g) {
                                    v.forEach(function(f) {
                                        forOneCodec(g, {
                                            codec: f.rtp.codec,
                                            rate: f.rtp.rate
                                        }, function(g) {
                                            g.rtp.payload !== f.rtp.payload && (g.rtp.payload = f.rtp.payload, _ = !0);
                                        });
                                    });
                                }), _ && (g = new S({
                                    type: g.type,
                                    sdp: tb.write(f)
                                }));
                            }
                            return g;
                        });
                    };
                }
                function suppressH264FormatParameters(g) {
                    forOneCodec(g, {
                        codec: "h264",
                        rate: 9e4
                    }, function(g) {
                        if (g.fmtp) {
                            const f = new QC, S = new QC(g.fmtp.config);
                            [
                                "level-asymmetry-allowed",
                                "packetization-mode",
                                "profile-level-id"
                            ].forEach(function(g) {
                                if (S.contains(g)) {
                                    let v = S.get(g);
                                    "profile-level-id" === g && (v = "42C02A"), f.setIfMissing(g, v);
                                }
                            }), g.fmtp.config = f.toString();
                        }
                    });
                }
                function hasDtls(g) {
                    return "RTP/SAVPF" !== g.protocol;
                }
                return shim(), _;
            }
            var ab = {
                build: (g)=>PeerConnection.bind(null, g)
            }, sb = class {
                constructor(g){
                    const f = g.configProvider.config.useSdpCapabilitiesLegacySession, S = g.configProvider.config.noRequiredCodecsWorkaround;
                    this.RTCRtpReceiver = eb.build(g, f, S), this.SdpTransform = JI, this.RTCPeerConnection = ab.build(this.RTCRtpReceiver), this.RTCSessionDescription = nb.build();
                }
            };
            function UnsupportedAdapter() {
                function throwUnsupported() {
                    throw new Error("unsupported platform");
                }
                this.SdpTransform = throwUnsupported, this.RTCPeerConnection = throwUnsupported, this.RTCSessionDescription = throwUnsupported, this.RTCRtpReceiver = throwUnsupported, this.RTCRtpSender = throwUnsupported;
            }
            function isWebkitRtc() {
                return void 0 !== Qa.window.webkitRTCPeerConnection;
            }
            var ob = {
                build: (g)=>isWebkitRtc() ? new sb(g) : new UnsupportedAdapter
            }, lb = class {
                dispose() {
                    this.stopPolling(), this.contributingSourcesProvider = void 0;
                }
                useCustomCodec(g) {
                    g ? this.stopPolling() : this.startPolling();
                }
                updateContributingSources(g) {
                    this.activeSpeakerManager.onContributingSourcesChanged(g);
                }
                startPolling(g = this.configProvider.config.webrtcContributingSourcesPollingInterval) {
                    !this.timer && this.contributingSourcesProvider && (this.logger.safe.info("Polling started"), this.timer = window.setTimeout(this.poll, g));
                }
                stopPolling() {
                    this.timer && (this.logger.safe.info("Polling stopped"), window.clearTimeout(this.timer), this.timer = void 0);
                }
                updateLastSources(g) {
                    this.lastSources = g.map((g)=>({
                            source: g.source,
                            timestamp: g.timestamp
                        }));
                }
                constructor(g, f, S, v){
                    this.logger = g, this.configProvider = f, this.activeSpeakerManager = S, this.contributingSourcesProvider = v, this.lastSources = [], this.emptySourcesCount = 0, this.poll = ()=>{
                        var _this_contributingSourcesProvider;
                        const g = (_this_contributingSourcesProvider = this.contributingSourcesProvider) === null || _this_contributingSourcesProvider === void 0 ? void 0 : _this_contributingSourcesProvider.getContributingSources();
                        if (!g) return this.logger.safe.info(`Contributing sources are not supported on this client. Retries attempts: ${this.emptySourcesCount}`), void (this.emptySourcesCount > 0 ? (this.emptySourcesCount--, this.timer = window.setTimeout(this.poll, this.configProvider.config.webrtcContributingSourcesPollingInterval)) : this.dispose());
                        this.activeSpeakerManager.onContributingSourcesChanged(g.filter((g)=>{
                            const f = this.lastSources.find((f)=>f.source === g.source);
                            return !f || f.timestamp !== g.timestamp;
                        }).map((g)=>g.source)), this.updateLastSources(g), this.timer = window.setTimeout(this.poll, this.configProvider.config.webrtcContributingSourcesPollingInterval);
                    }, this.emptySourcesCount = this.configProvider.config.webrtcContributingSourcesPollingEmptySources, this.startPolling(this.configProvider.config.webrtcContributingSourcesPollingStartDelay);
                }
            }, cb = class {
                getContributingSources() {
                    try {
                        var _this_peerConnection, _g_getContributingSources;
                        if (!((_this_peerConnection = this.peerConnection) === null || _this_peerConnection === void 0 ? void 0 : _this_peerConnection.getReceivers)) return;
                        const g = this.peerConnection.getReceivers().find((g)=>"audio" === g.track.kind);
                        return g ? (_g_getContributingSources = g.getContributingSources) === null || _g_getContributingSources === void 0 ? void 0 : _g_getContributingSources.call(g) : [];
                    } catch (g) {
                        return this.logger.safe.error("Failed to get contributing sources", g), void (this.logDiagnosticsError && this.sessionDiagnostics && (this.sessionDiagnostics.contributingSourcesError = `${g}`));
                    }
                }
                constructor(g, f, S, v){
                    this.logger = g, this.peerConnection = f, this.logDiagnosticsError = S, this.sessionDiagnostics = v;
                }
            }, db = class {
                fromOffer(g, f) {
                    g.media.forEach((g)=>{
                        if (g.type === Gt.MEDIA_TYPE.audio) Gt.MODALITY.audio in f && this.addMediaEntity(Gt.MODALITY.audio);
                        else if (g.type === Gt.MEDIA_TYPE.video) {
                            if (Gt.MODALITY.video in f) for(let g = 0; g < this.numVideoChannels; g++)this.addMediaEntity(Gt.MODALITY.video);
                            Gt.MODALITY.sharing in f && this.addMediaEntity(Gt.MODALITY.sharing);
                        } else g.type === Gt.MEDIA_TYPE.data && Gt.MODALITY.data in f && this.addMediaEntity(Gt.MODALITY.data);
                    });
                }
                fromRemote(g, f) {
                    g.media.forEach((g, S)=>{
                        const v = getModality(g);
                        if (isMediaDisabled(g) || !(v in f)) this.mediaEntities[S] ? this.mediaEntities[S].disable() : this.addDisabledMediaEntity(v), this.mediaEntities[S].setRemoteStreamId(null), this.mediaEntities[S].setRemoteTrackId(null);
                        else {
                            if (this.mediaEntities[S] ? this.mediaEntities[S].update(v, g.mid || this.generateMid(S)) : this.addMediaEntity(v, g.mid || this.generateMid(S)), g.msid) this.mediaEntities[S].setRemoteStreamId(g.msid.split(" ")[0]), this.mediaEntities[S].setRemoteTrackId(g.msid.split(" ")[1]);
                            else if (g.ssrcs) {
                                const f = g.ssrcs.find((g)=>"msid" === g.attribute);
                                f ? (this.mediaEntities[S].setRemoteStreamId(f.value.split(" ")[0]), this.mediaEntities[S].setRemoteTrackId(f.value.split(" ")[1])) : this.logger.safe.warn(`No ssrc msid for media of type ${g.type} with mid ${g.mid}`);
                            }
                            const f = g.xSourceStreamId || this.generateSourceStreamId(S);
                            this.mediaEntities[S].setXSourceStreamId(f);
                        }
                    });
                }
                isEmpty() {
                    return 0 === this.mediaEntities.length;
                }
                addMediaEntity(g, f) {
                    this.createMediaEntity(g, f || this.generateMid(this.mediaEntities.length));
                }
                addDisabledMediaEntity(g) {
                    this.createMediaEntity(g);
                }
                getMediaEntities() {
                    return this.mediaEntities;
                }
                createMediaEntity(g, f) {
                    const S = my.create(this.configProvider, g, f);
                    return this.mediaEntities.push(S), S;
                }
                getMediaEntity(g) {
                    return this.mediaEntities[g];
                }
                getMediaEntityByMid(g) {
                    return this.mediaEntities.find((f)=>f.getMid() === g);
                }
                getMediaEntitiesByModality(g) {
                    return this.mediaEntities.filter((f)=>f.getModality() === g);
                }
                getMediaEntityByRemoteStreamId(g) {
                    return this.mediaEntities.find((f)=>f.getRemoteStreamId() === g);
                }
                getMediaEntityByLocalTrackId(g) {
                    return this.mediaEntities.find((f)=>f.getLocalTrackId() === g);
                }
                getMediaEntityByXSourceStreamId(g) {
                    return this.mediaEntities.find((f)=>f.getXSourceStreamId() === g);
                }
                reset() {
                    this.mediaEntities = [];
                }
                syncModalities(g, f, S) {
                    this.disableModalities(f), S || (this.enableModalities(f), this.addModalities(f));
                }
                enableModalities(g) {
                    this.mediaEntities.forEach((f, S)=>{
                        f.getModality() in g && f.isDisabled() && f.update(f.getModality(), this.generateMid(S));
                    });
                }
                disableModalities(g) {
                    this.mediaEntities.forEach((f)=>{
                        f.getModality() in g || f.disable();
                    });
                }
                setRollbackUpdateHandler(g) {}
                addModalities(g) {
                    const f = {};
                    this.mediaEntities.map((g)=>g.getModality()).forEach((g)=>{
                        f[g] = !0;
                    });
                    for(const S in g)S in f || this.addMediaEntity(S);
                }
                setLocalTracksInfo(g) {
                    this.mediaTracks = g, this.updateLocalSsrc(this.mediaTracks);
                }
                getLocalTracksInfo() {
                    return this.mediaTracks;
                }
                getLocalSsrcs() {
                    return this.localSsrcs;
                }
                updateMediaEntitiesWithLocalTracks() {
                    this.mediaTracks && (this.mediaEntities.forEach((g)=>g.setLocalTrackId(null)), this.mediaTracks.forEach((g)=>{
                        const f = this.getMediaEntitiesByModality(g.modality)[0];
                        f ? f.setLocalTrackId(g.trackId) : this.logger.safe.error(`Media entity is not found for modality: ${JSON.stringify(g.modality)}`);
                    }));
                }
                updateMediaEntitiesWithActivityState(g, f) {}
                backup() {
                    this.mediaEntitiesBackup = [], this.mediaEntities.forEach((g)=>{
                        this.mediaEntitiesBackup.push(g.clone());
                    });
                }
                commit() {
                    this.mediaEntitiesBackup = [];
                }
                rollback() {
                    this.mediaEntities = this.mediaEntitiesBackup;
                }
                generateSourceStreamId(g) {
                    return g + 10;
                }
                generateMid(g) {
                    return `media_${g}`;
                }
                updateLocalSsrc(g) {
                    g.forEach((g)=>{
                        if (!this.localSsrcs.get(g.modality)) {
                            const f = this.ssrcGenerator.nextVideoStreamSsrc().min;
                            this.logger.safe.debug(`Ssrc updated for modality: ${g.modality}: ${f}`), this.localSsrcs.set(g.modality, f);
                        }
                    });
                }
                constructor(g){
                    this.mediaEntities = [], this.mediaEntitiesBackup = [], this.mediaTracks = [], this.localSsrcs = new Map, this.ssrcGenerator = new cy, this.logger = g.logger.createChild("MM"), this.configProvider = g.configProvider, this.numVideoChannels = g.numVideoChannels;
                }
            }, ub = __toESM(we()), hb = class {
                configure(g) {
                    this.peerConnection = g;
                }
                renegotiateNow() {
                    return this.renegotiate(null, !0);
                }
                renegotiate(g, f = !1, S = "local") {
                    if (!this.peerConnection) throw new Error("trying to renegotiate without a peerConnection");
                    const v = "local" === S ? this.createNegotiationTaskForHaveLocalOffer(g) : this.createNegotiationTaskForHaveRemoteOffer();
                    return f ? (this.logger.safe.info(`forced ${S} renegotiation starting`), Promise.resolve(v())) : this.negotiationQueue.add(v);
                }
                normalizeRemoteSdpSDES(g, f) {
                    if (f.media[0].crypto) g.media.forEach((g)=>{
                        delete g.fingerprint, delete g.setup, g.crypto = g.crypto.filter((g)=>f.media[0].crypto.some((f)=>f.id === g.id)).slice(0, 1);
                    }), g.fingerprint && delete g.fingerprint;
                    else {
                        const f = this.mediaManager.getMediaEntities().find((g)=>void 0 !== g.getExtension("setup"));
                        g.media.forEach((g)=>{
                            const S = (f === null || f === void 0 ? void 0 : f.getExtension("setup")) || "actpass";
                            "actpass" === g.setup && (g.setup = "active" === S ? "passive" : "active");
                        });
                    }
                }
                normalizeRemoteSdpExtensions(g, f) {
                    g.media.forEach((g, S)=>{
                        var _f_media_S_ext, _g_ext;
                        const v = new Set(((_f_media_S_ext = f.media[S].ext) === null || _f_media_S_ext === void 0 ? void 0 : _f_media_S_ext.map((g)=>g.value)) || []);
                        g.ext = (_g_ext = g.ext) === null || _g_ext === void 0 ? void 0 : _g_ext.filter((g)=>v.has(g.value));
                    });
                }
                createNegotiationTaskForHaveLocalOffer(g) {
                    return async ()=>{
                        let f = this.peerConnection.remoteDescription.sdp;
                        const S = this.peerConnection.localDescription.sdp;
                        this.logger.safe.info(`local renegotiation starting remoteSdp=${!!f} localSdp=${!!S}`);
                        const v = ub.parse(f), _ = ub.parse(S);
                        this.normalizeRemoteSdpSDES(v, _), this.normalizeRemoteSdpExtensions(v, _), f = ub.write(v);
                        let C = new this.RtcDescType({
                            sdp: f,
                            type: "answer"
                        });
                        g && g.forEach((g)=>{
                            C = g.modifyDescriptor(C);
                        });
                        try {
                            this.logger.safe.info("creating offer");
                            const g = await this.peerConnection.createOffer(), f = this.sessionDescription.createLocalOffer(g.sdp), S = new this.RtcDescType({
                                sdp: f.toLocal(),
                                type: "offer"
                            });
                            this.logger.safe.info("setting local description"), this.logger.unsafe.debug(`local description, sdp: ${S.sdp}`), await this.peerConnection.setLocalDescription(S), this.logger.safe.info("setting remote description"), this.logger.unsafe.debug(`remote description, sdp: ${C.sdp}`), await this.peerConnection.setRemoteDescription(C), this.logger.safe.debug("local renegotiation done");
                        } catch (g) {
                            throw this.logger.safe.error("local renegotiation failed: ", g.toString()), g;
                        }
                    };
                }
                createNegotiationTaskForHaveRemoteOffer() {
                    return this.logger.safe.info("createNegotiationTaskForRemote"), async ()=>{
                        this.logger.safe.info("proceed with setting local sdp start");
                        try {
                            this.logger.safe.info("creating answer");
                            const g = await this.peerConnection.createAnswer();
                            this.logger.safe.info("applying answer");
                            const f = this.sessionDescription.createLocalAnswer(g.sdp), S = new this.RtcDescType({
                                sdp: f.toLocal(),
                                type: "answer"
                            });
                            this.logger.safe.info("setting [answer] local description"), this.logger.unsafe.debug(`[answer] local description, sdp: ${S.sdp}`), await this.peerConnection.setLocalDescription(S), this.logger.safe.info("local answer for renegotiation is done");
                        } catch (g) {
                            throw this.logger.safe.error("local answer for renegotiation failed: ", g.toString()), g;
                        }
                    };
                }
                constructor(g, f, S, v, _){
                    this.logger = g, this.RtcDescType = f, this.sessionDescription = S, this.negotiationQueue = v, this.mediaManager = _;
                }
            }, gb = 15e3, pb = 5e3, mb = class {
                dispose() {
                    this.currentResolution = null, this.pendingResolution = null, this.maxResolution = null, this.listener = null, this.active = !1, clearTimeout(this.cooldownTimer), this.cooldownTimer = null, this.listener = null;
                }
                setMaxResolution(g) {
                    const f = Zt.Send.getResolutionByFs(g);
                    f !== this.maxResolution && (this.logger.safe.info(`Setting max resolution: ${f}`), this.maxResolution = f, this.lastSendBW && this.processEstimatedBandwidth(this.lastSendBW));
                }
                updateEstimatedSendBandwidth(g) {
                    g !== this.lastSendBW && (this.logger.safe.debug(`Send BW: ${g}`), this.processEstimatedBandwidth(g));
                }
                resetCurrentResolution() {
                    this.currentResolution = null;
                }
                getCurrentResolution() {
                    var _this_currentResolution;
                    return (_this_currentResolution = this.currentResolution) === null || _this_currentResolution === void 0 ? void 0 : _this_currentResolution.fs;
                }
                setCurrentResolution(g) {
                    this.currentResolution = g;
                }
                applyRes(g) {
                    this.pendingResolution = g, this.coolingDown && (!this.currentResolution || g.fs > this.currentResolution.fs) || (this.coolingDown = !0, this.logger.safe.info(`Changing resolution to ${g}`), this.listener && this.listener.onResolutionChanged(g.fs).then((f)=>{
                        f ? (g === this.pendingResolution && (this.pendingResolution = null), this.coolingDown && !this.currentResolution && (this.coolingDown = !1), this.currentResolution = g, this.cooldown()) : (this.logger.safe.info("Unable to apply resolution at the moment"), this.cooldown(pb));
                    }).catch((g)=>{
                        this.logger.safe.error(`Error while applying new resolution: ${JSON.stringify(g)}`), this.pendingResolution = null;
                    }));
                }
                cooldown(g = gb) {
                    !this.active || this.coolingDown && this.cooldownEnd - Date.now() > gb || (this.cooldownTimer && clearTimeout(this.cooldownTimer), this.coolingDown = !0, this.cooldownEnd = Date.now() + gb, this.cooldownTimer = setTimeout(()=>{
                        this.logger.safe.debug("Resolution changer cooled down"), this.coolingDown = !1, this.cooldownTimer = null, this.pendingResolution ? this.proposeResolution(this.pendingResolution) : this.processEstimatedBandwidth(this.lastSendBW);
                    }, g));
                }
                proposeResolution(g) {
                    let f = g;
                    this.maxResolution && this.maxResolution.fs < f.fs && (f = this.maxResolution), this.currentResolution && f.fs === this.currentResolution.fs || this.applyRes(f);
                }
                processEstimatedBandwidth(g) {
                    const { lowRes: f, highRes: S } = Zt.Send.getResolutionForBitrate(g), v = g < this.lastSendBW ? S : f;
                    g < this.lastSendBW && v && this.currentResolution && this.currentResolution.fs < v.fs || (v && this.proposeResolution(v), this.lastSendBW = g);
                }
                constructor(g, f, S){
                    this.settings = g, this.listener = f, this.logger = S, this.lastSendBW = 0, this.coolingDown = !1, this.cooldownTimer = null, this.cooldownEnd = 0, this.active = !1, this.maxResolution = this.settings.maxResolution, this.settings.scalingEnabled ? this.active = !0 : this.logger.safe.info("Resolution management disabled: no resolution management for 1x1 calls");
                }
            };
            function calculateEstimatedSendBandwidth(g, f) {
                var _g_transport_selectedCandidatePair, _g_transport;
                var _g_transport_selectedCandidatePair_availableOutgoingBitrate;
                const S = f.config.maxBandwidthInKbpsFallback > 0 ? f.config.maxBandwidthInKbpsFallback : Math.floor(Number.MAX_SAFE_INTEGER / 1e3), v = 1e3 * ((f.mediaConfig.maxBandwidthInKbps || S) - (f.config.audioBandwidthInKbps || 0)), _ = (_g_transport_selectedCandidatePair_availableOutgoingBitrate = (_g_transport = g.transport) === null || _g_transport === void 0 ? void 0 : (_g_transport_selectedCandidatePair = _g_transport.selectedCandidatePair) === null || _g_transport_selectedCandidatePair === void 0 ? void 0 : _g_transport_selectedCandidatePair.availableOutgoingBitrate) !== null && _g_transport_selectedCandidatePair_availableOutgoingBitrate !== void 0 ? _g_transport_selectedCandidatePair_availableOutgoingBitrate : 0;
                return Math.min(v, _);
            }
            var fb = class extends Bt {
                forceUpdate() {
                    this._forceUpdate = !0;
                }
                onBandwidthChanged(g) {
                    this._forceUpdate ? this.updateBandwidth(g, "forceUpdate") : this.processEstimatedBandwidth(g);
                }
                processEstimatedBandwidth(g) {
                    if (this.lastReportedAgo++, !g || this.bandwidth === g) return;
                    const f = this.configProvider.config.webrtcSendBandwidthIgnoredUpdateLimit, S = this.configProvider.config.webrtcSendBandwidthThreshold, v = this.lastReportedAgo === 1 / 0, _ = !f && !S, C = f && this.lastReportedAgo >= f, E = S && Math.abs((g - this.bandwidth) / this.bandwidth) >= S;
                    if (v || _ || C || E) {
                        const f = +v | +_ << 1 | +C << 2 | +E << 3, S = this.getUpdateReason(f);
                        this.updateBandwidth(g, S);
                    }
                }
                updateBandwidth(g, f) {
                    this.bandwidth = g, this.logger.safe.debug(`Updating send bandwidth: ${this.bandwidth}, reason: ${f}`), this.notifySendBandwidthChanged();
                }
                notifySendBandwidthChanged() {
                    this._forceUpdate = !1, this.event("onSendBandwidthChanged").raise(this.bandwidth), this.lastReportedAgo = 0;
                }
                getUpdateReason(g) {
                    return 1 & g ? "firstReport" : 2 & g ? "throttlingDisabled" : 4 & g ? "noReportsForTooLong" : 8 & g ? "bigMovement" : "none";
                }
                constructor(g, f){
                    super(f), this.configProvider = g, this.logger = f, this.lastReportedAgo = 1 / 0, this._forceUpdate = !1;
                }
            }, Sb = class {
                async setMaxCapabilities(g, f) {
                    var _this_diagnostics;
                    const S = {
                        modality: this.modality,
                        causeId: g,
                        capabilities: f,
                        isSimulcastEnabled: this.isSimulcastEnabled
                    };
                    this.statisticsGatherer.onMaxCapabilitiesRequested(S), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.onMaxCapabilitiesRequested(S), this.causeId = g;
                    const v = this.validator.ensureValidity(f[0]);
                    this.streamSenderParams = {
                        ...f[0],
                        ...v
                    }, this.resolutionManager.setMaxResolution(this.streamSenderParams.maxFs), this.configProvider.mediaConfig.simulcastSessionEnabled && await this.applyCapabilities(this.getParamsToApply());
                }
                resetCurrentResolution() {
                    this.resolutionManager.resetCurrentResolution();
                }
                getCurrentResolution() {
                    return this.resolutionManager.getCurrentResolution();
                }
                setCurrentResolution(g) {
                    this.resolutionManager.setCurrentResolution(g);
                }
                async onResolutionChanged(g) {
                    return this.applyCapabilities(this.getParamsToApply(g));
                }
                dispose() {
                    this.resolutionManager.dispose(), this.resolutionManager = null;
                }
                async applyCapabilities(g) {
                    return g ? this.lastAppliedSenderParams === g ? (this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(g)}`), !0) : (this.logger.safe.info(`Capabilities to apply: ${JSON.stringify(g)}`), this.lastAppliedSenderParams = g, this.listener.onReceiveCapabilitiesChanged(this.modality, this.causeId, [
                        g
                    ])) : (this.logger.safe.error("Send capabilities are not set. Cannot apply constraints"), !1);
                }
                getParamsToApply(g) {
                    if (!this.streamSenderParams) return null;
                    const f = g || this.resolutionManager.getCurrentResolution();
                    if (!f || this.streamSenderParams.maxFs <= f) return this.streamSenderParams;
                    const S = shallowClone(this.streamSenderParams);
                    return S.maxFs = f, S;
                }
                onStatisticsChanged(g) {
                    this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation || this.resolutionManager.updateEstimatedSendBandwidth(g.estimatedSendBandwidth);
                }
                onDiagnosticUpdated(g) {
                    try {
                        if (this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation) {
                            var _g_video_send, _g_video;
                            if (!((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length) || !g.video.send[0]) return;
                            this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("Caught onDiagnosticUpdated: Estimating send bandwidth");
                            const f = calculateEstimatedSendBandwidth(g.video.send[0], this.configProvider);
                            this.resolutionManager.updateEstimatedSendBandwidth(f);
                        }
                    } catch (g) {
                        this.logger.error("Failed to processes diagnostics update: " + g);
                    }
                }
                constructor(g, f, S, v, _, C, E){
                    this.listener = g, this.statisticsGatherer = f, this.diagnostics = S, this.logger = v, this.configProvider = _, this.isSimulcastEnabled = E, this.serialQueue = new q_(this.logger), this.modality = Gt.MODALITY.video;
                    const T = C.maxResolution ? {
                        maxFs: C.maxResolution.fs
                    } : null;
                    this.validator = new d_(this.logger.createChild("CapsValidator"), T), this.resolutionManager = new mb(C, this, this.logger.createChild("rm")), this.statisticsGatherer.on("onStatisticsChanged", (g)=>this.onStatisticsChanged(g)), this.statisticsGatherer.on("onDiagnosticUpdated", (g)=>this.onDiagnosticUpdated(g));
                }
            };
            __decorateClass([
                sequentialize()
            ], Sb.prototype, "applyCapabilities", 1);
            var vb = class {
                setMaxCapabilities(g, f) {
                    var _this_diagnostics;
                    const S = {
                        modality: this.modality,
                        causeId: g,
                        capabilities: f,
                        isSimulcastEnabled: this.isSimulcastEnabled
                    };
                    this.statisticsGatherer.onMaxCapabilitiesRequested(S), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.onMaxCapabilitiesRequested(S), this.listener.onReceiveCapabilitiesChanged(this.modality, g, f);
                }
                dispose() {}
                resetCurrentResolution() {}
                getCurrentResolution() {
                    return null;
                }
                setCurrentResolution(g) {}
                constructor(g, f, S, v, _){
                    this.modality = g, this.listener = f, this.statisticsGatherer = S, this.diagnostics = v, this.isSimulcastEnabled = _;
                }
            }, _b = class {
                dispose() {
                    this.mediaSourceModels.forEach((g)=>{
                        g.handler && (g.handler.dispose(), g.handler = null);
                    }), this.mediaSourceModels = null;
                }
                updateRegisteredSources(g) {
                    this.logger.safe.info(`Local media params updated: ${JSON.stringify(g)}`);
                    const f = [];
                    this.mediaSourceModels.forEach((g)=>f.push(g.sourceId));
                    const S = g.map((g)=>g.sourceId), v = subtractFrom(f, S);
                    this.removeSourcesWithIds(v);
                    const _ = subtractFrom(S, f);
                    this.addSourcesWithIds(_, g);
                }
                setMaxCapabilities(g, f) {
                    for (const S of g){
                        if (!S.capabilities.length) continue;
                        if (!S.sourceId) {
                            this.logger.safe.info(`SourceId is not defined to apply recv capabilities: ${JSON.stringify(S)}`);
                            continue;
                        }
                        const g = this.getModelWithSourceId(S.sourceId);
                        if (!g) {
                            this.logger.safe.info(`Model is not registered for sourceId: ${S.sourceId}`), this.configProvider.config.enableCachingFMTP && this.pendingCapabilities.set(S.sourceId, S);
                            continue;
                        }
                        this.logger.safe.info(`Capabilities handler found for sourceId: ${S.sourceId}`);
                        const v = this.getOrCreateHandlerForModel(g, S.isSimulcast);
                        v ? v.setMaxCapabilities(S.causeId || f, S.capabilities) : this.logger.safe.info(`Handler is not found for sourceId: ${S.sourceId}`);
                    }
                    this.logger.safe.debug("Max capabilities application completed");
                }
                setPendingCapabilities() {
                    if (!this.configProvider.config.enableCachingFMTP) return;
                    this.logger.safe.info(`Apply pending capabilities for sources [${Array.from(this.pendingCapabilities.keys())}]`);
                    const g = Array.from(this.pendingCapabilities.values());
                    this.setMaxCapabilities(g), this.pendingCapabilities.clear();
                }
                clearPendingCapabilities() {
                    this.pendingCapabilities.clear();
                }
                resetCurrentResolution() {
                    const g = this.mediaSourceModels.find((g)=>g.modality === Gt.MODALITY.video);
                    (g === null || g === void 0 ? void 0 : g.handler) && g.handler.resetCurrentResolution();
                }
                getCurrentResolution() {
                    var _this_currentResolution;
                    const g = this.mediaSourceModels.find((g)=>g.modality === Gt.MODALITY.video);
                    return (g === null || g === void 0 ? void 0 : g.handler) ? g.handler.getCurrentResolution() : (_this_currentResolution = this.currentResolution) === null || _this_currentResolution === void 0 ? void 0 : _this_currentResolution.fs;
                }
                setCurrentResolution(g) {
                    const f = this.mediaSourceModels.find((g)=>g.modality === Gt.MODALITY.video);
                    (f === null || f === void 0 ? void 0 : f.handler) ? f.handler.setCurrentResolution(g) : this.currentResolution = g;
                }
                getOrCreateHandlerForModel(g, f) {
                    return g.handler || (g.handler = this.getCapabilitiesHandler(g.modality, f)), g.handler;
                }
                addSourcesWithIds(g, f) {
                    g.forEach((g)=>{
                        const S = f.find((f)=>f.sourceId === g);
                        this.registerSource(g, S.modality);
                    });
                }
                removeSourcesWithIds(g) {
                    g.forEach((g)=>this.unregisterSource(g));
                }
                registerSource(g, f) {
                    this.logger.safe.info(`SourceId ${g} registered with mediaType: ${f}`), this.mediaSourceModels.push({
                        modality: f,
                        sourceId: g
                    });
                }
                unregisterSource(g) {
                    const f = this.mediaSourceModels.find((f)=>f.sourceId === g);
                    f ? (f.handler && f.handler.dispose(), this.mediaSourceModels.splice(this.mediaSourceModels.indexOf(f), 1), this.logger.safe.info(`SourceId ${g} unregistered`)) : this.logger.safe.info(`Model doesn't exist with sourceId ${g}`);
                }
                getModelWithSourceId(g) {
                    return this.mediaSourceModels.find((f)=>f.sourceId === g);
                }
                getCapabilitiesHandler(g, f) {
                    if (g === Gt.MODALITY.audio) return null;
                    if (g === Gt.MODALITY.video && !f && this.settings.customBwEstimationEnabled) {
                        const g = new Sb(this.listener, this.statsGatherer, this.diagnostics, this.logger.createChild("ach"), this.configProvider, this.settings, f);
                        return this.currentResolution && g.setCurrentResolution(this.currentResolution), g;
                    }
                    return new vb(g, this.listener, this.statsGatherer, this.diagnostics, f);
                }
                constructor(g, f, S, v, _, C){
                    this.logger = g, this.settings = f, this.listener = S, this.statsGatherer = v, this.diagnostics = _, this.configProvider = C, this.mediaSourceModels = [], this.pendingCapabilities = new Map;
                }
            }, Cb = class extends Bt {
                addRenderer(g) {
                    this.rendererResolutions.set(g, {
                        width: 0,
                        height: 0
                    }), g.on("onRendererSizeChanged", (g, f)=>{
                        this.onRendererSizeChanged(g, f);
                    }), this.scheduleUpdateLimitedResolutions();
                }
                removeRenderer(g) {
                    this.rendererResolutions.delete(g), this.rendererResolutionsApplied.delete(g), this.rendererResolutionMax.delete(g), this.scheduleUpdateLimitedResolutions();
                }
                clearRenderers() {
                    this.rendererResolutions.clear(), this.rendererResolutionsApplied.clear(), this.rendererResolutionMax.clear();
                }
                getMaxAllowedVideoFS() {
                    const g = this.getMaxHeightFromConfig(this.sizedRenderersCount);
                    return this.getMaxFSForHeight(g);
                }
                limitResolutionOnPoorPerformance(g) {
                    var _this_diagnostics;
                    const f = this.getRendererByMsi(g);
                    if (!f) return;
                    const S = f.resolution.height > f.resolution.width, v = Zt.Recv.getNextLowerResolution(f.resolution.width, f.resolution.height);
                    if (!v) return;
                    const _ = {
                        width: S ? v.height : v.width,
                        height: S ? v.width : v.height
                    };
                    this.rendererResolutionMax.set(f.renderer, _), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.registerResolutionChangeRequest({
                        ts: Date.now(),
                        msi: f.renderer.getMsi(),
                        res: _
                    }), this.logger.safe.info(`Poor perf. Limiting resolution for renderer msi: ${f.renderer.getMsi()} from ${f.resolution.height}p to ${_.height}p`), this.onRendererSizeChanged(f.renderer, _);
                }
                get renderersCount() {
                    return this.rendererResolutions.size;
                }
                get sizedRenderersCount() {
                    return this.configProvider.config.excludeUnsizedRenderersFromMultiviewResolutionLimits ? [
                        ...this.rendererResolutions.values()
                    ].filter((g)=>g.height > 0).length : this.renderersCount;
                }
                getMaxFSForHeight(g) {
                    return this.limitMaxFS(Zt.Recv.getMaxFsForHeight(g));
                }
                getRendererByMsi(g) {
                    for (const [f, S] of this.rendererResolutions.entries())if (f.getMsi() === g) return {
                        renderer: f,
                        resolution: S
                    };
                    return null;
                }
                applyRendererResolution(g, f) {
                    this.setMaxFSCapabilities(g, f), this.rendererResolutionsApplied.set(g, f);
                    const S = g.getMediaStream() && g.getMediaStream().getVideoTracks();
                    (S === null || S === void 0 ? void 0 : S[0]) && this.statsGatherer.setPreferredResolution(S[0].id, f, g.getModality());
                }
                onRendererSizeChanged(g, f) {
                    this.rendererResolutions.set(g, f), this.scheduleUpdateLimitedResolutions();
                }
                scheduleUpdateLimitedResolutions() {
                    this.hasPendingLimitResolutionUpdate || (this.hasPendingLimitResolutionUpdate = !0, window.setTimeout(()=>{
                        this.hasPendingLimitResolutionUpdate = !1;
                        const g = this.groupMaxRenderersResolutionsByMsi();
                        this.logger.safe.info(`Updating resolution limits: renderers count ${this.renderersCount}, with size: ${this.sizedRenderersCount}, resolution limits: ${JSON.stringify(this.configProvider.config.multiviewResolutionLimits)}`), this.spotlightedRenderers = this.findSpotlightedRenderers(), this.spotlightedRenderers.length > 0 && this.logger.safe.info(`Spotlighted renderers: ${this.spotlightedRenderers.map((g)=>g.getMsi())}, max spotlight height: ${this.configProvider.config.maxSpotlightResolution}`);
                        for (const [f, S] of this.rendererResolutions.entries()){
                            if (!S.height) continue;
                            const v = g.get(f.getMsi()), _ = this.limitRendererResolution(f, v || S), C = this.rendererResolutionsApplied.get(f);
                            (!C || C.height !== _.height || C.width !== _.width) && this.applyRendererResolution(f, _);
                        }
                    }, this.configProvider.config.multiviewResolutionLimitUpdateThrottleDelay));
                }
                findSpotlightedRenderers() {
                    if (this.sizedRenderersCount <= 1 || !this.configProvider.config.isSpotlightEnabled) return [];
                    let g = !1, f = 0;
                    for (const [S, v] of this.rendererResolutions.entries())v.height && v.height !== f && (f && (g = !0), f = v.height);
                    if (!g) return [];
                    const S = new fa((g, f)=>g.resolution.width > f.resolution.width);
                    for (const [g, f] of this.rendererResolutions.entries())S.enqueue({
                        renderer: g,
                        resolution: f
                    });
                    const v = [];
                    let _ = this.configProvider.config.maxNumberOfPinnedVideos;
                    for(; _;){
                        var _S_peek_resolution, _S_peek, _S_peek_resolution1, _S_peek1;
                        const g = (_S_peek = S.peek()) === null || _S_peek === void 0 ? void 0 : (_S_peek_resolution = _S_peek.resolution) === null || _S_peek_resolution === void 0 ? void 0 : _S_peek_resolution.width, f = [];
                        for(; ((_S_peek1 = S.peek()) === null || _S_peek1 === void 0 ? void 0 : (_S_peek_resolution1 = _S_peek1.resolution) === null || _S_peek_resolution1 === void 0 ? void 0 : _S_peek_resolution1.width) === g;)f.push(S.dequeue().renderer);
                        if (!(_ - f.length >= 0)) break;
                        _ -= f.length, v.push(...f);
                    }
                    return v;
                }
                getMaxHeightFromConfig(g, f = !1) {
                    return f ? this.configProvider.config.maxSpotlightResolution : this.configProvider.config.multiviewResolutionLimits[`${g}`] || this.configProvider.config.multiviewResolutionLimits.more;
                }
                getMaxHeight(g) {
                    const f = this.spotlightedRenderers.some((f)=>f.getMsi() === g.getMsi());
                    let S = this.getMaxHeightFromConfig(this.sizedRenderersCount, f);
                    const v = this.rendererResolutionMax.get(g);
                    return v && (S = Math.min(S, Math.min(v.height, v.width))), S;
                }
                limitRendererResolution(g, f) {
                    const S = this.getMaxHeight(g);
                    if (!S) return f;
                    if (f.height > f.width && f.width > S) {
                        const g = S / f.width;
                        return {
                            height: Math.ceil(f.height * g),
                            width: S,
                            limited: !0
                        };
                    }
                    if (f.width > f.height && f.height > S) {
                        const g = S / f.height;
                        return {
                            height: S,
                            width: Math.ceil(f.width * g),
                            limited: !0
                        };
                    }
                    return f;
                }
                setMaxFSCapabilities(g, f) {
                    const S = g.getMediaStream();
                    if (!S) return void this.logger.safe.warn("renderer has no stream attached");
                    const v = this.mediaManager.getMediaEntityByRemoteStreamId(S.id);
                    if (!(v === null || v === void 0 ? void 0 : v.getLocalRecvCapabilities())) return void this.logger.safe.warn(`no capabilities for provided modality: ${g.getModality()}`);
                    const _ = f.limited ? this.getMaxFSForHeight(f.height) : this.getMaxFS(f.width, f.height), C = v.getLocalRecvCapabilities();
                    C.setMaxFS(_, ()=>{
                        if (this.logger.safe.info(`updated max-fs video capability to ${_} for renderer msi: ${g.getMsi()}`), this.multiParty && this.configProvider.config.webrtcMultiPartyRecvVideoSignaling) {
                            const f = g.getMsi(), v = C.buildFmtp();
                            this.event("onSourceRequestRequired").raise(S.id, f, v);
                        } else this.event("onNegotiationRequired").raise();
                    });
                }
                getMaxFS(g, f) {
                    return this.limitMaxFS(Zt.Recv.getMaxFsForHeight(f));
                }
                limitMaxFS(g) {
                    return this.multiParty ? Math.min(g, this.configProvider.config.webrtcMultiPartyRecvVideoMaxFS) : Math.min(g, this.configProvider.config.webrtcRecvVideoMaxFS);
                }
                groupMaxRenderersResolutionsByMsi() {
                    const g = new Map;
                    return this.rendererResolutions.forEach((f, S)=>{
                        const v = S.getMsi(), _ = g.get(v);
                        (!_ || f.width > _.width && f.height > _.height) && g.set(v, f);
                    }), g;
                }
                constructor(g, f, S, v, _, C){
                    super(g), this.logger = g, this.multiParty = f, this.configProvider = S, this.mediaManager = v, this.statsGatherer = _, this.diagnostics = C, this.rendererResolutions = new Map, this.rendererResolutionsApplied = new Map, this.rendererResolutionMax = new Map, this.hasPendingLimitResolutionUpdate = !1, this.spotlightedRenderers = [];
                }
            }, yb = class extends Bt {
                captureRawStatistics(g) {
                    const f = g.googFrameRateDecoded, S = g.googFrameRateReceived, v = g.bytesReceived;
                    void 0 !== v && this.getModality() !== Gt.MODALITY.sharing && this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation && this.calculateBitrate(v, f), f > 0 && (this.mediaStarted = !0), 0 === f || 0 === S ? this.currentFreezeDuration += Gt.TIME_INTERVAL.SEC_1 : f > 0 && (void 0 === S || S > 0) && (this.currentFreezeDuration = 0);
                    const _ = this.configProvider.config.notRenderingTimeInterval[this.getModality()];
                    this.setIsRendering(_);
                }
                updateRenderingTracker(g) {
                    const f = g.extensions.frameRateDecoded || 0, S = g.extensions.frameRateReceived || 0, v = g.extensions.bitrate;
                    void 0 !== v && this.getModality() !== Gt.MODALITY.sharing && this.configProvider.config.isBytesRecvUsedInIsRenderingCalculation && this.calculateLowBitrateDuration(v, f), f > 0 && (this.mediaStarted = !0), 0 === f || 0 === S ? this.currentFreezeDuration += Gt.TIME_INTERVAL.SEC_1 : f > 0 && (void 0 === S || S > 0) && (this.currentFreezeDuration = 0);
                    const _ = this.configProvider.config.notRenderingTimeInterval[this.getModality()];
                    this.setIsRendering(_);
                }
                calculateLowBitrateDuration(g, f) {
                    g / 1e3 < this.configProvider.config.notRenderingLowBitrateThreshold && f < this.configProvider.config.notRenderingLowFramerateThreshold ? this.currentLowBitrateDuration++ : this.currentLowBitrateDuration = 0;
                }
                calculateBitrate(g, f) {
                    const S = 8 * (g - this.lastBytesRecv);
                    this.lastBytesRecv = g, this.calculateLowBitrateDuration(S, f);
                }
                setIsRendering(g) {
                    const f = this.currentFreezeDuration < g && this.currentLowBitrateDuration < g && this.mediaStarted;
                    f !== this.isRendering && (this.isRendering = f, this.event("onIsRenderingChanged").raise(this.isRendering));
                }
                constructor(g, f){
                    super(), this.configProvider = g, this.getModality = f, this.isRendering = !1, this.currentFreezeDuration = 0, this.mediaStarted = !1, this.lastBytesRecv = 0, this.currentLowBitrateDuration = 0;
                }
            }, Eb = class extends Bt {
                calcFreezeDurationMs() {
                    const g = this.videoElement.currentTime, f = g === this.prevCurrentTime, S = this.videoElement.webkitDecodedFrameCount, v = void 0 === S || S === this.prevDecodedFrameCount;
                    this.prevCurrentTime = g, this.prevDecodedFrameCount = S;
                    if (-1 !== this.getTimeToFirstFrame()) {
                        if (f && v) {
                            const g = Date.now();
                            this.currentFreezeDuration += g - this.prevTimestamp, this.prevTimestamp = g;
                        } else {
                            if (this.currentFreezeDuration > this.configProvider.config.freezeMinDuration) {
                                const g = this.calcFreeze();
                                this.event("onFreezeEnded").raise(g);
                            }
                            this.currentFreezeDuration = 0;
                        }
                    }
                    this.prevTimestamp = Date.now();
                }
                getEndOfTheFreeze() {
                    let g = 0;
                    return this.currentFreezeDuration > 0 && (g = this.calcFreeze(), this.currentFreezeDuration = 0), g;
                }
                dispose() {
                    const g = this.getEndOfTheFreeze();
                    this.event("onFreezeEnded").raise(g), clearInterval(this.freezeDurationTimer);
                }
                calcFreeze() {
                    const g = Date.now() - this.prevTimestamp;
                    return this.currentFreezeDuration + g;
                }
                constructor(g, f, S){
                    super(), this.videoElement = g, this.configProvider = f, this.getTimeToFirstFrame = S, this.prevCurrentTime = 0, this.prevDecodedFrameCount = 0, this.prevTimestamp = Date.now(), this.currentFreezeDuration = 0, this.freezeDurationTimer = window.setInterval(()=>{
                        this.calcFreezeDurationMs();
                    }, this.configProvider.config.freezeIntervalFrequency);
                }
            }, Tb = class extends Bt {
                get width() {
                    return this.originalVideoElementSize.width * this.devicePixelRatio;
                }
                get height() {
                    return this.originalVideoElementSize.height * this.devicePixelRatio;
                }
                initializeSizeTracking() {
                    const g = Math.floor(Math.random() * Math.abs(this.maxInterval - this.minInterval)) + this.minInterval;
                    this.elementSizeTrackingRef = this.window.setInterval(()=>{
                        this.videoElementSizeChanged() && (this.saveCurrentVideoElementSize(), this.raiseChanged());
                    }, g);
                }
                triggerVideoElementSizeChange() {
                    this.originalVideoElementSize.height && this.originalVideoElementSize.width && this.raiseChanged();
                }
                dispose() {
                    this.elementSizeTrackingRef && this.window.clearInterval(this.elementSizeTrackingRef);
                }
                videoElementSizeChanged() {
                    return this.originalVideoElementSize.width !== this.videoElement.offsetWidth || this.originalVideoElementSize.height !== this.videoElement.offsetHeight;
                }
                saveCurrentVideoElementSize() {
                    this.originalVideoElementSize.width = this.videoElement.offsetWidth, this.originalVideoElementSize.height = this.videoElement.offsetHeight;
                }
                constructor(g, f, S, v){
                    super(), this.videoElement = g, this.minInterval = f, this.maxInterval = S, this.window = Qa.window, this.devicePixelRatio = v && window.devicePixelRatio || 1, this.originalVideoElementSize = {
                        width: g.offsetWidth,
                        height: g.offsetHeight
                    }, this.initializeSizeTracking();
                }
            }, Ib = class extends X_ {
                getEndOfTheFreeze() {
                    var _this_freezeTracker;
                    return (_this_freezeTracker = this.freezeTracker) === null || _this_freezeTracker === void 0 ? void 0 : _this_freezeTracker.getEndOfTheFreeze();
                }
                resetTimeToFirstFrameFlag() {
                    this.isTimeToFirstFrameReported = !1;
                }
                setIsRendering(g) {
                    this.currentIsRendering !== g && (this.currentIsRendering = g, this.captureIsRenderingEvent(g));
                }
                updateStatsOverlay(g, f) {
                    this.overlayStats.setStats(g, f);
                }
                updateIsRenderingTracker(g) {
                    var _this_isRenderingTracker;
                    (_this_isRenderingTracker = this.isRenderingTracker) === null || _this_isRenderingTracker === void 0 ? void 0 : _this_isRenderingTracker.updateRenderingTracker(g);
                }
                subscribeVideoAsync(g, f) {
                    return this.timeToFirstFrameSinceSubscriptionStart = Date.now(), new Promise((S, v)=>{
                        this.modality = f ? Gt.MODALITY.sharing : Gt.MODALITY.video, this.diagnostics && (this.diagnostics.msi = g, this.diagnostics.modality = this.modality), this.trackElementSizeChange(), this.unsubscribe(), this.on("onVideoSizeChanged", (f, S)=>{
                            var _this_sessionDiagnostics, _this_sizeTracker;
                            if (this.modality === Gt.MODALITY.video && ((_this_sessionDiagnostics = this.sessionDiagnostics) === null || _this_sessionDiagnostics === void 0 ? void 0 : _this_sessionDiagnostics.registerResolutionChangeEvent({
                                ts: Date.now(),
                                msi: g,
                                res: {
                                    width: f,
                                    height: S
                                }
                            })), this.isTimeToFirstFrameReported) return;
                            if (-1 === this.timeToFirstFrame) {
                                const g = Date.now();
                                this.timeToFirstFrame = g - this.startTimeTTFF, this.timeToFirstFrameSinceSubscriptionStart = Date.now() - this.timeToFirstFrameSinceSubscriptionStart;
                            }
                            const v = this.getTrackId();
                            v && (this.diagnostics.timeToFirstFrameSinceSubscriptionStart = this.timeToFirstFrameSinceSubscriptionStart, this.diagnostics.timeToFirstFrame = this.timeToFirstFrame, (_this_sizeTracker = this.sizeTracker) === null || _this_sizeTracker === void 0 ? void 0 : _this_sizeTracker.triggerVideoElementSizeChange(), this.event("onVideoStarted").raise(this.timeToFirstFrame, this.timeToFirstFrameSinceSubscriptionStart, v), this.isTimeToFirstFrameReported = !0);
                        }), this.on("onVideoRendererStateChanged", (g)=>{
                            this.diagnostics.addStateChange(g);
                        });
                        const _ = this.subscriptionManager.subscribeVideo(this.modality, g);
                        this.subscription = _, this.logger.safe.info(`subscribing renderer to type: ${_.modality} msi: ${_.msi}`), _.setOnMediaStreamChangedHandler((g)=>{
                            var _this_sizeTracker;
                            const f = this.getMediaStream();
                            this.attachMediaStream(g), g && (this.startTimeTTFF = Date.now());
                            const v = this.getTrackId();
                            v && this.diagnostics && (this.diagnostics.trackId = v), this.logger.safe.info(`subscribed renderer to type: ${_.modality} msi: ${_.msi} on stream #${g ? g.id : "none"}`), g && f !== g && ((_this_sizeTracker = this.sizeTracker) === null || _this_sizeTracker === void 0 ? void 0 : _this_sizeTracker.triggerVideoElementSizeChange()), S();
                        }), _.setOnErrorHandler((f)=>{
                            this.logger.safe.error(`failed to subscribe renderer ${stringifyObject(f)}`), "webRtcSession cleanup" === JSON.stringify(f) && (this.logger.safe.info(`Retry to subscribe to video stream with msi: ${g}. Previous session was cleaned up`), this.subscriptionManager.streamChangedByMsi(g), S()), v(f);
                        });
                    });
                }
                dispose() {
                    var _this_freezeTracker, _this_sizeTracker, _this_isRenderingChangedSubscription, _this_diagnostics;
                    this.disposed ? this.logger.safe.warn("renderer already disposed") : (this.disposed = !0, this.logger.safe.info("disposing"), this.unsubscribe(), this.captureIsRenderingEvent(!1), (_this_freezeTracker = this.freezeTracker) === null || _this_freezeTracker === void 0 ? void 0 : _this_freezeTracker.dispose(), (_this_sizeTracker = this.sizeTracker) === null || _this_sizeTracker === void 0 ? void 0 : _this_sizeTracker.dispose(), (_this_isRenderingChangedSubscription = this.isRenderingChangedSubscription) === null || _this_isRenderingChangedSubscription === void 0 ? void 0 : _this_isRenderingChangedSubscription.dispose(), this.overlayStats.dispose(), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.dispose(), this.event("onRendererDisposed").raise(this), super.dispose());
                }
                getModality() {
                    return this.modality;
                }
                getMsi() {
                    var _this_subscription;
                    var _this_subscription_msi;
                    return (_this_subscription_msi = (_this_subscription = this.subscription) === null || _this_subscription === void 0 ? void 0 : _this_subscription.msi) !== null && _this_subscription_msi !== void 0 ? _this_subscription_msi : -1;
                }
                getLocalMsi() {
                    var _this_subscription;
                    return (_this_subscription = this.subscription) === null || _this_subscription === void 0 ? void 0 : _this_subscription.localMsi;
                }
                getCurrentResolution() {
                    var _this_resolution;
                    return (_this_resolution = this.resolution) !== null && _this_resolution !== void 0 ? _this_resolution : {
                        width: 0,
                        height: 0
                    };
                }
                unsubscribeNow() {
                    var _this_subscription;
                    (_this_subscription = this.subscription) === null || _this_subscription === void 0 ? void 0 : _this_subscription.unsubscribe(), this.subscription = null;
                }
                trackElementSizeChange() {
                    const g = this.modality === Gt.MODALITY.sharing, f = g ? this.configProvider.config.webrtcScreensharingCapabilityCheckIntervalMin : this.configProvider.config.webrtcVideoCapabilityCheckIntervalMin, S = g ? this.configProvider.config.webrtcScreensharingCapabilityCheckIntervalMax : this.configProvider.config.webrtcVideoCapabilityCheckIntervalMax;
                    f && S ? (this.sizeTracker = new Tb(this.getVideoElement(), f, S, this.configProvider.config.enableDevicePixelRatio), this.sizeTracker.changed(()=>this.onSizeTrackerChanged())) : this.logger.safe.info("skipping video size tracking");
                }
                onSizeTrackerChanged() {
                    this.resolution = {
                        width: this.sizeTracker.width,
                        height: this.sizeTracker.height
                    }, this.logger.safe.info(`video renderer size changed to ${this.resolution.width}x${this.resolution.height}`), this.diagnostics && (this.diagnostics.rendererSize = this.resolution), this.event("onRendererSizeChanged").raise(this, this.resolution);
                }
                unsubscribe() {
                    var _this_subscription;
                    (_this_subscription = this.subscription) === null || _this_subscription === void 0 ? void 0 : _this_subscription.dispose(), this.subscription = null;
                }
                captureIsRenderingEvent(g) {
                    this.diagnostics && (this.diagnostics.isRendering = g), this.event("onIsRenderingChanged").raise(g, this.getModality(), this.getTrackId());
                }
                constructor(g, f, S, v, _, C){
                    super(_, g.createChild("remote"), f), this.diagnostics = S, this.subscriptionManager = v, this.sessionDiagnostics = C, this.disposed = !1, this.currentIsRendering = !1, this.startTimeTTFF = 0, this.timeToFirstFrame = -1, this.isTimeToFirstFrameReported = !1, this.configProvider.config.freezeIntervalFrequency && (this.freezeTracker = new Eb(this.getVideoElement(), this.configProvider, ()=>this.timeToFirstFrame), this.freezeTracker.on("onFreezeEnded", (g)=>{
                        var _this_diagnostics;
                        (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.addFreezeDuration(g), this.event("onFreezeEnded").raise(g);
                    })), this.configProvider.config.isRenderingBasedOnRawStatistics && (this.isRenderingTracker = new yb(this.configProvider, this.getModality.bind(this)), this.isRenderingChangedSubscription = this.isRenderingTracker.on("onIsRenderingChanged", (g)=>{
                        this.setIsRendering(g);
                    })), this.overlayStats = new J_(this.configProvider.config.showStatsInCall, _, this);
                }
            }, bb = class {
                createRenderer(g, f, S) {
                    var _this_diagnostics;
                    const v = new Ib((S !== null && S !== void 0 ? S : this.logger).createChild("videorenderer"), this.configProvider, (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.newRendererDiagnostics(), f, g, this.sessionDiagnostics);
                    return this.domOverrides.onMediaElementAdded && this.domOverrides.onMediaElementAdded(v.getVideoElement()), this.addRenderer(v), v;
                }
                moveRenderers(g) {
                    this.renderers.forEach((f)=>{
                        f.resetTimeToFirstFrameFlag(), g.addRenderer(f), this.removeRenderer(f);
                    });
                }
                getMaxAllowedVideoFS() {
                    return this.remoteVideoResolutionManager.getMaxAllowedVideoFS();
                }
                dispose() {
                    this.renderers.forEach((g)=>g.resetTimeToFirstFrameFlag()), this.renderers.forEach((g)=>{
                        const f = g.getTrackId(), S = g.getEndOfTheFreeze();
                        this.statsGatherer.setFreezeDuration(S, f);
                    }), this.remoteRendererSubscriptions.forEach((g, f)=>{
                        f.dispose(), g.forEach((g)=>g.dispose());
                    }), this.remoteRendererSubscriptions.clear(), this.remoteVideoResolutionManager.clearRenderers();
                }
                processStatsReport(g) {
                    this.configProvider.config.isRenderingBasedOnRawStatistics && this.onDiagnosticUpdated(g), this.updateOverlayStats(g);
                }
                processLegacyStats(g) {
                    this.configProvider.config.isRenderingBasedOnRawStatistics || this.renderers.forEach((f)=>{
                        const S = f.getTrackId();
                        if (g.remoteVideoStreams[S]) {
                            const v = g.remoteVideoStreams[S].isRendering;
                            void 0 !== v && f.setIsRendering(v);
                        }
                    });
                }
                playVideo() {
                    this.renderers.forEach((g)=>g.playVideo());
                }
                get renderers() {
                    return Array.from(this.remoteRendererSubscriptions, ([g])=>g);
                }
                addRenderer(g) {
                    this.remoteRendererSubscriptions.set(g, this.subscribeOnEvents(g)), this.logger.safe.info("Added renderer to manager"), this.remoteVideoResolutionManager.addRenderer(g);
                }
                generateVideoRecvStats(g) {
                    var _g_sharing, _g_video;
                    const f = new Map, processRecvStats = (g)=>{
                        g === null || g === void 0 ? void 0 : g.forEach((g)=>{
                            var _g_track;
                            var _g_track_trackIdentifier;
                            const S = (_g_track_trackIdentifier = (_g_track = g.track) === null || _g_track === void 0 ? void 0 : _g_track.trackIdentifier) !== null && _g_track_trackIdentifier !== void 0 ? _g_track_trackIdentifier : g.inboundRTP.trackIdentifier;
                            f.set(S, g);
                        });
                    };
                    return processRecvStats((_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : _g_sharing.recv), processRecvStats((_g_video = g.video) === null || _g_video === void 0 ? void 0 : _g_video.recv), f;
                }
                updateOverlayStats(g) {
                    const f = this.generateVideoRecvStats(g);
                    this.renderers.forEach((S)=>{
                        var _g_audio_recv, _g_audio;
                        const v = S.getTrackId();
                        f.has(v) && ((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : (_g_audio_recv = _g_audio.recv) === null || _g_audio_recv === void 0 ? void 0 : _g_audio_recv.length) && S.updateStatsOverlay(f.get(v), g.audio.recv[0]);
                    });
                }
                onDiagnosticUpdated(g) {
                    var _g_video, _g_sharing;
                    var _g_video_recv, _g_sharing_recv;
                    const f = [
                        ...(_g_video_recv = (_g_video = g.video) === null || _g_video === void 0 ? void 0 : _g_video.recv) !== null && _g_video_recv !== void 0 ? _g_video_recv : [],
                        ...(_g_sharing_recv = (_g_sharing = g.sharing) === null || _g_sharing === void 0 ? void 0 : _g_sharing.recv) !== null && _g_sharing_recv !== void 0 ? _g_sharing_recv : []
                    ];
                    if (f.length) {
                        const g = new Map;
                        f.forEach((f)=>{
                            var _f_track;
                            g.set((_f_track = f.track) === null || _f_track === void 0 ? void 0 : _f_track.trackIdentifier, f);
                        }), this.renderers.forEach((f)=>{
                            const S = f.getTrackId();
                            g.has(S) && f.updateIsRenderingTracker(g.get(S));
                        });
                    }
                }
                subscribeOnEvents(g) {
                    return [
                        g.on("onRendererDisposed", (g)=>this.onRendererDisposed(g)),
                        g.on("onVideoStarted", (g, f, S)=>this.onVideoStarted(g, f, S)),
                        g.on("onFreezeEnded", (f)=>{
                            const S = g.getTrackId();
                            this.statsGatherer.setFreezeDuration(f, S);
                        }),
                        g.on("onIsRenderingChanged", (g, f, S)=>this.statsGatherer.setIsRendering(g, f, S))
                    ];
                }
                onRendererDisposed(g) {
                    this.logger.safe.debug("Renderer removed from manager"), this.removeRenderer(g), this.domOverrides.onMediaElementRemoved && this.domOverrides.onMediaElementRemoved(g.getVideoElement());
                }
                removeRenderer(g) {
                    this.remoteRendererSubscriptions.get(g).forEach((g)=>g.dispose()), this.remoteRendererSubscriptions.delete(g), this.remoteVideoResolutionManager.removeRenderer(g);
                }
                onVideoStarted(g, f, S) {
                    this.statsGatherer.setTimeToFirstFrame(g, f, S);
                }
                constructor(g, f, S, v, _, C){
                    this.logger = g, this.configProvider = f, this.statsGatherer = S, this.sessionDiagnostics = v, this.remoteVideoResolutionManager = _, this.domOverrides = C, this.remoteRendererSubscriptions = new Map, this.diagnostics = v === null || v === void 0 ? void 0 : v.newRemoteVideoManagerDiagnostics();
                }
            }, Ab = class extends Bt {
                get effectsManager() {
                    return this.callDeviceManager.getDeviceManager("Video").effectsManager;
                }
                startWatching(g, f) {
                    (this.configProvider.config.videoCaptureFreezeTimeout || f) && (this.trackInfo = g, this.performanceMonitor = f, this.configProvider.config.videoCaptureFreezeTimeout && (this.videoEffectManagerSubscription || (this.videoEffectManagerSubscription = this.effectsManager.on("videoFreezeDetected", (g)=>this.onVideoFreezeDetected(g)))));
                }
                stopWatching() {
                    var _this_videoEffectManagerSubscription;
                    this.trackInfo = [], (_this_videoEffectManagerSubscription = this.videoEffectManagerSubscription) === null || _this_videoEffectManagerSubscription === void 0 ? void 0 : _this_videoEffectManagerSubscription.dispose(), this.videoEffectManagerSubscription = null, this.performanceMonitor = void 0, 0 !== this.lastFramerateInput || this.timeoutId || this.event("onVideoCaptureFreeze").raise(!1, !this.effectsManager.isEffectEnabled("Video")), this.disposeTimer(), this.lastFramerateInput = -1;
                }
                dispose(g) {
                    var _this_callDeviceManagerSub;
                    (_this_callDeviceManagerSub = this.callDeviceManagerSub) === null || _this_callDeviceManagerSub === void 0 ? void 0 : _this_callDeviceManagerSub.dispose(), super.dispose(g), this.stopWatching();
                }
                onDiagnosticUpdated(g) {
                    var _g_video_send, _g_video, _g_video1, _this_performanceMonitor;
                    if (!this.trackInfo.length || !((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length)) return;
                    this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("Caught onDiagnosticUpdated: Updating local video stream watcher");
                    const f = (_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : _g_video1.send[0], S = [];
                    let v, _ = 0;
                    var _f_altLayouts;
                    [
                        f,
                        ...(_f_altLayouts = f.altLayouts) !== null && _f_altLayouts !== void 0 ? _f_altLayouts : []
                    ].forEach((g)=>{
                        var _f_framesPerSecond;
                        const f = g.mediaSource, C = (_f_framesPerSecond = f === null || f === void 0 ? void 0 : f.framesPerSecond) !== null && _f_framesPerSecond !== void 0 ? _f_framesPerSecond : 0;
                        this.trackInfo.some((g)=>g.trackId === f.trackIdentifier) && ((!v || _ < C) && (v = f, _ = C), this.performanceMonitor && S.push(g.outboundRTP));
                    }), (_this_performanceMonitor = this.performanceMonitor) === null || _this_performanceMonitor === void 0 ? void 0 : _this_performanceMonitor.monitor(S), this.configProvider.config.videoCaptureFreezeTimeout && (v ? _ !== this.lastFramerateInput && (0 === _ ? this.scheduleCaptureFreezeStart(v.trackIdentifier, !this.effectsManager.isEffectEnabled("Video")) : 0 === this.lastFramerateInput && (this.timeoutId ? this.disposeTimer() : (this.logger.info(`onVideoCaptureFreeze end for trackId: ${v.trackIdentifier}`), this.event("onVideoCaptureFreeze").raise(!1, !this.effectsManager.isEffectEnabled("Video")))), this.lastFramerateInput = _) : this.logger.safe.warn("WebRTC Stats for send video not found"));
                }
                onStatisticsChanged(g) {
                    if (!this.trackInfo.length || !this.configProvider.config.videoCaptureFreezeTimeout) return;
                    let f;
                    Object.keys(g.localVideoStreams).forEach((S)=>{
                        const v = g.localVideoStreams[S];
                        this.trackInfo.some((g)=>g.trackId === v.trackId) && (!f || f.frameRateInput < v.frameRateInput) && (f = v);
                    }), f ? f.frameRateInput !== this.lastFramerateInput && (0 === f.frameRateInput ? this.scheduleCaptureFreezeStart(f.trackId, !this.effectsManager.isEffectEnabled("Video")) : 0 === this.lastFramerateInput && (this.timeoutId ? this.disposeTimer() : (this.logger.info(`onVideoCaptureFreeze end for trackId: ${f.trackId}`), this.event("onVideoCaptureFreeze").raise(!1, !this.effectsManager.isEffectEnabled("Video")))), this.lastFramerateInput = f.frameRateInput) : this.logger.safe.warn("WebRTC Stats for send video not found");
                }
                onVideoFreezeDetected(g) {
                    this.logger.info(`onVideoCaptureFreeze, webcam freeze detected trackId: ${g}`), this.event("onVideoCaptureFreeze").raise(!1, !0);
                }
                scheduleCaptureFreezeStart(g, f) {
                    this.timeoutId = window.setTimeout(()=>{
                        this.timeoutId = null, this.logger.safe.info(`onVideoCaptureFreeze start for trackId: ${g} (isWebcamStream: ${f})`), this.event("onVideoCaptureFreeze").raise(!0, f);
                    }, this.configProvider.config.videoCaptureFreezeTimeout);
                }
                disposeTimer() {
                    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null);
                }
                handleDeviceManagerChange() {
                    var _this_videoEffectManagerSubscription;
                    (_this_videoEffectManagerSubscription = this.videoEffectManagerSubscription) === null || _this_videoEffectManagerSubscription === void 0 ? void 0 : _this_videoEffectManagerSubscription.dispose(), this.videoEffectManagerSubscription = this.effectsManager.on("videoFreezeDetected", (g)=>this.onVideoFreezeDetected(g));
                }
                constructor(g, f, S){
                    super(), this.configProvider = f, this.callDeviceManager = S, this.lastFramerateInput = -1, this.trackInfo = [], this.timeoutId = null, this.logger = g.createChild("localStreamWatcher"), this.callDeviceManagerSub = S.on("onSelectedVirtualDevicesChanged", ()=>{
                        this.logger.info("VirtualDevice changed, updating subscriptions"), this.handleDeviceManagerChange();
                    });
                }
            }, Rb = class {
                cleanup() {
                    this.queue.forEach((g)=>{
                        g.reject({
                            notSent: g.tones
                        });
                    }), this.queue = [];
                }
                waitForNotification(g) {
                    return g ? (this.logger.unsafe.info("sending dtmf tones: ", g), new Promise((f, S)=>{
                        this.queue.push({
                            tones: g,
                            resolve: f,
                            reject: S
                        });
                    })) : Promise.reject(new Error("invalid input"));
                }
                toneSent(g) {
                    this.queue[0] && (g === this.queue[0].tones[0] ? (this.queue[0].tones = this.queue[0].tones.substr(1), "" === this.queue[0].tones && (this.queue[0].resolve(), this.queue.shift())) : (this.queue[0].reject(new Error(`sent tone does not match: expected '${this.queue[0].tones[0]}' got '${g}'`)), this.queue.shift(), this.toneSent(g)));
                }
                constructor(g){
                    this.queue = [], this.logger = g;
                }
            }, Pb = class {
                sendDtmf(g, f) {
                    return (g === null || g === void 0 ? void 0 : g.getSenders) ? (this.syncSender(g), this.webRtcSender ? (this.webRtcSender.ontonechange = this.onToneChange.bind(this), this.webRtcSender.insertDTMF(this.webRtcSender.toneBuffer + f, this.configProvider.config.dtmf.toneDuration, this.configProvider.config.dtmf.toneGap), this.queue.waitForNotification(f)) : Promise.reject(new Error("not available"))) : Promise.reject(new Error("bad peerConnection"));
                }
                canSendDtmf(g) {
                    return !!(g === null || g === void 0 ? void 0 : g.getSenders) && (this.syncSender(g), !!this.webRtcSender && this.webRtcSender.canInsertDTMF);
                }
                dispose() {
                    this.queue.cleanup();
                }
                syncSender(g) {
                    const f = g.getSenders().filter((g)=>g.track && "audio" === g.track.kind).filter((g)=>{
                        var _g_dtmf;
                        return (_g_dtmf = g.dtmf) === null || _g_dtmf === void 0 ? void 0 : _g_dtmf.canInsertDTMF;
                    })[0];
                    this.webRtcSender && f && f.dtmf !== this.webRtcSender && (this.webRtcSender.ontonechange = null, this.queue.cleanup()), this.webRtcSender = f ? f.dtmf : null;
                }
                onToneChange(g) {
                    g.tone && this.queue.toneSent(g.tone);
                }
                constructor(g){
                    this.webRtcSender = null, this.configProvider = g.configProvider, this.queue = new Rb(g.logger);
                }
            }, wb = {
                build: (g)=>new Pb(g)
            }, Mb = class extends Bt {
                get hasPcConnectionState() {
                    return "connectionState" in this.pc && this.configProvider.config.useConnectionState;
                }
                get isWaitingAcceptProvisional() {
                    return this.isWaitingAcceptProvisionalInternal;
                }
                set isWaitingAcceptProvisional(g) {
                    this.isWaitingAcceptProvisionalInternal !== g && (this.logger.safe.debug(`isProvisional set ${this.isWaitingAcceptProvisionalInternal} -> ${g}`), this.isWaitingAcceptProvisionalInternal = g, this.diagnostics.provisional = g, this.updateState(this.state, !1));
                }
                get iceConnectionState() {
                    return this.iceConnectionStateInternal;
                }
                get signalingState() {
                    return this.signalingStateInternal;
                }
                get isIceConnected() {
                    return "connected" === this.iceConnectionStateInternal || "completed" === this.iceConnectionStateInternal;
                }
                get isTransportConnected() {
                    return "connected" === this.state || "completed" === this.state;
                }
                get isFailed() {
                    return this.configProvider.config.transportStateFailedFix ? "failed" === this.state : "failed" === this.state || "closed" === this.state;
                }
                get isConnected() {
                    return this.isTransportConnected && "closed" !== this.signalingStateInternal;
                }
                doOnConnected(g, f = "unknown", S = !1, v = !0) {
                    return this.diagnostics.scheduleDoOnConnected(g, f, S, v), v && this.isConnected && (S || !this.isWaitingAcceptProvisionalInternal) ? (this.logger.safe.info(`Running callback immediately ${f}`), this.diagnostics.runDoOnConnected(g, !0), void g()) : S ? (this.logger.safe.info(`Queuing provisional connected callback '${f}'`), void this.toBeCalledOnProvisionalConnected.push(g)) : (this.logger.safe.info(`Queuing connected callback '${f}'`), void this.toBeCalledOnConnected.push(g));
                }
                dispose() {
                    this.pc.oniceconnectionstatechange = void 0, this.pc.onsignalingstatechange = void 0, this.transport && (this.transport.onstatechange = void 0), this.pc.onconnectionstatechange && (this.pc.onconnectionstatechange = void 0), this.diagnostics.dispose();
                }
                updateState(g, f = !0) {
                    if (f && (this.statePrevious = this.state), this.state = g, this.event("stateChanged").raise(this.state, this.statePrevious, generateCauseId()), this.diagnostics.transportState = g, this.isConnected) {
                        if (!this.isWaitingAcceptProvisionalInternal && this.toBeCalledOnConnected.length) for(this.logger.safe.info(`Running ${this.toBeCalledOnConnected.length} callbacks on connected`); this.toBeCalledOnConnected.length;){
                            const g = this.toBeCalledOnConnected.shift();
                            this.diagnostics.runDoOnConnected(g), g();
                        }
                        if (this.toBeCalledOnProvisionalConnected.length) for(this.logger.safe.info(`Running ${this.toBeCalledOnProvisionalConnected.length} callbacks on provisional connected`); this.toBeCalledOnProvisionalConnected.length;){
                            const g = this.toBeCalledOnProvisionalConnected.shift();
                            this.diagnostics.runDoOnConnected(g), g();
                        }
                    }
                }
                shouldRaise(g) {
                    switch(g){
                        case 3:
                            if (1 !== this.cryptoMethod) throw new Error(`DTLS transport is used with cryptoMethod=${this.cryptoMethod}`);
                            return !this.configProvider.config.ignoreClosedDtlsTransportState || "closed" !== this.transport.state;
                        case 1:
                            return 1 === this.cryptoMethod && !this.transport;
                        case 0:
                            var _this_transport;
                            return !(!this.configProvider.config.ignoreClosedDtlsTransportState || !this.transport || "closed" !== this.pc.iceConnectionState) || 0 === this.cryptoMethod || !this.transport && !this.hasPcConnectionState || this.transport && "disconnected" === this.pc.iceConnectionState || "connected" === ((_this_transport = this.transport) === null || _this_transport === void 0 ? void 0 : _this_transport.state) && "connected" === this.pc.iceConnectionState;
                        default:
                            return this.logger.safe.error(`unknown StateMethod=${g}`), !1;
                    }
                }
                constructor(g, f, S, v, _){
                    super(S), this.pc = g, this.cryptoMethod = f, this.logger = S, this.configProvider = v, this.diagnostics = _, this.iceConnectionStateInternal = "new", this.isWaitingAcceptProvisionalInternal = !1, this.state = "new", this.toBeCalledOnConnected = [], this.toBeCalledOnProvisionalConnected = [], this.handleSignalingStateChange = ()=>{
                        const g = this.pc.signalingState;
                        if (this.logger.safe.info(`RTCPeerConnection onsignalingstatechange signalingState: ${this.signalingStateInternal} -> ${g}`), this.signalingStateInternal = g, this.diagnostics.signalingState = g, this.event("signalingStateChanged").raise(this.signalingStateInternal, generateCauseId()), !this.configProvider.config.useDtlsTrasportConnectionCheck || this.transport || 1 !== this.cryptoMethod || this.hasPcConnectionState) return;
                        const f = this.pc.getReceivers().find((g)=>!!g.transport);
                        this.transport = f === null || f === void 0 ? void 0 : f.transport, this.transport && (this.transport.onstatechange = this.handleDtlsTransportStateChange);
                    }, this.handleIceConnectionStateChange = ()=>{
                        const g = this.pc.iceConnectionState;
                        this.logger.safe.info(`RTCPeerConnection oniceconnectionstatechange iceConnectionState: ${g} pc.signalingState: ${this.pc.signalingState}`), this.iceConnectionStateInternal = g, this.diagnostics.iceConnectionState = g, this.event("iceConnectionStateChanged").raise(this.iceConnectionStateInternal, generateCauseId()), this.shouldRaise(0) && this.updateState(g);
                    }, this.handleConnectionStateChange = ()=>{
                        const g = this.pc.connectionState;
                        this.logger.safe.info(`RTCPeerConnection onconnectionStatechange connectionState: ${g} pc.signalingState: ${this.pc.signalingState}`), this.connectionStateInternal = g, this.diagnostics.connectionState = g, this.event("connectionStateChanged").raise(this.connectionStateInternal, generateCauseId()), this.shouldRaise(1) && this.updateState(g);
                    }, this.handleDtlsTransportStateChange = ()=>{
                        const g = this.transport.state;
                        this.logger.safe.info(`RTCDtlsTransport onstatechange state: ${g} pc.signalingState: ${this.pc.signalingState}`), this.dtlsStateInternal = g, this.diagnostics.dtlsTransportState = g, this.event("dtlsTransportStateChanged").raise(this.dtlsStateInternal, generateCauseId()), this.shouldRaise(3) && this.updateState(g);
                    }, this.iceConnectionStateInternal = this.pc.iceConnectionState, this.connectionStateInternal = this.pc.connectionState, this.signalingStateInternal = this.pc.signalingState, this.pc.oniceconnectionstatechange = this.handleIceConnectionStateChange, this.pc.onsignalingstatechange = this.handleSignalingStateChange, this.logger.safe.debug(`ctor ctryptoMethod ${1 === this.cryptoMethod ? "dtls" : "sdes"}, hasPcConnectionState ${this.hasPcConnectionState}`), 1 === this.cryptoMethod && this.hasPcConnectionState && (this.pc.onconnectionstatechange = this.handleConnectionStateChange), this.diagnostics.hasConnectionState = this.hasPcConnectionState;
                }
            }, Ob = class {
                dispose() {
                    this.cleanupDevToolsInjector(), this.modifiers && (this.modifiers.forEach((g)=>g.dispose()), this.modifiers = null), this.emulator = null, this.logger = this.logger.createChild("DISPOSED");
                }
                handleMessage(g) {
                    var _this_diagnostics, _this_diagnostics1;
                    const f = g.controlInfo[0].sourceId;
                    if (this.previousSequenceNumber.has(f) && g.sequenceNumber < this.previousSequenceNumber.get(f)) return this.statsGatherer.addVideoControlMessage(!0), (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.addVideoControlMessage(!0), this.logger.safe.info(`Discarded old media stream control message for sourceId ${f}: (${JSON.stringify(g)})`), Promise.resolve();
                    this.previousSequenceNumber.set(f, g.sequenceNumber), this.statsGatherer.addVideoControlMessage(), (_this_diagnostics1 = this.diagnostics) === null || _this_diagnostics1 === void 0 ? void 0 : _this_diagnostics1.addVideoControlMessage(), this.configProvider.config.enableDevtoolsAPI && this.injectFmtpHandler(g);
                    const S = {
                        controlVideoStreaming: g
                    };
                    return this.configureResolution(S), this.modifiers.length ? (this.modifiers.forEach((g)=>g.setVideoControlMessage(S)), this.emulator.renegotiate(this.modifiers)) : Promise.resolve();
                }
                configureResolution(g) {
                    this.logger.safe.info(`Signaling FMTP: ${JSON.stringify(g.controlVideoStreaming)}`);
                    const f = String(g.controlVideoStreaming.sequenceNumber), S = g.controlVideoStreaming.controlInfo[0].fmtParamsList, v = g.controlVideoStreaming.controlInfo[0].fmtParams, _ = S && this.configProvider.config.webrtcFmtParamListSupported ? this.parseFmtParamsList(S) : [
                        this.parseFmtParams(v)
                    ], C = +g.controlVideoStreaming.controlInfo[0].sourceId, E = [
                        {
                            causeId: f,
                            isSimulcast: _.some((g)=>void 0 !== g.rid) || _.length > 1,
                            capabilities: _,
                            sourceId: C
                        }
                    ];
                    this.qualityManager.setMaxCapabilities(E);
                }
                parseFmtParamsList(g) {
                    return g.map((g)=>this.parseFmtParams(g));
                }
                parseFmtParams(g) {
                    const f = new QC(g);
                    return {
                        maxFs: +f.get(Gt.VIDEO_CAPABILITIES.MAX_FS_PATH),
                        maxMbps: +f.get(Gt.VIDEO_CAPABILITIES.MAX_MBPS_PATH),
                        maxFps: +f.get(Gt.VIDEO_CAPABILITIES.MAX_FPS_PATH) / 100,
                        maxBr: 1200 * +f.get(Gt.VIDEO_CAPABILITIES.MAX_BR_PATH),
                        ssrc: +f.get(Gt.VIDEO_CAPABILITIES.SSRC_PATH),
                        rid: f.get(Gt.VIDEO_CAPABILITIES.RID_PATH),
                        keyframe: this.shouldGenerateKeyFrame(f),
                        vlaDebug: f.get(Gt.VIDEO_CAPABILITIES.VLA_DEBUG)
                    };
                }
                shouldGenerateKeyFrame(g) {
                    return g.get(Gt.VIDEO_CAPABILITIES.KEYFRAME_PATH) ? !!+g.get(Gt.VIDEO_CAPABILITIES.KEYFRAME_PATH) : this.configProvider.config.webrtcAllowRestoreKeyframe;
                }
                injectFmtpHandler(g) {
                    const f = window;
                    (f === null || f === void 0 ? void 0 : f.webMA) && (f.webMA.fmtp || (f.webMA.fmtp = {
                        handleMessage: this.handleMessage.bind(this)
                    }), f.webMA.fmtp.lastFmtp = g);
                }
                cleanupDevToolsInjector() {
                    const g = window;
                    (g === null || g === void 0 ? void 0 : g.webMA) && delete g.webMA.fmtp;
                }
                constructor(g, f, S, v, _, C){
                    this.logger = g, this.emulator = f, this.qualityManager = S, this.diagnostics = v, this.configProvider = _, this.statsGatherer = C, this.previousSequenceNumber = new Map, this.modifiers = this.configProvider.mediaConfig.simulcastSessionEnabled ? [] : [
                        new PT(this.logger.createChild("rembModifier"), this.qualityManager, this.configProvider)
                    ];
                }
            }, Db = ((g)=>(g[g.ThreeStreamSimulcast = 0] = "ThreeStreamSimulcast", g[g.HardwareEncoder = 1] = "HardwareEncoder", g[g.Encode1080P = 2] = "Encode1080P", g[g.BroadcastMode = 3] = "BroadcastMode", g))(Db || {}), Nb = class extends Bt {
                notify() {
                    super.raiseChanged();
                }
                find(g) {
                    var f;
                    var _g;
                    return (_g = (f = this.features)[g]) !== null && _g !== void 0 ? _g : f[g] = {};
                }
                set(g, f, S) {
                    const v = this.find(g);
                    let _ = !1;
                    return void 0 !== f && v.server !== f && (this.logger.safe.info(`Server support for [${this.mediaType}][${Db[g]}] changed from ${v.server} to ${f}`), v.server = f, _ = !0), void 0 !== S && v.client !== S && (this.logger.safe.info(`Client support for [${this.mediaType}][${Db[g]}] changed from ${v.client} to ${S}`), v.client = S, _ = !0), _;
                }
                toggleServer(g, f) {
                    return !!this.set(g, f, void 0) && (this.notify(), !0);
                }
                toggleClient(g, f) {
                    return !!this.set(g, void 0, f) && (this.notify(), !0);
                }
                toggle(g, f) {
                    return !!this.set(g, f, f) && (this.notify(), !0);
                }
                hasAnySupport(g) {
                    const f = this.find(g);
                    return !0 === f.client || !0 === f.server;
                }
                hasFullSupport(g) {
                    const f = this.find(g);
                    return !0 === f.client && !0 === f.server;
                }
                hasClientSupport(g) {
                    return !0 === this.find(g).client;
                }
                hasServerSupport(g) {
                    return !0 === this.find(g).server;
                }
                constructor(g, f){
                    super(f), this.mediaType = g, this.logger = f, this.features = {};
                }
            }, kb = class extends Bt {
                notify(g, f) {
                    this.blocked.has(g.mediaType) && !0 !== f || (this.blocked.add(g.mediaType), this.logger.safe.info(`Notify: ${g.mediaType}`), this.event("onVideoFeaturesChanged").raise(g), this.blocked.delete(g.mediaType));
                }
                manageFeatureSupport(g) {
                    for (const g of Object.values(this.modalities))this.blocked.add(g.mediaType);
                    g();
                    for (const g of [
                        ...this.blocked
                    ])this.notify(this.modalities[g], !0);
                }
                get(g) {
                    if (!this.modalities[g]) throw this.logger.safe.error(`Unsupported media type: ${g}`), new Error(`Unsupported media type: ${g}`);
                    return this.modalities[g];
                }
                constructor(g){
                    super(g), this.logger = g, this.modalities = {
                        Video: new Nb("Video", this.logger),
                        ScreenShare: new Nb("ScreenShare", this.logger)
                    }, this.blocked = new Set;
                    for (const g of Object.keys(this.modalities))this.modalities[g].changed(()=>{
                        this.notify(this.modalities[g], !1);
                    });
                }
            }, Lb = class {
                getVideoControlMessage(g, f, S) {
                    const v = {
                        controlVideoStreaming: {
                            sequenceNumber: ++this.sequence,
                            globalTimeStamp: (new Date).toString(),
                            controlInfo: [
                                {
                                    control: "start",
                                    sourceId: f,
                                    streamMsid: g
                                }
                            ]
                        }
                    };
                    return S && (v.controlVideoStreaming.controlInfo[0].fmtParams = fmtParamsToString(S)), v;
                }
                getSourceRequestMessage(g, f, S, v) {
                    if (!S) throw new Error("Failed to construct SourceRequestMessage, missing fmtParams");
                    const _ = {
                        sourceId: f,
                        streamMsid: g,
                        fmtParams: S
                    };
                    return _.subStreamIndex = v, {
                        type: "sr",
                        controlVideoStreaming: {
                            sequenceNumber: ++this.sequence,
                            controlInfo: _
                        }
                    };
                }
                getSignalingSourceRequestMessage(g, f, S, v, _) {
                    if (!v) throw new Error("Failed to construct SourceRequestMessage, missing fmtParams");
                    const C = {
                        sourceId: f,
                        streamMsid: g,
                        fmtParams: v
                    };
                    return C.subStreamIndex = _, {
                        applyChannelParameters: {
                            multiChannelParameter: {
                                mids: [
                                    S
                                ],
                                mediaParameter: JSON.stringify({
                                    controlVideoStreaming: {
                                        sequenceNumber: ++this.sequence,
                                        controlInfo: C
                                    }
                                })
                            }
                        }
                    };
                }
                getBandwidthInfoMessage(g) {
                    return {
                        type: "ssbwe",
                        BwMessage: g
                    };
                }
                getMaxVideoSendCapabilitiesMessage(g) {
                    const { streamMIDs: f, capabilities: S, useMax: v, sendMaxFs: _, sendMaxMbps: C } = g;
                    let E = ceilToMacroblock(S.maxWidth), T = ceilToMacroblock(S.maxHeight);
                    v && (E = T = Math.max(E, T));
                    const I = {
                        [Gt.VIDEO_CAPABILITIES.MAX_FPS_PATH]: S.maxFps,
                        [Gt.VIDEO_CAPABILITIES.MAX_WIDTH]: E,
                        [Gt.VIDEO_CAPABILITIES.MAX_HEIGHT]: T
                    };
                    return _ && (I[Gt.VIDEO_CAPABILITIES.MAX_FS_PATH] = S.maxFs), C && (I[Gt.VIDEO_CAPABILITIES.MAX_MBPS_PATH] = S.maxMbps), {
                        applyChannelParameters: {
                            multiChannelParameter: {
                                mids: f,
                                mediaParameter: JSON.stringify({
                                    maxVideoSendCapabilities: {
                                        caps: I
                                    }
                                })
                            }
                        }
                    };
                }
                getMaxVideoSendCapabilitiesContent(g, f, S, v) {
                    var _this_configProvider_config_broadcastMode;
                    const _ = {};
                    if (S) {
                        let g = ceilToMacroblock(S.maxWidth), f = ceilToMacroblock(S.maxHeight);
                        this.configProvider.config.maxSendVideoCapabilities.useMaximumWidthHeight && (g = f = Math.max(g, f)), _[Gt.VIDEO_CAPABILITIES.MAX_WIDTH] = g, _[Gt.VIDEO_CAPABILITIES.MAX_HEIGHT] = f, _[Gt.VIDEO_CAPABILITIES.MAX_FPS_PATH] = S.maxFps, this.configProvider.config.maxSendVideoCapabilities.sendMaxFs && (_[Gt.VIDEO_CAPABILITIES.MAX_FS_PATH] = S.maxFs), this.configProvider.config.maxSendVideoCapabilities.sendMaxMbps && (_[Gt.VIDEO_CAPABILITIES.MAX_MBPS_PATH] = S.maxMbps);
                    } else v && [
                        Gt.VIDEO_CAPABILITIES.MAX_WIDTH,
                        Gt.VIDEO_CAPABILITIES.MAX_HEIGHT,
                        Gt.VIDEO_CAPABILITIES.MAX_FPS_PATH,
                        Gt.VIDEO_CAPABILITIES.MAX_FS_PATH,
                        Gt.VIDEO_CAPABILITIES.MAX_MBPS_PATH
                    ].forEach((g)=>{
                        v[g] && (_[g] = v[g]);
                    });
                    const C = g.getSimulcastContext();
                    let E, T, I, b;
                    if (C && C.config.layerScaleFactors.length > 2 && (E = C.config.layerScaleFactors.length, T = C.config.layerScaleFactors.length, f.hasClientSupport(0) || (T = 2), this.configProvider.config.minFrameSizeForThreeStreamSimulcast && S && S.maxFs < this.configProvider.config.minFrameSizeForThreeStreamSimulcast && (T = 2)), void 0 !== E && (_[Gt.VIDEO_CAPABILITIES.MAX_STREAMS] = E), void 0 !== T && (_[Gt.VIDEO_CAPABILITIES.MAX_LAYERS] = T), f.hasClientSupport(3) && ((_this_configProvider_config_broadcastMode = this.configProvider.config.broadcastMode) === null || _this_configProvider_config_broadcastMode === void 0 ? void 0 : _this_configProvider_config_broadcastMode.prioritizeLayoutOnServer)) {
                        const g = this.configProvider.config.broadcastMode;
                        g.priorityLayoutMinFS && g.priorityLayoutMinFPS && (b = g.priorityLayoutMinFS, b *= g.priorityLayoutMinFPS), g.priorityLayoutMinBitrate && (I = g.priorityLayoutMinBitrate);
                    }
                    return I && (_[Gt.VIDEO_CAPABILITIES.PRIORITY_LAYOUT_MIN_BITRATE] = I), b && (_[Gt.VIDEO_CAPABILITIES.PRIORITY_LAYOUT_MIN_MBPR] = b), _;
                }
                getMultiChannelParametersMessage(g, f) {
                    return {
                        applyChannelParameters: {
                            multiChannelParameter: {
                                mids: g,
                                mediaParameter: JSON.stringify(f)
                            }
                        }
                    };
                }
                constructor(g){
                    this.configProvider = g, this.sequence = 0;
                }
            }, Fb = class {
                sendSourceRequest(g, f, S, v, _) {
                    if (this.configProvider.config.useApplyChannelParametersForSourceRequests) {
                        const C = this.messageGenerator.getSourceRequestMessage(g, f, v, _), E = this.messageGenerator.getSignalingSourceRequestMessage(g, f, S, v, _);
                        return this.sendMessage("ApplyChannelParametersSourceRequest", C, E);
                    }
                    const C = this.messageGenerator.getVideoControlMessage(g, f, v === null || v === void 0 ? void 0 : v[0]);
                    return this.sendMessage("ControlVideoStreaming", C);
                }
                sendMaxVideoSendCapabilities(g, f) {
                    const S = this.messageGenerator.getMaxVideoSendCapabilitiesMessage({
                        streamMIDs: g,
                        capabilities: f,
                        sendMaxFs: this.configProvider.config.maxSendVideoCapabilities.sendMaxFs,
                        sendMaxMbps: this.configProvider.config.maxSendVideoCapabilities.sendMaxMbps,
                        useMax: this.configProvider.config.maxSendVideoCapabilities.useMaximumWidthHeight
                    });
                    return this.sendMessage("ApplyChannelParametersVideoCapabilities", S);
                }
                async sendBandwidthInfo(g) {
                    var _this_mediaControlPlane;
                    const f = this.messageGenerator.getBandwidthInfoMessage(g);
                    return (_this_mediaControlPlane = this.mediaControlPlane) === null || _this_mediaControlPlane === void 0 ? void 0 : _this_mediaControlPlane.sendMsg(f);
                }
                sendMaxVideoSendCapabilitiesV2(g, f, S) {
                    if (void 0 === this.lastVideoSendMaxCapabilities[g.getMid()]) {
                        if (!S) return this.logger.safe.info("Skip sending empty max-capabilities message"), Promise.resolve();
                        this.lastVideoSendMaxCapabilities[g.getMid()] = {};
                    }
                    const v = this.messageGenerator.getMaxVideoSendCapabilitiesContent(g, f, S, this.lastVideoSendMaxCapabilities[g.getMid()]);
                    if (S || !deepEqual(this.lastVideoSendMaxCapabilities[g.getMid()], v)) {
                        this.lastVideoSendMaxCapabilities[g.getMid()] = v;
                        const f = this.messageGenerator.getMultiChannelParametersMessage([
                            g.getMid()
                        ], {
                            maxVideoSendCapabilities: {
                                caps: v
                            }
                        });
                        return this.sendMessage("ApplyChannelParametersVideoCapabilities", f);
                    }
                    return this.logger.safe.info("Skip sending duplicate max-capabilties message"), Promise.resolve();
                }
                async sendMessage(g, f, S) {
                    let v;
                    return "ApplyChannelParametersSourceRequest" === g && (v = f.controlVideoStreaming.sequenceNumber), this.logger.safe.info(`sending video control message: ${JSON.stringify(f)}`), this.sender.send(g, f, v, S);
                }
                constructor(g, f, S, v){
                    this.logger = g, this.configProvider = f, this.sender = S, this.mediaControlPlane = v, this.messageGenerator = new Lb(this.configProvider), this.lastVideoSendMaxCapabilities = {};
                }
            }, xb = 0, Ub = class _WebRtcSession {
                get audioStream() {
                    return this.mediaStreams.get("Audio");
                }
                get videoStream() {
                    return this.mediaStreams.get("Video");
                }
                get displayStream() {
                    return this.mediaStreams.get("ScreenShare");
                }
                useNullAudioStreamClient() {}
                getIncomingRawAudioStream() {
                    return null;
                }
                configureSpatialAudio(g, f) {}
                setParticipantSpatialAudioPositions(g, f) {}
                getAcceptedTypes() {
                    return this.allowedMediaContentType;
                }
                clone(g = !1) {
                    const f = shallowClone(this.context);
                    f.config = shallowClone(this.context.config), f.config.webrtcMediaContentType = this.mediaContentType, f.config.webrtcAllowedMediaContentType = this.allowedMediaContentType, g ? f.config.isConference = !0 : (f.config.iceHostCandidateOnly = !1, this.configProvider.config.waitForRelayOnReconnect && (f.config.webrtcIceGatheringTimeoutIncreased = !0));
                    const S = new _WebRtcSession(f, this.callId, this.callback);
                    return this.relayManagerProvider && (S.relayManagerProvider = this.relayManagerProvider), S.callbacks.onNegotiationRequired = this.callbacks.onNegotiationRequired, S;
                }
                setInternals(g) {
                    g.subscriptionManager && (this.subscriptionManager && this.subscriptionManager.dispose(), this.subscriptionManager = g.subscriptionManager, this.subscriptionManager.setStreamProvider({
                        getStreams: ()=>this.getStreams(),
                        setOnStreamsChangedHandler: (g)=>this.onStreamsChanged(g)
                    }), this.setSubsForSubscriptionManager(), this.subscriptionManager.reriseSubscribeEvents(), this.notifyStreamsChanged()), g.audioRenderer && (g.audioRenderer.play(this.audioRenderer.getStream()), this.audioRenderer = g.audioRenderer), g.remoteVideoManager && g.remoteVideoManager.moveRenderers(this.remoteVideoManager);
                }
                setSubsForSubscriptionManager() {
                    this.subscriptionManagerSubs = [
                        this.subscriptionManager.on("onTrackIdsChanged", (g)=>this.stats.setSubscribedTrackIds(g)),
                        this.subscriptionManager.on("onTrackSsrcChanged", (g)=>this.stats.setSubscribedTrackSsrc(g)),
                        this.subscriptionManager.on("onSubscriptionChanged", (g, f, S, v, _, C)=>this.stats.addSubscriptionEvent(g, f, S, v, null, _, C)),
                        this.subscriptionManager.on("onSubscriptionFailed", (g, f, S, v, _)=>this.stats.addSubscriptionEvent(g, f, S, v, _))
                    ];
                }
                move(g, f) {
                    g.setInternals({
                        subscriptionManager: this.subscriptionManager,
                        audioRenderer: this.audioRenderer,
                        remoteVideoManager: this.remoteVideoManager
                    }), g.muteHold(this.isMuteHold, f), this.doAudioMute ? g.muteInputAsync(f) : g.unmuteInputAsync(f), this.subscriptionManager = null, this.audioRenderer = null, this.callbacks.onTerminated = null;
                }
                setMute(g, f, S) {
                    this.logger.safe.info(`[${S}] call setMuteAsync with mute state ${f}, audio stream exists: ${!!this.audioStream}`), "Audio" === g && this.audioStream ? this.audioStream.setMuted(f, S) : "Video" === g && this.videoStream ? this.videoStream.setMuted(f, S) : "ScreenShare" === g && this.displayStream && this.displayStream.setMuted(f, S), this.updateQualityLevels(this.stats.getLastStatistics());
                }
                setCallConstraints(g, f) {
                    return Promise.reject(new Error("Not supported"));
                }
                configureModalitiesAsync(g, f) {
                    const S = this.configuredModalitiesPromise.then(()=>{
                        if (!g || !g.audio && !g.video && !g.sharing) throw new Error(`Invalid parameters! ${JSON.stringify(g)}`);
                        const S = !this.configuredModalities || !areNegotiatedDirectionsFulfilled(g, this.negotiatedModalities);
                        return this.configuredModalities = g, this.logger.safe.info(`[${f}] configure modalities`, `audio: ${g.audio}`, `video: ${g.video}`, `sharing: ${g.sharing}`, `peerconnection: ${!!this.peerConnection}`, `pc.signalingState: ${this.peerConnection ? this.peerConnection.signalingState : "-"}`, `needNewRenegotiation: ${S}`), S && this.triggerRenegotiation(!1, f), this.configuredModalities;
                    });
                    return this.configuredModalitiesPromise = S.catch((g)=>{
                        this.logger.safe.warn(`[${f}] Error during configuring modalities: ${stringifyObject(g)}`);
                    }).then(()=>{}), S.then(()=>{});
                }
                getConfiguredModalities() {
                    return this.configuredModalities;
                }
                getDisabledModalities() {
                    return this.disabledModalities;
                }
                getSubscriptionManager() {
                    return null;
                }
                createAudioElement(g) {}
                createOfferAsync(g) {
                    const f = this.negotiationQueue.add(()=>new Promise((f)=>{
                            this.logger.safe.info(`[${g}] create [offer] configured: ${JSON.stringify(this.configuredModalities)}`), this.initiator = !0, this.throwIfModalitiesNotConfigured("no configured modalities to create offer for"), this.canTriggerRenegotiation = !1, this.negotiatingModalities = this.configuredModalities, this.offeredModalities = this.negotiatingModalities, this.configProvider.config.webrtcNegotiateDisabledDataModality && !this.offeredModalities[Gt.MODALITY.data] && this.multiParty && (this.offeredModalities[Gt.MODALITY.data] = Gt.MEDIA_STATE.inactive), isOnHold(this.offeredModalities) && !isEmpty(this.negotiatedModalities) && Object.keys(this.offeredModalities).forEach((g)=>{
                                void 0 === this.negotiatedModalities[g] && delete this.offeredModalities[g];
                            }), f(this.updatePeerConnectionStreamsAsync(this.offeredModalities, !0, !0, g).then(()=>{
                                const f = this.createNegotiationConstraints(this.offeredModalities);
                                return this.logger.safe.info(`[${g}] create [offer] offered: ${JSON.stringify(this.offeredModalities)} constraints: ${JSON.stringify(f)}`), this.peerConnection.createOffer(f);
                            }).then((f)=>{
                                this.logger.unsafe.debug(`[${g}] create [offer] offer from peer connection`, "sdp:", f.sdp);
                                const S = this.sessionDescription.createLocalOffer(f.sdp);
                                this.hasIceCandidates(S) || this.resetCandidateGathering(g), this.stats.startWaitingForStreamStart(this.offeredModalities);
                                const v = new this.webrtcAdapter.RTCSessionDescription({
                                    sdp: S.toLocal(),
                                    type: "offer"
                                });
                                return this.setupIceGatheringTimeout(g), Promise.all([
                                    this.peerConnection.setLocalDescription(v),
                                    this.iceCandidatesDeferred.promise
                                ]);
                            }).then(()=>{
                                const f = this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp);
                                f.updateModalities(this.offeredModalities), this.checkIceCandidates(f);
                                const S = f.toOffer();
                                this.logger.unsafe.debug("CREATE OFFER", "sdp:", S);
                                const v = {
                                    blob: S,
                                    contentType: this.mediaContentType
                                };
                                return "" === this.configProvider.config.webrtcRequiredFeatures || this.multiParty || (v.requiredFeatures = this.configProvider.config.webrtcRequiredFeatures), this.configProvider.countryCode && (v.clientLocation = this.configProvider.countryCode), this.doRetargetIfNeeded(v, f, g), v;
                            }));
                        }), g);
                    return this.resetNegotiationQueue(g), f;
                }
                processOfferAsync(g, f) {
                    const S = this.negotiationQueue.add(()=>new Promise((S)=>{
                            const v = g.blob;
                            if (this.logger.unsafe.debug(`[${f}] process [offer]`, "sdp:", v), this.configProvider.config.webrtcCompareContentTypeInOffer && (assertContentTypeSupported(g.contentType, this.allowedMediaContentType), this.mediaContentType = g.contentType), g.requiredFeatures) {
                                const f = this.configProvider.config.webrtcRejectedFeatures.split(",");
                                throwIfFeatureNotSupported(g.requiredFeatures.split(","), f);
                            }
                            this.initiator = !1, this.offeredDescription = this.sessionDescription.createRemoteOffer(v), this.canTriggerRenegotiation = !1, this.offeredModalities = invertModalities(this.offeredDescription.getModalities()), this.peerConnection || (this.context.configProvider.mediaConfig.isTransportUnbundled ? this.context.configProvider.mediaConfig.isTransportUnbundled = this.offeredDescription.couldBeUnbundled() : this.context.configProvider.mediaConfig.isTransportUnbundled = this.offeredDescription.isUnbundled());
                            let _ = Promise.resolve(this.offeredModalities);
                            if (hasSendDirectionality(this.offeredModalities.video) || hasReceiveDirectionality(this.offeredModalities.video) || hasSendDirectionality(this.offeredModalities.sharing) || hasReceiveDirectionality(this.offeredModalities.sharing)) {
                                const g = this.offeredDescription.getVideoCodecs();
                                _ = this.webrtcAdapter.RTCRtpReceiver.getCapabilities("video").then((S)=>{
                                    if (!S.codecs.some((f)=>g.some((g)=>f.mimeType === g))) {
                                        this.logger.safe.warn(`[${f}] offer doesn't contain any supported video codecs`);
                                        const g = shallowClone(this.offeredModalities);
                                        return this.disabledModalities.video = g.video, this.disabledModalities.sharing = g.sharing, g.video = void 0, g.sharing = void 0, g;
                                    }
                                    return this.offeredModalities;
                                }).catch((g)=>(this.logger.safe.error(`[${f}] failed to get video capability ${stringifyObject(g)}`), this.offeredModalities));
                            }
                            S(_.then((g)=>(this.logger.safe.info(`[${f}] process [offer] offered: ${JSON.stringify(this.offeredModalities)} acceptable: ${JSON.stringify(g)}`), g)));
                        }), f);
                    return this.resetNegotiationQueue(f), S;
                }
                createAnswerAsync(g, f) {
                    return new Promise((S)=>{
                        if (g) return void S({
                            blob: "",
                            contentType: this.mediaContentType
                        });
                        this.logger.safe.info(`[${f}] create [answer] offered: ${JSON.stringify(this.offeredModalities)} configured: ${JSON.stringify(this.configuredModalities)}`), this.throwIfModalitiesNotConfigured("no configured modalities to create answer for"), this.negotiatingModalities = this.configuredModalities;
                        let v = negotiateModalities(this.offeredModalities, this.negotiatingModalities);
                        const _ = this.offeredDescription.clone();
                        S(this.updatePeerConnectionStreamsAsync(v, !0, !1, f).then(()=>this.handleCodecSwitchUnsupported(f)).then(()=>{
                            this.offeredDescription.setModalities(v);
                            const g = this.offeredDescription.toRemote();
                            this.mediaManager.updateMediaEntitiesWithLocalTracks(), this.registerMediaSources();
                            const S = new this.webrtcAdapter.RTCSessionDescription({
                                sdp: g,
                                type: "offer"
                            });
                            return this.updateDescriptor(S, _), this.logger.unsafe.info(`[${f}] create [answer] set remote description`, "negotiated:", v, "sdp:", S.sdp), this.peerConnection.setRemoteDescription(S);
                        }).then(()=>(this.callbacks.onTransportInitialized && this.callbacks.onTransportInitialized(), this.updatePeerConnectionStreamsAsync(v, !1, !0, f))).then(()=>(this.handleSharingRecvCapabilities(_), this.handleVideoRecvCapabilities(_))).then(()=>this.peerConnection.createAnswer()).then((g)=>{
                            this.logger.unsafe.debug(`[${f}] create [answer] answer from peer connection`, "sdp:", g.sdp);
                            const S = this.sessionDescription.createLocalAnswer(g.sdp);
                            this.hasIceCandidates(S) || this.resetCandidateGathering(f), this.stats.startWaitingForStreamStart(v);
                            const _ = new this.webrtcAdapter.RTCSessionDescription({
                                sdp: S.toLocal(),
                                type: "answer"
                            });
                            return this.setupIceGatheringTimeout(f), Promise.all([
                                this.peerConnection.setLocalDescription(_),
                                this.iceCandidatesDeferred.promise
                            ]);
                        }).then(()=>{
                            const g = this.sessionDescription.createLocalAnswer(this.peerConnection.localDescription.sdp);
                            g.updateModalities(v), this.checkIceCandidates(g);
                            const S = g.toAnswer();
                            v = g.getModalities(), areNegotiatedDirectionsAcceptable(this.configuredModalities, this.negotiatingModalities, v) || this.triggerRenegotiation(!0, f), this.setNegotiatedModalities(v), this.stats.sessionInfo.setBweType(g.getBweType()), this.logger.unsafe.debug("CREATE ANSWER", "sdp:", S);
                            const _ = {
                                blob: S,
                                contentType: this.mediaContentType
                            };
                            return this.configProvider.countryCode && (_.clientLocation = this.configProvider.countryCode), _;
                        }));
                    });
                }
                processAnswerAsync(g, f, S) {
                    const v = g.blob;
                    if (this.logger.unsafe.debug(S ? "PROCESS PRANSWER" : "PROCESS ANSWER", "sdp:", v), S) return this.logger.safe.info(`[${f}] process [pranswer] ignored`), Promise.resolve();
                    this.mediaContentType = g.contentType, -1 === this.allowedMediaContentType.indexOf(this.mediaContentType) && this.allowedMediaContentType.push(this.mediaContentType);
                    const _ = this.sessionDescription.createRemoteAnswer(v), C = _.clone(), E = invertModalities(_.getModalities());
                    this.setNegotiatedModalities(E), _.setModalities(this.negotiatedModalities);
                    const T = _.toRemote();
                    this.mediaManager.updateMediaEntitiesWithLocalTracks(), this.registerMediaSources(), this.stats.sessionInfo.setBweType(_.getBweType());
                    const I = new this.webrtcAdapter.RTCSessionDescription({
                        sdp: T,
                        type: "answer"
                    });
                    return this.updateDescriptor(I, C), this.logger.unsafe.info(`[${f}] process [answer] set remote description`, "negotiated:", this.negotiatedModalities, "sdp:", I.sdp), this.peerConnection.setRemoteDescription(I).then(()=>(this.callbacks.onTransportInitialized && this.callbacks.onTransportInitialized(), this.negotiatedModalities)).then(()=>(this.handleSharingRecvCapabilities(C), this.handleVideoRecvCapabilities(C))).then((g)=>{
                        g && this.triggerRenegotiation(!0, f);
                    });
                }
                completeNegotiationAsync(g) {
                    return new Promise((f)=>{
                        this.mediaManager.commit();
                        const S = this.configuredModalities, v = this.forceMediaStreamUpdate && !isOnHold(this.negotiatedModalities) || !areNegotiatedDirectionsAcceptable(S, this.negotiatingModalities, this.negotiatedModalities) || this.triggerRenegotiationFlag, _ = !v;
                        this.canTriggerRenegotiation = !0, this.logger.safe.info(`[${g}] negotiation completed isComplete: ${_} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`), v && this.triggerRenegotiation(!1, g), this.negotiationCompletedPromise.resolve();
                        f({
                            isComplete: _,
                            activeModalities: this.negotiatedModalities,
                            offeredModalities: this.offeredModalities,
                            attemptedModalities: this.negotiatingModalities,
                            configuredModalities: this.configuredModalities,
                            initiator: this.initiator
                        });
                    });
                }
                rejectNegotiationAsync(g, f, S = !1) {
                    return Promise.resolve().then(()=>{
                        if (this.mediaManager.rollback(), this.logger.safe.warn(`[${f}] negotiation rejected isComplete: ${!S} error: ${stringifyObject(g)} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`), this.peerConnection) {
                            if ("have-local-offer" === this.peerConnection.signalingState) return this.logger.safe.info(`[${f}] rolling back local description`), this.configProvider.config.webrtcHandleRollback ? (this.logger.safe.info(`[${f}] rolling back using local renegotiation`), this.negotiationEmulator.renegotiateNow().then(()=>{
                                this.logger.safe.info(`[${f}] rolling back using local complete`);
                            })) : this.peerConnection.setLocalDescription(new this.webrtcAdapter.RTCSessionDescription({
                                type: "rollback"
                            }));
                            this.logger.safe.error(`[${f}] cannot rollback local description in currrent state: ${this.peerConnection.signalingState}`);
                        }
                    }).then(()=>{
                        this.canTriggerRenegotiation = !0, this.negotiationCompletedPromise.reject("negotiation rejected");
                        this.getAddedMediaTypes(this.negotiatedModalities, this.negotiatingModalities).forEach((g)=>{
                            this.removeTrackByMediaType(g), this.disposeStreamByMediaType(g);
                        }), this.registerLocalStreams();
                    }).then(()=>(S && (this.logger.safe.info(`[${f}] retrying failed negotiation`), this.triggerRenegotiation(!1, f)), {
                            isComplete: !S,
                            activeModalities: this.negotiatedModalities,
                            offeredModalities: this.offeredModalities,
                            attemptedModalities: this.negotiatingModalities,
                            configuredModalities: this.configuredModalities,
                            initiator: this.initiator
                        }));
                }
                startMediaDescriptionsUpdateAsync(g) {
                    return Promise.reject(new Error("Not supported"));
                }
                completeMediaDescriptionsUpdateAsync(g) {
                    return Promise.reject(new Error("Not supported"));
                }
                rejectMediaDescriptionsUpdateAsync(g, f) {
                    return Promise.reject(new Error("Not supported"));
                }
                createRemoteRenderer(g) {
                    return this.remoteVideoManager.createRenderer(g, this.subscriptionManager, this.logger);
                }
                getStatsAsync(g) {
                    return this.terminated || (this.statisticsReport = this.statisticsReport.then(()=>this.stats.getReport(g)).catch((g)=>(this.logger.safe.error(`getting statistics should never fail: ${g.error}`), g.partialReport))), this.statisticsReport;
                }
                getLastKnownStats(g = !1) {
                    return this.stats.getReport(!1, g);
                }
                muteHold(g, f) {
                    this.isMuteHold = g;
                    const S = [
                        Gt.MODALITY.audio,
                        Gt.MODALITY.video,
                        Gt.MODALITY.sharing
                    ].filter((g)=>hasSendDirectionality(this.negotiatedModalities[g]) && (g !== Gt.MODALITY.audio || !this.doAudioMute));
                    for (const v of S)this.setMute(modalityToMediaType(v), g, f);
                }
                async muteInputAsync(g) {
                    this.doAudioMute = !0, this.setMute("Audio", !0, g);
                }
                async unmuteInputAsync(g) {
                    this.doAudioMute = !1, this.setMute("Audio", !1, g);
                }
                muteOutputAsync(g) {
                    return this.audioRenderer.setMuted(!0, g), Promise.resolve();
                }
                unmuteOutputAsync(g) {
                    return this.audioRenderer.setMuted(!1, g), Promise.resolve();
                }
                async getSpeakerVolume(g) {
                    return this.audioRenderer.getSpeakerVolume(g);
                }
                async setSpeakerVolume(g, f) {
                    return this.audioRenderer.setSpeakerVolume(g, f);
                }
                sendDtmf(g) {
                    return this.dtmfSender.sendDtmf(this.peerConnection, g);
                }
                canSendDtmf() {
                    return this.dtmfSender.canSendDtmf(this.peerConnection);
                }
                pauseNegotiations(g = generateCauseId()) {
                    const f = new ct;
                    return this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{
                        this.setNegotiationPromise(f, g);
                    }), f;
                }
                onDeviceEvent(g) {
                    this.stats.onDeviceEvent(g);
                }
                deviceSelectionChanged() {
                    this.peerConnection && (this.audioRenderer && this.audioRenderer.getStream() && this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()), isOnHold(this.negotiatedModalities) || (this.forceMediaStreamUpdate = !0, this.triggerRenegotiation(!0)));
                }
                async terminate(g, f, S = !0) {
                    this.logger.safe.info(`[${g}] terminate`), this.stats.setTerminated(), this.canTriggerRenegotiation = !1, this.cleanUp(g);
                    try {
                        S && await this.getStatsAsync(!1);
                    } catch (f) {
                        this.logger.safe.error(`[${g}] Error while gathering stats ${stringifyObject(f)}`);
                    } finally{
                        this.stats.dispose(), this.terminated = !0;
                    }
                }
                processNotification(g, f) {
                    "DominantSpeakerInfo" === g && this.activeSpeakerManager.onDominantSpeakerHistoryChanged(f.previousDominantSpeakerHistory, "signaling"), "ControlVideoStreaming" === g && this.streamConfigurationHandler.handleMessage(f);
                }
                cleanUp(g) {
                    this.negotiationQueue.dispose(), this.localVideoStreamWatcher.dispose(), this.remoteVideoManager.dispose(), this.resetPeerConnection(g), this.subscriptionManagerSubs.forEach((g)=>g.dispose()), this.subscriptionManager && this.subscriptionManager.dispose(), this.clearIceDisconnectedTimer(), this.callbacks.onTerminated && this.callbacks.onTerminated(), this.negotiationCompletedPromise.reject("webRtcSession cleanup");
                }
                resetPeerConnection(g) {
                    var _this_contributingSources;
                    this.logger.safe.info(`[${g}] reset peer connection`), this.audioRenderer && this.audioRenderer.dispose(), this.dtmfSender && (this.dtmfSender.dispose(), this.dtmfSender = null), this.peerConnection && this.peerConnection.close(), this.toBeCalledAfterConnected = [], this.disposeStreams(), this.peerConnection = null, (_this_contributingSources = this.contributingSources) === null || _this_contributingSources === void 0 ? void 0 : _this_contributingSources.dispose(), this.activeSpeakerManager.dispose(), this.negotiationEmulator.configure(null), this.peerConnectionPromise = null, this.resetCandidateGathering(g), this.canTriggerRenegotiation = !0, this.negotiatedModalities = {};
                }
                resetNegotiationQueue(g = generateCauseId()) {
                    this.negotiationCompletedPromise.reject("promise expired"), this.setNegotiationPromise(new ct, g);
                }
                setNegotiationPromise(g, f = generateCauseId()) {
                    this.terminated || (this.negotiationCompletedPromise = g, this.negotiationQueue.add(this.negotiationCompletedPromise, f));
                }
                updateQualityLevels(g) {
                    if (!g) return;
                    this.hwSilent !== g.audioHwSilent && (this.hwSilent = g.audioHwSilent, this.callbacks.onAudioHwSilentChanged && this.callbacks.onAudioHwSilentChanged(this.hwSilent)), this.ufdManager.signalEvent("NetworkRecvQuality", g.networkRecvLevel.quality, void 0, void 0, void 0, void 0, {
                        recvQualityData: g.networkRecvLevel
                    }), this.ufdManager.signalEvent("NetworkSendQuality", g.networkSendLevel.quality, void 0, void 0, void 0, void 0, {
                        sendQualityData: g.networkSendLevel
                    });
                    const f = !(!g.isSpeaking || !this.doAudioMute);
                    this.ufdManager.signalEvent("DeviceSpeakWhileMuted", f ? "Bad" : "Good");
                }
                triggerRenegotiation(g, f = generateCauseId()) {
                    this.canTriggerRenegotiation ? (this.canTriggerRenegotiation = !1, this.triggerRenegotiationFlag = !1, this.logger.safe.info(`[${f}] triggering renegotiation`), this.mediaManager.backup(), this.callbacks.onNegotiationRequired && this.callbacks.onNegotiationRequired(f)) : g && (this.logger.safe.info(`[${f}] renegotiation postponed`), this.triggerRenegotiationFlag = !0);
                }
                throwIfModalitiesNotConfigured(g) {
                    if (!this.configuredModalities) throw new Error(g);
                }
                addTrack(g, f, S) {
                    if (!g) return;
                    const v = this.modalityByMediaType(S);
                    if (this.logger.safe.info(`add media track kind: ${g.kind} id: ${g.id}`), this.senders[v]) throw new Error("track already created, modality:" + v + ", kind:" + g.kind + ", id:" + g.id);
                    "closed" !== this.peerConnection.iceConnectionState && (this.senders[v] = this.peerConnection.addTrack(g, f));
                }
                registerMediaSources() {
                    const g = [];
                    if (this.mediaStreams.forEach((f, S)=>{
                        const v = {
                            sourceId: this.getSourceIdForStream(f),
                            defaultSSRC: this.ssrcs[S].min,
                            modality: this.modalityByMediaType(S)
                        };
                        g.push(v);
                    }), this.qualityManager.updateRegisteredSources(g), this.videoStream) {
                        const g = this.videoStream.getResolution();
                        this.qualityManager.setCurrentResolution(new Qt(g.width, g.height));
                    }
                }
                updateStream(g, f) {
                    return g.start().then(()=>{
                        try {
                            const S = this.mediaStreams.get(f);
                            if (S && g.isSameStream(S)) return g.dispose(), null;
                            if (this.updateSsrcRangeForMediaType(f), this.removeTrackByMediaType(f), this.disposeStreamByMediaType(f), !this.peerConnection) return g.dispose(), null;
                            if (this.addTrack(g.rawTrack, g.rawStream, f), g.onApplyConstraints = (S)=>{
                                this.removeTrackByMediaType(f), S.then(()=>{
                                    this.addTrack(g.rawTrack, g.rawStream, f), this.registerLocalStreams(), this.mediaManager.updateMediaEntitiesWithLocalTracks();
                                });
                            }, this.mediaStreams.set(f, g), "Video" === f) {
                                const g = [
                                    this.getMediaTrackInfo(f)
                                ];
                                this.localVideoStreamWatcher.startWatching(g);
                            }
                        } catch (S) {
                            throw this.removeTrackByMediaType(f), this.disposeStreamByMediaType(f), g.dispose(), S;
                        }
                    });
                }
                getSourceIdForStream(g) {
                    const f = g.rawStream.getTracks()[0].id, S = this.mediaManager.getMediaEntityByLocalTrackId(f);
                    return S ? (this.logger.safe.info(`Media entity found: ${JSON.stringify(S.getXSourceStreamId())}`), S.getXSourceStreamId()) : (this.logger.safe.error(`Media entity is not found for stream: ${JSON.stringify(f)}`), 0);
                }
                updatePeerConnectionStreamsAsync(g, f, S, v) {
                    const _ = hasSendDirectionality(this.negotiatedModalities.audio), C = hasSendDirectionality(this.negotiatedModalities.video), E = hasSendDirectionality(this.negotiatedModalities.sharing), T = isOnHold(this.negotiatedModalities), I = hasSendDirectionality(g.audio), b = hasSendDirectionality(g.video), A = hasSendDirectionality(g.sharing), R = isOnHold(g);
                    return T || R || (this.stats.onSendersChanged("Audio", I), this.stats.onSendersChanged("Video", b), this.stats.onSendersChanged("ScreenShare", A)), this.assurePeerConnectionAsync(v).then(async ()=>{
                        if (this.logger.safe.info("updatePeerConnectionStreamsAsync", "pc state", this.peerConnection.signalingState, "hold", "[", T, "->", R, "]", "audio", "[", _, "->", I, "]", "video", "[", C, "->", b, "]", "sharing", "[", E, "->", A, "]"), T !== R) {
                            if (this.videoStream && this.videoStream.setHold(R), this.audioStream && this.audioStream.setHold(R), this.displayStream && this.displayStream.setHold(R), R) return;
                            if (!R && this.audioStream) {
                                this.removeTrackByMediaType("Audio");
                                const g = this.audioStream.clone();
                                this.audioStream.dispose(), this.mediaStreams.set("Audio", g), this.addTrack(this.audioStream.rawStream.getAudioTracks()[0], this.audioStream.rawStream, "Audio");
                            }
                        }
                        if ((_ !== I || C !== b || E !== A || this.forceMediaStreamUpdate) && (S && (this.forceMediaStreamUpdate = !1), f && (this.logger.safe.info("not using any media(track api) track, remove all senders"), I || (this.removeTrackByMediaType("Audio"), this.disposeStreamByMediaType("Audio")), S && b || (this.removeTrackByMediaType("Video"), this.disposeStreamByMediaType("Video")), S && A || (this.removeTrackByMediaType("ScreenShare"), this.disposeStreamByMediaType("ScreenShare"))), S)) {
                            const g = [];
                            if (b) {
                                const f = await this.deviceManager.getVideoStream(!1);
                                g.push(this.updateStream(f, "Video"));
                            }
                            if (A) {
                                const f = this.deviceManager.getDisplayStream();
                                g.push(this.updateStream(f, "ScreenShare"));
                            }
                            if (I) {
                                const f = await this.deviceManager.getAudioStream(!1);
                                g.push(this.updateStream(f, "Audio").then(()=>{
                                    this.audioStream.setMuted(this.doAudioMute);
                                }));
                            }
                            return Promise.all(g).then(()=>this.registerLocalStreams());
                        }
                    });
                }
                getMediaTrackInfo(g) {
                    const f = this.modalityByMediaType(g), S = this.mediaStreams.get(g).rawStream.getTracks()[0].id;
                    return S || this.logger.safe.error(`No media track for modality found: ${f}`), {
                        trackId: S,
                        modality: f
                    };
                }
                getSsrcRangeForMediaType(g) {
                    const f = {
                        min: 1,
                        max: 1
                    };
                    switch(g){
                        case "Audio":
                            return this.ssrcGenerator.nextAudioStreamSsrc();
                        case "Video":
                        case "ScreenShare":
                            return this.ssrcGenerator.nextVideoStreamSsrc();
                        default:
                            return f;
                    }
                }
                updateSsrcRangeForMediaType(g) {
                    "Video" !== g && "ScreenShare" !== g || (this.ssrcs[g] = this.ssrcGenerator.nextVideoStreamSsrc());
                }
                getStreamTransformConfiguration() {
                    return {
                        unifiedPlanEnabled: !1,
                        addPrefixForMsid: this.configProvider.config.addPrefixForMsidInSdp
                    };
                }
                registerLocalStreams() {
                    const g = [];
                    this.mediaStreams.forEach((f, S)=>{
                        g.push(this.getMediaTrackInfo(S));
                    }), this.mediaManager.setLocalTracksInfo(g);
                }
                handleVideoRecvCapabilities(g) {
                    if (this.configProvider.config.enableLocalVideoConstraints && hasReceiveDirectionality(g.getModalities().video)) {
                        if (this.videoStream) {
                            const f = g.getVideoRecvCapabilities();
                            if (!f) return this.logger.safe.error("No fmt params found for video modality"), Promise.resolve(!1);
                            const S = this.generateReceiveCapabilities(f, this.videoStream);
                            this.qualityManager.setMaxCapabilities([
                                S
                            ]);
                        }
                        this.logger.safe.error("remote endpoint didn't specify video receive capability");
                    }
                    return Promise.resolve(!1);
                }
                handleSharingRecvCapabilities(g) {
                    if (this.configProvider.config.enableLocalVideoConstraints && hasReceiveDirectionality(g.getModalities().sharing) && this.displayStream) {
                        const f = g.getSharingRecvCapabilities();
                        if (!f) return void this.logger.safe.error("No fmt params found for sharing modality");
                        const S = this.generateReceiveCapabilities(f, this.displayStream);
                        this.qualityManager.setMaxCapabilities([
                            S
                        ]);
                    }
                }
                generateReceiveCapabilities(g, f) {
                    const S = {
                        ssrc: 0,
                        rid: "0",
                        keyframe: !1,
                        ...g
                    }, v = {
                        causeId: generateCauseId(),
                        isSimulcast: !1,
                        sourceId: this.getSourceIdForStream(f),
                        capabilities: [
                            S
                        ]
                    };
                    return this.logger.safe.info(`Generated receive capabilities for stream ${f.id}: ${JSON.stringify(v)}`), v;
                }
                updateDescriptor(g, f) {
                    const S = f.getVideoRecvCapabilities(), v = {
                        sourceId: 0,
                        streamMsid: 0,
                        bandwidth: 0
                    };
                    if (S && this.videoStream && !this.displayStream && (v.sourceId = this.getSourceIdForStream(this.videoStream), v.streamMsid = this.videoStream.id, v.bandwidth = S.maxBr ? S.maxBr : Number.MAX_VALUE), v.bandwidth > 0) {
                        v.bandwidth = Math.floor(v.bandwidth / 1200);
                        const f = new PT(this.logger.createChild("rembModifier"), this.qualityManager, this.configProvider);
                        f.setControlItem(v), f.modifyDescriptor(g);
                    }
                }
                removeTrackByMediaType(g) {
                    return this.removeTracksByModality(this.modalityByMediaType(g));
                }
                modalityByMediaType(g) {
                    switch(g){
                        case "Audio":
                            return Gt.MODALITY.audio;
                        case "Video":
                            return Gt.MODALITY.video;
                        case "ScreenShare":
                            return Gt.MODALITY.sharing;
                        default:
                            throw new Error(`Modality is not defined for media type: ${g}`);
                    }
                }
                removeTracksByModality(g) {
                    this.forceKeyFramePromise && "sharing" === g ? this.forceKeyFramePromise.then(()=>{
                        this.removeTracksByModality(g);
                    }) : g in this.senders && (this.logger.safe.info(`remove sender track kind: ${this.senders[g].track.kind} track id: ${this.senders[g].track.id}`), "closed" !== this.peerConnection.iceConnectionState && this.peerConnection.removeTrack(this.senders[g]), delete this.senders[g]);
                }
                handleCodecSwitchUnsupported(g) {
                    return this.offeredDescription.isCodecSwitchSupported() ? Promise.resolve() : this.webrtcAdapter.RTCRtpReceiver.getCapabilities(Gt.MEDIA_TYPE.audio).then((g)=>{
                        const f = g.codecs.map((g)=>g.mimeType);
                        this.offeredDescription.usePrimaryAudioCodecOnly(f);
                    }).catch((f)=>{
                        this.logger.safe.error(`[${g}] failed to set primary codec based on audio capability ${stringifyObject(f)}`);
                    });
                }
                disposeStreamByMediaType(g) {
                    const f = this.mediaStreams.get(g);
                    f && (this.mediaStreams.delete(g), f.dispose(), "Video" === g && this.localVideoStreamWatcher.stopWatching());
                }
                disposeStreams() {
                    this.mediaStreams.forEach((g, f)=>this.disposeStreamByMediaType(f));
                }
                assurePeerConnectionAsync(g) {
                    if (!this.peerConnectionPromise) {
                        if (!this.relayManagerProvider) throw new Error("relay manager provider is not set!");
                        this.logger.safe.info("fetching relay details from RelayManager...");
                        const f = {
                            relayType: "turn",
                            isRemoteClientLync: this.context.config.isRemoteClientLync
                        };
                        this.peerConnectionPromise = this.relayManagerProvider.getRelayManager().queryRelaysAsync(f).then((f)=>{
                            if (this.terminated) throw new Error("session already disposed");
                            const S = {
                                optional: []
                            }, v = createIceServers(f, this.configProvider.config), _ = this.configureCrypto(S);
                            this.configureCpuThreshold(S), this.logger.safe.info("create peer connection");
                            const C = this.context.configProvider.mediaConfig.isTransportUnbundled ? "balanced" : "max-bundle", E = this.peerConnection = new this.webrtcAdapter.RTCPeerConnection({
                                iceServers: v,
                                rtcpMuxPolicy: "require",
                                iceTransportPolicy: this.iceTransportPolicy,
                                bundlePolicy: C,
                                sdpSemantics: "plan-b",
                                audioPortRange: this.configProvider.mediaConfig.audioPortRange,
                                videoPortRange: this.configProvider.mediaConfig.videoPortRange,
                                enableDtlsSrtp: 1 === _,
                                offerExtmapAllowMixed: !1
                            }, S);
                            this.negotiationEmulator.configure(E), this.stats.initialize(E), this.stats.sessionInfo.setIceServers(v), this.stats.sessionInfo.setIceTransportPolicy(this.iceTransportPolicy), this.stats.sessionInfo.setBundlePolicy(C);
                            const T = this.webrtcAdapter.RTCRtpReceiver.getCapabilities("video"), I = this.webrtcAdapter.RTCRtpSender.getCapabilities("video");
                            this.stats.setH264AvailableProfiles(T), this.stats.setSupportedH264Profiles(I, T), E.onnegotiationneeded = ()=>{
                                this.logger.safe.info(`onnegotiationneeded signalingState: ${E.signalingState}`);
                            }, E.onsignalingstatechange = ()=>{
                                this.stats.sessionInfo.setSignalingConnectionState(E.signalingState), this.logger.safe.info(`onsignalingstatechange signalingState: ${E.signalingState}`);
                            }, E.onicecandidateerror = (g)=>{
                                const [f, S] = [
                                    g.address,
                                    g.port
                                ];
                                this.logger.safe.warn(`On ICE candidate error ${g.url} | ${f}:${S}: code ${g.errorCode}: ${g.errorText}`), this.isConnected() && !this.iceCandidatesDeferred.isPending || this.stats.addIceCandidateError({
                                    address: f,
                                    port: +S,
                                    url: g.url,
                                    errorCode: g.errorCode,
                                    errorText: g.errorText
                                });
                            };
                            const onAddStream = (g)=>{
                                if (!this.isConnected()) return this.logger.safe.info("onaddstream handling postponed till PC is connected"), void this.toBeCalledAfterConnected.push(()=>onAddStream(g));
                                const f = g.stream;
                                this.logger.safe.info(`onaddstream stream: ${f.id}`);
                                let S = this.mediaManager.getMediaEntityByRemoteStreamId(f.id);
                                if (S || (this.logger.safe.info(`cannot find media entity with stream id ${f.id} trying to fallback`), f.getAudioTracks()[0] && (S = this.mediaManager.getMediaEntitiesByModality(Gt.MODALITY.audio)[0])), S) {
                                    const g = this.createReceiveStream(f, S);
                                    this.receiveStreamCollection.add(g);
                                } else this.logger.safe.error(`could not find media entity for an added stream: ${f.id}`);
                            };
                            E.onaddstream = onAddStream, E.ontrack = (g)=>{
                                this.logger.safe.info(`ontrack track: ${g.track}`);
                            };
                            const onRemoveStream = (g)=>{
                                if (!this.isConnected()) return this.logger.safe.info("onremovestream handling postponed till PC is connected"), void this.toBeCalledAfterConnected.push(()=>onRemoveStream(g));
                                this.logger.safe.info(`onremovestream stream: ${g.stream.id}`), this.receiveStreamCollection.remove(g.stream.id);
                            };
                            E.onremovestream = onRemoveStream, E.onicecandidate = (f)=>{
                                const S = f.candidate;
                                if (S) {
                                    const f = parseCandidateString(S.candidate);
                                    this.logger.safe.info(`[${g}] onicecandidate candidate: prio:${f.priority} type:${f.type} port:${f.port}`), this.logger.unsafe.info(`[${g}] candidate details: ${S.candidate}`), !this.relayCandidateGathered && S.candidate.indexOf("typ relay") > -1 && (this.stats.sessionInfo.setRelayCandidateInfo({
                                        priority: S.priority || S.candidate.split(" ")[3],
                                        time: Date.now() - this.iceRelayCandidatesGatherStartTime
                                    }), this.relayCandidateGathered = !0);
                                } else this.logger.safe.info(`[${g}] onicecandidate candidate: null`);
                                if (!this.iceCandidatesDeferred.isPending) return;
                                const _ = !this.initiator || !this.context.config.webrtcIceGatheringTimeoutIncreased, C = this.iceHostCandidateOnly || 0 === v.length;
                                if (!S && _ || C) {
                                    S && this.logger.safe.info(`[${g}] Not waiting for ICE candidates, hoping that host/prflx is enough`), this.logger.safe.info(`[${g}] Is connected:`, this.isConnected(), E.iceConnectionState, E.signalingState);
                                    let f = !0;
                                    if (this.context.configProvider.mediaConfig.isTransportUnbundled && S) f = this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp).hasUnbundledIceCandidates();
                                    f && this.completeCandidateGathering(g);
                                } else if (this.relayCandidateGathered) {
                                    let f = !0;
                                    if (this.context.configProvider.mediaConfig.isTransportUnbundled) f = this.sessionDescription.createLocalOffer(this.peerConnection.localDescription.sdp).hasUnbundledRelayIceCandidates();
                                    f && (this.stats.clearIceCandidateErrors(), this.completeCandidateGathering(g));
                                }
                            }, E.onicegatheringstatechange = ()=>{
                                this.logger.safe.info(`onicegatheringstatechange iceGatheringState: ${E.iceGatheringState}`);
                            }, E.oniceconnectionstatechange = ()=>{
                                const g = generateCauseId();
                                if (!this.terminated) {
                                    if (this.stats.sessionInfo.setIceConnectionState(E.iceConnectionState), this.logger.safe.info(`[${g}] oniceconnectionstatechange iceConnectionState: ${E.iceConnectionState} pc.signalingState: ${E.signalingState}`), "connected" === E.iceConnectionState || "completed" === E.iceConnectionState) this.onTransportConnected(g);
                                    else if ("failed" === E.iceConnectionState) {
                                        if (this.iceCandidatesDeferred.isPending) return this.logger.safe.info(`[${g}] ice failed while gathering candidates, suppressing error`), void this.completeCandidateGathering(g);
                                        this.raiseError({
                                            type: Gt.MEDIA_ERROR.iceConnectionError,
                                            detail: "ice transport failed"
                                        }, g), this.configProvider.config.webrtcCloseAfterIceFailure && E.close(), this.onTransportFailed();
                                    }
                                    "disconnected" === E.iceConnectionState ? (this.onTransportDisconnected(g), this.startIceDisconnectedTimer(g)) : this.clearIceDisconnectedTimer();
                                }
                            }, this.multiParty && (this.contributingSources = new lb(this.logger.createChild("ContributingSources"), this.configProvider, this.activeSpeakerManager, new cb(this.logger.createChild("ContributingSourcesProvider"), E)));
                        });
                    }
                    return this.peerConnectionPromise;
                }
                configureCrypto(g) {
                    let f = !1;
                    const S = preferSdesSrtp(this.context.configProvider, this.context.config.isPstnCall);
                    if (this.offeredDescription) {
                        const g = this.offeredDescription.getSrtpInfo();
                        this.stats.sessionInfo.setOfferedSrtpInfo(g), f = !g.dtls || g.sdes && S;
                    } else f = S;
                    return f && (this.logger.safe.info("configuring peer connection to use sdes"), g.optional.push({
                        DtlsSrtpKeyAgreement: !1
                    })), this.stats.sessionInfo.setNegotiatedSrtpInfo({
                        dtls: !f,
                        sdes: !!f
                    }), f ? 0 : 1;
                }
                configureCpuThreshold(g) {
                    this.configProvider.config.webrtcNativeCpuOveruseDisabled && this.multiParty && g.optional.push({
                        googCpuOveruseDetection: !1
                    });
                }
                completeCandidateGathering(g) {
                    this.iceCandidatesDeferred.isPending && (this.logger.safe.info(`[${g}] ICE candidates gathered completely`), this.iceCandidatesDeferred.resolve());
                }
                onTransportConnected(g) {
                    if (this.logger.safe.info(`[${g}] audio transport connected`), this.stats.clearIceCandidateErrors(), !this.terminated) for(this.callbacks.onAudioStateChanged(Gt.STREAMING_STATE.active, g), this.callbacks.onTransportConnected && this.callbacks.onTransportConnected(g); this.toBeCalledAfterConnected.length;)this.toBeCalledAfterConnected.shift()();
                }
                onTransportDisconnected(g) {
                    this.callbacks.onTransportDisconnected && this.callbacks.onTransportDisconnected(g);
                }
                onTransportFailed() {
                    this.callbacks.onTransportFailed && this.callbacks.onTransportFailed();
                }
                startIceDisconnectedTimer(g) {
                    this.configProvider.config.iceDisconnectedTimeoutMs && (this.iceDisconnectedTimer = setTimeout(()=>{
                        this.logger.safe.error(`[${g}] ice disconnected for ${this.configProvider.config.iceDisconnectedTimeoutMs}ms. Raise CONSTANTS.MEDIAthis._ERROR.iceConnectionError`), this.raiseError({
                            type: Gt.MEDIA_ERROR.iceConnectionError,
                            detail: "ice transport disconnected"
                        }, g);
                    }, this.configProvider.config.iceDisconnectedTimeoutMs));
                }
                clearIceDisconnectedTimer() {
                    this.iceDisconnectedTimer && (clearTimeout(this.iceDisconnectedTimer), this.iceDisconnectedTimer = null);
                }
                raiseError(g, f = generateCauseId()) {
                    this.logger.safe.error(`[${f}] Media error occurred type: ${g.type} detail: ${g.detail}`), this.callbacks.onSessionErrorOccurred && this.callbacks.onSessionErrorOccurred(g, f);
                }
                createNegotiationConstraints(g) {
                    function canReceive(g) {
                        return !!g && (hasReceiveDirectionality(g) || "inactive" === g);
                    }
                    return {
                        offerToReceiveAudio: canReceive(g.audio),
                        offerToReceiveVideo: canReceive(g.video) || canReceive(g.sharing)
                    };
                }
                resetCandidateGathering(g) {
                    this.logger.safe.info(`[${g}] reset candidate gathering`), this.iceCandidatesDeferred.promise.then(()=>{}, ()=>{}), this.iceCandidatesDeferred.reject(new Error("reset candidate gathering")), this.iceCandidatesDeferred = new ct;
                }
                checkIceCandidates(g) {
                    const f = this.hasIceCandidates(g);
                    if (f === this.noIceCandidates && (this.noIceCandidates = !this.noIceCandidates, this.ufdManager.signalEvent("NoNetwork", this.noIceCandidates ? "Bad" : "Good"), this.noIceCandidates)) throw {
                        type: Gt.MEDIA_ERROR.noNetworkError,
                        detail: "no ice candidates"
                    };
                    if (f) {
                        const f = this.hasRelayIceCandidates(g);
                        if (f === this.noRelayIceCandidates) {
                            if (!f && ("connected" === this.peerConnection.iceConnectionState || "completed" === this.peerConnection.iceConnectionState)) return;
                            this.noRelayIceCandidates = !this.noRelayIceCandidates, this.ufdManager.signalEvent("NetworkRelaysNotReachable", this.noRelayIceCandidates ? "Bad" : "Good");
                        }
                    }
                }
                hasIceCandidates(g) {
                    return this.configProvider.mediaConfig.isTransportUnbundled ? g.hasUnbundledIceCandidates() : g.hasIceCandidates();
                }
                hasRelayIceCandidates(g) {
                    return this.configProvider.mediaConfig.isTransportUnbundled ? g.hasUnbundledRelayIceCandidates() : g.hasRelayIceCandidates();
                }
                doRetargetIfNeeded(g, f, S) {
                    var _this_offeredDescription;
                    const v = f.isIceRestart();
                    this.logger.safe.info(`[${S}] ICE restart: ${v}`), this.context.configProvider.mediaConfig.isTransportUnbundled && ((_this_offeredDescription = this.offeredDescription) === null || _this_offeredDescription === void 0 ? void 0 : _this_offeredDescription.isMSRTC()) && v && !this.multiParty && f.getSrtpInfo().sdes && (g.newOffer = !0);
                }
                getAddedMediaTypes(g, f) {
                    g || (g = {}), f || (f = {});
                    const S = [];
                    return isModalityAdded(g.audio, f.audio) && S.push("Audio"), isModalityAdded(g.video, f.video) && S.push("Video"), isModalityAdded(g.sharing, f.sharing) && S.push("ScreenShare"), S;
                }
                applyCapabilitiesForModality(g, f, S) {
                    return g === Gt.MODALITY.video ? this.applyCapabilitiesForVideo(f, S[0]) : g === Gt.MODALITY.sharing ? this.applyCapabilitiesForSharing(f, S[0]) : Promise.resolve(!1);
                }
                applyCapabilitiesForSharing(g, f) {
                    return this.displayStream ? this.applyCapabilities(this.displayStream, f).then((S)=>(this.stats.onMaxCapabilitiesApplied({
                            causeId: g,
                            modality: Gt.MODALITY.sharing,
                            capabilities: [
                                f
                            ]
                        }), this.configProvider.config.webrtcAllowRestoreKeyframe ? this.forceKeyframe(this.senders[Gt.MODALITY.sharing]).then(()=>S) : Promise.resolve(S))) : (this.logger.safe.info(`${JSON.stringify(f)} is ignored as no sharing stream is sent, no renegotiation`), Promise.resolve(!1));
                }
                forceKeyframe(g) {
                    if (!g) return this.logger.safe.error("forceKeyframe: No sender available for sharing"), null;
                    if (this.forceKeyFramePromise) return this.logger.safe.warn("forceKeyframe: already in progress"), this.forceKeyFramePromise;
                    this.logger.safe.info("Restoring keyframe");
                    const f = g.track;
                    return this.forceKeyFramePromise = g.replaceTrack(null).then(()=>g.replaceTrack(f)).then(()=>{
                        this.forceKeyFramePromise = null, this.logger.safe.info("Restoring keyframe finished");
                    }).catch((g)=>{
                        this.forceKeyFramePromise = null, this.logger.safe.error(`Restoring keyframe failed: ${g}`), delete this.senders[Gt.MODALITY.sharing];
                    }), this.forceKeyFramePromise;
                }
                applyCapabilitiesForVideo(g, f) {
                    return this.negotiationCompletedPromise.isPending ? (this.logger.safe.info("##### Renegotiation is in progress, no local resolution switch for now #####"), this.negotiationCompletedPromise.promise.then(()=>Promise.resolve(!1))) : this.videoStream ? this.scheduleApplyCapabilities(this.videoStream, g, f) : (this.logger.safe.info(`${JSON.stringify(f)} is ignored as no video is sent, no renegotiation`), Promise.resolve(!0));
                }
                scheduleApplyCapabilities(g, f, S) {
                    this.logger.safe.info("Queueing local renegotiation...");
                    let v = !1;
                    return this.negotiationQueue.add(()=>(this.logger.safe.info("############# LOCAL RENEGOTIATION START #############"), this.applyCapabilities(g, S).then(()=>{
                            this.stats.onMaxCapabilitiesApplied({
                                causeId: f,
                                modality: Gt.MODALITY.video,
                                capabilities: [
                                    S
                                ]
                            }), v = !0;
                        })), f), this.negotiationEmulator.renegotiate().then(()=>(this.logger.safe.info(`############# LOCAL RENEGOTIATION END. RESULT: ${v}  #############`), v));
                }
                applyCapabilities(g, f) {
                    return g ? (this.logger.safe.info(`Changing resolution to ${JSON.stringify(f)}`), g.applyCapabilities(f)) : (this.logger.safe.info(`Resolution ${JSON.stringify(f)} ignored, no stream is being sent`), Promise.resolve(!1));
                }
                onOptimalVideoReceiversCountChanged(g) {
                    this.callback.onOptimalVideoReceiversCountChanged && this.callback.onOptimalVideoReceiversCountChanged(g);
                }
                getStreams() {
                    return this.receiveStreamCollection.getStreams();
                }
                onStreamsChanged(g) {
                    this.streamsChangedListener = g;
                }
                notifyStreamsChanged() {
                    this.logger.safe.info(`Scheduling stream changed notification: ${this.streamsChangedNotificationScheduled}`), this.streamsChangedNotificationScheduled || this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{
                        this.streamsChangedNotificationScheduled = !1, this.streamsChangedListener && this.streamsChangedListener();
                    });
                }
                streamAdded(g) {
                    Gt.MODALITY.audio === g.getModality() && (this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()), this.audioRenderer.play(g.getMediaStream())), this.notifyStreamsChanged();
                }
                streamRemoved(g) {
                    Gt.MODALITY.audio === g.getModality() && this.audioRenderer.getStream() === g.getMediaStream() && this.audioRenderer.stop(), this.notifyStreamsChanged();
                }
                setNegotiatedModalities(g) {
                    this.negotiatedModalities = g, this.stats.sessionInfo.setNegotiatedModalities(g);
                }
                setupIceGatheringTimeout(g) {
                    this.iceRelayCandidatesGatherStartTime = Date.now();
                    const f = this.context.config.webrtcIceGatheringTimeoutIncreased ? this.configProvider.config.relayWaitSaneTimeoutMs : this.configProvider.config.webrtcIceGatheringTimeoutMs;
                    if (!f) return;
                    this.iceCandidatesTimer > 0 && clearTimeout(this.iceCandidatesTimer);
                    const S = this.iceCandidatesDeferred;
                    this.iceCandidatesTimer = setTimeout(()=>{
                        this.iceCandidatesTimer = 0, S.isPending && (this.logger.safe.warn(`[${g}] ICE candidates gathering terminated due to timeout ${f}`), S.resolve());
                    }, f);
                }
                createAudioRenderer() {
                    this.audioRenderer = new G_(this.logger.createChild("AudioRenderer"), this.configProvider), this.context.maContext.domOverrides.onMediaElementAdded && this.audioRenderer.on("onAudioElementAdded", this.context.maContext.domOverrides.onMediaElementAdded), this.context.maContext.domOverrides.onMediaElementRemoved && this.audioRenderer.on("onAudioElementRemoved", this.context.maContext.domOverrides.onMediaElementRemoved);
                }
                isConnected() {
                    const g = this.peerConnection;
                    return g && ("connected" === g.iceConnectionState || "completed" === g.iceConnectionState);
                }
                isFailed() {
                    return this.peerConnection && ("failed" === this.peerConnection.iceConnectionState || "closed" === this.peerConnection.iceConnectionState);
                }
                hasRelayCandidates() {
                    return this.relayCandidateGathered;
                }
                createReceiveStream(g, f) {
                    const S = this.configProvider.config.addFmtpToInitialSubscription ? f.getLocalRecvCapabilities() : null, v = this.configProvider.config.useMultiviewLimitsOnInitialRequest && f.getModality() !== Gt.MODALITY.sharing ? ()=>this.remoteVideoManager.getMaxAllowedVideoFS() : null;
                    return new BC(g, null, f.getModality(), +f.getXSourceStreamId(), this, S, v);
                }
                requestSource(g, f, S) {
                    if (!this.multiParty) return Promise.resolve();
                    const v = this.mediaManager.getMediaEntityByRemoteStreamId(g);
                    return !this.isMuteHold && this.negotiatedModalities[v.getModality()] !== Gt.MEDIA_STATE.inactive || -1 === f ? this.negotiationCompletedPromise.isPending ? this.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>this.requestSource(g, f, S)) : Promise.resolve().then(()=>this.mediaMessageController.sendSourceRequest(v.getXSourceStreamId(), f, v === null || v === void 0 ? void 0 : v.getMid(), S, v.getSubstreamIndex())) : delay(10).then(()=>this.requestSource(g, f, S));
                }
                getSessionConfig() {
                    return this.configProvider;
                }
                getUnmixedAudioProvider() {
                    return null;
                }
                constructor(g, f, S){
                    var _this_context_config;
                    this.context = g, this.callId = f, this.callback = S, this.callbacks = {}, this.multiParty = (_this_context_config = this.context.config) === null || _this_context_config === void 0 ? void 0 : _this_context_config.isConference, this.configProvider = this.context.configProvider, this.logger = this.context.getLogger().createChild("webrtc-" + ++xb), this.deviceManager = this.context.callDeviceManager.getDefaultDeviceManager(), this.webrtcAdapter = ob.build({
                        global: this.context.maContext,
                        configProvider: this.configProvider
                    }), this.iceHostCandidateOnly = this.multiParty && getFrom("iceHostCandidateOnly", this.context.config, this.configProvider.config), this.mediaManager = new db({
                        logger: this.logger,
                        configProvider: this.configProvider,
                        numVideoChannels: this.multiParty && this.configProvider.config.numVideoChannelsGvc || 1,
                        useSimulcast: !1
                    }), this.sessionDescription = FE.build({
                        sdpTransform: new this.webrtcAdapter.SdpTransform(this.context),
                        mediaManager: this.mediaManager,
                        logger: this.logger,
                        configProvider: this.configProvider,
                        configuration: this.getStreamTransformConfiguration()
                    }), this.allowedMediaContentType = getFrom("webrtcAllowedMediaContentType", this.context.config, this.configProvider.config).concat(), this.receiveStreamCollection = new AT({
                        streamAdded: (g)=>this.streamAdded(g),
                        streamRemoved: (g)=>this.streamRemoved(g)
                    }), this.stats = new WI(this.logger.createChild("stats"), this.configProvider, void 0, this.mediaManager, this.multiParty), this.maxResolution = this.multiParty ? Zt.Send.getResolutionByFs(this.configProvider.config.webrtcMultipartyMaxScalingFs) : Zt.Send.getResolutionByFs(this.configProvider.config.webrtcMaxScalingFs), this.qualityManager = new _b(this.logger.createChild("qm"), {
                        scalingEnabled: this.configProvider.config.webrtcVideoScaling,
                        cooldownTimeout: this.configProvider.config.webrtcResolutionManagerCooldownTimeout,
                        retryDelay: this.configProvider.config.webrtcResolutionManagerRetryDelay,
                        maxResolution: this.maxResolution,
                        customBwEstimationEnabled: !0
                    }, {
                        onReceiveCapabilitiesChanged: (g, f, S)=>this.applyCapabilitiesForModality(g, f, S)
                    }, this.stats, void 0, this.configProvider), this.localVideoStreamWatcher = new Ab(this.logger, this.configProvider, this.context.callDeviceManager), this.activeSpeakerManager = new bT(this.callback.onContributingSourcesChanged, this.callback.onDominantSpeakerChanged, this.logger.createChild("ActiveSpeakerManager")), this.senders = {}, this.negotiationQueue = new q_(this.logger), this.negotiationEmulator = new hb(this.logger.createChild("negotiationEmulator"), this.webrtcAdapter.RTCSessionDescription, this.sessionDescription, this.negotiationQueue, this.mediaManager), this.streamConfigurationHandler = new Ob(this.logger, this.negotiationEmulator, this.qualityManager, null, this.configProvider, this.stats), this.mediaMessageController = new Fb(this.logger, this.configProvider, {
                        send: this.context.sendWebRtcMediaNotificationAsyncCallback
                    }), this.toBeCalledAfterConnected = [], this.iceTransportPolicy = this.configProvider.config.iceTransportPolicyForced || this.context.config.iceTransportPolicy || Gt.ICE_TRANSPORT_POLICY.all, this.isMuteHold = !1, this.peerConnection = null, this.mediaStreams = new Map, this.doAudioMute = this.context.config.muted, this.iceCandidatesDeferred = new ct, this.relayCandidateGathered = !1, this.iceCandidatesTimer = null, this.triggerRenegotiationFlag = !1, this.canTriggerRenegotiation = !0, this.noIceCandidates = !1, this.noRelayIceCandidates = !1, this.forceMediaStreamUpdate = !1, this.negotiatedModalities = {}, this.disabledModalities = {}, this.iceDisconnectedTimer = null, this.statisticsReport = Promise.resolve({}), this.terminated = !1, this.initiator = !1, this.streamsChangedListener = null, this.dtmfSender = wb.build({
                        logger: this.logger,
                        configProvider: this.configProvider
                    }), this.mediaContentType = getFrom("webrtcMediaContentType", this.context.config, this.configProvider.config), this.streamsChangedNotificationScheduled = !1, this.subscriptionManager = new jC(this.logger.createChild("subs"), this.configProvider, {
                        getStreams: ()=>this.getStreams(),
                        setOnStreamsChangedHandler: (g)=>this.onStreamsChanged(g)
                    }), this.remoteVideoResolutionManager = new Cb(this.logger.createChild("rvrm"), this.multiParty, this.configProvider, this.mediaManager, this.stats), this.remoteVideoManager = new bb(this.logger.createChild("RemoteVideoManager"), this.configProvider, this.stats, void 0, this.remoteVideoResolutionManager, this.context.maContext.domOverrides), this.hwSilent = !1, this.configuredModalitiesPromise = Promise.resolve(), this.negotiationCompletedPromise = new ct, this.ssrcGenerator = new cy, this.ssrcs = {
                        Audio: this.getSsrcRangeForMediaType("Audio"),
                        Video: this.getSsrcRangeForMediaType("Video"),
                        ScreenShare: this.getSsrcRangeForMediaType("ScreenShare")
                    }, this.forceKeyFramePromise = null, this.transportStateProvider = {
                        isFailed: this.isFailed.bind(this),
                        isConnected: this.isConnected.bind(this)
                    }, this.ufdManager = g.getUfdManager(), this.stats.on("onStatisticsChanged", (g)=>{
                        var _this_localVideoStreamWatcher;
                        this.remoteVideoManager.processLegacyStats(g), (_this_localVideoStreamWatcher = this.localVideoStreamWatcher) === null || _this_localVideoStreamWatcher === void 0 ? void 0 : _this_localVideoStreamWatcher.onStatisticsChanged(g), this.updateQualityLevels(g);
                    }), this.negotiationCompletedPromise.promise.catch(()=>{}), this.negotiationCompletedPromise.reject("placeholder"), this.remoteVideoResolutionManager.on("onNegotiationRequired", ()=>this.triggerRenegotiation(!0)), this.remoteVideoResolutionManager.on("onSourceRequestRequired", (g, f, S)=>this.requestSource(g, f, S)), this.setSubsForSubscriptionManager(), this.localVideoStreamWatcher.on("onVideoCaptureFreeze", (g)=>{
                        this.isConnected() && this.ufdManager.signalEvent("VideoCaptureDeviceFreeze", g ? "Bad" : "Good", "Video");
                    }), this.configProvider.mediaConfig.maxBandwidthInKbps && this.stats.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps), this.createAudioRenderer(), this.configProvider.config.webrtcVideoScaling && this.onOptimalVideoReceiversCountChanged(this.configProvider.config.nonEstimatedDefaultVideoReceiversCount);
                }
            };
            function isModalityAdded(g, f) {
                return !hasSendDirectionality(g) && hasSendDirectionality(f);
            }
            var Vb = {
                build: (g, f, S)=>new Ub(g, f, S)
            }, Bb = P, Hb = class extends Bt {
                start() {
                    return this.logger.safe.debug("start"), Promise.resolve();
                }
                clone() {
                    return this.logger.safe.debug("clone"), this;
                }
                setMuted(g, f) {
                    this.logger.safe.debug("setMuted");
                }
                setHold(g) {
                    this.logger.safe.debug("setHold");
                }
                getResolution() {
                    return this.logger.safe.debug("getResolution"), {
                        width: 240,
                        height: 180
                    };
                }
                getFrameRate() {
                    return this.logger.safe.debug("getFrameRate"), 1;
                }
                hasAudio() {
                    return this.logger.safe.debug("hasAudio"), !1;
                }
                hasVideo() {
                    return this.logger.safe.debug("hasVideo"), !1;
                }
                isSameStream(g) {
                    return this.logger.safe.debug("isSameStream"), g === this;
                }
                applyCapabilities(g) {
                    return this.logger.safe.debug("applyCapabilities"), Promise.resolve(!1);
                }
                onApplyConstraints(g) {
                    this.logger.safe.debug("onApplyConstraints");
                }
                update(g) {
                    this.logger.safe.debug("update");
                }
                isActive() {
                    return !1;
                }
                isDisposed() {
                    return !1;
                }
                constructor(g, f){
                    super(f), this.logger = f, this.id = -1, this.parentId = -1, this.rawStream = null, this.rawTrack = null, this.deviceId = null, this.mediaType = g;
                }
            }, $b = class _SessionStreamsProvider extends Bt {
                get currentMediaTypes() {
                    return keys(this.mediaStreams).filter((g)=>!!this.mediaStreams[g]);
                }
                get streams() {
                    return this.mediaStreams;
                }
                useNullAudioStreamClient() {
                    this.isNullAudioStream = !0;
                }
                async update(g, f) {
                    const S = keys(g).filter((f)=>g[f]);
                    return deepEqual(S, this.currentMediaTypes) ? (this.logger.safe.info("Requested modalities have not changed. Do nothing"), sendStreamsToModalities(this.mediaStreams)) : (this.logger.safe.info(`Starting media session with modalities: ${JSON.stringify(g)}`), await this.updateStreams(S, f), this.subscribeOnDeviceManagerEvents(), sendStreamsToModalities(this.mediaStreams));
                }
                async stopAsync() {
                    this.logger.safe.info("Stopping streams async"), this.stop();
                }
                stop() {
                    this.logger.safe.info("Stopping streams"), this.unsubscribeFromDeviceManagerEvents(), keys(this.mediaStreams).forEach((g)=>this.removeStreamByType(g));
                }
                async ensureUpdateCompleted() {
                    this.logger.safe.debug("streams updated");
                }
                dispose() {
                    this.stop(), super.dispose();
                }
                async updateStreams(g, f) {
                    const S = this.getAvailableMediaTypes(), v = (0, Bb.intersection)(g, S), _ = keys(this.mediaStreams).filter((g)=>this.mediaStreams[g]), C = f ? [] : subtractFrom(v, _), E = subtractFrom(_, v);
                    C.length && this.logger.safe.info(`Adding media streams for types: ${JSON.stringify(C)}`), await Promise.all(C.map(async (g)=>{
                        await this.addStream(g, !1), this.mediaStreams[g] && this.event("onStreamAdded").raise(g);
                    })), E.length && this.logger.safe.info(`Removing media streams for types: ${JSON.stringify(E)}`), E.forEach((g)=>{
                        this.event("onStreamRemoving").raise(g), this.removeStreamByType(g);
                    });
                }
                getAvailableMediaTypes() {
                    const g = this.callDeviceManager.getDefaultDeviceManager().getSelectedDevices(), f = [];
                    return g.microphone && f.push("Audio"), g.camera && f.push("Video"), f.push("ScreenShare"), f;
                }
                async addStream(g, f) {
                    if (this.mediaStreams[g]) return void this.logger.safe.warn(`Stream with type: ${g} is already registered`);
                    const S = await this.getStream(g, f);
                    this.subscribeOnMediaStreamEvents(S);
                    try {
                        await S.start();
                    } catch (f) {
                        return this.logger.safe.error(`Media stream request error: ${JSON.stringify(f)}`), void this.event("onStreamError").raise(g, f);
                    }
                    this.mediaStreams[g] = S;
                }
                removeStreamByType(g) {
                    const f = this.mediaStreams[g];
                    f ? (this.unsubscribeFromMediaStreamEvents(f), f.dispose(), this.mediaStreams[g] = null) : this.logger.safe.warn(`Stream with type: ${g} is not registered`);
                }
                async updateStream(g, f, S = !1) {
                    S && "Audio" === g ? await this.updateStreamWithEffect(g) : (this.removeStreamByType(g), await this.addStream(g, f)), this.event("onStreamUpdated").raise(g);
                }
                async updateStreamWithEffect(g) {
                    const f = this.mediaStreams[g];
                    f && this.unsubscribeFromMediaStreamEvents(f);
                    const S = await this.getStreamByMediaType(g, !0);
                    this.subscribeOnMediaStreamEvents(S);
                    try {
                        await S.start();
                    } catch (f) {
                        return this.logger.safe.error(`updateStreamWithEffect. Media stream request error: ${JSON.stringify(f)}`), void this.event("onStreamError").raise(g, f);
                    }
                    this.mediaStreams[g] = S, f === null || f === void 0 ? void 0 : f.dispose();
                }
                subscribeOnMediaStreamEvents(g) {
                    if (this.streamSubscriptions.has(g)) return;
                    const f = [];
                    f.push(g.on("onStreamClientError", (g, f)=>this.onStreamError(g, f))), f.push(g.on("onStreamClientDisposing", (g)=>this.onStreamDisposing(g))), this.streamSubscriptions.set(g, f);
                }
                unsubscribeFromMediaStreamEvents(g) {
                    this.streamSubscriptions.has(g) && (this.streamSubscriptions.get(g).forEach((g)=>g.dispose()), this.streamSubscriptions.delete(g));
                }
                async getStream(g, f) {
                    const S = this.mediaStreams[g];
                    return S ? (this.logger.safe.info(`Stream exists with id: ${S.id}, type: ${g}`), S) : this.getStreamByMediaType(g, f);
                }
                async getStreamByMediaType(g, f) {
                    switch(g){
                        case "Audio":
                            return this.isNullAudioStream ? new Hb("Audio", this.logger.createChild("NullStreamClient")) : this.getDeviceManagerByType("Audio").getAudioStream(f, "sessionStream");
                        case "Video":
                            return this.getDeviceManagerByType("Video").getVideoStream(f, "sessionStream", !1, this.sessionConfig.outgoingVideoMaxFS);
                        case "ScreenShare":
                            return this.getDeviceManagerByType("ScreenShare").getDisplayStream("sessionStream");
                        default:
                            throw new Error(`Media type is not supported: ${g}`);
                    }
                }
                getMediaTypeForStream(g) {
                    const f = Object.keys(this.mediaStreams).find((f)=>this.mediaStreams[f] === g);
                    return f || this.logger.safe.error(`Media type is not found for stream: ${stringifyObject(g)}`), f;
                }
                subscribeOnDeviceManagerEvents() {
                    if (0 !== this.deviceManagerSubscriptions.length) return;
                    if (this.callDeviceManager.isVirtualDeviceEnabled) {
                        const g = this.callDeviceManager.on("onSelectedVirtualDevicesChanged", (g, f)=>{
                            const S = g;
                            if (!g.camera) {
                                this.logger.info("Virtual DeviceID for camera is undefined, falling back to default device");
                                const { camera: g } = this.callDeviceManager.getDefaultDeviceManager().getSelectedDevices();
                                S.camera = g;
                            }
                            this.callDeviceManager.isModalityEnabled("Video") && f.camera !== S.camera && (this.logger.info("Updating stream for camera"), this.updateStreamForVirtualDeviceChange("Video")), this.callDeviceManager.isModalityEnabled("ScreenShare") && f.screenshare !== S.screenshare && (this.logger.info("Updating stream for screenshare"), this.updateStreamForVirtualDeviceChange("ScreenShare"));
                        });
                        this.deviceManagerSubscriptions.push(g);
                    }
                    const g = this.callDeviceManager.getDefaultDeviceManager();
                    this.deviceManagerSubscriptions.push(g.on("onSelectedDevicesChanged", (g, f)=>this.onSelectedDevicesChanged(g, f)), g.on("onStreamUpdateRequested", (g, f)=>this.requestStreamUpdate(g, !1, f)), g.on("onAudioSharingToggled", (g)=>this.onAudioSharingToggled(g)));
                }
                unsubscribeFromDeviceManagerEvents() {
                    0 !== this.deviceManagerSubscriptions.length && (this.deviceManagerSubscriptions.forEach((g)=>g.dispose()), this.deviceManagerSubscriptions = []);
                }
                getMediaTypesToUpdate(g, f) {
                    const S = [];
                    return this.currentMediaTypes.some((g)=>"Audio" === g) && g.microphone && g.microphone !== f.microphone && S.push("Audio"), !this.callDeviceManager.getSelectedDevices().camera && this.currentMediaTypes.some((g)=>"Video" === g) && g.camera && g.camera !== f.camera && S.push("Video"), S;
                }
                removeStream(g) {
                    const f = this.getMediaTypeForStream(g);
                    this.removeStreamByType(f);
                }
                async onSelectedDevicesChanged(g, f) {
                    if (this.configProvider.config.enablePermissionsWorkaround && _SessionStreamsProvider.isDeviceListEmpty(g, f)) return void this.logger.safe.info("Device list is empty, permission workaround enabled");
                    const S = this.getMediaTypesToUpdate(g, f);
                    this.logger.safe.info(`Media types to update: ${JSON.stringify(S)}`), await Promise.all(S.map((g)=>this.updateStream(g, !1)));
                }
                async onAudioSharingToggled(g) {
                    if (this.configProvider.config.postponeAudioMixerForAudioSharing && g) return this.updateStream("ScreenShare", !0);
                }
                async requestStreamUpdate(g, f, S = !1) {
                    if (this.currentMediaTypes.some((f)=>f === g) || f) return this.logger.safe.debug(`UpdateStream with media type: ${g}, force: ${f}`), this.updateStream(g, f, S);
                    this.logger.safe.debug(`Stream with media type: ${g} is not active. Do nothing`);
                }
                onStreamError(g, f) {
                    this.removeStream(g);
                }
                onStreamDisposing(g) {
                    this.removeStream(g);
                }
                static isDeviceListEmpty(g, f) {
                    return !g.camera && !g.microphone || !f.microphone && !f.camera;
                }
                getDeviceManagerByType(g) {
                    return this.callDeviceManager.getDeviceManager(g);
                }
                async updateStreamForVirtualDeviceChange(g) {
                    return this.updateStream(g, !1);
                }
                constructor(g, f, S, v, _){
                    super(_), this.callDeviceManager = g, this.configProvider = f, this.sessionConfig = S, this.serialQueue = v, this.logger = _, this.mediaStreams = {
                        Audio: null,
                        Video: null,
                        ScreenShare: null
                    }, this.streamSubscriptions = new Map, this.deviceManagerSubscriptions = [], this.isNullAudioStream = !1;
                }
            };
            __decorateClass([
                sequentialize()
            ], $b.prototype, "update", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "stopAsync", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "ensureUpdateCompleted", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "onSelectedDevicesChanged", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "onAudioSharingToggled", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "requestStreamUpdate", 1), __decorateClass([
                sequentialize()
            ], $b.prototype, "updateStreamForVirtualDeviceChange", 1);
            var jb = $b, Gb = P, qb = [
                5e4,
                1e6,
                15e5,
                2e6,
                25e5,
                375e4,
                4e6
            ], Wb = [
                7e4,
                2e5,
                4e5,
                8e5,
                15e5,
                2499990,
                25e5
            ];
            function createBandwidthAllocatorPerMediaType(g, f) {
                const S = new zb(g.createChild("BandwidthAllocator"));
                return S.setLadder("ScreenShare", f.config.sharingBitrateLadderOverride || qb), S.setLadder("Video", f.config.videoBitrateLadderOverride || Wb), S;
            }
            var zb = class {
                setAvailableBandwidth(g) {
                    this.availableBandwidth = g, this.logger.safe.debug(`Total available bandwidth updated: ${g}`), this.updateLayouts();
                }
                getAvailableBandwidth() {
                    return this.availableBandwidth;
                }
                addReceiverCapability(g, f) {
                    this.logger.safe.debug(`Receiver maxBr set: ${g}/${f}`), this.receivers.set(g, f), this.updateLayouts();
                }
                getReceiverCapabilities() {
                    const g = {};
                    for (const f of Object.keys(this.receivers)){
                        const S = this.receivers.get(f);
                        S && (g[f] = S);
                    }
                    return g;
                }
                removeReceiver(g) {
                    this.logger.safe.debug(`Receiver maxBr removed: ${g}`), this.receivers.delete(g), this.updateLayouts();
                }
                getLayouts() {
                    return this.currentLayout;
                }
                setLadder(g, f) {
                    this.ladders[g] = f;
                }
                updateLayouts() {
                    const g = this.generateLayouts();
                    (0, Gb.isEqual)(g, this.currentLayout) || (this.currentLayout = g, this.logger.safe.debug(`Bandwidth distribution updated: ${stringifyObject(g)}`));
                }
                generateLayouts() {
                    const g = {}, f = {};
                    for (const S of Object.keys(this.ladders)){
                        const v = this.receivers.get(S);
                        v && (f[S] = v || Number.MAX_SAFE_INTEGER, g[S] = 0);
                    }
                    let S = this.availableBandwidth, v = 0;
                    const runLoop = ()=>{
                        if (!S) return !1;
                        for (const g of Object.values(f))if (g) return !0;
                        return !1;
                    };
                    for(; runLoop();){
                        for (const _ of Object.keys(g)){
                            const C = this.ladders[_];
                            let E = C[v] || C[C.length - 1];
                            E = Math.min(E, S, f[_]), g[_] += E, S -= E, f[_] -= E;
                        }
                        v++;
                    }
                    return g;
                }
                constructor(g){
                    this.logger = g, this.availableBandwidth = 0, this.receivers = new Map, this.currentLayout = {}, this.ladders = {};
                }
            };
            function getVideoBandwidthLadder(g, f) {
                const S = g.config.bandwidthAllocatorV2;
                let v = [], _ = -1;
                for (const g of S.videoLadders)(f >= g.maxFS && _ < g.maxFS || -1 === _) && (v = g.ladder, _ = g.maxFS);
                return v;
            }
            function createBandwidthAllocatorV2(g, f) {
                const S = new Kb(g.createChild("BandwidthAllocator2"));
                return S.setPriority("ScreenShare", "Video"), S.setLadder("ScreenShare", f.config.bandwidthAllocatorV2.sharingLadder), S.setLadder("Video", getVideoBandwidthLadder(f, f.config.bandwidthAllocatorV2.defaultVideoMaxFS)), S;
            }
            var Kb = class {
                getReceiverCapabilities() {
                    const g = {};
                    for (const f of Object.keys(this.receivers)){
                        const S = this.receivers.get(f);
                        S && (g[f] = S);
                    }
                    return g;
                }
                setAvailableBandwidth(g) {
                    this.availableBandwidth = g, this.logger.safe.debug(`Total available bandwidth updated: ${g}`), this.updateLayouts();
                }
                getAvailableBandwidth() {
                    return this.availableBandwidth;
                }
                addReceiverCapability(g, f) {
                    this.logger.safe.debug(`Receiver maxBr set: ${g}/${f}`), this.receivers.set(g, f), this.updateLayouts();
                }
                removeReceiver(g) {
                    this.logger.safe.debug(`Receiver maxBr removed: ${g}`), this.receivers.delete(g), this.updateLayouts();
                }
                getLayouts() {
                    return this.currentLayout;
                }
                setPriority(...g) {
                    this.priority = g;
                }
                setLadder(g, f) {
                    this.logger.safe.info(`Set ladder for ${g}: ${JSON.stringify(f)}`);
                    for (const f of this.ladder)delete f[g];
                    -1 === this.priority.indexOf(g) && this.priority.push(g);
                    for(let S = 0; S < f.length; ++S)S >= this.ladder.length && this.ladder.push({}), this.ladder[S][g] = f[S];
                }
                updateLayouts() {
                    const g = this.generateLayouts();
                    (0, Gb.isEqual)(g, this.currentLayout) || (this.currentLayout = g, this.logger.safe.debug(`Bandwidth distribution updated: ${stringifyObject(g)}`));
                }
                generateLayouts() {
                    const g = {};
                    let f = this.availableBandwidth;
                    for (const f of this.priority)this.receivers.get(f) && (g[f] = 0);
                    for(let S = 0; S < this.ladder.length && f; ++S){
                        const v = this.ladder[S];
                        for (const S of this.priority){
                            const _ = v[S];
                            if (_ && this.receivers.get(S)) {
                                const v = Math.max(0, Math.min(_ - g[S], f));
                                f -= v, g[S] += v;
                            }
                        }
                    }
                    if (f) {
                        const S = f;
                        let v = 0;
                        var _this_receivers_get;
                        for (const g of this.priority)v += (_this_receivers_get = this.receivers.get(g)) !== null && _this_receivers_get !== void 0 ? _this_receivers_get : 0;
                        for (const _ of this.priority){
                            const C = this.receivers.get(_);
                            if (C) {
                                const E = Math.min(f, Math.ceil(C * S / v));
                                E && this.logger.safe.info(`[AllocateSurplus][${_}] ${g[_]} + ${C} | ${f}`), f -= E, g[_] += E;
                            }
                        }
                    }
                    return g;
                }
                constructor(g){
                    this.logger = g, this.availableBandwidth = 0, this.receivers = new Map, this.currentLayout = {}, this.ladder = [], this.priority = [];
                }
            }, Jb = class {
                invoke(g) {
                    this.logger.safe.debug(`Schedule shouldDefer: ${g}`), this.isFirstTimeDeferred ? g ? (this.isFirstTimeDeferred = !1, this.startTimer()) : (this.stopTimer(), this.internalCallback("request")) : this.timeoutId && g || this.internalCallback("request");
                }
                dispose() {
                    this.stopTimer();
                }
                startTimer() {
                    this.timeoutId || (this.timeoutId = setTimeout(()=>{
                        this.internalCallback("timeout"), this.timeoutId = void 0;
                    }, this.timeout), this.logger.safe.debug(`Timer started for : ${this.timeout}ms`));
                }
                stopTimer() {
                    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = void 0, this.logger.safe.debug("Timer stopped"));
                }
                constructor(g, f, S){
                    this.timeout = f, this.logger = S, this.isFirstTimeDeferred = !0, this.internalCallback = (f)=>{
                        this.logger.safe.debug(`Trigger reason: ${f}`), g();
                    };
                }
            }, Yb = class {
                setAvailableBandwidth(g) {
                    g !== this.lastSendBW && (this.logger.safe.debug(`Available bandwidth updated ${g}`), this.processEstimatedBandwidth(g));
                }
                setMaxFrameSize(g) {
                    this.logger.safe.debug(`SetMaxFrameSize ${g}`), g !== this.maxFrameSize ? (this.maxFrameSize = g, this.lastSendBW ? (this.logger.safe.debug(`Setting max frame size: ${g}`), this.processEstimatedBandwidth(this.lastSendBW)) : this.logger.safe.debug("Last send bwe is not defined. Do nothing")) : this.logger.safe.debug(`Max frame size did not change. Do nothing, maxFs: ${g}`);
                }
                getFrameSize() {
                    return this.currentFrameSize;
                }
                processEstimatedBandwidth(g) {
                    if (this.logger.safe.debug(`Process estimated bandwidth ${g}`), 0 === g) return this.lastSendBW = 0, void this.proposeResolution(0);
                    const { lowRes: f, highRes: S } = Zt.Send.getResolutionForBitrate(g);
                    this.logger.safe.debug("low", f, "hi", S);
                    const v = g < this.lastSendBW ? S.fs : f.fs;
                    g < this.lastSendBW && this.currentFrameSize < v ? this.logger.safe.debug(`proposed resolution is above the existing one, so we should stay on the current resolution, last bw: ${g}`) : (v && this.proposeResolution(v), this.logger.safe.debug(`Updating last bw: ${g}`), this.lastSendBW = g);
                }
                proposeResolution(g) {
                    this.logger.safe.debug(`Propose resolution ${g}`);
                    const f = this.maxFrameSize ? Math.min(g, this.maxFrameSize) : g;
                    f !== this.currentFrameSize && (this.currentFrameSize = f, this.logger.safe.debug(`Proposed new frame size: ${f} based on bandwidth: ${this.lastSendBW}`));
                }
                constructor(g){
                    this.logger = g, this.currentFrameSize = Zt.Send.initialResolution.fs;
                }
            }, Qb = 1e8, Xb = [
                {
                    bwe: 2e5,
                    param: 5e5
                },
                {
                    bwe: 5e5,
                    param: 12e5
                },
                {
                    bwe: 8e5,
                    param: 25e5
                },
                {
                    bwe: 12e5,
                    param: 4e6
                }
            ], Zb = [
                {
                    bwe: 2e5,
                    param: 240
                },
                {
                    bwe: 3e5,
                    param: 405
                },
                {
                    bwe: 5e5,
                    param: 920
                },
                {
                    bwe: 9e5,
                    param: 2040
                }
            ], limitParamByBwe = (g, f, S)=>{
                for (const v of S)if (f < v.bwe) return Math.min(g, v.param);
                return g;
            }, limitStreamMaxBitrate = (g, f, S = Xb)=>limitParamByBwe(g, f, S), limitStreamMaxResolution = (g, f, S = Zb)=>limitParamByBwe(g, f, S), eA = class extends Bt {
                dispose() {
                    this.logger.safe.debug("Disposed"), this.outputLayouts = null, super.dispose();
                }
                setAvailableBandwidth(g) {
                    this.storeAvailableBandwidth(g), this.inputLayouts ? (this.recalculateLayouts(), this.checkForChangesAndNotify()) : this.logger.safe.debug("Layouts are not set. Skip update");
                }
                setLayouts(g, f) {
                    this.storeAvailableBandwidth(f), g.length === this.layoutsNumber ? (this.logger.safe.debug(`Set layouts: ${JSON.stringify(g)}`), this.inputLayouts = this.getPrioritizedLayouts(g), this.recalculateLayouts(), this.checkForChangesAndNotify()) : this.logger.safe.warn(`Incorrect number of layouts! ${JSON.stringify(g)}, expected ${this.layoutsNumber}`);
                }
                getLayouts() {
                    return this.inputLayouts;
                }
                getPrioritizedLayouts(g) {
                    return g;
                }
                checkForChangesAndNotify() {
                    const g = this.getLayouts();
                    deepEqual(this.outputLayouts, g) ? this.logger.safe.debug("Layout has not changed, skip update") : (this.outputLayouts = g.slice(), this.event("onLayoutsChanged").raise());
                }
                storeAvailableBandwidth(g) {
                    this.logger.safe.debug(`Set available bandwidth: ${g}`), this.totalBandwidth = g, this.totalBandwidthMax = Math.max(this.totalBandwidthMax, this.totalBandwidth);
                }
                constructor(g, f, S){
                    super(f), this.configProvider = g, this.logger = f, this.layoutsNumber = S, this.totalBandwidth = Qb, this.totalBandwidthMax = 0, this.logger.safe.debug("Created");
                }
            }, tA = class extends eA {
                getLayouts() {
                    return this.hiFiLayout ? [
                        this.loFiLayout,
                        this.hiFiLayout
                    ] : [
                        this.loFiLayout
                    ];
                }
                dispose() {
                    super.dispose(), this.resolutionManager = null;
                }
                getHighLayoutBandwidth(g) {
                    var _this_inputLayouts, _this_configProvider_config_specCompliantSimulcast;
                    const f = ((_this_inputLayouts = this.inputLayouts) === null || _this_inputLayouts === void 0 ? void 0 : _this_inputLayouts[0].maxBr) || 0, S = Math.max(g - f, 0);
                    this.logger.safe.debug(`Setting available bandwidth for layouts. High: ${S}, low: ${f || "not set"}, total: ${g}`);
                    const v = ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.allowedBweOvershootRatio) || 1;
                    return Math.floor(S * v);
                }
                recalculateLayouts() {
                    const g = this.hiFiLayout, f = this.getHighLayoutBandwidth(this.totalBandwidth);
                    this.resolutionManager.setAvailableBandwidth(f), this.resolutionManager.setMaxFrameSize(this.inputLayouts[1].maxFs), this.loFiLayout = this.getMinimalLayoutParams(this.inputLayouts), this.hiFiLayout = this.getHighLayoutParams(this.inputLayouts, f, this.loFiLayout), this.loFiLayout = this.adjustLowLayoutBasedOnHighLayout(this.hiFiLayout, this.loFiLayout, g);
                }
                adjustLowLayoutBasedOnHighLayout(g, f, S) {
                    return this.configProvider.config.useMediaQualityControllerForceKeyFrame && !g && S && (this.logger.safe.debug("Forcing kayframe on low layout due to disabling high layout"), f.keyframe = !0), g ? (f.maxBr === g.maxBr && f.maxBr--, f) : f;
                }
                getPrioritizedLayouts(g) {
                    return g.sort((g, f)=>g.maxFs - f.maxFs ? g.maxFs - f.maxFs : g.maxFps - f.maxFps);
                }
                getHighLayoutParams(g, f, S) {
                    const v = g[1];
                    if (v.maxBr <= f) return this.logger.safe.debug(`High layout bandwidth suits requested caps. Applying as-is: ${JSON.stringify(v)}`), v;
                    const _ = {
                        ...g[1],
                        maxFs: this.resolutionManager.getFrameSize(),
                        maxBr: Math.min(f, g[1].maxBr),
                        maxFps: g[1].maxFps
                    }, C = _.maxBr < S.maxBr || _.maxFs < S.maxFs || _.maxFs === S.maxFs && _.maxFps <= S.maxFps, E = `Potential high layout: ${JSON.stringify(_)}`;
                    return !this.hiFiLayout && C ? (this.logger.safe.debug(`High layout is already disabled. Do nothing. ${E}`), null) : this.hiFiLayout && C ? (this.logger.safe.debug(`High layout gets disabled. ${E}`), null) : (this.hiFiLayout && deepEqual(_, this.hiFiLayout) ? this.logger.safe.debug(`High layout has not been changed. Do nothing. ${E}`) : this.hiFiLayout ? this.logger.safe.debug(`High layout updated. ${E}`) : this.logger.safe.debug(`High layout enabled. ${E}`), _);
                }
                getMinimalLayoutParams(g) {
                    const f = Math.min(g[0].maxBr, g[1].maxBr), S = this.configProvider.config.specCompliantSimulcast.maxBrControlEnabled ? limitStreamMaxBitrate(f, this.totalBandwidth, this.configProvider.config.specCompliantSimulcast.bitrateToBweTable) : f;
                    return {
                        ...g[0],
                        maxBr: S,
                        maxFps: Math.min(g[0].maxFps, g[1].maxFps),
                        maxFs: Math.min(g[0].maxFs, g[1].maxFs)
                    };
                }
                constructor(g, f){
                    super(g, f, 2), this.resolutionManager = new Yb(this.logger.createChild("BWEControlledResolutionManager"));
                }
            }, iA = class extends eA {
                getLayouts() {
                    return [
                        this.layout
                    ];
                }
                recalculateLayouts() {
                    let g = this.inputLayouts[0].maxFs;
                    if (this.configProvider.config.specCompliantSimulcast.allowResLimit && this.couldLimitFs && this.totalBandwidthMax) {
                        const f = this.configProvider.config.specCompliantSimulcast.fsToBweTable;
                        g = limitStreamMaxResolution(this.inputLayouts[0].maxFs, this.totalBandwidthMax, f);
                    }
                    const f = this.configProvider.config.specCompliantSimulcast.bitrateToBweTable, S = limitStreamMaxBitrate(this.inputLayouts[0].maxBr, this.totalBandwidth, f);
                    this.layout = {
                        ...this.inputLayouts[0],
                        maxFs: g,
                        maxBr: S
                    };
                }
                constructor(g, f, S){
                    super(f, S, 1), this.couldLimitFs = g;
                }
            }, nA = class extends Bt {
                dispose() {
                    this.logger.safe.debug("Disposed"), super.dispose();
                }
                setAvailableBandwidth(g) {
                    this.logger.safe.debug(`Available bandwidth updated ${g}`);
                }
                setLayouts(g, f) {
                    this.layouts = g, this.setAvailableBandwidth(f);
                }
                getLayouts() {
                    return this.layouts;
                }
                constructor(g){
                    super(g), this.logger = g, this.logger.safe.debug("Created");
                }
            }, compareQuality = (g, f)=>g.maxFs === f.maxFs ? g.maxFps === f.maxFps ? g.maxBr - f.maxBr : g.maxFps - f.maxFps : g.maxFs - f.maxFs, compareMBPR = (g, f)=>g.maxFs === f.maxFs ? g.maxFps - f.maxFps : g.maxFs - f.maxFs, rA = class extends Bt {
                dispose() {
                    this.logger.safe.debug("Disposed"), super.dispose();
                }
                setAvailableBandwidth(g) {
                    this.updateAvailableBandwidth(g), this.update();
                }
                setLayouts(g, f) {
                    this.inputLayouts = g, this.updateAvailableBandwidth(f), this.update();
                }
                getLayouts() {
                    var _this_outputLayouts;
                    return (_this_outputLayouts = this.outputLayouts) !== null && _this_outputLayouts !== void 0 ? _this_outputLayouts : [];
                }
                updateAvailableBandwidth(g) {
                    this.totalBandwidth !== Math.max(1, g) && (this.logger.safe.debug(`Available bandwidth updated ${g}`), this.totalBandwidth = Math.max(1, g), this.totalBandwidthMax = Math.max(this.totalBandwidthMax, this.totalBandwidth));
                }
                debug(g, f, ...S) {
                    let v;
                    const format = (g)=>{
                        var _ref;
                        return {
                            FS: g.maxFs,
                            FPS: g.maxFps,
                            BR: g.maxBr,
                            KF: g.keyframe ? "1" : "0",
                            id: (_ref = `rid:${g.rid}`) !== null && _ref !== void 0 ? _ref : `0x${g.ssrc.toString(16).padStart(8, "0")}`
                        };
                    };
                    v = Array.isArray(f) ? f.map(format) : format(f), this.logger.safe.info(`${g}: <${S.map((g)=>JSON.stringify(g)).join("><")}> ${JSON.stringify(v)}`);
                }
                update() {
                    const g = this.settings.allowedOvershoot || 1, f = this.adjustLayout(this.inputLayouts, this.totalBandwidth * g);
                    if (deepEqual(this.outputLayouts, f)) this.logger.safe.debug("Layout has not changed, skip update");
                    else {
                        if (this.settings.allowLayerBitrateOverlap && f.length && f.length < this.inputLayouts.length && (this.setMinimumQuality(f[0], this.inputLayouts), this.debug("SetMinimumQuality", f[0])), this.outputLayouts && this.settings.forceKeyFrameWhenLayerIsRemoved && this.outputLayouts.length > f.length) for (const g of f)this.logger.safe.debug(`Force key frame for rid:${g.rid}`), g.keyframe = !0;
                        this.outputLayouts = f, this.maxOutputLayers = Math.max(this.maxOutputLayers, this.outputLayouts.length), this.event("onLayoutsChanged").raise();
                    }
                }
                adjustLayout(g, f) {
                    const S = [];
                    if (g.length) {
                        var _this_settings_minFrameSizeForSimulcast, _this_settings_lowPriorityLayoutMaxFS;
                        if (g = g.map((g)=>Object.assign({}, g)).sort(compareQuality), this.debug("OriginalLayout", g), ((_this_settings_minFrameSizeForSimulcast = this.settings.minFrameSizeForSimulcast) === null || _this_settings_minFrameSizeForSimulcast === void 0 ? void 0 : _this_settings_minFrameSizeForSimulcast.length) > 1) {
                            const f = this.settings.minFrameSizeForSimulcast;
                            3 === g.length && 2 === (f === null || f === void 0 ? void 0 : f.length) && g[g.length - 1].maxFs < f[1] && this.debug("DisableLowResStream", g.pop());
                        }
                        if (this.settings.highPriorityLayoutMinFS && g.length > 1) g[g.length - 1].maxFs >= this.settings.highPriorityLayoutMinFS && ((_this_settings_lowPriorityLayoutMaxFS = this.settings.lowPriorityLayoutMaxFS) === null || _this_settings_lowPriorityLayoutMaxFS === void 0 ? void 0 : _this_settings_lowPriorityLayoutMaxFS.length) && this.limitResolutionOnLowerSimulcastStreams(g);
                        for(; g.length > 0 && f > 0;){
                            const v = g.shift();
                            this.debug("Next", v, f), this.settings.allowLayerBitrateOverlap || this.setMinimumQuality(v, g);
                            let _ = f - v.maxBr;
                            if (S.length > 0) {
                                if (_ < 0 && this.degradeBitrateOrResolution(v, f) && (this.debug("DegradeBitrateOrResolution", v), _ = f - v.maxBr), _ >= 0) {
                                    let g = !1;
                                    for (const f of S)if (g = compareMBPR(f, v) >= 0, this.settings.allowLayerBitrateOverlap || v.maxBr < f.maxBr && (g = !0), g) {
                                        this.debug("Drop", v, S.length);
                                        break;
                                    }
                                    g || (S.push(v), this.debug("Accept", v, S.length));
                                }
                            } else S.push(v), this.debug("Accept", v, S.length);
                            f = _;
                        }
                        this.debug("AdjustedLayout", S, f);
                    }
                    if (1 === S.length) {
                        if (this.settings.minSinglecastBitrate || this.settings.singlecastLadder) {
                            var _this_settings_minSinglecastBitrate;
                            const g = Math.max((_this_settings_minSinglecastBitrate = this.settings.minSinglecastBitrate) !== null && _this_settings_minSinglecastBitrate !== void 0 ? _this_settings_minSinglecastBitrate : this.totalBandwidth, this.totalBandwidth);
                            S[0].maxBr > g && this.degradeBitrateOrResolution(S[0], g, this.settings.singlecastLadder) && this.debug("DegradeSinglecast", S[0], g);
                        } else {
                            if (this.settings.limitMaxResolution && this.maxOutputLayers <= 1) {
                                var _this_configProvider_config_specCompliantSimulcast;
                                const g = (_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.fsToBweTable;
                                S[0].maxFs = limitStreamMaxResolution(S[0].maxFs, this.totalBandwidthMax, g), this.debug("LimitMaxFS", S[0], this.totalBandwidthMax);
                            }
                            if (this.settings.limitMaxBitrate) {
                                var _this_configProvider_config_specCompliantSimulcast1;
                                const g = (_this_configProvider_config_specCompliantSimulcast1 = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast1 === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast1.bitrateToBweTable;
                                S[0].maxBr = limitStreamMaxBitrate(S[0].maxBr, this.totalBandwidth, g), this.debug("LimitMaxBitrate", S[0], this.totalBandwidth);
                            }
                        }
                    }
                    return S;
                }
                limitResolutionOnLowerSimulcastStreams(g) {
                    const f = g.pop();
                    if (1 === g.length) {
                        const f = this.settings.lowPriorityLayoutMaxFS[0];
                        this.degradeResolutionTo(g[0], f) && this.debug("DegradeResolutionTo", g[0], 0, f);
                    } else {
                        const f = [
                            ...this.settings.lowPriorityLayoutMaxFS
                        ];
                        f.sort(), g.splice(Math.min(2, f.length));
                        for(let S = 0; S < g.length; ++S)this.degradeResolutionTo(g[S], f[S]) && this.debug("DegradeResolutionTo", g[S], S, f[S]);
                    }
                    g.push(f);
                }
                setMinimumQuality(g, f) {
                    for (const S of f)g.maxBr = Math.min(S.maxBr, g.maxBr), g.maxFs = Math.min(S.maxFs, g.maxFs), g.maxFps = Math.min(S.maxFps, g.maxFps), g.maxMbps = g.maxFs * g.maxFps;
                }
                degradeResolutionTo(g, f) {
                    for(; g.maxFs > f;)if (!this.degradeResolution(g)) return !1;
                    return !0;
                }
                degradeResolution(g) {
                    const f = this.mapLayoutToLadder(g);
                    if (f >= this.ladder.length) return !1;
                    if (f > 0) {
                        const S = this.ladder[f - 1];
                        return g.maxBr = Math.min(g.maxBr, S.maxBitrate), g.maxMbps = S.fs * S.fps, g.maxFps = S.fps, g.maxFs = S.fs, !0;
                    }
                    return !1;
                }
                degradeBitrateOrResolution(g, f, S) {
                    S !== null && S !== void 0 ? S : S = this.ladder;
                    const v = this.mapLayoutToLadder(g, S);
                    if (v >= S.length) return !1;
                    if (f >= S[v].minBitrate) return g.maxBr = f, !0;
                    let _ = v;
                    for(; _ > 0;){
                        const v = S[--_];
                        if (f >= v.minBitrate) return g.maxMbps = v.fs * v.fps, g.maxFps = v.fps, g.maxFs = v.fs, g.maxBr = Math.min(f, v.maxBitrate), !0;
                    }
                    return !1;
                }
                mapLayoutToLadder(g, f) {
                    let S = 0;
                    for(f !== null && f !== void 0 ? f : f = this.ladder; S < f.length && !(f[S].fs >= g.maxFs && f[S].fps >= g.maxFps);)++S;
                    return S;
                }
                constructor(g, f, S){
                    super(S), this.settings = g, this.configProvider = f, this.logger = S, this.totalBandwidthMax = 0, this.totalBandwidth = Qb, this.inputLayouts = null, this.outputLayouts = null, this.maxOutputLayers = 0, this.ladder = [], this.settings.ladder ? this.ladder.push(...this.settings.ladder) : this.ladder.push(...Zt.Send.getResolutions());
                }
            }, aA = class extends Bt {
                configure(g) {
                    var _this_configProvider_config_specCompliantSimulcast;
                    const f = this.isMultiStream(g);
                    this.multiStream !== f && (this.multiStream = f, this.simulcastStrategySettings || this.deferredOperation.invoke(this.multiStream && !((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.maxBrControlEnabled)));
                }
                onFeaturesChanged(g) {
                    var _this_configProvider_config_broadcastMode, _this_configProvider_config_software1080p, _this_configProvider_config_software1080p1, _this_configProvider_config_broadcastMode1, _this_configProvider_config_broadcastMode2, _S_video;
                    const f = {}, S = this.configProvider.config.specCompliantSimulcast;
                    let v = !1;
                    var _f_minSinglecastBitrate;
                    g.hasServerSupport(0) && (v = !0), g.hasClientSupport(1) || g.hasClientSupport(2) && this.configProvider.config.software1080p && (v = !0), g.hasClientSupport(3) && ((_this_configProvider_config_broadcastMode = this.configProvider.config.broadcastMode) === null || _this_configProvider_config_broadcastMode === void 0 ? void 0 : _this_configProvider_config_broadcastMode.prioritizeLayoutOnClient) && (v = !0), f.limitMaxBitrate = S === null || S === void 0 ? void 0 : S.maxBrControlEnabled, f.limitMaxResolution = S === null || S === void 0 ? void 0 : S.allowResLimit, f.allowedOvershoot = S === null || S === void 0 ? void 0 : S.allowedBweOvershootRatio, f.forceKeyFrameWhenLayerIsRemoved = this.configProvider.config.useMediaQualityControllerForceKeyFrame, v && f.limitMaxResolution && (f.limitMaxResolution = this.firstTime && !this.wasMultistream), g.hasClientSupport(1) || g.hasClientSupport(2) && (f.highPriorityLayoutMinFS = (_this_configProvider_config_software1080p = this.configProvider.config.software1080p) === null || _this_configProvider_config_software1080p === void 0 ? void 0 : _this_configProvider_config_software1080p.highPriorityLayoutMinFS, f.lowPriorityLayoutMaxFS = (_this_configProvider_config_software1080p1 = this.configProvider.config.software1080p) === null || _this_configProvider_config_software1080p1 === void 0 ? void 0 : _this_configProvider_config_software1080p1.lowPriorityLayoutMaxFS), g.hasClientSupport(3) && (f.highPriorityLayoutMinFS = (_this_configProvider_config_broadcastMode1 = this.configProvider.config.broadcastMode) === null || _this_configProvider_config_broadcastMode1 === void 0 ? void 0 : _this_configProvider_config_broadcastMode1.priorityLayoutMinFS, f.lowPriorityLayoutMaxFS = (_this_configProvider_config_broadcastMode2 = this.configProvider.config.broadcastMode) === null || _this_configProvider_config_broadcastMode2 === void 0 ? void 0 : _this_configProvider_config_broadcastMode2.lowPriorityLayoutMaxFS), g.hasClientSupport(2) && (f.minSinglecastBitrate = this.configProvider.config.minSinglecastBitrateFor1080pEncode), g.hasClientSupport(2) && this.configProvider.config.singlecastLayoutLadderFor1080pEncode && (f.singlecastLadder = createResolutionTable(this.configProvider.config.singlecastLayoutLadderFor1080pEncode)), g.hasServerSupport(0) && (f.minSinglecastBitrate = (_f_minSinglecastBitrate = f.minSinglecastBitrate) !== null && _f_minSinglecastBitrate !== void 0 ? _f_minSinglecastBitrate : S === null || S === void 0 ? void 0 : S.minSinglecastBitrate, f.allowLayerBitrateOverlap = S === null || S === void 0 ? void 0 : S.allowLayerBitrateOverlap, S.dropLowResolutionHigherStreams && (f.minFrameSizeForSimulcast = (_S_video = S.video) === null || _S_video === void 0 ? void 0 : _S_video.minFsForSimulcast)), !!this.simulcastStrategySettings === v && deepEqual(f, this.simulcastStrategySettings) || (v ? (this.logger.safe.info(`[SLCS] Configure [${this.simulcastStrategySettings ? "existing" : "initial"}][${this.wasMultistream}]: ${JSON.stringify(f)}`), this.simulcastStrategySettings = f) : (this.simulcastStrategySettings && this.logger.safe.info("[SLCS] Disable"), this.simulcastStrategySettings = void 0), this.deferredOperation.invoke(!1));
                }
                setLayouts(g, f) {
                    deepEqual(this.latestLayouts, g) && this.latestBandwidth === f ? this.logger.safe.debug("Layouts and bandwidth are not changed. Skipping update") : (this.latestLayouts = g, this.latestBandwidth = f, this.strategy.setLayouts(this.latestLayouts, f));
                }
                setAvailableBandwidth(g) {
                    this.latestBandwidth !== g ? (this.strategy.setAvailableBandwidth(g), this.latestBandwidth = g) : this.logger.safe.debug("Bandwidth is not changed. Skipping update");
                }
                getLayouts() {
                    return this.strategy.getLayouts();
                }
                dispose() {
                    this.strategy.dispose(), this.strategy = null, this.deferredOperation.dispose(), this.deferredOperation = null, super.dispose();
                }
                updateStrategy() {
                    this.strategy.dispose(), this.createStrategy(this.multiStream), this.latestLayouts && this.strategy.setLayouts(this.latestLayouts, this.latestBandwidth);
                }
                isMultiStream(g) {
                    return g > 1;
                }
                createStrategy(g, f = !1) {
                    this.strategy = this.getNewStrategy(g, f), this.strategy.on("onLayoutsChanged", ()=>{
                        this.wasMultistream = this.wasMultistream || this.isMultiStream(this.strategy.getLayouts().length), this.event("onLayoutsChanged").raise();
                    });
                }
                getNewStrategy(g, f) {
                    var _this_configProvider_config_specCompliantSimulcast;
                    return this.simulcastStrategySettings ? new rA(this.simulcastStrategySettings, this.configProvider, this.logger.createChild("SimulcastLayoutControlStrategy")) : g ? new tA(this.configProvider, this.logger.createChild("BWEControlledStrategy")) : ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.maxBrControlEnabled) && this.supportSingleBwControl ? new iA(f, this.configProvider, this.logger.createChild("BWEControlledStrategySingle")) : new nA(this.logger.createChild("NoControlStrategy"));
                }
                constructor(g, f, S, v){
                    super(v), this.supportSingleBwControl = g, this.firstTime = f, this.configProvider = S, this.logger = v, this.multiStream = !1, this.wasMultistream = !0, this.deferredOperation = new Jb(()=>this.updateStrategy(), this.configProvider.config.layoutControlTimeout, this.logger.createChild("DeferredOperation")), this.simulcastStrategySettings = void 0, this.wasMultistream = !1, this.createStrategy(this.multiStream, this.firstTime);
                }
            }, sA = class extends Bt {
                dispose() {
                    this.bandwidthAllocator = null, this.layoutProviders.forEach((g)=>g.dispose()), this.layoutProviders.clear(), this.layoutProviders = null, super.dispose();
                }
                addReceiver(g, f) {
                    this.logger.safe.debug(`Set receiver max capabilities for ${g}: ${JSON.stringify(f)}`), this.configureProviders(g, f.length);
                    const S = f.map((g)=>g.maxBr).reduce((g, f)=>g + f);
                    if (this.useNewBandwidthAllocator && "Video" === g && this.layoutProviders.has("ScreenShare") && this.configProvider.config.bandwidthAllocatorV2.enableDynamicVideoLadder) {
                        const g = Math.max(...f.map((g)=>g.maxFs));
                        g > this.highestVideoMaxFsWithSharingEnabled && (this.highestVideoMaxFsWithSharingEnabled = g, this.bandwidthAllocator.setLadder("Video", getVideoBandwidthLadder(this.configProvider, g)));
                    }
                    this.bandwidthAllocator.addReceiverCapability(g, S);
                    const v = this.bandwidthAllocator.getLayouts();
                    this.layoutProviders.get(g).setLayouts(f, v[g]), this.updateBandwidthDistribution();
                }
                removeReceiver(g) {
                    var _this_layoutProviders_get;
                    this.logger.safe.debug(`Removing receiver for ${g}`), (_this_layoutProviders_get = this.layoutProviders.get(g)) === null || _this_layoutProviders_get === void 0 ? void 0 : _this_layoutProviders_get.dispose(), this.layoutProviders.delete(g), this.highestVideoMaxFsWithSharingEnabled = 0, this.bandwidthAllocator.removeReceiver(g), this.updateBandwidthDistribution();
                }
                getLayouts(g) {
                    return this.layoutProviders.get(g).getLayouts();
                }
                onStatisticsChanged(g) {
                    this.sendBandwidthCalculator.onBandwidthChanged(g.estimatedSendBandwidth);
                }
                onDiagnosticUpdated(g) {
                    var _g_video_send, _g_video, _g_video1;
                    ((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : _g_video_send.length) && ((_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : _g_video1.send[0]) && (this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("Caught onDiagnosticUpdated: Estimating send bandwidth"), this.sendBandwidthCalculator.onBandwidthChanged(calculateEstimatedSendBandwidth(g.video.send[0], this.configProvider)));
                }
                useVideoFeatures(g) {
                    var _this_configProvider_config_specCompliantSimulcast, _this_configProvider_config_broadcastMode;
                    return "Video" === g && (!!((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.enableSimulcastLayoutControlStrategy) || !!((_this_configProvider_config_broadcastMode = this.configProvider.config.broadcastMode) === null || _this_configProvider_config_broadcastMode === void 0 ? void 0 : _this_configProvider_config_broadcastMode.prioritizeLayoutOnClient) || !!this.configProvider.config.software1080p);
                }
                switchBandwidthAllocator() {
                    const g = createBandwidthAllocatorV2(this.logger, this.configProvider);
                    g.setAvailableBandwidth(this.bandwidthAllocator.getAvailableBandwidth());
                    const f = this.bandwidthAllocator.getReceiverCapabilities();
                    for (const S of Object.keys(f))g.addReceiverCapability(S, f[S]);
                    this.useNewBandwidthAllocator = !0, this.bandwidthAllocator = g, this.updateBandwidthDistribution();
                }
                configureProviders(g, f) {
                    if (!this.layoutProviders.has(g)) {
                        const f = this.createProvider(g);
                        this.layoutProviders.set(g, f);
                    }
                    this.useVideoFeatures(g) && f > 2 && this.videoFeatures.get(g).toggleServer(0, !0), this.layoutProviders.get(g).configure(f);
                }
                createProvider(g) {
                    const f = new aA("Video" === g, !this.hadLayoutProvider.has(g), this.configProvider, this.logger.createChild(`LG:${g}`));
                    return f.on("onLayoutsChanged", ()=>{
                        const S = f.getLayouts();
                        this.logger.safe.debug(`New layouts generated: ${JSON.stringify(S)}`), this.event("onLayoutsUpdated").raise(g);
                    }), this.hadLayoutProvider.add(g), this.useVideoFeatures(g) && f.onFeaturesChanged(this.videoFeatures.get(g)), f;
                }
                onAvailableBandwidthChanged(g) {
                    this.bandwidthAllocator.setAvailableBandwidth(g), this.updateBandwidthDistribution();
                }
                updateBandwidthDistribution() {
                    var _this_layoutProviders_get, _this_configProvider_config_mediaControlPlaneConfig;
                    const g = this.bandwidthAllocator.getLayouts();
                    for (const [f, S] of Object.entries(g))(_this_layoutProviders_get = this.layoutProviders.get(f)) === null || _this_layoutProviders_get === void 0 ? void 0 : _this_layoutProviders_get.setAvailableBandwidth(S);
                    ((_this_configProvider_config_mediaControlPlaneConfig = this.configProvider.config.mediaControlPlaneConfig) === null || _this_configProvider_config_mediaControlPlaneConfig === void 0 ? void 0 : _this_configProvider_config_mediaControlPlaneConfig.enableSendBandwidthNotificationsEnabled) && this.event("onBandwidthAllocationUpdated").raise(g);
                }
                constructor(g, f, S){
                    super(f), this.configProvider = g, this.logger = f, this.videoFeatures = S, this.bandwidthAllocator = null, this.sendBandwidthCalculator = new fb(this.configProvider, this.logger.createChild("SendBandwidthCalculator")), this.layoutProviders = new Map, this.hadLayoutProvider = new Set, this.useNewBandwidthAllocator = !1, this.highestVideoMaxFsWithSharingEnabled = 0, this.bandwidthAllocator = createBandwidthAllocatorPerMediaType(this.logger, this.configProvider), this.sendBandwidthCalculator.on("onSendBandwidthChanged", (g)=>this.onAvailableBandwidthChanged(g)), this.configProvider.config.sendBandwidthSeedValue && this.bandwidthAllocator.setAvailableBandwidth(this.configProvider.config.sendBandwidthSeedValue), this.useVideoFeatures("Video") && this.videoFeatures.on("onVideoFeaturesChanged", (g)=>{
                        if (this.useVideoFeatures(g.mediaType)) {
                            const f = this.layoutProviders.get(g.mediaType);
                            f && f.onFeaturesChanged(g);
                        }
                        if (!this.useNewBandwidthAllocator && this.configProvider.config.bandwidthAllocatorV2.enableAllocator) {
                            var _this_configProvider_config_software1080p;
                            let f = !1;
                            g.hasServerSupport(0) && (f = !0), g.hasClientSupport(2) && ((_this_configProvider_config_software1080p = this.configProvider.config.software1080p) === null || _this_configProvider_config_software1080p === void 0 ? void 0 : _this_configProvider_config_software1080p.useNewBandwidthAllocator) && (f = !0), f && this.switchBandwidthAllocator();
                        }
                    });
                }
            }, oA = P;
            function mergeCapabilitiesWithCallConstraints(g, f, S) {
                if ("Video" !== g || !S) return S;
                var _f_config_outgoingVideoLimit;
                const { maxBitrate: v, maxResolution: _, maxFramerate: C } = (_f_config_outgoingVideoLimit = f.config.outgoingVideoLimit) !== null && _f_config_outgoingVideoLimit !== void 0 ? _f_config_outgoingVideoLimit : {}, E = v !== null && v !== void 0 ? v : 1 / 0, T = _ ? convertResolutionToFramesize(_) : 1 / 0, I = C !== null && C !== void 0 ? C : 1 / 0;
                return E === 1 / 0 && T === 1 / 0 && I === 1 / 0 ? S : S.map((g)=>({
                        ...g,
                        maxFs: getMinDefined(g.maxFs, T),
                        maxBr: getMinDefined(g.maxBr, E),
                        maxFps: getMinDefined(g.maxFps, I)
                    }));
            }
            var lA = new Set([
                "maintain-framerate",
                "maintain-resolution",
                "balanced"
            ]), cA = class {
                async setActive(g, f) {
                    const S = this.getSenderParameters(g);
                    return S.encodings[0].active = f, this.setSenderParameters(g, S, "setActive");
                }
                getScaleFactor(g, f) {
                    if (!f.width || !f.height) return this.logger.safe.warn("Stream resolution is not set yet. Cannot calculate scale factor. Returning 1"), 1;
                    const S = Zt.Send.getResolutionByFs(g);
                    let v = Math.min(f.width, f.height) / S.height;
                    return this.logger.safe.debug(`Scale factor is taken from resolution: ${JSON.stringify(f)} and new Fs: ${g} as ${v}`), v < 1 && (this.logger.safe.warn("Scale factor cannot be less than 1! Limiting to 1"), v = 1), v;
                }
                async generateKeyFrameIfNeeded(g, f) {
                    if (!f.track) return void this.logger.safe.info("No track attached. Skipping");
                    const S = this.getSenderParameters(f), v = g.filter((g)=>g.keyframe).map((g)=>g.rid);
                    if (0 !== v.length && S.encodings.some((g)=>g.active)) {
                        if (this.configProvider.config.useKeyFrameApi) {
                            const g = [];
                            S.encodings.forEach((f)=>{
                                !f.active || f.rid && !v.includes(f.rid) ? g.push({
                                    keyFrame: !1
                                }) : g.push({
                                    keyFrame: !0
                                });
                            }), await this.setSenderParameters(f, S, "generateKeyFrameAPI", !0, {
                                encodingOptions: g
                            });
                        } else {
                            const g = S.encodings.map((g, f)=>g.active ? g.rid && !v.includes(g.rid) ? null : {
                                    idx: f,
                                    factor: g.scaleResolutionDownBy || 1
                                } : null).filter((g)=>g);
                            for (const f of g)S.encodings[f.idx].scaleResolutionDownBy = f.factor * this.configProvider.config.forceKeyFrameV2ScaleFactor;
                            this.logger.safe.debug(`Restoring keyframe starting. Update scaleResolutionDownBy for encodings: ${JSON.stringify(S.encodings)}`), await this.setSenderParameters(f, S, "generateKeyFrameStart");
                            const _ = this.getSenderParameters(f);
                            for (const f of g)_.encodings[f.idx].scaleResolutionDownBy = f.factor;
                            await this.setSenderParameters(f, _, "generateKeyFrameEnd"), this.logger.safe.debug(`Restoring keyframe completed. Set scaleResolutionDownBy back for encodings: ${JSON.stringify(_.encodings)}`);
                        }
                    } else this.logger.safe.info("No keyframes needed. Skipping");
                }
                getSenderParameters(g) {
                    var _f_encodings;
                    const f = g.getParameters();
                    if (((_f_encodings = f.encodings) === null || _f_encodings === void 0 ? void 0 : _f_encodings.length) || (f.encodings = [
                        {}
                    ]), this.configProvider.config.reuseLastSetParameters && this.lastSetEncodings) {
                        this.logger.safe.info(`Override returned encodings ${JSON.stringify(f.encodings)}`);
                        const g = (0, oA.merge)((0, oA.cloneDeep)(f.encodings), this.lastSetEncodings);
                        this.logger.safe.info(`Overrided encodings ${JSON.stringify(g)}`), f.encodings = g;
                    }
                    return f;
                }
                async setSenderParameters(g, f, S, v = !0, _) {
                    try {
                        await g.setParameters(f, _), this.logger.safe.info(`${S}: Parameters applied for sender: encodings: ${JSON.stringify(f.encodings)}, degradationPreference: ${f.degradationPreference}`), this.lastSetEncodings = f.encodings;
                    } catch (g) {
                        const _ = `${S}: setParameters failed. Parameters: ${JSON.stringify(f.encodings)}, error:  ${stringifyObject(g)}`;
                        if (this.logger.safe.error(_), v) throw new Error(_);
                    }
                }
                getAdjustedBitrate(g, f) {
                    let S = g || 0;
                    const { maxBitrate: v } = Zt.Send.getBitrateForResolution(f.width, f.height);
                    return S = Math.min(S || v, v), S;
                }
                async updateStreamParameters(g, f, S) {
                    if (g.getCurrentConstraints().withEffect && (f === null || f === void 0 ? void 0 : f.maxFs)) {
                        const S = Zt.Send.getResolutionByFs(f.maxFs), v = {
                            width: S.width,
                            height: S.height
                        };
                        this.logger.safe.info(`Applying video constrains for video effetcs ${JSON.stringify(v)}`), g.resetEffectsOutputConstraints(v);
                    }
                    S && await g.applyCapabilities(f);
                }
                augmentDegradationPreference(g, f) {
                    lA.has(f) && g.degradationPreference !== f && (g.degradationPreference = f, this.logger.safe.info(`degradationPreference changed to: ${g.degradationPreference}`));
                }
                async setEncodingsActiveState(g, f, S) {
                    this.logger.safe.info(S);
                    const v = this.getSenderParameters(g);
                    return v.encodings.forEach((g)=>g.active = f), this.setSenderParameters(g, v, S);
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f;
                }
            }, dA = class {
                get streamResolution() {
                    var _this_stream;
                    return ((_this_stream = this.stream) === null || _this_stream === void 0 ? void 0 : _this_stream.getCurrentConstraints().withEffect) ? this._streamResolutionFromCapabilities : this._streamResolution;
                }
                setSender(g) {
                    this.rtpSender = g;
                }
                updateStream(g) {
                    this.stream = g, this._streamResolution = g.getResolution(), this._streamResolutionFromCapabilities = this._streamResolution;
                }
                setActive(g) {
                    return this.capabilitiesHelper.setActive(this.rtpSender, g);
                }
                async setCapabilities(g) {
                    (0, oA.isEqual)(this.currentCapabilities, g) ? this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(g)}. Do nothing`) : (this.defaultCapabilities = (0, oA.cloneDeep)(g), this.currentCapabilities = (0, oA.cloneDeep)(g), await this.applyLastCapabilities(), await this.capabilitiesHelper.generateKeyFrameIfNeeded(g, this.rtpSender));
                }
                async updateStreamQualityParams(g, f, S) {
                    var _this_rtpSender_track;
                    if (g && !(0, oA.isEqual)(this.streamResolution, g)) return this._streamResolution = g, this._streamResolutionFromCapabilities = g, this.logger.safe.info(`Stream params changed: ${JSON.stringify(g)}@${f}@${S} id: ${(_this_rtpSender_track = this.rtpSender.track) === null || _this_rtpSender_track === void 0 ? void 0 : _this_rtpSender_track.id}`), this.applyLastCapabilities();
                    this.logger.safe.debug(`Resolution is not defined or same: ${JSON.stringify(g)}@${f}`);
                }
                async startSender() {
                    if (this.configProvider.config.disableSendersTroughSetParameters) return this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender, !0, "Starting senders.");
                }
                async stopSender() {
                    return this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender, !1, "Stopping senders.");
                }
                async applyLastCapabilities() {
                    if (!this.currentCapabilities) return void this.logger.safe.info("Capabilities are not set. Do nothing");
                    this.currentCapabilities = mergeCapabilitiesWithCallConstraints(this.stream.mediaType, this.configProvider, this.defaultCapabilities), await this.applyStreamCapabilities(this.currentCapabilities);
                    const g = this.capabilitiesHelper.getSenderParameters(this.rtpSender), f = (0, oA.cloneDeep)(g);
                    return this.currentCapabilities.forEach((f)=>{
                        const S = this.getEncondingIndexForRid(f.rid, g.encodings);
                        this.updateEncodingsWithCaps(g.encodings[S], f);
                    }), this.capabilitiesHelper.augmentDegradationPreference(g, this.configProvider.config.degradationPreference), this.updateActiveStates(g, this.currentCapabilities), this.logger.safe.info(`Encoding params new: ${JSON.stringify(g.encodings)}, old: ${JSON.stringify(f.encodings)}`), this.capabilitiesHelper.setSenderParameters(this.rtpSender, g, "applyCapabilities");
                }
                async applyCallConstraints(g) {
                    return this.logger.safe.info(`[${g}] Applying call constraints`), this.applyLastCapabilities();
                }
                async applyStreamCapabilities(g) {
                    if ("Video" !== this.stream.mediaType || !g.length) return;
                    let f = g[0];
                    for (const S of g)f.maxFs < S.maxFs && (f = S);
                    if (g.length > 1) {
                        const S = this.configProvider.config.specCompliantSimulcast.video.minFsForSimulcast;
                        if (f = (0, oA.cloneDeep)(f), (S === null || S === void 0 ? void 0 : S.length) > 0) for(let v = 0; v < S.length; ++v)g.length > v + 1 && (f.maxFs = Math.max(S[v] || 0, f.maxFs));
                    }
                    const S = this.configProvider.config.specCompliantSimulcast.video.useApplyConstraints;
                    await this.capabilitiesHelper.updateStreamParameters(this.stream, f, S), S && (this._streamResolution = this.stream.getResolution());
                }
                getEncondingIndexForRid(g, f) {
                    if (!g) return this.logger.safe.error("No RID found in incoming params. Returning index 0"), 0;
                    const S = f.findIndex((f)=>f.rid === g);
                    return S < 0 || S - 1 > this.config.layerScaleFactors.length ? (this.logger.safe.error("Incorrect index deduced from requested RID. Returning index 0"), 0) : S;
                }
                updateEncodingsWithCaps(g, f) {
                    g ? (g.maxBitrate = f.maxBr, g.scaleResolutionDownBy = this.capabilitiesHelper.getScaleFactor(f.maxFs, this.streamResolution), g.maxFramerate = f.maxFps, this.config.defaultScalabilityMode && (g.scalabilityMode = this.config.defaultScalabilityMode)) : this.logger.safe.error(`SenderParams does not exist for caps: ${JSON.stringify(f)}`);
                }
                updateActiveStates(g, f) {
                    const S = g.encodings.map((g)=>g.rid), v = S.filter((g)=>f.some((f)=>g === f.rid)), _ = subtractFrom(S, v);
                    v.forEach((f)=>this.changeEncodingState(g, f, !0)), _.forEach((f)=>this.changeEncodingState(g, f, !1));
                }
                changeEncodingState(g, f, S) {
                    const v = g.encodings.find((g)=>g.rid === f);
                    v ? v.active = S : this.logger.safe.error(`Encoding not found for RID: ${f}`);
                }
                constructor(g, f, S){
                    this.config = g, this.configProvider = f, this.logger = S, this.capabilitiesHelper = new cA(this.configProvider, this.logger);
                }
            }, uA = class {
                get params() {
                    var _this_currentCapabilities, _this_currentCapabilities1;
                    var _this_currentCapabilities_find;
                    return (_this_currentCapabilities_find = (_this_currentCapabilities = this.currentCapabilities) === null || _this_currentCapabilities === void 0 ? void 0 : _this_currentCapabilities.find((g)=>"1" === g.rid)) !== null && _this_currentCapabilities_find !== void 0 ? _this_currentCapabilities_find : (_this_currentCapabilities1 = this.currentCapabilities) === null || _this_currentCapabilities1 === void 0 ? void 0 : _this_currentCapabilities1[0];
                }
                get useSetParameter() {
                    if ("ScreenShare" === this.stream.mediaType) {
                        if (this.configProvider.config.useSetParametersToApplySSCapabilities) return this.logger.safe.info("useSetParametersToApplySSCapabilities: true"), !0;
                        if (!1 === this.configProvider.config.useSetParametersToApplySSCapabilities) return this.logger.safe.info("useSetParametersToApplySSCapabilities: false"), !1;
                    }
                    return !!this.configProvider.config.useSetParametersToApplyCapabilities && (this.logger.safe.info("useSetParametersToApplyCapabilities"), !0);
                }
                async applyCallConstraints(g) {
                    return this.logger.safe.info(`[${g}] Applying call constraints`), this.applyLastCapabilities(3);
                }
                setSender(g) {
                    this.rtpSender = g;
                }
                updateStream(g) {
                    this.stream = g, this.streamResolution = g.getResolution();
                }
                setActive(g) {
                    return this.capabilitiesHelper.setActive(this.rtpSender, g);
                }
                async setCapabilities(g) {
                    (0, oA.isEqual)(this.currentCapabilities, g) ? this.logger.safe.info(`Capabilities already applied: ${JSON.stringify(g)}. Do nothing`) : 1 === g.length ? (this.defaultCapabilities = (0, oA.cloneDeep)(g), this.currentCapabilities = (0, oA.cloneDeep)(g), await this.applyLastCapabilities(0), await this.capabilitiesHelper.generateKeyFrameIfNeeded(g, this.rtpSender)) : this.logger.safe.error("Incorrect number of sender params!");
                }
                async updateStreamQualityParams(g, f, S) {
                    if (g && !(0, oA.isEqual)(this.streamResolution, g)) return this.streamResolution = g, this.logger.safe.debug(`Stream params changed: ${JSON.stringify(g)}@${f}`), this.applyLastCapabilities(S);
                    this.logger.safe.debug(`Resolution is not defined or same: ${JSON.stringify(g)}@${f}`);
                }
                async startSender(g) {
                    this.logger.safe.info(`Replace sender with track: ${g.id}`), await this.rtpSender.replaceTrack(g), this.logger.safe.info("replaceTrack completed"), this.configProvider.config.disableSendersTroughSetParameters && await this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender, !0, "Starting senders."), this.configProvider.config.applySenderParamsBeforeStart && this.currentCapabilities && await this.capabilitiesHelper.generateKeyFrameIfNeeded(this.currentCapabilities, this.rtpSender);
                }
                async stopSender() {
                    if (this.configProvider.config.disableSendersTroughSetParameters) return this.capabilitiesHelper.setEncodingsActiveState(this.rtpSender, !1, "Stopping senders.");
                    this.logger.safe.info("Replace sender with track: null"), await this.rtpSender.replaceTrack(null), this.logger.safe.info("replaceTrack completed");
                }
                async applyLastCapabilities(g) {
                    this.currentCapabilities ? (this.currentCapabilities = mergeCapabilitiesWithCallConstraints(this.stream.mediaType, this.configProvider, this.defaultCapabilities), this.logger.safe.info(`Applying params: ${JSON.stringify(this.params)}`), await this.applyParams(this.params, g), await this.applyBitrate(this.params.maxBr)) : this.logger.safe.debug("Capabilities are not yet set, nothing to apply");
                }
                applyBitrate(g) {
                    let f = g || 0;
                    return "Video" === this.stream.mediaType && (f = this.capabilitiesHelper.getAdjustedBitrate(f, this.streamResolution)), this.setSingleEncodingParameters(this.rtpSender, {
                        maxBitrate: f
                    }, "applyBitrate", !1);
                }
                async applyParams(g, f) {
                    if (this.useSetParameter) return this.setSingleEncodingParameters(this.rtpSender, {
                        scaleResolutionDownBy: this.capabilitiesHelper.getScaleFactor(g.maxFs, this.streamResolution),
                        maxFramerate: g.maxFps
                    }, "applyParams");
                    2 !== f && await this.capabilitiesHelper.updateStreamParameters(this.stream, g, !0);
                }
                async setSingleEncodingParameters(g, f, S, v = !0) {
                    const _ = this.capabilitiesHelper.getSenderParameters(g);
                    return (0, oA.merge)(_.encodings[0], f), 0 === _.encodings[0].maxBitrate && (this.configProvider.config.setParametersMaxBitrateUndefined ? _.encodings[0].maxBitrate = void 0 : delete _.encodings[0].maxBitrate), this.capabilitiesHelper.augmentDegradationPreference(_, this.configProvider.config.degradationPreference), this.capabilitiesHelper.setSenderParameters(this.rtpSender, _, S, v);
                }
                constructor(g, f){
                    this.configProvider = g, this.logger = f, this.capabilitiesHelper = new cA(this.configProvider, this.logger);
                }
            }, hA = class {
                get state() {
                    return this.stateCurrent;
                }
                isDestinationStateValid(g) {
                    return this.transitionStates[this.stateCurrent].indexOf(g) > -1;
                }
                setState(g) {
                    return this.isDestinationStateValid(g) ? (this.stateCurrent = g, !0) : (g !== this.stateCurrent && this.logger.safe.info(`Invalid state transition ${this.stateCurrent} -> ${g}`), !1);
                }
                isCurrentStateMatchedWith(g) {
                    return this.stateCurrent === g || (this.logger.safe.info(`State does not match. Current: ${this.stateCurrent} required: ${g}`), !1);
                }
                constructor(g, f, S){
                    this.transitionStates = g, this.logger = S, this.stateCurrent = f;
                }
            }, gA = class extends Bt {
                get numberOfStreams() {
                    return this.streamNodeMap.size;
                }
                addSourceStream(g) {
                    if (!g.rawStream) return;
                    if (this.streamNodeMap.has(g.rawStream)) return;
                    const f = g.on("onStreamClientDisposing", ()=>{
                        this.removeSourceStream(g.rawStream), f.dispose();
                    });
                    this.logger.safe.info(`Add stream: ${g.rawStream.id}, track: ${getTrack(g.rawStream).id}`), this.addStream(g.rawStream, g.mediaType);
                }
                getDestinationTrack() {
                    return getTrack(this.destination.stream);
                }
                dispose() {
                    super.dispose(), this.unsubscribeFromMediaTrackEvents(this.getDestinationTrack());
                    for (const g of this.streamNodeMap.keys())this.removeSourceStream(g);
                    this.audioContext.close(), this.audioContext = null;
                }
                addStream(g, f = "Audio") {
                    const S = this.audioContext.createMediaStreamSource(g);
                    S.connect(this.destination), this.streamNodeMap.set(g, {
                        mediaType: f,
                        sourceNode: S
                    });
                }
                removeSourceStream(g) {
                    const f = this.streamNodeMap.get(g);
                    f && (this.logger.safe.info(`Remove stream: ${g.id}, track: ${getTrack(g).id}`), f.sourceNode.disconnect(), this.streamNodeMap.delete(g));
                }
                subscribeOnMediaTrackEvents(g) {
                    g.onended = (f)=>{
                        this.logger.safe.info(`Track ${g.id} ended: ${JSON.stringify(f)}`);
                    }, g.onmute = ()=>{
                        this.logger.safe.info(`Track ${g.id} muted`);
                    }, g.onunmute = ()=>{
                        this.logger.safe.info(`Track ${g.id} unmuted`);
                    };
                }
                unsubscribeFromMediaTrackEvents(g) {
                    g.onended = null, g.onmute = null, g.onunmute = null;
                }
                constructor(g, f){
                    super(g), this.logger = g, this.configProvider = f, this.audioContext = new Qa.window.AudioContext(this.configProvider.config.audioSharingContextOptions), this.destination = this.audioContext.createMediaStreamDestination(), this.streamNodeMap = new Map, this.logger.safe.info(`Destination stream: ${this.destination.stream.id}, track: ${this.getDestinationTrack().id}`), this.subscribeOnMediaTrackEvents(this.getDestinationTrack());
                }
            };
            function getTrack(g) {
                return g.getAudioTracks()[0];
            }
            var pA = class extends Bt {
                get rawTrack() {
                    var _this_audioMixer;
                    return ((_this_audioMixer = this.audioMixer) === null || _this_audioMixer === void 0 ? void 0 : _this_audioMixer.getDestinationTrack()) || this.stream.rawTrack;
                }
                get trackId() {
                    var _this_rawTrack;
                    return (_this_rawTrack = this.rawTrack) === null || _this_rawTrack === void 0 ? void 0 : _this_rawTrack.id;
                }
                applyCallConstraints(g) {
                    return this.capabilitiesManager.applyCallConstraints(g);
                }
                async init() {
                    this.sender = await this.createSender(), this.isActive = !this.configProvider.config.disableSendersTroughSetParameters, this.addStreamTransforms(), this.capabilitiesManager.setSender(this.sender);
                }
                async start() {
                    this.isActive ? this.logger.safe.info("Already active. Do nothing") : (this.logger.safe.info("Starting"), this.isActive = !0, await this.capabilitiesManager.startSender(this.rawTrack), this.logger.safe.info("Started"));
                }
                async stop() {
                    this.isActive ? (this.logger.safe.info("Stopping"), this.isActive = !1, await this.capabilitiesManager.stopSender(), this.logger.safe.info("Stopped")) : this.logger.safe.info("Already stopped. Do nothing");
                }
                async setCapabilities(g) {
                    this.configProvider.config.applySenderParamsBeforeStart || await this.start();
                    try {
                        await this.capabilitiesManager.setCapabilities(g);
                    } catch (g) {
                        this.logger.safe.error(`Error setting capabilities: ${stringifyObject(g)}`);
                    }
                    await this.start();
                }
                updateStreamQualityParams(g, f, S) {
                    return this.capabilitiesManager.updateStreamQualityParams(g, f, S);
                }
                setMuted(g, f, S) {
                    var _this_audioMuteTransform;
                    this.isMuted = g, this.stream.setMuted(g, f), g && this.audioMixer && 1 !== this.audioMixer.numberOfStreams || ((_this_audioMuteTransform = this.audioMuteTransform) === null || _this_audioMuteTransform === void 0 ? void 0 : _this_audioMuteTransform.mute(g)), !this.configProvider.config.requestNewStreamOnUnmute || g || S || this.stream.isActive() || this.event("onNewStreamNeeded").raise();
                }
                async setHold(g, f) {
                    if (this.configProvider.config.holdSkipActivation) return;
                    const S = !g;
                    this.logger.safe.info(`[${f}] change isActive state to ${S}`);
                    try {
                        return this.capabilitiesManager.setActive(S);
                    } catch (g) {
                        const v = this.configProvider.config.holdRetryActivationDelay;
                        if (v >= 0) return this.logger.safe.info(`[${f}] retrying after delay of ${v}`), await delay(v), this.logger.safe.info(`[${f}] change isActive state to ${S}, second attempt`), this.capabilitiesManager.setActive(S);
                        throw g;
                    }
                }
                async setMainStream(g) {
                    var _this_onStreamClientMutedSubscription, _this_audioMixer, _this_rawTrack;
                    return this.stream.dispose(), (_this_onStreamClientMutedSubscription = this.onStreamClientMutedSubscription) === null || _this_onStreamClientMutedSubscription === void 0 ? void 0 : _this_onStreamClientMutedSubscription.dispose(), this.stream = g.clone("streamSender setMainStream"), this.stream.setMuted(this.isMuted), (_this_audioMixer = this.audioMixer) === null || _this_audioMixer === void 0 ? void 0 : _this_audioMixer.addSourceStream(this.stream), this.isActive && (this.logger.safe.info(`Replace sender with track: ${(_this_rawTrack = this.rawTrack) === null || _this_rawTrack === void 0 ? void 0 : _this_rawTrack.id}`), await this.sender.replaceTrack(this.rawTrack), this.logger.safe.info("Replace completed")), this.capabilitiesManager.updateStream(this.stream), this.subscribeOnStreamClientMuted(), this.capabilitiesManager.applyLastCapabilities(1);
                }
                async addAdditionalStream(g) {
                    var _this_audioMixer, _this_audioMuteTransform;
                    if ("Audio" === this.stream.mediaType) {
                        if (this.configProvider.config.postponeAudioMixerForAudioSharing && this.setupAudioMixer(), this.audioMixer || this.logger.safe.error(`addAdditionalStream is called when audioMixer is not created. Main stream type is ${this.stream.mediaType}.`), (_this_audioMixer = this.audioMixer) === null || _this_audioMixer === void 0 ? void 0 : _this_audioMixer.addSourceStream(g), (_this_audioMuteTransform = this.audioMuteTransform) === null || _this_audioMuteTransform === void 0 ? void 0 : _this_audioMuteTransform.mute(!1), this.configProvider.config.postponeAudioMixerForAudioSharing) {
                            var _this_rawTrack;
                            if (!this.sender) return void this.logger.safe.error("Sender not created, cannot replace track");
                            this.logger.safe.info(`addAdditionalStream replace sender with track: ${(_this_rawTrack = this.rawTrack) === null || _this_rawTrack === void 0 ? void 0 : _this_rawTrack.id}`), await this.sender.replaceTrack(this.rawTrack), this.logger.safe.info("addAdditionalStream replace completed");
                        }
                    } else this.logger.safe.error("Not adding additional stream for non-audio stream");
                }
                dispose() {
                    this.removeSender(), this.cleanUp();
                }
                async terminateAsync() {
                    await this.removeSenderAsync(), this.cleanUp();
                }
                getActiveStreamIndexes() {
                    return this.getSenderParameters().encodings.filter((g)=>g.active).map((g)=>+g.rid);
                }
                removeSender() {
                    this.logger.safe.info("Removing sender from pc");
                    try {
                        this.mediaConnection.removeSender(this.sender);
                    } catch (g) {
                        this.logger.safe.warn(`Error removing sender: ${stringifyObject(g)}`);
                    }
                }
                async removeSenderAsync() {
                    this.logger.safe.info("Removing sender from pc");
                    try {
                        await this.mediaConnection.removeSenderAsync(this.sender);
                    } catch (g) {
                        this.logger.safe.warn(`Error removing sender: ${stringifyObject(g)}`);
                    }
                }
                async createSender() {
                    return this.configProvider.config.postponeAudioMixerForAudioSharing || this.setupAudioMixer(), this.mediaConnection.createSender(this.rawTrack, this.contextStream, mediaTypeToModality(this.stream.mediaType));
                }
                addStreamTransforms() {
                    var _this_configProvider_config_useInsertableStreams, _this_configProvider_config_useInsertableStreams1;
                    const g = this.encStreamsManager.initTransformsCollection(this.sender, "Sender", this.stream.mediaType);
                    g && ("Audio" === this.stream.mediaType ? ((_this_configProvider_config_useInsertableStreams = this.configProvider.config.useInsertableStreams) === null || _this_configProvider_config_useInsertableStreams === void 0 ? void 0 : _this_configProvider_config_useInsertableStreams.audioExtendedMute) && (this.audioMuteTransform = new Ks(this.logger.createChild("SendAudioPayload")), g.addTransform(this.audioMuteTransform)) : ((_this_configProvider_config_useInsertableStreams1 = this.configProvider.config.useInsertableStreams) === null || _this_configProvider_config_useInsertableStreams1 === void 0 ? void 0 : _this_configProvider_config_useInsertableStreams1.videoStreamAnalyzer) && g.addTransform(new qs(this.logger.createChild(`SendStreamAnalyzer [${this.stream.mediaType}]`))));
                }
                setupAudioMixer() {
                    this.configProvider.config.enableAudioSharing ? "Audio" === this.stream.mediaType ? this.configProvider.config.audioSharingMemoryLeakFix && this.audioMixer ? this.logger.safe.debug("Audio mixer already created, not creating new one") : (this.audioMixer = new gA(this.logger.createChild("AudioMixer"), this.configProvider), this.audioMixer.addSourceStream(this.stream)) : this.logger.safe.error("Not setting up audio mixer for non-audio stream") : this.logger.safe.info("Audio sharing is disabled, not setting up audio mixer");
                }
                getSenderParameters() {
                    var _g_encodings;
                    const g = this.sender.getParameters();
                    return ((_g_encodings = g.encodings) === null || _g_encodings === void 0 ? void 0 : _g_encodings.length) || (g.encodings = [
                        {}
                    ]), g;
                }
                subscribeOnStreamClientMuted() {
                    this.configProvider.config.recoverOnStreamUnmute && (this.onStreamClientMutedSubscription = this.stream.on("onStreamClientMuted", async (g, f)=>{
                        f || await this.capabilitiesManager.applyLastCapabilities(1);
                    }));
                }
                cleanUp() {
                    var _this_audioMixer, _this_onStreamClientMutedSubscription;
                    super.dispose(), this.encStreamsManager.clearTransformsCollection(this.sender), this.sender = null, (_this_audioMixer = this.audioMixer) === null || _this_audioMixer === void 0 ? void 0 : _this_audioMixer.dispose(), this.stream.dispose(), (_this_onStreamClientMutedSubscription = this.onStreamClientMutedSubscription) === null || _this_onStreamClientMutedSubscription === void 0 ? void 0 : _this_onStreamClientMutedSubscription.dispose(), this.stream = null, this.isActive = !1;
                }
                constructor(g, f, S, v, _, C, E){
                    super(), this.mediaConnection = g, this.contextStream = S, this.logger = v, this.configProvider = _, this.encStreamsManager = C, this.capabilitiesManager = E, this.isActive = !1, this.isMuted = !1, this.stream = f.clone("streamSender ctor"), this.subscribeOnStreamClientMuted(), this.capabilitiesManager.updateStream(this.stream);
                }
            }, mA = class _SimulcastStreamSender extends Bt {
                async start() {
                    this.state.setState("Started") && (this.sender = new pA(this.mediaConnection, this.mainStream, this.contextStream, this.logger.createChild("Sender"), this.configProvider, this.encStreamsManager, this.getCapabilitiesManager(this.simulcastContext)), await this.sender.init(), this.notifyMaxVideoSendCapabilitiesChanged(), this.configProvider.config.deactiveAudioSender && "Audio" === this.mediaType && (this.logger.safe.info("start(): Deactivating audio sender"), await this.sender.stop()), this.sender.on("onNewStreamNeeded", ()=>{
                        this.logger.safe.info("onNewStreamNeeded"), this.event("onNewStreamNeeded").raise();
                    }));
                }
                async activate() {
                    if (this.state.setState("Active") && (this.pendingStream && (this.logger.safe.info("activate(): updating from pendingStream"), await this.updateStreamInternal(this.pendingStream), this.pendingStream = null), this.isAlwaysActive && !this.isMuted && "Audio" === this.mediaType && (this.logger.safe.info("activate(): starting sender"), await this.sender.start()), this.isAlwaysActive ? (this.event("onSendersChanged").raise(this, !0), this.logger.safe.info("Sender set to always active")) : this.configProvider.config.disableSendersTroughSetParameters || await this.sender.stop(), this.configProvider.config.enableCachingFMTP && this.pendingParams)) {
                        const updateParams = async ()=>{
                            this.configProvider.config.enableCachingFMTPDelay > 0 && (this.logger.safe.info("Applying delay before applying pending parameters"), await delay(this.configProvider.config.enableCachingFMTPDelay)), this.logger.safe.info("Apply pending parameters");
                            const g = this.updateParametersInternal(this.pendingParams);
                            return this.pendingParams = null, g;
                        };
                        this.configProvider.config.enableCachingFMTPAwait ? (this.logger.safe.info("Apply pending parameters"), await updateParams()) : (this.logger.safe.info("Apply pending parameters in background"), updateParams().catch((g)=>this.logger.safe.error("Error applying pending parameters", g)));
                    }
                }
                updateStream(g) {
                    return this.updateStreamInternal(g);
                }
                async addAdditionalStream(g) {
                    return this.sender.addAdditionalStream(g);
                }
                async updateParameters(g) {
                    if (this.state.isCurrentStateMatchedWith("Active")) return this.updateParametersInternal(g);
                    this.configProvider.config.enableCachingFMTP ? (this.logger.safe.info("Postpone params update until sender is activated"), this.pendingParams = g) : this.logger.safe.warn("Ignore params update as sender is not activated");
                }
                async terminateAsync() {
                    this.state.setState("Disposed") && (this.logger.safe.info("Terminating async"), await this.sender.terminateAsync(), this.cleanUp());
                }
                dispose() {
                    this.state.setState("Disposed") && (this.logger.safe.info("Disposing"), this.sender.dispose(), this.cleanUp());
                }
                async setHold(g, f) {
                    if (this.isHold !== g) return this.logger.safe.info(`[${f}] Setting hold to: ${g}`), this.isHold = g, this.sender.setHold(g, f);
                    this.logger.safe.info(`[${f}] Already in hold=${g} state`);
                }
                setMuted(g, f, S) {
                    this.logger.safe.info(`[${f}] Setting muted to: ${g}`), this.isMuted = g, this.sender.setMuted(this.isMuted, f, S), !this.isMuted && "Audio" === this.mediaType && this.state.isCurrentStateMatchedWith("Active") && this.sender.start();
                }
                getActiveStreamIndexes() {
                    return this.sender ? this.sender.getActiveStreamIndexes() : [];
                }
                getTrackInfo() {
                    return {
                        modality: mediaTypeToModality(this.mediaType),
                        trackId: this.sender.trackId
                    };
                }
                applyCallConstraints(g) {
                    if (this.configProvider.config.maxCameraFsViaCallConstraints && -1 !== this.configProvider.config.maxCameraFsViaCallConstraints) {
                        const f = Math.ceil(this.mainStream.getResolution().width / Gt.MACROBLOCK_SIZE) * Math.ceil(this.mainStream.getResolution().height / Gt.MACROBLOCK_SIZE);
                        f < this.configProvider.config.webrtcCameraOpenFs && (this.logger.safe.info(`[${g}] Applying call constraints, current resolution: ${f}\n                    asking for: ${this.configProvider.config.webrtcCameraOpenFs}`), this.event("onNewStreamNeeded").raise());
                    }
                    return this.sender.applyCallConstraints(g);
                }
                getCapabilitiesManager(g) {
                    return (g === null || g === void 0 ? void 0 : g.shouldUseSimulcast()) ? new dA(g.config, this.configProvider, this.logger.createChild("SimCapMgrV2")) : new uA(this.configProvider, this.logger.createChild("SnglCapMgrV2"));
                }
                async updateStreamInternal(g) {
                    return this.logger.info(`updateStreamInternal(): id: ${g.id}, parentId: ${g.parentId}), mediaType: ${this.mediaType}`), this.state.isCurrentStateMatchedWith("Active") ? this.mainStream !== g ? (this.logger.safe.debug(`Switching streams: ${this.mainStream.parentId}:${this.mainStream.id} -> ${g.parentId}:${g.id}`), this.unsubscribeFromQualityEvents(), this.mainStream.dispose(), this.mainStream = g, this.subscribeOnQualityUpdates(this.mainStream), this.notifyMaxVideoSendCapabilitiesChanged(), await this.sender.setMainStream(this.mainStream), this.logger.debug(`track info after stream update: ${JSON.stringify(this.getTrackInfo())}`), this.sender.updateStreamQualityParams(this.mainStream.getResolution(), this.mainStream.getFrameRate(), 1)) : void this.logger.safe.info("Stream has not been changed. Skipping update") : (this.logger.safe.info("Postponing stream update until sender is activated"), void this.setPendingStream(g));
                }
                async updateParametersInternal(g) {
                    await this.sender.setCapabilities(g), compareArraysBy(this.previousParameters, g, (g, f)=>g.ssrc === f.ssrc) || (this.previousParameters = g, this.event("onSendersChanged").raise(this, !0));
                }
                setPendingStream(g) {
                    this.pendingStream = g;
                    const f = g.on("onStreamClientDisposing", ()=>{
                        this.pendingStream === g && (this.pendingStream = null, f.dispose());
                    });
                }
                subscribeOnQualityUpdates(g) {
                    this.sub = g.on("onStreamQualityChanged", (g, f, S, v)=>this.updateStreamQualityParams(f, S, v));
                }
                updateStreamQualityParams(g, f, S) {
                    return S === or.EffectQualityChangeReason.Performance && this.notifyMaxVideoSendCapabilitiesChanged({
                        resolution: g,
                        fps: f
                    }), this.sender.updateStreamQualityParams(g, f, 2);
                }
                unsubscribeFromQualityEvents() {
                    var _this_sub;
                    (_this_sub = this.sub) === null || _this_sub === void 0 ? void 0 : _this_sub.dispose(), this.sub = null;
                }
                notifyMaxVideoSendCapabilitiesChanged(g) {
                    if (![
                        "Video",
                        "ScreenShare"
                    ].includes(this.mediaType)) return;
                    var _g_resolution, _g_fps;
                    const { width: f, height: S } = (_g_resolution = g === null || g === void 0 ? void 0 : g.resolution) !== null && _g_resolution !== void 0 ? _g_resolution : this.mainStream.getResolution(), v = (_g_fps = g === null || g === void 0 ? void 0 : g.fps) !== null && _g_fps !== void 0 ? _g_fps : this.mainStream.getFrameRate();
                    if (!f || !S || !v) return;
                    const _ = new Qt(f, S), C = {
                        maxFs: _.fs,
                        maxMbps: _.fs * v,
                        maxFps: v,
                        maxWidth: _.width,
                        maxHeight: _.height
                    };
                    this.logger.safe.info(`Capabilities for ${this.mediaType} stream: ${JSON.stringify(C)}`), this.event("onMaxVideoSendCapabilitiesChanged").raise(C);
                }
                cleanUp() {
                    this.unsubscribeFromQualityEvents(), this.mainStream.dispose(), this.mainStream = null, this.pendingStream && this.pendingStream.dispose(), this.pendingStream = null, this.sender = null, this.contextStream = null, this.event("onSendersChanged").raise(this, !1), super.dispose();
                }
                constructor(g, f, S, v, _, C, E, T, I, b){
                    super(), this.mediaConnection = g, this.mainStream = f, this.contextStream = S, this.mediaType = v, this.serialQueue = _, this.logger = C, this.configProvider = E, this.isAlwaysActive = T, this.encStreamsManager = I, this.simulcastContext = b, this.isMuted = !1, this.isHold = !1, this.previousParameters = [], this.state = new hA(_SimulcastStreamSender.transitionStates, "NotStarted", this.logger.createChild("state")), this.pendingStream = null, this.pendingParams = null, this.subscribeOnQualityUpdates(this.mainStream);
                }
            };
            mA.transitionStates = {
                NotStarted: [
                    "Started",
                    "Disposed"
                ],
                Started: [
                    "Active",
                    "Disposed"
                ],
                Active: [
                    "NotStarted",
                    "Disposed"
                ],
                Disposed: []
            }, __decorateClass([
                sequentialize()
            ], mA.prototype, "start", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "activate", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "updateStream", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "addAdditionalStream", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "updateParameters", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "terminateAsync", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "setHold", 1), __decorateClass([
                sequentialize()
            ], mA.prototype, "updateStreamQualityParams", 1);
            var fA = mA, SA = class {
                track(g, f) {
                    void 0 === this.signals[g] && (this.signals[g] = {
                        wasNotified: !1
                    }), this.signals[g].currentTime = Kt(), !!this.signals[g].currentState != !!f && (this.signals[g].currentState = f, this.signals[g].lastChanged = this.signals[g].currentTime, this.signals[g].wasNotified = !1);
                }
                update(g) {
                    const f = [];
                    for (const f of Object.keys(g))void 0 === this.signals[f] && (this.signals[f] = {
                        wasNotified: !1
                    });
                    for (const f of Object.keys(this.signals))this.track(f, g[f]);
                    for(const g in this.signals){
                        const S = this.signals[g];
                        if (void 0 !== S.currentState) {
                            if (S.wasNotified) continue;
                            S.currentTime - S.lastChanged >= this.durationThreshold && (S.wasNotified = !0, f.push(S.currentState));
                        }
                    }
                    return f;
                }
                constructor(g){
                    this.durationThreshold = g, this.signals = {};
                }
            }, vA = class extends Bt {
                key(g, f) {
                    return `${g.rid}:${f}`;
                }
                suspend(g) {
                    g > 0 && (this.logger.safe.info(`Suspending for ${(g / 1e3).toFixed(1)} seconds`), this.timeout = Kt() + g);
                }
                acceptLayout(g) {
                    if (g.some((g)=>void 0 === g.rid)) return this.logger.safe.info("Ignore layout with missing RID"), !1;
                    if (this.caps) {
                        if (Math.max(0, ...g.map((g)=>g.maxFs)) > this.caps.maxFs) return this.logger.safe.info("Ignore layout update while waiting for maxCapabilities to propagate to server"), !1;
                    }
                    return !0;
                }
                resetLayout() {
                    this.signals.update({}), this.layout = void 0;
                }
                updateMaxCapabilities(g) {
                    var _this_layout;
                    this.logger.safe.info(`Max capabilities updated: ${JSON.stringify(g)}`), this.caps && g.maxFs < this.caps.maxFs && ((_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.length) > 0 && (this.logger.safe.info("Stop monitoring current layout as maxFS will be reduced"), this.resetLayout()), this.caps = g;
                }
                updateLayout(g) {
                    if ((g || this.layout) && this.logger.safe.info(`New layout: ${JSON.stringify(g)}`), g && this.acceptLayout(g)) {
                        var _this_layout;
                        if ((g = g.map((g)=>Object.assign({}, g))).sort((g, f)=>g.maxFs === f.maxFs ? g.maxFps === f.maxFps ? g.maxBr - f.maxBr : g.maxFps - f.maxFps : g.maxFs - f.maxFs), (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.length) for(let f = 0; f < (g === null || g === void 0 ? void 0 : g.length); ++f){
                            const S = g[f], v = this.layout.find((g)=>g.rid === S.rid);
                            v && v.maxFs !== S.maxFs && (this.logger.safe.info(`Reset '${this.key(v, "FS")}'`), this.signals.track(this.key(v, "FS"), void 0));
                        }
                        this.layout = g, -1 === this.timeout && (this.timeout = 0, this.logger.safe.info("Starting performance monitor"), this.suspend(this.config.startupDelay));
                    } else this.resetLayout(), this.timeout = -1;
                }
                onMitigationApplied() {
                    this.logger.safe.info("Mitigation was applied - resetting current layout"), this.resetLayout(), this.suspend(this.config.mitigationTimeout);
                }
                monitor(g) {
                    const f = {};
                    let S = 0;
                    if (!this.layout || this.layout.length < 1 || g.length < this.layout.length || this.timeout > Kt()) return void this.signals.update(f);
                    for(this.timeout > 0 && (this.logger.safe.info("Resuming"), this.timeout = 0), S = 0; S < this.layout.length; ++S){
                        const v = this.layout[S], _ = g.find((g)=>g.rid === v.rid);
                        if (_) {
                            const g = Math.ceil(_.frameWidth / Gt.MACROBLOCK_SIZE) * Math.ceil(_.frameHeight / Gt.MACROBLOCK_SIZE);
                            if (this.config.monitorQualityLimitationReasons) {
                                const g = _.qualityLimitationReason;
                                -1 !== this.config.monitorQualityLimitationReasons.indexOf(`${g}`) && (f[this.key(v, "QL")] = {
                                    layout: v,
                                    type: "QL",
                                    expected: "none",
                                    actual: g
                                });
                            }
                            this.config.monitorMaxFS && g < v.maxFs && (f[this.key(v, "FS")] = {
                                layout: v,
                                type: "FS",
                                expected: v.maxFs,
                                actual: g
                            });
                        }
                    }
                    const v = this.signals.update(f).map((g)=>{
                        var _this_layout;
                        const f = Object.assign({}, g);
                        var _this_layout_find;
                        return f.layout = (_this_layout_find = (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.find((g)=>g.rid === f.layout.rid)) !== null && _this_layout_find !== void 0 ? _this_layout_find : f.layout, f;
                    });
                    v.length && (this.logger.safe.info(`Raise event: ${JSON.stringify(v)}`), this.event("onVideoQualityDegraded").raise(v));
                }
                constructor(g, f){
                    var _f_performanceMonitor, _f_performanceMonitor1, _f_performanceMonitor_mitigation, _f_performanceMonitor2, _f_performanceMonitor3;
                    var _f_performanceMonitor_durationThreshold;
                    super(), this.logger = g, this.timeout = -1, this.signals = new SA((_f_performanceMonitor_durationThreshold = f.performanceMonitor.durationThreshold) !== null && _f_performanceMonitor_durationThreshold !== void 0 ? _f_performanceMonitor_durationThreshold : 3e3), this.config = {
                        monitorQualityLimitationReasons: (_f_performanceMonitor = f.performanceMonitor) === null || _f_performanceMonitor === void 0 ? void 0 : _f_performanceMonitor.monitorQualityLimitationReasons,
                        monitorMaxFS: (_f_performanceMonitor1 = f.performanceMonitor) === null || _f_performanceMonitor1 === void 0 ? void 0 : _f_performanceMonitor1.monitorMaxFS,
                        mitigationTimeout: (_f_performanceMonitor2 = f.performanceMonitor) === null || _f_performanceMonitor2 === void 0 ? void 0 : (_f_performanceMonitor_mitigation = _f_performanceMonitor2.mitigation) === null || _f_performanceMonitor_mitigation === void 0 ? void 0 : _f_performanceMonitor_mitigation.timeout,
                        startupDelay: (_f_performanceMonitor3 = f.performanceMonitor) === null || _f_performanceMonitor3 === void 0 ? void 0 : _f_performanceMonitor3.startupDelay
                    };
                }
            }, _A = class extends Bt {
                hasSoftwareEncodedVideoAndSharing() {
                    return !this.videoFeatureManager.get("Video").hasClientSupport(1) && !this.videoFeatureManager.get("ScreenShare").hasClientSupport(1) && this.hasActiveSenders("Video", "ScreenShare");
                }
                hasActiveSenders(...g) {
                    return g.every((g)=>this.activeModalities.has(g));
                }
                getAdaptationInfo(g, f) {
                    return {
                        description: g,
                        activeModalities: [
                            ...this.activeModalities
                        ],
                        isTransient: f && this.config.allowReversals
                    };
                }
                notify(g) {
                    this.logger.safe.warn(`${g.description} activeModalities: ${g.activeModalities.join("/")} isTansient: ${g.isTransient}`), this.diagnostics.registerLocalVideoPerformanceEvent(g);
                }
                schedule(g, f, S) {
                    this.callbacks.push({
                        mediaType: g,
                        state: f,
                        callback: S
                    });
                }
                override(g, f, S) {
                    this.configProvider.config[g] = f, this.logger.safe.info(`Overwriting ${g} with ${this.configProvider.config[g]}. Reason: ${S}`);
                }
                disable1080pSoftwareEncode(g) {
                    const f = this.videoFeatureManager.get("Video");
                    if (!g.find((g)=>g.maxFs === Gt.MAX_FS_1080P)) return !1;
                    if (!f.hasClientSupport(2)) return !1;
                    if (f.hasClientSupport(1)) return !1;
                    if (1 === g.length && !this.config.allowDisabling1080pSinglecast) return this.logger.safe.info("Will not disable 1080p for singlecast"), !1;
                    if (g.length > 1 && !this.config.allowDisabling1080pSimulcast) return this.logger.safe.info("Will not disable 1080p for simulcast"), !1;
                    const S = this.configProvider.config.performanceFallbackMaxFsFor1080pSend, v = {}, _ = {
                        webrtcCameraOpenFs: this.configProvider.config.webrtcCameraOpenFs,
                        maxCameraFsViaCallConstraints: this.configProvider.config.maxCameraFsViaCallConstraints,
                        webrtcVideoCapabilityMaxFS: this.configProvider.config.webrtcVideoCapabilityMaxFS
                    };
                    for(const g in _)_[g] > 0 && (v[g] = Math.min(S, _[g]));
                    const C = Object.keys(v);
                    if (C.some((g)=>_[g] !== v[g])) {
                        C.forEach((g)=>{
                            this.override(g, v[g], "mitigating 1080p performance issues");
                        }), this.sessionConfig.outgoingVideoMaxFS = v.webrtcCameraOpenFs, this.event("onNewStreamNeeded").raise();
                        const g = this.getAdaptationInfo("Disabled software 1080p", this.hasSoftwareEncodedVideoAndSharing());
                        return g.isTransient && this.schedule("ScreenShare", !1, ()=>{
                            C.forEach((g)=>{
                                this.override(g, _[g], "removing mitigation for 1080p performance issues");
                            }), this.sessionConfig.outgoingVideoMaxFS = void 0, this.event("onNewStreamNeeded").raise(), this.notify(this.getAdaptationInfo("Re-enabled software 1080p", !0));
                        }), this.notify(g), !0;
                    }
                    return !1;
                }
                disableThreeStreamSimulcast(g) {
                    const f = this.videoFeatureManager.get("Video");
                    if (3 !== g.length) return !1;
                    if (!this.config.allowDisablingThreeStreamSimulcast) return this.logger.safe.info("Will not disable 3-stream simulcast"), !1;
                    if (f.hasClientSupport(1)) return !1;
                    if (f.hasFullSupport(0)) {
                        const g = this.getAdaptationInfo("Disabled 3-stream simulcast", this.hasSoftwareEncodedVideoAndSharing());
                        return f.toggleClient(0, !1), g.isTransient && this.schedule("ScreenShare", !1, ()=>{
                            f.toggleClient(0, !0), this.notify(this.getAdaptationInfo("Re-enabled Three stream simulcast", !0));
                        }), this.notify(g), !0;
                    }
                    return !1;
                }
                updateSenderState(g, f) {
                    if (f === this.activeModalities.has(g)) return;
                    f ? this.activeModalities.add(g) : this.activeModalities.delete(g);
                    const S = this.callbacks.filter((S)=>S.mediaType === g && S.state === f);
                    this.callbacks = this.callbacks.filter((S)=>S.mediaType !== g || S.state !== f);
                    for (const g of S)g.callback();
                }
                mitigatePerformanceIssue(g) {
                    return !!this.disable1080pSoftwareEncode(g) || !!this.disableThreeStreamSimulcast(g);
                }
                constructor(g, f, S, v, _){
                    var _this_configProvider_config_specCompliantSimulcast_performanceMonitor, _this_configProvider_config_specCompliantSimulcast;
                    super(g), this.logger = g, this.configProvider = f, this.sessionConfig = S, this.diagnostics = v, this.videoFeatureManager = _, this.activeModalities = new Set, this.callbacks = [];
                    var _this_configProvider_config_specCompliantSimulcast_performanceMonitor_mitigation;
                    const C = (_this_configProvider_config_specCompliantSimulcast_performanceMonitor_mitigation = (_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : (_this_configProvider_config_specCompliantSimulcast_performanceMonitor = _this_configProvider_config_specCompliantSimulcast.performanceMonitor) === null || _this_configProvider_config_specCompliantSimulcast_performanceMonitor === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast_performanceMonitor.mitigation) !== null && _this_configProvider_config_specCompliantSimulcast_performanceMonitor_mitigation !== void 0 ? _this_configProvider_config_specCompliantSimulcast_performanceMonitor_mitigation : {};
                    this.config = {
                        allowDisabling1080pSinglecast: C.enableFor1080pSinglecast,
                        allowDisabling1080pSimulcast: C.enableFor1080pSimulcast,
                        allowDisablingThreeStreamSimulcast: C.enableForThreeStreamSimulcast,
                        allowReversals: C.enableReversals
                    };
                }
            }, CA = class extends Bt {
                dispose() {
                    var _this_mediaQualityController;
                    this.senders.forEach((g, f)=>{
                        this.event("onSendStreamChanged").raise(null, f), this.configProvider.config.disposeSendersSync ? g.dispose() : g.terminateAsync();
                    }), this.senders.clear(), this.senderSubs.forEach((g)=>g.forEach((g)=>g.dispose())), this.senderSubs.clear(), this.streamProviderSubscriptions.forEach((g)=>g.dispose()), this.streamProviderSubscriptions = [], this.configProvider.config.disposeStreamsSync ? this.streamsProvider.stop() : this.streamsProvider.stopAsync(), this.localVideoStreamWatcherSub.dispose(), this.localVideoStreamWatcher.dispose(), this.logger = this.logger.createChild("DISPOSED"), (_this_mediaQualityController = this.mediaQualityController) === null || _this_mediaQualityController === void 0 ? void 0 : _this_mediaQualityController.dispose(), super.dispose();
                }
                registerRtpSenderManager(g) {
                    this.logger.safe.debug(`Registering RTP sender manager ${g}`), this.mediaConnection = g;
                }
                useNullAudioStreamClient() {
                    this.logger.safe.debug("Using null audio stream client"), this.streamsProvider.useNullAudioStreamClient();
                }
                get pendingStreamsPromise() {
                    return this.streamsPromise;
                }
                clearStreamsPromise() {
                    this.streamsPromise = void 0;
                }
                async update(g, f, S, v) {
                    v === null || v === void 0 ? void 0 : v.mark("startUpdateStreams");
                    let _ = getSendStreamModalities(g, this.configProvider.config.streamModalitiesExcludeData);
                    const C = 0 != (1 & f), E = 0 != (2 & f), T = 0 != (4 & f);
                    T && (_ = {
                        Audio: !0,
                        Video: !1,
                        Data: !1,
                        ScreenShare: !1
                    });
                    const I = T ? Promise.resolve(_) : this.streamsProvider.update(_, C);
                    let b, A;
                    return E || T ? (delete _.Data, b = shallowClone(_), A = C ? void 0 : b) : (b = await I, A = b), this.logger.safe.info(`[${S}] Streams updated, modalities requested: ${JSON.stringify(_)} (flags: ${f}), result: ${JSON.stringify(b)}`), v === null || v === void 0 ? void 0 : v.markAndMeasure("startUpdateStreams", "updateStreamsWithModalities"), await this.updateSenders(A, S), v === null || v === void 0 ? void 0 : v.markAndMeasure("updateStreamsWithModalities", "updateSenders"), E && (this.streamsPromise = (async ()=>{
                        const f = await I;
                        return this.streamsPromise = void 0, await this.updateSenders(f, S), this.setAndUpdateLocalTracksInfo(!1), this.mergeAndSaveModalities(f, g);
                    })()), this.applyMuteState(S, !0), this.setAndUpdateLocalTracksInfo(!1), this.mergeAndSaveModalities(b, g);
                }
                mergeAndSaveModalities(g, f) {
                    this.previousMediaModalities = shallowClone(g);
                    const S = shallowClone(f);
                    return forOwn(f, (f, v)=>{
                        const _ = modalityToMediaType(v);
                        hasSendDirectionality(f) && !g[_] && (S[v] = removeSendDirectionality(f));
                    }), S;
                }
                async activate(g) {
                    this.logger.safe.info(`[${g}] activate senders`), await Promise.all([
                        ...this.senders.values()
                    ].map(async (g)=>g.activate())), this.setAndUpdateLocalTracksInfo(!1);
                }
                applyCallConstraints(g) {
                    const f = this.senders.get("Video");
                    return f ? f.applyCallConstraints(g) : (this.logger.info(`[${g}] Caching call constraints until sender is created`), this.callConstraintsCauseId = g, this.applyCallConstraintsDeferred = new ct, this.applyCallConstraintsDeferred.promise);
                }
                async applyCapabilities(g, f, S) {
                    var _this_simulcastPerformanceAdaptationManager;
                    this.logger.safe.info(`[${g}] Applying incoming ${f} FMTP: ${JSON.stringify(S)}`);
                    const v = modalityToMediaType(f);
                    this.lastCauseId = g;
                    let _ = S;
                    return this.mediaQualityController && (this.mediaQualityController.addReceiver(v, S), _ = this.mediaQualityController.getLayouts(v)), (_this_simulcastPerformanceAdaptationManager = this.simulcastPerformanceAdaptationManager) === null || _this_simulcastPerformanceAdaptationManager === void 0 ? void 0 : _this_simulcastPerformanceAdaptationManager.updateSenderState(v, !0), this.updateParameters(g, v, _);
                }
                getLocalMediaSources() {
                    const g = this.getTracksInfo(), f = [];
                    return g.forEach((g)=>{
                        f.some((f)=>f.modality === g.modality) || f.push({
                            sourceId: this.getSourceIdForTrack(g),
                            modality: g.modality
                        });
                    }), f;
                }
                setMuted(g, f, S) {
                    this.muted.set(g, f), this.applyMuteState(S, !1);
                }
                async setHold(g, f) {
                    await Promise.all([
                        ...this.senders.values()
                    ].map(async (S)=>S.setHold(g, f)));
                }
                onStatisticsChanged(g) {
                    var _this_mediaQualityController;
                    this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation || ((_this_mediaQualityController = this.mediaQualityController) === null || _this_mediaQualityController === void 0 ? void 0 : _this_mediaQualityController.onStatisticsChanged(g)), this.configProvider.config.diagnostics.features.useNewStatsForLocalVideoStreamWatcher || this.localVideoStreamWatcher.onStatisticsChanged(g);
                }
                onDiagnosticUpdated(g) {
                    var _this_mediaQualityController;
                    this.configProvider.config.diagnostics.features.useNewSendBandwidthCalculation && ((_this_mediaQualityController = this.mediaQualityController) === null || _this_mediaQualityController === void 0 ? void 0 : _this_mediaQualityController.onDiagnosticUpdated(g)), this.configProvider.config.diagnostics.features.useNewStatsForLocalVideoStreamWatcher && this.localVideoStreamWatcher.onDiagnosticUpdated(g);
                }
                async updateParameters(g, f, S) {
                    try {
                        const v = this.senders.get(f);
                        v ? await v.updateParameters(S) : this.logger.safe.info(`[${this.lastCauseId}] Capabilities ignored ${JSON.stringify(S)}, no ${JSON.stringify(f)} sender`), this.logger.safe.debug(`[${g}] Capabilities completed`);
                        const _ = {
                            modality: mediaTypeToModality(f),
                            causeId: g,
                            capabilities: S
                        };
                        this.statisticsGatherer.onMaxCapabilitiesApplied(_), this.qmDiagnostics.onMaxCapabilitiesApplied(_);
                    } catch (v) {
                        const _ = stringifyObject(v);
                        this.logger.safe.error(`[${g}] Error applying capabilities ${_}`);
                        const C = {
                            modality: mediaTypeToModality(f),
                            causeId: g,
                            capabilities: S,
                            error: _
                        };
                        this.statisticsGatherer.onMaxCapabilitiesApplied(C), this.qmDiagnostics.onMaxCapabilitiesApplied(C);
                    }
                }
                applyMuteState(g, f) {
                    for (const [S, v] of this.muted)this.senders.get(S) && this.senders.get(S).setMuted(v, g, f);
                }
                setAndUpdateLocalTracksInfo(g) {
                    const f = this.getTracksInfo();
                    this.logger.safe.debug(`Local tracks info: ${JSON.stringify(f)}`), this.mediaManager.setLocalTracksInfo(f), g && (this.mediaManager.updateMediaEntitiesWithLocalTracks(), this.configProvider.config.mapSsrcToTrackForStats && this.statisticsGatherer.updateStatsWithLocalSsrcTrackInfo());
                }
                getTracksInfo() {
                    const g = [];
                    return this.senders.forEach((f)=>g.push(f.getTrackInfo())), g;
                }
                async updateSenders(g, f = generateCauseId()) {
                    await this.streamsProvider.ensureUpdateCompleted();
                    const S = g || sendStreamsToModalities(this.streamsProvider.streams);
                    this.logger.safe.info(`[${f}] Updating senders with modalities: ${JSON.stringify(S)}, override: ${!!g}`), await Promise.all(keys(S).map(async (g)=>{
                        var _this_streamsProvider_streams;
                        const v = S[g];
                        if (v === this.previousMediaModalities[g]) return;
                        if (!v) return this.logger.safe.info(`[${f}] Removing sender for ${JSON.stringify(g)}`), void await this.removeSender(g);
                        const _ = (_this_streamsProvider_streams = this.streamsProvider.streams) === null || _this_streamsProvider_streams === void 0 ? void 0 : _this_streamsProvider_streams[g];
                        if (await this.createAndStartSender(_, g), this.logger.safe.info(`[${f}] Sender for ${JSON.stringify(g)} is added`), this.applyCallConstraintsDeferred && "Video" === g) {
                            const g = this.senders.get("Video");
                            try {
                                await g.applyCallConstraints(this.callConstraintsCauseId), this.applyCallConstraintsDeferred.resolve();
                            } catch (g) {
                                this.applyCallConstraintsDeferred.reject(g);
                            }
                            this.applyCallConstraintsDeferred = void 0, this.callConstraintsCauseId = void 0;
                        }
                        await this.addAudioSharingStream(_), this.event("onSendStreamChanged").raise(_, g);
                    })), this.logger.safe.info(`[${f}] Senders updated. Enabled: ${JSON.stringify(Object.keys(S).filter((g)=>S[g]))}`);
                }
                createAndStartSender(g, f) {
                    var _this_configProvider_config_specCompliantSimulcast;
                    if (this.senders.get(f)) return this.logger.safe.error(`Sender already created, modality: ${JSON.stringify(f)}`), this.senders.get(f).start();
                    const S = this.mediaManager.getMediaEntitiesByModality(mediaTypeToModality(f))[0], v = S === null || S === void 0 ? void 0 : S.getSimulcastContext(), _ = !((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.disableTilde) && !!(v === null || v === void 0 ? void 0 : v.shouldUseSimulcast()), C = "Audio" === f || !this.isMultiparty || _, E = new fA(this.mediaConnection, g || new Hb(f, this.logger.createChild("tempStream")), new MediaStream, f, this.serialQueue, this.logger.createChild(`Sender_${JSON.stringify(f)}:${this.senderId++}`), this.configProvider, C, this.encStreamsManager, v);
                    this.senders.set(f, E);
                    const T = [
                        E.on("onSendersChanged", (g, f)=>this.onSenderStateChanged(g, f)),
                        E.on("onNewStreamNeeded", ()=>this.streamsProvider.requestStreamUpdate(f, !0)),
                        E.on("onMaxVideoSendCapabilitiesChanged", (g)=>{
                            this.event("onMaxVideoSendCapabilitiesChanged").raise(f, g), "Video" === f && this.simulcastPerformanceMonitor && this.simulcastPerformanceMonitor.updateMaxCapabilities(g);
                        })
                    ];
                    return this.senderSubs.set(E, T), E.start();
                }
                async removeSender(g) {
                    var _this_mediaQualityController, _this_simulcastPerformanceAdaptationManager;
                    const f = this.senders.get(g);
                    f && (this.senders.delete(g), this.event("onSendStreamChanged").raise(null, g), await f.terminateAsync(), this.senderSubs.get(f).forEach((g)=>g.dispose()), this.senderSubs.delete(f), this.logger.safe.info(`Removed sender with mediaType: ${JSON.stringify(g)}`)), (_this_mediaQualityController = this.mediaQualityController) === null || _this_mediaQualityController === void 0 ? void 0 : _this_mediaQualityController.removeReceiver(g), (_this_simulcastPerformanceAdaptationManager = this.simulcastPerformanceAdaptationManager) === null || _this_simulcastPerformanceAdaptationManager === void 0 ? void 0 : _this_simulcastPerformanceAdaptationManager.updateSenderState(g, !1), "Video" === g && this.simulcastPerformanceMonitor && this.simulcastPerformanceMonitor.updateLayout(void 0);
                }
                getSourceIdForTrack(g) {
                    const f = g.trackId, S = this.mediaManager.getMediaEntityByLocalTrackId(f);
                    return S ? (this.logger.safe.info(`Media entity found: ${JSON.stringify(S.getXSourceStreamId())}`), S.getXSourceStreamId()) : (this.logger.safe.error(`Media entity is not found for stream: ${JSON.stringify(f)}`), 0);
                }
                onVideoCaptureFreeze(g, f) {
                    g || (f ? this.qmDiagnostics.registerWebcamFreeze() : this.qmDiagnostics.registerProcessedStreamFreeze()), this.event("onVideoCaptureFreeze").raise(g);
                }
                onVideoQualityDegraded(g) {
                    var _this_mediaQualityController;
                    var _this_mediaQualityController_getLayouts;
                    const f = (_this_mediaQualityController_getLayouts = (_this_mediaQualityController = this.mediaQualityController) === null || _this_mediaQualityController === void 0 ? void 0 : _this_mediaQualityController.getLayouts("Video")) !== null && _this_mediaQualityController_getLayouts !== void 0 ? _this_mediaQualityController_getLayouts : [];
                    let S = !1;
                    for (const v of g)if (this.logger.safe.warn(`rid:${v.layout.rid} ${v.type} degraded - expected: ${v.expected}, actual: ${v.actual}`), !S && this.simulcastPerformanceAdaptationManager) switch(v.type){
                        case "QL":
                            "cpu" === v.actual && (S = this.simulcastPerformanceAdaptationManager.mitigatePerformanceIssue(f));
                            break;
                        case "FS":
                            "1" === v.layout.rid && (S = this.simulcastPerformanceAdaptationManager.mitigatePerformanceIssue(f));
                    }
                    S && this.simulcastPerformanceMonitor && this.simulcastPerformanceMonitor.onMitigationApplied();
                }
                async onStreamUpdated(g, f) {
                    if (!this.senders.has(g)) return void this.logger.safe.warn(`Sender with media type ${g} does not exist, do not update media stream`);
                    let S = this.streamsProvider.streams[g];
                    if (S || (this.logger.safe.info(`Stream is missing for mediaType: ${g}, using fake stream...`), S = new Hb(g, this.logger.createChild("NullStreamClient"))), S.isDisposed()) return void this.logger.safe.info(`Stream is already disposed for mediaType: ${g}`);
                    this.event("onSendStreamChanged").raise(S, g);
                    const v = this.senders.get(g);
                    await this.addAudioSharingStream(S), await v.updateStream(S), this.logger.safe.debug(`Stream updated for mediaType: ${g}, updated: ${f}`), this.setAndUpdateLocalTracksInfo(f);
                }
                onSenderStateChanged(g, f) {
                    if (this.mediaManager.updateMediaEntitiesWithActivityState(g.mediaType, g.getActiveStreamIndexes()), this.statisticsGatherer.onSendersChanged(g.mediaType, f), "Video" === g.mediaType) {
                        if (f) {
                            const g = this.getTracksInfo().filter((g)=>g.modality === Gt.MODALITY.video);
                            this.localVideoStreamWatcher.startWatching(g, this.simulcastPerformanceMonitor);
                        } else this.localVideoStreamWatcher.stopWatching();
                    }
                }
                async addAudioSharingStream(g) {
                    var _this_senders_get;
                    "ScreenShare" === (g === null || g === void 0 ? void 0 : g.mediaType) && (g === null || g === void 0 ? void 0 : g.hasAudio()) && (this.logger.safe.info("Adding audio stream from sharing to audio sender"), await ((_this_senders_get = this.senders.get("Audio")) === null || _this_senders_get === void 0 ? void 0 : _this_senders_get.addAdditionalStream(g)));
                }
                constructor(g, f, S, v, _, C, E, T, I, b, A){
                    var _this_configProvider_config_specCompliantSimulcast, _this_configProvider_config_specCompliantSimulcast_performanceMonitor, _this_configProvider_config_specCompliantSimulcast1;
                    super(f), this.mediaManager = g, this.logger = f, this.callDeviceManager = S, this.configProvider = v, this.sessionConfig = _, this.statisticsGatherer = C, this.diagnostics = E, this.qmDiagnostics = T, this.isMultiparty = I, this.encStreamsManager = b, this.videoFeatureManager = A, this.senders = new Map, this.senderSubs = new Map, this.senderId = 0, this.previousMediaModalities = {
                        Audio: !1,
                        Video: !1,
                        ScreenShare: !1
                    }, this.muted = new Map([
                        [
                            "Audio",
                            !1
                        ],
                        [
                            "Video",
                            !1
                        ]
                    ]), this.serialQueue = new q_(this.logger), this.streamsProvider = new jb(this.callDeviceManager, this.configProvider, this.sessionConfig, this.serialQueue, this.logger.createChild("StreamsProvider")), this.streamProviderSubscriptions = [
                        this.streamsProvider.on("onStreamAdded", (g)=>this.onStreamUpdated(g, !1)),
                        this.streamsProvider.on("onStreamUpdated", (g)=>this.onStreamUpdated(g, !0))
                    ], this.localVideoStreamWatcher = new Ab(this.logger, this.configProvider, this.callDeviceManager), this.localVideoStreamWatcherSub = this.localVideoStreamWatcher.on("onVideoCaptureFreeze", (g, f)=>this.onVideoCaptureFreeze(g, f)), this.configProvider.config.useMediaQualityController && (this.mediaQualityController = new sA(this.configProvider, this.logger.createChild("MQC"), this.videoFeatureManager), this.mediaQualityController.on("onLayoutsUpdated", (g)=>{
                        const f = this.mediaQualityController.getLayouts(g);
                        return this.logger.safe.debug(`Update layouts for ${g}: ${JSON.stringify(f)}`), "Video" === g && this.simulcastPerformanceMonitor && this.simulcastPerformanceMonitor.updateLayout(f), this.updateParameters(this.lastCauseId, g, f);
                    }), this.mediaQualityController.on("onBandwidthAllocationUpdated", (g)=>{
                        this.event("onBandwidthAllocationChanged").raise(g);
                    })), ((_this_configProvider_config_specCompliantSimulcast = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast.performanceMonitor) && (this.simulcastPerformanceMonitor = new vA(this.logger.createChild("SPM"), this.configProvider.config.specCompliantSimulcast), this.simulcastPerformanceMonitor.on("onVideoQualityDegraded", (g)=>this.onVideoQualityDegraded(g))), ((_this_configProvider_config_specCompliantSimulcast1 = this.configProvider.config.specCompliantSimulcast) === null || _this_configProvider_config_specCompliantSimulcast1 === void 0 ? void 0 : (_this_configProvider_config_specCompliantSimulcast_performanceMonitor = _this_configProvider_config_specCompliantSimulcast1.performanceMonitor) === null || _this_configProvider_config_specCompliantSimulcast_performanceMonitor === void 0 ? void 0 : _this_configProvider_config_specCompliantSimulcast_performanceMonitor.mitigation) && (this.simulcastPerformanceAdaptationManager = new _A(this.logger.createChild("SPAM"), this.configProvider, this.sessionConfig, this.diagnostics, this.videoFeatureManager), this.simulcastPerformanceAdaptationManager.on("onNewStreamNeeded", ()=>{
                        this.streamsProvider.requestStreamUpdate("Video", !0);
                    }));
                }
            };
            function getSendStreamModalities(g, f = !0) {
                const S = {
                    Audio: hasSendDirectionality(g.audio),
                    Video: hasSendDirectionality(g.video),
                    ScreenShare: hasSendDirectionality(g.sharing)
                };
                return f || (S.Data = hasSendDirectionality(g.data)), S;
            }
            var yA = class {
                get stream() {
                    return this.recvStream.getMediaStream();
                }
                dispose() {
                    this.unsubscribeFromStreamEvents(), this.receiveStreamCollection = null, this.mainTrack = null, this.recvStream.dispose();
                }
                getId() {
                    return this.recvStream.getId();
                }
                getModality() {
                    return this.recvStream.getModality();
                }
                getMsi() {
                    return this.recvStream.getMsi();
                }
                getMediaStream() {
                    return this.stream;
                }
                getReceiver() {
                    return this.recvStream.getReceiver();
                }
                requestSource(g) {
                    return this.recvStream.requestSource(g);
                }
                getSourceStreamId() {
                    return this.recvStream.getSourceStreamId();
                }
                getSubstreamIndex() {
                    return this.recvStream.getSubstreamIndex();
                }
                removeOtherTracks(g) {
                    if (this.settings.onAddTrackRemoveOtherTracks) this.stream.getTracks().forEach((f)=>{
                        f.id !== g.id && this.stream.removeTrack(f);
                    });
                }
                subscribeOnStreamEvents() {
                    const logEvent = (g)=>this.logger.safe.info(`${g} track: ${this.mainTrack.id}, stream: ${this.stream.id}`);
                    this.stream.onremovetrack = ()=>{
                        logEvent("onremovetrack"), this.receiveStreamCollection.remove(this.stream.id);
                    }, this.mainTrack.onended = ()=>{
                        logEvent("onended"), this.settings.removeRecvStreamOnEnded && this.receiveStreamCollection.remove(this.stream.id);
                    }, this.mainTrack.onmute = ()=>logEvent("onmute"), this.mainTrack.onunmute = ()=>logEvent("onunmute");
                }
                unsubscribeFromStreamEvents() {
                    this.stream.onremovetrack = null, this.mainTrack.onended = null, this.mainTrack.onmute = null, this.mainTrack.onunmute = null;
                }
                constructor(g, f, S, v, _){
                    this.recvStream = g, this.mainTrack = f, this.receiveStreamCollection = S, this.logger = v, this.settings = _, this.removeOtherTracks(f), this.subscribeOnStreamEvents();
                }
            }, EA = class {
                constructor(g){
                    this.startTimestamp = 0, this.totalTime = 0, this.lastActiveTime = 0, this.id = g;
                }
            }, TA = class {
                setSources(g = []) {
                    const f = g.map(this.getOrCreateSource.bind(this)), S = this.excludeSources(this.sources, f);
                    f.forEach((g)=>{
                        this.isAlreadyActive(g) || this.updateSourceTimestamp(g), this.updateSourceLastActiveTime(g);
                    }), S.forEach((g)=>{
                        this.updateTotalTime(g), this.resetStartTimestamp(g);
                    }), this.ping || (this.ping = this.setupTimer());
                }
                setOnDominantSpeakerChanged(g) {
                    this.callback = g;
                }
                dispose() {
                    this.clearTimer(), this.sources = null, this.callback = null;
                }
                excludeSources(g, f) {
                    return g.filter((g)=>!f.some((f)=>g.id === f.id));
                }
                trigger() {
                    if (!this.hasAnyoneSpoken()) return void this.clearTimer();
                    const byActivity = (g, f)=>f.totalTime - g.totalTime || f.lastActiveTime - g.lastActiveTime, toSourceId = (g)=>g.id, g = this.sources.map(this.updateTotalTime).sort(byActivity).map(toSourceId).slice(0, this.configProvider.config.ovcMaxCount);
                    g.length && !deepEqual(this.speakersHistory, g) && (this.speakersHistory = g, this.callback && this.callback(this.speakersHistory, "client")), this.sources.map(this.resetTotalTime).filter(this.isAlreadyActive).forEach(this.updateSourceTimestamp);
                }
                isAlreadyActive(g) {
                    return !!g.startTimestamp;
                }
                setupTimer() {
                    return window.setInterval(this.trigger.bind(this), this.configProvider.config.activeSpeaker.timeToPromote);
                }
                clearTimer() {
                    this.ping && (clearInterval(this.ping), this.ping = null);
                }
                getOrCreateSource(g) {
                    if (this.isExist(g)) return this.sourceById(g);
                    {
                        const f = new EA(g);
                        return this.sources.push(f), f;
                    }
                }
                isExist(g) {
                    return this.sources.some((f)=>g === f.id);
                }
                hasAnyoneSpoken() {
                    return this.sources.some((g)=>0 !== g.startTimestamp || 0 !== g.totalTime);
                }
                sourceById(g) {
                    return this.sources.find((f)=>g === f.id);
                }
                updateSourceTimestamp(g) {
                    g.startTimestamp = Date.now();
                }
                updateSourceLastActiveTime(g) {
                    g.lastActiveTime = Date.now();
                }
                updateTotalTime(g) {
                    return g.startTimestamp && (g.totalTime += Date.now() - g.startTimestamp), g;
                }
                resetStartTimestamp(g) {
                    return g.startTimestamp = 0, g;
                }
                resetTotalTime(g) {
                    return g.totalTime = 0, g;
                }
                constructor(g){
                    this.speakersHistory = [], this.sources = [], this.configProvider = g.configProvider, this.ping = this.setupTimer();
                }
            }, IA = class extends Bt {
                start() {
                    this.logger.safe.debug("Starting OptimalVideoCountCalculator"), this.isStarted = !0, this.throttler.changed(()=>this.event("calculatorStateChanged").raise(2, {
                            ovc: this.throttler.value,
                            ovcPayload: this.payload
                        }));
                }
                stop() {
                    this.isStarted = !1;
                }
                dispose() {
                    super.dispose(), this.logger.safe.debug("Disposing OptimalVideoCountCalculator"), this.throttler.dispose();
                }
                processEstimatedBandwidth(g) {
                    this.bandwidthConstrainedOvc = this.getOVCEstimate(g), this.payload = {
                        bandwidth: g,
                        reason: 0
                    }, this.throttler.setValue(this.getOvcValue(), 0);
                }
                updateParticipantCount(g) {
                    var _this_payload;
                    if (!this.configProvider || g === this.previousParticipantsCount) return;
                    const f = this.configProvider.config.ovcXLParticipantsCount;
                    g > f && this.previousParticipantsCount <= f && (this.maxCountStatic = this.configProvider.config.ovcMaxCountXL), g <= f && this.previousParticipantsCount > f && (this.configProvider.config.multiStreamSupported && this.isMcpSrAvailable ? this.maxCountStatic = this.configProvider.config.ovcMaxCountMultiStream : this.maxCountStatic = this.configProvider.config.ovcMaxCount), this.previousParticipantsCount = g, ((_this_payload = this.payload) === null || _this_payload === void 0 ? void 0 : _this_payload.bandwidth) && (this.bandwidthConstrainedOvc = this.getOVCEstimate(this.payload.bandwidth), this.payload.reason = 2), this.throttler.setValue(this.getOvcValue(), 2);
                }
                setPerfConstrainedValue(g) {
                    this.perfConstrainedOvc = g, this.logger.safe.info(`Setting perfConstrainedOvc to ${g}`), this.payload && this.getOvcValue() === g && (this.payload = {
                        reason: 1
                    }), this.throttler.setValue(this.getOvcValue(), 1);
                }
                mcpSourceRequestsAvailable() {
                    var _this_payload;
                    this.configProvider.config.multiStreamSupported && (this.isMcpSrAvailable = !0, this.maxCountStatic === this.configProvider.config.ovcMaxCount && (this.maxCountStatic = this.configProvider.config.ovcMaxCountMultiStream), ((_this_payload = this.payload) === null || _this_payload === void 0 ? void 0 : _this_payload.bandwidth) && (this.bandwidthConstrainedOvc = this.getOVCEstimate(this.payload.bandwidth), this.payload.reason = 2), this.throttler.setValue(this.getOvcValue(), 2));
                }
                getOVCEstimate(g) {
                    this.bandwidthEstimationAvailable || (this.bandwidthEstimationAvailable = this.isStarted && g > 0 && (this.totalSamples++ >= this.configProvider.config.ovcIgnoreFirstSamples || Math.floor(g) / this.configProvider.config.ovcBandwidthPerVideoReceiver >= this.configProvider.config.nonEstimatedDefaultVideoReceiversCount));
                    let f = this.configProvider.config.nonEstimatedDefaultVideoReceiversCount;
                    return this.bandwidthEstimationAvailable && (f = Math.floor(this.sampleSmoothed(g) / this.configProvider.config.ovcBandwidthPerVideoReceiver)), f;
                }
                getOvcValue() {
                    var _this_bandwidthConstrainedOvc, _this_perfConstrainedOvc;
                    return Math.max(1, Math.min((_this_bandwidthConstrainedOvc = this.bandwidthConstrainedOvc) !== null && _this_bandwidthConstrainedOvc !== void 0 ? _this_bandwidthConstrainedOvc : this.maxCountStatic, (_this_perfConstrainedOvc = this.perfConstrainedOvc) !== null && _this_perfConstrainedOvc !== void 0 ? _this_perfConstrainedOvc : this.maxCountStatic, this.maxCountStatic));
                }
                sampleSmoothed(g) {
                    if (this.smoothingWindow.length >= this.configProvider.config.ovcSlidingWindowSamples ? this.smoothingWindow.shift() : this.smoothingWindow.length === this.configProvider.config.ovcSlidingWindowSamples - 1 && (this.smoothingWindow = this.smoothingWindow.map(()=>g)), this.smoothingWindow.push(g), this.smoothingWindow.length >= this.configProvider.config.ovcSlidingWindowSamples) {
                        const g = this.smoothingWindow.slice().sort(), f = average(g);
                        return g[g.length - 1] - (g[g.length - 1] - f * (1 - this.configProvider.config.ovcSlidingWindowPercentile));
                    }
                    return g;
                }
                updateStaticConstraint(g, f, S) {
                    g && g < f && (this.maxCountStatic = Math.min(this.maxCountStatic, S));
                }
                constructor(g, f){
                    super(), this.configProvider = g, this.logger = f, this.bandwidthEstimationAvailable = !1, this.smoothingWindow = [], this.totalSamples = 0, this.isStarted = !1, this.maxCountStatic = this.configProvider.config.ovcMaxCount, this.previousParticipantsCount = 0, this.isMcpSrAvailable = !1;
                    const S = window.navigator;
                    this.updateStaticConstraint(S.hardwareConcurrency, this.configProvider.config.ovcAvailableConcurrencyForBiggerGrid, 4), this.updateStaticConstraint(S.deviceMemory, this.configProvider.config.ovcMemoryForBiggerGrid, 4), this.throttler = new bA(this.logger.createChild("ovcThrottler"), this.configProvider.config.ovcRampDownCooldown, this.configProvider.config.ovcRampUpCooldown);
                }
            }, bA = class extends Bt {
                get value() {
                    return this.lastValue;
                }
                setValue(g, f) {
                    if (g === this.lastValue) return;
                    const S = g > this.lastValue, v = void 0 !== this.lastValue && S !== this.wasRampingUp ? S ? this.throttleUpCooldown : this.throttleDownCooldown : -1, _ = Date.now();
                    _ - this.lastUpdateTime < v && (2 !== f || S) || (void 0 !== this.lastValue && (this.lastUpdateTime = _, this.wasRampingUp = S), this.logger.safe.info(`optimal video receivers count updated ${this.lastValue} -> ${g}, reason: ${f}`), this.lastValue = g, this.raiseChanged());
                }
                constructor(g, f, S){
                    super(g), this.logger = g, this.throttleDownCooldown = f, this.throttleUpCooldown = S, this.wasRampingUp = !0, this.lastUpdateTime = 0;
                }
            }, AA = class _CPUUsageMetricCollector {
                isSupported() {
                    var _window_chrome_runtime, _window_chrome;
                    return Boolean((_window_chrome = window.chrome) === null || _window_chrome === void 0 ? void 0 : (_window_chrome_runtime = _window_chrome.runtime) === null || _window_chrome_runtime === void 0 ? void 0 : _window_chrome_runtime.connect);
                }
                start() {
                    this.isSupported ? (this.started = !0, this.logger.debug("Starting collecting CPU metric"), this.port = window.chrome.runtime.connect(_CPUUsageMetricCollector.extensionID, {
                        name: _CPUUsageMetricCollector.extensionName
                    }), this.port.onMessage.addListener((g)=>{
                        g && arrayLimitedPush2(this.report, {
                            timeStamp: Date.now(),
                            value: g
                        }, this.maxEventNum);
                    })) : this.logger.debug("Chrome runtime is not supported");
                }
                stop() {
                    var _this_port;
                    (_this_port = this.port) === null || _this_port === void 0 ? void 0 : _this_port.disconnect(), this.port = null, this.started = !1;
                }
                getSamples() {
                    return this.report;
                }
                getLastSample() {
                    return getLast(this.report);
                }
                getCurrentCpuSample() {
                    return new Promise((g, f)=>{
                        this.started && g(getLast(this.report)), this.isSupported() || f("Not supported"), this.port = window.chrome.runtime.connect(_CPUUsageMetricCollector.extensionID, {
                            name: _CPUUsageMetricCollector.extensionName
                        }), this.port.onMessage.addListener((S)=>{
                            this.stop(), S || f("Not supported"), g({
                                timeStamp: Date.now(),
                                value: S
                            });
                        });
                    });
                }
                clearStats() {
                    this.report = [];
                }
                constructor(g, f = 30){
                    this.logger = g, this.maxEventNum = f, this.report = [], this.started = !1;
                }
            };
            AA.extensionID = "nkeimhogjdpnpccoofpliimaahmaaome", AA.extensionName = "processCpu";
            var RA = AA, PA = class {
                static isSupported() {
                    return void 0 !== globalThis.PressureObserver;
                }
                get cpuState() {
                    return this.currentCpuState;
                }
                start() {
                    if (this.logger.safe.debug("Starting CPU pressure observer"), this.started) this.logger.safe.debug("CPU pressure observer is already started");
                    else {
                        var _this_cpuObserver;
                        try {
                            this.cpuObserver = new globalThis.PressureObserver((g)=>{
                                g.forEach((f)=>{
                                    "cpu" === f.source && this.currentCpuState !== f.state && (this.logger.safe.debug(`CPU pressure state changed: ${JSON.stringify(g)}`), this.currentCpuState = f.state);
                                });
                            }, {
                                sampleRate: 1
                            });
                        } catch (g) {
                            throw this.logger.safe.error(`Error while creating pressure observer: ${g}`), g;
                        }
                        this.started = !0, (_this_cpuObserver = this.cpuObserver) === null || _this_cpuObserver === void 0 ? void 0 : _this_cpuObserver.observe("cpu");
                    }
                }
                stop() {
                    var _this_cpuObserver;
                    this.started = !1, (_this_cpuObserver = this.cpuObserver) === null || _this_cpuObserver === void 0 ? void 0 : _this_cpuObserver.disconnect();
                }
                constructor(g){
                    this.logger = g, this.started = !1;
                }
            }, wA = class extends Bt {
                start() {
                    var _this_cpuPressureObserver;
                    this.logger.safe.debug("Starting RemoteVideoPerformanceCalculator"), this.started ? this.logger.safe.debug("RemoteVideoPerformanceCalculator already running. Do nothing.") : (this.calculatorStrategy = U_.getStrategy(this.configProvider), this.started = !0, (_this_cpuPressureObserver = this.cpuPressureObserver) === null || _this_cpuPressureObserver === void 0 ? void 0 : _this_cpuPressureObserver.start(), this.subs.push(this.statsGatherer.on("onDiagnosticUpdated", (g)=>this.processStats(g))));
                }
                stop() {
                    var _this_cpuMetricCollector, _this_cpuPressureObserver;
                    this.logger.safe.debug("Stopping RemoteVideoPerformanceCalculator"), this.started = !1, this.subs.forEach((g)=>{
                        g.dispose();
                    }), (_this_cpuMetricCollector = this.cpuMetricCollector) === null || _this_cpuMetricCollector === void 0 ? void 0 : _this_cpuMetricCollector.stop(), (_this_cpuPressureObserver = this.cpuPressureObserver) === null || _this_cpuPressureObserver === void 0 ? void 0 : _this_cpuPressureObserver.stop();
                }
                dispose() {
                    this.logger.safe.debug("Disposing RemoteVideoPerformanceCalculator"), this.cleanupMaps(), this.stop();
                }
                cleanupMaps() {
                    this.badPerfIds.clear(), this.perfTrackerMap.clear();
                }
                async processStats(g) {
                    try {
                        var _g_video_recv, _g_video, _g_video_recv1, _g_video1;
                        if (this.paused) return;
                        if (!((_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_recv = _g_video.recv) === null || _g_video_recv === void 0 ? void 0 : _g_video_recv.length)) return;
                        this.configProvider.config.diagnostics.traceLogging && this.logger.safe.debug("Caught onDiagnosticUpdated: Calculating remote video performance"), (_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : (_g_video_recv1 = _g_video1.recv) === null || _g_video_recv1 === void 0 ? void 0 : _g_video_recv1.forEach(async (f)=>{
                            var _f_renderer, _f_extensions_macroblockRateStats, _f_extensions, _f_extensions_macroblockRateStats1, _f_extensions1, _f_extensions2, _f_extensions3, _f_extensions4, _f_extensions5, _f_extensions6, _f_extensions7, _g_video_recv, _g_video;
                            const S = (_f_renderer = f.renderer) === null || _f_renderer === void 0 ? void 0 : _f_renderer.msi;
                            if (!this.perfTrackerMap.has(S)) {
                                var _f_mediaEntity;
                                const g = {
                                    id: (_f_mediaEntity = f.mediaEntity) === null || _f_mediaEntity === void 0 ? void 0 : _f_mediaEntity.remoteTrackId,
                                    decodeTimeTracker: new zv(this.trackInterval),
                                    macroblockLossTracker: new zv(this.trackInterval),
                                    macroblockMaxLossTracker: 0,
                                    freezeDurationPercent: 0,
                                    frameHeight: 0,
                                    frameWidth: 0,
                                    rendererFps: new zv(this.trackInterval),
                                    incomingFps: new zv(this.trackInterval),
                                    framesReceived: 0,
                                    framesDecoded: 0,
                                    decoder: "",
                                    msi: S
                                };
                                this.perfTrackerMap.set(S, g);
                            }
                            const v = this.perfTrackerMap.get(S);
                            if (f.inboundRTP.totalDecodeTime && f.inboundRTP.framesDecoded) {
                                const g = round(f.inboundRTP.totalDecodeTime / f.inboundRTP.framesDecoded * 1e3, 2);
                                v.decodeTimeTracker.captureSample(g);
                            }
                            const _ = (_f_extensions = f.extensions) === null || _f_extensions === void 0 ? void 0 : (_f_extensions_macroblockRateStats = _f_extensions.macroblockRateStats) === null || _f_extensions_macroblockRateStats === void 0 ? void 0 : _f_extensions_macroblockRateStats.macroblockRateDecoderLossPercent;
                            v.macroblockLossTracker.captureSample(_), v.macroblockMaxLossTracker = (_f_extensions1 = f.extensions) === null || _f_extensions1 === void 0 ? void 0 : (_f_extensions_macroblockRateStats1 = _f_extensions1.macroblockRateStats) === null || _f_extensions_macroblockRateStats1 === void 0 ? void 0 : _f_extensions_macroblockRateStats1.macroblockRateMaxDecoderLossPercent, ((_f_extensions2 = f.extensions) === null || _f_extensions2 === void 0 ? void 0 : _f_extensions2.duration) && (v.freezeDurationPercent = ((_f_extensions3 = f.extensions) === null || _f_extensions3 === void 0 ? void 0 : _f_extensions3.totalFreezeDuration) / ((_f_extensions4 = f.extensions) === null || _f_extensions4 === void 0 ? void 0 : _f_extensions4.duration) * 100), v.frameHeight = f.inboundRTP.frameHeight || 0, v.frameWidth = f.inboundRTP.frameWidth || 0, void 0 !== ((_f_extensions5 = f.extensions) === null || _f_extensions5 === void 0 ? void 0 : _f_extensions5.frameRateDecoded) && void 0 !== f.inboundRTP.framesPerSecond && ((_f_extensions6 = f.extensions) === null || _f_extensions6 === void 0 ? void 0 : _f_extensions6.frameRateDecoded) <= this.rendererFpsCap && f.inboundRTP.framesPerSecond <= this.rendererFpsCap && (v.rendererFps.captureSample((_f_extensions7 = f.extensions) === null || _f_extensions7 === void 0 ? void 0 : _f_extensions7.frameRateDecoded), v.incomingFps.captureSample(f.inboundRTP.framesPerSecond)), f.inboundRTP.framesReceived && f.inboundRTP.framesDecoded && (v.framesReceived = f.inboundRTP.framesReceived, v.framesDecoded = f.inboundRTP.framesDecoded), v.decoder = f.inboundRTP.decoderImplementation, v.rendererFps.isReportComplete() && v.incomingFps.isReportComplete() && v.decodeTimeTracker.isReportComplete() && (this.paused = !0, await this.checkQuality(v, g.perfCounters, (_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_recv = _g_video.recv) === null || _g_video_recv === void 0 ? void 0 : _g_video_recv.length), this.paused = !1);
                        });
                    } catch (g) {
                        this.logger.error("Failed to processes diagnostics update: " + g);
                    }
                }
                async checkQuality(g, f, S) {
                    if (!S) return;
                    const v = [];
                    let _;
                    try {
                        var _this_cpuMetricCollector;
                        _ = await ((_this_cpuMetricCollector = this.cpuMetricCollector) === null || _this_cpuMetricCollector === void 0 ? void 0 : _this_cpuMetricCollector.getCurrentCpuSample());
                    } catch (e) {
                        this.logger.safe.debug("CPU sampling is not supported");
                    }
                    const C = {
                        ts: Date.now(),
                        trackId: g.id,
                        decodeTime: g.decodeTimeTracker.getReport(),
                        macroblockLossPercent: g.macroblockLossTracker.getReport(),
                        macroblockMaxLossPercent: g.macroblockMaxLossTracker,
                        freezeDurationPercent: g.freezeDurationPercent,
                        perfCounters: f,
                        cpuUsage: _,
                        rendererFps: g.rendererFps.getReport(),
                        incomingFps: g.incomingFps.getReport(),
                        framesDecoded: g.framesDecoded,
                        framesReceived: g.framesReceived,
                        msi: g.msi,
                        frameHeight: g.frameHeight,
                        decoder: g.decoder
                    };
                    v.push(C);
                    const E = this.calculatorStrategy.checkQuality(g);
                    if (0 === E) {
                        if (this.logger.safe.debug(`Bad perf detected for msi ${g.msi}: ${JSON.stringify(v)}`), this.configProvider.config.diagnostics.performanceMonitoring.usePerfConstrainedOvc && !Zt.Recv.getNextLowerResolution(g.frameWidth, g.frameHeight)) {
                            const g = Math.max(S - 1, 1);
                            return this.logger.info(`Min resolution reached, decreasing OVC to: ${g}`), this.diagnostics.registerVideoPerformanceEvent(v, 1, g), this.event("calculatorStateChanged").raise(2, {
                                ovc: g
                            }), void this.perfTrackerMap.clear();
                        }
                        this.diagnostics.registerVideoPerformanceEvent(v, 1), this.event("calculatorStateChanged").raise(1, {
                            msi: g.msi
                        });
                    }
                    2 === E && (this.diagnostics.registerVideoPerformanceEvent(v, 0), this.logger.safe.debug(`Good perf detected for msi ${g.msi}: ${JSON.stringify(v)}`), this.event("calculatorStateChanged").raise(0, {
                        msi: g.msi
                    })), this.perfTrackerMap.delete(g.msi);
                }
                constructor(g, f, S, v){
                    super(), this.statsGatherer = g, this.diagnostics = f, this.configProvider = S, this.logger = v, this.paused = !1, this.started = !1, this.trackInterval = this.configProvider.config.diagnostics.performanceMonitoring.remoteVideoTrackInterval, this.badPerfIds = new Set, this.perfTrackerMap = new Map, this.subs = [], this.rendererFpsCap = 40, this.configProvider.config.diagnostics.performanceMonitoring.useComputePressure && PA.isSupported() && (this.cpuPressureObserver = new PA(this.logger)), this.configProvider.config.diagnostics.performanceMonitoring.useCpuSample && (this.cpuMetricCollector = new RA(this.logger, this.configProvider.config.diagnostics.performanceMonitoring.cpuMetricCollector));
                }
            }, MA = class extends Bt {
                on(g, f) {
                    switch(g){
                        case "onIncomingVideoQualityChanged":
                            this.addCalculator(0), this.startCalculator(0);
                            break;
                        case "onOptimalVideoCountChanged":
                            this.addCalculator(2), this.startCalculator(2);
                    }
                    return this.subscribe({
                        changed: void 0,
                        on: {
                            name: String(g),
                            handler: f
                        }
                    });
                }
                addCalculator(g) {
                    let f = this.calculators.get(g);
                    if (!f) {
                        switch(g){
                            case 0:
                                if (!this.configProvider.config.diagnostics.performanceMonitoring.enableRemoteVideoCalculator) return;
                                f = new wA(this.statsGatherer, this.diagnostics, this.configProvider, this.logger.createChild("RemoteVideoPerformanceCalculator"));
                                break;
                            case 2:
                                if (!this.configProvider.config.enableOptimalVideoCount) return;
                                f = new IA(this.configProvider, this.logger.createChild("OptimalVideoCountCalculator"));
                                break;
                            case 1:
                                throw new Error("Not implemented");
                        }
                        this.subs.push(f.on("calculatorStateChanged", (f, S)=>{
                            this.handleChanged(g, f, S);
                        })), this.calculators.set(g, f);
                    }
                }
                startCalculator(g) {
                    this.logger.safe.debug(`adding calculator with id ${g}`);
                    const f = this.calculators.get(g);
                    f && f.start();
                }
                stopCalculator(g) {
                    this.logger.safe.debug(`stopping calculator with id ${g}`);
                    const f = this.calculators.get(g);
                    f && f.stop();
                }
                processNotification(g, f) {
                    switch(g){
                        case "BandwidthNotification":
                            var _this_calculators_get;
                            (_this_calculators_get = this.calculators.get(2)) === null || _this_calculators_get === void 0 ? void 0 : _this_calculators_get.processEstimatedBandwidth(f.bw);
                            break;
                        case "ParticipantCountChanged":
                            var _this_calculators_get1;
                            (_this_calculators_get1 = this.calculators.get(2)) === null || _this_calculators_get1 === void 0 ? void 0 : _this_calculators_get1.updateParticipantCount(f.count);
                            break;
                        case "McpSourceRequestsAvailable":
                            var _this_calculators_get2;
                            (_this_calculators_get2 = this.calculators.get(2)) === null || _this_calculators_get2 === void 0 ? void 0 : _this_calculators_get2.mcpSourceRequestsAvailable();
                            break;
                        default:
                            this.logger.safe.info(`Notification message handler not found for type: ${g}`);
                    }
                }
                dispose() {
                    super.dispose(), this.calculators.forEach((g)=>{
                        g.dispose();
                    }), this.subs.forEach((g)=>{
                        g.dispose();
                    });
                }
                handleChanged(g, f, S) {
                    switch(this.logger.info(`calculatorStateChanged  ${f}: calculatorType ${g} ${JSON.stringify(S)}`), g){
                        case 0:
                            if (2 === f) {
                                var _this_calculators_get;
                                (_this_calculators_get = this.calculators.get(2)) === null || _this_calculators_get === void 0 ? void 0 : _this_calculators_get.setPerfConstrainedValue(S === null || S === void 0 ? void 0 : S.ovc);
                                break;
                            }
                            this.configProvider.config.diagnostics.performanceMonitoring.enableLowerResolution && this.event("onIncomingVideoQualityChanged").raise(f, S === null || S === void 0 ? void 0 : S.msi);
                            break;
                        case 2:
                            this.event("onOptimalVideoCountChanged").raise(S === null || S === void 0 ? void 0 : S.ovc, S === null || S === void 0 ? void 0 : S.ovcPayload);
                    }
                }
                constructor(g, f, S, v){
                    super(), this.statsGatherer = g, this.diagnostics = f, this.configProvider = S, this.logger = v, this.calculators = new Map, this.subs = [];
                }
            }, OA = P, DA = class {
                processReport(g) {
                    var _g_audio_recv, _g_audio, _g_audio_send, _g_audio1;
                    ((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : (_g_audio_recv = _g_audio.recv) === null || _g_audio_recv === void 0 ? void 0 : _g_audio_recv.length) && (this.inboundNetworkQuality = this.processInboundSample((0, OA.last)(g.audio.recv))), ((_g_audio1 = g.audio) === null || _g_audio1 === void 0 ? void 0 : (_g_audio_send = _g_audio1.send) === null || _g_audio_send === void 0 ? void 0 : _g_audio_send.length) && (this.outboundNetworkQuality = this.processOutboundSample((0, OA.last)(g.audio.send)));
                }
                getInboundNetworkQuality() {
                    return this.inboundNetworkQuality;
                }
                getOutboundNetworkQuality() {
                    return this.outboundNetworkQuality;
                }
                processInboundSample(g) {
                    var _g_extensions;
                    const f = this.inboundNetworkQuality, { totalSamplesReceived: S } = g.inboundRTP, { healedRatio: v } = (_g_extensions = g.extensions) !== null && _g_extensions !== void 0 ? _g_extensions : {};
                    null != v && this.healedRatioAccumulator.add(v);
                    const _ = (0, OA.mean)(this.healedRatioAccumulator.items);
                    return !S || S < this.configProvider.config.webrtcMinAudioSamplesRecvForNetworkRecvQuality ? f : _ && this.healedRatioAccumulator.isFull ? this.determineInboundQualityLevel(_) : f;
                }
                determineInboundQualityLevel(g) {
                    const f = this.inboundNetworkQuality, S = this.configProvider.config.webrtcStatNetworkDetectionHysteresis, v = this.configProvider.config.webrtcStatNetworkDetectionBadLevel, _ = this.configProvider.config.webrtcStatNetworkDetectionGoodLevel;
                    return g < _ - S / 2 ? "Good" : g < _ + S / 2 ? "Good" === f ? "Good" : "Poor" : g < v - S / 2 ? "Poor" : g < v + S / 2 ? "Bad" === f ? "Bad" : "Poor" : "Bad";
                }
                processOutboundSample(g) {
                    var _g_remoteInboundRTP, _g_extensions;
                    const f = this.outboundNetworkQuality, { packetsSent: S, timestamp: v } = g.outboundRTP, { jitter: _ } = (_g_remoteInboundRTP = g.remoteInboundRTP) !== null && _g_remoteInboundRTP !== void 0 ? _g_remoteInboundRTP : {}, { lossRate: C } = (_g_extensions = g.extensions) !== null && _g_extensions !== void 0 ? _g_extensions : {};
                    if (!S || S < this.configProvider.config.webrtcMinPacketsSentForNetworkSendQuality) return f;
                    null != _ && this.jitterAccumulator.add(_);
                    const E = (0, OA.mean)(this.jitterAccumulator.items), T = this.jitterAccumulator.isFull ? this.jitterStateProcessor.onSample(E, v) : "Good", I = C ? this.lossRateStateProcessor.onSample(C, v) : "Good";
                    return "Good" === T && "Good" === I ? "Good" : "Bad";
                }
                constructor(g){
                    this.configProvider = g, this.outboundNetworkQuality = "Good", this.inboundNetworkQuality = "Good", this.jitterAccumulator = new Fv(this.configProvider.config.webrtcJitterWindowSize), this.healedRatioAccumulator = new Fv(this.configProvider.config.webrtcHealedRatioWindowSize), this.jitterStateProcessor = new cI(g.config.webrtcJitterLowThreshold, g.config.webrtcJitterHighThreshold, !0, g.config.webrtcJitterSticknessTime), this.lossRateStateProcessor = new cI(g.config.webrtcLossRateLowThreshold, g.config.webrtcLossRateHighThreshold, !0, g.config.webrtcLossRateSticknessTime);
                }
            }, NA = P, kA = class {
                processReport(g) {
                    var _g_audio_send, _g_audio;
                    if (!((_g_audio = g.audio) === null || _g_audio === void 0 ? void 0 : (_g_audio_send = _g_audio.send) === null || _g_audio_send === void 0 ? void 0 : _g_audio_send.length)) return !1;
                    var _f_extensions, _f_mediaSource;
                    const f = g.audio.send[0], { rawInputVolume: S, callIsMuted: v } = (_f_extensions = f.extensions) !== null && _f_extensions !== void 0 ? _f_extensions : {}, { audioLevel: _ } = (_f_mediaSource = f.mediaSource) !== null && _f_mediaSource !== void 0 ? _f_mediaSource : {}, { useAudioAnalyzer: C, webrtcSpeakingWhileMutedDetectionLevel: E } = this.configProvider.config;
                    if (!v) return this.speechWindow.clear(), !1;
                    const T = C ? S : _;
                    return null != T && this.speechWindow.add(T), !!this.speechWindow.isFull && (0, NA.mean)(this.speechWindow.items) > E;
                }
                constructor(g){
                    this.configProvider = g, this.speechWindow = new Fv(g.config.webrtcSpeakingWhileMutedDetectionWindow);
                }
            }, LA = class {
                toLocal(g, f, S) {
                    return this.modify({
                        sdpSource: 0,
                        sdpType: S
                    }, g, f);
                }
                toOffer(g, f, S) {
                    return this.modify({
                        sdpSource: 1,
                        sdpType: "offer"
                    }, g, f, S);
                }
                toAnswer(g, f, S) {
                    return this.modify({
                        sdpSource: 1,
                        sdpType: "answer"
                    }, g, f, S);
                }
                toRemote(g, f, S, v, _ = !1) {
                    return this.modify({
                        sdpSource: 2,
                        sdpType: v,
                        isOrWasProvisional: _
                    }, g, f, S);
                }
                modify(g, f, S, v) {
                    const _ = new _y(this.context, S, v, this.cname).build(g), C = deepClone(f);
                    return _.modify(C), C;
                }
                constructor(g){
                    this.context = g, this.cname = uniqueId();
                }
            }, FA = class {
                get sdp() {
                    return this.originalDescription.sdp;
                }
                set sdp(g) {
                    this.originalDescription = new Qa.window.RTCSessionDescription({
                        sdp: g,
                        type: this.originalDescription.type
                    });
                }
                get type() {
                    return this.originalDescription.type;
                }
                set type(g) {
                    this.originalDescription = new Qa.window.RTCSessionDescription({
                        sdp: this.originalDescription.sdp,
                        type: g
                    });
                }
                toJSON() {
                    return this.originalDescription.toJSON();
                }
                constructor(g){
                    this.originalDescription = new Qa.window.RTCSessionDescription(g);
                }
            }, xA = class {
                get configuredModalities() {
                    return this.configuredModalitiesInternal;
                }
                get offeredModalities() {
                    return this.offeredModalitiesInternal;
                }
                get disabledModalities() {
                    return this.disabledModalitiesInternal;
                }
                get negotiatedModalities() {
                    return this.negotiatedModalitiesInternal;
                }
                get allowedMediaContentType() {
                    return this.allowedMediaContentTypeInternal;
                }
                get negotiationCompletedPromise() {
                    return this.negotiationCompletedDefer;
                }
                get iceRelayGatheringStartTime() {
                    return this.iceRelayCandidatesGatherStartTime;
                }
                get iceCandidatesDefer() {
                    return this.iceCandidatesDeferred;
                }
                get initiator() {
                    return this.initiatorInternal;
                }
                set rollbackSupported(g) {
                    this.isRollbackSupported = g;
                }
                set iceCandidateReceived(g) {
                    this.iceCandidateReceivedInternal = g;
                }
                get mediaContentType() {
                    return this.useNGC1webrtcContentType ? Gt.CONTENT_TYPE.SDP_NGC : this.mediaContentTypeInternal;
                }
                setInternals(g, f, S) {
                    this.logger.safe.debug(`Setting internals tm: ${!!g} tsp: ${!!f} dc: ${!!S}`), this.transceiverManager = g, this.transportStateProvider = f, this.dataChannel = S;
                }
                terminate(g) {
                    this.logger.safe.info(`[${g}] terminating`), this.terminated = !0, this.canTriggerRenegotiation = !1, this.negotiatedModalitiesInternal = {}, this.resetCandidateGathering(g), this.negotiationCompletedDefer.reject("webRtcSession cleanup"), this.negotiationQueue.dispose();
                }
                pauseNegotiations(g = generateCauseId()) {
                    const f = new ct;
                    return this.negotiationCompletedDefer.promise.catch(()=>{}).then(()=>{
                        this.setNegotiationPromise(f, g);
                    }), f;
                }
                async configureModalities(g, f, S) {
                    const getPendingPromise = async ()=>{
                        if (await this.configureModalitiesPromise, !g.audio && !g.video && !g.sharing) throw new Error(`Invalid parameters! ${JSON.stringify(g)}`);
                        const v = shallowClone(g), _ = shallowClone(this.negotiatedModalities);
                        this.configProvider.config.alwaysNegotiateDataChannel && (delete v.data, delete _.data);
                        const C = !this.configuredModalities || !areNegotiatedDirectionsFulfilled(v, _);
                        this.logger.safe.info(`[${f}] configureModalities ${stringifyObject(this.configuredModalities)} -> ${stringifyObject(g)} (${C ? `update from ${stringifyObject(this.negotiatedModalities)}` : "fulfilled"})`), this.configuredModalities = g, C && !this.updateSendStreamsReinviteless(f, S) && (this.configProvider.config.removeSendersOnConfigureModalities && !isOnHold(this.configuredModalities) && await this.streamSendersManager.update(g, 1, f), this.triggerRenegotiation(!1, f, S));
                    };
                    return this.configureModalitiesPromise = getPendingPromise(), this.configureModalitiesPromise.catch((g)=>{
                        this.logger.safe.warn(`[${f}] Error during configuring modalities: ${stringifyObject(g)}`);
                    }), this.configureModalitiesPromise;
                }
                async completeNegotiation(g) {
                    this.mediaManager.commit();
                    let f = areNegotiatedDirectionsAcceptable(this.configuredModalities, this.negotiatingModalities, this.negotiatedModalities) && !this.triggerRenegotiationFlag;
                    this.canTriggerRenegotiation = !0, this.logger.safe.info(`[${g}] negotiation completed isComplete: ${f} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`);
                    let S = this.negotiatedModalities;
                    if (this.streamSendersManager.pendingStreamsPromise) {
                        this.logger.safe.info(`[${g}] Waiting for stream acquisitions to complete...`);
                        const v = await this.streamSendersManager.pendingStreamsPromise;
                        this.streamSendersManager.clearStreamsPromise(), this.logger.safe.info(`[${g}] Stream acquisitions completed: ${stringifyObject(v)}`), areNegotiatedDirectionsAcceptable(v, this.negotiatingModalities, this.negotiatedModalities) || (this.logger.safe.warn(`[${g}] Some streams were not acquired successfully, considering the negotiation as incomplete`), S = v, f = !1);
                    }
                    return f || this.triggerRenegotiation(!1, g), this.initialNegotiationCompleted = !0, this.negotiationCompletedDefer.resolve(), {
                        isComplete: f,
                        activeModalities: S,
                        offeredModalities: this.offeredModalities,
                        attemptedModalities: this.negotiatingModalities,
                        configuredModalities: this.configuredModalities,
                        initiator: this.initiatorInternal
                    };
                }
                async rejectNegotiation(g, f, S = !1) {
                    var _this_transceiverManager, _this_sessionContext_getSmallCallTelemetry, _this_dataChannel, _this_transportStateProvider;
                    let v;
                    this.mediaManager.rollback(), this.logger.safe.warn(`[${f}] negotiation rejected isComplete: ${!S} error: ${stringifyObject(g)} configured: ${JSON.stringify(this.configuredModalities)} negotiating: ${JSON.stringify(this.negotiatingModalities)} offered: ${JSON.stringify(this.offeredModalities)} negotiated: ${JSON.stringify(this.negotiatedModalities)}`), this.qualityManager.clearPendingCapabilities();
                    const _ = removeChangedSendDirection(this.negotiatedModalities, this.negotiatingModalities);
                    this.logger.safe.debug(`[${f}] configured modalities for rollback: ${JSON.stringify(_)}`), (_this_transceiverManager = this.transceiverManager) === null || _this_transceiverManager === void 0 ? void 0 : _this_transceiverManager.syncTransceivers(_), (_this_sessionContext_getSmallCallTelemetry = this.sessionContext.getSmallCallTelemetry()) === null || _this_sessionContext_getSmallCallTelemetry === void 0 ? void 0 : _this_sessionContext_getSmallCallTelemetry.setEventType("rejectNegotiation"), (_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.updateDataModalityState(this.negotiatingModalities.data);
                    const C = isOnHold(_);
                    isOnHold(this.negotiatedModalities) !== C && await this.streamSendersManager.setHold(C, f), C ? this.logger.safe.info(`[${f}] Hold is configured. Not updating streams`) : await this.streamSendersManager.update(_, 0, f);
                    const E = (_this_transportStateProvider = this.transportStateProvider) === null || _this_transportStateProvider === void 0 ? void 0 : _this_transportStateProvider.signalingState;
                    if ("have-local-offer" === E) {
                        v = {}, this.logger.safe.info(`[${f}] rolling back local description`);
                        try {
                            if (!this.isRollbackSupported || this.configProvider.config.webrtcHandleRollback) {
                                v.type = "LocalRN", this.logger.safe.info(`[${f}] rolling back using local renegotiation`);
                                const g = [
                                    this.callbacks.getRollbackModifier(this.logger)
                                ];
                                await this.negotiationEmulator.renegotiate(g, !0), this.logger.safe.info(`[${f}] rolling back using local complete`);
                            } else this.logger.safe.info(`[${f}] rolling back using rollback`), v.type = "Rollback", await this.callbacks.setLocalDescription({
                                type: "rollback"
                            });
                        } catch (g) {
                            this.logger.safe.error(`[${f}] rollback error: ${stringifyObject(g)}`), v.error = g;
                        }
                    } else if ("have-remote-offer" === E) {
                        v = {};
                        try {
                            if (!this.isRollbackSupported || this.configProvider.config.webrtcHandleRemoteRollback) {
                                v.type = "RemoteRN", this.logger.safe.info(`[${f}] applying answer for remote renegotiation`);
                                const g = [
                                    this.callbacks.getRollbackModifier(this.logger)
                                ];
                                await this.negotiationEmulator.renegotiate(g, !0, "remote");
                            } else this.logger.safe.info(`[${f}] rolling back using rollback on remote description`), v.type = "Rollback", await this.callbacks.setRemoteDescription({
                                type: "rollback"
                            });
                        } catch (g) {
                            this.logger.safe.error(`[${f}] rollback error: ${stringifyObject(g)}`), v.error = g;
                        }
                    } else this.callbacks.hasPC() && this.logger.safe.error(`[${f}] cannot rollback local description in current state: ${this.transportStateProvider.signalingState}`);
                    return this.canTriggerRenegotiation = !0, this.negotiationCompletedDefer.reject("negotiation rejected"), S && (this.logger.safe.info(`[${f}] retrying failed negotiation`), this.triggerRenegotiation(!1, f)), {
                        isComplete: !S,
                        activeModalities: _,
                        offeredModalities: this.offeredModalities,
                        attemptedModalities: this.negotiatingModalities,
                        configuredModalities: this.configuredModalities,
                        initiator: this.initiatorInternal,
                        rollback: v
                    };
                }
                triggerRenegotiation(g, f = generateCauseId(), S) {
                    this.canTriggerRenegotiation ? (this.canTriggerRenegotiation = !1, this.triggerRenegotiationFlag = !1, this.logger.safe.info(`[${f}] triggering renegotiation`), this.mediaManager.backup(), this.callbacks.onNegotiationRequired(f, S)) : g && (this.logger.safe.info(`[${f}] renegotiation postponed`), this.triggerRenegotiationFlag = !0);
                }
                configureCrypto(g, f) {
                    let S = !1;
                    const v = preferSdesSrtp(this.configProvider, f);
                    if (this.offeredDescription) {
                        const g = this.offeredDescription.getSrtpInfo();
                        this.diagnostics.offeredSrtp = g, S = !g.dtls || g.sdes && v;
                    } else S = v;
                    return S && (this.logger.safe.info("configuring peer connection to use sdes"), g.optional.push({
                        DtlsSrtpKeyAgreement: !1
                    })), this.diagnostics.negotiatedSrtp = {
                        dtls: !S,
                        sdes: !!S
                    }, S ? 0 : 1;
                }
                createOffer(g, f) {
                    const S = this.negotiationQueue.add(()=>this.createOfferAsync(g, f), g);
                    return this.resetNegotiationQueue(g), S;
                }
                processOffer(g, f) {
                    const S = this.negotiationQueue.add(()=>this.processOfferAsync(g, f), f);
                    return this.resetNegotiationQueue(f), S;
                }
                async createAnswer(g, f) {
                    var _this_dataChannel, _this_audioCodecManager_decoder;
                    if ((this.sessionContext.config.isPstnCall ? !this.configProvider.config.createProvisionalAnswer.enabledPstn : !this.configProvider.config.createProvisionalAnswer.enabled) && g) return this.logger.safe.info("createAnswer(): Ignoring provisional answer"), {
                        blob: "",
                        contentType: this.mediaContentType
                    };
                    const S = g ? "pranswer" : "answer", v = g ? "createProvisionalAnswerAsync" : "createAnswerAsync", _ = this.diagnostics.getTimerTracker(v, {
                        first: !0
                    });
                    if (_.mark("start"), this.logger.safe.info(`[${f}] create [${S}] offered: ${JSON.stringify(this.offeredModalities)} configured: ${JSON.stringify(this.configuredModalities)}`), !this.configuredModalities) throw new Error("no configured modalities to create answer for");
                    let C = this.negotiatingModalities = negotiateModalities(this.offeredModalities, this.configuredModalities);
                    await this.callbacks.assurePC(f, _.clone("assurePeerConnectionAsync"));
                    const E = this.transportStateProvider.isWaitingAcceptProvisional;
                    if (this.transportStateProvider.isWaitingAcceptProvisional = g, _.markAndMeasure("start", "assurePeerConnectionAsync"), this.logger.safe.info(`[${f}] updatePeerConnectionStreamsAsync, pc state: ${JSON.stringify(this.transportStateProvider.signalingState)}`), !this.offeredDescription.isCodecSwitchSupported()) try {
                        const g = (await this.capabilityGatherer.getCapabilities(Gt.MEDIA_TYPE.audio)).codecs.map((g)=>g.mimeType);
                        this.offeredDescription.usePrimaryAudioCodecOnly(g);
                    } catch (g) {
                        this.logger.safe.error(`[${f}] failed to set primary codec based on audio capability ${stringifyObject(g)}`);
                    }
                    _.markAndMeasure("assurePeerConnectionAsync", "handleCodecSwitchUnsupported"), this.audioCodecManager.prepareForNegotiation(this.initiatorInternal), this.offeredDescription.setModalities(C), await this.detectSendProfileSupport();
                    const T = this.offeredDescription.toRemote(g || E);
                    this.configProvider.config.createProvisionalAnswer.streamsBeforeSetFullRD && !g && E && [
                        "have-remote-offer",
                        "stable"
                    ].includes(this.transportStateProvider.signalingState) && !this.initialNegotiationCompleted && (this.logger.safe.info(`[${f}] create [${S}] provisional was applied, requesting streams and activating senders before set remote description is finished`), await this.updateStreamSenders(_, f, g, C)), this.logger.unsafe.info(`[${f}] create [${S}] set remote description', 'negotiated:`, C, "sdp:", T), await this.callbacks.setRemoteDescription({
                        sdp: T,
                        type: "offer"
                    }), _.markAndMeasure("handleCodecSwitchUnsupported", "setRemoteDescription"), (_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.updateDataModalityState(this.negotiatingModalities.data), await this.updateStreamSenders(_, f, g, C), _.markAndMeasure("assurePeerConnectionAsync", "assureStreamsAndDataChannel"), _.markAndMeasure("setRemoteDescription", "assureStreamsAndDataChannel"), this.callbacks.onTransportInitialized();
                    const I = this.configProvider.config.createProvisionalAnswer.setProperAnswerType ? await this.callbacks.createAnswer({
                        type: S
                    }) : await this.callbacks.createAnswer();
                    _.markAndMeasure("assureStreamsAndDataChannel", "createAnswer"), this.logger.unsafe.info(`[${f}] create [${S}] answer from peer connection type: ${I.type}, sdp:`, I.sdp);
                    const b = this.sessionDescription.createLocalAnswer(I.sdp);
                    this.hasIceCandidates(b) || this.resetCandidateGathering(f), this.callbacks.startWaitingForStreamStart(C), this.setupIceGatheringTimeout(f);
                    const A = b.toLocal();
                    this.logger.unsafe.info(`[${f}] create [${S}] set local description sdp:`, A), await this.callbacks.setLocalDescription({
                        sdp: A,
                        type: this.configProvider.config.createProvisionalAnswer.setProperAnswerType ? S : "answer"
                    }), _.markAndMeasure("createAnswer", "sLD"), await this.iceCandidatesDeferred.promise, _.markAndMeasure("sLD", "candidates");
                    const R = this.sessionDescription.createLocalAnswer(this.callbacks.getLocalDescription().sdp);
                    this.fixLocalDescription(R), R.updateModalities(C), this.checkIceCandidates(R), g && this.configProvider.config.createProvisionalAnswer.forceRecvonly && (this.logger.safe.info(`[${f}] create [${S}] munge returned local sdp to recvonly modalities`), R.forceRecvonly());
                    const P = R.toAnswer();
                    (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.setRecvPayloads(R.getPayloadsForMedia(Gt.MEDIA_TYPE.audio)), this.checkAudioCodecNegotiated(f), g ? this.logger.safe.debug(`[${f}] create [${S}] skip stream senders manager activation`) : (this.logger.safe.debug(`[${f}] create [${S}] activating stream senders manager`), await this.streamSendersManager.activate(f)), _.markAndMeasure("candidates", "streamSendersManagerActivate"), g ? this.logger.safe.debug(`[${f}] create [${S}] skip updating sources and capabilities`) : (this.logger.safe.debug(`[${f}] create [${S}] updating sources and capabilities`), this.callbacks.updateLocalMediaSources(), this.applyReceiveCapabilities(f)), C = R.getModalities(), this.reinvitelessContext.enabled && (C = removeChangedSendDirection(this.negotiatingModalities, C)), areNegotiatedDirectionsAcceptable(this.configuredModalities, this.negotiatingModalities, C) || this.triggerRenegotiation(!0, f), this.negotiatedModalities = C, this.diagnostics.bweType = R.getBweType(), this.logger.unsafe.info(`[${f}] CREATE ANSWER`, "sdp:", P);
                    const w = {
                        blob: P,
                        contentType: this.mediaContentType
                    };
                    return this.configProvider.countryCode && (w.clientLocation = this.configProvider.countryCode), this.reinvitelessContext.enabled && (w.mediaDescriptions = this.getMediaDescriptions(C)), this.callbacks.setBWSeed(w), _.markAndMeasure("start", v), w;
                }
                async detectSendProfileSupport() {
                    if (this.configProvider.config.preferredH264VideoSendProfile || this.configProvider.config.preferredH264SharingSendProfile) {
                        let g = this.capabilityGatherer;
                        this.configProvider.config.learnCodecSendCapabilitiesFromSenderApi && (g = eb.build({
                            global: this.sessionContext.maContext
                        }, this.configProvider.config.useSdpCapabilities, this.configProvider.config.noRequiredCodecsWorkaround, !0));
                        const f = await g.getCapabilities("video"), S = this.mediaManager.getMediaEntities().filter((g)=>{
                            const f = g.getModality();
                            return f === Gt.MEDIA_TYPE.video || f === Gt.MEDIA_TYPE.sharing;
                        }).filter((g)=>g.isEnabled());
                        for (const g of f.codecs)if (g.sdpFmtpLine && g.mimeType.toLocaleLowerCase().includes("h264")) {
                            const f = g.sdpFmtpLine.match(/profile-level-id=([a-fA-F0-9]{6})/);
                            2 === (f === null || f === void 0 ? void 0 : f.length) && S.forEach((g)=>g.addSupportedSendProfile("H264", f[1]));
                        }
                    }
                }
                async updateStreamSenders(g, f, S, v) {
                    this.transceiverManager.syncTransceivers(v), this.mediaManager.getMediaEntities().forEach((g)=>{
                        g.setExtension("midApplied", !0);
                    });
                    const _ = isOnHold(this.negotiatingModalities);
                    if (isOnHold(this.negotiatedModalities) !== _ && (g === null || g === void 0 ? void 0 : g.mark("startConfigureHold"), await this.streamSendersManager.setHold(_, f), g === null || g === void 0 ? void 0 : g.markAndMeasure("startConfigureHold", "configureHold")), _) this.logger.safe.info(`[${f}] Hold is configured. Not updating streams`);
                    else {
                        let _ = this.configProvider.config.negotiationParallelStreamAcquisitionCreateAnswer && !this.initialNegotiationCompleted ? 2 : 0;
                        S && (_ = 4), await this.streamSendersManager.update(v, _, f), g === null || g === void 0 ? void 0 : g.markAndMeasure("configureHold", "updateStreams");
                    }
                }
                configureBroadcastScenario(g, f) {
                    var _S_townHallScenarioNames;
                    const S = this.configProvider.config.broadcastMode;
                    if (this.diagnostics.meetingScenario = g.meetingScenario, ((S === null || S === void 0 ? void 0 : S.prioritizeLayoutOnServer) || (S === null || S === void 0 ? void 0 : S.prioritizeLayoutOnClient) || (S === null || S === void 0 ? void 0 : S.maxSessionBandwidthKbps)) && g.meetingScenario && ((_S_townHallScenarioNames = S.townHallScenarioNames) === null || _S_townHallScenarioNames === void 0 ? void 0 : _S_townHallScenarioNames.length)) -1 !== S.townHallScenarioNames.map((g)=>g.toLowerCase()).indexOf(g.meetingScenario.toLowerCase()) && (this.sessionContext.config.isTownHall = !0, this.diagnostics.isTownHall = !0, (S === null || S === void 0 ? void 0 : S.maxSessionBandwidthKbps) && this.configProvider.overrideMaxSessionBandwidth(S.maxSessionBandwidthKbps) && (this.logger.safe.info(`Adjusting maxSessionBandwidth for TownHall: ${this.configProvider.mediaConfig.maxBandwidthInKbps}`), this.triggerRenegotiation(!0, f)));
                }
                async processAnswer(g, f, S, v = !1) {
                    try {
                        var _this_dataChannel;
                        const _ = g.blob;
                        this.logger.unsafe.debug(S ? `[${f}] PROCESS PRANSWER` : `[${f}] PROCESS ANSWER`, "sdp:", _);
                        const C = S ? "pranswer" : "answer";
                        if (S && (!acceptProvisionalAnswer(this.sessionContext, v) || "have-local-offer" !== this.transportStateProvider.signalingState)) return void this.logger.safe.info(`[${f}] process [${C}] ignored`);
                        this.configureBroadcastScenario(g, f);
                        const E = this.diagnostics.getTimerTracker("" + (S ? "processProvisionalAnswerAsync" : "processAnswerAsync"), {
                            first: !0
                        });
                        E.mark("start");
                        const T = this.sessionDescription.createRemoteAnswer(_);
                        let I = invertModalities(T.getModalities());
                        this.reinvitelessContext.enabled && (I = removeChangedSendDirection(this.offeredModalities, I)), T.setModalities(I), await this.detectSendProfileSupport();
                        const b = T.toRemote();
                        if (S || (this.useNGC1webrtcContentType || (this.mediaContentType = g.contentType), -1 === this.allowedMediaContentType.indexOf(this.mediaContentType) && this.allowedMediaContentType.push(this.mediaContentType), isOnHold(I) || (await this.streamSendersManager.update(I, 1, f), E.markAndMeasure("start", "streamSendersManagerUpdate"), hasSendDirectionality(this.offeredModalities.data) && !I.data && ((_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.disable())), this.negotiatedModalities = I, this.callbacks.updateLocalMediaSources(), this.diagnostics.bweType = T.getBweType()), this.callbacks.onTransportInitialized(), this.logger.unsafe.info(`[${f}] process [${C}] set remote description`, "negotiated:", I, "sdp:", b), E.mark("startSetRemoteDescription"), await this.callbacks.setRemoteDescription({
                            sdp: b,
                            type: C
                        }), E.markAndMeasure("startSetRemoteDescription", "setRemoteDescription"), S) return;
                        await this.streamSendersManager.activate(f), E.markAndMeasure("setRemoteDescription", "streamSendersManagerActivate"), this.applyReceiveCapabilities(f), this.checkAudioCodecNegotiated(f), this.transceiverManager.syncTransceivers(I), E.markAndMeasure("start", "processAnswerAsync");
                    } catch (g) {
                        if (S) return void this.logger.safe.warn(`Error thrown during pranswer generation, ignoring: ${stringifyObject(g)}`);
                        throw g;
                    }
                }
                async createOfferAsync(g, f) {
                    var _this_transceiverManager, _this_dataChannel, _this_sessionContext_config, _this_audioCodecManager_decoder, _this_offeredDescription;
                    const S = this.diagnostics.getTimerTracker("createOfferAsync", {
                        first: !0
                    });
                    if (S.mark("start"), this.logger.safe.info(`[${g}] create [offer] configured: ${JSON.stringify(this.configuredModalities)}`), this.initiatorInternal = !0, !this.configuredModalities) throw new Error("no configured modalities to create offer for");
                    this.canTriggerRenegotiation = !1, this.negotiatingModalities = this.configuredModalities, await this.callbacks.assurePC(g, S.clone("assurePeerConnectionAsync")), S.markAndMeasure("start", "assurePeerConnectionAsync"), this.logger.safe.info(`[${g}] updatePeerConnectionStreamsAsync, pc state: ${JSON.stringify(this.transportStateProvider.signalingState)}`), isOnHold(this.negotiatingModalities) && !isEmpty(this.negotiatedModalities) && Object.keys(this.negotiatingModalities).forEach((g)=>{
                        void 0 === this.negotiatedModalities[g] && delete this.negotiatingModalities[g];
                    }), (_this_transceiverManager = this.transceiverManager) === null || _this_transceiverManager === void 0 ? void 0 : _this_transceiverManager.assureTransceivers(this.negotiatingModalities), (_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.updateDataModalityState(this.negotiatingModalities.data);
                    const v = isOnHold(this.negotiatingModalities);
                    let _;
                    isOnHold(this.negotiatedModalities) !== v && (S === null || S === void 0 ? void 0 : S.mark("startConfigureHold"), await this.streamSendersManager.setHold(v, g), S === null || S === void 0 ? void 0 : S.markAndMeasure("startConfigureHold", "configureHold")), v ? (this.logger.safe.info(`[${g}] Hold is configured. Not updating streams`), _ = this.negotiatingModalities) : (_ = await this.streamSendersManager.update(this.negotiatingModalities, this.configProvider.config.negotiationParallelStreamAcquisitionCreateOffer && !this.initialNegotiationCompleted ? 2 : 0, g), S === null || S === void 0 ? void 0 : S.markAndMeasure("configureHold", "updateStreams"), this.dataChannel && this.negotiatingModalities.data && (_.data = this.negotiatingModalities.data)), S.markAndMeasure("assurePeerConnectionAsync", "assureStreamsAndDataChannel"), this.offeredModalities = _, !allowDataChannel(this.sessionContext) && this.configProvider.config.webrtcNegotiateDisabledDataModality && !this.offeredModalities[Gt.MODALITY.data] && ((_this_sessionContext_config = this.sessionContext.config) === null || _this_sessionContext_config === void 0 ? void 0 : _this_sessionContext_config.isConference) && (this.offeredModalities[Gt.MODALITY.data] = Gt.MEDIA_STATE.inactive), this.audioCodecManager.prepareForNegotiation(this.initiatorInternal), this.logger.safe.info(`[${g}] create [offer] offered: ${JSON.stringify(this.offeredModalities)}`);
                    const C = await this.callbacks.createOffer();
                    S.markAndMeasure("assureStreamsAndDataChannel", "createOffer"), this.logger.unsafe.info(`[${g}] create [offer] offer from peer connection, sdp: ${C.sdp}`);
                    const E = this.sessionDescription.createLocalOffer(C.sdp);
                    this.hasIceCandidates(E) || this.resetCandidateGathering(g), this.callbacks.startWaitingForStreamStart(_), this.setupIceGatheringTimeout(g);
                    const T = E.toLocal();
                    this.logger.unsafe.info(`[${g}] create [offer] set local description`, "sdp:", T), await this.callbacks.setLocalDescription({
                        sdp: T,
                        type: "offer"
                    }), S.markAndMeasure("createOffer", "sLD"), await this.iceCandidatesDeferred.promise, S.markAndMeasure("sLD", "candidates");
                    const I = this.sessionDescription.createLocalOffer(this.callbacks.getLocalDescription().sdp);
                    this.fixLocalDescription(I), I.updateModalities(this.offeredModalities), this.checkIceCandidates(I);
                    const b = I.toOffer();
                    this.logger.unsafe.info(`[${g}] CREATE OFFER`, "sdp:", b);
                    const A = {
                        blob: b,
                        contentType: this.mediaContentType
                    };
                    "" === this.configProvider.mediaConfig.webrtcRequiredFeatures || this.sessionContext.config.isConference || (A.requiredFeatures = this.configProvider.mediaConfig.webrtcRequiredFeatures), (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.setRecvPayloads(I.getPayloadsForMedia(Gt.MEDIA_TYPE.audio)), this.configProvider.countryCode && (A.clientLocation = this.configProvider.countryCode), this.mediaManager.getMediaEntities().forEach((g)=>{
                        g.setExtension("midApplied", !0);
                    });
                    const R = E.isIceRestart();
                    return this.logger.safe.info(`[${g}] ICE restart: ${R}`), this.configProvider.mediaConfig.isTransportUnbundled && ((_this_offeredDescription = this.offeredDescription) === null || _this_offeredDescription === void 0 ? void 0 : _this_offeredDescription.isMSRTC()) && R && !this.sessionContext.config.isConference && E.getSrtpInfo().sdes && (A.newOffer = !0), this.reinvitelessContext.enabled && (this.mediaManager.updateMediaEntitiesWithLocalTracks(), A.mediaDescriptions = this.getMediaDescriptions(this.offeredModalities)), f && (A.negotiationTag = f), this.callbacks.setBWSeed(A), S.markAndMeasure("start", "createOfferAsync"), A;
                }
                async processOfferAsync(g, f) {
                    var _this_dataChannel;
                    const S = this.diagnostics.getTimerTracker("processOfferAsync", {
                        first: !0
                    });
                    S.mark("start"), this.mediaManager.backup();
                    const v = g.blob;
                    if (this.logger.unsafe.info(`[${f}] process [offer]`, "sdp:", v), this.configProvider.config.webrtcCompareContentTypeInOffer && !this.useNGC1webrtcContentType && (assertContentTypeSupported(g.contentType, this.allowedMediaContentType), this.mediaContentType = g.contentType), this.configureBroadcastScenario(g, f), this.offerOriginator && this.offerOriginator !== g.originator && this.configProvider.config.rejectIncompatibleOriginator) throw {
                        detail: "mediaContent.originator is different on renegotiation",
                        type: Gt.MEDIA_ERROR.incompatibleOriginator
                    };
                    if (this.offerOriginator = g.originator, g.requiredFeatures) {
                        const f = this.configProvider.mediaConfig.webrtcRejectedFeatures.split(",");
                        throwIfFeatureNotSupported(g.requiredFeatures.split(","), f);
                    }
                    if (this.initiatorInternal = !1, this.offeredDescription = this.sessionDescription.createRemoteOffer(v), this.configProvider.config.multiStreamSupported) {
                        const g = getMultiStreamCountFromSdp(v), S = this.configProvider.config.numVideoChannelsGvc - this.configProvider.config.nonMultiStreamChannels;
                        this.configProvider.mediaConfig.multiStreamChannelsOffered = g, g < S && (this.logger.safe.info(`Received ${g} multi stream channels, ${S} channels supported`), this.triggerRenegotiation(!0, f));
                    }
                    this.canTriggerRenegotiation = !1, this.offeredModalities = invertModalities(this.offeredDescription.getModalities()), this.callbacks.hasPC() || (this.configProvider.mediaConfig.isTransportUnbundled ? this.configProvider.mediaConfig.isTransportUnbundled = this.offeredDescription.couldBeUnbundled() : this.configProvider.mediaConfig.isTransportUnbundled = this.offeredDescription.isUnbundled());
                    let _ = this.configProvider.config.removeUnsupportedVideoModality ? this.offeredModalities : shallowClone(this.offeredModalities);
                    if (hasSendDirectionality(this.offeredModalities.video) || hasReceiveDirectionality(this.offeredModalities.video) || hasSendDirectionality(this.offeredModalities.sharing) || hasReceiveDirectionality(this.offeredModalities.sharing)) {
                        const g = this.offeredDescription.getVideoCodecs();
                        try {
                            S.mark("startGetCapabilities");
                            const v = await this.capabilityGatherer.getCapabilities("video");
                            S.markAndMeasure("startGetCapabilities", "getCapabilities");
                            v.codecs.some((f)=>g.some((g)=>f.mimeType === g && this.configProvider.config.primaryVideoCodecs.includes(g))) || (this.logger.safe.warn(`[${f}] offer doesn't contain any supported video codecs`), this.disabledModalities.video = _.video, this.disabledModalities.sharing = _.sharing, delete _.video, delete _.sharing);
                        } catch (g) {
                            this.logger.safe.error(`[${f}] failed to get video capability ${stringifyObject(g)}`);
                        }
                    }
                    return (!allowDataChannel(this.sessionContext) && (hasSendDirectionality(this.offeredModalities.data) || hasReceiveDirectionality(this.offeredModalities.data)) || "Failed" === ((_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.state)) && (this.logger.safe.info(`[${f}] Supressing data modality as data channel is not possible`), _ = shallowClone(_), delete _.data), S.markAndMeasure("start", "processOfferAsync"), this.logger.safe.info(`[${f}] process [offer] offered: ${JSON.stringify(this.offeredModalities)} acceptable: ${JSON.stringify(_)}`), _;
                }
                async startMediaDescriptionsUpdate(g, f) {
                    var _this_reinvitelessRequestedModalities, _this_dataChannel;
                    (_this_dataChannel = this.dataChannel) === null || _this_dataChannel === void 0 ? void 0 : _this_dataChannel.updateDataModalityState((_this_reinvitelessRequestedModalities = this.reinvitelessRequestedModalities) === null || _this_reinvitelessRequestedModalities === void 0 ? void 0 : _this_reinvitelessRequestedModalities.data);
                    const S = isOnHold(this.negotiatedModalities), v = isOnHold(this.reinvitelessRequestedModalities);
                    return S !== v && await this.streamSendersManager.setHold(v, g), v ? this.reinvitelessAppliedModalities = this.reinvitelessRequestedModalities : (this.reinvitelessAppliedModalities = await this.streamSendersManager.update(this.reinvitelessRequestedModalities, 0, g), this.dataChannel && this.reinvitelessRequestedModalities.data && (this.reinvitelessAppliedModalities.data = this.reinvitelessRequestedModalities.data)), this.callbacks.updateLocalMediaSources(), await this.streamSendersManager.activate(g), this.getMediaDescriptions(this.reinvitelessAppliedModalities, f);
                }
                async completeMediaDescriptionsUpdate(g) {
                    this.logger.safe.info(`[${g}] complete media descriptions update`), this.negotiatedModalities = this.reinvitelessAppliedModalities;
                    const f = this.reinvitelessAppliedModalities, S = this.reinvitelessRequestedModalities;
                    return this.reinvitelessAppliedModalities = {}, this.reinvitelessRequestedModalities = {}, {
                        appliedModalities: f,
                        requestedModalities: S
                    };
                }
                async rejectMediaDescriptionsUpdate(g, f = !1) {
                    this.logger.safe.info(`[${g}] reject media descriptions update`), f && (this.logger.safe.info(`[${g}] trigger renegotiation after failed media descriptions update`), this.triggerRenegotiation(!1, g));
                    const S = await this.streamSendersManager.update(this.negotiatedModalities, 1, g), v = this.reinvitelessRequestedModalities;
                    return this.reinvitelessAppliedModalities = {}, this.reinvitelessRequestedModalities = {}, {
                        appliedModalities: S,
                        requestedModalities: v
                    };
                }
                getMediaDescriptions(g, f) {
                    if (isOnHold(g)) return {};
                    const S = [];
                    for (const f of this.mediaManager.getMediaEntities()){
                        if (!f.getExtension("reinviteless")) continue;
                        const v = g[f.getModality()], _ = {
                            mid: f.getMid(),
                            direction: !f.getLocalTrackId() && hasSendDirectionality(v) ? removeSendDirectionality(v) : v
                        };
                        S.push(_);
                    }
                    return {
                        descriptions: S,
                        negotiationTag: f
                    };
                }
                updateSendStreamsReinviteless(g, f) {
                    if (isEmpty(this.negotiatedModalities) || isOnHold(this.negotiatedModalities) || isOnHold(this.configuredModalities)) return !1;
                    this.reinvitelessRequestedModalities = shallowClone(this.negotiatedModalities);
                    for (const [g, f] of Object.entries(this.configuredModalities)){
                        const S = this.mediaManager.getMediaEntitiesByModality(g)[0];
                        (S === null || S === void 0 ? void 0 : S.getExtension("reinviteless")) && (this.reinvitelessRequestedModalities[g] = f);
                    }
                    return !deepEqual(this.reinvitelessRequestedModalities, this.negotiatedModalities) && (this.callbacks.onUpdateMediaDescriptionsRequired(g, f), deepEqual(this.reinvitelessRequestedModalities, this.configuredModalities));
                }
                checkAudioCodecNegotiated(g) {
                    var _this_audioCodecManager_decoder_getUnmixedAudioProvider, _this_audioCodecManager_decoder;
                    const f = this.audioCodecManager.negotiationCompleted();
                    if ((_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : (_this_audioCodecManager_decoder_getUnmixedAudioProvider = _this_audioCodecManager_decoder.getUnmixedAudioProvider()) === null || _this_audioCodecManager_decoder_getUnmixedAudioProvider === void 0 ? void 0 : _this_audioCodecManager_decoder_getUnmixedAudioProvider.configured) {
                        const S = f ? "Good" : "Bad";
                        this.ufdManager.signalEvent("SpatialAudioMUCHUnavailable", S, "Audio", !0, g);
                    }
                }
                fixLocalDescription(g) {
                    this.configProvider.config.insertFakeCandidateIfNeeded && (this.iceCandidateReceivedInternal || !this.iceCandidateReceivedInternal && this.transportStateProvider.isIceConnected) && (this.diagnostics.fakeCandidate = g.insertFakeCandidateIfNeeded()), g.fixDataModality();
                }
                applyReceiveCapabilities(g) {
                    var _this_sessionContext_config;
                    const f = this.mediaManager.getMediaEntities().map((g)=>g.getRemoteRecvCapabilities());
                    ((_this_sessionContext_config = this.sessionContext.config) === null || _this_sessionContext_config === void 0 ? void 0 : _this_sessionContext_config.isConference) ? this.qualityManager.setPendingCapabilities() : this.qualityManager.setMaxCapabilities(f, g);
                }
                resetNegotiationQueue(g) {
                    this.negotiationCompletedDefer.reject("promise expired"), this.setNegotiationPromise(new ct, g);
                }
                setNegotiationPromise(g, f = generateCauseId()) {
                    this.terminated || (this.negotiationCompletedDefer = g, this.negotiationQueue.add(this.negotiationCompletedDefer, f));
                }
                hasIceCandidates(g) {
                    return this.configProvider.mediaConfig.isTransportUnbundled ? g.hasUnbundledIceCandidates() : g.hasIceCandidates();
                }
                checkIceCandidates(g) {
                    const f = this.hasIceCandidates(g);
                    if (f === this.noIceCandidates && (this.noIceCandidates = !this.noIceCandidates, this.ufdManager.signalEvent("NoNetwork", this.noIceCandidates ? "Bad" : "Good"), this.noIceCandidates)) throw {
                        type: Gt.MEDIA_ERROR.noNetworkError,
                        detail: "no ice candidates"
                    };
                    if (f) {
                        const f = this.hasRelayIceCandidates(g);
                        if (f === this.noRelayIceCandidates) {
                            if (!f && this.transportStateProvider.isIceConnected) return;
                            this.noRelayIceCandidates = !this.noRelayIceCandidates, this.ufdManager.signalEvent("NetworkRelaysNotReachable", this.noRelayIceCandidates ? "Bad" : "Good");
                        }
                    }
                }
                hasRelayIceCandidates(g) {
                    return this.configProvider.mediaConfig.isTransportUnbundled ? g.hasUnbundledRelayIceCandidates() : g.hasRelayIceCandidates();
                }
                setupIceGatheringTimeout(g) {
                    this.iceRelayCandidatesGatherStartTime = Date.now();
                    const f = this.sessionContext.config.webrtcIceGatheringTimeoutIncreased ? this.configProvider.config.relayWaitSaneTimeoutMs : this.configProvider.config.webrtcIceGatheringTimeoutMs;
                    if (!f) return;
                    this.iceCandidatesTimer && clearTimeout(this.iceCandidatesTimer);
                    const S = this.iceCandidatesDeferred;
                    this.iceCandidatesTimer = window.setTimeout(()=>{
                        this.iceCandidatesTimer = void 0, S.isPending && (this.logger.safe.warn(`[${g}] ICE candidates gathering terminated due to timeout ${f}`), S.resolve());
                    }, f);
                }
                resetCandidateGathering(g) {
                    this.logger.safe.info(`[${g}] reset candidate gathering`), this.iceCandidatesDeferred.promise.then(()=>{}, ()=>{}), this.iceCandidatesDeferred.reject(new Error("reset candidate gathering")), this.iceCandidatesDeferred = new ct, this.iceCandidateReceivedInternal = !1;
                }
                set offeredModalities(g) {
                    this.offeredModalitiesInternal = g, this.diagnostics.offeredModalities = g;
                }
                set negotiatedModalities(g) {
                    this.logger.safe.info(`setNegotiatedModalities ${JSON.stringify(g)}`), this.negotiatedModalitiesInternal = g, this.diagnostics.negotiatedModalities = g;
                }
                set configuredModalities(g) {
                    this.configuredModalitiesInternal = g;
                }
                set mediaContentType(g) {
                    this.mediaContentTypeInternal = g;
                }
                constructor(g, f, S, v, _, C, E, T, I, b, A){
                    this.logger = g, this.configProvider = f, this.diagnostics = S, this.reinvitelessContext = v, this.mediaManager = _, this.audioCodecManager = C, this.ufdManager = E, this.sessionContext = T, this.qualityManager = I, this.streamSendersManager = b, this.callbacks = A, this.negotiationQueue = new q_(this.logger), this.negotiatedModalitiesInternal = {}, this.disabledModalitiesInternal = {}, this.initiatorInternal = !1, this.noIceCandidates = !1, this.noRelayIceCandidates = !1, this.isRollbackSupported = !1, this.canTriggerRenegotiation = !0, this.triggerRenegotiationFlag = !1, this.capabilityGatherer = eb.build({
                        global: this.sessionContext.maContext
                    }, this.configProvider.config.useSdpCapabilities, this.configProvider.config.noRequiredCodecsWorkaround), this.mediaContentTypeInternal = getFrom("webrtcMediaContentType", this.sessionContext.config, this.configProvider.config), this.allowedMediaContentTypeInternal = getFrom("webrtcAllowedMediaContentType", this.sessionContext.config, this.configProvider.config).concat(), this.useNGC1webrtcContentType = getFrom("useNGC1webrtcContentType", this.sessionContext.config, this.configProvider.config), this.negotiationCompletedDefer = new ct, this.iceCandidatesDeferred = new ct, this.iceCandidateReceivedInternal = !1, this.initialNegotiationCompleted = !1, this.terminated = !1, this.sessionDescription = FE.build({
                        sdpTransform: new LA(this.sessionContext),
                        mediaManager: this.mediaManager,
                        logger: this.logger,
                        configProvider: this.configProvider,
                        configuration: {
                            unifiedPlanEnabled: !0,
                            addPrefixForMsid: this.configProvider.config.addPrefixForMsidInSdp
                        }
                    }), this.negotiationEmulator = new hb(this.logger.createChild("negotiationEmulator"), FA, this.sessionDescription, this.negotiationQueue, this.mediaManager), this.negotiationCompletedDefer.promise.catch(()=>{}), this.negotiationCompletedDefer.reject("placeholder");
                }
            };
            function acceptProvisionalAnswer(g, f = !1) {
                const S = !g.configProvider.config.acceptProvisionalAnswerFromPstnOnly || f;
                return g.config.isPstnCall ? g.configProvider.config.acceptProvisionalAnswerPstn && S : g.configProvider.config.acceptProvisionalAnswer;
            }
            var UA = class {
                setRecord(g, f, S) {
                    const v = {
                        sequenceNumber: f,
                        timestamp: Date.now(),
                        sourceId: S === null || S === void 0 ? void 0 : S.sourceId,
                        fmtp: S === null || S === void 0 ? void 0 : S.fmtParams
                    };
                    var _g_records;
                    (_g_records = g.records) !== null && _g_records !== void 0 ? _g_records : g.records = [], arrayLimitedPush2(g.records, v, this.mcpConfig.storedSRRecordsCount);
                }
                recordSignalingOperation(g, f) {
                    var S;
                    var _g;
                    (_g = (S = this.data.sourceRequestsSignaling)[g]) !== null && _g !== void 0 ? _g : S[g] = {
                        counter: 0
                    }, this.data.sourceRequestsSignaling[g].counter++;
                }
                recordMCPOperation(g, f, S) {
                    var v;
                    var _g;
                    (_g = (v = this.data.sourceRequestsMCP)[g]) !== null && _g !== void 0 ? _g : v[g] = {
                        counter: 0
                    }, this.data.sourceRequestsMCP[g].counter++, this.mcpConfig.verboseTelemetry && this.setRecord(this.data.sourceRequestsMCP[g], f, S);
                }
                recordError(g, f) {
                    const S = [
                        Date.now(),
                        f,
                        g
                    ];
                    arrayLimitedPush2(this.data.errors, S, this.mcpConfig.storedSRRecordsCount);
                }
                recordSignalingOperationDuration(g, f) {
                    var _this_data_sourceRequestsSignaling_g_records, _this_data_sourceRequestsSignaling_g;
                    const S = (_this_data_sourceRequestsSignaling_g = this.data.sourceRequestsSignaling[g]) === null || _this_data_sourceRequestsSignaling_g === void 0 ? void 0 : (_this_data_sourceRequestsSignaling_g_records = _this_data_sourceRequestsSignaling_g.records) === null || _this_data_sourceRequestsSignaling_g_records === void 0 ? void 0 : _this_data_sourceRequestsSignaling_g_records.find((g)=>g.sequenceNumber === f);
                    S && (S.duration = Date.now() - S.timestamp);
                }
                recordMCPMessageFallback(g, f) {
                    if (this.data.fallbackMCPMessagesCounter++, this.mcpConfig.verboseTelemetry) {
                        var _this_data_sourceRequestsMCP_f_records, _this_data_sourceRequestsMCP_f;
                        const S = (_this_data_sourceRequestsMCP_f = this.data.sourceRequestsMCP[f]) === null || _this_data_sourceRequestsMCP_f === void 0 ? void 0 : (_this_data_sourceRequestsMCP_f_records = _this_data_sourceRequestsMCP_f.records) === null || _this_data_sourceRequestsMCP_f_records === void 0 ? void 0 : _this_data_sourceRequestsMCP_f_records.find((f)=>f.sequenceNumber === g);
                        S && (S.fallback = !0, S.fallbackTimestamp = Date.now());
                    }
                }
                recordSrResultReceived(g, f, S) {
                    var v;
                    if (this.mcpConfig.verboseTelemetry) {
                        var _this_data_sourceRequestsMCP_S_records, _this_data_sourceRequestsMCP_S;
                        const v = (_this_data_sourceRequestsMCP_S = this.data.sourceRequestsMCP[S]) === null || _this_data_sourceRequestsMCP_S === void 0 ? void 0 : (_this_data_sourceRequestsMCP_S_records = _this_data_sourceRequestsMCP_S.records) === null || _this_data_sourceRequestsMCP_S_records === void 0 ? void 0 : _this_data_sourceRequestsMCP_S_records.find((g)=>g.sequenceNumber === f);
                        v && (v.duration = Date.now() - v.timestamp, v.result = g);
                    }
                    var _g;
                    (_g = (v = this.data.sourceRequestsResponses)[g]) !== null && _g !== void 0 ? _g : v[g] = 0, this.data.sourceRequestsResponses[g]++;
                }
                getObjectRef() {
                    return this.data;
                }
                constructor(g){
                    this.mcpConfig = g, this.data = {
                        sourceRequestsSignaling: {},
                        sourceRequestsMCP: {},
                        fallbackMCPMessagesCounter: 0,
                        sourceRequestsResponses: {},
                        errors: []
                    };
                }
            }, VA = 5, BA = class {
                get getSourceRequestSenderDiagnostics() {
                    return this.sourceRequestSenderDiagnostics;
                }
                logStarted() {
                    if (this.storage.startedCount++, this.storage.startedCount > VA) return;
                    const g = {
                        startedTs: duration(this.storage.createTime),
                        mpCapabilities: {},
                        sentMessages: {},
                        recvMessages: {},
                        sentFailed: 0,
                        recvFailed: 0,
                        cachedDshReceived: !1
                    };
                    this.storage.events.push(g), this.lastEventConnecting = !0;
                }
                logStopped() {
                    this.storage.stoppedCount++;
                    const g = this.getCurrentDCSessionEvent();
                    g && (g.stoppedTs = duration(this.storage.createTime)), this.lastEventConnecting = !1;
                }
                logSentMsg(g) {
                    var f, S;
                    const v = this.getCurrentDCSessionEvent();
                    var _;
                    v && ((_ = (f = v.sentMessages)[S = g.type]) !== null && _ !== void 0 ? _ : f[S] = 0, v.sentMessages[g.type]++);
                }
                logReceivedMsg(g) {
                    var f, S;
                    this.lastEventConnecting = !1;
                    const v = this.getCurrentDCSessionEvent();
                    var _;
                    v && ((_ = (f = v.recvMessages)[S = g.type]) !== null && _ !== void 0 ? _ : f[S] = 0, v.recvMessages[g.type]++, "dsh" !== g.type || v.handshakeDuration || (v.cachedDshReceived = !0));
                }
                logHandshakeStarted(g) {
                    const f = this.getCurrentDCSessionEvent();
                    f && (f.handshakeStartedTs = Date.now()), this.storage.clientCapabilities = g;
                }
                logHandshakeCompleted(g) {
                    const f = this.getCurrentDCSessionEvent();
                    f && (f.handshakeDuration || (f.handshakeDuration = duration(f.handshakeStartedTs)), f.mpCapabilities.send = g.send_capabilities, f.mpCapabilities.recv = g.receive_capabilities);
                }
                logHandshakeFailed(g) {
                    const f = this.getCurrentDCSessionEvent();
                    f && (f.handshakeDuration = duration(f.handshakeStartedTs), f.handshakeFailedWithError = g);
                }
                logSentFailed(g) {
                    const f = this.getCurrentDCSessionEvent();
                    f && (f.sentFailed++, f.lastSentFailed = {
                        ts: duration(this.storage.createTime),
                        error: g
                    });
                }
                logRecvFailed(g) {
                    const f = this.getCurrentDCSessionEvent();
                    f && (f.recvFailed++, f.lastRecvFailed = {
                        ts: duration(this.storage.createTime),
                        error: g
                    });
                }
                logTimeout() {
                    if (this.storage.startedCount >= VA && !this.lastEventConnecting) return;
                    const g = {
                        timeoutTs: Date.now()
                    }, f = this.getCurrentDCSessionEvent();
                    f && (g.handshakeStartedTs = f.handshakeStartedTs), this.lastEventConnecting && this.storage.events.pop(), this.storage.events.push(g), this.lastEventConnecting = !1;
                }
                getReport() {
                    const g = this.sourceRequestSenderDiagnostics.getObjectRef();
                    return this.storage.sourceRequestsReport = g, this.storage;
                }
                getCurrentDCSessionEvent() {
                    const g = this.storage.events[this.storage.events.length - 1];
                    return this.storage.startedCount <= VA && void 0 !== (g === null || g === void 0 ? void 0 : g.startedTs) ? g : null;
                }
                constructor(g){
                    this.mcpConfig = g, this.storage = {
                        createTime: Date.now(),
                        startedCount: 0,
                        stoppedCount: 0,
                        clientCapabilities: [],
                        events: []
                    }, this.sourceRequestSenderDiagnostics = new UA(this.mcpConfig);
                }
            };
            function duration(g) {
                return Date.now() - g;
            }
            var HA = 4294967292, $A = class extends ze {
                getTelemetryLogger() {
                    return this.telemetryLogger;
                }
                mcpFeaturesSupported(g) {
                    return this.mcpSupportedFeautres[g];
                }
                switchMcpFeauture(g, f) {
                    this.logger.warn(`Switching ${g} to ${f}`), this.mcpSupportedFeautres[g] = f;
                }
                getConfig() {
                    return this.mcpConfig;
                }
                getMcpState() {
                    return this.mcpState;
                }
                dispose() {
                    super.dispose(), clearTimeout(this.handshakeTimeout), this.handshakeTimeout = null, this.mcpState = "Inactive", this.switchMcpFeauture("sourceRequestsEnabled", !1), this.switchMcpFeauture("sourceRequestsResponseEnabled", !1);
                }
                getTelemetryReport() {
                    return this.logger.debug(`Telemetry ${JSON.stringify(this.telemetryLogger.getReport())}`), this.telemetryLogger.getReport();
                }
                async sendMsg(g) {
                    return this.sendMsgInternal(g);
                }
                async onDCStarted() {
                    this.logger.info("Data channel is started, starting handshake"), this.telemetryLogger.logStarted(), await this.startHandshake();
                }
                async onDCStopped() {
                    this.logger.info("Data channel handler is stopped"), this.telemetryLogger.logStopped(), this.mcpState = "Inactive";
                }
                subscribeToDataChannel() {
                    this.dataChannel.on("onStateChanged", ()=>this.onDataChannelStateChanged()), this.dataChannel.on("onmessage", (g, f, S)=>this.processIncomingData(g, S));
                }
                onDataChannelStateChanged() {
                    switch(this.dataChannel.state){
                        case "Connected":
                            this.onDCStarted();
                            break;
                        case "Closed":
                        case "Destroyed":
                            this.onDCStopped();
                    }
                }
                async startHandshake() {
                    try {
                        const g = [];
                        this.mcpConfig.enableDominantSpeakerHistory && g.push("dsh"), this.mcpConfig.enableBweNotifications && g.push("bwe"), this.mcpConfig.enableSourceRequests && g.push("sr"), this.mcpConfig.enableSendBandwidthNotificationsEnabled && g.push("ssbwe"), this.telemetryLogger.logHandshakeStarted(g), this.logger.info(`Send syn, client capabilities: ${JSON.stringify(g)}`), await this.sendMsgInternal({
                            type: "syn",
                            client_capabilities: g
                        }), this.handshakeTimeout = window.setTimeout(()=>{
                            this.handshakeTimeout = null, this.telemetryLogger.logTimeout(), this.mcpState = "TimedOut", this.switchMcpFeauture("sourceRequestsEnabled", !1), this.logger.warn(`Timeout after ${this.mcpConfig.handshakeTimeout}ms, raising onHandshakeTimeout`), this.event("onHandshakeTimeout").raise();
                        }, this.mcpConfig.handshakeTimeout);
                    } catch (g) {
                        this.logger.error(`Handshake failed with: ${stringifyObject(g)}`), this.telemetryLogger.logHandshakeFailed(stringifyObject(g));
                    }
                }
                async sendMsgInternal(g) {
                    const f = Array.isArray(g) ? g : [
                        g
                    ], S = (new TextEncoder).encode(JSON.stringify(f)), v = new Uint8Array(1 + S.length);
                    v[0] = 1, v.set(S, 1);
                    try {
                        await this.dataChannel.sendMessage(18, void 0, v, [
                            HA
                        ]);
                        for (const g of f)this.telemetryLogger.logSentMsg(g);
                    } catch (g) {
                        throw this.logger.error(`Send failed: ${stringifyObject(g)}`), this.telemetryLogger.logSentFailed(stringifyObject(g)), g;
                    }
                }
                processIncomingData(g, f) {
                    if (18 !== g) return;
                    if (1 !== f[0]) {
                        const g = `Unsupported header version ${f[0]}`;
                        return this.logger.info(g), void this.telemetryLogger.logRecvFailed(g);
                    }
                    const S = new DataView(f.buffer, 1);
                    let v;
                    try {
                        const g = (new TextDecoder).decode(S);
                        v = JSON.parse(g);
                    } catch (g) {
                        return this.logger.error(`Failed to parse received data, error ${stringifyObject(g)}`), void this.telemetryLogger.logRecvFailed(stringifyObject(g));
                    }
                    for (const g of v)switch(this.telemetryLogger.logReceivedMsg(g), g.type){
                        case "syn":
                            break;
                        case "ack":
                            this.processAckMsg(g);
                            break;
                        case "bwe":
                            this.processBweMsg(g);
                            break;
                        case "dsh":
                            this.processDshMsg(g);
                            break;
                        case "sr_res":
                            this.processSrResMsg(g);
                            break;
                        default:
                            {
                                const f = `Unsupported msg type ${g.type}`;
                                this.logger.error(f), this.telemetryLogger.logRecvFailed(f);
                            }
                    }
                }
                processDshMsg(g) {
                    this.mcpConfig.enableDominantSpeakerHistory && (this.logger.debug(`DSH received: ${JSON.stringify(g)}`), this.event("mpDshChanged").raise(g.history));
                }
                processSrResMsg(g) {
                    this.mcpConfig.enableSourceRequests && this.event("mpSrResReceived").raise(g.sequenceNumber, g.result), this.mcpState = "Active";
                }
                processBweMsg(g) {
                    this.mcpConfig.enableBweNotifications && this.event("mpSendBandwidthChanged").raise(g.bw);
                }
                processAckMsg(g) {
                    var _g_send_capabilities, _g_receive_capabilities, _g_send_capabilities1, _g_receive_capabilities1;
                    this.telemetryLogger.logHandshakeCompleted(g), this.logger.info(`Ack received: ${JSON.stringify(g)}`), this.switchMcpFeauture("dominantSpeakerHistoryEnabled", !(!this.mcpConfig.enableDominantSpeakerHistory || !((_g_send_capabilities = g.send_capabilities) === null || _g_send_capabilities === void 0 ? void 0 : _g_send_capabilities.includes("dsh")))), this.switchMcpFeauture("sourceRequestsEnabled", !(!this.mcpConfig.enableSourceRequests || !((_g_receive_capabilities = g.receive_capabilities) === null || _g_receive_capabilities === void 0 ? void 0 : _g_receive_capabilities.includes("sr")))), this.switchMcpFeauture("sourceRequestsResponseEnabled", !(!this.mcpConfig.enableSourceRequests || !((_g_send_capabilities1 = g.send_capabilities) === null || _g_send_capabilities1 === void 0 ? void 0 : _g_send_capabilities1.includes("sr_res")))), this.switchMcpFeauture("senderSideBandwidthEstimationEnabled", !(!this.mcpConfig.enableSendBandwidthNotificationsEnabled || !((_g_receive_capabilities1 = g.receive_capabilities) === null || _g_receive_capabilities1 === void 0 ? void 0 : _g_receive_capabilities1.includes("ssbwe")))), this.logger.info(`Mcp handshake completed:\n            Dominant speaker history: ${this.mcpSupportedFeautres.dominantSpeakerHistoryEnabled},\n            Source requests: ${this.mcpSupportedFeautres.sourceRequestsEnabled},\n            Source requests response: ${this.mcpSupportedFeautres.sourceRequestsResponseEnabled},\n            Bandwidth estimation response: ${this.mcpSupportedFeautres.senderSideBandwidthEstimationEnabled}`), this.event("mcpHandshakeCompleted").raise(), clearTimeout(this.handshakeTimeout), this.handshakeTimeout = null, this.mcpState = "Active";
                }
                constructor(g, f, S){
                    var _this_mcpConfig;
                    super(), this.dataChannel = g, this.logger = f, this.mcpConfig = S, this.mcpState = "Created", this.handshakeTimeout = null, this.telemetryLogger = new BA(this.mcpConfig), this.mcpSupportedFeautres = {
                        sourceRequestsEnabled: !1,
                        sourceRequestsResponseEnabled: !1,
                        dominantSpeakerHistoryEnabled: (_this_mcpConfig = this.mcpConfig) === null || _this_mcpConfig === void 0 ? void 0 : _this_mcpConfig.enableDominantSpeakerHistory,
                        senderSideBandwidthEstimationEnabled: !1
                    }, this.subscribeToDataChannel();
                }
            }, jA = class {
                mapToSignalingOperation(g) {
                    switch(g){
                        case "ApplyChannelParametersSourceRequest":
                        case "ApplyChannelParametersVideoCapabilities":
                            return 0;
                        case "ControlVideoStreaming":
                            return 1;
                        default:
                            return this.logger.error("Unknown send operation"), null;
                    }
                }
                send(g, f, S, v) {
                    switch(g){
                        case "ApplyChannelParametersSourceRequest":
                            return this.sendMcpMessage(g, f, S, v);
                        case "ApplyChannelParametersVideoCapabilities":
                        case "ControlVideoStreaming":
                            var _this_diagnostics;
                            return this.sendSignalingMessage ? ((_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.recordSignalingOperation(g), this.sendSignalingMessage(this.mapToSignalingOperation(g), f)) : Promise.reject(new Error("no signaling session"));
                        default:
                            return this.logger.warn(`Unable to send message reason: Operation unknown ${g}`), Promise.reject(new Error("Unable to send message"));
                    }
                }
                setResendingMechanism(g, f, S, v) {
                    var _this_mediaControlPlane;
                    const _ = window.setTimeout(()=>{
                        this.logger.warn(`Timed out message ${g}, sending message through signaling`), this.resendPendingMessageThroughSignaling(g, v);
                    }, (_this_mediaControlPlane = this.mediaControlPlane) === null || _this_mediaControlPlane === void 0 ? void 0 : _this_mediaControlPlane.getConfig().sourceRequestsMessagesTimeout);
                    this.pendingSourceRequests.set(g, {
                        sequenceNumber: g,
                        timeoutId: _,
                        deferred: f,
                        message: S,
                        operation: v
                    });
                }
                isAllowedToSendMcpMessage() {
                    var _this_mediaControlPlane;
                    if (!this.mediaControlPlane) return !1;
                    const g = this.mediaControlPlane.getMcpState(), f = this.mediaControlPlane.getConfig(), S = (_this_mediaControlPlane = this.mediaControlPlane) === null || _this_mediaControlPlane === void 0 ? void 0 : _this_mediaControlPlane.mcpFeaturesSupported("sourceRequestsEnabled");
                    return "Created" === g ? (f === null || f === void 0 ? void 0 : f.sendBeforeAck) && (f === null || f === void 0 ? void 0 : f.enableSourceRequests) : "Active" === g && S;
                }
                isResendingMechanismRequired(g) {
                    return this.mediaControlPlane.getConfig().setResendingMechanism && "ApplyChannelParametersSourceRequest" === g;
                }
                async sendMcpMessage(g, f, S, v) {
                    var _this_diagnostics;
                    if (this.isAllowedToSendMcpMessage()) {
                        const v = new ct;
                        this.isResendingMechanismRequired(g) && this.setResendingMechanism(S, v, f, g);
                        try {
                            var _f_controlVideoStreaming;
                            return this.diagnostics.recordMCPOperation(g, S, (_f_controlVideoStreaming = f.controlVideoStreaming) === null || _f_controlVideoStreaming === void 0 ? void 0 : _f_controlVideoStreaming.controlInfo), await this.mediaControlPlane.sendMsg(f), this.logger.info(`Sending ${f.type} by MCP sequenceNumber:${S}`), this.isResendingMechanismRequired(g) ? v.promise : Promise.resolve();
                        } catch (g) {
                            var _this_diagnostics1;
                            const f = stringifyObject(g);
                            (_this_diagnostics1 = this.diagnostics) === null || _this_diagnostics1 === void 0 ? void 0 : _this_diagnostics1.recordError(f, S), this.logger.error(`sendMsgInternal failed with error: ${f}`);
                        }
                    }
                    return this.sendSignalingMessage ? ((_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.recordSignalingOperation(g), this.logger.info(`Sending SR by signaling sequenceNumber:${S}`), this.sendSignalingMessage(this.mapToSignalingOperation(g), v)) : Promise.reject(new Error("no signaling session"));
                }
                async resendPendingMessageThroughSignaling(g, f) {
                    var _this_diagnostics;
                    (_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.recordMCPMessageFallback(g, f);
                    const S = this.pendingSourceRequests.get(g);
                    try {
                        var _this_diagnostics1;
                        (_this_diagnostics1 = this.diagnostics) === null || _this_diagnostics1 === void 0 ? void 0 : _this_diagnostics1.recordSignalingOperation(S.operation), await this.sendSignalingMessage(this.mapToSignalingOperation(S.operation), S.message), S.deferred.resolve();
                    } catch (e) {
                        S.deferred.reject(new Error("Sending source request failed"));
                    } finally{
                        this.logger.warn(`Deleting message from pending: ${g}`), this.pendingSourceRequests.delete(g), clearTimeout(S.timeoutId);
                    }
                }
                onMsgReceived(g, f) {
                    this.logger.info(`Received SR result: ${f} for sequenceNumber: ${g}`);
                    const S = this.pendingSourceRequests.get(g);
                    if (S) {
                        var _this_diagnostics;
                        switch((_this_diagnostics = this.diagnostics) === null || _this_diagnostics === void 0 ? void 0 : _this_diagnostics.recordSrResultReceived(f, g, S.operation), f){
                            case "ok":
                            case "duplicate":
                            case "out_of_order":
                                S.deferred.resolve();
                                break;
                            default:
                                S.deferred.reject(`SequenceNumber: ${g} failed with ${f}!`);
                        }
                        clearTimeout(S.timeoutId), this.pendingSourceRequests.delete(g);
                    } else this.logger.warn(`No pending SR found for sequenceNumber: ${g}`);
                }
                constructor(g, f, S){
                    var _this_mediaControlPlane, _this_mediaControlPlane1;
                    this.mediaControlPlane = g, this.sendSignalingMessage = f, this.logger = S, this.pendingSourceRequests = new Map, this.diagnostics = (_this_mediaControlPlane = this.mediaControlPlane) === null || _this_mediaControlPlane === void 0 ? void 0 : _this_mediaControlPlane.getTelemetryLogger().getSourceRequestSenderDiagnostics, (_this_mediaControlPlane1 = this.mediaControlPlane) === null || _this_mediaControlPlane1 === void 0 ? void 0 : _this_mediaControlPlane1.on("mpSrResReceived", (g, f)=>this.onMsgReceived(g, f));
                }
            }, GA = 0, qA = class _WebRtcSession2 {
                initializeMediaControlPlane(g) {
                    const f = this.dataChannel.getDataChannel(g);
                    f ? (this.mediaControlPlane = new $A(f, this.logger.createChild("MediaControlPlane"), this.configProvider.config.mediaControlPlaneConfig), this.mediaControlPlane.on("mpSendBandwidthChanged", (g)=>{
                        var _this_bandwidthCache;
                        this.performanceMonitor.processNotification("BandwidthNotification", {
                            bw: g
                        }), (_this_bandwidthCache = this.bandwidthCache) === null || _this_bandwidthCache === void 0 ? void 0 : _this_bandwidthCache.saveSeed(g), this.statsGatherer.addReportedReceiveBandwidth(g), this.diagnostics.addReportedReceiveBandwidth(g);
                    }), this.mediaControlPlane.on("mcpHandshakeCompleted", ()=>{
                        this.callback.onUpdateSignalingDSHMessageSubscription(!this.mediaControlPlane.mcpFeaturesSupported("dominantSpeakerHistoryEnabled")), this.mediaControlPlane.mcpFeaturesSupported("dominantSpeakerHistoryEnabled") && this.diagnostics.dshDiagnostics.setCurrentActiveStrategy("server"), this.mediaControlPlane.mcpFeaturesSupported("sourceRequestsEnabled") && (this.subscriptionManager.mcpSourceRequestsAvailable(), this.notifyStreamsChanged()), this.mediaControlPlane.mcpFeaturesSupported("senderSideBandwidthEstimationEnabled") && this.configProvider.config.specCompliantSimulcast.enableSimulcastLayoutControlStrategy && this.videoFeatureManager.get("Video").toggleServer(0, !0);
                    }), this.mediaControlPlane.on("onHandshakeTimeout", ()=>{
                        this.configProvider.config.enableSignalingDSHFallback && this.callback.onUpdateSignalingDSHMessageSubscription(!0);
                    }), this.mediaControlPlane.on("mpDshChanged", (g)=>{
                        this.activeSpeakerManager.onDominantSpeakerHistoryChanged(g, "server");
                    })) : this.logger.safe.error(`[${g}] Unable to initialize MediaControlPlane due to datachannel creation failure`);
                }
                getMediaControlPlaneInstance() {
                    return this.mediaControlPlane;
                }
                getAcceptedTypes() {
                    return this.negotiation.allowedMediaContentType;
                }
                clone(g, f) {
                    var _this_context_diagnostics;
                    const S = shallowClone(this.context);
                    S.config = shallowClone(this.context.config), S.config.webrtcMediaContentType = this.negotiation.mediaContentType, S.config.webrtcAllowedMediaContentType = this.negotiation.allowedMediaContentType, S.configProvider = f, S.diagnostics = (_this_context_diagnostics = this.context.diagnostics) === null || _this_context_diagnostics === void 0 ? void 0 : _this_context_diagnostics.newNativeSession(!1), g ? (S.config.isConference = !0, S.config.isPstnCall = !1) : (S.config.iceHostCandidateOnly = !1, this.configProvider.config.waitForRelayOnReconnect && (S.config.webrtcIceGatheringTimeoutIncreased = !0));
                    const v = new _WebRtcSession2(S, this.callId, this.callback);
                    return this.useNullAudioStream && v.useNullAudioStreamClient(), this.relayManagerProvider && (v.relayManagerProvider = this.relayManagerProvider), v.callbacks.onNegotiationRequired = this.callbacks.onNegotiationRequired, v;
                }
                async setCallConstraints(g, f) {
                    const S = this.configProvider.setCallConstraints(g);
                    if (this.logger.safe.info(`[${f}] Setting call constraints ${JSON.stringify(S)}, enableDynamicCallConstraints: ${this.configProvider.config.enableDynamicCallConstraints}`), this.configProvider.config.enableDynamicCallConstraints) try {
                        await this.streamSendersManager.applyCallConstraints(f), this.configProvider.addCallConstraintsTelemetryEvent(S, "applied");
                    } catch (g) {
                        throw this.logger.safe.error(`Error while applying constraints: ${g}`), g;
                    }
                    else this.configProvider.addCallConstraintsTelemetryEvent(S, "applied");
                    return S;
                }
                setInternals(g, f) {
                    var _this_subscriptionManager, _g_remoteVideoManager;
                    this.logger.safe.info(`[${f}] Setting internals from previous session`), this.diagnostics.commitNativeSession(), g.subscriptionManager && ((_this_subscriptionManager = this.subscriptionManager) === null || _this_subscriptionManager === void 0 ? void 0 : _this_subscriptionManager.dispose(), this.subscriptionManager = g.subscriptionManager, this.subscriptionManager.setDiagnostics(this.diagnostics.newSubscriptionManagerDiagnostics()), this.subscriptionManager.setStreamProvider({
                        getStreams: ()=>this.receiveStreamCollection.getStreams(),
                        setOnStreamsChangedHandler: (g)=>this.streamsChangedListener = g
                    }), this.subscriptionManager.setLogger(this.logger.createChild("subs")), this.setSubsForSubscriptionManager(), this.subscriptionManager.reriseSubscribeEvents(), this.notifyStreamsChanged()), g.audioRenderer && (g.audioRenderer.play(this.audioRenderer.getStream()), this.audioRenderer = g.audioRenderer), (_g_remoteVideoManager = g.remoteVideoManager) === null || _g_remoteVideoManager === void 0 ? void 0 : _g_remoteVideoManager.moveRenderers(this.remoteVideoManager), g.rawIncomingAudioStreamManager && this.rawIncomingAudioStreamManager.updateHandlers(g.rawIncomingAudioStreamManager.handlerMap), this.audioRenderer.getStream() && this.rawIncomingAudioStreamManager.streamChanged(this.audioRenderer.getStream());
                }
                setSubsForDeviceManager() {
                    const g = this.getVideoDeviceManager();
                    this.configProvider.config.enablePlayVideoOnStreamUnmuteWorkaround && this.deviceManagerSubs.push(g.on("onAudioStreamMuted", (f)=>{
                        f || (this.remoteVideoManager.playVideo(), g.getLocalVideoRenderers().forEach((g)=>g.playVideo()));
                    }));
                }
                setSubsForSubscriptionManager() {
                    this.subscriptionManagerSubs = [
                        this.subscriptionManager.on("onTrackIdsChanged", (g)=>this.statsGatherer.setSubscribedTrackIds(g)),
                        this.subscriptionManager.on("onTrackSsrcChanged", (g)=>this.statsGatherer.setSubscribedTrackSsrc(g)),
                        this.subscriptionManager.on("onSubscriptionChanged", (g, f, S, v, _, C)=>this.onSubscriptionChanged(g, f, S, v, _, C)),
                        this.subscriptionManager.on("onSubscriptionFailed", (g, f, S, v, _)=>this.statsGatherer.addSubscriptionEvent(g, f, S, v, _))
                    ];
                }
                onSubscriptionChanged(g, f, S, v, _, C) {
                    f === Gt.MODALITY.video && (2 === g && this.diagnostics.addSubscriptionToOvcEvent(this.subscriptionManager.getSubscriptionsCount()), 3 === g && this.diagnostics.addSubscriptionToOvcEvent(this.subscriptionManager.getSubscriptionsCount())), this.statsGatherer.addSubscriptionEvent(g, f, S, v, null, _, C);
                }
                setSubsForStreamManagerEvents() {
                    this.streamSendersManager.on("onSendStreamChanged", (g, f)=>{
                        this.statsGatherer.updateSendStream(g, f), (g === null || g === void 0 ? void 0 : g.hasAudio()) && this.diagnostics.setAudioSendStream(g, f), this.diagnostics.setPresentationAudioOnScreenSharing(g, f);
                    }), this.streamSendersManager.on("onVideoCaptureFreeze", (g)=>{
                        this.transportStateProvider.isConnected && !this.transportStateProvider.isWaitingAcceptProvisional && this.ufdManager.signalEvent("VideoCaptureDeviceFreeze", g ? "Bad" : "Good", "Video");
                    }), this.streamSendersManager.on("onMaxVideoSendCapabilitiesChanged", (g, f)=>this.onMaxVideoSendCapabilitiesChanged(g, f)), this.streamSendersManager.on("onBandwidthAllocationChanged", (g)=>this.onSendBandwidthChanged(g));
                }
                move(g, f) {
                    this.logger.safe.info(`[${f}] moving to new session`), g.setInternals({
                        subscriptionManager: this.subscriptionManager,
                        audioRenderer: this.audioRenderer,
                        remoteVideoManager: this.remoteVideoManager,
                        rawIncomingAudioStreamManager: this.rawIncomingAudioStreamManager
                    }, f), g.muteHold(this.isMuteHold, f), this.isAudioInputMuted ? g.muteInputAsync(f) : g.unmuteInputAsync(f), this.isAudioOutputMuted ? g.muteOutputAsync(f) : g.unmuteOutputAsync(f), this.subscriptionManager = null, this.audioRenderer = null, this.rawIncomingAudioStreamManager = null, this.callbacks.onTerminated = null;
                }
                setMute(g, f, S) {
                    this.logger.safe.info(`[${S}] call setMute for ${g} with mute state ${f}`), this.streamSendersManager.setMuted(g, f, S), this.processLegacyStats(this.statsGatherer.getLastStatistics());
                }
                getConfiguredModalities() {
                    return this.negotiation.configuredModalities;
                }
                getDisabledModalities() {
                    return this.negotiation.disabledModalities;
                }
                createAudioElement(g) {
                    this.configProvider.config.devices.setSinkImmediately && this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()), this.audioRenderer.assureAudioElement(g);
                }
                useNullAudioStreamClient() {
                    this.useNullAudioStream = !0, this.streamSendersManager.useNullAudioStreamClient();
                }
                createRemoteRenderer(g) {
                    return this.remoteVideoManager.createRenderer(g, this.subscriptionManager, this.logger);
                }
                getStatsAsync(g) {
                    if (this.statsGatherer && !this.statsGatherer.isDisposed) {
                        if (this.audioCodecManager) {
                            const g = this.audioCodecManager.getSessionEvents();
                            this.statsGatherer.sessionInfo.setAudioCodecEvents(g), this.diagnostics.audioCodecEvents = g;
                        }
                        this.statisticsReport = this.statisticsReport.then(()=>this.statsGatherer.getReport(g)).catch((g)=>(this.logger.safe.error(`getting statistics should never fail: ${g.error}`), g.partialReport));
                    }
                    return this.statisticsReport;
                }
                getLastKnownStats(g) {
                    return this.statsGatherer.getReport(!1, g);
                }
                muteHold(g, f) {
                    this.logger.safe.info(`[${f}] set muteHold state ${g}`), this.isMuteHold = g;
                    const S = [
                        Gt.MODALITY.audio,
                        Gt.MODALITY.video,
                        Gt.MODALITY.sharing
                    ].filter((g)=>hasSendDirectionality(this.negotiation.negotiatedModalities[g]) && (g !== Gt.MODALITY.audio || !this.isAudioInputMuted));
                    for (const v of S)this.setMute(modalityToMediaType(v), g, f);
                }
                async muteInputAsync(g) {
                    this.isAudioInputMuted = !0, this.setMute("Audio", !0, g);
                }
                async unmuteInputAsync(g) {
                    this.isAudioInputMuted = !1, this.setMute("Audio", !1, g);
                }
                async muteOutputAsync(g) {
                    var _this_audioCodecManager_decoder, _this_audioRenderer;
                    return this.isAudioOutputMuted = !0, (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.disableStreamsMixer(!0), (_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.setMuted(!0, g);
                }
                async unmuteOutputAsync(g) {
                    var _this_audioCodecManager_decoder, _this_audioRenderer;
                    return this.isAudioOutputMuted = !1, (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.disableStreamsMixer(!1), (_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.setMuted(!1, g);
                }
                async getSpeakerVolume(g) {
                    var _this_audioRenderer;
                    return ((_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.getSpeakerVolume(g)) || 0;
                }
                async setSpeakerVolume(g, f) {
                    var _this_audioRenderer;
                    return (_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.setSpeakerVolume(g, f);
                }
                sendDtmf(g) {
                    return this.dtmfSender.sendDtmf(this.peerConnection, g);
                }
                canSendDtmf() {
                    return this.dtmfSender.canSendDtmf(this.peerConnection);
                }
                onDeviceEvent(g) {
                    this.statsGatherer.onDeviceEvent(g);
                }
                deviceSelectionChanged() {
                    var _this_audioRenderer;
                    this.peerConnection && ((_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.getStream()) && this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId());
                }
                async terminate(g, f, S = !0) {
                    var _this_audioCodecManager_decoder, _this_rawIncomingAudioStreamManager, _this_contributingSources, _this_qualityManager, _this_audioRenderer, _this_dtmfSender, _this_streamSendersManager, _this_transportStateProvider, _this_mediaControlPlane, _this_peerConnection, _this_callDeviceManagerSub;
                    this.logger.safe.info(`[${g}] terminate`), this.statsGatherer.setTerminated(), this.diagnostics.terminate(), this.perfMonitorSubs.forEach((g)=>g === null || g === void 0 ? void 0 : g.dispose()), this.performanceMonitor.dispose(), this.terminated = !0, this.negotiation.terminate(g), await ((_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.storeApiRecording()), (_this_rawIncomingAudioStreamManager = this.rawIncomingAudioStreamManager) === null || _this_rawIncomingAudioStreamManager === void 0 ? void 0 : _this_rawIncomingAudioStreamManager.dispose(), this.remoteVideoManager.dispose(), this.dataChannel && (this.dataChannel.dispose(), this.dataChannel = null), this.logger.safe.info(`[${g}] reset peer connection`), (_this_contributingSources = this.contributingSources) === null || _this_contributingSources === void 0 ? void 0 : _this_contributingSources.dispose(), this.activeSpeakerManager.dispose(), (_this_qualityManager = this.qualityManager) === null || _this_qualityManager === void 0 ? void 0 : _this_qualityManager.dispose(), this.qualityManager = null, (_this_audioRenderer = this.audioRenderer) === null || _this_audioRenderer === void 0 ? void 0 : _this_audioRenderer.dispose(), (_this_dtmfSender = this.dtmfSender) === null || _this_dtmfSender === void 0 ? void 0 : _this_dtmfSender.dispose(), this.dtmfSender = null, (_this_streamSendersManager = this.streamSendersManager) === null || _this_streamSendersManager === void 0 ? void 0 : _this_streamSendersManager.dispose(), this.streamSendersManager = null, this.transceiverManager = null, this.encStreamsManager.dispose(), this.receiveStreamCollection.clear(), (_this_transportStateProvider = this.transportStateProvider) === null || _this_transportStateProvider === void 0 ? void 0 : _this_transportStateProvider.dispose(), this.transportStateProvider = null, this.audioCodecManager.dispose(), this.mediaManager.reset(), (_this_mediaControlPlane = this.mediaControlPlane) === null || _this_mediaControlPlane === void 0 ? void 0 : _this_mediaControlPlane.dispose(), (_this_peerConnection = this.peerConnection) === null || _this_peerConnection === void 0 ? void 0 : _this_peerConnection.close(), this.peerConnection = null, this.negotiation.negotiationEmulator.configure(null), this.peerConnectionPromise = null, this.subscriptionManagerSubs.forEach((g)=>g.dispose()), this.subscriptionManager && this.subscriptionManager.dispose(), this.deviceManagerSubs.forEach((g)=>g.dispose()), (_this_callDeviceManagerSub = this.callDeviceManagerSub) === null || _this_callDeviceManagerSub === void 0 ? void 0 : _this_callDeviceManagerSub.dispose(), this.clearIceDisconnectedTimer(), this.callbacks.onTerminated && this.callbacks.onTerminated();
                    try {
                        S && await this.getStatsAsync(!1);
                    } catch (f) {
                        this.logger.safe.error(`[${g}] Error while gathering stats ${stringifyObject(f)}`);
                    } finally{
                        this.statsGatherer.dispose();
                    }
                }
                getIncomingRawAudioStream(g) {
                    this.logger.info("IRawStream for incoming audio stream requested");
                    const f = this.audioRenderer.getStream();
                    return this.rawIncomingAudioStreamManager.createIRawStreamClient(f, g);
                }
                getUnmixedAudioProvider() {
                    var _this_audioCodecManager_decoder;
                    return (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.getUnmixedAudioProvider();
                }
                configureSpatialAudio(g, f) {
                    this.configProvider.mediaConfig.spatialAudioEnabled = g, this.audioCodecManager.configureSpatialAudio(g, f) || this.ufdManager.signalEvent("SpatialAudioMUCHUnavailable", "Bad", "Audio", !0, f);
                }
                setParticipantSpatialAudioPositions(g, f) {
                    var _this_audioCodecManager, _this_getUnmixedAudioProvider, _this_audioCodecManager_decoder;
                    if (!((_this_audioCodecManager = this.audioCodecManager) === null || _this_audioCodecManager === void 0 ? void 0 : _this_audioCodecManager.decoder) || !((_this_getUnmixedAudioProvider = this.getUnmixedAudioProvider()) === null || _this_getUnmixedAudioProvider === void 0 ? void 0 : _this_getUnmixedAudioProvider.configured)) throw this.logger.safe.error(`[${f}] setParticipantSpatialAudioPositions is called while MUCH audio decoder is not created or not enabled`), "setParticipantSpatialAudioPositions not allowed";
                    (_this_audioCodecManager_decoder = this.audioCodecManager.decoder) === null || _this_audioCodecManager_decoder === void 0 ? void 0 : _this_audioCodecManager_decoder.setParticipantSpatialAudioPositions(g);
                }
                processNotification(g, f) {
                    "McpSourceRequestsAvailable" === g && (this.subscriptionManager.mcpSourceRequestsAvailable(), this.notifyStreamsChanged()), "DominantSpeakerInfo" === g && this.activeSpeakerManager.onDominantSpeakerHistoryChanged(f.previousDominantSpeakerHistory, "signaling"), "ControlVideoStreaming" === g && this.streamConfigurationHandler.handleMessage(f), this.performanceMonitor.processNotification(g, f);
                }
                processStatsReport(g) {
                    try {
                        if (this.remoteVideoManager.processStatsReport(g), this.configProvider.config.diagnostics.features.useNewNetworkUFD) {
                            this.networkQualityDiagnostics.processReport(g);
                            const f = this.networkQualityDiagnostics.getInboundNetworkQuality();
                            this.ufdManager.signalEvent("NetworkRecvQuality", f);
                            const S = this.networkQualityDiagnostics.getOutboundNetworkQuality();
                            this.ufdManager.signalEvent("NetworkSendQuality", this.isAudioInputMuted ? "Good" : S);
                        }
                        this.configProvider.config.diagnostics.features.useNewSpeakingWhileMutedUFD && this.ufdManager.signalEvent("DeviceSpeakWhileMuted", this.speechDetectionDiagnostics.processReport(g) ? "Bad" : "Good"), this.streamSendersManager.onDiagnosticUpdated(g);
                        for (const f of this.getVideoDeviceManager().getLocalVideoRenderers())f.onDiagnosticUpdated(g);
                    } catch (g) {
                        this.logger.error("Failed to processes diagnostics update: " + g);
                    }
                }
                processLegacyStats(g) {
                    if (g) {
                        if (this.remoteVideoManager.processLegacyStats(g), this.hwSilent !== g.audioHwSilent && (this.hwSilent = g.audioHwSilent, this.callbacks.onAudioHwSilentChanged && this.callbacks.onAudioHwSilentChanged(this.hwSilent)), this.configProvider.config.diagnostics.features.useNewNetworkUFD || (this.ufdManager.signalEvent("NetworkRecvQuality", g.networkRecvLevel.quality, void 0, void 0, void 0, void 0, {
                            recvQualityData: g.networkRecvLevel
                        }), this.ufdManager.signalEvent("NetworkSendQuality", this.isAudioInputMuted ? "Good" : g.networkSendLevel.quality, void 0, void 0, void 0, void 0, {
                            sendQualityData: g.networkSendLevel
                        })), !this.configProvider.config.diagnostics.features.useNewSpeakingWhileMutedUFD) {
                            const f = !(!g.isSpeaking || !this.isAudioInputMuted);
                            this.ufdManager.signalEvent("DeviceSpeakWhileMuted", f ? "Bad" : "Good");
                        }
                        this.streamSendersManager.onStatisticsChanged(g);
                    }
                }
                assurePeerConnectionAsync(g, f) {
                    var _this_peerConnectionPromise;
                    return (_this_peerConnectionPromise = this.peerConnectionPromise) !== null && _this_peerConnectionPromise !== void 0 ? _this_peerConnectionPromise : this.peerConnectionPromise = this.getPeerConnectionPromise(g, f), this.peerConnectionPromise;
                }
                async getPeerConnectionPromise(g, f) {
                    var _this_callback_onDataChannelUpdated, _this_callback;
                    if (!this.relayManagerProvider) throw new Error("relay manager provider is not set!");
                    this.logger.safe.info(`[${g}] fetching relay details from RelayManager...`);
                    const S = {
                        relayType: "turn",
                        isRemoteClientLync: this.context.config.isRemoteClientLync
                    };
                    f.mark("startQueryRelaysAsync");
                    const v = await this.relayManagerProvider.getRelayManager().queryRelaysAsync(S);
                    if (f.markAndMeasure("startQueryRelaysAsync", "queryRelaysAsync"), this.terminated) throw new Error("session already disposed");
                    const _ = {
                        optional: []
                    }, C = createIceServers(v, this.configProvider.config), E = this.negotiation.configureCrypto(_, this.context.config.isPstnCall);
                    this.configureCpuThreshold(_), this.logger.safe.info("create peer connection");
                    const T = "unified-plan", I = this.context.configProvider.mediaConfig.isTransportUnbundled ? "balanced" : "max-bundle";
                    try {
                        this.peerConnection = new Qa.window.RTCPeerConnection({
                            iceServers: C,
                            rtcpMuxPolicy: "require",
                            iceTransportPolicy: this.configProvider.getIceTransportPolicy(),
                            iceCandidatePoolSize: this.configProvider.config.iceCandidatePoolSize,
                            bundlePolicy: I,
                            sdpSemantics: T,
                            audioPortRange: this.configProvider.mediaConfig.audioPortRange,
                            videoPortRange: this.configProvider.mediaConfig.videoPortRange,
                            enableDtlsSrtp: 1 === E,
                            encodedInsertableStreams: !!this.configProvider.config.useInsertableStreams
                        }, _);
                    } catch (g) {
                        throw g.code === DOMException.INVALID_STATE_ERR && this.ufdManager.signalEvent("NoNetwork", "Bad"), g;
                    }
                    const b = this.peerConnection;
                    this.negotiation.rollbackSupported = 1 === E && this.context.configProvider.userAgentConfig.isBrowserRollbackSupported, this.negotiation.negotiationEmulator.configure(b), this.statsGatherer.initialize(b), this.statsGatherer.sessionInfo.setIceServers(C), this.statsGatherer.sessionInfo.setIceTransportPolicy(this.configProvider.getIceTransportPolicy()), this.statsGatherer.sessionInfo.setSdpSemantics(T), this.statsGatherer.sessionInfo.setBundlePolicy(I), this.diagnostics.iceServers = C, this.diagnostics.iceTransportPolicy = this.configProvider.getIceTransportPolicy(), this.diagnostics.sdpSemantics = T, this.diagnostics.bundlePolicy = I, await this.checkVideoCodecsSupport(), f.markAndMeasure("queryRelaysAsync", "checkVideoCodecsSupport"), b.onnegotiationneeded = ()=>{
                        this.logger.safe.info(`onnegotiationneeded signalingState: ${b.signalingState}`);
                    }, b.onicecandidateerror = (g)=>{
                        const f = g, [S, v] = [
                            f.address,
                            f.port
                        ];
                        if (this.logger.safe.warn(`On ICE candidate error ${f.url} | ${S}:${v}: code ${f.errorCode}: ${f.errorText}`), !this.transportStateProvider.isConnected || this.negotiation.iceCandidatesDefer.isPending) {
                            const g = {
                                address: S,
                                port: +v,
                                url: f.url,
                                errorCode: f.errorCode,
                                errorText: f.errorText
                            };
                            this.statsGatherer.addIceCandidateError(g), this.diagnostics.addIceCandidateError(g);
                        }
                    }, b.onaddstream = (g)=>{
                        this.logger.safe.info(`onaddstream stream: ${g.stream.id}`);
                    };
                    const processTrack = (g, f, S, v)=>{
                        this.logger.safe.info(`ontrack processing ${g.kind}: ${f.id}`);
                        let _ = f.active;
                        if (!f.active && this.configProvider.config.useInactiveAudioTrack && "audio" === g.kind && (this.logger.safe.warn("ontrack override forcing to use inactive audio stream"), _ = !0), !_ || "stopped" === (v === null || v === void 0 ? void 0 : v.currentDirection) || (v === null || v === void 0 ? void 0 : v.stopped)) return void this.logger.safe.info("ontrack ignore non active stream");
                        let C = this.mediaManager.getMediaEntityByRemoteStreamId(f.id);
                        if (C || (this.logger.safe.info(`cannot find media entity with stream id ${f.id} trying to fallback`), f.getAudioTracks()[0] && (C = this.mediaManager.getMediaEntitiesByModality(Gt.MODALITY.audio)[0])), C) {
                            const v = this.createReceiveStream(f, S, g, C);
                            C.setRemoteTrackId(g.id), this.addReceiveStreamTransforms(S, C.getModality()), this.receiveStreamCollection.add(v);
                        } else this.logger.safe.error(`could not find media entity for an added stream: ${f.id}`);
                    };
                    b.ontrack = (g)=>{
                        var _g_streams_;
                        const { track: f, receiver: S, transceiver: v } = g, _ = (_g_streams_ = g.streams[0]) !== null && _g_streams_ !== void 0 ? _g_streams_ : new MediaStream([
                            f
                        ]), trackCallback = ()=>processTrack(f, _, S, v);
                        if (!(this.configProvider.config.addAudioStreamBeforeConnection && Gt.TRACK_KIND.audio === f.kind) && !this.transportStateProvider.isConnected || this.transportStateProvider.isWaitingAcceptProvisional) return this.logger.safe.info(`ontrack queueing to be run once connected ${f.kind}: ${_.id}`), void this.transportStateProvider.doOnConnected(trackCallback, "ontrack", !1);
                        trackCallback();
                    }, b.onremovestream = (g)=>{
                        this.logger.safe.info(`onremovestream ${g.stream.id}`), this.transportStateProvider.doOnConnected(()=>this.receiveStreamCollection.remove(g.stream.id), "onremovestream");
                    }, b.onicecandidate = (f)=>{
                        const S = f.candidate;
                        if (S) {
                            const f = parseCandidateString(S.candidate);
                            if (this.logger.safe.info(`[${g}] onicecandidate candidate: component:${f.component} protocol:${f.protocol} prio:${f.priority} type:${f.type} port:${f.port}`), this.logger.unsafe.info(`[${g}] candidate details: ${S.candidate}`), "1" !== f.component) return;
                            if (this.negotiation.iceCandidateReceived = !0, this.statsGatherer.sessionInfo.setCandidateDetails(f), this.diagnostics.setCandidateDetails(f), !this.relayCandidateGathered && S.candidate.indexOf("typ relay") > -1) {
                                var _S_priority;
                                const g = {
                                    priority: ((_S_priority = S.priority) === null || _S_priority === void 0 ? void 0 : _S_priority.toString()) || f.priority,
                                    time: Date.now() - this.negotiation.iceRelayGatheringStartTime
                                };
                                this.statsGatherer.sessionInfo.setRelayCandidateInfo(g), this.diagnostics.relayCandidateInfo = g, this.relayCandidateGathered = !0;
                            }
                        } else this.logger.safe.info(`[${g}] onicecandidate candidate: null`);
                        if (!this.negotiation.iceCandidatesDefer.isPending) return;
                        const v = !this.context.config.webrtcIceGatheringTimeoutIncreased || this.configProvider.config.emptyIceCandidateMarksGatheredAnswerer && !this.negotiation.initiator, _ = this.iceHostCandidateOnly || 0 === C.length;
                        if (!S && v || _) {
                            S && this.logger.safe.info(`[${g}] Not waiting for ICE candidates, hoping that host/prflx is enough`), this.logger.safe.info(`[${g}] Is connected:`, this.transportStateProvider.isConnected, this.transportStateProvider.iceConnectionState, this.transportStateProvider.signalingState);
                            let f = !0;
                            if (this.context.configProvider.mediaConfig.isTransportUnbundled && S) f = this.negotiation.sessionDescription.createLocalOffer(b.localDescription.sdp).hasUnbundledIceCandidates();
                            f && this.completeCandidateGathering(g);
                        } else if (this.relayCandidateGathered) {
                            let f = !0;
                            if (this.context.configProvider.mediaConfig.isTransportUnbundled) f = this.negotiation.sessionDescription.createLocalOffer(b.localDescription.sdp).hasUnbundledRelayIceCandidates();
                            f && (this.statsGatherer.clearIceCandidateErrors(), this.diagnostics.clearIceCandidateErrors(), this.completeCandidateGathering(g));
                        }
                    }, b.onicegatheringstatechange = ()=>{
                        this.logger.safe.info(`onicegatheringstatechange iceGatheringState: ${b.iceGatheringState}`);
                    }, this.transportStateProvider = new Mb(b, E, this.logger.createChild("TransportStateProvider"), this.configProvider, this.diagnostics.newTransportStateDiagnostics()), this.transportStateProvider.on("stateChanged", (S, v, _)=>{
                        var _this_callbacks_onTransportDisconnected, _this_callbacks;
                        if (this.terminated) return;
                        const C = this.wasConnected ? _ : g;
                        if (this.statsGatherer.sessionInfo.setIceConnectionState(S), "connecting" === S && f.mark("transportConnecting"), "connected" === S || "completed" === S) f.markAndMeasure("transportConnecting", "transportConnected"), this.onTransportConnected(C);
                        else if ("failed" === S || "closed" === S && "failed" !== v) {
                            var _this_callbacks_onTransportFailed, _this_callbacks1;
                            if (this.negotiation.iceCandidatesDefer.isPending) return this.logger.safe.info(`[${C}] ice failed while gathering candidates, suppressing error`), void this.completeCandidateGathering(C);
                            this.raiseError({
                                type: Gt.MEDIA_ERROR.iceConnectionError,
                                detail: "ice transport failed"
                            }, C), this.configProvider.config.webrtcCloseAfterIceFailure && b.close(), (_this_callbacks_onTransportFailed = (_this_callbacks1 = this.callbacks).onTransportFailed) === null || _this_callbacks_onTransportFailed === void 0 ? void 0 : _this_callbacks_onTransportFailed.call(_this_callbacks1);
                        }
                        "disconnected" === S ? ((_this_callbacks_onTransportDisconnected = (_this_callbacks = this.callbacks).onTransportDisconnected) === null || _this_callbacks_onTransportDisconnected === void 0 ? void 0 : _this_callbacks_onTransportDisconnected.call(_this_callbacks, g), this.startIceDisconnectedTimer(C)) : this.clearIceDisconnectedTimer();
                    }), this.transportStateProvider.on("signalingStateChanged", (g, f)=>{
                        this.configProvider.config.reconnectOnPcClose && !this.terminated && "closed" === g && this.transportStateProvider.isTransportConnected && this.raiseError({
                            type: Gt.MEDIA_ERROR.unexpectedClose,
                            detail: "PeerConnection is closed"
                        }, f);
                    }), this.transceiverManager = new Ss(this.logger, this.peerConnection, this.mediaManager, this.context, this.reinvitelessContext), this.streamSendersManager.registerRtpSenderManager(this.transceiverManager), allowDataChannel(this.context) && !this.dataChannel && (this.dataChannel = new Ra(this.peerConnection, this.diagnostics, this.logger, this.configProvider), (_this_callback_onDataChannelUpdated = (_this_callback = this.callback).onDataChannelUpdated) === null || _this_callback_onDataChannelUpdated === void 0 ? void 0 : _this_callback_onDataChannelUpdated.call(_this_callback, this.dataChannel), this.multiParty && this.initializeMediaControlPlane(g)), this.sourceRequestSender = new jA(this.mediaControlPlane, this.context.sendWebRtcMediaNotificationAsyncCallback, this.logger.createChild("SourceRequestSender")), this.mediaMessageController = new Fb(this.logger.createChild("SourceRequester"), this.configProvider, this.sourceRequestSender, this.mediaControlPlane), this.negotiation.setInternals(this.transceiverManager, this.transportStateProvider, this.dataChannel), this.multiParty && (this.contributingSources = new lb(this.logger.createChild("ContributingSources"), this.configProvider, this.activeSpeakerManager, new cb(this.logger.createChild("ContributingSourcesProvider"), b, this.configProvider.config.diagnostics.features.logContributingSourcesError, this.diagnostics))), f.mark("startInitialize"), await this.encStreamsManager.initialize(), f.markAndMeasure("startInitialize", "encStreamsManagerInitialize");
                    const A = this.encStreamsManager.isWorkerLoaded();
                    this.initAudioCodec(A), this.statsGatherer.sessionInfo.setEncodedStreamWorkerLoaded(A), this.diagnostics.encodedStreamWorker = A;
                }
                configureCpuThreshold(g) {
                    this.configProvider.config.webrtcNativeCpuOveruseDisabled && this.multiParty && g.optional.push({
                        googCpuOveruseDetection: !1
                    });
                }
                completeCandidateGathering(g) {
                    this.negotiation.iceCandidatesDefer.isPending && (this.logger.safe.info(`[${g}] ICE candidates gathered completely`), this.negotiation.iceCandidatesDefer.resolve());
                }
                detectVideoFeatures() {
                    var _f_video_layerScaleFactors, _f_video;
                    const g = this.videoFeatureManager.get("Video"), f = this.configProvider.config.specCompliantSimulcast;
                    if ((f === null || f === void 0 ? void 0 : f.enableSimulcastLayoutControlStrategy) && (f === null || f === void 0 ? void 0 : (_f_video = f.video) === null || _f_video === void 0 ? void 0 : (_f_video_layerScaleFactors = _f_video.layerScaleFactors) === null || _f_video_layerScaleFactors === void 0 ? void 0 : _f_video_layerScaleFactors.length) > 2 && g.toggleClient(0, !0), this.context.config.isTownHall) {
                        const f = this.configProvider.config.broadcastMode;
                        ((f === null || f === void 0 ? void 0 : f.prioritizeLayoutOnServer) || (f === null || f === void 0 ? void 0 : f.prioritizeLayoutOnClient)) && g.toggleClient(3, !0), (f === null || f === void 0 ? void 0 : f.maxSessionBandwidthKbps) && (this.statsGatherer.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps), this.diagnostics.maxSessionBandwidth = this.configProvider.mediaConfig.maxBandwidthInKbps);
                    }
                }
                onTransportConnected(g) {
                    if (this.statsGatherer.clearIceCandidateErrors(), this.diagnostics.clearIceCandidateErrors(), !this.terminated) {
                        var _this_callbacks_onAudioStateChanged, _this_callbacks, _this_callbacks_onTransportConnected, _this_callbacks1, _this_callbacks_onAudioStateChanged1, _this_callbacks2, _this_callbacks_onTransportConnected1, _this_callbacks3;
                        if (this.transportStateProvider.isWaitingAcceptProvisional) return this.logger.safe.info(`[${g}] transport connected provisional`), this.configProvider.config.createProvisionalAnswer.audioState && ((_this_callbacks_onAudioStateChanged = (_this_callbacks = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged === void 0 ? void 0 : _this_callbacks_onAudioStateChanged.call(_this_callbacks, this.configProvider.config.createProvisionalAnswer.audioState, g)), void (this.configProvider.config.createProvisionalAnswer.connectTransport && ((_this_callbacks_onTransportConnected = (_this_callbacks1 = this.callbacks).onTransportConnected) === null || _this_callbacks_onTransportConnected === void 0 ? void 0 : _this_callbacks_onTransportConnected.call(_this_callbacks1, g)));
                        this.logger.safe.info(`[${g}] audio transport connected`), this.wasConnected = !0, this.configProvider.config.webrtcPranswerWaitForMediaPollingInterval && "have-remote-pranswer" === this.transportStateProvider.signalingState ? this.handleEarlyMediaAudioState(g) : (_this_callbacks_onAudioStateChanged1 = (_this_callbacks2 = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged1 === void 0 ? void 0 : _this_callbacks_onAudioStateChanged1.call(_this_callbacks2, Gt.STREAMING_STATE.active, g), this.multiParty && this.configProvider.config.enableVideoFeatureManager && (this.videoFeatureManager.manageFeatureSupport(()=>{
                            this.detectVideoFeatures();
                        }), this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2 && this.videoFeatureManager.on("onVideoFeaturesChanged", (g)=>{
                            if ("Video" === g.mediaType && this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2) {
                                const f = this.mediaManager.getMediaEntitiesByModality("video");
                                f.length > 0 && this.mediaMessageController.sendMaxVideoSendCapabilitiesV2(f[0], g);
                            }
                        })), (_this_callbacks_onTransportConnected1 = (_this_callbacks3 = this.callbacks).onTransportConnected) === null || _this_callbacks_onTransportConnected1 === void 0 ? void 0 : _this_callbacks_onTransportConnected1.call(_this_callbacks3, g);
                    }
                }
                handleEarlyMediaAudioState(g) {
                    var _this_callbacks_onAudioStateChanged, _this_callbacks, _this_callbacks_onAudioStateChanged1, _this_callbacks1;
                    const f = this.peerConnection.getReceivers().filter((g)=>"audio" === g.track.kind)[0];
                    if (!f) return this.logger.safe.warn(`[${g}] Connected transport with provisional answer with no audio receiver`), void ((_this_callbacks_onAudioStateChanged = (_this_callbacks = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged === void 0 ? void 0 : _this_callbacks_onAudioStateChanged.call(_this_callbacks, Gt.STREAMING_STATE.active, g));
                    (_this_callbacks_onAudioStateChanged1 = (_this_callbacks1 = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged1 === void 0 ? void 0 : _this_callbacks_onAudioStateChanged1.call(_this_callbacks1, Gt.STREAMING_STATE.started, g);
                    const S = 500;
                    this.logger.safe.info(`[${g}] Starting polling for early media audio stats`);
                    const pollStats = async ()=>{
                        try {
                            var _this_callbacks_onAudioStateChanged, _this_callbacks;
                            if (this.terminated) return;
                            let v;
                            this.logger.safe.debug(`[${g}] Polling audio receiver stats to detect early media start`);
                            const _ = deferWithTimeout(S, "Unable to get audio receiver stats report");
                            f.getStats().then(_.resolve, _.reject);
                            const C = await _.promise;
                            this.diagnostics.registerEarlyMediaPoll();
                            for (const g of C.values())if ("inbound-rtp" === g.type) {
                                v = g;
                                break;
                            }
                            if (this.terminated || !v || v.bytesReceived > 0 || "have-remote-pranswer" !== this.transportStateProvider.signalingState) return this.logger.safe.info(`[${g}] Finished polling early media audio stats ${!this.terminated}`), void (this.terminated || ((_this_callbacks_onAudioStateChanged = (_this_callbacks = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged === void 0 ? void 0 : _this_callbacks_onAudioStateChanged.call(_this_callbacks, Gt.STREAMING_STATE.active, g)));
                            this.logger.safe.info(`[${g}] No audio data received yet, polling again in ${this.configProvider.config.webrtcPranswerWaitForMediaPollingInterval}ms`), setTimeout(pollStats, this.configProvider.config.webrtcPranswerWaitForMediaPollingInterval);
                        } catch (f) {
                            var _this_callbacks_onAudioStateChanged1, _this_callbacks1;
                            const S = stringifyObject(f);
                            this.logger.safe.error(`[${g}] Error polling stats for pranswer: ${S}`), this.diagnostics.addStatsError("WebrtcSession::earlyMediaPolling", S), (_this_callbacks_onAudioStateChanged1 = (_this_callbacks1 = this.callbacks).onAudioStateChanged) === null || _this_callbacks_onAudioStateChanged1 === void 0 ? void 0 : _this_callbacks_onAudioStateChanged1.call(_this_callbacks1, Gt.STREAMING_STATE.active, g);
                        }
                    };
                    pollStats();
                }
                startIceDisconnectedTimer(g) {
                    this.configProvider.config.iceDisconnectedTimeoutMs && (this.iceDisconnectedTimer = setTimeout(()=>{
                        this.logger.safe.error(`[${g}] ice disconnected for ${this.configProvider.config.iceDisconnectedTimeoutMs}ms. Raise ${Gt.MEDIA_ERROR.iceConnectionError}`), this.raiseError({
                            type: Gt.MEDIA_ERROR.iceConnectionError,
                            detail: "ice transport disconnected"
                        }, g);
                    }, this.configProvider.config.iceDisconnectedTimeoutMs));
                }
                clearIceDisconnectedTimer() {
                    this.iceDisconnectedTimer && (clearTimeout(this.iceDisconnectedTimer), this.iceDisconnectedTimer = null);
                }
                raiseError(g, f = generateCauseId()) {
                    this.logger.safe.error(`[${f}] Media error occurred type: ${g.type} detail: ${g.detail}`), this.callbacks.onSessionErrorOccurred && this.callbacks.onSessionErrorOccurred(g, f);
                }
                notifyStreamsChanged() {
                    this.streamsChangedNotificationScheduled || (this.logger.safe.info("Scheduling NotifyStreamsChanged"), this.streamsChangedNotificationScheduled = !0, this.negotiation.negotiationCompletedPromise.promise.catch(()=>{}).then(()=>{
                        var _this_streamsChangedListener, _this;
                        this.streamsChangedNotificationScheduled = !1, this.logger.safe.info("Executing NotifyStreamsChanged callback"), (_this_streamsChangedListener = (_this = this).streamsChangedListener) === null || _this_streamsChangedListener === void 0 ? void 0 : _this_streamsChangedListener.call(_this);
                    }));
                }
                async streamAdded(g) {
                    if (Gt.MODALITY.audio === g.getModality() && (this.webrtcAudioRecvStream = g.getMediaStream(), await this.audioRenderer.setOutputDevice(this.deviceManager.getOutputDeviceId()), await this.updateAudioRendererStream(this.webrtcAudioRecvStream)), this.configProvider.config.mapSsrcToTrackForStats) {
                        const f = this.mediaManager.getMediaEntityByRemoteStreamId(g.getMediaStream().id);
                        this.statsGatherer.setSsrcTrackPair(f.getRemoteSsrc(), f.getRemoteTrackId());
                    }
                    this.notifyStreamsChanged();
                }
                async updateAudioRendererStream(g) {
                    await this.audioRenderer.play(g), await this.deviceManager.effectsManager.setAecRefStream(g), this.rawIncomingAudioStreamManager.streamChanged(g);
                }
                streamRemoved(g) {
                    if (Gt.MODALITY.audio === g.getModality()) this.audioRenderer.getStream() === g.getMediaStream() && (this.audioRenderer.stop(), this.rawIncomingAudioStreamManager.streamChanged(null)), this.webrtcAudioRecvStream = null;
                    else if (Gt.MODALITY.video === g.getModality()) {
                        var _f_getLocalRecvCapabilities;
                        const f = this.mediaManager.getMediaEntityByRemoteStreamId(g.getMediaStream().id);
                        f === null || f === void 0 ? void 0 : (_f_getLocalRecvCapabilities = f.getLocalRecvCapabilities()) === null || _f_getLocalRecvCapabilities === void 0 ? void 0 : _f_getLocalRecvCapabilities.resetToInitial();
                    }
                    this.clearReceiveStreamTransforms(g.getReceiver()), g.dispose(), this.notifyStreamsChanged();
                }
                hasRelayCandidates() {
                    return this.relayCandidateGathered;
                }
                createReceiveStream(g, f, S, v) {
                    const _ = this.configProvider.config.addFmtpToInitialSubscription ? v.getLocalRecvCapabilities() : null, C = this.configProvider.config.useMultiviewLimitsOnInitialRequest && v.getModality() !== Gt.MODALITY.sharing ? ()=>this.remoteVideoManager.getMaxAllowedVideoFS() : null, E = new BC(g, f, v.getModality(), +v.getXSourceStreamId(), this, _, C, v.getSubstreamIndex());
                    return new yA(E, S, this.receiveStreamCollection, this.logger.createChild("RecvStream"), this.configProvider.config);
                }
                async requestSource(g, f, S) {
                    if (!this.multiParty) return;
                    const v = this.mediaManager.getMediaEntityByRemoteStreamId(g);
                    if ((this.isMuteHold || this.negotiation.negotiatedModalities[v.getModality()] === Gt.MEDIA_STATE.inactive) && -1 !== f) return await delay(10), this.requestSource(g, f, S);
                    if (this.negotiation.negotiationCompletedPromise.isPending) try {
                        await this.negotiation.negotiationCompletedPromise.promise;
                    } catch (e) {
                        this.logger.safe.info("source request should be sent even if negotiation rejected");
                    }
                    if (!this.transportStateProvider.isConnected || this.transportStateProvider.isWaitingAcceptProvisional) {
                        this.logger.safe.info("requestSource is postponed till transport is connected");
                        const g = new ct;
                        this.transportStateProvider.doOnConnected(()=>g.resolve(), "requestSource"), await g.promise;
                    }
                    return this.mediaMessageController.sendSourceRequest(v.getXSourceStreamId(), f, v === null || v === void 0 ? void 0 : v.getMid(), S, v.getSubstreamIndex());
                }
                async onReceiveCapabilitiesChanged(g, f, S) {
                    if (!this.streamSendersManager) return !1;
                    try {
                        return await this.streamSendersManager.applyCapabilities(f, g, S), !0;
                    } catch (g) {
                        return !1;
                    }
                }
                onOptimalVideoCountChanged(g, f) {
                    var _this_subscriptionManager;
                    this.callback.onOptimalVideoReceiversCountChanged && this.callback.onOptimalVideoReceiversCountChanged(g), this.diagnostics.addOvcSubscriptionReport(g, (_this_subscriptionManager = this.subscriptionManager) === null || _this_subscriptionManager === void 0 ? void 0 : _this_subscriptionManager.getSubscriptionsCount(), f);
                }
                async onSendBandwidthChanged(g) {
                    if (!this.transportStateProvider.isConnected || this.transportStateProvider.isWaitingAcceptProvisional || !this.mediaControlPlane.mcpFeaturesSupported("senderSideBandwidthEstimationEnabled")) return;
                    const f = [], S = Object.keys(g);
                    for (const v of S){
                        const S = this.mediaManager.getMediaEntitiesByModality(mediaTypeToModality(v)).filter((g)=>g.isEnabled() && null !== g.getLocalTrackId());
                        if (0 === S.length || 0 === g[v]) return;
                        f.push({
                            streamMsid: S[0].getXSourceStreamId(),
                            bw: g[v]
                        });
                    }
                    await this.mediaMessageController.sendBandwidthInfo(f), this.diagnostics.reportedSendBandwidthLayouts(g);
                }
                onMaxVideoSendCapabilitiesChanged(g, f) {
                    ("Video" === g && this.configProvider.config.maxSendVideoCapabilities.enableForVideo || "ScreenShare" === g && this.configProvider.config.maxSendVideoCapabilities.enableForSharing) && this.transportStateProvider.doOnConnected(()=>this.notifyMaxVideoCapabilitiesChanged(g, f), "maxCapabilities");
                }
                notifyMaxVideoCapabilitiesChanged(g, f) {
                    const S = mediaTypeToModality(g), v = this.mediaManager.getMediaEntitiesByModality(S)[0];
                    if (!v) return;
                    const _ = v.getMid();
                    "Video" === g && f.maxFs === Gt.MAX_FS_1080P && this.configProvider.config.software1080p && this.videoFeatureManager.get(g).toggleClient(2, !0), "Video" === g && this.configProvider.config.maxSendVideoCapabilities.enableForVideoV2 ? this.mediaMessageController.sendMaxVideoSendCapabilitiesV2(v, this.videoFeatureManager.get("Video"), f) : this.mediaMessageController.sendMaxVideoSendCapabilities([
                        _
                    ], f);
                }
                createAudioRenderer() {
                    this.audioRenderer = new G_(this.logger.createChild("AudioRenderer"), this.configProvider, this.diagnostics.newAudioRendererDiagnostics()), this.ufdManager.signalDeviceEvent(1, "Good", "Audio"), this.context.maContext.domOverrides.onMediaElementAdded && this.audioRenderer.on("onAudioElementAdded", this.context.maContext.domOverrides.onMediaElementAdded), this.context.maContext.domOverrides.onMediaElementRemoved && this.audioRenderer.on("onAudioElementRemoved", this.context.maContext.domOverrides.onMediaElementRemoved), this.audioRenderer.on("onAudioPlaybackError", (g, f, S)=>this.onAudioPlaybackError(g, f, S));
                }
                onAudioPlaybackError(g, f, S) {
                    var _this_configProvider_config_audioRendererFailedRetryCodes;
                    const v = {
                        type: f,
                        detail: S,
                        isAudio: !0
                    };
                    this.ufdManager.signalDeviceEvent(1, "Bad", "Audio"), this.deviceManager.raiseTelemetryEvent("reconnect_on_audio_playback_error", {
                        error: g,
                        mediaError: f,
                        message: S
                    }), this.context.reconnectRetry && ((_this_configProvider_config_audioRendererFailedRetryCodes = this.configProvider.config.audioRendererFailedRetryCodes) === null || _this_configProvider_config_audioRendererFailedRetryCodes === void 0 ? void 0 : _this_configProvider_config_audioRendererFailedRetryCodes.includes(g)) && (this.logger.warn(`Reconnect required, attempt No: ${this.context.reconnectRetry}`), this.context.reconnectRetry--, this.raiseError(v));
                }
                getSessionConfig() {
                    return this.configProvider;
                }
                getLocalMediaTrackId(g) {
                    const f = this.mediaManager.getLocalTracksInfo(), S = mediaTypeToModality(g), v = f.find((g)=>g.modality === S);
                    return v ? v.trackId : null;
                }
                addReceiveStreamTransforms(g, f) {
                    var _this_configProvider_config_useInsertableStreams;
                    const S = this.encStreamsManager.initTransformsCollection(g, "Receiver", modalityToMediaType(f));
                    S && f !== Gt.MODALITY.audio && ((_this_configProvider_config_useInsertableStreams = this.configProvider.config.useInsertableStreams) === null || _this_configProvider_config_useInsertableStreams === void 0 ? void 0 : _this_configProvider_config_useInsertableStreams.videoStreamAnalyzer) && S.addTransform(new qs(this.logger.createChild(`RecvStreamAnalyzer [${f}/${g.track.id}]`)));
                }
                clearReceiveStreamTransforms(g) {
                    this.encStreamsManager.clearTransformsCollection(g);
                }
                async checkVideoCodecsSupport() {
                    try {
                        var _g_codecs;
                        const g = await this.capabilityGatherer.getCapabilities("video");
                        this.statsGatherer.setH264AvailableProfiles(g);
                        const f = eb.build({
                            global: this.context.maContext
                        }, this.configProvider.config.useSdpCapabilities, this.configProvider.config.noRequiredCodecsWorkaround, !0), S = await f.getCapabilities("video"), v = eb.build({
                            global: this.context.maContext
                        }, !1), _ = await v.getCapabilities("video");
                        this.statsGatherer.setSupportedH264Profiles(S, _);
                        const C = await ss.isCodecsSupported(this.configProvider.config.hevcCodecs);
                        this.diagnostics.videoCapabilities = g, this.diagnostics.setSupportedH264Profiles(S, _), this.diagnostics.isCodecsSupported = C;
                        const E = new Set((g === null || g === void 0 ? void 0 : (_g_codecs = g.codecs) === null || _g_codecs === void 0 ? void 0 : _g_codecs.map((g)=>g.mimeType.toLocaleLowerCase())) || []);
                        for (const g of this.configProvider.config.requiredVideoCodecs)if (!E.has(g)) {
                            this.ufdManager.signalEvent("NoRequiredVideoCodecs", "Bad", "Video");
                            break;
                        }
                    } catch (g) {
                        this.logger.safe.error(`failed to get video capability ${stringifyObject(g)}`);
                    }
                }
                setBWSeed(g) {
                    if (!this.bandwidthCache) return;
                    const f = this.bandwidthCache.getSeed();
                    g.applyChannelParameters = {
                        multiChannelParameter: {
                            mids: this.configProvider.config.bwSeedOptions.mids,
                            mediaParameter: JSON.stringify({
                                sendSideBWSeed: {
                                    seedValueBitsPerSec: f
                                }
                            })
                        }
                    }, this.diagnostics.sentBWSeed = f;
                }
                getSubscriptionManager() {
                    return this.subscriptionManager;
                }
                initAudioCodec(g) {
                    this.audioCodecManager.init(g, this.isAudioOutputMuted);
                    const f = this.audioCodecManager.decoder;
                    f && (f.on("usedDecoderChanged", (g)=>{
                        var _this_contributingSources;
                        this.updateAudioRendererStream(g ? f.stream : this.webrtcAudioRecvStream), this.statsGatherer.setAudioDecoderStatsProvider(g ? f.getStatsProvider() : void 0), (_this_contributingSources = this.contributingSources) === null || _this_contributingSources === void 0 ? void 0 : _this_contributingSources.useCustomCodec(g);
                    }), f.on("contributingSourcesChanged", (g)=>{
                        var _this_contributingSources;
                        return (_this_contributingSources = this.contributingSources) === null || _this_contributingSources === void 0 ? void 0 : _this_contributingSources.updateContributingSources(g);
                    }), this.audioCodecManager.on("negotiationNeeded", (g)=>this.negotiation.triggerRenegotiation(!0, g)));
                }
                onIncomingVideoQualityChanged(g, f) {
                    1 === g && this.remoteVideoResolutionManager.limitResolutionOnPoorPerformance(f);
                }
                getVideoDeviceManager() {
                    return this.context.callDeviceManager.getDeviceManager("Video");
                }
                setupCallDeviceManagerSubs() {
                    this.callDeviceManagerSub = this.context.callDeviceManager.on("onSelectedVirtualDevicesChanged", ()=>{
                        this.logger.info("VirtualDevice changed, disposing deviceManager subscriptions"), this.deviceManagerSubs.forEach((g)=>g.dispose()), this.logger.info("New subscriptions for deviceManager created"), this.setSubsForDeviceManager();
                    });
                }
                updateLocalMediaSources() {
                    this.mediaManager.updateMediaEntitiesWithLocalTracks(), this.configProvider.config.mapSsrcToTrackForStats && this.statsGatherer.updateStatsWithLocalSsrcTrackInfo();
                    const g = this.streamSendersManager.getLocalMediaSources();
                    this.qualityManager.updateRegisteredSources(g);
                }
                constructor(g, f, S){
                    var _this_context_config, _this_context_maContext_getEncodedStreamsWorkerProvider, _this_context_maContext;
                    this.context = g, this.callId = f, this.callback = S, this.callbacks = {}, this.multiParty = (_this_context_config = this.context.config) === null || _this_context_config === void 0 ? void 0 : _this_context_config.isConference, this.configProvider = this.context.configProvider, this.logger = this.context.getLogger().createChild("webrtc2-" + ++GA), this.videoFeatureManager = new kb(this.logger.createChild("VFM")), this.ufdManager = this.context.getUfdManager(), this.deviceManager = this.context.callDeviceManager.getDefaultDeviceManager(), this.capabilityGatherer = eb.build({
                        global: this.context.maContext
                    }, this.configProvider.config.useSdpCapabilities, this.configProvider.config.noRequiredCodecsWorkaround), this.reinvitelessContext = makeReinvitelessContext(this.context.config.reinvitelessConfig, this.multiParty), this.iceHostCandidateOnly = this.multiParty && getFrom("iceHostCandidateOnly", this.context.config, this.configProvider.config), this.mediaManager = new Sy({
                        logger: this.logger,
                        configProvider: this.configProvider,
                        numVideoChannels: this.multiParty && this.configProvider.config.numVideoChannelsGvc || 1,
                        useSimulcast: this.multiParty,
                        reinviteltessContext: this.reinvitelessContext
                    }), this.receiveStreamCollection = new AT({
                        streamAdded: (g)=>this.streamAdded(g),
                        streamRemoved: (g)=>this.streamRemoved(g)
                    }), this.diagnostics = this.context.diagnostics, this.qmDiagnostics = this.diagnostics.newQualityManagerDiagnostics(), this.statsGatherer = new WI(this.logger.createChild("stats"), this.configProvider, this.diagnostics, this.mediaManager, this.multiParty), this.networkQualityDiagnostics = new DA(this.configProvider), this.speechDetectionDiagnostics = new kA(this.configProvider), this.qualityManager = new _b(this.logger.createChild("qm"), {
                        scalingEnabled: this.configProvider.config.webrtcVideoScaling,
                        customBwEstimationEnabled: this.configProvider.config.webrtcEnabledCustomBwEstimationForVideo
                    }, this, this.statsGatherer, this.qmDiagnostics, this.configProvider), this.activeSpeakerManager = new bT(this.callback.onContributingSourcesChanged, this.callback.onDominantSpeakerChanged, this.logger.createChild("ActiveSpeakerManager"), this.diagnostics.dshDiagnostics), this.wasConnected = !1, this.isAudioInputMuted = this.context.config.muted, this.isAudioOutputMuted = !1, this.relayCandidateGathered = !1, this.iceDisconnectedTimer = null, this.statisticsReport = Promise.resolve({
                        type: "WebRtcMediaStats",
                        data: {}
                    }), this.terminated = !1, this.dtmfSender = wb.build({
                        logger: this.logger,
                        configProvider: this.configProvider
                    }), this.streamsChangedNotificationScheduled = !1, this.subscriptionManager = new jC(this.logger.createChild("subs"), this.configProvider, {
                        getStreams: ()=>this.receiveStreamCollection.getStreams(),
                        setOnStreamsChangedHandler: (g)=>this.streamsChangedListener = g
                    }, this.diagnostics.newSubscriptionManagerDiagnostics()), this.remoteVideoResolutionManager = new Cb(this.logger.createChild("rvrm"), this.multiParty, this.configProvider, this.mediaManager, this.statsGatherer, this.diagnostics), this.remoteVideoManager = new bb(this.logger.createChild("RemoteVideoManager"), this.configProvider, this.statsGatherer, this.diagnostics, this.remoteVideoResolutionManager, this.context.maContext.domOverrides), this.encStreamsManager = new vs(this.configProvider, (_this_context_maContext_getEncodedStreamsWorkerProvider = (_this_context_maContext = this.context.maContext).getEncodedStreamsWorkerProvider) === null || _this_context_maContext_getEncodedStreamsWorkerProvider === void 0 ? void 0 : _this_context_maContext_getEncodedStreamsWorkerProvider.call(_this_context_maContext), this.logger.createChild("EncodedStreamsManager")), this.streamSendersManager = new CA(this.mediaManager, this.logger.createChild("SSM"), this.context.callDeviceManager, this.configProvider, this.context.config, this.statsGatherer, this.diagnostics, this.qmDiagnostics, this.multiParty, this.encStreamsManager, this.videoFeatureManager), this.hwSilent = !1, this.deviceManagerSubs = [], this.isMuteHold = !1, this.rawIncomingAudioStreamManager = new Zr(this.logger.createChild("rawIncomingAudioStream")), this.useNullAudioStream = !1, this.audioCodecManager = new xs(this.encStreamsManager, this.logger, this.configProvider), this.perfMonitorSubs = [], this.performanceMonitor = new MA(this.statsGatherer, this.diagnostics, this.configProvider, this.logger.createChild("PerformanceMonitor")), this.negotiation = new xA(this.logger.createChild("negotiation"), this.configProvider, this.diagnostics.newNegotiationDiagnostics(this.statsGatherer.sessionInfo), this.reinvitelessContext, this.mediaManager, this.audioCodecManager, this.ufdManager, this.context, this.qualityManager, this.streamSendersManager, {
                        onNegotiationRequired: (g, f)=>{
                            var _this_callbacks_onNegotiationRequired, _this_callbacks;
                            return (_this_callbacks_onNegotiationRequired = (_this_callbacks = this.callbacks).onNegotiationRequired) === null || _this_callbacks_onNegotiationRequired === void 0 ? void 0 : _this_callbacks_onNegotiationRequired.call(_this_callbacks, g, f);
                        },
                        onUpdateMediaDescriptionsRequired: (g, f)=>{
                            var _this_callbacks_onUpdateMediaDescriptionsRequired, _this_callbacks;
                            return (_this_callbacks_onUpdateMediaDescriptionsRequired = (_this_callbacks = this.callbacks).onUpdateMediaDescriptionsRequired) === null || _this_callbacks_onUpdateMediaDescriptionsRequired === void 0 ? void 0 : _this_callbacks_onUpdateMediaDescriptionsRequired.call(_this_callbacks, g, f);
                        },
                        updateLocalMediaSources: this.updateLocalMediaSources.bind(this),
                        assurePC: this.assurePeerConnectionAsync.bind(this),
                        hasPC: ()=>!!this.peerConnection,
                        createOffer: (g)=>this.peerConnection.createOffer(g),
                        createAnswer: (g)=>this.peerConnection.createAnswer(g),
                        setLocalDescription: (g)=>this.peerConnection.setLocalDescription(g),
                        getLocalDescription: ()=>this.peerConnection.localDescription,
                        setRemoteDescription: (g)=>this.peerConnection.setRemoteDescription(g),
                        setBWSeed: this.setBWSeed.bind(this),
                        onTransportInitialized: ()=>this.callbacks.onTransportInitialized(),
                        startWaitingForStreamStart: (g)=>{
                            this.statsGatherer.startWaitingForStreamStart(g);
                        },
                        getRollbackModifier: (g)=>new wT(this.peerConnection, this.configProvider, g)
                    }), this.streamConfigurationHandler = new Ob(this.logger, this.negotiation.negotiationEmulator, this.qualityManager, this.qmDiagnostics, this.configProvider, this.statsGatherer), this.pauseNegotiations = this.negotiation.pauseNegotiations.bind(this.negotiation), this.configureModalitiesAsync = this.negotiation.configureModalities.bind(this.negotiation), this.createOfferAsync = this.negotiation.createOffer.bind(this.negotiation), this.processOfferAsync = this.negotiation.processOffer.bind(this.negotiation), this.createAnswerAsync = this.negotiation.createAnswer.bind(this.negotiation), this.processAnswerAsync = this.negotiation.processAnswer.bind(this.negotiation), this.completeNegotiationAsync = this.negotiation.completeNegotiation.bind(this.negotiation), this.rejectNegotiationAsync = this.negotiation.rejectNegotiation.bind(this.negotiation), this.startMediaDescriptionsUpdateAsync = this.negotiation.startMediaDescriptionsUpdate.bind(this.negotiation), this.completeMediaDescriptionsUpdateAsync = this.negotiation.completeMediaDescriptionsUpdate.bind(this.negotiation), this.rejectMediaDescriptionsUpdateAsync = this.negotiation.rejectMediaDescriptionsUpdate.bind(this.negotiation), this.statsGatherer.on("onDiagnosticUpdated", (g)=>this.processStatsReport(g)), this.statsGatherer.on("onStatisticsChanged", (g)=>this.processLegacyStats(g)), this.remoteVideoResolutionManager.on("onNegotiationRequired", ()=>this.negotiation.triggerRenegotiation(!0)), this.remoteVideoResolutionManager.on("onSourceRequestRequired", (g, f, S)=>this.requestSource(g, f, S)), this.setSubsForSubscriptionManager(), this.setSubsForStreamManagerEvents(), this.configProvider.mediaConfig.maxBandwidthInKbps && (this.statsGatherer.setMaxSessionBandwidth(this.configProvider.mediaConfig.maxBandwidthInKbps), this.diagnostics.maxSessionBandwidth = this.configProvider.mediaConfig.maxBandwidthInKbps), this.createAudioRenderer(), this.setSubsForDeviceManager(), this.context.callDeviceManager.isVirtualDeviceEnabled && this.setupCallDeviceManagerSubs(), this.configProvider.config.enableActiveSpeakerBasedDSH && this.activeSpeakerManager.setStrategy(new TA({
                        configProvider: this.configProvider
                    })), this.perfMonitorSubs.push(this.performanceMonitor.on("onIncomingVideoQualityChanged", (g, f)=>{
                        this.onIncomingVideoQualityChanged(g, f);
                    })), this.configProvider.config.webrtcVideoScaling && (this.perfMonitorSubs.push(this.performanceMonitor.on("onOptimalVideoCountChanged", (g, f)=>{
                        this.onOptimalVideoCountChanged(g, f);
                    })), this.onOptimalVideoCountChanged(this.configProvider.config.nonEstimatedDefaultVideoReceiversCount)), this.configProvider.config.setBWSeed && (this.bandwidthCache = new r_(this.configProvider)), this.diagnostics.reinvitelessContext = this.reinvitelessContext, this.multiParty && this.configProvider.config.enableVideoFeatureManager && this.videoFeatureManager.manageFeatureSupport(()=>{
                        if (this.detectVideoFeatures(), this.configProvider.config.enableDevtoolsAPI) {
                            var _window;
                            const g = (_window = window) === null || _window === void 0 ? void 0 : _window.webMA;
                            (g === null || g === void 0 ? void 0 : g.initVideoFeatures) && g.initVideoFeatures(this.videoFeatureManager);
                        }
                    });
                }
            }, WA = {
                build: (g, f, S)=>new qA(g, f, S)
            };
            function makeReinvitelessContext(g, f) {
                const S = (f ? g === null || g === void 0 ? void 0 : g.maxReinvitelessMediaForVideoMultiparty : g === null || g === void 0 ? void 0 : g.maxReinvitelessMediaForVideo1on1) || 0, v = (f ? g === null || g === void 0 ? void 0 : g.maxReinvitelessMediaForVBSSMultiparty : g === null || g === void 0 ? void 0 : g.maxReinvitelessMediaForVBSS1on1) || 0;
                return {
                    enabled: S > 0 || v > 0,
                    maxStreamsForModality: {
                        video: S,
                        sharing: v
                    }
                };
            }
            var zA = class {
                createSession(g, f, S, v, _, C) {
                    const E = (0, iT.merge)({}, this.mediaConfig, C);
                    this.configProvider.setMediaConfiguration(E);
                    const T = this.configProvider.getConfigView(S === null || S === void 0 ? void 0 : S.isConference), I = this.logger, b = f.correlationId, A = this.diagnostics.newSession(T, b, this.logger.createChild("sessionDiagnostics"));
                    _ === null || _ === void 0 ? void 0 : _.setDiagnosticsReport(this.diagnostics.reportGenerator);
                    const R = {
                        getLogger: ()=>I,
                        getUfdManager: ()=>this.ufdManager,
                        sendWebRtcMediaNotificationAsyncCallback: (g, S)=>f.sendWebRtcMediaNotificationAsync(g, S),
                        maContext: this.context,
                        config: S !== null && S !== void 0 ? S : {},
                        configProvider: T,
                        diagnostics: A.newNativeSessionDiag(),
                        reconnectRetry: T.config.audioRendererFailedReconnectTimes,
                        callDeviceManager: v,
                        getSmallCallTelemetry: ()=>_
                    }, P = (T.mediaConfig.simulcastSessionEnabled ? WA : Vb).build(R, b, g), w = new IT(T, ++this.callsCount, A);
                    w.setMediaQosEnabled(!!E.enableMediaQoS), w.setPortRangeConfigured(!!E.mediaPortRanges);
                    const M = new vT(P, b, R, g, w, this.configProvider, A);
                    for(M.on("onTerminated", (g)=>this.onSessionTerminated(g)), this.activeSessions.push(M), this.configProvider.updateSessionCount(this.activeSessions.length), this.webRtcInternalsCollector = aT.getInstance(this.logger.createChild("WebRtcInternals"), T), this.webRtcInternalsCollector.updateSessionCount(this.activeSessions.length); this.pendingDeviceTelemetryEvents.length > 0;)M.registerDeviceTelemetryEvent(this.pendingDeviceTelemetryEvents.pop());
                    for(; this.pendingVideoEffectsTelemetryEvents.length > 0;)M.registerVideoEffectsTelemetryEvent(this.pendingVideoEffectsTelemetryEvents.pop());
                    for(; this.pendingAudioEffectsTelemetryEvents.length > 0;)M.registerAudioEffectsTelemetryEvent(this.pendingAudioEffectsTelemetryEvents.pop());
                    return M;
                }
                getDeviceManager() {
                    return this.deviceManager;
                }
                getCapabilities() {
                    return this.capabilities;
                }
                getScreenSharingManager() {
                    return new lT(this.deviceManager);
                }
                updateConfig(g, f, S, v) {
                    this.configProvider.updateConfig(g, f, S, v);
                }
                getConfig() {
                    return this.configProvider.config;
                }
                getConfigProvider() {
                    return this.configProvider;
                }
                setMediaConfig(g) {
                    (0, iT.merge)(this.mediaConfig, g), this.diagnostics.mediaConfig = this.mediaConfig;
                }
                getMediaLogs() {
                    return this.webRtcInternalsCollector ? this.webRtcInternalsCollector.collect() : Promise.resolve("");
                }
                getDiagnosticsData() {
                    return this.diagnostics.rootRef;
                }
                dispose(g) {
                    return Promise.all([
                        ...this.activeSessions.map(async (f)=>{
                            await f.terminate(g, {}).catch(()=>{}), f.dispose();
                        })
                    ]).then(()=>{}, ()=>{});
                }
                handleSendMidCallTelemetry(g) {
                    var _this_midCallTelemetry;
                    (_this_midCallTelemetry = this.midCallTelemetry) === null || _this_midCallTelemetry === void 0 ? void 0 : _this_midCallTelemetry.on("sendMidCallTelemetry", g);
                }
                configApplied() {
                    window && (this.configProvider.config.enableDevtoolsAPI ? window.webMA || this.injectDevtoolsAPI() : window.webMA && delete window.webMA);
                }
                injectDevtoolsAPI() {
                    const g = [], f = {
                        config: {
                            addOverride: (g, f)=>this.configProvider.setConsoleOverride(g, f),
                            setOverrides: (g)=>this.configProvider.setConsoleOverrides(g),
                            clearOverride: (g)=>this.configProvider.clearConsoleOverride(g),
                            clearAllOverrides: ()=>this.configProvider.clearAllConsoleOverrides(),
                            setConstraints: (g)=>this.configProvider.setCallConstraints(g),
                            setRelayConfigOverride: (g)=>this.context.getRelayManager().setRelayOverride(g),
                            manageVideoFeatures: (f)=>{
                                g.push(f);
                            }
                        },
                        diagnosticsReport: this.diagnostics.reportGenerator,
                        initVideoFeatures: (f)=>{
                            g.forEach((g)=>{
                                g((g, S, v)=>{
                                    let _;
                                    const C = Db[v];
                                    return void 0 !== C && (("video" === S || "sharing" === S) && (_ = f.get("Video")), void 0 !== _) && (g ? (_.toggleServer(C, !0), !0) : (_.toggleClient(C, !0), !0));
                                });
                            });
                        },
                        deviceManager: {
                            setAudioProcessingFlags: (g)=>this.deviceManager.setAudioProcessingFlags(g)
                        },
                        ufdManager: {
                            raiseUFD: (g, f = "Bad", S = "Video")=>this.ufdManager.signalEvent(g, f, S)
                        }
                    };
                    window.webMA = f;
                }
                onDeviceTelemetryEvent(g) {
                    this.activeSessions.length > 0 ? this.activeSessions.forEach((f)=>f.registerDeviceTelemetryEvent(g)) : this.pendingDeviceTelemetryEvents.push(g);
                }
                onVideoEffectsTelemetryEvent(g) {
                    this.activeSessions.length > 0 ? this.activeSessions.forEach((f)=>f.registerVideoEffectsTelemetryEvent(g)) : this.pendingVideoEffectsTelemetryEvents.push(g);
                }
                onAudioEffectsTelemetryEvent(g) {
                    this.activeSessions.length > 0 ? this.activeSessions.forEach((f)=>f.registerAudioEffectsTelemetryEvent(g)) : this.pendingAudioEffectsTelemetryEvents.push(g);
                }
                onSessionTerminated(g) {
                    remove2(this.activeSessions, (f)=>f === g), this.configProvider.updateSessionCount(this.activeSessions.length), this.webRtcInternalsCollector.updateSessionCount(this.activeSessions.length), 0 === this.activeSessions.length && this.ufdManager.reset();
                }
                constructor(g, f, S, v, _, C, E, T){
                    this.logger = g, this.context = f, this.configProvider = S, this.diagnostics = v, this.ufdManager = _, this.deviceManager = C, this.capabilities = E, this.midCallTelemetry = T, this.activeSessions = [], this.pendingDeviceTelemetryEvents = [], this.pendingVideoEffectsTelemetryEvents = [], this.pendingAudioEffectsTelemetryEvents = [], this.callsCount = 0, this.mediaConfig = {}, this.configProvider.on("configUpdated", ()=>this.configApplied()), this.deviceManager.on("onDeviceTelemetryEvent", (g)=>this.onDeviceTelemetryEvent(g)), this.deviceManager.on("onVideoEffectsTelemetryEvent", (g)=>this.onVideoEffectsTelemetryEvent(g)), this.deviceManager.on("onAudioEffectsTelemetryEvent", (g)=>this.onAudioEffectsTelemetryEvent(g));
                }
            }, KA = class {
                static build(g, f, S, v, _, C, E, T) {
                    return new zA(g, f, S, v, _, C, E, T);
                }
            };
            KA.constants = Gt, KA.helper = as;
            var JA = class {
                getWorkerFunction(g) {
                    var _this_callbacks;
                    if (this.logger.info(`getWorkerFunction, loaderName: ${g}`), !((_this_callbacks = this.callbacks) === null || _this_callbacks === void 0 ? void 0 : _this_callbacks.createGenericWebRTCWorker)) switch(g){
                        case "encoded-stream":
                            var _this_callbacks1;
                            return (_this_callbacks1 = this.callbacks) === null || _this_callbacks1 === void 0 ? void 0 : _this_callbacks1.createEncodedStreamsWorker;
                        case "wasmcv":
                            var _this_callbacks2;
                            return (_this_callbacks2 = this.callbacks) === null || _this_callbacks2 === void 0 ? void 0 : _this_callbacks2.createWasmCVWorker;
                        default:
                            return;
                    }
                    switch(g){
                        case "encoded-stream":
                            return this.createEncodedStreamsWorker;
                        case "wasmcv":
                            return this.createWasmCVWorker;
                        case "timer":
                            return this.createTimerWorker;
                        default:
                            return;
                    }
                }
                get audioWorklet() {
                    var _this_callbacks, _this_callbacks_audioWorklet, _this_callbacks1, _this_callbacks_audioWorklet1, _this_callbacks2, _this_callbacks_audioWorklet2, _this_callbacks3, _this_callbacks4;
                    return ((_this_callbacks = this.callbacks) === null || _this_callbacks === void 0 ? void 0 : _this_callbacks.createGenericWebRTCWorker) ? {
                        getWasmVqeWorker: this.getWasmVqeWorker,
                        getWasmDnsWorklet: (_this_callbacks1 = this.callbacks) === null || _this_callbacks1 === void 0 ? void 0 : (_this_callbacks_audioWorklet = _this_callbacks1.audioWorklet) === null || _this_callbacks_audioWorklet === void 0 ? void 0 : _this_callbacks_audioWorklet.getWasmDnsWorklet,
                        getWasmAecWorklet: (_this_callbacks2 = this.callbacks) === null || _this_callbacks2 === void 0 ? void 0 : (_this_callbacks_audioWorklet1 = _this_callbacks2.audioWorklet) === null || _this_callbacks_audioWorklet1 === void 0 ? void 0 : _this_callbacks_audioWorklet1.getWasmAecWorklet,
                        getWasmVqeWorklet: (_this_callbacks3 = this.callbacks) === null || _this_callbacks3 === void 0 ? void 0 : (_this_callbacks_audioWorklet2 = _this_callbacks3.audioWorklet) === null || _this_callbacks_audioWorklet2 === void 0 ? void 0 : _this_callbacks_audioWorklet2.getWasmVqeWorklet
                    } : (_this_callbacks4 = this.callbacks) === null || _this_callbacks4 === void 0 ? void 0 : _this_callbacks4.audioWorklet;
                }
                create(g) {
                    const f = this.callbacks.createGenericWebRTCWorker(), S = Date.now(), onError = (S)=>{
                        var _this_deviceManagerDiagnostics;
                        this.logger.error(`Worker ${JSON.stringify(g)} error: ${S}`), (_this_deviceManagerDiagnostics = this.deviceManagerDiagnostics) === null || _this_deviceManagerDiagnostics === void 0 ? void 0 : _this_deviceManagerDiagnostics.registerWorkerEvent({
                            timestamp: Date.now(),
                            workerType: g.msg,
                            msg: "generic-worker-error",
                            payload: JSON.stringify(S)
                        }), f.removeEventListener("error", onError);
                    }, onMessage = (v)=>{
                        var _v_data, _v_data1, _v_data2, _v_data3, _v_data4, _this_deviceManagerDiagnostics;
                        let _;
                        "wasm-worker-loaded" === (v === null || v === void 0 ? void 0 : (_v_data = v.data) === null || _v_data === void 0 ? void 0 : _v_data.msg) && (this.logger.info(`Worker ${JSON.stringify(g)} event: ${JSON.stringify(v.data)}`), _ = {
                            timestamp: Date.now(),
                            workerType: g.msg,
                            workerLoadTimeMs: Date.now() - S,
                            msg: JSON.stringify(v === null || v === void 0 ? void 0 : (_v_data1 = v.data) === null || _v_data1 === void 0 ? void 0 : _v_data1.msg),
                            payload: JSON.stringify(v === null || v === void 0 ? void 0 : (_v_data2 = v.data) === null || _v_data2 === void 0 ? void 0 : _v_data2.payload)
                        }, f.removeEventListener("message", onMessage)), "wasm-worker-load-error" === (v === null || v === void 0 ? void 0 : (_v_data3 = v.data) === null || _v_data3 === void 0 ? void 0 : _v_data3.msg) && (this.logger.info(`Worker ${JSON.stringify(g)} error: ${JSON.stringify(v.data)}`), _ = {
                            timestamp: Date.now(),
                            workerType: g.msg,
                            msg: "load-worker-error",
                            payload: JSON.stringify(v === null || v === void 0 ? void 0 : (_v_data4 = v.data) === null || _v_data4 === void 0 ? void 0 : _v_data4.payload)
                        }), _ && ((_this_deviceManagerDiagnostics = this.deviceManagerDiagnostics) === null || _this_deviceManagerDiagnostics === void 0 ? void 0 : _this_deviceManagerDiagnostics.registerWorkerEvent(_));
                    };
                    return f.addEventListener("error", onError), f.addEventListener("message", onMessage), f.postMessage(g), f;
                }
                constructor(g, f, S){
                    this.logger = g, this.callbacks = f, this.deviceManagerDiagnostics = S, this.createWasmCVWorker = ()=>(this.logger.info("Creating wasmcv worker"), this.create({
                            msg: "wasmcv"
                        })), this.createEncodedStreamsWorker = ()=>(this.logger.info("Creating encoded-stream worker"), this.create({
                            msg: "encoded-stream"
                        })), this.createTimerWorker = ()=>(this.logger.info("Creating timer worker"), this.create({
                            msg: "timer"
                        })), this.getWasmVqeWorker = ()=>(this.logger.info("Creating wasmvqe worker"), this.create({
                            msg: "wasmvqe"
                        }));
                }
            }, YA = class {
                getWorker(g) {
                    try {
                        g.safe.info("creating worker");
                        const f = this.wasmLoader.getWorkerFunction("encoded-stream");
                        return f ? f() : this.url ? (g.safe.warn("WasmLoader didn't provide worker function, falling back to legacy worker provider"), new Worker(this.url)) : (g.safe.error("no worker provider"), null);
                    } catch (f) {
                        g.safe.error(`failed to create worker ${stringifyObject(f)}`);
                    }
                    return null;
                }
                constructor(g, f){
                    this.wasmLoader = g, f && f.getWorkerUrl().then((g)=>{
                        this.url = g;
                    });
                }
            }, QA = class {
                getDeviceManager() {
                    return this.deviceManager;
                }
                async buildAgent(g, f, S) {
                    var _this_config;
                    if (!ss.hasMediaApi()) throw [
                        new XA(`${g} not supported by media agent provider`, "not_supported")
                    ];
                    if (((_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config.detectH264Support) && !await ss.hasH264CodecSupport(this.config.logger)) throw [
                        new XA("H264 is not supported", "not_supported")
                    ];
                    const v = new YA(this.wasmLoader, this.config.encodedStreamsWorkerProvider), _ = {
                        getRelayManager: ()=>f.getOrCreateRelayManager(),
                        getWebCVProvider: ()=>this.config.webcvProvider,
                        getWasmDnsProvider: ()=>this.config.wasmdnsProvider,
                        getWasmAecProvider: ()=>this.config.wasmaecProvider,
                        getWasmVqeProvider: ()=>this.config.wasmVqeProvider,
                        getEncodedStreamsWorkerProvider: ()=>v,
                        domOverrides: this.config.domOverrides,
                        configProvider: this.configProvider
                    };
                    f.setConfigProvider(this.configProvider);
                    const C = KA.build(this.logger, _, this.configProvider, this.mediaAgentDiagnostics, this.ufdManager, this.deviceManager, this.capabilities, S);
                    return C.constants = KA.constants, this.mediaAgents.push(C), C;
                }
                async dispose(g) {
                    return Promise.all([
                        this.deviceManager.dispose(),
                        this.ufdManager.dispose(),
                        this.configProvider.dispose(),
                        this.capabilities.dispose(),
                        ...this.mediaAgents.map((f)=>f.dispose(g))
                    ]).then(()=>{
                        this.mediaAgents = [];
                    });
                }
                constructor(g, f, S){
                    var _g_safeLogger;
                    var _g_logger, _g_domOverrides;
                    this.mediaAgents = [], (_g_logger = g.logger) !== null && _g_logger !== void 0 ? _g_logger : g.logger = new Ro, (_g_domOverrides = g.domOverrides) !== null && _g_domOverrides !== void 0 ? _g_domOverrides : g.domOverrides = {}, this.config = g;
                    const v = g.mediaSettings;
                    setAgentPlatformInfo(g.clientInformation), this.logger = new tT((_g_safeLogger = g.safeLogger) === null || _g_safeLogger === void 0 ? void 0 : _g_safeLogger.createChild("MA", v.debug), g.logger.createChild("MA", v.debug)), this.configProvider = new UC(this.logger.createChild("configProvider"), S, v);
                    const _ = new rC(this.configProvider);
                    this.mediaAgentDiagnostics = new eT(this.configProvider, _), this.ufdManager = new Mo(this.logger.createChild("UFD"), this.configProvider), this.wasmLoader = new JA(this.logger.createChild("WasmLoader"), g.createWasmWorkerCbs, _), this.deviceManager = new wC(this.logger.createChild("DeviceManager"), this.configProvider, _, g.domOverrides, this.ufdManager, g.webcvProvider, g.wasmdnsProvider, g.wasmaecProvider, g.wasmVqeProvider, this.wasmLoader), this.capabilities = new Po(this.configProvider), Zt.initialize(this.configProvider), f.on("OnECSChanged", ()=>{
                        const g = f.getEcsConfig("SkypeWebMedia", "mediaAgent");
                        g ? this.configProvider.updateConfig(g, f.ETag, f.getEcsConfig("ConfigIDs", "SkypeWebMedia"), f.getEcsConfig("Headers", "CountryCode")) : this.logger.warn("No SkypeWebMedia.mediaAgent config.");
                    });
                }
            }, XA = class extends Error {
                constructor(g, f = "failure"){
                    super(g), this.reason = f;
                }
            }, ZA = class {
                getPlatformSupportLevel(g) {
                    const f = Ze.getBrowserInfo(), S = this.supportedPlatforms.get(f.name);
                    if (g && S && Ze.isVersionGreaterOrEqual(S)) return 1;
                    if (g && !S) {
                        if (Ze.isEngine("Chromium", "ChromiumAVD")) return 2;
                        const g = this.experimentalPlatforms.get(f.name);
                        if (g && Ze.isVersionGreaterOrEqual(g)) return 2;
                    }
                    return 0;
                }
                constructor(){
                    this.supportedPlatforms = new Map([
                        [
                            "Chrome",
                            "59.0"
                        ],
                        [
                            "EdgeAnaheim",
                            "79.0"
                        ],
                        [
                            "Safari",
                            "13.1"
                        ],
                        [
                            "Electron",
                            "3.0"
                        ],
                        [
                            "Firefox",
                            "96.0"
                        ],
                        [
                            "Maglev",
                            "1.0"
                        ]
                    ]), this.experimentalPlatforms = new Map;
                }
            }, eR = class extends ze {
                get info() {
                    return this.currentInfo;
                }
                get areaContent() {
                    return this.currentAreaContent;
                }
                async getInfo() {
                    return this.isEnabled && !this.prober && await this.probeForIP("publicGetInfo"), this.currentInfo;
                }
                setClientInfo(g, f) {
                    if (this.isEnabled) switch(this.logger.info(`Client info for ${g} set`), g){
                        case 3:
                            this.mergeClientAreaInfo(JSON.parse(f));
                            break;
                        case 1:
                            break;
                        case 2:
                            this.mergeClientNetworkInfo(JSON.parse(f));
                    }
                }
                mergeClientAreaInfo(g) {
                    const f = JSON.stringify(this.currentAreaContent);
                    this.currentAreaContent.geoCoordinates = g.geoCoordinates, removeUndefinedFields(this.currentAreaContent), JSON.stringify(this.currentAreaContent) !== f && this.raiseChanged();
                }
                mergeClientNetworkInfo(g) {
                    if (0 === Object.keys(g).length) {
                        const g = Object.keys(this.currentInfo).length + Object.keys(this.currentAreaContent).length;
                        return this.currentInfo = {}, this.currentAreaContent = {}, void (g > 0 && this.raiseChanged());
                    }
                    const f = this.currentInfo.bssid !== g.bssid || this.currentInfo.bssidv6 !== g.bssidv6 || this.currentInfo.mac !== g.mac || this.currentInfo.macv6 !== g.macv6 || this.currentInfo.subnetLengthIpv4 !== g.subnetLengthIpv4 || this.currentInfo.subnetLengthIpv6 !== g.subnetLengthIpv6, S = this.currentInfo.e911;
                    this.currentInfo.bssid = g.bssid, this.currentInfo.bssidv6 = g.bssidv6, this.currentInfo.e911 = g.e911, this.currentInfo.mac = g.mac, this.currentInfo.macv6 = g.macv6, this.currentInfo.subnetLengthIpv4 = g.subnetLengthIpv4, this.currentInfo.subnetLengthIpv6 = g.subnetLengthIpv6, removeUndefinedFields(this.currentInfo), f ? this.probeForIP("clientNetworkInfoChanged").then((g)=>{
                        g || this.raiseChanged();
                    }) : JSON.stringify(S) !== JSON.stringify(g.e911) && this.raiseChanged();
                }
                async probeForIP(g) {
                    return this.probingPromise ? (this.logger.info(`Probing already in progress, tried to start for: ${g}`), this.probingPromise) : (this.probingPromise = this.probeForIPInternal(g), this.probingPromise.then((g)=>(this.probingPromise = void 0, g)).catch((g)=>(this.probingPromise = void 0, this.logger.error(`E911 probing failed: ${stringifyObject(g)}`), !1)));
                }
                async probeForIPInternal(g) {
                    this.logger.info(`Probing for public IP address: ${g}`);
                    const f = await this.ensureProber();
                    if (await f.ensureOnline(), f.ipFromRelay) {
                        if ((this.currentInfo.ipv4 || this.currentInfo.ipv6) !== f.ipFromRelay) return delete this.currentInfo.ipv4, delete this.currentInfo.ipv6, this.currentInfo[os.test(f.ipFromRelay) ? "ipv4" : "ipv6"] = f.ipFromRelay, this.raiseChanged(), !0;
                    } else if (0 !== Object.keys(this.currentInfo).length) return this.currentInfo = {}, this.raiseChanged(), !0;
                    return !1;
                }
                async ensureProber() {
                    if (this.prober) return this.prober;
                    const g = createProbeIceServers(await this.relayManagerProvider.getOrCreateRelayManager().queryRelaysAsync({
                        relayType: "turn"
                    }), this.configProvider.config);
                    return this.prober = new pT(g, new tT(this.logger.createChild("Prober"), this.logger.createChild("ProberUnsafe"))), this.prober;
                }
                constructor(g, f, S){
                    super(), this.relayManagerProvider = g, this.configProvider = f, this.logger = S, this.currentInfo = {}, this.currentAreaContent = {}, this.isEnabled = !1, this.isEnabled = this.configProvider.config.enableE911, f.on("configUpdated", ()=>{
                        var _this_prober;
                        const g = this.isEnabled;
                        this.isEnabled = this.configProvider.config.enableE911, !this.isEnabled || g === this.isEnabled && this.prober || ((_this_prober = this.prober) === null || _this_prober === void 0 ? void 0 : _this_prober.dispose(), this.prober = void 0, this.configProvider.config.probeE911OnInit && this.probeForIP("config"));
                    });
                }
            }, tR = class extends ze {
                get ETag() {
                    return this.etag;
                }
                async setEcsConfig(g) {
                    this.config = JSON.parse(g.ecsBlob), this.etag = g.etag, this.event("OnECSChanged").raise();
                }
                async setUserEcsServerUrl(g, f) {
                    throw new Error("Not implemented");
                }
                async getUserEcsServerUrl(g) {
                    throw new Error("Not implemented");
                }
                async setActiveUserForEcs(g) {
                    throw new Error("Not implemented");
                }
                async getEcsQueryParameters() {
                    var _this_ecsFilters_UserInfoRing, _this_ecsFilters;
                    const g = {};
                    g.CLRelease = getTsCallingVersion();
                    const f = "_TS_BUILC_VERSION_".replace("C", "D"), S = (_this_ecsFilters = this.ecsFilters) === null || _this_ecsFilters === void 0 ? void 0 : (_this_ecsFilters_UserInfoRing = _this_ecsFilters["UserInfo.Ring"]) === null || _this_ecsFilters_UserInfoRing === void 0 ? void 0 : _this_ecsFilters_UserInfoRing.value, v = this.getTeamsExperience();
                    g.CLRelease === f && (g.CLRelease = "9999.99"), S && (g.audienceGroup = S, g.teamsRing = S), v && (g.Experience = v);
                    const _ = Ze.getBrowserInfo();
                    return g.BrowserName = _.name, g.BrowserEngine = _.engine, g.BrowserVersion = _.version, g.FormFactor = _.formFactor, g.OsName = _.osName, g.OsVer = _.osVersion, ss.hardwareConcurrency && (g.CPUCount = ss.hardwareConcurrency), JSON.stringify(g);
                }
                async ecsGetUserQueryParameters(g) {
                    return this.getEcsQueryParameters();
                }
                async shouldTriggerCQF(g, f, S) {
                    throw new Error("Not implemented");
                }
                getEcsConfig(g, f) {
                    var _this_config;
                    const S = (_this_config = this.config) === null || _this_config === void 0 ? void 0 : _this_config[g];
                    return f ? S === null || S === void 0 ? void 0 : S[f] : S;
                }
                createEcsConfiguration() {
                    return new class {
                        getBoolean(g, f) {
                            return this.provider.getEcsConfig(g, f);
                        }
                        getNumber(g, f) {
                            return this.provider.getEcsConfig(g, f);
                        }
                        getString(g, f) {
                            const S = this.provider.getEcsConfig(g, f);
                            return JSON.stringify(S);
                        }
                        constructor(g){
                            this.provider = g;
                        }
                    }(this);
                }
                getTeamsExperience() {
                    var _this_ecsFilters_isTeams2, _this_ecsFilters, _this_ecsFilters_isTeams21, _this_ecsFilters1;
                    return !0 === ((_this_ecsFilters = this.ecsFilters) === null || _this_ecsFilters === void 0 ? void 0 : (_this_ecsFilters_isTeams2 = _this_ecsFilters.isTeams2) === null || _this_ecsFilters_isTeams2 === void 0 ? void 0 : _this_ecsFilters_isTeams2.value) ? "teams2" : !1 === ((_this_ecsFilters1 = this.ecsFilters) === null || _this_ecsFilters1 === void 0 ? void 0 : (_this_ecsFilters_isTeams21 = _this_ecsFilters1.isTeams2) === null || _this_ecsFilters_isTeams21 === void 0 ? void 0 : _this_ecsFilters_isTeams21.value) ? "teams1" : void 0;
                }
                constructor(g){
                    super(), this.ecsFilters = g, this.config = null;
                }
            }, iR = class {
                getId() {
                    return this._sharingSource.getId();
                }
                getDeviceId() {
                    return this._sharingSource.getDeviceId();
                }
                getType() {
                    return this.mapSharingSourceType(this._sharingSource.getType());
                }
                getPreview(g, f, S) {
                    return Promise.reject("not implemented");
                }
                getPreviewAsync(g, f) {
                    return this._sharingSource.getPreviewAsync(g, f);
                }
                getDescription() {
                    return this._sharingSource.getDescription();
                }
                getIcon(g, f) {
                    return this._sharingSource.getIcon(g, f);
                }
                getBounds() {}
                mapSharingSourceType(g) {
                    switch(g){
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 3:
                            return 3;
                        default:
                            throw new Error("Invalid sharing source type");
                    }
                }
                constructor(g){
                    this._sharingSource = g;
                }
            }, nR = class extends ze {
                enumerateScreensAsync() {
                    return this._screenSharingManager.enumerateScreensAsync().then((g)=>g.map((g)=>new iR(g)));
                }
                enumerateWindowsAsync() {
                    return this._screenSharingManager.enumerateWindowsAsync().then((g)=>g.map((g)=>new iR(g)));
                }
                enumerateCamerasAsync() {
                    return this._screenSharingManager.enumerateCamerasAsync().then((g)=>g.map((g)=>new iR(g)));
                }
                constructor(g){
                    super(), this._screenSharingManager = g, this._screenSharingManager.onScreensChanged(()=>{
                        this.event("screensChanged").raise();
                    });
                }
            }, rR = R, updateSignalingAgentConfig = (g, f)=>{
                if (!f) return g;
                const S = {
                    ...g
                };
                if (f.ngIncoming && f.ngOutgoing) {
                    const v = convertScreenSharingFlag(f.ngIncoming.isVBSSEnabled, f.ngOutgoing.isVBSSEnabled);
                    S.cloudScreenSharingFlag = getParam(v, g.cloudScreenSharingFlag);
                }
                return f.ngOutgoing && (S.emergencyCallCountry = convertEmergencyCallCountryFlag(f.ngOutgoing.isEmergencyCallingEnabled, g.emergencyCallCountry), S.isGVCOutgoingEnabled = getParam(f.ngOutgoing.isGVCEnabled, g.isGVCOutgoingEnabled), S.brokerEnabledOutgoing = getParam(f.ngOutgoing.isBrokerEnabled, g.brokerEnabledOutgoing)), f.ngIncoming && (S.isGVCJoiningEnabled = getParam(f.ngIncoming.isGVCEnabled, g.isGVCJoiningEnabled), S.brokerEnabledIncoming = getParam(f.ngIncoming.isBrokerEnabled, g.brokerEnabledIncoming)), S.conversationServiceUrl = getUrl(f.conversationServiceUrl, g.conversationServiceUrl), S.uploadLogRequestUrl = getUrl(f.uploadLogRequestUrl, g.uploadLogRequestUrl), S.isConversationServiceUrlFromEcs = !!f.conversationServiceUrl, S.isUploadLogRequestUrlFromEcs = !!f.uploadLogRequestUrl, S.callingTokenLogicalUrl = getUrl(f.callingTokenLogicalUrl, g.callingTokenLogicalUrl), S.doHostlessCalling = getParam(f.allowHostlessCalls, g.doHostlessCalling), S.supportsCompressedServicePayload = getParam(f.supportCompressedTrouterPayload, g.supportsCompressedServicePayload), S.brokerRequestBatching = getParam(f.allowBrokerSubscribeBatching, g.brokerRequestBatching), S.brokerExclusively = getParam(f.brokerExclusively, g.brokerExclusively), S.handleMediaOfferFromPushNotification = getParam(f.handleMediaOfferFromPushNotification, g.handleMediaOfferFromPushNotification), S.handleNewOfferRequest = getParam(f.handleNewOfferRequest, g.handleNewOfferRequest), S.sendProgressFromCC = getParam(f.sendProgressFromCC, g.sendProgressFromCC), S.useInternalHttpDispatcher = getParam(f.webInternalHttpDispatcher, g.useInternalHttpDispatcher), (f.webInternalHttpDispatcherConfigNetworkRequest || g.requestTypeHttpDispatcherConfigMap) && (f.webInternalHttpDispatcherConfigNetworkRequest = f.webInternalHttpDispatcherConfigNetworkRequest || {}, g.requestTypeHttpDispatcherConfigMap = g.requestTypeHttpDispatcherConfigMap || {}, S.requestTypeHttpDispatcherConfigMap = {
                    ...g.requestTypeHttpDispatcherConfigMap,
                    ...f.webInternalHttpDispatcherConfigNetworkRequest
                }), (f.operationTypeHttpDispatcherConfigMap || g.operationTypeHttpDispatcherConfigMap) && (f.operationTypeHttpDispatcherConfigMap = f.operationTypeHttpDispatcherConfigMap || {}, g.operationTypeHttpDispatcherConfigMap = g.operationTypeHttpDispatcherConfigMap || {}, S.operationTypeHttpDispatcherConfigMap = {
                    ...g.operationTypeHttpDispatcherConfigMap,
                    ...f.operationTypeHttpDispatcherConfigMap
                }), (f.csaTimeoutConfiguration || g.csaTimeoutConfiguration) && (f.csaTimeoutConfiguration = f.csaTimeoutConfiguration || {}, g.csaTimeoutConfiguration = g.csaTimeoutConfiguration || {}, S.csaTimeoutConfiguration = {
                    ...g.csaTimeoutConfiguration,
                    ...f.csaTimeoutConfiguration
                }), S.autoJoinOnConflict = getParam(f.autoJoinOnConflict, g.autoJoinOnConflict), S.enableQuickSendAcceptanceAck = getParam(f.enableQuickSendAcceptanceAck, g.enableQuickSendAcceptanceAck), S.supportMediaRetargetWhileIncomingRenegotiation = getParam(f.supportMediaRetargetWhileIncomingRenegotiation, g.supportMediaRetargetWhileIncomingRenegotiation), S.enableCallEstablishmentTimeoutsForStartJoinCall = getParam(f.enableCallEstablishmentTimeoutsForStartJoinCall, g.enableCallEstablishmentTimeoutsForStartJoinCall), S.callingServiceSupportsCAETokens = getParam(f.callingServiceSupportsCAETokens, g.callingServiceSupportsCAETokens), S.callingServiceSupportsAADTokens = getParam(f.callingServiceSupportsAADTokens, g.callingServiceSupportsAADTokens), S.aadTokenExpirationTimeInSeconds = getParam(f.aadTokenExpirationTimeInSeconds, g.aadTokenExpirationTimeInSeconds), S.caeTokenExpirationTimeInSeconds = getParam(f.caeTokenExpirationTimeInSeconds, g.caeTokenExpirationTimeInSeconds), S.disableTokenMigrationHeader = getParam(f.disableTokenMigrationHeader, g.disableTokenMigrationHeader), S.enablePublishTokenTelemetry = getParam(f.enablePublishTokenTelemetry, g.enablePublishTokenTelemetry), S.refreshTimeBeforeTokenTimeoutInSeconds = getParam(f.refreshTimeBeforeTokenTimeoutInSeconds, g.refreshTimeBeforeTokenTimeoutInSeconds), S.forceClearExpiredTokens = getParam(f.forceClearExpiredTokens, g.forceClearExpiredTokens), S.enableRefreshToken = getParam(f.enableRefreshToken, g.enableRefreshToken), S.enableAsyncDisablePreheat = getParam(f.enableAsyncDisablePreheat, g.enableAsyncDisablePreheat), S.forceLowercaseHttpHeaders = getParam(f.forceLowercaseHttpHeaders, g.forceLowercaseHttpHeaders), S.enableResolveScreenSharingWhenNegotiationComplete = getParam(f.enableResolveScreenSharingWhenNegotiationComplete, g.enableResolveScreenSharingWhenNegotiationComplete), S.maxReinvitelessMediaForVideoForWeb = getParam(f.maxReinvitelessMediaForVideoForWeb, g.maxReinvitelessMediaForVideoForWeb), S.maxReinvitelessMediaForVBSSForWeb = getParam(f.maxReinvitelessMediaForVBSSForWeb, g.maxReinvitelessMediaForVBSSForWeb), S.enableRefreshTokenRetry = getParam(f.enableRefreshTokenRetry, g.enableRefreshTokenRetry), S.enableRefreshTokenRetryInSeconds = getParam(f.enableRefreshTokenRetryInSeconds, g.enableRefreshTokenRetryInSeconds), S.enableConversationTypeUpdateOnCallEnd = getParam(f.enableConversationTypeUpdateOnCallEnd, g.enableConversationTypeUpdateOnCallEnd), S.supportMissingTokenTypesInResponse = getParam(f.supportMissingTokenTypesInResponse, g.supportMissingTokenTypesInResponse), S.useSkypeTokenWhenNoAuthenticateHeader = getParam(f.useSkypeTokenWhenNoAuthenticateHeader, g.useSkypeTokenWhenNoAuthenticateHeader), S.enableAutoPromotion = getParam(f.enableAutoPromotion, g.enableAutoPromotion), S.enableTokenCache = getParam(f.enableTokenCache, g.enableTokenCache), S.enableBatchedSendMessageStatus = getParam(f.enableBatchedSendMessageStatus, g.enableBatchedSendMessageStatus), S.enableBatchedReceiveMessage = getParam(f.enableBatchedReceiveMessage, g.enableBatchedReceiveMessage), S.enableTokenCacheForGenericTokenAPI = getParam(f.enableTokenCacheForGenericTokenAPI, g.enableTokenCacheForGenericTokenAPI), S.disableRealTimeModeFromRoster = getParam(f.disableRealTimeModeFromRoster, g.disableRealTimeModeFromRoster), S.enableLongOutgoing1To1SetupTimeoutForWeb = getParam(f.enableLongOutgoing1To1SetupTimeoutForWeb, g.enableLongOutgoing1To1SetupTimeoutForWeb), S.checkAttendeeRoleInCreateContentSharing = getParam(f.checkAttendeeRoleInCreateContentSharing, g.checkAttendeeRoleInCreateContentSharing), S.enableSpecificErrorCodesForCallEnd = getParam(f.enableSpecificErrorCodesForCallEnd, g.enableSpecificErrorCodesForCallEnd), S.enableSplitConversationEndUrl = getParam(f.enableSplitConversationEndUrl, g.enableSplitConversationEndUrl), S;
            };
            function getParam(g, f) {
                return null == g ? f : g;
            }
            function getUrl(g, f) {
                return g || f;
            }
            function convertScreenSharingFlag(g, f) {
                return f && g ? "enabled" : g ? "recvOnly" : !1 === g && !1 === f ? "disabled" : void 0;
            }
            function convertEmergencyCallCountryFlag(g, f) {
                return !1 === g ? "" : f;
            }
            var aR, sR = "SkypeCalling", oR = class {
                getSignalingAgent() {
                    return this.signalingAgent;
                }
                onEcsUpdate() {
                    const g = this.ecsProvider.getEcsConfig(sR);
                    this.logger.info(`onEcsUpdate, ecsTag=${this.ecsProvider.ETag || ""}, ecsConfig=${JSON.stringify(g)}`), this.signalingAgentConfig = updateSignalingAgentConfig(this.signalingAgentConfig, g), this.signalingAgentConfig.ecsEtag = this.ecsProvider.ETag, this.signalingAgent.updateSignalingAgentConfig(this.getSignalingAgentConfig());
                }
                getSignalingAgentConfig() {
                    return this.signalingAgentConfig.oneDsTelemetryLogger = this.telemetryLogger, this.signalingAgentConfig;
                }
                constructor(g, f, S, v){
                    this.signalingAgentConfig = g, this.ecsProvider = f, this.logger = S, this.telemetryLogger = v, this.ecsProvider.on("OnECSChanged", ()=>this.onEcsUpdate()), this.signalingAgentConfig.clientInformation += `/TsCallingVersion=${getTsCallingVersion()}/Ovb=${getOvb()}`, this.signalingAgentConfig.piiScrubber = {
                        omit: rR.pii.Omit,
                        mri: rR.pii.Mri
                    }, this.signalingAgent = new tr(this.getSignalingAgentConfig());
                }
            }, lR = {
                build: (g, f, S, v)=>new oR(g, f, S, v)
            }, cR = __toESM(P), dR = "toLowerCase", uR = "blkVal", hR = "length", gR = "rdOnly", pR = "notify", mR = "warnToConsole", fR = "throwInternal", SR = "setDf", vR = "watch", _R = "logger", CR = "apply", yR = "push", ER = "splice", TR = "hdlr", IR = "cancel", bR = "initialize", AR = "identifier", RR = "isInitialized", PR = "getPlugin", wR = "name", MR = "time", OR = "processNext", DR = "getProcessTelContext", NR = "unload", kR = "loggingLevelConsole", LR = "createNew", FR = "teardown", xR = "messageId", UR = "message", VR = "isAsync", BR = "diagLog", HR = "_doTeardown", $R = "update", jR = "getNext", GR = "setNextPlugin", qR = "userAgent", WR = "nodeType", zR = "replace", KR = "logInternalMessage", JR = "isChildEvt", YR = "getCtx", QR = "setCtx", XR = "complete";
            function throwAggregationError2(g, f) {
                aR || (aR = createCustomError("AggregationError", function(g, f) {
                    f[hR] > 1 && (g.errors = f[1]);
                }));
                var S = g || "One or more errors occurred.";
                throw arrForEach(f, function(g, f) {
                    S += "\n".concat(f, " > ").concat(dumpObj(g));
                }), new aR(S, f || []);
            }
            var ZR = void 0, eP = "", tP = "core", iP = "disabled", nP = "extensionConfig", rP = "processTelemetry", aP = "priority", sP = "getPerfMgr", oP = "Not dynamic - ", lP = /-([a-z])/g, cP = /([^\w\d_$])/g, dP = /^(\d+[\w\d_$])/;
            function isNotNullOrUndefined2(g) {
                return !isNullOrUndefined(g);
            }
            function normalizeJsName2(g) {
                var f = g;
                return f && ll(f) && (f = (f = (f = f[zR](lP, function(g, f) {
                    return f.toUpperCase();
                }))[zR](cP, "_"))[zR](dP, function(g, f) {
                    return "_" + f;
                })), f;
            }
            function strContains2(g, f) {
                return !(!g || !f) && -1 !== ac(g, f);
            }
            function toISOString2(g) {
                return g && g.toISOString() || "";
            }
            function _createProxyFunction2(g, f) {
                var S = null, v = null;
                return cl(g) ? S = g : v = g, function() {
                    var g = arguments;
                    if (S && (v = S()), v) return v[f][CR](v, g);
                };
            }
            function proxyFunctionAs2(g, f, S, v, _) {
                g && f && S && (!1 !== _ || isUndefined4(g[f])) && (g[f] = _createProxyFunction2(S, v));
            }
            var uP = "console", hP = "JSON", gP = "crypto", pP = "msCrypto", mP = "msie", fP = "trident/", SP = null, vP = null;
            function getConsole2() {
                return typeof console !== ko ? console : getInst(uP);
            }
            function hasJSON2() {
                return Boolean(typeof JSON === No && JSON || null !== getInst(hP));
            }
            function getJSON2() {
                return hasJSON2() ? JSON || getInst(hP) : null;
            }
            function getCrypto2() {
                return getInst(gP);
            }
            function getMsCrypto2() {
                return getInst(pP);
            }
            function isIE2() {
                var g = Wl();
                if (g && (g[qR] !== vP || null === SP)) {
                    var f = ((vP = g[qR]) || eP)[dR]();
                    SP = strContains2(f, mP) || strContains2(f, fP);
                }
                return SP;
            }
            var _P = 4294967296, CP = 4294967295, yP = 123456789, EP = 987654321, TP = !1, IP = yP, bP = EP;
            function _mwcSeed2(g) {
                g < 0 && (g >>>= 0), IP = yP + g & CP, bP = EP - g & CP, TP = !0;
            }
            function _autoSeedMwc2() {
                try {
                    var g = 2147483647 & utcNow();
                    _mwcSeed2((Math.random() * _P ^ g) + g);
                } catch (g) {}
            }
            function random322(g) {
                var f = 0, S = getCrypto2() || getMsCrypto2();
                return S && S.getRandomValues && (f = S.getRandomValues(new Uint32Array(1))[0] & CP), 0 === f && isIE2() && (TP || _autoSeedMwc2(), f = mwcRandom322() & CP), 0 === f && (f = Math.floor(_P * Math.random() | 0)), g || (f >>>= 0), f;
            }
            function mwcRandom322(g) {
                var f = ((bP = 36969 * (65535 & bP) + (bP >> 16) & CP) << 16) + (65535 & (IP = 18e3 * (65535 & IP) + (IP >> 16) & CP)) >>> 0 & CP | 0;
                return g || (f >>>= 0), f;
            }
            function newId2(g) {
                void 0 === g && (g = 22);
                for(var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S = random322() >>> 0, v = 0, _ = eP; _[hR] < g;)v++, _ += f.charAt(63 & S), S >>>= 6, 5 === v && (S = (random322() << 2 & 4294967295 | 3 & S) >>> 0, v = 0);
                return _;
            }
            var AP = "3.3.1", RP = "." + newId2(6), PP = 0;
            function _canAcceptData2(g) {
                return 1 === g[WR] || 9 === g[WR] || !+g[WR];
            }
            function _getCache2(g, f) {
                var S = f[g.id];
                if (!S) {
                    S = {};
                    try {
                        _canAcceptData2(f) && objDefine(f, g.id, {
                            e: !1,
                            v: S
                        });
                    } catch (g) {}
                }
                return S;
            }
            function createUniqueNamespace2(g, f) {
                return void 0 === f && (f = !1), normalizeJsName2(g + PP++ + (f ? "." + AP : eP) + RP);
            }
            function createElmNodeData2(g) {
                var f = {
                    id: createUniqueNamespace2("_aiData-" + (g || eP) + "." + AP),
                    accept: function(g) {
                        return _canAcceptData2(g);
                    },
                    get: function(g, S, v, _) {
                        var C = g[f.id];
                        return C ? C[normalizeJsName2(S)] : (_ && ((C = _getCache2(f, g))[normalizeJsName2(S)] = v), v);
                    },
                    kill: function(g, f) {
                        if (g && g[f]) try {
                            delete g[f];
                        } catch (g) {}
                    }
                };
                return f;
            }
            function _isConfigDefaults2(g) {
                return g && isObject3(g) && (g.isVal || g.fb || fl(g, "v") || fl(g, "mrg") || fl(g, "ref") || g.set);
            }
            function _getDefault2(g, f, S) {
                var v, _ = S.dfVal || isDefined2;
                if (f && S.fb) {
                    var C = S.fb;
                    dl(C) || (C = [
                        C
                    ]);
                    for(var E = 0; E < C[hR]; E++){
                        var T = C[E], I = f[T];
                        if (_(I) ? v = I : g && (_(I = g.cfg[T]) && (v = I), g.set(g.cfg, Cl(T), I)), _(v)) break;
                    }
                }
                return !_(v) && _(S.v) && (v = S.v), v;
            }
            function _resolveDefaultValue2(g, f, S) {
                var v, _ = S;
                (S && _isConfigDefaults2(S) && (_ = _getDefault2(g, f, S)), _) && (_isConfigDefaults2(_) && (_ = _resolveDefaultValue2(g, f, _)), dl(_) ? (v = [])[hR] = _[hR] : isPlainObject(_) && (v = {}), v && (objForEachKey(_, function(S, _) {
                    _ && _isConfigDefaults2(_) && (_ = _resolveDefaultValue2(g, f, _)), v[S] = _;
                }), _ = v));
                return _;
            }
            function _applyDefaultValue2(g, f, S, v) {
                var _, C, E, T, I, b, A, R, P = v;
                _isConfigDefaults2(P) ? (_ = P.isVal, C = P.set, b = P[gR], A = P[uR], T = P.mrg, !(I = P.ref) && isUndefined4(I) && (I = !!T), E = _getDefault2(g, f, P)) : E = v, A && g[uR](f, S);
                var w = !0, M = f[S];
                !M && isNullOrUndefined(M) || (R = M, w = !1, _ && R !== E && !_(R) && (R = E, w = !0), C && (w = (R = C(R, E, f)) === E)), w ? R = E ? _resolveDefaultValue2(g, f, E) : E : (isPlainObject(R) || dl(E)) && T && E && (isPlainObject(E) || dl(E)) && objForEachKey(E, function(f, S) {
                    _applyDefaultValue2(g, R, f, S);
                }), g.set(f, S, R), I && g.ref(f, S), b && g[gR](f, S);
            }
            var wP = symbolFor("[[ai_dynCfg_1]]"), MP = symbolFor("[[ai_blkDynCfg_1]]"), OP = symbolFor("[[ai_frcDynCfg_1]]");
            function _cfgDeepCopy2(g) {
                var f;
                if (g && (dl(g) ? (f = [])[hR] = g[hR] : isPlainObject(g) && (f = {}), f)) return objForEachKey(g, function(g, S) {
                    f[g] = _cfgDeepCopy2(S);
                }), f;
                return g;
            }
            function getDynamicConfigHandler2(g) {
                if (g) {
                    var f = g[wP] || g;
                    if (f.cfg && (f.cfg === g || f.cfg[wP] === f)) return f;
                }
                return null;
            }
            function blockDynamicConversion2(g) {
                if (g && (isPlainObject(g) || dl(g))) try {
                    g[MP] = !0;
                } catch (g) {}
                return g;
            }
            function _canMakeDynamic2(g, f, S) {
                var v = !1;
                return S && !g[f.blkVal] && ((v = S[OP]) || S[MP] || (v = isPlainObject(S) || dl(S))), v;
            }
            function throwInvalidAccess2(g) {
                throwTypeError("InvalidAccess:" + g);
            }
            var DP = [
                "push",
                "pop",
                "shift",
                "unshift",
                "splice"
            ], _throwDynamicError2 = function(g, f, S, v) {
                g && g[fR](3, 108, "".concat(S, " [").concat(f, "] failed - ") + dumpObj(v));
            };
            function _patchArray2(g, f, S) {
                dl(f) && arrForEach(DP, function(v) {
                    var _ = f[v];
                    f[v] = function() {
                        for(var v = [], C = 0; C < arguments.length; C++)v[C] = arguments[C];
                        var E = _[CR](this, v);
                        return _makeDynamicObject2(g, f, S, "Patching"), E;
                    };
                });
            }
            function _getOwnPropGetter2(g, f) {
                var S = ml(g, f);
                return S && S.get;
            }
            function _createDynamicProperty2(g, f, S, v) {
                var _ = {
                    n: S,
                    h: [],
                    trk: function(f) {
                        f && f.fn && (-1 === Kl(_.h, f) && _.h[yR](f), g.trk(f, _));
                    },
                    clr: function(g) {
                        var f = Kl(_.h, g);
                        -1 !== f && _.h[ER](f, 1);
                    }
                }, C = !0, E = !1;
                function _getProperty() {
                    C && (E = E || _canMakeDynamic2(_getProperty, g, v), v && !v[wP] && E && (v = _makeDynamicObject2(g, v, S, "Converting")), C = !1);
                    var f = g.act;
                    return f && _.trk(f), v;
                }
                function _setProperty(T) {
                    if (v !== T) {
                        _getProperty[g.ro] && !g.upd && throwInvalidAccess2("[" + S + "] is read-only:" + dumpObj(f)), C && (E = E || _canMakeDynamic2(_getProperty, g, v), C = !1);
                        var I = E && _getProperty[g.rf];
                        if (E) {
                            if (I) {
                                objForEachKey(v, function(g) {
                                    v[g] = T ? T[g] : ZR;
                                });
                                try {
                                    objForEachKey(T, function(f, S) {
                                        _setDynamicProperty2(g, v, f, S);
                                    }), T = v;
                                } catch (f) {
                                    _throwDynamicError2((g.hdlr || {})[_R], S, "Assigning", f), E = !1;
                                }
                            } else v && v[wP] && objForEachKey(v, function(f) {
                                var S = _getOwnPropGetter2(v, f);
                                if (S) {
                                    var _ = S[g.prop];
                                    _ && _.chng();
                                }
                            });
                        }
                        if (T !== v) {
                            var b = T && _canMakeDynamic2(_getProperty, g, T);
                            !I && b && (T = _makeDynamicObject2(g, T, S, "Converting")), v = T, E = b;
                        }
                        g.add(_);
                    }
                }
                _getProperty[g.prop] = {
                    chng: function() {
                        g.add(_);
                    }
                }, objDefine(f, _.n, {
                    g: _getProperty,
                    s: _setProperty
                });
            }
            function _setDynamicProperty2(g, f, S, v) {
                if (f) {
                    var _ = _getOwnPropGetter2(f, S);
                    _ && !!_[g.prop] ? f[S] = v : _createDynamicProperty2(g, f, S, v);
                }
                return f;
            }
            function _setDynamicPropertyState2(g, f, S, v) {
                if (f) {
                    var _ = _getOwnPropGetter2(f, S), C = _ && !!_[g.prop], E = v && v[0], T = v && v[1], I = v && v[2];
                    if (!C) {
                        if (I) try {
                            blockDynamicConversion2(f);
                        } catch (f) {
                            _throwDynamicError2((g.hdlr || {})[_R], S, "Blocking", f);
                        }
                        try {
                            _setDynamicProperty2(g, f, S, f[S]), _ = _getOwnPropGetter2(f, S);
                        } catch (f) {
                            _throwDynamicError2((g.hdlr || {})[_R], S, "State", f);
                        }
                    }
                    E && (_[g.rf] = E), T && (_[g.ro] = T), I && (_[g.blkVal] = !0);
                }
                return f;
            }
            function _makeDynamicObject2(g, f, S, v) {
                try {
                    objForEachKey(f, function(S, v) {
                        _setDynamicProperty2(g, f, S, v);
                    }), f[wP] || (vl(f, wP, {
                        get: function() {
                            return g[TR];
                        }
                    }), _patchArray2(g, f, S));
                } catch (f) {
                    _throwDynamicError2((g.hdlr || {})[_R], S, v, f);
                }
                return f;
            }
            var NP = "[[ai_", kP = "]]";
            function _createState2(g) {
                var f, S, v = newSymbol(NP + "get" + g.uid + kP), _ = newSymbol(NP + "ro" + g.uid + kP), C = newSymbol(NP + "rf" + g.uid + kP), E = newSymbol(NP + "blkVal" + g.uid + kP), T = newSymbol(NP + "dtl" + g.uid + kP), I = null, b = null;
                function _useHandler(f, v) {
                    var _ = S.act;
                    try {
                        S.act = f, f && f[T] && (arrForEach(f[T], function(g) {
                            g.clr(f);
                        }), f[T] = []), v({
                            cfg: g.cfg,
                            set: g.set.bind(g),
                            setDf: g[SR].bind(g),
                            ref: g.ref.bind(g),
                            rdOnly: g[gR].bind(g)
                        });
                    } catch (f) {
                        var C = g[_R];
                        throw C && C[fR](1, 107, dumpObj(f)), f;
                    } finally{
                        S.act = _ || null;
                    }
                }
                function _notifyWatchers() {
                    if (I) {
                        var g = I;
                        I = null, b && b[IR](), b = null;
                        var f = [];
                        if (arrForEach(g, function(g) {
                            if (g && (g[T] && (arrForEach(g[T], function(f) {
                                f.clr(g);
                            }), g[T] = null), g.fn)) try {
                                _useHandler(g, g.fn);
                            } catch (g) {
                                f[yR](g);
                            }
                        }), I) try {
                            _notifyWatchers();
                        } catch (g) {
                            f[yR](g);
                        }
                        f[hR] > 0 && throwAggregationError2("Watcher error(s): ", f);
                    }
                }
                function _addWatcher(g) {
                    if (g && g.h[hR] > 0) {
                        I || (I = []), b || (b = scheduleTimeout(function() {
                            b = null, _notifyWatchers();
                        }, 0));
                        for(var f = 0; f < g.h[hR]; f++){
                            var S = g.h[f];
                            S && -1 === Kl(I, S) && I[yR](S);
                        }
                    }
                }
                function _trackHandler(g, f) {
                    if (g) {
                        var S = g[T] = g[T] || [];
                        -1 === Kl(S, f) && S[yR](f);
                    }
                }
                return (f = {
                    prop: v,
                    ro: _,
                    rf: C
                })[uR] = E, f[TR] = g, f.add = _addWatcher, f[pR] = _notifyWatchers, f.use = _useHandler, f.trk = _trackHandler, S = f;
            }
            function _createAndUseHandler2(g, f) {
                var S = {
                    fn: f,
                    rm: function() {
                        S.fn = null, g = null, f = null;
                    }
                };
                return objDefine(S, "toJSON", {
                    v: function() {
                        return "WatcherHandler" + (S.fn ? "" : "[X]");
                    }
                }), g.use(S, f), S;
            }
            function _createDynamicHandler2(g, f, S) {
                var v, _ = getDynamicConfigHandler2(f);
                if (_) return _;
                var C, E = createUniqueNamespace2("dyncfg", !0), T = f && !1 !== S ? f : _cfgDeepCopy2(f);
                function _notifyWatchers() {
                    C[pR]();
                }
                function _setValue(f, S, v) {
                    try {
                        f = _setDynamicProperty2(C, f, S, v);
                    } catch (f) {
                        _throwDynamicError2(g, S, "Setting value", f);
                    }
                    return f[S];
                }
                function _watch(g) {
                    return _createAndUseHandler2(C, g);
                }
                function _block(g, f) {
                    C.use(null, function(S) {
                        var v = C.upd;
                        try {
                            isUndefined4(f) || (C.upd = f), g(S);
                        } finally{
                            C.upd = v;
                        }
                    });
                }
                function _ref(g, f) {
                    var S;
                    return _setDynamicPropertyState2(C, g, f, (S = {}, S[0] = !0, S))[f];
                }
                function _rdOnly(g, f) {
                    var S;
                    return _setDynamicPropertyState2(C, g, f, (S = {}, S[1] = !0, S))[f];
                }
                function _blkPropValue(g, f) {
                    var S;
                    return _setDynamicPropertyState2(C, g, f, (S = {}, S[2] = !0, S))[f];
                }
                function _applyDefaults(g, f) {
                    return f && objForEachKey(f, function(f, S) {
                        _applyDefaultValue2(I, g, f, S);
                    }), g;
                }
                var I = ((v = {
                    uid: null,
                    cfg: T
                })[_R] = g, v[pR] = _notifyWatchers, v.set = _setValue, v[SR] = _applyDefaults, v[vR] = _watch, v.ref = _ref, v[gR] = _rdOnly, v[uR] = _blkPropValue, v._block = _block, v);
                return objDefine(I, "uid", {
                    c: !1,
                    e: !1,
                    w: !1,
                    v: E
                }), _makeDynamicObject2(C = _createState2(I), T, "config", "Creating"), I;
            }
            function _logInvalidAccess2(g, f) {
                g ? (g[mR](f), g[fR](2, 108, f)) : throwInvalidAccess2(f);
            }
            function createDynamicConfig2(g, f, S, v) {
                var _ = _createDynamicHandler2(S, g || {}, v);
                return f && _[SR](_.cfg, f), _;
            }
            function onConfigChange2(g, f, S) {
                var v = g[wP] || g;
                return !v.cfg || v.cfg !== g && v.cfg[wP] !== v ? (_logInvalidAccess2(S, oP + dumpObj(g)), createDynamicConfig2(g, null, S)[vR](f)) : v[vR](f);
            }
            var LP, FP = null;
            function _getExtensionNamespace2() {
                var g = getInst("Microsoft");
                return g && (FP = g.ApplicationInsights), FP;
            }
            function getDebugExt2(g) {
                var f = FP;
                return f || !0 === g.disableDbgExt || (f = FP || _getExtensionNamespace2()), f ? f.ChromeDbgExt : null;
            }
            var xP = "warnToConsole", UP = "AI (Internal): ", VP = "AI: ", BP = "AITR_", HP = {
                loggingLevelConsole: 0,
                loggingLevelTelemetry: 1,
                maxMessageLimit: 25,
                enableDebug: !1
            }, $P = ((LP = {})[0] = null, LP[1] = "errorToConsole", LP[2] = xP, LP[3] = "debugToConsole", LP);
            function _sanitizeDiagnosticText2(g) {
                return g ? '"' + g[zR](/\"/g, eP) + '"' : eP;
            }
            function _logToConsole2(g, f) {
                var S = getConsole2();
                if (S) {
                    var v = "log";
                    S[g] && (v = g), cl(S[v]) && S[v](f);
                }
            }
            var jP = function() {
                function _InternalLogMessage3(g, f, S, v) {
                    void 0 === S && (S = !1);
                    var _ = this;
                    _[xR] = g, _[UR] = (S ? VP : UP) + g;
                    var C = eP;
                    hasJSON2() && (C = getJSON2().stringify(v));
                    var E = (f ? " message:" + _sanitizeDiagnosticText2(f) : eP) + (v ? " props:" + _sanitizeDiagnosticText2(C) : eP);
                    _[UR] += E;
                }
                return _InternalLogMessage3.dataType = "MessageData", _InternalLogMessage3;
            }();
            function safeGetLogger2(g, f) {
                return (g || {})[_R] || new GP(f);
            }
            var GP = function() {
                function DiagnosticLogger3(g) {
                    this.identifier = "DiagnosticLogger", this.queue = [];
                    var f, S, v, _, C, E = 0, T = {};
                    dynamicProto(DiagnosticLogger3, this, function(I) {
                        function _logInternalMessage3(g, f) {
                            if (!_areInternalMessagesThrottled()) {
                                var _ = !0, C = BP + f[xR];
                                if (T[C] ? _ = !1 : T[C] = !0, _ && (g <= S && (I.queue[yR](f), E++, _debugExtMsg(1 === g ? "error" : "warn", f)), E === v)) {
                                    var b = "Internal events throttle limit per PageView reached for this app.", A = new jP(23, b, !1);
                                    I.queue[yR](A), 1 === g ? I.errorToConsole(b) : I[mR](b);
                                }
                            }
                        }
                        function _setDefaultsFromConfig(g) {
                            return onConfigChange2(createDynamicConfig2(g, HP, I).cfg, function(g) {
                                var C = g.cfg;
                                f = C[kR], S = C.loggingLevelTelemetry, v = C.maxMessageLimit, _ = C.enableDebug;
                            });
                        }
                        function _areInternalMessagesThrottled() {
                            return E >= v;
                        }
                        function _debugExtMsg(f, S) {
                            var v = getDebugExt2(g || {});
                            v && v[BR] && v[BR](f, S);
                        }
                        C = _setDefaultsFromConfig(g || {}), I.consoleLoggingLevel = function() {
                            return f;
                        }, I[fR] = function(g, S, v, C, E) {
                            void 0 === E && (E = !1);
                            var b = new jP(S, v, E, C);
                            if (_) throw dumpObj(b);
                            var A = $P[g] || xP;
                            if (isUndefined4(b[UR])) _debugExtMsg("throw" + (1 === g ? "Critical" : "Warning"), b);
                            else {
                                if (E) {
                                    var R = +b[xR];
                                    !T[R] && f >= g && (I[A](b[UR]), T[R] = !0);
                                } else f >= g && I[A](b[UR]);
                                _logInternalMessage3(g, b);
                            }
                        }, I.debugToConsole = function(g) {
                            _logToConsole2("debug", g), _debugExtMsg("warning", g);
                        }, I[mR] = function(g) {
                            _logToConsole2("warn", g), _debugExtMsg("warning", g);
                        }, I.errorToConsole = function(g) {
                            _logToConsole2("error", g), _debugExtMsg("error", g);
                        }, I.resetInternalMessageCount = function() {
                            E = 0, T = {};
                        }, I[KR] = _logInternalMessage3, I[NR] = function(g) {
                            C && C.rm(), C = null;
                        };
                    });
                }
                return DiagnosticLogger3.__ieDyn = 1, DiagnosticLogger3;
            }();
            function _getLogger2(g) {
                return g || new GP;
            }
            function _throwInternal2(g, f, S, v, _, C) {
                void 0 === C && (C = !1), _getLogger2(g)[fR](f, S, v, _, C);
            }
            var qP = "ctx", WP = "ParentContextKey", zP = "ChildrenContextKey", KP = function() {
                function PerfEvent3(g, f, S) {
                    var v, _ = this;
                    (_.start = utcNow(), _[wR] = g, _[VR] = S, _[JR] = function() {
                        return !1;
                    }, cl(f)) && objDefine(_, "payload", {
                        g: function() {
                            return !v && cl(f) && (v = f(), f = null), v;
                        }
                    });
                    _[YR] = function(g) {
                        return g ? g === PerfEvent3[WP] || g === PerfEvent3[zP] ? _[g] : (_[qP] || {})[g] : null;
                    }, _[QR] = function(g, f) {
                        if (g) {
                            if (g === PerfEvent3[WP]) _[g] || (_[JR] = function() {
                                return !0;
                            }), _[g] = f;
                            else if (g === PerfEvent3[zP]) _[g] = f;
                            else (_[qP] = _[qP] || {})[g] = f;
                        }
                    }, _[XR] = function() {
                        var g = 0, f = _[YR](PerfEvent3[zP]);
                        if (dl(f)) for(var S = 0; S < f[hR]; S++){
                            var v = f[S];
                            v && (g += v[MR]);
                        }
                        _[MR] = utcNow() - _.start, _.exTime = _[MR] - g, _[XR] = function() {};
                    };
                }
                return PerfEvent3.ParentContextKey = "parent", PerfEvent3.ChildrenContextKey = "childEvts", PerfEvent3;
            }(), JP = "CoreUtils.doPerf";
            function doPerf2(g, f, S, v, _) {
                if (g) {
                    var C = g;
                    if (C[sP] && (C = C[sP]()), C) {
                        var E = void 0, T = C[YR](JP);
                        try {
                            if (E = C.create(f(), v, _)) {
                                if (T && E[QR] && (E[QR](KP[WP], T), T[YR] && T[QR])) {
                                    var I = T[YR](KP[zP]);
                                    I || (I = [], T[QR](KP[zP], I)), I[yR](E);
                                }
                                return C[QR](JP, E), S(E);
                            }
                        } catch (g) {
                            E && E[QR] && E[QR]("exception", g);
                        } finally{
                            E && C.fire(E), C[QR](JP, T);
                        }
                    }
                }
                return S();
            }
            function newGuid3() {
                var g = generateW3CId2();
                return Nl(g, 0, 8) + "-" + Nl(g, 8, 12) + "-" + Nl(g, 12, 16) + "-" + Nl(g, 16, 20) + "-" + Nl(g, 20);
            }
            function generateW3CId2() {
                for(var g, f = [
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f"
                ], S = eP, v = 0; v < 4; v++)S += f[15 & (g = random322())] + f[g >> 4 & 15] + f[g >> 8 & 15] + f[g >> 12 & 15] + f[g >> 16 & 15] + f[g >> 20 & 15] + f[g >> 24 & 15] + f[g >> 28 & 15];
                var _ = f[8 + (3 & random322()) | 0];
                return kl(S, 0, 8) + kl(S, 9, 4) + "4" + kl(S, 13, 3) + _ + kl(S, 16, 3) + kl(S, 19, 12);
            }
            var YP = createElmNodeData2("plugin");
            function _getPluginState2(g) {
                return YP.get(g, "state", {}, !0);
            }
            var QP, XP = "TelemetryPluginChain", ZP = "_hasRun", ew = "_getTelCtx", tw = 0;
            function _getNextProxyStart2(g, f, S) {
                for(; g;){
                    if (g[PR]() === S) return g;
                    g = g[jR]();
                }
                return createTelemetryProxyChain2([
                    S
                ], f.config || {}, f);
            }
            function _createInternalContext2(g, f, S, v) {
                var _ = null, C = [];
                f || (f = createDynamicConfig2({}, null, S[_R])), null !== v && (_ = v ? _getNextProxyStart2(g, S, v) : g);
                var E = {
                    _next: _moveNext,
                    ctx: {
                        core: function() {
                            return S;
                        },
                        diagLog: function() {
                            return safeGetLogger2(S, f.cfg);
                        },
                        getCfg: function() {
                            return f.cfg;
                        },
                        getExtCfg: _resolveExtCfg,
                        getConfig: _getConfig,
                        hasNext: function() {
                            return !!_;
                        },
                        getNext: function() {
                            return _;
                        },
                        setNext: function(g) {
                            _ = g;
                        },
                        iterate: _iterateChain,
                        onComplete: _addOnComplete
                    }
                };
                function _addOnComplete(g, f) {
                    for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                    g && C[yR]({
                        func: g,
                        self: isUndefined4(f) ? E.ctx : f,
                        args: S
                    });
                }
                function _moveNext() {
                    var g = _;
                    if (_ = g ? g[jR]() : null, !g) {
                        var f = C;
                        f && f[hR] > 0 && (arrForEach(f, function(g) {
                            try {
                                g.func.call(g.self, g.args);
                            } catch (g) {
                                _throwInternal2(S[_R], 2, 73, "Unexpected Exception during onComplete - " + dumpObj(g));
                            }
                        }), C = []);
                    }
                    return g;
                }
                function _getExtCfg(g, S) {
                    var v = null, _ = f.cfg;
                    if (_ && g) {
                        var C = _[nP];
                        !C && S && (C = {}), _[nP] = C, (C = f.ref(_, nP)) && (!(v = C[g]) && S && (v = {}), C[g] = v, v = f.ref(C, g));
                    }
                    return v;
                }
                function _resolveExtCfg(g, S) {
                    var v = _getExtCfg(g, !0);
                    return S && objForEachKey(S, function(g, S) {
                        if (isNullOrUndefined(v[g])) {
                            var _ = f.cfg[g];
                            !_ && isNullOrUndefined(_) || (v[g] = _);
                        }
                        _applyDefaultValue2(f, v, g, S);
                    }), f[SR](v, S);
                }
                function _getConfig(g, S, v) {
                    var _;
                    void 0 === v && (v = !1);
                    var C = _getExtCfg(g, !1), E = f.cfg;
                    return !C || !C[S] && isNullOrUndefined(C[S]) ? !E[S] && isNullOrUndefined(E[S]) || (_ = E[S]) : _ = C[S], _ || !isNullOrUndefined(_) ? _ : v;
                }
                function _iterateChain(g) {
                    for(var f; f = E._next();){
                        var S = f[PR]();
                        S && g(S);
                    }
                }
                return E;
            }
            function createProcessTelemetryContext2(g, f, S, v) {
                var _ = createDynamicConfig2(f), C = _createInternalContext2(g, _, S, v), E = C.ctx;
                function _processNext(g) {
                    var f = C._next();
                    return f && f[rP](g, E), !f;
                }
                function _createNew(g, f) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain2(g, _.cfg, S, f)), createProcessTelemetryContext2(g || E[jR](), _.cfg, S, f);
                }
                return E[OR] = _processNext, E[LR] = _createNew, E;
            }
            function createProcessTelemetryUnloadContext2(g, f, S) {
                var v = createDynamicConfig2(f.config), _ = _createInternalContext2(g, v, f, S), C = _.ctx;
                function _processNext(g) {
                    var f = _._next();
                    return f && f[NR](C, g), !f;
                }
                function _createNew(g, S) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain2(g, v.cfg, f, S)), createProcessTelemetryUnloadContext2(g || C[jR](), f, S);
                }
                return C[OR] = _processNext, C[LR] = _createNew, C;
            }
            function createProcessTelemetryUpdateContext2(g, f, S) {
                var v = createDynamicConfig2(f.config), _ = _createInternalContext2(g, v, f, S).ctx;
                function _processNext(g) {
                    return _.iterate(function(f) {
                        cl(f[$R]) && f[$R](_, g);
                    });
                }
                function _createNew(g, S) {
                    return void 0 === g && (g = null), dl(g) && (g = createTelemetryProxyChain2(g, v.cfg, f, S)), createProcessTelemetryUpdateContext2(g || _[jR](), f, S);
                }
                return _[OR] = _processNext, _[LR] = _createNew, _;
            }
            function createTelemetryProxyChain2(g, f, S, v) {
                var _ = null, C = !v;
                if (dl(g) && g[hR] > 0) {
                    var E = null;
                    arrForEach(g, function(g) {
                        if (C || v !== g || (C = !0), C && g && cl(g[rP])) {
                            var T = createTelemetryPluginProxy2(g, f, S);
                            _ || (_ = T), E && E._setNext(T), E = T;
                        }
                    });
                }
                return v && !_ ? createTelemetryProxyChain2([
                    v
                ], f, S) : _;
            }
            function createTelemetryPluginProxy2(g, f, S) {
                var v, _ = null, C = cl(g[rP]), E = cl(g[GR]), T = {
                    getPlugin: function() {
                        return g;
                    },
                    getNext: function() {
                        return _;
                    },
                    processTelemetry: _processTelemetry,
                    unload: _unloadPlugin,
                    update: _updatePlugin,
                    _id: v = g ? g[AR] + "-" + g[aP] + "-" + tw++ : "Unknown-0-" + tw++,
                    _setNext: function(g) {
                        _ = g;
                    }
                };
                function _getTelCtx() {
                    var v;
                    return g && cl(g[ew]) && (v = g[ew]()), v || (v = createProcessTelemetryContext2(T, f, S)), v;
                }
                function _processChain(f, S, C, E, T) {
                    var I = !1, b = g ? g[AR] : XP, A = f[ZP];
                    return A || (A = f[ZP] = {}), f.setNext(_), g && doPerf2(f[tP](), function() {
                        return b + ":" + C;
                    }, function() {
                        A[v] = !0;
                        try {
                            var g = _ ? _._id : eP;
                            g && (A[g] = !1), I = S(f);
                        } catch (g) {
                            var E = !_ || A[_._id];
                            E && (I = !0), _ && E || _throwInternal2(f[BR](), 1, 73, "Plugin [" + b + "] failed during " + C + " - " + dumpObj(g) + ", run flags: " + dumpObj(A));
                        }
                    }, E, T), I;
                }
                function _processTelemetry(f, S) {
                    function _callProcessTelemetry(S) {
                        if (!g || !C) return !1;
                        var v = _getPluginState2(g);
                        return !v[FR] && !v[iP] && (E && g[GR](_), g[rP](f, S), !0);
                    }
                    _processChain(S = S || _getTelCtx(), _callProcessTelemetry, "processTelemetry", function() {
                        return {
                            item: f
                        };
                    }, !f.sync) || S[OR](f);
                }
                function _unloadPlugin(f, S) {
                    function _callTeardown() {
                        var v = !1;
                        if (g) {
                            var _ = _getPluginState2(g), C = g[tP] || _[tP];
                            !g || C && C !== f.core() || _[FR] || (_[tP] = null, _[FR] = !0, _[RR] = !1, g[FR] && !0 === g[FR](f, S) && (v = !0));
                        }
                        return v;
                    }
                    _processChain(f, _callTeardown, "unload", function() {}, S[VR]) || f[OR](S);
                }
                function _updatePlugin(f, S) {
                    function _callUpdate() {
                        var v = !1;
                        if (g) {
                            var _ = _getPluginState2(g), C = g[tP] || _[tP];
                            !g || C && C !== f.core() || _[FR] || g[$R] && !0 === g[$R](f, S) && (v = !0);
                        }
                        return v;
                    }
                    _processChain(f, _callUpdate, "update", function() {}, !1) || f[OR](S);
                }
                return bl(T);
            }
            function createUnloadHandlerContainer2() {
                var g = [];
                function _addHandler(f) {
                    f && g[yR](f);
                }
                function _runHandlers(f, S) {
                    arrForEach(g, function(g) {
                        try {
                            g(f, S);
                        } catch (g) {
                            _throwInternal2(f[BR](), 2, 73, "Unexpected error calling unload handler - " + dumpObj(g));
                        }
                    }), g = [];
                }
                return {
                    add: _addHandler,
                    run: _runHandlers
                };
            }
            function createUnloadHookContainer2() {
                var g = [];
                function _doUnload(f) {
                    var S = g;
                    g = [], arrForEach(S, function(g) {
                        try {
                            (g.rm || g.remove).call(g);
                        } catch (g) {
                            _throwInternal2(f, 2, 73, "Unloading:" + dumpObj(g));
                        }
                    });
                }
                function _addHook(f) {
                    f && arrAppend(g, f);
                }
                return {
                    run: _doUnload,
                    add: _addHook
                };
            }
            var iw, nw = "getPlugin", rw = ((QP = {})[nP] = {
                isVal: isNotNullOrUndefined2,
                v: {}
            }, QP), aw = function() {
                function BaseTelemetryPlugin3() {
                    var g, f, S, v, _, C = this;
                    function _getTelCtx(g) {
                        void 0 === g && (g = null);
                        var v = g;
                        if (!v) {
                            var _ = f || createProcessTelemetryContext2(null, {}, C[tP]);
                            v = S && S[nw] ? _[LR](null, S[nw]) : _[LR](null, S);
                        }
                        return v;
                    }
                    function _setDefaults(g, v, _) {
                        createDynamicConfig2(g, rw, safeGetLogger2(v)), !_ && v && (_ = v[DR]()[jR]());
                        var E = S;
                        S && S[nw] && (E = S[nw]()), C[tP] = v, f = createProcessTelemetryContext2(_, g, v, E);
                    }
                    function _initDefaults() {
                        g = !1, C[tP] = null, f = null, S = null, _ = createUnloadHookContainer2(), v = createUnloadHandlerContainer2();
                    }
                    _initDefaults(), dynamicProto(BaseTelemetryPlugin3, C, function(f) {
                        f[bR] = function(f, S, v, _) {
                            _setDefaults(f, S, _), g = !0;
                        }, f[FR] = function(g, C) {
                            var E, T = f[tP];
                            if (T && (!g || T === g[tP]())) {
                                var I, b = !1, A = g || createProcessTelemetryUnloadContext2(null, T, S && S[nw] ? S[nw]() : S), R = C || ((E = {
                                    reason: 0
                                })[VR] = !1, E);
                                return f[HR] && !0 === f[HR](A, R, _unloadCallback) ? I = !0 : _unloadCallback(), I;
                            }
                            function _unloadCallback() {
                                b || (b = !0, v.run(A, C), _.run(A[BR]()), !0 === I && A[OR](R), _initDefaults());
                            }
                        }, f[$R] = function(g, v) {
                            var _ = f[tP];
                            if (_ && (!g || _ === g[tP]())) {
                                var C, E = !1, T = g || createProcessTelemetryUpdateContext2(null, _, S && S[nw] ? S[nw]() : S), I = v || {
                                    reason: 0
                                };
                                return f._doUpdate && !0 === f._doUpdate(T, I, _updateCallback) ? C = !0 : _updateCallback(), C;
                            }
                            function _updateCallback() {
                                E || (E = !0, _setDefaults(T.getCfg(), T.core(), T[jR]()));
                            }
                        }, proxyFunctionAs2(f, "_addUnloadCb", function() {
                            return v;
                        }, "add"), proxyFunctionAs2(f, "_addHook", function() {
                            return _;
                        }, "add"), objDefine(f, "_unloadHooks", {
                            g: function() {
                                return _;
                            }
                        });
                    }), C[BR] = function(g) {
                        return _getTelCtx(g)[BR]();
                    }, C[RR] = function() {
                        return g;
                    }, C.setInitialized = function(f) {
                        g = f;
                    }, C[GR] = function(g) {
                        S = g;
                    }, C[OR] = function(g, f) {
                        f ? f[OR](g) : S && cl(S[rP]) && S[rP](g, null);
                    }, C._getTelCtx = _getTelCtx;
                }
                return BaseTelemetryPlugin3.__ieDyn = 1, BaseTelemetryPlugin3;
            }(), sw = "", ow = "timings", lw = "processTelemetryStart";
            (iw = {})[0] = 0, iw[2] = 6, iw[1] = 1, iw[3] = 7, iw[4098] = 6, iw[4097] = 1, iw[4099] = 7;
            function getTenantId2(g) {
                if (g) {
                    var f = ac(g, "-");
                    if (f > -1) return strLeft(g, f);
                }
                return sw;
            }
            var cw, dw, uw = perfNow;
            function setProcessTelemetryTimings2(g, f) {
                var S = g;
                S[ow] = S[ow] || {}, S[ow][lw] = S[ow][lw] || {}, S[ow][lw][f] = uw();
            }
            function isGreaterThanZero2(g) {
                return g > 0;
            }
            function isValidPersistenceLevel(g) {
                return hl(g) && g >= 1 && g <= 2;
            }
            (dw = cw || (cw = {}))[dw.LocalStorage = 1] = "LocalStorage", dw[dw.SessionStorage = 2] = "SessionStorage", dw[dw.IndexedDb = 3] = "IndexedDb";
            var hw = "readwrite", gw = "result", pw = "DBError: Unable to open database", mw = "Database is not open", fw = "DBError: Failed to Open Cursor", Sw = "DBError: Failed to delete the database", vw = "DBError: Database does not exist", _w = "DBError: Database upgrade required", Cw = "DBError: Feature not supported", yw = [
                "indexedDB"
            ], Ew = cl, Tw = ll, Iw = 0;
            function _getDbFactory() {
                var g = getGlobal() || {}, f = null;
                if (g) try {
                    for(var S = 0; S < yw.length; S++)if ((f = g[yw[S]]) && Ew(f.open)) return f;
                } catch (g) {
                    f = null;
                }
                return f || null;
            }
            function _debugLog(g, f) {
                getInst("QUnit") && console && console.log("  [" + toISOString2(new Date) + "]: IndexedDbHelper [" + g + "] " + f);
            }
            function _warnLog(g, f, S) {
                g && g.warnToConsole("IndexedDbHelper [" + f + "] " + S);
            }
            function _eventReject(g, f, S, v) {
                return function(_) {
                    S(new Error(f)), _debugLog(g, "[" + v + "] event rejected");
                };
            }
            var bw = [];
            function _getDbContext(g, f) {
                for(var S = null, v = 0; v < bw.length; v++)if ((S = bw[v]).name === g) return S;
                return S = {
                    name: g,
                    sch: createTaskScheduler(createAsyncPromise, "IndexedDbHelper[" + g + "]"),
                    dbHdl: [],
                    add: function(f) {
                        S.dbHdl.push(f), _debugLog(g, "- dbOpened (add) -- hdls [" + S.dbHdl.length + "]");
                    },
                    remove: function(f) {
                        for(var v = S.dbHdl, _ = 0; _ < v.length; _++)if (v[_] === f) {
                            v.splice(_, 1);
                            break;
                        }
                        _debugLog(g, "- dbClosed (remove) -- hdls [" + S.dbHdl.length + "]");
                    },
                    isOpen: function() {
                        return S.dbHdl.length > 0;
                    },
                    openHdl: function() {
                        return S.dbHdl.length > 0 ? S.dbHdl[0] : null;
                    }
                }, bw.push(S), S;
            }
            var Aw = function() {
                function IndexedDbHelper2(g) {
                    var f = Iw++, S = 0;
                    dynamicProto(IndexedDbHelper2, this, function(v) {
                        var _ = _getDbFactory() || null;
                        function _createStoreContext(v, _, C) {
                            var E = v.db, T = S++;
                            _debugLog(v.dbName, "[" + f + ":" + T + "] txn.open - " + _ + " -- " + C);
                            var I = E.transaction(_, hw);
                            return I.onabort = function() {
                                _warnLog(g, v.dbName, "[" + f + ":" + T + "] txn.onabort - " + _ + " -- " + C + " -- " + dumpObj(I.error));
                            }, I.onerror = function() {
                                _warnLog(g, v.dbName, "[" + f + ":" + T + "] txn.onerror - " + _ + " -- " + C);
                            }, I.oncomplete = function() {
                                _debugLog(v.dbName, "[" + f + ":" + T + "] txn.oncomplete - " + _ + " -- " + C);
                            }, {
                                db: v,
                                store: I.objectStore(_),
                                tx: I,
                                tbl: _,
                                openCursor: function(g, f) {
                                    return _openCursor(v, _, g, f);
                                },
                                newTransaction: function(g) {
                                    return _openStore(v, _, g);
                                }
                            };
                        }
                        function _openStore(g, f, S) {
                            if (!g || !g.db) return gu(new Error(mw));
                            try {
                                var v = S(_createStoreContext(g, f, "openStore"));
                                return isPromiseLike2(v) ? v : hu(v);
                            } catch (g) {
                                return gu(g);
                            }
                        }
                        function _openCursor(g, f, S, v) {
                            if (!g || !g.db) return gu(new Error(mw));
                            var _ = null;
                            return S && Tw(S) ? _ = new Rw(S) : S && S.isMatch && (_ = S), createAsyncPromise(function(S, C) {
                                var E = [], T = null, I = null;
                                _ && _.keyRange && (I = _.keyRange());
                                var b = _createStoreContext(g, f, "openCursor");
                                (T = I ? b.store.openCursor(I) : b.store.openCursor()).onerror = _eventReject(b.db.dbName, fw, C, "openCursor"), T.onsuccess = function(g) {
                                    var f = g.target[gw];
                                    if (f) {
                                        var T = {
                                            store: b,
                                            cursor: f,
                                            continue: function() {
                                                f.continue();
                                            },
                                            done: function() {
                                                S(E);
                                            }
                                        }, I = f.value;
                                        if (!_ || _.isMatch(I)) {
                                            if (v) try {
                                                switch(v(T, I, E)){
                                                    case 2:
                                                        S(E);
                                                        break;
                                                    case 1:
                                                        break;
                                                    default:
                                                        T.continue();
                                                }
                                            } catch (g) {
                                                C(g);
                                            }
                                            else E.push(I), T.continue();
                                        } else T.continue();
                                    } else S(E);
                                };
                            });
                        }
                        function _scheduleEvent(g, f, S, v) {
                            return _getDbContext(g).sch.queue(S, f, v);
                        }
                        v.isAvailable = function() {
                            return !!_;
                        }, v.openDb = function(f, S, v, C) {
                            return _scheduleEvent(f, "openDb", function(E) {
                                return createAsyncPromise(function(T, I) {
                                    var b = !1;
                                    function _createDbCtx(g, v, _, C, E) {
                                        var T = {
                                            db: v,
                                            dbName: f,
                                            dbVersion: S,
                                            ctx: null,
                                            isNew: C,
                                            txn: _ ? _.transaction : null
                                        };
                                        return E || (T.openStore = function(g, f) {
                                            return _openStore(T, g, f);
                                        }, T.openCursor = function(g, f, S) {
                                            return _openCursor(T, g, f, S);
                                        }), T;
                                    }
                                    function _databaseUpgrade(g, f) {
                                        var S = _createDbCtx(null, g, f, !0, !0);
                                        if (C) b = !0, doAwaitResponse(C(S), function(g) {
                                            if (g.rejected) try {
                                                f.transaction && f.transaction.abort();
                                            } finally{
                                                I(g.reason);
                                            }
                                            else S.txn || (S.txn = f.transaction);
                                        });
                                        else try {
                                            f.transaction && f.transaction.abort();
                                        } finally{
                                            I(new Error(_w));
                                        }
                                    }
                                    function _databaseOpen(S, _) {
                                        var C = _getDbContext(f);
                                        C.add(S), S.onabort = function(v) {
                                            _warnLog(g, f, "onabort -- closing the Db"), C.remove(S);
                                        }, S.onerror = function(v) {
                                            _warnLog(g, f, "onerror -- closing the Db"), C.remove(S);
                                        }, S.onclose = function(v) {
                                            _warnLog(g, f, "onclose -- closing the Db"), C.remove(S);
                                        }, S.onversionchange = function(v) {
                                            _warnLog(g, f, "onversionchange -- force closing the Db"), S.close(), C.remove(S);
                                        };
                                        var E = null, A = null;
                                        C.dbHdl.length > 0 && (A = C.dbHdl[0]), E = _createDbCtx(C, A, _, b);
                                        try {
                                            doAwait(v(E), T, I);
                                        } catch (g) {
                                            I(g);
                                        }
                                    }
                                    var A = _getDbContext(f);
                                    if (null == _) I(new Error("No available storage factory"));
                                    else if (A.isOpen()) {
                                        var R = _createDbCtx(A, A.openHdl(), null, !1);
                                        doAwait(v(R), T, I);
                                    } else {
                                        var P = _.open(f, S);
                                        P.onblocked = function(S) {
                                            _warnLog(g, f, "Db Open Blocked event [" + E + "] - " + (P.error || "")), I(new Error(pw));
                                        }, P.onerror = function(S) {
                                            _warnLog(g, f, "Db Open Error event [" + E + "] - " + (P.error || "")), I(new Error(pw));
                                        }, P.onupgradeneeded = function(g) {
                                            _debugLog(f, "Db Open Create/Upgrade needed event [" + E + "]");
                                            try {
                                                var S = g.target[gw];
                                                if (!S) return void I(new Error(pw));
                                                _databaseUpgrade(S, P);
                                            } catch (g) {
                                                _eventReject(f, pw, I, E)(g);
                                            }
                                        }, P.onsuccess = function(g) {
                                            var f = g.target[gw];
                                            f ? _databaseOpen(f, P) : I(new Error(pw));
                                        };
                                    }
                                });
                            });
                        }, v.closeDb = function(g) {
                            _scheduleEvent(g, "closeDb", function(f) {
                                var S = _getDbContext(g), v = S.dbHdl, _ = v.length;
                                if (_ > 0) {
                                    for(var C = 0; C < _; C++)v[C].close();
                                    S.dbHdl = [];
                                }
                                return 1;
                            }).catch(function(g) {});
                        }, v.deleteDb = function(f) {
                            return null != _ && _scheduleEvent(f, "deleteDb", function(S) {
                                var v = _getDbContext(f), C = v.dbHdl, E = C.length;
                                if (E > 0) {
                                    _warnLog(g, f, "Db is open [" + E + "] force closing");
                                    for(var T = 0; T < E; T++)C[T].close();
                                    v.dbHdl = [];
                                }
                                return createAsyncPromise(function(v, C) {
                                    setTimeout(function() {
                                        try {
                                            _debugLog(f, "[" + S + "] starting");
                                            var E = _.deleteDatabase(f);
                                            E.onerror = function(v) {
                                                _warnLog(g, f, "[" + S + "] error!!"), C(new Error(Sw));
                                            }, E.onblocked = function(v) {
                                                _warnLog(g, f, "[" + S + "] blocked!!"), C(new Error(Sw));
                                            }, E.onupgradeneeded = function(v) {
                                                _warnLog(g, f, "[" + S + "] upgrade needed!!"), C(new Error(Sw));
                                            }, E.onsuccess = function(g) {
                                                _debugLog(f, "[" + S + "] complete"), v(!0);
                                            }, _debugLog(f, "[" + S + "] started");
                                        } catch (v) {
                                            _warnLog(g, f, "[" + S + "] threw - " + v), C(new Error(Sw + " - " + v));
                                        }
                                    }, 0);
                                });
                            });
                        }, v.getDbDetails = function(g) {
                            return _scheduleEvent(g, "getDbDetails", function(f) {
                                return null != _ && _.databases ? createAsyncPromise(function(f, S) {
                                    _.databases().then(function(v) {
                                        for(var _ = 0; _ < v.length; _++)if (v[_].name === g) return void f(v[_]);
                                        S(new Error(vw));
                                    }, S);
                                }) : gu(new Error(Cw));
                            }, 2e3);
                        };
                    });
                }
                return IndexedDbHelper2.__ieDyn = 1, IndexedDbHelper2;
            }(), Rw = function() {
                function SimpleQuery2(g) {
                    var f = [], S = null;
                    dynamicProto(SimpleQuery2, this, function(v) {
                        v.keyRange = function() {
                            return S;
                        }, v.parseQuery = function(g) {
                            if (f = [], g) for(var _ = g.split(";"), C = 0; C < _.length; C++){
                                var E = _[C], T = E.indexOf("=");
                                if (-1 !== T) {
                                    var I = E.substring(0, T), b = E.substring(T + 1);
                                    0 === I.indexOf("#") && (I = I.substring(1), S || (S = IDBKeyRange.bound(b, b + "\uFFFF"))), v.startsWith(I, b);
                                }
                            }
                        }, v.startsWith = function(g, S) {
                            f.push({
                                name: g,
                                value: S,
                                type: 0
                            });
                        }, v.contains = function(g, S) {
                            f.push({
                                name: g,
                                value: S,
                                type: 1
                            });
                        }, v.isMatch = function(g) {
                            if (!f || 0 === f.length) return !0;
                            if (!g) return !1;
                            for(var S = 0; S < f.length; S++){
                                var v = f[S], _ = g[v.name];
                                if (_) {
                                    if (0 === v.type) {
                                        if (0 !== _.indexOf(v.value)) return !1;
                                    } else if (1 === v.type && -1 === _.indexOf(v.value)) return !1;
                                }
                            }
                            return !0;
                        }, g && v.parseQuery(g);
                    });
                }
                return SimpleQuery2.__ieDyn = 1, SimpleQuery2;
            }(), Pw = 10, ww = 1, Mw = 6e5, Ow = 6048e5, Dw = "Unknown", Nw = -1, kw = "DBError: Unable to add event", Lw = "DBError: Unable to update iKey", Fw = 1, xw = "Evts", Uw = "iKey", Vw = isValidPersistenceLevel;
            function _getTime() {
                return (new Date).getTime();
            }
            function _eventReject2(g, f) {
                return function(S) {
                    return f(new Error(g));
                };
            }
            function _createDb(g) {
                g.objectStoreNames.contains(xw) || g.createObjectStore(xw, {
                    keyPath: "key"
                }).createIndex("EvntId", "key", {
                    unique: !1
                });
                g.objectStoreNames.contains(Uw) || g.createObjectStore(Uw, {
                    keyPath: "iKey"
                }).createIndex("iKey", "iKey", {
                    unique: !0
                });
            }
            function _updateiKey(g) {
                return g.openStore(Uw, function(f) {
                    return createAsyncPromise(function(S, v) {
                        var _ = {
                            iKey: g.ctx.iKey,
                            tm: _getTime()
                        }, C = f.store.put(_);
                        C.onsuccess = function(g) {
                            S(C.result.toString());
                        }, C.onerror = function(g) {
                            v(new Error(kw));
                        }, C.onerror = _eventReject2(Lw, v);
                    });
                });
            }
            function _orderEventsByPriority(g) {
                for(var f = [], S = 2; S >= 1; S--)for(var v = 0; v < g.length; v++){
                    var _ = g[v];
                    _ && _.evt.persistence === S && f.push(_.evt);
                }
                return f;
            }
            function _addEventByTime(g, f) {
                for(var S = 0; S < g.length; S++)if (f.tm < g[S].tm) return void g.splice(S, 0, f);
                g.push(f);
            }
            function _getKeyIndex(g, f) {
                for(var S = f.length, v = 0; v < S; v++)if (g === f[v].id) return v;
                return -1;
            }
            function _isOldItem(g, f) {
                var S = g.tm;
                return _getTime() - S > f;
            }
            function _cursorContinueEvent(g) {
                return function(f) {
                    return g.continue();
                };
            }
            function _cursorDeleteAndContinue(g) {
                var f = g.cursor.delete();
                return f.onerror = _cursorContinueEvent(g), f.onsuccess = _cursorContinueEvent(g), 1;
            }
            function _getAllEventsForiKey(g, f) {
                return g.openCursor(xw, f, function(g, f, S) {
                    return S.push(f), 0;
                });
            }
            function _deleteEvents(g, f, S) {
                return g.openCursor(xw, f, function(g, f, v) {
                    return S(f) ? (v.push(f), _cursorDeleteAndContinue(g)) : 0;
                });
            }
            function _deleteOrphanedEvents(g) {
                return createAsyncPromise(function(f, S) {
                    var v = !1;
                    g.openCursor(Uw, null, function(g, f, S) {
                        var _ = f.tm;
                        return _getTime() - _ < Ow ? 0 : (v = !0, 2);
                    }).then(function() {
                        if (v) {
                            var _ = {};
                            _deleteEvents(g, null, function(g) {
                                if (!g || !g.evt || !g.evt.iKey) return !0;
                                var f = g.tm;
                                return _getTime() - f > Ow || (_[g.evt.iKey] = 1, !1);
                            }).then(function() {
                                var v = [];
                                g.openCursor(Uw, null, function(g, f, S) {
                                    var C = f.tm;
                                    return _getTime() - C < Ow || _[f.iKey] ? 0 : (v.push(f), _cursorDeleteAndContinue(g));
                                }).then(function() {
                                    f(v);
                                }, S);
                            }, S);
                        } else f([]);
                    }, S);
                });
            }
            function _moveOldEventsToCurrentStore(g, f) {
                return g.openCursor(xw, "#key=" + g.ctx.iKeyPrefix(), function(S, v) {
                    var _ = v.key;
                    if (0 === _.indexOf(g.ctx.iKeyPrefix()) && -1 === _.indexOf(g.ctx.evtKeyPrefix()) && _isOldItem(v, f)) {
                        v.key = g.ctx.evtKeyPrefix() + v.id;
                        var C = S.store.store.put(v);
                        return C.onerror = _cursorContinueEvent(S), C.onsuccess = function(g) {
                            try {
                                _cursorDeleteAndContinue(S);
                            } catch (g) {
                                S.continue();
                            }
                        }, 1;
                    }
                    return 0;
                });
            }
            function _checkVersionAndMoveEventsToCurrentStorage(g, f) {
                return createAsyncPromise(function(S, v) {
                    _deleteOrphanedEvents(g).then(function() {
                        _moveOldEventsToCurrentStore(g, f).then(S, S);
                    }, v);
                });
            }
            function _dropEventsUpToPersistence(g, f) {
                return createAsyncPromise(function(S, v) {
                    var _ = 0, C = g.ctx.evtKeyPrefix();
                    function _resolveWithDroppedEvents() {
                        S(_);
                    }
                    function _dropEvent(g, f) {
                        return createAsyncPromise(function(S) {
                            var v = g.store.delete(f.key);
                            v.onsuccess = function(g) {
                                _++, S();
                            }, v.onerror = function(g) {
                                S();
                            };
                        });
                    }
                    function _processCandidates(f) {
                        0 !== f.length ? g.openStore(xw, function(g) {
                            for(var S = [], v = 0; v < f.length; v++)S.push(_dropEvent(g, f[v]));
                            return uu(S).then(_resolveWithDroppedEvents, _resolveWithDroppedEvents);
                        }) : _resolveWithDroppedEvents();
                    }
                    g.openCursor(xw, "#key=" + C, function(g, S, v) {
                        return S.evt.persistence <= f && 0 === S.key.indexOf(C) && (_addEventByTime(v, S), v.length > Pw && v.splice(v.length - 1, 1)), 0;
                    }).then(_processCandidates, function() {
                        S(0);
                    });
                });
            }
            var Bw = function() {
                function IndexedDbProvider2(g, f) {
                    dynamicProto(IndexedDbProvider2, this, function(S) {
                        var v = null, _ = null, C = Dw, E = null, T = null, I = null, b = Nw, A = 0, R = Mw;
                        function _openDb(g) {
                            function _handleDbUpgrade(g) {
                                return createAsyncPromise(function(f, S) {
                                    _createDb(g.db), f();
                                });
                            }
                            function _handleDbOpen(f) {
                                return createAsyncPromise(function(S, v) {
                                    var _ = {
                                        iKey: C,
                                        storageId: E,
                                        iKeyPrefix: function() {
                                            return T;
                                        },
                                        evtKeyPrefix: function() {
                                            return I;
                                        }
                                    };
                                    f.ctx = _, doAwait(_updateiKey(f), function() {
                                        doAwait(g(f), S, v);
                                    }, v);
                                });
                            }
                            return v.openDb(_, Fw, _handleDbOpen, _handleDbUpgrade);
                        }
                        function _addDbEvent(g, f, S) {
                            return createAsyncPromise(function(v, _) {
                                function dropEvents(f, S) {
                                    _dropEventsUpToPersistence(g, f).then(function(g) {
                                        g > 0 && (A -= g), S(g);
                                    }, function(g) {
                                        S(0);
                                    });
                                }
                                function resolveAddEvent(g) {
                                    v(f.evt);
                                }
                                function _insertNewEvent() {
                                    g.openStore(xw, function(C) {
                                        var E = C.store.put(f);
                                        E.onsuccess = function(_) {
                                            S && _updateiKey(g).then(resolveAddEvent, resolveAddEvent), A++, v(f.evt);
                                        }, E.onerror = function(C) {
                                            function _retryAddEvent(S) {
                                                0 === S && _(new Error(kw)), _addDbEvent(g, f, !1).then(function(g) {
                                                    v(f.evt);
                                                }, function() {
                                                    _(new Error(kw));
                                                });
                                            }
                                            S ? dropEvents(1, function(g) {
                                                g > 0 ? _retryAddEvent(g) : f.evt.persistence >= 2 ? dropEvents(2, function(g) {
                                                    _retryAddEvent(g);
                                                }) : _(new Error(kw));
                                            }) : _(new Error(kw));
                                        };
                                    });
                                }
                                b > 0 && A >= b ? dropEvents(1, function(g) {
                                    0 === g ? f.evt.persistence >= 2 ? dropEvents(2, function(g) {
                                        _insertNewEvent();
                                    }) : _(new Error(kw)) : _insertNewEvent();
                                }) : _insertNewEvent();
                            });
                        }
                        S.id = g, S.initialize = function(g) {
                            var A = g.itemCtx.diagLog();
                            if (!(v = new Aw(A)).isAvailable()) return v = null, !1;
                            var P = g.itemCtx.getCfg(), w = g.storageConfig;
                            C = P.instrumentationKey || C, E = S.id || g.id || newGuid3(), I = (T = C + "::") + E + "::", R = w.accessThresholdInMs || R;
                            var M = onConfigChange2(w, function() {
                                b = w.maxStorageItems;
                                var g = w.indexedDbName;
                                _ && g !== _ && _ && doAwaitResponse(S.clear(), function(f) {
                                    _ = g, _openDb(function(g) {
                                        return g.isNew ? [] : _checkVersionAndMoveEventsToCurrentStorage(g, R);
                                    }).then(function(g) {}, function(g) {
                                        A.warnToConsole("IndexedDbProvider failed to initialize - " + (g || "<unknown>")), v = null;
                                    });
                                }), _ = g;
                            });
                            return f && f.add(M), _openDb(function(g) {
                                return g.isNew ? [] : _checkVersionAndMoveEventsToCurrentStorage(g, R);
                            }).then(function(g) {}, function(g) {
                                A.warnToConsole("IndexedDbProvider failed to initialize - " + (g || "<unknown>")), v = null;
                            }), !0;
                        }, S._getDbgPlgTargets = function() {
                            return [
                                _
                            ];
                        }, S.supportsSyncRequests = function() {
                            return !1;
                        }, S.getAllEvents = function() {
                            return null != v && v.isAvailable() ? _openDb(function(g) {
                                return createAsyncPromise(function(f, S) {
                                    _getAllEventsForiKey(g, "#key=" + g.ctx.evtKeyPrefix()).then(function(g) {
                                        A = g.length, f(_orderEventsByPriority(g));
                                    }, S);
                                });
                            }) : [];
                        }, S.addEvent = function(g, f, S) {
                            return null != v && v.isAvailable() ? (f.id = f.id || newGuid3(), Vw(f.persistence) || (f.persistence = 1), _openDb(function(S) {
                                var v = g || f.id, _ = {
                                    key: S.ctx.evtKeyPrefix() + v,
                                    id: v,
                                    evt: f,
                                    tm: _getTime(),
                                    v: ww
                                };
                                return _addDbEvent(S, _, !0);
                            })) : f;
                        }, S.removeEvents = function(g) {
                            if (null == v || !v.isAvailable()) return [];
                            var f = [];
                            return createAsyncPromise(function(S, v) {
                                _openDb(function(S) {
                                    return S.openCursor(xw, "#key=" + S.ctx.iKey, function(S, v, _) {
                                        if (-1 !== _getKeyIndex(v.id, g)) {
                                            var C = S.cursor.delete();
                                            return C.onerror = _cursorContinueEvent(S), C.onsuccess = function() {
                                                f.push(v.evt), S.continue();
                                            }, 1;
                                        }
                                        return 0;
                                    });
                                }).then(function(g) {
                                    A -= f.length, S(f);
                                }, function(g) {
                                    A -= f.length, S(f);
                                });
                            });
                        }, S.clear = function() {
                            return null != v && v.isAvailable() ? createAsyncPromise(function(g, f) {
                                _openDb(function(g) {
                                    return _deleteEvents(g, "#key=" + g.ctx.evtKeyPrefix(), function(f) {
                                        return 0 === f.key.indexOf(g.ctx.evtKeyPrefix());
                                    });
                                }).then(function(f) {
                                    A = 0, g(_orderEventsByPriority(f));
                                }, f);
                            }) : [];
                        }, S.moveStaleEvents = function() {
                            _openDb(function(g) {
                                return _checkVersionAndMoveEventsToCurrentStorage(g, R);
                            });
                        }, S.teardown = function() {
                            v && v.closeDb(_);
                        };
                    });
                }
                return IndexedDbProvider2.__ieDyn = 1, IndexedDbProvider2;
            }(), Hw = 10, $w = "3", jw = "Version", Gw = "AWTEvents", qw = 5e6;
            function _isQuotaExceeded(g, f) {
                var S = !1;
                return f instanceof DOMException && (22 !== f.code && "QuotaExceededError" !== f.name && 1014 !== f.code && "NS_ERROR_DOM_QUOTA_REACHED" !== f.name || g && 0 !== g.length && (S = !0)), S;
            }
            function _getAvailableStorage(g) {
                var f = getGlobal() || {}, S = null;
                try {
                    if (S = f[g]) {
                        var v = "__storage_test__";
                        S.setItem(v, v), S.removeItem(v);
                    }
                } catch (g) {
                    _isQuotaExceeded(S, g) || (S = null);
                }
                return S;
            }
            function _forEachMap(g, f) {
                if (g) for(var S = Il(g), v = 0; v < S.length; v++){
                    var _ = S[v];
                    if (!f(g[_], _)) break;
                }
            }
            function _isMapEmpty(g) {
                var f = !0;
                return _forEachMap(g, function(g, S) {
                    return g && (f = !1), f;
                }), f;
            }
            function _dropEventsUpToPersistence2(g, f) {
                for(var S = 1, v = 0, _loop_1 = function() {
                    var g = [], _ = f[S];
                    if (_forEachMap(_, function(f, S) {
                        return g.push(S), ++v < Hw;
                    }), v > 0) {
                        for(var C = 0; C < g.length; C++)delete _[g[C]];
                        return {
                            value: !0
                        };
                    }
                    S++;
                }; S <= g && v < Hw;){
                    var _ = _loop_1();
                    if ("object" == typeof _) return _.value;
                }
                return v > 0;
            }
            var Ww = isValidPersistenceLevel, zw = function() {
                function WebStorageProvider2(g, f, S) {
                    dynamicProto(WebStorageProvider2, this, function(v) {
                        var _ = null, C = Gw, E = null, T = $w, I = null, b = null, A = qw, R = 6e5, P = null, w = null;
                        function _newStore(g, f) {
                            return {
                                key: g,
                                db: f
                            };
                        }
                        function _fetchStoredDb(g, f) {
                            void 0 === f && (f = !0);
                            var S = null;
                            if (_) {
                                var v = _.getItem(g);
                                if (v) try {
                                    S = JSON.parse(v);
                                } catch (f) {
                                    _.removeItem(g);
                                }
                            }
                            return f && !S && (S = {
                                events: {
                                    1: {},
                                    2: {},
                                    3: {}
                                },
                                lastAccessTime: 0
                            }), _newStore(g, S);
                        }
                        function _updateStoredDb(g, f) {
                            void 0 === f && (f = !0);
                            var S = !0, v = g.db;
                            if (v) {
                                f && (v.lastAccessTime = (new Date).getTime());
                                for(var C = 1; C <= 2; C++)if (!_isMapEmpty(v.events[C])) {
                                    S = !1;
                                    break;
                                }
                            }
                            try {
                                if (S) _ && _.removeItem(g.key);
                                else {
                                    var E = JSON.stringify(v);
                                    if (E.length > A) return !1;
                                    _ && _.setItem(g.key, E);
                                }
                            } catch (g) {
                                return !1;
                            }
                            return !0;
                        }
                        function _clearDatabase(g) {
                            var f = [], S = _fetchStoredDb(g, !1), v = S.db;
                            if (v) {
                                var C = v.events;
                                try {
                                    for(var E = 1; E <= 2; E++)_forEachMap(C[E], function(g, S) {
                                        return g && f.push(g), !0;
                                    });
                                } catch (g) {}
                                _ && _.removeItem(S.key);
                            }
                            return f;
                        }
                        function _checkVersionAndMoveEventsToCurrentStorage2() {
                            if (_) {
                                for(var g = _.getItem(P), f = [], S = _fetchStoredDb(w), v = !1, E = 0; E < _.length; E++){
                                    var I = _.key(E);
                                    if (0 === I.indexOf(C) && I !== P) {
                                        if (g !== $w) {
                                            f.push(_newStore(I, null));
                                            continue;
                                        }
                                        var A = _fetchStoredDb(I, !1), M = A.db;
                                        if (M) {
                                            if ((new Date).getTime() - M.lastAccessTime > R) {
                                                for(var O = 1, _loop_3 = function() {
                                                    var g = M.events[O], f = S.db.events[O];
                                                    _forEachMap(g, function(S, v) {
                                                        return (getTenantId2(S.iKey) || S.iKey) === b && (f[v] = S, delete g[v]), !0;
                                                    }), O++;
                                                }; O <= 2;)_loop_3();
                                                v = !0, f.push(A);
                                            }
                                        } else f.push(_newStore(I, null));
                                    }
                                }
                                for(E = 0; E < f.length; E++)_updateStoredDb(f[E], !1);
                                v && _updateStoredDb(S), _.setItem(P, T);
                            }
                        }
                        v.id = f, _ = _getAvailableStorage(g) || null, v._getDbgPlgTargets = function() {
                            return [
                                C,
                                A
                            ];
                        }, v.initialize = function(g) {
                            if (!_) return !1;
                            var f = g.storageConfig;
                            E = v.id || g.id || newGuid3(), I = g.itemCtx.getCfg().instrumentationKey, b = getTenantId2(I) || I, R = f.accessThresholdInMs ? f.accessThresholdInMs : R;
                            var T = onConfigChange2(f, function() {
                                A = f.maxStorageSizeInBytes;
                                var g = f.storageKey;
                                C && g !== C && doAwaitResponse(v.clear(), function(f) {
                                    w = (C = g) + "." + E, P = C + jw, _checkVersionAndMoveEventsToCurrentStorage2();
                                });
                            });
                            return S && S.add(T), C = f.storageKey, w = C + "." + E, P = C + jw, _checkVersionAndMoveEventsToCurrentStorage2(), !0;
                        }, v.supportsSyncRequests = function() {
                            return !0;
                        }, v.getAllEvents = function() {
                            try {
                                var g = [], f = _fetchStoredDb(w, !1).db;
                                if (f) for(var S = f.events, v = 2; v >= 1; v--)_forEachMap(S[v], function(f) {
                                    f && (getTenantId2(f.iKey) || f.iKey) === b && g.push(f);
                                    return !0;
                                });
                                return g;
                            } catch (g) {
                                return gu(g);
                            }
                        }, v.addEvent = function(g, f, S) {
                            try {
                                var v = _fetchStoredDb(w);
                                f.id = f.id || newGuid3(), Ww(f.persistence) || (f.persistence = 1);
                                for(var _ = f.persistence, C = f.id, E = v.db.events;;){
                                    if (E[_][C] = f, _updateStoredDb(v)) return f;
                                    if (delete E[_][C], !_dropEventsUpToPersistence2(_, E)) return gu(new Error("Unable to free up event space"));
                                }
                            } catch (g) {
                                return gu(g);
                            }
                        }, v.removeEvents = function(g) {
                            try {
                                var f = _fetchStoredDb(w, !1), S = f.db;
                                if (S) {
                                    var v = S.events;
                                    try {
                                        for(var _ = 0; _ < g.length; ++_){
                                            var C = g[_];
                                            delete v[C.persistence][C.id];
                                        }
                                        if (_updateStoredDb(f)) return g;
                                    } catch (g) {}
                                    g = _clearDatabase(f.key);
                                }
                                return g;
                            } catch (g) {
                                return gu(g);
                            }
                        }, v.clear = function() {
                            try {
                                var g = [], f = _fetchStoredDb(w, !1), S = f.db;
                                if (S) {
                                    for(var v = S.events, _loop_2 = function(f) {
                                        var S = v[f];
                                        _forEachMap(S, function(f) {
                                            f && (getTenantId2(f.iKey) || f.iKey) === b && (delete S[f.id], g.push(f));
                                            return !0;
                                        });
                                    }, _ = 2; _ >= 1; _--)_loop_2(_);
                                    _updateStoredDb(f);
                                }
                                return g;
                            } catch (g) {
                                return gu(g);
                            }
                        }, v.teardown = function() {
                            try {
                                var g = _fetchStoredDb(w, !1), f = g.db;
                                f && (f.lastAccessTime = 0, _updateStoredDb(g, !1));
                            } catch (g) {}
                        }, v.moveStaleEvents = function() {
                            _checkVersionAndMoveEventsToCurrentStorage2();
                        };
                    });
                }
                return WebStorageProvider2.__ieDyn = 1, WebStorageProvider2;
            }(), Kw = "4.3.1", Jw = "LocalStorage", Yw = 5, Qw = isValidPersistenceLevel, Xw = void 0, Zw = "AppInsightEvents.1", eM = objDeepFreeze({
                maxStorageSizeInBytes: {
                    isVal: isGreaterThanZero2,
                    v: 5e6
                },
                storageKey: "AWTEvents",
                minPersistenceLevel: {
                    isVal: Qw,
                    v: 1
                },
                providers: [
                    cw.LocalStorage,
                    cw.IndexedDb
                ],
                indexedDbName: Zw,
                maxStorageItems: {
                    isVal: isGreaterThanZero2,
                    v: Xw
                }
            }), tM = function(g) {
                function LocalStorageChannel2() {
                    var f = g.call(this) || this;
                    return f.identifier = Jw, f.priority = 1009, f.version = Kw, dynamicProto(LocalStorageChannel2, f, function(g, f) {
                        var S, v, _, C;
                        function _initDefaults() {
                            S = !1, v = !1, _ = null, C = [];
                        }
                        function _queueStorageEvent(g, f) {
                            _ || (_ = createTaskScheduler(createAsyncPromise, "LocalStorage")), _.queue(function(g) {
                                return f(g);
                            }, g).catch(function(g) {});
                        }
                        function _sendStoredEventsToNextPlugin(f) {
                            doPerf2(g.core, function() {
                                return "LocalStorageChannel:_sendStoredEventsToNextPlugin";
                            }, function() {
                                _queueStorageEvent("sendToNext", function(S) {
                                    return doAwaitResponse(f.provider.getAllEvents(), function(S) {
                                        for(var v = S.value || [], _ = 0; _ < v.length; _++)try {
                                            var C = v[_];
                                            (getTenantId2(C.iKey) || C.iKey) === f.tenantId && g.processNext(C, f.coreRootCtx.createNew());
                                        } catch (g) {}
                                    });
                                });
                            }, function() {
                                return {
                                    iKeyConfig: f
                                };
                            });
                        }
                        function _removeEvents(f, S) {
                            doPerf2(g.core, function() {
                                return "LocalStorageChannel:_removeEvents";
                            }, function() {
                                _queueStorageEvent("removeEvents", function(g) {
                                    var v = [];
                                    if (arrForEach(S, function(g) {
                                        (getTenantId2(g.iKey) || g.iKey) === f.tenantId && v.push(g);
                                    }), v.length > 0) return doAwaitResponse(f.provider.removeEvents(v), function(g) {});
                                });
                            }, function() {
                                return {
                                    iKeyConfig: f,
                                    events: S
                                };
                            });
                        }
                        function _shouldCacheEvent(g, f) {
                            return !(f.sync || f.persistence < g.minPersistenceCacheLevel);
                        }
                        function _tryGetIndexedDbProvider(f) {
                            var S = new Bw(void 0, g._unloadHooks);
                            return S.initialize(f) || (S = null), S;
                        }
                        function _tryGetWebStorageProvider(f, S) {
                            var v = new zw(f, void 0, g._unloadHooks);
                            return v.initialize(S) || (v = null), v;
                        }
                        function _initializeProvider(g) {
                            for(var f = g.storageConfig.providers, S = null, v = 0; !S && v < f.length && v < Yw;)switch(f[v++]){
                                case cw.LocalStorage:
                                    S = _tryGetWebStorageProvider("localStorage", g);
                                    break;
                                case cw.SessionStorage:
                                    S = _tryGetWebStorageProvider("sessionStorage", g);
                                    break;
                                case cw.IndexedDb:
                                    S = _tryGetIndexedDbProvider(g);
                            }
                            return S;
                        }
                        function _compareProviders(g, f) {
                            if (g.length !== f.length) return !1;
                            var S = !0;
                            return arrForEach(g, function(g, v) {
                                if (g !== f[v]) return S = !1, -1;
                            }), S;
                        }
                        function _getCoreItemCtx(f, S, v, _) {
                            f && (f.extensionConfig = f.extensionConfig || []), !_ && S && (_ = S.getProcessTelContext().getNext());
                            var C = null, E = g._getTelCtx().getNext();
                            return E && (C = E.getPlugin()), createProcessTelemetryContext2(_, f, S, C);
                        }
                        function _createIkeyConfig(f, S, v, _) {
                            var E = !1;
                            if (arrForEach(C, function(g) {
                                if (g.iKey === f.instrumentationKey) return E = !0, -1;
                            }), !E) {
                                var T = null;
                                g._addHook(onConfigChange2(f, function(v) {
                                    var _ = createProcessTelemetryContext2(null, v.cfg, S);
                                    T = _.getExtCfg(g.identifier, eM);
                                    var E = !1, I = null, b = f.instrumentationKey;
                                    if (arrForEach(C, function(g) {
                                        if (g.iKey === b) return E = !0, I = g, -1;
                                    }), E && I) {
                                        var R = T.providers, P = I.preProviders;
                                        _compareProviders(R, P) || doAwaitResponse(A.clear(), function(g) {
                                            if (!g.rejected) try {
                                                var f = C.indexOf(I);
                                                -1 !== f && C.splice(f, 1);
                                                var v = _initializeProvider(I.providerContext);
                                                I.provider = v, I.preProviders = R.slice();
                                                var _ = I.preListener;
                                                _ && S.removeNotificationListener(_);
                                                var E = {
                                                    eventsSent: function(g) {
                                                        _removeEvents(I, g);
                                                    },
                                                    eventsDiscarded: function(g, f) {
                                                        _removeEvents(I, g);
                                                    }
                                                };
                                                I.preListener = E, C.push(I), S.addNotificationListener(E), _sendStoredEventsToNextPlugin(I);
                                            } catch (g) {}
                                        });
                                    }
                                }));
                                var I = _getCoreItemCtx(f, S, v, _), b = {
                                    itemCtx: I,
                                    storageConfig: T,
                                    id: g.id
                                };
                                if (!ll(f.instrumentationKey)) return;
                                var A = _initializeProvider(b), R = {
                                    iKey: f.instrumentationKey,
                                    tenantId: getTenantId2(f.instrumentationKey) || f.instrumentationKey,
                                    minPersistenceCacheLevel: 1,
                                    coreRootCtx: I,
                                    providerContext: b,
                                    provider: A,
                                    preProviders: T.providers.slice()
                                };
                                if (A) {
                                    Qw(T.minPersistenceLevel || -1) && (R.minPersistenceCacheLevel = T.minPersistenceLevel);
                                    var P = {
                                        eventsSent: function(g) {
                                            _removeEvents(R, g);
                                        },
                                        eventsDiscarded: function(g, f) {
                                            _removeEvents(R, g);
                                        }
                                    };
                                    R.preListener = P, C.push(R), S.addNotificationListener(P), _sendStoredEventsToNextPlugin(R);
                                } else C.push(R);
                            }
                        }
                        _initDefaults(), g.initialize = function(g, v, C, E) {
                            doPerf2(v, function() {
                                return "LocalStorageChannel.initialize";
                            }, function() {
                                S || (f.initialize(g, v, C), f.setInitialized(!1), S = !0, _ = createTaskScheduler(createAsyncPromise, "LocalStorage")), _createIkeyConfig(g, v, C, E);
                            }, function() {
                                return {
                                    coreConfig: g,
                                    core: v,
                                    extensions: C,
                                    pluginChain: E
                                };
                            });
                        }, g.processTelemetry = function(f, _) {
                            var E = f;
                            if (S && !v) {
                                _ = g._getTelCtx(_), setProcessTelemetryTimings2(f, g.identifier);
                                var T = null;
                                arrForEach(C, function(g) {
                                    g.iKey === f.iKey && (T = g);
                                });
                                var I = T ? T.provider : null;
                                if (E.sync || !I) return void g.processNext(E, _);
                                E.id = E.id || newGuid3(), isValidPersistenceLevel(E.persistence) || (E.persistence = 1), _shouldCacheEvent(T, E) && _queueStorageEvent("processTelemetry", function(g) {
                                    return I.addEvent(E.id, E, _);
                                });
                            }
                            g.processNext(E, _);
                        }, g.pause = function() {
                            v = !0;
                        }, g.resume = function() {
                            doPerf2(g.core, function() {
                                return "LocalStorageChannel:resume";
                            }, function() {
                                v = !1, arrForEach(C, function(g) {
                                    g.provider && _sendStoredEventsToNextPlugin(g);
                                });
                            });
                        }, g._doTeardown = function(g, f) {
                            arrForEach(C, function(g) {
                                var f = g.provider;
                                f && f.teardown();
                            }), _initDefaults();
                        }, g.flush = function(g, f, S) {}, g._getDbgPlgTargets = function() {
                            return [
                                C
                            ];
                        }, g._sendStale = function(g) {
                            arrForEach(C, function(f) {
                                if (f && f.iKey === g && f.provider) return f.provider.moveStaleEvents(), _sendStoredEventsToNextPlugin(f), -1;
                            });
                        };
                    }), f;
                }
                return __extendsFn(LocalStorageChannel2, g), LocalStorageChannel2.__ieDyn = 1, LocalStorageChannel2;
            }(aw), iM = "LocalStorage", nM = class {
                createLogger(g) {
                    return new rM(g, this.manager, this.logger, this.configProvider, this.uiVersion, this.eventLatency, this.contextProvider, this.envOverride);
                }
                createConfigForManager() {
                    return {
                        channels: [],
                        extensionConfig: {},
                        propertyConfiguration: {
                            populateBrowserInfo: !0,
                            populateOperatingSystemInfo: !0
                        },
                        channelConfiguration: {
                            eventsLimitInMem: this.configProvider.config.eventsLimitInMem,
                            disableFetchKeepAlive: this.configProvider.config.oneDSDisableFetchKeepAlive,
                            useSendBeacon: this.configProvider.config.oneDSUseSendBeacon
                        },
                        endpointUrl: this.accountCollectorURL,
                        enableCompoundKey: this.configProvider.config.enableCompoundKey,
                        disablePageUnloadEvents: this.configProvider.config.oneDSDisabledPageUnloadEvents
                    };
                }
                getUiVersion() {
                    const g = this.clientInfo.match(/^.*?\/(\d+\/)(.*?)\/.*$/);
                    return g ? g[1] + g[2] : this.clientInfo;
                }
                updateChannelConfig() {
                    this.configProvider.config.eventsLimitInMem !== this.managerConfig.channelConfiguration.eventsLimitInMem && this.manager.getPostChannel().setEventQueueLimits(this.configProvider.config.eventsLimitInMem), this.setTransmitProfile();
                }
                initManager() {
                    this.initLocalStorageChannel(), this.manager.create(this.managerConfig, []), this.manager.getNotifyMgr().addNotificationListener({
                        eventsDiscarded: (g, f)=>this.logDiscardedEvents(g, f),
                        eventsSent: (g)=>this.logSentEvents(g)
                    }), this.setTransmitProfile();
                }
                initLocalStorageChannel() {
                    if (!this.configProvider.config.useLocalStorageForOneDs) return;
                    const g = new tM;
                    this.managerConfig.channels.push([
                        g
                    ]);
                    var _this_configProvider_config_oneDSLocalStorage_accessThresholdInMs;
                    const f = {
                        storageKey: "TsCalling",
                        accessThresholdInMs: (_this_configProvider_config_oneDSLocalStorage_accessThresholdInMs = this.configProvider.config.oneDSLocalStorage.accessThresholdInMs) !== null && _this_configProvider_config_oneDSLocalStorage_accessThresholdInMs !== void 0 ? _this_configProvider_config_oneDSLocalStorage_accessThresholdInMs : 6e5
                    };
                    this.managerConfig.extensionConfig[iM] = f;
                }
                logDiscardedEvents(g, f) {
                    let S = "discarded events:";
                    g.forEach((g)=>S = `${S + g.name};`), this.logger.info(`${S} reason:${f}`);
                }
                logSentEvents(g) {
                    var _g__data, _g_;
                    let f = `sent events: ${((_g_ = g[0]) === null || _g_ === void 0 ? void 0 : (_g__data = _g_.data) === null || _g__data === void 0 ? void 0 : _g__data.CorrelationId) && getFrom("value", g[0].data.CorrelationId)}:`;
                    g.forEach((g)=>{
                        f = `${f + g.name};`;
                    }), this.logger.info(`${f}`);
                }
                setTransmitProfile() {
                    this.configProvider.config.transmitProfileTimings.length && this.manager.getPostChannel()._loadTransmitProfiles({
                        [this.configProvider.config.transmitProfileName]: this.configProvider.config.transmitProfileTimings
                    }), this.configProvider.config.transmitProfileName !== this.currentTransmitProfile && this.manager.getPostChannel()._setTransmitProfile(this.configProvider.config.transmitProfileName), this.currentTransmitProfile = this.configProvider.config.transmitProfileName;
                }
                constructor(g, f, S, v, _, C, E){
                    this.logger = g, this.configProvider = f, this.clientInfo = S, this.eventLatency = v, this.contextProvider = _, this.accountCollectorURL = C, this.envOverride = E, this.manager = new wv, this.managerConfig = this.createConfigForManager(), this.currentTransmitProfile = Gt.REPORTING_PROFILE.RT_PROFILE, this.initManager(), this.uiVersion = this.getUiVersion(), this.configProvider.on("configUpdated", ()=>this.updateChannelConfig());
                }
            }, rM = class {
                sendEvent(g) {
                    var _g_props;
                    this.setEnvPropertiesToEveryEvent();
                    const f = g.props, S = {};
                    var _g_props_CorrelationId;
                    switch(this.logger.info(`preparing event for delivery: ${(_g_props_CorrelationId = (_g_props = g.props) === null || _g_props === void 0 ? void 0 : _g_props.CorrelationId) !== null && _g_props_CorrelationId !== void 0 ? _g_props_CorrelationId : ""}/${g.eventName}`), this.tenant){
                        case "signaling":
                            f.SkypeId && (S.user_id = {
                                value: f.SkypeId,
                                kind: 10
                            }, S.Skype_InitiatingUser_Username = {
                                value: f.SkypeId,
                                kind: 10
                            }, S.SkypeId = {
                                value: f.SkypeId,
                                kind: 10
                            }, delete f.SkypeId), this.uiVersion && (S.ui_version = {
                                value: this.uiVersion,
                                kind: 0
                            });
                            break;
                        case "media":
                        case "tlePlayer":
                            this.uiVersion && (S.uiVersion = {
                                value: this.uiVersion,
                                kind: 0
                            });
                            break;
                        case "realtimeMedia":
                            this.uiVersion && (S["AppInfo.Version"] = {
                                value: this.uiVersion,
                                kind: 0
                            });
                    }
                    for (const g of Object.keys(f)){
                        const v = f[g];
                        var _v_value, _v_piiKind;
                        S[g] = {
                            value: (_v_value = v === null || v === void 0 ? void 0 : v.value) !== null && _v_value !== void 0 ? _v_value : v,
                            kind: (_v_piiKind = v === null || v === void 0 ? void 0 : v.piiKind) !== null && _v_piiKind !== void 0 ? _v_piiKind : 0
                        };
                    }
                    const v = {
                        name: g.eventName,
                        data: S,
                        latency: this.eventLatency,
                        persistence: Cp.Normal,
                        sync: this.configProvider.config.oneDSEventSendType
                    };
                    this.configProvider.config.smallCallTelemetry.enable && "mdsc_webrtc_call_session" === v.name && (v.sync = this.configProvider.config.smallCallTelemetry.eventSendType), this.logger.info(`about to send event ${JSON.stringify(cR.omit(v, [
                        "LocalUser",
                        "TargetUser"
                    ]))}`), this.applicationInsights.track(v);
                }
                sendStaleEvents() {
                    this.logger.info("preparing to send stalled telemetry events");
                    const g = this.applicationInsights.getPlugin(iM).plugin;
                    g._sendStale && g._sendStale(this.tenantToken);
                }
                get applicationInsights() {
                    var _this_manager_getInst;
                    return (_this_manager_getInst = this.manager.getInst(this.tenantToken)) !== null && _this_manager_getInst !== void 0 ? _this_manager_getInst : this.manager.newInst(this.tenantToken, this.instanceConfig, []);
                }
                get tenantToken() {
                    return this.configProvider.config.telemetryTenants[this.tenant];
                }
                blockNotificationListenersOnPageUnload() {
                    let g = !1;
                    const setPageUnloading = ()=>{
                        g = !0;
                    }, resetPageUnloading = ()=>{
                        g = !1;
                    };
                    window.addEventListener("beforeunload", setPageUnloading), window.addEventListener("unload", setPageUnloading), window.addEventListener("pagehide", setPageUnloading), window.addEventListener("visibilitychange", ()=>{
                        "hidden" === document.visibilityState ? setPageUnloading() : resetPageUnloading();
                    }), this.applicationInsights.getNotifyMgr().listeners.forEach((f)=>{
                        const { eventsSent: S, eventsDiscarded: v } = f;
                        S && (f.eventsSent = (f)=>{
                            g ? this.logger.info("1DS eventSent was not raised due to page unload") : S(f);
                        }), v && (f.eventsDiscarded = (f, S)=>{
                            g ? this.logger.log("1DS eventsDiscarded was not raised due to page unload") : v(f, S);
                        });
                    });
                }
                blockEventsDiscarded() {
                    this.applicationInsights.getNotifyMgr().listeners.forEach((g)=>{
                        g.eventsDiscarded = (g, f)=>{
                            this.logger.log(`1DS eventsDiscarded with reason ${f} was not raised due to configuration`);
                        };
                    });
                }
                setEnvPropertiesToEveryEvent() {
                    var _this_contextProvider, _this;
                    const g = (_this_contextProvider = (_this = this).contextProvider) === null || _this_contextProvider === void 0 ? void 0 : _this_contextProvider.call(_this);
                    if (!deepEqual(this.ctx, g) && (this.ctx = g, this.ctx)) {
                        if (this.envOverride) {
                            for (const g of Object.keys(this.envOverride || {}))if (this.ctx[g]) {
                                var _this_ctx_g_piiKind;
                                const f = (_this_ctx_g_piiKind = this.ctx[g].piiKind) !== null && _this_ctx_g_piiKind !== void 0 ? _this_ctx_g_piiKind : 0, S = convertContextProperty(this.ctx[g].value);
                                this.manager.getPropertyManager().setProperty(this.envOverride[g], {
                                    value: S,
                                    kind: f
                                });
                            }
                        } else for (const g of Object.keys(this.ctx)){
                            var _this_ctx_g_piiKind1;
                            const f = (_this_ctx_g_piiKind1 = this.ctx[g].piiKind) !== null && _this_ctx_g_piiKind1 !== void 0 ? _this_ctx_g_piiKind1 : 0, S = convertContextProperty(this.ctx[g].value);
                            this.manager.getPropertyManager().setProperty(g, {
                                value: S,
                                kind: f
                            });
                        }
                    }
                }
                constructor(g, f, S, v, _, C, E, T){
                    this.tenant = g, this.manager = f, this.logger = S, this.configProvider = v, this.uiVersion = _, this.eventLatency = C, this.contextProvider = E, this.envOverride = T, this.instanceConfig = {
                        extensions: [],
                        extensionConfig: {}
                    };
                    const { oneDSLocalStorage: I, oneDSNotificationManager: b } = this.configProvider.config;
                    b.blockEventsDiscardedNotifications && this.blockEventsDiscarded(), b.blockNotificationsOnPageUnload && this.blockNotificationListenersOnPageUnload(), I.sendStaleEvents && this.sendStaleEvents();
                }
            }, aM = class extends Error {
                constructor(g, f = 1){
                    super(g), this.callSupport = f;
                }
            };
            function createTelemetryLoggersFromConfig(g) {
                var _g_telemetryService, _g_telemetryService1;
                let f = {};
                return g.telemetryLoggers ? f = g.telemetryLoggers : ((_g_telemetryService = g.telemetryService) === null || _g_telemetryService === void 0 ? void 0 : _g_telemetryService.getGenericTelemetryLogger) && g.telemetryTenants ? Object.keys(g.telemetryTenants).forEach((S)=>f[S] = g.telemetryService.getGenericTelemetryLogger(g.telemetryTenants[S])) : g.telemetryService && (g.telemetryService.sendEvents || g.telemetryService.getCallingAdapter) && (g.telemetryService.sendEvents && (f.media = {
                    sendEvent (f) {
                        f.eventName && (f.eventName = f.eventName.replace(/^(mdsc_)/, "")), g.telemetryService.sendEvents([
                            f
                        ]);
                    }
                }, f.tlePlayer = {
                    sendEvent (f) {
                        f.eventName && (f.eventName = f.eventName.replace(/^(mdsc_)/, "")), g.telemetryService.sendEvents([
                            f
                        ]);
                    }
                }), ((_g_telemetryService1 = g.telemetryService) === null || _g_telemetryService1 === void 0 ? void 0 : _g_telemetryService1.sendRealTimeEvents) && (f.realtimeMedia = {
                    sendEvent (f) {
                        f.eventName && (f.eventName = f.eventName.replace(/^(mdsc_)/, "")), g.telemetryService.sendRealTimeEvents([
                            f
                        ]);
                    }
                }), g.telemetryService.getCallingAdapter && (f.signaling = {
                    sendEvent (f) {
                        g.telemetryService.getCallingAdapter().sendEvent(f.eventName, f.props);
                    }
                })), f;
            }
            function createTelemetryLoggersForOneDs(g, f, S, v, _, C) {
                const E = {
                    signaling: [],
                    media: [],
                    tlePlayer: [],
                    realtimeMedia: []
                };
                let T = {
                    signaling: {
                        sendEvent: (g)=>E.signaling.push(g)
                    },
                    media: {
                        sendEvent: (g)=>E.media.push(g)
                    },
                    tlePlayer: {
                        sendEvent: (g)=>E.tlePlayer.push(g)
                    },
                    realtimeMedia: {
                        sendEvent: (g)=>E.realtimeMedia.push(g)
                    }
                };
                return f.getConfigReceivedOrTimeout().then(async ()=>{
                    var _serviceUrls, _this;
                    let I = (_this = await _) === null || _this === void 0 ? void 0 : (_serviceUrls = _this.serviceUrls) === null || _serviceUrls === void 0 ? void 0 : _serviceUrls.OneDsCollectorUrl;
                    if (I = I !== null && I !== void 0 ? I : f.config.collectorUrl, I) {
                        const _ = new nM(g, f, S, f.config.eventLatency, v, I);
                        T.signaling = _.createLogger("signaling"), T.media = _.createLogger("media"), T.tlePlayer = _.createLogger("tlePlayer");
                        const C = new nM(g, f, S, f.config.eventLatencyRealTime, v, I, {
                            "UserInfo.Ring": "Ring",
                            "UserInfo.TenantId": "TenantId",
                            "AppInfo.ClientType": "client_type",
                            "UserInfo.ETag": "AppInfo.EcsEtag",
                            appversion: "First/Second Client VDI Desktop Version",
                            vdiMode: "First/Second Client VDI Mode",
                            vdiConnectedState: "First/Second Client VDI Connected State",
                            vdiShimVersion: "First/Second Client VDI Shim Version",
                            vdiProvider: "First/Second Client VDI Provider Version"
                        });
                        T.realtimeMedia = C.createLogger("realtimeMedia");
                    } else T = createTelemetryLoggersFromConfig(C);
                    for (const [g, f] of Object.entries(E))for (const S of f)T[g].sendEvent(S);
                }), T;
            }
            var sM = class _PluginlessStack extends ze {
                async initializeMediaAgent(g) {
                    var _this__config_callSettings, _this__e911;
                    if (this._mediaAgent) throw new aM("Media agent is already initialized");
                    let f, S = null;
                    if (!this._mediaAgentProvider) throw new aM("PluginlessStack initialize MediaAgent error, Media Stack not initialized", S);
                    try {
                        this._relayManagerProvider = new gi(g, this._signalingAgentProvider, this._logger), f = await this._mediaAgentProvider.buildAgent(this._config.platformType, this._relayManagerProvider, this._midCallTelemetry);
                    } catch (g) {
                        const f = g.some((g)=>"incompatible_version" === g.reason);
                        S = f ? 2 : 1;
                    }
                    if (!this._config.usePlatformSupportApi && !((_this__config_callSettings = this._config.callSettings) === null || _this__config_callSettings === void 0 ? void 0 : _this__config_callSettings.useLwjForAllCalls)) {
                        if (S) throw new aM("PluginlessStack initialization failed", S);
                        {
                            const g = (new ZA).getPlatformSupportLevel(!0);
                            if (1 !== g && 2 !== g) throw new aM("PluginlessStack initialization failed", 1);
                        }
                    }
                    f ? (this._screenSharingManager = new nR(f.getScreenSharingManager()), this._waitForAccountConfigurationTimeout = window.setTimeout(()=>{
                        this._waitForAccountConfiguration.resolve(void 0), this._waitForAccountConfigurationTimeout = void 0;
                    }, 3e4), this._oneDsTelemetryLoggers = createTelemetryLoggersForOneDs(this._logger.createChild("OneDsLogger"), f.getConfigProvider(), g.clientInformation, this._config.telemetryContextProvider, this._waitForAccountConfiguration.promise, this._config), f.getConfigProvider().config.useOneDsLogger && (this.signalingLoggerAdapter = {
                        sendEvent: (g, f)=>{
                            const S = {
                                eventName: g,
                                props: f
                            };
                            this._oneDsTelemetryLoggers.signaling.sendEvent(S);
                        }
                    }), this._mediaAgent = f, this._e911 = new eR(this._relayManagerProvider, this._mediaAgent.getConfigProvider(), this._logger.createChild("E911")), (_this__e911 = this._e911) === null || _this__e911 === void 0 ? void 0 : _this__e911.changed(()=>{
                        var _this__e911, _this__e9111;
                        this.event("e911InfoChanged").raise((_this__e911 = this._e911) === null || _this__e911 === void 0 ? void 0 : _this__e911.info, (_this__e9111 = this._e911) === null || _this__e9111 === void 0 ? void 0 : _this__e9111.areaContent);
                    })) : this._deviceManager = new Ft;
                }
                async initializeSignalingAgentProvider(g) {
                    this._trouterService = g.trouterService, this._signalingAgentProvider = lR.build(g.signalingAgentConfig, this._ecsProvider, this._config.logger, this.signalingLoggerAdapter);
                }
                static async build(g, f, S) {
                    try {
                        const v = new _PluginlessStack({
                            detectH264Support: g.mediaAgentFactoryConfig.detectH264Support,
                            domOverrides: g.mediaAgentFactoryConfig.domOverrides,
                            mediaSettings: g.mediaAgentFactoryConfig.settings,
                            logger: g.logger,
                            telemetryLoggers: g.telemetryLoggers,
                            telemetryService: g.telemetryService,
                            telemetryTenants: g.telemetryTenants,
                            telemetryContextProvider: g.telemetryContextProvider,
                            platformType: g.platformType,
                            callSettings: g.callSettings,
                            usePlatformSupportApi: g.usePlatformSupportApi,
                            clientInformation: g.signalingAgentConfig.clientInformation,
                            vdi3diagnostics: g.vdi3diagnostics
                        }, f);
                        return v.initializeMediaProvider({
                            detectH264Support: g.mediaAgentFactoryConfig.detectH264Support,
                            domOverrides: g.mediaAgentFactoryConfig.domOverrides,
                            mediaSettings: g.mediaAgentFactoryConfig.settings,
                            logger: g.mediaAgentFactoryConfig.logger,
                            safeLogger: g.mediaAgentFactoryConfig.safeLogger,
                            webcvProvider: g.mediaAgentFactoryConfig.webcvProvider,
                            wasmdnsProvider: g.mediaAgentFactoryConfig.wasmdnsProvider,
                            wasmaecProvider: g.mediaAgentFactoryConfig.wasmaecProvider,
                            wasmVqeProvider: g.mediaAgentFactoryConfig.wasmVqeProvider,
                            createWasmWorkerCbs: g.mediaAgentFactoryConfig.createWasmWorkerCbs,
                            encodedStreamsWorkerProvider: g.mediaAgentFactoryConfig.encodedStreamsWorkerProvider,
                            clientInformation: g.signalingAgentConfig.clientInformation
                        }), v.setMidCallTelemetry(S), v.initializeSignalingAgentProvider({
                            signalingAgentConfig: g.signalingAgentConfig,
                            trouterService: g.trouterService
                        }), await v.initializeMediaAgent({
                            httpRequestDispatcher: g.mediaAgentFactoryConfig.httpRequestDispatcher,
                            tokenProvider: g.mediaAgentFactoryConfig.tokenProvider,
                            configProvider: g.mediaAgentFactoryConfig.configProvider,
                            appStateProvider: g.mediaAgentFactoryConfig.appStateProvider,
                            clientInformation: g.signalingAgentConfig.clientInformation,
                            trapTokenCredentialsProvider: g.mediaAgentFactoryConfig.trapTokenCredentialsProvider,
                            relayManager: g.mediaAgentFactoryConfig.relayManager
                        }), v;
                    } catch (g) {
                        throw g instanceof aM ? g : new aM(`${g}`);
                    }
                }
                static async buildBaseStack(g, f) {
                    const S = new _PluginlessStack(g, f);
                    return S.initializeMediaProvider({
                        detectH264Support: g.detectH264Support,
                        domOverrides: g.domOverrides,
                        mediaSettings: g.mediaSettings,
                        logger: g.logger,
                        safeLogger: g.safeLogger,
                        webcvProvider: g.webcvProvider,
                        wasmdnsProvider: g.wasmdnsProvider,
                        wasmaecProvider: g.wasmaecProvider,
                        wasmVqeProvider: g.wasmVqeProvider,
                        createWasmWorkerCbs: g.createWasmWorkerCbs,
                        encodedStreamsWorkerProvider: g.encodedStreamsWorkerProvider,
                        clientInformation: g.clientInformation
                    }), S;
                }
                async init() {}
                async dispose(g = generateCauseId()) {
                    var _this__e911;
                    const f = this._logger.createFnLogger("dispose", g);
                    f.info("Dispose"), this._ecsProvider.dispose(), (_this__e911 = this._e911) === null || _this__e911 === void 0 ? void 0 : _this__e911.dispose();
                    const handleDisposeError = (g)=>{
                        f.warn("Failed:", g);
                    }, S = this.callRegistries.map((f)=>f.dispose(g).catch(handleDisposeError));
                    await Promise.all(S), await this._mediaAgentProvider.dispose(g), f.info("media agent is disposed"), this.callRegistries = [], f.info("call registries are disposed"), this._screenSharingManager && (this._screenSharingManager.dispose(g), this._screenSharingManager = void 0, f.info("screensharing manager is disposed")), this._deviceManager = void 0, super.dispose();
                }
                getCallRegistry() {
                    return this._logger.info("returning default callRegistry"), this.callRegistries[0] ? this.callRegistries[0] : this._createCallRegistry();
                }
                async createCallRegistry(g, f = generateCauseId()) {
                    const S = g ? mriOrId(g.id) : void 0, v = this._logger.createFnLogger(`createCallRegistry[identity=${S}]`, f), _ = this.callRegistries.find((f)=>f.identity === g.id);
                    return _ && !_.isDisposing ? (v.info(`callRegistry already exists for ${mriOrId(g.id)}`), _) : ((_ === null || _ === void 0 ? void 0 : _.isDisposing) && await _.disposePromise, this._createCallRegistry(g));
                }
                createCompositor(g) {
                    throw new Error("Method not implemented.");
                }
                _createCallRegistry(g) {
                    if (!this._trouterService) throw new aM("Unable to create call registry, trouter service undefined");
                    if (!this._mediaAgent) throw new aM("Unable to create call registry, media agent undefined");
                    if (!this._signalingAgentProvider) throw new aM("Unable to create call registry, signaling agent undefined");
                    const f = new ho(this._trouterService, this._signalingAgentProvider, this._mediaAgent, this._logger, createTelemetryLoggersFromConfig(this._config), this._ecsProvider, g, this._oneDsTelemetryLoggers, this._config.vdi3diagnostics);
                    return f.on("disposed", ()=>{
                        this.callRegistries.splice(this.callRegistries.indexOf(f), 1);
                    }), f.on("accountConfigurationReceived", (g)=>{
                        this._waitForAccountConfiguration.isPending && (this._waitForAccountConfiguration.resolve(g), window.clearTimeout(this._waitForAccountConfigurationTimeout)), this._relayManagerProvider.getOrCreateRelayManager().setDefaultRelayConfig(g.relayConfig), this._relayManagerProvider.getOrCreateRelayManager().setClientSupportsGenericTokenApi(g.clientSupportsGenericTokenAPI);
                    }), f.on("locationInfoSet", (g, f)=>{
                        var _this__e911;
                        (_this__e911 = this._e911) === null || _this__e911 === void 0 ? void 0 : _this__e911.setClientInfo(g, f);
                    }), this._relayManagerProvider.getOrCreateRelayManager(), this.callRegistries.push(f), f;
                }
                initializeMediaProvider(g) {
                    const f = (0, $e.assign)({}, g);
                    this._mediaAgentProvider = new QA(f, this._ecsProvider, this.platformCallConstraintsProvider), this._deviceManager = new fo(this._mediaAgentProvider.getDeviceManager());
                }
                setMidCallTelemetry(g) {
                    this._midCallTelemetry = g;
                }
                getDeviceManager() {
                    return this._deviceManager;
                }
                async getDeviceManagerAsync() {
                    return this._deviceManager;
                }
                createDeviceManager(g) {
                    return this._deviceManager;
                }
                getScreenSharingManager() {
                    return this._screenSharingManager;
                }
                getSetup() {}
                getEcsProvider() {
                    return this._ecsProvider;
                }
                async getEcsProviderAsync() {
                    return this._ecsProvider;
                }
                getCallFeedback() {
                    return null;
                }
                getAiMdp() {
                    return null;
                }
                fireIntent(g, f) {}
                getVersion() {
                    return {
                        build: getTsCallingVersion(),
                        ovb: getOvb()
                    };
                }
                async getVersionAsync() {
                    return {
                        build: getTsCallingVersion(),
                        ovb: getOvb()
                    };
                }
                getMediaStatus() {
                    return null;
                }
                getVideoCapabilityLimits() {
                    return null;
                }
                async setMediaConfig(g) {
                    this._mediaAgent.setMediaConfig(g);
                }
                async getE911Info() {
                    var _this__e911;
                    return (_this__e911 = this._e911) === null || _this__e911 === void 0 ? void 0 : _this__e911.getInfo();
                }
                setPlatformCallConstraints(g) {
                    this.platformCallConstraintsProvider.setConstraints(g);
                }
                getPlatformSupportLevel() {
                    return this._platformManager.getPlatformSupportLevel(!!this._mediaAgent);
                }
                getLiveStreamClient() {
                    const getTelemetryLogger = ()=>createTelemetryLoggersFromConfig(this._config).tlePlayer;
                    return new Lt(this._ecsProvider.createEcsConfiguration(), this._logger.createChild("LiveStreamClient"), getTelemetryLogger);
                }
                createVoipCallCoordinator() {}
                async setLogFileName(g, f, S) {
                    throw new Error("not supported");
                }
                aggregateDiagnosticLogs(g) {
                    return Promise.reject("not supported");
                }
                submitBrbReport(g, f) {
                    return Promise.reject("not supported");
                }
                extendBrbFeedback(g, f) {
                    return Promise.reject("not supported");
                }
                async addOcclusion(g, f, S, v, _, C) {}
                async removeOcclusion(g, f, S, v) {}
                async flushLogs() {
                    throw new Error("not supported");
                }
                getDebugDump() {
                    return this._mediaAgent && maskSensitiveData(JSON.stringify(this._mediaAgent.getDiagnosticsData()), '"(redacted)",');
                }
                async getStageCapability() {
                    throw new Error("not supported");
                }
                async getAiCameraCapability() {
                    throw new Error("not supported");
                }
                createAiCameraManager() {
                    throw new Error("not supported");
                }
                async disposeMediaAgent(g = generateCauseId()) {
                    var _this__mediaAgent;
                    if (!this._mediaAgent) throw new aM("_mediaAgent is not initialized");
                    await ((_this__mediaAgent = this._mediaAgent) === null || _this__mediaAgent === void 0 ? void 0 : _this__mediaAgent.dispose(g)), this._mediaAgent = null;
                }
                async updateSignalingAgentProviderConfig(g) {
                    if (!this._signalingAgentProvider) throw new aM("_signalingAgentProvider not initialized");
                    this._trouterService = g.trouterService, this._signalingAgentProvider.getSignalingAgent().updateSignalingAgentConfig(g.signalingAgentConfig);
                }
                constructor(g, f){
                    super(), this._config = g, this._ecsProvider = f, this.callRegistries = [], this._logger = new je(this._config.logger).createChild("PluginlessStack"), this._platformManager = new ZA, this._waitForAccountConfiguration = new ct, this.platformCallConstraintsProvider = new ti(this._logger.createChild("PlatformConstraintsProvider"));
                }
            }, oM = {
                build (g, f = !0) {
                    var _g_telemetryContextProvider;
                    const S = (_g_telemetryContextProvider = g.telemetryContextProvider) === null || _g_telemetryContextProvider === void 0 ? void 0 : _g_telemetryContextProvider.call(g), v = new tR(S), _ = new Io;
                    return f && initLogger(g, v, _), sM.build(g, v, _);
                },
                buildBaseStack (g) {
                    var _g_telemetryContextProvider;
                    const f = (_g_telemetryContextProvider = g.telemetryContextProvider) === null || _g_telemetryContextProvider === void 0 ? void 0 : _g_telemetryContextProvider.call(g), S = new tR(f);
                    return sM.buildBaseStack(g, S);
                },
                getVersion: ()=>({
                        build: getTsCallingVersion(),
                        ovb: getOvb()
                    })
            };
            /*! Bundled license information:

	@nevware21/ts-utils/dist/es5/mod/ts-utils.js:
	  (*! https://github.com/nevware21/ts-utils v0.11.3 *)

	@nevware21/ts-async/dist/es5/mod/ts-async.js:
	  (*!
	   * NevWare21 Solutions LLC - ts-async, 0.5.2
	   * https://github.com/nevware21/ts-async
	   * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
	   * Licensed under the MIT license.
	   *)
	*/ if ("object" == typeof _.exports && "object" == typeof v) {
                var __cp = (g, f, S, v)=>{
                    if (f && "object" == typeof f || "function" == typeof f) for (let _ of Object.getOwnPropertyNames(f))Object.prototype.hasOwnProperty.call(g, _) || _ === S || Object.defineProperty(g, _, {
                        get: ()=>f[_],
                        enumerable: !(v = Object.getOwnPropertyDescriptor(f, _)) || v.enumerable
                    });
                    return g;
                };
                _.exports = __cp(_.exports, v);
            }
            return _.exports;
        });
    }), M = {
        BAD_REQUEST: 400,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        METHOD_NOT_ALLOWED: 405,
        REQUEST_TIMEOUT: 408,
        CONFLICT: 409,
        MEDIA_ERROR: 410,
        PRECONDITION_FAILED: 412,
        UNSUPPORTED_MEDIA_TYPE: 415,
        UNPROCESSABLE_ENTITY: 422,
        INTERNAL_ERROR: 500,
        NOT_IMPLEMENTED: 501
    };
    const O = {
        CALL_CLIENT: {
            INIT_CALL_CLIENT: {
                message: "Failed to initialize CallClient. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",
                code: 500,
                subCode: 4e4,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CREATE_CALL_AGENT: {
                message: "Failed to create CallAgent. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",
                code: 409,
                subCode: 40001,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CREATE_TEAMS_CALL_AGENT: {
                message: "Failed to create TeamsCallAgent. Please try again, if issue persists, gather browser console logs, and contact Azure Communication Services support.",
                code: 409,
                subCode: 40002,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            RELAY_INFO: {
                message: "Failed to create a URL object with the ICE server URL provided.",
                code: 400,
                subCode: 40003,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            RELAY_UNRECOGNIZED_SCHEMA: {
                message: "The ICE server url must contain 'turn', 'turns', or 'stun'.",
                code: 400,
                subCode: 40004,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PROXY_SHORT_URL: {
                message: "Failed setup proxy, the url is too short",
                code: 400,
                subCode: 40005,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PROXY_PROTOCOL: {
                message: "Failed setup proxy, the protocol is not https or http",
                code: 400,
                subCode: 40006,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SETUP_PROXY: {
                message: "Failed to create a URL object with the proxy URL provided.",
                code: 400,
                subCode: 40007,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ONE_CALL_AGENT_PER_CALL_CLIENT: {
                message: "CallClient instance can support only one CallAgent or TeamsCallAgent create new CallClient instance to create new CallAgent or TeamsCallAgent",
                code: 400,
                subCode: 40008,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EMERGENCY_CODE_TOO_LONG: {
                message: "EmergencyCountryCode is invalid, max length is 10",
                code: 400,
                subCode: 40009,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        CALL_STACK: {
            BAD_PROTOCOL: {
                message: "ACS Web Calling SDK must be used through https, file:, or localhost",
                code: 400,
                subCode: 40100,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            BASE_STACK_INIT_TIMEOUT: {
                message: "Failed to create CallAgent, timeout during initialization of the calling base stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 408,
                subCode: 40101,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            BASE_STACK_INIT_FAILED: {
                message: "Failed to create CallAgent, failure during initialization of the calling base stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40102,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_NO_BASE_STACK: {
                message: "Failed to create CallAgent, failure to initialize calling user stack because calling base stack failed to create. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40103,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_INIT_TIMEOUT: {
                message: "Failed to create CallAgent, timeout during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 408,
                subCode: 40104,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_INIT_FAILED: {
                message: "Failed to create CallAgent, failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40105,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            PARSE_CONFIG: {
                message: "Failed to set configurations for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40106,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_STACK_CONFIG: {
                message: "Failed to set user configurations for calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40107,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_DM: {
                message: "Failed to get device manager due to internal call stack undefined. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40108,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_STACK_PARAMS: {
                message: "Failed to set configuration parameters for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40109,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            FOUND_UNDEFINED_CONFIGS: {
                message: "Fetched undefined configurations for the calling stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40110,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SIGNALING_SERVICE_CREATE_FAIL: {
                message: "Failed to connect to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40111,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SIGNALING_INIT_FAIL: {
                message: "Failed to initialize connection to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40112,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SIGNALING_SERVICE_ALREADY_INITIALIZED: {
                message: "Already connected to Azure Communication Services infrastructure. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40113,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SIGNALING_SERVICE_CREATE_TIMEOUT: {
                message: "Failed to connect to Azure Communication Services infrastructure, timeout during initialization. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 408,
                subCode: 40114,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SIGNALING_UNINITIALIZED: {
                message: "Failed to create CallAgent, unable to initialize connection to Azure Communication Services infrastructure. Please try again and check the browser's network requests. If the requests keep failing, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 412,
                subCode: 40115,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_MEDIA_INIT_FAILED: {
                message: "Failed to create CallAgent, media failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40116,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_SIGNALING_INIT_FAILED: {
                message: "Failed to create CallAgent, signaling failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40117,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_INTERNAL_INIT_FAILED: {
                message: "Failed to create CallAgent, internal stack failure during initialization of the calling user stack. Please try again, if issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 40118,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            USER_STACK_MEDIA_INIT_FAILED_PLATFORM_NOT_SUPPORTED: {
                message: "Media stack is not supported on this platform",
                code: 400,
                subCode: 40119,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        CALL_AGENT: {
            PROXY_CUSTOM_TURN_FORBIDDEN: {
                message: "Using proxy or custom TURN for calls involving Teams is disabled",
                code: 403,
                subCode: 40200,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_ACCESSTOKEN: {
                message: "Failed to parse AccessToken",
                code: 500,
                subCode: 40201,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CANT_CALL_YOURSELF: {
                message: "Call to yourself is not supported.",
                code: 400,
                subCode: 40202,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACS_ALREADY_DISPOSED: {
                message: "Call Agent is already disposed",
                code: 409,
                subCode: 40203,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CTE_ALREADY_DISPOSED: {
                message: "Teams Call Agent is already disposed",
                code: 409,
                subCode: 40204,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to CallAgent event, unknown event name.",
                code: 422,
                subCode: 40205,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from CallAgent event, unknown event name.",
                code: 422,
                subCode: 40206,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MESH_DEVICETYPE_V2: {
                message: "Device type must be msft-acs-mesh-deviceType-v2 to join immersive call",
                code: 400,
                subCode: 40207,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STACK_NOT_INIT: {
                message: "Failed to start or join call, call stack did not initialize",
                code: 500,
                subCode: 40208,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INVALID_JOIN_LOCATOR: {
                message: "Invalid join locator specified.",
                code: 400,
                subCode: 40209,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_MEETING_LINK: {
                message: "The provided Teams meeting link is invalid.",
                code: 400,
                subCode: 40210,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            GROUPCALL_THREADID: {
                message: "Starting a group call must include thread ID in StartTeamsGroupCallOptions.",
                code: 400,
                subCode: 40212,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ONE_TO_ONE_THREADID: {
                message: "Starting a one to one with thread ID is invalid.",
                code: 400,
                subCode: 40213,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CTE_DISPLAY_NAME: {
                message: "Display name is not allowed to be set for Teams users.",
                code: 400,
                subCode: 40214,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            DISPLAY_NAME_TOO_LONG: {
                message: "Display name is too long.",
                code: 400,
                subCode: 40215,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INIT_FAIL: {
                message: "Failed to create CallAgent. Please try again, if issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 40216,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_TOKEN_BEFORE_INIT: {
                message: "Attempted to get AccessToken before initialization",
                code: 422,
                subCode: 40217,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INVALID_PUSH_NOTIFICATION_DATA: {
                message: "Invalid push notification data provided. No 'incomingCallContext' key found in the PushNotificationData.",
                code: 400,
                subCode: 40218,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PUSH_NOTIFICATION_FAIL: {
                message: "Failed to handle push notification",
                code: 500,
                subCode: 40219,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_PAYLOAD_TOO_MANY_KEYS: {
                message: "Incoming Call push notification payload provided has too many keys. Only 'incomingCallContext' key is expected in the PushNotificationData.",
                code: 400,
                subCode: 40220,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD_NO_CONTEXT_PROVIDED: {
                message: "Invalid push notification data provided. No 'incomingCallContext' key found in the PushNotificatitonData.",
                code: 400,
                subCode: 40221,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD: {
                message: "The decoded 'incomingCallContext' data is invalid.",
                code: 400,
                subCode: 40222,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_ALREADY_PROCESSED: {
                message: "Incoming Call is already being processed",
                code: 400,
                subCode: 40223,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_FAILED_TO_PROCESS: {
                message: "Failed to handle Incoming Call push notification",
                code: 500,
                subCode: 40224,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INCOMING_PUSH_NOTIFICATION_CALL_MISSED: {
                message: "Missed call",
                code: 400,
                subCode: 40225,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            USERIDS_MUST_BE_OBJECTS: {
                message: "AssertIsObject failed. : userIds must be object",
                code: 400,
                subCode: 40226,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            USERIDS_CANNOT_BE_NULL: {
                message: "AssertNotNull failed. : userIds cannot be null",
                code: 400,
                subCode: 40227,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACS_CALLAGENT_ALREADY_EXSISTS: {
                message: "Failed to create CallAgent, an instance of CallAgent associated with this identity already exists. Please dispose the existing CallAgent, or create a new one with a different identity.",
                code: 409,
                subCode: 40228,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACS_CALLAGENT_TOKEN_ONLY: {
                message: "CallAgent must be created only with ACS token",
                code: 403,
                subCode: 40229,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            TEAMS_CALLAGENT_ALREADY_EXSISTS: {
                message: "Failed to create TeamsCallAgent, an instance of TeamsCallAgent associated with this identity already exists. Please dispose the existing TeamsCallAgent before creating a new one.",
                code: 409,
                subCode: 40230,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            TEAMS_CALLAGENT_TOKEN_ONLY: {
                message: "TeamsCallAgent must be created only with Teams token",
                code: 403,
                subCode: 40231,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            FAILED_TO_GET_TOKEN: {
                message: "Failed to get token",
                code: 409,
                subCode: 40232,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            REFRESHED_TOKEN_INVALID_USERID: {
                message: "Refreshed AccessToken User Id doesnt match initial User Id.",
                code: 400,
                subCode: 40233,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            REFRESHED_TOKEN_RETRIES: {
                message: "Access token is expired and failed to fetch a valid one after retries.",
                code: 400,
                subCode: 40234,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACCESSTOKEN_EXPIRED: {
                message: "AccessToken expired",
                code: 401,
                subCode: 40235,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNSUPPORTED_TARGET_TYPE: {
                message: "Unsupported target participant type in ACS-Teams call",
                code: 400,
                subCode: 40236,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNSUPPORTED_TFL_MEETING_JOIN: {
                message: "Joining a Teams for life meeting is not supported",
                code: 400,
                subCode: 40238,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SET_DEVICE_TYPE_NOT_ALLOWED: {
                message: "setDeviceType is not allowed",
                code: 500,
                subCode: 40239,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        DEVICE_MANAGER: {
            GET_MEDIA_STREAM_TRACK: {
                message: "Failed to get raw device stream track",
                code: 500,
                subCode: 40600,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_MEDIA_STREAM_DEVICE_UNAVAILABLE: {
                message: "Failed to get raw device stream track, make sure there is available device",
                code: 412,
                subCode: 40601,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_DM: {
                message: "Failed to get device manager.",
                code: 500,
                subCode: 40602,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to DeviceManager event, unknown event name.",
                code: 422,
                subCode: 40603,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from DeviceManager event, unknown event name.",
                code: 422,
                subCode: 40604,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACCESS_DM: {
                message: "Unable to access device manager",
                code: 500,
                subCode: 40605,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SPEAKER_ENUMERATION_UNSUPPORTED: {
                message: "Failed to enumerate speakers, it is not supported to enumerate/select speakers on Android Chrome, iOS Safari, nor MacOS Safari.",
                code: 405,
                subCode: 40606,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SELECT_MICROPHONE_TIMEOUT: {
                message: "Microphone selection timed out.",
                code: 408,
                subCode: 40607,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SELECT_MICROPHONE_FAIL: {
                message: "There was an issue with selecting the microphone",
                code: 500,
                subCode: 40608,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SELECT_SPEAKER_TIMEOUT: {
                message: "Speaker selection timed out.",
                code: 408,
                subCode: 40609,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SELECT_SPEAKER_FAIL: {
                message: "There was an issue with selecting the speaker",
                code: 500,
                subCode: 40610,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SPEAKER_SELECTION_UNSUPPORTED: {
                message: "This device does not support speaker selection.",
                code: 405,
                subCode: 40611,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ONE_PERMISSION_ATLEAST: {
                message: "At least one permission must be requested",
                code: 400,
                subCode: 40612,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PERMISSION_NOT_GRANTED_OR_FAILED: {
                message: "Failed to obtain permission to use microphone and/or camera, it was denied or it failed. Please ensure to allow the permissions in the browser's setttings and in the OS setttings.",
                code: 400,
                subCode: 40613,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ADP_FAIL: {
                message: "Failed to ask for device permissions Please ensure to allow the permissions in the browser's setttings and in the OS setttings and try again. If issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 40614,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INVALID_DEVICE: {
                message: "Invalid AudioDeviceInfo object passed in. Ensure it has an Id.",
                code: 400,
                subCode: 40615,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            DEVICE_NOT_SELECTABLE: {
                message: "The device is not selectable",
                code: 400,
                subCode: 40616,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            DEVICE_ENUMERATING_FAIL: {
                message: "Failed to enumerate device.",
                code: 500,
                subCode: 40617,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        CALL: {
            OPERATION_NOT_ALLOWED_DURING_EMERGENCY_CALL: {
                message: "Attempted invalid operation during Emergency Call.",
                code: 500,
                subCode: 41e3,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            OPERATION_FAILED: {
                message: "{0} failed",
                code: 500,
                subCode: 41001,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            REMOTE_AUDIO_GET_MEDIA_STREAM_UNDEFINED: {
                message: "Unable to get remote audio stream, getMediaStream returned undefined",
                code: 500,
                subCode: 41002,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            REMOTE_AUDIO_GET_MEDIA_STREAM_RETURNED_ERROR: {
                message: "Unable to get remote audio stream, getMediaStream returned error",
                code: 500,
                subCode: 41003,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            REMOTE_AUDIO_GET_MEDIA_STREAM_DISABLED: {
                message: "Getting raw audio media stream is currently disabled by Azure Communication Services.",
                code: 409,
                subCode: 41004,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACCEPT_INCOMING_CALL: {
                message: "Failed to accept the Incoming Call",
                code: 500,
                subCode: 41005,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            ACCEPT_NOT_RINGING: {
                message: "Failed to accept the incoming call, it is not in the Ringing state. Subcscribe to CallAgent's 'incomingCall' event to accept the incoming call.",
                code: 400,
                subCode: 41006,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            REJECT_NOT_RINGING: {
                message: "Failed to reject the incoming call, it is not in the Ringing state. Subcscribe to CallAgent's 'incomingCall' event to reject the incoming call.",
                code: 400,
                subCode: 41007,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            LOCAL_AUDIO_GET_MEDIA_STREAM: {
                message: "Failed to get raw stream from local audio stream",
                code: 500,
                subCode: 41008,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LOCAL_AUDIO_SET_MEDIA_STREAM: {
                message: "Failed to set raw input audio stream",
                code: 500,
                subCode: 41009,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LOCAL_AUDIO_UNSET_MEDIA_STREAM: {
                message: "Failed to unset raw input audio stream",
                code: 500,
                subCode: 41010,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LOCAL_AUDIO_UNDEFINED_STACK: {
                message: "Failed to process audio because the calling stack is undefined. Please collect browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41011,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            REMOVE_LOCAL_VIDEO_ON_BAD_UFD: {
                message: "Removing local video stream due to video fail UFD being raised before call connected. Please ensure to allow video permissions in the browser's setttings and in the OS setttings, and ensure the camera device is not being used by another process.",
                code: 409,
                subCode: 41012,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            STOP_AUDIO_ON_BAD_UFD: {
                message: "Failed to stop audio on microphone device not functioning or capture mute event {0} with value {1}",
                code: 400,
                subCode: 41013,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INSTANTIATE_CALL: {
                message: "Failed to instantiate the Call",
                code: 500,
                subCode: 41014,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MIC_MUTE: {
                message: "Failed to mute microphone. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41015,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MIC_UNMUTE: {
                message: "Failed to unmute microphone. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 400,
                subCode: 41016,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MIC_UNMUTE_AND_STARTAUDIO: {
                message: "Failed to recover the microphone audio after bad microphone UFD recovered. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 410,
                subCode: 41017,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MUTE_ALL_PARTICIPANTS_DISABLED: {
                message: "Mute other participants is currently disabled by ACS service.",
                code: 403,
                subCode: 41018,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_ALL_PARTICIPANTS: {
                message: "Failed to mute all remote participants",
                code: 500,
                subCode: 41019,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MUTE_INCOMING_AUDIO: {
                message: "Failed to mute incoming audio",
                code: 500,
                subCode: 41020,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            UNMUTE_INCOMING_AUDIO: {
                message: "Failed to unmute incoming audio",
                code: 500,
                subCode: 41021,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            DTMF_TONE: {
                message: "Failed to send DTMF tone",
                code: 400,
                subCode: 41022,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            INVALID_DTMF_TONE: {
                message: "Invalid value passed to DtfmTone",
                code: 422,
                subCode: 41023,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            START_AUDIO_BEFORE_VIDEO: {
                message: "Failed to start audio before starting video",
                code: 500,
                subCode: 41024,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            STREAM_NULL: {
                message: "Failed to start video, LocalVideoStream instance is invalid or empty. Please pass in a LocalVideoStream instance.",
                code: 400,
                subCode: 41025,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STREAM_IS_NOT_LVS: {
                message: "Failed to start video, localVideoStream is not an instance of LocalVideoStream",
                code: 400,
                subCode: 41026,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIDEO_ALREADY_ON: {
                message: "Failed to start video, video is already started.",
                code: 400,
                subCode: 41027,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIDEO_SET_MEDIA_STREAM: {
                message: "Failed to set media stream",
                code: 500,
                subCode: 41028,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            START_VIDEO: {
                message: "Failed to start video",
                code: 500,
                subCode: 41029,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VIDEO_ALREADY_OFF: {
                message: "Failed to stop video, video is already stopped.",
                code: 400,
                subCode: 41030,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIDEO_UNDEFINED_STACK: {
                message: "Failed to start video because the calling stack is undefined. Please gether browser console logs, .HAR files, and contact Aure Communication Services support.",
                code: 500,
                subCode: 41031,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            STOP_WRONG_STREAM: {
                message: "Failed to stop video, invalid argument. LocalVideoStream used as an input is currently not being sent.",
                code: 400,
                subCode: 41032,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            HOLD_CALL: {
                message: "Failed to hold the call. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41033,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            RESUME_CALL: {
                message: "Failed to resume the call.Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41034,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SS_ALREADY_ON: {
                message: "Failed to start screen share, screen share is already started.",
                code: 400,
                subCode: 41035,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SS_RAW_STREAM_IS_NOT_LVS: {
                message: "Failed to start raw screen sharing, localVideoStream is not an instance of LocalVideoStream",
                code: 400,
                subCode: 41036,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SS_RAW_STREAM_UNDEFINED: {
                message: "Unable to get media stream from local video stream for raw media screen sharing. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41037,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SS_RAW_STREAM_SET: {
                message: "Failed to set raw media stream for screen sharing. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 422,
                subCode: 41038,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SS_RAW_STREAM_GET: {
                message: "Failed to get raw screen sharing stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 422,
                subCode: 41039,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            START_SS: {
                message: "Failed to start screen sharing",
                code: 500,
                subCode: 41040,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SS_ALREADY_OFF: {
                message: "Failed to stop screen share, screen share is already stopped.",
                code: 400,
                subCode: 41041,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to Call event, unknown event name.",
                code: 422,
                subCode: 41042,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from Call event, unknown event name.",
                code: 422,
                subCode: 41043,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ONLY_SINGLE_VIDEO_STREAM: {
                message: "Only single LocalVideoStream is supported currently",
                code: 400,
                subCode: 41044,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            NOT_INSTANCE_OF_LVS: {
                message: "Stream is not an instance of LocalVideoStream",
                code: 400,
                subCode: 41045,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ONLY_SINGLE_AUDIO_STREAM: {
                message: "Only single LocalAudioStream is supported currently",
                code: 400,
                subCode: 41046,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            NOT_INSTANCE_OF_LAS: {
                message: "Stream is not an instance of LocalAudioStream",
                code: 400,
                subCode: 41047,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIDEO_FAILED_TO_START: {
                message: "Failed to start video during call setup process. Please ensure to allow video permissions in the browser's setttings and in the OS setttings, and ensure the camera device is not being used by another process.",
                code: 410,
                subCode: 41048,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            AUDIO_FAILED_TO_START: {
                message: "Failed to start audio during call setup process. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 400,
                subCode: 41049,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LARGE_MEETING_FORCE_ISAVAILABLE: {
                message: "Failed to force isAvailable flag to false during large meeting",
                code: 500,
                subCode: 41050,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LARGE_MEETING_DISPOSE_VIEW: {
                message: "Failed to dispose view in large meeting",
                code: 500,
                subCode: 41051,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            ADD_UNKNOWN: {
                message: "Not able to add unkown participant.",
                code: 400,
                subCode: 41052,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARTICIPANT_ALREADY_IN_CALL: {
                message: "Participant is already in the call.",
                code: 400,
                subCode: 41053,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARTICIPANT_NOT_IN_CALL: {
                message: "Failed to remove the specified participant. The participant is not in the call.",
                code: 400,
                subCode: 41054,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CTE_ADDPARTICIPANT_NO_THREAD_ID: {
                message: "Add participant failed: thread ID is missing in options.",
                code: 400,
                subCode: 41055,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CTE_VOICE_NOT_ENABLED: {
                message: "Failed to start or join to the call, Teams Enterprise voice policy is not enabled for this Azure Communication Services resource. Follow the tutorial online to enable it.",
                code: 412,
                subCode: 41056,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SERVER_CALL_ID: {
                message: "Failed to get server call Id",
                code: 500,
                subCode: 41057,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VOLUME_TRACK: {
                message: "Failed to get the MediaStream to initialize the Volume indicator. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41058,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VOLUME_INIT: {
                message: "Failed to setup volume calcualtor using AudioContext, please retry getVolumeindicator on a working audio stream with exponential backoff",
                code: 500,
                subCode: 41059,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VOLUME_EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to Volume Indicator event, unknown event name.",
                code: 400,
                subCode: 41060,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VOLUME_EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from Volume Indicator event, unknown event name.",
                code: 400,
                subCode: 41061,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VOLUME_GET: {
                message: "Failed to setup volume calculator, please retry after exponential backoff",
                code: 500,
                subCode: 41062,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_SERVER_CALL_ID: {
                message: "Failed to get serverCallId, serverCallId is empty",
                code: 404,
                subCode: 41063,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MEDIA_CONSTRAINTS_DISABLED: {
                message: "Setting call constraint is currently disabled by ACS service.",
                code: 409,
                subCode: 41064,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SET_CONSTRAINTS_START_OR_ACCEPT: {
                message: "Error setting call constraints at call setup. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41065,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_CONSTRAINTS_MID_CALL: {
                message: "Error setting call constraints during mid-call",
                code: 500,
                subCode: 41066,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_CONSTRAINTS: {
                message: "Error settting video constraints during call settup or mid-call. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41067,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            ACCEPT_VIDEO_CONSTRAINTS: {
                message: "Error setting video constraints during call accept",
                code: 500,
                subCode: 41068,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CALLSTART_VIDEO_CONSTRAINTS: {
                message: "Error setting video constraints during call start",
                code: 500,
                subCode: 41069,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_VIDEO_CONSTRAINTS: {
                message: "Failed to set call constraints during mid call",
                code: 500,
                subCode: 41070,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            START_SS_CALL_NOT_CONNECTED: {
                message: "Failed to start screen share, call is not in Connected state. Subscribe to the Call's 'statteChanged' event to know when the call is connected.",
                code: 412,
                subCode: 41071,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STOP_SS_CALL_NOT_CONNECTED: {
                message: "Failed to stop screen sharing. Call must be in connected state",
                code: 412,
                subCode: 41072,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACCESS_RAW_MEDIA_STREAM_DISABLED: {
                message: "Failed to get or set custom MediaStream, this functionality is currently disabled by Azure Communication Services.",
                code: 412,
                subCode: 41073,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ACCESS_RAW_MEDIA_STREAM_UNDEFINED_FUNC: {
                message: "The raw media stream function is currently not available",
                code: 500,
                subCode: 41074,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SS_RAW_STREAM_LVS_IS_NOT_RAW_MEDIA: {
                message: "Failed to start raw screen sharing, localVideoStream doesn't contain a raw media stream",
                code: 400,
                subCode: 41075,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            START_AUDIO_STREAM_FAILED: {
                message: "Failed to start audio stream.",
                code: 400,
                subCode: 41076,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            STOP_VIDEO_FAILED: {
                message: "Failed to stop video.",
                code: 500,
                subCode: 41077,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            START_AUDIO_LAS_NOT_RAW_MEDIA: {
                message: "Failed to start raw audio, localAudioStream doesn't contain a raw media stream. To start raw audio, the LocalAudioStream passed in, must be constructed with a MediaStream object.",
                code: 400,
                subCode: 41083,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STOP_AUDIO_LAS_NOT_RAW_MEDIA: {
                message: "Failed to stop raw audio, localAudioStream doesn't contain a raw media stream. To stop raw audio, the current LocalAudioStream in the call must have a MediaStream as the source.",
                code: 400,
                subCode: 41084,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            TEAMS_INVALID_THREAD_ID: {
                message: "Thread ID is invalid.",
                code: 400,
                subCode: 41085,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_ALL_PARTICIPANTS_PSTN_UNSUPPORTED: {
                message: "Failed to mute ineligible PSTN remote participants.",
                code: 405,
                subCode: 41086,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_ALL_PARTICIPANTS_CALL_NOT_CONNECTED: {
                message: "Failed to mute all remote participants. Call must be in connected state",
                code: 412,
                subCode: 41087,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STOP_AUDIO_STREAM_CALL_NOT_CONNECTED: {
                message: "Failed to stop audio stream. Call must be in connected state",
                code: 412,
                subCode: 41088,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ADD_PARTICIPANT_CALL_NOT_CONNECTED: {
                message: "Failed to add participant. Call must be in connected state",
                code: 412,
                subCode: 41089,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            REMOVE_PARTICIPANT_CALL_NOT_CONNECTED: {
                message: "Failed to remove participant. Call must be in connected state",
                code: 412,
                subCode: 41090,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STOP_AUDIO_STREAM_FAILED: {
                message: "Failed to stop audio stream.",
                code: 400,
                subCode: 41091,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MUTE_ALL_PARTICIPANTS_NONCONNECTED_UNSUPPORTED: {
                message: "Failed to mute remote participants that are not in connected state.",
                code: 405,
                subCode: 41092,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_ALL_PARTICIPANTS_1_TO_1_UNSUPPORTED: {
                message: "Failed to mute remote participants as mute others in 1-1 calls are unsupported.",
                code: 405,
                subCode: 41093,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            IP_AUDIO_NOT_ALLOWED: {
                message: "Failed to mute/unmute as VOIP Audio is not allowed in this call.",
                code: 403,
                subCode: 41104,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            IP_VIDEO_NOT_ALLOWED: {
                message: "Failed to start/stop video as VOIP Video is not allowed in this call.",
                code: 403,
                subCode: 41105,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MIC_DISABLED: {
                message: "Failed to unmute as mic is disabled in this call.",
                code: 403,
                subCode: 41106,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CAMERA_DISABLED: {
                message: "Failed to start video as camera is disabled in this call.",
                code: 403,
                subCode: 41107,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNMUTE_CONSENT_RESTRICTED: {
                message: "Unmute operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",
                code: 400,
                subCode: 41108,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIDEOSTART_CONSENT_RESTRICTED: {
                message: "Video start operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",
                code: 400,
                subCode: 41109,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SCREENSHARE_CONSENT_RESTRICTED: {
                message: "Screen Share operation not allowed for participants that have not provided consent for recording or transcription as explicit consent is enabled.",
                code: 400,
                subCode: 41110,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CONSENT_NOT_SUPPORTED_1TO1: {
                message: "Bad request. Explicit consent is not supported for 1:1 calls.",
                code: 400,
                subCode: 41111,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            FAILED_TO_SET_CONSENT: {
                message: "Failed to set user consent publish state. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 41112,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            CONSENT_ALREADY_SET_OR_NOT_REQUIRED: {
                message: "Bad request. Consent for recording or transcription is either already provided or it is not required for the call.",
                code: 400,
                subCode: 41113,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        LOBBY: {
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to Lobby event, unknown event name.",
                code: 422,
                subCode: 41800,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from Lobby event, unknown event name.",
                code: 422,
                subCode: 41801,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CONV_UNSUPPORTED: {
                message: "Current conversation type doesn't support lobby admit and reject",
                code: 400,
                subCode: 41802,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            ALREADY_IN_MEETING: {
                message: "Participant is already in the meeting.",
                code: 400,
                subCode: 41803,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            NOT_IN_LOBBY: {
                message: "Participant is not in the lobby.",
                code: 400,
                subCode: 41804,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNAUTHORIZED_ADMIT_REJECT: {
                message: "only Organizer, Co-organizer or Presenter can admit/reject participants from lobby",
                code: 403,
                subCode: 41805,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        CTE_MID_TIER_POLICY_SERVICE: {
            TEAMS_USER_ID_NOT_PROVIDED: {
                message: "Failed to fetch Teams user policies and settings cannot proceed, because teams user Id was not found in the AccessToken.",
                code: 400,
                subCode: 41900,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            FETCH_POLICY: {
                message: "Error Fetching Teams user policy from ACS MiddleTier Service",
                code: 500,
                subCode: 41901,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            DERIVE_EMERGENCY_POLICY: {
                message: "Unable to derive emergency policy from ACS MiddleTier Service response",
                code: 500,
                subCode: 41902,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            TEAMSUSER_CALLINGPOLICY_FETCHING_FAILED: {
                message: "Unable to fetch Teams calling policy from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 41903,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            TEAMSUSER_MEETINGPOLICY_FETCHING_FAILED: {
                message: "Unable to fetch Teams meeting policy from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 41904,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            TEAMSUSER_FEATURETYPE_TEAMSPROMGMT_FETCHING_FAILED: {
                message: "Unable to fetch feature types from ACS MiddleTier Service response. Please try again, if the issue persists, gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                code: 500,
                subCode: 41905,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            CREATETHREAD_FAILED: {
                message: "Unable to create thread for the Teams User groupcall from ACS MiddleTier Service response",
                code: 500,
                subCode: 41906,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            ADD_PARTICIPANTS_TO_THREAD_FAILED: {
                message: "Unable to add particpant for the thread for Teams groupcall from ACS MiddleTier Service",
                code: 500,
                subCode: 41907,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            }
        },
        REMOTE_PARTICIPANT: {
            MUTE_PARTICIPANT_DISABLED: {
                message: "Mute other participants is disabled by ACS service.",
                code: 403,
                subCode: 42e3,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_PARTICIPANT_FAILED: {
                message: "Failed to mute specific participant",
                code: 500,
                subCode: 42001,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to RemoteParticipant event, unknown event name.",
                code: 422,
                subCode: 42002,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from RemoteParticipant event, unknown event name.",
                code: 422,
                subCode: 42003,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_PARTICIPANT_PSTN_UNSUPPORTED: {
                message: "The scenario to soft mute a PSTN participant is not supported.",
                code: 405,
                subCode: 42004,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_PARTICIPANT_NONCONNECTED_UNSUPPORTED: {
                message: "The scenario to soft mute a participant who is not connected is not supported.",
                code: 405,
                subCode: 42005,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MUTE_PARTICIPANT_1_TO_1_UNSUPPORTED: {
                message: "The scenario to soft mute a participant is a 1-1 call is not supported.",
                code: 405,
                subCode: 42006,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        LOCAL_VIDEO_STREAM: {
            SOURCE_UNAVAILABLE: {
                message: "Failed to start video, video device is being used by another process/application. Stop your camera from being used in the other process/application and try again.",
                code: 412,
                subCode: 43e3,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PERMISSION_DENIED: {
                message: "Failed to start video, permission was not granted to use selected video device. Ensure video device permissions are allowed in the browser's settings and in the system's setttings.",
                code: 403,
                subCode: 43001,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNKNOWN: {
                message: "Failed to start video, unknown error. Please try again. If the issue persists, contact Azure Communication Services support.",
                code: 500,
                subCode: 43002,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            WRONG_STREAM_TYPE: {
                message: "Failed to create local video stream, source was not of type VideoDeviceInfo or MediaStream",
                code: 400,
                subCode: 43003,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SWITCH_SOURCE_WRONG_TYPE: {
                message: "Failed to switch video device, invalid input. Input must be of a VideoDeviceInfo type.",
                code: 400,
                subCode: 43004,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SWITCH_SAME_SOURCE: {
                message: "Failed to switch video device, unable to switch to the same video device, it's already selected.",
                code: 400,
                subCode: 43005,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CANT_GET_DEVICE_TYPE: {
                message: "Unable to get device type",
                code: 500,
                subCode: 43006,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VIDEO_GET_MEDIA_STREAM: {
                message: "Failed to get raw video stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43007,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_MEDIA_STREAM_WRONG_TYPE: {
                message: "Failed to set media stream source is not MediaStream",
                code: 400,
                subCode: 43008,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SET_MEDIA_STREAM_UNDEFINED_FUNC: {
                message: "Failed to set raw video stream. Found undefined function. Gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43009,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_MEDIA_STREAM: {
                message: "Failed to set raw video stream. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43010,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to LocalVideoStream event, unknown event name.",
                code: 422,
                subCode: 43011,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from LocalVideoStream event, unknown event name.",
                code: 422,
                subCode: 43012,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            DEVICES_NOT_FOUND: {
                message: "Failed to start video, no video devices found. Ensure video devices are plugged in and enabled in the system settings.",
                code: 412,
                subCode: 43013,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MEDIA_STREAM_REQUEST_ERROR: {
                message: "Failed to start video, error requesting media stream. Please try again, if issue persists, contact Azure Communication Services support.",
                code: 412,
                subCode: 43014,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            MEDIA_STREAM_REQUEST_TIMEDOUT: {
                message: "Failed to start video, media stream request timed out. PLease allow permission on the browser's prompt to access the camera and try again.",
                code: 412,
                subCode: 43015,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PERMISSION_DENIED_BY_SYSTEM: {
                message: "Failed to start video, permissions denied by system. Ensure video device permissions are allowed in the browser's settings and in the system's setttings.",
                code: 412,
                subCode: 43016,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNSUPPORTED_STREAM: {
                message: "Failed to start video, unsupported stream. Please try again, if issue persists, contact Azure Communication Services support.",
                code: 412,
                subCode: 43017,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CONSTRAINT_NOT_SATISFIED: {
                message: "Failed to start video, failed to set constraints. Please try again, if issue persists, contact Azure Communication Services support.",
                code: 412,
                subCode: 43018,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            NO_DEVICE_SELECTED: {
                message: "Failed to start video, no device selected. Please ensure to pass a LocalVideoStream constructed with a VideoDeviceInfo and try again. If issue persists, contact Azure Communication Services support.",
                code: 412,
                subCode: 43019,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            CALL_NOT_FOUND: {
                message: "Start video is cancelled because call has ended.",
                code: 412,
                subCode: 43021,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        REMOTE_VIDEO_STREAM: {
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to RemoteVideoStream event, unknown event name.",
                code: 422,
                subCode: 43100,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from RemoteVideoStream event, unknown event name.",
                code: 422,
                subCode: 43101,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            GET_RAW_MEDIA_STREAM: {
                message: "Not able to get media stream",
                code: 500,
                subCode: 43102,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            RAWMEDIA_LVS_NOT_AVAILABLE: {
                message: "The remote video stream is currently not available, subscribe to the stream's isAvailable property to get notified when it is ready to get the raw media stream.",
                code: 400,
                subCode: 43103,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SUBSCRIBE_MEDIA_STREAM_TIMEOUT: {
                message: "Failed to subscribe to media stream, timeout",
                code: 408,
                subCode: 43104,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_TRACK: {
                message: "Failed to get media stream",
                code: 500,
                subCode: 43105,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TRACK_UNMUTED_TIMEOUT: {
                message: "Failed to subscribe to media stream, muted",
                code: 408,
                subCode: 43106,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            GET_MEDIA_STREAM: {
                message: "Failed to get raw media stream",
                code: 500,
                subCode: 43107,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        VIEW: {
            ISAVAILABLE_FALSE: {
                message: "Failed to render video stream, this stream is not available. Subscribe to the stream's isAvailable property to get notified when the remote participant has their video on and the stream is available for rendering.",
                code: 412,
                subCode: 43200,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            START_ALREADY_DISPOSED: {
                message: "Failed to start stream, already disposed",
                code: 405,
                subCode: 43201,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            STREAM_BECAME_UNAVAILABLE: {
                message: "Failed to render video stream, this stream is not longer available. Remote participant turned their video off.",
                code: 404,
                subCode: 43202,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            TIMEOUT: {
                message: "Failed to render video stream, rendering timed out while waiting for video frames. Please try again, if issue persists, contact Azure Communication Services support.",
                code: 408,
                subCode: 43203,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SUBSCRIBE: {
                message: "Failed to render video stream, failed to subscribe to video on the Azure Communication Services infrastructure. Please try again, if issue persists, contact Azure Communication Services support.",
                code: 500,
                subCode: 43204,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            START: {
                message: "Failed to start stream, internal error",
                code: 500,
                subCode: 43205,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SCALING_MODE: {
                message: "Failed to updateScalingMode, failed to update",
                code: 500,
                subCode: 43206,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            LARGE_MEETING_VIEW_DISPOSED: {
                message: "Failed to start stream, disposing stream because participant is not a dominant speaker in the large meeting",
                code: 405,
                subCode: 43207,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            REMOTE_VIDEO_STREAM_DISPOSED: {
                message: "Failed to start stream, disposing stream because remote video stream is disposing",
                code: 405,
                subCode: 43208,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            APP_VIEW_DISPOSED: {
                message: "Failed to render video stream, VideoStreamRenderer was disposed during initialization process.",
                code: 405,
                subCode: 43209,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            RENDERER_DISPOSE_ALREADY_DISPOSED: {
                message: "Failed to dispose VideoStreamRenderer, it is already disposed.",
                code: 400,
                subCode: 43210,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            REMOTE_RENDERER_DISPOSE_FAIL: {
                message: "Failed to dispose remote renderer",
                code: 500,
                subCode: 43211,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            VIEW_WRONG_STREAM_TYPE: {
                message: "Failed to create VideoStreamRendererView, videoStream must be either LocalVideoStream or RemoteVideoStream type",
                code: 400,
                subCode: 43212,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            VIEW_ALREADY_DISPOSED: {
                message: "Failed to dispose, VideoStreamRendererView is disposed",
                code: 400,
                subCode: 43213,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            RENDER_FAIL_STREAM_DISPOSED: {
                message: "Failed to render, stream disposed",
                code: 400,
                subCode: 43214,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SCALING_MODE_DISPOSED: {
                message: "Failed to updateScalingMode, VideoStreamRendererView is disposed",
                code: 400,
                subCode: 43215,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SCALING_MODE_WRONG_VAL: {
                message: "Failed to updateScalingMode, wrong scalingMode value",
                code: 400,
                subCode: 43216,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            DISPOSE_FAIL: {
                message: "Failed to dispose view",
                code: 500,
                subCode: 43217,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            RENDERER_WRONG_STREAM_TYPE: {
                message: "Failed to create VideoStreamRenderer, videoStream must be either LocalVideoStream or RemoteVideoStreamCommon type",
                code: 400,
                subCode: 43218,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            RENDERER_DISPOSED: {
                message: "Failed to create view, VideoStreamRenderer is disposed",
                code: 400,
                subCode: 43219,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            MAX_NUM_OF_VIEWS_REACHED: {
                message: "Failed to create view, maximum number of active RemoteVideoStream views has been reached. You can dispose of a previous one in order to create new one.",
                code: 400,
                subCode: 43220,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            CREATE_VIEW_FAILED: {
                message: "Failed to create view",
                code: 500,
                subCode: 43221,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            RENDERER_ALREADY_DISPOSED: {
                message: "Failed to dispose, VideoStreamRendererView is already disposed",
                code: 400,
                subCode: 43222,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNKNOWN_STREAM_TYPE: {
                message: "Unknown stream type",
                code: 400,
                subCode: 43223,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            LOCAL_RENDERER_DISPOSE_FAIL: {
                message: "Failed to dispose local renderer",
                code: 500,
                subCode: 43224,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            WATERMARK_ATTACH_FAIL: {
                message: "Meeting has watermark enabled, but failed to generate and attach watermark. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43225,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            WATERMARK_UNEXPECTED_VALUES: {
                message: "Unknown watermark settings from server. Please check meeting organizer settings for watermark. If the issue persists, gather browser logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43226,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            NO_WATERMARK_CAPABILITY_RECEIVED: {
                message: "Missing watermark capability from server. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43227,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            }
        },
        LOCAL_AUDIO_STREAM: {
            WRONG_STREAM_TYPE: {
                message: "Failed to create local audio stream, source is not of type AudioDeviceInfo or MediaStream",
                code: 400,
                subCode: 43600,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SOURCE_WRONG_TYPE: {
                message: "Failed to create local audio stream, source is not a microphone",
                code: 400,
                subCode: 43601,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            GET_MEDIA_STREAM: {
                message: "Failed to get media stream source is not AudioDeviceInfo or MediaStream",
                code: 500,
                subCode: 43602,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            SET_MEDIA_STREAM_WRONG_TYPE: {
                message: "Failed to switch stream on local audio, source is not of type MediaStream",
                code: 400,
                subCode: 43603,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SWITCH_SOURCE_WRONG_TYPE: {
                message: "Failed to create local audio stream, source is not a microphone",
                code: 400,
                subCode: 43604,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_SUBSCRIBE: {
                message: "Not able to subscribe to LocalAudioStream event, unknown event name.",
                code: 422,
                subCode: 43605,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EVENT_UNSUBSCRIBE: {
                message: "Not able to unsubscribe from LocalAudioStream event, unknown event name.",
                code: 422,
                subCode: 43606,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            SWITCH_SAME_SOURCE: {
                message: "Failed to switch audio device, unable to switch to the same audio device, it's already selected.",
                code: 400,
                subCode: 43607,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            UNKNOWN: {
                message: "Failed to start audio, unknown error. Please try again. If the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 43608,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        REMOTE_AUDIO_STREAM: {},
        IDENTIFIER: {
            PARSE_PHONENUMBER: {
                message: "Unable to parse PhoneNumberIdentifier object",
                code: 422,
                subCode: 44e3,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_MSFT_TEAMS_USER: {
                message: "Unable to parse MicrosoftTeamsUserIdentifier object",
                code: 422,
                subCode: 44001,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_MSFT_TEAMS_APP: {
                message: "Unable to parse MicrosoftTeamsAppIdentifier object",
                code: 422,
                subCode: 44002,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_IDENTIFIER: {
                message: "Unable to parse Identifier object, please check the syntax",
                code: 422,
                subCode: 44003,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_COMM_USER: {
                message: "Invalid CommunicationUser identifier specified",
                code: 422,
                subCode: 44004,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_MSFT_TEAMS_USER_RAWID: {
                message: "Invalid MicrosoftTeamsUser rawId specified",
                code: 422,
                subCode: 44005,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_MSFT_TEAMS_USER_USERID: {
                message: "Invalid MicrosoftTeamsUser microsoftTeamsUserId specified",
                code: 422,
                subCode: 44006,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_MSFT_TEAMS_APP_RAWID: {
                message: "Invalid MicrosoftTeamsApp rawId specified",
                code: 422,
                subCode: 44007,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_MSFT_TEAMS_APP_APPID: {
                message: "Invalid MicrosoftTeamsApp teamsAppId specified",
                code: 422,
                subCode: 44008,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_UNKNOWN_IDENTIFIER: {
                message: "Invalid identifier specified, please specify an id",
                code: 422,
                subCode: 44009,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_INVALID_IDENTIFIER: {
                message: "Unable to parse Identifier object",
                code: 422,
                subCode: 44010,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_IDENTIFIER_ARRAY: {
                message: "AssertIsArrayOfIdentifiers failed. : userIds must be array of CommunicationIdentifier",
                code: 422,
                subCode: 44011,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            NO_CLOUD_PREFIX_FOUND: {
                message: "No cloud prefix found in identity",
                code: 409,
                subCode: 44012,
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        INTERNAL: {
            ECS_CONFIG_EMPTY: {
                message: "Config is empty",
                code: 500,
                subCode: 44100,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            ECS_CONFIG_MISSING_ACS: {
                message: "Missing ACS config key",
                code: 500,
                subCode: 44101,
                resultCategories: [
                    "UnexpectedServerError"
                ]
            },
            ECS_CONFIG_MERGING_ERROR: {
                message: "Error while merging config",
                code: 500,
                subCode: 44102,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TELEMETRY_FAILED_TO_INITIALIZE_INVALID_CLOUD_TYPE: {
                message: "Failed to initialize telemetry",
                code: 500,
                subCode: 44103,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TELEMETRY_FAILED_TO_INITIALIZE_ALREADY_INITIALIZED: {
                message: "Failed to initialize telemetry",
                code: 500,
                subCode: 44104,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TELEMETRY_FAILED_TO_INITIALIZE: {
                message: "Failed to create and initialize telemetry logger for tenant. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                code: 500,
                subCode: 44105,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TELEMETRY_FAILED_TO_FLUSH: {
                message: "Failed to flush telemetry",
                code: 500,
                subCode: 44106,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TELEMETRY_LOGGER_INIT_FAIL: {
                message: "Failed to initialize telemetry logger",
                code: 500,
                subCode: 44107,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            NO_TOKEN_PROVIDED: {
                message: "No CommunicationTokenCredential provided",
                code: 401,
                subCode: 44108,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            EMPTY_TOKEN: {
                message: "AccessToken is empty",
                code: 401,
                subCode: 44109,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            GET_TOKEN: {
                message: "Failed to get AccessToken",
                code: 401,
                subCode: 44110,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            TOKEN_PAYLOAD_UNDEFINED: {
                message: "Invalid token",
                code: 401,
                subCode: 44111,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            TOKEN_UNDEFINED: {
                message: "Failed to parse AccessToken",
                code: 401,
                subCode: 44112,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_TOKEN_SCOPE: {
                message: "AccessToken does not contain 'voip' or 'voip.join' scope",
                code: 401,
                subCode: 44113,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            INVALID_TOKEN_SCOPE_FORMAT: {
                message: "Wrong AccessToken scope format. Scope is expected to be a string that contains 'voip'",
                code: 401,
                subCode: 44114,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            RESOURCE_NOT_FOUND_IN_TOKEN: {
                message: "AccessToken does not contain ACS resource Id",
                code: 401,
                subCode: 44115,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            USERID_NOT_FOUND_IN_TOKEN: {
                message: "AccessToken does not contain ACS user Id",
                code: 401,
                subCode: 44116,
                resultCategories: [
                    "ExpectedError"
                ]
            },
            PARSE_TOKEN_FAIL: {
                message: "Failed to parse AccessToken",
                code: 401,
                subCode: 44117,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            OPERATION_TIMEDOUT: {
                message: "Operation timed out",
                code: 408,
                subCode: 44118,
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        RAW_MEDIA: {},
        FEATURES: {
            AUDIO_EFFECTS: {
                SET_ECHO_CANCELLATION: {
                    message: "Error while trying to start or stop echo cancellation. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45e3,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SET_NOISE_SUPPRESSION: {
                    message: "Error while trying to start or stop noise suppression. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45001,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to AudioEffects event, unknown event name.",
                    code: 400,
                    subCode: 45002,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from AudioEffects event, unknown event name.",
                    code: 400,
                    subCode: 45003,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED: {
                    message: "Setting audio effects is currently disabled by Azure Communication Services.",
                    code: 403,
                    subCode: 45004,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_DISPOSED: {
                    message: "Audio effects feature is disposed. Create a new AudioEffects feature instance.",
                    code: 400,
                    subCode: 45005,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SOURCE_UNSUPPORTED: {
                    message: "Current source is not supported",
                    code: 415,
                    subCode: 45006,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_DEVICE_MANAGER: {
                    message: "Failed to get device manager to start effects.",
                    code: 500,
                    subCode: 45007,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                STOP_DISPOSED: {
                    message: "Audio effects feature is disposed. Create a new AudioEffects feature instance.",
                    code: 400,
                    subCode: 45008,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                STOP_DEVICE_MANAGER: {
                    message: "Failed to get device manager to stop effects.",
                    code: 500,
                    subCode: 45009,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                FAILED_TO_GET_DM: {
                    message: "Internal error - DM missing",
                    code: 500,
                    subCode: 45010,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                PROVIDER_UNAVAILABLE: {
                    message: "EffectProvider not available",
                    code: 500,
                    subCode: 45011,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                AEC_PROVIDER_MISSING: {
                    message: "Internal error - stack aec provider missing",
                    code: 500,
                    subCode: 45012,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                INVALID_EFFECT: {
                    message: "Invalid effect provided",
                    code: 400,
                    subCode: 45013,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_EFFECT_ECHO: {
                    message: "Invalid or no echo cancellation effect provided",
                    code: 400,
                    subCode: 45014,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_EFFECT_NOISE_SUPP: {
                    message: "Invalid or no noise suppression effect provided",
                    code: 400,
                    subCode: 45015,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_EFFECT: {
                    message: "Unsupported effect specified. Please specify a supported audio effect.",
                    code: 415,
                    subCode: 45016,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SUPPORT_CHECK_FAILED: {
                    message: "Error while checking support",
                    code: 501,
                    subCode: 45017,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                INVALID_EFFECT_GAINCONTROL: {
                    message: "Invalid or no auto gain control effect provided",
                    code: 400,
                    subCode: 45018,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SET_AUTO_GAIN_CONTROL: {
                    message: "Error while trying to start or stop auto gain control. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45019,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                AUDIO_FLAGS: {
                    message: "Error setting browser audio processing flags",
                    code: 500,
                    subCode: 45020,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                START_FAILED: {
                    message: "Error starting audio effects.",
                    code: 500,
                    subCode: 45021,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                STOP_FAILED: {
                    message: "Error stopping audio effects.",
                    code: 500,
                    subCode: 45022,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                DISPOSE_FAILED: {
                    message: "Error disposing audio effects feature.",
                    code: 500,
                    subCode: 45023,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            AUDIO_ZONES: {},
            CALL_SURVEY: {
                INVALID_SURVEY: {
                    message: "Invalid call survey. Please submit a survey options.",
                    code: 400,
                    subCode: 45100,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SUBMIT_TIMEOUT: {
                    message: "Failed to submit survery, timedout. Please try again, if issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 408,
                    subCode: 45101,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            CAPABILITIES: {},
            CAPTIONS: {
                INITIALIZE: {
                    message: "Failed to initialize Captions.",
                    code: 500,
                    subCode: 45200,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                DISABLED: {
                    message: "Captions feature is currently disabled by Azure Communication services.",
                    code: 412,
                    subCode: 45201,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SPOKEN_LANG_UNSUPPORTED: {
                    message: "Spoken language requested is not supported.",
                    code: 400,
                    subCode: 45202,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                MEETING_POLICY_DISABLED: {
                    message: "Captions feature is disabled in meeting policy.",
                    code: 403,
                    subCode: 45203,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CALLING_POLICY_DISABLED: {
                    message: "Captions feature is disabled in calling policy.",
                    code: 403,
                    subCode: 45204,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_FAILED: {
                    message: "Could not start captions.",
                    code: 500,
                    subCode: 45205,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UPDATE_LANGUAGE_NOT_STARTED: {
                    message: "Cannot update spoken language as captions has not started.",
                    code: 400,
                    subCode: 45206,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SPOKEN_LANG_DISABLED: {
                    message: "Set spoken language is currently disabled by Azure Communication Services.",
                    code: 412,
                    subCode: 45207,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UPDATE_LANGUAGE_GET_TOKEN: {
                    message: "Unable to update spoken language. Failed to get token.",
                    code: 401,
                    subCode: 45208,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UPDATE_LANGUAGE_FAILED: {
                    message: "Unable to update spoken language.",
                    code: 500,
                    subCode: 45209,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UPDATE_CAPTIONS_NOT_STARTED: {
                    message: "Cannot update caption language as captions has not started.",
                    code: 400,
                    subCode: 45210,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CAPTIONS_LANG_DISABLED: {
                    message: "Set caption language is currently disabled by Azure Communication Services.",
                    code: 412,
                    subCode: 45211,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CAPTIONS_LANG_TEAMS_LICENSE: {
                    message: "Set caption language failed. Teams premium license is needed to use this feature.",
                    code: 401,
                    subCode: 45212,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CAPTIONS_LANG_UNSUPPORTED: {
                    message: "Caption language requested is not supported.",
                    code: 400,
                    subCode: 45213,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UPDATE_CAPTIONS_GET_TOKEN: {
                    message: "Null token",
                    code: 401,
                    subCode: 45214,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UPDATE_CAPTIONS_FAILED: {
                    message: "Unable to update caption language.",
                    code: 500,
                    subCode: 45215,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                CTE_POLICY_FETCH_FAIL: {
                    message: "Failed to fetch policy for Teams Captions.",
                    code: 500,
                    subCode: 45216,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                ALREADY_ACTIVE: {
                    message: "Captions already active",
                    code: 400,
                    subCode: 45217,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                STOP_NOT_ACTIVE: {
                    message: "Captions feature is not active.",
                    code: 400,
                    subCode: 45218,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                ALREADY_STARTING: {
                    message: "Operation in progress",
                    code: 400,
                    subCode: 45219,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SPOKEN_LANGUAGE_ALREADY_SET: {
                    message: "Spoken language already set",
                    code: 400,
                    subCode: 45220,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UPDATE_CAPTIONS_NOT_ACTIVE: {
                    message: "Unable to update caption language as Captions is not active.",
                    code: 400,
                    subCode: 45221,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CAPTIONS_LANG_ALREADY_SET: {
                    message: "Caption language already set.",
                    code: 400,
                    subCode: 45222,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UPDATE_ENDPOINT_METADATA: {
                    message: "Failed to update endpoint metadata",
                    code: 500,
                    subCode: 45225,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                START_FAILED_CALL_NOT_CONNECTED: {
                    message: "Cannot start captions as call state is not connected.",
                    code: 400,
                    subCode: 45226,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_FAILED_CALL_ENDPOINTS_NOT_AVAILABLE: {
                    message: "Cannot start captions as call endpoints are not available.",
                    code: 400,
                    subCode: 45227,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            COMPOSED_STREAM: {},
            DATA_CHANNEL: {
                DISPOSED: {
                    message: "DataChannel has been disposed",
                    code: 500,
                    subCode: 45300,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SENDER_NOT_READY: {
                    message: "Sender is not ready",
                    code: 500,
                    subCode: 45301,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                NO_AVAILABLE_CHANNEL_ID: {
                    message: "No available channel id",
                    code: 500,
                    subCode: 45302,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                INVALID_CHANNEL_ID: {
                    message: "Invalid channel id",
                    code: 400,
                    subCode: 45303,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_BITRATE_IN_KBPS: {
                    message: "Invalid bitrateInKbps",
                    code: 400,
                    subCode: 45304,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_PARTICIPANTS: {
                    message: "Invalid participants",
                    code: 400,
                    subCode: 45305,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                TOO_MANY_PARTICIPANTS: {
                    message: "Too many participants",
                    code: 400,
                    subCode: 45306,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                NO_VALID_PARTICIPANT: {
                    message: "No valid participant",
                    code: 400,
                    subCode: 45307,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                MSG_DATA_EMPTY: {
                    message: "Message data is empty",
                    code: 400,
                    subCode: 45308,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                MSG_DATA_TOO_LARGE: {
                    message: "The size of message data is too large",
                    code: 400,
                    subCode: 45309,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_MSG_LENGTH: {
                    message: "Invalid message length",
                    code: 500,
                    subCode: 45310,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                BUFFER_FULL: {
                    message: "The buffer is full. Please wait and try again",
                    code: 500,
                    subCode: 45311,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SENDER_CLOSED: {
                    message: "The sender has been closed",
                    code: 400,
                    subCode: 45312,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                NO_AVAILABLE_RELIABLE_CHANNEL: {
                    message: "Currently there is no available reliable channel",
                    code: 500,
                    subCode: 45313,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                NO_AVAILABLE_UNRELIABLE_CHANNEL: {
                    message: "Currently there is no available unreliable channel",
                    code: 500,
                    subCode: 45314,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                CHANNEL_ALREADY_ALLOCATED: {
                    message: "Unable allocate the channel because a channel with the same channelId has already been allocated",
                    code: 500,
                    subCode: 45315,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                INVALID_BITRATE: {
                    message: "Invalid bitrate",
                    code: 400,
                    subCode: 45316,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                TRAFFIC_LIMITED: {
                    message: "Traffic is limited",
                    code: 400,
                    subCode: 45317,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SEND_FAIL: {
                    message: "Failed to send message.",
                    code: 500,
                    subCode: 45318,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to DataChannel event, unknown event name.",
                    code: 422,
                    subCode: 45319,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                WRONG_ARGUMENT_TYPE: {
                    message: "Wrong argument type specified.",
                    code: 400,
                    subCode: 45320,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                WRONG_ARGUMENT_VALUE: {
                    message: "Wrong value specified.",
                    code: 400,
                    subCode: 45321,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CANT_FIND_CHANNEL_ID: {
                    message: "Cannot find the channelId specified.",
                    code: 400,
                    subCode: 45322,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                FAILED_TO_CREATE_SENDER: {
                    message: "Failed to create the sender.",
                    code: 500,
                    subCode: 45323,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            DEBUG_INFO: {},
            DIAGNOSTICS: {
                INCORRECT_VALUETYPE_MAPPED: {
                    message: "Mapped to an incorrect value type. Please gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45400,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to UserFacingDiagnostics event, unknown event name.",
                    code: 422,
                    subCode: 45401,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from UserFacingDiagnostics event, unknown event name.",
                    code: 422,
                    subCode: 45402,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INCORRECT_VALUE_MAPPED: {
                    message: "Failed to map diagnostic quality level. Please gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45403,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            DOMINANT_SPEAKER: {},
            LIVE_STREAM: {
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to LiveStream event, unknown event name.",
                    code: 422,
                    subCode: 45500,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribefrom LiveStream event, unknown event name.",
                    code: 422,
                    subCode: 45501,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_AGGREGATION_INTERVAL_RANGE: {
                    message: "Invalid aggregationInterval value range.",
                    code: 400,
                    subCode: 45502,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_DATAPOINTS_AGGREGATION_RANGE: {
                    message: "invalid dataPointsPerAggregation value range.",
                    code: 400,
                    subCode: 45503,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISPOSED: {
                    message: "MediaStatsCallFeature has been disposed.",
                    code: 400,
                    subCode: 45504,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            MEDIA_STATS: {
                INVALID_AGGREGATION_INTERVAL_RANGE: {
                    message: "Invalid aggregationInterval value range.",
                    code: 400,
                    subCode: 45550,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_DATAPOINTS_AGGREGATION_RANGE: {
                    message: "invalid dataPointsPerAggregation value range.",
                    code: 400,
                    subCode: 45551,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISPOSED: {
                    message: "MediaStatsCallFeature has been disposed.",
                    code: 400,
                    subCode: 45552,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            OPTIMAL_VIDEO_COUNT: {
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to OptimalVideoCount event, unknown event name.",
                    code: 422,
                    subCode: 45600,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from OptimalVideoCount event, unknown event name.",
                    code: 422,
                    subCode: 45601,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            PPTLIVE: {},
            PRECALL_DIAGNOSTICS: {
                SET_DEVICE_FAIL: {
                    message: "Failed to set default microphone or speaker with error",
                    code: 412,
                    subCode: 45700,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                GET_DIAGNOSTICS_INFO: {
                    message: "Unable to return call diagnostic information.",
                    code: 500,
                    subCode: 45701,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                VIDEO_STREAM_TIMEOUT: {
                    message: "Timeout in checking media stream status",
                    code: 500,
                    subCode: 45702,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                GET_CALL_AGENT: {
                    message: "Failed to get existing call agent or create a new one",
                    code: 500,
                    subCode: 45703,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                CONNECT_FAIL: {
                    message: "Test call failed to connect",
                    code: 500,
                    subCode: 45704,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                RENDER_VIDEO: {
                    message: "Call failed to render video.",
                    code: 500,
                    subCode: 45705,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                HANGUP_FAIL: {
                    message: "Test call failed hang up the call",
                    code: 500,
                    subCode: 45706,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                VIDEO_MEDIASTATS: {
                    message: "Failed to get video call media stats",
                    code: 500,
                    subCode: 45707,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                CALL_CONNECT_TIMEOUT: {
                    message: "Call timed out to connect. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 408,
                    subCode: 45708,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            RAISE_HAND: {
                INITIALIZE: {
                    message: "Could not initialize raise hand feature.",
                    code: 500,
                    subCode: 45750,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                RAISE_HAND_PUBLISH_STATE: {
                    message: "Could not change a participant state.",
                    code: 500,
                    subCode: 45751,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                RAISE_HAND_FAIL: {
                    message: "Could not change a participant state.",
                    code: 500,
                    subCode: 45752,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                LOWER_HAND_FAIL: {
                    message: "Could not change a participant state.",
                    code: 500,
                    subCode: 45753,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                LOWER_REMOTEPARTICIPANTS_HANDS_FAIL: {
                    message: "Could not change a participant state.",
                    code: 500,
                    subCode: 45754,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                LOWER_ALL_HANDS_FAIL: {
                    message: "Could not change a participant state.",
                    code: 500,
                    subCode: 45755,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                NOT_SUPPORTED_1TO1: {
                    message: "Raise hand is not supported for 1:1 direct calling",
                    code: 400,
                    subCode: 45758,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            REACTION: {
                CALL_NOT_CONNECTED: {
                    message: "Call is not connected yet to send reaction",
                    code: 400,
                    subCode: 45800,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                NOT_SUPPORTED_1TO1_CTE: {
                    message: "Reaction send is not supported for 1:1 direct calling with teams identity",
                    code: 400,
                    subCode: 45801,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_SUBSCRIBE_FAIL_POLICY: {
                    message: "Unable to register listener due to meeting policy",
                    code: 403,
                    subCode: 45802,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE_FAIL_POLICY: {
                    message: "Unable to deregister listener due to meeting policy",
                    code: 403,
                    subCode: 45803,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SEND_FAIL_POLICY: {
                    message: "Unable to send reaction due to meeting policy",
                    code: 403,
                    subCode: 45804,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                STATE_SERVICE_CONNECT_FAIL: {
                    message: "Could not create state service proxy web-socket connection",
                    code: 500,
                    subCode: 45805,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                MAP_CREATE_FAIL: {
                    message: "Could not create sync map to exchange reaction",
                    code: 500,
                    subCode: 45806,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                NOT_INIT_YET: {
                    message: "Unable to handle send reaction",
                    code: 400,
                    subCode: 45807,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SEND_REACTION_FAIL: {
                    message: "Unable to handle send reaction",
                    code: 500,
                    subCode: 45808,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                RECEIVE_REACTION_FAIL: {
                    message: "Unable to parse reaction",
                    code: 500,
                    subCode: 45809,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to Reation event, unknown event name.",
                    code: 422,
                    subCode: 45810,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from Reaction event, unknown event name.",
                    code: 422,
                    subCode: 45811,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            RECORDING: {
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to Recording event, unknown event name.",
                    code: 422,
                    subCode: 45850,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from Recording event, unknown event name.",
                    code: 422,
                    subCode: 45851,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                RECORDING_CONSENT_FAILURE: {
                    message: "Failed to set consent publish state for recording. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 45853,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                }
            },
            SPOTLIGHT: {
                ALREADY_SPOTLIGHTED: {
                    message: "Bad request. All participants are already spotlighted",
                    code: 400,
                    subCode: 45900,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_SPOTLIGHT_FAILED: {
                    message: "Internal Error. Start spotlight for participants failed",
                    code: 500,
                    subCode: 45901,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                SPOTLIGHT_LIGHT_MAX_REACHED: {
                    message: "Failed to start spotlight. Reached the maximum number of participants that can be Spotlighted.",
                    code: 400,
                    subCode: 45902,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_ROLE_TYPE: {
                    message: "Failed to spotlight. User does not have a Presenter or Organizer role.",
                    code: 403,
                    subCode: 45903,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                NOT_SUPPORTED_1TO1: {
                    message: "Spotlight is not supported for 1:1 direct calling",
                    code: 400,
                    subCode: 45906,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            TEAMS_MEETING_AUDIO_CONFERENCING: {
                ONLY_AVAILABLE_IN_MEETINGS: {
                    message: "Teams meeting audio conferencing feature is only available in meetings",
                    code: 400,
                    subCode: 45950,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED: {
                    message: "The Teams meeting audio conferencing details feature is disabled by ACS service.",
                    code: 405,
                    subCode: 45951,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNAVAILABLE_BEFORE_JOINING: {
                    message: "Teams meeting audio conferencing details are not available before joining the Teams meeting",
                    code: 400,
                    subCode: 45952,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNVAILABLE_IN_LOBBY: {
                    message: "Teams meeting audio conferencing details are not available in Lobby",
                    code: 400,
                    subCode: 45953,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DETAILS_NOT_CONFIGURED: {
                    message: "Teams meeting audio conferencing details is not configured",
                    code: 400,
                    subCode: 45954,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                GET_DETAILS_FAILED: {
                    message: "Error retrieving Teams meeting audio conferencing details",
                    code: 500,
                    subCode: 45955,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                }
            },
            TRANSCRIPTION: {
                TRANSCRIPTION_CONSENT_FAILURE: {
                    message: "Failed to set consent publish state for transcription. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46001,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                }
            },
            TRANSFER: {
                TRANSFER_TO_TARGET_FAILED: {
                    message: "Transfer to target failed",
                    code: 500,
                    subCode: 46050,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UNSUPPORTED_CALL_TYPE: {
                    message: "Transfer is not supported in this call.",
                    code: 400,
                    subCode: 46051,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                TARGET_NOT_RECOGNIZED: {
                    message: "Transfer target is not recognized.",
                    code: 400,
                    subCode: 46052,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_TARGET_TYPE: {
                    message: "Invalid target participant type detected.",
                    code: 400,
                    subCode: 46053,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            UNMIXED_AUDIO: {
                UNAVAILABLE: {
                    message: "UnmixedAudio is not available.",
                    code: 500,
                    subCode: 46100,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                PENDING_OPERATION: {
                    message: "The operation cannot be done because there is a pending operation",
                    code: 400,
                    subCode: 46101,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_OPERATION: {
                    message: "The operation is not supported in peer-to-peer call",
                    code: 400,
                    subCode: 46102,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                ENABLED: {
                    message: "Unmixed audio has been enabled",
                    code: 400,
                    subCode: 46103,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED: {
                    message: "Unmixed audio has been disabled",
                    code: 400,
                    subCode: 46104,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISPOSED: {
                    message: "Unmixed audio has been disposed",
                    code: 400,
                    subCode: 46105,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_SUBSCIBE_UNSUBSCRIBE: {
                    message: "Not able to subscribe or unsubscibe to UnmixedAudio event, unknown event name.",
                    code: 422,
                    subCode: 46106,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                WRONG_ARGUMENT_TYPE: {
                    message: "Wrong argument type specified.",
                    code: 400,
                    subCode: 46107,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                WRONG_ARGUMENT_VALUE: {
                    message: "Wrong value specified.",
                    code: 400,
                    subCode: 46108,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_STATE: {
                    message: "Invalid state.",
                    code: 400,
                    subCode: 46109,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNKNOWN_ERROR: {
                    message: "Unknown error",
                    code: 500,
                    subCode: 46110,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                FAILED_TO_ENABLE: {
                    message: "Failed to enable unmixed audio: AudioContext={0}, UnmixedAudio={1}",
                    code: 500,
                    subCode: 46111,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                FAILED_TO_DISABLE: {
                    message: "Failed to disable unmixed audio: AudioContext={0}, UnmixedAudio={1}",
                    code: 500,
                    subCode: 46112,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                FAILED_TO_INITIALIZE: {
                    message: "Failed to initialize unmixed audio.",
                    code: 500,
                    subCode: 46113,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            VIDEO_EFFECTS: {
                DISABLED: {
                    message: "Video effects feature is currently disabled by Azure Communication Services.",
                    code: 403,
                    subCode: 46150,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_DISPOSED: {
                    message: "VideoEffects feature is disposed. Create a new VideoEffects Feature instance.",
                    code: 400,
                    subCode: 46151,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_SOURCE: {
                    message: "Current source is unsupported to use effects",
                    code: 415,
                    subCode: 46152,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                START_DEVICE_MANAGER: {
                    message: "Failed to get device manager to start effects.",
                    code: 500,
                    subCode: 46153,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                PROVIDER_UNAVAILABLE: {
                    message: "EffectProvider not available",
                    code: 500,
                    subCode: 46154,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                WEBCV_PROVIDER_FAILED: {
                    message: "Failed to get WebCV provider.",
                    code: 500,
                    subCode: 46155,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UNSUPPORTED_EFFECT: {
                    message: "Effect is not supported.",
                    code: 501,
                    subCode: 46156,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                STOP_DISPOSED: {
                    message: "VideoEffects feature is disposed. Create a new VideoEffects Feature instance.",
                    code: 400,
                    subCode: 46157,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                STOP_DEVICE_MANAGER: {
                    message: "Failed to get device manager to stop effects.",
                    code: 500,
                    subCode: 46158,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                INVALID_EFFECT: {
                    message: "Invalid effect provided",
                    code: 400,
                    subCode: 46159,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to event {event}, unknown event name",
                    code: 400,
                    subCode: 46160,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe event {event}, unknown event name",
                    code: 400,
                    subCode: 46161,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EFFECT_PROVIDER_TIMEOUT: {
                    message: "Timed promise; rejected.",
                    code: 408,
                    subCode: 46162,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SUPPORT_CHECK_FAILED: {
                    message: "Error while checking support",
                    code: 501,
                    subCode: 46163,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                START_FAILED: {
                    message: "Error starting video effects",
                    code: 500,
                    subCode: 46164,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                STOP_FAILED: {
                    message: "Error stopping video effects",
                    code: 500,
                    subCode: 46165,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                DISPOSE_FAILED: {
                    message: "Error disposing video effects feature",
                    code: 500,
                    subCode: 46166,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                EFFECT_CONFIG_UPDATE_CALLBACK_FAILED: {
                    message: "Effect config update callback had errors",
                    code: 500,
                    subCode: 46169,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            LOCAL_RECORDING: {
                ONLY_AVAILABLE_IN_MEETINGS: {
                    message: "Local Recording feature is only available in meetings",
                    code: 400,
                    subCode: 46200,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED: {
                    message: "Local Recording feature is currently disabled by Azure Communication Service.",
                    code: 405,
                    subCode: 46201,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to LocalRecording event, unknown event name.",
                    code: 422,
                    subCode: 46202,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from LocalRecording event, unknown event name.",
                    code: 422,
                    subCode: 46203,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            BREAKOUT_ROOMS: {
                ONLY_AVAILABLE_IN_MEETINGS: {
                    message: "Breakout Rooms feature is only available in Teams meetings.",
                    code: 400,
                    subCode: 46250,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED: {
                    message: "Breakout Rooms feature is currently disabled by Azure Communication Services.",
                    code: 405,
                    subCode: 46251,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_SUBSCRIBE: {
                    message: "Not able to subscribe to Breakout Rooms event, unknown event name.",
                    code: 422,
                    subCode: 46252,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                EVENT_UNSUBSCRIBE: {
                    message: "Not able to unsubscribe from Breakout Rooms event, unknown event name.",
                    code: 422,
                    subCode: 46253,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                JOIN_FAILED: {
                    message: "Not able to join Breakout Room due to an unexpected error. Please try again, if the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46254,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                MAINMEETING_HOLD_FAILED: {
                    message: "Not able to join Breakout Room as Main meeting hold is failed. Please try again, by calling join() method. If the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46255,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                JOIN_FAILED_ROOM_CLOSED: {
                    message: "Not able to join Breakout Room as the room is closed. Please check the state of the Breakout Room before calling join.",
                    code: 412,
                    subCode: 46256,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                MAINMEETING_RESUME_FAILED: {
                    message: "Not able to join back to the Main meeting as the resume failed.Please gather browser console logs and contact Azure Communication Services support.",
                    code: 412,
                    subCode: 46257,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                BREAKOUT_ROOMS_UPDATEFAILED: {
                    message: "Error while trying to update the Breakoutroom details. Please gather browser console logs and contact Azure Communication Services support.",
                    code: 412,
                    subCode: 46258,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                BREAKOUT_ROOM_HANGUP_FAILED: {
                    message: "Could not hang up the Breakout room call. Please gather browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46259,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                BREAKOUT_ROOM_URL_DOESNOT_EXIST: {
                    message: "Cannot join Breakout Room as the url is null or empty.Can join BreakoutRoom only when assigned.",
                    code: 412,
                    subCode: 46260,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                RETURN_TO_MAINMEETING_FAILED: {
                    message: "Not able to join the main meeting. Please try again by calling the ReturnToMainMeeting() method. If the issue persists, gather browser console logs and contact Azure Communication Services support.",
                    code: 412,
                    subCode: 46261,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                ALREADY_IN_MAINMEETING: {
                    message: "Already in the main meeting. Please call this method only when the participant is in breakoutroom and removed from the main meeting.",
                    code: 412,
                    subCode: 46262,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                HANGUP_EXISTING_BREAKOUT_ROOM_FAILED: {
                    message: "Existing breakout room call hangup failed. Try to call hangup() method again to hangup the call. Call join() method to join the breakout room again.",
                    code: 412,
                    subCode: 46263,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            },
            TOGETHER_MODE: {
                ADD_TOGETHER_MODE_BOT_FAILED: {
                    message: "Unable to add together mode bot. Please collect browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46300,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                PUBLISH_TOGETHER_MODE_STATE_FAILED: {
                    message: "Internal Error. Publish together mode state failed. Please collect browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46301,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                SEAT_MAP_CALCULATION_FAILED: {
                    message: "Seat coordinates calculation failed. Please collect browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46302,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UNSUPPORTED_ROLE_TYPE: {
                    message: "Start together mode failed. User does not have a Presenter, Co-Organizer or Organizer.",
                    code: 403,
                    subCode: 46303,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_CONVERSATION_TYPE: {
                    message: "Start together mode failed. Together mode can only be started in group call or meeting scenarios.",
                    code: 403,
                    subCode: 46304,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                REQUEST_INITIAL_SEAT_MAPPING_FAILED: {
                    message: "Unable to get initial seating coordinates. Please collect browser console logs and contact Azure Communication Services support.",
                    code: 500,
                    subCode: 46305,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UNSUPPORTED_USER_KIND: {
                    message: "Start Together Mode failed. Only M365 users can start together mode.",
                    code: 403,
                    subCode: 46306,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            CALLKIT: {},
            ONE_PHONE_SYSTEM: {
                CUSTOM_CONTEXT_NOT_SUPPORTED: {
                    message: "Specifying custom context is not supported when OnBehalfOfOptions is specified.",
                    code: 412,
                    subCode: 46400,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            SHAREDLINE_APPEARANCE: {
                DISABLED: {
                    message: "Shared line appearance is currently disabled by Azure Communication Services.",
                    code: 405,
                    subCode: 46450,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                DISABLED_BY_CALLING_POLICY: {
                    message: "Shared line appearance is disabled by Teams calling policy. Assign TeamsCalling policy with Allow delegation to true to enabled Sharedline appearance.",
                    code: 405,
                    subCode: 46451,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            MEDIA_ACCESS: {
                MEDIA_ACCESS_UPDATE_FAILED: {
                    message: "Internal error while updating the audio /video access.",
                    code: 500,
                    subCode: 46500,
                    resultCategories: [
                        "UnexpectedServerError"
                    ]
                },
                INITIALIZE_FAILED: {
                    message: "Could not initialize media access feature.",
                    code: 500,
                    subCode: 46501,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                UNSUPPORTED_ROLE: {
                    message: "Change media access failed. User does not have a Organizer, Co-Organizer or Presenter role.",
                    code: 403,
                    subCode: 46502,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                UNSUPPORTED_CONVERSATION_TYPE: {
                    message: "Change media access failed. Change media access can only be done in meeting/group call scenarios.",
                    code: 403,
                    subCode: 46503,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                ROLE_RESTRICTED: {
                    message: "Change media access failed. Only able to change media access for attendees.",
                    code: 403,
                    subCode: 46504,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                CALL_NOT_CONNECTED: {
                    message: "Failed to change media access. Call must be in connected state",
                    code: 412,
                    subCode: 46505,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                INVALID_MEETING_CAPABILITY_ATTENDEE_RESTRICTIONS: {
                    message: "Change audio video access failed. Meeting capability attendee restrictions is empty",
                    code: 500,
                    subCode: 46506,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                FEATURE_DISABLED: {
                    message: "Feature is disabled.",
                    code: 412,
                    subCode: 46507,
                    resultCategories: [
                        "ExpectedError"
                    ]
                }
            },
            REAL_TIME_TEXT: {
                INITIALIZE_FAILED: {
                    message: "Failed to initialize RealTimeTextFeature",
                    code: 500,
                    subCode: 46550,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                START_REAL_TIME_TEXT_FAILED: {
                    message: "Failed to start RealTimeTextFeature",
                    code: 500,
                    subCode: 46551,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                MESSAGE_LENGTH_EXCEEDS_MAX_INPUT_LENGTH: {
                    message: "Message length exceeds max allowed input length",
                    code: 400,
                    subCode: 46552,
                    resultCategories: [
                        "ExpectedError"
                    ]
                },
                SEND_REAL_TIME_TEXT_MESSAGE_FAILED: {
                    message: "Failed to send a RealTimeText message",
                    code: 500,
                    subCode: 46553,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                SEND_DATA_CHANNEL_MESSAGE_FAILED: {
                    message: "Failed to send data channel message",
                    code: 500,
                    subCode: 46554,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                REAL_TIME_TEXT_MESSAGE_PARSE_FAILED: {
                    message: "Failed to parse RealTimeText message",
                    code: 500,
                    subCode: 46555,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                REAL_TIME_TEXT_MESSAGE_CONTAINS_NO_SPEAKER: {
                    message: "Real Time Text message contains no speaker",
                    code: 500,
                    subCode: 46556,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                REAL_TIME_TEXT_MESSAGE_HANDLER_FAILED: {
                    message: "Failed to handle RealTimeText Message",
                    code: 500,
                    subCode: 46557,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                },
                REAL_TIME_TEXT_MESSAGE_ENTRY_UPDATE_FAILED: {
                    message: "Failed to update RealTimeText message entry",
                    code: 500,
                    subCode: 46558,
                    resultCategories: [
                        "UnexpectedClientError"
                    ]
                }
            }
        }
    }, D = {
        0: {
            0: {
                public: !0,
                code: 0,
                subCode: 0,
                message: "Call ended successfully by local participant.",
                resultCategories: [
                    "Success"
                ]
            },
            4097: {
                public: !0,
                code: 0,
                subCode: 4097,
                message: "Call ended for all users by the meeting organizer.",
                resultCategories: [
                    "Success"
                ]
            },
            4521: {
                public: !0,
                code: 0,
                subCode: 4521,
                message: "Call ended because user disconnected from the call abruptly, this may be a result of a user closing the application that hosted the call, eg a user terminated application, closed browser of browser tab without proper hang-up.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            5e3: {
                public: !0,
                code: 0,
                subCode: 5e3,
                message: "Call ended for this participant as it was removed from the conversation by another participant.",
                resultCategories: [
                    "Success"
                ]
            },
            5003: {
                public: !0,
                code: 0,
                subCode: 5003,
                message: "Call ended successfully, as all callee endpoints declined the call.",
                resultCategories: [
                    "Success"
                ]
            },
            5010: {
                code: 0,
                subCode: 5010,
                message: "This conversation has ended as only one participant was remaining in the conversation.",
                resultCategories: [
                    "Success"
                ]
            },
            5013: {
                code: 0,
                subCode: 5013,
                message: "This conversation has ended as no one else has joined the group call.",
                resultCategories: [
                    "Success"
                ]
            },
            5014: {
                code: 0,
                subCode: 5014,
                message: "",
                resultCategories: [
                    "Success"
                ]
            },
            5300: {
                public: !0,
                code: 0,
                subCode: 5300,
                message: "Call ended for this participant as it was removed from the conversation by another participant.",
                resultCategories: [
                    "Success"
                ]
            },
            5854: {
                code: 0,
                subCode: 5854,
                message: "Removed from the Teams meeting lobby by another participant.",
                resultCategories: [
                    "Success"
                ]
            },
            5855: {
                code: 0,
                subCode: 5855,
                message: "Removed from Teams meeting lobby due to inactivity timeout.",
                resultCategories: [
                    "Success"
                ]
            },
            7e3: {
                public: !0,
                code: 0,
                subCode: 7e3,
                message: "Call was ended by Azure Communication Service Call Automation API or a server bot.",
                resultCategories: [
                    "Success"
                ]
            },
            7015: {
                code: 0,
                subCode: 7015,
                message: "Call ended by service because transfer completed successfully.",
                resultCategories: [
                    "Success"
                ]
            },
            54e4: {
                public: !0,
                code: 0,
                subCode: 54e4,
                message: "Call ended successfully by local PSTN caller.",
                resultCategories: [
                    "Success"
                ]
            },
            56e4: {
                public: !0,
                code: 0,
                subCode: 56e4,
                message: "Call ended successfully by remote PSTN participant.",
                resultCategories: [
                    "Success"
                ]
            }
        },
        400: {
            580040: {
                code: 400,
                subCode: 580040,
                message: "Error from CreateUsageRequest: User is not entitled to call this destination.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        401: {
            10009: {
                public: !0,
                code: 401,
                subCode: 10009,
                message: "Unauthenticated identity. Ensure that your Communication Services token is valid and not expired.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        403: {
            830: {
                code: 403,
                subCode: 830,
                message: "Only Communication Services user is allowed to join the Rooms meeting.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            5829: {
                code: 403,
                subCode: 5829,
                message: "The join isn't allowed for the Rooms meeting beyond end time or prior to start time of the meeting.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            510403: {
                public: !0,
                code: 403,
                subCode: 510403,
                message: "Call ended, as it has been marked as a spam and got blocked.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            560403: {
                code: 403,
                subCode: 560403,
                message: "Call was forbidden, cancelled or rejected",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        404: {
            404: {
                code: 404,
                subCode: 404,
                message: "Call failed, unable to start or join to a call with given Id, call does not exist. Please check if provided id is correct, and if the call did not end already and try again.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            4500: {
                code: 404,
                subCode: 4500,
                message: "Call failed, unable to start or join to a call with given Id, call does not exist. Please check if provided id is correct, and if the call did not end already and try again.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            560404: {
                code: 404,
                subCode: 560404,
                message: "Phone number not found.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        408: {
            4506: {
                public: !0,
                code: 408,
                subCode: 4506,
                message: "Call timed out. Check if the callee received and accepted the call.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            10057: {
                public: !0,
                code: 408,
                subCode: 10057,
                message: "Call failed, callee failed to finalize call setup, most likely callee lost network or terminated the application abruptly. Ensure clients are connected and available.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10325: {
                code: 408,
                subCode: 10325,
                message: "",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            500001: {
                code: 408,
                subCode: 500001,
                message: "Gateway (SBC) failover timer expired.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            560408: {
                code: 408,
                subCode: 560408,
                message: "The called party did not respond.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        410: {
            3100: {
                public: !0,
                code: 410,
                subCode: 3100,
                message: "Call setup failed due to unexpected network problem on the client, please check client's network and retry.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            3101: {
                public: !0,
                code: 410,
                subCode: 3101,
                message: "Call dropped due to unexpected network problem on the client, check the client's network and retry.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            3111: {
                public: !0,
                code: 410,
                subCode: 3111,
                message: "Call setup failed, unable to process media offer while connecting the call.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            3112: {
                public: !0,
                code: 410,
                subCode: 3112,
                message: "Call setup failed due to network configuration problem on the client side, please check client's network configuration, and retry.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            301004: {
                public: !0,
                code: 410,
                subCode: 301004,
                message: "Participant was removed from the call by the Azure Communication Services infrastructure due to inability to establish media connectivity with Azure Communication Services infrastructure during call setup. Check user's network configuration, including local network, firewalls, VPNs configuration and try again.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            },
            301005: {
                public: !0,
                code: 410,
                subCode: 301005,
                message: "Participant was removed from the call by the Azure Communication Services infrastructure due to loss of media connectivity with Azure Communication Services infrastructure, this usually happens if participant leaves the call abruptly or looses network connectivity. If participant wants to continue the call, it should reconnect.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        429: {
            5029: {
                code: 429,
                subCode: 5029,
                message: "",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10110: {
                code: 429,
                subCode: 10110,
                message: "This call has exceeded the maximum call lifetime.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        430: {
            10315: {
                code: 430,
                subCode: 10315,
                message: "Unable to deliver message to client application. Please ensure the client application is successfully sending netwwork requests to Azure Communication Services.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10317: {
                code: 430,
                subCode: 10317,
                message: "Unable to deliver message to client application. Please ensure the client application is successfully sending netwwork requests to Azure Communication Services.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        480: {
            10037: {
                public: !0,
                code: 480,
                subCode: 10037,
                message: "Target user did not have any endpoints registered with ACS. Please ensure that target user has at least one active endpoint and it is online.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10076: {
                public: !0,
                code: 480,
                subCode: 10076,
                message: "Target user was registered but it wasn't online at the time of the call. Ensure that target user has at least one active endpoint and it's online.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10077: {
                public: !0,
                code: 480,
                subCode: 10077,
                message: "Target user was registered with ACS and/or for push notifications, but it wasn't online at the time of the call. Ensure that target user has at least one active endpoint and it's online.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10078: {
                public: !0,
                code: 480,
                subCode: 10078,
                message: "Remote client endpoint not registered or not reachable. Ensure the remote client endpoint is successfully sending network requests to Azure Communication Services.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            560480: {
                code: 480,
                subCode: 560480,
                message: "No answer from callee. Please double check why the callee did not answer the call. Retry the call later in case that the callee was temporary unavailable.",
                resultCategories: [
                    "UnexpectedServerError"
                ]
            }
        },
        484: {
            560484: {
                code: 484,
                subCode: 560484,
                message: "Incomplete/Invalid callee address.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        486: {
            560486: {
                public: !0,
                code: 486,
                subCode: 560486,
                message: "Call ended because remote PSTN participant was busy. The number called was already in a call or having technical issues.",
                resultCategories: [
                    "Success"
                ]
            }
        },
        487: {
            0: {
                public: !0,
                code: 487,
                subCode: 0,
                message: "Call ended successfully as caller canceled the call.",
                resultCategories: [
                    "Success"
                ]
            },
            4501: {
                code: 487,
                subCode: 4501,
                message: "Call canceled, locally declined, ended due to an endpoint mismatch issue, or failed to generate media offer.",
                resultCategories: [
                    "Success"
                ]
            },
            10003: {
                public: !0,
                code: 487,
                subCode: 10003,
                message: "Call was cancelled for this user endpoint as it was was accepted elsewhere, by another endpoint.",
                resultCategories: [
                    "Success"
                ]
            },
            10004: {
                public: !0,
                code: 487,
                subCode: 10004,
                message: "Call was cancelled on timeout, as target user did not accept or reject it on time. Ensure that user saw the notification and/or application can handle it automatically and try to initiate that call again.",
                resultCategories: [
                    "ExpectedError"
                ]
            },
            10024: {
                public: !0,
                code: 487,
                subCode: 10024,
                message: "Call ended successfully as it was declined by all callee endpoints.",
                resultCategories: [
                    "Success"
                ]
            },
            540200: {
                code: 487,
                subCode: 540200,
                message: "Call canceled, locally declined, ended due to an endpoint mismatch issue, or failed to generate media offer.",
                resultCategories: [
                    "Success"
                ]
            },
            540487: {
                public: !0,
                code: 487,
                subCode: 540487,
                message: "Call ended successfully as caller canceled the call.",
                resultCategories: [
                    "Success"
                ]
            },
            560487: {
                code: 487,
                subCode: 560487,
                message: "Call cancelled by originator.",
                resultCategories: [
                    "Success"
                ]
            }
        },
        490: {
            4502: {
                public: !0,
                code: 490,
                subCode: 4502,
                message: "Call failed due to network connectivity problems, browser failed to complete the network HTTP request.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        495: {
            4507: {
                public: !0,
                code: 495,
                subCode: 4507,
                message: "Call ended as application didn't provide a valid Azure Communication Services token.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        496: {
            7: {
                public: !0,
                code: 496,
                subCode: 7,
                message: "Call ended as client lost network connection abruptly, and despite retrying multiple times it wasn't able to connect.",
                resultCategories: [
                    "ExpectedError"
                ]
            }
        },
        500: {
            10045: {
                code: 500,
                subCode: 10045,
                message: "Azure Communication Services infrastructure error. Please gather browser console logs, .HAR file, and contact Azure Communication Services support.",
                resultCategories: [
                    "UnexpectedClientError"
                ]
            }
        },
        503: {
            560503: {
                code: 503,
                subCode: 560503,
                message: "Unexpected server error",
                resultCategories: [
                    "UnexpectedServerError"
                ]
            }
        },
        603: {
            0: {
                public: !0,
                code: 603,
                subCode: 0,
                message: "Call ended successfully as it was declined from callee.",
                resultCategories: [
                    "Success"
                ]
            }
        }
    }, N = M.BAD_REQUEST, k = M.REQUEST_TIMEOUT, L = M.PRECONDITION_FAILED, F = M.UNPROCESSABLE_ENTITY, x = M.INTERNAL_ERROR, U = "19:preview-", V = {
        Date: !0,
        RegExp: !0,
        String: !0,
        Number: !0
    }, B = 3e3, H = Symbol("INTERNAL_TELEMETRY_ERROR_MESSAGE_SYMBOL");
    var $;
    class CallingCommunicationError extends Error {
        get code() {
            return this._code;
        }
        get subCode() {
            return this._subCode;
        }
        get resultCategories() {
            return this._resultCategories;
        }
        constructor(g){
            if (super(), this._code = 0, this._subCode = 0, this._resultCategories = [], this[$] = "", this.name = "CallingCommunicationError", g.originalError instanceof CallingCommunicationError) return this._code = g.originalError.code, this._subCode = g.originalError.subCode, this._resultCategories = g.originalError.resultCategories, this.message = g.originalError.message, this.stack = g.originalError.stack, void (this[H] = g.originalError[H]);
            g.defaultErrorMessageArgs ? this.message = g.defaultError.message.replace(/{(\d+)}/g, function(f, S) {
                return g.defaultErrorMessageArgs && void 0 !== g.defaultErrorMessageArgs[S] ? g.defaultErrorMessageArgs[S] : f;
            }) : this.message = g.defaultError.message, this._code = g.defaultError.code, this._subCode = g.defaultError.subCode, this._resultCategories = g.defaultError.resultCategories, g.originalError instanceof Error && (this.stack = g.originalError.stack, this[H] = g.originalError.message);
        }
    }
    $ = H;
    const j = Symbol("loggerKeySymbol");
    var G, q, W;
    function syncOperation(g) {
        return operationDecoratorFactory(g || "", !1);
    }
    function asyncOperation(g) {
        return operationDecoratorFactory(g || "", !0);
    }
    (G = g.CallAgentKind || (g.CallAgentKind = {})).CallAgent = "CallAgent", G.TeamsCallAgent = "TeamsCallAgent", (q = g.CallKind || (g.CallKind = {})).Call = "Call", q.TeamsCall = "TeamsCall", (W = g.IncomingCallKind || (g.IncomingCallKind = {})).IncomingCall = "IncomingCall", W.TeamsIncomingCall = "TeamsIncomingCall";
    const validateEmergencyCallOperation = (f)=>(S, v, _)=>{
            const C = _.value;
            return _.value = function(...S) {
                if (this.kind === g.CallKind.TeamsCall && this.isEmergencyCallInProgress()) throw new CallingCommunicationError({
                    defaultError: O.CALL.OPERATION_NOT_ALLOWED_DURING_EMERGENCY_CALL,
                    defaultErrorMessageArgs: [
                        f
                    ]
                });
                return C.apply(this, S);
            }, _;
        }, operationDecoratorFactory = (g, f)=>f ? (f, S, v)=>{
            const _ = v.value;
            return v.value = async function(...f) {
                let S;
                const v = +new Date;
                tryToLogAcsMessage(this, g, "started");
                try {
                    S = await _.apply(this, f), tryToLogAcsMessage(this, g, "succeeded", v);
                } catch (f) {
                    const S = new CallingCommunicationError({
                        defaultError: O.CALL.OPERATION_FAILED,
                        defaultErrorMessageArgs: [
                            g
                        ],
                        originalError: f
                    });
                    throw tryToLogAcsError(this, g, f, v), S;
                }
                return S;
            }, v;
        } : (f, S, v)=>{
            const _ = v.value;
            return v.value = function(...f) {
                let S;
                const v = +new Date;
                tryToLogAcsMessage(this, g, "started");
                try {
                    S = _.apply(this, f), tryToLogAcsMessage(this, g, "succeeded", v);
                } catch (f) {
                    const S = new CallingCommunicationError({
                        defaultError: O.CALL.OPERATION_FAILED,
                        defaultErrorMessageArgs: [
                            g
                        ],
                        originalError: f
                    });
                    throw tryToLogAcsError(this, g, f, v), S;
                }
                return S;
            }, v;
        };
    function tryToLogAcsMessage(g, f, S, v) {
        const _ = getAcsLogger(g);
        if (_) {
            const g = v ? `in ${(+new Date - v) / 1e3}s` : "";
            _.info(`op:${f}, ${S} ${g}`);
        }
    }
    function tryToLogAcsError(g, f, S, v) {
        const _ = getAcsLogger(g);
        try {
            if (_) {
                const g = v ? `in ${(+new Date - v) / 1e3}s` : "";
                _.error(`op:${f} failed, message=${S.message}, code=${S.code}${S.subCode ? `, subCode=${S.subCode}` : ""} ${g}`), S && _.error(`op:${f} failed, message=${S.message}, code=${S.code}, subCode=${S.subCode}, resultCategories=${S.resultCategories}, time elapsed=${g}`);
            }
        } catch (S) {}
    }
    function getAcsLogger(g) {
        try {
            const f = Reflect.getMetadata(j, g);
            if (f) return g[f];
        } catch (g) {}
    }
    function generateGuid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (g)=>{
            const f = 16 * Math.random() | 0;
            return ("x" === g ? f : 3 & f | 8).toString(16);
        });
    }
    var z = "function", K = "object", J = "undefined", Y = "prototype", Q = Object, X = Q[Y];
    /*! https://github.com/nevware21/ts-utils v0.11.3 */ function _pureAssign(g, f) {
        return g || f;
    }
    function _pureRef(g, f) {
        return g[f];
    }
    var Z, ee = void 0, te = null, ie = "", ne = "function", re = "object", ae = "prototype", se = "__proto__", oe = "undefined", le = "constructor", ce = "Symbol", de = "_polyfill", ue = "length", he = "name", ge = "call", pe = "toString", me = _pureAssign(Object), fe = _pureRef(me, ae), Se = _pureAssign(String), ve = _pureRef(Se, ae), _e = _pureAssign(Math), Ce = _pureAssign(Array), ye = _pureRef(Ce, ae), Ee = _pureRef(ye, "slice");
    function safe(g, f) {
        try {
            return {
                v: g.apply(this, f)
            };
        } catch (g) {
            return {
                e: g
            };
        }
    }
    function safeGet(g, f) {
        var S = safe(g);
        return S.e ? f : S.v;
    }
    function _createIs(g) {
        return function(f) {
            return typeof f === g;
        };
    }
    function _createObjIs(g) {
        var f = "[object " + g + "]";
        return function(g) {
            return !(!g || objToString(g) !== f);
        };
    }
    function objToString(g) {
        return fe[pe].call(g);
    }
    function isUndefined(g) {
        return typeof g === oe || g === oe;
    }
    function isNullOrUndefined(g) {
        return g === te || isUndefined(g);
    }
    function isStrictNullOrUndefined(g) {
        return g === te || !isDefined(g);
    }
    function isDefined(g) {
        return !!g || g !== ee;
    }
    function isPrimitiveType(g) {
        return !Z && (Z = [
            "string",
            "number",
            "boolean",
            oe,
            "symbol",
            "bigint"
        ]), g !== re && -1 !== Z.indexOf(g);
    }
    var Te = _createIs("string"), Ie = _createIs(ne);
    function isObject(g) {
        return !(!g && isNullOrUndefined(g)) && !!g && typeof g === re;
    }
    var be = _pureRef(Ce, "isArray"), Ae = _createObjIs("Date"), Re = _createIs("number"), Pe = _createIs("boolean"), we = _createObjIs("Error");
    function isPromiseLike(g) {
        return !!(g && g.then && Ie(g.then));
    }
    function isTruthy(g) {
        return !(!g || safeGet(function() {
            return !(g && 0 + g);
        }, !g));
    }
    var Me = _pureRef(me, "getOwnPropertyDescriptor");
    function objHasOwnProperty(g, f) {
        return !!g && fe.hasOwnProperty[ge](g, f);
    }
    var Oe = _pureAssign(_pureRef(me, "hasOwn"), polyObjHasOwn);
    function polyObjHasOwn(g, f) {
        return objHasOwnProperty(g, f) || !!Me(g, f);
    }
    function objForEachKey(g, f, S) {
        if (g && isObject(g)) {
            for(var v in g)if (Oe(g, v) && -1 === f[ge](S || g, v, g[v])) break;
        }
    }
    var De = {
        e: "enumerable",
        c: "configurable",
        v: "value",
        w: "writable",
        g: "get",
        s: "set"
    };
    function _createProp(g) {
        var f = {};
        if (f[De.c] = !0, f[De.e] = !0, g.l) {
            f.get = function() {
                return g.l.v;
            };
            var S = Me(g.l, "v");
            S && S.set && (f.set = function(f) {
                g.l.v = f;
            });
        }
        return objForEachKey(g, function(g, S) {
            f[De[g]] = isUndefined(S) ? f[De[g]] : S;
        }), f;
    }
    var Ne = _pureRef(me, "defineProperty"), ke = _pureRef(me, "defineProperties");
    function objDefine(g, f, S) {
        return Ne(g, f, _createProp(S));
    }
    function objDefineProps(g, f) {
        var S = {};
        return objForEachKey(f, function(g, f) {
            S[g] = _createProp(f);
        }), ke(g, S);
    }
    function _createKeyValueMap(g, f, S, v, _) {
        var C = {};
        return objForEachKey(g, function(g, v) {
            _assignMapValue(C, g, f ? v : g, _), _assignMapValue(C, v, S ? v : g, _);
        }), v ? v(C) : C;
    }
    function _assignMapValue(g, f, S, v) {
        Ne(g, f, {
            value: S,
            enumerable: !0,
            writable: !!v
        });
    }
    var Le = _pureAssign(Se), Fe = "[object Error]";
    function dumpObj(g, f) {
        var S = ie, v = fe[pe][ge](g);
        v === Fe && (g = {
            stack: Le(g.stack),
            message: Le(g.message),
            name: Le(g.name)
        });
        try {
            S = (S = JSON.stringify(g, te, f ? "number" == typeof f ? f : 4 : ee)) && S.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") || Le(g);
        } catch (g) {
            S = " - " + dumpObj(g, f);
        }
        return v + ": " + S;
    }
    function throwError(g) {
        throw new Error(g);
    }
    function throwTypeError(g) {
        throw new TypeError(g);
    }
    var xe = _pureRef(me, "freeze");
    function _doNothing(g) {
        return g;
    }
    function _getProto(g) {
        return g[se] || te;
    }
    var Ue = _pureRef(me, "assign"), Ve = _pureRef(me, "keys");
    function objDeepFreeze(g) {
        return xe && objForEachKey(g, function(g, f) {
            (be(f) || isObject(f)) && objDeepFreeze(f);
        }), Be(g);
    }
    var Be = _pureAssign(xe, _doNothing), He = _pureAssign(_pureRef(me, "getPrototypeOf"), _getProto);
    function createEnum(g) {
        return _createKeyValueMap(g, 1, 0, Be);
    }
    function createEnumKeyMap(g) {
        return _createKeyValueMap(g, 0, 0, Be);
    }
    function createSimpleMap(g) {
        var f = {};
        return objForEachKey(g, function(g, S) {
            _assignMapValue(f, g, S[1]), _assignMapValue(f, S[0], S[1]);
        }), Be(f);
    }
    function createTypeMap(g) {
        return createSimpleMap(g);
    }
    var $e, je = createEnumKeyMap({
        asyncIterator: 0,
        hasInstance: 1,
        isConcatSpreadable: 2,
        iterator: 3,
        match: 4,
        matchAll: 5,
        replace: 6,
        search: 7,
        species: 8,
        split: 9,
        toPrimitive: 10,
        toStringTag: 11,
        unscopables: 12
    }), Ge = "__tsUtils$gblCfg";
    function _getGlobalValue() {
        var g;
        return typeof globalThis !== oe && (g = globalThis), g || typeof self === oe || (g = self), g || typeof window === oe || (g = window), g || typeof $parcel$global === oe || (g = $parcel$global), g;
    }
    function _getGlobalConfig() {
        if (!$e) {
            var g = safe(_getGlobalValue).v || {};
            $e = g[Ge] = g[Ge] || {};
        }
        return $e;
    }
    var qe = _unwrapFunctionWithPoly;
    function _unwrapFunctionWithPoly(g, f, S) {
        var v = f && f[g];
        return function(f) {
            var _ = f && f[g] || v;
            if (_ || S) {
                var C = arguments;
                return (_ || S).apply(f, _ ? Ee[ge](C, 1) : C);
            }
            throwTypeError('"' + Le(g) + '" not defined for ' + dumpObj(f));
        };
    }
    function _unwrapProp(g) {
        return function(f) {
            return f[g];
        };
    }
    var We = _pureRef(_e, "max"), ze = qe("slice", ve), Ke = qe("substring", ve), Je = _unwrapFunctionWithPoly("substr", ve, polyStrSubstr);
    function polyStrSubstr(g, f, S) {
        return isNullOrUndefined(g) && throwTypeError("Invalid " + dumpObj(g)), S < 0 ? ie : ((f = f || 0) < 0 && (f = We(f + g[ue], 0)), isUndefined(S) ? ze(g, f) : ze(g, f, f + S));
    }
    function strLeft(g, f) {
        return Ke(g, 0, f);
    }
    var Ye, Qe, Xe, Ze = "_urid";
    function _globalSymbolRegistry() {
        if (!Ye) {
            var g = _getGlobalConfig();
            Ye = g.gblSym = g.gblSym || {
                k: {},
                s: {}
            };
        }
        return Ye;
    }
    function polyNewSymbol(g) {
        var f = {
            description: Le(g),
            toString: function() {
                return ce + "(" + g + ")";
            }
        };
        return f[de] = !0, f;
    }
    function polySymbolFor(g) {
        var f = _globalSymbolRegistry();
        if (!Oe(f.k, g)) {
            var S = polyNewSymbol(g), v = Ve(f.s).length;
            S[Ze] = function() {
                return v + "_" + S[pe]();
            }, f.k[g] = S, f.s[S[Ze]()] = Le(g);
        }
        return f.k[g];
    }
    function polyGetKnownSymbol(g) {
        var f;
        !Qe && (Qe = {});
        var S = je[g];
        return S && (f = Qe[S] = Qe[S] || polyNewSymbol(ce + "." + S)), f;
    }
    function _initTestHooks() {
        Xe = _getGlobalConfig();
    }
    function getLazy(g) {
        var f = {};
        return !Xe && _initTestHooks(), f.b = Xe.lzy, Ne(f, "v", {
            configurable: !0,
            get: function() {
                var S = g();
                return Xe.lzy || Ne(f, "v", {
                    value: S
                }), f.b = Xe.lzy, S;
            }
        }), f;
    }
    function createCachedValue(g) {
        return Ne({
            toJSON: function() {
                return g;
            }
        }, "v", {
            value: g
        });
    }
    var et, tt = "window";
    function _getGlobalInstFn(g, f) {
        var S;
        return function() {
            return !Xe && _initTestHooks(), (!S || Xe.lzy) && (S = createCachedValue(safe(g, f).v)), S.v;
        };
    }
    function getGlobal(g) {
        return !Xe && _initTestHooks(), (!et || !1 === g || Xe.lzy) && (et = createCachedValue(safe(_getGlobalValue).v || te)), et.v;
    }
    function getInst(g, f) {
        var S = et && !1 !== f ? et.v : getGlobal(f);
        return S && S[g] ? S[g] : g === tt ? nt() : te;
    }
    function hasDocument() {
        return !!it();
    }
    var it = _getGlobalInstFn(getInst, [
        "document"
    ]);
    function hasWindow() {
        return !!nt();
    }
    var nt = _getGlobalInstFn(getInst, [
        tt
    ]);
    function hasNavigator() {
        return !!ot();
    }
    var rt, at, st, ot = _getGlobalInstFn(getInst, [
        "navigator"
    ]), lt = _getGlobalInstFn(function() {
        return !!safe(function() {
            return $lUPho && ($lUPho.versions || {}).node;
        }).v;
    });
    function _initSymbol() {
        return rt = createCachedValue(safe(getInst, [
            ce
        ]).v);
    }
    function _getSymbolKey(g) {
        var f = (Xe.lzy ? 0 : rt) || _initSymbol();
        return f.v ? f.v[g] : ee;
    }
    function hasSymbol() {
        return !!getSymbol();
    }
    function getSymbol() {
        return !Xe && _initTestHooks(), ((Xe.lzy ? 0 : rt) || _initSymbol()).v;
    }
    function getKnownSymbol(g, f) {
        var S = je[g];
        !Xe && _initTestHooks();
        var v = (Xe.lzy ? 0 : rt) || _initSymbol();
        return v.v ? v.v[S || g] : f ? ee : polyGetKnownSymbol(g);
    }
    function newSymbol(g, f) {
        !Xe && _initTestHooks();
        var S = (Xe.lzy ? 0 : rt) || _initSymbol();
        return S.v ? S.v(g) : f ? te : polyNewSymbol(g);
    }
    function symbolFor(g) {
        return !Xe && _initTestHooks(), ((at = (Xe.lzy ? 0 : at) || createCachedValue(safe(_getSymbolKey, [
            "for"
        ]).v)).v || polySymbolFor)(g);
    }
    function isIterator(g) {
        return !!g && Ie(g.next);
    }
    function isIterable(g) {
        return !isStrictNullOrUndefined(g) && Ie(g[getKnownSymbol(3)]);
    }
    function iterForOf(g, f, S) {
        if (g && (isIterator(g) || (!st && (st = createCachedValue(getKnownSymbol(3))), g = g[st.v] ? g[st.v]() : null), isIterator(g))) {
            var v = ee, _ = ee;
            try {
                for(var C = 0; !(_ = g.next()).done && -1 !== f[ge](S || g, _.value, C, g);)C++;
            } catch (f) {
                v = {
                    e: f
                }, g.throw && (_ = te, g.throw(v));
            } finally{
                try {
                    _ && !_.done && g.return && g.return(_);
                } finally{
                    if (v) throw v.e;
                }
            }
        }
    }
    function fnApply(g, f, S) {
        return g.apply(f, S);
    }
    function arrAppend(g, f) {
        return !isUndefined(f) && g && (be(f) ? fnApply(g.push, g, f) : isIterator(f) || isIterable(f) ? iterForOf(f, function(f) {
            g.push(f);
        }) : g.push(f)), g;
    }
    function arrForEach(g, f, S) {
        if (g) for(var v = g[ue] >>> 0, _ = 0; _ < v && (!(_ in g) || -1 !== f[ge](S || g, g[_], _, g)); _++);
    }
    var ct = qe("indexOf", ye);
    function arrSlice(g, f, S) {
        return (g && g.slice || Ee).apply(g, Ee[ge](arguments, 1));
    }
    var dt, ut = _pureAssign(_pureRef(me, "create"), polyObjCreate);
    function polyObjCreate(g) {
        if (!g) return {};
        var f = typeof g;
        function tempFunc() {}
        return f !== re && f !== ne && throwTypeError("Prototype must be an Object or function: " + dumpObj(g)), tempFunc[ae] = g, new tempFunc;
    }
    function objSetPrototypeOf(g, f) {
        var S = me.setPrototypeOf || function(g, f) {
            var S;
            !dt && (dt = createCachedValue(((S = {})[se] = [], S instanceof Array))), dt.v ? g[se] = f : objForEachKey(f, function(f, S) {
                return g[f] = S;
            });
        };
        return S(g, f);
    }
    function _createCustomError(g, f, S) {
        function __() {
            this[le] = f, safe(objDefine, [
                this,
                he,
                {
                    v: g,
                    c: !0,
                    e: !1
                }
            ]);
        }
        return safe(objDefine, [
            f,
            he,
            {
                v: g,
                c: !0,
                e: !1
            }
        ]), (f = objSetPrototypeOf(f, S))[ae] = S === te ? ut(S) : (__[ae] = S[ae], new __), f;
    }
    function _setName(g, f) {
        f && (g[he] = f);
    }
    function createCustomError(g, f, S) {
        var v = S || Error, _ = v[ae][he], C = Error.captureStackTrace;
        return _createCustomError(g, function() {
            var S = this, E = arguments;
            try {
                safe(_setName, [
                    v,
                    g
                ]);
                var T = fnApply(v, S, Ee[ge](E)) || S;
                if (T !== S) {
                    var I = He(S);
                    I !== He(T) && objSetPrototypeOf(T, I);
                }
                return C && C(T, S[le]), f && f(T, E), T;
            } finally{
                safe(_setName, [
                    v,
                    _
                ]);
            }
        }, v);
    }
    function utcNow() {
        return (Date.now || polyUtcNow)();
    }
    function polyUtcNow() {
        return (new Date).getTime();
    }
    function _createTrimFn(g) {
        return function _doTrim(f) {
            return isNullOrUndefined(f) && throwTypeError("strTrim called [" + dumpObj(f) + "]"), f && f.replace && (f = f.replace(g, ie)), f;
        };
    }
    var ht, gt, pt, mt = _unwrapFunctionWithPoly("trim", ve, _createTrimFn(/^\s+|(?=\s)\s+$/g));
    function isPlainObject(g) {
        if (!g || typeof g !== re) return !1;
        pt || (pt = !hasWindow() || nt());
        var f = !1;
        if (g !== pt) {
            gt || (ht = Function[ae][pe], gt = ht[ge](me));
            try {
                var S = He(g);
                (f = !S) || (objHasOwnProperty(S, le) && (S = S[le]), f = S && typeof S === ne && ht[ge](S) === gt);
            } catch (g) {}
        }
        return f;
    }
    function _defaultDeepCopyHandler(g) {
        return g.value && plainObjDeepCopyHandler(g), !0;
    }
    var ft = [
        arrayDeepCopyHandler,
        plainObjDeepCopyHandler,
        functionDeepCopyHandler,
        dateDeepCopyHandler
    ];
    function _getSetVisited(g, f, S, v) {
        var _;
        return arrForEach(g, function(g) {
            if (g.k === f) return _ = g, -1;
        }), _ || (_ = {
            k: f,
            v: f
        }, g.push(_), v(_)), _.v;
    }
    function _deepCopy(g, f, S, v) {
        var _ = S.handler, C = S.path ? v ? S.path.concat(v) : S.path : [], E = {
            handler: S.handler,
            src: S.src,
            path: C
        }, T = typeof f, I = !1, b = !1;
        f && T === re ? I = isPlainObject(f) : b = f === te || isPrimitiveType(T);
        var A = {
            type: T,
            isPrim: b,
            isPlain: I,
            value: f,
            result: f,
            path: C,
            origin: S.src,
            copy: function(f, v) {
                return _deepCopy(g, f, v ? E : S, v);
            },
            copyTo: function(f, S) {
                return _copyProps(g, f, S, E);
            }
        };
        return A.isPrim ? _ && _[ge](S, A) ? A.result : f : _getSetVisited(g, f, C, function(g) {
            objDefine(A, "result", {
                g: function() {
                    return g.v;
                },
                s: function(f) {
                    g.v = f;
                }
            });
            for(var f = 0, v = _; !(v || (f < ft.length ? ft[f++] : _defaultDeepCopyHandler))[ge](S, A);)v = te;
        });
    }
    function _copyProps(g, f, S, v) {
        if (!isNullOrUndefined(S)) for(var _ in S)f[_] = _deepCopy(g, S[_], v, _);
        return f;
    }
    function objCopyProps(g, f, S) {
        return _copyProps([], g, f, {
            handler: S,
            src: f,
            path: []
        });
    }
    function objDeepCopy(g, f) {
        return _deepCopy([], g, {
            handler: f,
            src: g
        });
    }
    function arrayDeepCopyHandler(g) {
        var f = g.value;
        if (be(f)) {
            var S = g.result = [];
            return S.length = f.length, g.copyTo(S, f), !0;
        }
        return !1;
    }
    function dateDeepCopyHandler(g) {
        var f = g.value;
        return !!Ae(f) && (g.result = new Date(f.getTime()), !0);
    }
    function functionDeepCopyHandler(g) {
        return g.type === ne;
    }
    function plainObjDeepCopyHandler(g) {
        var f = g.value;
        if (f && g.isPlain) {
            var S = g.result = {};
            return g.copyTo(S, f), !0;
        }
        return !1;
    }
    function _doExtend(g, f) {
        return arrForEach(f, function(f) {
            objCopyProps(g, f);
        }), g;
    }
    function deepExtend(g, f, S, v, _, C, E) {
        return _doExtend(objDeepCopy(g) || {}, Ee[ge](arguments));
    }
    var St, vt = _unwrapProp(ue);
    function getPerformance() {
        return !Xe && _initTestHooks(), (!St || Xe.lzy) && (St = createCachedValue(safe(getInst, [
            "performance"
        ]).v)), St.v;
    }
    function perfNow() {
        var g = getPerformance();
        return g && g.now ? g.now() : utcNow();
    }
    var _t = _unwrapFunctionWithPoly("endsWith", ve, polyStrEndsWith);
    function polyStrEndsWith(g, f, S) {
        Te(g) || throwTypeError("'" + dumpObj(g) + "' is not a string");
        var v = Te(f) ? f : Le(f), _ = !isUndefined(S) && S < g[ue] ? S : g[ue];
        return Ke(g, _ - v[ue], _) === v;
    }
    var Ct = qe("indexOf", ve), yt = _unwrapFunctionWithPoly("startsWith", ve, polyStrStartsWith);
    function polyStrStartsWith(g, f, S) {
        Te(g) || throwTypeError("'" + dumpObj(g) + "' is not a string");
        var v = Te(f) ? f : Le(f), _ = S > 0 ? S : 0;
        return Ke(g, _, _ + v[ue]) === v;
    }
    var Et = "ref", Tt = "unref", It = "hasRef", bt = "enabled";
    function _createTimerHandler(g, f, S) {
        var v, _ = !0, C = g ? f(te) : te;
        function _unref() {
            return _ = !1, C && C[Tt] && C[Tt](), v;
        }
        function _cancel() {
            C && S(C), C = te;
        }
        function _refresh() {
            return C = f(C), _ || _unref(), v;
        }
        function _setEnabled(g) {
            !g && C && _cancel(), g && !C && _refresh();
        }
        return (v = {
            cancel: _cancel,
            refresh: _refresh
        })[It] = function() {
            return C && C[It] ? C[It]() : _;
        }, v[Et] = function() {
            return _ = !0, C && C[Et] && C[Et](), v;
        }, v[Tt] = _unref, {
            h: v = Ne(v, bt, {
                get: function() {
                    return !!C;
                },
                set: _setEnabled
            }),
            dn: function() {
                C = te;
            }
        };
    }
    function _createTimeoutWith(g, f, S) {
        var v = be(f), _ = v ? f.length : 0, C = (_ > 0 ? f[0] : v ? ee : f) || setTimeout, E = (_ > 1 ? f[1] : ee) || clearTimeout, T = S[0];
        S[0] = function() {
            I.dn(), fnApply(T, ee, Ee[ge](arguments));
        };
        var I = _createTimerHandler(g, function(g) {
            if (g) {
                if (g.refresh) return g.refresh(), g;
                fnApply(E, ee, [
                    g
                ]);
            }
            return fnApply(C, ee, S);
        }, function(g) {
            fnApply(E, ee, [
                g
            ]);
        });
        return I.h;
    }
    function scheduleTimeout(g, f) {
        return _createTimeoutWith(!0, ee, Ee[ge](arguments));
    }
    function scheduleTimeoutWith(g, f, S) {
        return _createTimeoutWith(!0, g, Ee[ge](arguments, 1));
    }
    function createTimeout(g, f) {
        return _createTimeoutWith(!1, ee, Ee[ge](arguments));
    }
    (getGlobal() || {}).Symbol, (getGlobal() || {}).Reflect;
    var At, Rt = "hasOwnProperty", extendStaticsFn = function(g, f) {
        return extendStaticsFn = Q.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f[Rt](S) && (g[S] = f[S]);
        }, extendStaticsFn(g, f);
    };
    function __extendsFn(g, f) {
        function __() {
            this.constructor = g;
        }
        typeof f !== z && null !== f && throwTypeError("Class extends value " + String(f) + " is not a constructor or null"), extendStaticsFn(g, f), g[Y] = null === f ? ut(f) : (__[Y] = f[Y], new __);
    }
    function __spreadArrayFn(g, f) {
        for(var S = 0, v = f.length, _ = g.length; S < v; S++, _++)g[_] = f[S];
        return g;
    }
    var Pt = "constructor", wt = "prototype", Mt = "function", Ot = "_dynInstFuncs", Dt = "_isDynProxy", Nt = "_dynClass", kt = "_dynCls$", Lt = "_dynInstChk", Ft = Lt, xt = "_dfOpts", Ut = "_unknown_", Vt = "__proto__", Bt = "_dyn" + Vt, Ht = "__dynProto$Gbl", $t = "_dynInstProto", jt = "useBaseInst", Gt = "setInstFuncs", qt = Object, Wt = qt.getPrototypeOf, zt = qt.getOwnPropertyNames, Kt = getGlobal(), Jt = Kt[Ht] || (Kt[Ht] = {
        o: (At = {}, At[Gt] = !0, At[jt] = !0, At),
        n: 1e3
    });
    function _isObjectOrArrayPrototype(g) {
        return g && (g === qt[wt] || g === Array[wt]);
    }
    function _isObjectArrayOrFunctionPrototype(g) {
        return _isObjectOrArrayPrototype(g) || g === Function[wt];
    }
    function _getObjProto(g) {
        var f;
        if (g) {
            if (Wt) return Wt(g);
            var S = g[Vt] || g[wt] || (g[Pt] ? g[Pt][wt] : null);
            f = g[Bt] || S, objHasOwnProperty(g, Bt) || (delete g[$t], f = g[Bt] = g[$t] || g[Bt], g[$t] = S);
        }
        return f;
    }
    function _forEachProp(g, f) {
        var S = [];
        if (zt) S = zt(g);
        else for(var v in g)"string" == typeof v && objHasOwnProperty(g, v) && S.push(v);
        if (S && S.length > 0) for(var _ = 0; _ < S.length; _++)f(S[_]);
    }
    function _isDynamicCandidate(g, f, S) {
        return f !== Pt && typeof g[f] === Mt && (S || objHasOwnProperty(g, f)) && f !== Vt && f !== wt;
    }
    function _throwTypeError(g) {
        throwTypeError("DynamicProto: " + g);
    }
    function _getInstanceFuncs(g) {
        var f = ut(null);
        return _forEachProp(g, function(S) {
            !f[S] && _isDynamicCandidate(g, S, !1) && (f[S] = g[S]);
        }), f;
    }
    function _hasVisited(g, f) {
        for(var S = g.length - 1; S >= 0; S--)if (g[S] === f) return !0;
        return !1;
    }
    function _getBaseFuncs(g, f, S, v) {
        function _instFuncProxy(g, f, S) {
            var _ = f[S];
            if (_[Dt] && v) {
                var C = g[Ot] || {};
                !1 !== C[Ft] && (_ = (C[f[Nt]] || {})[S] || _);
            }
            return function() {
                return _.apply(g, arguments);
            };
        }
        var _ = ut(null);
        _forEachProp(S, function(g) {
            _[g] = _instFuncProxy(f, S, g);
        });
        for(var C = _getObjProto(g), E = []; C && !_isObjectArrayOrFunctionPrototype(C) && !_hasVisited(E, C);)_forEachProp(C, function(g) {
            !_[g] && _isDynamicCandidate(C, g, !Wt) && (_[g] = _instFuncProxy(f, C, g));
        }), E.push(C), C = _getObjProto(C);
        return _;
    }
    function _getInstFunc(g, f, S, v) {
        var _ = null;
        if (g && objHasOwnProperty(S, Nt)) {
            var C = g[Ot] || ut(null);
            if ((_ = (C[S[Nt]] || ut(null))[f]) || _throwTypeError("Missing [" + f + "] " + Mt), !_[Lt] && !1 !== C[Ft]) {
                for(var E = !objHasOwnProperty(g, f), T = _getObjProto(g), I = []; E && T && !_isObjectArrayOrFunctionPrototype(T) && !_hasVisited(I, T);){
                    var b = T[f];
                    if (b) {
                        E = b === v;
                        break;
                    }
                    I.push(T), T = _getObjProto(T);
                }
                try {
                    E && (g[f] = _), _[Lt] = 1;
                } catch (g) {
                    C[Ft] = !1;
                }
            }
        }
        return _;
    }
    function _getProtoFunc(g, f, S) {
        var v = f[g];
        return v === S && (v = _getObjProto(f)[g]), typeof v !== Mt && _throwTypeError("[" + g + "] is not a " + Mt), v;
    }
    function _populatePrototype(g, f, S, v, _) {
        function _createDynamicPrototype(g, f) {
            var dynProtoProxy = function() {
                return (_getInstFunc(this, f, g, dynProtoProxy) || _getProtoFunc(f, g, dynProtoProxy)).apply(this, arguments);
            };
            return dynProtoProxy[Dt] = 1, dynProtoProxy;
        }
        if (!_isObjectOrArrayPrototype(g)) {
            var C = S[Ot] = S[Ot] || ut(null);
            if (!_isObjectOrArrayPrototype(C)) {
                var E = C[f] = C[f] || ut(null);
                !1 !== C[Ft] && (C[Ft] = !!_), _isObjectOrArrayPrototype(E) || _forEachProp(S, function(f) {
                    _isDynamicCandidate(S, f, !1) && S[f] !== v[f] && (E[f] = S[f], delete S[f], (!objHasOwnProperty(g, f) || g[f] && !g[f][Dt]) && (g[f] = _createDynamicPrototype(g, f)));
                });
            }
        }
    }
    function _checkPrototype(g, f) {
        if (Wt) {
            for(var S = [], v = _getObjProto(f); v && !_isObjectArrayOrFunctionPrototype(v) && !_hasVisited(S, v);){
                if (v === g) return !0;
                S.push(v), v = _getObjProto(v);
            }
            return !1;
        }
        return !0;
    }
    function _getObjName(g, f) {
        return objHasOwnProperty(g, wt) ? g.name || f || Ut : ((g || {})[Pt] || {}).name || f || Ut;
    }
    function dynamicProto(g, f, S, v) {
        objHasOwnProperty(g, wt) || _throwTypeError("theClass is an invalid class definition.");
        var _ = g[wt];
        _checkPrototype(_, f) || _throwTypeError("[" + _getObjName(g) + "] not in hierarchy of [" + _getObjName(f) + "]");
        var C = null;
        objHasOwnProperty(_, Nt) ? C = _[Nt] : (C = kt + _getObjName(g, "_") + "$" + Jt.n, Jt.n++, _[Nt] = C);
        var E = dynamicProto[xt], T = !!E[jt];
        T && v && void 0 !== v[jt] && (T = !!v[jt]);
        var I = _getInstanceFuncs(f);
        S(f, _getBaseFuncs(_, f, I, T));
        var b = !!Wt && !!E[Gt];
        b && v && (b = !!v[Gt]), _populatePrototype(_, C, f, I, !1 !== b);
    }
    dynamicProto[xt] = Jt.o;
    var Yt, Qt = createEnum, Xt = Qt({
        Unknown: 0,
        NonRetryableStatus: 1,
        InvalidEvent: 2,
        SizeLimitExceeded: 3,
        KillSwitch: 4,
        QueueFull: 5
    }), Zt = (Qt({
        Unknown: 0,
        NonRetryableStatus: 1,
        CleanStorage: 2,
        MaxInStorageTimeExceeded: 3
    }), Qt({
        NONE: 0,
        PENDING: 3,
        INACTIVE: 1,
        ACTIVE: 2
    })), ei = "toLowerCase", ti = "blkVal", ii = "length", ni = "rdOnly", ri = "notify", ai = "warnToConsole", si = "throwInternal", oi = "setDf", li = "watch", ci = "logger", di = "apply", ui = "push", hi = "splice", gi = "hdlr", pi = "cancel", mi = "initialize", fi = "identifier", Si = "removeNotificationListener", vi = "addNotificationListener", _i = "isInitialized", Ci = "instrumentationKey", yi = "INACTIVE", Ei = "value", Ti = "getNotifyMgr", Ii = "getPlugin", bi = "name", Ai = "iKey", Ri = "time", Pi = "processNext", wi = "getProcessTelContext", Mi = "pollInternalLogs", Oi = "enabled", Di = "stopPollingInternalLogs", Ni = "unload", ki = "onComplete", Li = "version", Fi = "loggingLevelConsole", xi = "createNew", Ui = "teardown", Vi = "messageId", Bi = "message", Hi = "isAsync", $i = "diagLog", ji = "_doTeardown", Gi = "update", qi = "getNext", Wi = "setNextPlugin", zi = "protocol", Ki = "userAgent", Ji = "split", Yi = "nodeType", Qi = "replace", Xi = "logInternalMessage", Zi = "type", en = "handler", tn = "status", nn = "getResponseHeader", rn = "getAllResponseHeaders", an = "isChildEvt", sn = "data", on = "getCtx", ln = "setCtx", cn = "complete", dn = "urlString", un = "sendPOST", hn = "headers", gn = "timeout", pn = "setRequestHeader", mn = "traceId", fn = "spanId", Sn = "traceFlags";
    function throwAggregationError(g, f) {
        Yt || (Yt = createCustomError("AggregationError", function(g, f) {
            f[ii] > 1 && (g.errors = f[1]);
        }));
        var S = g || "One or more errors occurred.";
        throw arrForEach(f, function(g, f) {
            S += "\n".concat(f, " > ").concat(dumpObj(g));
        }), new Yt(S, f || []);
    }
    /*!
	 * NevWare21 Solutions LLC - ts-async, 0.5.2
	 * https://github.com/nevware21/ts-async
	 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
	 * Licensed under the MIT license.
	 */ var vn = "Promise", _n = "rejected";
    function doAwaitResponse(g, f) {
        return doAwait(g, function(g) {
            return f ? f({
                status: "fulfilled",
                rejected: !1,
                value: g
            }) : g;
        }, function(g) {
            return f ? f({
                status: _n,
                rejected: !0,
                reason: g
            }) : g;
        });
    }
    function doAwait(g, f, S, v) {
        var _ = g;
        try {
            if (isPromiseLike(g)) (f || S) && (_ = g.then(f, S));
            else try {
                f && (_ = f(g));
            } catch (g) {
                if (!S) throw g;
                _ = S(g);
            }
        } finally{
            v && doFinally(_, v);
        }
        return _;
    }
    function doFinally(g, f) {
        var S = g;
        return f && (isPromiseLike(g) ? S = g.finally ? g.finally(f) : g.then(function(g) {
            return f(), g;
        }, function(g) {
            throw f(), g;
        }) : f()), S;
    }
    var Cn, yn = [
        "pending",
        "resolving",
        "resolved",
        _n
    ], En = "dispatchEvent";
    function _hasInitEventFn(g) {
        var f;
        return g && g.createEvent && (f = g.createEvent("Event")), !!f && f.initEvent;
    }
    function emitEvent(g, f, S, v) {
        var _ = it();
        !Cn && (Cn = createCachedValue(!!safe(_hasInitEventFn, [
            _
        ]).v));
        var C = Cn.v ? _.createEvent("Event") : v ? new Event(f) : {};
        if (S && S(C), Cn.v && C.initEvent(f, !1, !0), C && g[En]) g[En](C);
        else {
            var E = g["on" + f];
            if (E) E(C);
            else {
                var T = getInst("console");
                T && (T.error || T.log)(f, dumpObj(C));
            }
        }
    }
    var Tn, In = "unhandledRejection", bn = In.toLowerCase(), An = [], Rn = 0, Pn = 10;
    function dumpFnObj(g) {
        return Ie(g) ? g.toString() : dumpObj(g);
    }
    function _createPromise(g, f, S) {
        var v, _, C = arrSlice(arguments, 3), E = 0, T = !1, I = [], b = Rn++, A = !1, R = null;
        function _then(f, S) {
            try {
                return An.push(b), A = !0, R && R.cancel(), R = null, g(function(g, _) {
                    I.push(function() {
                        try {
                            var C = 2 === E ? f : S, T = isUndefined(C) ? v : Ie(C) ? C(v) : C;
                            isPromiseLike(T) ? T.then(g, _) : C ? g(T) : 3 === E ? _(T) : g(T);
                        } catch (g) {
                            _(g);
                        }
                    }), T && _processQueue();
                }, C);
            } finally{
                An.pop();
            }
        }
        function _catch(g) {
            return _then(void 0, g);
        }
        function _finally(g) {
            var f = g, S = g;
            return Ie(g) && (f = function(f) {
                return g && g(), f;
            }, S = function(f) {
                throw g && g(), f;
            }), _then(f, S);
        }
        function _strState() {
            return yn[E];
        }
        function _processQueue() {
            if (I.length > 0) {
                var g = I.slice();
                I = [], A = !0, R && R.cancel(), R = null, f(g);
            }
        }
        function _createSettleIfFn(g, f) {
            return function(S) {
                if (E === f) {
                    if (2 === g && isPromiseLike(S)) return E = 1, void S.then(_createSettleIfFn(2, 1), _createSettleIfFn(3, 1));
                    E = g, T = !0, v = S, _processQueue(), A || 3 !== g || R || (R = scheduleTimeout(_notifyUnhandledRejection, Pn));
                }
            };
        }
        function _notifyUnhandledRejection() {
            if (!A) {
                if (A = !0, lt()) $lUPho.emit(In, v, _);
                else {
                    var g = nt() || getGlobal();
                    !Tn && (Tn = createCachedValue(safe(getInst, [
                        vn + "RejectionEvent"
                    ]).v)), emitEvent(g, bn, function(g) {
                        return objDefine(g, "promise", {
                            g: function() {
                                return _;
                            }
                        }), g.reason = v, g;
                    }, !!Tn.v);
                }
            }
        }
        function _toString() {
            return "IPromise " + _strState() + (T ? " - " + dumpFnObj(v) : "");
        }
        return Ne(_ = {
            then: _then,
            catch: _catch,
            finally: _finally
        }, "state", {
            get: _strState
        }), hasSymbol() && (_[getKnownSymbol(11)] = "IPromise"), _.toString = _toString, function _initialize() {
            Ie(S) || throwTypeError(vn + ": executor is not a function - " + dumpFnObj(S));
            var g = _createSettleIfFn(3, 0);
            try {
                S.call(_, _createSettleIfFn(2, 0), g);
            } catch (f) {
                g(f);
            }
        }(), _;
    }
    function _createAllPromise(g) {
        return function(f) {
            var S = arrSlice(arguments, 1);
            return g(function(g, S) {
                try {
                    var v = [], _ = 1;
                    iterForOf(f, function(f, C) {
                        f && (_++, doAwait(f, function(f) {
                            v[C] = f, 0 == --_ && g(v);
                        }, S));
                    }), 0 === --_ && g(v);
                } catch (g) {
                    S(g);
                }
            }, S);
        };
    }
    function _createResolvedPromise(g) {
        return function(f) {
            var S = arrSlice(arguments, 1);
            return isPromiseLike(f) ? f : g(function(g) {
                g(f);
            }, S);
        };
    }
    function _createRejectedPromise(g) {
        return function(f) {
            var S = arrSlice(arguments, 1);
            return g(function(g, S) {
                S(f);
            }, S);
        };
    }
    function _createAllSettledPromise(g) {
        return createCachedValue(function(f) {
            var S = arrSlice(arguments, 1);
            return g(function(g, S) {
                var v = [], _ = 1;
                function processItem(f, S) {
                    _++, doAwaitResponse(f, function(f) {
                        f.rejected ? v[S] = {
                            status: _n,
                            reason: f.reason
                        } : v[S] = {
                            status: "fulfilled",
                            value: f.value
                        }, 0 == --_ && g(v);
                    });
                }
                try {
                    be(f) ? arrForEach(f, processItem) : isIterable(f) ? iterForOf(f, processItem) : throwTypeError("Input is not an iterable"), 0 === --_ && g(v);
                } catch (g) {
                    S(g);
                }
            }, S);
        });
    }
    function syncItemProcessor(g) {
        arrForEach(g, function(g) {
            try {
                g();
            } catch (g) {}
        });
    }
    function timeoutItemProcessor(g) {
        var f = Re(g) ? g : 0;
        return function(g) {
            scheduleTimeout(function() {
                syncItemProcessor(g);
            }, f);
        };
    }
    function createAsyncPromise(g, f) {
        return _createPromise(createAsyncPromise, timeoutItemProcessor(f), g, f);
    }
    var wn, Mn, On, Dn = _createAllPromise(createAsyncPromise), Nn = _createResolvedPromise(createAsyncPromise), kn = _createRejectedPromise(createAsyncPromise);
    function createNativePromise(g, f) {
        !wn && (wn = createCachedValue(safe(getInst, [
            vn
        ]).v || null));
        var S = wn.v;
        if (!S) return createAsyncPromise(g);
        Ie(g) || throwTypeError(vn + ": executor is not a function - " + dumpObj(g));
        var v = 0;
        function _strState() {
            return yn[v];
        }
        var _ = new S(function(f, S) {
            function _resolve(g) {
                v = 2, f(g);
            }
            function _reject(g) {
                v = 3, S(g);
            }
            g(_resolve, _reject);
        });
        return Ne(_, "state", {
            get: _strState
        }), _;
    }
    function createPromise(g, f) {
        return !Mn && (Mn = createCachedValue(createNativePromise)), Mn.v.call(this, g, f);
    }
    var Ln = _createAllPromise(createPromise);
    function createAllSettledPromise(g, f) {
        return !On && (On = _createAllSettledPromise(createPromise)), On.v(g, f);
    }
    var Fn, xn, Un = "reject", Vn = "Rejected", Bn = 0, Hn = {};
    function _rejectDone() {}
    function _createError(g, f, S) {
        !Hn[g] && (Hn[g] = createCustomError(g));
        var v = utcNow();
        return new Hn[g]("Task [".concat(f.id, "] ").concat(S || "", "- ").concat(f.st ? "Running" : "Waiting", ": ").concat(_calcTime(v, f.st || f.cr)));
    }
    function _calcTime(g, f) {
        return (g - f || "0") + " ms";
    }
    function _abortStaleTasks(g, f) {
        var S = utcNow() - f;
        arrForEach(g, function(g) {
            (g && !g.rj && g.st && g.st < S || !g.st && g.cr && g.cr < S) && g && g[Un](g.rj || _createError("Aborted", g, "Stale "));
        });
    }
    function _removeTask(g, f) {
        var S = ct(g, f);
        -1 !== S && g.splice(S, 1);
    }
    function _addDebugState(g, f, S) {
        xn = xn || {
            toString: function() {
                return "[[SchedulerState]]";
            }
        }, Ne(g, Fn = Fn || {
            toString: function() {
                return "[[SchedulerName]]";
            }
        }, {
            get: f
        }), Ne(g, xn, {
            get: S
        });
    }
    function createTaskScheduler(g, f) {
        var S, v, _ = [], C = [], E = 6e5, T = E / 10, I = 0, b = (f ? f + "." : "") + Bn++;
        g = g || createPromise;
        var _startBlockedTimer = function() {
            var g = vt(_) + vt(C) > 0;
            E > 0 && (v || (v = scheduleTimeout(function() {
                _abortStaleTasks(_, E), _abortStaleTasks(C, E), v && (v.enabled = vt(_) + vt(C) > 0);
            }, T)).unref(), v && (v.enabled = g));
        }, _queueTask = function(f, v, _) {
            var C, E = b + "." + I++;
            v && (E += "-(" + v + ")");
            var T = ((C = {
                id: E,
                cr: utcNow(),
                to: _
            })[Un] = function(g) {
                T.rj = g || _createError(Vn, T), T[Un] = _rejectDone;
            }, C);
            return T.p = S ? _waitForPreviousTask(T, S, f) : g(_runTask(T, f)), S = T, T.p;
        }, _runTask = function(g, f) {
            return g.st = utcNow(), _.push(g), _startBlockedTimer(), function(S, v) {
                var _promiseReject = function(f) {
                    g.rj = g.rj || f || _createError(Vn, g), g[Un] = _rejectDone, _doCleanup(g), S = null, v && v(f), v = null;
                }, _ = g.id;
                if (g.rj) _promiseReject(g.rj);
                else {
                    g[Un] = _promiseReject;
                    try {
                        var C = f(_);
                        g.to && isPromiseLike(C) && (g.t = scheduleTimeout(function() {
                            _promiseReject(_createError("Timeout", g));
                        }, g.to)), doAwait(C, function(f) {
                            _doCleanup(g);
                            try {
                                S && S(f);
                            } catch (g) {
                                v && v(g);
                            }
                            v = null, S = null;
                        }, _promiseReject);
                    } catch (g) {
                        _promiseReject(g);
                    }
                }
            };
        }, _waitForPreviousTask = function(f, S, v) {
            return C.push(f), _startBlockedTimer(), g(function(g, _) {
                doAwaitResponse(S.p, function() {
                    _removeTask(C, f), _runTask(f, v)(g, _);
                });
            });
        }, _doCleanup = function(g) {
            _removeTask(_, g), g.t && g.t.cancel(), g.t = null, S && S === g && (S = null, vt(_) + vt(C) === 0 && (v && v.cancel(), v = null));
        }, A = {
            idle: !0,
            queue: _queueTask,
            setStaleTimeout: function(g, f) {
                v && v.cancel(), v = null, E = g, T = f || g / 10, _startBlockedTimer();
            }
        };
        return objDefine(A, "idle", {
            g: function() {
                return vt(_) + vt(C) === 0;
            }
        }), _addDebugState(A, function() {
            return b;
        }, function() {
            return {
                l: S,
                r: _,
                w: C
            };
        }), A;
    }
    getKnownSymbol(11);
    var $n = void 0, jn = "", Gn = "channels", qn = "core", Wn = "createPerfMgr", zn = "disabled", Kn = "extensionConfig", Jn = "extensions", Yn = "processTelemetry", Qn = "priority", Xn = "eventsSent", Zn = "eventsDiscarded", er = "eventsSendRequest", tr = "perfEvent", ir = "offlineEventsStored", nr = "offlineBatchSent", rr = "offlineBatchDrop", ar = "getPerfMgr", sr = "domain", or = "path", lr = "Not dynamic - ", cr = /-([a-z])/g, dr = /([^\w\d_$])/g, ur = /^(\d+[\w\d_$])/;
    function isNotNullOrUndefined(g) {
        return !isNullOrUndefined(g);
    }
    function normalizeJsName(g) {
        var f = g;
        return f && Te(f) && (f = (f = (f = f[Qi](cr, function(g, f) {
            return f.toUpperCase();
        }))[Qi](dr, "_"))[Qi](ur, function(g, f) {
            return "_" + f;
        })), f;
    }
    function strContains(g, f) {
        return !(!g || !f) && -1 !== Ct(g, f);
    }
    function toISOString(g) {
        return g && g.toISOString() || "";
    }
    function getExceptionName(g) {
        return we(g) ? g[bi] : jn;
    }
    function setValue(g, f, S, v, _) {
        var C = S;
        return g && ((C = g[f]) === S || _ && !_(C) || v && !v(S) || (C = S, g[f] = C)), C;
    }
    function getSetValue(g, f, S) {
        var v;
        return g ? !(v = g[f]) && isNullOrUndefined(v) && (v = isUndefined(S) ? {} : S, g[f] = v) : v = isUndefined(S) ? {} : S, v;
    }
    function _createProxyFunction(g, f) {
        var S = null, v = null;
        return Ie(g) ? S = g : v = g, function() {
            var g = arguments;
            if (S && (v = S()), v) return v[f][di](v, g);
        };
    }
    function proxyFunctionAs(g, f, S, v, _) {
        g && f && S && (!1 !== _ || isUndefined(g[f])) && (g[f] = _createProxyFunction(S, v));
    }
    function proxyFunctions(g, f, S, v) {
        return g && f && isObject(g) && be(S) && arrForEach(S, function(S) {
            Te(S) && proxyFunctionAs(g, S, f, S, v);
        }), g;
    }
    function optimizeObject(g) {
        return g && Ue && (g = Q(Ue({}, g))), g;
    }
    function getResponseText(g) {
        try {
            return g.responseText;
        } catch (g) {}
        return null;
    }
    function formatErrorMessageXdr(g, f) {
        return g ? "XDomainRequest,Response:" + getResponseText(g) : f;
    }
    function formatErrorMessageXhr(g, f) {
        return g ? "XMLHttpRequest,Status:" + g[tn] + ",Response:" + getResponseText(g) || g.response || "" : f;
    }
    function prependTransports(g, f) {
        return f && (Re(f) ? g = [
            f
        ].concat(g) : be(f) && (g = f.concat(g))), g;
    }
    var hr = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", gr = "withCredentials", pr = "timeout";
    function openXhr(g, f, S, v, _, C) {
        function _wrapSetXhrProp(g, f, S) {
            try {
                g[f] = S;
            } catch (g) {}
        }
        void 0 === v && (v = !1), void 0 === _ && (_ = !1);
        var E = new XMLHttpRequest;
        return v && _wrapSetXhrProp(E, hr, v), S && _wrapSetXhrProp(E, gr, S), E.open(g, f, !_), S && _wrapSetXhrProp(E, gr, S), !_ && C && _wrapSetXhrProp(E, pr, C), E;
    }
    function convertAllHeadersToMap(g) {
        var f = {};
        Te(g) && arrForEach(mt(g)[Ji](/[\r\n]+/), function(g) {
            if (g) {
                var S = g.indexOf(": ");
                if (-1 !== S) {
                    var v = mt(g.substring(0, S))[ei](), _ = mt(g.substring(S + 1));
                    f[v] = _;
                } else f[mt(g)] = 1;
            }
        });
        return f;
    }
    function _appendHeader(g, f, S) {
        if (!g[S] && f && f[nn]) {
            var v = f[nn](S);
            v && (g[S] = mt(v));
        }
        return g;
    }
    var mr = "kill-duration", fr = "kill-duration-seconds", Sr = "time-delta-millis";
    function _getAllResponseHeaders(g, f) {
        var S = {};
        return g[rn] ? S = convertAllHeadersToMap(g[rn]()) : f && (S = _appendHeader(S, g, Sr), S = _appendHeader(S, g, mr), S = _appendHeader(S, g, fr)), S;
    }
    var vr = "location", _r = "console", Cr = "JSON", yr = "crypto", Er = "msCrypto", Tr = "ReactNative", Ir = "msie", br = "trident/", Ar = "XMLHttpRequest", Rr = null, Pr = null, wr = !1, Mr = null, Or = null;
    function _hasProperty(g, f) {
        var S = !1;
        if (g) {
            try {
                if (!(S = f in g)) {
                    var v = g[Y];
                    v && (S = f in v);
                }
            } catch (g) {}
            if (!S) try {
                S = !isUndefined((new g)[f]);
            } catch (g) {}
        }
        return S;
    }
    function getLocation(g) {
        if (g && wr) {
            var f = getInst("__mockLocation");
            if (f) return f;
        }
        return typeof location === K && location ? location : getInst(vr);
    }
    function getConsole() {
        return typeof console !== J ? console : getInst(_r);
    }
    function hasJSON() {
        return Boolean(typeof JSON === K && JSON || null !== getInst(Cr));
    }
    function getJSON() {
        return hasJSON() ? JSON || getInst(Cr) : null;
    }
    function getCrypto() {
        return getInst(yr);
    }
    function getMsCrypto() {
        return getInst(Er);
    }
    function isReactNative() {
        var g = ot();
        return !(!g || !g.product) && g.product === Tr;
    }
    function isIE() {
        var g = ot();
        if (g && (g[Ki] !== Pr || null === Rr)) {
            var f = ((Pr = g[Ki]) || jn)[ei]();
            Rr = strContains(f, Ir) || strContains(f, br);
        }
        return Rr;
    }
    function isBeaconsSupported(g) {
        return null !== Or && !1 !== g || (Or = hasNavigator() && Boolean(ot().sendBeacon)), Or;
    }
    function isFetchSupported(g) {
        var f = !1;
        try {
            f = !!getInst("fetch");
            var S = getInst("Request");
            f && g && S && (f = _hasProperty(S, "keepalive"));
        } catch (g) {}
        return f;
    }
    function useXDomainRequest() {
        return null === Mr && (Mr = typeof XDomainRequest !== J) && isXhrSupported() && (Mr = Mr && !_hasProperty(getInst(Ar), "withCredentials")), Mr;
    }
    function isXhrSupported() {
        var g = !1;
        try {
            g = !!getInst(Ar);
        } catch (g) {}
        return g;
    }
    var Dr = 4294967296, Nr = 4294967295, kr = 123456789, Lr = 987654321, Fr = !1, xr = kr, Ur = Lr;
    function _mwcSeed(g) {
        g < 0 && (g >>>= 0), xr = kr + g & Nr, Ur = Lr - g & Nr, Fr = !0;
    }
    function _autoSeedMwc() {
        try {
            var g = 2147483647 & utcNow();
            _mwcSeed((Math.random() * Dr ^ g) + g);
        } catch (g) {}
    }
    function random32(g) {
        var f = 0, S = getCrypto() || getMsCrypto();
        return S && S.getRandomValues && (f = S.getRandomValues(new Uint32Array(1))[0] & Nr), 0 === f && isIE() && (Fr || _autoSeedMwc(), f = mwcRandom32() & Nr), 0 === f && (f = Math.floor(Dr * Math.random() | 0)), g || (f >>>= 0), f;
    }
    function mwcRandom32(g) {
        var f = ((Ur = 36969 * (65535 & Ur) + (Ur >> 16) & Nr) << 16) + (65535 & (xr = 18e3 * (65535 & xr) + (xr >> 16) & Nr)) >>> 0 & Nr | 0;
        return g || (f >>>= 0), f;
    }
    function newId(g) {
        void 0 === g && (g = 22);
        for(var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S = random32() >>> 0, v = 0, _ = jn; _[ii] < g;)v++, _ += f.charAt(63 & S), S >>>= 6, 5 === v && (S = (random32() << 2 & 4294967295 | 3 & S) >>> 0, v = 0);
        return _;
    }
    var Vr = "3.3.2", Br = "." + newId(6), Hr = 0;
    function _canAcceptData(g) {
        return 1 === g[Yi] || 9 === g[Yi] || !+g[Yi];
    }
    function _getCache(g, f) {
        var S = f[g.id];
        if (!S) {
            S = {};
            try {
                _canAcceptData(f) && objDefine(f, g.id, {
                    e: !1,
                    v: S
                });
            } catch (g) {}
        }
        return S;
    }
    function createUniqueNamespace(g, f) {
        return void 0 === f && (f = !1), normalizeJsName(g + Hr++ + (f ? "." + Vr : jn) + Br);
    }
    function createElmNodeData(g) {
        var f = {
            id: createUniqueNamespace("_aiData-" + (g || jn) + "." + Vr),
            accept: function(g) {
                return _canAcceptData(g);
            },
            get: function(g, S, v, _) {
                var C = g[f.id];
                return C ? C[normalizeJsName(S)] : (_ && ((C = _getCache(f, g))[normalizeJsName(S)] = v), v);
            },
            kill: function(g, f) {
                if (g && g[f]) try {
                    delete g[f];
                } catch (g) {}
            }
        };
        return f;
    }
    function _isConfigDefaults(g) {
        return g && isObject(g) && (g.isVal || g.fb || Oe(g, "v") || Oe(g, "mrg") || Oe(g, "ref") || g.set);
    }
    function _getDefault(g, f, S) {
        var v, _ = S.dfVal || isDefined;
        if (f && S.fb) {
            var C = S.fb;
            be(C) || (C = [
                C
            ]);
            for(var E = 0; E < C[ii]; E++){
                var T = C[E], I = f[T];
                if (_(I) ? v = I : g && (_(I = g.cfg[T]) && (v = I), g.set(g.cfg, Le(T), I)), _(v)) break;
            }
        }
        return !_(v) && _(S.v) && (v = S.v), v;
    }
    function _resolveDefaultValue(g, f, S) {
        var v, _ = S;
        (S && _isConfigDefaults(S) && (_ = _getDefault(g, f, S)), _) && (_isConfigDefaults(_) && (_ = _resolveDefaultValue(g, f, _)), be(_) ? (v = [])[ii] = _[ii] : isPlainObject(_) && (v = {}), v && (objForEachKey(_, function(S, _) {
            _ && _isConfigDefaults(_) && (_ = _resolveDefaultValue(g, f, _)), v[S] = _;
        }), _ = v));
        return _;
    }
    function _applyDefaultValue(g, f, S, v) {
        var _, C, E, T, I, b, A, R, P = v;
        _isConfigDefaults(P) ? (_ = P.isVal, C = P.set, b = P[ni], A = P[ti], T = P.mrg, !(I = P.ref) && isUndefined(I) && (I = !!T), E = _getDefault(g, f, P)) : E = v, A && g[ti](f, S);
        var w = !0, M = f[S];
        !M && isNullOrUndefined(M) || (R = M, w = !1, _ && R !== E && !_(R) && (R = E, w = !0), C && (w = (R = C(R, E, f)) === E)), w ? R = E ? _resolveDefaultValue(g, f, E) : E : (isPlainObject(R) || be(E)) && T && E && (isPlainObject(E) || be(E)) && objForEachKey(E, function(f, S) {
            _applyDefaultValue(g, R, f, S);
        }), g.set(f, S, R), I && g.ref(f, S), b && g[ni](f, S);
    }
    var $r = symbolFor("[[ai_dynCfg_1]]"), jr = symbolFor("[[ai_blkDynCfg_1]]"), Gr = symbolFor("[[ai_frcDynCfg_1]]");
    function _cfgDeepCopy(g) {
        var f;
        if (g && (be(g) ? (f = [])[ii] = g[ii] : isPlainObject(g) && (f = {}), f)) return objForEachKey(g, function(g, S) {
            f[g] = _cfgDeepCopy(S);
        }), f;
        return g;
    }
    function getDynamicConfigHandler(g) {
        if (g) {
            var f = g[$r] || g;
            if (f.cfg && (f.cfg === g || f.cfg[$r] === f)) return f;
        }
        return null;
    }
    function blockDynamicConversion(g) {
        if (g && (isPlainObject(g) || be(g))) try {
            g[jr] = !0;
        } catch (g) {}
        return g;
    }
    function _canMakeDynamic(g, f, S) {
        var v = !1;
        return S && !g[f.blkVal] && ((v = S[Gr]) || S[jr] || (v = isPlainObject(S) || be(S))), v;
    }
    function throwInvalidAccess(g) {
        throwTypeError("InvalidAccess:" + g);
    }
    var qr = [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ], _throwDynamicError = function(g, f, S, v) {
        g && g[si](3, 108, "".concat(S, " [").concat(f, "] failed - ") + dumpObj(v));
    };
    function _patchArray(g, f, S) {
        be(f) && arrForEach(qr, function(v) {
            var _ = f[v];
            f[v] = function() {
                for(var v = [], C = 0; C < arguments.length; C++)v[C] = arguments[C];
                var E = _[di](this, v);
                return _makeDynamicObject(g, f, S, "Patching"), E;
            };
        });
    }
    function _getOwnPropGetter(g, f) {
        var S = Me(g, f);
        return S && S.get;
    }
    function _createDynamicProperty(g, f, S, v) {
        var _ = {
            n: S,
            h: [],
            trk: function(f) {
                f && f.fn && (-1 === ct(_.h, f) && _.h[ui](f), g.trk(f, _));
            },
            clr: function(g) {
                var f = ct(_.h, g);
                -1 !== f && _.h[hi](f, 1);
            }
        }, C = !0, E = !1;
        function _getProperty() {
            C && (E = E || _canMakeDynamic(_getProperty, g, v), v && !v[$r] && E && (v = _makeDynamicObject(g, v, S, "Converting")), C = !1);
            var f = g.act;
            return f && _.trk(f), v;
        }
        function _setProperty(T) {
            if (v !== T) {
                _getProperty[g.ro] && !g.upd && throwInvalidAccess("[" + S + "] is read-only:" + dumpObj(f)), C && (E = E || _canMakeDynamic(_getProperty, g, v), C = !1);
                var I = E && _getProperty[g.rf];
                if (E) {
                    if (I) {
                        objForEachKey(v, function(g) {
                            v[g] = T ? T[g] : $n;
                        });
                        try {
                            objForEachKey(T, function(f, S) {
                                _setDynamicProperty(g, v, f, S);
                            }), T = v;
                        } catch (f) {
                            _throwDynamicError((g.hdlr || {})[ci], S, "Assigning", f), E = !1;
                        }
                    } else v && v[$r] && objForEachKey(v, function(f) {
                        var S = _getOwnPropGetter(v, f);
                        if (S) {
                            var _ = S[g.prop];
                            _ && _.chng();
                        }
                    });
                }
                if (T !== v) {
                    var b = T && _canMakeDynamic(_getProperty, g, T);
                    !I && b && (T = _makeDynamicObject(g, T, S, "Converting")), v = T, E = b;
                }
                g.add(_);
            }
        }
        _getProperty[g.prop] = {
            chng: function() {
                g.add(_);
            }
        }, objDefine(f, _.n, {
            g: _getProperty,
            s: _setProperty
        });
    }
    function _setDynamicProperty(g, f, S, v) {
        if (f) {
            var _ = _getOwnPropGetter(f, S);
            _ && !!_[g.prop] ? f[S] = v : _createDynamicProperty(g, f, S, v);
        }
        return f;
    }
    function _setDynamicPropertyState(g, f, S, v) {
        if (f) {
            var _ = _getOwnPropGetter(f, S), C = _ && !!_[g.prop], E = v && v[0], T = v && v[1], I = v && v[2];
            if (!C) {
                if (I) try {
                    blockDynamicConversion(f);
                } catch (f) {
                    _throwDynamicError((g.hdlr || {})[ci], S, "Blocking", f);
                }
                try {
                    _setDynamicProperty(g, f, S, f[S]), _ = _getOwnPropGetter(f, S);
                } catch (f) {
                    _throwDynamicError((g.hdlr || {})[ci], S, "State", f);
                }
            }
            E && (_[g.rf] = E), T && (_[g.ro] = T), I && (_[g.blkVal] = !0);
        }
        return f;
    }
    function _makeDynamicObject(g, f, S, v) {
        try {
            objForEachKey(f, function(S, v) {
                _setDynamicProperty(g, f, S, v);
            }), f[$r] || (Ne(f, $r, {
                get: function() {
                    return g[gi];
                }
            }), _patchArray(g, f, S));
        } catch (f) {
            _throwDynamicError((g.hdlr || {})[ci], S, v, f);
        }
        return f;
    }
    var Wr = "[[ai_", zr = "]]";
    function _createState(g) {
        var f, S, v = newSymbol(Wr + "get" + g.uid + zr), _ = newSymbol(Wr + "ro" + g.uid + zr), C = newSymbol(Wr + "rf" + g.uid + zr), E = newSymbol(Wr + "blkVal" + g.uid + zr), T = newSymbol(Wr + "dtl" + g.uid + zr), I = null, b = null;
        function _useHandler(f, v) {
            var _ = S.act;
            try {
                S.act = f, f && f[T] && (arrForEach(f[T], function(g) {
                    g.clr(f);
                }), f[T] = []), v({
                    cfg: g.cfg,
                    set: g.set.bind(g),
                    setDf: g[oi].bind(g),
                    ref: g.ref.bind(g),
                    rdOnly: g[ni].bind(g)
                });
            } catch (f) {
                var C = g[ci];
                throw C && C[si](1, 107, dumpObj(f)), f;
            } finally{
                S.act = _ || null;
            }
        }
        function _notifyWatchers() {
            if (I) {
                var g = I;
                I = null, b && b[pi](), b = null;
                var f = [];
                if (arrForEach(g, function(g) {
                    if (g && (g[T] && (arrForEach(g[T], function(f) {
                        f.clr(g);
                    }), g[T] = null), g.fn)) try {
                        _useHandler(g, g.fn);
                    } catch (g) {
                        f[ui](g);
                    }
                }), I) try {
                    _notifyWatchers();
                } catch (g) {
                    f[ui](g);
                }
                f[ii] > 0 && throwAggregationError("Watcher error(s): ", f);
            }
        }
        function _addWatcher(g) {
            if (g && g.h[ii] > 0) {
                I || (I = []), b || (b = scheduleTimeout(function() {
                    b = null, _notifyWatchers();
                }, 0));
                for(var f = 0; f < g.h[ii]; f++){
                    var S = g.h[f];
                    S && -1 === ct(I, S) && I[ui](S);
                }
            }
        }
        function _trackHandler(g, f) {
            if (g) {
                var S = g[T] = g[T] || [];
                -1 === ct(S, f) && S[ui](f);
            }
        }
        return (f = {
            prop: v,
            ro: _,
            rf: C
        })[ti] = E, f[gi] = g, f.add = _addWatcher, f[ri] = _notifyWatchers, f.use = _useHandler, f.trk = _trackHandler, S = f;
    }
    function _createAndUseHandler(g, f) {
        var S = {
            fn: f,
            rm: function() {
                S.fn = null, g = null, f = null;
            }
        };
        return objDefine(S, "toJSON", {
            v: function() {
                return "WatcherHandler" + (S.fn ? "" : "[X]");
            }
        }), g.use(S, f), S;
    }
    function _createDynamicHandler(g, f, S) {
        var v, _ = getDynamicConfigHandler(f);
        if (_) return _;
        var C, E = createUniqueNamespace("dyncfg", !0), T = f && !1 !== S ? f : _cfgDeepCopy(f);
        function _notifyWatchers() {
            C[ri]();
        }
        function _setValue(f, S, v) {
            try {
                f = _setDynamicProperty(C, f, S, v);
            } catch (f) {
                _throwDynamicError(g, S, "Setting value", f);
            }
            return f[S];
        }
        function _watch(g) {
            return _createAndUseHandler(C, g);
        }
        function _block(g, f) {
            C.use(null, function(S) {
                var v = C.upd;
                try {
                    isUndefined(f) || (C.upd = f), g(S);
                } finally{
                    C.upd = v;
                }
            });
        }
        function _ref(g, f) {
            var S;
            return _setDynamicPropertyState(C, g, f, (S = {}, S[0] = !0, S))[f];
        }
        function _rdOnly(g, f) {
            var S;
            return _setDynamicPropertyState(C, g, f, (S = {}, S[1] = !0, S))[f];
        }
        function _blkPropValue(g, f) {
            var S;
            return _setDynamicPropertyState(C, g, f, (S = {}, S[2] = !0, S))[f];
        }
        function _applyDefaults(g, f) {
            return f && objForEachKey(f, function(f, S) {
                _applyDefaultValue(I, g, f, S);
            }), g;
        }
        var I = ((v = {
            uid: null,
            cfg: T
        })[ci] = g, v[ri] = _notifyWatchers, v.set = _setValue, v[oi] = _applyDefaults, v[li] = _watch, v.ref = _ref, v[ni] = _rdOnly, v[ti] = _blkPropValue, v._block = _block, v);
        return objDefine(I, "uid", {
            c: !1,
            e: !1,
            w: !1,
            v: E
        }), _makeDynamicObject(C = _createState(I), T, "config", "Creating"), I;
    }
    function _logInvalidAccess(g, f) {
        g ? (g[ai](f), g[si](2, 108, f)) : throwInvalidAccess(f);
    }
    function createDynamicConfig(g, f, S, v) {
        var _ = _createDynamicHandler(S, g || {}, v);
        return f && _[oi](_.cfg, f), _;
    }
    function onConfigChange(g, f, S) {
        var v = g[$r] || g;
        return !v.cfg || v.cfg !== g && v.cfg[$r] !== v ? (_logInvalidAccess(S, lr + dumpObj(g)), createDynamicConfig(g, null, S)[li](f)) : v[li](f);
    }
    function runTargetUnload(g, f) {
        if (g && g[Ni]) return g[Ni](f);
    }
    function doUnloadAll(g, f, S) {
        var v;
        return S || (v = createPromise(function(g) {
            S = g;
        })), g && vt(g) > 0 ? doAwaitResponse(runTargetUnload(g[0], f), function() {
            doUnloadAll(arrSlice(g, 1), f, S);
        }) : S(), v;
    }
    var Kr = 500, Jr = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
    function cfgDfMerge(g) {
        return {
            mrg: !0,
            v: g
        };
    }
    var Yr, Qr, Xr = [
        Xn,
        Zn,
        er,
        tr
    ], Zr = null;
    function _listenerProxyFunc(g, f) {
        return function() {
            var S = arguments, v = getDebugExt(f);
            if (v) {
                var _ = v.listener;
                _ && _[g] && _[g][di](_, S);
            }
        };
    }
    function _getExtensionNamespace() {
        var g = getInst("Microsoft");
        return g && (Zr = g.ApplicationInsights), Zr;
    }
    function getDebugExt(g) {
        var f = Zr;
        return f || !0 === g.disableDbgExt || (f = Zr || _getExtensionNamespace()), f ? f.ChromeDbgExt : null;
    }
    function getDebugListener(g) {
        if (!Yr) {
            Yr = {};
            for(var f = 0; f < Xr[ii]; f++)Yr[Xr[f]] = _listenerProxyFunc(Xr[f], g);
        }
        return Yr;
    }
    var ea = "warnToConsole", ta = "AI (Internal): ", ia = "AI: ", na = "AITR_", ra = {
        loggingLevelConsole: 0,
        loggingLevelTelemetry: 1,
        maxMessageLimit: 25,
        enableDebug: !1
    }, aa = ((Qr = {})[0] = null, Qr[1] = "errorToConsole", Qr[2] = ea, Qr[3] = "debugToConsole", Qr);
    function _sanitizeDiagnosticText(g) {
        return g ? '"' + g[Qi](/\"/g, jn) + '"' : jn;
    }
    function _logToConsole(g, f) {
        var S = getConsole();
        if (S) {
            var v = "log";
            S[g] && (v = g), Ie(S[v]) && S[v](f);
        }
    }
    var sa = function() {
        function _InternalLogMessage(g, f, S, v) {
            void 0 === S && (S = !1);
            var _ = this;
            _[Vi] = g, _[Bi] = (S ? ia : ta) + g;
            var C = jn;
            hasJSON() && (C = getJSON().stringify(v));
            var E = (f ? " message:" + _sanitizeDiagnosticText(f) : jn) + (v ? " props:" + _sanitizeDiagnosticText(C) : jn);
            _[Bi] += E;
        }
        return _InternalLogMessage.dataType = "MessageData", _InternalLogMessage;
    }();
    function safeGetLogger(g, f) {
        return (g || {})[ci] || new ca(f);
    }
    var oa, la, ca = function() {
        function DiagnosticLogger(g) {
            this.identifier = "DiagnosticLogger", this.queue = [];
            var f, S, v, _, C, E = 0, T = {};
            dynamicProto(DiagnosticLogger, this, function(I) {
                function _logInternalMessage(g, f) {
                    if (!_areInternalMessagesThrottled()) {
                        var _ = !0, C = na + f[Vi];
                        if (T[C] ? _ = !1 : T[C] = !0, _ && (g <= S && (I.queue[ui](f), E++, _debugExtMsg(1 === g ? "error" : "warn", f)), E === v)) {
                            var b = "Internal events throttle limit per PageView reached for this app.", A = new sa(23, b, !1);
                            I.queue[ui](A), 1 === g ? I.errorToConsole(b) : I[ai](b);
                        }
                    }
                }
                function _setDefaultsFromConfig(g) {
                    return onConfigChange(createDynamicConfig(g, ra, I).cfg, function(g) {
                        var C = g.cfg;
                        f = C[Fi], S = C.loggingLevelTelemetry, v = C.maxMessageLimit, _ = C.enableDebug;
                    });
                }
                function _areInternalMessagesThrottled() {
                    return E >= v;
                }
                function _debugExtMsg(f, S) {
                    var v = getDebugExt(g || {});
                    v && v[$i] && v[$i](f, S);
                }
                C = _setDefaultsFromConfig(g || {}), I.consoleLoggingLevel = function() {
                    return f;
                }, I[si] = function(g, S, v, C, E) {
                    void 0 === E && (E = !1);
                    var b = new sa(S, v, E, C);
                    if (_) throw dumpObj(b);
                    var A = aa[g] || ea;
                    if (isUndefined(b[Bi])) _debugExtMsg("throw" + (1 === g ? "Critical" : "Warning"), b);
                    else {
                        if (E) {
                            var R = +b[Vi];
                            !T[R] && f >= g && (I[A](b[Bi]), T[R] = !0);
                        } else f >= g && I[A](b[Bi]);
                        _logInternalMessage(g, b);
                    }
                }, I.debugToConsole = function(g) {
                    _logToConsole("debug", g), _debugExtMsg("warning", g);
                }, I[ai] = function(g) {
                    _logToConsole("warn", g), _debugExtMsg("warning", g);
                }, I.errorToConsole = function(g) {
                    _logToConsole("error", g), _debugExtMsg("error", g);
                }, I.resetInternalMessageCount = function() {
                    E = 0, T = {};
                }, I[Xi] = _logInternalMessage, I[Ni] = function(g) {
                    C && C.rm(), C = null;
                };
            });
        }
        return DiagnosticLogger.__ieDyn = 1, DiagnosticLogger;
    }();
    function _getLogger(g) {
        return g || new ca;
    }
    function _throwInternal(g, f, S, v, _, C) {
        void 0 === C && (C = !1), _getLogger(g)[si](f, S, v, _, C);
    }
    function _warnToConsole(g, f) {
        _getLogger(g)[ai](f);
    }
    var da, ua = "toGMTString", ha = "toUTCString", ga = "cookie", pa = "expires", ma = "isCookieUseDisabled", fa = "disableCookiesUsage", Sa = "_ckMgr", va = null, _a = null, Ca = null, ya = {}, Ea = {}, Ta = ((oa = {
        cookieCfg: cfgDfMerge((la = {}, la[sr] = {
            fb: "cookieDomain",
            dfVal: isNotNullOrUndefined
        }, la.path = {
            fb: "cookiePath",
            dfVal: isNotNullOrUndefined
        }, la.enabled = $n, la.ignoreCookies = $n, la.blockedCookies = $n, la)),
        cookieDomain: $n,
        cookiePath: $n
    })[fa] = $n, oa);
    function _getDoc() {
        !da && (da = getLazy(function() {
            return it();
        }));
    }
    function _gblCookieMgr(g, f) {
        var S = createCookieMgr[Sa] || Ea[Sa];
        return S || (S = createCookieMgr[Sa] = createCookieMgr(g, f), Ea[Sa] = S), S;
    }
    function _isMgrEnabled(g) {
        return !g || g.isEnabled();
    }
    function _isIgnoredCookie(g, f) {
        return !!(f && g && be(g.ignoreCookies)) && -1 !== ct(g.ignoreCookies, f);
    }
    function _isBlockedCookie(g, f) {
        return !!(f && g && be(g.blockedCookies) && -1 !== ct(g.blockedCookies, f)) || _isIgnoredCookie(g, f);
    }
    function _isCfgEnabled(g, f) {
        var S = f[Oi];
        if (isNullOrUndefined(S)) {
            var v = void 0;
            isUndefined(g[ma]) || (v = !g[ma]), isUndefined(g[fa]) || (v = !g[fa]), S = v;
        }
        return S;
    }
    function safeGetCookieMgr(g, f) {
        var S;
        if (g) S = g.getCookieMgr();
        else if (f) {
            var v = f.cookieCfg;
            S = v && v[Sa] ? v[Sa] : createCookieMgr(f);
        }
        return S || (S = _gblCookieMgr(f, (g || {})[ci])), S;
    }
    function createCookieMgr(g, f) {
        var S, v, _, C, E, T, I, b, A;
        g = createDynamicConfig(g || Ea, null, f).cfg, E = onConfigChange(g, function(f) {
            f[oi](f.cfg, Ta), v = f.ref(f.cfg, "cookieCfg"), _ = v[or] || "/", C = v[sr], T = !1 !== _isCfgEnabled(g, v), I = v.getCookie || _getCookieValue, b = v.setCookie || _setCookieValue, A = v.delCookie || _setCookieValue;
        }, f);
        var R = ((S = {
            isEnabled: function() {
                var S = !1 !== _isCfgEnabled(g, v) && T && areCookiesSupported(f), _ = Ea[Sa];
                return S && _ && R !== _ && (S = _isMgrEnabled(_)), S;
            },
            setEnabled: function(g) {
                T = !1 !== g, v[Oi] = g;
            },
            set: function(g, f, S, E, T) {
                var I = !1;
                if (_isMgrEnabled(R) && !_isBlockedCookie(v, g)) {
                    var A = {}, P = mt(f || jn), w = Ct(P, ";");
                    if (-1 !== w && (P = mt(strLeft(f, w)), A = _extractParts(Ke(f, w + 1))), setValue(A, sr, E || C, isTruthy, isUndefined), !isNullOrUndefined(S)) {
                        var M = isIE();
                        if (isUndefined(A[pa])) {
                            var O = utcNow() + 1e3 * S;
                            if (O > 0) {
                                var D = new Date;
                                D.setTime(O), setValue(A, pa, _formatDate(D, M ? ua : ha) || _formatDate(D, M ? ua : ha) || jn, isTruthy);
                            }
                        }
                        M || setValue(A, "max-age", jn + S, null, isUndefined);
                    }
                    var N = getLocation();
                    N && "https:" === N[zi] && (setValue(A, "secure", null, null, isUndefined), null === _a && (_a = !uaDisallowsSameSiteNone((ot() || {})[Ki])), _a && setValue(A, "SameSite", "None", null, isUndefined)), setValue(A, or, T || _, null, isUndefined), b(g, _formatCookieValue(P, A)), I = !0;
                }
                return I;
            },
            get: function(g) {
                var f = jn;
                return _isMgrEnabled(R) && !_isIgnoredCookie(v, g) && (f = I(g)), f;
            },
            del: function(g, f) {
                var S = !1;
                return _isMgrEnabled(R) && (S = R.purge(g, f)), S;
            },
            purge: function(g, S) {
                var v, _ = !1;
                if (areCookiesSupported(f)) {
                    var C = ((v = {})[or] = S || "/", v[pa] = "Thu, 01 Jan 1970 00:00:01 GMT", v);
                    isIE() || (C["max-age"] = "0"), A(g, _formatCookieValue(jn, C)), _ = !0;
                }
                return _;
            }
        })[Ni] = function(g) {
            E && E.rm(), E = null;
        }, S);
        return R[Sa] = R, R;
    }
    function areCookiesSupported(g) {
        if (null === va) {
            va = !1, !da && _getDoc();
            try {
                var f = da.v || {};
                va = void 0 !== f[ga];
            } catch (f) {
                _throwInternal(g, 2, 68, "Cannot access document.cookie - " + getExceptionName(f), {
                    exception: dumpObj(f)
                });
            }
        }
        return va;
    }
    function _extractParts(g) {
        var f = {};
        g && g[ii] && arrForEach(mt(g)[Ji](";"), function(g) {
            if (g = mt(g || jn)) {
                var S = Ct(g, "=");
                -1 === S ? f[g] = null : f[mt(strLeft(g, S))] = mt(Ke(g, S + 1));
            }
        });
        return f;
    }
    function _formatDate(g, f) {
        return Ie(g[f]) ? g[f]() : null;
    }
    function _formatCookieValue(g, f) {
        var S = g || jn;
        return objForEachKey(f, function(g, f) {
            S += "; " + g + (isNullOrUndefined(f) ? jn : "=" + f);
        }), S;
    }
    function _getCookieValue(g) {
        var f = jn;
        if (!da && _getDoc(), da.v) {
            var S = da.v[ga] || jn;
            Ca !== S && (ya = _extractParts(S), Ca = S), f = mt(ya[g] || jn);
        }
        return f;
    }
    function _setCookieValue(g, f) {
        !da && _getDoc(), da.v && (da.v[ga] = g + "=" + f);
    }
    function uaDisallowsSameSiteNone(g) {
        return !!Te(g) && (!(!strContains(g, "CPU iPhone OS 12") && !strContains(g, "iPad; CPU OS 12")) || !!(strContains(g, "Macintosh; Intel Mac OS X 10_14") && strContains(g, "Version/") && strContains(g, "Safari")) || !(!strContains(g, "Macintosh; Intel Mac OS X 10_14") || !_t(g, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) || !(!strContains(g, "Chrome/5") && !strContains(g, "Chrome/6")) || !(!strContains(g, "UnrealEngine") || strContains(g, "Chrome")) || !(!strContains(g, "UCBrowser/12") && !strContains(g, "UCBrowser/11")));
    }
    var Ia = {
        perfEvtsSendAll: !1
    };
    function _runScheduledListeners(g) {
        g.h = null;
        var f = g.cb;
        g.cb = [], arrForEach(f, function(g) {
            safe(g.fn, [
                g.arg
            ]);
        });
    }
    function _runListeners(g, f, S, v) {
        arrForEach(g, function(g) {
            g && g[f] && (S ? (S.cb[ui]({
                fn: v,
                arg: g
            }), S.h = S.h || scheduleTimeout(_runScheduledListeners, 0, S)) : safe(v, [
                g
            ]));
        });
    }
    var ba = function() {
        function NotificationManager(g) {
            var f, S;
            this.listeners = [];
            var v = [], _ = {
                h: null,
                cb: []
            }, C = createDynamicConfig(g, Ia);
            S = C[li](function(g) {
                f = !!g.cfg.perfEvtsSendAll;
            }), dynamicProto(NotificationManager, this, function(g) {
                objDefine(g, "listeners", {
                    g: function() {
                        return v;
                    }
                }), g[vi] = function(g) {
                    v[ui](g);
                }, g[Si] = function(g) {
                    for(var f = ct(v, g); f > -1;)v[hi](f, 1), f = ct(v, g);
                }, g[Xn] = function(g) {
                    _runListeners(v, Xn, _, function(f) {
                        f[Xn](g);
                    });
                }, g[Zn] = function(g, f) {
                    _runListeners(v, Zn, _, function(S) {
                        S[Zn](g, f);
                    });
                }, g[er] = function(g, f) {
                    _runListeners(v, er, f ? _ : null, function(S) {
                        S[er](g, f);
                    });
                }, g[tr] = function(g) {
                    g && (!f && g[an]() || _runListeners(v, tr, null, function(f) {
                        g[Hi] ? scheduleTimeout(function() {
                            return f[tr](g);
                        }, 0) : f[tr](g);
                    }));
                }, g[ir] = function(g) {
                    g && g[ii] && _runListeners(v, ir, _, function(f) {
                        f[ir](g);
                    });
                }, g[nr] = function(g) {
                    g && g[sn] && _runListeners(v, nr, _, function(f) {
                        f[nr](g);
                    });
                }, g[rr] = function(g, f) {
                    if (g > 0) {
                        var S = f || 0;
                        _runListeners(v, rr, _, function(f) {
                            f[rr](g, S);
                        });
                    }
                }, g[Ni] = function(g) {
                    var f, _finishUnload = function() {
                        S && S.rm(), S = null, v = [], _.h && _.h[pi](), _.h = null, _.cb = [];
                    };
                    if (_runListeners(v, "unload", null, function(S) {
                        var v = S[Ni](g);
                        v && (f || (f = []), f[ui](v));
                    }), f) return createPromise(function(g) {
                        return doAwaitResponse(Ln(f), function() {
                            _finishUnload(), g();
                        });
                    });
                    _finishUnload();
                };
            });
        }
        return NotificationManager.__ieDyn = 1, NotificationManager;
    }(), Aa = "ctx", Ra = "ParentContextKey", Pa = "ChildrenContextKey", wa = null, Ma = function() {
        function PerfEvent(g, f, S) {
            var v, _ = this;
            (_.start = utcNow(), _[bi] = g, _[Hi] = S, _[an] = function() {
                return !1;
            }, Ie(f)) && objDefine(_, "payload", {
                g: function() {
                    return !v && Ie(f) && (v = f(), f = null), v;
                }
            });
            _[on] = function(g) {
                return g ? g === PerfEvent[Ra] || g === PerfEvent[Pa] ? _[g] : (_[Aa] || {})[g] : null;
            }, _[ln] = function(g, f) {
                if (g) {
                    if (g === PerfEvent[Ra]) _[g] || (_[an] = function() {
                        return !0;
                    }), _[g] = f;
                    else if (g === PerfEvent[Pa]) _[g] = f;
                    else (_[Aa] = _[Aa] || {})[g] = f;
                }
            }, _[cn] = function() {
                var g = 0, f = _[on](PerfEvent[Pa]);
                if (be(f)) for(var S = 0; S < f[ii]; S++){
                    var v = f[S];
                    v && (g += v[Ri]);
                }
                _[Ri] = utcNow() - _.start, _.exTime = _[Ri] - g, _[cn] = function() {};
            };
        }
        return PerfEvent.ParentContextKey = "parent", PerfEvent.ChildrenContextKey = "childEvts", PerfEvent;
    }(), Oa = function() {
        function PerfManager(g) {
            this.ctx = {}, dynamicProto(PerfManager, this, function(f) {
                f.create = function(g, f, S) {
                    return new Ma(g, f, S);
                }, f.fire = function(f) {
                    f && (f[cn](), g && Ie(g[tr]) && g[tr](f));
                }, f[ln] = function(g, S) {
                    g && ((f[Aa] = f[Aa] || {})[g] = S);
                }, f[on] = function(g) {
                    return (f[Aa] || {})[g];
                };
            });
        }
        return PerfManager.__ieDyn = 1, PerfManager;
    }(), Da = "CoreUtils.doPerf";
    function doPerf(g, f, S, v, _) {
        if (g) {
            var C = g;
            if (C[ar] && (C = C[ar]()), C) {
                var E = void 0, T = C[on](Da);
                try {
                    if (E = C.create(f(), v, _)) {
                        if (T && E[ln] && (E[ln](Ma[Ra], T), T[on] && T[ln])) {
                            var I = T[on](Ma[Pa]);
                            I || (I = [], T[ln](Ma[Pa], I)), I[ui](E);
                        }
                        return C[ln](Da, E), S(E);
                    }
                } catch (g) {
                    E && E[ln] && E[ln]("exception", g);
                } finally{
                    E && C.fire(E), C[ln](Da, T);
                }
            }
        }
        return S();
    }
    function getGblPerfMgr() {
        return wa;
    }
    function newGuid() {
        var g = generateW3CId();
        return Ke(g, 0, 8) + "-" + Ke(g, 8, 12) + "-" + Ke(g, 12, 16) + "-" + Ke(g, 16, 20) + "-" + Ke(g, 20);
    }
    function generateW3CId() {
        for(var g, f = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f"
        ], S = jn, v = 0; v < 4; v++)S += f[15 & (g = random32())] + f[g >> 4 & 15] + f[g >> 8 & 15] + f[g >> 12 & 15] + f[g >> 16 & 15] + f[g >> 20 & 15] + f[g >> 24 & 15] + f[g >> 28 & 15];
        var _ = f[8 + (3 & random32()) | 0];
        return Je(S, 0, 8) + Je(S, 9, 4) + "4" + Je(S, 13, 3) + _ + Je(S, 16, 3) + Je(S, 19, 12);
    }
    var Na = "00000000000000000000000000000000", ka = "0000000000000000";
    function _isValid(g, f, S) {
        return !(!g || g[ii] !== f || g === S) && !!g.match(/^[\da-f]*$/i);
    }
    function isValidTraceId(g) {
        return _isValid(g, 32, Na);
    }
    function isValidSpanId(g) {
        return _isValid(g, 16, ka);
    }
    var La = createElmNodeData("plugin");
    function _getPluginState(g) {
        return La.get(g, "state", {}, !0);
    }
    function initializePlugins(g, f) {
        for(var S, v = [], _ = null, C = g[qi](); C;){
            var E = C[Ii]();
            if (E) {
                _ && _[Wi] && E[Yn] && _[Wi](E);
                var T = !!(S = _getPluginState(E))[_i];
                E[_i] && (T = E[_i]()), T || v[ui](E), _ = E, C = C[qi]();
            }
        }
        arrForEach(v, function(v) {
            var _ = g[qn]();
            v[mi](g.getCfg(), _, f, g[qi]()), S = _getPluginState(v), v[qn] || S[qn] || (S[qn] = _), S[_i] = !0, delete S[Ui];
        });
    }
    function sortPlugins(g) {
        return g.sort(function(g, f) {
            var S = 0;
            if (f) {
                var v = f[Yn];
                g[Yn] ? S = v ? g[Qn] - f[Qn] : 1 : v && (S = -1);
            } else S = g ? 1 : -1;
            return S;
        });
    }
    function createDistributedTraceContext(g) {
        var f = {};
        return {
            getName: function() {
                return f[bi];
            },
            setName: function(S) {
                g && g.setName(S), f[bi] = S;
            },
            getTraceId: function() {
                return f[mn];
            },
            setTraceId: function(S) {
                g && g.setTraceId(S), isValidTraceId(S) && (f[mn] = S);
            },
            getSpanId: function() {
                return f[fn];
            },
            setSpanId: function(S) {
                g && g.setSpanId(S), isValidSpanId(S) && (f[fn] = S);
            },
            getTraceFlags: function() {
                return f[Sn];
            },
            setTraceFlags: function(S) {
                g && g.setTraceFlags(S), f[Sn] = S;
            }
        };
    }
    var Fa, xa = "TelemetryPluginChain", Ua = "_hasRun", Va = "_getTelCtx", Ba = 0;
    function _getNextProxyStart(g, f, S) {
        for(; g;){
            if (g[Ii]() === S) return g;
            g = g[qi]();
        }
        return createTelemetryProxyChain([
            S
        ], f.config || {}, f);
    }
    function _createInternalContext(g, f, S, v) {
        var _ = null, C = [];
        f || (f = createDynamicConfig({}, null, S[ci])), null !== v && (_ = v ? _getNextProxyStart(g, S, v) : g);
        var E = {
            _next: _moveNext,
            ctx: {
                core: function() {
                    return S;
                },
                diagLog: function() {
                    return safeGetLogger(S, f.cfg);
                },
                getCfg: function() {
                    return f.cfg;
                },
                getExtCfg: _resolveExtCfg,
                getConfig: _getConfig,
                hasNext: function() {
                    return !!_;
                },
                getNext: function() {
                    return _;
                },
                setNext: function(g) {
                    _ = g;
                },
                iterate: _iterateChain,
                onComplete: _addOnComplete
            }
        };
        function _addOnComplete(g, f) {
            for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
            g && C[ui]({
                func: g,
                self: isUndefined(f) ? E.ctx : f,
                args: S
            });
        }
        function _moveNext() {
            var g = _;
            if (_ = g ? g[qi]() : null, !g) {
                var f = C;
                f && f[ii] > 0 && (arrForEach(f, function(g) {
                    try {
                        g.func.call(g.self, g.args);
                    } catch (g) {
                        _throwInternal(S[ci], 2, 73, "Unexpected Exception during onComplete - " + dumpObj(g));
                    }
                }), C = []);
            }
            return g;
        }
        function _getExtCfg(g, S) {
            var v = null, _ = f.cfg;
            if (_ && g) {
                var C = _[Kn];
                !C && S && (C = {}), _[Kn] = C, (C = f.ref(_, Kn)) && (!(v = C[g]) && S && (v = {}), C[g] = v, v = f.ref(C, g));
            }
            return v;
        }
        function _resolveExtCfg(g, S) {
            var v = _getExtCfg(g, !0);
            return S && objForEachKey(S, function(g, S) {
                if (isNullOrUndefined(v[g])) {
                    var _ = f.cfg[g];
                    !_ && isNullOrUndefined(_) || (v[g] = _);
                }
                _applyDefaultValue(f, v, g, S);
            }), f[oi](v, S);
        }
        function _getConfig(g, S, v) {
            var _;
            void 0 === v && (v = !1);
            var C = _getExtCfg(g, !1), E = f.cfg;
            return !C || !C[S] && isNullOrUndefined(C[S]) ? !E[S] && isNullOrUndefined(E[S]) || (_ = E[S]) : _ = C[S], _ || !isNullOrUndefined(_) ? _ : v;
        }
        function _iterateChain(g) {
            for(var f; f = E._next();){
                var S = f[Ii]();
                S && g(S);
            }
        }
        return E;
    }
    function createProcessTelemetryContext(g, f, S, v) {
        var _ = createDynamicConfig(f), C = _createInternalContext(g, _, S, v), E = C.ctx;
        function _processNext(g) {
            var f = C._next();
            return f && f[Yn](g, E), !f;
        }
        function _createNew(g, f) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain(g, _.cfg, S, f)), createProcessTelemetryContext(g || E[qi](), _.cfg, S, f);
        }
        return E[Pi] = _processNext, E[xi] = _createNew, E;
    }
    function createProcessTelemetryUnloadContext(g, f, S) {
        var v = createDynamicConfig(f.config), _ = _createInternalContext(g, v, f, S), C = _.ctx;
        function _processNext(g) {
            var f = _._next();
            return f && f[Ni](C, g), !f;
        }
        function _createNew(g, S) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain(g, v.cfg, f, S)), createProcessTelemetryUnloadContext(g || C[qi](), f, S);
        }
        return C[Pi] = _processNext, C[xi] = _createNew, C;
    }
    function createProcessTelemetryUpdateContext(g, f, S) {
        var v = createDynamicConfig(f.config), _ = _createInternalContext(g, v, f, S).ctx;
        function _processNext(g) {
            return _.iterate(function(f) {
                Ie(f[Gi]) && f[Gi](_, g);
            });
        }
        function _createNew(g, S) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain(g, v.cfg, f, S)), createProcessTelemetryUpdateContext(g || _[qi](), f, S);
        }
        return _[Pi] = _processNext, _[xi] = _createNew, _;
    }
    function createTelemetryProxyChain(g, f, S, v) {
        var _ = null, C = !v;
        if (be(g) && g[ii] > 0) {
            var E = null;
            arrForEach(g, function(g) {
                if (C || v !== g || (C = !0), C && g && Ie(g[Yn])) {
                    var T = createTelemetryPluginProxy(g, f, S);
                    _ || (_ = T), E && E._setNext(T), E = T;
                }
            });
        }
        return v && !_ ? createTelemetryProxyChain([
            v
        ], f, S) : _;
    }
    function createTelemetryPluginProxy(g, f, S) {
        var v, _ = null, C = Ie(g[Yn]), E = Ie(g[Wi]), T = {
            getPlugin: function() {
                return g;
            },
            getNext: function() {
                return _;
            },
            processTelemetry: _processTelemetry,
            unload: _unloadPlugin,
            update: _updatePlugin,
            _id: v = g ? g[fi] + "-" + g[Qn] + "-" + Ba++ : "Unknown-0-" + Ba++,
            _setNext: function(g) {
                _ = g;
            }
        };
        function _getTelCtx() {
            var v;
            return g && Ie(g[Va]) && (v = g[Va]()), v || (v = createProcessTelemetryContext(T, f, S)), v;
        }
        function _processChain(f, S, C, E, T) {
            var I = !1, b = g ? g[fi] : xa, A = f[Ua];
            return A || (A = f[Ua] = {}), f.setNext(_), g && doPerf(f[qn](), function() {
                return b + ":" + C;
            }, function() {
                A[v] = !0;
                try {
                    var g = _ ? _._id : jn;
                    g && (A[g] = !1), I = S(f);
                } catch (g) {
                    var E = !_ || A[_._id];
                    E && (I = !0), _ && E || _throwInternal(f[$i](), 1, 73, "Plugin [" + b + "] failed during " + C + " - " + dumpObj(g) + ", run flags: " + dumpObj(A));
                }
            }, E, T), I;
        }
        function _processTelemetry(f, S) {
            function _callProcessTelemetry(S) {
                if (!g || !C) return !1;
                var v = _getPluginState(g);
                return !v[Ui] && !v[zn] && (E && g[Wi](_), g[Yn](f, S), !0);
            }
            _processChain(S = S || _getTelCtx(), _callProcessTelemetry, "processTelemetry", function() {
                return {
                    item: f
                };
            }, !f.sync) || S[Pi](f);
        }
        function _unloadPlugin(f, S) {
            function _callTeardown() {
                var v = !1;
                if (g) {
                    var _ = _getPluginState(g), C = g[qn] || _[qn];
                    !g || C && C !== f.core() || _[Ui] || (_[qn] = null, _[Ui] = !0, _[_i] = !1, g[Ui] && !0 === g[Ui](f, S) && (v = !0));
                }
                return v;
            }
            _processChain(f, _callTeardown, "unload", function() {}, S[Hi]) || f[Pi](S);
        }
        function _updatePlugin(f, S) {
            function _callUpdate() {
                var v = !1;
                if (g) {
                    var _ = _getPluginState(g), C = g[qn] || _[qn];
                    !g || C && C !== f.core() || _[Ui] || g[Gi] && !0 === g[Gi](f, S) && (v = !0);
                }
                return v;
            }
            _processChain(f, _callUpdate, "update", function() {}, !1) || f[Pi](S);
        }
        return Be(T);
    }
    function createUnloadHandlerContainer() {
        var g = [];
        function _addHandler(f) {
            f && g[ui](f);
        }
        function _runHandlers(f, S) {
            arrForEach(g, function(g) {
                try {
                    g(f, S);
                } catch (g) {
                    _throwInternal(f[$i](), 2, 73, "Unexpected error calling unload handler - " + dumpObj(g));
                }
            }), g = [];
        }
        return {
            add: _addHandler,
            run: _runHandlers
        };
    }
    function createUnloadHookContainer() {
        var g = [];
        function _doUnload(f) {
            var S = g;
            g = [], arrForEach(S, function(g) {
                try {
                    (g.rm || g.remove).call(g);
                } catch (g) {
                    _throwInternal(f, 2, 73, "Unloading:" + dumpObj(g));
                }
            });
        }
        function _addHook(f) {
            f && arrAppend(g, f);
        }
        return {
            run: _doUnload,
            add: _addHook
        };
    }
    var Ha = "getPlugin", $a = ((Fa = {})[Kn] = {
        isVal: isNotNullOrUndefined,
        v: {}
    }, Fa), ja = function() {
        function BaseTelemetryPlugin() {
            var g, f, S, v, _, C = this;
            function _getTelCtx(g) {
                void 0 === g && (g = null);
                var v = g;
                if (!v) {
                    var _ = f || createProcessTelemetryContext(null, {}, C[qn]);
                    v = S && S[Ha] ? _[xi](null, S[Ha]) : _[xi](null, S);
                }
                return v;
            }
            function _setDefaults(g, v, _) {
                createDynamicConfig(g, $a, safeGetLogger(v)), !_ && v && (_ = v[wi]()[qi]());
                var E = S;
                S && S[Ha] && (E = S[Ha]()), C[qn] = v, f = createProcessTelemetryContext(_, g, v, E);
            }
            function _initDefaults() {
                g = !1, C[qn] = null, f = null, S = null, _ = createUnloadHookContainer(), v = createUnloadHandlerContainer();
            }
            _initDefaults(), dynamicProto(BaseTelemetryPlugin, C, function(f) {
                f[mi] = function(f, S, v, _) {
                    _setDefaults(f, S, _), g = !0;
                }, f[Ui] = function(g, C) {
                    var E, T = f[qn];
                    if (T && (!g || T === g[qn]())) {
                        var I, b = !1, A = g || createProcessTelemetryUnloadContext(null, T, S && S[Ha] ? S[Ha]() : S), R = C || ((E = {
                            reason: 0
                        })[Hi] = !1, E);
                        return f[ji] && !0 === f[ji](A, R, _unloadCallback) ? I = !0 : _unloadCallback(), I;
                    }
                    function _unloadCallback() {
                        b || (b = !0, v.run(A, C), _.run(A[$i]()), !0 === I && A[Pi](R), _initDefaults());
                    }
                }, f[Gi] = function(g, v) {
                    var _ = f[qn];
                    if (_ && (!g || _ === g[qn]())) {
                        var C, E = !1, T = g || createProcessTelemetryUpdateContext(null, _, S && S[Ha] ? S[Ha]() : S), I = v || {
                            reason: 0
                        };
                        return f._doUpdate && !0 === f._doUpdate(T, I, _updateCallback) ? C = !0 : _updateCallback(), C;
                    }
                    function _updateCallback() {
                        E || (E = !0, _setDefaults(T.getCfg(), T.core(), T[qi]()));
                    }
                }, proxyFunctionAs(f, "_addUnloadCb", function() {
                    return v;
                }, "add"), proxyFunctionAs(f, "_addHook", function() {
                    return _;
                }, "add"), objDefine(f, "_unloadHooks", {
                    g: function() {
                        return _;
                    }
                });
            }), C[$i] = function(g) {
                return _getTelCtx(g)[$i]();
            }, C[_i] = function() {
                return g;
            }, C.setInitialized = function(f) {
                g = f;
            }, C[Wi] = function(g) {
                S = g;
            }, C[Pi] = function(g, f) {
                f ? f[Pi](g) : S && Ie(S[Yn]) && S[Yn](g, null);
            }, C._getTelCtx = _getTelCtx;
        }
        return BaseTelemetryPlugin.__ieDyn = 1, BaseTelemetryPlugin;
    }();
    function _addInitializer(g, f, S) {
        var v = {
            id: f,
            fn: S
        };
        return arrAppend(g, v), {
            remove: function() {
                arrForEach(g, function(f, S) {
                    if (f.id === v.id) return g[hi](S, 1), -1;
                });
            }
        };
    }
    function _runInitializers(g, f, S) {
        for(var v = !1, _ = g[ii], C = 0; C < _; ++C){
            var E = g[C];
            if (E) try {
                if (!1 === E.fn[di](null, [
                    f
                ])) {
                    v = !0;
                    break;
                }
            } catch (g) {
                _throwInternal(S, 2, 64, "Telemetry initializer failed: " + getExceptionName(g), {
                    exception: dumpObj(g)
                }, !0);
            }
        }
        return !v;
    }
    var Ga, qa = function(g) {
        function TelemetryInitializerPlugin() {
            var f, S, v = g.call(this) || this;
            function _initDefaults() {
                f = 0, S = [];
            }
            return v.identifier = "TelemetryInitializerPlugin", v.priority = 199, _initDefaults(), dynamicProto(TelemetryInitializerPlugin, v, function(g, v) {
                g.addTelemetryInitializer = function(g) {
                    return _addInitializer(S, f++, g);
                }, g[Yn] = function(f, v) {
                    _runInitializers(S, f, v ? v[$i]() : g[$i]()) && g[Pi](f, v);
                }, g[ji] = function() {
                    _initDefaults();
                };
            }), v;
        }
        return __extendsFn(TelemetryInitializerPlugin, g), TelemetryInitializerPlugin.__ieDyn = 1, TelemetryInitializerPlugin;
    }(ja), Wa = "Plugins must provide initialize method", za = "_notificationManager", Ka = "SDK is still unloading...", Ja = "SDK is not initialized", Ya = 100, Qa = 5e4, Xa = objDeepFreeze(((Ga = {
        cookieCfg: {}
    })[Jn] = {
        rdOnly: !0,
        ref: !0,
        v: []
    }, Ga[Gn] = {
        rdOnly: !0,
        ref: !0,
        v: []
    }, Ga[Kn] = {
        ref: !0,
        v: {}
    }, Ga[Wn] = $n, Ga.loggingLevelConsole = 0, Ga.diagnosticLogInterval = $n, Ga));
    function _createPerfManager(g, f) {
        return new Oa(f);
    }
    function _validateExtensions(g, f, S) {
        var v, _ = [], C = [], E = {};
        return arrForEach(S, function(S) {
            (isNullOrUndefined(S) || isNullOrUndefined(S[mi])) && throwError(Wa);
            var v = S[Qn], T = S[fi];
            S && v && (isNullOrUndefined(E[v]) ? E[v] = T : _warnToConsole(g, "Two extensions have same priority #" + v + " - " + E[v] + ", " + T)), !v || v < f ? _[ui](S) : C[ui](S);
        }), (v = {})[qn] = _, v[Gn] = C, v;
    }
    function _isPluginPresent(g, f) {
        var S = !1;
        return arrForEach(f, function(f) {
            if (f === g) return S = !0, -1;
        }), S;
    }
    function _deepMergeConfig(g, f, S, v) {
        S && objForEachKey(S, function(S, _) {
            v && isPlainObject(_) && isPlainObject(f[S]) && _deepMergeConfig(g, f[S], _, v), v && isPlainObject(_) && isPlainObject(f[S]) ? _deepMergeConfig(g, f[S], _, v) : g.set(f, S, _);
        });
    }
    function _findWatcher(g, f) {
        var S = null, v = -1;
        return arrForEach(g, function(g, _) {
            if (g.w === f) return S = g, v = _, -1;
        }), {
            i: v,
            l: S
        };
    }
    function _addDelayedCfgListener(g, f) {
        var S = _findWatcher(g, f).l;
        return S || (S = {
            w: f,
            rm: function() {
                var S = _findWatcher(g, f);
                -1 !== S.i && g[hi](S.i, 1);
            }
        }, g[ui](S)), S;
    }
    function _registerDelayedCfgListener(g, f, S) {
        arrForEach(f, function(f) {
            var v = onConfigChange(g, f.w, S);
            delete f.w, f.rm = function() {
                v.rm();
            };
        });
    }
    function _initDebugListener(g, f, S, v) {
        return f.add(g[li](function(g) {
            var f = g.cfg.disableDbgExt;
            !0 === f && v && (S[Si](v), v = null), S && !v && !0 !== f && (v = getDebugListener(g.cfg), S[vi](v));
        })), v;
    }
    function _createUnloadHook(g) {
        return objDefine({
            rm: function() {
                g.rm();
            }
        }, "toJSON", {
            v: function() {
                return "aicore::onCfgChange<" + JSON.stringify(g) + ">";
            }
        });
    }
    var Za = function() {
        function AppInsightsCore() {
            var g, f, S, v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G, q, W, z;
            dynamicProto(AppInsightsCore, this, function(K) {
                function _setStatus() {
                    G = !0, isNullOrUndefined(F) ? (H = Zt[yi], _throwInternal(S, 1, 112, "ikey can't be resolved from promises")) : H = Zt.ACTIVE, _releaseQueues();
                }
                function _releaseQueues() {
                    f && (K.releaseQueue(), K[Mi]());
                }
                function _startLogPoller(f) {
                    q && q[Oi] || z || (f || S && S.queue[ii] > 0) && (W || (W = !0, _addUnloadHook(g[li](function(g) {
                        var f = g.cfg.diagnosticLogInterval;
                        f && f > 0 || (f = 1e4);
                        var S = !1;
                        q && (S = q[Oi], q[pi]()), (q = createTimeout(_flushInternalLogs, f)).unref(), q[Oi] = S;
                    }))), q[Oi] = !0);
                    return q;
                }
                function _setPluginVersions() {
                    var g = {};
                    V = [];
                    var _addPluginVersions = function(f) {
                        f && arrForEach(f, function(f) {
                            if (f[fi] && f[Li] && !g[f.identifier]) {
                                var S = f[fi] + "=" + f[Li];
                                V[ui](S), g[f.identifier] = f;
                            }
                        });
                    };
                    _addPluginVersions(R), A && arrForEach(A, function(g) {
                        _addPluginVersions(g);
                    }), _addPluginVersions(b);
                }
                function _initDefaults() {
                    f = !1, (g = createDynamicConfig({}, Xa, K[ci])).cfg[Fi] = 1, objDefine(K, "config", {
                        g: function() {
                            return g.cfg;
                        },
                        s: function(g) {
                            K.updateCfg(g, !1);
                        }
                    }), objDefine(K, "pluginVersionStringArr", {
                        g: function() {
                            return V || _setPluginVersions(), V;
                        }
                    }), objDefine(K, "pluginVersionString", {
                        g: function() {
                            return B || (V || _setPluginVersions(), B = V.join(";")), B || jn;
                        }
                    }), objDefine(K, "logger", {
                        g: function() {
                            return S || (S = new ca(g.cfg), g[ci] = S), S;
                        },
                        s: function(f) {
                            g[ci] = f, S !== f && (runTargetUnload(S, !1), S = f);
                        }
                    }), K[ci] = new ca(g.cfg), U = [];
                    var k = K.config[Jn] || [];
                    k.splice(0, k[ii]), arrAppend(k, U), w = new qa, v = [], runTargetUnload(_, !1), _ = null, C = null, E = null, runTargetUnload(T, !1), T = null, I = null, b = [], A = null, R = null, P = !1, M = null, O = createUniqueNamespace("AIBaseCore", !0), D = createUnloadHandlerContainer(), L = null, F = null, N = createUnloadHookContainer(), x = [], B = null, V = null, z = !1, q = null, W = !1, H = 0, $ = null, j = null, G = !1;
                }
                function _createTelCtx() {
                    var f = createProcessTelemetryContext(_getPluginChain(), g.cfg, K);
                    return f[ki](_startLogPoller), f;
                }
                function _initPluginChain(g) {
                    var f = _validateExtensions(K[ci], Kr, b);
                    I = null, B = null, V = null, R = sortPlugins(arrAppend(R = (A || [])[0] || [], f[Gn]));
                    var S = arrAppend(sortPlugins(f[qn]), R);
                    U = Be(S);
                    var v = K.config[Jn] || [];
                    v.splice(0, v[ii]), arrAppend(v, U);
                    var _ = _createTelCtx();
                    R && R[ii] > 0 && initializePlugins(_[xi](R), S), initializePlugins(_, S), g && _doUpdate(g);
                }
                function _getPlugin(g) {
                    var f = null, S = null, v = [];
                    return arrForEach(U, function(f) {
                        if (f[fi] === g && f !== w) return S = f, -1;
                        f.getChannel && v[ui](f);
                    }), !S && v[ii] > 0 && arrForEach(v, function(f) {
                        if (!(S = f.getChannel(g))) return -1;
                    }), S && (f = {
                        plugin: S,
                        setEnabled: function(g) {
                            _getPluginState(S)[zn] = !g;
                        },
                        isEnabled: function() {
                            var g = _getPluginState(S);
                            return !g[Ui] && !g[zn];
                        },
                        remove: function(g, f) {
                            var v;
                            void 0 === g && (g = !0);
                            var _ = [
                                S
                            ], C = ((v = {
                                reason: 1
                            })[Hi] = g, v);
                            _removePlugins(_, C, function(g) {
                                g && _initPluginChain({
                                    reason: 32,
                                    removed: _
                                }), f && f(g);
                            });
                        }
                    }), f;
                }
                function _getPluginChain() {
                    if (!I) {
                        var f = (U || []).slice();
                        -1 === ct(f, w) && f[ui](w), I = createTelemetryProxyChain(sortPlugins(f), g.cfg, K);
                    }
                    return I;
                }
                function _removePlugins(f, S, v) {
                    if (f && f[ii] > 0) {
                        var _ = createProcessTelemetryUnloadContext(createTelemetryProxyChain(f, g.cfg, K), K);
                        _[ki](function() {
                            var g = !1, S = [];
                            arrForEach(b, function(v, _) {
                                _isPluginPresent(v, f) ? g = !0 : S[ui](v);
                            }), b = S, B = null, V = null;
                            var _ = [];
                            A && (arrForEach(A, function(S, v) {
                                var C = [];
                                arrForEach(S, function(S) {
                                    _isPluginPresent(S, f) ? g = !0 : C[ui](S);
                                }), _[ui](C);
                            }), A = _), v && v(g), _startLogPoller();
                        }), _[Pi](S);
                    } else v(!1);
                }
                function _flushInternalLogs() {
                    if (S && S.queue) {
                        var g = S.queue.slice(0);
                        S.queue[ii] = 0, arrForEach(g, function(g) {
                            var f, S = ((f = {})[bi] = M || "InternalMessageId: " + g[Vi], f[Ai] = F, f[Ri] = toISOString(new Date), f.baseType = sa.dataType, f.baseData = {
                                message: g[Bi]
                            }, f);
                            K.track(S);
                        });
                    }
                }
                function _flushChannels(g, f, S, v) {
                    var _ = 1, C = !1, E = null;
                    function doCallback() {
                        _--, C && 0 === _ && (E && E[pi](), E = null, f && f(C), f = null);
                    }
                    (v = v || 5e3, R && R[ii] > 0) && _createTelCtx()[xi](R).iterate(function(f) {
                        if (f.flush) {
                            _++;
                            var C = !1;
                            f.flush(g, function() {
                                C = !0, doCallback();
                            }, S) || C || (g && null == E ? E = scheduleTimeout(function() {
                                E = null, doCallback();
                            }, v) : doCallback());
                        }
                    });
                    return C = !0, doCallback(), !0;
                }
                function _initPerfManager() {
                    var f;
                    _addUnloadHook(g[li](function(g) {
                        if (g.cfg.enablePerfMgr) {
                            var S = g.cfg[Wn];
                            f !== S && (S || (S = _createPerfManager), getSetValue(g.cfg, Wn, S), f = S, E = null), C || E || !Ie(S) || (E = S(K, K[Ti]()));
                        } else E = null, f = null;
                    }));
                }
                function _doUpdate(g) {
                    var f = createProcessTelemetryUpdateContext(_getPluginChain(), K);
                    f[ki](_startLogPoller), K._updateHook && !0 === K._updateHook(f, g) || f[Pi](g);
                }
                function _logOrThrowError(g) {
                    var f = K[ci];
                    f ? (_throwInternal(f, 2, 73, g), _startLogPoller()) : throwError(g);
                }
                function _notifyInvalidEvent(g) {
                    var f = K[Ti]();
                    f && f[Zn]([
                        g
                    ], 2);
                }
                function _addUnloadHook(g) {
                    N.add(g);
                }
                _initDefaults(), K._getDbgPlgTargets = function() {
                    return [
                        U,
                        v
                    ];
                }, K[_i] = function() {
                    return f;
                }, K.activeStatus = function() {
                    return H;
                }, K._setPendingStatus = function() {
                    H = 3;
                }, K[mi] = function(v, C, E, T) {
                    P && throwError(Ka), K[_i]() && throwError("Core cannot be initialized more than once"), g = createDynamicConfig(v, Xa, E || K[ci], !1), v = g.cfg, _addUnloadHook(g[li](function(g) {
                        var _ = g.cfg;
                        if (!(3 === H)) {
                            j = _.initInMemoMaxSize || Ya;
                            var C = _[Ci], E = _.endpointUrl;
                            if (isNullOrUndefined(C)) {
                                F = null, H = Zt[yi];
                                var T = "Please provide instrumentation key";
                                f ? (_throwInternal(S, 1, 100, T), _releaseQueues()) : throwError(T);
                            } else {
                                var I = [];
                                if (isPromiseLike(C) ? (I[ui](C), F = null) : F = C, isPromiseLike(E) ? (I[ui](E), $ = null) : $ = E, I[ii]) {
                                    G = !1, H = 3;
                                    var b = isNotNullOrUndefined(_.initTimeOut) ? _.initTimeOut : Qa, A = createAllSettledPromise(I);
                                    scheduleTimeout(function() {
                                        G || _setStatus();
                                    }, b), doAwaitResponse(A, function(g) {
                                        try {
                                            if (G) return;
                                            if (!g.rejected) {
                                                var f = g[Ei];
                                                if (f && f[ii]) {
                                                    var S = f[0];
                                                    if (F = S && S[Ei], f[ii] > 1) {
                                                        var _ = f[1];
                                                        $ = _ && _[Ei];
                                                    }
                                                }
                                                F && (v[Ci] = F, v.endpointUrl = $);
                                            }
                                            _setStatus();
                                        } catch (g) {
                                            G || _setStatus();
                                        }
                                    });
                                } else _setStatus();
                                var R = g.ref(g.cfg, Kn);
                                objForEachKey(R, function(f) {
                                    g.ref(R, f);
                                });
                            }
                        }
                    })), k = _initDebugListener(g, N, (_ = T) && K[Ti](), k), _initPerfManager(), K[ci] = E;
                    var I = v[Jn];
                    if ((b = [])[ui].apply(b, __spreadArrayFn(__spreadArrayFn([], C, !1), I)), A = v[Gn], _initPluginChain(null), R && 0 !== R[ii] || throwError("No " + Gn + " available"), A && A[ii] > 1) {
                        var w = K[Ii]("TeeChannelController");
                        w && w.plugin || _throwInternal(S, 1, 28, "TeeChannel required");
                    }
                    _registerDelayedCfgListener(v, x, S), x = null, f = !0, H === Zt.ACTIVE && _releaseQueues();
                }, K.getChannels = function() {
                    var g = [];
                    return R && arrForEach(R, function(f) {
                        g[ui](f);
                    }), Be(g);
                }, K.track = function(g) {
                    doPerf(K[ar](), function() {
                        return "AppInsightsCore:track";
                    }, function() {
                        null === g && (_notifyInvalidEvent(g), throwError("Invalid telemetry item")), !g[bi] && isNullOrUndefined(g[bi]) && (_notifyInvalidEvent(g), throwError("telemetry name required")), g[Ai] = g[Ai] || F, g[Ri] = g[Ri] || toISOString(new Date), g.ver = g.ver || "4.0", !P && K[_i]() && H === Zt.ACTIVE ? _createTelCtx()[Pi](g) : H !== Zt[yi] && v[ii] <= j && v[ui](g);
                    }, function() {
                        return {
                            item: g
                        };
                    }, !g.sync);
                }, K[wi] = _createTelCtx, K[Ti] = function() {
                    return _ || (_ = new ba(g.cfg), K[za] = _), _;
                }, K[vi] = function(g) {
                    K.getNotifyMgr()[vi](g);
                }, K[Si] = function(g) {
                    _ && _[Si](g);
                }, K.getCookieMgr = function() {
                    return T || (T = createCookieMgr(g.cfg, K[ci])), T;
                }, K.setCookieMgr = function(g) {
                    T !== g && (runTargetUnload(T, !1), T = g);
                }, K[ar] = function() {
                    return C || E || getGblPerfMgr();
                }, K.setPerfMgr = function(g) {
                    C = g;
                }, K.eventCnt = function() {
                    return v[ii];
                }, K.releaseQueue = function() {
                    if (f && v[ii] > 0) {
                        var g = v;
                        v = [], 2 === H ? arrForEach(g, function(g) {
                            g[Ai] = g[Ai] || F, _createTelCtx()[Pi](g);
                        }) : _throwInternal(S, 2, 20, "core init status is not active");
                    }
                }, K[Mi] = function(g) {
                    return M = g || null, z = !1, q && q[pi](), _startLogPoller(!0);
                }, K[Di] = function() {
                    z = !0, q && q[pi](), _flushInternalLogs();
                }, proxyFunctions(K, function() {
                    return w;
                }, [
                    "addTelemetryInitializer"
                ]), K[Ni] = function(g, v, C) {
                    var E;
                    void 0 === g && (g = !0), f || throwError(Ja), P && throwError(Ka);
                    var I, b = ((E = {
                        reason: 50
                    })[Hi] = g, E.flushComplete = !1, E);
                    g && !v && (I = createPromise(function(g) {
                        v = g;
                    }));
                    var A = createProcessTelemetryUnloadContext(_getPluginChain(), K);
                    function _doUnload(g) {
                        b.flushComplete = g, P = !0, D.run(A, b), K[Di](), A[Pi](b);
                    }
                    return A[ki](function() {
                        N.run(K[ci]), doUnloadAll([
                            T,
                            _,
                            S
                        ], g, function() {
                            _initDefaults(), v && v(b);
                        });
                    }, K), _flushInternalLogs(), _flushChannels(g, _doUnload, 6, C), I;
                }, K[Ii] = _getPlugin, K.addPlugin = function(g, f, S, v) {
                    if (!g) return v && v(!1), void _logOrThrowError(Wa);
                    var _ = _getPlugin(g[fi]);
                    if (_ && !f) return v && v(!1), void _logOrThrowError("Plugin [" + g[fi] + "] is already loaded!");
                    var C = {
                        reason: 16
                    };
                    function _addPlugin(f) {
                        b[ui](g), C.added = [
                            g
                        ], _initPluginChain(C), v && v(!0);
                    }
                    if (_) {
                        var E = [
                            _.plugin
                        ];
                        _removePlugins(E, {
                            reason: 2,
                            isAsync: !!S
                        }, function(g) {
                            g ? (C.removed = E, C.reason |= 32, _addPlugin()) : v && v(!1);
                        });
                    } else _addPlugin();
                }, K.updateCfg = function(f, S) {
                    var v;
                    if (void 0 === S && (S = !0), K[_i]()) {
                        v = {
                            reason: 1,
                            cfg: g.cfg,
                            oldCfg: deepExtend({}, g.cfg),
                            newConfig: deepExtend({}, f),
                            merge: S
                        }, f = v.newConfig;
                        var _ = g.cfg;
                        f[Jn] = _[Jn], f[Gn] = _[Gn];
                    }
                    g._block(function(g) {
                        var v = g.cfg;
                        _deepMergeConfig(g, v, f, S), S || objForEachKey(v, function(S) {
                            Oe(f, S) || g.set(v, S, $n);
                        }), g[oi](v, Xa);
                    }, !0), g[ri](), v && _doUpdate(v);
                }, K.evtNamespace = function() {
                    return O;
                }, K.flush = _flushChannels, K.getTraceCtx = function(g) {
                    return L || (L = createDistributedTraceContext()), L;
                }, K.setTraceCtx = function(g) {
                    L = g || null;
                }, K.addUnloadHook = _addUnloadHook, proxyFunctionAs(K, "addUnloadCb", function() {
                    return D;
                }, "add"), K.onCfgChange = function(S) {
                    return _createUnloadHook(f ? onConfigChange(g.cfg, S, K[ci]) : _addDelayedCfgListener(x, S));
                }, K.getWParam = function() {
                    return hasDocument() || g.cfg.enableWParam ? 0 : -1;
                };
            });
        }
        return AppInsightsCore.__ieDyn = 1, AppInsightsCore;
    }(), es = "", ts = "&NoResponseBody=true", is = "POST", ns = function() {
        function SenderPostManager() {
            var g, f, S, v, _, C, E, T, I, b, A, R, P, w, M = 0;
            dynamicProto(SenderPostManager, this, function(O, D) {
                var N = !0;
                function _onSuccess(g, f) {
                    _doOnComplete(f, 200, {}, g);
                }
                function _onError(g, f) {
                    _throwInternal(S, 2, 26, "Failed to send telemetry.", {
                        message: g
                    }), _doOnComplete(f, 400, {});
                }
                function _onNoPayloadUrl(g) {
                    _onError("No endpoint url is provided for the batch", g);
                }
                function _getSenderInterface(g, f) {
                    for(var S, v = 0, _ = null, C = 0; null == _ && C < g[ii];)v = g[C], I || 1 !== v ? 2 !== v || !isFetchSupported(f) || f && R ? 3 !== v || !isBeaconsSupported() || (f ? A : b) || (_ = _beaconSender) : _ = _doFetchSender : useXDomainRequest() ? _ = _xdrSender : isXhrSupported() && (_ = _xhrSender), C++;
                    return _ ? ((S = {
                        _transport: v,
                        _isSync: f
                    })[un] = _, S) : null;
                }
                function _doOnComplete(g, f, S, v) {
                    try {
                        g && g(f, S, v);
                    } catch (g) {}
                }
                function _doBeaconSend(g, f) {
                    var S = ot(), _ = g[dn];
                    if (!_) return _onNoPayloadUrl(f), !0;
                    _ = g[dn] + (P ? ts : es);
                    var C = g[sn], E = v ? C : new Blob([
                        C
                    ], {
                        type: "text/plain;charset=UTF-8"
                    });
                    return S.sendBeacon(_, E);
                }
                function _beaconSender(g, f, C) {
                    var E = g[sn];
                    try {
                        if (E) {
                            if (_doBeaconSend(g, f)) _onSuccess(es, f);
                            else {
                                var I = _ && _.beaconOnRetry;
                                I && Ie(I) ? I(g, f, _doBeaconSend) : (T && T[un](g, f, !0), _throwInternal(S, 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
                            }
                        }
                    } catch (g) {
                        v && _warnToConsole(S, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj(g)), _doOnComplete(f, v ? 0 : 400, {}, es);
                    }
                }
                function _xhrSender(f, S, C) {
                    var E, T, I, b = f[hn] || {};
                    !C && g && (E = createPromise(function(g, f) {
                        T = g, I = f;
                    })), v && C && f.disableXhrSync && (C = !1);
                    var A = f[dn];
                    if (!A) return _onNoPayloadUrl(S), void (T && T(!1));
                    var R = openXhr(is, A, N, !0, C, f[gn]);
                    function _doOnReadyFunc(g) {
                        var C = _ && _.xhrOnComplete;
                        if (C && Ie(C)) C(g, S, f);
                        else {
                            var E = getResponseText(g);
                            _doOnComplete(S, g[tn], _getAllResponseHeaders(g, v), E);
                        }
                    }
                    return v || R[pn]("Content-type", "application/json"), arrForEach(Ve(b), function(g) {
                        R[pn](g, b[g]);
                    }), R.onreadystatechange = function() {
                        v || (_doOnReadyFunc(R), 4 === R.readyState && T && T(!0));
                    }, R.onload = function() {
                        v && _doOnReadyFunc(R);
                    }, R.onerror = function(g) {
                        _doOnComplete(S, v ? R[tn] : 400, _getAllResponseHeaders(R, v), v ? es : formatErrorMessageXhr(R)), I && I(g);
                    }, R.ontimeout = function() {
                        _doOnComplete(S, v ? R[tn] : 500, _getAllResponseHeaders(R, v), v ? es : formatErrorMessageXhr(R)), T && T(!1);
                    }, R.send(f[sn]), E;
                }
                function _doFetchSender(f, S, C) {
                    var T, I, b, A, R = f[dn], O = f[sn], D = v ? O : new Blob([
                        O
                    ], {
                        type: "application/json"
                    }), k = new Headers, L = O[ii], F = !1, x = !1, U = f[hn] || {}, V = ((T = {
                        method: is,
                        body: D
                    })[Jr] = !0, T);
                    f.headers && Ve(f.headers)[ii] > 0 && (arrForEach(Ve(U), function(g) {
                        k.append(g, U[g]);
                    }), V[hn] = k), E ? V.credentials = E : N && v && (V.credentials = "include"), C && (V.keepalive = !0, M += L, v ? 2 === f._sendReason && (F = !0, P && (R += ts)) : F = !0);
                    var B = new Request(R, V);
                    try {
                        B[Jr] = !0;
                    } catch (g) {}
                    if (!C && g && (I = createPromise(function(g, f) {
                        b = g, A = f;
                    })), !R) return _onNoPayloadUrl(S), void (b && b(!1));
                    function _handleError(g) {
                        _doOnComplete(S, v ? 0 : 400, {}, v ? es : g);
                    }
                    function _onFetchComplete(g, f, v) {
                        var C = g[tn], E = _.fetchOnComplete;
                        E && Ie(E) ? E(g, S, v || es, f) : _doOnComplete(S, C, {}, v || es);
                    }
                    try {
                        doAwaitResponse(fetch(v ? R : B, v ? V : null), function(g) {
                            if (C && (M -= L, L = 0), !x) {
                                if (x = !0, g.rejected) _handleError(g.reason && g.reason[Bi]), A && A(g.reason);
                                else {
                                    var S = g[Ei];
                                    try {
                                        v || S.ok ? v && !S.body ? (_onFetchComplete(S, null, es), b && b(!0)) : doAwaitResponse(S.text(), function(g) {
                                            _onFetchComplete(S, f, g[Ei]), b && b(!0);
                                        }) : (_handleError(S.statusText), b && b(!1));
                                    } catch (g) {
                                        _handleError(dumpObj(g)), A && A(g);
                                    }
                                }
                            }
                        });
                    } catch (g) {
                        x || (_handleError(dumpObj(g)), A && A(g));
                    }
                    return F && !x && (x = !0, _doOnComplete(S, 200, {}), b && b(!0)), v && !x && f[gn] > 0 && w && w.set(function() {
                        x || (x = !0, _doOnComplete(S, 500, {}), b && b(!0));
                    }, f[gn]), I;
                }
                function _xdrSender(g, f, C) {
                    var E = nt(), T = new XDomainRequest, I = g[sn];
                    T.onload = function() {
                        var S = getResponseText(T), v = _ && _.xdrOnComplete;
                        v && Ie(v) ? v(T, f, g) : _doOnComplete(f, 200, {}, S);
                    }, T.onerror = function() {
                        _doOnComplete(f, 400, {}, v ? es : formatErrorMessageXdr(T));
                    }, T.ontimeout = function() {
                        _doOnComplete(f, 500, {});
                    }, T.onprogress = function() {};
                    var b = E && E.location && E.location[zi] || "", A = g[dn];
                    if (A) {
                        if (!v && 0 !== A.lastIndexOf(b, 0)) {
                            var R = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
                            return _throwInternal(S, 2, 40, ". " + R), void _onError(R, f);
                        }
                        var P = v ? A : A[Qi](/^(https?:)/, "");
                        T.open(is, P), g[gn] && (T[gn] = g[gn]), T.send(I), v && C ? w && w.set(function() {
                            T.send(I);
                        }, 0) : T.send(I);
                    } else _onNoPayloadUrl(f);
                }
                function _initDefaults() {
                    M = 0, f = !1, g = !1, S = null, v = null, _ = null, C = null, E = null, T = null, I = !1, b = !1, A = !1, R = !1, P = !1, w = null;
                }
                _initDefaults(), O[mi] = function(g, v) {
                    S = v, f && _throwInternal(S, 1, 28, "Sender is already initialized"), O.SetConfig(g), f = !0;
                }, O._getDbgPlgTargets = function() {
                    return [
                        f,
                        v,
                        C,
                        g
                    ];
                }, O.SetConfig = function(f) {
                    try {
                        if (_ = f.senderOnCompleteCallBack || {}, C = !!f.disableCredentials, E = f.fetchCredentials, v = !!f.isOneDs, g = !!f.enableSendPromise, I = !!f.disableXhr, b = !!f.disableBeacon, A = !!f.disableBeaconSync, w = f.timeWrapper, P = !!f.addNoResponse, R = !!f.disableFetchKeepAlive, T = {
                            sendPOST: _xhrSender
                        }, v || (N = !1), C) {
                            var S = getLocation();
                            S && S.protocol && "file:" === S.protocol[ei]() && (N = !1);
                        }
                        return !0;
                    } catch (g) {}
                    return !1;
                }, O.getSyncFetchPayload = function() {
                    return M;
                }, O.getSenderInst = function(g, f) {
                    return g && g[ii] ? _getSenderInterface(g, f) : null;
                }, O.getFallbackInst = function() {
                    return T;
                }, O[ji] = function(g, f) {
                    _initDefaults();
                };
            });
        }
        return SenderPostManager.__ieDyn = 1, SenderPostManager;
    }(), rs = "on", as = "attachEvent", ss = "addEventListener", os = "detachEvent", ls = "removeEventListener", cs = "events", ds = "visibilitychange", us = "pagehide", hs = "pageshow", gs = "unload", ps = "beforeunload", ms = createUniqueNamespace("aiEvtPageHide"), fs = createUniqueNamespace("aiEvtPageShow"), Ss = /\.[\.]+/g, vs = /[\.]+$/, _s = 1, Cs = createElmNodeData("events"), ys = /^([^.]*)(?:\.(.+)|)/;
    function _normalizeNamespace(g) {
        return g && g[Qi] ? g[Qi](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, jn) : g;
    }
    function _getEvtNamespace(g, f) {
        var S;
        if (f) {
            var v = jn;
            be(f) ? (v = jn, arrForEach(f, function(g) {
                (g = _normalizeNamespace(g)) && ("." !== g[0] && (g = "." + g), v += g);
            })) : v = _normalizeNamespace(f), v && ("." !== v[0] && (v = "." + v), g = (g || jn) + v);
        }
        var _ = ys.exec(g || jn) || [];
        return (S = {})[Zi] = _[1], S.ns = (_[2] || jn).replace(Ss, ".").replace(vs, jn)[Ji](".").sort().join("."), S;
    }
    function _getRegisteredEvents(g, f, S) {
        void 0 === S && (S = !0);
        var v = Cs.get(g, cs, {}, S), _ = v[f];
        return _ || (_ = v[f] = []), _;
    }
    function _doDetach(g, f, S, v) {
        g && f && f[Zi] && (g[ls] ? g[ls](f[Zi], S, v) : g[os] && g[os](rs + f[Zi], S));
    }
    function _doAttach(g, f, S, v) {
        var _ = !1;
        return g && f && f[Zi] && S && (g[ss] ? (g[ss](f[Zi], S, v), _ = !0) : g[as] && (g[as](rs + f[Zi], S), _ = !0)), _;
    }
    function _doUnregister(g, f, S, v) {
        for(var _ = f[ii]; _--;){
            var C = f[_];
            C && (S.ns && S.ns !== C.evtName.ns || v && !v(C) || (_doDetach(g, C.evtName, C[en], C.capture), f[hi](_, 1)));
        }
    }
    function _unregisterEvents(g, f, S) {
        if (f[Zi]) _doUnregister(g, _getRegisteredEvents(g, f[Zi]), f, S);
        else {
            var v = Cs.get(g, cs, {});
            objForEachKey(v, function(v, _) {
                _doUnregister(g, _, f, S);
            }), 0 === Ve(v)[ii] && Cs.kill(g, cs);
        }
    }
    function mergeEvtNamespace(g, f) {
        return f ? _getEvtNamespace("xx", be(f) ? [
            g
        ].concat(f) : [
            g,
            f
        ]).ns[Ji](".") : g;
    }
    function eventOn(g, f, S, v, _) {
        var C;
        void 0 === _ && (_ = !1);
        var E = !1;
        if (g) try {
            var T = _getEvtNamespace(f, v);
            if ((E = _doAttach(g, T, S, _)) && Cs.accept(g)) {
                var I = ((C = {
                    guid: _s++,
                    evtName: T
                })[en] = S, C.capture = _, C);
                _getRegisteredEvents(g, T.type)[ui](I);
            }
        } catch (g) {}
        return E;
    }
    function eventOff(g, f, S, v, _) {
        if (void 0 === _ && (_ = !1), g) try {
            var C = _getEvtNamespace(f, v), E = !1;
            _unregisterEvents(g, C, function(g) {
                return !((!C.ns || S) && g[en] !== S) && (E = !0, !0);
            }), E || _doDetach(g, C, S, _);
        } catch (g) {}
    }
    function addEventHandler(g, f, S) {
        var v = !1, _ = nt();
        _ && (v = eventOn(_, g, f, S), v = eventOn(_.body, g, f, S) || v);
        var C = it();
        return C && (v = eventOn(C, g, f, S) || v), v;
    }
    function removeEventHandler(g, f, S) {
        var v = nt();
        v && (eventOff(v, g, f, S), eventOff(v.body, g, f, S));
        var _ = it();
        _ && eventOff(_, g, f, S);
    }
    function _addEventListeners(g, f, S, v) {
        var _ = !1;
        return f && g && g[ii] > 0 && arrForEach(g, function(g) {
            g && (S && -1 !== ct(S, g) || (_ = addEventHandler(g, f, v) || _));
        }), _;
    }
    function addEventListeners(g, f, S, v) {
        var _ = !1;
        return f && g && be(g) && !(_ = _addEventListeners(g, f, S, v)) && S && S[ii] > 0 && (_ = _addEventListeners(g, f, null, v)), _;
    }
    function removeEventListeners(g, f, S) {
        g && be(g) && arrForEach(g, function(g) {
            g && removeEventHandler(g, f, S);
        });
    }
    function addPageUnloadEventListener(g, f, S) {
        return addEventListeners([
            ps,
            gs,
            us
        ], g, f, S);
    }
    function removePageUnloadEventListener(g, f) {
        removeEventListeners([
            ps,
            gs,
            us
        ], g, f);
    }
    function addPageHideEventListener(g, f, S) {
        function _handlePageVisibility(f) {
            var S = it();
            g && S && "hidden" === S.visibilityState && g(f);
        }
        var v = mergeEvtNamespace(ms, S), _ = _addEventListeners([
            us
        ], g, f, v);
        return f && -1 !== ct(f, ds) || (_ = _addEventListeners([
            ds
        ], _handlePageVisibility, f, v) || _), !_ && f && (_ = addPageHideEventListener(g, null, S)), _;
    }
    function removePageHideEventListener(g, f) {
        var S = mergeEvtNamespace(ms, f);
        removeEventListeners([
            us
        ], g, S), removeEventListeners([
            ds
        ], null, S);
    }
    function addPageShowEventListener(g, f, S) {
        function _handlePageVisibility(f) {
            var S = it();
            g && S && "visible" === S.visibilityState && g(f);
        }
        var v = mergeEvtNamespace(fs, S), _ = _addEventListeners([
            hs
        ], g, f, v);
        return !(_ = _addEventListeners([
            ds
        ], _handlePageVisibility, f, v) || _) && f && (_ = addPageShowEventListener(g, null, S)), _;
    }
    function removePageShowEventListener(g, f) {
        var S = mergeEvtNamespace(fs, f);
        removeEventListeners([
            hs
        ], g, S), removeEventListeners([
            ds
        ], null, S);
    }
    var Es, Ts = "", Is = "https://browser.events.data.microsoft.com/OneCollector/1.0/", bs = "version", As = "properties", Rs = "initialize", Ps = "logger", ws = "indexOf", Ms = "timings", Os = "pollInternalLogs", Ds = "value", Ns = "kind", ks = "length", Ls = "processTelemetryStart", Fs = "1DS-Web-JS-4.3.2", xs = X.hasOwnProperty, Us = ((Es = {})[0] = 0, Es[2] = 6, Es[1] = 1, Es[3] = 7, Es[4098] = 6, Es[4097] = 1, Es[4099] = 7, Es);
    function isValueAssigned(g) {
        return !(g === Ts || isNullOrUndefined(g));
    }
    function getTenantId(g) {
        if (g) {
            var f = Ct(g, "-");
            if (f > -1) return strLeft(g, f);
        }
        return Ts;
    }
    function isLatency(g) {
        return !!(g && Re(g) && g >= 1 && g <= 4);
    }
    function sanitizeProperty(g, f, S) {
        if (!f && !isValueAssigned(f) || "string" != typeof g) return null;
        var v = typeof f;
        if ("string" === v || "number" === v || "boolean" === v || be(f)) f = {
            value: f
        };
        else if ("object" !== v || xs.call(f, "value")) {
            if (isNullOrUndefined(f[Ds]) || f[Ds] === Ts || !Te(f[Ds]) && !Re(f[Ds]) && !Pe(f[Ds]) && !be(f[Ds])) return null;
        } else f = {
            value: S ? JSON.stringify(f) : f
        };
        if (be(f[Ds]) && !isArrayValid(f[Ds])) return null;
        if (!isNullOrUndefined(f[Ns])) {
            if (be(f[Ds]) || !isValueKind(f[Ns])) return null;
            f[Ds] = f[Ds].toString();
        }
        return f;
    }
    function getCommonSchemaMetaData(g, f, S) {
        var v = -1;
        if (!isUndefined(g)) {
            if (f > 0 && (32 === f ? v = 8192 : f <= 13 && (v = f << 5)), isDataType(S)) -1 === v && (v = 0), v |= S;
            else {
                var _ = Us[getFieldValueType(g)] || -1;
                -1 !== v && -1 !== _ ? v |= _ : 6 === _ && (v = _);
            }
        }
        return v;
    }
    function getCookieValue(g, f, S) {
        var v;
        return void 0 === S && (S = !0), g && (v = g.get(f), S && v && decodeURIComponent && (v = decodeURIComponent(v))), v || Ts;
    }
    function createGuid(g) {
        void 0 === g && (g = "D");
        var f = newGuid();
        return "B" === g ? f = "{" + f + "}" : "P" === g ? f = "(" + f + ")" : "N" === g && (f = f.replace(/-/g, Ts)), f;
    }
    function extend(g, f, S, v, _) {
        var C = {}, E = !1, T = 0, I = arguments[ks], b = arguments;
        for(Pe(b[0]) && (E = b[0], T++); T < I; T++)objForEachKey(b[T], function(g, f) {
            E && f && isObject(f) ? be(f) ? (C[g] = C[g] || [], arrForEach(f, function(f, S) {
                f && isObject(f) ? C[g][S] = extend(!0, C[g][S], f) : C[g][S] = f;
            })) : C[g] = extend(!0, C[g], f) : C[g] = f;
        });
        return C;
    }
    var Vs = perfNow;
    function isValueKind(g) {
        return 0 === g || g > 0 && g <= 13 || 32 === g;
    }
    function isDataType(g) {
        return g >= 0 && g <= 9;
    }
    function isArrayValid(g) {
        return g[ks] > 0;
    }
    function setProcessTelemetryTimings(g, f) {
        var S = g;
        S[Ms] = S[Ms] || {}, S[Ms][Ls] = S[Ms][Ls] || {}, S[Ms][Ls][f] = Vs();
    }
    function getFieldValueType(g) {
        var f = 0;
        if (null != g) {
            var S = typeof g;
            "string" === S ? f = 1 : "number" === S ? f = 2 : "boolean" === S ? f = 3 : S === K && (f = 4, be(g) ? (f = 4096, g[ks] > 0 && (f |= getFieldValueType(g[0]))) : xs.call(g, "value") && (f = 8192 | getFieldValueType(g[Ds])));
        }
        return f;
    }
    function isChromium() {
        return !!getInst("chrome");
    }
    function isGreaterThanZero(g) {
        return g > 0;
    }
    var Bs = objDeepFreeze({
        endpointUrl: Is,
        propertyStorageOverride: {
            isVal: _chkPropOverride
        }
    });
    function _chkPropOverride(g) {
        return !g || g.getProperty && g.setProperty || throwError("Invalid property storage override passed."), !0;
    }
    var Hs, $s = function(g) {
        function AppInsightsCore() {
            var f = g.call(this) || this;
            return dynamicProto(AppInsightsCore, f, function(g, f) {
                g[Rs] = function(S, v, _, C) {
                    doPerf(g, function() {
                        return "AppInsightsCore.initialize";
                    }, function() {
                        try {
                            f[Rs](createDynamicConfig(S, Bs, _ || g[Ps], !1).cfg, v, _, C);
                        } catch (f) {
                            var E = g[Ps], T = dumpObj(f);
                            -1 !== T[ws]("channels") && (T += "\n - Channels must be provided through config.channels only!"), _throwInternal(E, 1, 514, "SDK Initialization Failed - no telemetry will be sent: " + T);
                        }
                    }, function() {
                        return {
                            config: S,
                            extensions: v,
                            logger: _,
                            notificationManager: C
                        };
                    });
                }, g.track = function(S) {
                    doPerf(g, function() {
                        return "AppInsightsCore.track";
                    }, function() {
                        var v = S;
                        if (v) {
                            v[Ms] = v[Ms] || {}, v[Ms].trackStart = Vs(), isLatency(v.latency) || (v.latency = 1);
                            var _ = v.ext = v.ext || {};
                            _.sdk = _.sdk || {}, _.sdk.ver = Fs;
                            var C = v.baseData = v.baseData || {};
                            C[As] = C[As] || {};
                            var E = C[As];
                            E[bs] = E[bs] || g.pluginVersionString || Ts;
                        }
                        f.track(v);
                    }, function() {
                        return {
                            item: S
                        };
                    }, !S.sync);
                }, g[Os] = function(g) {
                    return f[Os](g || "InternalLog");
                };
            }), f;
        }
        return __extendsFn(AppInsightsCore, g), AppInsightsCore.__ieDyn = 1, AppInsightsCore;
    }(Za), js = (Qt({
        NotSet: 0,
        Pii_DistinguishedName: 1,
        Pii_GenericData: 2,
        Pii_IPV4Address: 3,
        Pii_IPv6Address: 4,
        Pii_MailSubject: 5,
        Pii_PhoneNumber: 6,
        Pii_QueryString: 7,
        Pii_SipAddress: 8,
        Pii_SmtpAddress: 9,
        Pii_Identity: 10,
        Pii_Uri: 11,
        Pii_Fqdn: 12,
        Pii_IPV4AddressLegacy: 13,
        Pii_IPv6ScrubLastHextets: 14,
        Pii_DropValue: 15,
        CustomerContent_GenericContent: 32
    }), Qt({
        Normal: 1,
        CostDeferred: 2,
        RealTime: 3,
        Immediate: 4
    })), Gs = (Qt({
        Unspecified: 0,
        String: 1,
        Int32: 2,
        UInt32: 3,
        Int64: 4,
        UInt64: 5,
        Double: 6,
        Bool: 7,
        Guid: 8,
        DateTime: 9
    }), Qt({
        Normal: 1,
        Critical: 2
    }), Qt({
        NONE: 0,
        ERROR: 1,
        WARNING: 2,
        INFORMATION: 3
    }), "function"), qs = "object", Ws = "undefined", zs = "prototype", Ks = Object, Js = ((getGlobal() || {}).Symbol, (getGlobal() || {}).Reflect, "hasOwnProperty"), extendStaticsFn$1 = function(g, f) {
        return extendStaticsFn$1 = Ks.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f[Js](S) && (g[S] = f[S]);
        }, extendStaticsFn$1(g, f);
    };
    function __extendsFn$1(g, f) {
        function __() {
            this.constructor = g;
        }
        typeof f !== Gs && null !== f && throwTypeError("Class extends value " + String(f) + " is not a constructor or null"), extendStaticsFn$1(g, f), g[zs] = null === f ? ut(f) : (__[zs] = f[zs], new __);
    }
    var Ys = "constructor", Qs = "prototype", Xs = "function", Zs = "_dynInstFuncs", eo = "_isDynProxy", to = "_dynClass", io = "_dynCls$", no = "_dynInstChk", ro = no, ao = "_dfOpts", so = "_unknown_", oo = "__proto__", lo = "_dyn" + oo, co = "__dynProto$Gbl", uo = "_dynInstProto", ho = "useBaseInst", go = "setInstFuncs", po = Object, mo = po.getPrototypeOf, fo = po.getOwnPropertyNames, So = getGlobal(), vo = So[co] || (So[co] = {
        o: (Hs = {}, Hs[go] = !0, Hs[ho] = !0, Hs),
        n: 1e3
    });
    function _isObjectOrArrayPrototype$1(g) {
        return g && (g === po[Qs] || g === Array[Qs]);
    }
    function _isObjectArrayOrFunctionPrototype$1(g) {
        return _isObjectOrArrayPrototype$1(g) || g === Function[Qs];
    }
    function _getObjProto$1(g) {
        var f;
        if (g) {
            if (mo) return mo(g);
            var S = g[oo] || g[Qs] || (g[Ys] ? g[Ys][Qs] : null);
            f = g[lo] || S, objHasOwnProperty(g, lo) || (delete g[uo], f = g[lo] = g[uo] || g[lo], g[uo] = S);
        }
        return f;
    }
    function _forEachProp$1(g, f) {
        var S = [];
        if (fo) S = fo(g);
        else for(var v in g)"string" == typeof v && objHasOwnProperty(g, v) && S.push(v);
        if (S && S.length > 0) for(var _ = 0; _ < S.length; _++)f(S[_]);
    }
    function _isDynamicCandidate$1(g, f, S) {
        return f !== Ys && typeof g[f] === Xs && (S || objHasOwnProperty(g, f)) && f !== oo && f !== Qs;
    }
    function _throwTypeError$1(g) {
        throwTypeError("DynamicProto: " + g);
    }
    function _getInstanceFuncs$1(g) {
        var f = ut(null);
        return _forEachProp$1(g, function(S) {
            !f[S] && _isDynamicCandidate$1(g, S, !1) && (f[S] = g[S]);
        }), f;
    }
    function _hasVisited$1(g, f) {
        for(var S = g.length - 1; S >= 0; S--)if (g[S] === f) return !0;
        return !1;
    }
    function _getBaseFuncs$1(g, f, S, v) {
        function _instFuncProxy(g, f, S) {
            var _ = f[S];
            if (_[eo] && v) {
                var C = g[Zs] || {};
                !1 !== C[ro] && (_ = (C[f[to]] || {})[S] || _);
            }
            return function() {
                return _.apply(g, arguments);
            };
        }
        var _ = ut(null);
        _forEachProp$1(S, function(g) {
            _[g] = _instFuncProxy(f, S, g);
        });
        for(var C = _getObjProto$1(g), E = []; C && !_isObjectArrayOrFunctionPrototype$1(C) && !_hasVisited$1(E, C);)_forEachProp$1(C, function(g) {
            !_[g] && _isDynamicCandidate$1(C, g, !mo) && (_[g] = _instFuncProxy(f, C, g));
        }), E.push(C), C = _getObjProto$1(C);
        return _;
    }
    function _getInstFunc$1(g, f, S, v) {
        var _ = null;
        if (g && objHasOwnProperty(S, to)) {
            var C = g[Zs] || ut(null);
            if ((_ = (C[S[to]] || ut(null))[f]) || _throwTypeError$1("Missing [" + f + "] " + Xs), !_[no] && !1 !== C[ro]) {
                for(var E = !objHasOwnProperty(g, f), T = _getObjProto$1(g), I = []; E && T && !_isObjectArrayOrFunctionPrototype$1(T) && !_hasVisited$1(I, T);){
                    var b = T[f];
                    if (b) {
                        E = b === v;
                        break;
                    }
                    I.push(T), T = _getObjProto$1(T);
                }
                try {
                    E && (g[f] = _), _[no] = 1;
                } catch (g) {
                    C[ro] = !1;
                }
            }
        }
        return _;
    }
    function _getProtoFunc$1(g, f, S) {
        var v = f[g];
        return v === S && (v = _getObjProto$1(f)[g]), typeof v !== Xs && _throwTypeError$1("[" + g + "] is not a " + Xs), v;
    }
    function _populatePrototype$1(g, f, S, v, _) {
        function _createDynamicPrototype(g, f) {
            var dynProtoProxy = function() {
                return (_getInstFunc$1(this, f, g, dynProtoProxy) || _getProtoFunc$1(f, g, dynProtoProxy)).apply(this, arguments);
            };
            return dynProtoProxy[eo] = 1, dynProtoProxy;
        }
        if (!_isObjectOrArrayPrototype$1(g)) {
            var C = S[Zs] = S[Zs] || ut(null);
            if (!_isObjectOrArrayPrototype$1(C)) {
                var E = C[f] = C[f] || ut(null);
                !1 !== C[ro] && (C[ro] = !!_), _isObjectOrArrayPrototype$1(E) || _forEachProp$1(S, function(f) {
                    _isDynamicCandidate$1(S, f, !1) && S[f] !== v[f] && (E[f] = S[f], delete S[f], (!objHasOwnProperty(g, f) || g[f] && !g[f][eo]) && (g[f] = _createDynamicPrototype(g, f)));
                });
            }
        }
    }
    function _checkPrototype$1(g, f) {
        if (mo) {
            for(var S = [], v = _getObjProto$1(f); v && !_isObjectArrayOrFunctionPrototype$1(v) && !_hasVisited$1(S, v);){
                if (v === g) return !0;
                S.push(v), v = _getObjProto$1(v);
            }
            return !1;
        }
        return !0;
    }
    function _getObjName$1(g, f) {
        return objHasOwnProperty(g, Qs) ? g.name || f || so : ((g || {})[Ys] || {}).name || f || so;
    }
    function dynamicProto$1(g, f, S, v) {
        objHasOwnProperty(g, Qs) || _throwTypeError$1("theClass is an invalid class definition.");
        var _ = g[Qs];
        _checkPrototype$1(_, f) || _throwTypeError$1("[" + _getObjName$1(g) + "] not in hierarchy of [" + _getObjName$1(f) + "]");
        var C = null;
        objHasOwnProperty(_, to) ? C = _[to] : (C = io + _getObjName$1(g, "_") + "$" + vo.n, vo.n++, _[to] = C);
        var E = dynamicProto$1[ao], T = !!E[ho];
        T && v && void 0 !== v[ho] && (T = !!v[ho]);
        var I = _getInstanceFuncs$1(f);
        S(f, _getBaseFuncs$1(_, f, I, T));
        var b = !!mo && !!E[go];
        b && v && (b = !!v[go]), _populatePrototype$1(_, C, f, I, !1 !== b);
    }
    dynamicProto$1[ao] = vo.o;
    var _o, Co = "toLowerCase", yo = "blkVal", Eo = "length", To = "rdOnly", Io = "notify", bo = "warnToConsole", Ao = "throwInternal", Ro = "setDf", Po = "watch", wo = "logger", Mo = "apply", Oo = "push", Do = "splice", No = "hdlr", ko = "cancel", Lo = "initialize", Fo = "identifier", xo = "isInitialized", Uo = "getPlugin", Vo = "name", Bo = "time", Ho = "processNext", $o = "getProcessTelContext", jo = "unload", Go = "loggingLevelConsole", qo = "createNew", Wo = "teardown", zo = "messageId", Ko = "message", Jo = "isAsync", Yo = "diagLog", Qo = "_doTeardown", Xo = "update", Zo = "getNext", el = "setNextPlugin", tl = "userAgent", il = "nodeType", nl = "replace", rl = "logInternalMessage", al = "isChildEvt", sl = "getCtx", ol = "setCtx", ll = "complete";
    function throwAggregationError$1(g, f) {
        _o || (_o = createCustomError("AggregationError", function(g, f) {
            f[Eo] > 1 && (g.errors = f[1]);
        }));
        var S = g || "One or more errors occurred.";
        throw arrForEach(f, function(g, f) {
            S += "\n".concat(f, " > ").concat(dumpObj(g));
        }), new _o(S, f || []);
    }
    var cl = void 0, dl = "", ul = "core", hl = "disabled", gl = "extensionConfig", pl = "processTelemetry", ml = "priority", fl = "getPerfMgr", Sl = "Not dynamic - ", vl = /-([a-z])/g, _l = /([^\w\d_$])/g, Cl = /^(\d+[\w\d_$])/;
    function isNotNullOrUndefined$1(g) {
        return !isNullOrUndefined(g);
    }
    function normalizeJsName$1(g) {
        var f = g;
        return f && Te(f) && (f = (f = (f = f[nl](vl, function(g, f) {
            return f.toUpperCase();
        }))[nl](_l, "_"))[nl](Cl, function(g, f) {
            return "_" + f;
        })), f;
    }
    function strContains$1(g, f) {
        return !(!g || !f) && -1 !== Ct(g, f);
    }
    function toISOString$1(g) {
        return g && g.toISOString() || "";
    }
    function _createProxyFunction$1(g, f) {
        var S = null, v = null;
        return Ie(g) ? S = g : v = g, function() {
            var g = arguments;
            if (S && (v = S()), v) return v[f][Mo](v, g);
        };
    }
    function proxyFunctionAs$1(g, f, S, v, _) {
        g && f && S && (!1 !== _ || isUndefined(g[f])) && (g[f] = _createProxyFunction$1(S, v));
    }
    var yl = "console", El = "JSON", Tl = "crypto", Il = "msCrypto", bl = "msie", Al = "trident/", Rl = null, Pl = null;
    function getConsole$1() {
        return typeof console !== Ws ? console : getInst(yl);
    }
    function hasJSON$1() {
        return Boolean(typeof JSON === qs && JSON || null !== getInst(El));
    }
    function getJSON$1() {
        return hasJSON$1() ? JSON || getInst(El) : null;
    }
    function getCrypto$1() {
        return getInst(Tl);
    }
    function getMsCrypto$1() {
        return getInst(Il);
    }
    function isIE$1() {
        var g = ot();
        if (g && (g[tl] !== Pl || null === Rl)) {
            var f = ((Pl = g[tl]) || dl)[Co]();
            Rl = strContains$1(f, bl) || strContains$1(f, Al);
        }
        return Rl;
    }
    var wl = 4294967296, Ml = 4294967295, Ol = 123456789, Dl = 987654321, Nl = !1, kl = Ol, Ll = Dl;
    function _mwcSeed$1(g) {
        g < 0 && (g >>>= 0), kl = Ol + g & Ml, Ll = Dl - g & Ml, Nl = !0;
    }
    function _autoSeedMwc$1() {
        try {
            var g = 2147483647 & utcNow();
            _mwcSeed$1((Math.random() * wl ^ g) + g);
        } catch (g) {}
    }
    function random32$1(g) {
        var f = 0, S = getCrypto$1() || getMsCrypto$1();
        return S && S.getRandomValues && (f = S.getRandomValues(new Uint32Array(1))[0] & Ml), 0 === f && isIE$1() && (Nl || _autoSeedMwc$1(), f = mwcRandom32$1() & Ml), 0 === f && (f = Math.floor(wl * Math.random() | 0)), g || (f >>>= 0), f;
    }
    function mwcRandom32$1(g) {
        var f = ((Ll = 36969 * (65535 & Ll) + (Ll >> 16) & Ml) << 16) + (65535 & (kl = 18e3 * (65535 & kl) + (kl >> 16) & Ml)) >>> 0 & Ml | 0;
        return g || (f >>>= 0), f;
    }
    function newId$1(g) {
        void 0 === g && (g = 22);
        for(var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S = random32$1() >>> 0, v = 0, _ = dl; _[Eo] < g;)v++, _ += f.charAt(63 & S), S >>>= 6, 5 === v && (S = (random32$1() << 2 & 4294967295 | 3 & S) >>> 0, v = 0);
        return _;
    }
    var Fl = "3.3.1", xl = "." + newId$1(6), Ul = 0;
    function _canAcceptData$1(g) {
        return 1 === g[il] || 9 === g[il] || !+g[il];
    }
    function _getCache$1(g, f) {
        var S = f[g.id];
        if (!S) {
            S = {};
            try {
                _canAcceptData$1(f) && objDefine(f, g.id, {
                    e: !1,
                    v: S
                });
            } catch (g) {}
        }
        return S;
    }
    function createUniqueNamespace$1(g, f) {
        return void 0 === f && (f = !1), normalizeJsName$1(g + Ul++ + (f ? "." + Fl : dl) + xl);
    }
    function createElmNodeData$1(g) {
        var f = {
            id: createUniqueNamespace$1("_aiData-" + (g || dl) + "." + Fl),
            accept: function(g) {
                return _canAcceptData$1(g);
            },
            get: function(g, S, v, _) {
                var C = g[f.id];
                return C ? C[normalizeJsName$1(S)] : (_ && ((C = _getCache$1(f, g))[normalizeJsName$1(S)] = v), v);
            },
            kill: function(g, f) {
                if (g && g[f]) try {
                    delete g[f];
                } catch (g) {}
            }
        };
        return f;
    }
    function _isConfigDefaults$1(g) {
        return g && isObject(g) && (g.isVal || g.fb || Oe(g, "v") || Oe(g, "mrg") || Oe(g, "ref") || g.set);
    }
    function _getDefault$1(g, f, S) {
        var v, _ = S.dfVal || isDefined;
        if (f && S.fb) {
            var C = S.fb;
            be(C) || (C = [
                C
            ]);
            for(var E = 0; E < C[Eo]; E++){
                var T = C[E], I = f[T];
                if (_(I) ? v = I : g && (_(I = g.cfg[T]) && (v = I), g.set(g.cfg, Le(T), I)), _(v)) break;
            }
        }
        return !_(v) && _(S.v) && (v = S.v), v;
    }
    function _resolveDefaultValue$1(g, f, S) {
        var v, _ = S;
        (S && _isConfigDefaults$1(S) && (_ = _getDefault$1(g, f, S)), _) && (_isConfigDefaults$1(_) && (_ = _resolveDefaultValue$1(g, f, _)), be(_) ? (v = [])[Eo] = _[Eo] : isPlainObject(_) && (v = {}), v && (objForEachKey(_, function(S, _) {
            _ && _isConfigDefaults$1(_) && (_ = _resolveDefaultValue$1(g, f, _)), v[S] = _;
        }), _ = v));
        return _;
    }
    function _applyDefaultValue$1(g, f, S, v) {
        var _, C, E, T, I, b, A, R, P = v;
        _isConfigDefaults$1(P) ? (_ = P.isVal, C = P.set, b = P[To], A = P[yo], T = P.mrg, !(I = P.ref) && isUndefined(I) && (I = !!T), E = _getDefault$1(g, f, P)) : E = v, A && g[yo](f, S);
        var w = !0, M = f[S];
        !M && isNullOrUndefined(M) || (R = M, w = !1, _ && R !== E && !_(R) && (R = E, w = !0), C && (w = (R = C(R, E, f)) === E)), w ? R = E ? _resolveDefaultValue$1(g, f, E) : E : (isPlainObject(R) || be(E)) && T && E && (isPlainObject(E) || be(E)) && objForEachKey(E, function(f, S) {
            _applyDefaultValue$1(g, R, f, S);
        }), g.set(f, S, R), I && g.ref(f, S), b && g[To](f, S);
    }
    var Vl = symbolFor("[[ai_dynCfg_1]]"), Bl = symbolFor("[[ai_blkDynCfg_1]]"), Hl = symbolFor("[[ai_frcDynCfg_1]]");
    function _cfgDeepCopy$1(g) {
        var f;
        if (g && (be(g) ? (f = [])[Eo] = g[Eo] : isPlainObject(g) && (f = {}), f)) return objForEachKey(g, function(g, S) {
            f[g] = _cfgDeepCopy$1(S);
        }), f;
        return g;
    }
    function getDynamicConfigHandler$1(g) {
        if (g) {
            var f = g[Vl] || g;
            if (f.cfg && (f.cfg === g || f.cfg[Vl] === f)) return f;
        }
        return null;
    }
    function blockDynamicConversion$1(g) {
        if (g && (isPlainObject(g) || be(g))) try {
            g[Bl] = !0;
        } catch (g) {}
        return g;
    }
    function _canMakeDynamic$1(g, f, S) {
        var v = !1;
        return S && !g[f.blkVal] && ((v = S[Hl]) || S[Bl] || (v = isPlainObject(S) || be(S))), v;
    }
    function throwInvalidAccess$1(g) {
        throwTypeError("InvalidAccess:" + g);
    }
    var $l = [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ], _throwDynamicError$1 = function(g, f, S, v) {
        g && g[Ao](3, 108, "".concat(S, " [").concat(f, "] failed - ") + dumpObj(v));
    };
    function _patchArray$1(g, f, S) {
        be(f) && arrForEach($l, function(v) {
            var _ = f[v];
            f[v] = function() {
                for(var v = [], C = 0; C < arguments.length; C++)v[C] = arguments[C];
                var E = _[Mo](this, v);
                return _makeDynamicObject$1(g, f, S, "Patching"), E;
            };
        });
    }
    function _getOwnPropGetter$1(g, f) {
        var S = Me(g, f);
        return S && S.get;
    }
    function _createDynamicProperty$1(g, f, S, v) {
        var _ = {
            n: S,
            h: [],
            trk: function(f) {
                f && f.fn && (-1 === ct(_.h, f) && _.h[Oo](f), g.trk(f, _));
            },
            clr: function(g) {
                var f = ct(_.h, g);
                -1 !== f && _.h[Do](f, 1);
            }
        }, C = !0, E = !1;
        function _getProperty() {
            C && (E = E || _canMakeDynamic$1(_getProperty, g, v), v && !v[Vl] && E && (v = _makeDynamicObject$1(g, v, S, "Converting")), C = !1);
            var f = g.act;
            return f && _.trk(f), v;
        }
        function _setProperty(T) {
            if (v !== T) {
                _getProperty[g.ro] && !g.upd && throwInvalidAccess$1("[" + S + "] is read-only:" + dumpObj(f)), C && (E = E || _canMakeDynamic$1(_getProperty, g, v), C = !1);
                var I = E && _getProperty[g.rf];
                if (E) {
                    if (I) {
                        objForEachKey(v, function(g) {
                            v[g] = T ? T[g] : cl;
                        });
                        try {
                            objForEachKey(T, function(f, S) {
                                _setDynamicProperty$1(g, v, f, S);
                            }), T = v;
                        } catch (f) {
                            _throwDynamicError$1((g.hdlr || {})[wo], S, "Assigning", f), E = !1;
                        }
                    } else v && v[Vl] && objForEachKey(v, function(f) {
                        var S = _getOwnPropGetter$1(v, f);
                        if (S) {
                            var _ = S[g.prop];
                            _ && _.chng();
                        }
                    });
                }
                if (T !== v) {
                    var b = T && _canMakeDynamic$1(_getProperty, g, T);
                    !I && b && (T = _makeDynamicObject$1(g, T, S, "Converting")), v = T, E = b;
                }
                g.add(_);
            }
        }
        _getProperty[g.prop] = {
            chng: function() {
                g.add(_);
            }
        }, objDefine(f, _.n, {
            g: _getProperty,
            s: _setProperty
        });
    }
    function _setDynamicProperty$1(g, f, S, v) {
        if (f) {
            var _ = _getOwnPropGetter$1(f, S);
            _ && !!_[g.prop] ? f[S] = v : _createDynamicProperty$1(g, f, S, v);
        }
        return f;
    }
    function _setDynamicPropertyState$1(g, f, S, v) {
        if (f) {
            var _ = _getOwnPropGetter$1(f, S), C = _ && !!_[g.prop], E = v && v[0], T = v && v[1], I = v && v[2];
            if (!C) {
                if (I) try {
                    blockDynamicConversion$1(f);
                } catch (f) {
                    _throwDynamicError$1((g.hdlr || {})[wo], S, "Blocking", f);
                }
                try {
                    _setDynamicProperty$1(g, f, S, f[S]), _ = _getOwnPropGetter$1(f, S);
                } catch (f) {
                    _throwDynamicError$1((g.hdlr || {})[wo], S, "State", f);
                }
            }
            E && (_[g.rf] = E), T && (_[g.ro] = T), I && (_[g.blkVal] = !0);
        }
        return f;
    }
    function _makeDynamicObject$1(g, f, S, v) {
        try {
            objForEachKey(f, function(S, v) {
                _setDynamicProperty$1(g, f, S, v);
            }), f[Vl] || (Ne(f, Vl, {
                get: function() {
                    return g[No];
                }
            }), _patchArray$1(g, f, S));
        } catch (f) {
            _throwDynamicError$1((g.hdlr || {})[wo], S, v, f);
        }
        return f;
    }
    var jl = "[[ai_", Gl = "]]";
    function _createState$1(g) {
        var f, S, v = newSymbol(jl + "get" + g.uid + Gl), _ = newSymbol(jl + "ro" + g.uid + Gl), C = newSymbol(jl + "rf" + g.uid + Gl), E = newSymbol(jl + "blkVal" + g.uid + Gl), T = newSymbol(jl + "dtl" + g.uid + Gl), I = null, b = null;
        function _useHandler(f, v) {
            var _ = S.act;
            try {
                S.act = f, f && f[T] && (arrForEach(f[T], function(g) {
                    g.clr(f);
                }), f[T] = []), v({
                    cfg: g.cfg,
                    set: g.set.bind(g),
                    setDf: g[Ro].bind(g),
                    ref: g.ref.bind(g),
                    rdOnly: g[To].bind(g)
                });
            } catch (f) {
                var C = g[wo];
                throw C && C[Ao](1, 107, dumpObj(f)), f;
            } finally{
                S.act = _ || null;
            }
        }
        function _notifyWatchers() {
            if (I) {
                var g = I;
                I = null, b && b[ko](), b = null;
                var f = [];
                if (arrForEach(g, function(g) {
                    if (g && (g[T] && (arrForEach(g[T], function(f) {
                        f.clr(g);
                    }), g[T] = null), g.fn)) try {
                        _useHandler(g, g.fn);
                    } catch (g) {
                        f[Oo](g);
                    }
                }), I) try {
                    _notifyWatchers();
                } catch (g) {
                    f[Oo](g);
                }
                f[Eo] > 0 && throwAggregationError$1("Watcher error(s): ", f);
            }
        }
        function _addWatcher(g) {
            if (g && g.h[Eo] > 0) {
                I || (I = []), b || (b = scheduleTimeout(function() {
                    b = null, _notifyWatchers();
                }, 0));
                for(var f = 0; f < g.h[Eo]; f++){
                    var S = g.h[f];
                    S && -1 === ct(I, S) && I[Oo](S);
                }
            }
        }
        function _trackHandler(g, f) {
            if (g) {
                var S = g[T] = g[T] || [];
                -1 === ct(S, f) && S[Oo](f);
            }
        }
        return (f = {
            prop: v,
            ro: _,
            rf: C
        })[yo] = E, f[No] = g, f.add = _addWatcher, f[Io] = _notifyWatchers, f.use = _useHandler, f.trk = _trackHandler, S = f;
    }
    function _createAndUseHandler$1(g, f) {
        var S = {
            fn: f,
            rm: function() {
                S.fn = null, g = null, f = null;
            }
        };
        return objDefine(S, "toJSON", {
            v: function() {
                return "WatcherHandler" + (S.fn ? "" : "[X]");
            }
        }), g.use(S, f), S;
    }
    function _createDynamicHandler$1(g, f, S) {
        var v, _ = getDynamicConfigHandler$1(f);
        if (_) return _;
        var C, E = createUniqueNamespace$1("dyncfg", !0), T = f && !1 !== S ? f : _cfgDeepCopy$1(f);
        function _notifyWatchers() {
            C[Io]();
        }
        function _setValue(f, S, v) {
            try {
                f = _setDynamicProperty$1(C, f, S, v);
            } catch (f) {
                _throwDynamicError$1(g, S, "Setting value", f);
            }
            return f[S];
        }
        function _watch(g) {
            return _createAndUseHandler$1(C, g);
        }
        function _block(g, f) {
            C.use(null, function(S) {
                var v = C.upd;
                try {
                    isUndefined(f) || (C.upd = f), g(S);
                } finally{
                    C.upd = v;
                }
            });
        }
        function _ref(g, f) {
            var S;
            return _setDynamicPropertyState$1(C, g, f, (S = {}, S[0] = !0, S))[f];
        }
        function _rdOnly(g, f) {
            var S;
            return _setDynamicPropertyState$1(C, g, f, (S = {}, S[1] = !0, S))[f];
        }
        function _blkPropValue(g, f) {
            var S;
            return _setDynamicPropertyState$1(C, g, f, (S = {}, S[2] = !0, S))[f];
        }
        function _applyDefaults(g, f) {
            return f && objForEachKey(f, function(f, S) {
                _applyDefaultValue$1(I, g, f, S);
            }), g;
        }
        var I = ((v = {
            uid: null,
            cfg: T
        })[wo] = g, v[Io] = _notifyWatchers, v.set = _setValue, v[Ro] = _applyDefaults, v[Po] = _watch, v.ref = _ref, v[To] = _rdOnly, v[yo] = _blkPropValue, v._block = _block, v);
        return objDefine(I, "uid", {
            c: !1,
            e: !1,
            w: !1,
            v: E
        }), _makeDynamicObject$1(C = _createState$1(I), T, "config", "Creating"), I;
    }
    function _logInvalidAccess$1(g, f) {
        g ? (g[bo](f), g[Ao](2, 108, f)) : throwInvalidAccess$1(f);
    }
    function createDynamicConfig$1(g, f, S, v) {
        var _ = _createDynamicHandler$1(S, g || {}, v);
        return f && _[Ro](_.cfg, f), _;
    }
    function onConfigChange$1(g, f, S) {
        var v = g[Vl] || g;
        return !v.cfg || v.cfg !== g && v.cfg[Vl] !== v ? (_logInvalidAccess$1(S, Sl + dumpObj(g)), createDynamicConfig$1(g, null, S)[Po](f)) : v[Po](f);
    }
    var ql, Wl = null;
    function _getExtensionNamespace$1() {
        var g = getInst("Microsoft");
        return g && (Wl = g.ApplicationInsights), Wl;
    }
    function getDebugExt$1(g) {
        var f = Wl;
        return f || !0 === g.disableDbgExt || (f = Wl || _getExtensionNamespace$1()), f ? f.ChromeDbgExt : null;
    }
    var zl = "warnToConsole", Kl = "AI (Internal): ", Jl = "AI: ", Yl = "AITR_", Ql = {
        loggingLevelConsole: 0,
        loggingLevelTelemetry: 1,
        maxMessageLimit: 25,
        enableDebug: !1
    }, Xl = ((ql = {})[0] = null, ql[1] = "errorToConsole", ql[2] = zl, ql[3] = "debugToConsole", ql);
    function _sanitizeDiagnosticText$1(g) {
        return g ? '"' + g[nl](/\"/g, dl) + '"' : dl;
    }
    function _logToConsole$1(g, f) {
        var S = getConsole$1();
        if (S) {
            var v = "log";
            S[g] && (v = g), Ie(S[v]) && S[v](f);
        }
    }
    var Zl = function() {
        function _InternalLogMessage(g, f, S, v) {
            void 0 === S && (S = !1);
            var _ = this;
            _[zo] = g, _[Ko] = (S ? Jl : Kl) + g;
            var C = dl;
            hasJSON$1() && (C = getJSON$1().stringify(v));
            var E = (f ? " message:" + _sanitizeDiagnosticText$1(f) : dl) + (v ? " props:" + _sanitizeDiagnosticText$1(C) : dl);
            _[Ko] += E;
        }
        return _InternalLogMessage.dataType = "MessageData", _InternalLogMessage;
    }();
    function safeGetLogger$1(g, f) {
        return (g || {})[wo] || new ec(f);
    }
    var ec = function() {
        function DiagnosticLogger(g) {
            this.identifier = "DiagnosticLogger", this.queue = [];
            var f, S, v, _, C, E = 0, T = {};
            dynamicProto$1(DiagnosticLogger, this, function(I) {
                function _logInternalMessage(g, f) {
                    if (!_areInternalMessagesThrottled()) {
                        var _ = !0, C = Yl + f[zo];
                        if (T[C] ? _ = !1 : T[C] = !0, _ && (g <= S && (I.queue[Oo](f), E++, _debugExtMsg(1 === g ? "error" : "warn", f)), E === v)) {
                            var b = "Internal events throttle limit per PageView reached for this app.", A = new Zl(23, b, !1);
                            I.queue[Oo](A), 1 === g ? I.errorToConsole(b) : I[bo](b);
                        }
                    }
                }
                function _setDefaultsFromConfig(g) {
                    return onConfigChange$1(createDynamicConfig$1(g, Ql, I).cfg, function(g) {
                        var C = g.cfg;
                        f = C[Go], S = C.loggingLevelTelemetry, v = C.maxMessageLimit, _ = C.enableDebug;
                    });
                }
                function _areInternalMessagesThrottled() {
                    return E >= v;
                }
                function _debugExtMsg(f, S) {
                    var v = getDebugExt$1(g || {});
                    v && v[Yo] && v[Yo](f, S);
                }
                C = _setDefaultsFromConfig(g || {}), I.consoleLoggingLevel = function() {
                    return f;
                }, I[Ao] = function(g, S, v, C, E) {
                    void 0 === E && (E = !1);
                    var b = new Zl(S, v, E, C);
                    if (_) throw dumpObj(b);
                    var A = Xl[g] || zl;
                    if (isUndefined(b[Ko])) _debugExtMsg("throw" + (1 === g ? "Critical" : "Warning"), b);
                    else {
                        if (E) {
                            var R = +b[zo];
                            !T[R] && f >= g && (I[A](b[Ko]), T[R] = !0);
                        } else f >= g && I[A](b[Ko]);
                        _logInternalMessage(g, b);
                    }
                }, I.debugToConsole = function(g) {
                    _logToConsole$1("debug", g), _debugExtMsg("warning", g);
                }, I[bo] = function(g) {
                    _logToConsole$1("warn", g), _debugExtMsg("warning", g);
                }, I.errorToConsole = function(g) {
                    _logToConsole$1("error", g), _debugExtMsg("error", g);
                }, I.resetInternalMessageCount = function() {
                    E = 0, T = {};
                }, I[rl] = _logInternalMessage, I[jo] = function(g) {
                    C && C.rm(), C = null;
                };
            });
        }
        return DiagnosticLogger.__ieDyn = 1, DiagnosticLogger;
    }();
    function _getLogger$1(g) {
        return g || new ec;
    }
    function _throwInternal$1(g, f, S, v, _, C) {
        void 0 === C && (C = !1), _getLogger$1(g)[Ao](f, S, v, _, C);
    }
    var tc = "ctx", ic = "ParentContextKey", nc = "ChildrenContextKey", rc = function() {
        function PerfEvent(g, f, S) {
            var v, _ = this;
            (_.start = utcNow(), _[Vo] = g, _[Jo] = S, _[al] = function() {
                return !1;
            }, Ie(f)) && objDefine(_, "payload", {
                g: function() {
                    return !v && Ie(f) && (v = f(), f = null), v;
                }
            });
            _[sl] = function(g) {
                return g ? g === PerfEvent[ic] || g === PerfEvent[nc] ? _[g] : (_[tc] || {})[g] : null;
            }, _[ol] = function(g, f) {
                if (g) {
                    if (g === PerfEvent[ic]) _[g] || (_[al] = function() {
                        return !0;
                    }), _[g] = f;
                    else if (g === PerfEvent[nc]) _[g] = f;
                    else (_[tc] = _[tc] || {})[g] = f;
                }
            }, _[ll] = function() {
                var g = 0, f = _[sl](PerfEvent[nc]);
                if (be(f)) for(var S = 0; S < f[Eo]; S++){
                    var v = f[S];
                    v && (g += v[Bo]);
                }
                _[Bo] = utcNow() - _.start, _.exTime = _[Bo] - g, _[ll] = function() {};
            };
        }
        return PerfEvent.ParentContextKey = "parent", PerfEvent.ChildrenContextKey = "childEvts", PerfEvent;
    }(), ac = "CoreUtils.doPerf";
    function doPerf$1(g, f, S, v, _) {
        if (g) {
            var C = g;
            if (C[fl] && (C = C[fl]()), C) {
                var E = void 0, T = C[sl](ac);
                try {
                    if (E = C.create(f(), v, _)) {
                        if (T && E[ol] && (E[ol](rc[ic], T), T[sl] && T[ol])) {
                            var I = T[sl](rc[nc]);
                            I || (I = [], T[ol](rc[nc], I)), I[Oo](E);
                        }
                        return C[ol](ac, E), S(E);
                    }
                } catch (g) {
                    E && E[ol] && E[ol]("exception", g);
                } finally{
                    E && C.fire(E), C[ol](ac, T);
                }
            }
        }
        return S();
    }
    function newGuid$1() {
        var g = generateW3CId$1();
        return Ke(g, 0, 8) + "-" + Ke(g, 8, 12) + "-" + Ke(g, 12, 16) + "-" + Ke(g, 16, 20) + "-" + Ke(g, 20);
    }
    function generateW3CId$1() {
        for(var g, f = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f"
        ], S = dl, v = 0; v < 4; v++)S += f[15 & (g = random32$1())] + f[g >> 4 & 15] + f[g >> 8 & 15] + f[g >> 12 & 15] + f[g >> 16 & 15] + f[g >> 20 & 15] + f[g >> 24 & 15] + f[g >> 28 & 15];
        var _ = f[8 + (3 & random32$1()) | 0];
        return Je(S, 0, 8) + Je(S, 9, 4) + "4" + Je(S, 13, 3) + _ + Je(S, 16, 3) + Je(S, 19, 12);
    }
    var sc = createElmNodeData$1("plugin");
    function _getPluginState$1(g) {
        return sc.get(g, "state", {}, !0);
    }
    var oc, lc = "TelemetryPluginChain", cc = "_hasRun", dc = "_getTelCtx", uc = 0;
    function _getNextProxyStart$1(g, f, S) {
        for(; g;){
            if (g[Uo]() === S) return g;
            g = g[Zo]();
        }
        return createTelemetryProxyChain$1([
            S
        ], f.config || {}, f);
    }
    function _createInternalContext$1(g, f, S, v) {
        var _ = null, C = [];
        f || (f = createDynamicConfig$1({}, null, S[wo])), null !== v && (_ = v ? _getNextProxyStart$1(g, S, v) : g);
        var E = {
            _next: _moveNext,
            ctx: {
                core: function() {
                    return S;
                },
                diagLog: function() {
                    return safeGetLogger$1(S, f.cfg);
                },
                getCfg: function() {
                    return f.cfg;
                },
                getExtCfg: _resolveExtCfg,
                getConfig: _getConfig,
                hasNext: function() {
                    return !!_;
                },
                getNext: function() {
                    return _;
                },
                setNext: function(g) {
                    _ = g;
                },
                iterate: _iterateChain,
                onComplete: _addOnComplete
            }
        };
        function _addOnComplete(g, f) {
            for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
            g && C[Oo]({
                func: g,
                self: isUndefined(f) ? E.ctx : f,
                args: S
            });
        }
        function _moveNext() {
            var g = _;
            if (_ = g ? g[Zo]() : null, !g) {
                var f = C;
                f && f[Eo] > 0 && (arrForEach(f, function(g) {
                    try {
                        g.func.call(g.self, g.args);
                    } catch (g) {
                        _throwInternal$1(S[wo], 2, 73, "Unexpected Exception during onComplete - " + dumpObj(g));
                    }
                }), C = []);
            }
            return g;
        }
        function _getExtCfg(g, S) {
            var v = null, _ = f.cfg;
            if (_ && g) {
                var C = _[gl];
                !C && S && (C = {}), _[gl] = C, (C = f.ref(_, gl)) && (!(v = C[g]) && S && (v = {}), C[g] = v, v = f.ref(C, g));
            }
            return v;
        }
        function _resolveExtCfg(g, S) {
            var v = _getExtCfg(g, !0);
            return S && objForEachKey(S, function(g, S) {
                if (isNullOrUndefined(v[g])) {
                    var _ = f.cfg[g];
                    !_ && isNullOrUndefined(_) || (v[g] = _);
                }
                _applyDefaultValue$1(f, v, g, S);
            }), f[Ro](v, S);
        }
        function _getConfig(g, S, v) {
            var _;
            void 0 === v && (v = !1);
            var C = _getExtCfg(g, !1), E = f.cfg;
            return !C || !C[S] && isNullOrUndefined(C[S]) ? !E[S] && isNullOrUndefined(E[S]) || (_ = E[S]) : _ = C[S], _ || !isNullOrUndefined(_) ? _ : v;
        }
        function _iterateChain(g) {
            for(var f; f = E._next();){
                var S = f[Uo]();
                S && g(S);
            }
        }
        return E;
    }
    function createProcessTelemetryContext$1(g, f, S, v) {
        var _ = createDynamicConfig$1(f), C = _createInternalContext$1(g, _, S, v), E = C.ctx;
        function _processNext(g) {
            var f = C._next();
            return f && f[pl](g, E), !f;
        }
        function _createNew(g, f) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain$1(g, _.cfg, S, f)), createProcessTelemetryContext$1(g || E[Zo](), _.cfg, S, f);
        }
        return E[Ho] = _processNext, E[qo] = _createNew, E;
    }
    function createProcessTelemetryUnloadContext$1(g, f, S) {
        var v = createDynamicConfig$1(f.config), _ = _createInternalContext$1(g, v, f, S), C = _.ctx;
        function _processNext(g) {
            var f = _._next();
            return f && f[jo](C, g), !f;
        }
        function _createNew(g, S) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain$1(g, v.cfg, f, S)), createProcessTelemetryUnloadContext$1(g || C[Zo](), f, S);
        }
        return C[Ho] = _processNext, C[qo] = _createNew, C;
    }
    function createProcessTelemetryUpdateContext$1(g, f, S) {
        var v = createDynamicConfig$1(f.config), _ = _createInternalContext$1(g, v, f, S).ctx;
        function _processNext(g) {
            return _.iterate(function(f) {
                Ie(f[Xo]) && f[Xo](_, g);
            });
        }
        function _createNew(g, S) {
            return void 0 === g && (g = null), be(g) && (g = createTelemetryProxyChain$1(g, v.cfg, f, S)), createProcessTelemetryUpdateContext$1(g || _[Zo](), f, S);
        }
        return _[Ho] = _processNext, _[qo] = _createNew, _;
    }
    function createTelemetryProxyChain$1(g, f, S, v) {
        var _ = null, C = !v;
        if (be(g) && g[Eo] > 0) {
            var E = null;
            arrForEach(g, function(g) {
                if (C || v !== g || (C = !0), C && g && Ie(g[pl])) {
                    var T = createTelemetryPluginProxy$1(g, f, S);
                    _ || (_ = T), E && E._setNext(T), E = T;
                }
            });
        }
        return v && !_ ? createTelemetryProxyChain$1([
            v
        ], f, S) : _;
    }
    function createTelemetryPluginProxy$1(g, f, S) {
        var v, _ = null, C = Ie(g[pl]), E = Ie(g[el]), T = {
            getPlugin: function() {
                return g;
            },
            getNext: function() {
                return _;
            },
            processTelemetry: _processTelemetry,
            unload: _unloadPlugin,
            update: _updatePlugin,
            _id: v = g ? g[Fo] + "-" + g[ml] + "-" + uc++ : "Unknown-0-" + uc++,
            _setNext: function(g) {
                _ = g;
            }
        };
        function _getTelCtx() {
            var v;
            return g && Ie(g[dc]) && (v = g[dc]()), v || (v = createProcessTelemetryContext$1(T, f, S)), v;
        }
        function _processChain(f, S, C, E, T) {
            var I = !1, b = g ? g[Fo] : lc, A = f[cc];
            return A || (A = f[cc] = {}), f.setNext(_), g && doPerf$1(f[ul](), function() {
                return b + ":" + C;
            }, function() {
                A[v] = !0;
                try {
                    var g = _ ? _._id : dl;
                    g && (A[g] = !1), I = S(f);
                } catch (g) {
                    var E = !_ || A[_._id];
                    E && (I = !0), _ && E || _throwInternal$1(f[Yo](), 1, 73, "Plugin [" + b + "] failed during " + C + " - " + dumpObj(g) + ", run flags: " + dumpObj(A));
                }
            }, E, T), I;
        }
        function _processTelemetry(f, S) {
            function _callProcessTelemetry(S) {
                if (!g || !C) return !1;
                var v = _getPluginState$1(g);
                return !v[Wo] && !v[hl] && (E && g[el](_), g[pl](f, S), !0);
            }
            _processChain(S = S || _getTelCtx(), _callProcessTelemetry, "processTelemetry", function() {
                return {
                    item: f
                };
            }, !f.sync) || S[Ho](f);
        }
        function _unloadPlugin(f, S) {
            function _callTeardown() {
                var v = !1;
                if (g) {
                    var _ = _getPluginState$1(g), C = g[ul] || _[ul];
                    !g || C && C !== f.core() || _[Wo] || (_[ul] = null, _[Wo] = !0, _[xo] = !1, g[Wo] && !0 === g[Wo](f, S) && (v = !0));
                }
                return v;
            }
            _processChain(f, _callTeardown, "unload", function() {}, S[Jo]) || f[Ho](S);
        }
        function _updatePlugin(f, S) {
            function _callUpdate() {
                var v = !1;
                if (g) {
                    var _ = _getPluginState$1(g), C = g[ul] || _[ul];
                    !g || C && C !== f.core() || _[Wo] || g[Xo] && !0 === g[Xo](f, S) && (v = !0);
                }
                return v;
            }
            _processChain(f, _callUpdate, "update", function() {}, !1) || f[Ho](S);
        }
        return Be(T);
    }
    function createUnloadHandlerContainer$1() {
        var g = [];
        function _addHandler(f) {
            f && g[Oo](f);
        }
        function _runHandlers(f, S) {
            arrForEach(g, function(g) {
                try {
                    g(f, S);
                } catch (g) {
                    _throwInternal$1(f[Yo](), 2, 73, "Unexpected error calling unload handler - " + dumpObj(g));
                }
            }), g = [];
        }
        return {
            add: _addHandler,
            run: _runHandlers
        };
    }
    function createUnloadHookContainer$1() {
        var g = [];
        function _doUnload(f) {
            var S = g;
            g = [], arrForEach(S, function(g) {
                try {
                    (g.rm || g.remove).call(g);
                } catch (g) {
                    _throwInternal$1(f, 2, 73, "Unloading:" + dumpObj(g));
                }
            });
        }
        function _addHook(f) {
            f && arrAppend(g, f);
        }
        return {
            run: _doUnload,
            add: _addHook
        };
    }
    var hc, gc = "getPlugin", pc = ((oc = {})[gl] = {
        isVal: isNotNullOrUndefined$1,
        v: {}
    }, oc), mc = function() {
        function BaseTelemetryPlugin() {
            var g, f, S, v, _, C = this;
            function _getTelCtx(g) {
                void 0 === g && (g = null);
                var v = g;
                if (!v) {
                    var _ = f || createProcessTelemetryContext$1(null, {}, C[ul]);
                    v = S && S[gc] ? _[qo](null, S[gc]) : _[qo](null, S);
                }
                return v;
            }
            function _setDefaults(g, v, _) {
                createDynamicConfig$1(g, pc, safeGetLogger$1(v)), !_ && v && (_ = v[$o]()[Zo]());
                var E = S;
                S && S[gc] && (E = S[gc]()), C[ul] = v, f = createProcessTelemetryContext$1(_, g, v, E);
            }
            function _initDefaults() {
                g = !1, C[ul] = null, f = null, S = null, _ = createUnloadHookContainer$1(), v = createUnloadHandlerContainer$1();
            }
            _initDefaults(), dynamicProto$1(BaseTelemetryPlugin, C, function(f) {
                f[Lo] = function(f, S, v, _) {
                    _setDefaults(f, S, _), g = !0;
                }, f[Wo] = function(g, C) {
                    var E, T = f[ul];
                    if (T && (!g || T === g[ul]())) {
                        var I, b = !1, A = g || createProcessTelemetryUnloadContext$1(null, T, S && S[gc] ? S[gc]() : S), R = C || ((E = {
                            reason: 0
                        })[Jo] = !1, E);
                        return f[Qo] && !0 === f[Qo](A, R, _unloadCallback) ? I = !0 : _unloadCallback(), I;
                    }
                    function _unloadCallback() {
                        b || (b = !0, v.run(A, C), _.run(A[Yo]()), !0 === I && A[Ho](R), _initDefaults());
                    }
                }, f[Xo] = function(g, v) {
                    var _ = f[ul];
                    if (_ && (!g || _ === g[ul]())) {
                        var C, E = !1, T = g || createProcessTelemetryUpdateContext$1(null, _, S && S[gc] ? S[gc]() : S), I = v || {
                            reason: 0
                        };
                        return f._doUpdate && !0 === f._doUpdate(T, I, _updateCallback) ? C = !0 : _updateCallback(), C;
                    }
                    function _updateCallback() {
                        E || (E = !0, _setDefaults(T.getCfg(), T.core(), T[Zo]()));
                    }
                }, proxyFunctionAs$1(f, "_addUnloadCb", function() {
                    return v;
                }, "add"), proxyFunctionAs$1(f, "_addHook", function() {
                    return _;
                }, "add"), objDefine(f, "_unloadHooks", {
                    g: function() {
                        return _;
                    }
                });
            }), C[Yo] = function(g) {
                return _getTelCtx(g)[Yo]();
            }, C[xo] = function() {
                return g;
            }, C.setInitialized = function(f) {
                g = f;
            }, C[el] = function(g) {
                S = g;
            }, C[Ho] = function(g, f) {
                f ? f[Ho](g) : S && Ie(S[pl]) && S[pl](g, null);
            }, C._getTelCtx = _getTelCtx;
        }
        return BaseTelemetryPlugin.__ieDyn = 1, BaseTelemetryPlugin;
    }(), fc = "", Sc = "timings", vc = "processTelemetryStart";
    (hc = {})[0] = 0, hc[2] = 6, hc[1] = 1, hc[3] = 7, hc[4098] = 6, hc[4097] = 1, hc[4099] = 7;
    function getTenantId$1(g) {
        if (g) {
            var f = Ct(g, "-");
            if (f > -1) return strLeft(g, f);
        }
        return fc;
    }
    var _c, Cc = perfNow;
    function setProcessTelemetryTimings$1(g, f) {
        var S = g;
        S[Sc] = S[Sc] || {}, S[Sc][vc] = S[Sc][vc] || {}, S[Sc][vc][f] = Cc();
    }
    function isGreaterThanZero$1(g) {
        return g > 0;
    }
    function isValidPersistenceLevel(g) {
        return Re(g) && g >= 1 && g <= 2;
    }
    !function(g) {
        g[g.LocalStorage = 1] = "LocalStorage", g[g.SessionStorage = 2] = "SessionStorage", g[g.IndexedDb = 3] = "IndexedDb";
    }(_c || (_c = {}));
    var yc = "readwrite", Ec = "result", Tc = "DBError: Unable to open database", Ic = "Database is not open", bc = "DBError: Failed to Open Cursor", Ac = "DBError: Failed to delete the database", Rc = "DBError: Database does not exist", Pc = "DBError: Database upgrade required", wc = "DBError: Feature not supported", Mc = [
        "indexedDB"
    ], Oc = Ie, Dc = Te, Nc = 0;
    function _getDbFactory() {
        var g = getGlobal() || {}, f = null;
        if (g) try {
            for(var S = 0; S < Mc.length; S++)if ((f = g[Mc[S]]) && Oc(f.open)) return f;
        } catch (g) {
            f = null;
        }
        return f || null;
    }
    function _debugLog(g, f) {
        getInst("QUnit") && console && console.log("  [" + toISOString$1(new Date) + "]: IndexedDbHelper [" + g + "] " + f);
    }
    function _warnLog(g, f, S) {
        g && g.warnToConsole("IndexedDbHelper [" + f + "] " + S);
    }
    function _eventReject(g, f, S, v) {
        return function(_) {
            S(new Error(f)), _debugLog(g, "[" + v + "] event rejected");
        };
    }
    var kc = [];
    function _getDbContext(g, f) {
        for(var S = null, v = 0; v < kc.length; v++)if ((S = kc[v]).name === g) return S;
        return S = {
            name: g,
            sch: createTaskScheduler(createAsyncPromise, "IndexedDbHelper[" + g + "]"),
            dbHdl: [],
            add: function(f) {
                S.dbHdl.push(f), _debugLog(g, "- dbOpened (add) -- hdls [" + S.dbHdl.length + "]");
            },
            remove: function(f) {
                for(var v = S.dbHdl, _ = 0; _ < v.length; _++)if (v[_] === f) {
                    v.splice(_, 1);
                    break;
                }
                _debugLog(g, "- dbClosed (remove) -- hdls [" + S.dbHdl.length + "]");
            },
            isOpen: function() {
                return S.dbHdl.length > 0;
            },
            openHdl: function() {
                return S.dbHdl.length > 0 ? S.dbHdl[0] : null;
            }
        }, kc.push(S), S;
    }
    var Lc = function() {
        function IndexedDbHelper(g) {
            var f = Nc++, S = 0;
            dynamicProto$1(IndexedDbHelper, this, function(v) {
                var _ = _getDbFactory() || null;
                function _createStoreContext(v, _, C) {
                    var E = v.db, T = S++;
                    _debugLog(v.dbName, "[" + f + ":" + T + "] txn.open - " + _ + " -- " + C);
                    var I = E.transaction(_, yc);
                    return I.onabort = function() {
                        _warnLog(g, v.dbName, "[" + f + ":" + T + "] txn.onabort - " + _ + " -- " + C + " -- " + dumpObj(I.error));
                    }, I.onerror = function() {
                        _warnLog(g, v.dbName, "[" + f + ":" + T + "] txn.onerror - " + _ + " -- " + C);
                    }, I.oncomplete = function() {
                        _debugLog(v.dbName, "[" + f + ":" + T + "] txn.oncomplete - " + _ + " -- " + C);
                    }, {
                        db: v,
                        store: I.objectStore(_),
                        tx: I,
                        tbl: _,
                        openCursor: function(g, f) {
                            return _openCursor(v, _, g, f);
                        },
                        newTransaction: function(g) {
                            return _openStore(v, _, g);
                        }
                    };
                }
                function _openStore(g, f, S) {
                    if (!g || !g.db) return kn(new Error(Ic));
                    try {
                        var v = S(_createStoreContext(g, f, "openStore"));
                        return isPromiseLike(v) ? v : Nn(v);
                    } catch (g) {
                        return kn(g);
                    }
                }
                function _openCursor(g, f, S, v) {
                    if (!g || !g.db) return kn(new Error(Ic));
                    var _ = null;
                    return S && Dc(S) ? _ = new Fc(S) : S && S.isMatch && (_ = S), createAsyncPromise(function(S, C) {
                        var E = [], T = null, I = null;
                        _ && _.keyRange && (I = _.keyRange());
                        var b = _createStoreContext(g, f, "openCursor");
                        (T = I ? b.store.openCursor(I) : b.store.openCursor()).onerror = _eventReject(b.db.dbName, bc, C, "openCursor"), T.onsuccess = function(g) {
                            var f = g.target[Ec];
                            if (f) {
                                var T = {
                                    store: b,
                                    cursor: f,
                                    continue: function() {
                                        f.continue();
                                    },
                                    done: function() {
                                        S(E);
                                    }
                                }, I = f.value;
                                if (!_ || _.isMatch(I)) {
                                    if (v) try {
                                        switch(v(T, I, E)){
                                            case 2:
                                                S(E);
                                                break;
                                            case 1:
                                                break;
                                            default:
                                                T.continue();
                                        }
                                    } catch (g) {
                                        C(g);
                                    }
                                    else E.push(I), T.continue();
                                } else T.continue();
                            } else S(E);
                        };
                    });
                }
                function _scheduleEvent(g, f, S, v) {
                    return _getDbContext(g).sch.queue(S, f, v);
                }
                v.isAvailable = function() {
                    return !!_;
                }, v.openDb = function(f, S, v, C) {
                    return _scheduleEvent(f, "openDb", function(E) {
                        return createAsyncPromise(function(T, I) {
                            var b = !1;
                            function _createDbCtx(g, v, _, C, E) {
                                var T = {
                                    db: v,
                                    dbName: f,
                                    dbVersion: S,
                                    ctx: null,
                                    isNew: C,
                                    txn: _ ? _.transaction : null
                                };
                                return E || (T.openStore = function(g, f) {
                                    return _openStore(T, g, f);
                                }, T.openCursor = function(g, f, S) {
                                    return _openCursor(T, g, f, S);
                                }), T;
                            }
                            function _databaseUpgrade(g, f) {
                                var S = _createDbCtx(null, g, f, !0, !0);
                                if (C) b = !0, doAwaitResponse(C(S), function(g) {
                                    if (g.rejected) try {
                                        f.transaction && f.transaction.abort();
                                    } finally{
                                        I(g.reason);
                                    }
                                    else S.txn || (S.txn = f.transaction);
                                });
                                else try {
                                    f.transaction && f.transaction.abort();
                                } finally{
                                    I(new Error(Pc));
                                }
                            }
                            function _databaseOpen(S, _) {
                                var C = _getDbContext(f);
                                C.add(S), S.onabort = function(v) {
                                    _warnLog(g, f, "onabort -- closing the Db"), C.remove(S);
                                }, S.onerror = function(v) {
                                    _warnLog(g, f, "onerror -- closing the Db"), C.remove(S);
                                }, S.onclose = function(v) {
                                    _warnLog(g, f, "onclose -- closing the Db"), C.remove(S);
                                }, S.onversionchange = function(v) {
                                    _warnLog(g, f, "onversionchange -- force closing the Db"), S.close(), C.remove(S);
                                };
                                var E = null, A = null;
                                C.dbHdl.length > 0 && (A = C.dbHdl[0]), E = _createDbCtx(C, A, _, b);
                                try {
                                    doAwait(v(E), T, I);
                                } catch (g) {
                                    I(g);
                                }
                            }
                            var A = _getDbContext(f);
                            if (null == _) I(new Error("No available storage factory"));
                            else if (A.isOpen()) {
                                var R = _createDbCtx(A, A.openHdl(), null, !1);
                                doAwait(v(R), T, I);
                            } else {
                                var P = _.open(f, S);
                                P.onblocked = function(S) {
                                    _warnLog(g, f, "Db Open Blocked event [" + E + "] - " + (P.error || "")), I(new Error(Tc));
                                }, P.onerror = function(S) {
                                    _warnLog(g, f, "Db Open Error event [" + E + "] - " + (P.error || "")), I(new Error(Tc));
                                }, P.onupgradeneeded = function(g) {
                                    _debugLog(f, "Db Open Create/Upgrade needed event [" + E + "]");
                                    try {
                                        var S = g.target[Ec];
                                        if (!S) return void I(new Error(Tc));
                                        _databaseUpgrade(S, P);
                                    } catch (g) {
                                        _eventReject(f, Tc, I, E)(g);
                                    }
                                }, P.onsuccess = function(g) {
                                    var f = g.target[Ec];
                                    f ? _databaseOpen(f, P) : I(new Error(Tc));
                                };
                            }
                        });
                    });
                }, v.closeDb = function(g) {
                    _scheduleEvent(g, "closeDb", function(f) {
                        var S = _getDbContext(g), v = S.dbHdl, _ = v.length;
                        if (_ > 0) {
                            for(var C = 0; C < _; C++)v[C].close();
                            S.dbHdl = [];
                        }
                        return 1;
                    }).catch(function(g) {});
                }, v.deleteDb = function(f) {
                    return null != _ && _scheduleEvent(f, "deleteDb", function(S) {
                        var v = _getDbContext(f), C = v.dbHdl, E = C.length;
                        if (E > 0) {
                            _warnLog(g, f, "Db is open [" + E + "] force closing");
                            for(var T = 0; T < E; T++)C[T].close();
                            v.dbHdl = [];
                        }
                        return createAsyncPromise(function(v, C) {
                            setTimeout(function() {
                                try {
                                    _debugLog(f, "[" + S + "] starting");
                                    var E = _.deleteDatabase(f);
                                    E.onerror = function(v) {
                                        _warnLog(g, f, "[" + S + "] error!!"), C(new Error(Ac));
                                    }, E.onblocked = function(v) {
                                        _warnLog(g, f, "[" + S + "] blocked!!"), C(new Error(Ac));
                                    }, E.onupgradeneeded = function(v) {
                                        _warnLog(g, f, "[" + S + "] upgrade needed!!"), C(new Error(Ac));
                                    }, E.onsuccess = function(g) {
                                        _debugLog(f, "[" + S + "] complete"), v(!0);
                                    }, _debugLog(f, "[" + S + "] started");
                                } catch (v) {
                                    _warnLog(g, f, "[" + S + "] threw - " + v), C(new Error(Ac + " - " + v));
                                }
                            }, 0);
                        });
                    });
                }, v.getDbDetails = function(g) {
                    return _scheduleEvent(g, "getDbDetails", function(f) {
                        return null != _ && _.databases ? createAsyncPromise(function(f, S) {
                            _.databases().then(function(v) {
                                for(var _ = 0; _ < v.length; _++)if (v[_].name === g) return void f(v[_]);
                                S(new Error(Rc));
                            }, S);
                        }) : kn(new Error(wc));
                    }, 2e3);
                };
            });
        }
        return IndexedDbHelper.__ieDyn = 1, IndexedDbHelper;
    }(), Fc = function() {
        function SimpleQuery(g) {
            var f = [], S = null;
            dynamicProto$1(SimpleQuery, this, function(v) {
                v.keyRange = function() {
                    return S;
                }, v.parseQuery = function(g) {
                    if (f = [], g) for(var _ = g.split(";"), C = 0; C < _.length; C++){
                        var E = _[C], T = E.indexOf("=");
                        if (-1 !== T) {
                            var I = E.substring(0, T), b = E.substring(T + 1);
                            0 === I.indexOf("#") && (I = I.substring(1), S || (S = IDBKeyRange.bound(b, b + "\uFFFF"))), v.startsWith(I, b);
                        }
                    }
                }, v.startsWith = function(g, S) {
                    f.push({
                        name: g,
                        value: S,
                        type: 0
                    });
                }, v.contains = function(g, S) {
                    f.push({
                        name: g,
                        value: S,
                        type: 1
                    });
                }, v.isMatch = function(g) {
                    if (!f || 0 === f.length) return !0;
                    if (!g) return !1;
                    for(var S = 0; S < f.length; S++){
                        var v = f[S], _ = g[v.name];
                        if (_) {
                            if (0 === v.type) {
                                if (0 !== _.indexOf(v.value)) return !1;
                            } else if (1 === v.type && -1 === _.indexOf(v.value)) return !1;
                        }
                    }
                    return !0;
                }, g && v.parseQuery(g);
            });
        }
        return SimpleQuery.__ieDyn = 1, SimpleQuery;
    }(), xc = 10, Uc = 1, Vc = 6e5, Bc = 6048e5, Hc = "Unknown", $c = -1, jc = "DBError: Unable to add event", Gc = "DBError: Unable to update iKey", qc = 1, Wc = "Evts", zc = "iKey", Kc = isValidPersistenceLevel;
    function _getTime() {
        return (new Date).getTime();
    }
    function _eventReject$1(g, f) {
        return function(S) {
            return f(new Error(g));
        };
    }
    function _createDb(g) {
        g.objectStoreNames.contains(Wc) || g.createObjectStore(Wc, {
            keyPath: "key"
        }).createIndex("EvntId", "key", {
            unique: !1
        });
        g.objectStoreNames.contains(zc) || g.createObjectStore(zc, {
            keyPath: "iKey"
        }).createIndex("iKey", "iKey", {
            unique: !0
        });
    }
    function _updateiKey(g) {
        return g.openStore(zc, function(f) {
            return createAsyncPromise(function(S, v) {
                var _ = {
                    iKey: g.ctx.iKey,
                    tm: _getTime()
                }, C = f.store.put(_);
                C.onsuccess = function(g) {
                    S(C.result.toString());
                }, C.onerror = function(g) {
                    v(new Error(jc));
                }, C.onerror = _eventReject$1(Gc, v);
            });
        });
    }
    function _orderEventsByPriority(g) {
        for(var f = [], S = 2; S >= 1; S--)for(var v = 0; v < g.length; v++){
            var _ = g[v];
            _ && _.evt.persistence === S && f.push(_.evt);
        }
        return f;
    }
    function _addEventByTime(g, f) {
        for(var S = 0; S < g.length; S++)if (f.tm < g[S].tm) return void g.splice(S, 0, f);
        g.push(f);
    }
    function _getKeyIndex(g, f) {
        for(var S = f.length, v = 0; v < S; v++)if (g === f[v].id) return v;
        return -1;
    }
    function _isOldItem(g, f) {
        var S = g.tm;
        return _getTime() - S > f;
    }
    function _cursorContinueEvent(g) {
        return function(f) {
            return g.continue();
        };
    }
    function _cursorDeleteAndContinue(g) {
        var f = g.cursor.delete();
        return f.onerror = _cursorContinueEvent(g), f.onsuccess = _cursorContinueEvent(g), 1;
    }
    function _getAllEventsForiKey(g, f) {
        return g.openCursor(Wc, f, function(g, f, S) {
            return S.push(f), 0;
        });
    }
    function _deleteEvents(g, f, S) {
        return g.openCursor(Wc, f, function(g, f, v) {
            return S(f) ? (v.push(f), _cursorDeleteAndContinue(g)) : 0;
        });
    }
    function _deleteOrphanedEvents(g) {
        return createAsyncPromise(function(f, S) {
            var v = !1;
            g.openCursor(zc, null, function(g, f, S) {
                var _ = f.tm;
                return _getTime() - _ < Bc ? 0 : (v = !0, 2);
            }).then(function() {
                if (v) {
                    var _ = {};
                    _deleteEvents(g, null, function(g) {
                        if (!g || !g.evt || !g.evt.iKey) return !0;
                        var f = g.tm;
                        return _getTime() - f > Bc || (_[g.evt.iKey] = 1, !1);
                    }).then(function() {
                        var v = [];
                        g.openCursor(zc, null, function(g, f, S) {
                            var C = f.tm;
                            return _getTime() - C < Bc || _[f.iKey] ? 0 : (v.push(f), _cursorDeleteAndContinue(g));
                        }).then(function() {
                            f(v);
                        }, S);
                    }, S);
                } else f([]);
            }, S);
        });
    }
    function _moveOldEventsToCurrentStore(g, f) {
        return g.openCursor(Wc, "#key=" + g.ctx.iKeyPrefix(), function(S, v) {
            var _ = v.key;
            if (0 === _.indexOf(g.ctx.iKeyPrefix()) && -1 === _.indexOf(g.ctx.evtKeyPrefix()) && _isOldItem(v, f)) {
                v.key = g.ctx.evtKeyPrefix() + v.id;
                var C = S.store.store.put(v);
                return C.onerror = _cursorContinueEvent(S), C.onsuccess = function(g) {
                    try {
                        _cursorDeleteAndContinue(S);
                    } catch (g) {
                        S.continue();
                    }
                }, 1;
            }
            return 0;
        });
    }
    function _checkVersionAndMoveEventsToCurrentStorage(g, f) {
        return createAsyncPromise(function(S, v) {
            _deleteOrphanedEvents(g).then(function() {
                _moveOldEventsToCurrentStore(g, f).then(S, S);
            }, v);
        });
    }
    function _dropEventsUpToPersistence(g, f) {
        return createAsyncPromise(function(S, v) {
            var _ = 0, C = g.ctx.evtKeyPrefix();
            function _resolveWithDroppedEvents() {
                S(_);
            }
            function _dropEvent(g, f) {
                return createAsyncPromise(function(S) {
                    var v = g.store.delete(f.key);
                    v.onsuccess = function(g) {
                        _++, S();
                    }, v.onerror = function(g) {
                        S();
                    };
                });
            }
            function _processCandidates(f) {
                0 !== f.length ? g.openStore(Wc, function(g) {
                    for(var S = [], v = 0; v < f.length; v++)S.push(_dropEvent(g, f[v]));
                    return Dn(S).then(_resolveWithDroppedEvents, _resolveWithDroppedEvents);
                }) : _resolveWithDroppedEvents();
            }
            g.openCursor(Wc, "#key=" + C, function(g, S, v) {
                return S.evt.persistence <= f && 0 === S.key.indexOf(C) && (_addEventByTime(v, S), v.length > xc && v.splice(v.length - 1, 1)), 0;
            }).then(_processCandidates, function() {
                S(0);
            });
        });
    }
    var Jc = function() {
        function IndexedDbProvider(g, f) {
            dynamicProto$1(IndexedDbProvider, this, function(S) {
                var v = null, _ = null, C = Hc, E = null, T = null, I = null, b = $c, A = 0, R = Vc;
                function _openDb(g) {
                    function _handleDbUpgrade(g) {
                        return createAsyncPromise(function(f, S) {
                            _createDb(g.db), f();
                        });
                    }
                    function _handleDbOpen(f) {
                        return createAsyncPromise(function(S, v) {
                            var _ = {
                                iKey: C,
                                storageId: E,
                                iKeyPrefix: function() {
                                    return T;
                                },
                                evtKeyPrefix: function() {
                                    return I;
                                }
                            };
                            f.ctx = _, doAwait(_updateiKey(f), function() {
                                doAwait(g(f), S, v);
                            }, v);
                        });
                    }
                    return v.openDb(_, qc, _handleDbOpen, _handleDbUpgrade);
                }
                function _addDbEvent(g, f, S) {
                    return createAsyncPromise(function(v, _) {
                        function dropEvents(f, S) {
                            _dropEventsUpToPersistence(g, f).then(function(g) {
                                g > 0 && (A -= g), S(g);
                            }, function(g) {
                                S(0);
                            });
                        }
                        function resolveAddEvent(g) {
                            v(f.evt);
                        }
                        function _insertNewEvent() {
                            g.openStore(Wc, function(C) {
                                var E = C.store.put(f);
                                E.onsuccess = function(_) {
                                    S && _updateiKey(g).then(resolveAddEvent, resolveAddEvent), A++, v(f.evt);
                                }, E.onerror = function(C) {
                                    function _retryAddEvent(S) {
                                        0 === S && _(new Error(jc)), _addDbEvent(g, f, !1).then(function(g) {
                                            v(f.evt);
                                        }, function() {
                                            _(new Error(jc));
                                        });
                                    }
                                    S ? dropEvents(1, function(g) {
                                        g > 0 ? _retryAddEvent(g) : f.evt.persistence >= 2 ? dropEvents(2, function(g) {
                                            _retryAddEvent(g);
                                        }) : _(new Error(jc));
                                    }) : _(new Error(jc));
                                };
                            });
                        }
                        b > 0 && A >= b ? dropEvents(1, function(g) {
                            0 === g ? f.evt.persistence >= 2 ? dropEvents(2, function(g) {
                                _insertNewEvent();
                            }) : _(new Error(jc)) : _insertNewEvent();
                        }) : _insertNewEvent();
                    });
                }
                S.id = g, S.initialize = function(g) {
                    var A = g.itemCtx.diagLog();
                    if (!(v = new Lc(A)).isAvailable()) return v = null, !1;
                    var P = g.itemCtx.getCfg(), w = g.storageConfig;
                    C = P.instrumentationKey || C, E = S.id || g.id || newGuid$1(), I = (T = C + "::") + E + "::", R = w.accessThresholdInMs || R;
                    var M = onConfigChange$1(w, function() {
                        b = w.maxStorageItems;
                        var g = w.indexedDbName;
                        _ && g !== _ && _ && doAwaitResponse(S.clear(), function(f) {
                            _ = g, _openDb(function(g) {
                                return g.isNew ? [] : _checkVersionAndMoveEventsToCurrentStorage(g, R);
                            }).then(function(g) {}, function(g) {
                                A.warnToConsole("IndexedDbProvider failed to initialize - " + (g || "<unknown>")), v = null;
                            });
                        }), _ = g;
                    });
                    return f && f.add(M), _openDb(function(g) {
                        return g.isNew ? [] : _checkVersionAndMoveEventsToCurrentStorage(g, R);
                    }).then(function(g) {}, function(g) {
                        A.warnToConsole("IndexedDbProvider failed to initialize - " + (g || "<unknown>")), v = null;
                    }), !0;
                }, S._getDbgPlgTargets = function() {
                    return [
                        _
                    ];
                }, S.supportsSyncRequests = function() {
                    return !1;
                }, S.getAllEvents = function() {
                    return null != v && v.isAvailable() ? _openDb(function(g) {
                        return createAsyncPromise(function(f, S) {
                            _getAllEventsForiKey(g, "#key=" + g.ctx.evtKeyPrefix()).then(function(g) {
                                A = g.length, f(_orderEventsByPriority(g));
                            }, S);
                        });
                    }) : [];
                }, S.addEvent = function(g, f, S) {
                    return null != v && v.isAvailable() ? (f.id = f.id || newGuid$1(), Kc(f.persistence) || (f.persistence = 1), _openDb(function(S) {
                        var v = g || f.id, _ = {
                            key: S.ctx.evtKeyPrefix() + v,
                            id: v,
                            evt: f,
                            tm: _getTime(),
                            v: Uc
                        };
                        return _addDbEvent(S, _, !0);
                    })) : f;
                }, S.removeEvents = function(g) {
                    if (null == v || !v.isAvailable()) return [];
                    var f = [];
                    return createAsyncPromise(function(S, v) {
                        _openDb(function(S) {
                            return S.openCursor(Wc, "#key=" + S.ctx.iKey, function(S, v, _) {
                                if (-1 !== _getKeyIndex(v.id, g)) {
                                    var C = S.cursor.delete();
                                    return C.onerror = _cursorContinueEvent(S), C.onsuccess = function() {
                                        f.push(v.evt), S.continue();
                                    }, 1;
                                }
                                return 0;
                            });
                        }).then(function(g) {
                            A -= f.length, S(f);
                        }, function(g) {
                            A -= f.length, S(f);
                        });
                    });
                }, S.clear = function() {
                    return null != v && v.isAvailable() ? createAsyncPromise(function(g, f) {
                        _openDb(function(g) {
                            return _deleteEvents(g, "#key=" + g.ctx.evtKeyPrefix(), function(f) {
                                return 0 === f.key.indexOf(g.ctx.evtKeyPrefix());
                            });
                        }).then(function(f) {
                            A = 0, g(_orderEventsByPriority(f));
                        }, f);
                    }) : [];
                }, S.moveStaleEvents = function() {
                    _openDb(function(g) {
                        return _checkVersionAndMoveEventsToCurrentStorage(g, R);
                    });
                }, S.teardown = function() {
                    v && v.closeDb(_);
                };
            });
        }
        return IndexedDbProvider.__ieDyn = 1, IndexedDbProvider;
    }(), Yc = 10, Qc = "3", Xc = "Version", Zc = "AWTEvents", ed = 5e6;
    function _isQuotaExceeded(g, f) {
        var S = !1;
        return f instanceof DOMException && (22 !== f.code && "QuotaExceededError" !== f.name && 1014 !== f.code && "NS_ERROR_DOM_QUOTA_REACHED" !== f.name || g && 0 !== g.length && (S = !0)), S;
    }
    function _getAvailableStorage(g) {
        var f = getGlobal() || {}, S = null;
        try {
            if (S = f[g]) {
                var v = "__storage_test__";
                S.setItem(v, v), S.removeItem(v);
            }
        } catch (g) {
            _isQuotaExceeded(S, g) || (S = null);
        }
        return S;
    }
    function _forEachMap(g, f) {
        if (g) for(var S = Ve(g), v = 0; v < S.length; v++){
            var _ = S[v];
            if (!f(g[_], _)) break;
        }
    }
    function _isMapEmpty(g) {
        var f = !0;
        return _forEachMap(g, function(g, S) {
            return g && (f = !1), f;
        }), f;
    }
    function _dropEventsUpToPersistence$1(g, f) {
        for(var S = 1, v = 0, _loop_1 = function() {
            var g = [], _ = f[S];
            if (_forEachMap(_, function(f, S) {
                return g.push(S), ++v < Yc;
            }), v > 0) {
                for(var C = 0; C < g.length; C++)delete _[g[C]];
                return {
                    value: !0
                };
            }
            S++;
        }; S <= g && v < Yc;){
            var _ = _loop_1();
            if ("object" == typeof _) return _.value;
        }
        return v > 0;
    }
    var td, id = isValidPersistenceLevel, nd = function() {
        function WebStorageProvider(g, f, S) {
            dynamicProto$1(WebStorageProvider, this, function(v) {
                var _ = null, C = Zc, E = null, T = Qc, I = null, b = null, A = ed, R = 6e5, P = null, w = null;
                function _newStore(g, f) {
                    return {
                        key: g,
                        db: f
                    };
                }
                function _fetchStoredDb(g, f) {
                    void 0 === f && (f = !0);
                    var S = null;
                    if (_) {
                        var v = _.getItem(g);
                        if (v) try {
                            S = JSON.parse(v);
                        } catch (f) {
                            _.removeItem(g);
                        }
                    }
                    return f && !S && (S = {
                        events: {
                            1: {},
                            2: {},
                            3: {}
                        },
                        lastAccessTime: 0
                    }), _newStore(g, S);
                }
                function _updateStoredDb(g, f) {
                    void 0 === f && (f = !0);
                    var S = !0, v = g.db;
                    if (v) {
                        f && (v.lastAccessTime = (new Date).getTime());
                        for(var C = 1; C <= 2; C++)if (!_isMapEmpty(v.events[C])) {
                            S = !1;
                            break;
                        }
                    }
                    try {
                        if (S) _ && _.removeItem(g.key);
                        else {
                            var E = JSON.stringify(v);
                            if (E.length > A) return !1;
                            _ && _.setItem(g.key, E);
                        }
                    } catch (g) {
                        return !1;
                    }
                    return !0;
                }
                function _clearDatabase(g) {
                    var f = [], S = _fetchStoredDb(g, !1), v = S.db;
                    if (v) {
                        var C = v.events;
                        try {
                            for(var E = 1; E <= 2; E++)_forEachMap(C[E], function(g, S) {
                                return g && f.push(g), !0;
                            });
                        } catch (g) {}
                        _ && _.removeItem(S.key);
                    }
                    return f;
                }
                function _checkVersionAndMoveEventsToCurrentStorage() {
                    if (_) {
                        for(var g = _.getItem(P), f = [], S = _fetchStoredDb(w), v = !1, E = 0; E < _.length; E++){
                            var I = _.key(E);
                            if (0 === I.indexOf(C) && I !== P) {
                                if (g !== Qc) {
                                    f.push(_newStore(I, null));
                                    continue;
                                }
                                var A = _fetchStoredDb(I, !1), M = A.db;
                                if (M) {
                                    if ((new Date).getTime() - M.lastAccessTime > R) {
                                        for(var O = 1, _loop_3 = function() {
                                            var g = M.events[O], f = S.db.events[O];
                                            _forEachMap(g, function(S, v) {
                                                return (getTenantId$1(S.iKey) || S.iKey) === b && (f[v] = S, delete g[v]), !0;
                                            }), O++;
                                        }; O <= 2;)_loop_3();
                                        v = !0, f.push(A);
                                    }
                                } else f.push(_newStore(I, null));
                            }
                        }
                        for(E = 0; E < f.length; E++)_updateStoredDb(f[E], !1);
                        v && _updateStoredDb(S), _.setItem(P, T);
                    }
                }
                v.id = f, _ = _getAvailableStorage(g) || null, v._getDbgPlgTargets = function() {
                    return [
                        C,
                        A
                    ];
                }, v.initialize = function(g) {
                    if (!_) return !1;
                    var f = g.storageConfig;
                    E = v.id || g.id || newGuid$1(), I = g.itemCtx.getCfg().instrumentationKey, b = getTenantId$1(I) || I, R = f.accessThresholdInMs ? f.accessThresholdInMs : R;
                    var T = onConfigChange$1(f, function() {
                        A = f.maxStorageSizeInBytes;
                        var g = f.storageKey;
                        C && g !== C && doAwaitResponse(v.clear(), function(f) {
                            w = (C = g) + "." + E, P = C + Xc, _checkVersionAndMoveEventsToCurrentStorage();
                        });
                    });
                    return S && S.add(T), C = f.storageKey, w = C + "." + E, P = C + Xc, _checkVersionAndMoveEventsToCurrentStorage(), !0;
                }, v.supportsSyncRequests = function() {
                    return !0;
                }, v.getAllEvents = function() {
                    try {
                        var g = [], f = _fetchStoredDb(w, !1).db;
                        if (f) for(var S = f.events, v = 2; v >= 1; v--)_forEachMap(S[v], function(f) {
                            f && (getTenantId$1(f.iKey) || f.iKey) === b && g.push(f);
                            return !0;
                        });
                        return g;
                    } catch (g) {
                        return kn(g);
                    }
                }, v.addEvent = function(g, f, S) {
                    try {
                        var v = _fetchStoredDb(w);
                        f.id = f.id || newGuid$1(), id(f.persistence) || (f.persistence = 1);
                        for(var _ = f.persistence, C = f.id, E = v.db.events;;){
                            if (E[_][C] = f, _updateStoredDb(v)) return f;
                            if (delete E[_][C], !_dropEventsUpToPersistence$1(_, E)) return kn(new Error("Unable to free up event space"));
                        }
                    } catch (g) {
                        return kn(g);
                    }
                }, v.removeEvents = function(g) {
                    try {
                        var f = _fetchStoredDb(w, !1), S = f.db;
                        if (S) {
                            var v = S.events;
                            try {
                                for(var _ = 0; _ < g.length; ++_){
                                    var C = g[_];
                                    delete v[C.persistence][C.id];
                                }
                                if (_updateStoredDb(f)) return g;
                            } catch (g) {}
                            g = _clearDatabase(f.key);
                        }
                        return g;
                    } catch (g) {
                        return kn(g);
                    }
                }, v.clear = function() {
                    try {
                        var g = [], f = _fetchStoredDb(w, !1), S = f.db;
                        if (S) {
                            for(var v = S.events, _loop_2 = function(f) {
                                var S = v[f];
                                _forEachMap(S, function(f) {
                                    f && (getTenantId$1(f.iKey) || f.iKey) === b && (delete S[f.id], g.push(f));
                                    return !0;
                                });
                            }, _ = 2; _ >= 1; _--)_loop_2(_);
                            _updateStoredDb(f);
                        }
                        return g;
                    } catch (g) {
                        return kn(g);
                    }
                }, v.teardown = function() {
                    try {
                        var g = _fetchStoredDb(w, !1), f = g.db;
                        f && (f.lastAccessTime = 0, _updateStoredDb(g, !1));
                    } catch (g) {}
                }, v.moveStaleEvents = function() {
                    _checkVersionAndMoveEventsToCurrentStorage();
                };
            });
        }
        return WebStorageProvider.__ieDyn = 1, WebStorageProvider;
    }(), rd = "4.3.1", ad = "LocalStorage", sd = 5, od = isValidPersistenceLevel, ld = void 0, cd = "AppInsightEvents.1", dd = objDeepFreeze({
        maxStorageSizeInBytes: {
            isVal: isGreaterThanZero$1,
            v: 5e6
        },
        storageKey: "AWTEvents",
        minPersistenceLevel: {
            isVal: od,
            v: 1
        },
        providers: [
            _c.LocalStorage,
            _c.IndexedDb
        ],
        indexedDbName: cd,
        maxStorageItems: {
            isVal: isGreaterThanZero$1,
            v: ld
        }
    }), ud = function(g) {
        function LocalStorageChannel() {
            var f = g.call(this) || this;
            return f.identifier = ad, f.priority = 1009, f.version = rd, dynamicProto$1(LocalStorageChannel, f, function(g, f) {
                var S, v, _, C;
                function _initDefaults() {
                    S = !1, v = !1, _ = null, C = [];
                }
                function _queueStorageEvent(g, f) {
                    _ || (_ = createTaskScheduler(createAsyncPromise, "LocalStorage")), _.queue(function(g) {
                        return f(g);
                    }, g).catch(function(g) {});
                }
                function _sendStoredEventsToNextPlugin(f) {
                    doPerf$1(g.core, function() {
                        return "LocalStorageChannel:_sendStoredEventsToNextPlugin";
                    }, function() {
                        _queueStorageEvent("sendToNext", function(S) {
                            return doAwaitResponse(f.provider.getAllEvents(), function(S) {
                                for(var v = S.value || [], _ = 0; _ < v.length; _++)try {
                                    var C = v[_];
                                    (getTenantId$1(C.iKey) || C.iKey) === f.tenantId && g.processNext(C, f.coreRootCtx.createNew());
                                } catch (g) {}
                            });
                        });
                    }, function() {
                        return {
                            iKeyConfig: f
                        };
                    });
                }
                function _removeEvents(f, S) {
                    doPerf$1(g.core, function() {
                        return "LocalStorageChannel:_removeEvents";
                    }, function() {
                        _queueStorageEvent("removeEvents", function(g) {
                            var v = [];
                            if (arrForEach(S, function(g) {
                                (getTenantId$1(g.iKey) || g.iKey) === f.tenantId && v.push(g);
                            }), v.length > 0) return doAwaitResponse(f.provider.removeEvents(v), function(g) {});
                        });
                    }, function() {
                        return {
                            iKeyConfig: f,
                            events: S
                        };
                    });
                }
                function _shouldCacheEvent(g, f) {
                    return !(f.sync || f.persistence < g.minPersistenceCacheLevel);
                }
                function _tryGetIndexedDbProvider(f) {
                    var S = new Jc(void 0, g._unloadHooks);
                    return S.initialize(f) || (S = null), S;
                }
                function _tryGetWebStorageProvider(f, S) {
                    var v = new nd(f, void 0, g._unloadHooks);
                    return v.initialize(S) || (v = null), v;
                }
                function _initializeProvider(g) {
                    for(var f = g.storageConfig.providers, S = null, v = 0; !S && v < f.length && v < sd;)switch(f[v++]){
                        case _c.LocalStorage:
                            S = _tryGetWebStorageProvider("localStorage", g);
                            break;
                        case _c.SessionStorage:
                            S = _tryGetWebStorageProvider("sessionStorage", g);
                            break;
                        case _c.IndexedDb:
                            S = _tryGetIndexedDbProvider(g);
                    }
                    return S;
                }
                function _compareProviders(g, f) {
                    if (g.length !== f.length) return !1;
                    var S = !0;
                    return arrForEach(g, function(g, v) {
                        if (g !== f[v]) return S = !1, -1;
                    }), S;
                }
                function _getCoreItemCtx(f, S, v, _) {
                    f && (f.extensionConfig = f.extensionConfig || []), !_ && S && (_ = S.getProcessTelContext().getNext());
                    var C = null, E = g._getTelCtx().getNext();
                    return E && (C = E.getPlugin()), createProcessTelemetryContext$1(_, f, S, C);
                }
                function _createIkeyConfig(f, S, v, _) {
                    var E = !1;
                    if (arrForEach(C, function(g) {
                        if (g.iKey === f.instrumentationKey) return E = !0, -1;
                    }), !E) {
                        var T = null;
                        g._addHook(onConfigChange$1(f, function(v) {
                            var _ = createProcessTelemetryContext$1(null, v.cfg, S);
                            T = _.getExtCfg(g.identifier, dd);
                            var E = !1, I = null, b = f.instrumentationKey;
                            if (arrForEach(C, function(g) {
                                if (g.iKey === b) return E = !0, I = g, -1;
                            }), E && I) {
                                var R = T.providers, P = I.preProviders;
                                _compareProviders(R, P) || doAwaitResponse(A.clear(), function(g) {
                                    if (!g.rejected) try {
                                        var f = C.indexOf(I);
                                        -1 !== f && C.splice(f, 1);
                                        var v = _initializeProvider(I.providerContext);
                                        I.provider = v, I.preProviders = R.slice();
                                        var _ = I.preListener;
                                        _ && S.removeNotificationListener(_);
                                        var E = {
                                            eventsSent: function(g) {
                                                _removeEvents(I, g);
                                            },
                                            eventsDiscarded: function(g, f) {
                                                _removeEvents(I, g);
                                            }
                                        };
                                        I.preListener = E, C.push(I), S.addNotificationListener(E), _sendStoredEventsToNextPlugin(I);
                                    } catch (g) {}
                                });
                            }
                        }));
                        var I = _getCoreItemCtx(f, S, v, _), b = {
                            itemCtx: I,
                            storageConfig: T,
                            id: g.id
                        };
                        if (!Te(f.instrumentationKey)) return;
                        var A = _initializeProvider(b), R = {
                            iKey: f.instrumentationKey,
                            tenantId: getTenantId$1(f.instrumentationKey) || f.instrumentationKey,
                            minPersistenceCacheLevel: 1,
                            coreRootCtx: I,
                            providerContext: b,
                            provider: A,
                            preProviders: T.providers.slice()
                        };
                        if (A) {
                            od(T.minPersistenceLevel || -1) && (R.minPersistenceCacheLevel = T.minPersistenceLevel);
                            var P = {
                                eventsSent: function(g) {
                                    _removeEvents(R, g);
                                },
                                eventsDiscarded: function(g, f) {
                                    _removeEvents(R, g);
                                }
                            };
                            R.preListener = P, C.push(R), S.addNotificationListener(P), _sendStoredEventsToNextPlugin(R);
                        } else C.push(R);
                    }
                }
                _initDefaults(), g.initialize = function(g, v, C, E) {
                    doPerf$1(v, function() {
                        return "LocalStorageChannel.initialize";
                    }, function() {
                        S || (f.initialize(g, v, C), f.setInitialized(!1), S = !0, _ = createTaskScheduler(createAsyncPromise, "LocalStorage")), _createIkeyConfig(g, v, C, E);
                    }, function() {
                        return {
                            coreConfig: g,
                            core: v,
                            extensions: C,
                            pluginChain: E
                        };
                    });
                }, g.processTelemetry = function(f, _) {
                    var E = f;
                    if (S && !v) {
                        _ = g._getTelCtx(_), setProcessTelemetryTimings$1(f, g.identifier);
                        var T = null;
                        arrForEach(C, function(g) {
                            g.iKey === f.iKey && (T = g);
                        });
                        var I = T ? T.provider : null;
                        if (E.sync || !I) return void g.processNext(E, _);
                        E.id = E.id || newGuid$1(), isValidPersistenceLevel(E.persistence) || (E.persistence = 1), _shouldCacheEvent(T, E) && _queueStorageEvent("processTelemetry", function(g) {
                            return I.addEvent(E.id, E, _);
                        });
                    }
                    g.processNext(E, _);
                }, g.pause = function() {
                    v = !0;
                }, g.resume = function() {
                    doPerf$1(g.core, function() {
                        return "LocalStorageChannel:resume";
                    }, function() {
                        v = !1, arrForEach(C, function(g) {
                            g.provider && _sendStoredEventsToNextPlugin(g);
                        });
                    });
                }, g._doTeardown = function(g, f) {
                    arrForEach(C, function(g) {
                        var f = g.provider;
                        f && f.teardown();
                    }), _initDefaults();
                }, g.flush = function(g, f, S) {}, g._getDbgPlgTargets = function() {
                    return [
                        C
                    ];
                }, g._sendStale = function(g) {
                    arrForEach(C, function(f) {
                        if (f && f.iKey === g && f.provider) return f.provider.moveStaleEvents(), _sendStoredEventsToNextPlugin(f), -1;
                    });
                };
            }), f;
        }
        return __extendsFn$1(LocalStorageChannel, g), LocalStorageChannel.__ieDyn = 1, LocalStorageChannel;
    }(mc), hd = "REAL_TIME", gd = "NEAR_REAL_TIME", pd = "BEST_EFFORT", md = "function", fd = "prototype", Sd = Object, vd = ((getGlobal() || {}).Symbol, (getGlobal() || {}).Reflect, "hasOwnProperty"), extendStaticsFn$2 = function(g, f) {
        return extendStaticsFn$2 = Sd.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f[vd](S) && (g[S] = f[S]);
        }, extendStaticsFn$2(g, f);
    };
    function __extendsFn$2(g, f) {
        function __() {
            this.constructor = g;
        }
        typeof f !== md && null !== f && throwTypeError("Class extends value " + String(f) + " is not a constructor or null"), extendStaticsFn$2(g, f), g[fd] = null === f ? ut(f) : (__[fd] = f[fd], new __);
    }
    var _d = "constructor", Cd = "prototype", yd = "function", Ed = "_dynInstFuncs", Td = "_isDynProxy", Id = "_dynClass", bd = "_dynCls$", Ad = "_dynInstChk", Rd = Ad, Pd = "_dfOpts", wd = "_unknown_", Md = "__proto__", Od = "_dyn" + Md, Dd = "__dynProto$Gbl", Nd = "_dynInstProto", kd = "useBaseInst", Ld = "setInstFuncs", Fd = Object, xd = Fd.getPrototypeOf, Ud = Fd.getOwnPropertyNames, Vd = getGlobal(), Bd = Vd[Dd] || (Vd[Dd] = {
        o: (td = {}, td[Ld] = !0, td[kd] = !0, td),
        n: 1e3
    });
    function _isObjectOrArrayPrototype$2(g) {
        return g && (g === Fd[Cd] || g === Array[Cd]);
    }
    function _isObjectArrayOrFunctionPrototype$2(g) {
        return _isObjectOrArrayPrototype$2(g) || g === Function[Cd];
    }
    function _getObjProto$2(g) {
        var f;
        if (g) {
            if (xd) return xd(g);
            var S = g[Md] || g[Cd] || (g[_d] ? g[_d][Cd] : null);
            f = g[Od] || S, objHasOwnProperty(g, Od) || (delete g[Nd], f = g[Od] = g[Nd] || g[Od], g[Nd] = S);
        }
        return f;
    }
    function _forEachProp$2(g, f) {
        var S = [];
        if (Ud) S = Ud(g);
        else for(var v in g)"string" == typeof v && objHasOwnProperty(g, v) && S.push(v);
        if (S && S.length > 0) for(var _ = 0; _ < S.length; _++)f(S[_]);
    }
    function _isDynamicCandidate$2(g, f, S) {
        return f !== _d && typeof g[f] === yd && (S || objHasOwnProperty(g, f)) && f !== Md && f !== Cd;
    }
    function _throwTypeError$2(g) {
        throwTypeError("DynamicProto: " + g);
    }
    function _getInstanceFuncs$2(g) {
        var f = ut(null);
        return _forEachProp$2(g, function(S) {
            !f[S] && _isDynamicCandidate$2(g, S, !1) && (f[S] = g[S]);
        }), f;
    }
    function _hasVisited$2(g, f) {
        for(var S = g.length - 1; S >= 0; S--)if (g[S] === f) return !0;
        return !1;
    }
    function _getBaseFuncs$2(g, f, S, v) {
        function _instFuncProxy(g, f, S) {
            var _ = f[S];
            if (_[Td] && v) {
                var C = g[Ed] || {};
                !1 !== C[Rd] && (_ = (C[f[Id]] || {})[S] || _);
            }
            return function() {
                return _.apply(g, arguments);
            };
        }
        var _ = ut(null);
        _forEachProp$2(S, function(g) {
            _[g] = _instFuncProxy(f, S, g);
        });
        for(var C = _getObjProto$2(g), E = []; C && !_isObjectArrayOrFunctionPrototype$2(C) && !_hasVisited$2(E, C);)_forEachProp$2(C, function(g) {
            !_[g] && _isDynamicCandidate$2(C, g, !xd) && (_[g] = _instFuncProxy(f, C, g));
        }), E.push(C), C = _getObjProto$2(C);
        return _;
    }
    function _getInstFunc$2(g, f, S, v) {
        var _ = null;
        if (g && objHasOwnProperty(S, Id)) {
            var C = g[Ed] || ut(null);
            if ((_ = (C[S[Id]] || ut(null))[f]) || _throwTypeError$2("Missing [" + f + "] " + yd), !_[Ad] && !1 !== C[Rd]) {
                for(var E = !objHasOwnProperty(g, f), T = _getObjProto$2(g), I = []; E && T && !_isObjectArrayOrFunctionPrototype$2(T) && !_hasVisited$2(I, T);){
                    var b = T[f];
                    if (b) {
                        E = b === v;
                        break;
                    }
                    I.push(T), T = _getObjProto$2(T);
                }
                try {
                    E && (g[f] = _), _[Ad] = 1;
                } catch (g) {
                    C[Rd] = !1;
                }
            }
        }
        return _;
    }
    function _getProtoFunc$2(g, f, S) {
        var v = f[g];
        return v === S && (v = _getObjProto$2(f)[g]), typeof v !== yd && _throwTypeError$2("[" + g + "] is not a " + yd), v;
    }
    function _populatePrototype$2(g, f, S, v, _) {
        function _createDynamicPrototype(g, f) {
            var dynProtoProxy = function() {
                return (_getInstFunc$2(this, f, g, dynProtoProxy) || _getProtoFunc$2(f, g, dynProtoProxy)).apply(this, arguments);
            };
            return dynProtoProxy[Td] = 1, dynProtoProxy;
        }
        if (!_isObjectOrArrayPrototype$2(g)) {
            var C = S[Ed] = S[Ed] || ut(null);
            if (!_isObjectOrArrayPrototype$2(C)) {
                var E = C[f] = C[f] || ut(null);
                !1 !== C[Rd] && (C[Rd] = !!_), _isObjectOrArrayPrototype$2(E) || _forEachProp$2(S, function(f) {
                    _isDynamicCandidate$2(S, f, !1) && S[f] !== v[f] && (E[f] = S[f], delete S[f], (!objHasOwnProperty(g, f) || g[f] && !g[f][Td]) && (g[f] = _createDynamicPrototype(g, f)));
                });
            }
        }
    }
    function _checkPrototype$2(g, f) {
        if (xd) {
            for(var S = [], v = _getObjProto$2(f); v && !_isObjectArrayOrFunctionPrototype$2(v) && !_hasVisited$2(S, v);){
                if (v === g) return !0;
                S.push(v), v = _getObjProto$2(v);
            }
            return !1;
        }
        return !0;
    }
    function _getObjName$2(g, f) {
        return objHasOwnProperty(g, Cd) ? g.name || f || wd : ((g || {})[_d] || {}).name || f || wd;
    }
    function dynamicProto$2(g, f, S, v) {
        objHasOwnProperty(g, Cd) || _throwTypeError$2("theClass is an invalid class definition.");
        var _ = g[Cd];
        _checkPrototype$2(_, f) || _throwTypeError$2("[" + _getObjName$2(g) + "] not in hierarchy of [" + _getObjName$2(f) + "]");
        var C = null;
        objHasOwnProperty(_, Id) ? C = _[Id] : (C = bd + _getObjName$2(g, "_") + "$" + Bd.n, Bd.n++, _[Id] = C);
        var E = dynamicProto$2[Pd], T = !!E[kd];
        T && v && void 0 !== v[kd] && (T = !!v[kd]);
        var I = _getInstanceFuncs$2(f);
        S(f, _getBaseFuncs$2(_, f, I, T));
        var b = !!xd && !!E[Ld];
        b && v && (b = !!v[Ld]), _populatePrototype$2(_, C, f, I, !1 !== b);
    }
    dynamicProto$2[Pd] = Bd.o;
    var Hd = "", $d = "drop", jd = "send", Gd = "requeue", qd = "rspFail", Wd = "oth", zd = "no-cache, no-store", Kd = "application/x-json-stream", Jd = "cache-control", Yd = "content-type", Qd = "kill-tokens", Xd = "kill-duration", Zd = "time-delta-millis", eu = "client-version", tu = "client-id", iu = "time-delta-to-apply-millis", nu = "upload-time", ru = "apikey", au = "AuthMsaDeviceTicket", su = "WebAuthToken", ou = "AuthXToken", lu = "NoResponseBody", cu = "msfpc", du = "trace", uu = "user", hu = "allowRequestSending", gu = "firstRequestSent", pu = "shouldAddClockSkewHeaders", mu = "getClockSkewHeaderValue", fu = "setClockSkew", Su = "length", vu = "concat", _u = "iKey", Cu = "count", yu = "events", Eu = "push", Tu = "split", Iu = "splice", bu = "toLowerCase", Au = "hdrs", Ru = "useHdrs", Pu = "initialize", wu = "setTimeoutOverride", Mu = "clearTimeoutOverride", Ou = "payloadPreprocessor", Du = "overrideEndpointUrl", Nu = "avoidOptions", ku = "disableEventTimings", Lu = "stringifyObjects", Fu = "enableCompoundKey", xu = "disableXhrSync", Uu = "disableFetchKeepAlive", Vu = "addNoResponse", Bu = "excludeCsMetaData", Hu = "useSendBeacon", $u = "fetchCredentials", ju = "alwaysUseXhrOverride", Gu = "unloadTransports", qu = "serializeOfflineEvt", Wu = "getOfflineRequestDetails", zu = "createPayload", Ku = "createOneDSPayload", Ju = "payloadBlob", Yu = "headers", Qu = "_thePayload", Xu = "urlString", Zu = "batches", eh = "sendType", th = "addHeader", ih = "canSendRequest", nh = "sendQueuedRequests", rh = "isCompletelyIdle", ah = "setUnloading", sh = "isTenantKilled", oh = "sendSynchronousBatch", lh = "_transport", ch = "getWParam", dh = "isBeacon", uh = "timings", hh = "isTeardown", gh = "isSync", ph = "data", mh = "timeout", fh = "_sendReason", Sh = "setKillSwitchTenants", vh = "_backOffTransmission", _h = "identifier", Ch = "disableOptimizeObj", yh = "ignoreMc1Ms0CookieProcessing", Eh = "eventsLimitInMem", Th = "autoFlushEventsLimit", Ih = "disableAutoBatchFlushLimit", bh = "overrideInstrumentationKey", Ah = "disableTelemetry", Rh = "baseData", Ph = "sendAttempt", wh = "latency", Mh = "sync";
    function _getEventMsfpc(g) {
        var f = (g.ext || {}).intweb;
        return f && isValueAssigned(f[cu]) ? f[cu] : null;
    }
    function _getMsfpc(g) {
        for(var f = null, S = 0; null === f && S < g[Su]; S++)f = _getEventMsfpc(g[S]);
        return f;
    }
    var Oh = function() {
        function EventBatch(g, f) {
            var S = f ? [][vu](f) : [], v = this, _ = _getMsfpc(S);
            v[_u] = function() {
                return g;
            }, v.Msfpc = function() {
                return _ || Hd;
            }, v[Cu] = function() {
                return S[Su];
            }, v[yu] = function() {
                return S;
            }, v.addEvent = function(g) {
                return !!g && (S[Eu](g), _ || (_ = _getEventMsfpc(g)), !0);
            }, v[Tu] = function(f, v) {
                var C;
                if (f < S[Su]) {
                    var E = S[Su] - f;
                    isNullOrUndefined(v) || (E = v < E ? v : E), C = S[Iu](f, E), _ = _getMsfpc(S);
                }
                return new EventBatch(g, C);
            };
        }
        return EventBatch.create = function(g, f) {
            return new EventBatch(g, f);
        }, EventBatch;
    }(), Dh = function() {
        function ClockSkewManager() {
            var g = !0, f = !0, S = !0, v = "use-collector-delta", _ = !1;
            dynamicProto$2(ClockSkewManager, this, function(C) {
                C[hu] = function() {
                    return g;
                }, C[gu] = function() {
                    S && (S = !1, _ || (g = !1));
                }, C[pu] = function() {
                    return f;
                }, C[mu] = function() {
                    return v;
                }, C[fu] = function(S) {
                    _ || (S ? (v = S, f = !0, _ = !0) : f = !1, g = !0);
                };
            });
        }
        return ClockSkewManager.__ieDyn = 1, ClockSkewManager;
    }(), Nh = 1e3, kh = function() {
        function KillSwitch() {
            var g = {};
            function _normalizeTenants(g) {
                var f = [];
                return g && arrForEach(g, function(g) {
                    f[Eu](mt(g));
                }), f;
            }
            dynamicProto$2(KillSwitch, this, function(f) {
                f[Sh] = function(f, S) {
                    if (f && S) try {
                        var v = _normalizeTenants(f[Tu](","));
                        if ("this-request-only" === S) return v;
                        for(var _ = parseInt(S, 10) * Nh, C = 0; C < v[Su]; ++C)g[v[C]] = utcNow() + _;
                    } catch (g) {
                        return [];
                    }
                    return [];
                }, f[sh] = function(f) {
                    var S = g, v = mt(f);
                    return void 0 !== S[v] && S[v] > utcNow() || (delete S[v], !1);
                };
            });
        }
        return KillSwitch.__ieDyn = 1, KillSwitch;
    }(), Lh = .8, Fh = 1.2, xh = 3e3, Uh = 6e5;
    function retryPolicyShouldRetryForStatus(g) {
        return !(g >= 300 && g < 500 && 429 != g || 501 == g || 505 == g);
    }
    function retryPolicyGetMillisToBackoffForRetry(g) {
        var f = 0, S = xh * Lh, v = xh * Fh, _ = Math.floor(Math.random() * (v - S)) + S;
        return f = Math.pow(2, g) * _, Math.min(f, Uh);
    }
    var Vh, Bh = 20, Hh = 3984588, $h = 65e3, jh = 2e6, Gh = Math.min(jh, $h), qh = "metadata", Wh = "f", zh = /\./, Kh = function() {
        function Serializer(g, f, S, v, _, C) {
            var E = "data", T = "baseData", I = "ext", b = !!v, A = !0, R = f, P = {}, w = !!C, M = _ || getCommonSchemaMetaData;
            dynamicProto$2(Serializer, this, function(f) {
                function _isReservedField(g, f) {
                    var S = P[g];
                    return void 0 === S && (g.length >= 7 && (S = yt(g, "ext.metadata") || yt(g, "ext.web")), P[g] = S), S;
                }
                function _processPathKeys(g, f, v, _, C, E, T) {
                    objForEachKey(g, function(g, I) {
                        var A = null;
                        if (I || isValueAssigned(I)) {
                            var P = v, w = g, M = C, O = f;
                            if (b && !_ && zh.test(g)) {
                                var D = g.split("."), N = D.length;
                                if (N > 1) {
                                    M && (M = M.slice());
                                    for(var k = 0; k < N - 1; k++){
                                        var L = D[k];
                                        O = O[L] = O[L] || {}, P += "." + L, M && M.push(L);
                                    }
                                    w = D[N - 1];
                                }
                            }
                            if (A = !(_ && _isReservedField(P)) && R && R.handleField(P, w) ? R.value(P, w, I, S) : sanitizeProperty(w, I, S)) {
                                var F = A.value;
                                if (O[w] = F, E && E(M, w, A), T && "object" == typeof F && !be(F)) {
                                    var x = M;
                                    x && (x = x.slice()).push(w), _processPathKeys(I, F, P + "." + w, _, x, E, T);
                                }
                            }
                        }
                    });
                }
                f.createPayload = function(g, f, S, v, _, C) {
                    return {
                        apiKeys: [],
                        payloadBlob: Hd,
                        overflow: null,
                        sizeExceed: [],
                        failedEvts: [],
                        batches: [],
                        numEvents: 0,
                        retryCnt: g,
                        isTeardown: f,
                        isSync: S,
                        isBeacon: v,
                        sendType: C,
                        sendReason: _
                    };
                }, f.appendPayload = function(S, v, _) {
                    var C = S && v && !S.overflow;
                    return C && doPerf(g, function() {
                        return "Serializer:appendPayload";
                    }, function() {
                        for(var g = v.events(), C = S.payloadBlob, E = S.numEvents, T = !1, I = [], b = [], A = S.isBeacon, R = A ? $h : Hh, P = A ? Gh : jh, w = 0, M = 0; w < g.length;){
                            var O = g[w];
                            if (O) {
                                if (E >= _) {
                                    S.overflow = v.split(w);
                                    break;
                                }
                                var D = f.getEventBlob(O);
                                if (D && D.length <= P) {
                                    var N = D.length;
                                    if (C.length + N > R) {
                                        S.overflow = v.split(w);
                                        break;
                                    }
                                    C && (C += "\n"), C += D, ++M > Bh && (Je(C, 0, 1), M = 0), T = !0, E++;
                                } else D ? I.push(O) : b.push(O), g.splice(w, 1), w--;
                            }
                            w++;
                        }
                        if (I.length > 0 && S.sizeExceed.push(Oh.create(v.iKey(), I)), b.length > 0 && S.failedEvts.push(Oh.create(v.iKey(), b)), T) {
                            S.batches.push(v), S.payloadBlob = C, S.numEvents = E;
                            var k = v.iKey();
                            -1 === ct(S.apiKeys, k) && S.apiKeys.push(k);
                        }
                    }, function() {
                        return {
                            payload: S,
                            theBatch: {
                                iKey: v.iKey(),
                                evts: v.events()
                            },
                            max: _
                        };
                    }), C;
                }, f.getEventBlob = function(f) {
                    try {
                        return doPerf(g, function() {
                            return "Serializer.getEventBlob";
                        }, function() {
                            var g = {};
                            g.name = f.name, g.time = f.time, g.ver = f.ver, g.iKey = "o:" + getTenantId(f.iKey);
                            var S, v = {};
                            w || (S = function(g, f, S) {
                                _addJSONPropertyMetaData(M, v, g, f, S);
                            });
                            var _ = f[I];
                            _ && (g[I] = v, objForEachKey(_, function(g, f) {
                                _processPathKeys(f, v[g] = {}, "ext." + g, !0, null, null, !0);
                            }));
                            var C = g[E] = {};
                            C.baseType = f.baseType;
                            var b = C[T] = {};
                            return _processPathKeys(f.baseData, b, T, !1, [
                                T
                            ], S, A), _processPathKeys(f.data, C, E, !1, [], S, A), JSON.stringify(g);
                        }, function() {
                            return {
                                item: f
                            };
                        });
                    } catch (g) {
                        return null;
                    }
                };
            });
        }
        return Serializer.__ieDyn = 1, Serializer;
    }();
    function _addJSONPropertyMetaData(g, f, S, v, _) {
        if (_ && f) {
            var C = g(_.value, _.kind, _.propertyType);
            if (C > -1) {
                var E = f[qh];
                E || (E = f[qh] = {
                    f: {}
                });
                var T = E[Wh];
                if (T || (T = E[Wh] = {}), S) for(var I = 0; I < S.length; I++){
                    var b = S[I];
                    T[b] || (T[b] = {
                        f: {}
                    });
                    var A = T[b][Wh];
                    A || (A = T[b][Wh] = {}), T = A;
                }
                T = T[v] = {}, be(_.value) ? T.a = {
                    t: C
                } : T.t = C;
            }
        }
    }
    function createTimeoutWrapper(g, f) {
        return {
            set: function(S, v) {
                for(var _ = [], C = 2; C < arguments.length; C++)_[C - 2] = arguments[C];
                return scheduleTimeoutWith([
                    g,
                    f
                ], S, v, _);
            }
        };
    }
    var Jh = "sendAttempt", Yh = "&" + lu + "=true", Qh = "?cors=true&" + Yd[bu]() + "=" + Kd, Xh = ((Vh = {})[1] = Gd, Vh[100] = Gd, Vh[200] = "sent", Vh[8004] = $d, Vh[8003] = $d, Vh), Zh = {}, eg = {};
    function _addCollectorHeaderQsMapping(g, f, S) {
        Zh[g] = f, !1 !== S && (eg[f] = g);
    }
    function _hasHeader(g, f) {
        var S = !1;
        if (g && f) {
            var v = Ve(g);
            if (v && v[Su] > 0) for(var _ = f[bu](), C = 0; C < v[Su]; C++){
                var E = v[C];
                if (E && objHasOwnProperty(f, E) && E[bu]() === _) {
                    S = !0;
                    break;
                }
            }
        }
        return S;
    }
    function _addRequestDetails(g, f, S, v) {
        f && S && S[Su] > 0 && (v && Zh[f] ? (g[Au][Zh[f]] = S, g[Ru] = !0) : g.url += "&" + f + "=" + S);
    }
    function _addQueryStringParameter(g, f, S) {
        for(var v = 0; v < g[Su]; v++)if (g[v].name === f) return void (g[v].value = S);
        g[Eu]({
            name: f,
            value: S
        });
    }
    function _removeQueryStringParameter(g, f) {
        for(var S = 0; S < g[Su]; S++)if (g[S].name === f) return void g[Iu](S, 1);
    }
    _addCollectorHeaderQsMapping(au, au, !1), _addCollectorHeaderQsMapping(eu, eu), _addCollectorHeaderQsMapping(tu, "Client-Id"), _addCollectorHeaderQsMapping(ru, ru), _addCollectorHeaderQsMapping(iu, iu), _addCollectorHeaderQsMapping(nu, nu), _addCollectorHeaderQsMapping(ou, ou);
    var tg = function() {
        function HttpManager(g, f, S, v) {
            var _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G, q, W, z, K, Y, Q, X, Z = !1;
            dynamicProto$2(HttpManager, this, function(ee) {
                _initDefaults();
                var te = !0;
                function _getSenderInterface(g, f) {
                    try {
                        return Q && Q.getSenderInst(g, f);
                    } catch (g) {}
                    return null;
                }
                function _getSendPostMgrConfig() {
                    try {
                        return {
                            enableSendPromise: !1,
                            isOneDs: !0,
                            disableCredentials: !te,
                            fetchCredentials: X,
                            disableXhr: !1,
                            disableBeacon: !Z,
                            disableBeaconSync: !Z,
                            disableFetchKeepAlive: B,
                            timeWrapper: K,
                            addNoResponse: $,
                            senderOnCompleteCallBack: {
                                xdrOnComplete: _xdrOncomplete,
                                fetchOnComplete: _fetchOnComplete,
                                xhrOnComplete: _xhrOnComplete,
                                beaconOnRetry: _onBeaconRetry
                            }
                        };
                    } catch (g) {}
                    return null;
                }
                function _xdrOncomplete(g, f, S) {
                    var v = getResponseText(g);
                    _doOnComplete(f, 200, {}, v), _handleCollectorResponse(v);
                }
                function _initDefaults() {
                    var g;
                    _ = null, C = new kh, E = !1, T = new Dh, Z = !1, I = 0, b = null, A = null, R = null, P = null, w = !0, M = [], O = {}, D = [], N = null, k = !1, L = null, F = !1, x = !1, U = g, V = g, B = g, H = g, $ = g, j = [], G = g, q = g, W = [], z = !1, K = createTimeoutWrapper(), Y = !1, Q = null;
                }
                function _fetchOnComplete(g, f, S, v) {
                    var handleResponse = function(g, S, v) {
                        _doOnComplete(f, g, S, v), _handleCollectorResponse(v);
                    }, _ = {}, C = g[Yu];
                    C && C.forEach(function(g, f) {
                        _[f] = g;
                    }), handleResponse(g.status, _, S || Hd);
                }
                function _xhrOnComplete(g, f, S) {
                    var v = getResponseText(g);
                    _doOnComplete(f, g.status, _getAllResponseHeaders(g, !0), v), _handleCollectorResponse(v);
                }
                function _doOnComplete(g, f, S, v) {
                    try {
                        g(f, S, v);
                    } catch (g) {
                        _throwInternal(A, 2, 518, dumpObj(g));
                    }
                }
                function _onBeaconRetry(g, f, S) {
                    var v = 200, _ = g[Qu], C = g[Xu] + ($ ? Yh : Hd);
                    try {
                        var E = ot();
                        if (_) {
                            var T = !!P.getPlugin("LocalStorage"), I = [], b = [];
                            arrForEach(_[Zu], function(g) {
                                if (I && g && g[Cu]() > 0) for(var f = g[yu](), S = 0; S < f[Su]; S++){
                                    if (!E.sendBeacon(C, N.getEventBlob(f[S]))) {
                                        I[Eu](g[Tu](S));
                                        break;
                                    }
                                    b[Eu](g[S]);
                                }
                                else I[Eu](g[Tu](0));
                            }), b[Su] > 0 && (_.sentEvts = b), T || _sendBatchesNotification(I, 8003, _[eh], !0);
                        } else v = 0;
                    } catch (g) {
                        _warnToConsole(A, "Failed to send telemetry using sendBeacon API. Ex:" + dumpObj(g)), v = 0;
                    } finally{
                        _doOnComplete(f, v, {}, Hd);
                    }
                }
                function _isBeaconPayload(g) {
                    return 2 === g || 3 === g;
                }
                function _adjustSendType(g) {
                    return F && _isBeaconPayload(g) && (g = 2), g;
                }
                function _hasIdleConnection() {
                    return !E && I < f;
                }
                function _clearQueue() {
                    var g = D;
                    return D = [], g;
                }
                function _canSendPayload(g, f, S) {
                    var v = !1;
                    return g && g[Su] > 0 && !E && R[f] && N && (v = 0 !== f || _hasIdleConnection() && (S > 0 || T[hu]())), v;
                }
                function _createDebugBatches(g) {
                    var f = {};
                    return g && arrForEach(g, function(g, S) {
                        f[S] = {
                            iKey: g[_u](),
                            evts: g[yu]()
                        };
                    }), f;
                }
                function _sendBatches(f, S, v, _, T) {
                    if (f && 0 !== f[Su]) {
                        if (E) _sendBatchesNotification(f, 1, _);
                        else {
                            _ = _adjustSendType(_);
                            try {
                                var I = f, b = 0 !== _;
                                doPerf(P, function() {
                                    return "HttpManager:_sendBatches";
                                }, function(E) {
                                    E && (f = f.slice(0));
                                    for(var I = [], A = null, P = Vs(), w = R[_] || (b ? R[1] : R[0]), M = w && w[lh], O = H && (F || _isBeaconPayload(_) || 3 === M || w._isSync && 2 === M); _canSendPayload(f, _, S);){
                                        var k = f.shift();
                                        k && k[Cu]() > 0 && (C.isTenantKilled(k[_u]()) ? I[Eu](k) : (A = A || N[zu](S, v, b, O, T, _), N.appendPayload(A, k, g) ? null !== A.overflow && (f = [
                                            A.overflow
                                        ][vu](f), A.overflow = null, _doPayloadSend(A, P, Vs(), T), P = Vs(), A = null) : (_doPayloadSend(A, P, Vs(), T), P = Vs(), f = [
                                            k
                                        ][vu](f), A = null)));
                                    }
                                    A && _doPayloadSend(A, P, Vs(), T), f[Su] > 0 && (D = f[vu](D)), _sendBatchesNotification(I, 8004, _);
                                }, function() {
                                    return {
                                        batches: _createDebugBatches(I),
                                        retryCount: S,
                                        isTeardown: v,
                                        isSynchronous: b,
                                        sendReason: T,
                                        useSendBeacon: _isBeaconPayload(_),
                                        sendType: _
                                    };
                                }, !b);
                            } catch (g) {
                                _throwInternal(A, 2, 48, "Unexpected Exception sending batch: " + dumpObj(g));
                            }
                        }
                    }
                }
                function _buildRequestDetails(g, f) {
                    var S = {
                        url: _,
                        hdrs: {},
                        useHdrs: !1
                    };
                    f ? (S[Au] = extend(S[Au], O), S.useHdrs = Ve(S.hdrs)[Su] > 0) : objForEachKey(O, function(g, f) {
                        eg[g] ? _addRequestDetails(S, eg[g], f, !1) : (S[Au][g] = f, S[Ru] = !0);
                    }), _addRequestDetails(S, tu, "NO_AUTH", f), _addRequestDetails(S, eu, Fs, f);
                    var v = Hd;
                    arrForEach(g.apiKeys, function(g) {
                        v[Su] > 0 && (v += ","), v += g;
                    }), _addRequestDetails(S, ru, v, f), _addRequestDetails(S, nu, utcNow().toString(), f);
                    var C = _getMsfpc(g);
                    if (isValueAssigned(C) && (S.url += "&ext.intweb.msfpc=" + C), T[pu]() && _addRequestDetails(S, iu, T[mu](), f), P[ch]) {
                        var E = P[ch]();
                        E >= 0 && (S.url += "&w=" + E);
                    }
                    for(var I = 0; I < M[Su]; I++)S.url += "&" + M[I].name + "=" + M[I].value;
                    return S;
                }
                function _setTimingValue(g, f, S) {
                    g[f] = g[f] || {}, g[f][b.identifier] = S;
                }
                function _doPayloadSend(g, f, S, v) {
                    if (g && g.payloadBlob && g.payloadBlob[Su] > 0) {
                        var _ = !!G, C = R[g.sendType];
                        !_isBeaconPayload(g[eh]) && g[dh] && 2 === g.sendReason && (C = R[2] || R[3] || C);
                        var E = x;
                        (g.isBeacon || 3 === C[lh]) && (E = !1);
                        var b = _buildRequestDetails(g, E);
                        E = E || b[Ru];
                        var M = Vs();
                        doPerf(P, function() {
                            return "HttpManager:_doPayloadSend";
                        }, function() {
                            for(var R = 0; R < g.batches[Su]; R++)for(var O = g[Zu][R][yu](), D = 0; D < O[Su]; D++){
                                var N = O[D];
                                if (k) {
                                    var L = N[uh] = N[uh] || {};
                                    _setTimingValue(L, "sendEventStart", M), _setTimingValue(L, "serializationStart", f), _setTimingValue(L, "serializationCompleted", S);
                                }
                                N[Jh] > 0 ? N[Jh]++ : N[Jh] = 1;
                            }
                            _sendBatchesNotification(g[Zu], 1e3 + (v || 0), g[eh], !0);
                            var F = {
                                data: g[Ju],
                                urlString: b.url,
                                headers: b[Au],
                                _thePayload: g,
                                _sendReason: v,
                                timeout: U,
                                disableXhrSync: V,
                                disableFetchKeepAlive: B
                            };
                            E && (_hasHeader(F[Yu], Jd) || (F[Yu][Jd] = zd), _hasHeader(F[Yu], Yd) || (F[Yu][Yd] = Kd));
                            var x = null;
                            C && (x = function(f) {
                                T[gu]();
                                var onComplete = function(f, S) {
                                    _retryRequestIfNeeded(f, S, g, v);
                                }, S = g[hh] || g[gh];
                                try {
                                    C.sendPOST(f, onComplete, S), q && q(F, f, S, g[dh]);
                                } catch (g) {
                                    _warnToConsole(A, "Unexpected exception sending payload. Ex:" + dumpObj(g)), _doOnComplete(onComplete, 0, {});
                                }
                            }), doPerf(P, function() {
                                return "HttpManager:_doPayloadSend.sender";
                            }, function() {
                                if (x) {
                                    if (0 === g[eh] && I++, _ && !g.isBeacon && 3 !== C[lh]) {
                                        var f = {
                                            data: F[ph],
                                            urlString: F[Xu],
                                            headers: extend({}, F[Yu]),
                                            timeout: F[mh],
                                            disableXhrSync: F[xu],
                                            disableFetchKeepAlive: F[Uu]
                                        }, S = !1;
                                        doPerf(P, function() {
                                            return "HttpManager:_doPayloadSend.sendHook";
                                        }, function() {
                                            try {
                                                G(f, function(g) {
                                                    S = !0, w || g[Qu] || (g[Qu] = g[Qu] || F[Qu], g[fh] = g[fh] || F[fh]), x(g);
                                                }, g.isSync || g[hh]);
                                            } catch (g) {
                                                S || x(F);
                                            }
                                        });
                                    } else x(F);
                                }
                            });
                        }, function() {
                            return {
                                thePayload: g,
                                serializationStart: f,
                                serializationCompleted: S,
                                sendReason: v
                            };
                        }, g[gh]);
                    }
                    g.sizeExceed && g.sizeExceed[Su] > 0 && _sendBatchesNotification(g.sizeExceed, 8003, g[eh]), g.failedEvts && g.failedEvts[Su] > 0 && _sendBatchesNotification(g.failedEvts, 8002, g[eh]);
                }
                function _addEventCompletedTimings(g, f) {
                    k && arrForEach(g, function(g) {
                        _setTimingValue(g[uh] = g[uh] || {}, "sendEventCompleted", f);
                    });
                }
                function _retryRequestIfNeeded(g, f, v, _) {
                    var E = 9e3, b = null, A = !1, R = !1;
                    try {
                        var P = !0;
                        if (typeof g !== J) {
                            if (f) {
                                T[fu](f[Zd]);
                                var w = f[Xd] || f["kill-duration-seconds"];
                                arrForEach(C[Sh](f[Qd], w), function(g) {
                                    arrForEach(v[Zu], function(f) {
                                        if (f[_u]() === g) {
                                            b = b || [];
                                            var S = f[Tu](0);
                                            v.numEvents -= S[Cu](), b[Eu](S);
                                        }
                                    });
                                });
                            }
                            if (200 == g || 204 == g) return void (E = 200);
                            (!retryPolicyShouldRetryForStatus(g) || v.numEvents <= 0) && (P = !1), E = 9e3 + g % 1e3;
                        }
                        if (P) {
                            E = 100;
                            var M = v.retryCnt;
                            0 === v[eh] && (M < S ? (A = !0, _doAction(function() {
                                0 === v[eh] && I--, _sendBatches(v[Zu], M + 1, v[hh], F ? 2 : v[eh], 5);
                            }, F, retryPolicyGetMillisToBackoffForRetry(M))) : (R = !0, F && (E = 8001)));
                        }
                    } finally{
                        A || (T[fu](), _handleRequestFinished(v, E, _, R)), _sendBatchesNotification(b, 8004, v[eh]);
                    }
                }
                function _handleRequestFinished(g, f, S, v) {
                    try {
                        v && b[vh]();
                        var _ = g[Zu];
                        200 === f && (_ = g.sentEvts || g[Zu], v || g[gh] || b._clearBackOff(), _addCompleteTimings(_)), _sendBatchesNotification(_, f, g[eh], !0);
                    } finally{
                        0 === g[eh] && (I--, 5 !== S && ee.sendQueuedRequests(g[eh], S));
                    }
                }
                function _addCompleteTimings(g) {
                    if (k) {
                        var f = Vs();
                        arrForEach(g, function(g) {
                            g && g[Cu]() > 0 && _addEventCompletedTimings(g[yu](), f);
                        });
                    }
                }
                function _doAction(g, f, S) {
                    f ? g() : K.set(g, S);
                }
                function _getMsfpc(g) {
                    for(var f = 0; f < g.batches[Su]; f++){
                        var S = g[Zu][f].Msfpc();
                        if (S) return encodeURIComponent(S);
                    }
                    return Hd;
                }
                function _handleCollectorResponse(g) {
                    var f = W;
                    try {
                        for(var S = 0; S < f[Su]; S++)try {
                            f[S](g);
                        } catch (g) {
                            _throwInternal(A, 1, 519, "Response handler failed: " + g);
                        }
                        if (g) {
                            var v = JSON.parse(g);
                            isValueAssigned(v.webResult) && isValueAssigned(v.webResult[cu]) && L.set("MSFPC", v.webResult[cu], 31536e3);
                        }
                    } catch (g) {}
                }
                function _sendBatchesNotification(g, f, S, _) {
                    if (g && g[Su] > 0 && v) {
                        var C = v[_getNotificationAction(f)];
                        if (C) {
                            var E = 0 !== S;
                            doPerf(P, function() {
                                return "HttpManager:_sendBatchesNotification";
                            }, function() {
                                _doAction(function() {
                                    try {
                                        C.call(v, g, f, E, S);
                                    } catch (g) {
                                        _throwInternal(A, 1, 74, "send request notification failed: " + g);
                                    }
                                }, _ || E, 0);
                            }, function() {
                                return {
                                    batches: _createDebugBatches(g),
                                    reason: f,
                                    isSync: E,
                                    sendSync: _,
                                    sendType: S
                                };
                            }, !E);
                        }
                    }
                }
                function _getNotificationAction(g) {
                    var f = Xh[g];
                    return isValueAssigned(f) || (f = Wd, g >= 9e3 && g <= 9999 ? f = qd : g >= 8e3 && g <= 8999 ? f = $d : g >= 1e3 && g <= 1999 && (f = jd)), f;
                }
                ee[Pu] = function(g, f, S) {
                    z || (P = f, L = f.getCookieMgr(), A = (b = S).diagLog(), arrAppend(j, onConfigChange(g, function(g) {
                        var v, C = g.cfg, E = g.cfg.extensionConfig[S.identifier];
                        K = createTimeoutWrapper(E[wu], E[Mu]), isValueAssigned(C.anonCookieName) ? _addQueryStringParameter(M, "anoncknm", C.anonCookieName) : _removeQueryStringParameter(M, "anoncknm"), G = E[Ou], q = E.payloadListener;
                        var T = E.httpXHROverride, I = E[Du] ? E[Du] : C.endpointUrl;
                        _ = I + Qh, x = !!isUndefined(E[Nu]) || !E[Nu], k = !E[ku];
                        var b = E.valueSanitizer, O = E[Lu], D = !!C[Fu];
                        isUndefined(E[Fu]) || (D = !!E[Fu]), U = E.xhrTimeout, V = !!E[xu], B = !!E[Uu], $ = !1 !== E[Vu], Y = !!E[Bu], f.getPlugin("LocalStorage") && (B = !0), Z = !isReactNative(), N = new Kh(P, b, O, D, getCommonSchemaMetaData, Y), isNullOrUndefined(E[Hu]) || (Z = !!E[Hu]), E[$u] && (X = E[$u]);
                        var L = _getSendPostMgrConfig();
                        Q ? Q.SetConfig(L) : (Q = new ns)[Pu](L, A);
                        var F = T, j = E[ju] ? T : null, W = E[ju] ? T : null, z = [
                            3,
                            2
                        ];
                        if (!T) {
                            w = !1;
                            var J = [];
                            isReactNative() ? (J = [
                                2,
                                1
                            ], z = [
                                2,
                                1,
                                3
                            ]) : J = [
                                1,
                                2,
                                3
                            ], (T = _getSenderInterface(J = prependTransports(J, E.transports), !1)) || _warnToConsole(A, "No available transport to send events"), F = _getSenderInterface(J, !0);
                        }
                        j || (j = _getSenderInterface(z = prependTransports(z, E[Gu]), !0)), H = !w && (Z && isBeaconsSupported() || !B && isFetchSupported(!0)), (v = {})[0] = T, v[1] = F || _getSenderInterface([
                            1,
                            2,
                            3
                        ], !0), v[2] = j || F || _getSenderInterface([
                            1
                        ], !0), v[3] = W || _getSenderInterface([
                            2,
                            3
                        ], !0) || F || _getSenderInterface([
                            1
                        ], !0), R = v;
                    })), z = !0);
                }, ee.addResponseHandler = function(g) {
                    return W[Eu](g), {
                        rm: function() {
                            var f = W.indexOf(g);
                            f >= 0 && W[Iu](f, 1);
                        }
                    };
                }, ee[qu] = function(g) {
                    try {
                        if (N) return N.getEventBlob(g);
                    } catch (g) {}
                    return Hd;
                }, ee[Wu] = function() {
                    try {
                        return _buildRequestDetails(N && N[zu](0, !1, !1, !1, 1, 0), x);
                    } catch (g) {}
                    return null;
                }, ee[Ku] = function(f, S) {
                    try {
                        var v = [];
                        arrForEach(f, function(g) {
                            S && (g = optimizeObject(g));
                            var f = Oh.create(g[_u], [
                                g
                            ]);
                            v[Eu](f);
                        });
                        for(var _ = null; v[Su] > 0 && N;){
                            var C = v.shift();
                            C && C[Cu]() > 0 && (_ = _ || N[zu](0, !1, !1, !1, 1, 0), N.appendPayload(_, C, g));
                        }
                        var E = _buildRequestDetails(_, x), T = {
                            data: _[Ju],
                            urlString: E.url,
                            headers: E[Au],
                            timeout: U,
                            disableXhrSync: V,
                            disableFetchKeepAlive: B
                        };
                        return x && (_hasHeader(T[Yu], Jd) || (T[Yu][Jd] = zd), _hasHeader(T[Yu], Yd) || (T[Yu][Yd] = Kd)), T;
                    } catch (g) {}
                    return null;
                }, ee._getDbgPlgTargets = function() {
                    return [
                        R[0],
                        C,
                        N,
                        R,
                        _getSendPostMgrConfig()
                    ];
                }, ee[th] = function(g, f) {
                    O[g] = f;
                }, ee.removeHeader = function(g) {
                    delete O[g];
                }, ee[ih] = function() {
                    return _hasIdleConnection() && T[hu]();
                }, ee[nh] = function(g, f) {
                    isUndefined(g) && (g = 0), F && (g = _adjustSendType(g), f = 2), _canSendPayload(D, g, 0) && _sendBatches(_clearQueue(), 0, !1, g, f || 0);
                }, ee[rh] = function() {
                    return !E && 0 === I && 0 === D[Su];
                }, ee[ah] = function(g) {
                    F = g;
                }, ee.addBatch = function(g) {
                    if (g && g[Cu]() > 0) {
                        if (C.isTenantKilled(g[_u]())) return !1;
                        D[Eu](g);
                    }
                    return !0;
                }, ee.teardown = function() {
                    D[Su] > 0 && _sendBatches(_clearQueue(), 0, !0, 2, 2), arrForEach(j, function(g) {
                        g && g.rm && g.rm();
                    }), j = [];
                }, ee.pause = function() {
                    E = !0;
                }, ee.resume = function() {
                    E = !1, ee[nh](0, 4);
                }, ee[oh] = function(g, f, S) {
                    g && g[Cu]() > 0 && (isNullOrUndefined(f) && (f = 1), F && (f = _adjustSendType(f), S = 2), _sendBatches([
                        g
                    ], 0, !1, f, S || 0));
                };
            });
        }
        return HttpManager.__ieDyn = 1, HttpManager;
    }(), ig = .25, ng = 500, rg = 20, ag = 6, sg = 2, og = 4, lg = 2, cg = 1, dg = 1e4, ug = "eventsDiscarded", hg = "", gg = void 0, pg = objDeepFreeze({
        eventsLimitInMem: {
            isVal: isGreaterThanZero,
            v: dg
        },
        immediateEventLimit: {
            isVal: isGreaterThanZero,
            v: 500
        },
        autoFlushEventsLimit: {
            isVal: isGreaterThanZero,
            v: 0
        },
        disableAutoBatchFlushLimit: !1,
        httpXHROverride: {
            isVal: isOverrideFn,
            v: gg
        },
        overrideInstrumentationKey: gg,
        overrideEndpointUrl: gg,
        disableTelemetry: !1,
        ignoreMc1Ms0CookieProcessing: !1,
        setTimeoutOverride: gg,
        clearTimeoutOverride: gg,
        payloadPreprocessor: gg,
        payloadListener: gg,
        disableEventTimings: gg,
        valueSanitizer: gg,
        stringifyObjects: gg,
        enableCompoundKey: gg,
        disableOptimizeObj: !1,
        fetchCredentials: gg,
        transports: gg,
        unloadTransports: gg,
        useSendBeacon: gg,
        disableFetchKeepAlive: gg,
        avoidOptions: !1,
        xhrTimeout: gg,
        disableXhrSync: gg,
        alwaysUseXhrOverride: !1,
        maxEventRetryAttempts: {
            isVal: Re,
            v: ag
        },
        maxUnloadEventRetryAttempts: {
            isVal: Re,
            v: sg
        },
        addNoResponse: gg,
        excludeCsMetaData: gg
    });
    function isOverrideFn(g) {
        return g && g.sendPOST;
    }
    var mg, fg = function(g) {
        function PostChannel() {
            var f, S = g.call(this) || this;
            S.identifier = "PostChannel", S.priority = 1011, S.version = "4.3.2";
            var v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $, j, G = !1, q = [], W = !1, z = 0, K = 0, J = {}, Y = hd;
            return dynamicProto$2(PostChannel, S, function(g, S) {
                function _removeUnloadHandlers() {
                    removePageUnloadEventListener(null, F), removePageHideEventListener(null, F), removePageShowEventListener(null, F);
                }
                function _hookWParam(g) {
                    var f = g[ch];
                    g[ch] = function() {
                        var S = 0;
                        return U && (S |= 2), S | f.call(g);
                    };
                }
                function _batch(g) {
                    var f = hg;
                    return g && g[Su] && arrForEach(g, function(g) {
                        f && (f += "\n"), f += g;
                    }), f;
                }
                function _serialize(g) {
                    var f = hg;
                    try {
                        _cleanEvent(g), f = A[qu](g);
                    } catch (g) {}
                    return f;
                }
                function _handleUnloadEvents(g) {
                    "beforeunload" !== (g || nt().event).type && (N = !0, A[ah](N)), _releaseAllQueues(2, 2);
                }
                function _handleShowEvents(g) {
                    N = !1, A[ah](N);
                }
                function _cleanEvent(g) {
                    g.ext && g.ext[du] && delete g.ext[du], g.ext && g.ext[uu] && g.ext[uu].id && delete g.ext[uu].id, D && (g.ext = optimizeObject(g.ext), g[Rh] && (g[Rh] = optimizeObject(g[Rh])), g[ph] && (g[ph] = optimizeObject(g[ph])));
                }
                function _addEventToQueues(g, f) {
                    if (g[Ph] || (g[Ph] = 0), g[wh] || (g[wh] = 1), _cleanEvent(g), g[Mh]) {
                        if (I || W) g[wh] = 3, g[Mh] = !1;
                        else if (A) return D && (g = optimizeObject(g)), void A[oh](Oh.create(g[_u], [
                            g
                        ]), !0 === g[Mh] ? 1 : g[Mh], 3);
                    }
                    var S = g[wh], v = K, E = C;
                    4 === S && (v = z, E = _);
                    var T = !1;
                    if (v < E) T = !_addEventToProperQueue(g, f);
                    else {
                        var b = 1, R = rg;
                        4 === S && (b = 4, R = 1), T = !0, _dropEventWithLatencyOrLess(g[_u], g[wh], b, R) && (T = !_addEventToProperQueue(g, f));
                    }
                    T && _notifyEvents(ug, [
                        g
                    ], Xt.QueueFull);
                }
                function _sendEventsForLatencyAndAbove(g, f, S) {
                    var v = _queueBatches(g, f, S);
                    return A[nh](f, S), v;
                }
                function _hasEvents() {
                    return K > 0;
                }
                function _scheduleTimer() {
                    if (M >= 0 && _queueBatches(M, 0, O) && A[nh](0, O), z > 0 && !T && !W) {
                        var g = J[Y][2];
                        g >= 0 && (T = _createTimer(function() {
                            T = null, _sendEventsForLatencyAndAbove(4, 0, 1), _scheduleTimer();
                        }, g));
                    }
                    var f = J[Y][1];
                    !E && !v && f >= 0 && !W && (_hasEvents() ? E = _createTimer(function() {
                        E = null, _sendEventsForLatencyAndAbove(0 === b ? 3 : 1, 0, 1), b++, b %= 2, _scheduleTimer();
                    }, f) : b = 0);
                }
                function _initDefaults() {
                    f = null, G = !1, q = [], v = null, W = !1, z = 0, _ = 500, K = 0, C = dg, J = {}, Y = hd, E = null, T = null, I = 0, b = 0, R = {}, P = 0, H = !1, w = 0, M = -1, O = null, D = !0, N = !1, k = ag, L = sg, F = null, $ = null, j = !1, x = createTimeoutWrapper(), A = new tg(ng, lg, cg, {
                        requeue: _requeueEvents,
                        send: _sendingEvent,
                        sent: _eventsSentEvent,
                        drop: _eventsDropped,
                        rspFail: _eventsResponseFail,
                        oth: _otherEvent
                    }), _initializeProfiles(), _clearQueues(), _setAutoLimits();
                }
                function _createTimer(g, f) {
                    0 === f && I && (f = 1);
                    var S = 1e3;
                    return I && (S = retryPolicyGetMillisToBackoffForRetry(I - 1)), x.set(g, f * S);
                }
                function _clearScheduledTimer() {
                    return null !== E && (E.cancel(), E = null, b = 0, !0);
                }
                function _releaseAllQueues(g, f) {
                    _clearScheduledTimer(), v && (v.cancel(), v = null), W || _sendEventsForLatencyAndAbove(1, g, f);
                }
                function _clearQueues() {
                    R[4] = {
                        batches: [],
                        iKeyMap: {}
                    }, R[3] = {
                        batches: [],
                        iKeyMap: {}
                    }, R[2] = {
                        batches: [],
                        iKeyMap: {}
                    }, R[1] = {
                        batches: [],
                        iKeyMap: {}
                    };
                }
                function _getEventBatch(g, f, S) {
                    var v = R[f];
                    v || (v = R[f = 1]);
                    var _ = v.iKeyMap[g];
                    return !_ && S && (_ = Oh.create(g), v.batches[Eu](_), v.iKeyMap[g] = _), _;
                }
                function _performAutoFlush(f, S) {
                    A[ih]() && !I && (P > 0 && K > P && (S = !0), S && null == v && g.flush(f, function() {}, 20));
                }
                function _addEventToProperQueue(g, f) {
                    D && (g = optimizeObject(g));
                    var S = g[wh], v = _getEventBatch(g[_u], S, !0);
                    return !!v.addEvent(g) && (4 !== S ? (K++, f && 0 === g[Ph] && _performAutoFlush(!g.sync, w > 0 && v[Cu]() >= w)) : z++, !0);
                }
                function _dropEventWithLatencyOrLess(g, f, S, v) {
                    for(; S <= f;){
                        var _ = _getEventBatch(g, f, !0);
                        if (_ && _[Cu]() > 0) {
                            var C = _[Tu](0, v), E = C[Cu]();
                            if (E > 0) return 4 === S ? z -= E : K -= E, _notifyBatchEvents(ug, [
                                C
                            ], Xt.QueueFull), !0;
                        }
                        S++;
                    }
                    return _resetQueueCounts(), !1;
                }
                function _resetQueueCounts() {
                    for(var g = 0, f = 0, _loop_1 = function(S) {
                        var v = R[S];
                        v && v[Zu] && arrForEach(v[Zu], function(v) {
                            4 === S ? g += v[Cu]() : f += v[Cu]();
                        });
                    }, S = 1; S <= 4; S++)_loop_1(S);
                    K = f, z = g;
                }
                function _queueBatches(f, S, v) {
                    var _ = !1, C = 0 === S;
                    return !C || A[ih]() ? doPerf(g.core, function() {
                        return "PostChannel._queueBatches";
                    }, function() {
                        for(var g = [], S = 4; S >= f;){
                            var v = R[S];
                            v && v.batches && v.batches[Su] > 0 && (arrForEach(v[Zu], function(f) {
                                A.addBatch(f) ? _ = _ || f && f[Cu]() > 0 : g = g[vu](f[yu]()), 4 === S ? z -= f[Cu]() : K -= f[Cu]();
                            }), v[Zu] = [], v.iKeyMap = {}), S--;
                        }
                        g[Su] > 0 && _notifyEvents(ug, g, Xt.KillSwitch), _ && M >= f && (M = -1, O = 0);
                    }, function() {
                        return {
                            latency: f,
                            sendType: S,
                            sendReason: v
                        };
                    }, !C) : (M = M >= 0 ? Math.min(M, f) : f, O = Math.max(O, v)), _;
                }
                function _flushImpl(g, f) {
                    _sendEventsForLatencyAndAbove(1, 0, f), _resetQueueCounts(), _waitForIdleManager(function() {
                        g && g(), q[Su] > 0 ? v = _createTimer(function() {
                            v = null, _flushImpl(q.shift(), f);
                        }, 0) : (v = null, _scheduleTimer());
                    });
                }
                function _waitForIdleManager(g) {
                    A[rh]() ? g() : v = _createTimer(function() {
                        v = null, _waitForIdleManager(g);
                    }, ig);
                }
                function _resetTransmitProfiles() {
                    _clearScheduledTimer(), _initializeProfiles(), Y = hd, _scheduleTimer();
                }
                function _initializeProfiles() {
                    (J = {})[hd] = [
                        2,
                        1,
                        0
                    ], J[gd] = [
                        6,
                        3,
                        0
                    ], J[pd] = [
                        18,
                        9,
                        0
                    ];
                }
                function _requeueEvents(f, S) {
                    var v = [], _ = k;
                    N && (_ = L), arrForEach(f, function(f) {
                        f && f[Cu]() > 0 && arrForEach(f[yu](), function(f) {
                            f && (f[Mh] && (f[wh] = 4, f[Mh] = !1), f[Ph] < _ ? (setProcessTelemetryTimings(f, g[_h]), _addEventToQueues(f, !1)) : v[Eu](f));
                        });
                    }), v[Su] > 0 && _notifyEvents(ug, v, Xt.NonRetryableStatus), N && _releaseAllQueues(2, 2);
                }
                function _callNotification(f, S) {
                    var v = B || {}, _ = v[f];
                    if (_) try {
                        _.apply(v, S);
                    } catch (S) {
                        _throwInternal(g.diagLog(), 1, 74, f + " notification failed: " + S);
                    }
                }
                function _notifyEvents(g, f) {
                    for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                    f && f[Su] > 0 && _callNotification(g, [
                        f
                    ][vu](S));
                }
                function _notifyBatchEvents(g, f) {
                    for(var S = [], v = 2; v < arguments.length; v++)S[v - 2] = arguments[v];
                    f && f[Su] > 0 && arrForEach(f, function(f) {
                        f && f[Cu]() > 0 && _callNotification(g, [
                            f.events()
                        ][vu](S));
                    });
                }
                function _sendingEvent(g, f, S) {
                    g && g[Su] > 0 && _callNotification("eventsSendRequest", [
                        f >= 1e3 && f <= 1999 ? f - 1e3 : 0,
                        !0 !== S
                    ]);
                }
                function _eventsSentEvent(g, f) {
                    _notifyBatchEvents("eventsSent", g, f), _scheduleTimer();
                }
                function _eventsDropped(g, f) {
                    _notifyBatchEvents(ug, g, f >= 8e3 && f <= 8999 ? f - 8e3 : Xt.Unknown);
                }
                function _eventsResponseFail(g) {
                    _notifyBatchEvents(ug, g, Xt.NonRetryableStatus), _scheduleTimer();
                }
                function _otherEvent(g, f) {
                    _notifyBatchEvents(ug, g, Xt.Unknown), _scheduleTimer();
                }
                function _setAutoLimits() {
                    w = V ? 0 : Math.max(ng * (lg + 1), C / 6);
                }
                _initDefaults(), g._getDbgPlgTargets = function() {
                    return [
                        A,
                        f
                    ];
                }, g[Pu] = function(v, E, T) {
                    doPerf(E, function() {
                        return "PostChannel:initialize";
                    }, function() {
                        S[Pu](v, E, T), B = E.getNotifyMgr();
                        try {
                            F = mergeEvtNamespace(createUniqueNamespace(g[_h]), E.evtNamespace && E.evtNamespace()), g._addHook(onConfigChange(v, function(S) {
                                var v = S.cfg, T = createProcessTelemetryContext(null, v, E);
                                f = T.getExtCfg(g[_h], pg), x = createTimeoutWrapper(f[wu], f[Mu]), D = !f[Ch] && isChromium(), U = f[yh], _hookWParam(E), C = f[Eh], _ = f.immediateEventLimit, P = f[Th], k = f.maxEventRetryAttempts, L = f.maxUnloadEventRetryAttempts, V = f[Ih], _setAutoLimits(), $ = f[bh], j = !!f[Ah], H && _removeUnloadHandlers();
                                var I = v.disablePageUnloadEvents || [];
                                H = addPageUnloadEventListener(_handleUnloadEvents, I, F), H = addPageHideEventListener(_handleUnloadEvents, I, F) || H, H = addPageShowEventListener(_handleShowEvents, v.disablePageShowEvents, F) || H;
                            })), A[Pu](v, g.core, g);
                        } catch (f) {
                            throw g.setInitialized(!1), f;
                        }
                    }, function() {
                        return {
                            theConfig: v,
                            core: E,
                            extensions: T
                        };
                    });
                }, g.processTelemetry = function(f, S) {
                    setProcessTelemetryTimings(f, g[_h]), S = S || g._getTelCtx(S);
                    var v = f;
                    j || G || ($ && (v[_u] = $), _addEventToQueues(v, !0), N ? _releaseAllQueues(2, 2) : _scheduleTimer()), g.processNext(v, S);
                }, g.getOfflineSupport = function() {
                    try {
                        var g = A && A[Wu]();
                        if (A) return {
                            getUrl: function() {
                                return g ? g.url : null;
                            },
                            serialize: _serialize,
                            batch: _batch,
                            shouldProcess: function(g) {
                                return !j;
                            },
                            createPayload: function(g) {
                                return null;
                            },
                            createOneDSPayload: function(g) {
                                if (A[Ku]) return A[Ku](g, D);
                            }
                        };
                    } catch (g) {}
                    return null;
                }, g._doTeardown = function(g, f) {
                    _releaseAllQueues(2, 2), G = !0, A.teardown(), _removeUnloadHandlers(), _initDefaults();
                }, g.setEventQueueLimits = function(g, S) {
                    f[Eh] = C = isGreaterThanZero(g) ? g : dg, f[Th] = P = isGreaterThanZero(S) ? S : 0, _setAutoLimits();
                    var v = K > g;
                    if (!v && w > 0) for(var _ = 1; !v && _ <= 3; _++){
                        var E = R[_];
                        E && E[Zu] && arrForEach(E[Zu], function(g) {
                            g && g[Cu]() >= w && (v = !0);
                        });
                    }
                    _performAutoFlush(!0, v);
                }, g.pause = function() {
                    _clearScheduledTimer(), W = !0, A.pause();
                }, g.resume = function() {
                    W = !1, A.resume(), _scheduleTimer();
                }, g._loadTransmitProfiles = function(g) {
                    _resetTransmitProfiles(), objForEachKey(g, function(g, f) {
                        var S = f[Su];
                        if (S >= 2) {
                            var v = S > 2 ? f[2] : 0;
                            if (f[Iu](0, S - 2), f[1] < 0 && (f[0] = -1), f[1] > 0 && f[0] > 0) {
                                var _ = f[0] / f[1];
                                f[0] = Math.ceil(_) * f[1];
                            }
                            v >= 0 && f[1] >= 0 && v > f[1] && (v = f[1]), f[Eu](v), J[g] = f;
                        }
                    });
                }, g.flush = function(g, f, S) {
                    var _;
                    if (void 0 === g && (g = !0), !W) {
                        if (S = S || 1, g) f || (_ = createPromise(function(g) {
                            f = g;
                        })), null == v ? (_clearScheduledTimer(), _queueBatches(1, 0, S), v = _createTimer(function() {
                            v = null, _flushImpl(f, S);
                        }, 0)) : q[Eu](f);
                        else {
                            var C = _clearScheduledTimer();
                            _sendEventsForLatencyAndAbove(1, 1, S), f && f(), C && _scheduleTimer();
                        }
                    }
                    return _;
                }, g.setMsaAuthTicket = function(g) {
                    A[th](au, g);
                }, g.setAuthPluginHeader = function(g) {
                    A[th](su, g);
                }, g.removeAuthPluginHeader = function() {
                    A.removeHeader(su);
                }, g.hasEvents = _hasEvents, g._setTransmitProfile = function(g) {
                    Y !== g && void 0 !== J[g] && (_clearScheduledTimer(), Y = g, _scheduleTimer());
                }, proxyFunctions(g, function() {
                    return A;
                }, [
                    "addResponseHandler"
                ]), g[vh] = function() {
                    I < og && (I++, _clearScheduledTimer(), _scheduleTimer());
                }, g._clearBackOff = function() {
                    I && (I = 0, _clearScheduledTimer(), _scheduleTimer());
                };
            }), S;
        }
        return __extendsFn$2(PostChannel, g), PostChannel.__ieDyn = 1, PostChannel;
    }(ja), Sg = "function", vg = "prototype", _g = Object, Cg = ((getGlobal() || {}).Symbol, (getGlobal() || {}).Reflect, "hasOwnProperty"), extendStaticsFn$3 = function(g, f) {
        return extendStaticsFn$3 = _g.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(g, f) {
            g.__proto__ = f;
        } || function(g, f) {
            for(var S in f)f[Cg](S) && (g[S] = f[S]);
        }, extendStaticsFn$3(g, f);
    };
    function __extendsFn$3(g, f) {
        function __() {
            this.constructor = g;
        }
        typeof f !== Sg && null !== f && throwTypeError("Class extends value " + String(f) + " is not a constructor or null"), extendStaticsFn$3(g, f), g[vg] = null === f ? ut(f) : (__[vg] = f[vg], new __);
    }
    var yg = "constructor", Eg = "prototype", Tg = "function", Ig = "_dynInstFuncs", bg = "_isDynProxy", Ag = "_dynClass", Rg = "_dynCls$", Pg = "_dynInstChk", wg = Pg, Mg = "_dfOpts", Og = "_unknown_", Dg = "__proto__", Ng = "_dyn" + Dg, kg = "__dynProto$Gbl", Lg = "_dynInstProto", Fg = "useBaseInst", xg = "setInstFuncs", Ug = Object, Vg = Ug.getPrototypeOf, Bg = Ug.getOwnPropertyNames, Hg = getGlobal(), $g = Hg[kg] || (Hg[kg] = {
        o: (mg = {}, mg[xg] = !0, mg[Fg] = !0, mg),
        n: 1e3
    });
    function _isObjectOrArrayPrototype$3(g) {
        return g && (g === Ug[Eg] || g === Array[Eg]);
    }
    function _isObjectArrayOrFunctionPrototype$3(g) {
        return _isObjectOrArrayPrototype$3(g) || g === Function[Eg];
    }
    function _getObjProto$3(g) {
        var f;
        if (g) {
            if (Vg) return Vg(g);
            var S = g[Dg] || g[Eg] || (g[yg] ? g[yg][Eg] : null);
            f = g[Ng] || S, objHasOwnProperty(g, Ng) || (delete g[Lg], f = g[Ng] = g[Lg] || g[Ng], g[Lg] = S);
        }
        return f;
    }
    function _forEachProp$3(g, f) {
        var S = [];
        if (Bg) S = Bg(g);
        else for(var v in g)"string" == typeof v && objHasOwnProperty(g, v) && S.push(v);
        if (S && S.length > 0) for(var _ = 0; _ < S.length; _++)f(S[_]);
    }
    function _isDynamicCandidate$3(g, f, S) {
        return f !== yg && typeof g[f] === Tg && (S || objHasOwnProperty(g, f)) && f !== Dg && f !== Eg;
    }
    function _throwTypeError$3(g) {
        throwTypeError("DynamicProto: " + g);
    }
    function _getInstanceFuncs$3(g) {
        var f = ut(null);
        return _forEachProp$3(g, function(S) {
            !f[S] && _isDynamicCandidate$3(g, S, !1) && (f[S] = g[S]);
        }), f;
    }
    function _hasVisited$3(g, f) {
        for(var S = g.length - 1; S >= 0; S--)if (g[S] === f) return !0;
        return !1;
    }
    function _getBaseFuncs$3(g, f, S, v) {
        function _instFuncProxy(g, f, S) {
            var _ = f[S];
            if (_[bg] && v) {
                var C = g[Ig] || {};
                !1 !== C[wg] && (_ = (C[f[Ag]] || {})[S] || _);
            }
            return function() {
                return _.apply(g, arguments);
            };
        }
        var _ = ut(null);
        _forEachProp$3(S, function(g) {
            _[g] = _instFuncProxy(f, S, g);
        });
        for(var C = _getObjProto$3(g), E = []; C && !_isObjectArrayOrFunctionPrototype$3(C) && !_hasVisited$3(E, C);)_forEachProp$3(C, function(g) {
            !_[g] && _isDynamicCandidate$3(C, g, !Vg) && (_[g] = _instFuncProxy(f, C, g));
        }), E.push(C), C = _getObjProto$3(C);
        return _;
    }
    function _getInstFunc$3(g, f, S, v) {
        var _ = null;
        if (g && objHasOwnProperty(S, Ag)) {
            var C = g[Ig] || ut(null);
            if ((_ = (C[S[Ag]] || ut(null))[f]) || _throwTypeError$3("Missing [" + f + "] " + Tg), !_[Pg] && !1 !== C[wg]) {
                for(var E = !objHasOwnProperty(g, f), T = _getObjProto$3(g), I = []; E && T && !_isObjectArrayOrFunctionPrototype$3(T) && !_hasVisited$3(I, T);){
                    var b = T[f];
                    if (b) {
                        E = b === v;
                        break;
                    }
                    I.push(T), T = _getObjProto$3(T);
                }
                try {
                    E && (g[f] = _), _[Pg] = 1;
                } catch (g) {
                    C[wg] = !1;
                }
            }
        }
        return _;
    }
    function _getProtoFunc$3(g, f, S) {
        var v = f[g];
        return v === S && (v = _getObjProto$3(f)[g]), typeof v !== Tg && _throwTypeError$3("[" + g + "] is not a " + Tg), v;
    }
    function _populatePrototype$3(g, f, S, v, _) {
        function _createDynamicPrototype(g, f) {
            var dynProtoProxy = function() {
                return (_getInstFunc$3(this, f, g, dynProtoProxy) || _getProtoFunc$3(f, g, dynProtoProxy)).apply(this, arguments);
            };
            return dynProtoProxy[bg] = 1, dynProtoProxy;
        }
        if (!_isObjectOrArrayPrototype$3(g)) {
            var C = S[Ig] = S[Ig] || ut(null);
            if (!_isObjectOrArrayPrototype$3(C)) {
                var E = C[f] = C[f] || ut(null);
                !1 !== C[wg] && (C[wg] = !!_), _isObjectOrArrayPrototype$3(E) || _forEachProp$3(S, function(f) {
                    _isDynamicCandidate$3(S, f, !1) && S[f] !== v[f] && (E[f] = S[f], delete S[f], (!objHasOwnProperty(g, f) || g[f] && !g[f][bg]) && (g[f] = _createDynamicPrototype(g, f)));
                });
            }
        }
    }
    function _checkPrototype$3(g, f) {
        if (Vg) {
            for(var S = [], v = _getObjProto$3(f); v && !_isObjectArrayOrFunctionPrototype$3(v) && !_hasVisited$3(S, v);){
                if (v === g) return !0;
                S.push(v), v = _getObjProto$3(v);
            }
            return !1;
        }
        return !0;
    }
    function _getObjName$3(g, f) {
        return objHasOwnProperty(g, Eg) ? g.name || f || Og : ((g || {})[yg] || {}).name || f || Og;
    }
    function dynamicProto$3(g, f, S, v) {
        objHasOwnProperty(g, Eg) || _throwTypeError$3("theClass is an invalid class definition.");
        var _ = g[Eg];
        _checkPrototype$3(_, f) || _throwTypeError$3("[" + _getObjName$3(g) + "] not in hierarchy of [" + _getObjName$3(f) + "]");
        var C = null;
        objHasOwnProperty(_, Ag) ? C = _[Ag] : (C = Rg + _getObjName$3(g, "_") + "$" + $g.n, $g.n++, _[Ag] = C);
        var E = dynamicProto$3[Mg], T = !!E[Fg];
        T && v && void 0 !== v[Fg] && (T = !!v[Fg]);
        var I = _getInstanceFuncs$3(f);
        S(f, _getBaseFuncs$3(_, f, I, T));
        var b = !!Vg && !!E[xg];
        b && v && (b = !!v[xg]), _populatePrototype$3(_, C, f, I, !1 !== b);
    }
    dynamicProto$3[Mg] = $g.o;
    var jg = createTypeMap, Gg = "";
    function cfgDfMerge$1(g) {
        return {
            mrg: !0,
            v: g
        };
    }
    function cfgDfString(g) {
        return {
            isVal: Te,
            v: Le(g || Gg)
        };
    }
    var qg, Wg = "locale", zg = "ver", Kg = "browser", Jg = "browserVer", Yg = "popSample", Qg = "eventFlags", Xg = "name", Zg = "serviceName", ep = jg({
        UserExt: [
            0,
            "user"
        ],
        DeviceExt: [
            1,
            "device"
        ],
        TraceExt: [
            2,
            "trace"
        ],
        WebExt: [
            3,
            "web"
        ],
        AppExt: [
            4,
            "app"
        ],
        OSExt: [
            5,
            "os"
        ],
        SdkExt: [
            6,
            "sdk"
        ],
        IntWebExt: [
            7,
            "intweb"
        ],
        UtcExt: [
            8,
            "utc"
        ],
        LocExt: [
            9,
            "loc"
        ],
        CloudExt: [
            10,
            "cloud"
        ],
        DtExt: [
            11,
            "dt"
        ]
    }), tp = jg({
        id: [
            0,
            "id"
        ],
        ver: [
            1,
            zg
        ],
        appName: [
            2,
            Xg
        ],
        locale: [
            3,
            Wg
        ],
        expId: [
            4,
            "expId"
        ],
        env: [
            5,
            "env"
        ]
    }), ip = jg({
        domain: [
            0,
            "domain"
        ],
        browser: [
            1,
            Kg
        ],
        browserVer: [
            2,
            Jg
        ],
        screenRes: [
            3,
            "screenRes"
        ],
        userConsent: [
            4,
            "userConsent"
        ],
        consentDetails: [
            5,
            "consentDetails"
        ]
    }), np = jg({
        locale: [
            0,
            Wg
        ],
        localId: [
            1,
            "localId"
        ],
        id: [
            2,
            "id"
        ]
    }), rp = jg({
        osName: [
            0,
            Xg
        ],
        ver: [
            1,
            zg
        ]
    }), ap = jg({
        ver: [
            0,
            zg
        ],
        seq: [
            1,
            "seq"
        ],
        installId: [
            2,
            "installId"
        ],
        epoch: [
            3,
            "epoch"
        ]
    }), sp = jg({
        msfpc: [
            0,
            "msfpc"
        ],
        anid: [
            1,
            "anid"
        ],
        serviceName: [
            2,
            Zg
        ]
    }), op = jg({
        popSample: [
            0,
            Yg
        ],
        eventFlags: [
            1,
            Qg
        ]
    }), lp = jg({
        tz: [
            0,
            "tz"
        ]
    }), cp = jg({
        sessionId: [
            0,
            "sesId"
        ]
    }), dp = jg({
        localId: [
            0,
            "localId"
        ],
        deviceClass: [
            1,
            "deviceClass"
        ],
        make: [
            2,
            "make"
        ],
        model: [
            3,
            "model"
        ]
    }), up = jg({
        role: [
            0,
            "role"
        ],
        roleInstance: [
            1,
            "roleInstance"
        ],
        roleVer: [
            2,
            "roleVer"
        ]
    }), hp = jg({
        traceId: [
            0,
            "traceID"
        ],
        traceName: [
            1,
            Xg
        ],
        parentId: [
            2,
            "parentID"
        ]
    }), gp = jg({
        traceId: [
            0,
            "traceId"
        ],
        spanId: [
            1,
            "spanId"
        ],
        traceFlags: [
            2,
            "traceFlags"
        ]
    });
    function canUseLocalStorage() {
        return void 0 === qg && (qg = !!_getVerifiedStorageObject(0)), qg;
    }
    function _getLocalStorageObject() {
        return canUseLocalStorage() ? _getVerifiedStorageObject(0) : null;
    }
    function _getVerifiedStorageObject(g) {
        var f, S, v = null;
        try {
            var _ = getGlobal();
            if (!_) return null;
            S = new Date, (v = 0 === g ? _.localStorage : _.sessionStorage) && Ie(v.setItem) && (v.setItem(S, S), f = v.getItem(S) !== S, v.removeItem(S), f && (v = null));
        } catch (g) {
            v = null;
        }
        return v;
    }
    function setStorage(g, f, S) {
        var v = _getLocalStorageObject();
        if (null !== v) try {
            return v.setItem(f, S), !0;
        } catch (f) {
            qg = !1, _throwInternal(g, 1, 504, "Browser failed write to local storage. " + f);
        }
        return !1;
    }
    function getStorage(g, f) {
        var S = _getLocalStorageObject();
        if (null !== S) try {
            return S.getItem(f);
        } catch (f) {
            qg = !1, _throwInternal(g, 1, 503, "Browser failed read of local storage. " + f);
        }
        return null;
    }
    function _getId() {
        return this.getId();
    }
    function _setId(g) {
        this.setId(g);
    }
    var pp = function() {
        function Session() {
            dynamicProto$3(Session, this, function(g) {
                g.setId = function(f) {
                    g.customId = f;
                }, g.getId = function() {
                    return Te(g.customId) ? g.customId : g.automaticId;
                };
            });
        }
        return Session._staticInit = void objDefine(Session.prototype, "id", {
            g: _getId,
            s: _setId
        }), Session;
    }(), mp = "ai_session", fp = function() {
        function SessionManager(g, f, S) {
            var v, _, C, E = safeGetLogger(g), T = safeGetCookieMgr(g);
            dynamicProto$3(SessionManager, this, function(g) {
                var I = onConfigChange(f, function() {
                    C = f, g.config = C;
                });
                function _initializeAutomaticSession() {
                    var f = T.get(_());
                    if (f && Ie(f.split)) _initializeAutomaticSessionWithData(f);
                    else {
                        var S = getStorage(E, _());
                        S && _initializeAutomaticSessionWithData(S);
                    }
                    g.automaticSession.getId() || _renew();
                }
                function _initializeAutomaticSessionWithData(f) {
                    var S = g.automaticSession, v = f.split("|");
                    v.length > 0 && S.setId(v[0]);
                    try {
                        if (v.length > 1) {
                            var _ = +v[1];
                            S.acquisitionDate = +new Date(_), S.acquisitionDate = S.acquisitionDate > 0 ? S.acquisitionDate : 0;
                        }
                        if (v.length > 2) {
                            var C = +v[2];
                            S.renewalDate = +new Date(C), S.renewalDate = S.renewalDate > 0 ? S.renewalDate : 0;
                        }
                    } catch (g) {
                        _throwInternal(E, 1, 510, "Error parsing ai_session cookie, session will be reset: " + g);
                    }
                    0 === S.renewalDate && _throwInternal(E, 2, 517, "AI session renewal date is 0, session will be reset.");
                }
                function _renew() {
                    var f = g.automaticSession, S = (new Date).getTime(), v = g.config.sessionAsGuid;
                    !isUndefined(v) && v ? Pe(v) ? f.setId(createGuid()) : f.setId(createGuid(v)) : f.setId(newId(C.idLength || 22)), f.acquisitionDate = S, f.renewalDate = S, _setCookie(f.getId(), f.acquisitionDate, f.renewalDate), canUseLocalStorage() || _throwInternal(E, 2, 505, "Browser does not support local storage. Session durations will be inaccurate.");
                }
                function _setCookie(f, S, C) {
                    var E = S + g.config.sessionExpirationMs, I = C + g.config.sessionRenewalMs, b = new Date, A = [
                        f,
                        S,
                        C
                    ];
                    E < I ? b.setTime(E) : b.setTime(I);
                    var R = g.config.cookieDomain || null;
                    T.set(_(), A.join("|") + ";expires=" + b.toUTCString(), null, R), v = (new Date).getTime();
                }
                function _setStorage(g, f, S) {
                    setStorage(E, _(), [
                        g,
                        f,
                        S
                    ].join("|"));
                }
                S && S.add(I), _ = function() {
                    return g.config.namePrefix ? mp + g.config.namePrefix : mp;
                }, g.automaticSession = new pp, g.update = function() {
                    g.automaticSession.getId() || _initializeAutomaticSession();
                    var f = g.automaticSession, S = g.config, _ = (new Date).getTime(), C = _ - f.acquisitionDate > S.sessionExpirationMs, E = _ - f.renewalDate > S.sessionRenewalMs;
                    if (C || E) _renew();
                    else (!v || _ - v > SessionManager.cookieUpdateInterval) && (f.renewalDate = _, _setCookie(f.getId(), f.acquisitionDate, f.renewalDate));
                }, g.backup = function() {
                    var f = g.automaticSession;
                    _setStorage(f.getId(), f.acquisitionDate, f.renewalDate);
                };
            });
        }
        return SessionManager.cookieUpdateInterval = 6e4, SessionManager;
    }(), Sp = [
        "AX",
        "EX",
        "SF",
        "CS",
        "CF",
        "CT",
        "CU",
        "DC",
        "DF",
        "H5",
        "HL",
        "WS",
        "WP"
    ];
    function _validateAppExpId(g, f) {
        void 0 === f && (f = Sp);
        var S = null;
        if (g) for(var v = g.split(","), _ = 0; _ < v.length; _++)_isValidAppFlightId(v[_], f) && (S ? S += "," + v[_] : S = v[_]);
        return S;
    }
    function _isValidAppFlightId(g, f) {
        if (void 0 === f && (f = Sp), !g || g.length < 4) return !1;
        for(var S = !1, v = 256, _ = g.substring(0, 3).toString().toUpperCase(), C = 0; C < f.length; C++)if (f[C] + ":" === _ && g.length <= v) {
            S = !0;
            break;
        }
        return S;
    }
    function _getExpId() {
        return this.getExpId();
    }
    var vp = function() {
        function Application(g, f, S) {
            var v, _ = null, C = Sp.slice(0), E = "Treatments", T = null;
            dynamicProto$3(Application, this, function(I) {
                if (_populateDefaults(g), hasDocument()) {
                    var b = it().documentElement;
                    b && (I.locale = b.lang);
                }
                function _getMetaDataFromDOM(g) {
                    var f, S = {}, v = it();
                    if (v) {
                        f = v && v.querySelectorAll("meta");
                        for(var _ = 0; _ < f.length; _++){
                            var C = f[_];
                            if (C.name) {
                                if (0 === C.name.toLowerCase().indexOf(g)) S[C.name.replace(g, "")] = C.content;
                            }
                        }
                    }
                    return S;
                }
                function _setAppExpId(g) {
                    g !== _ && (_ = _validateAppExpId(g, C));
                }
                function _readExpIdFromCookie() {
                    return _setAppExpId(getCookieValue(v, E)), _;
                }
                function _readExpIdFromCoreData(g) {
                    return _setAppExpId(g), _;
                }
                function _populateDefaults(g) {
                    var _ = onConfigChange(g, function() {
                        v = f && f.getCookieMgr(), T = g || {}, I.env = T.env || _getMetaDataFromDOM("awa-").env;
                    });
                    S && S.add(_);
                }
                I.getExpId = function() {
                    return T.expId ? _readExpIdFromCoreData(T.expId) : _readExpIdFromCookie();
                };
            });
        }
        return Application.validateAppExpId = _validateAppExpId, Application._staticInit = void objDefine(Application.prototype, "expId", {
            g: _getExpId
        }), Application;
    }(), _p = function() {
        function Cloud() {}
        return Cloud;
    }(), Cp = function() {
        function Device() {}
        return Device;
    }();
    /**
	* Cloud.ts
	* @author Hector Hernandez (hectorh)
	* @copyright Microsoft 2020
	*/ function _getMsfpc$1() {
        return this.getMsfpc();
    }
    function _getAnid() {
        return this.getAnid();
    }
    var yp = function() {
        function IntWeb(g, f, S) {
            var v;
            dynamicProto$3(IntWeb, this, function(_) {
                function _populateDefaults(g) {
                    var C = onConfigChange(g, function() {
                        v = f && f.getCookieMgr();
                        var S = g || {};
                        S.serviceName && (_.serviceName = S.serviceName);
                    });
                    S && S.add(C);
                }
                _populateDefaults(g), _.getMsfpc = function() {
                    return getCookieValue(v, "MSFPC");
                }, _.getAnid = function() {
                    return getCookieValue(v, "ANON").slice(0, 34);
                };
            });
        }
        var g;
        return IntWeb._staticInit = (objDefine(g = IntWeb.prototype, "msfpc", {
            g: _getMsfpc$1
        }), void objDefine(g, "anid", {
            g: _getAnid
        })), IntWeb;
    }(), Ep = function() {
        function Loc() {
            var g = (new Date).getTimezoneOffset(), f = g % 60, S = (g - f) / 60, v = "+";
            S > 0 && (v = "-"), S = Math.abs(S), f = Math.abs(f), this.tz = v + (S < 10 ? "0" + S : S.toString()) + ":" + (f < 10 ? "0" + f : f.toString());
        }
        return Loc;
    }(), Tp = {
        WIN: /(windows|win32)/i,
        WINRT: / arm;/i,
        WINPHONE: /windows\sphone\s\d+\.\d+/i,
        OSX: /(macintosh|mac os x)/i,
        IOS: /(ipad|iphone|ipod)(?=.*like mac os x)/i,
        LINUX: /(linux|joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)/i,
        ANDROID: /android/i,
        CROS: /CrOS/i
    }, Ip = {
        5.1: "XP",
        "6.0": "Vista",
        6.1: "7",
        6.2: "8",
        6.3: "8.1",
        "10.0": "10"
    }, bp = "([\\d,.]+)", Ap = "([\\d,_,.]+)", Rp = "Unknown", Pp = [
        {
            r: Tp.WINPHONE,
            os: "Windows Phone"
        },
        {
            r: Tp.WINRT,
            os: "Windows RT"
        },
        {
            r: Tp.WIN,
            os: "Windows"
        },
        {
            r: Tp.IOS,
            os: "iOS"
        },
        {
            r: Tp.ANDROID,
            os: "Android"
        },
        {
            r: Tp.LINUX,
            os: "Linux"
        },
        {
            r: Tp.CROS,
            os: "Chrome OS"
        },
        {
            s: "x11",
            os: "Unix"
        },
        {
            s: "blackberry",
            os: "BlackBerry"
        },
        {
            s: "symbian",
            os: "Symbian"
        },
        {
            s: "nokia",
            os: "Nokia"
        },
        {
            r: Tp.OSX,
            os: "Mac OS X"
        }
    ];
    /**
	* Loc.ts
	* @author Hector Hernandez (hectorh)
	* @copyright Microsoft 2019
	*/ function _getOsName(g) {
        for(var f = 0; f < Pp.length; f++){
            var S = Pp[f];
            if (S.r && g.match(S.r)) return S.os;
            if (S.s && -1 !== g.indexOf(S.s)) return S.os;
        }
        return Rp;
    }
    function _getOsVersion(g, f) {
        return "Windows" === f ? _getGenericOsVersion(g, "Windows NT") : "Android" === f ? _getGenericOsVersion(g, f) : "Mac OS X" === f ? _getMacOsxVersion(g) : "iOS" === f ? _getIosVersion(g) : Rp;
    }
    function _getGenericOsVersion(g, f) {
        var S = g.match(new RegExp(f + " " + bp));
        return S ? Ip[S[1]] ? Ip[S[1]] : S[1] : Rp;
    }
    function _getMacOsxVersion(g) {
        var f = g.match(new RegExp("Mac OS X " + Ap));
        if (f) {
            var S = f[1].replace(/_/g, ".");
            if (S) {
                var v = _getDelimiter(S);
                return v ? S.split(v)[0] : S;
            }
        }
        return Rp;
    }
    function _getIosVersion(g) {
        var f = g.match(new RegExp("OS " + Ap));
        if (f) {
            var S = f[1].replace(/_/g, ".");
            if (S) {
                var v = _getDelimiter(S);
                return v ? S.split(v)[0] : S;
            }
        }
        return Rp;
    }
    function _getDelimiter(g) {
        return g.indexOf(".") > -1 ? "." : g.indexOf("_") > -1 ? "_" : null;
    }
    var wp = function() {
        function OperatingSystem(g, f) {
            var S = this, v = null, _ = null, C = null, E = null, _setSysName = function(g) {
                C = g;
            }, _setSysVer = function(g) {
                E = g;
            }, _getSysName = function() {
                return C || v;
            }, _getSysVer = function() {
                return E || _;
            }, T = onConfigChange(g, function() {
                if ((g || {}).populateOperatingSystemInfo) {
                    var f = ot() || {}, S = g.userAgent || f.userAgent || "", C = (g.userAgentData || {}).platform || (f.userAgentData || {}).platform;
                    if (S) {
                        var E = _getOsName(S.toLowerCase());
                        v = E, _ = _getOsVersion(S, E);
                    }
                    v && v !== Rp || !Te(C) || (v = C);
                }
            });
            f && f.add(T), objDefine(S, "name", {
                s: _setSysName,
                g: _getSysName
            }), objDefine(S, "ver", {
                s: _setSysVer,
                g: _getSysVer
            });
        }
        return OperatingSystem;
    }(), Mp = "MicrosoftApplicationsTelemetryDeviceId";
    function _saveData(g, f, S, v) {
        f ? f.setProperty(S, v) : g.set(S, v, 31536e3);
    }
    function _getData(g, f, S) {
        return f ? f.getProperty(S) || "" : getCookieValue(g, S);
    }
    var Op = function() {
        function Sdk(g, f, S) {
            var v, _ = 0;
            dynamicProto$3(Sdk, this, function(C) {
                C.seq = _, C.epoch = random32(!1).toString(), C.getSequenceId = function() {
                    return ++_;
                };
                var E = onConfigChange(g, function(g) {
                    v = f && f.getCookieMgr();
                    var S = g.cfg.propertyStorageOverride;
                    if (v.isEnabled() || S) {
                        var _ = _getData(v, S, Mp);
                        _ || (_ = newGuid()), _saveData(v, S, Mp, _), C.installId = _;
                    } else v.purge(Mp);
                });
                S && S.add(E);
            });
        }
        return Sdk.__ieDyn = 1, Sdk;
    }(), Dp = function() {
        function Trace(g, f, S, v, _) {
            var C = this;
            C.traceId = f || generateW3CId();
            var E = onConfigChange(g, function() {
                var f = g;
                if (f.enableDistributedTracing && !S && (S = generateW3CId().substring(0, 16)), C.parentId = C.parentId || S, f.enableApplicationInsightsTrace && !v) {
                    var _ = getLocation();
                    _ && _.pathname && (v = _.pathname);
                }
                C.name = C.name || v;
            });
            _ && _.add(E);
        }
        return Trace;
    }(), Np = "setLocalId";
    function _getLocalId() {
        return this.getLocalId();
    }
    function _setLocalId(g) {
        this[Np](g);
    }
    var kp = function() {
        function User(g, f, S, v) {
            var _, C, E;
            dynamicProto$3(User, this, function(T) {
                if (_populateDefaults(f), "undefined" != typeof navigator) {
                    var I = navigator;
                    T.locale = I.userLanguage || I.language;
                }
                function _populateMuidFromCookie() {
                    if (!_.hashIdentifiers && !_.dropIdentifiers) {
                        var g = getCookieValue(E, "MUID");
                        g && (C = "t:" + g);
                    }
                    return C;
                }
                function _populateDefaults(f) {
                    var I = onConfigChange(f, function() {
                        if (E = S && S.getCookieMgr(), _ = f, C = null, E && E.isEnabled() && (_populateMuidFromCookie(), _.enableApplicationInsightsUser)) {
                            var v = getCookieValue(E, User.userCookieName);
                            if (v) {
                                var I = v.split(User.cookieSeparator);
                                I.length > 0 && (T.id = I[0]);
                            }
                            if (!T.id) {
                                T.id = newId(g && !isUndefined(g.idLength) ? g.idLength : 22);
                                var b = toISOString(new Date);
                                T.accountAcquisitionDate = b;
                                var A = [
                                    T.id,
                                    b
                                ], R = _.cookieDomain ? _.cookieDomain : void 0;
                                E.set(User.userCookieName, A.join(User.cookieSeparator), 31536e3, R);
                            }
                        }
                    });
                    v && v.add(I);
                }
                T.getLocalId = function() {
                    return C || _populateMuidFromCookie();
                }, T[Np] = function(g) {
                    C = g;
                };
            });
        }
        return User.cookieSeparator = "|", User.userCookieName = "ai_user", User._staticInit = void objDefine(User.prototype, "localId", {
            g: _getLocalId,
            s: _setLocalId
        }), User;
    }(), Lp = 1048576, Fp = 2097152, xp = 4194304, Up = function() {
        function Utc(g, f) {
            var S = this;
            S.popSample = 100;
            var v = onConfigChange(g, function() {
                S.eventFlags = 0, g.hashIdentifiers && (S.eventFlags = S.eventFlags | Lp), g.dropIdentifiers && (S.eventFlags = S.eventFlags | Fp), g.scrubIpOnly && (S.eventFlags = S.eventFlags | xp);
            });
            f && f.add(v);
        }
        return Utc;
    }(), Vp = [
        "Required",
        "Analytics",
        "SocialMedia",
        "Advertising"
    ], Bp = "([\\d,.]+)", Hp = "Unknown", $p = "Edg/", jp = "EdgiOS/", Gp = [
        {
            ua: "OPR/",
            b: "Opera"
        },
        {
            ua: "PhantomJS",
            b: "PhantomJS"
        },
        {
            ua: "Edge",
            b: "Edge"
        },
        {
            ua: $p,
            b: "Edge"
        },
        {
            ua: jp,
            b: "Edge"
        },
        {
            ua: "Electron",
            b: "Electron"
        },
        {
            ua: "Chrome",
            b: "Chrome"
        },
        {
            ua: "Trident",
            b: "MSIE"
        },
        {
            ua: "MSIE ",
            b: "MSIE"
        },
        {
            ua: "Firefox",
            b: "Firefox"
        },
        {
            ua: "Safari",
            b: "Safari"
        },
        {
            ua: "SkypeShell",
            b: "SkypeShell"
        }
    ], qp = [
        {
            br: "Microsoft Edge",
            b: "Edge"
        },
        {
            br: "Google Chrome",
            b: "Chrome"
        },
        {
            br: "Opera",
            b: "Opera"
        }
    ];
    function _userAgentContainsString(g, f) {
        return f.indexOf(g) > -1;
    }
    function _getBrandVersion(g, f) {
        for(var S = 0; S < f.length; S++)if (g == f[S].brand) return f[S].version;
        return null;
    }
    function _getBrowserName(g) {
        if (g) for(var f = 0; f < Gp.length; f++){
            if (_userAgentContainsString(Gp[f].ua, g)) return Gp[f].b;
        }
        return Hp;
    }
    function _getBrowserVersion(g, f) {
        return "MSIE" === f ? _getIeVersion(g) : _getOtherVersion(f, g);
    }
    function _getIeVersion(g) {
        var f = g.match(new RegExp("MSIE " + Bp));
        if (f) return f[1];
        var S = g.match(new RegExp("rv:" + Bp));
        return S ? S[1] : void 0;
    }
    function _getOtherVersion(g, f) {
        "Safari" === g ? g = "Version" : "Edge" === g && (_userAgentContainsString($p, f) ? g = "Edg" : _userAgentContainsString(jp, f) && (g = "EdgiOS"));
        var S = f.match(new RegExp(g + "/" + Bp));
        return S || "Opera" === g && (S = f.match(new RegExp("OPR/" + Bp))) ? S[1] : Hp;
    }
    function _getScreenResolution() {
        var g = {
            h: 0,
            w: 0
        }, f = nt();
        return f && f.screen && (g.h = screen.height, g.w = screen.width), g;
    }
    function _getUserConsent() {
        return this.getUserConsent();
    }
    var Wp = function() {
        function Web(g, f, S) {
            safeGetCookieMgr(f);
            var v = g || {}, _ = null, C = null, E = null, T = null, I = null, b = null, A = null;
            dynamicProto$3(Web, this, function(f) {
                _populateDefaults(g);
                var R = getLocation();
                if (R) {
                    var P = R.hostname;
                    P && (f.domain = "file:" === R.protocol ? "local" : P);
                }
                var w = _getScreenResolution();
                function _parseUserAgent(g, f) {
                    if (be(f)) try {
                        for(var S = 0; S < qp.length; S++){
                            var v = _getBrandVersion(qp[S].br, f);
                            if (v) return I = qp[S].b, void (b = v);
                        }
                    } catch (g) {}
                    if (g) {
                        var _ = _getBrowserName(g);
                        I = _, b = _getBrowserVersion(g, _);
                    }
                }
                function _setBrowser(g) {
                    E = g;
                }
                function _setBrowserVer(g) {
                    T = g;
                }
                function _getBrowser() {
                    return E || I;
                }
                function _getBrowserVer() {
                    return T || b;
                }
                f.screenRes = w.w + "X" + w.h, f.getUserConsent = function() {
                    return !1;
                }, f.getUserConsentDetails = function() {
                    var g = null;
                    try {
                        var f = v.callback;
                        if (f && f.userConsentDetails) {
                            var S = f.userConsentDetails();
                            if (S) {
                                g = v.disableConsentDetailsSanitize ? S : {};
                                for(var _ = 0; _ < Vp.length; _++){
                                    var C = Vp[_];
                                    g[C] = S[C] || !1;
                                }
                            }
                        }
                        return null !== A && ((g = g || {}).GPC_DataSharingOptIn = !!A), g ? JSON.stringify(g) : null;
                    } catch (g) {}
                };
                var _getGpcDataSharing = function() {
                    return A;
                }, _setGpcDataSharing = function(g) {
                    A = Pe(g) ? g : null, v.gpcDataSharingOptIn = A;
                };
                function _populateDefaults(g) {
                    var f = onConfigChange(g, function() {
                        if ((v = g).populateBrowserInfo) {
                            var f = v.userAgent, S = (v.userAgentData || {}).brands;
                            if (f !== _ || S !== C) {
                                if (!f || !S || 0 === S.length) {
                                    var E = ot();
                                    E && (f = f || E.userAgent || "", S = S || (E.userAgentData || {}).brands);
                                }
                                _parseUserAgent(f, S), _ = f, C = S;
                            }
                        }
                        A = Pe(v.gpcDataSharingOptIn) ? v.gpcDataSharingOptIn : null;
                    });
                    S && S.add(f);
                }
                objDefineProps(f, {
                    userConsent: {
                        g: f.getUserConsent
                    },
                    browser: {
                        s: _setBrowser,
                        g: _getBrowser
                    },
                    browserVer: {
                        s: _setBrowserVer,
                        g: _getBrowserVer
                    },
                    gpcDataSharingOptIn: {
                        g: _getGpcDataSharing,
                        s: _setGpcDataSharing
                    }
                });
            });
        }
        return Web._staticInit = void objDefine(Web.prototype, "userConsent", {
            g: _getUserConsent
        }), Web;
    }();
    function _applyExtValues(g, f, S, v, _) {
        var C = f.ext[ep[g]];
        if (C) try {
            objForEachKey(v, function(g, f) {
                if (Te(f) || Re(f) || Pe(f)) {
                    var v = C[S[g]];
                    !_ && (v || Te(v) || Re(v) || Pe(v)) && (f = v), C[S[g]] = f;
                }
            });
        } catch (g) {}
        return C;
    }
    var zp, Kp = function() {
        function TelemetryContext(g, f, S, v) {
            dynamicProto$3(TelemetryContext, this, function(_) {
                _.app = new vp(f, S, v), _.cloud = new _p, _.user = new kp(g, f, S, v), _.os = new wp(f, v), _.web = new Wp(f, S, v);
                var C = new Op(g, S, v), E = new yp(f, S, v), T = new Up(f, v);
                _.loc = new Ep, _.device = new Cp;
                var I = new fp(S, f, v);
                _.session = new pp;
                var b = void 0, A = createDistributedTraceContextFromTraceCtx(new Dp(f, b, b, b, v), _getTraceCtx()), R = !(f || {}).eventContainExtFields;
                function _getSessionId() {
                    var g = _.session;
                    if (g && Te(g.customId)) return g.customId;
                    I.update();
                    var f = I.automaticSession;
                    if (f) {
                        var S = f.getId();
                        S && Te(S) && (g.automaticId = S);
                    }
                    return g.automaticId;
                }
                function _getTraceCtx() {
                    var g = A;
                    return S && S.getTraceCtx && (g = S.getTraceCtx(!1) || A), g;
                }
                _.getTraceCtx = function() {
                    return A;
                }, _.getSessionId = _getSessionId, _.applyApplicationContext = function(g) {
                    var f, S = _.app;
                    _applyExtValues(4, g, tp, ((f = {})[0] = S.id, f[1] = S.ver, f[2] = S.name, f[3] = S.locale, f[4] = S.getExpId(), f[5] = S.env, f), R);
                }, _.applyUserContext = function(g) {
                    var f, S = _.user;
                    _applyExtValues(0, g, np, ((f = {})[1] = S.getLocalId(), f[0] = S.locale, f[2] = S.id, f), R);
                }, _.applyWebContext = function(g) {
                    var f, S = _.web;
                    _applyExtValues(3, g, ip, ((f = {})[0] = S.domain, f[1] = S.browser, f[2] = S.browserVer, f[3] = S.screenRes, f[5] = S.getUserConsentDetails(), f[4] = !1, f), R);
                }, _.applyOsContext = function(g) {
                    var f, S = _.os;
                    _applyExtValues(5, g, rp, ((f = {})[0] = S.name, f[1] = S.ver, f), R);
                }, _.applySdkContext = function(g) {
                    var f;
                    _applyExtValues(6, g, ap, ((f = {})[2] = C.installId, f[1] = C.getSequenceId(), f[3] = C.epoch, f), R);
                }, _.applyIntWebContext = function(g) {
                    var f;
                    _applyExtValues(7, g, sp, ((f = {})[0] = E.getMsfpc(), f[1] = E.getAnid(), f[2] = E.serviceName, f), R);
                }, _.applyUtcContext = function(g) {
                    var f, S = ((f = {})[0] = T.popSample, f);
                    T.eventFlags > 0 && (S[1] = T.eventFlags), _applyExtValues(8, g, op, S, R);
                }, _.applyLocContext = function(g) {
                    var f;
                    _applyExtValues(9, g, lp, ((f = {})[0] = _.loc.tz, f), R);
                }, _.applySessionContext = function(g) {
                    var f;
                    _applyExtValues(4, g, cp, ((f = {})[0] = _getSessionId(), f), R);
                }, _.applyDeviceContext = function(g) {
                    var f, S = _.device;
                    _applyExtValues(1, g, dp, ((f = {})[0] = S.localId, f[2] = S.make, f[3] = S.model, f[1] = S.deviceClass, f), R);
                }, _.applyCloudContext = function(g) {
                    var f, S = _.cloud;
                    _applyExtValues(10, g, up, ((f = {})[0] = S.role, f[1] = S.roleInstance, f[2] = S.roleVer, f), R);
                }, _.applyAITraceContext = function(g) {
                    var S;
                    if (f.enableApplicationInsightsTrace) {
                        var v = _getTraceCtx();
                        v && _applyExtValues(2, g, hp, ((S = {})[0] = v.getTraceId(), S[1] = v.getName(), S[2] = v.getSpanId(), S), !1);
                    }
                }, _.applyDistributedTraceContext = function(g) {
                    var f, S = _getTraceCtx();
                    if (S) {
                        var v = ((f = {})[0] = S.getTraceId(), f[1] = S.getSpanId(), f), _ = S.getTraceFlags();
                        isNullOrUndefined(_) || (v[2] = _), _applyExtValues(11, g, gp, v, !1);
                    }
                };
            });
        }
        return TelemetryContext.__ieDyn = 1, TelemetryContext;
    }();
    function createDistributedTraceContextFromTraceCtx(g, f) {
        var S = g || {};
        return {
            getName: function() {
                return S.name;
            },
            setName: function(g) {
                f && f.setName(g), S.name = g;
            },
            getTraceId: function() {
                return S.traceId;
            },
            setTraceId: function(g) {
                f && f.setTraceId(g), isValidTraceId(g) && (S.traceId = g);
            },
            getSpanId: function() {
                return S.parentId;
            },
            setSpanId: function(g) {
                f && f.setSpanId(g), isValidSpanId(g) && (S.parentId = g);
            },
            getTraceFlags: function() {
                return S.traceFlags;
            },
            setTraceFlags: function(g) {
                f && f.setTraceFlags(g), S.traceFlags = g;
            }
        };
    }
    var Jp = [
        ep[4],
        ep[0],
        ep[3],
        ep[5],
        ep[6],
        ep[7],
        ep[8],
        ep[9],
        ep[1],
        ep[2],
        ep[11],
        ep[10]
    ], Yp = objDeepFreeze({
        populateBrowserInfo: !1,
        populateOperatingSystemInfo: !1,
        userAgent: cfgDfString(),
        userAgentData: cfgDfMerge$1({
            brands: zp,
            mobile: zp,
            platform: zp
        }),
        userConsentCookieName: cfgDfString(),
        userConsented: !1,
        serviceName: cfgDfString(),
        env: cfgDfString(),
        expId: cfgDfString(),
        sessionRenewalMs: 18e5,
        sessionExpirationMs: 864e5,
        sessionAsGuid: null,
        cookieDomain: cfgDfString(),
        namePrefix: cfgDfString(),
        enableApplicationInsightsTrace: !1,
        enableApplicationInsightsUser: !1,
        hashIdentifiers: !1,
        dropIdentifiers: !1,
        scrubIpOnly: !1,
        callback: cfgDfMerge$1({
            userConsentDetails: null
        }),
        gpcDataSharingOptIn: zp,
        idLength: 22,
        enableDistributedTracing: !1,
        eventContainExtFields: !1
    }), Qp = function(g) {
        function PropertiesPlugin() {
            var f, S, v, _ = g.call(this) || this;
            return _.identifier = "SystemPropertiesCollector", _.priority = 3, _.version = "4.3.2", dynamicProto$3(PropertiesPlugin, _, function(g, _) {
                function _initDefaults() {
                    f = null, S = {};
                }
                function _populateDefaults(S) {
                    var _ = g.identifier, C = g.core;
                    g._addHook(onConfigChange(S, function() {
                        var g = createProcessTelemetryContext(null, S, C);
                        v = g.getExtCfg(_, Yp);
                    })), f = new Kp(S, v, C, g._unloadHooks), C && C.setTraceCtx && C.setTraceCtx(f.getTraceCtx());
                }
                function _addPropertiesIfAbsent(g, f) {
                    g && objForEachKey(g, function(g, S) {
                        f[g] || (f[g] = S);
                    });
                }
                _initDefaults(), g.initialize = function(g, f, S) {
                    _.initialize(g, f, S), _populateDefaults(g);
                }, g.processTelemetry = function(_, C) {
                    setProcessTelemetryTimings(_, g.identifier), C = g._getTelCtx(C);
                    var E = _.ext = _.ext ? _.ext : {};
                    _.data = _.data ? _.data : {}, arrForEach(Jp, function(g) {
                        E[g] = E[g] || {};
                    }), f && (f.applyUtcContext(_), f.applyApplicationContext(_), f.applyUserContext(_), f.applyWebContext(_), f.applyOsContext(_), f.applySdkContext(_), f.applyIntWebContext(_), f.applyLocContext(_), f.applySessionContext(_), f.applyDeviceContext(_), v.enableApplicationInsightsTrace && f.applyAITraceContext(_), v.enableDistributedTracing && f.applyDistributedTraceContext(_), f.applyCloudContext(_)), arrForEach(Ve(E), function(g) {
                        0 === Ve(E[g]).length && delete E[g];
                    }), _addPropertiesIfAbsent(S, _.data), g.processNext(_, C);
                }, g.getPropertiesContext = function() {
                    return f;
                }, g.setProperty = function(g, f) {
                    S[g] = f;
                }, g._doTeardown = function(g, S) {
                    var v = (g || {}).core();
                    if (v && v.getTraceCtx && f) {
                        var _ = v.getTraceCtx(!1);
                        _ && _ === f.getTraceCtx() && v.setTraceCtx(null);
                    }
                    _initDefaults();
                }, g._getDbgPlgTargets = function() {
                    return [
                        v
                    ];
                };
            }), _;
        }
        return __extendsFn$3(PropertiesPlugin, g), PropertiesPlugin.__ieDyn = 1, PropertiesPlugin;
    }(ja);
    const Xp = "Skype", Zp = "ConfigIDs", em = "This type of config is not currently supported.", tm = "Ecs Service has not yet responded. Try calling this API again in sometime.", im = "Possible duplicate call. Ecs already initialized for this confiugration definition.", nm = {
        Public: "https://ic3.events.data.microsoft.com/OneCollector/1.0/",
        PublicEUDB: "https://eu-ic3.events.data.microsoft.com/OneCollector/1.0/",
        GccHigh: "https://tb.events.data.microsoft.com/OneCollector/1.0/",
        Dod: "https://pf.events.data.microsoft.com/OneCollector/1.0/",
        AirGap08: "https://collector.azure.eaglex.ic.gov/OneCollector/1.0/",
        AirGap09: "https://collector.azure.microsoft.scloud/OneCollector/1.0/",
        Enterprise: "https://teams.events.data.microsoft.com/OneCollector/1.0",
        EnterpriseEUDB: "https://eu-teams.events.data.microsoft.com/OneCollector/1.0"
    };
    var rm, am;
    !function(g) {
        g.Public = "Public", g.GccHigh = "GCCHigh", g.Dod = "DoD", g.AirGap08 = "AirGap08", g.AirGap09 = "AirGap09";
    }(rm || (rm = {})), function(g) {
        g.OrgId = "orgid", g.Acs = "acs", g.Spool = "spool", g.GccHigh = "gcch", g.GccHighAcs = "gcch-acs", g.Dod = "dod", g.DodAcs = "dod-acs", g.AirGap08 = "ag08", g.AirGap08Acs = "ag08-acs", g.AirGap09 = "ag09", g.AirGap09Acs = "ag09-acs";
    }(am || (am = {}));
    const sm = {
        Public_EcsServer_Url: "https://ecs.communication.microsoft.com",
        GccHigh_EcsServer_Url: "https://config.ecs.gov.teams.microsoft.us",
        Dod_EcsServer_Url: "https://config.ecs.dod.teams.microsoft.us",
        AirGap08_EcsServer_Url: "https://config.ecs.teams.eaglex.ic.go",
        AirGap09_EcsServer_Url: "https://config.ecs.teams.microsoft.scloud",
        Enterprise_Ecs_ServerUrl: "https://config.teams.microsoft.com"
    }, om = {
        Public_ConversationServiceUrl: "https://api.flightproxy.skype.com/api/v2/cpconv",
        Public_TrouterServiceUrl: "https://go.trouter.communication.microsoft.com/v4/a",
        Public_RegistrarServiceUrl: "https://prod.registrar.skype.com/v3/registrations",
        Public_MdnTrapServiceUrl: "https://edge.skype.com/trap",
        Public_MdnTrapServiceTokenUrl: "https://edge.skype.com/trap/tokens",
        Public_MdnTrapRelaySkypeFqdns: "worldaz.tr.skype.com",
        Public_MdnTrapRelayTurnFqdns: "turn.azure.com",
        Public_MdnTrapRelayTurnUrl: "",
        GccHigh_ConversationServiceUrl: "https://api.cc.gov.teams.microsoft.us/conv/",
        GccHigh_TrouterServiceUrl: "https://go.trouter.gov.teams.microsoft.us/v4/a",
        GccHigh_RegistrarServiceUrl: "https://registrar.gov.teams.microsoft.us/v3/registrations",
        GccHigh_MdnTrapServiceUrl: "https://trap.gov.teams.microsoft.us",
        GccHigh_MdnTrapServiceTokenUrl: "https://trap.gov.teams.microsoft.us/tokens",
        GccHigh_MdnTrapRelaySkypeFqdns: "tr.gov.teams.microsoft.us",
        GccHigh_MdnTrapRelayTurnFqdns: "turn.gov.teams.microsoft.us",
        GccHigh_MdnTrapRelayTurnUrl: "https://turn.gov.teams.microsoft.us/relay",
        Dod_ConversationServiceUrl: "https://api.cc.dod.teams.microsoft.us/conv/",
        Dod_TrouterServiceUrl: "https://go.trouter.dod.teams.microsoft.us/v4/a",
        Dod_RegistrarServiceUrl: "https://registrar.dod.teams.microsoft.us/v3/registrations",
        Dod_MdnTrapServiceUrl: "https://trap.dod.teams.microsoft.us",
        Dod_MdnTrapServiceTokenUrl: "https://trap.dod.teams.microsoft.us/tokens",
        Dod_MdnTrapRelaySkypeFqdns: "tr.dod.teams.microsoft.us",
        Dod_MdnTrapRelayTurnFqdns: "turn.dod.teams.microsoft.us",
        Dod_MdnTrapRelayTurnUrl: "https://turn.dod.teams.microsoft.us/relay",
        AirGap08_ConversationServiceUrl: "https://api.cc.skype.com/conv/",
        AirGap08_TrouterServiceUrl: "https://go.trouter.teams.eaglex.ic.gov/v4/a",
        AirGap08_RegistrarServiceUrl: "https://api.registrar.teams.eaglex.ic.gov/v3/registrations",
        AirGap09_ConversationServiceUrl: "https://api.cc.skype.com/conv/",
        AirGap09_TrouterServiceUrl: "https://go.trouter.teams.microsoft.scloud/v4/a",
        AirGap09_RegistrarServiceUrl: "https://api.registrar.teams.microsoft.scloud/v3/registrations",
        Enterprise_ConversationServiceUrl: "https://api.flightproxy.teams.microsoft.com/api/v2/epconv",
        Enterprise_TrouterServiceUrl: "https://go.trouter.teams.microsoft.com/v4/a",
        Enterprise_RegistrarServiceUrl: "https://teams.microsoft.com/registrar/prod/v3/registrations",
        Enterprise_MdnTrapServiceUrl: "https://teams.microsoft.com/trap",
        Enterprise_MdnTrapServiceTokenUrl: "https://teams.microsoft.com/trap/tokens",
        Enterprise_MdnTrapRelaySkypeFqdns: "worldaz.relay.teams.microsoft.com",
        Enterprise_MdnTrapRelayTurnFqdns: "worldaz.relay.teams.microsoft.com",
        Enterprise_MdnTrapRelayTurnUrl: ""
    };
    var lm;
    !function(g) {
        g.Public_ConversationServiceUrl_EUDB = "https://api.flightproxy.skype.com/api/v2/cpconv", g.Public_TrouterServiceUrl_EUDB = "https://go-eu.trouter.communication.microsoft.com/v4/a", g.Public_RegistrarServiceUrl_EUDB = "https://emea.prod.registrar.skype.com/v3/registrations", g.Public_MdnTrapServiceUrl_EUDB = "https://edge.skype.com/trap", g.Public_MdnTrapServiceTokenUrl_EUDB = "https://edge.skype.com/trap/tokens", g.Public_MdnTrapRelaySkypeFqdns_EUDB = "eu.relay.skype.com", g.Public_MdnTrapRelayTurnFqdns_EUDB = "eu.relay.skype.com", g.Public_MdnTrapRelayTurnUrl_EUDB = "", g.Enterprise_ConversationServiceUrl_EUDB = "https://api.flightproxy.teams.microsoft.com/api/v2/epconv", g.Enterprise_TrouterServiceUrl_EUDB = "https://go-eu.trouter.teams.microsoft.com/v4/a", g.Enterprise_RegistrarServiceUrl_EUDB = "https://teams.microsoft.com/registrar/prod/v3/registrations", g.Enterprise_MdnTrapServiceUrl_EUDB = "https://teams.microsoft.com/trap", g.Enterprise_MdnTrapServiceTokenUrl_EUDB = "https://teams.microsoft.com/trap/tokens", g.Enterprise_MdnTrapRelaySkypeFqdns_EUDB = "euaz.relay.teams.microsoft.com", g.Enterprise_MdnTrapRelayTurnFqdns_EUDB = "euaz.relay.teams.microsoft.com", g.Enterprise_MdnTrapRelayTurnUrl_EUDB = "";
    }(lm || (lm = {}));
    const cm = {
        ...om,
        ...sm
    }, dm = {
        baseServiceUrl: "https://global.mtgw.prod.communication.microsoft.com/",
        policyUrlSuffix: "acsmt/v1/useraggregatepolicysettings/",
        policyUrlSuffixV2: "acsmt/v2/useraggregatepolicysettings/",
        createThreadSuffix: "acsmt/v1/threads/",
        addParticipantSuffix: "acsmt/v1/addParticipantsToThread/"
    };
    var um;
    !function(g) {
        g.Consumer = "consumer", g.Enterprise = "enterprise";
    }(um || (um = {}));
    const hm = [
        "europe",
        "france",
        "germany",
        "norway",
        "switzerland",
        "sweden"
    ], gm = [
        "emea",
        "fr",
        "de",
        "se"
    ], pm = Array.from(new Set(hm.concat([
        "qatar",
        "uae",
        "africa",
        "uk"
    ]))), mm = [
        "asiapacific",
        "india",
        "japan",
        "korea",
        "australia"
    ], fm = [
        "unitedstates",
        "brazil",
        "canada"
    ];
    var Sm, vm;
    !function(g) {
        g.EU = "EU", g.RoW = "RoW";
    }(Sm || (Sm = {})), function(g) {
        g.APAC = "APAC", g.NOAM = "NOAM", g.EMEA = "EMEA", g.UNKNOWN = "";
    }(vm || (vm = {}));
    const _m = {
        AUDIO: {
            JITTER: {
                GOOD: 30,
                AVERAGE: 75
            },
            RTT: {
                GOOD: 200,
                AVERAGE: 350
            },
            PACKETS_LOSS_PERCENTAGE: {
                GOOD: 3,
                AVERAGE: 6
            }
        },
        VIDEO: {
            JITTER: {
                GOOD: 20,
                AVERAGE: 75
            },
            RTT: {
                GOOD: 200,
                AVERAGE: 350
            },
            PACKETS_LOSS_PERCENTAGE: {
                GOOD: 3,
                AVERAGE: 6
            }
        },
        BANDWIDTH: {
            GOOD: 1500,
            AVERAGE: 500
        },
        CALL: {
            DURATION_IN_SEC: 30,
            GROUP_ID: generateGuid(),
            AGGREGATION: {
                INTERVAL: 1e3,
                DATAPOINTS: 1
            },
            VIDEO_SIZE: {
                heigth: 720,
                width: 1280
            },
            MEDIASTREAM_TIMEOUT_IN_SEC: 15,
            CONNECT_TIMEOUT_IN_SEC: 10
        }
    };
    var Cm;
    !function(g) {
        g.AcsOrganizerRole = "acsorganizer", g.AcsPresenterRole = "acspresenter", g.AcsAttendeeRole = "acsattendee", g.AcsConsumerRole = "acsconsumer", g.TeamsOrganizer = "organizer", g.TeamsAttendee = "attendee", g.TeamsPresenter = "presenter", g.TeamsCoorganizer = "coorganizer";
    }(Cm || (Cm = {}));
    const ym = [
        "airpod",
        "bluetooth",
        "hands-free",
        "stereo",
        "wireless",
        "citrix hdx",
        "remote audio",
        "vmware",
        "built-in",
        "integrated",
        "internal",
        "teams",
        "high definition",
        "facetime",
        "macbook",
        "smartaudio",
        "front",
        "rear",
        "back",
        "iphone",
        "ipad",
        "display",
        "displayport",
        "dp",
        "hdmi",
        "amd",
        "nvidia",
        "intel",
        "analog",
        "digital",
        "dock",
        "line( in| out)?",
        "s/pdif",
        "external",
        "thunderbolt\\d*",
        "usb",
        "panoramic",
        "desktop",
        "capture",
        "cable",
        "cam",
        "virtual",
        "manycam",
        "snap camera",
        "obs",
        "vb-audio",
        "vaio",
        "effect",
        "sink",
        "source",
        "default",
        "test"
    ], Em = "28:9cd07db6-fab5-438c-8e34-44117fac7650";
    let Tm = "3617";
    const getPlatformId = ()=>Tm, Im = 2e3, bm = 5e4, Am = 3e4, Rm = 25e3, Pm = 6e3, wm = 5e3, Mm = 1e3, Om = 3, Dm = "acs_broadcast_channel", Nm = 5e3, km = 500, Lm = !1, Fm = 500, xm = 512, Um = 0, Vm = .4, Bm = 200, Hm = 100, $m = 255, jm = -127, Gm = 6e3, qm = 2500, Wm = 1500, zm = 5e3, Km = 12, Jm = 2e4, Ym = 6e4, Qm = {
        WIDTH: 0,
        HEIGHT: 0
    }, Xm = 0, Zm = 6e3, ef = 100, tf = 4, nf = "4cf9ed87f7dc4e148f77855cd1f2fdca-61fb83a7-6672-4264-806f-7aded29f9b49-7618", rf = "53fdaa090eb946b5a1d6cbdeb4f2ef66-bcbf6380-2590-41cc-ae60-9e467cd51835-7413", af = "1cae5691997646c98b01d15beddae7a3-ce16e198-bc32-420f-ac64-42bb916111af-6865", sf = "2efdf03d07594586a5977c404e185186-71b046c4-f48f-4ba7-96d3-2a74b54e1d46-7326", of = "708a9eb9fe2646fe8f4c37b7eee2e3da-9b97485a-57b9-43a8-8177-07ca7a653a30-6706", lf = 7e3, cf = 10, df = 3, uf = "28:8133db4c-c049-4346-9edd-273f164a9227", hf = "28:b1902c3e-b9f7-4650-9b23-5772bd429747", gf = "28:bdd75849-e0a6-4cce-8fc1-d7c0d4da43e5", pf = "28:4b25d9f8-18f5-4d09-a582-cd0a28f63181", mf = "ACS-Public", ff = "Teams-Public", Sf = [
        "en-us"
    ], vf = [
        "en"
    ], _f = "en-us", Cf = 10, yf = "setLanguage", Ef = "mode", Tf = "Transcription", If = "RecordingAndTranscription", bf = "transcriptionModes", Af = "processingModes", Rf = [
        "closedCaptions"
    ], Pf = [
        "scheduledMeeting",
        "adhocMeeting"
    ], wf = [
        "28:f4693563-c70b-4e4d-bda6-01792aa21440",
        "28:e32c9418-a835-4eb1-bfb9-733fa74dd6e8"
    ], Mf = [
        "28:5f2511f1-6da9-41d9-80d9-af7da23a2c27",
        "28:accb0009-8d12-4cfe-969c-39b204e3ed0c"
    ], Of = "tlePlayer", Df = 256, Nf = "0.0", kf = !0, Lf = Symbol("global_telemetry_logger"), Ff = Symbol("global_call_client_index"), xf = 107, Uf = "orgid", Vf = "dod", Bf = "gcch", Hf = "8:", $f = "28:", jf = "4:", Gf = ":", qf = "Unknown", Wf = "ACSWeb", zf = Hf + (Uf + Gf), Kf = Hf + (Vf + Gf), Jf = Hf + (Bf + Gf), Yf = Hf + ("teamsvisitor" + Gf), Qf = Hf + ("acs" + Gf), Xf = Hf + ("spool" + Gf), Zf = Hf + ("dod-acs" + Gf), eS = Hf + ("gcch-acs" + Gf), tS = $f + (Uf + Gf), iS = $f + (Bf + Gf), nS = $f + (Vf + Gf), rS = {
        audioBitrate: {
            aggregation_needed: !1,
            raw_data_reduction: !0
        },
        videoBitrate: {
            aggregation_needed: !1,
            raw_data_reduction: !0
        },
        downloadBitrate: {
            aggregation_needed: !0,
            multiplier: 8,
            integer: !0,
            calculation_method: "rate"
        },
        bufferLengthInMs: {
            aggregation_needed: !0
        },
        mediaDelayInMs: {
            aggregation_needed: !0,
            is_internal: !0
        },
        videoHeight: {
            aggregation_needed: !1,
            raw_data_reduction: !0
        },
        videoWidth: {
            aggregation_needed: !1,
            raw_data_reduction: !0
        },
        playerHeight: {
            aggregation_needed: !1,
            raw_data_reduction: !0,
            is_internal: !0
        },
        playerWidth: {
            aggregation_needed: !1,
            raw_data_reduction: !0,
            is_internal: !0
        },
        currentPlayPosition: {
            aggregation_needed: !1,
            raw_data_reduction: !0
        }
    };
    var aS, sS;
    !function(g) {
        g.GroupCall = "joinGroupId", g.GroupChatCall = "joinThreadId", g.TeamsCoordinates = "joinMeetingCoordinates", g.TeamsMeetingId = "joinMeetingId", g.TeamsMeetingLink = "joinMeetingLink", g.RoomCall = "joinRoom", g.Unknown = "Unknown";
    }(aS || (aS = {})), function(g) {
        g.Organizer = "Organizer", g.Coorganizer = "Co-organizer", g.Attendee = "Attendee", g.Presenter = "Presenter", g.Consumer = "Consumer", g.Unknown = "Unknown";
    }(sS || (sS = {}));
    const oS = {
        "msft-acs-room-deviceType": "room",
        "msft-acs-3proom-deviceType": "3proom",
        "msft-acs-mesh-deviceType": "mesh",
        "msft-acs-mesh-deviceType-v2": "meshV2"
    };
    var lS, cS;
    !function(g) {
        g.onlyUsedProxy = "onlyUsedProxy", g.onlyUsedNonMsftTurn = "onlyUsedNonMsftTurn", g.usedProxyAndNonMsftTurn = "usedProxyAndNonMsftTurn", g.noCustomProxyAndTurnUsed = "noCustomProxyAndTurnUsed";
    }(lS || (lS = {})), function(g) {
        g.RoleRestricted = "RoleRestricted", g.FeatureNotSupported = "FeatureNotSupported", g.ClientRestricted = "ClientRestricted", g.MeetingRestricted = "MeetingRestricted", g.UserPolicyRestricted = "UserPolicyRestricted", g.TeamsPremiumLicenseRestricted = "TeamsPremiumLicenseRestricted", g.NotInitialized = "NotInitialized", g.Capable = "Capable", g.NotCapable = "NotCapable", g.CapabilityNotApplicableForTheCallType = "CapabilityNotApplicableForTheCallType", g.IpModeUserPolicyRestricted = "IpModeUserPolicyRestricted", g.ExplicitConsentRequired = "ExplicitConsentRequired";
    }(cS || (cS = {}));
    const dS = "roomsRoleBasedCapabilities", uS = "teamsRoleBasedCapabilities", hS = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, gS = /(\:[0-9]{1,6})(?=$|\/|\?)/;
    var pS, mS;
    !function(g) {
        g.TeamsProMgmt = "TeamsProMgmt";
    }(pS || (pS = {})), function(g) {
        g.Disabled = "Disabled", g.DisabledUserOverride = "DisabledUserOverride";
    }(mS || (mS = {}));
    const fS = {
        Unknown: "Unknown",
        UsbCamera: "UsbCamera",
        CaptureAdapter: "CaptureAdapter",
        Virtual: "Virtual",
        ScreenSharing: "ScreenSharing"
    };
    var SS;
    function getMriFromIdentifier(g) {
        const f = S.getIdentifierKind(g);
        switch(f.kind){
            case SS.communicationUser:
                return f.communicationUserId;
            case SS.phoneNumber:
                if (f.rawId) return `${f.rawId}`;
                if (f.phoneNumber) return `${jf}${f.phoneNumber}`;
                throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_PHONENUMBER
                });
            case SS.microsoftTeamsUser:
                if (f.rawId) return f.rawId;
                if (f.microsoftTeamsUserId) {
                    if (f.isAnonymous) return `${Yf}${f.microsoftTeamsUserId}`;
                    if ("public" === f.cloud) return `${zf}${f.microsoftTeamsUserId}`;
                    if ("dod" === f.cloud) return `${Kf}${f.microsoftTeamsUserId}`;
                    if ("gcch" === f.cloud) return `${Jf}${f.microsoftTeamsUserId}`;
                    if (!f.cloud) return `${zf}${f.microsoftTeamsUserId}`;
                }
                throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_MSFT_TEAMS_USER
                });
            case SS.microsoftTeamsApp:
                if (f.rawId) return f.rawId;
                if (f.teamsAppId) {
                    if ("public" === f.cloud) return `${tS}${f.teamsAppId}`;
                    if ("dod" === f.cloud) return `${nS}${f.teamsAppId}`;
                    if ("gcch" === f.cloud) return `${iS}${f.teamsAppId}`;
                    if (!f.cloud) return `${tS}${f.teamsAppId}`;
                }
                throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_MSFT_TEAMS_APP
                });
            case "unknown":
                return f.id;
            default:
                throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_IDENTIFIER
                });
        }
    }
    function constructIdentifierKindFromMri(g) {
        return g.startsWith(zf) ? {
            kind: SS.microsoftTeamsUser,
            rawId: g,
            microsoftTeamsUserId: g.substring(8),
            isAnonymous: !1,
            cloud: "public"
        } : g.startsWith(Kf) ? {
            kind: SS.microsoftTeamsUser,
            rawId: g,
            microsoftTeamsUserId: g.substring(6),
            isAnonymous: !1,
            cloud: "dod"
        } : g.startsWith(Jf) ? {
            kind: SS.microsoftTeamsUser,
            rawId: g,
            microsoftTeamsUserId: g.substring(7),
            isAnonymous: !1,
            cloud: "gcch"
        } : g.startsWith(Yf) ? {
            kind: SS.microsoftTeamsUser,
            rawId: g,
            microsoftTeamsUserId: g.substring(15),
            isAnonymous: !0
        } : g.startsWith(jf) ? {
            kind: SS.phoneNumber,
            rawId: g,
            phoneNumber: g.substring(2)
        } : g.startsWith(Qf) || g.startsWith(Xf) || g.startsWith(eS) || g.startsWith(Zf) ? {
            kind: SS.communicationUser,
            communicationUserId: g
        } : g.startsWith(tS) ? {
            kind: SS.microsoftTeamsApp,
            rawId: g,
            teamsAppId: g.substring(9),
            cloud: "public"
        } : g.startsWith(iS) ? {
            kind: SS.microsoftTeamsApp,
            rawId: g,
            teamsAppId: g.substring(8),
            cloud: "gcch"
        } : g.startsWith(nS) ? {
            kind: SS.microsoftTeamsApp,
            rawId: g,
            teamsAppId: g.substring(7),
            cloud: "dod"
        } : {
            kind: SS.unknown,
            id: g
        };
    }
    function isCallingApplication(g) {
        return !!g.startsWith($f);
    }
    function isGlobalCallingApplication(g) {
        return !(!g.startsWith($f) || g.startsWith(tS) || g.startsWith(nS) || g.startsWith(iS));
    }
    function validateIdentifier(g) {
        const f = S.getIdentifierKind(g);
        switch(f.kind){
            case SS.communicationUser:
                if (!(f.communicationUserId.startsWith(Qf) || f.communicationUserId.startsWith(Xf) || f.communicationUserId.startsWith(eS) || f.communicationUserId.startsWith(Zf))) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_COMM_USER
                });
                return f;
            case "phoneNumber":
                return f;
            case SS.microsoftTeamsUser:
                if (f.rawId && !f.rawId.startsWith(zf) && !f.rawId.startsWith(Kf) && !f.rawId.startsWith(Jf) && !f.rawId.startsWith(Yf)) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_MSFT_TEAMS_USER_RAWID
                });
                if (!f.microsoftTeamsUserId) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_MSFT_TEAMS_USER_USERID
                });
                return f;
            case SS.microsoftTeamsApp:
                if (f.rawId && !f.rawId.startsWith($f)) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_MSFT_TEAMS_APP_RAWID
                });
                if (!f.teamsAppId) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_MSFT_TEAMS_APP_APPID
                });
                return f;
            case SS.unknown:
                if (!f.id) throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.INVALID_UNKNOWN_IDENTIFIER
                });
                return f;
            default:
                throw new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_INVALID_IDENTIFIER
                });
        }
    }
    function assertIsArrayOfIdentifiers(g) {
        if (!(g instanceof Array)) throw new CallingCommunicationError({
            defaultError: O.IDENTIFIER.INVALID_IDENTIFIER_ARRAY
        });
    }
    function getCloudTypeFromSkypeId(g) {
        const f = g.substring(0, g.indexOf(":"));
        if (!f) throw new CallingCommunicationError({
            defaultError: O.IDENTIFIER.NO_CLOUD_PREFIX_FOUND
        });
        switch(f){
            case am.OrgId:
            case am.Acs:
            case am.Spool:
                return rm.Public;
            case am.GccHigh:
            case am.GccHighAcs:
                return rm.GccHigh;
            case am.Dod:
            case am.DodAcs:
                return rm.Dod;
            case am.AirGap08:
            case am.AirGap08Acs:
                return rm.AirGap08;
            case am.AirGap09:
            case am.AirGap09Acs:
                return rm.AirGap09;
            default:
                return rm.Public;
        }
    }
    !function(g) {
        g.communicationUser = "communicationUser", g.microsoftTeamsUser = "microsoftTeamsUser", g.microsoftTeamsApp = "microsoftTeamsApp", g.phoneNumber = "phoneNumber", g.unknown = "unknown", g.group = "group";
    }(SS || (SS = {}));
    const vS = "1.32.1.0_stable", _S = "1.32.1";
    function getSdkInternalVersion() {
        const g = "ACS_CLIENT_INTERNAL_SZK_VERSION".replace("Z", "D");
        return vS === g ? "1.0.0.0" : vS;
    }
    function getSdkVersion() {
        const g = "ACS_CLIENT_SZK_VERSION".replace("Z", "D");
        return _S === g ? "1.0.0.0" : _S;
    }
    function getDateInIsoFormat() {
        return (new Date).toISOString();
    }
    function arrayMergeCustomizer(g, f) {
        if (Array.isArray(g)) return f.slice();
    }
    function isNonEmptyArray(g) {
        return Array.isArray(g) && 0 !== g.length;
    }
    function isNullOrUndefined$1(g) {
        return null == g || void 0 === g;
    }
    function valueOrDefault(g, f) {
        return void 0 !== g ? g : f;
    }
    function isPromiseLike$1(g) {
        return !!g && "function" == typeof g.then;
    }
    function safeJsonStringify(g) {
        try {
            return JSON.stringify(g, null, 2);
        } catch (f) {
            return `failed to stringify obj ${g}`;
        }
    }
    function isIpv4Address(g) {
        return new RegExp(hS).test(g);
    }
    function clampEmail(g, f) {
        const S = 3, v = 2, _ = 1, C = /^(.+)@([^@]+)$/, E = g.match(C), T = E === null || E === void 0 ? void 0 : E[v], I = (E === null || E === void 0 ? void 0 : E.length) === S ? E[_] : g, b = I.length > f ? `${I.substring(0, f)}***` : I;
        return T ? `${b}@${T}` : b;
    }
    const calculateWatermarkPatternScaling = (g, f, S)=>{
        const v = document.documentElement.clientWidth / document.documentElement.clientHeight, _ = Math.max(v, 1), C = 1 / _, E = .001, T = .5, I = .5, b = 4.5, A = 11.5, R = .75, P = 24, w = 1, M = Math.min(g, f) * E * _;
        return {
            scaledFontSize: P * Math.max(R, M) * C,
            scaledBorderSize: w * Math.max(1, M) * C,
            scaledHorizontalGap: I * Math.max(T, Math.min(1, M)),
            scaledVerticalGap: Math.max(A * Math.min(1, M), b * _)
        };
    }, createTextDiagonalCalculation = (g)=>{
        const f = toRadians(90 - g), S = 1 / Math.cos(toRadians(g)), v = 1 / Math.cos(f), _ = Math.tan(f);
        return (g, f)=>g < _ * f ? g * S : f * v;
    }, toRadians = (g)=>{
        const f = 180;
        return g * (Math.PI / f);
    }, CS = {
        "audio.send": {
            bitrate: {
                min: 0,
                max: 535500
            },
            packetsPerSecond: {
                min: 0,
                max: 200
            },
            packetsLostPerSecond: {
                min: 0,
                max: 200
            }
        },
        "audio.receive": {
            bitrate: {
                min: 0,
                max: 535500
            },
            packetsPerSecond: {
                min: 0,
                max: 200
            },
            packetsLostPerSecond: {
                min: 0,
                max: 200
            }
        },
        "video.send": {
            bitrate: {
                min: 0,
                max: 8e6
            },
            packetsPerSecond: {
                min: 0,
                max: 1e3
            },
            packetsLostPerSecond: {
                min: 0,
                max: 1e3
            },
            frameRateInput: {
                min: 0,
                max: 66
            },
            frameRateEncoded: {
                min: 0,
                max: 66
            },
            frameRateSent: {
                min: 0,
                max: 66
            }
        },
        "video.receive": {
            bitrate: {
                min: 0,
                max: 8e6
            },
            packetsPerSecond: {
                min: 0,
                max: 1e3
            },
            packetsLostPerSecond: {
                min: 0,
                max: 1e3
            },
            frameRateOutput: {
                min: 0,
                max: 66
            },
            frameRateDecoded: {
                min: 0,
                max: 66
            },
            frameRateReceived: {
                min: 0,
                max: 66
            }
        },
        "screenShare.send": {
            bitrate: {
                min: 0,
                max: 8e6
            },
            packetsPerSecond: {
                min: 0,
                max: 1e3
            },
            packetsLostPerSecond: {
                min: 0,
                max: 1e3
            },
            frameRateInput: {
                min: 0,
                max: 33
            },
            frameRateEncoded: {
                min: 0,
                max: 33
            },
            frameRateSent: {
                min: 0,
                max: 33
            }
        },
        "screenShare.receive": {
            bitrate: {
                min: 0,
                max: 8e6
            },
            packetsPerSecond: {
                min: 0,
                max: 1e3
            },
            packetsLostPerSecond: {
                min: 0,
                max: 1e3
            },
            frameRateOutput: {
                min: 0,
                max: 33
            },
            frameRateDecoded: {
                min: 0,
                max: 33
            },
            frameRateReceived: {
                min: 0,
                max: 33
            }
        }
    };
    var yS, ES, TS, IS, bS, AS, RS, PS, wS, MS, OS, DS, NS, kS, LS, FS, xS, US, VS, BS, HS, $S, jS;
    !function(g) {
        g.Outgoing = "Outgoing", g.Incoming = "Incoming", g.TransferOutgoing = "TransferOutgoing";
    }(yS || (yS = {})), function(g) {
        g.CreateCallAgent = "CreateCallAgent", g.CreateTeamsCallAgent = "CreateTeamsCallAgent", g.GetDeviceManager = "GetDeviceManager", g.GetEnvironmentInfo = "GetEnvironmentInfo", g.GetSDKVersion = "GetSDKVersion", g.Feature = "Feature";
    }(ES || (ES = {})), function(g) {
        g.StartCall = "StartCall", g.Join = "Join", g.HandlePushNotification = "HandlePushNotification", g.Initialize = "Initialize", g.Dispose = "Dispose", g.CreateCall = "CreateCall", g.Feature = "Feature";
    }(TS || (TS = {})), function(g) {
        g.Call = "Call", g.StartCall = "StartCall", g.CallGroup = "CallGroup", g.JoinGroup = "JoinGroup", g.Accept = "Accept", g.Reject = "Reject", g.Mute = "Mute", g.Unmute = "Unmute", g.MuteAllRemoteParticipants = "MuteAllRemoteParticipants", g.MuteIncomingAudio = "MuteIncomingAudio", g.UnmuteIncomingAudio = "UnmuteIncomingAudio", g.SendDtmf = "SendDtmf", g.HangUp = "HangUp", g.StartVideo = "StartVideo", g.StartAudio = "StartAudio", g.StopAudio = "StopAudio", g.StopVideo = "StopVideo", g.AddParticipant = "AddParticipant", g.RemoveParticipant = "RemoveParticipant", g.LobbyAdmitParticipant = "LobbyAdmitParticipant", g.LobbyRejectParticipant = "LobbyRejectParticipant", g.LobbyAdmitAll = "LobbyAdmitAll", g.Hold = "Hold", g.Resume = "Resume", g.StartScreenShare = "StartScreenShare", g.StopScreenShare = "StopScreenShare", g.Transfer = "Transfer", g.BindToCall = "BindToCall", g.Feature = "Feature", g.SetConstraints = "SetConstraints";
    }(IS || (IS = {})), function(g) {
        g.Mute = "Mute";
    }(bS || (bS = {})), function(g) {
        g.GetServerCallId = "GetServerCallId";
    }(AS || (AS = {})), function(g) {
        g.CreateStackBase = "CreateStackBase", g.GetDeviceManager = "GetDeviceManager", g.InitializeStackForUser = "InitializeStackForUser", g.InitializeEcsBase = "InitializeEcsBase", g.InitializeEcsForUser = "InitializeEcsForUser", g.Dispose = "Dispose";
    }(RS || (RS = {})), function(g) {
        g.GetDeviceManager = "GetDeviceManager", g.GetCameras = "GetCameras", g.GetMicrophones = "GetMicrophones", g.GetSpeakers = "GetSpeakers", g.GetCamera = "GetCamera", g.SelectCamera = "SelectCamera", g.GetSelectedMicrophone = "GetSelectedMicrophone", g.SelectMicrophone = "SelectMicrophone", g.GetSelectedSpeaker = "GetSelectedSpeaker", g.SelectSpeaker = "SelectSpeaker", g.RenderPreviewVideo = "RenderPreviewVideo", g.AskDevicePermission = "AskDevicePermission";
    }(PS || (PS = {})), function(g) {
        g.Dispose = "Dispose", g.UpdateScalingMode = "UpdateScalingMode", g.Render = "Render", g.RenderRemoteStream = "RenderRemoteStream", g.RenderLocalStream = "RenderLocalStream";
    }(wS || (wS = {})), function(g) {
        g.Dispose = "Dispose", g.CreateView = "CreateView";
    }(MS || (MS = {})), function(g) {
        g.SwitchSource = "SwitchSource", g.Render = "Render", g.GetMediaStream = "GetMediaStream", g.SetMediaStream = "SetMediaStream", g.SwitchVideo = "SwitchVideo", g.Feature = "Feature";
    }(OS || (OS = {})), function(g) {
        g.SwitchSource = "SwitchSource", g.GetMediaStream = "GetMediaStream", g.SetMediaStream = "SetMediaStream", g.Feature = "Feature";
    }(DS || (DS = {})), function(g) {
        g.SetScalingMode = "SetScalingMode", g.Start = "Start", g.Stop = "Stop", g.SwitchDevice = "SwitchDevice", g.Dispose = "Dispose";
    }(NS || (NS = {})), function(g) {
        g.Render = "Render", g.GetMediaStream = "GetMediaStream";
    }(kS || (kS = {})), function(g) {
        g.Start = "Start", g.Resume = "Resume", g.Pause = "Pause", g.SetScalingMode = "SetScalingMode", g.Dispose = "Dispose";
    }(LS || (LS = {})), function(g) {
        g.Start = "Start", g.Resume = "Resume", g.Pause = "Pause", g.SetScalingMode = "SetScalingMode", g.Dispose = "Dispose", g.SetSourceObject = "SetSourceObject";
    }(FS || (FS = {})), function(g) {
        g.SourceUnavailableError = "SourceUnavailableError", g.permissionDeniedError = "permissionDeniedError", g.PermissionDeniedError = "PermissionDeniedError", g.DevicesNotFoundError = "DevicesNotFoundError", g.MediaStreamRequestError = "MediaStreamRequestError", g.PermissionsDeniedBySystem = "PermissionsDeniedBySystem", g.UnknownFailureForVideoOperation = "UnknownFailureForVideoOperation", g.noDeviceSelected = "noDeviceSelected", g.NoDeviceSelected = "NoDeviceSelected", g.MediaStreamRequestTimedout = "MediaStreamRequestTimedout", g.UnsupportedStream = "UnsupportedStream", g.ConstraintNotSatisfiedError = "ConstraintNotSatisfiedError";
    }(xS || (xS = {})), function(g) {
        g.BrowserNotSupported = "BrowserNotSupported", g.IncompatibleVersions = "IncompatibleVersions";
    }(US || (US = {})), function(g) {
        g.JoinTeamMeeting = "JoinTeamMeeting", g.JoinRoom = "JoinRoom", g.JoinWithGroupId = "JoinWithGroupId", g.PlaceCall = "PlaceCall", g.AcceptCall = "AcceptCall", g.TransferToParticipant = "TransferToParticipant", g.TransferToCall = "TransferToCall", g.CallQueue = "CallQueue";
    }(VS || (VS = {})), function(g) {
        g.TeamsMeeting = "TeamsMeeting", g.Rooms = "Rooms", g.GroupIdCall = "GroupIdCall", g.TwoParty = "TwoParty", g.MultiParty = "MultiParty";
    }(BS || (BS = {})), function(g) {
        g.Enabled = "Enabled", g.UserOverride = "UserOverride", g.Disabled = "Disabled";
    }(HS || (HS = {})), function(g) {
        g.Standard = "standard", g.MusicOnHold = "musicOnHold";
    }($S || ($S = {})), function(g) {
        g.Disabled = "Disabled", g.EnabledOutgoingIncoming = "EnabledOutgoingIncoming";
    }(jS || (jS = {}));
    const GS = {
        telemetry: {
            callStatsFlushTimeout: Pm,
            discardedTelemetryRetryTimeout: wm,
            discardedEventsBufferMaxLength: Mm,
            discardedEventsMaxRetries: Om,
            telemetryFlushTimeout: Im,
            asyncTelemetryFlush: !0,
            allowedEvents: [],
            blockedEvents: [
                "acs_calling_feature_usage",
                "acs_calling_call_client_init"
            ],
            blockedKindOfEvents: [
                {
                    name: "acs_calling_token_expiration_changed",
                    kindOfEvents: [
                        "attempt",
                        "success"
                    ]
                }
            ],
            limit: {
                outSideCall: {
                    enabled: !1,
                    deltaTimeInMs: 15e3,
                    includedEvents: [],
                    excludedEvents: []
                },
                rates: []
            },
            telemetryBeforeUnload: !1,
            gzipTelemetryPayload: !0,
            localStorageEnable: !1,
            speakingWhileMutedThrottleInterval: 18e4,
            mediaStatsConfig: {
                enabled: !0,
                throttleTelemetry: 1,
                aggregationInterval: 10,
                dataPointsPerAggregation: 6,
                metricsProperties: {},
                dataToSend: {
                    raw: !1,
                    min: !0,
                    max: !0,
                    sum: !0,
                    count: !0
                },
                enableNetworkInformation: !1,
                enableMemoryInformationV1: !1,
                enableMemoryInformationV2: !1,
                enableBatteryInformation: !1,
                enablePressureInformation: !1,
                enableAudioLeakInformation: !1,
                audioLeakThreshold: 46e-5,
                enableVideoLeakInformation: !1,
                enableVideoMaxCapCallStats: !1
            },
            liveStreamStatsConfig: {
                enabled: !1,
                aggregationInterval: 10,
                dataPointsPerAggregation: 6,
                additionalStats: {},
                dataToSend: {
                    raw: !1,
                    min: !0,
                    max: !0,
                    sum: !0,
                    count: !0
                }
            },
            reportSdkUaToService: !0,
            reportEnvToService: !0,
            sendNetworkChangedTelemetry: !1,
            deviceChangedEvents: {
                enabled: !0,
                piiSafeWordsMode: "merge",
                piiSafeWords: ym
            },
            maxExistingReportedParticipants: 25,
            sendNetworkInfo: !1,
            apiCauseIdHeader: "X-Microsoft-Skype-Message-ID"
        },
        mediaStats: {
            blockMetrics: {},
            transformMetrics: {},
            activeState: [
                3,
                10,
                9
            ],
            fetchInterval: 1,
            aggregationInterval: 10,
            dataPointsPerAggregation: 6,
            pollingMethod: "interval",
            timerThrottlingFilter: {
                enabled: !1,
                delayRatio: 0,
                filterRange: CS
            }
        },
        liveStreamStats: {
            activeState: [
                3
            ],
            fetchInterval: 1,
            aggregationInterval: 10,
            dataPointsPerAggregation: 6,
            pollingMethod: "interval"
        },
        debugInfo: {
            broadcastChannelName: Dm,
            tabsBroadcastDelay: Nm,
            tabsUpdateDelay: km,
            enableLogDump: Lm,
            maxLogDumpLength: Fm,
            includeList: [],
            excludeList: []
        },
        volumeIndicator: {
            fftSize: xm,
            minDecibels: jm,
            maxDecibels: Um,
            smoothingConstant: Vm,
            microphoneVolumeSampleIntervalMs: Bm,
            normalisedMaxVolume: Hm,
            maxAvailableVolume: $m
        },
        telemetryEvents: {
            eventNameToPriority: {
                eventName: [
                    "acs_calling_call_stats"
                ],
                priority: [
                    js.Immediate
                ]
            }
        },
        rendering: {
            remoteVideo: {
                createViewTimeout: Gm,
                speedupCreateViewWithPlayEvent: !1,
                createViewUnsubscribeTimeout: qm,
                debounceTimeout: Wm,
                createViewSendMediaStats: !0,
                createViewSendMediaStatsMaxLength: 120,
                createViewSendMediaStatsInitialMaxLength: 1,
                createViewFailureNetworkUfdCheckWindowInMs: 2e3,
                forceCheckIfVideoWasAttachedToDom: !0,
                checkIfVideoAttachedToDom_poll: !0,
                checkIfVideoAttachedToDom_intervalTime: zm,
                checkIfVideoAttachedToDom_intervalMaxTries: Km,
                checkIfVideoAttachedToDom_timeout: Jm,
                createViewSenderStatsDuration: Ym,
                registeredViewIdsMaxLength: Xm,
                getMediaStreamTimeout: Zm,
                largeMeeting: {
                    handleVideoRendering: !0,
                    participantCountThreshold: ef,
                    dominantSpeakersWithVideoOn_topCount: tf
                }
            }
        },
        captions: {
            acsBotMri: uf,
            teamsBotMri: gf,
            teamsGccBotMri: pf,
            clientInfo: mf,
            availableLanguages: Sf,
            enabled: !0,
            dataChannelId: df,
            useCapabilities: !0,
            setBotMetadataWhenEmptyFix: !0,
            acs: {
                enabled: !0,
                botMri: uf,
                modeKey: Ef,
                modeVal: Tf,
                modesKey: bf,
                modesVal: Rf,
                clientInfo: {
                    ring: mf
                },
                spokenLanguages: {
                    enabled: !0,
                    languages: Sf
                }
            },
            teams: {
                enabled: !0,
                legacyBotMri: hf,
                botMri: gf,
                gccBotMri: pf,
                modeKey: Ef,
                modeVal: If,
                modesKey: Af,
                modesVal: Rf,
                clientInfo: {
                    ring: ff
                },
                spokenLanguages: {
                    enabled: !0,
                    languages: Sf
                },
                captionLanguages: {
                    enabled: !1,
                    languages: vf
                }
            }
        },
        audioEffects: {
            enableAudioEffects: !1,
            maxStringLengthForTelemetry: 250
        },
        videoEffects: {
            enableVideoEffects: !1,
            imageTransparencyCheckTimeoutInMs: 1e3,
            effectInitTimeThresholdInMs: 2e4,
            fpsWarningThreshold: 5,
            waitTimeToInitiateFpsChecksInMs: 2e4,
            fpsCheckIntervalTimeInMs: 3e3,
            maxStringLengthForTelemetry: 250
        },
        calling: {
            enableMuteOthers: !0,
            enableSmePassFakeConversation: !1,
            doNotWaitForTrouter: !0,
            hangUpCallOnPageHide: !1,
            maxNumberOfTokenFetchRetries: 10,
            deviceSelectionTimeoutInMs: 3e3,
            deviceNotFunctioningMuted: !0,
            muteUnmuteOnMicrophoneNotFunctioning: !1,
            unmuteDelayForMicrophoneNotFunctioningInMs: 0,
            preventStopAudio: !1,
            preventFakeMute: !1,
            osAutoRecoverAudio: !1,
            deviceCaptureMuteRecover: !1,
            allowMuteOnBadUfd: !0,
            preventStopVideo: !0,
            mediaMetricsDeviceEventsEnabled: !1,
            allowAccessRawMediaStream: !1,
            applyViewLimit: !0,
            deviceCaptureMutedVideo: !0,
            removeLvsCheckOnCallStartAndCallAccept: !1,
            removeLocalAudioStreamCheckOnCallStartAndCallAccept: !1,
            turnOffScreenShareBeforeHold: !0,
            constraints: {
                enabled: !1,
                maxOutgoingResolution: 0,
                maxOutgoingFrameRate: 0,
                maxOutgoingVideoBitrate: 0
            },
            sharedLineAppearance: {
                enabled: !1
            },
            supportLiveStreaming: !1,
            liveStreamingBotIds: wf,
            composedStreamBotIds: Mf,
            teamsCallQualityFeedback: {
                enabled: !0,
                tenantId: af
            },
            setDeviceType: !1,
            devicePermissions: {
                splitAskAudioVideo: !1,
                timeoutInBetween: 0,
                getCurrentState: !0
            },
            applicationSettingsUrls: {
                Public_ConversationServiceUrl: cm.Public_ConversationServiceUrl,
                Public_TrouterServiceUrl: cm.Public_TrouterServiceUrl,
                Public_RegistrarServiceUrl: cm.Public_RegistrarServiceUrl,
                Public_MdnTrapServiceUrl: cm.Public_MdnTrapServiceUrl,
                Public_MdnTrapServiceTokenUrl: cm.Public_MdnTrapServiceTokenUrl,
                Public_MdnTrapRelaySkypeFqdns: cm.Public_MdnTrapRelaySkypeFqdns,
                Public_MdnTrapRelayTurnFqdns: cm.Public_MdnTrapRelayTurnFqdns,
                Public_MdnTrapRelayTurnUrl: cm.Public_MdnTrapRelayTurnUrl,
                GccHigh_ConversationServiceUrl: cm.GccHigh_ConversationServiceUrl,
                GccHigh_TrouterServiceUrl: cm.GccHigh_TrouterServiceUrl,
                GccHigh_RegistrarServiceUrl: cm.GccHigh_RegistrarServiceUrl,
                GccHigh_MdnTrapServiceUrl: cm.GccHigh_MdnTrapServiceUrl,
                GccHigh_MdnTrapServiceTokenUrl: cm.GccHigh_MdnTrapServiceTokenUrl,
                GccHigh_MdnTrapRelaySkypeFqdns: cm.GccHigh_MdnTrapRelaySkypeFqdns,
                GccHigh_MdnTrapRelayTurnFqdns: cm.GccHigh_MdnTrapRelayTurnFqdns,
                GccHigh_MdnTrapRelayTurnUrl: cm.GccHigh_MdnTrapRelayTurnUrl,
                Dod_ConversationServiceUrl: cm.Dod_ConversationServiceUrl,
                Dod_TrouterServiceUrl: cm.Dod_TrouterServiceUrl,
                Dod_RegistrarServiceUrl: cm.Dod_RegistrarServiceUrl,
                Dod_MdnTrapServiceUrl: cm.Dod_MdnTrapServiceUrl,
                Dod_MdnTrapServiceTokenUrl: cm.Dod_MdnTrapServiceTokenUrl,
                Dod_MdnTrapRelaySkypeFqdns: cm.Dod_MdnTrapRelaySkypeFqdns,
                Dod_MdnTrapRelayTurnFqdns: cm.Dod_MdnTrapRelayTurnFqdns,
                Dod_MdnTrapRelayTurnUrl: cm.Dod_MdnTrapRelayTurnUrl,
                AirGap08_ConversationServiceUrl: cm.AirGap08_ConversationServiceUrl,
                AirGap08_TrouterServiceUrl: cm.AirGap08_TrouterServiceUrl,
                AirGap08_RegistrarServiceUrl: cm.AirGap08_RegistrarServiceUrl,
                AirGap09_ConversationServiceUrl: cm.AirGap09_ConversationServiceUrl,
                AirGap09_TrouterServiceUrl: cm.AirGap09_TrouterServiceUrl,
                AirGap09_RegistrarServiceUrl: cm.AirGap09_RegistrarServiceUrl,
                Enterprise_ConversationServiceUrl: cm.Enterprise_ConversationServiceUrl,
                Enterprise_TrouterServiceUrl: cm.Enterprise_TrouterServiceUrl,
                Enterprise_RegistrarServiceUrl: cm.Enterprise_RegistrarServiceUrl,
                Enterprise_MdnTrapServiceUrl: cm.Enterprise_MdnTrapServiceUrl,
                Enterprise_MdnTrapServiceTokenUrl: cm.Enterprise_MdnTrapServiceTokenUrl,
                Enterprise_MdnTrapRelaySkypeFqdns: cm.Enterprise_MdnTrapRelaySkypeFqdns,
                Enterprise_MdnTrapRelayTurnFqdns: cm.Enterprise_MdnTrapRelayTurnFqdns,
                Enterprise_MdnTrapRelayTurnUrl: cm.Enterprise_MdnTrapRelayTurnUrl
            },
            applicationSettingsEudbUrls: {
                Public_ConversationServiceUrl_EUDB: lm.Public_ConversationServiceUrl_EUDB,
                Public_TrouterServiceUrl_EUDB: lm.Public_TrouterServiceUrl_EUDB,
                Public_RegistrarServiceUrl_EUDB: lm.Public_RegistrarServiceUrl_EUDB,
                Public_MdnTrapServiceUrl_EUDB: lm.Public_MdnTrapServiceUrl_EUDB,
                Public_MdnTrapServiceTokenUrl_EUDB: lm.Public_MdnTrapServiceTokenUrl_EUDB,
                Public_MdnTrapRelaySkypeFqdns_EUDB: lm.Public_MdnTrapRelaySkypeFqdns_EUDB,
                Public_MdnTrapRelayTurnFqdns_EUDB: lm.Public_MdnTrapRelayTurnFqdns_EUDB,
                Public_MdnTrapRelayTurnUrl_EUDB: lm.Public_MdnTrapRelayTurnUrl_EUDB,
                Enterprise_ConversationServiceUrl_EUDB: lm.Enterprise_ConversationServiceUrl_EUDB,
                Enterprise_TrouterServiceUrl_EUDB: lm.Enterprise_TrouterServiceUrl_EUDB,
                Enterprise_RegistrarServiceUrl_EUDB: lm.Enterprise_RegistrarServiceUrl_EUDB,
                Enterprise_MdnTrapServiceUrl_EUDB: lm.Enterprise_MdnTrapServiceUrl_EUDB,
                Enterprise_MdnTrapServiceTokenUrl_EUDB: lm.Enterprise_MdnTrapServiceTokenUrl_EUDB,
                Enterprise_MdnTrapRelaySkypeFqdns_EUDB: lm.Enterprise_MdnTrapRelaySkypeFqdns_EUDB,
                Enterprise_MdnTrapRelayTurnFqdns_EUDB: lm.Enterprise_MdnTrapRelayTurnFqdns_EUDB,
                Enterprise_MdnTrapRelayTurnUrl_EUDB: lm.Enterprise_MdnTrapRelayTurnUrl_EUDB
            },
            maxDisplayNameLength: 256,
            callDiagnostics: _m,
            eudb: {
                isEnabled: !0,
                countries: hm,
                regions: gm,
                defaultDataLocationEurope: !1,
                EmeaTenants: pm,
                ApacTenants: mm,
                NoamTenants: fm,
                acsCompliantEvents: {},
                isRgnClaimEnabledForACS: !0,
                sendRegionToNgc: !0
            },
            tfl: {
                isEnabled: !1,
                hosts: [
                    "teams.live.com"
                ]
            },
            remoteDiagnostic: {
                sourceEvents: [
                    "cameraStartTimedOut",
                    "speakingWhileMicrophoneIsMuted"
                ],
                exposedEvents: [
                    "cameraStartFailed",
                    ""
                ]
            },
            lobbyAdmitAndReject: {
                enabled: !0,
                supportedConversationTypes: [
                    "scheduledMeeting",
                    "adHocMeeting"
                ]
            },
            localRecording: {
                enabled: !0,
                supportedConversationTypes: [
                    "scheduledMeeting",
                    "adHocMeeting"
                ]
            },
            platformSupportValidation: !1,
            enableCustomTurnUsage: !1,
            allowProxyForTeamsCalls: !1,
            allowCustomTurnForTeamsCalls: !1,
            spotlight: {
                enabled: !0,
                maxSpotlightParticipants: 7,
                supportedRoles: [
                    "presenter",
                    "organizer",
                    "coorganizer"
                ],
                meetingTypes: [
                    "scheduledMeeting"
                ]
            },
            teamsMeetingAudioConferencing: {
                enabled: !0,
                supportedConversationTypes: [
                    "scheduledMeeting",
                    "adHocMeeting"
                ]
            },
            breakoutRooms: {
                enabled: !0,
                supportedConversationTypes: [
                    "scheduledMeeting"
                ],
                autoMoveInMilliSeconds: 3e3,
                hangUpCallDelayInMilliSeconds: 5e3
            },
            explicitConsentFeatureEnabled: {
                enabled: !0
            },
            transfer: {
                autoAccept: !0
            },
            reaction: {
                enabled: !0,
                telemetryEventAggregationIntervalInSecond: 3,
                enableStateServiceConsoleLogs: !0,
                StateServiceProxySettings: {
                    batchedRequestsEnabled: !1,
                    websocketAliveTimeAfterLoseFocusInMS: 3e4,
                    pingTimeoutInMs: 2e4,
                    pongTimeoutInMs: 5e3,
                    maxSessionRetries: 2,
                    offlineMessageCacheEnabled: !0,
                    maxOfflineMessageCacheLength: 64,
                    maxOfflineMessageCacheTimeInMs: 2e4,
                    autoRoutingEnabled: !0
                }
            },
            pptlive: {
                enabled: !0,
                wdParams: {
                    wdModernSlideShowInTeams: !0,
                    wdPresenterViewInTeams: !1,
                    wdForceModernSlideShowInTeams: !1,
                    isMovePrivateViewingToPPTEnabled: !0
                },
                appSettings: {
                    takeFocusOnBoot: !0,
                    enableAdvanceOnClick: !1,
                    enableAdvanceOnTap: !1
                },
                stateServiceProxySettings: {
                    batchedRequestsEnabled: !1,
                    maxRoundtripRaw: 300,
                    pingTimeoutInMs: 15e3,
                    pongTimeoutInMs: 15e3,
                    retryIntervalsInMs: [
                        1e3,
                        2e3,
                        4e3
                    ],
                    verbose: !1,
                    websocketAliveTimeAfterLoseFocusInMS: 3e4,
                    autoRoutingEnabled: !0,
                    useServiceGeneratedClientId: !0,
                    offlineMessageCacheEnabled: !0,
                    maxOfflineMessageCacheTimeInMs: 2e4,
                    maxOfflineMessageCacheLength: 64,
                    allowReconnectOnSendMessage: !0
                },
                enableStateServiceInPreviewerFeatures: '["Ink","Media","Nav","NavSync","PresUrl","PresUrlBoot"]',
                featureGates: '{"ModernSlideShowAllowListForFileType":"pptx;ppsx;potx;pptm;ppsm;pot;ppt;odp;pps"}'
            },
            togetherMode: {
                enable: !0,
                botId: Em,
                dataChannelId: 13,
                forceSeatMapRequest: !1,
                supportedConversationTypes: [
                    "scheduledMeeting",
                    "adHocMeeting",
                    "groupCall"
                ],
                mainVideo: {
                    scaledWidthRatio: .6,
                    scaledHeightRatio: .8
                }
            },
            checkHiddenBotOnCallStart: !0,
            blacklistedBots: [],
            musicOnHoldEnabled: !0,
            customContext: {
                userToUser: {
                    headerKey: "User-To-User"
                },
                xHeaders: {
                    headerKeyPrefix: "X-MS-Custom-",
                    headerKeyRegex: "^[a-zA-Z0-9.!%*_+~-]{1,64}$",
                    headerValueRegex: "^[a-zA-Z0-9.!%*_+~=;-]{1,256}$",
                    maxCount: 5
                }
            },
            watermark: {
                watermarkEnabledForAcsUsers: !0,
                watermarkEnabledForCteUsers: !0,
                watermarkDefaultOpacity: 30,
                watermarkDefaultPattern: "Tiled",
                enableAudioOnlyFallback: !0,
                watermarkMaxUsernameLength: 17,
                watermarkEmptyDisplayNamePlaceholder: "UnknownUser"
            },
            mediaAccess: {
                enabled: !0,
                ipMediaPolicyEnabled: !0,
                supportedRoles: [
                    "presenter",
                    "organizer",
                    "coorganizer"
                ],
                supportedConversationTypes: [
                    "scheduledMeeting",
                    "adHocMeeting",
                    "groupCall",
                    "huddleGroupCall",
                    "screenShareCall"
                ],
                supportedConversationTypesForMuteAll: [
                    "scheduledMeeting",
                    "adHocMeeting"
                ]
            }
        },
        teamsMeetingShortUrlJoin: {
            validatePattern: !0,
            regexPattern: "\\/meet\\/[^\\/\\?]+(\\?p=[^\\/\\?]+)?$"
        },
        dataChannel: {
            maxReceiveBufferSize: 2097152,
            receiveTimeoutInMs: 12e4,
            maxSendBandwidth: 5e5,
            maxBroadcastPacketRate: 80,
            defaultBitrate: 32e3,
            maxMessageSize: 32768,
            enableBroadcastLimitOnReliableChannel: !1,
            dataIdConfigs: []
        },
        unmixedAudio: {
            maxStreamSize: 7,
            operationTimeoutInMs: 1e4,
            skipProviderStateCheck: !1
        },
        roles: {
            acsOrganizer: Cm.AcsOrganizerRole,
            acsPresenter: Cm.AcsPresenterRole,
            acsAttendee: Cm.AcsAttendeeRole,
            acsConsumer: Cm.AcsConsumerRole,
            teamsAttendee: Cm.TeamsAttendee,
            teamsOrganizer: Cm.TeamsOrganizer,
            teamsPresenter: Cm.TeamsPresenter,
            teamsCoorganizer: Cm.TeamsCoorganizer
        },
        roomsRoleBasedCapabilities: {
            presenter: getDefaultCapabilities(BS.Rooms, "Presenter"),
            attendee: getDefaultCapabilities(BS.Rooms, "Attendee"),
            consumer: getDefaultCapabilities(BS.Rooms, "Consumer")
        },
        teamsRoleBasedCapabilities: {
            organizer: getDefaultCapabilities(BS.TeamsMeeting, "Organizer"),
            coorganizer: getDefaultCapabilities(BS.TeamsMeeting, "Co-organizer"),
            presenter: getDefaultCapabilities(BS.TeamsMeeting, "Presenter"),
            attendee: getDefaultCapabilities(BS.TeamsMeeting, "Attendee")
        },
        environments: {
            android: {
                chrome: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                edgeanaheim: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                }
            },
            ios: {
                safari: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                chrome: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: !getSdkVersion().includes("stable")
                },
                edgeanaheim: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: !getSdkVersion().includes("stable")
                },
                applewebview: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                }
            },
            mac: {
                chrome: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                safari: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                edgeanaheim: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                firefox: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: !getSdkVersion().includes("stable")
                }
            },
            windows: {
                chrome: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                chromium: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                edgeanaheim: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                firefox: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: !getSdkVersion().includes("stable")
                }
            },
            linux: {
                chrome: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: kf
                },
                firefox: {
                    minVersion: Nf,
                    isSupportedOnSdkVersion: !getSdkVersion().includes("stable")
                }
            }
        },
        MiddleTier: {
            enabled: !1,
            maxRetry: 3,
            baseServiceUrl: dm.baseServiceUrl,
            policyUrlSuffix: dm.policyUrlSuffix,
            policyUrlSuffixV2: dm.policyUrlSuffixV2,
            userPolicySettingsApi: !1,
            serverManagedThreadIdApiConfiguration: {
                allowServerThreadCreation: !0,
                decoupleChatThreadFromCalls: !0,
                createThreadSuffix: dm.createThreadSuffix,
                addParticipantSuffix: dm.addParticipantSuffix
            }
        },
        PowerPointStateServiceUrl: {
            public: {
                amer: "https://usc.pptservicescast.officeapps.live.com",
                apac: "https://apac.pptservicescast.officeapps.live.com",
                emea: "https://emea.pptservicescast.officeapps.live.com",
                uk: "https://ukc.pptservicescast.officeapps.live.com",
                eu: "https://euc.pptservicescast.officeapps.live.com",
                in: "https://inc.pptservicescast.officeapps.live.com",
                au: "https://auc.pptservicescast.officeapps.live.com",
                ca: "https://canc.pptservicescast.officeapps.live.com",
                fr: "https://fr.pptservicescast.officeapps.live.com",
                jp: "https://jpc.pptservicescast.officeapps.live.com",
                ae: "https://ae.pptservicescast.officeapps.live.com",
                kr: "https://krc.pptservicescast.officeapps.live.com",
                sg: "https://sg.pptservicescast.officeapps.live.com",
                za: "https://za.pptservicescast.officeapps.live.com",
                de: "https://de.pptservicescast.officeapps.live.com",
                ch: "https://ch.pptservicescast.officeapps.live.com",
                no: "https://no.pptservicescast.officeapps.live.com",
                br: "https://pptservicescast.officeapps.live.com",
                se: "https://se.pptservicescast.officeapps.live.com",
                qa: "https://qa.pptservicescast.officeapps.live.com",
                gallatin: "https://pptservicescast.osi.microsoftonline.cn",
                pl: "https://pl.pptservicescast.officeapps.live.com",
                it: "https://euc.pptservicescast.officeapps.live.com",
                il: "https://pptservicescast.officeapps.live.com",
                mx: "https://pptservicescast.officeapps.live.com"
            },
            gcc: "https://pptservicescast.gcc.osi.office365.us",
            gcch: "https://pptservicescast.osi.office365.us",
            dod: "https://pptservicescast.osi.apps.mil",
            ag08: "https://pptservicescast.osi.eaglex.ic.gov",
            ag09: "https://pptservicescast.osi.microsoft.scloud"
        }
    };
    let qS;
    function setAcsEcsConfig(g) {
        if (!g) throw new CallingCommunicationError({
            defaultError: O.INTERNAL.ECS_CONFIG_EMPTY
        });
        if (!g.AcsCallingSDKWeb) throw new CallingCommunicationError({
            defaultError: O.INTERNAL.ECS_CONFIG_MISSING_ACS
        });
        try {
            const f = GS.telemetry.deviceChangedEvents.piiSafeWords.slice();
            P.mergeWith(GS, g.AcsCallingSDKWeb, arrayMergeCustomizer);
            const S = GS.telemetry.deviceChangedEvents;
            "merge" === S.piiSafeWordsMode && (S.piiSafeWords = P.union(f, S.piiSafeWords));
        } catch (g) {
            throw new CallingCommunicationError({
                defaultError: O.INTERNAL.ECS_CONFIG_MERGING_ERROR
            });
        }
    }
    function getAcsEcsConfig() {
        return GS;
    }
    function setMediaConfig(g) {
        qS = g;
    }
    function getMediaConfig() {
        return qS;
    }
    function getDefaultCapabilities(g, f) {
        const S = {
            turnVideoOn: !0,
            unmuteMic: !0,
            shareScreen: !0,
            removeParticipant: !0,
            hangUpForEveryOne: !0,
            addCommunicationUser: !0,
            addTeamsUser: !0,
            addPhoneNumber: !0,
            manageLobby: !0,
            spotlightParticipant: !0,
            removeParticipantsSpotlight: !0,
            blurBackground: !0,
            startLiveMeetingCaptions: !0,
            startLiveCallingCaptions: !0,
            setCaptionLanguage: !0,
            raiseHand: !0,
            pstnDialOut: !0,
            muteOthers: !0,
            useReactions: !0,
            viewAttendeeNames: !0,
            startTogetherMode: !0,
            joinBreakoutRooms: !0,
            forbidOthersAudio: !0,
            forbidOthersVideo: !0
        };
        if (g == BS.TeamsMeeting) {
            if ("Co-organizer" == f || "Organizer" == f) return {
                ...S
            };
            if ("Presenter" == f) {
                const g = {
                    ...S
                };
                return g.hangUpForEveryOne = !1, g;
            }
            if ("Attendee" == f) {
                const g = {
                    ...S
                };
                return g.removeParticipant = !1, g.manageLobby = !1, g.spotlightParticipant = !1, g.removeParticipantsSpotlight = !1, g.shareScreen = !1, g.muteOthers = !1, g.hangUpForEveryOne = !1, g.startTogetherMode = !1, g.joinBreakoutRooms = !0, g.forbidOthersAudio = !1, g.forbidOthersVideo = !1, g;
            }
        }
        if (g == BS.Rooms) {
            const g = {
                ...S
            };
            if (g.removeParticipant = !1, g.hangUpForEveryOne = !1, g.addCommunicationUser = !1, g.addTeamsUser = !1, g.manageLobby = !1, g.spotlightParticipant = !1, g.removeParticipantsSpotlight = !1, g.blurBackground = !1, g.startLiveMeetingCaptions = !0, g.startLiveCallingCaptions = !0, g.setCaptionLanguage = !1, g.raiseHand = !1, g.startTogetherMode = !1, g.joinBreakoutRooms = !1, g.forbidOthersAudio = !1, g.forbidOthersVideo = !1, "Presenter" == f) return {
                ...g
            };
            if ("Attendee" == f) {
                const f = {
                    ...g
                };
                return f.shareScreen = !1, f.muteOthers = !1, f.addPhoneNumber = !1, f.pstnDialOut = !1, f;
            }
            if ("Consumer" == f) {
                const f = {
                    ...g
                };
                return f.turnVideoOn = !1, f.unmuteMic = !1, f.shareScreen = !1, f.muteOthers = !1, f.addPhoneNumber = !1, f.pstnDialOut = !1, f;
            }
        }
        return S;
    }
    const WS = [
        "response",
        "responseText",
        "responseURL",
        "status",
        "state",
        "statusText",
        "timeout",
        "withCredentials",
        "stack",
        "message",
        "name",
        "error",
        "piiSafe",
        "phase",
        "code",
        "participantId",
        "phrase",
        "subCode",
        "reason"
    ];
    function toTsScalingMode(g) {
        switch(g){
            case "Crop":
                return 1;
            case "Fit":
                return 2;
            default:
                return 0;
        }
    }
    function stringifyObject(g) {
        return g.toString === Object.prototype.toString ? JSON.stringify(g) : g.toString();
    }
    function getSizeInBytes(g, f) {
        try {
            return "string" == typeof g ? new Blob([
                g
            ]).size : g.byteLength;
        } catch (g) {
            return f.error(g), 0;
        }
    }
    function shallowEqual(g, f) {
        const S = Object.keys(g);
        for (let v of S)if (g[v] !== f[v]) return !1;
        return !0;
    }
    function convertMapToFrozenJson(g) {
        let f = {};
        return g.forEach((g, S)=>{
            f[S] = g;
        }), Object.freeze(f);
    }
    function defer() {
        let g, f, S = !0;
        return {
            isPending: ()=>S,
            promise: new Promise((S, v)=>{
                g = S, f = v;
            }),
            resolve: (f)=>{
                S && (g(f), S = !1);
            },
            reject: (g)=>{
                S && (f(g), S = !1);
            },
            dispose: ()=>{
                S && (f("disposed"), S = !1);
            }
        };
    }
    function timedDefer(g, f = "Timed promise; rejected.") {
        let S, v, _, C = !0;
        const timerStart = ()=>{
            _ = window.setTimeout(()=>{
                v(new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.EFFECT_PROVIDER_TIMEOUT
                }));
            }, g);
        }, timerStop = ()=>{
            window.clearTimeout(_);
        };
        let E = new Promise((g, f)=>{
            S = (f)=>{
                timerStop(), C = !1, g(f);
            }, v = (g)=>{
                timerStop(), C = !1, f(g);
            };
        });
        return {
            timerStart: timerStart,
            timerStop: timerStop,
            deferredPromise: {
                promise: E,
                resolve: S,
                reject: v,
                isPending: ()=>C,
                dispose: ()=>{
                    v("disposed");
                }
            }
        };
    }
    function assertNotNull(g, f) {
        if (null == g) throw new CallingCommunicationError({
            defaultError: f
        });
    }
    function assertIsObject(g, f) {
        if ("object" != typeof g) throw new CallingCommunicationError({
            defaultError: f
        });
    }
    function parseJWT(g) {
        let [, f] = g === null || g === void 0 ? void 0 : g.split(".");
        if (void 0 === f) throw new CallingCommunicationError({
            defaultError: O.INTERNAL.TOKEN_PAYLOAD_UNDEFINED
        });
        return f = f.replace(/-/g, "+").replace(/_/g, "/"), JSON.parse(decodeURIComponent(escape(atob(f))));
    }
    function logErrorAndThrow(g, f) {
        throw f.error(`CallingCommunicationError: Message={${g.message},Code={${g.code}}, SubCode={${g.subCode}}, ResultCategories={${g.resultCategories}}`), new CallingCommunicationError({
            defaultError: g
        });
    }
    function noop() {}
    function isEudbLocation(g, f) {
        const S = getGeoLocations(g);
        return !!f && !!S.find((g)=>g === f);
    }
    function isEudbConfigurationsApplicable(g, f) {
        return getAcsEcsConfig().calling.eudb.isEnabled && isEudbLocation(g, f || "");
    }
    function isRgnClaimApplicable(g) {
        return getAcsEcsConfig().calling.eudb.isRgnClaimEnabledForACS || !!g && g === um.Enterprise || !1;
    }
    function getGeoLocations(g) {
        return isRgnClaimApplicable(g) ? getAcsEcsConfig().calling.eudb.regions : getAcsEcsConfig().calling.eudb.countries;
    }
    async function parseTokenCredential(g, f, S) {
        let v;
        try {
            if (!g) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.NO_TOKEN_PROVIDED
            });
            try {
                var _this;
                v = (_this = await g.getToken(S)) === null || _this === void 0 ? void 0 : _this.token;
            } catch (g) {
                throw new CallingCommunicationError("The token returned from the tokenRefresher is expired." === g.message ? {
                    defaultError: O.CALL_AGENT.ACCESSTOKEN_EXPIRED
                } : {
                    defaultError: O.INTERNAL.GET_TOKEN
                });
            }
            if (!v) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.EMPTY_TOKEN
            });
        } catch (g) {
            throw new CallingCommunicationError({
                defaultError: O.INTERNAL.GET_TOKEN,
                originalError: g
            });
        }
        try {
            let g = parseJWT(v);
            if (!g) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.TOKEN_UNDEFINED
            });
            if ("string" != typeof g.acsScope) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.INVALID_TOKEN_SCOPE_FORMAT
            });
            if (!g.acsScope.split(",").find((g)=>"voip" === g || "voip.join" === g)) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.INVALID_TOKEN_SCOPE
            });
            const S = g.resourceId, _ = constructIdentifierKindFromMri(`8:${g.skypeid}`);
            if (!S && !("microsoftTeamsUser" === (_ === null || _ === void 0 ? void 0 : _.kind))) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.RESOURCE_NOT_FOUND_IN_TOKEN
            });
            let C = g.skypeid;
            if (!C) throw new CallingCommunicationError({
                defaultError: O.INTERNAL.USERID_NOT_FOUND_IN_TOKEN
            });
            const E = getCloudTypeFromSkypeId(C), T = !!g.tid, I = !!g.rgn;
            return {
                jwtToken: v,
                acsResourceId: S,
                identityMri: C,
                cloudType: E,
                isCte: T,
                region: (T || f ? g.rgn : g.resourceLocation) || "",
                rgnClaimExists: I,
                exp: 1e3 * g.exp
            };
        } catch (g) {
            throw new CallingCommunicationError({
                defaultError: O.INTERNAL.PARSE_TOKEN_FAIL,
                originalError: g
            });
        }
    }
    function buildCallingUserAgent(g, f, S) {
        var _S_diagnostics, _S_diagnostics1, _S_diagnostics2, _S_diagnostics3, _S_diagnostics4;
        const v = `azsdk-js-communication-calling/${g}`;
        let _ = "";
        if (S === null || S === void 0 ? void 0 : (_S_diagnostics = S.diagnostics) === null || _S_diagnostics === void 0 ? void 0 : _S_diagnostics.appName) {
            var _S_diagnostics5;
            let g = S === null || S === void 0 ? void 0 : (_S_diagnostics5 = S.diagnostics) === null || _S_diagnostics5 === void 0 ? void 0 : _S_diagnostics5.appName.trim().replace(/\s/g, "_");
            g.length > 64 && (f.warn("appName is too long, max allowed length is 64 chars, appName was truncated to max length"), g = g.substr(0, 64)), _ += g ? `${g}/` : "default/";
        } else _ += "default/";
        if (S === null || S === void 0 ? void 0 : (_S_diagnostics1 = S.diagnostics) === null || _S_diagnostics1 === void 0 ? void 0 : _S_diagnostics1.appVersion) {
            var _S_diagnostics6;
            let g = S === null || S === void 0 ? void 0 : (_S_diagnostics6 = S.diagnostics) === null || _S_diagnostics6 === void 0 ? void 0 : _S_diagnostics6.appVersion.trim().replace(/\s/g, "_");
            g.length > 64 && (f.warn("appVersion is too long, max allowed length is 64 chars, appVersion was truncated to max length"), g = g.substr(0, 64)), _ += g || "0.0.0";
        } else _ += "0.0.0";
        if (_ += ` ${v}`, (S === null || S === void 0 ? void 0 : (_S_diagnostics2 = S.diagnostics) === null || _S_diagnostics2 === void 0 ? void 0 : _S_diagnostics2.tags) && Array.isArray(S === null || S === void 0 ? void 0 : (_S_diagnostics3 = S.diagnostics) === null || _S_diagnostics3 === void 0 ? void 0 : _S_diagnostics3.tags) && (S === null || S === void 0 ? void 0 : (_S_diagnostics4 = S.diagnostics) === null || _S_diagnostics4 === void 0 ? void 0 : _S_diagnostics4.tags.length) > 0) {
            var _S_diagnostics7;
            let g = S === null || S === void 0 ? void 0 : (_S_diagnostics7 = S.diagnostics) === null || _S_diagnostics7 === void 0 ? void 0 : _S_diagnostics7.tags.map((g)=>g.trim().replace(/\s/g, "_")).filter((g)=>!!g).join(";");
            g.length > 128 && (f.warn("tags are too long, max allowed length is 128 chars, tags were truncated to max length"), g = g.substr(0, 128)), g.length > 0 && (_ += " (" + g + ").");
        }
        return _;
    }
    function getJoinContextDescription(g) {
        return g ? g.groupId ? aS.GroupCall : !g.threadId || g.organizerId || g.tenantId || g.messageId ? g.threadId && g.organizerId && g.tenantId && g.messageId ? aS.TeamsCoordinates : g.meetingId ? aS.TeamsMeetingId : g.meetingLink ? aS.TeamsMeetingLink : g.roomId ? aS.RoomCall : aS.Unknown : aS.GroupChatCall : aS.Unknown;
    }
    function getPrintableObject(g, f = !1) {
        const processStackTrace = (g)=>{
            try {
                return g.split("\n")[0];
            } catch (g) {
                return "invalid stack";
            }
        };
        if (void 0 === g) return "void";
        if (g instanceof Error) return g.toString();
        if (g instanceof String || g instanceof Number || g instanceof Boolean) return g.toString();
        try {
            return g.stack && (g.stack = processStackTrace(g.stack)), (f ? JSON.stringify(g) : JSON.stringify(g, WS, 4)).replace(/(\r\n\t|\n|\r\t|\s)/gm, "");
        } catch (f) {
            return `failed to get error information:${g && "function" == typeof g.toString && g.toString()} ${g && g.response && JSON.stringify(g.response)}`;
        }
    }
    function permissionStateToBool(g, f) {
        return f.info("permission state to boolean", g), "granted" === g;
    }
    function getSafeObjectDiff(g, f, S = []) {
        let v = [];
        try {
            const _ = Array.isArray(g);
            for(const C in g){
                const E = g[C], T = _ ? +C : C;
                if (!(C in f)) {
                    v.push({
                        type: "REMOVE",
                        path: [
                            T
                        ],
                        oldValue: g[C]
                    });
                    continue;
                }
                const I = f[C], b = "object" == typeof E && "object" == typeof I;
                if (E && I && b && !V[Object.getPrototypeOf(E).constructor.name] && !S.includes(E)) {
                    const g = getSafeObjectDiff(E, I);
                    v.push.apply(v, g.map((g)=>(g.path.unshift(T), g)));
                } else E === I || b && (isNaN(E) ? E + "" == I + "" : +E == +I) || v.push({
                    path: [
                        T
                    ],
                    type: "CHANGE",
                    value: I,
                    oldValue: E
                });
            }
            const C = Array.isArray(f);
            for(const S in f)S in g || v.push({
                type: "CREATE",
                path: [
                    C ? +S : S
                ],
                value: f[S]
            });
        } catch (g) {}
        return v;
    }
    function advancedMeetingRoleToParticipantRole(g, f) {
        const S = {
            [g.roles.acsOrganizer.toLowerCase()]: sS.Organizer,
            [g.roles.teamsOrganizer.toLowerCase()]: sS.Organizer,
            [g.roles.acsPresenter.toLowerCase()]: sS.Presenter,
            [g.roles.teamsPresenter.toLowerCase()]: sS.Presenter,
            [g.roles.acsAttendee.toLowerCase()]: sS.Attendee,
            [g.roles.teamsAttendee.toLowerCase()]: sS.Attendee,
            [g.roles.acsConsumer.toLowerCase()]: sS.Consumer,
            [g.roles.teamsCoorganizer.toLowerCase()]: sS.Coorganizer
        };
        return f && S[f.toString().toLowerCase()] ? S[f.toString().toLowerCase()] : sS.Unknown;
    }
    function hasMeetingDetailsChanged(g, f) {
        return null == f.meetingCapability && null != g.meetingCapability || null == f.capabilities && null != g.capabilities || !(P.isEqual(f.capabilities, g.capabilities) && P.isEqual(f.meetingCapability, g.meetingCapability) && P.isEqual(f.recordingConsentDetails, g.recordingConsentDetails));
    }
    function hasCoreMeetingCapabilitiesChanged(g, f) {
        var _f_capabilities, _f_meetingCapability, _f_meetingCapability1, _f_meetingCapability2, _f_meetingCapability3, _f_meetingCapability4, _f_meetingCapability5, _f_meetingCapability6, _f_meetingCapability7, _f_meetingCapability8, _f_meetingCapability9, _f_meetingCapability10, _f_meetingCapability11, _f_meetingCapability12, _f_capabilities1, _f_capabilities2, _f_recordingConsentDetails;
        return !(!g.capabilities || null == g.capabilities.allowVideo || null != ((_f_capabilities = f.capabilities) === null || _f_capabilities === void 0 ? void 0 : _f_capabilities.allowVideo) && f.capabilities.allowVideo == g.capabilities.allowVideo) || !(!g.meetingCapability || null == g.meetingCapability.allowIPVideo || null != ((_f_meetingCapability = f.meetingCapability) === null || _f_meetingCapability === void 0 ? void 0 : _f_meetingCapability.allowIPVideo) && f.meetingCapability.allowIPVideo == g.meetingCapability.allowIPVideo) || !(!g.meetingCapability || null == g.meetingCapability.attendeeRestrictions || null != ((_f_meetingCapability1 = f.meetingCapability) === null || _f_meetingCapability1 === void 0 ? void 0 : _f_meetingCapability1.attendeeRestrictions) && f.meetingCapability.attendeeRestrictions == g.meetingCapability.attendeeRestrictions) || !(!g.meetingCapability || null == g.meetingCapability.allowPstnConferencing || null != ((_f_meetingCapability2 = f.meetingCapability) === null || _f_meetingCapability2 === void 0 ? void 0 : _f_meetingCapability2.allowPstnConferencing) && f.meetingCapability.allowPstnConferencing == g.meetingCapability.allowPstnConferencing) || !(!g.meetingCapability || null == g.meetingCapability.allowTranslatedCaptions || null != ((_f_meetingCapability3 = f.meetingCapability) === null || _f_meetingCapability3 === void 0 ? void 0 : _f_meetingCapability3.allowTranslatedCaptions) && ((_f_meetingCapability4 = f.meetingCapability) === null || _f_meetingCapability4 === void 0 ? void 0 : _f_meetingCapability4.allowTranslatedCaptions) == g.meetingCapability.allowTranslatedCaptions) || !(!g.meetingCapability || null == g.meetingCapability.allowTranslatedTranscriptions || null != ((_f_meetingCapability5 = f.meetingCapability) === null || _f_meetingCapability5 === void 0 ? void 0 : _f_meetingCapability5.allowTranslatedTranscriptions) && ((_f_meetingCapability6 = f.meetingCapability) === null || _f_meetingCapability6 === void 0 ? void 0 : _f_meetingCapability6.allowTranslatedTranscriptions) == g.meetingCapability.allowTranslatedTranscriptions) || !(!g.meetingCapability || null == g.meetingCapability.allowRaiseHands || null != ((_f_meetingCapability7 = f.meetingCapability) === null || _f_meetingCapability7 === void 0 ? void 0 : _f_meetingCapability7.allowRaiseHands) && ((_f_meetingCapability8 = f.meetingCapability) === null || _f_meetingCapability8 === void 0 ? void 0 : _f_meetingCapability8.allowRaiseHands) == g.meetingCapability.allowRaiseHands) || !(!g.meetingCapability || null == g.meetingCapability.allowTeamsMeetingReactions || null != ((_f_meetingCapability9 = f.meetingCapability) === null || _f_meetingCapability9 === void 0 ? void 0 : _f_meetingCapability9.allowTeamsMeetingReactions) && ((_f_meetingCapability10 = f.meetingCapability) === null || _f_meetingCapability10 === void 0 ? void 0 : _f_meetingCapability10.allowTeamsMeetingReactions) == g.meetingCapability.allowTeamsMeetingReactions) || !(!g.meetingCapability || null == g.meetingCapability.presenterOption || null != ((_f_meetingCapability11 = f.meetingCapability) === null || _f_meetingCapability11 === void 0 ? void 0 : _f_meetingCapability11.presenterOption) && ((_f_meetingCapability12 = f.meetingCapability) === null || _f_meetingCapability12 === void 0 ? void 0 : _f_meetingCapability12.presenterOption) == g.meetingCapability.presenterOption) || !(!g.capabilities || null == g.capabilities.maskIdentitiesForRole || null != ((_f_capabilities1 = f.capabilities) === null || _f_capabilities1 === void 0 ? void 0 : _f_capabilities1.maskIdentitiesForRole) && ((_f_capabilities2 = f.capabilities) === null || _f_capabilities2 === void 0 ? void 0 : _f_capabilities2.maskIdentitiesForRole) == g.capabilities.maskIdentitiesForRole) || !(!g.recordingConsentDetails || null == g.recordingConsentDetails.consentActivelyRequired || null != ((_f_recordingConsentDetails = f.recordingConsentDetails) === null || _f_recordingConsentDetails === void 0 ? void 0 : _f_recordingConsentDetails.consentActivelyRequired) && f.recordingConsentDetails.consentActivelyRequired == g.recordingConsentDetails.consentActivelyRequired);
    }
    function getTotalNotBotParticipantCount(g) {
        let f = 1;
        if (g.participantCounts && g.participantCounts.totalParticipants > 0 && (f = g.participantCounts.totalParticipants), g.participants) f -= g.participants.filter((g)=>isHiddenBot(g)).length;
        return f;
    }
    function isHiddenBot(g) {
        if (isCallingApplication(g.id)) {
            var _getAcsEcsConfig_calling_blacklistedBots, _getAcsEcsConfig_calling, _getAcsEcsConfig, _g_endpoints, _g_endpoints1, _g_endpoints_endpointDetails__endpointMetadata___platform_ui, _g_endpoints_endpointDetails__endpointMetadata___platform, _g_endpoints_endpointDetails__endpointMetadata, _g_endpoints2;
            if (isGlobalCallingApplication(g.id)) return !0;
            if ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : (_getAcsEcsConfig_calling_blacklistedBots = _getAcsEcsConfig_calling.blacklistedBots) === null || _getAcsEcsConfig_calling_blacklistedBots === void 0 ? void 0 : _getAcsEcsConfig_calling_blacklistedBots.includes(g.id)) return !0;
            if (((_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails) && ((_g_endpoints1 = g.endpoints) === null || _g_endpoints1 === void 0 ? void 0 : _g_endpoints1.endpointDetails.length) > 0) return (_g_endpoints2 = g.endpoints) === null || _g_endpoints2 === void 0 ? void 0 : (_g_endpoints_endpointDetails__endpointMetadata = _g_endpoints2.endpointDetails[0].endpointMetadata) === null || _g_endpoints_endpointDetails__endpointMetadata === void 0 ? void 0 : (_g_endpoints_endpointDetails__endpointMetadata___platform = _g_endpoints_endpointDetails__endpointMetadata.__platform) === null || _g_endpoints_endpointDetails__endpointMetadata___platform === void 0 ? void 0 : (_g_endpoints_endpointDetails__endpointMetadata___platform_ui = _g_endpoints_endpointDetails__endpointMetadata___platform.ui) === null || _g_endpoints_endpointDetails__endpointMetadata___platform_ui === void 0 ? void 0 : _g_endpoints_endpointDetails__endpointMetadata___platform_ui.hidden;
        }
        return !1;
    }
    function isProxyAndCustomTurnAllowed(g, f, S, v, _) {
        if (S || v && "microsoftTeamsUser" === v.kind || _ && callContextHasTeamsJoinOptions(_)) {
            const S = getAcsEcsConfig().calling.allowProxyForTeamsCalls, v = g.proxyInUse, _ = getAcsEcsConfig().calling.allowCustomTurnForTeamsCalls, C = f.customRelayManagerInUse;
            if (v && !S) return !1;
            if (C && !_) return !1;
        }
        return !0;
    }
    function isAcsTeamParticipantPresentInCall(f, v) {
        let _ = v == g.CallAgentKind.TeamsCallAgent ? "communicationUser" : "microsoftTeamsUser";
        return !!f.find((g)=>S.getIdentifierKind(g).kind === _);
    }
    function isAcsThreadlessId(g) {
        return g.startsWith(U);
    }
    function callContextHasTeamsJoinOptions(g) {
        return !!(g.meetingId || g.meetingLink || g.messageId || g.organizerId || g.tenantId || g.threadId);
    }
    function initializeUfdsCorrelationIdCache() {
        return {
            1: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            2: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            3: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            4: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            5: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            6: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            7: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            8: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            9: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            10: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            11: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            12: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            13: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            14: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            15: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            16: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            17: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            18: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            19: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            20: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            21: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            22: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            23: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            24: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            25: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            26: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            27: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            28: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            29: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            30: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            31: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            32: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            33: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            34: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            35: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            36: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            37: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            38: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            39: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            40: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            41: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            42: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            43: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            44: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            45: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            46: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            47: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            48: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            49: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            50: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            51: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            52: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            53: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            54: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            55: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            56: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            57: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            58: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            59: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            60: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            61: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            62: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            63: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            64: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            65: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            80: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            66: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            67: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            68: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            69: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            70: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            71: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            72: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            73: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            74: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            75: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            76: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            77: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            78: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            },
            79: {
                0: void 0,
                1: void 0,
                2: void 0,
                3: void 0
            }
        };
    }
    function processCustomContext(g) {
        if (!g || !g.customContext) return;
        const f = {}, S = {};
        if (g.customContext.userToUser && (f[getAcsEcsConfig().calling.customContext.userToUser.headerKey] = g.customContext.userToUser), g.customContext.xHeaders && !g.customContext.sipHeaders) {
            const S = getAcsEcsConfig().calling.customContext.xHeaders.headerKeyPrefix, v = new RegExp(getAcsEcsConfig().calling.customContext.xHeaders.headerKeyRegex), _ = new RegExp(getAcsEcsConfig().calling.customContext.xHeaders.headerValueRegex);
            g.customContext.xHeaders.forEach((g)=>{
                const f = g.key.toLowerCase().startsWith(S.toLowerCase());
                g.key = f ? `${S}${g.key.slice(S.length)}` : `${S}${g.key}`;
            }), g.customContext.xHeaders.filter((g)=>v.test(g.key) && _.test(g.value)).slice(0, getAcsEcsConfig().calling.customContext.xHeaders.maxCount).forEach((g)=>f[g.key] = g.value);
        }
        if (g.customContext.sipHeaders) {
            const S = getAcsEcsConfig().calling.customContext.xHeaders.headerKeyPrefix, v = new RegExp(getAcsEcsConfig().calling.customContext.xHeaders.headerKeyRegex), _ = new RegExp(getAcsEcsConfig().calling.customContext.xHeaders.headerValueRegex);
            g.customContext.sipHeaders.forEach((g)=>{
                const f = g.key.toLowerCase().startsWith(S.toLowerCase());
                g.key = f ? `${S}${g.key.slice(S.length)}` : `${S}${g.key}`;
            }), g.customContext.sipHeaders.filter((g)=>v.test(g.key) && _.test(g.value)).slice(0, getAcsEcsConfig().calling.customContext.xHeaders.maxCount).forEach((g)=>f[g.key] = g.value);
        }
        g.customContext.voipHeaders && g.customContext.voipHeaders.forEach((g)=>S[g.key] = g.value);
        const v = {};
        return Object.keys(f).length > 0 && (v.sipHeaders = f), Object.keys(S).length > 0 && (v.voipHeaders = S), Object.keys(f).length > 0 || Object.keys(S).length > 0 ? v : void 0;
    }
    function parseCustomContext(g) {
        return parseCustomContextInner(g.customHeaderContext) || parseCustomContextInner(g.clientTransferContext);
    }
    function parseCustomContextInner(g) {
        var _g_customContext, _g_customContext1, _I_xHeaders, _I_sipHeaders, _I_voipHeaders;
        if (!g) return;
        const f = g.sipHeaders || ((_g_customContext = g.customContext) === null || _g_customContext === void 0 ? void 0 : _g_customContext.sipHeaders), S = g.voipHeaders || ((_g_customContext1 = g.customContext) === null || _g_customContext1 === void 0 ? void 0 : _g_customContext1.voipHeaders);
        if (!f && !S) return;
        const v = getAcsEcsConfig().calling.customContext.userToUser.headerKey, _ = getAcsEcsConfig().calling.customContext.xHeaders.headerKeyPrefix, C = f && Object.entries(f).find((g)=>{
            var _g_;
            return ((_g_ = g[0]) === null || _g_ === void 0 ? void 0 : _g_.toLowerCase()) === v.toLowerCase();
        }), E = f && Object.entries(f).filter((g)=>{
            var _g_;
            return (_g_ = g[0]) === null || _g_ === void 0 ? void 0 : _g_.toLowerCase().startsWith(_ === null || _ === void 0 ? void 0 : _.toLowerCase());
        }).map((g)=>({
                key: g[0],
                value: g[1]
            })), T = S && Object.entries(S).map((g)=>({
                key: g[0],
                value: g[1]
            })), I = {};
        f && C && (I.userToUser = C[1]), E && E.length > 0 && (I.xHeaders = E, I.sipHeaders = E), T && T.length > 0 && (I.voipHeaders = T);
        return void 0 === I.userToUser && 0 === ((_I_xHeaders = I.xHeaders) === null || _I_xHeaders === void 0 ? void 0 : _I_xHeaders.length) && 0 === ((_I_sipHeaders = I.sipHeaders) === null || _I_sipHeaders === void 0 ? void 0 : _I_sipHeaders.length) && 0 === ((_I_voipHeaders = I.voipHeaders) === null || _I_voipHeaders === void 0 ? void 0 : _I_voipHeaders.length) ? void 0 : I;
    }
    var zS = createCommonjsModule(function(g, f) {
        var S = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
        f.assign = function(g) {
            for(var f = Array.prototype.slice.call(arguments, 1); f.length;){
                var S = f.shift();
                if (S) {
                    if ("object" != typeof S) throw new TypeError(S + "must be non-object");
                    for(var v in S)S.hasOwnProperty(v) && (g[v] = S[v]);
                }
            }
            return g;
        }, f.shrinkBuf = function(g, f) {
            return g.length === f ? g : g.subarray ? g.subarray(0, f) : (g.length = f, g);
        };
        var v = {
            arraySet: function(g, f, S, v, _) {
                if (f.subarray && g.subarray) g.set(f.subarray(S, S + v), _);
                else for(var C = 0; C < v; C++)g[_ + C] = f[S + C];
            },
            flattenChunks: function(g) {
                var f, S, v, _, C, E;
                for(v = 0, f = 0, S = g.length; f < S; f++)v += g[f].length;
                for(E = new Uint8Array(v), _ = 0, f = 0, S = g.length; f < S; f++)C = g[f], E.set(C, _), _ += C.length;
                return E;
            }
        }, _ = {
            arraySet: function(g, f, S, v, _) {
                for(var C = 0; C < v; C++)g[_ + C] = f[S + C];
            },
            flattenChunks: function(g) {
                return [].concat.apply([], g);
            }
        };
        f.setTyped = function(g) {
            g ? (f.Buf8 = Uint8Array, f.Buf16 = Uint16Array, f.Buf32 = Int32Array, f.assign(f, v)) : (f.Buf8 = Array, f.Buf16 = Array, f.Buf32 = Array, f.assign(f, _));
        }, f.setTyped(S);
    }), KS = 4, JS = 0, YS = 1, QS = 2;
    function zero(g) {
        for(var f = g.length; --f >= 0;)g[f] = 0;
    }
    var XS = 0, ZS = 1, ev = 2, tv = 3, iv = 258, nv = 29, rv = 256, av = rv + 1 + nv, sv = 30, ov = 19, lv = 2 * av + 1, cv = 15, dv = 16, uv = 7, hv = 256, gv = 16, pv = 17, mv = 18, fv = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        2,
        2,
        2,
        2,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        5,
        5,
        5,
        5,
        0
    ], Sv = [
        0,
        0,
        0,
        0,
        1,
        1,
        2,
        2,
        3,
        3,
        4,
        4,
        5,
        5,
        6,
        6,
        7,
        7,
        8,
        8,
        9,
        9,
        10,
        10,
        11,
        11,
        12,
        12,
        13,
        13
    ], vv = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        3,
        7
    ], _v = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ], Cv = 512, yv = new Array(2 * (av + 2));
    zero(yv);
    var Ev = new Array(2 * sv);
    zero(Ev);
    var Tv = new Array(Cv);
    zero(Tv);
    var Iv = new Array(iv - tv + 1);
    zero(Iv);
    var bv = new Array(nv);
    zero(bv);
    var Av, Rv, Pv, wv = new Array(sv);
    function StaticTreeDesc(g, f, S, v, _) {
        this.static_tree = g, this.extra_bits = f, this.extra_base = S, this.elems = v, this.max_length = _, this.has_stree = g && g.length;
    }
    function TreeDesc(g, f) {
        this.dyn_tree = g, this.max_code = 0, this.stat_desc = f;
    }
    function d_code(g) {
        return g < 256 ? Tv[g] : Tv[256 + (g >>> 7)];
    }
    function put_short(g, f) {
        g.pending_buf[g.pending++] = 255 & f, g.pending_buf[g.pending++] = f >>> 8 & 255;
    }
    function send_bits(g, f, S) {
        g.bi_valid > dv - S ? (g.bi_buf |= f << g.bi_valid & 65535, put_short(g, g.bi_buf), g.bi_buf = f >> dv - g.bi_valid, g.bi_valid += S - dv) : (g.bi_buf |= f << g.bi_valid & 65535, g.bi_valid += S);
    }
    function send_code(g, f, S) {
        send_bits(g, S[2 * f], S[2 * f + 1]);
    }
    function bi_reverse(g, f) {
        var S = 0;
        do S |= 1 & g, g >>>= 1, S <<= 1;
        while (--f > 0);
        return S >>> 1;
    }
    function bi_flush(g) {
        16 === g.bi_valid ? (put_short(g, g.bi_buf), g.bi_buf = 0, g.bi_valid = 0) : g.bi_valid >= 8 && (g.pending_buf[g.pending++] = 255 & g.bi_buf, g.bi_buf >>= 8, g.bi_valid -= 8);
    }
    function gen_bitlen(g, f) {
        var S, v, _, C, E, T, I = f.dyn_tree, b = f.max_code, A = f.stat_desc.static_tree, R = f.stat_desc.has_stree, P = f.stat_desc.extra_bits, w = f.stat_desc.extra_base, M = f.stat_desc.max_length, O = 0;
        for(C = 0; C <= cv; C++)g.bl_count[C] = 0;
        for(I[2 * g.heap[g.heap_max] + 1] = 0, S = g.heap_max + 1; S < lv; S++)(C = I[2 * I[2 * (v = g.heap[S]) + 1] + 1] + 1) > M && (C = M, O++), I[2 * v + 1] = C, v > b || (g.bl_count[C]++, E = 0, v >= w && (E = P[v - w]), T = I[2 * v], g.opt_len += T * (C + E), R && (g.static_len += T * (A[2 * v + 1] + E)));
        if (0 !== O) {
            do {
                for(C = M - 1; 0 === g.bl_count[C];)C--;
                g.bl_count[C]--, g.bl_count[C + 1] += 2, g.bl_count[M]--, O -= 2;
            }while (O > 0);
            for(C = M; 0 !== C; C--)for(v = g.bl_count[C]; 0 !== v;)(_ = g.heap[--S]) > b || (I[2 * _ + 1] !== C && (g.opt_len += (C - I[2 * _ + 1]) * I[2 * _], I[2 * _ + 1] = C), v--);
        }
    }
    function gen_codes(g, f, S) {
        var v, _, C = new Array(cv + 1), E = 0;
        for(v = 1; v <= cv; v++)C[v] = E = E + S[v - 1] << 1;
        for(_ = 0; _ <= f; _++){
            var T = g[2 * _ + 1];
            0 !== T && (g[2 * _] = bi_reverse(C[T]++, T));
        }
    }
    function tr_static_init() {
        var g, f, S, v, _, C = new Array(cv + 1);
        for(S = 0, v = 0; v < nv - 1; v++)for(bv[v] = S, g = 0; g < 1 << fv[v]; g++)Iv[S++] = v;
        for(Iv[S - 1] = v, _ = 0, v = 0; v < 16; v++)for(wv[v] = _, g = 0; g < 1 << Sv[v]; g++)Tv[_++] = v;
        for(_ >>= 7; v < sv; v++)for(wv[v] = _ << 7, g = 0; g < 1 << Sv[v] - 7; g++)Tv[256 + _++] = v;
        for(f = 0; f <= cv; f++)C[f] = 0;
        for(g = 0; g <= 143;)yv[2 * g + 1] = 8, g++, C[8]++;
        for(; g <= 255;)yv[2 * g + 1] = 9, g++, C[9]++;
        for(; g <= 279;)yv[2 * g + 1] = 7, g++, C[7]++;
        for(; g <= 287;)yv[2 * g + 1] = 8, g++, C[8]++;
        for(gen_codes(yv, av + 1, C), g = 0; g < sv; g++)Ev[2 * g + 1] = 5, Ev[2 * g] = bi_reverse(g, 5);
        Av = new StaticTreeDesc(yv, fv, rv + 1, av, cv), Rv = new StaticTreeDesc(Ev, Sv, 0, sv, cv), Pv = new StaticTreeDesc(new Array(0), vv, 0, ov, uv);
    }
    function init_block(g) {
        var f;
        for(f = 0; f < av; f++)g.dyn_ltree[2 * f] = 0;
        for(f = 0; f < sv; f++)g.dyn_dtree[2 * f] = 0;
        for(f = 0; f < ov; f++)g.bl_tree[2 * f] = 0;
        g.dyn_ltree[2 * hv] = 1, g.opt_len = g.static_len = 0, g.last_lit = g.matches = 0;
    }
    function bi_windup(g) {
        g.bi_valid > 8 ? put_short(g, g.bi_buf) : g.bi_valid > 0 && (g.pending_buf[g.pending++] = g.bi_buf), g.bi_buf = 0, g.bi_valid = 0;
    }
    function copy_block(g, f, S, v) {
        bi_windup(g), v && (put_short(g, S), put_short(g, ~S)), zS.arraySet(g.pending_buf, g.window, f, S, g.pending), g.pending += S;
    }
    function smaller(g, f, S, v) {
        var _ = 2 * f, C = 2 * S;
        return g[_] < g[C] || g[_] === g[C] && v[f] <= v[S];
    }
    function pqdownheap(g, f, S) {
        for(var v = g.heap[S], _ = S << 1; _ <= g.heap_len && (_ < g.heap_len && smaller(f, g.heap[_ + 1], g.heap[_], g.depth) && _++, !smaller(f, v, g.heap[_], g.depth));)g.heap[S] = g.heap[_], S = _, _ <<= 1;
        g.heap[S] = v;
    }
    function compress_block(g, f, S) {
        var v, _, C, E, T = 0;
        if (0 !== g.last_lit) do v = g.pending_buf[g.d_buf + 2 * T] << 8 | g.pending_buf[g.d_buf + 2 * T + 1], _ = g.pending_buf[g.l_buf + T], T++, 0 === v ? send_code(g, _, f) : (send_code(g, (C = Iv[_]) + rv + 1, f), 0 !== (E = fv[C]) && send_bits(g, _ -= bv[C], E), send_code(g, C = d_code(--v), S), 0 !== (E = Sv[C]) && send_bits(g, v -= wv[C], E));
        while (T < g.last_lit);
        send_code(g, hv, f);
    }
    function build_tree(g, f) {
        var S, v, _, C = f.dyn_tree, E = f.stat_desc.static_tree, T = f.stat_desc.has_stree, I = f.stat_desc.elems, b = -1;
        for(g.heap_len = 0, g.heap_max = lv, S = 0; S < I; S++)0 !== C[2 * S] ? (g.heap[++g.heap_len] = b = S, g.depth[S] = 0) : C[2 * S + 1] = 0;
        for(; g.heap_len < 2;)C[2 * (_ = g.heap[++g.heap_len] = b < 2 ? ++b : 0)] = 1, g.depth[_] = 0, g.opt_len--, T && (g.static_len -= E[2 * _ + 1]);
        for(f.max_code = b, S = g.heap_len >> 1; S >= 1; S--)pqdownheap(g, C, S);
        _ = I;
        do S = g.heap[1], g.heap[1] = g.heap[g.heap_len--], pqdownheap(g, C, 1), v = g.heap[1], g.heap[--g.heap_max] = S, g.heap[--g.heap_max] = v, C[2 * _] = C[2 * S] + C[2 * v], g.depth[_] = (g.depth[S] >= g.depth[v] ? g.depth[S] : g.depth[v]) + 1, C[2 * S + 1] = C[2 * v + 1] = _, g.heap[1] = _++, pqdownheap(g, C, 1);
        while (g.heap_len >= 2);
        g.heap[--g.heap_max] = g.heap[1], gen_bitlen(g, f), gen_codes(C, b, g.bl_count);
    }
    function scan_tree(g, f, S) {
        var v, _, C = -1, E = f[1], T = 0, I = 7, b = 4;
        for(0 === E && (I = 138, b = 3), f[2 * (S + 1) + 1] = 65535, v = 0; v <= S; v++)_ = E, E = f[2 * (v + 1) + 1], ++T < I && _ === E || (T < b ? g.bl_tree[2 * _] += T : 0 !== _ ? (_ !== C && g.bl_tree[2 * _]++, g.bl_tree[2 * gv]++) : T <= 10 ? g.bl_tree[2 * pv]++ : g.bl_tree[2 * mv]++, T = 0, C = _, 0 === E ? (I = 138, b = 3) : _ === E ? (I = 6, b = 3) : (I = 7, b = 4));
    }
    function send_tree(g, f, S) {
        var v, _, C = -1, E = f[1], T = 0, I = 7, b = 4;
        for(0 === E && (I = 138, b = 3), v = 0; v <= S; v++)if (_ = E, E = f[2 * (v + 1) + 1], !(++T < I && _ === E)) {
            if (T < b) do send_code(g, _, g.bl_tree);
            while (0 != --T);
            else 0 !== _ ? (_ !== C && (send_code(g, _, g.bl_tree), T--), send_code(g, gv, g.bl_tree), send_bits(g, T - 3, 2)) : T <= 10 ? (send_code(g, pv, g.bl_tree), send_bits(g, T - 3, 3)) : (send_code(g, mv, g.bl_tree), send_bits(g, T - 11, 7));
            T = 0, C = _, 0 === E ? (I = 138, b = 3) : _ === E ? (I = 6, b = 3) : (I = 7, b = 4);
        }
    }
    function build_bl_tree(g) {
        var f;
        for(scan_tree(g, g.dyn_ltree, g.l_desc.max_code), scan_tree(g, g.dyn_dtree, g.d_desc.max_code), build_tree(g, g.bl_desc), f = ov - 1; f >= 3 && 0 === g.bl_tree[2 * _v[f] + 1]; f--);
        return g.opt_len += 3 * (f + 1) + 5 + 5 + 4, f;
    }
    function send_all_trees(g, f, S, v) {
        var _;
        for(send_bits(g, f - 257, 5), send_bits(g, S - 1, 5), send_bits(g, v - 4, 4), _ = 0; _ < v; _++)send_bits(g, g.bl_tree[2 * _v[_] + 1], 3);
        send_tree(g, g.dyn_ltree, f - 1), send_tree(g, g.dyn_dtree, S - 1);
    }
    function detect_data_type(g) {
        var f, S = 4093624447;
        for(f = 0; f <= 31; f++, S >>>= 1)if (1 & S && 0 !== g.dyn_ltree[2 * f]) return JS;
        if (0 !== g.dyn_ltree[18] || 0 !== g.dyn_ltree[20] || 0 !== g.dyn_ltree[26]) return YS;
        for(f = 32; f < rv; f++)if (0 !== g.dyn_ltree[2 * f]) return YS;
        return JS;
    }
    zero(wv);
    var Mv = !1;
    function _tr_init(g) {
        Mv || (tr_static_init(), Mv = !0), g.l_desc = new TreeDesc(g.dyn_ltree, Av), g.d_desc = new TreeDesc(g.dyn_dtree, Rv), g.bl_desc = new TreeDesc(g.bl_tree, Pv), g.bi_buf = 0, g.bi_valid = 0, init_block(g);
    }
    function _tr_stored_block(g, f, S, v) {
        send_bits(g, (XS << 1) + (v ? 1 : 0), 3), copy_block(g, f, S, !0);
    }
    function _tr_align(g) {
        send_bits(g, ZS << 1, 3), send_code(g, hv, yv), bi_flush(g);
    }
    function _tr_flush_block(g, f, S, v) {
        var _, C, E = 0;
        g.level > 0 ? (g.strm.data_type === QS && (g.strm.data_type = detect_data_type(g)), build_tree(g, g.l_desc), build_tree(g, g.d_desc), E = build_bl_tree(g), _ = g.opt_len + 3 + 7 >>> 3, (C = g.static_len + 3 + 7 >>> 3) <= _ && (_ = C)) : _ = C = S + 5, S + 4 <= _ && -1 !== f ? _tr_stored_block(g, f, S, v) : g.strategy === KS || C === _ ? (send_bits(g, (ZS << 1) + (v ? 1 : 0), 3), compress_block(g, yv, Ev)) : (send_bits(g, (ev << 1) + (v ? 1 : 0), 3), send_all_trees(g, g.l_desc.max_code + 1, g.d_desc.max_code + 1, E + 1), compress_block(g, g.dyn_ltree, g.dyn_dtree)), init_block(g), v && bi_windup(g);
    }
    function _tr_tally(g, f, S) {
        return g.pending_buf[g.d_buf + 2 * g.last_lit] = f >>> 8 & 255, g.pending_buf[g.d_buf + 2 * g.last_lit + 1] = 255 & f, g.pending_buf[g.l_buf + g.last_lit] = 255 & S, g.last_lit++, 0 === f ? g.dyn_ltree[2 * S]++ : (g.matches++, f--, g.dyn_ltree[2 * (Iv[S] + rv + 1)]++, g.dyn_dtree[2 * d_code(f)]++), g.last_lit === g.lit_bufsize - 1;
    }
    var Ov = {
        _tr_init: _tr_init,
        _tr_stored_block: _tr_stored_block,
        _tr_flush_block: _tr_flush_block,
        _tr_tally: _tr_tally,
        _tr_align: _tr_align
    };
    function adler32(g, f, S, v) {
        for(var _ = 65535 & g | 0, C = g >>> 16 & 65535 | 0, E = 0; 0 !== S;){
            S -= E = S > 2e3 ? 2e3 : S;
            do C = C + (_ = _ + f[v++] | 0) | 0;
            while (--E);
            _ %= 65521, C %= 65521;
        }
        return _ | C << 16 | 0;
    }
    var Dv = adler32;
    function makeTable() {
        for(var g, f = [], S = 0; S < 256; S++){
            g = S;
            for(var v = 0; v < 8; v++)g = 1 & g ? 3988292384 ^ g >>> 1 : g >>> 1;
            f[S] = g;
        }
        return f;
    }
    var Nv = makeTable();
    function crc32(g, f, S, v) {
        var _ = Nv, C = v + S;
        g ^= -1;
        for(var E = v; E < C; E++)g = g >>> 8 ^ _[255 & (g ^ f[E])];
        return -1 ^ g;
    }
    var kv, Lv = crc32, Fv = {
        2: "need dictionary",
        1: "stream end",
        0: "",
        "-1": "file error",
        "-2": "stream error",
        "-3": "data error",
        "-4": "insufficient memory",
        "-5": "buffer error",
        "-6": "incompatible version"
    }, xv = 0, Uv = 1, Vv = 3, Bv = 4, Hv = 5, $v = 0, jv = 1, Gv = -2, qv = -3, Wv = -5, zv = -1, Kv = 1, Jv = 2, Yv = 3, Qv = 4, Xv = 0, Zv = 2, e_ = 8, t_ = 9, i_ = 15, n_ = 8, r_ = 286, a_ = 30, s_ = 19, o_ = 2 * r_ + 1, l_ = 15, c_ = 3, d_ = 258, u_ = d_ + c_ + 1, h_ = 32, g_ = 42, p_ = 69, m_ = 73, f_ = 91, S_ = 103, v_ = 113, C_ = 666, y_ = 1, E_ = 2, T_ = 3, I_ = 4, b_ = 3;
    function err(g, f) {
        return g.msg = Fv[f], f;
    }
    function rank(g) {
        return (g << 1) - (g > 4 ? 9 : 0);
    }
    function zero$1(g) {
        for(var f = g.length; --f >= 0;)g[f] = 0;
    }
    function flush_pending(g) {
        var f = g.state, S = f.pending;
        S > g.avail_out && (S = g.avail_out), 0 !== S && (zS.arraySet(g.output, f.pending_buf, f.pending_out, S, g.next_out), g.next_out += S, f.pending_out += S, g.total_out += S, g.avail_out -= S, f.pending -= S, 0 === f.pending && (f.pending_out = 0));
    }
    function flush_block_only(g, f) {
        Ov._tr_flush_block(g, g.block_start >= 0 ? g.block_start : -1, g.strstart - g.block_start, f), g.block_start = g.strstart, flush_pending(g.strm);
    }
    function put_byte(g, f) {
        g.pending_buf[g.pending++] = f;
    }
    function putShortMSB(g, f) {
        g.pending_buf[g.pending++] = f >>> 8 & 255, g.pending_buf[g.pending++] = 255 & f;
    }
    function read_buf(g, f, S, v) {
        var _ = g.avail_in;
        return _ > v && (_ = v), 0 === _ ? 0 : (g.avail_in -= _, zS.arraySet(f, g.input, g.next_in, _, S), 1 === g.state.wrap ? g.adler = Dv(g.adler, f, _, S) : 2 === g.state.wrap && (g.adler = Lv(g.adler, f, _, S)), g.next_in += _, g.total_in += _, _);
    }
    function longest_match(g, f) {
        var S, v, _ = g.max_chain_length, C = g.strstart, E = g.prev_length, T = g.nice_match, I = g.strstart > g.w_size - u_ ? g.strstart - (g.w_size - u_) : 0, b = g.window, A = g.w_mask, R = g.prev, P = g.strstart + d_, w = b[C + E - 1], M = b[C + E];
        g.prev_length >= g.good_match && (_ >>= 2), T > g.lookahead && (T = g.lookahead);
        do if (b[(S = f) + E] === M && b[S + E - 1] === w && b[S] === b[C] && b[++S] === b[C + 1]) {
            C += 2, S++;
            do ;
            while (b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && b[++C] === b[++S] && C < P);
            if (v = d_ - (P - C), C = P - d_, v > E) {
                if (g.match_start = f, E = v, v >= T) break;
                w = b[C + E - 1], M = b[C + E];
            }
        }
        while ((f = R[f & A]) > I && 0 != --_);
        return E <= g.lookahead ? E : g.lookahead;
    }
    function fill_window(g) {
        var f, S, v, _, C, E = g.w_size;
        do {
            if (_ = g.window_size - g.lookahead - g.strstart, g.strstart >= E + (E - u_)) {
                zS.arraySet(g.window, g.window, E, E, 0), g.match_start -= E, g.strstart -= E, g.block_start -= E, f = S = g.hash_size;
                do v = g.head[--f], g.head[f] = v >= E ? v - E : 0;
                while (--S);
                f = S = E;
                do v = g.prev[--f], g.prev[f] = v >= E ? v - E : 0;
                while (--S);
                _ += E;
            }
            if (0 === g.strm.avail_in) break;
            if (S = read_buf(g.strm, g.window, g.strstart + g.lookahead, _), g.lookahead += S, g.lookahead + g.insert >= c_) for(C = g.strstart - g.insert, g.ins_h = g.window[C], g.ins_h = (g.ins_h << g.hash_shift ^ g.window[C + 1]) & g.hash_mask; g.insert && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[C + c_ - 1]) & g.hash_mask, g.prev[C & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = C, C++, g.insert--, !(g.lookahead + g.insert < c_)););
        }while (g.lookahead < u_ && 0 !== g.strm.avail_in);
    }
    function deflate_stored(g, f) {
        var S = 65535;
        for(S > g.pending_buf_size - 5 && (S = g.pending_buf_size - 5);;){
            if (g.lookahead <= 1) {
                if (fill_window(g), 0 === g.lookahead && f === xv) return y_;
                if (0 === g.lookahead) break;
            }
            g.strstart += g.lookahead, g.lookahead = 0;
            var v = g.block_start + S;
            if ((0 === g.strstart || g.strstart >= v) && (g.lookahead = g.strstart - v, g.strstart = v, flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
            if (g.strstart - g.block_start >= g.w_size - u_ && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
        }
        return g.insert = 0, f === Bv ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? T_ : I_) : (g.strstart > g.block_start && (flush_block_only(g, !1), g.strm.avail_out), y_);
    }
    function deflate_fast(g, f) {
        for(var S, v;;){
            if (g.lookahead < u_) {
                if (fill_window(g), g.lookahead < u_ && f === xv) return y_;
                if (0 === g.lookahead) break;
            }
            if (S = 0, g.lookahead >= c_ && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + c_ - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart), 0 !== S && g.strstart - S <= g.w_size - u_ && (g.match_length = longest_match(g, S)), g.match_length >= c_) {
                if (v = Ov._tr_tally(g, g.strstart - g.match_start, g.match_length - c_), g.lookahead -= g.match_length, g.match_length <= g.max_lazy_match && g.lookahead >= c_) {
                    g.match_length--;
                    do g.strstart++, g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + c_ - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart;
                    while (0 != --g.match_length);
                    g.strstart++;
                } else g.strstart += g.match_length, g.match_length = 0, g.ins_h = g.window[g.strstart], g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + 1]) & g.hash_mask;
            } else v = Ov._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++;
            if (v && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
        }
        return g.insert = g.strstart < c_ - 1 ? g.strstart : c_ - 1, f === Bv ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? T_ : I_) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? y_ : E_;
    }
    function deflate_slow(g, f) {
        for(var S, v, _;;){
            if (g.lookahead < u_) {
                if (fill_window(g), g.lookahead < u_ && f === xv) return y_;
                if (0 === g.lookahead) break;
            }
            if (S = 0, g.lookahead >= c_ && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + c_ - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart), g.prev_length = g.match_length, g.prev_match = g.match_start, g.match_length = c_ - 1, 0 !== S && g.prev_length < g.max_lazy_match && g.strstart - S <= g.w_size - u_ && (g.match_length = longest_match(g, S), g.match_length <= 5 && (g.strategy === Kv || g.match_length === c_ && g.strstart - g.match_start > 4096) && (g.match_length = c_ - 1)), g.prev_length >= c_ && g.match_length <= g.prev_length) {
                _ = g.strstart + g.lookahead - c_, v = Ov._tr_tally(g, g.strstart - 1 - g.prev_match, g.prev_length - c_), g.lookahead -= g.prev_length - 1, g.prev_length -= 2;
                do ++g.strstart <= _ && (g.ins_h = (g.ins_h << g.hash_shift ^ g.window[g.strstart + c_ - 1]) & g.hash_mask, S = g.prev[g.strstart & g.w_mask] = g.head[g.ins_h], g.head[g.ins_h] = g.strstart);
                while (0 != --g.prev_length);
                if (g.match_available = 0, g.match_length = c_ - 1, g.strstart++, v && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
            } else if (g.match_available) {
                if ((v = Ov._tr_tally(g, 0, g.window[g.strstart - 1])) && flush_block_only(g, !1), g.strstart++, g.lookahead--, 0 === g.strm.avail_out) return y_;
            } else g.match_available = 1, g.strstart++, g.lookahead--;
        }
        return g.match_available && (v = Ov._tr_tally(g, 0, g.window[g.strstart - 1]), g.match_available = 0), g.insert = g.strstart < c_ - 1 ? g.strstart : c_ - 1, f === Bv ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? T_ : I_) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? y_ : E_;
    }
    function deflate_rle(g, f) {
        for(var S, v, _, C, E = g.window;;){
            if (g.lookahead <= d_) {
                if (fill_window(g), g.lookahead <= d_ && f === xv) return y_;
                if (0 === g.lookahead) break;
            }
            if (g.match_length = 0, g.lookahead >= c_ && g.strstart > 0 && (v = E[_ = g.strstart - 1]) === E[++_] && v === E[++_] && v === E[++_]) {
                C = g.strstart + d_;
                do ;
                while (v === E[++_] && v === E[++_] && v === E[++_] && v === E[++_] && v === E[++_] && v === E[++_] && v === E[++_] && v === E[++_] && _ < C);
                g.match_length = d_ - (C - _), g.match_length > g.lookahead && (g.match_length = g.lookahead);
            }
            if (g.match_length >= c_ ? (S = Ov._tr_tally(g, 1, g.match_length - c_), g.lookahead -= g.match_length, g.strstart += g.match_length, g.match_length = 0) : (S = Ov._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++), S && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
        }
        return g.insert = 0, f === Bv ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? T_ : I_) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? y_ : E_;
    }
    function deflate_huff(g, f) {
        for(var S;;){
            if (0 === g.lookahead && (fill_window(g), 0 === g.lookahead)) {
                if (f === xv) return y_;
                break;
            }
            if (g.match_length = 0, S = Ov._tr_tally(g, 0, g.window[g.strstart]), g.lookahead--, g.strstart++, S && (flush_block_only(g, !1), 0 === g.strm.avail_out)) return y_;
        }
        return g.insert = 0, f === Bv ? (flush_block_only(g, !0), 0 === g.strm.avail_out ? T_ : I_) : g.last_lit && (flush_block_only(g, !1), 0 === g.strm.avail_out) ? y_ : E_;
    }
    function Config(g, f, S, v, _) {
        this.good_length = g, this.max_lazy = f, this.nice_length = S, this.max_chain = v, this.func = _;
    }
    function lm_init(g) {
        g.window_size = 2 * g.w_size, zero$1(g.head), g.max_lazy_match = kv[g.level].max_lazy, g.good_match = kv[g.level].good_length, g.nice_match = kv[g.level].nice_length, g.max_chain_length = kv[g.level].max_chain, g.strstart = 0, g.block_start = 0, g.lookahead = 0, g.insert = 0, g.match_length = g.prev_length = c_ - 1, g.match_available = 0, g.ins_h = 0;
    }
    function DeflateState() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = e_, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new zS.Buf16(2 * o_), this.dyn_dtree = new zS.Buf16(2 * (2 * a_ + 1)), this.bl_tree = new zS.Buf16(2 * (2 * s_ + 1)), zero$1(this.dyn_ltree), zero$1(this.dyn_dtree), zero$1(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new zS.Buf16(l_ + 1), this.heap = new zS.Buf16(2 * r_ + 1), zero$1(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new zS.Buf16(2 * r_ + 1), zero$1(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
    }
    function deflateResetKeep(g) {
        var f;
        return g && g.state ? (g.total_in = g.total_out = 0, g.data_type = Zv, (f = g.state).pending = 0, f.pending_out = 0, f.wrap < 0 && (f.wrap = -f.wrap), f.status = f.wrap ? g_ : v_, g.adler = 2 === f.wrap ? 0 : 1, f.last_flush = xv, Ov._tr_init(f), $v) : err(g, Gv);
    }
    function deflateReset(g) {
        var f = deflateResetKeep(g);
        return f === $v && lm_init(g.state), f;
    }
    function deflateSetHeader(g, f) {
        return g && g.state ? 2 !== g.state.wrap ? Gv : (g.state.gzhead = f, $v) : Gv;
    }
    function deflateInit2(g, f, S, v, _, C) {
        if (!g) return Gv;
        var E = 1;
        if (f === zv && (f = 6), v < 0 ? (E = 0, v = -v) : v > 15 && (E = 2, v -= 16), _ < 1 || _ > t_ || S !== e_ || v < 8 || v > 15 || f < 0 || f > 9 || C < 0 || C > Qv) return err(g, Gv);
        8 === v && (v = 9);
        var T = new DeflateState;
        return g.state = T, T.strm = g, T.wrap = E, T.gzhead = null, T.w_bits = v, T.w_size = 1 << T.w_bits, T.w_mask = T.w_size - 1, T.hash_bits = _ + 7, T.hash_size = 1 << T.hash_bits, T.hash_mask = T.hash_size - 1, T.hash_shift = ~~((T.hash_bits + c_ - 1) / c_), T.window = new zS.Buf8(2 * T.w_size), T.head = new zS.Buf16(T.hash_size), T.prev = new zS.Buf16(T.w_size), T.lit_bufsize = 1 << _ + 6, T.pending_buf_size = 4 * T.lit_bufsize, T.pending_buf = new zS.Buf8(T.pending_buf_size), T.d_buf = T.lit_bufsize >> 1, T.l_buf = 3 * T.lit_bufsize, T.level = f, T.strategy = C, T.method = S, deflateReset(g);
    }
    function deflateInit(g, f) {
        return deflateInit2(g, f, e_, i_, n_, Xv);
    }
    function deflate(g, f) {
        var S, v, _, C;
        if (!g || !g.state || f > Hv || f < 0) return g ? err(g, Gv) : Gv;
        if (v = g.state, !g.output || !g.input && 0 !== g.avail_in || v.status === C_ && f !== Bv) return err(g, 0 === g.avail_out ? Wv : Gv);
        if (v.strm = g, S = v.last_flush, v.last_flush = f, v.status === g_) {
            if (2 === v.wrap) g.adler = 0, put_byte(v, 31), put_byte(v, 139), put_byte(v, 8), v.gzhead ? (put_byte(v, (v.gzhead.text ? 1 : 0) + (v.gzhead.hcrc ? 2 : 0) + (v.gzhead.extra ? 4 : 0) + (v.gzhead.name ? 8 : 0) + (v.gzhead.comment ? 16 : 0)), put_byte(v, 255 & v.gzhead.time), put_byte(v, v.gzhead.time >> 8 & 255), put_byte(v, v.gzhead.time >> 16 & 255), put_byte(v, v.gzhead.time >> 24 & 255), put_byte(v, 9 === v.level ? 2 : v.strategy >= Jv || v.level < 2 ? 4 : 0), put_byte(v, 255 & v.gzhead.os), v.gzhead.extra && v.gzhead.extra.length && (put_byte(v, 255 & v.gzhead.extra.length), put_byte(v, v.gzhead.extra.length >> 8 & 255)), v.gzhead.hcrc && (g.adler = Lv(g.adler, v.pending_buf, v.pending, 0)), v.gzindex = 0, v.status = p_) : (put_byte(v, 0), put_byte(v, 0), put_byte(v, 0), put_byte(v, 0), put_byte(v, 0), put_byte(v, 9 === v.level ? 2 : v.strategy >= Jv || v.level < 2 ? 4 : 0), put_byte(v, b_), v.status = v_);
            else {
                var E = e_ + (v.w_bits - 8 << 4) << 8;
                E |= (v.strategy >= Jv || v.level < 2 ? 0 : v.level < 6 ? 1 : 6 === v.level ? 2 : 3) << 6, 0 !== v.strstart && (E |= h_), E += 31 - E % 31, v.status = v_, putShortMSB(v, E), 0 !== v.strstart && (putShortMSB(v, g.adler >>> 16), putShortMSB(v, 65535 & g.adler)), g.adler = 1;
            }
        }
        if (v.status === p_) {
            if (v.gzhead.extra) {
                for(_ = v.pending; v.gzindex < (65535 & v.gzhead.extra.length) && (v.pending !== v.pending_buf_size || (v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), flush_pending(g), _ = v.pending, v.pending !== v.pending_buf_size));)put_byte(v, 255 & v.gzhead.extra[v.gzindex]), v.gzindex++;
                v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), v.gzindex === v.gzhead.extra.length && (v.gzindex = 0, v.status = m_);
            } else v.status = m_;
        }
        if (v.status === m_) {
            if (v.gzhead.name) {
                _ = v.pending;
                do {
                    if (v.pending === v.pending_buf_size && (v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), flush_pending(g), _ = v.pending, v.pending === v.pending_buf_size)) {
                        C = 1;
                        break;
                    }
                    C = v.gzindex < v.gzhead.name.length ? 255 & v.gzhead.name.charCodeAt(v.gzindex++) : 0, put_byte(v, C);
                }while (0 !== C);
                v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), 0 === C && (v.gzindex = 0, v.status = f_);
            } else v.status = f_;
        }
        if (v.status === f_) {
            if (v.gzhead.comment) {
                _ = v.pending;
                do {
                    if (v.pending === v.pending_buf_size && (v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), flush_pending(g), _ = v.pending, v.pending === v.pending_buf_size)) {
                        C = 1;
                        break;
                    }
                    C = v.gzindex < v.gzhead.comment.length ? 255 & v.gzhead.comment.charCodeAt(v.gzindex++) : 0, put_byte(v, C);
                }while (0 !== C);
                v.gzhead.hcrc && v.pending > _ && (g.adler = Lv(g.adler, v.pending_buf, v.pending - _, _)), 0 === C && (v.status = S_);
            } else v.status = S_;
        }
        if (v.status === S_ && (v.gzhead.hcrc ? (v.pending + 2 > v.pending_buf_size && flush_pending(g), v.pending + 2 <= v.pending_buf_size && (put_byte(v, 255 & g.adler), put_byte(v, g.adler >> 8 & 255), g.adler = 0, v.status = v_)) : v.status = v_), 0 !== v.pending) {
            if (flush_pending(g), 0 === g.avail_out) return v.last_flush = -1, $v;
        } else if (0 === g.avail_in && rank(f) <= rank(S) && f !== Bv) return err(g, Wv);
        if (v.status === C_ && 0 !== g.avail_in) return err(g, Wv);
        if (0 !== g.avail_in || 0 !== v.lookahead || f !== xv && v.status !== C_) {
            var T = v.strategy === Jv ? deflate_huff(v, f) : v.strategy === Yv ? deflate_rle(v, f) : kv[v.level].func(v, f);
            if (T !== T_ && T !== I_ || (v.status = C_), T === y_ || T === T_) return 0 === g.avail_out && (v.last_flush = -1), $v;
            if (T === E_ && (f === Uv ? Ov._tr_align(v) : f !== Hv && (Ov._tr_stored_block(v, 0, 0, !1), f === Vv && (zero$1(v.head), 0 === v.lookahead && (v.strstart = 0, v.block_start = 0, v.insert = 0))), flush_pending(g), 0 === g.avail_out)) return v.last_flush = -1, $v;
        }
        return f !== Bv ? $v : v.wrap <= 0 ? jv : (2 === v.wrap ? (put_byte(v, 255 & g.adler), put_byte(v, g.adler >> 8 & 255), put_byte(v, g.adler >> 16 & 255), put_byte(v, g.adler >> 24 & 255), put_byte(v, 255 & g.total_in), put_byte(v, g.total_in >> 8 & 255), put_byte(v, g.total_in >> 16 & 255), put_byte(v, g.total_in >> 24 & 255)) : (putShortMSB(v, g.adler >>> 16), putShortMSB(v, 65535 & g.adler)), flush_pending(g), v.wrap > 0 && (v.wrap = -v.wrap), 0 !== v.pending ? $v : jv);
    }
    function deflateEnd(g) {
        var f;
        return g && g.state ? (f = g.state.status) !== g_ && f !== p_ && f !== m_ && f !== f_ && f !== S_ && f !== v_ && f !== C_ ? err(g, Gv) : (g.state = null, f === v_ ? err(g, qv) : $v) : Gv;
    }
    function deflateSetDictionary(g, f) {
        var S, v, _, C, E, T, I, b, A = f.length;
        if (!g || !g.state) return Gv;
        if (2 === (C = (S = g.state).wrap) || 1 === C && S.status !== g_ || S.lookahead) return Gv;
        for(1 === C && (g.adler = Dv(g.adler, f, A, 0)), S.wrap = 0, A >= S.w_size && (0 === C && (zero$1(S.head), S.strstart = 0, S.block_start = 0, S.insert = 0), b = new zS.Buf8(S.w_size), zS.arraySet(b, f, A - S.w_size, S.w_size, 0), f = b, A = S.w_size), E = g.avail_in, T = g.next_in, I = g.input, g.avail_in = A, g.next_in = 0, g.input = f, fill_window(S); S.lookahead >= c_;){
            v = S.strstart, _ = S.lookahead - (c_ - 1);
            do S.ins_h = (S.ins_h << S.hash_shift ^ S.window[v + c_ - 1]) & S.hash_mask, S.prev[v & S.w_mask] = S.head[S.ins_h], S.head[S.ins_h] = v, v++;
            while (--_);
            S.strstart = v, S.lookahead = c_ - 1, fill_window(S);
        }
        return S.strstart += S.lookahead, S.block_start = S.strstart, S.insert = S.lookahead, S.lookahead = 0, S.match_length = S.prev_length = c_ - 1, S.match_available = 0, g.next_in = T, g.input = I, g.avail_in = E, S.wrap = C, $v;
    }
    kv = [
        new Config(0, 0, 0, 0, deflate_stored),
        new Config(4, 4, 8, 4, deflate_fast),
        new Config(4, 5, 16, 8, deflate_fast),
        new Config(4, 6, 32, 32, deflate_fast),
        new Config(4, 4, 16, 16, deflate_slow),
        new Config(8, 16, 32, 32, deflate_slow),
        new Config(8, 16, 128, 128, deflate_slow),
        new Config(8, 32, 128, 256, deflate_slow),
        new Config(32, 128, 258, 1024, deflate_slow),
        new Config(32, 258, 258, 4096, deflate_slow)
    ];
    var A_ = {
        deflateInit: deflateInit,
        deflateInit2: deflateInit2,
        deflateReset: deflateReset,
        deflateResetKeep: deflateResetKeep,
        deflateSetHeader: deflateSetHeader,
        deflate: deflate,
        deflateEnd: deflateEnd,
        deflateSetDictionary: deflateSetDictionary,
        deflateInfo: "pako deflate (from Nodeca project)"
    }, R_ = !0, P_ = !0;
    try {
        String.fromCharCode.apply(null, [
            0
        ]);
    } catch (g) {
        R_ = !1;
    }
    try {
        String.fromCharCode.apply(null, new Uint8Array(1));
    } catch (g) {
        P_ = !1;
    }
    for(var w_ = new zS.Buf8(256), M_ = 0; M_ < 256; M_++)w_[M_] = M_ >= 252 ? 6 : M_ >= 248 ? 5 : M_ >= 240 ? 4 : M_ >= 224 ? 3 : M_ >= 192 ? 2 : 1;
    w_[254] = w_[254] = 1;
    var string2buf = function(g) {
        var f, S, v, _, C, E = g.length, T = 0;
        for(_ = 0; _ < E; _++)55296 == (64512 & (S = g.charCodeAt(_))) && _ + 1 < E && 56320 == (64512 & (v = g.charCodeAt(_ + 1))) && (S = 65536 + (S - 55296 << 10) + (v - 56320), _++), T += S < 128 ? 1 : S < 2048 ? 2 : S < 65536 ? 3 : 4;
        for(f = new zS.Buf8(T), C = 0, _ = 0; C < T; _++)55296 == (64512 & (S = g.charCodeAt(_))) && _ + 1 < E && 56320 == (64512 & (v = g.charCodeAt(_ + 1))) && (S = 65536 + (S - 55296 << 10) + (v - 56320), _++), S < 128 ? f[C++] = S : S < 2048 ? (f[C++] = 192 | S >>> 6, f[C++] = 128 | 63 & S) : S < 65536 ? (f[C++] = 224 | S >>> 12, f[C++] = 128 | S >>> 6 & 63, f[C++] = 128 | 63 & S) : (f[C++] = 240 | S >>> 18, f[C++] = 128 | S >>> 12 & 63, f[C++] = 128 | S >>> 6 & 63, f[C++] = 128 | 63 & S);
        return f;
    };
    function buf2binstring(g, f) {
        if (f < 65537 && (g.subarray && P_ || !g.subarray && R_)) return String.fromCharCode.apply(null, zS.shrinkBuf(g, f));
        for(var S = "", v = 0; v < f; v++)S += String.fromCharCode(g[v]);
        return S;
    }
    var binstring2buf = function(g) {
        for(var f = new zS.Buf8(g.length), S = 0, v = f.length; S < v; S++)f[S] = g.charCodeAt(S);
        return f;
    }, buf2string = function(g, f) {
        var S, v, _, C, E = f || g.length, T = new Array(2 * E);
        for(v = 0, S = 0; S < E;)if ((_ = g[S++]) < 128) T[v++] = _;
        else if ((C = w_[_]) > 4) T[v++] = 65533, S += C - 1;
        else {
            for(_ &= 2 === C ? 31 : 3 === C ? 15 : 7; C > 1 && S < E;)_ = _ << 6 | 63 & g[S++], C--;
            C > 1 ? T[v++] = 65533 : _ < 65536 ? T[v++] = _ : (_ -= 65536, T[v++] = 55296 | _ >> 10 & 1023, T[v++] = 56320 | 1023 & _);
        }
        return buf2binstring(T, v);
    }, O_ = {
        string2buf: string2buf,
        buf2binstring: function(g) {
            return buf2binstring(g, g.length);
        },
        binstring2buf: binstring2buf,
        buf2string: buf2string,
        utf8border: function(g, f) {
            var S;
            for((f = f || g.length) > g.length && (f = g.length), S = f - 1; S >= 0 && 128 == (192 & g[S]);)S--;
            return S < 0 || 0 === S ? f : S + w_[g[S]] > f ? S : f;
        }
    };
    function ZStream() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
    }
    var D_ = ZStream, N_ = Object.prototype.toString, k_ = 0, L_ = 4, F_ = 0, x_ = 1, U_ = 2, V_ = -1, B_ = 0, H_ = 8;
    function Deflate(g) {
        if (!(this instanceof Deflate)) return new Deflate(g);
        this.options = zS.assign({
            level: V_,
            method: H_,
            chunkSize: 16384,
            windowBits: 15,
            memLevel: 8,
            strategy: B_,
            to: ""
        }, g || {});
        var f = this.options;
        f.raw && f.windowBits > 0 ? f.windowBits = -f.windowBits : f.gzip && f.windowBits > 0 && f.windowBits < 16 && (f.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new D_, this.strm.avail_out = 0;
        var S = A_.deflateInit2(this.strm, f.level, f.method, f.windowBits, f.memLevel, f.strategy);
        if (S !== F_) throw new Error(Fv[S]);
        if (f.header && A_.deflateSetHeader(this.strm, f.header), f.dictionary) {
            var v;
            if (v = "string" == typeof f.dictionary ? O_.string2buf(f.dictionary) : "[object ArrayBuffer]" === N_.call(f.dictionary) ? new Uint8Array(f.dictionary) : f.dictionary, (S = A_.deflateSetDictionary(this.strm, v)) !== F_) throw new Error(Fv[S]);
            this._dict_set = !0;
        }
    }
    function deflate$1(g, f) {
        var S = new Deflate(f);
        if (S.push(g, !0), S.err) throw S.msg;
        return S.result;
    }
    function deflateRaw(g, f) {
        return (f = f || {}).raw = !0, deflate$1(g, f);
    }
    function gzip(g, f) {
        return (f = f || {}).gzip = !0, deflate$1(g, f);
    }
    Deflate.prototype.push = function(g, f) {
        var S, v, _ = this.strm, C = this.options.chunkSize;
        if (this.ended) return !1;
        v = f === ~~f ? f : !0 === f ? L_ : k_, "string" == typeof g ? _.input = O_.string2buf(g) : "[object ArrayBuffer]" === N_.call(g) ? _.input = new Uint8Array(g) : _.input = g, _.next_in = 0, _.avail_in = _.input.length;
        do {
            if (0 === _.avail_out && (_.output = new zS.Buf8(C), _.next_out = 0, _.avail_out = C), (S = A_.deflate(_, v)) !== x_ && S !== F_) return this.onEnd(S), this.ended = !0, !1;
            0 !== _.avail_out && (0 !== _.avail_in || v !== L_ && v !== U_) || ("string" === this.options.to ? this.onData(O_.buf2binstring(zS.shrinkBuf(_.output, _.next_out))) : this.onData(zS.shrinkBuf(_.output, _.next_out)));
        }while ((_.avail_in > 0 || 0 === _.avail_out) && S !== x_);
        return v === L_ ? (S = A_.deflateEnd(this.strm), this.onEnd(S), this.ended = !0, S === F_) : v !== U_ || (this.onEnd(F_), _.avail_out = 0, !0);
    }, Deflate.prototype.onData = function(g) {
        this.chunks.push(g);
    }, Deflate.prototype.onEnd = function(g) {
        g === F_ && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = zS.flattenChunks(this.chunks)), this.chunks = [], this.err = g, this.msg = this.strm.msg;
    };
    var $_ = {
        Deflate: Deflate,
        deflate: deflate$1,
        deflateRaw: deflateRaw,
        gzip: gzip
    }, j_ = 30, G_ = 12, q_ = function inflate_fast(g, f) {
        var S, v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $;
        S = g.state, v = g.next_in, H = g.input, _ = v + (g.avail_in - 5), C = g.next_out, $ = g.output, E = C - (f - g.avail_out), T = C + (g.avail_out - 257), I = S.dmax, b = S.wsize, A = S.whave, R = S.wnext, P = S.window, w = S.hold, M = S.bits, O = S.lencode, D = S.distcode, N = (1 << S.lenbits) - 1, k = (1 << S.distbits) - 1;
        e: do {
            M < 15 && (w += H[v++] << M, M += 8, w += H[v++] << M, M += 8), L = O[w & N];
            t: for(;;){
                if (w >>>= F = L >>> 24, M -= F, 0 === (F = L >>> 16 & 255)) $[C++] = 65535 & L;
                else {
                    if (!(16 & F)) {
                        if (0 == (64 & F)) {
                            L = O[(65535 & L) + (w & (1 << F) - 1)];
                            continue t;
                        }
                        if (32 & F) {
                            S.mode = G_;
                            break e;
                        }
                        g.msg = "invalid literal/length code", S.mode = j_;
                        break e;
                    }
                    x = 65535 & L, (F &= 15) && (M < F && (w += H[v++] << M, M += 8), x += w & (1 << F) - 1, w >>>= F, M -= F), M < 15 && (w += H[v++] << M, M += 8, w += H[v++] << M, M += 8), L = D[w & k];
                    i: for(;;){
                        if (w >>>= F = L >>> 24, M -= F, !(16 & (F = L >>> 16 & 255))) {
                            if (0 == (64 & F)) {
                                L = D[(65535 & L) + (w & (1 << F) - 1)];
                                continue i;
                            }
                            g.msg = "invalid distance code", S.mode = j_;
                            break e;
                        }
                        if (U = 65535 & L, M < (F &= 15) && (w += H[v++] << M, (M += 8) < F && (w += H[v++] << M, M += 8)), (U += w & (1 << F) - 1) > I) {
                            g.msg = "invalid distance too far back", S.mode = j_;
                            break e;
                        }
                        if (w >>>= F, M -= F, U > (F = C - E)) {
                            if ((F = U - F) > A && S.sane) {
                                g.msg = "invalid distance too far back", S.mode = j_;
                                break e;
                            }
                            if (V = 0, B = P, 0 === R) {
                                if (V += b - F, F < x) {
                                    x -= F;
                                    do $[C++] = P[V++];
                                    while (--F);
                                    V = C - U, B = $;
                                }
                            } else if (R < F) {
                                if (V += b + R - F, (F -= R) < x) {
                                    x -= F;
                                    do $[C++] = P[V++];
                                    while (--F);
                                    if (V = 0, R < x) {
                                        x -= F = R;
                                        do $[C++] = P[V++];
                                        while (--F);
                                        V = C - U, B = $;
                                    }
                                }
                            } else if (V += R - F, F < x) {
                                x -= F;
                                do $[C++] = P[V++];
                                while (--F);
                                V = C - U, B = $;
                            }
                            for(; x > 2;)$[C++] = B[V++], $[C++] = B[V++], $[C++] = B[V++], x -= 3;
                            x && ($[C++] = B[V++], x > 1 && ($[C++] = B[V++]));
                        } else {
                            V = C - U;
                            do $[C++] = $[V++], $[C++] = $[V++], $[C++] = $[V++], x -= 3;
                            while (x > 2);
                            x && ($[C++] = $[V++], x > 1 && ($[C++] = $[V++]));
                        }
                        break;
                    }
                }
                break;
            }
        }while (v < _ && C < T);
        v -= x = M >> 3, w &= (1 << (M -= x << 3)) - 1, g.next_in = v, g.next_out = C, g.avail_in = v < _ ? _ - v + 5 : 5 - (v - _), g.avail_out = C < T ? T - C + 257 : 257 - (C - T), S.hold = w, S.bits = M;
    }, W_ = 15, z_ = 852, K_ = 592, J_ = 0, Y_ = 1, Q_ = 2, X_ = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258,
        0,
        0
    ], Z_ = [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        17,
        17,
        17,
        17,
        18,
        18,
        18,
        18,
        19,
        19,
        19,
        19,
        20,
        20,
        20,
        20,
        21,
        21,
        21,
        21,
        16,
        72,
        78
    ], eC = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577,
        0,
        0
    ], tC = [
        16,
        16,
        16,
        16,
        17,
        17,
        18,
        18,
        19,
        19,
        20,
        20,
        21,
        21,
        22,
        22,
        23,
        23,
        24,
        24,
        25,
        25,
        26,
        26,
        27,
        27,
        28,
        28,
        29,
        29,
        64,
        64
    ], iC = function inflate_table(g, f, S, v, _, C, E, T) {
        var I, b, A, R, P, w, M, O, D, N = T.bits, k = 0, L = 0, F = 0, x = 0, U = 0, V = 0, B = 0, H = 0, $ = 0, j = 0, G = null, q = 0, W = new zS.Buf16(W_ + 1), z = new zS.Buf16(W_ + 1), K = null, J = 0;
        for(k = 0; k <= W_; k++)W[k] = 0;
        for(L = 0; L < v; L++)W[f[S + L]]++;
        for(U = N, x = W_; x >= 1 && 0 === W[x]; x--);
        if (U > x && (U = x), 0 === x) return _[C++] = 20971520, _[C++] = 20971520, T.bits = 1, 0;
        for(F = 1; F < x && 0 === W[F]; F++);
        for(U < F && (U = F), H = 1, k = 1; k <= W_; k++)if (H <<= 1, (H -= W[k]) < 0) return -1;
        if (H > 0 && (g === J_ || 1 !== x)) return -1;
        for(z[1] = 0, k = 1; k < W_; k++)z[k + 1] = z[k] + W[k];
        for(L = 0; L < v; L++)0 !== f[S + L] && (E[z[f[S + L]]++] = L);
        if (g === J_ ? (G = K = E, w = 19) : g === Y_ ? (G = X_, q -= 257, K = Z_, J -= 257, w = 256) : (G = eC, K = tC, w = -1), j = 0, L = 0, k = F, P = C, V = U, B = 0, A = -1, R = ($ = 1 << U) - 1, g === Y_ && $ > z_ || g === Q_ && $ > K_) return 1;
        for(;;){
            M = k - B, E[L] < w ? (O = 0, D = E[L]) : E[L] > w ? (O = K[J + E[L]], D = G[q + E[L]]) : (O = 96, D = 0), I = 1 << k - B, F = b = 1 << V;
            do _[P + (j >> B) + (b -= I)] = M << 24 | O << 16 | D | 0;
            while (0 !== b);
            for(I = 1 << k - 1; j & I;)I >>= 1;
            if (0 !== I ? (j &= I - 1, j += I) : j = 0, L++, 0 == --W[k]) {
                if (k === x) break;
                k = f[S + E[L]];
            }
            if (k > U && (j & R) !== A) {
                for(0 === B && (B = U), P += F, H = 1 << (V = k - B); V + B < x && !((H -= W[V + B]) <= 0);)V++, H <<= 1;
                if ($ += 1 << V, g === Y_ && $ > z_ || g === Q_ && $ > K_) return 1;
                _[A = j & R] = U << 24 | V << 16 | P - C | 0;
            }
        }
        return 0 !== j && (_[P + j] = k - B << 24 | 4194304), T.bits = U, 0;
    }, nC = 0, rC = 1, aC = 2, sC = 4, oC = 5, lC = 6, cC = 0, dC = 1, uC = 2, hC = -2, gC = -3, pC = -4, mC = -5, fC = 8, SC = 1, vC = 2, _C = 3, CC = 4, yC = 5, EC = 6, TC = 7, IC = 8, bC = 9, AC = 10, RC = 11, PC = 12, wC = 13, MC = 14, OC = 15, DC = 16, NC = 17, kC = 18, LC = 19, FC = 20, xC = 21, UC = 22, VC = 23, BC = 24, HC = 25, $C = 26, jC = 27, GC = 28, qC = 29, WC = 30, zC = 31, KC = 852, JC = 592, YC = 15;
    function zswap32(g) {
        return (g >>> 24 & 255) + (g >>> 8 & 65280) + ((65280 & g) << 8) + ((255 & g) << 24);
    }
    function InflateState() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new zS.Buf16(320), this.work = new zS.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
    }
    function inflateResetKeep(g) {
        var f;
        return g && g.state ? (f = g.state, g.total_in = g.total_out = f.total = 0, g.msg = "", f.wrap && (g.adler = 1 & f.wrap), f.mode = SC, f.last = 0, f.havedict = 0, f.dmax = 32768, f.head = null, f.hold = 0, f.bits = 0, f.lencode = f.lendyn = new zS.Buf32(KC), f.distcode = f.distdyn = new zS.Buf32(JC), f.sane = 1, f.back = -1, cC) : hC;
    }
    function inflateReset(g) {
        var f;
        return g && g.state ? ((f = g.state).wsize = 0, f.whave = 0, f.wnext = 0, inflateResetKeep(g)) : hC;
    }
    function inflateReset2(g, f) {
        var S, v;
        return g && g.state ? (v = g.state, f < 0 ? (S = 0, f = -f) : (S = 1 + (f >> 4), f < 48 && (f &= 15)), f && (f < 8 || f > 15) ? hC : (null !== v.window && v.wbits !== f && (v.window = null), v.wrap = S, v.wbits = f, inflateReset(g))) : hC;
    }
    function inflateInit2(g, f) {
        var S, v;
        return g ? (v = new InflateState, g.state = v, v.window = null, (S = inflateReset2(g, f)) !== cC && (g.state = null), S) : hC;
    }
    function inflateInit(g) {
        return inflateInit2(g, YC);
    }
    var QC, XC, ZC = !0;
    function fixedtables(g) {
        if (ZC) {
            var f;
            for(QC = new zS.Buf32(512), XC = new zS.Buf32(32), f = 0; f < 144;)g.lens[f++] = 8;
            for(; f < 256;)g.lens[f++] = 9;
            for(; f < 280;)g.lens[f++] = 7;
            for(; f < 288;)g.lens[f++] = 8;
            for(iC(rC, g.lens, 0, 288, QC, 0, g.work, {
                bits: 9
            }), f = 0; f < 32;)g.lens[f++] = 5;
            iC(aC, g.lens, 0, 32, XC, 0, g.work, {
                bits: 5
            }), ZC = !1;
        }
        g.lencode = QC, g.lenbits = 9, g.distcode = XC, g.distbits = 5;
    }
    function updatewindow(g, f, S, v) {
        var _, C = g.state;
        return null === C.window && (C.wsize = 1 << C.wbits, C.wnext = 0, C.whave = 0, C.window = new zS.Buf8(C.wsize)), v >= C.wsize ? (zS.arraySet(C.window, f, S - C.wsize, C.wsize, 0), C.wnext = 0, C.whave = C.wsize) : ((_ = C.wsize - C.wnext) > v && (_ = v), zS.arraySet(C.window, f, S - v, _, C.wnext), (v -= _) ? (zS.arraySet(C.window, f, S - v, v, 0), C.wnext = v, C.whave = C.wsize) : (C.wnext += _, C.wnext === C.wsize && (C.wnext = 0), C.whave < C.wsize && (C.whave += _))), 0;
    }
    function inflate(g, f) {
        var S, v, _, C, E, T, I, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V, B, H, $ = 0, j = new zS.Buf8(4), G = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ];
        if (!g || !g.state || !g.output || !g.input && 0 !== g.avail_in) return hC;
        (S = g.state).mode === PC && (S.mode = wC), E = g.next_out, _ = g.output, I = g.avail_out, C = g.next_in, v = g.input, T = g.avail_in, b = S.hold, A = S.bits, R = T, P = I, V = cC;
        e: for(;;)switch(S.mode){
            case SC:
                if (0 === S.wrap) {
                    S.mode = wC;
                    break;
                }
                for(; A < 16;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if (2 & S.wrap && 35615 === b) {
                    S.check = 0, j[0] = 255 & b, j[1] = b >>> 8 & 255, S.check = Lv(S.check, j, 2, 0), b = 0, A = 0, S.mode = vC;
                    break;
                }
                if (S.flags = 0, S.head && (S.head.done = !1), !(1 & S.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                    g.msg = "incorrect header check", S.mode = WC;
                    break;
                }
                if ((15 & b) !== fC) {
                    g.msg = "unknown compression method", S.mode = WC;
                    break;
                }
                if (A -= 4, U = 8 + (15 & (b >>>= 4)), 0 === S.wbits) S.wbits = U;
                else if (U > S.wbits) {
                    g.msg = "invalid window size", S.mode = WC;
                    break;
                }
                S.dmax = 1 << U, g.adler = S.check = 1, S.mode = 512 & b ? AC : PC, b = 0, A = 0;
                break;
            case vC:
                for(; A < 16;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if (S.flags = b, (255 & S.flags) !== fC) {
                    g.msg = "unknown compression method", S.mode = WC;
                    break;
                }
                if (57344 & S.flags) {
                    g.msg = "unknown header flags set", S.mode = WC;
                    break;
                }
                S.head && (S.head.text = b >> 8 & 1), 512 & S.flags && (j[0] = 255 & b, j[1] = b >>> 8 & 255, S.check = Lv(S.check, j, 2, 0)), b = 0, A = 0, S.mode = _C;
            case _C:
                for(; A < 32;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                S.head && (S.head.time = b), 512 & S.flags && (j[0] = 255 & b, j[1] = b >>> 8 & 255, j[2] = b >>> 16 & 255, j[3] = b >>> 24 & 255, S.check = Lv(S.check, j, 4, 0)), b = 0, A = 0, S.mode = CC;
            case CC:
                for(; A < 16;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                S.head && (S.head.xflags = 255 & b, S.head.os = b >> 8), 512 & S.flags && (j[0] = 255 & b, j[1] = b >>> 8 & 255, S.check = Lv(S.check, j, 2, 0)), b = 0, A = 0, S.mode = yC;
            case yC:
                if (1024 & S.flags) {
                    for(; A < 16;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    S.length = b, S.head && (S.head.extra_len = b), 512 & S.flags && (j[0] = 255 & b, j[1] = b >>> 8 & 255, S.check = Lv(S.check, j, 2, 0)), b = 0, A = 0;
                } else S.head && (S.head.extra = null);
                S.mode = EC;
            case EC:
                if (1024 & S.flags && ((w = S.length) > T && (w = T), w && (S.head && (U = S.head.extra_len - S.length, S.head.extra || (S.head.extra = new Array(S.head.extra_len)), zS.arraySet(S.head.extra, v, C, w, U)), 512 & S.flags && (S.check = Lv(S.check, v, w, C)), T -= w, C += w, S.length -= w), S.length)) break e;
                S.length = 0, S.mode = TC;
            case TC:
                if (2048 & S.flags) {
                    if (0 === T) break e;
                    w = 0;
                    do U = v[C + w++], S.head && U && S.length < 65536 && (S.head.name += String.fromCharCode(U));
                    while (U && w < T);
                    if (512 & S.flags && (S.check = Lv(S.check, v, w, C)), T -= w, C += w, U) break e;
                } else S.head && (S.head.name = null);
                S.length = 0, S.mode = IC;
            case IC:
                if (4096 & S.flags) {
                    if (0 === T) break e;
                    w = 0;
                    do U = v[C + w++], S.head && U && S.length < 65536 && (S.head.comment += String.fromCharCode(U));
                    while (U && w < T);
                    if (512 & S.flags && (S.check = Lv(S.check, v, w, C)), T -= w, C += w, U) break e;
                } else S.head && (S.head.comment = null);
                S.mode = bC;
            case bC:
                if (512 & S.flags) {
                    for(; A < 16;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    if (b !== (65535 & S.check)) {
                        g.msg = "header crc mismatch", S.mode = WC;
                        break;
                    }
                    b = 0, A = 0;
                }
                S.head && (S.head.hcrc = S.flags >> 9 & 1, S.head.done = !0), g.adler = S.check = 0, S.mode = PC;
                break;
            case AC:
                for(; A < 32;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                g.adler = S.check = zswap32(b), b = 0, A = 0, S.mode = RC;
            case RC:
                if (0 === S.havedict) return g.next_out = E, g.avail_out = I, g.next_in = C, g.avail_in = T, S.hold = b, S.bits = A, uC;
                g.adler = S.check = 1, S.mode = PC;
            case PC:
                if (f === oC || f === lC) break e;
            case wC:
                if (S.last) {
                    b >>>= 7 & A, A -= 7 & A, S.mode = jC;
                    break;
                }
                for(; A < 3;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                switch(S.last = 1 & b, A -= 1, 3 & (b >>>= 1)){
                    case 0:
                        S.mode = MC;
                        break;
                    case 1:
                        if (fixedtables(S), S.mode = FC, f === lC) {
                            b >>>= 2, A -= 2;
                            break e;
                        }
                        break;
                    case 2:
                        S.mode = NC;
                        break;
                    case 3:
                        g.msg = "invalid block type", S.mode = WC;
                }
                b >>>= 2, A -= 2;
                break;
            case MC:
                for(b >>>= 7 & A, A -= 7 & A; A < 32;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if ((65535 & b) != (b >>> 16 ^ 65535)) {
                    g.msg = "invalid stored block lengths", S.mode = WC;
                    break;
                }
                if (S.length = 65535 & b, b = 0, A = 0, S.mode = OC, f === lC) break e;
            case OC:
                S.mode = DC;
            case DC:
                if (w = S.length) {
                    if (w > T && (w = T), w > I && (w = I), 0 === w) break e;
                    zS.arraySet(_, v, C, w, E), T -= w, C += w, I -= w, E += w, S.length -= w;
                    break;
                }
                S.mode = PC;
                break;
            case NC:
                for(; A < 14;){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if (S.nlen = 257 + (31 & b), b >>>= 5, A -= 5, S.ndist = 1 + (31 & b), b >>>= 5, A -= 5, S.ncode = 4 + (15 & b), b >>>= 4, A -= 4, S.nlen > 286 || S.ndist > 30) {
                    g.msg = "too many length or distance symbols", S.mode = WC;
                    break;
                }
                S.have = 0, S.mode = kC;
            case kC:
                for(; S.have < S.ncode;){
                    for(; A < 3;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    S.lens[G[S.have++]] = 7 & b, b >>>= 3, A -= 3;
                }
                for(; S.have < 19;)S.lens[G[S.have++]] = 0;
                if (S.lencode = S.lendyn, S.lenbits = 7, B = {
                    bits: S.lenbits
                }, V = iC(nC, S.lens, 0, 19, S.lencode, 0, S.work, B), S.lenbits = B.bits, V) {
                    g.msg = "invalid code lengths set", S.mode = WC;
                    break;
                }
                S.have = 0, S.mode = LC;
            case LC:
                for(; S.have < S.nlen + S.ndist;){
                    for(; N = ($ = S.lencode[b & (1 << S.lenbits) - 1]) >>> 16 & 255, k = 65535 & $, !((D = $ >>> 24) <= A);){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    if (k < 16) b >>>= D, A -= D, S.lens[S.have++] = k;
                    else {
                        if (16 === k) {
                            for(H = D + 2; A < H;){
                                if (0 === T) break e;
                                T--, b += v[C++] << A, A += 8;
                            }
                            if (b >>>= D, A -= D, 0 === S.have) {
                                g.msg = "invalid bit length repeat", S.mode = WC;
                                break;
                            }
                            U = S.lens[S.have - 1], w = 3 + (3 & b), b >>>= 2, A -= 2;
                        } else if (17 === k) {
                            for(H = D + 3; A < H;){
                                if (0 === T) break e;
                                T--, b += v[C++] << A, A += 8;
                            }
                            A -= D, U = 0, w = 3 + (7 & (b >>>= D)), b >>>= 3, A -= 3;
                        } else {
                            for(H = D + 7; A < H;){
                                if (0 === T) break e;
                                T--, b += v[C++] << A, A += 8;
                            }
                            A -= D, U = 0, w = 11 + (127 & (b >>>= D)), b >>>= 7, A -= 7;
                        }
                        if (S.have + w > S.nlen + S.ndist) {
                            g.msg = "invalid bit length repeat", S.mode = WC;
                            break;
                        }
                        for(; w--;)S.lens[S.have++] = U;
                    }
                }
                if (S.mode === WC) break;
                if (0 === S.lens[256]) {
                    g.msg = "invalid code -- missing end-of-block", S.mode = WC;
                    break;
                }
                if (S.lenbits = 9, B = {
                    bits: S.lenbits
                }, V = iC(rC, S.lens, 0, S.nlen, S.lencode, 0, S.work, B), S.lenbits = B.bits, V) {
                    g.msg = "invalid literal/lengths set", S.mode = WC;
                    break;
                }
                if (S.distbits = 6, S.distcode = S.distdyn, B = {
                    bits: S.distbits
                }, V = iC(aC, S.lens, S.nlen, S.ndist, S.distcode, 0, S.work, B), S.distbits = B.bits, V) {
                    g.msg = "invalid distances set", S.mode = WC;
                    break;
                }
                if (S.mode = FC, f === lC) break e;
            case FC:
                S.mode = xC;
            case xC:
                if (T >= 6 && I >= 258) {
                    g.next_out = E, g.avail_out = I, g.next_in = C, g.avail_in = T, S.hold = b, S.bits = A, q_(g, P), E = g.next_out, _ = g.output, I = g.avail_out, C = g.next_in, v = g.input, T = g.avail_in, b = S.hold, A = S.bits, S.mode === PC && (S.back = -1);
                    break;
                }
                for(S.back = 0; N = ($ = S.lencode[b & (1 << S.lenbits) - 1]) >>> 16 & 255, k = 65535 & $, !((D = $ >>> 24) <= A);){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if (N && 0 == (240 & N)) {
                    for(L = D, F = N, x = k; N = ($ = S.lencode[x + ((b & (1 << L + F) - 1) >> L)]) >>> 16 & 255, k = 65535 & $, !(L + (D = $ >>> 24) <= A);){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    b >>>= L, A -= L, S.back += L;
                }
                if (b >>>= D, A -= D, S.back += D, S.length = k, 0 === N) {
                    S.mode = $C;
                    break;
                }
                if (32 & N) {
                    S.back = -1, S.mode = PC;
                    break;
                }
                if (64 & N) {
                    g.msg = "invalid literal/length code", S.mode = WC;
                    break;
                }
                S.extra = 15 & N, S.mode = UC;
            case UC:
                if (S.extra) {
                    for(H = S.extra; A < H;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    S.length += b & (1 << S.extra) - 1, b >>>= S.extra, A -= S.extra, S.back += S.extra;
                }
                S.was = S.length, S.mode = VC;
            case VC:
                for(; N = ($ = S.distcode[b & (1 << S.distbits) - 1]) >>> 16 & 255, k = 65535 & $, !((D = $ >>> 24) <= A);){
                    if (0 === T) break e;
                    T--, b += v[C++] << A, A += 8;
                }
                if (0 == (240 & N)) {
                    for(L = D, F = N, x = k; N = ($ = S.distcode[x + ((b & (1 << L + F) - 1) >> L)]) >>> 16 & 255, k = 65535 & $, !(L + (D = $ >>> 24) <= A);){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    b >>>= L, A -= L, S.back += L;
                }
                if (b >>>= D, A -= D, S.back += D, 64 & N) {
                    g.msg = "invalid distance code", S.mode = WC;
                    break;
                }
                S.offset = k, S.extra = 15 & N, S.mode = BC;
            case BC:
                if (S.extra) {
                    for(H = S.extra; A < H;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    S.offset += b & (1 << S.extra) - 1, b >>>= S.extra, A -= S.extra, S.back += S.extra;
                }
                if (S.offset > S.dmax) {
                    g.msg = "invalid distance too far back", S.mode = WC;
                    break;
                }
                S.mode = HC;
            case HC:
                if (0 === I) break e;
                if (w = P - I, S.offset > w) {
                    if ((w = S.offset - w) > S.whave && S.sane) {
                        g.msg = "invalid distance too far back", S.mode = WC;
                        break;
                    }
                    w > S.wnext ? (w -= S.wnext, M = S.wsize - w) : M = S.wnext - w, w > S.length && (w = S.length), O = S.window;
                } else O = _, M = E - S.offset, w = S.length;
                w > I && (w = I), I -= w, S.length -= w;
                do _[E++] = O[M++];
                while (--w);
                0 === S.length && (S.mode = xC);
                break;
            case $C:
                if (0 === I) break e;
                _[E++] = S.length, I--, S.mode = xC;
                break;
            case jC:
                if (S.wrap) {
                    for(; A < 32;){
                        if (0 === T) break e;
                        T--, b |= v[C++] << A, A += 8;
                    }
                    if (P -= I, g.total_out += P, S.total += P, P && (g.adler = S.check = S.flags ? Lv(S.check, _, P, E - P) : Dv(S.check, _, P, E - P)), P = I, (S.flags ? b : zswap32(b)) !== S.check) {
                        g.msg = "incorrect data check", S.mode = WC;
                        break;
                    }
                    b = 0, A = 0;
                }
                S.mode = GC;
            case GC:
                if (S.wrap && S.flags) {
                    for(; A < 32;){
                        if (0 === T) break e;
                        T--, b += v[C++] << A, A += 8;
                    }
                    if (b !== (4294967295 & S.total)) {
                        g.msg = "incorrect length check", S.mode = WC;
                        break;
                    }
                    b = 0, A = 0;
                }
                S.mode = qC;
            case qC:
                V = dC;
                break e;
            case WC:
                V = gC;
                break e;
            case zC:
                return pC;
            default:
                return hC;
        }
        return g.next_out = E, g.avail_out = I, g.next_in = C, g.avail_in = T, S.hold = b, S.bits = A, (S.wsize || P !== g.avail_out && S.mode < WC && (S.mode < jC || f !== sC)) && updatewindow(g, g.output, g.next_out, P - g.avail_out), R -= g.avail_in, P -= g.avail_out, g.total_in += R, g.total_out += P, S.total += P, S.wrap && P && (g.adler = S.check = S.flags ? Lv(S.check, _, P, g.next_out - P) : Dv(S.check, _, P, g.next_out - P)), g.data_type = S.bits + (S.last ? 64 : 0) + (S.mode === PC ? 128 : 0) + (S.mode === FC || S.mode === OC ? 256 : 0), (0 === R && 0 === P || f === sC) && V === cC && (V = mC), V;
    }
    function inflateEnd(g) {
        if (!g || !g.state) return hC;
        var f = g.state;
        return f.window && (f.window = null), g.state = null, cC;
    }
    function inflateGetHeader(g, f) {
        var S;
        return g && g.state ? 0 == (2 & (S = g.state).wrap) ? hC : (S.head = f, f.done = !1, cC) : hC;
    }
    function inflateSetDictionary(g, f) {
        var S, v = f.length;
        return g && g.state ? 0 !== (S = g.state).wrap && S.mode !== RC ? hC : S.mode === RC && Dv(1, f, v, 0) !== S.check ? gC : updatewindow(g, f, v, v) ? (S.mode = zC, pC) : (S.havedict = 1, cC) : hC;
    }
    var ey = {
        inflateReset: inflateReset,
        inflateReset2: inflateReset2,
        inflateResetKeep: inflateResetKeep,
        inflateInit: inflateInit,
        inflateInit2: inflateInit2,
        inflate: inflate,
        inflateEnd: inflateEnd,
        inflateGetHeader: inflateGetHeader,
        inflateSetDictionary: inflateSetDictionary,
        inflateInfo: "pako inflate (from Nodeca project)"
    }, ty = {
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        Z_BUF_ERROR: -5,
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        Z_BINARY: 0,
        Z_TEXT: 1,
        Z_UNKNOWN: 2,
        Z_DEFLATED: 8
    };
    function GZheader() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
    }
    var iy = GZheader, ny = Object.prototype.toString;
    function Inflate(g) {
        if (!(this instanceof Inflate)) return new Inflate(g);
        this.options = zS.assign({
            chunkSize: 16384,
            windowBits: 0,
            to: ""
        }, g || {});
        var f = this.options;
        f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, 0 === f.windowBits && (f.windowBits = -15)), !(f.windowBits >= 0 && f.windowBits < 16) || g && g.windowBits || (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && 0 == (15 & f.windowBits) && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new D_, this.strm.avail_out = 0;
        var S = ey.inflateInit2(this.strm, f.windowBits);
        if (S !== ty.Z_OK) throw new Error(Fv[S]);
        this.header = new iy, ey.inflateGetHeader(this.strm, this.header);
    }
    function inflate$1(g, f) {
        var S = new Inflate(f);
        if (S.push(g, !0), S.err) throw S.msg;
        return S.result;
    }
    function inflateRaw(g, f) {
        return (f = f || {}).raw = !0, inflate$1(g, f);
    }
    Inflate.prototype.push = function(g, f) {
        var S, v, _, C, E, T, I = this.strm, b = this.options.chunkSize, A = this.options.dictionary, R = !1;
        if (this.ended) return !1;
        v = f === ~~f ? f : !0 === f ? ty.Z_FINISH : ty.Z_NO_FLUSH, "string" == typeof g ? I.input = O_.binstring2buf(g) : "[object ArrayBuffer]" === ny.call(g) ? I.input = new Uint8Array(g) : I.input = g, I.next_in = 0, I.avail_in = I.input.length;
        do {
            if (0 === I.avail_out && (I.output = new zS.Buf8(b), I.next_out = 0, I.avail_out = b), (S = ey.inflate(I, ty.Z_NO_FLUSH)) === ty.Z_NEED_DICT && A && (T = "string" == typeof A ? O_.string2buf(A) : "[object ArrayBuffer]" === ny.call(A) ? new Uint8Array(A) : A, S = ey.inflateSetDictionary(this.strm, T)), S === ty.Z_BUF_ERROR && !0 === R && (S = ty.Z_OK, R = !1), S !== ty.Z_STREAM_END && S !== ty.Z_OK) return this.onEnd(S), this.ended = !0, !1;
            I.next_out && (0 !== I.avail_out && S !== ty.Z_STREAM_END && (0 !== I.avail_in || v !== ty.Z_FINISH && v !== ty.Z_SYNC_FLUSH) || ("string" === this.options.to ? (_ = O_.utf8border(I.output, I.next_out), C = I.next_out - _, E = O_.buf2string(I.output, _), I.next_out = C, I.avail_out = b - C, C && zS.arraySet(I.output, I.output, _, C, 0), this.onData(E)) : this.onData(zS.shrinkBuf(I.output, I.next_out)))), 0 === I.avail_in && 0 === I.avail_out && (R = !0);
        }while ((I.avail_in > 0 || 0 === I.avail_out) && S !== ty.Z_STREAM_END);
        return S === ty.Z_STREAM_END && (v = ty.Z_FINISH), v === ty.Z_FINISH ? (S = ey.inflateEnd(this.strm), this.onEnd(S), this.ended = !0, S === ty.Z_OK) : v !== ty.Z_SYNC_FLUSH || (this.onEnd(ty.Z_OK), I.avail_out = 0, !0);
    }, Inflate.prototype.onData = function(g) {
        this.chunks.push(g);
    }, Inflate.prototype.onEnd = function(g) {
        g === ty.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = zS.flattenChunks(this.chunks)), this.chunks = [], this.err = g, this.msg = this.strm.msg;
    };
    var ry = {
        Inflate: Inflate,
        inflate: inflate$1,
        inflateRaw: inflateRaw,
        ungzip: inflate$1
    }, ay = {};
    (0, zS.assign)(ay, $_, ry, ty);
    var sy = ay;
    function defer$1() {
        let g, f, S = !0;
        return {
            isPending: ()=>S,
            promise: new Promise((S, v)=>{
                g = S, f = v;
            }),
            resolve: (f)=>{
                S && (g(f), S = !1);
            },
            reject: (g)=>{
                S && (f(g), S = !1);
            }
        };
    }
    function sleep(g) {
        return new Promise((f)=>_setTimeout(f, g));
    }
    function _setTimeout(g, f) {
        return globalThis.setTimeout(g, f);
    }
    function _clearTimeout(g) {
        globalThis.clearTimeout(g);
    }
    function wait(g, f) {
        const S = defer$1();
        let v;
        try {
            v = g();
        } catch (g) {
            return Promise.reject(S.reject(g));
        }
        if (f < 0) return v.finally(()=>{
            S.resolve(v);
        }), S.promise;
        const _ = _setTimeout(()=>{
            S.isPending() && S.reject(new CallingCommunicationError({
                defaultError: O.INTERNAL.OPERATION_TIMEDOUT
            }));
        }, f);
        return v.catch((g)=>{
            _clearTimeout(_), S.isPending() && S.reject(g);
        }).finally(()=>{
            _clearTimeout(_), S.isPending() && S.resolve(v);
        }), S.promise;
    }
    function dictOrderGreaterFirst(g, f) {
        var S = g.toString(), v = f.toString();
        return S > v ? 1 : S < v ? -1 : 0;
    }
    var oy = dictOrderGreaterFirst;
    function _classCallCheck(g, f) {
        if (!(g instanceof f)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(g, f) {
        for(var S = 0; S < f.length; S++){
            var v = f[S];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(g, v.key, v);
        }
    }
    function _createClass(g, f, S) {
        return f && _defineProperties(g.prototype, f), S && _defineProperties(g, S), g;
    }
    function _defineProperty(g, f, S) {
        return f in g ? Object.defineProperty(g, f, {
            value: S,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : g[f] = S, g;
    }
    var ly = function() {
        function PriorityQueue() {
            var g = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).comparator, f = void 0 === g ? oy : g;
            _classCallCheck(this, PriorityQueue), _defineProperty(this, "comparator", void 0), this.comparator = f;
        }
        return _createClass(PriorityQueue, null, [
            {
                key: "from",
                value: function from(g, f) {
                    throw new Error("not implemented");
                }
            }
        ]), _createClass(PriorityQueue, [
            {
                key: "clear",
                value: function clear() {
                    throw new Error("not implemented");
                }
            },
            {
                key: "toArray",
                value: function toArray() {
                    throw new Error("not implemented");
                }
            },
            {
                key: "push",
                value: function push(g) {
                    throw new Error("not implemented");
                }
            },
            {
                key: "enqueue",
                value: function enqueue(g) {
                    return this.push(g);
                }
            },
            {
                key: "top",
                value: function top() {
                    throw new Error("not implemented");
                }
            },
            {
                key: "peek",
                value: function peek() {
                    return this.top();
                }
            },
            {
                key: "pop",
                value: function pop() {
                    throw new Error("not implemented");
                }
            },
            {
                key: "dequeue",
                value: function dequeue() {
                    return this.pop();
                }
            },
            {
                key: "merge",
                value: function merge(g) {
                    throw new Error("not implemented");
                }
            },
            {
                key: "isEmpty",
                value: function isEmpty() {
                    throw new Error("not implemented");
                }
            },
            {
                key: "length",
                get: function get() {
                    throw new Error("not implemented");
                }
            }
        ]), PriorityQueue;
    }();
    function _typeof(g) {
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(g) {
            return typeof g;
        } : function _typeof(g) {
            return g && "function" == typeof Symbol && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
        }, _typeof(g);
    }
    function _toConsumableArray(g) {
        return _arrayWithoutHoles(g) || _iterableToArray(g) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _iterableToArray(g) {
        if (Symbol.iterator in Object(g) || "[object Arguments]" === Object.prototype.toString.call(g)) return Array.from(g);
    }
    function _arrayWithoutHoles(g) {
        if (Array.isArray(g)) {
            for(var f = 0, S = new Array(g.length); f < g.length; f++)S[f] = g[f];
            return S;
        }
    }
    function _classCallCheck$1(g, f) {
        if (!(g instanceof f)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$1(g, f) {
        for(var S = 0; S < f.length; S++){
            var v = f[S];
            v.enumerable = v.enumerable || !1, v.configurable = !0, "value" in v && (v.writable = !0), Object.defineProperty(g, v.key, v);
        }
    }
    function _createClass$1(g, f, S) {
        return f && _defineProperties$1(g.prototype, f), S && _defineProperties$1(g, S), g;
    }
    function _possibleConstructorReturn(g, f) {
        return !f || "object" !== _typeof(f) && "function" != typeof f ? _assertThisInitialized(g) : f;
    }
    function _getPrototypeOf(g) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(g) {
            return g.__proto__ || Object.getPrototypeOf(g);
        }, _getPrototypeOf(g);
    }
    function _assertThisInitialized(g) {
        if (void 0 === g) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return g;
    }
    function _inherits(g, f) {
        if ("function" != typeof f && null !== f) throw new TypeError("Super expression must either be null or a function");
        g.prototype = Object.create(f && f.prototype, {
            constructor: {
                value: g,
                writable: !0,
                configurable: !0
            }
        }), f && _setPrototypeOf(g, f);
    }
    function _setPrototypeOf(g, f) {
        return _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(g, f) {
            return g.__proto__ = f, g;
        }, _setPrototypeOf(g, f);
    }
    function _defineProperty$1(g, f, S) {
        return f in g ? Object.defineProperty(g, f, {
            value: S,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : g[f] = S, g;
    }
    function getLargestIndex(g, f, S) {
        var v = 2 * f, _ = 2 * f + 1, C = f;
        return v < g.length && S(g[C], g[v]) < 0 && (C = v), _ < g.length && S(g[C], g[_]) < 0 && (C = _), C;
    }
    function heapify(g, f, S) {
        var v = getLargestIndex(g, f, S);
        if (v !== f) {
            var _ = g[f];
            g[f] = g[v], g[v] = _, heapify(g, v, S);
        }
    }
    function heapifyAll(g) {
        for(var f = Math.floor(g.collection.length / 2) - 1; f >= 0; --f)heapify(g.collection, f, g.comparator);
    }
    var cy, dy, uy, hy, gy, py, my, fy = function(g) {
        function BinaryHeap() {
            var g, f;
            _classCallCheck$1(this, BinaryHeap);
            for(var S = arguments.length, v = new Array(S), _ = 0; _ < S; _++)v[_] = arguments[_];
            return _defineProperty$1(_assertThisInitialized(f = _possibleConstructorReturn(this, (g = _getPrototypeOf(BinaryHeap)).call.apply(g, [
                this
            ].concat(v)))), "collection", []), f;
        }
        return _inherits(BinaryHeap, g), _createClass$1(BinaryHeap, [
            {
                key: "clear",
                value: function clear() {
                    this.collection.length = 0;
                }
            },
            {
                key: "toArray",
                value: function toArray() {
                    return _toConsumableArray(this.collection).sort(this.comparator);
                }
            },
            {
                key: "top",
                value: function top() {
                    if (0 === this.length) throw new Error("invalid operation: top() called for empty BinaryHeap");
                    return this.collection[0];
                }
            },
            {
                key: "pop",
                value: function pop() {
                    if (0 === this.length) throw new Error("invalid operation: pop() called for empty BinaryHeap");
                    var g = this.collection[0];
                    return this.collection.length > 1 ? (this.collection[0] = this.collection.pop(), heapify(this.collection, 0, this.comparator)) : this.collection.pop(), g;
                }
            },
            {
                key: "push",
                value: function push(g) {
                    this.collection.push(g);
                    for(var f = this.collection, S = f.length - 1, v = Math.floor(S / 2); S > 0 && this.comparator(f[v], f[S]) < 0; S = v, v = Math.floor(v / 2)){
                        var _ = f[S];
                        f[S] = f[v], f[v] = _;
                    }
                }
            },
            {
                key: "merge",
                value: function merge(g) {
                    this.collection = g instanceof BinaryHeap ? this.collection.concat(g.collection) : this.collection.concat(g.toArray()), heapifyAll(this), g.clear();
                }
            },
            {
                key: "isEmpty",
                value: function isEmpty() {
                    return !this.collection.length;
                }
            },
            {
                key: "length",
                get: function get() {
                    return this.collection.length;
                }
            }
        ], [
            {
                key: "from",
                value: function from(g) {
                    var f = new BinaryHeap(arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return f.collection = Array.from(g), heapifyAll(f), f;
                }
            }
        ]), BinaryHeap;
    }(ly), Sy = fy;
    class NotificationManager$1 {
        addNotificationListener(g) {
            this.listeners.find((f)=>f === g) || this.listeners.push(g);
        }
        removeNotificationListener(g) {
            this.listeners = this.listeners.filter((f)=>f !== g);
        }
        eventsSent(g) {
            const f = JSON.stringify(g);
            this._logger.log(`Notification Manager sent telemetry events ${f}`), this.listeners.forEach((f)=>f.eventsSent && f.eventsSent(g));
        }
        eventsDiscarded(g, f) {
            this._logger.log(`Notification Manager discarded telemetry events ${JSON.stringify(g)}, reason ${f} adding to retry buffer`), g.forEach((g)=>{
                g.latency = g.latency || js.Normal;
                const f = g;
                (f.sendAttempt || 0) <= getAcsEcsConfig().telemetry.discardedEventsMaxRetries ? this._discardedEventsBufferPQ.push(f) : this._logger.log(`Notification Manager dropping event due to too many retries ${JSON.stringify(g)}`);
            });
            const S = getAcsEcsConfig().telemetry.discardedEventsBufferMaxLength;
            for(; this._discardedEventsBufferPQ.length > S;)this._logger.log(` dropping event from retry buffer ${this._discardedEventsBufferPQ.dequeue()} due to overflow`);
            this.listeners.forEach((S)=>S.eventsDiscarded && S.eventsDiscarded(g, f));
        }
        getDiscardedEvents() {
            const g = [], f = this._discardedEventsBufferPQ.length;
            for(let S = 0; S < f; S++)g.push(this._discardedEventsBufferPQ.dequeue());
            return g;
        }
        constructor(g, f){
            this._tenantId = g, this.listeners = [], this._logger = f.createChild(`TelemetryLogger[${g}]`);
            const S = this._tenantId;
            f.log(`Notification Manager Notification Manager logger initialized for tenant ${S}`), this._discardedEventsBufferPQ = new Sy({
                comparator: (g, f)=>f.latency - g.latency
            });
        }
    }
    class TelemetryLogManager {
        getTelemetryLoggers() {
            return this._telemetryLoggers;
        }
        getEventsBufferMap() {
            return this._eventsBufferMap;
        }
        isInitialized() {
            return this._initialized;
        }
        getCloudType() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.cloudType;
        }
        getAcsResourceId() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.acsResourceId;
        }
        getClientId() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.clientId;
        }
        initialize(g) {
            if (!g.cloudType) throw this._logger.error("Failed to initialize telemetry loggers, invalid cloud type provided."), new CallingCommunicationError({
                defaultError: O.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE_INVALID_CLOUD_TYPE
            });
            if (this._initialized) throw this._logger.error("Failed to initialize telemetry loggers, telemetry log manager is already initialized."), new CallingCommunicationError({
                defaultError: O.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE_ALREADY_INITIALIZED
            });
            this._telemetryLoggers.forEach((f, S)=>{
                try {
                    f.initialize(g), this._logger.log(`Initialized and flushed buffered telemetry logger for ${S}`);
                } catch (g) {
                    this._logger.warn(`Failed to initialize and flush buffered telemetry logger for ${S}`), this._telemetryLoggers.delete(S);
                }
            }), this._initialized = !0, this._caConfigBag = g, this._logger.log(`Telemetry log manager has been initialized for Call Client: ${this._caConfigBag.clientId}`);
        }
        clearTelemetryLoggers() {
            const g = this._telemetryLoggers.size;
            return this._telemetryLoggers = new Map, this._caConfigBag = void 0, this._initialized = !1, g;
        }
        getMediaEventReportedPromise(g) {
            if (!this._mediaEventsReportedForTheCall[g]) {
                const f = defer();
                f.promise.catch(noop), this._mediaEventsReportedForTheCall[g] = f;
            }
            return this._mediaEventsReportedForTheCall[g].promise;
        }
        _reportMediaEventForTheCall(g) {
            if (this._mediaEventsReportedForTheCall[g]) this._mediaEventsReportedForTheCall[g].resolve();
            else {
                const f = defer();
                f.promise.catch(noop), f.resolve(), this._mediaEventsReportedForTheCall[g] = f;
            }
        }
        _getEventDataWithoutPii(g) {
            const f = {};
            if (g.properties) for (const S of Object.keys(g.properties)){
                const v = g.properties[S];
                var _v_value, _v_piiKind;
                f[S] = {
                    value: (_v_value = v === null || v === void 0 ? void 0 : v.value) !== null && _v_value !== void 0 ? _v_value : v,
                    kind: (_v_piiKind = v === null || v === void 0 ? void 0 : v.piiKind) !== null && _v_piiKind !== void 0 ? _v_piiKind : 0
                };
            }
            return f;
        }
        sendEvent(g, f) {
            try {
                var _S_data;
                if (this._logger.debug(`sending event=${g.name}`), this.checkIfEventIsBlocked(g) || this.shouldLimitSendingTelemetry(g.name) || this.isRateLimitExceeded(g.name)) return void this._logger.debug(`event=${g.name} is blocked`);
                const S = {
                    name: g.name,
                    data: g.properties
                };
                (S === null || S === void 0 ? void 0 : S.name) in Ey && (S.data = this._getEventDataWithoutPii(g)), void 0 === S.data && (S.data = {}), (S === null || S === void 0 ? void 0 : S.name) === Ey.mdsc_webrtc_session && this._reportMediaEventForTheCall(S === null || S === void 0 ? void 0 : (_S_data = S.data) === null || _S_data === void 0 ? void 0 : _S_data.CorrelationId), g.priority, S.latency = g.priority;
                const v = getAcsEcsConfig().telemetryEvents.eventNameToPriority.eventName.indexOf(g.name);
                -1 !== v && (S.latency = getAcsEcsConfig().telemetryEvents.eventNameToPriority.priority[v]), S.data.sdkVersion = this._sdkInternaVersion, S.data.platformId = getPlatformId();
                const _ = `${getPlatformId()}/${this._sdkInternaVersion}`;
                S.data.uiVersion = _, S.data.ui_version = _, S.data.Platform_Uiversion = _, S.data.userAgent = `${this.sdkDiagnosticInformation} ${navigator.userAgent}`, S.data.clientTimestamp = +new Date, S.data.customProxyAndRelayUsage = this.getCustomProxyAndRelayTag();
                const C = g.tenant;
                let E = this._eventsBufferMap.get(C);
                E || (E = this._eventsBufferMap.set(C, []).get(C));
                let T = this._telemetryLoggers.get(C);
                if (T || (T = new TelemetryLogger(C, this._logger, E, this._acsProxy), this._telemetryLoggers.set(C, T), this._logger.log(`Created telemetry logger for ${C}`)), this._initialized) {
                    var _T_getAppInsightsCore;
                    if (!T.isInitialized()) try {
                        T.initialize(this._caConfigBag), this._logger.log(`Created and initialized telemetry logger for ${C}`);
                    } catch (g) {
                        throw this._telemetryLoggers.delete(C), E === null || E === void 0 ? void 0 : E.push(S), this._logger.error(`Failed to create and initialize telemetry logger for ${C}`), new CallingCommunicationError({
                            defaultError: O.INTERNAL.TELEMETRY_FAILED_TO_INITIALIZE,
                            defaultErrorMessageArgs: [
                                C
                            ]
                        });
                    }
                    f && ((_T_getAppInsightsCore = T.getAppInsightsCore()) === null || _T_getAppInsightsCore === void 0 ? void 0 : _T_getAppInsightsCore.addNotificationListener(f)), T.sendEvent(S);
                } else E === null || E === void 0 ? void 0 : E.push(S);
            } catch (f) {
                this._logger.warn(`Failed to send event ${g === null || g === void 0 ? void 0 : g.name}`);
            }
        }
        async flushAllEvents(g) {
            if (this._logger.debug(`flushing events: ${this._telemetryLoggers.size}`), -1 !== getAcsEcsConfig().telemetry.telemetryFlushTimeout) {
                const flushLogger = (f, S)=>{
                    try {
                        const v = defer();
                        v.promise.catch(noop);
                        const _ = wait(async ()=>(S === af && await this.getMediaEventReportedPromise(g), v.promise), getAcsEcsConfig().telemetry.telemetryFlushTimeout);
                        return f.flushEvents(()=>{
                            this._logger.debug("events flushed"), v.resolve();
                        }), _.then(noop);
                    } catch (g) {
                        throw new CallingCommunicationError({
                            defaultError: O.INTERNAL.TELEMETRY_FAILED_TO_FLUSH
                        });
                    }
                }, f = [];
                return this._telemetryLoggers.forEach((g, S)=>{
                    f.push(flushLogger(g, S).catch(()=>{
                        this._logger.warn("Failed to flush telemetry");
                    }));
                }), Promise.all(f);
            }
            this._telemetryLoggers.forEach((g)=>{
                try {
                    g.flushEvents();
                } catch (g) {
                    this._logger.warn("Failed to flush telemetry");
                }
            });
        }
        checkIfEventIsBlocked(g) {
            var _g_properties;
            const f = g.name, S = (_g_properties = g.properties) === null || _g_properties === void 0 ? void 0 : _g_properties.kindOfEvent, v = getAcsEcsConfig().telemetry.blockedEvents, _ = getAcsEcsConfig().telemetry.blockedKindOfEvents;
            return v.includes(f) || void 0 !== _.find((g)=>g.name == f && g.kindOfEvents.includes(S));
        }
        shouldLimitSendingTelemetry(g) {
            return getAcsEcsConfig().telemetry.limit.outSideCall.enabled && (0 === getAcsEcsConfig().telemetry.limit.outSideCall.includedEvents.length || getAcsEcsConfig().telemetry.limit.outSideCall.includedEvents.includes(g)) && !getAcsEcsConfig().telemetry.limit.outSideCall.excludedEvents.includes(g) && TelemetryLogManager.callEndTimestamp !== Number.MAX_SAFE_INTEGER && TelemetryLogManager.callEndTimestamp + getAcsEcsConfig().telemetry.limit.outSideCall.deltaTimeInMs - Date.now() < 0;
        }
        isRateLimitExceeded(g) {
            const f = this._telemetryRateLimit.get(g);
            if (f) {
                const S = Date.now();
                if (S - f.windowStartTime > f.windowSizeInMs && (f.windowStartTime = S, f.eventCount = 0), f.eventCount++, f.eventCount > f.maxEventPerWindow) return this._logger.info(`Telemetry event ${g} is rate limited`), !0;
            }
            return !1;
        }
        getCustomProxyAndRelayTag() {
            var _this__acsProxy, _this__acsCustomRelayManager;
            var _this__acsProxy_proxyInUse, _this__acsCustomRelayManager_hasRelayConfig;
            const g = (_this__acsProxy_proxyInUse = (_this__acsProxy = this._acsProxy) === null || _this__acsProxy === void 0 ? void 0 : _this__acsProxy.proxyInUse) !== null && _this__acsProxy_proxyInUse !== void 0 ? _this__acsProxy_proxyInUse : !1, f = (_this__acsCustomRelayManager_hasRelayConfig = (_this__acsCustomRelayManager = this._acsCustomRelayManager) === null || _this__acsCustomRelayManager === void 0 ? void 0 : _this__acsCustomRelayManager.hasRelayConfig) !== null && _this__acsCustomRelayManager_hasRelayConfig !== void 0 ? _this__acsCustomRelayManager_hasRelayConfig : !1;
            return g && f ? lS.usedProxyAndNonMsftTurn : g ? lS.onlyUsedProxy : f ? lS.onlyUsedNonMsftTurn : lS.noCustomProxyAndTurnUsed;
        }
        constructor(g, f, S, v){
            this._telemetryLoggers = new Map, this._eventsBufferMap = new Map, this._initialized = !1, this.sdkDiagnosticInformation = "", this._telemetryRateLimit = new Map, this._mediaEventsReportedForTheCall = {}, this._logger = g.createChild("TelemetryLogManager"), this.sdkDiagnosticInformation = f, this._sdkInternaVersion = getSdkInternalVersion(), this._acsProxy = S, this._acsCustomRelayManager = v, getAcsEcsConfig().telemetry.limit.rates.forEach((g)=>{
                this._telemetryRateLimit.set(g.eventName, {
                    ...g,
                    windowStartTime: Date.now(),
                    eventCount: 0
                });
            });
        }
    }
    TelemetryLogManager.telemetryPayloadBytesOriginal = 0, TelemetryLogManager.telemetryPayloadBytesCompressed = 0, TelemetryLogManager.callEndTimestamp = 0;
    class TelemetryLogger {
        initialize(g) {
            if (this._initialized) this._logger.warn(`Telemetry logger for tenant: ${this._tenantId}, already initialized`);
            else try {
                var _getAcsEcsConfig_calling_eudb, _getAcsEcsConfig_calling;
                const f = new Qp;
                this._appInsightsCore = new $s, this._postChannel = new fg;
                const S = {
                    instrumentationKey: this._tenantId,
                    extensions: [
                        this._postChannel,
                        f
                    ],
                    disableCookiesUsage: !0
                }, v = {
                    populateBrowserInfo: !0,
                    populateOperatingSystemInfo: !0
                };
                void 0 === S.extensionConfig && (S.extensionConfig = {}), S.extensionConfig[f.identifier] = v;
                const _ = {
                    overrideEndpointUrl: this.getAriaCollectorUrl(g),
                    payloadPreprocessor: getAcsEcsConfig().telemetry.gzipTelemetryPayload ? (g, f)=>{
                        this.gzipPayload(g, f);
                    } : void 0
                };
                if (S.extensionConfig[this._postChannel.identifier] = _, Object.keys((_getAcsEcsConfig_calling = getAcsEcsConfig().calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : (_getAcsEcsConfig_calling_eudb = _getAcsEcsConfig_calling.eudb) === null || _getAcsEcsConfig_calling_eudb === void 0 ? void 0 : _getAcsEcsConfig_calling_eudb.acsCompliantEvents).length > 0 && (vy = {
                    ...vy,
                    ...getAcsEcsConfig().calling.eudb.acsCompliantEvents
                }), getAcsEcsConfig().telemetry.localStorageEnable) {
                    var _S_extensions;
                    const g = new ud;
                    (_S_extensions = S.extensions) === null || _S_extensions === void 0 ? void 0 : _S_extensions.push(g);
                    const f = {
                        storageKey: "WebSdkTelemetry"
                    };
                    S.extensionConfig[g.identifier] = f;
                }
                this._NotificationManager = new NotificationManager$1(this._tenantId, this._logger), this._appInsightsCore.initialize(S, [], void 0, this._NotificationManager), this._caConfigBag = g, this.scheduleDiscardedTelemetryRetry(), this._initialized = !0, this._eventsBuffer.forEach((g)=>{
                    this.sendEvent(g);
                }), this._eventsBuffer.splice(0, this._eventsBuffer.length);
            } catch (g) {
                throw this._logger.error(`Failed to initialize telemetry logger for tenant: ${this._tenantId}`), new CallingCommunicationError({
                    defaultError: O.INTERNAL.TELEMETRY_LOGGER_INIT_FAIL
                });
            }
        }
        getCloudType() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.cloudType;
        }
        getAcsResourceId() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.acsResourceId;
        }
        getClientId() {
            var _this__caConfigBag;
            return (_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.clientId;
        }
        isInitialized() {
            return this._initialized;
        }
        getAppInsightsCore() {
            return this._appInsightsCore;
        }
        sendEvent(g) {
            var _this__caConfigBag, _g_name, _this__caConfigBag1, _this__caConfigBag2, _this__caConfigBag3, _this__caConfigBag4;
            this._initialized && ((g === null || g === void 0 ? void 0 : g.name) in vy && this.appendEudbComplianceRegionToEvent(g), (g === null || g === void 0 ? void 0 : g.data) && (g.data.clientId = ((_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.clientId) || "", 0 === (g === null || g === void 0 ? void 0 : (_g_name = g.name) === null || _g_name === void 0 ? void 0 : _g_name.indexOf("mdsc_webrtc")) ? g.data.metrics_AcsResourceId = ((_this__caConfigBag1 = this._caConfigBag) === null || _this__caConfigBag1 === void 0 ? void 0 : _this__caConfigBag1.acsResourceId) || "" : g.data.AcsResourceId = ((_this__caConfigBag2 = this._caConfigBag) === null || _this__caConfigBag2 === void 0 ? void 0 : _this__caConfigBag2.acsResourceId) || "", g.data.cloudType = ((_this__caConfigBag3 = this._caConfigBag) === null || _this__caConfigBag3 === void 0 ? void 0 : _this__caConfigBag3.cloudType) || "", g.data.identityType = ((_this__caConfigBag4 = this._caConfigBag) === null || _this__caConfigBag4 === void 0 ? void 0 : _this__caConfigBag4.identityType) || ""), this.sendAppInsightsCoreEvent(g));
        }
        scheduleDiscardedTelemetryRetry() {
            const g = getAcsEcsConfig().telemetry.discardedTelemetryRetryTimeout;
            let f = setInterval(async ()=>{
                var _this__NotificationManager;
                this._networkOnline ? ((_this__NotificationManager = this._NotificationManager) === null || _this__NotificationManager === void 0 ? void 0 : _this__NotificationManager.getDiscardedEvents().forEach((g)=>{
                    this.sendEvent(g);
                }), this._telemetryRetryIntervalRunning = !0) : (this._logger.log("browser lost network access stopping telemetry send retry"), clearInterval(f), this._telemetryRetryIntervalRunning = !1);
            }, g);
        }
        sendAppInsightsCoreEvent(g) {
            var _this__appInsightsCore;
            (_this__appInsightsCore = this._appInsightsCore) === null || _this__appInsightsCore === void 0 ? void 0 : _this__appInsightsCore.track(g);
        }
        flushEvents(g) {
            if (this._initialized && this._postChannel) {
                const f = getAcsEcsConfig().telemetry.asyncTelemetryFlush;
                this._postChannel.flush(f, g);
            }
        }
        getAriaCollectorUrl(g) {
            const f = isEudbConfigurationsApplicable(g.identityType, g.region);
            let S;
            if (g.identityType === um.Enterprise) S = f ? nm.EnterpriseEUDB : nm.Enterprise;
            else switch(g.cloudType){
                case rm.Public:
                    S = f ? nm.PublicEUDB : nm.Public;
                    break;
                case rm.GccHigh:
                    S = nm.GccHigh;
                    break;
                case rm.Dod:
                    S = nm.Dod;
                    break;
                case rm.AirGap08:
                    S = nm.AirGap08;
                    break;
                case rm.AirGap09:
                    S = nm.AirGap09;
                    break;
                default:
                    S = nm.Public;
            }
            return this._acsProxy ? this._acsProxy.proxyfyUrl(S) : S;
        }
        gzipPayload(g, f) {
            try {
                TelemetryLogManager.telemetryPayloadBytesOriginal += getSizeInBytes(g.data, this._logger), g.data = sy.gzip(g.data), g.urlString += "&content-encoding=gzip", TelemetryLogManager.telemetryPayloadBytesCompressed += getSizeInBytes(g.data, this._logger);
            } catch (g) {
                this._logger.warn("Failed to gzip with pako: ", g);
            }
            f(g);
        }
        getRegion(g) {
            if (this._caConfigBag && isRgnClaimApplicable(this._caConfigBag.identityType)) switch(g){
                case "emea":
                case "de":
                    return vm.EMEA;
                case "apac":
                    return vm.APAC;
                case "noam":
                case "amer":
                    return vm.NOAM;
                default:
                    return this._logger.log(`Unable to map region \`${g}\`, to EudbTenantRegion`), vm.UNKNOWN;
            }
            return g && pm.includes(g) ? vm.EMEA : g && mm.includes(g) ? vm.APAC : g && fm.includes(g) ? vm.NOAM : (this._logger.log(`Unable to map region \`${g}\`, to EudbTenantRegion`), vm.UNKNOWN);
        }
        appendEudbComplianceRegionToEvent(g) {
            var _this__caConfigBag;
            let f = this.getTenantComplianceRegion();
            const S = this.getRegion((_this__caConfigBag = this._caConfigBag) === null || _this__caConfigBag === void 0 ? void 0 : _this__caConfigBag.region);
            if (g.data) {
                let v = {};
                v[_y] = f, v[yy] = S, g.data[Cy] = v;
            }
        }
        getTenantComplianceRegion() {
            return this._caConfigBag && isEudbConfigurationsApplicable(this._caConfigBag.identityType, this._caConfigBag.region) ? Sm.EU : Sm.RoW;
        }
        constructor(g, f, S, v){
            this._tenantId = g, this._eventsBuffer = S, this._initialized = !1, this._networkOnline = !0, this._telemetryRetryIntervalRunning = !1, this._logger = f.createChild(`TelemetryLogger[${g}]`), this._acsProxy = v, window.addEventListener("online", (g)=>{
                this._networkOnline = g.detail, this._networkOnline && this._initialized && !this._telemetryRetryIntervalRunning && (this._logger.log("browser network back online starting telemetry send retry"), this.scheduleDiscardedTelemetryRetry());
            });
        }
    }
    !function(g) {
        g.remote_view = "remote_view", g.remote_stream = "remote_stream", g.network_quality = "network_quality", g.video_device_issue = "video_device_issue", g.other_diagnostic = "other_diagnostic", g.logger_event = "logger_event", g.number_of_participants = "number_of_participants", g.media_metrics_device_events = "media_metrics_device_events", g.sdk_active_in_another_tab = "sdk_active_in_another_tab", g.network_changed = "network_changed", g.video_max_capabilities = "video_max_capabilities";
    }(cy || (cy = {})), function(g) {
        g.acs_calling_call_attempt = "acs_calling_call_attempt", g.acs_calling_call_connected = "acs_calling_call_connected", g.acs_calling_call_failed = "acs_calling_call_failed", g.acs_calling_call_accept_attempt = "acs_calling_call_accept_attempt", g.acs_calling_call_accept_connected = "acs_calling_call_accept_connected", g.acs_calling_call_accept_failed = "acs_calling_call_accept_failed", g.acs_calling_call_reject_attempt = "acs_calling_call_reject_attempt", g.acs_calling_call_reject_success = "acs_calling_call_reject_success", g.acs_calling_call_reject_failed = "acs_calling_call_reject_failed", g.acs_calling_call_hangup_attempt = "acs_calling_call_hangup_attempt", g.acs_calling_call_hangup_success = "acs_calling_call_hangup_success", g.acs_calling_call_hangup_failure = "acs_calling_call_hangup_failure", g.acs_calling_call_progress = "acs_calling_call_progress", g.acs_calling_stack_init = "acs_calling_stack_init", g.acs_calling_get_device_manager = "acs_calling_get_device_manager", g.acs_calling_config_fetched_attempt = "acs_calling_config_fetched_attempt", g.acs_calling_config_fetched_success = "acs_calling_config_fetched_success", g.acs_calling_config_fetched_failure = "acs_calling_config_fetched_failure", g.acs_calling_signaling_init = "acs_calling_signaling_init", g.acs_calling_call_agent = "acs_calling_call_agent", g.acs_calling_call_agent_init_attempt = "acs_calling_call_agent_init_attempt", g.acs_calling_call_agent_init_success = "acs_calling_call_agent_init_success", g.acs_calling_call_agent_init_failure = "acs_calling_call_agent_init_failure", g.acs_calling_create_view_attempt = "acs_calling_create_view_attempt", g.acs_calling_create_view_success = "acs_calling_create_view_success", g.acs_calling_create_view_failure = "acs_calling_create_view_failure", g.acs_calling_dispose_view_attempt = "acs_calling_dispose_view_attempt", g.acs_calling_dispose_view_success = "acs_calling_dispose_view_success", g.acs_calling_dispose_view_failure = "acs_calling_dispose_view_failure", g.acs_calling_start_video_attempt = "acs_calling_start_video_attempt", g.acs_calling_start_video_success = "acs_calling_start_video_success", g.acs_calling_start_video_failure = "acs_calling_start_video_failure", g.acs_calling_stop_video_on_ufd_attempt = "acs_calling_stop_video_on_ufd_attempt", g.acs_calling_stop_video_attempt = "acs_calling_stop_video_attempt", g.acs_calling_stop_video_success = "acs_calling_stop_video_success", g.acs_calling_stop_video_failure = "acs_calling_stop_video_failure", g.acs_calling_call_hold_and_resume = "acs_calling_call_hold_and_resume", g.acs_calling_start_screen_share = "acs_calling_start_screen_share", g.acs_calling_stop_screen_share = "acs_calling_stop_screen_share", g.acs_calling_audio_stream_volume = "acs_calling_audio_stream_volume", g.acs_calling_call_stats = "acs_calling_call_stats", g.acs_calling_call_stats_and_ufds = "acs_calling_call_stats_and_ufds", g.acs_calling_participant_added_or_removed = "acs_calling_participant_added_or_removed", g.acs_calling_adp_attempt = "acs_calling_adp_attempt", g.acs_calling_adp_success = "acs_calling_adp_success", g.acs_calling_adp_failure = "acs_calling_adp_failure", g.acs_calling_client_operations = "acs_calling_client_operations", g.acs_calling_device_permission_changed = "acs_calling_device_permission_changed", g.acs_calling_local_audio_source_changed = "acs_calling_local_audio_source_changed", g.acs_calling_start_audio_stream_track = "acs_calling_start_audio_stream_track", g.acs_calling_stop_audio_stream_track = "acs_calling_stop_audio_stream_track", g.acs_calling_get_remote_audio_stream_track = "acs_calling_get_remote_audio_stream_track", g.acs_calling_get_raw_device_media_stream = "acs_calling_get_raw_device_media_stream", g.acs_calling_media_stream = "acs_calling_media_stream", g.acs_calling_page_hidden = "acs_calling_page_hidden", g.acs_calling_orientation_changed = "acs_calling_orientation_changed", g.acs_calling_token_expiration_changed = "acs_calling_token_expiration_changed", g.acs_calling_token_expiration_changed_failure = "acs_calling_token_expiration_changed_failure", g.acs_calling_token_has_no_data_location = "acs_calling_token_has_no_data_location", g.acs_calling_mute_on_ufd_attempt = "acs_calling_mute_on_ufd_attempt", g.acs_calling_mute_attempt = "acs_calling_mute_attempt", g.acs_calling_mute_success = "acs_calling_mute_success", g.acs_calling_mute_failure = "acs_calling_mute_failure", g.acs_calling_unmute_attempt = "acs_calling_unmute_attempt", g.acs_calling_unmute_success = "acs_calling_unmute_success", g.acs_calling_unmute_failure = "acs_calling_unmute_failure", g.acs_calling_start_audio_attempt = "acs_calling_start_audio_attempt", g.acs_calling_start_audio_success = "acs_calling_start_audio_success", g.acs_calling_start_audio_failure = "acs_calling_start_audio_failure", g.acs_calling_unmute_speaker_attempt = "acs_calling_unmute_speaker_attempt", g.acs_calling_unmute_speaker_success = "acs_calling_unmute_speaker_success", g.acs_calling_unmute_speaker_failure = "acs_calling_unmute_speaker_failure", g.acs_calling_stop_audio_attempt = "acs_calling_stop_audio_attempt", g.acs_calling_stop_audio_success = "acs_calling_stop_audio_success", g.acs_calling_stop_audio_failure = "acs_calling_stop_audio_failure", g.acs_calling_prevent_stop_audio = "acs_calling_prevent_stop_audio", g.acs_calling_captions = "acs_calling_captions", g.acs_calling_mid_call_media_stats = "acs_calling_mid_call_media_stats", g.acs_calling_mid_call_new_media_stats = "acs_calling_mid_call_new_media_stats", g.acs_calling_mid_call_raw_media_stats = "acs_calling_mid_call_raw_media_stats", g.acs_calling_datachannel = "acs_calling_datachannel", g.acs_calling_datachannel_stats = "acs_calling_datachannel_stats", g.acs_calling_unmixed_audio = "acs_calling_unmixed_audio", g.acs_calling_livestream_stats = "acs_calling_livestream_stats", g.acs_calling_livestream_raw_stats = "acs_calling_livestream_raw_stats", g.acs_calling_survey = "acs_calling_survey", g.mdsc_call_quality_feedback = "mdsc_call_quality_feedback", g.acs_calling_switch_video_source_attempt = "acs_calling_switch_video_source_attempt", g.acs_calling_switch_video_source_success = "acs_calling_switch_video_source_success", g.acs_calling_switch_video_source_failure = "acs_calling_switch_video_source_failure", g.acs_calling_diagnostics_attempt = "acs_calling_diagnostics_attempt", g.acs_calling_diagnostics_result = "acs_calling_diagnostics_result", g.acs_calling_feature_usage = "acs_calling_feature_usage", g.acs_calling_middletier_gateway_fetch_policy = "acs_calling_middletier_gateway_fetch_policy", g.acs_calling_middletier_gateway_emergency_content = "acs_calling_middletier_gateway_emergency_content", g.acs_calling_middletier_gateway_fetch_user_policies_for_captions = "acs_calling_middletier_gateway_fetch_user_policies_for_captions", g.acs_calling_middletier_gateway_api = "acs_calling_middletier_gateway_api", g.acs_calling_call_client_init = "acs_calling_call_client_init", g.acs_calling_tab_events = "acs_calling_tab_events", g.acs_calling_lobby_events = "acs_calling_lobby_events", g.acs_calling_handle_push_notification = "acs_calling_handle_push_notification";
    }(dy || (dy = {})), function(g) {
        g.attempt = "attempt", g.success = "success", g.failure = "failure", g.getter = "getter", g.setter = "setter", g.subscribe = "subscribe", g.unsubscribe = "unsubscribe", g.initialize = "initialize", g.event = "event";
    }(uy || (uy = {})), function(g) {
        g.lobbyAdmit = "lobbyAdmit", g.lobbyAdmitAll = "lobbyAdmitAll", g.lobbyReject = "lobbyReject";
    }(hy || (hy = {})), function(g) {
        g.MuteMicrophone = "MuteMicrophone", g.MuteAllRemoteParticipants = "MuteAllRemoteParticipants", g.MuteSpecificParticipant = "MuteSpecificParticipant", g.UnmuteMicrophone = "UnmuteMicrophone", g.MuteIncomingAudio = "MuteIncomingAudio", g.UnmuteIncomingAudio = "UnmuteIncomingAudio";
    }(gy || (gy = {})), function(g) {
        g.Expected = "expected", g.Unexpected = "unexpected", g.Unknown = "unknown";
    }(py || (py = {})), function(g) {
        g.CaptionsKindChanged = "CaptionsKindChanged", g.FirstCaptionReceived = "FirstCaptionReceived", g.FirstCaptionParsingError = "FirstCaptionParsingError", g.InitializeCaptions = "InitializeCaptions", g.LanguageChanged = "LanguageChanged", g.SetSpokenLanguage = "SetSpokenLanguage", g.SetCaptionLanguage = "SetCaptionLanguage", g.SpokenLanguageChanged = "SpokenLanguageChanged", g.StartCaptions = "StartCaptions", g.StopCaptions = "StopCaptions", g.UpdateEndpointMetadata = "UpdateEndpointMetadata", g.UpdateIsActive = "UpdateIsActive", g.StartDataChannel = "StartDataChannel";
    }(my || (my = {}));
    let vy = {
        ...dy,
        skypecosi_concore_web_csa_conversation_callmodality: "skypecosi_concore_web_csa_conversation_callmodality",
        skypecosi_concore_web_pluginless_modality_session: "skypecosi_concore_web_pluginless_modality_session",
        skypecosi_concore_web_pluginless_call_session: "skypecosi_concore_web_pluginless_call_session",
        skypecosi_concore_web_csa_conversation_httprequest: "skypecosi_concore_web_csa_conversation_httprequest"
    };
    const _y = "tenantComplianceRegion", Cy = "acsCompliancePayload", yy = "tenantRegion";
    var Ey, Ty, Iy, by, Ay, Ry, Py;
    !function(g) {
        g.mdsc_webrtc_session = "mdsc_webrtc_session", g.mdsc_webrtc_session_initial = "mdsc_webrtc_session_initial";
    }(Ey || (Ey = {})), function(g) {
        g.AudioRaw = "AudioRaw", g.VideoRaw = "VideoRaw", g.ScreenSharingRaw = "ScreenSharingRaw", g.VideoRawOrScreenSharingRaw = "VideoRawOrScreenSharingRaw", g.Audio = "Audio", g.Video = "Video";
    }(Ty || (Ty = {})), function(g) {
        g.Local = "Local", g.Remote = "Remote";
    }(Iy || (Iy = {})), function(g) {
        g.getMediaStream = "getMediaStream", g.setMediaStream = "setMediaStream", g.startEffects = "startEffects", g.stopEffects = "stopEffects", g.effectConfigureUpdate = "effectConfigureUpdate", g.isSupported = "isSupported", g.subscribe = "subscribe", g.fpsWarningThresholdReached = "fpsWarningThresholdReached", g.timeForEffectsWarningReached = "timeForEffectsWarningReached", g.effectsError = "effectsError", g.switchSource = "switchSource", g.render = "render", g.watermark = "watermark";
    }(by || (by = {})), function(g) {
        g.stun = "stun", g.turn = "turn", g.turns = "turns";
    }(Ay || (Ay = {})), function(g) {
        g.tcp = "tcp", g.tls = "tls", g.udp = "udp";
    }(Ry || (Ry = {})), function(g) {
        g.Public_App = "Public_App", g.Internal_LargeMeetingVideoRendering = "Internal_LargeMeetingVideoRendering", g.Internal_RemoteVideoStreamDisposed = "Internal_RemoteVideoStreamDisposed";
    }(Py || (Py = {}));
    var wy, My = "object" == typeof Reflect ? Reflect : null, Oy = My && "function" == typeof My.apply ? My.apply : function ReflectApply(g, f, S) {
        return Function.prototype.apply.call(g, f, S);
    };
    function ProcessEmitWarning(g) {
        console && console.warn && console.warn(g);
    }
    wy = My && "function" == typeof My.ownKeys ? My.ownKeys : Object.getOwnPropertySymbols ? function ReflectOwnKeys(g) {
        return Object.getOwnPropertyNames(g).concat(Object.getOwnPropertySymbols(g));
    } : function ReflectOwnKeys(g) {
        return Object.getOwnPropertyNames(g);
    };
    var Dy = Number.isNaN || function NumberIsNaN(g) {
        return g != g;
    };
    function EventEmitter() {
        EventEmitter.init.call(this);
    }
    var Ny = EventEmitter, ky = once;
    EventEmitter.EventEmitter = EventEmitter, EventEmitter.prototype._events = void 0, EventEmitter.prototype._eventsCount = 0, EventEmitter.prototype._maxListeners = void 0;
    var Ly = 10;
    function checkListener(g) {
        if ("function" != typeof g) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof g);
    }
    function _getMaxListeners(g) {
        return void 0 === g._maxListeners ? EventEmitter.defaultMaxListeners : g._maxListeners;
    }
    function _addListener(g, f, S, v) {
        var _, C, E;
        if (checkListener(S), void 0 === (C = g._events) ? (C = g._events = Object.create(null), g._eventsCount = 0) : (void 0 !== C.newListener && (g.emit("newListener", f, S.listener ? S.listener : S), C = g._events), E = C[f]), void 0 === E) E = C[f] = S, ++g._eventsCount;
        else if ("function" == typeof E ? E = C[f] = v ? [
            S,
            E
        ] : [
            E,
            S
        ] : v ? E.unshift(S) : E.push(S), (_ = _getMaxListeners(g)) > 0 && E.length > _ && !E.warned) {
            E.warned = !0;
            var T = new Error("Possible EventEmitter memory leak detected. " + E.length + " " + String(f) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            T.name = "MaxListenersExceededWarning", T.emitter = g, T.type = f, T.count = E.length, ProcessEmitWarning(T);
        }
        return g;
    }
    function onceWrapper() {
        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function _onceWrap(g, f, S) {
        var v = {
            fired: !1,
            wrapFn: void 0,
            target: g,
            type: f,
            listener: S
        }, _ = onceWrapper.bind(v);
        return _.listener = S, v.wrapFn = _, _;
    }
    function _listeners(g, f, S) {
        var v = g._events;
        if (void 0 === v) return [];
        var _ = v[f];
        return void 0 === _ ? [] : "function" == typeof _ ? S ? [
            _.listener || _
        ] : [
            _
        ] : S ? unwrapListeners(_) : arrayClone(_, _.length);
    }
    function listenerCount(g) {
        var f = this._events;
        if (void 0 !== f) {
            var S = f[g];
            if ("function" == typeof S) return 1;
            if (void 0 !== S) return S.length;
        }
        return 0;
    }
    function arrayClone(g, f) {
        for(var S = new Array(f), v = 0; v < f; ++v)S[v] = g[v];
        return S;
    }
    function spliceOne(g, f) {
        for(; f + 1 < g.length; f++)g[f] = g[f + 1];
        g.pop();
    }
    function unwrapListeners(g) {
        for(var f = new Array(g.length), S = 0; S < f.length; ++S)f[S] = g[S].listener || g[S];
        return f;
    }
    function once(g, f) {
        return new Promise(function(S, v) {
            function eventListener() {
                void 0 !== _ && g.removeListener("error", _), S([].slice.call(arguments));
            }
            var _;
            "error" !== f && (_ = function errorListener(S) {
                g.removeListener(f, eventListener), v(S);
            }, g.once("error", _)), g.once(f, eventListener);
        });
    }
    Object.defineProperty(EventEmitter, "defaultMaxListeners", {
        enumerable: !0,
        get: function() {
            return Ly;
        },
        set: function(g) {
            if ("number" != typeof g || g < 0 || Dy(g)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + g + ".");
            Ly = g;
        }
    }), EventEmitter.init = function() {
        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, EventEmitter.prototype.setMaxListeners = function setMaxListeners(g) {
        if ("number" != typeof g || g < 0 || Dy(g)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + g + ".");
        return this._maxListeners = g, this;
    }, EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
    }, EventEmitter.prototype.emit = function emit(g) {
        for(var f = [], S = 1; S < arguments.length; S++)f.push(arguments[S]);
        var v = "error" === g, _ = this._events;
        if (void 0 !== _) v = v && void 0 === _.error;
        else if (!v) return !1;
        if (v) {
            var C;
            if (f.length > 0 && (C = f[0]), C instanceof Error) throw C;
            var E = new Error("Unhandled error." + (C ? " (" + C.message + ")" : ""));
            throw E.context = C, E;
        }
        var T = _[g];
        if (void 0 === T) return !1;
        if ("function" == typeof T) Oy(T, this, f);
        else {
            var I = T.length, b = arrayClone(T, I);
            for(S = 0; S < I; ++S)Oy(b[S], this, f);
        }
        return !0;
    }, EventEmitter.prototype.addListener = function addListener(g, f) {
        return _addListener(this, g, f, !1);
    }, EventEmitter.prototype.on = EventEmitter.prototype.addListener, EventEmitter.prototype.prependListener = function prependListener(g, f) {
        return _addListener(this, g, f, !0);
    }, EventEmitter.prototype.once = function once(g, f) {
        return checkListener(f), this.on(g, _onceWrap(this, g, f)), this;
    }, EventEmitter.prototype.prependOnceListener = function prependOnceListener(g, f) {
        return checkListener(f), this.prependListener(g, _onceWrap(this, g, f)), this;
    }, EventEmitter.prototype.removeListener = function removeListener(g, f) {
        var S, v, _, C, E;
        if (checkListener(f), void 0 === (v = this._events)) return this;
        if (void 0 === (S = v[g])) return this;
        if (S === f || S.listener === f) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete v[g], v.removeListener && this.emit("removeListener", g, S.listener || f));
        else if ("function" != typeof S) {
            for(_ = -1, C = S.length - 1; C >= 0; C--)if (S[C] === f || S[C].listener === f) {
                E = S[C].listener, _ = C;
                break;
            }
            if (_ < 0) return this;
            0 === _ ? S.shift() : spliceOne(S, _), 1 === S.length && (v[g] = S[0]), void 0 !== v.removeListener && this.emit("removeListener", g, E || f);
        }
        return this;
    }, EventEmitter.prototype.off = EventEmitter.prototype.removeListener, EventEmitter.prototype.removeAllListeners = function removeAllListeners(g) {
        var f, S, v;
        if (void 0 === (S = this._events)) return this;
        if (void 0 === S.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== S[g] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete S[g]), this;
        if (0 === arguments.length) {
            var _, C = Object.keys(S);
            for(v = 0; v < C.length; ++v)"removeListener" !== (_ = C[v]) && this.removeAllListeners(_);
            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
        }
        if ("function" == typeof (f = S[g])) this.removeListener(g, f);
        else if (void 0 !== f) for(v = f.length - 1; v >= 0; v--)this.removeListener(g, f[v]);
        return this;
    }, EventEmitter.prototype.listeners = function listeners(g) {
        return _listeners(this, g, !0);
    }, EventEmitter.prototype.rawListeners = function rawListeners(g) {
        return _listeners(this, g, !1);
    }, EventEmitter.listenerCount = function(g, f) {
        return "function" == typeof g.listenerCount ? g.listenerCount(f) : listenerCount.call(g, f);
    }, EventEmitter.prototype.listenerCount = listenerCount, EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? wy(this._events) : [];
    }, Ny.once = ky;
    class BaseCallAgentFeature {
        dispose() {
            this.disposed || (this.eventEmitter.removeAllListeners(), this.disposed = !0);
        }
        constructor(g){
            this.disposed = !1, this.callAgent = g.callAgent, this.callClient = g.callClient, this.eventEmitter = new Ny.EventEmitter;
        }
    }
    class BaseCallClientFeature {
        dispose() {
            this.disposed || (this.eventEmitter.removeAllListeners(), this.disposed = !0);
        }
        constructor(g){
            this.disposed = !1, this.callClient = g.callClient, this.eventEmitter = new Ny.EventEmitter;
        }
    }
    class BaseCallFeature {
        dispose() {
            this.disposed || (this.eventEmitter.removeAllListeners(), this.disposed = !0);
        }
        constructor(g){
            this.disposed = !1, this.call = g.call, this.callAgent = g.callAgent, this.callInfo = g.callInfo, this.eventEmitter = new Ny.EventEmitter;
        }
    }
    class PromiseQueue {
        add(g) {
            var _this__queue;
            this._queue || (this._queue = Promise.resolve());
            let f = g;
            const S = (_this__queue = this._queue) === null || _this__queue === void 0 ? void 0 : _this__queue.then(f);
            return S && (this._queue = S === null || S === void 0 ? void 0 : S.catch((g)=>{
                var _this__logger;
                throw g instanceof CallingCommunicationError ? ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(`Error from promiseQueue! ${JSON.stringify(g)}`), g) : new Error(`Error from promiseQueue! ${JSON.stringify(g)}`);
            })), S;
        }
        dispose() {
            this._queue = null;
        }
        constructor(g){
            this._logger = g, this._queue = Promise.resolve();
        }
    }
    const sequentialize = ()=>(g, f, S)=>{
            const v = S.value;
            return S.value = function(...g) {
                return this.serialQueue.add(v.bind(this, ...g));
            }, S;
        };
    class BaseVideoStreamFeature {
        constructor(g){
            this.disposed = !1, this.streamInstance = g.streamInstance, this.eventEmitter = new Ny.EventEmitter, this.serialQueue = new PromiseQueue(this.streamInstance.logger);
        }
    }
    class BaseAudioStreamFeature {
        constructor(g){
            this.disposed = !1, this.streamInstance = g.streamInstance, this.eventEmitter = new Ny.EventEmitter, this.serialQueue = new PromiseQueue(this.streamInstance.logger);
        }
    }
    var Fy, xy;
    !function(g) {
        g[g.CallClientFeature = 0] = "CallClientFeature", g[g.CallAgentFeature = 1] = "CallAgentFeature", g[g.CallFeature = 2] = "CallFeature";
    }(Fy || (Fy = {}));
    class FirstPartyCallFeature extends BaseCallFeature {
    }
    class FirstPartyCallAgentFeature extends BaseCallAgentFeature {
    }
    class FirstPartyCallClientFeature extends BaseCallClientFeature {
    }
    class FirstPartyVideoStreamFeature extends BaseVideoStreamFeature {
    }
    class FirstPartyAudioStreamFeature extends BaseAudioStreamFeature {
    }
    !function(g) {
        g.Transfer = "Transfer", g.StartCaptions = "StartCaptions", g.StopCaptions = "StopCaptions", g.SetSpokenLanguage = "SetSpokenLanguage", g.SetCaptionLanguage = "SetCaptionLanguage", g.getMediaStatsCollector = "getMediaStatsCollector", g.disposeAllCollectors = "disposeAllCollectors";
    }(xy || (xy = {}));
    class ExtensibleFeatureImpl {
        getApiObjectInstance(g) {
            if (!this._apiObjInstances.has(g)) {
                const f = new g(this._featureCtorContext);
                return (f instanceof FirstPartyCallFeature || f instanceof FirstPartyCallAgentFeature || f instanceof FirstPartyCallClientFeature || f instanceof FirstPartyVideoStreamFeature || f instanceof FirstPartyAudioStreamFeature) && f.initialize(this._featureInitContext, this._logger), this._apiObjInstances.set(g, f), f;
            }
            return this._apiObjInstances.get(g);
        }
        dispose() {
            for (const [, g] of this._apiObjInstances)g.dispose();
        }
        constructor(g, f, S){
            this._logger = g, this._featureCtorContext = f, this._featureInitContext = S, this._apiObjInstances = new Map;
        }
    }
    const Uy = {
        commandUrl: "",
        processingModes: {
            closedCaptions: {
                state: "Inactive"
            },
            realTimeTranscript: {
                state: "Inactive"
            }
        },
        spokenLanguage: ""
    };
    var Vy, By;
    !function(g) {
        g.Acs = "acs", g.Teams = "teams", g.Unknown = "unknown";
    }(Vy || (Vy = {})), function(g) {
        g.Captions = "captions", g.TeamsCaptions = "teams_captions";
    }(By || (By = {}));
    class BaseLanguageCallFeatureImplOverTsCall {
        dispose() {
            this._acsMetadata = void 0;
        }
        constructor(g){
            this._eventEmitter = g, this._dataChannelId = getAcsEcsConfig().captions.dataChannelId, this._isCaptionsBot = (g)=>g.id === this._captionsBotMri || g.id === this._captionsLegacyBotMri, this._getBotMetadata = (g)=>{
                var _g_endpoints_endpointDetails_, _g_endpoints;
                var _g_endpoints_endpointDetails__endpointMetadata;
                return (_g_endpoints_endpointDetails__endpointMetadata = g === null || g === void 0 ? void 0 : (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails_ = _g_endpoints.endpointDetails[0]) === null || _g_endpoints_endpointDetails_ === void 0 ? void 0 : _g_endpoints_endpointDetails_.endpointMetadata) !== null && _g_endpoints_endpointDetails__endpointMetadata !== void 0 ? _g_endpoints_endpointDetails__endpointMetadata : void 0;
            }, this._getBotDataMediaStreamSourceId = (g)=>{
                var _g_endpoints_endpointDetails_, _g_endpoints;
                if (g === null || g === void 0 ? void 0 : (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails_ = _g_endpoints.endpointDetails[0]) === null || _g_endpoints_endpointDetails_ === void 0 ? void 0 : _g_endpoints_endpointDetails_.mediaStreams) {
                    var _g_endpoints_endpointDetails_1, _g_endpoints1;
                    let f = g === null || g === void 0 ? void 0 : (_g_endpoints1 = g.endpoints) === null || _g_endpoints1 === void 0 ? void 0 : (_g_endpoints_endpointDetails_1 = _g_endpoints1.endpointDetails[0]) === null || _g_endpoints_endpointDetails_1 === void 0 ? void 0 : _g_endpoints_endpointDetails_1.mediaStreams;
                    if (f.length > 0) {
                        for(let g in f)if ("data" === f[g].type) return f[g].sourceId;
                    }
                }
            }, this._isCaptionsEnabled = (g)=>{
                var _g_processingModes_closedCaptions, _g_processingModes;
                return "Active" === (g === null || g === void 0 ? void 0 : (_g_processingModes = g.processingModes) === null || _g_processingModes === void 0 ? void 0 : (_g_processingModes_closedCaptions = _g_processingModes.closedCaptions) === null || _g_processingModes_closedCaptions === void 0 ? void 0 : _g_processingModes_closedCaptions.state);
            }, this._copyBotMetaData = (g)=>{
                const f = this._getBotMetadata(g) || Uy;
                return JSON.parse(JSON.stringify(f));
            };
        }
    }
    function callFeatureFactory(g, f = {
        activationEvent: "OnFeatureAccess"
    }) {
        return {
            get callApiCtor () {
                return g;
            },
            activationOptions: f,
            isCallFeature: !0
        };
    }
    function callClientFeatureFactory(g, f = {
        activationEvent: "OnFeatureAccess"
    }) {
        return {
            get callClientApiCtor () {
                return g;
            },
            activationOptions: f,
            isCallClientFeature: !0
        };
    }
    function videoStreamFeatureFactory(g, f = {
        activationEvent: "OnFeatureAccess"
    }) {
        return {
            get videoStreamApiCtor () {
                return g;
            },
            activationOptions: f,
            isVideoStreamFeature: !0
        };
    }
    function audioStreamFeatureFactory(g, f = {
        activationEvent: "OnFeatureAccess"
    }) {
        return {
            get audioStreamApiCtor () {
                return g;
            },
            activationOptions: f,
            isAudioStreamFeature: !0
        };
    }
    function getRoundedAverage(g, f, S = 100) {
        return Math.round((g / f + Number.EPSILON) * S) / S;
    }
    function sendCallFeatureUsageTelemetry(g, f, S) {
        try {
            const S = {
                correlationId: g.correlationId || "",
                callId: g.callId,
                localParticipantId: g.localParticipantId,
                featureName: g.featureName,
                featureType: g.featureType,
                initializationType: g.initializationType,
                featureDetails: g.featureDetails,
                additionalDetails: g.additionalDetails || {},
                networkInfo: g.networkInfo || []
            };
            f.sendEvent({
                name: dy.acs_calling_feature_usage,
                tenant: nf,
                properties: S
            });
        } catch (f) {
            S.debug(`Unable to send ${g.featureName} feature usage telemtery`);
        }
    }
    function sendCallClientFeatureUsageTelemetry(g, f, S) {
        try {
            const S = {
                featureName: g.featureName,
                featureType: g.featureType,
                initializationType: g.initializationType,
                featureDetails: g.featureDetails
            };
            f.sendEvent({
                name: dy.acs_calling_feature_usage,
                tenant: nf,
                properties: S
            });
        } catch (f) {
            S.debug(`Unable to send ${g.featureName} feature usage telemetry`);
        }
    }
    const Hy = {
        0: "",
        1: "Success",
        2: "NoNgcEndpoint",
        3: "NetworkError",
        4: "MediaDroppedError",
        5: "BadRequest",
        6: "CallEstablishmentTimeout",
        7: "CallSetupError",
        8: "NoPermission",
        9: "Missed",
        10: "Declined",
        11: "Busy",
        12: "Cancelled",
        13: "Dropped",
        14: "PstnInsufficientFunds",
        15: "PstnSkypeoutAccountBlocked",
        16: "PstnCouldNotConnectToSkypeProxy",
        17: "PstnBlockedByUs",
        18: "PstnBlockedRegulatoryIndia",
        19: "PstnInvalidNumber",
        20: "PstnNumberForbidden",
        21: "PstnCallTerminated",
        22: "PstnNumberUnavailable",
        23: "PstnEmergencyCallDenied",
        24: "CallNotFound",
        25: "LocalError",
        26: "NotAcceptableHere",
        27: "CallForwarded",
        28: "CallForwardedToVoicemail",
        29: "SkypeTokenError",
        30: "CallAccepted",
        31: "LocalHttpStackError",
        32: "UnknownError",
        33: "PstnNoSubscriptionCover",
        34: "SessionNotFound",
        35: "SessionTimedOut",
        36: "PstnCreditExpired",
        37: "PstnCreditExpiredButEnough",
        38: "RetargetNotSupported",
        39: "EnterprisePstnInternalError",
        40: "EnterprisePstnUnavailable",
        41: "EnterprisePstnForbidden",
        42: "EnterprisePstnInvalidNumber",
        43: "EnterprisePstnMiscError",
        44: "Kicked",
        45: "NetworkRequestTimeoutError",
        46: "CallDoesNotExist",
        47: "MediaSetupFailure",
        48: "ServiceUnavailable",
        49: "SignalingError",
        50: "ConversationEstablishmentFailed",
        51: "TemporarilyUnavailable",
        52: "CannotConnectToNetworkError",
        53: "MediaRelayWhiteListingIssue",
        54: "NoSignalingFromPeer",
        55: "DeniedInLobby",
        56: "TimedOutInLobby",
        57: "CallFailedConflict",
        58: "DevicePermissionDenied",
        59: "ConfParticipantCountLimitReached",
        60: "ActionNotAllowed",
        61: "Abandoned",
        62: "ForbiddenDueToPolicy",
        63: "InsufficientCapabilitiesForCallee",
        64: "UserBlocked",
        65: "AccessDenied",
        66: "AnonymousJoinDisabledByPolicy",
        67: "NoLobbyForBroadcastJoin",
        68: "NotAllowedDueToInformationBarrier",
        69: "BroadcastLimitReached",
        70: "TeamParkPolicyDisabled",
        71: "B2bJoinDisabledByPolicy",
        72: "LocationBasedRoutingError",
        73: "ConfLobbyParticipantCountLimitReached",
        74: "DowngradeToStreamingClient",
        75: "CallRedirected",
        76: "CallIsEndToEndEncrypted",
        77: "Suspended"
    }, convertTerminatedReasonToString = (g)=>{
        const f = "UnknownError";
        return "number" == typeof g && Hy[g] || f;
    }, $y = {
        0: "",
        1: "AddingFailed",
        2: "NoResponse",
        3: "Declined",
        4: "NotReachable",
        5: "Blocked",
        6: "NotFriendOrAuthorized",
        7: "CallLimitReached",
        8: "CallNotFound",
        9: "NetworkError",
        10: "MediaDroppedError",
        11: "OtherError",
        12: "PstnInsufficientFunds",
        13: "PstnSkypeoutAccountBlocked",
        14: "PstnCouldNotConnectToSkypeProxy",
        15: "PstnBlockedByUs",
        16: "PstnBlockedRegulatoryIndia",
        17: "PstnInvalidNumber",
        18: "PstnNumberForbidden",
        19: "Busy",
        20: "PstnCallTerminated",
        21: "PstnNumberUnavailable",
        22: "PstnEmergencyCallDenied",
        23: "Cancelled",
        24: "Dropped",
        25: "PstnNoSubscriptionCover",
        26: "PstnCreditExpired",
        27: "PstnCreditExpiredButEnough",
        28: "EnterprisePstnInternalError",
        29: "EnterprisePstnUnavailable",
        30: "EnterprisePstnForbidden",
        31: "EnterprisePstnInvalidNumber",
        32: "EnterprisePstnMiscError",
        33: "Kicked",
        34: "NetworkRequestTimeoutError",
        35: "CallDoesNotExist",
        36: "MediaSetupFailure",
        37: "ServiceUnavailable",
        38: "SignalingError",
        39: "ConversationEstablishmentFailed",
        40: "TemporarilyUnavailable",
        41: "CannotConnectToNetworkError",
        42: "NoSignalingFromPeer",
        43: "ParticipantDoesNotExist",
        44: "DeniedInLobby",
        45: "TimedOutInLobby",
        46: "ConfParticipantCountLimitReached",
        47: "Abandoned",
        48: "ActionNotAllowed",
        49: "ForbiddenDueToPolicy",
        50: "InsufficientCapabilitiesForCallee",
        51: "AccessDenied",
        52: "NoPermission",
        53: "AnonymousJoinDisabledByPolicy",
        54: "NoLobbyForBroadcastJoin",
        55: "NotAllowedDueToInformationBarrier",
        56: "BroadcastLimitReached",
        57: "B2bJoinDisabledByPolicy",
        58: "LocationBasedRoutingError",
        59: "ConfLobbyParticipantCountLimitReached",
        60: "LobbyUserLeft"
    }, convertParticipantStateReasonToString = (g)=>{
        const f = "UnknownError";
        return "number" == typeof g && $y[g] || f;
    }, jy = {
        0: "None",
        1: "Incoming Call",
        2: "Connecting",
        3: "Connected",
        4: "LocalHold",
        5: "RemoteHold",
        10: "InLobby",
        9: "EarlyMedia",
        6: "Disconnecting",
        7: "Disconnected",
        8: "Unknown",
        11: "Unknown",
        12: "Unknown",
        13: "Unknown",
        14: "Unknown",
        15: "Unknown"
    }, Gy = {
        0: "None",
        1: "RealTime",
        2: "Streaming"
    };
    function toDtmfTone(g) {
        switch(g){
            case "Num0":
                return 0;
            case "Num1":
                return 1;
            case "Num2":
                return 2;
            case "Num3":
                return 3;
            case "Num4":
                return 4;
            case "Num5":
                return 5;
            case "Num6":
                return 6;
            case "Num7":
                return 7;
            case "Num8":
                return 8;
            case "Num9":
                return 9;
            case "Star":
                return 10;
            case "Pound":
                return 11;
            case "A":
                return 12;
            case "B":
                return 13;
            case "C":
                return 14;
            case "D":
                return 15;
            case "Flash":
                return 16;
            default:
                throw new CallingCommunicationError({
                    defaultError: O.CALL.INVALID_DTMF_TONE
                });
        }
    }
    function getCallEndReason(g, f) {
        var _D_S_v, _D_S, _D_S_v1, _D_S1, _g_tsCall;
        let S = 0, v = 0, _ = qf, C = [];
        return S = g.tsCall.callEndDiagnosticsInfo && g.tsCall.callEndDiagnosticsInfo.callControllerCode || 0, v = g.tsCall.callEndDiagnosticsInfo && g.tsCall.callEndDiagnosticsInfo.callControllerSubCode || 0, C = ((_D_S = D[S]) === null || _D_S === void 0 ? void 0 : (_D_S_v = _D_S[v]) === null || _D_S_v === void 0 ? void 0 : _D_S_v.resultCategories) || g.tsCall.callEndDiagnosticsInfo && g.tsCall.callEndDiagnosticsInfo.resultCategories || [
            "Success"
        ], _ = ((_D_S1 = D[S]) === null || _D_S1 === void 0 ? void 0 : (_D_S_v1 = _D_S1[v]) === null || _D_S_v1 === void 0 ? void 0 : _D_S_v1.message) || convertTerminatedReasonToString(f || ((_g_tsCall = g.tsCall) === null || _g_tsCall === void 0 ? void 0 : _g_tsCall.terminatedReason) || 0), g.logger.error(`Call end reason=${_}, code=${S}, subCode=${v}, resultCategories=${C.toString()}`), {
            callEndReason: {
                message: _,
                code: S,
                subCode: v,
                resultCategories: C
            },
            callingCommunicationError: new CallingCommunicationError({
                defaultError: {
                    message: _,
                    code: S,
                    subCode: v,
                    resultCategories: C
                }
            })
        };
    }
    function getRemoteParticipantCallEndReason(g, f, S) {
        var _D_v__, _D_v, _D_v__1, _D_v1;
        let v = 0, _ = 0, C = qf, E = [];
        if (f === null || f === void 0 ? void 0 : f.callEndDiagnosticsInfo) v = f.callEndDiagnosticsInfo && f.callEndDiagnosticsInfo.callControllerCode || 0, _ = f.callEndDiagnosticsInfo && f.callEndDiagnosticsInfo.callControllerSubCode || 0, C = ((_D_v = D[v]) === null || _D_v === void 0 ? void 0 : (_D_v__ = _D_v[_]) === null || _D_v__ === void 0 ? void 0 : _D_v__.message) || convertParticipantStateReasonToString(S || f.stateReason || 0), E = ((_D_v1 = D[v]) === null || _D_v1 === void 0 ? void 0 : (_D_v__1 = _D_v1[_]) === null || _D_v__1 === void 0 ? void 0 : _D_v__1.resultCategories) || f.callEndDiagnosticsInfo && f.callEndDiagnosticsInfo.resultCategories || [
            "Success"
        ];
        else {
            const f = getCallEndReason(g, S);
            v = f.callEndReason.code, _ = f.callEndReason.subCode || 0, E = f.callEndReason.resultCategories, C = f.callEndReason.message;
        }
        return g.logger[0 === v ? "info" : "error"](`Participant call end reason=${C}, code=${v}, subCode=${_}, resultCategories=${E.toString()}`), {
            callEndReason: {
                message: C,
                code: v,
                subCode: _,
                resultCategories: E
            },
            callingCommunicationError: new CallingCommunicationError({
                defaultError: {
                    message: C,
                    code: v,
                    subCode: _,
                    resultCategories: E
                }
            })
        };
    }
    function handleVideoOperationFailure(g, f, S) {
        let v;
        switch((f === null || f === void 0 ? void 0 : f.type) ? f.type : xS.UnknownFailureForVideoOperation){
            case xS.DevicesNotFoundError:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.DEVICES_NOT_FOUND
                });
                break;
            case xS.MediaStreamRequestError:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.MEDIA_STREAM_REQUEST_ERROR
                });
                break;
            case xS.MediaStreamRequestTimedout:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.MEDIA_STREAM_REQUEST_TIMEDOUT
                });
                break;
            case xS.PermissionsDeniedBySystem:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.PERMISSION_DENIED_BY_SYSTEM
                });
                break;
            case xS.UnsupportedStream:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.UNSUPPORTED_STREAM
                });
                break;
            case xS.ConstraintNotSatisfiedError:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.CONSTRAINT_NOT_SATISFIED
                });
                break;
            case xS.noDeviceSelected:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.NO_DEVICE_SELECTED
                });
                break;
            case xS.SourceUnavailableError:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.SOURCE_UNAVAILABLE
                });
                break;
            case xS.PermissionDeniedError:
            case xS.permissionDeniedError:
                v = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.PERMISSION_DENIED
                });
                break;
            default:
                v = new CallingCommunicationError(S ? {
                    defaultError: O.CALL.STOP_VIDEO_FAILED
                } : {
                    defaultError: O.LOCAL_VIDEO_STREAM.UNKNOWN
                });
        }
        return v;
    }
    function handleLobbyFailure(g, f, S) {
        const v = void 0 === (f === null || f === void 0 ? void 0 : f.code) ? 500 : f === null || f === void 0 ? void 0 : f._code, _ = (f === null || f === void 0 ? void 0 : f.subCode) || (f === null || f === void 0 ? void 0 : f._subCode) || 0;
        return new CallingCommunicationError({
            defaultError: {
                message: S + ", reason: " + ((f === null || f === void 0 ? void 0 : f.phrase) || (f === null || f === void 0 ? void 0 : f.message) || "unknown error"),
                code: v,
                subCode: _,
                resultCategories: (f === null || f === void 0 ? void 0 : f.resultCategories) || []
            }
        });
    }
    function handlePublishStateFailure(g, f) {
        var _g_response;
        return new CallingCommunicationError({
            defaultError: {
                message: f.message,
                code: (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status) || f.code,
                subCode: f.subCode,
                resultCategories: f.resultCategories
            },
            originalError: g
        });
    }
    function handleFetchPoliciesFromAcsMiddleTierFailure(g, f) {
        var _g_response_data_operationFailure, _g_response_data, _g_response, _g_response_data_operationFailure1, _g_response_data1, _g_response1, _g_response_data_operationFailure2, _g_response_data2, _g_response2, _g_response_data_operationFailure3, _g_response_data3, _g_response3;
        return new CallingCommunicationError({
            defaultError: {
                message: (g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : (_g_response_data = _g_response.data) === null || _g_response_data === void 0 ? void 0 : (_g_response_data_operationFailure = _g_response_data.operationFailure) === null || _g_response_data_operationFailure === void 0 ? void 0 : _g_response_data_operationFailure.phrase) || f.message,
                code: (g === null || g === void 0 ? void 0 : (_g_response1 = g.response) === null || _g_response1 === void 0 ? void 0 : (_g_response_data1 = _g_response1.data) === null || _g_response_data1 === void 0 ? void 0 : (_g_response_data_operationFailure1 = _g_response_data1.operationFailure) === null || _g_response_data_operationFailure1 === void 0 ? void 0 : _g_response_data_operationFailure1.code) || f.code,
                subCode: (g === null || g === void 0 ? void 0 : (_g_response2 = g.response) === null || _g_response2 === void 0 ? void 0 : (_g_response_data2 = _g_response2.data) === null || _g_response_data2 === void 0 ? void 0 : (_g_response_data_operationFailure2 = _g_response_data2.operationFailure) === null || _g_response_data_operationFailure2 === void 0 ? void 0 : _g_response_data_operationFailure2.subCode) || f.subCode,
                resultCategories: (g === null || g === void 0 ? void 0 : (_g_response3 = g.response) === null || _g_response3 === void 0 ? void 0 : (_g_response_data3 = _g_response3.data) === null || _g_response_data3 === void 0 ? void 0 : (_g_response_data_operationFailure3 = _g_response_data3.operationFailure) === null || _g_response_data_operationFailure3 === void 0 ? void 0 : _g_response_data_operationFailure3.resultCategories) || f.resultCategories
            },
            originalError: g
        });
    }
    function extractCommunicationServicesErrorForTelemetry(g) {
        return {
            communicationServicesError: {
                message: g.message || "Unknown error",
                code: void 0 === g.code ? x : g.code,
                subCode: g.subCode || 0,
                resultCategories: void 0 === g.resultCategories || 0 === g.resultCategories.length ? [
                    "UnexpectedClientError"
                ] : g.resultCategories,
                originalErrorMessage: g[H] || ""
            }
        };
    }
    function extractCallEndReasonForTelemetry(g) {
        return {
            callEndReason: {
                message: g.message,
                code: void 0 === g.code ? x : g.code,
                subCode: g.subCode || 0,
                resultCategories: void 0 === g.resultCategories || 0 === g.resultCategories.length ? [
                    "UnexpectedClientError"
                ] : g.resultCategories
            }
        };
    }
    var __decorate = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    const qy = Date.UTC(1900, 0, 1), Wy = 3;
    class CaptionsCallFeatureImpl extends FirstPartyCallFeature {
        initialize(g, f) {
            const S = generateGuid();
            this._impl.initialize(g.tsCall, g.call, g.callAgent, g.callAgent.getHttpRequestHelper(), g.telemetryLogManager, f, this._telemetryStartTime, S), this._logger = f, this._telemetryStartTime = +Date.now(), this._telemetryLogManager = g.telemetryLogManager, this._call = g.call;
        }
        get name() {
            return this._sendFeatureUsage("name", uy.getter), this._captionsTelemetryType.toString();
        }
        get _captionsTelemetryType() {
            return "TeamsCaptions" === this._impl.kind ? By.TeamsCaptions : By.Captions;
        }
        get captions() {
            return this._impl.captions;
        }
        on(g, f) {
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this.eventEmitter.off(g, f);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: this._captionsTelemetryType,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g), this._impl = new CaptionsCallFeatureImplOverTsCall(this.eventEmitter);
        }
    }
    class CaptionsCommonImpl {
        async startCaptions(g) {
            await this._impl.startCaptions(g);
        }
        async stopCaptions() {
            await this._impl.stopCaptions();
        }
        async setSpokenLanguage(g) {
            await this._impl.setSpokenLanguage(g);
        }
        get supportedSpokenLanguages() {
            return this._impl.supportedSpokenLanguages;
        }
        get isCaptionsFeatureActive() {
            return this._impl.isCaptionsFeatureActive;
        }
        get activeSpokenLanguage() {
            return this._impl.activeSpokenLanguage;
        }
        get kind() {
            return this._impl.kind;
        }
        constructor(g, f){
            this._eventEmitter = f, this._impl = g;
        }
    }
    class CaptionsImpl extends CaptionsCommonImpl {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        constructor(g, f){
            super(g, f);
        }
    }
    class TeamsCaptionsImpl extends CaptionsCommonImpl {
        get supportedCaptionLanguages() {
            return this._impl.supportedCaptionLanguages;
        }
        get activeCaptionLanguage() {
            return this._impl.activeCaptionLanguage;
        }
        async setCaptionLanguage(g) {
            await this._impl.setCaptionLanguage(g);
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        constructor(g, f){
            super(g, f);
        }
    }
    class CaptionsCallFeatureImplOverTsCall extends BaseLanguageCallFeatureImplOverTsCall {
        get isCaptionsFeatureActive() {
            return !!this._acsMetadata && this._isCaptionsEnabled(this._acsMetadata) && this._isCaptionsActive;
        }
        get supportedSpokenLanguages() {
            return this._ecsSpokenLanguages;
        }
        get supportedCaptionLanguages() {
            return this._ecsCaptionLanguages;
        }
        get captions() {
            return this._captions;
        }
        get kind() {
            return this._name === By.TeamsCaptions ? "TeamsCaptions" : "Captions";
        }
        get activeSpokenLanguage() {
            return this._currentLanguage;
        }
        get activeCaptionLanguage() {
            return this._currentCaptionLanguage;
        }
        get isTeamsConversationType() {
            return Pf.indexOf(this._tsCall.conversationType) > -1;
        }
        get isTeamsUserInCall() {
            for (let g of this._tsCall.participants)if ("microsoftTeamsUser" === constructIdentifierKindFromMri(g.id).kind) return !0;
            return !1;
        }
        get isTeamsCallKind() {
            return this._call.kind === g.CallKind.TeamsCall;
        }
        get isTeamsCaptionsBotInCall() {
            for (let g of this._tsCall.participants){
                if ("gcc" === this._tsCall.region && g.id === getAcsEcsConfig().captions.teams.gccBotMri) return !0;
                if ("gcc" !== this._tsCall.region && (g.id === getAcsEcsConfig().captions.teams.botMri || g.id === getAcsEcsConfig().captions.teams.legacyBotMri)) return !0;
            }
            return !1;
        }
        updateParticipantTranscriptionPrefsMetadata(g, f) {
            var _this__tsCall_endpoints, _this__tsCall_endpoints1, _v_transcriptionPrefs, _v_transcriptionPrefs1;
            let S;
            for(let g in (_this__tsCall_endpoints = this._tsCall.endpoints) === null || _this__tsCall_endpoints === void 0 ? void 0 : _this__tsCall_endpoints.endpointDetails)if (((_this__tsCall_endpoints1 = this._tsCall.endpoints) === null || _this__tsCall_endpoints1 === void 0 ? void 0 : _this__tsCall_endpoints1.endpointDetails[g].participantId) === this._tsCall.participantId) {
                var _this__tsCall_endpoints2;
                S = (_this__tsCall_endpoints2 = this._tsCall.endpoints) === null || _this__tsCall_endpoints2 === void 0 ? void 0 : _this__tsCall_endpoints2.endpointDetails[g];
                break;
            }
            var _S_endpointMetadata;
            const v = (_S_endpointMetadata = S === null || S === void 0 ? void 0 : S.endpointMetadata) !== null && _S_endpointMetadata !== void 0 ? _S_endpointMetadata : {
                transcriptionPrefs: {}
            };
            g ? ((_v_transcriptionPrefs = v.transcriptionPrefs) === null || _v_transcriptionPrefs === void 0 ? void 0 : _v_transcriptionPrefs.closedCaptions) ? v.transcriptionPrefs.closedCaptions = g : v.transcriptionPrefs = {
                closedCaptions: g
            } : ((_v_transcriptionPrefs1 = v.transcriptionPrefs) === null || _v_transcriptionPrefs1 === void 0 ? void 0 : _v_transcriptionPrefs1.closedCaptions) && delete v.transcriptionPrefs.closedCaptions;
            try {
                this._tsCall.updateEndpointMetadata(JSON.stringify(v));
            } catch (g) {
                this._addParticipantPromise = null;
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_ENDPOINT_METADATA
                });
                throw this._sendCaptionsEvent(my.UpdateEndpointMetadata, uy.failure, f, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("updateEndpointMetadata", uy.failure), this._logger.warn(S.message), S;
            }
        }
        initialize(g, f, S, v, _, C, E, T) {
            this._logger = C.createChild(()=>`CaptionsFeature::Call(id='${g.callId}', state='${g.state}')`), this._tsCall = g, this._call = f, this._internalCallAgent = S, this._httpRequestHelper = v, this._telemetryLogManager = _, this._telemetryStartTime = E, this._isCteUser = S.isCteUser(), this._ecsCaptionsEnabled = getAcsEcsConfig().captions.enabled, this._ecsACSCaptionsEnabled = getAcsEcsConfig().captions.acs.enabled, this._ecsTeamsCaptionsEnabled = getAcsEcsConfig().captions.teams.enabled, this._ecsSetBotMetadataWhenEmptyFixEnabled = getAcsEcsConfig().captions.setBotMetadataWhenEmptyFix, this._name = this.isTeamsConversationType || this._isCteUser || this.isTeamsUserInCall || this.isTeamsCaptionsBotInCall || this.isTeamsCallKind ? By.TeamsCaptions : By.Captions, this.updateCaptionsData(this._name), this._sendCaptionsEvent(my.InitializeCaptions, uy.initialize, T, this._telemetryStartTime), this._initializationPromise = new Promise((g, f)=>{
                this._initializeAsync(T).then((f)=>g()).catch((g)=>f(g));
            });
        }
        async _initializeAsync(g) {
            try {
                this._textDecoder = new TextDecoder, this._tsCall.on("participantAdded", async (f)=>{
                    if (this._captions && "Captions" === this._captions.kind && "microsoftTeamsUser" === constructIdentifierKindFromMri(f.id).kind) {
                        if (this._captionsBotMri) try {
                            await this._tsCall.removeParticipant(this._captionsBotMri), this._acsMetadata && (this._acsMetadata = void 0);
                        } catch (S) {
                            var _f_callEndDiagnosticsInfo, _f_callEndDiagnosticsInfo1, _f_callEndDiagnosticsInfo2;
                            const v = new CallingCommunicationError({
                                defaultError: {
                                    message: convertParticipantStateReasonToString(S),
                                    code: ((_f_callEndDiagnosticsInfo = f.callEndDiagnosticsInfo) === null || _f_callEndDiagnosticsInfo === void 0 ? void 0 : _f_callEndDiagnosticsInfo.callControllerCode) || 0,
                                    subCode: ((_f_callEndDiagnosticsInfo1 = f.callEndDiagnosticsInfo) === null || _f_callEndDiagnosticsInfo1 === void 0 ? void 0 : _f_callEndDiagnosticsInfo1.callControllerSubCode) || 0,
                                    resultCategories: ((_f_callEndDiagnosticsInfo2 = f.callEndDiagnosticsInfo) === null || _f_callEndDiagnosticsInfo2 === void 0 ? void 0 : _f_callEndDiagnosticsInfo2.resultCategories) || [
                                        "UnexpectedClientError"
                                    ]
                                },
                                originalError: S
                            });
                            this._sendCaptionsEvent(my.CaptionsKindChanged, uy.failure, g, this._telemetryStartTime, py.Unexpected, v.message, v.code, v.subCode, extractCommunicationServicesErrorForTelemetry(v));
                        }
                        if (this.updateCaptionsData(By.TeamsCaptions), this._ecsSetBotMetadataWhenEmptyFixEnabled) {
                            const f = this._tsCall.participants.find((g)=>g.id === this._captionsBotMri);
                            if (f) {
                                this._acsMetadata = this._copyBotMetaData(f), this._mediaStreamSourceId = f.getSourceIdForMediaType(3);
                                try {
                                    await this._tsCall.startDataChannel(), await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId, this._dataChannelHandler);
                                } catch (f) {
                                    const S = new CallingCommunicationError({
                                        defaultError: O.FEATURES.CAPTIONS.ALREADY_ACTIVE
                                    });
                                    this._sendCaptionsEvent(my.StartDataChannel, uy.failure, g, this._telemetryStartTime, py.Expected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("startDataChannel", uy.failure);
                                }
                            }
                        }
                        this._isCaptionsActive && (this._currentLanguage && this._ecsSpokenLanguages.includes(this._currentLanguage) ? await this._captions.startCaptions({
                            spokenLanguage: this._currentLanguage
                        }) : await this._captions.startCaptions()), this._eventEmitter.emit("CaptionsKindChanged"), this._sendCaptionsEvent(my.CaptionsKindChanged, uy.success, g, this._telemetryStartTime);
                    }
                }), this._tsCall.on("participantAdded", async (g)=>{
                    this._isCaptionsBot(g) && (this._acsMetadata || (this._acsMetadata = this._copyBotMetaData(g), this._mediaStreamSourceId = this._getBotDataMediaStreamSourceId(g), await this._tsCall.startDataChannel(), await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId, this._dataChannelHandler)));
                }), this._tsCall.on("participantRemoved", async (g)=>{
                    this._isCaptionsBot(g) && this._handleBotRemoved(g);
                }), this._tsCall.on("participantUpdated", async (g)=>{
                    this._getBotMetadata(g) && this._isCaptionsBot(g) && this._acsMetadata && (this._acsMetadata = this._copyBotMetaData(g), this._mediaStreamSourceId = this._getBotDataMediaStreamSourceId(g), !this._firstTimeActive && this.isCaptionsFeatureActive && (this._firstTimeActive = !0, this._eventEmitter.emit("CaptionsActiveChanged")));
                });
                const f = this._tsCall.participants.find((g)=>g.id === this._captionsBotMri || g.id === this._captionsLegacyBotMri);
                f && (this._acsMetadata = this._copyBotMetaData(f), this._mediaStreamSourceId = f.getSourceIdForMediaType(3), await this._tsCall.startDataChannel(), await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId, this._dataChannelHandler));
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.INITIALIZE
                });
                throw this._sendCaptionsEvent(my.InitializeCaptions, uy.failure, g, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._logger.error(S.message), S;
            }
        }
        updateCaptionsData(g) {
            g === By.Captions ? (this._name = By.Captions, this._captionsBotMri = getAcsEcsConfig().captions.acs.botMri, this._captionsLegacyBotMri = void 0, this._modeKey = getAcsEcsConfig().captions.acs.modeKey, this._modeVal = getAcsEcsConfig().captions.acs.modeVal, this._modesKey = getAcsEcsConfig().captions.acs.modesKey, this._modesVal = getAcsEcsConfig().captions.acs.modesVal, this._clientInfo = getAcsEcsConfig().captions.acs.clientInfo.ring, this._ecsACSCaptionsEnabled = getAcsEcsConfig().captions.acs.enabled, this._ecsSpokenLanguagesEnabled = getAcsEcsConfig().captions.acs.spokenLanguages.enabled, this._ecsSpokenLanguages = getAcsEcsConfig().captions.acs.spokenLanguages.languages, this._ecsCapabilitiesEnabled = getAcsEcsConfig().captions.useCapabilities, this._ecsSetBotMetadataWhenEmptyFixEnabled = getAcsEcsConfig().captions.setBotMetadataWhenEmptyFix, this._call.offParticipantCapabilitiesChanged("capabilitiesChanged", this.capabilityChangeHandler), this._logger.log("participant capabilities change event listener unregistered"), this._captions = new CaptionsImpl(this, this._eventEmitter)) : g === By.TeamsCaptions && (this._name = By.TeamsCaptions, "gcc" === this._tsCall.region ? this._captionsBotMri = getAcsEcsConfig().captions.teams.gccBotMri : this._captionsBotMri = getAcsEcsConfig().captions.teams.botMri, this._captionsLegacyBotMri = getAcsEcsConfig().captions.teams.legacyBotMri, this._modeKey = getAcsEcsConfig().captions.teams.modeKey, this._modeVal = getAcsEcsConfig().captions.teams.modeVal, this._modesKey = getAcsEcsConfig().captions.teams.modesKey, this._modesVal = getAcsEcsConfig().captions.teams.modesVal, this._clientInfo = getAcsEcsConfig().captions.teams.clientInfo.ring, this._ecsTeamsCaptionsEnabled = getAcsEcsConfig().captions.teams.enabled, this._ecsSpokenLanguagesEnabled = getAcsEcsConfig().captions.teams.spokenLanguages.enabled, this._ecsSpokenLanguages = getAcsEcsConfig().captions.teams.spokenLanguages.languages, this._ecsCaptionLanguagesEnabled = getAcsEcsConfig().captions.teams.captionLanguages.enabled, this._ecsCaptionLanguages = getAcsEcsConfig().captions.teams.captionLanguages.languages, this._ecsAmtPolicyUrlSuffix = getAcsEcsConfig().MiddleTier.policyUrlSuffixV2, this._ecsCapabilitiesEnabled = getAcsEcsConfig().captions.useCapabilities, this._ecsSetBotMetadataWhenEmptyFixEnabled = getAcsEcsConfig().captions.setBotMetadataWhenEmptyFix, this._participantCapability.startLiveMeetingCaptions = this._call.getParticipantCapabilities().startLiveMeetingCaptions, this._logger.log(`participant capabilitity to startLiveMeetingCaptions feature is ${this._participantCapability.startLiveMeetingCaptions}`), this._participantCapability.startLiveCallingCaptions = this._call.getParticipantCapabilities().startLiveCallingCaptions, this._logger.log(`participant capabilitity to startLiveCallingCaptions feature is ${this._participantCapability.startLiveCallingCaptions}`), this._participantCapability.setCaptionLanguage = this._call.getParticipantCapabilities().setCaptionLanguage, this._logger.log(`participant capabilitity to setCaptionLanguage feature is ${this._participantCapability.setCaptionLanguage}`), this._call.onParticipantCapabilitiesChanged("capabilitiesChanged", this.capabilityChangeHandler), this._logger.log("participant capabilities change event listener registered"), this._captions = new TeamsCaptionsImpl(this, this._eventEmitter));
        }
        async startCaptions(g) {
            this._telemetryStartTime = +Date.now();
            const f = generateGuid(), S = (g === null || g === void 0 ? void 0 : g.spokenLanguage) || _f;
            if (this._sendFeatureUsage("startCaptions", uy.attempt), this._sendCaptionsEvent(my.StartCaptions, uy.attempt, f, 0), this._addParticipantPromise) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.ALREADY_STARTING
                });
                return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), void this._sendFeatureUsage("startCaptions", uy.failure);
            }
            if (await this._initializationPromise, !this._ecsCaptionsEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.DISABLED
                });
                return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), void this._logger.error("Feature is not enabled.");
            }
            if (3 !== this._tsCall.state) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.START_FAILED_CALL_NOT_CONNECTED
                });
                return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), void this._logger.error("Captions unable to start as call state is not connected.");
            }
            if (!this._tsCall.endpoints) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.START_FAILED_CALL_ENDPOINTS_NOT_AVAILABLE
                });
                return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), void this._logger.error("Captions unable to start as call endpoints are not available.");
            }
            if (!this._ecsSpokenLanguages.includes(S)) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.SPOKEN_LANG_UNSUPPORTED
                });
                throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), this._logger.error("Spoken language requested is not supported."), g;
            }
            if (this._name === By.Captions && !this._ecsACSCaptionsEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.DISABLED
                });
                return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), void this._logger.error("Captions Feature is not enabled.");
            }
            if (this._name === By.TeamsCaptions) {
                if (!this._ecsTeamsCaptionsEnabled) {
                    const g = new CallingCommunicationError({
                        defaultError: O.FEATURES.CAPTIONS.DISABLED
                    });
                    return this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), void this._logger.error("Teams Captinons Feature is not enabled.");
                }
                if (this._ecsCapabilitiesEnabled) {
                    if (this._isCteUser) {
                        if (this._call.callInfo.context === BS.TeamsMeeting || this.isTeamsConversationType) {
                            if (this._participantCapability) {
                                var _this__participantCapability, _this__participantCapability1;
                                if (this.isTeamsConversationType) {
                                    if (!((_this__participantCapability = this._participantCapability) === null || _this__participantCapability === void 0 ? void 0 : _this__participantCapability.startLiveMeetingCaptions.isPresent)) {
                                        const g = new CallingCommunicationError({
                                            defaultError: O.FEATURES.CAPTIONS.MEETING_POLICY_DISABLED
                                        });
                                        throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(g.message), g;
                                    }
                                } else if (!((_this__participantCapability1 = this._participantCapability) === null || _this__participantCapability1 === void 0 ? void 0 : _this__participantCapability1.startLiveCallingCaptions.isPresent)) {
                                    const g = new CallingCommunicationError({
                                        defaultError: O.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED
                                    });
                                    throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(g.message), g;
                                }
                            }
                        } else {
                            var _g_teamsCallingPolicy;
                            const g = this._internalCallAgent.getUserPolicy();
                            if ("DisabledUserOverride" !== (g === null || g === void 0 ? void 0 : (_g_teamsCallingPolicy = g.teamsCallingPolicy) === null || _g_teamsCallingPolicy === void 0 ? void 0 : _g_teamsCallingPolicy.liveCaptionsEnabledTypeForCalling)) {
                                const g = new CallingCommunicationError({
                                    defaultError: O.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED
                                });
                                throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(g.message), g;
                            }
                        }
                    }
                } else if (this._mtPolicy = this._internalCallAgent.mtPolicyService, this._isCteUser) {
                    try {
                        this._mtPolicy.initialize({
                            localParticipant: this._internalCallAgent.getUserMri(),
                            jwtTokenProvider: await this._internalCallAgent.tokenProvider,
                            telemetryLogManager: this._telemetryLogManager
                        }), await this._mtPolicy.fetchUserPoliciesFromAcsMiddleTier(this._tsCall.callId, this._call.callAgent.getUserMri(), {
                            policyUrlSuffix: this._ecsAmtPolicyUrlSuffix,
                            userPolicies: [
                                "TeamsCallingPolicy",
                                "TeamsMeetingPolicy"
                            ],
                            userProperties: [
                                "FeatureTypes",
                                "PoliciesMetadata"
                            ]
                        }), this._mtCaptionsPolicyResult = JSON.parse(this._mtPolicy.getTeamsUserCaptionsPoliciesData());
                    } catch (g) {
                        const S = new CallingCommunicationError({
                            defaultError: O.FEATURES.CAPTIONS.CTE_POLICY_FETCH_FAIL,
                            originalError: g
                        });
                        this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._logger.error("Unable to fetch policies");
                    }
                    if (this._mtCaptionsPolicyResult) {
                        var _this__mtCaptionsPolicyResult, _this__mtCaptionsPolicyResult1;
                        if (this.isTeamsConversationType) {
                            if (!((_this__mtCaptionsPolicyResult = this._mtCaptionsPolicyResult) === null || _this__mtCaptionsPolicyResult === void 0 ? void 0 : _this__mtCaptionsPolicyResult.isLiveCaptionsEnabledForMeeting)) {
                                const g = new CallingCommunicationError({
                                    defaultError: O.FEATURES.CAPTIONS.MEETING_POLICY_DISABLED
                                });
                                throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(g.message), g;
                            }
                        } else if (!((_this__mtCaptionsPolicyResult1 = this._mtCaptionsPolicyResult) === null || _this__mtCaptionsPolicyResult1 === void 0 ? void 0 : _this__mtCaptionsPolicyResult1.isLiveCaptionsEnabledForCalling)) {
                            const g = new CallingCommunicationError({
                                defaultError: O.FEATURES.CAPTIONS.CALLING_POLICY_DISABLED
                            });
                            throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(g.message), g;
                        }
                    }
                }
            }
            if (this._ecsSetBotMetadataWhenEmptyFixEnabled) {
                const g = this._tsCall.participants.find((g)=>g.id === this._captionsBotMri || g.id === this._captionsLegacyBotMri);
                if (g && !this._acsMetadata) {
                    this._acsMetadata = this._copyBotMetaData(g), this._mediaStreamSourceId = g.getSourceIdForMediaType(3);
                    try {
                        await this._tsCall.startDataChannel(), await this._tsCall.dataChannelAdapter.addHandler(this._dataChannelId, this._dataChannelHandler);
                    } catch (g) {
                        const S = new CallingCommunicationError({
                            defaultError: O.FEATURES.CAPTIONS.ALREADY_ACTIVE
                        });
                        this._sendCaptionsEvent(my.StartDataChannel, uy.failure, f, this._telemetryStartTime, py.Expected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("startDataChannel", uy.failure);
                    }
                }
            }
            if (this._acsMetadata) {
                if (this._isCaptionsEnabled(this._acsMetadata)) {
                    if (this._isCaptionsActive) {
                        const g = new CallingCommunicationError({
                            defaultError: O.FEATURES.CAPTIONS.ALREADY_ACTIVE
                        });
                        this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure);
                    } else this._isCaptionsActive = !0, "Captions" === this._captions.kind && this.updateParticipantTranscriptionPrefsMetadata(!0, f), this._sendCaptionsEvent(my.StartCaptions, uy.success, f, this._telemetryStartTime), this._sendFeatureUsage("startCaptions", uy.success), this._eventEmitter.emit("CaptionsActiveChanged");
                } else if ("Captions" === this._captions.kind) {
                    if (this._isCaptionsActive) {
                        const g = new CallingCommunicationError({
                            defaultError: O.FEATURES.CAPTIONS.ALREADY_ACTIVE
                        });
                        this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("startCaptions", uy.failure);
                    } else this._isCaptionsActive = !0, this.updateParticipantTranscriptionPrefsMetadata(!0, f), this._sendCaptionsEvent(my.StartCaptions, uy.success, f, this._telemetryStartTime), this._sendFeatureUsage("startCaptions", uy.success), this._eventEmitter.emit("CaptionsActiveChanged");
                }
            } else try {
                const g = {
                    participantInvitationData: {
                        botData: {
                            clientInfo: this._clientInfo,
                            consumerType: "ACS",
                            initiatorUserToken: this._name === By.TeamsCaptions ? "" : await this._internalCallAgent.tokenProvider(),
                            spokenLanguage: S,
                            [this._modeKey]: this._modeVal,
                            [this._modesKey]: this._modesVal
                        }
                    }
                };
                "Captions" === this._captions.kind && this.updateParticipantTranscriptionPrefsMetadata(!0, f), this._addParticipantPromise = this._tsCall.addParticipant(this._captionsBotMri, g), await this._addParticipantPromise, this._addParticipantPromise = null, this._currentLanguage !== S && (this._currentLanguage = S, this._eventEmitter.emit("SpokenLanguageChanged")), this._isCaptionsActive = !0, this._sendCaptionsEvent(my.StartCaptions, uy.success, f, this._telemetryStartTime), this._sendFeatureUsage("startCaptions", uy.success);
            } catch (g) {
                this._addParticipantPromise = null;
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.START_FAILED
                });
                throw this._sendCaptionsEvent(my.StartCaptions, uy.failure, f, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("startCaptions", uy.failure), this._logger.error(S.message), S;
            }
        }
        async stopCaptions() {
            this._telemetryStartTime = +Date.now();
            const g = generateGuid();
            if (this._sendFeatureUsage("stopCaptions", uy.attempt), this._sendCaptionsEvent(my.StopCaptions, uy.attempt, g, 0), this.isCaptionsFeatureActive) "Captions" === this._captions.kind && this.updateParticipantTranscriptionPrefsMetadata(!1, g), this._isCaptionsActive = !1, this._sendCaptionsEvent(my.StopCaptions, uy.success, g, this._telemetryStartTime), this._sendFeatureUsage("stopCaptions", uy.success), this._eventEmitter.emit("CaptionsActiveChanged");
            else {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.STOP_NOT_ACTIVE
                });
                this._sendCaptionsEvent(my.StopCaptions, uy.failure, g, this._telemetryStartTime, py.Expected, f.message, f.code, f.subCode, extractCommunicationServicesErrorForTelemetry(f)), this._logger.warn(f.message);
            }
            this._isCaptionsActive = !1;
        }
        async setSpokenLanguage(g) {
            var _this__acsMetadata;
            this._telemetryStartTime = +Date.now();
            const f = generateGuid();
            if (this._sendFeatureUsage("setSpokenLanguage", uy.attempt), this._sendCaptionsEvent(my.SetSpokenLanguage, uy.attempt, f, 0), await this._initializationPromise, !((_this__acsMetadata = this._acsMetadata) === null || _this__acsMetadata === void 0 ? void 0 : _this__acsMetadata.commandUrl)) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_LANGUAGE_NOT_STARTED
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), this._logger.error(g.message), g;
            }
            if (!this._isCaptionsActive) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_LANGUAGE_NOT_STARTED
                });
                return this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), void this._logger.warn(g.message);
            }
            if (!this._ecsSpokenLanguagesEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.SPOKEN_LANG_DISABLED
                });
                return this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), void this._logger.error(g.message);
            }
            if (g == this._currentLanguage) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.SPOKEN_LANGUAGE_ALREADY_SET
                });
                return this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), void this._sendFeatureUsage("setSpokenLanguage", uy.failure);
            }
            if (!this._ecsSpokenLanguages.includes(g)) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.SPOKEN_LANG_UNSUPPORTED
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), this._logger.error(g.message), g;
            }
            try {
                const S = await this._internalCallAgent.tokenProvider();
                if (!S) {
                    const g = new CallingCommunicationError({
                        defaultError: O.FEATURES.CAPTIONS.UPDATE_LANGUAGE_GET_TOKEN
                    });
                    throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Unexpected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), g;
                }
                await this._sendSetLanguageRequest(g, "", S, this._acsMetadata.commandUrl), this._currentLanguage !== g && (this._currentLanguage = g, this._eventEmitter.emit("SpokenLanguageChanged")), this._sendCaptionsEvent(my.SetSpokenLanguage, uy.success, f, this._telemetryStartTime), this._sendFeatureUsage("setSpokenLanguage", uy.success);
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_LANGUAGE_FAILED,
                    originalError: g
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("setSpokenLanguage", uy.failure), this._logger.error(S.message), S;
            }
        }
        async setCaptionLanguage(g) {
            var _this__acsMetadata, _this__tsCall_meetingDetails;
            this._telemetryStartTime = +Date.now();
            const f = generateGuid();
            if (this._sendFeatureUsage("setCaptionLanguage", uy.attempt), this._sendCaptionsEvent(my.SetCaptionLanguage, uy.attempt, f, 0), await this._initializationPromise, !((_this__acsMetadata = this._acsMetadata) === null || _this__acsMetadata === void 0 ? void 0 : _this__acsMetadata.commandUrl)) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_CAPTIONS_NOT_STARTED
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(g.message), g;
            }
            if (!this._isCaptionsActive) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_CAPTIONS_NOT_ACTIVE
                });
                return this._sendCaptionsEvent(my.SetCaptionLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), void this._logger.warn(g.message);
            }
            if (!this._ecsCaptionLanguagesEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_DISABLED
                });
                return this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), void this._logger.error(g.message);
            }
            if (this._isTranslatedCaptionsAllowed || ((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : _this__tsCall_meetingDetails.meetingCapability) && this._tsCall.meetingDetails.meetingCapability.allowTranslatedCaptions && (this._isTranslatedCaptionsAllowed = this._tsCall.meetingDetails.meetingCapability.allowTranslatedCaptions), !this.isTeamsConversationType || !this._isTranslatedCaptionsAllowed) {
                var _this__mtCaptionsPolicyResult;
                if (this._ecsCapabilitiesEnabled) {
                    var _this__participantCapability;
                    if (this._call.callInfo.context !== BS.TeamsMeeting) {
                        var _g_featureTypes;
                        const g = this._internalCallAgent.getUserProperties();
                        if (!(g === null || g === void 0 ? void 0 : (_g_featureTypes = g.featureTypes) === null || _g_featureTypes === void 0 ? void 0 : _g_featureTypes.includes(pS.TeamsProMgmt))) {
                            const g = new CallingCommunicationError({
                                defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE
                            });
                            throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(g.message), g;
                        }
                    } else if (!((_this__participantCapability = this._participantCapability) === null || _this__participantCapability === void 0 ? void 0 : _this__participantCapability.setCaptionLanguage.isPresent)) {
                        const g = new CallingCommunicationError({
                            defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE
                        });
                        throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(g.message), g;
                    }
                } else if (!((_this__mtCaptionsPolicyResult = this._mtCaptionsPolicyResult) === null || _this__mtCaptionsPolicyResult === void 0 ? void 0 : _this__mtCaptionsPolicyResult.isTeamsProMgmtSkuAvailable)) {
                    const g = new CallingCommunicationError({
                        defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_TEAMS_LICENSE
                    });
                    throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(g.message), g;
                }
            }
            if (g == this._currentCaptionLanguage) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_ALREADY_SET
                });
                return this._sendCaptionsEvent(my.SetCaptionLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), void this._sendFeatureUsage("setCaptionLanguage", uy.failure);
            }
            if (!this._ecsCaptionLanguages.includes(g)) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.CAPTIONS_LANG_UNSUPPORTED
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Expected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(g.message), g;
            }
            try {
                const S = await this._internalCallAgent.tokenProvider();
                if (!S) {
                    const g = new CallingCommunicationError({
                        defaultError: O.FEATURES.CAPTIONS.UPDATE_CAPTIONS_GET_TOKEN
                    });
                    throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Unexpected, g.message, g.code, g.subCode, extractCommunicationServicesErrorForTelemetry(g)), g;
                }
                await this._sendSetLanguageRequest("", g, S, this._acsMetadata.commandUrl), this._currentCaptionLanguage !== g && (this._currentCaptionLanguage = g, this._eventEmitter.emit("CaptionLanguageChanged")), this._sendCaptionsEvent(my.SetCaptionLanguage, uy.success, f, this._telemetryStartTime), this._sendFeatureUsage("setCaptionLanguage", uy.success);
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.CAPTIONS.UPDATE_CAPTIONS_FAILED,
                    originalError: g
                });
                throw this._sendCaptionsEvent(my.SetSpokenLanguage, uy.failure, f, this._telemetryStartTime, py.Unexpected, S.message, S.code, S.subCode, extractCommunicationServicesErrorForTelemetry(S)), this._sendFeatureUsage("setCaptionLanguage", uy.failure), this._logger.error(S.message), S;
            }
        }
        dispose() {
            this._acsMetadata = void 0, this._textDecoder = void 0;
        }
        _sendCaptionsEvent(g, f, S, v, _, C, E, T, I) {
            let b = {
                eventName: dy.acs_calling_captions,
                callId: this._call.id,
                correlationId: S,
                isExpected: _ !== null && _ !== void 0 ? _ : "",
                localParticipantId: this._call.tsCall.participantId,
                featureType: this._name,
                featureDetails: {
                    step: g
                },
                kindOfEvent: f,
                timestampInfo: v ? {
                    deltaTimeInMs: +Date.now() - v
                } : "",
                additionalDetails: {
                    failureReason: C,
                    code: E,
                    subCode: T,
                    ...I
                }
            };
            try {
                this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_captions,
                    tenant: nf,
                    properties: b
                });
            } catch (g) {
                this._logger.debug(`Unable to send ${this._name} feature usage telemtery`);
            }
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: this._name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        async _sendSetLanguageRequest(g, f, S, v) {
            const _ = g ? {
                type: yf,
                spokenLanguage: g
            } : {
                type: yf,
                subtitleLanguages: [
                    f
                ]
            }, C = {
                timestamp: (new Date).toISOString(),
                participantMri: this._internalCallAgent.getUserMri(),
                participantLegId: this._tsCall.participantId,
                action: yf,
                mode: Tf,
                actionParameters: _
            }, E = {
                headers: {
                    "X-Microsoft-Skype-Chain-ID": this._tsCall.callId,
                    Authorization: `Bearer ${S}`,
                    "x-skypetoken": S
                },
                withCredentials: !0
            };
            return this._httpRequestHelper.sendRequestWithRetry("post", v, C, E, Wy);
        }
        constructor(g, f, S, v){
            super(g), this._botParticipantId = "", this._isCteUser = !1, this._isCaptionsActive = !1, this._firstTimeActive = !1, this._ecsCaptionsEnabled = !1, this._ecsACSCaptionsEnabled = !1, this._ecsTeamsCaptionsEnabled = !1, this._ecsSpokenLanguagesEnabled = !1, this._ecsSpokenLanguages = [], this._ecsCaptionLanguagesEnabled = !1, this._ecsCaptionLanguages = [], this._ecsAmtPolicyUrlSuffix = "", this._ecsCapabilitiesEnabled = !0, this._ecsSetBotMetadataWhenEmptyFixEnabled = !0, this._hasReportedCaptionParseFailure = !1, this._hasReceivedFirstCaption = !1, this._currentLanguage = "", this._currentCaptionLanguage = "", this._participantSequenceIdMap = {}, this.capabilityChangeHandler = (g)=>{
                g.newValue.startLiveMeetingCaptions && (this._participantCapability.startLiveMeetingCaptions = this._call.getParticipantCapabilities().startLiveMeetingCaptions, this._logger.log(`participant capabilitity to startLiveMeetingCaptions feature is ${this._participantCapability}`)), g.newValue.startLiveCallingCaptions && (this._participantCapability.startLiveCallingCaptions = this._call.getParticipantCapabilities().startLiveCallingCaptions, this._logger.log(`participant capabilitity to startLiveCallingCaptions feature is ${this._participantCapability}`)), g.newValue.setCaptionLanguage && (this._participantCapability.setCaptionLanguage = this._call.getParticipantCapabilities().setCaptionLanguage, this._logger.log(`participant capabilitity to setCaptionLanguage feature is ${this._participantCapability}`));
            }, this._addParticipantPromise = null, this._dataChannelHandler = {
                onStarted: async (g, f)=>{},
                onStopped: async (g)=>{},
                onDataReceived: async (g, f, S)=>{
                    let v;
                    try {
                        v = JSON.parse(f.toString());
                    } catch (g) {
                        try {
                            if (void 0 === this._textDecoder) throw new Error("TextDecoder undefined.");
                            v = JSON.parse(this._textDecoder.decode(f));
                        } catch (g) {
                            return this._logger.error("Failed to parse Captions result", g), void (this._hasReportedCaptionParseFailure || (this._hasReportedCaptionParseFailure = !0, this._sendCaptionsEvent(my.FirstCaptionParsingError, uy.failure, "", 0, py.Unexpected, "Could not decode data packet.")));
                        }
                    }
                    if (v) {
                        let g = [];
                        v.textTracks && this._isCaptionInTextTracks(v) ? g = v.textTracks : v.recognitionResults && (g = v.recognitionResults), g.forEach((g)=>{
                            try {
                                var _this__tsCall_participants_find, _this__internalCallAgent;
                                if ("mt" !== g.source.toLowerCase() && "ai" !== g.source.toLowerCase()) return;
                                const [f, v] = g.id.split("/");
                                let _ = parseInt(v, 10);
                                if (this._participantSequenceIdMap[g.userId] && this._botParticipantId == f && this._participantSequenceIdMap[g.userId] > _) return;
                                this._botParticipantId = f, this._participantSequenceIdMap[g.userId] = _;
                                var _g_originalText;
                                const C = ((_this__tsCall_participants_find = this._tsCall.participants.find((f)=>f.id === g.userId)) === null || _this__tsCall_participants_find === void 0 ? void 0 : _this__tsCall_participants_find.displayName) || (this._internalCallAgent.getUserMri() === g.userId ? (_this__internalCallAgent = this._internalCallAgent) === null || _this__internalCallAgent === void 0 ? void 0 : _this__internalCallAgent.displayName : void 0), E = {
                                    resultType: g.isFinal ? "Final" : "Partial",
                                    captionText: g.text,
                                    spokenText: (_g_originalText = g.originalText) !== null && _g_originalText !== void 0 ? _g_originalText : g.text,
                                    timestamp: new Date(new Date(g.timestampAudioSent / 1e4).getTime() + qy),
                                    speaker: {
                                        identifier: constructIdentifierKindFromMri(g.userId),
                                        displayName: C
                                    },
                                    spokenLanguage: g.spokenLanguage,
                                    captionLanguage: g.trackLanguage
                                };
                                if (this._currentLanguage != g.spokenLanguage && (this._currentLanguage = g.spokenLanguage, this._eventEmitter.emit("SpokenLanguageChanged")), !this.isCaptionsFeatureActive || this._mediaStreamSourceId !== S) return;
                                this._hasReceivedFirstCaption || (this._hasReceivedFirstCaption = !0, this._sendCaptionsEvent(my.FirstCaptionReceived, uy.success, "", 0)), this._eventEmitter.emit("CaptionsReceived", E);
                            } catch (g) {
                                this._logger.error("Failed to parse Captions result", g), this._hasReportedCaptionParseFailure || (this._hasReportedCaptionParseFailure = !0, this._sendCaptionsEvent(my.FirstCaptionParsingError, uy.failure, "", 0, py.Unexpected, "Error thrown during incoming caption result mapping."));
                            }
                        });
                    }
                }
            }, this._isCaptionInTextTracks = (g)=>{
                let f = !1;
                return g.textTracks && g.textTracks.forEach((g)=>{
                    "Mt" === g.source && (f = !0);
                }), f;
            }, this._handleBotRemoved = (g)=>{
                this._acsMetadata && this._isCaptionsBot(g) && (this.isCaptionsFeatureActive && (this._isCaptionsActive = !1, this._eventEmitter.emit("CaptionsActiveChanged")), this._acsMetadata = void 0, this._firstTimeActive = !1);
            }, this._participantCapability = {
                startLiveMeetingCaptions: {
                    isPresent: !0,
                    reason: "Capable"
                },
                startLiveCallingCaptions: {
                    isPresent: !0,
                    reason: "Capable"
                },
                setCaptionLanguage: {
                    isPresent: !0,
                    reason: "Capable"
                }
            }, this._telemetryStartTime = Date.now();
        }
    }
    __decorate([
        asyncOperation(xy.StartCaptions),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [
            Object
        ]),
        __metadata("design:returntype", Promise)
    ], CaptionsCallFeatureImplOverTsCall.prototype, "startCaptions", null), __decorate([
        asyncOperation(xy.StopCaptions),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], CaptionsCallFeatureImplOverTsCall.prototype, "stopCaptions", null), __decorate([
        asyncOperation(xy.SetSpokenLanguage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [
            String
        ]),
        __metadata("design:returntype", Promise)
    ], CaptionsCallFeatureImplOverTsCall.prototype, "setSpokenLanguage", null), __decorate([
        asyncOperation(xy.SetCaptionLanguage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [
            String
        ]),
        __metadata("design:returntype", Promise)
    ], CaptionsCallFeatureImplOverTsCall.prototype, "setCaptionLanguage", null);
    class RaiseHandCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "RaiseHand";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f, this._callInfo);
        }
        async raiseHand() {
            return this._impl.raiseHand();
        }
        async lowerHand() {
            return this._impl.lowerHand();
        }
        async lowerHands(g) {
            return this._impl.lowerHands(g);
        }
        lowerAllHands() {
            return this._impl.lowerAllHands();
        }
        getRaisedHands() {
            return this._sendFeatureUsage("getRaisedHands", uy.getter), this._impl.raisedHands;
        }
        on(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "RaiseHand",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._impl = new RaiseHandCallImplOverTsCall(this.eventEmitter), this._callInfo = g.callInfo;
        }
    }
    class RaiseHandCallImplOverTsCall {
        initialize(g, f, S, v, _) {
            this._logger = v.createChild(()=>`RaiseHandFeature::Call(id='${g.callId}')`), this._tsCall = g, this._callInfo = _, this._telemetryLogManager = S, this._internalCallAgent = f, this._sendFeatureUsage("initialize", uy.initialize);
            try {
                let extractMRIs = (g)=>new Map(this.getPublishedState(g).sort(this.typeRankComparator).map((g)=>[
                            g.id,
                            g
                        ]));
                this._tsCall.on("publishedStatesChanged", async (g)=>{
                    let f = extractMRIs(g), S = this._currentRaiseHandStates;
                    this._currentRaiseHandStates = f, this._currentRaiseHandStates.forEach((g, f)=>{
                        S.has(f) || this._eventEmitter.emit("raisedHandEvent", {
                            identifier: constructIdentifierKindFromMri(f)
                        });
                    }), S.forEach((g, f)=>{
                        this._currentRaiseHandStates.has(f) || this._eventEmitter.emit("loweredHandEvent", {
                            identifier: constructIdentifierKindFromMri(f)
                        });
                    });
                }), this._tsCall.publishedStates && (this._currentRaiseHandStates = extractMRIs(this._tsCall.publishedStates)), this._sendFeatureUsage("initialize", uy.success);
            } catch (g) {
                throw this._logger.error("Could not initialize raise hand feature.", g), this._sendFeatureUsage("initialize", uy.failure), new CallingCommunicationError({
                    defaultError: O.FEATURES.RAISE_HAND.INITIALIZE,
                    originalError: g
                });
            }
        }
        async raiseHand() {
            if (this._sendFeatureUsage("raiseHand", uy.attempt), this._callInfo.context === BS.TwoParty) throw this._logger.warn("Raise hand not supported for 1:1 calls"), this._sendFeatureUsage("raiseHand", uy.failure), new CallingCommunicationError({
                defaultError: O.FEATURES.RAISE_HAND.NOT_SUPPORTED_1TO1
            });
            try {
                if (void 0 !== this.getLocalRaiseHandState()) return void this._sendFeatureUsage("raiseHand", uy.failure);
                const g = {
                    level: "user",
                    type: "raiseHands",
                    content: "{}"
                };
                if (!await this._tsCall.publishState(g, w.generateCauseId())) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.RAISE_HAND.RAISE_HAND_PUBLISH_STATE
                });
                this._sendFeatureUsage("raiseHand", uy.success);
            } catch (g) {
                var _g_response;
                throw this._logger.error("Could not change a participant state. Code: ", g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status), this._sendFeatureUsage("raiseHand", uy.failure), handlePublishStateFailure(g, O.FEATURES.RAISE_HAND.RAISE_HAND_FAIL);
            }
        }
        async lowerHand() {
            this._sendFeatureUsage("lowerHand", uy.attempt);
            try {
                const g = this.getLocalRaiseHandState();
                if (void 0 === g) return void this._sendFeatureUsage("lowerHand", uy.failure);
                const f = {
                    stateIds: [
                        g
                    ]
                };
                await this._tsCall.removeState(f, w.generateCauseId()), this._sendFeatureUsage("lowerHand", uy.success);
            } catch (g) {
                var _g_response;
                throw this._logger.error("Could not change a participant state. Code: ", g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status), this._sendFeatureUsage("lowerHand", uy.failure), handlePublishStateFailure(g, O.FEATURES.RAISE_HAND.LOWER_HAND_FAIL);
            }
        }
        async lowerHands(g) {
            this._sendFeatureUsage("lowerHands", uy.attempt);
            try {
                if (0 === g.length) return void this._sendFeatureUsage("lowerHands", uy.failure);
                if (0 === this._currentRaiseHandStates.size) return void this._sendFeatureUsage("lowerHands", uy.failure);
                const f = g.map((g)=>getMriFromIdentifier(g)), S = this.findStateIdsForParticipantIds(f);
                await this._tsCall.removeState({
                    stateIds: S
                }, w.generateCauseId()), this._sendFeatureUsage("lowerHands", uy.success);
            } catch (g) {
                throw this._logger.error("Could not change a participant state.", g), this._sendFeatureUsage("lowerHands", uy.failure), handlePublishStateFailure(g, O.FEATURES.RAISE_HAND.LOWER_REMOTEPARTICIPANTS_HANDS_FAIL);
            }
        }
        async lowerAllHands() {
            this._sendFeatureUsage("lowerAllHands", uy.attempt);
            try {
                await this._tsCall.removeStatesForEveryone({
                    type: "raiseHands"
                }, w.generateCauseId()), this._sendFeatureUsage("lowerAllHands", uy.success);
            } catch (g) {
                throw this._logger.error("Could not change a participant state.", g), this._sendFeatureUsage("lowerAllHands", uy.failure), handlePublishStateFailure(g, O.FEATURES.RAISE_HAND.LOWER_ALL_HANDS_FAIL);
            }
        }
        get raisedHands() {
            return 0 === this._currentRaiseHandStates.size ? [] : Array.from(this._currentRaiseHandStates.keys()).map((g, f)=>({
                    identifier: constructIdentifierKindFromMri(g),
                    order: f + 1
                }));
        }
        getLocalRaiseHandState() {
            const g = this.findStateIdsForParticipantIds([
                this._internalCallAgent.getUserMri()
            ]);
            if (g && g.length > 0) return g[0];
        }
        findStateIdsForParticipantIds(g) {
            return g && 0 !== this._currentRaiseHandStates.size ? Array.from(this._currentRaiseHandStates.entries()).filter((f)=>g.includes(f[0])).map((g)=>{
                var _g__publishedState, _g_;
                return (_g_ = g[1]) === null || _g_ === void 0 ? void 0 : (_g__publishedState = _g_.publishedState) === null || _g__publishedState === void 0 ? void 0 : _g__publishedState.stateId;
            }).filter((g)=>!!g) : [];
        }
        getPublishedState(g) {
            return g.typeStates.filter((g)=>"raiseHands" === g.type).map((g)=>g.participantStates).flat();
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "RaiseHand",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            this.typeRankComparator = (g, f)=>void 0 === g.publishedState ? -1 : void 0 === f.publishedState ? 1 : g.publishedState.typeRank - f.publishedState.typeRank, this._eventEmitter = g, this._currentRaiseHandStates = new Map;
        }
    }
    var zy;
    !function(g) {
        g.turnVideoOn = "turnVideoOn", g.unmuteMic = "unmuteMic", g.shareScreen = "shareScreen", g.removeParticipant = "removeParticipant", g.hangUpForEveryOne = "hangUpForEveryOne", g.addCommunicationUser = "addCommunicationUser", g.addTeamsUser = "addTeamsUser", g.addPhoneNumber = "addPhoneNumber", g.manageLobby = "manageLobby", g.spotlightParticipant = "spotlightParticipant", g.removeParticipantsSpotlight = "removeParticipantsSpotlight", g.blurBackground = "blurBackground", g.startLiveMeetingCaptions = "startLiveMeetingCaptions", g.startLiveCallingCaptions = "startLiveCallingCaptions", g.setCaptionLanguage = "setCaptionLanguage", g.raiseHand = "raiseHand", g.pstnDialOut = "pstnDialOut", g.muteOthers = "muteOthers", g.useReactions = "useReactions", g.viewAttendeeNames = "viewAttendeeNames", g.startTogetherMode = "startTogetherMode", g.joinBreakoutRooms = "joinBreakoutRooms", g.forbidOthersAudio = "forbidOthersAudio", g.forbidOthersVideo = "forbidOthersVideo";
    }(zy || (zy = {}));
    class RoomsCapabilityResolver {
        getResolvedCapabilitiesBasedOnRole(g, f) {
            let S = {
                ...f
            }, v = g.toLocaleLowerCase();
            return v !== sS.Attendee.toLocaleLowerCase() && v !== sS.Presenter.toLocaleLowerCase() && v !== sS.Consumer.toLocaleLowerCase() && v !== sS.Organizer.toLocaleLowerCase() || (this._ecsConfig[dS][v][zy.turnVideoOn] ? S.turnVideoOn = {
                isPresent: this._ecsConfig[dS][v][zy.turnVideoOn],
                reason: cS.Capable
            } : S.turnVideoOn = {
                isPresent: this._ecsConfig[dS][v][zy.turnVideoOn],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.unmuteMic] ? S.unmuteMic = {
                isPresent: this._ecsConfig[dS][v][zy.unmuteMic],
                reason: cS.Capable
            } : S.unmuteMic = {
                isPresent: this._ecsConfig[dS][v][zy.unmuteMic],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.shareScreen] ? S.shareScreen = {
                isPresent: this._ecsConfig[dS][v][zy.shareScreen],
                reason: cS.Capable
            } : S.shareScreen = {
                isPresent: this._ecsConfig[dS][v][zy.shareScreen],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.removeParticipant] ? S.removeParticipant = {
                isPresent: this._ecsConfig[dS][v][zy.removeParticipant],
                reason: cS.Capable
            } : S.removeParticipant = {
                isPresent: this._ecsConfig[dS][v][zy.removeParticipant],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.muteOthers] ? S.muteOthers = {
                isPresent: this._ecsConfig[dS][v][zy.muteOthers],
                reason: cS.Capable
            } : S.muteOthers = {
                isPresent: this._ecsConfig[dS][v][zy.muteOthers],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.pstnDialOut] ? S.pstnDialOut = {
                isPresent: this._ecsConfig[dS][v][zy.pstnDialOut],
                reason: cS.Capable
            } : S.pstnDialOut = {
                isPresent: this._ecsConfig[dS][v][zy.pstnDialOut],
                reason: cS.RoleRestricted
            }, this._ecsConfig[dS][v][zy.addPhoneNumber] ? S.addPhoneNumber = {
                isPresent: this._ecsConfig[dS][v][zy.addPhoneNumber],
                reason: cS.Capable
            } : S.addPhoneNumber = {
                isPresent: this._ecsConfig[dS][v][zy.addPhoneNumber],
                reason: cS.RoleRestricted
            }), S.removeParticipant = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.hangUpForEveryOne = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.addCommunicationUser = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.addTeamsUser = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.manageLobby = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.spotlightParticipant = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.removeParticipantsSpotlight = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.blurBackground = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.startLiveMeetingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            }, S.startLiveCallingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            }, S.setCaptionLanguage = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.raiseHand = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.useReactions = {
                isPresent: !0,
                reason: cS.Capable
            }, S.viewAttendeeNames = {
                isPresent: !0,
                reason: cS.Capable
            }, S.startTogetherMode = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.joinBreakoutRooms = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.forbidOthersAudio = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, S.forbidOthersVideo = {
                isPresent: !1,
                reason: cS.CapabilityNotApplicableForTheCallType
            }, this._logger.log(`Capabilities resolved to : ${JSON.stringify(S)} on role change to ${g}`), S;
        }
        constructor(g){
            this._logger = g, this._ecsConfig = getAcsEcsConfig();
        }
    }
    const Ky = "DisableAv", Jy = "DisableVideo", Yy = "DisableAudio", Qy = "Attendee", Xy = "attendee";
    class MediaAccessCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "MediaAccess";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        getAllOthersMediaAccess() {
            return this._impl.getAllOthersMediaAccess();
        }
        getMeetingMediaAccess() {
            return this._impl.getMeetingMediaAccess();
        }
        async permitAudio(g) {
            return this._impl.permitAudio(g);
        }
        async permitOthersAudio() {
            return this._impl.permitOthersAudio();
        }
        async forbidAudio(g) {
            return this._impl.forbidAudio(g);
        }
        async forbidOthersAudio() {
            return this._impl.forbidOthersAudio();
        }
        async permitVideo(g) {
            return this._impl.permitVideo(g);
        }
        async permitOthersVideo() {
            return this._impl.permitOthersVideo();
        }
        async forbidVideo(g) {
            return this._impl.forbidVideo(g);
        }
        async forbidOthersVideo() {
            return this._impl.forbidOthersVideo();
        }
        on(g, f) {
            if (this._sendFeatureUsage(g, uy.subscribe), "mediaAccessChanged" !== g && "meetingMediaAccessChanged" !== g && "localParticipantMediaAccessChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if (this._sendFeatureUsage(g, uy.unsubscribe), "mediaAccessChanged" !== g && "meetingMediaAccessChanged" !== g && "localParticipantMediaAccessChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "MediaAccess",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this.getLocalParticipantMediaAccess = ()=>this._impl.getLocalParticipantMediaAccess(), this._impl = new MediaAccessCallImplOverTsCall(this.eventEmitter);
        }
    }
    class MediaAccessCallImplOverTsCall {
        initialize(g, f, S, v, _) {
            this._logger = _.createChild(()=>`MediaAccessCallFeature::Call(id='${g.callId}')`), this._tsCall = g, this._call = S, this._telemetryLogManager = v, this._internalCallAgent = f, this._sendFeatureUsage("initialize", uy.initialize);
            try {
                var _this__tsCall_meetingDetails_meetingCapability, _this__tsCall_meetingDetails;
                if (!this._ecsTeamsMediaAccessEnabled) throw "feature not supported or call context is not teams meeting join";
                this._tsCall.on("publishedStatesChanged", async (g)=>{
                    this._logger.info("publishedStatesChanged event received");
                    const f = this._publishedStatesMediaAccessMap;
                    this._publishedStatesMediaAccessMap = this.getMediaAccessMap(g), P.isEqual(f, this._publishedStatesMediaAccessMap) || this._eventEmitter.emit("mediaAccessChanged", {
                        mediaAccesses: this.getAllOthersMediaAccess()
                    }), this.checkLocalMediaAccessAndEmitEvent();
                }), this._tsCall.changed(()=>{
                    var _this__tsCall_meetingDetails_meetingCapability, _this__tsCall_meetingDetails;
                    const g = (_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_meetingCapability = _this__tsCall_meetingDetails.meetingCapability) === null || _this__tsCall_meetingDetails_meetingCapability === void 0 ? void 0 : _this__tsCall_meetingDetails_meetingCapability.attendeeRestrictions;
                    P.isEqual(this._attendeeRestrictions, g) || (this._logger.info(`Attendee restrictions change from ${this._attendeeRestrictions} to ${g}`), this._attendeeRestrictions = g, this._eventEmitter.emit("meetingMediaAccessChanged", {
                        meetingMediaAccess: this.getMeetingMediaAccess()
                    }), this.checkRemoteParticipantsMediaAccessAndEmitEvent(), this.checkLocalMediaAccessAndEmitEvent());
                }), this._tsCall.on("participantCountsUpdated", (g)=>{
                    this._logger.info("participantCountsUpdated changed event received, totalParticipants: ", g === null || g === void 0 ? void 0 : g.totalParticipants), this.checkRemoteParticipantsMediaAccessAndEmitEvent(), this.checkLocalMediaAccessAndEmitEvent();
                }), this._attendeeRestrictions = (_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_meetingCapability = _this__tsCall_meetingDetails.meetingCapability) === null || _this__tsCall_meetingDetails_meetingCapability === void 0 ? void 0 : _this__tsCall_meetingDetails_meetingCapability.attendeeRestrictions, this._publishedStatesMediaAccessMap = this.getMediaAccessMap(this._tsCall.publishedStates), this._localMediaAccess = this.getLocalParticipantMediaAccess(), this._sendFeatureUsage("initialize", uy.success);
            } catch (g) {
                throw this._logger.error("Could not initialize media access feature.", g), this._sendFeatureUsage("initialize", uy.failure), new CallingCommunicationError({
                    defaultError: O.FEATURES.MEDIA_ACCESS.INITIALIZE_FAILED,
                    originalError: g
                });
            }
        }
        async permitAudio(g) {
            const f = generateGuid();
            this._sendFeatureUsage("permitAudio", uy.attempt, f), this.validateMediaAccessConditions("permitAudio", f, !1, g.map((g)=>getMriFromIdentifier(g)));
            try {
                const S = g.map((g)=>getMriFromIdentifier(g));
                this.isMeetingCapabilityAudioRestricted() ? await this.addModalityState(S, "attendeeModalitiesUnrestricted", f) : await this.removeModalityState(S, "attendeeAudioRestricted", f), this._sendFeatureUsage("permitAudio", uy.success, f);
            } catch (g) {
                var _g_response;
                throw this._logger.error(`Could not change a participant state. Code: ${g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status} correlationId: ${f}`), this._sendFeatureUsage("permitAudio", uy.failure), handlePublishStateFailure(g, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async forbidAudio(g) {
            const f = generateGuid();
            this._sendFeatureUsage("forbidAudio", uy.attempt, f), this.validateMediaAccessConditions("forbidAudio", f, !1, g.map((g)=>getMriFromIdentifier(g)));
            try {
                const S = g.map((g)=>getMriFromIdentifier(g));
                this.isMeetingCapabilityAudioRestricted() ? await this.removeModalityState(S, "attendeeModalitiesUnrestricted", f) : await this.addModalityState(S, "attendeeAudioRestricted", f), this._sendFeatureUsage("forbidAudio", uy.success, f);
            } catch (g) {
                var _g_response;
                throw this._logger.error(`Could not change a participant state. Code: ${g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status} correlationId: ${f}`), this._sendFeatureUsage("forbidAudio", uy.failure), handlePublishStateFailure(g, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async permitOthersAudio() {
            const g = generateGuid();
            this._sendFeatureUsage("permitOthersAudio", uy.attempt, g), this.validateMediaAccessConditions("permitOthersAudio", g, !0);
            try {
                let f;
                f = this.isMeetingCapabilityVideoRestricted() ? 2 : 0, await this.updateAttendeeRestrictions(f, g), this._sendFeatureUsage("permitOthersAudio", uy.success, g);
            } catch (f) {
                var _f_response;
                throw this._logger.error(`Could not change a participant state. Code: ${f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.status} correlationId: ${g}`), this._sendFeatureUsage("permitOthersAudio", uy.failure), handlePublishStateFailure(f, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async forbidOthersAudio() {
            const g = generateGuid();
            this._sendFeatureUsage("forbidOthersAudio", uy.attempt, g), this.validateMediaAccessConditions("forbidOthersAudio", g, !0);
            try {
                let f;
                f = this.isMeetingCapabilityVideoRestricted() ? 3 : 1, await this.updateAttendeeRestrictions(f, g), this._sendFeatureUsage("forbidOthersAudio", uy.success, g);
            } catch (f) {
                var _f_response;
                throw this._logger.error(`Could not change a participant state. Code: ${f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.status} correlationId: ${g}`), this._sendFeatureUsage("forbidOthersAudio", uy.failure), handlePublishStateFailure(f, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async permitVideo(g) {
            const f = generateGuid();
            this._sendFeatureUsage("permitVideo", uy.attempt, f), this.validateMediaAccessConditions("permitVideo", f, !1, g.map((g)=>getMriFromIdentifier(g)));
            try {
                const S = g.map((g)=>getMriFromIdentifier(g));
                this.isMeetingCapabilityVideoRestricted() ? await this.addModalityState(S, "attendeeVideoUnrestricted", f) : await this.removeModalityState(S, "attendeeVideoRestricted", f), this._sendFeatureUsage("permitVideo", uy.success, f);
            } catch (g) {
                var _g_response;
                throw this._logger.error(`Could not change a participant state. Code: ${g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status} correlationId: ${f}`), this._sendFeatureUsage("permitVideo", uy.failure), handlePublishStateFailure(g, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async forbidVideo(g) {
            const f = generateGuid();
            this._sendFeatureUsage("forbidVideo", uy.attempt, f), this.validateMediaAccessConditions("forbidVideo", f, !1, g.map((g)=>getMriFromIdentifier(g)));
            try {
                const S = g.map((g)=>getMriFromIdentifier(g));
                this.isMeetingCapabilityVideoRestricted() ? await this.removeModalityState(S, "attendeeVideoUnrestricted", f) : await this.addModalityState(S, "attendeeVideoRestricted", f), this._sendFeatureUsage("forbidVideo", uy.success, f);
            } catch (g) {
                var _g_response;
                throw this._logger.error(`Could not change a participant state. Code: ${g === null || g === void 0 ? void 0 : (_g_response = g.response) === null || _g_response === void 0 ? void 0 : _g_response.status} correlationId: ${f}`), this._sendFeatureUsage("forbidVideo", uy.failure), handlePublishStateFailure(g, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async permitOthersVideo() {
            const g = generateGuid();
            this._sendFeatureUsage("permitOthersVideo", uy.attempt, g), this.validateMediaAccessConditions("permitOthersVideo", g, !0);
            try {
                let f;
                f = this.isMeetingCapabilityAudioRestricted() ? 1 : 0, await this.updateAttendeeRestrictions(f, g), this._sendFeatureUsage("permitOthersVideo", uy.success, g);
            } catch (f) {
                var _f_response;
                throw this._logger.error(`Could not change a participant state. Code: ${f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.status} correlationId: ${g}`), this._sendFeatureUsage("permitOthersVideo", uy.failure), handlePublishStateFailure(f, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        async forbidOthersVideo() {
            const g = generateGuid();
            this._sendFeatureUsage("forbidOthersVideo", uy.attempt, g), this.validateMediaAccessConditions("forbidOthersVideo", g, !0);
            try {
                let f;
                f = this.isMeetingCapabilityAudioRestricted() ? 3 : 2, await this.updateAttendeeRestrictions(f, g), this._sendFeatureUsage("forbidOthersVideo", uy.success, g);
            } catch (f) {
                var _f_response;
                throw this._logger.error(`Could not change a participant state. Code: ${f === null || f === void 0 ? void 0 : (_f_response = f.response) === null || _f_response === void 0 ? void 0 : _f_response.status} correlationId: ${g}`), this._sendFeatureUsage("forbidOthersVideo", uy.failure), handlePublishStateFailure(f, O.FEATURES.MEDIA_ACCESS.MEDIA_ACCESS_UPDATE_FAILED);
            }
        }
        getMeetingMediaAccess() {
            return {
                isAudioPermitted: !this.isMeetingCapabilityAudioRestricted(),
                isVideoPermitted: !this.isMeetingCapabilityVideoRestricted()
            };
        }
        updateAttendeeRestrictions(g, f) {
            const S = {
                attendeeRestrictions: g
            };
            return this._tsCall.updateMeetingSettings(S, f).catch((g)=>{
                this._logger.error(`updateAttendeeRestrictions: failed with correlationId: ${f}, error: ${JSON.stringify(g)}`);
            });
        }
        getPublishedState(g) {
            return g.typeStates.filter((g)=>[
                    "attendeeVideoRestricted",
                    "attendeeAudioRestricted",
                    "attendeeVideoUnrestricted",
                    "attendeeModalitiesUnrestricted"
                ].includes(g.type));
        }
        addModalityState(g, f, S) {
            return new Promise((v, _)=>{
                const C = {
                    type: f,
                    level: "user",
                    content: "{}",
                    participantIds: g
                };
                this._tsCall.publishState(C, S).then(()=>{
                    v();
                }).catch((f)=>{
                    const v = `addModalityState: failed with error: ${JSON.stringify({
                        ...f,
                        correlationId: S,
                        participantIds: g
                    })}`;
                    this._logger.error(v), _(v);
                });
            });
        }
        removeModalityState(g, f, S) {
            const v = this._tsCall.publishedStates ? this.getStateIdForParticipants(this._tsCall.publishedStates, g, f) : [];
            if (P.isEmpty(v)) {
                const v = `removeModalityState: no valid stateIds found for participants: ${g}, publishStateType: ${f} correlationId: ${S}`;
                return this._logger.error(v), Promise.reject(v);
            }
            return new Promise((g, f)=>{
                const _ = {
                    stateIds: v
                };
                this._tsCall.removeState(_, S).then(()=>{
                    g();
                }).catch((g)=>{
                    const _ = `removeModalityState: failed with error: ${JSON.stringify({
                        ...g,
                        correlationId: S,
                        stateIds: v
                    })}`;
                    this._logger.error(_), f(_);
                });
            });
        }
        getStateIdForParticipants(g, f, S) {
            const v = [], _ = g && g.typeStates && g.typeStates.find((g)=>g.type === S);
            return P.isEmpty(_ === null || _ === void 0 ? void 0 : _.participantStates) ? (this._logger.error(`getStateIdForParticipants: no valid typeState or participantStates found for participants: ${f}`), v) : (f.forEach((g)=>{
                const f = _ === null || _ === void 0 ? void 0 : _.participantStates.find((f)=>f && f.id === g);
                P.isEmpty(f) ? this._logger.error(`getStateIdForParticipants: participant: ${g} not found.`) : P.isEmpty(f === null || f === void 0 ? void 0 : f.publishedState) ? this._logger.error(`getStateIdForParticipants: no published state for participant: ${g}`) : (f === null || f === void 0 ? void 0 : f.publishedState) && v.push(f.publishedState.stateId);
            }), v);
        }
        validateMediaAccessConditions(g, f, S, v) {
            let _;
            if (this._ecsTeamsMediaAccessEnabled) {
                if (this.isUserRoleEligible()) {
                    if (S || this.isSupportedConversationType()) {
                        var _this__tsCall_meetingDetails_meetingCapability, _this__tsCall_meetingDetails;
                        if (S && !this._supportedConversationTypesForMuteAll.includes(this._tsCall.conversationType)) this._logger.error(`Conversation type is not supported for media access all feature, conversation type: ${this._tsCall.conversationType}`), _ = new CallingCommunicationError({
                            defaultError: O.FEATURES.MEDIA_ACCESS.UNSUPPORTED_CONVERSATION_TYPE,
                            defaultErrorMessageArgs: [
                                "Conversation type: ",
                                this._tsCall.conversationType
                            ]
                        });
                        else if (3 !== this._tsCall.state) this._logger.error("Call state is not connected."), _ = new CallingCommunicationError({
                            defaultError: O.FEATURES.MEDIA_ACCESS.CALL_NOT_CONNECTED,
                            defaultErrorMessageArgs: [
                                "call state: ",
                                this._tsCall.state
                            ]
                        });
                        else if (P.isEmpty(v)) ((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_meetingCapability = _this__tsCall_meetingDetails.meetingCapability) === null || _this__tsCall_meetingDetails_meetingCapability === void 0 ? void 0 : _this__tsCall_meetingDetails_meetingCapability.attendeeRestrictions) || (this._logger.error("Meeting capability attendee restrictions is empty."), _ = new CallingCommunicationError({
                            defaultError: O.FEATURES.MEDIA_ACCESS.INVALID_MEETING_CAPABILITY_ATTENDEE_RESTRICTIONS,
                            defaultErrorMessageArgs: [
                                "Meeting capability attendeerestrictions is empty."
                            ]
                        }));
                        else {
                            const g = this._tsCall.participants.find((g)=>(v === null || v === void 0 ? void 0 : v.includes(g.id)) && g.advancedMeetingRole !== Xy);
                            g && (this._logger.error(`Participant is not an attendee. id: ${g.id}`), _ = new CallingCommunicationError({
                                defaultError: O.FEATURES.MEDIA_ACCESS.ROLE_RESTRICTED,
                                defaultErrorMessageArgs: [
                                    "Participant role: ",
                                    g.advancedMeetingRole || ""
                                ]
                            }));
                        }
                    } else this._logger.error(`Conversation type is not supported for media access feature, conversation type: ${this._tsCall.conversationType}`), _ = new CallingCommunicationError({
                        defaultError: O.FEATURES.MEDIA_ACCESS.UNSUPPORTED_CONVERSATION_TYPE,
                        defaultErrorMessageArgs: [
                            "Conversation type: ",
                            this._tsCall.conversationType
                        ]
                    });
                } else this._logger.error("User role is not eligible for media access feature."), _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.MEDIA_ACCESS.UNSUPPORTED_ROLE,
                    defaultErrorMessageArgs: [
                        "User role: ",
                        this._tsCall.advancedMeetingRole || ""
                    ]
                });
            } else this._logger.error("Media access feature is not enabled."), _ = new CallingCommunicationError({
                defaultError: O.FEATURES.MEDIA_ACCESS.FEATURE_DISABLED,
                defaultErrorMessageArgs: [
                    "Media access feature is not enabled."
                ]
            });
            if (_) throw this._sendFeatureUsage(g, uy.failure, f), _;
        }
        _sendFeatureUsage(g, f, S) {
            sendCallFeatureUsageTelemetry({
                correlationId: S,
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "MediaAccess",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            this._ecsTeamsMediaAccessEnabled = !1, this._remoteParticipantsMediaAccess = [], this.getAllOthersMediaAccess = ()=>(this._remoteParticipantsMediaAccess = this._tsCall.participants.reduce((g, f)=>{
                    const S = this._publishedStatesMediaAccessMap.get(f.id), v = f.advancedMeetingRole === Xy, _ = constructIdentifierKindFromMri(f.id);
                    return S && v ? g.push(S) : !S && v ? g.push({
                        participant: _,
                        isAudioPermitted: !this.isMeetingCapabilityAudioRestricted(),
                        isVideoPermitted: !this.isMeetingCapabilityVideoRestricted()
                    }) : g.push({
                        participant: _,
                        isAudioPermitted: !0,
                        isVideoPermitted: !0
                    }), g;
                }, []), this._remoteParticipantsMediaAccess), this.getLocalParticipantMediaAccess = ()=>{
                const g = this._internalCallAgent.getUserMri(), f = this._publishedStatesMediaAccessMap.get(g), S = this._call.role === Qy;
                if (f && S) return f;
                const v = constructIdentifierKindFromMri(g);
                return !f && S ? {
                    participant: v,
                    isAudioPermitted: !this.isMeetingCapabilityAudioRestricted(),
                    isVideoPermitted: !this.isMeetingCapabilityVideoRestricted()
                } : {
                    participant: v,
                    isAudioPermitted: !0,
                    isVideoPermitted: !0
                };
            }, this.isMeetingCapabilityAudioRestricted = ()=>{
                var _this__tsCall_meetingDetails_meetingCapability, _this__tsCall_meetingDetails;
                return [
                    Ky,
                    Yy
                ].includes((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_meetingCapability = _this__tsCall_meetingDetails.meetingCapability) === null || _this__tsCall_meetingDetails_meetingCapability === void 0 ? void 0 : _this__tsCall_meetingDetails_meetingCapability.attendeeRestrictions);
            }, this.isMeetingCapabilityVideoRestricted = ()=>{
                var _this__tsCall_meetingDetails_meetingCapability, _this__tsCall_meetingDetails;
                return [
                    Ky,
                    Jy
                ].includes((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_meetingCapability = _this__tsCall_meetingDetails.meetingCapability) === null || _this__tsCall_meetingDetails_meetingCapability === void 0 ? void 0 : _this__tsCall_meetingDetails_meetingCapability.attendeeRestrictions);
            }, this.getMediaAccessMap = (g)=>{
                if (P.isEmpty(g === null || g === void 0 ? void 0 : g.typeStates)) return new Map;
                const f = new Map;
                return g && this.getPublishedState(g).forEach((g)=>{
                    g.participantStates.forEach((S)=>{
                        let v = f.get(S.id);
                        v || (v = {
                            participantId: S.id
                        }, f.set(S.id, v)), [
                            "attendeeAudioRestricted",
                            "attendeeModalitiesUnrestricted"
                        ].includes(g.type) && (v.isAudioPermitted = this.isAudioPermitted(g.type)), [
                            "attendeeVideoRestricted",
                            "attendeeVideoUnrestricted"
                        ].includes(g.type) && (v.isVideoPermitted = this.isVideoPermitted(g.type));
                    });
                }), f.forEach((g)=>{
                    void 0 === g.isAudioPermitted && (g.isAudioPermitted = !this.isMeetingCapabilityAudioRestricted()), void 0 === g.isVideoPermitted && (g.isVideoPermitted = !this.isMeetingCapabilityVideoRestricted());
                }), new Map(Array.from(f).map(([g, f])=>[
                        g,
                        {
                            participant: constructIdentifierKindFromMri(g),
                            isAudioPermitted: !!(f === null || f === void 0 ? void 0 : f.isAudioPermitted),
                            isVideoPermitted: !!(f === null || f === void 0 ? void 0 : f.isVideoPermitted)
                        }
                    ]));
            }, this.isAudioPermitted = (g)=>this.isMeetingCapabilityAudioRestricted() ? "attendeeModalitiesUnrestricted" === g : "attendeeAudioRestricted" !== g, this.isVideoPermitted = (g)=>this.isMeetingCapabilityVideoRestricted() ? "attendeeVideoUnrestricted" === g : "attendeeVideoRestricted" !== g, this.checkRemoteParticipantsMediaAccessAndEmitEvent = ()=>{
                const g = this._remoteParticipantsMediaAccess;
                this._publishedStatesMediaAccessMap = this.getMediaAccessMap(this._tsCall.publishedStates), this.getAllOthersMediaAccess(), P.isEqual(g, this._remoteParticipantsMediaAccess) || this._eventEmitter.emit("mediaAccessChanged", {
                    mediaAccesses: this._remoteParticipantsMediaAccess
                });
            }, this.checkLocalMediaAccessAndEmitEvent = ()=>{
                const g = this.getLocalParticipantMediaAccess();
                P.isEqual(this._localMediaAccess, g) || (this._localMediaAccess = g, this._eventEmitter.emit("localParticipantMediaAccessChanged", {
                    mediaAccess: this._localMediaAccess
                }));
            }, this.isUserRoleEligible = ()=>this._tsCall.advancedMeetingRole && this._supportedUserRoles.includes(this._tsCall.advancedMeetingRole), this.isSupportedConversationType = ()=>this._supportedConversationTypes.includes(this._tsCall.conversationType);
            const f = getAcsEcsConfig().calling.mediaAccess;
            this._ecsTeamsMediaAccessEnabled = f.enabled, this._supportedUserRoles = f.supportedRoles, this._supportedConversationTypes = f.supportedConversationTypes, this._supportedConversationTypesForMuteAll = f.supportedConversationTypesForMuteAll, this._eventEmitter = g, this._publishedStatesMediaAccessMap = new Map, this._attendeeRestrictions = "", this._localMediaAccess = void 0;
        }
    }
    class TeamsCapabilityResolver {
        getResolvedCapabilitiesBasedOnRole(g, f) {
            let S = {
                ...f
            }, v = g.toLocaleLowerCase();
            return v !== sS.Attendee.toLocaleLowerCase() && v !== sS.Presenter.toLocaleLowerCase() && v !== sS.Consumer.toLocaleLowerCase() && v !== sS.Organizer.toLocaleLowerCase() && v !== sS.Coorganizer.toLocaleLowerCase() || (v = v.replace("-", ""), f.shareScreen.reason != cS.UserPolicyRestricted && (this._ecsConfig[uS][v][zy.shareScreen] ? S.shareScreen = {
                isPresent: !0,
                reason: cS.Capable
            } : S.shareScreen = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), this._ecsConfig[uS][v][zy.removeParticipant] ? S.removeParticipant = {
                isPresent: !0,
                reason: cS.Capable
            } : S.removeParticipant = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.hangUpForEveryOne] ? S.hangUpForEveryOne = {
                isPresent: !0,
                reason: cS.Capable
            } : S.hangUpForEveryOne = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.addCommunicationUser] ? S.addCommunicationUser = {
                isPresent: !0,
                reason: cS.Capable
            } : S.addCommunicationUser = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.addTeamsUser] ? S.addTeamsUser = {
                isPresent: !0,
                reason: cS.Capable
            } : S.addTeamsUser = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.addPhoneNumber] ? S.addPhoneNumber = {
                isPresent: !0,
                reason: cS.Capable
            } : S.addPhoneNumber = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.manageLobby] ? S.manageLobby = {
                isPresent: !0,
                reason: cS.Capable
            } : S.manageLobby = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.spotlightParticipant] ? S.spotlightParticipant = {
                isPresent: !0,
                reason: cS.Capable
            } : S.spotlightParticipant = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, this._ecsConfig[uS][v][zy.removeParticipantsSpotlight] ? S.removeParticipantsSpotlight = {
                isPresent: !0,
                reason: cS.Capable
            } : S.removeParticipantsSpotlight = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }, f.blurBackground.reason != cS.UserPolicyRestricted && (this._ecsConfig[uS][v][zy.blurBackground] ? S.blurBackground = {
                isPresent: !0,
                reason: cS.Capable
            } : S.blurBackground = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.startLiveMeetingCaptions.reason != cS.UserPolicyRestricted && (this._ecsConfig[uS][v][zy.startLiveMeetingCaptions] ? S.startLiveMeetingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            } : S.startLiveMeetingCaptions = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.startLiveCallingCaptions.reason != cS.UserPolicyRestricted && (this._ecsConfig[uS][v][zy.startLiveCallingCaptions] ? S.startLiveCallingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            } : S.startLiveCallingCaptions = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.setCaptionLanguage.reason != cS.TeamsPremiumLicenseRestricted && (this._ecsConfig[uS][v][zy.setCaptionLanguage] ? S.setCaptionLanguage = {
                isPresent: !0,
                reason: cS.Capable
            } : S.setCaptionLanguage = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.raiseHand.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.raiseHand] ? S.raiseHand = {
                isPresent: !0,
                reason: cS.Capable
            } : S.raiseHand = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.pstnDialOut.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.pstnDialOut] ? S.pstnDialOut = {
                isPresent: !0,
                reason: cS.Capable
            } : S.pstnDialOut = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.muteOthers.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.muteOthers] ? S.muteOthers = {
                isPresent: !0,
                reason: cS.Capable
            } : S.muteOthers = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.forbidOthersAudio.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.forbidOthersAudio] ? S.forbidOthersAudio = {
                isPresent: !0,
                reason: cS.Capable
            } : S.forbidOthersAudio = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.forbidOthersVideo.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.forbidOthersVideo] ? S.forbidOthersVideo = {
                isPresent: !0,
                reason: cS.Capable
            } : S.forbidOthersVideo = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.useReactions.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.useReactions] ? S.useReactions = {
                isPresent: !0,
                reason: cS.Capable
            } : S.useReactions = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.viewAttendeeNames.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.viewAttendeeNames] ? S.viewAttendeeNames = {
                isPresent: !0,
                reason: cS.Capable
            } : S.viewAttendeeNames = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.startTogetherMode.reason != cS.MeetingRestricted && (this._ecsConfig[uS][v][zy.startTogetherMode] ? S.startTogetherMode = {
                isPresent: !0,
                reason: cS.Capable
            } : S.startTogetherMode = {
                isPresent: !1,
                reason: cS.RoleRestricted
            }), f.joinBreakoutRooms.reason != cS.UserPolicyRestricted && (this._ecsConfig[uS][v][zy.joinBreakoutRooms] ? S.joinBreakoutRooms = {
                isPresent: !0,
                reason: cS.Capable
            } : S.joinBreakoutRooms = {
                isPresent: !1,
                reason: cS.RoleRestricted
            })), this.resolveMicVideoAndScreenShareCapabilities(S), this._logger.log(`Capabilities resolved to : ${JSON.stringify(S)} on role change to ${g}`), S;
        }
        getResolvedCapabilitiesBasedOnMeetingCapabilities(g, f) {
            let S = {
                ...f
            };
            return this.resolveMicVideoAndScreenShareCapabilities(S), null != g.allowRaiseHands && (g.allowRaiseHands ? S.raiseHand = {
                isPresent: !0,
                reason: cS.Capable
            } : S.raiseHand = {
                isPresent: !1,
                reason: cS.MeetingRestricted
            }), null != g.allowPstnConferencing && (g.allowPstnConferencing ? S.pstnDialOut = {
                isPresent: !0,
                reason: cS.Capable
            } : S.pstnDialOut = {
                isPresent: !1,
                reason: cS.MeetingRestricted
            }), null != g.allowTeamsMeetingReactions && (g.allowTeamsMeetingReactions ? S.useReactions = {
                isPresent: !0,
                reason: cS.Capable
            } : S.useReactions = {
                isPresent: !1,
                reason: cS.MeetingRestricted
            }), null != g.maskIdentitiesForRole && (g.maskIdentitiesForRole ? S.viewAttendeeNames = {
                isPresent: !1,
                reason: cS.MeetingRestricted
            } : S.viewAttendeeNames = {
                isPresent: !0,
                reason: cS.Capable
            }), null != g.allowTranslatedCaptions && (g.allowTranslatedCaptions ? S.setCaptionLanguage = {
                isPresent: !0,
                reason: cS.Capable
            } : S.setCaptionLanguage = {
                isPresent: !1,
                reason: cS.TeamsPremiumLicenseRestricted
            }), this._logger.log(`Capabilities resolved to : ${JSON.stringify(S)} on meeting details change to ${g}`), S;
        }
        getResolvedCapabilitiesBasedOnUserPolicy(g, f) {
            var _g_teamsMeetingPolicy, _g_teamsMeetingPolicy1, _g_teamsMeetingPolicy2, _g_teamsMeetingPolicy3, _g_teamsCallingPolicy, _g_teamsCallingPolicy1, _g_teamsMeetingPolicy4, _g_teamsMeetingPolicy5, _g_teamsMeetingPolicy6, _g_teamsMeetingPolicy7, _g_teamsMeetingPolicy8, _g_teamsMeetingPolicy9, _g_teamsMeetingPolicy10, _g_teamsMeetingPolicy11;
            let S = {
                ...f
            };
            return null != ((_g_teamsMeetingPolicy = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy === void 0 ? void 0 : _g_teamsMeetingPolicy.screenSharingMode) && ("Disabled" == ((_g_teamsMeetingPolicy1 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy1 === void 0 ? void 0 : _g_teamsMeetingPolicy1.screenSharingMode) ? S.shareScreen = {
                isPresent: !1,
                reason: cS.UserPolicyRestricted
            } : S.shareScreen = {
                isPresent: !0,
                reason: cS.Capable
            }), null != ((_g_teamsMeetingPolicy2 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy2 === void 0 ? void 0 : _g_teamsMeetingPolicy2.liveCaptionsEnabledType) && ("Disabled" == ((_g_teamsMeetingPolicy3 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy3 === void 0 ? void 0 : _g_teamsMeetingPolicy3.liveCaptionsEnabledType) ? S.startLiveMeetingCaptions = {
                isPresent: !1,
                reason: cS.UserPolicyRestricted
            } : S.startLiveMeetingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            }), null != ((_g_teamsCallingPolicy = g.teamsCallingPolicy) === null || _g_teamsCallingPolicy === void 0 ? void 0 : _g_teamsCallingPolicy.liveCaptionsEnabledTypeForCalling) && ("Disabled" == ((_g_teamsCallingPolicy1 = g.teamsCallingPolicy) === null || _g_teamsCallingPolicy1 === void 0 ? void 0 : _g_teamsCallingPolicy1.liveCaptionsEnabledTypeForCalling) ? S.startLiveCallingCaptions = {
                isPresent: !1,
                reason: cS.UserPolicyRestricted
            } : S.startLiveCallingCaptions = {
                isPresent: !0,
                reason: cS.Capable
            }), null != ((_g_teamsMeetingPolicy4 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy4 === void 0 ? void 0 : _g_teamsMeetingPolicy4.videoFiltersMode) && ("NoFilters" == ((_g_teamsMeetingPolicy5 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy5 === void 0 ? void 0 : _g_teamsMeetingPolicy5.videoFiltersMode) ? S.blurBackground = {
                isPresent: !1,
                reason: cS.UserPolicyRestricted
            } : S.blurBackground = {
                isPresent: !0,
                reason: cS.Capable
            }), null != ((_g_teamsMeetingPolicy6 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy6 === void 0 ? void 0 : _g_teamsMeetingPolicy6.allowBreakoutRooms) && (((_g_teamsMeetingPolicy7 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy7 === void 0 ? void 0 : _g_teamsMeetingPolicy7.allowBreakoutRooms) ? S.joinBreakoutRooms = {
                isPresent: !0,
                reason: cS.Capable
            } : S.joinBreakoutRooms = {
                isPresent: !1,
                reason: cS.UserPolicyRestricted
            }), null != ((_g_teamsMeetingPolicy8 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy8 === void 0 ? void 0 : _g_teamsMeetingPolicy8.ipAudioMode) && ("Disabled" === ((_g_teamsMeetingPolicy9 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy9 === void 0 ? void 0 : _g_teamsMeetingPolicy9.ipAudioMode) ? S.unmuteMic = {
                isPresent: !1,
                reason: cS.IpModeUserPolicyRestricted
            } : S.unmuteMic = {
                isPresent: !0,
                reason: cS.Capable
            }), null != ((_g_teamsMeetingPolicy10 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy10 === void 0 ? void 0 : _g_teamsMeetingPolicy10.ipVideoMode) && ("Disabled" === ((_g_teamsMeetingPolicy11 = g.teamsMeetingPolicy) === null || _g_teamsMeetingPolicy11 === void 0 ? void 0 : _g_teamsMeetingPolicy11.ipVideoMode) ? S.turnVideoOn = {
                isPresent: !1,
                reason: cS.IpModeUserPolicyRestricted
            } : S.turnVideoOn = {
                isPresent: !0,
                reason: cS.Capable
            }), this.resolveMicVideoAndScreenShareCapabilities(S), this._logger.log(`Capabilities resolved to : ${JSON.stringify(S)} on user policy update to ${g}`), S;
        }
        getResolvedCapabilitiesBasedOnUserProperties(g, f) {
            let S = {
                ...f
            };
            return this._logger.log(`Capabilities resolved to : ${JSON.stringify(S)} on user properties update to ${g}`), S;
        }
        getResolvedCapabilitiesBasedOnCallPublishedStates(g) {
            const f = {
                ...g
            };
            return this.resolveMicVideoAndScreenShareCapabilities(f), this._logger.log(`Capabilities resolved to : ${JSON.stringify(f)}`), f;
        }
        resolveMicVideoAndScreenShareCapabilities(g) {
            const f = g.unmuteMic.reason === cS.IpModeUserPolicyRestricted, S = g.turnVideoOn.reason === cS.IpModeUserPolicyRestricted;
            if (!f || !S) {
                const v = this._call.feature(callFeatureFactory(MediaAccessCallFeatureImpl)).getLocalParticipantMediaAccess();
                f || (g.unmuteMic = v.isAudioPermitted ? {
                    isPresent: !0,
                    reason: cS.Capable
                } : {
                    isPresent: !1,
                    reason: cS.MeetingRestricted
                }), S || (g.turnVideoOn = v.isVideoPermitted ? {
                    isPresent: !0,
                    reason: cS.Capable
                } : {
                    isPresent: !1,
                    reason: cS.MeetingRestricted
                });
            }
            g.shareScreen.reason === cS.Capable && this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() ? g.shareScreen = {
                isPresent: !1,
                reason: cS.ExplicitConsentRequired
            } : g.shareScreen.reason !== cS.ExplicitConsentRequired || this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() || (g.shareScreen = {
                isPresent: !0,
                reason: cS.Capable
            }), g.unmuteMic.reason === cS.Capable && this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() ? g.unmuteMic = {
                isPresent: !1,
                reason: cS.ExplicitConsentRequired
            } : g.unmuteMic.reason !== cS.ExplicitConsentRequired || this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() || (g.unmuteMic = {
                isPresent: !0,
                reason: cS.Capable
            }), g.turnVideoOn.reason === cS.Capable && this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() ? g.turnVideoOn = {
                isPresent: !1,
                reason: cS.ExplicitConsentRequired
            } : g.turnVideoOn.reason !== cS.ExplicitConsentRequired || this._call.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() || (g.turnVideoOn = {
                isPresent: !0,
                reason: cS.Capable
            });
        }
        constructor(g, f){
            this._logger = g, this._ecsConfig = getAcsEcsConfig(), this._call = f;
        }
    }
    class CapabilityResolverImpl {
        initializeCapabilities() {
            return this._logger.info("initializing capabilities"), this._callInfo.context != BS.Rooms && this._callInfo.context != BS.TeamsMeeting ? {
                turnVideoOn: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                unmuteMic: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                shareScreen: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                removeParticipant: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                hangUpForEveryOne: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                addCommunicationUser: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                addTeamsUser: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                addPhoneNumber: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                manageLobby: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                spotlightParticipant: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                removeParticipantsSpotlight: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                blurBackground: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                startLiveMeetingCaptions: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                startLiveCallingCaptions: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                setCaptionLanguage: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                raiseHand: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                pstnDialOut: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                muteOthers: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                useReactions: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                viewAttendeeNames: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                startTogetherMode: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                joinBreakoutRooms: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                forbidOthersAudio: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                forbidOthersVideo: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                }
            } : {
                turnVideoOn: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                unmuteMic: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                shareScreen: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                removeParticipant: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                hangUpForEveryOne: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                addCommunicationUser: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                addTeamsUser: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                addPhoneNumber: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                manageLobby: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                spotlightParticipant: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                removeParticipantsSpotlight: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                blurBackground: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                startLiveMeetingCaptions: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                startLiveCallingCaptions: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                setCaptionLanguage: {
                    isPresent: !1,
                    reason: cS.FeatureNotSupported
                },
                raiseHand: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                pstnDialOut: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                muteOthers: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                useReactions: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                joinBreakoutRooms: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                viewAttendeeNames: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                startTogetherMode: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                forbidOthersAudio: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                },
                forbidOthersVideo: {
                    isPresent: !1,
                    reason: cS.NotInitialized
                }
            };
        }
        doInitialCapabilityResolutionBasedOnRole() {
            this.resolveCapabilitiesBasedOnRole();
        }
        doInitialCapabilityResolutionBasedOnUserPolicy() {
            this.getCapabilityResolver() instanceof TeamsCapabilityResolver && this._callInfo.context != BS.Rooms && this.resolveCapabilitiesBasedOnUserPolicy();
        }
        doInitialCapabilityResolutionBasedOnMeetingCapabilities() {
            this.resolveCapabilitiesBasedOnMeetingCapabilities();
        }
        doInitialCapabilityResolutionBasedOnCallPublishedStates() {
            this.resolveCapabilitiesBasedOnCallPublishedStates();
        }
        getCapabilityResolver() {
            var _this__callInfo_context, _this__callInfo_context1;
            return ((_this__callInfo_context = this._callInfo.context) === null || _this__callInfo_context === void 0 ? void 0 : _this__callInfo_context.match(BS.Rooms)) ? new RoomsCapabilityResolver(this._logger) : ((_this__callInfo_context1 = this._callInfo.context) === null || _this__callInfo_context1 === void 0 ? void 0 : _this__callInfo_context1.match(BS.TeamsMeeting), new TeamsCapabilityResolver(this._logger, this._call));
        }
        getCapabilities() {
            return this._capabilities;
        }
        resolveCapabilitiesBasedOnRole() {
            if (this._callInfo.context != BS.Rooms && this._callInfo.context != BS.TeamsMeeting) return;
            let g = this._call.role;
            g == sS.Unknown && (g = this._callInfo.context == BS.Rooms ? sS.Consumer : sS.Attendee);
            let f = this.getCapabilityResolver();
            if (f) {
                let S = JSON.parse(JSON.stringify(this._capabilities));
                if (this._capabilities = f.getResolvedCapabilitiesBasedOnRole(g, this._capabilities), !P.isEqual(S, this._capabilities)) {
                    const f = this.getChangedCapabilitiesInfo(S, this._capabilities, "RoleChanged");
                    this._logger.info(`Capabilities has changed based on role update to ${g}, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(f)}`), this._eventEmitter.emit("capabilitiesChanged", f);
                }
            }
        }
        resolveCapabilitiesBasedOnMeetingCapabilities() {
            var _this__tsCall_meetingDetails, _this__tsCall_meetingDetails1, _this__tsCall_meetingDetails2;
            if (this._callInfo.context != BS.TeamsMeeting) return;
            let g = {};
            g = {
                ...(_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : _this__tsCall_meetingDetails.capabilities,
                ...(_this__tsCall_meetingDetails1 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails1 === void 0 ? void 0 : _this__tsCall_meetingDetails1.meetingCapability,
                ...(_this__tsCall_meetingDetails2 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails2 === void 0 ? void 0 : _this__tsCall_meetingDetails2.recordingConsentDetails
            }, this._meetingCapabilities = {
                ...g
            };
            let f = this.getCapabilityResolver();
            if (f && f) {
                const S = JSON.parse(JSON.stringify(this._capabilities));
                if (this._capabilities = f.getResolvedCapabilitiesBasedOnMeetingCapabilities(g, this._capabilities), !P.isEqual(S, this._capabilities)) {
                    const g = this.getChangedCapabilitiesInfo(S, this._capabilities, "MeetingOptionOrOrganizerPolicyChanged");
                    this._logger.info(`Capabilities has changed due to meeting capabilities, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(g)}`), this._eventEmitter.emit("capabilitiesChanged", g);
                }
            }
        }
        resolveCapabilitiesBasedOnCallPublishedStates() {
            if (this._callInfo.context !== BS.TeamsMeeting) return;
            const g = this.getCapabilityResolver();
            if (g && g) {
                const f = JSON.parse(JSON.stringify(this._capabilities));
                if (this._capabilities = g.getResolvedCapabilitiesBasedOnCallPublishedStates(this._capabilities), !P.isEqual(f, this._capabilities)) {
                    const g = this.getChangedCapabilitiesInfo(f, this._capabilities, "MeetingOptionOrOrganizerPolicyChanged");
                    this._logger.info(`Capabilities has changed due to call published states, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(g)}`), this._eventEmitter.emit("capabilitiesChanged", g);
                }
            }
        }
        resolveCapabilitiesBasedOnUserPolicy() {
            if (this._callInfo.context != BS.TeamsMeeting) return;
            let g = this._callAgent.getUserPolicy(), f = this.getCapabilityResolver();
            if (f && f && g) {
                let S = JSON.parse(JSON.stringify(this._capabilities));
                if (this._capabilities = f.getResolvedCapabilitiesBasedOnUserPolicy(g, this._capabilities), !P.isEqual(S, this._capabilities)) {
                    const g = this.getChangedCapabilitiesInfo(S, this._capabilities, "UserPolicyChanged");
                    this._logger.info(`Capabilities has changed due to user policy, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(g)}`), this._eventEmitter.emit("capabilitiesChanged", g);
                }
            }
        }
        resolveCapabilitiesBasedOnUserProperties() {
            if (this._callInfo.context != BS.TeamsMeeting) return;
            let g = this._callAgent.getUserProperties(), f = this.getCapabilityResolver();
            if (f && f && g) {
                let S = JSON.parse(JSON.stringify(this._capabilities));
                if (this._capabilities = f.getResolvedCapabilitiesBasedOnUserProperties(g, this._capabilities), !P.isEqual(S, this._capabilities)) {
                    const g = this.getChangedCapabilitiesInfo(S, this._capabilities, "TeamsPremiumLicenseChanged");
                    this._logger.info(`Capabilities has changed due to Teams Premium License, emitting capabilities changed event with capabilitiesChangeInfo: ${JSON.stringify(g)}`), this._eventEmitter.emit("capabilitiesChanged", g);
                }
            }
        }
        getMeetingsCapabilitiesInternal() {
            return this._meetingCapabilities;
        }
        getChangedCapabilitiesInfo(g, f, S) {
            let v = {}, _ = {};
            return Object.keys(g).forEach((S)=>{
                g[S].isPresent != f[S].isPresent && (v[S] = g[S], _[S] = f[S]);
            }), {
                oldValue: v,
                newValue: _,
                reason: S
            };
        }
        constructor(g, f, S, v, _, C){
            this._meetingCapabilities = {}, this._eventEmitter = g, this._logger = f, this._callInfo = v, this._tsCall = C, this._call = S, this._callAgent = _, this._capabilities = this.initializeCapabilities(), (this._callInfo.context == BS.Rooms || this._callInfo.context == BS.TeamsMeeting) && this.doInitialCapabilityResolutionBasedOnRole(), this._callInfo.context == BS.TeamsMeeting && this.doInitialCapabilityResolutionBasedOnUserPolicy(), this._callInfo.context == BS.TeamsMeeting && this.doInitialCapabilityResolutionBasedOnMeetingCapabilities(), this._callInfo.context == BS.TeamsMeeting && this.doInitialCapabilityResolutionBasedOnCallPublishedStates();
        }
    }
    class CapabilitiesFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "Capabilities";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(g.tsCall, g.callAgent, g.call, this._callInfo, g.telemetryLogManager, f), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get capabilities() {
            return this._sendFeatureUsage("getCapabilities", uy.getter), this._impl.capabilities;
        }
        on(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "Capabilities",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._callInfo = g.callInfo, this._impl = new CapabilitiesImplOverTsCall(this.eventEmitter);
        }
    }
    class CapabilitiesImplOverTsCall {
        get capabilities() {
            return this._capabilityResolver.getCapabilities();
        }
        initialize(g, f, S, v, _, C) {
            this._logger = C.createChild(()=>`CapabilitiesFeature::Call(id='${g.callId}')`), this._tsCall = g, this._call = S, this._callInfo = v, this._internalCallAgent = f, this._timeToInitialize = new Date, this._capabilityResolver = new CapabilityResolverImpl(this._eventEmitter, this._logger, this._call, this._callInfo, this._internalCallAgent, this._tsCall), this._call.on("roleChanged", ()=>{
                this._capabilityResolver.resolveCapabilitiesBasedOnRole();
                let g = ((new Date).getTime() - this._timeToInitialize.getTime()) / 1e3;
                this._logger.info("Time difference to initialize after role set is " + g);
            }), this._call.onMeetingCapabilitiesChanged("meetingCapabilitiesChanged", ()=>{
                this._capabilityResolver.resolveCapabilitiesBasedOnMeetingCapabilities();
                let g = ((new Date).getTime() - this._timeToInitialize.getTime()) / 1e3;
                this._logger.info("Time difference to initialize after meeting set up is" + g);
            }), this._call.feature(callFeatureFactory(MediaAccessCallFeatureImpl)).on("localParticipantMediaAccessChanged", ()=>{
                this._capabilityResolver.resolveCapabilitiesBasedOnCallPublishedStates(), this._logger.info("Time when received localParticipantMediaAccessChanged event" + (new Date).getTime());
            }), this._call.explicitConsentStateImp.onConsentRestrictionChanged("consentRestrictionChanged", ()=>{
                this._capabilityResolver.resolveCapabilitiesBasedOnCallPublishedStates();
                let g = ((new Date).getTime() - this._timeToInitialize.getTime()) / 1e3;
                this._logger.info("Time difference to initialize after published state change is" + g);
            });
        }
        constructor(g){
            this._eventEmitter = g;
        }
    }
    var Zy, eE, bitwise = function(g) {
        var f = 0;
        if (0 == g.length) return f;
        for(var S = 0; S < g.length; S++)f = (f << 5) - f + g.charCodeAt(S), f &= f;
        return f;
    }, binaryTransfer = function(g, f) {
        var S = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        f = f || 62;
        var v, _ = [], C = "", E = g < 0 ? "-" : "";
        for(g = Math.abs(g); g >= f;)v = g % f, g = Math.floor(g / f), _.push(S[v]);
        g > 0 && _.push(S[g]);
        for(var T = _.length - 1; T >= 0; T--)C += _[T];
        return E + C;
    }, dist = function(g) {
        var f = typeof g;
        if ("string" === f || "number" === f) return binaryTransfer(bitwise(String(g)), 61).replace("-", "Z");
        throw new Error("Unexpected input type");
    };
    !function(g) {
        g.ping = "ping", g.pong = "pong";
    }(Zy || (Zy = {}));
    class DebugInfoCallClientFeatureImpl extends FirstPartyCallClientFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "DebugInfo";
        }
        get lastLocalParticipantId() {
            return this._sendFeatureUsage("lastLocalParticipantId", uy.getter), this._impl.lastLocalParticipantId;
        }
        get logs() {
            return this._impl.logDump;
        }
        get localParticipantIdMap() {
            return this._impl.localParticipantIdMap;
        }
        get incommingCallIdMap() {
            return this._impl.incommingCallIdMap;
        }
        get lastCallId() {
            if (this._sendFeatureUsage("lastCallId", uy.getter), this.lastLocalParticipantId) return this._impl.localParticipantIdMap[this.lastLocalParticipantId].callIds.slice(-1)[0];
        }
        get diagnosticInformation() {
            return this._impl.diagnosticInformation;
        }
        get sdkVersion() {
            return getSdkVersion();
        }
        get acsResourceId() {
            return this._impl.AcsResourceId;
        }
        get clientId() {
            return this._impl.clientId;
        }
        dumpDebugInfoAsJSONString() {
            try {
                return JSON.stringify(this.toZip());
            } catch (g) {
                return `JSON.stringify threw: ${g}`;
            }
        }
        toZip() {
            return {
                clientId: this.clientId,
                lastLocalParticipantId: this.lastLocalParticipantId,
                localParticipantIdMap: this.localParticipantIdMap,
                incommingCallMap: this.incommingCallIdMap,
                AcsResourceId: this.acsResourceId,
                diagnosticInformation: this.diagnosticInformation,
                sdkVersion: this.sdkVersion,
                logs: this.logs
            };
        }
        dumpDebugInfo() {
            this._sendFeatureUsage("dumpDebugInfo", uy.attempt);
            try {
                const g = sy.deflate(this.dumpDebugInfoAsJSONString(), {
                    to: "string"
                }), f = dist(g);
                return this._sendFeatureUsage("dumpDebugInfo", uy.success), {
                    dump: g,
                    dumpId: `${generateGuid()}-${f}`
                };
            } catch (g) {
                const f = `failed to deflate, error: ${g}`;
                return this.logger.error(f), this._sendFeatureUsage("dumpDebugInfo", uy.failure), {
                    dump: sy.deflate(f, {
                        to: "string"
                    }),
                    dumpId: generateGuid()
                };
            }
        }
        initialize(g, f) {
            this._impl.initialize(g, f), this.logger = f, this._telemetryLogManager = g.telemetryLogManager, this._callClient = g.callClient, this._browserTabInfoImpl && this._browserTabInfoImpl.initialize(g.callClient, f, g.telemetryLogManager), this._sendFeatureUsage("initialize", uy.initialize);
        }
        async getEnvironmentInfo() {
            return this._sendFeatureUsage("getEnvironmentInfo", uy.getter), await this._callClient.getEnvironmentInfoInternal();
        }
        get isAnotherCallClientActiveInSameTab() {
            return this._sendFeatureUsage("isAnotherCallClientActiveInSameTab", uy.getter), !!this._browserTabInfoImpl && this._browserTabInfoImpl.isAnotherCallClientActiveInSameTab;
        }
        get isCallClientActiveInAnotherTab() {
            return this._sendFeatureUsage("isCallClientActiveInAnotherTab", uy.getter), !!this._browserTabInfoImpl && this._browserTabInfoImpl.isCallClientActiveInAnotherTab;
        }
        on(g, f) {
            "isCallClientActiveInAnotherTabChanged" !== g && "isAnotherCallClientActiveInSameTabChanged" !== g && this.logger.error(`Not able to subscribe to event ${g}, unknown event name`), this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            "isCallClientActiveInAnotherTabChanged" !== g && "isAnotherCallClientActiveInSameTabChanged" !== g && this.logger.error(`Not able to unsubscribe to event ${g}, unknown event name`), this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallClientFeatureUsageTelemetry({
                featureName: "DebugInfo",
                featureType: "CallClient",
                initializationType: "OnExtendedObjectConstructor",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this.logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new DebugInfoImplOverTsCall;
            try {
                getSdkVersion().includes("stable") || (this._browserTabInfoImpl = new BrowserTabInfoImpl(this.eventEmitter));
            } catch (f) {
                g.callClient.logger.error("Feature to detect multiple tabs is not supported on the current environment.");
            }
        }
    }
    class DebugInfoImplOverTsCall {
        get diagnosticInformation() {
            return this._sdkDiagnosticInformation;
        }
        get logDump() {
            return this._logger.log("Log dump requested"), this._logger.dumpAllLogs();
        }
        get AcsResourceId() {
            var _this__callAgent;
            return (_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : _this__callAgent.getAcsResourceId();
        }
        get lastLocalParticipantId() {
            return this._lastLocalParticipantId;
        }
        get localParticipantIdMap() {
            return this._localParticipantIdMap;
        }
        get incommingCallIdMap() {
            return this._incommingCallIdMap;
        }
        get clientId() {
            var _this__callAgent;
            return (_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : _this__callAgent.getClientId();
        }
        initialize(g, f) {
            var _g_callClient;
            this._logger = f, this._callAgent = g === null || g === void 0 ? void 0 : (_g_callClient = g.callClient) === null || _g_callClient === void 0 ? void 0 : _g_callClient.callAgent, this._sdkDiagnosticInformation = g === null || g === void 0 ? void 0 : g.callClient.sdkDiagnosticInformation, this._logger.info("waiting for call agent to be created");
            const bindAndSubscribeToCallAgentEvents = ()=>{
                this._callAgent = g === null || g === void 0 ? void 0 : g.callClient.callAgent, this.subscribeToCallAgentEvents();
            };
            g === null || g === void 0 ? void 0 : g.callClient.on("callAgentCreated", bindAndSubscribeToCallAgentEvents);
        }
        dispose() {}
        subscribeToCallAgentEvents() {
            try {
                var _this__callAgent, _this__callAgent1;
                (_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : _this__callAgent.on("callsUpdated", (g)=>{
                    [
                        ...g.added,
                        ...g.removed
                    ].forEach((g)=>{
                        this.updateLocalParticipantIdMap(g), g.on("idChanged", ()=>{
                            this.updateLocalParticipantIdMap(g);
                        });
                    });
                }), (_this__callAgent1 = this._callAgent) === null || _this__callAgent1 === void 0 ? void 0 : _this__callAgent1.on("incomingCall", (g)=>{
                    let f = g.incomingCall;
                    f.on("callEnded", (g)=>{
                        try {
                            this._incommingCallIdMap[f.id] = JSON.stringify(g.callEndReason);
                        } catch (g) {
                            this._incommingCallIdMap[f.id] = "callEnd reason unknown";
                        }
                    });
                    try {
                        var _g_incomingCall_callerInfo_identifier;
                        this._incommingCallIdMap[f.id] = JSON.stringify((_g_incomingCall_callerInfo_identifier = g.incomingCall.callerInfo.identifier) === null || _g_incomingCall_callerInfo_identifier === void 0 ? void 0 : _g_incomingCall_callerInfo_identifier.kind);
                    } catch (g) {
                        this._incommingCallIdMap[f.id] = "identifier kind unknown";
                    }
                });
            } catch (g) {
                this._logger.info("failed to subscribe to call agent events, due to non initialized call agent");
            }
        }
        updateLocalParticipantIdMap(g) {
            try {
                var _this__localParticipantIdMap_g_tsCall_participantId, _this__localParticipantIdMap_g_tsCall_participantId1;
                var _this__localParticipantIdMap_g_tsCall_participantId_callIds_filter_concat;
                let f = (_this__localParticipantIdMap_g_tsCall_participantId_callIds_filter_concat = (_this__localParticipantIdMap_g_tsCall_participantId = this._localParticipantIdMap[g.tsCall.participantId]) === null || _this__localParticipantIdMap_g_tsCall_participantId === void 0 ? void 0 : _this__localParticipantIdMap_g_tsCall_participantId.callIds.filter((f)=>f !== g.tsCall.callId).concat([
                    g.tsCall.callId
                ])) !== null && _this__localParticipantIdMap_g_tsCall_participantId_callIds_filter_concat !== void 0 ? _this__localParticipantIdMap_g_tsCall_participantId_callIds_filter_concat : [
                    g.tsCall.callId
                ], S = [], v = [], _ = g.callEndReason ? JSON.stringify(g.callEndReason) : g.state, C = g.state;
                ((_this__localParticipantIdMap_g_tsCall_participantId1 = this._localParticipantIdMap[g.tsCall.participantId]) === null || _this__localParticipantIdMap_g_tsCall_participantId1 === void 0 ? void 0 : _this__localParticipantIdMap_g_tsCall_participantId1.callEndReasons) ? (this._localParticipantIdMap[g.tsCall.participantId].callEndReasons.slice(-1)[0] !== _ ? (this._localParticipantIdMap[g.tsCall.participantId].callEndReasons.push(_), S = this._localParticipantIdMap[g.tsCall.participantId].callEndReasons) : S = this._localParticipantIdMap[g.tsCall.participantId].callEndReasons, this._localParticipantIdMap[g.tsCall.participantId].stateTransitions.slice(-1)[0] !== C ? (this._localParticipantIdMap[g.tsCall.participantId].stateTransitions.push(C), v = this._localParticipantIdMap[g.tsCall.participantId].stateTransitions) : v = this._localParticipantIdMap[g.tsCall.participantId].stateTransitions) : (S = [
                    _
                ], v = [
                    g.state
                ]), this._localParticipantIdMap[g.tsCall.participantId] = {
                    callIds: f,
                    callEndReasons: S,
                    stateTransitions: v
                }, this._logger.info(`localParticipantIdMap: ${JSON.stringify(this._localParticipantIdMap)}`), g.on("stateChanged", ()=>{
                    "Connected" === g.state && (this._lastLocalParticipantId = g.tsCall.participantId, this._logger.info(`last patricipant id: ${this._lastLocalParticipantId}`)), this._localParticipantIdMap[g.tsCall.participantId].stateTransitions.slice(-1)[0] !== g.state && this.localParticipantIdMap[g.tsCall.participantId].stateTransitions.push(g.state);
                });
            } catch (g) {
                this._logger.error(`exception occured while updating localParticipantId map: ${g}`);
            }
        }
        constructor(){
            this._localParticipantIdMap = {}, this._incommingCallIdMap = {};
        }
    }
    class BrowserTabInfoImpl {
        get isCallClientActiveInAnotherTab() {
            return this._isCallClientActiveInAnotherTab;
        }
        get isAnotherCallClientActiveInSameTab() {
            return this._isAnotherCallClientActiveInSameTab;
        }
        initialize(g, f, S) {
            this._callClient = g, this._logger = f, this._telemetryLogManager = S;
            const v = getAcsEcsConfig().debugInfo.tabsBroadcastDelay, _ = getAcsEcsConfig().debugInfo.tabsUpdateDelay;
            this.tabsCheck(), this._channel.postMessage({
                action: Zy.ping,
                tabId: BrowserTabInfoImpl.tabId,
                groupId: this._tabGroupId
            }), this._timeoutId = setTimeout(()=>{
                this._areThereMultipleTabs && (this._isCallClientActiveInAnotherTab = this._areThereMultipleTabs), this._manyCallClientInSameTab && (this._isAnotherCallClientActiveInSameTab = this._manyCallClientInSameTab), this.sendTabUpdateEvent(), this._isTabFirstLoadFlag = !1;
            }, 10), this._intervalId = setInterval(()=>{
                this._areThereMultipleTabs = null, this._manyCallClientInSameTab = null, this._channel.postMessage({
                    action: Zy.ping,
                    tabId: BrowserTabInfoImpl.tabId,
                    groupId: this._tabGroupId
                }), setTimeout(()=>{
                    null === this._areThereMultipleTabs && (this._areThereMultipleTabs = !1), null === this._manyCallClientInSameTab && (this._manyCallClientInSameTab = !1), this.tabsUpdate();
                }, _);
            }, v);
        }
        tabsCheck() {
            this._channel.addEventListener("message", (g)=>{
                var _g_data, _g_data1, _g_data2, _g_data3;
                ((_g_data = g.data) === null || _g_data === void 0 ? void 0 : _g_data.action) !== Zy.ping && ((_g_data1 = g.data) === null || _g_data1 === void 0 ? void 0 : _g_data1.action) !== Zy.pong || (((_g_data2 = g.data) === null || _g_data2 === void 0 ? void 0 : _g_data2.action) === Zy.ping && (BrowserTabInfoImpl.tabId === g.data.tabId ? this._manyCallClientInSameTab = !0 : BrowserTabInfoImpl.tabId !== g.data.tabId && (this._areThereMultipleTabs = !0), this._channel.postMessage({
                    action: Zy.pong,
                    tabId: BrowserTabInfoImpl.tabId,
                    groupId: this._tabGroupId
                })), ((_g_data3 = g.data) === null || _g_data3 === void 0 ? void 0 : _g_data3.action) === Zy.pong && (BrowserTabInfoImpl.tabId === g.data.tabId ? this._manyCallClientInSameTab = !0 : BrowserTabInfoImpl.tabId !== g.data.tabId && (this._areThereMultipleTabs = !0), this._tabGroupId !== g.data.groupId && (this._tabGroupId = g.data.groupId)), this.tabsUpdate());
            });
        }
        sendTabUpdateToCallEvent() {
            var _this__callClient_callAgent__calls, _this__callClient_callAgent;
            (_this__callClient_callAgent = this._callClient.callAgent) === null || _this__callClient_callAgent === void 0 ? void 0 : (_this__callClient_callAgent__calls = _this__callClient_callAgent._calls) === null || _this__callClient_callAgent__calls === void 0 ? void 0 : _this__callClient_callAgent__calls.forEach((g)=>{
                var _g_stats;
                return g === null || g === void 0 ? void 0 : (_g_stats = g.stats) === null || _g_stats === void 0 ? void 0 : _g_stats.recordEvent({
                    name: cy.sdk_active_in_another_tab,
                    callId: g.id,
                    localParticipantId: g.tsCall.participantId,
                    data: {
                        tabId: BrowserTabInfoImpl.tabId,
                        tabGroupId: this._tabGroupId,
                        isCallClientActiveInAnotherTab: this._isCallClientActiveInAnotherTab,
                        isAnotherCallClientActiveInSameTab: this._isAnotherCallClientActiveInSameTab
                    }
                });
            });
        }
        sendTabUpdateEvent() {
            const g = {
                tabId: BrowserTabInfoImpl.tabId,
                tabGroupId: this._tabGroupId,
                isCallClientActiveInAnotherTab: this._isCallClientActiveInAnotherTab,
                isAnotherCallClientActiveInSameTab: this._isAnotherCallClientActiveInSameTab
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_tab_events,
                tenant: nf,
                properties: g
            });
        }
        tabsUpdate() {
            this._isTabFirstLoadFlag || null === this._manyCallClientInSameTab || null === this._areThereMultipleTabs || this._isCallClientActiveInAnotherTab === this._areThereMultipleTabs && this._isAnotherCallClientActiveInSameTab === this._manyCallClientInSameTab || (this._isAnotherCallClientActiveInSameTab !== this._manyCallClientInSameTab && (this._logger.log(`isAnotherCallClientActiveInSameTab changed from ${this._isAnotherCallClientActiveInSameTab} to ${this._manyCallClientInSameTab}`), this._isAnotherCallClientActiveInSameTab = this._manyCallClientInSameTab, this._eventEmitter.emit("isAnotherCallClientActiveInSameTabChanged")), this._isCallClientActiveInAnotherTab !== this._areThereMultipleTabs && (this._logger.log(`isCallClientActiveInAnotherTab changed from ${this._isCallClientActiveInAnotherTab} to ${this._areThereMultipleTabs}`), this._isCallClientActiveInAnotherTab = this._areThereMultipleTabs, this._eventEmitter.emit("isCallClientActiveInAnotherTabChanged")), this.sendTabUpdateEvent(), this.sendTabUpdateToCallEvent());
        }
        dispose() {
            this._channel.close(), void 0 !== this._timeoutId && clearTimeout(this._timeoutId), void 0 !== this._intervalId && clearInterval(this._intervalId);
        }
        constructor(g){
            this._eventEmitter = g, this._tabGroupId = BrowserTabInfoImpl.tabId, this._isCallClientActiveInAnotherTab = !1, this._isAnotherCallClientActiveInSameTab = !1, this._areThereMultipleTabs = null, this._manyCallClientInSameTab = null, this._isTabFirstLoadFlag = !0, this._intervalId = void 0, this._timeoutId = void 0, this._channel = new BroadcastChannel(getAcsEcsConfig().debugInfo.broadcastChannelName);
        }
    }
    BrowserTabInfoImpl.tabId = generateGuid(), (eE = g.DiagnosticQuality || (g.DiagnosticQuality = {}))[eE.Good = 1] = "Good", eE[eE.Poor = 2] = "Poor", eE[eE.Bad = 3] = "Bad";
    const tE = "networkReconnect", iE = "networkReceiveQuality", nE = "networkSendQuality", rE = "networkRelaysNotReachable", aE = "noNetwork", sE = "noSpeakerDevicesEnumerated", oE = "noMicrophoneDevicesEnumerated", lE = "microphoneNotFunctioning", cE = "microphoneMuteUnexpectedly", dE = "cameraStoppedUnexpectedly", uE = "capturerStoppedUnexpectedly", hE = "speakingWhileMicrophoneIsMuted", gE = "cameraFreeze", pE = "cameraStartFailed", mE = "capturerStartFailed", fE = "cameraStartTimedOut", SE = "screenshareRecordingDisabled", vE = "microphonePermissionDenied", _E = "cameraPermissionDenied";
    function diagnosticValueToText(f, S) {
        return "serverConnection" == S ? f ? "Good" : "Bad" : "boolean" == typeof f ? f ? "Bad" : "Good" : g.DiagnosticQuality[f];
    }
    class UserFacingDiagnosticsFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "Diagnostics";
        }
        get network() {
            return this._sendFeatureUsage("network", uy.getter), this._impl.network;
        }
        get media() {
            return this._sendFeatureUsage("media", uy.getter), this._impl.media;
        }
        get remote() {
            return this._sendFeatureUsage("remote", uy.getter), this._impl.remote;
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g, f), this._sendFeatureUsage("initialize", uy.initialize);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "Diagnostics",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new UserFacingDiagnosticsImplOverTsCall;
        }
    }
    class UserFacingDiagnosticsImplOverTsCall {
        get network() {
            return void 0 === this._network && (this._network = new NetworkDiagnosticsImpl(this._internalApi, this._logger), this._network.bindToTsCallQualityChangedEvent()), this._network;
        }
        get media() {
            return void 0 === this._media && (this._media = new MediaDiagnosticsImpl(this._internalApi, this._logger), this._media.bindToTsCallQualityChangedEvent()), this._media;
        }
        get remote() {
            return void 0 === this._remote && (this._remote = new RemoteDiagnosticsImpl(this._internalApi, this._logger), this._remote.bindToTsCallPublishedStatesChangedEvent()), this._remote;
        }
        initialize(g, f) {
            this._internalApi = g, this._logger = f;
        }
        dispose() {}
    }
    class UserFacingDiagnosticsImpl {
        bindToTsCallQualityChangedEvent() {
            this.internalApi.tsCall.on("callQualityChanged", (f)=>{
                try {
                    let S;
                    if ("NetworkDiagnostics" === this._name ? S = this.mapTsNetworkQualityEventType(f.type) : "MediaDiagnostics" === this._name && (S = this.mapTsMediaQualityEventType(f.type, f.mediaType)), S) {
                        if (f.value === this._tsUfdUnknownValue) return;
                        let v, _;
                        if ("NetworkDiagnostics" === this._name) {
                            const { mappedQualityLevel: g, valueType: _ } = this.mapTsNetworkQualityLevel(S, f.value);
                            v = g, this.setLatestDiagnostic(S, {
                                value: v,
                                valueType: _
                            });
                        } else if ("MediaDiagnostics" === this._name) {
                            const { mappedQualityLevel: g, valueType: _ } = this.mapTsMediaQualityLevel(S, f.value);
                            v = g, this.setLatestDiagnostic(S, {
                                value: v,
                                valueType: _
                            });
                        }
                        if ("number" != typeof v || v !== g.DiagnosticQuality.Good && v !== g.DiagnosticQuality.Poor && v !== g.DiagnosticQuality.Bad) {
                            if ("boolean" != typeof v) throw this.logger.error(`Incorrect valueType mapped for diagnostic='${S}', value='${v}'`), new CallingCommunicationError({
                                defaultError: O.FEATURES.DIAGNOSTICS.INCORRECT_VALUETYPE_MAPPED
                            });
                            _ = "DiagnosticFlag";
                        } else _ = "DiagnosticQuality";
                        const C = {
                            diagnostic: S,
                            value: v,
                            valueType: _
                        };
                        this.logger.log(`Call diagnostic changed, diagnostic='${C.diagnostic}', value='${C.value}'`);
                        const E = "DiagnosticFlag" === C.valueType && !0 === C.value, T = "DiagnosticQuality" === C.valueType && (C.value === g.DiagnosticQuality.Bad || C.value === g.DiagnosticQuality.Poor);
                        (E || T) && this.logger.warn(`Call diagnostic error raised!, diagnostic='${C.diagnostic}', value='${C.value}', value type='${C.valueType}'`), this.sendDiagnosticEvent({
                            name: "UserFacingDiagnostics",
                            callId: this.internalApi.tsCall.callId,
                            localParticipantId: this.internalApi.tsCall.participantId,
                            remoteParticipantId: "",
                            diagnostic: C.diagnostic,
                            valueText: diagnosticValueToText(C.value),
                            valueType: C.valueType,
                            correlationId: ""
                        }), this.eventEmitter.emit("diagnosticChanged", C);
                    }
                } catch (g) {
                    this.logger.error(`${g === null || g === void 0 ? void 0 : g.message})`);
                }
            });
        }
        mapTsNetworkQualityEventType(g) {
            return this.tsToAcsNetworkQualityEventTypeMap[g];
        }
        mapTsNetworkQualityLevel(g, f) {
            let S, v;
            switch(g){
                case tE:
                case iE:
                case nE:
                    v = "DiagnosticQuality", S = this.tsQualityToAcsQualityMap[f];
                    break;
                case rE:
                case aE:
                    v = "DiagnosticFlag", S = this.tsQualityToAcsBooleanMap[f];
            }
            return {
                mappedQualityLevel: S,
                valueType: v
            };
        }
        mapTsMediaQualityEventType(g, f) {
            const S = this.tsToAcsMediaQualityEventTypeMap[g];
            if (S === cE) switch(f){
                case 1:
                    return dE;
                case 2:
                    return uE;
            }
            return S === pE && 2 === f ? mE : S;
        }
        mapTsMediaQualityLevel(g, f) {
            let S, v;
            switch(g){
                case sE:
                case oE:
                case lE:
                case cE:
                case hE:
                case gE:
                case pE:
                case fE:
                case SE:
                case vE:
                case _E:
                case dE:
                case uE:
                case mE:
                    v = "DiagnosticFlag", S = this.tsQualityToAcsBooleanMap[f];
            }
            return {
                mappedQualityLevel: S,
                valueType: v
            };
        }
        sendDiagnosticEvent(g) {
            this.internalApi.telemetryLogManager.sendEvent({
                name: dy.acs_calling_call_stats_and_ufds,
                tenant: nf,
                properties: {
                    name: g.name,
                    callId: g.callId,
                    localParticipantId: g.localParticipantId,
                    remoteParticipantId: g.remoteParticipantId,
                    diagnostic: g.diagnostic,
                    valueText: g.valueText,
                    valueType: g.valueType,
                    correlationId: g.correlationId
                }
            });
        }
        constructor(f, S, v){
            this._name = f, this.internalApi = S, this.logger = v, this._tsUfdUnknownValue = 0, this.tsToAcsNetworkQualityEventTypeMap = {
                5: tE,
                2: iE,
                1: nE,
                32: rE,
                37: aE
            }, this.tsToAcsMediaQualityEventTypeMap = {
                44: sE,
                43: oE,
                9: lE,
                25: cE,
                27: hE,
                45: gE,
                33: pE,
                34: fE,
                55: SE,
                26: vE,
                47: _E
            }, this.tsQualityToAcsQualityMap = {
                1: g.DiagnosticQuality.Good,
                2: g.DiagnosticQuality.Poor,
                3: g.DiagnosticQuality.Bad
            }, this.tsQualityToAcsBooleanMap = {
                3: !0,
                1: !1
            }, this.eventEmitter = new Ny.EventEmitter;
        }
    }
    class NetworkDiagnosticsImpl extends UserFacingDiagnosticsImpl {
        setLatestDiagnostic(g, f) {
            this.latestNetworkDiagnostics.set(g, f);
        }
        on(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        getLatest() {
            try {
                return convertMapToFrozenJson(this.latestNetworkDiagnostics);
            } catch (g) {
                return this.logger.error("Failed to get latest network diagnostics"), {};
            }
        }
        constructor(g, f){
            super("NetworkDiagnostics", g, f.createChild(()=>`[UserFacingDiagnosticsFeature:NetworkDiagnostics:Call(id='${g.tsCall.callId}', state='${g.tsCall.state}')]`)), this.latestNetworkDiagnostics = new Map;
        }
    }
    class MediaDiagnosticsImpl extends UserFacingDiagnosticsImpl {
        setLatestDiagnostic(g, f) {
            this.latestMediaDiagnostics.set(g, f);
        }
        on(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        getLatest() {
            try {
                return convertMapToFrozenJson(this.latestMediaDiagnostics);
            } catch (g) {
                return this.logger.error("Failed to get latest media diagnostics"), {};
            }
        }
        constructor(g, f){
            super("MediaDiagnostics", g, f.createChild(()=>`[UserFacingDiagnosticsFeature:MediaDiagnostics:Call(id='${g.tsCall.callId}', state='${g.tsCall.state}')]`)), this.latestMediaDiagnostics = new Map;
        }
    }
    class RemoteDiagnosticsImpl extends UserFacingDiagnosticsImpl {
        bindToTsCallPublishedStatesChangedEvent() {
            this.internalApi.tsCall.on("publishedStatesChanged", async (g)=>{
                const f = [], S = new Set;
                g.typeStates.forEach((g)=>{
                    const processRemoteDiagnostics = (g, S)=>{
                        const v = this.getRemoteDiagnosticIndex(g);
                        v > -1 && this._latestRemoteDiagnostics.diagnostics[v].value !== g.value ? (g = {
                            ...g,
                            remoteParticipant: this._latestRemoteDiagnostics.diagnostics[v].remoteParticipant
                        }, this._latestRemoteDiagnostics.diagnostics[v] = g, f.push(g)) : -1 !== v || this.isGoodServerRemoteDiagnostic(g) || (g = {
                            ...g,
                            remoteParticipant: this.internalApi.call.remoteParticipants.find((g)=>getMriFromIdentifier(g.identifier) === S)
                        }, this._latestRemoteDiagnostics.diagnostics.push(g), f.push(g));
                    };
                    "serverMediaUfd" === g.type && (this.logger.debug(`Remote diagnostics changed, typeState='${JSON.stringify(g)}'`), g.participantStates.forEach((g)=>{
                        try {
                            if (g.id !== this.internalApi.callAgent.getUserMri()) {
                                var _g_publishedState;
                                const f = this.createServerRemoteDiagnostic(g.id, (_g_publishedState = g.publishedState) === null || _g_publishedState === void 0 ? void 0 : _g_publishedState.content);
                                processRemoteDiagnostics(f, g.id), S.add(g.id);
                            }
                        } catch (f) {
                            this.logger.error(`Error processing remote diagnostic: ${JSON.stringify(g)}, error: ${f === null || f === void 0 ? void 0 : f.message}`);
                        }
                    })), "clientMediaUfd" === g.type && (this.logger.debug(`Client remote diagnostics changed, typeState='${JSON.stringify(g)}'`), g.participantStates.forEach((g)=>{
                        try {
                            if (g.id !== this.internalApi.callAgent.getUserMri() && g.endpoints) for (const f of g.endpoints){
                                const S = this.createClientRemoteDiagnostic(g.id, f);
                                S && processRemoteDiagnostics(S, g.id);
                            }
                        } catch (f) {
                            this.logger.error(`Error processing client remote diagnostic: ${JSON.stringify(g)}, error: ${f === null || f === void 0 ? void 0 : f.message}`);
                        }
                    }));
                }), this.removeRemoteUserDiagnostics(S), f.length > 0 && (this.sendRemoteDiagnosticsTelemetry(f), this.eventEmitter.emit("diagnosticChanged", {
                    diagnostics: f
                }));
            });
        }
        setLatestDiagnostic(g, f) {}
        getLatest() {
            return this._latestRemoteDiagnostics;
        }
        on(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("diagnosticChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.DIAGNOSTICS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        isGoodServerRemoteDiagnostic(g) {
            return "serverConnection" === g.diagnostic && !0 === g.value;
        }
        createServerRemoteDiagnostic(g, f) {
            if (!f) throw new Error("Content is missing in remote diagnostic");
            "string" == typeof f && (f = JSON.parse(f));
            return {
                participantId: f.participantId,
                rawId: g,
                diagnostic: f.type,
                value: "string" == typeof f.value && "good" === f.value.toLowerCase(),
                valueType: "DiagnosticFlag"
            };
        }
        mergeOrIgnoreClientDiagnostics(g) {
            const f = getAcsEcsConfig().calling.remoteDiagnostic.sourceEvents.indexOf(g);
            if (f > -1) {
                const g = getAcsEcsConfig().calling.remoteDiagnostic.exposedEvents[f];
                return this.logger.debug(`Merging ${getAcsEcsConfig().calling.remoteDiagnostic.sourceEvents[f]} to ${g}`), g;
            }
            return g;
        }
        createClientRemoteDiagnostic(g, f) {
            if (!f.publishedState.content) throw new Error("Content is missing in client remote diagnostic");
            const S = f.publishedState.content, v = S.type;
            let _ = this.mapTsNetworkQualityEventType(this.tsQualityStringToEnumMap[v]);
            const C = S.value;
            let E;
            if (_) E = this.mapTsNetworkQualityLevel(_, this.tsQualityLevelStringToEnumMap[C]);
            else {
                const g = S.mediaType;
                _ = this.mapTsMediaQualityEventType(this.tsQualityStringToEnumMap[v], this.tsMediaStringToEnumMap[g]), E = this.mapTsMediaQualityLevel(_, this.tsQualityLevelStringToEnumMap[C]);
            }
            const T = this.mergeOrIgnoreClientDiagnostics(_);
            if ("" === T) return;
            T !== _ && (_ = T);
            return {
                participantId: f.id,
                rawId: g,
                diagnostic: _,
                value: E.mappedQualityLevel,
                valueType: E.valueType
            };
        }
        getRemoteDiagnosticIndex(g) {
            return this._latestRemoteDiagnostics.diagnostics.findIndex((f)=>f.participantId === g.participantId && f.diagnostic === g.diagnostic);
        }
        removeRemoteUserDiagnostics(g) {
            this._latestRemoteDiagnostics.diagnostics = this._latestRemoteDiagnostics.diagnostics.filter((f)=>{
                const S = g.has(f.rawId);
                return S || this._remoteDiagnosticCorrelationIdMap.forEach((g, S)=>{
                    S.endsWith(`_${f.participantId}`) && this._remoteDiagnosticCorrelationIdMap.delete(S);
                }), S;
            });
        }
        sendRemoteDiagnosticsTelemetry(f) {
            this.logger.debug(`Sending remote diagnostics telemetry, number of diagnostics=${f.length}`), f.forEach((f)=>{
                const S = `${f.diagnostic}_${f.participantId}`;
                var _this__remoteDiagnosticCorrelationIdMap_get;
                this._remoteDiagnosticCorrelationIdMap.has(S) || this._remoteDiagnosticCorrelationIdMap.set(S, generateGuid()), this.sendDiagnosticEvent({
                    name: "RemoteClientDiagnostics",
                    callId: this.internalApi.tsCall.callId,
                    localParticipantId: this.internalApi.tsCall.participantId,
                    remoteParticipantId: f.participantId,
                    diagnostic: f.diagnostic,
                    valueText: diagnosticValueToText(f.value, f.diagnostic),
                    valueType: f.valueType,
                    correlationId: (_this__remoteDiagnosticCorrelationIdMap_get = this._remoteDiagnosticCorrelationIdMap.get(S)) !== null && _this__remoteDiagnosticCorrelationIdMap_get !== void 0 ? _this__remoteDiagnosticCorrelationIdMap_get : ""
                }), ("DiagnosticFlag" === f.valueType && !0 === f.value || "DiagnosticQuality" === f.valueType && f.value === g.DiagnosticQuality.Good) && this._remoteDiagnosticCorrelationIdMap.set(S, generateGuid());
            });
        }
        constructor(g, f){
            super("RemoteDiagnostics", g, f.createChild(()=>`[UserFacingDiagnosticsFeature:RemoteDiagnosticsiagnostics:Call(id='${g.tsCall.callId}', state='${g.tsCall.state}')]`)), this._remoteDiagnosticCorrelationIdMap = new Map, this.tsQualityStringToEnumMap = {
                NetworkSendQuality: 1,
                NetworkRecvQuality: 2,
                NetworkDelay: 3,
                NetworkBandwidthLow: 4,
                NetworkReconnect: 5,
                NetworkPacketLoss: 6,
                NetworkJitter: 7,
                NetworkRateMatching: 8,
                DeviceCaptureNotFunctioning: 9,
                DeviceRenderNotFunctioning: 10,
                DeviceRenderGlitches: 11,
                DeviceLowSNR: 12,
                DeviceLowSpeechLevel: 13,
                DeviceClipping: 14,
                DeviceEcho: 15,
                DeviceNearEndToEchoRatio: 16,
                DeviceHalfDuplexAec: 17,
                DeviceMultipleEndpoints: 18,
                DeviceHowling: 19,
                DeviceRenderZeroVolume: 20,
                DeviceRenderMute: 21,
                NetworkSendCatastrophic: 22,
                NetworkRecvCatastrophic: 23,
                CpuInsufficient: 24,
                DeviceCaptureMute: 25,
                DeviceCaptureNotMuteButSilent: 26,
                DeviceSpeakWhileMuted: 27,
                VideoVbssRendered: 28,
                NetworkEthernetInterfaceUsed: 29,
                NetworkWlanInterfaceUsed: 30,
                NetworkWwanInterfaceUsed: 31,
                NetworkRelaysNotReachable: 32,
                VideoCapturerDeviceStartFailed: 33,
                VideoCapturerDeviceStartTimedOut: 34,
                VideoCapturerDeviceStartFailureLackSystemRes: 35,
                VideoCapturerDeviceStartFailureMFResConflict: 36,
                NoNetwork: 37,
                NetworkNotWorking: 38,
                DeviceCaptureNotFunctioningDeviceInUse: 39,
                DeviceRenderNotFunctioningDeviceInUse: 40,
                DeviceCaptureNotFunctioningAudioSrvNotRunning: 41,
                DeviceRenderNotFunctioningAudioSrvNotRunning: 42,
                ZeroCaptureDevicesEnumerated: 43,
                ZeroRenderDevicesEnumerated: 44,
                VideoCaptureDeviceFreeze: 45,
                AudioCapturePermissionDenied: 46,
                VideoCapturePermissionDenied: 47,
                VideoCaptureFreezeRecovered: 48,
                DeviceRenderHowling: 49,
                LowFarEndInput: 50,
                ImageRenderingQuality: 51,
                RemoteNetworkConnectivityIssue: 52,
                PresentationAudioLoopbackDeviceState: 53,
                AudioCaptureUltrasoundDetected: 54,
                ScreenshareRecordingDisabled: 55,
                MultichannelAudioBandwidth: 56,
                MusicModeNotAvailable: 57,
                MusicModeSupported: 58,
                AudioCaptureMusicDetectedWithHighNS: 59,
                AudioCaptureMusicDetectedWithLowNS: 60,
                CameraLighting: 61,
                DeviceCaptureVoiceActive: 62,
                AudioLoopbackDeviceReady: 63,
                NoRequiredVideoCodecs: 64,
                SpatialAudioMUCHUnavailable: 65,
                SpeechOverlapFailedInterruptionDetected: 66,
                BackgroundSpeechSuppressed: 67,
                BackgroundLoudSpeechSuppressed: 68,
                ActiveSpeechDetected: 69,
                DeviceCaptureNotFunctioningBluetoothMidCallFail: 70,
                DeviceCaptureNotFunctioningWebcamMicMidCallFail: 71,
                DeviceCaptureNotMuteButSilentDongle: 72,
                DeviceRenderNotFunctioningBluetoothMidCallFail: 73,
                ZeroCaptureDevicesEnumeratedRDP: 74,
                ZeroRenderDevicesEnumeratedRDP: 75,
                WrongCaptureDevicesUsedRDP: 76,
                WrongRenderDevicesUsedRDP: 77,
                NetworkStatusIndicator: 78,
                LoopbackDeviceRenderNotFunctioning: 79,
                AudioMixMUCHUnavailable: 80
            }, this.tsMediaStringToEnumMap = {
                Audio: 0,
                Video: 1,
                ScreenShare: 2,
                Data: 3
            }, this.tsQualityLevelStringToEnumMap = {
                Good: 1,
                Poor: 2,
                Bad: 3,
                Unknown: 0
            }, this._latestRemoteDiagnostics = {
                diagnostics: []
            };
        }
    }
    class DominantSpeakersCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "DominantSpeakers";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get dominantSpeakers() {
            return this._sendFeatureUsage("dominantSpeakers", uy.getter), this._impl.dominantSpeakers;
        }
        on(g, f) {
            this._sendFeatureUsage("dominantSpeakersChanged", uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage("dominantSpeakersChanged", uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "DominantSpeakers",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new DominantSpeakersCallImplOverTsCall(this.eventEmitter);
        }
    }
    class DominantSpeakersCallImplOverTsCall {
        initialize(g, f, S, v, _ = !1) {
            var _this__tsCall_dominantSpeakerInfo;
            this._logger = v.createChild(()=>`DominantSpeakersFeature${_ ? "Internal" : ""}::Call(id='${g.callId}')`), this._tsCall = g, this.localDominantList = ((_this__tsCall_dominantSpeakerInfo = this._tsCall.dominantSpeakerInfo) === null || _this__tsCall_dominantSpeakerInfo === void 0 ? void 0 : _this__tsCall_dominantSpeakerInfo.speakerList) || [], this._tsCallChangedListener = this._tsCall.changed(()=>{
                let g = !1;
                if (this.localDominantList.length != this._tsCall.dominantSpeakerInfo.speakerList.length) g = !0;
                else for(let f in this._tsCall.dominantSpeakerInfo.speakerList)if (this._tsCall.dominantSpeakerInfo.speakerList[f] !== this.localDominantList[f]) {
                    g = !0;
                    break;
                }
                g && (this._logger.info("Dominant speakers list change detected"), this.localDominantList = this._tsCall.dominantSpeakerInfo.speakerList, this._eventEmitter.emit("dominantSpeakersChanged"));
            });
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        get dominantSpeakers() {
            let g = Array();
            return this._tsCall.dominantSpeakerInfo.speakerList.map((f)=>{
                g.push(constructIdentifierKindFromMri(f));
            }), {
                speakersList: g,
                timestamp: this._tsCall.dominantSpeakerInfo.timestamp || new Date
            };
        }
        dispose() {
            var _this__tsCallChangedListener;
            this._eventEmitter.removeAllListeners(), (_this__tsCallChangedListener = this._tsCallChangedListener) === null || _this__tsCallChangedListener === void 0 ? void 0 : _this__tsCallChangedListener.dispose();
        }
        constructor(g){
            this._eventEmitter = g, this.localDominantList = [];
        }
    }
    class CallingEventEmitter extends Ny.EventEmitter {
        on(g, f) {
            return !1 !== this._options.enableLogOn && this._logger.info(`event:subscribe to ${g.toString()}`), super.on(g, f);
        }
        once(g, f) {
            return !1 !== this._options.enableLogOnce && this._logger.info(`event:subscribe once to ${g.toString()}`), super.once(g, f);
        }
        off(g, f) {
            return !1 !== this._options.enableLogOff && this._logger.info(`event:unsubscribed ${g.toString()}`), super.off(g, f);
        }
        emit(g, ...f) {
            try {
                return !1 !== this._options.enableLogEmit && this._logger.info(`event:emit ${g.toString()}`), super.emit(g, ...f);
            } catch (f) {
                return this._logger.warn(`Application threw an error while it handled the ${g.toString()} event`), !1;
            }
        }
        constructor(g, f){
            super(), this._options = {
                enableLogOn: !0,
                enableLogOff: !0,
                enableLogOnce: !0,
                enableLogEmit: !0
            }, this._logger = g.createChild("CallingEventEmitter"), f && (this._options = f);
        }
    }
    function createMediaStatsReportInternalObject() {
        return {
            audio: {
                send: {},
                receive: {}
            },
            video: {
                send: {},
                receive: {}
            },
            screenShare: {
                send: {},
                receive: {}
            },
            dataChannel: {},
            transports: {},
            info: {}
        };
    }
    function getMax(g) {
        let f = g.length > 0 ? g[0] : 0;
        return g.forEach((g)=>{
            g > f && (f = g);
        }), f;
    }
    function getMin(g) {
        let f = g.length > 0 ? g[0] : 0;
        return g.forEach((g)=>{
            g < f && (f = g);
        }), f;
    }
    function getSum(g) {
        let f = 0, S = 0;
        return g.forEach((g)=>{
            const v = g - S, _ = f + v;
            S = _ - f - v, f = _;
        }), f;
    }
    const CE = createMediaStatsReportInternalObject;
    class MediaStatsCalculator {
        addStats(g, f) {
            const S = this._metricsProperties[g];
            if (void 0 !== S && !0 !== S.skip) {
                if (S.events) {
                    var _S_output_key;
                    const v = (_S_output_key = S.output_key) !== null && _S_output_key !== void 0 ? _S_output_key : g;
                    f !== this._currentValues[v] && (this._currentValues[v] = f, this._events.push({
                        name: v,
                        value: f,
                        timestamp: Date.now()
                    }));
                } else {
                    let S = this._originalValues[g];
                    void 0 === S && (S = {
                        raw: [],
                        beginTime: Date.now()
                    }, this._originalValues[g] = S), S.raw.push(f);
                }
                return f;
            }
        }
        aggregate() {
            for (const [g, f] of Object.entries(this._originalValues)){
                var _S_output_key;
                const S = this._metricsProperties[g], v = (_S_output_key = S.output_key) !== null && _S_output_key !== void 0 ? _S_output_key : g;
                let _ = this._aggregateValues[v];
                void 0 === _ && (_ = {
                    raw: [],
                    timestamp: new Date(f.beginTime)
                }, S.aggregable && (_.aggregation = {
                    count: [],
                    sum: [],
                    max: [],
                    min: []
                }), this._aggregateValues[v] = _);
                const C = f.raw;
                let E = C;
                if (S.aggregable && _.aggregation) {
                    const g = C.filter((g)=>"number" == typeof g && !isNaN(g));
                    _.aggregation.count.push(g.length), _.aggregation.sum.push(getSum(g)), _.aggregation.max.push(getMax(g)), _.aggregation.min.push(getMin(g)), E = g;
                }
                S.raw_data_reduction && E.length > 0 && (_.reduced = _.reduced || [], _.reduced.push(E[E.length - 1])), E.forEach((g)=>_.raw.push(g));
            }
            this._originalValues = {};
        }
        popAggregates() {
            const g = this._aggregateValues;
            return this._aggregateValues = {}, g;
        }
        popEvents() {
            const g = this._events;
            return this._events = [], g;
        }
        constructor(g){
            this._metricsProperties = g, this._originalValues = {}, this._aggregateValues = {}, this._events = [], this._currentValues = {};
        }
    }
    class TelemetryCollector {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            var _this__mediaStatsSource;
            this._disposed || (this._disposed = !0, this._callStateChanged.resolve(!1), this._eventEmitter.removeAllListeners(), (_this__mediaStatsSource = this._mediaStatsSource) === null || _this__mediaStatsSource === void 0 ? void 0 : _this__mediaStatsSource.removeSink(this));
        }
        get source() {
            return this._mediaStatsSource;
        }
        set source(g) {
            this._mediaStatsSource = g;
        }
        onReport(g) {
            this._processMediaStatsReport(g);
        }
        onAdded(g) {
            this._isActive !== g && (this._isActive = g, this._callStateChanged.resolve(g));
        }
        onRemoved() {
            this.dispose();
        }
        pause() {
            this._isActive && (this._isActive = !1, this._callStateChanged.resolve(!1));
        }
        resume() {
            this._isActive || (this._isActive = !0, this._callStateChanged.resolve(!0));
        }
        stop() {
            this.dispose();
        }
        _processMediaStatsReport(g) {
            try {
                const f = [
                    [
                        g.audio.send,
                        this._calculators.audio.send,
                        this._metricsProperties.audio.send,
                        "send"
                    ],
                    [
                        g.audio.receive,
                        this._calculators.audio.receive,
                        this._metricsProperties.audio.receive,
                        "recv"
                    ],
                    [
                        g.video.send,
                        this._calculators.video.send,
                        this._metricsProperties.video.send,
                        "send"
                    ],
                    [
                        g.video.receive,
                        this._calculators.video.receive,
                        this._metricsProperties.video.receive,
                        "recv"
                    ],
                    [
                        g.screenShare.send,
                        this._calculators.screenShare.send,
                        this._metricsProperties.screenShare.send,
                        "send"
                    ],
                    [
                        g.screenShare.receive,
                        this._calculators.screenShare.receive,
                        this._metricsProperties.screenShare.receive,
                        "recv"
                    ],
                    [
                        g.dataChannel,
                        this._calculators.dataChannel,
                        this._metricsProperties.dataChannel,
                        ""
                    ],
                    [
                        g.transports,
                        this._calculators.transports,
                        this._metricsProperties.transports,
                        ""
                    ],
                    [
                        g.info,
                        this._calculators.info,
                        this._metricsProperties.info,
                        ""
                    ]
                ];
                for (const [S, v, _, C] of f){
                    const f = [], E = Object.keys(v);
                    Object.keys(S).forEach((E)=>{
                        const T = S[E], I = T.id;
                        f.push(I), void 0 === v[I] && (v[I] = new MediaStatsCalculator(_));
                        const addStats = (g, f)=>v[I].addStats(g, f);
                        if (Object.keys(T).forEach((g)=>addStats(g, T[g])), "send" == C || "recv" == C) {
                            const f = T.transportId;
                            if (void 0 !== f) {
                                const S = g.transports[f];
                                void 0 !== S.rtt && addStats("pairRttInMs", S.rttInMs), void 0 !== S.availableIncomingBitrate && "recv" == C && addStats("availableBitrate", S.availableIncomingBitrate), void 0 !== S.availableOutgoingBitrate && "send" == C && addStats("availableBitrate", S.availableOutgoingBitrate);
                            }
                        }
                    });
                    E.filter((g)=>!f.includes(g)).forEach((g)=>{
                        delete v[g];
                    });
                }
            } catch (g) {
                this._logger.error(g);
            }
        }
        async _run() {
            let g = 0;
            const flushData = ()=>{
                if (0 === g) return;
                const f = {
                    audio: {
                        send: {},
                        receive: {}
                    },
                    video: {
                        send: {},
                        receive: {}
                    },
                    screenShare: {
                        send: {},
                        receive: {}
                    },
                    dataChannel: {},
                    transports: {},
                    info: {}
                }, S = [
                    [
                        f.audio.send,
                        this._calculators.audio.send
                    ],
                    [
                        f.audio.receive,
                        this._calculators.audio.receive
                    ],
                    [
                        f.video.send,
                        this._calculators.video.send
                    ],
                    [
                        f.video.receive,
                        this._calculators.video.receive
                    ],
                    [
                        f.screenShare.send,
                        this._calculators.screenShare.send
                    ],
                    [
                        f.screenShare.receive,
                        this._calculators.screenShare.receive
                    ],
                    [
                        f.dataChannel,
                        this._calculators.dataChannel
                    ],
                    [
                        f.transports,
                        this._calculators.transports
                    ],
                    [
                        f.info,
                        this._calculators.info
                    ]
                ];
                for (const [g, f] of S)for (const [S, v] of Object.entries(f))g[S] = {
                    id: S,
                    ...v.popAggregates(),
                    events: v.popEvents()
                };
                this._eventEmitter.emit("data", f), g = 0;
            };
            let f = 1e3 * this._aggregationInterval;
            for(; !this._disposed;){
                const S = [
                    this._calculators.audio.send,
                    this._calculators.audio.receive,
                    this._calculators.video.send,
                    this._calculators.video.receive,
                    this._calculators.screenShare.send,
                    this._calculators.screenShare.receive,
                    this._calculators.dataChannel,
                    this._calculators.info
                ];
                if (this._isActive) {
                    f > 0 && await wait(()=>this._callStateChanged.promise, f).catch((g)=>{});
                    const v = Date.now();
                    for (const g of S)for (const [, f] of Object.entries(g))f.aggregate();
                    g++, g === this._dataPointsPerAggregation && flushData();
                    const _ = Date.now();
                    f = v + 1e3 * this._aggregationInterval - _;
                } else flushData(), this._calculators = CE(), await this._callStateChanged.promise.catch((g)=>{}), f = 1e3 * this._aggregationInterval;
                this._callStateChanged.isPending() || (this._callStateChanged = defer$1());
            }
            flushData();
        }
        constructor(g, f){
            if (this._aggregationInterval = 0, this._dataPointsPerAggregation = 0, this._disposed = !1, this._calculators = CE(), this._isActive = !1, f.aggregationInterval < 1) throw new Error("invalid aggregationInterval value range");
            if (f.dataPointsPerAggregation < 1) throw new Error("invalid dataPointsPerAggregation value range");
            this._metricsProperties = f.metricsPropertics, this._logger = g.createChild("TelemetryCollector"), this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogEmit: !1
            }), this._callStateChanged = defer$1(), this._aggregationInterval = f.aggregationInterval, this._dataPointsPerAggregation = f.dataPointsPerAggregation, this._run();
        }
    }
    function convertAltLayouts(g) {
        const f = [];
        return g.sort((g, f)=>g.id > f.id ? 1 : g.id < f.id ? -1 : 0), g.forEach((g)=>{
            const S = /^([^.]+)\.?([^.]+)?$/.exec(g.id);
            if (S && S[2]) {
                g.id = P.toString(S[2]);
                const v = P.toString(S[1]);
                if (f.length > 0 && f[f.length - 1].id === v) {
                    var _f__altLayouts;
                    const S = (_f__altLayouts = f[f.length - 1].altLayouts) !== null && _f__altLayouts !== void 0 ? _f__altLayouts : [];
                    S.push(g), f[f.length - 1].altLayouts = S;
                } else f.push(g);
            } else f.push(g);
        }), f;
    }
    class MediaStatsCollectorImpl {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            var _this__mediaStatsSource;
            this._disposed || (this._disposed = !0, this._callStateChanged.resolve(!1), this._eventEmitter.removeAllListeners(), (_this__mediaStatsSource = this._mediaStatsSource) === null || _this__mediaStatsSource === void 0 ? void 0 : _this__mediaStatsSource.removeSink(this));
        }
        get source() {
            return this._mediaStatsSource;
        }
        set source(g) {
            this._mediaStatsSource = g;
        }
        onReport(g) {
            this._processMediaStatsReport(g);
        }
        onAdded(g) {
            this._isActive !== g && (this._isActive = g, this._callStateChanged.resolve(g));
        }
        onRemoved() {
            this.dispose();
        }
        pause() {
            this._isActive && (this._isActive = !1, this._callStateChanged.resolve(!1));
        }
        resume() {
            this._isActive || (this._isActive = !0, this._callStateChanged.resolve(!0));
        }
        stop() {
            this.dispose();
        }
        _processMediaStatsReport(g) {
            const f = {
                audio: {
                    send: [],
                    receive: []
                },
                video: {
                    send: [],
                    receive: []
                },
                screenShare: {
                    send: [],
                    receive: []
                },
                transports: []
            };
            try {
                const S = [
                    [
                        g.audio.send,
                        f.audio.send,
                        this._calculators.audio.send,
                        this._metricsProperties.audio.send
                    ],
                    [
                        g.audio.receive,
                        f.audio.receive,
                        this._calculators.audio.receive,
                        this._metricsProperties.audio.receive
                    ],
                    [
                        g.video.send,
                        f.video.send,
                        this._calculators.video.send,
                        this._metricsProperties.video.send
                    ],
                    [
                        g.video.receive,
                        f.video.receive,
                        this._calculators.video.receive,
                        this._metricsProperties.video.receive
                    ],
                    [
                        g.screenShare.send,
                        f.screenShare.send,
                        this._calculators.screenShare.send,
                        this._metricsProperties.screenShare.send
                    ],
                    [
                        g.screenShare.receive,
                        f.screenShare.receive,
                        this._calculators.screenShare.receive,
                        this._metricsProperties.screenShare.receive
                    ],
                    [
                        g.transports,
                        f.transports,
                        this._calculators.transports,
                        this._metricsProperties.transports
                    ]
                ];
                let v = !1;
                for (const [g, f, _, C] of S){
                    const S = [], E = Object.keys(_);
                    Object.keys(g).forEach((E)=>{
                        const T = g[E];
                        let I = T.id;
                        T.groupId && (I = `${T.groupId}.${I}`, v = !0);
                        const b = {
                            id: I
                        };
                        S.push(I), void 0 === _[I] && (_[I] = new MediaStatsCalculator(C)), Object.keys(T).forEach((g)=>{
                            const f = C[g];
                            if (f && !0 !== f.skip) {
                                var _f_output_key;
                                const S = _[I].addStats(g, T[g]), v = (_f_output_key = f.output_key) !== null && _f_output_key !== void 0 ? _f_output_key : g;
                                b[v] = S;
                            }
                        }), f.push(b);
                    });
                    E.filter((g)=>!S.includes(g)).forEach((g)=>{
                        delete _[g];
                    });
                }
                v && (f.video.send = convertAltLayouts(f.video.send), f.screenShare.send = convertAltLayouts(f.screenShare.send));
            } catch (g) {
                this._logger.error(g);
            }
            this._eventEmitter.emit("sampleReported", f);
        }
        async _run() {
            let g = 0;
            const flushData = ()=>{
                if (0 === g) return;
                const f = {
                    audio: {
                        send: [],
                        receive: []
                    },
                    video: {
                        send: [],
                        receive: []
                    },
                    screenShare: {
                        send: [],
                        receive: []
                    },
                    transports: []
                };
                for (const [g, S] of Object.entries(this._calculators.audio.send))f.audio.send.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.audio.receive))f.audio.receive.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.video.send))f.video.send.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.video.receive))f.video.receive.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.screenShare.send))f.screenShare.send.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.screenShare.receive))f.screenShare.receive.push({
                    id: g,
                    ...S.popAggregates()
                });
                for (const [g, S] of Object.entries(this._calculators.transports))f.transports.push({
                    id: g,
                    ...S.popAggregates()
                });
                f.video.send = convertAltLayouts(f.video.send), f.screenShare.send = convertAltLayouts(f.screenShare.send), this._eventEmitter.emit("summaryReported", f), g = 0;
            };
            let f = 1e3 * this._aggregationInterval;
            for(; !this._disposed;){
                const S = [
                    this._calculators.audio.send,
                    this._calculators.audio.receive,
                    this._calculators.video.send,
                    this._calculators.video.receive,
                    this._calculators.screenShare.send,
                    this._calculators.screenShare.receive,
                    this._calculators.transports
                ];
                if (this._isActive) {
                    f > 0 && await wait(()=>this._callStateChanged.promise, f).catch((g)=>{});
                    const v = Date.now();
                    for (const g of S)for (const [, f] of Object.entries(g))f.aggregate();
                    g++, g === this._dataPointsPerAggregation && flushData();
                    const _ = Date.now();
                    f = v + 1e3 * this._aggregationInterval - _;
                } else flushData(), this._calculators = CE(), await this._callStateChanged.promise.catch((g)=>{}), f = 1e3 * this._aggregationInterval;
                this._callStateChanged.isPending() || (this._callStateChanged = defer$1());
            }
            flushData();
        }
        constructor(g, f){
            if (this._aggregationInterval = 0, this._dataPointsPerAggregation = 0, this._disposed = !1, this._calculators = CE(), this._isActive = !1, f.aggregationInterval < 1) throw new CallingCommunicationError({
                defaultError: O.FEATURES.MEDIA_STATS.INVALID_AGGREGATION_INTERVAL_RANGE
            });
            if (f.dataPointsPerAggregation < 1) throw new CallingCommunicationError({
                defaultError: O.FEATURES.MEDIA_STATS.INVALID_DATAPOINTS_AGGREGATION_RANGE
            });
            this._metricsProperties = f.metricsPropertics, this._logger = g.createChild("MediaStatsCollector"), this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogEmit: !1
            }), this._callStateChanged = defer$1(), this._aggregationInterval = f.aggregationInterval, this._dataPointsPerAggregation = f.dataPointsPerAggregation, this._run();
        }
    }
    class AbstractTicker {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            this._eventEmitter.removeAllListeners();
        }
        constructor(){
            this._eventEmitter = new Ny.EventEmitter, this._getCurrentTime = globalThis.performance && "function" == typeof globalThis.performance.now ? ()=>globalThis.performance.now() : ()=>Date.now();
        }
    }
    class IntervalTicker extends AbstractTicker {
        start() {
            this._handle || (this._handle = globalThis.setInterval(()=>{
                this._eventEmitter.emit("tick");
            }, this._intervalInMs));
        }
        stop() {
            this._handle && (globalThis.clearInterval(this._handle), this._handle = 0);
        }
        dispose() {
            this.stop(), super.dispose();
        }
        constructor(g){
            super(), this._intervalInMs = g, this._handle = 0;
        }
    }
    class ChainedTimeoutTicker extends AbstractTicker {
        start() {
            if (this._state.isRunning) return;
            const g = {
                isRunning: !0
            };
            this._state = g;
            const runLoop = async ()=>{
                for(; g.isRunning;){
                    const g = this._getCurrentTime();
                    this._eventEmitter.emit("tick");
                    const f = this._getCurrentTime() - g;
                    f < this._intervalInMs && await sleep(this._intervalInMs - f);
                }
            };
            this._callQueue = this._callQueue.then(()=>runLoop()).catch(()=>{});
        }
        stop() {
            this._state.isRunning && (this._state.isRunning = !1);
        }
        dispose() {
            this._state.isRunning = !1, super.dispose();
        }
        constructor(g){
            super(), this._intervalInMs = g, this._callQueue = Promise.resolve(), this._state = {
                isRunning: !1
            };
        }
    }
    class TickerFactory {
        static createTicker(g, f) {
            if ("interval" === g) return new IntervalTicker(f);
            if ("timeout" === g) return new ChainedTimeoutTicker(f);
            throw new Error(`Invalid tickerType: ${g}`);
        }
    }
    class StatsPoller {
        dispose() {
            this._callStateChangedHandle.dispose(), this._ticker.dispose();
        }
        get fetchInterval() {
            return this._fetchInterval;
        }
        get timerDelayRatio() {
            return this._timerDelayRatio;
        }
        _start() {
            this._lastFetchTime = 0, this._timerDelayRatio = 0, this._ticker.start();
        }
        _stop() {
            this._ticker.stop();
        }
        on(g, f) {
            this._dataEventRefCount++, this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._dataEventRefCount--, this._eventEmitter.off(g, f);
        }
        constructor(g, f, S, v, _){
            this._call = g, this._logger = f, this._dataEventRefCount = 0, this._lastFetchTime = 0, this._timerDelayRatio = 0, this._pendingStats = !1, this._tsCall = this._call.tsCall, this._fetchInterval = S, this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogEmit: !1
            });
            const C = 1e3 * S;
            this._ticker = TickerFactory.createTicker(v, C), this._ticker.on("tick", ()=>{
                const g = Date.now();
                this._lastFetchTime > 0 && (this._timerDelayRatio = (g - this._lastFetchTime) / C), this._lastFetchTime = g, this._dataEventRefCount > 0 && !1 === this._pendingStats && (this._pendingStats = !0, this.getStats().then((g)=>{
                    g && this._eventEmitter.emit("data", g);
                }).catch((g)=>{
                    this._logger.error(g);
                }).finally(()=>{
                    this._pendingStats = !1;
                }));
            });
            const checkState = ()=>{
                _.includes(this._tsCall.state) ? this._start() : this._stop();
            };
            this._callStateChangedHandle = this._tsCall.on("callStateChanged", ()=>{
                checkState();
            }), checkState();
        }
    }
    class MediaStatsPoller extends StatsPoller {
        _recordSendMaxCapabilities(g, f) {
            if (f) try {
                const S = JSON.parse(f);
                P.each(S, (f)=>{
                    var _this__lastCap_get;
                    const S = f.events, v = (_this__lastCap_get = this._lastCap.get(g)) !== null && _this__lastCap_get !== void 0 ? _this__lastCap_get : 0, _ = P.filter(P.flatten(S), (g)=>"req" === (g === null || g === void 0 ? void 0 : g.eventType) && (g === null || g === void 0 ? void 0 : g.timestamp) > v);
                    _.length > 0 && this._lastCap.set(g, P.last(_).timestamp), _.forEach((f)=>{
                        var _f_eventType, _f_capabilities, _f_isSimulcast;
                        this._call.stats.recordEvent({
                            name: cy.video_max_capabilities,
                            callId: this._call.id,
                            localParticipantId: this._tsCall.participantId,
                            timestamp: f.timestamp,
                            data: {
                                streamType: g,
                                eventType: (_f_eventType = f.eventType) !== null && _f_eventType !== void 0 ? _f_eventType : "",
                                capabilities: (_f_capabilities = f.capabilities) !== null && _f_capabilities !== void 0 ? _f_capabilities : {},
                                isSimulcast: (_f_isSimulcast = f.isSimulcast) !== null && _f_isSimulcast !== void 0 ? _f_isSimulcast : !1
                            }
                        });
                    });
                });
            } catch (f) {
                this._logger.warn(`Failed to process max capabilities for streamType ${g}: ${f}`);
            }
        }
        async getStats() {
            var _window_performance, _window_performance1;
            const g = this._tsCall.getMediaSessionStats();
            this._telemetryConfig.enableVideoMaxCapCallStats && (g === null || g === void 0 ? void 0 : g.extensions) && (this._recordSendMaxCapabilities("Video", g.extensions.Video_send_MaxCapabilities), this._recordSendMaxCapabilities("ScreenSharing", g.extensions.Sharing_send_MaxCapabilities));
            const f = {
                report: g,
                delayRatio: this.timerDelayRatio
            };
            if (this._telemetryConfig.enableNetworkInformation && window.navigator.connection) {
                const g = window.navigator.connection, S = P.get(g, "downlink"), v = P.get(g, "rtt");
                void 0 === S && void 0 === v || (f.networkInformation = {
                    downlink: S,
                    rtt: v
                });
            }
            if (this._telemetryConfig.enableMemoryInformationV1 && ((_window_performance = window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.memory)) {
                const g = window.performance.memory, S = P.get(g, "jsHeapSizeLimit"), v = P.get(g, "totalJSHeapSize"), _ = P.get(g, "usedJSHeapSize");
                void 0 === S && void 0 === v && void 0 === _ || (f.memoryInformationV1 = {
                    jsHeapSizeLimit: S,
                    totalJSHeapSize: v,
                    usedJSHeapSize: _
                });
            }
            if (this._telemetryConfig.enableMemoryInformationV2 && window.crossOriginIsolated && ((_window_performance1 = window.performance) === null || _window_performance1 === void 0 ? void 0 : _window_performance1.measureUserAgentSpecificMemory) && (this._memoryInformationV2 && (f.memoryInformationV2 = {
                jsSize: this._memoryInformationV2.jsSize,
                sharedSize: this._memoryInformationV2.sharedSize,
                domSize: this._memoryInformationV2.domSize
            }), this._memoryInformationV2PendingTask || (this._memoryInformationV2PendingTask = !0, window.performance.measureUserAgentSpecificMemory.call(window.performance).then((g)=>{
                let f, S, v;
                P.get(g, "breakdown", []).forEach((g)=>{
                    g.bytes > 0 && (P.indexOf(g.types, "DOM") >= 0 && (v = void 0 === v ? g.bytes : v + g.bytes), P.indexOf(g.types, "Shared") >= 0 && (S = void 0 === S ? g.bytes : S + g.bytes), P.indexOf(g.types, "JavaScript") >= 0 && (f = void 0 === f ? g.bytes : f + g.bytes));
                }), this._memoryInformationV2 = {
                    jsSize: f,
                    sharedSize: S,
                    domSize: v
                };
            }).catch((g)=>{
                this._memoryInformationV2 = void 0;
            }).finally(()=>{
                this._memoryInformationV2PendingTask = !1;
            }))), this._telemetryConfig.enableBatteryInformation && navigator.getBattery) try {
                const g = await navigator.getBattery();
                g && (f.batteryInformation = {
                    charging: g.charging,
                    level: g.level
                });
            } catch (g) {}
            if (this._telemetryConfig.enablePressureInformation && window.PressureObserver) {
                if (!this._pressureObserver) try {
                    this._pressureObserver = new window.PressureObserver((g)=>{
                        const f = g[g.length - 1];
                        this._lastCpuPressureLevel = [
                            "nominal",
                            "fair",
                            "serious",
                            "critical"
                        ].indexOf(f.state);
                    }), await this._pressureObserver.observe("cpu", {
                        sampleInterval: 1e3
                    });
                } catch (g) {
                    this._logger.error(`Failed to observe cpu pressure ${g}`);
                }
                -1 !== this._lastCpuPressureLevel && (f.pressureInformation = {
                    cpuPressureLevel: this._lastCpuPressureLevel
                });
            }
            if (this._telemetryConfig.enableAudioLeakInformation) try {
                var _navigator_mediaDevices_tsCallingChannel;
                const S = this._tsCall.isMuted || this._tsCall.isServerMuted;
                f.callInformation ? f.callInformation.audioLeak = 0 : f.callInformation = {
                    audioLeak: 0
                }, S && (g === null || g === void 0 ? void 0 : g.audio.send.length) && void 0 !== g.audio.send[0].audioLevel && g.audio.send[0].audioLevel > this._telemetryConfig.audioLeakThreshold && (navigator.mediaDevices.isRemote && !((_navigator_mediaDevices_tsCallingChannel = navigator.mediaDevices.tsCallingChannel) === null || _navigator_mediaDevices_tsCallingChannel === void 0 ? void 0 : _navigator_mediaDevices_tsCallingChannel.createdRemoteObject) || (f.callInformation.audioLeak = 1));
            } catch (g) {}
            if (this._telemetryConfig.enableVideoLeakInformation) try {
                f.callInformation ? f.callInformation.videoLeak = 0 : f.callInformation = {
                    videoLeak: 0
                }, !this._tsCall.isVideoOn && (g === null || g === void 0 ? void 0 : g.video.send.length) && (f.callInformation.videoLeak = 1);
            } catch (g) {}
            return f;
        }
        dispose() {
            try {
                this._pressureObserver && (this._pressureObserver.disconnect(), this._pressureObserver = void 0);
            } catch (g) {
                this._logger.error(`dispose error: ${g}`);
            }
        }
        constructor(g, f, S){
            super(g, f.createChild("MediaStatsPoller"), S.mediaStats.fetchInterval, S.mediaStats.pollingMethod, S.mediaStats.activeState), this._memoryInformationV2PendingTask = !1, this._lastCap = new Map, this._lastCpuPressureLevel = -1, this._telemetryConfig = S.telemetry.mediaStatsConfig;
        }
    }
    var yE;
    !function(g) {
        g[g.Running = 0] = "Running", g[g.Paused = 1] = "Paused", g[g.Stopped = 2] = "Stopped";
    }(yE || (yE = {}));
    class MediaStatsSourceNode {
        _setTransformers(g) {
            this._transformers = g.slice();
        }
        addSink(g) {
            g.source = this, this._sinks.push(g), g.onAdded(this._state === yE.Running);
        }
        removeSink(g) {
            g.source === this && (P.pull(this._sinks, g), g.source = void 0, g.onRemoved());
        }
        removeAllSinks() {
            const g = this._sinks;
            this._sinks = [], g.forEach((g)=>{
                g.source = void 0, g.onRemoved();
            });
        }
        send(g) {
            if (this._state !== yE.Running) return;
            let f = g;
            this._transformers.length && (f = this._transformers.reduce((g, f)=>f.transform(g), g)), this._sinks.forEach((g)=>g.onReport(f));
        }
        pause() {
            this._state === yE.Running && (this._state = yE.Paused, this._sinks.forEach((g)=>g.pause()));
        }
        resume() {
            this._state === yE.Paused && (this._state = yE.Running, this._sinks.forEach((g)=>g.resume()));
        }
        stop() {
            this._state !== yE.Stopped && this._sinks.forEach((g)=>g.stop());
        }
        constructor(){
            this._sinks = [], this._transformers = [], this._state = yE.Running;
        }
    }
    class MediaStatsReportSourceNode extends MediaStatsSourceNode {
        onReport(g) {
            if (void 0 === g.report) return;
            const f = createMediaStatsReportInternalObject();
            var _f_metadata;
            f.metadata = (_f_metadata = f.metadata) !== null && _f_metadata !== void 0 ? _f_metadata : {}, f.metadata.delayRatio = g.delayRatio;
            const S = [], v = {
                id: "0"
            };
            g.networkInformation && (void 0 !== g.networkInformation.downlink && (v.networkInfoDownlink = g.networkInformation.downlink), void 0 !== g.networkInformation.rtt && (v.networkInfoRttInMs = g.networkInformation.rtt)), g.memoryInformationV1 && (void 0 !== g.memoryInformationV1.jsHeapSizeLimit && (v.jsHeapSizeLimit = g.memoryInformationV1.jsHeapSizeLimit), void 0 !== g.memoryInformationV1.totalJSHeapSize && (v.totalJSHeapSize = g.memoryInformationV1.totalJSHeapSize), void 0 !== g.memoryInformationV1.usedJSHeapSize && (v.usedJSHeapSize = g.memoryInformationV1.usedJSHeapSize)), g.memoryInformationV2 && (void 0 !== g.memoryInformationV2.jsSize && (v.jsSize = g.memoryInformationV2.jsSize), void 0 !== g.memoryInformationV2.sharedSize && (v.sharedSize = g.memoryInformationV2.sharedSize), void 0 !== g.memoryInformationV2.domSize && (v.domSize = g.memoryInformationV2.domSize)), g.batteryInformation && (void 0 !== g.batteryInformation.charging && (v.batteryCharging = g.batteryInformation.charging ? 1 : 0), void 0 !== g.batteryInformation.level && (v.batteryLevel = g.batteryInformation.level)), g.pressureInformation && void 0 !== g.pressureInformation.cpuPressureLevel && (v.cpuPressureLevel = g.pressureInformation.cpuPressureLevel), g.callInformation && (void 0 !== g.callInformation.audioLeak && (v.audioLeak = g.callInformation.audioLeak), void 0 !== g.callInformation.videoLeak && (v.videoLeak = g.callInformation.videoLeak)), P.keys(v).length > 1 && S.push(v);
            const _ = [
                [
                    g.report.audio.send,
                    f.audio.send
                ],
                [
                    g.report.audio.recv,
                    f.audio.receive
                ],
                [
                    g.report.video.send,
                    f.video.send
                ],
                [
                    g.report.video.recv,
                    f.video.receive
                ],
                [
                    g.report.screenShare.send,
                    f.screenShare.send
                ],
                [
                    g.report.screenShare.recv,
                    f.screenShare.receive
                ],
                [
                    g.report.data,
                    f.dataChannel
                ],
                [
                    g.report.transports,
                    f.transports
                ],
                [
                    S,
                    f.info
                ]
            ], extractKV = (g)=>{
                const f = {};
                return Object.entries(g).forEach((g)=>{
                    const S = g[0], v = g[1];
                    "altLayouts" !== S && null != v && (f[S] = v);
                }), f;
            };
            _.forEach((g)=>{
                const f = g[0];
                if (void 0 !== f) {
                    const S = g[1];
                    f.forEach((g)=>{
                        const f = P.toString(g.id);
                        if (S[f] = extractKV(g), void 0 !== g.altLayouts) g.altLayouts.forEach((g)=>{
                            const v = g.id, _ = extractKV(g);
                            _.groupId = f, S[v] = _;
                        });
                    });
                }
            }), this.send(f);
        }
        constructor(g){
            super(), this._setTransformers(g);
        }
    }
    class MediaStatsReportFilterNode extends MediaStatsSourceNode {
        onAdded(g) {}
        onRemoved() {}
        onReport(g) {
            this.send(g);
        }
        get source() {
            return this._mediaStatsSource;
        }
        set source(g) {
            this._mediaStatsSource = g;
        }
        constructor(g){
            super(), this._setTransformers(g);
        }
    }
    class ParticipantMappingManager {
        _updateMapping(g) {
            var _g_endpoints_endpointDetails, _g_endpoints;
            const f = g.id, S = [], v = this._config.calling.composedStreamBotIds;
            (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.forEach((g)=>{
                var _g_mediaStreams;
                (_g_mediaStreams = g.mediaStreams) === null || _g_mediaStreams === void 0 ? void 0 : _g_mediaStreams.forEach((_)=>{
                    S.push(_.sourceId), this._sourceIdToParticipantInfo.set(_.sourceId, {
                        mri: f,
                        participantId: g.participantId,
                        isComposedStream: v.includes(f)
                    });
                });
            });
        }
        _removeMapping(g) {
            var _g_endpoints_endpointDetails, _g_endpoints;
            (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.forEach((g)=>{
                var _g_mediaStreams;
                (_g_mediaStreams = g.mediaStreams) === null || _g_mediaStreams === void 0 ? void 0 : _g_mediaStreams.forEach((g)=>{
                    this._sourceIdToParticipantInfo.delete(g.sourceId);
                });
            });
        }
        findParticipantInfo(g) {
            var _this__tsCall_participants__endpoints;
            let f = this._sourceIdToParticipantInfo.get(g);
            if (void 0 === f && this.isP2P() && this._tsCall.participants.length && ((_this__tsCall_participants__endpoints = this._tsCall.participants[0].endpoints) === null || _this__tsCall_participants__endpoints === void 0 ? void 0 : _this__tsCall_participants__endpoints.endpointDetails.length)) {
                var _g_endpoints;
                const g = this._tsCall.participants[0], S = (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails[0];
                var _S_participantId;
                f = {
                    mri: g.id,
                    participantId: (_S_participantId = S === null || S === void 0 ? void 0 : S.participantId) !== null && _S_participantId !== void 0 ? _S_participantId : "",
                    isComposedStream: !1
                };
            }
            return f;
        }
        isP2P() {
            return 1 === this._tsCall.callType;
        }
        dispose() {
            this._activeParticipantMris.clear(), this._sourceIdToParticipantInfo.clear(), this._listenerHandles.forEach((g)=>g.dispose());
        }
        constructor(g){
            var _this__tsCall_participants;
            this._tsCall = g, this._activeParticipantMris = new Set, this._sourceIdToParticipantInfo = new Map, this._listenerHandles = [], this._config = getAcsEcsConfig(), this._listenerHandles.push(this._tsCall.on("participantAdded", (g)=>{
                this._activeParticipantMris.add(g.id), this._updateMapping(g);
            })), this._listenerHandles.push(this._tsCall.on("participantUpdated", (g)=>{
                this._activeParticipantMris.has(g.id) && this._updateMapping(g);
            })), this._listenerHandles.push(this._tsCall.on("participantRemoved", (g)=>{
                this._activeParticipantMris.delete(g.id), this._removeMapping(g);
            })), (_this__tsCall_participants = this._tsCall.participants) === null || _this__tsCall_participants === void 0 ? void 0 : _this__tsCall_participants.forEach((g)=>{
                this._activeParticipantMris.add(g.id), this._updateMapping(g);
            });
        }
    }
    class MediaStatsTelemetryLogger {
        dispose() {
            this._participantMappingManager.dispose();
        }
        log(g) {
            const f = this._config.telemetry.mediaStatsConfig;
            [
                {
                    type: "audio",
                    direction: "send",
                    value: g.audio.send
                },
                {
                    type: "audio",
                    direction: "recv",
                    value: g.audio.receive
                },
                {
                    type: "video",
                    direction: "send",
                    value: g.video.send
                },
                {
                    type: "video",
                    direction: "recv",
                    value: g.video.receive
                },
                {
                    type: "screen",
                    direction: "send",
                    value: g.screenShare.send
                },
                {
                    type: "screen",
                    direction: "recv",
                    value: g.screenShare.receive
                },
                {
                    type: "data",
                    direction: "",
                    value: g.dataChannel
                },
                {
                    type: "transport",
                    direction: "",
                    value: g.transports
                },
                {
                    type: "info",
                    direction: "",
                    value: g.info
                }
            ].forEach((g)=>{
                const S = Object.values(g.value);
                S.forEach((v)=>{
                    const _ = {
                        id: v.id
                    }, C = {
                        id: v.id
                    };
                    Object.keys(v).forEach((g)=>{
                        const S = g;
                        if ("id" === g) return;
                        if ("events" === g) {
                            const g = v[S];
                            return void (g.length > 0 && (_.events = JSON.stringify(g)));
                        }
                        const E = v[S];
                        if (f.dataToSend.raw) {
                            const g = {};
                            (E === null || E === void 0 ? void 0 : E.timestamp) && (g.timestamp = E === null || E === void 0 ? void 0 : E.timestamp), f.dataToSend.raw && (g.raw = E === null || E === void 0 ? void 0 : E.raw), C[S] = g;
                        }
                        const T = {};
                        void 0 !== E.aggregation ? (E.timestamp && (T.timestamp = E.timestamp), f.dataToSend.min && (T.min = E.aggregation.min), f.dataToSend.max && (T.max = E.aggregation.max), f.dataToSend.sum && (T.sum = E.aggregation.sum), f.dataToSend.count && (T.count = E.aggregation.count)) : (E.timestamp && (T.timestamp = E.timestamp), E.reduced ? T.raw = E.reduced : E.raw && (T.raw = E.raw)), _[S] = T;
                    });
                    let E = "", T = "";
                    if (("video" === g.type || "screen" === g.type) && "recv" === g.direction) {
                        var _g_streamId_raw;
                        const g = v;
                        if (void 0 !== g.streamId && ((_g_streamId_raw = g.streamId.raw) === null || _g_streamId_raw === void 0 ? void 0 : _g_streamId_raw.length)) {
                            const f = g.streamId.raw[0], S = this._participantMappingManager.findParticipantInfo(f);
                            var _S_participantId;
                            E = (_S_participantId = S === null || S === void 0 ? void 0 : S.participantId) !== null && _S_participantId !== void 0 ? _S_participantId : "", T = (S === null || S === void 0 ? void 0 : S.isComposedStream) ? "ComposedVideoStream" : "RemoteVideoStream";
                        }
                    }
                    if (Object.keys(_).length > 1) {
                        var _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameHeight, _this__call_mediaConstraintsManager_currentVideoConstraints_send, _this__call_mediaConstraintsManager_currentVideoConstraints, _this__call_mediaConstraintsManager_currentVideoConstraints_send_bitrate, _this__call_mediaConstraintsManager_currentVideoConstraints_send1, _this__call_mediaConstraintsManager_currentVideoConstraints1, _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameRate, _this__call_mediaConstraintsManager_currentVideoConstraints_send2, _this__call_mediaConstraintsManager_currentVideoConstraints2;
                        var _this__call_audioEffectsProcessorStats;
                        const f = {
                            mediaType: g.type,
                            mediaDirection: g.direction,
                            stats: _,
                            callId: this._tsCall.callId,
                            remoteParticipantId: E,
                            localParticipantId: this._tsCall.participantId,
                            videoStreamKind: T,
                            streamCount: S.length,
                            appliedFrameHeightMaxSentConstraint: (_this__call_mediaConstraintsManager_currentVideoConstraints = this._call.mediaConstraintsManager.currentVideoConstraints) === null || _this__call_mediaConstraintsManager_currentVideoConstraints === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send = _this__call_mediaConstraintsManager_currentVideoConstraints.send) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send_frameHeight = _this__call_mediaConstraintsManager_currentVideoConstraints_send.frameHeight) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameHeight === void 0 ? void 0 : _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameHeight.max,
                            appliedBitrateMaxSentConstraint: (_this__call_mediaConstraintsManager_currentVideoConstraints1 = this._call.mediaConstraintsManager.currentVideoConstraints) === null || _this__call_mediaConstraintsManager_currentVideoConstraints1 === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send1 = _this__call_mediaConstraintsManager_currentVideoConstraints1.send) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send1 === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send_bitrate = _this__call_mediaConstraintsManager_currentVideoConstraints_send1.bitrate) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send_bitrate === void 0 ? void 0 : _this__call_mediaConstraintsManager_currentVideoConstraints_send_bitrate.max,
                            appliedFrameRateMaxSentConstraint: (_this__call_mediaConstraintsManager_currentVideoConstraints2 = this._call.mediaConstraintsManager.currentVideoConstraints) === null || _this__call_mediaConstraintsManager_currentVideoConstraints2 === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send2 = _this__call_mediaConstraintsManager_currentVideoConstraints2.send) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send2 === void 0 ? void 0 : (_this__call_mediaConstraintsManager_currentVideoConstraints_send_frameRate = _this__call_mediaConstraintsManager_currentVideoConstraints_send2.frameRate) === null || _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameRate === void 0 ? void 0 : _this__call_mediaConstraintsManager_currentVideoConstraints_send_frameRate.max,
                            audioEffectsProcessorStats: (_this__call_audioEffectsProcessorStats = this._call.audioEffectsProcessorStats) !== null && _this__call_audioEffectsProcessorStats !== void 0 ? _this__call_audioEffectsProcessorStats : void 0
                        };
                        this._sendMidCallNewMediaStats(f);
                    }
                    if (f.dataToSend.raw && Object.keys(C).length > 1) {
                        const f = {
                            mediaType: g.type,
                            mediaDirection: g.direction,
                            stats: C,
                            callId: this._tsCall.callId,
                            remoteParticipantId: E,
                            localParticipantId: this._tsCall.participantId,
                            videoStreamKind: T,
                            streamCount: S.length
                        };
                        this._sendMidCallRawMediaStats(f);
                    }
                });
            });
        }
        _sendMidCallNewMediaStats(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_mid_call_new_media_stats,
                tenant: nf,
                properties: g
            });
        }
        _sendMidCallRawMediaStats(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_mid_call_raw_media_stats,
                tenant: nf,
                properties: g
            });
        }
        constructor(g, f, S, v){
            this._tsCall = g, this._call = f, this._telemetryLogManager = S, this._config = v, this._participantMappingManager = new ParticipantMappingManager(this._tsCall);
        }
    }
    function cloneReport() {
        return {
            transform: (g)=>P.cloneDeep(g)
        };
    }
    function transformStatsReport(g) {
        return {
            transform: (f)=>([
                    [
                        f.audio.send,
                        g.audio.send
                    ],
                    [
                        f.audio.receive,
                        g.audio.receive
                    ],
                    [
                        f.video.send,
                        g.video.send
                    ],
                    [
                        f.video.receive,
                        g.video.receive
                    ],
                    [
                        f.screenShare.send,
                        g.screenShare.send
                    ],
                    [
                        f.screenShare.receive,
                        g.screenShare.receive
                    ],
                    [
                        f.dataChannel,
                        g.dataChannel
                    ],
                    [
                        f.transports,
                        g.transports
                    ],
                    [
                        f.info,
                        g.info
                    ]
                ].forEach((g)=>{
                    const f = g[0], S = g[1];
                    P.forEach(S, (g, S)=>{
                        !0 !== g.disabled && P.forEach(f, (f)=>{
                            let v = f[g.source];
                            void 0 !== v && (void 0 !== g.multiplier && "number" == typeof v && (v *= g.multiplier), g.integer && (v = P.toInteger(v)), f[S] = v);
                        });
                    });
                }), f)
        };
    }
    function blockMetrics(g) {
        const f = [
            "audio.send",
            "audio.receive",
            "video.send",
            "video.receive",
            "screenShare.send",
            "screenShare.receive",
            "dataChannel",
            "transports",
            "info"
        ];
        return {
            transform: (S)=>(P.forEach(f, (f)=>{
                    const v = P.get(S, f), _ = P.get(g, f, []);
                    P.forEach(v, (g)=>{
                        _.forEach((f)=>{
                            "id" !== f && delete g[f];
                        });
                    });
                }), S)
        };
    }
    function filterMetricsByRangeLimit(g, f) {
        return {
            transform: (S)=>{
                var _S_metadata;
                const v = (_S_metadata = S.metadata) === null || _S_metadata === void 0 ? void 0 : _S_metadata.delayRatio, _ = g > 0 && void 0 !== v && v > g;
                return P.forEach(f, (g, f)=>{
                    const v = P.get(S, f);
                    P.forEach(v, (f)=>{
                        P.forEach(g, (g, S)=>{
                            if (_) delete f[S];
                            else {
                                const v = f[S];
                                (void 0 !== g.max && v > g.max || void 0 !== g.min && v < g.min || P.isNaN(v)) && delete f[S];
                            }
                        });
                    });
                }), S;
            }
        };
    }
    const EE = {
        codecName: {},
        bitrate: {
            aggregable: !0
        },
        jitterInMs: {
            aggregable: !0
        },
        packets: {},
        packetsPerSecond: {
            aggregable: !0
        },
        packetsLost: {},
        packetsLostPerSecond: {
            aggregable: !0
        },
        rttInMs: {
            aggregable: !0
        },
        frameRateInput: {
            aggregable: !0
        },
        frameWidthInput: {
            aggregable: !0
        },
        frameHeightInput: {
            aggregable: !0
        },
        framesEncoded: {},
        frameRateEncoded: {
            aggregable: !0
        },
        framesSent: {},
        frameRateSent: {
            aggregable: !0
        },
        frameWidthSent: {
            aggregable: !0
        },
        frameHeightSent: {
            aggregable: !0
        },
        keyFramesEncoded: {},
        transportId: {}
    }, TE = {
        codecName: {},
        bitrate: {
            aggregable: !0
        },
        jitterInMs: {
            aggregable: !0
        },
        packets: {},
        packetsPerSecond: {
            aggregable: !0
        },
        packetsLost: {},
        packetsLostPerSecond: {
            aggregable: !0
        },
        rttInMs: {
            aggregable: !0
        },
        streamId: {},
        jitterBufferDelayInMs: {
            aggregable: !0
        },
        frameRateDecoded: {
            aggregable: !0
        },
        frameRateReceived: {
            aggregable: !0
        },
        frameWidthReceived: {
            aggregable: !0
        },
        frameHeightReceived: {
            aggregable: !0
        },
        longestFreezeDurationInMs: {},
        totalFreezeDurationInMs: {},
        framesReceived: {},
        framesDropped: {},
        framesDecoded: {},
        keyFramesDecoded: {},
        transportId: {}
    }, IE = {
        audio: {
            send: {
                codecName: {},
                bitrate: {
                    aggregable: !0
                },
                jitterInMs: {
                    aggregable: !0
                },
                packets: {},
                packetsPerSecond: {
                    aggregable: !0
                },
                packetsLost: {},
                packetsLostPerSecond: {
                    aggregable: !0
                },
                rttInMs: {
                    aggregable: !0
                },
                audioInputLevel: {
                    aggregable: !0
                },
                transportId: {}
            },
            receive: {
                codecName: {},
                bitrate: {
                    aggregable: !0
                },
                jitterInMs: {
                    aggregable: !0
                },
                packets: {},
                packetsPerSecond: {
                    aggregable: !0
                },
                packetsLost: {},
                packetsLostPerSecond: {
                    aggregable: !0
                },
                rttInMs: {
                    aggregable: !0
                },
                jitterBufferDelayInMs: {
                    aggregable: !0
                },
                audioOutputLevel: {
                    aggregable: !0
                },
                healedRatio: {
                    aggregable: !0
                },
                transportId: {}
            }
        },
        video: {
            send: EE,
            receive: TE
        },
        screenShare: {
            send: EE,
            receive: TE
        },
        dataChannel: {
            incomingBitrate: {
                aggregable: !0
            },
            outgoingBitrate: {
                aggregable: !0
            },
            messagesSentPerSecond: {
                aggregable: !0
            },
            messagesReceivedPerSecond: {
                aggregable: !0
            }
        },
        transports: {
            rttInMs: {
                aggregable: !0
            },
            availableIncomingBitrate: {
                aggregable: !0
            },
            availableOutgoingBitrate: {
                aggregable: !0
            }
        },
        info: {}
    }, bE = {
        codecName: {
            raw_data_reduction: !0
        },
        packets: {
            raw_data_reduction: !0
        },
        packetsLost: {
            raw_data_reduction: !0
        },
        framesEncoded: {
            raw_data_reduction: !0
        },
        framesSent: {
            raw_data_reduction: !0
        },
        keyFramesEncoded: {
            raw_data_reduction: !0
        },
        pairRttInMs: {
            aggregable: !0
        },
        availableBitrate: {
            aggregable: !0
        },
        transportId: {
            skip: !0
        },
        groupId: {
            raw_data_reduction: !0
        }
    }, AE = {
        codecName: {
            raw_data_reduction: !0
        },
        streamId: {
            raw_data_reduction: !0
        },
        packets: {
            raw_data_reduction: !0
        },
        packetsLost: {
            raw_data_reduction: !0
        },
        jitterBufferDelayInMs: {
            output_key: "jitterBufferInMs"
        },
        longestFreezeDurationInMs: {
            skip: !0
        },
        totalFreezeDurationInMs: {
            raw_data_reduction: !0
        },
        framesReceived: {
            raw_data_reduction: !0
        },
        framesDropped: {
            raw_data_reduction: !0
        },
        framesDecoded: {
            raw_data_reduction: !0
        },
        keyFramesDecoded: {
            raw_data_reduction: !0
        },
        pairRttInMs: {
            aggregable: !0
        },
        availableBitrate: {
            aggregable: !0
        },
        transportId: {
            skip: !0
        }
    }, RE = {
        audio: {
            send: {
                codecName: {
                    raw_data_reduction: !0
                },
                packets: {
                    raw_data_reduction: !0
                },
                packetsLost: {
                    raw_data_reduction: !0
                },
                pairRttInMs: {
                    aggregable: !0
                },
                availableBitrate: {
                    aggregable: !0
                },
                transportId: {
                    skip: !0
                }
            },
            receive: {
                codecName: {
                    raw_data_reduction: !0
                },
                packets: {
                    raw_data_reduction: !0
                },
                packetsLost: {
                    raw_data_reduction: !0
                },
                jitterBufferDelayInMs: {
                    output_key: "jitterBufferInMs"
                },
                pairRttInMs: {
                    aggregable: !0
                },
                availableBitrate: {
                    aggregable: !0
                },
                transportId: {
                    skip: !0
                }
            }
        },
        video: {
            send: bE,
            receive: AE
        },
        screenShare: {
            send: bE,
            receive: AE
        },
        dataChannel: {
            state: {
                raw_data_reduction: !0
            },
            dataChannelIdentifier: {
                raw_data_reduction: !0
            },
            messagesSent: {
                raw_data_reduction: !0
            },
            bytesSent: {
                raw_data_reduction: !0
            },
            messagesReceived: {
                raw_data_reduction: !0
            },
            bytesReceived: {
                raw_data_reduction: !0
            }
        },
        transports: {
            candidateType: {
                events: !0
            },
            relayProtocol: {
                events: !0
            }
        },
        info: {
            networkInfoDownlink: {
                aggregable: !0
            },
            networkInfoRttInMs: {
                aggregable: !0
            },
            totalJSHeapSize: {
                aggregable: !0
            },
            usedJSHeapSize: {
                aggregable: !0
            },
            jsHeapSizeLimit: {
                aggregable: !0
            },
            jsSize: {
                aggregable: !0
            },
            sharedSize: {
                aggregable: !0
            },
            domSize: {
                aggregable: !0
            },
            batteryCharging: {
                aggregable: !0
            },
            batteryLevel: {
                aggregable: !0
            },
            cpuPressureLevel: {
                aggregable: !0
            },
            audioLeak: {
                aggregable: !0
            },
            videoLeak: {
                aggregable: !0
            }
        }
    }, PE = {
        multiplier: 1e3,
        integer: !0,
        source: "jitter"
    }, wE = {
        multiplier: 1e3,
        integer: !0,
        source: "rtt"
    }, ME = {
        integer: !0,
        source: "jitterBufferMs"
    }, OE = {
        jitterInMs: PE,
        rttInMs: wE
    }, DE = {
        jitterInMs: PE,
        rttInMs: wE,
        jitterBufferDelayInMs: ME,
        streamId: {
            source: "msi"
        },
        longestFreezeDurationInMs: {
            multiplier: 1e3,
            integer: !0,
            source: "longestFreezeDuration"
        },
        totalFreezeDurationInMs: {
            multiplier: 1e3,
            integer: !0,
            source: "totalFreezeDuration"
        }
    }, NE = {
        audio: {
            send: {
                jitterInMs: PE,
                rttInMs: wE,
                audioInputLevel: {
                    multiplier: 65536,
                    integer: !0,
                    source: "audioLevel"
                }
            },
            receive: {
                jitterInMs: PE,
                rttInMs: wE,
                jitterBufferDelayInMs: ME,
                audioOutputLevel: {
                    multiplier: 65536,
                    integer: !0,
                    source: "audioLevel"
                }
            }
        },
        video: {
            send: OE,
            receive: DE
        },
        screenShare: {
            send: OE,
            receive: DE
        },
        dataChannel: {
            incomingBitrate: {
                source: "recvBitrate"
            },
            outgoingBitrate: {
                source: "sendBitrate"
            }
        },
        transports: {
            rttInMs: wE
        },
        info: {
            networkInfoDownlink: {
                multiplier: 1e3,
                integer: !0,
                source: "networkInfoDownlink"
            }
        }
    };
    class MediaStatsManager {
        createCollector(g) {
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.FEATURES.MEDIA_STATS.DISPOSED
            });
            var _g_aggregationInterval, _g_dataPointsPerAggregation;
            const f = this._config, S = new MediaStatsCollectorImpl(this._logger, {
                aggregationInterval: (_g_aggregationInterval = g === null || g === void 0 ? void 0 : g.aggregationInterval) !== null && _g_aggregationInterval !== void 0 ? _g_aggregationInterval : f.aggregationInterval,
                dataPointsPerAggregation: (_g_dataPointsPerAggregation = g === null || g === void 0 ? void 0 : g.dataPointsPerAggregation) !== null && _g_dataPointsPerAggregation !== void 0 ? _g_dataPointsPerAggregation : f.dataPointsPerAggregation,
                metricsPropertics: IE
            });
            return this._collectorsSourceNode.addSink(S), S;
        }
        dispose() {
            this._disposed || (this._disposed = !0, this._statsPoller.off("data", this._dataEventListener), this._statsPoller.dispose(), this._mediaStatsSourceNode.stop(), this._callStateChangedHandle.dispose());
        }
        constructor(g, f, S, v){
            this._tsCall = g, this._call = f, this._logger = S, this._disposed = !1;
            const _ = getAcsEcsConfig();
            this._config = _.mediaStats, this._statsPoller = new MediaStatsPoller(f, this._logger, _);
            const C = [
                transformStatsReport(P.merge(P.cloneDeep(NE), this._config.transformMetrics))
            ];
            this._config.timerThrottlingFilter.enabled && C.push(filterMetricsByRangeLimit(this._config.timerThrottlingFilter.delayRatio, this._config.timerThrottlingFilter.filterRange)), this._mediaStatsSourceNode = new MediaStatsReportSourceNode(C);
            const E = this._config.activeState;
            this._isCallActive = E.includes(this._tsCall.state), this._callStateChangedHandle = this._tsCall.on("callStateChanged", ()=>{
                const g = E.includes(this._tsCall.state);
                this._isCallActive !== g && (this._isCallActive = g, g ? this._mediaStatsSourceNode.resume() : this._mediaStatsSourceNode.pause());
            });
            const T = this._config.blockMetrics;
            if (Object.keys(T).length > 0) {
                const g = new MediaStatsReportFilterNode([
                    cloneReport(),
                    blockMetrics(T)
                ]);
                this._mediaStatsSourceNode.addSink(g), this._collectorsSourceNode = g;
            } else this._collectorsSourceNode = this._mediaStatsSourceNode;
            const I = _.telemetry.mediaStatsConfig;
            if (I.enabled) {
                const g = new MediaStatsTelemetryLogger(this._tsCall, this._call, v, _), f = P.merge(P.cloneDeep(IE), RE, I.metricsProperties), S = new TelemetryCollector(this._logger, {
                    aggregationInterval: I.aggregationInterval,
                    dataPointsPerAggregation: I.dataPointsPerAggregation,
                    metricsPropertics: f
                });
                S.on("data", (f)=>g.log(f)), this._mediaStatsSourceNode.addSink(S);
            }
            this._isCallActive ? this._mediaStatsSourceNode.resume() : this._mediaStatsSourceNode.pause(), this._dataEventListener = (g)=>{
                this._mediaStatsSourceNode.onReport(g);
            }, this._statsPoller.on("data", this._dataEventListener);
        }
    }
    class MediaStatsCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "MediaStats";
        }
        createCollector(g) {
            this._sendFeatureUsage("createCollector", uy.attempt);
            const f = this._statsManager.createCollector(g);
            return this._sendFeatureUsage("creaetCollector", uy.success), f;
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._statsManager = new MediaStatsManager(g.tsCall, this._call, this._logger, this._telemetryLogManager), this._sendFeatureUsage("initialize", uy.initialize);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "MediaStats",
                featureType: "Call",
                initializationType: "OnExtendedObjectConstructor",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._statsManager.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g);
        }
    }
    var kE, LE;
    (kE = g.RecordingState || (g.RecordingState = {}))[kE.None = 0] = "None", kE[kE.Started = 1] = "Started", kE[kE.Paused = 2] = "Paused", kE[kE.Ended = 3] = "Ended";
    class RecordingCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "Recording";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g.tsCall, f, this._callInfo, this._call), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get isRecordingActive() {
            return this._sendFeatureUsage("isRecordingActive", uy.getter), this._impl.isRecordingActive;
        }
        get recordings() {
            return this._sendFeatureUsage("recordings", uy.getter), this._impl.recordings;
        }
        on(g, f) {
            if ("isRecordingActiveChanged" !== g && "recordingsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.RECORDING.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("isRecordingActiveChanged" !== g && "recordingsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.RECORDING.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        get isTeamsConsentRequired() {
            return this._sendFeatureUsage("isTeamsConsentRequired", uy.getter), this._impl.isTeamsConsentRequired;
        }
        grantTeamsConsent() {
            return this._sendFeatureUsage("ConsentForRecording", uy.attempt), this._impl.grantTeamsConsent().then(()=>{
                this._sendFeatureUsage("ConsentForRecording", uy.success);
            }).catch((g)=>{
                throw this._sendFeatureUsage("ConsentForRecording", uy.failure, g), g;
            });
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? extractCommunicationServicesErrorForTelemetry(S) : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "Recording",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g), this._callInfo = g.callInfo, this._impl = new RecordingCallImplOverTsCall(this.eventEmitter);
        }
    }
    class RecordingCallImplOverTsCall {
        get isRecordingActive() {
            return this._isRecordingActive;
        }
        get recordings() {
            return Array.from(this._recordingBots.values()).map((g)=>g === null || g === void 0 ? void 0 : g.recordingInfo).filter((g)=>!!g);
        }
        initialize(g, f, S, v) {
            this._logger = f.createChild(()=>`RecordingFeature::Call(id='${g.callId}', state='${g.state}')`), this._callInfo = S, this._call = v, g.on("callStateChanged", async ()=>{
                3 === g.state && this._initInitiatorMap(g);
            }), g.participants.forEach((g)=>{
                isCallingApplication(g.id) && this._handleRecordingBotAdded(g);
            }), g.on("participantAdded", async (g)=>{
                isCallingApplication(g.id) ? this._handleRecordingBotAdded(g) : void 0 === g || this._recordingInitiatorMap.has(g.id) || this._recordingInitiatorMap.set(g.id, g.displayName);
            }), g.on("participantRemoved", async (g)=>{
                isCallingApplication(g.id) ? this._handleRecordingBotRemoved(g) : void 0 !== g && this._recordingInitiatorMap.has(g.id) && this._recordingInitiatorMap.delete(g.id);
            }), g.on("participantUpdated", async (g)=>{
                void 0 !== g && this._recordingInitiatorMap.has(g.id) && this._recordingInitiatorMap.set(g.id, g.displayName);
            });
        }
        get isTeamsConsentRequired() {
            return this._call.explicitConsentStateImp.isConsentRequiredInCall();
        }
        dispose() {
            let g = this._updateIsCallRecorded(!1), f = Array.from(this._recordingBots.values());
            f.forEach((g)=>{
                var _g_recordingInfo;
                return g === null || g === void 0 ? void 0 : (_g_recordingInfo = g.recordingInfo) === null || _g_recordingInfo === void 0 ? void 0 : _g_recordingInfo.dispose();
            }), this._sendEvents(void 0, void 0, f, g);
        }
        _initInitiatorMap(g) {
            const { participants: f } = g;
            [
                ...f
            ].forEach((g)=>{
                isCallingApplication(g.id) || this._recordingInitiatorMap.set(g.id, g.displayName);
            });
        }
        constructor(g){
            this._eventEmitter = g, this._recordingBots = new Map, this._recordingBotChangedSubs = new WeakMap, this._recordingInitiatorMap = new Map, this._isRecordingActive = !1, this.grantTeamsConsent = async ()=>(this._logger.info("Attempting to set consent for recording"), this._call.explicitConsentStateImp.consent(this._callInfo).catch((g)=>{
                    throw this._logger.error("Consent failure to set publish state for user"), handlePublishStateFailure(g, O.FEATURES.RECORDING.RECORDING_CONSENT_FAILURE);
                })), this._updateIsCallRecorded = (g)=>this._isRecordingActive !== g && (this._isRecordingActive = g, this._logger.info(`Updating isCallRecorded to ${g}`), !0), this._handleRecordingBotAdded = (g)=>{
                const handleRecordingBotChanged = ()=>{
                    let f, S = !1, v = !1;
                    if (this._hasRecordingState(g)) {
                        if (this._recordingBots.has(g.id)) {
                            let S = this._getRecordingBotEndpoint(g);
                            if (f = this._recordingBots.get(g.id), S && f) {
                                var _f_recordingInfo;
                                f.endpoint = S;
                                let g = S.userId ? this._recordingInitiatorMap.get(S.userId) : void 0;
                                var _f_recordingInfo_update;
                                v = (_f_recordingInfo_update = (_f_recordingInfo = f.recordingInfo) === null || _f_recordingInfo === void 0 ? void 0 : _f_recordingInfo.update(S, g)) !== null && _f_recordingInfo_update !== void 0 ? _f_recordingInfo_update : !1;
                            }
                        } else f = this._getRecordingBotInfo(g), f && (this._logger.info("Adding recording bot"), this._recordingBots.set(g.id, f), S = !0);
                        this._sendEvents(v ? [
                            f
                        ] : void 0, S ? [
                            f
                        ] : void 0, void 0, this._updateIsCallRecorded(this._isRecordingEnabled()));
                    }
                };
                handleRecordingBotChanged(), this._recordingBotChangedSubs.set(g, g.changed(handleRecordingBotChanged));
            }, this._handleRecordingBotRemoved = (g)=>{
                var _this__recordingBotChangedSubs_get, _f_endpoint, _f_recordingInfo;
                let f = this._recordingBots.get(g.id);
                this._recordingBots.delete(g.id), (_this__recordingBotChangedSubs_get = this._recordingBotChangedSubs.get(g)) === null || _this__recordingBotChangedSubs_get === void 0 ? void 0 : _this__recordingBotChangedSubs_get.dispose(), this._recordingBotChangedSubs.delete(g), this._logger.info(`Updating recordingState to ${f === null || f === void 0 ? void 0 : (_f_endpoint = f.endpoint) === null || _f_endpoint === void 0 ? void 0 : _f_endpoint.state}`), f === null || f === void 0 ? void 0 : (_f_recordingInfo = f.recordingInfo) === null || _f_recordingInfo === void 0 ? void 0 : _f_recordingInfo.dispose(), this._sendEvents([
                    f
                ], void 0, [
                    f
                ], this._updateIsCallRecorded(this._isRecordingEnabled()));
            }, this._sendEvents = (g, f, S, v)=>{
                g && g.forEach((g)=>{
                    var _g_recordingInfo;
                    return g === null || g === void 0 ? void 0 : (_g_recordingInfo = g.recordingInfo) === null || _g_recordingInfo === void 0 ? void 0 : _g_recordingInfo.sendRecordingStateChanged();
                });
                let _ = !!f && f.length > 0, C = !!S && S.length > 0;
                (_ || C) && this._eventEmitter.emit("recordingsUpdated", {
                    added: this._getRecordingInfos(f),
                    removed: this._getRecordingInfos(S)
                }), v && this._eventEmitter.emit("isRecordingActiveChanged");
            }, this._hasRecordingState = (g)=>{
                var _g_endpoints_endpointDetails, _g_endpoints;
                var _g_endpoints_endpointDetails_some;
                return (_g_endpoints_endpointDetails_some = g === null || g === void 0 ? void 0 : (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.some((g)=>{
                    var _g_endpointMetadata___platform_recording_compliance, _g_endpointMetadata___platform_recording, _g_endpointMetadata___platform, _g_endpointMetadata, _g_endpointMetadata_processingModes_recording, _g_endpointMetadata_processingModes, _g_endpointMetadata1;
                    return !!(g === null || g === void 0 ? void 0 : (_g_endpointMetadata = g.endpointMetadata) === null || _g_endpointMetadata === void 0 ? void 0 : (_g_endpointMetadata___platform = _g_endpointMetadata.__platform) === null || _g_endpointMetadata___platform === void 0 ? void 0 : (_g_endpointMetadata___platform_recording = _g_endpointMetadata___platform.recording) === null || _g_endpointMetadata___platform_recording === void 0 ? void 0 : (_g_endpointMetadata___platform_recording_compliance = _g_endpointMetadata___platform_recording.compliance) === null || _g_endpointMetadata___platform_recording_compliance === void 0 ? void 0 : _g_endpointMetadata___platform_recording_compliance.state) || !!(g === null || g === void 0 ? void 0 : (_g_endpointMetadata1 = g.endpointMetadata) === null || _g_endpointMetadata1 === void 0 ? void 0 : (_g_endpointMetadata_processingModes = _g_endpointMetadata1.processingModes) === null || _g_endpointMetadata_processingModes === void 0 ? void 0 : (_g_endpointMetadata_processingModes_recording = _g_endpointMetadata_processingModes.recording) === null || _g_endpointMetadata_processingModes_recording === void 0 ? void 0 : _g_endpointMetadata_processingModes_recording.state);
                })) !== null && _g_endpoints_endpointDetails_some !== void 0 ? _g_endpoints_endpointDetails_some : !1;
            }, this._getRecordingInfos = (g)=>{
                if (g) return g.map((g)=>g === null || g === void 0 ? void 0 : g.recordingInfo).filter((g)=>!!g);
            }, this._isRecordingEnabled = ()=>{
                let g = !1;
                try {
                    this._recordingBots.forEach((f)=>{
                        var _f_endpoint;
                        g || (g = "Active" === (f === null || f === void 0 ? void 0 : (_f_endpoint = f.endpoint) === null || _f_endpoint === void 0 ? void 0 : _f_endpoint.state));
                    });
                } catch (g) {
                    this._logger.info("Unable to read recording state: ", g);
                }
                return g;
            }, this._getRecordingInfoImpl = (g)=>{
                if (null == g) return;
                if ("Active" !== g.state && "Inactive" !== g.state) return;
                let f;
                return void 0 !== g.userId && (f = this._recordingInitiatorMap.get(g.userId)), new RecordingInfoImpl(g.state, this._eventEmitter, f);
            }, this._getRecordingBotInfo = (g)=>{
                let f = this._getRecordingBotEndpoint(g);
                return f ? {
                    endpoint: f,
                    recordingInfo: this._getRecordingInfoImpl(f)
                } : void 0;
            }, this._getRecordingBotEndpoint = (g)=>{
                var _g_endpoints;
                let f = (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails.map((g)=>{
                    var _g_endpointMetadata___platform_recording_compliance, _g_endpointMetadata___platform_recording, _g_endpointMetadata___platform, _g_endpointMetadata, _g_endpointMetadata___platform_recording_compliance1, _g_endpointMetadata___platform_recording1, _g_endpointMetadata___platform1, _g_endpointMetadata1, _g_endpointMetadata_processingModes_recording, _g_endpointMetadata_processingModes, _g_endpointMetadata2, _g_endpointMetadata_processingModes_recording1, _g_endpointMetadata_processingModes1, _g_endpointMetadata3;
                    let f = g === null || g === void 0 ? void 0 : (_g_endpointMetadata = g.endpointMetadata) === null || _g_endpointMetadata === void 0 ? void 0 : (_g_endpointMetadata___platform = _g_endpointMetadata.__platform) === null || _g_endpointMetadata___platform === void 0 ? void 0 : (_g_endpointMetadata___platform_recording = _g_endpointMetadata___platform.recording) === null || _g_endpointMetadata___platform_recording === void 0 ? void 0 : (_g_endpointMetadata___platform_recording_compliance = _g_endpointMetadata___platform_recording.compliance) === null || _g_endpointMetadata___platform_recording_compliance === void 0 ? void 0 : _g_endpointMetadata___platform_recording_compliance.state, S = g === null || g === void 0 ? void 0 : (_g_endpointMetadata1 = g.endpointMetadata) === null || _g_endpointMetadata1 === void 0 ? void 0 : (_g_endpointMetadata___platform1 = _g_endpointMetadata1.__platform) === null || _g_endpointMetadata___platform1 === void 0 ? void 0 : (_g_endpointMetadata___platform_recording1 = _g_endpointMetadata___platform1.recording) === null || _g_endpointMetadata___platform_recording1 === void 0 ? void 0 : (_g_endpointMetadata___platform_recording_compliance1 = _g_endpointMetadata___platform_recording1.compliance) === null || _g_endpointMetadata___platform_recording_compliance1 === void 0 ? void 0 : _g_endpointMetadata___platform_recording_compliance1.userId, v = g === null || g === void 0 ? void 0 : (_g_endpointMetadata2 = g.endpointMetadata) === null || _g_endpointMetadata2 === void 0 ? void 0 : (_g_endpointMetadata_processingModes = _g_endpointMetadata2.processingModes) === null || _g_endpointMetadata_processingModes === void 0 ? void 0 : (_g_endpointMetadata_processingModes_recording = _g_endpointMetadata_processingModes.recording) === null || _g_endpointMetadata_processingModes_recording === void 0 ? void 0 : _g_endpointMetadata_processingModes_recording.state, _ = g === null || g === void 0 ? void 0 : (_g_endpointMetadata3 = g.endpointMetadata) === null || _g_endpointMetadata3 === void 0 ? void 0 : (_g_endpointMetadata_processingModes1 = _g_endpointMetadata3.processingModes) === null || _g_endpointMetadata_processingModes1 === void 0 ? void 0 : (_g_endpointMetadata_processingModes_recording1 = _g_endpointMetadata_processingModes1.recording) === null || _g_endpointMetadata_processingModes_recording1 === void 0 ? void 0 : _g_endpointMetadata_processingModes_recording1.userId;
                    if (f || v) return {
                        state: f !== null && f !== void 0 ? f : v,
                        userId: S !== null && S !== void 0 ? S : _
                    };
                }).filter((g)=>null != g);
                if (f && 0 != f.length) return f.length > 1 && this._logger.log(`Unexpected: multiple recording endpoints: ${f === null || f === void 0 ? void 0 : f.map((g)=>{
                    var _g_state;
                    return (_g_state = g === null || g === void 0 ? void 0 : g.state) !== null && _g_state !== void 0 ? _g_state : "undefined";
                }).join(", ")}`), f[0];
            };
        }
    }
    class RecordingInfoImpl {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        update(g, f) {
            if (null == g) return !1;
            let S = this.getRecordingState(g.state);
            return S != this.state && (this.state = S, void 0 !== f && (this.displayName = f), !0);
        }
        dispose() {
            this.state = g.RecordingState.Ended;
        }
        sendRecordingStateChanged() {
            this._eventEmitter.emit("recordingStateChanged");
        }
        getRecordingState(f) {
            let S = g.RecordingState.None;
            switch(f === null || f === void 0 ? void 0 : f.toLocaleLowerCase()){
                case "active":
                    S = g.RecordingState.Started;
                    break;
                case "inactive":
                    S = g.RecordingState.Paused;
                    break;
                default:
                    S = g.RecordingState.None;
            }
            return S;
        }
        constructor(g, f, S){
            this.state = this.getRecordingState(g), this._eventEmitter = f, this.displayName = S;
        }
    }
    (LE = g.LocalRecordingState || (g.LocalRecordingState = {}))[LE.None = 0] = "None", LE[LE.Started = 1] = "Started", LE[LE.Ended = 2] = "Ended";
    const FE = {
        ACTIVE: "active",
        INACTIVE: "inactive"
    };
    class LocalRecordingCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "LocalRecording";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g.tsCall, g.telemetryLogManager, f), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get isRecordingActive() {
            return this._sendFeatureUsage("isRecordingActive", uy.getter), this._impl.isRecordingActive;
        }
        get recordings() {
            return this._sendFeatureUsage("recordings", uy.getter), this._impl.recordings;
        }
        on(g, f) {
            if ("isLocalRecordingActiveChanged" !== g && "localRecordingsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.RECORDING.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("isLocalRecordingActiveChanged" !== g && "localRecordingsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.RECORDING.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? {
                code: (S === null || S === void 0 ? void 0 : S.code) || x,
                subCode: (S === null || S === void 0 ? void 0 : S.subCode) || 0,
                failureReason: (S === null || S === void 0 ? void 0 : S.message) || ""
            } : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "LocalRecording",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new LocalRecordingCallImplOverTsCall(this.eventEmitter);
        }
    }
    class LocalRecordingCallImplOverTsCall {
        get isRecordingActive() {
            return this._localRecordingInitiators.size > 0;
        }
        get recordings() {
            return Array.from(this._localRecordingInitiators.values());
        }
        initialize(g, f, S) {
            if (this._logger = S.createChild(()=>`LocalRecordingFeature::Call(id='${g.callId}', state='${g.state}')`), !this._isEnabled) {
                const g = "Local Recording feature is is disabled", f = new CallingCommunicationError({
                    defaultError: O.FEATURES.LOCAL_RECORDING.DISABLED
                });
                throw this._logger.error(g), f;
            }
            g.on("callStateChanged", async ()=>{
                if (3 === g.state) {
                    if (!this._supportedConversationTypes.includes(g.conversationType)) {
                        const g = "Local Recording feature is only available in meetings", f = new CallingCommunicationError({
                            defaultError: O.FEATURES.LOCAL_RECORDING.ONLY_AVAILABLE_IN_MEETINGS
                        });
                        throw this._logger.error(g), f;
                    }
                    this.initLocalRecordingStatus(g);
                }
            }), g.on("participantUpdated", (f)=>{
                var _f_endpoints;
                return this._onParticipantUpdatedEvent(g, f, (_f_endpoints = f.endpoints) === null || _f_endpoints === void 0 ? void 0 : _f_endpoints.endpointDetails);
            });
        }
        dispose() {
            let g = this._localRecordingInitiators.size > 0, f = Array.from(this._localRecordingInitiators.values());
            f.forEach((g)=>g === null || g === void 0 ? void 0 : g.dispose()), g && (g = 0 == this._localRecordingInitiators.size), this._sendEvents(void 0, f, g);
        }
        hasOngoingLocalRecording(g) {
            return (g === null || g === void 0 ? void 0 : g.some((g)=>{
                var _g_propertyBag_localRecording_value, _g_propertyBag_localRecording, _g_propertyBag;
                return (((_g_propertyBag = g.propertyBag) === null || _g_propertyBag === void 0 ? void 0 : (_g_propertyBag_localRecording = _g_propertyBag.localRecording) === null || _g_propertyBag_localRecording === void 0 ? void 0 : (_g_propertyBag_localRecording_value = _g_propertyBag_localRecording.value) === null || _g_propertyBag_localRecording_value === void 0 ? void 0 : _g_propertyBag_localRecording_value.state) || "") === FE.ACTIVE;
            })) || !1;
        }
        initLocalRecordingStatus(g) {
            const { participants: f } = g, S = [
                ...f
            ];
            this._localRecordingInitiators = new Map(S.filter((g)=>{
                var _g_endpoints;
                return this.hasOngoingLocalRecording((_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails);
            }).map((g)=>[
                    g.id,
                    this._getLocalRecordingInfo(g)
                ]));
        }
        _onParticipantUpdatedEvent(g, f, S) {
            f ? isCallingApplication(f.id) || (this.hasOngoingLocalRecording(S) ? this._tryAddLocalRecordingInitiator(g, f) : this._tryRemoveLocalRecordingInitiator(g, f)) : this._logger.error(`Empty participant, skip update event processing. CallId: ${g.callId}`);
        }
        _tryAddLocalRecordingInitiator(g, f) {
            const { callId: S } = g;
            if (!this._localRecordingInitiators.has(f.id)) {
                this._logger.info(`Add local recording participant: ${f.id}, callId: ${S}`);
                let g = this._getLocalRecordingInfo(f);
                this._localRecordingInitiators.set(f.id, g), this._sendEvents([
                    g
                ], void 0, 1 == this._localRecordingInitiators.size);
            }
        }
        _tryRemoveLocalRecordingInitiator(g, f) {
            const { callId: S } = g;
            if (this._localRecordingInitiators.has(f.id)) {
                this._logger.info(`Remove local recording participant: ${f.id}, callId: ${S}`);
                let g = this._localRecordingInitiators.get(f.id);
                g.update(FE.INACTIVE), this._localRecordingInitiators.delete(f.id), this._sendEvents(void 0, [
                    g
                ], 0 == this._localRecordingInitiators.size);
            }
        }
        _getLocalRecordingInfo(g) {
            let f = g.displayName;
            return new LocalRecordingInfoImpl(FE.ACTIVE, f);
        }
        constructor(g){
            this._eventEmitter = g, this._localRecordingInitiators = new Map, this._sendEvents = (g, f, S)=>{
                let v = !!g && g.length > 0, _ = !!f && f.length > 0;
                (v || _) && this._eventEmitter.emit("localRecordingsUpdated", {
                    added: g,
                    removed: f
                }), S && this._eventEmitter.emit("isLocalRecordingActiveChanged");
            }, this._isEnabled = getAcsEcsConfig().calling.localRecording.enabled, this._supportedConversationTypes = getAcsEcsConfig().calling.localRecording.supportedConversationTypes;
        }
    }
    class LocalRecordingInfoImpl {
        update(g) {
            let f = this.getRecordingState(g);
            return f != this.state && (this.state = f, !0);
        }
        dispose() {
            this.state = g.LocalRecordingState.Ended;
        }
        getRecordingState(f) {
            let S = g.LocalRecordingState.None;
            switch(f === null || f === void 0 ? void 0 : f.toLocaleLowerCase()){
                case "active":
                    S = g.LocalRecordingState.Started;
                    break;
                case "inactive":
                    S = g.LocalRecordingState.Ended;
                    break;
                default:
                    S = g.LocalRecordingState.None;
            }
            return S;
        }
        constructor(g, f){
            this.state = this.getRecordingState(g), this.displayName = f;
        }
    }
    class TranscriptionCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "Transcription";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g.tsCall, f, this._callInfo, this._call), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get isTranscriptionActive() {
            return this._sendFeatureUsage("isTranscriptionActive", uy.getter), this._impl.isTranscriptionActive;
        }
        get isTeamsConsentRequired() {
            return this._sendFeatureUsage("isTeamsConsentRequired", uy.getter), this._impl.isTeamsConsentRequired;
        }
        grantTeamsConsent() {
            return this._sendFeatureUsage("ConsentForTranscription", uy.attempt), this._impl.grantTeamsConsent().then(()=>{
                this._sendFeatureUsage("ConsentForTranscription", uy.success);
            }).catch((g)=>{
                throw this._sendFeatureUsage("ConsentForTranscription", uy.failure, g), g;
            });
        }
        on(g, f) {
            this._sendFeatureUsage("isTranscriptionActiveChanged", uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage("isTranscriptionActiveChanged", uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? extractCommunicationServicesErrorForTelemetry(S) : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "Transcription",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g), this._impl = new TranscriptionCallImplOverTsCall(this.eventEmitter), this._callInfo = g.callInfo;
        }
    }
    class TranscriptionCallImplOverTsCall {
        get isTranscriptionActive() {
            return this._isTranscriptionActive;
        }
        initialize(g, f, S, v) {
            this._logger = f.createChild(()=>`TranscriptionFeature::Call(id='${g.callId}', state='${g.state}')`), this._callInfo = S, this._call = v, g.on("participantAdded", (g)=>{
                this._isCallingApplication(g) && this._handleBotAdded(g);
            }), g.participants.forEach((g)=>{
                this._isCallingApplication(g) && this._handleBotAdded(g);
            }), g.on("participantRemoved", (g)=>{
                this._isCallingApplication(g) && this._handleBotRemoved(g);
            });
        }
        get isTeamsConsentRequired() {
            return this._call.explicitConsentStateImp.isConsentRequiredInCall();
        }
        dispose() {
            this._updateIsTranscriptionActive(!1), this._botChangedSubs.forEach((g, f)=>g.dispose()), this._botChangedSubs.clear();
        }
        constructor(g){
            this._eventEmitter = g, this._botChangedSubs = new Map, this._isTranscriptionActive = !1, this.grantTeamsConsent = async ()=>(this._logger.info("Attempting to set consent for transcription"), this._call.explicitConsentStateImp.consent(this._callInfo).catch((g)=>{
                    throw this._logger.error("Consent failure to set publish state for user"), handlePublishStateFailure(g, O.FEATURES.TRANSCRIPTION.TRANSCRIPTION_CONSENT_FAILURE);
                })), this._updateIsTranscriptionActive = (g)=>{
                this._isTranscriptionActive !== g && (this._isTranscriptionActive = g, this._logger.info(`Updating isTranscriptionActive to ${g}`), this._eventEmitter.emit("isTranscriptionActiveChanged"));
            }, this._isCallingApplication = (g)=>isCallingApplication(g.id), this._handleBotRemoved = (g)=>{
                var _this__botChangedSubs_get;
                (_this__botChangedSubs_get = this._botChangedSubs.get(g)) === null || _this__botChangedSubs_get === void 0 ? void 0 : _this__botChangedSubs_get.dispose(), this._botChangedSubs.delete(g), this._checkIfAbotIsTranscribing();
            }, this._handleBotAdded = (g)=>{
                this._botChangedSubs.set(g, g.changed(this._checkIfAbotIsTranscribing)), this._checkIfAbotIsTranscribing();
            }, this._checkIfAbotIsTranscribing = ()=>{
                try {
                    Array.from(this._botChangedSubs.keys()).find((g)=>{
                        var _g_endpoints_endpointDetails, _g_endpoints;
                        return (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.find((g)=>{
                            var _g_endpointMetadata_processingModes_realTimeTranscript, _g_endpointMetadata_processingModes, _g_endpointMetadata;
                            return "Active" === (g === null || g === void 0 ? void 0 : (_g_endpointMetadata = g.endpointMetadata) === null || _g_endpointMetadata === void 0 ? void 0 : (_g_endpointMetadata_processingModes = _g_endpointMetadata.processingModes) === null || _g_endpointMetadata_processingModes === void 0 ? void 0 : (_g_endpointMetadata_processingModes_realTimeTranscript = _g_endpointMetadata_processingModes.realTimeTranscript) === null || _g_endpointMetadata_processingModes_realTimeTranscript === void 0 ? void 0 : _g_endpointMetadata_processingModes_realTimeTranscript.state);
                        });
                    }) ? this._updateIsTranscriptionActive(!0) : this._updateIsTranscriptionActive(!1);
                } catch (g) {
                    this._logger.warn("Unable to read transcription state: ", g);
                }
            };
        }
    }
    class TransferImpl {
        get state() {
            return this._state;
        }
        get error() {
            return this._error;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        setTransferState(g) {
            let f, S;
            const v = {
                0: "None",
                1: "Transferring",
                2: "Transferring",
                3: "Transferred",
                4: "Failed"
            };
            v[g] ? (f = v[g], "Failed" === f && (S = this._getTransferEndReason(), this._error = S), this._logger.log(`Mapped ts transfer state:[${g}] to [${f}]`), this._setTransferState(f)) : this._logger.warn(`unable to map tsCall state=[${g}] to transfer state`);
        }
        _setTransferState(g) {
            g !== this._state && (this._logger.log(`transfer state changed [${this._state}]=>[${this.state}]`), this._state = g, this._eventEmitter.emit("stateChanged"));
        }
        constructor(g, f, S = !0){
            return this._eventEmitter = new Ny.EventEmitter, this._lastTsTransferState = 0, this._getTransferEndReason = (g, f = 0)=>{
                var _this__tsCall_transferDiagnosticsInfo;
                let S = f, v = 0, _ = g || "Unknown";
                this._tsCall && (S = this._tsCall.transferDiagnosticsInfo && this._tsCall.transferDiagnosticsInfo.callControllerCode || f, v = this._tsCall.transferDiagnosticsInfo && ((_this__tsCall_transferDiagnosticsInfo = this._tsCall.transferDiagnosticsInfo) === null || _this__tsCall_transferDiagnosticsInfo === void 0 ? void 0 : _this__tsCall_transferDiagnosticsInfo.callControllerSubCode) || 0, _ = convertTerminatedReasonToString(this._tsCall.terminatedReason));
                const C = {
                    code: S,
                    subCode: v
                };
                return this._logger[0 === S ? "info" : "error"](`Transfer end reason=${_}, code=${S}, subCode=${v}`), C;
            }, this._state = "None", this._logger = f.createChild(()=>"Transfer"), this._logger.log("created"), this._tsCall = g, S ? 4 !== g.state ? (this._logger.error("Transfer end reason= call must be on hold before transfer"), this._error = {
                code: L
            }, void this.setTransferState(4)) : (this._lastTsTransferState = this._tsCall.transferState, this.setTransferState(this._tsCall.transferState), void this._tsCall.changed(()=>{
                this._tsCall.transferState !== this._lastTsTransferState && (this._logger.log(`tsCall transfer state changed=${this._tsCall.transferState}`), this._lastTsTransferState = this._tsCall.transferState, this.setTransferState(this._tsCall.transferState));
            })) : (this._logger.error("Transfer end reason= call was not found with this callId"), this._error = {
                code: L
            }, void this.setTransferState(4));
        }
    }
    class NetworkInfoImpl {
        static getInstance() {
            return this.instance || (this.instance = new NetworkInfoImpl), this.instance;
        }
        deleteNetworkInfo(g) {
            delete this.CAUSE_ID_TO_NETWORK_INFO[g];
        }
        ifCauseIdExistsRemoveNetworkInfo(g) {
            return this.CAUSE_ID_TO_NETWORK_INFO[g] && 0 === this.CAUSE_ID_TO_NETWORK_INFO[g].length ? !!this.getRemoveCauseIdToNetworkInfo(g) : !!this.CAUSE_ID_TO_NETWORK_INFO[g];
        }
        getRemoveCauseIdToNetworkInfo(g) {
            if (!getAcsEcsConfig().telemetry.sendNetworkInfo) return;
            const f = this.CAUSE_ID_TO_NETWORK_INFO[g];
            return f && this.deleteNetworkInfo(g), f;
        }
        setCauseIdToNetworkInfo(g, f) {
            Object.keys(this.CAUSE_ID_TO_NETWORK_INFO).length > 100 && (this.CAUSE_ID_TO_NETWORK_INFO = {}), f ? this.CAUSE_ID_TO_NETWORK_INFO[g] ? this.CAUSE_ID_TO_NETWORK_INFO[g].push({
                url: f.url,
                statusCode: f.statusCode,
                start: f.start,
                end: f.end,
                deltaTimeInMs: f.deltaTimeInMs,
                causeId: f.causeId
            }) : this.CAUSE_ID_TO_NETWORK_INFO[g] = [
                {
                    url: f.url,
                    statusCode: f.statusCode,
                    start: f.start,
                    end: f.end,
                    deltaTimeInMs: f.deltaTimeInMs,
                    causeId: f.causeId
                }
            ] : this.CAUSE_ID_TO_NETWORK_INFO[g] = [];
        }
        constructor(){
            this.CAUSE_ID_TO_NETWORK_INFO = {};
        }
    }
    NetworkInfoImpl.instance = null;
    const xE = NetworkInfoImpl.getInstance();
    var __decorate$1 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$1 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class TransferCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "Transfer";
        }
        transfer(g, f) {
            return this._impl.transfer(g, f);
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f), this._sendFeatureUsage("initialize", uy.initialize);
        }
        on(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: "Transfer",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new TransferCallImplOverTsCall(this.eventEmitter);
        }
    }
    class TransferCallImplOverTsCall {
        initialize(g, f, S, v) {
            this._logger = v.createChild(()=>`TransferFeature::Call(id='${g.callId}', state='${g.state}')`), this._telemetryLogManager = S, this._tsCall = g, this._callAgent = f, g.on("transferRequested", (g)=>{
                const f = this.getTransferRequestPayload(g);
                if (this._autoAccept) {
                    const g = f.accept();
                    this._eventEmitter.emit("transferAccepted", {
                        targetCall: g
                    });
                }
            });
        }
        transfer(g, f) {
            let S = "safe";
            if (g.targetCallId ? S = "consultative" : g.targetParticipantVoicemail && (S = "voicemail"), this._sendFeatureUsage(S, uy.attempt, f), !this.isTransferable(this._tsCall)) throw this._sendFeatureUsage(S, uy.failure, f), new CallingCommunicationError({
                defaultError: O.FEATURES.TRANSFER.UNSUPPORTED_CALL_TYPE
            });
            const v = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(v);
            try {
                let _;
                switch(S){
                    case "safe":
                        return _ = this.transferToParticipant(g.targetParticipant, v, f), this._sendFeatureUsage(S, uy.success, f, xE.getRemoveCauseIdToNetworkInfo(v)), _;
                    case "consultative":
                        return _ = this.transferToCall(g.targetCallId, v, f), this._sendFeatureUsage(S, uy.success, f, xE.getRemoveCauseIdToNetworkInfo(v)), _;
                    case "voicemail":
                        return _ = this.transferToParticipantVoicemail(g.targetParticipantVoicemail, f), this._sendFeatureUsage(S, uy.success, f), _;
                }
            } catch (g) {
                if (this._sendFeatureUsage(S, uy.failure, f, xE.getRemoveCauseIdToNetworkInfo(v)), g instanceof CallingCommunicationError) throw g;
            }
            throw this._sendFeatureUsage(S, uy.failure, f), new CallingCommunicationError({
                defaultError: O.FEATURES.TRANSFER.TARGET_NOT_RECOGNIZED
            });
        }
        getTransferRequestPayload(g) {
            const f = constructIdentifierKindFromMri(g.transferContext.targetMri);
            if ("communicationUser" === f.kind || "phoneNumber" === f.kind || "microsoftTeamsUser" === f.kind || "unknown" === f.kind || "microsoftTeamsApp" === f.kind) {
                let f = !1;
                const S = {
                    accept: ()=>{
                        let S;
                        try {
                            if (S = this._callAgent.createTransferTargetCall(g.transferContext), f) return this._logger.info("Transfer accept was called when transfer action is already in progress."), S;
                            f = !0;
                            const v = {
                                threadId: "",
                                messageId: void 0,
                                transferContext: g.transferContext,
                                mediaPeerType: 0
                            };
                            S.startCallInternal(void 0, !1, void 0, v).catch((S)=>{
                                f = !1, g.onCompleted(7), this._logger.error("Transfer to target failed at call start");
                            });
                            const callReplacementCallBack = ()=>{
                                if (f) switch(S.state){
                                    case "Connected":
                                        f = !1, g.onCompleted(1), this._logger.info("Transfer Completed"), S.off("stateChanged", ()=>{});
                                        break;
                                    case "Disconnected":
                                        var _S_callEndReason, _S_callEndReason1, _S_callEndReason2, _S_callEndReason3;
                                        f = !1, g.onCompleted(7), this._logger.info(`Transfer call disconnected. \n                                            code = ${(_S_callEndReason = S.callEndReason) === null || _S_callEndReason === void 0 ? void 0 : _S_callEndReason.code} \n                                            subcode = ${(_S_callEndReason1 = S.callEndReason) === null || _S_callEndReason1 === void 0 ? void 0 : _S_callEndReason1.subCode} \n                                            message = ${(_S_callEndReason2 = S.callEndReason) === null || _S_callEndReason2 === void 0 ? void 0 : _S_callEndReason2.message} \n                                            result categories = ${(_S_callEndReason3 = S.callEndReason) === null || _S_callEndReason3 === void 0 ? void 0 : _S_callEndReason3.resultCategories}`), S.off("stateChanged", ()=>{});
                                }
                            };
                            return S.on("stateChanged", callReplacementCallBack), S;
                        } catch (S) {
                            throw f = !1, g.onCompleted(7), this._logger.error("Transfer to target failed at call create"), new CallingCommunicationError({
                                defaultError: O.FEATURES.TRANSFER.TRANSFER_TO_TARGET_FAILED,
                                originalError: S
                            });
                        }
                    }
                };
                return S;
            }
            throw new CallingCommunicationError({
                defaultError: O.FEATURES.TRANSFER.INVALID_TARGET_TYPE,
                defaultErrorMessageArgs: [
                    f
                ]
            });
        }
        isTransferable(g) {
            return 1 === g.callType || g.participants.filter((g)=>!isCallingApplication(g.id)).length <= 2;
        }
        transferToParticipant(g, f, S) {
            const v = getMriFromIdentifier(g);
            let _;
            S && (_ = {
                disableForwardingAndUnanswered: S.disableForwardingAndUnanswered,
                clientTransferContext: {
                    customContext: processCustomContext(S)
                }
            }), 4 === this._tsCall.state && this._tsCall.callSafeTransfer(v, f, _);
            return new TransferImpl(this._tsCall, this._logger);
        }
        transferToCall(g, f, S) {
            const v = this._callAgent.getCallByCallId(g);
            if (v && !this.isTransferable(v)) throw new CallingCommunicationError({
                defaultError: O.FEATURES.TRANSFER.UNSUPPORTED_CALL_TYPE
            });
            let _;
            S && (_ = {
                clientTransferContext: {
                    customContext: processCustomContext(S)
                }
            }), v && 4 === this._tsCall.state && this._tsCall.callConsultativeTransfer(v, f, void 0, _);
            return new TransferImpl(this._tsCall, this._logger, !!v);
        }
        transferToParticipantVoicemail(g, f) {
            const S = getMriFromIdentifier(g);
            if (4 === this._tsCall.state) {
                const g = {
                    transferTargetMri: S
                };
                this._tsCall.transferCallToVoicemail(g);
            }
            return new TransferImpl(this._tsCall, this._logger);
        }
        _sendFeatureUsage(g, f, S, v) {
            var _S_customContext, _S_customContext1;
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "Transfer",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: {
                    transferConstraint: {
                        userToUserPresent: !!(S === null || S === void 0 ? void 0 : (_S_customContext = S.customContext) === null || _S_customContext === void 0 ? void 0 : _S_customContext.userToUser),
                        xHeadersPresent: !!(S === null || S === void 0 ? void 0 : (_S_customContext1 = S.customContext) === null || _S_customContext1 === void 0 ? void 0 : _S_customContext1.xHeaders) && S.customContext.xHeaders.length > 0,
                        type: "safe" === g ? "participant" : "consultative" === g ? "call" : "voicemail"
                    }
                },
                networkInfo: v || []
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {}
        constructor(g){
            this._eventEmitter = g, this._autoAccept = getAcsEcsConfig().calling.transfer.autoAccept;
        }
    }
    __decorate$1([
        syncOperation(xy.Transfer),
        __metadata$1("design:type", Function),
        __metadata$1("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$1("design:returntype", Object)
    ], TransferCallImplOverTsCall.prototype, "transfer", null);
    class VideoDeviceInfoImpl {
        get name() {
            return this._name;
        }
        setName(g) {
            this._name = g;
        }
        get id() {
            return this._id;
        }
        setId(g) {
            this._id = g;
        }
        get deviceType() {
            return this._deviceType;
        }
        setDeviceType(g) {
            this._deviceType = g;
        }
        get deviceManager() {
            return this._deviceManager;
        }
        constructor(g, f, S, v){
            this._name = g, this._id = f, this._deviceType = S, this._deviceManager = v;
        }
    }
    function loggerProperty(g, f) {
        Reflect.defineMetadata(j, f, g);
    }
    function Deque(g) {
        if (this._capacity = getCapacity(g), this._length = 0, this._front = 0, UE(g)) {
            for(var f = g.length, S = 0; S < f; ++S)this[S] = g[S];
            this._length = f;
        }
    }
    Deque.prototype.toArray = function Deque$toArray() {
        for(var g = this._length, f = new Array(g), S = this._front, v = this._capacity, _ = 0; _ < g; ++_)f[_] = this[S + _ & v - 1];
        return f;
    }, Deque.prototype.push = function Deque$push(g) {
        var f = arguments.length, S = this._length;
        if (f > 1) {
            var v = this._capacity;
            if (S + f > v) {
                for(var _ = 0; _ < f; ++_)this._checkCapacity(S + 1), this[C = this._front + S & this._capacity - 1] = arguments[_], S++, this._length = S;
                return S;
            }
            for(var C = this._front, _ = 0; _ < f; ++_)this[C + S & v - 1] = arguments[_], C++;
            return this._length = S + f, S + f;
        }
        return 0 === f ? S : (this._checkCapacity(S + 1), this[_ = this._front + S & this._capacity - 1] = g, this._length = S + 1, S + 1);
    }, Deque.prototype.pop = function Deque$pop() {
        var g = this._length;
        if (0 !== g) {
            var f = this._front + g - 1 & this._capacity - 1, S = this[f];
            return this[f] = void 0, this._length = g - 1, S;
        }
    }, Deque.prototype.shift = function Deque$shift() {
        var g = this._length;
        if (0 !== g) {
            var f = this._front, S = this[f];
            return this[f] = void 0, this._front = f + 1 & this._capacity - 1, this._length = g - 1, S;
        }
    }, Deque.prototype.unshift = function Deque$unshift(g) {
        var f = this._length, S = arguments.length;
        if (S > 1) {
            if (f + S > (_ = this._capacity)) {
                for(var v = S - 1; v >= 0; v--){
                    this._checkCapacity(f + 1);
                    var _ = this._capacity;
                    this[E = (this._front - 1 & _ - 1 ^ _) - _] = arguments[v], f++, this._length = f, this._front = E;
                }
                return f;
            }
            var C = this._front;
            for(v = S - 1; v >= 0; v--){
                var E;
                this[E = (C - 1 & _ - 1 ^ _) - _] = arguments[v], C = E;
            }
            return this._front = C, this._length = f + S, f + S;
        }
        if (0 === S) return f;
        this._checkCapacity(f + 1);
        _ = this._capacity;
        return this[v = (this._front - 1 & _ - 1 ^ _) - _] = g, this._length = f + 1, this._front = v, f + 1;
    }, Deque.prototype.peekBack = function Deque$peekBack() {
        var g = this._length;
        if (0 !== g) return this[this._front + g - 1 & this._capacity - 1];
    }, Deque.prototype.peekFront = function Deque$peekFront() {
        if (0 !== this._length) return this[this._front];
    }, Deque.prototype.get = function Deque$get(g) {
        var f = g;
        if (f === (0 | f)) {
            var S = this._length;
            if (f < 0 && (f += S), !(f < 0 || f >= S)) return this[this._front + f & this._capacity - 1];
        }
    }, Deque.prototype.isEmpty = function Deque$isEmpty() {
        return 0 === this._length;
    }, Deque.prototype.clear = function Deque$clear() {
        for(var g = this._length, f = this._front, S = this._capacity, v = 0; v < g; ++v)this[f + v & S - 1] = void 0;
        this._length = 0, this._front = 0;
    }, Deque.prototype.toString = function Deque$toString() {
        return this.toArray().toString();
    }, Deque.prototype.valueOf = Deque.prototype.toString, Deque.prototype.removeFront = Deque.prototype.shift, Deque.prototype.removeBack = Deque.prototype.pop, Deque.prototype.insertFront = Deque.prototype.unshift, Deque.prototype.insertBack = Deque.prototype.push, Deque.prototype.enqueue = Deque.prototype.push, Deque.prototype.dequeue = Deque.prototype.shift, Deque.prototype.toJSON = Deque.prototype.toArray, Object.defineProperty(Deque.prototype, "length", {
        get: function() {
            return this._length;
        },
        set: function() {
            throw new RangeError("");
        }
    }), Deque.prototype._checkCapacity = function Deque$_checkCapacity(g) {
        this._capacity < g && this._resizeTo(getCapacity(1.5 * this._capacity + 16));
    }, Deque.prototype._resizeTo = function Deque$_resizeTo(g) {
        var f = this._capacity;
        this._capacity = g;
        var S = this._front, v = this._length;
        S + v > f && arrayMove(this, 0, this, f, S + v & f - 1);
    };
    var UE = Array.isArray;
    function arrayMove(g, f, S, v, _) {
        for(var C = 0; C < _; ++C)S[C + v] = g[C + f], g[C + f] = void 0;
    }
    function pow2AtLeast(g) {
        return g >>>= 0, g -= 1, g |= g >> 1, g |= g >> 2, g |= g >> 4, g |= g >> 8, (g |= g >> 16) + 1;
    }
    function getCapacity(g) {
        if ("number" != typeof g) {
            if (!UE(g)) return 16;
            g = g.length;
        }
        return pow2AtLeast(Math.min(Math.max(16, g), 1073741824));
    }
    var VE = Deque;
    class DefaultLogger {
        static overrideDefaultLogDump() {
            var _getAcsEcsConfig_debugInfo, _getAcsEcsConfig;
            if (DefaultLogger.logDump.isEmpty()) DefaultLogger.logDump = new VE((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo = _getAcsEcsConfig.debugInfo) === null || _getAcsEcsConfig_debugInfo === void 0 ? void 0 : _getAcsEcsConfig_debugInfo.maxLogDumpLength);
            else {
                var _getAcsEcsConfig_debugInfo1, _getAcsEcsConfig1;
                let g = new VE((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo1 = _getAcsEcsConfig1.debugInfo) === null || _getAcsEcsConfig_debugInfo1 === void 0 ? void 0 : _getAcsEcsConfig_debugInfo1.maxLogDumpLength);
                for(; DefaultLogger.logDump.length > 0;){
                    const f = DefaultLogger.logDump.shift();
                    f && g.push(f);
                }
                DefaultLogger.logDump = g;
            }
        }
        createChild(g) {
            return new DefaultLogger(this._azureLogger, [
                ...this._namespace,
                "string" == typeof g ? ()=>g : g
            ]);
        }
        createFnLogger(g, f, ...S) {
            return this.createChild(this.getPrefix(g, f) + S.join(""));
        }
        log(...g) {
            const f = this.getMessage(g);
            this._azureLogger.verbose(f), this._logRedirectCallback(`log:${f}`);
        }
        debug(...g) {
            const f = this.getMessage(g);
            this._azureLogger.verbose(f), this._logRedirectCallback(`debug:${f}`);
        }
        info(...g) {
            const f = this.getMessage(g);
            this._azureLogger.info(f), this._logRedirectCallback(`info:${f}`);
        }
        warn(...g) {
            const f = this.getMessage(g);
            this._azureLogger.warning(f), this._logRedirectCallback(`warn:${f}`);
        }
        error(...g) {
            const f = this.getMessage(g);
            this._azureLogger.error(this.getMessage(g)), this._logRedirectCallback(`error::${f}`);
        }
        getMessage(...g) {
            return `${getDateInIsoFormat()} ${this.getNamespace()} ${g.join(" ")}`;
        }
        getNamespace() {
            return this._namespace.map((g)=>g()).join(":");
        }
        getPrefix(g, f) {
            let S = "";
            return f && (S += f), g && (S += g), S;
        }
        redirectLog(g) {
            this._logRedirectCallback = (f)=>{
                DefaultLogger.defaultLogRedirect(f), g(f);
            };
        }
        dumpAllLogs() {
            return [
                ...DefaultLogger.logDump.toArray()
            ];
        }
        constructor(g, f = [], S = DefaultLogger.defaultLogRedirect){
            this._azureLogger = g, this._namespace = f, this._logRedirectCallback = S;
        }
    }
    DefaultLogger.logDump = new VE(Fm), DefaultLogger.defaultLogRedirect = (g)=>{
        var _getAcsEcsConfig_debugInfo, _getAcsEcsConfig;
        if ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo = _getAcsEcsConfig.debugInfo) === null || _getAcsEcsConfig_debugInfo === void 0 ? void 0 : _getAcsEcsConfig_debugInfo.enableLogDump) {
            var _getAcsEcsConfig_debugInfo1, _getAcsEcsConfig1, _getAcsEcsConfig_debugInfo2, _getAcsEcsConfig2;
            const sizeCheck = ()=>{
                var _getAcsEcsConfig_debugInfo, _getAcsEcsConfig;
                DefaultLogger.logDump.length > ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo = _getAcsEcsConfig.debugInfo) === null || _getAcsEcsConfig_debugInfo === void 0 ? void 0 : _getAcsEcsConfig_debugInfo.maxLogDumpLength) && DefaultLogger.logDump.shift();
            };
            if ((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo1 = _getAcsEcsConfig1.debugInfo) === null || _getAcsEcsConfig_debugInfo1 === void 0 ? void 0 : _getAcsEcsConfig_debugInfo1.includeList.some((f)=>P.includes(g, f))) return DefaultLogger.logDump.push(g), void sizeCheck();
            if (!((_getAcsEcsConfig2 = getAcsEcsConfig()) === null || _getAcsEcsConfig2 === void 0 ? void 0 : (_getAcsEcsConfig_debugInfo2 = _getAcsEcsConfig2.debugInfo) === null || _getAcsEcsConfig_debugInfo2 === void 0 ? void 0 : _getAcsEcsConfig_debugInfo2.excludeList.some((f)=>P.includes(g, f)))) return DefaultLogger.logDump.push(g), void sizeCheck();
        }
    };
    var __decorate$2 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$2 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class StreamTelemetryEventSender {
        sendMediaStreamEvent(g) {
            var _this__telemetryLogManager;
            (_this__telemetryLogManager = this._telemetryLogManager) === null || _this__telemetryLogManager === void 0 ? void 0 : _this__telemetryLogManager.sendEvent({
                name: dy.acs_calling_media_stream,
                tenant: nf,
                properties: {
                    correlationId: g.correlationId,
                    mediaType: g.mediaType,
                    operation: g.operation,
                    timestampInfo: g.timestampInfo,
                    streamType: g.streamType || Iy.Local,
                    additionalDetails: g.additionalDetails || "",
                    kindOfEvent: g.kindOfEvent || "",
                    callId: g.callId || "",
                    localPaticipantId: g.localParticipantId || "",
                    createViewResolvedOnPlayEvent: g.createViewResolvedOnPlayEvent || ""
                }
            });
        }
        constructor(g){
            this._telemetryLogManager = g;
        }
    }
    __decorate$2([
        loggerProperty,
        __metadata$2("design:type", Object)
    ], StreamTelemetryEventSender.prototype, "logger", void 0);
    class EffectsCapabilityChecker {
        async videoEffectsSupported() {
            if (this._videoEffectsEnabled) {
                var _this__mediaConfig_webcv, _this__mediaConfig;
                const g = ((_this__mediaConfig = this._mediaConfig) === null || _this__mediaConfig === void 0 ? void 0 : (_this__mediaConfig_webcv = _this__mediaConfig.webcv) === null || _this__mediaConfig_webcv === void 0 ? void 0 : _this__mediaConfig_webcv.useWasmEffects) ? this._isWasmVideoEffectSupported() : this._isWebgl2EffectSupported();
                this._videoEffectsSupported = g && this._isCurrentEnvironmentSDKSupported();
            } else this._logger.info("Video effects are disabled."), this._videoEffectsSupported = !1;
            return this._videoEffectsSupported;
        }
        async audioEffectsSupported(g) {
            return this._audioEffectsEnabled ? this._audioEffectsSupported = this._isBrowserEffect(g) ? this._isBrowserEffectSupported(g) : await this._isWasmAudioEffectSupported() : (this._logger.info("Audio effects are disabled."), this._audioEffectsSupported = !1), this._audioEffectsSupported;
        }
        _isBrowserEffect(g) {
            if ("string" == typeof g) switch(g){
                case "BrowserEchoCancellation":
                case "BrowserNoiseSuppression":
                case "BrowserAutoGainControl":
                    return !0;
                default:
                    return !1;
            }
            return !1;
        }
        _isBrowserEffectSupported(g) {
            var _window_navigator_mediaDevices_getSupportedConstraints, _window_navigator_mediaDevices, _window_navigator;
            const f = (_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_mediaDevices = _window_navigator.mediaDevices) === null || _window_navigator_mediaDevices === void 0 ? void 0 : (_window_navigator_mediaDevices_getSupportedConstraints = _window_navigator_mediaDevices.getSupportedConstraints) === null || _window_navigator_mediaDevices_getSupportedConstraints === void 0 ? void 0 : _window_navigator_mediaDevices_getSupportedConstraints.call(_window_navigator_mediaDevices);
            if (f) switch(g){
                case "BrowserEchoCancellation":
                    return !!f.echoCancellation;
                case "BrowserNoiseSuppression":
                    return !!f.noiseSuppression;
                case "BrowserAutoGainControl":
                    return !!f.autoGainControl;
                default:
                    return !1;
            }
            return !1;
        }
        _isCurrentEnvironmentSDKSupported() {
            return !!(this._environmentInfo.isSupportedBrowser && this._environmentInfo.isSupportedBrowserVersion && this._environmentInfo.isSupportedEnvironment && this._environmentInfo.isSupportedPlatform);
        }
        _isWasmVideoEffectSupported() {
            var _this__mediaConfig_webcv, _this__mediaConfig;
            return ((_this__mediaConfig = this._mediaConfig) === null || _this__mediaConfig === void 0 ? void 0 : (_this__mediaConfig_webcv = _this__mediaConfig.webcv) === null || _this__mediaConfig_webcv === void 0 ? void 0 : _this__mediaConfig_webcv.useWasmEffects) ? !!window.MediaStreamTrackProcessor || (this._logger.info("WASM effects disabled, insertable streams are not supported"), !1) : (this._logger.info("WASM effects disabled by WebCV feature flag"), !1);
        }
        _isWebgl2EffectSupported() {
            return this._isCurrentRendererSupported() && this._isWebGL2Supported();
        }
        _isCurrentRendererSupported() {
            var _this__mediaConfig_webcv, _this__mediaConfig;
            var _this__mediaConfig_webcv_webGLUnsupportedRenderers;
            const g = (_this__mediaConfig_webcv_webGLUnsupportedRenderers = (_this__mediaConfig = this._mediaConfig) === null || _this__mediaConfig === void 0 ? void 0 : (_this__mediaConfig_webcv = _this__mediaConfig.webcv) === null || _this__mediaConfig_webcv === void 0 ? void 0 : _this__mediaConfig_webcv.webGLUnsupportedRenderers) !== null && _this__mediaConfig_webcv_webGLUnsupportedRenderers !== void 0 ? _this__mediaConfig_webcv_webGLUnsupportedRenderers : [];
            let f = !1;
            try {
                const S = document.createElement("canvas").getContext("webgl"), v = S === null || S === void 0 ? void 0 : S.getExtension("WEBGL_debug_renderer_info"), _ = v && (S === null || S === void 0 ? void 0 : S.getParameter(v.UNMASKED_RENDERER_WEBGL));
                return _ && !g.some((g)=>g === _) ? f = !0 : this._logger.info(`Unsupported renderer: ${stringifyObject(_)}`), f;
            } catch (g) {
                return this._logger.warn(`Error trying to check compatibility: ${JSON.stringify(g)}`), !1;
            }
        }
        _isWebGL2Supported() {
            try {
                var _this__mediaConfig_webcv, _this__mediaConfig;
                const g = document.createElement("canvas").getContext("webgl2");
                if (!g) return this._logger.info("WebGL2 context is not supported"), !1;
                const f = g.getSupportedExtensions(), S = (_this__mediaConfig = this._mediaConfig) === null || _this__mediaConfig === void 0 ? void 0 : (_this__mediaConfig_webcv = _this__mediaConfig.webcv) === null || _this__mediaConfig_webcv === void 0 ? void 0 : _this__mediaConfig_webcv.webGLRequiredExtensions.filter((g)=>!(f === null || f === void 0 ? void 0 : f.includes(g)));
                if (S.length > 0) return this._logger.info(`Unsupported WebGL2 extensions: ${stringifyObject(S)}`), !1;
            } catch (g) {
                return this._logger.error(`isWebGL2Supported: ${stringifyObject(g)}`), !1;
            }
            return !0;
        }
        async _isWasmAudioEffectSupported() {
            return window.AudioWorkletNode ? !!window.WebAssembly || (this._logger.info("WebAssembly is not supported"), !1) : (this._logger.info("AudioWorkletNode is not supported"), !1);
        }
        constructor(g, f){
            var _this__mediaConfig, _this__config_videoEffects, _this__config, _this__config_audioEffects, _this__config1, _this__mediaConfig_webcv, _this__mediaConfig1;
            this._logger = g, this._environmentInfo = f, this._videoEffectsEnabled = !1, this._audioEffectsEnabled = !1, this._videoEffectsSupported = !1, this._audioEffectsSupported = !1, this._config = getAcsEcsConfig(), this._mediaConfig = getMediaConfig(), this._videoEffectsEnabled = !(!((_this__mediaConfig = this._mediaConfig) === null || _this__mediaConfig === void 0 ? void 0 : _this__mediaConfig.enableVideoEffects) || !((_this__config = this._config) === null || _this__config === void 0 ? void 0 : (_this__config_videoEffects = _this__config.videoEffects) === null || _this__config_videoEffects === void 0 ? void 0 : _this__config_videoEffects.enableVideoEffects)), this._audioEffectsEnabled = !!((_this__config1 = this._config) === null || _this__config1 === void 0 ? void 0 : (_this__config_audioEffects = _this__config1.audioEffects) === null || _this__config_audioEffects === void 0 ? void 0 : _this__config_audioEffects.enableAudioEffects), this._videoEffectsEnabled && (this._videoEffectsSupported = ((_this__mediaConfig1 = this._mediaConfig) === null || _this__mediaConfig1 === void 0 ? void 0 : (_this__mediaConfig_webcv = _this__mediaConfig1.webcv) === null || _this__mediaConfig_webcv === void 0 ? void 0 : _this__mediaConfig_webcv.useWasmEffects) ? this._isWasmVideoEffectSupported() : this._isWebgl2EffectSupported());
        }
    }
    var __decorate$3 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$3 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    const BE = [
        {
            acsEffect: "Off",
            tsCallingEffect: 0
        },
        {
            acsEffect: "BackgroundBlur",
            tsCallingEffect: 1
        },
        {
            acsEffect: "BackgroundReplacement",
            tsCallingEffect: 16
        }
    ];
    class VideoEffectsFeatureImpl extends FirstPartyVideoStreamFeature {
        initialize(g, f) {
            this._logger = f.createChild(" - VideoEffects:"), this._telemetryLogManager = g.telemetryLogManager, this.updateEffectStatusManager();
        }
        get name() {
            return "VideoEffects";
        }
        get activeEffects() {
            var _this__effectsStatusManager_getActiveEffects, _this__effectsStatusManager;
            var _this__effectsStatusManager_getActiveEffects1;
            return (_this__effectsStatusManager_getActiveEffects1 = (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : (_this__effectsStatusManager_getActiveEffects = _this__effectsStatusManager.getActiveEffects) === null || _this__effectsStatusManager_getActiveEffects === void 0 ? void 0 : _this__effectsStatusManager_getActiveEffects.call(_this__effectsStatusManager)) !== null && _this__effectsStatusManager_getActiveEffects1 !== void 0 ? _this__effectsStatusManager_getActiveEffects1 : this._activeEffects;
        }
        on(g, f) {
            if ("effectsStarted" !== g && "effectsStopped" !== g && "effectsError" !== g && "fpsWarningThresholdReached" !== g && "timeForEffectsWarningReached" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.VIDEO_EFFECTS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
            const S = generateGuid();
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: S,
                operation: by.subscribe,
                additionalDetails: {
                    usageDetails: `Subscribed to ${g}`
                }
            });
        }
        off(g, f) {
            if ("effectsStarted" !== g && "effectsStopped" !== g && "effectsError" !== g && "fpsWarningThresholdReached" !== g && "timeForEffectsWarningReached" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.VIDEO_EFFECTS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        async isSupported(g) {
            const f = generateGuid(), S = +new Date, v = this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name), _ = this.getUsageDetailsForTelemetry("", v);
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: f,
                operation: by.isSupported,
                kindOfEvent: uy.attempt,
                additionalDetails: {
                    usageDetails: _
                }
            });
            try {
                this._logger.info(`isSupported attempted with input ${this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name)}`);
                const v = this.getEffectInternalCast(g);
                if (this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.START_DISPOSED
                });
                if (!this.streamInstance.canStartEffects) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_SOURCE
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager);
                const _ = this._internalDeviceManager.getEnvironmentInfoInternal();
                this._supportChecker || (this._supportChecker = new EffectsCapabilityChecker(this._logger, _));
                const C = await this._supportChecker.videoEffectsSupported();
                this._logger.info(`Support check for ${v.name} resulted in: ${C}`);
                const E = this.getUsageDetailsForTelemetry("", v.name);
                return this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.isSupported,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.success,
                    additionalDetails: {
                        usageDetails: E
                    }
                }), this._logger.info("isSupported success"), C;
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.SUPPORT_CHECK_FAILED,
                    originalError: v
                });
                this._logger.error(_.message);
                const C = this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name), E = this.getUsageDetailsForTelemetry("", C);
                throw this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.isSupported,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_),
                        usageDetails: E
                    }
                }), _;
            }
        }
        async startEffects(g) {
            const f = generateGuid(), S = +new Date, v = this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name), _ = this.getUsageDetailsForTelemetry("", v);
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: f,
                operation: by.startEffects,
                kindOfEvent: uy.attempt,
                additionalDetails: {
                    usageDetails: _
                }
            });
            try {
                this._logger.info(`startEffects attempted with input ${this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name)}`);
                if (!getAcsEcsConfig().videoEffects.enableVideoEffects) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.DISABLED
                });
                if (this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.START_DISPOSED
                });
                if (!this.streamInstance.canStartEffects) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_SOURCE
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager), this.updateEffectStatusManager(), this.subscribeToStreamInstanceEvents();
                const v = window.performance.now();
                this._effect = this.getEffectInternalCast(g);
                if (!await this.isSupported(g)) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT
                });
                const _ = this._internalDeviceManager.getTsDeviceManager();
                if (!_) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.START_DEVICE_MANAGER
                });
                this.setConfigForEffects(), this.disposeEffectEventSubscriptions(), this.subscribeToEffectEvents();
                const C = await this._effect._internalHandle.getEffectProvider();
                if (!C) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.PROVIDER_UNAVAILABLE
                });
                const E = await C.getVideoEffectProvider(), T = this.streamInstance.callStackWebCVProvider;
                if (!T) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.WEBCV_PROVIDER_FAILED
                });
                T.videoEffectProviderDeferredPromise.resolve(E), 0 === this._tsCallingEffectCapability && (this._tsCallingEffectCapability = await (_ === null || _ === void 0 ? void 0 : _.getDeviceEffectsCapabilityAsync(""))), this._tsCallingSupportedEffects = this.getTsCallingSupportedEffects();
                const I = this._tsCallingSupportedEffects.find((g)=>{
                    var _this__effect;
                    return g.acsEffect === ((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name);
                });
                if (!I) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT
                });
                await (_ === null || _ === void 0 ? void 0 : _.setDeviceEffectsAsync("", I.tsCallingEffect)), this._effectsStatusManager.setActiveEffects([
                    this._effect.name
                ]), this._logger.info(`Video effects started: ${this._effect.name}`);
                const b = window.performance.now();
                this.handleEffectsInitTimeEvent(v, b), this.handleFpsWarningEvent();
                const A = this.getUsageDetailsForTelemetry("", this._effect.name);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.startEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.success,
                    additionalDetails: {
                        usageDetails: A,
                        effectsSdk: {
                            videoEffects: {
                                backgroundImageHasTransparentPixels: this.getBackgroundImageHasTransparentPixel()
                            }
                        }
                    }
                }), this._logger.info("startEffects success");
            } catch (v) {
                var _this__logger;
                const _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.START_FAILED,
                    originalError: v
                });
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(_.message), this.eventEmitter.emit("effectsError", _), this.clearFpsCheckInterval();
                const C = this.getEffectNameForTelemetry(g === null || g === void 0 ? void 0 : g.name), E = this.getUsageDetailsForTelemetry("", C);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.startEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_),
                        usageDetails: E,
                        effectsSdk: {
                            videoEffects: {
                                backgroundImageHasTransparentPixels: this.getBackgroundImageHasTransparentPixel()
                            }
                        }
                    }
                });
            }
        }
        async stopEffects() {
            const g = generateGuid(), f = +new Date;
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: g,
                operation: by.stopEffects,
                kindOfEvent: uy.attempt
            });
            try {
                var _this__effectsStatusManager, _this__effect;
                if (this._logger.info("stopEffects attempted"), this.clearFpsCheckInterval(), this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.STOP_DISPOSED
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager);
                const S = this._internalDeviceManager.getTsDeviceManager();
                if (!S) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.STOP_DEVICE_MANAGER
                });
                this.updateEffectStatusManager();
                const v = this._tsCallingSupportedEffects.find((g)=>"Off" === g.acsEffect);
                if (!v) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.UNSUPPORTED_EFFECT
                });
                await S.setDeviceEffectsAsync("", v.tsCallingEffect), (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.setActiveEffects([]), this.unsubscribeFromStreamInstanceEvents();
                const _ = this.getEffectNameForTelemetry((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name);
                this._logger.info(`Video effects stopped: ${_}`), this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: g,
                    operation: by.stopEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    kindOfEvent: uy.success
                }), this._logger.info("stopEffects success");
            } catch (S) {
                var _this__logger;
                const v = new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.STOP_FAILED,
                    originalError: S
                });
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(v.message), this.eventEmitter.emit("effectsError", v), this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: g,
                    operation: by.stopEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    }
                });
            }
        }
        async dispose() {
            try {
                var _this__effectsStatusManager;
                if (this._logger.info("dispose attempted"), this.disposed) return void this._logger.info("VideoEffects feature already disposed");
                this._effect && await this.stopEffects(), this.eventEmitter.removeAllListeners(), this.serialQueue.dispose(), (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.off("statusChanged", this.effectStatusChangedCallback), this.unsubscribeFromStreamInstanceEvents(), this.disposed = !0, this._logger.info("VideoEffects feature disposed");
            } catch (g) {
                var _this__logger;
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.VIDEO_EFFECTS.DISPOSE_FAILED,
                    originalError: g
                });
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(f.message), this.eventEmitter.emit("effectsError", f);
            }
        }
        getEffectsSdkVersion() {
            var _this__effect__internalHandle, _this__effect__internalHandle1;
            let g = this._stringForUnknownInput;
            return this.activeEffects.length > 0 && this._effect && ((_this__effect__internalHandle = this._effect._internalHandle) === null || _this__effect__internalHandle === void 0 ? void 0 : _this__effect__internalHandle.getVersion) && (g = (_this__effect__internalHandle1 = this._effect._internalHandle) === null || _this__effect__internalHandle1 === void 0 ? void 0 : _this__effect__internalHandle1.getVersion()), this.truncateToMax(g);
        }
        getActiveEffectsForTelemetry() {
            return this.truncateToMax(JSON.stringify(this.activeEffects));
        }
        getEffectInternalCast(g) {
            if ("BackgroundBlur" === (g === null || g === void 0 ? void 0 : g.name) && this.isValidEffectInstance(g)) return g;
            if ("BackgroundReplacement" === (g === null || g === void 0 ? void 0 : g.name) && this.isValidEffectInstance(g)) return g;
            throw new CallingCommunicationError({
                defaultError: O.FEATURES.VIDEO_EFFECTS.INVALID_EFFECT
            });
        }
        isValidEffectInstance(g) {
            let f;
            return ("BackgroundBlur" === g.name && void 0 !== g._internalHandle || "BackgroundReplacement" === g.name && void 0 !== g._internalHandle) && (f = g, this.hasValidInternalHandle(f._internalHandle));
        }
        hasValidInternalHandle(g) {
            return void 0 !== g.effectConfig && void 0 !== g.getEffectProvider && void 0 !== g.dispose && void 0 !== g.getStats && void 0 !== g.setConfig;
        }
        getTsCallingSupportedEffects() {
            const g = [];
            return Object.values(BE).forEach((f)=>{
                (this._tsCallingEffectCapability & f.tsCallingEffect) === f.tsCallingEffect && g.push(f);
            }), g;
        }
        subscribeToEffectEvents() {
            this._effect && this._internalDeviceManager ? (this._effect._internalHandle.on("configUpdated", this.configUpdatedCallback), this._effect._internalHandle.on("processingError", this.processingErrorCallback)) : this._logger.debug("No effect instance found.");
        }
        disposeEffectEventSubscriptions() {
            this._effect ? (this._effect._internalHandle.off("configUpdated", this.configUpdatedCallback), this._effect._internalHandle.off("processingError", this.processingErrorCallback)) : this._logger.debug("No effect instance found.");
        }
        subscribeToStreamInstanceEvents() {
            this._sourceStreamSubscription && (this._logger.info("Already subscribed to videoSourceChanged, removing old sub"), this.streamInstance.off("videoSourceChanged", this._sourceStreamSubscription)), this._sourceStreamSubscription = async (g)=>{
                g.source && "Video" !== g.source.mediaStreamType && await this.stopEffects();
            }, this.streamInstance.on("videoSourceChanged", this._sourceStreamSubscription);
        }
        unsubscribeFromStreamInstanceEvents() {
            this._sourceStreamSubscription ? (this.streamInstance.off("videoSourceChanged", this._sourceStreamSubscription), this._sourceStreamSubscription = null) : this._logger.info("No videoSourceChanged sub active");
        }
        handleEffectsInitTimeEvent(g, f) {
            if (!this._effect) return void this._logger.debug("No effect active");
            const S = generateGuid(), v = f - g, _ = this._effect._internalHandle.effectConfig.effectInitTimeThresholdInMs;
            if (this._logger.info(`Time for effects to start: ${v}ms`), _ && v > _) {
                this.eventEmitter.emit("timeForEffectsWarningReached", this._effect.name);
                const g = this.getUsageDetailsForTelemetry(`Threshold value: ${_}ms`, this._effect.name);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: S,
                    operation: by.timeForEffectsWarningReached,
                    additionalDetails: {
                        usageDetails: g
                    }
                });
            }
        }
        handleFpsWarningEvent() {
            if (!this._effect) return void this._logger.debug("No effect active");
            this.clearFpsCheckInterval();
            const g = getAcsEcsConfig(), f = generateGuid(), S = g.videoEffects.waitTimeToInitiateFpsChecksInMs, v = g.videoEffects.fpsCheckIntervalTimeInMs;
            var _this__effect__internalHandle_effectConfig_fpsWarningThreshold;
            this._fpsWarningThresholdValue = (_this__effect__internalHandle_effectConfig_fpsWarningThreshold = this._effect._internalHandle.effectConfig.fpsWarningThreshold) !== null && _this__effect__internalHandle_effectConfig_fpsWarningThreshold !== void 0 ? _this__effect__internalHandle_effectConfig_fpsWarningThreshold : g.videoEffects.fpsWarningThreshold;
            const startFpsChecker = ()=>{
                const g = window.setInterval(()=>{
                    var _this__effect;
                    const S = (_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect._internalHandle.getStats(), v = S === null || S === void 0 ? void 0 : S.processor.fpsAvg;
                    if (this._logger.info(`Effects avg fps check interval poll. Current Avg - ${v}`), v && v < this._fpsWarningThresholdValue) {
                        var _this__effect1, _this__effect2;
                        this.eventEmitter.emit("fpsWarningThresholdReached", (_this__effect1 = this._effect) === null || _this__effect1 === void 0 ? void 0 : _this__effect1.name), window.clearInterval(g), this._logger.info(`Effects fps warning threshold hit at ${v}fps`);
                        const S = this.getUsageDetailsForTelemetry(`Fps reported: ${v}, Fps warning threshold value: ${this._fpsWarningThresholdValue}`, (_this__effect2 = this._effect) === null || _this__effect2 === void 0 ? void 0 : _this__effect2.name);
                        this.sendFeatureUsageTelemetry({
                            eventName: dy.acs_calling_media_stream,
                            correlationId: f,
                            operation: by.fpsWarningThresholdReached,
                            additionalDetails: {
                                usageDetails: S
                            }
                        });
                    }
                }, v);
                this._fpsWarningEventIntervalIds.push(g);
            }, _ = window.setTimeout(startFpsChecker, S);
            this._fpsWarningEventTimeoutIds.push(_);
        }
        setConfigForEffects() {
            var _S_videoEffects;
            if (!this._effect) return void this._logger.debug("No effect active");
            var _this__effect__internalHandle_configProvider_config_videoEffects;
            const g = (_this__effect__internalHandle_configProvider_config_videoEffects = this._effect._internalHandle.configProvider.config.videoEffects) !== null && _this__effect__internalHandle_configProvider_config_videoEffects !== void 0 ? _this__effect__internalHandle_configProvider_config_videoEffects : this._effect._internalHandle.configProvider.config, f = getMediaConfig(), S = getAcsEcsConfig();
            if ((f === null || f === void 0 ? void 0 : f.enableVideoEffects) && (S === null || S === void 0 ? void 0 : (_S_videoEffects = S.videoEffects) === null || _S_videoEffects === void 0 ? void 0 : _S_videoEffects.enableVideoEffects) && (g.enableVideoEffects = f.enableVideoEffects && S.videoEffects.enableVideoEffects), g.effectConfig = {
                ...g.effectConfig,
                effectInitTimeThresholdInMs: S.videoEffects.effectInitTimeThresholdInMs,
                fpsWarningThreshold: S.videoEffects.fpsWarningThreshold
            }, f.webcv) {
                const S = f.webcv;
                g.webcvConfig = {
                    ...g.webcvConfig,
                    ...S
                };
            }
            this._effect._internalHandle.setConfig(g), this._logger.info(`Config for effects set: ${stringifyObject(g)}`);
        }
        sendFeatureUsageTelemetry(g) {
            if (this._telemetryLogManager) {
                var _this_streamInstance_getCall, _g_additionalDetails;
                g.additionalDetails = {
                    ...g.additionalDetails,
                    callState: (_this_streamInstance_getCall = this.streamInstance.getCall()) === null || _this_streamInstance_getCall === void 0 ? void 0 : _this_streamInstance_getCall.state,
                    activeEffects: JSON.stringify(this.activeEffects),
                    effectsSdk: {
                        ...(_g_additionalDetails = g.additionalDetails) === null || _g_additionalDetails === void 0 ? void 0 : _g_additionalDetails.effectsSdk,
                        version: this.getEffectsSdkVersion()
                    }
                };
                try {
                    var _this_streamInstance_getCall1;
                    const f = {
                        correlationId: g.correlationId,
                        mediaType: Ty.VideoRaw,
                        streamType: Iy.Local,
                        operation: g.operation,
                        timestampInfo: g.timestampInfo || {},
                        kindOfEvent: g.kindOfEvent || "",
                        additionalDetails: g.additionalDetails || "",
                        callId: ((_this_streamInstance_getCall1 = this.streamInstance.getCall()) === null || _this_streamInstance_getCall1 === void 0 ? void 0 : _this_streamInstance_getCall1.id) || "",
                        localParticipantId: this.streamInstance.getLocalParticipantId() || ""
                    };
                    this._telemetryLogManager.sendEvent({
                        name: g.eventName,
                        tenant: nf,
                        properties: f
                    });
                } catch (f) {
                    this._logger.debug(`Unable to send ${g.operation} telemetry`);
                }
            } else this._logger.debug("Telemetry error. Instance is undefined.");
        }
        getEffectNameForTelemetry(g) {
            var _this__effect, _this__activeEffects;
            let f = this._stringForUnknownInput;
            return g ? f = "string" == typeof g ? g : JSON.stringify(g) : ((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name) ? f = this._effect.name : ((_this__activeEffects = this._activeEffects) === null || _this__activeEffects === void 0 ? void 0 : _this__activeEffects[0]) && (f = JSON.stringify(this._activeEffects[0])), this.truncateToMax(f);
        }
        getUsageDetailsForTelemetry(g, f = "") {
            return this.truncateToMax(`${f ? `[${f}] ` : ""}${g}`);
        }
        clearFpsCheckInterval() {
            this._fpsWarningEventIntervalIds.forEach((g)=>{
                window.clearInterval(g);
            }), this._fpsWarningEventTimeoutIds.forEach((g)=>{
                window.clearTimeout(g);
            }), this._fpsWarningEventIntervalIds = [], this._fpsWarningEventTimeoutIds = [];
        }
        updateEffectStatusManager() {
            this.streamInstance.canStartEffects ? (this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager), this._effectsStatusManager || (this._effectsStatusManager = this._internalDeviceManager.callStackVideoEffectsStatusManager, this._effectsStatusManager.on("statusChanged", this.effectStatusChangedCallback)), this._activeEffects = this._effectsStatusManager.getActiveEffects()) : this._logger.warn("Cannot update status manager, current source is not supported.");
        }
        truncateToMax(g) {
            var _this__logger;
            const f = getAcsEcsConfig().videoEffects.maxStringLengthForTelemetry;
            return g.length > f ? ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Truncating video effects info for telemetry"), g.substring(0, f - 2) + "..") : g;
        }
        getBackgroundImageHasTransparentPixel() {
            try {
                var _this__effect, _this__effect__internalHandle_imageLoader, _this__effect__internalHandle, _this__effect__internalHandle_imageLoader1;
                if ("BackgroundReplacement" === ((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name) && void 0 !== ((_this__effect__internalHandle = this._effect._internalHandle) === null || _this__effect__internalHandle === void 0 ? void 0 : (_this__effect__internalHandle_imageLoader = _this__effect__internalHandle.imageLoader) === null || _this__effect__internalHandle_imageLoader === void 0 ? void 0 : _this__effect__internalHandle_imageLoader.loadedImageHasTransparentPixels)) return (_this__effect__internalHandle_imageLoader1 = this._effect._internalHandle.imageLoader) === null || _this__effect__internalHandle_imageLoader1 === void 0 ? void 0 : _this__effect__internalHandle_imageLoader1.loadedImageHasTransparentPixels;
            } catch (g) {
                return null;
            }
            return null;
        }
        constructor(){
            super(...arguments), this._effect = null, this._fpsWarningEventIntervalIds = [], this._fpsWarningEventTimeoutIds = [], this._tsCallingEffectCapability = 0, this._tsCallingSupportedEffects = [
                {
                    acsEffect: "Off",
                    tsCallingEffect: 0
                }
            ], this._activeEffects = [], this._sourceStreamSubscription = null, this._stringForUnknownInput = "UNKNOWN", this.configUpdatedCallback = async (g)=>{
                const f = generateGuid(), S = this.getUsageDetailsForTelemetry("Configure method", g), v = +new Date;
                try {
                    this.sendFeatureUsageTelemetry({
                        eventName: dy.acs_calling_media_stream,
                        correlationId: f,
                        operation: by.effectConfigureUpdate,
                        kindOfEvent: uy.attempt,
                        additionalDetails: {
                            usageDetails: S,
                            effectsSdk: {
                                videoEffects: {
                                    backgroundImageHasTransparentPixels: this.getBackgroundImageHasTransparentPixel()
                                }
                            }
                        }
                    });
                    const _ = this._internalDeviceManager.getTsDeviceManager();
                    if ("BackgroundReplacement" === g) {
                        var _this__effect__internalHandle, _this__effect;
                        const g = ((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : (_this__effect__internalHandle = _this__effect._internalHandle) === null || _this__effect__internalHandle === void 0 ? void 0 : _this__effect__internalHandle.effectConfig).backgroundImageUrl;
                        g && await _.setBackgroundImageAsync("", g), this.sendFeatureUsageTelemetry({
                            eventName: dy.acs_calling_media_stream,
                            correlationId: f,
                            operation: by.effectConfigureUpdate,
                            timestampInfo: {
                                deltaTimeInMs: +new Date - v
                            },
                            kindOfEvent: uy.success,
                            additionalDetails: {
                                usageDetails: S,
                                effectsSdk: {
                                    videoEffects: {
                                        backgroundImageHasTransparentPixels: this.getBackgroundImageHasTransparentPixel()
                                    }
                                }
                            }
                        });
                    }
                    this._logger.info("effect config was updated");
                } catch (g) {
                    const _ = new CallingCommunicationError({
                        defaultError: O.FEATURES.VIDEO_EFFECTS.EFFECT_CONFIG_UPDATE_CALLBACK_FAILED,
                        originalError: g
                    });
                    this._logger.error(_.message), this.sendFeatureUsageTelemetry({
                        eventName: dy.acs_calling_media_stream,
                        correlationId: f,
                        operation: by.effectConfigureUpdate,
                        timestampInfo: {
                            deltaTimeInMs: +new Date - v
                        },
                        kindOfEvent: uy.failure,
                        additionalDetails: {
                            failureReason: _.message,
                            code: _.code,
                            ...extractCommunicationServicesErrorForTelemetry(_),
                            usageDetails: S
                        }
                    });
                }
            }, this.processingErrorCallback = async (g)=>{
                var _this__effect;
                const f = generateGuid();
                this.eventEmitter.emit("effectsError", g);
                const S = this.getEffectNameForTelemetry((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name), v = this.getUsageDetailsForTelemetry("Internal handle error", S);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.effectsError,
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g),
                        usageDetails: v
                    }
                }), await this.stopEffects();
            }, this.effectStatusChangedCallback = (g, f)=>{
                if (f.length > 0) {
                    var _this__effect;
                    const g = ((_this__effect = this._effect) === null || _this__effect === void 0 ? void 0 : _this__effect.name) ? [
                        this._effect.name
                    ] : f;
                    this.eventEmitter.emit("effectsStarted", g);
                } else {
                    var _this__effect1;
                    const f = ((_this__effect1 = this._effect) === null || _this__effect1 === void 0 ? void 0 : _this__effect1.name) ? [
                        this._effect.name
                    ] : g;
                    this.eventEmitter.emit("effectsStopped", f);
                }
            };
        }
    }
    __decorate$3([
        sequentialize(),
        __metadata$3("design:type", Function),
        __metadata$3("design:paramtypes", [
            Object
        ]),
        __metadata$3("design:returntype", Promise)
    ], VideoEffectsFeatureImpl.prototype, "startEffects", null), __decorate$3([
        sequentialize(),
        __metadata$3("design:type", Function),
        __metadata$3("design:paramtypes", []),
        __metadata$3("design:returntype", Promise)
    ], VideoEffectsFeatureImpl.prototype, "stopEffects", null);
    var HE, __decorate$4 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$4 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class LocalVideoStream {
        on(g, f) {
            if ("videoSourceChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.LOCAL_VIDEO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("videoSourceChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.LOCAL_VIDEO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        get source() {
            return this._source;
        }
        get mediaStreamType() {
            return this._mediaStreamType;
        }
        get telemetryLogManager() {
            return this._telemetryLogManager;
        }
        get callStackWebCVProvider() {
            var _this_source_deviceManager, _this_source;
            var _this_source_deviceManager_callStackWebCvProvider;
            return (_this_source_deviceManager_callStackWebCvProvider = (_this_source = this.source) === null || _this_source === void 0 ? void 0 : (_this_source_deviceManager = _this_source.deviceManager) === null || _this_source_deviceManager === void 0 ? void 0 : _this_source_deviceManager.callStackWebCvProvider) !== null && _this_source_deviceManager_callStackWebCvProvider !== void 0 ? _this_source_deviceManager_callStackWebCvProvider : null;
        }
        get callStackEffectsStatusManager() {
            var _this_source_deviceManager, _this_source;
            var _this_source_deviceManager_callStackVideoEffectsStatusManager;
            return (_this_source_deviceManager_callStackVideoEffectsStatusManager = (_this_source = this.source) === null || _this_source === void 0 ? void 0 : (_this_source_deviceManager = _this_source.deviceManager) === null || _this_source_deviceManager === void 0 ? void 0 : _this_source_deviceManager.callStackVideoEffectsStatusManager) !== null && _this_source_deviceManager_callStackVideoEffectsStatusManager !== void 0 ? _this_source_deviceManager_callStackVideoEffectsStatusManager : null;
        }
        get canStartEffects() {
            return this._canStartEffects;
        }
        async switchSource(g) {
            var _this_getCall;
            const f = this.logger.createFnLogger(OS.SwitchSource), S = +new Date, v = generateGuid(), _ = {
                timestampInfo: {
                    attemptTimestamp: S
                },
                correlationId: v,
                operation: by.switchSource,
                callId: ((_this_getCall = this.getCall()) === null || _this_getCall === void 0 ? void 0 : _this_getCall.id) || "",
                localParticipantId: this.getLocalParticipantId() || "",
                kindOfEvent: uy.attempt,
                mediaType: Ty.Video,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), !(g instanceof VideoDeviceInfoImpl)) {
                var _this_getCall1;
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.SWITCH_SOURCE_WRONG_TYPE
                }), f = {
                    correlationId: v,
                    callId: ((_this_getCall1 = this.getCall()) === null || _this_getCall1 === void 0 ? void 0 : _this_getCall1.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: g.message,
                        code: F,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Video,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(f), g;
            }
            if (this._source === g) {
                var _this_getCall2;
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.SWITCH_SAME_SOURCE
                }), f = {
                    correlationId: v,
                    callId: ((_this_getCall2 = this.getCall()) === null || _this_getCall2 === void 0 ? void 0 : _this_getCall2.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Video,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(f), g;
            }
            try {
                var _g_deviceManager_getTsDeviceManager_unsetRawMediaStream, _g_deviceManager_getTsDeviceManager, _this_getCall3;
                if ("RawMedia" === this._mediaStreamType) Array.from(this._call.values()).some((g)=>g.localVideoStream === this) && ((_g_deviceManager_getTsDeviceManager_unsetRawMediaStream = (_g_deviceManager_getTsDeviceManager = g.deviceManager.getTsDeviceManager()).unsetRawMediaStream) === null || _g_deviceManager_getTsDeviceManager_unsetRawMediaStream === void 0 ? void 0 : _g_deviceManager_getTsDeviceManager_unsetRawMediaStream.call(_g_deviceManager_getTsDeviceManager, 1));
                g.deviceManager.getTsDeviceManager().selectDevices({
                    camera: g.id
                }), this.setSource(g);
                const f = {
                    correlationId: v,
                    callId: ((_this_getCall3 = this.getCall()) === null || _this_getCall3 === void 0 ? void 0 : _this_getCall3.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    mediaType: Ty.Video,
                    operation: by.switchSource,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                this._localStreamTelemetryEventSender.sendMediaStreamEvent(f);
            } catch (g) {
                var _this_getCall4;
                const _ = handleVideoOperationFailure(f, g), C = {
                    correlationId: v,
                    callId: ((_this_getCall4 = this.getCall()) === null || _this_getCall4 === void 0 ? void 0 : _this_getCall4.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: _.message,
                        code: F,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Video,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(C), _;
            }
        }
        dispose() {
            var _this__extensibleApi;
            this.logger.log("Disposing LocalVideoStream."), this._disposed ? this.logger.log("already disposed") : (this.disposeRawStream(), this._renderers.forEach((g)=>this._disposeRenderer(g)), this._renderers = [], (_this__extensibleApi = this._extensibleApi) === null || _this__extensibleApi === void 0 ? void 0 : _this__extensibleApi.dispose(), this._eventEmitter.removeAllListeners(), this._disposed = !0);
        }
        async getMediaStream() {
            var _this_getCall;
            const g = generateGuid();
            let f = +new Date;
            const S = {
                correlationId: g,
                callId: ((_this_getCall = this.getCall()) === null || _this_getCall === void 0 ? void 0 : _this_getCall.id) || "",
                localParticipantId: this.getLocalParticipantId() || "",
                timestampInfo: {
                    attemptTimestamp: f
                },
                operation: by.getMediaStream,
                kindOfEvent: uy.attempt,
                mediaType: Ty.VideoRaw,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(S), this.subscribeToRawStreamChangedIfNeeded(), this._mediaStreamSource) {
                var _this_getCall1;
                const S = {
                    correlationId: g,
                    callId: ((_this_getCall1 = this.getCall()) === null || _this_getCall1 === void 0 ? void 0 : _this_getCall1.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    mediaType: Ty.VideoRaw,
                    operation: by.getMediaStream,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                this._localStreamTelemetryEventSender.sendMediaStreamEvent(S);
                const v = this._mediaStreamSource.clone();
                return this._cacheCloneStream(v), v;
            }
            try {
                var _this_getCall2, _this__rawStream;
                let S;
                if ("ScreenSharing" === this._source.deviceType ? S = 2 : "UsbCamera" !== this._source.deviceType && "CaptureAdapter" !== this._source.deviceType && "Virtual" !== this._source.deviceType || (S = 1), !S) throw new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.CANT_GET_DEVICE_TYPE
                });
                this._rawStream || (this._rawStream = this.source.deviceManager.getRawDeviceMediaStream(S));
                const v = {
                    correlationId: g,
                    callId: ((_this_getCall2 = this.getCall()) === null || _this_getCall2 === void 0 ? void 0 : _this_getCall2.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    mediaType: Ty.VideoRaw,
                    operation: by.getMediaStream,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                this._localStreamTelemetryEventSender.sendMediaStreamEvent(v);
                const _ = (await ((_this__rawStream = this._rawStream) === null || _this__rawStream === void 0 ? void 0 : _this__rawStream.getMediaStream())).clone();
                return this._cacheCloneStream(_), _;
            } catch (S) {
                var _this_getCall3;
                let v;
                v = "ScreenSharing" === this._source.deviceType ? new CallingCommunicationError({
                    defaultError: O.CALL.SS_RAW_STREAM_GET,
                    originalError: S
                }) : new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,
                    originalError: S
                });
                const _ = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    correlationId: g,
                    callId: ((_this_getCall3 = this.getCall()) === null || _this_getCall3 === void 0 ? void 0 : _this_getCall3.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.getMediaStream,
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.VideoRaw,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), v;
            }
        }
        async setMediaStream(g) {
            var _this_getCall, _getAcsEcsConfig_calling, _getAcsEcsConfig;
            const f = generateGuid();
            let S, v = +new Date, _ = !1, C = !1, E = Ty.VideoRawOrScreenSharingRaw;
            for (let g of this._call){
                const f = g;
                if (f.localScreenSharingStream === this || f.localVideoStream === this) {
                    S = f.deviceManager, C = !0, f.localVideoStream === this ? (_ = !0, E = Ty.VideoRaw) : f.localScreenSharingStream === this && (_ = !1, E = Ty.ScreenSharingRaw);
                    break;
                }
            }
            const T = {
                timestampInfo: {
                    attemptTimestamp: v
                },
                correlationId: f,
                callId: ((_this_getCall = this.getCall()) === null || _this_getCall === void 0 ? void 0 : _this_getCall.id) || "",
                localParticipantId: this.getLocalParticipantId() || "",
                operation: by.setMediaStream,
                kindOfEvent: uy.attempt,
                mediaType: E,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(T), !(g instanceof MediaStream)) {
                var _this_getCall1;
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM_WRONG_TYPE
                }), S = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - v
                    },
                    correlationId: f,
                    callId: ((_this_getCall1 = this.getCall()) === null || _this_getCall1 === void 0 ? void 0 : _this_getCall1.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.setMediaStream,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: E,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(S), g;
            }
            if (this.setSource(g), (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.allowAccessRawMediaStream) try {
                var _this_getCall2;
                if (C) {
                    const f = S === null || S === void 0 ? void 0 : S.getTsDeviceManager();
                    if (!(f === null || f === void 0 ? void 0 : f.setRawMediaStream)) throw new CallingCommunicationError({
                        defaultError: O.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM_UNDEFINED_FUNC
                    });
                    _ ? f.setRawMediaStream(g, 1) : f.setRawMediaStream(g, 2);
                }
                this._renderers.forEach((f)=>{
                    f.setSourceObject(g);
                });
                const T = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - v
                    },
                    correlationId: f,
                    callId: ((_this_getCall2 = this.getCall()) === null || _this_getCall2 === void 0 ? void 0 : _this_getCall2.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.setMediaStream,
                    kindOfEvent: uy.success,
                    mediaType: E,
                    streamType: Iy.Local
                };
                this._localStreamTelemetryEventSender.sendMediaStreamEvent(T);
            } catch (g) {
                var _this_getCall3;
                const S = new CallingCommunicationError({
                    defaultError: O.LOCAL_VIDEO_STREAM.SET_MEDIA_STREAM,
                    originalError: g
                }), _ = {
                    correlationId: f,
                    callId: ((_this_getCall3 = this.getCall()) === null || _this_getCall3 === void 0 ? void 0 : _this_getCall3.id) || "",
                    localParticipantId: this.getLocalParticipantId() || "",
                    operation: by.setMediaStream,
                    additionalDetails: {
                        failureReason: S.message,
                        code: S.code,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - v
                    },
                    kindOfEvent: uy.failure,
                    mediaType: E,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), S;
            }
        }
        addCall(g) {
            this._call.add(g);
        }
        removeCall(g) {
            this._call.delete(g);
        }
        feature(g) {
            return this._extensibleApi || (this._extensibleApi = new ExtensibleFeatureImpl(this.logger, {
                streamInstance: this
            }, {
                streamInstance: this,
                telemetryLogManager: this.telemetryLogManager
            })), this._extensibleApi.getApiObjectInstance(g.videoStreamApiCtor);
        }
        registerRenderer(g) {
            this._renderers.push(g);
        }
        unregisterRenderer(g) {
            const f = this._renderers.indexOf(g);
            -1 !== f && this._renderers.splice(f, 1);
        }
        getStreamMetadata() {
            var _S_tsCall_mediaStreams__, _S_tsCall_mediaStreams__1;
            let g, f, S = this.getCall();
            this._source instanceof VideoDeviceInfoImpl ? (g = this.source.deviceManager, f = this.source.deviceType) : this._mediaStreamSource instanceof MediaStream && S && (g = S.deviceManager);
            let v = -1;
            return S && ("Video" === this._mediaStreamType || "RawMedia" === this.mediaStreamType && S.localVideoStream === this ? v = ((_S_tsCall_mediaStreams__ = S.tsCall.mediaStreams[0][0]) === null || _S_tsCall_mediaStreams__ === void 0 ? void 0 : _S_tsCall_mediaStreams__.id) || -1 : ("ScreenSharing" === this._mediaStreamType || "RawMedia" === this.mediaStreamType && S.localScreenSharingStream === this) && (v = ((_S_tsCall_mediaStreams__1 = S.tsCall.mediaStreams[1][0]) === null || _S_tsCall_mediaStreams__1 === void 0 ? void 0 : _S_tsCall_mediaStreams__1.id) || -1)), {
                source: "local",
                sourceId: v,
                streamType: this.mediaStreamType,
                deviceType: f || "",
                callId: (S === null || S === void 0 ? void 0 : S.id) || "",
                localParticipantId: (S === null || S === void 0 ? void 0 : S.tsCall.participantId) || "",
                deviceManagerPermissionState: g ? JSON.stringify({
                    cameraPermission: g.getVideoDevicePermission(),
                    microphonePermission: g.getAudioDevicePermission()
                }) : "",
                acsResourceId: (g === null || g === void 0 ? void 0 : g.getAcsResourceId()) || "",
                clientId: (g === null || g === void 0 ? void 0 : g.getClientId()) || ""
            };
        }
        getLocalParticipantId() {
            let g = "";
            const f = this.getCall();
            return f && (g = f.tsCall.participantId), g;
        }
        getCall() {
            for (const g of this._call)if (g.localVideoStreams.includes(this)) return g;
        }
        getEffectsCurrentStateRecord() {
            try {
                const g = this.feature(videoStreamFeatureFactory(VideoEffectsFeatureImpl)), f = g.getEffectsSdkVersion();
                return {
                    activeEffects: g.getActiveEffectsForTelemetry(),
                    effectsSdk: {
                        version: f
                    }
                };
            } catch (g) {
                return void this.logger.warn(`Error while getting current effect state on LocalAudioStream for telemetry: ${g}`);
            }
        }
        setSource(g, f = !1) {
            if (g instanceof VideoDeviceInfoImpl) this._telemetryLogManager = g.deviceManager.telemetryLogManager, this._source = g, this._mediaStreamType = "ScreenSharing" === g.deviceType ? "ScreenSharing" : "Video", this._mediaStreamSource = void 0, this._rawStream = void 0, this._canStartEffects = !0;
            else {
                try {
                    1 === globalThis[Ff] && (this._telemetryLogManager = globalThis[Lf]);
                } catch (g) {
                    this.logger.error("Failed to retrive telemetry logger for localVideoStream");
                }
                this._source = {
                    name: "CustomMediaStream",
                    id: generateGuid(),
                    deviceType: "Virtual"
                }, this._mediaStreamSource = g, this._mediaStreamType = "RawMedia", this._canStartEffects = !1;
            }
            f || this._eventEmitter.emit("videoSourceChanged", {
                source: this
            });
        }
        subscribeToRawStreamChangedIfNeeded() {
            var _this__rawStream;
            this._source instanceof VideoDeviceInfoImpl && !this._videoSourceChangedSub && (this._videoSourceChangedSub = (_this__rawStream = this._rawStream) === null || _this__rawStream === void 0 ? void 0 : _this__rawStream.changed(()=>{
                this._eventEmitter.emit("videoSourceChanged", {
                    source: this
                });
            }));
        }
        _cacheCloneStream(g) {
            this._rawStreamCloneCache.add(g);
        }
        disposeRawStream() {
            var _g_getTracks, _this__videoSourceChangedSub;
            this._rawStream && this._rawStream.dispose();
            for (const g of Array.from(this._rawStreamCloneCache))g === null || g === void 0 ? void 0 : (_g_getTracks = g.getTracks) === null || _g_getTracks === void 0 ? void 0 : _g_getTracks.call(g).forEach((g)=>g.stop());
            this._rawStreamCloneCache.clear(), (_this__videoSourceChangedSub = this._videoSourceChangedSub) === null || _this__videoSourceChangedSub === void 0 ? void 0 : _this__videoSourceChangedSub.dispose(), this._videoSourceChangedSub = void 0;
        }
        constructor(g){
            if (this._disposed = !1, this._call = new Set, this._canStartEffects = !1, this.kind = "LocalVideoStream", this._renderers = [], this._rawStreamCloneCache = new Set, this._disposeRenderer = (g)=>{
                this.logger.log("disposing renderer");
                try {
                    g.dispose(), this.logger.log("renderer disposed");
                } catch (g) {
                    this.logger.log("failed to dispose renderer");
                }
            }, !(g instanceof VideoDeviceInfoImpl || g instanceof MediaStream)) throw new CallingCommunicationError({
                defaultError: O.LOCAL_VIDEO_STREAM.WRONG_STREAM_TYPE
            });
            const S = f.createClientLogger("ACS-calling");
            this.logger = new DefaultLogger(S, [
                ()=>`LocalVideoStream:${g.id}`
            ]), this.logger.info("created"), this._eventEmitter = new CallingEventEmitter(this.logger), this.setSource(g, !0), this._localStreamTelemetryEventSender = new StreamTelemetryEventSender(this._telemetryLogManager);
        }
    }
    __decorate$4([
        loggerProperty,
        __metadata$4("design:type", Object)
    ], LocalVideoStream.prototype, "logger", void 0), __decorate$4([
        asyncOperation(OS.SwitchSource),
        __metadata$4("design:type", Function),
        __metadata$4("design:paramtypes", [
            Object
        ]),
        __metadata$4("design:returntype", Promise)
    ], LocalVideoStream.prototype, "switchSource", null), __decorate$4([
        asyncOperation(OS.GetMediaStream),
        __metadata$4("design:type", Function),
        __metadata$4("design:paramtypes", []),
        __metadata$4("design:returntype", Promise)
    ], LocalVideoStream.prototype, "getMediaStream", null), __decorate$4([
        asyncOperation(OS.SetMediaStream),
        __metadata$4("design:type", Function),
        __metadata$4("design:paramtypes", [
            MediaStream
        ]),
        __metadata$4("design:returntype", Promise)
    ], LocalVideoStream.prototype, "setMediaStream", null), __decorate$4([
        syncOperation(OS.Feature),
        __metadata$4("design:type", Function),
        __metadata$4("design:paramtypes", [
            Object
        ]),
        __metadata$4("design:returntype", "function" == typeof (HE = "undefined" != typeof TFeature && TFeature) ? HE : Object)
    ], LocalVideoStream.prototype, "feature", null);
    class AudioDeviceInfoImpl {
        get name() {
            return this._name;
        }
        setName(g) {
            this._name = g;
        }
        get id() {
            return this._id;
        }
        setId(g) {
            this._id = g;
        }
        get isSystemDefault() {
            return this._isSystemDefault;
        }
        setIsSystemDefault(g) {
            this._isSystemDefault = g;
        }
        get deviceType() {
            return this._deviceType;
        }
        setDeviceType(g) {
            this._deviceType = g;
        }
        get deviceManager() {
            return this._deviceManager;
        }
        constructor(g, f, S, v, _){
            this._name = g, this._id = f, this._isSystemDefault = S, this._deviceType = v, this._deviceManager = _;
        }
    }
    var __decorate$5 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$5 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class VolumeImpl {
        get isInitialized() {
            return this._isInitialized;
        }
        initialize(g) {
            if (void 0 === g) throw this.logger.error("failed to getMediaStreamTrack"), new CallingCommunicationError({
                defaultError: O.CALL.VOLUME_TRACK
            });
            const f = generateGuid(), S = +new Date;
            try {
                this.sendVolumeEvent({
                    eventName: dy.acs_calling_audio_stream_volume,
                    correlationId: f,
                    callId: this._callId || "",
                    localParticipantId: this._localParticipantId || "",
                    streamType: this._streamType,
                    kindOfEvent: "attempt",
                    timestampInfo: "",
                    additionalDetails: ""
                }), this.bindToAudioStreamVolume(g), this.sendVolumeEvent({
                    eventName: dy.acs_calling_audio_stream_volume,
                    correlationId: f,
                    callId: this._callId || "",
                    localParticipantId: this._localParticipantId || "",
                    streamType: this._streamType,
                    kindOfEvent: "success",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: ""
                });
            } catch (g) {
                const v = new CallingCommunicationError({
                    defaultError: O.CALL.VOLUME_INIT,
                    originalError: g
                });
                throw this.logger.error(v.message), this.sendVolumeEvent({
                    eventName: dy.acs_calling_audio_stream_volume,
                    correlationId: f,
                    callId: this._callId || "",
                    localParticipantId: this._localParticipantId || "",
                    streamType: this._streamType,
                    kindOfEvent: "failure",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        subCode: v.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    }
                }), v;
            }
        }
        bindToAudioStreamVolume(g) {
            var _getAcsEcsConfig_volumeIndicator, _getAcsEcsConfig;
            let [f, S] = this.setupVolumeCalculator(g);
            this._level = f();
            let v = setInterval(()=>{
                let g = f();
                g !== this._level && (this._level = g, this._eventEmitter.emit("levelChanged"));
            }, (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_volumeIndicator = _getAcsEcsConfig.volumeIndicator) === null || _getAcsEcsConfig_volumeIndicator === void 0 ? void 0 : _getAcsEcsConfig_volumeIndicator.microphoneVolumeSampleIntervalMs);
            this._volumeCallBackInterval = v, this._audioContext = S;
        }
        setupVolumeCalculator(g) {
            const f = new MediaStream(g), S = new AudioContext, v = S.createMediaStreamSource(f), _ = S.createAnalyser();
            v.connect(_), _.fftSize = getAcsEcsConfig().volumeIndicator.fftSize, _.minDecibels = getAcsEcsConfig().volumeIndicator.minDecibels, _.maxDecibels = getAcsEcsConfig().volumeIndicator.maxDecibels, _.smoothingTimeConstant = getAcsEcsConfig().volumeIndicator.smoothingConstant;
            const C = new Uint8Array(_.frequencyBinCount);
            return [
                ()=>{
                    try {
                        _.getByteFrequencyData(C);
                        let g = 0;
                        for (const f of C)g += f;
                        const f = g / C.length;
                        return f * getAcsEcsConfig().volumeIndicator.normalisedMaxVolume / getAcsEcsConfig().volumeIndicator.maxAvailableVolume;
                    } catch (g) {
                        return this.logger.error("error in calculating audio stream volume"), 0;
                    }
                },
                S
            ];
        }
        dispose() {
            this._isInitialized = !1, this._level = 0, this._eventEmitter.removeAllListeners();
            try {
                var _this__audioContext;
                (_this__audioContext = this._audioContext) === null || _this__audioContext === void 0 ? void 0 : _this__audioContext.close().catch((g)=>{
                    this.logger.error("unable to close AudioContext");
                });
            } catch (g) {
                this.logger.error("unable to close MicrophoneAudioContext");
            }
            this._volumeCallBackInterval && clearInterval(this._volumeCallBackInterval);
        }
        on(g, f) {
            if ("levelChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.VOLUME_EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("levelChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.VOLUME_EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        get level() {
            return this._level;
        }
        getVolumeIndicator(g) {
            const executeSerialisedAsync = ()=>{
                if (!this.isInitialized) try {
                    this.initialize(g), this._isInitialized = !0;
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.CALL.VOLUME_GET,
                        originalError: g
                    });
                    throw this.logger.error(f.message), f;
                }
                return this;
            }, f = this._workQueue.then(()=>executeSerialisedAsync());
            return this._workQueue = f.then(noop, noop), f;
        }
        sendVolumeEvent(g) {
            try {
                var _this__telemetryLogManager;
                (_this__telemetryLogManager = this._telemetryLogManager) === null || _this__telemetryLogManager === void 0 ? void 0 : _this__telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send screen share telemetry");
            }
        }
        constructor(g, f, S, v, _){
            this._workQueue = Promise.resolve(), this.logger = g.createChild("volume indicator"), this._eventEmitter = new CallingEventEmitter(this.logger, {
                enableLogEmit: !1
            }), this._isInitialized = !1, this._level = 0, this._streamType = f, this._callId = v, this._localParticipantId = _, this._telemetryLogManager = S;
        }
    }
    __decorate$5([
        loggerProperty,
        __metadata$5("design:type", Object)
    ], VolumeImpl.prototype, "logger", void 0);
    class BrowserAudioEffectsHelper {
        async setBrowserAudioEffects(g, f, S) {
            try {
                await this._updateCurrentActive(f);
                const v = {
                    autoGainControl: void 0 !== S.autoGainControl ? S.autoGainControl : this._currentActiveBrowserEffects.autoGainControl,
                    echoCancellation: void 0 !== S.echoCancellation ? S.echoCancellation : this._currentActiveBrowserEffects.echoCancellation,
                    noiseSuppression: void 0 !== S.noiseSuppression ? S.noiseSuppression : this._currentActiveBrowserEffects.noiseSuppression
                }, _ = this._calculateFlags(v);
                this._logger.info(`Setting browser audio processing flags to ${_}`), await g.setAudioProcessingFlags(_);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.AUDIO_FLAGS,
                    originalError: g
                });
            }
        }
        async _updateCurrentActive(g) {
            try {
                var _S_getAudioTracks, _f_autoGainControl, _f_echoCancellation, _f_noiseSuppression;
                const f = g !== null && g !== void 0 ? g : this._effectsStatusManager.getActiveEffects();
                if (!this._localAudioStream.canStartEffects) throw new Error("Cannot proceed to update current browser audio effects, most likely source is not supported for audio effects");
                const S = await this._localAudioStream.getMediaStream(), v = S === null || S === void 0 ? void 0 : (_S_getAudioTracks = S.getAudioTracks()) === null || _S_getAudioTracks === void 0 ? void 0 : _S_getAudioTracks[0];
                if (!v) throw new Error("Could not get MediaStreamTrack from the LocalAudioStream");
                const _ = v.getSettings();
                let C = !!(_ === null || _ === void 0 ? void 0 : _.autoGainControl), E = !!(_ === null || _ === void 0 ? void 0 : _.noiseSuppression), T = !!(_ === null || _ === void 0 ? void 0 : _.echoCancellation);
                this._currentActiveBrowserEffects = {}, ("BrowserAutoGainControl" === (f === null || f === void 0 ? void 0 : (_f_autoGainControl = f.autoGainControl) === null || _f_autoGainControl === void 0 ? void 0 : _f_autoGainControl[0]) || C) && (this._currentActiveBrowserEffects.autoGainControl = !0), ("BrowserEchoCancellation" === (f === null || f === void 0 ? void 0 : (_f_echoCancellation = f.echoCancellation) === null || _f_echoCancellation === void 0 ? void 0 : _f_echoCancellation[0]) || T) && (this._currentActiveBrowserEffects.echoCancellation = !0), ("BrowserNoiseSuppression" === (f === null || f === void 0 ? void 0 : (_f_noiseSuppression = f.noiseSuppression) === null || _f_noiseSuppression === void 0 ? void 0 : _f_noiseSuppression[0]) || E) && (this._currentActiveBrowserEffects.noiseSuppression = !0);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.AUDIO_FLAGS,
                    originalError: g
                });
            }
        }
        _calculateFlags(g) {
            let f = 0;
            return g.autoGainControl && (f += 1), g.echoCancellation && (f += 2), g.noiseSuppression && (f += 4), f;
        }
        constructor(g, f, S){
            this._effectsStatusManager = g, this._logger = f, this._localAudioStream = S, this._currentActiveBrowserEffects = {}, this._updateCurrentActive();
        }
    }
    var __decorate$6 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$6 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class AudioEffectsFeatureImpl extends FirstPartyAudioStreamFeature {
        initialize(g, f) {
            this._logger = f.createChild(" - AudioEffects:"), this._telemetryLogManager = g.telemetryLogManager, this.updateAudioEffectsStatusManager();
        }
        get name() {
            return "AudioEffects";
        }
        get activeEffects() {
            var _this__effectsStatusManager_getActiveEffects, _this__effectsStatusManager;
            var _this__effectsStatusManager_getActiveEffects1;
            return (_this__effectsStatusManager_getActiveEffects1 = (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : (_this__effectsStatusManager_getActiveEffects = _this__effectsStatusManager.getActiveEffects) === null || _this__effectsStatusManager_getActiveEffects === void 0 ? void 0 : _this__effectsStatusManager_getActiveEffects.call(_this__effectsStatusManager)) !== null && _this__effectsStatusManager_getActiveEffects1 !== void 0 ? _this__effectsStatusManager_getActiveEffects1 : this._activeEffects;
        }
        on(g, f) {
            if ("effectsStarted" !== g && "effectsStopped" !== g && "effectsError" !== g && "effectsProcessorStatsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("effectsStarted" !== g && "effectsStopped" !== g && "effectsError" !== g && "effectsProcessorStatsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        async isSupported(g) {
            const f = generateGuid(), S = +new Date, v = this.getUsageDetailsForTelemetry("", this.getEffectsNameForTelemetry(g));
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: f,
                operation: by.isSupported,
                kindOfEvent: uy.attempt,
                additionalDetails: {
                    usageDetails: v
                }
            });
            try {
                var _this__logger, _this__logger1, _this__logger2;
                if ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`isSupported attempted with input ${g}`), this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.START_DISPOSED
                });
                if (!this.streamInstance.canStartEffects) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SOURCE_UNSUPPORTED
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager);
                const v = this._internalDeviceManager.getEnvironmentInfoInternal();
                this._supportChecker || (this._supportChecker = new EffectsCapabilityChecker(this._logger, v));
                let _ = !1;
                if ("object" == typeof g) {
                    var _this__logger3;
                    const f = this.getEffectInternalCast(g);
                    _ = await this._supportChecker.audioEffectsSupported(f), (_this__logger3 = this._logger) === null || _this__logger3 === void 0 ? void 0 : _this__logger3.info(`Support check for ${f.name} resulted in: ${_}`);
                } else "string" == typeof g && (_ = await this._supportChecker.audioEffectsSupported(g), (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info(`Support check for ${g} resulted in: ${_}`));
                const C = this.getEffectsNameForTelemetry(g), E = this.getUsageDetailsForTelemetry("", C);
                return this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.isSupported,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.success,
                    additionalDetails: {
                        usageDetails: E
                    }
                }), (_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info("isSupported success"), _;
            } catch (v) {
                var _this__logger4;
                const _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SUPPORT_CHECK_FAILED,
                    originalError: v
                });
                (_this__logger4 = this._logger) === null || _this__logger4 === void 0 ? void 0 : _this__logger4.error(_.message);
                const C = this.getEffectsNameForTelemetry(g), E = this.getUsageDetailsForTelemetry("", C);
                throw this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.isSupported,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_),
                        usageDetails: E
                    }
                }), _;
            }
        }
        async startEffects(g) {
            const f = generateGuid(), S = +new Date, v = this.getUsageDetailsForTelemetry("", JSON.stringify(this.getEffectsConfigForTelemetry(g)));
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: f,
                operation: by.startEffects,
                kindOfEvent: uy.attempt,
                additionalDetails: {
                    usageDetails: v
                }
            });
            try {
                var _this__logger, _v_audioEffects, _this__logger1, _this__effectsStatusManager, _this__logger2;
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`startEffects attempted with input ${JSON.stringify(this.getEffectsConfigForTelemetry(g))}`);
                const v = getAcsEcsConfig();
                if (!(v === null || v === void 0 ? void 0 : (_v_audioEffects = v.audioEffects) === null || _v_audioEffects === void 0 ? void 0 : _v_audioEffects.enableAudioEffects)) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.DISABLED
                });
                if (this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.START_DISPOSED
                });
                if (!this.streamInstance.canStartEffects) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SOURCE_UNSUPPORTED
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager);
                const _ = this._internalDeviceManager.getTsDeviceManager();
                if (!_) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.START_DEVICE_MANAGER
                });
                await this.updateAudioEffectsStatusManager(), this.subscribeToStreamInstanceEvents(), this.disposeEffectEventSubscriptions(), this.subscribeToEffectEvents();
                let C = this.activeEffects;
                (g === null || g === void 0 ? void 0 : g.autoGainControl) && (C = await this.startStopAutoGainControl(_, C, !0, g.autoGainControl)), (g === null || g === void 0 ? void 0 : g.echoCancellation) && (C = await this.startStopEchoCancellation(_, C, !0, g.echoCancellation)), (g === null || g === void 0 ? void 0 : g.noiseSuppression) && (C = await this.startStopNoiseSuppression(_, C, !0, g.noiseSuppression)), this._currentTsWasmEffectType !== this._previousTsWasmEffectType && ((_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info(`Setting tsDeviceManager setAudioEffectsAsync API with ${this._currentTsWasmEffectType}`), await _.setAudioEffectsAsync("", this._currentTsWasmEffectType)), (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.setActiveEffects(C, "start"), await this.subscribeToStatUpdates();
                const E = JSON.stringify(C), T = this.getUsageDetailsForTelemetry("", E);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.startEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.success,
                    additionalDetails: {
                        usageDetails: T
                    }
                }), (_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info("startEffects success");
            } catch (v) {
                var _this__logger3;
                const _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.START_FAILED,
                    originalError: v
                });
                (_this__logger3 = this._logger) === null || _this__logger3 === void 0 ? void 0 : _this__logger3.error(_.message), this.eventEmitter.emit("effectsError", _);
                const C = JSON.stringify(this.getEffectsConfigForTelemetry(g)), E = this.getUsageDetailsForTelemetry("", C);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.startEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_),
                        usageDetails: E
                    }
                });
            }
        }
        async stopEffects(g) {
            const f = generateGuid(), S = +new Date, v = this.getUsageDetailsForTelemetry("", JSON.stringify(this.getEffectsConfigForTelemetry(g)));
            this.sendFeatureUsageTelemetry({
                eventName: dy.acs_calling_media_stream,
                correlationId: f,
                operation: by.stopEffects,
                kindOfEvent: uy.attempt,
                additionalDetails: {
                    usageDetails: v
                }
            });
            try {
                var _this__logger, _this__logger1, _this__effectsStatusManager, _this__logger2;
                if ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`stopEffects attempted with input ${JSON.stringify(this.getEffectsConfigForTelemetry(g))}`), this.disposed) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.STOP_DISPOSED
                });
                this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager);
                const v = this._internalDeviceManager.getTsDeviceManager();
                if (!v) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.STOP_DEVICE_MANAGER
                });
                await this.updateAudioEffectsStatusManager();
                let _ = this.activeEffects;
                (g === null || g === void 0 ? void 0 : g.autoGainControl) && (_ = await this.startStopAutoGainControl(v, _, !1)), (g === null || g === void 0 ? void 0 : g.echoCancellation) && (_ = await this.startStopEchoCancellation(v, _, !1)), (g === null || g === void 0 ? void 0 : g.noiseSuppression) && (_ = await this.startStopNoiseSuppression(v, _, !1)), this._currentTsWasmEffectType !== this._previousTsWasmEffectType && ((_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info(`Setting tsDeviceManager setAudioEffectsAsync API with ${this._currentTsWasmEffectType}`), await v.setAudioEffectsAsync("", this._currentTsWasmEffectType)), (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.setActiveEffects(_, "stop"), this.unsubscribeFromStatUpdates(), this.unsubscribeFromStreamInstanceEvents();
                const C = JSON.stringify(_), E = this.getUsageDetailsForTelemetry("", C);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.stopEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.success,
                    additionalDetails: {
                        usageDetails: E
                    }
                }), (_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info("stopEffects success");
            } catch (v) {
                var _this__logger3;
                const _ = new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.STOP_FAILED,
                    originalError: v
                });
                (_this__logger3 = this._logger) === null || _this__logger3 === void 0 ? void 0 : _this__logger3.error(_.message), this.eventEmitter.emit("effectsError", _);
                const C = JSON.stringify(this.getEffectsConfigForTelemetry(g)), E = this.getUsageDetailsForTelemetry("", C);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.stopEffects,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_),
                        usageDetails: E
                    }
                });
            }
        }
        async dispose() {
            const stopEffectsIfStreamNotDisposed = async ()=>{
                try {
                    var _this__internalDeviceManager;
                    const g = (_this__internalDeviceManager = this._internalDeviceManager) === null || _this__internalDeviceManager === void 0 ? void 0 : _this__internalDeviceManager.getTsDeviceManager();
                    if (g) {
                        let f = await this.startStopAutoGainControl(g, this._activeEffects, !1);
                        f = await this.startStopEchoCancellation(g, f, !1), await this.startStopNoiseSuppression(g, f, !1);
                    }
                } catch (g) {
                    var _this__logger;
                    (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`Error stopping effects before disposing: ${g.message}`);
                }
            };
            try {
                var _this__logger, _this__logger1, _this__effectsStatusManager, _this__effectsStatusManager1, _this__logger2;
                if ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("dispose attempt"), this.disposed) return void ((_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("AudioEffects feature already disposed"));
                await stopEffectsIfStreamNotDisposed(), this.unsubscribeFromStatUpdates(), this.unsubscribeFromStreamInstanceEvents(), this._currentEffects = {}, (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.setActiveEffects({
                    echoCancellation: [],
                    noiseSuppression: [],
                    autoGainControl: []
                }, "dispose"), this.eventEmitter.removeAllListeners(), this.serialQueue.dispose(), (_this__effectsStatusManager1 = this._effectsStatusManager) === null || _this__effectsStatusManager1 === void 0 ? void 0 : _this__effectsStatusManager1.off("statusChanged", this.effectStatusChangedCallback), this.disposed = !0, (_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info("AudioEffects feature disposed");
            } catch (g) {
                var _this__logger3;
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.DISPOSE_FAILED,
                    originalError: g
                });
                (_this__logger3 = this._logger) === null || _this__logger3 === void 0 ? void 0 : _this__logger3.error(f.message), this.eventEmitter.emit("effectsError", f);
            }
        }
        get audioEffectsProcessorStats() {
            return this._audioEffectsProcessorStats;
        }
        getEffectsSdkVersion() {
            var _f__internalHandle;
            let g = this._stringForUnknownInput;
            const f = this.getAnyActiveWasmEffect();
            return f && ((_f__internalHandle = f._internalHandle) === null || _f__internalHandle === void 0 ? void 0 : _f__internalHandle.getVersion) && (g = f._internalHandle.getVersion()), this.truncateToMax(g);
        }
        getActiveEffectsForTelemetry() {
            return this.truncateToMax(JSON.stringify(this.activeEffects));
        }
        async updateAudioEffectsStatusManager() {
            var _this__logger;
            if (this.streamInstance.canStartEffects) {
                if (this._internalDeviceManager || (this._internalDeviceManager = this.streamInstance.source.deviceManager), !this._effectsStatusManager) {
                    var _this__logger1;
                    if (this._effectsStatusManager = this._internalDeviceManager.callStackAudioEffectsStatusManager, this._effectsStatusManager.on("statusChanged", this.effectStatusChangedCallback), this.streamInstance.canStartEffects) {
                        var _g_getAudioTracks, _this__effectsStatusManager;
                        const g = await this.streamInstance.getMediaStream(), f = g === null || g === void 0 ? void 0 : (_g_getAudioTracks = g.getAudioTracks()) === null || _g_getAudioTracks === void 0 ? void 0 : _g_getAudioTracks[0], S = f === null || f === void 0 ? void 0 : f.getSettings();
                        (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.setActiveEffects({
                            autoGainControl: S.autoGainControl ? [
                                "BrowserAutoGainControl"
                            ] : [],
                            echoCancellation: S.echoCancellation ? [
                                "BrowserEchoCancellation"
                            ] : [],
                            noiseSuppression: S.noiseSuppression ? [
                                "BrowserNoiseSuppression"
                            ] : []
                        }, "initialize");
                    } else (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.debug("Cannot process initial browser audio effects status, most likely LocalAudioStream source is not AudioDeviceInfo");
                }
                this._activeEffects = this._effectsStatusManager.getActiveEffects(), this._browserAudioEffectsManager || (this._browserAudioEffectsManager = new BrowserAudioEffectsHelper(this._effectsStatusManager, this._logger, this.streamInstance));
            } else (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.warn("Cannot update status manager, current source is not supported.");
        }
        async initializeWasmVqeInStack(g) {
            var _this__logger;
            if (this._wasmVqeInitialized) return void ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("WasmVqe initialized already"));
            if (!this._internalDeviceManager) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.FAILED_TO_GET_DM
            });
            const f = await g._internalHandle.getEffectProvider();
            if (!f) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.PROVIDER_UNAVAILABLE
            });
            const S = await f.getAudioEffectProvider(), v = this.streamInstance.callStackWasmVqeProvider;
            if (!v) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.AEC_PROVIDER_MISSING
            });
            v.providerValue = S, this._wasmVqeInitialized = !0;
        }
        getEffectInternalCast(g) {
            if ("EchoCancellation" === (g === null || g === void 0 ? void 0 : g.name) && this.isValidEffectInstance(g)) return g;
            if ("DeepNoiseSuppression" === (g === null || g === void 0 ? void 0 : g.name) && this.isValidEffectInstance(g)) return g;
            throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT
            });
        }
        isValidEffectInstance(g) {
            let f;
            return ("EchoCancellation" === g.name && g._internalHandle || !("DeepNoiseSuppression" !== g.name || !g._internalHandle)) && (f = g, this.hasValidInternalHandle(f._internalHandle));
        }
        hasValidInternalHandle(g) {
            return !!(g.getEffectProvider && g.dispose && g.setConfig && g.handleProcessingError);
        }
        updateCurrentTsWasmAudioEffectType(g, f, S) {
            var _this__effectsStatusManager, _v_echoCancellation, _v_noiseSuppression;
            const v = S !== null && S !== void 0 ? S : (_this__effectsStatusManager = this._effectsStatusManager) === null || _this__effectsStatusManager === void 0 ? void 0 : _this__effectsStatusManager.getActiveEffects();
            let _ = !!(v === null || v === void 0 ? void 0 : (_v_echoCancellation = v.echoCancellation) === null || _v_echoCancellation === void 0 ? void 0 : _v_echoCancellation.includes("EchoCancellation")), C = !!(v === null || v === void 0 ? void 0 : (_v_noiseSuppression = v.noiseSuppression) === null || _v_noiseSuppression === void 0 ? void 0 : _v_noiseSuppression.includes("DeepNoiseSuppression"));
            switch(g){
                case "EchoCancellation":
                    _ = f;
                    break;
                case "DeepNoiseSuppression":
                    C = f;
            }
            this._previousTsWasmEffectType = this._currentTsWasmEffectType, this._currentTsWasmEffectType = _ && C ? 16 : _ ? 4 : C ? 2 : 0;
        }
        subscribeToStreamInstanceEvents() {
            var _this__logger;
            this._sourceStreamSubscription && ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Already subscribed to audioSourceChanged before, removing old sub"), this.streamInstance.off("audioSourceChanged", this._sourceStreamSubscription)), this._sourceStreamSubscription = async (g)=>{
                g.source && "Audio" !== g.source.mediaStreamType && await this.stopEffects({
                    echoCancellation: !0,
                    noiseSuppression: !0
                });
            }, this.streamInstance.on("audioSourceChanged", this._sourceStreamSubscription);
        }
        unsubscribeFromStreamInstanceEvents() {
            var _this__logger;
            this._sourceStreamSubscription ? (this.streamInstance.off("audioSourceChanged", this._sourceStreamSubscription), this._sourceStreamSubscription = null) : (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("No audioSourceChanged sub active");
        }
        subscribeToEffectEvents() {
            var _this__currentEffects_echoCancellation, _this__currentEffects_echoCancellation1, _this__currentEffects_noiseSuppression, _this__currentEffects_noiseSuppression1;
            "object" == typeof this._currentEffects.echoCancellation && ((_this__currentEffects_echoCancellation = this._currentEffects.echoCancellation) === null || _this__currentEffects_echoCancellation === void 0 ? void 0 : _this__currentEffects_echoCancellation._internalHandle.on("configUpdated", this.configUpdatedCallback), (_this__currentEffects_echoCancellation1 = this._currentEffects.echoCancellation) === null || _this__currentEffects_echoCancellation1 === void 0 ? void 0 : _this__currentEffects_echoCancellation1._internalHandle.on("processingError", this.processingErrorCallback)), "object" == typeof this._currentEffects.noiseSuppression && ((_this__currentEffects_noiseSuppression = this._currentEffects.noiseSuppression) === null || _this__currentEffects_noiseSuppression === void 0 ? void 0 : _this__currentEffects_noiseSuppression._internalHandle.on("configUpdated", this.configUpdatedCallback), (_this__currentEffects_noiseSuppression1 = this._currentEffects.noiseSuppression) === null || _this__currentEffects_noiseSuppression1 === void 0 ? void 0 : _this__currentEffects_noiseSuppression1._internalHandle.on("processingError", this.processingErrorCallback));
        }
        disposeEffectEventSubscriptions() {
            var _this__currentEffects_echoCancellation, _this__currentEffects_echoCancellation1, _this__currentEffects_noiseSuppression, _this__currentEffects_noiseSuppression1;
            "object" == typeof this._currentEffects.echoCancellation && ((_this__currentEffects_echoCancellation = this._currentEffects.echoCancellation) === null || _this__currentEffects_echoCancellation === void 0 ? void 0 : _this__currentEffects_echoCancellation._internalHandle.off("configUpdated", this.configUpdatedCallback), (_this__currentEffects_echoCancellation1 = this._currentEffects.echoCancellation) === null || _this__currentEffects_echoCancellation1 === void 0 ? void 0 : _this__currentEffects_echoCancellation1._internalHandle.off("processingError", this.processingErrorCallback)), "object" == typeof this._currentEffects.noiseSuppression && ((_this__currentEffects_noiseSuppression = this._currentEffects.noiseSuppression) === null || _this__currentEffects_noiseSuppression === void 0 ? void 0 : _this__currentEffects_noiseSuppression._internalHandle.off("configUpdated", this.configUpdatedCallback), (_this__currentEffects_noiseSuppression1 = this._currentEffects.noiseSuppression) === null || _this__currentEffects_noiseSuppression1 === void 0 ? void 0 : _this__currentEffects_noiseSuppression1._internalHandle.off("processingError", this.processingErrorCallback));
        }
        setConfigForEffects(g) {
            var _S_wasmvqe, _v_audioEffects, _S_wasmvqe1, _this__logger;
            const f = g._internalHandle.configProvider.config.audioEffects, S = getMediaConfig(), v = getAcsEcsConfig();
            (S === null || S === void 0 ? void 0 : (_S_wasmvqe = S.wasmvqe) === null || _S_wasmvqe === void 0 ? void 0 : _S_wasmvqe.enableVqe) && (v === null || v === void 0 ? void 0 : (_v_audioEffects = v.audioEffects) === null || _v_audioEffects === void 0 ? void 0 : _v_audioEffects.enableAudioEffects) && (f.enableAudioEffects = (S === null || S === void 0 ? void 0 : (_S_wasmvqe1 = S.wasmvqe) === null || _S_wasmvqe1 === void 0 ? void 0 : _S_wasmvqe1.enableVqe) && v.audioEffects.enableAudioEffects), g._internalHandle.setConfig(f), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info(`Config for audio effects set: ${stringifyObject(f)}`);
        }
        async startStopAutoGainControl(g, f, S, v) {
            try {
                var _f_autoGainControl;
                if (S && v) {
                    var _this__browserAudioEffectsManager, _this__logger;
                    if (!await this.isSupported(v)) {
                        const g = this.getEffectsNameForTelemetry(v);
                        throw new CallingCommunicationError({
                            defaultError: O.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,
                            defaultErrorMessageArgs: [
                                JSON.stringify(g)
                            ]
                        });
                    }
                    if ("BrowserAutoGainControl" !== v) throw new CallingCommunicationError({
                        defaultError: O.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_GAINCONTROL
                    });
                    return await ((_this__browserAudioEffectsManager = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager === void 0 ? void 0 : _this__browserAudioEffectsManager.setBrowserAudioEffects(g, f, {
                        autoGainControl: !0
                    })), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Browser auto gain control started"), this._currentEffects.autoGainControl = v, f.autoGainControl = [
                        v
                    ], f;
                }
                var _f_autoGainControl_;
                switch((_f_autoGainControl_ = f === null || f === void 0 ? void 0 : (_f_autoGainControl = f.autoGainControl) === null || _f_autoGainControl === void 0 ? void 0 : _f_autoGainControl[0]) !== null && _f_autoGainControl_ !== void 0 ? _f_autoGainControl_ : ""){
                    case "":
                    case "BrowserAutoGainControl":
                        var _this__browserAudioEffectsManager1, _this__logger1;
                        await ((_this__browserAudioEffectsManager1 = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager1 === void 0 ? void 0 : _this__browserAudioEffectsManager1.setBrowserAudioEffects(g, f, {
                            autoGainControl: !1
                        })), (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Browser auto gain control stopped");
                }
                return f.autoGainControl = [], this._currentEffects.autoGainControl = void 0, f;
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SET_AUTO_GAIN_CONTROL,
                    defaultErrorMessageArgs: [
                        S
                    ],
                    originalError: g
                });
            }
        }
        async startStopEchoCancellation(g, f, S, v) {
            try {
                var _f_echoCancellation;
                if (S && v) {
                    var _this__browserAudioEffectsManager, _this__logger;
                    if (!await this.isSupported(v)) {
                        const g = this.getEffectsNameForTelemetry(v);
                        throw new CallingCommunicationError({
                            defaultError: O.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,
                            defaultErrorMessageArgs: [
                                JSON.stringify(g)
                            ]
                        });
                    }
                    if ("string" == typeof v && "BrowserEchoCancellation" === v) "EchoCancellation" === f.echoCancellation[0] && (await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression), this.updateCurrentTsWasmAudioEffectType("EchoCancellation", !1, f), f.echoCancellation = []), await ((_this__browserAudioEffectsManager = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager === void 0 ? void 0 : _this__browserAudioEffectsManager.setBrowserAudioEffects(g, f, {
                        echoCancellation: !0
                    })), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Browser echo cancellation started"), this._currentEffects.echoCancellation = v, f.echoCancellation = [
                        v
                    ];
                    else {
                        if ("object" != typeof v) throw new CallingCommunicationError({
                            defaultError: O.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_ECHO
                        });
                        this._currentEffects.echoCancellation = this.getEffectInternalCast(v), this.setConfigForEffects(this._currentEffects.echoCancellation), await this.initializeWasmVqeInStack(this._currentEffects.echoCancellation), this.updateCurrentTsWasmAudioEffectType(this._currentEffects.echoCancellation.name, !0, f), f.echoCancellation = [
                            this._currentEffects.echoCancellation.name
                        ];
                    }
                    return f;
                }
                var _f_echoCancellation_;
                switch((_f_echoCancellation_ = f === null || f === void 0 ? void 0 : (_f_echoCancellation = f.echoCancellation) === null || _f_echoCancellation === void 0 ? void 0 : _f_echoCancellation[0]) !== null && _f_echoCancellation_ !== void 0 ? _f_echoCancellation_ : ""){
                    case "":
                    case "BrowserEchoCancellation":
                        var _this__browserAudioEffectsManager1, _this__logger1;
                        await ((_this__browserAudioEffectsManager1 = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager1 === void 0 ? void 0 : _this__browserAudioEffectsManager1.setBrowserAudioEffects(g, f, {
                            echoCancellation: !1
                        })), (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Browser echo cancellation stopped");
                        break;
                    case "EchoCancellation":
                        await this.initializeWasmVqeInStack(this._currentEffects.echoCancellation), this.updateCurrentTsWasmAudioEffectType("EchoCancellation", !1, f);
                }
                return f.echoCancellation = [], this._currentEffects.echoCancellation = void 0, f;
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SET_ECHO_CANCELLATION,
                    defaultErrorMessageArgs: [
                        S
                    ],
                    originalError: g
                });
            }
        }
        async startStopNoiseSuppression(g, f, S, v) {
            try {
                var _f_noiseSuppression;
                if (S && v) {
                    var _this__browserAudioEffectsManager, _this__logger;
                    if (!await this.isSupported(v)) {
                        const g = this.getEffectsNameForTelemetry(v);
                        throw new CallingCommunicationError({
                            defaultError: O.FEATURES.AUDIO_EFFECTS.UNSUPPORTED_EFFECT,
                            defaultErrorMessageArgs: [
                                JSON.stringify(g)
                            ]
                        });
                    }
                    if ("string" == typeof v && "BrowserNoiseSuppression" === v) "DeepNoiseSuppression" === f.noiseSuppression[0] && (await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression), this.updateCurrentTsWasmAudioEffectType("DeepNoiseSuppression", !1, f), f.noiseSuppression = []), await ((_this__browserAudioEffectsManager = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager === void 0 ? void 0 : _this__browserAudioEffectsManager.setBrowserAudioEffects(g, f, {
                        noiseSuppression: !0
                    })), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Browser noise cancellation started"), f.noiseSuppression = [
                        v
                    ], this._currentEffects.noiseSuppression = v;
                    else {
                        if ("object" != typeof v) throw new CallingCommunicationError({
                            defaultError: O.FEATURES.AUDIO_EFFECTS.INVALID_EFFECT_NOISE_SUPP
                        });
                        this._currentEffects.noiseSuppression = this.getEffectInternalCast(v), this.setConfigForEffects(this._currentEffects.noiseSuppression), await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression), this.updateCurrentTsWasmAudioEffectType(this._currentEffects.noiseSuppression.name, !0, f), f.noiseSuppression = [
                            this._currentEffects.noiseSuppression.name
                        ];
                    }
                    return f;
                }
                var _f_noiseSuppression_;
                switch((_f_noiseSuppression_ = f === null || f === void 0 ? void 0 : (_f_noiseSuppression = f.noiseSuppression) === null || _f_noiseSuppression === void 0 ? void 0 : _f_noiseSuppression[0]) !== null && _f_noiseSuppression_ !== void 0 ? _f_noiseSuppression_ : ""){
                    case "":
                    case "BrowserNoiseSuppression":
                        var _this__browserAudioEffectsManager1, _this__logger1;
                        await ((_this__browserAudioEffectsManager1 = this._browserAudioEffectsManager) === null || _this__browserAudioEffectsManager1 === void 0 ? void 0 : _this__browserAudioEffectsManager1.setBrowserAudioEffects(g, f, {
                            noiseSuppression: !1
                        })), (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Browser noise suppression stopped");
                        break;
                    case "DeepNoiseSuppression":
                        await this.initializeWasmVqeInStack(this._currentEffects.noiseSuppression), this.updateCurrentTsWasmAudioEffectType("DeepNoiseSuppression", !1, f);
                }
                return f.noiseSuppression = [], this._currentEffects.noiseSuppression = void 0, f;
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.AUDIO_EFFECTS.SET_NOISE_SUPPRESSION,
                    defaultErrorMessageArgs: [
                        S
                    ],
                    originalError: g
                });
            }
        }
        sendFeatureUsageTelemetry(g) {
            var _this__logger;
            if (this._telemetryLogManager) {
                var _this_streamInstance_getCall;
                g.additionalDetails = {
                    ...g.additionalDetails,
                    callState: (_this_streamInstance_getCall = this.streamInstance.getCall()) === null || _this_streamInstance_getCall === void 0 ? void 0 : _this_streamInstance_getCall.state,
                    activeEffects: JSON.stringify(this.activeEffects),
                    effectsSdk: {
                        version: this.getEffectsSdkVersion()
                    }
                };
                try {
                    var _this_streamInstance_getCall1;
                    const f = {
                        correlationId: g.correlationId,
                        mediaType: Ty.AudioRaw,
                        streamType: Iy.Local,
                        operation: g.operation,
                        timestampInfo: g.timestampInfo || {},
                        kindOfEvent: g.kindOfEvent || "",
                        additionalDetails: g.additionalDetails || "",
                        callId: ((_this_streamInstance_getCall1 = this.streamInstance.getCall()) === null || _this_streamInstance_getCall1 === void 0 ? void 0 : _this_streamInstance_getCall1.id) || "",
                        localParticipantId: this.streamInstance.getLocalParticipantId() || ""
                    };
                    this._telemetryLogManager.sendEvent({
                        name: g.eventName,
                        tenant: nf,
                        properties: f
                    });
                } catch (f) {
                    var _this__logger1;
                    (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.debug(`Unable to send ${g.operation} telemetry`);
                }
            } else (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.debug("Telemetry error. Instance is undefined.");
        }
        getAnyActiveWasmEffect() {
            let g = null;
            for (const f of Object.values(this._currentEffects))f && "object" == typeof f && (g = f);
            return g;
        }
        getEffectsConfigForTelemetry(g) {
            let f = !1;
            "boolean" != typeof (g === null || g === void 0 ? void 0 : g.autoGainControl) && "boolean" != typeof (g === null || g === void 0 ? void 0 : g.echoCancellation) && "boolean" != typeof (g === null || g === void 0 ? void 0 : g.noiseSuppression) || (f = !0);
            let S = {};
            return S = f ? {
                autoGainControl: (g === null || g === void 0 ? void 0 : g.autoGainControl) && "boolean" == typeof (g === null || g === void 0 ? void 0 : g.autoGainControl) ? g === null || g === void 0 ? void 0 : g.autoGainControl : void 0,
                echoCancellation: (g === null || g === void 0 ? void 0 : g.echoCancellation) && "boolean" == typeof (g === null || g === void 0 ? void 0 : g.echoCancellation) ? g === null || g === void 0 ? void 0 : g.echoCancellation : void 0,
                noiseSuppression: (g === null || g === void 0 ? void 0 : g.noiseSuppression) && "boolean" == typeof (g === null || g === void 0 ? void 0 : g.noiseSuppression) ? g === null || g === void 0 ? void 0 : g.noiseSuppression : void 0
            } : {
                autoGainControl: this.getEffectsNameForTelemetry(g === null || g === void 0 ? void 0 : g.autoGainControl),
                echoCancellation: this.getEffectsNameForTelemetry(g === null || g === void 0 ? void 0 : g.echoCancellation),
                noiseSuppression: this.getEffectsNameForTelemetry(g === null || g === void 0 ? void 0 : g.noiseSuppression)
            }, Object.keys(S).forEach((g)=>{
                "" !== S[g] && void 0 !== S[g] || delete S[g];
            }), S;
        }
        getEffectsNameForTelemetry(g) {
            var _this__logger;
            return g ? "string" == typeof g ? this.truncateToMax(g) : (g === null || g === void 0 ? void 0 : g.name) && "string" == typeof (g === null || g === void 0 ? void 0 : g.name) ? this.truncateToMax(g.name) : ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.warn("Invalid effect object found"), this._stringForUnknownInput) : "";
        }
        getUsageDetailsForTelemetry(g, f) {
            const S = `${f ? `[${f}]` : ""}:${g !== null && g !== void 0 ? g : ""}`;
            return this.truncateToMax(S);
        }
        truncateToMax(g) {
            var _this__logger;
            const f = getAcsEcsConfig().audioEffects.maxStringLengthForTelemetry;
            return g.length > f ? ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Truncating audio effects info for telemetry"), g.substring(0, f - 2) + "..") : g;
        }
        constructor(){
            super(...arguments), this._wasmVqeInitialized = !1, this._activeEffects = {
                echoCancellation: [],
                noiseSuppression: [],
                autoGainControl: []
            }, this._currentEffects = {}, this._previousTsWasmEffectType = 0, this._currentTsWasmEffectType = 0, this._stringForUnknownInput = "UNKNOWN", this._audioEffectsProcessorStats = null, this._sourceStreamSubscription = null, this.effectStatusChangedCallback = (g, f, S)=>{
                var _this__logger;
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.debug(`Effects status changed from ${JSON.stringify(g)} to ${JSON.stringify(f)} with operationType: ${S}`), "start" !== S && "initialize" !== S || this.eventEmitter.emit("effectsStarted", f), "stop" === S && this.eventEmitter.emit("effectsStopped", f);
            }, this.configUpdatedCallback = async (g)=>{
                var _this__logger;
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("configUpdated callback, no-op.");
            }, this.processingErrorCallback = async (g)=>{
                var _this__logger;
                const f = generateGuid();
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("processingError callback"), this.eventEmitter.emit("effectsError", g);
                const S = this.getEffectsNameForTelemetry(this.activeEffects), v = this.getUsageDetailsForTelemetry("Internal handle error", S);
                this.sendFeatureUsageTelemetry({
                    eventName: dy.acs_calling_media_stream,
                    correlationId: f,
                    operation: by.stopEffects,
                    kindOfEvent: uy.failure,
                    additionalDetails: {
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(g),
                        usageDetails: v
                    }
                }), await this.stopEffects({
                    echoCancellation: !0,
                    noiseSuppression: !0
                });
            }, this.subscribeToStatUpdates = async ()=>{
                var _S_on, _this__logger;
                const g = this.getAnyActiveWasmEffect();
                if (!g) return;
                const f = await g._internalHandle.getEffectProvider(), S = await (f === null || f === void 0 ? void 0 : f.getAudioEffectProvider());
                let v = null;
                S && (this._audioEffectProviderSub = S === null || S === void 0 ? void 0 : (_S_on = S.on) === null || _S_on === void 0 ? void 0 : _S_on.call(S, "onMetricsUpdated", ()=>{
                    try {
                        var _v_speechLevels, _v_speechLevels1, _v_noiseLevels, _v_noiseLevels1, _v_speechLevels2, _v_speechLevels3;
                        v = (S === null || S === void 0 ? void 0 : S.getStats) && S.getStats(), v && (this._audioEffectsProcessorStats = {
                            activeAudioEffects: JSON.stringify(this.activeEffects),
                            audioEffectsSpeechProcessingStats: {
                                localAudioInputSpeechRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_speechLevels = v.speechLevels) === null || _v_speechLevels === void 0 ? void 0 : _v_speechLevels.nearEndInputRMS_dBFS,
                                localAudioOutputSpeechRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_speechLevels1 = v.speechLevels) === null || _v_speechLevels1 === void 0 ? void 0 : _v_speechLevels1.nearEndOutputRMS_dBFS,
                                localAudioInputNoiseRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_noiseLevels = v.noiseLevels) === null || _v_noiseLevels === void 0 ? void 0 : _v_noiseLevels.nearEndInputRMS_dBFS,
                                localAudioOutputNoiseRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_noiseLevels1 = v.noiseLevels) === null || _v_noiseLevels1 === void 0 ? void 0 : _v_noiseLevels1.nearEndOutputRMS_dBFS,
                                remoteAudioInputSpeechRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_speechLevels2 = v.speechLevels) === null || _v_speechLevels2 === void 0 ? void 0 : _v_speechLevels2.farEndInputRMS_dBFS,
                                remoteAudioOutputSpeechRMS_dBFS: v === null || v === void 0 ? void 0 : (_v_speechLevels3 = v.speechLevels) === null || _v_speechLevels3 === void 0 ? void 0 : _v_speechLevels3.farEndOutputRMS_dBFS
                            },
                            rawStats: JSON.stringify(v)
                        }), this.eventEmitter.emit("effectsProcessorStatsUpdated", this._audioEffectsProcessorStats);
                    } catch (g) {
                        var _this__logger;
                        (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.warn(`Could not emit audio effect processor stat event: ${g}`);
                    }
                }), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Subscribed to audioEffectsProvider stat updates"));
            }, this.unsubscribeFromStatUpdates = ()=>{
                var _this__logger, _this__audioEffectProviderSub, _this__logger1;
                this.getAnyActiveWasmEffect() ? (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("There is a wasm audio effect still active, skipping stat unsubscribe") : ((_this__audioEffectProviderSub = this._audioEffectProviderSub) === null || _this__audioEffectProviderSub === void 0 ? void 0 : _this__audioEffectProviderSub.dispose) && (this._audioEffectProviderSub.dispose(), this._audioEffectProviderSub = ()=>{}, this._audioEffectsProcessorStats = null, (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Unsubscribed from audioEffectsProvider stat updates"));
            };
        }
    }
    __decorate$6([
        sequentialize(),
        __metadata$6("design:type", Function),
        __metadata$6("design:paramtypes", [
            Object
        ]),
        __metadata$6("design:returntype", Promise)
    ], AudioEffectsFeatureImpl.prototype, "startEffects", null), __decorate$6([
        sequentialize(),
        __metadata$6("design:type", Function),
        __metadata$6("design:paramtypes", [
            Object
        ]),
        __metadata$6("design:returntype", Promise)
    ], AudioEffectsFeatureImpl.prototype, "stopEffects", null);
    var $E, jE, GE, __decorate$7 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$7 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class LocalAudioStream {
        on(g, f) {
            if ("audioSourceChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.LOCAL_AUDIO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("audioSourceChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.LOCAL_AUDIO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        feature(g) {
            return this._extensibleApi || (this._extensibleApi = new ExtensibleFeatureImpl(this.logger, {
                streamInstance: this
            }, {
                streamInstance: this,
                telemetryLogManager: this.telemetryLogManager
            })), this._extensibleApi.getApiObjectInstance(g.audioStreamApiCtor);
        }
        get mediaStreamType() {
            return this._mediaStreamType;
        }
        get source() {
            return this._source;
        }
        get telemetryLogManager() {
            return this._telemetryLogManager;
        }
        get callStackWasmVqeProvider() {
            var _this_source_deviceManager, _this_source;
            var _this_source_deviceManager_callStackWasmVqeProvider;
            return (_this_source_deviceManager_callStackWasmVqeProvider = (_this_source = this.source) === null || _this_source === void 0 ? void 0 : (_this_source_deviceManager = _this_source.deviceManager) === null || _this_source_deviceManager === void 0 ? void 0 : _this_source_deviceManager.callStackWasmVqeProvider) !== null && _this_source_deviceManager_callStackWasmVqeProvider !== void 0 ? _this_source_deviceManager_callStackWasmVqeProvider : null;
        }
        get callStackEffectsStatusManager() {
            var _this_source_deviceManager, _this_source;
            var _this_source_deviceManager_callStackAudioEffectsStatusManager;
            return (_this_source_deviceManager_callStackAudioEffectsStatusManager = (_this_source = this.source) === null || _this_source === void 0 ? void 0 : (_this_source_deviceManager = _this_source.deviceManager) === null || _this_source_deviceManager === void 0 ? void 0 : _this_source_deviceManager.callStackAudioEffectsStatusManager) !== null && _this_source_deviceManager_callStackAudioEffectsStatusManager !== void 0 ? _this_source_deviceManager_callStackAudioEffectsStatusManager : null;
        }
        addCall(g) {
            this._calls.add(g);
        }
        removeCall(g) {
            this._calls.delete(g);
        }
        getCall() {
            for (const g of this._calls)if (g.localAudioStreams.includes(this)) return g;
        }
        getLocalParticipantId() {
            let g = "";
            const f = this.getCall();
            return f && (g = f.tsCall.participantId), g;
        }
        async getMediaStream() {
            const g = generateGuid(), f = +new Date, S = {
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: g,
                operation: by.getMediaStream,
                kindOfEvent: uy.attempt,
                mediaType: Ty.AudioRaw,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(S), this.subscribeToRawStreamChangedIfNeeded(), this._mediaStreamSource) {
                const S = {
                    correlationId: g,
                    mediaType: Ty.AudioRaw,
                    operation: by.getMediaStream,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                return this._localStreamTelemetryEventSender.sendMediaStreamEvent(S), this._mediaStreamSource;
            }
            if (this._source instanceof AudioDeviceInfoImpl) try {
                var _this__rawStream;
                this._rawStream || (this._rawStream = this._source.deviceManager.getRawDeviceMediaStream(0));
                const S = await ((_this__rawStream = this._rawStream) === null || _this__rawStream === void 0 ? void 0 : _this__rawStream.getMediaStream()), v = {
                    correlationId: g,
                    mediaType: Ty.AudioRaw,
                    operation: by.getMediaStream,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                return this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), S;
            } catch (v) {
                const S = new CallingCommunicationError({
                    defaultError: O.LOCAL_AUDIO_STREAM.GET_MEDIA_STREAM,
                    originalError: v
                }), _ = {
                    correlationId: g,
                    operation: by.getMediaStream,
                    additionalDetails: {
                        failureReason: S.message,
                        code: S.code,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.AudioRaw,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), S;
            }
            const v = new CallingCommunicationError({
                defaultError: O.LOCAL_AUDIO_STREAM.GET_MEDIA_STREAM
            }), _ = {
                timestampInfo: {
                    deltaTimeInMs: +new Date - f
                },
                correlationId: g,
                operation: by.getMediaStream,
                additionalDetails: {
                    failureReason: v.message,
                    code: F,
                    ...extractCommunicationServicesErrorForTelemetry(v)
                },
                kindOfEvent: uy.failure,
                mediaType: Ty.AudioRaw,
                streamType: Iy.Local
            };
            throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), v;
        }
        async setMediaStream(g) {
            const f = generateGuid();
            let S = +new Date;
            const v = {
                timestampInfo: {
                    attemptTimestamp: S
                },
                correlationId: f,
                operation: by.setMediaStream,
                kindOfEvent: uy.attempt,
                mediaType: Ty.AudioRaw,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), !(g instanceof MediaStream)) {
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_AUDIO_STREAM.SET_MEDIA_STREAM_WRONG_TYPE
                }), v = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    correlationId: f,
                    operation: by.setMediaStream,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.AudioRaw,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), g;
            }
            this._mediaStreamSource = new MediaStream(g.getAudioTracks()), this.setSource(this._mediaStreamSource), this._volumeIndicator.dispose();
            const _ = {
                correlationId: f,
                mediaType: Ty.AudioRaw,
                operation: by.setMediaStream,
                timestampInfo: {
                    deltaTimeInMs: +new Date - S
                },
                streamType: Iy.Local,
                kindOfEvent: uy.success
            };
            this._localStreamTelemetryEventSender.sendMediaStreamEvent(_);
        }
        async switchSource(g) {
            const f = +new Date, S = generateGuid(), v = {
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                operation: by.switchSource,
                kindOfEvent: uy.attempt,
                mediaType: Ty.Audio,
                streamType: Iy.Local
            };
            if (this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), g instanceof AudioDeviceInfoImpl && "Microphone" !== g.deviceType) {
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_AUDIO_STREAM.SWITCH_SOURCE_WRONG_TYPE
                }), v = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    correlationId: S,
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Audio,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), g;
            }
            if (this._source === g) {
                const g = new CallingCommunicationError({
                    defaultError: O.LOCAL_AUDIO_STREAM.SWITCH_SAME_SOURCE
                }), v = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    correlationId: S,
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Audio,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), g;
            }
            try {
                this._source.deviceManager.selectMicrophone(g), this.setSource(g), this._volumeIndicator.dispose();
                const v = {
                    correlationId: S,
                    mediaType: Ty.Audio,
                    operation: by.switchSource,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    streamType: Iy.Local,
                    kindOfEvent: uy.success
                };
                this._localStreamTelemetryEventSender.sendMediaStreamEvent(v);
            } catch (g) {
                const v = new CallingCommunicationError({
                    defaultError: O.LOCAL_AUDIO_STREAM.UNKNOWN,
                    originalError: g
                }), _ = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    correlationId: S,
                    operation: by.switchSource,
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: Ty.Audio,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(_), v;
            }
        }
        dispose() {
            var _this__extensibleApi;
            this.logger.log("LocalAudioStream disposing"), this._disposed ? this.logger.log("Already disposed") : (this.disposeRawStream(), this._volumeIndicator.dispose(), (_this__extensibleApi = this._extensibleApi) === null || _this__extensibleApi === void 0 ? void 0 : _this__extensibleApi.dispose(), this._eventEmitter.removeAllListeners(), this._disposed = !0, this.logger.log("LocalAudioStream disposed"));
        }
        async getVolume() {
            return this._volumeIndicator.isInitialized ? this._volumeIndicator : this._volumeIndicator.getVolumeIndicator(await this.getMediaStream());
        }
        subscribeToRawStreamChangedIfNeeded() {
            var _this__rawStream;
            this._source instanceof AudioDeviceInfoImpl && !this._audioSourceChangedSub && (this._audioSourceChangedSub = (_this__rawStream = this._rawStream) === null || _this__rawStream === void 0 ? void 0 : _this__rawStream.changed(()=>{
                this._volumeIndicator.dispose(), this._eventEmitter.emit("audioSourceChanged", {
                    source: this
                });
            }));
        }
        disposeRawStream() {
            var _this__audioSourceChangedSub, _this__rawStream;
            (_this__audioSourceChangedSub = this._audioSourceChangedSub) === null || _this__audioSourceChangedSub === void 0 ? void 0 : _this__audioSourceChangedSub.dispose(), (_this__rawStream = this._rawStream) === null || _this__rawStream === void 0 ? void 0 : _this__rawStream.dispose(), this._audioSourceChangedSub = void 0;
        }
        getStreamMetadata() {
            const g = this.source.deviceManager;
            return {
                source: "local",
                streamType: this.mediaStreamType,
                deviceType: this.source.deviceType,
                deviceManagerPermissionState: JSON.stringify({
                    cameraPermission: g.getVideoDevicePermission(),
                    microphonePermission: g.getAudioDevicePermission()
                }),
                acsResourceId: g.getAcsResourceId() || "",
                clientId: g.getClientId()
            };
        }
        getEffectsCurrentStateRecord() {
            try {
                const g = this.feature(audioStreamFeatureFactory(AudioEffectsFeatureImpl)), f = g.getEffectsSdkVersion();
                return {
                    activeEffects: g.getActiveEffectsForTelemetry(),
                    effectsSdk: {
                        version: f
                    }
                };
            } catch (g) {
                return void this.logger.warn(`Error while getting current effect state on LocalAudioStream for telemetry: ${g}`);
            }
        }
        setSource(g, f = !1) {
            if (g instanceof AudioDeviceInfoImpl) this._telemetryLogManager = g.deviceManager.telemetryLogManager, this._source = g, this._mediaStreamType = "Audio", this._mediaStreamSource = void 0, this._rawStream = void 0, this.canStartEffects = !0;
            else {
                try {
                    1 === globalThis[Ff] && (this._telemetryLogManager = globalThis[Lf]);
                } catch (g) {
                    this.logger.error("Failed to retrive telemetry logger for localAudioStream");
                }
                this._source = {
                    name: "CustomMediaStream",
                    id: generateGuid(),
                    deviceType: "Virtual",
                    isSystemDefault: !1
                }, this._mediaStreamSource = g, this._mediaStreamType = "RawMedia", this.canStartEffects = !1;
            }
            f || this._eventEmitter.emit("audioSourceChanged", {
                source: this
            });
        }
        constructor(g){
            this._calls = new Set, this.canStartEffects = !1;
            const S = f.createClientLogger("ACS-calling");
            if (this.logger = new DefaultLogger(S, [
                ()=>`LocalAudioStream for default device with source: ${!!g}`
            ]), this._eventEmitter = new CallingEventEmitter(this.logger), this._disposed = !1, !(g instanceof AudioDeviceInfoImpl || g instanceof MediaStream)) throw new CallingCommunicationError({
                defaultError: O.LOCAL_AUDIO_STREAM.WRONG_STREAM_TYPE
            });
            if (g instanceof AudioDeviceInfoImpl && "Microphone" !== g.deviceType) throw new CallingCommunicationError({
                defaultError: O.LOCAL_AUDIO_STREAM.SOURCE_WRONG_TYPE
            });
            this.setSource(g, !0), this._localStreamTelemetryEventSender = new StreamTelemetryEventSender(this._telemetryLogManager), this._volumeIndicator = new VolumeImpl(this.logger, "LocalAudioStream", this._telemetryLogManager), this.logger.info("created");
        }
    }
    __decorate$7([
        loggerProperty,
        __metadata$7("design:type", Object)
    ], LocalAudioStream.prototype, "logger", void 0), __decorate$7([
        syncOperation(DS.Feature),
        __metadata$7("design:type", Function),
        __metadata$7("design:paramtypes", [
            Object
        ]),
        __metadata$7("design:returntype", "function" == typeof ($E = "undefined" != typeof TFeature && TFeature) ? $E : Object)
    ], LocalAudioStream.prototype, "feature", null), __decorate$7([
        asyncOperation(DS.GetMediaStream),
        __metadata$7("design:type", Function),
        __metadata$7("design:paramtypes", []),
        __metadata$7("design:returntype", Promise)
    ], LocalAudioStream.prototype, "getMediaStream", null), __decorate$7([
        asyncOperation(DS.SetMediaStream),
        __metadata$7("design:type", Function),
        __metadata$7("design:paramtypes", [
            MediaStream
        ]),
        __metadata$7("design:returntype", Promise)
    ], LocalAudioStream.prototype, "setMediaStream", null), __decorate$7([
        asyncOperation(DS.SwitchSource),
        __metadata$7("design:type", Function),
        __metadata$7("design:paramtypes", [
            Object
        ]),
        __metadata$7("design:returntype", Promise)
    ], LocalAudioStream.prototype, "switchSource", null), function(g) {
        g[g.JITTER = 0] = "JITTER", g[g.RTT = 1] = "RTT", g[g.PACKETS_LOSS = 2] = "PACKETS_LOSS", g[g.BIT_RATE = 3] = "BIT_RATE", g[g.BANDWIDTH = 4] = "BANDWIDTH";
    }(jE || (jE = {})), function(g) {
        g[g.AUDIO = 0] = "AUDIO", g[g.VIDEO = 1] = "VIDEO";
    }(GE || (GE = {}));
    const qE = "Unknown";
    var WE, zE;
    function collectMediaStatsForCreateView(g, f, S, v) {
        var _getAcsEcsConfig, _getAcsEcsConfig1;
        const _ = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.rendering.remoteVideo.createViewSendMediaStatsMaxLength, C = (_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : _getAcsEcsConfig1.rendering.remoteVideo.createViewSendMediaStatsInitialMaxLength, E = [
            "bitrate",
            "packetsPerSecond",
            "packetsLostPerSecond",
            "jitterInMs",
            "rttInMs",
            "pairRttInMs",
            "healedRatio",
            "lossRate"
        ], T = [
            "bitrate",
            "packetsPerSecond",
            "packetsLostPerSecond",
            "jitterInMs",
            "rttInMs",
            "pairRttInMs",
            "frameRateDecoded",
            "frameRateReceived",
            "frameWidthReceived",
            "frameHeightReceived",
            "longestFreezeDurationInMs",
            "totalFreezeDurationInMs",
            "framesReceived",
            "framesDropped",
            "framesDecoded",
            "keyFramesDecoded"
        ], I = T;
        if (S.audio.receive.length > 0) {
            const v = S.audio.receive[0];
            var _g_audio, _f_audio;
            g.audio = (_g_audio = g.audio) !== null && _g_audio !== void 0 ? _g_audio : {}, f.audio = (_f_audio = f.audio) !== null && _f_audio !== void 0 ? _f_audio : {}, E.forEach((S)=>{
                const E = S;
                if (void 0 !== v[E] && g.audio) {
                    const f = v[E];
                    if (void 0 === g.audio[E]) g.audio[E] = [
                        f
                    ];
                    else {
                        var _g_audio_E, _g_audio_E1, _g_audio_E2;
                        const S = (_g_audio_E = g.audio[E]) === null || _g_audio_E === void 0 ? void 0 : _g_audio_E.length;
                        S >= _ && ((_g_audio_E1 = g.audio[E]) === null || _g_audio_E1 === void 0 ? void 0 : _g_audio_E1.shift()), (_g_audio_E2 = g.audio[E]) === null || _g_audio_E2 === void 0 ? void 0 : _g_audio_E2.push(f);
                    }
                }
                if (void 0 !== v[E] && f.audio) {
                    const g = v[E];
                    if (void 0 === f.audio[E]) f.audio[E] = [
                        g
                    ];
                    else {
                        var _f_audio_E, _f_audio_E1;
                        const S = (_f_audio_E = f.audio[E]) === null || _f_audio_E === void 0 ? void 0 : _f_audio_E.length;
                        S < C && ((_f_audio_E1 = f.audio[E]) === null || _f_audio_E1 === void 0 ? void 0 : _f_audio_E1.push(g));
                    }
                }
            });
        }
        if (S.video.receive.length > 0) {
            const E = S.video.receive.find((g)=>g.streamId === v);
            var _g_video, _f_video;
            void 0 !== E && (g.video = (_g_video = g.video) !== null && _g_video !== void 0 ? _g_video : {}, f.video = (_f_video = f.video) !== null && _f_video !== void 0 ? _f_video : {}, T.forEach((S)=>{
                const v = S;
                if (void 0 !== E[v] && g.video) {
                    const f = E[v];
                    if (void 0 === g.video[v]) g.video[v] = [
                        f
                    ];
                    else {
                        var _g_video_v, _g_video_v1, _g_video_v2;
                        const S = (_g_video_v = g.video[v]) === null || _g_video_v === void 0 ? void 0 : _g_video_v.length;
                        S >= _ && ((_g_video_v1 = g.video[v]) === null || _g_video_v1 === void 0 ? void 0 : _g_video_v1.shift()), (_g_video_v2 = g.video[v]) === null || _g_video_v2 === void 0 ? void 0 : _g_video_v2.push(f);
                    }
                }
                if (void 0 !== E[v] && f.video) {
                    const g = E[v];
                    if (void 0 === f.video[v]) f.video[v] = [
                        g
                    ];
                    else {
                        var _f_video_v, _f_video_v1;
                        const S = (_f_video_v = f.video[v]) === null || _f_video_v === void 0 ? void 0 : _f_video_v.length;
                        S < C && ((_f_video_v1 = f.video[v]) === null || _f_video_v1 === void 0 ? void 0 : _f_video_v1.push(g));
                    }
                }
            }));
        }
        if (S.screenShare.receive.length > 0) {
            const E = S.screenShare.receive.find((g)=>g.streamId === v);
            var _g_screenShare, _f_screenShare;
            void 0 !== E && (g.screenShare = (_g_screenShare = g.screenShare) !== null && _g_screenShare !== void 0 ? _g_screenShare : {}, f.screenShare = (_f_screenShare = f.screenShare) !== null && _f_screenShare !== void 0 ? _f_screenShare : {}, I.forEach((S)=>{
                const v = S;
                if (void 0 !== E[v] && g.screenShare) {
                    const f = E[v];
                    if (void 0 === g.screenShare[v]) g.screenShare[v] = [
                        f
                    ];
                    else {
                        var _g_screenShare_v, _g_screenShare_v1, _g_screenShare_v2;
                        const S = (_g_screenShare_v = g.screenShare[v]) === null || _g_screenShare_v === void 0 ? void 0 : _g_screenShare_v.length;
                        S >= _ && ((_g_screenShare_v1 = g.screenShare[v]) === null || _g_screenShare_v1 === void 0 ? void 0 : _g_screenShare_v1.shift()), (_g_screenShare_v2 = g.screenShare[v]) === null || _g_screenShare_v2 === void 0 ? void 0 : _g_screenShare_v2.push(f);
                    }
                }
                if (void 0 !== E[v] && f.screenShare) {
                    const g = E[v];
                    if (void 0 === f.screenShare[v]) f.screenShare[v] = [
                        g
                    ];
                    else {
                        var _f_screenShare_v, _f_screenShare_v1;
                        const S = (_f_screenShare_v = f.screenShare[v]) === null || _f_screenShare_v === void 0 ? void 0 : _f_screenShare_v.length;
                        S < C && ((_f_screenShare_v1 = f.screenShare[v]) === null || _f_screenShare_v1 === void 0 ? void 0 : _f_screenShare_v1.push(g));
                    }
                }
            }));
        }
    }
    function calculateFirstAverage(g) {
        if ((g === null || g === void 0 ? void 0 : g.count.length) && (g === null || g === void 0 ? void 0 : g.count[0])) return getRoundedAverage(g.sum[0], g.count[0]);
        return NaN;
    }
    function calculateFirstSum(g) {
        return (g === null || g === void 0 ? void 0 : g.count.length) && (g === null || g === void 0 ? void 0 : g.count[0]) ? g.sum[0] : NaN;
    }
    !function(g) {
        g.Supported = "Supported", g.NotSupported = "NotSupported", g.Unknown = "Unknown";
    }(WE || (WE = {})), function(g) {
        g.CompleteTest = "CompleteTest", g.StartTest = "StartTest", g.DeviceAccess = "DeviceAccess", g.DeviceEnumerations = "DeviceEnumerations", g.InCallDiagnostics = "InCallDiagnostics", g.BrowserSupport = "BrowserSupport";
    }(zE || (zE = {}));
    class PreCallDiagnosticsFeatureImpl extends FirstPartyCallClientFeature {
        initialize(g, f) {
            const S = g.callClient;
            this._logger = f;
            const v = {
                diagnostics: {
                    tags: [
                        "diagnostics"
                    ]
                }
            }, _ = S.createInstance(v);
            this._telemetryLogManager = _.telemetryLogManager, this._impl.intialize(S, _, f, this._telemetryLogManager), this._sendFeatureUsage("initialize", uy.initialize);
        }
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "PreCallDiagnostics";
        }
        startTest(g, f) {
            return this._impl.startTest(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallClientFeatureUsageTelemetry({
                featureName: "PreCallDiagnostics",
                featureType: "CallClient",
                initializationType: "OnExtendedObjectConstructor",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this._sendFeatureUsage("dispose", uy.attempt), this.disposed ? this._sendFeatureUsage("dispose", uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage("dispose", uy.success));
        }
        constructor(g){
            super(g), this._impl = new PreCallDiagnosticsImpl;
        }
    }
    class PreCallDiagnosticsImpl {
        intialize(g, f, S, v) {
            this._internalCallClient = f, this._mainCallClient = g, this._logger = S, this._telemetryLogManager = v;
        }
        async getDevices(g, f) {
            let S = [];
            try {
                switch(f){
                    case "Speaker":
                        S = await g.getSpeakers();
                        break;
                    case "Microphone":
                        S = await g.getMicrophones();
                        break;
                    default:
                        S = await g.getCameras();
                }
            } catch (g) {
                this._logger.warn("Failed to get speakers");
            }
            return S;
        }
        async startTest(g, f) {
            this._sendFeatureUsage("startTest", uy.attempt), this._currentTestRunId = generateGuid(), this._diagnosticsTestRunIds.push(this._currentTestRunId), this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.CompleteTest
                }
            }), this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.StartTest
                }
            });
            try {
                var _f_selectedSpeaker, _f_selectedMicrophone, _g_tsStack;
                this._internalDeviceManager = await this._internalCallClient.getDeviceManager();
                const g = this._internalCallClient.callAgent, f = await this._mainCallClient.getDeviceManager();
                g === null || g === void 0 ? void 0 : (_g_tsStack = g.tsStack) === null || _g_tsStack === void 0 ? void 0 : _g_tsStack.getDeviceManager().selectDevices({
                    speaker: (_f_selectedSpeaker = f.selectedSpeaker) === null || _f_selectedSpeaker === void 0 ? void 0 : _f_selectedSpeaker.id,
                    microphone: (_f_selectedMicrophone = f.selectedMicrophone) === null || _f_selectedMicrophone === void 0 ? void 0 : _f_selectedMicrophone.id
                });
                const S = await this._internalCallClient.getDeviceManager(), v = {
                    mic: (await this.getDevices(S, "Microphone")).length,
                    speaker: (await this.getDevices(S, "Speaker")).length
                };
                this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.StartTest, !0, `Device selection successful. Result: ${getPrintableObject(v, this._printableObjectAll)}`)
                });
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.SET_DEVICE_FAIL,
                    originalError: g
                });
                throw this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.StartTest, !1, "Device selection failed."),
                    additionalDetails: {
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), this._logger.warn(g), this._sendFeatureUsage("startTest", uy.failure), f;
            }
            try {
                return this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.StartTest, !0, "StartTest succeeded")
                }), this._sendFeatureUsage("startTest", uy.success), f ? {
                    deviceAccess: f.deviceAccess ? this.deviceAccess() : void 0,
                    deviceEnumeration: f.deviceEnumeration ? this.deviceEnumeration() : void 0,
                    inCallDiagnostics: f.inCallDiagnostics ? this.getInCallDiagnostics(g) : void 0,
                    browserSupport: f.browserSupport ? this.getBrowserSupport() : void 0,
                    callMediaStatistics: f.callMediaStatistics ? this.getcallMediaStatistics() : void 0,
                    id: this._currentTestRunId
                } : {
                    deviceAccess: this.deviceAccess(),
                    deviceEnumeration: this.deviceEnumeration(),
                    inCallDiagnostics: this.getInCallDiagnostics(g),
                    browserSupport: this.getBrowserSupport(),
                    callMediaStatistics: this.getcallMediaStatistics(),
                    id: this._currentTestRunId
                };
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.GET_DIAGNOSTICS_INFO,
                    originalError: g
                });
                throw this._logger.error(f.message), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.StartTest, !1, "StartTest failed."),
                    additionalDetails: {
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), this._sendFeatureUsage("startTest", uy.failure), f;
            }
        }
        async getBrowserSupport() {
            let g;
            this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.BrowserSupport
                }
            });
            try {
                const f = await this._mainCallClient.getEnvironmentInfoInternal();
                g = {
                    browser: f.isSupportedBrowser ? WE.Supported : WE.NotSupported,
                    os: f.isSupportedPlatform ? WE.Supported : WE.NotSupported
                }, this.updateTestInfo(zE.BrowserSupport, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: `Browser support successful. Result: ${getPrintableObject(g, this._printableObjectAll)}`,
                        name: zE.BrowserSupport
                    }
                });
            } catch (f) {
                g = {
                    browser: WE.Unknown,
                    os: WE.Unknown
                }, this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.BrowserSupport, !1, `Browser support failed. Error: ${getPrintableObject(f)}`)
                }), this._logger.error(`Browser support failed: ${f}`);
            }
            return new Promise((f)=>f(g));
        }
        async renderHiddenVideoElement(g, f) {
            let S, v = g.tsCall, _ = v.mediaStreams;
            try {
                await new Promise((g, f)=>{
                    S = v.changed(()=>{
                        void 0 !== _[0] && _[0].length > 0 && _[0][0].isAvailable && (g(), S === null || S === void 0 ? void 0 : S.dispose(), this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                            diagnosticsTestRunId: this._currentTestRunId,
                            testResultDetails: {
                                succeeded: !0,
                                result: "Call mediaStreams successful.",
                                name: zE.InCallDiagnostics
                            }
                        }));
                    }), setTimeout(()=>{
                        this.telemetryLogResultEvents({
                            diagnosticsTestRunId: this._currentTestRunId,
                            testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, "Call mediaStreams failed. Error: Timeout")
                        }), f(new CallingCommunicationError({
                            defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.VIDEO_STREAM_TIMEOUT
                        }));
                    }, 1e3 * this._diagnosticsEcsConfig.CALL.MEDIASTREAM_TIMEOUT_IN_SEC);
                });
                let C = v.mediaStreams[0][0], E = document.getElementById("_hiddenSelfRemoteStream");
                E && E.remove(), E = document.createElement("div"), E.id = "_hiddenSelfRemoteStream", E.style.position = "relative", E.style.height = "0px", E.style.width = "0px";
                const T = document.createElement("div");
                T.style.position = "absolute", T.style.height = this._diagnosticsEcsConfig.CALL.VIDEO_SIZE.heigth + "px", T.style.width = this._diagnosticsEcsConfig.CALL.VIDEO_SIZE.width + "px", T.style.bottom = "0px", T.style.left = "-2000px", E.appendChild(T), document.getElementsByTagName("body")[0].appendChild(E), this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: `Video element rendering successful. CallId: ${g.id}, localParticipantId: ${f}`,
                        name: zE.InCallDiagnostics
                    }
                }), await C.start(T);
            } catch (g) {
                this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, `Call mediaStreams failed. Error: ${getPrintableObject(g)}`)
                }), this._logger.warn("Failed to render hidden video element");
            }
        }
        sineWaveAudioStream() {
            const g = new window.AudioContext, f = g.createMediaStreamDestination(), S = g.createOscillator();
            S.type = "sine", S.frequency.value = 500, S.connect(f), S.start();
            const { stream: v } = f;
            return new LocalAudioStream(v);
        }
        async receiveAndPlayCallAudio(g, f) {
            try {
                const S = new window.AudioContext, v = new MediaStream;
                S.createMediaStreamSource(v).connect(S.destination), this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: `Call mediaStreams audio track succeeded. CallId: ${g.id}, localParticipantId: ${f}`,
                        name: zE.InCallDiagnostics
                    }
                });
            } catch (g) {
                this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, `Call mediaStreams audio track failed. Error: ${getPrintableObject(g)}`)
                }), this._logger.warn("Failed to send audio to call.");
            }
        }
        async getcallMediaStatistics() {
            return this._callMediaStatistics.promise;
        }
        setEcsConfig() {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig;
            this._diagnosticsEcsConfig = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.callDiagnostics;
        }
        async getInCallDiagnostics(g) {
            var _this__internalCallClient_callAgent;
            this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.InCallDiagnostics
                }
            }), this.setEcsConfig();
            const f = {
                groupId: this._diagnosticsEcsConfig.CALL.GROUP_ID
            }, S = await this.getDevices(this._internalDeviceManager, "Camera");
            let v, _ = "";
            0 !== S.length && (v = [
                new LocalVideoStream(S[0])
            ]);
            const C = {
                videoOptions: {
                    localVideoStreams: v
                },
                audioOptions: {
                    muted: !1,
                    localAudioStreams: [
                        this.sineWaveAudioStream()
                    ]
                }
            };
            let E;
            try {
                var _this__mainCallClient_callAgent;
                E = await ((_this__mainCallClient_callAgent = this._mainCallClient.callAgent) === null || _this__mainCallClient_callAgent === void 0 ? void 0 : _this__mainCallClient_callAgent.getExistingCallAgentWithToken(g)), E ? this._internalCallClient.setCallAgent(E) : (this._isCreatingNewCallAgent = !0, await this._internalCallClient.createCallAgent(g)), this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: "Create CallAgent successful.",
                        name: zE.InCallDiagnostics
                    }
                });
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.GET_CALL_AGENT,
                    originalError: g
                });
                throw this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, f.message),
                    additionalDetails: {
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), this._logger.error(f.message), f;
            }
            const T = (_this__internalCallClient_callAgent = this._internalCallClient.callAgent) === null || _this__internalCallClient_callAgent === void 0 ? void 0 : _this__internalCallClient_callAgent.join(f, C);
            if (T) {
                try {
                    await this.waitCallConnected(T), _ = T.tsCall.participantId, this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                        diagnosticsTestRunId: this._currentTestRunId,
                        testResultDetails: {
                            succeeded: !0,
                            result: "Call connected successfully",
                            name: zE.InCallDiagnostics
                        }
                    });
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.CONNECT_FAIL,
                        originalError: g
                    });
                    throw this.telemetryLogResultEvents({
                        diagnosticsTestRunId: this._currentTestRunId,
                        testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, f.message),
                        additionalDetails: {
                            ...extractCommunicationServicesErrorForTelemetry(f)
                        }
                    }), this._logger.error(f.message), f;
                }
                try {
                    this.updateTestInfo(zE.InCallDiagnostics, !0), await this.renderHiddenVideoElement(T, _);
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.RENDER_VIDEO,
                        originalError: g
                    });
                    throw this.telemetryLogResultEvents({
                        diagnosticsTestRunId: this._currentTestRunId,
                        testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, f.message),
                        additionalDetails: {
                            ...extractCommunicationServicesErrorForTelemetry(f)
                        }
                    }), f;
                }
                this.receiveAndPlayCallAudio(T, _);
                const g = T.feature(callFeatureFactory(MediaStatsCallFeatureImpl, {
                    activationEvent: "OnExtendedObjectConstructor"
                }));
                this._callMediaStatistics.resolve(g);
                g.createCollector({
                    aggregationInterval: this._diagnosticsEcsConfig.CALL.AGGREGATION.INTERVAL,
                    dataPointsPerAggregation: this._diagnosticsEcsConfig.CALL.AGGREGATION.DATAPOINTS
                }).on("summaryReported", (g)=>this.gatherCallStatistics(g));
                try {
                    await sleep(1e3 * this._diagnosticsEcsConfig.CALL.DURATION_IN_SEC), await T.hangUp({
                        forEveryone: !0
                    }), this.updateTestInfo(zE.InCallDiagnostics, !0), this.telemetryLogResultEvents({
                        diagnosticsTestRunId: this._currentTestRunId,
                        testResultDetails: {
                            succeeded: !0,
                            result: `Call hangup successful. Result: ${getPrintableObject(this._inCallDiagnostics, this._printableObjectAll)}`,
                            name: zE.InCallDiagnostics
                        }
                    });
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.HANGUP_FAIL,
                        originalError: g
                    });
                    throw this.telemetryLogResultEvents({
                        diagnosticsTestRunId: this._currentTestRunId,
                        testResultDetails: this.updateTestInfo(zE.InCallDiagnostics, !1, f.message),
                        additionalDetails: {
                            ...extractCommunicationServicesErrorForTelemetry(f)
                        }
                    }), this._logger.error(f.message), f;
                }
                this.dispose();
            }
            return this.telemetryLogResultEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testResultDetails: {
                    succeeded: this._completeTestInfo.succeeded,
                    result: this._completeTestInfo.result || "InCallDiagnostics succeeded.",
                    name: zE.CompleteTest
                }
            }), this._inCallDiagnostics;
        }
        async waitCallConnected(g) {
            await new Promise(async (f, S)=>{
                g.on("stateChanged", ()=>{
                    "Connected" == g.state && (this._inCallDiagnostics.connected = !0, f()), "Disconnected" == g.state && S("Call disconnected");
                });
                const v = this._diagnosticsEcsConfig.CALL.CONNECT_TIMEOUT_IN_SEC;
                await sleep(1e3 * v), S(new CallingCommunicationError({
                    defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.CALL_CONNECT_TIMEOUT,
                    defaultErrorMessageArgs: [
                        v
                    ]
                }));
            });
        }
        qualityGrade(g, f, S) {
            return g <= f ? "Good" : g >= S ? "Bad" : "Average";
        }
        bandwidthQualityGrade(g, f, S) {
            return g >= f ? "Good" : g <= S ? "Bad" : "Average";
        }
        getQualityGradeForMetric(g, f, S) {
            switch(g){
                case jE.JITTER:
                    return S === GE.AUDIO ? this.qualityGrade(f, this._diagnosticsEcsConfig.AUDIO.JITTER.GOOD, this._diagnosticsEcsConfig.AUDIO.JITTER.AVERAGE) : this.qualityGrade(f, this._diagnosticsEcsConfig.VIDEO.JITTER.GOOD, this._diagnosticsEcsConfig.VIDEO.JITTER.AVERAGE);
                case jE.RTT:
                    return S === GE.AUDIO ? this.qualityGrade(f, this._diagnosticsEcsConfig.AUDIO.RTT.GOOD, this._diagnosticsEcsConfig.AUDIO.RTT.AVERAGE) : this.qualityGrade(f, this._diagnosticsEcsConfig.VIDEO.RTT.GOOD, this._diagnosticsEcsConfig.VIDEO.RTT.AVERAGE);
                case jE.PACKETS_LOSS:
                    return S === GE.AUDIO ? this.qualityGrade(f, this._diagnosticsEcsConfig.AUDIO.PACKETS_LOSS_PERCENTAGE.GOOD, this._diagnosticsEcsConfig.AUDIO.PACKETS_LOSS_PERCENTAGE.AVERAGE) : this.qualityGrade(f, this._diagnosticsEcsConfig.VIDEO.PACKETS_LOSS_PERCENTAGE.GOOD, this._diagnosticsEcsConfig.VIDEO.PACKETS_LOSS_PERCENTAGE.AVERAGE);
                case jE.BANDWIDTH:
                    return this.bandwidthQualityGrade(f, this._diagnosticsEcsConfig.BANDWIDTH.GOOD, this._diagnosticsEcsConfig.BANDWIDTH.AVERAGE);
                default:
                    return qE;
            }
        }
        gatherCallStatistics(g) {
            try {
                var _f_jitterInMs, _S_jitterInMs, _this__diagnosticsMediaTelemetry_jitter_audio, _this__diagnosticsMediaTelemetry_jitter_audio1, _S_rttInMs, _S_packetsPerSecond, _S_packetsLostPerSecond, _f_packetsPerSecond, _f_packetsLostPerSecond, _v_jitterInMs, __jitterInMs, __rttInMs, __packetsPerSecond, __packetsLostPerSecond, _v_packetsPerSecond, _v_packetsLostPerSecond, _C_availableOutgoingBitrate;
                const f = g.audio.receive.length ? g.audio.receive[0] : void 0, S = g.audio.send.length ? g.audio.send[0] : void 0, v = g.video.receive.length ? g.video.receive[0] : void 0, _ = g.video.send.length ? g.video.send[0] : void 0, C = g.transports.length ? g.transports[0] : void 0;
                this._diagnosticsMediaTelemetry.jitter.audio.inbound = calculateFirstAverage(f === null || f === void 0 ? void 0 : (_f_jitterInMs = f.jitterInMs) === null || _f_jitterInMs === void 0 ? void 0 : _f_jitterInMs.aggregation), this._diagnosticsMediaTelemetry.jitter.audio.outbound = calculateFirstAverage(S === null || S === void 0 ? void 0 : (_S_jitterInMs = S.jitterInMs) === null || _S_jitterInMs === void 0 ? void 0 : _S_jitterInMs.aggregation);
                const E = Math.max((_this__diagnosticsMediaTelemetry_jitter_audio = this._diagnosticsMediaTelemetry.jitter.audio) === null || _this__diagnosticsMediaTelemetry_jitter_audio === void 0 ? void 0 : _this__diagnosticsMediaTelemetry_jitter_audio.inbound, (_this__diagnosticsMediaTelemetry_jitter_audio1 = this._diagnosticsMediaTelemetry.jitter.audio) === null || _this__diagnosticsMediaTelemetry_jitter_audio1 === void 0 ? void 0 : _this__diagnosticsMediaTelemetry_jitter_audio1.outbound);
                this._inCallDiagnostics.diagnostics.audio.jitter = this.getQualityGradeForMetric(jE.JITTER, E, GE.AUDIO), this._diagnosticsMediaTelemetry.rtt.audio = calculateFirstAverage(S === null || S === void 0 ? void 0 : (_S_rttInMs = S.rttInMs) === null || _S_rttInMs === void 0 ? void 0 : _S_rttInMs.aggregation), this._inCallDiagnostics.diagnostics.audio.rtt = this.getQualityGradeForMetric(jE.JITTER, this._diagnosticsMediaTelemetry.rtt.audio, GE.AUDIO), this._diagnosticsMediaTelemetry.packets.audioSent = calculateFirstSum(S === null || S === void 0 ? void 0 : (_S_packetsPerSecond = S.packetsPerSecond) === null || _S_packetsPerSecond === void 0 ? void 0 : _S_packetsPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.audioSentLost = calculateFirstSum(S === null || S === void 0 ? void 0 : (_S_packetsLostPerSecond = S.packetsLostPerSecond) === null || _S_packetsLostPerSecond === void 0 ? void 0 : _S_packetsLostPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.audioReceived = calculateFirstSum(f === null || f === void 0 ? void 0 : (_f_packetsPerSecond = f.packetsPerSecond) === null || _f_packetsPerSecond === void 0 ? void 0 : _f_packetsPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.audioReceivedLost = calculateFirstSum(f === null || f === void 0 ? void 0 : (_f_packetsLostPerSecond = f.packetsLostPerSecond) === null || _f_packetsLostPerSecond === void 0 ? void 0 : _f_packetsLostPerSecond.aggregation);
                const T = this._diagnosticsMediaTelemetry.packets.audioSent - this._diagnosticsMediaTelemetry.packets.audioSentLost, I = this._diagnosticsMediaTelemetry.packets.audioReceived - this._diagnosticsMediaTelemetry.packets.audioReceivedLost, b = Math.max(T, I) / this._diagnosticsMediaTelemetry.packets.audioSent * 100;
                this._inCallDiagnostics.diagnostics.audio.packetLoss = this.getQualityGradeForMetric(jE.PACKETS_LOSS, b, GE.AUDIO), this._diagnosticsMediaTelemetry.jitter.video.inbound = calculateFirstAverage(v === null || v === void 0 ? void 0 : (_v_jitterInMs = v.jitterInMs) === null || _v_jitterInMs === void 0 ? void 0 : _v_jitterInMs.aggregation), this._diagnosticsMediaTelemetry.jitter.video.outbound = calculateFirstAverage(_ === null || _ === void 0 ? void 0 : (__jitterInMs = _.jitterInMs) === null || __jitterInMs === void 0 ? void 0 : __jitterInMs.aggregation);
                const A = Math.max(this._diagnosticsMediaTelemetry.jitter.video.inbound, this._diagnosticsMediaTelemetry.jitter.video.outbound);
                this._inCallDiagnostics.diagnostics.video.jitter = this.getQualityGradeForMetric(jE.JITTER, A, GE.VIDEO), this._diagnosticsMediaTelemetry.rtt.video = calculateFirstAverage(_ === null || _ === void 0 ? void 0 : (__rttInMs = _.rttInMs) === null || __rttInMs === void 0 ? void 0 : __rttInMs.aggregation), this._inCallDiagnostics.diagnostics.video.rtt = this.getQualityGradeForMetric(jE.RTT, this._diagnosticsMediaTelemetry.rtt.video, GE.VIDEO), this._diagnosticsMediaTelemetry.packets.videoSent = calculateFirstSum(_ === null || _ === void 0 ? void 0 : (__packetsPerSecond = _.packetsPerSecond) === null || __packetsPerSecond === void 0 ? void 0 : __packetsPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.videoSentLost = calculateFirstSum(_ === null || _ === void 0 ? void 0 : (__packetsLostPerSecond = _.packetsLostPerSecond) === null || __packetsLostPerSecond === void 0 ? void 0 : __packetsLostPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.videoReceived = calculateFirstSum(v === null || v === void 0 ? void 0 : (_v_packetsPerSecond = v.packetsPerSecond) === null || _v_packetsPerSecond === void 0 ? void 0 : _v_packetsPerSecond.aggregation), this._diagnosticsMediaTelemetry.packets.videoReceivedLost = calculateFirstSum(v === null || v === void 0 ? void 0 : (_v_packetsLostPerSecond = v.packetsLostPerSecond) === null || _v_packetsLostPerSecond === void 0 ? void 0 : _v_packetsLostPerSecond.aggregation);
                const R = this._diagnosticsMediaTelemetry.packets.videoSent - this._diagnosticsMediaTelemetry.packets.videoSentLost, P = this._diagnosticsMediaTelemetry.packets.videoReceived - this._diagnosticsMediaTelemetry.packets.videoReceivedLost, w = Math.max(R, P) / this._diagnosticsMediaTelemetry.packets.videoSent * 100;
                this._inCallDiagnostics.diagnostics.video.packetLoss = this.getQualityGradeForMetric(jE.PACKETS_LOSS, w, GE.VIDEO), this._diagnosticsMediaTelemetry.bandWidth = calculateFirstAverage(C === null || C === void 0 ? void 0 : (_C_availableOutgoingBitrate = C.availableOutgoingBitrate) === null || _C_availableOutgoingBitrate === void 0 ? void 0 : _C_availableOutgoingBitrate.aggregation), this._inCallDiagnostics.bandWidth = this.getQualityGradeForMetric(jE.BANDWIDTH, this._diagnosticsMediaTelemetry.bandWidth, GE.AUDIO);
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.PRECALL_DIAGNOSTICS.VIDEO_MEDIASTATS,
                    originalError: g
                });
                this._logger.error("Failed to get audio call media stats:", f.message), this._callMediaStatistics.reject(f);
            }
        }
        async deviceAccess() {
            this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.DeviceAccess
                }
            });
            const g = this._internalDeviceManager.askDevicePermission({
                audio: !0,
                video: !0
            });
            try {
                const f = await g;
                this.updateTestInfo(zE.DeviceAccess, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: `Device Access successful. Result: ${getPrintableObject(f, this._printableObjectAll)}`,
                        name: zE.DeviceAccess
                    }
                });
            } catch (g) {
                this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.DeviceAccess, !1, "Device Access failed.")
                });
            }
            return g;
        }
        async deviceEnumeration() {
            const g = {
                microphone: qE,
                camera: qE,
                speaker: qE
            };
            this.telemetryLogAttemptEvents({
                diagnosticsTestRunId: this._currentTestRunId,
                testAttemptDetails: {
                    name: zE.DeviceEnumerations
                }
            });
            try {
                const f = 0 !== (await this.getDevices(this._internalDeviceManager, "Microphone")).length, S = 0 !== (await this.getDevices(this._internalDeviceManager, "Camera")).length, v = 0 !== (await this.getDevices(this._internalDeviceManager, "Speaker")).length;
                g.microphone = f ? "Available" : "NotAvailable", g.camera = S ? "Available" : "NotAvailable", g.speaker = v ? "Available" : "NotAvailable", this.updateTestInfo(zE.DeviceEnumerations, !0), this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: {
                        succeeded: !0,
                        result: `Device Enumeration successful. Result: ${getPrintableObject(g, this._printableObjectAll)}`,
                        name: zE.DeviceEnumerations
                    }
                });
            } catch (g) {
                this.telemetryLogResultEvents({
                    diagnosticsTestRunId: this._currentTestRunId,
                    testResultDetails: this.updateTestInfo(zE.DeviceEnumerations, !1, "Device Enumeration failed.")
                }), this._logger.error(`Couldn't find mic, camera, or speaker: ${g}`);
            }
            return g;
        }
        telemetryLogAttemptEvents(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_diagnostics_attempt,
                tenant: nf,
                properties: {
                    name: g.testAttemptDetails.name,
                    diagnosticsTestRunId: g.diagnosticsTestRunId
                }
            });
        }
        telemetryLogResultEvents(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_diagnostics_result,
                tenant: nf,
                properties: {
                    name: g.testResultDetails.name,
                    diagnosticsTestRunId: g.diagnosticsTestRunId,
                    succeeded: g.testResultDetails.succeeded,
                    result: g.testResultDetails.result,
                    additionalDetails: g.additionalDetails || {}
                }
            });
        }
        updateTestInfo(g, f, S) {
            return this._completeTestInfo.succeeded && (this._completeTestInfo = {
                succeeded: f,
                name: g,
                result: S
            }), {
                succeeded: f,
                name: g,
                result: S || ""
            };
        }
        _sendFeatureUsage(g, f) {
            sendCallClientFeatureUsageTelemetry({
                featureName: "PreCallDiagnostics",
                featureType: "CallClient",
                initializationType: "OnExtendedObjectConstructor",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            var _this__internalCallClient_callAgent;
            this._isCreatingNewCallAgent && ((_this__internalCallClient_callAgent = this._internalCallClient.callAgent) === null || _this__internalCallClient_callAgent === void 0 ? void 0 : _this__internalCallClient_callAgent.dispose());
        }
        constructor(){
            this._printableObjectAll = !0, this._completeTestInfo = {
                name: "",
                succeeded: !0
            }, this._diagnosticsTestRunIds = [], this._callMediaStatistics = defer(), this._inCallDiagnostics = {
                connected: !1,
                diagnostics: {
                    audio: {
                        jitter: qE,
                        packetLoss: qE,
                        rtt: qE
                    },
                    video: {
                        jitter: qE,
                        packetLoss: qE,
                        rtt: qE
                    }
                },
                bandWidth: qE
            }, this._diagnosticsMediaTelemetry = {
                jitter: {
                    audio: {
                        inbound: 0,
                        outbound: 0
                    },
                    video: {
                        inbound: 0,
                        outbound: 0
                    }
                },
                rtt: {
                    audio: 0,
                    video: 0
                },
                packets: {
                    audioSent: 0,
                    audioSentLost: 0,
                    audioReceived: 0,
                    audioReceivedLost: 0,
                    videoSent: 0,
                    videoSentLost: 0,
                    videoReceived: 0,
                    videoReceivedLost: 0
                },
                bandWidth: 0
            }, this._isCreatingNewCallAgent = !1;
        }
    }
    class Debounce {
        debounce() {
            this._debounce ? (clearTimeout(this._debounce), this._debounce = setTimeout(()=>{
                this._updateFunction(), this._debounce = void 0;
            }, this._timeout)) : (this._updateFunction(), this._debounce = setTimeout(()=>{
                this._debounce = void 0;
            }, this._timeout));
        }
        flush() {
            this._debounce && (clearTimeout(this._debounce), this._debounce = void 0, this._updateFunction());
        }
        constructor(g, f){
            this._debounce = void 0, this._updateFunction = g, this._timeout = f;
        }
    }
    class RemoteVideoStreamCommonImpl {
        on(g, f) {
            if ("sizeChanged" !== g && "isReceivingChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_VIDEO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("sizeChanged" !== g && "isReceivingChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_VIDEO_STREAM.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        get id() {
            return this.tsStream.id;
        }
        get isReceiving() {
            return this._isReceiving;
        }
        get tsParticipantId() {
            return this._tsParticipantId;
        }
        get remoteParticipantId() {
            var _this_tsStream_participantId;
            return (_this_tsStream_participantId = this.tsStream.participantId) !== null && _this_tsStream_participantId !== void 0 ? _this_tsStream_participantId : "";
        }
        get mediaStreamType() {
            return this._mediaStreamType;
        }
        get size() {
            return {
                height: this._size.height,
                width: this._size.width
            };
        }
        updateSize() {
            this._debounceSize.debounce();
        }
        updateIsReceiving() {
            this._debounceIsReceiving.debounce();
        }
        flushIsReceiving() {
            this._debounceIsReceiving.flush();
        }
        registerRenderer(g) {
            this._renderers.push(g), this.logger.info(`Renderer registered, view id: ${g.viewId}`);
        }
        unregisterRenderer(g) {
            const f = this._renderers.indexOf(g);
            -1 !== f && (this._renderers.splice(f, 1), this.logger.info(`Renderer un-registered, view id: ${g.viewId}`));
        }
        dispose() {
            this.logger.log("dispose"), this._disposed ? this.logger.log("already disposed") : (this._disposed = !0, this._streamChangedHandler && this._streamChangedHandler.dispose(), this._renderers.forEach((g)=>this._disposeRenderer(g)), this._renderers = [], this._eventEmitter.removeAllListeners());
        }
        getRegisteredViewIds() {
            let g = this._renderers.map((g)=>g.viewId);
            return this._registeredViewIdsMaxLength && (g = g.slice(0, this._registeredViewIdsMaxLength)), g.join(", ");
        }
        sendRemoteVideoStreamTelemetry() {
            this.call.stats.recordEvent({
                name: cy.remote_stream,
                callId: this.call.id,
                localParticipantId: this.call.tsCall.participantId,
                data: {
                    ...this.getStreamMetadata()
                }
            });
        }
        createDebounceSize() {
            return new Debounce(()=>{
                var _this__renderers;
                let g = {
                    height: 0,
                    width: 0
                };
                (_this__renderers = this._renderers) === null || _this__renderers === void 0 ? void 0 : _this__renderers.forEach((f)=>{
                    (f === null || f === void 0 ? void 0 : f.isRendering) && f.size.height > g.height && f.size.width > g.width && (g.height = f.size.height, g.width = f.size.width);
                }, getAcsEcsConfig().rendering.remoteVideo.debounceTimeout), this._size.height === g.height && this._size.width === g.width || (this._size.height = g.height, this._size.width = g.width, this.logger.info(`stream size changed to { height: ${this._size.height}, width: ${this._size.width} }`), this._eventEmitter.emit("sizeChanged"), this.sendRemoteVideoStreamTelemetry());
            }, getAcsEcsConfig().rendering.remoteVideo.debounceTimeout);
        }
        constructor(g, f, S, v, _, C){
            this._isReceiving = !1, this._mediaStreamType = "Video", this._renderers = [], this._disposed = !1, this._size = {
                height: 0,
                width: 0
            }, this._setType = (g)=>{
                0 === g.type ? this._mediaStreamType = "Video" : 1 === g.type ? this._mediaStreamType = "ScreenSharing" : 2 === g.type && (this._mediaStreamType = "LiveStream");
            }, this._disposeRenderer = (g)=>{
                this.logger.log("disposing renderer");
                try {
                    g.dispose(Py.Internal_RemoteVideoStreamDisposed), this.logger.log("renderer disposed");
                } catch (g) {
                    this.logger.log("failed to dispose renderer");
                }
            }, this.tsStream = g, this._setType(this.tsStream), this.logger = f.createChild(()=>`Stream:{id=${this.tsStream.id}}:{type=${this._mediaStreamType}}`), this.telemetryLogManager = _, this.kind = C, this._eventEmitter = new CallingEventEmitter(this.logger), this.call = S, this._tsParticipantId = v, this.sendRemoteVideoStreamTelemetry(), this._debounceSize = this.createDebounceSize(), this._debounceIsReceiving = new Debounce(()=>{
                var _this__renderers;
                const g = ((_this__renderers = this._renderers) === null || _this__renderers === void 0 ? void 0 : _this__renderers.filter((g)=>!!(g === null || g === void 0 ? void 0 : g.isRendering)).length) > 0;
                this._isReceiving !== g && (this._isReceiving = g, this.logger.info(`isReceiving changed to ${this._isReceiving}`), this._eventEmitter.emit("isReceivingChanged"), this.sendRemoteVideoStreamTelemetry());
            }, getAcsEcsConfig().rendering.remoteVideo.debounceTimeout), this._registeredViewIdsMaxLength = getAcsEcsConfig().rendering.remoteVideo.registeredViewIdsMaxLength, this.logger.info("created");
        }
    }
    class LiveStreamStatsCalculator {
        isDiffMethod(g) {
            return "diff" == g || "last2" == g || "rate" === g;
        }
        addStats(g, f) {
            const S = this._statsInfo[g];
            let v = this._originalValues[g];
            if (void 0 === v && (v = {
                raw: [],
                calc: [],
                lastTime: Date.now(),
                beginTime: Date.now()
            }, this._originalValues[g] = v), this.isDiffMethod(S.calculation_method)) {
                v.raw.push(f);
                const g = Date.now(), _ = v.lastTime;
                if (v.lastTime = g, v.raw.length > 1) f = v.raw[v.raw.length - 1] - v.raw[v.raw.length - 2], "rate" === S.calculation_method && (f = f / (g - _) * 1e3), void 0 !== S.multiplier && (f *= S.multiplier), !0 === S.integer && (f |= 0), v.calc.push(f);
                else "rate" === S.calculation_method && (f = 0);
            } else void 0 !== S.multiplier && "number" == typeof f && (f *= S.multiplier), !0 === S.integer && (f |= 0), v.raw.push(f);
            return f;
        }
        aggregate() {
            const g = {};
            for (const [f, S] of Object.entries(this._originalValues)){
                var _S_calc;
                const v = this._statsInfo[f];
                if (void 0 === v || !1 === v.show) continue;
                this.isDiffMethod(v.calculation_method) && S.raw.length > 0 && (g[f] = {
                    raw: [
                        S.raw[S.raw.length - 1]
                    ],
                    calc: [],
                    lastTime: S.lastTime,
                    beginTime: 0
                });
                let _ = this._aggregateValues[f];
                void 0 === _ && (_ = {
                    raw: [],
                    timestamp: new Date(S.beginTime)
                }, v.aggregation_needed && (_.aggregation = {
                    count: [],
                    sum: [],
                    max: [],
                    min: []
                }), this._aggregateValues[f] = _);
                const C = ((_S_calc = S.calc) === null || _S_calc === void 0 ? void 0 : _S_calc.length) ? S.calc : S.raw;
                let E = C;
                if (v.aggregation_needed && _.aggregation) {
                    const g = C.filter((g)=>"number" == typeof g && !isNaN(g));
                    _.aggregation.count.push(g.length), _.aggregation.sum.push(getSum(g)), _.aggregation.max.push(getMax(g)), _.aggregation.min.push(getMin(g)), E = g;
                }
                v.raw_data_reduction && E.length > 0 && (_.reduced = _.reduced || [], _.reduced.push(E[E.length - 1])), E.forEach((g)=>_.raw.push(g));
            }
            this._originalValues = g;
        }
        popAggregates() {
            const g = {};
            var _this__statsInfo_f_name;
            for (const [f, S] of Object.entries(this._aggregateValues))g[(_this__statsInfo_f_name = this._statsInfo[f].name) !== null && _this__statsInfo_f_name !== void 0 ? _this__statsInfo_f_name : f] = S;
            return this._aggregateValues = {}, g;
        }
        constructor(g){
            this._statsInfo = g, this._originalValues = {}, this._aggregateValues = {};
        }
    }
    class LiveStreamStatsCollectorImpl {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            this._disposed || (this._disposed = !0, this._callStateChangedHandle.dispose(), this._callStateChanged.resolve(!1), this._statsPoller.off("data", this._dataEventListener), this._eventEmitter.emit("dispose"), this._eventEmitter.removeAllListeners());
        }
        _processData(g) {
            const f = {}, S = Object.keys(g);
            0 !== S.length && (S.forEach((S)=>{
                const v = g[S], _ = {};
                let C = this._calculators.get(S);
                C || (C = new LiveStreamStatsCalculator(this._statsInfo), this._calculators.set(S, C));
                for (const [g, f] of Object.entries(v)){
                    const S = this._statsInfo[g];
                    if (S && !1 !== S.show && (this._isInternal || !S.is_internal)) {
                        const v = C.addStats(g, f);
                        var _S_name;
                        _[(_S_name = S.name) !== null && _S_name !== void 0 ? _S_name : g] = v;
                    }
                }
                f[S] = _;
            }), Object.keys(f).length > 0 && this._eventEmitter.emit("sampleReported", f));
        }
        async _run() {
            let g = 0;
            const filterReducedRaw = (g)=>(Object.keys(g).forEach((f)=>{
                    g[f].reduced && !this._isInternal && delete g[f].reduced;
                }), g), flushData = ()=>{
                if (0 === this._calculators.size || 0 === g) return;
                const f = [], S = {};
                this._calculators.forEach((g, v)=>{
                    const _ = filterReducedRaw(g.popAggregates());
                    0 === Object.keys(_).length ? f.push(v) : (_.reduced && !this._isInternal && delete _.reduced, S[v] = _);
                });
                try {
                    this._eventEmitter.emit("summaryReported", S);
                } catch (g) {
                    this._logger.error(`summary event: ${g}`);
                }
                f.forEach((g)=>{
                    this._calculators.delete(g);
                }), g = 0;
            }, f = [
                3,
                10
            ];
            let S = 1e3 * this._aggregationInterval;
            for(; !this._disposed;){
                if (f.includes(this._tsCall.state)) {
                    S > 0 && await wait(()=>this._callStateChanged.promise, S).catch((g)=>{});
                    const f = Date.now();
                    this._calculators.size > 0 && (this._calculators.forEach((g)=>{
                        g.aggregate();
                    }), g++, g === this._dataPointsPerAggregation && flushData());
                    const v = Date.now();
                    S = f + 1e3 * this._aggregationInterval - v;
                } else flushData(), this._calculators.clear(), await this._callStateChanged.promise.catch((g)=>{}), S = 1e3 * this._aggregationInterval;
                this._callStateChanged.isPending() || (this._callStateChanged = defer$1());
            }
            flushData();
        }
        constructor(g, f, S){
            if (this._tsCall = g, this._aggregationInterval = 0, this._dataPointsPerAggregation = 0, this._disposed = !1, this._calculators = new Map, S.aggregationInterval < 1) throw new CallingCommunicationError({
                defaultError: O.FEATURES.LIVE_STREAM.INVALID_AGGREGATION_INTERVAL_RANGE
            });
            if (S.dataPointsPerAggregation < 1) throw new CallingCommunicationError({
                defaultError: O.FEATURES.LIVE_STREAM.INVALID_DATAPOINTS_AGGREGATION_RANGE
            });
            this._logger = f.createChild("LiveStreamStatsCollector"), this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogEmit: !1
            }), this._callStateChanged = defer$1(), this._statsPoller = S.statsPoller, this._statsInfo = S.statsInfo, this._aggregationInterval = S.aggregationInterval, this._dataPointsPerAggregation = S.dataPointsPerAggregation, this._isInternal = S.isInternal, this._dataEventListener = (g)=>{
                void 0 !== g && this._processData(g);
            }, this._statsPoller.on("data", this._dataEventListener);
            const v = [
                3,
                10
            ];
            let _ = v.includes(this._tsCall.state);
            this._callStateChangedHandle = this._tsCall.on("callStateChanged", ()=>{
                _ !== v.includes(this._tsCall.state) && (_ = !_, this._callStateChanged.resolve(_));
            }), this._run();
        }
    }
    class LiveStreamStatsPoller extends StatsPoller {
        async getStats() {
            const g = {};
            return this._liveStreams.forEach((f, S)=>{
                try {
                    const S = f.tsStream.getStats();
                    if (S) {
                        const f = S.id.toString(), v = {
                            id: f
                        };
                        "number" == typeof S.player_downloadBitrate && (v.videoBitrate = S.player_downloadBitrate), "number" == typeof S.player_audioDownloadBitrate && (v.audioBitrate = S.player_audioDownloadBitrate), "number" == typeof S.player_totalDownloadedBytes && (v.downloadBitrate = S.player_totalDownloadedBytes, v.totalDownloadBytes = S.player_totalDownloadedBytes), "number" == typeof S.player_videoBufferLength && (v.bufferLengthInMs = Math.round(1e3 * S.player_videoBufferLength)), void 0 !== S.player_mediaHeight && (v.videoHeight = S.player_mediaHeight), void 0 !== S.player_mediaWidth && (v.videoWidth = S.player_mediaWidth), void 0 !== S.player_playerHeight && (v.playerHeight = S.player_playerHeight), void 0 !== S.player_playerWidth && (v.playerWidth = S.player_playerWidth), "number" == typeof S.player_mediaDelay && (v.mediaDelayInMs = Math.round(1e3 * S.player_mediaDelay)), "number" == typeof S.player_currentPlayPosition && (v.currentPlayPosition = Math.round(1e3 * S.player_currentPlayPosition) / 1e3), g[f] = v;
                    }
                } catch (g) {
                    this._logger.error(`fetch live stream stats failed: ${g}`);
                }
            }), Object.keys(g).length > 0 ? g : void 0;
        }
        constructor(g, f, S, v){
            super(g, f.createChild("LiveStreamStatsPoller"), S.liveStreamStats.fetchInterval, S.liveStreamStats.pollingMethod, S.liveStreamStats.activeState), this._liveStreams = v;
        }
    }
    class LiveStreamStatsTelemetryLogger {
        log(g) {
            Object.entries(g).forEach(([g, f])=>{
                const S = {
                    id: g
                }, v = {
                    id: g
                };
                if (Object.entries(f).forEach(([g, f])=>{
                    const _ = g, C = {};
                    if (this._config.dataToSend.raw) {
                        const g = {};
                        (f === null || f === void 0 ? void 0 : f.timestamp) && (g.timestamp = f.timestamp), (f === null || f === void 0 ? void 0 : f.raw) && (g.raw = f === null || f === void 0 ? void 0 : f.raw), void 0 === g.raw && delete v[_], v[_] = g;
                    }
                    void 0 !== (f === null || f === void 0 ? void 0 : f.aggregation) ? ((f === null || f === void 0 ? void 0 : f.timestamp) && (C.timestamp = f === null || f === void 0 ? void 0 : f.timestamp), this._config.dataToSend.min && (C.min = f === null || f === void 0 ? void 0 : f.aggregation.min), this._config.dataToSend.max && (C.max = f === null || f === void 0 ? void 0 : f.aggregation.max), this._config.dataToSend.sum && (C.sum = f === null || f === void 0 ? void 0 : f.aggregation.sum), this._config.dataToSend.count && (C.count = f === null || f === void 0 ? void 0 : f.aggregation.count), (f === null || f === void 0 ? void 0 : f.aggregation.sum) && (f === null || f === void 0 ? void 0 : f.aggregation.count) && (C.average = getSum(f === null || f === void 0 ? void 0 : f.aggregation.sum) / getSum(f === null || f === void 0 ? void 0 : f.aggregation.count))) : ((f === null || f === void 0 ? void 0 : f.timestamp) && (C.timestamp = f.timestamp), (f === null || f === void 0 ? void 0 : f.reduced) ? C.raw = f === null || f === void 0 ? void 0 : f.reduced : void 0 !== (f === null || f === void 0 ? void 0 : f.raw) && (C.raw = f === null || f === void 0 ? void 0 : f.raw)), S[_] = C;
                }), Object.keys(S).length > 1) {
                    const g = {
                        stats: S,
                        callId: this._tsCall.callId || "",
                        localParticipantId: this._tsCall.participantId || ""
                    };
                    this._sendLiveStreamStatsEvent(g);
                }
                if (this._config.dataToSend.raw && Object.keys(v).length > 1) {
                    const g = {
                        stats: v,
                        callId: this._tsCall.callId || "",
                        localParticipantId: this._tsCall.participantId || ""
                    };
                    this._sendLiveStreamRawStatsEvent(g);
                }
            });
        }
        _sendLiveStreamStatsEvent(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_livestream_stats,
                tenant: nf,
                properties: g
            });
        }
        _sendLiveStreamRawStatsEvent(g) {
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_livestream_raw_stats,
                tenant: nf,
                properties: g
            });
        }
        constructor(g, f, S){
            this._tsCall = g, this._telemetryLogManager = f, this._config = S;
        }
    }
    class LiveStreamStatsManager {
        createStatsCollector(g) {
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.FEATURES.LIVE_STREAM.DISPOSED
            });
            var _g_aggregationInterval, _g_dataPointsPerAggregation;
            const f = this._config, S = new LiveStreamStatsCollectorImpl(this._tsCall, this._logger, {
                statsPoller: this._statsPoller,
                aggregationInterval: (_g_aggregationInterval = g === null || g === void 0 ? void 0 : g.aggregationInterval) !== null && _g_aggregationInterval !== void 0 ? _g_aggregationInterval : f.aggregationInterval,
                dataPointsPerAggregation: (_g_dataPointsPerAggregation = g === null || g === void 0 ? void 0 : g.dataPointsPerAggregation) !== null && _g_dataPointsPerAggregation !== void 0 ? _g_dataPointsPerAggregation : f.dataPointsPerAggregation,
                statsInfo: this._externalStatsInfo,
                isInternal: !1
            });
            return S.on("dispose", ()=>{
                this._collectors = this._collectors.filter((g)=>g !== S);
            }), this._collectors.push(S), S;
        }
        dispose() {
            this._disposed || (this._disposed = !0, this._collectors.forEach((g)=>{
                g.dispose();
            }));
        }
        constructor(g, f, S, v){
            this._logger = f, this._collectors = [], this._disposed = !1, this._externalStatsInfo = {};
            const _ = getAcsEcsConfig(), C = _.telemetry.liveStreamStatsConfig;
            this._config = _.liveStreamStats, this._tsCall = g.tsCall, this._statsPoller = new LiveStreamStatsPoller(g, this._logger, _, v);
            const E = {
                ...rS,
                ...C.additionalStats
            };
            if (Object.entries(E).filter(([, g])=>!g.is_internal).forEach(([g, f])=>{
                this._externalStatsInfo[g] = f;
            }), C.enabled) {
                const g = new LiveStreamStatsCollectorImpl(this._tsCall, this._logger, {
                    statsPoller: this._statsPoller,
                    aggregationInterval: C.aggregationInterval,
                    dataPointsPerAggregation: C.dataPointsPerAggregation,
                    statsInfo: E,
                    isInternal: !0
                }), f = new LiveStreamStatsTelemetryLogger(this._tsCall, S, C);
                g.on("summaryReported", (g)=>{
                    f.log(g);
                }), this._collectors.push(g);
            }
        }
    }
    class BotStreamCommonCallFeature {
        initialize(g, f, S, v, _) {
            this._logger = _.createChild(()=>`${this._featureName}::Call(id='${g.callId}')`), this._telemetryLogManager = v, this._call = S, this._tsCall = g, this._callAgent = f, this.observeBotParticipantsAlreadyInCall(), this._tsCall.on("participantAdded", async (g)=>{
                this.observeBotParticipantJustJoinedCall(g);
            }), this._tsCall.on("participantRemoved", async (g)=>{
                this.removeStreamOfTheBotJustRemovedFromCall(g);
            });
        }
        disposeAllBotStreams() {
            this._streamIdToStreamMap.forEach((g)=>g.dispose()), this._streamIdToStreamMap.clear();
        }
        observeBotParticipantsAlreadyInCall() {
            this._tsCall.participants.forEach((g)=>{
                this.isExpectedBotParticipant(g) && (this._logger.info(`${this._featureName} Bot already in the call`), this.observeBotParticipant(g));
            });
        }
        observeBotParticipantJustJoinedCall(g) {
            this.isExpectedBotParticipant(g) && (this._logger.info(`${this._featureName} Bot added`), this.observeBotParticipant(g));
        }
        removeStreamOfTheBotJustRemovedFromCall(g) {
            if (this.isExpectedBotParticipant(g)) {
                this._logger.info(`${this._featureName} Bot removed`);
                const f = [];
                this.removeAllStreams(g, f), this.checkVideoStreamAddedOrRemoved([], f);
            }
        }
        observeBotParticipant(g) {
            g.changed(()=>{
                this._logger.info(`${this._featureName} Bot - changed event triggered. state: ${g.state}`), this._mapStreams(g);
            }), this._logger.info(`Composition Bot state: ${g.state}`), this._mapStreams(g);
        }
        _mapStreams(g) {
            const f = [], S = [], mapStreamsOfType = (v)=>{
                if (g) {
                    if (isNonEmptyArray(g.streams && g.streams[v])) {
                        let _ = g.streams[v];
                        this._logger.log(`Stream Type: ${v}`), _.forEach((S)=>{
                            if (void 0 === S.id && (S.id = -1), !this._streamIdToStreamMap.get(S.id)) {
                                const v = this.createConcreteVideoStream(S, g.id);
                                this._logger.log(`${this._featureName} stream created, type==${v.mediaStreamType} id=${S.id}`), f.push(v);
                            }
                        }), this._streamIdToStreamMap.forEach((f)=>{
                            f.tsParticipantId !== g.id || _.some((g)=>g.id === f.id) || S.push(f);
                        });
                    } else this.removeAllStreams(g, S);
                }
            };
            this.getStreamTypes().forEach((g)=>mapStreamsOfType(g)), this.checkVideoStreamAddedOrRemoved(f, S);
        }
        removeAllStreams(g, f) {
            this._streamIdToStreamMap.forEach((S)=>{
                S.tsParticipantId === g.id && f.push(S);
            });
        }
        checkVideoStreamAddedOrRemoved(g, f) {
            if (g.length > 0 || f.length > 0) {
                const handleNewStream = (g)=>{
                    this._streamIdToStreamMap.set(g.id, g);
                }, handleRemovedStream = (g)=>{
                    const f = this._streamIdToStreamMap.get(g.id);
                    f && (this._logger.log(`stream removed, type==${f.mediaStreamType} id=${g.id}`), this._streamIdToStreamMap.delete(g.id), f.dispose());
                };
                g.forEach(handleNewStream), f.forEach(handleRemovedStream), this.emitVideoStreamsUpdatedEvent({
                    added: g,
                    removed: f
                });
            }
        }
        isExpectedBotParticipant(g) {
            return this._targetBotIds.includes(g.id);
        }
        constructor(g, f){
            this._featureName = g, this._targetBotIds = f, this._streamIdToStreamMap = new Map;
        }
    }
    class LiveStreamCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "LiveStream";
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        dispose() {
            this._impl.dispose(), super.dispose();
        }
        get liveStreams() {
            return this._impl.liveStreams;
        }
        get participantCount() {
            return this._impl.streamingClientCount;
        }
        on(g, f) {
            if ("liveStreamsUpdated" !== g && "participantCountChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.LIVE_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("liveStreamsUpdated" !== g && "participantCount" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.LIVE_STREAM.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        createStatsCollector(g) {
            return this._impl.createStatsCollector(g);
        }
        constructor(g){
            super(g), this._impl = new LiveStreamCallFeatureImplOverTsCall(this.eventEmitter, this.name);
        }
    }
    class LiveStreamCallFeatureImplOverTsCall extends BotStreamCommonCallFeature {
        initialize(g, f, S, v, _) {
            super.initialize(g, f, S, v, _), this._statsManager = new LiveStreamStatsManager(S, _, v, this._streamIdToStreamMap), this._tsCall.participantCounts && null != this._tsCall.participantCounts.streamingClients && (this._participantCount = this._tsCall.participantCounts.streamingClients), this._tsCall.on("participantCountsUpdated", ()=>{
                if (this._tsCall.participantCounts && this._participantCount !== this._tsCall.participantCounts.streamingClients) {
                    const g = this._participantCount;
                    this._participantCount = this._tsCall.participantCounts.streamingClients, this._logger.log(`tsCall participantCount changed from ${g} to ${this._participantCount}`), this._eventEmitter.emit("participantCountChanged");
                }
            });
        }
        dispose() {
            super.disposeAllBotStreams(), this._statsManager.dispose();
        }
        createStatsCollector(g) {
            return this._statsManager.createStatsCollector(g);
        }
        get liveStreams() {
            return [
                ...this._streamIdToStreamMap.values()
            ].map((g)=>g);
        }
        get streamingClientCount() {
            var _this__participantCount;
            return (_this__participantCount = this._participantCount) !== null && _this__participantCount !== void 0 ? _this__participantCount : 0;
        }
        createConcreteVideoStream(g, f) {
            return new LiveVideoStreamImpl(g, this._logger, this._call, this._callAgent, f, this._telemetryLogManager);
        }
        getStreamTypes() {
            return [
                2
            ];
        }
        emitVideoStreamsUpdatedEvent(g) {
            return this._eventEmitter.emit("liveStreamsUpdated", g);
        }
        constructor(g, f){
            super(f, getAcsEcsConfig().calling.liveStreamingBotIds), this._eventEmitter = g;
        }
    }
    class LiveVideoStreamImpl extends RemoteVideoStreamCommonImpl {
        getStreamMetadata() {
            var _this_call;
            return {
                callId: (_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.id,
                streamType: this.mediaStreamType,
                localParticipantId: this.call.tsCall.participantId,
                remoteParticipantId: this.remoteParticipantId,
                sourceId: this.id,
                source: "remote",
                isReceiving: this._isReceiving,
                isStreaming: this.tsStream.isStreaming,
                viewIdsRegistered: this.getRegisteredViewIds(),
                height: this._size.height,
                width: this._size.width,
                isDisposed: this._disposed
            };
        }
        constructor(g, f, S, v, _, C){
            super(g, f, S, _, C, "LiveVideoStream");
        }
    }
    class ComposedStreamCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "ComposedStream";
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        dispose() {
            this._impl.dispose(), super.dispose();
        }
        get composedStreams() {
            return this._impl.composedStreams;
        }
        on(g, f) {
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this.eventEmitter.off(g, f);
        }
        constructor(g){
            super(g), this._impl = new ComposedStreamCallFeatureImplOverTsCall(this.eventEmitter, this.name);
        }
    }
    class ComposedStreamCallFeatureImplOverTsCall extends BotStreamCommonCallFeature {
        initialize(g, f, S, v, _) {
            super.initialize(g, f, S, v, _);
        }
        dispose() {
            super.disposeAllBotStreams();
        }
        get composedStreams() {
            return [
                ...this._streamIdToStreamMap.values()
            ].map((g)=>g);
        }
        createConcreteVideoStream(g, f) {
            return new ComposedVideoStreamImpl(g, this._logger, this._call, this._callAgent, f, this._telemetryLogManager);
        }
        getStreamTypes() {
            return [
                0
            ];
        }
        emitVideoStreamsUpdatedEvent(g) {
            return this._eventEmitter.emit("composedStreamsUpdated", g);
        }
        constructor(g, f){
            super(f, getAcsEcsConfig().calling.composedStreamBotIds), this._eventEmitter = g;
        }
    }
    class ComposedVideoStreamImpl extends RemoteVideoStreamCommonImpl {
        getStreamMetadata() {
            var _this_call;
            return {
                callId: (_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.id,
                streamType: this.mediaStreamType,
                localParticipantId: this.call.tsCall.participantId,
                remoteParticipantId: this.remoteParticipantId,
                sourceId: this.id,
                source: "remote",
                isReceiving: this._isReceiving,
                isStreaming: this.tsStream.isStreaming,
                viewIdsRegistered: this.getRegisteredViewIds(),
                height: this._size.height,
                width: this._size.width,
                isDisposed: this._disposed
            };
        }
        constructor(g, f, S, v, _, C){
            super(g, f, S, _, C, "ComposedVideoStream");
        }
    }
    class ParticipantMappingManager$1 {
        _updateMapping(g) {
            var _g_endpoints_endpointDetails, _g_endpoints;
            const f = g.id, S = [];
            (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.forEach((g)=>{
                var _g_mediaStreams;
                const f = (_g_mediaStreams = g.mediaStreams) === null || _g_mediaStreams === void 0 ? void 0 : _g_mediaStreams.find((g)=>"data" === g.type);
                f && (S.push(f.sourceId), this._sourceIdToParticipantId.set(f.sourceId, g.participantId));
            });
            const v = this._participantMriToSourceId.get(f);
            return S.sort(), !P.isEqual(S, v) && (this._participantMriToSourceId.set(f, S), S.forEach((g)=>{
                this._sourceIdToParticipantMri.set(g, f);
            }), !0);
        }
        _removeMapping(g) {
            const f = g.id, S = this._participantMriToSourceId.get(f) || [];
            this._participantMriToSourceId.delete(f), S.forEach((g)=>{
                this._sourceIdToParticipantMri.delete(g), this._sourceIdToParticipantId.delete(g);
            });
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        findParticipantMri(g) {
            let f = this._sourceIdToParticipantMri.get(g);
            return void 0 === f && this.isP2P() && this._tsCall.participants.length && (f = this._tsCall.participants[0].id), f;
        }
        findParticipantId(g) {
            var _this__tsCall_participants__endpoints;
            let f = this._sourceIdToParticipantId.get(g);
            if (void 0 === f && this.isP2P() && this._tsCall.participants.length && ((_this__tsCall_participants__endpoints = this._tsCall.participants[0].endpoints) === null || _this__tsCall_participants__endpoints === void 0 ? void 0 : _this__tsCall_participants__endpoints.endpointDetails.length)) {
                var _this__tsCall_participants__endpoints1;
                const g = (_this__tsCall_participants__endpoints1 = this._tsCall.participants[0].endpoints) === null || _this__tsCall_participants__endpoints1 === void 0 ? void 0 : _this__tsCall_participants__endpoints1.endpointDetails[0];
                f = g.participantId;
            }
            return f;
        }
        findSourceIds(g) {
            var _this__participantMriToSourceId_get;
            return (_this__participantMriToSourceId_get = this._participantMriToSourceId.get(g)) !== null && _this__participantMriToSourceId_get !== void 0 ? _this__participantMriToSourceId_get : [];
        }
        isP2P() {
            return 1 === this._tsCall.callType;
        }
        dispose() {
            this._activeParticipantMris.clear(), this._participantMriToSourceId.clear(), this._sourceIdToParticipantMri.clear(), this._sourceIdToParticipantId.clear(), this._listenerHandles.forEach((g)=>g.dispose()), this._eventEmitter.removeAllListeners();
        }
        constructor(g){
            this._tsCall = g, this._activeParticipantMris = new Set, this._participantMriToSourceId = new Map, this._sourceIdToParticipantMri = new Map, this._sourceIdToParticipantId = new Map, this._listenerHandles = [], this._eventEmitter = new Ny.EventEmitter, this._listenerHandles.push(this._tsCall.on("participantAdded", (g)=>{
                this._activeParticipantMris.add(g.id), this._updateMapping(g), this._eventEmitter.emit("participantAdded", g.id);
            })), this._listenerHandles.push(this._tsCall.on("participantUpdated", (g)=>{
                this._activeParticipantMris.has(g.id) && this._updateMapping(g) && this._eventEmitter.emit("participantUpdated", g.id);
            })), this._listenerHandles.push(this._tsCall.on("participantRemoved", (g)=>{
                this._activeParticipantMris.delete(g.id), this._removeMapping(g), this._eventEmitter.emit("participantRemoved", g.id);
            })), this._tsCall.participants.forEach((g)=>{
                this._activeParticipantMris.add(g.id), this._updateMapping(g);
            });
        }
    }
    const KE = 2147483648, JE = 65535, YE = 1024, QE = 255, XE = 8, ZE = 64, eT = 4294967295, tT = "Normal", iT = "Durable", nT = .4, rT = .8;
    function invalidEventSubscription(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.EVENT_SUBSCRIBE,
            defaultErrorMessageArgs: [
                f,
                g
            ]
        });
    }
    function wrongArgumentType(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.WRONG_ARGUMENT_TYPE,
            defaultErrorMessageArgs: [
                g,
                f
            ]
        });
    }
    function wrongArgumentValue(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.WRONG_ARGUMENT_VALUE,
            defaultErrorMessageArgs: [
                g,
                f
            ]
        });
    }
    function dataChannelHasBeenDisposed() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.DISPOSED
        });
    }
    function senderIsNotReady() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.SENDER_NOT_READY
        });
    }
    function noAvailableChannelId() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.NO_AVAILABLE_CHANNEL_ID
        });
    }
    function invalidChannelId() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.INVALID_CHANNEL_ID
        });
    }
    function tooManyParticipants() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.TOO_MANY_PARTICIPANTS
        });
    }
    function noValidParticipants() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.NO_VALID_PARTICIPANT
        });
    }
    function messageDataIsEmpty() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.MSG_DATA_EMPTY
        });
    }
    function messageDataSizeIsTooLarge() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.MSG_DATA_TOO_LARGE
        });
    }
    function invalidMessageLength() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.INVALID_MSG_LENGTH
        });
    }
    function sendBufferIsFull() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.BUFFER_FULL
        });
    }
    function senderIsClosed() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.SENDER_CLOSED
        });
    }
    function noAvailableReliableDataId() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.NO_AVAILABLE_RELIABLE_CHANNEL
        });
    }
    function noAvailableUnreliableDataId() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.NO_AVAILABLE_UNRELIABLE_CHANNEL
        });
    }
    function channelHasBeenAllocated() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.CHANNEL_ALREADY_ALLOCATED
        });
    }
    function channelNotFound(g) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.CANT_FIND_CHANNEL_ID,
            defaultErrorMessageArgs: [
                g
            ]
        });
    }
    function trafficLimited() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.DATA_CHANNEL.TRAFFIC_LIMITED
        });
    }
    function getErrorString(g) {
        var _g_message;
        return (_g_message = g === null || g === void 0 ? void 0 : g.message) !== null && _g_message !== void 0 ? _g_message : "Unknown";
    }
    function logError(g, f, S) {
        const v = S.value;
        return S.value = function(...g) {
            try {
                return v === null || v === void 0 ? void 0 : v.apply(this, g);
            } catch (g) {
                var _this__logger, _this;
                throw (_this = this) === null || _this === void 0 ? void 0 : (_this__logger = _this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(`${f}: ${getErrorString(g)}`), g;
            }
        }, S;
    }
    function logErrorAsync(g, f, S) {
        const v = S.value;
        return S.value = async function(...g) {
            try {
                return await (v === null || v === void 0 ? void 0 : v.apply(this, g));
            } catch (g) {
                var _this__logger, _this;
                throw (_this = this) === null || _this === void 0 ? void 0 : (_this__logger = _this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(`${f}: ${getErrorString(g)}`), g;
            }
        }, S;
    }
    class Message {
        static parse(g) {
            if (g.length < Message.headerLength) throw invalidMessageLength();
            const f = new DataView(g.buffer), S = f.getUint8(0), v = f.getUint8(1), _ = f.getUint16(2), C = f.getUint32(4), E = g.slice(Message.headerLength), T = new Message;
            return T._firstByte = S, T._channelVersion = v, T._channelId = _, T._sequenceNumber = C, T._data = E, T._serializedData = g, T;
        }
        static create(g, f, S, v) {
            const _ = new Message, C = new Uint8Array(Message.headerLength + v.length), E = new DataView(C.buffer);
            return f &= 255, g &= 65535, S >>>= 0, E.setUint8(0, 0), E.setUint8(1, f), E.setUint16(2, g), E.setUint32(4, S), C.set(v, Message.headerLength), _._channelVersion = f, _._channelId = g, _._sequenceNumber = S, _._data = v, _._serializedData = C, _;
        }
        get channelId() {
            return this._channelId;
        }
        set channelId(g) {
            this._channelId = g;
        }
        get channelVersion() {
            return this._channelVersion;
        }
        get sequenceNumber() {
            return this._sequenceNumber;
        }
        get data() {
            return this._data;
        }
        get serializedData() {
            return this._serializedData;
        }
        isInternal() {
            return 0 != (128 & this._firstByte);
        }
        isEmpty() {
            return 0 === this._data.length;
        }
        constructor(){
            this._firstByte = 0, this._channelVersion = 0, this._channelId = 0, this._sequenceNumber = 0;
        }
    }
    var aT;
    Message.headerLength = XE, (aT = g.DataChannelState || (g.DataChannelState = {}))[aT.Initializing = 0] = "Initializing", aT[aT.Initialized = 1] = "Initialized", aT[aT.Started = 2] = "Started", aT[aT.Stopped = 3] = "Stopped", aT[aT.Destroyed = 4] = "Destroyed";
    class DataChannelAdapter {
        async initialize() {
            var _this__tsCall_dataChannelAdapter;
            const f = {
                onStarted: async (f, S, v)=>{
                    this._dataSendFunction = S, this._getStats = v, this._state = g.DataChannelState.Started, this._eventEmitter.emit("stateChanged", this._state);
                },
                onStopped: async (f)=>{
                    this._dataSendFunction = void 0, this._getStats = void 0, this._state = g.DataChannelState.Stopped, this._eventEmitter.emit("stateChanged", this._state);
                },
                onDataReceived: async (g, f, S)=>{
                    const v = {
                        sourceId: S,
                        data: f
                    };
                    this._eventEmitter.emit("message", v);
                }
            };
            await ((_this__tsCall_dataChannelAdapter = this._tsCall.dataChannelAdapter) === null || _this__tsCall_dataChannelAdapter === void 0 ? void 0 : _this__tsCall_dataChannelAdapter.addHandler(this._dataId, f)), this._state < g.DataChannelState.Initialized && (this._state = g.DataChannelState.Initialized);
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        send(g, f) {
            return this._dataSendFunction ? this._dataSendFunction(g, f) : Promise.reject(senderIsNotReady());
        }
        getStats() {
            return this._getStats ? this._getStats() : Promise.resolve({
                bufferSize: 0,
                remainingBytes: 0,
                remainingPackets: 0
            });
        }
        get state() {
            return this._state;
        }
        dispose() {
            var _this__tsCall_dataChannelAdapter;
            if (this._state === g.DataChannelState.Destroyed) return;
            const f = this._state;
            this._state = g.DataChannelState.Destroyed, this._dataSendFunction = void 0, this._getStats = void 0, f !== g.DataChannelState.Initializing && ((_this__tsCall_dataChannelAdapter = this._tsCall.dataChannelAdapter) === null || _this__tsCall_dataChannelAdapter === void 0 ? void 0 : _this__tsCall_dataChannelAdapter.removeHandler(this._dataId).catch(noop)), this._eventEmitter.emit("stateChanged", this._state), this._eventEmitter.removeAllListeners();
        }
        constructor(f, S){
            this._eventEmitter = new Ny.EventEmitter, this._state = g.DataChannelState.Initializing, this._tsCall = f, this._dataId = S;
        }
    }
    class DataChannelProcessor {
        async initialize() {
            await this._dataChannelAdapter.initialize();
        }
        async send(g) {
            try {
                if (void 0 === g.recipients) throw noValidParticipants();
                if (g.recipients.length > ZE) throw tooManyParticipants();
                await this._dataChannelAdapter.send(g.data, g.recipients);
            } catch (g) {
                throw (g === null || g === void 0 ? void 0 : g.message) === this._bufferFullErrorMessage ? sendBufferIsFull() : new CallingCommunicationError({
                    defaultError: O.FEATURES.DATA_CHANNEL.SEND_FAIL,
                    originalError: g
                });
            }
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            this._eventEmitter.removeAllListeners(), this._dataChannelAdapter.dispose();
        }
        constructor(g, f, S){
            const v = g.dataId;
            this._logger = S.createChild(`DataChannelProcessor(${v})`), this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogOn: !1,
                enableLogOff: !1,
                enableLogOnce: !1,
                enableLogEmit: !1
            }), this._bufferFullErrorMessage = `dataId ${v} send queue is full`, this._dataChannelAdapter = new DataChannelAdapter(f, v), this._dataChannelAdapter.on("message", (g)=>{
                try {
                    const f = g.sourceId, S = Message.parse(g.data), v = {
                        sourceId: f,
                        message: S
                    };
                    S.isInternal() ? this._eventEmitter.emit("internalMessage", v) : this._eventEmitter.emit("message", v);
                } catch (g) {
                    this._logger.error(`process message error: ${getErrorString(g)}`);
                }
            });
        }
    }
    class RecipientsManager {
        get sourceIds() {
            if (this._participantMappingManager.isP2P() || !(this._participantMapping.size > 0) || 0 !== this._sourceIds.length) return this._sourceIds;
        }
        setParticipants(g) {
            const f = [];
            g.forEach((g)=>{
                validateIdentifier(g), f.push(getMriFromIdentifier(g));
            }), this._participantMapping.clear(), f.forEach((g)=>{
                const f = this._participantMappingManager.findSourceIds(g);
                this._participantMapping.set(g, f);
            }), this._updateSourceIds();
        }
        _updateSourceIds() {
            this._sourceIds = Array.from(this._participantMapping.values()).flat();
        }
        constructor(g){
            this._sourceIds = [], this._participantMappingManager = g, this._participantMapping = new Map, g.on("participantAdded", (g)=>{
                if (this._participantMapping.has(g)) {
                    const f = this._participantMappingManager.findSourceIds(g);
                    this._participantMapping.set(g, f), this._updateSourceIds();
                }
            }), g.on("participantUpdated", (g)=>{
                if (this._participantMapping.has(g)) {
                    const f = this._participantMappingManager.findSourceIds(g);
                    this._participantMapping.set(g, f), this._updateSourceIds();
                }
            }), g.on("participantRemoved", (g)=>{
                this._participantMapping.has(g) && (this._participantMapping.set(g, []), this._updateSourceIds());
            });
        }
    }
    var sT, __decorate$8 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$8 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    !function(g) {
        g[g.Open = 0] = "Open", g[g.Closed = 1] = "Closed", g[g.Destroyed = 2] = "Destroyed";
    }(sT || (sT = {}));
    class DataChannelSenderImpl {
        get channelId() {
            return this._channelId;
        }
        get maxMessageSize() {
            return this._maxMessageSize;
        }
        setParticipants(g) {
            if (!Array.isArray(g)) throw wrongArgumentType("participants", "CommunicationIdentifier[]");
            if (g.length > ZE) throw tooManyParticipants();
            this._recipientsManager.setParticipants(g), this._logger.info(`participant size: ${g.length}`);
        }
        async sendMessage(g) {
            if (this._dataChannelMonitor.updateAttemptStats(g.length), !(g instanceof Uint8Array)) throw wrongArgumentType("data", "Uint8Array");
            if (this._state === sT.Closed) throw senderIsClosed();
            if (0 === g.length) throw messageDataIsEmpty();
            if (g.length > this._maxMessageSize) throw messageDataSizeIsTooLarge();
            const f = this._recipientsManager.sourceIds;
            await this._sendMessage(g, f), this._dataChannelMonitor.updateCommitStats(g.length);
        }
        close() {
            this._state < sT.Closed && (this._sendMessage(new Uint8Array, []).catch(noop), this._state = sT.Closed, this._eventEmitter.emit("close"), this._logger.info("closed"), this._dataChannelMonitor.close());
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            this.close(), this._state !== sT.Destroyed && (this._eventEmitter.removeAllListeners(), this._state = sT.Destroyed, this._logger.info("disposed"));
        }
        get channelVersion() {
            return this._channelVersion;
        }
        get state() {
            return this._state;
        }
        async _sendMessage(g, f) {
            const S = Message.create(this._channelId, this._channelVersion, this._sequenceNumber, g);
            this._sequenceNumber = (this._sequenceNumber + 1) % (eT + 1);
            const v = {
                channelId: this._channelId,
                channelVersion: this._channelVersion,
                recipients: f,
                data: S.serializedData
            };
            await this._sendMessageFunction(v);
        }
        constructor(g, f, S, v, _, C){
            this._state = sT.Open;
            const E = getAcsEcsConfig().dataChannel;
            this._eventEmitter = new Ny.EventEmitter, this._channelId = g, this._channelVersion = f, this._sequenceNumber = Math.floor(Math.random() * (eT + 1)), this._recipientsManager = new RecipientsManager(v), this._dataChannelMonitor = _, this._sendMessageFunction = S, this._maxMessageSize = E.maxMessageSize, this._logger = C.createChild(`DataChannelSender(${g},${f})`), this._logger.info("opened");
        }
    }
    __decorate$8([
        logError,
        __metadata$8("design:type", Function),
        __metadata$8("design:paramtypes", [
            Array
        ]),
        __metadata$8("design:returntype", void 0)
    ], DataChannelSenderImpl.prototype, "setParticipants", null), __decorate$8([
        logErrorAsync,
        __metadata$8("design:type", Function),
        __metadata$8("design:paramtypes", [
            Uint8Array
        ]),
        __metadata$8("design:returntype", Promise)
    ], DataChannelSenderImpl.prototype, "sendMessage", null), __decorate$8([
        logError,
        __metadata$8("design:type", Function),
        __metadata$8("design:paramtypes", []),
        __metadata$8("design:returntype", void 0)
    ], DataChannelSenderImpl.prototype, "close", null), __decorate$8([
        logError,
        __metadata$8("design:type", Function),
        __metadata$8("design:paramtypes", []),
        __metadata$8("design:returntype", void 0)
    ], DataChannelSenderImpl.prototype, "dispose", null);
    class Node$1 {
        constructor(g){
            this.value = g, this.next = void 0;
        }
    }
    class Queue {
        enqueue(g) {
            const f = new Node$1(g);
            this.front ? (this.rear.next = f, this.rear = f) : (this.front = f, this.rear = f), this.length++;
        }
        dequeue() {
            if (!this.front) return;
            const g = this.front;
            return this.front === this.rear ? (this.front = void 0, this.rear = void 0) : this.front = this.front.next, this.length--, g.value;
        }
        peek() {
            var _this_front;
            return (_this_front = this.front) === null || _this_front === void 0 ? void 0 : _this_front.value;
        }
        size() {
            return this.length;
        }
        back() {
            var _this_rear;
            return (_this_rear = this.rear) === null || _this_rear === void 0 ? void 0 : _this_rear.value;
        }
        isEmpty() {
            return 0 === length;
        }
        clear() {
            this.front = void 0, this.rear = void 0, this.length = 0;
        }
        constructor(){
            this.length = 0, this.front = void 0, this.rear = void 0;
        }
    }
    var oT, __decorate$9 = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$9 = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    !function(g) {
        g[g.Open = 0] = "Open", g[g.Closed = 1] = "Closed", g[g.Destroyed = 2] = "Destroyed";
    }(oT || (oT = {}));
    class DataChannelReceiverImpl {
        get channelId() {
            return this._channelId;
        }
        get senderParticipantIdentifier() {
            return this._senderParticipantIdentifier;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        readMessage() {
            const g = this._receiveBuffers.dequeue();
            return (g === null || g === void 0 ? void 0 : g.data) && (this._remainingBytes -= g.data.length), g;
        }
        dispose() {
            this._state !== oT.Destroyed && (this.close(), this._state = oT.Destroyed, this._receiveBuffers.clear(), this._eventEmitter.removeAllListeners());
        }
        close() {
            this._state === oT.Open && (this._state = oT.Closed, this._eventEmitter.emit("close"), this._dataChannelMonitor.close());
        }
        get channelVersion() {
            return this._channelVersion;
        }
        get lastMessageTimestamp() {
            return this._lastMessageTimestamp;
        }
        get state() {
            return this._state;
        }
        appendMessage(g) {
            if (this._dataChannelMonitor.updateAttemptStats(g.data.length), this._state !== oT.Open) return;
            if (0 === g.data.length) return void this.close();
            if (this._lastMessageTimestamp = Date.now(), this._remainingBytes + g.data.length > this._maxBufferSize) return;
            const f = {
                sequenceNumber: g.sequenceNumber,
                data: g.data
            };
            this._receiveBuffers.enqueue(f), this._remainingBytes += g.data.length, this._eventEmitter.emit("messageReady"), this._dataChannelMonitor.updateCommitStats(g.data.length);
        }
        constructor(g, f, S, v, _, C){
            this._receiveBuffers = new Queue, this._remainingBytes = 0, this._state = oT.Open, this._channelVersion = 0;
            const E = getAcsEcsConfig().dataChannel;
            this._logger = C.createChild(`DataChannelReceiver(${g},${v},${S})`), this._eventEmitter = new CallingEventEmitter(this._logger, {
                enableLogEmit: !1
            }), this._maxBufferSize = E.maxReceiveBufferSize, this._dataChannelMonitor = _, this._channelId = g, this._senderParticipantIdentifier = constructIdentifierKindFromMri(f), this._channelVersion = v, this._lastMessageTimestamp = Date.now(), this._logger.info("created.");
        }
    }
    function logSenderOptions(g) {
        const f = [];
        return void 0 !== g.bitrateInKbps && f.push(`bitrateInKbps=${g.bitrateInKbps}`), void 0 !== g.channelId && f.push(`channelId=${g.channelId}`), void 0 !== g.participants && f.push(`participants size=${g.participants.length}`), void 0 !== g.priority && f.push(`priority=${g.priority}`), void 0 !== g.reliability && f.push(`reliability=${g.reliability}`), f.join(",");
    }
    function compareChannelVersion(g, f) {
        if (g === f) return 0;
        if (-1 === f) return 1;
        const S = g - f;
        return S > 0 ? S < QE / 2 ? 1 : -1 : -S > QE / 2 ? 1 : -1;
    }
    function nextChannelVersion(g) {
        return g === QE ? 0 : g + 1;
    }
    __decorate$9([
        logError,
        __metadata$9("design:type", Function),
        __metadata$9("design:paramtypes", []),
        __metadata$9("design:returntype", Object)
    ], DataChannelReceiverImpl.prototype, "readMessage", null), __decorate$9([
        logError,
        __metadata$9("design:type", Function),
        __metadata$9("design:paramtypes", [
            Message
        ]),
        __metadata$9("design:returntype", void 0)
    ], DataChannelReceiverImpl.prototype, "appendMessage", null);
    class DataChannelReceiversManager {
        _checkTimeoutReceivers() {
            Array.from(this._receivers.keys()).forEach((g)=>{
                const f = this._receivers.get(g);
                if (void 0 !== f) Date.now() - f.lastMessageTimestamp >= this._receiveTimeoutInMs && f.close();
            }), this._receivers.size > 0 && (this._timeoutHandle = window.setTimeout(()=>{
                this._timeoutHandle = 0, this._checkTimeoutReceivers(), this._receiveTimeoutInMs;
            }));
        }
        appendMessage(g) {
            const f = `${g.sourceId},${g.message.channelId}`, S = `${g.sourceId},${g.message.channelId},${g.message.channelVersion}`;
            let v = this._lastestVersion.get(f), _ = this._receivers.get(S);
            const C = g.message;
            if (void 0 === _) {
                if (void 0 !== v) {
                    if (-1 === compareChannelVersion(C.channelVersion, v)) return;
                }
                if (this._lastestVersion.set(f, C.channelVersion), C.isEmpty()) return;
                if (0 === this._eventEmitter.listenerCount("dataChannelReceiverCreated")) return;
                var _this__participantMappingManager_findParticipantMri, _this__participantMappingManager_findParticipantId;
                const E = (_this__participantMappingManager_findParticipantMri = this._participantMappingManager.findParticipantMri(g.sourceId)) !== null && _this__participantMappingManager_findParticipantMri !== void 0 ? _this__participantMappingManager_findParticipantMri : "", T = (_this__participantMappingManager_findParticipantId = this._participantMappingManager.findParticipantId(g.sourceId)) !== null && _this__participantMappingManager_findParticipantId !== void 0 ? _this__participantMappingManager_findParticipantId : "", I = this._dataChannelMonitor.createReceiverMonitor(C.channelId, C.channelVersion, T);
                if ("" === E) return void this._logger.info(`Unable to find corresponding sender mri, ignoring the message. channelId:${C.channelId}, sourceId:${g.sourceId}`);
                this._logger.info(`channelId:${C.channelId} message from ${T}, sourceId:${g.sourceId}, channelVersion:${C.channelVersion}`), _ = new DataChannelReceiverImpl(C.channelId, E, g.sourceId, C.channelVersion, I, this._logger), _.on("close", ()=>{
                    this._receivers.delete(S);
                }), this._receivers.set(S, _), this._eventEmitter.emit("dataChannelReceiverCreated", _), 0 === this._timeoutHandle && this._checkTimeoutReceivers();
            }
            _.appendMessage(C), C.isEmpty() && this._receivers.delete(S);
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            window.clearTimeout(this._timeoutHandle), this._timeoutHandle = 0, this._receivers.forEach((g, f)=>{
                g.dispose();
            }), this._lastestVersion.clear(), this._receivers.clear(), this._eventEmitter.removeAllListeners();
        }
        constructor(g, f, S){
            this._timeoutHandle = 0;
            const v = getAcsEcsConfig().dataChannel;
            this._eventEmitter = new Ny.EventEmitter, this._participantMappingManager = g, this._dataChannelMonitor = f, this._logger = S, this._receivers = new Map, this._lastestVersion = new Map, this._receiveTimeoutInMs = v.receiveTimeoutInMs;
        }
    }
    const lT = JE - YE + 1;
    class RandomPickStrategy {
        findAvailableChannelId() {
            if (this._channelIdsInUse.size >= lT) throw noAvailableChannelId();
            const genId = ()=>Math.floor(Math.random() * lT) + YE;
            let g;
            for(; (g = genId()) && this._channelIdsInUse.has(g););
            return g;
        }
        constructor(g){
            this._channelIdsInUse = g;
        }
    }
    class ShuffleArrayStrategy {
        findAvailableChannelId() {
            if (0 === this._availableChannelIds.length) {
                if (this._channelIdsInUse.size >= lT) throw noAvailableChannelId();
                this._initArray();
            }
            return this._availableChannelIds.pop();
        }
        _initArray() {
            const g = Array.from(this._channelIdsInUse, (g)=>g).sort();
            let f = 0, S = 0;
            for(; f <= JE && S < g.length;)f < g[S] ? (this._availableChannelIds.push(f), f++) : (f > g[S] || f++, S++);
            for(; f <= JE;)this._availableChannelIds.push(f), f++;
            this._availableChannelIds = P.shuffle(this._availableChannelIds);
        }
        constructor(g){
            this._availableChannelIds = [], this._channelIdsInUse = g, this._initArray();
        }
    }
    class RandomChannelIdManager {
        addChannelId(g) {
            g >= YE && g <= JE && (this._channelIdsInUse.add(g), this._channelIdsInUse.size >= this._highWaterMark && this._strategy instanceof RandomPickStrategy && (this._strategy = new ShuffleArrayStrategy(this._channelIdsInUse)));
        }
        removeChannelId(g) {
            this._channelIdsInUse.delete(g), this._channelIdsInUse.size < this._lowWaterMark && this._strategy instanceof ShuffleArrayStrategy && (this._strategy = new RandomPickStrategy(this._channelIdsInUse));
        }
        findAvailableChannelId() {
            return this._strategy.findAvailableChannelId();
        }
        constructor(){
            this._channelIdsInUse = new Set, this._highWaterMark = Math.ceil(lT * rT), this._lowWaterMark = Math.floor(lT * nT), this._strategy = new RandomPickStrategy(this._channelIdsInUse);
        }
    }
    class DurableDataIdResourceManager {
        allocate(g) {
            const f = P.maxBy(this._dataIds, (f)=>1 - (f.allocatedBandwidth + g.bitrate) / f.bandwidth);
            if (void 0 === f) throw noAvailableReliableDataId();
            return f.allocatedBandwidth += g.bitrate, this._channelIds.set(g.channelId, {
                dataId: f.dataId,
                allocatedBandwidth: g.bitrate
            }), f.dataId;
        }
        deallocate(g) {
            const f = this._channelIds.get(g);
            if (void 0 !== f) {
                const S = this._dataIds.find((g)=>g.dataId === f.dataId);
                void 0 !== S && (S.allocatedBandwidth -= f.allocatedBandwidth), this._channelIds.delete(g);
            }
        }
        getDataIds(g) {
            const f = this._channelIds.get(g);
            return void 0 !== f ? [
                f.dataId
            ] : [];
        }
        constructor(g){
            this._dataIds = [], this._channelIds = new Map, g.forEach((g)=>{
                this._dataIds.push({
                    dataId: g.dataId,
                    bandwidth: g.bandwidth,
                    allocatedBandwidth: 0
                });
            });
        }
    }
    function isPowerOf2(g) {
        if (g.find((g)=>!Number.isInteger(Math.log2(g)))) return !1;
        for(let f = 1; f < g.length; f++)if (g[f] !== 2 * g[f - 1]) return !1;
        return !0;
    }
    class DataIdSelectionNullStrategy {
        getDataIds(g) {
            throw noAvailableUnreliableDataId();
        }
        getAllSum() {
            return 0;
        }
    }
    class DataIdSelectionPower2Strategy {
        getDataIds(g) {
            let f = [];
            const S = Math.ceil(g / 1e3);
            if (S >= this._allSum) f = this._acsDataIdConfigs.map((g)=>g.dataId);
            else {
                const g = this._bandwidthList[0] - 1;
                let v = 0;
                0 != (S & g) && (v = this._bandwidthList.findIndex((g)=>0 == (g & S)), -1 !== v && (f.push(this._acsDataIdConfigs[v].dataId), v++));
                for(let g = v; g < this._bandwidthList.length; g++)this._bandwidthList[g] & S && f.push(this._acsDataIdConfigs[g].dataId);
            }
            return f;
        }
        getAllSum() {
            return this._allSum;
        }
        constructor(g){
            this._acsDataIdConfigs = [], this._bandwidthList = [], this._acsDataIdConfigs = g, g.forEach((g)=>{
                this._bandwidthList.push(g.bandwidth / 1e3);
            }), this._allSum = P.sumBy(g, (g)=>g.bandwidth);
        }
    }
    function powerSet(g) {
        const f = [
            []
        ];
        return g.forEach((g)=>{
            const S = [];
            f.forEach((f)=>{
                S.push([
                    ...f,
                    g
                ]);
            }), f.push(...S);
        }), f;
    }
    class DataIdSelectionPowerSetSumStrategy {
        getDataIds(g) {
            var _this__bandwidthList_f;
            const f = P.sortedIndex(this._bandwidthList, g), S = (_this__bandwidthList_f = this._bandwidthList[f]) !== null && _this__bandwidthList_f !== void 0 ? _this__bandwidthList_f : this._bandwidthList[this._bandwidthList.length - 1];
            return this._bandwidthMap.get(S) || [];
        }
        getAllSum() {
            return P.last(this._bandwidthList) || 0;
        }
        constructor(g){
            this._bandwidthMap = new Map, this._bandwidthMap.set(0, []);
            powerSet(g).forEach((g)=>{
                const f = P.sumBy(g, (g)=>g.bandwidth), S = this._bandwidthMap.get(f);
                (void 0 === S || g.length < S.length) && this._bandwidthMap.set(f, g.map((g)=>g.dataId));
            }), this._bandwidthList = Array.from(this._bandwidthMap.keys()).sort((g, f)=>g - f);
        }
    }
    class BandwidthTable {
        getDataIds(g) {
            return this._dataIdSelectionStrategy.getDataIds(g);
        }
        getAllSum() {
            return this._dataIdSelectionStrategy.getAllSum();
        }
        constructor(g){
            (g = P.sortBy(g, (g)=>g.bandwidth)).length ? isPowerOf2(g.map((g)=>g.bandwidth / 1e3)) ? this._dataIdSelectionStrategy = new DataIdSelectionPower2Strategy(g) : this._dataIdSelectionStrategy = new DataIdSelectionPowerSetSumStrategy(g) : this._dataIdSelectionStrategy = new DataIdSelectionNullStrategy;
        }
    }
    class LossyDataIdResourceManager {
        allocate(g) {
            this._configs.set(g.channelId, g), "Normal" === g.priority ? this._totalNormalPriorityBandwidth += g.bitrate : "High" === g.priority && (this._totalHighPriorityBandwidth += g.bitrate), this._updateDataIds();
        }
        deallocate(g) {
            const f = this._configs.get(g);
            void 0 !== f && (this._configs.delete(g), "Normal" === f.priority ? this._totalNormalPriorityBandwidth -= f.bitrate : "High" === f.priority && (this._totalHighPriorityBandwidth -= f.bitrate), this._updateDataIds());
        }
        getDataIds(g) {
            const f = this._configs.get(g);
            if (void 0 !== f) {
                if ("Normal" === f.priority) return this._currentNormalPriorityDataIds;
                if ("High" === f.priority) return this._currentHighPriorityDataIds;
            }
            return [];
        }
        _updateDataIds() {
            const g = this._highPriorityTable.getAllSum(), f = this._totalHighPriorityBandwidth - g;
            if (f > 0) {
                const g = this._totalNormalPriorityBandwidth + f;
                this._currentNormalPriorityDataIds = this._normalPriorityTable.getDataIds(g), this._currentHighPriorityDataIds = this._highPriorityTable.getDataIds(this._totalHighPriorityBandwidth).concat(this._currentNormalPriorityDataIds);
            } else this._currentNormalPriorityDataIds = this._normalPriorityTable.getDataIds(this._totalNormalPriorityBandwidth), this._currentHighPriorityDataIds = this._highPriorityTable.getDataIds(this._totalHighPriorityBandwidth);
        }
        constructor(g){
            this._totalNormalPriorityBandwidth = 0, this._totalHighPriorityBandwidth = 0, this._configs = new Map, this._currentNormalPriorityDataIds = [], this._currentHighPriorityDataIds = [], this._normalPriorityTable = new BandwidthTable(g.filter((g)=>"normal" === g.priority)), this._highPriorityTable = new BandwidthTable(g.filter((g)=>"high" === g.priority));
        }
    }
    class DataIdMappingManager {
        allocate(g) {
            let f = -1;
            if (this._configs.has(g.channelId)) throw channelHasBeenAllocated();
            try {
                "Durable" === g.reliability ? f = this._reliableDataIdManager.allocate(g) : (this._unicastDataIdManager.allocate(g), this._broadcastDataIdManager.allocate(g)), this._configs.set(g.channelId, g);
            } catch (f) {
                throw "Durable" === g.reliability ? this._reliableDataIdManager.deallocate(g.channelId) : (this._unicastDataIdManager.deallocate(g.channelId), this._broadcastDataIdManager.deallocate(g.channelId)), f;
            }
            return f;
        }
        deallocate(g) {
            const f = this._configs.get(g);
            void 0 !== f && ("Durable" === f.reliability ? this._reliableDataIdManager.deallocate(g) : (this._unicastDataIdManager.deallocate(g), this._broadcastDataIdManager.deallocate(g)), this._configs.delete(g));
        }
        getDataIdToSend(g, f, S) {
            const v = this._configs.get(g);
            if (void 0 !== v) return "Durable" === v.reliability ? this._reliableDataIdManager.getDataIds(g) : S ? this._broadcastDataIdManager.getDataIds(g) : this._unicastDataIdManager.getDataIds(g);
            throw channelNotFound(g);
        }
        constructor(g){
            const f = g.filter((g)=>"reliable" === g.category), S = g.filter((g)=>"unicast" === g.category), v = g.filter((g)=>"broadcast" === g.category);
            this._reliableDataIdManager = new DurableDataIdResourceManager(f), this._unicastDataIdManager = new LossyDataIdResourceManager(S), this._broadcastDataIdManager = new LossyDataIdResourceManager(v), this._configs = new Map;
        }
    }
    class DataChannelSendRecvMonitor {
        updateAttemptStats(g) {
            this._attemptCount++, this._attemptBytes += g;
        }
        updateCommitStats(g) {
            this._commitCount++, this._commitBytes += g;
        }
        close() {
            this._closeTime = new Date;
        }
        constructor(g){
            this._attemptCount = 0, this._attemptBytes = 0, this._commitCount = 0, this._commitBytes = 0, this._dataChannelTelemetryLogger = g, this._openTime = new Date, this._closeTime = this._openTime;
        }
    }
    class DataChannelSenderMonitor extends DataChannelSendRecvMonitor {
        close() {
            super.close();
            const g = {
                direction: "send",
                channelId: this._channelId,
                channelVersion: this._channelVersion,
                openTime: this._openTime,
                closeTime: this._closeTime,
                attemptCount: this._attemptCount,
                attemptBytes: this._attemptBytes,
                commitCount: this._commitCount,
                commitBytes: this._commitBytes,
                correlationId: this._correlationId
            };
            this._dataChannelTelemetryLogger.sendStatsEvent(g);
        }
        constructor(g, f, S, v){
            super(v), this._channelId = g, this._channelVersion = f, this._correlationId = S;
        }
    }
    class DataChannelReceiverMonitor extends DataChannelSendRecvMonitor {
        close() {
            super.close();
            const g = {
                direction: "recv",
                channelId: this._channelId,
                channelVersion: this._channelVersion,
                openTime: this._openTime,
                closeTime: this._closeTime,
                attemptCount: this._attemptCount,
                attemptBytes: this._attemptBytes,
                commitCount: this._commitCount,
                commitBytes: this._commitBytes,
                remoteParticipantId: this._remoteParticipantId
            };
            this._dataChannelTelemetryLogger.sendStatsEvent(g);
        }
        constructor(g, f, S, v){
            super(v), this._channelId = g, this._channelVersion = f, this._remoteParticipantId = S;
        }
    }
    class DataChannelMonitor {
        createSenderMonitor(g, f, S) {
            return new DataChannelSenderMonitor(g, f, S, this._dataChannelTelemetryLogger);
        }
        createReceiverMonitor(g, f, S) {
            return new DataChannelReceiverMonitor(g, f, S, this._dataChannelTelemetryLogger);
        }
        constructor(g){
            this._dataChannelTelemetryLogger = g;
        }
    }
    class PacketRateLimiter {
        canSend(g) {
            let f = Math.ceil(g / 1200);
            const S = window.performance.now();
            return Math.floor(S / 1e3) == this._timeBucket && (f += this._packetCount), f <= this._maxPacketRate;
        }
        update(g) {
            let f = Math.ceil(g / 1200);
            const S = window.performance.now(), v = Math.floor(S / 1e3);
            v !== this._timeBucket && (this._timeBucket = v, this._packetCount = 0), this._packetCount += f;
        }
        constructor(g){
            this._timeBucket = 0, this._maxPacketRate = 0, this._packetCount = 0, this._maxPacketRate = g;
        }
    }
    class BitrateLimiter {
        canSend(g) {
            if (0 === this._maxDataRate) return !0;
            const f = window.performance.now(), S = (this._endTime - f) / 1e3;
            return !(S > 0) || S + g / this._maxDataRate <= 1;
        }
        update(g) {
            const f = window.performance.now(), S = this._maxDataRate ? g / this._maxDataRate * 1e3 : 0;
            this._endTime < f ? this._endTime = f + S : this._endTime += S;
        }
        changeBitrate(g) {
            this._maxDataRate = g / 8;
        }
        constructor(g){
            this._endTime = 0, this._maxDataRate = 0, this._maxDataRate = g / 8;
        }
    }
    class BitrateCalculator {
        getBitrate() {
            return this._currentBitrate;
        }
        update(g) {
            this._totalBytes += g;
        }
        calculateBitrate() {
            const g = window.performance.now();
            g - this._lastUpdateTime > 0 && (this._currentBitrate = 8 * (this._totalBytes - this._lastUpdateBytes) / (g - this._lastUpdateTime)), this._lastUpdateTime = g, this._lastUpdateBytes = this._totalBytes;
        }
        constructor(){
            this._totalBytes = 0, this._lastUpdateTime = window.performance.now(), this._lastUpdateBytes = 0, this._currentBitrate = 0;
        }
    }
    class SendTrafficLimiter {
        canSend(g, f) {
            return f ? !!this._packetRateLimiter.canSend(g) && this._availableBytes - this._reducedBytes >= g : this._availableBytes >= g;
        }
        updateSendBytes(g, f) {
            f && this._packetRateLimiter.update(g), this._availableBytes -= g;
        }
        updateReceiveBytes(g) {
            this._receiveBitrate.update(g);
        }
        dispose() {
            window.clearInterval(this._bitrateTimer);
        }
        constructor(g, f){
            this._availableBytes = 0, this._reducedBytes = 0, this._lastUpdateTime = window.performance.now(), this._packetRateLimiter = new PacketRateLimiter(f), this._receiveBitrate = new BitrateCalculator, this._bitrateTimer = window.setInterval(()=>{
                this._receiveBitrate.calculateBitrate();
                const f = window.performance.now(), S = (f - this._lastUpdateTime) / 1e3;
                this._availableBytes = g / 8 * S, this._reducedBytes = .8 * this._receiveBitrate.getBitrate() / 8 * S, this._lastUpdateTime = f;
            }, 1e3);
        }
    }
    var cT, dT;
    !function(g) {
        g[g.Initializing = 0] = "Initializing", g[g.Initialized = 1] = "Initialized", g[g.Destroyed = 2] = "Destroyed";
    }(cT || (cT = {}));
    class DataChannelManager {
        async initialize() {
            const createProcessor = async (g)=>{
                const f = new DataChannelProcessor(g, this._tsCall, this._logger);
                return f.on("message", (f)=>{
                    const S = f.message;
                    g.raw ? S.channelId = g.dataId + KE : this._sendTrafficLimiter.updateReceiveBytes(S.data.length);
                    try {
                        this._receiversManager.appendMessage(f);
                    } catch (f) {
                        this._logger.error(`Failed to appendMessage on dataId ${g.dataId}: ${getErrorString(f)}`);
                    }
                }), await f.initialize(), f;
            }, g = [], f = new Map, S = Array.from(this._dataIds.keys());
            for(let v = 0; v < S.length; v++){
                const _ = S[v], C = this._dataIds.get(_)[0];
                try {
                    const g = await createProcessor(C);
                    f.set(_, g);
                } catch (f) {
                    g.push(_), this._dataIds.delete(_);
                }
            }
            const v = P.flatten(Array.from(this._dataIds.values())).filter((g)=>!g.raw);
            this._dataIdMappingManager = new DataIdMappingManager(v), this._state === cT.Initializing ? (this._processors = f, v.forEach((g)=>{
                this._rateLimiters.has(g.dataId) || this._rateLimiters.set(g.dataId, new BitrateLimiter(g.bandwidth));
            }), g.length && this._dataChannelTelemtryLogger.sendCreateProcessorEvent({
                kindOfEvent: "failure",
                dataIds: g
            }), this._state = cT.Initialized, this._initializedDefer.resolve()) : f.forEach((g)=>{
                g.dispose();
            });
        }
        createSender(g, f) {
            var _this__senders_get;
            let S = g.channelId, v = !1;
            if (S >= KE) {
                var _this__dataIds_get;
                if (!0 !== ((_this__dataIds_get = this._dataIds.get(S - KE)) === null || _this__dataIds_get === void 0 ? void 0 : _this__dataIds_get[0].raw)) throw invalidChannelId();
                v = !0;
            } else {
                if (S < 0 || S > JE) throw invalidChannelId();
                0 === S && (S = this._randomChannelIdManager.findAvailableChannelId());
            }
            (_this__senders_get = this._senders.get(S)) === null || _this__senders_get === void 0 ? void 0 : _this__senders_get.close();
            var _this__channelVersions_get;
            const _ = nextChannelVersion((_this__channelVersions_get = this._channelVersions.get(S)) !== null && _this__channelVersions_get !== void 0 ? _this__channelVersions_get : -1);
            let C = S >= KE ? S - KE : -1, E = !1;
            -1 === C && this._state === cT.Initialized && (C = this._dataIdMappingManager.allocate({
                channelId: S,
                reliability: g.reliability,
                priority: g.priority,
                bitrate: 1e3 * g.bitrateInKbps
            }), E = !0);
            const sendFunction = async (f)=>{
                var _f_recipients;
                const _ = f.data.length;
                if (-1 === C && !E) {
                    if (_ === XE) return;
                    await this._initializedDefer.promise, E || (C = this._dataIdMappingManager.allocate({
                        channelId: S,
                        reliability: g.reliability,
                        priority: g.priority,
                        bitrate: 1e3 * g.bitrateInKbps
                    }), E = !0);
                }
                const T = 0 === ((_f_recipients = f.recipients) === null || _f_recipients === void 0 ? void 0 : _f_recipients.length) && !this._participantMappingManager.isP2P();
                if (-1 !== C) {
                    if (this._enableBroadcastLimitOnReliableChannel && T && !v) {
                        if (!this._sendTrafficLimiter.canSend(_, T)) throw trafficLimited();
                        const g = this._processors.get(C);
                        await (g === null || g === void 0 ? void 0 : g.send(f)), this._sendTrafficLimiter.updateSendBytes(_, T);
                    } else {
                        const g = this._processors.get(C);
                        await (g === null || g === void 0 ? void 0 : g.send(f));
                    }
                } else {
                    const v = this._dataIdMappingManager.getDataIdToSend(S, _, T);
                    try {
                        const S = !this._sendTrafficLimiter.canSend(_, T);
                        if (S && "High" !== g.priority) throw trafficLimited();
                        if (0 === v.length) throw noAvailableUnreliableDataId();
                        for(let g = 0; g < v.length; g++)try {
                            const C = v[g], E = this._dataIds.get(C)[0];
                            if (S && "normal" === E.priority) continue;
                            const I = this._rateLimiters.get(C);
                            var _I_canSend;
                            if ((_I_canSend = I === null || I === void 0 ? void 0 : I.canSend(_)) !== null && _I_canSend !== void 0 ? _I_canSend : !0) {
                                const g = this._processors.get(C);
                                return await (g === null || g === void 0 ? void 0 : g.send(f)), I === null || I === void 0 ? void 0 : I.update(_), void this._sendTrafficLimiter.updateSendBytes(_, T);
                            }
                        } catch (g) {}
                        throw trafficLimited();
                    } catch (g) {
                        this._logger.error(`Failed to send channelId ${S} message: ${getErrorString(g)}`);
                    }
                }
            }, T = this._dataChannelMonitor.createSenderMonitor(S, _, f), I = new DataChannelSenderImpl(S, _, sendFunction, this._participantMappingManager, T, this._logger);
            return I.on("close", ()=>{
                E && this._dataIdMappingManager.deallocate(S), this._randomChannelIdManager.removeChannelId(S), this._senders.delete(S), setTimeout(()=>I.dispose(), 0);
            }), void 0 !== g.participants && I.setParticipants(g.participants), this._senders.set(S, I), this._randomChannelIdManager.addChannelId(S), this._channelVersions.set(S, _), I;
        }
        getDataStreamIdsFromParticipant(g) {
            return this._participantMappingManager.findSourceIds(g.id);
        }
        on(g, f) {
            "dataChannelReceiverCreated" === g && this._receiversManager.on("dataChannelReceiverCreated", f);
        }
        off(g, f) {
            "dataChannelReceiverCreated" === g && this._receiversManager.off("dataChannelReceiverCreated", f);
        }
        dispose() {
            this._state !== cT.Destroyed && (this._state = cT.Destroyed, this._initializedDefer.isPending() && this._initializedDefer.reject(dataChannelHasBeenDisposed()), this._senders.forEach((g)=>{
                g.dispose();
            }), this._receiversManager.dispose(), this._processors.forEach((g)=>{
                g.dispose();
            }), this._sendTrafficLimiter.dispose(), this._participantMappingManager.dispose());
        }
        constructor(g, f, S){
            this._state = cT.Initializing, this._initializedDefer = defer$1();
            const v = getAcsEcsConfig();
            this._logger = f, this._tsCall = g, this._dataChannelTelemtryLogger = S, this._participantMappingManager = new ParticipantMappingManager$1(g), this._dataChannelMonitor = new DataChannelMonitor(S), this._senders = new Map, this._receiversManager = new DataChannelReceiversManager(this._participantMappingManager, this._dataChannelMonitor, f), this._processors = new Map, this._channelVersions = new Map, this._randomChannelIdManager = new RandomChannelIdManager, this._dataIds = new Map, v.dataChannel.dataIdConfigs.forEach((g)=>{
                var _this__dataIds_get;
                const f = (_this__dataIds_get = this._dataIds.get(g.dataId)) !== null && _this__dataIds_get !== void 0 ? _this__dataIds_get : [];
                var _g_bandwidth, _g_priority, _g_category;
                f.push(g.raw ? {
                    dataId: g.dataId,
                    raw: g.raw
                } : {
                    dataId: g.dataId,
                    raw: g.raw,
                    bandwidth: (_g_bandwidth = g.bandwidth) !== null && _g_bandwidth !== void 0 ? _g_bandwidth : 0,
                    priority: (_g_priority = g.priority) !== null && _g_priority !== void 0 ? _g_priority : "normal",
                    category: (_g_category = g.category) !== null && _g_category !== void 0 ? _g_category : "reliable"
                }), this._dataIds.set(g.dataId, f);
            }), this._rateLimiters = new Map, this._sendTrafficLimiter = new SendTrafficLimiter(v.dataChannel.maxSendBandwidth, v.dataChannel.maxBroadcastPacketRate), this._enableBroadcastLimitOnReliableChannel = v.dataChannel.enableBroadcastLimitOnReliableChannel;
        }
    }
    class DataChannelTelemetryLogger {
        sendStatsEvent(g) {
            const f = {
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                ...g
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_datachannel_stats,
                tenant: nf,
                properties: f
            });
        }
        sendCreateSenderEvent(g) {
            const f = {
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                operation: "createSender",
                ...g
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_datachannel,
                tenant: nf,
                properties: f
            });
        }
        sendCreateProcessorEvent(g) {
            const f = {
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                operation: "createProcessor",
                ...g
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_datachannel,
                tenant: nf,
                properties: f
            });
        }
        constructor(g, f){
            this._tsCall = g, this._telemetryLogManager = f;
        }
    }
    class DataChannelCallFeatureImpl extends FirstPartyCallFeature {
        createDataChannelSender(g) {
            const f = generateGuid(), S = getAcsEcsConfig();
            try {
                var _g_participants, _v_participants;
                if (void 0 !== g.bitrateInKbps && "number" != typeof g.bitrateInKbps) throw wrongArgumentType("bitrateInKbps", "number");
                if (void 0 !== g.channelId && "number" != typeof g.channelId) throw wrongArgumentType("channelId", "number");
                if (void 0 !== g.participants && !Array.isArray(g.participants)) throw wrongArgumentType("participants", "CommunicationIdentifier[]");
                if (void 0 !== g.priority && -1 === [
                    "High",
                    "Normal"
                ].indexOf(g.priority)) throw wrongArgumentValue("priority", "High,Normal");
                if (void 0 !== g.reliability && -1 === [
                    "Durable",
                    "Lossy"
                ].indexOf(g.reliability)) throw wrongArgumentValue("reliability", "Durable,Lossy");
                var _g_bitrateInKbps, _g_channelId, _g_participants1, _g_priority, _g_reliability;
                const v = {
                    bitrateInKbps: Math.ceil((_g_bitrateInKbps = g.bitrateInKbps) !== null && _g_bitrateInKbps !== void 0 ? _g_bitrateInKbps : S.dataChannel.defaultBitrate / 1e3),
                    channelId: (_g_channelId = g.channelId) !== null && _g_channelId !== void 0 ? _g_channelId : 0,
                    participants: (_g_participants1 = g.participants) !== null && _g_participants1 !== void 0 ? _g_participants1 : [],
                    priority: (_g_priority = g.priority) !== null && _g_priority !== void 0 ? _g_priority : tT,
                    reliability: (_g_reliability = g.reliability) !== null && _g_reliability !== void 0 ? _g_reliability : iT
                };
                this._logger.info(`createDataChannelSender: ${logSenderOptions(g)}`), this._sendFeatureUsage("createDataChannelSender", uy.attempt), this._dataChannelTelemetryLogger.sendCreateSenderEvent({
                    kindOfEvent: "attempt",
                    correlationId: f,
                    senderOptions: {
                        channelId: g.channelId,
                        bitrateInKbps: g.bitrateInKbps,
                        participantsSize: (_g_participants = g.participants) === null || _g_participants === void 0 ? void 0 : _g_participants.length,
                        priority: g.priority,
                        reliability: g.reliability
                    }
                });
                const _ = this._dataChannelManager.createSender(v, f);
                return this._dataChannelTelemetryLogger.sendCreateSenderEvent({
                    kindOfEvent: "success",
                    correlationId: f,
                    senderOptions: {
                        channelId: _.channelId,
                        bitrateInKbps: v.bitrateInKbps,
                        participantsSize: (_v_participants = v.participants) === null || _v_participants === void 0 ? void 0 : _v_participants.length,
                        priority: v.priority,
                        reliability: v.reliability
                    }
                }), this._logger.info(`The sender is created. channel id=${_.channelId}`), this._sendFeatureUsage("createDataChannelSender", uy.success), _;
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.DATA_CHANNEL.FAILED_TO_CREATE_SENDER,
                    originalError: g
                });
                throw this._logger.info(`Failed to create the sender: ${S.message}`), this._sendFeatureUsage("createDataChannelSender", uy.failure), this._dataChannelTelemetryLogger.sendCreateSenderEvent({
                    kindOfEvent: "failure",
                    correlationId: f,
                    failureReason: S.message,
                    additionalDetails: {
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    }
                }), S;
            }
        }
        async createDataChannelAdapter(g) {
            const f = new DataChannelAdapter(this._tsCall, g);
            return await f.initialize(), f;
        }
        initialize(g, f) {
            this._tsCall = g.tsCall, this._logger = f.createChild("DataChannelCallFeature"), this._telemetryLogManager = g.telemetryLogManager, this._dataChannelTelemetryLogger = new DataChannelTelemetryLogger(this._tsCall, this._telemetryLogManager);
            const S = new DataChannelManager(this._tsCall, this._logger, this._dataChannelTelemetryLogger);
            this._dataChannelManager = S, this._dataChannelManager.initialize().then(()=>{
                this._sendFeatureUsage("initialize", uy.initialize);
            }).catch((g)=>{
                this._logger.error(`initialize:${getErrorString(g)}`);
            });
        }
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "DataChannel";
        }
        dispose() {
            var _this__dataChannelManager;
            this.disposed || ((_this__dataChannelManager = this._dataChannelManager) === null || _this__dataChannelManager === void 0 ? void 0 : _this__dataChannelManager.dispose(), super.dispose());
        }
        getDataStreamIdsFromParticipant(g) {
            return g.tsRemoteParticipant ? this._dataChannelManager.getDataStreamIdsFromParticipant(g.tsRemoteParticipant) : [];
        }
        on(g, f) {
            var _this__dataChannelManager;
            if ("dataChannelReceiverCreated" !== g) throw invalidEventSubscription(g, "subscribe");
            this._sendFeatureUsage(g, uy.subscribe), "dataChannelReceiverCreated" === g && ((_this__dataChannelManager = this._dataChannelManager) === null || _this__dataChannelManager === void 0 ? void 0 : _this__dataChannelManager.on("dataChannelReceiverCreated", f));
        }
        off(g, f) {
            var _this__dataChannelManager;
            if ("dataChannelReceiverCreated" !== g) throw invalidEventSubscription(g, "unsubscribe");
            this._sendFeatureUsage(g, uy.unsubscribe), "dataChannelReceiverCreated" === g && ((_this__dataChannelManager = this._dataChannelManager) === null || _this__dataChannelManager === void 0 ? void 0 : _this__dataChannelManager.off("dataChannelReceiverCreated", f));
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "DataChannel",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g);
        }
    }
    class SpotlightCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "Spotlight";
        }
        initialize(g, f) {
            this._logger = f, this._logger.info(`Spotlight feature enable flag: ${this._isSpotlightFeatureEnabled}`), this._isSpotlightFeatureEnabled ? (this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f, this._callInfo)) : this._logger.warn("Calls to spotlight APIs will perform no action or return default values where applicable");
        }
        async startSpotlight(g) {
            this._isSpotlightFeatureEnabled && this.validateIdentifierParam(g) && await this._impl.startSpotlight(g);
        }
        async stopSpotlight(g) {
            this._isSpotlightFeatureEnabled && this.validateIdentifierParam(g) && await this._impl.stopSpotlight(g);
        }
        async stopAllSpotlight() {
            this._isSpotlightFeatureEnabled && await this._impl.stopAllSpotlight();
        }
        getSpotlightedParticipants() {
            return this._isSpotlightFeatureEnabled ? (this._sendFeatureUsage("getSpotlightedParticipants", uy.getter), this._impl.spotlightedParticipants) : [];
        }
        get maxParticipantsToSpotlight() {
            return this._isSpotlightFeatureEnabled ? (this._sendFeatureUsage("maxSpotlightSupportedState", uy.getter), this._impl.maxSpotlightStateSupported) : 0;
        }
        on(g, f) {
            this._isSpotlightFeatureEnabled && (this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f));
        }
        off(g, f) {
            this._isSpotlightFeatureEnabled && (this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f));
        }
        validateIdentifierParam(g = []) {
            try {
                return g.forEach((g)=>validateIdentifier(g)), !0;
            } catch (g) {
                return !1;
            }
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: this.name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._impl = new SpotlightCallImplOverTsCall(this.eventEmitter), this._isSpotlightFeatureEnabled = getAcsEcsConfig().calling.spotlight.enabled, this._callInfo = g.callInfo;
        }
    }
    class SpotlightCallImplOverTsCall {
        initialize(g, f, S, v, _) {
            this._logger = v.createChild(()=>`SpotlightFeature::Call(id='${g.callId}')`), this._tsCall = g, this._callInfo = _, this._telemetryLogManager = S, this._internalCallAgent = f;
            const C = "initialize";
            this._sendFeatureUsage(C, uy.initialize);
            try {
                let extractMRIs = (g)=>new Map(this.getPublishedState(g).sort(this.typeRankComparator).map((g, f)=>{
                        var _g_publishedState;
                        return [
                            g.id,
                            {
                                spotlightStateId: (_g_publishedState = g.publishedState) === null || _g_publishedState === void 0 ? void 0 : _g_publishedState.stateId,
                                index: f + 1
                            }
                        ];
                    }));
                this._tsCall.on("publishedStatesChanged", async (g)=>{
                    let f = extractMRIs(g), S = [];
                    f.forEach((g, f)=>{
                        this._currentSpotlightStates.has(f) || S.push({
                            identifier: constructIdentifierKindFromMri(f),
                            order: g === null || g === void 0 ? void 0 : g.index
                        });
                    });
                    let v = [];
                    this._currentSpotlightStates.forEach((g, S)=>{
                        f.has(S) || v.push({
                            identifier: constructIdentifierKindFromMri(S)
                        });
                    }), this._currentSpotlightStates = f, (S.length || v.length) && this._eventEmitter.emit("spotlightChanged", {
                        added: S,
                        removed: v
                    });
                }), this._tsCall.publishedStates && (this._currentSpotlightStates = extractMRIs(this._tsCall.publishedStates)), this._sendFeatureUsage(C, uy.success);
            } catch (g) {
                this.handleSpotlightFailure(C, g);
            }
        }
        async startSpotlight(g) {
            const f = "startSpotlight";
            try {
                this._sendFeatureUsage(f, uy.attempt);
                let S = this.getIdentifiersMri(g).filter((g)=>!this._currentSpotlightStates.has(g));
                if (!S.length) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.SPOTLIGHT.ALREADY_SPOTLIGHTED
                });
                this.validateStartSpotlightConditions(S);
                const v = {
                    level: "user",
                    type: "spotlight",
                    content: "{}",
                    participantIds: S
                };
                if (!await this._tsCall.publishState(v, w.generateCauseId())) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.SPOTLIGHT.START_SPOTLIGHT_FAILED
                });
                this._sendFeatureUsage(f, uy.success);
            } catch (g) {
                this.handleSpotlightFailure(f, g);
            }
        }
        async stopSpotlight(g) {
            const f = "stopSpotlight";
            this._tsCall.publishedStates || this._logger.warn(`${f}: no participants is currently Spotlighted`);
            try {
                this._sendFeatureUsage(f, uy.attempt);
                let S = this.getIdentifiersMri(g);
                this.validateStopSpotlightConditions(S);
                const v = this.findStateIdsForParticipantIds(S);
                await this._tsCall.removeState({
                    stateIds: v
                }, w.generateCauseId()), this._sendFeatureUsage(f, uy.success);
            } catch (g) {
                this.handleSpotlightFailure(f, g);
            }
        }
        async stopAllSpotlight() {
            const g = "stopAllSpotlight";
            try {
                this._sendFeatureUsage(g, uy.attempt), this.validateStopSpotlightConditions([]), await this._tsCall.removeStatesForEveryone({
                    type: "spotlight"
                }, w.generateCauseId()), this._sendFeatureUsage(g, uy.success);
            } catch (f) {
                this.handleSpotlightFailure(g, f);
            }
        }
        get spotlightedParticipants() {
            return this._tsCall.publishedStates ? Array.from(this._currentSpotlightStates.keys()).map((g)=>{
                var _this__currentSpotlightStates_get;
                return {
                    identifier: constructIdentifierKindFromMri(g),
                    order: (_this__currentSpotlightStates_get = this._currentSpotlightStates.get(g)) === null || _this__currentSpotlightStates_get === void 0 ? void 0 : _this__currentSpotlightStates_get.index
                };
            }) : [];
        }
        get maxSpotlightStateSupported() {
            return this._maxSpotlightStateSupported;
        }
        findStateIdsForParticipantIds(g) {
            return g.length && this._tsCall.publishedStates ? g.map((g)=>{
                var _this__currentSpotlightStates_get;
                return ((_this__currentSpotlightStates_get = this._currentSpotlightStates.get(g)) === null || _this__currentSpotlightStates_get === void 0 ? void 0 : _this__currentSpotlightStates_get.spotlightStateId) || "";
            }).filter((g)=>g.length) : [];
        }
        getPublishedState(g) {
            return g.typeStates.filter((g)=>"spotlight" === g.type).map((g)=>g.participantStates).flat();
        }
        isUserRoleEligible() {
            const g = this._tsCall.advancedMeetingRole;
            return !!g && !!this._supportedUserRoles.find((f)=>f === g);
        }
        isRoleBasedConversationType() {
            const g = this._tsCall.conversationType;
            return !!g && !!this._meetingTypes.find((f)=>f === g);
        }
        getIdentifiersMri(g) {
            return g && (g === null || g === void 0 ? void 0 : g.length) ? g.map((g)=>getMriFromIdentifier(g)) : [
                this._internalCallAgent.getUserMri()
            ];
        }
        validateStartSpotlightConditions(g) {
            const f = "startSpotlight";
            if (this._callInfo.context === BS.TwoParty) throw this._logger.warn("Spotlight not supported for 1:1 calls"), this._sendFeatureUsage(f, uy.failure), new CallingCommunicationError({
                defaultError: O.FEATURES.SPOTLIGHT.NOT_SUPPORTED_1TO1
            });
            if (this.spotlightedParticipants.length + g.length > this._maxSpotlightStateSupported) throw new CallingCommunicationError({
                defaultError: O.FEATURES.SPOTLIGHT.SPOTLIGHT_LIGHT_MAX_REACHED,
                defaultErrorMessageArgs: [
                    this._maxSpotlightStateSupported
                ]
            });
            if (this.isRoleBasedConversationType() && !this.isUserRoleEligible()) throw new CallingCommunicationError({
                defaultError: O.FEATURES.SPOTLIGHT.UNSUPPORTED_ROLE_TYPE,
                defaultErrorMessageArgs: [
                    "Start",
                    this._tsCall.conversationType
                ]
            });
        }
        validateStopSpotlightConditions(g) {
            if (!(1 === g.length && g[0] === this._internalCallAgent.getUserMri()) && this.isRoleBasedConversationType() && !this.isUserRoleEligible()) throw new CallingCommunicationError({
                defaultError: O.FEATURES.SPOTLIGHT.UNSUPPORTED_ROLE_TYPE,
                defaultErrorMessageArgs: [
                    "Stop",
                    this._tsCall.conversationType
                ]
            });
        }
        handleSpotlightFailure(g, f) {
            throw this._logger.error(JSON.stringify(f)), this._sendFeatureUsage(g, uy.failure, f), f;
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? {
                code: (S === null || S === void 0 ? void 0 : S.code) || x,
                subCode: (S === null || S === void 0 ? void 0 : S.subCode) || 0,
                failureReason: (S === null || S === void 0 ? void 0 : S.message) || "",
                ...extractCommunicationServicesErrorForTelemetry(S)
            } : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "Spotlight",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            this.typeRankComparator = (g, f)=>void 0 === g.publishedState ? -1 : void 0 === f.publishedState ? 1 : g.publishedState.typeRank - f.publishedState.typeRank, this._eventEmitter = g, this._currentSpotlightStates = new Map;
            const f = getAcsEcsConfig().calling.spotlight;
            this._maxSpotlightStateSupported = f.maxSpotlightParticipants, this._supportedUserRoles = f.supportedRoles, this._meetingTypes = f.meetingTypes;
        }
    }
    class CallSurveyFeatureImpl extends FirstPartyCallFeature {
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        get name() {
            return "CallSurvey";
        }
        dispose() {
            super.dispose();
        }
        submitSurvey(g) {
            return this._impl.submitSurvey(g);
        }
        constructor(g){
            super(g), this._impl = new CallSurveyFeatureImplOverTsCall;
        }
    }
    class CallSurveyFeatureImplOverTsCall {
        initialize(g, f, S, v, _) {
            this._tsCall = g, this._call = S, this._telemetryLogManager = v, this._logger = _;
        }
        async submitSurvey(g) {
            const f = +new Date, S = generateGuid();
            this.sendEndOfCallEvent("attempt", S);
            const v = this.validateSurvey(g);
            if (v) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.CALL_SURVEY.INVALID_SURVEY,
                    defaultErrorMessageArgs: [
                        v
                    ]
                });
                throw this.sendEndOfCallEvent("failure", S, f, {
                    failureReason: v,
                    code: N,
                    ...extractCommunicationServicesErrorForTelemetry(g),
                    isExpected: !0
                }), g;
            }
            return new Promise((v, _)=>{
                const C = this.createCallSurveyInternal(g);
                this.registerNotificationEventListener(C, S, f, v, _), this.sendEndOfCallEvent("success", S, f, void 0, C);
            });
        }
        registerNotificationEventListener(g, f, S, v, _) {
            const C = {
                id: f,
                callId: g.callId,
                localParticipantId: g.localParticipantId,
                overallRating: g.overallRating,
                audioRating: g.audioRating,
                videoRating: g.videoRating,
                screenshareRating: g.screenshareRating
            };
            CallSurveyFeatureImplOverTsCall.NOTIFICATION_LISTENER.eventsSent = (g)=>{
                g.find((g)=>{
                    var _g_data, _g_data1;
                    return g.name === dy.acs_calling_survey && ((_g_data = g.data) === null || _g_data === void 0 ? void 0 : _g_data.correlationId) === f && "success" === ((_g_data1 = g.data) === null || _g_data1 === void 0 ? void 0 : _g_data1.kindOfEvent);
                }) && v(C);
            }, CallSurveyFeatureImplOverTsCall.NOTIFICATION_LISTENER.eventsDiscarded = (g, v)=>{
                if (g.find((g)=>{
                    var _g_data, _g_data1;
                    return g.name === dy.acs_calling_survey && ((_g_data = g.data) === null || _g_data === void 0 ? void 0 : _g_data.correlationId) === f && "success" === ((_g_data1 = g.data) === null || _g_data1 === void 0 ? void 0 : _g_data1.kindOfEvent);
                })) {
                    const g = new CallingCommunicationError({
                        defaultError: O.FEATURES.CALL_SURVEY.SUBMIT_TIMEOUT
                    });
                    this.sendEndOfCallEvent("failure", f, S, {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }), _(g);
                }
            };
        }
        sendEndOfCallEvent(g, f, S, v, _) {
            try {
                var _this__tsCall, _this__tsCall1;
                const C = {
                    eventName: dy.acs_calling_survey,
                    callId: (_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.callId,
                    localParticipantId: (_this__tsCall1 = this._tsCall) === null || _this__tsCall1 === void 0 ? void 0 : _this__tsCall1.participantId,
                    correlationId: f,
                    kindOfEvent: g,
                    timestampInfo: {
                        deltaTimeInMs: 0
                    },
                    additionalDetails: v
                };
                if (S) {
                    const g = +new Date;
                    C.timestampInfo.deltaTimeInMs = g - S;
                }
                "success" === g && _ ? (C.overallRating = _.overallRating, C.audioRating = _.audioRating, C.videoRating = _.videoRating, C.screenshareRating = _.screenshareRating, this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_survey,
                    tenant: nf,
                    priority: js.Immediate,
                    properties: C
                }, CallSurveyFeatureImplOverTsCall.NOTIFICATION_LISTENER), getAcsEcsConfig().calling.teamsCallQualityFeedback.enabled && this._call.isCteTeamsCall && this.acsCallSurveyToMediaCallQualityFeedback(_, f)) : this._telemetryLogManager.sendEvent({
                    name: C.eventName,
                    tenant: nf,
                    properties: C
                });
            } catch (g) {
                this._logger.debug("Unable to send call survey telemetry");
            }
        }
        acsCallSurveyToMediaCallQualityFeedback(g, f) {
            var _this__tsCall;
            const S = this.getFiveStarRating(g.overallRating);
            if (void 0 === S) return void this._logger.info("Call survey has no valid overall rating. Skipping media call quality feedback.");
            const v = this.getAllCallIssues(g), _ = {
                acs_correlation_id: f,
                call_mos_score_questionary_id: 105,
                clientType: "ACSWebSDK",
                call_id: g.callId,
                participant_id: g.localParticipantId,
                call_mos_score: S - 1,
                call_mos_score_tracking_reason: "random",
                call_mos_score_problem_tokens: v,
                call_mos_score_never_expires: !1
            };
            void 0 !== ((_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.callMode) && (_.call_mode = this._tsCall.callMode), this._telemetryLogManager.sendEvent({
                name: dy.mdsc_call_quality_feedback,
                tenant: getAcsEcsConfig().calling.teamsCallQualityFeedback.tenantId,
                priority: js.Immediate,
                properties: _
            });
        }
        getAllCallIssues(g) {
            var _g_overallRating_issues, _g_overallRating, _g_audioRating_issues, _g_audioRating, _g_videoRating_issues, _g_videoRating, _g_screenshareRating_issues, _g_screenshareRating;
            const f = [];
            return (_g_overallRating = g.overallRating) === null || _g_overallRating === void 0 ? void 0 : (_g_overallRating_issues = _g_overallRating.issues) === null || _g_overallRating_issues === void 0 ? void 0 : _g_overallRating_issues.forEach((g)=>f.push(CallSurveyFeatureImplOverTsCall.ACS_OVERALL_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[g])), (_g_audioRating = g.audioRating) === null || _g_audioRating === void 0 ? void 0 : (_g_audioRating_issues = _g_audioRating.issues) === null || _g_audioRating_issues === void 0 ? void 0 : _g_audioRating_issues.forEach((g)=>f.push(CallSurveyFeatureImplOverTsCall.ACS_AUDIO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[g])), (_g_videoRating = g.videoRating) === null || _g_videoRating === void 0 ? void 0 : (_g_videoRating_issues = _g_videoRating.issues) === null || _g_videoRating_issues === void 0 ? void 0 : _g_videoRating_issues.forEach((g)=>f.push(CallSurveyFeatureImplOverTsCall.ACS_VIDEO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[g])), (_g_screenshareRating = g.screenshareRating) === null || _g_screenshareRating === void 0 ? void 0 : (_g_screenshareRating_issues = _g_screenshareRating.issues) === null || _g_screenshareRating_issues === void 0 ? void 0 : _g_screenshareRating_issues.forEach((g)=>f.push(CallSurveyFeatureImplOverTsCall.ACS_SCREENSHARE_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE[g])), f.length > 0 ? "checks=" + f.join("%20") : "";
        }
        getFiveStarRating(g) {
            if (g === null || g === void 0 ? void 0 : g.scale) {
                const f = g.score - g.scale.lowerBound + 1, S = g.scale.upperBound - g.scale.lowerBound + 1, v = Math.round(5 * f / S);
                return v < 1 ? 1 : v;
            }
            return g === null || g === void 0 ? void 0 : g.score;
        }
        createCallSurveyInternal(g) {
            var _this__tsCall, _this__tsCall1;
            const f = {
                callId: (_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.callId,
                localParticipantId: (_this__tsCall1 = this._tsCall) === null || _this__tsCall1 === void 0 ? void 0 : _this__tsCall1.participantId
            };
            return g && (f.overallRating = g.overallRating, f.audioRating = g.audioRating, f.videoRating = g.videoRating, f.screenshareRating = g.screenshareRating), f;
        }
        validateSurvey(g) {
            let f = "";
            return f = this.validateOverallRating(g.overallRating), f += this.validateAudioRating(g.audioRating), f += this.validateVideoRating(g.videoRating), f += this.validateScreenshareRating(g.screenshareRating), "" !== f || g.overallRating || g.audioRating || g.videoRating || g.screenshareRating || (f = "At least one survey rating is required."), "" === f && (f = this.validateCallSurveyTypes(g)), f.trim();
        }
        validateOverallRating(g) {
            if (!g) return "";
            let f = "";
            return this.isValidFiveStarRating(g) ? g.scale && !this.isRatingValueMatchesRatingScale(g.score, g.scale) ? f = this.ratingOutOfRangeMessage(CallSurveyFeatureImplOverTsCall.OVERALL_RATING_SCORE, g) : g.scale && !this.isValidQualityThreshold(g.scale) ? f = this.thresholdOutOfRangeMessage("overallRating.scale.lowScoreThreshold", g) : g.scale && !this.isValidRatingScale(g.scale) && (f = this.ratingScaleOutOfRangeMessage("overallRating.scale", g)) : f = this.defaultRatingScaleMessage(CallSurveyFeatureImplOverTsCall.OVERALL_RATING_SCORE), f;
        }
        validateAudioRating(g) {
            if (!g) return "";
            let f = "";
            return this.isValidFiveStarRating(g) ? g.scale && !this.isRatingValueMatchesRatingScale(g.score, g.scale) ? f = this.ratingOutOfRangeMessage(CallSurveyFeatureImplOverTsCall.AUDIO_RATING_SCORE, g) : g.scale && !this.isValidQualityThreshold(g.scale) ? f = this.thresholdOutOfRangeMessage("audioRating.scale.lowScoreThreshold", g) : g.scale && !this.isValidRatingScale(g.scale) && (f = this.ratingScaleOutOfRangeMessage("audioRating.scale", g)) : f = this.defaultRatingScaleMessage(CallSurveyFeatureImplOverTsCall.AUDIO_RATING_SCORE), f;
        }
        validateVideoRating(g) {
            if (!g) return "";
            let f = "";
            return this.isValidFiveStarRating(g) ? g.scale && !this.isRatingValueMatchesRatingScale(g.score, g.scale) ? f = this.ratingOutOfRangeMessage(CallSurveyFeatureImplOverTsCall.VIDEO_RATING_SCORE, g) : g.scale && !this.isValidQualityThreshold(g.scale) ? f = this.thresholdOutOfRangeMessage("videoRating.scale.lowScoreThreshold", g) : g.scale && !this.isValidRatingScale(g.scale) && (f = this.ratingScaleOutOfRangeMessage("videoRating.scale", g)) : f = this.defaultRatingScaleMessage(CallSurveyFeatureImplOverTsCall.VIDEO_RATING_SCORE), f;
        }
        validateScreenshareRating(g) {
            if (!g) return "";
            let f = "";
            return this.isValidFiveStarRating(g) ? g.scale && !this.isRatingValueMatchesRatingScale(g.score, g.scale) ? f = this.ratingOutOfRangeMessage(CallSurveyFeatureImplOverTsCall.SCREEN_SHARE_RATING_SCORE, g) : g.scale && !this.isValidQualityThreshold(g.scale) ? f = this.thresholdOutOfRangeMessage("screenshareRating.scale.lowScoreThreshold", g) : g.scale && !this.isValidRatingScale(g.scale) && (f = this.ratingScaleOutOfRangeMessage("screenshareRating.scale", g)) : f = this.defaultRatingScaleMessage(CallSurveyFeatureImplOverTsCall.SCREEN_SHARE_RATING_SCORE), f;
        }
        validateCallSurveyTypes(g) {
            let f = "";
            return g.overallRating && (f = this.valueShouldBeNumber(CallSurveyFeatureImplOverTsCall.OVERALL_RATING_SCORE, g.overallRating.score), g.overallRating.issues && (this.isArray(g.overallRating.issues) ? g.overallRating.issues.some((g)=>CallSurveyFeatureImplOverTsCall.OVERALL_ISSUES[g] !== g) && (f += "overallRating.issues array should be of type OverallIssue. ") : f += "overallRating.issues should be of type Array<OverallIssue>. "), f += this.ratingScaleShouldNotHaveUnexpectedProperties("overallRating.scale", g.overallRating.scale), f += this.ratingShouldNotHaveUnexpectedProperties("overallRating", g.overallRating)), g.audioRating && (f += this.valueShouldBeNumber(CallSurveyFeatureImplOverTsCall.AUDIO_RATING_SCORE, g.audioRating.score), g.audioRating.issues && (this.isArray(g.audioRating.issues) ? g.audioRating.issues.some((g)=>CallSurveyFeatureImplOverTsCall.AUDIO_ISSUES[g] !== g) && (f += "audioRating.issues array should be of type AudioIssue. ") : f += "audioRating.issues should be of type Array<AudioIssue>. "), f += this.ratingScaleShouldNotHaveUnexpectedProperties("audioRating.scale", g.audioRating.scale), f += this.ratingShouldNotHaveUnexpectedProperties("audioRating", g.audioRating)), g.videoRating && (f += this.valueShouldBeNumber(CallSurveyFeatureImplOverTsCall.VIDEO_RATING_SCORE, g.videoRating.score), g.videoRating.issues && (this.isArray(g.videoRating.issues) ? g.videoRating.issues.some((g)=>CallSurveyFeatureImplOverTsCall.VIDEO_ISSUES[g] !== g) && (f += "videoRating.issues array should be of type VideoIssue. ") : f += "videoRating.issues should be of type Array<VideoIssue>. "), f += this.ratingScaleShouldNotHaveUnexpectedProperties("videoRating.scale", g.videoRating.scale), f += this.ratingShouldNotHaveUnexpectedProperties("videoRating", g.videoRating)), g.screenshareRating && (f += this.valueShouldBeNumber(CallSurveyFeatureImplOverTsCall.SCREEN_SHARE_RATING_SCORE, g.screenshareRating.score), g.screenshareRating.issues && (this.isArray(g.screenshareRating.issues) ? g.screenshareRating.issues.some((g)=>CallSurveyFeatureImplOverTsCall.SCREENSHARE_ISSUES[g] !== g) && (f += "screenshareRating.issues array should be of type ScreenshareIssue. ") : f += "screenshareRating.issues should be of type Array<ScreenshareIssue>. "), f += this.ratingScaleShouldNotHaveUnexpectedProperties("screenshareRating.scale", g.screenshareRating.scale), f += this.ratingShouldNotHaveUnexpectedProperties("screenshareRating", g.screenshareRating)), f;
        }
        isNumber(g) {
            return null !== g && "number" == typeof g;
        }
        isArray(g) {
            return null !== g && Array.isArray(g);
        }
        isValidFiveStarRating(g) {
            return null == g || void 0 !== g.scale || g.score >= 1 && g.score <= 5;
        }
        isRatingValueMatchesRatingScale(g, f) {
            return g >= f.lowerBound && g <= f.upperBound;
        }
        isValidQualityThreshold(g) {
            return g.lowScoreThreshold >= g.lowerBound && g.lowScoreThreshold <= g.upperBound;
        }
        isValidRatingScale(g) {
            return g.lowerBound >= 0 && g.upperBound <= 100;
        }
        valueShouldBeNumber(g, f) {
            return this.isNumber(f) ? "" : `${g} should be of type number. `;
        }
        ratingScaleShouldNotHaveUnexpectedProperties(g, f) {
            let S = "";
            if (!f) return S;
            for(const v in f)void 0 === CallSurveyFeatureImplOverTsCall.RATING_SCALE_KEYS[v] && (S += `${g} should not have ${v}. `);
            return S;
        }
        ratingShouldNotHaveUnexpectedProperties(g, f) {
            let S = "";
            if (!f) return S;
            for(const v in f)void 0 === CallSurveyFeatureImplOverTsCall.CALL_RATING_KEYS[v] && (S += `${g} should not have ${v}. `);
            return S;
        }
        defaultRatingScaleMessage(g) {
            return `In default scale ${g} should be 1 to 5. `;
        }
        ratingOutOfRangeMessage(g, f) {
            var _f_scale, _f_scale1;
            return `${g}: ${f.score} should be between ${(_f_scale = f.scale) === null || _f_scale === void 0 ? void 0 : _f_scale.lowerBound} and ${(_f_scale1 = f.scale) === null || _f_scale1 === void 0 ? void 0 : _f_scale1.upperBound}. `;
        }
        thresholdOutOfRangeMessage(g, f) {
            var _f_scale, _f_scale1, _f_scale2;
            return `${g}: ${(_f_scale = f.scale) === null || _f_scale === void 0 ? void 0 : _f_scale.lowScoreThreshold} should be between ${(_f_scale1 = f.scale) === null || _f_scale1 === void 0 ? void 0 : _f_scale1.lowerBound} and ${(_f_scale2 = f.scale) === null || _f_scale2 === void 0 ? void 0 : _f_scale2.upperBound}. `;
        }
        ratingScaleOutOfRangeMessage(g, f) {
            var _f_scale, _f_scale1;
            return `${g} lowerBound: ${(_f_scale = f.scale) === null || _f_scale === void 0 ? void 0 : _f_scale.lowerBound} and upperBound: ${(_f_scale1 = f.scale) === null || _f_scale1 === void 0 ? void 0 : _f_scale1.upperBound} should be between 0 and 100. `;
        }
    }
    CallSurveyFeatureImplOverTsCall.OVERALL_RATING_SCORE = "overallRating.score", CallSurveyFeatureImplOverTsCall.AUDIO_RATING_SCORE = "audioRating.score", CallSurveyFeatureImplOverTsCall.VIDEO_RATING_SCORE = "videoRating.score", CallSurveyFeatureImplOverTsCall.SCREEN_SHARE_RATING_SCORE = "screenshareRating.score", CallSurveyFeatureImplOverTsCall.NOTIFICATION_LISTENER = {}, CallSurveyFeatureImplOverTsCall.OVERALL_ISSUES = {
        CallCannotInvite: "CallCannotInvite",
        CallCannotJoin: "CallCannotJoin",
        CallEndedUnexpectedly: "CallEndedUnexpectedly",
        HadToRejoin: "HadToRejoin",
        OtherIssues: "OtherIssues"
    }, CallSurveyFeatureImplOverTsCall.AUDIO_ISSUES = {
        AudioInterruption: "AudioInterruption",
        AudioNoise: "AudioNoise",
        AudioStoppedUnexpectedly: "AudioStoppedUnexpectedly",
        DistortedSpeech: "DistortedSpeech",
        Echo: "Echo",
        LowVolume: "LowVolume",
        NoLocalAudio: "NoLocalAudio",
        NoRemoteAudio: "NoRemoteAudio",
        OtherIssues: "OtherIssues"
    }, CallSurveyFeatureImplOverTsCall.VIDEO_ISSUES = {
        AudioVideoOutOfSync: "AudioVideoOutOfSync",
        DarkVideoReceived: "DarkVideoReceived",
        Freezes: "Freezes",
        LowQuality: "LowQuality",
        NoVideoReceived: "NoVideoReceived",
        NoVideoSent: "NoVideoSent",
        OtherIssues: "OtherIssues",
        StoppedUnexpectedly: "StoppedUnexpectedly"
    }, CallSurveyFeatureImplOverTsCall.SCREENSHARE_ISSUES = {
        CannotPresent: "CannotPresent",
        Freezes: "Freezes",
        LargeDelay: "LargeDelay",
        LowQuality: "LowQuality",
        NoContentLocal: "NoContentLocal",
        NoContentRemote: "NoContentRemote",
        OtherIssues: "OtherIssues",
        StoppedUnexpectedly: "StoppedUnexpectedly"
    }, CallSurveyFeatureImplOverTsCall.CALL_RATING_KEYS = {
        score: "score",
        issues: "issues",
        scale: "scale"
    }, CallSurveyFeatureImplOverTsCall.RATING_SCALE_KEYS = {
        lowerBound: "lowerBound",
        upperBound: "upperBound",
        lowScoreThreshold: "lowScoreThreshold"
    }, CallSurveyFeatureImplOverTsCall.ACS_OVERALL_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE = {
        CallCannotInvite: 502,
        CallCannotJoin: 501,
        CallEndedUnexpectedly: 501,
        HadToRejoin: 501,
        OtherIssues: 501
    }, CallSurveyFeatureImplOverTsCall.ACS_AUDIO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE = {
        AudioInterruption: 108,
        AudioNoise: 104,
        AudioStoppedUnexpectedly: 106,
        DistortedSpeech: 107,
        Echo: 103,
        LowVolume: 105,
        NoLocalAudio: 101,
        NoRemoteAudio: 102,
        OtherIssues: 109
    }, CallSurveyFeatureImplOverTsCall.ACS_VIDEO_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE = {
        AudioVideoOutOfSync: 207,
        DarkVideoReceived: 206,
        Freezes: 204,
        LowQuality: 203,
        NoVideoReceived: 201,
        NoVideoSent: 202,
        OtherIssues: 208,
        StoppedUnexpectedly: 205
    }, CallSurveyFeatureImplOverTsCall.ACS_SCREENSHARE_ISSUES_TO_TEAMS_CQF_PROBLEM_TOKEN_CODE = {
        CannotPresent: 402,
        Freezes: 405,
        LargeDelay: 407,
        LowQuality: 404,
        NoContentLocal: 401,
        NoContentRemote: 402,
        OtherIssues: 408,
        StoppedUnexpectedly: 406
    };
    class AudioZonesCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "AudioZones";
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        updateAudioZone(g, f) {
            return this._impl.updateAudioZone(g, f);
        }
        dispose() {
            this._impl.dispose(), super.dispose();
        }
        get meetingGroupDetails() {
            return this._impl.meetingGroupDetails;
        }
        on(g, f) {
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this.eventEmitter.off(g, f);
        }
        constructor(g){
            super(g), this._impl = new AudioZonesImpl(this.eventEmitter, this.name);
        }
    }
    class AudioZonesImpl {
        initialize(g, f, S, v, _) {
            this._logger = _.createChild(()=>`${this._featureName}::Call(id='${g.callId}')`), this._tsCall = g, this.updateMeetingGroupDetails(), this._tsCall.changed(()=>{
                this._logger.log("tsCall changed"), this.updateMeetingGroupDetails();
            });
        }
        updateAudioZone(g, f) {
            const S = generateGuid();
            return this._logger.log(`updateAudioZone toGroup=${g}, fromGroup=${f}, causeId=${S}`), this._tsCall.updateMeetingGroups(S, {
                scope: 4,
                toGroup: g,
                fromGroup: f
            });
        }
        dispose() {
            this._meetingGroupDetails = void 0;
        }
        get meetingGroupDetails() {
            return this._meetingGroupDetails;
        }
        updateMeetingGroupDetails() {
            var _this__tsCall_meetingDetails;
            var _this__tsCall_meetingDetails_meetingGroups;
            const g = (_this__tsCall_meetingDetails_meetingGroups = (_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : _this__tsCall_meetingDetails.meetingGroups) !== null && _this__tsCall_meetingDetails_meetingGroups !== void 0 ? _this__tsCall_meetingDetails_meetingGroups : void 0;
            P.isEqual(g, this._meetingGroupDetails) || (this._meetingGroupDetails = g, this._eventEmitter.emit("meetingGroupDetailsChanged"));
        }
        constructor(g, f){
            this._eventEmitter = g, this._featureName = f;
        }
    }
    class OptimalVideoCountCallFeatureImpl extends FirstPartyCallFeature {
        _sendOVCTelemetryEvent(g) {
            var _this__call, _this__tsCall;
            if (!this._telemetryLogManager) return;
            const f = {
                callId: ((_this__call = this._call) === null || _this__call === void 0 ? void 0 : _this__call.id) || "",
                localParticipantId: ((_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.participantId) || "",
                featureName: "OptimalVideoCount",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    step: g
                }
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_feature_usage,
                tenant: nf,
                properties: f
            });
        }
        get optimalVideoCount() {
            var _this__tsCall;
            return this._sendOVCTelemetryEvent(uy.getter), ((_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.optimalVideoCount) ? this._tsCall.optimalVideoCount : 1;
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f), this._tsCall = g.tsCall, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call;
        }
        on(g, f) {
            if ("optimalVideoCountChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.OPTIMAL_VIDEO_COUNT.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendOVCTelemetryEvent(uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("optimalVideoCountChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.OPTIMAL_VIDEO_COUNT.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._sendOVCTelemetryEvent(uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        constructor(g){
            super(g), this.name = "OptimalVideoCount", this._impl = new OptimalVideoCountCallFeatureImplOverTsCall(this.name, this.eventEmitter, this.optimalVideoCount);
        }
    }
    class OptimalVideoCountCallFeatureImplOverTsCall {
        initialize(g, f, S, v, _) {
            var _this__logger;
            this._tsCall = g, this._logger = _, (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.createChild(()=>{
                var _this__tsCall;
                return `${this._featureName}::Call(id='${(_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : _this__tsCall.callId}')`;
            }), this._tsCall.changed(()=>this.ovcChanged(g));
        }
        ovcChanged(g) {
            (g === null || g === void 0 ? void 0 : g.optimalVideoCount) && g.optimalVideoCount !== this._optimalVideoCount && (this._logger.log(`tsCall optimalVideoCount changed from ${this._optimalVideoCount} to ${g === null || g === void 0 ? void 0 : g.optimalVideoCount}`), this._eventEmitter.emit("optimalVideoCountChanged"));
        }
        constructor(g, f, S){
            this._featureName = g, this._eventEmitter = f, this._optimalVideoCount = S;
        }
    }
    function invalidEventSubscription$1(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.EVENT_SUBSCIBE_UNSUBSCRIBE,
            defaultErrorMessageArgs: [
                f,
                g
            ]
        });
    }
    function unmixedAudioIsNotAvailable() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.UNAVAILABLE
        });
    }
    function getErrorString$1(g) {
        var _g_message;
        return P.isString(g) ? g : (_g_message = g === null || g === void 0 ? void 0 : g.message) !== null && _g_message !== void 0 ? _g_message : "Unknown";
    }
    function rethrowError(g) {
        throw g instanceof CallingCommunicationError ? g : new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.UNKNOWN_ERROR
        });
    }
    function hasPendingOpertion() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.PENDING_OPERATION
        });
    }
    function notSupportP2P() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.UNSUPPORTED_OPERATION
        });
    }
    function unmixedAudioHasBeenEnabled() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.ENABLED
        });
    }
    function unmixedAudioHasBeenDisabled() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.DISABLED
        });
    }
    function unmixedAudioHasBeenDisposed() {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.DISPOSED
        });
    }
    function invalidState(g) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.INVALID_STATE,
            defaultErrorMessageArgs: [
                g
            ]
        });
    }
    function failedToInitialize(g) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.FAILED_TO_INITIALIZE,
            originalError: g
        });
    }
    function failedToEnable(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.FAILED_TO_ENABLE,
            defaultErrorMessageArgs: [
                f.audioContextState || "undefined",
                f.unmixedAudioState || "undefined"
            ],
            originalError: g
        });
    }
    function failedToDisable(g, f) {
        return new CallingCommunicationError({
            defaultError: O.FEATURES.UNMIXED_AUDIO.FAILED_TO_DISABLE,
            defaultErrorMessageArgs: [
                f.audioContextState || "undefined",
                f.unmixedAudioState || "undefined"
            ],
            originalError: g
        });
    }
    class ParticipantMappingManager$2 {
        _updateMapping(g) {
            var _g_endpoints_endpointDetails, _g_endpoints;
            (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.forEach((f)=>{
                var _f_mediaStreams;
                const S = (_f_mediaStreams = f.mediaStreams) === null || _f_mediaStreams === void 0 ? void 0 : _f_mediaStreams.find((g)=>"audio" === g.type);
                if (S) {
                    const v = {
                        sourceId: S.sourceId,
                        participantId: f.participantId,
                        mri: g.id
                    };
                    this._sourceIdMapping.set(S.sourceId, v), this._participantIdMapping.set(f.participantId, v);
                }
            });
        }
        _removeMapping(g) {
            var _g_endpoints_endpointDetails, _g_endpoints;
            (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : (_g_endpoints_endpointDetails = _g_endpoints.endpointDetails) === null || _g_endpoints_endpointDetails === void 0 ? void 0 : _g_endpoints_endpointDetails.forEach((g)=>{
                var _g_mediaStreams;
                const f = (_g_mediaStreams = g.mediaStreams) === null || _g_mediaStreams === void 0 ? void 0 : _g_mediaStreams.find((g)=>"audio" === g.type);
                f && (this._sourceIdMapping.delete(f.sourceId), this._participantIdMapping.delete(g.participantId));
            });
        }
        findParticipantInfoBySourceId(g) {
            return this._sourceIdMapping.get(g);
        }
        findParticipantInfoByParticipantId(g) {
            return this._participantIdMapping.get(g);
        }
        dispose() {
            this._sourceIdMapping.clear(), this._participantIdMapping.clear(), this._listenerHandles.forEach((g)=>g.dispose());
        }
        constructor(g){
            this._tsCall = g, this._sourceIdMapping = new Map, this._participantIdMapping = new Map, this._listenerHandles = [], this._listenerHandles.push(this._tsCall.on("participantAdded", (g)=>{
                this._updateMapping(g);
            })), this._listenerHandles.push(this._tsCall.on("participantUpdated", (g)=>{
                this._updateMapping(g);
            })), this._listenerHandles.push(this._tsCall.on("participantRemoved", (g)=>{
                this._removeMapping(g);
            })), this._tsCall.participants.forEach((g)=>{
                this._updateMapping(g);
            });
        }
    }
    class UnmixedAudioTelemetryLogger {
        sendActionEvent(g) {
            const f = {
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                ...g
            };
            this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_unmixed_audio,
                tenant: nf,
                properties: f
            });
        }
        constructor(g, f){
            this._tsCall = g, this._telemetryLogManager = f;
        }
    }
    class UnmixedAudioActionTelemetryLogger {
        logAttempt() {
            this._unmixedAudioTelemetryLogger.sendActionEvent({
                action: this._action,
                kindOfEvent: "attempt",
                correlationId: this._correlationId
            });
        }
        logSuccess() {
            this._unmixedAudioTelemetryLogger.sendActionEvent({
                action: this._action,
                kindOfEvent: "success",
                correlationId: this._correlationId
            });
        }
        logFailure(g, f) {
            this._unmixedAudioTelemetryLogger.sendActionEvent({
                action: this._action,
                kindOfEvent: "failure",
                correlationId: this._correlationId,
                failureReason: g.message,
                ...f,
                additionalDetails: {
                    ...extractCommunicationServicesErrorForTelemetry(g)
                }
            });
        }
        constructor(g, f){
            this._unmixedAudioTelemetryLogger = g, this._action = f, this._correlationId = generateGuid();
        }
    }
    class StatePromise {
        updateState(g) {
            this._result.isPending() && (g === this._expectedState ? this._result.resolve() : this._result.reject(new Error(`Unexpected active state: ${g}`)));
        }
        get waitState() {
            return this._expectedState;
        }
        async wait() {
            await this._wait;
        }
        cancel() {
            this._result.isPending() && this._result.reject(new Error("Operation cancelled"));
        }
        constructor(g, f){
            this._waitTimeoutInMs = g, this._expectedState = f, this._result = defer(), this._wait = wait(()=>this._result.promise, this._waitTimeoutInMs);
        }
    }
    class UnmixedAudioContext {
        async resume(g = 0) {
            if ("closed" === this._audioContext.state) throw invalidState(this._audioContext.state);
            if ("running" === this._audioContext.state) return;
            const f = new StatePromise(g, !0);
            return this._audioContext.resume().then(()=>{
                f.updateState(!0), this._logger.info("resumed");
            }).catch((g)=>{
                this._logger.info(`Failed to resume: ${getErrorString$1(g)}`), f.updateState(!1);
            }), f.wait();
        }
        async close() {
            "closed" !== this._audioContext.state && await this._audioContext.close().then(()=>{
                this._logger.info("closed");
            }).catch((g)=>{
                this._logger.info(`Failed to close: ${getErrorString$1(g)}`);
            });
        }
        get state() {
            return this._audioContext.state;
        }
        get value() {
            return this._audioContext;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        constructor(g, f){
            this._logger = g.createChild(`AudioContext:${f}`), this._eventEmitter = new Ny.EventEmitter;
            const S = new AudioContext, stateChangeHandler = ()=>{
                this._logger.info(`The AudioContext:${f} state changed to ${S.state}`), this._eventEmitter.emit("stateChanged"), "closed" === S.state && (S.removeEventListener("statechange", stateChangeHandler), this._eventEmitter.removeAllListeners());
            };
            S.addEventListener("statechange", stateChangeHandler), this._audioContext = S;
        }
    }
    function getStateString(g) {
        switch(g){
            case dT.Uninitialized:
                return "Uninitialized";
            case dT.Initializing:
                return "Initializing";
            case dT.Initialized:
                return "Initialized";
            case dT.Destroyed:
                return "Destroyed";
            case dT.Aborted:
                return "Aborted";
        }
    }
    !function(g) {
        g[g.Uninitialized = 0] = "Uninitialized", g[g.Initializing = 1] = "Initializing", g[g.Initialized = 2] = "Initialized", g[g.Destroyed = 3] = "Destroyed", g[g.Aborted = 4] = "Aborted";
    }(dT || (dT = {}));
    class UnmixedAudioManager {
        async initialize() {
            if (this._state !== dT.Uninitialized) throw invalidState(getStateString(this._state));
            this._initializedDefer.isPending() || (this._initializedDefer = defer());
            const g = new UnmixedAudioActionTelemetryLogger(this._unmixedAudioTelemetryLogger, "initialize");
            this._state = dT.Initializing;
            try {
                if (g.logAttempt(), !this._tsCall.getUnmixedAudioProvider) throw unmixedAudioIsNotAvailable();
                var _this__tsUnmixedAudioProvider;
                if (this._tsUnmixedAudioProvider = (_this__tsUnmixedAudioProvider = this._tsUnmixedAudioProvider) !== null && _this__tsUnmixedAudioProvider !== void 0 ? _this__tsUnmixedAudioProvider : await this._tsCall.getUnmixedAudioProvider(), !this._tsUnmixedAudioProvider) throw unmixedAudioIsNotAvailable();
                this._audioContext || (this._audioContext = new UnmixedAudioContext(this._logger, this._audioContextSeq++), this._audioContext.on("stateChanged", ()=>{
                    this._updateActiveState();
                })), 0 === this._listenerHandles.length && (this._listenerHandles.push(this._tsUnmixedAudioProvider.on("onStreamSourcesUpdated", (g)=>{
                    this._state === dT.Initialized ? this._onStreamSourcesUpdatedHandler(g) : this._logger.error(`Cannot attach _onStreamSourcesUpdatedHandler listener - this._state:${this._state}`);
                })), this._listenerHandles.push(this._tsUnmixedAudioProvider.on("onActiveStateChanged", ()=>{
                    this._state === dT.Initialized ? this._updateActiveState() : this._logger.error(`Cannot attach _updateActiveState listener - this._state:${this._state}`);
                }))), g.logSuccess(), this._logger.info(`Initialized with maxStreamSize ${this._maxStreamSize}. The AudioContext state is ${this._getAudioContextState()}. tsUnmixedAudioProvider state is: [active: ${this._tsUnmixedAudioProvider.active} configured: ${this._tsUnmixedAudioProvider.configured}]`), this._state = dT.Initialized, this._initializedDefer.resolve(), this._updateActiveState();
            } catch (f) {
                this._state = dT.Uninitialized;
                const S = getErrorString$1(f);
                this._logger.error(`Failed to initialize: ${S}`);
                const v = failedToInitialize(f);
                g.logFailure(v), this._initializedDefer.reject(v);
            }
            return this._initializedDefer.promise;
        }
        async enableUnmixedAudio() {
            const g = new UnmixedAudioActionTelemetryLogger(this._unmixedAudioTelemetryLogger, "enable");
            try {
                if (![
                    dT.Uninitialized,
                    dT.Initializing,
                    dT.Initialized
                ].includes(this._state)) throw invalidState(getStateString(this._state));
                if (1 === this._tsCall.callType) throw notSupportP2P();
                if (this._pendingOperation) throw hasPendingOpertion();
                if (this.isUnmixedAudioEnabled && (this._skipProviderStateCheck || "active" === this._getUnmixedAudioProviderState()) && "running" === this._getAudioContextState()) throw unmixedAudioHasBeenEnabled();
                this._pendingOperation = !0, g.logAttempt(), this._state === dT.Uninitialized ? await this.initialize() : this._state === dT.Initializing && await this._initializedDefer.promise, void 0 !== this._audioContext && "closed" !== this._getAudioContextState() || (this._cleaupAudioNodes(), this._audioContext = new UnmixedAudioContext(this._logger, this._audioContextSeq++), this._audioContext.on("stateChanged", ()=>{
                    this._updateActiveState();
                }));
                const f = [
                    [
                        "resume AudioContext",
                        "running" === this._getAudioContextState() ? void 0 : this._audioContext.resume(this._operationTimeoutInMs)
                    ],
                    [
                        "enable spatial audio config",
                        this.isUnmixedAudioEnabled ? void 0 : this._enableSpatialAudio(!0)
                    ]
                ];
                await this._runTasks(f), this._pendingOperation = !1, g.logSuccess(), this._logger.info(`UnmixedAudio is enabled. The AudioContext state is ${this._getAudioContextState()}.`), this._updateActiveState();
            } catch (f) {
                const S = this._getAudioContextState(), v = this._getUnmixedAudioProviderState(), _ = getErrorString$1(f);
                this._logger.error(`Failed to enable unmixed audio: ${_}. isEnabled=${this.isUnmixedAudioEnabled}, AudioContext=${S}, UnmixedAudio=${v}`);
                const C = {
                    audioContextState: S,
                    unmixedAudioState: v
                }, E = failedToEnable(f, C);
                !1 === this._pendingOperation && rethrowError(E), g.logFailure(E, C), this._pendingOperation = !1, rethrowError(E);
            }
        }
        async disableUnmixedAudio() {
            const g = new UnmixedAudioActionTelemetryLogger(this._unmixedAudioTelemetryLogger, "disable");
            try {
                if (![
                    dT.Initializing,
                    dT.Initialized
                ].includes(this._state)) throw invalidState(getStateString(this._state));
                if (1 === this._tsCall.callType) throw notSupportP2P();
                if (this._pendingOperation) throw hasPendingOpertion();
                if (!this.isUnmixedAudioEnabled) throw unmixedAudioHasBeenDisabled();
                this._pendingOperation = !0, g.logAttempt(), this._state === dT.Initializing && await this._initializedDefer.promise;
                const f = [
                    [
                        "disable spatial audio config",
                        this._enableSpatialAudio(!1)
                    ]
                ];
                await this._runTasks(f), this._pendingOperation = !1, g.logSuccess(), this._logger.info("UnmixedAudio is disabled");
            } catch (f) {
                const S = this._getAudioContextState(), v = this._getUnmixedAudioProviderState(), _ = getErrorString$1(f);
                this._logger.info(`Failed to disable unmixed audio: ${_}. isEnabled=${this.isUnmixedAudioEnabled}, AudioContext=${S}, UnmixedAudio=${v}`);
                const C = {
                    audioContextState: S,
                    unmixedAudioState: v
                }, E = failedToDisable(f, C);
                !1 === this._pendingOperation && rethrowError(E), g.logFailure(E, C), this._pendingOperation = !1, rethrowError(E);
            }
        }
        get isUnmixedAudioActive() {
            return this._state === dT.Initialized && "active" === this._getUnmixedAudioProviderState() && "running" === this._getAudioContextState();
        }
        get isUnmixedAudioEnabled() {
            var _this__tsUnmixedAudioProvider;
            var _this__tsUnmixedAudioProvider_configured;
            return this._state === dT.Initialized && ((_this__tsUnmixedAudioProvider_configured = (_this__tsUnmixedAudioProvider = this._tsUnmixedAudioProvider) === null || _this__tsUnmixedAudioProvider === void 0 ? void 0 : _this__tsUnmixedAudioProvider.configured) !== null && _this__tsUnmixedAudioProvider_configured !== void 0 ? _this__tsUnmixedAudioProvider_configured : !1);
        }
        getAudioSourceIdsFromParticipantIds(g) {
            return g.map((g)=>{
                var _this__participantManager_findParticipantInfoByParticipantId;
                return (_this__participantManager_findParticipantInfoByParticipantId = this._participantManager.findParticipantInfoByParticipantId(g.participantId)) === null || _this__participantManager_findParticipantInfoByParticipantId === void 0 ? void 0 : _this__participantManager_findParticipantInfoByParticipantId.sourceId;
            }).filter((g)=>void 0 !== g);
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            var _this__audioContext;
            this._state !== dT.Destroyed && (this._state = dT.Destroyed, this._initializedDefer.isPending() && this._initializedDefer.reject(unmixedAudioHasBeenDisposed()), this._listenerHandles.forEach((g)=>g.dispose()), this._cleaupAudioNodes(), this._participantManager.dispose(), (_this__audioContext = this._audioContext) === null || _this__audioContext === void 0 ? void 0 : _this__audioContext.close(), this._eventEmitter.removeAllListeners());
        }
        _getAudioContextState() {
            var _this__audioContext;
            var _this__audioContext_state;
            return (_this__audioContext_state = (_this__audioContext = this._audioContext) === null || _this__audioContext === void 0 ? void 0 : _this__audioContext.state) !== null && _this__audioContext_state !== void 0 ? _this__audioContext_state : "unavailable";
        }
        _getUnmixedAudioProviderState() {
            return this._tsUnmixedAudioProvider ? this._tsUnmixedAudioProvider.active ? "active" : "inactive" : "unavailable";
        }
        _cleaupAudioNodes() {
            this._sourceStreamInfoList.forEach((g, f)=>{
                const S = this._destinationStreamInfoList[f];
                void 0 !== g && void 0 !== S && g.audioNode.disconnect(S.audioNode), this._sourceStreamInfoList[f] = void 0, this._destinationStreamInfoList[f] = void 0;
            }), this._destinationStreamInfoMap.clear();
        }
        _onStreamSourcesUpdatedHandler(g) {
            var _this__audioContext;
            const f = (_this__audioContext = this._audioContext) === null || _this__audioContext === void 0 ? void 0 : _this__audioContext.value;
            if (void 0 === f || "running" !== f.state) return void this._logger.warn(`Dropping onStreamSourcesUpdated event because audioContext.state is ${f === null || f === void 0 ? void 0 : f.state}`);
            const S = [];
            for(let v = 0; v < this._maxStreamSize; v++){
                const _ = v < g.length ? g[v] : 0, C = _ ? this._participantManager.findParticipantInfoBySourceId(_) : void 0;
                let E = this._destinationStreamInfoList[v], T = this._sourceStreamInfoList[v];
                if (void 0 === C) void 0 !== E && void 0 !== T && (T.audioNode.disconnect(E.audioNode), this._destinationStreamInfoList[v] = void 0);
                else {
                    var _this__tsUnmixedAudioProvider;
                    var _this__tsUnmixedAudioProvider_streams_v;
                    const g = (_this__tsUnmixedAudioProvider_streams_v = (_this__tsUnmixedAudioProvider = this._tsUnmixedAudioProvider) === null || _this__tsUnmixedAudioProvider === void 0 ? void 0 : _this__tsUnmixedAudioProvider.streams[v]) !== null && _this__tsUnmixedAudioProvider_streams_v !== void 0 ? _this__tsUnmixedAudioProvider_streams_v : void 0;
                    if (void 0 !== T && T.mediaStream !== g && (void 0 !== E && T.audioNode.disconnect(E.audioNode), T = void 0, this._sourceStreamInfoList[v] = void 0), !g) continue;
                    let _ = !1;
                    void 0 !== T && void 0 !== E && C.participantId !== E.participantId && (T.audioNode.disconnect(E.audioNode), E = void 0, this._destinationStreamInfoList[v] = void 0), void 0 === E && (E = this._destinationStreamInfoMap.get(C.participantId), void 0 === E && (E = {
                        participantId: C.participantId,
                        identifier: constructIdentifierKindFromMri(C.mri),
                        audioNode: f.createMediaStreamDestination()
                    }, this._destinationStreamInfoMap.set(C.participantId, E)), this._destinationStreamInfoList[v] = E, _ = !0), void 0 === T && (T = {
                        mediaStream: g,
                        audioNode: f.createMediaStreamSource(g)
                    }, this._sourceStreamInfoList[v] = T, _ = !0), _ && T.audioNode.connect(E.audioNode), S.push({
                        id: C.sourceId,
                        stream: E.audioNode.stream,
                        participantId: C.participantId,
                        identifier: E.identifier
                    });
                }
            }
            this._eventEmitter.emit("participantSpeaking", {
                speakers: S
            });
        }
        async _enableSpatialAudio(g) {
            await this._tsCall.setAudioMidcallConfigJson({
                enableSpatialAudio: g
            });
        }
        async _runTasks(g) {
            let f;
            if ((await Promise.allSettled(g.map((g)=>g[1]))).forEach((S, v)=>{
                "rejected" === S.status && (this._logger.info(`Failed to ${g[v][0]}: ${getErrorString$1(S.reason)}}`), f = S);
            }), void 0 !== f) throw f.reason;
        }
        _updateActiveState() {
            const g = this.isUnmixedAudioActive;
            g !== this._activeState && (this._activeState = g, this._eventEmitter.emit("activeStateChanged"));
        }
        constructor(g, f, S, v){
            this._state = dT.Uninitialized, this._listenerHandles = [], this._audioContextSeq = 0, this._activeState = !1, this._pendingOperation = !1, this._initializedDefer = defer();
            try {
                this._tsCall = g, this._logger = f.createChild("UnmixedAudioManager"), this._eventEmitter = new CallingEventEmitter(this._logger, {
                    enableLogEmit: !1
                }), this._unmixedAudioTelemetryLogger = S, this._participantManager = new ParticipantMappingManager$2(g), this._destinationStreamInfoMap = new Map, this._destinationStreamInfoList = new Array(v.maxStreamSize), this._sourceStreamInfoList = new Array(v.maxStreamSize), this._maxStreamSize = v.maxStreamSize, this._operationTimeoutInMs = v.operationTimeoutInMs, this._skipProviderStateCheck = v.skipProviderStateCheck;
            } catch (g) {
                throw this._state = dT.Aborted, f.info(`Failed to create UnmixedAudioManager: ${getErrorString$1(g)}`), failedToInitialize(g);
            }
        }
    }
    class UnmixedAudioCallFeatureImpl extends FirstPartyCallFeature {
        initialize(g, f) {
            const S = getAcsEcsConfig().unmixedAudio;
            this._tsCall = g.tsCall, this._logger = f.createChild("UnmixedAudioCallFeature"), this._telemetryLogManager = g.telemetryLogManager;
            const v = new UnmixedAudioTelemetryLogger(this._tsCall, this._telemetryLogManager);
            this._unmixedAudioManager = new UnmixedAudioManager(this._tsCall, this._logger, v, S), this._unmixedAudioManager.initialize().then(()=>{
                this._sendFeatureUsage("initialize", uy.initialize);
            }).catch((g)=>{});
        }
        get name() {
            return this._sendFeatureUsage("name", uy.getter), "UnmixedAudio";
        }
        dispose() {
            this.disposed || (this._unmixedAudioManager.dispose(), super.dispose());
        }
        enableUnmixedAudio() {
            return this._unmixedAudioManager.enableUnmixedAudio();
        }
        disableUnmixedAudio() {
            return this._unmixedAudioManager.disableUnmixedAudio();
        }
        get isUnmixedAudioActive() {
            return this._unmixedAudioManager.isUnmixedAudioActive;
        }
        get isUnmixedAudioEnabled() {
            return this._unmixedAudioManager.isUnmixedAudioEnabled;
        }
        getAudioStreamIdsFromParticipant(g) {
            return this._unmixedAudioManager.getAudioSourceIdsFromParticipantIds(g.endpointDetails);
        }
        on(g, f) {
            if ("participantSpeaking" !== g && "activeStateChanged" !== g) throw invalidEventSubscription$1(g, "subscribe");
            this._sendFeatureUsage(g, uy.subscribe), this._unmixedAudioManager.on(g, f);
        }
        off(g, f) {
            if ("participantSpeaking" !== g && "activeStateChanged" !== g) throw invalidEventSubscription$1(g, "unsubscribe");
            this._sendFeatureUsage(g, uy.unsubscribe), this._unmixedAudioManager.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "UnmixedAudio",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g);
        }
    }
    class TeamsMeetingAudioConferencingCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "TeamsMeetingAudioConferencing";
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f);
        }
        async getTeamsMeetingAudioConferencingDetails() {
            return this._impl.getTeamsMeetingAudioConferencingDetails();
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._impl = new TeamsMeetingConferencingCallFeatureImplOverTsCall;
        }
    }
    class TeamsMeetingConferencingCallFeatureImplOverTsCall {
        initialize(g, f, S, v) {
            this._logger = v.createChild(()=>`teamsMeetingAudioConferencing::Call(id='${g.callId}')`), this._tsCall = g, this._telemetryLogManager = S, this._internalCallAgent = f;
            const _ = "initialize";
            if (this.sendFeatureUsage(_, uy.initialize), !this.isSupportedConversationType()) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.ONLY_AVAILABLE_IN_MEETINGS
                });
                throw this._logger.error(g.message), this.sendFeatureUsage(_, uy.failure, g), g;
            }
            this.sendFeatureUsage(_, uy.success);
        }
        getTeamsMeetingAudioConferencingDetails() {
            const g = "getTeamsMeetingAudioConferencingDetails";
            if (this.sendFeatureUsage(g, uy.attempt), !this._isEnabled) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.DISABLED
                });
                return this._logger.error(f.message), this.sendFeatureUsage(g, uy.failure, f), Promise.reject(f);
            }
            if (!this.isSupportedConversationType()) {
                const f = new CallingCommunicationError({
                    defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.ONLY_AVAILABLE_IN_MEETINGS
                });
                return this._logger.error(f.message), this.sendFeatureUsage(g, uy.failure, f), Promise.reject(f);
            }
            let f;
            if (3 !== this._tsCall.state) return f = new CallingCommunicationError({
                defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.UNAVAILABLE_BEFORE_JOINING
            }), 10 === this._tsCall.state && (f = new CallingCommunicationError({
                defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.UNVAILABLE_IN_LOBBY
            })), this.sendFeatureUsage(g, uy.failure, f), this._logger.error(f.message), Promise.reject(f);
            let S = {
                phoneConferenceId: "",
                phoneNumbers: []
            };
            try {
                var _this__tsCall_meetingDetails_pstnDetails_acpMcuInfo, _this__tsCall_meetingDetails_pstnDetails, _this__tsCall_meetingDetails, _this__tsCall, _this__tsCall_meetingDetails_pstnDetails1, _this__tsCall_meetingDetails1, _this__tsCall1;
                const f = (_this__tsCall = this._tsCall) === null || _this__tsCall === void 0 ? void 0 : (_this__tsCall_meetingDetails = _this__tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_pstnDetails = _this__tsCall_meetingDetails.pstnDetails) === null || _this__tsCall_meetingDetails_pstnDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_pstnDetails_acpMcuInfo = _this__tsCall_meetingDetails_pstnDetails.acpMcuInfo) === null || _this__tsCall_meetingDetails_pstnDetails_acpMcuInfo === void 0 ? void 0 : _this__tsCall_meetingDetails_pstnDetails_acpMcuInfo.settings, v = (_this__tsCall1 = this._tsCall) === null || _this__tsCall1 === void 0 ? void 0 : (_this__tsCall_meetingDetails1 = _this__tsCall1.meetingDetails) === null || _this__tsCall_meetingDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_pstnDetails1 = _this__tsCall_meetingDetails1.pstnDetails) === null || _this__tsCall_meetingDetails_pstnDetails1 === void 0 ? void 0 : _this__tsCall_meetingDetails_pstnDetails1.meetingInvitePhoneNumbers;
                if (f || v) {
                    const g = (f === null || f === void 0 ? void 0 : f.participantPasscode) || "", _ = (v === null || v === void 0 ? void 0 : v.flatMap((g)=>{
                        const getFormattedPhoneNumber = ()=>{
                            const f = g.isTollFree ? void 0 : constructIdentifierKindFromMri(jf + g.number), S = g.isTollFree ? constructIdentifierKindFromMri(jf + g.number) : void 0;
                            return {
                                cityName: g === null || g === void 0 ? void 0 : g.cityName,
                                countryName: g === null || g === void 0 ? void 0 : g.countryName,
                                tollPhoneNumber: f,
                                tollFreePhoneNumber: S
                            };
                        };
                        return g.number ? getFormattedPhoneNumber() : [];
                    })) || [];
                    if (null === _ || 0 === _.length) {
                        const g = {
                            cityName: void 0,
                            countryName: void 0,
                            tollPhoneNumber: (f === null || f === void 0 ? void 0 : f.tollNumber) && constructIdentifierKindFromMri(jf + (f === null || f === void 0 ? void 0 : f.tollNumber)),
                            tollFreePhoneNumber: (f === null || f === void 0 ? void 0 : f.tollFreeNumber) && constructIdentifierKindFromMri(jf + (f === null || f === void 0 ? void 0 : f.tollFreeNumber))
                        };
                        _.push(g);
                    }
                    S = {
                        phoneConferenceId: g,
                        phoneNumbers: _
                    }, this._logger.info("Teams meeting audio conferencing details was retrieved successfully");
                }
                return this.sendFeatureUsage(g, uy.success), Promise.resolve(S);
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.TEAMS_MEETING_AUDIO_CONFERENCING.GET_DETAILS_FAILED,
                    originalError: f
                });
                throw this.sendFeatureUsage(g, uy.failure, S), S;
            }
        }
        isSupportedConversationType() {
            const g = this._tsCall.conversationType;
            let f = this._supportedConversationTypes.find((f)=>f === g);
            return this._logger.info(`TeamsMeetingAudioConferencingDetails::ConversationType = \n            ${g}. ConversationType is supported = ${f}`), f;
        }
        sendFeatureUsage(g, f, S) {
            let v = S ? {
                code: (S === null || S === void 0 ? void 0 : S.code) || x,
                subCode: (S === null || S === void 0 ? void 0 : S.subCode) || 0,
                failureReason: (S === null || S === void 0 ? void 0 : S.message) || "",
                ...extractCommunicationServicesErrorForTelemetry(S)
            } : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "TeamsMeetingAudioConferencing",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(){
            this._isEnabled = getAcsEcsConfig().calling.teamsMeetingAudioConferencing.enabled, this._supportedConversationTypes = getAcsEcsConfig().calling.teamsMeetingAudioConferencing.supportedConversationTypes;
        }
    }
    var uT, hT = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.TraceLevel = void 0, function(g) {
            g[g.Error = 10] = "Error", g[g.Warning = 15] = "Warning", g[g.Info = 50] = "Info";
        }(f.TraceLevel || (f.TraceLevel = {}));
    }), gT = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.MessageTrackingOption = f.ConnectionState = f.ServiceGeneratedClientIdName = f.SystemCommandsStateName = f.ConfigurationName = f.SystemSessionStateName = f.StateSubscriptionsName = void 0, f.StateSubscriptionsName = "ConfigStateSubscriptions", f.SystemSessionStateName = "systemSessionState", f.ConfigurationName = "config", f.SystemCommandsStateName = "systemCommands", f.ServiceGeneratedClientIdName = "serviceGeneratedClientId", function(g) {
            g[g.Disconnected = 0] = "Disconnected", g[g.Connected = 1] = "Connected", g[g.Connecting = 2] = "Connecting";
        }(f.ConnectionState || (f.ConnectionState = {})), function(g) {
            g[g.All = 0] = "All", g[g.Last = 1] = "Last", g[g.None = 2] = "None";
        }(f.MessageTrackingOption || (f.MessageTrackingOption = {}));
    }), pT = function bind(g, f) {
        return function wrap() {
            return g.apply(f, arguments);
        };
    }, mT = Object.prototype.toString, fT = (uT = Object.create(null), function(g) {
        var f = mT.call(g);
        return uT[f] || (uT[f] = f.slice(8, -1).toLowerCase());
    });
    function kindOfTest(g) {
        return g = g.toLowerCase(), function isKindOf(f) {
            return fT(f) === g;
        };
    }
    function isArray$2(g) {
        return Array.isArray(g);
    }
    function isUndefined$1(g) {
        return void 0 === g;
    }
    function isBuffer(g) {
        return null !== g && !isUndefined$1(g) && null !== g.constructor && !isUndefined$1(g.constructor) && "function" == typeof g.constructor.isBuffer && g.constructor.isBuffer(g);
    }
    var ST = kindOfTest("ArrayBuffer");
    function isArrayBufferView(g) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(g) : g && g.buffer && ST(g.buffer);
    }
    function isString$1(g) {
        return "string" == typeof g;
    }
    function isNumber$1(g) {
        return "number" == typeof g;
    }
    function isObject$1(g) {
        return null !== g && "object" == typeof g;
    }
    function isPlainObject$1(g) {
        if ("object" !== fT(g)) return !1;
        var f = Object.getPrototypeOf(g);
        return null === f || f === Object.prototype;
    }
    function isEmptyObject(g) {
        return g && 0 === Object.keys(g).length && Object.getPrototypeOf(g) === Object.prototype;
    }
    var vT = kindOfTest("Date"), _T = kindOfTest("File"), CT = kindOfTest("Blob"), yT = kindOfTest("FileList");
    function isFunction$1(g) {
        return "[object Function]" === mT.call(g);
    }
    function isStream(g) {
        return isObject$1(g) && isFunction$1(g.pipe);
    }
    function isFormData(g) {
        var f = "[object FormData]";
        return g && ("function" == typeof FormData && g instanceof FormData || mT.call(g) === f || isFunction$1(g.toString) && g.toString() === f);
    }
    var ET = kindOfTest("URLSearchParams");
    function trim(g) {
        return g.trim ? g.trim() : g.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
    function isStandardBrowserEnv() {
        var g;
        return ("undefined" == typeof navigator || "ReactNative" !== (g = navigator.product) && "NativeScript" !== g && "NS" !== g) && "undefined" != typeof window && "undefined" != typeof document;
    }
    function forEach(g, f) {
        if (null != g) {
            if ("object" != typeof g && (g = [
                g
            ]), isArray$2(g)) for(var S = 0, v = g.length; S < v; S++)f.call(null, g[S], S, g);
            else for(var _ in g)Object.prototype.hasOwnProperty.call(g, _) && f.call(null, g[_], _, g);
        }
    }
    function merge() {
        var g = {};
        function assignValue(f, S) {
            isPlainObject$1(g[S]) && isPlainObject$1(f) ? g[S] = merge(g[S], f) : isPlainObject$1(f) ? g[S] = merge({}, f) : isArray$2(f) ? g[S] = f.slice() : g[S] = f;
        }
        for(var f = 0, S = arguments.length; f < S; f++)forEach(arguments[f], assignValue);
        return g;
    }
    function extend$1(g, f, S) {
        return forEach(f, function assignValue(f, v) {
            g[v] = S && "function" == typeof f ? pT(f, S) : f;
        }), g;
    }
    function stripBOM(g) {
        return 65279 === g.charCodeAt(0) && (g = g.slice(1)), g;
    }
    function inherits(g, f, S, v) {
        g.prototype = Object.create(f.prototype, v), g.prototype.constructor = g, S && Object.assign(g.prototype, S);
    }
    function toFlatObject(g, f, S, v) {
        var _, C, E, T = {};
        if (f = f || {}, null == g) return f;
        do {
            for(C = (_ = Object.getOwnPropertyNames(g)).length; C-- > 0;)E = _[C], v && !v(E, g, f) || T[E] || (f[E] = g[E], T[E] = !0);
            g = !1 !== S && Object.getPrototypeOf(g);
        }while (g && (!S || S(g, f)) && g !== Object.prototype);
        return f;
    }
    function endsWith(g, f, S) {
        g = String(g), (void 0 === S || S > g.length) && (S = g.length), S -= f.length;
        var v = g.indexOf(f, S);
        return -1 !== v && v === S;
    }
    function toArray(g) {
        if (!g) return null;
        if (isArray$2(g)) return g;
        var f = g.length;
        if (!isNumber$1(f)) return null;
        for(var S = new Array(f); f-- > 0;)S[f] = g[f];
        return S;
    }
    var TT, IT = (TT = "undefined" != typeof Uint8Array && Object.getPrototypeOf(Uint8Array), function(g) {
        return TT && g instanceof TT;
    });
    function forEachEntry(g, f) {
        for(var S, v = (g && g[Symbol.iterator]).call(g); (S = v.next()) && !S.done;){
            var _ = S.value;
            f.call(g, _[0], _[1]);
        }
    }
    function matchAll(g, f) {
        for(var S, v = []; null !== (S = g.exec(f));)v.push(S);
        return v;
    }
    var bT = kindOfTest("HTMLFormElement"), AT = function resolver(g) {
        return function(f, S) {
            return g.call(f, S);
        };
    }(Object.prototype.hasOwnProperty), RT = {
        isArray: isArray$2,
        isArrayBuffer: ST,
        isBuffer: isBuffer,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString$1,
        isNumber: isNumber$1,
        isObject: isObject$1,
        isPlainObject: isPlainObject$1,
        isEmptyObject: isEmptyObject,
        isUndefined: isUndefined$1,
        isDate: vT,
        isFile: _T,
        isBlob: CT,
        isFunction: isFunction$1,
        isStream: isStream,
        isURLSearchParams: ET,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach,
        merge: merge,
        extend: extend$1,
        trim: trim,
        stripBOM: stripBOM,
        inherits: inherits,
        toFlatObject: toFlatObject,
        kindOf: fT,
        kindOfTest: kindOfTest,
        endsWith: endsWith,
        toArray: toArray,
        isTypedArray: IT,
        isFileList: yT,
        forEachEntry: forEachEntry,
        matchAll: matchAll,
        isHTMLForm: bT,
        hasOwnProperty: AT
    };
    function AxiosError(g, f, S, v, _) {
        Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (new Error).stack, this.message = g, this.name = "AxiosError", f && (this.code = f), S && (this.config = S), v && (this.request = v), _ && (this.response = _);
    }
    RT.inherits(AxiosError, Error, {
        toJSON: function toJSON() {
            return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
                status: this.response && this.response.status ? this.response.status : null
            };
        }
    });
    var PT = AxiosError.prototype, wT = {};
    [
        "ERR_BAD_OPTION_VALUE",
        "ERR_BAD_OPTION",
        "ECONNABORTED",
        "ETIMEDOUT",
        "ERR_NETWORK",
        "ERR_FR_TOO_MANY_REDIRECTS",
        "ERR_DEPRECATED",
        "ERR_BAD_RESPONSE",
        "ERR_BAD_REQUEST",
        "ERR_CANCELED",
        "ERR_NOT_SUPPORT",
        "ERR_INVALID_URL"
    ].forEach(function(g) {
        wT[g] = {
            value: g
        };
    }), Object.defineProperties(AxiosError, wT), Object.defineProperty(PT, "isAxiosError", {
        value: !0
    }), AxiosError.from = function(g, f, S, v, _, C) {
        var E = Object.create(PT);
        return RT.toFlatObject(g, E, function filter(g) {
            return g !== Error.prototype;
        }), AxiosError.call(E, g.message, f, S, v, _), E.cause = g, E.name = g.name, C && Object.assign(E, C), E;
    };
    var MT = AxiosError, OT = "object" == typeof self ? self.FormData : window.FormData;
    function isVisitable(g) {
        return RT.isPlainObject(g) || RT.isArray(g);
    }
    function removeBrackets(g) {
        return RT.endsWith(g, "[]") ? g.slice(0, -2) : g;
    }
    function renderKey(g, f, S) {
        return g ? g.concat(f).map(function each(g, f) {
            return g = removeBrackets(g), !S && f ? "[" + g + "]" : g;
        }).join(S ? "." : "") : f;
    }
    function isFlatArray(g) {
        return RT.isArray(g) && !g.some(isVisitable);
    }
    var DT = RT.toFlatObject(RT, {}, null, function filter(g) {
        return /^is[A-Z]/.test(g);
    });
    function isSpecCompliant(g) {
        return g && RT.isFunction(g.append) && "FormData" === g[Symbol.toStringTag] && g[Symbol.iterator];
    }
    function toFormData(g, f, S) {
        if (!RT.isObject(g)) throw new TypeError("target must be an object");
        f = f || new (OT || FormData);
        var v = (S = RT.toFlatObject(S, {
            metaTokens: !0,
            dots: !1,
            indexes: !1
        }, !1, function defined(g, f) {
            return !RT.isUndefined(f[g]);
        })).metaTokens, _ = S.visitor || defaultVisitor, C = S.dots, E = S.indexes, T = (S.Blob || "undefined" != typeof Blob && Blob) && isSpecCompliant(f);
        if (!RT.isFunction(_)) throw new TypeError("visitor must be a function");
        function convertValue(g) {
            if (null === g) return "";
            if (RT.isDate(g)) return g.toISOString();
            if (!T && RT.isBlob(g)) throw new MT("Blob is not supported. Use a Buffer instead.");
            return RT.isArrayBuffer(g) || RT.isTypedArray(g) ? T && "function" == typeof Blob ? new Blob([
                g
            ]) : $cf5b5da7977a3fc4$require$Buffer.from(g) : g;
        }
        function defaultVisitor(g, S, _) {
            var T = g;
            if (g && !_ && "object" == typeof g) {
                if (RT.endsWith(S, "{}")) S = v ? S : S.slice(0, -2), g = JSON.stringify(g);
                else if (RT.isArray(g) && isFlatArray(g) || RT.isFileList(g) || RT.endsWith(S, "[]") && (T = RT.toArray(g))) return S = removeBrackets(S), T.forEach(function each(g, v) {
                    !RT.isUndefined(g) && f.append(!0 === E ? renderKey([
                        S
                    ], v, C) : null === E ? S : S + "[]", convertValue(g));
                }), !1;
            }
            return !!isVisitable(g) || (f.append(renderKey(_, S, C), convertValue(g)), !1);
        }
        var I = [], b = Object.assign(DT, {
            defaultVisitor: defaultVisitor,
            convertValue: convertValue,
            isVisitable: isVisitable
        });
        function build(g, S) {
            if (!RT.isUndefined(g)) {
                if (-1 !== I.indexOf(g)) throw Error("Circular reference detected in " + S.join("."));
                I.push(g), RT.forEach(g, function each(g, v) {
                    !0 === (!RT.isUndefined(g) && _.call(f, g, RT.isString(v) ? v.trim() : v, S, b)) && build(g, S ? S.concat(v) : [
                        v
                    ]);
                }), I.pop();
            }
        }
        if (!RT.isObject(g)) throw new TypeError("data must be an object");
        return build(g), f;
    }
    var NT = toFormData;
    function encode(g) {
        var f = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
        };
        return encodeURIComponent(g).replace(/[!'\(\)~]|%20|%00/g, function replacer(g) {
            return f[g];
        });
    }
    function AxiosURLSearchParams(g, f) {
        this._pairs = [], g && NT(g, this, f);
    }
    var kT = AxiosURLSearchParams.prototype;
    kT.append = function append(g, f) {
        this._pairs.push([
            g,
            f
        ]);
    }, kT.toString = function toString(g) {
        var f = g ? function(f) {
            return g.call(this, f, encode);
        } : encode;
        return this._pairs.map(function each(g) {
            return f(g[0]) + "=" + f(g[1]);
        }, "").join("&");
    };
    var LT = AxiosURLSearchParams;
    function encode$1(g) {
        return encodeURIComponent(g).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    var FT = function buildURL(g, f, S) {
        if (!f) return g;
        var v = g.indexOf("#");
        -1 !== v && (g = g.slice(0, v));
        var _, C = S && S.encode || encode$1, E = S && S.serialize;
        return (_ = E ? E(f, S) : RT.isURLSearchParams(f) ? f.toString() : new LT(f, S).toString(C)) && (g += (-1 === g.indexOf("?") ? "?" : "&") + _), g;
    };
    function InterceptorManager() {
        this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(g, f, S) {
        return this.handlers.push({
            fulfilled: g,
            rejected: f,
            synchronous: !!S && S.synchronous,
            runWhen: S ? S.runWhen : null
        }), this.handlers.length - 1;
    }, InterceptorManager.prototype.eject = function eject(g) {
        this.handlers[g] && (this.handlers[g] = null);
    }, InterceptorManager.prototype.clear = function clear() {
        this.handlers && (this.handlers = []);
    }, InterceptorManager.prototype.forEach = function forEach(g) {
        RT.forEach(this.handlers, function forEachHandler(f) {
            null !== f && g(f);
        });
    };
    var xT = InterceptorManager, UT = function normalizeHeaderName(g, f) {
        RT.forEach(g, function processHeader(S, v) {
            v !== f && v.toUpperCase() === f.toUpperCase() && (g[f] = S, delete g[v]);
        });
    }, VT = {
        silentJSONParsing: !0,
        forcedJSONParsing: !0,
        clarifyTimeoutError: !1
    }, BT = {
        isBrowser: !0,
        classes: {
            URLSearchParams: "undefined" != typeof URLSearchParams ? URLSearchParams : LT,
            FormData: FormData,
            Blob: Blob
        },
        protocols: [
            "http",
            "https",
            "file",
            "blob",
            "url",
            "data"
        ]
    }, HT = function toURLEncodedForm(g, f) {
        return NT(g, new BT.classes.URLSearchParams, Object.assign({
            visitor: function(g, f, S, v) {
                return v.defaultVisitor.apply(this, arguments);
            }
        }, f));
    };
    function parsePropPath(g) {
        return RT.matchAll(/\w+|\[(\w*)]/g, g).map(function(g) {
            return "[]" === g[0] ? "" : g[1] || g[0];
        });
    }
    function arrayToObject(g) {
        var f, S, v = {}, _ = Object.keys(g), C = _.length;
        for(f = 0; f < C; f++)v[S = _[f]] = g[S];
        return v;
    }
    function formDataToJSON(g) {
        function buildPath(g, f, S, v) {
            var _ = g[v++], C = Number.isFinite(+_), E = v >= g.length;
            return _ = !_ && RT.isArray(S) ? S.length : _, E ? (RT.hasOwnProperty(S, _) ? S[_] = [
                S[_],
                f
            ] : S[_] = f, !C) : (S[_] && RT.isObject(S[_]) || (S[_] = []), buildPath(g, f, S[_], v) && RT.isArray(S[_]) && (S[_] = arrayToObject(S[_])), !C);
        }
        if (RT.isFormData(g) && RT.isFunction(g.entries)) {
            var f = {};
            return RT.forEachEntry(g, function(g, S) {
                buildPath(parsePropPath(g), S, f, 0);
            }), f;
        }
        return null;
    }
    var $T = formDataToJSON, jT = function settle(g, f, S) {
        var v = S.config.validateStatus;
        S.status && v && !v(S.status) ? f(new MT("Request failed with status code " + S.status, [
            MT.ERR_BAD_REQUEST,
            MT.ERR_BAD_RESPONSE
        ][Math.floor(S.status / 100) - 4], S.config, S.request, S)) : g(S);
    }, GT = RT.isStandardBrowserEnv() ? function standardBrowserEnv() {
        return {
            write: function write(g, f, S, v, _, C) {
                var E = [];
                E.push(g + "=" + encodeURIComponent(f)), RT.isNumber(S) && E.push("expires=" + new Date(S).toGMTString()), RT.isString(v) && E.push("path=" + v), RT.isString(_) && E.push("domain=" + _), !0 === C && E.push("secure"), document.cookie = E.join("; ");
            },
            read: function read(g) {
                var f = document.cookie.match(new RegExp("(^|;\\s*)(" + g + ")=([^;]*)"));
                return f ? decodeURIComponent(f[3]) : null;
            },
            remove: function remove(g) {
                this.write(g, "", Date.now() - 864e5);
            }
        };
    }() : {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    }, qT = function isAbsoluteURL(g) {
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(g);
    }, WT = function combineURLs(g, f) {
        return f ? g.replace(/\/+$/, "") + "/" + f.replace(/^\/+/, "") : g;
    }, zT = function buildFullPath(g, f) {
        return g && !qT(f) ? WT(g, f) : f;
    }, KT = [
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent"
    ], JT = function parseHeaders(g) {
        var f, S, v, _ = {};
        return g ? (RT.forEach(g.split("\n"), function parser(g) {
            if (v = g.indexOf(":"), f = RT.trim(g.slice(0, v)).toLowerCase(), S = RT.trim(g.slice(v + 1)), f) {
                if (_[f] && KT.indexOf(f) >= 0) return;
                _[f] = "set-cookie" === f ? (_[f] ? _[f] : []).concat([
                    S
                ]) : _[f] ? _[f] + ", " + S : S;
            }
        }), _) : _;
    }, YT = RT.isStandardBrowserEnv() ? function standardBrowserEnv() {
        var g, f = /(msie|trident)/i.test(navigator.userAgent), S = document.createElement("a");
        function resolveURL(g) {
            var v = g;
            return f && (S.setAttribute("href", v), v = S.href), S.setAttribute("href", v), {
                href: S.href,
                protocol: S.protocol ? S.protocol.replace(/:$/, "") : "",
                host: S.host,
                search: S.search ? S.search.replace(/^\?/, "") : "",
                hash: S.hash ? S.hash.replace(/^#/, "") : "",
                hostname: S.hostname,
                port: S.port,
                pathname: "/" === S.pathname.charAt(0) ? S.pathname : "/" + S.pathname
            };
        }
        return g = resolveURL(window.location.href), function isURLSameOrigin(f) {
            var S = RT.isString(f) ? resolveURL(f) : f;
            return S.protocol === g.protocol && S.host === g.host;
        };
    }() : function isURLSameOrigin() {
        return !0;
    };
    function CanceledError(g, f, S) {
        MT.call(this, null == g ? "canceled" : g, MT.ERR_CANCELED, f, S), this.name = "CanceledError";
    }
    RT.inherits(CanceledError, MT, {
        __CANCEL__: !0
    });
    var QT = CanceledError, XT = function parseProtocol(g) {
        var f = /^([-+\w]{1,25})(:?\/\/|:)/.exec(g);
        return f && f[1] || "";
    }, ZT = function xhrAdapter(g) {
        return new Promise(function dispatchXhrRequest(f, S) {
            var v, _ = g.data, C = g.headers, E = g.responseType, T = g.withXSRFToken;
            function done() {
                g.cancelToken && g.cancelToken.unsubscribe(v), g.signal && g.signal.removeEventListener("abort", v);
            }
            RT.isFormData(_) && RT.isStandardBrowserEnv() && delete C["Content-Type"];
            var I = new XMLHttpRequest;
            if (g.auth) {
                var b = g.auth.username || "", A = g.auth.password ? unescape(encodeURIComponent(g.auth.password)) : "";
                C.Authorization = "Basic " + btoa(b + ":" + A);
            }
            var R = zT(g.baseURL, g.url);
            function onloadend() {
                if (I) {
                    var v = "getAllResponseHeaders" in I ? JT(I.getAllResponseHeaders()) : null, _ = {
                        data: E && "text" !== E && "json" !== E ? I.response : I.responseText,
                        status: I.status,
                        statusText: I.statusText,
                        headers: v,
                        config: g,
                        request: I
                    };
                    jT(function _resolve(g) {
                        f(g), done();
                    }, function _reject(g) {
                        S(g), done();
                    }, _), I = null;
                }
            }
            if (I.open(g.method.toUpperCase(), FT(R, g.params, g.paramsSerializer), !0), I.timeout = g.timeout, "onloadend" in I ? I.onloadend = onloadend : I.onreadystatechange = function handleLoad() {
                I && 4 === I.readyState && (0 !== I.status || I.responseURL && 0 === I.responseURL.indexOf("file:")) && setTimeout(onloadend);
            }, I.onabort = function handleAbort() {
                I && (S(new MT("Request aborted", MT.ECONNABORTED, g, I)), I = null);
            }, I.onerror = function handleError() {
                S(new MT("Network Error", MT.ERR_NETWORK, g, I)), I = null;
            }, I.ontimeout = function handleTimeout() {
                var f = g.timeout ? "timeout of " + g.timeout + "ms exceeded" : "timeout exceeded", v = g.transitional || VT;
                g.timeoutErrorMessage && (f = g.timeoutErrorMessage), S(new MT(f, v.clarifyTimeoutError ? MT.ETIMEDOUT : MT.ECONNABORTED, g, I)), I = null;
            }, RT.isStandardBrowserEnv() && (T && RT.isFunction(T) && (T = T(g)), T || !1 !== T && YT(R))) {
                var P = g.xsrfHeaderName && g.xsrfCookieName && GT.read(g.xsrfCookieName);
                P && (C[g.xsrfHeaderName] = P);
            }
            "setRequestHeader" in I && RT.forEach(C, function setRequestHeader(g, f) {
                void 0 === _ && "content-type" === f.toLowerCase() ? delete C[f] : I.setRequestHeader(f, g);
            }), RT.isUndefined(g.withCredentials) || (I.withCredentials = !!g.withCredentials), E && "json" !== E && (I.responseType = g.responseType), "function" == typeof g.onDownloadProgress && I.addEventListener("progress", g.onDownloadProgress), "function" == typeof g.onUploadProgress && I.upload && I.upload.addEventListener("progress", g.onUploadProgress), (g.cancelToken || g.signal) && (v = function(f) {
                I && (S(!f || f.type ? new QT(null, g, I) : f), I.abort(), I = null);
            }, g.cancelToken && g.cancelToken.subscribe(v), g.signal && (g.signal.aborted ? v() : g.signal.addEventListener("abort", v))), _ || !1 === _ || 0 === _ || "" === _ || (_ = null);
            var w = XT(R);
            w && -1 === BT.protocols.indexOf(w) ? S(new MT("Unsupported protocol " + w + ":", MT.ERR_BAD_REQUEST, g)) : I.send(_);
        });
    }, eI = {
        "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(g, f) {
        !RT.isUndefined(g) && RT.isUndefined(g["Content-Type"]) && (g["Content-Type"] = f);
    }
    function getDefaultAdapter() {
        var g;
        return ("undefined" != typeof XMLHttpRequest || "undefined" != typeof $lUPho && "[object process]" === Object.prototype.toString.call($lUPho)) && (g = ZT), g;
    }
    function stringifySafely(g, f, S) {
        if (RT.isString(g)) try {
            return (f || JSON.parse)(g), RT.trim(g);
        } catch (g) {
            if ("SyntaxError" !== g.name) throw g;
        }
        return (S || JSON.stringify)(g);
    }
    var tI = {
        transitional: VT,
        adapter: getDefaultAdapter(),
        transformRequest: [
            function transformRequest(g, f) {
                UT(f, "Accept"), UT(f, "Content-Type");
                var S, v = f && f["Content-Type"] || "", _ = v.indexOf("application/json") > -1, C = RT.isObject(g);
                if (C && RT.isHTMLForm(g) && (g = new FormData(g)), RT.isFormData(g)) return _ ? JSON.stringify($T(g)) : g;
                if (RT.isArrayBuffer(g) || RT.isBuffer(g) || RT.isStream(g) || RT.isFile(g) || RT.isBlob(g)) return g;
                if (RT.isArrayBufferView(g)) return g.buffer;
                if (RT.isURLSearchParams(g)) return setContentTypeIfUnset(f, "application/x-www-form-urlencoded;charset=utf-8"), g.toString();
                if (C) {
                    if (-1 !== v.indexOf("application/x-www-form-urlencoded")) return HT(g, this.formSerializer).toString();
                    if ((S = RT.isFileList(g)) || v.indexOf("multipart/form-data") > -1) {
                        var E = this.env && this.env.FormData;
                        return NT(S ? {
                            "files[]": g
                        } : g, E && new E, this.formSerializer);
                    }
                }
                return C || _ ? (setContentTypeIfUnset(f, "application/json"), stringifySafely(g)) : g;
            }
        ],
        transformResponse: [
            function transformResponse(g) {
                var f = this.transitional || tI.transitional, S = f && f.forcedJSONParsing, v = "json" === this.responseType;
                if (g && RT.isString(g) && (S && !this.responseType || v)) {
                    var _ = !(f && f.silentJSONParsing) && v;
                    try {
                        return JSON.parse(g);
                    } catch (g) {
                        if (_) {
                            if ("SyntaxError" === g.name) throw MT.from(g, MT.ERR_BAD_RESPONSE, this, null, this.response);
                            throw g;
                        }
                    }
                }
                return g;
            }
        ],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        env: {
            FormData: BT.classes.FormData,
            Blob: BT.classes.Blob
        },
        validateStatus: function validateStatus(g) {
            return g >= 200 && g < 300;
        },
        headers: {
            common: {
                Accept: "application/json, text/plain, */*"
            }
        }
    };
    RT.forEach([
        "delete",
        "get",
        "head"
    ], function forEachMethodNoData(g) {
        tI.headers[g] = {};
    }), RT.forEach([
        "post",
        "put",
        "patch"
    ], function forEachMethodWithData(g) {
        tI.headers[g] = RT.merge(eI);
    });
    var iI = tI, nI = function transformData(g, f, S, v) {
        var _ = this || iI;
        return RT.forEach(v, function transform(v) {
            g = v.call(_, g, f, S);
        }), g;
    }, rI = function isCancel(g) {
        return !(!g || !g.__CANCEL__);
    };
    function throwIfCancellationRequested(g) {
        if (g.cancelToken && g.cancelToken.throwIfRequested(), g.signal && g.signal.aborted) throw new QT;
    }
    var aI = function dispatchRequest(g) {
        return throwIfCancellationRequested(g), g.headers = g.headers || {}, g.data = nI.call(g, g.data, g.headers, null, g.transformRequest), UT(g.headers, "Accept"), UT(g.headers, "Content-Type"), g.headers = RT.merge(g.headers.common || {}, g.headers[g.method] || {}, g.headers), RT.forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], function cleanHeaderConfig(f) {
            delete g.headers[f];
        }), (g.adapter || iI.adapter)(g).then(function onAdapterResolution(f) {
            return throwIfCancellationRequested(g), f.data = nI.call(g, f.data, f.headers, f.status, g.transformResponse), f;
        }, function onAdapterRejection(f) {
            return rI(f) || (throwIfCancellationRequested(g), f && f.response && (f.response.data = nI.call(g, f.response.data, f.response.headers, f.response.status, g.transformResponse))), Promise.reject(f);
        });
    }, sI = function mergeConfig(g, f) {
        f = f || {};
        var S = {};
        function getMergedValue(g, f) {
            return RT.isPlainObject(g) && RT.isPlainObject(f) ? RT.merge(g, f) : RT.isEmptyObject(f) ? RT.merge({}, g) : RT.isPlainObject(f) ? RT.merge({}, f) : RT.isArray(f) ? f.slice() : f;
        }
        function mergeDeepProperties(S) {
            return RT.isUndefined(f[S]) ? RT.isUndefined(g[S]) ? void 0 : getMergedValue(void 0, g[S]) : getMergedValue(g[S], f[S]);
        }
        function valueFromConfig2(g) {
            if (!RT.isUndefined(f[g])) return getMergedValue(void 0, f[g]);
        }
        function defaultToConfig2(S) {
            return RT.isUndefined(f[S]) ? RT.isUndefined(g[S]) ? void 0 : getMergedValue(void 0, g[S]) : getMergedValue(void 0, f[S]);
        }
        function mergeDirectKeys(S) {
            return S in f ? getMergedValue(g[S], f[S]) : S in g ? getMergedValue(void 0, g[S]) : void 0;
        }
        var v = {
            url: valueFromConfig2,
            method: valueFromConfig2,
            data: valueFromConfig2,
            baseURL: defaultToConfig2,
            transformRequest: defaultToConfig2,
            transformResponse: defaultToConfig2,
            paramsSerializer: defaultToConfig2,
            timeout: defaultToConfig2,
            timeoutMessage: defaultToConfig2,
            withCredentials: defaultToConfig2,
            withXSRFToken: defaultToConfig2,
            adapter: defaultToConfig2,
            responseType: defaultToConfig2,
            xsrfCookieName: defaultToConfig2,
            xsrfHeaderName: defaultToConfig2,
            onUploadProgress: defaultToConfig2,
            onDownloadProgress: defaultToConfig2,
            decompress: defaultToConfig2,
            maxContentLength: defaultToConfig2,
            maxBodyLength: defaultToConfig2,
            beforeRedirect: defaultToConfig2,
            transport: defaultToConfig2,
            httpAgent: defaultToConfig2,
            httpsAgent: defaultToConfig2,
            cancelToken: defaultToConfig2,
            socketPath: defaultToConfig2,
            responseEncoding: defaultToConfig2,
            validateStatus: mergeDirectKeys
        };
        return RT.forEach(Object.keys(g).concat(Object.keys(f)), function computeConfigValue(g) {
            var f = v[g] || mergeDeepProperties, _ = f(g);
            RT.isUndefined(_) && f !== mergeDirectKeys || (S[g] = _);
        }), S;
    }, oI = {
        version: "0.28.1"
    }, lI = oI.version, cI = {};
    [
        "object",
        "boolean",
        "number",
        "function",
        "string",
        "symbol"
    ].forEach(function(g, f) {
        cI[g] = function validator(S) {
            return typeof S === g || "a" + (f < 1 ? "n " : " ") + g;
        };
    });
    var dI = {};
    function assertOptions(g, f, S) {
        if ("object" != typeof g) throw new MT("options must be an object", MT.ERR_BAD_OPTION_VALUE);
        for(var v = Object.keys(g), _ = v.length; _-- > 0;){
            var C = v[_], E = f[C];
            if (E) {
                var T = g[C], I = void 0 === T || E(T, C, g);
                if (!0 !== I) throw new MT("option " + C + " must be " + I, MT.ERR_BAD_OPTION_VALUE);
            } else if (!0 !== S) throw new MT("Unknown option " + C, MT.ERR_BAD_OPTION);
        }
    }
    cI.transitional = function transitional(g, f, S) {
        function formatMessage(g, f) {
            return "[Axios v" + lI + "] Transitional option '" + g + "'" + f + (S ? ". " + S : "");
        }
        return function(S, v, _) {
            if (!1 === g) throw new MT(formatMessage(v, " has been removed" + (f ? " in " + f : "")), MT.ERR_DEPRECATED);
            return f && !dI[v] && (dI[v] = !0, console.warn(formatMessage(v, " has been deprecated since v" + f + " and will be removed in the near future"))), !g || g(S, v, _);
        };
    };
    var uI = {
        assertOptions: assertOptions,
        validators: cI
    }, hI = uI.validators;
    function Axios(g) {
        this.defaults = g, this.interceptors = {
            request: new xT,
            response: new xT
        };
    }
    Axios.prototype.request = function request(g, f) {
        "string" == typeof g ? (f = f || {}).url = g : f = g || {}, (f = sI(this.defaults, f)).method ? f.method = f.method.toLowerCase() : this.defaults.method ? f.method = this.defaults.method.toLowerCase() : f.method = "get";
        var S = f.transitional;
        void 0 !== S && uI.assertOptions(S, {
            silentJSONParsing: hI.transitional(hI.boolean),
            forcedJSONParsing: hI.transitional(hI.boolean),
            clarifyTimeoutError: hI.transitional(hI.boolean)
        }, !1);
        var v = f.paramsSerializer;
        void 0 !== v && uI.assertOptions(v, {
            encode: hI.function,
            serialize: hI.function
        }, !0), RT.isFunction(v) && (f.paramsSerializer = {
            serialize: v
        });
        var _ = [], C = !0;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(g) {
            "function" == typeof g.runWhen && !1 === g.runWhen(f) || (C = C && g.synchronous, _.unshift(g.fulfilled, g.rejected));
        });
        var E, T = [];
        if (this.interceptors.response.forEach(function pushResponseInterceptors(g) {
            T.push(g.fulfilled, g.rejected);
        }), !C) {
            var I = [
                aI,
                void 0
            ];
            for(Array.prototype.unshift.apply(I, _), I = I.concat(T), E = Promise.resolve(f); I.length;)E = E.then(I.shift(), I.shift());
            return E;
        }
        for(var b = f; _.length;){
            var A = _.shift(), R = _.shift();
            try {
                b = A(b);
            } catch (g) {
                R(g);
                break;
            }
        }
        try {
            E = aI(b);
        } catch (g) {
            return Promise.reject(g);
        }
        for(; T.length;)E = E.then(T.shift(), T.shift());
        return E;
    }, Axios.prototype.getUri = function getUri(g) {
        g = sI(this.defaults, g);
        var f = zT(g.baseURL, g.url);
        return FT(f, g.params, g.paramsSerializer);
    }, RT.forEach([
        "delete",
        "get",
        "head",
        "options"
    ], function forEachMethodNoData(g) {
        Axios.prototype[g] = function(f, S) {
            return this.request(sI(S || {}, {
                method: g,
                url: f,
                data: (S || {}).data
            }));
        };
    }), RT.forEach([
        "post",
        "put",
        "patch"
    ], function forEachMethodWithData(g) {
        function generateHTTPMethod(f) {
            return function httpMethod(S, v, _) {
                return this.request(sI(_ || {}, {
                    method: g,
                    headers: f ? {
                        "Content-Type": "multipart/form-data"
                    } : {},
                    url: S,
                    data: v
                }));
            };
        }
        Axios.prototype[g] = generateHTTPMethod(), Axios.prototype[g + "Form"] = generateHTTPMethod(!0);
    });
    var gI = Axios;
    function CancelToken(g) {
        if ("function" != typeof g) throw new TypeError("executor must be a function.");
        var f;
        this.promise = new Promise(function promiseExecutor(g) {
            f = g;
        });
        var S = this;
        this.promise.then(function(g) {
            if (S._listeners) {
                for(var f = S._listeners.length; f-- > 0;)S._listeners[f](g);
                S._listeners = null;
            }
        }), this.promise.then = function(g) {
            var f, v = new Promise(function(g) {
                S.subscribe(g), f = g;
            }).then(g);
            return v.cancel = function reject() {
                S.unsubscribe(f);
            }, v;
        }, g(function cancel(g, v, _) {
            S.reason || (S.reason = new QT(g, v, _), f(S.reason));
        });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) throw this.reason;
    }, CancelToken.prototype.subscribe = function subscribe(g) {
        this.reason ? g(this.reason) : this._listeners ? this._listeners.push(g) : this._listeners = [
            g
        ];
    }, CancelToken.prototype.unsubscribe = function unsubscribe(g) {
        if (this._listeners) {
            var f = this._listeners.indexOf(g);
            -1 !== f && this._listeners.splice(f, 1);
        }
    }, CancelToken.source = function source() {
        var g;
        return {
            token: new CancelToken(function executor(f) {
                g = f;
            }),
            cancel: g
        };
    };
    var pI = CancelToken, mI = function spread(g) {
        return function wrap(f) {
            return g.apply(null, f);
        };
    }, fI = function isAxiosError(g) {
        return RT.isObject(g) && !0 === g.isAxiosError;
    };
    function createInstance(g) {
        var f = new gI(g), S = pT(gI.prototype.request, f);
        return RT.extend(S, gI.prototype, f), RT.extend(S, f), S.create = function create(f) {
            return createInstance(sI(g, f));
        }, S;
    }
    var SI = createInstance(iI);
    SI.Axios = gI, SI.CanceledError = QT, SI.CancelToken = pI, SI.isCancel = rI, SI.VERSION = oI.version, SI.toFormData = NT, SI.AxiosError = MT, SI.Cancel = SI.CanceledError, SI.all = function all(g) {
        return Promise.all(g);
    }, SI.spread = mI, SI.isAxiosError = fI, SI.formToJSON = function(g) {
        return $T(RT.isHTMLForm(g) ? new FormData(g) : g);
    };
    var vI = SI, _I = SI;
    vI.default = _I;
    for(var CI = vI, yI = createCommonjsModule(function(g) {
        var f = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
        if (f) {
            var S = new Uint8Array(16);
            g.exports = function whatwgRNG() {
                return f(S), S;
            };
        } else {
            var v = new Array(16);
            g.exports = function mathRNG() {
                for(var g, f = 0; f < 16; f++)0 == (3 & f) && (g = 4294967296 * Math.random()), v[f] = g >>> ((3 & f) << 3) & 255;
                return v;
            };
        }
    }), EI = [], TI = 0; TI < 256; ++TI)EI[TI] = (TI + 256).toString(16).substr(1);
    function bytesToUuid(g, f) {
        var S = f || 0, v = EI;
        return [
            v[g[S++]],
            v[g[S++]],
            v[g[S++]],
            v[g[S++]],
            "-",
            v[g[S++]],
            v[g[S++]],
            "-",
            v[g[S++]],
            v[g[S++]],
            "-",
            v[g[S++]],
            v[g[S++]],
            "-",
            v[g[S++]],
            v[g[S++]],
            v[g[S++]],
            v[g[S++]],
            v[g[S++]],
            v[g[S++]]
        ].join("");
    }
    var II, bI, AI = bytesToUuid, RI = 0, PI = 0;
    function v1(g, f, S) {
        var v = f && S || 0, _ = f || [], C = (g = g || {}).node || II, E = void 0 !== g.clockseq ? g.clockseq : bI;
        if (null == C || null == E) {
            var T = yI();
            null == C && (C = II = [
                1 | T[0],
                T[1],
                T[2],
                T[3],
                T[4],
                T[5]
            ]), null == E && (E = bI = 16383 & (T[6] << 8 | T[7]));
        }
        var I = void 0 !== g.msecs ? g.msecs : (new Date).getTime(), b = void 0 !== g.nsecs ? g.nsecs : PI + 1, A = I - RI + (b - PI) / 1e4;
        if (A < 0 && void 0 === g.clockseq && (E = E + 1 & 16383), (A < 0 || I > RI) && void 0 === g.nsecs && (b = 0), b >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        RI = I, PI = b, bI = E;
        var R = (1e4 * (268435455 & (I += 122192928e5)) + b) % 4294967296;
        _[v++] = R >>> 24 & 255, _[v++] = R >>> 16 & 255, _[v++] = R >>> 8 & 255, _[v++] = 255 & R;
        var P = I / 4294967296 * 1e4 & 268435455;
        _[v++] = P >>> 8 & 255, _[v++] = 255 & P, _[v++] = P >>> 24 & 15 | 16, _[v++] = P >>> 16 & 255, _[v++] = E >>> 8 | 128, _[v++] = 255 & E;
        for(var w = 0; w < 6; ++w)_[v + w] = C[w];
        return f || AI(_);
    }
    var wI = v1;
    function v4(g, f, S) {
        var v = f && S || 0;
        "string" == typeof g && (f = "binary" === g ? new Array(16) : null, g = null);
        var _ = (g = g || {}).random || (g.rng || yI)();
        if (_[6] = 15 & _[6] | 64, _[8] = 63 & _[8] | 128, f) for(var C = 0; C < 16; ++C)f[v + C] = _[C];
        return f || AI(_);
    }
    var MI = v4, OI = MI;
    OI.v1 = wI, OI.v4 = MI;
    var DI = OI, NI = createCommonjsModule(function(g, f) {
        var S = _ && _.__assign || function() {
            return S = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, S.apply(this, arguments);
        };
        function errorToString(g, f) {
            if (void 0 === f && (f = !0), null == g) return "";
            if ("string" == typeof g) return g;
            try {
                return JSON.stringify(g, circularReplacer(buildErrorJsonReplacer(f)));
            } catch (g) {
                return "Stringifying error failed";
            }
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.errorToString = void 0, f.errorToString = errorToString;
        var buildErrorJsonReplacer = function(g) {
            return void 0 === g && (g = !1), function(f, v) {
                return v instanceof Error ? S({
                    name: v.name,
                    message: v.message,
                    stack: g ? [] : ("string" == typeof v.stack ? v.stack : "").split("\n").map(function(g) {
                        return g.trim();
                    }).filter(function(g) {
                        return !!g;
                    })
                }, v) : v;
            };
        }, circularReplacer = function(g) {
            var f = new WeakSet;
            return function(S, v) {
                if ("object" == typeof v && null !== v) {
                    if (f.has(v)) return;
                    f.add(v);
                }
                return g(S, v);
            };
        };
    }), kI = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.EvictingQueue = void 0;
        var S = function() {
            function EvictingQueue(g) {
                this.maxSize = g, this._store = [];
            }
            return Object.defineProperty(EvictingQueue.prototype, "store", {
                get: function() {
                    return this._store;
                },
                enumerable: !1,
                configurable: !0
            }), Object.defineProperty(EvictingQueue.prototype, "size", {
                get: function() {
                    return this._store.length;
                },
                enumerable: !1,
                configurable: !0
            }), EvictingQueue.prototype.enqueue = function(g) {
                this._store.length >= this.maxSize && this._store.shift(), this._store.push(g);
            }, EvictingQueue.prototype.dequeue = function() {
                return this._store.shift();
            }, EvictingQueue.prototype.clear = function() {
                this._store = [];
            }, EvictingQueue.prototype.forEach = function(g) {
                this._store.forEach(g);
            }, EvictingQueue;
        }();
        f.EvictingQueue = S;
    }), LI = createCommonjsModule(function(g, f) {
        var S = _ && _.__awaiter || function(g, f, S, v) {
            function adopt(g) {
                return g instanceof S ? g : new S(function(f) {
                    f(g);
                });
            }
            return new (S || (S = Promise))(function(S, _) {
                function fulfilled(g) {
                    try {
                        step(v.next(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function rejected(g) {
                    try {
                        step(v.throw(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function step(g) {
                    g.done ? S(g.value) : adopt(g.value).then(fulfilled, rejected);
                }
                step((v = v.apply(g, f || [])).next());
            });
        }, v = _ && _.__generator || function(g, f) {
            var S, v, _, C, E = {
                label: 0,
                sent: function() {
                    if (1 & _[0]) throw _[1];
                    return _[1];
                },
                trys: [],
                ops: []
            };
            return C = {
                next: verb(0),
                throw: verb(1),
                return: verb(2)
            }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                return this;
            }), C;
            function verb(g) {
                return function(f) {
                    return step([
                        g,
                        f
                    ]);
                };
            }
            function step(C) {
                if (S) throw new TypeError("Generator is already executing.");
                for(; E;)try {
                    if (S = 1, v && (_ = 2 & C[0] ? v.return : C[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, C[1])).done) return _;
                    switch(v = 0, _ && (C = [
                        2 & C[0],
                        _.value
                    ]), C[0]){
                        case 0:
                        case 1:
                            _ = C;
                            break;
                        case 4:
                            return E.label++, {
                                value: C[1],
                                done: !1
                            };
                        case 5:
                            E.label++, v = C[1], C = [
                                0
                            ];
                            continue;
                        case 7:
                            C = E.ops.pop(), E.trys.pop();
                            continue;
                        default:
                            if (!(_ = E.trys, (_ = _.length > 0 && _[_.length - 1]) || 6 !== C[0] && 2 !== C[0])) {
                                E = 0;
                                continue;
                            }
                            if (3 === C[0] && (!_ || C[1] > _[0] && C[1] < _[3])) {
                                E.label = C[1];
                                break;
                            }
                            if (6 === C[0] && E.label < _[1]) {
                                E.label = _[1], _ = C;
                                break;
                            }
                            if (_ && E.label < _[2]) {
                                E.label = _[2], E.ops.push(C);
                                break;
                            }
                            _[2] && E.ops.pop(), E.trys.pop();
                            continue;
                    }
                    C = f.call(g, E);
                } catch (g) {
                    C = [
                        6,
                        g
                    ], v = 0;
                } finally{
                    S = _ = 0;
                }
                if (5 & C[0]) throw C[1];
                return {
                    value: C[0] ? C[1] : void 0,
                    done: !0
                };
            }
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.SimpleSyncCell = void 0;
        var C = function() {
            function SimpleSyncCell(g, f, S, v, _) {
                this.m_id = g, this.m_sender = f, this.m_shouldEmitEventForAllMessages = S, this.aggregation = _, this.m_events = new Ny.EventEmitter, this.m_emitUnacknowledgedEventFor = null != v ? v : gT.MessageTrackingOption.None;
            }
            return SimpleSyncCell.prototype.on = function(g, f) {
                return this.m_events.on(g, f), this;
            }, SimpleSyncCell.prototype.off = function(g, f) {
                return this.m_events.off(g, f), this;
            }, SimpleSyncCell.prototype.removeAllListeners = function(g) {
                return this.m_events.removeAllListeners(g), this;
            }, SimpleSyncCell.prototype.id = function() {
                return this.m_id;
            }, SimpleSyncCell.prototype.messageTrackingOption = function() {
                return this.m_emitUnacknowledgedEventFor;
            }, SimpleSyncCell.prototype.getAsync = function() {
                return S(this, void 0, void 0, function() {
                    return v(this, function(g) {
                        return [
                            2,
                            this.m_value
                        ];
                    });
                });
            }, SimpleSyncCell.prototype.setAsync = function(g) {
                return S(this, void 0, void 0, function() {
                    var f;
                    return v(this, function(S) {
                        return this.m_value = g, f = {
                            messageId: DI.v4(),
                            senderId: this.m_sender.senderId(),
                            objectId: this.m_id,
                            type: "cell",
                            operation: "set",
                            value: JSON.stringify(this.m_value)
                        }, this.m_sender.sendStateMessage(f), [
                            2
                        ];
                    });
                });
            }, SimpleSyncCell.prototype.delete = function() {
                this.m_value = void 0;
                var g = {
                    messageId: DI.v4(),
                    senderId: this.m_sender.senderId(),
                    objectId: this.m_id,
                    type: "cell",
                    operation: "delete",
                    value: ""
                };
                this.m_sender.sendStateMessage(g);
            }, SimpleSyncCell.prototype.handleStateMessage = function(g) {
                switch(g.operation){
                    case "set":
                        return void ((JSON.stringify(this.m_value) !== g.value || this.m_shouldEmitEventForAllMessages) && (this.m_value = JSON.parse(g.value), this.m_events.emit("valueChanged", this.m_value, g)));
                    case "delete":
                        return this.m_value = void 0, void this.m_events.emit("valueDeleted", this.m_value, g);
                    default:
                        return;
                }
            }, SimpleSyncCell.prototype.handleUnacknowledgedMessage = function(g) {
                this.m_events.emit("valueUnacknowledged", g);
            }, SimpleSyncCell.prototype.beginAggregatedStateUpdating = function() {
                var g;
                null === (g = this.aggregation) || void 0 === g || g.beginAggregatedStateUpdating();
            }, SimpleSyncCell.prototype.endAggregatedStateUpdating = function() {
                var g;
                null === (g = this.aggregation) || void 0 === g || g.endAggregatedStateUpdating();
            }, SimpleSyncCell;
        }();
        f.SimpleSyncCell = C;
    }), FI = createCommonjsModule(function(g, f) {
        function isPrefixDeleteMessage(g) {
            return "delete" === g.operation && "prefix" === g.value;
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.isPrefixDeleteMessage = void 0, f.isPrefixDeleteMessage = isPrefixDeleteMessage;
    }), xI = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.SimpleSyncMap = void 0;
        var S = function() {
            function SimpleSyncMap(g, f, S, v, _) {
                this.m_id = g, this.m_sender = f, this.m_shouldEmitEventForAllMessages = S, this.aggregation = _, this.m_events = new Ny.EventEmitter, this.m_map = new Map, this.m_emitUnacknowledgedEventFor = null != v ? v : gT.MessageTrackingOption.None;
            }
            return SimpleSyncMap.prototype.on = function(g, f) {
                return this.m_events.on(g, f), this;
            }, SimpleSyncMap.prototype.off = function(g, f) {
                return this.m_events.off(g, f), this;
            }, SimpleSyncMap.prototype.removeAllListeners = function(g) {
                return this.m_events.removeAllListeners(g), this;
            }, SimpleSyncMap.prototype.id = function() {
                return this.m_id;
            }, SimpleSyncMap.prototype.messageTrackingOption = function() {
                return this.m_emitUnacknowledgedEventFor;
            }, SimpleSyncMap.prototype.get = function(g) {
                return this.m_map.get(g);
            }, SimpleSyncMap.prototype.set = function(g, f) {
                this.m_map.set(g, f);
                var S = {
                    messageId: DI.v4(),
                    senderId: this.m_sender.senderId(),
                    objectId: this.m_id,
                    type: "map",
                    operation: "set",
                    property: g,
                    value: JSON.stringify(f)
                };
                this.m_sender.sendStateMessage(S);
            }, SimpleSyncMap.prototype.delete = function(g) {
                var f = {
                    messageId: DI.v4(),
                    senderId: this.m_sender.senderId(),
                    objectId: this.m_id,
                    type: "map",
                    operation: "delete",
                    property: g,
                    value: ""
                };
                this.performLocalDelete(f), this.m_sender.sendStateMessage(f);
            }, SimpleSyncMap.prototype.deleteWithPrefix = function(g) {
                var f = {
                    messageId: DI.v4(),
                    senderId: this.m_sender.senderId(),
                    objectId: this.m_id,
                    type: "map",
                    operation: "delete",
                    property: g,
                    value: "prefix"
                };
                this.performLocalDelete(f), this.m_sender.sendStateMessage(f);
            }, SimpleSyncMap.prototype.forEach = function(g) {
                this.m_map.forEach(g);
            }, SimpleSyncMap.prototype.handleStateMessage = function(g) {
                switch(g.operation){
                    case "set":
                        return void this.handleSet(g);
                    case "delete":
                        return void this.handleDelete(g);
                    default:
                        return;
                }
            }, SimpleSyncMap.prototype.handleSet = function(g) {
                if (!g.property) throw new Error("property is missing for a map.");
                (JSON.stringify(this.m_map.get(g.property)) !== g.value || this.m_shouldEmitEventForAllMessages) && (this.m_map.set(g.property, JSON.parse(g.value)), this.m_events.emit("valueChanged", g.property, g));
            }, SimpleSyncMap.prototype.handleDelete = function(g) {
                this.performLocalDelete(g), FI.isPrefixDeleteMessage(g) ? this.m_events.emit("valuesDeletedWithPrefix", g.property, g) : this.m_events.emit("valueDeleted", g.property || "", g);
            }, SimpleSyncMap.prototype.handleUnacknowledgedMessage = function(g) {
                this.m_events.emit("valueUnacknowledged", g);
            }, SimpleSyncMap.prototype.beginAggregatedStateUpdating = function() {
                var g;
                null === (g = this.aggregation) || void 0 === g || g.beginAggregatedStateUpdating();
            }, SimpleSyncMap.prototype.endAggregatedStateUpdating = function() {
                var g;
                null === (g = this.aggregation) || void 0 === g || g.endAggregatedStateUpdating();
            }, SimpleSyncMap.prototype.performLocalDelete = function(g) {
                var f = this;
                if (g.property) {
                    var S = g.property;
                    FI.isPrefixDeleteMessage(g) ? this.m_map.forEach(function(g, v) {
                        v.startsWith(S) && f.m_map.delete(v);
                    }) : this.m_map.delete(g.property);
                } else this.m_map.clear();
            }, SimpleSyncMap;
        }();
        f.SimpleSyncMap = S;
    }), UI = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.SimpleServicePerformanceTelemetry = f.SimpleServiceTelemetry = void 0;
        var S = function() {
            function SimpleServiceTelemetry(g, f, S) {
                this.backendService = "SimpleService", this.clientId = g, this.sessionId = f, this.wsReconnectCount = 0, this.wsState = gT.ConnectionState[gT.ConnectionState.Disconnected], this.maxRoundtripRaw = S || 0, this.roundtripTelemetry = new v, this.messageHandleTelemetry = new v, this.offlineCacheTelemetry = {
                    cachedCount: 0,
                    resentCount: 0,
                    expiredCount: 0,
                    rejectedCount: 0
                }, this.maxRoundtripRaw > 0 && (this.roundtripRaw = []), this.messagePendingAckCount = 0, this.unacknowledgedMessagesCount = 0, this.messageRequested = {}, this.messageReceived = {}, this.messageAcknowledged = {};
            }
            return SimpleServiceTelemetry.prototype.addRoundtripLatency = function(g) {
                this.roundtripRaw && this.roundtripRaw.length < this.maxRoundtripRaw && this.roundtripRaw.push(g), this.roundtripTelemetry.addLatency(g);
            }, SimpleServiceTelemetry.prototype.addMessageHandleLatency = function(g) {
                this.messageHandleTelemetry.addLatency(g);
            }, SimpleServiceTelemetry.prototype.incrementAcknowledgedCount = function(g) {
                this.incrementMessageCount(this.messageAcknowledged, g);
            }, SimpleServiceTelemetry.prototype.incrementRequestedCount = function(g) {
                this.incrementMessageCount(this.messageRequested, g);
            }, SimpleServiceTelemetry.prototype.incrementReceivedCount = function(g) {
                this.incrementMessageCount(this.messageReceived, g);
            }, SimpleServiceTelemetry.prototype.incrementMessageCount = function(g, f) {
                var S = g[f], v = void 0 === S ? 1 : S + 1;
                g[f] = v;
            }, SimpleServiceTelemetry;
        }();
        f.SimpleServiceTelemetry = S;
        var v = function() {
            function SimpleServicePerformanceTelemetry() {
                this.count = 0, this.minValue = 0, this.maxValue = 0, this.avgValue = 0;
            }
            return SimpleServicePerformanceTelemetry.prototype.addLatency = function(g) {
                this.count += 1, this.avgValue = this.avgValue + (g - this.avgValue) / this.count, this.minValue = this.count > 1 ? Math.min(g, this.minValue) : g, this.maxValue = Math.max(this.maxValue, g);
            }, SimpleServicePerformanceTelemetry;
        }();
        f.SimpleServicePerformanceTelemetry = v;
    }), VI = createCommonjsModule(function(g, f) {
        var S = _ && _.__awaiter || function(g, f, S, v) {
            function adopt(g) {
                return g instanceof S ? g : new S(function(f) {
                    f(g);
                });
            }
            return new (S || (S = Promise))(function(S, _) {
                function fulfilled(g) {
                    try {
                        step(v.next(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function rejected(g) {
                    try {
                        step(v.throw(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function step(g) {
                    g.done ? S(g.value) : adopt(g.value).then(fulfilled, rejected);
                }
                step((v = v.apply(g, f || [])).next());
            });
        }, v = _ && _.__generator || function(g, f) {
            var S, v, _, C, E = {
                label: 0,
                sent: function() {
                    if (1 & _[0]) throw _[1];
                    return _[1];
                },
                trys: [],
                ops: []
            };
            return C = {
                next: verb(0),
                throw: verb(1),
                return: verb(2)
            }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                return this;
            }), C;
            function verb(g) {
                return function(f) {
                    return step([
                        g,
                        f
                    ]);
                };
            }
            function step(C) {
                if (S) throw new TypeError("Generator is already executing.");
                for(; E;)try {
                    if (S = 1, v && (_ = 2 & C[0] ? v.return : C[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, C[1])).done) return _;
                    switch(v = 0, _ && (C = [
                        2 & C[0],
                        _.value
                    ]), C[0]){
                        case 0:
                        case 1:
                            _ = C;
                            break;
                        case 4:
                            return E.label++, {
                                value: C[1],
                                done: !1
                            };
                        case 5:
                            E.label++, v = C[1], C = [
                                0
                            ];
                            continue;
                        case 7:
                            C = E.ops.pop(), E.trys.pop();
                            continue;
                        default:
                            if (!(_ = E.trys, (_ = _.length > 0 && _[_.length - 1]) || 6 !== C[0] && 2 !== C[0])) {
                                E = 0;
                                continue;
                            }
                            if (3 === C[0] && (!_ || C[1] > _[0] && C[1] < _[3])) {
                                E.label = C[1];
                                break;
                            }
                            if (6 === C[0] && E.label < _[1]) {
                                E.label = _[1], _ = C;
                                break;
                            }
                            if (_ && E.label < _[2]) {
                                E.label = _[2], E.ops.push(C);
                                break;
                            }
                            _[2] && E.ops.pop(), E.trys.pop();
                            continue;
                    }
                    C = f.call(g, E);
                } catch (g) {
                    C = [
                        6,
                        g
                    ], v = 0;
                } finally{
                    S = _ = 0;
                }
                if (5 & C[0]) throw C[1];
                return {
                    value: C[0] ? C[1] : void 0,
                    done: !0
                };
            }
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.StateServiceWebSocketConnection = void 0;
        var C = function() {
            function StateServiceWebSocketConnection(g, f) {
                var _ = this;
                this.onopen = null, this.onclose = null, this.onerror = null, this.onmessage = null, this.onlog = null, this.ws = new WebSocket(g), this.settings = f, this.ws.onopen = function(g) {
                    return S(_, void 0, void 0, function() {
                        return v(this, function(f) {
                            switch(f.label){
                                case 0:
                                    return this.onopen && this.onopen(g), [
                                        4,
                                        this.sendSetupMessages()
                                    ];
                                case 1:
                                    return f.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, this.ws.onclose = function(g) {
                    _.onclose && _.onclose(g);
                }, this.ws.onerror = function(g) {
                    _.onerror && _.onerror(g);
                }, this.ws.onmessage = function(g) {
                    _.onmessage && _.onmessage(g);
                };
            }
            return StateServiceWebSocketConnection.CreateAsync = function(g, f) {
                return S(this, void 0, void 0, function() {
                    return v(this, function(S) {
                        return [
                            2,
                            new StateServiceWebSocketConnection(g, f)
                        ];
                    });
                });
            }, Object.defineProperty(StateServiceWebSocketConnection.prototype, "name", {
                get: function() {
                    return "WebSocket";
                },
                enumerable: !1,
                configurable: !0
            }), Object.defineProperty(StateServiceWebSocketConnection.prototype, "readyState", {
                get: function() {
                    return this.ws.readyState;
                },
                enumerable: !1,
                configurable: !0
            }), Object.defineProperty(StateServiceWebSocketConnection.prototype, "isOpen", {
                get: function() {
                    return this.ws.readyState === WebSocket.OPEN;
                },
                enumerable: !1,
                configurable: !0
            }), Object.defineProperty(StateServiceWebSocketConnection.prototype, "shouldSendPings", {
                get: function() {
                    return !0;
                },
                enumerable: !1,
                configurable: !0
            }), StateServiceWebSocketConnection.prototype.close = function() {
                this.ws.close();
            }, StateServiceWebSocketConnection.prototype.send = function(g) {
                this.ws.send(g);
            }, StateServiceWebSocketConnection.prototype.sendSetupMessages = function() {
                return S(this, void 0, void 0, function() {
                    var g, f, S, _, C, E, T = this;
                    return v(this, function(v) {
                        switch(v.label){
                            case 0:
                                return (f = this.settings.getAuthTokenAsync) ? [
                                    4,
                                    this.settings.getAuthTokenAsync()
                                ] : [
                                    3,
                                    2
                                ];
                            case 1:
                                f = v.sent(), v.label = 2;
                            case 2:
                                return g = f, S = this.settings, _ = S.metadata, C = S.subscriptions, E = {
                                    authToken: g,
                                    metadata: _,
                                    subscriptions: C
                                }, this.settings.createSetupMessage(E).forEach(function(g) {
                                    return T.send(g);
                                }), [
                                    2
                                ];
                        }
                    });
                });
            }, StateServiceWebSocketConnection;
        }();
        f.StateServiceWebSocketConnection = C;
    }), BI = createCommonjsModule(function(g, f) {
        var S = _ && _.__awaiter || function(g, f, S, v) {
            function adopt(g) {
                return g instanceof S ? g : new S(function(f) {
                    f(g);
                });
            }
            return new (S || (S = Promise))(function(S, _) {
                function fulfilled(g) {
                    try {
                        step(v.next(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function rejected(g) {
                    try {
                        step(v.throw(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function step(g) {
                    g.done ? S(g.value) : adopt(g.value).then(fulfilled, rejected);
                }
                step((v = v.apply(g, f || [])).next());
            });
        }, v = _ && _.__generator || function(g, f) {
            var S, v, _, C, E = {
                label: 0,
                sent: function() {
                    if (1 & _[0]) throw _[1];
                    return _[1];
                },
                trys: [],
                ops: []
            };
            return C = {
                next: verb(0),
                throw: verb(1),
                return: verb(2)
            }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                return this;
            }), C;
            function verb(g) {
                return function(f) {
                    return step([
                        g,
                        f
                    ]);
                };
            }
            function step(C) {
                if (S) throw new TypeError("Generator is already executing.");
                for(; E;)try {
                    if (S = 1, v && (_ = 2 & C[0] ? v.return : C[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, C[1])).done) return _;
                    switch(v = 0, _ && (C = [
                        2 & C[0],
                        _.value
                    ]), C[0]){
                        case 0:
                        case 1:
                            _ = C;
                            break;
                        case 4:
                            return E.label++, {
                                value: C[1],
                                done: !1
                            };
                        case 5:
                            E.label++, v = C[1], C = [
                                0
                            ];
                            continue;
                        case 7:
                            C = E.ops.pop(), E.trys.pop();
                            continue;
                        default:
                            if (!(_ = E.trys, (_ = _.length > 0 && _[_.length - 1]) || 6 !== C[0] && 2 !== C[0])) {
                                E = 0;
                                continue;
                            }
                            if (3 === C[0] && (!_ || C[1] > _[0] && C[1] < _[3])) {
                                E.label = C[1];
                                break;
                            }
                            if (6 === C[0] && E.label < _[1]) {
                                E.label = _[1], _ = C;
                                break;
                            }
                            if (_ && E.label < _[2]) {
                                E.label = _[2], E.ops.push(C);
                                break;
                            }
                            _[2] && E.ops.pop(), E.trys.pop();
                            continue;
                    }
                    C = f.call(g, E);
                } catch (g) {
                    C = [
                        6,
                        g
                    ], v = 0;
                } finally{
                    S = _ = 0;
                }
                if (5 & C[0]) throw C[1];
                return {
                    value: C[0] ? C[1] : void 0,
                    done: !0
                };
            }
        }, C = _ && _.__values || function(g) {
            var f = "function" == typeof Symbol && Symbol.iterator, S = f && g[f], v = 0;
            if (S) return S.call(g);
            if (g && "number" == typeof g.length) return {
                next: function() {
                    return g && v >= g.length && (g = void 0), {
                        value: g && g[v++],
                        done: !g
                    };
                }
            };
            throw new TypeError(f ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }, E = _ && _.__importDefault || function(g) {
            return g && g.__esModule ? g : {
                default: g
            };
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.SimpleStateServiceProxy = void 0;
        var T = E(CI), I = [
            2e3,
            2e3,
            3e3,
            3e3,
            5e3
        ], b = 4321, A = function() {
            function SimpleStateServiceProxy(g, f, S, v, _, C) {
                var E;
                this.m_events = new Ny.EventEmitter, this.m_clientId = "", this.m_connectionState = gT.ConnectionState.Disconnected, this.m_handlers = new Map, this.m_connection = null, this.m_clientIds = new Set, this.m_initTimeoutDurationInMS = 0, this.m_retryAttempts = 0, this.m_sessionRetryAttempts = 0, this.m_maxSessionRetries = 0, this.m_outboundMessageInfo = new Map, this.m_initPromise = {
                    promise: null,
                    resolve: null,
                    reject: null
                }, this.m_messageBuffer = [], this.m_batchWaitTimeMS = 20, this.m_batchMessageTypeName = "list", this.m_closeConnectionTimer = null, this.m_lastCloseCode = 0, this.m_lastCloseReason = "", this.m_offlineMessageCache = [], this.m_unacknowledgedMessages = new Map, this.m_sessionId = g, this.m_logger = v, this.m_connectionAliveTimeAfterLoseFocusInMS = _.websocketAliveTimeAfterLoseFocusInMS, this.m_useServiceGeneratedClientId = _.useServiceGeneratedClientId || !1, this.m_wsUrl = S + "?docId=" + this.m_sessionId + "&clientType=" + f, _.correlationId && (this.m_wsUrl += "&cid=" + _.correlationId), _.isAutomation && (this.m_wsUrl += "&automation=true"), _.autoRoutingEnabled && (this.m_wsUrl += "&routing=true"), this.m_useServiceGeneratedClientId || (this.m_clientId = _.customClientId || DI.v4(), this.m_wsUrl += "&clientId=" + this.m_clientId), this.m_deltasBaseUrl = S.replace("wss://", "https://").replace("ws://", "http://"), this.setupSystemClientsCell(), this.setUpSystemCommandsCell(), this.setupServiceGeneratedClientIdCell(), this.m_useServiceGeneratedClientId && (this.m_clientIdEvictingQueue = new kI.EvictingQueue(20)), this.m_telemetry = new UI.SimpleServiceTelemetry(this.m_clientId, this.m_sessionId, _.maxRoundtripRaw), this.m_verbose = _.verbose || !1, this.m_batchedRequestsEnabled = _.batchedRequestsEnabled, this.m_initTimeoutDurationInMS = _.initTimeoutDurationInMs || 0, this.m_pingTimeoutInMs = _.pingTimeoutInMs, this.m_pongTimeoutInMs = _.pongTimeoutInMs, this.m_user = C, this.m_metadata = _.metadata, this.m_retryIntervalsInMs = _.retryIntervalsInMs || I, this.m_maxSessionRetries = _.maxSessionRetries, this.m_offlineMessageCacheEnabled = _.offlineMessageCacheEnabled, this.m_maxOfflineMessageCacheTimeInMs = _.maxOfflineMessageCacheTimeInMs, this.m_maxOfflineMessageCacheLength = _.maxOfflineMessageCacheLength, this.m_allowReconnectOnMessageSend = _.allowReconnectOnSendMessage || !1, this.m_unacknowledgedMaxTimeInMs = null !== (E = _.unacknowledgeMessageTimeoutInMs) && void 0 !== E ? E : 0, this.m_subscriptions = _.subscriptions, this.m_connectionSettings = {
                    getAuthTokenAsync: this.getAuthToken.bind(this),
                    createSetupMessage: this.createSetupMessage.bind(this),
                    metadata: this.m_metadata,
                    subscriptions: this.m_subscriptions
                };
            }
            return Object.defineProperty(SimpleStateServiceProxy.prototype, "lastCloseReason", {
                get: function() {
                    return this.m_lastCloseReason;
                },
                enumerable: !1,
                configurable: !0
            }), SimpleStateServiceProxy.prototype.senderId = function() {
                return this.m_clientId;
            }, SimpleStateServiceProxy.prototype.countOfOutboundMessagesNotRoundTrippedYet = function() {
                return this.m_outboundMessageInfo.size;
            }, SimpleStateServiceProxy.prototype.canRetry = function() {
                return this.m_connectionState === gT.ConnectionState.Disconnected && this.m_lastCloseCode !== b;
            }, SimpleStateServiceProxy.prototype.getServiceTelemetry = function() {
                return this.m_telemetry.wsState = gT.ConnectionState[this.getConnectionState()], this.m_telemetry.messagePendingAckCount = this.m_outboundMessageInfo.size, this.m_telemetry;
            }, SimpleStateServiceProxy.prototype.activeClientCount = function() {
                return this.m_clientIds.size;
            }, SimpleStateServiceProxy.prototype.activeClientIds = function() {
                return this.m_clientIds;
            }, SimpleStateServiceProxy.prototype.clientId = function() {
                return this.m_clientId;
            }, SimpleStateServiceProxy.prototype.getConnectionState = function() {
                return this.m_connectionState;
            }, SimpleStateServiceProxy.prototype.on = function(g, f) {
                return this.m_events.on(g, f), this;
            }, SimpleStateServiceProxy.prototype.connectAsync = function() {
                return S(this, void 0, void 0, function() {
                    var g = this;
                    return v(this, function(f) {
                        return this.m_initPromise.promise = new Promise(function(f, S) {
                            g.m_initPromise.resolve = f, g.m_initPromise.reject = S;
                        }), this.setConnectionState(gT.ConnectionState.Connecting), [
                            2,
                            new Promise(function(f, _) {
                                return S(g, void 0, void 0, function() {
                                    var g, S = this;
                                    return v(this, function(v) {
                                        switch(v.label){
                                            case 0:
                                                return g = this, [
                                                    4,
                                                    VI.StateServiceWebSocketConnection.CreateAsync(this.m_wsUrl, this.m_connectionSettings)
                                                ];
                                            case 1:
                                                return g.m_connection = v.sent(), this.m_connection.onopen = function() {
                                                    S.handleConnectionOpen(), S.startInitTimeoutTimerWithRetry(S.m_initTimeoutDurationInMS, S.m_initPromise.reject), f();
                                                }, this.m_connection.onerror = function(g) {
                                                    var v;
                                                    S.m_logger.sendTraceTag(590213388, hT.TraceLevel.Error, "SimpleStateServiceProxy::connect - " + (null === (v = S.m_connection) || void 0 === v ? void 0 : v.name) + " onerror. {sessionId: " + S.m_sessionId + ", ClientId: " + S.m_clientId + ", Error: " + JSON.stringify(g) + "}"), S.retryConnection(function(g) {
                                                        var f, v = "failed to reconnect after " + (null === (f = S.m_connection) || void 0 === f ? void 0 : f.name) + " error: " + NI.errorToString(g);
                                                        S.m_logger.sendTraceTag(579463185, hT.TraceLevel.Error, v), _(v);
                                                    }, !1, function() {
                                                        return f();
                                                    });
                                                }, this.m_connection.onlog = function(g) {
                                                    var f;
                                                    S.m_logger.sendTraceTag(556909603, g.detail.level, "SimpleStateServiceProxy::log - " + (null === (f = S.m_connection) || void 0 === f ? void 0 : f.name) + " {sessionId: " + S.m_sessionId + ", ClientId: " + S.m_clientId + ", Message: " + g.detail.message + "}");
                                                }, this.m_connection.onclose = function(g) {
                                                    var v, C;
                                                    S.m_logger.sendTraceTag(590213389, hT.TraceLevel.Error, "SimpleStateServiceProxy::connect - " + (null === (v = S.m_connection) || void 0 === v ? void 0 : v.name) + " onclose. {sessionId: " + S.m_sessionId + ", ClientId: " + S.m_clientId + ", Code: " + g.code + ", Reason: " + g.reason + "}"), S.m_lastCloseCode = g.code, S.m_lastCloseReason = g.reason, g.code !== b ? S.retryConnection(function(g) {
                                                        var f = "failed to reconnect after service side disconnect: " + NI.errorToString(g);
                                                        S.m_logger.sendTraceTag(579463186, hT.TraceLevel.Error, f), _(f);
                                                    }, !1, function() {
                                                        return f();
                                                    }) : (S.setConnectionState(gT.ConnectionState.Disconnected), S.m_logger.sendTraceTag(588009741, hT.TraceLevel.Error, "SimpleStateServiceProxy::connect - " + (null === (C = S.m_connection) || void 0 === C ? void 0 : C.name) + " onclose. Not retryable close code. {sessionId: " + S.m_sessionId + ", ClientId: " + S.m_clientId + "}"));
                                                }, this.m_connection.onmessage = function(g) {
                                                    var f;
                                                    try {
                                                        S.handleConnectionMessage(g);
                                                    } catch (g) {
                                                        S.m_logger.sendTraceTag(590213390, hT.TraceLevel.Error, "SimpleStateServiceProxy::onmessage - " + (null === (f = S.m_connection) || void 0 === f ? void 0 : f.name) + " error. {sessionId: " + S.m_sessionId + ", ClientId: " + S.m_clientId + ", Error: " + NI.errorToString(g) + "}");
                                                    }
                                                }, [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            }, SimpleStateServiceProxy.prototype.close = function() {
                var g;
                this.m_logger.sendTraceTag(590213400, hT.TraceLevel.Info, "SimpleStateServiceProxy::close. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}"), this.closeAndClearConnection(), this.m_retryTimer && (clearTimeout(this.m_retryTimer), this.m_retryTimer = null), this.m_unacknowledgedMessages.clear(), this.clearPingPongTimer(), this.clearOfflineMessageCacheTimer(), this.clearInitTimeoutTimer(), this.clearUnacknowledgedTimer(), null === (g = this.m_clientIdEvictingQueue) || void 0 === g || g.clear(), 0 !== this.countOfOutboundMessagesNotRoundTrippedYet() && (this.m_events.emit("messageFailedToRoundTripOnClose", this.m_outboundMessageInfo.size), this.m_outboundMessageInfo.clear());
            }, SimpleStateServiceProxy.prototype.sendStateMessage = function(g) {
                this.sendStateMessageImpl(g);
            }, SimpleStateServiceProxy.prototype.createMapAsync = function(g, f, _, C) {
                return S(this, void 0, void 0, function() {
                    var S;
                    return v(this, function(v) {
                        return S = new xI.SimpleSyncMap(g, this, f, _, C), this.m_handlers.set(g, S), [
                            2,
                            S
                        ];
                    });
                });
            }, SimpleStateServiceProxy.prototype.getMapAsync = function(g) {
                return S(this, void 0, void 0, function() {
                    var f;
                    return v(this, function(S) {
                        return (f = this.m_handlers.get(g)) ? [
                            2,
                            f
                        ] : [
                            2,
                            null
                        ];
                    });
                });
            }, SimpleStateServiceProxy.prototype.waitMapAsync = function(g, f, _, C) {
                return S(this, void 0, void 0, function() {
                    var S;
                    return v(this, function(v) {
                        switch(v.label){
                            case 0:
                                return [
                                    4,
                                    this.m_initPromise.promise
                                ];
                            case 1:
                                return v.sent(), [
                                    4,
                                    this.getMapAsync(g)
                                ];
                            case 2:
                                return (S = v.sent()) ? [
                                    3,
                                    4
                                ] : [
                                    4,
                                    this.createMapAsync(g, f, _, C)
                                ];
                            case 3:
                                S = v.sent(), v.label = 4;
                            case 4:
                                return [
                                    2,
                                    S
                                ];
                        }
                    });
                });
            }, SimpleStateServiceProxy.prototype.createCellAsync = function(g, f, _, C) {
                return S(this, void 0, void 0, function() {
                    var S;
                    return v(this, function(v) {
                        return S = new LI.SimpleSyncCell(g, this, f, _, C), this.m_handlers.set(g, S), [
                            2,
                            S
                        ];
                    });
                });
            }, SimpleStateServiceProxy.prototype.getCellAsync = function(g) {
                return S(this, void 0, void 0, function() {
                    var f;
                    return v(this, function(S) {
                        return (f = this.m_handlers.get(g)) ? [
                            2,
                            f
                        ] : [
                            2,
                            null
                        ];
                    });
                });
            }, SimpleStateServiceProxy.prototype.waitCellAsync = function(g, f, _, C) {
                return S(this, void 0, void 0, function() {
                    var S;
                    return v(this, function(v) {
                        switch(v.label){
                            case 0:
                                return this.m_logger.sendTraceTag(520161040, hT.TraceLevel.Info, "SimpleStateServiceProxy::waitCellAsync - awaiting initPromise " + g), [
                                    4,
                                    this.m_initPromise.promise
                                ];
                            case 1:
                                return v.sent(), this.m_logger.sendTraceTag(520161039, hT.TraceLevel.Info, "SimpleStateServiceProxy::waitCellAsync - getCellAsync " + g), [
                                    4,
                                    this.getCellAsync(g)
                                ];
                            case 2:
                                return (S = v.sent()) ? [
                                    3,
                                    4
                                ] : (this.m_logger.sendTraceTag(520161038, hT.TraceLevel.Info, "SimpleStateServiceProxy::waitCellAsync - createCellAsync " + g), [
                                    4,
                                    this.createCellAsync(g, f, _, C)
                                ]);
                            case 3:
                                S = v.sent(), v.label = 4;
                            case 4:
                                return [
                                    2,
                                    S
                                ];
                        }
                    });
                });
            }, SimpleStateServiceProxy.prototype.onFocusChanged = function(g) {
                var f = this;
                g ? (window.clearTimeout(this.m_closeConnectionTimer), this.m_connection || (this.m_logger.sendTraceTag(590213392, hT.TraceLevel.Info, "SimpleStateServiceProxy::onFocusChanged - retryConnection due to getting focus again. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}"), this.retryConnection(function(g) {
                    f.m_logger.sendTraceTag(579463187, hT.TraceLevel.Error, "failed to reconnect after regaining focus: " + NI.errorToString(g));
                }, !0))) : this.m_closeConnectionTimer = window.setTimeout(function() {
                    var g;
                    f.m_connection && (f.m_logger.sendTraceTag(590213391, hT.TraceLevel.Info, "SimpleStateServiceProxy::onFocusChanged - " + (null === (g = f.m_connection) || void 0 === g ? void 0 : g.name) + " close due to losing focus. {sessionId: " + f.m_sessionId + ", ClientId: " + f.m_clientId + "}"), f.m_connection.onclose = function() {}, f.m_connection.close(), f.m_connection = null);
                }, this.m_connectionAliveTimeAfterLoseFocusInMS);
            }, SimpleStateServiceProxy.prototype.getHistoryAsync = function(g, f) {
                return S(this, void 0, void 0, function() {
                    var S, _;
                    return v(this, function(v) {
                        switch(v.label){
                            case 0:
                                return (S = new URL(this.m_deltasBaseUrl)).searchParams.append("action", "deltas"), S.searchParams.append("docId", this.m_sessionId), S.searchParams.append("cid", this.m_clientId), S.searchParams.append("objectId", g), f && S.searchParams.append("property", f), [
                                    4,
                                    T.default.get(S.toString())
                                ];
                            case 1:
                                return (_ = v.sent().data).forEach(function(g) {
                                    return g.value = JSON.parse(g.value);
                                }), [
                                    2,
                                    _
                                ];
                        }
                    });
                });
            }, SimpleStateServiceProxy.prototype.getHistoryWithPaginationAsync = function(g, f, _) {
                return S(this, void 0, void 0, function() {
                    var S, C;
                    return v(this, function(v) {
                        switch(v.label){
                            case 0:
                                return (S = new URL(this.m_deltasBaseUrl)).searchParams.append("action", "deltas"), S.searchParams.append("docId", this.m_sessionId), S.searchParams.append("cid", this.m_clientId), S.searchParams.append("objectId", g), S.searchParams.append("pagination", "true"), _ && S.searchParams.append("cursor", _), f && S.searchParams.append("property", f), [
                                    4,
                                    T.default.get(S.toString())
                                ];
                            case 1:
                                return (C = v.sent().data).messages.forEach(function(g) {
                                    return g.value = JSON.parse(g.value);
                                }), [
                                    2,
                                    C
                                ];
                        }
                    });
                });
            }, SimpleStateServiceProxy.prototype.setupSystemClientsCell = function() {
                var g = this;
                this.m_clientsCell = new LI.SimpleSyncCell("systemClients", this), this.m_handlers.set(this.m_clientsCell.id(), this.m_clientsCell), this.m_clientsCell.on("valueChanged", function(f) {
                    g.m_clientIds = new Set(f), g.m_events.emit("activeClientCountChanged");
                });
            }, SimpleStateServiceProxy.prototype.setUpSystemCommandsCell = function() {
                var g = this;
                this.m_systemCommandsCell = new LI.SimpleSyncCell(gT.SystemCommandsStateName, this), this.m_handlers.set(this.m_systemCommandsCell.id(), this.m_systemCommandsCell), this.m_systemCommandsCell.on("valueChanged", function(f) {
                    return S(g, void 0, void 0, function() {
                        var g, S, _;
                        return v(this, function(v) {
                            switch(v.label){
                                case 0:
                                    return "refreshToken" === f ? [
                                        3,
                                        1
                                    ] : [
                                        3,
                                        6
                                    ];
                                case 1:
                                    if (!this.m_user || !this.m_user.getForceRefreshedTokenAsync) return [
                                        3,
                                        5
                                    ];
                                    v.label = 2;
                                case 2:
                                    return v.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]), [
                                        4,
                                        this.m_user.getForceRefreshedTokenAsync()
                                    ];
                                case 3:
                                    return g = v.sent(), S = {}, g && (S.authorization = g.token, S.authProvider = g.authProvider, S.mri = g.mri || "", S.huid = g.hashedUserEmail || ""), this.sendConfigMessage(S), [
                                        3,
                                        5
                                    ];
                                case 4:
                                    return _ = v.sent(), this.m_logger.sendTraceTag(574107847, hT.TraceLevel.Error, "Error getting force refreshed auth token: " + NI.errorToString(_)), [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    return this.m_logger.sendTraceTag(574107848, hT.TraceLevel.Error, "Unknown system command cell value: " + f), [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            }, SimpleStateServiceProxy.prototype.setupServiceGeneratedClientIdCell = function() {
                var g = this;
                this.m_serviceGeneratedClientIdCell = new LI.SimpleSyncCell(gT.ServiceGeneratedClientIdName, this), this.m_handlers.set(this.m_serviceGeneratedClientIdCell.id(), this.m_serviceGeneratedClientIdCell), this.m_serviceGeneratedClientIdCell.on("valueChanged", function(f) {
                    g.m_logger.sendTraceTag(520161037, hT.TraceLevel.Info, "SimpleStateServiceProxy::serviceGeneratedClientId changed to " + f + "}"), g.setClientId(f, !0), g.processClientIdQueue(), g.m_useServiceGeneratedClientId && (g.processOfflineMessageCache(!0), g.clearOfflineMessageCacheTimer());
                }), this.m_logger.sendTraceTag(509743689, hT.TraceLevel.Info, "SimpleStateServiceProxy::setupServiceGeneratedClientIdCell completed.");
            }, SimpleStateServiceProxy.prototype.handleConnectionOpen = function() {
                var g;
                this.m_logger.sendTraceTag(590213387, hT.TraceLevel.Info, "SimpleStateServiceProxy::connect - " + (null === (g = this.m_connection) || void 0 === g ? void 0 : g.name) + " onopen. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}"), this.m_retryAttempts = 0, this.setConnectionState(gT.ConnectionState.Connected), this.startPingTimer(), this.m_useServiceGeneratedClientId || (this.processOfflineMessageCache(!1), this.clearOfflineMessageCacheTimer());
            }, SimpleStateServiceProxy.prototype.setConnectionState = function(g) {
                this.m_connectionState !== g && (this.m_connectionState = g, g === gT.ConnectionState.Disconnected && this.m_useServiceGeneratedClientId && this.setClientId("", !1), this.m_events.emit("connectionStateChanged"));
            }, SimpleStateServiceProxy.prototype.setClientId = function(g, f) {
                this.m_clientId !== g && (this.m_clientId = g, f && this.m_events.emit("clientIdChanged"));
            }, SimpleStateServiceProxy.prototype.processClientIdQueue = function() {
                var g = this;
                this.m_clientIdEvictingQueue && this.m_clientIdEvictingQueue.forEach(function(f) {
                    f.senderId = g.m_clientId, g.sendConnectionMessage(f, !0);
                });
            }, SimpleStateServiceProxy.prototype.sendGetInitialSystemStateMessages = function() {
                try {
                    var g = {
                        messageId: DI.v4(),
                        senderId: this.senderId(),
                        objectId: gT.SystemSessionStateName,
                        type: "",
                        operation: "get",
                        value: ""
                    };
                    this.sendStateMessage(g);
                    var f = {
                        messageId: DI.v4(),
                        senderId: this.senderId(),
                        objectId: gT.ServiceGeneratedClientIdName,
                        type: "",
                        operation: "get",
                        value: ""
                    };
                    this.sendStateMessage(f), this.m_logger.sendTraceTag(509141838, hT.TraceLevel.Info, "SimpleStateServiceProxy::sendGetInitialSystemStateMessages - sent messages.");
                } catch (g) {
                    this.m_logger.sendTraceTag(509141837, hT.TraceLevel.Error, "SimpleStateServiceProxy::sendGetInitialSystemStateMessages - caught error " + g);
                }
            }, SimpleStateServiceProxy.prototype.createSetupMessage = function(g) {
                var f = g.authToken, S = g.metadata, v = g.subscriptions, _ = [];
                if (f || S) {
                    var C = {};
                    f && (C.authorization = f.token, C.authProvider = f.authProvider, C.mri = f.mri || "", C.huid = f.hashedUserEmail || ""), S && (C.metadata = JSON.stringify(S));
                    var E = {
                        messageId: DI.v4(),
                        senderId: this.senderId(),
                        objectId: gT.ConfigurationName,
                        type: "",
                        operation: "",
                        value: JSON.stringify(C)
                    };
                    _.push(JSON.stringify(E));
                }
                if (v) {
                    E = {
                        messageId: DI.v4(),
                        senderId: this.senderId(),
                        objectId: gT.StateSubscriptionsName,
                        type: "",
                        operation: "",
                        value: JSON.stringify(v)
                    };
                    _.push(JSON.stringify(E));
                }
                return _;
            }, SimpleStateServiceProxy.prototype.sendConfigMessage = function(g) {
                var f = {
                    messageId: DI.v4(),
                    senderId: this.senderId(),
                    objectId: gT.ConfigurationName,
                    type: "",
                    operation: "",
                    value: JSON.stringify(g)
                };
                this.sendStateMessage(f);
            }, SimpleStateServiceProxy.prototype.retryConnection = function(g, f, _) {
                var C = this;
                if (this.clearPingPongTimer(), this.clearInitTimeoutTimer(), this.m_retryAttempts >= this.m_retryIntervalsInMs.length || this.m_sessionRetryAttempts >= this.m_maxSessionRetries) return this.setConnectionState(gT.ConnectionState.Disconnected), this.m_logger.sendTraceTag(590213393, hT.TraceLevel.Error, "SimpleStateServiceProxy::retryConnection reached max retry attempts. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}"), void (g && g(new Error("reached max retry attempts")));
                if (this.setConnectionState(gT.ConnectionState.Connecting), f || this.m_connection && !this.m_retryTimer) {
                    var E = this.m_retryIntervalsInMs[this.m_retryAttempts];
                    this.m_retryAttempts += 1, this.m_sessionRetryAttempts += 1, this.m_telemetry.wsReconnectCount += 1, this.closeAndClearConnection(), this.m_retryTimer = setTimeout(function() {
                        return S(C, void 0, void 0, function() {
                            var f;
                            return v(this, function(S) {
                                switch(S.label){
                                    case 0:
                                        this.m_logger.sendTraceTag(590213395, hT.TraceLevel.Info, "SimpleStateServiceProxy::retryConnection. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}"), this.m_retryTimer = null, S.label = 1;
                                    case 1:
                                        return S.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]), [
                                            4,
                                            this.connectAsync()
                                        ];
                                    case 2:
                                        return S.sent(), _ && _(), [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        return f = S.sent(), this.setConnectionState(gT.ConnectionState.Disconnected), this.m_logger.sendTraceTag(590213396, hT.TraceLevel.Error, "SimpleStateServiceProxy::retryConnection failed. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}, " + NI.errorToString(f)), this.m_retryAttempts >= this.m_retryIntervalsInMs.length && g(f), [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, E);
                } else this.m_logger.sendTraceTag(590213394, hT.TraceLevel.Info, "SimpleStateServiceProxy::retryConnection skipped. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", NullConnection: " + (null === this.m_connection) + ", NullRetryTimer: " + (null === this.m_retryTimer) + "}");
            }, SimpleStateServiceProxy.prototype.startPingTimer = function() {
                var g = this;
                this.m_connection && this.m_connection.shouldSendPings && (this.m_pingTimeoutInMs <= 0 || this.m_pongTimeoutInMs <= 0 || (this.clearPingPongTimer(), this.m_pingTimer = setTimeout(function() {
                    return S(g, void 0, void 0, function() {
                        return v(this, function(g) {
                            return this.sendPingMessage(), this.m_pingTimer = null, [
                                2
                            ];
                        });
                    });
                }, this.m_pingTimeoutInMs)));
            }, SimpleStateServiceProxy.prototype.sendPingMessage = function() {
                var g = this;
                this.m_connection && (this.m_connection.isOpen ? (this.m_verbose && this.m_logger.sendTraceTag(559952470, hT.TraceLevel.Info, "SimpleStateServiceProxy::sendPingMessage. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", __ping__"), this.m_connection.send("__ping__"), this.clearPongTimer(), this.m_pongTimer = setTimeout(function() {
                    return S(g, void 0, void 0, function() {
                        var g = this;
                        return v(this, function(f) {
                            return this.retryConnection(function(f) {
                                g.m_logger.sendTraceTag(579463188, hT.TraceLevel.Error, "failed to reconnect after missing ping: " + NI.errorToString(f));
                            }, !1), this.m_pongTimer = null, [
                                2
                            ];
                        });
                    });
                }, this.m_pongTimeoutInMs)) : (this.retryConnection(function(f) {
                    g.m_logger.sendTraceTag(579463189, hT.TraceLevel.Error, "failed to reconnect after closed connection: " + NI.errorToString(f));
                }, !1), this.clearPongTimer()));
            }, SimpleStateServiceProxy.prototype.clearPingPongTimer = function() {
                this.clearPingTimer(), this.clearPongTimer();
            }, SimpleStateServiceProxy.prototype.clearPingTimer = function() {
                this.m_pingTimer && (clearTimeout(this.m_pingTimer), this.m_pingTimer = null);
            }, SimpleStateServiceProxy.prototype.clearPongTimer = function() {
                this.m_pongTimer && (clearTimeout(this.m_pongTimer), this.m_pongTimer = null);
            }, SimpleStateServiceProxy.prototype.handleConnectionMessage = function(g) {
                if ("string" == typeof g.data) {
                    if (this.startPingTimer(), "__pong__" === g.data) return void (this.m_verbose && this.m_logger.sendTraceTag(559952471, hT.TraceLevel.Info, "SimpleStateServiceProxy::handleConnectionMessage. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", __pong__"));
                    var f = Date.now();
                    try {
                        var S = JSON.parse(g.data);
                        Array.isArray(S) && S.length > 0 ? this.handleAggregatedStateMessages(S) : this.handleStateMessage(S), this.m_telemetry.addMessageHandleLatency(Date.now() - f), S.objectId === gT.SystemSessionStateName ? (this.m_logger.sendTraceTag(520161036, hT.TraceLevel.Info, "SimpleStateServiceProxy::handleConnectionMessage - systemSessionState - initPromise resolved."), this.m_initPromise.resolve(), this.clearInitTimeoutTimer()) : S.objectId === gT.ServiceGeneratedClientIdName && this.m_logger.sendTraceTag(509743688, hT.TraceLevel.Info, "SimpleStateServiceProxy::handleConnectionMessage - serviceGeneratedClientId received.");
                    } catch (g) {
                        this.m_logger.sendTraceTag(578102302, hT.TraceLevel.Error, "handleConnectionMessage: " + NI.errorToString(g));
                    }
                } else this.m_logger.sendTraceTag(590213397, hT.TraceLevel.Error, "SimpleStateServiceProxy::handleConnectionMessage - Unknown data type. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", Type: " + typeof g.data + "}");
            }, SimpleStateServiceProxy.prototype.handleAggregatedStateMessages = function(g) {
                var f, S, v = this;
                if (g && 0 !== g.length) {
                    var _ = g.map(function(g) {
                        return JSON.parse(g);
                    }), E = {};
                    _.forEach(function(g) {
                        return E[g.objectId] = 1 + (E[g.objectId] || 0);
                    }), Object.keys(E).forEach(function(g) {
                        if (E[g] > 1) {
                            var f = v.m_handlers.get(g);
                            f && f.beginAggregatedStateUpdating && f.beginAggregatedStateUpdating();
                        }
                    });
                    try {
                        for(var T = C(_), I = T.next(); !I.done; I = T.next()){
                            var b = I.value;
                            this.handleStateMessage(b);
                        }
                    } catch (g) {
                        f = {
                            error: g
                        };
                    } finally{
                        try {
                            I && !I.done && (S = T.return) && S.call(T);
                        } finally{
                            if (f) throw f.error;
                        }
                    }
                    Object.keys(E).forEach(function(g) {
                        if (E[g] > 1) {
                            var f = v.m_handlers.get(g);
                            f && f.endAggregatedStateUpdating && f.endAggregatedStateUpdating();
                        }
                    });
                }
            }, SimpleStateServiceProxy.prototype.handleStateMessage = function(g) {
                var f = this;
                if (this.m_verbose && this.m_logger.sendTraceTag(590213398, hT.TraceLevel.Info, "SimpleStateServiceProxy::handleStateMessage. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", ObjectId: " + g.objectId + ", MessageId: " + g.messageId + "}"), "list" === g.type) JSON.parse(g.value).forEach(function(g) {
                    f.handleStateMessage(g);
                });
                else {
                    if (this.m_user && this.m_user.validateMessage && !this.m_user.validateMessage(g)) return void this.m_logger.sendTraceTag(588009742, hT.TraceLevel.Error, "SimpleStateServiceProxy::handleStateMessage rejected message: {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", ObjectId: " + g.objectId + ", MessageId: " + g.messageId + "}");
                    var S = this.getHandlerForMessage(g);
                    if (g.senderId === this.senderId() && (this.acknowledgeMessage(g, S), this.m_telemetry.incrementAcknowledgedCount(g.objectId)), this.measureMessageRoundTripLatency(g), this.m_telemetry.incrementReceivedCount(g.objectId), S) return void S.handleStateMessage(g);
                }
            }, SimpleStateServiceProxy.prototype.getAuthToken = function() {
                return S(this, void 0, void 0, function() {
                    var g, f;
                    return v(this, function(S) {
                        switch(S.label){
                            case 0:
                                if (!this.m_user || !this.m_user.getAuthTokenAsync) return [
                                    3,
                                    4
                                ];
                                S.label = 1;
                            case 1:
                                return S.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    this.m_user.getAuthTokenAsync()
                                ];
                            case 2:
                                return g = S.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                return f = S.sent(), this.m_logger.sendTraceTag(578102469, hT.TraceLevel.Error, "Error getting auth token: " + NI.errorToString(f)), [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2,
                                    g
                                ];
                        }
                    });
                });
            }, SimpleStateServiceProxy.prototype.getHandlerForMessage = function(g) {
                var f = this.m_handlers.get(g.objectId);
                return f || ("cell" === g.type ? f = new LI.SimpleSyncCell(g.objectId, this) : "map" === g.type ? f = new xI.SimpleSyncMap(g.objectId, this) : this.m_logger.sendTraceTag(559204164, hT.TraceLevel.Error, "SimpleStateServiceProxy::handleStateMessage - Unknown message type. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", Type: " + g.type + "}"), f && this.m_handlers.set(g.objectId, f), f);
            }, SimpleStateServiceProxy.prototype.sendStateMessageImpl = function(g) {
                var f, S = this;
                if (this.m_verbose && this.m_logger.sendTraceTag(590213403, hT.TraceLevel.Info, "SimpleStateServiceProxy::sendStateMessageImpl. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", ObjectId: " + g.objectId + ", MessageId: " + g.messageId + "}"), g.objectId !== gT.StateSubscriptionsName && g.objectId !== gT.ConfigurationName) {
                    if (this.m_outboundMessageInfo.set(g.messageId, Date.now()), this.m_telemetry.incrementRequestedCount(g.objectId), this.m_unacknowledgedMaxTimeInMs > 0) {
                        var v = null === (f = this.getHandlerForMessage(g)) || void 0 === f ? void 0 : f.messageTrackingOption();
                        if (v && v !== gT.MessageTrackingOption.None) {
                            var _ = this.getUnacknowledgedMessagesMapKey(g, v);
                            this.m_unacknowledgedMessages.set(_, {
                                message: g,
                                timestamp: Date.now()
                            }), this.startUnacknowledgeMessageTimer();
                        }
                    }
                    if (this.m_useServiceGeneratedClientId && this.m_clientIdEvictingQueue && !this.m_clientId && "get" !== g.operation) return this.m_logger.sendTraceTag(508348254, hT.TraceLevel.Info, "SimpleStateServiceProxy::enqueueMessage " + JSON.stringify(g)), void this.m_clientIdEvictingQueue.enqueue(g);
                }
                this.m_user && this.m_user.patchMessage && this.m_user.patchMessage(g), this.m_batchedRequestsEnabled ? (this.m_messageBuffer.push(g), this.m_processBufferTimer || (this.m_processBufferTimer = setTimeout(function() {
                    S.processMessageBuffer();
                }, this.m_batchWaitTimeMS))) : this.sendConnectionMessage(g, !0);
            }, SimpleStateServiceProxy.prototype.createListMessage = function(g) {
                if (0 !== g.length) return 1 === g.length ? g[0] : {
                    value: JSON.stringify(g),
                    type: this.m_batchMessageTypeName,
                    operation: "",
                    messageId: DI.v4(),
                    objectId: "batch",
                    senderId: this.senderId()
                };
            }, SimpleStateServiceProxy.prototype.processMessageBuffer = function() {
                var g = this.m_messageBuffer.length, f = this.m_messageBuffer.splice(0, g), S = this.createListMessage(f);
                this.m_processBufferTimer && clearTimeout(this.m_processBufferTimer), this.m_processBufferTimer = null, S && this.sendConnectionMessage(S, !0);
            }, SimpleStateServiceProxy.prototype.processOfflineMessageCache = function(g) {
                var f = this;
                this.m_offlineMessageCacheEnabled && (this.m_offlineMessageCache.forEach(function(S) {
                    g && (S.message.senderId = f.m_clientId), f.sendConnectionMessage(S.message, !1), f.m_telemetry.offlineCacheTelemetry.resentCount += 1;
                }), this.m_offlineMessageCache = []);
            }, SimpleStateServiceProxy.prototype.purgeOfflineMessageCache = function() {
                var g = this;
                if (this.m_offlineMessageCacheEnabled && this.m_maxOfflineMessageCacheTimeInMs) {
                    var f = Date.now(), S = this.m_offlineMessageCache.filter(function(S) {
                        return g.m_maxOfflineMessageCacheTimeInMs && S.timestamp + g.m_maxOfflineMessageCacheTimeInMs >= f;
                    });
                    this.m_telemetry.offlineCacheTelemetry.expiredCount += this.m_offlineMessageCache.length - S.length, this.m_offlineMessageCache = S, 0 === this.m_offlineMessageCache.length && this.clearOfflineMessageCacheTimer();
                }
            }, SimpleStateServiceProxy.prototype.clearOfflineMessageCacheTimer = function() {
                this.m_offlineMessageCacheEnabled && this.m_offlineMessageCacheTimer && (clearInterval(this.m_offlineMessageCacheTimer), this.m_offlineMessageCacheTimer = null);
            }, SimpleStateServiceProxy.prototype.getUnacknowledgedMessagesMapKey = function(g, f) {
                return f === gT.MessageTrackingOption.None ? "" : f === gT.MessageTrackingOption.All ? g.messageId : g.objectId;
            }, SimpleStateServiceProxy.prototype.startUnacknowledgeMessageTimer = function() {
                var g = this;
                this.m_unacknowledgedMaxTimeInMs > 0 && !this.m_unacknowledgedTimer && (this.m_unacknowledgedTimer = setInterval(function() {
                    g.notifyUnacknowledgedMessages(), g.m_unacknowledgedMessages.size <= 0 && g.clearUnacknowledgedTimer();
                }, this.m_unacknowledgedMaxTimeInMs / 2));
            }, SimpleStateServiceProxy.prototype.acknowledgeMessage = function(g, f) {
                if (g.senderId === this.senderId() && f && !(this.m_unacknowledgedMessages.size <= 0)) {
                    var S = this.getUnacknowledgedMessagesMapKey(g, f.messageTrackingOption()), v = this.m_unacknowledgedMessages.get(S);
                    v && g.messageId === v.message.messageId && this.m_unacknowledgedMessages.delete(S);
                }
            }, SimpleStateServiceProxy.prototype.notifyUnacknowledgedMessages = function() {
                var g = this, f = Date.now();
                this.m_unacknowledgedMessages.forEach(function(S, v) {
                    if (S.timestamp + g.m_unacknowledgedMaxTimeInMs < f) {
                        var _ = g.getHandlerForMessage(S.message);
                        null == _ || _.handleUnacknowledgedMessage(S.message), g.m_unacknowledgedMessages.delete(v), g.m_telemetry.unacknowledgedMessagesCount += 1;
                    }
                });
            }, SimpleStateServiceProxy.prototype.clearUnacknowledgedTimer = function() {
                this.m_unacknowledgedTimer && (clearInterval(this.m_unacknowledgedTimer), this.m_unacknowledgedTimer = null);
            }, SimpleStateServiceProxy.prototype.startInitTimeoutTimerWithRetry = function(g, f) {
                var S = this;
                this.startInitTimeoutTimer(g, function() {
                    S.m_logger.sendTraceTag(509141836, hT.TraceLevel.Error, "SimpleStateServiceProxy::startInitTimeoutTimer - failed to init after " + g + " ms; requesting get messages and retrying"), S.sendGetInitialSystemStateMessages(), S.startInitTimeoutTimer(g, f);
                });
            }, SimpleStateServiceProxy.prototype.startInitTimeoutTimer = function(g, f) {
                g > 0 && (this.clearInitTimeoutTimer(), this.m_initTimeoutTimer = setTimeout(function() {
                    f("Initialization timed out after " + g + " ms");
                }, g));
            }, SimpleStateServiceProxy.prototype.clearInitTimeoutTimer = function() {
                this.m_initTimeoutTimer && clearTimeout(this.m_initTimeoutTimer);
            }, SimpleStateServiceProxy.prototype.sendConnectionMessage = function(g, f) {
                var S, v, _ = this;
                if (this.m_allowReconnectOnMessageSend && this.m_connectionState === gT.ConnectionState.Disconnected && (this.updateRetryAttempts(), this.retryConnection(function(g) {
                    _.m_logger.sendTraceTag(559428289, hT.TraceLevel.Error, "SimpleStateServiceProxy::sendConnectionMessage - failed to reconnect with error: " + NI.errorToString(g) + " ");
                }, !1)), this.m_offlineMessageCacheEnabled && f) {
                    if (!this.m_connection || this.m_connectionState !== gT.ConnectionState.Connected) return !this.m_maxOfflineMessageCacheLength || this.m_offlineMessageCache.length >= this.m_maxOfflineMessageCacheLength ? (this.m_telemetry.offlineCacheTelemetry.rejectedCount += 1, void this.m_logger.sendTraceTag(570807006, hT.TraceLevel.Error, "SimpleStateServiceProxy::sendConnectionMessage - Dropping message because offline cache is full. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", Status: " + (null === (S = this.m_connection) || void 0 === S ? void 0 : S.readyState) + "}")) : (!this.m_offlineMessageCacheTimer && this.m_maxOfflineMessageCacheTimeInMs && (this.m_offlineMessageCacheTimer = setInterval(function() {
                        _.purgeOfflineMessageCache();
                    }, this.m_maxOfflineMessageCacheTimeInMs / 2)), this.m_offlineMessageCache.push({
                        message: g,
                        timestamp: Date.now()
                    }), void (this.m_telemetry.offlineCacheTelemetry.cachedCount += 1));
                } else {
                    if (!this.m_connection) return void this.m_logger.sendTraceTag(590213401, hT.TraceLevel.Error, "SimpleStateServiceProxy::sendConnectionMessage - connection is not set. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + "}");
                    if (!this.m_connection.isOpen) return void this.m_logger.sendTraceTag(590213402, hT.TraceLevel.Error, "SimpleStateServiceProxy::sendConnectionMessage - " + this.m_connection.name + " status is not open. {sessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", Status: " + this.m_connection.readyState + "}");
                }
                null === (v = this.m_connection) || void 0 === v || v.send(JSON.stringify(g));
            }, SimpleStateServiceProxy.prototype.closeAndClearConnection = function() {
                if (this.m_connection) {
                    if (this.m_connection.onclose = function() {}, this.m_connection.isOpen) this.m_connection.close();
                    else {
                        var g = this.m_connection;
                        g.onopen = function() {
                            return g.close();
                        };
                    }
                    this.m_connection = null;
                }
            }, SimpleStateServiceProxy.prototype.updateRetryAttempts = function() {
                this.m_retryAttempts >= this.m_retryIntervalsInMs.length && (this.m_retryAttempts = 0), this.m_sessionRetryAttempts >= this.m_maxSessionRetries && (this.m_sessionRetryAttempts = 0);
            }, SimpleStateServiceProxy.prototype.measureMessageRoundTripLatency = function(g) {
                if (g.senderId === this.senderId()) try {
                    var f = this.m_outboundMessageInfo.get(g.messageId);
                    if (void 0 !== f) {
                        this.m_outboundMessageInfo.delete(g.messageId);
                        var S = Date.now() - f;
                        this.m_events.emit("messageRoundTripped", {
                            clientId: this.m_clientId,
                            sessionId: this.m_sessionId,
                            messageId: g.messageId,
                            objectId: g.objectId,
                            operation: g.operation,
                            latencyInMs: S
                        }), this.m_telemetry.addRoundtripLatency(S);
                    } else this.m_verbose && this.m_logger.sendTraceTag(590213404, hT.TraceLevel.Info, "SimpleStateServiceProxy::measureMessageRoundTripLatency. Failed to find outbound message info for {SessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", ObjectId: " + g.objectId + ", MessageId: " + g.messageId + "}");
                } catch (f) {
                    this.m_logger.sendTraceTag(590213405, hT.TraceLevel.Error, "SimpleStateServiceProxy::measureMessageRoundTripLatency - Exception thrown error. {SessionId: " + this.m_sessionId + ", ClientId: " + this.m_clientId + ", MessageId: " + g.messageId + ", Error: " + f.message + "}");
                }
            }, SimpleStateServiceProxy;
        }();
        f.SimpleStateServiceProxy = A;
    }), HI = createCommonjsModule(function(g, f) {
        var S = _ && _.__awaiter || function(g, f, S, v) {
            function adopt(g) {
                return g instanceof S ? g : new S(function(f) {
                    f(g);
                });
            }
            return new (S || (S = Promise))(function(S, _) {
                function fulfilled(g) {
                    try {
                        step(v.next(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function rejected(g) {
                    try {
                        step(v.throw(g));
                    } catch (g) {
                        _(g);
                    }
                }
                function step(g) {
                    g.done ? S(g.value) : adopt(g.value).then(fulfilled, rejected);
                }
                step((v = v.apply(g, f || [])).next());
            });
        }, v = _ && _.__generator || function(g, f) {
            var S, v, _, C, E = {
                label: 0,
                sent: function() {
                    if (1 & _[0]) throw _[1];
                    return _[1];
                },
                trys: [],
                ops: []
            };
            return C = {
                next: verb(0),
                throw: verb(1),
                return: verb(2)
            }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                return this;
            }), C;
            function verb(g) {
                return function(f) {
                    return step([
                        g,
                        f
                    ]);
                };
            }
            function step(C) {
                if (S) throw new TypeError("Generator is already executing.");
                for(; E;)try {
                    if (S = 1, v && (_ = 2 & C[0] ? v.return : C[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, C[1])).done) return _;
                    switch(v = 0, _ && (C = [
                        2 & C[0],
                        _.value
                    ]), C[0]){
                        case 0:
                        case 1:
                            _ = C;
                            break;
                        case 4:
                            return E.label++, {
                                value: C[1],
                                done: !1
                            };
                        case 5:
                            E.label++, v = C[1], C = [
                                0
                            ];
                            continue;
                        case 7:
                            C = E.ops.pop(), E.trys.pop();
                            continue;
                        default:
                            if (!(_ = E.trys, (_ = _.length > 0 && _[_.length - 1]) || 6 !== C[0] && 2 !== C[0])) {
                                E = 0;
                                continue;
                            }
                            if (3 === C[0] && (!_ || C[1] > _[0] && C[1] < _[3])) {
                                E.label = C[1];
                                break;
                            }
                            if (6 === C[0] && E.label < _[1]) {
                                E.label = _[1], _ = C;
                                break;
                            }
                            if (_ && E.label < _[2]) {
                                E.label = _[2], E.ops.push(C);
                                break;
                            }
                            _[2] && E.ops.pop(), E.trys.pop();
                            continue;
                    }
                    C = f.call(g, E);
                } catch (g) {
                    C = [
                        6,
                        g
                    ], v = 0;
                } finally{
                    S = _ = 0;
                }
                if (5 & C[0]) throw C[1];
                return {
                    value: C[0] ? C[1] : void 0,
                    done: !0
                };
            }
        };
        function createStateServiceProxyAsync(g, f, _, C, E, T) {
            return S(this, void 0, void 0, function() {
                var S;
                return v(this, function(v) {
                    switch(v.label){
                        case 0:
                            return [
                                4,
                                (S = new BI.SimpleStateServiceProxy(g, f, _, C, E, T)).connectAsync()
                            ];
                        case 1:
                            return v.sent(), [
                                2,
                                S
                            ];
                    }
                });
            });
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.createStateServiceProxyAsync = void 0, f.createStateServiceProxyAsync = createStateServiceProxyAsync;
    }), $I = createCommonjsModule(function(g, f) {
        var S = _ && _.__createBinding || (Object.create ? function(g, f, S, v) {
            void 0 === v && (v = S), Object.defineProperty(g, v, {
                enumerable: !0,
                get: function() {
                    return f[S];
                }
            });
        } : function(g, f, S, v) {
            void 0 === v && (v = S), g[v] = f[S];
        }), v = _ && _.__exportStar || function(g, f) {
            for(var v in g)"default" === v || f.hasOwnProperty(v) || S(f, g, v);
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), v(hT, f), v(gT, f), v(HI, f);
    });
    class ReactionLogger {
        sendTraceTag(g, f, S) {
            this.enableConsoleLog && this._logger.info(`Tag: ${g}, Leve: ${f}, Message: ${S}`);
        }
        constructor(g){
            this.enableConsoleLog = getAcsEcsConfig().calling.reaction.enableStateServiceConsoleLogs, this._logger = g;
        }
    }
    class ReactionFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "Reaction";
        }
        initialize(g, f) {
            this._tsCall = g.tsCall, this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._logger.info(`Meeting Reaction feature enable flag: ${this._isReactionFeatureEnabled}`), this._isReactionFeatureEnabled && 3 === g.tsCall.state ? this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f, this._callInfo) : g.tsCall.on("callStateChanged", ()=>{
                this._isReactionFeatureEnabled && 3 === g.tsCall.state ? this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f, this._callInfo) : this._logger.warn("Calls to reaction APIs will perform no action or return default values where applicable");
            });
        }
        async sendReaction(g) {
            let f = generateGuid();
            if (this._sendFeatureUsage("sendReaction", uy.attempt, void 0, f), 3 != this._tsCall.state || this.callInfo.context === BS.TwoParty) {
                const g = new CallingCommunicationError({
                    defaultError: 3 != this._tsCall.state ? O.FEATURES.REACTION.CALL_NOT_CONNECTED : O.FEATURES.REACTION.NOT_SUPPORTED_1TO1_CTE
                });
                throw this._sendFeatureUsage("sendReaction", uy.failure, g, f), g;
            }
            await this._impl.sendReaction(g, f);
        }
        on(g, f) {
            if ("reaction" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.REACTION.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            if (!this._isReactionFeatureEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.EVENT_SUBSCRIBE_FAIL_POLICY
                });
                throw this._sendFeatureUsage("receiveReaction", uy.failure, g), g;
            }
            this._sendFeatureUsage("receiveReaction", uy.subscribe), this._impl.on(g, f);
        }
        off(g, f) {
            if ("reaction" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.REACTION.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            if (!this._isReactionFeatureEnabled) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.EVENT_UNSUBSCRIBE_FAIL_POLICY
                });
                throw this._sendFeatureUsage("receiveReaction", uy.failure, g), g;
            }
            this._sendFeatureUsage("receiveReaction", uy.unsubscribe), this._impl.off(g, f);
        }
        dispose() {
            this.disposed || (this._impl.dispose(), super.dispose());
        }
        _sendFeatureUsage(g, f, S, v) {
            let _ = S ? {
                code: (S === null || S === void 0 ? void 0 : S.code) || x,
                subCode: (S === null || S === void 0 ? void 0 : S.subCode) || 0,
                failureReason: (S === null || S === void 0 ? void 0 : S.message) || "",
                ...extractCommunicationServicesErrorForTelemetry(S)
            } : void 0;
            sendCallFeatureUsageTelemetry({
                correlationId: v,
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: this.name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: _
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g), this._impl = new ReactionImplOverStateService(this.eventEmitter), this._isReactionFeatureEnabled = getAcsEcsConfig().calling.reaction.enabled, this._callInfo = g.callInfo;
        }
    }
    class ReactionImplOverStateService {
        initialize(g, f, S, v, _, C) {
            var _this__proxy;
            void 0 === this._proxy || ((_this__proxy = this._proxy) === null || _this__proxy === void 0 ? void 0 : _this__proxy.getConnectionState()) === $I.ConnectionState.Disconnected ? (this._logger = _.createChild(()=>`ReactionImplOverStateService::Call(id='${this._tsCall.callId}')`), this._internalCallAgent = f, this._tsCall = g, this._call = S, this._callInfo = C, this._docId = this._tsCall.callId, this._wsUrl = this.getEndpointUrl(), this._telemetryLogManager = v, this._sendAttempOrFailureFeatureUsage("initialize", uy.attempt), this.start()) : _.info("State Service Proxy already has an active connection."), this._callInfo.context == BS.TeamsMeeting && (this._participantCapability = this._call.getParticipantCapabilities().useReactions, this._logger.log(`participant capabilitity to useReactions feature is ${this._participantCapability}`), this._call.onParticipantCapabilitiesChanged("capabilitiesChanged", this.capabilityChangeHandler), this._logger.log("participant capabilities change event listener registered"));
        }
        async start() {
            var _this__reactionsMap;
            const g = getAcsEcsConfig().calling.reaction.StateServiceProxySettings, f = Wf, S = {
                getAuthTokenAsync: this.getAuthToken.bind(this)
            };
            try {
                this._proxy = await $I.createStateServiceProxyAsync(this._docId, f, this._wsUrl, new ReactionLogger(this._logger), g, S);
            } catch (g) {
                return this._logger.error("Could not create state service proxy", g), void this._sendAttempOrFailureFeatureUsage("initialize", uy.failure, new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.STATE_SERVICE_CONNECT_FAIL,
                    originalError: g
                }));
            }
            try {
                this._reactionsMap = await this._proxy.createMapAsync("reactions", !0);
            } catch (g) {
                return this._logger.error("Could not create state service proxy reaction map", g), void this._sendAttempOrFailureFeatureUsage("initialize", uy.failure, new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.MAP_CREATE_FAIL,
                    originalError: g
                }));
            }
            this._sendSuccessFeatureUsage("initialize", uy.success), (_this__reactionsMap = this._reactionsMap) === null || _this__reactionsMap === void 0 ? void 0 : _this__reactionsMap.on("valueChanged", this.onReactionsReceived.bind(this));
        }
        async getAuthToken() {
            const g = {
                token: await this._internalCallAgent.tokenProvider(),
                authProvider: "SKYPE",
                mri: this._internalCallAgent.getUserMri()
            };
            return Promise.resolve(g);
        }
        async sendReaction(g, f) {
            if (!this._isReactionFeatureEnabled || !this._participantCapability.isPresent) {
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.SEND_FAIL_POLICY
                });
                throw this._sendAttempOrFailureFeatureUsage("sendReaction", uy.failure, g, f), g;
            }
            if (!this._reactionsMap) {
                this._logger.error("Reaction Map has not yet been initialized.");
                const g = new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.NOT_INIT_YET
                });
                throw this._sendAttempOrFailureFeatureUsage("sendReaction", uy.failure, g, f), g;
            }
            try {
                var _this__reactionsMap;
                return (_this__reactionsMap = this._reactionsMap) === null || _this__reactionsMap === void 0 ? void 0 : _this__reactionsMap.set(this._internalCallAgent.getUserMri(), {
                    name: g.reactionType
                }), void this._sendSuccessFeatureUsage("sendReaction", uy.success, f, g.reactionType);
            } catch (g) {
                this._logger.error("Unable to send reaction", g);
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.REACTION.SEND_REACTION_FAIL,
                    originalError: g
                });
                throw this._sendAttempOrFailureFeatureUsage("sendReaction", uy.failure, S, f), S;
            }
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        async onReactionsReceived(g) {
            if (3 === this._tsCall.state && this._participantCapability.isPresent) {
                const f = generateGuid();
                this._sendAttempOrFailureFeatureUsage("receiveReaction", uy.attempt, void 0, f);
                try {
                    var _this__reactionsMap;
                    const S = {
                        reactionType: (await ((_this__reactionsMap = this._reactionsMap) === null || _this__reactionsMap === void 0 ? void 0 : _this__reactionsMap.get(g))).name
                    };
                    this._eventEmitter.emit("reaction", {
                        identifier: g,
                        reactionMessage: S
                    }), this._sendSuccessFeatureUsage("receiveReaction", uy.success, f, S.reactionType);
                } catch (g) {
                    this._logger.error("Unable to parse reaction", g);
                    let S = new CallingCommunicationError({
                        defaultError: O.FEATURES.REACTION.RECEIVE_REACTION_FAIL,
                        originalError: g
                    });
                    this._sendAttempOrFailureFeatureUsage("receiveReaction", uy.failure, S, f);
                }
            }
        }
        dispose() {
            var _this__proxy, _this__reactionsMap;
            void 0 !== this._telemetryLogManager && (((_this__proxy = this._proxy) === null || _this__proxy === void 0 ? void 0 : _this__proxy.getConnectionState()) === $I.ConnectionState.Connected ? ((_this__reactionsMap = this._reactionsMap) === null || _this__reactionsMap === void 0 ? void 0 : _this__reactionsMap.removeAllListeners("valueChanged"), this._proxy.close(), this._sendSuccessFeatureUsage("dispose", uy.success), this._call.offParticipantCapabilitiesChanged("capabilitiesChanged", this.capabilityChangeHandler)) : this._sendSuccessFeatureUsage("dispose", uy.failure));
        }
        _sendAttempOrFailureFeatureUsage(g, f, S, v) {
            let _ = S ? {
                code: (S === null || S === void 0 ? void 0 : S.code) || x,
                subCode: (S === null || S === void 0 ? void 0 : S.subCode) || 0,
                failureReason: (S === null || S === void 0 ? void 0 : S.message) || "",
                ...extractCommunicationServicesErrorForTelemetry(S)
            } : void 0;
            sendCallFeatureUsageTelemetry({
                correlationId: v,
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: this.name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: _
            }, this._telemetryLogManager, this._logger);
        }
        _sendSuccessFeatureUsage(g, f, S, v) {
            let _;
            _ = "initialize" === g || "dispose" == g ? void 0 : {
                reactionConstraint: {
                    reactionType: v
                }
            }, sendCallFeatureUsageTelemetry({
                correlationId: S,
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: this.name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: _
            }, this._telemetryLogManager, this._logger);
        }
        getEndpointUrl() {
            const g = this._internalCallAgent._caConfigBag, f = g && isEudbConfigurationsApplicable(g.identityType, g.region);
            var S = getAcsEcsConfig().PowerPointStateServiceUrl.public.amer;
            switch(g === null || g === void 0 ? void 0 : g.cloudType){
                case rm.Public:
                    f && (S = getAcsEcsConfig().PowerPointStateServiceUrl.public.eu);
                    break;
                case rm.GccHigh:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.gcch;
                    break;
                case rm.AirGap08:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.ag08;
                    break;
                case rm.AirGap09:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.ag09;
                    break;
                case rm.Dod:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.dod;
                    break;
                default:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.public.amer;
            }
            return `wss://${new URL(S).hostname}/StateServiceHandler.ashx`;
        }
        constructor(g){
            this._wsUrl = "", this.name = "Reaction", this.capabilityChangeHandler = (g)=>{
                g.newValue.useReactions && (this._participantCapability = this._call.getParticipantCapabilities().useReactions, this._logger.log(`participant capabilitity to useReactions feature is ${this._participantCapability}`));
            }, this._eventEmitter = g, this._participantCapability = {
                isPresent: !0,
                reason: "Capable"
            }, this._isReactionFeatureEnabled = getAcsEcsConfig().calling.reaction.enabled;
        }
    }
    class ContentSharingSession {
        get contentSharingSession() {
            return this._contentSharingSession;
        }
        getFileDetails() {
            if (this.contentSharingSession) return JSON.parse(atob(this.contentSharingSession.contentSharingIdentity));
        }
        constructor(g){
            this._contentSharingSession = g;
        }
    }
    const jI = "azure_communication_calling_pptLive";
    class PPTLiveCallFeatureImpl extends FirstPartyCallFeature {
        on(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        get isActive() {
            return this._impl.isActive;
        }
        get target() {
            return this._impl.target;
        }
        get activePresenterId() {
            return this._impl.activePresenterId;
        }
        get name() {
            return "PPTLive";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(g.tsCall, g.callAgent, g.telemetryLogManager, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: g,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._impl = new PPTLiveCallImplOverTsCall(this.eventEmitter);
        }
    }
    class PPTLiveCallImplOverTsCall {
        initialize(g, f, S, v) {
            this._logger = v.createChild(()=>`PPTLive::Call(id='${g.callId}')`), this._tsCall = g, this._internalCallAgent = f, this._telemetryLogManager = S, this._tsCall.on("contentSharingChanged", ()=>{
                this._checkContentSharingSession(this._tsCall.contentSharingSessions);
            }), this._tsCall.on("callStateChanged", ()=>{
                this._updatePPTLive(this._tsCall.state);
            });
        }
        get isActive() {
            return this._isActive;
        }
        get target() {
            return this._target;
        }
        get activePresenterId() {
            return this._activePresenterId;
        }
        _checkContentSharingSession(g) {
            if (this._contentSharing && 0 === g.length) this._updateIsActive(!1), this._contentSharing = void 0, this._target.innerHTML = "", this._isInitializingPPTLive = !1, this._eventEmitter.emit("isActiveChanged"), this._sendFeatureUsage("endedPPTLive", uy.success);
            else if (!this._contentSharing && 0 !== g.length) {
                var _this__contentSharing_contentSharingSession, _this__contentSharing;
                if (!getAcsEcsConfig().calling.pptlive.enabled) return;
                this._contentSharing = new ContentSharingSession(g[0]), this._updatePPTLive(this._tsCall.state), this._sendFeatureUsage("startedPPTLive", uy.attempt, (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingGuid);
            }
        }
        async _updatePPTLive(g) {
            var _this__contentSharing;
            this._fileDetails = (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : _this__contentSharing.getFileDetails(), this._fileDetails && "ppt" === this._fileDetails.type && 3 === g && await this._startPPTLive(this._target);
        }
        _updateActivePresenter() {
            this._tsCall.participants.forEach((g)=>{
                const f = constructIdentifierKindFromMri(g.id);
                2 === g.contentSharingRole && (this._activePresenterId = f);
            });
        }
        _sendFeatureUsage(g, f, S) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "PPTLive",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: {
                    pptLiveConstraint: {
                        contentId: S
                    }
                }
            }, this._telemetryLogManager, this._logger);
        }
        _observeDivMount() {
            const g = new MutationObserver(async (f)=>{
                if (this._isActive && !this._isInitializingPPTLive) for (const S of f)for(let f = 0; f < S.addedNodes.length; f++){
                    const v = S.addedNodes[f];
                    if (v.nodeType === Node.ELEMENT_NODE) {
                        if (v.matches(`#${jI}`)) {
                            await this._startPPTLive(this._target), g.disconnect();
                            break;
                        }
                    }
                }
                else g.disconnect();
            });
            g.observe(document.body, {
                childList: !0,
                subtree: !0
            });
        }
        _initViewerWithExperiment(g, f, S, v, _, C, E, T, I, b, A, R, P, w, M) {
            var _this__contentSharing_contentSharingSession, _this__contentSharing;
            const O = {
                getAuthTokenAsync: !1,
                getForceRefreshedTokenAsync: !1
            }, D = window.Microsoft, OnInitSuccess = (g)=>{
                var _this__contentSharing_contentSharingSession, _this__contentSharing;
                g.GoToSlide(f, [], ""), this._isInitializingPPTLive = !1, this._observeDivMount(), this._sendFeatureUsage("startedPPTLive", uy.success, (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingGuid);
            }, OnInitFailure = (g)=>{
                var _this__contentSharing_contentSharingSession, _this__contentSharing;
                this._isInitializingPPTLive = !1;
                var f = "Category: " + g.Category + "\nMessage: " + g.Message + "\nExtraInfo: " + g.ExtraInfo;
                this._sendFeatureUsage("startedPPTLive", uy.failure, (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingGuid), this._logger.error(f);
            }, N = getAcsEcsConfig().calling.pptlive, k = {
                entryPoint: "null"
            }, L = {
                Container: g,
                SessionInformation: {
                    DocumentClickTime: new Date,
                    HostInitTime: new Date,
                    UiLocale: R,
                    DataLocale: R,
                    IsPresenter: !1,
                    WdParams: {
                        wdModernSlideShowInTeams: N.wdParams.wdModernSlideShowInTeams,
                        wdPresenterViewInTeams: N.wdParams.wdPresenterViewInTeams,
                        wdForceModernSlideShowInTeams: N.wdParams.wdForceModernSlideShowInTeams,
                        isMovePrivateViewingToPPTEnabled: N.wdParams.isMovePrivateViewingToPPTEnabled
                    },
                    PptFeatureGates: N.featureGates,
                    ParticipantId: T,
                    EnableStateServiceInPreviewerFeatures: JSON.parse(N.enableStateServiceInPreviewerFeatures),
                    StateServiceSettings: {
                        stateServiceProxySettings: N.stateServiceProxySettings,
                        regionalEndpointUrl: this._getEndpointUrl(),
                        authEnabled: !1,
                        rosterCheckEnabled: !1,
                        stateServiceUser: O
                    },
                    ContentId: P,
                    EndpointId: E,
                    CallId: w,
                    HostName: "ACSWeb",
                    HostSessionId: I
                },
                WopiPrecheckInfo: {
                    FileName: v,
                    FileGetUrl: C,
                    FileSize: _,
                    CustomFontCatalogUrl: M,
                    BundleInfo: {
                        MajorVersion: S,
                        Url: b
                    },
                    CreateNewInfo: null
                },
                ApplicationCustomSettings: {
                    TakeFocusOnBoot: N.appSettings.takeFocusOnBoot,
                    EnableAdvanceOnClick: N.appSettings.enableAdvanceOnClick,
                    EnableAdvanceOnTap: N.appSettings.enableAdvanceOnTap
                },
                Diagnostics: k,
                FnOnInitializeSuccess: OnInitSuccess,
                FnOnInitializeFailure: OnInitFailure
            };
            A && (L.ApplicationCustomSettings.EnableWacFallback = !1, L.ApplicationUrl = A), D.Office.PowerPoint.Bootstrap.Prefetch(), D.Office.PowerPoint.Bootstrap.InitializeWopiPending(L), this._updateActivePresenter(), this._updateIsActive(!0), this._eventEmitter.emit("isActiveChanged"), this._sendFeatureUsage("startedPPTLive", uy.initialize, (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingGuid);
        }
        async _startPPTLive(g) {
            var _this__fileDetails;
            ((_this__fileDetails = this._fileDetails) === null || _this__fileDetails === void 0 ? void 0 : _this__fileDetails.bootstrapperUrl) && (this._isInitializingPPTLive = !0, g.innerHTML = "", await this._loadDynamicModule(this._fileDetails.bootstrapperUrl).then(()=>{
                var _this__contentSharing_contentSharingSession, _this__contentSharing;
                this._fileDetails && this._initViewerWithExperiment(g, Number((_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingState), this._fileDetails.majorVersion, this._fileDetails.name, this._fileDetails.fileSize, this._fileDetails.fileGetUrl, this._tsCall.endpointId, this._tsCall.participantId, generateGuid(), this._fileDetails.contentBundleUrl, this._fileDetails.wacUrl, navigator.language, this._fileDetails.id, this._tsCall.callId, this._fileDetails.customFontCatalogUrl);
            }).catch(()=>{
                var _this__contentSharing_contentSharingSession, _this__contentSharing;
                this._sendFeatureUsage("startedPPTLive", uy.failure, (_this__contentSharing = this._contentSharing) === null || _this__contentSharing === void 0 ? void 0 : (_this__contentSharing_contentSharingSession = _this__contentSharing.contentSharingSession) === null || _this__contentSharing_contentSharingSession === void 0 ? void 0 : _this__contentSharing_contentSharingSession.contentSharingGuid);
            }));
        }
        _getEndpointUrl() {
            const g = this._internalCallAgent._caConfigBag, f = g && isEudbConfigurationsApplicable(g.identityType, g.region);
            let S = getAcsEcsConfig().PowerPointStateServiceUrl.public.amer;
            switch(g === null || g === void 0 ? void 0 : g.cloudType){
                case rm.Public:
                    f && (S = getAcsEcsConfig().PowerPointStateServiceUrl.public.eu);
                    break;
                case rm.GccHigh:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.gcch;
                    break;
                case rm.AirGap08:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.ag08;
                    break;
                case rm.AirGap09:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.ag09;
                    break;
                case rm.Dod:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.dod;
                    break;
                default:
                    S = getAcsEcsConfig().PowerPointStateServiceUrl.public.amer;
            }
            return S;
        }
        async _loadDynamicModule(g) {
            return new Function(`return (async () => await import('${g}'))()`)();
        }
        constructor(g){
            this._isActive = !1, this._isInitializingPPTLive = !1, this._updateIsActive = (g)=>this._isActive !== g && (this._isActive = g, this._logger.info(`Updating isActive to ${g}`), !0), this._eventEmitter = g, this._target = document.createElement("div"), this._target.id = jI, this._target.style.width = "100%", this._target.style.height = "100%";
        }
    }
    const GI = 1.778, qI = 255, WI = 2, zI = 1280, KI = 720;
    var JI;
    !function(g) {
        g.sceneChanged = "sceneChanged", g.seatingChanged = "seatingChanged";
    }(JI || (JI = {}));
    for(var YI = byteLength, QI = toByteArray, XI = fromByteArray, ZI = [], eb = [], tb = "undefined" != typeof Uint8Array ? Uint8Array : Array, ib = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", nb = 0, rb = ib.length; nb < rb; ++nb)ZI[nb] = ib[nb], eb[ib.charCodeAt(nb)] = nb;
    function getLens(g) {
        var f = g.length;
        if (f % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
        var S = g.indexOf("=");
        return -1 === S && (S = f), [
            S,
            S === f ? 0 : 4 - S % 4
        ];
    }
    function byteLength(g) {
        var f = getLens(g), S = f[0], v = f[1];
        return 3 * (S + v) / 4 - v;
    }
    function _byteLength(g, f, S) {
        return 3 * (f + S) / 4 - S;
    }
    function toByteArray(g) {
        var f, S, v = getLens(g), _ = v[0], C = v[1], E = new tb(_byteLength(g, _, C)), T = 0, I = C > 0 ? _ - 4 : _;
        for(S = 0; S < I; S += 4)f = eb[g.charCodeAt(S)] << 18 | eb[g.charCodeAt(S + 1)] << 12 | eb[g.charCodeAt(S + 2)] << 6 | eb[g.charCodeAt(S + 3)], E[T++] = f >> 16 & 255, E[T++] = f >> 8 & 255, E[T++] = 255 & f;
        return 2 === C && (f = eb[g.charCodeAt(S)] << 2 | eb[g.charCodeAt(S + 1)] >> 4, E[T++] = 255 & f), 1 === C && (f = eb[g.charCodeAt(S)] << 10 | eb[g.charCodeAt(S + 1)] << 4 | eb[g.charCodeAt(S + 2)] >> 2, E[T++] = f >> 8 & 255, E[T++] = 255 & f), E;
    }
    function tripletToBase64(g) {
        return ZI[g >> 18 & 63] + ZI[g >> 12 & 63] + ZI[g >> 6 & 63] + ZI[63 & g];
    }
    function encodeChunk(g, f, S) {
        for(var v, _ = [], C = f; C < S; C += 3)v = (g[C] << 16 & 16711680) + (g[C + 1] << 8 & 65280) + (255 & g[C + 2]), _.push(tripletToBase64(v));
        return _.join("");
    }
    function fromByteArray(g) {
        for(var f, S = g.length, v = S % 3, _ = [], C = 16383, E = 0, T = S - v; E < T; E += C)_.push(encodeChunk(g, E, E + C > T ? T : E + C));
        return 1 === v ? (f = g[S - 1], _.push(ZI[f >> 2] + ZI[f << 4 & 63] + "==")) : 2 === v && (f = (g[S - 2] << 8) + g[S - 1], _.push(ZI[f >> 10] + ZI[f >> 4 & 63] + ZI[f << 2 & 63] + "=")), _.join("");
    }
    eb["-".charCodeAt(0)] = 62, eb["_".charCodeAt(0)] = 63;
    var ab = {
        byteLength: YI,
        toByteArray: QI,
        fromByteArray: XI
    }, read = function(g, f, S, v, _) {
        var C, E, T = 8 * _ - v - 1, I = (1 << T) - 1, b = I >> 1, A = -7, R = S ? _ - 1 : 0, P = S ? -1 : 1, w = g[f + R];
        for(R += P, C = w & (1 << -A) - 1, w >>= -A, A += T; A > 0; C = 256 * C + g[f + R], R += P, A -= 8);
        for(E = C & (1 << -A) - 1, C >>= -A, A += v; A > 0; E = 256 * E + g[f + R], R += P, A -= 8);
        if (0 === C) C = 1 - b;
        else {
            if (C === I) return E ? NaN : 1 / 0 * (w ? -1 : 1);
            E += Math.pow(2, v), C -= b;
        }
        return (w ? -1 : 1) * E * Math.pow(2, C - v);
    }, write = function(g, f, S, v, _, C) {
        var E, T, I, b = 8 * C - _ - 1, A = (1 << b) - 1, R = A >> 1, P = 23 === _ ? Math.pow(2, -24) - Math.pow(2, -77) : 0, w = v ? 0 : C - 1, M = v ? 1 : -1, O = f < 0 || 0 === f && 1 / f < 0 ? 1 : 0;
        for(f = Math.abs(f), isNaN(f) || f === 1 / 0 ? (T = isNaN(f) ? 1 : 0, E = A) : (E = Math.floor(Math.log(f) / Math.LN2), f * (I = Math.pow(2, -E)) < 1 && (E--, I *= 2), (f += E + R >= 1 ? P / I : P * Math.pow(2, 1 - R)) * I >= 2 && (E++, I /= 2), E + R >= A ? (T = 0, E = A) : E + R >= 1 ? (T = (f * I - 1) * Math.pow(2, _), E += R) : (T = f * Math.pow(2, R - 1) * Math.pow(2, _), E = 0)); _ >= 8; g[S + w] = 255 & T, w += M, T /= 256, _ -= 8);
        for(E = E << _ | T, b += _; b > 0; g[S + w] = 255 & E, w += M, E /= 256, b -= 8);
        g[S + w - M] |= 128 * O;
    }, sb = {
        read: read,
        write: write
    }, ob = {}.toString, lb = Array.isArray || function(g) {
        return "[object Array]" == ob.call(g);
    }, cb = createCommonjsModule(function(g, f) {
        function typedArraySupport() {
            try {
                var g = new Uint8Array(1);
                return g.__proto__ = {
                    __proto__: Uint8Array.prototype,
                    foo: function() {
                        return 42;
                    }
                }, 42 === g.foo() && "function" == typeof g.subarray && 0 === g.subarray(1, 1).byteLength;
            } catch (g) {
                return !1;
            }
        }
        function kMaxLength() {
            return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
        }
        function createBuffer(g, f) {
            if (kMaxLength() < f) throw new RangeError("Invalid typed array length");
            return Buffer.TYPED_ARRAY_SUPPORT ? (g = new Uint8Array(f)).__proto__ = Buffer.prototype : (null === g && (g = new Buffer(f)), g.length = f), g;
        }
        function Buffer(g, f, S) {
            if (!(Buffer.TYPED_ARRAY_SUPPORT || this instanceof Buffer)) return new Buffer(g, f, S);
            if ("number" == typeof g) {
                if ("string" == typeof f) throw new Error("If encoding is specified then the first argument must be a string");
                return allocUnsafe(this, g);
            }
            return from(this, g, f, S);
        }
        function from(g, f, S, v) {
            if ("number" == typeof f) throw new TypeError('"value" argument must not be a number');
            return "undefined" != typeof ArrayBuffer && f instanceof ArrayBuffer ? fromArrayBuffer(g, f, S, v) : "string" == typeof f ? fromString(g, f, S) : fromObject(g, f);
        }
        function assertSize(g) {
            if ("number" != typeof g) throw new TypeError('"size" argument must be a number');
            if (g < 0) throw new RangeError('"size" argument must not be negative');
        }
        function alloc(g, f, S, v) {
            return assertSize(f), f <= 0 ? createBuffer(g, f) : void 0 !== S ? "string" == typeof v ? createBuffer(g, f).fill(S, v) : createBuffer(g, f).fill(S) : createBuffer(g, f);
        }
        function allocUnsafe(g, f) {
            if (assertSize(f), g = createBuffer(g, f < 0 ? 0 : 0 | checked(f)), !Buffer.TYPED_ARRAY_SUPPORT) for(var S = 0; S < f; ++S)g[S] = 0;
            return g;
        }
        function fromString(g, f, S) {
            if ("string" == typeof S && "" !== S || (S = "utf8"), !Buffer.isEncoding(S)) throw new TypeError('"encoding" must be a valid string encoding');
            var v = 0 | byteLength(f, S), _ = (g = createBuffer(g, v)).write(f, S);
            return _ !== v && (g = g.slice(0, _)), g;
        }
        function fromArrayLike(g, f) {
            var S = f.length < 0 ? 0 : 0 | checked(f.length);
            g = createBuffer(g, S);
            for(var v = 0; v < S; v += 1)g[v] = 255 & f[v];
            return g;
        }
        function fromArrayBuffer(g, f, S, v) {
            if (f.byteLength, S < 0 || f.byteLength < S) throw new RangeError("'offset' is out of bounds");
            if (f.byteLength < S + (v || 0)) throw new RangeError("'length' is out of bounds");
            return f = void 0 === S && void 0 === v ? new Uint8Array(f) : void 0 === v ? new Uint8Array(f, S) : new Uint8Array(f, S, v), Buffer.TYPED_ARRAY_SUPPORT ? (g = f).__proto__ = Buffer.prototype : g = fromArrayLike(g, f), g;
        }
        function fromObject(g, f) {
            if (Buffer.isBuffer(f)) {
                var S = 0 | checked(f.length);
                return 0 === (g = createBuffer(g, S)).length || f.copy(g, 0, 0, S), g;
            }
            if (f) {
                if ("undefined" != typeof ArrayBuffer && f.buffer instanceof ArrayBuffer || "length" in f) return "number" != typeof f.length || isnan(f.length) ? createBuffer(g, 0) : fromArrayLike(g, f);
                if ("Buffer" === f.type && lb(f.data)) return fromArrayLike(g, f.data);
            }
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }
        function checked(g) {
            if (g >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
            return 0 | g;
        }
        function SlowBuffer(g) {
            return +g != g && (g = 0), Buffer.alloc(+g);
        }
        function byteLength(g, f) {
            if (Buffer.isBuffer(g)) return g.length;
            if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(g) || g instanceof ArrayBuffer)) return g.byteLength;
            "string" != typeof g && (g = "" + g);
            var S = g.length;
            if (0 === S) return 0;
            for(var v = !1;;)switch(f){
                case "ascii":
                case "latin1":
                case "binary":
                    return S;
                case "utf8":
                case "utf-8":
                case void 0:
                    return utf8ToBytes(g).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return 2 * S;
                case "hex":
                    return S >>> 1;
                case "base64":
                    return base64ToBytes(g).length;
                default:
                    if (v) return utf8ToBytes(g).length;
                    f = ("" + f).toLowerCase(), v = !0;
            }
        }
        function slowToString(g, f, S) {
            var v = !1;
            if ((void 0 === f || f < 0) && (f = 0), f > this.length) return "";
            if ((void 0 === S || S > this.length) && (S = this.length), S <= 0) return "";
            if ((S >>>= 0) <= (f >>>= 0)) return "";
            for(g || (g = "utf8");;)switch(g){
                case "hex":
                    return hexSlice(this, f, S);
                case "utf8":
                case "utf-8":
                    return utf8Slice(this, f, S);
                case "ascii":
                    return asciiSlice(this, f, S);
                case "latin1":
                case "binary":
                    return latin1Slice(this, f, S);
                case "base64":
                    return base64Slice(this, f, S);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return utf16leSlice(this, f, S);
                default:
                    if (v) throw new TypeError("Unknown encoding: " + g);
                    g = (g + "").toLowerCase(), v = !0;
            }
        }
        function swap(g, f, S) {
            var v = g[f];
            g[f] = g[S], g[S] = v;
        }
        function bidirectionalIndexOf(g, f, S, v, _) {
            if (0 === g.length) return -1;
            if ("string" == typeof S ? (v = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, isNaN(S) && (S = _ ? 0 : g.length - 1), S < 0 && (S = g.length + S), S >= g.length) {
                if (_) return -1;
                S = g.length - 1;
            } else if (S < 0) {
                if (!_) return -1;
                S = 0;
            }
            if ("string" == typeof f && (f = Buffer.from(f, v)), Buffer.isBuffer(f)) return 0 === f.length ? -1 : arrayIndexOf(g, f, S, v, _);
            if ("number" == typeof f) return f &= 255, Buffer.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? _ ? Uint8Array.prototype.indexOf.call(g, f, S) : Uint8Array.prototype.lastIndexOf.call(g, f, S) : arrayIndexOf(g, [
                f
            ], S, v, _);
            throw new TypeError("val must be string, number or Buffer");
        }
        function arrayIndexOf(g, f, S, v, _) {
            var C, E = 1, T = g.length, I = f.length;
            if (void 0 !== v && ("ucs2" === (v = String(v).toLowerCase()) || "ucs-2" === v || "utf16le" === v || "utf-16le" === v)) {
                if (g.length < 2 || f.length < 2) return -1;
                E = 2, T /= 2, I /= 2, S /= 2;
            }
            function read(g, f) {
                return 1 === E ? g[f] : g.readUInt16BE(f * E);
            }
            if (_) {
                var b = -1;
                for(C = S; C < T; C++)if (read(g, C) === read(f, -1 === b ? 0 : C - b)) {
                    if (-1 === b && (b = C), C - b + 1 === I) return b * E;
                } else -1 !== b && (C -= C - b), b = -1;
            } else for(S + I > T && (S = T - I), C = S; C >= 0; C--){
                for(var A = !0, R = 0; R < I; R++)if (read(g, C + R) !== read(f, R)) {
                    A = !1;
                    break;
                }
                if (A) return C;
            }
            return -1;
        }
        function hexWrite(g, f, S, v) {
            S = Number(S) || 0;
            var _ = g.length - S;
            v ? (v = Number(v)) > _ && (v = _) : v = _;
            var C = f.length;
            if (C % 2 != 0) throw new TypeError("Invalid hex string");
            v > C / 2 && (v = C / 2);
            for(var E = 0; E < v; ++E){
                var T = parseInt(f.substr(2 * E, 2), 16);
                if (isNaN(T)) return E;
                g[S + E] = T;
            }
            return E;
        }
        function utf8Write(g, f, S, v) {
            return blitBuffer(utf8ToBytes(f, g.length - S), g, S, v);
        }
        function asciiWrite(g, f, S, v) {
            return blitBuffer(asciiToBytes(f), g, S, v);
        }
        function latin1Write(g, f, S, v) {
            return asciiWrite(g, f, S, v);
        }
        function base64Write(g, f, S, v) {
            return blitBuffer(base64ToBytes(f), g, S, v);
        }
        function ucs2Write(g, f, S, v) {
            return blitBuffer(utf16leToBytes(f, g.length - S), g, S, v);
        }
        function base64Slice(g, f, S) {
            return 0 === f && S === g.length ? ab.fromByteArray(g) : ab.fromByteArray(g.slice(f, S));
        }
        function utf8Slice(g, f, S) {
            S = Math.min(g.length, S);
            for(var v = [], _ = f; _ < S;){
                var C, E, T, I, b = g[_], A = null, R = b > 239 ? 4 : b > 223 ? 3 : b > 191 ? 2 : 1;
                if (_ + R <= S) switch(R){
                    case 1:
                        b < 128 && (A = b);
                        break;
                    case 2:
                        128 == (192 & (C = g[_ + 1])) && (I = (31 & b) << 6 | 63 & C) > 127 && (A = I);
                        break;
                    case 3:
                        C = g[_ + 1], E = g[_ + 2], 128 == (192 & C) && 128 == (192 & E) && (I = (15 & b) << 12 | (63 & C) << 6 | 63 & E) > 2047 && (I < 55296 || I > 57343) && (A = I);
                        break;
                    case 4:
                        C = g[_ + 1], E = g[_ + 2], T = g[_ + 3], 128 == (192 & C) && 128 == (192 & E) && 128 == (192 & T) && (I = (15 & b) << 18 | (63 & C) << 12 | (63 & E) << 6 | 63 & T) > 65535 && I < 1114112 && (A = I);
                }
                null === A ? (A = 65533, R = 1) : A > 65535 && (A -= 65536, v.push(A >>> 10 & 1023 | 55296), A = 56320 | 1023 & A), v.push(A), _ += R;
            }
            return decodeCodePointsArray(v);
        }
        f.Buffer = Buffer, f.SlowBuffer = SlowBuffer, f.INSPECT_MAX_BYTES = 50, Buffer.TYPED_ARRAY_SUPPORT = void 0 !== _.TYPED_ARRAY_SUPPORT ? _.TYPED_ARRAY_SUPPORT : typedArraySupport(), f.kMaxLength = kMaxLength(), Buffer.poolSize = 8192, Buffer._augment = function(g) {
            return g.__proto__ = Buffer.prototype, g;
        }, Buffer.from = function(g, f, S) {
            return from(null, g, f, S);
        }, Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && Buffer[Symbol.species] === Buffer && Object.defineProperty(Buffer, Symbol.species, {
            value: null,
            configurable: !0
        })), Buffer.alloc = function(g, f, S) {
            return alloc(null, g, f, S);
        }, Buffer.allocUnsafe = function(g) {
            return allocUnsafe(null, g);
        }, Buffer.allocUnsafeSlow = function(g) {
            return allocUnsafe(null, g);
        }, Buffer.isBuffer = function isBuffer(g) {
            return !(null == g || !g._isBuffer);
        }, Buffer.compare = function compare(g, f) {
            if (!Buffer.isBuffer(g) || !Buffer.isBuffer(f)) throw new TypeError("Arguments must be Buffers");
            if (g === f) return 0;
            for(var S = g.length, v = f.length, _ = 0, C = Math.min(S, v); _ < C; ++_)if (g[_] !== f[_]) {
                S = g[_], v = f[_];
                break;
            }
            return S < v ? -1 : v < S ? 1 : 0;
        }, Buffer.isEncoding = function isEncoding(g) {
            switch(String(g).toLowerCase()){
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return !0;
                default:
                    return !1;
            }
        }, Buffer.concat = function concat(g, f) {
            if (!lb(g)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === g.length) return Buffer.alloc(0);
            var S;
            if (void 0 === f) for(f = 0, S = 0; S < g.length; ++S)f += g[S].length;
            var v = Buffer.allocUnsafe(f), _ = 0;
            for(S = 0; S < g.length; ++S){
                var C = g[S];
                if (!Buffer.isBuffer(C)) throw new TypeError('"list" argument must be an Array of Buffers');
                C.copy(v, _), _ += C.length;
            }
            return v;
        }, Buffer.byteLength = byteLength, Buffer.prototype._isBuffer = !0, Buffer.prototype.swap16 = function swap16() {
            var g = this.length;
            if (g % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
            for(var f = 0; f < g; f += 2)swap(this, f, f + 1);
            return this;
        }, Buffer.prototype.swap32 = function swap32() {
            var g = this.length;
            if (g % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
            for(var f = 0; f < g; f += 4)swap(this, f, f + 3), swap(this, f + 1, f + 2);
            return this;
        }, Buffer.prototype.swap64 = function swap64() {
            var g = this.length;
            if (g % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
            for(var f = 0; f < g; f += 8)swap(this, f, f + 7), swap(this, f + 1, f + 6), swap(this, f + 2, f + 5), swap(this, f + 3, f + 4);
            return this;
        }, Buffer.prototype.toString = function toString() {
            var g = 0 | this.length;
            return 0 === g ? "" : 0 === arguments.length ? utf8Slice(this, 0, g) : slowToString.apply(this, arguments);
        }, Buffer.prototype.equals = function equals(g) {
            if (!Buffer.isBuffer(g)) throw new TypeError("Argument must be a Buffer");
            return this === g || 0 === Buffer.compare(this, g);
        }, Buffer.prototype.inspect = function inspect() {
            var g = "", S = f.INSPECT_MAX_BYTES;
            return this.length > 0 && (g = this.toString("hex", 0, S).match(/.{2}/g).join(" "), this.length > S && (g += " ... ")), "<Buffer " + g + ">";
        }, Buffer.prototype.compare = function compare(g, f, S, v, _) {
            if (!Buffer.isBuffer(g)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === f && (f = 0), void 0 === S && (S = g ? g.length : 0), void 0 === v && (v = 0), void 0 === _ && (_ = this.length), f < 0 || S > g.length || v < 0 || _ > this.length) throw new RangeError("out of range index");
            if (v >= _ && f >= S) return 0;
            if (v >= _) return -1;
            if (f >= S) return 1;
            if (this === g) return 0;
            for(var C = (_ >>>= 0) - (v >>>= 0), E = (S >>>= 0) - (f >>>= 0), T = Math.min(C, E), I = this.slice(v, _), b = g.slice(f, S), A = 0; A < T; ++A)if (I[A] !== b[A]) {
                C = I[A], E = b[A];
                break;
            }
            return C < E ? -1 : E < C ? 1 : 0;
        }, Buffer.prototype.includes = function includes(g, f, S) {
            return -1 !== this.indexOf(g, f, S);
        }, Buffer.prototype.indexOf = function indexOf(g, f, S) {
            return bidirectionalIndexOf(this, g, f, S, !0);
        }, Buffer.prototype.lastIndexOf = function lastIndexOf(g, f, S) {
            return bidirectionalIndexOf(this, g, f, S, !1);
        }, Buffer.prototype.write = function write(g, f, S, v) {
            if (void 0 === f) v = "utf8", S = this.length, f = 0;
            else if (void 0 === S && "string" == typeof f) v = f, S = this.length, f = 0;
            else {
                if (!isFinite(f)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                f |= 0, isFinite(S) ? (S |= 0, void 0 === v && (v = "utf8")) : (v = S, S = void 0);
            }
            var _ = this.length - f;
            if ((void 0 === S || S > _) && (S = _), g.length > 0 && (S < 0 || f < 0) || f > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            v || (v = "utf8");
            for(var C = !1;;)switch(v){
                case "hex":
                    return hexWrite(this, g, f, S);
                case "utf8":
                case "utf-8":
                    return utf8Write(this, g, f, S);
                case "ascii":
                    return asciiWrite(this, g, f, S);
                case "latin1":
                case "binary":
                    return latin1Write(this, g, f, S);
                case "base64":
                    return base64Write(this, g, f, S);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                    return ucs2Write(this, g, f, S);
                default:
                    if (C) throw new TypeError("Unknown encoding: " + v);
                    v = ("" + v).toLowerCase(), C = !0;
            }
        }, Buffer.prototype.toJSON = function toJSON() {
            return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
            };
        };
        var S = 4096;
        function decodeCodePointsArray(g) {
            var f = g.length;
            if (f <= S) return String.fromCharCode.apply(String, g);
            for(var v = "", _ = 0; _ < f;)v += String.fromCharCode.apply(String, g.slice(_, _ += S));
            return v;
        }
        function asciiSlice(g, f, S) {
            var v = "";
            S = Math.min(g.length, S);
            for(var _ = f; _ < S; ++_)v += String.fromCharCode(127 & g[_]);
            return v;
        }
        function latin1Slice(g, f, S) {
            var v = "";
            S = Math.min(g.length, S);
            for(var _ = f; _ < S; ++_)v += String.fromCharCode(g[_]);
            return v;
        }
        function hexSlice(g, f, S) {
            var v = g.length;
            (!f || f < 0) && (f = 0), (!S || S < 0 || S > v) && (S = v);
            for(var _ = "", C = f; C < S; ++C)_ += toHex(g[C]);
            return _;
        }
        function utf16leSlice(g, f, S) {
            for(var v = g.slice(f, S), _ = "", C = 0; C < v.length; C += 2)_ += String.fromCharCode(v[C] + 256 * v[C + 1]);
            return _;
        }
        function checkOffset(g, f, S) {
            if (g % 1 != 0 || g < 0) throw new RangeError("offset is not uint");
            if (g + f > S) throw new RangeError("Trying to access beyond buffer length");
        }
        function checkInt(g, f, S, v, _, C) {
            if (!Buffer.isBuffer(g)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (f > _ || f < C) throw new RangeError('"value" argument is out of bounds');
            if (S + v > g.length) throw new RangeError("Index out of range");
        }
        function objectWriteUInt16(g, f, S, v) {
            f < 0 && (f = 65535 + f + 1);
            for(var _ = 0, C = Math.min(g.length - S, 2); _ < C; ++_)g[S + _] = (f & 255 << 8 * (v ? _ : 1 - _)) >>> 8 * (v ? _ : 1 - _);
        }
        function objectWriteUInt32(g, f, S, v) {
            f < 0 && (f = 4294967295 + f + 1);
            for(var _ = 0, C = Math.min(g.length - S, 4); _ < C; ++_)g[S + _] = f >>> 8 * (v ? _ : 3 - _) & 255;
        }
        function checkIEEE754(g, f, S, v, _, C) {
            if (S + v > g.length) throw new RangeError("Index out of range");
            if (S < 0) throw new RangeError("Index out of range");
        }
        function writeFloat(g, f, S, v, _) {
            return _ || checkIEEE754(g, f, S, 4), sb.write(g, f, S, v, 23, 4), S + 4;
        }
        function writeDouble(g, f, S, v, _) {
            return _ || checkIEEE754(g, f, S, 8), sb.write(g, f, S, v, 52, 8), S + 8;
        }
        Buffer.prototype.slice = function slice(g, f) {
            var S, v = this.length;
            if ((g = ~~g) < 0 ? (g += v) < 0 && (g = 0) : g > v && (g = v), (f = void 0 === f ? v : ~~f) < 0 ? (f += v) < 0 && (f = 0) : f > v && (f = v), f < g && (f = g), Buffer.TYPED_ARRAY_SUPPORT) (S = this.subarray(g, f)).__proto__ = Buffer.prototype;
            else {
                var _ = f - g;
                S = new Buffer(_, void 0);
                for(var C = 0; C < _; ++C)S[C] = this[C + g];
            }
            return S;
        }, Buffer.prototype.readUIntLE = function readUIntLE(g, f, S) {
            g |= 0, f |= 0, S || checkOffset(g, f, this.length);
            for(var v = this[g], _ = 1, C = 0; ++C < f && (_ *= 256);)v += this[g + C] * _;
            return v;
        }, Buffer.prototype.readUIntBE = function readUIntBE(g, f, S) {
            g |= 0, f |= 0, S || checkOffset(g, f, this.length);
            for(var v = this[g + --f], _ = 1; f > 0 && (_ *= 256);)v += this[g + --f] * _;
            return v;
        }, Buffer.prototype.readUInt8 = function readUInt8(g, f) {
            return f || checkOffset(g, 1, this.length), this[g];
        }, Buffer.prototype.readUInt16LE = function readUInt16LE(g, f) {
            return f || checkOffset(g, 2, this.length), this[g] | this[g + 1] << 8;
        }, Buffer.prototype.readUInt16BE = function readUInt16BE(g, f) {
            return f || checkOffset(g, 2, this.length), this[g] << 8 | this[g + 1];
        }, Buffer.prototype.readUInt32LE = function readUInt32LE(g, f) {
            return f || checkOffset(g, 4, this.length), (this[g] | this[g + 1] << 8 | this[g + 2] << 16) + 16777216 * this[g + 3];
        }, Buffer.prototype.readUInt32BE = function readUInt32BE(g, f) {
            return f || checkOffset(g, 4, this.length), 16777216 * this[g] + (this[g + 1] << 16 | this[g + 2] << 8 | this[g + 3]);
        }, Buffer.prototype.readIntLE = function readIntLE(g, f, S) {
            g |= 0, f |= 0, S || checkOffset(g, f, this.length);
            for(var v = this[g], _ = 1, C = 0; ++C < f && (_ *= 256);)v += this[g + C] * _;
            return v >= (_ *= 128) && (v -= Math.pow(2, 8 * f)), v;
        }, Buffer.prototype.readIntBE = function readIntBE(g, f, S) {
            g |= 0, f |= 0, S || checkOffset(g, f, this.length);
            for(var v = f, _ = 1, C = this[g + --v]; v > 0 && (_ *= 256);)C += this[g + --v] * _;
            return C >= (_ *= 128) && (C -= Math.pow(2, 8 * f)), C;
        }, Buffer.prototype.readInt8 = function readInt8(g, f) {
            return f || checkOffset(g, 1, this.length), 128 & this[g] ? -1 * (255 - this[g] + 1) : this[g];
        }, Buffer.prototype.readInt16LE = function readInt16LE(g, f) {
            f || checkOffset(g, 2, this.length);
            var S = this[g] | this[g + 1] << 8;
            return 32768 & S ? 4294901760 | S : S;
        }, Buffer.prototype.readInt16BE = function readInt16BE(g, f) {
            f || checkOffset(g, 2, this.length);
            var S = this[g + 1] | this[g] << 8;
            return 32768 & S ? 4294901760 | S : S;
        }, Buffer.prototype.readInt32LE = function readInt32LE(g, f) {
            return f || checkOffset(g, 4, this.length), this[g] | this[g + 1] << 8 | this[g + 2] << 16 | this[g + 3] << 24;
        }, Buffer.prototype.readInt32BE = function readInt32BE(g, f) {
            return f || checkOffset(g, 4, this.length), this[g] << 24 | this[g + 1] << 16 | this[g + 2] << 8 | this[g + 3];
        }, Buffer.prototype.readFloatLE = function readFloatLE(g, f) {
            return f || checkOffset(g, 4, this.length), sb.read(this, g, !0, 23, 4);
        }, Buffer.prototype.readFloatBE = function readFloatBE(g, f) {
            return f || checkOffset(g, 4, this.length), sb.read(this, g, !1, 23, 4);
        }, Buffer.prototype.readDoubleLE = function readDoubleLE(g, f) {
            return f || checkOffset(g, 8, this.length), sb.read(this, g, !0, 52, 8);
        }, Buffer.prototype.readDoubleBE = function readDoubleBE(g, f) {
            return f || checkOffset(g, 8, this.length), sb.read(this, g, !1, 52, 8);
        }, Buffer.prototype.writeUIntLE = function writeUIntLE(g, f, S, v) {
            (g = +g, f |= 0, S |= 0, v) || checkInt(this, g, f, S, Math.pow(2, 8 * S) - 1, 0);
            var _ = 1, C = 0;
            for(this[f] = 255 & g; ++C < S && (_ *= 256);)this[f + C] = g / _ & 255;
            return f + S;
        }, Buffer.prototype.writeUIntBE = function writeUIntBE(g, f, S, v) {
            (g = +g, f |= 0, S |= 0, v) || checkInt(this, g, f, S, Math.pow(2, 8 * S) - 1, 0);
            var _ = S - 1, C = 1;
            for(this[f + _] = 255 & g; --_ >= 0 && (C *= 256);)this[f + _] = g / C & 255;
            return f + S;
        }, Buffer.prototype.writeUInt8 = function writeUInt8(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (g = Math.floor(g)), this[f] = 255 & g, f + 1;
        }, Buffer.prototype.writeUInt16LE = function writeUInt16LE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = 255 & g, this[f + 1] = g >>> 8) : objectWriteUInt16(this, g, f, !0), f + 2;
        }, Buffer.prototype.writeUInt16BE = function writeUInt16BE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = g >>> 8, this[f + 1] = 255 & g) : objectWriteUInt16(this, g, f, !1), f + 2;
        }, Buffer.prototype.writeUInt32LE = function writeUInt32LE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[f + 3] = g >>> 24, this[f + 2] = g >>> 16, this[f + 1] = g >>> 8, this[f] = 255 & g) : objectWriteUInt32(this, g, f, !0), f + 4;
        }, Buffer.prototype.writeUInt32BE = function writeUInt32BE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = g >>> 24, this[f + 1] = g >>> 16, this[f + 2] = g >>> 8, this[f + 3] = 255 & g) : objectWriteUInt32(this, g, f, !1), f + 4;
        }, Buffer.prototype.writeIntLE = function writeIntLE(g, f, S, v) {
            if (g = +g, f |= 0, !v) {
                var _ = Math.pow(2, 8 * S - 1);
                checkInt(this, g, f, S, _ - 1, -_);
            }
            var C = 0, E = 1, T = 0;
            for(this[f] = 255 & g; ++C < S && (E *= 256);)g < 0 && 0 === T && 0 !== this[f + C - 1] && (T = 1), this[f + C] = (g / E >> 0) - T & 255;
            return f + S;
        }, Buffer.prototype.writeIntBE = function writeIntBE(g, f, S, v) {
            if (g = +g, f |= 0, !v) {
                var _ = Math.pow(2, 8 * S - 1);
                checkInt(this, g, f, S, _ - 1, -_);
            }
            var C = S - 1, E = 1, T = 0;
            for(this[f + C] = 255 & g; --C >= 0 && (E *= 256);)g < 0 && 0 === T && 0 !== this[f + C + 1] && (T = 1), this[f + C] = (g / E >> 0) - T & 255;
            return f + S;
        }, Buffer.prototype.writeInt8 = function writeInt8(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (g = Math.floor(g)), g < 0 && (g = 255 + g + 1), this[f] = 255 & g, f + 1;
        }, Buffer.prototype.writeInt16LE = function writeInt16LE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = 255 & g, this[f + 1] = g >>> 8) : objectWriteUInt16(this, g, f, !0), f + 2;
        }, Buffer.prototype.writeInt16BE = function writeInt16BE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = g >>> 8, this[f + 1] = 255 & g) : objectWriteUInt16(this, g, f, !1), f + 2;
        }, Buffer.prototype.writeInt32LE = function writeInt32LE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = 255 & g, this[f + 1] = g >>> 8, this[f + 2] = g >>> 16, this[f + 3] = g >>> 24) : objectWriteUInt32(this, g, f, !0), f + 4;
        }, Buffer.prototype.writeInt32BE = function writeInt32BE(g, f, S) {
            return g = +g, f |= 0, S || checkInt(this, g, f, 4, 2147483647, -2147483648), g < 0 && (g = 4294967295 + g + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[f] = g >>> 24, this[f + 1] = g >>> 16, this[f + 2] = g >>> 8, this[f + 3] = 255 & g) : objectWriteUInt32(this, g, f, !1), f + 4;
        }, Buffer.prototype.writeFloatLE = function writeFloatLE(g, f, S) {
            return writeFloat(this, g, f, !0, S);
        }, Buffer.prototype.writeFloatBE = function writeFloatBE(g, f, S) {
            return writeFloat(this, g, f, !1, S);
        }, Buffer.prototype.writeDoubleLE = function writeDoubleLE(g, f, S) {
            return writeDouble(this, g, f, !0, S);
        }, Buffer.prototype.writeDoubleBE = function writeDoubleBE(g, f, S) {
            return writeDouble(this, g, f, !1, S);
        }, Buffer.prototype.copy = function copy(g, f, S, v) {
            if (S || (S = 0), v || 0 === v || (v = this.length), f >= g.length && (f = g.length), f || (f = 0), v > 0 && v < S && (v = S), v === S) return 0;
            if (0 === g.length || 0 === this.length) return 0;
            if (f < 0) throw new RangeError("targetStart out of bounds");
            if (S < 0 || S >= this.length) throw new RangeError("sourceStart out of bounds");
            if (v < 0) throw new RangeError("sourceEnd out of bounds");
            v > this.length && (v = this.length), g.length - f < v - S && (v = g.length - f + S);
            var _, C = v - S;
            if (this === g && S < f && f < v) for(_ = C - 1; _ >= 0; --_)g[_ + f] = this[_ + S];
            else if (C < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT) for(_ = 0; _ < C; ++_)g[_ + f] = this[_ + S];
            else Uint8Array.prototype.set.call(g, this.subarray(S, S + C), f);
            return C;
        }, Buffer.prototype.fill = function fill(g, f, S, v) {
            if ("string" == typeof g) {
                if ("string" == typeof f ? (v = f, f = 0, S = this.length) : "string" == typeof S && (v = S, S = this.length), 1 === g.length) {
                    var _ = g.charCodeAt(0);
                    _ < 256 && (g = _);
                }
                if (void 0 !== v && "string" != typeof v) throw new TypeError("encoding must be a string");
                if ("string" == typeof v && !Buffer.isEncoding(v)) throw new TypeError("Unknown encoding: " + v);
            } else "number" == typeof g && (g &= 255);
            if (f < 0 || this.length < f || this.length < S) throw new RangeError("Out of range index");
            if (S <= f) return this;
            var C;
            if (f >>>= 0, S = void 0 === S ? this.length : S >>> 0, g || (g = 0), "number" == typeof g) for(C = f; C < S; ++C)this[C] = g;
            else {
                var E = Buffer.isBuffer(g) ? g : utf8ToBytes(new Buffer(g, v).toString()), T = E.length;
                for(C = 0; C < S - f; ++C)this[C + f] = E[C % T];
            }
            return this;
        };
        var v = /[^+\/0-9A-Za-z-_]/g;
        function base64clean(g) {
            if ((g = stringtrim(g).replace(v, "")).length < 2) return "";
            for(; g.length % 4 != 0;)g += "=";
            return g;
        }
        function stringtrim(g) {
            return g.trim ? g.trim() : g.replace(/^\s+|\s+$/g, "");
        }
        function toHex(g) {
            return g < 16 ? "0" + g.toString(16) : g.toString(16);
        }
        function utf8ToBytes(g, f) {
            var S;
            f = f || 1 / 0;
            for(var v = g.length, _ = null, C = [], E = 0; E < v; ++E){
                if ((S = g.charCodeAt(E)) > 55295 && S < 57344) {
                    if (!_) {
                        if (S > 56319) {
                            (f -= 3) > -1 && C.push(239, 191, 189);
                            continue;
                        }
                        if (E + 1 === v) {
                            (f -= 3) > -1 && C.push(239, 191, 189);
                            continue;
                        }
                        _ = S;
                        continue;
                    }
                    if (S < 56320) {
                        (f -= 3) > -1 && C.push(239, 191, 189), _ = S;
                        continue;
                    }
                    S = 65536 + (_ - 55296 << 10 | S - 56320);
                } else _ && (f -= 3) > -1 && C.push(239, 191, 189);
                if (_ = null, S < 128) {
                    if ((f -= 1) < 0) break;
                    C.push(S);
                } else if (S < 2048) {
                    if ((f -= 2) < 0) break;
                    C.push(S >> 6 | 192, 63 & S | 128);
                } else if (S < 65536) {
                    if ((f -= 3) < 0) break;
                    C.push(S >> 12 | 224, S >> 6 & 63 | 128, 63 & S | 128);
                } else {
                    if (!(S < 1114112)) throw new Error("Invalid code point");
                    if ((f -= 4) < 0) break;
                    C.push(S >> 18 | 240, S >> 12 & 63 | 128, S >> 6 & 63 | 128, 63 & S | 128);
                }
            }
            return C;
        }
        function asciiToBytes(g) {
            for(var f = [], S = 0; S < g.length; ++S)f.push(255 & g.charCodeAt(S));
            return f;
        }
        function utf16leToBytes(g, f) {
            for(var S, v, _, C = [], E = 0; E < g.length && !((f -= 2) < 0); ++E)v = (S = g.charCodeAt(E)) >> 8, _ = S % 256, C.push(_), C.push(v);
            return C;
        }
        function base64ToBytes(g) {
            return ab.toByteArray(base64clean(g));
        }
        function blitBuffer(g, f, S, v) {
            for(var _ = 0; _ < v && !(_ + S >= f.length || _ >= g.length); ++_)f[_ + S] = g[_];
            return _;
        }
        function isnan(g) {
            return g != g;
        }
    });
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ const getSeatingCoordinates = (g, f)=>{
        var _JSON_parse;
        const S = new Map, v = (_JSON_parse = JSON.parse(uncompressSeatingData(g))) === null || _JSON_parse === void 0 ? void 0 : _JSON_parse.seating;
        return v.forEach((g)=>{
            const v = g === null || g === void 0 ? void 0 : g.mri, _ = calculateUserBoxState({
                x: g === null || g === void 0 ? void 0 : g.x,
                y: g === null || g === void 0 ? void 0 : g.y,
                w: g === null || g === void 0 ? void 0 : g.w,
                h: g === null || g === void 0 ? void 0 : g.h
            }, f);
            S.set(v, _);
        }), S;
    }, uncompressSeatingData = (g)=>{
        try {
            const f = sy.ungzip(cb.Buffer.from(g, "base64"));
            return (new TextDecoder).decode(f);
        } catch (g) {
            throw g;
        }
    }, calculateUserBoxState = (g, f)=>{
        const { sceneX: S, sceneY: v, sceneWidth: _, sceneHeight: C } = calculateAspectRatioFit(f), E = calculateOriginalSeatPosition(g.x, g.y, g.w, g.h, _, C), T = getAcsEcsConfig().calling.togetherMode.mainVideo.scaledHeightRatio, I = getAcsEcsConfig().calling.togetherMode.mainVideo.scaledWidthRatio;
        return {
            top: v + E.y + E.h * (1 - T),
            left: S + E.x + E.w * (1 - I) / WI,
            width: E.w * I,
            height: E.h * T
        };
    }, calculateAspectRatioFit = (g)=>{
        const f = g.width, S = g.height, v = GI, _ = Math.max(f - S * v, 0) / WI, C = Math.max(S - f / v, 0) / WI;
        return {
            sceneX: _,
            sceneY: C,
            sceneWidth: f - _ * WI,
            sceneHeight: S - C * WI
        };
    }, calculateOriginalSeatPosition = (g, f, S, v, _, C)=>({
            x: g / qI * _,
            y: f / qI * C,
            w: S / qI * _,
            h: v / qI * C
        });
    class TogetherModeCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "TeamsMeetingTogetherMode";
        }
        initialize(g, f) {
            this._impl.initialize(g.tsCall, g.callAgent, g.call, g.telemetryLogManager, f);
        }
        dispose() {
            this._impl.dispose(), super.dispose();
        }
        on(g, f) {
            if ("togetherModeStreamsUpdated" !== g && "togetherModeSceneUpdated" !== g && "togetherModeSeatingUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("togetherModeStreamsUpdated" !== g && "togetherModeSceneUpdated" !== g && "togetherModeSeatingUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        get togetherModeStream() {
            return this._impl.togetherModeStream;
        }
        get togetherModeSeatingMap() {
            return this._impl.seatingCooridnates;
        }
        set sceneSize(g) {
            this._impl.sceneSize = g;
        }
        get sceneSize() {
            return this._impl.sceneSize;
        }
        async start() {
            await this._impl.start();
        }
        constructor(g){
            super(g), this._impl = new TogetherModeCallImplOverTsCall(this.eventEmitter, this.name, getAcsEcsConfig().calling.togetherMode.botId);
        }
    }
    class TogetherModeCallImplOverTsCall extends BotStreamCommonCallFeature {
        initialize(g, f, S, v, _) {
            super.initialize(g, f, S, v, _), this._dataChannelAdapter = new DataChannelAdapter(g, this._dataChannelId), this._dataChannelAdapter.on("message", (g)=>{
                this.handleDataChannelMessageReceived(g);
            }), this._dataChannelAdapter.on("stateChanged", (g)=>{
                this.handleDataChannelStateChanged(g);
            }), this._dataChannelAdapter.initialize(), this._sendFeatureUsage("initialize", uy.initialize);
        }
        dispose() {
            var _this__dataChannelAdapter, _this__dataChannelAdapter1, _this__dataChannelAdapter2;
            (_this__dataChannelAdapter = this._dataChannelAdapter) === null || _this__dataChannelAdapter === void 0 ? void 0 : _this__dataChannelAdapter.off("message", ()=>{}), (_this__dataChannelAdapter1 = this._dataChannelAdapter) === null || _this__dataChannelAdapter1 === void 0 ? void 0 : _this__dataChannelAdapter1.off("stateChanged", ()=>{}), super.disposeAllBotStreams(), (_this__dataChannelAdapter2 = this._dataChannelAdapter) === null || _this__dataChannelAdapter2 === void 0 ? void 0 : _this__dataChannelAdapter2.dispose();
        }
        get togetherModeStream() {
            return [
                ...this._streamIdToStreamMap.values()
            ].map((g)=>g);
        }
        get seatingCooridnates() {
            return this._seatingCoordinates;
        }
        set sceneSize(g) {
            var _this__lastdataChannelMessage;
            this._botSceneSize = g;
            const f = this.decodeMessageData((_this__lastdataChannelMessage = this._lastdataChannelMessage) === null || _this__lastdataChannelMessage === void 0 ? void 0 : _this__lastdataChannelMessage.data);
            this.updateSeatingCoordinatesAndEmitEvent(f === null || f === void 0 ? void 0 : f.payload, f === null || f === void 0 ? void 0 : f.eventType);
        }
        get sceneSize() {
            return this._botSceneSize;
        }
        async start() {
            const g = "start";
            try {
                this.validateCanStartTogetherMode();
            } catch (f) {
                return this._sendFeatureUsage(g, uy.failure, f), void this._logger.error(`[${this._featureName}]: Validation failed. ${JSON.stringify(f)}`);
            }
            if (this.isTogetherModeBotInCall()) this._logger.warn("Together mode is already active");
            else {
                this._sendFeatureUsage(g, uy.attempt), this._logger.info(`[${this._featureName}]: Adding together mode bot to call`);
                try {
                    await this._tsCall.addParticipant(this._togetherModeBotId);
                } catch (f) {
                    const S = new CallingCommunicationError({
                        defaultError: O.FEATURES.TOGETHER_MODE.ADD_TOGETHER_MODE_BOT_FAILED,
                        originalError: f
                    });
                    throw this._sendFeatureUsage(g, uy.failure, S), S;
                }
                const f = {
                    level: "user",
                    type: "togetherMode",
                    content: "{}",
                    participantIds: [
                        this._togetherModeBotId
                    ]
                };
                try {
                    await this._tsCall.publishState(f, w.generateCauseId());
                } catch (f) {
                    const S = handlePublishStateFailure(f, O.FEATURES.TOGETHER_MODE.PUBLISH_TOGETHER_MODE_STATE_FAILED);
                    throw this._sendFeatureUsage(g, uy.failure, S), S;
                }
                this._sendFeatureUsage(g, uy.success);
            }
        }
        createConcreteVideoStream(g, f) {
            return new TogetherModeVideoStreamImpl(g, this._logger, this._call, f, this._telemetryLogManager);
        }
        getStreamTypes() {
            return [
                0
            ];
        }
        emitVideoStreamsUpdatedEvent(g) {
            return this._eventEmitter.emit("togetherModeStreamsUpdated", g);
        }
        handleDataChannelMessageReceived(g) {
            if (!(g === null || g === void 0 ? void 0 : g.data)) return;
            const f = "messageReceived";
            try {
                var _S_payload;
                this._sendFeatureUsage(f, uy.attempt), this._lastdataChannelMessage = g;
                const S = this.decodeMessageData(g.data);
                if (!(S === null || S === void 0 ? void 0 : (_S_payload = S.payload) === null || _S_payload === void 0 ? void 0 : _S_payload.seating)) return this._logger.info("Received data does not contain seating information. Ignoring the event"), void this._sendFeatureUsage(f, uy.success);
                if (S.payload.seating === this._lastSeatingMapData) return this._logger.info("Seating map data is the same as the last received data. Ignoring the event"), void this._sendFeatureUsage(f, uy.success);
                this._lastSeatingMapData = S.payload.seating, this.updateSeatingCoordinatesAndEmitEvent(S.payload, S.eventType), this._sendFeatureUsage(f, uy.success);
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.FEATURES.TOGETHER_MODE.SEAT_MAP_CALCULATION_FAILED,
                    originalError: g
                });
                this._sendFeatureUsage(f, uy.failure, S);
            }
        }
        decodeMessageData(g) {
            return g ? JSON.parse((new TextDecoder).decode(g)) : null;
        }
        updateSeatingCoordinatesAndEmitEvent(g, f) {
            if (f === JI.sceneChanged || f === JI.seatingChanged) {
                const S = f === JI.sceneChanged ? "togetherModeSceneUpdated" : "togetherModeSeatingUpdated";
                this._seatingCoordinates = getSeatingCoordinates(g === null || g === void 0 ? void 0 : g.seating, this._botSceneSize), getAcsEcsConfig().calling.togetherMode.forceSeatMapRequest && this.requestSeatMap(), "togetherModeSceneUpdated" === S && this._eventEmitter.emit("togetherModeSeatingUpdated", this._seatingCoordinates), this._eventEmitter.emit(S, this._seatingCoordinates);
            }
        }
        validateCanStartTogetherMode() {
            if (!this._callAgent.isCteUser()) throw new CallingCommunicationError({
                defaultError: O.FEATURES.TOGETHER_MODE.UNSUPPORTED_USER_KIND
            });
            if (!this.isSupportedConversationType()) throw new CallingCommunicationError({
                defaultError: O.FEATURES.TOGETHER_MODE.UNSUPPORTED_CONVERSATION_TYPE
            });
        }
        handleDataChannelStateChanged(f) {
            f === g.DataChannelState.Started && this.requestSeatMap();
        }
        requestSeatMap() {
            try {
                var _this__dataChannelAdapter;
                const g = {
                    eventType: "seatMapping",
                    payload: {
                        seqId: 1
                    }
                };
                (_this__dataChannelAdapter = this._dataChannelAdapter) === null || _this__dataChannelAdapter === void 0 ? void 0 : _this__dataChannelAdapter.send((new TextEncoder).encode(JSON.stringify(g)));
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.FEATURES.TOGETHER_MODE.REQUEST_INITIAL_SEAT_MAPPING_FAILED,
                    originalError: g
                });
            }
        }
        isTogetherModeBotInCall() {
            for (let g of this._tsCall.participants)if (g.id === this._togetherModeBotId) return !0;
            return !1;
        }
        isSupportedConversationType() {
            const g = this._tsCall.conversationType;
            return !!g && !!this._supportedConversationTypes.find((f)=>f === g);
        }
        _sendFeatureUsage(g, f, S) {
            const v = S && extractCommunicationServicesErrorForTelemetry(S);
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "TogetherMode",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g, f, S){
            super(f, [
                S
            ]), this._eventEmitter = g, this._togetherModeBotId = S, this._lastSeatingMapData = "", this._seatingCoordinates = new Map, this._dataChannelId = getAcsEcsConfig().calling.togetherMode.dataChannelId, this._supportedConversationTypes = getAcsEcsConfig().calling.togetherMode.supportedConversationTypes, this._lastdataChannelMessage = {}, this._botSceneSize = {
                width: zI,
                height: KI
            };
        }
    }
    class TogetherModeVideoStreamImpl extends RemoteVideoStreamCommonImpl {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        setIsAvailable(g) {
            g !== this._isAvailable && (this._isAvailable = !!g, this.logger.log(`isAvailable changed to ${this._isAvailable}`), this._eventEmitter.emit("isAvailableChanged", this._isAvailable), super.sendRemoteVideoStreamTelemetry());
        }
        getStreamMetadata() {
            var _this_call;
            return {
                callId: (_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.id,
                streamType: this.mediaStreamType,
                localParticipantId: this.call.tsCall.participantId,
                remoteParticipantId: this.remoteParticipantId,
                sourceId: this.id,
                source: "remote",
                isReceiving: this._isReceiving,
                isStreaming: this.tsStream.isStreaming,
                isAvailable: this._isAvailable,
                viewIdsRegistered: this.getRegisteredViewIds(),
                height: this._size.height,
                width: this._size.width,
                isDisposed: this._disposed
            };
        }
        get isAvailable() {
            return this._isAvailable;
        }
        constructor(g, f, S, v, _){
            super(g, f, S, v, _, "TogetherModeVideoStream"), this._isAvailable = !1;
            const handleIsAvailable = ()=>{
                this.setIsAvailable(this.tsStream.isAvailable);
            };
            this._streamChangedHandler = this.tsStream.changed(()=>{
                handleIsAvailable();
            }), handleIsAvailable();
        }
    }
    class BreakoutRoomImpl {
        async join() {
            try {
                if ("open" !== this.state) throw this._logger.error("Breakout room is not open."), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.JOIN_FAILED_ROOM_CLOSED,
                    originalError: "Cannot join the breakout room as it is closed."
                });
                return await this.holdMainMeetingCall(), await this.joinBreakoutRoomCall();
            } catch (g) {
                var _this__logger;
                throw this._logger.error("Breakout Room join failed", g), this._sendFeatureUsage("BreakoutRoomJoinError", uy.failure), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error(g), g;
            }
        }
        async returnToMainMeeting() {
            try {
                var _this_call, _this__logger;
                return "open" == this.state && (this._breakoutRoomsService.isMainMeetingRejoin = !0), "Connected" === ((_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.state) && this.handleBreakoutRoomCallHangUp(this.call), this._mainMeeting.isSubscribedCall && "None" == this._mainMeeting.state && (await this.hangUpSubscribedCall(), await sleep(this._hangUpCallDelayInMilliSeconds)), this.isBreakoutRoomManager() ? ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Resuming main meeting."), await this.resumeMainMeeting()) : await this.rejoinMainMeeting();
            } catch (g) {
                throw this._logger.error("Rejoin main meeting failed.", g), this._sendFeatureUsage("RejoinMainMeetingError", uy.failure), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.RETURN_TO_MAINMEETING_FAILED,
                    originalError: g
                });
            }
        }
        async hangUp(g) {
            null != g && setTimeout(()=>{
                this.handleBreakoutRoomCallHangUp(g);
            }, this._hangUpCallDelayInMilliSeconds);
        }
        async handleBreakoutRoomCallHangUp(g) {
            "Connected" === (g === null || g === void 0 ? void 0 : g.state) && await (g === null || g === void 0 ? void 0 : g.hangUp().then(()=>{
                this._logger.info("Breakout room call hang up success.");
            }).catch((g)=>{
                throw this._logger.error("Error in hanging up the breakout room call.", g), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.HANGUP_EXISTING_BREAKOUT_ROOM_FAILED,
                    originalError: g
                });
            }));
        }
        getBreakoutRoomCall(g) {
            return this._callAgent.calls.find((f)=>f.id == g);
        }
        async rejoinMainMeeting() {
            var _this__logger, _this__logger1;
            let g;
            if (!this._mainMeeting.isSubscribedCall && "Connected" === this._mainMeeting.state) throw (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error("Cannot return to  main meeting as the user is already in main meeting."), new CallingCommunicationError({
                defaultError: O.FEATURES.BREAKOUT_ROOMS.ALREADY_IN_MAINMEETING,
                originalError: "Cannot return to main meeting as the user is already in main meeting."
            });
            return (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Returning to main meeting."), this._breakoutRoomsService.mainMeetingjoinLink && (g = this._callAgent.join({
                meetingLink: this._breakoutRoomsService.mainMeetingjoinLink
            }), this._logger.info("joined mainmeeting , callId :", g.id), this._sendFeatureUsage("RejoinMainMeetingSuccess", uy.success)), Promise.resolve(g);
        }
        async joinBreakoutRoomCall() {
            try {
                if (null == this.url) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.BREAKOUT_ROOM_URL_DOESNOT_EXIST,
                    originalError: "Cannot join the breakout room as the BreakoutRoom is not created."
                });
                this.call = this._callAgent.join({
                    meetingLink: this.url
                });
                const g = {
                    type: "join",
                    data: this.call
                };
                this.emitBreakoutRoomsUpdated(g), this._logger.info("Joined breakout room. callId :", this.call.id), this._sendFeatureUsage("BreakoutRoomJoin", uy.success), this.call.on("stateChanged", ()=>{
                    var _this_call;
                    switch((_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.state){
                        case "Disconnected":
                            var _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl;
                            this._logger.info("Breakout room is disconnected."), !this._breakoutRoomsService.isNewBreakoutRoomAssigned && this.hangUpSubscribedCall(), this._breakoutRoomsService.breakoutRoomCallId = void 0, (_this__breakoutRoomsService_breakoutRoomsCallFeatureImpl = this._breakoutRoomsService.breakoutRoomsCallFeatureImpl) === null || _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl === void 0 ? void 0 : _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl.dispose();
                            break;
                        case "Connected":
                            !this._mainMeeting.isSubscribedCall && this.hangUpMainMeeting(), this._previousBreakoutRoomId = this._breakoutRoomsService.breakoutRoomCallId, this._breakoutRoomsService.isNewBreakoutRoomAssigned && this._previousBreakoutRoomId && this.hangUp(this.getBreakoutRoomCall(this._previousBreakoutRoomId)), this._breakoutRoomsService.breakoutRoomCallId = this.call.id;
                    }
                });
            } catch (g) {
                throw this._logger.error("Breakout room join failed", g), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.JOIN_FAILED,
                    originalError: g
                });
            }
            return Promise.resolve(this.call);
        }
        emitBreakoutRoomsUpdated(g) {
            !this._mainMeeting.isSubscribedCall && this._eventEmitter.emit("breakoutRoomsUpdated", g), this._mainMeeting.isSubscribedCall && this._eventEmitter.emit("breakoutRoomsUpdatedInternal", g);
        }
        async holdMainMeetingCall() {
            this._mainMeeting.isSubscribedCall || "Connected" != this._mainMeeting.state || this._mainMeeting.hold().catch((g)=>{
                throw this._logger.error("Main meeting hold failed", g), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.MAINMEETING_HOLD_FAILED,
                    originalError: g
                });
            });
        }
        async resumeMainMeeting() {
            try {
                var _this__logger;
                if (this.isBreakoutRoomManager() && ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Resuming main meeting"), "LocalHold" === this._mainMeeting.state)) return this._mainMeeting.resume().then(()=>{
                    var _this__logger;
                    (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Main meeting is resumed"), this._sendFeatureUsage("MainMeetingResumeSuccess", uy.success);
                    let g = this._callAgent.calls.find((g)=>g.id == this._mainMeeting.id);
                    if (g) return g;
                    throw new CallingCommunicationError({
                        defaultError: O.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,
                        originalError: "Main meeting call not found."
                    });
                }).catch((g)=>{
                    var _this__logger;
                    const f = new CallingCommunicationError({
                        defaultError: O.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,
                        originalError: g
                    });
                    throw (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error("Error in resuming main meeting", f), this._sendFeatureUsage("MainMeetingResumeError", uy.failure), f;
                });
            } catch (g) {
                throw g;
            }
            throw new CallingCommunicationError({
                defaultError: O.FEATURES.BREAKOUT_ROOMS.MAINMEETING_RESUME_FAILED,
                originalError: "Main meeting resume failed."
            });
        }
        async hangUpSubscribedCall() {
            this._mainMeeting.isSubscribedCall && (this._mainMeeting.on("stateChanged", async ()=>{
                "Disconnected" === this._mainMeeting.state && (this._breakoutRoomsService.isNewBreakoutRoomAssigned = !1, this._mainMeeting.dispose());
            }), this._mainMeeting.hangUp().then(()=>{
                var _this__logger;
                this._breakoutRoomsService.isMainMeetingRejoin = !0, (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Subscribed call is disconnected"), this._sendFeatureUsage("SubscribedCallHangupSuccess", uy.success);
            }).catch((g)=>{
                var _this__logger;
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error("Not able to disconnect subscribed call", g), this._sendFeatureUsage("SubscribedCallHangupError", uy.failure);
            }));
        }
        async hangUpMainMeeting() {
            try {
                if (!this.isBreakoutRoomManager()) {
                    let g = this._callAgent.getCallByCallId(this._mainMeeting.id);
                    const f = g && JSON.parse(await g.getJoinBlob()), S = f === null || f === void 0 ? void 0 : f.conversationUrl;
                    if (!S) throw new CallingCommunicationError({
                        defaultError: O.CALL.GET_SERVER_CALL_ID
                    });
                    if (g) {
                        const f = {
                            meetingUrl: S,
                            threadId: g.threadId,
                            callId: g.callId,
                            participantId: g.participantId,
                            messageId: g.messageId
                        };
                        this._mainMeeting.on("stateChanged", async ()=>{
                            if ("Disconnected" === this._mainMeeting.state) return this._mainMeeting.dispose(), await this.joinMainMeetingWithoutModalities(f);
                        }), await this._mainMeeting.hangUp();
                    }
                }
            } catch (g) {
                var _this__logger;
                this._sendFeatureUsage("MainMeetingHangupError", uy.failure), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error("Error in hangingup main meeting ", g);
            }
        }
        isBreakoutRoomManager() {
            if (this._callAgent.isCteUser()) {
                var _this__mainMeeting, _this__mainMeeting1, _this__tsCall_meetingDetails_breakoutDetails_mainMeetingProperties, _this__tsCall_meetingDetails_breakoutDetails, _this__tsCall_meetingDetails, _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties, _this__tsCall_meetingDetails_breakoutDetails1, _this__tsCall_meetingDetails1;
                if (((_this__mainMeeting = this._mainMeeting) === null || _this__mainMeeting === void 0 ? void 0 : _this__mainMeeting.role) == sS.Organizer || ((_this__mainMeeting1 = this._mainMeeting) === null || _this__mainMeeting1 === void 0 ? void 0 : _this__mainMeeting1.role) == sS.Coorganizer) return !0;
                const g = this._callAgent.getUserMri(), f = ((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails = _this__tsCall_meetingDetails.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_mainMeetingProperties = _this__tsCall_meetingDetails_breakoutDetails.mainMeetingProperties) === null || _this__tsCall_meetingDetails_breakoutDetails_mainMeetingProperties === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_mainMeetingProperties.breakoutRoomManagers) || ((_this__tsCall_meetingDetails1 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails1 = _this__tsCall_meetingDetails1.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties = _this__tsCall_meetingDetails_breakoutDetails1.breakoutRoomProperties) === null || _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties.breakoutRoomManagers);
                if (null == f || 0 == (f === null || f === void 0 ? void 0 : f.length)) return !1;
                return !!f.find((f)=>f.id === g);
            }
            return !1;
        }
        async joinMainMeetingWithoutModalities(g) {
            this._callAgent.subscribeCallWithoutModality(g).then((g)=>{
                var _this__logger;
                if (g.isSubscribedCall = !0, this._mainMeeting = g, g) {
                    let f = this._callAgent.getCallByCallId(g.id);
                    f && (this._breakoutRoomsCallFeature.initialize({
                        tsCall: f,
                        call: g,
                        callAgent: this._callAgent,
                        telemetryLogManager: this._telemetryLogManager
                    }, this._logger), this._breakoutRoomsCallFeature.on("breakoutRoomsUpdatedInternal", (g)=>{
                        var _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl;
                        (_this__breakoutRoomsService_breakoutRoomsCallFeatureImpl = this._breakoutRoomsService.breakoutRoomsCallFeatureImpl) === null || _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl === void 0 ? void 0 : _this__breakoutRoomsService_breakoutRoomsCallFeatureImpl.emitBreakoutRoomsEvents(g);
                    }));
                }
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Joined main meeting without modalities successfully"), this._sendFeatureUsage("SubscribedCallJoinSuccess", uy.success);
            }).catch((g)=>{
                var _this__logger;
                throw (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.error("Error in joining the  main meeting without modalities", g), this._sendFeatureUsage("SubscribedCallJoinFailed", uy.failure), g;
            });
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? extractCommunicationServicesErrorForTelemetry(S) : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "BreakoutRooms",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g, f, S, v, _, C, E, T){
            this._logger = v.createChild(()=>"BreakoutRooms"), this._logger.log("created"), this._tsCall = g, this._mainMeeting = S, this._callAgent = f, this._telemetryLogManager = C, this.state = "closed", this._eventEmitter = _, this.threadId = "", this._breakoutRoomsCallFeature = E, this._breakoutRoomsService = T, this._hangUpCallDelayInMilliSeconds = getAcsEcsConfig().calling.breakoutRooms.hangUpCallDelayInMilliSeconds;
        }
    }
    function isLongMeetingUrl(g) {
        const f = new URL(g), S = f.pathname.split("/"), v = decodeURIComponent(S[3]);
        var _f_searchParams_get;
        return !!((_f_searchParams_get = f.searchParams.get("context")) !== null && _f_searchParams_get !== void 0 ? _f_searchParams_get : void 0) && !!v;
    }
    function isShortMeetingUrl(g, f) {
        let S = !0;
        try {
            const f = new URL(g);
            if (getAcsEcsConfig().teamsMeetingShortUrlJoin.validatePattern) {
                const g = new RegExp(getAcsEcsConfig().teamsMeetingShortUrlJoin.regexPattern);
                S = !!f.toString().trim().match(g);
            }
        } catch (g) {
            f.error(`Teams Meeting url validation failed with error= ${JSON.stringify(g)}`), S = !1;
        }
        return S;
    }
    function isTflMeetingLink(g, f) {
        return f.some((f)=>g.includes(f.trim().toLocaleLowerCase()));
    }
    function parseLongMeetingLink(g) {
        try {
            const f = new URL(g), S = f.pathname.split("/"), v = decodeURIComponent(S[3]), _ = S[4], C = JSON.parse(decodeURIComponent(f.search.replace("?context=", ""))), E = C.Oid;
            return {
                threadId: v,
                messageId: _,
                organizerId: E,
                tenantId: C.Tid
            };
        } catch (g) {
            throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INVALID_MEETING_LINK,
                originalError: g
            });
        }
    }
    function base64UrlEncoding(g) {
        let f = btoa(g).replace(/=/g, "");
        f = f.replace(/\+/g, "-"), f = f.replace(/\//g, "_");
        for (const g of f)if (g.match(/[^A-Za-z0-9-_]/)) throw new CallingCommunicationError({
            defaultError: O.CALL.SERVER_CALL_ID
        });
        return f;
    }
    class BreakoutRoomsUpdatesManagerImpl {
        initialize(g) {
            g.changed(()=>{
                this._logger.log("tsCall changed event with breakoutroom details"), this.updateBreakoutDetails();
            });
        }
        get breakoutRoomAssigned() {
            return this._breakoutRoomAssigned = this._breakoutRoomAssignedInternal, this._breakoutRoomAssigned;
        }
        get breakoutRooms() {
            return this._breakoutRooms = this._breakoutRoomsInternal, this._breakoutRooms;
        }
        get breakoutRoomSettings() {
            return this._breakoutRoomSettings = this._breakoutRoomSettingsInternal, this._breakoutRoomSettings;
        }
        emitBreakoutRoomsEvents(g) {
            this._eventEmitter.emit("breakoutRoomsUpdated", g);
        }
        updateBreakoutDetails() {
            try {
                var _this__tsCall_breakoutDetails_mainMeetingProperties, _this__tsCall_breakoutDetails, _this__tsCall_breakoutDetails_mainMeetingProperties1, _this__tsCall_breakoutDetails1, _this__tsCall_breakoutDetails_mainMeetingProperties2, _this__tsCall_breakoutDetails2, _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms, _this__tsCall_breakoutDetails_mainMeetingProperties3, _this__tsCall_breakoutDetails3, _this__tsCall_breakoutDetails_mainMeetingProperties4, _this__tsCall_breakoutDetails4, _this__tsCall_meetingDetails_breakoutDetails, _this__tsCall_meetingDetails, _this__tsCall_meetingDetails_breakoutDetails1, _this__tsCall_meetingDetails1, _this__tsCall_meetingDetails_breakoutDetails2, _this__tsCall_meetingDetails2;
                if (((_this__tsCall_breakoutDetails = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties = _this__tsCall_breakoutDetails.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties.assignedBreakoutRooms) && ((_this__tsCall_breakoutDetails1 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails1 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties1 = _this__tsCall_breakoutDetails1.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties1 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties1.assignedBreakoutRooms.length) > 0) {
                    var _this__tsCall_breakoutDetails_mainMeetingProperties5, _this__tsCall_breakoutDetails5, _this__tsCall_breakoutDetails_mainMeetingProperties6, _this__tsCall_breakoutDetails6, _this__tsCall_breakoutDetails_mainMeetingProperties7, _this__tsCall_breakoutDetails7, _this__logger;
                    if (this.hasBreakoutRooomsAssigned((_this__tsCall_breakoutDetails5 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails5 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties5 = _this__tsCall_breakoutDetails5.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties5 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties5.assignedBreakoutRooms[0]) || this.hasBreakoutRooomsAssignmentChanged((_this__tsCall_breakoutDetails6 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails6 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties6 = _this__tsCall_breakoutDetails6.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties6 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties6.assignedBreakoutRooms[0])) {
                        var _this__logger1, _this__tsCall_breakoutDetails_mainMeetingProperties8, _this__tsCall_breakoutDetails8, _this__logger2, _this__breakoutRoomAssignedInternal, _this__breakoutRoomAssignedInternal_call, _this__breakoutRoomAssignedInternal1;
                        (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("breakoutroom is assigned");
                        var _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_;
                        const g = (_this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_ = (_this__tsCall_breakoutDetails8 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails8 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties8 = _this__tsCall_breakoutDetails8.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties8 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties8.assignedBreakoutRooms[0]) !== null && _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_ !== void 0 ? _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_ : null;
                        if (null != this._breakoutRoomAssignedInternal && ((_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info("New breakout room is assigned"), this.breakoutRoomsService.isNewBreakoutRoomAssigned = ((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.url) != (g === null || g === void 0 ? void 0 : g.meetingJoinUrl), this.breakoutRoomsService.isNewBreakoutRoomAssigned && (this.breakoutRoomsService.breakoutRoomCallId = (_this__breakoutRoomAssignedInternal1 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal1 === void 0 ? void 0 : (_this__breakoutRoomAssignedInternal_call = _this__breakoutRoomAssignedInternal1.call) === null || _this__breakoutRoomAssignedInternal_call === void 0 ? void 0 : _this__breakoutRoomAssignedInternal_call.id)), g) {
                            this._breakoutRoomAssignedInternal = this.updateAssignedBreakoutRoomDetails(g);
                            const f = {
                                type: "assignedBreakoutRooms",
                                data: this.breakoutRoomAssigned
                            };
                            this.emitBreakoutRoomsUpdated(f);
                        }
                        this.canJoinBreakoutRoom() && this.joinBreakoutRoom(), this._currentCall.isSubscribedCall && this._breakoutRoomAssignedInternal && !this.breakoutRoomsService.isNewBreakoutRoomAssigned && this.breakoutRoomsService.breakoutRoomCallId && (this._breakoutRoomAssignedInternal.call = this._callAgent.calls.find((g)=>g.id === this.breakoutRoomsService.breakoutRoomCallId), this.breakoutRoomsService.breakoutRoomCallId = void 0), this.breakoutRoomsService.isMainMeetingRejoin && (this.breakoutRoomsService.isMainMeetingRejoin = !1);
                    }
                    this.hasBreakoutRoomsStateChanged((_this__tsCall_breakoutDetails7 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails7 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties7 = _this__tsCall_breakoutDetails7.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties7 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties7.assignedBreakoutRooms[0]) && ((_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("breakoutroom state changed"), this.handleBreakoutRoomStateChanged());
                }
                if (this._breakoutRoomAssignedInternal && null == ((_this__tsCall_breakoutDetails2 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails2 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties2 = _this__tsCall_breakoutDetails2.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties2 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties2.assignedBreakoutRooms) || 0 == ((_this__tsCall_breakoutDetails3 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails3 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties3 = _this__tsCall_breakoutDetails3.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties3 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms = _this__tsCall_breakoutDetails_mainMeetingProperties3.assignedBreakoutRooms) === null || _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms.length)) {
                    this._breakoutRoomAssignedInternal = void 0;
                    const g = {
                        type: "assignedBreakoutRooms",
                        data: this.breakoutRoomAssigned
                    };
                    this.emitBreakoutRoomsUpdated(g);
                }
                if (this.hasAllBreakoutRoomsAvailable((_this__tsCall_breakoutDetails4 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails4 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties4 = _this__tsCall_breakoutDetails4.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties4 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties4.allBreakoutRooms)) {
                    var _this__logger3, _this__tsCall_breakoutDetails_mainMeetingProperties9, _this__tsCall_breakoutDetails9;
                    (_this__logger3 = this._logger) === null || _this__logger3 === void 0 ? void 0 : _this__logger3.info("all breakoutrooms available"), this.parseBreakoutRooms((_this__tsCall_breakoutDetails9 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails9 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties9 = _this__tsCall_breakoutDetails9.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties9 === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties9.allBreakoutRooms);
                    const g = {
                        type: "breakoutRooms",
                        data: this.breakoutRooms
                    };
                    this._eventEmitter.emit("breakoutRoomsUpdated", g);
                }
                if (((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails = _this__tsCall_meetingDetails.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails.breakoutRoomProperties) && this.hasbreakoutRoomSettingsAvailable((_this__tsCall_meetingDetails1 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails1 = _this__tsCall_meetingDetails1.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails1 === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails1.breakoutRoomProperties) || this.hasbreakoutRoomSettingsUpdated((_this__tsCall_meetingDetails2 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails2 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails2 = _this__tsCall_meetingDetails2.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails2 === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails2.breakoutRoomProperties)) {
                    var _this__logger4;
                    (_this__logger4 = this._logger) === null || _this__logger4 === void 0 ? void 0 : _this__logger4.info("breakoutroom settings are available"), this.updateBreakoutRoomSettings(), this.breakoutRoomsService.breakoutRoomsCallFeatureImpl = this._breakoutRoomsCallFeature;
                    const g = {
                        type: "breakoutRoomsSettings",
                        data: this.breakoutRoomSettings
                    };
                    this._currentCall.isBreakoutRoomCall = !0, this._eventEmitter.emit("breakoutRoomsUpdated", g);
                }
            } catch (g) {
                throw this._logger.error("Could not Update Breakout details.", g), this._sendFeatureUsage("UpdateBreakoutDetails", uy.failure), new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.BREAKOUT_ROOMS_UPDATEFAILED,
                    originalError: g
                });
            }
        }
        updateAssignedBreakoutRoomDetails(g) {
            let f = this.breakoutRoom;
            return this.assignBreakoutRoomProperties(g, f), f;
        }
        assignBreakoutRoomProperties(g, f) {
            var _parseLongMeetingLink;
            f.autoMoveParticipantToBreakoutRoom = g === null || g === void 0 ? void 0 : g.allowMoveParticipantsAutomatically, f.displayName = g === null || g === void 0 ? void 0 : g.name, f.url = g === null || g === void 0 ? void 0 : g.meetingJoinUrl, f.threadId = (g === null || g === void 0 ? void 0 : g.meetingJoinUrl) && ((_parseLongMeetingLink = parseLongMeetingLink(g === null || g === void 0 ? void 0 : g.meetingJoinUrl)) === null || _parseLongMeetingLink === void 0 ? void 0 : _parseLongMeetingLink.threadId) || "", f.state = (g === null || g === void 0 ? void 0 : g.isOpen) ? "open" : "closed";
        }
        emitBreakoutRoomsUpdated(g) {
            !this._currentCall.isSubscribedCall && this._eventEmitter.emit("breakoutRoomsUpdated", g), this._currentCall.isSubscribedCall && this._eventEmitter.emit("breakoutRoomsUpdatedInternal", g);
        }
        canJoinBreakoutRoom() {
            var _this__breakoutRoomAssignedInternal, _this__breakoutRoomAssignedInternal1;
            return "open" == ((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.state) && ((_this__breakoutRoomAssignedInternal1 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal1 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal1.autoMoveParticipantToBreakoutRoom) && (this._currentCall.isSubscribedCall && this.breakoutRoomsService.isNewBreakoutRoomAssigned || !this._currentCall.isSubscribedCall && !this.breakoutRoomsService.isMainMeetingRejoin);
        }
        async handleBreakoutRoomStateChanged() {
            var _this__breakoutRoomAssignedInternal;
            if (this._breakoutRoomAssignedInternal && ((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.state)) {
                var _this__tsCall_breakoutDetails_mainMeetingProperties, _this__tsCall_breakoutDetails, _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_, _this__tsCall_breakoutDetails_mainMeetingProperties1, _this__tsCall_breakoutDetails1, _this__breakoutRoomAssignedInternal1, _this__logger, _this__breakoutRoomAssignedInternal2, _this__breakoutRoomAssignedInternal3, _this__breakoutRoomAssignedInternal4;
                this._breakoutRoomAssignedInternal.state = ((_this__tsCall_breakoutDetails = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties = _this__tsCall_breakoutDetails.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties.assignedBreakoutRooms) && ((_this__tsCall_breakoutDetails1 = this._tsCall.breakoutDetails) === null || _this__tsCall_breakoutDetails1 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties1 = _this__tsCall_breakoutDetails1.mainMeetingProperties) === null || _this__tsCall_breakoutDetails_mainMeetingProperties1 === void 0 ? void 0 : (_this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_ = _this__tsCall_breakoutDetails_mainMeetingProperties1.assignedBreakoutRooms[0]) === null || _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_ === void 0 ? void 0 : _this__tsCall_breakoutDetails_mainMeetingProperties_assignedBreakoutRooms_.isOpen) ? "open" : "closed", (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("breakoutroom state is changed to ", (_this__breakoutRoomAssignedInternal1 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal1 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal1.state);
                const g = {
                    type: "assignedBreakoutRooms",
                    data: this.breakoutRoomAssigned
                };
                this.emitBreakoutRoomsUpdated(g), "open" === ((_this__breakoutRoomAssignedInternal2 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal2 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal2.state) && ((_this__breakoutRoomAssignedInternal3 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal3 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal3.autoMoveParticipantToBreakoutRoom) ? this.joinBreakoutRoom() : "closed" === ((_this__breakoutRoomAssignedInternal4 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal4 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal4.state) && (this.breakoutRoomsService.isMainMeetingRejoin = !1, await this._breakoutRoomAssignedInternal.hangUp(this._breakoutRoomAssignedInternal.call));
            }
        }
        joinBreakoutRoom() {
            try {
                var _this__logger;
                (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("joining breakout room call"), setTimeout(()=>{
                    var _this__breakoutRoomAssignedInternal;
                    (_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.join().then((g)=>{
                        var _this__logger;
                        this._breakoutRoomAssignedInternal && (this._breakoutRoomAssignedInternal.call = g), (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Breakout room call joined successfully");
                    });
                }, this._autoMoveInMs);
            } catch (g) {
                var _this__logger1;
                throw (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.error(g), g;
            }
        }
        hasbreakoutRoomSettingsAvailable(g) {
            return null != g && void 0 === this._breakoutRoomSettingsInternal;
        }
        hasbreakoutRoomSettingsUpdated(g) {
            var _this__breakoutRoomSettingsInternal, _g_additionalData, _this__breakoutRoomSettingsInternal1;
            return null != g && null == this._breakoutRoomSettingsInternal || (g === null || g === void 0 ? void 0 : g.roomEndTime) != ((_this__breakoutRoomSettingsInternal = this._breakoutRoomSettingsInternal) === null || _this__breakoutRoomSettingsInternal === void 0 ? void 0 : _this__breakoutRoomSettingsInternal.roomEndTime) || (g === null || g === void 0 ? void 0 : (_g_additionalData = g.additionalData) === null || _g_additionalData === void 0 ? void 0 : _g_additionalData.allowJoinBackToMainMeeting) != ((_this__breakoutRoomSettingsInternal1 = this._breakoutRoomSettingsInternal) === null || _this__breakoutRoomSettingsInternal1 === void 0 ? void 0 : _this__breakoutRoomSettingsInternal1.disableReturnToMainMeeting);
        }
        updateBreakoutRoomSettings() {
            var _this__tsCall_meetingDetails_breakoutDetails_additionalData, _this__tsCall_meetingDetails_breakoutDetails, _this__tsCall_meetingDetails, _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties, _this__tsCall_meetingDetails_breakoutDetails1, _this__tsCall_meetingDetails1, _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties1, _this__tsCall_meetingDetails_breakoutDetails2, _this__tsCall_meetingDetails2, _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties2, _this__tsCall_meetingDetails_breakoutDetails3, _this__tsCall_meetingDetails3;
            this._breakoutRoomSettingsInternal = {
                disableReturnToMainMeeting: !("true" === ((_this__tsCall_meetingDetails = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails = _this__tsCall_meetingDetails.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_additionalData = _this__tsCall_meetingDetails_breakoutDetails.additionalData) === null || _this__tsCall_meetingDetails_breakoutDetails_additionalData === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_additionalData.allowJoinBackToMainMeeting.toLowerCase()))
            }, ((_this__tsCall_meetingDetails1 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails1 = _this__tsCall_meetingDetails1.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails1 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties = _this__tsCall_meetingDetails_breakoutDetails1.breakoutRoomProperties) === null || _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties.roomEndTime) && (this._breakoutRoomSettingsInternal.roomEndTime = (_this__tsCall_meetingDetails2 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails2 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails2 = _this__tsCall_meetingDetails2.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails2 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties1 = _this__tsCall_meetingDetails_breakoutDetails2.breakoutRoomProperties) === null || _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties1 === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties1.roomEndTime), this.breakoutRoomsService.mainMeetingjoinLink = (_this__tsCall_meetingDetails3 = this._tsCall.meetingDetails) === null || _this__tsCall_meetingDetails3 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails3 = _this__tsCall_meetingDetails3.breakoutDetails) === null || _this__tsCall_meetingDetails_breakoutDetails3 === void 0 ? void 0 : (_this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties2 = _this__tsCall_meetingDetails_breakoutDetails3.breakoutRoomProperties) === null || _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties2 === void 0 ? void 0 : _this__tsCall_meetingDetails_breakoutDetails_breakoutRoomProperties2.mainMeetingJoinUrl;
        }
        parseBreakoutRooms(g) {
            this._breakoutRoomsInternal = g.map((g)=>{
                let f = new BreakoutRoomImpl(this._tsCall, this._callAgent, this._currentCall, this._logger, this._eventEmitter, this._telemetryLogManager, this._breakoutRoomsCallFeature, this.breakoutRoomsService);
                return this.assignBreakoutRoomProperties(g, f), f.invitees = g.invitees.map((g)=>constructIdentifierKindFromMri(g.id)), f;
            });
        }
        hasAllBreakoutRoomsAvailable(g) {
            var _this__breakoutRoomsInternal, _this__breakoutRooms, _this__breakoutRoomsInternal1;
            return !!((g === null || g === void 0 ? void 0 : g.length) > 0 && 0 == ((_this__breakoutRoomsInternal = this._breakoutRoomsInternal) === null || _this__breakoutRoomsInternal === void 0 ? void 0 : _this__breakoutRoomsInternal.length) || (g === null || g === void 0 ? void 0 : g.length) != ((_this__breakoutRooms = this._breakoutRooms) === null || _this__breakoutRooms === void 0 ? void 0 : _this__breakoutRooms.length) || this.hasAllBreakoutRoomsPropertiesChanged(g) || this._breakoutRoomsInternal && ((_this__breakoutRoomsInternal1 = this._breakoutRoomsInternal) === null || _this__breakoutRoomsInternal1 === void 0 ? void 0 : _this__breakoutRoomsInternal1.length) > 0 && 0 == (g === null || g === void 0 ? void 0 : g.length));
        }
        hasAllBreakoutRoomsPropertiesChanged(g) {
            return !!(g && g.length > 0 && this._breakoutRooms && this._breakoutRooms.length > 0) && g.some((g)=>{
                var _this__breakoutRoomsInternal;
                const f = (_this__breakoutRoomsInternal = this._breakoutRoomsInternal) === null || _this__breakoutRoomsInternal === void 0 ? void 0 : _this__breakoutRoomsInternal.find((f)=>g.displayName === f.displayName);
                return !f || g.isOpen !== ("open" === f.state);
            });
        }
        hasBreakoutRooomsAssigned(g) {
            var _this__breakoutRoomAssignedInternal, _this__breakoutRoomAssignedInternal1, _this__breakoutRoomAssignedInternal2;
            return (null == ((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.url) || "" == ((_this__breakoutRoomAssignedInternal1 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal1 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal1.url)) && void 0 !== (g === null || g === void 0 ? void 0 : g.meetingJoinUrl) || ((_this__breakoutRoomAssignedInternal2 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal2 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal2.displayName) != (g === null || g === void 0 ? void 0 : g.name);
        }
        hasBreakoutRooomsAssignmentChanged(g) {
            var _this__breakoutRoomAssignedInternal, _this__breakoutRoomAssignedInternal1, _this__breakoutRoomAssignedInternal2;
            return !!(((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.url) && g && void 0 !== (g === null || g === void 0 ? void 0 : g.meetingJoinUrl) && ((_this__breakoutRoomAssignedInternal1 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal1 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal1.url) != (g === null || g === void 0 ? void 0 : g.meetingJoinUrl) || ((_this__breakoutRoomAssignedInternal2 = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal2 === void 0 ? void 0 : _this__breakoutRoomAssignedInternal2.autoMoveParticipantToBreakoutRoom) != (g === null || g === void 0 ? void 0 : g.allowMoveParticipantsAutomatically));
        }
        hasBreakoutRoomsStateChanged(g) {
            return !(!this._breakoutRoomAssignedInternal || this.isBreakoutRoomOpen() == g.isOpen);
        }
        isBreakoutRoomOpen() {
            var _this__breakoutRoomAssignedInternal;
            return "open" === ((_this__breakoutRoomAssignedInternal = this._breakoutRoomAssignedInternal) === null || _this__breakoutRoomAssignedInternal === void 0 ? void 0 : _this__breakoutRoomAssignedInternal.state);
        }
        _sendFeatureUsage(g, f, S) {
            let v = S ? extractCommunicationServicesErrorForTelemetry(S) : void 0;
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "BreakoutRooms",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: v
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g, f, S, v, _, C, E, T){
            this._autoMoveInMs = getAcsEcsConfig().calling.breakoutRooms.autoMoveInMilliSeconds, this._eventEmitter = E, this._tsCall = g, this._currentCall = S, this._telemetryLogManager = v, this._callAgent = f, this._logger = _, this._breakoutRoomsCallFeature = C, this.breakoutRoomsService = T, this.breakoutRoom = new BreakoutRoomImpl(this._tsCall, this._callAgent, this._currentCall, this._logger, E, this._telemetryLogManager, this._breakoutRoomsCallFeature, this.breakoutRoomsService);
        }
    }
    class BreakoutRoomsService {
        emit(g, f) {
            !g && this._eventEmitter.emit("breakoutRoomsUpdated", f), g && this._eventEmitter.emit("breakoutRoomsUpdatedInternal", f);
        }
        subscribe(g) {
            this._eventEmitter.on("breakoutRoomsUpdatedInternal", g);
        }
        static getInstance(g) {
            return BreakoutRoomsService.instance || (BreakoutRoomsService.instance = new BreakoutRoomsService(g)), BreakoutRoomsService.instance;
        }
        dispose() {
            BreakoutRoomsService.instance = void 0;
        }
        constructor(g){
            this._eventEmitter = g;
        }
    }
    class BreakoutRoomsCallFeatureImpl extends FirstPartyCallFeature {
        get name() {
            return "BreakoutRooms";
        }
        initialize(g, f) {
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._tsCall = g.tsCall, this._impl.initialize(this._tsCall, g.callAgent, g.call, g.telemetryLogManager, f, this.breakoutRoomsService);
        }
        get assignedBreakoutRooms() {
            return this._impl.breakoutRoomAssigned;
        }
        get breakoutRooms() {
            return this._impl.breakoutRooms;
        }
        get breakoutRoomsSettings() {
            return this._impl.breakoutRoomSettings;
        }
        emitBreakoutRoomsEvents(g) {
            this._impl.emitBreakoutRoomsEvents(g);
        }
        on(g, f) {
            this._sendFeatureUsage(g, uy.subscribe), this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this._sendFeatureUsage(g, uy.unsubscribe), this.eventEmitter.off(g, f);
        }
        _sendFeatureUsage(g, f) {
            sendCallFeatureUsageTelemetry({
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "BreakoutRooms",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        dispose() {
            this.disposed || super.dispose();
        }
        constructor(g){
            super(g), this._impl = new BreakoutRoomsCallImplOverTsCall(this.eventEmitter, this), this.breakoutRoomsService = BreakoutRoomsService.getInstance(this.eventEmitter);
        }
    }
    class BreakoutRoomsCallImplOverTsCall {
        initialize(g, f, S, v, _, C) {
            this._logger = _.createChild(()=>`BreakoutRoomsFeature::Call(id='${g.callId}')`), this._tsCall = g, this._internalCallAgent = f;
            const E = "initialize";
            if (this._breakoutRoomsImpl = new BreakoutRoomsUpdatesManagerImpl(g, f, S, v, _, this._breakoutRoomsCallFeature, this._eventEmitter, C), this._breakoutRoomsImpl._sendFeatureUsage(E, uy.attempt), !this._isEnabled) {
                const g = "Breakoutrooms feature is is disabled", f = new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.DISABLED
                });
                throw this._breakoutRoomsImpl._sendFeatureUsage(E, uy.failure, f), this._logger.error(g), f;
            }
            if (3 === this._tsCall.state && !this._supportedConversationTypes.includes(g.conversationType)) {
                const g = "Breakout rooms feature is only available in meetings", f = new CallingCommunicationError({
                    defaultError: O.FEATURES.BREAKOUT_ROOMS.ONLY_AVAILABLE_IN_MEETINGS
                });
                throw this._breakoutRoomsImpl._sendFeatureUsage(E, uy.failure, f), this._logger.error(g), f;
            }
            this._breakoutRoomsImpl.initialize(this._tsCall), this._breakoutRoomsImpl._sendFeatureUsage(E, uy.success);
        }
        get breakoutRoomAssigned() {
            return this._breakoutRoomsImpl.breakoutRoomAssigned;
        }
        get breakoutRooms() {
            return this._breakoutRoomsImpl.breakoutRooms;
        }
        get breakoutRoomSettings() {
            return this._breakoutRoomsImpl.breakoutRoomSettings;
        }
        emitBreakoutRoomsEvents(g) {
            return this._breakoutRoomsImpl.emitBreakoutRoomsEvents(g);
        }
        constructor(g, f){
            this._isEnabled = getAcsEcsConfig().calling.breakoutRooms.enabled, this._supportedConversationTypes = getAcsEcsConfig().calling.breakoutRooms.supportedConversationTypes, this._eventEmitter = g, this._breakoutRoomsCallFeature = f;
        }
    }
    const db = 24, ub = 3e3, hb = 300, gb = 2e3;
    var pb;
    !function(g) {
        g.Initialize = "initialize", g.Dispose = "dispose", g.RealTimeTextReceived = "realTimeTextReceived", g.SendRealTimeText = "sendRealTimeText", g.StartDataChannel = "startDataChannel", g.LockTimerToDataChannel = "lockTimerToDataChannel", g.SendTimerToDataChannel = "sendTimerToDataChannel", g.RealTimeTextStarted = "realTimeTextStarted";
    }(pb || (pb = {}));
    class RealTimeTextFeatureImpl extends FirstPartyCallFeature {
        initialize(g, f) {
            const S = generateGuid();
            this._logger = f, this._telemetryLogManager = g.telemetryLogManager, this._call = g.call, this._sendFeatureUsage(pb.Initialize, uy.initialize, S), this._impl.initialize(g.tsCall, g.call, g.callAgent, g.telemetryLogManager, f, S);
        }
        get name() {
            return "RealTimeText";
        }
        async sendRealTimeText(g, f) {
            await this._impl.sendRealTimeText(g, f);
        }
        on(g, f) {
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            this.eventEmitter.off(g, f);
        }
        dispose() {
            this._sendFeatureUsage(pb.Dispose, uy.attempt), this.disposed ? this._sendFeatureUsage(pb.Dispose, uy.failure) : (this._impl.dispose(), super.dispose(), this._sendFeatureUsage(pb.Dispose, uy.success));
        }
        _sendFeatureUsage(g, f, S) {
            sendCallFeatureUsageTelemetry({
                correlationId: S,
                callId: this._call.id,
                localParticipantId: this._call.tsCall.participantId,
                featureName: this.name,
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                }
            }, this._telemetryLogManager, this._logger);
        }
        constructor(g){
            super(g), this._impl = new RealTimeTextFeatureImplOverTsCall(this.eventEmitter);
        }
    }
    class RealTimeTextFeatureImplOverTsCall {
        initialize(g, f, S, v, _, C) {
            this._logger = _, this._tsCall = g, this._call = f, this._internalCallAgent = S, this._telemetryLogManager = v;
            try {
                this._userMri = this._internalCallAgent.getUserMri(), this._rttDataChannelAdapter = new DataChannelAdapter(g, db), this._participantMappingManager = new ParticipantMappingManager$1(g), this._textDecoder = new TextDecoder, this._textEncoder = new TextEncoder, this.startDataChannel(C);
            } catch (g) {
                const f = new CallingCommunicationError({
                    originalError: g,
                    defaultError: O.FEATURES.REAL_TIME_TEXT.INITIALIZE_FAILED
                });
                throw this._sendFeatureUsage(pb.Initialize, uy.failure, C, f), f;
            }
        }
        startDataChannel(g) {
            try {
                this._rttDataChannelAdapter || (this._rttDataChannelAdapter = new DataChannelAdapter(this._tsCall, db)), this._dataChannelInitialized || (this._rttDataChannelAdapter.initialize().then(()=>{
                    this._dataChannelInitialized = !0;
                }), this._rttDataChannelAdapter.off("message", this._dataChannelHandler), this._rttDataChannelAdapter.on("message", this._dataChannelHandler));
            } catch (f) {
                const S = new CallingCommunicationError({
                    originalError: f,
                    defaultError: O.FEATURES.REAL_TIME_TEXT.START_REAL_TIME_TEXT_FAILED
                });
                throw this._sendFeatureUsage(pb.StartDataChannel, uy.failure, g, S), S;
            }
        }
        async sendRealTimeText(g, f) {
            const S = generateGuid();
            this.startDataChannel(S), this._sendFeatureUsage(pb.SendRealTimeText, uy.attempt, S);
            try {
                var _this__entries_get, _this__entries_get1;
                if ("" === g && (!this._entries.get(this._userMri) || "Final" === ((_this__entries_get = this._entries.get(this._userMri)) === null || _this__entries_get === void 0 ? void 0 : _this__entries_get.resultType))) return;
                if (!f && g === ((_this__entries_get1 = this._entries.get(this._userMri)) === null || _this__entries_get1 === void 0 ? void 0 : _this__entries_get1.text)) return;
                if (g.length >= gb) throw new CallingCommunicationError({
                    defaultError: O.FEATURES.REAL_TIME_TEXT.MESSAGE_LENGTH_EXCEEDS_MAX_INPUT_LENGTH
                });
                this._nextMessage = f ? g += "\n" : g, f ? (this._lockTimer && (clearTimeout(this._lockTimer), this._lockTimer = null), this._sendTimer && (clearTimeout(this._sendTimer), this._sendTimer = null), await this._purgeMessage(S, pb.SendTimerToDataChannel)) : (this._rttLockTimerToDataChannel(), this._sendTimer || this._rttSendTimerToDataChannel()), this._sendFeatureUsage(pb.SendRealTimeText, uy.success, S);
            } catch (g) {
                const f = new CallingCommunicationError({
                    originalError: g,
                    defaultError: O.FEATURES.REAL_TIME_TEXT.SEND_REAL_TIME_TEXT_MESSAGE_FAILED
                });
                throw this._sendFeatureUsage(pb.SendRealTimeText, uy.failure, S, f), f;
            }
        }
        async _purgeMessage(g, f) {
            var _this__entries_get;
            var _this__entries_get_text;
            const S = encodeMessage((_this__entries_get_text = (_this__entries_get = this._entries.get(this._userMri)) === null || _this__entries_get === void 0 ? void 0 : _this__entries_get.text) !== null && _this__entries_get_text !== void 0 ? _this__entries_get_text : "", this._nextMessage);
            if ("" !== S) {
                if (void 0 === this._textEncoder) throw new Error("TextEncoder undefined.");
                let v = this._textEncoder.encode(JSON.stringify({
                    s: S
                }));
                this._updateEntries(this._internalCallAgent.getUserMri(), S);
                try {
                    var _this__rttDataChannelAdapter;
                    await ((_this__rttDataChannelAdapter = this._rttDataChannelAdapter) === null || _this__rttDataChannelAdapter === void 0 ? void 0 : _this__rttDataChannelAdapter.send(v)), this._sendFirstMessageReceivedOrSentTelemetry();
                } catch (S) {
                    const v = new CallingCommunicationError({
                        defaultError: O.FEATURES.REAL_TIME_TEXT.SEND_DATA_CHANNEL_MESSAGE_FAILED
                    });
                    throw this._sendFeatureUsage(f, uy.failure, g), v;
                }
                this._nextMessage = "", S.includes("\n") ? (this._lockTimer && (clearTimeout(this._lockTimer), this._lockTimer = null), this._entries.delete(this._userMri)) : this._rttLockTimerToDataChannel(), this._sendTimer && (clearTimeout(this._sendTimer), this._sendTimer = null), this._sendFeatureUsage(f, uy.success, g);
            }
        }
        dispose() {
            this._textDecoder = void 0;
        }
        _sendFeatureUsage(g, f, S, v) {
            const _ = v && extractCommunicationServicesErrorForTelemetry(v);
            sendCallFeatureUsageTelemetry({
                correlationId: S,
                callId: this._tsCall.callId,
                localParticipantId: this._tsCall.participantId,
                featureName: "RealTimeText",
                featureType: "Call",
                initializationType: "OnFeatureAccess",
                featureDetails: {
                    name: g,
                    step: f
                },
                additionalDetails: _
            }, this._telemetryLogManager, this._logger);
        }
        _sendFirstMessageReceivedOrSentTelemetry() {
            this._firstMessageReceivedOrSent || (this._sendFeatureUsage(pb.RealTimeTextStarted, uy.event), this._firstMessageReceivedOrSent = !0);
        }
        constructor(g){
            this._eventEmitter = g, this._dataChannelInitialized = !1, this._firstMessageReceivedOrSent = !1, this._entries = new Map, this.sequenceId = 0, this._userMri = "", this._nextMessage = "", this._rttSendTimerToDataChannel = ()=>{
                const g = generateGuid();
                this._sendTimer = setTimeout(async ()=>{
                    this._sendFeatureUsage(pb.SendTimerToDataChannel, uy.attempt, g), this._nextMessage.includes("\n") && this._lockTimer && (clearTimeout(this._lockTimer), this._lockTimer = null), await this._purgeMessage(g, pb.SendTimerToDataChannel);
                }, hb);
            }, this._rttLockTimerToDataChannel = ()=>{
                const g = generateGuid();
                this._lockTimer && (clearTimeout(this._lockTimer), this._lockTimer = null), this._lockTimer = setTimeout(async ()=>{
                    var _this__entries_get, _this__entries_get1;
                    this._sendFeatureUsage(pb.LockTimerToDataChannel, uy.attempt, g);
                    var _this__entries_get_text;
                    let f = (_this__entries_get_text = (_this__entries_get = this._entries.get(this._userMri)) === null || _this__entries_get === void 0 ? void 0 : _this__entries_get.text) !== null && _this__entries_get_text !== void 0 ? _this__entries_get_text : "";
                    ("" !== f.trim() || this._entries.get(this._userMri) && "Final" !== ((_this__entries_get1 = this._entries.get(this._userMri)) === null || _this__entries_get1 === void 0 ? void 0 : _this__entries_get1.resultType)) && (this._nextMessage = f + "\n", await this._purgeMessage(g, pb.LockTimerToDataChannel));
                }, ub);
            }, this._dataChannelHandler = (g)=>{
                let f, { sourceId: S, data: v } = g;
                const _ = generateGuid();
                try {
                    this._sendFeatureUsage(pb.RealTimeTextReceived, uy.attempt, _), f = JSON.parse(v.toString());
                } catch (g) {
                    try {
                        if (void 0 === this._textDecoder) throw new Error("TextDecoder undefined.");
                        f = JSON.parse(this._textDecoder.decode(v));
                    } catch (g) {
                        this._logger.error("Failed to parse RealTimeText message");
                        throw new CallingCommunicationError({
                            defaultError: O.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_PARSE_FAILED
                        });
                    }
                    try {
                        if (f && S) {
                            var _this__participantMappingManager;
                            let g = f.s, v = (_this__participantMappingManager = this._participantMappingManager) === null || _this__participantMappingManager === void 0 ? void 0 : _this__participantMappingManager.findParticipantMri(S);
                            if (!v) throw new CallingCommunicationError({
                                defaultError: O.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_CONTAINS_NO_SPEAKER
                            });
                            this._updateEntries(v, g), this._sendFirstMessageReceivedOrSentTelemetry(), this._sendFeatureUsage(pb.RealTimeTextReceived, uy.success, _);
                        }
                    } catch (g) {
                        const f = new CallingCommunicationError({
                            originalError: g,
                            defaultError: O.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_HANDLER_FAILED
                        });
                        throw this._sendFeatureUsage(pb.RealTimeTextReceived, uy.failure, _, f), f;
                    }
                }
            }, this._updateEntries = (g, f)=>{
                try {
                    var _this__entries_get;
                    let S, v = this._entries.get(g), { composedText: _, isFinal: C } = this._generateRealTimeTextMessage(f, v && "Final" !== v.resultType ? v.text : "");
                    const E = new Date, T = C ? "Final" : "Partial";
                    if (v) S = {
                        ...v,
                        sequenceId: "Final" === v.resultType ? this.sequenceId++ : v.sequenceId,
                        text: _,
                        updatedTimestamp: E,
                        resultType: T
                    };
                    else {
                        var _this__tsCall_participants_find, _this__internalCallAgent;
                        const f = ((_this__tsCall_participants_find = this._tsCall.participants.find((f)=>f.id === g)) === null || _this__tsCall_participants_find === void 0 ? void 0 : _this__tsCall_participants_find.displayName) || (this._internalCallAgent.getUserMri() === g ? (_this__internalCallAgent = this._internalCallAgent) === null || _this__internalCallAgent === void 0 ? void 0 : _this__internalCallAgent.displayName : void 0);
                        S = {
                            sequenceId: this.sequenceId++,
                            text: _,
                            sender: {
                                identifier: constructIdentifierKindFromMri(g),
                                displayName: f,
                                endpointDetails: []
                            },
                            receivedTimestamp: E,
                            updatedTimestamp: E,
                            resultType: T,
                            isLocal: this._internalCallAgent.getUserMri() === g
                        };
                    }
                    this._entries.set(g, S), this._eventEmitter.emit("realTimeTextReceived", this._entries.get(g)), "Final" === ((_this__entries_get = this._entries.get(g)) === null || _this__entries_get === void 0 ? void 0 : _this__entries_get.resultType) && this._entries.delete(g);
                } catch (g) {
                    throw new CallingCommunicationError({
                        originalError: g,
                        defaultError: O.FEATURES.REAL_TIME_TEXT.REAL_TIME_TEXT_MESSAGE_ENTRY_UPDATE_FAILED
                    });
                }
            }, this._generateRealTimeTextMessage = (g, f)=>{
                let S = f;
                for (const f of g)switch(f){
                    case "\b":
                        S = S.slice(0, -1);
                        break;
                    case "\n":
                        return {
                            composedText: S,
                            isFinal: !0
                        };
                    default:
                        S += f;
                }
                return {
                    composedText: S,
                    isFinal: !1
                };
            };
        }
    }
    const encodeMessage = (g, f)=>{
        let S = "";
        const v = Math.min(g === null || g === void 0 ? void 0 : g.length, f.length);
        let _ = -1;
        for(let C = 0; C < v; C++)g[C] !== f[C] && -1 === _ && (_ = C), -1 !== _ && (S += "\b");
        for(let f = v; f < g.length; f++)S += "\b";
        return S += -1 === _ ? f.substring(v) : f.substring(_), S;
    }, mb = {
        Recording: callFeatureFactory(RecordingCallFeatureImpl),
        Transfer: callFeatureFactory(TransferCallFeatureImpl),
        Transcription: callFeatureFactory(TranscriptionCallFeatureImpl),
        Captions: callFeatureFactory(CaptionsCallFeatureImpl),
        RaiseHand: callFeatureFactory(RaiseHandCallFeatureImpl),
        LocalRecording: callFeatureFactory(LocalRecordingCallFeatureImpl),
        Reaction: callFeatureFactory(ReactionFeatureImpl),
        Spotlight: callFeatureFactory(SpotlightCallFeatureImpl),
        PPTLive: callFeatureFactory(PPTLiveCallFeatureImpl),
        BreakoutRooms: callFeatureFactory(BreakoutRoomsCallFeatureImpl),
        Capabilities: callFeatureFactory(CapabilitiesFeatureImpl),
        DominantSpeakers: callFeatureFactory(DominantSpeakersCallFeatureImpl),
        LiveStream: callFeatureFactory(LiveStreamCallFeatureImpl),
        ComposedStream: callFeatureFactory(ComposedStreamCallFeatureImpl),
        CallSurvey: callFeatureFactory(CallSurveyFeatureImpl),
        UserFacingDiagnostics: callFeatureFactory(UserFacingDiagnosticsFeatureImpl),
        MediaStats: callFeatureFactory(MediaStatsCallFeatureImpl, {
            activationEvent: "OnExtendedObjectConstructor"
        }),
        DebugInfo: callClientFeatureFactory(DebugInfoCallClientFeatureImpl, {
            activationEvent: "OnExtendedObjectConstructor"
        }),
        PreCallDiagnostics: callClientFeatureFactory(PreCallDiagnosticsFeatureImpl),
        VideoEffects: videoStreamFeatureFactory(VideoEffectsFeatureImpl),
        AudioEffects: audioStreamFeatureFactory(AudioEffectsFeatureImpl),
        DataChannel: callFeatureFactory(DataChannelCallFeatureImpl),
        OptimalVideoCount: callFeatureFactory(OptimalVideoCountCallFeatureImpl),
        UnmixedAudio: callFeatureFactory(UnmixedAudioCallFeatureImpl),
        AudioZones: callFeatureFactory(AudioZonesCallFeatureImpl),
        TeamsMeetingAudioConferencing: callFeatureFactory(TeamsMeetingAudioConferencingCallFeatureImpl),
        TogetherMode: callFeatureFactory(TogetherModeCallFeatureImpl),
        MediaAccess: callFeatureFactory(MediaAccessCallFeatureImpl),
        RealTimeText: callFeatureFactory(RealTimeTextFeatureImpl)
    };
    function getRegisteredFeatures(g) {
        switch(g){
            case Fy.CallClientFeature:
                return Object.entries(mb).filter((g)=>!0 === g[1].isCallClientFeature).map((g)=>g[1]);
            case Fy.CallAgentFeature:
                return Object.entries(mb).filter((g)=>!0 === g[1].isCallAgentFeature).map((g)=>g[1]);
            case Fy.CallFeature:
                return Object.entries(mb).filter((g)=>!0 === g[1].isCallFeature).map((g)=>g[1]);
        }
    }
    class CallStats {
        recordEvent(g) {
            try {
                var _getAcsEcsConfig_telemetry, _getAcsEcsConfig, _getAcsEcsConfig_telemetry_blockedEvents, _getAcsEcsConfig_telemetry1, _getAcsEcsConfig1;
                if (((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_telemetry = _getAcsEcsConfig.telemetry) === null || _getAcsEcsConfig_telemetry === void 0 ? void 0 : _getAcsEcsConfig_telemetry.callStatsFlushTimeout) < 0) return;
                if (((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_telemetry1 = _getAcsEcsConfig1.telemetry) === null || _getAcsEcsConfig_telemetry1 === void 0 ? void 0 : (_getAcsEcsConfig_telemetry_blockedEvents = _getAcsEcsConfig_telemetry1.blockedEvents) === null || _getAcsEcsConfig_telemetry_blockedEvents === void 0 ? void 0 : _getAcsEcsConfig_telemetry_blockedEvents.indexOf(g.name)) > -1) return;
                const f = {
                    timestamp: +new Date,
                    ...g
                };
                this._logger.debug(`CallStat recorded=${g.name}`), this._eventBag.push(f), this.scheduleTelemetryFlush();
            } catch (g) {
                this._logger.debug("Failed to record call stats");
            }
        }
        flushEvents() {
            if (this._logger.debug(`CallStats sending telemetry, number of events=${this._eventBag.length}`), 0 !== this._eventBag.length) try {
                const g = this._eventBag.reduce((g, f)=>(g[f.localParticipantId] ? g[f.localParticipantId].events.push({
                        name: f.name,
                        timestamp: f.timestamp,
                        ...f.data
                    }) : g[f.localParticipantId] = {
                        callId: f.callId,
                        localParticipantId: f.localParticipantId,
                        events: [
                            {
                                name: f.name,
                                timestamp: f.timestamp,
                                ...f.data
                            }
                        ]
                    }, g), {});
                Object.keys(g).forEach((f)=>{
                    this._telemetryLogManager.sendEvent({
                        name: dy.acs_calling_call_stats,
                        tenant: nf,
                        properties: {
                            ...g[f]
                        }
                    });
                }), this.resetEventBag();
            } catch (g) {
                this._logger.debug("Failed to send call stats");
            }
        }
        scheduleTelemetryFlush() {
            this._callStatSendTimeout || (this._callStatSendTimeout = window.setTimeout(()=>{
                this.flushEvents(), this._callStatSendTimeout = void 0;
            }, getAcsEcsConfig().telemetry.callStatsFlushTimeout));
        }
        constructor(g, f){
            this._eventBag = [], this.resetEventBag = ()=>{
                this._eventBag = [];
            }, this._logger = g.createChild("CallStats"), this._telemetryLogManager = f;
        }
    }
    function validateCallConnected(g, f) {
        if ("Connected" === f) return;
        let S;
        if (g == IS.MuteAllRemoteParticipants) S = O.CALL.MUTE_ALL_PARTICIPANTS_CALL_NOT_CONNECTED;
        else if (g == IS.StopAudio) S = O.CALL.STOP_AUDIO_STREAM_CALL_NOT_CONNECTED;
        else if (g == IS.AddParticipant) S = O.CALL.ADD_PARTICIPANT_CALL_NOT_CONNECTED;
        else {
            if (g != IS.RemoveParticipant) return;
            S = O.CALL.REMOVE_PARTICIPANT_CALL_NOT_CONNECTED;
        }
        throw new CallingCommunicationError({
            defaultError: S
        });
    }
    class VolumeProxy {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        get level() {
            return this._volumeIndicator.level;
        }
        async setSource(g) {
            this._mediaStream !== g && (this._mediaStream && this._volumeIndicator.dispose(), g && (this._mediaStream = g, await this._volumeIndicator.getVolumeIndicator(g), this._volumeIndicator.on("levelChanged", ()=>{
                this._eventEmitter.emit("levelChanged");
            })));
        }
        dispose() {
            this._eventEmitter.removeAllListeners();
        }
        constructor(g){
            this._volumeIndicator = g, this._eventEmitter = new Ny;
        }
    }
    var __decorate$a = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$a = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class RemoteAudioStreamImpl {
        async getMediaStream() {
            return await this._source.getMediaStream();
        }
        get source() {
            return this._source;
        }
        dispose() {
            this.logger.log("dispose"), this._disposed ? this.logger.log("already disposed") : (this._volumeIndicator.dispose(), this._disposed = !0);
        }
        async getVolume() {
            if (!this._volumeProxy) {
                const g = new VolumeProxy(this._volumeIndicator), f = this._workQueue.then(async ()=>{
                    await g.setSource(await this._source.getMediaStream());
                });
                this._workQueue = f.catch(noop), await f, this._volumeProxy = g;
            }
            return this._volumeProxy;
        }
        constructor(g, S, v, _){
            this._workQueue = Promise.resolve();
            const C = f.createClientLogger("ACS-calling");
            this.logger = new DefaultLogger(C, [
                ()=>"RemoteAudioStream for media stream"
            ]), this._source = g, this._disposed = !1, this._volumeIndicator = new VolumeImpl(this.logger, "RemoteAudioStream", S, v, _), g.changed(async ()=>{
                this._volumeProxy && (this._workQueue = this._workQueue.then(async ()=>{
                    var _this__volumeProxy;
                    await ((_this__volumeProxy = this._volumeProxy) === null || _this__volumeProxy === void 0 ? void 0 : _this__volumeProxy.setSource(await this._source.getMediaStream()));
                }).catch((g)=>{
                    var _g_message;
                    this.logger.log(`source changed but failed to update volume indicator: ${(_g_message = g === null || g === void 0 ? void 0 : g.message) !== null && _g_message !== void 0 ? _g_message : "unknown error"}`);
                }));
            }), this.logger.info("created");
        }
    }
    __decorate$a([
        loggerProperty,
        __metadata$a("design:type", Object)
    ], RemoteAudioStreamImpl.prototype, "logger", void 0);
    var fb = createCommonjsModule(function(g, f) {
        !function(S, v) {
            var _ = "1.0.38", C = "", E = "?", T = "function", I = "undefined", b = "object", A = "string", R = "major", P = "model", w = "name", M = "type", O = "vendor", D = "version", N = "architecture", k = "console", L = "mobile", F = "tablet", x = "smarttv", U = "wearable", V = "embedded", B = 500, H = "Amazon", $ = "Apple", j = "ASUS", G = "BlackBerry", q = "Browser", W = "Chrome", z = "Firefox", K = "Google", J = "Huawei", Y = "LG", Q = "Microsoft", X = "Motorola", Z = "Opera", ee = "Samsung", te = "Sharp", ie = "Sony", ne = "Xiaomi", re = "Zebra", ae = "Facebook", se = "Chromium OS", oe = "Mac OS", extend = function(g, f) {
                var S = {};
                for(var v in g)f[v] && f[v].length % 2 == 0 ? S[v] = f[v].concat(g[v]) : S[v] = g[v];
                return S;
            }, enumerize = function(g) {
                for(var f = {}, S = 0; S < g.length; S++)f[g[S].toUpperCase()] = g[S];
                return f;
            }, has = function(g, f) {
                return typeof g === A && -1 !== lowerize(f).indexOf(lowerize(g));
            }, lowerize = function(g) {
                return g.toLowerCase();
            }, majorize = function(g) {
                return typeof g === A ? g.replace(/[^\d\.]/g, C).split(".")[0] : v;
            }, trim = function(g, f) {
                if (typeof g === A) return g = g.replace(/^\s\s*/, C), typeof f === I ? g : g.substring(0, B);
            }, rgxMapper = function(g, f) {
                for(var S, _, C, E, I, A, R = 0; R < f.length && !I;){
                    var P = f[R], w = f[R + 1];
                    for(S = _ = 0; S < P.length && !I && P[S];)if (I = P[S++].exec(g)) for(C = 0; C < w.length; C++)A = I[++_], typeof (E = w[C]) === b && E.length > 0 ? 2 === E.length ? typeof E[1] == T ? this[E[0]] = E[1].call(this, A) : this[E[0]] = E[1] : 3 === E.length ? typeof E[1] !== T || E[1].exec && E[1].test ? this[E[0]] = A ? A.replace(E[1], E[2]) : v : this[E[0]] = A ? E[1].call(this, A, E[2]) : v : 4 === E.length && (this[E[0]] = A ? E[3].call(this, A.replace(E[1], E[2])) : v) : this[E] = A || v;
                    R += 2;
                }
            }, strMapper = function(g, f) {
                for(var S in f)if (typeof f[S] === b && f[S].length > 0) {
                    for(var _ = 0; _ < f[S].length; _++)if (has(f[S][_], g)) return S === E ? v : S;
                } else if (has(f[S], g)) return S === E ? v : S;
                return g;
            }, le = {
                ME: "4.90",
                "NT 3.11": "NT3.51",
                "NT 4.0": "NT4.0",
                2e3: "NT 5.0",
                XP: [
                    "NT 5.1",
                    "NT 5.2"
                ],
                Vista: "NT 6.0",
                7: "NT 6.1",
                8: "NT 6.2",
                8.1: "NT 6.3",
                10: [
                    "NT 6.4",
                    "NT 10.0"
                ],
                RT: "ARM"
            }, ce = {
                browser: [
                    [
                        /\b(?:crmo|crios)\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Chrome"
                        ]
                    ],
                    [
                        /edg(?:e|ios|a)?\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Edge"
                        ]
                    ],
                    [
                        /(opera mini)\/([-\w\.]+)/i,
                        /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                        /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /opios[\/ ]+([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            Z + " Mini"
                        ]
                    ],
                    [
                        /\bop(?:rg)?x\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            Z + " GX"
                        ]
                    ],
                    [
                        /\bopr\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            Z
                        ]
                    ],
                    [
                        /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Baidu"
                        ]
                    ],
                    [
                        /(kindle)\/([\w\.]+)/i,
                        /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                        /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                        /(?:ms|\()(ie) ([\w\.]+)/i,
                        /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                        /(heytap|ovi)browser\/([\d\.]+)/i,
                        /(weibo)__([\d\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /\bddg\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "DuckDuckGo"
                        ]
                    ],
                    [
                        /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "UC" + q
                        ]
                    ],
                    [
                        /microm.+\bqbcore\/([\w\.]+)/i,
                        /\bqbcore\/([\w\.]+).+microm/i,
                        /micromessenger\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "WeChat"
                        ]
                    ],
                    [
                        /konqueror\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Konqueror"
                        ]
                    ],
                    [
                        /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                    ],
                    [
                        D,
                        [
                            w,
                            "IE"
                        ]
                    ],
                    [
                        /ya(?:search)?browser\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Yandex"
                        ]
                    ],
                    [
                        /slbrowser\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Smart Lenovo " + q
                        ]
                    ],
                    [
                        /(avast|avg)\/([\w\.]+)/i
                    ],
                    [
                        [
                            w,
                            /(.+)/,
                            "$1 Secure " + q
                        ],
                        D
                    ],
                    [
                        /\bfocus\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            z + " Focus"
                        ]
                    ],
                    [
                        /\bopt\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            Z + " Touch"
                        ]
                    ],
                    [
                        /coc_coc\w+\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Coc Coc"
                        ]
                    ],
                    [
                        /dolfin\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Dolphin"
                        ]
                    ],
                    [
                        /coast\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            Z + " Coast"
                        ]
                    ],
                    [
                        /miuibrowser\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "MIUI " + q
                        ]
                    ],
                    [
                        /fxios\/([-\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            z
                        ]
                    ],
                    [
                        /\bqihu|(qi?ho?o?|360)browser/i
                    ],
                    [
                        [
                            w,
                            "360 " + q
                        ]
                    ],
                    [
                        /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                    ],
                    [
                        [
                            w,
                            /(.+)/,
                            "$1 " + q
                        ],
                        D
                    ],
                    [
                        /samsungbrowser\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            ee + " Internet"
                        ]
                    ],
                    [
                        /(comodo_dragon)\/([\w\.]+)/i
                    ],
                    [
                        [
                            w,
                            /_/g,
                            " "
                        ],
                        D
                    ],
                    [
                        /metasr[\/ ]?([\d\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Sogou Explorer"
                        ]
                    ],
                    [
                        /(sogou)mo\w+\/([\d\.]+)/i
                    ],
                    [
                        [
                            w,
                            "Sogou Mobile"
                        ],
                        D
                    ],
                    [
                        /(electron)\/([\w\.]+) safari/i,
                        /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                        /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /(lbbrowser)/i,
                        /\[(linkedin)app\]/i
                    ],
                    [
                        w
                    ],
                    [
                        /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                    ],
                    [
                        [
                            w,
                            ae
                        ],
                        D
                    ],
                    [
                        /(Klarna)\/([\w\.]+)/i,
                        /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                        /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                        /safari (line)\/([\w\.]+)/i,
                        /\b(line)\/([\w\.]+)\/iab/i,
                        /(alipay)client\/([\w\.]+)/i,
                        /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                        /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /\bgsa\/([\w\.]+) .*safari\//i
                    ],
                    [
                        D,
                        [
                            w,
                            "GSA"
                        ]
                    ],
                    [
                        /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "TikTok"
                        ]
                    ],
                    [
                        /headlesschrome(?:\/([\w\.]+)| )/i
                    ],
                    [
                        D,
                        [
                            w,
                            W + " Headless"
                        ]
                    ],
                    [
                        / wv\).+(chrome)\/([\w\.]+)/i
                    ],
                    [
                        [
                            w,
                            W + " WebView"
                        ],
                        D
                    ],
                    [
                        /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Android " + q
                        ]
                    ],
                    [
                        /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Mobile Safari"
                        ]
                    ],
                    [
                        /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                    ],
                    [
                        D,
                        w
                    ],
                    [
                        /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                    ],
                    [
                        w,
                        [
                            D,
                            strMapper,
                            {
                                "1.0": "/8",
                                1.2: "/1",
                                1.3: "/3",
                                "2.0": "/412",
                                "2.0.2": "/416",
                                "2.0.3": "/417",
                                "2.0.4": "/419",
                                "?": "/"
                            }
                        ]
                    ],
                    [
                        /(webkit|khtml)\/([\w\.]+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /(navigator|netscape\d?)\/([-\w\.]+)/i
                    ],
                    [
                        [
                            w,
                            "Netscape"
                        ],
                        D
                    ],
                    [
                        /mobile vr; rv:([\w\.]+)\).+firefox/i
                    ],
                    [
                        D,
                        [
                            w,
                            z + " Reality"
                        ]
                    ],
                    [
                        /ekiohf.+(flow)\/([\w\.]+)/i,
                        /(swiftfox)/i,
                        /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                        /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                        /(firefox)\/([\w\.]+)/i,
                        /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                        /(links) \(([\w\.]+)/i,
                        /panasonic;(viera)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /(cobalt)\/([\w\.]+)/i
                    ],
                    [
                        w,
                        [
                            D,
                            /master.|lts./,
                            ""
                        ]
                    ]
                ],
                cpu: [
                    [
                        /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                    ],
                    [
                        [
                            N,
                            "amd64"
                        ]
                    ],
                    [
                        /(ia32(?=;))/i
                    ],
                    [
                        [
                            N,
                            lowerize
                        ]
                    ],
                    [
                        /((?:i[346]|x)86)[;\)]/i
                    ],
                    [
                        [
                            N,
                            "ia32"
                        ]
                    ],
                    [
                        /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                    ],
                    [
                        [
                            N,
                            "arm64"
                        ]
                    ],
                    [
                        /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                    ],
                    [
                        [
                            N,
                            "armhf"
                        ]
                    ],
                    [
                        /windows (ce|mobile); ppc;/i
                    ],
                    [
                        [
                            N,
                            "arm"
                        ]
                    ],
                    [
                        /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                    ],
                    [
                        [
                            N,
                            /ower/,
                            C,
                            lowerize
                        ]
                    ],
                    [
                        /(sun4\w)[;\)]/i
                    ],
                    [
                        [
                            N,
                            "sparc"
                        ]
                    ],
                    [
                        /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                    ],
                    [
                        [
                            N,
                            lowerize
                        ]
                    ]
                ],
                device: [
                    [
                        /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                    ],
                    [
                        P,
                        [
                            O,
                            ee
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                        /samsung[- ]([-\w]+)/i,
                        /sec-(sgh\w+)/i
                    ],
                    [
                        P,
                        [
                            O,
                            ee
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                    ],
                    [
                        P,
                        [
                            O,
                            $
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\((ipad);[-\w\),; ]+apple/i,
                        /applecoremedia\/[\w\.]+ \((ipad)/i,
                        /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                    ],
                    [
                        P,
                        [
                            O,
                            $
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(macintosh);/i
                    ],
                    [
                        P,
                        [
                            O,
                            $
                        ]
                    ],
                    [
                        /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                    ],
                    [
                        P,
                        [
                            O,
                            te
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                    ],
                    [
                        P,
                        [
                            O,
                            J
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(?:huawei|honor)([-\w ]+)[;\)]/i,
                        /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                    ],
                    [
                        P,
                        [
                            O,
                            J
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                        /\b; (\w+) build\/hm\1/i,
                        /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                        /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                        /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                        /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                    ],
                    [
                        [
                            P,
                            /_/g,
                            " "
                        ],
                        [
                            O,
                            ne
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                        /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                    ],
                    [
                        [
                            P,
                            /_/g,
                            " "
                        ],
                        [
                            O,
                            ne
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /; (\w+) bui.+ oppo/i,
                        /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "OPPO"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(opd2\d{3}a?) bui/i
                    ],
                    [
                        P,
                        [
                            O,
                            "OPPO"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /vivo (\w+)(?: bui|\))/i,
                        /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Vivo"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Realme"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                        /\bmot(?:orola)?[- ](\w*)/i,
                        /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                    ],
                    [
                        P,
                        [
                            O,
                            X
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                    ],
                    [
                        P,
                        [
                            O,
                            X
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                    ],
                    [
                        P,
                        [
                            O,
                            Y
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                        /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                        /\blg-?([\d\w]+) bui/i
                    ],
                    [
                        P,
                        [
                            O,
                            Y
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(ideatab[-\w ]+)/i,
                        /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Lenovo"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(?:maemo|nokia).*(n900|lumia \d+)/i,
                        /nokia[-_ ]?([-\w\.]*)/i
                    ],
                    [
                        [
                            P,
                            /_/g,
                            " "
                        ],
                        [
                            O,
                            "Nokia"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(pixel c)\b/i
                    ],
                    [
                        P,
                        [
                            O,
                            K
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            K
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                    ],
                    [
                        P,
                        [
                            O,
                            ie
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /sony tablet [ps]/i,
                        /\b(?:sony)?sgp\w+(?: bui|\))/i
                    ],
                    [
                        [
                            P,
                            "Xperia Tablet"
                        ],
                        [
                            O,
                            ie
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        / (kb2005|in20[12]5|be20[12][59])\b/i,
                        /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            "OnePlus"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(alexa)webm/i,
                        /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                        /(kf[a-z]+)( bui|\)).+silk\//i
                    ],
                    [
                        P,
                        [
                            O,
                            H
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                    ],
                    [
                        [
                            P,
                            /(.+)/g,
                            "Fire Phone $1"
                        ],
                        [
                            O,
                            H
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(playbook);[-\w\),; ]+(rim)/i
                    ],
                    [
                        P,
                        O,
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b((?:bb[a-f]|st[hv])100-\d)/i,
                        /\(bb10; (\w+)/i
                    ],
                    [
                        P,
                        [
                            O,
                            G
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                    ],
                    [
                        P,
                        [
                            O,
                            j
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                    ],
                    [
                        P,
                        [
                            O,
                            j
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(nexus 9)/i
                    ],
                    [
                        P,
                        [
                            O,
                            "HTC"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                        /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                        /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                    ],
                    [
                        O,
                        [
                            P,
                            /_/g,
                            " "
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Acer"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /droid.+; (m[1-5] note) bui/i,
                        /\bmz-([-\w]{2,})/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Meizu"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Ulefone"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                        /(hp) ([\w ]+\w)/i,
                        /(asus)-?(\w+)/i,
                        /(microsoft); (lumia[\w ]+)/i,
                        /(lenovo)[-_ ]?([-\w]+)/i,
                        /(jolla)/i,
                        /(oppo) ?([\w ]+) bui/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(kobo)\s(ereader|touch)/i,
                        /(archos) (gamepad2?)/i,
                        /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                        /(kindle)\/([\w\.]+)/i,
                        /(nook)[\w ]+build\/(\w+)/i,
                        /(dell) (strea[kpr\d ]*[\dko])/i,
                        /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                        /(trinity)[- ]*(t\d{3}) bui/i,
                        /(gigaset)[- ]+(q\w{1,9}) bui/i,
                        /(vodafone) ([\w ]+)(?:\)| bui)/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(surface duo)/i
                    ],
                    [
                        P,
                        [
                            O,
                            Q
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /droid [\d\.]+; (fp\du?)(?: b|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Fairphone"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(u304aa)/i
                    ],
                    [
                        P,
                        [
                            O,
                            "AT&T"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\bsie-(\w*)/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Siemens"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(rct\w+) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "RCA"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(venue[\d ]{2,7}) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Dell"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(q(?:mv|ta)\w+) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Verizon"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Barnes & Noble"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(tm\d{3}\w+) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "NuVision"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(k88) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "ZTE"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(nx\d{3}j) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "ZTE"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(gen\d{3}) b.+49h/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Swiss"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(zur\d{3}) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Swiss"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b((zeki)?tb.*\b) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Zeki"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b([yr]\d{2}) b/i,
                        /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                    ],
                    [
                        [
                            O,
                            "Dragon Touch"
                        ],
                        P,
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(ns-?\w{0,9}) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Insignia"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b((nxa|next)-?\w{0,9}) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "NextBook"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                    ],
                    [
                        [
                            O,
                            "Voice"
                        ],
                        P,
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(lvtel\-)?(v1[12]) b/i
                    ],
                    [
                        [
                            O,
                            "LvTel"
                        ],
                        P,
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(ph-1) /i
                    ],
                    [
                        P,
                        [
                            O,
                            "Essential"
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /\b(v(100md|700na|7011|917g).*\b) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Envizen"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b(trio[-\w\. ]+) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "MachSpeed"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\btu_(1491) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Rotor"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(shield[\w ]+) b/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Nvidia"
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(sprint) (\w+)/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(kin\.[onetw]{3})/i
                    ],
                    [
                        [
                            P,
                            /\./g,
                            " "
                        ],
                        [
                            O,
                            Q
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                    ],
                    [
                        P,
                        [
                            O,
                            re
                        ],
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                    ],
                    [
                        P,
                        [
                            O,
                            re
                        ],
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /smart-tv.+(samsung)/i
                    ],
                    [
                        O,
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /hbbtv.+maple;(\d+)/i
                    ],
                    [
                        [
                            P,
                            /^/,
                            "SmartTV"
                        ],
                        [
                            O,
                            ee
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                    ],
                    [
                        [
                            O,
                            Y
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /(apple) ?tv/i
                    ],
                    [
                        O,
                        [
                            P,
                            $ + " TV"
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /crkey/i
                    ],
                    [
                        [
                            P,
                            W + "cast"
                        ],
                        [
                            O,
                            K
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /droid.+aft(\w+)( bui|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            H
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /\(dtv[\);].+(aquos)/i,
                        /(aquos-tv[\w ]+)\)/i
                    ],
                    [
                        P,
                        [
                            O,
                            te
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /(bravia[\w ]+)( bui|\))/i
                    ],
                    [
                        P,
                        [
                            O,
                            ie
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /(mitv-\w{5}) bui/i
                    ],
                    [
                        P,
                        [
                            O,
                            ne
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /Hbbtv.*(technisat) (.*);/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                        /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                    ],
                    [
                        [
                            O,
                            trim
                        ],
                        [
                            P,
                            trim
                        ],
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                    ],
                    [
                        [
                            M,
                            x
                        ]
                    ],
                    [
                        /(ouya)/i,
                        /(nintendo) ([wids3utch]+)/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            k
                        ]
                    ],
                    [
                        /droid.+; (shield) bui/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Nvidia"
                        ],
                        [
                            M,
                            k
                        ]
                    ],
                    [
                        /(playstation [345portablevi]+)/i
                    ],
                    [
                        P,
                        [
                            O,
                            ie
                        ],
                        [
                            M,
                            k
                        ]
                    ],
                    [
                        /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                    ],
                    [
                        P,
                        [
                            O,
                            Q
                        ],
                        [
                            M,
                            k
                        ]
                    ],
                    [
                        /((pebble))app/i
                    ],
                    [
                        O,
                        P,
                        [
                            M,
                            U
                        ]
                    ],
                    [
                        /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                    ],
                    [
                        P,
                        [
                            O,
                            $
                        ],
                        [
                            M,
                            U
                        ]
                    ],
                    [
                        /droid.+; (glass) \d/i
                    ],
                    [
                        P,
                        [
                            O,
                            K
                        ],
                        [
                            M,
                            U
                        ]
                    ],
                    [
                        /droid.+; (wt63?0{2,3})\)/i
                    ],
                    [
                        P,
                        [
                            O,
                            re
                        ],
                        [
                            M,
                            U
                        ]
                    ],
                    [
                        /(quest( \d| pro)?)/i
                    ],
                    [
                        P,
                        [
                            O,
                            ae
                        ],
                        [
                            M,
                            U
                        ]
                    ],
                    [
                        /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                    ],
                    [
                        O,
                        [
                            M,
                            V
                        ]
                    ],
                    [
                        /(aeobc)\b/i
                    ],
                    [
                        P,
                        [
                            O,
                            H
                        ],
                        [
                            M,
                            V
                        ]
                    ],
                    [
                        /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                    ],
                    [
                        P,
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                    ],
                    [
                        P,
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                    ],
                    [
                        [
                            M,
                            F
                        ]
                    ],
                    [
                        /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                    ],
                    [
                        [
                            M,
                            L
                        ]
                    ],
                    [
                        /(android[-\w\. ]{0,9});.+buil/i
                    ],
                    [
                        P,
                        [
                            O,
                            "Generic"
                        ]
                    ]
                ],
                engine: [
                    [
                        /windows.+ edge\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "EdgeHTML"
                        ]
                    ],
                    [
                        /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Blink"
                        ]
                    ],
                    [
                        /(presto)\/([\w\.]+)/i,
                        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                        /ekioh(flow)\/([\w\.]+)/i,
                        /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                        /(icab)[\/ ]([23]\.[\d\.]+)/i,
                        /\b(libweb)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /rv\:([\w\.]{1,9})\b.+(gecko)/i
                    ],
                    [
                        D,
                        w
                    ]
                ],
                os: [
                    [
                        /microsoft (windows) (vista|xp)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                    ],
                    [
                        w,
                        [
                            D,
                            strMapper,
                            le
                        ]
                    ],
                    [
                        /windows nt 6\.2; (arm)/i,
                        /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                        /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                    ],
                    [
                        [
                            D,
                            strMapper,
                            le
                        ],
                        [
                            w,
                            "Windows"
                        ]
                    ],
                    [
                        /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                        /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                        /cfnetwork\/.+darwin/i
                    ],
                    [
                        [
                            D,
                            /_/g,
                            "."
                        ],
                        [
                            w,
                            "iOS"
                        ]
                    ],
                    [
                        /(mac os x) ?([\w\. ]*)/i,
                        /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                    ],
                    [
                        [
                            w,
                            oe
                        ],
                        [
                            D,
                            /_/g,
                            "."
                        ]
                    ],
                    [
                        /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                    ],
                    [
                        D,
                        w
                    ],
                    [
                        /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                        /(blackberry)\w*\/([\w\.]*)/i,
                        /(tizen|kaios)[\/ ]([\w\.]+)/i,
                        /\((series40);/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /\(bb(10);/i
                    ],
                    [
                        D,
                        [
                            w,
                            G
                        ]
                    ],
                    [
                        /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "Symbian"
                        ]
                    ],
                    [
                        /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            z + " OS"
                        ]
                    ],
                    [
                        /web0s;.+rt(tv)/i,
                        /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "webOS"
                        ]
                    ],
                    [
                        /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            "watchOS"
                        ]
                    ],
                    [
                        /crkey\/([\d\.]+)/i
                    ],
                    [
                        D,
                        [
                            w,
                            W + "cast"
                        ]
                    ],
                    [
                        /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                    ],
                    [
                        [
                            w,
                            se
                        ],
                        D
                    ],
                    [
                        /panasonic;(viera)/i,
                        /(netrange)mmh/i,
                        /(nettv)\/(\d+\.[\w\.]+)/i,
                        /(nintendo|playstation) ([wids345portablevuch]+)/i,
                        /(xbox); +xbox ([^\);]+)/i,
                        /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                        /(mint)[\/\(\) ]?(\w*)/i,
                        /(mageia|vectorlinux)[; ]/i,
                        /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                        /(hurd|linux) ?([\w\.]*)/i,
                        /(gnu) ?([\w\.]*)/i,
                        /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                        /(haiku) (\w+)/i
                    ],
                    [
                        w,
                        D
                    ],
                    [
                        /(sunos) ?([\w\.\d]*)/i
                    ],
                    [
                        [
                            w,
                            "Solaris"
                        ],
                        D
                    ],
                    [
                        /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                        /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                        /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                        /(unix) ?([\w\.]*)/i
                    ],
                    [
                        w,
                        D
                    ]
                ]
            }, UAParser = function(g, f) {
                if (typeof g === b && (f = g, g = v), !(this instanceof UAParser)) return new UAParser(g, f).getResult();
                var _ = typeof S !== I && S.navigator ? S.navigator : v, E = g || (_ && _.userAgent ? _.userAgent : C), k = _ && _.userAgentData ? _.userAgentData : v, x = f ? extend(ce, f) : ce, U = _ && _.userAgent == E;
                return this.getBrowser = function() {
                    var g = {};
                    return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.browser), g[R] = majorize(g[D]), U && _ && _.brave && typeof _.brave.isBrave == T && (g[w] = "Brave"), g;
                }, this.getCPU = function() {
                    var g = {};
                    return g[N] = v, rgxMapper.call(g, E, x.cpu), g;
                }, this.getDevice = function() {
                    var g = {};
                    return g[O] = v, g[P] = v, g[M] = v, rgxMapper.call(g, E, x.device), U && !g[M] && k && k.mobile && (g[M] = L), U && "Macintosh" == g[P] && _ && typeof _.standalone !== I && _.maxTouchPoints && _.maxTouchPoints > 2 && (g[P] = "iPad", g[M] = F), g;
                }, this.getEngine = function() {
                    var g = {};
                    return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.engine), g;
                }, this.getOS = function() {
                    var g = {};
                    return g[w] = v, g[D] = v, rgxMapper.call(g, E, x.os), U && !g[w] && k && k.platform && "Unknown" != k.platform && (g[w] = k.platform.replace(/chrome os/i, se).replace(/macos/i, oe)), g;
                }, this.getResult = function() {
                    return {
                        ua: this.getUA(),
                        browser: this.getBrowser(),
                        engine: this.getEngine(),
                        os: this.getOS(),
                        device: this.getDevice(),
                        cpu: this.getCPU()
                    };
                }, this.getUA = function() {
                    return E;
                }, this.setUA = function(g) {
                    return E = typeof g === A && g.length > B ? trim(g, B) : g, this;
                }, this.setUA(E), this;
            };
            UAParser.VERSION = _, UAParser.BROWSER = enumerize([
                w,
                D,
                R
            ]), UAParser.CPU = enumerize([
                N
            ]), UAParser.DEVICE = enumerize([
                P,
                O,
                M,
                k,
                L,
                x,
                F,
                U,
                V
            ]), UAParser.ENGINE = UAParser.OS = enumerize([
                w,
                D
            ]), g.exports && (f = g.exports = UAParser), f.UAParser = UAParser;
            var de = typeof S !== I && (S.jQuery || S.Zepto);
            if (de && !de.ua) {
                var ue = new UAParser;
                de.ua = ue.getResult(), de.ua.get = function() {
                    return ue.getUA();
                }, de.ua.set = function(g) {
                    ue.setUA(g);
                    var f = ue.getResult();
                    for(var S in f)de.ua[S] = f[S];
                };
            }
        }("object" == typeof window ? window : _);
    });
    const Sb = [
        {
            name: "edge",
            engine: "Edge",
            key: "Edge"
        },
        {
            name: "edgeanaheim",
            engine: "Chromium",
            key: "Edg"
        },
        {
            name: "chromium",
            engine: "Chromium",
            key: "Chromium"
        },
        {
            name: "opera",
            engine: "Chromium",
            key: "OPR"
        },
        {
            name: "yandexbrowser",
            engine: "Chromium",
            key: "YaBrowser"
        },
        {
            name: "electron",
            engine: "Chromium",
            key: "Electron"
        },
        {
            name: "chrome",
            engine: "Chromium",
            key: "Chrome"
        },
        {
            name: "firefox",
            engine: "Firefox",
            key: "Firefox"
        },
        {
            name: "safari",
            engine: "Safari",
            key: "Safari"
        },
        {
            name: "applewebview",
            engine: "Safari",
            key: "Mac OS X"
        },
        {
            name: "ie",
            engine: "MSIE",
            key: "Trident"
        }
    ], vb = "0.0", _b = "unknown";
    function getFormFactor(g) {
        return /iPhone|iPad|iPod|Android|Mobi/i.test(g) ? "Mobile" : "Desktop";
    }
    function isAndroid(g) {
        const f = !/like android/i.test(g), S = /android/i.test(g);
        return f && S;
    }
    let Cb = new fb.UAParser;
    function getEnvironmentDetails() {
        Cb || (Cb = new fb.UAParser);
        return Cb.getResult();
    }
    function getPlatformName() {
        const g = getEnvironmentDetails().ua;
        return -1 !== g.indexOf("Edge") ? "edge" : -1 !== g.indexOf("Electron") ? "electron" : -1 !== g.indexOf("Chrome") ? "chrome" : -1 !== g.indexOf("Firefox") ? "firefox" : -1 !== g.indexOf("Safari") ? "safari" : -1 !== g.indexOf("Mac OS X") ? "applewebview" : -1 !== g.indexOf("Trident") ? "ie" : "unknown";
    }
    function updateBrowserName(g, f) {
        return "edge" !== g && "edgeanaheim" !== g || ((f.includes("Edg/") || f.includes("EdgA/") || f.includes("EdgiOS/")) && (g = "edgeanaheim"), f.includes("Edge/") && (g = "edge")), g;
    }
    function getBrowserName(g, f) {
        const S = f.find(({ key: f })=>g.includes(f));
        if (!S) return _b;
        let v = S.name;
        return v = updateBrowserName(v, getEnvironmentDetails().ua), v;
    }
    function updateBrowserEngine(g, f) {
        return "ios" === getOS() && (f = "Safari"), f;
    }
    function getBrowserEngine(g, f) {
        const S = f.find(({ name: f })=>f === g);
        if (!S) return _b;
        let v = S.engine;
        return v = updateBrowserEngine(g, v), v;
    }
    function getBrowserVersion() {
        const g = getEnvironmentDetails();
        var _g_os_version;
        return "WebKit" === g.browser.name && -1 !== g.ua.indexOf("Mac OS X") ? (_g_os_version = g.os.version) !== null && _g_os_version !== void 0 ? _g_os_version : vb : void 0 !== g.browser.version ? g.browser.version : vb;
    }
    function getBrowserInfo() {
        const g = getEnvironmentDetails(), f = g.ua, S = getBrowserName(g.browser.name, Sb);
        return {
            name: S,
            engine: getBrowserEngine(S, Sb),
            version: getBrowserVersion(),
            formFactor: getFormFactor(f)
        };
    }
    function getOS() {
        const g = getEnvironmentDetails().ua;
        return /windows phone/i.test(g) ? "windowsphone" : /windows /i.test(g) ? "windows" : /macintosh/i.test(g) ? "mac" : /(ipod|iphone|ipad)/i.test(g) ? "ios" : isAndroid(g) ? "android" : /(web|hpw)[o0]s/i.test(g) ? "webos" : /tizen/i.test(g) ? "tizen" : /headlesschrome(?:\/([\w\.]+)| )/i.test(g) ? "headlesschrome" : /linux/i.test(g) ? "linux" : /CrOS/.test(g) ? "chrome" : "other";
    }
    function getInternalEnvInfo() {
        const g = getBrowserInfo();
        return `${`os=${getOS()};`} ${`osVer=${getOSVersion()};`} ${`browser=${g.name};`} ${`browserVer=${g.version};`} ${`formFactor=${g.formFactor};`}`;
    }
    function getOSVersion() {
        const g = getEnvironmentDetails();
        return void 0 !== g.os.version ? g.os.version : vb;
    }
    function isDigitMade(g) {
        return /^\d+$/.test(g);
    }
    function checkVersionSupport(g, S) {
        g = g.replace(/,/g, ".").trim(), S = S.replace(/,/g, ".").trim();
        let v = g.split("."), _ = S.split("."), C = 0;
        try {
            if (!v.every(isDigitMade) || !_.every(isDigitMade)) return -2;
            for(; v.length < _.length;)v.push("0");
            for(; _.length < v.length;)_.push("0");
            let g = v.map(Number), f = _.map(Number);
            for(var E = 0; E < g.length; E++)if (g[E] !== f[E]) {
                if (g[E] > f[E]) return 1;
                if (g[E] < f[E]) return -1;
            }
        } catch (g) {
            f.AzureLogger.log(`Error in browser check version support: ${g}`);
        }
        return C;
    }
    function checkOsSupport(g) {
        var _getAcsEcsConfig;
        let f = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.environments;
        return !!f.hasOwnProperty(g);
    }
    function checkOsBrowserSupport(g, f) {
        var _getAcsEcsConfig;
        let S = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.environments;
        return !(!checkOsSupport(g) || !S[g].hasOwnProperty(f)) && S[g][f].isSupportedOnSdkVersion;
    }
    function getMinBrowserVersion(g, f) {
        var _getAcsEcsConfig;
        let S = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.environments;
        return S.hasOwnProperty(g) && S[g].hasOwnProperty(f) ? S[g][f].minVersion : vb;
    }
    function getEnvironmentInfos() {
        let g, f, S = !1;
        const v = getEnvironmentDetails(), _ = getOS(), C = getBrowserInfo().name, E = getBrowserInfo().version, T = checkOsSupport(_), I = checkOsBrowserSupport(_, C);
        if (I) checkVersionSupport(E, getMinBrowserVersion(_, C)) >= 0 && (S = !0);
        return f = {
            platform: v.os.name,
            browser: v.browser.name,
            browserVersion: v.browser.version
        }, g = {
            environment: f,
            isSupportedPlatform: T,
            isSupportedBrowser: I,
            isSupportedBrowserVersion: S,
            isSupportedEnvironment: T && I && S
        }, g;
    }
    var __decorate$b = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$b = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class MediaConstraintsManager {
        get currentVideoConstraints() {
            return this._currentVideoConstraints;
        }
        async setVideoConstraints(g, f, S, v) {
            const _ = this.getTelemetryPayload({
                video: g
            }), sendSuccessOrFailureTelemetryEvent = (g)=>{
                let _ = g ? {
                    failureReason: g ? g.message : void 0,
                    code: g ? g.code : void 0,
                    ...extractCommunicationServicesErrorForTelemetry(g)
                } : void 0;
                sendCallFeatureUsageTelemetry({
                    correlationId: S,
                    callId: this._tsCall.callId,
                    localParticipantId: this._tsCall.participantId,
                    featureName: "SetConstraints",
                    featureType: "Call",
                    initializationType: "None",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - v
                    },
                    featureDetails: {
                        name: "setConstraints",
                        step: g ? uy.failure : uy.success,
                        stage: f
                    },
                    additionalDetails: {
                        constraints: this.getTelemetryPayload({
                            video: this._currentVideoConstraints
                        }),
                        ..._
                    }
                }, this._telemetryLogManager, this._logger);
            };
            try {
                var _this__currentVideoConstraints_send_frameHeight, _this__currentVideoConstraints_send, _this__currentVideoConstraints_send_frameRate, _this__currentVideoConstraints_send1, _this__currentVideoConstraints_send_bitrate, _this__currentVideoConstraints_send2, _this__tsCall_setCallConstraints, _this__tsCall;
                sendCallFeatureUsageTelemetry({
                    correlationId: S,
                    callId: this._tsCall.callId,
                    localParticipantId: this._tsCall.participantId,
                    featureName: "SetConstraints",
                    featureType: "Call",
                    initializationType: "None",
                    timestampInfo: "",
                    featureDetails: {
                        name: "setConstraints",
                        step: uy.attempt,
                        stage: f
                    },
                    additionalDetails: {
                        constraints: _
                    }
                }, this._telemetryLogManager, this._logger);
                if (!getAcsEcsConfig().calling.constraints.enabled) throw this._logger.error("Setting call constraints is disabled"), new CallingCommunicationError({
                    defaultError: O.CALL.MEDIA_CONSTRAINTS_DISABLED
                });
                this._updateVideoConstraintsCache(g);
                const v = {
                    outgoingVideoLimit: {
                        maxResolution: (_this__currentVideoConstraints_send = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send === void 0 ? void 0 : (_this__currentVideoConstraints_send_frameHeight = _this__currentVideoConstraints_send.frameHeight) === null || _this__currentVideoConstraints_send_frameHeight === void 0 ? void 0 : _this__currentVideoConstraints_send_frameHeight.max,
                        maxFramerate: (_this__currentVideoConstraints_send1 = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send1 === void 0 ? void 0 : (_this__currentVideoConstraints_send_frameRate = _this__currentVideoConstraints_send1.frameRate) === null || _this__currentVideoConstraints_send_frameRate === void 0 ? void 0 : _this__currentVideoConstraints_send_frameRate.max,
                        maxBitrate: (_this__currentVideoConstraints_send2 = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send2 === void 0 ? void 0 : (_this__currentVideoConstraints_send_bitrate = _this__currentVideoConstraints_send2.bitrate) === null || _this__currentVideoConstraints_send_bitrate === void 0 ? void 0 : _this__currentVideoConstraints_send_bitrate.max
                    }
                }, C = (_this__tsCall_setCallConstraints = (_this__tsCall = this._tsCall).setCallConstraints) === null || _this__tsCall_setCallConstraints === void 0 ? void 0 : _this__tsCall_setCallConstraints.call(_this__tsCall, v);
                if ("mid-call" !== f) C === null || C === void 0 ? void 0 : C.then(()=>{
                    this._logger.info(`Successfully set call constraints at call ${f} - ${JSON.stringify(this._currentVideoConstraints)}`), sendSuccessOrFailureTelemetryEvent();
                }).catch((g)=>{
                    this._logger.error(`Error setting call constraints at call ${f}`);
                    const S = new CallingCommunicationError({
                        defaultError: O.CALL.SET_CONSTRAINTS_START_OR_ACCEPT,
                        defaultErrorMessageArgs: [
                            f
                        ],
                        originalError: g
                    });
                    sendSuccessOrFailureTelemetryEvent(S);
                });
                else try {
                    await C, this._logger.info(`Successfully set call constraints during ${f} - ${JSON.stringify(this._currentVideoConstraints)}`), sendSuccessOrFailureTelemetryEvent();
                } catch (g) {
                    throw new CallingCommunicationError({
                        defaultError: O.CALL.SET_CONSTRAINTS_MID_CALL,
                        originalError: g
                    });
                }
                return this._currentVideoConstraints;
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.CALL.SET_CONSTRAINTS,
                    defaultErrorMessageArgs: [
                        f
                    ],
                    originalError: g
                });
                throw sendSuccessOrFailureTelemetryEvent(S), S;
            }
        }
        getTelemetryPayload(g) {
            var _g_video_send_frameHeight, _g_video_send, _g_video, _g_video_send_frameRate, _g_video_send1, _g_video1, _g_video_send_bitrate, _g_video_send2, _g_video2;
            return {
                video: {
                    send: {
                        frameHeight: {
                            max: (_g_video = g.video) === null || _g_video === void 0 ? void 0 : (_g_video_send = _g_video.send) === null || _g_video_send === void 0 ? void 0 : (_g_video_send_frameHeight = _g_video_send.frameHeight) === null || _g_video_send_frameHeight === void 0 ? void 0 : _g_video_send_frameHeight.max
                        },
                        frameRate: {
                            max: (_g_video1 = g.video) === null || _g_video1 === void 0 ? void 0 : (_g_video_send1 = _g_video1.send) === null || _g_video_send1 === void 0 ? void 0 : (_g_video_send_frameRate = _g_video_send1.frameRate) === null || _g_video_send_frameRate === void 0 ? void 0 : _g_video_send_frameRate.max
                        },
                        bitrate: {
                            max: (_g_video2 = g.video) === null || _g_video2 === void 0 ? void 0 : (_g_video_send2 = _g_video2.send) === null || _g_video_send2 === void 0 ? void 0 : (_g_video_send_bitrate = _g_video_send2.bitrate) === null || _g_video_send_bitrate === void 0 ? void 0 : _g_video_send_bitrate.max
                        }
                    }
                }
            };
        }
        _updateVideoConstraintsCache(g) {
            var _g_send_frameHeight, _g_send, _this__currentVideoConstraints_send_frameHeight, _this__currentVideoConstraints_send, _g_send_frameRate, _g_send1, _this__currentVideoConstraints_send_frameRate, _this__currentVideoConstraints_send1, _g_send_bitrate, _g_send2, _this__currentVideoConstraints_send_bitrate, _this__currentVideoConstraints_send2;
            var _g_send_frameHeight_max, _g_send_frameRate_max, _g_send_bitrate_max;
            const f = getAcsEcsConfig(), S = f.calling.constraints.maxOutgoingResolution, v = f.calling.constraints.maxOutgoingFrameRate, _ = f.calling.constraints.maxOutgoingVideoBitrate, C = (_g_send_frameHeight_max = g === null || g === void 0 ? void 0 : (_g_send = g.send) === null || _g_send === void 0 ? void 0 : (_g_send_frameHeight = _g_send.frameHeight) === null || _g_send_frameHeight === void 0 ? void 0 : _g_send_frameHeight.max) !== null && _g_send_frameHeight_max !== void 0 ? _g_send_frameHeight_max : (_this__currentVideoConstraints_send = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send === void 0 ? void 0 : (_this__currentVideoConstraints_send_frameHeight = _this__currentVideoConstraints_send.frameHeight) === null || _this__currentVideoConstraints_send_frameHeight === void 0 ? void 0 : _this__currentVideoConstraints_send_frameHeight.max, E = (_g_send_frameRate_max = g === null || g === void 0 ? void 0 : (_g_send1 = g.send) === null || _g_send1 === void 0 ? void 0 : (_g_send_frameRate = _g_send1.frameRate) === null || _g_send_frameRate === void 0 ? void 0 : _g_send_frameRate.max) !== null && _g_send_frameRate_max !== void 0 ? _g_send_frameRate_max : (_this__currentVideoConstraints_send1 = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send1 === void 0 ? void 0 : (_this__currentVideoConstraints_send_frameRate = _this__currentVideoConstraints_send1.frameRate) === null || _this__currentVideoConstraints_send_frameRate === void 0 ? void 0 : _this__currentVideoConstraints_send_frameRate.max, T = (_g_send_bitrate_max = g === null || g === void 0 ? void 0 : (_g_send2 = g.send) === null || _g_send2 === void 0 ? void 0 : (_g_send_bitrate = _g_send2.bitrate) === null || _g_send_bitrate === void 0 ? void 0 : _g_send_bitrate.max) !== null && _g_send_bitrate_max !== void 0 ? _g_send_bitrate_max : (_this__currentVideoConstraints_send2 = this._currentVideoConstraints.send) === null || _this__currentVideoConstraints_send2 === void 0 ? void 0 : (_this__currentVideoConstraints_send_bitrate = _this__currentVideoConstraints_send2.bitrate) === null || _this__currentVideoConstraints_send_bitrate === void 0 ? void 0 : _this__currentVideoConstraints_send_bitrate.max;
            this._currentVideoConstraints = {
                send: {
                    frameHeight: {
                        max: this._getConstraintValue(S, "maxOutgoingResolution", C)
                    },
                    frameRate: {
                        max: this._getConstraintValue(v, "maxOutgoingFrameRate", E)
                    },
                    bitrate: {
                        max: this._getConstraintValue(_, "maxOutgoingBitrate", T)
                    }
                }
            };
        }
        _getConstraintValue(g, f, S) {
            return "number" == typeof S ? S < 1 ? void this._logger.info(`Received ${f} as 0 or less, removing ${f} constraint`) : (g > 0 && S > g && (this._logger.info(`${f} value ${S} is larger than ${g}, resetting to ${g}`), S = g), S) : void this._logger.warn(`Received invalid ${f} value, removing ${f} constraint`);
        }
        constructor(g, f, S){
            this._tsCall = g, this._currentVideoConstraints = {
                send: {
                    frameHeight: {
                        max: void 0
                    },
                    frameRate: {
                        max: void 0
                    },
                    bitrate: {
                        max: void 0
                    }
                }
            }, this._logger = f.createChild("MediaConstraintsManager"), this._telemetryLogManager = S;
        }
    }
    __decorate$b([
        loggerProperty,
        __metadata$b("design:type", Object)
    ], MediaConstraintsManager.prototype, "_logger", void 0);
    var __decorate$c = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$c = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class LobbyImpl {
        on(g, f) {
            if ("lobbyParticipantsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.LOBBY.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("lobbyParticipantsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.LOBBY.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        async admit(g, f) {
            if (!this._isLobbyEnabled) return void this.logger.warn("Lobby is not enabled");
            const S = generateGuid(), v = +new Date;
            this._sendLobbyAdmitAndRejectUsage("Start admit participant", hy.lobbyAdmit, S, uy.attempt, void 0);
            try {
                validateIdentifier(g), this.validateLobbyOperation(g), await this._tsCall.admitParticipant(getMriFromIdentifier(g));
                const f = +new Date;
                this._sendLobbyAdmitAndRejectUsage("Lobby participant admitted successfully", hy.lobbyAdmit, S, uy.success, f - v);
            } catch (g) {
                let f = py.Unexpected;
                this._hasExpectedError && (f = py.Expected, this._hasExpectedError = !1), this.handleLobbyAdmitAndRejectFailure("Failed to admit participant from lobby", g, S, v, hy.lobbyAdmit, f);
            }
        }
        async reject(g, f) {
            if (!this._isLobbyEnabled) return void this.logger.warn("Lobby is not enabled");
            const S = generateGuid(), v = +new Date;
            this._sendLobbyAdmitAndRejectUsage("Start reject participant", hy.lobbyReject, S, uy.attempt, void 0);
            try {
                validateIdentifier(g), this.validateLobbyOperation(g), await this._tsCall.removeParticipant(getMriFromIdentifier(g));
                const f = +new Date;
                this._sendLobbyAdmitAndRejectUsage("Lobby participant rejected successfully", hy.lobbyReject, S, uy.success, f - v);
            } catch (g) {
                let f = py.Unexpected;
                this._hasExpectedError && (f = py.Expected, this._hasExpectedError = !1), this.handleLobbyAdmitAndRejectFailure("Failed to reject participant from lobby", g, S, v, hy.lobbyReject, f);
            }
        }
        async admitAll(g) {
            const f = generateGuid(), S = +new Date;
            let v, _ = 0, C = 0;
            if (!this._isLobbyEnabled) return this.logger.warn("Lobby is not enabled"), {
                successCount: _,
                failureCount: C
            };
            this._sendLobbyAdmitAndRejectUsage("Start admit all participants", hy.lobbyAdmitAll, f, uy.attempt, void 0);
            try {
                this.validateLobbyOperation(), await this._tsCall.admit({
                    scope: "all"
                }, w.generateCauseId()).then((g)=>{
                    if (v = g, g.result) {
                        const f = JSON.parse(g.result);
                        _ = f.successCount, C = f.failureCount;
                    }
                });
                const g = +new Date;
                if (0 !== C) return this._sendLobbyAdmitAndRejectUsage(`${_} participants are admitted successfully, ${C} participants admit failed. TransactionEnd: ${v}`, hy.lobbyAdmitAll, f, uy.success, g - S), {
                    successCount: _,
                    failureCount: C
                };
                this._sendLobbyAdmitAndRejectUsage("All participants are admitted successfully", hy.lobbyAdmitAll, f, uy.success, g - S);
            } catch (g) {
                let v = py.Unexpected;
                this._hasExpectedError && (v = py.Expected, this._hasExpectedError = !1), this.handleLobbyAdmitAndRejectFailure("Failed to admit all participants from lobby", g, f, S, hy.lobbyAdmitAll, v);
            }
            return {
                successCount: _,
                failureCount: C
            };
        }
        get participants() {
            return this._isLobbyEnabled ? Array.from(this._participants.values()) : (this.logger.warn("Lobby is not enabled"), []);
        }
        getInLobbyParticipants(g) {
            g.forEach((g)=>{
                if ("InLobby" === g.state) {
                    const f = getMriFromIdentifier(g.identifier);
                    this._participants.set(f, g);
                }
            });
        }
        removeAllLobbyParticipants() {
            if (0 === this._participants.size) return;
            const g = Array.from(this._participants.values());
            this._participants.clear(), this.logger.info("All participants are removed from lobby"), this._eventEmitter.emit("lobbyParticipantsUpdated", {
                added: [],
                removed: g
            });
        }
        removeLobbyParticipant(g) {
            const f = getMriFromIdentifier(g.identifier);
            this._participants.has(f) && (this.logger.info(`${S.getIdentifierKind(g.identifier).kind} is removed from lobby`), this._participants.delete(f), this._eventEmitter.emit("lobbyParticipantsUpdated", {
                added: [],
                removed: [
                    g
                ]
            }));
        }
        addLobbyParticipant(g) {
            const f = getMriFromIdentifier(g.identifier);
            this._participants.has(f) || (this.logger.info(`${S.getIdentifierKind(g.identifier).kind} is added to lobby`), this._participants.set(f, g), this._eventEmitter.emit("lobbyParticipantsUpdated", {
                added: [
                    g
                ],
                removed: []
            }));
        }
        validateLobbyOperation(g) {
            const f = this._tsCall.conversationType ? this._tsCall.conversationType : "oneToOneCall";
            if (this.logger.info("Current conversation type is: ", f), !this._lobbySupportedConversationTypes.find((g)=>g === f)) throw this._hasExpectedError = !0, new CallingCommunicationError({
                defaultError: O.LOBBY.CONV_UNSUPPORTED
            });
            if (g) {
                let f = this._call.remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g));
                if (f && "Connected" === f.state) throw this._hasExpectedError = !0, new CallingCommunicationError({
                    defaultError: O.LOBBY.ALREADY_IN_MEETING,
                    defaultErrorMessageArgs: [
                        S.getIdentifierKind(g).kind
                    ]
                });
                if (f && "InLobby" !== f.state || !f) throw this._hasExpectedError = !0, new CallingCommunicationError({
                    defaultError: O.LOBBY.NOT_IN_LOBBY,
                    defaultErrorMessageArgs: [
                        S.getIdentifierKind(g).kind
                    ]
                });
            }
            if (this._call.role !== sS.Presenter && this._call.role !== sS.Organizer && this._call.role !== sS.Coorganizer) throw this._hasExpectedError = !0, new CallingCommunicationError({
                defaultError: O.LOBBY.UNAUTHORIZED_ADMIT_REJECT
            });
        }
        handleLobbyAdmitAndRejectFailure(g, f, S, v, _, C) {
            const E = +new Date, T = handleLobbyFailure(this.logger, f, g);
            throw this._sendLobbyAdmitAndRejectUsage(T.message, _, S, uy.failure, E - v, C, f), T;
        }
        _sendLobbyAdmitAndRejectUsage(g, f, S, v, _, C, E) {
            v === uy.failure ? this.logger.error(g) : this.logger.info(g), this.sendLobbyAdmitAndRejectEvent({
                eventName: dy.acs_calling_lobby_events,
                callId: this._call.id,
                localParticipantId: this._tsCall.participantId,
                correlationId: S,
                kindOfEvent: v,
                operation: f,
                isExpected: C !== null && C !== void 0 ? C : "",
                timestampInfo: _ ? {
                    deltaTimeInMs: _
                } : "",
                additionalDetails: E ? {
                    failureReason: E.message,
                    code: E.code,
                    subCode: E.subCode,
                    ...extractCommunicationServicesErrorForTelemetry(E)
                } : ""
            });
        }
        sendLobbyAdmitAndRejectEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send lobby admit and reject telemetry");
            }
        }
        constructor(g, f, S, v){
            this.logger = S.createChild("Lobby"), this._tsCall = g, this._eventEmitter = new CallingEventEmitter(this.logger), this._participants = new Map, this._call = f, this._telemetryLogManager = v, this._lobbySupportedConversationTypes = getAcsEcsConfig().calling.lobbyAdmitAndReject.supportedConversationTypes, this._isLobbyEnabled = getAcsEcsConfig().calling.lobbyAdmitAndReject.enabled, this._hasExpectedError = !1, this._isLobbyEnabled && (this.getInLobbyParticipants(f.remoteParticipants), this._remoteParticipantUpdatedListener = (g)=>{
                if (0 !== g.added.length && g.added.forEach((g)=>{
                    "InLobby" === g.state && this.addLobbyParticipant(g), g.on("stateChanged", ()=>{
                        "InLobby" === g.state ? this.addLobbyParticipant(g) : "Connected" === g.state && this.removeLobbyParticipant(g);
                    });
                }), 0 !== g.removed.length) {
                    if (0 === this._call.remoteParticipants.length) return void this.removeAllLobbyParticipants();
                    g.removed.forEach((g)=>{
                        this.removeLobbyParticipant(g);
                    });
                }
            }, this._call.on("remoteParticipantsUpdated", this._remoteParticipantUpdatedListener));
        }
    }
    function getMmrRdpState() {
        const g = window.navigator.mediaDevices;
        if (g === null || g === void 0 ? void 0 : g.isRemote) {
            var _g_MSRDC_MMR_Shim_remoteObjectManager, _g_MSRDC_MMR_Shim;
            const f = g === null || g === void 0 ? void 0 : (_g_MSRDC_MMR_Shim = g.MSRDC_MMR_Shim) === null || _g_MSRDC_MMR_Shim === void 0 ? void 0 : (_g_MSRDC_MMR_Shim_remoteObjectManager = _g_MSRDC_MMR_Shim.remoteObjectManager) === null || _g_MSRDC_MMR_Shim_remoteObjectManager === void 0 ? void 0 : _g_MSRDC_MMR_Shim_remoteObjectManager.isConnected;
            if (!0 === f) return "connected";
            if (!1 === f) return "disconnected";
        }
        return "";
    }
    function getMMRInfo() {
        var _g_isRemote;
        const g = window.navigator.mediaDevices, f = {
            isMMREnabled: (_g_isRemote = g === null || g === void 0 ? void 0 : g.isRemote) !== null && _g_isRemote !== void 0 ? _g_isRemote : !1
        };
        return f.isMMREnabled && ((g === null || g === void 0 ? void 0 : g.mmrClientVersion) && (f.mmrClientVersion = g.mmrClientVersion), (g === null || g === void 0 ? void 0 : g.mmrExtensionVersion) && (f.mmrExtensionVersion = g.mmrExtensionVersion), (g === null || g === void 0 ? void 0 : g.mmrHostVersion) && (f.mmrHostVersion = g.mmrHostVersion), (g === null || g === void 0 ? void 0 : g.activityId) && (f.mmrActivityId = g.activityId), (g === null || g === void 0 ? void 0 : g.connectionId) && (f.mmrConnectionId = g.connectionId), f.mmrRdpState = getMmrRdpState()), f;
    }
    __decorate$c([
        loggerProperty,
        __metadata$c("design:type", Object)
    ], LobbyImpl.prototype, "logger", void 0), __decorate$c([
        asyncOperation(IS.LobbyAdmitParticipant),
        __metadata$c("design:type", Function),
        __metadata$c("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$c("design:returntype", Promise)
    ], LobbyImpl.prototype, "admit", null), __decorate$c([
        asyncOperation(IS.LobbyRejectParticipant),
        __metadata$c("design:type", Function),
        __metadata$c("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$c("design:returntype", Promise)
    ], LobbyImpl.prototype, "reject", null), __decorate$c([
        asyncOperation(IS.LobbyAdmitAll),
        __metadata$c("design:type", Function),
        __metadata$c("design:paramtypes", [
            Object
        ]),
        __metadata$c("design:returntype", Promise)
    ], LobbyImpl.prototype, "admitAll", null);
    class MmrRdpConnectionManager {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        get state() {
            return getMmrRdpState();
        }
        dispose() {
            const g = window.navigator.mediaDevices;
            (g === null || g === void 0 ? void 0 : g.isRemote) && (g === null || g === void 0 ? void 0 : g.removeEventListener("rdpClientConnectionStateChanged", this._callback), this._logger.info("event listener unregistered")), this._eventEmitter.removeAllListeners();
        }
        constructor(g){
            this._lastState = "", this._callback = (g)=>{
                var _g_detail;
                var _g_detail_state;
                const f = (_g_detail_state = g === null || g === void 0 ? void 0 : (_g_detail = g.detail) === null || _g_detail === void 0 ? void 0 : _g_detail.state) !== null && _g_detail_state !== void 0 ? _g_detail_state : "";
                f ? f !== this._lastState && (this._logger.info(`connection state is ${f}`), this._eventEmitter.emit("stateChange", f), this._lastState = f) : this._logger.info("connection state is unknown");
            }, this._logger = g.createChild("MmrRdpConnectionManager"), this._eventEmitter = new Ny.EventEmitter;
            const f = window.navigator.mediaDevices;
            (f === null || f === void 0 ? void 0 : f.isRemote) && (f === null || f === void 0 ? void 0 : f.addEventListener("rdpClientConnectionStateChanged", this._callback), this._logger.info("listener registered"));
        }
    }
    var __decorate$d = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$d = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class RemoteVideoStreamImpl extends RemoteVideoStreamCommonImpl {
        on(g, f) {
            if ("isAvailableChanged" !== g && "sizeChanged" !== g && "isReceivingChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_VIDEO_STREAM.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("isAvailableChanged" !== g && "sizeChanged" !== g && "isReceivingChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_VIDEO_STREAM.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        get isAvailable() {
            return this._isAvailable;
        }
        async getMediaStream() {
            const g = generateGuid(), f = +new Date, S = {
                correlationId: g,
                additionalDetails: {
                    remoteStreamMetadata: this.getStreamMetadata(),
                    mediaSourceId: this.tsStream.mediaSourceId
                },
                operation: by.getMediaStream,
                mediaType: this.getMediaType(),
                streamType: Iy.Remote,
                timestampInfo: {
                    attemptTimestamp: f
                },
                kindOfEvent: uy.attempt,
                localParticipantId: this.call.tsCall.participantId,
                callId: this.call.id
            };
            this.sendMediaStreamEvent(S);
            try {
                if (!this.tsStream.getRawStream) throw new CallingCommunicationError({
                    defaultError: O.REMOTE_VIDEO_STREAM.GET_RAW_MEDIA_STREAM
                });
                if (!this.tsStream.isAvailable) throw new CallingCommunicationError({
                    defaultError: O.REMOTE_VIDEO_STREAM.RAWMEDIA_LVS_NOT_AVAILABLE
                });
                const S = this.tsStream.getRawStream(), v = new Promise(async (g, f)=>{
                    const v = setTimeout(()=>{
                        _.dispose(), f(new CallingCommunicationError({
                            defaultError: O.REMOTE_VIDEO_STREAM.SUBSCRIBE_MEDIA_STREAM_TIMEOUT
                        }));
                    }, getAcsEcsConfig().rendering.remoteVideo.getMediaStreamTimeout), _ = S.changed(()=>{
                        tryToResolveGetStreamPromise();
                    }), tryToResolveGetStreamPromise = async ()=>{
                        try {
                            const f = await S.getMediaStream();
                            if (!f) return void this.logger.warn("MediaStream is not yet ready.");
                            clearTimeout(v), _.dispose(), g(f);
                        } catch (g) {
                            this.logger.warn(`MediaStream is not yet ready, error=${(g === null || g === void 0 ? void 0 : g.message) || "unknown"}`);
                        }
                    };
                    tryToResolveGetStreamPromise();
                }), _ = await v, C = _.getVideoTracks()[0];
                if (!C) throw new CallingCommunicationError({
                    defaultError: O.REMOTE_VIDEO_STREAM.GET_TRACK
                });
                const E = new Promise((g, f)=>{
                    const resolveUnmutedPromise = ()=>{
                        C.removeEventListener("unmute", resolveUnmutedPromise, !1), g();
                    };
                    C.addEventListener("unmute", resolveUnmutedPromise, !1), C.muted ? setTimeout(()=>{
                        C.removeEventListener("unmute", resolveUnmutedPromise, !1), f(new CallingCommunicationError({
                            defaultError: O.REMOTE_VIDEO_STREAM.TRACK_UNMUTED_TIMEOUT
                        }));
                    }, getAcsEcsConfig().rendering.remoteVideo.getMediaStreamTimeout) : resolveUnmutedPromise();
                });
                await E;
                const T = {
                    correlationId: g,
                    additionalDetails: {
                        remoteStreamMetadata: this.getStreamMetadata(),
                        mediaSourceId: this.tsStream.mediaSourceId
                    },
                    operation: by.getMediaStream,
                    mediaType: this.getMediaType(),
                    streamType: Iy.Remote,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    kindOfEvent: uy.success,
                    localParticipantId: this.call.tsCall.participantId,
                    callId: this.call.id
                };
                return this.sendMediaStreamEvent(T), _;
            } catch (S) {
                const v = {
                    correlationId: g,
                    operation: by.getMediaStream,
                    mediaType: this.getMediaType(),
                    streamType: Iy.Remote,
                    additionalDetails: {
                        failureReason: (S === null || S === void 0 ? void 0 : S.message) || "",
                        code: S.code || x,
                        ...extractCommunicationServicesErrorForTelemetry(S),
                        remoteStreamMetadata: this.getStreamMetadata(),
                        mediaSourceId: this.tsStream.mediaSourceId
                    },
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    kindOfEvent: uy.failure,
                    localParticipantId: this.call.tsCall.participantId,
                    callId: this.call.id
                };
                throw this.sendMediaStreamEvent(v), new CallingCommunicationError({
                    defaultError: O.REMOTE_VIDEO_STREAM.GET_MEDIA_STREAM,
                    originalError: S
                });
            }
        }
        getStreamMetadata() {
            var _this_call, _this_call1, _this_call_activeRemoteVideoStreamViews, _this_call2;
            return {
                callId: (_this_call = this.call) === null || _this_call === void 0 ? void 0 : _this_call.id,
                streamType: this.mediaStreamType,
                localParticipantId: this.call.tsCall.participantId,
                remoteParticipantId: this.remoteParticipantId,
                sourceId: this.id,
                source: "remote",
                rank: this.tsStream.rank,
                isAvailable: this.tsStream.isAvailable,
                acsIsAvailable: this._isAvailable,
                isReceiving: this._isReceiving,
                isStreaming: this.tsStream.isStreaming,
                viewIdsRegistered: this._renderers.map((g)=>g.viewId).join(", "),
                height: this._size.height,
                width: this._size.width,
                isDisposed: this._disposed,
                optimalVideoCount: ((_this_call1 = this.call) === null || _this_call1 === void 0 ? void 0 : _this_call1.tsCall.optimalVideoCount) || 1,
                currentNumberOfVideosRendered: ((_this_call2 = this.call) === null || _this_call2 === void 0 ? void 0 : (_this_call_activeRemoteVideoStreamViews = _this_call2.activeRemoteVideoStreamViews) === null || _this_call_activeRemoteVideoStreamViews === void 0 ? void 0 : _this_call_activeRemoteVideoStreamViews.size) || 0
            };
        }
        dispose() {
            this.setIsAvailable(!1), super.dispose();
        }
        getMediaType() {
            return "ScreenSharing" === this.mediaStreamType ? Ty.ScreenSharingRaw : Ty.VideoRaw;
        }
        sendMediaStreamEvent(g) {
            this.telemetryLogManager.sendEvent({
                name: dy.acs_calling_media_stream,
                tenant: nf,
                properties: {
                    timestampInfo: g.timestampInfo,
                    correlationId: g.correlationId,
                    additionalDetails: g.additionalDetails || "",
                    kindOfEvent: g.kindOfEvent || "",
                    mediaType: g.mediaType,
                    streamType: g.streamType,
                    operation: g.operation,
                    localParticipantId: g.localParticipantId || "",
                    callId: g.callId || ""
                }
            });
        }
        constructor(g, f, S, v, _, C, E){
            super(g, f, S, _, C, "RemoteVideoStream"), this._remoteParticipantIdentifier = E, this._isAvailable = !1, this.setIsAvailable = (g)=>{
                g !== this._isAvailable && (this._isAvailable = !!g, this.logger.log(`isAvailable changed to ${this._isAvailable}`), this._eventEmitter.emit("isAvailableChanged", this._isAvailable), this.call.isHandlingLargeMeetingVideoRendering && this.call.handleDominantSpeakersVideos(), super.sendRemoteVideoStreamTelemetry());
            };
            const handleIsAvailable = ()=>{
                if ("Video" === this.mediaStreamType && S.isHandlingLargeMeetingVideoRendering) {
                    for (const g of S.getTopNDominantSpeakersWithVideoOn())if (this.tsStream.isAvailable && getMriFromIdentifier(g.identifier) === getMriFromIdentifier(this._remoteParticipantIdentifier)) return void this.setIsAvailable(!0);
                    this.setIsAvailable(!1);
                } else this.setIsAvailable(this.tsStream.isAvailable);
            };
            this._streamChangedHandler = this.tsStream.changed(()=>{
                handleIsAvailable();
            }), handleIsAvailable();
        }
    }
    __decorate$d([
        asyncOperation(kS.GetMediaStream),
        __metadata$d("design:type", Function),
        __metadata$d("design:paramtypes", []),
        __metadata$d("design:returntype", Promise)
    ], RemoteVideoStreamImpl.prototype, "getMediaStream", null);
    const yb = {
        2: "#050505",
        4: "#0a0a0a",
        6: "#0f0f0f",
        8: "#141414",
        10: "#1a1a1a",
        12: "#1f1f1f",
        14: "#242424",
        16: "#292929",
        18: "#2e2e2e",
        20: "#333333",
        22: "#383838",
        24: "#3d3d3d",
        26: "#424242",
        28: "#474747",
        30: "#4d4d4d",
        32: "#525252",
        34: "#575757",
        36: "#5c5c5c",
        38: "#616161",
        40: "#666666",
        42: "#6b6b6b",
        44: "#707070",
        46: "#757575",
        48: "#7a7a7a",
        50: "#808080",
        52: "#858585",
        54: "#8a8a8a",
        56: "#8f8f8f",
        58: "#949494",
        60: "#999999",
        62: "#9e9e9e",
        64: "#a3a3a3",
        66: "#a8a8a8",
        68: "#adadad",
        70: "#b3b3b3",
        72: "#b8b8b8",
        74: "#bdbdbd",
        76: "#c2c2c2",
        78: "#c7c7c7",
        80: "#cccccc",
        82: "#d1d1d1",
        84: "#d6d6d6",
        86: "#dbdbdb",
        88: "#e0e0e0",
        90: "#e6e6e6",
        92: "#ebebeb",
        94: "#f0f0f0",
        96: "#f5f5f5",
        98: "#fafafa"
    }, Eb = {
        5: "rgba(255, 255, 255, 0.05)",
        10: "rgba(255, 255, 255, 0.1)",
        20: "rgba(255, 255, 255, 0.2)",
        30: "rgba(255, 255, 255, 0.3)",
        40: "rgba(255, 255, 255, 0.4)",
        50: "rgba(255, 255, 255, 0.5)",
        60: "rgba(255, 255, 255, 0.6)",
        70: "rgba(255, 255, 255, 0.7)",
        80: "rgba(255, 255, 255, 0.8)",
        90: "rgba(255, 255, 255, 0.9)"
    }, Tb = {
        5: "rgba(0, 0, 0, 0.05)",
        10: "rgba(0, 0, 0, 0.1)",
        20: "rgba(0, 0, 0, 0.2)",
        30: "rgba(0, 0, 0, 0.3)",
        40: "rgba(0, 0, 0, 0.4)",
        50: "rgba(0, 0, 0, 0.5)",
        60: "rgba(0, 0, 0, 0.6)",
        70: "rgba(0, 0, 0, 0.7)",
        80: "rgba(0, 0, 0, 0.8)",
        90: "rgba(0, 0, 0, 0.9)"
    }, Ib = "#ffffff", bb = "#000000", Ab = {
        shade50: "#200205",
        shade40: "#3b0509",
        shade30: "#6e0811",
        shade20: "#960b18",
        shade10: "#b10e1c",
        primary: "#c50f1f",
        tint10: "#cc2635",
        tint20: "#d33f4c",
        tint30: "#dc626d",
        tint40: "#eeacb2",
        tint50: "#f6d1d5",
        tint60: "#fdf3f4"
    }, Rb = {
        shade50: "#031403",
        shade40: "#052505",
        shade30: "#094509",
        shade20: "#0c5e0c",
        shade10: "#0e700e",
        primary: "#107c10",
        tint10: "#218c21",
        tint20: "#359b35",
        tint30: "#54b054",
        tint40: "#9fd89f",
        tint50: "#c9eac9",
        tint60: "#f1faf1"
    }, Pb = {
        red: {
            shade50: "#210809",
            shade40: "#3f1011",
            shade30: "#751d1f",
            shade20: "#9f282b",
            shade10: "#bc2f32",
            primary: "#d13438",
            tint10: "#d7494c",
            tint20: "#dc5e62",
            tint30: "#e37d80",
            tint40: "#f1bbbc",
            tint50: "#f8dadb",
            tint60: "#fdf6f6"
        },
        green: Rb,
        darkOrange: {
            shade50: "#230900",
            shade40: "#411200",
            shade30: "#7a2101",
            shade20: "#a62d01",
            shade10: "#c43501",
            primary: "#da3b01",
            tint10: "#de501c",
            tint20: "#e36537",
            tint30: "#e9835e",
            tint40: "#f4bfab",
            tint50: "#f9dcd1",
            tint60: "#fdf6f3"
        },
        yellow: {
            shade50: "#282400",
            shade40: "#4c4400",
            shade30: "#817400",
            shade20: "#c0ad00",
            shade10: "#e4cc00",
            primary: "#fde300",
            tint10: "#fde61e",
            tint20: "#fdea3d",
            tint30: "#feee66",
            tint40: "#fef7b2",
            tint50: "#fffad6",
            tint60: "#fffef5"
        },
        berry: {
            shade50: "#1f091d",
            shade40: "#3a1136",
            shade30: "#6d2064",
            shade20: "#932b88",
            shade10: "#af33a1",
            primary: "#c239b3",
            tint10: "#c94cbc",
            tint20: "#d161c4",
            tint30: "#da7ed0",
            tint40: "#edbbe7",
            tint50: "#f5daf2",
            tint60: "#fdf5fc"
        },
        lightGreen: {
            shade50: "#031a02",
            shade40: "#063004",
            shade30: "#0b5a08",
            shade20: "#0e7a0b",
            shade10: "#11910d",
            primary: "#13a10e",
            tint10: "#27ac22",
            tint20: "#3db838",
            tint30: "#5ec75a",
            tint40: "#a7e3a5",
            tint50: "#cef0cd",
            tint60: "#f2fbf2"
        },
        marigold: {
            shade50: "#251a00",
            shade40: "#463100",
            shade30: "#835b00",
            shade20: "#b27c00",
            shade10: "#d39300",
            primary: "#eaa300",
            tint10: "#edad1c",
            tint20: "#efb839",
            tint30: "#f2c661",
            tint40: "#f9e2ae",
            tint50: "#fcefd3",
            tint60: "#fefbf4"
        }
    }, wb = {
        darkRed: {
            shade50: "#130204",
            shade40: "#230308",
            shade30: "#420610",
            shade20: "#590815",
            shade10: "#690a19",
            primary: "#750b1c",
            tint10: "#861b2c",
            tint20: "#962f3f",
            tint30: "#ac4f5e",
            tint40: "#d69ca5",
            tint50: "#e9c7cd",
            tint60: "#f9f0f2"
        },
        cranberry: Ab,
        pumpkin: {
            shade50: "#200d03",
            shade40: "#3d1805",
            shade30: "#712d09",
            shade20: "#9a3d0c",
            shade10: "#b6480e",
            primary: "#ca5010",
            tint10: "#d06228",
            tint20: "#d77440",
            tint30: "#df8e64",
            tint40: "#efc4ad",
            tint50: "#f7dfd2",
            tint60: "#fdf7f4"
        },
        peach: {
            shade50: "#291600",
            shade40: "#4d2a00",
            shade30: "#8f4e00",
            shade20: "#c26a00",
            shade10: "#e67e00",
            primary: "#ff8c00",
            tint10: "#ff9a1f",
            tint20: "#ffa83d",
            tint30: "#ffba66",
            tint40: "#ffddb3",
            tint50: "#ffedd6",
            tint60: "#fffaf5"
        },
        gold: {
            shade50: "#1f1900",
            shade40: "#3a2f00",
            shade30: "#6c5700",
            shade20: "#937700",
            shade10: "#ae8c00",
            primary: "#c19c00",
            tint10: "#c8a718",
            tint20: "#d0b232",
            tint30: "#dac157",
            tint40: "#ecdfa5",
            tint50: "#f5eece",
            tint60: "#fdfbf2"
        },
        brass: {
            shade50: "#181202",
            shade40: "#2e2103",
            shade30: "#553e06",
            shade20: "#745408",
            shade10: "#89640a",
            primary: "#986f0b",
            tint10: "#a47d1e",
            tint20: "#b18c34",
            tint30: "#c1a256",
            tint40: "#e0cea2",
            tint50: "#efe4cb",
            tint60: "#fbf8f2"
        },
        brown: {
            shade50: "#170e07",
            shade40: "#2b1a0e",
            shade30: "#50301a",
            shade20: "#6c4123",
            shade10: "#804d29",
            primary: "#8e562e",
            tint10: "#9c663f",
            tint20: "#a97652",
            tint30: "#bb8f6f",
            tint40: "#ddc3b0",
            tint50: "#edded3",
            tint60: "#faf7f4"
        },
        forest: {
            shade50: "#0c1501",
            shade40: "#162702",
            shade30: "#294903",
            shade20: "#376304",
            shade10: "#427505",
            primary: "#498205",
            tint10: "#599116",
            tint20: "#6ba02b",
            tint30: "#85b44c",
            tint40: "#bdd99b",
            tint50: "#dbebc7",
            tint60: "#f6faf0"
        },
        seafoam: {
            shade50: "#002111",
            shade40: "#003d20",
            shade30: "#00723b",
            shade20: "#009b51",
            shade10: "#00b85f",
            primary: "#00cc6a",
            tint10: "#19d279",
            tint20: "#34d889",
            tint30: "#5ae0a0",
            tint40: "#a8f0cd",
            tint50: "#cff7e4",
            tint60: "#f3fdf8"
        },
        darkGreen: {
            shade50: "#021102",
            shade40: "#032003",
            shade30: "#063b06",
            shade20: "#085108",
            shade10: "#0a5f0a",
            primary: "#0b6a0b",
            tint10: "#1a7c1a",
            tint20: "#2d8e2d",
            tint30: "#4da64d",
            tint40: "#9ad29a",
            tint50: "#c6e7c6",
            tint60: "#f0f9f0"
        },
        lightTeal: {
            shade50: "#001d1f",
            shade40: "#00373a",
            shade30: "#00666d",
            shade20: "#008b94",
            shade10: "#00a5af",
            primary: "#00b7c3",
            tint10: "#18bfca",
            tint20: "#32c8d1",
            tint30: "#58d3db",
            tint40: "#a6e9ed",
            tint50: "#cef3f5",
            tint60: "#f2fcfd"
        },
        teal: {
            shade50: "#001516",
            shade40: "#012728",
            shade30: "#02494c",
            shade20: "#026467",
            shade10: "#037679",
            primary: "#038387",
            tint10: "#159195",
            tint20: "#2aa0a4",
            tint30: "#4cb4b7",
            tint40: "#9bd9db",
            tint50: "#c7ebec",
            tint60: "#f0fafa"
        },
        steel: {
            shade50: "#000f12",
            shade40: "#001b22",
            shade30: "#00333f",
            shade20: "#004555",
            shade10: "#005265",
            primary: "#005b70",
            tint10: "#0f6c81",
            tint20: "#237d92",
            tint30: "#4496a9",
            tint40: "#94c8d4",
            tint50: "#c3e1e8",
            tint60: "#eff7f9"
        },
        blue: {
            shade50: "#001322",
            shade40: "#002440",
            shade30: "#004377",
            shade20: "#005ba1",
            shade10: "#006cbf",
            primary: "#0078d4",
            tint10: "#1a86d9",
            tint20: "#3595de",
            tint30: "#5caae5",
            tint40: "#a9d3f2",
            tint50: "#d0e7f8",
            tint60: "#f3f9fd"
        },
        royalBlue: {
            shade50: "#000c16",
            shade40: "#00172a",
            shade30: "#002c4e",
            shade20: "#003b6a",
            shade10: "#00467e",
            primary: "#004e8c",
            tint10: "#125e9a",
            tint20: "#286fa8",
            tint30: "#4a89ba",
            tint40: "#9abfdc",
            tint50: "#c7dced",
            tint60: "#f0f6fa"
        },
        cornflower: {
            shade50: "#0d1126",
            shade40: "#182047",
            shade30: "#2c3c85",
            shade20: "#3c51b4",
            shade10: "#4760d5",
            primary: "#4f6bed",
            tint10: "#637cef",
            tint20: "#778df1",
            tint30: "#93a4f4",
            tint40: "#c8d1fa",
            tint50: "#e1e6fc",
            tint60: "#f7f9fe"
        },
        navy: {
            shade50: "#00061d",
            shade40: "#000c36",
            shade30: "#001665",
            shade20: "#001e89",
            shade10: "#0023a2",
            primary: "#0027b4",
            tint10: "#173bbd",
            tint20: "#3050c6",
            tint30: "#546fd2",
            tint40: "#a3b2e8",
            tint50: "#ccd5f3",
            tint60: "#f2f4fc"
        },
        lavender: {
            shade50: "#120f25",
            shade40: "#221d46",
            shade30: "#3f3682",
            shade20: "#5649b0",
            shade10: "#6656d1",
            primary: "#7160e8",
            tint10: "#8172eb",
            tint20: "#9184ee",
            tint30: "#a79cf1",
            tint40: "#d2ccf8",
            tint50: "#e7e4fb",
            tint60: "#f9f8fe"
        },
        purple: {
            shade50: "#0f0717",
            shade40: "#1c0e2b",
            shade30: "#341a51",
            shade20: "#46236e",
            shade10: "#532982",
            primary: "#5c2e91",
            tint10: "#6b3f9e",
            tint20: "#7c52ab",
            tint30: "#9470bd",
            tint40: "#c6b1de",
            tint50: "#e0d3ed",
            tint60: "#f7f4fb"
        },
        grape: {
            shade50: "#160418",
            shade40: "#29072e",
            shade30: "#4c0d55",
            shade20: "#671174",
            shade10: "#7a1589",
            primary: "#881798",
            tint10: "#952aa4",
            tint20: "#a33fb1",
            tint30: "#b55fc1",
            tint40: "#d9a7e0",
            tint50: "#eaceef",
            tint60: "#faf2fb"
        },
        lilac: {
            shade50: "#1c0b1f",
            shade40: "#35153a",
            shade30: "#63276d",
            shade20: "#863593",
            shade10: "#9f3faf",
            primary: "#b146c2",
            tint10: "#ba58c9",
            tint20: "#c36bd1",
            tint30: "#cf87da",
            tint40: "#e6bfed",
            tint50: "#f2dcf5",
            tint60: "#fcf6fd"
        },
        pink: {
            shade50: "#24091b",
            shade40: "#441232",
            shade30: "#80215d",
            shade20: "#ad2d7e",
            shade10: "#cd3595",
            primary: "#e43ba6",
            tint10: "#e750b0",
            tint20: "#ea66ba",
            tint30: "#ef85c8",
            tint40: "#f7c0e3",
            tint50: "#fbddf0",
            tint60: "#fef6fb"
        },
        magenta: {
            shade50: "#1f0013",
            shade40: "#390024",
            shade30: "#6b0043",
            shade20: "#91005a",
            shade10: "#ac006b",
            primary: "#bf0077",
            tint10: "#c71885",
            tint20: "#ce3293",
            tint30: "#d957a8",
            tint40: "#eca5d1",
            tint50: "#f5cee6",
            tint60: "#fcf2f9"
        },
        plum: {
            shade50: "#13000c",
            shade40: "#240017",
            shade30: "#43002b",
            shade20: "#5a003b",
            shade10: "#6b0045",
            primary: "#77004d",
            tint10: "#87105d",
            tint20: "#98246f",
            tint30: "#ad4589",
            tint40: "#d696c0",
            tint50: "#e9c4dc",
            tint60: "#faf0f6"
        },
        beige: {
            shade50: "#141313",
            shade40: "#252323",
            shade30: "#444241",
            shade20: "#5d5958",
            shade10: "#6e6968",
            primary: "#7a7574",
            tint10: "#8a8584",
            tint20: "#9a9594",
            tint30: "#afabaa",
            tint40: "#d7d4d4",
            tint50: "#eae8e8",
            tint60: "#faf9f9"
        },
        mink: {
            shade50: "#0f0e0e",
            shade40: "#1c1b1a",
            shade30: "#343231",
            shade20: "#474443",
            shade10: "#54514f",
            primary: "#5d5a58",
            tint10: "#706d6b",
            tint20: "#84817e",
            tint30: "#9e9b99",
            tint40: "#cecccb",
            tint50: "#e5e4e3",
            tint60: "#f8f8f8"
        },
        platinum: {
            shade50: "#111314",
            shade40: "#1f2426",
            shade30: "#3b4447",
            shade20: "#505c60",
            shade10: "#5f6d71",
            primary: "#69797e",
            tint10: "#79898d",
            tint20: "#89989d",
            tint30: "#a0adb2",
            tint40: "#cdd6d8",
            tint50: "#e4e9ea",
            tint60: "#f8f9fa"
        },
        anchor: {
            shade50: "#090a0b",
            shade40: "#111315",
            shade30: "#202427",
            shade20: "#2b3135",
            shade10: "#333a3f",
            primary: "#394146",
            tint10: "#4d565c",
            tint20: "#626c72",
            tint30: "#808a90",
            tint40: "#bcc3c7",
            tint50: "#dbdfe1",
            tint60: "#f6f7f8"
        }
    }, Mb = {
        cranberry: Ab,
        green: Rb,
        orange: {
            shade50: "#271002",
            shade40: "#4a1e04",
            shade30: "#8a3707",
            shade20: "#bc4b09",
            shade10: "#de590b",
            primary: "#f7630c",
            tint10: "#f87528",
            tint20: "#f98845",
            tint30: "#faa06b",
            tint40: "#fdcfb4",
            tint50: "#fee5d7",
            tint60: "#fff9f5"
        }
    }, Ob = [
        "darkRed",
        "cranberry",
        "pumpkin",
        "peach",
        "gold",
        "brass",
        "brown",
        "forest",
        "seafoam",
        "darkGreen",
        "lightTeal",
        "teal",
        "steel",
        "blue",
        "royalBlue",
        "cornflower",
        "navy",
        "lavender",
        "purple",
        "grape",
        "lilac",
        "pink",
        "magenta",
        "plum",
        "beige",
        "mink",
        "platinum",
        "anchor"
    ], Db = {
        success: "green",
        warning: "orange",
        danger: "cranberry"
    }, Nb = [
        "red",
        "green",
        "darkOrange",
        "yellow",
        "berry",
        "lightGreen",
        "marigold"
    ].reduce((g, f)=>{
        const S = f.slice(0, 1).toUpperCase() + f.slice(1), v = {
            [`colorPalette${S}Background1`]: Pb[f].tint60,
            [`colorPalette${S}Background2`]: Pb[f].tint40,
            [`colorPalette${S}Background3`]: Pb[f].primary,
            [`colorPalette${S}Foreground1`]: Pb[f].shade10,
            [`colorPalette${S}Foreground2`]: Pb[f].shade30,
            [`colorPalette${S}Foreground3`]: Pb[f].primary,
            [`colorPalette${S}BorderActive`]: Pb[f].primary,
            [`colorPalette${S}Border1`]: Pb[f].tint40,
            [`colorPalette${S}Border2`]: Pb[f].primary
        };
        return Object.assign(g, v);
    }, {});
    Nb.colorPaletteYellowForeground1 = Pb.yellow.shade30, Nb.colorPaletteRedForegroundInverted = Pb.red.tint20, Nb.colorPaletteGreenForegroundInverted = Pb.green.tint20, Nb.colorPaletteYellowForegroundInverted = Pb.yellow.tint40;
    const kb = Ob.reduce((g, f)=>{
        const S = f.slice(0, 1).toUpperCase() + f.slice(1), v = {
            [`colorPalette${S}Background2`]: wb[f].tint40,
            [`colorPalette${S}Foreground2`]: wb[f].shade30,
            [`colorPalette${S}BorderActive`]: wb[f].primary
        };
        return Object.assign(g, v);
    }, {}), Lb = {
        ...Nb,
        ...kb
    }, Fb = Object.entries(Db).reduce((g, [f, S])=>{
        const v = f.slice(0, 1).toUpperCase() + f.slice(1), _ = {
            [`colorStatus${v}Background1`]: Mb[S].tint60,
            [`colorStatus${v}Background2`]: Mb[S].tint40,
            [`colorStatus${v}Background3`]: Mb[S].primary,
            [`colorStatus${v}Foreground1`]: Mb[S].shade10,
            [`colorStatus${v}Foreground2`]: Mb[S].shade30,
            [`colorStatus${v}Foreground3`]: Mb[S].primary,
            [`colorStatus${v}ForegroundInverted`]: Mb[S].tint30,
            [`colorStatus${v}BorderActive`]: Mb[S].primary,
            [`colorStatus${v}Border1`]: Mb[S].tint40,
            [`colorStatus${v}Border2`]: Mb[S].primary
        };
        return Object.assign(g, _);
    }, {});
    Fb.colorStatusDangerBackground3Hover = Mb[Db.danger].shade10, Fb.colorStatusDangerBackground3Pressed = Mb[Db.danger].shade20, Fb.colorStatusWarningForeground1 = Mb[Db.warning].shade20, Fb.colorStatusWarningForeground3 = Mb[Db.warning].shade20, Fb.colorStatusWarningBorder2 = Mb[Db.warning].shade20;
    const generateColorTokens = (g)=>({
            colorNeutralForeground1: yb[14],
            colorNeutralForeground1Hover: yb[14],
            colorNeutralForeground1Pressed: yb[14],
            colorNeutralForeground1Selected: yb[14],
            colorNeutralForeground2: yb[26],
            colorNeutralForeground2Hover: yb[14],
            colorNeutralForeground2Pressed: yb[14],
            colorNeutralForeground2Selected: yb[14],
            colorNeutralForeground2BrandHover: g[80],
            colorNeutralForeground2BrandPressed: g[70],
            colorNeutralForeground2BrandSelected: g[80],
            colorNeutralForeground3: yb[38],
            colorNeutralForeground3Hover: yb[26],
            colorNeutralForeground3Pressed: yb[26],
            colorNeutralForeground3Selected: yb[26],
            colorNeutralForeground3BrandHover: g[80],
            colorNeutralForeground3BrandPressed: g[70],
            colorNeutralForeground3BrandSelected: g[80],
            colorNeutralForeground4: yb[44],
            colorNeutralForegroundDisabled: yb[74],
            colorNeutralForegroundInvertedDisabled: Eb[40],
            colorBrandForegroundLink: g[70],
            colorBrandForegroundLinkHover: g[60],
            colorBrandForegroundLinkPressed: g[40],
            colorBrandForegroundLinkSelected: g[70],
            colorNeutralForeground2Link: yb[26],
            colorNeutralForeground2LinkHover: yb[14],
            colorNeutralForeground2LinkPressed: yb[14],
            colorNeutralForeground2LinkSelected: yb[14],
            colorCompoundBrandForeground1: g[80],
            colorCompoundBrandForeground1Hover: g[70],
            colorCompoundBrandForeground1Pressed: g[60],
            colorBrandForeground1: g[80],
            colorBrandForeground2: g[70],
            colorBrandForeground2Hover: g[60],
            colorBrandForeground2Pressed: g[30],
            colorNeutralForeground1Static: yb[14],
            colorNeutralForegroundStaticInverted: Ib,
            colorNeutralForegroundInverted: Ib,
            colorNeutralForegroundInvertedHover: Ib,
            colorNeutralForegroundInvertedPressed: Ib,
            colorNeutralForegroundInvertedSelected: Ib,
            colorNeutralForegroundInverted2: Ib,
            colorNeutralForegroundOnBrand: Ib,
            colorNeutralForegroundInvertedLink: Ib,
            colorNeutralForegroundInvertedLinkHover: Ib,
            colorNeutralForegroundInvertedLinkPressed: Ib,
            colorNeutralForegroundInvertedLinkSelected: Ib,
            colorBrandForegroundInverted: g[100],
            colorBrandForegroundInvertedHover: g[110],
            colorBrandForegroundInvertedPressed: g[100],
            colorBrandForegroundOnLight: g[80],
            colorBrandForegroundOnLightHover: g[70],
            colorBrandForegroundOnLightPressed: g[50],
            colorBrandForegroundOnLightSelected: g[60],
            colorNeutralBackground1: Ib,
            colorNeutralBackground1Hover: yb[96],
            colorNeutralBackground1Pressed: yb[88],
            colorNeutralBackground1Selected: yb[92],
            colorNeutralBackground2: yb[98],
            colorNeutralBackground2Hover: yb[94],
            colorNeutralBackground2Pressed: yb[86],
            colorNeutralBackground2Selected: yb[90],
            colorNeutralBackground3: yb[96],
            colorNeutralBackground3Hover: yb[92],
            colorNeutralBackground3Pressed: yb[84],
            colorNeutralBackground3Selected: yb[88],
            colorNeutralBackground4: yb[94],
            colorNeutralBackground4Hover: yb[98],
            colorNeutralBackground4Pressed: yb[96],
            colorNeutralBackground4Selected: Ib,
            colorNeutralBackground5: yb[92],
            colorNeutralBackground5Hover: yb[96],
            colorNeutralBackground5Pressed: yb[94],
            colorNeutralBackground5Selected: yb[98],
            colorNeutralBackground6: yb[90],
            colorNeutralBackgroundInverted: yb[16],
            colorNeutralBackgroundStatic: yb[20],
            colorNeutralBackgroundAlpha: Eb[50],
            colorNeutralBackgroundAlpha2: Eb[80],
            colorSubtleBackground: "transparent",
            colorSubtleBackgroundHover: yb[96],
            colorSubtleBackgroundPressed: yb[88],
            colorSubtleBackgroundSelected: yb[92],
            colorSubtleBackgroundLightAlphaHover: Eb[70],
            colorSubtleBackgroundLightAlphaPressed: Eb[50],
            colorSubtleBackgroundLightAlphaSelected: "transparent",
            colorSubtleBackgroundInverted: "transparent",
            colorSubtleBackgroundInvertedHover: Tb[10],
            colorSubtleBackgroundInvertedPressed: Tb[30],
            colorSubtleBackgroundInvertedSelected: Tb[20],
            colorTransparentBackground: "transparent",
            colorTransparentBackgroundHover: "transparent",
            colorTransparentBackgroundPressed: "transparent",
            colorTransparentBackgroundSelected: "transparent",
            colorNeutralBackgroundDisabled: yb[94],
            colorNeutralBackgroundInvertedDisabled: Eb[10],
            colorNeutralStencil1: yb[90],
            colorNeutralStencil2: yb[98],
            colorNeutralStencil1Alpha: Tb[10],
            colorNeutralStencil2Alpha: Tb[5],
            colorBackgroundOverlay: Tb[40],
            colorScrollbarOverlay: Tb[50],
            colorBrandBackground: g[80],
            colorBrandBackgroundHover: g[70],
            colorBrandBackgroundPressed: g[40],
            colorBrandBackgroundSelected: g[60],
            colorCompoundBrandBackground: g[80],
            colorCompoundBrandBackgroundHover: g[70],
            colorCompoundBrandBackgroundPressed: g[60],
            colorBrandBackgroundStatic: g[80],
            colorBrandBackground2: g[160],
            colorBrandBackground2Hover: g[150],
            colorBrandBackground2Pressed: g[130],
            colorBrandBackground3Static: g[60],
            colorBrandBackground4Static: g[40],
            colorBrandBackgroundInverted: Ib,
            colorBrandBackgroundInvertedHover: g[160],
            colorBrandBackgroundInvertedPressed: g[140],
            colorBrandBackgroundInvertedSelected: g[150],
            colorNeutralCardBackground: yb[98],
            colorNeutralCardBackgroundHover: Ib,
            colorNeutralCardBackgroundPressed: yb[96],
            colorNeutralCardBackgroundSelected: yb[92],
            colorNeutralCardBackgroundDisabled: yb[94],
            colorNeutralStrokeAccessible: yb[38],
            colorNeutralStrokeAccessibleHover: yb[34],
            colorNeutralStrokeAccessiblePressed: yb[30],
            colorNeutralStrokeAccessibleSelected: g[80],
            colorNeutralStroke1: yb[82],
            colorNeutralStroke1Hover: yb[78],
            colorNeutralStroke1Pressed: yb[70],
            colorNeutralStroke1Selected: yb[74],
            colorNeutralStroke2: yb[88],
            colorNeutralStroke3: yb[94],
            colorNeutralStrokeSubtle: yb[88],
            colorNeutralStrokeOnBrand: Ib,
            colorNeutralStrokeOnBrand2: Ib,
            colorNeutralStrokeOnBrand2Hover: Ib,
            colorNeutralStrokeOnBrand2Pressed: Ib,
            colorNeutralStrokeOnBrand2Selected: Ib,
            colorBrandStroke1: g[80],
            colorBrandStroke2: g[140],
            colorBrandStroke2Hover: g[120],
            colorBrandStroke2Pressed: g[80],
            colorBrandStroke2Contrast: g[140],
            colorCompoundBrandStroke: g[80],
            colorCompoundBrandStrokeHover: g[70],
            colorCompoundBrandStrokePressed: g[60],
            colorNeutralStrokeDisabled: yb[88],
            colorNeutralStrokeInvertedDisabled: Eb[40],
            colorTransparentStroke: "transparent",
            colorTransparentStrokeInteractive: "transparent",
            colorTransparentStrokeDisabled: "transparent",
            colorNeutralStrokeAlpha: Tb[5],
            colorNeutralStrokeAlpha2: Eb[20],
            colorStrokeFocus1: Ib,
            colorStrokeFocus2: bb,
            colorNeutralShadowAmbient: "rgba(0,0,0,0.12)",
            colorNeutralShadowKey: "rgba(0,0,0,0.14)",
            colorNeutralShadowAmbientLighter: "rgba(0,0,0,0.06)",
            colorNeutralShadowKeyLighter: "rgba(0,0,0,0.07)",
            colorNeutralShadowAmbientDarker: "rgba(0,0,0,0.20)",
            colorNeutralShadowKeyDarker: "rgba(0,0,0,0.24)",
            colorBrandShadowAmbient: "rgba(0,0,0,0.30)",
            colorBrandShadowKey: "rgba(0,0,0,0.25)"
        }), xb = {
        borderRadiusNone: "0",
        borderRadiusSmall: "2px",
        borderRadiusMedium: "4px",
        borderRadiusLarge: "6px",
        borderRadiusXLarge: "8px",
        borderRadiusCircular: "10000px"
    }, Ub = {
        curveAccelerateMax: "cubic-bezier(0.9,0.1,1,0.2)",
        curveAccelerateMid: "cubic-bezier(1,0,1,1)",
        curveAccelerateMin: "cubic-bezier(0.8,0,0.78,1)",
        curveDecelerateMax: "cubic-bezier(0.1,0.9,0.2,1)",
        curveDecelerateMid: "cubic-bezier(0,0,0,1)",
        curveDecelerateMin: "cubic-bezier(0.33,0,0.1,1)",
        curveEasyEaseMax: "cubic-bezier(0.8,0,0.2,1)",
        curveEasyEase: "cubic-bezier(0.33,0,0.67,1)",
        curveLinear: "cubic-bezier(0,0,1,1)"
    }, Vb = {
        durationUltraFast: "50ms",
        durationFaster: "100ms",
        durationFast: "150ms",
        durationNormal: "200ms",
        durationGentle: "250ms",
        durationSlow: "300ms",
        durationSlower: "400ms",
        durationUltraSlow: "500ms"
    }, Bb = {
        fontSizeBase100: "10px",
        fontSizeBase200: "12px",
        fontSizeBase300: "14px",
        fontSizeBase400: "16px",
        fontSizeBase500: "20px",
        fontSizeBase600: "24px",
        fontSizeHero700: "28px",
        fontSizeHero800: "32px",
        fontSizeHero900: "40px",
        fontSizeHero1000: "68px"
    }, Hb = {
        lineHeightBase100: "14px",
        lineHeightBase200: "16px",
        lineHeightBase300: "20px",
        lineHeightBase400: "22px",
        lineHeightBase500: "28px",
        lineHeightBase600: "32px",
        lineHeightHero700: "36px",
        lineHeightHero800: "40px",
        lineHeightHero900: "52px",
        lineHeightHero1000: "92px"
    }, $b = {
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemibold: 600,
        fontWeightBold: 700
    }, jb = {
        fontFamilyBase: "'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
        fontFamilyMonospace: "Consolas, 'Courier New', Courier, monospace",
        fontFamilyNumeric: "Bahnschrift, 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif"
    }, Gb = {
        none: "0",
        xxs: "2px",
        xs: "4px",
        sNudge: "6px",
        s: "8px",
        mNudge: "10px",
        m: "12px",
        l: "16px",
        xl: "20px",
        xxl: "24px",
        xxxl: "32px"
    }, qb = {
        spacingHorizontalNone: Gb.none,
        spacingHorizontalXXS: Gb.xxs,
        spacingHorizontalXS: Gb.xs,
        spacingHorizontalSNudge: Gb.sNudge,
        spacingHorizontalS: Gb.s,
        spacingHorizontalMNudge: Gb.mNudge,
        spacingHorizontalM: Gb.m,
        spacingHorizontalL: Gb.l,
        spacingHorizontalXL: Gb.xl,
        spacingHorizontalXXL: Gb.xxl,
        spacingHorizontalXXXL: Gb.xxxl
    }, Wb = {
        spacingVerticalNone: Gb.none,
        spacingVerticalXXS: Gb.xxs,
        spacingVerticalXS: Gb.xs,
        spacingVerticalSNudge: Gb.sNudge,
        spacingVerticalS: Gb.s,
        spacingVerticalMNudge: Gb.mNudge,
        spacingVerticalM: Gb.m,
        spacingVerticalL: Gb.l,
        spacingVerticalXL: Gb.xl,
        spacingVerticalXXL: Gb.xxl,
        spacingVerticalXXXL: Gb.xxxl
    }, zb = {
        strokeWidthThin: "1px",
        strokeWidthThick: "2px",
        strokeWidthThicker: "3px",
        strokeWidthThickest: "4px"
    };
    function createShadowTokens(g, f, S = "") {
        return {
            [`shadow2${S}`]: `0 0 2px ${g}, 0 1px 2px ${f}`,
            [`shadow4${S}`]: `0 0 2px ${g}, 0 2px 4px ${f}`,
            [`shadow8${S}`]: `0 0 2px ${g}, 0 4px 8px ${f}`,
            [`shadow16${S}`]: `0 0 2px ${g}, 0 8px 16px ${f}`,
            [`shadow28${S}`]: `0 0 8px ${g}, 0 14px 28px ${f}`,
            [`shadow64${S}`]: `0 0 8px ${g}, 0 32px 64px ${f}`
        };
    }
    const Kb = ((g)=>{
        const f = generateColorTokens(g);
        return {
            ...xb,
            ...Bb,
            ...Hb,
            ...jb,
            ...$b,
            ...zb,
            ...qb,
            ...Wb,
            ...Vb,
            ...Ub,
            ...f,
            ...Lb,
            ...Fb,
            ...createShadowTokens(f.colorNeutralShadowAmbient, f.colorNeutralShadowKey),
            ...createShadowTokens(f.colorBrandShadowAmbient, f.colorBrandShadowKey, "Brand")
        };
    })({
        10: "#061724",
        20: "#082338",
        30: "#0a2e4a",
        40: "#0c3b5e",
        50: "#0e4775",
        60: "#0f548c",
        70: "#115ea3",
        80: "#0f6cbd",
        90: "#2886de",
        100: "#479ef5",
        110: "#62abf5",
        120: "#77b7f7",
        130: "#96c6fa",
        140: "#b4d6fa",
        150: "#cfe4fa",
        160: "#ebf3fc"
    });
    let Jb = 1;
    class WatermarkOverlayProvider {
        attach() {
            const g = generateGuid(), f = Date.now();
            try {
                if (!this._watermarkCapability) return void this._logger.warn("No watermark capabilities found. No-op.");
                if ("Video" !== this._videoStream.mediaStreamType && "ScreenSharing" !== this._videoStream.mediaStreamType) throw new Error("Unsupported media type for watermark");
                this._watermarkIsReceivingSub = ()=>{
                    this._videoStream.isReceiving && (this._generateWatermark(this._videoStream.mediaStreamType, g), this._updateWatermarkScalingValues(this._container.getBoundingClientRect().width, this._container.getBoundingClientRect().height));
                }, this._videoStream.on("isReceivingChanged", this._watermarkIsReceivingSub);
            } catch (S) {
                const v = new CallingCommunicationError({
                    defaultError: O.VIEW.WATERMARK_ATTACH_FAIL,
                    originalError: S
                });
                throw this._streamTelemetryEventSender.sendMediaStreamEvent({
                    correlationId: g,
                    callId: this._call.id,
                    timestampInfo: {
                        deltaTimeInMs: Date.now() - f
                    },
                    operation: by.watermark,
                    kindOfEvent: uy.failure,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        ...extractCommunicationServicesErrorForTelemetry(v),
                        watermark: {
                            ...this._getWatermarkUsageTelemetryPayload()
                        }
                    }
                }), v;
            }
        }
        dispose() {
            this._resizeObserver && this._resizeObserver.disconnect(), this._mutationObserver && this._mutationObserver.disconnect(), this._audioOnlyCallback && this._call.offWatermarkAudioOnlyFallbackTriggeredChanged("watermarkAudioOnlyFallbackTriggeredChanged", this._audioOnlyCallback), this._svgContainer && (this._container.removeChild(this._svgContainer), this._svgContainer = void 0, this._svgContainerHidden = ""), this._watermarkIsReceivingSub && this._videoStream.off("isReceivingChanged", this._watermarkIsReceivingSub), this._logger.info(`watermark overlay provider disposed for viewid: ${this._viewId}`);
        }
        _updateWatermarkScalingValues(g, f) {
            "Single" === this._getSelectedWatermarkPattern() ? this._updateWatermarkUseTextScalingSingle(g, f) : "Tiled" === this._getSelectedWatermarkPattern() && this._updateWatermarkPatternScalingTiled(g, f);
        }
        _generateWatermark(g, f) {
            const S = Date.now();
            try {
                if (!this._watermarkCapability) return void this._logger.warn("No watermark capabilities found. No-op.");
                if (this._call.watermarkAudioOnlyFallbackTriggered) return this._logger.warn("Watermark audio only fallback was triggered, disposing remote stream"), void this._videoStream.dispose();
                let v;
                if ("Video" === g && this._watermarkCapability.enabledForVideo) v = this._watermarkCapability.videoSettings;
                else {
                    if ("ScreenSharing" !== g || !this._watermarkCapability.enabledForVbss) return void this._logger.info(`No watermark operations to be done on viewId: ${this._viewId}`);
                    v = this._watermarkCapability.vbssSettings;
                }
                if (this._streamTelemetryEventSender.sendMediaStreamEvent({
                    correlationId: f,
                    callId: this._call.id,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    operation: by.watermark,
                    kindOfEvent: uy.attempt,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    additionalDetails: {
                        watermark: {
                            ...this._getWatermarkUsageTelemetryPayload()
                        }
                    }
                }), !v || !v.opacity || !v.pattern || "number" != typeof v.opacity || "string" != typeof v.pattern) throw this._logger.debug("Unexpected watermark settings"), new CallingCommunicationError({
                    defaultError: O.VIEW.WATERMARK_UNEXPECTED_VALUES
                });
                const _ = this._getClampedUsername();
                let C;
                if ("Single" === v.pattern) C = this._generateSinglePatternWatermark(_, v);
                else {
                    if ("Tiled" !== v.pattern) throw this._logger.debug("Unexpected watermark pattern setting"), new CallingCommunicationError({
                        defaultError: O.VIEW.WATERMARK_UNEXPECTED_VALUES
                    });
                    C = this._generateTiledPatternWatermark(_, v);
                }
                this._svgContainerHidden = C.outerHTML, this._container.appendChild(C), this._audioOnlyCallback = ()=>{
                    this._call.watermarkAudioOnlyFallbackTriggered && (this._logger.debug("Watermark audio only fallback triggered by one of the renderers"), this._logger.debug(`Disposing remote stream with viewId ${this._viewId}`), this._videoStream.dispose(), this._streamTelemetryEventSender.sendMediaStreamEvent({
                        correlationId: f,
                        callId: this._call.id,
                        timestampInfo: {
                            attemptTimestamp: Date.now()
                        },
                        operation: by.watermark,
                        kindOfEvent: uy.event,
                        mediaType: this._videoStream.mediaStreamType,
                        streamType: Iy.Remote,
                        additionalDetails: {
                            watermark: {
                                ...this._getWatermarkUsageTelemetryPayload()
                            }
                        }
                    }));
                }, this._call.onWatermarkAudioOnlyFallbackTriggeredChanged("watermarkAudioOnlyFallbackTriggeredChanged", this._audioOnlyCallback), this._mutationObserver = new MutationObserver((g)=>{
                    var _this__svgContainer;
                    ((_this__svgContainer = this._svgContainer) === null || _this__svgContainer === void 0 ? void 0 : _this__svgContainer.outerHTML) !== this._svgContainerHidden && (this._logger.debug("watermark mutation detected, falling back to audio only!"), this._triggerAudioOnlyFallback(), this._streamTelemetryEventSender.sendMediaStreamEvent({
                        correlationId: f,
                        callId: this._call.id,
                        timestampInfo: {
                            attemptTimestamp: Date.now()
                        },
                        operation: by.watermark,
                        kindOfEvent: uy.event,
                        mediaType: this._videoStream.mediaStreamType,
                        streamType: Iy.Remote,
                        additionalDetails: {
                            watermark: {
                                ...this._getWatermarkUsageTelemetryPayload(this._viewId)
                            }
                        }
                    }));
                }), this._mutationObserver.observe(this._container, {
                    attributes: !0,
                    subtree: !0,
                    childList: !0
                }), this._logger.info(`watermark attached for viewId: ${this._viewId}`), this._streamTelemetryEventSender.sendMediaStreamEvent({
                    correlationId: f,
                    callId: this._call.id,
                    timestampInfo: {
                        deltaTimeInMs: Date.now() - S
                    },
                    operation: by.watermark,
                    kindOfEvent: uy.success,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    additionalDetails: {
                        watermark: {
                            ...this._getWatermarkUsageTelemetryPayload()
                        }
                    }
                });
            } catch (g) {
                const v = new CallingCommunicationError({
                    defaultError: O.VIEW.WATERMARK_ATTACH_FAIL,
                    originalError: g
                });
                throw this._triggerAudioOnlyFallback(), this._streamTelemetryEventSender.sendMediaStreamEvent({
                    correlationId: f,
                    callId: this._call.id,
                    timestampInfo: {
                        deltaTimeInMs: Date.now() - S
                    },
                    operation: by.watermark,
                    kindOfEvent: uy.failure,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        ...extractCommunicationServicesErrorForTelemetry(v),
                        watermark: {
                            ...this._getWatermarkUsageTelemetryPayload(this._viewId)
                        }
                    }
                }), v;
            }
        }
        _triggerAudioOnlyFallback() {
            this._logger.debug(`audio only fallback triggered by viewId ${this._viewId}`), this._logger.debug(`Disposing remote stream with viewId ${this._viewId}`), this._videoStream.dispose(), this._call.setWatermarkAudioOnlyFallbackTriggered(!0);
        }
        _addStyleAttributesToSvgElement(g, f) {
            for (const [S, v] of Object.entries(f))g.style[`${S}`] = v;
        }
        _generateSinglePatternWatermark(g, f) {
            const S = this._getWatermarkContainer(f);
            this._svgContainer = S;
            const v = f.opacity / this.RANGE_MAX, _ = v / this.SHADOW_OPACITY_RATIO, C = generateGuid(), E = `url(#${C})`, T = document.createElementNS("http://www.w3.org/2000/svg", "defs"), I = this._getSvgFilter(C, _), b = document.createElementNS("http://www.w3.org/2000/svg", "text");
            b.id = generateGuid(), this._addStyleAttributesToSvgElement(b, this.WATERMARK_TEXT_COMMON_STYLES), b.setAttribute("filter", E), b.setAttribute("text-anchor", "middle"), b.setAttribute("dominant-baseline", "middle"), b.setAttribute("fill-opacity", `${v}`), b.style.transform = "rotate(-30deg)";
            const A = document.createTextNode(g);
            b.appendChild(A), this._svgTextDefElement = b, T.appendChild(I), T.appendChild(b);
            const R = document.createElementNS("http://www.w3.org/2000/svg", "use");
            return R.id = generateGuid(), this._svgWatermarkUseTagSinglePattern = R, R.setAttribute("href", `#${this._svgTextDefElement.id}`), R.setAttribute("x", "50%"), R.setAttribute("y", "50%"), R.setAttribute("width", "100%"), R.setAttribute("height", "100%"), R.setAttribute("font-size", `${this._svgWatermarkUseTextScale}`), R.setAttribute("stroke-width", `${this._svgWatermarkUseTextBorderSize}`), S.appendChild(T), S.appendChild(R), this._updateWatermarkUseTextScalingSingle(this._container.getBoundingClientRect().width, this._container.getBoundingClientRect().height), S;
        }
        _updateWatermarkUseTextScalingSingle(g, f) {
            if (this._svgContainer && this._svgWatermarkUseTagSinglePattern) {
                const S = this._computeTextDiagonal(g, f);
                return this._svgWatermarkUseTextScale = this.SPACE_USE * S * this.SINGLE_PATTERN_FONT_SIZE_FACTOR, this._svgWatermarkUseTextBorderSize = Math.max(1, Math.min(this.MAX_BORDER, this._svgWatermarkUseTextScale * this.BORDER_SIZE_FRAC)), this._svgWatermarkUseTagSinglePattern.setAttribute("font-size", `${this._svgWatermarkUseTextScale}`), this._svgWatermarkUseTagSinglePattern.setAttribute("stroke-width", `${this._svgWatermarkUseTextBorderSize}`), void (this._svgContainerHidden = this._svgContainer.outerHTML);
            }
            this._logger.warn("svg watermark element missing, cannot update");
        }
        _updateWatermarkPatternScalingTiled(g, f) {
            if (this._svgContainer && this._svgTextDefElement && this._svgFirstPattern && this._svgSecondPattern) {
                const S = calculateWatermarkPatternScaling(g, f, this._isApple);
                this._svgTextTiledScaledSize = S.scaledFontSize, this._svgTextTiledScaledStrokeWidth = S.scaledBorderSize, this._svgTextDefElement.setAttribute("font-size", `${this._svgTextTiledScaledSize}`), this._svgTextDefElement.setAttribute("stroke-width", `${this._svgTextTiledScaledStrokeWidth}`);
                const v = this._svgTextDefElement.getBoundingClientRect().width, _ = this._svgTextDefElement.getBoundingClientRect().height, { width: C, height: E } = this._getScaledPatternDimensions(v, _, S.scaledHorizontalGap, S.scaledVerticalGap), T = .5 * C, I = .5 * E;
                return this._svgFirstPatternWidth = C, this._svgFirstPatternHeight = E, this._svgSecondPatternWidth = C, this._svgSecondPatternHeight = E, this._svgSecondPatternOffsetX = T, this._svgSecondPatternOffsetY = I, this._svgFirstPattern.setAttribute("width", `${this._svgFirstPatternWidth}`), this._svgFirstPattern.setAttribute("height", `${this._svgFirstPatternHeight}`), this._svgSecondPattern.setAttribute("width", `${this._svgSecondPatternWidth}`), this._svgSecondPattern.setAttribute("height", `${this._svgSecondPatternHeight}`), this._svgSecondPattern.setAttribute("x", `${this._svgSecondPatternOffsetX}`), this._svgSecondPattern.setAttribute("y", `${this._svgSecondPatternOffsetY}`), void (this._svgContainerHidden = this._svgContainer.outerHTML);
            }
            this._logger.warn("svg watermark element missing, cannot update");
        }
        _generateTiledPatternWatermark(g, f) {
            const S = this._getWatermarkContainer(f);
            this._svgContainer = S;
            const v = f.opacity / this.RANGE_MAX, _ = v / this.SHADOW_OPACITY_RATIO, C = generateGuid(), E = generateGuid(), T = generateGuid(), I = `url(#${C})`, b = document.createElementNS("http://www.w3.org/2000/svg", "defs"), A = this._getSvgFilter(C, _), R = document.createElementNS("http://www.w3.org/2000/svg", "text");
            this._svgTextDefElement = R, R.id = generateGuid(), this._addStyleAttributesToSvgElement(R, this.WATERMARK_TEXT_COMMON_STYLES), R.setAttribute("filter", I), R.setAttribute("dominant-baseline", "hanging"), R.setAttribute("fill-opacity", `${v}`), R.setAttribute("font-size", `${this._svgTextTiledScaledSize}`), R.setAttribute("stroke-width", `${this._svgTextTiledScaledStrokeWidth}`);
            const P = document.createTextNode(g);
            R.appendChild(P);
            const w = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
            this._svgFirstPattern = w, w.id = E, w.setAttribute("patternUnits", "userSpaceOnUse"), w.setAttribute("patternTransform", "rotate(-30)"), w.setAttribute("width", `${this._svgFirstPatternWidth}`), w.setAttribute("height", `${this._svgFirstPatternHeight}`);
            const M = document.createElementNS("http://www.w3.org/2000/svg", "use");
            M.setAttribute("href", `#${this._svgTextDefElement.id}`), w.appendChild(M);
            const O = document.createElementNS("http://www.w3.org/2000/svg", "pattern");
            this._svgSecondPattern = O, O.id = T, O.setAttribute("patternUnits", "userSpaceOnUse"), O.setAttribute("patternTransform", "rotate(-30)"), O.setAttribute("width", `${this._svgSecondPatternWidth}`), O.setAttribute("height", `${this._svgSecondPatternHeight}`), O.setAttribute("x", `${this._svgSecondPatternOffsetX}`), O.setAttribute("y", `${this._svgSecondPatternOffsetY}`);
            const D = M.cloneNode(!0);
            O.appendChild(D), b.appendChild(A), b.appendChild(R), b.appendChild(w), b.appendChild(O);
            const N = this._getRect(0, 0, 100, 100, E), k = this._getRect(0, 0, 100, 100, T);
            return S.appendChild(b), S.appendChild(N), S.appendChild(k), this._updateWatermarkPatternScalingTiled(this._container.getBoundingClientRect().width, this._container.getBoundingClientRect().height), S;
        }
        _getWatermarkContainer(g) {
            const f = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            return this._addStyleAttributesToSvgElement(f, this.WATERMARK_CONTAINER_STYLES), f.setAttribute("xmlns", "http://www.w3.org/2000/svg"), f;
        }
        _getSvgFilter(g, f) {
            const S = document.createElementNS("http://www.w3.org/2000/svg", "filter");
            S.id = g;
            const v = document.createElementNS("http://www.w3.org/2000/svg", "feDropShadow");
            return v.setAttribute("dx", "0.5"), v.setAttribute("dy", "0.5"), v.setAttribute("stdDeviation", "1"), v.setAttribute("flood-color", "black"), v.setAttribute("flood-opacity", `${f}`), S.appendChild(v), S;
        }
        _getRect(g, f, S, v, _) {
            const C = document.createElementNS("http://www.w3.org/2000/svg", "rect");
            return C.setAttribute("x", `${g}%`), C.setAttribute("y", `${f}%`), C.setAttribute("width", `${S}%`), C.setAttribute("height", `${v}%`), C.setAttribute("fill", `url(#${_})`), C;
        }
        _getClampedUsername() {
            let g = "";
            const f = this._call.callAgent, S = getAcsEcsConfig().calling.watermark, v = S.watermarkMaxUsernameLength, _ = S.watermarkEmptyDisplayNamePlaceholder;
            var _f_displayName;
            if (f === null || f === void 0 ? void 0 : f.isCteUser()) {
                var _f_getUserProperties;
                let S = (_f_getUserProperties = f.getUserProperties()) === null || _f_getUserProperties === void 0 ? void 0 : _f_getUserProperties.sipUri;
                S && "string" == typeof S && (g = S.replace("sip:", ""));
            } else g = (_f_displayName = f === null || f === void 0 ? void 0 : f.displayName) !== null && _f_displayName !== void 0 ? _f_displayName : "", g || (g = _);
            return clampEmail(g, v);
        }
        _getSelectedWatermarkPattern() {
            var _this__watermarkCapability, _this__watermarkCapability_videoSettings, _this__watermarkCapability1, _this__watermarkCapability2, _this__watermarkCapability_vbssSettings, _this__watermarkCapability3;
            return "Video" === this._videoStream.mediaStreamType && ((_this__watermarkCapability = this._watermarkCapability) === null || _this__watermarkCapability === void 0 ? void 0 : _this__watermarkCapability.enabledForVideo) && ((_this__watermarkCapability1 = this._watermarkCapability) === null || _this__watermarkCapability1 === void 0 ? void 0 : (_this__watermarkCapability_videoSettings = _this__watermarkCapability1.videoSettings) === null || _this__watermarkCapability_videoSettings === void 0 ? void 0 : _this__watermarkCapability_videoSettings.pattern) ? this._watermarkCapability.videoSettings.pattern : "ScreenSharing" === this._videoStream.mediaStreamType && ((_this__watermarkCapability2 = this._watermarkCapability) === null || _this__watermarkCapability2 === void 0 ? void 0 : _this__watermarkCapability2.enabledForVbss) && ((_this__watermarkCapability3 = this._watermarkCapability) === null || _this__watermarkCapability3 === void 0 ? void 0 : (_this__watermarkCapability_vbssSettings = _this__watermarkCapability3.vbssSettings) === null || _this__watermarkCapability_vbssSettings === void 0 ? void 0 : _this__watermarkCapability_vbssSettings.pattern) ? this._watermarkCapability.vbssSettings.pattern : "";
        }
        _getWatermarkUsageTelemetryPayload(g = "") {
            var _this__watermarkCapability, _this__watermarkCapability1, _this__watermarkCapability2, _this__watermarkCapability3, _this__watermarkCapability4, _this__watermarkCapability5;
            return {
                endpointSupportsWatermark: this._call.callAgent.isWatermarkSupported(),
                audioOnlyFallbackTriggered: this._call.watermarkAudioOnlyFallbackTriggered,
                audioOnlyFallbackTriggeredByViewId: g,
                watermarkUsage: {
                    video: {
                        enabled: (_this__watermarkCapability = this._watermarkCapability) === null || _this__watermarkCapability === void 0 ? void 0 : _this__watermarkCapability.enabledForVideo,
                        opacity: (_this__watermarkCapability1 = this._watermarkCapability) === null || _this__watermarkCapability1 === void 0 ? void 0 : _this__watermarkCapability1.videoSettings.opacity,
                        pattern: (_this__watermarkCapability2 = this._watermarkCapability) === null || _this__watermarkCapability2 === void 0 ? void 0 : _this__watermarkCapability2.videoSettings.pattern
                    },
                    screenshare: {
                        enabled: (_this__watermarkCapability3 = this._watermarkCapability) === null || _this__watermarkCapability3 === void 0 ? void 0 : _this__watermarkCapability3.enabledForVbss,
                        opacity: (_this__watermarkCapability4 = this._watermarkCapability) === null || _this__watermarkCapability4 === void 0 ? void 0 : _this__watermarkCapability4.vbssSettings.opacity,
                        pattern: (_this__watermarkCapability5 = this._watermarkCapability) === null || _this__watermarkCapability5 === void 0 ? void 0 : _this__watermarkCapability5.vbssSettings.pattern
                    }
                },
                viewId: this._viewId
            };
        }
        constructor(g, f, S, v, _){
            this._container = g, this._videoStream = f, this._viewId = S, this._streamTelemetryEventSender = _, this._watermarkCapability = null, this.WATERMARK_TEXT_COMMON_STYLES = {
                fontFamily: Kb.fontFamilyBase,
                fontWeight: "bold",
                stroke: "black",
                strokeOpacity: "0.1",
                fill: Kb.colorNeutralStrokeOnBrand2
            }, this.WATERMARK_CONTAINER_STYLES = {
                position: "absolute",
                pointerEvents: "none",
                width: "100%",
                height: "100%",
                top: "0",
                left: "0"
            }, this.TEXT_ROTATION = 30, this.SHADOW_OPACITY_RATIO = 3, this.RANGE_MAX = 100, this.BORDER_SIZE = 18, this.BORDER_SIZE_FRAC = 1 / this.BORDER_SIZE, this.SPACE_USE = .9, this.MAX_BORDER = 2, this.SINGLE_PATTERN_FONT_SIZE_FACTOR = .07, this._svgContainerHidden = "", this._svgWatermarkUseTextScale = 0, this._svgWatermarkUseTextBorderSize = 0, this._svgTextTiledScaledSize = 0, this._svgTextTiledScaledStrokeWidth = 0, this._svgFirstPatternWidth = 0, this._svgFirstPatternHeight = 0, this._svgSecondPatternWidth = 0, this._svgSecondPatternHeight = 0, this._svgSecondPatternOffsetX = 0, this._svgSecondPatternOffsetY = 0, this._computeTextDiagonal = createTextDiagonalCalculation(this.TEXT_ROTATION), this._isApple = !1, this._getScaledPatternDimensions = (g, f, S, v)=>({
                    width: g * (S + 1.1),
                    height: f * (v + 1.1)
                }), this._call = this._videoStream.call, this._logger = v.createChild("WatermarkOverlayProvider" + Jb++);
            const C = this._call.getMeetingCapabilitiesInternal();
            if (!C) {
                this._logger.warn("No watermark capabilities found. Likely not received from service.");
                const g = new CallingCommunicationError({
                    defaultError: O.VIEW.NO_WATERMARK_CAPABILITY_RECEIVED
                }), f = generateGuid();
                return void this._streamTelemetryEventSender.sendMediaStreamEvent({
                    correlationId: f,
                    callId: this._call.id,
                    timestampInfo: {
                        attemptTimestamp: Date.now()
                    },
                    operation: by.watermark,
                    kindOfEvent: uy.failure,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        ...extractCommunicationServicesErrorForTelemetry(g),
                        watermark: {
                            ...this._getWatermarkUsageTelemetryPayload()
                        }
                    }
                });
            }
            this._watermarkCapability = C.waterMarkCapability;
            const E = this._call.deviceManager.getOSNameInternal();
            this._isApple = "ios" === E || "mac" === E, this._resizeObserver = new ResizeObserver((g)=>{
                var _f_contentRect;
                for (const f of g)if (((_f_contentRect = f.contentRect) === null || _f_contentRect === void 0 ? void 0 : _f_contentRect.width) > 1) {
                    const g = f.contentRect.width, S = f.contentRect.height;
                    this._updateWatermarkScalingValues(g, S);
                }
            }), this._resizeObserver.observe(this._container);
        }
    }
    var __decorate$e = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$e = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    let Yb = 1;
    class RemoteStreamRenderer {
        get isRendering() {
            return this._isRendering;
        }
        get scalingMode() {
            return this._scalingMode;
        }
        get isMirrored() {
            return this._isMirrored;
        }
        get target() {
            return this._target;
        }
        get viewId() {
            return this._viewId;
        }
        get size() {
            return {
                height: this._size.height,
                width: this._size.width
            };
        }
        async start() {
            const g = generateGuid(), f = +new Date, S = this.logger.createFnLogger(LS.Start), v = {
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: g,
                operation: by.render,
                kindOfEvent: uy.attempt,
                mediaType: this._videoStream.mediaStreamType,
                streamType: Iy.Remote
            };
            if (this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(v), this._disposed) throw this.logger.warn("already disposed"), new CallingCommunicationError({
                defaultError: O.VIEW.START_ALREADY_DISPOSED
            });
            try {
                S.info(`scalingMode=${toTsScalingMode(this._scalingMode)}`), this._videoStream.registerRenderer(this), this._renderingDeferred = defer$1(), this._renderingDeferred.promise.catch(noop), "RemoteVideoStream" === this._videoStream.kind && (this._availableCallback = ()=>{
                    var _this__renderingDeferred, _this__renderingDeferred1;
                    this._videoStream.isAvailable || (S.warn("stream isAvailable changed to false, attempting to reject operation"), ((_this__renderingDeferred = this._renderingDeferred) === null || _this__renderingDeferred === void 0 ? void 0 : _this__renderingDeferred.isPending()) && !this._disposed && ((_this__renderingDeferred1 = this._renderingDeferred) === null || _this__renderingDeferred1 === void 0 ? void 0 : _this__renderingDeferred1.reject(new CallingCommunicationError({
                        defaultError: O.VIEW.STREAM_BECAME_UNAVAILABLE
                    }))));
                }, this._videoStream.on("isAvailableChanged", this._availableCallback)), this._createViewSteps.startSubscriptionTimestamp = Date.now(), this._createViewSteps.startSubscriptionTimeDeltaSinceAttemptMs = void 0 === this._createViewSteps.attemptTimestamp ? 0 : this._createViewSteps.startSubscriptionTimestamp - this._createViewSteps.attemptTimestamp, this._videoStream.tsStream.start(this._target, {
                    scalingMode: toTsScalingMode(this._scalingMode),
                    transparent: !1
                }).then((g)=>{
                    if (this._createViewSteps.rendererIsAvailableTimestamp = Date.now(), this._createViewSteps.rendererIsAvailableTimeDeltaSinceAttemptMs = void 0 === this._createViewSteps.attemptTimestamp ? 0 : this._createViewSteps.rendererIsAvailableTimestamp - this._createViewSteps.attemptTimestamp, this._isMirrored && (this._target.style.transform = "rotateY(180deg)", this._target.style.webkitTransform = "rotateY(180deg)"), this._tsRenderer = g, this.logger.info("subscribed to video, waiting for the first frame"), this._disposed) throw this.logger.warn("already disposed, dispose underlying renderer"), this._attemptToDisposeTsRenderer(), new CallingCommunicationError({
                        defaultError: O.VIEW.START_ALREADY_DISPOSED
                    });
                    if (this.logger.info(`current state of rendering is ${this._tsRenderer.isRendering}`), this.sendRendererTelemetry(), -1 !== getAcsEcsConfig().rendering.remoteVideo.createViewTimeout && setTimeout(()=>{
                        var _this__renderingDeferred;
                        if ((_this__renderingDeferred = this._renderingDeferred) === null || _this__renderingDeferred === void 0 ? void 0 : _this__renderingDeferred.isPending()) try {
                            this._renderingDeferred.reject(new CallingCommunicationError({
                                defaultError: O.VIEW.TIMEOUT
                            }));
                        } catch (g) {
                            noop();
                        }
                    }, getAcsEcsConfig().rendering.remoteVideo.createViewTimeout), getAcsEcsConfig().rendering.remoteVideo.speedupCreateViewWithPlayEvent) {
                        const g = this._target && this._target.children.length > 0 && this._target.children[0];
                        g ? g.addEventListener("play", this.videoPlayEventListener.bind(this)) : this.logger.warn("video element was not found while trying to listen to play event");
                    }
                    this._tsRendererChanged = this._tsRenderer.changed(()=>this._handleTsRendererChanged(S)), this._tsRenderer.isRendering && (this._isRendering = !0, this._videoStream.updateIsReceiving(), this.setAndUpdateSize(), this.resolveRenderingPendingPromise());
                }).catch((g)=>{
                    var _this__renderingDeferred;
                    if (this.logger.info("Failed to subscribe to video"), (_this__renderingDeferred = this._renderingDeferred) === null || _this__renderingDeferred === void 0 ? void 0 : _this__renderingDeferred.isPending()) {
                        const f = new CallingCommunicationError({
                            defaultError: O.VIEW.SUBSCRIBE,
                            originalError: g
                        });
                        this._renderingDeferred.reject(f);
                    }
                }), await this._renderingDeferred.promise, this._videoStream.flushIsReceiving(), this._unsubscribeAvailabilityCallback(), getAcsEcsConfig().rendering.remoteVideo.forceCheckIfVideoWasAttachedToDom && this._checkIfVideoWasAttachedToDom();
                const v = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    correlationId: g,
                    operation: by.render,
                    kindOfEvent: uy.success,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Remote,
                    createViewResolvedOnPlayEvent: this._createViewResolvedOnPlayEvent
                };
                return this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(v), this;
            } catch (S) {
                this.logger.warn(`Failed to render, message=${S}`);
                try {
                    this.dispose();
                } catch (g) {
                    this.logger.warn(`dispose failed with ${g === null || g === void 0 ? void 0 : g.message} error`);
                }
                const v = new CallingCommunicationError({
                    defaultError: O.VIEW.START,
                    originalError: S
                });
                if (v.message !== O.VIEW.LARGE_MEETING_VIEW_DISPOSED.message && v.message !== O.VIEW.REMOTE_VIDEO_STREAM_DISPOSED.message) {
                    const S = {
                        timestampInfo: {
                            deltaTimeInMs: +new Date - f
                        },
                        correlationId: g,
                        operation: by.render,
                        additionalDetails: {
                            failureReason: v.message,
                            code: F,
                            ...extractCommunicationServicesErrorForTelemetry(v)
                        },
                        kindOfEvent: uy.failure,
                        mediaType: this._videoStream.mediaStreamType,
                        streamType: Iy.Remote,
                        createViewResolvedOnPlayEvent: this._createViewResolvedOnPlayEvent
                    };
                    this._remoteStreamTelemetryEventSender.sendMediaStreamEvent(S);
                }
                throw v;
            }
        }
        videoPlayEventListener() {
            this.logger.log("video element play event was fired"), this.resolveRenderingPendingPromise(!0);
        }
        setAndUpdateSize() {
            try {
                var _this__tsRenderer, _this__tsRenderer1;
                this._size.width = ((_this__tsRenderer = this._tsRenderer) === null || _this__tsRenderer === void 0 ? void 0 : _this__tsRenderer.streamSize.width) || Qm.WIDTH, this._size.height = ((_this__tsRenderer1 = this._tsRenderer) === null || _this__tsRenderer1 === void 0 ? void 0 : _this__tsRenderer1.streamSize.height) || Qm.HEIGHT, this._videoStream.updateSize();
            } catch (g) {
                this.logger.error(`Failed to update video stream size with error ${g}`);
            }
        }
        async setScalingMode(g) {
            if (!this._tsRenderer) throw new CallingCommunicationError({
                defaultError: O.VIEW.SCALING_MODE
            });
            await this._tsRenderer.setScalingMode(toTsScalingMode(g)), this._scalingMode = g;
        }
        dispose(g = Py.Public_App) {
            var _this__renderingDeferred;
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.VIEW.RENDERER_DISPOSE_ALREADY_DISPOSED
            });
            if (this._disposed = !0, this._disposeTsRendererChangedObservable(), this._unsubscribeAvailabilityCallback(), this._attemptToDisposeTsRenderer(), (_this__renderingDeferred = this._renderingDeferred) === null || _this__renderingDeferred === void 0 ? void 0 : _this__renderingDeferred.isPending()) {
                let f;
                switch(g){
                    case Py.Internal_LargeMeetingVideoRendering:
                        f = O.VIEW.LARGE_MEETING_VIEW_DISPOSED;
                        break;
                    case Py.Internal_RemoteVideoStreamDisposed:
                        f = O.VIEW.REMOTE_VIDEO_STREAM_DISPOSED;
                        break;
                    default:
                        f = O.VIEW.APP_VIEW_DISPOSED;
                }
                this._renderingDeferred.reject(new CallingCommunicationError({
                    defaultError: f
                }));
            }
            if (this._target) {
                const g = this._target.children && this._target.children.length > 0 && this._target.children[0];
                g && g.removeEventListener("play", this.videoPlayEventListener), this._target.remove();
            }
            try {
                g !== Py.Public_App && this._onDisposedCallback(g);
            } catch (g) {
                this.logger.debug(`dispose callback failed with ${g === null || g === void 0 ? void 0 : g.message} error`);
            }
            this._watermarkOverlayProvider.dispose(), this._videoStream.unregisterRenderer(this), this._size.height = 0, this._size.width = 0, this._videoStream.updateSize(), this._isRendering = !1, this._videoStream.updateIsReceiving(), this._eventEmitter.removeAllListeners(), this._renderingDeferred = void 0;
        }
        _checkIfVideoWasAttachedToDom() {
            if (getAcsEcsConfig().rendering.remoteVideo.checkIfVideoAttachedToDom_poll) {
                let g = getAcsEcsConfig().rendering.remoteVideo.checkIfVideoAttachedToDom_intervalMaxTries;
                const check = ()=>{
                    this._target.isConnected || g <= 0 ? this.sendRendererTelemetry() : (g--, g >= 0 && setTimeout(()=>check, getAcsEcsConfig().rendering.remoteVideo.checkIfVideoAttachedToDom_intervalTime));
                };
                check();
            } else setTimeout(()=>{
                this._target.isConnected && this.sendRendererTelemetry();
            }, getAcsEcsConfig().rendering.remoteVideo.checkIfVideoAttachedToDom_timeout);
        }
        constructor(g, f, S, v, _, C, E){
            this._target = g, this._viewId = f, this._videoStream = S, this._onDisposedCallback = _, this._createViewSteps = C, this._eventEmitter = new Ny.EventEmitter, this._isRendering = !1, this._scalingMode = "Stretch", this._isMirrored = !1, this._createViewResolvedOnPlayEvent = !1, this._hasRenderingEvent = !1, this._hasPlayEvent = !1, this._size = {
                height: 0,
                width: 0
            }, this._disposed = !1, this.resolveRenderingPendingPromise = (g = !1)=>{
                var _this__renderingDeferred, _this__tsRenderer;
                ((_this__renderingDeferred = this._renderingDeferred) === null || _this__renderingDeferred === void 0 ? void 0 : _this__renderingDeferred.isPending()) && (this._renderingDeferred.resolve(), g && (this.logger.log(`video element play event was fired and promise was resolved and isRendering is: ${(_this__tsRenderer = this._tsRenderer) === null || _this__tsRenderer === void 0 ? void 0 : _this__tsRenderer.isRendering}`), this._createViewResolvedOnPlayEvent = !0)), g ? this._hasPlayEvent || (this._hasPlayEvent = !0, this._createViewSteps.isPlayedTimestamp = Date.now(), this._createViewSteps.isPlayedTimeDeltaSinceAttemptMs = void 0 === this._createViewSteps.attemptTimestamp ? 0 : this._createViewSteps.isPlayedTimestamp - this._createViewSteps.attemptTimestamp) : !this._hasRenderingEvent && this._isRendering && (this._hasRenderingEvent = !0, this._createViewSteps.isRenderedTimestamp = Date.now(), this._createViewSteps.isRenderedTimeDeltaSinceAttemptMs = void 0 === this._createViewSteps.attemptTimestamp ? 0 : this._createViewSteps.isRenderedTimestamp - this._createViewSteps.attemptTimestamp);
            }, this._handleTsRendererChanged = (g)=>{
                var _this__tsRenderer;
                if (this.logger.debug(`rendering state is ${this._isRendering}, changed to ${(_this__tsRenderer = this._tsRenderer) === null || _this__tsRenderer === void 0 ? void 0 : _this__tsRenderer.isRendering}`), this._tsRenderer) {
                    if (this._tsRenderer.isRendering !== this._isRendering && (this._isRendering = this._tsRenderer.isRendering, this._videoStream.updateIsReceiving(), this._isRendering && this.resolveRenderingPendingPromise(), g.log(`isRendering change to ${this._isRendering}`)), this._tsRenderer.isRendering) {
                        var _this__tsRenderer_streamSize, _this__tsRenderer_streamSize1;
                        const g = ((_this__tsRenderer_streamSize = this._tsRenderer.streamSize) === null || _this__tsRenderer_streamSize === void 0 ? void 0 : _this__tsRenderer_streamSize.height) || Qm.HEIGHT, f = ((_this__tsRenderer_streamSize1 = this._tsRenderer.streamSize) === null || _this__tsRenderer_streamSize1 === void 0 ? void 0 : _this__tsRenderer_streamSize1.width) || Qm.WIDTH;
                        g === this._size.height && f === this._size.width || this.setAndUpdateSize(), this.resolveRenderingPendingPromise();
                    } else this._size.height = 0, this._size.width = 0, this._videoStream.updateSize();
                }
                this.sendRendererTelemetry();
            }, this.sendRendererTelemetry = ()=>{
                if (this._tsRenderer) try {
                    var _this__target, _this__target1;
                    const g = {
                        isRendering: this._tsRenderer.isRendering,
                        streamWidth: this._tsRenderer.streamSize.width,
                        streamHeight: this._tsRenderer.streamSize.height,
                        isVideoAttached: this._target.isConnected,
                        rendererWidth: (_this__target = this._target) === null || _this__target === void 0 ? void 0 : _this__target.offsetWidth,
                        rendererHeight: (_this__target1 = this._target) === null || _this__target1 === void 0 ? void 0 : _this__target1.offsetHeight
                    };
                    if (this.previousStats) {
                        if (shallowEqual(this.previousStats, g)) return;
                    } else this.previousStats = g;
                    this.previousStats = g;
                    const f = this._videoStream.getStreamMetadata(), { callId: S, localParticipantId: v, isDisposed: _, viewIdsRegistered: C, height: E, width: T, ...I } = f, b = {
                        ...g,
                        ...I,
                        viewId: this._viewId,
                        disposed: this._disposed
                    };
                    this._videoStream.call.stats.recordEvent({
                        name: cy.remote_view,
                        callId: S,
                        localParticipantId: v,
                        data: b
                    });
                } catch (g) {}
            }, this._unsubscribeAvailabilityCallback = ()=>{
                var _this__videoStream;
                this._availableCallback && ("RemoteVideoStream" === this._videoStream.kind && ((_this__videoStream = this._videoStream) === null || _this__videoStream === void 0 ? void 0 : _this__videoStream.off("isAvailableChanged", this._availableCallback)), this._availableCallback = void 0);
            }, this._disposeTsRendererChangedObservable = ()=>{
                this._tsRendererChanged && (this._tsRendererChanged.dispose(), this._tsRendererChanged = void 0);
            }, this._attemptToDisposeTsRenderer = ()=>{
                if (this._tsRenderer) {
                    this.logger.debug("disposing underlying remote renderer");
                    try {
                        var _this__tsRenderer;
                        (_this__tsRenderer = this._tsRenderer) === null || _this__tsRenderer === void 0 ? void 0 : _this__tsRenderer.dispose(), this._tsRenderer = void 0;
                    } catch (g) {
                        throw this.logger.warn(`underlying remote renderer dispose failed with ${g === null || g === void 0 ? void 0 : g.message} error`), new CallingCommunicationError({
                            defaultError: O.VIEW.REMOTE_RENDERER_DISPOSE_FAIL
                        });
                    }
                }
            }, this.logger = v.createChild("RemoteStreamRenderer" + Yb++), this.logger.log("created"), void 0 !== (E === null || E === void 0 ? void 0 : E.scalingMode) && (this._scalingMode = E.scalingMode), void 0 !== (E === null || E === void 0 ? void 0 : E.isMirrored) && (this._isMirrored = E.isMirrored), this._remoteStreamTelemetryEventSender = new StreamTelemetryEventSender(this._videoStream.telemetryLogManager), this._watermarkOverlayProvider = new WatermarkOverlayProvider(this._target, this._videoStream, this._viewId, this.logger, this._remoteStreamTelemetryEventSender), this._watermarkOverlayProvider.attach();
        }
    }
    __decorate$e([
        loggerProperty,
        __metadata$e("design:type", Object)
    ], RemoteStreamRenderer.prototype, "logger", void 0), __decorate$e([
        asyncOperation(LS.Start),
        __metadata$e("design:type", Function),
        __metadata$e("design:paramtypes", []),
        __metadata$e("design:returntype", Promise)
    ], RemoteStreamRenderer.prototype, "start", null), __decorate$e([
        syncOperation(LS.Dispose),
        __metadata$e("design:type", Function),
        __metadata$e("design:paramtypes", [
            String
        ]),
        __metadata$e("design:returntype", void 0)
    ], RemoteStreamRenderer.prototype, "dispose", null);
    var __decorate$f = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$f = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class LocalStreamRenderer {
        get isRendering() {
            return this._isRendering;
        }
        get scalingMode() {
            return this._scalingMode;
        }
        get isMirrored() {
            return this._isMirrored;
        }
        get target() {
            return this._target;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        async start() {
            const g = generateGuid(), f = this.logger.createFnLogger(LS.Start), S = +new Date, v = {
                timestampInfo: {
                    attemptTimestamp: S
                },
                correlationId: g,
                operation: by.render,
                kindOfEvent: uy.attempt,
                mediaType: this._videoStream.mediaStreamType,
                streamType: Iy.Local
            };
            this._localStreamTelemetryEventSender.sendMediaStreamEvent(v);
            try {
                if (f.info("attempting to select new device as a source"), this._videoStream.source instanceof VideoDeviceInfoImpl && "Video" === this._videoStream.mediaStreamType) {
                    const g = this._videoStream.source.deviceManager.getTsDeviceManager();
                    g.selectDevices({
                        camera: this._videoStream.source.id
                    }), f.info("device selected"), f.info("creating preview"), this._tsRenderer = await g.createPreview(this._target, {
                        kind: "camera"
                    }, {
                        scalingMode: toTsScalingMode(this._scalingMode),
                        transparent: !1,
                        ignoreMirroring: !1,
                        disposeRendererWhenStreamisNotAvailable: ()=>!0
                    });
                } else {
                    if ("RawMedia" !== this._videoStream.mediaStreamType && "ScreenSharing" !== this._videoStream.mediaStreamType) throw new CallingCommunicationError({
                        defaultError: O.VIEW.UNKNOWN_STREAM_TYPE
                    });
                    this._rawMediaOrSS_previewVideo = document.createElement("video"), this._rawMediaOrSS_previewVideo.style.width = "100%", this._rawMediaOrSS_previewVideo.style.height = "100%", this._rawMediaOrSS_previewVideo.style.objectFit = "contain", this._rawMediaOrSS_previewVideo.setAttribute("playsinline", "true"), this._rawMediaOrSS_previewVideo.disablePictureInPicture = !0, this._rawMediaOrSS_previewVideo.autoplay = !0, this._rawMediaOrSS_previewVideo.srcObject = await this._videoStream.getMediaStream(), this._rawMediaOrSS_previewVideo.play(), this._target.appendChild(this._rawMediaOrSS_previewVideo);
                }
                this._isMirrored && (this._target.style.transform = "rotateY(180deg)", this._target.style.webkitTransform = "rotateY(180deg)"), this._videoStream.registerRenderer(this);
                const v = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    correlationId: g,
                    operation: by.render,
                    kindOfEvent: uy.success,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Local
                };
                return this._localStreamTelemetryEventSender.sendMediaStreamEvent(v), this;
            } catch (v) {
                this.dispose();
                const _ = handleVideoOperationFailure(f, v), C = {
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    correlationId: g,
                    operation: by.render,
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        subCode: _.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    },
                    kindOfEvent: uy.failure,
                    mediaType: this._videoStream.mediaStreamType,
                    streamType: Iy.Local
                };
                throw this._localStreamTelemetryEventSender.sendMediaStreamEvent(C), _;
            }
        }
        setScalingMode(g) {
            if (this._tsRenderer) this._tsRenderer.setScalingMode(toTsScalingMode(g)), this._scalingMode = g;
            else {
                if (!this._rawMediaOrSS_previewVideo) throw new CallingCommunicationError({
                    defaultError: O.VIEW.SCALING_MODE
                });
                switch(g){
                    case "Stretch":
                        this._rawMediaOrSS_previewVideo.style.objectFit = "fill";
                        break;
                    case "Crop":
                        this._rawMediaOrSS_previewVideo.style.objectFit = "cover";
                        break;
                    default:
                        this._rawMediaOrSS_previewVideo.style.objectFit = "contain";
                }
            }
        }
        setSourceObject(g) {
            this.disposeScreenSharingMediaStream();
            const f = this._target.querySelector("video");
            f && (f.srcObject = g, f.play());
        }
        dispose() {
            if (!this._disposed) {
                if (this._tsRenderer) try {
                    this.logger.log("disposing underlying local renderer"), this._tsRenderer.dispose(), this._tsRenderer = void 0;
                } catch (g) {
                    throw this.logger.warn(`underlying local renderer dispose failed with ${g === null || g === void 0 ? void 0 : g.message} error`), new CallingCommunicationError({
                        defaultError: O.VIEW.LOCAL_RENDERER_DISPOSE_FAIL
                    });
                }
                this.disposeScreenSharingMediaStream(), this._target.remove(), this._onDisposed && this._onDisposed(this), this._eventEmitter.removeAllListeners(), this._disposed = !0;
            }
        }
        disposeScreenSharingMediaStream() {
            var _this__videoStream_getCall;
            if ((_this__videoStream_getCall = this._videoStream.getCall()) === null || _this__videoStream_getCall === void 0 ? void 0 : _this__videoStream_getCall.localScreenSharingStream) {
                const g = this._target.querySelector("video"), f = g === null || g === void 0 ? void 0 : g.srcObject;
                f && (f.getVideoTracks().forEach((g)=>{
                    g.stop();
                }), g.srcObject = null, this.logger.info("disposed of ScreenSharing MediaStream"));
            }
        }
        constructor(g, f, S, v, _){
            this._target = g, this._videoStream = f, this._onDisposed = v, this._eventEmitter = new Ny.EventEmitter, this._isRendering = !1, this._scalingMode = "Stretch", this._isMirrored = !0, this._disposed = !1, this.logger = S.createChild("LocalStreamRenderer"), this.logger.log("created"), void 0 !== (_ === null || _ === void 0 ? void 0 : _.scalingMode) && (this._scalingMode = _.scalingMode), void 0 !== (_ === null || _ === void 0 ? void 0 : _.isMirrored) ? this._isMirrored = _.isMirrored : "ScreenSharing" === this._videoStream.mediaStreamType && (this._isMirrored = !1), this._localStreamTelemetryEventSender = new StreamTelemetryEventSender(this._videoStream.telemetryLogManager);
        }
    }
    __decorate$f([
        loggerProperty,
        __metadata$f("design:type", Object)
    ], LocalStreamRenderer.prototype, "logger", void 0), __decorate$f([
        asyncOperation(FS.Start),
        __metadata$f("design:type", Function),
        __metadata$f("design:paramtypes", []),
        __metadata$f("design:returntype", Promise)
    ], LocalStreamRenderer.prototype, "start", null), __decorate$f([
        syncOperation(FS.SetScalingMode),
        __metadata$f("design:type", Function),
        __metadata$f("design:paramtypes", [
            String
        ]),
        __metadata$f("design:returntype", void 0)
    ], LocalStreamRenderer.prototype, "setScalingMode", null), __decorate$f([
        syncOperation(FS.SetSourceObject),
        __metadata$f("design:type", Function),
        __metadata$f("design:paramtypes", [
            MediaStream
        ]),
        __metadata$f("design:returntype", void 0)
    ], LocalStreamRenderer.prototype, "setSourceObject", null), __decorate$f([
        syncOperation(FS.Dispose),
        __metadata$f("design:type", Function),
        __metadata$f("design:paramtypes", []),
        __metadata$f("design:returntype", void 0)
    ], LocalStreamRenderer.prototype, "dispose", null);
    var __decorate$g = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$g = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    let Qb = 1;
    class VideoStreamRendererViewImpl {
        get scalingMode() {
            return this._streamRenderer.scalingMode;
        }
        get isMirrored() {
            return this._streamRenderer.isMirrored;
        }
        get disposed() {
            return this._disposed;
        }
        async render() {
            const g = this.logger.createFnLogger(this._videoStream instanceof RemoteVideoStreamCommonImpl ? wS.RenderRemoteStream : wS.RenderLocalStream);
            if (this._disposed) throw g.log("failed, stream disposed!"), new CallingCommunicationError({
                defaultError: O.VIEW.RENDER_FAIL_STREAM_DISPOSED
            });
            try {
                await this._streamRenderer.start();
            } catch (f) {
                g.error("failed");
                try {
                    this.dispose();
                } catch (g) {
                    this.logger.warn(`Failed to dispose, message=${g.message}`);
                }
                throw f;
            }
        }
        async updateScalingMode(g) {
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.VIEW.SCALING_MODE_DISPOSED
            });
            if ("Crop" !== g && "Fit" !== g && "Stretch" !== g) throw new CallingCommunicationError({
                defaultError: O.VIEW.SCALING_MODE_WRONG_VAL
            });
            try {
                await this._streamRenderer.setScalingMode(g);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.VIEW.SCALING_MODE,
                    originalError: g
                });
            }
        }
        dispose(g = Py.Public_App) {
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.VIEW.VIEW_ALREADY_DISPOSED
            });
            this._disposed = !0;
            const f = +new Date, S = generateGuid();
            try {
                var _this_target;
                g === Py.Public_App && this.sendDisposeViewEvent({
                    eventName: dy.acs_calling_dispose_view_attempt,
                    correlationId: S,
                    timestampInfo: {
                        attemptTimestamp: f
                    }
                }), this._videoStream instanceof RemoteVideoStreamImpl && this._deleteActiveRemoteVideoStreamView(this._videoStream, this._viewId), this.logger.debug("attempt to dispose stream renderer"), this._streamRenderer.dispose(g), (_this_target = this.target) === null || _this_target === void 0 ? void 0 : _this_target.remove();
                const v = +new Date;
                g === Py.Public_App && this.sendDisposeViewEvent({
                    eventName: dy.acs_calling_dispose_view_success,
                    correlationId: S,
                    timestampInfo: {
                        deltaTimeInMs: v - f
                    }
                });
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.VIEW.DISPOSE_FAIL,
                    originalError: v
                });
                if (g === Py.Public_App) {
                    const g = +new Date;
                    this.sendDisposeViewEvent({
                        eventName: dy.acs_calling_dispose_view_failure,
                        correlationId: S,
                        timestampInfo: {
                            deltaTimeInMS: g - f
                        }
                    }, _);
                }
                throw _;
            }
        }
        sendDisposeViewEvent(g, f) {
            try {
                let S, v;
                f && (S = "string" == typeof (f === null || f === void 0 ? void 0 : f.message) ? f === null || f === void 0 ? void 0 : f.message : "", v = {
                    ...extractCommunicationServicesErrorForTelemetry(f)
                }), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        ...this._videoStream.getStreamMetadata(),
                        viewId: this._viewId,
                        correlationId: g.correlationId,
                        timestampInfo: g.timestampInfo,
                        failureReason: S,
                        additionalDetails: v
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send telemtery");
            }
        }
        constructor(g, f, S, v, _){
            if (this._videoStream = g, this._viewId = S, this._options = _, this._disposed = !1, this._deleteActiveRemoteVideoStreamView = (g, f)=>{
                var _g_call_activeRemoteVideoStreamViews;
                if ((_g_call_activeRemoteVideoStreamViews = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews.has(g.id)) {
                    var _g_call_activeRemoteVideoStreamViews1, _g_call_activeRemoteVideoStreamViews2;
                    let S = (_g_call_activeRemoteVideoStreamViews1 = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews1 === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews1.get(g.id);
                    S === null || S === void 0 ? void 0 : S.delete(f), 0 == (S === null || S === void 0 ? void 0 : S.size) && ((_g_call_activeRemoteVideoStreamViews2 = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews2 === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews2.delete(g.id));
                }
            }, this.logger = f.createChild("VideoStreamRendererView" + Qb++), this.target = document.createElement("div"), this.target.style.width = "100%", this.target.style.height = "100%", this._videoStream instanceof RemoteVideoStreamCommonImpl) this._streamRenderer = new RemoteStreamRenderer(this.target, this._viewId, this._videoStream, this.logger, (g)=>{
                this._disposed ? noop() : this.dispose(g);
            }, v, this._options);
            else {
                if (!(this._videoStream instanceof LocalVideoStream)) throw new CallingCommunicationError({
                    defaultError: O.VIEW.VIEW_WRONG_STREAM_TYPE
                });
                this._streamRenderer = new LocalStreamRenderer(this.target, this._videoStream, this.logger, ()=>this.dispose, this._options);
            }
            this._telemetryLogManager = this._videoStream.telemetryLogManager, this.logger.info("created");
        }
    }
    function collectLiveStreamStatsForCreateView(g, f, S, v) {
        const _ = [
            "audioBitrate",
            "videoBitrate",
            "downloadBitrate",
            "bufferLengthInMs",
            "videoHeight",
            "videoWidth",
            "currentPlayPosition"
        ], C = f[S.toString()];
        void 0 !== C && _.forEach((f)=>{
            const S = f, _ = f;
            if (void 0 !== C[S]) {
                const f = C[S];
                if (void 0 === g[_]) g[_] = [
                    f
                ];
                else {
                    var _g__, _g__1, _g__2;
                    const S = (_g__ = g[_]) === null || _g__ === void 0 ? void 0 : _g__.length;
                    S >= v && ((_g__1 = g[_]) === null || _g__1 === void 0 ? void 0 : _g__1.shift()), (_g__2 = g[_]) === null || _g__2 === void 0 ? void 0 : _g__2.push(f);
                }
            }
        });
    }
    __decorate$g([
        loggerProperty,
        __metadata$g("design:type", Object)
    ], VideoStreamRendererViewImpl.prototype, "logger", void 0), __decorate$g([
        asyncOperation(wS.Render),
        __metadata$g("design:type", Function),
        __metadata$g("design:paramtypes", []),
        __metadata$g("design:returntype", Promise)
    ], VideoStreamRendererViewImpl.prototype, "render", null), __decorate$g([
        asyncOperation(wS.UpdateScalingMode),
        __metadata$g("design:type", Function),
        __metadata$g("design:paramtypes", [
            String
        ]),
        __metadata$g("design:returntype", Promise)
    ], VideoStreamRendererViewImpl.prototype, "updateScalingMode", null), __decorate$g([
        syncOperation(wS.Dispose),
        __metadata$g("design:type", Function),
        __metadata$g("design:paramtypes", [
            String
        ]),
        __metadata$g("design:returntype", void 0)
    ], VideoStreamRendererViewImpl.prototype, "dispose", null);
    class CreateViewTelemetryHelper {
        get createViewStats() {
            return this._createViewStats;
        }
        get initialCreateViewStats() {
            return this._initialCreateViewStats;
        }
        getCreateViewFailureStats() {
            try {
                var _this_createViewStats_video, _this_initialCreateViewStats_video, _this_createViewStats_video1, _this_createViewStats_video2, _this_initialCreateViewStats_video1, _this_createViewStats_video3, _this_initialCreateViewStats_video2, _this_initialCreateViewStats_video3, _this_createViewStats_video4, _this_initialCreateViewStats_video4, _this_initialCreateViewStats_video5, _this_createViewStats_video5, _this_initialCreateViewStats_video6, _this_initialCreateViewStats_video7;
                let g = 0, f = NaN;
                void 0 !== ((_this_createViewStats_video = this.createViewStats.video) === null || _this_createViewStats_video === void 0 ? void 0 : _this_createViewStats_video.framesDropped) && void 0 !== ((_this_initialCreateViewStats_video = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video === void 0 ? void 0 : _this_initialCreateViewStats_video.framesDropped) && (g = (_this_createViewStats_video1 = this.createViewStats.video) === null || _this_createViewStats_video1 === void 0 ? void 0 : _this_createViewStats_video1.framesDropped.length, f = ((_this_createViewStats_video2 = this.createViewStats.video) === null || _this_createViewStats_video2 === void 0 ? void 0 : _this_createViewStats_video2.framesDropped[g - 1]) - ((_this_initialCreateViewStats_video1 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video1 === void 0 ? void 0 : _this_initialCreateViewStats_video1.framesDropped[0]));
                let S = NaN;
                void 0 !== ((_this_createViewStats_video3 = this.createViewStats.video) === null || _this_createViewStats_video3 === void 0 ? void 0 : _this_createViewStats_video3.framesReceived) && void 0 !== ((_this_initialCreateViewStats_video2 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video2 === void 0 ? void 0 : _this_initialCreateViewStats_video2.framesReceived) && (g = this.createViewStats.video.framesReceived.length, S = this.createViewStats.video.framesReceived[g - 1] - ((_this_initialCreateViewStats_video3 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video3 === void 0 ? void 0 : _this_initialCreateViewStats_video3.framesReceived[0]));
                let v = NaN;
                void 0 !== ((_this_createViewStats_video4 = this.createViewStats.video) === null || _this_createViewStats_video4 === void 0 ? void 0 : _this_createViewStats_video4.framesDecoded) && void 0 !== ((_this_initialCreateViewStats_video4 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video4 === void 0 ? void 0 : _this_initialCreateViewStats_video4.framesDecoded) && (g = this.createViewStats.video.framesDecoded.length, v = this.createViewStats.video.framesDecoded[g - 1] - ((_this_initialCreateViewStats_video5 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video5 === void 0 ? void 0 : _this_initialCreateViewStats_video5.framesDecoded[0]));
                let _ = NaN;
                void 0 !== ((_this_createViewStats_video5 = this.createViewStats.video) === null || _this_createViewStats_video5 === void 0 ? void 0 : _this_createViewStats_video5.keyFramesDecoded) && void 0 !== ((_this_initialCreateViewStats_video6 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video6 === void 0 ? void 0 : _this_initialCreateViewStats_video6.keyFramesDecoded) && (g = this.createViewStats.video.keyFramesDecoded.length, _ = this.createViewStats.video.keyFramesDecoded[g - 1] - ((_this_initialCreateViewStats_video7 = this.initialCreateViewStats.video) === null || _this_initialCreateViewStats_video7 === void 0 ? void 0 : _this_initialCreateViewStats_video7.keyFramesDecoded[0]));
                let C = 0;
                !isNaN(f) && S > 0 && (C = Number((f / S * 100).toFixed(7)));
                let E = !1;
                S > 0 && 0 === v && (E = !0);
                let T = !1;
                !isNaN(v) && !isNaN(_) && v > 0 && v === _ && (T = !0);
                const I = [], b = this._call.networkQualityUfdEventDetails, A = getAcsEcsConfig().rendering.remoteVideo.createViewFailureNetworkUfdCheckWindowInMs;
                b.forEach((g)=>{
                    Math.abs(g.timestampInfo - this._attemptTimestamp) <= A && I.push(g);
                });
                const R = 0 === S;
                this._createViewFailureStats.video = {
                    framesDroppedPercentage: C,
                    framesReceivedButNothingDecoded: E,
                    onlyKeyFramesDecoded: T,
                    networkQualityEventsDuringAttempt: I,
                    zeroFramesReceived: R
                };
            } catch (g) {
                this._logger.debug("Error calculating create view failure stats!");
            }
            return this._createViewFailureStats;
        }
        constructor(g, f, S, v, _){
            this._statsCollector = g, this._streamId = f, this._logger = S, this._call = v, this._attemptTimestamp = _, this._createViewFailureStats = {}, this._createViewStats = {}, this._initialCreateViewStats = {}, this._statsCollector.on("sampleReported", (g)=>{
                collectMediaStatsForCreateView(this.createViewStats, this.initialCreateViewStats, g, this._streamId);
            });
        }
    }
    class CreateViewLiveStreamTelemetryHelper {
        get initialCreateViewLiveStreamStats() {
            return this._initialLiveStreamStats;
        }
        get createViewLiveStreamStats() {
            return this._liveStreamStats;
        }
        constructor(g, f){
            var _getAcsEcsConfig;
            this._liveStreamStatsCollector = g, this._streamId = f, this._liveStreamStats = {}, this._initialLiveStreamStats = {};
            const S = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.rendering.remoteVideo.createViewSendMediaStatsMaxLength;
            this._liveStreamStatsCollector.on("sampleReported", (g)=>{
                collectLiveStreamStatsForCreateView(this._liveStreamStats, g, this._streamId, S), P.isEmpty(this._initialLiveStreamStats) && (this._initialLiveStreamStats = this._liveStreamStats);
            });
        }
    }
    var __decorate$h = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$h = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class VideoStreamRenderer {
        get _createViewStats() {
            return "RemoteVideoStream" !== this._videoStream.kind && "ComposedVideoStream" !== this._videoStream.kind || !this._createViewTelemetryHelper ? "LiveVideoStream" === this._videoStream.kind && this._createViewLiveStreamTelemetryHelper ? this._createViewLiveStreamTelemetryHelper.createViewLiveStreamStats : {} : this._createViewTelemetryHelper.createViewStats;
        }
        async createView(g) {
            if (this.disposed) throw new CallingCommunicationError({
                defaultError: O.VIEW.RENDERER_DISPOSED
            });
            const f = {}, S = +new Date, v = generateGuid(), _ = generateGuid();
            let C, E;
            try {
                var _getAcsEcsConfig, _getMediaConfig, _getAcsEcsConfig1;
                if (f.attemptTimestamp = S, this.sendCreateViewEvent({
                    eventName: dy.acs_calling_create_view_attempt,
                    viewId: v,
                    correlationId: _,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    isMirrored: g === null || g === void 0 ? void 0 : g.isMirrored,
                    scalingMode: g === null || g === void 0 ? void 0 : g.scalingMode,
                    stepsInfo: f
                }), "RemoteVideoStream" === this._videoStream.kind && !this._videoStream.isAvailable) throw new CallingCommunicationError({
                    defaultError: O.VIEW.ISAVAILABLE_FALSE
                });
                if ("RemoteVideoStream" === this._videoStream.kind && "ScreenSharing" !== this._videoStream.mediaStreamType && ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.calling.applyViewLimit) && ((_getMediaConfig = getMediaConfig()) === null || _getMediaConfig === void 0 ? void 0 : _getMediaConfig.numVideoChannelsGvc)) {
                    var _f_call_activeRemoteVideoStreamViews, _f_call_activeRemoteVideoStreamViews1;
                    const g = getMediaConfig().numVideoChannelsGvc, f = this._videoStream;
                    if (!((_f_call_activeRemoteVideoStreamViews = f.call.activeRemoteVideoStreamViews) === null || _f_call_activeRemoteVideoStreamViews === void 0 ? void 0 : _f_call_activeRemoteVideoStreamViews.has(f.id)) && ((_f_call_activeRemoteVideoStreamViews1 = f.call.activeRemoteVideoStreamViews) === null || _f_call_activeRemoteVideoStreamViews1 === void 0 ? void 0 : _f_call_activeRemoteVideoStreamViews1.size) >= g) throw new CallingCommunicationError({
                        defaultError: O.VIEW.MAX_NUM_OF_VIEWS_REACHED,
                        defaultErrorMessageArgs: [
                            g
                        ]
                    });
                }
                if ((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : _getAcsEcsConfig1.rendering.remoteVideo.createViewSendMediaStats) {
                    if ("RemoteVideoStream" === this._videoStream.kind || "ComposedVideoStream" === this._videoStream.kind) {
                        const g = this._videoStream, f = g.call;
                        E = g.call.feature(mb.MediaStats).createCollector();
                        const v = g.id;
                        this._createViewTelemetryHelper = new CreateViewTelemetryHelper(E, v, this.logger, f, S);
                    } else if ("LiveVideoStream" === this._videoStream.kind) {
                        const g = this._videoStream;
                        E = g.call.feature(mb.LiveStream).createStatsCollector();
                        const f = g.id;
                        this._createViewLiveStreamTelemetryHelper = new CreateViewLiveStreamTelemetryHelper(E, f);
                    }
                }
                C = new VideoStreamRendererViewImpl(this._videoStream, this.logger, v, f, g), this.views.set(v, C), await C.render(), "RemoteVideoStream" === this._videoStream.kind && "ScreenSharing" !== this._videoStream.mediaStreamType && this._addActiveRemoteVideoStreamView(this._videoStream, v, C);
                const T = +new Date;
                return this.sendCreateViewEvent({
                    eventName: dy.acs_calling_create_view_success,
                    viewId: v,
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: T - S
                    },
                    stepsInfo: f
                }), C;
            } catch (g) {
                const E = new CallingCommunicationError({
                    defaultError: O.VIEW.CREATE_VIEW_FAILED,
                    originalError: g
                });
                if (this.views.delete(v), this._attemptToDisposeView(C), E.message !== O.VIEW.LARGE_MEETING_VIEW_DISPOSED.message && E.message !== O.VIEW.REMOTE_VIDEO_STREAM_DISPOSED.message) {
                    const g = Date.now();
                    this.sendCreateViewEvent({
                        eventName: dy.acs_calling_create_view_failure,
                        viewId: v,
                        correlationId: _,
                        timestampInfo: {
                            deltaTimeInMs: g - S
                        },
                        stepsInfo: f
                    }, E);
                }
                throw E;
            } finally{
                E === null || E === void 0 ? void 0 : E.dispose();
            }
        }
        async sendCreateViewEvent(g, f) {
            try {
                var _getAcsEcsConfig;
                let S = {}, v = {}, _ = {};
                if (((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : _getAcsEcsConfig.rendering.remoteVideo.createViewSendMediaStats) && (g.eventName === dy.acs_calling_create_view_failure || g.eventName === dy.acs_calling_create_view_success)) {
                    var _this__createViewTelemetryHelper;
                    if ("RemoteVideoStream" === this._videoStream.kind) {
                        var _f_extensions, _f_extensions1, _f_extensions2, _f_extensions3, _f_metrics, _f_extensions4, _f_extensions5, _f_extensions6, _g_activeRemoteVideoStreamViews;
                        const g = this._videoStream.call, f = g.tsCall.getMediaSessionStats();
                        S = {
                            videoSubscriptionEvents: f === null || f === void 0 ? void 0 : (_f_extensions = f.extensions) === null || _f_extensions === void 0 ? void 0 : _f_extensions.Video_SubscriptionEvents,
                            screenSharingSubscriptionEvents: f === null || f === void 0 ? void 0 : (_f_extensions1 = f.extensions) === null || _f_extensions1 === void 0 ? void 0 : _f_extensions1.Sharing_SubscriptionEvents,
                            videoSendMaxCapabilities: f === null || f === void 0 ? void 0 : (_f_extensions2 = f.extensions) === null || _f_extensions2 === void 0 ? void 0 : _f_extensions2.Video_send_MaxCapabilities,
                            screenSharingSendMaxCapabilities: f === null || f === void 0 ? void 0 : (_f_extensions3 = f.extensions) === null || _f_extensions3 === void 0 ? void 0 : _f_extensions3.Sharing_send_MaxCapabilities,
                            iceConnectedStateTime: f === null || f === void 0 ? void 0 : (_f_metrics = f.metrics) === null || _f_metrics === void 0 ? void 0 : _f_metrics.IceConnectedStateTime,
                            relayCandidate: f === null || f === void 0 ? void 0 : (_f_extensions4 = f.extensions) === null || _f_extensions4 === void 0 ? void 0 : _f_extensions4.RelayCandidate,
                            videoRecvTimeToFirstFrame: f === null || f === void 0 ? void 0 : (_f_extensions5 = f.extensions) === null || _f_extensions5 === void 0 ? void 0 : _f_extensions5.Video_recv_TimeToFirstFrame,
                            screenSharingRecvTimeToFirstFrame: f === null || f === void 0 ? void 0 : (_f_extensions6 = f.extensions) === null || _f_extensions6 === void 0 ? void 0 : _f_extensions6.Sharing_recv_TimeToFirstFrame,
                            optimalVideoCount: g.tsCall.optimalVideoCount || 1,
                            currentNumberOfVideosRendered: ((_g_activeRemoteVideoStreamViews = g.activeRemoteVideoStreamViews) === null || _g_activeRemoteVideoStreamViews === void 0 ? void 0 : _g_activeRemoteVideoStreamViews.size) || 0
                        };
                    }
                    var _this__createViewTelemetryHelper_getCreateViewFailureStats;
                    g.eventName === dy.acs_calling_create_view_failure && (_ = (_this__createViewTelemetryHelper_getCreateViewFailureStats = (_this__createViewTelemetryHelper = this._createViewTelemetryHelper) === null || _this__createViewTelemetryHelper === void 0 ? void 0 : _this__createViewTelemetryHelper.getCreateViewFailureStats()) !== null && _this__createViewTelemetryHelper_getCreateViewFailureStats !== void 0 ? _this__createViewTelemetryHelper_getCreateViewFailureStats : {}, v = this._createViewStats);
                }
                S.visibilityState = document.visibilityState, void 0 !== g.isMirrored && (S.isMirrored = g.isMirrored), void 0 !== g.scalingMode && (S.scalingMode = g.scalingMode), g.eventName !== dy.acs_calling_create_view_failure && g.eventName !== dy.acs_calling_create_view_success || "RemoteVideoStream" !== this._videoStream.kind && "ComposedVideoStream" !== this._videoStream.kind || P.forOwn(g.stepsInfo, (g, f)=>{
                    void 0 !== g && (S[f] = g);
                });
                let C = "", E = {};
                f && (C = "string" == typeof (f === null || f === void 0 ? void 0 : f.message) ? f === null || f === void 0 ? void 0 : f.message : "", E = {
                    ...extractCommunicationServicesErrorForTelemetry(f)
                }), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        viewId: g.viewId,
                        correlationId: g.correlationId,
                        timestampInfo: g.timestampInfo,
                        ...this._videoStream.getStreamMetadata(),
                        failureReason: C,
                        additionalProperties: S,
                        additionalDetails: E,
                        stats: v,
                        createViewFailureDebugStats: _,
                        videoStreamKind: this._videoStream.kind
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send telemtery");
            }
        }
        dispose() {
            if (this.disposed) throw new CallingCommunicationError({
                defaultError: O.VIEW.RENDERER_ALREADY_DISPOSED
            });
            this.disposed = !0, this.views.forEach(this._attemptToDisposeView), this.views.clear();
        }
        constructor(g){
            if (this.size = {
                height: 0,
                width: 0
            }, this.views = new Map, this.disposed = !1, this._attemptToDisposeView = (g)=>{
                try {
                    g === null || g === void 0 ? void 0 : g.dispose();
                } catch (g) {
                    this.logger.warn((g === null || g === void 0 ? void 0 : g.message) || "Failed to dispose, unknown error");
                }
            }, this._addActiveRemoteVideoStreamView = (g, f, S)=>{
                var _g_call_activeRemoteVideoStreamViews;
                if ((_g_call_activeRemoteVideoStreamViews = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews.has(g.id)) {
                    var _g_call_activeRemoteVideoStreamViews1;
                    let v = (_g_call_activeRemoteVideoStreamViews1 = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews1 === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews1.get(g.id);
                    v && v.set(f, S);
                } else {
                    var _g_call_activeRemoteVideoStreamViews2;
                    let v = new Map;
                    v.set(f, S), (_g_call_activeRemoteVideoStreamViews2 = g.call.activeRemoteVideoStreamViews) === null || _g_call_activeRemoteVideoStreamViews2 === void 0 ? void 0 : _g_call_activeRemoteVideoStreamViews2.set(g.id, v);
                }
            }, !(g instanceof LocalVideoStream || g instanceof RemoteVideoStreamCommonImpl || g instanceof RemoteVideoStreamImpl)) throw new CallingCommunicationError({
                defaultError: O.VIEW.RENDERER_WRONG_STREAM_TYPE
            });
            const S = f.createClientLogger("ACS");
            this._videoStream = g, this._telemetryLogManager = g.telemetryLogManager, this.logger = new DefaultLogger(S, g instanceof LocalVideoStream ? [
                ()=>{
                    var _g_source;
                    return `VideoStreamRenderer:LocalVideoStream:${R.pii.Omit(g === null || g === void 0 ? void 0 : (_g_source = g.source) === null || _g_source === void 0 ? void 0 : _g_source.id)}`;
                }
            ] : [
                ()=>`VideoStreamRenderer:${g.kind}:${g === null || g === void 0 ? void 0 : g.id}`
            ]), this.logger.info("created");
        }
    }
    __decorate$h([
        loggerProperty,
        __metadata$h("design:type", Object)
    ], VideoStreamRenderer.prototype, "logger", void 0), __decorate$h([
        asyncOperation(MS.CreateView),
        __metadata$h("design:type", Function),
        __metadata$h("design:paramtypes", [
            Object
        ]),
        __metadata$h("design:returntype", Promise)
    ], VideoStreamRenderer.prototype, "createView", null), __decorate$h([
        syncOperation(MS.Dispose),
        __metadata$h("design:type", Function),
        __metadata$h("design:paramtypes", []),
        __metadata$h("design:returntype", void 0)
    ], VideoStreamRenderer.prototype, "dispose", null);
    var __decorate$i = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$i = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class RemoteParticipantImpl {
        get identifier() {
            return this._identifier;
        }
        get endpointDetails() {
            var _this__tsParticipant_endpoints, _this__tsParticipant;
            return ((_this__tsParticipant = this._tsParticipant) === null || _this__tsParticipant === void 0 ? void 0 : (_this__tsParticipant_endpoints = _this__tsParticipant.endpoints) === null || _this__tsParticipant_endpoints === void 0 ? void 0 : _this__tsParticipant_endpoints.endpointDetails.map((g)=>({
                    participantId: g.participantId,
                    deviceType: g.deviceType,
                    clientEndpointCapabilities: g.clientEndpointCapabilities,
                    endpointMetadata: g.endpointMetadata
                }))) || [];
        }
        get state() {
            return this._state;
        }
        get videoStreams() {
            return [
                ...this._mappedStreams.values()
            ];
        }
        get isMuted() {
            return this._isMuted;
        }
        get isSpeaking() {
            return this._isSpeaking;
        }
        get callEndReason() {
            return this._callEndReason;
        }
        get displayName() {
            return this._displayName;
        }
        get role() {
            return this._role;
        }
        on(g, f) {
            if ("stateChanged" !== g && "isMutedChanged" !== g && "isSpeakingChanged" !== g && "displayNameChanged" !== g && "roleChanged" !== g && "videoStreamsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_PARTICIPANT.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("stateChanged" !== g && "isMutedChanged" !== g && "isSpeakingChanged" !== g && "displayNameChanged" !== g && "roleChanged" !== g && "videoStreamsUpdated" !== g) throw new CallingCommunicationError({
                defaultError: O.REMOTE_PARTICIPANT.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        async mute() {
            if (!getAcsEcsConfig().calling.enableMuteOthers) throw new CallingCommunicationError({
                defaultError: O.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_DISABLED
            });
            if (!this._call.tsCall.conversationType && this._call.callInfo.context === BS.TwoParty) throw new CallingCommunicationError({
                defaultError: O.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_1_TO_1_UNSUPPORTED
            });
            if (![
                "Connected",
                "Hold"
            ].some((g)=>g === this._state)) throw new CallingCommunicationError({
                defaultError: O.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_NONCONNECTED_UNSUPPORTED
            });
            const g = this.logger.createFnLogger(bS.Mute), f = +new Date, S = generateGuid();
            if (this.sendAudioEvent({
                eventName: dy.acs_calling_mute_attempt,
                eventType: gy.MuteSpecificParticipant,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call"
            }), "phoneNumber" === this._identifier.kind) {
                const v = +new Date, _ = O.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_PSTN_UNSUPPORTED;
                g.warn(_.message);
                const C = new CallingCommunicationError({
                    defaultError: _
                });
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_failure,
                    eventType: gy.MuteSpecificParticipant,
                    timestampInfo: {
                        deltaTimeInMs: v - f
                    },
                    correlationId: S,
                    step: "mid-call"
                }, C), C;
            }
            try {
                g.info("remote mute specific");
                var v = [];
                void 0 !== this._tsParticipant ? v = v.concat(this._tsParticipant) : g.warn("no participant to mute in attempt to mute specific remote participant"), await this._call.tsCall.muteParticipants(1, v), g.info("remote mute specific success");
                const _ = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_success,
                    eventType: gy.MuteSpecificParticipant,
                    timestampInfo: {
                        deltaTimeInMs: _ - f
                    },
                    correlationId: S,
                    step: "mid-call"
                });
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.REMOTE_PARTICIPANT.MUTE_PARTICIPANT_FAILED,
                    originalError: v
                });
                g.error(_.message);
                const C = +new Date;
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_failure,
                    eventType: gy.MuteSpecificParticipant,
                    timestampInfo: {
                        deltaTimeInMs: C - f
                    },
                    correlationId: S,
                    step: "mid-call"
                }, _), _;
            }
        }
        _dispose() {
            this.logger.log("dispose"), this._participantChangedHandler && this._participantChangedHandler.dispose(), this._mappedStreams.forEach((g)=>g.dispose()), this._eventEmitter.emit("stateChanged", this._state), this._eventEmitter.removeAllListeners(), this._disposeVideo(0), this._disposeVideo(1);
        }
        get tsRemoteParticipant() {
            return this._tsParticipant;
        }
        get kind() {
            return "RemoteParticipant";
        }
        setCallEndReason(g) {
            this._callEndReason = g;
        }
        observeParticipant(g) {
            this._tsParticipant || (this._tsParticipant = g, this._displayName = g.displayName, this._isMuted = g.isServerMuted, this._participantChangedHandler = this._tsParticipant.changed(()=>{
                if (this._tsParticipant && this._tsParticipant.state !== this._lastTsParticipantState && (this._lastTsParticipantState = this._tsParticipant.state, this._mapTsParticipantState(this._tsParticipant.state)), this._mapStreams(), this._tsParticipant && this._tsParticipant.isServerMuted !== this._isMuted && (this._isMuted = this._tsParticipant.isServerMuted, this._eventEmitter.emit("isMutedChanged")), this._tsParticipant && this._tsParticipant.displayName && this._tsParticipant.displayName !== this._displayName && (this._displayName = g.displayName, this._eventEmitter.emit("displayNameChanged")), this._tsParticipant && this._tsParticipant.advancedMeetingRole !== this._lastTsParticipantAdvancedRole && (this._lastTsParticipantAdvancedRole = g.advancedMeetingRole, this._setParticipantRole(this._tsParticipant.advancedMeetingRole)), this._tsParticipant) {
                    const g = 0 !== this._tsParticipant.voiceLevel;
                    g !== this._isSpeaking && (this._isSpeaking = g, this._eventEmitter.emit("isSpeakingChanged"));
                }
            }), this._mapTsParticipantState(this._tsParticipant.state), this._mapStreams(), this._lastTsParticipantAdvancedRole = this._tsParticipant.advancedMeetingRole, this._setParticipantRole(this._tsParticipant.advancedMeetingRole), this._displayName || !S.isMicrosoftTeamsAppIdentifier(this._identifier) && !S.isMicrosoftTeamsUserIdentifier(this._identifier) || this.getRemoteParticipantProperties().then((g)=>{
                (g === null || g === void 0 ? void 0 : g.displayName) && (this._displayName = g.displayName, this._eventEmitter.emit("displayNameChanged"));
            }).catch((g)=>{
                this.logger.error(`Failed to get remote participant properties: ${g}`);
            }));
        }
        setParticipantState(g) {
            g !== this._state && (this.logger.log(`state changed ${this._state}=>${this.state}`), this._state = g, "Disconnected" == this._state ? this._dispose() : this._eventEmitter.emit("stateChanged", this._state));
        }
        async stopRenderingVideo() {
            this._disposeVideo(0);
        }
        async renderVideo(g, f) {
            if ("function" == typeof g) return this._updateRenderingState(g, "Video", f);
            return await this._renderStreamForParticipant(g, 0, f);
        }
        async _updateRenderingState(g, f, S) {
            if ("function" == typeof g) {
                let v;
                const _ = "Video" === f ? 0 : 1;
                this._tsParticipant && (v = (S === null || S === void 0 ? void 0 : S.stream) ? S.stream : new RemoteVideoStreamImpl(this._tsParticipant.streams[_][0], this.logger, this._call, this._callAgent, this._tsParticipant.id, this._telemetryLogManager, this._identifier), v.on("isReceivingChanged", ()=>{
                    this._renderers[f].renderingState.isFrozen = !v.isReceiving, g(this._renderers[f].renderingState);
                }), v.on("isAvailableChanged", async ()=>{
                    var _this__renderers_f, _this__renderers_f_renderer, _this__renderers_f_view;
                    this._renderers[f].renderingState.isStreaming !== (v === null || v === void 0 ? void 0 : v.isAvailable) && (this._renderers[f].renderingState.isStreaming = v.isAvailable, this._renderers[f].renderingState.isStreaming && !this._renderers[f].renderer && (this._renderers[f].renderer = ((_this__renderers_f = this._renderers[f]) === null || _this__renderers_f === void 0 ? void 0 : _this__renderers_f.renderer) ? this._renderers[f].renderer : new VideoStreamRenderer(v), this._renderers[f].view || (this._renderers[f].view = await ((_this__renderers_f_renderer = this._renderers[f].renderer) === null || _this__renderers_f_renderer === void 0 ? void 0 : _this__renderers_f_renderer.createView(S === null || S === void 0 ? void 0 : S.viewOptions))), this._renderers[f].renderingState.videoTarget = (_this__renderers_f_view = this._renderers[f].view) === null || _this__renderers_f_view === void 0 ? void 0 : _this__renderers_f_view.target)), g(this._renderers[f].renderingState);
                }));
            }
        }
        async renderScreenShare(g, f) {
            if ("function" == typeof g) return this._updateRenderingState(g, "ScreenSharing", f);
            return this._renderStreamForParticipant(g, 1, f);
        }
        async _renderStreamForParticipant(g, f, S) {
            if (this._tsParticipant) {
                var _this__renderers_v;
                const v = 0 === f ? "Video" : "ScreenSharing", _ = (S === null || S === void 0 ? void 0 : S.stream) ? S.stream : new RemoteVideoStreamImpl(this._tsParticipant.streams[f][0], this.logger, this._call, this._callAgent, this._tsParticipant.id, this._telemetryLogManager, this._identifier);
                return _.isAvailable && (this._renderers[v].view = await this._appendVideo(g, f, _, S === null || S === void 0 ? void 0 : S.viewOptions)), _.on("isAvailableChanged", async ()=>{
                    var _this__renderers_v, _this__renderers_v_view, _this__renderers_v_view1, _this__renderers_v_view_target_parentNode, _this__renderers_v_view2;
                    _.isAvailable ? this._renderers[v].view = await this._appendVideo(g, f, _, S === null || S === void 0 ? void 0 : S.viewOptions) : ((_this__renderers_v = this._renderers[v]) === null || _this__renderers_v === void 0 ? void 0 : _this__renderers_v.view) && ((_this__renderers_v_view = this._renderers[v].view) === null || _this__renderers_v_view === void 0 ? void 0 : _this__renderers_v_view.target) && ((_this__renderers_v_view2 = this._renderers[v].view) === null || _this__renderers_v_view2 === void 0 ? void 0 : (_this__renderers_v_view_target_parentNode = _this__renderers_v_view2.target.parentNode) === null || _this__renderers_v_view_target_parentNode === void 0 ? void 0 : _this__renderers_v_view_target_parentNode.removeChild((_this__renderers_v_view1 = this._renderers[v].view) === null || _this__renderers_v_view1 === void 0 ? void 0 : _this__renderers_v_view1.target));
                }), Promise.resolve({
                    stream: _,
                    view: (_this__renderers_v = this._renderers[v]) === null || _this__renderers_v === void 0 ? void 0 : _this__renderers_v.view
                });
            }
            return Promise.reject();
        }
        async _appendVideo(g, f, S, v) {
            try {
                var _this__renderers__, _this__renderers__1, _this__renderers___renderer, _this__renderers___view;
                const _ = 0 === f ? "Video" : "ScreenSharing";
                if (0 === f && (((_this__renderers__ = this._renderers[_]) === null || _this__renderers__ === void 0 ? void 0 : _this__renderers__.renderer) || (this._renderers[_].renderer = ((_this__renderers__1 = this._renderers[_]) === null || _this__renderers__1 === void 0 ? void 0 : _this__renderers__1.renderer) ? this._renderers[_].renderer : new VideoStreamRenderer(S), this._renderers[_].view = await ((_this__renderers___renderer = this._renderers[_].renderer) === null || _this__renderers___renderer === void 0 ? void 0 : _this__renderers___renderer.createView(v))), this._renderers[_].view)) return g.appendChild(((_this__renderers___view = this._renderers[_].view) === null || _this__renderers___view === void 0 ? void 0 : _this__renderers___view.target) || document.createElement("emptyNode")), Promise.resolve(this._renderers[_].view);
            } catch (g) {
                return Promise.reject(g);
            }
            return Promise.reject();
        }
        async _disposeVideo(g) {
            var _this__renderers_f_view, _this__renderers_f_renderer;
            const f = 0 === g ? "Video" : "ScreenSharing";
            (_this__renderers_f_view = this._renderers[f].view) === null || _this__renderers_f_view === void 0 ? void 0 : _this__renderers_f_view.dispose(), (_this__renderers_f_renderer = this._renderers[f].renderer) === null || _this__renderers_f_renderer === void 0 ? void 0 : _this__renderers_f_renderer.dispose(), this._renderers[f] = {
                renderingState: {}
            };
        }
        _setParticipantRole(g) {
            let f = advancedMeetingRoleToParticipantRole(getAcsEcsConfig(), g);
            "Unknown" === f ? this.logger.log(`tsParticipant advancedMeetingRole=${g} had no mapping`) : this.logger.log(`mapped tsParticipant advancedMeetingRole=${g}=>${f}`), this._role != f && (this.logger.log(`role changed ${this._role}=>${g}`), this._role = f, this._eventEmitter.emit("roleChanged"));
        }
        _mapTsParticipantState(g) {
            let f;
            const S = {
                0: "Idle",
                1: "Connecting",
                2: "Ringing",
                3: "Connected",
                4: "Disconnected",
                5: "Hold",
                7: "InLobby",
                6: "EarlyMedia"
            };
            S[g] ? (f = S[g], this.logger.log(`mapped tsParticipant ${g}=>${this._state}`), this.setParticipantState(f)) : this.logger.log(`unable to map tsCall state=${g} to call state`);
        }
        _mapStreams() {
            const g = [], f = [], handleNewStream = (g)=>{
                this._mappedStreams.set(g.id, g);
            }, handleRemovedStream = (g)=>{
                const f = this._mappedStreams.get(g.id);
                f && (this.logger.log(`stream removed, type==${f.mediaStreamType} id=${g.id}`), this._mappedStreams.delete(g.id), f.dispose());
            }, mapStreamsOfType = (S)=>{
                if (this._tsParticipant) {
                    if (this._tsParticipant.streams && isNonEmptyArray(this._tsParticipant.streams[S])) {
                        let v = [];
                        this._tsParticipant && (v = this._tsParticipant.streams[S]), v.forEach((f)=>{
                            if (!this._mappedStreams.get(f.id)) {
                                const S = new RemoteVideoStreamImpl(f, this.logger, this._call, this._callAgent, this._tsParticipant.id, this._telemetryLogManager, this._identifier);
                                this.logger.log(`stream created, type==${S.mediaStreamType} id=${f.id}`), g.push(S);
                            }
                        }), this._mappedStreams.forEach((g)=>{
                            if (this.acsToTsStreamType(g.mediaStreamType) === S) v.some((f)=>f.id === g.id) || f.push(g);
                        });
                    } else this._mappedStreams.forEach((g)=>{
                        this.acsToTsStreamType(g.mediaStreamType) === S && f.push(g);
                    });
                }
            };
            mapStreamsOfType(0), mapStreamsOfType(1), (g.length > 0 || f.length > 0) && (g.forEach(handleNewStream), f.forEach(handleRemovedStream), this._eventEmitter.emit("videoStreamsUpdated", {
                added: g,
                removed: f
            }));
        }
        sendAudioEvent(g, f) {
            try {
                let S, v;
                f && (S = f.message, v = extractCommunicationServicesErrorForTelemetry(f));
                const _ = {
                    callId: this._call.id,
                    timestampInfo: g.timestampInfo,
                    correlationId: g.correlationId,
                    step: g.step || "",
                    failureReason: S || "",
                    additionalDetails: {
                        ...v
                    }
                };
                void 0 !== g.eventType && (_.eventType = g.eventType), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: _
                });
            } catch (g) {
                this.logger.debug("Unable to send mute others audio telemetry");
            }
        }
        getRemoteParticipantProperties() {
            return new Promise((g)=>{
                const f = {
                    policyUrlSuffix: getAcsEcsConfig().MiddleTier.policyUrlSuffixV2,
                    userPolicies: [
                        "TeamsMeetingPolicy"
                    ],
                    userProperties: [
                        "displayName"
                    ]
                };
                this._callAgent.mtPolicyService.requestUserPoliciesFromAcsMiddleTier(this._call.id, getMriFromIdentifier(this.identifier), f, this._callAgent.getUserMri()).then((f)=>{
                    var _f_userAggregatedPolicySettingData;
                    g((_f_userAggregatedPolicySettingData = f.userAggregatedPolicySettingData) === null || _f_userAggregatedPolicySettingData === void 0 ? void 0 : _f_userAggregatedPolicySettingData.userProperties);
                });
            });
        }
        constructor(g, f, S, v, _){
            this._mappedStreams = new Map, this._state = "Idle", this._lastTsParticipantState = 0, this._isMuted = !1, this._isSpeaking = !1, this._displayName = "", this._role = "Unknown", this.acsToTsStreamType = (g)=>"Video" === g ? 0 : "ScreenSharing" === g ? 1 : void 0, this._identifier = g, this.logger = f.createChild(()=>`RemoteParticipant{${this._identifier.kind}}`), this._telemetryLogManager = _, this._eventEmitter = new CallingEventEmitter(this.logger), this._callAgent = v, this._call = S, this.logger.log("created"), this._renderers = {
                Video: {
                    renderingState: {}
                },
                ScreenSharing: {
                    renderingState: {}
                }
            };
        }
    }
    __decorate$i([
        loggerProperty,
        __metadata$i("design:type", Object)
    ], RemoteParticipantImpl.prototype, "logger", void 0), __decorate$i([
        asyncOperation(bS.Mute),
        __metadata$i("design:type", Function),
        __metadata$i("design:paramtypes", []),
        __metadata$i("design:returntype", Promise)
    ], RemoteParticipantImpl.prototype, "mute", null);
    class SelectedDeviceManager {
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        selectedDevice(g) {
            return this._selectedDevices.get(g);
        }
        dispose() {
            const g = this._selectedDeviceListeners.get("Speaker");
            g && this._deviceManager.off("selectedSpeakerChanged", g);
            const f = this._selectedDeviceListeners.get("Microphone");
            f && this._deviceManager.off("selectedMicrophoneChanged", f), this._eventEmitter.removeAllListeners();
        }
        constructor(g){
            this._deviceManager = g, this._eventEmitter = new Ny.EventEmitter, this._selectedDeviceListeners = new Map, this._selectedDevices = new Map, this._deviceInfoMapper = this._deviceManager.deviceInfoMapper;
            const createSelectedDeviceListener = (g)=>()=>{
                    const f = this._selectedDevices.get(g), S = (()=>"Speaker" === g ? this._deviceManager.selectedSpeaker : "Microphone" === g ? this._deviceManager.selectedMicrophone : void 0)(), v = void 0 === S ? void 0 : {
                        id: this._deviceInfoMapper.getDeviceId(S.id),
                        name: this._deviceInfoMapper.scrubDeviceLabel(S.name)
                    };
                    this._selectedDevices.set(g, v), this._eventEmitter.emit("selectedDeviceChanged", {
                        selectedDeviceType: g,
                        oldDevice: f,
                        newDevice: v
                    });
                }, f = createSelectedDeviceListener("Speaker");
            this._selectedDeviceListeners.set("Speaker", f), this._deviceManager.on("selectedSpeakerChanged", f), f();
            const S = createSelectedDeviceListener("Microphone");
            this._selectedDeviceListeners.set("Microphone", S), this._deviceManager.on("selectedMicrophoneChanged", S), S();
        }
    }
    function getCallProgressCommonPayload(f, S, v, _) {
        var _f_tsCall_meetingData, _f_localAudioStreams, _f_localVideoStreams, _S_runningEnvironmentInfo;
        const C = _ === aS.RoomCall || f.kind === g.CallKind.Call && "Incoming" == f.direction && !f.tsCall.groupId && !!((_f_tsCall_meetingData = f.tsCall.meetingData) === null || _f_tsCall_meetingData === void 0 ? void 0 : _f_tsCall_meetingData.meetingCode) && !f.tsCall.threadId, E = !C && _ === aS.TeamsMeetingLink || _ === aS.TeamsMeetingId || _ === aS.TeamsCoordinates || "Incoming" == f.direction && !f.tsCall.groupId && !!f.tsCall.meetingData && !!f.tsCall.threadId, T = {
            audio: "",
            video: ""
        }, I = (_f_localAudioStreams = f.localAudioStreams) === null || _f_localAudioStreams === void 0 ? void 0 : _f_localAudioStreams[0];
        var _I_getEffectsCurrentStateRecord;
        I && (T.audio = (_I_getEffectsCurrentStateRecord = I.getEffectsCurrentStateRecord()) !== null && _I_getEffectsCurrentStateRecord !== void 0 ? _I_getEffectsCurrentStateRecord : "");
        const b = (_f_localVideoStreams = f.localVideoStreams) === null || _f_localVideoStreams === void 0 ? void 0 : _f_localVideoStreams[0];
        var _b_getEffectsCurrentStateRecord;
        return b && (T.video = (_b_getEffectsCurrentStateRecord = b.getEffectsCurrentStateRecord()) !== null && _b_getEffectsCurrentStateRecord !== void 0 ? _b_getEffectsCurrentStateRecord : ""), {
            timestampInfo: {
                attemptTimestamp: +new Date
            },
            correlationId: v,
            localParticipantId: f.tsCall.participantId || "",
            isAcsTeamsCall: f.isAcsTeamsCall,
            callId: f.tsCall.callId || "",
            callType: f.tsCall.callType || "",
            callDirection: f.direction,
            state: "Ringing" === f.state ? "Ringing" : jy[f.tsCall.state],
            groupJoin: !!f.tsCall.groupId,
            roomJoin: C,
            meetingJoin: E,
            callEndDiagnosticsInfo: f.tsCall.callEndDiagnosticsInfo || {},
            isSupportedEnvironment: S === null || S === void 0 ? void 0 : (_S_runningEnvironmentInfo = S.runningEnvironmentInfo) === null || _S_runningEnvironmentInfo === void 0 ? void 0 : _S_runningEnvironmentInfo.isSupportedEnvironment,
            effectsStateInfo: T,
            hostRegion: f.tsCall.region || "",
            diagnosticInfo: {
                ...f.tsCall.callEndDiagnosticsInfo,
                telemetryPayloadBytesOriginal: TelemetryLogManager.telemetryPayloadBytesOriginal,
                telemetryPayloadBytesCompressed: TelemetryLogManager.telemetryPayloadBytesCompressed
            }
        };
    }
    function sendCallProgressEvent(g, f, S) {
        try {
            "state-changed" === S.step && "Connecting" === S.newState && (TelemetryLogManager.telemetryPayloadBytesOriginal = 0, TelemetryLogManager.telemetryPayloadBytesCompressed = 0), g.sendEvent({
                name: dy.acs_calling_call_progress,
                tenant: nf,
                properties: S
            });
        } catch (g) {
            f.error(`Failed to send event: ${dy.acs_calling_call_progress} step: ${S.step}`);
        }
    }
    var __decorate$j = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$j = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class CallInfoCommonImpl {
        get threadId() {
            return this._threadId;
        }
        get roomId() {
            return this._roomId;
        }
        get groupId() {
            return this._groupId;
        }
        get participantId() {
            return this._tsCall.participantId;
        }
        get isPstnInterop() {
            return this._isPstnInterop;
        }
        get isTeamsInterop() {
            return this._isTeamsInterop;
        }
        get callScenario() {
            if (this._tsCall.callQueueInfo) return VS.CallQueue;
            if ("unknown" !== this.transferorKind) {
                if ("transfer" === this._tsCall.incomingCallType) return VS.TransferToParticipant;
                if ("replaces" === this._tsCall.incomingCallType) return VS.TransferToCall;
            }
            return "Incoming" === this.direction ? "AcceptCall" : "Outgoing" === this.direction && "Rooms" == this.context ? VS.JoinRoom : "Outgoing" === this.direction && "TeamsMeeting" == this.context ? VS.JoinTeamMeeting : "Outgoing" === this.direction && "GroupIdCall" == this.context ? VS.JoinWithGroupId : VS.PlaceCall;
        }
        get context() {
            var _this__config, _this__tsCall_meetingData_meetingCode, _this__tsCall_meetingData, _this__tsCall_meetingData_meetingCode1, _this__tsCall_meetingData1, _this__tsCall_meetingData_meetingCode2, _this__tsCall_meetingData2, _this__tsCall_meetingData3, _this__tsCall_meetingData4;
            return 1 == this._tsCall.callType || this._currentCallContext == BS.TwoParty ? BS.TwoParty : this._tsCall.groupId ? BS.GroupIdCall : "groupCall" == this._tsCall.conversationType || this._currentCallContext == BS.MultiParty ? BS.MultiParty : ((_this__config = this._config) === null || _this__config === void 0 ? void 0 : _this__config.roomId) || this._roomId || ((_this__tsCall_meetingData = this._tsCall.meetingData) === null || _this__tsCall_meetingData === void 0 ? void 0 : (_this__tsCall_meetingData_meetingCode = _this__tsCall_meetingData.meetingCode) === null || _this__tsCall_meetingData_meetingCode === void 0 ? void 0 : _this__tsCall_meetingData_meetingCode.startsWith("994")) || ((_this__tsCall_meetingData1 = this._tsCall.meetingData) === null || _this__tsCall_meetingData1 === void 0 ? void 0 : (_this__tsCall_meetingData_meetingCode1 = _this__tsCall_meetingData1.meetingCode) === null || _this__tsCall_meetingData_meetingCode1 === void 0 ? void 0 : _this__tsCall_meetingData_meetingCode1.startsWith("995")) || ((_this__tsCall_meetingData2 = this._tsCall.meetingData) === null || _this__tsCall_meetingData2 === void 0 ? void 0 : (_this__tsCall_meetingData_meetingCode2 = _this__tsCall_meetingData2.meetingCode) === null || _this__tsCall_meetingData_meetingCode2 === void 0 ? void 0 : _this__tsCall_meetingData_meetingCode2.startsWith("996")) ? BS.Rooms : ((_this__tsCall_meetingData3 = this._tsCall.meetingData) === null || _this__tsCall_meetingData3 === void 0 ? void 0 : _this__tsCall_meetingData3.meetingUrl) || ((_this__tsCall_meetingData4 = this._tsCall.meetingData) === null || _this__tsCall_meetingData4 === void 0 ? void 0 : _this__tsCall_meetingData4.passcode) || "scheduledMeeting" == this._tsCall.conversationType ? BS.TeamsMeeting : (this._tsCall.callType, BS.MultiParty);
        }
        get transferorKind() {
            return this._tsCall.transferorMri ? constructIdentifierKindFromMri(this._tsCall.transferorMri || "").kind : "";
        }
        get direction() {
            var _this__config;
            return ((_this__config = this._config) === null || _this__config === void 0 ? void 0 : _this__config.isIncoming) ? yS.Incoming : yS.Outgoing;
        }
        get initiatorKind() {
            return constructIdentifierKindFromMri(this._tsCall.callerMri ? this._tsCall.callerMri : "").kind;
        }
        get targetKind() {
            var _this__config, _this__tsCall_meetingData, _this__tsCall_meetingData1;
            if (this._tsCall.groupId) return this._tsCall.groupId;
            if ((_this__config = this._config) === null || _this__config === void 0 ? void 0 : _this__config.roomId) return this._config.roomId;
            if (((_this__tsCall_meetingData = this._tsCall.meetingData) === null || _this__tsCall_meetingData === void 0 ? void 0 : _this__tsCall_meetingData.meetingUrl) || ((_this__tsCall_meetingData1 = this._tsCall.meetingData) === null || _this__tsCall_meetingData1 === void 0 ? void 0 : _this__tsCall_meetingData1.meetingCode)) return "TeamsMeetingJoinLink";
            if (this._tsCall.transferorMri) return "Transferee";
            if (1 === this._tsCall.participants.length) return constructIdentifierKindFromMri(this._tsCall.participants[0].id).kind;
            return this._tsCall.participants.filter((g)=>g.id !== this._tsCall.callerMri).map((g)=>constructIdentifierKindFromMri(g.id).kind).toString();
        }
        setThreadId(g) {
            this._threadId = g;
        }
        initialize(g, f, S) {
            this._logger = f, this._eventEmitter = g, this._threadId = this._tsCall.threadId, this._tsCallChangedListener = this._tsCall.changed(()=>this.threadIdChanged(this._tsCall)), this._p2pCallListener = this._tsCall.changed(()=>this.p2pCallHandler()), this._isPstnInterop = this.isPSTNUserInCall, this._isTeamsInterop = this.isTeamsUserInCall, this._participantUpdatedListener = this._tsCall.on("participantCountsUpdated", ()=>{
                this.interoperabilityChangeHandler(), this.p2pCallEscalationHandler();
            });
        }
        async getServerCallId() {
            const g = JSON.parse(await this._tsCall.getJoinBlob()), f = g === null || g === void 0 ? void 0 : g.conversationUrl;
            if (!f) throw new CallingCommunicationError({
                defaultError: O.CALL.GET_SERVER_CALL_ID
            });
            return base64UrlEncoding(f);
        }
        p2pCallHandler() {
            null == this._currentCallContext && 1 == this._tsCall.callType && (this._currentCallContext = BS.TwoParty);
        }
        p2pCallEscalationHandler() {
            var _this__p2pCallListener;
            this._currentCallContext == BS.TwoParty && getTotalNotBotParticipantCount(this._tsCall) > 2 && (this._currentCallContext = BS.MultiParty, this._eventEmitter.emit("callInfoChanged"), (_this__p2pCallListener = this._p2pCallListener) === null || _this__p2pCallListener === void 0 ? void 0 : _this__p2pCallListener.dispose());
        }
        get isTeamsUserInCall() {
            if (!this._tsCall.participants) return !1;
            for (const g of this._tsCall.participants)if ("microsoftTeamsUser" === constructIdentifierKindFromMri(g.id).kind) return !0;
            return !1;
        }
        get isPSTNUserInCall() {
            if (!this._tsCall.participants) return !1;
            for (const g of this._tsCall.participants)if ("phoneNumber" === constructIdentifierKindFromMri(g.id).kind) return !0;
            return !1;
        }
        interoperabilityChangeHandler() {
            !this._isPstnInterop && this.isPSTNUserInCall && (this._isPstnInterop = !0, this._eventEmitter.emit("callInfoChanged")), !this._isTeamsInterop && this.isTeamsUserInCall && (this._isTeamsInterop = !0, this._eventEmitter.emit("callInfoChanged"));
        }
        threadIdChanged(g) {
            this._tsCall.threadId !== this._threadId && (this._logger.log(`threadId changed from ${this._threadId} to ${g === null || g === void 0 ? void 0 : g.threadId}`), this._threadId = this._tsCall.threadId, this._eventEmitter.emit("threadIdChanged"));
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        onCallInfoChanged(g, f) {
            this._eventEmitter.on(g, f);
        }
        offCallInfoChanged(g, f) {
            this._eventEmitter.off(g, f);
        }
        dispose() {
            var _this__tsCallChangedListener, _this__p2pCallListener, _this__participantUpdatedListener;
            (_this__tsCallChangedListener = this._tsCallChangedListener) === null || _this__tsCallChangedListener === void 0 ? void 0 : _this__tsCallChangedListener.dispose(), this._eventEmitter.removeAllListeners(), (_this__p2pCallListener = this._p2pCallListener) === null || _this__p2pCallListener === void 0 ? void 0 : _this__p2pCallListener.dispose(), (_this__participantUpdatedListener = this._participantUpdatedListener) === null || _this__participantUpdatedListener === void 0 ? void 0 : _this__participantUpdatedListener.dispose();
        }
        constructor(g, f = {}){
            var _f_config;
            this._tsCall = g, this._threadId = this._tsCall.threadId;
            const S = this._tsCall.groupId;
            this._groupId = !S || S.startsWith("19:") || S.startsWith("99:") ? void 0 : S, this._roomId = f === null || f === void 0 ? void 0 : (_f_config = f.config) === null || _f_config === void 0 ? void 0 : _f_config.roomId, this._config = f.config, this._isPstnInterop = !1, this._isTeamsInterop = !1;
        }
    }
    __decorate$j([
        asyncOperation(AS.GetServerCallId),
        __metadata$j("design:type", Function),
        __metadata$j("design:paramtypes", []),
        __metadata$j("design:returntype", Promise)
    ], CallInfoCommonImpl.prototype, "getServerCallId", null);
    class ExplicitConsentCallStateManager {
        dispose() {
            this._isInitialized = !1, this._recordingConsentEnabled = !1, this._consentActivelyRequired = !1, this._localParticipantConsentPublishState = !1, ExplicitConsentCallStateManager.instance = null;
        }
        isConsentRequiredInCall() {
            if (!this._isExplicitConsentEnabled) return !1;
            let g = this._recordingConsentEnabled && !this._localParticipantConsentPublishState;
            return this._logger.info("ExplicitConsentCallStateManager: isConsentRequiredInCall: Recording Consent Enabled: " + this._recordingConsentEnabled + " Local Participant Consent Publish State: " + this._localParticipantConsentPublishState), this._logger.log("ExplicitConsentCallStateManager: isConsentRequiredInCall: " + g), g;
        }
        async consent(g) {
            if (this._isExplicitConsentEnabled) {
                if (g.context === BS.TwoParty) throw this._logger.warn("Consent for recording is not supported for 1:1 calls"), new CallingCommunicationError({
                    defaultError: O.CALL.CONSENT_NOT_SUPPORTED_1TO1
                });
                if (!this.isConsentRequiredInCall()) throw new CallingCommunicationError({
                    defaultError: O.CALL.CONSENT_ALREADY_SET_OR_NOT_REQUIRED
                });
                try {
                    const g = {
                        level: "user",
                        type: "consentToRecording",
                        content: "{}"
                    };
                    if (!await this._tsCall.publishState(g, w.generateCauseId())) throw this._logger.error("Consent failure to set publish state for user"), new CallingCommunicationError({
                        defaultError: O.CALL.FAILED_TO_SET_CONSENT
                    });
                    this._logger.log("ExplicitConsentCallStateManager: Consent for the call provided successfully");
                } catch (g) {
                    throw this._logger.error("Consent failure to set publish state for user on service side"), g;
                }
            }
        }
        areCoreCapabilitiesConsentRestricted() {
            if (!this._isExplicitConsentEnabled) return !1;
            let g = this._consentActivelyRequired && !this._localParticipantConsentPublishState;
            return this._logger.info("ExplicitConsentCallStateManager: areCoreCapabilitiesConsentRestricted: Consent Actively Required: " + this._consentActivelyRequired + " Local Participant Consent Publish State: " + this._localParticipantConsentPublishState), this._logger.log("ExplicitConsentCallStateManager: areCoreCapabilitiesConsentRestricted: " + g), g;
        }
        offConsentRestrictionChanged(g, f) {
            if ("consentRestrictionChanged" !== g) throw new Error("ExplicitConsentCallStateManager: OffConsentRestrictionChanged - Invalid event");
            this._logger.log("ExplicitConsentCallStateManager: Unsubscribing to consentRestrictionChanged event"), this._eventEmitter.off(g, f);
        }
        onConsentRestrictionChanged(g, f) {
            if ("consentRestrictionChanged" !== g) throw new Error("ExplicitConsentCallStateManager: onConsentRestrictionChanged - Invalid event");
            this._logger.log("ExplicitConsentCallStateManager: Subscribing to consentRestrictionChanged event"), this._eventEmitter.on(g, f);
        }
        handleConsentCapabilitiesChanges() {
            this._eventEmitter.emit("consentRestrictionChanged"), this.areCoreCapabilitiesConsentRestricted() && (!this._call.isMuted && this._tsCall.mute().catch((g)=>{
                this._logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping mic", g);
            }), this._call.isLocalVideoStarted && this._tsCall.stopVideo().catch((g)=>{
                this._logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping video", g);
            }), this._call.isScreenSharingOn && this._tsCall.stopScreenSharing().catch((g)=>{
                this._logger.error("ExplicitConsentCallStateManager: Handle Capabilities changes: Error stopping screen sharing", g);
            }), this._logger.log("ExplicitConsentCallStateManager: Handle Capabilities changes: Core capabilities are turned off"));
        }
        initialize(g, f, S, v, _) {
            this._isExplicitConsentEnabled && (this._isInitialized || (this._logger = _.createChild(()=>`Explicit Consent::Call(id='${g.callId}', state='${g.state}')`), this._tsCall = g, this._callAgent = S, this._eventEmitter = v, this._call = f, g.changed(()=>{
                var _g_meetingDetails_recordingConsentDetails, _g_meetingDetails;
                if (!0 === ((_g_meetingDetails = g.meetingDetails) === null || _g_meetingDetails === void 0 ? void 0 : (_g_meetingDetails_recordingConsentDetails = _g_meetingDetails.recordingConsentDetails) === null || _g_meetingDetails_recordingConsentDetails === void 0 ? void 0 : _g_meetingDetails_recordingConsentDetails.explicitRecordingConsentEnabled)) {
                    var _g_meetingDetails_recordingConsentDetails1, _g_meetingDetails1;
                    this._recordingConsentEnabled = !0;
                    const f = !0 === ((_g_meetingDetails1 = g.meetingDetails) === null || _g_meetingDetails1 === void 0 ? void 0 : (_g_meetingDetails_recordingConsentDetails1 = _g_meetingDetails1.recordingConsentDetails) === null || _g_meetingDetails_recordingConsentDetails1 === void 0 ? void 0 : _g_meetingDetails_recordingConsentDetails1.consentActivelyRequired);
                    f !== this._consentActivelyRequired && (this._consentActivelyRequired = f, this.handleConsentCapabilitiesChanges());
                }
            }), g.on("publishedStatesChanged", async (g)=>{
                this._localParticipantConsentPublishState = !1, this._handleConsentStateChange(g);
            }), this._isInitialized = !0));
        }
        _handleConsentStateChange(g) {
            if (!0 !== this._localParticipantConsentPublishState) {
                const S = this._callAgent.getUserMri();
                var f = !1;
                g && this._getPublishedState(g).forEach((g)=>{
                    g.participantStates.forEach((g)=>{
                        if (g.id === S) return this._logger.log("ExplicitConsentCallStateManager: Handle Consent State changes: Local participant has provided the consent"), void (f = !0);
                    });
                }), this._localParticipantConsentPublishState = f, f && this._eventEmitter.emit("consentRestrictionChanged");
            }
        }
        _getPublishedState(g) {
            return g.typeStates.filter((g)=>[
                    "consentToRecording"
                ].includes(g.type));
        }
        constructor(g, f, S, v, _){
            this._recordingConsentEnabled = !1, this._consentActivelyRequired = !1, this._localParticipantConsentPublishState = !1, this._isExplicitConsentEnabled = !1, this._isInitialized = !1, this._isExplicitConsentEnabled = getAcsEcsConfig().calling.explicitConsentFeatureEnabled.enabled, this.initialize(g, f, S, v, _);
        }
    }
    ExplicitConsentCallStateManager.instance = null;
    var Xb, __decorate$k = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$k = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class QualityEventLogManager {
        updateLastRecoveredTime(g) {
            this._lastRecovered = new Date(g.getTime() + this._interval), this._shouldNotifyError = !0, this._shouldNotifyRecovery = !1;
        }
        shouldNotifyError(g) {
            const f = this._lastRecovered < g && this._shouldNotifyError;
            return f && (this._shouldNotifyError = !1, this._shouldNotifyRecovery = !0), f;
        }
        shouldNotifyRecovery(g) {
            const f = this._shouldNotifyRecovery;
            return f && this.updateLastRecoveredTime(g), f;
        }
        constructor(g){
            this._lastRecovered = new Date, this._shouldNotifyError = !0, this._shouldNotifyRecovery = !0, this._interval = 0, this._interval = g;
        }
    }
    class CallCommonImpl {
        get id() {
            return this._id;
        }
        get callerInfo() {
            return {
                identifier: this._callerIdentity,
                displayName: this._callerDisplayName
            };
        }
        get transferorInfo() {
            if (this._transferorIdentity) return {
                identifier: this._transferorIdentity,
                displayName: this._transferorDisplayName
            };
        }
        get state() {
            return this._state;
        }
        get role() {
            return this._role;
        }
        get callEndReason() {
            return this._callEndReason;
        }
        get kind() {
            return this._kind;
        }
        get direction() {
            return this._direction;
        }
        get isMuted() {
            return this._isMuted;
        }
        get isScreenSharingOn() {
            return this._isScreenSharingOn;
        }
        get isLocalVideoStarted() {
            return this._isLocalVideoStarted;
        }
        get localVideoStreams() {
            return this._localVideoStreams;
        }
        get localAudioStreams() {
            return this._localAudioStreams;
        }
        get isIncomingAudioMuted() {
            return this._isIncomingAudioMuted;
        }
        get remoteParticipants() {
            return this._remoteParticipants;
        }
        get totalParticipantCount() {
            return this._totalParticipantCount;
        }
        get lobby() {
            return this._lobby;
        }
        get isAcsTeamsCall() {
            return this._isAcsTeamsCall;
        }
        get isIPAudioEnabled() {
            return this.callInfo.context === BS.TwoParty || this._allowIPAudio;
        }
        get isIPVideoEnabled() {
            return this.callInfo.context === BS.TwoParty || this._allowIPVideo;
        }
        get isCteTeamsCall() {
            return this._isCteTeamsCall;
        }
        subscribeToGetRemoteAudioStream() {
            if (!this._rawAudioStreamChangedSubscription) try {
                const g = this.tsCall.getIncomingRawAudioStream(), populateRemoteAudioStreamCollection = async ()=>{
                    try {
                        if (0 === this._remoteAudioStreams.length) {
                            if (!await g.getMediaStream()) throw new CallingCommunicationError({
                                defaultError: O.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_UNDEFINED
                            });
                            this._remoteAudioStreams.push(new RemoteAudioStreamImpl(g, this._telemetryLogManager, this.id, this.tsCall.participantId)), this._eventEmitter.emit("remoteAudioStreamsUpdated", {
                                added: this._remoteAudioStreams,
                                removed: []
                            });
                        } else if (await g.getMediaStream()) this._eventEmitter.emit("remoteAudioStreamsUpdated", {
                            added: [],
                            removed: []
                        });
                        else {
                            const g = this._remoteAudioStreams[0];
                            g.dispose(), this._remoteAudioStreams = [], this._eventEmitter.emit("remoteAudioStreamsUpdated", {
                                added: [],
                                removed: [
                                    g
                                ]
                            });
                        }
                    } catch (g) {
                        throw new CallingCommunicationError({
                            defaultError: O.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_RETURNED_ERROR,
                            originalError: g
                        });
                    }
                };
                this._rawAudioStreamChangedSubscription = g.changed(()=>{
                    this.logger.info(`Changed fired ${this.tsCall.state}, ${this.state}`), populateRemoteAudioStreamCollection().catch(noop);
                }), populateRemoteAudioStreamCollection().catch(()=>{
                    this.logger.info("Failed to update remote audio stream collection, retrying on changed");
                });
            } catch (g) {
                this.logger.info("Failed to get raw audio stream from the stack");
            }
        }
        get remoteAudioStreams() {
            if (!getAcsEcsConfig().calling.allowAccessRawMediaStream) throw new CallingCommunicationError({
                defaultError: O.CALL.REMOTE_AUDIO_GET_MEDIA_STREAM_DISABLED
            });
            return this._remoteAudioStreams;
        }
        get deviceManager() {
            return this._callAgent.deviceManager;
        }
        get mediaConstraintsManager() {
            return this._mediaConstraintsManager;
        }
        get isHandlingLargeMeetingVideoRendering() {
            return this._isHandlingLargeMeetingVideoRendering;
        }
        get callInfo() {
            return this._callInfo;
        }
        get networkQualityUfdEventDetails() {
            return this._networkQualityUfdEventDetails;
        }
        get acsProxy() {
            return this._callAgent.acsProxy;
        }
        get acsCustomRelayManager() {
            return this._callAgent.acsCustomRelayManager;
        }
        get audioEffectsProcessorStats() {
            return this._audioEffectsProcessorStats;
        }
        get callAgent() {
            return this._callAgent;
        }
        get iceServers() {
            var _this_tsCall_getMediaSessionStats_extensions, _this_tsCall_getMediaSessionStats;
            return this._getIceServersCalledOnce || (this._getIceServersCalledOnce = !0, this._iceServers = (_this_tsCall_getMediaSessionStats = this.tsCall.getMediaSessionStats()) === null || _this_tsCall_getMediaSessionStats === void 0 ? void 0 : (_this_tsCall_getMediaSessionStats_extensions = _this_tsCall_getMediaSessionStats.extensions) === null || _this_tsCall_getMediaSessionStats_extensions === void 0 ? void 0 : _this_tsCall_getMediaSessionStats_extensions.IceServers), this._iceServers;
        }
        get watermarkAudioOnlyFallbackTriggered() {
            return this._watermarkAudioOnlyFallbackTriggered;
        }
        setWatermarkAudioOnlyFallbackTriggered(g) {
            this._watermarkAudioOnlyFallbackTriggered = g, this._eventEmitter.emit("watermarkAudioOnlyFallbackTriggeredChanged");
        }
        async accept(g = {}) {
            var _g_audioOptions, _this__callAgent__caConfigBag, _this__callAgent__caConfigBag1;
            var _g_audioOptions_muted;
            const f = (_g_audioOptions_muted = (_g_audioOptions = g.audioOptions) === null || _g_audioOptions === void 0 ? void 0 : _g_audioOptions.muted) !== null && _g_audioOptions_muted !== void 0 ? _g_audioOptions_muted : !1, S = this.getLocalVideoStreamFromCallOptions(g), v = this.getLocalAudioStreamFromCallOptions(g), _ = +new Date, C = generateGuid(), E = this._callAgent.getEcsConfigIds(), T = parseCustomContext(this.tsCall);
            let I = {
                joinContextDescription: "",
                additionalProperties: {
                    EmergencyCountryCode: ((_this__callAgent__caConfigBag = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.emergencyCountryCode) || "",
                    IsUserEmergencyCountryCode: ((_this__callAgent__caConfigBag1 = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag1 === void 0 ? void 0 : _this__callAgent__caConfigBag1.IsUserEmergencyCountryCode) || !1,
                    trouterState: this._callAgent.getTrouterState(),
                    muted: f,
                    withVideo: this.isIPVideoEnabled && !!S,
                    withAudio: this.isIPAudioEnabled && (v === null || v === void 0 ? void 0 : v.mediaStreamType) ? v === null || v === void 0 ? void 0 : v.mediaStreamType : "",
                    ...getMMRInfo(),
                    AcsCallingSDKWeb_ecsConfigId: E.AcsCallingSDKWeb,
                    SkypeWebMedia_ecsConfigId: E.SkypeWebMedia,
                    customContext: {
                        userToUserPresent: !!(T === null || T === void 0 ? void 0 : T.userToUser),
                        xHeadersPresent: !!(T === null || T === void 0 ? void 0 : T.xHeaders) && T.xHeaders.length > 0
                    }
                },
                additionalDetails: {}
            };
            const handleError = (g, f, E)=>{
                const T = +new Date;
                let b, A = {
                    ...I
                };
                if (f) {
                    const { callEndReason: f, callingCommunicationError: S } = getCallEndReason(this, g);
                    A.additionalDetails.callEndReason = f, b = S;
                } else b = new CallingCommunicationError({
                    defaultError: O.CALL.ACCEPT_INCOMING_CALL,
                    originalError: g
                }), A.additionalDetails.communicationServicesError = extractCommunicationServicesErrorForTelemetry(b).communicationServicesError;
                if (this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_accept_failed,
                    correlationId: C,
                    timestampInfo: {
                        deltaTimeInMs: T - _
                    },
                    additionalPayload: A
                }, b, void 0, E ? xE.getRemoveCauseIdToNetworkInfo(E) : void 0), S) {
                    const g = +new Date;
                    b = new CallingCommunicationError({
                        defaultError: O.LOCAL_VIDEO_STREAM.CALL_NOT_FOUND
                    }), this.logger.error(b.message), this.sendVideoEvent({
                        correlationId: C,
                        eventName: dy.acs_calling_start_video_failure,
                        timestampInfo: {
                            deltaTimeInMs: g - _
                        },
                        localVideoStream: S,
                        step: "accept",
                        isScreenSharingOnFlag: this._isScreenSharingOn
                    }, b), this.removeLocalVideoStream(S);
                }
                return v && this.removeLocalAudioStream(v), b;
            };
            try {
                var _g_videoOptions, _getAcsEcsConfig_calling, _getAcsEcsConfig, _this_acsCustomRelayManager;
                if (g === null || g === void 0 ? void 0 : (_g_videoOptions = g.videoOptions) === null || _g_videoOptions === void 0 ? void 0 : _g_videoOptions.constraints) {
                    var _g_videoOptions1;
                    let f = this._mediaConstraintsManager.getTelemetryPayload({
                        video: g === null || g === void 0 ? void 0 : (_g_videoOptions1 = g.videoOptions) === null || _g_videoOptions1 === void 0 ? void 0 : _g_videoOptions1.constraints
                    });
                    I.additionalProperties.constraints = f;
                }
                this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_accept_attempt,
                    correlationId: C,
                    timestampInfo: {
                        attemptTimestamp: _
                    },
                    additionalPayload: I
                });
                let E = {
                    ...I
                };
                if (S && this.setLocalVideoStream(S), this.setLocalAudioStream(v), S && this.sendVideoEvent({
                    eventName: dy.acs_calling_start_video_attempt,
                    timestampInfo: {
                        attemptTimestamp: _
                    },
                    correlationId: C,
                    step: "accept",
                    isScreenSharingOnFlag: this._isScreenSharingOn
                }), 1 !== this.tsCall.state) throw new CallingCommunicationError({
                    defaultError: O.CALL.ACCEPT_NOT_RINGING
                });
                try {
                    var _g_videoOptions2;
                    if (g === null || g === void 0 ? void 0 : (_g_videoOptions2 = g.videoOptions) === null || _g_videoOptions2 === void 0 ? void 0 : _g_videoOptions2.constraints) {
                        var _g_videoOptions3;
                        const f = await this._mediaConstraintsManager.setVideoConstraints(g === null || g === void 0 ? void 0 : (_g_videoOptions3 = g.videoOptions) === null || _g_videoOptions3 === void 0 ? void 0 : _g_videoOptions3.constraints, "accept", C, _), S = this._mediaConstraintsManager.getTelemetryPayload({
                            video: f
                        });
                        E.additionalProperties.constraints = S;
                    }
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.CALL.ACCEPT_VIDEO_CONSTRAINTS,
                        originalError: g
                    });
                    this.logger.error(`${f.message}`);
                }
                const T = {
                    withVideo: !!S && this.isIPVideoEnabled,
                    muted: f
                };
                if (f && (T.muteFlags = 1), ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.enableCustomTurnUsage) && ((_this_acsCustomRelayManager = this.acsCustomRelayManager) === null || _this_acsCustomRelayManager === void 0 ? void 0 : _this_acsCustomRelayManager.customRelayManagerInUse) && (T.mediaConfiguration = {
                    connectionType: "NoDirectConnection"
                }), v && await this.startAudioInternal(v, !0).catch((g)=>{
                    this.logger.error(`Failed to start localAudioStream, message=${g === null || g === void 0 ? void 0 : g.message}`);
                }), "RawMedia" === (S === null || S === void 0 ? void 0 : S.mediaStreamType)) try {
                    await this._setRawStream(S, 1);
                } catch (g) {
                    const f = +new Date, v = new CallingCommunicationError({
                        defaultError: O.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,
                        originalError: g
                    });
                    this.sendVideoEvent({
                        correlationId: C,
                        eventName: dy.acs_calling_media_stream,
                        timestampInfo: {
                            deltaTimeInMs: f - _
                        },
                        localVideoStream: S,
                        step: "accept",
                        isScreenSharingOnFlag: this._isScreenSharingOn
                    }, v), this.removeLocalVideoStream(S);
                }
                const b = w.generateCauseId();
                return xE.setCauseIdToNetworkInfo(b), this.tsCall.accept(T, b).then(async ()=>{
                    const g = +new Date;
                    S && this.shallRemoveLvsAfterConnectedSuccessfully(S, "accept", C, g, _), v && this.shallRemoveLasAfterConnectedSuccessfully(v, "accept", C, g, _), this.sendCallStageEvent({
                        eventName: dy.acs_calling_call_accept_connected,
                        correlationId: C,
                        timestampInfo: {
                            deltaTimeInMs: g - _
                        },
                        additionalPayload: E
                    }, void 0, void 0, xE.getRemoveCauseIdToNetworkInfo(b));
                }).catch((g)=>{
                    handleError(g, !0, b);
                }), this;
            } catch (g) {
                throw handleError(g, !1);
            }
        }
        async reject() {
            var _this__callAgent__caConfigBag, _this__callAgent__caConfigBag1;
            const g = +new Date, f = generateGuid();
            this.sendCallStageEvent({
                eventName: dy.acs_calling_call_reject_attempt,
                correlationId: f,
                timestampInfo: {
                    attemptTimestamp: g
                }
            });
            const S = this._callAgent.getEcsConfigIds(), v = {
                additionalProperties: {
                    EmergencyCountryCode: ((_this__callAgent__caConfigBag = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.emergencyCountryCode) || "",
                    IsUserEmergencyCountryCode: ((_this__callAgent__caConfigBag1 = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag1 === void 0 ? void 0 : _this__callAgent__caConfigBag1.IsUserEmergencyCountryCode) || !1,
                    trouterState: this._callAgent.getTrouterState(),
                    AcsCallingSDKWeb_ecsConfigId: S.AcsCallingSDKWeb,
                    SkypeWebMedia_ecsConfigId: S.SkypeWebMedia
                },
                additionalDetails: {}
            };
            if (1 !== this.tsCall.state) {
                const S = new CallingCommunicationError({
                    defaultError: O.CALL.REJECT_NOT_RINGING
                });
                v.additionalDetails.communicationServicesError = extractCommunicationServicesErrorForTelemetry(S).communicationServicesError;
                const _ = +new Date;
                throw this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_reject_failed,
                    correlationId: f,
                    timestampInfo: {
                        deltaTimeInMs: _ - g
                    },
                    additionalPayload: v
                }, S), S;
            }
            const _ = w.generateCauseId();
            return xE.setCauseIdToNetworkInfo(_), this.tsCall.reject(_).then(()=>{
                const S = +new Date;
                this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_reject_success,
                    correlationId: f,
                    timestampInfo: {
                        deltaTimeInMs: S - g
                    }
                }, void 0, void 0, xE.getRemoveCauseIdToNetworkInfo(_));
            }).catch((S)=>{
                const C = +new Date, { callEndReason: E, callingCommunicationError: T } = getCallEndReason(this, S);
                throw v.additionalDetails.callEndReason = E, this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_reject_failed,
                    correlationId: f,
                    timestampInfo: {
                        deltaTimeInMs: C - g
                    },
                    additionalPayload: v
                }, T, void 0, xE.getRemoveCauseIdToNetworkInfo(_)), T;
            });
        }
        dispose() {
            var _this__selectedDeviceManager;
            this._disposed || (this._dmDevicesChangedSub && this._dmDevicesChangedSub.dispose(), this._dmDevicesChangedSub = void 0, this._extensibleApi.dispose(), this._eventEmitter.removeAllListeners(), this._onlineListener && window.removeEventListener("online", this._onlineListener), this._offlineListener && window.removeEventListener("offline", this._offlineListener), this._trouterStateChangedListener && this._callAgent.offTrouterStateChanged(this._trouterStateChangedListener), this._mmrRdpConnectionManager.dispose(), (_this__selectedDeviceManager = this._selectedDeviceManager) === null || _this__selectedDeviceManager === void 0 ? void 0 : _this__selectedDeviceManager.dispose(), this.explicitConsentStateImp.dispose(), this._disposed = !0);
        }
        async startAudioInternal(g, f = !1) {
            const S = generateGuid(), v = +new Date, _ = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(_);
            try {
                var _this__callAgent_tsStack, _getAcsEcsConfig_calling, _getAcsEcsConfig;
                if (this.isInternalApiCallWithoutRawMedia(g, f)) return;
                this.sendRawMediaEvent({
                    eventName: dy.acs_calling_start_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    kindOfEvent: uy.attempt,
                    isInternal: f,
                    timestampInfo: "",
                    additionalDetails: ""
                }), this.validateRawMedia(g, O.CALL.START_AUDIO_LAS_NOT_RAW_MEDIA), this._userProvidedLocalAudioStreamCache = g;
                const C = await this.createMediaStream(g), E = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager();
                if (!((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.allowAccessRawMediaStream) || !(E === null || E === void 0 ? void 0 : E.setRawMediaStream)) throw new CallingCommunicationError({
                    defaultError: O.CALL.LOCAL_AUDIO_SET_MEDIA_STREAM
                });
                E === null || E === void 0 ? void 0 : E.setRawMediaStream(C, 0), this.removeLocalAudioStream(this.localAudioStreams[0]), this.setLocalAudioStream(g);
                const T = +new Date;
                this.sendRawMediaEvent({
                    eventName: dy.acs_calling_start_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    kindOfEvent: uy.success,
                    isInternal: f,
                    localAudioStream: this.localAudioStreams[0],
                    timestampInfo: {
                        deltaTimeInMs: T - v
                    },
                    additionalDetails: {
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                    }
                });
            } catch (g) {
                const C = new CallingCommunicationError({
                    defaultError: O.CALL.START_AUDIO_STREAM_FAILED,
                    originalError: g
                });
                this.logger.error(`Failed to start raw media audio: ${C.message}`);
                const E = +new Date;
                throw this.sendRawMediaEvent({
                    eventName: dy.acs_calling_start_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    isInternal: f,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: E - v
                    },
                    additionalDetails: {
                        failureReason: C.message || "",
                        code: C.code,
                        subCode: C.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(C),
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                    }
                }), C;
            }
        }
        isInternalApiCallWithoutRawMedia(g, f) {
            return !("RawMedia" === (g === null || g === void 0 ? void 0 : g.mediaStreamType) || !f) && (this.logger.info("startAudioInternal internal call: LocalAudioStream media type is raw media, skipping raw audio startAudioInternal"), !0);
        }
        validateRawMedia(g, f) {
            if ("RawMedia" !== (g === null || g === void 0 ? void 0 : g.mediaStreamType)) throw new CallingCommunicationError({
                defaultError: f
            });
        }
        async createMediaStream(g) {
            let f;
            try {
                f = await g.getMediaStream();
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.CALL.LOCAL_AUDIO_GET_MEDIA_STREAM,
                    originalError: g
                });
            }
            return new MediaStream(f);
        }
        stopAudioInternal(g = !1) {
            const f = generateGuid(), S = +new Date, v = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(v);
            try {
                var _this__callAgent_tsStack, _getAcsEcsConfig_calling, _getAcsEcsConfig;
                const _ = this._localAudioStreams[0];
                if (this.isInternalApiCallWithoutRawMedia(_, g)) return;
                this.sendRawMediaEvent({
                    eventName: dy.acs_calling_stop_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    kindOfEvent: uy.attempt,
                    isInternal: g,
                    timestampInfo: "",
                    additionalDetails: ""
                }), g || validateCallConnected(IS.StopAudio, this.state), this.validateRawMedia(_, O.CALL.STOP_AUDIO_LAS_NOT_RAW_MEDIA);
                const C = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager();
                if (!((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.allowAccessRawMediaStream) || !(C === null || C === void 0 ? void 0 : C.unsetRawMediaStream)) throw new CallingCommunicationError({
                    defaultError: O.CALL.LOCAL_AUDIO_UNSET_MEDIA_STREAM
                });
                C.unsetRawMediaStream(0), this._userProvidedLocalAudioStreamCache = void 0, this.removeLocalAudioStream(this.localAudioStreams[0]), this.setLocalAudioStream();
                const E = +new Date;
                this.sendRawMediaEvent({
                    eventName: dy.acs_calling_stop_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    kindOfEvent: uy.success,
                    isInternal: g,
                    localAudioStream: this.localAudioStreams[0],
                    timestampInfo: {
                        deltaTimeInMs: E - S
                    },
                    additionalDetails: {
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(v)
                    }
                });
            } catch (_) {
                const C = new CallingCommunicationError({
                    defaultError: O.CALL.STOP_AUDIO_STREAM_FAILED,
                    originalError: _
                });
                this.logger.error(`Failed to stop raw media audio: ${C.message}`);
                const E = +new Date;
                throw this.sendRawMediaEvent({
                    eventName: dy.acs_calling_stop_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    isInternal: g,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: E - S
                    },
                    additionalDetails: {
                        failureReason: C.message || "",
                        code: C.code,
                        subCode: C.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(C),
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(v)
                    }
                }), C;
            }
        }
        bindTsCall() {
            var _this_tsCall_participants_find, _this_tsCall_participants_find1, _this_tsCall_participants_find2, _this_tsCall_participants, _this_tsCall;
            void 0 !== this.tsCall.callerMri && (this._callerIdentity = constructIdentifierKindFromMri(this.tsCall.callerMri), this._callerDisplayName = (_this_tsCall_participants_find = this.tsCall.participants.find((g)=>g.id === this.tsCall.callerMri)) === null || _this_tsCall_participants_find === void 0 ? void 0 : _this_tsCall_participants_find.displayName), this._lastTsCallState = this.tsCall.state, this.mapTsCallState(this.tsCall.state), this._setCallRole(this.tsCall.advancedMeetingRole), this.tsCall.callQueueInfo ? (this._callerIdentity = constructIdentifierKindFromMri(this.tsCall.callQueueInfo.onBehalfOf.id), this._callerDisplayName = this.tsCall.callQueueInfo.onBehalfOf.displayName ? this.tsCall.callQueueInfo.onBehalfOf.displayName : (_this_tsCall_participants_find1 = this.tsCall.participants.find((g)=>{
                var _this_tsCall_callQueueInfo;
                return g.id === ((_this_tsCall_callQueueInfo = this.tsCall.callQueueInfo) === null || _this_tsCall_callQueueInfo === void 0 ? void 0 : _this_tsCall_callQueueInfo.details.id);
            })) === null || _this_tsCall_participants_find1 === void 0 ? void 0 : _this_tsCall_participants_find1.displayName, this._transferorIdentity = constructIdentifierKindFromMri(this.tsCall.callQueueInfo.details.id), this._transferorDisplayName = this.tsCall.callQueueInfo.details.displayName ? this.tsCall.callQueueInfo.details.displayName : (_this_tsCall_participants_find2 = this.tsCall.participants.find((g)=>{
                var _this_tsCall_callQueueInfo;
                return g.id === ((_this_tsCall_callQueueInfo = this.tsCall.callQueueInfo) === null || _this_tsCall_callQueueInfo === void 0 ? void 0 : _this_tsCall_callQueueInfo.details.id);
            })) === null || _this_tsCall_participants_find2 === void 0 ? void 0 : _this_tsCall_participants_find2.displayName) : this.tsCall.transferorMri && (this._transferorIdentity = constructIdentifierKindFromMri(this.tsCall.transferorMri), this._transferorDisplayName = this.tsCall.transferorDisplayName), this.updateCallMode(), this.tsCall.changed(()=>{
                var _this_tsCall_meetingData, _this_tsCall_meetingData1;
                this.tsCall.callId !== this._id && (this.logger.log(`tsCall callId changed from ${this._id} to ${this.tsCall.callId}`), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                    ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                    step: "id-changed",
                    isAcsTeamsCall: this.isAcsTeamsCall,
                    oldCallId: this._id,
                    newCallId: this.tsCall.callId
                }), this._id = this.tsCall.callId, this._eventEmitter.emit("idChanged")), this.tsCall.state !== this._lastTsCallState && (this.logger.log(`tsCall state changed=${this.tsCall.state}`), this._lastTsCallState = this.tsCall.state, this.mapTsCallState(this.tsCall.state), this._handleMuteChanges()), this._isScreenSharingOn !== this.tsCall.isScreenSharingOn && (this.logger.log(`tsCall isScreenSharingOn changed=${this.tsCall.isScreenSharingOn}`), this._isScreenSharingOn = this.tsCall.isScreenSharingOn, this._isScreenSharingOn || this.removeScreenSharingStream(), this._eventEmitter.emit("isScreenSharingOnChanged")), this._isMicrophoneMuted !== this.tsCall.isMuted && (this.logger.log(`tsCall isMuted changed=${this.tsCall.isMuted}`), this._isMicrophoneMuted = this.tsCall.isMuted, this._handleMuteChanges()), this._isSpeakerMuted !== this.tsCall.isSpeakerMuted && (this.logger.log(`tsCall _isSpeakerMuted changed=${this.tsCall.isSpeakerMuted}`), this._isSpeakerMuted = this.tsCall.isSpeakerMuted, this._handleIncomingAudioMuteChanges()), this.tsCall.advancedMeetingRole !== this._lastTsCallAdvancedMeetingRole && (this.logger.log(`tsCall advancedMeetingRole changed=${this.tsCall.advancedMeetingRole}`), this._setCallRole(this.tsCall.advancedMeetingRole)), (((_this_tsCall_meetingData = this.tsCall.meetingData) === null || _this_tsCall_meetingData === void 0 ? void 0 : _this_tsCall_meetingData.meetingUrl) || ((_this_tsCall_meetingData1 = this.tsCall.meetingData) === null || _this_tsCall_meetingData1 === void 0 ? void 0 : _this_tsCall_meetingData1.passcode) || "scheduledMeeting" == this.tsCall.conversationType) && this.tsCall.meetingDetails && hasMeetingDetailsChanged(this.tsCall.meetingDetails, this._lastTsCallMeetingDetails) && this._setMeetingCapabilities(this.tsCall.meetingDetails), this.updateCallMode(), this.optimalVideoCountChanged();
            }), this.tsCall.on("serverMutedChanged", ()=>{
                this.logger.log(`tsCall isServerMuted changed=${this.tsCall.isServerMuted}`), this._handleMuteChanges();
            }), this._totalParticipantCount = getTotalNotBotParticipantCount(this.tsCall), this.tsCall.on("participantCountsUpdated", ()=>{
                const g = getTotalNotBotParticipantCount(this.tsCall);
                if (this._totalParticipantCount !== g) {
                    const f = this._totalParticipantCount;
                    this._totalParticipantCount = g, this.logger.log(`tsCall totalParticipantCount changed from ${f} to ${this._totalParticipantCount}`), getAcsEcsConfig().rendering.remoteVideo.largeMeeting.handleVideoRendering && this._enableOrDisable_largeMeeting_videoRendering(), this._eventEmitter.emit("totalParticipantCountChanged");
                    try {
                        this.stats.recordEvent({
                            name: cy.number_of_participants,
                            callId: this.id,
                            localParticipantId: this.tsCall.participantId,
                            data: {
                                totalParticipantCount: this._totalParticipantCount,
                                participantCounts: this.tsCall.participantCounts || {},
                                previousParticipantCount: f
                            }
                        });
                    } catch (g) {
                        this.logger.error("failed to send participant count change telemetry");
                    }
                }
            });
            const transportStateChanged = (g, f)=>{
                if (g !== f) {
                    this.logger.log(`transportState changed from ${this._transportState} to ${f}`);
                    const S = void 0 === this._transportStateTimestamp.get("Connected") ? this._connectedTimestamp : void 0;
                    this._transportStateTimestamp.delete(f);
                    const v = P.omitBy({
                        connectedTimetamp: S,
                        transportConnectedTimestamp: this._transportStateTimestamp.get("Connected"),
                        transportDisconnectedTimestamp: this._transportStateTimestamp.get("Disconnected"),
                        transportFailedTimestamp: this._transportStateTimestamp.get("Failed")
                    }, P.isUndefined), _ = P.merge(getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription), {
                        timestampInfo: v
                    });
                    sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                        ..._,
                        step: "transportState-changed",
                        oldState: g,
                        newState: f
                    }), this._transportStateTimestamp.set(f, Date.now()), this._transportState = f;
                }
            };
            this.tsCall.on("transportConnected", ()=>{
                transportStateChanged(this._transportState, "Connected");
            }), this.tsCall.on("transportDisconnected", ()=>{
                transportStateChanged(this._transportState, "Disconnected");
            }), this.tsCall.on("transportFailed", ()=>{
                transportStateChanged(this._transportState, "Failed");
            }), this.tsCall.on("callQualityChanged", async (g)=>{
                try {
                    let f, S;
                    if (5 === g.type || 32 === g.type || 2 === g.type || 1 === g.type || 37 === g.type ? (f = cy.network_quality, this._trackNetworkQualityUfdEventDetails(g.type)) : 44 === g.type || 43 === g.type || 9 === g.type || 25 === g.type || 45 === g.type || 33 === g.type || 34 === g.type || 55 === g.type || 26 === g.type || 47 === g.type ? f = cy.video_device_issue : 27 === g.type ? (S = !0, f = cy.video_device_issue) : f = cy.other_diagnostic, 3 === g.value || 2 === g.value) {
                        if (S && !this._speakingWhileMutedManager.shouldNotifyError(new Date)) return;
                        this.logger.warn(`Ufd error raised!, ufd=${g.type}, value=${g.value}, kind=${f}`), f === cy.network_quality && window.dispatchEvent(new CustomEvent("online", {
                            detail: !1
                        }));
                    } else {
                        if (S && !this._speakingWhileMutedManager.shouldNotifyRecovery(new Date)) return;
                        this.logger.warn(`Ufd error recovered!, ufd=${g.type}, value=${g.value}, kind=${f}`), f === cy.network_quality && window.dispatchEvent(new CustomEvent("online", {
                            detail: !0
                        }));
                    }
                    let v = "";
                    const _ = this._ufdsCorrelationIdCache[g.type][g.mediaType];
                    3 == g.value || 2 == g.value ? _ ? v = _ : (v = generateGuid(), this._ufdsCorrelationIdCache[g.type][g.mediaType] = v) : (_ && (v = _), this._ufdsCorrelationIdCache[g.type][g.mediaType] = void 0);
                    const C = {
                        type: g.type.toString(),
                        level: g.value,
                        mediaType: g.mediaType,
                        correlationId: v
                    };
                    if (this.stats.recordEvent({
                        name: f,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        data: C
                    }), this.shallStopVideo(g)) {
                        const f = +new Date, S = generateGuid();
                        this.logger.warn(`Attempting to stop video gracefully due to video ufd being raised.UFD: ${g.type}, value: ${g.value}, call direction: ${this._direction}`), this.sendAudioEvent({
                            eventName: dy.acs_calling_stop_video_on_ufd_attempt,
                            timestampInfo: {
                                attemptTimestamp: f
                            },
                            correlationId: S,
                            step: "mid-call"
                        });
                        try {
                            this.localVideoStream && this.stopVideo(this.localVideoStream);
                        } catch (f) {
                            const S = `Failed to stop video on video device start failed or capture mute event ${g.type} with value ${g.value}`;
                            this.logger.error(S);
                        }
                    }
                    if (this.shallRemoveLocalVideoStreamOnBadUfd(g)) {
                        const f = new CallingCommunicationError({
                            defaultError: O.CALL.REMOVE_LOCAL_VIDEO_ON_BAD_UFD,
                            defaultErrorMessageArgs: [
                                g.type,
                                g.value,
                                this._direction
                            ]
                        });
                        this.localVideoStream && (this.sendVideoEvent({
                            eventName: dy.acs_calling_start_video_failure,
                            correlationId: generateGuid(),
                            timestampInfo: {
                                attemptTimestamp: +new Date
                            },
                            step: "start",
                            additionalDetails: {
                                ...extractCommunicationServicesErrorForTelemetry(f)
                            },
                            localVideoStream: this.localVideoStream,
                            isScreenSharingOnFlag: this.isScreenSharingOn
                        }, f), this.removeLocalVideoStream(this.localVideoStream)), this.logger.error(f.message);
                    }
                    if (this.shallStopAudio(g)) {
                        var _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig_calling1, _getAcsEcsConfig1, _getAcsEcsConfig_calling2, _getAcsEcsConfig2;
                        const f = +new Date, S = generateGuid();
                        if (((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.allowMuteOnBadUfd) && !this.tsCall.isMuted) {
                            this.sendAudioEvent({
                                eventName: dy.acs_calling_mute_on_ufd_attempt,
                                timestampInfo: {
                                    attemptTimestamp: f
                                },
                                correlationId: S,
                                step: "mid-call"
                            });
                            try {
                                await this.mute();
                            } catch (f) {
                                const S = `Failed to mute on microphone device not functioning or capture mute event ${g.type} with value ${g.value}`;
                                this.logger.error(S);
                            }
                        }
                        const v = (_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_calling1 = _getAcsEcsConfig1.calling) === null || _getAcsEcsConfig_calling1 === void 0 ? void 0 : _getAcsEcsConfig_calling1.preventStopAudio;
                        if (v) return this.sendAudioEvent({
                            eventName: dy.acs_calling_prevent_stop_audio,
                            timestampInfo: {
                                attemptTimestamp: f
                            },
                            correlationId: S,
                            step: "mid-call"
                        }), void (!((_getAcsEcsConfig2 = getAcsEcsConfig()) === null || _getAcsEcsConfig2 === void 0 ? void 0 : (_getAcsEcsConfig_calling2 = _getAcsEcsConfig2.calling) === null || _getAcsEcsConfig_calling2 === void 0 ? void 0 : _getAcsEcsConfig_calling2.preventFakeMute) && this.markCallMuted());
                        this.sendAudioEvent({
                            eventName: dy.acs_calling_stop_audio_attempt,
                            timestampInfo: {
                                attemptTimestamp: f
                            },
                            correlationId: S,
                            step: "mid-call"
                        });
                        try {
                            await this.tsCall.stopAudio(), this.markCallMuted();
                            const g = +new Date;
                            this.sendAudioEvent({
                                eventName: dy.acs_calling_stop_audio_success,
                                timestampInfo: {
                                    deltaTimeInMs: g - f
                                },
                                correlationId: S,
                                step: "mid-call"
                            });
                        } catch (v) {
                            const _ = new CallingCommunicationError({
                                defaultError: O.CALL.STOP_AUDIO_ON_BAD_UFD,
                                defaultErrorMessageArgs: [
                                    g.type,
                                    g.value
                                ],
                                originalError: v
                            });
                            this.logger.error(_.message);
                            const C = +new Date;
                            this.sendAudioEvent({
                                eventName: dy.acs_calling_stop_audio_failure,
                                timestampInfo: {
                                    deltaTimeInMs: C - f
                                },
                                correlationId: S,
                                step: "mid-call"
                            }, _);
                        }
                    }
                    this.muteUnmuteOnMicrophoneNotFunctioningUfd(g), this.audioDidAutoRecover(g) && (this._isDeviceNotFunctioningMuted = !1, this._handleMuteChanges());
                } catch (g) {
                    this.logger.error("Failed to send ufd telemetry");
                }
            }), this.tsCall.on("participantAdded", async (g)=>{
                var _g_endpoints;
                this.logger.debug("tsCall participant added");
                const f = [];
                (_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails.forEach((g)=>f.push(g.participantId)), 0 === f.length && f.push("remoteParticipantId unavailable");
                const S = constructIdentifierKindFromMri(g.id);
                if (this._isCteTeamsCall = this._isCteTeamsCall || "microsoftTeamsUser" === S.kind, this.sendParticipantAddedOrRemovedEvent({
                    remoteParticipantIds: f,
                    participantAddedOrRemoved: "added",
                    kindOfEvent: uy.event
                }), isHiddenBot(g)) this.logger.info("Add participant: Handle hidden calling application");
                else {
                    this._handleLocalRingingCallState(g);
                    try {
                        const f = this.getOrCreateRemoteParticipant(S, g);
                        this._eventEmitter.emit("remoteParticipantsUpdated", {
                            added: [
                                f
                            ],
                            removed: []
                        });
                    } catch (g) {
                        this.logger.log("unable to map call participant to ACS user");
                    }
                }
            }), this.logger.debug(`tsCall current participant count=${(_this_tsCall = this.tsCall) === null || _this_tsCall === void 0 ? void 0 : (_this_tsCall_participants = _this_tsCall.participants) === null || _this_tsCall_participants === void 0 ? void 0 : _this_tsCall_participants.length}`);
            const addParticipantOnCallInit = (g)=>{
                const f = constructIdentifierKindFromMri(g.id);
                this._isCteTeamsCall = this._isCteTeamsCall || "microsoftTeamsUser" === f.kind;
                const S = this.getOrCreateRemoteParticipant(f, g);
                this._handleLocalRingingCallState(g), S.on("displayNameChanged", ()=>{
                    this._callerIdentity && getMriFromIdentifier(this._callerIdentity) === getMriFromIdentifier(S.identifier) && (this._callerDisplayName = S.displayName, this._eventEmitter.emit("callerInfoChanged")), this._transferorIdentity && getMriFromIdentifier(this._transferorIdentity) === getMriFromIdentifier(S.identifier) && (this._transferorDisplayName = S.displayName, this._eventEmitter.emit("transferorInfoChanged"));
                });
            }, g = [];
            this.tsCall.participants.forEach((f)=>{
                getAcsEcsConfig().calling.checkHiddenBotOnCallStart && isHiddenBot(f) || addParticipantOnCallInit(f);
                try {
                    var _f_endpoints;
                    (_f_endpoints = f.endpoints) === null || _f_endpoints === void 0 ? void 0 : _f_endpoints.endpointDetails.forEach((f)=>g.push(f.participantId));
                } catch (g) {
                    this.logger.error("Unable to get participantId from from remote participant");
                }
            });
            try {
                this.sendParticipantAddedOrRemovedEvent({
                    remoteParticipantIds: g,
                    participantAddedOrRemoved: "added",
                    kindOfEvent: uy.initialize
                });
            } catch (g) {
                this.logger.error("Unable to send participant added telemtery");
            }
            this.tsCall.on("participantRemoved", async (g)=>{
                var _g_endpoints;
                this.logger.debug("tsCall participant removed");
                const f = [];
                if ((_g_endpoints = g.endpoints) === null || _g_endpoints === void 0 ? void 0 : _g_endpoints.endpointDetails.forEach((g)=>f.push(g.participantId)), 0 === f.length && f.push("remoteParticipantId unavailable"), isHiddenBot(g)) return this.logger.info("Remove participant: Ignore calling application"), void this.sendParticipantAddedOrRemovedEvent({
                    remoteParticipantIds: f,
                    participantAddedOrRemoved: "removed",
                    kindOfEvent: uy.event
                });
                const S = g.id;
                if (S) {
                    const v = this._remoteParticipants.find((g)=>getMriFromIdentifier(g.identifier) === S);
                    if (v) {
                        const { callEndReason: S } = getRemoteParticipantCallEndReason(this, g);
                        v.setCallEndReason(S), this.deleteRemoteParticipant(v), this._eventEmitter.emit("remoteParticipantsUpdated", {
                            added: [],
                            removed: [
                                v
                            ]
                        }), this.sendParticipantAddedOrRemovedEvent({
                            remoteParticipantIds: f,
                            participantAddedOrRemoved: "removed",
                            kindOfEvent: uy.event,
                            additionalDetails: {
                                ...extractCallEndReasonForTelemetry(S)
                            }
                        });
                    } else this.logger.log("unable to find participant to remove");
                }
            });
        }
        _trackNetworkQualityUfdEventDetails(g) {
            const f = +new Date;
            let S = "";
            switch(g){
                case 5:
                    S = tE;
                    break;
                case 32:
                    S = rE;
                    break;
                case 2:
                    S = iE;
                    break;
                case 1:
                    S = nE;
                    break;
                case 37:
                    S = aE;
            }
            this._networkQualityUfdEventDetails.push({
                eventName: S,
                timestampInfo: f
            });
        }
        async muteUnmuteOnMicrophoneNotFunctioningUfd(g) {
            try {
                const f = getAcsEcsConfig().calling;
                if (!f.muteUnmuteOnMicrophoneNotFunctioning || this._isMuted || 9 !== g.type || 3 !== g.value) return;
                this.__attemptedToRecoverMicNotFunctioningBySDK = !0, await this.mute(), f.unmuteDelayForMicrophoneNotFunctioningInMs >= 0 && await sleep(f.unmuteDelayForMicrophoneNotFunctioningInMs), await this.unmute();
            } catch (g) {
                this.logger.info("Unable to perform mute and unmute to recover microphoneNotFunctioning", g);
            } finally{
                this.__attemptedToRecoverMicNotFunctioningBySDK = !1;
            }
        }
        updateCallMode() {
            this.tsCall.callMode && this._callMode !== this.tsCall.callMode && (this.logger.log(`tsCall callMode changed from ${this._callMode} to ${this.tsCall.callMode}`), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                step: "callMode-changed",
                oldState: Gy[this._callMode],
                newState: Gy[this.tsCall.callMode]
            }), this._callMode = this.tsCall.callMode);
        }
        async startCallInternal(g, f, S, v) {
            var _g_audioOptions, _this__callAgent__caConfigBag, _this__callAgent__caConfigBag1, _g_customContext, _g_customContext1, _g_firstPartyOptions, _g_videoOptions, _g_videoOptions1, _v_meetingInfo;
            const _ = !!(g === null || g === void 0 ? void 0 : (_g_audioOptions = g.audioOptions) === null || _g_audioOptions === void 0 ? void 0 : _g_audioOptions.muted), C = this.getLocalVideoStreamFromCallOptions(g), E = this.getLocalAudioStreamFromCallOptions(g);
            let T;
            const I = +new Date, b = generateGuid();
            this._joinContextDescription = getJoinContextDescription(S);
            const A = this._callAgent.getEcsConfigIds(), R = 1 === this.tsCall.participants.length && !this.tsCall.threadId && !f, P = !!R || this._allowIPAudio, M = !!R || this._allowIPVideo, D = {
                joinContextDescription: this._joinContextDescription,
                additionalProperties: {
                    EmergencyCountryCode: ((_this__callAgent__caConfigBag = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.emergencyCountryCode) || "",
                    IsUserEmergencyCountryCode: ((_this__callAgent__caConfigBag1 = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag1 === void 0 ? void 0 : _this__callAgent__caConfigBag1.IsUserEmergencyCountryCode) || !1,
                    IsEmergencyCall: (v === null || v === void 0 ? void 0 : v.isEmergency) || !1,
                    trouterState: this._callAgent.getTrouterState(),
                    muted: _,
                    withVideo: M && !!C,
                    withAudio: P && (E === null || E === void 0 ? void 0 : E.mediaStreamType) ? E.mediaStreamType : "",
                    ...getMMRInfo(),
                    AcsCallingSDKWeb_ecsConfigId: A.AcsCallingSDKWeb,
                    SkypeWebMedia_ecsConfigId: A.SkypeWebMedia,
                    customContext: {
                        userToUserPresent: !!(g === null || g === void 0 ? void 0 : (_g_customContext = g.customContext) === null || _g_customContext === void 0 ? void 0 : _g_customContext.userToUser),
                        xHeadersPresent: !!(g === null || g === void 0 ? void 0 : (_g_customContext1 = g.customContext) === null || _g_customContext1 === void 0 ? void 0 : _g_customContext1.xHeaders) && g.customContext.xHeaders.length > 0
                    },
                    firstPartyOptions: {
                        isDeviceTypeEnabled: getAcsEcsConfig().calling.setDeviceType,
                        deviceType: this._callAgent.getDeviceType(),
                        isImmersiveMode: g === null || g === void 0 ? void 0 : (_g_firstPartyOptions = g.firstPartyOptions) === null || _g_firstPartyOptions === void 0 ? void 0 : _g_firstPartyOptions.isImmersiveMode
                    }
                },
                additionalDetails: {}
            };
            (g === null || g === void 0 ? void 0 : (_g_videoOptions = g.videoOptions) === null || _g_videoOptions === void 0 ? void 0 : _g_videoOptions.constraints) && (D.additionalProperties.constraints = this._mediaConstraintsManager.getTelemetryPayload({
                video: g === null || g === void 0 ? void 0 : (_g_videoOptions1 = g.videoOptions) === null || _g_videoOptions1 === void 0 ? void 0 : _g_videoOptions1.constraints
            })), (v === null || v === void 0 ? void 0 : (_v_meetingInfo = v.meetingInfo) === null || _v_meetingInfo === void 0 ? void 0 : _v_meetingInfo.tenantId) && (this._teamsMeetingTenantId = v.meetingInfo.tenantId, D.additionalProperties.teamsMeetingTenantId = v.meetingInfo.tenantId), (v === null || v === void 0 ? void 0 : v.threadId) && (this._teamsMeetingThreadId = v.threadId, D.additionalProperties.teamsMeetingThreadId = v.threadId), (v === null || v === void 0 ? void 0 : v.onBehalfOf) && (D.additionalProperties.onBehalfOfProvided = !0, D.additionalProperties.onBehalfOfIdKind = constructIdentifierKindFromMri(v.onBehalfOf).kind), this.sendCallStageEvent({
                eventName: dy.acs_calling_call_attempt,
                correlationId: b,
                timestampInfo: {
                    attemptTimestamp: I
                },
                additionalPayload: D
            });
            let N = {
                ...D
            }, k = {
                ...D
            };
            try {
                this._isMicrophoneMuted = _, (g === null || g === void 0 ? void 0 : g.alternateCallerId) && (T = getMriFromIdentifier(g.alternateCallerId)), C && this.setLocalVideoStream(C), this.setLocalAudioStream(E);
            } catch (g) {
                const f = +new Date, S = new CallingCommunicationError({
                    defaultError: O.CALL.INSTANTIATE_CALL,
                    originalError: g
                });
                throw N.additionalDetails.communicationServicesError = extractCommunicationServicesErrorForTelemetry(S).communicationServicesError, this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_failed,
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: f - I
                    },
                    additionalPayload: N
                }, S), this.logger.error(S.message), S;
            }
            const L = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(L);
            try {
                var _getAcsEcsConfig_calling, _getAcsEcsConfig, _this_acsCustomRelayManager, _g_firstPartyOptions1, _g_firstPartyOptions2;
                const S = {
                    ...v
                };
                !getAcsEcsConfig().calling.setDeviceType || "mesh" !== this._callAgent.getDeviceType() && "meshV2" !== this._callAgent.getDeviceType() || (S.endpointMetadata = JSON.stringify({
                    meshapp: !0
                })), this.tsCall.init(S), C && this.sendVideoEvent({
                    correlationId: b,
                    eventName: dy.acs_calling_start_video_attempt,
                    timestampInfo: {
                        attemptTimestamp: I
                    },
                    localVideoStream: C,
                    step: "start",
                    isScreenSharingOnFlag: this._isScreenSharingOn
                });
                try {
                    var _g_videoOptions2;
                    if (g === null || g === void 0 ? void 0 : (_g_videoOptions2 = g.videoOptions) === null || _g_videoOptions2 === void 0 ? void 0 : _g_videoOptions2.constraints) {
                        var _g_videoOptions3;
                        const f = await this._mediaConstraintsManager.setVideoConstraints(g === null || g === void 0 ? void 0 : (_g_videoOptions3 = g.videoOptions) === null || _g_videoOptions3 === void 0 ? void 0 : _g_videoOptions3.constraints, "start", b, I), S = this._mediaConstraintsManager.getTelemetryPayload({
                            video: f
                        });
                        k.additionalProperties.constraints = S;
                    }
                } catch (g) {
                    const f = new CallingCommunicationError({
                        defaultError: O.CALL.CALLSTART_VIDEO_CONSTRAINTS,
                        originalError: g
                    });
                    this.logger.error(`${f.message}`);
                }
                let A = this.setClientEndpointCapabilities(g);
                if (((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.enableCustomTurnUsage) && ((_this_acsCustomRelayManager = this.acsCustomRelayManager) === null || _this_acsCustomRelayManager === void 0 ? void 0 : _this_acsCustomRelayManager.customRelayManagerInUse) && (A.mediaConfiguration = {
                    connectionType: "NoDirectConnection"
                }), _ && (A.muteFlags = 1), (g === null || g === void 0 ? void 0 : (_g_firstPartyOptions1 = g.firstPartyOptions) === null || _g_firstPartyOptions1 === void 0 ? void 0 : _g_firstPartyOptions1.disableAudioMixing) && (void 0 === A.muteFlags ? A.muteFlags = 2 : A.muteFlags |= 2), void 0 !== (g === null || g === void 0 ? void 0 : (_g_firstPartyOptions2 = g.firstPartyOptions) === null || _g_firstPartyOptions2 === void 0 ? void 0 : _g_firstPartyOptions2.enableSpatialAudio) && (A.mediaConfiguration = A.mediaConfiguration || {}, A.mediaConfiguration.enableSpatialAudio = g.firstPartyOptions.enableSpatialAudio, this._callAgent.tsStack ? this._callAgent.tsStack.setMediaConfig({
                    enableSpatialAudio: g.firstPartyOptions.enableSpatialAudio
                }) : this.logger.error(`Could not set enableSpatialAudio to ${g.firstPartyOptions.enableSpatialAudio} since this._callAgent.tsStack is null`)), A.customHeaderContext = processCustomContext(g), E && await this.startAudioInternal(E, !0).catch((g)=>{
                    this.logger.error(`Failed to start localAudioStream, message=${g === null || g === void 0 ? void 0 : g.message}`);
                }), "RawMedia" === (C === null || C === void 0 ? void 0 : C.mediaStreamType)) try {
                    await this._setRawStream(C, 1);
                } catch (g) {
                    const f = +new Date, S = new CallingCommunicationError({
                        defaultError: O.LOCAL_VIDEO_STREAM.VIDEO_GET_MEDIA_STREAM,
                        originalError: g
                    });
                    this.sendVideoEvent({
                        correlationId: b,
                        eventName: dy.acs_calling_media_stream,
                        timestampInfo: {
                            deltaTimeInMs: f - I
                        },
                        localVideoStream: C,
                        step: "start",
                        isScreenSharingOnFlag: this._isScreenSharingOn
                    }, S), this.removeLocalVideoStream(C);
                }
                f ? await this.tsCall.startWithMeetingData(L, {
                    withVideo: !!C && this.isIPVideoEnabled,
                    muted: _,
                    ringOthers: !0,
                    alternateId: T,
                    shouldResurrect: "resurrect",
                    ...A
                }) : await this.tsCall.start({
                    withVideo: !!C && this.isIPVideoEnabled,
                    muted: _,
                    ringOthers: !0,
                    alternateId: T,
                    ...A
                }, L);
                const R = +new Date;
                this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_connected,
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: R - I
                    },
                    additionalPayload: k
                }, void 0, void 0, xE.getRemoveCauseIdToNetworkInfo(L)), E && this.shallRemoveLasAfterConnectedSuccessfully(E, "start", b, R, I), C && this.shallRemoveLvsAfterConnectedSuccessfully(C, "start", b, R, I), this._handleAudioEffectsOperations();
            } catch (g) {
                const f = +new Date, { callEndReason: S, callingCommunicationError: v } = getCallEndReason(this, g);
                if (C) {
                    const S = new CallingCommunicationError({
                        defaultError: O.LOCAL_VIDEO_STREAM.CALL_NOT_FOUND,
                        originalError: g
                    });
                    this.sendVideoEvent({
                        correlationId: b,
                        eventName: dy.acs_calling_start_video_failure,
                        timestampInfo: {
                            deltaTimeInMs: f - I
                        },
                        localVideoStream: C,
                        step: "start",
                        isScreenSharingOnFlag: this._isScreenSharingOn
                    }, S), this.removeLocalVideoStream(C);
                }
                throw E && this.removeLocalAudioStream(E), N.additionalDetails.callEndReason = extractCallEndReasonForTelemetry(S).callEndReason, this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_failed,
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: f - I
                    },
                    additionalPayload: N
                }, v, void 0, xE.getRemoveCauseIdToNetworkInfo(L)), this.logger.error(`Failed to start the call, message=${S === null || S === void 0 ? void 0 : S.message}, code=${S === null || S === void 0 ? void 0 : S.code}, subCode=${S === null || S === void 0 ? void 0 : S.subCode}, resultCategories=${S === null || S === void 0 ? void 0 : S.resultCategories}`), v;
            }
        }
        getTopNDominantSpeakersWithVideoOn() {
            if (this._internalDominantSpeakersListener) {
                const g = this._internalDominantSpeakersListener.dominantSpeakers.speakersList.map((g)=>this._mriToRemoteParticipantMap.get(getMriFromIdentifier(g))).filter((g)=>!!g).filter((g)=>!!g.videoStreams.filter((g)=>"Video" === g.mediaStreamType).find((g)=>g.tsStream.isAvailable));
                if (this.logger.info(`There are currently ${g.length} top-n dominant speakers with video on in the large meeting where topCount is ${getAcsEcsConfig().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount}`), g.length < getAcsEcsConfig().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount) {
                    const f = this._remoteParticipants.filter((g)=>!!g.videoStreams.filter((g)=>"Video" === g.mediaStreamType).find((g)=>g.tsStream.isAvailable)).filter((f)=>!g.includes(f));
                    f.sort((g, f)=>{
                        var _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams, _g_tsRemoteParticipant_endpoints_endpointDetails_, _g_tsRemoteParticipant_endpoints, _g_tsRemoteParticipant, _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams, _f_tsRemoteParticipant_endpoints_endpointDetails_, _f_tsRemoteParticipant_endpoints, _f_tsRemoteParticipant;
                        var _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map, _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map;
                        const S = (_g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map = (_g_tsRemoteParticipant = g.tsRemoteParticipant) === null || _g_tsRemoteParticipant === void 0 ? void 0 : (_g_tsRemoteParticipant_endpoints = _g_tsRemoteParticipant.endpoints) === null || _g_tsRemoteParticipant_endpoints === void 0 ? void 0 : (_g_tsRemoteParticipant_endpoints_endpointDetails_ = _g_tsRemoteParticipant_endpoints.endpointDetails[0]) === null || _g_tsRemoteParticipant_endpoints_endpointDetails_ === void 0 ? void 0 : (_g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams = _g_tsRemoteParticipant_endpoints_endpointDetails_.mediaStreams) === null || _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams === void 0 ? void 0 : _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams.filter((g)=>"audio" === g.type).map((g)=>g.sourceId)) !== null && _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map !== void 0 ? _g_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map : [], v = S.length > 0 ? Math.min(...S) : void 0, _ = (_f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map = (_f_tsRemoteParticipant = f.tsRemoteParticipant) === null || _f_tsRemoteParticipant === void 0 ? void 0 : (_f_tsRemoteParticipant_endpoints = _f_tsRemoteParticipant.endpoints) === null || _f_tsRemoteParticipant_endpoints === void 0 ? void 0 : (_f_tsRemoteParticipant_endpoints_endpointDetails_ = _f_tsRemoteParticipant_endpoints.endpointDetails[0]) === null || _f_tsRemoteParticipant_endpoints_endpointDetails_ === void 0 ? void 0 : (_f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams = _f_tsRemoteParticipant_endpoints_endpointDetails_.mediaStreams) === null || _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams === void 0 ? void 0 : _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams.filter((g)=>"audio" === g.type).map((g)=>g.sourceId)) !== null && _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map !== void 0 ? _f_tsRemoteParticipant_endpoints_endpointDetails__mediaStreams_filter_map : [], C = _.length > 0 ? Math.min(..._) : void 0;
                        return void 0 !== v && null != C ? v - C : 0;
                    });
                    for (const S of f){
                        if (g.length === getAcsEcsConfig().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount) break;
                        g.push(S);
                    }
                } else g.splice(getAcsEcsConfig().rendering.remoteVideo.largeMeeting.dominantSpeakersWithVideoOn_topCount);
                return g;
            }
            return [];
        }
        getParticipantCapabilities() {
            const g = this._capabilityResolver.getCapabilities();
            return this.logger.log(`participant capabilities are ${g}`), g;
        }
        getMeetingCapabilitiesInternal() {
            const g = this._capabilityResolver.getMeetingsCapabilitiesInternal();
            return this.logger.info(`meeting capabilities are ${g}`), g;
        }
        feature(g) {
            return this._extensibleApi.getApiObjectInstance(g.callApiCtor);
        }
        async hangUp(g) {
            const f = +new Date, S = generateGuid(), v = w.generateCauseId();
            return xE.setCauseIdToNetworkInfo(v), this.sendCallStageEvent({
                eventName: dy.acs_calling_call_hangup_attempt,
                correlationId: S,
                timestampInfo: {
                    attemptTimestamp: f
                }
            }), this.tsCall.stop(g === null || g === void 0 ? void 0 : g.forEveryone, v).then(()=>{
                const g = +new Date;
                this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_hangup_success,
                    correlationId: S,
                    timestampInfo: {
                        deltaTimeInMs: g - f
                    }
                }, void 0, void 0, xE.getRemoveCauseIdToNetworkInfo(v));
            }).catch((g)=>{
                var _this__callAgent__caConfigBag, _this__callAgent__caConfigBag1;
                const _ = +new Date, { callEndReason: C, callingCommunicationError: E } = getCallEndReason(this, g), T = this._callAgent.getEcsConfigIds(), I = {
                    additionalProperties: {
                        EmergencyCountryCode: ((_this__callAgent__caConfigBag = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.emergencyCountryCode) || "",
                        IsUserEmergencyCountryCode: ((_this__callAgent__caConfigBag1 = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag1 === void 0 ? void 0 : _this__callAgent__caConfigBag1.IsUserEmergencyCountryCode) || !1,
                        trouterState: this._callAgent.getTrouterState(),
                        AcsCallingSDKWeb_ecsConfigId: T.AcsCallingSDKWeb,
                        SkypeWebMedia_ecsConfigId: T.SkypeWebMedia
                    },
                    additionalDetails: {
                        ...extractCallEndReasonForTelemetry(C)
                    }
                };
                throw this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_hangup_failure,
                    correlationId: S,
                    timestampInfo: {
                        deltaTimeInMs: _ - f
                    },
                    additionalPayload: I
                }, E, void 0, xE.getRemoveCauseIdToNetworkInfo(v)), E;
            });
        }
        async mute() {
            const g = this.logger.createFnLogger(IS.Mute), f = +new Date, S = generateGuid(), v = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(v), this.sendAudioEvent({
                eventName: dy.acs_calling_mute_attempt,
                eventType: gy.MuteMicrophone,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call",
                initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK
            });
            try {
                g.info("mute"), await this.tsCall.mute(v), g.info("mute success");
                const _ = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_success,
                    eventType: gy.MuteMicrophone,
                    timestampInfo: {
                        deltaTimeInMs: _ - f
                    },
                    correlationId: S,
                    step: "mid-call",
                    initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(v)
                });
            } catch (_) {
                const C = new CallingCommunicationError({
                    defaultError: O.CALL.MIC_MUTE,
                    originalError: _
                });
                g.error("Failed to mute microphone");
                const E = +new Date;
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_failure,
                    eventType: gy.MuteMicrophone,
                    timestampInfo: {
                        deltaTimeInMs: E - f
                    },
                    correlationId: S,
                    step: "mid-call",
                    initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(v)
                }, C), C;
            }
        }
        async unmute() {
            const g = this.logger.createFnLogger(IS.Unmute), f = +new Date, S = generateGuid();
            let v = !1;
            const _ = w.generateCauseId();
            if (xE.setCauseIdToNetworkInfo(_), this.sendAudioEvent({
                eventName: dy.acs_calling_unmute_attempt,
                eventType: gy.UnmuteMicrophone,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call",
                initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK
            }), !this.isAudioPermitted()) {
                const f = "cannot unmute as microphone is disabled";
                throw g.error(f), new CallingCommunicationError({
                    defaultError: O.CALL.MIC_DISABLED,
                    originalError: f
                });
            }
            if (!this.isIPAudioEnabled) {
                const f = "cannot unmute as IP audio in Teams Meeting Policy is disabled";
                throw g.error(f), new CallingCommunicationError({
                    defaultError: O.CALL.IP_AUDIO_NOT_ALLOWED,
                    originalError: f
                });
            }
            if (this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()) {
                const f = "cannot unmute as consent is required to be recorded or transcribed";
                throw g.error(f), new CallingCommunicationError({
                    defaultError: O.CALL.UNMUTE_CONSENT_RESTRICTED,
                    originalError: f
                });
            }
            try {
                var _getAcsEcsConfig_calling, _getAcsEcsConfig;
                g.info("unmute"), await this.tsCall.unmute(_), g.info("unmute success");
                const C = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_unmute_success,
                    eventType: gy.UnmuteMicrophone,
                    timestampInfo: {
                        deltaTimeInMs: C - f
                    },
                    correlationId: S,
                    step: "mid-call",
                    initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                });
                const E = +new Date, T = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.preventStopAudio;
                if (!T && this._isDeviceNotFunctioningMuted) {
                    this.sendAudioEvent({
                        eventName: dy.acs_calling_start_audio_attempt,
                        timestampInfo: {
                            attemptTimestamp: E
                        },
                        correlationId: S,
                        step: "mid-call",
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                    }), v = !0, g.info("start audio"), await this.tsCall.startAudio(), g.info("start audio success");
                    const f = +new Date;
                    this._isDeviceNotFunctioningMuted = !1, this._handleMuteChanges(), this.sendAudioEvent({
                        eventName: dy.acs_calling_start_audio_success,
                        timestampInfo: {
                            deltaTimeInMs: f - E
                        },
                        correlationId: S,
                        step: "mid-call",
                        networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                    });
                }
                this.setLocalAudioStream();
            } catch (C) {
                const E = v ? O.CALL.MIC_UNMUTE_AND_STARTAUDIO : O.CALL.MIC_UNMUTE, T = new CallingCommunicationError({
                    defaultError: E,
                    originalError: C
                });
                g.error(E.message);
                const I = +new Date;
                throw this.sendAudioEvent({
                    eventName: v ? dy.acs_calling_start_audio_failure : dy.acs_calling_unmute_failure,
                    eventType: v ? void 0 : gy.UnmuteMicrophone,
                    timestampInfo: {
                        deltaTimeInMs: I - f
                    },
                    correlationId: S,
                    step: "mid-call",
                    initiatedBySdk: this.__attemptedToRecoverMicNotFunctioningBySDK && !v,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(_)
                }, T), T;
            }
        }
        async muteAllRemoteParticipants() {
            if (!getAcsEcsConfig().calling.enableMuteOthers) throw new CallingCommunicationError({
                defaultError: O.CALL.MUTE_ALL_PARTICIPANTS_DISABLED
            });
            if (!this.tsCall.conversationType && this._callInfo.context === BS.TwoParty) throw new CallingCommunicationError({
                defaultError: O.CALL.MUTE_ALL_PARTICIPANTS_1_TO_1_UNSUPPORTED
            });
            const g = this.logger.createFnLogger(IS.MuteAllRemoteParticipants), f = +new Date, S = generateGuid();
            this.sendAudioEvent({
                eventName: dy.acs_calling_mute_attempt,
                eventType: gy.MuteAllRemoteParticipants,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call"
            });
            try {
                g.info("mute all others"), validateCallConnected(IS.MuteAllRemoteParticipants, this.state);
                const v = [];
                if (0 !== this._remoteParticipants.length) {
                    let f = !1, S = !1, _ = "";
                    if (this._remoteParticipants.map((C)=>{
                        const E = C.tsRemoteParticipant;
                        "phoneNumber" === C.identifier.kind ? (g.error("PSTN participants cannot be muted by others"), f = !0) : [
                            3,
                            5
                        ].some((g)=>g === (E === null || E === void 0 ? void 0 : E.state)) ? void 0 !== E && (v.push(E), _ += getMriFromIdentifier(C.identifier) + ", ") : (g.error("non-connected participants cannot be muted by others"), S = !0);
                    }), 0 !== v.length ? (await this.tsCall.muteParticipants(1, v), g.info(`called mute function on the following participants: ${_}`)) : g.error("all remote participants are not supported to be muted by others"), f) throw new CallingCommunicationError({
                        defaultError: O.CALL.MUTE_ALL_PARTICIPANTS_PSTN_UNSUPPORTED
                    });
                    if (S) throw new CallingCommunicationError({
                        defaultError: O.CALL.MUTE_ALL_PARTICIPANTS_NONCONNECTED_UNSUPPORTED
                    });
                } else g.info("no participants to mute in attempt to mute all remote participants");
                g.info("mute all others success");
                const _ = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_success,
                    eventType: gy.MuteAllRemoteParticipants,
                    timestampInfo: {
                        deltaTimeInMs: _ - f
                    },
                    correlationId: S,
                    step: "mid-call"
                });
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.MUTE_ALL_PARTICIPANTS,
                    originalError: v
                });
                g.error(_.message);
                const C = +new Date;
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_failure,
                    eventType: gy.MuteAllRemoteParticipants,
                    timestampInfo: {
                        deltaTimeInMs: C - f
                    },
                    correlationId: S,
                    step: "mid-call"
                }, _), _;
            }
        }
        async muteIncomingAudio() {
            const g = this.logger.createFnLogger(IS.MuteIncomingAudio), f = +new Date, S = generateGuid();
            this.sendAudioEvent({
                eventName: dy.acs_calling_mute_attempt,
                eventType: gy.MuteIncomingAudio,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call"
            });
            try {
                await this.tsCall.muteSpeaker();
                const g = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_success,
                    eventType: gy.MuteIncomingAudio,
                    timestampInfo: {
                        deltaTimeInMs: g - f
                    },
                    correlationId: S,
                    step: "mid-call"
                });
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.MUTE_INCOMING_AUDIO,
                    originalError: v
                });
                g.error(_.message);
                const C = +new Date;
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_mute_failure,
                    eventType: gy.MuteIncomingAudio,
                    timestampInfo: {
                        deltaTimeInMs: C - f
                    },
                    correlationId: S,
                    step: "mid-call"
                }, _), _;
            }
        }
        async unmuteIncomingAudio() {
            const g = this.logger.createFnLogger(IS.MuteIncomingAudio), f = +new Date, S = generateGuid();
            this.sendAudioEvent({
                eventName: dy.acs_calling_unmute_attempt,
                eventType: gy.UnmuteIncomingAudio,
                timestampInfo: {
                    attemptTimestamp: f
                },
                correlationId: S,
                step: "mid-call"
            });
            try {
                await this.tsCall.unmuteSpeaker();
                const g = +new Date;
                this.sendAudioEvent({
                    eventName: dy.acs_calling_unmute_success,
                    eventType: gy.UnmuteIncomingAudio,
                    timestampInfo: {
                        deltaTimeInMs: g - f
                    },
                    correlationId: S,
                    step: "mid-call"
                });
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.UNMUTE_INCOMING_AUDIO,
                    originalError: v
                });
                g.error(_.message);
                const C = +new Date;
                throw this.sendAudioEvent({
                    eventName: dy.acs_calling_unmute_failure,
                    eventType: gy.UnmuteIncomingAudio,
                    timestampInfo: {
                        deltaTimeInMs: C - f
                    },
                    correlationId: S,
                    step: "mid-call"
                }, _), _;
            }
        }
        async sendDtmf(g) {
            const f = toDtmfTone(g);
            return this.tsCall.sendDtmfTone(f).catch((g)=>{
                throw this.logger.error("Failed to send DTMF tone"), new CallingCommunicationError({
                    defaultError: O.CALL.DTMF_TONE
                });
            });
        }
        async startVideo(g) {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig;
            const f = this.logger.createFnLogger(IS.StartVideo), S = +new Date, v = generateGuid(), _ = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.preventStopAudio;
            if (this.sendVideoEvent({
                eventName: dy.acs_calling_start_video_attempt,
                timestampInfo: {
                    attemptTimestamp: S
                },
                localVideoStream: g,
                correlationId: v,
                step: "mid-call",
                isScreenSharingOnFlag: this._isScreenSharingOn
            }), !this.isVideoPermitted()) {
                const g = "cannot start video as camera is disabled by the Presenter or Organizer of the meeting";
                throw f.error(g), new CallingCommunicationError({
                    defaultError: O.CALL.CAMERA_DISABLED,
                    originalError: g
                });
            }
            if (!this.isIPVideoEnabled) {
                const g = "cannot start video as IP video is not allowed";
                throw f.error(g), new CallingCommunicationError({
                    defaultError: O.CALL.IP_VIDEO_NOT_ALLOWED,
                    originalError: g
                });
            }
            if (this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()) {
                const g = "cannot start video as consent is restricted";
                throw f.error(g), new CallingCommunicationError({
                    defaultError: O.CALL.VIDEOSTART_CONSENT_RESTRICTED,
                    originalError: g
                });
            }
            if (this._isDeviceNotFunctioningMuted && !_) {
                this.sendAudioEvent({
                    eventName: dy.acs_calling_start_audio_attempt,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    correlationId: v,
                    step: "mid-call"
                });
                try {
                    f.info("start audio before starting video"), await this.tsCall.startAudio(), f.info("start audio success before starting video");
                    const g = +new Date;
                    this._isDeviceNotFunctioningMuted = !1, this._handleMuteChanges(), this.sendAudioEvent({
                        eventName: dy.acs_calling_start_audio_success,
                        timestampInfo: {
                            deltaTimeInMs: g - S
                        },
                        correlationId: v,
                        step: "mid-call"
                    });
                } catch (g) {
                    const _ = "Failed to start audio before starting video", C = new CallingCommunicationError({
                        defaultError: O.CALL.START_AUDIO_BEFORE_VIDEO,
                        originalError: g
                    });
                    f.error(_);
                    const E = +new Date;
                    throw this.sendAudioEvent({
                        eventName: dy.acs_calling_start_audio_failure,
                        timestampInfo: {
                            deltaTimeInMs: E - S
                        },
                        correlationId: v,
                        step: "mid-call"
                    }, C), C;
                }
            }
            try {
                if (!g) throw new CallingCommunicationError({
                    defaultError: O.CALL.STREAM_NULL
                });
                if (!(g instanceof LocalVideoStream)) throw new CallingCommunicationError({
                    defaultError: O.CALL.STREAM_IS_NOT_LVS
                });
                if (this.tsCall.isVideoOn) throw new CallingCommunicationError({
                    defaultError: O.CALL.VIDEO_ALREADY_ON
                });
                "RawMedia" === (g === null || g === void 0 ? void 0 : g.mediaStreamType) && await this._setRawStream(g, 1), this.setLocalVideoStream(g);
            } catch (f) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.START_VIDEO,
                    originalError: f
                });
                throw this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_start_video_failure,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn
                }, _), _;
            }
            const C = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(C);
            try {
                f.info("start video"), await this.tsCall.startVideo(void 0, C);
                const _ = +new Date;
                this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_start_video_success,
                    timestampInfo: {
                        deltaTimeInMs: _ - S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(C)
                }), f.info("video started");
            } catch (_) {
                const E = +new Date, T = handleVideoOperationFailure(f, _);
                throw this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_start_video_failure,
                    timestampInfo: {
                        deltaTimeInMs: E - S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(C)
                }, T), this.removeLocalVideoStream(g), T;
            }
        }
        async stopVideo(g) {
            const f = this.logger.createFnLogger(IS.StopVideo), S = +new Date, v = generateGuid();
            this.sendVideoEvent({
                correlationId: v,
                eventName: dy.acs_calling_stop_video_attempt,
                timestampInfo: {
                    attemptTimestamp: S
                },
                localVideoStream: g,
                step: "mid-call",
                isScreenSharingOnFlag: this._isScreenSharingOn
            });
            const _ = 4 === this.tsCall.state || 5 === this.tsCall.state;
            if (!_ && !this.tsCall.isVideoOn || _ && !this.localVideoStream) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL.VIDEO_ALREADY_OFF
                });
                throw this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_stop_video_failure,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn
                }, f), f;
            }
            if (this.localVideoStream !== g) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL.STOP_WRONG_STREAM
                });
                throw this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_stop_video_failure,
                    timestampInfo: {
                        attemptTimestamp: S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn
                }, f), f;
            }
            const unsetRawVideoStream = ()=>{
                try {
                    if (getAcsEcsConfig().calling.allowAccessRawMediaStream && "RawMedia" === g.mediaStreamType) {
                        var _this__callAgent_tsStack;
                        const g = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager();
                        g && g.unsetRawMediaStream && g.unsetRawMediaStream(1);
                    }
                } catch (g) {
                    var _g_message;
                    this.logger.info(`Unset raw video stream: ${(_g_message = g === null || g === void 0 ? void 0 : g.message) !== null && _g_message !== void 0 ? _g_message : "Unkown error"}`);
                }
            }, C = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(C);
            try {
                f.info("stop video"), await this.tsCall.stopVideo(void 0, C), unsetRawVideoStream();
                const _ = +new Date;
                this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_stop_video_success,
                    timestampInfo: {
                        deltaTimeInMs: _ - S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(C)
                }), f.info("video stopped"), this.removeLocalVideoStream(g);
            } catch (_) {
                unsetRawVideoStream();
                const E = +new Date, T = handleVideoOperationFailure(f, _, !0);
                throw this.sendVideoEvent({
                    correlationId: v,
                    eventName: dy.acs_calling_stop_video_failure,
                    timestampInfo: {
                        deltaTimeInMs: E - S
                    },
                    localVideoStream: g,
                    step: "mid-call",
                    isScreenSharingOnFlag: this._isScreenSharingOn,
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(C)
                }, T), T;
            }
        }
        startAudio(g) {
            return this.startAudioInternal(g);
        }
        stopAudio() {
            return this.stopAudioInternal();
        }
        async hold() {
            const g = +new Date, f = generateGuid(), S = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(S);
            try {
                this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Hold,
                    kindOfEvent: uy.attempt,
                    timestampInfo: {
                        deltaTimeInMs: g
                    },
                    additionalDetails: {
                        holdType: $S.Standard,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                    }
                }), getAcsEcsConfig().calling.turnOffScreenShareBeforeHold && this.tsCall.isScreenSharingOn && await this.tsCall.stopScreenSharing().then(()=>{
                    this.logger.log("Successfully turned off screen sharing before hold");
                }).catch(()=>{
                    this.logger.error("Failed to turn off screensharing before hold");
                }), await this.tsCall.hold(void 0, S), this.removeLocalAudioStream(this._localAudioStreams[0]);
                const v = +new Date;
                this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Hold,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: v - g
                    },
                    additionalDetails: {
                        holdType: $S.Standard,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(S)
                });
            } catch (v) {
                const _ = +new Date, C = new CallingCommunicationError({
                    defaultError: O.CALL.HOLD_CALL
                });
                throw this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Hold,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: _ - g
                    },
                    additionalDetails: {
                        failureReason: C.message,
                        code: C.code,
                        subCode: C.subCode,
                        holdType: $S.Standard,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn,
                        ...extractCommunicationServicesErrorForTelemetry(C)
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(S)
                }), C;
            }
        }
        async resume() {
            const g = +new Date, f = generateGuid(), S = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(S);
            try {
                this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Resume,
                    kindOfEvent: uy.attempt,
                    timestampInfo: {
                        deltaTimeInMs: g
                    },
                    additionalDetails: {
                        holdType: $S.Standard,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                    }
                }), await this.tsCall.unhold(void 0, S), this.setLocalAudioStream();
                const v = +new Date;
                this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Resume,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: v - g
                    },
                    additionalDetails: {
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn,
                        holdType: $S.Standard
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(S)
                });
            } catch (v) {
                const _ = +new Date, C = new CallingCommunicationError({
                    defaultError: O.CALL.RESUME_CALL
                });
                throw this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Resume,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: _ - g
                    },
                    additionalDetails: {
                        failureReason: C.message,
                        code: C.code,
                        subCode: C.subCode,
                        holdType: $S.Standard,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn,
                        ...extractCommunicationServicesErrorForTelemetry(C)
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(S)
                }), C;
            }
        }
        async startScreenSharing(g) {
            const f = this.logger.createFnLogger(IS.StartScreenShare), S = +new Date, v = generateGuid();
            try {
                if (this.sendScreenShareEvent({
                    eventName: dy.acs_calling_start_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: v,
                    kindOfEvent: uy.attempt,
                    timestampInfo: "",
                    additionalDetails: "",
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: g
                }), 3 !== this.tsCall.state) throw new CallingCommunicationError({
                    defaultError: O.CALL.START_SS_CALL_NOT_CONNECTED
                });
                if (this.tsCall.isScreenSharingOn) throw new CallingCommunicationError({
                    defaultError: O.CALL.SS_ALREADY_ON
                });
                if (this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted()) {
                    const g = "screen sharing cannot be started as consent is required to be recorded or transcribed";
                    throw f.error(g), new CallingCommunicationError({
                        defaultError: O.CALL.SCREENSHARE_CONSENT_RESTRICTED,
                        originalError: g
                    });
                }
                if (g) {
                    if (!(g instanceof LocalVideoStream)) throw new CallingCommunicationError({
                        defaultError: O.CALL.SS_RAW_STREAM_IS_NOT_LVS
                    });
                    if ("RawMedia" !== g.mediaStreamType) throw new CallingCommunicationError({
                        defaultError: O.CALL.SS_RAW_STREAM_LVS_IS_NOT_RAW_MEDIA
                    });
                    await this._setRawStream(g, 2), this.localScreenSharingStream = g;
                } else this.localScreenSharingStream = new LocalVideoStream(new VideoDeviceInfoImpl(fS.ScreenSharing, generateGuid(), fS.ScreenSharing, this._callAgent.deviceManager));
            } catch (g) {
                const f = +new Date;
                this.removeScreenSharingStream();
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.START_SS,
                    originalError: g
                });
                throw this.sendScreenShareEvent({
                    eventName: dy.acs_calling_start_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: v,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: f - S
                    },
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        subCode: _.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    },
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: this.localScreenSharingStream
                }), _;
            }
            return this.tsCall.startScreenSharing().then(()=>{
                const g = +new Date;
                this.localScreenSharingStream && -1 === this._localVideoStreams.indexOf(this.localScreenSharingStream) && (this.localScreenSharingStream.addCall(this), this._localVideoStreams.push(this.localScreenSharingStream), this._eventEmitter.emit("localVideoStreamsUpdated", {
                    added: [
                        this.localScreenSharingStream
                    ],
                    removed: []
                })), this.sendScreenShareEvent({
                    eventName: dy.acs_calling_start_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: v,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: g - S
                    },
                    additionalDetails: "",
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: this.localScreenSharingStream
                });
            }).catch((g)=>{
                const _ = +new Date;
                this.removeScreenSharingStream();
                const C = handleVideoOperationFailure(f, g);
                throw this.sendScreenShareEvent({
                    eventName: dy.acs_calling_start_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: v,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: _ - S
                    },
                    additionalDetails: {
                        failureReason: C.message,
                        code: C.code,
                        subCode: C.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(C)
                    },
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: this.localScreenSharingStream
                }), C;
            });
        }
        async stopScreenSharing() {
            const g = this.logger.createFnLogger(IS.StopScreenShare), f = +new Date, S = generateGuid();
            if (this.sendScreenShareEvent({
                eventName: dy.acs_calling_stop_screen_share,
                callId: this.id,
                localParticipantId: this.tsCall.participantId,
                correlationId: S,
                kindOfEvent: uy.attempt,
                timestampInfo: "",
                additionalDetails: "",
                isVideoOn: this._isLocalVideoStarted,
                localVideoStream: this.localScreenSharingStream
            }), 3 !== this.tsCall.state) throw new CallingCommunicationError({
                defaultError: O.CALL.STOP_SS_CALL_NOT_CONNECTED
            });
            if (!this.tsCall.isScreenSharingOn) {
                const g = +new Date, v = new CallingCommunicationError({
                    defaultError: O.CALL.SS_ALREADY_OFF
                });
                throw this.sendScreenShareEvent({
                    eventName: dy.acs_calling_stop_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: g - f
                    },
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        subCode: v.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    },
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: this.localScreenSharingStream
                }), v;
            }
            return this.tsCall.stopScreenSharing().then(()=>{
                const g = +new Date, v = P.cloneDeep(this.localScreenSharingStream);
                this.removeScreenSharingStream(), this.sendScreenShareEvent({
                    eventName: dy.acs_calling_stop_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: g - f
                    },
                    additionalDetails: "",
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: v
                });
            }).catch((v)=>{
                const _ = +new Date, C = handleVideoOperationFailure(g, v, !0);
                let E = "string" == typeof (C === null || C === void 0 ? void 0 : C.message) ? C === null || C === void 0 ? void 0 : C.message : void 0;
                throw this.sendScreenShareEvent({
                    eventName: dy.acs_calling_stop_screen_share,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: _ - f
                    },
                    additionalDetails: {
                        failureReason: E || "",
                        code: C.code,
                        subCode: C.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(C)
                    },
                    isVideoOn: this._isLocalVideoStarted,
                    localVideoStream: this.localScreenSharingStream
                }), C;
            });
        }
        async setConstraints(g) {
            const f = +new Date, S = generateGuid();
            try {
                let v = await this._mediaConstraintsManager.setVideoConstraints(g === null || g === void 0 ? void 0 : g.video, "mid-call", S, f);
                this.logger.info(`Video constraints set - ${JSON.stringify(v)}`);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.CALL.SET_VIDEO_CONSTRAINTS,
                    originalError: g
                });
            }
        }
        on(g, f) {
            if ("stateChanged" !== g && "idChanged" !== g && "isMutedChanged" !== g && "isIncomingAudioMutedChanged" !== g && "isScreenSharingOnChanged" !== g && "isLocalVideoStartedChanged" !== g && "remoteParticipantsUpdated" !== g && "localVideoStreamsUpdated" !== g && "localAudioStreamsUpdated" !== g && "remoteAudioStreamsUpdated" !== g && "totalParticipantCountChanged" !== g && "roleChanged" != g && "mutedByOthers" !== g && "callerInfoChanged" !== g && "transferorInfoChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("stateChanged" !== g && "idChanged" !== g && "isMutedChanged" !== g && "isIncomingAudioMutedChanged" != g && "isScreenSharingOnChanged" !== g && "isLocalVideoStartedChanged" !== g && "remoteParticipantsUpdated" !== g && "localVideoStreamsUpdated" !== g && "localAudioStreamsUpdated" !== g && "remoteAudioStreamsUpdated" !== g && "totalParticipantCountChanged" != g && "roleChanged" != g && "mutedByOthers" !== g && "callerInfoChanged" !== g && "transferorInfoChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        onMeetingCapabilitiesChanged(g, f) {
            if ("meetingCapabilitiesChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        offMeetingCapabilitiesChanged(g, f) {
            if ("meetingCapabilitiesChanged" != g) throw new CallingCommunicationError({
                defaultError: O.CALL.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        onParticipantCapabilitiesChanged(g, f) {
            this.logger.log("participant capabilities change event listener registered"), this._eventEmitter.on(g, f);
        }
        offParticipantCapabilitiesChanged(g, f) {
            this.logger.log("participant capabilities change event listener unregistered"), this._eventEmitter.off(g, f);
        }
        onWatermarkAudioOnlyFallbackTriggeredChanged(g, f) {
            this.logger.log("watermark audio only fallback triggered listener registered"), this._eventEmitter.on(g, f);
        }
        offWatermarkAudioOnlyFallbackTriggeredChanged(g, f) {
            this.logger.log("watermark audio only fallback triggered listener unregistered"), this._eventEmitter.off(g, f);
        }
        getOrCreateRemoteParticipant(g, f) {
            let S = this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g));
            return S || (S = new RemoteParticipantImpl(g, this.logger, this, this._callAgent, this._telemetryLogManager), this._remoteParticipants.push(S), this._mriToRemoteParticipantMap.set(getMriFromIdentifier(S.identifier), S)), f && S.observeParticipant(f), S;
        }
        deleteRemoteParticipant(g) {
            let f = !0;
            return 1 !== this._remoteParticipants.splice(this._remoteParticipants.indexOf(g), 1).length && (this.logger.warn("Deleted remote participant array is not 1"), f = !1), this._mriToRemoteParticipantMap.delete(getMriFromIdentifier(g.identifier)) || (this.logger.warn("Deleted remote participant was not found in mri-to-remoteparticipant map"), f = !1), f;
        }
        sendCallOnHoldAndResumedEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send call hold or resume telemetry");
            }
        }
        sendVideoEvent(g, f) {
            try {
                let S, v;
                try {
                    var _g_localVideoStream;
                    S = (_g_localVideoStream = g.localVideoStream) === null || _g_localVideoStream === void 0 ? void 0 : _g_localVideoStream.getStreamMetadata();
                } catch (g) {
                    this.logger.error("Unable to get stream meta data on send video event");
                }
                f && (v = "string" == typeof (f === null || f === void 0 ? void 0 : f.message) ? f === null || f === void 0 ? void 0 : f.message : void 0, g.additionalDetails = {
                    ...extractCommunicationServicesErrorForTelemetry(f)
                }), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        ...S,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        timestampInfo: g.timestampInfo,
                        correlationId: g.correlationId,
                        step: g.step || "",
                        failureReason: v || "",
                        isScreenSharingOnFlag: g.isScreenSharingOnFlag,
                        additionalDetails: g.additionalDetails || {},
                        networkInfo: g.networkInfo || []
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send video telemetry");
            }
        }
        sendScreenShareEvent(g) {
            let f;
            try {
                var _g_localVideoStream;
                f = (_g_localVideoStream = g.localVideoStream) === null || _g_localVideoStream === void 0 ? void 0 : _g_localVideoStream.getStreamMetadata();
            } catch (g) {
                this.logger.error("Unable to get stream meta data on send video event");
            }
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        ...f,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        correlationId: g.correlationId,
                        kindOfEvent: g.kindOfEvent,
                        timestampInfo: g.timestampInfo,
                        additionalDetails: g.additionalDetails,
                        isVideoOn: g.isVideoOn
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send screen share telemetry");
            }
        }
        sendRawMediaEvent(g) {
            var _g_localAudioStream;
            const f = {
                ...g
            };
            f.localAudioStream = ((_g_localAudioStream = g.localAudioStream) === null || _g_localAudioStream === void 0 ? void 0 : _g_localAudioStream.source) instanceof MediaStream ? "MediaStream" : "Device";
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: f
                });
            } catch (g) {
                this.logger.debug("Unable to send raw media telemetry");
            }
        }
        sendAudioEvent(g, f) {
            try {
                let S;
                f && (S = "string" == typeof (f === null || f === void 0 ? void 0 : f.message) ? f === null || f === void 0 ? void 0 : f.message : void 0, g.additionalDetails = {
                    ...extractCommunicationServicesErrorForTelemetry(f)
                });
                const v = {
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    timestampInfo: g.timestampInfo,
                    correlationId: g.correlationId,
                    step: g.step || "",
                    failureReason: S || "",
                    additionalDetails: g.additionalDetails || {},
                    networkInfo: g.networkInfo || []
                };
                void 0 !== g.eventType && (v.eventType = g.eventType), g.initiatedBySdk && (v.initiatedBySdk = !0), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: v
                });
            } catch (g) {
                this.logger.debug("Unable to send audio telemetry");
            }
        }
        sendCallStageEvent(f, S, v, _) {
            try {
                var _this_tsCall, _this, _this_tsCall_meetingData, _this_tsCall1, _this1, _this_tsCall2, _this2, _this_tsCall3, _this3, _this_tsCall4, _this4, _this_tsCall5, _this5;
                let C, E = "";
                S && (C = ((_this = this) === null || _this === void 0 ? void 0 : (_this_tsCall = _this.tsCall) === null || _this_tsCall === void 0 ? void 0 : _this_tsCall.callEndDiagnosticsInfo) || v || {}, E = S.message);
                const T = this._joinContextDescription === aS.RoomCall || this.kind === g.CallKind.Call && "Incoming" === this._direction && !this.tsCall.groupId && !!((_this_tsCall_meetingData = this.tsCall.meetingData) === null || _this_tsCall_meetingData === void 0 ? void 0 : _this_tsCall_meetingData.meetingCode) && !this.tsCall.threadId, I = !T && this._joinContextDescription === aS.TeamsMeetingLink || this._joinContextDescription === aS.TeamsMeetingId || this._joinContextDescription === aS.TeamsCoordinates || "Incoming" == this._direction && !this.tsCall.groupId && !!this.tsCall.meetingData && !!this.tsCall.threadId, b = {
                    localParticipantId: ((_this1 = this) === null || _this1 === void 0 ? void 0 : (_this_tsCall1 = _this1.tsCall) === null || _this_tsCall1 === void 0 ? void 0 : _this_tsCall1.participantId) || "",
                    callId: ((_this2 = this) === null || _this2 === void 0 ? void 0 : (_this_tsCall2 = _this2.tsCall) === null || _this_tsCall2 === void 0 ? void 0 : _this_tsCall2.callId) || "",
                    callType: ((_this3 = this) === null || _this3 === void 0 ? void 0 : (_this_tsCall3 = _this3.tsCall) === null || _this_tsCall3 === void 0 ? void 0 : _this_tsCall3.callType) || "",
                    callDirection: this._direction,
                    failureReason: E,
                    callEndDiagnosticsInfo: C,
                    calleeIdentityType: this.getParticipantIdentityType(),
                    groupJoin: !!((_this4 = this) === null || _this4 === void 0 ? void 0 : (_this_tsCall4 = _this4.tsCall) === null || _this_tsCall4 === void 0 ? void 0 : _this_tsCall4.groupId),
                    roomJoin: T,
                    meetingJoin: I,
                    hostRegion: ((_this5 = this) === null || _this5 === void 0 ? void 0 : (_this_tsCall5 = _this5.tsCall) === null || _this_tsCall5 === void 0 ? void 0 : _this_tsCall5.region) || "",
                    correlationId: f.correlationId,
                    timestampInfo: f.timestampInfo,
                    ...f.additionalPayload,
                    networkInfo: _ || []
                };
                this._telemetryLogManager.sendEvent({
                    name: f.eventName,
                    tenant: nf,
                    properties: b
                });
            } catch (g) {}
        }
        getParticipantIdentityType() {
            var _this_tsCall, _this_tsCall1, _this_tsCall2;
            if (((_this_tsCall = this.tsCall) === null || _this_tsCall === void 0 ? void 0 : _this_tsCall.participants.length) > 1) return SS.group;
            if (0 === ((_this_tsCall1 = this.tsCall) === null || _this_tsCall1 === void 0 ? void 0 : _this_tsCall1.participants.length)) return SS.unknown;
            const g = (_this_tsCall2 = this.tsCall) === null || _this_tsCall2 === void 0 ? void 0 : _this_tsCall2.participants[0];
            return constructIdentifierKindFromMri(g.id).kind;
        }
        optimalVideoCountChanged() {
            const g = this._optimalVideoCount, f = this.tsCall.optimalVideoCount;
            if (f && g !== f) try {
                var _this_activeRemoteVideoStreamViews;
                sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                    ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                    step: "optimalVideoCount-changed",
                    previousOptimalVideoCount: g,
                    newOptimalVideoCount: f,
                    currentNumberOfVideosRendered: ((_this_activeRemoteVideoStreamViews = this.activeRemoteVideoStreamViews) === null || _this_activeRemoteVideoStreamViews === void 0 ? void 0 : _this_activeRemoteVideoStreamViews.size) || 0
                });
            } catch (g) {
                this.logger.error("Failed to send optimal video count change telemetry");
            } finally{
                this._optimalVideoCount = this.tsCall.optimalVideoCount || 1;
            }
        }
        _sendNetworkChangedTelemetry() {
            try {
                const recordNetworkChangedTelemetry = (g, f, S)=>{
                    sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                        ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                        step: "network-changed",
                        trouterState: g,
                        onLine: f,
                        rdpState: S
                    });
                };
                this._trouterStateChangedListener = (g)=>{
                    recordNetworkChangedTelemetry(g, navigator.onLine, this._mmrRdpConnectionManager.state);
                }, this._callAgent.onTrouterStateChanged(this._trouterStateChangedListener), this._onlineListener = (g)=>{
                    recordNetworkChangedTelemetry(this._callAgent.getTrouterState(), !0, this._mmrRdpConnectionManager.state);
                }, window.addEventListener("online", this._onlineListener), this._offlineListener = (g)=>{
                    recordNetworkChangedTelemetry(this._callAgent.getTrouterState(), !1, this._mmrRdpConnectionManager.state);
                }, window.addEventListener("offline", this._offlineListener), this._mmrRdpConnectionManager.on("stateChange", (g)=>{
                    recordNetworkChangedTelemetry(this._callAgent.getTrouterState(), !1, g);
                }), recordNetworkChangedTelemetry(this._callAgent.getTrouterState(), navigator.onLine, this._mmrRdpConnectionManager.state);
            } catch (g) {
                this.logger.warn("Failed to subscribe to network changed");
            }
        }
        _setupSelectedDeviceChangedTelemetry() {
            try {
                const recordTelemetry = (g)=>{
                    sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                        ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                        step: "selectedDevice-changed",
                        selectedDeviceType: g.selectedDeviceType,
                        oldDevice: g.oldDevice,
                        newDevice: g.newDevice
                    });
                };
                if (this._selectedDeviceManager) {
                    this._selectedDeviceManager.on("selectedDeviceChanged", recordTelemetry);
                    const g = this._selectedDeviceManager.selectedDevice("Speaker"), f = this._selectedDeviceManager.selectedDevice("Microphone");
                    recordTelemetry({
                        selectedDeviceType: "Speaker",
                        oldDevice: void 0,
                        newDevice: g
                    }), recordTelemetry({
                        selectedDeviceType: "Microphone",
                        oldDevice: void 0,
                        newDevice: f
                    });
                }
            } catch (g) {
                this.logger.warn("Failed to subscribe to selectedDevice changed");
            }
        }
        setLocalVideoStream(g) {
            if (!this._callAgent.tsStack) throw new CallingCommunicationError({
                defaultError: O.CALL.VIDEO_UNDEFINED_STACK
            });
            if (!this.localVideoStream && g && !this._localVideoStreams.find((f)=>f === g)) {
                this.localVideoStream = g, this._localVideoStreams.push(this.localVideoStream), "RawMedia" !== this.localVideoStream.mediaStreamType && this._callAgent.tsStack.getDeviceManager().selectDevices({
                    camera: g.source.id
                }), this.localVideoStream.addCall(this);
                try {
                    this._eventEmitter.emit("localVideoStreamsUpdated", {
                        added: [
                            this.localVideoStream
                        ],
                        removed: []
                    });
                } catch (g) {
                    this.logger.warn("Application threw on emit localVideoStreamsUpdated added");
                }
                this.logger.log("isLocalVideoStarted changed=true"), this._isLocalVideoStarted = !0, this._eventEmitter.emit("isLocalVideoStartedChanged");
            }
        }
        removeLocalVideoStream(g) {
            if (this.localVideoStream && g === this.localVideoStream && this.localVideoStreams.find((g)=>g === this.localVideoStream)) {
                this.logger.log("Attempting to remove local video stream");
                if (0 === this._localVideoStreams.splice(this._localVideoStreams.indexOf(this.localVideoStream), 1).length) return void this.logger.warn("Stream not found, failed to remove stream from localVideoStreams collection");
                this.logger.log("Local video stream removed successfully"), this.localVideoStream.removeCall(this), this.localVideoStream.dispose();
                const g = this.localVideoStream;
                this.localVideoStream = void 0;
                try {
                    this._eventEmitter.emit("localVideoStreamsUpdated", {
                        added: [],
                        removed: [
                            g
                        ]
                    });
                } catch (g) {
                    this.logger.warn("Application threw on emit localVideoStreamsUpdated removed");
                }
                this.logger.log("isLocalVideoStarted changed=false"), this._isLocalVideoStarted = !1, this._eventEmitter.emit("isLocalVideoStartedChanged");
            }
        }
        setLocalAudioStream(g) {
            if (!this._callAgent.tsStack) throw new CallingCommunicationError({
                defaultError: O.CALL.LOCAL_AUDIO_UNDEFINED_STACK
            });
            if (g) g.on("audioSourceChanged", this.audioSourceChanged), this._localAudioStreams.push(g), g.addCall(this), this._eventEmitter.emit("localAudioStreamsUpdated", {
                added: [
                    g
                ],
                removed: []
            });
            else if (0 === this._localAudioStreams.length) {
                var _this_deviceManager;
                if (this._userProvidedLocalAudioStreamCache) return (g = this._userProvidedLocalAudioStreamCache).on("audioSourceChanged", this.audioSourceChanged), this._localAudioStreams.push(g), g.addCall(this), void this._eventEmitter.emit("localAudioStreamsUpdated", {
                    added: [
                        g
                    ],
                    removed: []
                });
                const f = (_this_deviceManager = this.deviceManager) === null || _this_deviceManager === void 0 ? void 0 : _this_deviceManager.selectedMicrophone;
                if (f) {
                    const g = new LocalAudioStream(f);
                    g.on("audioSourceChanged", this.audioSourceChanged), this._localAudioStreams.push(g), g.addCall(this), this._eventEmitter.emit("localAudioStreamsUpdated", {
                        added: [
                            g
                        ],
                        removed: []
                    });
                } else this.logger.warn("Could not get current selected microphone to update localAudioStreams collection");
            } else this.logger.warn("No localAudioStream provided and the collection is not empty, doing nothing");
        }
        removeLocalAudioStream(g) {
            if (g) {
                this.logger.log("Attempting to remove local audio stream"), g.off("audioSourceChanged", this.audioSourceChanged), g.dispose();
                if (0 === this._localAudioStreams.splice(this._localAudioStreams.indexOf(g), 1).length) return void this.logger.warn("Stream not found, failed to remove stream from localAudioStreams collection");
                g.removeCall(this), this.logger.log("Local audio stream removed successfully"), this._eventEmitter.emit("localAudioStreamsUpdated", {
                    added: [],
                    removed: [
                        g
                    ]
                });
            }
        }
        _handleAudioEffectsOperations() {
            try {
                var _this__localAudioStreams;
                const g = (_this__localAudioStreams = this._localAudioStreams) === null || _this__localAudioStreams === void 0 ? void 0 : _this__localAudioStreams[0];
                if (!g) return void this.logger.debug("No LocalAudioStream found in the call, cannot handle call audio effects operations");
                this._audioEffectsStatsListener = (g)=>{
                    this._audioEffectsProcessorStats = g;
                };
                const f = g.feature(mb.AudioEffects);
                f === null || f === void 0 ? void 0 : f.on("effectsProcessorStatsUpdated", this._audioEffectsStatsListener);
            } catch (g) {
                this.logger.warn(`Error handling audio effects operations during call start: ${g}`);
            }
        }
        isAudioPermitted() {
            var _this_feature;
            return !!((_this_feature = this.feature(mb.MediaAccess)) === null || _this_feature === void 0 ? void 0 : _this_feature.getLocalParticipantMediaAccess().isAudioPermitted);
        }
        isVideoPermitted() {
            var _this_feature;
            return !!((_this_feature = this.feature(mb.MediaAccess)) === null || _this_feature === void 0 ? void 0 : _this_feature.getLocalParticipantMediaAccess().isVideoPermitted);
        }
        removeScreenSharingStream() {
            if (this.localScreenSharingStream && this.localVideoStreams.find((g)=>g === this.localScreenSharingStream)) {
                var _getAcsEcsConfig_calling, _getAcsEcsConfig, _this_localScreenSharingStream;
                if (((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.allowAccessRawMediaStream) && "RawMedia" === ((_this_localScreenSharingStream = this.localScreenSharingStream) === null || _this_localScreenSharingStream === void 0 ? void 0 : _this_localScreenSharingStream.mediaStreamType)) {
                    var _this__callAgent_tsStack;
                    const g = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager();
                    (g === null || g === void 0 ? void 0 : g.unsetRawMediaStream) && g.unsetRawMediaStream(2);
                }
                this.localScreenSharingStream.dispose(), this.localScreenSharingStream.removeCall(this);
                const g = this._localVideoStreams.indexOf(this.localScreenSharingStream);
                this._localVideoStreams.splice(g, 1);
                const f = this.localScreenSharingStream;
                this.localScreenSharingStream = void 0, this._eventEmitter.emit("localVideoStreamsUpdated", {
                    added: [],
                    removed: [
                        f
                    ]
                });
            }
        }
        mapTsCallState(g) {
            const f = jy[g];
            switch(f){
                case "Unknown":
                case void 0:
                    this.logger.log(`Ignored tsCall state \`${g}\``);
                    break;
                case "Disconnected":
                    {
                        var _this__rawAudioStreamChangedSubscription;
                        this._callEndReason = getCallEndReason(this).callEndReason, this._remoteParticipants.forEach((g)=>{
                            g.setCallEndReason(getRemoteParticipantCallEndReason(this, g.tsRemoteParticipant).callEndReason), g.setParticipantState("Disconnected");
                        });
                        const S = this._remoteParticipants.map((g)=>g);
                        this._remoteParticipants = [], this._mriToRemoteParticipantMap.clear(), this._eventEmitter.emit("remoteParticipantsUpdated", {
                            added: [],
                            removed: S
                        }), this.localVideoStream && this.removeLocalVideoStream(this.localVideoStream), this.localAudioStreams[0] && this.removeLocalAudioStream(this.localAudioStreams[0]), ((_this__rawAudioStreamChangedSubscription = this._rawAudioStreamChangedSubscription) === null || _this__rawAudioStreamChangedSubscription === void 0 ? void 0 : _this__rawAudioStreamChangedSubscription.dispose) && this._rawAudioStreamChangedSubscription.dispose(), getAcsEcsConfig().calling.allowAccessRawMediaStream && this.remoteAudioStreams[0] && this.removeRemoteAudioStream(this.remoteAudioStreams[0]), this._userProvidedLocalAudioStreamCache = void 0, this.logger.log(`Mapped tsCall state:${g} to ${f}`), this._setCallState(f), this._telemetryLogManager.flushAllEvents(this.id).then(()=>{
                            this.logger.log("Telemetry flushed");
                        }).catch((g)=>{
                            this.logger.warn("Failed to flush telemetry log manager events");
                        });
                        break;
                    }
                case "Connected":
                    this.logger.log(`Mapped tsCall state:${g} to ${f}`), this._remoteParticipantsChangedListeners.forEach((g)=>{
                        g.dispose();
                    }), this._setCallState(f), this.setOrUpdateMediaMetricsDeviceEvents(), getAcsEcsConfig().calling.allowAccessRawMediaStream && this.subscribeToGetRemoteAudioStream();
                    break;
                case "Incoming Call":
                    {
                        var _this_tsCall_callStartedAt;
                        this.logger.log(`state changed from ${this._state} to 'Incoming Call'`);
                        const g = new CallInfoCommonImpl(this.tsCall, {
                            config: this._config
                        });
                        sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                            ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                            step: "state-changed",
                            oldState: this._state,
                            newState: "Incoming Call",
                            callTypeInfo: {
                                initiatorKind: g.initiatorKind,
                                targetKind: g.targetKind,
                                transferor: g.transferorKind,
                                context: g.context,
                                callScenario: g.callScenario,
                                direction: g.direction
                            },
                            teamsMeetingTenantId: this._teamsMeetingTenantId || "",
                            teamsMeetingThreadId: this._teamsMeetingThreadId || "",
                            callDurationInSeconds: this.tsCall.callStartedAt ? Math.floor((Date.now() - ((_this_tsCall_callStartedAt = this.tsCall.callStartedAt) === null || _this_tsCall_callStartedAt === void 0 ? void 0 : _this_tsCall_callStartedAt.getTime())) / 1e3) : -1
                        });
                        break;
                    }
                default:
                    this.logger.log(`Mapped tsCall state:${g} to ${f}`), this._setCallState(f);
            }
        }
        shallStopVideo(g) {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig_calling1, _getAcsEcsConfig1, _getAcsEcsConfig_calling2, _getAcsEcsConfig2;
            const f = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.deviceNotFunctioningMuted, S = (_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_calling1 = _getAcsEcsConfig1.calling) === null || _getAcsEcsConfig_calling1 === void 0 ? void 0 : _getAcsEcsConfig_calling1.deviceCaptureMutedVideo, v = (_getAcsEcsConfig2 = getAcsEcsConfig()) === null || _getAcsEcsConfig2 === void 0 ? void 0 : (_getAcsEcsConfig_calling2 = _getAcsEcsConfig2.calling) === null || _getAcsEcsConfig_calling2 === void 0 ? void 0 : _getAcsEcsConfig_calling2.preventStopVideo, _ = 25 === g.type && 3 === g.value, C = _ && 1 === g.mediaType, E = 33 === g.type && 3 === g.value, T = getBrowserInfo(), I = "ios" === getOS() && "Safari" === T.engine, b = "android" === getOS(), A = 3 === this.tsCall.state;
            return v ? A && this.tsCall.isVideoOn && E : f && A && this.tsCall.isVideoOn && (E || I && _ || S && b && C);
        }
        shallRemoveLocalVideoStreamOnBadUfd(g) {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig;
            const f = this.tsCall.localMediaStreams.find((g)=>1 === g.mediaType), S = 1 === g.mediaType && 3 === g.value && 25 === g.type, v = 4 == this.tsCall.state || 5 === this.tsCall.state;
            if ("Mobile" === getBrowserInfo().formFactor && (S || "hidden" == document.visibilityState) && this.localVideoStream && v && !f) return !1;
            if (!((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.removeLvsCheckOnCallStartAndCallAccept)) return !1;
            const _ = 3 === this.tsCall.state;
            return 1 === g.mediaType && 3 === g.value && (33 === g.type || 25 === g.type || 34 === g.type) && !!this.localVideoStream && !_ && !f;
        }
        shallStopAudio(g) {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig_calling1, _getAcsEcsConfig1;
            const f = (_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.deviceNotFunctioningMuted, S = (_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_calling1 = _getAcsEcsConfig1.calling) === null || _getAcsEcsConfig_calling1 === void 0 ? void 0 : _getAcsEcsConfig_calling1.osAutoRecoverAudio, v = 25 === g.type && 3 === g.value && 0 === g.mediaType, _ = 9 === g.type && 3 === g.value, C = getBrowserInfo(), E = "ios" === getOS() && "Safari" === C.engine, T = 3 === this.tsCall.state;
            return S ? f && T && _ : f && !this._isDeviceNotFunctioningMuted && T && (_ || E && v);
        }
        markCallMuted() {
            this._isDeviceNotFunctioningMuted = !0, this._handleMuteChanges();
        }
        audioDidAutoRecover(g) {
            var _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig_calling1, _getAcsEcsConfig1;
            const f = ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.deviceCaptureMuteRecover) && !((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_calling1 = _getAcsEcsConfig1.calling) === null || _getAcsEcsConfig_calling1 === void 0 ? void 0 : _getAcsEcsConfig_calling1.preventFakeMute), S = 25 === g.type && 1 === g.value && 0 === g.mediaType, v = 3 === this.tsCall.state, _ = getBrowserInfo(), C = "ios" === getOS() && "Safari" === _.engine, E = 9 === g.type && 1 === g.value;
            return f && this._isDeviceNotFunctioningMuted && v && (E || C && S);
        }
        sendParticipantAddedOrRemovedEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_participant_added_or_removed,
                    tenant: nf,
                    properties: {
                        callId: this.id,
                        remotePerticipantId: Array.isArray(g === null || g === void 0 ? void 0 : g.remoteParticipantIds) ? g === null || g === void 0 ? void 0 : g.remoteParticipantIds.slice(0, getAcsEcsConfig().telemetry.maxExistingReportedParticipants) : [],
                        participantAddedOrRemoved: g.participantAddedOrRemoved,
                        localParticipantId: this.tsCall.participantId,
                        kindOfEvent: g.kindOfEvent,
                        correlationId: g.correlationId || "",
                        timestampInfo: g.timestampInfo || "",
                        additionalDetails: g.additionalDetails || {},
                        networkInfo: g.networkInfo || []
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send participant added or removed telemtery");
            }
        }
        _handleLocalRingingCallState(g) {
            "Connected" === this._state || "Outgoing" !== this._direction || this._localRingingStateSet || this._remoteParticipantsChangedListeners.push(g.changed(()=>{
                2 !== g.state || "Connected" === this._state || this._localRingingStateSet || (this._setCallState("Ringing"), this._localRingingStateSet = !0, this._remoteParticipantsChangedListeners.forEach((g)=>{
                    g.dispose();
                }));
            }));
        }
        _setCallState(g) {
            if (g !== this._state) {
                var _this_tsCall_callStartedAt;
                const f = this._state, S = g, v = new CallInfoCommonImpl(this.tsCall, {
                    config: this._config
                });
                this.logger.log(`state changed from ${f} to ${S}`), this._state = S, "Connected" === S && (this._connectedTimestamp = Date.now()), this._eventEmitter.emit("stateChanged"), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                    ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                    step: "state-changed",
                    oldState: f,
                    newState: S,
                    callTypeInfo: {
                        initiatorKind: v.initiatorKind,
                        targetKind: v.targetKind,
                        transferor: v.transferorKind,
                        context: v.context,
                        callScenario: v.callScenario,
                        direction: v.direction
                    },
                    teamsMeetingTenantId: this._teamsMeetingTenantId || "",
                    teamsMeetingThreadId: this._teamsMeetingThreadId || "",
                    callDurationInSeconds: this.tsCall.callStartedAt ? Math.floor((Date.now() - ((_this_tsCall_callStartedAt = this.tsCall.callStartedAt) === null || _this_tsCall_callStartedAt === void 0 ? void 0 : _this_tsCall_callStartedAt.getTime())) / 1e3) : -1,
                    additionalDetails: "Disconnected" === this._state && this._callEndReason ? {
                        ...extractCallEndReasonForTelemetry(this._callEndReason)
                    } : void 0
                });
            }
        }
        _setCallRole(g) {
            if (g !== this._lastTsCallAdvancedMeetingRole) {
                let f = advancedMeetingRoleToParticipantRole(getAcsEcsConfig(), g);
                f === qf ? this.logger.log(`tsParticipant advancedMeetingRole=${this._role} had no mapping`) : this.logger.log(`mapped tsParticipant advancedMeetingRole=${g}=>${f}`), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                    ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                    step: "role-changed",
                    oldAcsRole: this._role,
                    newAcsRole: f,
                    serviceRole: g || ""
                }), this._role != f && (this.logger.log(`self-role changed ${this._role}=>${g}`), this._role = f, this._lastTsCallAdvancedMeetingRole = g, this._capabilityResolver.resolveCapabilitiesBasedOnRole(), this._eventEmitter.emit("roleChanged"));
            }
        }
        _setMeetingCapabilities(g) {
            hasCoreMeetingCapabilitiesChanged(g, this._lastTsCallMeetingDetails) && (sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                ...getCallProgressCommonPayload(this, this._callAgent, generateGuid(), this._joinContextDescription),
                step: "meetingCapabilities-changed",
                oldMeetingDetails: this._lastTsCallMeetingDetails,
                newMeetingDetails: g
            }), this.logger.log(`Core Meeting Capabilities has changed to: ${JSON.stringify(g)}`), this._capabilityResolver.resolveCapabilitiesBasedOnMeetingCapabilities(), this._eventEmitter.emit("meetingCapabilitiesChanged")), Object.assign(this._lastTsCallMeetingDetails, g);
        }
        removeRemoteAudioStream(g) {
            if (g) {
                this.logger.log("Attempting to remove remote audio stream");
                if (0 === this._remoteAudioStreams.splice(this._remoteAudioStreams.indexOf(g), 1).length) return void this.logger.warn("Stream not found, failed to remove stream from remoteAudioStreams collection");
                this.logger.log("remote audio stream removed successfully"), this._eventEmitter.emit("remoteAudioStreamsUpdated", {
                    added: [],
                    removed: [
                        g
                    ]
                });
            }
        }
        async setOrUpdateMediaMetricsDeviceEvents() {
            if (getAcsEcsConfig().calling.mediaMetricsDeviceEventsEnabled) try {
                var _g_metrics;
                const g = this.tsCall.getMediaSessionStats();
                if (void 0 !== (g === null || g === void 0 ? void 0 : (_g_metrics = g.metrics) === null || _g_metrics === void 0 ? void 0 : _g_metrics.DeviceEvents)) {
                    const f = JSON.parse(g.metrics.DeviceEvents), S = getSafeObjectDiff(this._mediaMetricsDeviceEvents || {}, f);
                    S.length > 0 && (this._mediaMetricsDeviceEvents = f, this.stats.recordEvent({
                        name: cy.media_metrics_device_events,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        data: {
                            metricsDeviceEvents: S || {},
                            metricsDevicesChangeCount: (f === null || f === void 0 ? void 0 : f.metrics_DevicesChangeCount) || 0,
                            metricsDevicesCount: (f === null || f === void 0 ? void 0 : f.metrics_DevicesCount) || {}
                        }
                    }));
                } else this.logger.error("Failed to set media metrics device events telemetry: no valid events data");
            } catch (g) {
                this.logger.error("Failed to set media metrics device events telemetry");
            }
        }
        setClientEndpointCapabilities(g) {
            var _g_firstPartyOptions, _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig1;
            const f = {};
            let S = 0;
            return (g === null || g === void 0 ? void 0 : (_g_firstPartyOptions = g.firstPartyOptions) === null || _g_firstPartyOptions === void 0 ? void 0 : _g_firstPartyOptions.isImmersiveMode) && (S |= 32768), ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.supportLiveStreaming) && (S |= 32), ((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : _getAcsEcsConfig1.calling.sharedLineAppearance.enabled) && (S |= 128), this._allowBreakoutRoomJoin && (S |= 4098), S > 0 && (f.clientEndpointCapabilities = S), f;
        }
        getLocalVideoStreamFromCallOptions(g) {
            var _g_videoOptions;
            let f;
            if (Array.isArray(g === null || g === void 0 ? void 0 : (_g_videoOptions = g.videoOptions) === null || _g_videoOptions === void 0 ? void 0 : _g_videoOptions.localVideoStreams)) {
                var _g_videoOptions1, _g_videoOptions2;
                if (1 !== (g === null || g === void 0 ? void 0 : (_g_videoOptions1 = g.videoOptions) === null || _g_videoOptions1 === void 0 ? void 0 : _g_videoOptions1.localVideoStreams.length)) throw new CallingCommunicationError({
                    defaultError: O.CALL.ONLY_SINGLE_VIDEO_STREAM
                });
                if (f = g === null || g === void 0 ? void 0 : (_g_videoOptions2 = g.videoOptions) === null || _g_videoOptions2 === void 0 ? void 0 : _g_videoOptions2.localVideoStreams[0], !(f instanceof LocalVideoStream)) throw new CallingCommunicationError({
                    defaultError: O.CALL.NOT_INSTANCE_OF_LVS
                });
            }
            return f;
        }
        getLocalAudioStreamFromCallOptions(g) {
            var _g_audioOptions;
            let f;
            if (Array.isArray(g === null || g === void 0 ? void 0 : (_g_audioOptions = g.audioOptions) === null || _g_audioOptions === void 0 ? void 0 : _g_audioOptions.localAudioStreams)) {
                var _g_audioOptions1, _g_audioOptions2;
                if (1 !== (g === null || g === void 0 ? void 0 : (_g_audioOptions1 = g.audioOptions) === null || _g_audioOptions1 === void 0 ? void 0 : _g_audioOptions1.localAudioStreams.length)) throw new CallingCommunicationError({
                    defaultError: O.CALL.ONLY_SINGLE_AUDIO_STREAM
                });
                if (f = g === null || g === void 0 ? void 0 : (_g_audioOptions2 = g.audioOptions) === null || _g_audioOptions2 === void 0 ? void 0 : _g_audioOptions2.localAudioStreams[0], !(f instanceof LocalAudioStream)) throw new CallingCommunicationError({
                    defaultError: O.CALL.NOT_INSTANCE_OF_LAS
                });
            }
            return f && (this._userProvidedLocalAudioStreamCache = f), f;
        }
        async _setRawStream(g, f) {
            var _this__callAgent_tsStack;
            if (!getAcsEcsConfig().calling.allowAccessRawMediaStream) throw new CallingCommunicationError({
                defaultError: O.CALL.ACCESS_RAW_MEDIA_STREAM_DISABLED
            });
            const S = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager();
            if (!(S === null || S === void 0 ? void 0 : S.setRawMediaStream)) throw new CallingCommunicationError({
                defaultError: O.CALL.ACCESS_RAW_MEDIA_STREAM_UNDEFINED_FUNC
            });
            try {
                const v = await g.getMediaStream();
                if (!v) throw new CallingCommunicationError({
                    defaultError: O.CALL.SS_RAW_STREAM_UNDEFINED
                });
                S.setRawMediaStream(v, f);
            } catch (g) {
                if (1 === f) throw new CallingCommunicationError({
                    defaultError: O.CALL.VIDEO_SET_MEDIA_STREAM,
                    originalError: g
                });
                if (2 === f) throw new CallingCommunicationError({
                    defaultError: O.CALL.SS_RAW_STREAM_SET,
                    originalError: g
                });
            }
        }
        shallRemoveLvsAfterConnectedSuccessfully(g, f, S, v, _) {
            if (this.tsCall.localMediaStreams.find((g)=>1 === g.mediaType)) this.sendVideoEvent({
                correlationId: S,
                eventName: dy.acs_calling_start_video_success,
                timestampInfo: {
                    deltaTimeInMs: v - _
                },
                localVideoStream: g,
                step: f,
                isScreenSharingOnFlag: this._isScreenSharingOn
            });
            else {
                var _getAcsEcsConfig_calling, _getAcsEcsConfig;
                if (!((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.removeLvsCheckOnCallStartAndCallAccept)) return;
                this.localVideoStream && this.removeLocalVideoStream(this.localVideoStream);
                const v = +new Date, C = new CallingCommunicationError({
                    defaultError: O.CALL.VIDEO_FAILED_TO_START,
                    defaultErrorMessageArgs: [
                        f
                    ]
                });
                this.logger.error(C.message), this.sendVideoEvent({
                    correlationId: S,
                    eventName: dy.acs_calling_start_video_failure,
                    timestampInfo: {
                        deltaTimeInMs: v - _
                    },
                    localVideoStream: g,
                    step: f,
                    isScreenSharingOnFlag: this._isScreenSharingOn
                }, C);
            }
        }
        shallRemoveLasAfterConnectedSuccessfully(g, f, S, v, _) {
            if (this.tsCall.localMediaStreams.find((g)=>0 === g.mediaType)) this.sendRawMediaEvent({
                eventName: dy.acs_calling_start_audio_stream_track,
                callId: this.id,
                localParticipantId: this.tsCall.participantId,
                correlationId: S,
                kindOfEvent: uy.success,
                localAudioStream: g,
                timestampInfo: {
                    deltaTimeInMs: v - _
                },
                additionalDetails: ""
            });
            else {
                if (!getAcsEcsConfig().calling.removeLocalAudioStreamCheckOnCallStartAndCallAccept) return;
                this.removeLocalAudioStream(this.localAudioStreams[0]);
                const v = +new Date;
                this.logger.error(`Removing local audio stream because audio failed to start during call-${f} process.`);
                const C = new CallingCommunicationError({
                    defaultError: O.CALL.AUDIO_FAILED_TO_START,
                    defaultErrorMessageArgs: [
                        f
                    ]
                });
                this.sendRawMediaEvent({
                    eventName: dy.acs_calling_start_audio_stream_track,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: S,
                    localAudioStream: g,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: v - _
                    },
                    additionalDetails: {
                        failureReason: C.message || "",
                        code: C.code,
                        subCode: C.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(C)
                    }
                });
            }
        }
        _enableOrDisable_largeMeeting_videoRendering() {
            try {
                var _this__internalDominantSpeakersListener;
                !this._isHandlingLargeMeetingVideoRendering && this._totalParticipantCount - 1 >= getAcsEcsConfig().rendering.remoteVideo.largeMeeting.participantCountThreshold ? (this._isHandlingLargeMeetingVideoRendering = !0, this._internalDominantSpeakersListener = new DominantSpeakersCallImplOverTsCall(new CallingEventEmitter(this.logger.createChild(()=>`DominanSpeakersFeatureInternal:: Call(id=${this.tsCall.callId})`))), this._internalDominantSpeakersListener.initialize(this.tsCall, this._callAgent, this._telemetryLogManager, this.logger, !0), this.logger.info("Initialized internal dominant speakers listener"), this._internalDominantSpeakersListener.on("dominantSpeakersChanged", ()=>{
                    this.handleDominantSpeakersVideos();
                }), this.handleDominantSpeakersVideos(), this.logger.info("Initialized large meeting video rendering handler")) : this._isHandlingLargeMeetingVideoRendering && (this._totalParticipantCount - 1 >= getAcsEcsConfig().rendering.remoteVideo.largeMeeting.participantCountThreshold ? this.handleDominantSpeakersVideos() : (this._isHandlingLargeMeetingVideoRendering = !1, (_this__internalDominantSpeakersListener = this._internalDominantSpeakersListener) === null || _this__internalDominantSpeakersListener === void 0 ? void 0 : _this__internalDominantSpeakersListener.dispose(), this._internalDominantSpeakersListener = void 0, this.logger.info("Disposed of internal dominant speakers listener"), this.remoteParticipants.forEach((g)=>{
                    g.videoStreams.forEach((g)=>{
                        g.setIsAvailable(g.tsStream.isAvailable);
                    });
                }), this.logger.info("All remote streams isAvailable flags were reset"), this.logger.info("Disposed large meeting video rendering handler")));
            } catch (g) {
                this.logger.error("Failed to handle large meeting video rendering", g);
            }
        }
        handleDominantSpeakersVideos() {
            this.logger.info("Dominant speakers changed during large meeting");
            const g = this.getTopNDominantSpeakersWithVideoOn();
            this.logger.info(`There are currently ${g.length} top-n speakers with video on in the large meeting`), g.forEach((g)=>{
                g.videoStreams.filter((g)=>"Video" === g.mediaStreamType).forEach((g)=>{
                    g.setIsAvailable(g.tsStream.isAvailable);
                });
            }), this._remoteParticipants.filter((f)=>!g.includes(f)).forEach((g)=>{
                g.videoStreams.filter((g)=>"Video" === g.mediaStreamType).forEach((g)=>{
                    try {
                        g.setIsAvailable(!1);
                    } catch (g) {
                        const f = new CallingCommunicationError({
                            defaultError: O.CALL.LARGE_MEETING_FORCE_ISAVAILABLE,
                            originalError: g
                        });
                        this.logger.warn(f.message);
                    }
                    const f = this.activeRemoteVideoStreamViews.get(g.id);
                    f && f.forEach((g)=>{
                        try {
                            g.disposed || (g.dispose(Py.Internal_LargeMeetingVideoRendering), this.logger.info("Successfully disposed of view during large meeting"));
                        } catch (g) {
                            const f = new CallingCommunicationError({
                                defaultError: O.CALL.LARGE_MEETING_DISPOSE_VIEW,
                                originalError: g
                            });
                            this.logger.warn(f.message);
                        }
                    });
                });
            });
        }
        constructor(g, f, S, v, _, C){
            var _this__callAgent_tsStack;
            this._callAgent = f, this._isMuted = !1, this._isMuted_correlationIdCache = generateGuid(), this._isIncomingAudioMuted = !1, this._isIncomingAudioMuted_correlationIdCache = generateGuid(), this._isScreenSharingOn = !1, this._isLocalVideoStarted = !1, this._localVideoStreams = [], this._localAudioStreams = [], this._remoteAudioStreams = [], this._totalParticipantCount = 1, this._isDeviceNotFunctioningMuted = !1, this.__attemptedToRecoverMicNotFunctioningBySDK = !1, this._isMicrophoneMuted = !1, this._disposed = !1, this._lastTsCallState = 0, this._isSpeakerMuted = !1, this._callMode = 0, this._role = qf, this._lastTsCallMeetingDetails = {}, this._isHandlingLargeMeetingVideoRendering = !1, this._joinContextDescription = aS.Unknown, this._remoteParticipantsChangedListeners = [], this._localRingingStateSet = !1, this._networkQualityUfdEventDetails = [], this._audioEffectsProcessorStats = null, this._getIceServersCalledOnce = !1, this._watermarkAudioOnlyFallbackTriggered = !1, this._transportStateTimestamp = new Map, this._isAcsTeamsCall = !1, this._isCteTeamsCall = this._callAgent.isCteUser(), this._mriToRemoteParticipantMap = new Map, this._remoteParticipants = [], this._state = "None", this._transportState = "None", this._allowIPAudio = !0, this._allowIPVideo = !0, this.localVideoStream = void 0, this.localScreenSharingStream = void 0, this._handleMuteChanges = ()=>{
                const g = [
                    BS.Rooms,
                    BS.GroupIdCall,
                    BS.MultiParty,
                    BS.TeamsMeeting
                ].some((g)=>g === this._callInfo.context), f = this.tsCall.conversationType || g ? !!(this.tsCall.isMuted || 10 !== this.tsCall.state && this.tsCall.isServerMuted || this._isDeviceNotFunctioningMuted) : !(!this.tsCall.isMuted && !this._isDeviceNotFunctioningMuted);
                if (this._isMuted != f) {
                    this.logger.info(`isMuted changed from ${this._isMuted} to ${f}`);
                    const g = [];
                    this.tsCall.isMuted && g.push("isMicrophoneMuted"), this.tsCall.isServerMuted && (g.push("isServerMuted"), [
                        3,
                        4,
                        5
                    ].some((g)=>g === this.tsCall.state) && this._eventEmitter.emit("mutedByOthers"), this.explicitConsentStateImp.areCoreCapabilitiesConsentRestricted() && this.explicitConsentStateImp.handleConsentCapabilitiesChanges()), this._isDeviceNotFunctioningMuted && g.push("isDeviceNotFunctioningMuted");
                    let S = "";
                    g.length >= 1 && (S = g.join(", ")), f && (this._isMuted_correlationIdCache = generateGuid()), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                        ...getCallProgressCommonPayload(this, this._callAgent, this._isMuted_correlationIdCache, this._joinContextDescription),
                        step: "isMuted-changed",
                        oldIsMuted: this._isMuted,
                        newIsMuted: f,
                        reason: S
                    }), this._isMuted = f, this._eventEmitter.emit("isMutedChanged");
                }
            }, this.audioSourceChanged = async (g)=>{
                var _g_source, _this__callAgent_tsStack;
                this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_local_audio_source_changed,
                    tenant: nf,
                    properties: {
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        timestampInfo: +new Date,
                        correlationId: generateGuid(),
                        localAudioStream: ((_g_source = g.source) === null || _g_source === void 0 ? void 0 : _g_source.source) instanceof MediaStream ? "MediaStream" : "Device"
                    }
                }), g.source instanceof AudioDeviceInfoImpl ? (this.localAudioStreams[0] && "RawMedia" === this.localAudioStreams[0].mediaStreamType && this.stopAudioInternal(!0), (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager().selectDevices({
                    microphone: g.source.id
                })) : await this.startAudioInternal(g.source, !0);
            }, this._handleIncomingAudioMuteChanges = ()=>{
                const g = this._isSpeakerMuted;
                this._isIncomingAudioMuted != g && (this.logger.info(`newIncomingAudioMuted changed from ${this._isIncomingAudioMuted} to ${g}`), g && (this._isIncomingAudioMuted_correlationIdCache = generateGuid()), sendCallProgressEvent(this._telemetryLogManager, this.logger, {
                    ...getCallProgressCommonPayload(this, this._callAgent, this._isIncomingAudioMuted_correlationIdCache, this._joinContextDescription),
                    step: "isIncomingAudioMuted-changed",
                    oldIsMuted: this._isIncomingAudioMuted,
                    newIsMuted: g,
                    reason: ""
                }), this._isIncomingAudioMuted = g, this._eventEmitter.emit("isIncomingAudioMutedChanged"));
            }, this._id = g.callId, this.tsCall = S, this._direction = g.isIncoming ? "Incoming" : "Outgoing", this._config = g, this.logger = this._callAgent.logger.createChild(()=>`Call:${this._id}:${this._state}`), this._telemetryLogManager = v, this.stats = new CallStats(this.logger, this._telemetryLogManager), this._eventEmitter = new CallingEventEmitter(this.logger), this.activeRemoteVideoStreamViews = new Map, this.isSubscribedCall = !1, this.isBreakoutRoomCall = !1, this._mediaMetricsDeviceEvents = {}, this._kind = _, this._optimalVideoCount = 1, this._ufdsCorrelationIdCache = initializeUfdsCorrelationIdCache(), this._callInfo = new CallInfoCommonImpl(S, {
                config: g
            }), this._callInfo.initialize(this._eventEmitter, this.logger, this._telemetryLogManager), this._speakingWhileMutedManager = new QualityEventLogManager(getAcsEcsConfig().telemetry.speakingWhileMutedThrottleInterval), getAcsEcsConfig().calling.mediaMetricsDeviceEventsEnabled && (this._dmDevicesChangedSub = (_this__callAgent_tsStack = this._callAgent.tsStack) === null || _this__callAgent_tsStack === void 0 ? void 0 : _this__callAgent_tsStack.getDeviceManager().on("devicesChanged", ()=>{
                this.setOrUpdateMediaMetricsDeviceEvents();
            })), this._extensibleApi = new ExtensibleFeatureImpl(this.logger, {
                call: this,
                callAgent: this._callAgent,
                callInfo: this._callInfo
            }, {
                tsCall: this.tsCall,
                callAgent: this._callAgent,
                call: this,
                telemetryLogManager: this._telemetryLogManager
            }), this.explicitConsentStateImp = new ExplicitConsentCallStateManager(this.tsCall, this, f, this._eventEmitter, this.logger), this._capabilityResolver = new CapabilityResolverImpl(this._eventEmitter, this.logger, this, this._callInfo, f, S), this._lobby = new LobbyImpl(this.tsCall, this, this.logger, this._telemetryLogManager);
            const E = getRegisteredFeatures(Fy.CallFeature);
            for (const g of E)"OnExtendedObjectConstructor" === g.activationOptions.activationEvent && this.feature(g);
            this._mmrRdpConnectionManager = new MmrRdpConnectionManager(this.logger), getAcsEcsConfig().telemetry.sendNetworkChangedTelemetry && this._sendNetworkChangedTelemetry(), getAcsEcsConfig().telemetry.deviceChangedEvents.enabled && (this._selectedDeviceManager = new SelectedDeviceManager(this.deviceManager), this._setupSelectedDeviceChangedTelemetry()), this._mediaConstraintsManager = new MediaConstraintsManager(this.tsCall, this.logger, this._telemetryLogManager), this._isAcsTeamsCall = C !== null && C !== void 0 ? C : !1, this.feature(mb.MediaAccess).on("localParticipantMediaAccessChanged", (g)=>{
                this.logger.info(`Call common, time when received localParticipantMediaAccessChanged event: ${(new Date).getTime()}, isAudioPermitted=${g.mediaAccess.isAudioPermitted}, isVideoPermitted=${g.mediaAccess.isVideoPermitted}`), !1 === g.mediaAccess.isVideoPermitted && this.localVideoStream && this.stopVideo(this.localVideoStream);
            });
        }
    }
    __decorate$k([
        loggerProperty,
        __metadata$k("design:type", Object)
    ], CallCommonImpl.prototype, "logger", void 0), __decorate$k([
        syncOperation(IS.BindToCall),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", void 0)
    ], CallCommonImpl.prototype, "bindTsCall", null), __decorate$k([
        syncOperation(IS.Feature),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            Object
        ]),
        __metadata$k("design:returntype", "function" == typeof (Xb = "undefined" != typeof TFeature && TFeature) ? Xb : Object)
    ], CallCommonImpl.prototype, "feature", null), __decorate$k([
        asyncOperation(IS.HangUp),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            Object
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "hangUp", null), __decorate$k([
        asyncOperation(IS.Mute),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "mute", null), __decorate$k([
        asyncOperation(IS.Unmute),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "unmute", null), __decorate$k([
        asyncOperation(IS.MuteAllRemoteParticipants),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "muteAllRemoteParticipants", null), __decorate$k([
        asyncOperation(IS.MuteIncomingAudio),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "muteIncomingAudio", null), __decorate$k([
        asyncOperation(IS.UnmuteIncomingAudio),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "unmuteIncomingAudio", null), __decorate$k([
        asyncOperation(IS.SendDtmf),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            String
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "sendDtmf", null), __decorate$k([
        asyncOperation(IS.StartVideo),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            LocalVideoStream
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "startVideo", null), __decorate$k([
        asyncOperation(IS.StopVideo),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            LocalVideoStream
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "stopVideo", null), __decorate$k([
        asyncOperation(IS.StartAudio),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            LocalAudioStream
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "startAudio", null), __decorate$k([
        validateEmergencyCallOperation(IS.Hold),
        asyncOperation(IS.Hold),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "hold", null), __decorate$k([
        validateEmergencyCallOperation(IS.Resume),
        asyncOperation(IS.Resume),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "resume", null), __decorate$k([
        asyncOperation(IS.StartScreenShare),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            LocalVideoStream
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "startScreenSharing", null), __decorate$k([
        asyncOperation(IS.StopScreenShare),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", []),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "stopScreenSharing", null), __decorate$k([
        asyncOperation(IS.SetConstraints),
        __metadata$k("design:type", Function),
        __metadata$k("design:paramtypes", [
            Object
        ]),
        __metadata$k("design:returntype", Promise)
    ], CallCommonImpl.prototype, "setConstraints", null);
    var __decorate$l = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$l = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class CallImpl extends CallCommonImpl {
        get info() {
            return this._info;
        }
        dispose() {
            super.dispose(), this._extensibleApi.dispose();
        }
        addParticipant(g, f) {
            var _C_customContext, _C_customContext1;
            let v, _;
            const C = f, E = f, T = f, I = +new Date, b = generateGuid();
            if (this.sendParticipantAddedOrRemovedEvent({
                kindOfEvent: uy.attempt,
                participantAddedOrRemoved: "add",
                correlationId: b,
                timestampInfo: {
                    attemptTimestamp: I
                },
                additionalDetails: {
                    customContext: {
                        userToUserPresent: !!(C === null || C === void 0 ? void 0 : (_C_customContext = C.customContext) === null || _C_customContext === void 0 ? void 0 : _C_customContext.userToUser),
                        xHeadersPresent: !!(C === null || C === void 0 ? void 0 : (_C_customContext1 = C.customContext) === null || _C_customContext1 === void 0 ? void 0 : _C_customContext1.xHeaders) && (C === null || C === void 0 ? void 0 : C.customContext.xHeaders.length) > 0
                    }
                }
            }), this._callAgent.isCteUser()) {
                this.validateThreadId(g, f);
                switch(S.getIdentifierKind(g).kind){
                    case "communicationUser":
                        _ = C.threadId;
                        break;
                    case "microsoftTeamsUser":
                        _ = T.threadId;
                        break;
                    case "phoneNumber":
                        _ = E.threadId;
                        break;
                    default:
                        {
                            const g = new CallingCommunicationError({
                                defaultError: O.CALL.ADD_UNKNOWN
                            });
                            throw this.sendParticipantAddedOrRemovedEvent({
                                kindOfEvent: uy.failure,
                                participantAddedOrRemoved: "add",
                                correlationId: b,
                                timestampInfo: {
                                    deltaTimeInMs: +new Date - I
                                },
                                additionalDetails: {
                                    code: g.code,
                                    failureReason: g.message,
                                    ...extractCommunicationServicesErrorForTelemetry(g)
                                }
                            }), g;
                        }
                }
            }
            let A;
            (E === null || E === void 0 ? void 0 : E.alternateCallerId) && (validateIdentifier(E.alternateCallerId), v = getMriFromIdentifier(E.alternateCallerId));
            try {
                if (validateCallConnected(IS.AddParticipant, this.state), A = validateIdentifier(g), !isProxyAndCustomTurnAllowed(this.acsProxy, this.acsCustomRelayManager, !1, A)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
                });
            } catch (g) {
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - I
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }
                }), g;
            }
            if (this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g))) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL.PARTICIPANT_ALREADY_IN_CALL,
                    defaultErrorMessageArgs: [
                        S.getIdentifierKind(g).kind
                    ]
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - I
                    },
                    additionalDetails: {
                        code: f.code,
                        failureReason: f.message,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
            const R = [
                ...this.remoteParticipants.values()
            ].map((g)=>g.identifier);
            this._isAcsTeamsCall = isAcsTeamParticipantPresentInCall([
                ...R,
                g
            ], this._callAgent.kind), getAcsEcsConfig().calling.enableSmePassFakeConversation && this._isAcsTeamsCall && !_ && (_ = this.tsCall.threadId || `${U}${generateGuid()}`);
            const P = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(P);
            const M = this.getOrCreateRemoteParticipant(constructIdentifierKindFromMri(getMriFromIdentifier(g)));
            return this.tsCall.addParticipant(getMriFromIdentifier(g), {
                alternateId: v,
                threadId: _,
                customHeaderContext: processCustomContext(E)
            }, P).then(()=>{
                this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.success,
                    participantAddedOrRemoved: "add",
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - I
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(P)
                });
            }).catch((f)=>{
                const { callEndReason: S } = getRemoteParticipantCallEndReason(this, M.tsRemoteParticipant, f);
                M.callEndReason || M.setCallEndReason(S);
                const v = extractCallEndReasonForTelemetry(S);
                this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: b,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - I
                    },
                    additionalDetails: {
                        code: v === null || v === void 0 ? void 0 : v.callEndReason.code,
                        subCode: v === null || v === void 0 ? void 0 : v.callEndReason.subCode,
                        failureReason: v === null || v === void 0 ? void 0 : v.callEndReason.message,
                        ...v
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(P)
                }), this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g)) && (this.deleteRemoteParticipant(M), this._eventEmitter.emit("remoteParticipantsUpdated", {
                    added: [],
                    removed: [
                        M
                    ]
                }));
            }), M;
        }
        async removeParticipant(g, f) {
            const v = +new Date, _ = generateGuid();
            this.sendParticipantAddedOrRemovedEvent({
                kindOfEvent: uy.attempt,
                participantAddedOrRemoved: "remove",
                correlationId: _,
                timestampInfo: {
                    attemptTimestamp: v
                }
            });
            try {
                validateCallConnected(IS.RemoveParticipant, this.state), validateIdentifier(g);
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_INVALID_IDENTIFIER,
                    originalError: g
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - v
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
            let C = this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g));
            if (!C) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL.PARTICIPANT_NOT_IN_CALL,
                    defaultErrorMessageArgs: [
                        S.getIdentifierKind(g).kind
                    ]
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: f.code,
                        subCode: f.subCode,
                        failureReason: f.message,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
            const E = w.generateCauseId();
            xE.setCauseIdToNetworkInfo(E);
            try {
                await this.tsCall.removeParticipant(getMriFromIdentifier(g)), this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.success,
                    participantAddedOrRemoved: "remove",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(E)
                });
            } catch (g) {
                const f = getRemoteParticipantCallEndReason(this, C.tsRemoteParticipant, g).callEndReason;
                C.callEndReason || C.setCallEndReason(f);
                const S = extractCallEndReasonForTelemetry(f);
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: S === null || S === void 0 ? void 0 : S.callEndReason.code,
                        subCode: S === null || S === void 0 ? void 0 : S.callEndReason.subCode,
                        failureReason: S === null || S === void 0 ? void 0 : S.callEndReason.message,
                        ...S
                    },
                    networkInfo: xE.getRemoveCauseIdToNetworkInfo(E)
                }), new CallingCommunicationError({
                    defaultError: {
                        message: f.message,
                        code: f.code,
                        subCode: f.subCode || 0,
                        resultCategories: f.resultCategories
                    },
                    originalError: g
                });
            }
        }
        validateThreadId(g, f) {
            if (!(f === null || f === void 0 ? void 0 : f.threadId)) throw new CallingCommunicationError({
                defaultError: O.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID
            });
        }
        constructor(f, S, v, _, C){
            super(f, S, v, _, g.CallKind.Call, C), this._info = this.callInfo, this._allowBreakoutRoomJoin = getAcsEcsConfig().calling.breakoutRooms.enabled;
        }
    }
    __decorate$l([
        syncOperation(IS.AddParticipant),
        __metadata$l("design:type", Function),
        __metadata$l("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$l("design:returntype", Object)
    ], CallImpl.prototype, "addParticipant", null), __decorate$l([
        asyncOperation(IS.RemoveParticipant),
        __metadata$l("design:type", Function),
        __metadata$l("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$l("design:returntype", Promise)
    ], CallImpl.prototype, "removeParticipant", null);
    var __decorate$m = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$m = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class IncomingCallCommonImpl {
        get kind() {
            return this._kind;
        }
        get id() {
            return this._callCommon.id;
        }
        get callerInfo() {
            return this._callCommon.callerInfo;
        }
        get transferorInfo() {
            return this._callCommon.transferorInfo;
        }
        get callEndReason() {
            return this._callCommon.callEndReason;
        }
        get customContext() {
            return this._customContext;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        reject() {
            return this._callCommon.reject();
        }
        constructor(g, f){
            this._callCommon = g, this._eventEmitter = new Ny.EventEmitter, this._kind = f, this._callConnected = "Connected" === this._callCommon.state, this._customContext = parseCustomContext(this._callCommon.tsCall), this._callCommon.on("stateChanged", ()=>{
                "Connected" === this._callCommon.state ? this._callConnected = !0 : "Disconnected" !== this._callCommon.state || this._callConnected || this._eventEmitter.emit("callEnded", {
                    callEndReason: this._callCommon.callEndReason
                });
            }), this._callCommon.on("callerInfoChanged", ()=>{
                this._eventEmitter.emit("callerInfoChanged");
            }), this._callCommon.on("transferorInfoChanged", ()=>{
                this._eventEmitter.emit("transferorInfoChanged");
            });
        }
    }
    __decorate$m([
        asyncOperation(),
        __metadata$m("design:type", Function),
        __metadata$m("design:paramtypes", []),
        __metadata$m("design:returntype", Promise)
    ], IncomingCallCommonImpl.prototype, "reject", null);
    var __decorate$n = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$n = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class IncomingCallImpl extends IncomingCallCommonImpl {
        get info() {
            return this._call.info;
        }
        async accept(g) {
            var _this_info;
            if ("microsoftTeamsUser" === ((_this_info = this.info) === null || _this_info === void 0 ? void 0 : _this_info.initiatorKind) && !isProxyAndCustomTurnAllowed(this._call.acsProxy, this._call.acsCustomRelayManager, !0)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
            });
            return await this._call.accept(g), this._call;
        }
        constructor(f){
            super(f, g.IncomingCallKind.IncomingCall), this._call = f;
        }
    }
    __decorate$n([
        asyncOperation(IS.Accept),
        __metadata$n("design:type", Function),
        __metadata$n("design:paramtypes", [
            Object
        ]),
        __metadata$n("design:returntype", Promise)
    ], IncomingCallImpl.prototype, "accept", null);
    class HttpRequestHelper {
        async sendRequestWithRetry(g, f, S, v, _, C = 1, E) {
            if (C > _) throw new Error("Max retry reached");
            v.timeout || (v.timeout = 2e4), v.maxRedirects = 0, this.proxy && (f = this.proxy.proxyfyUrl(f));
            try {
                switch(g){
                    case "post":
                    default:
                        return await CI.post(f, S, v);
                    case "get":
                        return await CI.get(f, v);
                    case "put":
                        return await CI.put(f, S, v);
                    case "delete":
                        return await CI.delete(f, v);
                }
            } catch (T) {
                var _T_response;
                let I = T === null || T === void 0 ? void 0 : (_T_response = T.response) === null || _T_response === void 0 ? void 0 : _T_response.status;
                this.logger.error(`Found error for request ${g} ${f} ${I || ""}`);
                const b = C + 1;
                if (b <= _) {
                    let C = f;
                    if (T && T.response) {
                        if (301 === T.response.status || 302 === T.response.status || 303 === T.response.status || 307 === T.response.status || 404 === T.response.status) C = T.response.headers && T.response.headers.location ? T.response.headers.location : C;
                        else if (T.response.status < 500) throw T;
                    }
                    return this.logger.error(`Retrying, attempt #${b} url=${C}`), await new Promise((g)=>setTimeout(g, E)), this.sendRequestWithRetry(g, C, S, v, _, b, E);
                }
                throw T;
            }
        }
        constructor(g, f){
            this.logger = g, this.proxy = f;
        }
    }
    const Zb = {
        callNotification: "callNotification",
        conversationInvitation: "conversationInvitation",
        debugContent: "debugContent",
        groupContext: "groupContext"
    };
    class IncomingCallPushNotificationHandler {
        get callId() {
            return this._callId;
        }
        get localParticipantId() {
            return this._localParticipantId;
        }
        async process() {
            try {
                if (this._tsCallRegistry.calls.some((g)=>g.callId == this._callId)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_ALREADY_PROCESSED
                });
                const g = defer$1(), callAddedListener = (f)=>{
                    const checkNotified = ()=>{
                        f.callId === this._callId && f.participantId === this._localParticipantId && 1 === f.state && g.resolve();
                    };
                    this._tsCallStateSub = f.on("callStateChanged", checkNotified), checkNotified();
                };
                this._tsCallRegistrySub = this._tsCallRegistry.on("callAdded", callAddedListener);
                const f = {
                    eventId: xf,
                    body: {
                        gp: this._gp
                    }
                };
                if (!this._tsCallRegistry.incomingCallMessageHandler.handleMessage(f)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_FAILED_TO_PROCESS
                });
                setTimeout(()=>{
                    g.isPending() && g.reject(new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_CALL_MISSED
                    }));
                }, 5e3), await g.promise;
            } catch (g) {
                throw g;
            } finally{
                var _this__tsCallRegistrySub, _this__tsCallStateSub;
                (_this__tsCallRegistrySub = this._tsCallRegistrySub) === null || _this__tsCallRegistrySub === void 0 ? void 0 : _this__tsCallRegistrySub.dispose(), (_this__tsCallStateSub = this._tsCallStateSub) === null || _this__tsCallStateSub === void 0 ? void 0 : _this__tsCallStateSub.dispose();
            }
        }
        constructor(g, f, S){
            if (this._callId = "", this._localParticipantId = "", this._logger = S.createChild("IncomingCallPushNotificationHandler"), !g.incomingCallContext) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD_NO_CONTEXT_PROVIDED
            });
            if (Object.keys(g).length > 1) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_PAYLOAD_TOO_MANY_KEYS
            });
            if (this._payload = g, this._incomingCallContext = this._payload.incomingCallContext, this._tsCallRegistry = f, this._gp = JSON.parse(sy.inflate(atob(this._incomingCallContext), {
                to: "string"
            })), !(this._gp.hasOwnProperty(Zb.callNotification) && this._gp.hasOwnProperty(Zb.conversationInvitation) && this._gp.hasOwnProperty(Zb.debugContent) && this._gp.hasOwnProperty(Zb.groupContext))) throw this._logger.error(`Missing incoming call context data. Found: ${Object.keys(this._gp)}`), new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INCOMING_PUSH_NOTIFICATION_INVALID_PAYLOAD
            });
            this._callId = this._gp.debugContent.callId, this._localParticipantId = this._gp.debugContent.participantId;
        }
    }
    const eA = 0, tA = 220004, iA = 220005, nA = 220006, rA = 220007;
    class AcsMiddleTierPolicyService {
        initialize(g) {
            this._localParticipant = g.localParticipant, this._jwtTokenProvider = g.jwtTokenProvider, this._telemetryLogManager = g.telemetryLogManager;
        }
        userDialedNumber(g) {
            this._userDialedPstnNumber = g, this._emergencyNumber = this._userDialedPstnNumber;
        }
        async CreateChatThreadId(g, f) {
            this._callId = g;
            var _f_createThreadIdSuffix;
            const S = +new Date, v = (_f_createThreadIdSuffix = f === null || f === void 0 ? void 0 : f.createThreadIdSuffix) !== null && _f_createThreadIdSuffix !== void 0 ? _f_createThreadIdSuffix : getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix;
            this.sendMiddleTierApiEvent({
                eventName: dy.acs_calling_middletier_gateway_api,
                suffix: v,
                kindOfEvent: uy.attempt
            });
            const _ = await this.getAcsMiddletierServiceRequestHeaderForThreadApi(), C = new URL(v, getAcsEcsConfig().MiddleTier.baseServiceUrl);
            f === null || f === void 0 ? void 0 : f.participants.push({
                id: this._localParticipant
            });
            const E = {
                Participants: f === null || f === void 0 ? void 0 : f.participants
            };
            try {
                const g = await this._httpRequestHelper.sendRequestWithRetry("post", C.toString(), E, {
                    headers: _
                }, getAcsEcsConfig().MiddleTier.maxRetry);
                return this._logger.info("Successfully created chat thread using ACS MiddleTier Service."), this._threadIdData = g === null || g === void 0 ? void 0 : g.data, this.sendMiddleTierApiEvent({
                    eventName: dy.acs_calling_middletier_gateway_api,
                    suffix: v,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - S
                    },
                    additionalDetails: {
                        phrase: "Thread Id was successfully created from ACS MiddleTier Service",
                        code: eA,
                        subCode: nA
                    }
                }), Promise.resolve(this._threadIdData.threadId);
            } catch (g) {
                this._logger.error("Error creating thread Id from ACS MiddleTier Service");
                const f = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED
                });
                throw this.sendMiddleTierApiEvent({
                    eventName: dy.acs_calling_middletier_gateway_api,
                    suffix: v,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - S
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
        }
        async AddParticipantsToThread(g, f) {
            this._callId = g;
            var _f_addParticipantsSuffix;
            const S = +new Date, v = (_f_addParticipantsSuffix = f === null || f === void 0 ? void 0 : f.addParticipantsSuffix) !== null && _f_addParticipantsSuffix !== void 0 ? _f_addParticipantsSuffix : getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.addParticipantSuffix;
            this.sendMiddleTierApiEvent({
                eventName: dy.acs_calling_middletier_gateway_api,
                suffix: v,
                kindOfEvent: uy.attempt
            });
            const _ = await this.getAcsMiddletierServiceRequestHeaderForThreadApi(), C = new URL(v, getAcsEcsConfig().MiddleTier.baseServiceUrl), E = {
                threadId: f === null || f === void 0 ? void 0 : f.threadId,
                Participants: f === null || f === void 0 ? void 0 : f.participants
            };
            try {
                const g = await this._httpRequestHelper.sendRequestWithRetry("post", C.toString(), E, {
                    headers: _
                }, getAcsEcsConfig().MiddleTier.maxRetry);
                this._logger.info("Call to add participants to chat thread using ACS MiddleTier Service");
                const f = g === null || g === void 0 ? void 0 : g.data;
                if (null !== f) {
                    if (!f.isSuccess) throw new CallingCommunicationError({
                        defaultError: O.CTE_MID_TIER_POLICY_SERVICE.ADD_PARTICIPANTS_TO_THREAD_FAILED
                    });
                    f.multipleStatus.length > 0 && 735 == f.multipleStatus[0].statusCode && this._logger.info("Trying to add the same participant to the thread id");
                }
                return this.sendMiddleTierApiEvent({
                    eventName: dy.acs_calling_middletier_gateway_api,
                    suffix: v,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - S
                    },
                    additionalDetails: {
                        phrase: "Successfully add participants from ACS MiddleTier Service",
                        code: eA,
                        subCode: rA
                    }
                }), Promise.resolve(f.isSuccess);
            } catch (g) {
                this._logger.error("Fail to add participant error from ACS MiddleTier Service");
                const f = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.ADD_PARTICIPANTS_TO_THREAD_FAILED
                });
                throw this.sendMiddleTierApiEvent({
                    eventName: dy.acs_calling_middletier_gateway_api,
                    suffix: v,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - S
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
        }
        async fetchUserPoliciesFromAcsMiddleTier(g, f, S) {
            this._policySettingData = await this.requestUserPoliciesFromAcsMiddleTier(g, f, S);
        }
        async requestUserPoliciesFromAcsMiddleTier(g, f, S, v) {
            this._callId = g;
            const _ = +new Date;
            if (this.sendMiddleTierPolicyEvent({
                eventName: dy.acs_calling_middletier_gateway_fetch_policy,
                kindOfEvent: uy.attempt
            }, f), !f) {
                const g = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.TEAMS_USER_ID_NOT_PROVIDED
                });
                throw this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_policy,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - _
                    },
                    additionalDetails: {
                        failureReason: g.message,
                        code: g.code,
                        subCode: g.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }
                }), g;
            }
            let C, E = {};
            S ? (C = new URL(S.policyUrlSuffix, getAcsEcsConfig().MiddleTier.baseServiceUrl), E = {
                id: f,
                userPolicies: S.userPolicies,
                userProperties: S.userProperties
            }) : (C = new URL(getAcsEcsConfig().MiddleTier.policyUrlSuffix, getAcsEcsConfig().MiddleTier.baseServiceUrl), E = {
                id: f
            });
            const T = await this.getAcsMiddletierServiceRequestHeaderForThreadApi(v);
            try {
                const g = await this._httpRequestHelper.sendRequestWithRetry("post", C.toString(), E, {
                    headers: T
                }, getAcsEcsConfig().MiddleTier.maxRetry);
                return this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_policy,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - _
                    },
                    additionalDetails: {
                        phrase: "Teams user policy was fetched successfully from ACS MiddleTier Service",
                        code: eA,
                        subCode: tA
                    }
                }, f), g === null || g === void 0 ? void 0 : g.data;
            } catch (g) {
                const S = handleFetchPoliciesFromAcsMiddleTierFailure(g, O.CTE_MID_TIER_POLICY_SERVICE.FETCH_POLICY);
                throw this._logger.error(S.message), this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_policy,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - _
                    },
                    additionalDetails: {
                        failureReason: S.message,
                        code: S.code,
                        subCode: S.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    }
                }, f), S;
            }
        }
        isEvEnabled() {
            var _this__policySettingData_userAggregatedPolicySettingData, _this__policySettingData;
            const g = (_this__policySettingData = this._policySettingData) === null || _this__policySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData = _this__policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData.userProperties;
            return (g === null || g === void 0 ? void 0 : g.evEnabled) || !1;
        }
        isMoHEnabled() {
            var _this__policySettingData_userAggregatedPolicySettingData_userPolicies, _this__policySettingData_userAggregatedPolicySettingData, _this__policySettingData;
            const g = (_this__policySettingData = this._policySettingData) === null || _this__policySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData = _this__policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData_userPolicies = _this__policySettingData_userAggregatedPolicySettingData.userPolicies) === null || _this__policySettingData_userAggregatedPolicySettingData_userPolicies === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData_userPolicies.teamsCallingPolicy, f = g === null || g === void 0 ? void 0 : g.musicOnHoldEnabledType;
            return this._logger.info("Checking Music on Hold Policy, Enabled Type is: " + f), f === (HS.Enabled || HS.UserOverride);
        }
        isBreakoutRoomsAllowed() {
            var _this__policySettingData_userAggregatedPolicySettingData_userPolicies, _this__policySettingData_userAggregatedPolicySettingData, _this__policySettingData;
            const g = (_this__policySettingData = this._policySettingData) === null || _this__policySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData = _this__policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData_userPolicies = _this__policySettingData_userAggregatedPolicySettingData.userPolicies) === null || _this__policySettingData_userAggregatedPolicySettingData_userPolicies === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData_userPolicies.teamsMeetingPolicy;
            let f = g === null || g === void 0 ? void 0 : g.allowBreakoutRooms;
            return this._logger.info("Allow Breakout rooms from Teams meeting policy is " + f), null == f && (f = !0), f;
        }
        isIPAudioAllowed() {
            var _this__policySettingData_userAggregatedPolicySettingData_userPolicies, _this__policySettingData_userAggregatedPolicySettingData, _this__policySettingData;
            if (!getAcsEcsConfig().calling.mediaAccess.ipMediaPolicyEnabled) return this._logger.info("Allow IP audio is true as feature flag ipAudioVideoPolicyEnabled is false"), !0;
            const g = (_this__policySettingData = this._policySettingData) === null || _this__policySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData = _this__policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData_userPolicies = _this__policySettingData_userAggregatedPolicySettingData.userPolicies) === null || _this__policySettingData_userAggregatedPolicySettingData_userPolicies === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData_userPolicies.teamsMeetingPolicy, f = (g === null || g === void 0 ? void 0 : g.ipAudioMode) !== jS.Disabled;
            return this._logger.info("Allow IP audio from Teams meeting policy is " + f), f;
        }
        isIPVideoAllowed() {
            var _this__policySettingData_userAggregatedPolicySettingData_userPolicies, _this__policySettingData_userAggregatedPolicySettingData, _this__policySettingData;
            if (!getAcsEcsConfig().calling.mediaAccess.ipMediaPolicyEnabled) return this._logger.info("Allow IP video is true as feature flag ipAudioVideoPolicyEnabled is false"), !0;
            const g = (_this__policySettingData = this._policySettingData) === null || _this__policySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData = _this__policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData_userPolicies = _this__policySettingData_userAggregatedPolicySettingData.userPolicies) === null || _this__policySettingData_userAggregatedPolicySettingData_userPolicies === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData_userPolicies.teamsMeetingPolicy, f = (g === null || g === void 0 ? void 0 : g.ipVideoMode) !== jS.Disabled;
            return this._logger.info("Allow IP video from Teams meeting policy is " + f), f;
        }
        getTeamsUserCaptionsPoliciesData() {
            var __featureTypes, _v_teamsCallingPolicy, _v_teamsMeetingPolicy, __featureTypes1;
            const g = +new Date;
            let f = "";
            this.sendMiddleTierPolicyEvent({
                eventName: dy.acs_calling_middletier_gateway_fetch_user_policies_for_captions,
                kindOfEvent: uy.attempt
            });
            const S = this._policySettingData.userAggregatedPolicySettingData, v = S === null || S === void 0 ? void 0 : S.userPolicies, _ = S === null || S === void 0 ? void 0 : S.userProperties;
            if (!(v === null || v === void 0 ? void 0 : v.teamsCallingPolicy)) {
                const f = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_CALLINGPOLICY_FETCHING_FAILED
                });
                this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_user_policies_for_captions,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - g
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                });
            }
            if (!(v === null || v === void 0 ? void 0 : v.teamsMeetingPolicy)) {
                const f = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_MEETINGPOLICY_FETCHING_FAILED
                });
                this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_user_policies_for_captions,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - g
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                });
            }
            if (!(_ === null || _ === void 0 ? void 0 : _.featureTypes)) {
                const f = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.TEAMSUSER_FEATURETYPE_TEAMSPROMGMT_FETCHING_FAILED
                });
                this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_fetch_user_policies_for_captions,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - g
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                });
            }
            var __featureTypes_includes;
            return ((v === null || v === void 0 ? void 0 : v.teamsCallingPolicy) || (v === null || v === void 0 ? void 0 : v.teamsMeetingPolicy) || (_ === null || _ === void 0 ? void 0 : (__featureTypes = _.featureTypes) === null || __featureTypes === void 0 ? void 0 : __featureTypes.includes(pS.TeamsProMgmt))) && (f = JSON.stringify({
                isLiveCaptionsEnabledForCalling: (v === null || v === void 0 ? void 0 : (_v_teamsCallingPolicy = v.teamsCallingPolicy) === null || _v_teamsCallingPolicy === void 0 ? void 0 : _v_teamsCallingPolicy.liveCaptionsEnabledTypeForCalling) === mS.DisabledUserOverride,
                isLiveCaptionsEnabledForMeeting: (v === null || v === void 0 ? void 0 : (_v_teamsMeetingPolicy = v.teamsMeetingPolicy) === null || _v_teamsMeetingPolicy === void 0 ? void 0 : _v_teamsMeetingPolicy.liveCaptionsEnabledType) === mS.DisabledUserOverride,
                isTeamsProMgmtSkuAvailable: (__featureTypes_includes = _ === null || _ === void 0 ? void 0 : (__featureTypes1 = _.featureTypes) === null || __featureTypes1 === void 0 ? void 0 : __featureTypes1.includes(pS.TeamsProMgmt)) !== null && __featureTypes_includes !== void 0 ? __featureTypes_includes : !1
            }), this.sendMiddleTierPolicyEvent({
                eventName: dy.acs_calling_middletier_gateway_fetch_user_policies_for_captions,
                kindOfEvent: uy.success,
                timestampInfo: {
                    deltaTimeInMs: (new Date).getTime() - g
                },
                additionalDetails: {
                    phrase: "Fetching Captions policy from ACS MiddleTier Service response was successful",
                    code: eA
                }
            }), this._logger.info(`Fetching user's captions policy content = ${f}`)), f;
        }
        getEmergencyContent() {
            const g = +new Date;
            this.sendMiddleTierPolicyEvent({
                eventName: dy.acs_calling_middletier_gateway_emergency_content,
                kindOfEvent: uy.attempt
            });
            let f = "";
            try {
                var _v_locationPolicy;
                const S = this._policySettingData.userAggregatedPolicySettingData, v = S === null || S === void 0 ? void 0 : S.userPolicies;
                let _ = !1, C = "";
                if (v === null || v === void 0 ? void 0 : (_v_locationPolicy = v.locationPolicy) === null || _v_locationPolicy === void 0 ? void 0 : _v_locationPolicy.emergencyNumbers) {
                    var _v_locationPolicy1, _v_teamsEmergencyCallingPolicy;
                    const g = v.locationPolicy.emergencyNumbers || [];
                    this.isPhoneNumberInLocationPolicy(g) && (_ = !0, f = JSON.stringify({
                        enableSecurityMemberNotifications: this.isSecurityDeskEnabled(),
                        callerLocation: S === null || S === void 0 ? void 0 : S.userProperties.region,
                        locationPolicyTag: v === null || v === void 0 ? void 0 : (_v_locationPolicy1 = v.locationPolicy) === null || _v_locationPolicy1 === void 0 ? void 0 : _v_locationPolicy1.policyDocument,
                        teamsEmergencyCallingPolicyTag: v === null || v === void 0 ? void 0 : (_v_teamsEmergencyCallingPolicy = v.teamsEmergencyCallingPolicy) === null || _v_teamsEmergencyCallingPolicy === void 0 ? void 0 : _v_teamsEmergencyCallingPolicy.policyDocument
                    }), C = "LocationPolicy");
                }
                if (!_ && (v === null || v === void 0 ? void 0 : v.teamsEmergencyCallRoutingPolicy)) {
                    var _v_teamsEmergencyCallRoutingPolicy, _v_teamsEmergencyCallRoutingPolicy1, _v_teamsEmergencyCallingPolicy1;
                    const g = (v === null || v === void 0 ? void 0 : (_v_teamsEmergencyCallRoutingPolicy = v.teamsEmergencyCallRoutingPolicy) === null || _v_teamsEmergencyCallRoutingPolicy === void 0 ? void 0 : _v_teamsEmergencyCallRoutingPolicy.emergencyNumbers) || [];
                    this.isPhoneNumberInTeamsEmergenencyRoutingPolicy(g) && (_ = !0, f = JSON.stringify({
                        enableSecurityMemberNotifications: this.isSecurityDeskEnabled(),
                        callerLocation: S === null || S === void 0 ? void 0 : S.userProperties.region,
                        teamsEmergencyCallRoutingPolicyTag: v === null || v === void 0 ? void 0 : (_v_teamsEmergencyCallRoutingPolicy1 = v.teamsEmergencyCallRoutingPolicy) === null || _v_teamsEmergencyCallRoutingPolicy1 === void 0 ? void 0 : _v_teamsEmergencyCallRoutingPolicy1.policyDocument,
                        teamsEmergencyCallingPolicyTag: v === null || v === void 0 ? void 0 : (_v_teamsEmergencyCallingPolicy1 = v.teamsEmergencyCallingPolicy) === null || _v_teamsEmergencyCallingPolicy1 === void 0 ? void 0 : _v_teamsEmergencyCallingPolicy1.policyDocument
                    }), C = "TeamsEmergencyCallingRoutingPolicy");
                }
                const E = _ ? `Created Emergency policy using ${C}` : "This is NOT an emergency call";
                return this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_emergency_content,
                    kindOfEvent: uy.success,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - g
                    },
                    additionalDetails: {
                        phrase: "Deriving Emergency policy from ACS MiddleTier Service response was successful",
                        code: eA,
                        subCode: iA
                    }
                }), this._logger.info(`Deriving emergency policy message = ${E}. Emergency Content = ${f}`), f;
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.CTE_MID_TIER_POLICY_SERVICE.DERIVE_EMERGENCY_POLICY,
                    originalError: f
                });
                throw this.sendMiddleTierPolicyEvent({
                    eventName: dy.acs_calling_middletier_gateway_emergency_content,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: (new Date).getTime() - g
                    },
                    additionalDetails: {
                        failureReason: S.message,
                        code: S.code,
                        subCode: S.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    }
                }), S;
            }
        }
        isFetchUserPoliciesAndSettingsApplicable(g, f) {
            return isNullOrUndefined$1(g) || isNullOrUndefined$1(f) || (this._isPolicyFetchApplicable = this.verifyFetchUserPoliciesSettings(g, f)), this._isPolicyFetchApplicable;
        }
        getEmergencyNumber() {
            return this._emergencyNumber;
        }
        getUserDialedPstnNumber() {
            return this._userDialedPstnNumber;
        }
        getUserPolicy() {
            var _this__policySettingData_userAggregatedPolicySettingData;
            return (_this__policySettingData_userAggregatedPolicySettingData = this._policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData.userPolicies;
        }
        getUserProperties() {
            var _this__policySettingData_userAggregatedPolicySettingData;
            return (_this__policySettingData_userAggregatedPolicySettingData = this._policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData.userProperties;
        }
        isPhoneNumberInLocationPolicy(g) {
            if (!isNullOrUndefined$1(g)) {
                var _f_dialMask;
                for (const f of g)if (f.dialString === this._userDialedPstnNumber || !isNullOrUndefined$1((_f_dialMask = f.dialMask) === null || _f_dialMask === void 0 ? void 0 : _f_dialMask.split(";").find((g)=>g === this._userDialedPstnNumber))) return this._emergencyNumber = f.dialString, !0;
            }
            return !1;
        }
        isPhoneNumberInTeamsEmergenencyRoutingPolicy(g) {
            if (!isNullOrUndefined$1(g)) {
                var _f_emergencyDialMask;
                for (const f of g)if (f.emergencyDialString === this._userDialedPstnNumber || !isNullOrUndefined$1((_f_emergencyDialMask = f.emergencyDialMask) === null || _f_emergencyDialMask === void 0 ? void 0 : _f_emergencyDialMask.split(";").find((g)=>g === this._userDialedPstnNumber))) return this._emergencyNumber = f.emergencyDialString, !0;
            }
            return !1;
        }
        verifyFetchUserPoliciesSettings(g, f) {
            const v = getAcsEcsConfig().MiddleTier;
            return v.enabled ? v.userPolicySettingsApi ? g ? Array.isArray(f) && (f.length > 1 || !S.isPhoneNumberIdentifier(f[0])) ? (this._logger.info("Target particpant (Callee) is not a PSTN Number"), !1) : Array.isArray(f) || S.isPhoneNumberIdentifier(f) ? (this._logger.info("Teams user is eligible to fetch policies and settings from MiddleTier Service "), !0) : (this._logger.info("Target particpant (Callee) is not a PSTN Number"), !1) : (this._logger.info("Originator (Caller) is not a Teams User"), !1) : (this._logger.info("ACS MiddleTier Policy API is disabled"), v.userPolicySettingsApi) : (this._logger.info("ACS MiddleTier service is disabled"), v.enabled);
        }
        isSecurityDeskEnabled() {
            var _this__policySettingData_userAggregatedPolicySettingData_userPolicies, _this__policySettingData_userAggregatedPolicySettingData, _g_notificationGroup, _g_notificationDialOutNumber;
            const g = (_this__policySettingData_userAggregatedPolicySettingData = this._policySettingData.userAggregatedPolicySettingData) === null || _this__policySettingData_userAggregatedPolicySettingData === void 0 ? void 0 : (_this__policySettingData_userAggregatedPolicySettingData_userPolicies = _this__policySettingData_userAggregatedPolicySettingData.userPolicies) === null || _this__policySettingData_userAggregatedPolicySettingData_userPolicies === void 0 ? void 0 : _this__policySettingData_userAggregatedPolicySettingData_userPolicies.teamsEmergencyCallingPolicy;
            return !(isNullOrUndefined$1(g === null || g === void 0 ? void 0 : g.notificationGroup) && isNullOrUndefined$1(g === null || g === void 0 ? void 0 : g.notificationDialOutNumber) || 0 == (g === null || g === void 0 ? void 0 : (_g_notificationGroup = g.notificationGroup) === null || _g_notificationGroup === void 0 ? void 0 : _g_notificationGroup.trim().length) && 0 == (g === null || g === void 0 ? void 0 : (_g_notificationDialOutNumber = g.notificationDialOutNumber) === null || _g_notificationDialOutNumber === void 0 ? void 0 : _g_notificationDialOutNumber.trim().length));
        }
        async getAcsMiddletierServiceRequestHeader() {
            return {
                "Content-Type": "application/json",
                "X-Skypetoken": this._jwtTokenProvider ? await this._jwtTokenProvider() : "",
                "Access-Control-Allow-Origin": "*",
                "X-Microsoft-Skype-Chain-ID": this._callId
            };
        }
        async getAcsMiddletierServiceRequestHeaderForThreadApi(g) {
            let f = {};
            return f = await this.getAcsMiddletierServiceRequestHeader(), f.onbehalfOfUser = g !== null && g !== void 0 ? g : this._localParticipant, f;
        }
        sendMiddleTierPolicyEvent(g, f) {
            try {
                var _this__telemetryLogManager;
                this.setDefaultEventData(g, f), (_this__telemetryLogManager = this._telemetryLogManager) === null || _this__telemetryLogManager === void 0 ? void 0 : _this__telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this._logger.debug("Unable to send AcsMiddleTierPolicyService telemetry");
            }
        }
        sendMiddleTierApiEvent(g) {
            try {
                var _this__telemetryLogManager;
                this.setDefaultEventData(g), (_this__telemetryLogManager = this._telemetryLogManager) === null || _this__telemetryLogManager === void 0 ? void 0 : _this__telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this._logger.debug("Unable to send MiddleTier Api telemetry");
            }
        }
        setDefaultEventData(g, f) {
            var _g_timestampInfo, _g_additionalDetails;
            g.callId = this._callId, g.localParticipantId = this._localParticipant, g.requestedParticipantMRI = f !== null && f !== void 0 ? f : this._localParticipant, g.timestampInfo = (_g_timestampInfo = g.timestampInfo) !== null && _g_timestampInfo !== void 0 ? _g_timestampInfo : "", g.additionalDetails = (_g_additionalDetails = g.additionalDetails) !== null && _g_additionalDetails !== void 0 ? _g_additionalDetails : "";
        }
        constructor(g){
            this._httpRequestHelper = g, this._isPolicyFetchApplicable = !1, this._policySettingData = {}, this._threadIdData = {};
            const S = f.createClientLogger("ACS");
            this._logger = new DefaultLogger(S);
        }
    }
    class HardwareInfo {
        get gpu() {
            const g = {};
            try {
                var _this__logger;
                const f = document.createElement("canvas"), S = f.getContext("webgl") || f.getContext("experimental-webgl");
                if (S) {
                    var _this__logger1;
                    const f = S.getExtension("WEBGL_debug_renderer_info");
                    f ? (g.vendor = S.getParameter(f.UNMASKED_VENDOR_WEBGL), g.renderer = S.getParameter(f.UNMASKED_RENDERER_WEBGL)) : (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : _this__logger1.info("Unable to get GPU info: debug renderer info is not supported");
                } else (_this__logger = this._logger) === null || _this__logger === void 0 ? void 0 : _this__logger.info("Unable to get GPU info: WebGL is not supported");
            } catch (g) {
                var _this__logger2;
                (_this__logger2 = this._logger) === null || _this__logger2 === void 0 ? void 0 : _this__logger2.info(`Unable to get GPU info: ${g}`);
            }
            return g;
        }
        get hardwareConcurrency() {
            return navigator.hardwareConcurrency;
        }
        constructor(g){
            this._logger = g;
        }
    }
    var aA, __decorate$o = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$o = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    let sA = 1;
    class CallAgentCommonImpl {
        get kind() {
            return this._kind;
        }
        get connectionState() {
            return this._connectionState;
        }
        getHttpRequestHelper() {
            return this._httpRequestHelper;
        }
        getTrouterState() {
            return this._callStack ? this._callStack.getTrouterState() : "Unknown";
        }
        onTrouterStateChanged(g) {
            return this._callStack.onTrouterStateChanged(g);
        }
        offTrouterStateChanged(g) {
            return this._callStack.offTrouterStateChanged(g);
        }
        onDisposed(g) {
            this._internalEventEmitter.on("disposed", g);
        }
        getAcsResourceId() {
            var _this__parsedTokenCredential;
            return ((_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.acsResourceId) || "";
        }
        getUserMri() {
            var _this__parsedTokenCredential;
            return `8:${(_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.identityMri}` || "";
        }
        getUserPolicy() {
            return this._userPolicies;
        }
        getUserProperties() {
            return this._userProperties;
        }
        async initialize(f, S) {
            const v = +new Date, _ = new HardwareInfo(this.logger), C = {
                gpu: _.gpu,
                hardwareConcurrency: _.hardwareConcurrency
            };
            try {
                var _S_emergencyCallOptions, _S_emergencyCallOptions1, _this__userProperties;
                if (this.sendCallAgentInitializiedEvent(dy.acs_calling_call_agent_init_attempt, {
                    attemptTimestamp: v
                }, C), this._communicationTokenCredential = f, this._parsedTokenCredential = await parseTokenCredential(f, getAcsEcsConfig().calling.eudb.isRgnClaimEnabledForACS, {
                    abortSignal: this._abortController.signal
                }), this._kind !== g.CallAgentKind.TeamsCallAgent || this._parsedTokenCredential.isCte ? this._kind === g.CallAgentKind.CallAgent && this._parsedTokenCredential.isCte && logErrorAndThrow(O.CALL_AGENT.ACS_CALLAGENT_TOKEN_ONLY, this.logger) : logErrorAndThrow(O.CALL_AGENT.TEAMS_CALLAGENT_TOKEN_ONLY, this.logger), S === null || S === void 0 ? void 0 : S.displayName) {
                    if (this._parsedTokenCredential.isCte) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.CTE_DISPLAY_NAME
                    });
                    if ((S === null || S === void 0 ? void 0 : S.displayName.length) > this._maxDisplayNameLength) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.DISPLAY_NAME_TOO_LONG
                    });
                }
                if (this._parsedTokenCredential.cloudType === rm.Public && (!this._parsedTokenCredential.region || "" === this._parsedTokenCredential.region)) {
                    try {
                        const g = +new Date - v;
                        this._telemetryLogManager.sendEvent({
                            name: dy.acs_calling_token_has_no_data_location,
                            tenant: nf,
                            properties: {
                                deltaTimeInMs: g
                            }
                        });
                    } catch (g) {
                        this.logger.debug("Unable to send token has no data location assigned");
                    }
                    this._parsedTokenCredential.region = this._parsedTokenCredential.rgnClaimExists ? gm[0] : hm[0], this.logger.info("Used default data location because token has no data location assigned");
                }
                this._caConfigBag = {
                    clientId: this.clientId,
                    acsResourceId: this._parsedTokenCredential.acsResourceId,
                    identityMri: this._parsedTokenCredential.identityMri,
                    cloudType: this._parsedTokenCredential.cloudType,
                    identityType: this._parsedTokenCredential.isCte ? um.Enterprise : um.Consumer,
                    emergencyCountryCode: S === null || S === void 0 ? void 0 : (_S_emergencyCallOptions = S.emergencyCallOptions) === null || _S_emergencyCallOptions === void 0 ? void 0 : _S_emergencyCallOptions.countryCode,
                    region: this._parsedTokenCredential.region,
                    IsUserEmergencyCountryCode: !!(S === null || S === void 0 ? void 0 : (_S_emergencyCallOptions1 = S.emergencyCallOptions) === null || _S_emergencyCallOptions1 === void 0 ? void 0 : _S_emergencyCallOptions1.countryCode)
                }, this.addToCallAgentsMap(this._parsedTokenCredential), this._disposed = !1;
                try {
                    this.runningEnvironmentInfo = await this._callClient.getEnvironmentInfoInternal();
                } catch (g) {
                    this.logger.debug("Unable to get the running environment info");
                }
                if (this.tsStack = await this._callStack.initializeStackForUser(this.tokenProvider, this._caConfigBag), this._parsedTokenCredential.rgnClaimExists) try {
                    await this.updateParsedTokenCredentials(f);
                } catch (g) {
                    this.logger.debug(`Failed to update parsed token credentials. Error message = ${(g === null || g === void 0 ? void 0 : g.message) || ""}`);
                }
                var _this__userProperties_displayName;
                await this.setUserPoliciesOnAgentInitialization(), this.isCteUser() && (S = {
                    ...S,
                    displayName: (_this__userProperties_displayName = (_this__userProperties = this._userProperties) === null || _this__userProperties === void 0 ? void 0 : _this__userProperties.displayName) !== null && _this__userProperties_displayName !== void 0 ? _this__userProperties_displayName : void 0
                }), this._telemetryLogManager.initialize(this._caConfigBag), this._tsCallRegistry = await this.initializeCallRegistry(this.tsStack, S), this.registerConnectionStateEventHandlers();
                const _ = +new Date;
                this.sendCallAgentInitializiedEvent(dy.acs_calling_call_agent_init_success, {
                    deltaTimeInMs: _ - v
                }, C);
            } catch (g) {
                this._caConfigBag && !this._telemetryLogManager.isInitialized() && this._telemetryLogManager.initialize(this._caConfigBag);
                const f = new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.INIT_FAIL,
                    originalError: g
                });
                this.removeFromCallAgentsMap(this._parsedTokenCredential);
                const S = +new Date;
                throw this.sendCallAgentInitializiedEvent(dy.acs_calling_call_agent_init_failure, {
                    deltaTimeInMs: S - v
                }, C, f), this._telemetryLogManager.clearTelemetryLoggers(), f;
            }
        }
        async setUserPoliciesOnAgentInitialization() {
            this.mtPolicyService.initialize({
                localParticipant: this.getUserMri(),
                jwtTokenProvider: this.tokenProvider,
                telemetryLogManager: this._telemetryLogManager
            });
        }
        isCteUser() {
            var _this__parsedTokenCredential, _this__parsedTokenCredential1;
            return void 0 !== ((_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.isCte) && ((_this__parsedTokenCredential1 = this._parsedTokenCredential) === null || _this__parsedTokenCredential1 === void 0 ? void 0 : _this__parsedTokenCredential1.isCte);
        }
        getClientId() {
            return this.clientId;
        }
        getCallByCallId(g, f) {
            var _this__tsCallRegistry_calls_filter;
            return f ? this._tsCallRegistry.getCall(g, f) : (_this__tsCallRegistry_calls_filter = this._tsCallRegistry.calls.filter((f)=>f.callId === g)) === null || _this__tsCallRegistry_calls_filter === void 0 ? void 0 : _this__tsCallRegistry_calls_filter[0];
        }
        createTransferTargetCall(g) {
            const f = w.generateCauseId(), S = generateGuid(), v = generateGuid(), _ = this._tsCallRegistry.createCall("", S, v, void 0, f), C = this.createNewCall(S, _);
            return this.addToCallArray(C), this.handleCallState(C), _.addParticipant(g.targetMri).catch(()=>{
                this.logger.error("Failed to add participant for transer call");
            }), C.bindTsCall(), this._eventEmitter.emit("callsUpdated", {
                added: [
                    C
                ],
                removed: []
            }), C;
        }
        async subscribeCallWithoutModality(g) {
            const f = w.generateCauseId(), S = this._tsCallRegistry.createCall(g.threadId, g.callId, g.participantId, g.messageId, f), v = this.createNewCall(g.callId, S), _ = {
                conversationUrl: g.meetingUrl,
                conversationId: g.callId
            }, C = {};
            return this.addToCallArray(v), this.handleCallState(v), S.joinCallWithoutCallModality(_, C, f).then(()=>{
                this.logger.info("Successfully joined call without modalities");
            }).catch((g)=>{
                throw this.logger.error("Error while joining call without modalities", g), new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.INVALID_JOIN_LOCATOR,
                    originalError: g
                });
            }), v.bindTsCall(), v;
        }
        getEcsConfigIds() {
            return this._callStack.getEcsConfigIds();
        }
        feature(g) {
            return this._extensibleApi.getApiObjectInstance(g.callAgentApiCtor);
        }
        async handlePushNotification(g) {
            const f = generateGuid(), S = +new Date;
            let v;
            try {
                if (this.sendHandlePushNotificationEvent({
                    eventName: dy.acs_calling_handle_push_notification,
                    correlationId: f,
                    featureName: "handlePushNotification",
                    operationName: "handleIncomingCallPushNotification",
                    callId: "",
                    localParticipantId: "",
                    kindOfEvent: "attempt",
                    timestampInfo: "",
                    additionalDetails: ""
                }), !g.incomingCallContext) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.INVALID_PUSH_NOTIFICATION_DATA
                });
                v = new IncomingCallPushNotificationHandler(g, this._tsCallRegistry, this.logger), await v.process(), this.sendHandlePushNotificationEvent({
                    eventName: dy.acs_calling_handle_push_notification,
                    correlationId: f,
                    featureName: "handlePushNotification",
                    operationName: "handleIncomingCallPushNotification",
                    callId: v.callId,
                    localParticipantId: v.localParticipantId,
                    kindOfEvent: "success",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: ""
                });
            } catch (g) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.PUSH_NOTIFICATION_FAIL,
                    originalError: g
                });
                throw this.sendHandlePushNotificationEvent({
                    eventName: dy.acs_calling_handle_push_notification,
                    correlationId: f,
                    featureName: "handlePushNotification",
                    operationName: "handleIncomingCallPushNotification",
                    callId: (v === null || v === void 0 ? void 0 : v.callId) || "",
                    localParticipantId: (v === null || v === void 0 ? void 0 : v.localParticipantId) || "",
                    kindOfEvent: "failure",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: {
                        failureReason: _.message,
                        code: _.code,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    }
                }), _;
            }
        }
        getDeviceType() {
            var _this__callClient_firstPartyOptions, _this__callClient;
            const g = (_this__callClient = this._callClient) === null || _this__callClient === void 0 ? void 0 : (_this__callClient_firstPartyOptions = _this__callClient.firstPartyOptions) === null || _this__callClient_firstPartyOptions === void 0 ? void 0 : _this__callClient_firstPartyOptions.acsDeviceType;
            return g ? oS[g] : "default";
        }
        isWatermarkSupported() {
            return this.isCteUser() ? getAcsEcsConfig().calling.watermark.watermarkEnabledForCteUsers : getAcsEcsConfig().calling.watermark.watermarkEnabledForAcsUsers;
        }
        trackCallEndTimeToStopTelemetry(g) {
            0 === g.length ? TelemetryLogManager.callEndTimestamp = Date.now() : TelemetryLogManager.callEndTimestamp = Number.MAX_SAFE_INTEGER;
        }
        updateConnectionState(g) {
            var _this__callStack;
            const f = this.getCallAgentConnectionState(), S = this.getTrouterState(), v = ((_this__callStack = this._callStack) === null || _this__callStack === void 0 ? void 0 : _this__callStack.isRegistered()) ? "Connected" : "Disconnected", _ = "Connected" === f ? void 0 : "invalidToken" == g ? "invalidToken" : "connectionIssue";
            if (this.sendCallAgentInfoEvent({
                eventName: dy.acs_calling_call_agent,
                additionalDetails: {
                    step: "connectionState-changed",
                    oldState: this._connectionState,
                    newState: f,
                    trouterState: S,
                    registrarState: v,
                    reason: _,
                    connectionStateSource: g
                }
            }), f !== this._connectionState || _ !== this._connectionStateReason) {
                const g = {
                    oldValue: this._connectionState,
                    newValue: f,
                    reason: _
                };
                this._connectionState = f, this._connectionStateReason = _, this._eventEmitter.emit("connectionStateChanged", g);
            }
        }
        sendCallAgentInfoEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        ...g.additionalDetails
                    }
                });
            } catch (g) {
                this.logger.debug("Failed to send connection state changed event", g);
            }
        }
        sendCallAgentInitializiedEvent(g, f, S, v) {
            try {
                var _this_runningEnvironmentInfo, _this__callClient_firstPartyOptions_acsDeviceType, _this__callClient_firstPartyOptions, _this__callClient;
                let _ = "string" == typeof (v === null || v === void 0 ? void 0 : v.message) ? v === null || v === void 0 ? void 0 : v.message : void 0;
                g !== dy.acs_calling_call_agent_init_failure && (_ = void 0);
                const C = v ? extractCommunicationServicesErrorForTelemetry(v) : void 0, E = this.getEcsConfigIds();
                this._telemetryLogManager.sendEvent({
                    name: g,
                    tenant: nf,
                    properties: {
                        ...f,
                        isSupportedEnvironment: (_this_runningEnvironmentInfo = this.runningEnvironmentInfo) === null || _this_runningEnvironmentInfo === void 0 ? void 0 : _this_runningEnvironmentInfo.isSupportedEnvironment,
                        failureReason: _,
                        additionalProperties: {
                            AcsCallingSDKWeb_ecsConfigIds: E.AcsCallingSDKWeb,
                            SkypeWebMedia_ecsConfigIds: E.SkypeWebMedia
                        },
                        additionalInformation: {
                            trouterState: this.getTrouterState(),
                            hardwareInfo: S
                        },
                        additionalDetails: {
                            ...C,
                            firstPartyOptions: {
                                isDeviceTypeEnabled: getAcsEcsConfig().calling.setDeviceType,
                                deviceTypeRawStrlen: (_this__callClient = this._callClient) === null || _this__callClient === void 0 ? void 0 : (_this__callClient_firstPartyOptions = _this__callClient.firstPartyOptions) === null || _this__callClient_firstPartyOptions === void 0 ? void 0 : (_this__callClient_firstPartyOptions_acsDeviceType = _this__callClient_firstPartyOptions.acsDeviceType) === null || _this__callClient_firstPartyOptions_acsDeviceType === void 0 ? void 0 : _this__callClient_firstPartyOptions_acsDeviceType.length,
                                deviceType: this.getDeviceType()
                            }
                        }
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send telemtery");
            }
        }
        sendHandlePushNotificationEvent(g) {
            try {
                var _this__telemetryLogManager;
                (_this__telemetryLogManager = this._telemetryLogManager) === null || _this__telemetryLogManager === void 0 ? void 0 : _this__telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send handle push notification telemetry");
            }
        }
        async initializeCallRegistry(g, f) {
            const S = f === null || f === void 0 ? void 0 : f.displayName, v = await this.getCallRegistry(g, this._parsedTokenCredential, this.tokenProvider, S);
            return this.logger.info(`registry created for version number=${getSdkVersion()}`), v;
        }
        async getCallRegistry(g, f, S, v) {
            var _getAcsEcsConfig_tsCalling_accountConfiguration, _getAcsEcsConfig_tsCalling, _getAcsEcsConfig, _this__callClient_firstPartyOptions, _getAcsEcsConfig1;
            const _ = {
                id: f.identityMri,
                displayName: v || "",
                tokenProvider: S
            }, C = await g.createCallRegistry(_);
            await C.login(_);
            const E = ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_tsCalling = _getAcsEcsConfig.tsCalling) === null || _getAcsEcsConfig_tsCalling === void 0 ? void 0 : (_getAcsEcsConfig_tsCalling_accountConfiguration = _getAcsEcsConfig_tsCalling.accountConfiguration) === null || _getAcsEcsConfig_tsCalling_accountConfiguration === void 0 ? void 0 : _getAcsEcsConfig_tsCalling_accountConfiguration.ring) || void 0, T = f.isCte ? um.Enterprise : um.Consumer, I = f.acsResourceId, b = f.region;
            let A = {
                acsResourceId: I,
                clientType: T,
                ring: E
            };
            if (getAcsEcsConfig().calling.setDeviceType) A.deviceType = this.getDeviceType();
            else if ((_this__callClient_firstPartyOptions = this._callClient.firstPartyOptions) === null || _this__callClient_firstPartyOptions === void 0 ? void 0 : _this__callClient_firstPartyOptions.acsDeviceType) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.SET_DEVICE_TYPE_NOT_ALLOWED
            });
            const R = getAcsEcsConfig().calling.eudb;
            return R.isEnabled && R.sendRegionToNgc && (R.isRgnClaimEnabledForACS || f.isCte) && (A = {
                ...A,
                region: b
            }), ((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : _getAcsEcsConfig1.calling.supportLiveStreaming) && (A.clientSupportsUms = !0), A.clientSupportsWatermark = this.isWatermarkSupported(), C.setConfiguration(A), C.on("callAdded", this.handleCallAdded), C.on("callRemoved", this.handleCallRemoved), v && C.updateDisplayName(v), C;
        }
        async updateParsedTokenCredentials(g) {
            this._parsedTokenCredential = await parseTokenCredential(g, getAcsEcsConfig().calling.eudb.isRgnClaimEnabledForACS, {
                abortSignal: this._abortController.signal
            }), this._caConfigBag.region = this._parsedTokenCredential.region;
        }
        registerConnectionStateEventHandlers() {
            this._callStack.onRegisteredChanged(this._registrarStateChangeCallback), this.onTrouterStateChanged(this._trouterStateChangeCallback);
        }
        getCallAgentConnectionState() {
            var _this__callStack;
            return ((_this__callStack = this._callStack) === null || _this__callStack === void 0 ? void 0 : _this__callStack.isRegistered()) && "Connected" === this.getTrouterState() ? "Connected" : "Disconnected";
        }
        constructor(g, f, S, v, _, C, E){
            var _getAcsEcsConfig_calling, _getAcsEcsConfig, _getAcsEcsConfig_calling1, _getAcsEcsConfig1;
            this._callClient = g, this._disposed = !1, this.tokenProvider = async (g)=>{
                const f = +new Date;
                let S;
                try {
                    var _this__parsedTokenCredential, _this__parsedTokenCredential1;
                    if (this.sendTokenChangedEvent({
                        kindOfEvent: "attempt",
                        timestampInfo: {
                            attemptTimestamp: f
                        },
                        oldTokenExpiration: this._oldTokenExpiration
                    }), !this._communicationTokenCredential) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.GET_TOKEN_BEFORE_INIT
                    });
                    S = await parseTokenCredential(this._communicationTokenCredential, getAcsEcsConfig().calling.eudb.isRgnClaimEnabledForACS, {
                        abortSignal: this._abortController.signal
                    }), S.acsResourceId === ((_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.acsResourceId) && S.identityMri === ((_this__parsedTokenCredential1 = this._parsedTokenCredential) === null || _this__parsedTokenCredential1 === void 0 ? void 0 : _this__parsedTokenCredential1.identityMri) || logErrorAndThrow(O.CALL_AGENT.REFRESHED_TOKEN_INVALID_USERID, this.logger), g ? this._tokenFetchTries += 1 : this._tokenFetchTries = 0, this._tokenFetchTries > this._maxNmberOfRetries && (this.updateConnectionState("invalidToken"), this._disposed || await this.dispose(), logErrorAndThrow(O.CALL_AGENT.REFRESHED_TOKEN_RETRIES, this.logger));
                    const v = +new Date;
                    return this.sendTokenChangedEvent({
                        kindOfEvent: "success",
                        timestampInfo: {
                            deltaTimeInMs: v - f
                        },
                        oldTokenExpiration: this._oldTokenExpiration,
                        newTokenExpiration: S.exp,
                        isTokenChanged: this._oldToken !== S.jwtToken
                    }), this._oldToken = S.jwtToken, this._oldTokenExpiration = S.exp, S.jwtToken;
                } catch (g) {
                    const v = {
                        kindOfEvent: "failure",
                        timestampInfo: {
                            deltaTimeInMs: +new Date - f
                        },
                        oldTokenExpiration: this._oldTokenExpiration
                    };
                    throw S && (v.newTokenExpiration = S.exp, v.isTokenChanged = this._oldToken !== S.jwtToken, this._oldToken = S.jwtToken, this._oldTokenExpiration = S.exp), this.sendTokenChangedEvent(v, g), g;
                }
            }, this.sendTokenChangedEvent = (g, f)=>{
                try {
                    let S = {
                        kindOfEvent: g.kindOfEvent,
                        timestampInfo: g.timestampInfo,
                        oldTokenExpiration: g.oldTokenExpiration
                    };
                    void 0 !== g.newTokenExpiration && (S.newTokenExpiration = g.newTokenExpiration), void 0 !== g.isTokenChanged && (S.isTokenChanged = g.isTokenChanged), f && (S = {
                        ...S,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }), this._telemetryLogManager.sendEvent({
                        name: dy.acs_calling_token_expiration_changed,
                        tenant: nf,
                        properties: S
                    });
                } catch (g) {
                    this.logger.debug("Unable to send token change telemetry");
                }
            }, this.logger = f.createChild("CallAgent" + sA++), this._telemetryLogManager = v, this._kind = C, this._connectionState = "Disconnected", this._eventEmitter = new CallingEventEmitter(this.logger), this._internalEventEmitter = new Ny.EventEmitter, this.clientId = S, this._abortController = new AbortController, this._maxDisplayNameLength = ((_getAcsEcsConfig = getAcsEcsConfig()) === null || _getAcsEcsConfig === void 0 ? void 0 : (_getAcsEcsConfig_calling = _getAcsEcsConfig.calling) === null || _getAcsEcsConfig_calling === void 0 ? void 0 : _getAcsEcsConfig_calling.maxDisplayNameLength) || Df, this._oldToken = "", this._oldTokenExpiration = 0, this._tokenFetchTries = 0, this._maxNmberOfRetries = ((_getAcsEcsConfig1 = getAcsEcsConfig()) === null || _getAcsEcsConfig1 === void 0 ? void 0 : (_getAcsEcsConfig_calling1 = _getAcsEcsConfig1.calling) === null || _getAcsEcsConfig_calling1 === void 0 ? void 0 : _getAcsEcsConfig_calling1.maxNumberOfTokenFetchRetries) || Cf, this._callStack = _, this.acsProxy = this._callClient.acsProxy, this.acsCustomRelayManager = this._callClient.acsCustomRelayManager, this._httpRequestHelper = new HttpRequestHelper(this.logger, this.acsProxy), this.mtPolicyService = new AcsMiddleTierPolicyService(this._httpRequestHelper), this._parsedTokenCredential = {
                jwtToken: "",
                acsResourceId: void 0,
                identityMri: "",
                cloudType: rm.Public,
                isCte: !1,
                region: "",
                rgnClaimExists: !1,
                exp: 0
            }, this._caConfigBag = {
                clientId: "",
                acsResourceId: this._parsedTokenCredential.acsResourceId,
                identityMri: this._parsedTokenCredential.identityMri,
                cloudType: this._parsedTokenCredential.cloudType,
                identityType: this._parsedTokenCredential.isCte ? um.Enterprise : um.Consumer,
                region: this._parsedTokenCredential.region,
                emergencyCountryCode: void 0,
                IsUserEmergencyCountryCode: !1
            }, this.deviceManager = E, this._extensibleApi = new ExtensibleFeatureImpl(this.logger, {
                callClient: this._callClient,
                callAgent: this
            }, {
                tsStack: this.tsStack,
                callAgent: this,
                telemetryLogManager: this._telemetryLogManager
            });
            const T = getRegisteredFeatures(Fy.CallAgentFeature);
            for (const g of T)"OnExtendedObjectConstructor" === g.activationOptions.activationEvent && this.feature(g);
            this._trouterStateChangeCallback = (g)=>{
                this.logger.log(`Callback Trouter state changed to ${g}`), this.updateConnectionState("trouterChanged");
            }, this._registrarStateChangeCallback = (g)=>{
                this.logger.log(`Callback Registrar state changed to ${g}`), this.updateConnectionState("registrarChanged");
            };
        }
    }
    __decorate$o([
        loggerProperty,
        __metadata$o("design:type", Object)
    ], CallAgentCommonImpl.prototype, "logger", void 0), __decorate$o([
        asyncOperation(TS.Initialize),
        __metadata$o("design:type", Function),
        __metadata$o("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$o("design:returntype", Promise)
    ], CallAgentCommonImpl.prototype, "initialize", null), __decorate$o([
        syncOperation(TS.Feature),
        __metadata$o("design:type", Function),
        __metadata$o("design:paramtypes", [
            Object
        ]),
        __metadata$o("design:returntype", "function" == typeof (aA = "undefined" != typeof TFeature && TFeature) ? aA : Object)
    ], CallAgentCommonImpl.prototype, "feature", null), __decorate$o([
        asyncOperation(TS.HandlePushNotification),
        __metadata$o("design:type", Function),
        __metadata$o("design:paramtypes", [
            Object
        ]),
        __metadata$o("design:returntype", Promise)
    ], CallAgentCommonImpl.prototype, "handlePushNotification", null);
    var __decorate$p = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$p = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class CallAgentImpl extends CallAgentCommonImpl {
        get calls() {
            return this._calls;
        }
        addToCallAgentsMap(g) {
            CallAgentImpl.callAgents.get(g === null || g === void 0 ? void 0 : g.identityMri) && logErrorAndThrow(O.CALL_AGENT.ACS_CALLAGENT_ALREADY_EXSISTS, this.logger), CallAgentImpl.callAgents.set(g === null || g === void 0 ? void 0 : g.identityMri, this);
        }
        removeFromCallAgentsMap(g) {
            (g === null || g === void 0 ? void 0 : g.identityMri) && CallAgentImpl.callAgents.get(g === null || g === void 0 ? void 0 : g.identityMri) === this && CallAgentImpl.callAgents.delete(g === null || g === void 0 ? void 0 : g.identityMri);
        }
        disposeCall(g) {
            const f = this._calls.indexOf(g);
            -1 !== f && this._calls.splice(f, 1), g.dispose(), this.trackCallEndTimeToStopTelemetry(this._calls);
        }
        async getExistingCallAgentWithToken(g) {
            try {
                const f = await parseTokenCredential(g, getAcsEcsConfig().calling.eudb.isRgnClaimEnabledForACS);
                return CallAgentImpl.callAgents.get(f.identityMri);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.PARSE_ACCESSTOKEN,
                    originalError: g
                });
            }
        }
        createNewCall(g, f) {
            return new CallImpl({
                callId: g
            }, this, f, this._telemetryLogManager);
        }
        addToCallArray(g) {
            this._calls.push(g), this.trackCallEndTimeToStopTelemetry(this._calls);
        }
        startCall(g, f) {
            var _f_audioOptions;
            if (this.assertCallUserIds(g), (f === null || f === void 0 ? void 0 : f.alternateCallerId) && validateIdentifier(f.alternateCallerId), g.find((g)=>getMriFromIdentifier(g) === this.getUserMri())) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.CANT_CALL_YOURSELF
            });
            let S = f === null || f === void 0 ? void 0 : (_f_audioOptions = f.audioOptions) === null || _f_audioOptions === void 0 ? void 0 : _f_audioOptions.muted;
            return void 0 === S && (S = !1), this.logger.info(`startCall with video=${!!(f === null || f === void 0 ? void 0 : f.videoOptions)},muted=${S}`), this.createCall({
                participants: g,
                startCallOptions: f
            });
        }
        join(g, f) {
            var _f_audioOptions;
            if (!isProxyAndCustomTurnAllowed(this.acsProxy, this.acsCustomRelayManager, !1, void 0, g)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
            });
            this.assertCallContext(g);
            let S = f === null || f === void 0 ? void 0 : (_f_audioOptions = f.audioOptions) === null || _f_audioOptions === void 0 ? void 0 : _f_audioOptions.muted;
            return void 0 === S && (S = !1), this.logger.info(`join with video=${!!(f === null || f === void 0 ? void 0 : f.videoOptions)},muted=${S}`), this.createCall({
                callContext: g,
                startCallOptions: f
            });
        }
        async dispose() {
            var _this__parsedTokenCredential, _this__parsedTokenCredential1;
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.ACS_ALREADY_DISPOSED
            });
            this._disposed = !0, this._abortController.abort(), this._extensibleApi.dispose(), ((_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.identityMri) && CallAgentImpl.callAgents.delete((_this__parsedTokenCredential1 = this._parsedTokenCredential) === null || _this__parsedTokenCredential1 === void 0 ? void 0 : _this__parsedTokenCredential1.identityMri);
            try {
                var _this__callStack;
                const g = this._tokenFetchTries > this._maxNmberOfRetries;
                await ((_this__callStack = this._callStack) === null || _this__callStack === void 0 ? void 0 : _this__callStack.dispose(g));
            } catch (g) {
                this.logger.error("Call Agent failed to dispose to Call Stack");
            }
            this.offTrouterStateChanged(this._trouterStateChangeCallback), this._callStack.offRegisteredChanged(this._registrarStateChangeCallback), delete this._callStack, this._telemetryLogManager.clearTelemetryLoggers(), this._eventEmitter.removeAllListeners(), this._internalEventEmitter.emit("disposed"), this._internalEventEmitter.removeAllListeners();
        }
        on(g, f) {
            if ("incomingCall" !== g && "callsUpdated" !== g && "connectionStateChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("incomingCall" !== g && "callsUpdated" !== g && "connectionStateChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        createCall(g) {
            var _g_startCallOptions_firstPartyOptions, _g_startCallOptions, _g_callContext, _g_startCallOptions1, _g_callContext1, _g_callContext2, _g_callContext3, _g_callContext4, _g_callContext5, _g_callContext6, _g_callContext7, _g_callContext8, _g_callContext9, _g_callContext10, _g_callContext11, _g_callContext12, _g_callContext13;
            if ((g === null || g === void 0 ? void 0 : (_g_startCallOptions = g.startCallOptions) === null || _g_startCallOptions === void 0 ? void 0 : (_g_startCallOptions_firstPartyOptions = _g_startCallOptions.firstPartyOptions) === null || _g_startCallOptions_firstPartyOptions === void 0 ? void 0 : _g_startCallOptions_firstPartyOptions.isImmersiveMode) && "meshV2" !== this.getDeviceType()) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.MESH_DEVICETYPE_V2
            });
            let f, S, v, _ = (g === null || g === void 0 ? void 0 : (_g_callContext = g.callContext) === null || _g_callContext === void 0 ? void 0 : _g_callContext.threadId) || (g === null || g === void 0 ? void 0 : (_g_startCallOptions1 = g.startCallOptions) === null || _g_startCallOptions1 === void 0 ? void 0 : _g_startCallOptions1.threadId), C = !1, E = g === null || g === void 0 ? void 0 : (_g_callContext1 = g.callContext) === null || _g_callContext1 === void 0 ? void 0 : _g_callContext1.groupId;
            const T = g === null || g === void 0 ? void 0 : (_g_callContext2 = g.callContext) === null || _g_callContext2 === void 0 ? void 0 : _g_callContext2.roomId, I = g === null || g === void 0 ? void 0 : (_g_callContext3 = g.callContext) === null || _g_callContext3 === void 0 ? void 0 : _g_callContext3.meetingLink, b = g === null || g === void 0 ? void 0 : (_g_callContext4 = g.callContext) === null || _g_callContext4 === void 0 ? void 0 : _g_callContext4.meetingId, A = (g === null || g === void 0 ? void 0 : (_g_callContext5 = g.callContext) === null || _g_callContext5 === void 0 ? void 0 : _g_callContext5.passcode) || "";
            if (E && E.startsWith("19:") && (_ = E, E = ""), I) {
                if (isLongMeetingUrl(I)) S = parseLongMeetingLink(I);
                else {
                    if (!isShortMeetingUrl(I, this.logger)) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.INVALID_MEETING_LINK
                    });
                    if (isTflMeetingLink(I.trim().toLocaleLowerCase(), getAcsEcsConfig().calling.tfl.hosts) && !getAcsEcsConfig().calling.tfl.isEnabled) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.UNSUPPORTED_TFL_MEETING_JOIN
                    });
                    C = !0;
                }
            }
            if ((g === null || g === void 0 ? void 0 : (_g_callContext6 = g.callContext) === null || _g_callContext6 === void 0 ? void 0 : _g_callContext6.threadId) && (g === null || g === void 0 ? void 0 : (_g_callContext7 = g.callContext) === null || _g_callContext7 === void 0 ? void 0 : _g_callContext7.organizerId) && (g === null || g === void 0 ? void 0 : (_g_callContext8 = g.callContext) === null || _g_callContext8 === void 0 ? void 0 : _g_callContext8.tenantId) && (S = {
                threadId: g === null || g === void 0 ? void 0 : (_g_callContext9 = g.callContext) === null || _g_callContext9 === void 0 ? void 0 : _g_callContext9.threadId,
                messageId: (g === null || g === void 0 ? void 0 : (_g_callContext10 = g.callContext) === null || _g_callContext10 === void 0 ? void 0 : _g_callContext10.messageId) ? g === null || g === void 0 ? void 0 : (_g_callContext11 = g.callContext) === null || _g_callContext11 === void 0 ? void 0 : _g_callContext11.messageId.toString() : "0",
                organizerId: g === null || g === void 0 ? void 0 : (_g_callContext12 = g.callContext) === null || _g_callContext12 === void 0 ? void 0 : _g_callContext12.organizerId,
                tenantId: g === null || g === void 0 ? void 0 : (_g_callContext13 = g.callContext) === null || _g_callContext13 === void 0 ? void 0 : _g_callContext13.tenantId
            }), S && (v = {
                meetingType: "0" === S.messageId ? 1 : 2,
                tenantId: S.tenantId,
                organizerId: S.organizerId,
                replyChainMessageId: S.messageId
            }, _ = S.threadId, f = S.messageId), this.tsStack) {
                const S = w.generateCauseId(), R = generateGuid(), P = generateGuid();
                let M, O = !1;
                E ? M = this._tsCallRegistry.createCallWithGroupId(E, R, P, S) : b ? M = this._tsCallRegistry.createCallWithMeetingData({
                    meetingCode: b,
                    passcode: A,
                    threadId: _
                }, R, P, S) : T ? M = this._tsCallRegistry.createCallWithMeetingData({
                    meetingCode: T
                }, R, P, S) : C ? M = this._tsCallRegistry.createCallWithMeetingData({
                    meetingUrl: I
                }, R, P, S) : (O = !!(g === null || g === void 0 ? void 0 : g.participants) && g.participants.length >= 2 && isAcsTeamParticipantPresentInCall(g.participants, this.kind), getAcsEcsConfig().calling.enableSmePassFakeConversation && !_ && O && (_ = `${U}${generateGuid()}`), M = this._tsCallRegistry.createCall(_ || "", R, P, f, S));
                const D = new CallImpl({
                    callId: R,
                    roomId: T
                }, this, M, this._telemetryLogManager, O);
                this.addToCallArray(D), this.handleCallState(D);
                const N = {
                    threadId: _ || "",
                    messageId: f || "",
                    meetingInfo: v,
                    mediaPeerType: 2
                };
                return (g === null || g === void 0 ? void 0 : g.participants) && (g === null || g === void 0 ? void 0 : g.participants.forEach((g)=>{
                    M.addParticipant(getMriFromIdentifier(g)).catch(()=>{
                        this.logger.error("Failed to add participant during call start");
                    });
                })), D.startCallInternal(g === null || g === void 0 ? void 0 : g.startCallOptions, !!b || !!T, g === null || g === void 0 ? void 0 : g.callContext, N).catch(noop), D.bindTsCall(), this._eventEmitter.emit("callsUpdated", {
                    added: [
                        D
                    ],
                    removed: []
                }), D;
            }
            throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.STACK_NOT_INIT
            });
        }
        assertCallContext(g) {
            if (!g || this.checkForAtLeastOneValidCallConfig(g) || this.checkIfMultiplesConfigsWereSpecified(g) || this.checkForInvalidTeamsMeetingCoordinates(g)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INVALID_JOIN_LOCATOR
            });
        }
        checkForAtLeastOneValidCallConfig(g) {
            return !(g.threadId || g.meetingLink || g.groupId || g.meetingId || g.roomId);
        }
        checkIfMultiplesConfigsWereSpecified(g) {
            return g.threadId && g.groupId || g.groupId && g.meetingLink;
        }
        checkForInvalidTeamsMeetingCoordinates(g) {
            return !g.threadId && g.tenantId && g.organizerId || g.threadId && (g.organizerId && !g.tenantId || !g.organizerId && g.tenantId);
        }
        assertCallUserIds(g) {
            assertIsObject(g, O.CALL_AGENT.USERIDS_MUST_BE_OBJECTS), assertNotNull(g, O.CALL_AGENT.USERIDS_CANNOT_BE_NULL), assertIsArrayOfIdentifiers(g), g.forEach((g)=>{
                const f = validateIdentifier(g);
                if (!isProxyAndCustomTurnAllowed(this.acsProxy, this.acsCustomRelayManager, !1, f)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
                });
            });
        }
        constructor(f, S, v, _, C, E, T){
            super(f, S, _, C, v, g.CallAgentKind.CallAgent, E), this._calls = [], this.handleCallRemoved = (g)=>{
                this.logger.info(`removing callId=${g.callId}`);
                const f = this._calls.find((f)=>f.id === g.callId);
                if (f) {
                    if (f.isBreakoutRoomCall) {
                        const g = getAcsEcsConfig().calling.breakoutRooms.hangUpCallDelayInMilliSeconds;
                        setTimeout(()=>{
                            this.disposeCall(f);
                        }, g);
                    } else this.disposeCall(f);
                    this._eventEmitter.emit("callsUpdated", {
                        added: [],
                        removed: [
                            f
                        ]
                    }), this.logger.info("call removed");
                }
            }, this.handleCallAdded = (g)=>{
                if (!this._calls.find((f)=>f.id === g.callId)) {
                    const f = g.on("callStateChanged", ()=>{
                        if (1 === g.state) {
                            const S = g.callId;
                            f.dispose();
                            const v = new CallImpl({
                                callId: S,
                                isIncoming: !0
                            }, this, g, this._telemetryLogManager), _ = new IncomingCallImpl(v);
                            this.handleCallState(v), v.bindTsCall(), this._eventEmitter.emit("incomingCall", {
                                incomingCall: _
                            });
                        }
                    });
                }
            }, this.handleCallState = (g)=>{
                g.on("stateChanged", ()=>{
                    try {
                        if ("Disconnected" === g.state) this.tsStack ? (this._tsCallRegistry.deleteCall(g.tsCall) || this.logger.error(`Failed to remove call from registry, call id: ${g.id}`), g.stats.flushEvents(), this._telemetryLogManager.flushAllEvents(g.id).catch(()=>{
                            this.logger.error("Failed to flush telemetry log manager events");
                        })) : this.logger.info("Unable to remove call from registry");
                        else "Connecting" === g.state && "Incoming" == g.direction && (this.addToCallArray(g), this._eventEmitter.emit("callsUpdated", {
                            added: [
                                g
                            ],
                            removed: []
                        }));
                    } catch (g) {
                        this.logger.error("Failed to handle call state changed event");
                    }
                });
            }, this.displayName = T === null || T === void 0 ? void 0 : T.displayName;
        }
    }
    CallAgentImpl.callAgents = new Map, __decorate$p([
        syncOperation(TS.StartCall),
        __metadata$p("design:type", Function),
        __metadata$p("design:paramtypes", [
            Array,
            Object
        ]),
        __metadata$p("design:returntype", Object)
    ], CallAgentImpl.prototype, "startCall", null), __decorate$p([
        syncOperation(TS.Join),
        __metadata$p("design:type", Function),
        __metadata$p("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$p("design:returntype", Object)
    ], CallAgentImpl.prototype, "join", null), __decorate$p([
        asyncOperation(TS.Dispose),
        __metadata$p("design:type", Function),
        __metadata$p("design:paramtypes", []),
        __metadata$p("design:returntype", Promise)
    ], CallAgentImpl.prototype, "dispose", null);
    class EcsProvider {
        getTrouterTelemetryConfig() {
            return {
                enabled: this._TrouterJScriptClient.TelemetryEnabled,
                ...this._TrouterJScriptClient.ClientTelemetryEventEnabled
            };
        }
        getJamaSettings() {
            const g = getBrowserInfo();
            let f = this._JamaSettings;
            return "Mobile" == g.formFactor && (f = {
                ...f,
                ...this._JamaSettingsMobile
            }), f;
        }
        getClientInformation() {
            const g = getAcsEcsConfig().telemetry.reportSdkUaToService, f = getAcsEcsConfig().telemetry.reportEnvToService;
            return `ACSWeb(${getPlatformId()}/${getSdkInternalVersion()})` + (f ? `/${getInternalEnvInfo()}` : "") + (g ? `/(${this.sdkDiagnosticInformation})` : "");
        }
        getJsCsaConfig() {
            return this._JsCsaConfig.useInternalHttpDispatcher = !(this._acsProxy.hasProxyUrl() || getAcsEcsConfig().telemetry.sendNetworkInfo), {
                ...this._JsCsaConfig,
                clientInformation: this.getClientInformation()
            };
        }
        getMdnTrapSettings() {
            return this._MDNTrapSettings;
        }
        getTrouterSettings() {
            return this._trouterSettings;
        }
        setConfig(g, f) {
            var _f_ConfigIDs, _f_ConfigIDs1, _f_SkypeWebMedia;
            this._logger.info("Update ECS settings");
            const S = getAcsEcsConfig().calling.applicationSettingsUrls, v = getAcsEcsConfig().calling.applicationSettingsEudbUrls, _ = g && isEudbConfigurationsApplicable(g.identityType, g.region);
            if ((g === null || g === void 0 ? void 0 : g.identityType) == um.Enterprise) _ ? (this._trouterSettings.trouterServiceUrl = v.Enterprise_TrouterServiceUrl_EUDB, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(v.Enterprise_RegistrarServiceUrl_EUDB)) : (this._trouterSettings.trouterServiceUrl = S.Enterprise_TrouterServiceUrl, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(S.Enterprise_RegistrarServiceUrl));
            else switch(g === null || g === void 0 ? void 0 : g.cloudType){
                case rm.Public:
                    _ && (this._trouterSettings.trouterServiceUrl = v.Public_TrouterServiceUrl_EUDB, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(v.Public_RegistrarServiceUrl_EUDB), this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(v.Public_ConversationServiceUrl_EUDB), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(v.Public_MdnTrapServiceUrl_EUDB), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(v.Public_MdnTrapServiceTokenUrl_EUDB), this._MDNTrapSettings.Relay.Skype.fqdns = [
                        v.Public_MdnTrapRelaySkypeFqdns_EUDB
                    ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                        v.Public_MdnTrapRelayTurnFqdns_EUDB
                    ], this._MDNTrapSettings.Relay.Turn.url = v.Public_MdnTrapRelayTurnUrl_EUDB);
                    break;
                case rm.GccHigh:
                    this._trouterSettings.trouterServiceUrl = S.GccHigh_TrouterServiceUrl, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(S.GccHigh_RegistrarServiceUrl);
                    break;
                case rm.Dod:
                    this._trouterSettings.trouterServiceUrl = S.Dod_TrouterServiceUrl, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(S.Dod_RegistrarServiceUrl);
                    break;
                case rm.AirGap08:
                    this._trouterSettings.trouterServiceUrl = S.AirGap08_TrouterServiceUrl, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(S.AirGap08_RegistrarServiceUrl);
                    break;
                case rm.AirGap09:
                    this._trouterSettings.trouterServiceUrl = S.AirGap09_TrouterServiceUrl, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(S.AirGap09_RegistrarServiceUrl);
            }
            if (f) this._configIds = {
                AcsCallingSDKWeb: (f === null || f === void 0 ? void 0 : (_f_ConfigIDs = f.ConfigIDs) === null || _f_ConfigIDs === void 0 ? void 0 : _f_ConfigIDs.AcsCallingSDKWeb) || "",
                SkypeWebMedia: (f === null || f === void 0 ? void 0 : (_f_ConfigIDs1 = f.ConfigIDs) === null || _f_ConfigIDs1 === void 0 ? void 0 : _f_ConfigIDs1.SkypeWebMedia) || ""
            }, this.setConfigOrDefault(f === null || f === void 0 ? void 0 : f.SkypeCalling, this._JsCsaConfig), this.setConfigOrDefault(f === null || f === void 0 ? void 0 : f.MDN_TRAP, this._MDNTrapSettings), this.setConfigOrDefault(f === null || f === void 0 ? void 0 : (_f_SkypeWebMedia = f.SkypeWebMedia) === null || _f_SkypeWebMedia === void 0 ? void 0 : _f_SkypeWebMedia.mediaAgent, this._JamaSettings), this.setConfigOrDefault(f === null || f === void 0 ? void 0 : f.TrouterJScriptClient, this._TrouterJScriptClient);
            else if ((g === null || g === void 0 ? void 0 : g.identityType) === um.Enterprise) _ ? (this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(v.Enterprise_ConversationServiceUrl_EUDB), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(v.Enterprise_MdnTrapServiceUrl_EUDB), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(v.Enterprise_MdnTrapServiceTokenUrl_EUDB), this._MDNTrapSettings.Relay.Skype.fqdns = [
                v.Enterprise_MdnTrapRelaySkypeFqdns_EUDB
            ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                v.Enterprise_MdnTrapRelayTurnFqdns_EUDB
            ], this._MDNTrapSettings.Relay.Turn.url = v.Enterprise_MdnTrapRelayTurnUrl_EUDB) : (this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(S.Enterprise_ConversationServiceUrl), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(S.Enterprise_MdnTrapServiceUrl), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(S.Enterprise_MdnTrapServiceTokenUrl), this._MDNTrapSettings.Relay.Skype.fqdns = [
                S.Enterprise_MdnTrapRelaySkypeFqdns
            ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                S.Enterprise_MdnTrapRelayTurnFqdns
            ], this._MDNTrapSettings.Relay.Turn.url = S.Enterprise_MdnTrapRelayTurnUrl);
            else switch(g === null || g === void 0 ? void 0 : g.cloudType){
                case rm.Public:
                    _ && (this._trouterSettings.trouterServiceUrl = v.Public_TrouterServiceUrl_EUDB, this._trouterSettings.registrarServiceUrl = this._acsProxy.proxyfyUrl(v.Public_RegistrarServiceUrl_EUDB), this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(v.Public_ConversationServiceUrl_EUDB), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(v.Public_MdnTrapServiceUrl_EUDB), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(v.Public_MdnTrapServiceTokenUrl_EUDB), this._MDNTrapSettings.Relay.Skype.fqdns = [
                        v.Public_MdnTrapRelaySkypeFqdns_EUDB
                    ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                        v.Public_MdnTrapRelayTurnFqdns_EUDB
                    ], this._MDNTrapSettings.Relay.Turn.url = v.Public_MdnTrapRelayTurnUrl_EUDB);
                    break;
                case rm.GccHigh:
                    this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(S.GccHigh_ConversationServiceUrl), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(S.GccHigh_MdnTrapServiceUrl), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(S.GccHigh_MdnTrapServiceTokenUrl), this._MDNTrapSettings.Relay.Skype.fqdns = [
                        S.GccHigh_MdnTrapRelaySkypeFqdns
                    ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                        S.GccHigh_MdnTrapRelayTurnFqdns
                    ], this._MDNTrapSettings.Relay.Turn.url = S.GccHigh_MdnTrapRelayTurnUrl;
                    break;
                case rm.Dod:
                    this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(S.Dod_ConversationServiceUrl), this._MDNTrapSettings.Service.url = this._acsProxy.proxyfyUrl(S.Dod_MdnTrapServiceUrl), this._MDNTrapSettings.Service.tokenUrl = this._acsProxy.proxyfyUrl(S.Dod_MdnTrapServiceTokenUrl), this._MDNTrapSettings.Relay.Skype.fqdns = [
                        S.Dod_MdnTrapRelaySkypeFqdns
                    ], this._MDNTrapSettings.Relay.Turn.fqdns = [
                        S.Dod_MdnTrapRelayTurnFqdns
                    ], this._MDNTrapSettings.Relay.Turn.url = S.Dod_MdnTrapRelayTurnUrl;
                    break;
                case rm.AirGap08:
                    this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(S.AirGap08_ConversationServiceUrl);
                    break;
                case rm.AirGap09:
                    this._JsCsaConfig.conversationServiceUrl = this._acsProxy.proxyfyUrl(S.AirGap09_ConversationServiceUrl);
            }
        }
        getConfigIds() {
            return this._configIds;
        }
        assertConfigs(g) {
            var _g_SkypeWebMedia;
            const f = "SkypeCalling", S = "MDN_TRAP", v = "SkypeWebMedia", _ = "SkypeWebMedia.mediaAgent", C = "TrouterJScriptClient";
            let E = [];
            if ((g === null || g === void 0 ? void 0 : g.SkypeCalling) || E.push(f), (g === null || g === void 0 ? void 0 : g.MDN_TRAP) || E.push(S), (g === null || g === void 0 ? void 0 : g.SkypeWebMedia) ? (g === null || g === void 0 ? void 0 : (_g_SkypeWebMedia = g.SkypeWebMedia) === null || _g_SkypeWebMedia === void 0 ? void 0 : _g_SkypeWebMedia.mediaAgent) || E.push(_) : E.push(v), (g === null || g === void 0 ? void 0 : g.TrouterJScriptClient) || E.push(C), E.length > 0) {
                const g = new CallingCommunicationError({
                    defaultError: O.CALL_STACK.FOUND_UNDEFINED_CONFIGS,
                    defaultErrorMessageArgs: [
                        E.join(", ")
                    ]
                });
                throw this._logger.error(g.message), g;
            }
        }
        constructor(g, f, S){
            this._configIds = {
                AcsCallingSDKWeb: "",
                SkypeWebMedia: ""
            }, this.setConfigOrDefault = (g, f)=>{
                g && Object.keys(g).forEach((S)=>{
                    void 0 !== g[S] && (f[S] = g[S]);
                });
            }, this._logger = g, this.sdkDiagnosticInformation = f, this._acsProxy = S;
            const v = getAcsEcsConfig().calling.applicationSettingsUrls;
            this._trouterSettings = {
                version: `${getPlatformId()}/${getSdkInternalVersion()}`,
                productName: "AcsWeb",
                trouterServiceUrl: v.Public_TrouterServiceUrl,
                registrarServiceUrl: v.Public_RegistrarServiceUrl,
                maxRegistrationTimeInMs: 36e5,
                pnhAppId: "AcsWeb",
                pnhTemplate: "AcsWeb_2.0",
                environment: "Prod",
                platform: getPlatformName()
            }, this._JsCsaConfig = {
                languageCode: "en",
                emergencyCallCountry: "",
                autoResolveConflictedCall: !1,
                handleRosterFromCreateAndJoin: !0,
                conversationServiceUrl: S.proxyfyUrl(v.Public_ConversationServiceUrl),
                useInternalHttpDispatcher: !0,
                supportsHostlessGroupCalls: !0,
                doHostlessCalling: !0,
                shouldServiceSendCallEventMessages: !0,
                shouldServiceSendNGCUpgradeMessages: !0,
                supportsCompressedServicePayload: !0,
                handleNewOfferRequest: !0,
                handleMediaOfferFromPushNotification: !0,
                isWebRtcEnabled: !0,
                supportsSynchronousTrouterResponse: !0,
                autoJoinOnConflict: !0,
                brokerEnabledOutgoing: !0,
                brokerEnabledIncoming: !0,
                brokerExclusively: !1,
                brokerRequestBatching: !0,
                isGVCOutgoingEnabled: !0,
                isGVCJoiningEnabled: !0,
                enableTokenCache: !1
            }, this._JamaSettingsMobile = {
                webrtcCameraOpenFs: 900,
                webrtcMultipartyMaxScalingFs: 900,
                webrtcMaxScalingFs: 900
            }, this._JamaSettings = {
                debug: !1,
                numVideoChannelsGvc: 6,
                webcv: null
            }, this._MDNTrapSettings = {
                Service: {
                    url: S.proxyfyUrl(v.Public_MdnTrapServiceUrl),
                    tokenUrl: S.proxyfyUrl(v.Public_MdnTrapServiceTokenUrl)
                },
                Relay: {
                    Skype: {
                        addresses: [],
                        fqdns: [
                            v.Public_MdnTrapRelaySkypeFqdns
                        ],
                        tcpPort: 443,
                        udpPort: 3478
                    },
                    Turn: {
                        addresses: [],
                        fqdns: [
                            v.Public_MdnTrapRelayTurnFqdns
                        ],
                        tcpPort: 443,
                        udpPort: 3478,
                        url: v.Public_MdnTrapRelayTurnUrl
                    }
                },
                Http: {
                    connectionTimeout: 30,
                    requestTimeout: 60
                },
                Token: {
                    earlyRefreshMinutes: 1080,
                    earlyRefreshPercentage: 25
                }
            }, this._TrouterJScriptClient = {
                TelemetryEnabled: !1,
                ClientTelemetryEventEnabled: {
                    trouter_js_client_connected: !1,
                    trouter_js_client_disconnected: !1,
                    trouter_js_client_error: !1,
                    trouter_js_client_progress: !1,
                    trouter_js_client_response: !1,
                    trouter_js_client_check_connection: !1,
                    trouter_js_client_registration: !1,
                    trouter_js_client_unregistration: !1,
                    logHealthCheckError: !1,
                    logSendPingError: !1,
                    numberOfStepsToMaintain: 0,
                    sendProgressTimeoutSecs: 0
                }
            };
        }
    }
    var oA, lA = createCommonjsModule(function(g, f) {
        var S;
        S = function() {
            return function(g) {
                function e(S) {
                    if (f[S]) return f[S].exports;
                    var v = f[S] = {
                        i: S,
                        l: !1,
                        exports: {}
                    };
                    return g[S].call(v.exports, v, v.exports, e), v.l = !0, v.exports;
                }
                var f = {};
                return e.m = g, e.c = f, e.i = function(g) {
                    return g;
                }, e.d = function(g, f, S) {
                    e.o(g, f) || Object.defineProperty(g, f, {
                        configurable: !1,
                        enumerable: !0,
                        get: S
                    });
                }, e.n = function(g) {
                    var f = g && g.__esModule ? function() {
                        return g.default;
                    } : function() {
                        return g;
                    };
                    return e.d(f, "a", f), f;
                }, e.o = function(g, f) {
                    return Object.prototype.hasOwnProperty.call(g, f);
                }, e.p = "", e(e.s = 1);
            }([
                function(g, f, S) {
                    function n(g, f) {
                        var S, v = new Promise(function(f, v) {
                            fetch(g).then(function(g) {
                                void 0 !== S && clearTimeout(S), f(g);
                            }).catch(function(g) {
                                void 0 !== S && clearTimeout(S), v(g);
                            });
                        });
                        if (0 !== f) {
                            var _ = new Promise(function(v, _) {
                                S = setTimeout(_, f, new Error("Fetch for '".concat(g.url, "' timed out")));
                            });
                            return Promise.race([
                                v,
                                _
                            ]);
                        }
                        return v;
                    }
                    function o(g) {
                        try {
                            return JSON.stringify(g);
                        } catch (f) {
                            return "Unable to serialize object of type ".concat(typeof g);
                        }
                    }
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.Timespan = f.toJson = f.fetchWithTimeout = void 0, f.fetchWithTimeout = n, f.toJson = o;
                    var v = function() {
                        function t() {
                            this.start = Date.now();
                        }
                        return Object.defineProperty(t.prototype, "duration", {
                            get: function() {
                                return Date.now() - this.start;
                            },
                            enumerable: !1,
                            configurable: !0
                        }), Object.defineProperty(t.prototype, "startTime", {
                            get: function() {
                                return this.start;
                            },
                            enumerable: !1,
                            configurable: !0
                        }), t.prototype.reset = function() {
                            this.start = Date.now();
                        }, t;
                    }();
                    f.Timespan = v;
                },
                function(g, f, S) {
                    function n(g, f, S) {
                        return new R(g, f, S);
                    }
                    var v = this && this.__extends || function() {
                        var t = function(g, f) {
                            return (t = Object.setPrototypeOf || ({
                                __proto__: []
                            }) instanceof Array && function(g, f) {
                                g.__proto__ = f;
                            } || function(g, f) {
                                for(var S in f)Object.prototype.hasOwnProperty.call(f, S) && (g[S] = f[S]);
                            })(g, f);
                        };
                        return function(g, f) {
                            function n() {
                                this.constructor = g;
                            }
                            if ("function" != typeof f && null !== f) throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
                            t(g, f), g.prototype = null === f ? Object.create(f) : (n.prototype = f.prototype, new n);
                        };
                    }(), _ = this && this.__assign || function() {
                        return _ = Object.assign || function(g) {
                            for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                            return g;
                        }, _.apply(this, arguments);
                    }, C = this && this.__awaiter || function(g, f, S, v) {
                        function o(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    c(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                try {
                                    c(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                g.done ? S(g.value) : o(g.value).then(s, a);
                            }
                            c((v = v.apply(g, f || [])).next());
                        });
                    }, E = this && this.__generator || function(g, f) {
                        function r(g) {
                            return function(f) {
                                return n([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function n(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: r(0),
                            throw: r(1),
                            return: r(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.createRegistrarClient = f.RegistrarClient = void 0;
                    var T = S(0), I = [
                        "skype",
                        "aad",
                        "cae"
                    ], b = function(g) {
                        function e(f) {
                            var S = g.call(this, f) || this;
                            return S.name = "CancelationError", S;
                        }
                        return v(e, g), e;
                    }(Error), A = function() {
                        function t(g, f, S) {
                            this.logger = g, this.maxBackoffInMs = f, this.initialDelay = S, this.backoffCount = 0, this.id = ++t.idCounter;
                        }
                        return t.prototype.delay = function(g) {
                            var f = this;
                            if (void 0 !== this.timerHandle) throw new Error("Retry sequence logical failure");
                            if (-1 === this.backoffCount) return new Promise(function(g, f) {
                                f(new b("Cancelled"));
                            });
                            var S = this.calculateNextBackoffMs();
                            return this.backoffCount++, this.logger.info("[RegistrarClient] Backing off ".concat(g, " for ").concat(S, " milliseconds with ID ").concat(this.id)), new Promise(function(v, _) {
                                f.cancelFunc = _, f.timerHandle = setTimeout(function() {
                                    f.logger.info("[RegistrarClient] Back off for ".concat(g, " with ID ").concat(f.id, " complete")), f.timerHandle = void 0, v();
                                }, S);
                            });
                        }, t.prototype.cancel = function() {
                            void 0 !== this.timerHandle && (this.logger.debug("Resetting back off"), clearTimeout(this.timerHandle), void 0 !== this.cancelFunc && this.cancelFunc(new b("Cancelled"))), this.backoffCount = -1;
                        }, t.prototype.calculateNextBackoffMs = function() {
                            var g = 1 + .4 * (Math.random() - .5), f = this.initialDelay * Math.pow(2, this.backoffCount) * g;
                            return f = Math.round(f), Math.min(this.maxBackoffInMs, f);
                        }, t.idCounter = 0, t;
                    }(), R = function() {
                        function t(g, f, S) {
                            var v;
                            this.logger = g, this.tokenProvider = f, this.options = S, this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN = 15, this.DEFAULT_MAX_BACKOFF_TIME_IN_MS = 3e5, this.backoffs = {}, this.maxBackOffTime = this.options.maxRetryDelayMs > 0 ? this.options.maxRetryDelayMs : this.DEFAULT_MAX_BACKOFF_TIME_IN_MS, this.maxRetriesForGetToken = void 0 === S.maxRetriesForGetToken || null === S.maxRetriesForGetToken ? this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN : S.maxRetriesForGetToken, this.proxyUrlRewrite = null !== (v = S.proxyUrlRewrite) && void 0 !== v ? v : function(g) {
                                return g;
                            };
                        }
                        return t.prototype.setTelemetryLogger = function(g) {
                            this.eventLogger = g;
                        }, t.prototype.register = function(g, f) {
                            return C(this, void 0, void 0, function() {
                                return E(this, function(S) {
                                    switch(S.label){
                                        case 0:
                                            return [
                                                4,
                                                this.performRegistration(g, f, "pr_set_registration")
                                            ];
                                        case 1:
                                            return S.sent(), this.cachedRegistrationParams = [
                                                g,
                                                f
                                            ], [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.unregister = function() {
                            return C(this, void 0, void 0, function() {
                                var g;
                                return E(this, function(f) {
                                    switch(f.label){
                                        case 0:
                                            return this.logger.info("[RegistrarClient] sending unregister request"), g = new Request(this.proxyUrlRewrite("".concat(this.options.registrarUrl, "/").concat(this.options.registrationId)), {
                                                method: "DELETE",
                                                mode: "cors",
                                                headers: new Headers(_(_({}, this.options.extraRegistrationHeaders), {
                                                    accept: "application/json, text/javascript"
                                                }))
                                            }), [
                                                4,
                                                this.callRegistrar(g, "pr_delete_registration")
                                            ];
                                        case 1:
                                            return f.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.cancelPendingRequests = function() {
                            var g = this;
                            Object.keys(this.backoffs).forEach(function(f) {
                                g.backoffs[f].cancel();
                            }), this.backoffs = {};
                        }, t.prototype.resendRegistration = function() {
                            return C(this, void 0, void 0, function() {
                                return E(this, function(g) {
                                    switch(g.label){
                                        case 0:
                                            if (!this.cachedRegistrationParams) throw new Error("Re-registration failed because there is no registration parameters cached");
                                            return [
                                                4,
                                                this.performRegistration(this.cachedRegistrationParams[0], this.cachedRegistrationParams[1], "pr_resend_registration")
                                            ];
                                        case 1:
                                            return g.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.performRegistration = function(g, f, S) {
                            return C(this, void 0, void 0, function() {
                                var v, C;
                                return E(this, function(E) {
                                    switch(E.label){
                                        case 0:
                                            return this.logger.info("[RegistrarClient] Sending register request"), v = {
                                                clientDescription: g,
                                                registrationId: this.options.registrationId,
                                                nodeId: "",
                                                transports: f
                                            }, C = new Request(this.proxyUrlRewrite(this.options.registrarUrl), {
                                                method: "POST",
                                                mode: "cors",
                                                headers: new Headers(_(_({}, this.options.extraRegistrationHeaders), {
                                                    "content-type": "application/json",
                                                    accept: "application/json, text/javascript"
                                                })),
                                                body: (0, T.toJson)(v)
                                            }), [
                                                4,
                                                this.callRegistrar(C, S)
                                            ];
                                        case 1:
                                            return E.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.startBackoff = function() {
                            var g = new A(this.logger, this.maxBackOffTime, this.options.initialRetryDelayMs);
                            return this.backoffs[g.id] = g, g;
                        }, t.prototype.stopBackoff = function(g) {
                            g.cancel(), delete this.backoffs[g.id];
                        }, t.prototype.getToken = function(g) {
                            return C(this, void 0, void 0, function() {
                                var f, S, v, _, C, T, b;
                                return E(this, function(E) {
                                    switch(E.label){
                                        case 0:
                                            f = this.startBackoff(), S = 0, E.label = 1;
                                        case 1:
                                            return E.trys.push([
                                                1,
                                                3,
                                                ,
                                                8
                                            ]), this.logger.info("[RegistrarClient] Asking for a new token"), [
                                                4,
                                                this.tokenProvider({
                                                    needFresh: !0,
                                                    supportedTokenTypes: I,
                                                    wwwAuthenticateHeader: g,
                                                    purpose: "registrar"
                                                })
                                            ];
                                        case 2:
                                            return v = E.sent(), this.stopBackoff(f), [
                                                2,
                                                v
                                            ];
                                        case 3:
                                            _ = E.sent(), E.label = 4;
                                        case 4:
                                            return E.trys.push([
                                                4,
                                                6,
                                                ,
                                                7
                                            ]), S++, C = JSON.stringify(_), S > this.maxRetriesForGetToken ? (T = "[RegistrarClient] getToken retry limit hit. Will not retry now. Error: ".concat(C), this.logger.error(T), this.stopBackoff(f), [
                                                2,
                                                Promise.reject(T)
                                            ]) : (this.logger.warn("[RegistrarClient] Retrying for a new token. Retry Count: ".concat(S, " Error: ").concat(C)), [
                                                4,
                                                f.delay("Fetching a new token")
                                            ]);
                                        case 5:
                                            return E.sent(), [
                                                3,
                                                8
                                            ];
                                        case 6:
                                            throw b = E.sent(), this.stopBackoff(f), b;
                                        case 7:
                                            return [
                                                3,
                                                8
                                            ];
                                        case 8:
                                            return [
                                                3,
                                                1
                                            ];
                                        case 9:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.callRegistrar = function(g, f) {
                            var S, v, _;
                            return C(this, void 0, void 0, function() {
                                var C, b, A, R, P, w, M, O, D, N, k, L, F, x, U, V;
                                return E(this, function(E) {
                                    switch(E.label){
                                        case 0:
                                            return C = this.startBackoff(), [
                                                4,
                                                this.tokenProvider({
                                                    needFresh: !1,
                                                    supportedTokenTypes: I,
                                                    wwwAuthenticateHeader: void 0,
                                                    purpose: "registrar"
                                                })
                                            ];
                                        case 1:
                                            b = E.sent(), this.setTokenHeader(g, b), A = new T.Timespan, R = 0, E.label = 2;
                                        case 2:
                                            P = void 0, E.label = 3;
                                        case 3:
                                            return E.trys.push([
                                                3,
                                                10,
                                                15,
                                                16
                                            ]), w = g.clone(), [
                                                4,
                                                (0, T.fetchWithTimeout)(w, this.options.requestTimeoutMs)
                                            ];
                                        case 4:
                                            return 401 !== (P = E.sent()).status ? [
                                                3,
                                                8
                                            ] : ++R > this.maxRetriesForGetToken ? (M = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '".concat(g.url, "' failed with ").concat(P.status, " ").concat(P.statusText), this.logger.error(M), this.stopBackoff(C), [
                                                2,
                                                Promise.reject(M)
                                            ]) : (this.logger.warn("[RegistrarClient] Retry Count ".concat(R, ". Request '").concat(g.url, "' failed with ").concat(P.status, " ").concat(P.statusText)), O = null !== (v = null === (S = P.headers) || void 0 === S ? void 0 : S.get("www-authenticate")) && void 0 !== v ? v : void 0, D = this.setTokenHeader, N = [
                                                g
                                            ], [
                                                4,
                                                this.getToken(O)
                                            ]);
                                        case 5:
                                            return D.apply(this, N.concat([
                                                E.sent()
                                            ])), R > 1 ? [
                                                4,
                                                C.delay("Registrar call retry after 401")
                                            ] : [
                                                3,
                                                7
                                            ];
                                        case 6:
                                            E.sent(), E.label = 7;
                                        case 7:
                                            return [
                                                3,
                                                22
                                            ];
                                        case 8:
                                            if (P.status >= 500 && P.status < 600) throw new Error("Fetch for '".concat(g.url, "' failed with ").concat(P.status, " ").concat(P.statusText));
                                            E.label = 9;
                                        case 9:
                                            return [
                                                3,
                                                16
                                            ];
                                        case 10:
                                            k = E.sent(), this.logger.error("[RegistrarClient] Request failed with ".concat(k)), E.label = 11;
                                        case 11:
                                            return E.trys.push([
                                                11,
                                                13,
                                                ,
                                                14
                                            ]), [
                                                4,
                                                C.delay("Registrar call retry")
                                            ];
                                        case 12:
                                            return E.sent(), [
                                                3,
                                                22
                                            ];
                                        case 13:
                                            throw L = E.sent(), this.logger.error("[RegistrarClient] Request cancelled"), this.stopBackoff(C), L;
                                        case 14:
                                            return [
                                                3,
                                                16
                                            ];
                                        case 15:
                                            return this.sendTelemetryEvent(f, g, P, A), [
                                                7
                                            ];
                                        case 16:
                                            return this.stopBackoff(C), P.ok ? [
                                                2,
                                                P
                                            ] : [
                                                3,
                                                17
                                            ];
                                        case 17:
                                            F = void 0, E.label = 18;
                                        case 18:
                                            return E.trys.push([
                                                18,
                                                20,
                                                ,
                                                21
                                            ]), U = (x = JSON).stringify, [
                                                4,
                                                P.json()
                                            ];
                                        case 19:
                                            return F = U.apply(x, [
                                                E.sent()
                                            ]), [
                                                3,
                                                21
                                            ];
                                        case 20:
                                            return E.sent(), F = "no details", [
                                                3,
                                                21
                                            ];
                                        case 21:
                                            throw V = "Fetch for '".concat(g.url, "' failed with ").concat(P.status, " ").concat(P.statusText, " (").concat(F, ", MS-CV: ").concat(null === (_ = P.headers) || void 0 === _ ? void 0 : _.get("MS-CV"), ")"), this.logger.error("[RegistrarClient] ".concat(V)), new Error(V);
                                        case 22:
                                            return [
                                                3,
                                                2
                                            ];
                                        case 23:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.setTokenHeader = function(g, f) {
                            switch(g.headers.delete("X-Skypetoken"), g.headers.delete("Authorization"), g.headers.delete("X-MS-Migration"), f.tokenType.toLowerCase()){
                                case "skype":
                                    g.headers.set("X-Skypetoken", f.token);
                                    break;
                                case "aad":
                                case "cae":
                                    g.headers.set("Authorization", "Bearer ".concat(f.token));
                                    break;
                                default:
                                    throw new Error("unsupported token type: ".concat(f.tokenType));
                            }
                            !1 === this.options.usingLegacyTokenApi && g.headers.set("X-MS-Migration", "True");
                        }, t.prototype.sendTelemetryEvent = function(g, f, S, v) {
                            if (void 0 !== this.eventLogger) {
                                var _ = {
                                    name: g,
                                    properties: {
                                        url: {
                                            value: f.url
                                        },
                                        result_code: {
                                            value: void 0 !== S ? S.status : 0
                                        },
                                        begin_timestamp: {
                                            value: v.startTime
                                        },
                                        elapsed: {
                                            value: v.duration
                                        }
                                    }
                                };
                                this.eventLogger.logEvent(_);
                            }
                        }, t;
                    }();
                    f.RegistrarClient = R, f.createRegistrarClient = n;
                }
            ]);
        }, g.exports = S();
    }), cA = createCommonjsModule(function(g, f) {
        var S;
        S = function(g) {
            return function(g) {
                function e(S) {
                    if (f[S]) return f[S].exports;
                    var v = f[S] = {
                        i: S,
                        l: !1,
                        exports: {}
                    };
                    return g[S].call(v.exports, v, v.exports, e), v.l = !0, v.exports;
                }
                var f = {};
                return e.m = g, e.c = f, e.i = function(g) {
                    return g;
                }, e.d = function(g, f, S) {
                    e.o(g, f) || Object.defineProperty(g, f, {
                        configurable: !1,
                        enumerable: !0,
                        get: S
                    });
                }, e.n = function(g) {
                    var f = g && g.__esModule ? function() {
                        return g.default;
                    } : function() {
                        return g;
                    };
                    return e.d(f, "a", f), f;
                }, e.o = function(g, f) {
                    return Object.prototype.hasOwnProperty.call(g, f);
                }, e.p = "", e(e.s = 20);
            }([
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.Logger = void 0;
                    var v = function() {
                        function t(g, f) {
                            this.name = g, this.logger = f;
                        }
                        return t.prototype.debug = function(g) {
                            this.logger.debug("[".concat(this.name, "] ").concat(g));
                        }, t.prototype.info = function(g) {
                            this.logger.info("[".concat(this.name, "] ").concat(g));
                        }, t.prototype.warn = function(g) {
                            this.logger.warn("[".concat(this.name, "] ").concat(g));
                        }, t.prototype.error = function(g) {
                            this.logger.error("[".concat(this.name, "] ").concat(g));
                        }, t;
                    }();
                    f.Logger = v;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.USER_AUTHENTICATE_EVENT_NAME = f.SUPPORTED_TOKEN_TYPES = f.FAILED_MESSAGE_ACK = f.UNHANDLED_MESSAGE_ACK = f.HANDLED_MESSAGE_ACK = f.CLIENT_VERSION = f.constants = void 0, f.constants = {
                        TROUTER_INIT: "trouterinit",
                        TROUTER_READY_EVENT: "trouterReadyEvent",
                        TROUTER_READY_TIMEOUT: "trouterReadyTimeout",
                        TROUTER_TOKEN_REQUEST: "trouterTokenRequest",
                        TROUTER_TOKEN_GET_SUCCEEDED: "trouterTokenGetSucceeded",
                        TROUTER_TOKEN_GET_FAILED: "trouterTokenGetFailed",
                        TROUTER_RECONNECTING: "trouterReconnecting",
                        RENEWAL: "renewal",
                        NEW_CONNECTION: "newConnection",
                        ENDPOINT_REGISTRATION_FAILED: "endpointRegistrationFailed"
                    }, f.CLIENT_VERSION = "2024.50.01.8", f.HANDLED_MESSAGE_ACK = 200, f.UNHANDLED_MESSAGE_ACK = 404, f.FAILED_MESSAGE_ACK = 500, f.SUPPORTED_TOKEN_TYPES = [
                        "skype",
                        "aad",
                        "cae"
                    ], f.USER_AUTHENTICATE_EVENT_NAME = "user.authenticate";
                },
                function(g, f, S) {
                    var v, _;
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterState = f.UserActivityState = void 0, function(g) {
                        g[g.Unknown = 0] = "Unknown", g[g.Active = 1] = "Active", g[g.Inactive = 2] = "Inactive";
                    }(v || (f.UserActivityState = v = {})), function(g) {
                        g[g.Unknown = 0] = "Unknown", g[g.Connected = 2] = "Connected", g[g.Disconnected = 3] = "Disconnected", g[g.Switching = 9] = "Switching";
                    }(_ || (f.TrouterState = _ = {}));
                },
                function(g, f, S) {
                    function o(g) {
                        try {
                            return JSON.stringify(g);
                        } catch (f) {
                            return "Unable to serialize object of type ".concat(typeof g);
                        }
                    }
                    function i(g) {
                        var f = Math.round((new Date).getTime() / 1e3);
                        return void 0 !== g && g > f ? g - f : 0;
                    }
                    function r(g) {
                        return Math.round((new Date).getTime() / 1e3) + g;
                    }
                    function s(g, f) {
                        return v(this, void 0, void 0, function() {
                            var S, v, C;
                            return _(this, function(_) {
                                return v = new Promise(function(f, v) {
                                    fetch(g).then(function(g) {
                                        clearTimeout(S), f(g);
                                    }).catch(function(g) {
                                        clearTimeout(S), v(g);
                                    });
                                }), 0 !== f ? (C = new Promise(function(v, _) {
                                    var C = new URL(g.url), E = new Error("".concat(g.method, " ").concat(C.origin).concat(C.pathname, " timed out"));
                                    S = setTimeout(_, f, E);
                                }), [
                                    2,
                                    Promise.race([
                                        v,
                                        C
                                    ])
                                ]) : [
                                    2,
                                    v
                                ];
                            });
                        });
                    }
                    var v = this && this.__awaiter || function(g, f, S, v) {
                        function i(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    a(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                try {
                                    a(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                g.done ? S(g.value) : i(g.value).then(s, c);
                            }
                            a((v = v.apply(g, f || [])).next());
                        });
                    }, _ = this && this.__generator || function(g, f) {
                        function n(g) {
                            return function(f) {
                                return o([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function o(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: n(0),
                            throw: n(1),
                            return: n(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.Timespan = f.CorrelationVector = f.fetchWithTimeout = f.calculateExpireTsInSec = f.calculateTtlInSec = f.toJson = void 0, f.toJson = o, f.calculateTtlInSec = i, f.calculateExpireTsInSec = r, f.fetchWithTimeout = s;
                    var C = function() {
                        function t(g) {
                            this.base = void 0 !== g ? g : this.createCorrelationVectorBase(), this.extension = 0;
                        }
                        return t.extend = function(g) {
                            return new t(g);
                        }, t.prototype.increase = function() {
                            this.extension++;
                        }, t.prototype.value = function() {
                            return "".concat(this.base, ".").concat(this.extension);
                        }, t.prototype.createCorrelationVectorBase = function() {
                            for(var g = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+", f = "AQgw", S = "", v = 0; v < 21; v++)S += g.charAt(Math.floor(Math.random() * g.length));
                            return S + f.charAt(Math.floor(Math.random() * f.length));
                        }, t;
                    }();
                    f.CorrelationVector = C;
                    var E = function() {
                        function t() {
                            this.start = Date.now();
                        }
                        return Object.defineProperty(t.prototype, "duration", {
                            get: function() {
                                return Date.now() - this.start;
                            },
                            enumerable: !1,
                            configurable: !0
                        }), Object.defineProperty(t.prototype, "startTime", {
                            get: function() {
                                return this.start;
                            },
                            enumerable: !1,
                            configurable: !0
                        }), t.prototype.reset = function() {
                            this.start = Date.now();
                        }, t;
                    }();
                    f.Timespan = E;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterManagerState = f.UserActivityEventReason = f.ServerState = void 0;
                    var v, _, C = S(3), E = function() {
                        function t(g, f, S, v, _, C) {
                            this.connectionId = g, this.connectedClientId = f, this.domId = S, this.url = v, this.c2cUrlBase = _, this.expirationTsSec = C;
                        }
                        return t.prototype.getRemainingTtlInSec = function() {
                            return (0, C.calculateTtlInSec)(this.expirationTsSec);
                        }, t;
                    }();
                    f.ServerState = E, function(g) {
                        g[g.Unknown = 0] = "Unknown", g[g.Modified = 1] = "Modified", g[g.Snapshot = 2] = "Snapshot", g[g.Connected = 3] = "Connected";
                    }(v || (f.UserActivityEventReason = v = {})), function(g) {
                        g[g.Unknown = 0] = "Unknown", g[g.Connected = 2] = "Connected", g[g.Disconnected = 3] = "Disconnected", g[g.Switching = 9] = "Switching", g[g.TerminalError = 10] = "TerminalError";
                    }(_ || (f.TrouterManagerState = _ = {}));
                },
                function(g, f, S) {
                    function o(g, f) {
                        return "skype" === g && "1" !== i(null == f ? void 0 : f.scae) ? "v4a" : "v4c";
                    }
                    function i(g) {
                        return "string" == typeof g ? g : "number" == typeof g ? g.toString() : void 0;
                    }
                    function r(g, f) {
                        return "v4c-websocket-failure" === (null == f ? void 0 : f.kind) ? "v4a" : g;
                    }
                    function s(g) {
                        return Object.prototype.hasOwnProperty.call(g, "connectparams");
                    }
                    function c(g, f) {
                        return "v4a" === f ? g.replace(/\/v4\/c\b/, "/v4/a").replace("wss://", "https://").replace("ws://", "http://") : g.replace(/\/v4\/a\b/, "/v4/c").replace("https://", "wss://").replace("http://", "ws://");
                    }
                    function a(g) {
                        if (void 0 !== g) return v(v({}, g), {
                            reconnectUrl: void 0,
                            serviceUrl: void 0
                        });
                    }
                    function u(g) {
                        return "string" == typeof g ? parseInt(g, 10) : g;
                    }
                    function h(g) {
                        if ("redirect" === (null == g ? void 0 : g.kind) && void 0 !== g.host) {
                            var f = g.host;
                            return f.endsWith("/") && (f = f.substring(0, f.length - 1)), f.endsWith("/v4/c") || f.endsWith("/v4/a") || (f += "/v4/c"), f;
                        }
                    }
                    var v = this && this.__assign || function() {
                        return v = Object.assign || function(g) {
                            for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                            return g;
                        }, v.apply(this, arguments);
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.redirectUrlIfPresent = f.ensureNumber = f.reconnectParamsWithoutUrls = f.adaptUrl = f.isV4ConnectEvent = f.usedProtocolAfterFallback = f.usedProtocol = void 0, f.usedProtocol = o, f.usedProtocolAfterFallback = r, f.isV4ConnectEvent = s, f.adaptUrl = c, f.reconnectParamsWithoutUrls = a, f.ensureNumber = u, f.redirectUrlIfPresent = h;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterFsm = f.State = void 0;
                    var v, _, C = S(4), E = S(0), T = S(5);
                    !function(g) {
                        g[g.Initial = 0] = "Initial", g[g.RetrievingToken = 1] = "RetrievingToken", g[g.Allocating = 2] = "Allocating", g[g.Handshaking = 3] = "Handshaking", g[g.Connecting = 4] = "Connecting", g[g.AnonymousConnecting = 5] = "AnonymousConnecting", g[g.WebsocketAuthenticating = 6] = "WebsocketAuthenticating", g[g.Connected = 7] = "Connected", g[g.Unregistering = 8] = "Unregistering", g[g.TerminalError = 9] = "TerminalError";
                    }(v || (f.State = v = {})), function(g) {
                        g[g.Initial = 0] = "Initial", g[g.Registering = 1] = "Registering", g[g.RegisteringButResendPending = 2] = "RegisteringButResendPending", g[g.Retrying = 3] = "Retrying", g[g.Registered = 4] = "Registered", g[g.RegistrationDisabled = 5] = "RegistrationDisabled";
                    }(_ || (_ = {}));
                    var I = function() {
                        function t(g, f, S, C) {
                            this.worker = f, this.incallModeEnabled = S, this.protocolSelector = C, this.state = v.Initial, this.autoReconnect = !0, this.logger = new E.Logger("ConnectionFsm", g), this.registrationState = _.Initial;
                        }
                        return t.prototype.getState = function() {
                            return this.state;
                        }, t.prototype.isActive = function() {
                            return this.state === v.Allocating || this.state === v.Connected || this.state === v.Handshaking || this.state === v.Connecting || this.state === v.RetrievingToken || this.state === v.AnonymousConnecting || this.state === v.WebsocketAuthenticating;
                        }, t.prototype.isConnecting = function() {
                            return this.state === v.Allocating || this.state === v.Handshaking || this.state === v.Connecting || this.state === v.AnonymousConnecting;
                        }, t.prototype.start = function() {
                            return this.state === v.Initial ? (this.setState(v.RetrievingToken), this.worker.getToken(!0, !1, void 0), !0) : (this.showIgnored("start"), !1);
                        }, t.prototype.stop = function(g, f) {
                            g && (this.registrationState = _.Initial), this.worker.isIncallMode() && this.worker.exitIncallMode(), this.worker.resetTokenBackoff(), this.worker.cancelPendingRegistrationRequests(), this.worker.stopConnectionTimer(), this.worker.stopPingTimer(), this.worker.clearSentEventTimers(), this.worker.stopRegistrationTimer(), this.worker.stopSocketIo(), this.state === v.Connected && this.worker.sendDisconnectTelemetryEvent("connection stopped"), this.registrationState !== _.Registered && this.registrationState !== _.Registering && this.registrationState !== _.RegisteringButResendPending || this.state === v.Unregistering ? f ? (this.setState(v.TerminalError), this.worker.dispatchTerminalError()) : (this.setState(v.Initial), this.worker.dispatchDisconnected()) : (this.registrationState = _.Initial, this.setState(v.Unregistering), this.worker.sendUnregisterRequest());
                        }, t.prototype.onTokenReceived = function(g, f, S) {
                            this.state === v.RetrievingToken ? "v4c" === (0, T.usedProtocolAfterFallback)(this.protocolSelector(g.tokenType, S), f) ? (this.setState(v.AnonymousConnecting), this.worker.startConnectionTimer(), this.worker.connectV4c(g, f)) : (this.setState(v.Allocating), this.worker.startConnectionTimer(), this.worker.sendAllocateRequest(g)) : this.showIgnored("onTokenReceived");
                        }, t.prototype.checkConnection = function(g) {
                            g && this.onPingInterval();
                        }, t.prototype.onAllocationSucceed = function(g) {
                            return this.state === v.Allocating && this.registrationState === _.Registered && this.worker.dispatchUnregistered(), this.state === v.Allocating ? (this.setState(v.Handshaking), this.registrationState = _.Initial, this.worker.startSocketIo(g), !0) : (this.showIgnored("onAllocationSucceed"), !1);
                        }, t.prototype.onAllocationFailed = function(g, f) {
                            this.state === v.Allocating ? this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !g,
                                claimsChallenge: f
                            }) : this.showIgnored("onAllocationFailed");
                        }, t.prototype.onV4cConnectivityCheckFailed = function() {
                            this.state === v.AnonymousConnecting ? this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !0
                            }) : this.showIgnored("onV4cConnectivityCheckFailed");
                        }, t.prototype.onV4cException = function() {
                            this.state !== v.AnonymousConnecting && this.state !== v.WebsocketAuthenticating || (this.logger.error("v4c exception, falling back to longpoll"), this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !0,
                                fallbackReason: {
                                    kind: "v4c-websocket-failure"
                                }
                            }));
                        }, t.prototype.onConnectingTimeout = function() {
                            this.state === v.Allocating || this.state === v.Connecting || this.state === v.Handshaking || this.state === v.AnonymousConnecting || this.state === v.WebsocketAuthenticating ? this.cleanUpAndInitiateReconnect({
                                backoff: !1,
                                allowCachedToken: !0
                            }) : this.showIgnored("onConnectingTimeout");
                        }, t.prototype.onConnecting = function() {
                            this.state === v.Handshaking ? this.setState(v.Connecting) : this.showIgnored("onConnecting");
                        }, t.prototype.onSocketConnect = function(g) {
                            this.state === v.AnonymousConnecting ? (this.setState(v.WebsocketAuthenticating), this.worker.sendV4cAuthenticationEvent(g)) : this.showIgnored("onSocketConnect");
                        }, t.prototype.onConnectingFailed = function() {
                            this.state === v.Connecting ? this.onConnectingTimeout() : this.state === v.Handshaking ? (this.logger.error("Unexpected error in Socket.io - no valid transports"), this.onConnectingTimeout()) : this.state === v.AnonymousConnecting || this.state === v.WebsocketAuthenticating ? (this.logger.info("/v4/c falling back to longpoll"), this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !0,
                                fallbackReason: {
                                    kind: "v4c-websocket-failure"
                                }
                            })) : this.showIgnored("onConnectingFailed");
                        }, t.prototype.onSocketDisconnect = function(g) {
                            this.state === v.Handshaking || this.state === v.Connected || this.state === v.WebsocketAuthenticating ? (this.state === v.Connected && this.worker.sendDisconnectTelemetryEvent(null == g ? void 0 : g.toTelemetryString()), this.state === v.WebsocketAuthenticating && this.worker.countDisconnectBeforeConnectionEstablishment(), "skypetoken-deprecated" === (null == g ? void 0 : g.reason) ? (this.logger.error("Skypetoken deprecated response, not retrying any further"), this.onTerminalError()) : this.cleanUpAndInitiateReconnect({
                                backoff: this.state !== v.Connected && "dup" !== (null == g ? void 0 : g.reason),
                                allowCachedToken: "unauthorized" !== (null == g ? void 0 : g.reason),
                                claimsChallenge: null == g ? void 0 : g.claims
                            })) : this.showIgnored("onSocketDisconnect");
                        }, t.prototype.onTrouterConnected = function() {
                            this.state === v.Connecting || this.state === v.WebsocketAuthenticating ? (this.setState(v.Connected), this.worker.resetTokenBackoff(), this.worker.stopConnectionTimer(), this.worker.sendUserActivityState(C.UserActivityEventReason.Connected, !0), this.worker.startPingTimer(), this.worker.dispatchConnected(), this.worker.shouldSkipRegistration() ? (this.registrationState = _.RegistrationDisabled, this.worker.dispatchRegistered()) : (this.registrationState = _.Registering, this.worker.sendRegisterRequest())) : this.showIgnored("onTrouterConnected");
                        }, t.prototype.onReconnectRequired = function(g, f, S) {
                            this.state === v.AnonymousConnecting || this.state === v.WebsocketAuthenticating ? void 0 === S || "host" !== S.target || void 0 === S.url || "" === S.url ? (this.logger.error("unexpected reconnect arguments: ".concat(null == S ? void 0 : S.target, " ").concat(null == S ? void 0 : S.url, ", reconnecting without cache")), this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !0,
                                fallbackReason: {
                                    kind: "redirect-no-host"
                                }
                            })) : this.cleanUpAndInitiateReconnect({
                                backoff: !0,
                                allowCachedToken: !0,
                                fallbackReason: {
                                    kind: "redirect",
                                    host: S.url
                                }
                            }) : this.worker.dispatchReconnectIsRequired(g, f);
                        }, t.prototype.disableAutoReconnect = function() {
                            this.autoReconnect = !1;
                        }, t.prototype.onDownstreamRequest = function(g) {
                            this.state === v.Connected ? (this.switchToIncallModeIfEnabled(), this.worker.dispatchDownstreamRequest(g)) : this.showIgnored("onDownstreamRequest");
                        }, t.prototype.onTrouterMessageLost = function(g) {
                            this.state === v.Connected ? this.worker.dispatchTrouterMessageLost(g) : this.showIgnored("onTrouterMessageLost");
                        }, t.prototype.onPingInterval = function() {
                            this.state === v.Connected ? this.worker.sendPingRequest() : this.showIgnored("onPingInterval");
                        }, t.prototype.onPingResponseTimeout = function() {
                            this.onMissedResponse("onPingResponseTimeout");
                        }, t.prototype.onPingResponse = function() {
                            this.state === v.Connected || this.showIgnored("onPingResponse");
                        }, t.prototype.onRegistrationFailed = function() {
                            this.state === v.Connected && this.registrationState === _.Registering ? (this.worker.dispatchUnregistered(), this.registrationState = _.Retrying, this.worker.startRegistrationRetryTimer()) : this.state === v.Connected && this.registrationState === _.RegisteringButResendPending ? (this.registrationState = _.Registering, this.worker.sendRegisterRequest()) : this.showIgnored("onRegistrationFailed");
                        }, t.prototype.onRetryRegistration = function() {
                            this.state === v.Connected && this.registrationState === _.Retrying ? (this.registrationState = _.Registering, this.worker.sendRegisterRequest()) : this.showIgnored("onRetryRegistration");
                        }, t.prototype.onRegistrationSucceeded = function() {
                            this.state === v.Connected && this.registrationState === _.Registering ? (this.registrationState = _.Registered, this.worker.dispatchRegistered(), this.worker.startRegistrationTimer()) : this.state === v.Connected && this.registrationState === _.RegisteringButResendPending ? (this.registrationState = _.Registering, this.worker.sendRegisterRequest()) : this.showIgnored("onRegistrationSucceeded");
                        }, t.prototype.onRegistrationNearExpiry = function() {
                            this.state === v.Connected && this.registrationState === _.Registered ? (this.registrationState = _.Registering, this.worker.sendRegisterRequest()) : this.showIgnored("onRegistrationNearExpiry");
                        }, t.prototype.onUnregistrationDone = function() {
                            this.state === v.Unregistering ? (this.setState(v.Initial), this.worker.dispatchUnregistered(), this.worker.dispatchDisconnected()) : this.showIgnored("onUnregistrationDone");
                        }, t.prototype.onResendRegistration = function() {
                            this.worker.dispatchUnregistered(), this.state === v.Connected && this.registrationState === _.Registered ? (this.registrationState = _.Registering, this.worker.stopRegistrationTimer(), this.worker.sendRegisterRequest()) : this.state === v.Connected && this.registrationState === _.Registering && (this.registrationState = _.RegisteringButResendPending);
                        }, t.prototype.onIncallModeTimer = function() {
                            this.worker.exitIncallMode(), this.state === v.Connected ? (this.worker.stopPingTimer(), this.worker.startPingTimer()) : this.showIgnored("onIncallModeTimer");
                        }, t.prototype.onSetNewUserActivityState = function() {
                            this.worker.sendUserActivityState(C.UserActivityEventReason.Modified, this.state === v.Connected);
                        }, t.prototype.onActivityStateResponseTimeout = function() {
                            this.onMissedResponse("onActivityStateResponseTimeout");
                        }, t.prototype.forceReconnect = function(g) {
                            this.state === v.Connected && this.worker.sendDisconnectTelemetryEvent(g), this.worker.resetTokenBackoff(), this.cleanUpAndInitiateReconnect({
                                backoff: !1,
                                allowCachedToken: !0
                            });
                        }, t.prototype.onTerminalError = function() {
                            this.logger.error("Cannot proceed, reached terminal state. Switching from state '".concat(v[this.state], "' to ").concat(v[v.TerminalError])), this.stop(!0, !0), this.setState(v.TerminalError);
                        }, t.prototype.onMissedResponse = function(g) {
                            this.state === v.Connected ? (this.worker.sendDisconnectTelemetryEvent(g), this.cleanUpAndInitiateReconnect({
                                backoff: !1,
                                allowCachedToken: !0
                            })) : this.showIgnored(g);
                        }, t.prototype.showIgnored = function(g) {
                            this.logger.debug("Ignoring event '".concat(g, "' in state '").concat(v[this.state], "'"));
                        }, t.prototype.setState = function(g) {
                            this.logger.info("Switching from state '".concat(v[this.state], "' to state '").concat(v[g], "'")), this.state !== g ? this.state = g : this.logger.error("Attempt to switch to the current state '".concat(v[g], "'"));
                        }, t.prototype.switchToIncallModeIfEnabled = function() {
                            this.incallModeEnabled && (this.worker.isIncallMode() || (this.worker.enterIncallMode(), this.worker.stopPingTimer(), this.worker.startPingTimer()), this.worker.restartIncallModeTimer());
                        }, t.prototype.cleanUpAndInitiateReconnect = function(g) {
                            if (!this.autoReconnect) return this.logger.info("Automatic reconnect is disabled, stopping this connection"), void this.stop(!0);
                            this.worker.cancelPendingRegistrationRequests(), this.worker.stopConnectionTimer(), this.worker.stopPingTimer(), this.worker.clearSentEventTimers(), this.worker.stopRegistrationTimer(), this.worker.stopSocketIo(), this.setState(v.RetrievingToken), this.worker.dispatchReconnecting(), this.worker.getToken(g.allowCachedToken, g.backoff, g.claimsChallenge, g.fallbackReason);
                        }, t;
                    }();
                    f.TrouterFsm = I;
                },
                function(g, f, S) {
                    function o(g, f) {
                        var S = f ? void 0 : {
                            "X-MS-Migration": "True"
                        };
                        switch(g.tokenType.toLowerCase()){
                            case "skype":
                                return v({
                                    "X-Skypetoken": g.token
                                }, S);
                            case "aad":
                            case "cae":
                                return v({
                                    Authorization: "Bearer ".concat(g.token)
                                }, S);
                            default:
                                throw new Error("unsupported token type: ".concat(g.tokenType));
                        }
                    }
                    function i(g) {
                        return null != g && "function" == typeof g.toString ? g.toString() : "[".concat(typeof g, "]");
                    }
                    function r(g) {
                        return "object" == typeof g && null !== g && void 0 !== g.stack ? (0, I.toJson)(g.stack) : '"(no error.stack)"';
                    }
                    function s(g) {
                        return "object" == typeof g && null !== g && "string" == typeof g.message ? g.message : "(no error.message)";
                    }
                    var v = this && this.__assign || function() {
                        return v = Object.assign || function(g) {
                            for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                            return g;
                        }, v.apply(this, arguments);
                    }, _ = this && this.__awaiter || function(g, f, S, v) {
                        function i(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    a(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                try {
                                    a(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                g.done ? S(g.value) : i(g.value).then(s, c);
                            }
                            a((v = v.apply(g, f || [])).next());
                        });
                    }, C = this && this.__generator || function(g, f) {
                        function n(g) {
                            return function(f) {
                                return o([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function o(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: n(0),
                            throw: n(1),
                            return: n(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterConnection = f.ReconnectReason = void 0;
                    var E, T = S(21), I = S(3), b = S(15), A = S(1), R = S(16), P = S(17), w = S(2), M = S(4), O = S(0), D = S(5), N = S(6), k = S(12), L = function() {
                        function t() {
                            this.cv = A.CLIENT_VERSION, this.ua = "", this.hr = "", this.v = "";
                        }
                        return t;
                    }(), F = function() {
                        function t() {
                            this["force new connection"] = !0, this.reconnect = !1, this.query = "", this.ackTimeoutMs = 5e3;
                        }
                        return t.prototype.rewriteUrlForProxy = function(g) {
                            return g;
                        }, t;
                    }(), x = "MS-CV", U = function() {
                        function t(g, f) {
                            this.logger = f, this.cvCounter = 0;
                            var S = JSON.parse(g);
                            this.startTS = this.safeJsonNumber(S, "startTS", 0), this.url = this.safeJsonString(S, "url", ""), this.shortUrl = this.safeJsonString(S, "shortUrl", ""), this.body = this.safeJsonString(S, "body", ""), this.headers = this.safeJsonRecord(S, "headers", {}), this.id = this.safeJsonNumber(S, "id", -1), this.method = this.safeJsonString(S, "method", ""), this.replied = !1, this.timedout = !1, this.receivedCv = this.headers[x], this.updateCvHeader();
                        }
                        return Object.defineProperty(t.prototype, "correlationVector", {
                            get: function() {
                                return this.receivedCv ? "".concat(this.receivedCv, ".").concat(this.cvCounter) : "";
                            },
                            enumerable: !1,
                            configurable: !0
                        }), t.prototype.on = function(g, f) {
                            "data" === g ? this.dataCallback = f : "end" === g && ("function" == typeof this.dataCallback && this.dataCallback(this.body), f());
                        }, t.prototype.incrementCorrelationVector = function() {
                            ++this.cvCounter, this.updateCvHeader();
                        }, t.prototype.updateCvHeader = function() {
                            var g = this.correlationVector;
                            g && (this.headers[x] = g);
                        }, t.prototype.safeJsonNumber = function(g, f, S) {
                            var v;
                            if (null != g && Object.prototype.hasOwnProperty.call(g, f)) {
                                var _ = g;
                                if ("number" == typeof _[f]) return _[f];
                                if ("string" == typeof _[f]) return parseFloat(_[f]);
                                null === (v = this.logger) || void 0 === v || v.warn("unexpected type of '".concat(f, "': ").concat(typeof _[f]));
                            }
                            return S;
                        }, t.prototype.safeJsonString = function(g, f, S) {
                            var v;
                            if (null != g && Object.prototype.hasOwnProperty.call(g, f)) {
                                var _ = g;
                                if ("string" == typeof _[f]) return _[f];
                                null === (v = this.logger) || void 0 === v || v.warn("unexpected type of '".concat(f, "': ").concat(typeof _[f]));
                            }
                            return S;
                        }, t.prototype.safeJsonRecord = function(g, f, S) {
                            var v;
                            if (null != g && Object.prototype.hasOwnProperty.call(g, f)) {
                                var _ = g;
                                if ("object" == typeof _[f]) return _[f];
                                null === (v = this.logger) || void 0 === v || v.warn("unexpected type of '".concat(f, "': ").concat(typeof _[f]));
                            }
                            return S;
                        }, t;
                    }(), V = function() {
                        function t(g, f, S) {
                            this.request = g, this.responseData = f, this.sendResponse = S;
                        }
                        return t.prototype.writeHead = function(g, f) {
                            this.responseData.status = g, this.responseData.headers = f;
                        }, t.prototype.write = function(g) {
                            this.responseData.body += g;
                        }, t.prototype.end = function(g) {
                            return g && (this.responseData.body += g), this.sendResponse(this.request, this.responseData);
                        }, t;
                    }(), B = function() {
                        function t(g) {
                            this.name = g, this.args = {}, this.timeoutTimerId = 0;
                        }
                        return t;
                    }();
                    !function(g) {
                        g[g.Configuration = 0] = "Configuration", g[g.ServerInitiated = 1] = "ServerInitiated";
                    }(E || (f.ReconnectReason = E = {}));
                    var H = function() {
                        function t(g, f, S, v, _, C, E, I) {
                            var R, w = this;
                            this.options = f, this.manager = S, this.tokenProvider = v, this.usingLegacyTokenApi = _, this.protocolSelector = E, this.audienceSubscriptionState = I, this.WEBSOCKET_TRANSPORT_NAME = "websocket", this.XHR_POLLING_TRANSPORT_NAME = "xhr-polling", this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR = "Error", this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED = "Unsubscribed", this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT = "Timeout", this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST = "BadRequest", this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX = /&audienceSubscriptionState=[^&]*|^audienceSubscriptionState=[^&]*&?/, this.USER_ACTIVITY_QUERY_PARAM_REGEX = /userActivity=[^&]*/, this.connectionId = "", this.inIncallMode = !1, this.connectionAttempt = 0, this.connectedClientId = "", this.isNavigatorOnline = !0, this.onNavigatorOnlineStatusUpdateBound = this.onNavigatorOnlineStatusUpdate.bind(this), this.c2cUrlBase = "", this.connectingErrorsInRow = 0, this.connectivityCheckFailuresInARow = 0, this.unauthorizedErrorCount = 0, this.pendingSentEventTimers = {}, this.lastDisconnectReason = "", this.UNKNOWN_TRANSPORT = "unknown_transport", this.connectingErrorsThreshold = 3, this.pendingAudienceSubscription = void 0, this.logger = new O.Logger("Connection", g), this.timeoutOptions = this.options.timeoutOptions, this.tokenBackoff = new P.ExponentialBackoff(this.logger, this.timeoutOptions.maxBackoffMs), this.clientID = Date.now(), "undefined" != typeof window && window.location && (this.domId = window.location.hostname);
                            var M = new L;
                            M.cv = A.CLIENT_VERSION, M.ua = "", (null === (R = this.options) || void 0 === R ? void 0 : R.clientInfo) && (M.ua = this.safeString(this.options.clientInfo.ua), M.v = this.safeString(this.options.clientInfo.v)), this.clientInfo = M, this.connectionTracker = new b.ConnectionTracker(g, this.clientID, this.clientInfo, function() {
                                return w.getServerState();
                            }, this.options.endpointId, this.options.clientCorrelationID, this.options.environment), this.applyConnectionTrackerOptions(f);
                            var D = this.options.incallModeTimeoutMs > 0;
                            if (this.fsm = new N.TrouterFsm(g, this, D, this.protocolSelector), f.registration) {
                                var k = {
                                    registrarUrl: f.registration.registrarUrl,
                                    proxyUrlRewrite: f.rewriteUrlForProxy,
                                    registrationId: f.registration.registrationId,
                                    requestTimeoutMs: f.timeoutOptions.fetchTimeoutMs,
                                    initialRetryDelayMs: 1e3,
                                    maxRetryDelayMs: f.timeoutOptions.maxBackoffMs,
                                    usingLegacyTokenApi: this.usingLegacyTokenApi,
                                    maxRetriesForGetToken: f.retryLimitOnTokenFetch,
                                    extraRegistrationHeaders: f.extraConnectionHeaders
                                };
                                this.registrarClient = (0, T.createRegistrarClient)(g, this.tokenProvider, k);
                            }
                            this.userActivityState = C;
                        }
                        return t.prototype.start = function(g) {
                            this.logger.info("Starting"), this.reconnectParams = g, "undefined" != typeof window && window.navigator && window.addEventListener ? (this.isNavigatorOnline = window.navigator.onLine, window.addEventListener("online", this.onNavigatorOnlineStatusUpdateBound), window.addEventListener("offline", this.onNavigatorOnlineStatusUpdateBound), this.logger.debug("Registered for browser online notifications - current state: ".concat(this.isNavigatorOnline))) : this.isNavigatorOnline = !0, this.fsm.start();
                        }, t.prototype.stop = function(g) {
                            this.logger.info("Stopping"), "undefined" != typeof window && window.navigator && (window.removeEventListener("online", this.onNavigatorOnlineStatusUpdateBound), window.removeEventListener("offline", this.onNavigatorOnlineStatusUpdateBound)), this.fsm.stop(g), this.connectionTracker.close();
                        }, t.prototype.configure = function(g) {
                            var f = this.options.trouterUrl !== g.trouterUrl;
                            this.options = g, this.applyConnectionTrackerOptions(g), f && (this.logger.info("Configuration changed. Reconnection required."), this.fsm.onReconnectRequired(!1, E.Configuration));
                        }, t.prototype.checkConnection = function(g) {
                            this.logger.info("checkConnection called with ".concat(g)), this.fsm.checkConnection(g), g && this.connectionTracker.sendTelemetry(b.ClientEventName.CheckConnection, {
                                disconnectDetected: g
                            }, []);
                        }, t.prototype.disableRegistrationsAndAutoReconnect = function() {
                            this.stopRegistrationTimer(), this.cancelPendingRegistrationRequests(), this.fsm.disableAutoReconnect();
                        }, t.prototype.getServerState = function() {
                            return new M.ServerState(this.connectionId, this.connectedClientId, this.domId ? this.domId : "", this.allocateResult ? this.allocateResult.surl : "", this.c2cUrlBase, this.connectionExpireTimestampInSecs);
                        }, t.prototype.getState = function() {
                            return this.fsm.getState();
                        }, t.prototype.getToken = function(g, f, S, v, _) {
                            var C = this;
                            void 0 === _ && (_ = 0), this.logger.info("Getting token ".concat(f ? "with backoff" : "without backoff"));
                            var s = function() {
                                C.connectionTracker.trackStart("token");
                                var f = {
                                    needFresh: !g,
                                    wwwAuthenticateHeader: S,
                                    supportedTokenTypes: A.SUPPORTED_TOKEN_TYPES,
                                    purpose: "trouter"
                                };
                                C.logger.info("Requesting token: needFresh=".concat(f.needFresh, " ") + "types=[".concat(A.SUPPORTED_TOKEN_TYPES, "], ") + "wwwAuthenticateHeader is ".concat(f.wwwAuthenticateHeader ? "non empty" : "empty")), C.tokenProvider(f).then(function(g) {
                                    C.logger.debug("".concat(g.tokenType, " token is received")), C.connectionTracker.trackEnd("token"), C.fsm.onTokenReceived(g, v, C.reconnectParams);
                                }).catch(function(f) {
                                    var E = (0, I.toJson)(f.stack);
                                    if (C.logger.error("Getting token failed, will retry after timeout. Error: ".concat(E)), C.connectionTracker.trackError("token", E), !C.canRetryTokenFetchRequest(_ + C.unauthorizedErrorCount)) return C.connectionTracker.trackError("token", "getToken retry limit hit, reached terminal error state"), C.resetTokenBackoff(), void C.fsm.onTerminalError();
                                    C.getToken(g, !0, S, v, _ + 1);
                                });
                            };
                            f ? this.tokenBackoff.backoff("getting token", s) : (this.resetTokenBackoff(), s());
                        }, t.prototype.startConnectionTimer = function() {
                            var g = this;
                            this.stopConnectionTimer(), this.logger.debug("Starting connection timeout for ".concat(this.timeoutOptions.connectionTimeoutMs, " ms")), this.connectionTimeoutId = setTimeout(function() {
                                g.logger.info("Connection timeout is fired"), g.fsm.onConnectingTimeout();
                            }, this.timeoutOptions.connectionTimeoutMs);
                        }, t.prototype.stopConnectionTimer = function() {
                            this.connectionTimeoutId && (this.logger.debug("Stopping connection timeout"), clearTimeout(this.connectionTimeoutId), this.connectionTimeoutId = void 0);
                        }, t.prototype.startPingTimer = function() {
                            var g = this;
                            "websocket" === this.transportTypeName ? (this.logger.debug("Starting ping timeout for ".concat(this.timeoutOptions.pingTimeoutMs, " ms")), this.pingTimerId = setInterval(function() {
                                g.logger.info("Ping interval fired"), g.fsm.onPingInterval();
                            }, this.timeoutOptions.pingTimeoutMs)) : this.logger.debug("Not starting ping for transport ".concat(this.transportTypeName));
                        }, t.prototype.stopPingTimer = function() {
                            this.pingTimerId && (this.logger.debug("Stopping ping timeout"), this.clearPingResponseTimer(), clearInterval(this.pingTimerId), this.pingTimerId = void 0);
                        }, t.prototype.shouldSkipRegistration = function() {
                            return void 0 === this.options.registration;
                        }, t.prototype.hasCustomRegistrationTtl = function() {
                            var g, f;
                            return void 0 !== (null === (g = this.options.registration) || void 0 === g ? void 0 : g.registrarTtlSec) && 0 !== (null === (f = this.options.registration) || void 0 === f ? void 0 : f.registrarTtlSec);
                        }, t.prototype.startRegistrationTimer = function() {
                            var g = this;
                            this.stopRegistrationTimer();
                            var f = this.getRegistrationTtl(), S = f[0], v = f[1];
                            if (S <= 30 || !v) return this.logger.debug("Starting registration expiration timer (TTL ".concat(S, " sec)")), void (this.registrationTimerId = setTimeout(function() {
                                g.registrationTimerId = void 0, g.logger.warn("Registration expired but the connection is still alive. Should never happen"), g.dispatchUnregistered();
                            }, 1e3 * S));
                            var _ = S - 30;
                            this.logger.debug("Starting registration extension timer for ".concat(_, " sec")), this.registrationTimerId = setTimeout(function() {
                                g.logger.info("Registration extension timer fired"), g.registrationTimerId = setTimeout(function() {
                                    g.registrationTimerId = void 0, g.logger.debug("Registration extension did not happen in time"), g.dispatchUnregistered();
                                }, 3e4), g.fsm.onRegistrationNearExpiry();
                            }, 1e3 * _);
                        }, t.prototype.startRegistrationRetryTimer = function() {
                            var g = this;
                            this.stopRegistrationTimer(), this.registrationTimerId = setTimeout(function() {
                                g.registrationTimerId = void 0, g.fsm.onRetryRegistration();
                            }, 123e3);
                        }, t.prototype.stopRegistrationTimer = function() {
                            this.registrationTimerId && (this.logger.debug("Stopping registration timeout"), clearTimeout(this.registrationTimerId), this.registrationTimerId = void 0);
                        }, t.prototype.resendRegistration = function() {
                            if (!this.registrarClient) throw new Error("Trouter Client not configured to handle registrations");
                            return this.fsm.onResendRegistration(), Promise.resolve();
                        }, t.prototype.buildSocketIoUrlParams = function(g, f) {
                            if (!this.allocateResult) throw new Error("Allocate result is undefined in buildSocketIoUrlParams()");
                            for(var S = {}, v = this.allocateResult.connectparams, _ = 0, C = Object.keys(v); _ < C.length; _++){
                                var E = C[_];
                                if (void 0 !== v[E]) {
                                    var T = v[E];
                                    "string" == typeof T || "number" == typeof T ? S[E] = T : this.logger.error("signatureData[".concat(E, "] has unsupported type ").concat(typeof T));
                                }
                            }
                            return S.v = "v4", S.tc = encodeURI((0, I.toJson)(this.clientInfo)), S.timeout = this.timeoutOptions.pingTimeoutMs / 1e3, S.auth = "true", this.options.endpointId && (S.epid = this.options.endpointId), g && (S.userActivity = encodeURIComponent((0, I.toJson)(g))), f && (S.audienceSubscriptionState = encodeURIComponent((0, I.toJson)(f))), this.appendConnectedClientIds(this.buildQuery(S), !0);
                        }, t.prototype.startSocketIo = function(g) {
                            var f, S;
                            if (this.logger.debug("Starting socket io"), this.connectionTracker.trackStart("connectSocket"), !this.allocateResult) throw new Error("Allocate result is undefined in startSocketIo()");
                            var _ = this.options.ioOptions ? v({}, this.options.ioOptions) : new F, C = this.userActivityState.state !== w.UserActivityState.Unknown ? this.userActivityState.increaseCvAndGetEventObject() : void 0, E = null === (f = this.audienceSubscriptionState) || void 0 === f ? void 0 : f.increaseCvAndGetEventObject();
                            if (_["force new connection"] = !0, _.reconnect = !1, _.rewriteUrlForProxy = this.options.rewriteUrlForProxy, _.requestHeaders = v(v({}, this.options.extraConnectionHeaders), o(g, this.usingLegacyTokenApi)), _.query = this.buildSocketIoUrlParams(C, E), this.logger.info("connecting to ".concat(this.allocateResult.socketio)), this.stopSocketIo(), this.socket = (null !== (S = this.options.io) && void 0 !== S ? S : k).connect(this.allocateResult.socketio, _), void 0 === this.socket) throw new Error("Can't create Socket.io object");
                            this.attachSocketIoHandlers(this.socket, g, C, E);
                        }, t.prototype.stopSocketIo = function() {
                            if (this.socket) {
                                this.logger.debug("clearing socket.io");
                                try {
                                    for(var g = 0, f = [
                                        "connecting",
                                        "connect",
                                        "connect_failed",
                                        "close_during_connecting",
                                        "disconnect",
                                        "reconnect",
                                        "reconnect_failed",
                                        "reconnecting",
                                        "error",
                                        "message",
                                        "trouter.connected",
                                        "trouter.reconnect",
                                        "trouter.message_loss"
                                    ]; g < f.length; g++){
                                        var S = f[g];
                                        this.socket.removeAllListeners(S);
                                    }
                                    this.socket.disconnect(), this.logger.debug("cleared socket"), this.socket = void 0;
                                } catch (g) {
                                    this.logger.error("exception in disconnecting previous socket. Error: ".concat(r(g)));
                                }
                            }
                        }, t.prototype.dispatchConnected = function() {
                            this.logger.info("dispatching connected"), this.manager.onConnected(this);
                        }, t.prototype.dispatchRegistered = function() {
                            this.logger.info("dispatching registered"), this.manager.onRegistered(this);
                        }, t.prototype.dispatchUnregistered = function() {
                            this.logger.info("dispatching unregistered"), this.manager.onUnregistered(this);
                        }, t.prototype.dispatchDownstreamRequest = function(g) {
                            var f = this;
                            this.logger.debug("dispatching downstream request");
                            try {
                                var S = new V(g, new b.ResponseData(g.id), function(g, S) {
                                    return f.logger.debug("sending response to downstream"), f.sendResponse(g, S);
                                });
                                this.manager.onDownstreamRequest(this, g, S);
                            } catch (g) {
                                this.logger.error("exception in socket.on message. Error : ".concat(r(g)));
                            }
                        }, t.prototype.dispatchReconnecting = function() {
                            this.logger.info("dispatching reconnecting"), this.manager.onReconnecting(this);
                        }, t.prototype.dispatchReconnectIsRequired = function(g, f) {
                            this.logger.info("dispatching reconnect is required by server"), this.manager.onReconnectIsRequired(this, g, f);
                        }, t.prototype.dispatchDisconnected = function() {
                            this.logger.info("dispatching disconnected"), this.manager.onDisconnected(this);
                        }, t.prototype.dispatchTerminalError = function() {
                            this.logger.info("dispatching terminal error"), this.manager.onTerminalError(this);
                        }, t.prototype.dispatchTrouterMessageLost = function(g) {
                            this.logger.info("dispatching trouter message lost"), this.manager.onTrouterMessageLost(g);
                        }, t.prototype.countDisconnectBeforeConnectionEstablishment = function() {
                            this.logger.warn("counting disconnect before connection was fully established as a connection failure"), ++this.connectingErrorsInRow >= this.connectingErrorsThreshold && this.resetReconnectParamsOnErrorThreshold();
                        }, t.prototype.sendProcessedDroppedIndicators = function(g) {
                            var f = this;
                            try {
                                this.logger.debug("emitting processed flow tags to the server");
                                var S = new B("trouter.processed_message_loss");
                                S.args = {
                                    droppedIndicators: g
                                }, this.sendDownstreamEvent(S, function() {
                                    f.logger.info("emitted processed flow tags to the server");
                                });
                            } catch (g) {
                                var v = r(g);
                                this.logger.error("unable to send processed message loss event. Error: ".concat(v)), this.connectionTracker.trackError("trouter.processed_message_loss", v, !1);
                            }
                        }, t.prototype.sendAllocateRequest = function(g) {
                            var f = this;
                            this.connectionAttempt++, this.connectionTracker.trackNewConnection();
                            var S, _ = this.options.trouterUrl, C = this.reconnectParams, E = "string" == typeof (null == C ? void 0 : C.se) ? parseInt(C.se, 10) : "number" == typeof (null == C ? void 0 : C.se) ? C.se : void 0;
                            E && E <= Date.now() + 36e5 && (this.logger.warn("Dropping expired cached connection parameters: ".concat(new Date(E))), this.reconnectParams = C = void 0), C && C.serviceUrl !== _ && (this.logger.warn("Dropping cached connection parameters for a different environment (".concat(C.serviceUrl, ", now ").concat(_, ")")), this.reconnectParams = C = void 0), (null == C ? void 0 : C.reconnectUrl) && (_ = C.reconnectUrl), S = C ? v(v({}, C), {
                                serviceUrl: void 0,
                                reconnectUrl: void 0
                            }) : null, _ = (0, D.adaptUrl)(_, "v4a"), _ = this.appendCorrelationIds(_, !1);
                            var T = _ = this.appendEndpointId(_, !1);
                            S && (_ += "&".concat(this.buildQuery(S)), S.v || (_ += "&v=".concat("v4"))), _ = this.options.rewriteUrlForProxy(_);
                            var b = new Request(_, {
                                method: "POST",
                                mode: "cors",
                                headers: new Headers(v(v({
                                    "Content-Type": "text/plain"
                                }, this.options.extraConnectionHeaders), o(g, this.usingLegacyTokenApi)))
                            });
                            this.logger.info("sendAllocateRequest: POST ".concat(this.options.rewriteUrlForProxy(T), " (connectparams redacted)}")), this.connectionTracker.trackStart("allocation");
                            var A, R = Date.now(), P = -1, w = !1;
                            (0, I.fetchWithTimeout)(b, this.timeoutOptions.fetchTimeoutMs).then(function(g) {
                                var S;
                                if (P = g.status, !g.ok) throw A = null !== (S = g.headers.get("www-authenticate")) && void 0 !== S ? S : void 0, w = "1" === g.headers.get("x-trouter-skypetoken-deprecated"), f.logger.warn("Allocation request got response status ".concat(g.status, ", www-authenticate header was ").concat(A ? "not empty" : "empty")), new Error(g.statusText);
                                var v = g.headers.get("content-type");
                                if (!v || "application/json" !== v && !v.startsWith("application/json;")) throw new Error("Content-type '".concat(v, "' is unexpected"));
                                return f.connectionTracker.trackEnd("allocation"), g.json();
                            }).then(function(S) {
                                f.unauthorizedErrorCount = 0, f.onAllocationResponse(S, g);
                            }).catch(function(g) {
                                f.connectingErrorsInRow++;
                                var S = "".concat(g).concat(P >= 0 ? ", status code ".concat(P) : "");
                                if (f.logger.error("".concat(f.connectingErrorsInRow, " failed connecting attempt(s) in a row. ").concat(S)), f.connectionTracker.trackError("allocation", S), w) {
                                    var v = "Skypetoken deprecated response, not retrying any further";
                                    return f.logger.error(v), f.connectionTracker.trackError("allocation", v), void f.fsm.onTerminalError();
                                }
                                if (401 === P && f.unauthorizedErrorCount++, !f.canRetryTokenFetchRequest(f.unauthorizedErrorCount)) return v = "getToken retry limit hit, reached terminal error state", f.connectionTracker.trackError("allocation", v), void f.fsm.onTerminalError();
                                if (-1 !== P || f.isNavigatorOnline) {
                                    if (f.reconnectParams && f.connectingErrorsInRow >= f.connectingErrorsThreshold) {
                                        if (P >= 400 && P <= 599) f.resetReconnectParamsOnErrorThreshold();
                                        else if (f.reconnectParams.reconnectUrl && f.connectingErrorsInRow % 3 == 0) {
                                            f.logger.warn("".concat(f.connectingErrorsInRow, " connection attempts, testing nominal service URL"));
                                            var _ = Math.min(f.timeoutOptions.connectionTimeoutMs - (Date.now() - R) - 500, f.timeoutOptions.fetchTimeoutMs);
                                            return void f.testNominalUrlConnectivity(_).then(function(g) {
                                                f.connectionTracker.trackProgress("nomcheck", g ? "ok" : "failed"), g ? (f.logger.warn("Nominal service URL is reachable, erasing cached reconnect URL"), f.reconnectParams && delete f.reconnectParams.reconnectUrl) : f.logger.warn("Nominal service URL is not reachable either, keeping cached reconnect URL"), f.fsm.onAllocationFailed(!1, void 0);
                                            }, function() {
                                                f.fsm.onAllocationFailed(!1, void 0);
                                            });
                                        }
                                    }
                                } else f.logger.info("Expected failure, the browser says it is not online at the moment");
                                f.fsm.onAllocationFailed(401 === P, A);
                            });
                        }, t.prototype.testNominalUrlConnectivity = function(g) {
                            var f, S = this;
                            if (g < 1e3) return this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (".concat(g, " ms), falling back to assuming that the connectivity is fine")), Promise.resolve(!0);
                            try {
                                var v = new URL(this.options.trouterUrl);
                                v.pathname = v.pathname.replace(/\/v4\/.*/, "/"), v.search = "?" + this.buildQuery({
                                    check: Date.now(),
                                    cor_id: encodeURIComponent(this.options.clientCorrelationID),
                                    epid: encodeURIComponent(this.options.endpointId ? this.options.endpointId : ""),
                                    tc: encodeURIComponent((0, I.toJson)(this.clientInfo))
                                }), f = new Request(this.options.rewriteUrlForProxy(v.toString()), {
                                    method: "GET",
                                    headers: {
                                        Accept: "text/plain"
                                    }
                                });
                            } catch (g) {
                                return this.logger.warn("Nominal service URL connectivity test request could not be created (".concat(g, "), falling back to assuming that the connectivity is fine")), Promise.resolve(!0);
                            }
                            return (0, I.fetchWithTimeout)(f, g).then(function(g) {
                                if (200 !== g.status) throw new Error("Not 200 OK: ".concat(g.status, " ").concat(g.statusText));
                                return g.text();
                            }).then(function(g) {
                                if ("Trouter" !== g) throw new Error('Not "Trouter": '.concat(g.substring(0, 16)).concat(g.length > 16 ? "..." : ""));
                                return !0;
                            }).catch(function(g) {
                                return S.logger.error("Nominal service URL connectivity test failed: ".concat(g)), !1;
                            });
                        }, t.prototype.sendPingRequest = function() {
                            var g = this;
                            if (this.socket && void 0 === this.pingResponseTimerId) try {
                                this.logger.debug("emitting ping event");
                                var f = !1;
                                this.socket.emit("ping", function() {
                                    !0 !== f && g.onPingResponse();
                                }), this.pingResponseTimerId = setTimeout(function() {
                                    g.logger.error("Ping response timeout is fired"), f = !0, g.clearPingResponseTimer(), g.fsm.onPingResponseTimeout();
                                }, this.timeoutOptions.pongTimeoutMs);
                            } catch (g) {
                                var S = r(g);
                                this.logger.error("unable to send ping. Error: ".concat(S)), this.connectionTracker.trackError("ping", S, !1);
                            }
                        }, t.prototype.connectV4c = function(g, f) {
                            var S, E, T, I, b, A;
                            return _(this, void 0, void 0, function() {
                                var _, R, P, w;
                                return C(this, function(C) {
                                    switch(C.label){
                                        case 0:
                                            return [
                                                4,
                                                this.performV4cInitialConnectivityCheck()
                                            ];
                                        case 1:
                                            if (!1 === C.sent()) return [
                                                2
                                            ];
                                            (_ = this.options.ioOptions ? v({}, this.options.ioOptions) : new F)["force new connection"] = !0, _.reconnect = !1, (null === (S = this.reconnectParams) || void 0 === S ? void 0 : S.serviceUrl) && (0, D.adaptUrl)(this.reconnectParams.serviceUrl, "v4c") !== (0, D.adaptUrl)(this.options.trouterUrl, "v4c") && (this.logger.warn("Dropping cached connection parameters for a different environment (".concat(this.reconnectParams.serviceUrl, ", now ").concat(this.options.trouterUrl, ")")), this.reconnectParams = void 0), R = null !== (I = null !== (E = (0, D.redirectUrlIfPresent)(f)) && void 0 !== E ? E : "redirect-no-host" !== (null == f ? void 0 : f.kind) ? null === (T = this.reconnectParams) || void 0 === T ? void 0 : T.reconnectUrl : void 0) && void 0 !== I ? I : this.options.trouterUrl, P = (0, D.adaptUrl)(R, "v4c"), _["skipped handshake data"] = {
                                                timeout: 70,
                                                websocketUrl: P
                                            }, _.query = this.buildV4cUrlParams(), _.rewriteUrlForProxy = this.options.rewriteUrlForProxy;
                                            try {
                                                if (this.stopSocketIo(), this.transportTypeName = "websocket", this.socket = (null !== (b = this.options.io) && void 0 !== b ? b : k).connect(this.options.trouterUrl, _), void 0 === this.socket) throw new Error("failed to create Socket.io object");
                                                w = null === (A = this.audienceSubscriptionState) || void 0 === A ? void 0 : A.increaseCvAndGetEventObject(), this.attachSocketIoHandlers(this.socket, g, void 0, w);
                                            } catch (g) {
                                                this.logger.error("".concat(g)), this.connectionTracker.trackError("v4c", "".concat(g)), this.fsm.onV4cException();
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.performV4cInitialConnectivityCheck = function() {
                            return _(this, void 0, void 0, function() {
                                return C(this, function(g) {
                                    switch(g.label){
                                        case 0:
                                            return this.options.initialConnectivityCheck ? (this.logger.info("checking connectivity to configured URL (go URL) before a connection attempt"), [
                                                4,
                                                this.testNominalUrlConnectivity(3e3)
                                            ]) : [
                                                2,
                                                !0
                                            ];
                                        case 1:
                                            return g.sent() ? (this.connectivityCheckFailuresInARow = 0, [
                                                2,
                                                !0
                                            ]) : this.connectivityCheckFailuresInARow >= 3 ? (this.connectivityCheckFailuresInARow = 0, this.logger.error("three connectivity checks failed in a row, will attempt with the fallback protocol"), this.fsm.onV4cException(), [
                                                2,
                                                !1
                                            ]) : (this.logger.warn("connectivity check failed, will retry after backoff"), this.connectivityCheckFailuresInARow++, this.fsm.onV4cConnectivityCheckFailed(), [
                                                2,
                                                !1
                                            ]);
                                    }
                                });
                            });
                        }, t.prototype.sendV4cAuthenticationEvent = function(g) {
                            var f, S = {
                                headers: v(v({}, this.options.extraConnectionHeaders), o(g, this.usingLegacyTokenApi)),
                                connectparams: (0, D.reconnectParamsWithoutUrls)(this.reconnectParams)
                            };
                            null === (f = this.socket) || void 0 === f || f.emit(A.USER_AUTHENTICATE_EVENT_NAME, S);
                        }, t.prototype.setUserActivityState = function(g) {
                            var f = g.state !== this.userActivityState.state;
                            this.userActivityState = g, f ? (this.logger.info("Changing user activity state to '".concat(g.toEventJSON(), "'")), this.fsm.onSetNewUserActivityState()) : (this.logger.debug("Not changing the same user activity state '".concat(g.toEventJSON(), "'")), this.manager.onUserActivityStateAccepted(g.correlationVector.value()));
                        }, t.prototype.sendUserActivityState = function(g, f) {
                            if (this.userActivityState.state !== w.UserActivityState.Unknown) {
                                if (this.options.updateUserActivityDuringConnectionAttempt && this.socket) {
                                    var S = this.userActivityState.toEventObject(), v = this.socket.socket.options.query;
                                    if (v) {
                                        var _ = "userActivity=".concat(encodeURIComponent((0, I.toJson)(S)));
                                        -1 == v.search(this.USER_ACTIVITY_QUERY_PARAM_REGEX) ? this.socket.socket.options.query = v.concat("&", _) : this.socket.socket.options.query = v.replace(this.USER_ACTIVITY_QUERY_PARAM_REGEX, _);
                                    }
                                }
                                "websocket" === this.transportTypeName && f ? g === M.UserActivityEventReason.Connected ? this.sendUserActivityStateMultiple(2) : this.sendUserActivityStateMultiple(1) : "xhr-polling" === this.transportTypeName && g === M.UserActivityEventReason.Modified && this.fsm.forceReconnect("user activity/force reconnect");
                            }
                        }, t.prototype.setAudienceSubscriptionsAsync = function(g, f) {
                            var S = this.audienceSubscriptionState;
                            if (this.audienceSubscriptionState = g, this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME) return this.setAudienceSubscriptionsInternalAsync(g.increaseCvAndGetEventObject(), f);
                            if (this.transportTypeName === this.XHR_POLLING_TRANSPORT_NAME) {
                                var v = this.setAudienceSubscriptionsLongpollInternalAsync(g.increaseCvAndGetEventObject(), f, S);
                                return this.fsm.forceReconnect("set audience subscription force reconnect"), v;
                            }
                            throw new Error("set audience subscription executed on an unknown transport");
                        }, t.prototype.setAudienceSubscriptionsUnsafeAsync = function(g) {
                            if (g) return this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME ? this.setAudienceSubscriptionsInternalAsync(g, 15e3) : void 0;
                        }, t.prototype.setAudienceSubscriptionsInternalAsync = function(g, f) {
                            return _(this, void 0, void 0, function() {
                                var S, v, _ = this;
                                return C(this, function(C) {
                                    switch(C.label){
                                        case 0:
                                            return this.logger.info("[WebSocket] Audience subscription set requested."), (S = new B("audience.subscribe")).args = g, [
                                                4,
                                                new Promise(function(v) {
                                                    var C = !1, E = setTimeout(function() {
                                                        return C = !0, v(_.buildAudienceSubscriptionsTimeoutResponse(g));
                                                    }, f);
                                                    _.sendDownstreamEvent(S, function(g, f) {
                                                        C || (clearTimeout(E), _.logger.debug("[Websocket] Audience subscription response: ".concat(f)), _.pendingAudienceSubscription && _.onAudienceSubscriptionResult(f), v(f));
                                                    });
                                                })
                                            ];
                                        case 1:
                                            return v = C.sent(), this.manager.onAudiencesSetResolved(v, g.cv), [
                                                2,
                                                v
                                            ];
                                    }
                                });
                            });
                        }, t.prototype.setAudienceSubscriptionsLongpollInternalAsync = function(g, f, S) {
                            var v;
                            return _(this, void 0, void 0, function() {
                                var _, E, T, I, b, A, R = this;
                                return C(this, function(C) {
                                    switch(C.label){
                                        case 0:
                                            return this.logger.info("[XHR Polling] Audience subscription set requested."), this.pendingAudienceSubscription && (this.logger.error("Racing audience subscriptions occured. This situation resolves into undefined scenario and/or nasal demons."), clearTimeout(this.pendingAudienceSubscription.timeoutId)), 0 === g.audiences.length ? [
                                                2,
                                                this.handleAudienceUnsubscribeLongpoll(g.cv, S)
                                            ] : [
                                                4,
                                                new Promise(function(S) {
                                                    var v = setTimeout(function() {
                                                        return R.pendingAudienceSubscription = void 0, S(R.buildAudienceSubscriptionsTimeoutResponse(g));
                                                    }, f);
                                                    R.pendingAudienceSubscription = {
                                                        audienceSetResolve: S,
                                                        timeoutId: v
                                                    };
                                                })
                                            ];
                                        case 1:
                                            return _ = C.sent(), this.manager.getState() === w.TrouterState.Unknown || this.transportTypeName === this.WEBSOCKET_TRANSPORT_NAME ? [
                                                2,
                                                _
                                            ] : (null == (E = _.responses[0]) ? void 0 : E.result.audienceSubscriptionState) === this.AUDIENCE_SUBSCRIPTION_RESULT_BAD_REQUEST ? (this.clearAudienceSubscriptionStateQueryParam(), this.manager.onAudiencesSetResolved(_, g.cv), [
                                                2,
                                                _
                                            ]) : (T = _.responses.find(function(f) {
                                                return f.audienceId === g.audiences[0].id;
                                            }), (null == T ? void 0 : T.result.audienceSubscriptionState) === this.AUDIENCE_SUBSCRIPTION_RESULT_ERROR ? (this.clearAudienceSubscriptionStateQueryParam(), this.manager.onAudiencesSetResolved(_, g.cv), [
                                                2,
                                                _
                                            ]) : (I = (null === (v = null == S ? void 0 : S.audienceSubscriptionModel.audienceSubscriptions[0]) || void 0 === v ? void 0 : v.id) !== (null == E ? void 0 : E.audienceId), S && I && (b = this.mapToSyntheticAudienceSubscriptionResponses(S.audienceSubscriptionModel.audienceSubscriptions, this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED, 200), (A = _.responses).push.apply(A, b)), this.manager.onAudiencesSetResolved(_, g.cv), [
                                                2,
                                                _
                                            ]));
                                    }
                                });
                            });
                        }, t.prototype.clearAudienceSubscriptionStateQueryParam = function() {
                            var g, f, S;
                            (null === (S = null === (f = null === (g = this.socket) || void 0 === g ? void 0 : g.socket) || void 0 === f ? void 0 : f.options) || void 0 === S ? void 0 : S.query) && (this.socket.socket.options.query = this.socket.socket.options.query.replace(this.AUDIENCE_SUBSCRIPTION_STATE_QUERY_PARAM_REGEX, ""));
                        }, t.prototype.handleAudienceUnsubscribeLongpoll = function(g, f) {
                            var S;
                            this.audienceSubscriptionState = void 0;
                            var v = {
                                responses: []
                            };
                            if (f) {
                                var _ = this.mapToSyntheticAudienceSubscriptionResponses(f.audienceSubscriptionModel.audienceSubscriptions, this.AUDIENCE_SUBSCRIPTION_RESULT_UNSUBSCRIBED, 200);
                                (S = v.responses).push.apply(S, _);
                            }
                            return this.manager.onAudiencesSetResolved(v, g), v;
                        }, t.prototype.buildAudienceSubscriptionsTimeoutResponse = function(g) {
                            return this.logger.error("Audience subscription attempt has timed out."), {
                                responses: this.mapToSyntheticAudienceSubscriptionResponses(g.audiences, this.AUDIENCE_SUBSCRIPTION_RESULT_TIMEOUT)
                            };
                        }, t.prototype.mapToSyntheticAudienceSubscriptionResponses = function(g, f, S) {
                            return g.map(function(g) {
                                return {
                                    audienceId: g.id,
                                    result: {
                                        audienceSubscriptionState: f,
                                        responseStatus: S
                                    }
                                };
                            });
                        }, t.prototype.expediteBackoff = function() {
                            this.tokenBackoff.expediteIfPending();
                        }, t.prototype.sendRegisterRequest = function() {
                            var g = this;
                            if (!this.options.registration || !this.registrarClient) throw new Error("Internal error - options.registration is undefined");
                            if (!this.allocateResult) throw new Error("Allocate result is undefined in sendRegisterRequest()");
                            this.logger.info("sending register request");
                            var f = new I.Timespan;
                            this.connectionTracker.trackStart("registration");
                            var S = this.getRegistrationTtl()[0];
                            this.registrarClient.register({
                                appId: this.options.registration.pnhAppId,
                                aesKey: "",
                                languageId: "en-US",
                                platform: this.options.registration.platform,
                                templateKey: this.options.registration.pnhTemplateKey,
                                platformUIVersion: this.options.registration.platformUIVersion,
                                productContext: this.options.registration.productContext
                            }, {
                                TROUTER: [
                                    {
                                        context: this.options.registration.context,
                                        path: this.allocateResult.surl,
                                        ttl: S
                                    }
                                ]
                            }).then(function() {
                                g.logger.info("Register request successful"), g.connectionTracker.trackEnd("registration"), g.fsm.onRegistrationSucceeded(), g.connectionTracker.sendTelemetry(b.ClientEventName.Registration, {
                                    duration: f.duration
                                }, []);
                            }).catch(function(S) {
                                g.logger.error("Register request failed. Error: ".concat(S)), g.connectionTracker.trackError("registration", s(S)), g.fsm.onRegistrationFailed(), g.connectionTracker.sendTelemetry(b.ClientEventName.Registration, {
                                    duration: f.duration
                                }, []);
                            });
                        }, t.prototype.sendUnregisterRequest = function() {
                            var g = this;
                            this.logger.info("sending unregister request");
                            var f = new I.Timespan;
                            if (!this.options.registration || !this.registrarClient) throw new Error("Internal error - options.registration is undefined");
                            this.connectionTracker.trackStart("unregistration"), this.registrarClient.unregister().then(function() {
                                g.logger.info("Unregister request successful"), g.connectionTracker.trackEnd("unregistration"), g.fsm.onUnregistrationDone(), g.connectionTracker.sendTelemetry(b.ClientEventName.Unregistration, {
                                    duration: f.duration
                                }, []);
                            }).catch(function(S) {
                                g.logger.error("Unregister request failed. Error: ".concat(S)), g.connectionTracker.trackError("unregistration", s(S)), g.fsm.onUnregistrationDone(), g.connectionTracker.sendTelemetry(b.ClientEventName.Unregistration, {
                                    duration: f.duration
                                }, []);
                            });
                        }, t.prototype.resetTokenBackoff = function() {
                            this.tokenBackoff.reset();
                        }, t.prototype.cancelPendingRegistrationRequests = function() {
                            this.registrarClient && this.registrarClient.cancelPendingRequests();
                        }, t.prototype.clearSentEventTimers = function() {
                            var g = Object.keys(this.pendingSentEventTimers);
                            if (g.length > 0) {
                                this.logger.debug("Clearing all pending downstream events related timers");
                                for(var f = 0, S = g; f < S.length; f++){
                                    var v = S[f];
                                    this.clearSentEventTimer(Number(v));
                                }
                            }
                        }, t.prototype.restartIncallModeTimer = function() {
                            var g = this;
                            this.clearIncallModeTimerId(), this.logger.debug("Restarting incall mode timer"), this.incallModeTimerId = setTimeout(function() {
                                g.logger.info("Call mode timer fired"), g.fsm.onIncallModeTimer();
                            }, this.options.incallModeTimeoutMs);
                        }, t.prototype.enterIncallMode = function() {
                            this.logger.info("Entering incall mode"), this.timeoutOptions = this.options.incallTimeoutOptions, this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs), this.inIncallMode = !0;
                        }, t.prototype.exitIncallMode = function() {
                            this.logger.info("Exiting incall mode"), this.clearIncallModeTimerId(), this.timeoutOptions = this.options.timeoutOptions, this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs), this.inIncallMode = !1;
                        }, t.prototype.isIncallMode = function() {
                            return this.inIncallMode;
                        }, t.prototype.sendDisconnectTelemetryEvent = function(g) {
                            var f = {
                                reason: g,
                                serverClosed: !this.fsm.isActive()
                            };
                            this.connectionTracker.trackDisconnected(f), this.connectionTracker.clearConnectedInfo();
                        }, t.prototype.forceReconnectDueToNoRegistration = function() {
                            this.fsm.forceReconnect("force reconnect due to no registration");
                        }, t.prototype.resetReconnectParamsOnErrorThreshold = function() {
                            this.logger.warn("".concat(this.connectingErrorsInRow, " connection attempts, server-side failure: erasing cached connection parameters")), this.reconnectParams = void 0;
                        }, t.prototype.onSocketConnecting = function(g) {
                            this.logger.info("onSocketConnecting(".concat(g, ")")), this.transportTypeName = g, this.connectionTracker.trackProgress("connecting", this.transportTypeName), this.fsm.onConnecting();
                        }, t.prototype.onSocketConnect = function(g) {
                            this.logger.info("onSocketConnect"), this.fsm.onSocketConnect(g);
                        }, t.prototype.onSocketConnectFailed = function(g) {
                            this.logger.error("onSocketConnectFailed"), this.connectionTracker.trackError("connect_failed", g, !0, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT), this.fsm.onConnectingFailed();
                        }, t.prototype.onSocketDisconnect = function(g) {
                            var f = this.connectionTracker.getSessionLength() || 0, S = R.DisconnectReason.fromRawReason(g);
                            this.logger.error("onSocketDisconnect, reason: ".concat(S.reason)), "dup" === S.reason && "dup" === this.lastDisconnectReason && f < this.options.duplicateDisconnectThresholdMs && (this.logger.warn("Socket was closed by server as Duplicate for the second time in a row " + "after ".concat(f, " ms which is below the threshold of ") + "".concat(this.options.duplicateDisconnectThresholdMs, " ms. Resetting cached ") + "connection parameters and making a new allocation."), this.reconnectParams = void 0), this.lastDisconnectReason = S.reason, this.fsm.onSocketDisconnect(S), this.connectionExpireTimestampInSecs = void 0;
                        }, t.prototype.onSocketReconnect = function() {
                            this.logger.error("onSocketReconnect"), this.fsm.onTrouterConnected();
                        }, t.prototype.onSocketReconnectFailed = function(g) {
                            this.logger.error("onSocketReconnectFailed with '".concat(g, "'")), this.fsm.onSocketDisconnect(R.DisconnectReason.fromSocketIoEventData("reconnecterror", g));
                        }, t.prototype.onSocketReconnecting = function() {
                            this.logger.error("onSocketReconnecting");
                        }, t.prototype.onSocketError = function(g) {
                            this.logger.error("onSocketError with '".concat((0, I.toJson)(g), "'")), this.fsm.isConnecting() && ++this.connectingErrorsInRow >= this.connectingErrorsThreshold && this.resetReconnectParamsOnErrorThreshold(), this.connectionTracker.trackError("connectSocket", i(g)), this.fsm.onSocketDisconnect(R.DisconnectReason.fromSocketIoEventData("socketerror", g));
                        }, t.prototype.onSocketMessage = function(g) {
                            var f, S, v = this;
                            this.logger.debug("onSocketMessage");
                            try {
                                var _ = null === (f = (S = new U(g, this.logger)).headers) || void 0 === f ? void 0 : f["X-Microsoft-Skype-Chain-ID"], C = _ ? " Chain-Id ".concat(_) : "";
                                this.logger.info("Received request N ".concat(S.id).concat(C, " CV ").concat(S.correlationVector, " to '").concat(S.url, "'")), S.startTS = Date.now(), S.url && this.urlPath && S.url.startsWith(this.urlPath) && (S.shortUrl = S.url.substring(this.urlPath.length));
                            } catch (g) {
                                var E = r(g);
                                return this.logger.error("unable to parse request. Error: ".concat(E)), this.connectionTracker.trackRequest(void 0, E), void this.connectionTracker.sendResponseError("unable to parse request, error: ".concat(g));
                            }
                            S.timeoutTimerId = setTimeout(function() {
                                if (!S.replied) {
                                    v.logger.error("Request ".concat(S.id, " timed out"));
                                    var g = new b.ResponseData(S.id);
                                    g.status = 504, g.headers = {
                                        "Trouter-Responder": "ClientLib"
                                    }, v.sendResponse(S, g), S.timedout = !0;
                                }
                            }, this.timeoutOptions.requestTimeoutMs);
                            try {
                                this.connectionTracker.trackRequest(S), this.fsm.onDownstreamRequest(S);
                            } catch (g) {
                                this.logger.error("exception in socket.on message. Error: ".concat(r(g))), this.connectionTracker.sendResponseError(s(g), S, void 0);
                            }
                        }, t.prototype.onTrouterConnected = function(g, f, S) {
                            var _, C, E, T, b, A = this;
                            if ((0, D.isV4ConnectEvent)(g)) {
                                var R = g;
                                this.allocateResult = v(v({}, R), {
                                    ttl: g.ttl.toString()
                                }), this.populateAndCacheReconnectParams(R, R.reconnectUrl), this.populateConnectionStateFields(R);
                            } else if (!this.allocateResult) return void this.logger.error("Invalid internal state - received onTrouterConnected while allocateResult is not set");
                            this.connectingErrorsInRow = 0, this.logger.info("onTrouterConnected: ".concat(this.allocateResult.surl)), this.options.updateUserActivityDuringConnectionAttempt ? "xhr-polling" === this.transportTypeName && ((null !== (_ = null == f ? void 0 : f.state) && void 0 !== _ ? _ : "unknown") !== this.userActivityState.getStateString() ? (this.logger.info("XHR user activity changed during connection attempt, from '".concat((0, I.toJson)(f), "' to '").concat(this.userActivityState.toEventJSON(), "', updating")), this.sendUserActivityStateIgnoreResponse()) : f && this.manager.onUserActivityStateAccepted(f.cv)) : "xhr-polling" === this.transportTypeName && f && this.manager.onUserActivityStateAccepted(f.cv), (null === (T = null === (E = null === (C = this.socket) || void 0 === C ? void 0 : C.socket) || void 0 === E ? void 0 : E.options) || void 0 === T ? void 0 : T.query) && (this.socket.socket.options.query += "&connected=true"), this.urlPath = this.allocateResult.surl.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//, "/");
                            var P = this.connectedUrl !== this.allocateResult.surl;
                            this.connectedUrl = this.allocateResult.surl, this.connectionExpireTimestampInSecs = (0, I.calculateExpireTsInSec)((0, D.ensureNumber)(g.ttl)), this.connectionTracker.trackEnd("connectSocket"), this.connectionTracker.trackConnected(P, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT), null === (b = this.setAudienceSubscriptionsUnsafeAsync(S)) || void 0 === b || b.catch(function(g) {
                                return A.logger.error("Re-subscribe to audiences has failed with ".concat(g));
                            }), this.fsm.onTrouterConnected();
                        }, t.prototype.onTrouterReconnect = function(g) {
                            var f = g.target;
                            this.logger.info("onTrouterReconnect target: ".concat(f)), "self" === f ? this.fsm.onReconnectRequired(!0, E.ServerInitiated) : this.fsm.onReconnectRequired(!1, E.ServerInitiated, g);
                        }, t.prototype.onTrouterMessageLoss = function(g) {
                            this.logger.debug("onTrouterMessageLoss"), this.fsm.onTrouterMessageLost(g.droppedIndicators);
                        }, t.prototype.onAudienceSubscriptionResult = function(g) {
                            this.logger.info("onAudienceSubscriptionResult"), this.pendingAudienceSubscription && (clearTimeout(this.pendingAudienceSubscription.timeoutId), this.pendingAudienceSubscription.audienceSetResolve(g), this.pendingAudienceSubscription = void 0);
                        }, t.prototype.buildV4cUrlParams = function() {
                            var g = {};
                            return g.tc = encodeURI((0, I.toJson)(this.clientInfo)), g.timeout = Math.floor(this.timeoutOptions.pingTimeoutMs / 1e3), this.options.endpointId && (g.epid = this.options.endpointId), this.appendConnectedClientIds(this.buildQuery(g), !0);
                        }, t.prototype.attachSocketIoHandlers = function(g, f, S, v) {
                            var _ = this;
                            g.on("connecting", function(g) {
                                _.onSocketConnecting(g);
                            }), g.on("connect", function() {
                                _.onSocketConnect(f);
                            }), g.on("connect_failed", function(g) {
                                _.onSocketConnectFailed(g);
                            }), g.on("close_during_connecting", function(g) {
                                _.onSocketConnectFailed(g);
                            }), g.on("disconnect", function(g) {
                                _.onSocketDisconnect(g);
                            }), g.on("reconnect", function() {
                                _.onSocketReconnect();
                            }), g.on("reconnect_failed", function(g) {
                                _.onSocketReconnectFailed(g);
                            }), g.on("reconnecting", function() {
                                _.onSocketReconnecting();
                            }), g.on("error", function(g) {
                                _.onSocketError(g);
                            }), g.on("message", function(g) {
                                _.onSocketMessage(g);
                            }), g.on("trouter.connected", function(g) {
                                _.onTrouterConnected(g, S, v);
                            }), g.on("trouter.reconnect", function(g) {
                                _.onTrouterReconnect(g);
                            }), g.on("trouter.message_loss", function(g) {
                                _.onTrouterMessageLoss(g);
                            }), g.on("audience.subscriptionresult", function(g, f) {
                                _.onAudienceSubscriptionResult(f);
                            });
                        }, t.prototype.onNavigatorOnlineStatusUpdate = function() {
                            var g = window.navigator.onLine;
                            this.logger.debug("Browser online status update - new state: ".concat(g, ", previously: ").concat(this.isNavigatorOnline)), g && !this.isNavigatorOnline ? (this.isNavigatorOnline = !0, this.tokenBackoff.expediteIfPending(), this.connectionTracker.trackProgress("browserNet", "online")) : !g && this.isNavigatorOnline && (this.isNavigatorOnline = !1, this.connectionTracker.trackProgress("browserNet", "offline"));
                        }, t.prototype.onAllocationResponse = function(g, f) {
                            this.logger.info("Received allocation response ".concat(JSON.stringify(v(v({}, g), {
                                connectparams: void 0
                            })), " (connectparams redacted)")), this.allocateResult = g, this.populateAndCacheReconnectParams(this.allocateResult, "".concat(this.allocateResult.socketio, "v4/a")), this.populateConnectionStateFields(this.allocateResult), this.fsm.onAllocationSucceed(f);
                        }, t.prototype.populateAndCacheReconnectParams = function(g, f) {
                            this.reconnectParams = v({
                                serviceUrl: this.options.trouterUrl,
                                reconnectUrl: f
                            }, g.connectparams), this.manager.onConnectionParametersUpdated(this.reconnectParams);
                        }, t.prototype.populateConnectionStateFields = function(g) {
                            var f, S, v = "string" == typeof g.ttl ? parseInt(g.ttl, 10) : g.ttl;
                            if (this.connectionExpireTimestampInSecs = (0, I.calculateExpireTsInSec)(v), this.connectionId = null !== (f = g.id) && void 0 !== f ? f : "", this.connectedClientId = g.ccid, this.logger.debug("connected client id set {connectedClientId:".concat(this.connectedClientId, "}")), this.c2cUrlBase = null !== (S = g.curlb) && void 0 !== S ? S : "", "" === this.c2cUrlBase) {
                                var _ = g.surl.indexOf("://");
                                _ >= 0 && (_ = g.surl.indexOf("/", _ + 3)) >= 5 && ":3443" === g.surl.substr(_ - 5, 5) && (this.c2cUrlBase = g.surl.substr(0, _ - 5));
                            }
                        }, t.prototype.onPingResponse = function() {
                            this.logger.debug("onPingResponse"), this.connectionTracker.increasePingResponseCount(), this.clearPingResponseTimer(), this.fsm.onPingResponse();
                        }, t.prototype.clearPingResponseTimer = function() {
                            void 0 !== this.pingResponseTimerId && (clearTimeout(this.pingResponseTimerId), this.pingResponseTimerId = void 0);
                        }, t.prototype.buildQuery = function(g) {
                            for(var f = [], S = 0, v = Object.keys(g); S < v.length; S++){
                                var _ = v[S];
                                void 0 !== g[_] && f.push("".concat(_, "=").concat(g[_]));
                            }
                            return f.join("&");
                        }, t.prototype.appendConnectedClientIds = function(g, f) {
                            var S = "";
                            g.includes("ccid=") || (S = "ccid=".concat(this.connectedClientId, "&")), this.domId && (S += "dom=".concat(this.domId, "&")), S.length > 0 && (S = S.slice(0, -1));
                            var v = f || g.includes("?") ? "&" : "?";
                            return this.appendCorrelationIds(g + v + S, f);
                        }, t.prototype.appendEndpointId = function(g, f) {
                            var S = f || g.includes("?") ? "&" : "?";
                            return !g.includes("epid") && this.options.endpointId ? "".concat(g).concat(S, "epid=").concat(this.options.endpointId) : g;
                        }, t.prototype.appendCorrelationIds = function(g, f) {
                            var S = f || g.includes("?") ? "&" : "?";
                            return g.includes("cor_id") ? g : "".concat(g).concat(S, "cor_id=").concat(this.options.clientCorrelationID) + "&con_num=".concat(this.clientID, "_").concat(this.connectionAttempt);
                        }, t.prototype.safeString = function(g) {
                            return "string" == typeof g ? g : "";
                        }, t.prototype.sendResponse = function(g, f) {
                            var S, v, _;
                            if (g.timedout) return this.logger.error("Request ".concat(g.id, " already timed out")), 1;
                            if (g.replied) return this.logger.error("Response for request ".concat(g.id, " already sent")), 2;
                            clearTimeout(g.timeoutTimerId), g.timeoutTimerId = void 0, g.replied = !0, f.headers = null !== (S = f.headers) && void 0 !== S ? S : {};
                            var C = g.correlationVector;
                            this.logger.info("Sending response N ".concat(g.id, " CV ").concat(C, " with status ").concat(f.status)), C && (f.headers[x] = C), (null === (v = g.headers) || void 0 === v ? void 0 : v["trouter-request"]) && (f.headers["trouter-request"] = g.headers["trouter-request"]);
                            var E = Date.now() - g.startTS;
                            if (f.headers["trouter-client"] = (0, I.toJson)({
                                cd: E
                            }), (null === (_ = g.headers) || void 0 === _ ? void 0 : _["trouter-is-broadcast"]) && (f.headers["trouter-is-broadcast"] = g.headers["trouter-is-broadcast"]), !this.socket) return this.connectionTracker.sendResponseError("no socket", g, f), 4;
                            try {
                                return this.socket.send((0, I.toJson)(f)), f.sentTS = Date.now(), g.incrementCorrelationVector(), this.connectionTracker.trackResponse(g, E, f), "websocket" === this.transportTypeName && this.sendPingRequest(), 0;
                            } catch (S) {
                                var T = "unable to send data on response.end. Error: ".concat(r(S));
                                return this.logger.error(T), this.connectionTracker.sendResponseError(T, g, f), 4;
                            }
                        }, t.prototype.sendUserActivityStateMultiple = function(g) {
                            var f = this, S = new B("user.activity"), v = this.userActivityState.increaseCvAndGetEventObject();
                            S.args = v, this.logger.debug("Sending user activity '".concat(this.userActivityState.toEventJSON(), "', remaining ").concat(g - 1));
                            var _ = !1;
                            this.sendDownstreamEvent(S, function() {
                                if (!0 !== _ && (f.logger.info("User activity state: ".concat(v.state, ", cv: ").concat(v.cv, " accepted")), f.manager.onUserActivityStateAccepted(v.cv), f.clearSentEventTimer(S.timeoutTimerId), g > 1)) {
                                    var C = setTimeout(function() {
                                        f.clearSentEventTimer(C), f.sendUserActivityStateMultiple(g - 1);
                                    }, f.options.userActivitySecondResendDelayMs);
                                    f.registerSentEventTimer(C, "user.activity/resend");
                                }
                            }), S.timeoutTimerId = setTimeout(function() {
                                f.logger.error("Activity state response timeout is fired"), _ = !0, f.fsm.onActivityStateResponseTimeout(), f.clearSentEventTimer(S.timeoutTimerId);
                            }, this.timeoutOptions.userActivityResponseTimeoutMs), this.registerSentEventTimer(S.timeoutTimerId, "user.activity/response");
                        }, t.prototype.sendUserActivityStateIgnoreResponse = function() {
                            var g = new B("user.activity"), f = this.userActivityState.toEventObject();
                            g.args = f, this.socket && (this.logger.info("Sending user activity after XHR connect, ".concat(f.state, ", cv: ").concat(f.cv, ", treating it as accepted")), this.socket.emit(g.name, g.args), this.manager.onUserActivityStateAccepted(f.cv));
                        }, t.prototype.sendDownstreamEvent = function(g, f) {
                            this.logger.debug("Sending downstream event ".concat(g.name)), this.socket && this.socket.emit(g.name, g.args, f);
                        }, t.prototype.registerSentEventTimer = function(g, f) {
                            this.logger.debug("registering timer ".concat(g, " -> ").concat(f)), this.pendingSentEventTimers[g] = f;
                        }, t.prototype.clearSentEventTimer = function(g) {
                            var f = this.pendingSentEventTimers[g];
                            this.logger.debug("clearing timer ".concat(g, " -> ").concat(f)), delete this.pendingSentEventTimers[g], clearTimeout(g);
                        }, t.prototype.getRegistrationTtl = function() {
                            var g, f, S = (0, I.calculateTtlInSec)(this.connectionExpireTimestampInSecs);
                            if (this.logger.debug("Current connectionID will expire in ".concat(S, " seconds")), (null === (g = this.options.registration) || void 0 === g ? void 0 : g.registrarTtlSec) && S > 0) {
                                var v = this.options.registration.registrarTtlSec < S;
                                return [
                                    Math.min(this.options.registration.registrarTtlSec, S),
                                    v
                                ];
                            }
                            return (null === (f = this.options.registration) || void 0 === f ? void 0 : f.registrarTtlSec) ? [
                                this.options.registration.registrarTtlSec,
                                !1
                            ] : S > 0 ? [
                                S,
                                !1
                            ] : [
                                3600,
                                !1
                            ];
                        }, t.prototype.clearIncallModeTimerId = function() {
                            void 0 !== this.incallModeTimerId && (this.logger.debug("Clearing in-call mode timer"), clearTimeout(this.incallModeTimerId), this.incallModeTimerId = void 0);
                        }, t.prototype.applyConnectionTrackerOptions = function(g) {
                            try {
                                g.eventLogger && "function" == typeof g.eventLogger.logEvent ? (this.connectionTracker.mergeSettings(g.telemetrySettings), this.connectionTracker.enable(g.eventLogger)) : this.logger.warn("Trouter client event logging disabled due to invalid configuration.");
                            } catch (g) {
                                this.logger.warn("Trouter client event logging disabled. Error: ".concat(r(g))), this.connectionTracker.disable();
                            }
                        }, t.prototype.canRetryTokenFetchRequest = function(g) {
                            var f = this.options.retryLimitOnTokenFetch;
                            return null == f || g < f || (this.logger.warn("Reached limit on maximum number of token fetch request. Current count: ".concat(g, ", retry limit: ").concat(f)), !1);
                        }, t;
                    }();
                    f.TrouterConnection = H;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.MessageHandlerRegistry = void 0;
                    var v = S(1), _ = S(0), C = function() {
                        function t(g) {
                            this.messageHandlers = [], this.logger = new _.Logger("MessageHandlers", g);
                        }
                        return t.prototype.register = function(g) {
                            if (this.messageHandlers.some(function(f) {
                                return f === g;
                            })) throw new Error("Registering the same handler twice is not allowed");
                            this.messageHandlers.push(g);
                        }, t.prototype.clear = function() {
                            this.logger.debug("Clearing message handlers"), this.messageHandlers = [];
                        }, t.prototype.active = function() {
                            return this.messageHandlers.length > 0;
                        }, t.prototype.handleMessage = function(g) {
                            for(var f = {
                                resultCode: v.UNHANDLED_MESSAGE_ACK,
                                isHandled: !1
                            }, S = 0, _ = this.messageHandlers; S < _.length; S++){
                                var C = _[S], E = this.safeExecuteHandle(C, g);
                                if (void 0 !== E && (void 0 === E.isHandled || E.isHandled)) return void 0 === E.resultCode && (E.resultCode = v.HANDLED_MESSAGE_ACK), E;
                            }
                            return f;
                        }, t.prototype.safeExecuteHandle = function(g, f) {
                            try {
                                return g.handleMessage(f);
                            } catch (g) {
                                return void this.logger.warn("Trouter message handler threw an exception: ".concat(g));
                            }
                        }, t;
                    }();
                    f.MessageHandlerRegistry = C;
                },
                function(g, f, S) {
                    function o(g) {
                        var f, S = this;
                        return function(C) {
                            return v(S, void 0, void 0, function() {
                                return _(this, function(S) {
                                    return C && (f = void 0), [
                                        2,
                                        new Promise(function(S, v) {
                                            g(C).then(function(g) {
                                                f = g, S(g);
                                            }).catch(function(g) {
                                                void 0 !== f && f.length > 0 && S(f), v(g);
                                            });
                                        })
                                    ];
                                });
                            });
                        };
                    }
                    var v = this && this.__awaiter || function(g, f, S, v) {
                        function i(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    a(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                try {
                                    a(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                g.done ? S(g.value) : i(g.value).then(s, c);
                            }
                            a((v = v.apply(g, f || [])).next());
                        });
                    }, _ = this && this.__generator || function(g, f) {
                        function n(g) {
                            return function(f) {
                                return o([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function o(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: n(0),
                            throw: n(1),
                            return: n(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.addCacheAsBackupTo = void 0, f.addCacheAsBackupTo = o;
                },
                function(g, f, S) {
                    var v = this && this.__awaiter || function(g, f, S, v) {
                        function i(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    a(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                try {
                                    a(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                g.done ? S(g.value) : i(g.value).then(s, c);
                            }
                            a((v = v.apply(g, f || [])).next());
                        });
                    }, _ = this && this.__generator || function(g, f) {
                        function n(g) {
                            return function(f) {
                                return o([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function o(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: n(0),
                            throw: n(1),
                            return: n(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterManager = f.AudienceSubscriptionState = f.UserActivityObject = void 0;
                    var C = S(3), E = S(2), T = S(4), I = S(0), b = S(5), A = S(18), R = S(7), P = S(6), w = S(19), M = function() {
                        function t(g, f) {
                            this.state = g, this.correlationVector = void 0 !== f ? f : C.CorrelationVector.extend();
                        }
                        return t.prototype.getStateString = function() {
                            switch(this.state){
                                case E.UserActivityState.Active:
                                    return "active";
                                case E.UserActivityState.Inactive:
                                    return "inactive";
                                case E.UserActivityState.Unknown:
                                    return "unknown";
                                default:
                                    return "undefined";
                            }
                        }, t.prototype.increaseCvAndGetEventObject = function() {
                            return this.correlationVector.increase(), this.toEventObject();
                        }, t.prototype.toEventObject = function() {
                            return {
                                state: this.getStateString(),
                                cv: this.correlationVector.value()
                            };
                        }, t.prototype.toEventJSON = function() {
                            return (0, C.toJson)(this.toEventObject());
                        }, t;
                    }();
                    f.UserActivityObject = M;
                    var O = function() {
                        function t(g, f) {
                            void 0 === f && (f = C.CorrelationVector.extend()), this.audienceSubscriptionModel = g, this.correlationVector = f;
                        }
                        return t.prototype.increaseCvAndGetEventObject = function() {
                            return this.correlationVector.increase(), this.toEventObject();
                        }, t.prototype.toEventObject = function() {
                            return {
                                audiences: this.audienceSubscriptionModel.audienceSubscriptions,
                                cv: this.correlationVector.value()
                            };
                        }, t.prototype.toEventJSON = function() {
                            return (0, C.toJson)(this.toEventObject());
                        }, t;
                    }();
                    f.AudienceSubscriptionState = O;
                    var D = function() {
                        function t(g, f, S, v, _, T) {
                            var A = this;
                            this.logFunc = g, this.options = f, this.tokenProvider = S, this.usingLegacyTokenApi = v, this.listener = _, this.tokenTypeProtocolSelector = function(g, f) {
                                return A.options.forceV4aProtocol ? "v4a" : (0, b.usedProtocol)(g, f);
                            }, this.logger = new I.Logger("Manager", g), this.logger.info("Created TrouterManager with options ".concat((0, C.toJson)(this.options))), this.fsm = new w.TrouterManagerFsm(g, this), this.baseEndpointUrl = "", this.processedMessageLoss = {}, this.userActivityObject = new M(E.UserActivityState.Unknown), this.protocolSelector = null != T ? T : this.tokenTypeProtocolSelector.bind(this);
                        }
                        return t.prototype.start = function() {
                            this.fsm.start();
                        }, t.prototype.stop = function(g) {
                            this.fsm.stop(g);
                        }, t.prototype.configure = function(g) {
                            this.options = g, void 0 !== this.firstConnection && this.firstConnection.configure(g), void 0 !== this.secondConnection && this.secondConnection.configure(g), this.logger.info("Reconfigured TrouterManager with options ".concat((0, C.toJson)(this.options)));
                        }, t.prototype.checkConnection = function(g) {
                            void 0 !== this.firstConnection && this.firstConnection.checkConnection(g), void 0 !== this.secondConnection && this.secondConnection.checkConnection(g);
                        }, t.prototype.resendRegistration = function() {
                            return v(this, void 0, void 0, function() {
                                return _(this, function(g) {
                                    return void 0 !== this.secondConnection ? (this.logger.info("Resending registration on the second/new connection"), [
                                        2,
                                        this.secondConnection.resendRegistration()
                                    ]) : void 0 !== this.firstConnection ? (this.logger.info("Resending registration on the first/current connection"), [
                                        2,
                                        this.firstConnection.resendRegistration()
                                    ]) : (this.logger.info("No connection to resend registration on, will be done upon (re)connect"), [
                                        2
                                    ]);
                                });
                            });
                        }, t.prototype.getServerState = function() {
                            if (void 0 !== this.firstConnection) return this.firstConnection.getServerState();
                        }, t.prototype.getState = function() {
                            return this.fsm.getState();
                        }, t.prototype.isInTerminalState = function() {
                            return this.fsm.getInternalState() === T.TrouterManagerState.TerminalError;
                        }, t.prototype.reportStateInfo = function() {
                            var g = this.firstConnection ? P.State[this.firstConnection.getState()] : "Unknown", f = T.TrouterManagerState[this.fsm.getInternalState()];
                            if (this.secondConnection) {
                                var S = P.State[this.secondConnection.getState()];
                                return "Manager ".concat(f, "; 1st ").concat(g, "; 2nd ").concat(S);
                            }
                            return "Manager ".concat(f, "; Connection ").concat(g);
                        }, t.prototype.startFirstConnection = function() {
                            var g = new R.TrouterConnection(this.logFunc, this.options, this.configuredTrouterManager(), this.tokenProvider, this.usingLegacyTokenApi, this.userActivityObject, this.protocolSelector, this.audienceSubscriptionState);
                            this.firstConnection = g, this.getConnectionCache().then(function(f) {
                                g.start(f);
                            }).catch(function() {});
                        }, t.prototype.startSecondConnection = function(g) {
                            var f = new R.TrouterConnection(this.logFunc, this.options, this.configuredTrouterManager(), this.tokenProvider, this.usingLegacyTokenApi, this.userActivityObject, this.protocolSelector, this.audienceSubscriptionState);
                            this.secondConnection = f, void 0 !== this.firstConnection && this.firstConnection.disableRegistrationsAndAutoReconnect(), g ? this.getConnectionCache().then(function(g) {
                                f.start(g);
                            }).catch(function() {}) : f.start();
                        }, t.prototype.stopFirstConnection = function(g) {
                            void 0 !== this.firstConnection && (this.storedFirstConnection = this.firstConnection, this.firstConnection.stop(g), this.firstConnection = void 0);
                        }, t.prototype.stopSecondConnection = function(g) {
                            void 0 !== this.secondConnection && (this.secondConnection.stop(g), this.secondConnection = void 0);
                        }, t.prototype.stopSecondConnectionDelayed = function() {
                            if (void 0 !== this.secondConnection) {
                                var g = this.secondConnection;
                                this.secondConnection = void 0, this.logger.info("Closing an inactive connection in ".concat(Math.round(this.options.lingeringConnectionDelayMs / 1e3), "s")), setTimeout(function() {
                                    g.stop(!0);
                                }, this.options.lingeringConnectionDelayMs);
                            }
                        }, t.prototype.forceStopLingeringConnection = function() {
                            this.storedFirstConnection && (this.storedFirstConnection.stop(!1), this.storedFirstConnection = void 0);
                        }, t.prototype.switchConnections = function() {
                            var g = this.firstConnection;
                            this.firstConnection = this.secondConnection, this.secondConnection = g;
                        }, t.prototype.doesSecondConnectionExist = function() {
                            return void 0 !== this.secondConnection;
                        }, t.prototype.dispatchConnected = function() {
                            if (void 0 !== this.firstConnection) {
                                var g = this.firstConnection.getServerState(), f = g.url.endsWith("/") ? g.url.slice(0, -1) : g.url, S = {
                                    baseEndpointUrl: f,
                                    newEndpointUrl: f !== this.baseEndpointUrl,
                                    c2cUrlBase: g.c2cUrlBase,
                                    clientId: g.connectedClientId,
                                    connectionId: g.connectionId,
                                    connectionTtlSec: g.getRemainingTtlInSec()
                                };
                                this.baseEndpointUrl = f, this.listener.onTrouterConnected(g.url, S);
                            }
                        }, t.prototype.dispatchDisconnected = function() {
                            this.listener.onTrouterDisconnected && this.listener.onTrouterDisconnected();
                        }, t.prototype.dispatchTerminalError = function() {
                            this.listener.onTrouterDisconnected && this.listener.onTrouterDisconnected();
                        }, t.prototype.dispatchRegistrationState = function(g) {
                            this.options.registrationStateCallback && this.options.registrationStateCallback(g);
                        }, t.prototype.expediteBackoffOnConnections = function() {
                            var g;
                            void 0 !== this.lastExpediteBackoffCallAt && Date.now() - this.lastExpediteBackoffCallAt < (null !== (g = this.options.expediteBackoffOnStartMinimumDelayMs) && void 0 !== g ? g : 1e4) ? this.logger.info("Expedite backoff due to start() too frequent, skipping") : (this.lastExpediteBackoffCallAt = Date.now(), void 0 !== this.firstConnection && this.firstConnection.expediteBackoff(), void 0 !== this.secondConnection && this.secondConnection.expediteBackoff());
                        }, t.prototype.onDownstreamRequest = function(g, f, S) {
                            var v = {
                                id: f.id,
                                method: f.method,
                                path: "/".concat(f.shortUrl),
                                body: f.body,
                                headers: f.headers
                            }, _ = {
                                id: f.id,
                                status: 0,
                                headers: {},
                                body: "",
                                send: function() {
                                    return _.status <= 100 || _.status >= 999 ? 3 : (S.writeHead(_.status, _.headers), S.end(_.body));
                                }
                            };
                            this.listener.onTrouterRequest(v, _);
                        }, t.prototype.onConnected = function(g) {
                            this.fsm.onConnected(g === this.firstConnection);
                        }, t.prototype.onRegistered = function(g) {
                            this.fsm.onRegistered(g === this.firstConnection);
                        }, t.prototype.onUnregistered = function(g) {
                            this.fsm.onUnregistered(g === this.firstConnection || g === this.storedFirstConnection);
                        }, t.prototype.onReconnecting = function(g) {
                            this.fsm.onReconnecting(g === this.firstConnection);
                        }, t.prototype.onReconnectIsRequired = function(g, f, S) {
                            this.fsm.onReconnectionRequired(g === this.firstConnection, f, S);
                        }, t.prototype.onDisconnected = function(g) {
                            this.fsm.onDisconnected(g === this.firstConnection || g == this.storedFirstConnection), this.storedFirstConnection = void 0;
                        }, t.prototype.onTerminalError = function() {
                            this.fsm.onTerminalError(), this.storedFirstConnection = void 0;
                        }, t.prototype.onUserActivityStateAccepted = function(g) {
                            this.listener.onTrouterUserActivityStateAccepted && this.listener.onTrouterUserActivityStateAccepted(g);
                        }, t.prototype.onAudiencesSetResolved = function(g, f) {
                            var S, v;
                            null === (v = (S = this.listener).onAudiencesSetResolved) || void 0 === v || v.call(S, g, f);
                        }, t.prototype.onConnectionParametersUpdated = function(g) {
                            this.setConnectionCache(g);
                        }, t.prototype.setUserActivityState = function(g, f) {
                            return this.userActivityObject = new M(g, C.CorrelationVector.extend(f)), void 0 !== this.secondConnection ? (this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON(), " on the second/new connection")), void this.secondConnection.setUserActivityState(this.userActivityObject)) : void 0 !== this.firstConnection ? (this.logger.info("Setting user activity ".concat(this.userActivityObject.toEventJSON(), " on the first/current connection")), void this.firstConnection.setUserActivityState(this.userActivityObject)) : void 0;
                        }, t.prototype.setAudienceSubscriptionsAsync = function(g, f, S) {
                            if (this.audienceSubscriptionState = new O(g, C.CorrelationVector.extend(S)), this.secondConnection) return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON(), " on second/new connection")), this.secondConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState, f);
                            if (this.firstConnection) return this.logger.info("Setting audience subscriptions ".concat(this.audienceSubscriptionState.toEventJSON(), " on first/current connection")), this.firstConnection.setAudienceSubscriptionsAsync(this.audienceSubscriptionState, f);
                            throw new Error("No connection found");
                        }, t.prototype.onTrouterMessageLost = function(g) {
                            var f = this;
                            if (this.listener.onTrouterMessageLoss) {
                                if (null == g ? void 0 : g.length) {
                                    var S = g.filter(function(g) {
                                        return void 0 !== f.processedMessageLoss["".concat(g.tag, "-").concat(g.etag)];
                                    });
                                    if (S.length && (this.logger.info("onTrouterMessageLoss - immediately acknowledging ".concat(S.length, " seen dropped indicators")), this.sendProcessedDroppedIndicators(S), !(g = g.filter(function(g) {
                                        return void 0 === f.processedMessageLoss["".concat(g.tag, "-").concat(g.etag)];
                                    })).length)) return void this.logger.info("onTrouterMessageLoss - all declared dropped indicators have been seen before");
                                    if (!this.listener.onTrouterMessageLoss(g.map(function(g) {
                                        return g.tag;
                                    }))) return void this.logger.warn("onTrouterMessageLoss - some flow tag(s) have not been processed by listeners");
                                    g.forEach(function(g) {
                                        f.processedMessageLoss["".concat(g.tag, "-").concat(g.etag)] = "";
                                    }), this.sendProcessedDroppedIndicators(g);
                                } else this.logger.warn("onTrouterMessageLoss - no flow tags have been provided");
                            }
                        }, t.prototype.getConnectionCache = function() {
                            var g = this;
                            return this.options.connectionCache ? (this.logger.debug("Querying host's connection cache"), this.options.connectionCache.onGetTrouterConnectionCache().then(function(g) {
                                var f = g ? JSON.parse(g) : void 0;
                                return "object" == typeof f ? f : void 0;
                            }).catch(function(f) {
                                return g.logger.warn("Invalid connection cache content provided: ".concat(f)), g.connectionCache;
                            })) : Promise.resolve(this.connectionCache);
                        }, t.prototype.setConnectionCache = function(g) {
                            if (this.connectionCache = g, this.options.connectionCache) try {
                                this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(g));
                            } catch (g) {
                                this.logger.warn("Error setting external connection cache: ".concat(g));
                            }
                        }, t.prototype.sendProcessedDroppedIndicators = function(g) {
                            return void 0 !== this.firstConnection ? void this.firstConnection.sendProcessedDroppedIndicators(g) : void 0 !== this.secondConnection ? void this.secondConnection.sendProcessedDroppedIndicators(g) : void 0;
                        }, t.prototype.configuredTrouterManager = function() {
                            return new A.RegistrationEnforcer(this, this.options.connectionDependsOnRegistration, this.options.delayEventsUntilRegistered);
                        }, t;
                    }();
                    f.TrouterManager = D;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterUrlPromise = void 0;
                    var v = S(0), _ = function() {
                        function t(g) {
                            this.logger = new v.Logger("UrlPromise", g);
                        }
                        return t.prototype.getPromise = function() {
                            var g = this;
                            return void 0 !== this.url ? (this.logger.debug("returning previously resolved url: ".concat(this.url)), Promise.resolve(this.url)) : (void 0 === this.pendingPromise ? (this.logger.debug("creating and returning promise"), this.pendingPromise = new Promise(function(f, S) {
                                g.pendingPromiseResolveRef = f, g.pendingPromiseRejectRef = S;
                            })) : this.logger.debug("returning existing promise"), this.pendingPromise);
                        }, t.prototype.resolveUrl = function(g) {
                            this.url = g, this.logger.debug("got url: ".concat(this.url));
                            var f = this.pendingPromiseResolveRef;
                            this.pendingPromise = void 0, this.pendingPromiseResolveRef = void 0, this.pendingPromiseRejectRef = void 0, void 0 !== f && (this.logger.debug("resolving promise"), f(g));
                        }, t.prototype.rejectUrl = function(g) {
                            this.logger.debug("aborting");
                            var f = this.pendingPromiseRejectRef;
                            this.url = void 0, this.pendingPromise = void 0, this.pendingPromiseResolveRef = void 0, this.pendingPromiseRejectRef = void 0, void 0 !== f && (this.logger.debug("rejecting promise"), f(g));
                        }, t.prototype.resetUrl = function() {
                            this.logger.debug("resetting url"), this.url = void 0;
                        }, t;
                    }();
                    f.TrouterUrlPromise = _;
                },
                function(g, f, S) {
                    (function(g, S) {
                        !function(g, f) {
                            var S = g;
                            S.version = "0.9.6", S.protocol = 1, S.transports = [], S.j = [], S.sockets = {}, S.connect = function(g, v) {
                                var _, C, E = S.util.parseUri(g);
                                f && f.location && (E.protocol = E.protocol || f.location.protocol.slice(0, -1), E.host = E.host || (f.document ? f.document.domain : f.location.hostname), E.port = E.port || f.location.port), _ = S.util.uniqueUri(E);
                                var T = {
                                    host: E.host,
                                    secure: "https" == E.protocol,
                                    port: E.port || ("https" == E.protocol ? 443 : 80),
                                    query: E.query || ""
                                };
                                return S.util.merge(T, v), !T["force new connection"] && S.sockets[_] || (C = new S.Socket(T)), !T["force new connection"] && C && (S.sockets[_] = C), C = C || S.sockets[_], T["skipped handshake data"] ? C.of("") : C.of(E.path.length > 1 ? E.path : "");
                            };
                        }(S.exports, void 0 === g ? window : g);
                        var v = S.exports;
                        !function(g, f) {
                            var S = g.util = {}, v = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, _ = [
                                "source",
                                "protocol",
                                "authority",
                                "userInfo",
                                "user",
                                "password",
                                "host",
                                "port",
                                "relative",
                                "path",
                                "directory",
                                "file",
                                "query",
                                "anchor"
                            ];
                            S.parseUri = function(g) {
                                for(var f = v.exec(g || ""), S = {}, C = 14; C--;)S[_[C]] = f[C] || "";
                                return S;
                            }, S.uniqueUri = function(g) {
                                var S = g.protocol, v = g.host, _ = g.port;
                                return "document" in f ? (v = v || document.domain, _ = _ || ("https" == S && "https:" !== document.location.protocol ? 443 : document.location.port)) : (v = v || "localhost", _ || "https" != S || (_ = 443)), (S || "http") + "://" + v + ":" + (_ || 80);
                            }, S.query = function(g, f) {
                                var v = S.chunkQuery(g || ""), _ = [];
                                for(var C in S.merge(v, S.chunkQuery(f || "")), v)v.hasOwnProperty(C) && _.push(C + "=" + v[C]);
                                return _.length ? "?" + _.join("&") : "";
                            }, S.chunkQuery = function(g) {
                                for(var f, S = {}, v = g.split("&"), _ = 0, C = v.length; _ < C; ++_)(f = v[_].split("="))[0] && (S[f[0]] = f[1]);
                                return S;
                            };
                            var C = !1;
                            S.load = function(g) {
                                if ("document" in f && "complete" === document.readyState || C) return g();
                                S.on(f, "load", g, !1);
                            }, S.on = function(g, f, S, v) {
                                g.attachEvent ? g.attachEvent("on" + f, S) : g.addEventListener && g.addEventListener(f, S, v);
                            }, S.request = function(g) {
                                if (g && "undefined" != typeof XDomainRequest) return new XDomainRequest;
                                if ("undefined" != typeof XMLHttpRequest && (!g || S.ua.hasCORS)) return new XMLHttpRequest;
                                if (!g) try {
                                    return new window[[
                                        "Active"
                                    ].concat("Object").join("X")]("Microsoft.XMLHTTP");
                                } catch (g) {}
                                return null;
                            }, "undefined" != typeof window && S.load(function() {
                                C = !0;
                            }), S.defer = function(g) {
                                if (!S.ua.webkit || "undefined" != typeof importScripts) return g();
                                S.load(function() {
                                    setTimeout(g, 100);
                                });
                            }, S.merge = function(g, f, v, _) {
                                var C, E = _ || [], T = void 0 === v ? 2 : v;
                                for(C in f)f.hasOwnProperty(C) && S.indexOf(E, C) < 0 && ("object" == typeof g[C] && T ? S.merge(g[C], f[C], T - 1, E) : (g[C] = f[C], E.push(f[C])));
                                return g;
                            }, S.mixin = function(g, f) {
                                S.merge(g.prototype, f.prototype);
                            }, S.inherit = function(g, f) {
                                function n() {}
                                n.prototype = f.prototype, g.prototype = new n;
                            }, S.isArray = Array.isArray || function(g) {
                                return "[object Array]" === Object.prototype.toString.call(g);
                            }, S.intersect = function(g, f) {
                                for(var v = [], _ = g.length > f.length ? g : f, C = g.length > f.length ? f : g, E = 0, T = C.length; E < T; E++)~S.indexOf(_, C[E]) && v.push(C[E]);
                                return v;
                            }, S.indexOf = function(g, f, S) {
                                var v = g.length;
                                for(S = S < 0 ? S + v < 0 ? 0 : S + v : S || 0; S < v && g[S] !== f; S++);
                                return v <= S ? -1 : S;
                            }, S.toArray = function(g) {
                                for(var f = [], S = 0, v = g.length; S < v; S++)f.push(g[S]);
                                return f;
                            }, S.ua = {}, S.ua.hasCORS = "undefined" != typeof XMLHttpRequest && function() {
                                try {
                                    var g = new XMLHttpRequest;
                                } catch (g) {
                                    return !1;
                                }
                                return null != g.withCredentials;
                            }(), S.ua.webkit = "undefined" != typeof navigator && /webkit/i.test(navigator.userAgent);
                        }(void 0 !== v ? v : S.exports, void 0 === g ? window : g), function(g, f) {
                            function n() {}
                            g.EventEmitter = n, n.prototype.on = function(g, S) {
                                return this.$events || (this.$events = {}), this.$events[g] ? f.util.isArray(this.$events[g]) ? this.$events[g].push(S) : this.$events[g] = [
                                    this.$events[g],
                                    S
                                ] : this.$events[g] = S, this;
                            }, n.prototype.addListener = n.prototype.on, n.prototype.once = function(g, f) {
                                function n() {
                                    S.removeListener(g, n), f.apply(this, arguments);
                                }
                                var S = this;
                                return n.listener = f, this.on(g, n), this;
                            }, n.prototype.removeListener = function(g, S) {
                                if (this.$events && this.$events[g]) {
                                    var v = this.$events[g];
                                    if (f.util.isArray(v)) {
                                        for(var _ = -1, C = 0, E = v.length; C < E; C++)if (v[C] === S || v[C].listener && v[C].listener === S) {
                                            _ = C;
                                            break;
                                        }
                                        if (_ < 0) return this;
                                        v.splice(_, 1), v.length || delete this.$events[g];
                                    } else (v === S || v.listener && v.listener === S) && delete this.$events[g];
                                }
                                return this;
                            }, n.prototype.removeAllListeners = function(g) {
                                return this.$events && this.$events[g] && (this.$events[g] = null), this;
                            }, n.prototype.listeners = function(g) {
                                return this.$events || (this.$events = {}), this.$events[g] || (this.$events[g] = []), f.util.isArray(this.$events[g]) || (this.$events[g] = [
                                    this.$events[g]
                                ]), this.$events[g];
                            }, n.prototype.emit = function(g) {
                                if (!this.$events) return !1;
                                var S = this.$events[g];
                                if (!S) return !1;
                                var v = Array.prototype.slice.call(arguments, 1);
                                if ("function" == typeof S) S.apply(this, v);
                                else {
                                    if (!f.util.isArray(S)) return !1;
                                    for(var _ = S.slice(), C = 0, E = _.length; C < E; C++)_[C].apply(this, v);
                                }
                                return !0;
                            };
                        }(void 0 !== v ? v : S.exports, void 0 !== v ? v : S.parent.exports), function(g, f) {
                            if (f && f.parse) return g.JSON = {
                                parse: f.parse,
                                stringify: f.stringify
                            };
                            throw new Error("JSON not available");
                        }(void 0 !== v ? v : S.exports, "undefined" != typeof JSON ? JSON : void 0), function(g, f) {
                            var S = g.parser = {}, v = S.packets = [
                                "disconnect",
                                "connect",
                                "heartbeat",
                                "message",
                                "json",
                                "event",
                                "ack",
                                "error",
                                "noop"
                            ], _ = S.reasons = [
                                "transport not supported",
                                "client not handshaken",
                                "unauthorized"
                            ], C = S.advice = [
                                "reconnect"
                            ], E = f.JSON, T = f.util.indexOf;
                            S.encodePacket = function(g) {
                                var f = T(v, g.type), S = g.id || "", I = g.endpoint || "", b = g.ack, A = null;
                                switch(g.type){
                                    case "error":
                                        var R = g.reason ? T(_, g.reason) : "", P = g.advice ? T(C, g.advice) : "";
                                        "" === R && "" === P || (A = R + ("" !== P ? "+" + P : ""));
                                        break;
                                    case "message":
                                        "" !== g.data && (A = g.data);
                                        break;
                                    case "event":
                                        var w = {
                                            name: g.name
                                        };
                                        g.args && g.args.length && (w.args = g.args), A = E.stringify(w);
                                        break;
                                    case "json":
                                        A = E.stringify(g.data);
                                        break;
                                    case "connect":
                                        g.qs && (A = g.qs);
                                        break;
                                    case "ack":
                                        A = g.ackId + (g.args && g.args.length ? "+" + E.stringify(g.args) : "");
                                }
                                var M = [
                                    f,
                                    S + ("data" == b ? "+" : ""),
                                    I
                                ];
                                return null != A && M.push(A), M.join(":");
                            }, S.encodePayload = function(g) {
                                var f = "";
                                if (1 == g.length) return g[0];
                                for(var S = 0, v = g.length; S < v; S++)f += "\uFFFD" + g[S].length + "\uFFFD" + g[S];
                                return f;
                            };
                            var I = /([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;
                            S.decodePacket = function(g) {
                                if (!(T = g.match(I))) return {};
                                var f = T[2] || "", S = (g = T[5] || "", {
                                    type: v[T[1]],
                                    endpoint: T[4] || ""
                                });
                                switch(f && (S.id = f, T[3] ? S.ack = "data" : S.ack = !0), S.type){
                                    case "error":
                                        var T = g.split("+");
                                        S.reason = _[T[0]] || "", S.advice = C[T[1]] || "";
                                        break;
                                    case "message":
                                        S.data = g || "";
                                        break;
                                    case "event":
                                        try {
                                            var b = E.parse(g);
                                            S.name = b.name, S.args = b.args;
                                        } catch (g) {}
                                        S.args = S.args || [];
                                        break;
                                    case "json":
                                        try {
                                            S.data = E.parse(g);
                                        } catch (g) {}
                                        break;
                                    case "connect":
                                        S.qs = g || "";
                                        break;
                                    case "ack":
                                        if ((T = g.match(/^([0-9]+)(\+)?(.*)/)) && (S.ackId = T[1], S.args = [], T[3])) try {
                                            S.args = T[3] ? E.parse(T[3]) : [];
                                        } catch (g) {}
                                        break;
                                    case "disconnect":
                                        S.reason = g;
                                }
                                return S;
                            }, S.decodePayload = function(g) {
                                if ("\uFFFD" == g.charAt(0)) {
                                    for(var f = [], v = 1, _ = ""; v < g.length; v++)"\uFFFD" == g.charAt(v) ? (f.push(S.decodePacket(g.substr(v + 1).substr(0, _))), v += Number(_) + 1, _ = "") : _ += g.charAt(v);
                                    return f;
                                }
                                return [
                                    S.decodePacket(g)
                                ];
                            };
                        }(void 0 !== v ? v : S.exports, void 0 !== v ? v : S.parent.exports), function(g, f) {
                            function n(g, f) {
                                this.socket = g, this.sessid = f, this.connectErrorCallback = void 0, this.isOpened = !1;
                            }
                            g.Transport = n, f.util.mixin(n, f.EventEmitter), n.prototype.onData = function(g) {
                                if (this.clearCloseTimeout(), (this.socket.connected || this.socket.connecting || this.socket.reconnecting) && this.setCloseTimeout(), "" !== g) {
                                    var S = f.parser.decodePayload(g);
                                    if (S && S.length) for(var v = 0, _ = S.length; v < _; v++)this.onPacket(S[v]);
                                }
                                return this;
                            }, n.prototype.onPacket = function(g) {
                                return this.socket.setHeartbeatTimeout(), "heartbeat" == g.type ? this.onHeartbeat() : ("connect" == g.type && "" == g.endpoint && this.onConnect(), "error" == g.type && "reconnect" == g.advice && (this.isOpened = !1), this.socket.onPacket(g), this);
                            }, n.prototype.setCloseTimeout = function() {
                                if (!this.closeTimeout) {
                                    var g = this;
                                    this.closeTimeout = setTimeout(function() {
                                        g.onDisconnect();
                                    }, this.socket.closeTimeout);
                                }
                            }, n.prototype.onDisconnect = function() {
                                return this.close && this.isOpened && this.close(), this.clearTimeouts(), this.socket.onDisconnect(), this;
                            }, n.prototype.onConnect = function() {
                                return this.socket.onConnect(), this.connectErrorCallback = void 0, this;
                            }, n.prototype.clearCloseTimeout = function() {
                                this.closeTimeout && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
                            }, n.prototype.clearTimeouts = function() {
                                this.clearCloseTimeout(), this.reopenTimeout && clearTimeout(this.reopenTimeout);
                            }, n.prototype.packet = function(g) {
                                this.send(f.parser.encodePacket(g));
                            }, n.prototype.onHeartbeat = function(g) {
                                this.packet({
                                    type: "heartbeat"
                                });
                            }, n.prototype.onOpen = function() {
                                this.isOpened = !0, this.clearCloseTimeout(), this.socket.onOpen();
                            }, n.prototype.onClose = function() {
                                this.isOpened = !1, this.socket.onClose(), this.onDisconnect();
                            }, n.prototype.prepareUrl = function(g) {
                                var S = this.socket.options;
                                if (S["skipped handshake data"]) return S.rewriteUrlForProxy(S["skipped handshake data"].websocketUrl + (g || ""));
                                var v = this.scheme() + "://" + S.host + ":" + S.port + "/" + S.resource + "/" + f.protocol + "/" + this.name + "/" + this.sessid + (g || "");
                                return S.rewriteUrlForProxy(v);
                            }, n.prototype.ready = function(g, f) {
                                f.call(this);
                            }, n.prototype.clearEventHandlers = function() {
                                return this;
                            };
                        }(void 0 !== v ? v : S.exports, void 0 !== v ? v : S.parent.exports), function(g, f, S) {
                            function o(g) {
                                if (this.options = {
                                    port: 80,
                                    secure: !1,
                                    document: "document" in S && document,
                                    resource: "socket.io",
                                    transports: f.transports.slice(),
                                    "connect timeout": 1e4,
                                    "try multiple transports": !0,
                                    reconnect: !0,
                                    "reconnection delay": 500,
                                    "reconnection limit": 1 / 0,
                                    "reopen delay": 3e3,
                                    "max reconnection attempts": 10,
                                    "sync disconnect on unload": !0,
                                    "auto connect": !0,
                                    "flash policy port": 10843
                                }, f.util.merge(this.options, g), this.connected = !1, this.open = !1, this.connecting = !1, this.reconnecting = !1, this.namespaces = {}, this.buffer = [], this.doBuffer = !1, this.disconnected = !1, this.options["sync disconnect on unload"] && (!this.isXDomain() || f.util.ua.hasCORS)) {
                                    var v = this;
                                    f.util.on(S, "unload", function() {
                                        v.disconnectSync();
                                    }, !1);
                                }
                                this.options["auto connect"] && this.connect();
                            }
                            function i() {}
                            g.Socket = o, f.util.mixin(o, f.EventEmitter), o.prototype.of = function(g) {
                                return this.namespaces[g] || (this.namespaces[g] = new f.SocketNamespace(this, g), "" !== g && this.namespaces[g].packet({
                                    type: "connect"
                                })), this.namespaces[g];
                            }, o.prototype.publish = function() {
                                var g;
                                for(var f in this.emit.apply(this, arguments), this.namespaces)this.namespaces.hasOwnProperty(f) && (g = this.of(f)).$emit.apply(g, arguments);
                            }, o.prototype.handshake = function(g) {
                                function n(f) {
                                    f instanceof Error ? S.onError(f.message) : g.apply(null, f.split(":"));
                                }
                                var S = this, v = this.options;
                                if (!S.disconnected) {
                                    var _ = v.rewriteUrlForProxy([
                                        "http" + (v.secure ? "s" : "") + ":/",
                                        v.host + ":" + v.port,
                                        v.resource,
                                        f.protocol,
                                        f.util.query(this.options.query, "t=" + +new Date)
                                    ].join("/"));
                                    if (this.isXDomain() && !f.util.ua.hasCORS) {
                                        var C = document.getElementsByTagName("script")[0], E = document.createElement("script");
                                        E.src = _ + "&jsonp=" + f.j.length, C.parentNode.insertBefore(E, C), f.j.push(function(g) {
                                            n(g), E.parentNode.removeChild(E);
                                        });
                                    } else {
                                        var T = f.util.request();
                                        T.open("GET", _, !0);
                                        var I = this.options.requestHeaders;
                                        void 0 !== I && Object.keys(I).forEach(function(g) {
                                            T.setRequestHeader(g, I[g]);
                                        }), T.onreadystatechange = function() {
                                            4 == T.readyState && (T.onreadystatechange = i, 200 == T.status ? n(T.responseText) : !S.reconnecting && S.onError(T.responseText));
                                        }, T.send(null);
                                    }
                                }
                            }, o.prototype.getTransport = function(g) {
                                for(var S, v = g || this.transports, _ = 0; S = v[_]; _++)if (f.Transport[S] && f.Transport[S].check(this) && (!this.isXDomain() || f.Transport[S].xdomainCheck())) return new f.Transport[S](this, this.sessionid);
                                return null;
                            }, o.prototype.connect = function(g) {
                                if (this.connecting || this.disconnected) return this;
                                var S = this, o = function(v, _, C, E) {
                                    function c() {
                                        if (!S.connected && !S.disconnected) {
                                            if (S.connecting = !1, clearTimeout(S.connectTimeoutTimer), S.options["try multiple transports"]) {
                                                for(; S.remainingTransports.length > 0 && S.remainingTransports.splice(0, 1)[0] != S.transport.name;);
                                                S.remainingTransports.length ? a(S.remainingTransports) : S.publish("connect_failed");
                                            } else S.publish("connect_failed");
                                        }
                                    }
                                    function a(g) {
                                        if (S.transport && (S.transport.clearTimeouts(), S.transport.clearEventHandlers()), S.transport = S.getTransport(g), !S.transport || S.disconnected) return S.publish("connect_failed");
                                        S.transport.ready(S, function() {
                                            S.connecting = !0, S.publish("connecting", S.transport.name), S.transport.open(c), S.options["connect timeout"] && (S.connectTimeoutTimer = setTimeout(function() {
                                                c();
                                            }, S.options["connect timeout"]));
                                        });
                                    }
                                    S.sessionid = v, S.closeTimeout = 1e3 * C + 2e3, S.heartbeatTimeout = 1e3 * _ + 2e3, S.transports = E ? f.util.intersect(E.split(","), S.options.transports) : S.options.transports, S.setHeartbeatTimeout(), S.remainingTransports = S.transports.slice(0), a(S.transports), S.once("connect", function() {
                                        clearTimeout(S.connectTimeoutTimer), g && "function" == typeof g && g();
                                    });
                                };
                                if (this.options["skipped handshake data"]) {
                                    var v = this.options["skipped handshake data"];
                                    o("v4c-" + (new Date).getTime(), v.timeout, v.timeout, "websocket");
                                } else this.handshake(o);
                                return this;
                            }, o.prototype.setHeartbeatTimeout = function() {
                                clearTimeout(this.heartbeatTimeoutTimer);
                                var g = this;
                                this.heartbeatTimeoutTimer = setTimeout(function() {
                                    g.transport.onClose();
                                }, this.heartbeatTimeout);
                            }, o.prototype.packet = function(g) {
                                return this.connected && !this.doBuffer ? this.transport.packet(g) : this.buffer.push(g), this;
                            }, o.prototype.setBuffer = function(g) {
                                this.doBuffer = g, !g && this.connected && this.buffer.length && (this.transport.payload(this.buffer), this.buffer = []);
                            }, o.prototype.disconnect = function() {
                                return (this.connected || this.connecting) && (this.open && this.of("").packet({
                                    type: "disconnect"
                                }), this.onDisconnect("booted")), this.disconnected = !0, this;
                            }, o.prototype.disconnectSync = function() {
                                var g = f.util.request(), S = this.resource + "/" + f.protocol + "/" + this.sessionid;
                                g.open("GET", S, !0), this.onDisconnect("booted");
                            }, o.prototype.isXDomain = function() {
                                var g = S.location.port || ("https:" == S.location.protocol ? 443 : 80);
                                return this.options.host !== S.location.hostname || this.options.port != g;
                            }, o.prototype.onConnect = function() {
                                this.connected || (this.connected = !0, this.connecting = !1, this.doBuffer || this.setBuffer(!1), this.emit("connect"));
                            }, o.prototype.onOpen = function() {
                                this.open = !0;
                            }, o.prototype.onClose = function() {
                                this.open = !1, clearTimeout(this.heartbeatTimeoutTimer);
                            }, o.prototype.onPacket = function(g) {
                                this.of(g.endpoint).onPacket(g);
                            }, o.prototype.onError = function(g) {
                                g && g.advice && "reconnect" === g.advice && (this.connected || this.connecting) && (this.disconnect(), this.options.reconnect && this.reconnect()), this.publish("error", g && g.reason ? g.reason : g);
                            }, o.prototype.onDisconnect = function(g) {
                                var f = this.connected, S = this.connecting;
                                this.connected = !1, this.connecting = !1, this.open = !1, (f || S) && (this.transport.close(), this.transport.clearTimeouts(), f ? (this.publish("disconnect", g), "booted" != g && this.options.reconnect && !this.reconnecting && this.reconnect()) : this.publish("close_during_connecting", g));
                            }, o.prototype.reconnect = function() {
                                function t() {
                                    if (g.connected) {
                                        for(var f in g.namespaces)g.namespaces.hasOwnProperty(f) && "" !== f && g.namespaces[f].packet({
                                            type: "connect"
                                        });
                                        g.publish("reconnect", g.transport.name, g.reconnectionAttempts);
                                    }
                                    clearTimeout(g.reconnectionTimer), g.removeListener("connect_failed", e), g.removeListener("connect", e), g.reconnecting = !1, delete g.reconnectionAttempts, delete g.reconnectionDelay, delete g.reconnectionTimer, delete g.redoTransports, g.options["try multiple transports"] = S;
                                }
                                function e() {
                                    if (g.reconnecting) return g.connected ? t() : g.connecting && g.reconnecting ? g.reconnectionTimer = setTimeout(e, 1e3) : void (g.reconnectionAttempts++ >= f ? g.redoTransports ? (g.publish("reconnect_failed"), t()) : (g.on("connect_failed", e), g.options["try multiple transports"] = !0, g.transport = g.getTransport(), g.redoTransports = !0, g.connect()) : (g.reconnectionDelay < v && (g.reconnectionDelay *= 2), g.connect(), g.publish("reconnecting", g.reconnectionDelay, g.reconnectionAttempts), g.reconnectionTimer = setTimeout(e, g.reconnectionDelay)));
                                }
                                this.reconnecting = !0, this.reconnectionAttempts = 0, this.reconnectionDelay = this.options["reconnection delay"];
                                var g = this, f = this.options["max reconnection attempts"], S = this.options["try multiple transports"], v = this.options["reconnection limit"];
                                this.options["try multiple transports"] = !1, this.reconnectionTimer = setTimeout(e, this.reconnectionDelay), this.on("connect", e);
                            };
                        }(void 0 !== v ? v : S.exports, void 0 !== v ? v : S.parent.exports, void 0 === g ? window : g), function(g, f) {
                            function n(g, f) {
                                this.socket = g, this.name = f || "", this.flags = {}, this.json = new o(this, "json"), this.ackPackets = 0, this.acks = {};
                            }
                            function o(g, f) {
                                this.namespace = g, this.name = f;
                            }
                            g.SocketNamespace = n, f.util.mixin(n, f.EventEmitter), n.prototype.$emit = f.EventEmitter.prototype.emit, n.prototype.of = function() {
                                return this.socket.of.apply(this.socket, arguments);
                            }, n.prototype.packet = function(g) {
                                return g.endpoint = this.name, this.socket.packet(g), this.flags = {}, this;
                            }, n.prototype.send = function(g, f) {
                                var S = {
                                    type: this.flags.json ? "json" : "message",
                                    data: g
                                };
                                return "function" == typeof f && (S.id = ++this.ackPackets, S.ack = !0, this.acks[S.id] = f), this.packet(S);
                            }, n.prototype.emit = function(g) {
                                var f = Array.prototype.slice.call(arguments, 1), S = f[f.length - 1], v = {
                                    type: "event",
                                    name: g
                                };
                                return "function" == typeof S && (v.id = ++this.ackPackets, v.ack = "data", this.acks[v.id] = S, f = f.slice(0, f.length - 1)), v.args = f, this.packet(v);
                            }, n.prototype.disconnect = function() {
                                return "" === this.name ? this.socket.disconnect() : (this.packet({
                                    type: "disconnect"
                                }), this.$emit("disconnect")), this;
                            }, n.prototype.onPacket = function(g) {
                                function n() {
                                    S.packet({
                                        type: "ack",
                                        args: f.util.toArray(arguments),
                                        ackId: g.id
                                    });
                                }
                                var S = this;
                                switch(g.type){
                                    case "connect":
                                        this.$emit("connect");
                                        break;
                                    case "disconnect":
                                        "" === this.name ? this.socket.onDisconnect(g.reason || "booted") : this.$emit("disconnect", g.reason || "");
                                        break;
                                    case "message":
                                    case "json":
                                        var v = [
                                            "message",
                                            g.data
                                        ];
                                        "data" == g.ack ? v.push(n) : g.ack && this.packet({
                                            type: "ack",
                                            ackId: g.id
                                        }), this.$emit.apply(this, v);
                                        break;
                                    case "event":
                                        v = [
                                            g.name
                                        ].concat(g.args), "data" == g.ack && v.push(n), this.$emit.apply(this, v);
                                        break;
                                    case "ack":
                                        this.acks[g.ackId] && (this.acks[g.ackId].apply(this, g.args), delete this.acks[g.ackId]);
                                        break;
                                    case "error":
                                        g.advice ? this.socket.onError(g) : "unauthorized" == g.reason ? this.$emit("connect_failed", g.reason) : this.$emit("error", g.reason);
                                }
                            }, o.prototype.send = function() {
                                this.namespace.flags[this.name] = !0, this.namespace.send.apply(this.namespace, arguments);
                            }, o.prototype.emit = function() {
                                this.namespace.flags[this.name] = !0, this.namespace.emit.apply(this.namespace, arguments);
                            };
                        }(void 0 !== v ? v : S.exports, void 0 !== v ? v : S.parent.exports), function(g, f, S) {
                            function o(g) {
                                f.Transport.apply(this, arguments);
                            }
                            function i() {}
                            g.websocket = o, f.util.inherit(o, f.Transport), o.prototype.name = "websocket", o.prototype.open = function(g) {
                                var v, _ = f.util.query(this.socket.options.query), C = this;
                                return this.connectErrorCallback = g, v || (v = S.MozWebSocket || S.WebSocket), this.websocket = new v(this.prepareUrl(_)), this.websocket.onopen = function() {
                                    C.onOpen(), C.socket.setBuffer(!1);
                                }, this.websocket.onmessage = function(g) {
                                    C.onData(g.data);
                                }, this.websocket.onclose = function() {
                                    C.onClose(), C.socket.setBuffer(!0);
                                }, this.websocket.onerror = function(g) {
                                    C.onError(g);
                                }, this;
                            }, o.prototype.send = function(g) {
                                return this.websocket.send(g), this;
                            }, o.prototype.payload = function(g) {
                                for(var f = 0, S = g.length; f < S; f++)this.packet(g[f]);
                                return this;
                            }, o.prototype.close = function() {
                                return this.websocket.close(), this;
                            }, o.prototype.onError = function(g) {
                                void 0 !== this.connectErrorCallback && (this.connectErrorCallback(), this.connectErrorCallback = void 0), this.socket.onError(g);
                            }, o.prototype.scheme = function() {
                                return this.socket.options.secure ? "wss" : "ws";
                            }, o.check = function() {
                                return "WebSocket" in S && !("__addTask" in WebSocket) || "MozWebSocket" in S;
                            }, o.xdomainCheck = function() {
                                return !0;
                            }, o.prototype.clearEventHandlers = function() {
                                return this.websocket && (this.websocket.onopen = this.websocket.onmessage = this.websocket.onclose = this.websocket.onerror = i), this;
                            }, f.transports.push("websocket");
                        }(void 0 !== v ? v.Transport : S.exports, void 0 !== v ? v : S.parent.exports, void 0 === g ? window : g), function(g, f, S) {
                            function o(g) {
                                g && f.Transport.apply(this, arguments);
                            }
                            function i() {}
                            g.XHR = o, f.util.inherit(o, f.Transport), o.prototype.open = function() {
                                return this.socket.setBuffer(!1), this.onOpen(), this.get(), this.setCloseTimeout(), this;
                            }, o.prototype.payload = function(g) {
                                for(var S = [], v = 0, _ = g.length; v < _; v++)S.push(f.parser.encodePacket(g[v]));
                                this.send(f.parser.encodePayload(S));
                            }, o.prototype.send = function(g) {
                                return this.post(g), this;
                            }, o.prototype.post = function(g) {
                                function e() {
                                    4 == this.readyState && (this.onreadystatechange = i, 200 == this.status ? (clearTimeout(this.ackTimeoutTimer), f.socket.setBuffer(!1)) : f.onClose());
                                }
                                function o() {
                                    this.onload = i, f.socket.setBuffer(!1);
                                }
                                var f = this;
                                this.socket.setBuffer(!0), this.sendXHR = this.request("POST"), S.XDomainRequest && this.sendXHR instanceof XDomainRequest ? this.sendXHR.onload = this.sendXHR.onerror = o : this.sendXHR.onreadystatechange = e, this.sendXHR.send(g), f.sendXHR.ackTimeoutTimer = setTimeout(function() {
                                    f.onClose();
                                }, f.socket.options.ackTimeoutMs);
                            }, o.prototype.close = function() {
                                return this.onClose(), this;
                            }, o.prototype.request = function(g) {
                                var S = f.util.request(this.socket.isXDomain()), v = f.util.query(this.socket.options.query, "t=" + +new Date);
                                S.open(g || "GET", this.prepareUrl(v), !0);
                                var _ = this.socket.options.requestHeaders;
                                if (void 0 !== _ && Object.keys(_).forEach(function(g) {
                                    S.setRequestHeader(g, _[g]);
                                }), "POST" == g) try {
                                    S.setRequestHeader ? S.setRequestHeader("Content-type", "text/plain;charset=UTF-8") : S.contentType = "text/plain";
                                } catch (g) {}
                                return S;
                            }, o.prototype.scheme = function() {
                                return this.socket.options.secure ? "https" : "http";
                            }, o.check = function(g, v) {
                                try {
                                    var _ = f.util.request(v), C = S.XDomainRequest && _ instanceof XDomainRequest, E = (g && g.options && g.options.secure ? "https:" : "http:") != S.location.protocol;
                                    if (_ && (!C || !E)) return !0;
                                } catch (g) {}
                                return !1;
                            }, o.xdomainCheck = function() {
                                return o.check(null, !0);
                            }, o.prototype.clearEventHandlers = function() {
                                return this.sendXHR && (this.sendXHR.onreadystatechange = this.sendXHR.onload = i), this;
                            };
                        }(void 0 !== v ? v.Transport : S.exports, void 0 !== v ? v : S.parent.exports, void 0 === g ? window : g), function(g, f, S) {
                            function o() {
                                f.Transport.XHR.apply(this, arguments);
                            }
                            function i() {}
                            g["xhr-polling"] = o, f.util.inherit(o, f.Transport.XHR), f.util.merge(o, f.Transport.XHR), o.prototype.name = "xhr-polling", o.prototype.open = function(g) {
                                var S = this;
                                return S.connectErrorCallback = g, f.Transport.XHR.prototype.open.call(S), !1;
                            }, o.prototype.get = function() {
                                function t() {
                                    4 == this.readyState && (this.onreadystatechange = i, 200 == this.status ? (g.connectErrorCallback = void 0, g.onData(this.responseText), g.get()) : (g.onClose(), void 0 !== g.connectErrorCallback && (g.connectErrorCallback(), g.connectErrorCallback = void 0)));
                                }
                                function e() {
                                    g.connectErrorCallback = void 0, this.onload = i, this.onerror = i, g.onData(this.responseText), g.get();
                                }
                                function o() {
                                    g.onClose(), void 0 !== g.connectErrorCallback && (g.connectErrorCallback(), g.connectErrorCallback = void 0);
                                }
                                if (this.isOpened) {
                                    var g = this;
                                    this.xhr = this.request(), S.XDomainRequest && this.xhr instanceof XDomainRequest ? (this.xhr.onload = e, this.xhr.onerror = o) : this.xhr.onreadystatechange = t, this.xhr.send(null);
                                }
                            }, o.prototype.onClose = function() {
                                if (f.Transport.XHR.prototype.onClose.call(this), this.xhr) {
                                    this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = i;
                                    try {
                                        this.xhr.abort();
                                    } catch (g) {}
                                    this.xhr = null;
                                }
                            }, o.prototype.ready = function(g, S) {
                                var v = this;
                                f.util.defer(function() {
                                    S.call(v);
                                });
                            }, o.prototype.clearEventHandlers = function() {
                                return f.Transport.XHR.prototype.clearEventHandlers.call(this), this.xhr && (this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = i), this;
                            }, f.transports.push("xhr-polling");
                        }(void 0 !== v ? v.Transport : S.exports, void 0 !== v ? v : S.parent.exports, void 0 === g ? window : g), f.io = v;
                    }).call(f, S(13), S(14)(g));
                },
                function(g, f) {
                    var S;
                    S = function() {
                        return this;
                    }();
                    try {
                        S = S || Function("return this")() || (0, eval)("this");
                    } catch (g) {
                        "object" == typeof window && (S = window);
                    }
                    g.exports = S;
                },
                function(g, f) {
                    g.exports = function(g) {
                        return g.webpackPolyfill || (g.deprecate = function() {}, g.paths = [], g.children || (g.children = []), Object.defineProperty(g, "loaded", {
                            enumerable: !0,
                            get: function() {
                                return g.l;
                            }
                        }), Object.defineProperty(g, "id", {
                            enumerable: !0,
                            get: function() {
                                return g.i;
                            }
                        }), g.webpackPolyfill = 1), g;
                    };
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.ConnectionTracker = f.Properties = f.TrackerStep = f.ClientEventName = f.ResponseData = void 0;
                    var v, _ = S(3), C = S(1), E = S(0), T = function() {
                        function t(g) {
                            this.id = g, this.status = 200, this.headers = {}, this.body = "";
                        }
                        return t;
                    }();
                    f.ResponseData = T, function(g) {
                        g.Connected = "trouter_js_client_connected", g.Disconnected = "trouter_js_client_disconnected", g.Error = "trouter_js_client_error", g.Progress = "trouter_js_client_progress", g.Response = "trouter_js_client_response", g.Request = "trouter_js_client_request", g.CheckConnection = "trouter_js_client_check_connection", g.Registration = "trouter_js_client_registration", g.Unregistration = "trouter_js_client_unregistration";
                    }(v || (f.ClientEventName = v = {}));
                    var I = function() {
                        function t(g, f, S, v, _) {
                            this.stepName = g, this.operation = f, this.delta = S, this.ts = v, this.error = _;
                        }
                        return t;
                    }();
                    f.TrackerStep = I;
                    var b = function() {
                        function t() {}
                        return t;
                    }();
                    f.Properties = b;
                    var A = function() {
                        function t() {
                            this.numberOfPingReplies = 0, this.connectedTimestamp = 0, this.isNewUrl = !1, this.transportType = "", this.connectionNumber = 0;
                        }
                        return t;
                    }(), R = function() {
                        function t() {
                            this.enabled = !1, this.numberOfStepsToMaintain = 40, this.logHealthCheckError = !1, this.sendProgressTimeoutSecs = 55, this.logSendPingError = !1, this.maxBackoffInMs = 12e4, this.trouter_js_client_connected = !1, this.trouter_js_client_disconnected = !1, this.trouter_js_client_error = !1, this.trouter_js_client_progress = !1, this.trouter_js_client_response = !1, this.trouter_js_client_request = !1, this.trouter_js_client_registration = !1, this.trouter_js_client_unregistration = !1, this.trouter_js_client_check_connection = !0;
                        }
                        return t;
                    }(), P = function() {
                        function t(g, f, S, v, C, T, I) {
                            this.clientId = f, this.clientInfo = S, this.getServerState = v, this.endpointId = C, this.clientCorrelationID = T, this.environment = I, this.logger = new E.Logger("ConnectionTracker", g), this.clientCorrelationID = void 0 !== T ? T : "", this.steps = [], this.connectionAttempt = 0, this.totalStepCount = 0, this.beginTimestamp = new _.Timespan, this.eventLogSettings = new R, this.connectedInfo = new A;
                        }
                        return t.prototype.enable = function(g) {
                            this.eventLogSettings.enabled = !0, this.eventLogger = g;
                        }, t.prototype.disable = function() {
                            this.eventLogSettings.enabled = !1;
                        }, t.prototype.sendProgress = function(g) {
                            this.steps.length > 0 && this.sendTelemetry(v.Progress, g, this.steps);
                        }, t.prototype.cancelProgressTimer = function() {
                            void 0 !== this.progressTimeout && (clearTimeout(this.progressTimeout), this.progressTimeout = void 0);
                        }, t.prototype.resetProgressSendTimer = function() {
                            var g = this;
                            this.cancelProgressTimer(), void 0 !== this.eventLogSettings.sendProgressTimeoutSecs && this.eventLogSettings.sendProgressTimeoutSecs > 0 && (this.progressTimeout = setTimeout(function() {
                                g.sendProgress({
                                    reason: "timeout",
                                    timeoutSecs: g.eventLogSettings.sendProgressTimeoutSecs
                                });
                            }, 1e3 * this.eventLogSettings.sendProgressTimeoutSecs));
                        }, t.prototype.setConnectedInfo = function(g, f) {
                            this.connectedInfo.numberOfPingReplies = 0, this.connectedInfo.connectedTimestamp = Date.now(), this.connectedInfo.isNewUrl = g, this.connectedInfo.transportType = f, ++this.connectedInfo.connectionNumber;
                        }, t.prototype.clearConnectedInfo = function() {
                            this.connectedInfo.numberOfPingReplies = 0, this.connectedInfo.connectedTimestamp = 0, this.connectedInfo.isNewUrl = !0, this.connectedInfo.transportType = "";
                        }, t.prototype.copyProperties = function(g, f) {
                            for(var S = 0, v = Object.keys(f); S < v.length; S++){
                                var _ = v[S];
                                void 0 !== f[_] && (g[_.replace(/-/g, "_")] = {
                                    value: f[_]
                                });
                            }
                        }, t.prototype.increasePingResponseCount = function() {
                            ++this.connectedInfo.numberOfPingReplies;
                        }, t.prototype.sendTelemetry = function(g, f, S) {
                            try {
                                if (!0 === this.eventLogSettings.enabled && !0 === this.eventLogSettings[g] && void 0 !== this.eventLogger) {
                                    var v = this.getServerState(), E = {
                                        name: g,
                                        properties: {
                                            connectionAttempt: {
                                                value: this.connectionAttempt
                                            },
                                            epid: {
                                                value: this.endpointId
                                            },
                                            clientCorrelationID: {
                                                value: this.clientCorrelationID
                                            },
                                            steps: {
                                                value: (0, _.toJson)(S)
                                            },
                                            clientID: {
                                                value: this.clientId
                                            },
                                            eventVersion: {
                                                value: 3
                                            },
                                            environment: {
                                                value: this.environment
                                            },
                                            cv: {
                                                value: C.CLIENT_VERSION
                                            },
                                            ua: {
                                                value: this.clientInfo.ua
                                            },
                                            connectionId: {
                                                value: v.connectionId
                                            },
                                            connectedClientId: {
                                                value: v.connectedClientId
                                            },
                                            domId: {
                                                value: v.domId
                                            },
                                            url: {
                                                value: v.url
                                            },
                                            ttlInSecs: {
                                                value: v.getRemainingTtlInSec()
                                            },
                                            numberOfPingReplies: {
                                                value: this.connectedInfo.numberOfPingReplies
                                            },
                                            connectedTimestamp: {
                                                value: this.connectedInfo.connectedTimestamp
                                            },
                                            isNewUrl: {
                                                value: this.connectedInfo.isNewUrl
                                            },
                                            transportType: {
                                                value: this.connectedInfo.transportType
                                            },
                                            connectionNumber: {
                                                value: this.connectedInfo.connectionNumber
                                            }
                                        }
                                    };
                                    this.copyProperties(E.properties, f), this.eventLogger.logEvent(E);
                                }
                            } catch (f) {
                                this.logger.warn("error in sending event ".concat(g, ": ").concat((0, _.toJson)(f)));
                            }
                        }, t.prototype.createStep = function(g, f, S) {
                            return new I(g, f, this.beginTimestamp.duration, Date.now(), S);
                        }, t.prototype.addStep = function(g, f, S) {
                            if (!1 !== this.eventLogSettings.enabled && (0 === this.steps.length && this.beginTimestamp.reset(), this.steps.push(this.createStep(g, f, S)), ++this.totalStepCount, void 0 !== this.eventLogSettings.numberOfStepsToMaintain && this.steps.length > this.eventLogSettings.numberOfStepsToMaintain)) {
                                var _ = this.steps.slice(0);
                                this.steps.length = 0, this.sendTelemetry(v.Progress, {
                                    reason: "flush"
                                }, _);
                            }
                        }, t.prototype.trackStart = function(g) {
                            this.addStep(g, "start");
                        }, t.prototype.trackEnd = function(g) {
                            this.addStep(g, "end");
                        }, t.prototype.trackError = function(g, f, S, _) {
                            void 0 === S && (S = !0), "health" === g && !0 !== this.eventLogSettings.logHealthCheckError || "ping" === g && !1 === this.eventLogSettings.logSendPingError || (void 0 === _ && (_ = "error"), !0 === S && this.addStep(g, _, f), this.sendTelemetry(v.Error, {}, [
                                this.createStep(g, _, f)
                            ]));
                        }, t.prototype.trackProgress = function(g, f) {
                            this.addStep(g, f);
                        }, t.prototype.trackConnected = function(g, f) {
                            this.setConnectedInfo(g, f);
                            var S = this.steps.slice(0), _ = this.totalStepCount, C = this.beginTimestamp.duration;
                            this.steps.length = 0, this.totalStepCount = 0, this.sendTelemetry(v.Connected, {
                                stepCount: S.length,
                                totalStepCount: _,
                                connectionEstablishmentMs_Total: C
                            }, S), this.cancelProgressTimer();
                        }, t.prototype.getSessionLength = function() {
                            return Date.now() - this.connectedInfo.connectedTimestamp;
                        }, t.prototype.trackDisconnected = function(g) {
                            g.sessionLengthMS = this.getSessionLength(), this.sendTelemetry(v.Disconnected, g, []), this.resetProgressSendTimer();
                        }, t.prototype.trackNewConnection = function() {
                            ++this.connectionAttempt;
                        }, t.prototype.trackRequest = function(g, f) {
                            var S = {};
                            void 0 !== f && (S.hasError = !0, S.error = f);
                            try {
                                if (g) {
                                    S.requestID = g.id, S.httpMethod = g.method, S.url = g.url, S.bodyLength = g.body.length, S.shortUrl = g.shortUrl, S.requestTimeStamp = g.startTS, S.correlationVector = g.correlationVector;
                                    for(var C = g.headers, E = 0, T = Object.keys(C); E < T.length; E++){
                                        var I = T[E];
                                        S[I] = C[I];
                                    }
                                }
                            } catch (g) {
                                S.hasError = !0, S.error = "".concat(S.error, " error creating request context ").concat((0, _.toJson)(g));
                            }
                            this.sendTelemetry(v.Request, S, []);
                        }, t.prototype.trackResponse = function(g, f, S, C) {
                            var E = {};
                            void 0 !== C && (E.hasError = !0, E.error = C);
                            try {
                                if (E.responseTimestamp = void 0 !== S ? S.sentTS : Date.now(), g) {
                                    E.requestID = g.id, E.httpMethod = g.method, E.shortUrl = g.shortUrl, E.correlationVector = g.correlationVector;
                                    for(var T = g.headers, I = 0, b = Object.keys(T); I < b.length; I++){
                                        var A = b[I];
                                        E[A] = T[A];
                                    }
                                }
                                S && (E.latencyMS = f, E.responseCode = S.status, E.responseLength = S.body.length);
                            } catch (g) {
                                E.hasError = !0, E.error = "".concat(E.error, " error creating response context ").concat((0, _.toJson)(g));
                            }
                            this.sendTelemetry(v.Response, E, []);
                        }, t.prototype.sendResponseError = function(g, f, S) {
                            this.trackResponse(f, void 0, S, g);
                        }, t.prototype.close = function() {
                            this.sendProgress({
                                reason: "closed"
                            }), this.steps.length = 0, this.cancelProgressTimer();
                        }, t.prototype.mergeSettings = function(g) {
                            if (g) {
                                this.eventLogSettings.numberOfStepsToMaintain = Math.min(40, Math.max(10, void 0 !== g.numberOfStepsToMaintain ? g.numberOfStepsToMaintain : 0));
                                var f = Math.min(3600, Math.max(55, void 0 !== g.sendProgressTimeoutSecs ? g.sendProgressTimeoutSecs : 0));
                                this.eventLogSettings.logHealthCheckError = g.logHealthCheckError, this.eventLogSettings.logSendPingError = g.logSendPingError;
                                for(var S = 0, _ = Object.keys(v).map(function(g) {
                                    return v[g];
                                }); S < _.length; S++){
                                    var C = _[S];
                                    void 0 !== g[C] && (this.eventLogSettings[C] = g[C]);
                                }
                                this.eventLogSettings.sendProgressTimeoutSecs !== f && (this.eventLogSettings.sendProgressTimeoutSecs = f, this.resetProgressSendTimer());
                            }
                        }, t;
                    }();
                    f.ConnectionTracker = P;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.DisconnectReason = void 0;
                    var v = function() {
                        function t(g, f, S) {
                            this.reason = g, this.claims = f, this.details = S;
                        }
                        return t.fromRawReason = function(g, f) {
                            if ("" === g || "dup" === g) return new t(g);
                            try {
                                var S = JSON.parse(g);
                                return "object" != typeof S || void 0 === S.reason ? (null == f || f.error("invalid disconnect reason format"), new t("unknown", void 0, g)) : new t(S.reason, S.claims, S.details);
                            } catch (f) {
                                return new t("disconnect", void 0, g);
                            }
                        }, t.fromSocketIoEventData = function(g, f) {
                            return "string" == typeof f ? new t(g, void 0, f) : void 0;
                        }, t.prototype.toTelemetryString = function() {
                            return "socketerror" === this.reason || "reconnecterror" === this.reason || "disconnect" === this.reason ? this.details : this.reason;
                        }, t;
                    }();
                    f.DisconnectReason = v;
                },
                function(g, f, S) {
                    function o(g, f, S) {
                        if (void 0 === g || void 0 === f) return !1;
                        var v = Date.now() - g;
                        return v > f * S.tolerance && v > S.minimumWaitMs;
                    }
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.ExponentialBackoff = void 0;
                    var v = function() {
                        function t(g, f, S) {
                            void 0 === S && (S = {
                                tolerance: 2,
                                minimumWaitMs: 1e4
                            }), this.logger = g, this.maxBackoffInMs = f, this.gapDetectionSettings = S, this.backoffId = 0, this.backoffCount = 0;
                        }
                        return t.calculateNextBackoffMs = function(g, f) {
                            var S = 1 + .4 * (Math.random() - .5), v = 1e3 * Math.pow(2, g) * S;
                            return v = Math.round(v), Math.min(f, v);
                        }, t.prototype.setMaxBackoffMs = function(g) {
                            this.maxBackoffInMs = g;
                        }, t.prototype.backoff = function(g, f) {
                            var S = this;
                            if (void 0 !== this.timerHandle && (this.logger.debug("Clearing current back off"), clearTimeout(this.timerHandle), this.timerHandle = void 0), void 0 !== this.previousCompleteTime) {
                                var v = Date.now() - this.previousCompleteTime;
                                v > this.maxBackoffInMs * this.gapDetectionSettings.tolerance && v > this.gapDetectionSettings.minimumWaitMs && (this.logger.info("Back off for ".concat(g, " with ID ").concat(this.backoffId, " will be reset due to a lot of time having passed since the previous backoff (").concat(v, " ms)")), this.backoffCount = 0, this.previousCompleteTime = void 0);
                            }
                            var _ = t.calculateNextBackoffMs(this.backoffCount, this.maxBackoffInMs);
                            this.backoffId++, this.backoffCount++, this.logger.info("Backing off ".concat(g, " for ").concat(_, " milliseconds with ID ").concat(this.backoffId)), this.callback = function(v, _) {
                                o(v, _, S.gapDetectionSettings) && (S.logger.info("Back off for ".concat(g, " with ID ").concat(S.backoffId, " will be reset due to the wait (").concat(Date.now() - (null != v ? v : 0), " ms) being longer than expected (").concat(_, " ms)")), S.backoffCount = 0), S.logger.info("Back off for ".concat(g, " with ID ").concat(S.backoffId, " complete, invoking handler")), S.timerHandle = void 0, S.callback = void 0, S.previousCompleteTime = Date.now(), f();
                            };
                            var C = Date.now();
                            this.timerHandle = setTimeout(function() {
                                var g;
                                return null === (g = S.callback) || void 0 === g ? void 0 : g.call(S, C, _);
                            }, _);
                        }, t.prototype.reset = function() {
                            void 0 !== this.timerHandle && (this.logger.debug("Resetting back off with ID ".concat(this.backoffId)), clearTimeout(this.timerHandle), this.timerHandle = void 0, this.callback = void 0), this.backoffCount = 0;
                        }, t.prototype.expediteIfPending = function() {
                            if (this.backoffCount = 0, void 0 !== this.timerHandle) {
                                this.logger.debug("Expediting back off with ID ".concat(this.backoffId)), clearTimeout(this.timerHandle), this.timerHandle = void 0;
                                var g = this.callback;
                                this.callback = void 0, g && g();
                            }
                        }, t;
                    }();
                    f.ExponentialBackoff = v;
                },
                function(g, f, S) {
                    var v = this && this.__spreadArray || function(g, f, S) {
                        if (S || 2 === arguments.length) for(var v, _ = 0, C = f.length; _ < C; _++)!v && _ in f || (v || (v = Array.prototype.slice.call(f, 0, _)), v[_] = f[_]);
                        return g.concat(v || Array.prototype.slice.call(f));
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.LoggingManagerConsumer = f.RegistrationEnforcer = void 0;
                    var _ = S(6), C = function() {
                        function t(g, f, S) {
                            this.wrapped = g, this.shouldConnectionDependOnRegistration = f, this.shouldHoldBackEvents = S, this.isRegistered = !1, this.heldBackEvents = [];
                        }
                        return t.prototype.onDownstreamRequest = function(g, f, S) {
                            this.passIfRegisteredOrNotNeeded("onDownstreamRequest", g, f, S);
                        }, t.prototype.onConnected = function(g) {
                            this.passIfRegisteredOrNotNeeded("onConnected", g);
                        }, t.prototype.onRegistered = function(g) {
                            this.isRegistered = !0, this.wrapped.onRegistered(g), this.fireHeldBackEvents();
                        }, t.prototype.onUnregistered = function(g) {
                            var f = this.isRegistered;
                            this.isRegistered = !1, this.wrapped.onUnregistered(g), f && g.getState() === _.State.Connected && this.shouldConnectionDependOnRegistration() && g.forceReconnectDueToNoRegistration();
                        }, t.prototype.onReconnecting = function(g) {
                            this.wrapped.onReconnecting(g);
                        }, t.prototype.onReconnectIsRequired = function(g, f, S) {
                            this.wrapped.onReconnectIsRequired(g, f, S);
                        }, t.prototype.onDisconnected = function(g) {
                            this.isRegistered = !1, this.dropHeldBackEvents(), this.wrapped.onDisconnected(g);
                        }, t.prototype.onTerminalError = function(g) {
                            this.wrapped.onTerminalError(g);
                        }, t.prototype.onConnectionParametersUpdated = function(g) {
                            this.wrapped.onConnectionParametersUpdated(g);
                        }, t.prototype.onTrouterMessageLost = function(g) {
                            this.passIfRegisteredOrNotNeeded("onTrouterMessageLost", g);
                        }, t.prototype.onUserActivityStateAccepted = function(g) {
                            this.passIfRegisteredOrNotNeeded("onUserActivityStateAccepted", g);
                        }, t.prototype.onAudiencesSetResolved = function(g, f) {
                            this.passIfRegisteredOrNotNeeded("onAudiencesSetResolved", g, f);
                        }, t.prototype.getState = function() {
                            return this.wrapped.getState();
                        }, t.prototype.holdBackEvent = function(g) {
                            for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
                            this.heldBackEvents.push({
                                kind: g,
                                args: f
                            });
                        }, t.prototype.passIfRegisteredOrNotNeeded = function(g) {
                            for(var f, S = [], _ = 1; _ < arguments.length; _++)S[_ - 1] = arguments[_];
                            var C = this.shouldConnectionDependOnRegistration(), E = this.shouldHoldBackEvents();
                            C && E || this.fireHeldBackEvents(C ? function(g) {
                                return "onConnected" !== g.kind;
                            } : void 0), this.isRegistered || !C || !1 === E && "onConnected" !== g ? (f = this.wrapped)[g].apply(f, S) : this.holdBackEvent.apply(this, v([
                                g
                            ], S, !1));
                        }, t.prototype.fireHeldBackEvents = function(g) {
                            for(var f, S = 0, v = this.heldBackEvents; S < v.length; S++){
                                var _ = v[S];
                                (void 0 === g || g(_)) && (f = this.wrapped)[_.kind].apply(f, _.args);
                            }
                            this.heldBackEvents = void 0 === g ? [] : this.heldBackEvents.filter(function(f) {
                                return !g(f);
                            });
                        }, t.prototype.dropHeldBackEvents = function() {
                            this.heldBackEvents = [];
                        }, t;
                    }();
                    f.RegistrationEnforcer = C;
                    var E = function() {
                        function t(g, f, S, v) {
                            this.wrapped = g, this.prefix = f, this.logger = S, this.onEventAction = v;
                        }
                        return t.prototype.onEvent = function(g, f) {
                            var S;
                            void 0 !== this.onEventAction ? this.onEventAction(g, f) : (null !== (S = this.logger) && void 0 !== S ? S : console).log("".concat(this.prefix, " TracingEnforcer: ").concat(g, "(").concat(f, ")"));
                        }, t.prototype.onDownstreamRequest = function(g, f, S) {
                            this.onEvent("onDownstreamRequest", JSON.stringify({
                                request: f,
                                response: S
                            })), this.wrapped.onDownstreamRequest(g, f, S);
                        }, t.prototype.onConnected = function(g) {
                            this.onEvent("onConnected", g.getState().toString()), this.wrapped.onConnected(g);
                        }, t.prototype.onRegistered = function(g) {
                            this.onEvent("onRegistered", g.getState().toString()), this.wrapped.onRegistered(g);
                        }, t.prototype.onUnregistered = function(g) {
                            this.onEvent("onUnregistered", g.getState().toString()), this.wrapped.onUnregistered(g);
                        }, t.prototype.onReconnecting = function(g) {
                            this.onEvent("onReconnecting", g.getState().toString()), this.wrapped.onReconnecting(g);
                        }, t.prototype.onReconnectIsRequired = function(g, f, S) {
                            this.onEvent("onReconnectIsRequired", JSON.stringify({
                                connection: g.getState().toString(),
                                useConnectParamsFromCache: f,
                                reason: S
                            })), this.wrapped.onReconnectIsRequired(g, f, S);
                        }, t.prototype.onDisconnected = function(g) {
                            this.onEvent("onDisconnected", g.getState().toString()), this.wrapped.onDisconnected(g);
                        }, t.prototype.onTerminalError = function(g) {
                            this.onEvent("onTerminalError", JSON.stringify({
                                connection: g
                            })), this.wrapped.onTerminalError(g);
                        }, t.prototype.onConnectionParametersUpdated = function(g) {
                            this.onEvent("onConnectionParametersUpdated", JSON.stringify({
                                connectParams: g
                            })), this.wrapped.onConnectionParametersUpdated(g);
                        }, t.prototype.onTrouterMessageLost = function(g) {
                            this.onEvent("onTrouterMessageLost", JSON.stringify({
                                flowTags: g
                            })), this.wrapped.onTrouterMessageLost(g);
                        }, t.prototype.onUserActivityStateAccepted = function(g) {
                            this.onEvent("onUserActivityStateAccepted", JSON.stringify({
                                cv: g
                            })), this.wrapped.onUserActivityStateAccepted(g);
                        }, t.prototype.onAudiencesSetResolved = function(g, f) {
                            this.onEvent("onAudiencesSetResolved", JSON.stringify({
                                audienceSubscriptionsResponse: g,
                                cv: f
                            })), this.wrapped.onAudiencesSetResolved(g, f);
                        }, t.prototype.getState = function() {
                            return this.wrapped.getState();
                        }, t;
                    }();
                    f.LoggingManagerConsumer = E;
                },
                function(g, f, S) {
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.TrouterManagerFsm = void 0;
                    var v = S(2), _ = S(4), C = S(0), E = S(7), T = function() {
                        function t(g, f) {
                            this.worker = f, this.state = _.TrouterManagerState.Unknown, this.logger = new C.Logger("ManagerFsm", g);
                        }
                        return t.prototype.start = function() {
                            this.state === _.TrouterManagerState.Unknown ? (this.setState(_.TrouterManagerState.Disconnected), this.worker.forceStopLingeringConnection(), this.worker.startFirstConnection()) : (this.logger.info("start called in state '".concat(_.TrouterManagerState[this.state], "', expediting pending backoffs, if any")), this.worker.expediteBackoffOnConnections());
                        }, t.prototype.stop = function(g) {
                            this.state !== _.TrouterManagerState.Unknown ? (this.setState(_.TrouterManagerState.Unknown), this.worker.stopFirstConnection(!0 === g), this.worker.stopSecondConnection(!0 === g)) : this.showIgnored("stop");
                        }, t.prototype.getState = function() {
                            switch(this.state){
                                case _.TrouterManagerState.Unknown:
                                case _.TrouterManagerState.Connected:
                                case _.TrouterManagerState.Disconnected:
                                case _.TrouterManagerState.Switching:
                                    return this.state;
                                case _.TrouterManagerState.TerminalError:
                                    return v.TrouterState.Disconnected;
                            }
                        }, t.prototype.getInternalState = function() {
                            return this.state;
                        }, t.prototype.onConnected = function(g) {
                            this.state === _.TrouterManagerState.Disconnected && g ? this.worker.doesSecondConnectionExist() ? this.setState(_.TrouterManagerState.Switching) : (this.setState(_.TrouterManagerState.Connected), this.worker.dispatchConnected()) : this.showIgnored("onConnected(".concat(g, ")"));
                        }, t.prototype.onRegistered = function(g) {
                            this.state !== _.TrouterManagerState.Disconnected || g ? this.state !== _.TrouterManagerState.Switching || g ? this.state === _.TrouterManagerState.Disconnected && g && (this.setState(_.TrouterManagerState.Connected), this.worker.dispatchConnected()) : (this.setState(_.TrouterManagerState.Connected), this.worker.switchConnections(), this.worker.stopSecondConnectionDelayed(), this.worker.dispatchConnected()) : (this.setState(_.TrouterManagerState.Connected), this.worker.switchConnections(), this.worker.stopSecondConnection(!0), this.worker.dispatchConnected()), this.worker.dispatchRegistrationState(!0);
                        }, t.prototype.onUnregistered = function(g) {
                            g && this.worker.dispatchRegistrationState(!1);
                        }, t.prototype.onReconnecting = function(g) {
                            this.state !== _.TrouterManagerState.Connected && this.state !== _.TrouterManagerState.Switching || !g ? this.showIgnored("onReconnecting(".concat(g, ")")) : (this.setState(_.TrouterManagerState.Disconnected), this.worker.dispatchDisconnected());
                        }, t.prototype.onReconnectionRequired = function(g, f, S) {
                            this.state === _.TrouterManagerState.Connected && g ? (this.setState(_.TrouterManagerState.Switching), this.worker.startSecondConnection(f)) : this.state === _.TrouterManagerState.Disconnected && g ? this.worker.startSecondConnection(f) : this.state === _.TrouterManagerState.Switching && g && S === E.ReconnectReason.Configuration ? (this.logger.debug("onReconnectionRequired: switch requested while already in Switching state"), this.worker.stopSecondConnection(!0), this.worker.startSecondConnection(f)) : this.showIgnored("onReconnectionRequired(".concat(g, ")"));
                        }, t.prototype.onDisconnected = function(g) {
                            this.state == _.TrouterManagerState.Unknown && g ? this.worker.dispatchDisconnected() : this.state == _.TrouterManagerState.Switching && g ? (this.worker.switchConnections(), this.worker.stopSecondConnection(!1), this.setState(_.TrouterManagerState.Disconnected), this.worker.dispatchDisconnected()) : this.showIgnored("onDisconnected(".concat(g, ")"));
                        }, t.prototype.onTerminalError = function() {
                            this.setState(_.TrouterManagerState.TerminalError), this.worker.dispatchTerminalError();
                        }, t.prototype.showIgnored = function(g) {
                            this.logger.info("Ignoring event '".concat(g, "' in state '").concat(_.TrouterManagerState[this.state], "'"));
                        }, t.prototype.setState = function(g) {
                            this.logger.info("Switching from state '".concat(_.TrouterManagerState[this.state], "' to state '").concat(_.TrouterManagerState[g], "'")), this.state !== g ? this.state = g : this.logger.error("Attempt to switch to the current state '".concat(_.TrouterManagerState[g], "'"));
                        }, t;
                    }();
                    f.TrouterManagerFsm = T;
                },
                function(g, f, S) {
                    function o(g, f) {
                        if (!f) return g;
                        var S = v(v({}, g), {
                            enabled: f.TelemetryEnabled
                        });
                        return void 0 !== f.ClientTelemetryEventEnabled && (S = v(v({}, S), f.ClientTelemetryEventEnabled)), S;
                    }
                    function i(g, f, S) {
                        var _, C, E, T, I, b, A, R, P, w, M, O, m = function(S) {
                            return g.proxyUrlRewrite ? (f.info("Using rewritten URL for proxy"), g.proxyUrlRewrite(S)) : S;
                        };
                        return {
                            clientInfo: {
                                ua: g.trouterSettings.productName,
                                v: g.trouterSettings.version
                            },
                            ioOptions: {
                                ackTimeoutMs: 5e3,
                                rewriteUrlForProxy: m
                            },
                            clientCorrelationID: g.trouterSettings.sessionId,
                            environment: g.trouterSettings.environment,
                            telemetrySettings: o(g.telemetryConfig.settings, S),
                            eventLogger: g.telemetryConfig.eventLogger,
                            endpointId: g.trouterSettings.registrationId,
                            trouterUrl: (null == S ? void 0 : S.TrouterConnectionUrl) || g.trouterSettings.trouterServiceUrl,
                            registration: g.trouterSettings.registrarServiceUrl ? {
                                registrarUrl: g.trouterSettings.registrarServiceUrl,
                                registrationId: null !== (_ = g.trouterSettings.registrationId) && void 0 !== _ ? _ : "",
                                pnhAppId: null !== (C = g.trouterSettings.pnhAppId) && void 0 !== C ? C : "",
                                platform: null !== (E = g.trouterSettings.platform) && void 0 !== E ? E : "",
                                pnhTemplateKey: null !== (T = g.trouterSettings.pnhTemplate) && void 0 !== T ? T : "",
                                platformUIVersion: null !== (I = g.trouterSettings.platformUIVersion) && void 0 !== I ? I : "",
                                productContext: g.trouterSettings.pnhProductContext || void 0,
                                context: null !== (b = g.trouterSettings.pnhContext) && void 0 !== b ? b : "",
                                registrarTtlSec: (null !== (A = g.trouterSettings.maxRegistrationTimeInMs) && void 0 !== A ? A : 0) / 1e3
                            } : void 0,
                            connectionDependsOnRegistration: void 0 === g.trouterSettings.registrarServiceUrl ? function() {
                                return !1;
                            } : null !== (R = g.trouterSettings.connectionDependsOnRegistration) && void 0 !== R ? R : function() {
                                return !1;
                            },
                            delayEventsUntilRegistered: null !== (P = g.trouterSettings.delayEventsUntilRegistered) && void 0 !== P ? P : function() {
                                return !1;
                            },
                            timeoutOptions: v({
                                connectionTimeoutMs: g.trouterSettings.trouterConnectTimeoutInMs || 3e4,
                                fetchTimeoutMs: 1e4,
                                pingTimeoutMs: 4e4,
                                pongTimeoutMs: 5e3,
                                maxBackoffMs: "TeamsCDL" === g.trouterSettings.productName ? 3e5 : 3e4,
                                requestTimeoutMs: 5e3,
                                userActivityResponseTimeoutMs: 1e4
                            }, g.trouterSettings.timeoutOptions),
                            incallTimeoutOptions: v({
                                connectionTimeoutMs: 1e4,
                                fetchTimeoutMs: 5e3,
                                pingTimeoutMs: 5e3,
                                pongTimeoutMs: 2e3,
                                maxBackoffMs: "TeamsCDL" === g.trouterSettings.productName ? 3e5 : 1e4,
                                requestTimeoutMs: 5e3,
                                userActivityResponseTimeoutMs: 1e4
                            }, g.trouterSettings.incallTimeoutOptions),
                            incallModeTimeoutMs: null !== (w = g.trouterSettings.incallModeTimeoutMs) && void 0 !== w ? w : 0,
                            lingeringConnectionDelayMs: 6e4,
                            userActivitySecondResendDelayMs: g.trouterSettings.userActivitySecondResendDelayMs || 1e4,
                            duplicateDisconnectThresholdMs: 1e4,
                            connectionCache: g.connectionCache,
                            registrationStateCallback: g.registrationStateCallbackForAcsDoNotUse,
                            rewriteUrlForProxy: m,
                            retryLimitOnTokenFetch: g.trouterSettings.retryLimitOnTokenFetch,
                            extraConnectionHeaders: g.trouterSettings.extraConnectionHeaders,
                            expediteBackoffOnStartMinimumDelayMs: 1e4,
                            updateUserActivityDuringConnectionAttempt: null === (M = g.trouterSettings.updateUserActivityDuringConnectionAttempt) || void 0 === M || M,
                            initialConnectivityCheck: null === (O = g.trouterSettings.initialConnectivityCheck) || void 0 === O || O,
                            toJSON: function() {
                                return v(v({}, this), {
                                    connectionCache: this.connectionCache ? {} : this.connectionCache
                                });
                            }
                        };
                    }
                    function r(g) {
                        return new w(g);
                    }
                    function s() {
                        return E.CLIENT_VERSION;
                    }
                    function c(g, f) {
                        var S = g.indexOf("://");
                        if (S >= 0) {
                            var v = g.indexOf("/", S + 3);
                            if (v >= 0) return f + g.substr(v);
                        }
                        return "";
                    }
                    function a(g) {
                        var f = this;
                        return function(S) {
                            return _(f, void 0, void 0, function() {
                                var f;
                                return C(this, function(v) {
                                    switch(v.label){
                                        case 0:
                                            return f = {}, [
                                                4,
                                                g(S.needFresh)
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                (f.token = v.sent(), f.tokenType = "skype", f)
                                            ];
                                    }
                                });
                            });
                        };
                    }
                    function u(g, f) {
                        var S, v = this;
                        return function(E) {
                            return _(v, void 0, void 0, function() {
                                var v, _, T;
                                return C(this, function(C) {
                                    switch(C.label){
                                        case 0:
                                            v = new Date, _ = setInterval(function() {
                                                var f = Math.round((Date.now() - v.getTime()) / 6e4);
                                                g.warn("Note: Trouter auth token request promise from ".concat(v.toISOString(), " has not been resolved for ").concat(f, " minutes. The client is blocked from operating properly"));
                                            }, 3e5), C.label = 1;
                                        case 1:
                                            return C.trys.push([
                                                1,
                                                ,
                                                3,
                                                4
                                            ]), [
                                                4,
                                                f(E)
                                            ];
                                        case 2:
                                            return T = C.sent(), E.needFresh && T.token === S && g.error("API violation: Trouter auth token provider got a request with needRefresh=true, but returned the same token as last time anyway. Please fix the host app"), S = T.token, [
                                                2,
                                                T
                                            ];
                                        case 3:
                                            return clearInterval(_), [
                                                7
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                    }
                    var v = this && this.__assign || function() {
                        return v = Object.assign || function(g) {
                            for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                            return g;
                        }, v.apply(this, arguments);
                    }, _ = this && this.__awaiter || function(g, f, S, v) {
                        function i(g) {
                            return g instanceof S ? g : new S(function(f) {
                                f(g);
                            });
                        }
                        return new (S || (S = Promise))(function(S, _) {
                            function s(g) {
                                try {
                                    a(v.next(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function c(g) {
                                try {
                                    a(v.throw(g));
                                } catch (g) {
                                    _(g);
                                }
                            }
                            function a(g) {
                                g.done ? S(g.value) : i(g.value).then(s, c);
                            }
                            a((v = v.apply(g, f || [])).next());
                        });
                    }, C = this && this.__generator || function(g, f) {
                        function n(g) {
                            return function(f) {
                                return o([
                                    g,
                                    f
                                ]);
                            };
                        }
                        function o(T) {
                            if (S) throw new TypeError("Generator is already executing.");
                            for(; C && (C = 0, T[0] && (E = 0)), E;)try {
                                if (S = 1, v && (_ = 2 & T[0] ? v.return : T[0] ? v.throw || ((_ = v.return) && _.call(v), 0) : v.next) && !(_ = _.call(v, T[1])).done) return _;
                                switch(v = 0, _ && (T = [
                                    2 & T[0],
                                    _.value
                                ]), T[0]){
                                    case 0:
                                    case 1:
                                        _ = T;
                                        break;
                                    case 4:
                                        return E.label++, {
                                            value: T[1],
                                            done: !1
                                        };
                                    case 5:
                                        E.label++, v = T[1], T = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        T = E.ops.pop(), E.trys.pop();
                                        continue;
                                    default:
                                        if (!(_ = (_ = E.trys).length > 0 && _[_.length - 1]) && (6 === T[0] || 2 === T[0])) {
                                            E = 0;
                                            continue;
                                        }
                                        if (3 === T[0] && (!_ || T[1] > _[0] && T[1] < _[3])) {
                                            E.label = T[1];
                                            break;
                                        }
                                        if (6 === T[0] && E.label < _[1]) {
                                            E.label = _[1], _ = T;
                                            break;
                                        }
                                        if (_ && E.label < _[2]) {
                                            E.label = _[2], E.ops.push(T);
                                            break;
                                        }
                                        _[2] && E.ops.pop(), E.trys.pop();
                                        continue;
                                }
                                T = f.call(g, E);
                            } catch (g) {
                                T = [
                                    6,
                                    g
                                ], v = 0;
                            } finally{
                                S = _ = 0;
                            }
                            if (5 & T[0]) throw T[1];
                            return {
                                value: T[0] ? T[1] : void 0,
                                done: !0
                            };
                        }
                        var S, v, _, C, E = {
                            label: 0,
                            sent: function() {
                                if (1 & _[0]) throw _[1];
                                return _[1];
                            },
                            trys: [],
                            ops: []
                        };
                        return C = {
                            next: n(0),
                            throw: n(1),
                            return: n(2)
                        }, "function" == typeof Symbol && (C[Symbol.iterator] = function() {
                            return this;
                        }), C;
                    };
                    Object.defineProperty(f, "__esModule", {
                        value: !0
                    }), f.replaceTrouterUrlBase = f.getTrouterServiceVersion = f.createTrouterService = f.TrouterService = f.UserActivityState = f.TrouterState = void 0;
                    var E = S(1), T = S(2);
                    Object.defineProperty(f, "TrouterState", {
                        enumerable: !0,
                        get: function() {
                            return T.TrouterState;
                        }
                    }), Object.defineProperty(f, "UserActivityState", {
                        enumerable: !0,
                        get: function() {
                            return T.UserActivityState;
                        }
                    });
                    var I = S(0), b = S(8), A = S(9), R = S(10), P = S(11), w = function() {
                        function t(g) {
                            this.logProvider = g, this.stateChangedListeners = [], this.logger = new I.Logger("Trouter", g), this.trouterUrlPromise = new P.TrouterUrlPromise(g), this.messageHandlers = new b.MessageHandlerRegistry(g), this.listeners = {}, this.connectionInfo = null, this.logger.info("Created TrouterService version ".concat(E.CLIENT_VERSION));
                        }
                        return t.prototype.start = function(g) {
                            var f;
                            if (this.logger.info("Start"), !g.skypeTokenProvider && !g.authTokenProvider) throw new Error("no token provider has been configured, either skypeTokenProvider or authTokenProvider must be populated");
                            g.skypeTokenProvider && !g.trouterSettings.disableInternalSkypeTokenCache && (g.skypeTokenProvider = (0, A.addCacheAsBackupTo)(g.skypeTokenProvider)), this.trouterCfg = g;
                            var S = i(g, this.logger, this.ecsCfg);
                            !1 === g.internalEnableV4cProtocol && (S.forceV4aProtocol = !0);
                            var v = u(this.logger, null !== (f = g.authTokenProvider) && void 0 !== f ? f : a(g.skypeTokenProvider));
                            void 0 === this.trouterServer && (this.trouterServer = new R.TrouterManager(this.logProvider, S, v, void 0 === g.authTokenProvider, this)), void 0 !== this.pendingActivityState && (this.trouterServer.setUserActivityState(this.pendingActivityState[0], this.pendingActivityState[1]), this.pendingActivityState = void 0), this.trouterServer.start();
                        }, t.prototype.stop = function(g) {
                            this.logger.info("close connection"), this.trouterUrlPromise.rejectUrl(new Error("TrouterService is stopped")), void 0 !== this.trouterServer && this.trouterServer.stop(g);
                        }, t.prototype.setEcsConfig = function(g) {
                            return _(this, void 0, void 0, function() {
                                var f = this;
                                return C(this, function(S) {
                                    return [
                                        2,
                                        new Promise(function(S) {
                                            if (f.ecsCfg = g.TrouterJScriptClient, f.logger.info("Setting ECS configuration to ".concat(JSON.stringify(f.ecsCfg))), void 0 !== f.trouterServer && void 0 !== f.trouterCfg) {
                                                var v = i(f.trouterCfg, f.logger, f.ecsCfg);
                                                f.trouterServer.configure(v);
                                            }
                                            S();
                                        })
                                    ];
                                });
                            });
                        }, t.prototype.checkConnection = function(g) {
                            void 0 !== this.trouterServer && this.trouterServer.checkConnection(null != g && g);
                        }, t.prototype.resendRegistration = function() {
                            return _(this, void 0, void 0, function() {
                                return C(this, function(g) {
                                    if (!this.trouterServer) throw new Error("resendRegistration called too early");
                                    return [
                                        2,
                                        this.trouterServer.resendRegistration()
                                    ];
                                });
                            });
                        }, t.prototype.registerListener = function(g, f) {
                            return "" === f || !f.startsWith("/") || f.includes("?") || f.includes("#") ? (this.logger.error("Listener path '".concat(f, "' is not valid")), !1) : this.listeners[f] ? (this.logger.error("Another listener is already registered for path '".concat(f, "'")), !1) : (this.listeners[f] = g, this.logger.debug("Listener for path '".concat(f, "' registered")), this.connectionInfo && g.onTrouterConnected(this.connectionInfo.baseEndpointUrl + f, this.connectionInfo), !0);
                        }, t.prototype.unregisterListener = function(g) {
                            for(var f = [], S = 0, v = Object.keys(this.listeners); S < v.length; S++){
                                var _ = v[S];
                                this.listeners[_] === g && f.push(_);
                            }
                            if (0 === f.length) return !1;
                            for(var C = 0, E = f; C < E.length; C++)_ = E[C], delete this.listeners[_];
                            return this.logger.debug("Listener for path(s) '".concat(f.join("', '"), "' unregistered")), !0;
                        }, t.prototype.onTrouterConnected = function(g, f) {
                            this.logger.debug("Trouter is now connected");
                            for(var S = 0, v = Object.keys(this.listeners); S < v.length; S++){
                                var _ = v[S];
                                try {
                                    this.listeners[_].onTrouterConnected(f.baseEndpointUrl + _, f);
                                } catch (g) {
                                    this.logger.error("Listener '".concat(_, "' threw an exception from onTrouterConnected(): ").concat(g));
                                }
                            }
                            this.connectionInfo = f, this.trouterUrlPromise.resolveUrl(g), this.notifyStateChanged(T.TrouterState.Connected, {
                                url: g,
                                getRemainingTtlInSec: function() {
                                    return f.connectionTtlSec;
                                }
                            });
                        }, t.prototype.onTrouterDisconnected = function() {
                            this.logger.debug("Trouter is now disconnected"), this.connectionInfo = null;
                            for(var g = 0, f = Object.keys(this.listeners); g < f.length; g++){
                                var S = f[g], v = this.listeners[S];
                                if (v.onTrouterDisconnected) try {
                                    v.onTrouterDisconnected();
                                } catch (g) {
                                    this.logger.error("Listener '".concat(S, "' threw an exception from onTrouterDisconnected(): ").concat(g));
                                }
                            }
                            this.notifyStateChanged(T.TrouterState.Disconnected);
                        }, t.prototype.onTrouterRequest = function(g, f) {
                            for(var S = "", v = 0, _ = Object.keys(this.listeners); v < _.length; v++){
                                var C = _[v];
                                g.path.startsWith(C) && C.length > S.length && (S = C);
                            }
                            if ("" === S) this.tryMessageHandlers(g, f) || (f.status = 404, f.headers = {
                                "Trouter-Responder": "ClientLib"
                            }, f.send());
                            else try {
                                this.listeners[S].onTrouterRequest(g, f);
                            } catch (g) {
                                this.logger.error("Listener '".concat(S, "' threw an exception from onTrouterRequest(): ").concat(g)), f.status = 500, f.headers = {
                                    "Trouter-Responder": "ClientLib"
                                }, f.send();
                            }
                        }, t.prototype.onTrouterMessageLoss = function(g) {
                            this.logger.info("onTrouterMessageLoss called with tags [".concat(g, "]"));
                            for(var f = !0, S = 0, v = Object.keys(this.listeners); S < v.length; S++){
                                var _ = v[S], C = this.listeners[_];
                                if (C.onTrouterMessageLoss) try {
                                    void 0 === (f = C.onTrouterMessageLoss(g) && f) && (this.logger.error("Listener '".concat(_, "' did not return a boolean value from onTrouterMessageLoss()")), f = !1);
                                } catch (g) {
                                    this.logger.error("Listener '".concat(_, "' threw an exception from onTrouterMessageLoss(): ").concat(g)), f = !1;
                                }
                            }
                            return f;
                        }, t.prototype.onTrouterUserActivityStateAccepted = function(g) {
                            this.logger.debug("onTrouterUserActivityStateAccepted cv: ".concat(g));
                            for(var f = 0, S = Object.keys(this.listeners); f < S.length; f++){
                                var v = S[f], _ = this.listeners[v];
                                if (_.onTrouterUserActivityStateAccepted) try {
                                    _.onTrouterUserActivityStateAccepted(g);
                                } catch (g) {
                                    this.logger.error("Listener '".concat(v, "' threw an exception from onTrouterUserActivityStateAccepted(): ").concat(g));
                                }
                            }
                        }, t.prototype.onAudiencesSetResolved = function(g, f) {
                            this.logger.debug("onAudiencesSetResolved cv: ".concat(f));
                            for(var S = 0, v = Object.keys(this.listeners); S < v.length; S++){
                                var _ = v[S], C = this.listeners[_];
                                if (C.onAudiencesSetResolved) try {
                                    C.onAudiencesSetResolved(g, f);
                                } catch (g) {
                                    this.logger.error("Listener '".concat(_, "' threw an exception from onAudienceSubscribed(): ").concat(g));
                                }
                            }
                        }, t.prototype.setUserActivityState = function(g, f) {
                            if (g !== T.UserActivityState.Active && g !== T.UserActivityState.Inactive) throw new Error("setUserActivityState called with unsupported value ".concat(g));
                            this.logger.info("setUserActivityState called with value ".concat(T.UserActivityState[g])), this.trouterServer && this.state() !== T.TrouterState.Unknown ? this.trouterServer.setUserActivityState(g, f) : (this.pendingActivityState = [
                                g,
                                f
                            ], this.logger.warn("setUserActivityState called before start() or after stop()"));
                        }, t.prototype.setAudienceSubscriptions = function(g, f) {
                            if (g.audienceSubscriptions.length > 1) throw new Error("Only singular audience subscription is supported");
                            if (this.trouterServer && this.state() !== T.TrouterState.Unknown) return this.trouterServer.setAudienceSubscriptionsAsync(g, 15e3, f);
                            throw new Error("audience subscribe called before start() or after stop()");
                        }, t.prototype.state = function() {
                            return void 0 !== this.trouterServer ? this.trouterServer.getState() : T.TrouterState.Unknown;
                        }, t.prototype.isInTerminalState = function() {
                            return void 0 !== this.trouterServer && this.trouterServer.isInTerminalState();
                        }, t.prototype.reportStateInfo = function() {
                            return void 0 === this.trouterServer ? "" : this.trouterServer.reportStateInfo();
                        }, t.prototype.getServerState = function() {
                            if (void 0 !== this.trouterServer) return this.trouterServer.getServerState();
                        }, t.prototype.getTrouterUrlAsync = function() {
                            return void 0 !== this.trouterServer ? this.trouterUrlPromise.getPromise() : Promise.reject(new Error("TrouterService has not been started"));
                        }, t.prototype.onStateChanged = function(g) {
                            if (this.logger.info("onStateChanged called"), void 0 === g) this.stateChangedListeners = this.stateChangedListeners.filter(function(g) {
                                return void 0 === g.wrappedCallback;
                            });
                            else {
                                this.offStateChanged(g);
                                var e = function(f, S) {
                                    g(f, S ? S.url : "");
                                };
                                e.wrappedCallback = g, this.stateChangedListeners.push(e);
                            }
                        }, t.prototype.offStateChanged = function(g) {
                            this.logger.info("offStateChanged called");
                            var f = this.stateChangedListeners.length;
                            return this.stateChangedListeners = this.stateChangedListeners.filter(function(f) {
                                return f.wrappedCallback !== g;
                            }), f > this.stateChangedListeners.length;
                        }, t.prototype.addCallback = function(g) {
                            this.logger.info("addListener called"), -1 === this.stateChangedListeners.indexOf(g, 0) && void 0 !== g && this.stateChangedListeners.push(g);
                        }, t.prototype.removeCallback = function(g) {
                            this.logger.info("removeListener called");
                            var f = this.stateChangedListeners.indexOf(g, 0);
                            return f > -1 && (this.stateChangedListeners.splice(f, 1), !0);
                        }, t.prototype.registerMessageHandler = function(g) {
                            this.logger.info("registerMessageHandler is called"), this.messageHandlers.register(g);
                        }, t.prototype.clearMessageHandlers = function() {
                            this.logger.info("clearMessageHandlers is called"), this.messageHandlers.clear();
                        }, t.prototype.notifyStateChanged = function(g, f) {
                            var S = this;
                            this.logger.info("notifyStateChanged called, will forward to ".concat(this.stateChangedListeners.length, " listeners")), this.stateChangedListeners.forEach(function(v) {
                                try {
                                    v(g, f);
                                } catch (g) {
                                    S.logger.error("Error in callback ".concat(g));
                                }
                            });
                        }, t.prototype.tryMessageHandlers = function(g, f) {
                            if (!this.messageHandlers.active()) return !1;
                            var S, v = null;
                            try {
                                v = (S = JSON.parse(g.body)) && (S.evt || S.eventId) || null;
                            } catch (g) {}
                            var _ = {
                                eventId: v,
                                url: (this.connectionInfo ? this.connectionInfo.baseEndpointUrl : "") + g.path,
                                body: S,
                                rawBody: g.body,
                                headers: g.headers
                            }, C = this.messageHandlers.handleMessage(_);
                            return !!C.isHandled && (f.status = C.resultCode, C.responseHeaders && (f.headers = C.responseHeaders), C.responseBody && (f.body = C.responseBody), f.send(), !0);
                        }, t;
                    }();
                    f.TrouterService = w, f.createTrouterService = r, f.getTrouterServiceVersion = s, f.replaceTrouterUrlBase = c;
                },
                function(f, S) {
                    f.exports = g;
                }
            ]);
        }, g.exports = S(lA);
    });
    class TelemetrySender {
        constructor(g, f){
            this.logEvent = (g)=>{
                this._logger.debug(g), this._telemetryLogManager.sendEvent({
                    name: g.name,
                    tenant: of,
                    properties: {
                        ...g.properties
                    }
                });
            }, this._logger = g.createChild("TelemetrySender"), this._telemetryLogManager = f;
        }
    }
    class Trouter {
        async start(g) {
            let f;
            if (this._trouterService) throw this._logger.error("Trouterservice already initialized"), new CallingCommunicationError({
                defaultError: O.CALL_STACK.SIGNALING_SERVICE_ALREADY_INITIALIZED
            });
            {
                const S = new Promise(async (f, S)=>{
                    try {
                        if (this._logger.info("Trouterservice start"), this._trouterService = cA.createTrouterService(this._logger), !this._trouterService) throw this._logger.error("Failed to create trouter service"), new CallingCommunicationError({
                            defaultError: O.CALL_STACK.SIGNALING_SERVICE_CREATE_FAIL
                        });
                        this._options = this._getTrouterConfig(this._logger, this._tokenProvider), g && (this._options.trouterSettings.environment = g.environment || "", this._options.trouterSettings.sessionId = g.sessionId);
                        let S, v, _ = +new Date;
                        this._trouterService.start(this._options), this._trouterService.onStateChanged((g, f)=>{
                            g === cA.TrouterState.Connected && (S = +new Date);
                        }), await this._initialRegistrationCompleteDefer.promise;
                        const C = +new Date;
                        S = S !== null && S !== void 0 ? S : +new Date, v = S, f({
                            trouterRequestCompletionTimeDeltaMs: Math.max(0, S - _),
                            registrarRequestCompletionTimeDeltaMs: Math.max(0, C - v)
                        });
                    } catch (g) {
                        S(g);
                    }
                });
                try {
                    const g = wait(()=>S, Rm);
                    f = await g;
                } catch (g) {
                    throw 408 === g.code ? (this._logger.error("Signaling init timeout"), new CallingCommunicationError({
                        defaultError: O.CALL_STACK.SIGNALING_SERVICE_CREATE_TIMEOUT,
                        defaultErrorMessageArgs: [
                            Rm
                        ]
                    })) : (this._logger.error("Signaling init failed"), new CallingCommunicationError({
                        defaultError: O.CALL_STACK.SIGNALING_INIT_FAIL
                    }));
                }
            }
            return f;
        }
        isRegistered() {
            return this._isRegistered;
        }
        onRegisteredChanged(g) {
            this._logger.info("TrouterService onRegisteredChanged"), this._registeredChangedListeners.push(g);
        }
        offRegisteredChanged(g) {
            const f = this._registeredChangedListeners.indexOf(g);
            this._logger.info(`TrouterService offRegisteredChanged: ${f}`), f > -1 && this._registeredChangedListeners.splice(f, 1);
        }
        stop(g) {
            this._logger.info("Trouterservice stop"), this._trouterService ? (this._trouterService.onStateChanged(void 0), this._trouterService.stop(g), this._trouterService = void 0) : this._logger.error("Trouterservice not inited");
        }
        registerMessageHandler(g) {
            this._logger.info("Trouterservice registerMessageHandler"), this._trouterService && this._trouterService.registerMessageHandler(g);
        }
        clearMessageHandlers() {
            this._trouterService && this._trouterService.clearMessageHandlers();
        }
        checkConnection() {
            this._trouterService && this._trouterService.checkConnection();
        }
        state() {
            return this._logger.info("Trouterservice state"), this._trouterService ? this._trouterService.state() : cA.TrouterState.Unknown;
        }
        onStateChanged(g) {
            this._logger.info("Trouterservice onStateChanged"), this._trouterService && this._trouterService.onStateChanged(g);
        }
        offStateChanged(g) {
            this._logger.info("Trouterservice offStateChanged"), this._trouterService && this._trouterService.offStateChanged(g);
        }
        getTrouterUrlAsync() {
            return this._trouterService ? (this._logger.info("getTrouterUrlAsync called"), this._trouterService.getTrouterUrlAsync()) : Promise.reject("Trouterservice not started yet");
        }
        _getSettings() {
            return {
                registrationId: generateGuid(),
                registrarServiceUrl: this._ecsProvider.getTrouterSettings().registrarServiceUrl,
                registrarTtlInSeconds: this._ecsProvider.getTrouterSettings().registrarTtlInSeconds,
                maxRegistrationTimeInMs: this._ecsProvider.getTrouterSettings().maxRegistrationTimeInMs,
                registrarRefreshTimeoutInMs: this._ecsProvider.getTrouterSettings().registrarRefreshTimeoutInMs,
                pnhAppId: this._ecsProvider.getTrouterSettings().pnhAppId,
                pnhTemplate: this._ecsProvider.getTrouterSettings().pnhTemplate,
                platform: this._ecsProvider.getTrouterSettings().platform,
                platformUIVersion: this._ecsProvider.getTrouterSettings().version,
                trouterServiceUrl: this._ecsProvider.getTrouterSettings().trouterServiceUrl,
                version: this._ecsProvider.getTrouterSettings().version,
                trouterConnectTimeoutInMs: this._ecsProvider.getTrouterSettings().trouterConnectTimeoutInMs,
                productName: this._ecsProvider.getTrouterSettings().productName,
                sessionId: generateGuid(),
                environment: this._ecsProvider.getTrouterSettings().environment,
                timeoutOptions: this._ecsProvider.getTrouterSettings().timeoutOptions
            };
        }
        _createTrouterTelemetryConfig(g) {
            return {
                eventLogger: new TelemetrySender(g.createChild("TrouterTelemetry"), this._telemetryLogManager),
                settings: {
                    enabled: this._ecsProvider.getTrouterTelemetryConfig().enabled,
                    logHealthCheckError: this._ecsProvider.getTrouterTelemetryConfig().logHealthCheckError,
                    trouter_js_client_connected: this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_connected,
                    trouter_js_client_disconnected: this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_disconnected,
                    trouter_js_client_error: this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_error,
                    trouter_js_client_progress: this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_progress,
                    trouter_js_client_response: this._ecsProvider.getTrouterTelemetryConfig().trouter_js_client_response,
                    numberOfStepsToMaintain: this._ecsProvider.getTrouterTelemetryConfig().numberOfStepsToMaintain,
                    sendProgressTimeoutSecs: this._ecsProvider.getTrouterTelemetryConfig().sendProgressTimeoutSecs
                }
            };
        }
        _getTrouterConfig(g, f) {
            return {
                trouterSettings: this._getSettings(),
                proxyUrlRewrite: this._acsProxy.hasProxyUrl() ? (g)=>this._acsProxy.proxyfyUrl(g) : void 0,
                skypeTokenProvider: f,
                telemetryConfig: this._createTrouterTelemetryConfig(g),
                registrationStateCallbackForAcsDoNotUse: (g)=>{
                    this._logger.info(`TrouterService registrationStateCallbackForAcs: ${g}`), this._isRegistered = g, this._initialRegistrationCompleteDefer.isPending() && this._isRegistered ? this._initialRegistrationCompleteDefer.resolve() : this._isRegistered ? this._logger.info("Signaling service is currently registered") : this._logger.error("Signaling service is currently not registered. Unable to receive incoming calls"), this._onRegisteredChanged(g);
                }
            };
        }
        _onRegisteredChanged(g) {
            this._logger.info(`TrouterService onRegisteredChanged: ${g}`), this._registeredChangedListeners.forEach((f)=>{
                f(g);
            });
        }
        constructor(g, f, S, v, _){
            this._ecsProvider = f, this._tokenProvider = S, this._isRegistered = !1, this._registeredChangedListeners = [], this._logger = g.createChild("Trouter"), this._logger.info("init"), this._initialRegistrationCompleteDefer = defer$1(), this._telemetryLogManager = v, this._acsProxy = _;
        }
    }
    class TelemetryService {
        constructor(g){
            this._eventToTenantId = {
                skypecosi_concore_web_csa_conversation_httprequest: rf,
                skypecosi_concore_web_ts_calling_in_call_session: rf,
                skypecosi_concore_web_ts_calling_call_setup_session: rf,
                skypecosi_concore_native_ts_calling_in_call_session: rf,
                skypecosi_concore_native_ts_calling_call_setup_session: rf,
                skypecosi_concore_web_pluginless_call_session: rf,
                skypecosi_concore_web_pluginless_modality_session: rf,
                skypecosi_concore_web_csa_conversation_callmodality: rf,
                skypecosi_concore_web_ts_calling_registry: rf,
                mdsc_webrtc_session: af,
                mdsc_webrtc_session_initial: af,
                live_events: sf,
                mdsc_ortc_reports: af,
                mdsc_ortc_reports_initial: af,
                mdsc_rt_log: af
            }, this.getTenant = (g)=>this._eventToTenantId[g] ? this._eventToTenantId[g] : "", this.getCallingAdapter = ()=>({
                    sendEvent: (g, f)=>{
                        this._telemetryLogManager.sendEvent({
                            tenant: this.getTenant(g),
                            name: g,
                            properties: f
                        });
                    }
                }), this.getGenericTelemetryLogger = (g)=>({
                    sendEvent: (g)=>{
                        this._telemetryLogManager.sendEvent({
                            tenant: this.getTenant(g.eventName),
                            name: g.eventName,
                            properties: g.props
                        });
                    }
                }), this.getMediaAdapter = ()=>({
                    sendEvent: (g, f)=>{
                        this._telemetryLogManager.sendEvent({
                            tenant: this.getTenant(g),
                            name: g,
                            properties: f
                        });
                    }
                }), this.sendEvents = (g)=>(g.forEach((g)=>{
                    this._telemetryLogManager.sendEvent({
                        tenant: this.getTenant(g.eventName),
                        name: g.eventName,
                        properties: g.props
                    });
                }), Promise.resolve()), this._telemetryLogManager = g;
        }
    }
    class EcsConfigObj {
        constructor(g, f, S, v, _, C = !0, E, T, I, b){
            this.configType = g, this.caConfigBag = f, this.queryParameters = S, this.ecsConfigReceiver = v, this.platformId = _, this.isAppInitiallyInForeground = C, this.userRawSkypeToken = E, this.userSkypeTokenExpiration = T, this.projectName = I, this.ecsHosts = b;
        }
    }
    class WebCVProvider {
        get videoEffectProviderDeferredPromise() {
            return this._timedVideoEffectProviderPromise.deferredPromise;
        }
        get modelConfigDeferredPromise() {
            return this._timedModelConfigPromise.deferredPromise;
        }
        async getVideoEffectProvider() {
            return this._timedVideoEffectProviderPromise.timerStart(), this._timedVideoEffectProviderPromise.deferredPromise.promise;
        }
        async getModelConfig() {
            return this._timedModelConfigPromise.deferredPromise.resolve({
                modelUrl: "",
                weightPathPrefix: ""
            }), this._timedModelConfigPromise.deferredPromise.promise;
        }
        constructor(){
            this._timedVideoEffectProviderPromise = timedDefer(B), this._timedModelConfigPromise = timedDefer(B);
        }
    }
    class EncodedStreamsWorkerProvider {
        async getWorkerUrl() {
            return this._encodedStreamsJsPath;
        }
        constructor(g){
            this._encodedStreamsJsPath = g;
        }
    }
    class HttpRequestDispatcher {
        getRequestOptions(g, f, S, v, _) {
            return {
                headers: f || {},
                timeout: v,
                payload: S || null,
                responseType: _
            };
        }
        getAsync(g, f) {
            return this.sendRequest(this.proxy ? this.proxy.proxyfyUrl(g) : g, f, "GET");
        }
        postAsync(g, f) {
            return this.sendRequest(this.proxy ? this.proxy.proxyfyUrl(g) : g, f, "POST");
        }
        putAsync(g, f) {
            return this.sendRequest(this.proxy ? this.proxy.proxyfyUrl(g) : g, f, "PUT");
        }
        removeAsync(g, f) {
            return this.sendRequest(this.proxy ? this.proxy.proxyfyUrl(g) : g, f, "DELETE");
        }
        async sendRequest(g, f = {
            headers: {}
        }, S) {
            const v = this.logger.createChild(`[${f.causeId || generateGuid()}][Request]`);
            v.info(`sending, ${S}-${g}`);
            const _ = Date.now();
            let C;
            f.headers = f.headers || {}, f.headers["content-type"] || (f.headers["content-type"] = f.contentType || "application/json");
            let E = {
                url: g,
                start: new Date(_).toISOString(),
                end: "",
                statusCode: 0,
                deltaTimeInMs: 0,
                causeId: ""
            };
            const T = getAcsEcsConfig().telemetry.apiCauseIdHeader;
            try {
                const I = CI.request({
                    url: g,
                    method: S,
                    headers: f.headers || {},
                    timeout: "number" == typeof f.timeout ? f.timeout : 45e3,
                    data: f.payload || "",
                    responseType: f.responseType || f.dataType || "json",
                    withCredentials: valueOrDefault(f.withCredentials, !1),
                    cancelToken: new CI.CancelToken((g)=>{
                        C = g;
                    })
                });
                isPromiseLike$1(f.timeout) && f.timeout.then(()=>{
                    v.info("Aborting pending request"), C();
                }, ()=>{
                    v.info("Timeout promise rejected, ignoring");
                });
                const b = await I;
                if (v.info(`success, status=${b.status}`), f.headers[T]) {
                    const g = f.headers[T].split("-")[0];
                    xE.getRemoveCauseIdToNetworkInfo(g) && (E = {
                        ...E,
                        end: (new Date).toISOString(),
                        statusCode: b.status,
                        deltaTimeInMs: Date.now() - _,
                        causeId: g
                    }, xE.setCauseIdToNetworkInfo(g, E));
                }
                return {
                    response: b.data,
                    request: b.request,
                    duration: Date.now() - _
                };
            } catch (g) {
                if (v.info("failed"), f.headers[T]) {
                    const S = f.headers[T].split("-")[0];
                    xE.ifCauseIdExistsRemoveNetworkInfo(S) && (E = {
                        ...E,
                        end: (new Date).toISOString(),
                        statusCode: g.code,
                        deltaTimeInMs: Date.now() - _,
                        causeId: S
                    }, xE.setCauseIdToNetworkInfo(S, E));
                }
                if (CI.isCancel(g)) throw v.info(`response=${safeJsonStringify(g.message)}`), {
                    aborted: !0
                };
                throw g.response ? v.info(`response=${safeJsonStringify(g.response)}`) : g.request ? v.info(`no response, request=${safeJsonStringify(g.request)}`) : v.info(`request not made, error=${safeJsonStringify(g)}`), g || new Error("Request failed");
            }
        }
        constructor(g, f){
            f || "function" != typeof g.createChild ? this.logger = g : this.logger = g.createChild("JS.TsCalling.RequestDispatcher"), this.proxy = f;
        }
    }
    class VideoEffectsStatusManager {
        on(g, f) {
            if ("statusChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.VIDEO_EFFECTS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("statusChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.VIDEO_EFFECTS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        getActiveEffects() {
            return this._activeEffects;
        }
        setActiveEffects(g) {
            const f = this._activeEffects;
            this._activeEffects = g, this.eventEmitter.emit("statusChanged", f, this._activeEffects);
        }
        constructor(){
            this._activeEffects = [], this.eventEmitter = new Ny.EventEmitter;
        }
    }
    !function(g) {
        g[g.Default = 0] = "Default", g[g.User = 1] = "User";
    }(oA || (oA = {}));
    class AudioEffectsStatusManager {
        on(g, f) {
            if ("statusChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("statusChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.FEATURES.AUDIO_EFFECTS.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this.eventEmitter.off(g, f);
        }
        getActiveEffects() {
            return this._activeEffects;
        }
        setActiveEffects(g, f) {
            const S = {
                ...this._activeEffects
            };
            this._activeEffects = {
                ...g
            }, this.eventEmitter.emit("statusChanged", S, this._activeEffects, f);
        }
        constructor(){
            this._activeEffects = {
                echoCancellation: [],
                noiseSuppression: [],
                autoGainControl: []
            }, this.eventEmitter = new Ny.EventEmitter;
        }
    }
    class WasmVqeProvider {
        get providerValue() {
            return this._providerValue;
        }
        set providerValue(g) {
            this._providerValue = g;
        }
        async getAudioEffectProvider() {
            return this.providerValue;
        }
    }
    var dA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function AllowBackgroundFetchData() {
                this._isAllowed = !1;
            }
            return AllowBackgroundFetchData.prototype.putBackgroundFetchAllowed = function(g) {
                if (this._isAllowed = g, this.isBackgroundFetchAllowed() && this._isAllowedDeferral) {
                    var f = this._isAllowedDeferral;
                    this._isAllowedDeferral = void 0, f.resolve(void 0);
                }
            }, AllowBackgroundFetchData.prototype.isBackgroundFetchAllowed = function() {
                return this._isAllowed;
            }, AllowBackgroundFetchData.prototype.waitForBackgroundFetchAllowed = function() {
                return this.isBackgroundFetchAllowed() ? T.Resolved() : (this._isAllowedDeferral || (this._isAllowedDeferral = T.Defer()), this._isAllowedDeferral.promise());
            }, AllowBackgroundFetchData;
        }();
        f.default = S;
    }), uA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function AppActiveData() {
                this._isActive = !1;
            }
            return AppActiveData.prototype.putAppActive = function(g) {
                if (this._isActive = g, this.isAppActive() && this._appActiveDeferral) {
                    var f = this._appActiveDeferral;
                    this._appActiveDeferral = void 0, f.resolve(void 0);
                }
            }, AppActiveData.prototype.isAppActive = function() {
                return this._isActive;
            }, AppActiveData.prototype.waitForAppActive = function() {
                return this.isAppActive() ? T.Resolved() : (this._appActiveDeferral || (this._appActiveDeferral = T.Defer()), this._appActiveDeferral.promise());
            }, AppActiveData;
        }();
        f.default = S;
    }), hA = function() {
        function SubscriptionToken(g, f) {
            this._event = g, this._callback = f;
        }
        return SubscriptionToken.prototype.unsubscribe = function() {
            this._event.unsubscribe(this._callback);
        }, SubscriptionToken;
    }(), gA = function() {
        function SubscribableEvent(g) {
            void 0 === g && (g = !1);
            var f = this;
            this._allowStopPropagation = g, this.fire = function() {
                for(var g = [], S = 0; S < arguments.length; S++)g[S] = arguments[S];
                for(var v = f._subscribers, _ = v.length - 1; _ >= 0; _--){
                    var C = v[_].apply(null, g);
                    if (f._allowStopPropagation && C) return !0;
                }
                return !1;
            }, this._subscribers = [];
        }
        return SubscribableEvent.prototype.dispose = function() {
            this._subscribers = [];
        }, SubscribableEvent.prototype.subscribe = function(g) {
            return this._subscribers = this._subscribers.concat(g), new hA(this, g);
        }, SubscribableEvent.prototype.unsubscribe = function(g) {
            this._subscribers = this._subscribers.filter(function(f) {
                return f !== g;
            });
        }, SubscribableEvent;
    }(), pA = Object.freeze({
        __proto__: null,
        SubscriptionToken: hA,
        default: gA
    }), mA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), function(g) {
            g[g.Default = 0] = "Default", g[g.User = 1] = "User";
        }(f.EcsConfigType || (f.EcsConfigType = {}));
    }), fA = getAugmentedNamespace(pA), SA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function Cache(g) {
                this._config = g, this.configUpdated = new fA.default, this._cachedConfigs = {};
            }
            return Cache.prototype.initialize = function() {
                return this.updateConfigsToFetch();
            }, Cache.prototype.updateConfigsToFetch = function() {
                var g = this, f = this._config.getConfig(), S = f.databaseInterface, v = f.configsToFetch;
                if (!S) return T.Resolved();
                for(var _ = [], _loop_1 = function(f) {
                    if (C._cachedConfigs[f]) return "continue";
                    _.push(S.getData(f).then(function(S) {
                        S && (g._cachedConfigs[f] = S);
                    }).catch(function() {
                        return T.Resolved();
                    }));
                }, C = this, E = 0, I = v; E < I.length; E++)_loop_1(I[E]);
                return T.all(_).then(function() {
                    _.length > 0 && g.configUpdated.fire();
                });
            }, Cache.prototype.getEcsConfig = function() {
                return this._cachedConfigs[mA.EcsConfigType.User] || this._cachedConfigs[mA.EcsConfigType.Default];
            }, Cache.prototype.getEcsConfigByType = function(g) {
                return this._cachedConfigs[g];
            }, Cache.prototype.putConfig = function(g) {
                var f = this.getEcsConfig();
                this._cachedConfigs[g.configType] = g;
                var S = this.getEcsConfig();
                (S && S.configType === g.configType || f && S && f.configType !== S.configType) && this.configUpdated.fire();
                var v = this._config.getConfig().databaseInterface;
                return v ? v.putData(g.configType, g) : T.Resolved();
            }, Cache;
        }();
        f.default = S;
    }), vA = createCommonjsModule(function(g, f) {
        var S = _ && _.__assign || function() {
            return S = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, S.apply(this, arguments);
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var v = function() {
            function Config() {}
            return Config.prototype.initialize = function(g) {
                if (this._config) throw "ECS Configuration already initialized";
                this._config = g;
            }, Config.prototype.getConfig = function() {
                if (!this._config) throw "ECS Configuration not yet initialized";
                return this._config;
            }, Config.prototype.setConfigsToFetch = function(g) {
                if (!this._config) throw "ECS Configuration not yet initialized";
                this._config = S({}, this._config, {
                    configsToFetch: g
                });
            }, Config.prototype.setFetchTimeout = function(g) {
                if (!this._config) throw "ECS Configuration not yet initialized";
                this._config = S({}, this._config, {
                    fetchTimeout: g
                });
            }, Config;
        }();
        f.default = v;
    }), _A = createCommonjsModule(function(g, f) {
        var S = _ && _.__assign || function() {
            return S = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, S.apply(this, arguments);
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.assert = function(g, f) {
            if (!g) throw new Error(f);
        }, f.isObject = function(g) {
            return null !== g && "object" == typeof g;
        }, f.isString = function(g) {
            return "string" == typeof g;
        }, f.attempt = function(g) {
            for(var f = [], S = 1; S < arguments.length; S++)f[S - 1] = arguments[S];
            try {
                return g.apply(void 0, f);
            } catch (g) {
                return new Error(g);
            }
        }, f.remove = function(g, f) {
            for(var S = g.length - 1; S >= 0; S--)g[S] === f && g.splice(S, 1);
        }, f.clone = function(g) {
            return Array.isArray(g) ? g.map(f.clone) : f.isObject(g) ? Object.keys(g).reduce(function(v, _) {
                var C;
                return S(S({}, v), ((C = {})[_] = f.clone(g[_]), C));
            }, {}) : g;
        };
    }), CA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.DEFAULT_TIME_GROW_FACTOR = 2.718281828459045, f.DEFAULT_TIME_JITTER = .11962656472;
        var S = function() {
            function ExponentialTime(g, S, v, _) {
                void 0 === v && (v = f.DEFAULT_TIME_GROW_FACTOR), void 0 === _ && (_ = f.DEFAULT_TIME_JITTER), this._initialTime = g, this._maxTime = S, this._growFactor = v, this._jitterFactor = _, _A.assert(this._initialTime > 0, "Initial delay must be positive"), _A.assert(this._maxTime > 0, "Delay upper bound must be positive"), _A.assert(this._growFactor >= 0, "Ratio must be non-negative"), _A.assert(this._jitterFactor >= 0, "Jitter factor must be non-negative"), this.reset();
            }
            return ExponentialTime.prototype.reset = function() {
                this._incrementCount = 0, this._currentTime = Math.round(this._initialTime * (1 + Math.random() * this._jitterFactor));
            }, ExponentialTime.prototype.getTime = function() {
                return this._currentTime;
            }, ExponentialTime.prototype.getIncrementCount = function() {
                return this._incrementCount;
            }, ExponentialTime.prototype.calculateNext = function() {
                var g = this._currentTime * this._growFactor;
                return g > this._maxTime && (g = this._maxTime), this._jitterFactor < 1e-5 ? this._currentTime = g : this._currentTime = Math.round(Math.random() * g * this._jitterFactor + g), this._currentTime < this._initialTime && (this._currentTime = this._initialTime), this._currentTime > this._maxTime && (this._currentTime = this._maxTime), this._incrementCount++, this._currentTime;
            }, ExponentialTime.prototype.getTimeAndCalculateNext = function() {
                var g = this.getTime();
                return this.calculateNext(), g;
            }, ExponentialTime;
        }();
        f.ExponentialTime = S;
    }), yA = createCommonjsModule(function(g, f) {
        var S, v, C, E = _ && _.__extends || (S = function(g, f) {
            return S = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(g, f) {
                g.__proto__ = f;
            } || function(g, f) {
                for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
            }, S(g, f);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        }), I = _ && _.__assign || function() {
            return I = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, I.apply(this, arguments);
        };
        function isJsonContentType(g) {
            return !!g && 0 === g.indexOf("application/json");
        }
        function isFormContentType(g) {
            return !!g && 0 === g.indexOf("application/x-www-form-urlencoded");
        }
        function isFormDataContentType(g) {
            return !!g && 0 === g.indexOf("multipart/form-data");
        }
        function DefaultErrorHandler(g, f) {
            return f.canceled || !f.statusCode || f.statusCode >= 400 && f.statusCode < 600 ? C.DoNotRetry : C.RetryCountedWithBackoff;
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), function(g) {
            g[g.DontCare = 0] = "DontCare", g[g.Low = 1] = "Low", g[g.Normal = 2] = "Normal", g[g.High = 3] = "High", g[g.Critical = 4] = "Critical";
        }(v = f.WebRequestPriority || (f.WebRequestPriority = {})), function(g) {
            g[g.DoNotRetry = 0] = "DoNotRetry", g[g.RetryUncountedImmediately = 1] = "RetryUncountedImmediately", g[g.RetryUncountedWithBackoff = 2] = "RetryUncountedWithBackoff", g[g.RetryCountedWithBackoff = 3] = "RetryCountedWithBackoff", g[g.PauseUntilResumed = 4] = "PauseUntilResumed";
        }(C = f.ErrorHandlingType || (f.ErrorHandlingType = {})), f.DefaultOptions = {
            priority: v.Normal
        }, f.SimpleWebRequestOptions = {
            MaxSimultaneousRequests: 5,
            HungRequestCleanupIntervalMs: 1e4,
            setTimeout: function(g, f) {
                return setTimeout(g, f);
            },
            clearTimeout: function(g) {
                return clearTimeout(g);
            }
        }, f.DefaultErrorHandler = DefaultErrorHandler;
        var b, A = [], R = [], P = [], w = 0, M = 0, O = function() {
            function SimpleWebRequestBase(g, S, v, _, C) {
                this._action = g, this._url = S, this.options = v, this._getHeaders = _, this._blockRequestUntil = C, this._aborted = !1, this._timedOut = !1, this._paused = !1, this._created = Date.now(), this._finishHandled = !1, this._retryExponentialTime = new CA.ExponentialTime(1e3, 3e5), this._options = I(I({}, f.DefaultOptions), v);
            }
            return SimpleWebRequestBase.prototype.getPriority = function() {
                return this._options.priority || v.DontCare;
            }, SimpleWebRequestBase.checkQueueProcessing = function() {
                for(var _loop_1 = function() {
                    var g = A.shift();
                    R.push(g), (g._blockRequestUntil && g._blockRequestUntil() || T.Resolved()).finally(function() {
                        _A.remove(R, g);
                    }).then(function() {
                        P.length < f.SimpleWebRequestOptions.MaxSimultaneousRequests && !g._aborted ? (P.push(g), D._scheduleHungRequestCleanupIfNeeded(), g._fire()) : g._enqueue();
                    }, function(f) {
                        g._respond("_blockRequestUntil rejected: " + f);
                    });
                }; A.length > 0 && P.length < f.SimpleWebRequestOptions.MaxSimultaneousRequests;)_loop_1();
            }, SimpleWebRequestBase._scheduleHungRequestCleanupIfNeeded = function() {
                P.length > 0 && void 0 === b ? b = f.SimpleWebRequestOptions.setTimeout(this._hungRequestCleanupTimerCallback, f.SimpleWebRequestOptions.HungRequestCleanupIntervalMs) : 0 === P.length && b && (f.SimpleWebRequestOptions.clearTimeout(b), b = void 0);
            }, SimpleWebRequestBase.prototype._removeFromQueue = function() {
                _A.remove(P, this), _A.remove(A, this);
            }, SimpleWebRequestBase.prototype._assertAndClean = function(g, f) {
                g || (this._removeFromQueue(), console.error(f), _A.assert(g, f));
            }, SimpleWebRequestBase.prototype._fire = function() {
                var g = this;
                this._xhr = new XMLHttpRequest, this._xhrRequestHeaders = {};
                var S = _A.attempt(function() {
                    g._xhr.open(g._action, g._url, !0);
                });
                if (S) this._respond(S.toString());
                else {
                    if (this._options.timeout) {
                        var v = M;
                        3 !== v && (this._assertAndClean(!this._requestTimeoutTimer, "Double-fired requestTimeoutTimer"), this._requestTimeoutTimer = f.SimpleWebRequestOptions.setTimeout(function() {
                            g._requestTimeoutTimer = void 0, g._timedOut = !0, g.abort();
                        }, this._options.timeout)), (3 === v || v <= 1) && (this._xhr.timeout = this._options.timeout, this._xhr.ontimeout = function() {
                            M = 3, 3 === v && (g._timedOut = !0, g._aborted = !0, g._respond("TimedOut"));
                        });
                    }
                    var _ = w;
                    3 !== _ ? (0 === _ && (w = 1), this._xhr.onreadystatechange = function() {
                        g._xhr && (3 !== g._xhr.readyState || !g._options.streamingDownloadProgress || g._aborted ? 4 === g._xhr.readyState && (0 === _ && 1 === w && f.SimpleWebRequestOptions.setTimeout(function() {
                            3 !== w && (w = 2);
                        }, 1e4), g._respond()) : g._options.streamingDownloadProgress(g._xhr.responseText));
                    }) : this._options.streamingDownloadProgress && (this._xhr.onreadystatechange = function() {
                        g._xhr && 3 === g._xhr.readyState && g._options.streamingDownloadProgress && !g._aborted && g._options.streamingDownloadProgress(g._xhr.responseText);
                    }), 2 !== _ && (this._xhr.onload = function() {
                        w = 3, 3 === _ && g._respond();
                    }, this._xhr.onerror = function() {
                        w = 3, 3 === _ && g._respond();
                    }), this._xhr.onabort = function() {
                        g._aborted = !0, g._respond("Aborted");
                    }, this._xhr.upload && this._options.onProgress && (this._xhr.upload.onprogress = this._options.onProgress);
                    var C = this._options.acceptType || "json", E = this._options.customResponseType || SimpleWebRequestBase._getResponseType(C), T = _A.attempt(function() {
                        g._xhr.responseType = E;
                    });
                    if (T && "json" !== E) throw T;
                    D._setRequestHeader(this._xhr, this._xhrRequestHeaders, "Accept", SimpleWebRequestBase.mapContentType(C)), this._xhr.withCredentials = !!this._options.withCredentials;
                    var I = this.getRequestHeaders(), b = {};
                    if (Object.keys(I).forEach(function(f) {
                        var S = I[f], v = f.toLowerCase();
                        "content-type" !== v ? "accept" !== v ? (g._assertAndClean(!b[v], "Setting duplicate header key: " + b[v] + " and " + f), null != S ? (b[v] = !0, D._setRequestHeader(g._xhr, g._xhrRequestHeaders, f, S)) : console.warn('Tried to set header "' + f + '" on request with "' + S + '" value, header will be dropped')) : g._assertAndClean(!1, "Don't set Accept with options.headers -- use it with the options.acceptType property") : g._assertAndClean(!1, "Don't set Content-Type with options.headers -- use it with the options.contentType property");
                    }), this._options.sendData) {
                        var A = SimpleWebRequestBase.mapContentType(this._options.contentType || "json");
                        D._setRequestHeader(this._xhr, this._xhrRequestHeaders, "Content-Type", A);
                        var R = SimpleWebRequestBase.mapBody(this._options.sendData, A);
                        this._xhr.send(R);
                    } else this._xhr.send();
                }
            }, SimpleWebRequestBase._setRequestHeader = function(g, f, S, v) {
                g.setRequestHeader(S, v), f[S] = v;
            }, SimpleWebRequestBase.mapContentType = function(g) {
                return "json" === g ? "application/json" : "form" === g ? "application/x-www-form-urlencoded" : g;
            }, SimpleWebRequestBase.mapBody = function(g, f) {
                if (isJsonContentType(f)) {
                    if (!_A.isString(g)) return JSON.stringify(g);
                } else if (isFormContentType(f)) {
                    if (!_A.isString(g) && _A.isObject(g)) {
                        var S = g;
                        return Object.keys(S).map(function(g) {
                            return encodeURIComponent(g) + (S[g] ? "=" + encodeURIComponent(S[g].toString()) : "");
                        }).join("&");
                    }
                } else if (isFormDataContentType(f)) {
                    if (_A.isObject(g)) {
                        var v = new FormData, _ = g;
                        return Object.keys(_).forEach(function(g) {
                            return v.append(g, _[g]);
                        }), v;
                    }
                    _A.assert(!1, "contentType multipart/form-data must include an object as sendData");
                }
                return g;
            }, SimpleWebRequestBase.prototype.setUrl = function(g) {
                this._url = g;
            }, SimpleWebRequestBase.prototype.setHeader = function(g, f) {
                this._options.augmentHeaders || (this._options.augmentHeaders = {}), f ? this._options.augmentHeaders[g] = f : delete this._options.augmentHeaders[g];
            }, SimpleWebRequestBase.prototype.getRequestHeaders = function() {
                var g = {};
                return !this._getHeaders || this._options.overrideGetHeaders || this._options.headers || (g = I(I({}, g), this._getHeaders())), this._options.overrideGetHeaders && (g = I(I({}, g), this._options.overrideGetHeaders)), this._options.headers && (g = I(I({}, g), this._options.headers)), this._options.augmentHeaders && (g = I(I({}, g), this._options.augmentHeaders)), g;
            }, SimpleWebRequestBase.prototype.getOptions = function() {
                return _A.clone(this._options);
            }, SimpleWebRequestBase.prototype.setPriority = function(g) {
                this._options.priority !== g && (this._options.priority = g, this._paused || this._xhr || (_A.remove(A, this), this._enqueue()));
            }, SimpleWebRequestBase.prototype.resumeRetrying = function() {
                this._paused ? (this._paused = !1, this._enqueue()) : _A.assert(!1, "resumeRetrying() called but not paused!");
            }, SimpleWebRequestBase.prototype._enqueue = function() {
                var g = this;
                if (!this._aborted && !(P.indexOf(this) >= 0 || R.indexOf(this) >= 0 || A.indexOf(this) >= 0)) {
                    var f = A.findIndex(function(f) {
                        return f.getPriority() === g.getPriority() && f._created > g._created || f.getPriority() < g.getPriority();
                    });
                    f > -1 ? A.splice(f, 0, this) : A.push(this), SimpleWebRequestBase.checkQueueProcessing();
                }
            }, SimpleWebRequestBase._getResponseType = function(g) {
                return "blob" === g ? "arraybuffer" : "text/xml" === g || "application/xml" === g ? "document" : "text/plain" === g ? "text" : "json";
            }, SimpleWebRequestBase._hungRequestCleanupTimerCallback = function() {
                b = void 0, P.filter(function(g) {
                    return !(!g._xhr || 4 !== g._xhr.readyState) && (console.warn("SimpleWebRequests found a completed XHR that hasn't invoked it's callback functions, manually responding"), !0);
                }).forEach(function(g) {
                    g._respond();
                }), D._scheduleHungRequestCleanupIfNeeded();
            }, SimpleWebRequestBase;
        }();
        f.SimpleWebRequestBase = O;
        var D = function(g) {
            function SimpleWebRequest(f, S, v, _, C) {
                return g.call(this, f, S, v, _, C) || this;
            }
            return E(SimpleWebRequest, g), SimpleWebRequest.prototype.abort = function() {
                this._aborted ? _A.assert(!1, "Already aborted " + this._action + " request to " + this._url) : (this._aborted = !0, this._retryTimer && (f.SimpleWebRequestOptions.clearTimeout(this._retryTimer), this._retryTimer = void 0), this._requestTimeoutTimer && (f.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer), this._requestTimeoutTimer = void 0), this._deferred ? (this._respond("Aborted"), this._xhr && this._xhr.abort()) : _A.assert(!1, "Haven't even fired start() yet -- can't abort"));
            }, SimpleWebRequest.prototype.start = function() {
                var g = this;
                return this._deferred ? (_A.assert(!1, "WebRequest already started"), T.Rejected("WebRequest already started")) : (this._deferred = T.Defer(), this._deferred.onCancel(function() {
                    g.abort();
                }), this._enqueue(), this._deferred.promise());
            }, SimpleWebRequest.prototype._respond = function(g) {
                var S = this;
                if (!this._finishHandled) {
                    this._finishHandled = !0, this._removeFromQueue(), this._retryTimer && (f.SimpleWebRequestOptions.clearTimeout(this._retryTimer), this._retryTimer = void 0), this._requestTimeoutTimer && (f.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer), this._requestTimeoutTimer = void 0);
                    var v, _ = 0;
                    if (this._xhr) try {
                        _ = this._xhr.status, v = this._xhr.statusText || g;
                    } catch (g) {}
                    else v = g || "Browser Error - Possible CORS or Connectivity Issue";
                    var E, T, I = {};
                    if (this._xhr) {
                        if ((this._xhr.getAllResponseHeaders() || "").split(/\r?\n/).forEach(function(g) {
                            if (0 !== g.length) {
                                var f = g.indexOf(":");
                                -1 === f ? I[g] = "" : I[g.substr(0, f).toLowerCase()] = g.substr(f + 1).trim();
                            }
                        }), !I["content-type"]) {
                            var b = this._xhr.getResponseHeader("content-type");
                            b && (I["content-type"] = b);
                        }
                        if (E = this._xhr.response, I["content-type"] && isJsonContentType(I["content-type"]) && (!E || !_A.isObject(E)) && ("text" === this._xhr.responseType || "" === this._xhr.responseType) && this._xhr.responseText) try {
                            E = JSON.parse(this._xhr.responseText);
                        } catch (g) {
                            T = g, console.warn("Failed to parse XHR JSON response");
                        }
                    }
                    if (this._xhr && 4 === this._xhr.readyState && (_ >= 200 && _ < 300 || 304 === _)) {
                        var A = {
                            url: this._xhr.responseURL || this._url,
                            method: this._action,
                            requestOptions: this._options,
                            requestHeaders: this._xhrRequestHeaders || {},
                            statusCode: _,
                            statusText: v,
                            headers: I,
                            body: E,
                            responseParsingException: T
                        };
                        this._deferred.resolve(A);
                    } else {
                        var R = {
                            url: (this._xhr ? this._xhr.responseURL : void 0) || this._url,
                            method: this._action,
                            requestOptions: this._options,
                            requestHeaders: this._xhrRequestHeaders || {},
                            statusCode: _,
                            statusText: v,
                            headers: I,
                            body: E,
                            canceled: this._aborted,
                            timedOut: this._timedOut,
                            responseParsingException: T
                        };
                        this._options.augmentErrorResponse && this._options.augmentErrorResponse(R);
                        var P = this._options.customErrorHandler ? this._options.customErrorHandler(this, R) : DefaultErrorHandler(this, R);
                        P !== C.DoNotRetry && (this._options.retries && this._options.retries > 0 || P === C.PauseUntilResumed || P === C.RetryUncountedImmediately || P === C.RetryUncountedWithBackoff) ? (P === C.RetryCountedWithBackoff && this._options.retries--, this._requestTimeoutTimer && (f.SimpleWebRequestOptions.clearTimeout(this._requestTimeoutTimer), this._requestTimeoutTimer = void 0), this._aborted = !1, this._timedOut = !1, this._finishHandled = !1, this._xhr && (this._xhr.onabort = null, this._xhr.onerror = null, this._xhr.onload = null, this._xhr.onprogress = null, this._xhr.onreadystatechange = null, this._xhr.ontimeout = null, this._xhr = void 0, this._xhrRequestHeaders = void 0), P === C.PauseUntilResumed ? this._paused = !0 : P === C.RetryUncountedImmediately ? this._enqueue() : this._retryTimer = f.SimpleWebRequestOptions.setTimeout(function() {
                            S._retryTimer = void 0, S._enqueue();
                        }, this._retryExponentialTime.getTimeAndCalculateNext())) : this._deferred.reject(R);
                    }
                    O.checkQueueProcessing();
                }
            }, SimpleWebRequest;
        }(O);
        f.SimpleWebRequest = D;
    }), EA = createCommonjsModule(function(g, f) {
        var S = _ && _.__assign || function() {
            return S = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, S.apply(this, arguments);
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var v = function() {
            function GenericRestClient(g) {
                this._defaultOptions = {
                    excludeEndpointUrl: !1,
                    withCredentials: !1,
                    retries: 0
                }, this._endpointUrl = g;
            }
            return GenericRestClient.prototype._performApiCall = function(g, f, v, _) {
                var C = this;
                void 0 === _ && (_ = {});
                var E = S(S({}, this._defaultOptions), _);
                v && (E.sendData = v), E.eTag && (E.augmentHeaders || (E.augmentHeaders = {}), E.augmentHeaders["If-None-Match"] = E.eTag), E.contentType || (E.contentType = _A.isString(E.sendData) ? "form" : "json");
                var T = E.excludeEndpointUrl ? g : this._endpointUrl + g;
                return new yA.SimpleWebRequest(f, T, E, function() {
                    return C._getHeaders(E);
                }, function() {
                    return C._blockRequestUntil(E);
                }).start().then(function(g) {
                    return C._processSuccessResponse(g), g;
                });
            }, GenericRestClient.prototype._getHeaders = function(g) {
                return {};
            }, GenericRestClient.prototype._blockRequestUntil = function(g) {}, GenericRestClient.prototype._processSuccessResponse = function(g) {}, GenericRestClient.prototype.performApiGet = function(g, f) {
                return this.performApiGetDetailed(g, f).then(function(g) {
                    return g.body;
                });
            }, GenericRestClient.prototype.performApiGetDetailed = function(g, f) {
                return this._performApiCall(g, "GET", void 0, f);
            }, GenericRestClient.prototype.performApiPost = function(g, f, S) {
                return this.performApiPostDetailed(g, f, S).then(function(g) {
                    return g.body;
                });
            }, GenericRestClient.prototype.performApiPostDetailed = function(g, f, S) {
                return this._performApiCall(g, "POST", f, S);
            }, GenericRestClient.prototype.performApiPatch = function(g, f, S) {
                return this.performApiPatchDetailed(g, f, S).then(function(g) {
                    return g.body;
                });
            }, GenericRestClient.prototype.performApiPatchDetailed = function(g, f, S) {
                return this._performApiCall(g, "PATCH", f, S);
            }, GenericRestClient.prototype.performApiPut = function(g, f, S) {
                return this.performApiPutDetailed(g, f, S).then(function(g) {
                    return g.body;
                });
            }, GenericRestClient.prototype.performApiPutDetailed = function(g, f, S) {
                return this._performApiCall(g, "PUT", f, S);
            }, GenericRestClient.prototype.performApiDelete = function(g, f, S) {
                return this.performApiDeleteDetailed(g, f, S).then(function(g) {
                    return g.body;
                });
            }, GenericRestClient.prototype.performApiDeleteDetailed = function(g, f, S) {
                return this._performApiCall(g, "DELETE", f, S);
            }, GenericRestClient;
        }();
        f.GenericRestClient = v;
    }), TA = createCommonjsModule(function(g, f) {
        function __export(g) {
            for(var S in g)f.hasOwnProperty(S) || (f[S] = g[S]);
        }
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), __export(CA), __export(EA), __export(yA);
    }), IA = TA, bA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function TelemetryEventBase() {}
            return TelemetryEventBase.prototype.getAttributes = function() {
                return {
                    Source: "ecs_client"
                };
            }, TelemetryEventBase;
        }();
        f.TelemetryEventBase = S;
    }), AA = createCommonjsModule(function(g, f) {
        var S, v = _ && _.__extends || (S = function(g, f) {
            return S = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(g, f) {
                g.__proto__ = f;
            } || function(g, f) {
                for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
            }, S(g, f);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        });
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var C = function(g) {
            function EcsConfigFetchResponse(f, S, v, _, C, E, T, I, b, A, R, P, w) {
                var M = g.call(this) || this;
                return M._responseTime = f, M._responseCode = S, M._fetchAttempts = v, M._hasValidToken = _, M._serverEndpoint = C, M._etag = E, M._fetchDurationValid = T, M._cacheAvailable = I, M._responseSize = b, M._configAge = A, M._configExpired = R, M._fetchStart = P, M._fetchEnd = w, M;
            }
            return v(EcsConfigFetchResponse, g), EcsConfigFetchResponse.prototype.getEventName = function() {
                return "ecs_tsclient_fetch_config";
            }, EcsConfigFetchResponse.prototype.getAttributes = function() {
                var f = g.prototype.getAttributes.call(this);
                return f.fetch_delay_ms = this._responseTime, f.fetch_response_code = this._responseCode, f.fetch_attempts = this._fetchAttempts, f.authenticated_user = this._hasValidToken, f.url = this._serverEndpoint, f.fetched_etag = this._etag, f.fetch_duration_valid = this._fetchDurationValid, f.cache_available = this._cacheAvailable, f.response_size = this._responseSize, f.config_age = this._configAge, f.config_expired = this._configExpired, f.fetch_start = this._fetchStart, f.fetch_end = this._fetchEnd, f;
            }, EcsConfigFetchResponse;
        }(bA.TelemetryEventBase);
        f.EcsConfigFetchResponse = C;
    }), RA = createCommonjsModule(function(g, f) {
        var S, v = _ && _.__extends || (S = function(g, f) {
            return S = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(g, f) {
                g.__proto__ = f;
            } || function(g, f) {
                for(var S in f)f.hasOwnProperty(S) && (g[S] = f[S]);
            }, S(g, f);
        }, function(g, f) {
            function __() {
                this.constructor = g;
            }
            S(g, f), g.prototype = null === f ? Object.create(f) : (__.prototype = f.prototype, new __);
        }), C = _ && _.__assign || function() {
            return C = Object.assign || function(g) {
                for(var f, S = 1, v = arguments.length; S < v; S++)for(var _ in f = arguments[S])Object.prototype.hasOwnProperty.call(f, _) && (g[_] = f[_]);
                return g;
            }, C.apply(this, arguments);
        };
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var E, I, b = 1728e5, A = 18e5, R = 31536e6, P = 3e4, w = function(g) {
            function EcsFetcher(f, S, v, _, C, E, T, I) {
                var b = g.call(this, f) || this;
                if (b._config = S, b._skypeTokenData = v, b._appActiveData = _, b._allowBackgroundFetchData = C, b._etag = E, b._getUserConfig = T, b._apiPath = "/config/v1/" + b._config.getConfig().clientName + "/" + b._config.getConfig().clientVersion, I) {
                    var A = Object.keys(I).map(function(g) {
                        return encodeURIComponent(g) + "=" + encodeURIComponent(I[g].toString());
                    });
                    A && (b._apiPath += "?" + A.join("&"));
                }
                return b;
            }
            return v(EcsFetcher, g), EcsFetcher.prototype._blockRequestUntil = function(g) {
                var f = this;
                if (this._getUserConfig && !this._skypeTokenData.isSkypeTokenValid() && console.log("ECS - Delaying User config fetch until we have a valid SkypeToken"), !this._appActiveData.isAppActive() && !this._allowBackgroundFetchData.isBackgroundFetchAllowed()) {
                    var S = this._getUserConfig ? "User config" : "config";
                    console.log("ECS - Delaying " + S + " fetch until the app is active (or background fetch is allowed)");
                }
                return T.race([
                    this._appActiveData.waitForAppActive(),
                    this._allowBackgroundFetchData.waitForBackgroundFetchAllowed()
                ]).then(function() {
                    if (f._getUserConfig) return f._skypeTokenData.waitForValidSkypeToken();
                }).then(function() {
                    I = Date.now();
                });
            }, EcsFetcher.prototype._getHeaders = function() {
                var g = {};
                return this._etag && (g["If-None-Match"] = this._etag), this._getUserConfig && (g.Authorization = this._skypeTokenData.getSkypeToken()), g;
            }, EcsFetcher.prototype.getConfig = function() {
                var f = this._config.getConfig().fetchTimeout;
                return void 0 !== f && (f < 0 ? f = 0 : f > 0 && f < P && (f = P)), g.prototype.performApiGetDetailed.call(this, this._apiPath, {
                    timeout: f
                });
            }, EcsFetcher;
        }(IA.GenericRestClient), M = function() {
            function EcsClient(g, f, S, v, _) {
                this._config = g, this._skypeTokenData = f, this._appActiveData = S, this._allowBackgroundFetchData = v, this._telemetryManager = _, this._ecsFailureBackoffTimer = new IA.ExponentialTime(1e3, 3e5), this._cacheMaxAgeRegex = /.*max-age=(\d+).*/gi, this._serverIndex = NaN;
            }
            return EcsClient.prototype.getConfig = function(g, f, S) {
                var v = this, _ = this._config.getConfig().hosts;
                if ((isNaN(this._serverIndex) || this._serverIndex > _.length - 1) && (this._serverIndex = Math.floor(Math.random() * _.length)), !_ || !_.length) return T.Rejected(new Error("no configuration service endpoint"));
                var b = T.Defer(), A = 0, callConfigServer = function() {
                    var P = g && g.eTag ? g.eTag : void 0, M = new w(_[v._serverIndex], v._config, v._skypeTokenData, v._appActiveData, v._allowBackgroundFetchData, P, f, S);
                    A++, M.getConfig().then(function(S) {
                        var w = S.headers.etag, M = S.headers.expires;
                        if (S.body && S.body.Headers && (w || (w = S.body.Headers.ETag), M || (M = S.body.Headers.Expires)), E = Date.now(), !w || !M) return console.warn("ECS - Service returned an empty ETag or Expiration header: " + JSON.stringify(S)), T.Rejected();
                        var O, D = new Date(v._calculateExpirationDate(S.headers)).getTime();
                        if (304 === S.statusCode && g) (O = C({}, g)).eTag = w, O.expiration = D, O.cacheUpdateTime = E, O.lastFetchTokenHash = v._skypeTokenData.getSkypeTokenHash(S.requestHeaders.Authorization);
                        else {
                            if ("object" != typeof S.body) return console.warn("ECS - Service returned invalid response " + JSON.stringify(S)), T.Rejected();
                            O = {
                                config: S.body,
                                configType: f ? mA.EcsConfigType.User : mA.EcsConfigType.Default,
                                eTag: w,
                                expiration: D,
                                cacheUpdateTime: I,
                                lastFetchTokenHash: v._skypeTokenData.getSkypeTokenHash(S.requestHeaders.Authorization),
                                appVersion: v._config.getConfig().clientVersion
                            };
                        }
                        var N = E - I, k = !(N < 0 || N > R), L = g ? Date.now() - g.cacheUpdateTime : 0;
                        v._telemetryManager.sendTelemetryEvent(new AA.EcsConfigFetchResponse(N, S.statusCode, A, v._skypeTokenData.isSkypeTokenValid(), _[v._serverIndex], w, k, !!P, JSON.stringify(S).length, L, !(g && g.expiration - Date.now() > 0), I, E)), v._ecsFailureBackoffTimer.reset(), b.resolve(O);
                    }).catch(function() {
                        v._serverIndex = (v._serverIndex + 1) % _.length, setTimeout(function() {
                            callConfigServer();
                        }, v._ecsFailureBackoffTimer.getTimeAndCalculateNext());
                    });
                };
                return callConfigServer(), b.promise();
            }, EcsClient.prototype._calculateExpirationDate = function(g) {
                var f = Date.now() + b;
                if (g.date && g.expires) {
                    var S = new Date(g.date).getTime(), v = Date.now() - S, _ = new Date(g.expires).getTime();
                    return isNaN(_) ? f : Math.min(f, _ + v);
                }
                var C = this._cacheMaxAgeRegex.exec(g["cache-control"]);
                return this._cacheMaxAgeRegex.lastIndex = 0, C && 2 === C.length ? Math.min(f, Date.now() + 1e3 * Number(C[1])) : Date.now() + A;
            }, EcsClient;
        }();
        f.default = M;
    }), PA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function Scheduler(g, f, S, v, _, C) {
                var E = this;
                this._config = g, this._skypeTokenData = f, this._cache = S, this._isFetchingSettings = {}, this._pendingFetch = {}, this._paused = !1, this._fetchEcsSettingsIfNeeded = function(g) {
                    var f = E._config.getConfig(), S = E._cache.getEcsConfigByType(g);
                    if (-1 !== f.configsToFetch.indexOf(g) && !E._isFetchingSettings[g]) {
                        if (S || !E._pendingFetch[g]) {
                            var v = S ? S.expiration - Date.now() : -1;
                            v <= 0 || S && g === mA.EcsConfigType.User && E._skypeTokenData.isSkypeTokenValid() && S.lastFetchTokenHash !== E._skypeTokenData.getSkypeTokenHash(E._skypeTokenData.getSkypeToken()) ? E._fetchSkypeEcsSettings(g) : setTimeout(function() {
                                return E._fetchEcsSettingsIfNeeded(g);
                            }, v);
                        } else E._fetchSkypeEcsSettings(g);
                    }
                }, this._fetchSkypeEcsSettings = function(g, f) {
                    (void 0 === f && (f = !1), E._isFetchingSettings[g] || E._paused && !f) ? E._pendingFetch[g] = !0 : (E._pendingFetch[g] = !1, E._isFetchingSettings[g] = !0, E._config.getConfig().getEcsParameters().catch(function() {
                        return console.warn("ECS - Failed to fetch ECS fetching parameters"), {};
                    }).then(function(f) {
                        return E._ecsClient.getConfig(E._cache.getEcsConfig(), g === mA.EcsConfigType.User, f);
                    }).then(function(f) {
                        console.log("ECS - Config fetch complete"), E._isFetchingSettings[g] = !1, E._cache.putConfig(f), E._fetchEcsSettingsIfNeeded(g);
                    }));
                }, this._ecsClient = new RA.default(this._config, this._skypeTokenData, v, _, C);
            }
            return Scheduler.prototype.initialize = function() {
                var g = this;
                this.updateConfigsToFetch(), this._skypeTokenData.skypeTokenChanged.subscribe(function() {
                    return g._fetchEcsSettingsIfNeeded(mA.EcsConfigType.User);
                });
            }, Scheduler.prototype.updateConfigsToFetch = function() {
                for(var g = this._config.getConfig(), f = 0, S = g.configsToFetch; f < S.length; f++)(C = S[f]) in this._isFetchingSettings || (this._isFetchingSettings[C] = !1), C in this._isFetchingSettings || (this._pendingFetch[C] = !1);
                for(var v = 0, _ = g.configsToFetch; v < _.length; v++){
                    var C = _[v], E = this._cache.getEcsConfigByType(C);
                    !E || E.appVersion && E.appVersion !== g.clientVersion ? this._fetchSkypeEcsSettings(C, !0) : this._fetchEcsSettingsIfNeeded(C);
                }
            }, Scheduler.prototype.requestUpdate = function() {
                for(var g = 0, f = this._config.getConfig().configsToFetch; g < f.length; g++){
                    var S = f[g];
                    this._fetchSkypeEcsSettings(S);
                }
            }, Scheduler.prototype.pause = function() {
                this._paused = !0;
            }, Scheduler.prototype.resume = function() {
                this._paused = !1;
                for(var g = 0, f = this._config.getConfig().configsToFetch; g < f.length; g++){
                    var S = f[g];
                    this._fetchEcsSettingsIfNeeded(S);
                }
            }, Scheduler;
        }();
        f.default = S;
    }), wA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function SkypeTokenData() {
                this.skypeTokenChanged = new fA.default;
            }
            return SkypeTokenData.prototype.putSkypeTokenData = function(g) {
                if (this._data = g, this.isSkypeTokenValid() && this.skypeTokenChanged.fire(), this.isSkypeTokenValid() && this._validSkypeTokenDeferral) {
                    var f = this._validSkypeTokenDeferral;
                    this._validSkypeTokenDeferral = void 0, f.resolve(void 0);
                }
            }, SkypeTokenData.prototype.isSkypeTokenValid = function() {
                var g = this._data;
                return !!g && !!g.skypeToken && g.skypeTokenExpiration > Date.now();
            }, SkypeTokenData.prototype.getSkypeToken = function() {
                var g = this._data;
                if (!g || !g.skypeToken) throw "No Skype Token provided";
                return g.skypeToken;
            }, SkypeTokenData.prototype.getSkypeTokenHash = function(g) {
                return void 0 === g ? 0 : g.split("").reduce(function(g, f) {
                    return (101 * g + f.charCodeAt(0)) % 999727999;
                }, g.length);
            }, SkypeTokenData.prototype.waitForValidSkypeToken = function() {
                return this.isSkypeTokenValid() ? T.Resolved() : (this._validSkypeTokenDeferral || (this._validSkypeTokenDeferral = T.Defer()), this._validSkypeTokenDeferral.promise());
            }, SkypeTokenData;
        }();
        f.default = S;
    }), MA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        });
        var S = function() {
            function TelemetryManager(g) {
                this._cache = g, this.telemetryEventAdded = new fA.default;
            }
            return TelemetryManager.prototype.sendTelemetryEvent = function(g) {
                var f = g.getEventName(), S = g.getAttributes(), v = !1, _ = this._cache.getEcsConfig();
                if (_ && TelemetryManager._containsEcsClientTelemetryConfig(_.config)) {
                    var C = _.config.ECSCONFIG;
                    C && C.ecsClientTelemetry && (v = !!C.ecsClientTelemetry[f]);
                }
                v && this.telemetryEventAdded.fire(f, S);
            }, TelemetryManager._containsEcsClientTelemetryConfig = function(g) {
                return !!g && !!g.ECSCONFIG && !!g.ECSCONFIG.ecsClientTelemetry;
            }, TelemetryManager;
        }();
        f.default = S;
    }), OA = createCommonjsModule(function(g, f) {
        Object.defineProperty(f, "__esModule", {
            value: !0
        }), f.Models = mA;
        var S = function() {
            function EcsClient() {
                this._allowBackgroundFetchData = new dA.default, this._appActiveData = new uA.default, this._config = new vA.default, this._cache = new SA.default(this._config), this._skypeTokenData = new wA.default, this._telemetryManager = new MA.default(this._cache), this._scheduler = new PA.default(this._config, this._skypeTokenData, this._cache, this._appActiveData, this._allowBackgroundFetchData, this._telemetryManager), this.telemetryEventAdded = this._telemetryManager.telemetryEventAdded, this.configUpdated = this._cache.configUpdated;
            }
            return EcsClient.prototype.initialize = function(g) {
                var f = this;
                return this._config.initialize(g), this._skypeTokenData.putSkypeTokenData(g.initialSkypeTokenData), this._appActiveData.putAppActive(g.initialAppActiveState), this._cache.initialize().then(function() {
                    f._scheduler.initialize();
                });
            }, EcsClient.prototype.getConfig = function() {
                return this._cache.getEcsConfig();
            }, EcsClient.prototype.getConfigType = function() {
                var g = this._cache.getEcsConfig();
                if (g) return g.configType;
            }, EcsClient.prototype.requestUpdate = function() {
                this._scheduler.requestUpdate();
            }, EcsClient.prototype.pause = function() {
                this._scheduler.pause();
            }, EcsClient.prototype.resume = function() {
                this._scheduler.resume();
            }, EcsClient.prototype.setAllowBackgroundFetch = function(g) {
                this._allowBackgroundFetchData.putBackgroundFetchAllowed(g);
            }, EcsClient.prototype.useSkypeToken = function(g, f) {
                this._skypeTokenData.putSkypeTokenData({
                    skypeToken: g,
                    skypeTokenExpiration: f
                });
            }, EcsClient.prototype.setAppActive = function(g) {
                this._appActiveData.putAppActive(g);
            }, EcsClient.prototype.setConfigsToFetch = function(g) {
                var f = this;
                return this._config.setConfigsToFetch(g), this._cache.updateConfigsToFetch().then(function() {
                    f._scheduler.updateConfigsToFetch();
                });
            }, EcsClient.prototype.setFetchTimeout = function(g) {
                this._config.setFetchTimeout(g);
            }, EcsClient;
        }();
        f.default = S;
    }), DA = getDefaultExportFromCjs(OA);
    class EcsSkypeToken {
        constructor(g, f){
            this.skypeToken = g, this.skypeTokenExpiration = f;
        }
    }
    class EcsConfigFetcher {
        subscribeEcsConfig(g) {
            return g.configType !== oA.Default && g.configType !== oA.User ? Promise.reject(em) : (this._resetConfigCache(g), this._initialized || this._isSubscribed ? Promise.reject(im) : Promise.resolve(this._initializeEcsConfig(g).then(()=>{
                this._ecsClient.configUpdated.subscribe(()=>{
                    if (this._isSubscribed = !0, this._config = this._ecsClient.getConfig(), g.ecsConfigReceiver && this._config) {
                        if (g.ecsConfigReceiver(this._config.config) ? this._counter = 0 : this._counter += 1, this._counter > 3) try {
                            this._ecsClient.pause(), this._counter = 0, this._resumeCounter *= 2, window.setTimeout(()=>{
                                this._disposed || this._ecsClient.resume();
                            }, this._resumeCounter);
                        } catch (g) {
                            this._logger.warn("Failed to retry fetch ECS");
                        }
                    }
                });
            }).catch((g)=>{
                this._logger.warn("Failed to initialize ECS config because: " + g);
            })));
        }
        setConfigsToFetch(g) {
            return this._ecsClient.setConfigsToFetch(g);
        }
        dispose() {
            try {
                this._ecsClient.configUpdated.dispose(), this._disposed = !0;
            } catch (g) {
                this._logger.warn(`Failed to dispose ECS config update, e=${g}`);
            }
        }
        getConfigType() {
            if (void 0 !== this._configDefCache) return this._ecsClient.getConfigType();
        }
        getETag() {
            return void 0 === this._config ? "" : this._config.eTag;
        }
        getConfigId(g) {
            return void 0 === this._config ? Promise.reject(tm) : Promise.resolve(this._config.config[Zp][g]);
        }
        setAllowBackgroundFetch(g) {
            return this._ecsClient.setAllowBackgroundFetch(g), Promise.resolve();
        }
        setSkypeToken(g, f) {
            return this._ecsClient.useSkypeToken(g, f), Promise.resolve();
        }
        setAppActiveState(g) {
            return this._ecsClient.setAppActive(g), Promise.resolve();
        }
        _resetConfigCache(g) {
            void 0 === g || void 0 === this._configDefCache || g.queryParameters === this._configDefCache.queryParameters && g.configType === this._configDefCache.configType || (this._isSubscribed = !1, this._initialized = !1, this._config = void 0), this._configDefCache = g;
        }
        _initializeEcsConfig(g) {
            this._initialized = !0;
            const f = {
                hosts: g.ecsHosts ? g.ecsHosts : this._getHostUrls(g.caConfigBag),
                clientName: Xp,
                clientVersion: this._getClientVersion(g.platformId),
                configsToFetch: this._getLibConfigType(g.configType),
                getEcsParameters: ()=>this._getQueryParameterPromise(g.queryParameters),
                initialAppActiveState: g.isAppInitiallyInForeground,
                initialSkypeTokenData: new EcsSkypeToken(g.userRawSkypeToken, g.userSkypeTokenExpiration)
            };
            return new Promise((g, S)=>{
                this._ecsClient.initialize(f).then(g, S);
            });
        }
        _getHostUrls(g) {
            let f;
            if (g) {
                if (g.identityType === um.Enterprise) f = cm.Enterprise_Ecs_ServerUrl;
                else switch(g.cloudType){
                    case rm.Public:
                        f = cm.Public_EcsServer_Url;
                        break;
                    case rm.Dod:
                        f = cm.Dod_EcsServer_Url;
                        break;
                    case rm.GccHigh:
                        f = cm.GccHigh_EcsServer_Url;
                        break;
                    case rm.AirGap08:
                        f = cm.AirGap08_EcsServer_Url;
                        break;
                    case rm.AirGap09:
                        f = cm.AirGap09_EcsServer_Url;
                        break;
                    default:
                        f = cm.Public_EcsServer_Url;
                }
            } else f = cm.Public_EcsServer_Url;
            return [
                this._acsProxy.proxyfyUrl(f)
            ];
        }
        _getClientVersion(g) {
            let f = "";
            return f += g || getPlatformId(), f += "_", f += getSdkInternalVersion(), f;
        }
        _getLibConfigType(g) {
            return [
                g === oA.Default ? OA.Models.EcsConfigType.Default : OA.Models.EcsConfigType.User
            ];
        }
        _getQueryParameterPromise(g = {}) {
            return T.Resolved(g);
        }
        constructor(g, f, S){
            this._logger = g, this._acsProxy = f, this._counter = 0, this._resumeCounter = 3e3, this._disposed = !1, this._ecsClient = S || new DA, this._isSubscribed = this._initialized = !1;
        }
    }
    var NA, __decorate$q = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$q = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class CallStack {
        getClientId() {
            return this.clientId;
        }
        getTrouterState() {
            var _this__trouterService, _this;
            const g = (_this = this) === null || _this === void 0 ? void 0 : (_this__trouterService = _this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.state();
            return this.mapTsTrouterState(g);
        }
        getEcsConfigIds() {
            return this._ecsProvider.getConfigIds();
        }
        isRegistered() {
            var _this__trouterService;
            var _this__trouterService_isRegistered;
            return (_this__trouterService_isRegistered = (_this__trouterService = this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.isRegistered()) !== null && _this__trouterService_isRegistered !== void 0 ? _this__trouterService_isRegistered : !1;
        }
        onRegisteredChanged(g) {
            var _this__trouterService;
            (_this__trouterService = this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.onRegisteredChanged(g);
        }
        offRegisteredChanged(g) {
            var _this__trouterService;
            (_this__trouterService = this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.offRegisteredChanged(g);
        }
        onTrouterStateChanged(g) {
            var _this__trouterService;
            const tsTrouterStateChangedListener = (f, S)=>{
                g(this.mapTsTrouterState(f));
            };
            return (_this__trouterService = this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.onStateChanged(tsTrouterStateChangedListener), this._trouterStateChangedListenersRegistered.set(g, tsTrouterStateChangedListener), {
                listener: g,
                tsTrouterStateChangedListener: tsTrouterStateChangedListener
            };
        }
        offTrouterStateChanged(g) {
            var _this__trouterService;
            const f = this._trouterStateChangedListenersRegistered.get(g);
            if (f) return (_this__trouterService = this._trouterService) === null || _this__trouterService === void 0 ? void 0 : _this__trouterService.offStateChanged(f), this._trouterStateChangedListenersRegistered.delete(g), {
                listener: g,
                tsTrouterStateChangedListener: f
            };
        }
        mapTsTrouterState(g) {
            let f = "Uninitialized";
            if (void 0 !== g) switch(g){
                case 0:
                    f = "Unknown";
                    break;
                case 2:
                    f = "Connected";
                    break;
                case 3:
                    f = "Disconnected";
                    break;
                case 9:
                    f = "Switching";
            }
            return f;
        }
        get webcvProvider() {
            return this._webcvProvider;
        }
        get wasmvqeProvider() {
            return this._wasmvqeProvider;
        }
        get videoEffectsStatusManager() {
            return this._videoEffectsStatusManager;
        }
        get audioEffectsStatusManager() {
            return this._audioEffectsStatusManager;
        }
        async createStackBase(g) {
            if (this._createStackBaseWaitPromise) return this._createStackBaseWaitPromise;
            const f = new Promise(async (f, S)=>{
                try {
                    const S = this._getBaseStackConfig();
                    this._tsStack = await w.pluginlessStackFactory.buildBaseStack(S), await this.initializeEcsBase(g), f(this._tsStack);
                } catch (g) {
                    S(g);
                }
            });
            try {
                this._createStackBaseWaitPromise = wait(()=>f, bm);
                const g = await this._createStackBaseWaitPromise;
                return this.logger.log("Base stack init success"), g;
            } catch (g) {
                throw await this.dispose(), g.code === k ? new CallingCommunicationError({
                    defaultError: O.CALL_STACK.BASE_STACK_INIT_TIMEOUT
                }) : new CallingCommunicationError({
                    defaultError: O.CALL_STACK.BASE_STACK_INIT_FAILED,
                    originalError: g
                });
            }
        }
        async initializeStackForUser(g, f) {
            if (this.caConfigBag = f, this._initializeStackForUserWaitPromise) return this._initializeStackForUserWaitPromise;
            this._tsStack = await this.createStackBase(f), this._disposed = !1;
            const S = new Promise(async (S, v)=>{
                try {
                    this._tsStack ? (this._telemetryService = new TelemetryService(this._telemetryLogManager), this._ecsProvider = new EcsProvider(this.logger, this.sdkDiagnosticInformation, this._acsProxy), this._ecsFetcher = new EcsConfigFetcher(this.logger, this._acsProxy), await this.initializeEcsBase(f), await this.initializeEcsForUser(g), DefaultLogger.overrideDefaultLogDump(), getAcsEcsConfig().calling.doNotWaitForTrouter ? this._initTrouter(g).catch(()=>{
                        this.logger.warn(O.CALL_STACK.SIGNALING_UNINITIALIZED.message);
                    }) : await this._initTrouter(g), this.logger.log("Signaling initialized successfully."), await initializeMediaStack(g, this._tsStack), await initializeSignalingAgent(g, this._tsStack), await initializeTsStack(this._tsStack), S(this._tsStack)) : (this.logger.error("Base stack failed to create"), v(new CallingCommunicationError({
                        defaultError: O.CALL_STACK.USER_STACK_NO_BASE_STACK
                    })));
                } catch (g) {
                    v(g);
                }
            }), initializeMediaStack = async (g, f)=>{
                try {
                    if (await f.initializeMediaAgent({
                        httpRequestDispatcher: this.getRequestDispatcher(),
                        tokenProvider: g,
                        relayManager: this.getCustomRelayManager(),
                        configProvider: {
                            getSkypeConfig: ()=>Promise.resolve({}),
                            getRelayConfig: ()=>{
                                const g = this._ecsProvider.getMdnTrapSettings();
                                return Promise.resolve(g);
                            }
                        },
                        appStateProvider: this._getAppStateProvider(),
                        clientInformation: this._ecsProvider.getJsCsaConfig().clientInformation
                    }), getAcsEcsConfig().calling.platformSupportValidation && 0 === f.getPlatformSupportLevel()) {
                        const g = new CallingCommunicationError({
                            defaultError: O.CALL_STACK.USER_STACK_MEDIA_INIT_FAILED_PLATFORM_NOT_SUPPORTED
                        });
                        throw this.logger.error(g.message), g;
                    }
                } catch (g) {
                    throw this.logger.error("Failed to  initialize media stack", g), new CallingCommunicationError({
                        defaultError: O.CALL_STACK.USER_STACK_MEDIA_INIT_FAILED,
                        originalError: g
                    });
                }
            }, initializeSignalingAgent = async (g, f)=>{
                try {
                    await f.initializeSignalingAgentProvider({
                        signalingAgentConfig: this._getSignalingConfig(g),
                        trouterService: this._trouterService
                    });
                } catch (g) {
                    throw this.logger.error("Failed to  initialize signaling agent", g), new CallingCommunicationError({
                        defaultError: O.CALL_STACK.USER_STACK_SIGNALING_INIT_FAILED,
                        originalError: g
                    });
                }
            }, initializeTsStack = async (g)=>{
                try {
                    await g.init();
                } catch (g) {
                    throw this.logger.error("Failed to initialize calling stack", g), new CallingCommunicationError({
                        defaultError: O.CALL_STACK.USER_STACK_INTERNAL_INIT_FAILED,
                        originalError: g
                    });
                }
            };
            try {
                this._initializeStackForUserWaitPromise = wait(()=>S, Am);
                const g = await this._initializeStackForUserWaitPromise;
                return this.sendStackInitEvent(!0), this.logger.log("User stack init success"), g;
            } catch (g) {
                if (await this.dispose(), g.code === k) throw this.sendStackInitEvent(!1, "User stack init timeout", g), new CallingCommunicationError({
                    defaultError: O.CALL_STACK.USER_STACK_INIT_TIMEOUT
                });
                if (!(g instanceof CallingCommunicationError) && "Uninitialized" === this.getTrouterState()) throw new CallingCommunicationError({
                    defaultError: O.CALL_STACK.SIGNALING_UNINITIALIZED,
                    originalError: g
                });
                throw this.sendStackInitEvent(!1, "User stack init failed", g), new CallingCommunicationError({
                    defaultError: O.CALL_STACK.USER_STACK_INIT_FAILED,
                    originalError: g
                });
            }
        }
        getRequestDispatcher() {
            return this._acsProxy.hasProxyUrl() ? (this.logger.info("Using custom proxy for network requests (non media)"), new HttpRequestDispatcher(this.logger, this._acsProxy)) : getAcsEcsConfig().telemetry.sendNetworkInfo ? new HttpRequestDispatcher(this.logger) : new w.HttpRequestDispatcherImplementation;
        }
        async initializeEcsBase(g) {
            const f = defer(), S = this.getEcsQueryParameters(g), v = generateGuid(), _ = g ? this._ECS_FETCH_TYPE_USER : this._ECS_FETCH_TYPE_DEFAULT, C = new EcsConfigObj(oA.Default, g, S, (S)=>{
                var _S_Headers, _S_Headers1;
                if ((S === null || S === void 0 ? void 0 : (_S_Headers = S.Headers) === null || _S_Headers === void 0 ? void 0 : _S_Headers.CountryCode) && this.updateEmergencyCallCountry(S === null || S === void 0 ? void 0 : (_S_Headers1 = S.Headers) === null || _S_Headers1 === void 0 ? void 0 : _S_Headers1.CountryCode), f.resolve(), this._ecsFetcher.getConfigType() === oA.User && this._ecsSetupCompleteForUser.resolve(), this._ecsFetcher && this._tsStack && void 0 !== S) {
                    let f;
                    const C = +new Date;
                    try {
                        return setAcsEcsConfig(S), this._ecsProvider.setConfig(g, S), setMediaConfig(this._ecsProvider.getJamaSettings()), f = JSON.stringify(S), this._tsStack.getEcsProvider().setEcsConfig({
                            ecsBlob: f,
                            userIdentity: "",
                            etag: this._ecsFetcher.getETag()
                        }), this._ecsProvider.assertConfigs(S), !0;
                    } catch (g) {
                        const f = +new Date;
                        this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_failure, {
                            deltaTimeInMs: f - C
                        }, _, v, this._ecsProvider.getConfigIds(), new CallingCommunicationError({
                            defaultError: O.CALL_STACK.PARSE_CONFIG,
                            originalError: g
                        })), this.logger.error("Unable to parse configuration");
                    }
                }
                return !1;
            }, getPlatformId()), E = +new Date;
            try {
                await this._ecsFetcher.subscribeEcsConfig(C), this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_attempt, {
                    attemptTimestamp: E
                }, _, v);
                const g = wait(()=>f.promise, lf);
                await g;
                const S = +new Date;
                this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_success, {
                    deltaTimeInMs: S - E
                }, _, v, this._ecsProvider.getConfigIds());
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.CALL_STACK.PARSE_CONFIG,
                    originalError: f
                }), C = +new Date;
                this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_failure, {
                    deltaTimeInMs: C - E
                }, _, v, this._ecsProvider.getConfigIds(), S), this.logger.warn("Failed to fetch base settings. Stack will initialize without default settings", f), this._ecsProvider.setConfig(g, void 0);
            }
        }
        async initializeEcsForUser(g) {
            const f = await g();
            this._ecsSetupCompleteForUser = defer();
            try {
                await this._ecsFetcher.setConfigsToFetch([
                    oA.User
                ]), await this._ecsFetcher.setSkypeToken(f, 1e3 * parseJWT(f).exp);
            } catch (g) {
                throw this.logger.error("Unable to set skype token for user ecs config"), new CallingCommunicationError({
                    defaultError: O.CALL_STACK.SET_STACK_CONFIG
                });
            }
            const S = generateGuid(), v = this.caConfigBag ? "User" : "Default", _ = +new Date;
            try {
                this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_attempt, {
                    attemptTimestamp: _
                }, v, S);
                const g = wait(()=>this._ecsSetupCompleteForUser.promise, lf);
                await g;
                const f = +new Date;
                this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_success, {
                    deltaTimeInMs: f - _
                }, v, S, this._ecsProvider.getConfigIds());
            } catch (g) {
                const f = +new Date;
                this.sendEcsSettingsFetchedDataEvent(dy.acs_calling_config_fetched_failure, {
                    deltaTimeInMs: f - _
                }, v, S, this._ecsProvider.getConfigIds(), g), this.logger.warn("Failed to fetch user settings. Stack will initialize without user settings", g);
            }
        }
        async getDeviceManager() {
            if (!this._createStackBaseWaitPromise) throw new CallingCommunicationError({
                defaultError: O.CALL_STACK.GET_DM
            });
            return (await this._createStackBaseWaitPromise).getDeviceManager();
        }
        async dispose(g) {
            if (!this._disposed) {
                if (this._disposed = !0, this._trouterService) try {
                    this._trouterService.clearMessageHandlers(), this._trouterService.stop(g), this._trouterService = void 0;
                } catch (g) {
                    this.logger.error("Failed to dispose signaling");
                }
                if (this._tsStack) try {
                    await this._tsStack.dispose(), this._tsStack = void 0;
                } catch (g) {
                    this.logger.error("Failed to dispose calling stack");
                }
                this._ecsFetcher.dispose(), this._createStackBaseWaitPromise = void 0, this._initializeStackForUserWaitPromise = void 0, this._tsStack = void 0, this.logger.info("Calling stack disposed");
            }
        }
        getEcsQueryParameters(g) {
            const f = {};
            try {
                f.CLRelease = w.getVersion();
                const S = getBrowserInfo();
                f.BrowserName = S.name, f.BrowserEngine = S.engine, f.BrowserVersion = S.version, f.FormFactor = S.formFactor, f.IdentityType = um.Consumer, f.Cloud = rm.Public, f.OSVer = `${getOS()}-${getOSVersion()}`, g && (f.Cloud = g.cloudType, f.IdentityType = g.identityType);
                const v = "_TS_BUILC_VERSION_".replace("C", "D");
                f.CLRelease === v ? f.CLRelease = "9999.99" : f.CLRelease.match(/^\d+\.\d+\.\d+\.\d+$/) || delete f.CLRelease;
            } catch (g) {
                throw this.logger.error(g), new CallingCommunicationError({
                    defaultError: O.CALL_STACK.SET_STACK_PARAMS,
                    originalError: g
                });
            }
            return f;
        }
        sendEcsSettingsFetchedDataEvent(g, f, S, v, _, C) {
            let E, T;
            C && (E = C.message, T = extractCommunicationServicesErrorForTelemetry(C)), this._telemetryLogManager.sendEvent({
                name: g,
                tenant: nf,
                properties: {
                    ...f,
                    ecsFetchType: S,
                    correlationId: v,
                    failureReason: E,
                    ecsConfigIds_AcsCallingSDKWeb: (_ === null || _ === void 0 ? void 0 : _.AcsCallingSDKWeb) || "",
                    ecsConfigIds_SkypeWebMedia: (_ === null || _ === void 0 ? void 0 : _.SkypeWebMedia) || "",
                    additionalDetails: {
                        ...T
                    }
                }
            });
        }
        updateEmergencyCallCountry(g) {
            this.caConfigBag && !this.caConfigBag.emergencyCountryCode && !this.caConfigBag.IsUserEmergencyCountryCode && g && (this.caConfigBag.emergencyCountryCode = g);
        }
        async _initTrouter(g) {
            let f = +new Date;
            try {
                this._trouterService = new Trouter(this.logger, this._ecsProvider, (f)=>g(f), this._telemetryLogManager, this._acsProxy), f = +new Date;
                let S = await this._trouterService.start();
                return void this.sendSignalingInitEvent(!0, +new Date - f, S.trouterRequestCompletionTimeDeltaMs, S.registrarRequestCompletionTimeDeltaMs);
            } catch (g) {
                throw this.sendSignalingInitEvent(!1, +new Date - f, void 0, void 0, g), g;
            }
        }
        _getBaseStackConfig() {
            const g = this._getMediaProviderConfig(), f = {
                clientInformation: this._ecsProvider.getClientInformation(),
                logger: this.logger,
                mediaSettings: g.mediaSettings,
                platformType: getPlatformName(),
                callSettings: {
                    useLwjForAllCalls: !1
                },
                usePlatformSupportApi: !0,
                telemetryTenants: {
                    media: "mediaAgent",
                    signaling: "signalingAgent",
                    tlePlayer: Of
                },
                telemetryService: this._telemetryService,
                webcvProvider: this._webcvProvider,
                wasmVqeProvider: this._wasmvqeProvider
            };
            return void 0 !== this._encodedStreamsWorkerProvider && (f.encodedStreamsWorkerProvider = this._encodedStreamsWorkerProvider), f;
        }
        _getSignalingConfig(g) {
            var _this_caConfigBag, _this_caConfigBag1;
            const f = {
                ...this._ecsProvider.getJsCsaConfig(),
                httpRequestDispatcher: this.getRequestDispatcher(),
                telemetryManager: this._telemetryService.getCallingAdapter(),
                logger: this.logger,
                skypeToken: ()=>g(),
                trouterServiceProvider: this._trouterService,
                ecsEtag: this._ecsFetcher.getETag()
            };
            return ((_this_caConfigBag = this.caConfigBag) === null || _this_caConfigBag === void 0 ? void 0 : _this_caConfigBag.emergencyCountryCode) && (f.emergencyCallCountry = (_this_caConfigBag1 = this.caConfigBag) === null || _this_caConfigBag1 === void 0 ? void 0 : _this_caConfigBag1.emergencyCountryCode), f;
        }
        _getMediaProviderConfig() {
            return {
                logger: this.logger,
                mediaSettings: this._getMediaAgentConfig()
            };
        }
        _getMediaAgentConfig() {
            return {
                ...this._ecsProvider.getJamaSettings()
            };
        }
        _getAppStateProvider() {
            return {
                isOnline: ()=>!0
            };
        }
        sendStackInitEvent(g, f, S) {
            try {
                let v, _;
                S && (v = S.message, _ = extractCommunicationServicesErrorForTelemetry(S)), this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_stack_init,
                    tenant: nf,
                    properties: {
                        success: g,
                        reason: f,
                        failureReason: v || "unknown",
                        additionalDetails: {
                            ..._
                        }
                    }
                });
            } catch (g) {}
        }
        sendSignalingInitEvent(g, f, S, v, _) {
            try {
                let C, E;
                _ && (C = _.message, E = extractCommunicationServicesErrorForTelemetry(_)), this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_signaling_init,
                    tenant: nf,
                    properties: {
                        success: g,
                        failureReason: C || "unknown",
                        timestampInfo: {
                            deltaTimeInMs: f,
                            deltaTimeInMsTrouterRequest: S,
                            deltaTimeInMsRegistrarRequest: v
                        },
                        additionalDetails: {
                            ...E
                        }
                    }
                });
            } catch (g) {}
        }
        getCustomRelayManager() {
            if (this._tsCustomRelayManager = this._acsCustomRelayManager.getTsRelayManager(), this._tsCustomRelayManager && getAcsEcsConfig().calling.enableCustomTurnUsage) return this.logger.info("Using custom relays for media traffic"), this._acsCustomRelayManager.customRelayManagerInUse = !0, this._tsCustomRelayManager;
        }
        constructor(g, f, S, v, _, C, E){
            if (this._ECS_FETCH_TYPE_USER = "User", this._ECS_FETCH_TYPE_DEFAULT = "Default", this._disposed = !1, this._trouterStateChangedListenersRegistered = new Map, this.clientId = f, this.sdkDiagnosticInformation = v, this.logger = g.createChild("CallStack"), this._telemetryLogManager = S, this._acsProxy = _, this._acsCustomRelayManager = C, this._webcvProvider = new WebCVProvider, this._wasmvqeProvider = new WasmVqeProvider, "https:" !== location.protocol && "file:" !== location.protocol && "localhost" !== location.hostname) throw new CallingCommunicationError({
                defaultError: O.CALL_STACK.BAD_PROTOCOL
            });
            this._telemetryService = new TelemetryService(this._telemetryLogManager), this._ecsProvider = new EcsProvider(this.logger, this.sdkDiagnosticInformation, this._acsProxy), this._ecsFetcher = new EcsConfigFetcher(this.logger, this._acsProxy), this._videoEffectsStatusManager = new VideoEffectsStatusManager, this._audioEffectsStatusManager = new AudioEffectsStatusManager, void 0 !== E && (this._encodedStreamsWorkerProvider = new EncodedStreamsWorkerProvider(E));
        }
    }
    __decorate$q([
        loggerProperty,
        __metadata$q("design:type", Object)
    ], CallStack.prototype, "logger", void 0), __decorate$q([
        asyncOperation(RS.CreateStackBase),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", [
            Object
        ]),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "createStackBase", null), __decorate$q([
        asyncOperation(RS.InitializeStackForUser),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", [
            Function,
            Object
        ]),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "initializeStackForUser", null), __decorate$q([
        asyncOperation(RS.InitializeEcsBase),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", [
            Object
        ]),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "initializeEcsBase", null), __decorate$q([
        asyncOperation(RS.InitializeEcsForUser),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", [
            Function
        ]),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "initializeEcsForUser", null), __decorate$q([
        asyncOperation(RS.GetDeviceManager),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", []),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "getDeviceManager", null), __decorate$q([
        asyncOperation(RS.Dispose),
        __metadata$q("design:type", Function),
        __metadata$q("design:paramtypes", [
            Boolean
        ]),
        __metadata$q("design:returntype", Promise)
    ], CallStack.prototype, "dispose", null);
    class ObservableSubjects {
        notifyAll(g) {
            this._eventEmitter.emit(g);
        }
        waitFor(g, f) {
            return new Promise((S, v)=>{
                let _ = 0;
                const listener = ()=>{
                    S(), clearTimeout(_);
                };
                this._eventEmitter.once(g, listener), _ = window.setTimeout(()=>{
                    this._eventEmitter.off(g, listener), v(new Error("timeout"));
                }, f);
            });
        }
        constructor(){
            this._eventEmitter = new Ny.EventEmitter;
        }
    }
    class DeviceInfoMapper {
        getDeviceId(g) {
            let f = this._deviceIdMapping.get(g);
            if (void 0 !== f) return f;
            ++this._deviceId;
            var _g_split_;
            return f = `${(_g_split_ = g.split(":")[0]) !== null && _g_split_ !== void 0 ? _g_split_ : ""}:${this._deviceId}`, this._deviceIdMapping.set(g, f), f;
        }
        scrubDeviceLabel(g) {
            return scrubDeviceLabelPii(g, this._keywords);
        }
        constructor(){
            this._deviceIdMapping = new Map, this._deviceId = 1, this._keywords = getAcsEcsConfig().telemetry.deviceChangedEvents.piiSafeWords;
        }
    }
    function scrubDeviceLabelPii(g, f) {
        if (!g) return "";
        if (g.length < 3) return g;
        const S = [], v = g.match(/\(([0-9a-zA-Z]+:[0-9a-zA-Z]+)\)/);
        v && S.push(v[1]);
        try {
            if (!(f === null || f === void 0 ? void 0 : f.length)) return "no_keywords";
            {
                const v = new RegExp(`(${f.join("|")})`, "gi");
                let _ = v.exec(g);
                for(; _;)S.push(_[1]), _ = v.exec(g);
            }
        } catch (g) {
            const stringifyError = (g)=>{
                var _g_message;
                return P.isString(g) ? g : (_g_message = g === null || g === void 0 ? void 0 : g.message) !== null && _g_message !== void 0 ? _g_message : "";
            };
            S.push(`Error: ${stringifyError(g)}`);
        }
        return 0 === S.length ? "unknown" : S.join(" ");
    }
    !function(g) {
        g.deviceSelection = "deviceSelection";
    }(NA || (NA = {}));
    var __decorate$r = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$r = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class DeviceManagerImpl {
        get telemetryLogManager() {
            return this._telemetryLogManager;
        }
        getRawDeviceMediaStream(g) {
            var _this__tsDeviceManager;
            const f = generateGuid(), S = +new Date;
            if (this.sendRawMediaEvent({
                eventName: dy.acs_calling_get_raw_device_media_stream,
                correlationId: f,
                kindOfEvent: "attempt",
                mediaType: g,
                timestampInfo: "",
                additionalDetails: ""
            }), !((_this__tsDeviceManager = this._tsDeviceManager) === null || _this__tsDeviceManager === void 0 ? void 0 : _this__tsDeviceManager.getRawDeviceMediaStream)) {
                const v = new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.GET_MEDIA_STREAM_TRACK
                });
                this.logger.error("Failed to get raw device stream track");
                const _ = +new Date;
                throw this.sendRawMediaEvent({
                    eventName: dy.acs_calling_get_raw_device_media_stream,
                    correlationId: f,
                    kindOfEvent: "failure",
                    mediaType: g,
                    timestampInfo: {
                        deltaTimeInMs: _ - S
                    },
                    additionalDetails: {
                        failureReason: v.message || "",
                        code: v.code,
                        subCode: v.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    }
                }), v;
            }
            let v;
            try {
                var _this__tsDeviceManager1;
                v = (_this__tsDeviceManager1 = this._tsDeviceManager) === null || _this__tsDeviceManager1 === void 0 ? void 0 : _this__tsDeviceManager1.getRawDeviceMediaStream(g);
                const _ = +new Date;
                return this.sendRawMediaEvent({
                    eventName: dy.acs_calling_get_raw_device_media_stream,
                    correlationId: f,
                    kindOfEvent: "success",
                    mediaType: g,
                    timestampInfo: {
                        deltaTimeInMs: _ - S
                    },
                    additionalDetails: ""
                }), v;
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.GET_MEDIA_STREAM_DEVICE_UNAVAILABLE,
                    originalError: v
                });
                this.logger.error("Failed to get raw device stream track");
                const C = +new Date;
                throw this.sendRawMediaEvent({
                    eventName: dy.acs_calling_get_raw_device_media_stream,
                    correlationId: f,
                    kindOfEvent: "failure",
                    mediaType: g,
                    timestampInfo: {
                        deltaTimeInMs: C - S
                    },
                    additionalDetails: {
                        failureReason: _.message || "",
                        code: _.code,
                        subCode: _.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    }
                }), _;
            }
        }
        getClientId() {
            return this._callStack.getClientId();
        }
        async getDeviceManager() {
            if (this._tsDeviceManager) return this._tsDeviceManager;
            const g = +new Date;
            try {
                var _this__tsDeviceManager, _this__tsDeviceManager1;
                this.sendGetDeviceManagerEvent({
                    eventName: dy.acs_calling_get_device_manager,
                    kindOfEvent: "attempt",
                    timestampInfo: "",
                    additionalDetails: ""
                }), await this._callStack.createStackBase(), this._tsDeviceManager = await this._callStack.getDeviceManager();
                const f = await this.enumerateDevicesAsync();
                this.logger.info(`tsDevicesList:${JSON.stringify(f)}`), f.forEach((g)=>{
                    if (1 === g.kind) {
                        const f = g;
                        this._videoDevices.push(new VideoDeviceInfoImpl(f.label, f.id, "UsbCamera", this));
                    } else if (2 === g.kind || 3 === g.kind) {
                        const f = g, S = new AudioDeviceInfoImpl(f.label, f.id, f.isSystemDefault, this._tsDeviceTypeToAudioDeviceType[f.kind], this);
                        this._audioDevices.push(S);
                    }
                });
                const S = this._tsDeviceManager.getSelectedDevices();
                this._selectedMicrophone = this._audioDevices.find((g)=>g.id === S.microphone), this._selectedSpeaker = this._audioDevices.find((g)=>g.id === S.speaker), this._dmDevicesChangedSub = this._tsDeviceManager.on("devicesChanged", async ()=>{
                    try {
                        await this.syncDeviceList(await this.enumerateDevicesAsync()), this.checkForSelectedDevicesChanges();
                    } catch (f) {
                        this.logger.warn(`Unable to handle devicesChanged, error=${f === null || f === void 0 ? void 0 : f.message}, code=${f === null || f === void 0 ? void 0 : f.code}`);
                        const S = +new Date;
                        this.sendGetDeviceManagerEvent({
                            eventName: dy.acs_calling_get_device_manager,
                            kindOfEvent: "failure",
                            timestampInfo: {
                                deltaTimeInMs: S - g
                            },
                            additionalDetails: {
                                failureReason: f === null || f === void 0 ? void 0 : f.message,
                                code: f === null || f === void 0 ? void 0 : f.code,
                                ...extractCommunicationServicesErrorForTelemetry(f),
                                context: "devicesChanged"
                            }
                        });
                    }
                }), getAcsEcsConfig().calling.devicePermissions.getCurrentState && (this._audioDevicePermission = permissionStateToBool((_this__tsDeviceManager = this._tsDeviceManager) === null || _this__tsDeviceManager === void 0 ? void 0 : _this__tsDeviceManager.getPermissionState("microphone"), this.logger), this._videoDevicePermission = permissionStateToBool((_this__tsDeviceManager1 = this._tsDeviceManager) === null || _this__tsDeviceManager1 === void 0 ? void 0 : _this__tsDeviceManager1.getPermissionState("camera"), this.logger)), this.logger.info("Initial permission state audio:", this._audioDevicePermission, "video:", this._videoDevicePermission), this._dmDevicesPermissionChangedSub = this._tsDeviceManager.on("onPermissionStateChanged", this.permissionsChanged.bind(this));
                const v = +new Date;
                this.sendGetDeviceManagerEvent({
                    eventName: dy.acs_calling_get_device_manager,
                    kindOfEvent: "success",
                    timestampInfo: {
                        deltaTimeInMs: v - g
                    },
                    additionalDetails: ""
                });
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.GET_DM,
                    originalError: f
                });
                this.logger.error(S.message);
                const v = +new Date;
                this.sendGetDeviceManagerEvent({
                    eventName: dy.acs_calling_get_device_manager,
                    kindOfEvent: "failure",
                    timestampInfo: {
                        deltaTimeInMs: v - g
                    },
                    additionalDetails: {
                        failureReason: S.message,
                        code: S.code,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    }
                });
            }
            return this._tsDeviceManager;
        }
        on(g, f) {
            if ("videoDevicesUpdated" !== g && "audioDevicesUpdated" !== g && "selectedMicrophoneChanged" !== g && "selectedSpeakerChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("videoDevicesUpdated" !== g && "audioDevicesUpdated" !== g && "selectedMicrophoneChanged" !== g && "selectedSpeakerChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        getTsDeviceManager() {
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            return this._tsDeviceManager;
        }
        getSafariPermissionState() {
            return "Safari" === this._browserInfo.engine ? this._safariVideoPermissionState : "unknown";
        }
        getAcsResourceId() {
            var _this__callStack_caConfigBag, _this__callStack;
            return (_this__callStack = this._callStack) === null || _this__callStack === void 0 ? void 0 : (_this__callStack_caConfigBag = _this__callStack.caConfigBag) === null || _this__callStack_caConfigBag === void 0 ? void 0 : _this__callStack_caConfigBag.acsResourceId;
        }
        getAudioDevicePermission() {
            return this._audioDevicePermission;
        }
        getVideoDevicePermission() {
            return this._videoDevicePermission;
        }
        get callStackWebCvProvider() {
            return this._callStack.webcvProvider;
        }
        get callStackWasmVqeProvider() {
            return this._callStack.wasmvqeProvider;
        }
        get callStackVideoEffectsStatusManager() {
            return this._callStack.videoEffectsStatusManager;
        }
        get callStackAudioEffectsStatusManager() {
            return this._callStack.audioEffectsStatusManager;
        }
        get deviceInfoMapper() {
            return this._deviceInfoMapper;
        }
        getEnvironmentInfoInternal() {
            return this._environmentInfo || (this._environmentInfo = getEnvironmentInfos()), this._environmentInfo;
        }
        getOSNameInternal() {
            return getOS();
        }
        sendRawMediaEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send raw media telemetry");
            }
        }
        sendGetDeviceManagerEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send get_device_manager telemetry");
            }
        }
        permissionsChanged(g, f) {
            var _this__tsDeviceManager, _this__tsDeviceManager1;
            const S = this._audioDevicePermission, v = this._videoDevicePermission;
            let _, C;
            var _g_audio, _g_video;
            getAcsEcsConfig().calling.devicePermissions.getCurrentState ? (_ = permissionStateToBool((_this__tsDeviceManager = this._tsDeviceManager) === null || _this__tsDeviceManager === void 0 ? void 0 : _this__tsDeviceManager.getPermissionState("microphone"), this.logger), C = permissionStateToBool((_this__tsDeviceManager1 = this._tsDeviceManager) === null || _this__tsDeviceManager1 === void 0 ? void 0 : _this__tsDeviceManager1.getPermissionState("camera"), this.logger)) : (_ = S, C = v), this._audioDevicePermission = _ || !!(g === null || g === void 0 ? void 0 : g.audio), this._videoDevicePermission = C || !!(g === null || g === void 0 ? void 0 : g.video), f && (f.audio && (this._audioDevicePermission = (_g_audio = g === null || g === void 0 ? void 0 : g.audio) !== null && _g_audio !== void 0 ? _g_audio : !1), f.video && (this._videoDevicePermission = (_g_video = g === null || g === void 0 ? void 0 : g.video) !== null && _g_video !== void 0 ? _g_video : !1)), S === this._audioDevicePermission && v === this._videoDevicePermission || (this.logger.info(`permission state changed from audio: ${S}, video: ${v}\n                          to audio: ${this._audioDevicePermission}, video: ${this._videoDevicePermission}`), this._telemetryLogManager.sendEvent({
                name: dy.acs_calling_device_permission_changed,
                tenant: nf,
                properties: {
                    previousAudioDevicePermission: this.nullHandler(S),
                    previousVideoDevicePermission: this.nullHandler(v),
                    newAudioDevicePermission: this.nullHandler(this._audioDevicePermission),
                    newVideoDevicePermission: this.nullHandler(this._videoDevicePermission)
                }
            }));
        }
        checkForSelectedDevicesChanges() {
            if (this.logger.info("checkForSelectedDevicesChanges"), this._tsDeviceManager) {
                var _this__selectedMicrophone, _this__selectedSpeaker;
                const g = this._tsDeviceManager.getSelectedDevices();
                g.microphone !== ((_this__selectedMicrophone = this._selectedMicrophone) === null || _this__selectedMicrophone === void 0 ? void 0 : _this__selectedMicrophone.id) && (this._selectedMicrophone = this._audioDevices.find((f)=>f.id === g.microphone), this._eventEmitter.emit("selectedMicrophoneChanged"), void 0 !== g.microphone && this._deviceSelectionNotifications.notifyAll(g.microphone)), g.speaker !== ((_this__selectedSpeaker = this._selectedSpeaker) === null || _this__selectedSpeaker === void 0 ? void 0 : _this__selectedSpeaker.id) && (this._selectedSpeaker = this._audioDevices.find((f)=>f.id === g.speaker), this._eventEmitter.emit("selectedSpeakerChanged"), void 0 !== g.speaker && this._deviceSelectionNotifications.notifyAll(g.speaker));
            } else this.logger.warn("DeviceManager is undefined, Unable to check selected devices");
        }
        isACSDeviceEqualToTSDevice(g, f) {
            return g.id === f.id;
        }
        async syncDeviceList(g) {
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            this.logger.info("syncDeviceList"), void 0 === g && (g = await this.enumerateDevicesAsync());
            const f = [];
            let S = [];
            const v = [];
            let _ = [];
            g.map((g)=>{
                if (1 === g.kind) {
                    const S = this._videoDevices.find((f)=>this.isACSDeviceEqualToTSDevice(f, g));
                    if (S) S.setName(g.label), S.setId(g.id), S.setDeviceType("UsbCamera");
                    else {
                        const S = new VideoDeviceInfoImpl(g.label, g.id, "UsbCamera", this);
                        f.push(S), this._videoDevices.push(S);
                    }
                } else if (2 === g.kind || 3 === g.kind) {
                    const f = this._audioDevices.find((f)=>this.isACSDeviceEqualToTSDevice(f, g));
                    if (f) {
                        const S = g;
                        f.setName(S.label), f.setId(S.id), f.setIsSystemDefault(S.isSystemDefault), f.setDeviceType(this._tsDeviceTypeToAudioDeviceType[S.kind]);
                    } else {
                        const f = new AudioDeviceInfoImpl(g.label, g.id, g.isSystemDefault, this._tsDeviceTypeToAudioDeviceType[g.kind], this);
                        v.push(f), this._audioDevices.push(f);
                    }
                }
            });
            const calculateRemovedDiffs = (f)=>{
                const S = f.filter((f)=>!g.find((g)=>this.isACSDeviceEqualToTSDevice(f, g)));
                return S.map((g)=>{
                    f.splice(f.indexOf(g), 1);
                }), S;
            };
            S = calculateRemovedDiffs(this._videoDevices), _ = calculateRemovedDiffs(this._audioDevices), (f.length > 0 || S.length > 0) && this._eventEmitter.emit("videoDevicesUpdated", {
                added: f,
                removed: S
            }), (v.length > 0 || _.length > 0) && this._eventEmitter.emit("audioDevicesUpdated", {
                added: v,
                removed: _
            });
        }
        async enumerateDevicesAsync() {
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            try {
                return await this._tsDeviceManager.enumerateDevicesAsync();
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.DEVICE_ENUMERATING_FAIL
                });
            }
        }
        get isSpeakerSelectionAvailable() {
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            return this._tsDeviceManager.isAudioOutputSelectionSupported;
        }
        get selectedMicrophone() {
            return this._selectedMicrophone;
        }
        get selectedSpeaker() {
            return this._selectedSpeaker;
        }
        async getCameras() {
            return await this.syncDeviceList(), this._videoDevices;
        }
        async getMicrophones() {
            return await this.syncDeviceList(), this._audioDevices.filter((g)=>"Microphone" === g.deviceType);
        }
        async getSpeakers() {
            if (this.isSpeakerSelectionAvailable) return await this.syncDeviceList(), this._audioDevices.filter((g)=>"Speaker" === g.deviceType);
            throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.SPEAKER_ENUMERATION_UNSUPPORTED
            });
        }
        async selectMicrophone(g) {
            var _this__selectedMicrophone;
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            if (!g || !g.id) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.INVALID_DEVICE
            });
            if ("microphone:" === g.id) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.DEVICE_NOT_SELECTABLE
            });
            if (this.logger.info("selectMicrophone called"), ((_this__selectedMicrophone = this._selectedMicrophone) === null || _this__selectedMicrophone === void 0 ? void 0 : _this__selectedMicrophone.id) !== g.id) {
                const f = getAcsEcsConfig().calling.deviceSelectionTimeoutInMs, S = this._deviceSelectionNotifications.waitFor(g.id, f), v = "Microphone", _ = this._deviceInfoMapper.getDeviceId(g.id), C = this._deviceInfoMapper.scrubDeviceLabel(g.name), E = generateGuid(), sendEvent = (g, f, S)=>{
                    this.sendDeviceSelectionEvent({
                        eventName: dy.acs_calling_client_operations,
                        operation: NA.deviceSelection,
                        kindOfEvent: g,
                        correlationId: E,
                        timestampInfo: void 0 !== f ? {
                            deltaTimeInMs: f
                        } : {},
                        additionalDetails: void 0 !== S ? {
                            failureReason: S.message,
                            code: S.code,
                            ...extractCommunicationServicesErrorForTelemetry(S)
                        } : "",
                        deviceSelection: {
                            deviceId: _,
                            deviceName: C,
                            deviceType: v
                        }
                    });
                };
                sendEvent("attempt");
                const T = Date.now();
                try {
                    this._tsDeviceManager.selectDevices({
                        microphone: g.id
                    }), await S.catch((f)=>{
                        var _this__selectedMicrophone;
                        if (((_this__selectedMicrophone = this._selectedMicrophone) === null || _this__selectedMicrophone === void 0 ? void 0 : _this__selectedMicrophone.id) !== g.id) throw f;
                    }), sendEvent("success", Date.now() - T);
                } catch (g) {
                    let f;
                    throw f = new CallingCommunicationError("timeout" === (g === null || g === void 0 ? void 0 : g.message) ? {
                        defaultError: O.DEVICE_MANAGER.SELECT_MICROPHONE_TIMEOUT
                    } : {
                        defaultError: O.DEVICE_MANAGER.SELECT_MICROPHONE_FAIL,
                        originalError: g
                    }), sendEvent("failure", Date.now() - T, f), f;
                }
            } else this.logger.warn("microphoneDevice is already active");
        }
        async selectSpeaker(g) {
            var _this__selectedSpeaker;
            const f = this.logger.createFnLogger(PS.SelectSpeaker);
            if (!this._tsDeviceManager) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ACCESS_DM
            });
            if (!this.isSpeakerSelectionAvailable) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.SPEAKER_SELECTION_UNSUPPORTED
            });
            if (!g || !g.id) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.INVALID_DEVICE
            });
            if ("speaker:" === g.id) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.DEVICE_NOT_SELECTABLE
            });
            if (f.info("selectSpeaker called"), ((_this__selectedSpeaker = this._selectedSpeaker) === null || _this__selectedSpeaker === void 0 ? void 0 : _this__selectedSpeaker.id) !== g.id) {
                const f = getAcsEcsConfig().calling.deviceSelectionTimeoutInMs, S = this._deviceSelectionNotifications.waitFor(g.id, f), v = "Speaker", _ = this._deviceInfoMapper.getDeviceId(g.id), C = this._deviceInfoMapper.scrubDeviceLabel(g.name), E = generateGuid(), sendEvent = (g, f, S)=>{
                    this.sendDeviceSelectionEvent({
                        eventName: dy.acs_calling_client_operations,
                        operation: NA.deviceSelection,
                        kindOfEvent: g,
                        correlationId: E,
                        timestampInfo: void 0 !== f ? {
                            deltaTimeInMs: f
                        } : {},
                        additionalDetails: void 0 !== S ? {
                            failureReason: S.message,
                            code: S.code,
                            ...extractCommunicationServicesErrorForTelemetry(S)
                        } : "",
                        deviceSelection: {
                            deviceId: _,
                            deviceName: C,
                            deviceType: v
                        }
                    });
                };
                sendEvent("attempt");
                const T = Date.now();
                try {
                    this._tsDeviceManager.selectDevices({
                        speaker: g.id
                    }), await S.catch((f)=>{
                        var _this__selectedSpeaker;
                        if (((_this__selectedSpeaker = this._selectedSpeaker) === null || _this__selectedSpeaker === void 0 ? void 0 : _this__selectedSpeaker.id) !== g.id) throw f;
                    }), sendEvent("success", Date.now() - T);
                } catch (g) {
                    let f;
                    throw f = new CallingCommunicationError("timeout" === (g === null || g === void 0 ? void 0 : g.message) ? {
                        defaultError: O.DEVICE_MANAGER.SELECT_SPEAKER_TIMEOUT
                    } : {
                        defaultError: O.DEVICE_MANAGER.SELECT_SPEAKER_FAIL,
                        originalError: g
                    }), sendEvent("failure", Date.now() - T, f), f;
                }
            } else f.warn("device is already selected");
        }
        async askDevicePermission(g) {
            const f = {
                audio: !!g.audio,
                video: !!g.video
            };
            if (!g.audio && !g.video) throw new CallingCommunicationError({
                defaultError: O.DEVICE_MANAGER.ONE_PERMISSION_ATLEAST
            });
            const S = this.getKeyForConstrains(f);
            let v = this._combinedDevicePermission.get(S);
            return v ? this.logger.info(`askDevicePermission attempt: audio:${f.audio}, video:${f.video} on pending existing request ${getPrintableObject(v)}`) : (v = this.askDevicePermissionInternal(f), this._combinedDevicePermission.set(S, v), v.finally(()=>{
                this._combinedDevicePermission.delete(S);
            })), v;
        }
        getKeyForConstrains(g) {
            return Object.keys(g).filter((f)=>g[f]).toString();
        }
        async askDevicePermissionInternal(g) {
            this.logger.info(`askDevicePermission attempt: audio:${g.audio}, video:${g.video}`);
            const f = generateGuid(), S = +new Date;
            this.sendAudioVideoPermissionEvent({
                eventName: dy.acs_calling_adp_attempt,
                correlationId: f,
                audioPermissionRequested: g.audio,
                videoPermissionRequested: g.video
            });
            try {
                if (!this._tsDeviceManager) throw new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.ACCESS_DM
                });
                const v = [];
                if (getAcsEcsConfig().calling.devicePermissions.splitAskAudioVideo) {
                    this.logger.info("askDevicePermission, split permission check");
                    const f = [];
                    if (g.audio && (this.logger.info("askDevicePermission, split permission audio"), f.push(this._tsDeviceManager.askDevicePermission({
                        audio: g.audio,
                        video: !1
                    }))), g.video) {
                        const askDevicePermissionVideoWithDelay = async (f)=>new Promise((S, v)=>{
                                const askDevicePermissionVideo = async ()=>{
                                    if (this.logger.info("askDevicePermission, split permission video"), !this._tsDeviceManager) {
                                        const g = "askDevicePermission, split permission video failed device manager not found";
                                        return this.logger.error(g), void v(g);
                                    }
                                    try {
                                        const f = await this._tsDeviceManager.askDevicePermission({
                                            audio: !1,
                                            video: g.video
                                        });
                                        S(f);
                                    } catch (g) {
                                        v(g);
                                    }
                                };
                                f ? window.setTimeout(askDevicePermissionVideo, f) : askDevicePermissionVideo();
                            });
                        f.push(askDevicePermissionVideoWithDelay(getAcsEcsConfig().calling.devicePermissions.timeoutInBetween));
                    }
                    const S = await Promise.allSettled(f);
                    let _ = {
                        audio: !1,
                        video: !1
                    };
                    S.forEach((g)=>{
                        var _g_value, _g_value1;
                        "fulfilled" === g.status && (g === null || g === void 0 ? void 0 : g.value) && (_ = {
                            audio: _.audio || !!(g === null || g === void 0 ? void 0 : (_g_value = g.value) === null || _g_value === void 0 ? void 0 : _g_value.audio),
                            video: _.video || !!(g === null || g === void 0 ? void 0 : (_g_value1 = g.value) === null || _g_value1 === void 0 ? void 0 : _g_value1.video)
                        }), "rejected" === g.status && (g === null || g === void 0 ? void 0 : g.reason) && v.push(g.reason);
                    }), this.permissionsChanged(_, g), this._safariVideoPermissionState = this._videoDevicePermission ? "granted" : "denied";
                } else {
                    const f = await this._tsDeviceManager.askDevicePermission({
                        audio: g.audio,
                        video: g.video
                    });
                    this.permissionsChanged(f, g);
                }
                if ((g === null || g === void 0 ? void 0 : g.audio) && !this._audioDevicePermission || (g === null || g === void 0 ? void 0 : g.video) && !this._videoDevicePermission) this.sendAudioVideoPermissionEvent({
                    eventName: dy.acs_calling_adp_failure,
                    correlationId: f,
                    audioPermissionRequested: g.audio,
                    videoPermissionRequested: g.video,
                    audioPermissionGranted: this._audioDevicePermission,
                    videoPermissionGranted: this._videoDevicePermission
                }, new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.PERMISSION_NOT_GRANTED_OR_FAILED,
                    defaultErrorMessageArgs: [
                        getPrintableObject(v)
                    ]
                }));
                else {
                    const v = +new Date;
                    this.sendAudioVideoPermissionEvent({
                        eventName: dy.acs_calling_adp_success,
                        correlationId: f,
                        audioPermissionRequested: g.audio,
                        videoPermissionRequested: g.video,
                        audioPermissionGranted: this._audioDevicePermission,
                        videoPermissionGranted: this._videoDevicePermission,
                        deltaTimeInMs: v - S
                    });
                }
            } catch (v) {
                const _ = new CallingCommunicationError({
                    defaultError: O.DEVICE_MANAGER.ADP_FAIL,
                    originalError: v
                }), C = +new Date;
                this.sendAudioVideoPermissionEvent({
                    eventName: dy.acs_calling_adp_failure,
                    correlationId: f,
                    audioPermissionRequested: g.audio,
                    videoPermissionRequested: g.video,
                    audioPermissionGranted: this._audioDevicePermission,
                    videoPermissionGranted: this._videoDevicePermission,
                    deltaTimeInMs: C - S
                }, _);
            }
            return {
                audio: !!this._audioDevicePermission,
                video: !!this._videoDevicePermission
            };
        }
        sendAudioVideoPermissionEvent(g, f) {
            try {
                let S, v, _;
                f && (S = "string" == typeof (f === null || f === void 0 ? void 0 : f.message) ? f === null || f === void 0 ? void 0 : f.message : void 0, v = extractCommunicationServicesErrorForTelemetry(f)), g.deltaTimeInMs && (_ = g.deltaTimeInMs > 25e3), this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: {
                        audioPermissionGranted: this.nullHandler(g.audioPermissionGranted),
                        videoPermissionGranted: this.nullHandler(g.videoPermissionGranted),
                        audioPermissionRequested: g.audioPermissionRequested,
                        videoPermissionRequested: g.videoPermissionRequested,
                        correlationId: g.correlationId || "",
                        failureReason: S || "",
                        deltaTimeInMs: g.deltaTimeInMs || "",
                        deltaTimeGreaterThanJAMATimeout: this.nullHandler(_),
                        additionalDetails: {
                            ...v
                        }
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send audio video permission failure success telemtery");
            }
        }
        sendDeviceSelectionEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send device selection telemetry");
            }
        }
        nullHandler(g) {
            return void 0 === g ? "" : g;
        }
        dispose() {
            this._dmDevicesChangedSub && this._dmDevicesChangedSub.dispose(), this._dmDevicesPermissionChangedSub && this._dmDevicesPermissionChangedSub.dispose(), this._dmDevicesPermissionChangedSub = void 0, this._dmDevicesChangedSub = void 0;
        }
        constructor(g, f, S){
            this._callStack = f, this._videoDevices = [], this._audioDevices = [], this._tsDeviceTypeToAudioDeviceType = {
                2: "Microphone",
                3: "Speaker",
                4: "CompositeAudioDevice"
            }, this.logger = g.createChild("DeviceManager"), this._telemetryLogManager = S, this._eventEmitter = new CallingEventEmitter(this.logger), this._browserInfo = getBrowserInfo(), this._safariVideoPermissionState = "unknown", this._combinedDevicePermission = new Map, this._deviceInfoMapper = new DeviceInfoMapper, this._deviceSelectionNotifications = new ObservableSubjects;
        }
    }
    __decorate$r([
        loggerProperty,
        __metadata$r("design:type", Object)
    ], DeviceManagerImpl.prototype, "logger", void 0), __decorate$r([
        asyncOperation(PS.GetDeviceManager),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", []),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "getDeviceManager", null), __decorate$r([
        asyncOperation(PS.GetCameras),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", []),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "getCameras", null), __decorate$r([
        asyncOperation(PS.GetMicrophones),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", []),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "getMicrophones", null), __decorate$r([
        syncOperation(PS.GetSpeakers),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", []),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "getSpeakers", null), __decorate$r([
        asyncOperation(PS.SelectMicrophone),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", [
            Object
        ]),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "selectMicrophone", null), __decorate$r([
        asyncOperation(PS.SelectSpeaker),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", [
            Object
        ]),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "selectSpeaker", null), __decorate$r([
        asyncOperation(PS.AskDevicePermission),
        __metadata$r("design:type", Function),
        __metadata$r("design:paramtypes", [
            Object
        ]),
        __metadata$r("design:returntype", Promise)
    ], DeviceManagerImpl.prototype, "askDevicePermission", null);
    var __decorate$s = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$s = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class TeamsIncomingCallImpl extends IncomingCallCommonImpl {
        get info() {
            return this._teamsCall.info;
        }
        async accept(g) {
            if (!isProxyAndCustomTurnAllowed(this._teamsCall.acsProxy, this._teamsCall.acsCustomRelayManager, !0)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
            });
            return await this._teamsCall.accept(g), this._teamsCall;
        }
        constructor(f){
            super(f, g.IncomingCallKind.TeamsIncomingCall), this._teamsCall = f;
        }
    }
    __decorate$s([
        asyncOperation(IS.Accept),
        __metadata$s("design:type", Function),
        __metadata$s("design:paramtypes", [
            Object
        ]),
        __metadata$s("design:returntype", Promise)
    ], TeamsIncomingCallImpl.prototype, "accept", null);
    var __decorate$t = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$t = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class TeamsCallImpl extends CallCommonImpl {
        get info() {
            return this._info;
        }
        async startCallInternal(g, f, S, v, _) {
            if (this._mtPolicyService && this._mtPolicyService.isFetchUserPoliciesAndSettingsApplicable(!0, _)) {
                this._mtPolicyService.userDialedNumber(Array.isArray(_) ? _[0].phoneNumber : _.phoneNumber);
                let g = "", f = !0;
                this._isEmergencyCall = !1;
                try {
                    this.logger.info("Fetching Teams User policy from MiddleTier Service"), await this._mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(this.tsCall.callId, this._callAgent.getUserMri());
                } catch (g) {
                    f = !1, this.logger.warn(`Fetching Teams user policy from ACS MiddleTier Service failed.\n                    Error message = ${g === null || g === void 0 ? void 0 : g.message}, code = ${g === null || g === void 0 ? void 0 : g.code}, subcode = ${g === null || g === void 0 ? void 0 : g.subCode}.\n                    Proceeding as normal pstn call`);
                }
                if (f) {
                    try {
                        this.enforcePolicyAndLicenseRestrictions();
                    } catch (g) {
                        return void this.handlePolicyAndLicenseRestrictionsFailure(g);
                    }
                    try {
                        this.logger.info("Deriving emergency content from fetched policies and settings"), g = this._mtPolicyService.getEmergencyContent();
                    } catch (g) {
                        this.logger.warn(`Error deriving emergency content from fetched policies and settings. \n                    Error message = ${g === null || g === void 0 ? void 0 : g.message}, code = ${g === null || g === void 0 ? void 0 : g.code}, subcode = ${g === null || g === void 0 ? void 0 : g.subCode}. Proceeding as normal pstn call`);
                    }
                    v && (v.emergencyContent = g || "", v.isEmergency = (g === null || g === void 0 ? void 0 : g.trim().length) > 0 || !1, this._isEmergencyCall = v.isEmergency);
                }
            }
            if (_) {
                let f = [];
                Array.isArray(_) ? f = _ : f.push(_), this._isEmergencyCall && 1 == f.length && (this.logger.info(`user dialed number (${f[0].phoneNumber}) resolved to actual emergency number (${this._mtPolicyService.getEmergencyNumber()} during startCall`), f[0] = {
                    phoneNumber: this._mtPolicyService.getEmergencyNumber()
                }), f.length > 1 && await this.setupThreadIdWhenStartingGroupCall(f, g, v), f.forEach((g)=>{
                    this.tsCall.addParticipant(getMriFromIdentifier(g)).catch(()=>{
                        this.logger.error("Failed to add participant during call start");
                    });
                }), this.logger.info("Paticipant added during startCall");
            }
            this._allowBreakoutRoomJoin = getAcsEcsConfig().calling.breakoutRooms.enabled && this._mtPolicyService.isBreakoutRoomsAllowed() && !!S, this._allowIPAudio = this._mtPolicyService.isIPAudioAllowed(), this._allowIPVideo = this._mtPolicyService.isIPVideoAllowed(), super.startCallInternal(g, f, S, v).catch(noop);
        }
        isEmergencyCallInProgress() {
            return this._isEmergencyCall;
        }
        dispose() {
            super.dispose(), this._extensibleApi.dispose();
        }
        addParticipant(g, f) {
            var _f_customContext, _f_customContext1;
            const v = +new Date, _ = generateGuid();
            this.sendParticipantAddedOrRemovedEvent({
                kindOfEvent: uy.attempt,
                participantAddedOrRemoved: "add",
                correlationId: _,
                timestampInfo: {
                    attemptTimestamp: v
                },
                additionalDetails: {
                    customContext: {
                        userToUserPresent: !!(f === null || f === void 0 ? void 0 : (_f_customContext = f.customContext) === null || _f_customContext === void 0 ? void 0 : _f_customContext.userToUser),
                        xHeadersPresent: !!(f === null || f === void 0 ? void 0 : (_f_customContext1 = f.customContext) === null || _f_customContext1 === void 0 ? void 0 : _f_customContext1.xHeaders) && (f === null || f === void 0 ? void 0 : f.customContext.xHeaders.length) > 0
                    }
                }
            });
            try {
                validateCallConnected(IS.AddParticipant, this.state), validateIdentifier(g);
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_INVALID_IDENTIFIER,
                    originalError: g
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
            if (!isProxyAndCustomTurnAllowed(this.acsProxy, this.acsCustomRelayManager, !0)) {
                const g = new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }
                }), g;
            }
            if (this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g))) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL.PARTICIPANT_ALREADY_IN_CALL,
                    defaultErrorMessageArgs: [
                        S.getIdentifierKind(g).kind
                    ]
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: f.code,
                        failureReason: f.message,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
            if (this.tsCall.threadId && isAcsThreadlessId(this.tsCall.threadId)) try {
                if (this.IsTargetUserAllowed(g)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.UNSUPPORTED_TARGET_TYPE
                });
            } catch (g) {
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }
                }), this.logger.error(g), g;
            }
            const C = this.getOrCreateRemoteParticipant(constructIdentifierKindFromMri(getMriFromIdentifier(g)));
            let E = "";
            return this.GetOrCreateGroupChatThread(!!(f === null || f === void 0 ? void 0 : f.threadId), g, f).then((S)=>{
                S && ((f = f !== null && f !== void 0 ? f : {}).threadId = S, E = S, this._info.setThreadId(S)), this.addParticipantToTsCall(g, E, f, C, _, v);
            }).catch((g)=>{
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: v - +new Date
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(g)
                    }
                }), g;
            }), C;
        }
        async removeParticipant(g) {
            const f = +new Date, v = generateGuid();
            this.sendParticipantAddedOrRemovedEvent({
                kindOfEvent: uy.attempt,
                participantAddedOrRemoved: "remove",
                correlationId: v,
                timestampInfo: {
                    attemptTimestamp: f
                }
            });
            try {
                validateCallConnected(IS.RemoveParticipant, this.state), validateIdentifier(g);
            } catch (g) {
                const S = new CallingCommunicationError({
                    defaultError: O.IDENTIFIER.PARSE_INVALID_IDENTIFIER,
                    originalError: g
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: v,
                    timestampInfo: {
                        deltaTimeInMs: f - +new Date
                    },
                    additionalDetails: {
                        code: g.code,
                        failureReason: g.message,
                        ...extractCommunicationServicesErrorForTelemetry(S)
                    }
                }), S;
            }
            let _ = this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g));
            if (!_) {
                const _ = new CallingCommunicationError({
                    defaultError: O.CALL.PARTICIPANT_NOT_IN_CALL,
                    originalError: [
                        S.getIdentifierKind(g).kind
                    ]
                });
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: v,
                    timestampInfo: {
                        deltaTimeInMs: +new Date - f
                    },
                    additionalDetails: {
                        code: _.code,
                        subCode: _.subCode,
                        failureReason: _.message,
                        ...extractCommunicationServicesErrorForTelemetry(_)
                    }
                }), _;
            }
            try {
                await this.tsCall.removeParticipant(getMriFromIdentifier(g)), this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.success,
                    participantAddedOrRemoved: "remove",
                    correlationId: v,
                    timestampInfo: {
                        deltaTimeInMs: f - +new Date
                    }
                });
            } catch (g) {
                const { callEndReason: S } = getRemoteParticipantCallEndReason(this, _.tsRemoteParticipant, g);
                _.callEndReason || _.setCallEndReason(S);
                const C = extractCallEndReasonForTelemetry(S);
                throw this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "remove",
                    correlationId: v,
                    timestampInfo: {
                        deltaTimeInMs: f - +new Date
                    },
                    additionalDetails: {
                        code: C === null || C === void 0 ? void 0 : C.callEndReason.code,
                        subCode: C === null || C === void 0 ? void 0 : C.callEndReason.subCode,
                        failureReason: C === null || C === void 0 ? void 0 : C.callEndReason.message,
                        ...C
                    }
                }), new CallingCommunicationError({
                    defaultError: {
                        message: S.message,
                        code: S.code,
                        subCode: S.subCode || 0,
                        resultCategories: S.resultCategories
                    },
                    originalError: g
                });
            }
        }
        async mute() {
            super.mute();
        }
        async unmute() {
            super.unmute();
        }
        async hold() {
            if (4 === this.tsCall.state) return void this.logger.info("Call already on hold");
            if (!getAcsEcsConfig().calling.musicOnHoldEnabled) return this.logger.warn("Music on Hold is not enabled"), super.hold();
            const g = +new Date, f = generateGuid();
            if (this._causeId = w.generateCauseId(), this.sendCallOnHoldAndResumedEvent({
                eventName: dy.acs_calling_call_hold_and_resume,
                callId: this.id,
                localParticipantId: this.tsCall.participantId,
                correlationId: f,
                operation: IS.Hold,
                kindOfEvent: uy.attempt,
                timestampInfo: {
                    deltaTimeInMs: g
                },
                additionalDetails: {
                    holdType: $S.MusicOnHold,
                    isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                }
            }), !this._hasFetchedPolicies) try {
                this.logger.info("Fetching Teams Calling Policy from Azure Communication Services"), await this._mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(this.tsCall.callId, this._callAgent.getUserMri(), {
                    policyUrlSuffix: getAcsEcsConfig().MiddleTier.policyUrlSuffixV2,
                    userPolicies: [
                        "TeamsCallingPolicy"
                    ]
                }), this._hasFetchedPolicies = !0, this._musicOnHoldEnabled = this._mtPolicyService.isMoHEnabled();
            } catch (g) {
                this.logger.warn(`Fetching Teams Calling Policy from Azure Communication Services failed.\n                    Error message = ${g === null || g === void 0 ? void 0 : g.message}, code = ${g === null || g === void 0 ? void 0 : g.code}, subcode = ${g === null || g === void 0 ? void 0 : g.subCode}.`);
            }
            return this._musicOnHoldEnabled ? (getAcsEcsConfig().calling.turnOffScreenShareBeforeHold && this.tsCall.isScreenSharingOn && await this.tsCall.stopScreenSharing().then(()=>{
                this.logger.log("Successfully turned off screen sharing before hold");
            }).catch(()=>{
                this.logger.error("Failed to turn off screensharing before hold");
            }), await this.tsCall.hold(void 0, this._causeId, {
                isLocal: !0
            }, 1).then(async ()=>{
                this.logger.info("Successfully detached devices as part of Hold"), await this.tsCall.park(3, this._causeId).then(()=>{
                    const S = +new Date;
                    this.sendCallOnHoldAndResumedEvent({
                        eventName: dy.acs_calling_call_hold_and_resume,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        correlationId: f,
                        operation: IS.Hold,
                        kindOfEvent: uy.success,
                        timestampInfo: {
                            deltaTimeInMs: S - g
                        },
                        additionalDetails: {
                            holdType: $S.MusicOnHold,
                            isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                        }
                    }), this.logger.info("Successful park() as part of hold, Music on Hold completed successfully");
                });
            }).catch(()=>{
                const S = +new Date, v = new CallingCommunicationError({
                    defaultError: O.CALL.HOLD_CALL
                });
                throw this.logger.warn(`Attempting to perform Music on Hold failed.\n                    Error message = ${v.message}, code = ${v.code}, subcode = ${v.subCode}`), this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Hold,
                    kindOfEvent: uy.failure,
                    timestampInfo: {
                        deltaTimeInMs: S - g
                    },
                    additionalDetails: {
                        failureReason: v.message,
                        code: v.code,
                        subCode: v.subCode,
                        holdType: $S.MusicOnHold,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn,
                        ...extractCommunicationServicesErrorForTelemetry(v)
                    }
                }), v;
            })) : (this.logger.info("Fetching  of Teams Calling Policy failed or Music on Hold Disabled, proceeding with standard hold"), super.hold());
        }
        async resume() {
            if (this._musicOnHoldEnabled) {
                const g = +new Date, f = generateGuid();
                return this.sendCallOnHoldAndResumedEvent({
                    eventName: dy.acs_calling_call_hold_and_resume,
                    callId: this.id,
                    localParticipantId: this.tsCall.participantId,
                    correlationId: f,
                    operation: IS.Resume,
                    kindOfEvent: uy.attempt,
                    timestampInfo: {
                        deltaTimeInMs: g
                    },
                    additionalDetails: {
                        holdType: $S.MusicOnHold,
                        isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                    }
                }), await this.tsCall.unpark(3, this._causeId).then(async ()=>{
                    this.logger.info("Successful unpark() as part of resume"), await this.tsCall.unhold(void 0, this._causeId).then(()=>{
                        const S = +new Date;
                        this.sendCallOnHoldAndResumedEvent({
                            eventName: dy.acs_calling_call_hold_and_resume,
                            callId: this.id,
                            localParticipantId: this.tsCall.participantId,
                            correlationId: f,
                            operation: IS.Resume,
                            kindOfEvent: uy.success,
                            timestampInfo: {
                                deltaTimeInMs: S - g
                            },
                            additionalDetails: {
                                holdType: $S.MusicOnHold,
                                isScreenSharingOnFlag: this.tsCall.isScreenSharingOn
                            }
                        }), this.logger.info("Successful unhold() as part of resume, resume completed successfully");
                    });
                }).catch(()=>{
                    const S = +new Date, v = new CallingCommunicationError({
                        defaultError: O.CALL.RESUME_CALL
                    });
                    throw this.logger.warn(`Attempting to perform resume from Music on Hold failed.\n                    Error message = ${v.message}, code = ${v.code}, subcode = ${v.subCode}`), this.sendCallOnHoldAndResumedEvent({
                        eventName: dy.acs_calling_call_hold_and_resume,
                        callId: this.id,
                        localParticipantId: this.tsCall.participantId,
                        correlationId: f,
                        operation: IS.Resume,
                        kindOfEvent: uy.failure,
                        timestampInfo: {
                            deltaTimeInMs: S - g
                        },
                        additionalDetails: {
                            failureReason: v.message,
                            code: v.code,
                            subCode: v.subCode,
                            holdType: $S.MusicOnHold,
                            isScreenSharingOnFlag: this.tsCall.isScreenSharingOn,
                            ...extractCommunicationServicesErrorForTelemetry(v)
                        }
                    }), v;
                });
            }
            return this.logger.info("Music on Hold Disabled, proceeding with standard resume"), super.resume();
        }
        validateThreadId(g, f) {
            if (!(f === null || f === void 0 ? void 0 : f.threadId)) {
                const g = new CallingCommunicationError({
                    defaultError: O.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID
                });
                throw this.logger.error(`Error Message = ${g.message}, code = ${g.code}, subcode = ${g.subCode}`), g;
            }
            this.validateThreadIdFormat(f === null || f === void 0 ? void 0 : f.threadId);
        }
        validateThreadIdFormat(g) {
            if (!g.startsWith("19")) {
                const g = new CallingCommunicationError({
                    defaultError: O.CALL.TEAMS_INVALID_THREAD_ID
                });
                throw this.logger.error(`Error Message = ${g.message}, code = ${g.code}, subcode = ${g.subCode}`), g;
            }
        }
        enforcePolicyAndLicenseRestrictions() {
            const g = +new Date;
            if (!this._mtPolicyService.isEvEnabled()) {
                var _this__callAgent__caConfigBag, _this__callAgent__caConfigBag1;
                const f = +new Date, S = new CallingCommunicationError({
                    defaultError: O.CALL.CTE_VOICE_NOT_ENABLED
                });
                this.logger.error(`Error Message = ${S.message}, code = ${S.code}, subcode = ${S.subCode}`);
                const v = this._callAgent.getEcsConfigIds();
                throw this.sendCallStageEvent({
                    eventName: dy.acs_calling_call_failed,
                    correlationId: generateGuid(),
                    timestampInfo: {
                        deltaTimeInMs: f - g
                    },
                    additionalPayload: {
                        additionalProperties: {
                            EmergencyCountryCode: ((_this__callAgent__caConfigBag = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.emergencyCountryCode) || "",
                            IsUserEmergencyCountryCode: ((_this__callAgent__caConfigBag1 = this._callAgent._caConfigBag) === null || _this__callAgent__caConfigBag1 === void 0 ? void 0 : _this__callAgent__caConfigBag1.IsUserEmergencyCountryCode) || !1,
                            trouterState: this._callAgent.getTrouterState(),
                            AcsCallingSDKWeb_ecsConfigId: v.AcsCallingSDKWeb,
                            SkypeWebMedia_ecsConfigId: v.SkypeWebMedia
                        },
                        additionalDetails: {
                            ...extractCommunicationServicesErrorForTelemetry(S)
                        }
                    }
                }, S, {
                    code: S.code,
                    subCode: S.subCode,
                    phrase: S.message
                }), S;
            }
        }
        handlePolicyAndLicenseRestrictionsFailure(g) {
            this._callEndReason = {
                message: "Unknown",
                code: g === null || g === void 0 ? void 0 : g.code,
                subCode: g === null || g === void 0 ? void 0 : g.subCode,
                resultCategories: g === null || g === void 0 ? void 0 : g.resultCategories
            }, this._state = "Disconnected", this._eventEmitter.emit("stateChanged"), this._callAgent.handleCallRemoved(this.tsCall);
        }
        async setupThreadIdWhenStartingGroupCall(g, f, S) {
            if (f && f.threadId && (this.validateThreadIdFormat(f.threadId), this.logger.info("ThreadId is already provided in the options parameter: " + JSON.stringify(f))), void 0 === f || !f.threadId) {
                let v = [];
                g.forEach((g)=>{
                    v.push({
                        id: getMriFromIdentifier(g)
                    });
                });
                try {
                    const g = await this._mtPolicyService.CreateChatThreadId(this.tsCall.callId, {
                        createThreadIdSuffix: getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix,
                        participants: v
                    });
                    f || (f = {}), f.threadId = g, g && this._info.setThreadId(g), S && g && (S.threadId = g);
                } catch (g) {
                    let f = "Failed to create thread Id for Teams group call ";
                    if (!getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.decoupleChatThreadFromCalls) throw new CallingCommunicationError({
                        defaultError: O.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED
                    });
                    this.logger.warn(f + g);
                }
            }
        }
        async GetOrCreateGroupChatThread(g, f, S) {
            let v = "";
            if (g) return this.logger.info("Customer provided threadId in options: " + JSON.stringify(S)), this.validateThreadId(f, S), v = S.threadId, Promise.resolve(v);
            if (!getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.allowServerThreadCreation) throw new CallingCommunicationError({
                defaultError: O.CALL.CTE_ADDPARTICIPANT_NO_THREAD_ID
            });
            if (null !== this._info.threadId && void 0 !== this._info.threadId) {
                v = this._info.threadId;
                let g = [];
                return g.push({
                    id: getMriFromIdentifier(f)
                }), await this._mtPolicyService.AddParticipantsToThread(this.tsCall.callId, {
                    threadId: v,
                    addParticipantsSuffix: getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.addParticipantSuffix,
                    participants: g
                }).catch((f)=>{
                    this.logger.warn("Error when adding participants " + JSON.stringify(g) + " to thread. " + f);
                }), Promise.resolve(v);
            }
            {
                let g = [];
                return this._remoteParticipants.forEach((f)=>{
                    g.push({
                        id: getMriFromIdentifier(f.identifier)
                    });
                }), g.push({
                    id: getMriFromIdentifier(f)
                }), await this._mtPolicyService.CreateChatThreadId(this.tsCall.callId, {
                    createThreadIdSuffix: getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.createThreadSuffix,
                    participants: g
                }).then((g)=>{
                    v = g, this.logger.info("Add participant into 1on1 call to convert it into Teams group call. Create thread id: " + v);
                }).catch((g)=>{
                    let S = "Error when adding participants " + getMriFromIdentifier(f) + " to thread to create a Teams group call. ";
                    if (!getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.decoupleChatThreadFromCalls) throw new CallingCommunicationError({
                        defaultError: O.CTE_MID_TIER_POLICY_SERVICE.CREATETHREAD_FAILED
                    });
                    this.logger.warn(S + g);
                }), Promise.resolve(v);
            }
        }
        addParticipantToTsCall(g, f, S, v, _, C) {
            this.tsCall.addParticipant(getMriFromIdentifier(g), {
                threadId: f,
                customHeaderContext: processCustomContext(S)
            }).then(()=>{
                this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.success,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: C - +new Date
                    }
                });
            }).catch((f)=>{
                const { callEndReason: S } = getRemoteParticipantCallEndReason(this, v.tsRemoteParticipant, f);
                v.callEndReason || v.setCallEndReason(S);
                const E = extractCallEndReasonForTelemetry(S);
                this.sendParticipantAddedOrRemovedEvent({
                    kindOfEvent: uy.failure,
                    participantAddedOrRemoved: "add",
                    correlationId: _,
                    timestampInfo: {
                        deltaTimeInMs: C - +new Date
                    },
                    additionalDetails: {
                        code: E === null || E === void 0 ? void 0 : E.callEndReason.code,
                        subCode: E === null || E === void 0 ? void 0 : E.callEndReason.subCode,
                        failureReason: E === null || E === void 0 ? void 0 : E.callEndReason.message,
                        ...E
                    }
                }), this._remoteParticipants.find((f)=>getMriFromIdentifier(f.identifier) === getMriFromIdentifier(g)) && (this.deleteRemoteParticipant(v), this._eventEmitter.emit("remoteParticipantsUpdated", {
                    added: [],
                    removed: [
                        v
                    ]
                }));
            });
        }
        IsTargetUserAllowed(g) {
            return S.isUnknownIdentifier(g) || S.isPhoneNumberIdentifier(g) || S.isCommunicationUserIdentifier(g);
        }
        constructor(f, S, v, _){
            super(f, S, v, _, g.CallKind.TeamsCall), this._isEmergencyCall = !1, this._musicOnHoldEnabled = !1, this._hasFetchedPolicies = !1, this._info = this.callInfo, this._mtPolicyService = S.mtPolicyService;
        }
    }
    __decorate$t([
        validateEmergencyCallOperation(IS.AddParticipant),
        syncOperation(IS.AddParticipant),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$t("design:returntype", Object)
    ], TeamsCallImpl.prototype, "addParticipant", null), __decorate$t([
        validateEmergencyCallOperation(IS.RemoveParticipant),
        asyncOperation(IS.RemoveParticipant),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", [
            Object
        ]),
        __metadata$t("design:returntype", Promise)
    ], TeamsCallImpl.prototype, "removeParticipant", null), __decorate$t([
        validateEmergencyCallOperation(IS.Mute),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", []),
        __metadata$t("design:returntype", Promise)
    ], TeamsCallImpl.prototype, "mute", null), __decorate$t([
        validateEmergencyCallOperation(IS.Unmute),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", []),
        __metadata$t("design:returntype", Promise)
    ], TeamsCallImpl.prototype, "unmute", null), __decorate$t([
        validateEmergencyCallOperation(IS.Hold),
        asyncOperation(IS.Hold),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", []),
        __metadata$t("design:returntype", Promise)
    ], TeamsCallImpl.prototype, "hold", null), __decorate$t([
        validateEmergencyCallOperation(IS.Resume),
        asyncOperation(IS.Resume),
        __metadata$t("design:type", Function),
        __metadata$t("design:paramtypes", []),
        __metadata$t("design:returntype", Promise)
    ], TeamsCallImpl.prototype, "resume", null);
    var __decorate$u = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$u = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    class TeamsCallAgentImpl extends CallAgentCommonImpl {
        get calls() {
            return this._calls;
        }
        createNewCall(g, f) {
            return new TeamsCallImpl({
                callId: g
            }, this, f, this._telemetryLogManager);
        }
        addToCallArray(g) {
            this._calls.push(g), this.trackCallEndTimeToStopTelemetry(this._calls);
        }
        addToCallAgentsMap(g) {
            TeamsCallAgentImpl.teamsCallAgents.get(g === null || g === void 0 ? void 0 : g.identityMri) && logErrorAndThrow(O.CALL_AGENT.TEAMS_CALLAGENT_ALREADY_EXSISTS, this.logger), TeamsCallAgentImpl.teamsCallAgents.set(g === null || g === void 0 ? void 0 : g.identityMri, this);
        }
        removeFromCallAgentsMap(g) {
            (g === null || g === void 0 ? void 0 : g.identityMri) && TeamsCallAgentImpl.teamsCallAgents.get(g === null || g === void 0 ? void 0 : g.identityMri) === this && TeamsCallAgentImpl.teamsCallAgents.delete(g === null || g === void 0 ? void 0 : g.identityMri);
        }
        disposeCall(g) {
            const f = this._calls.indexOf(g);
            -1 !== f && this._calls.splice(f, 1), g.dispose(), this.trackCallEndTimeToStopTelemetry(this._calls);
        }
        getMiddleTierServiceInstance() {
            return this.mtPolicyService;
        }
        async setUserPoliciesOnAgentInitialization() {
            super.setUserPoliciesOnAgentInitialization();
            try {
                if (this.isCteUser()) {
                    const g = generateGuid();
                    this.logger.info(`ACS MiddleTier service called on Teams Call Agent initialization with call Id=${g}`), await this.mtPolicyService.fetchUserPoliciesFromAcsMiddleTier(g, this.getUserMri(), {
                        policyUrlSuffix: getAcsEcsConfig().MiddleTier.policyUrlSuffixV2,
                        userPolicies: [
                            "EmergencyPolicies",
                            "TeamsCallingPolicy",
                            "TeamsMeetingPolicy"
                        ],
                        userProperties: [
                            "FeatureTypes",
                            "PoliciesMetadata",
                            "phoneNumber",
                            "sipUri",
                            "hostType",
                            "accountEnabled",
                            "useTeamsCalling",
                            "evEnabled",
                            "region",
                            "routingType",
                            "preferredDataLocation",
                            "featureTypes",
                            "displayName"
                        ]
                    }), this._userPolicies = this.mtPolicyService.getUserPolicy(), this._userProperties = this.mtPolicyService.getUserProperties(), this.logger.info(`****User policy initialized to ${JSON.stringify(this._userPolicies)}`), this.logger.info(`****User properties initialized to ${JSON.stringify(this._userProperties)}`);
                }
            } catch (g) {
                this.logger.warn(`Fetching Teams user policy and Properties from ACS MiddleTier Service failed.\n            Error message = ${g === null || g === void 0 ? void 0 : g.message}, code = ${g === null || g === void 0 ? void 0 : g.code}, subcode = ${g === null || g === void 0 ? void 0 : g.subCode}.`);
            }
        }
        startCall(g, f) {
            var _S_audioOptions;
            let S;
            if (this.assertParticipants(g), Array.isArray(g)) {
                if (S = f, g.length > 1 && !getAcsEcsConfig().MiddleTier.serverManagedThreadIdApiConfiguration.allowServerThreadCreation && !(S === null || S === void 0 ? void 0 : S.threadId)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.GROUPCALL_THREADID
                });
                if (1 == g.length && (S === null || S === void 0 ? void 0 : S.threadId)) throw new CallingCommunicationError({
                    defaultError: O.CALL_AGENT.ONE_TO_ONE_THREADID
                });
            } else S = f;
            if (getAcsEcsConfig().calling.enableSmePassFakeConversation && this.isAcsToTeamsInteropCall(g)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.UNSUPPORTED_TARGET_TYPE
            });
            let v = S === null || S === void 0 ? void 0 : (_S_audioOptions = S.audioOptions) === null || _S_audioOptions === void 0 ? void 0 : _S_audioOptions.muted;
            return void 0 === v && (v = !1), this.logger.info(`startCall with video=${!!(S === null || S === void 0 ? void 0 : S.videoOptions)},muted=${v}`), this.createCall({
                participants: g,
                startCallOptions: S
            });
        }
        join(g, f) {
            var _f_audioOptions;
            this.assertCallContext(g);
            const S = !!(f === null || f === void 0 ? void 0 : (_f_audioOptions = f.audioOptions) === null || _f_audioOptions === void 0 ? void 0 : _f_audioOptions.muted);
            return this.logger.info(`join with video=${!!(f === null || f === void 0 ? void 0 : f.videoOptions)},muted=${S}`), this.createCall({
                teamsCallContext: g,
                startCallOptions: f
            });
        }
        async dispose() {
            var _this__parsedTokenCredential, _this__parsedTokenCredential1;
            if (this._disposed) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.CTE_ALREADY_DISPOSED
            });
            this._disposed = !0, this._abortController.abort(), this._extensibleApi.dispose(), ((_this__parsedTokenCredential = this._parsedTokenCredential) === null || _this__parsedTokenCredential === void 0 ? void 0 : _this__parsedTokenCredential.identityMri) && TeamsCallAgentImpl.teamsCallAgents.delete((_this__parsedTokenCredential1 = this._parsedTokenCredential) === null || _this__parsedTokenCredential1 === void 0 ? void 0 : _this__parsedTokenCredential1.identityMri);
            try {
                var _this__callStack;
                const g = this._tokenFetchTries > this._maxNmberOfRetries;
                await ((_this__callStack = this._callStack) === null || _this__callStack === void 0 ? void 0 : _this__callStack.dispose(g));
            } catch (g) {
                this.logger.error("Call Agent failed to dispose to Call Stack");
            }
            this.offTrouterStateChanged(this._trouterStateChangeCallback), this._callStack.offRegisteredChanged(this._registrarStateChangeCallback), delete this._callStack, this._telemetryLogManager.clearTelemetryLoggers(), this._eventEmitter.removeAllListeners(), this._internalEventEmitter.emit("disposed"), this._internalEventEmitter.removeAllListeners();
        }
        on(g, f) {
            if ("incomingCall" !== g && "callsUpdated" !== g && "connectionStateChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.EVENT_SUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            if ("incomingCall" !== g && "callsUpdated" !== g && "connectionStateChanged" !== g) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.EVENT_UNSUBSCRIBE,
                defaultErrorMessageArgs: [
                    g
                ]
            });
            this._eventEmitter.off(g, f);
        }
        createCall(g) {
            var _g_teamsCallContext, _g_teamsCallContext1, _g_teamsCallContext2, _g_teamsCallContext3, _g_teamsCallContext4, _g_teamsCallContext5, _g_teamsCallContext6, _g_teamsCallContext7, _g_teamsCallContext8, _g_teamsCallContext9, _g_teamsCallContext10, _g_teamsCallContext11;
            let f, v, _, C = g === null || g === void 0 ? void 0 : (_g_teamsCallContext = g.teamsCallContext) === null || _g_teamsCallContext === void 0 ? void 0 : _g_teamsCallContext.threadId, E = !1;
            const T = g === null || g === void 0 ? void 0 : (_g_teamsCallContext1 = g.teamsCallContext) === null || _g_teamsCallContext1 === void 0 ? void 0 : _g_teamsCallContext1.meetingLink, I = g === null || g === void 0 ? void 0 : (_g_teamsCallContext2 = g.teamsCallContext) === null || _g_teamsCallContext2 === void 0 ? void 0 : _g_teamsCallContext2.meetingId, b = (g === null || g === void 0 ? void 0 : (_g_teamsCallContext3 = g.teamsCallContext) === null || _g_teamsCallContext3 === void 0 ? void 0 : _g_teamsCallContext3.passcode) || "", A = !!(g === null || g === void 0 ? void 0 : g.participants) && Array.isArray(g === null || g === void 0 ? void 0 : g.participants) && (g === null || g === void 0 ? void 0 : g.participants.length) > 1;
            if (this.isCteUser() && A && (C = (g === null || g === void 0 ? void 0 : g.startCallOptions).threadId), !isProxyAndCustomTurnAllowed(this.acsProxy, this.acsCustomRelayManager, !0)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.PROXY_CUSTOM_TURN_FORBIDDEN
            });
            if (T) {
                if (isLongMeetingUrl(T)) v = parseLongMeetingLink(T);
                else {
                    if (!isShortMeetingUrl(T, this.logger)) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.INVALID_MEETING_LINK
                    });
                    if (isTflMeetingLink(T.trim().toLocaleLowerCase(), getAcsEcsConfig().calling.tfl.hosts)) throw new CallingCommunicationError({
                        defaultError: O.CALL_AGENT.UNSUPPORTED_TFL_MEETING_JOIN
                    });
                    E = !0;
                }
            }
            if ((g === null || g === void 0 ? void 0 : (_g_teamsCallContext4 = g.teamsCallContext) === null || _g_teamsCallContext4 === void 0 ? void 0 : _g_teamsCallContext4.threadId) && (g === null || g === void 0 ? void 0 : (_g_teamsCallContext5 = g.teamsCallContext) === null || _g_teamsCallContext5 === void 0 ? void 0 : _g_teamsCallContext5.organizerId) && (g === null || g === void 0 ? void 0 : (_g_teamsCallContext6 = g.teamsCallContext) === null || _g_teamsCallContext6 === void 0 ? void 0 : _g_teamsCallContext6.tenantId) && (v = {
                threadId: g === null || g === void 0 ? void 0 : (_g_teamsCallContext7 = g.teamsCallContext) === null || _g_teamsCallContext7 === void 0 ? void 0 : _g_teamsCallContext7.threadId,
                messageId: (g === null || g === void 0 ? void 0 : (_g_teamsCallContext8 = g.teamsCallContext) === null || _g_teamsCallContext8 === void 0 ? void 0 : _g_teamsCallContext8.messageId) ? g === null || g === void 0 ? void 0 : (_g_teamsCallContext9 = g.teamsCallContext) === null || _g_teamsCallContext9 === void 0 ? void 0 : _g_teamsCallContext9.messageId.toString() : "0",
                organizerId: g === null || g === void 0 ? void 0 : (_g_teamsCallContext10 = g.teamsCallContext) === null || _g_teamsCallContext10 === void 0 ? void 0 : _g_teamsCallContext10.organizerId,
                tenantId: g === null || g === void 0 ? void 0 : (_g_teamsCallContext11 = g.teamsCallContext) === null || _g_teamsCallContext11 === void 0 ? void 0 : _g_teamsCallContext11.tenantId
            }), v && (_ = {
                meetingType: "0" === v.messageId ? 1 : 2,
                tenantId: v.tenantId,
                organizerId: v.organizerId,
                replyChainMessageId: v.messageId
            }, C = v.threadId, f = v.messageId), this.tsStack) {
                var _g_startCallOptions;
                const v = w.generateCauseId(), A = generateGuid(), R = generateGuid();
                let P;
                P = I ? this._tsCallRegistry.createCallWithMeetingData({
                    meetingCode: I,
                    passcode: b,
                    threadId: C
                }, A, R, v) : E ? this._tsCallRegistry.createCallWithMeetingData({
                    meetingUrl: T
                }, A, R, v) : this._tsCallRegistry.createCall(C || "", A, R, f, v);
                const M = new TeamsCallImpl({
                    callId: A
                }, this, P, this._telemetryLogManager);
                this.addToCallArray(M), this.handleCallState(M);
                const D = g === null || g === void 0 ? void 0 : (_g_startCallOptions = g.startCallOptions) === null || _g_startCallOptions === void 0 ? void 0 : _g_startCallOptions.onBehalfOfOptions, N = D === null || D === void 0 ? void 0 : D.userId;
                let k;
                if (N) {
                    if ((g === null || g === void 0 ? void 0 : g.startCallOptions).customContext) throw new CallingCommunicationError({
                        defaultError: O.FEATURES.ONE_PHONE_SYSTEM.CUSTOM_CONTEXT_NOT_SUPPORTED
                    });
                    if (S.isMicrosoftTeamsAppIdentifier(N)) k = S.getIdentifierRawId(N);
                    else {
                        var _this_getUserPolicy_teamsCallingPolicy, _this_getUserPolicy;
                        if (!S.isMicrosoftTeamsUserIdentifier(N)) throw new CallingCommunicationError({
                            defaultError: O.IDENTIFIER.INVALID_COMM_USER
                        });
                        if (!getAcsEcsConfig().calling.sharedLineAppearance.enabled) throw new CallingCommunicationError({
                            defaultError: O.FEATURES.SHAREDLINE_APPEARANCE.DISABLED
                        });
                        if (!((_this_getUserPolicy = this.getUserPolicy()) === null || _this_getUserPolicy === void 0 ? void 0 : (_this_getUserPolicy_teamsCallingPolicy = _this_getUserPolicy.teamsCallingPolicy) === null || _this_getUserPolicy_teamsCallingPolicy === void 0 ? void 0 : _this_getUserPolicy_teamsCallingPolicy.allowDelegation)) throw new CallingCommunicationError({
                            defaultError: O.FEATURES.SHAREDLINE_APPEARANCE.DISABLED_BY_CALLING_POLICY
                        });
                        k = S.getIdentifierRawId(N);
                    }
                }
                const L = {
                    threadId: C || "",
                    messageId: f || "",
                    meetingInfo: _,
                    mediaPeerType: 2,
                    onBehalfOf: k
                };
                return M.startCallInternal(g === null || g === void 0 ? void 0 : g.startCallOptions, !!I, g === null || g === void 0 ? void 0 : g.teamsCallContext, L, g === null || g === void 0 ? void 0 : g.participants).catch(noop), M.bindTsCall(), this._eventEmitter.emit("callsUpdated", {
                    added: [
                        M
                    ],
                    removed: []
                }), M;
            }
            throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.STACK_NOT_INIT
            });
        }
        assertParticipants(g) {
            assertIsObject(g, O.CALL_AGENT.USERIDS_MUST_BE_OBJECTS), assertNotNull(g, O.CALL_AGENT.USERIDS_CANNOT_BE_NULL);
        }
        assertCallContext(g) {
            if (!g || this.checkForAtLeastOneValidCallConfig(g) || this.checkForInvalidTeamsMeetingCoordinates(g)) throw new CallingCommunicationError({
                defaultError: O.CALL_AGENT.INVALID_JOIN_LOCATOR
            });
        }
        checkForAtLeastOneValidCallConfig(g) {
            return !g.threadId && !g.meetingLink && !g.meetingId;
        }
        checkForInvalidTeamsMeetingCoordinates(g) {
            return !g.threadId && g.tenantId && g.organizerId || g.threadId && (g.organizerId && !g.tenantId || !g.organizerId && g.tenantId);
        }
        isAcsToTeamsInteropCall(g) {
            let f = !1;
            return this.isCteUser() && (Array.isArray(g) ? g.length >= 1 && g.find((g)=>S.isCommunicationUserIdentifier(g)) && (f = !0) : S.isCommunicationUserIdentifier(g) && (f = !0)), f;
        }
        constructor(f, S, v, _, C, E){
            super(f, S, _, C, v, g.CallAgentKind.TeamsCallAgent, E), this._calls = [], this.handleCallAdded = (g)=>{
                if (!this._calls.find((f)=>f.id === g.callId)) {
                    const f = g.on("callStateChanged", ()=>{
                        if (1 === g.state) {
                            const S = g.callId;
                            f.dispose();
                            const v = new TeamsCallImpl({
                                callId: S,
                                isIncoming: !0
                            }, this, g, this._telemetryLogManager), _ = new TeamsIncomingCallImpl(v);
                            this.handleCallState(v), v.bindTsCall(), this._eventEmitter.emit("incomingCall", {
                                incomingCall: _
                            });
                        }
                    });
                }
            }, this.handleCallRemoved = (g)=>{
                this.logger.info(`removing callId=${g.callId}`);
                const f = this._calls.find((f)=>f.id === g.callId);
                if (f) {
                    if (f.isBreakoutRoomCall) {
                        const g = getAcsEcsConfig().calling.breakoutRooms.hangUpCallDelayInMilliSeconds;
                        setTimeout(()=>{
                            this.disposeCall(f);
                        }, g);
                    } else this.disposeCall(f);
                    this._eventEmitter.emit("callsUpdated", {
                        added: [],
                        removed: [
                            f
                        ]
                    }), this.logger.info("call removed");
                }
            }, this.handleCallState = (g)=>{
                g.on("stateChanged", ()=>{
                    try {
                        if ("Disconnected" === g.state) this.tsStack ? (this._tsCallRegistry.deleteCall(g.tsCall) || this.logger.error(`Failed to remove call from registry, call id: ${g.id}`), g.stats.flushEvents(), this._telemetryLogManager.flushAllEvents(g.id).catch(()=>{
                            this.logger.error("Failed to flush telemetry log manager events");
                        })) : this.logger.info("Unable to remove call from registry");
                        else "Connecting" === g.state && "Incoming" == g.direction && (this.addToCallArray(g), this._eventEmitter.emit("callsUpdated", {
                            added: [
                                g
                            ],
                            removed: []
                        }));
                    } catch (g) {
                        this.logger.error("Failed to handle call state changed event");
                    }
                });
            }, this.logger = S;
        }
    }
    TeamsCallAgentImpl.teamsCallAgents = new Map, __decorate$u([
        syncOperation(TS.StartCall),
        __metadata$u("design:type", Function),
        __metadata$u("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$u("design:returntype", Object)
    ], TeamsCallAgentImpl.prototype, "startCall", null), __decorate$u([
        syncOperation(TS.Join),
        __metadata$u("design:type", Function),
        __metadata$u("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$u("design:returntype", Object)
    ], TeamsCallAgentImpl.prototype, "join", null), __decorate$u([
        asyncOperation(TS.Dispose),
        __metadata$u("design:type", Function),
        __metadata$u("design:paramtypes", []),
        __metadata$u("design:returntype", Promise)
    ], TeamsCallAgentImpl.prototype, "dispose", null);
    class AcsProxy {
        get proxyInUse() {
            return this._proxyInUse;
        }
        set proxyInUse(g) {
            this._proxyInUse = g;
        }
        get proxyUrl() {
            var _this__proxyUrl;
            return ((_this__proxyUrl = this._proxyUrl) === null || _this__proxyUrl === void 0 ? void 0 : _this__proxyUrl.toString()) || "";
        }
        set proxyUrl(g) {
            if (g.length < 4) throw new CallingCommunicationError({
                defaultError: O.CALL_CLIENT.PROXY_SHORT_URL
            });
            "/" !== g.slice(-1) && (g = g.concat("", "/"));
            try {
                const f = new URL(g);
                if ("https:" !== f.protocol && "http:" !== f.protocol) throw new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.PROXY_PROTOCOL
                });
                this._proxyUrl = f;
            } catch (f) {
                const S = new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.SETUP_PROXY,
                    defaultErrorMessageArgs: [
                        g
                    ],
                    originalError: f
                });
                throw this.logger.error(S.message), S;
            }
        }
        hasProxyUrl() {
            return !!this._proxyUrl;
        }
        proxyfyUrl(g) {
            let f = g;
            if (!this._proxyUrl) return this.logger.info(`Proxy url not defined, return original ${f}`), f;
            try {
                const g = new URL(f);
                f = `${`${g.protocol}//${this._proxyUrl.host}${this._proxyUrl.pathname}`}${g.host}${g.pathname}${g.search}`, this.logger.info(`Proxyfing url from ${g} to ${f}`);
            } catch (g) {
                const f = `Failed proxyfy url with error: ${JSON.stringify(g)}, returning original`;
                this.logger.error(f);
            }
            return this._proxyInUse = !0, f;
        }
        constructor(){
            this._proxyInUse = !1;
            const g = f.createClientLogger("ACS-calling");
            this.logger = new DefaultLogger(g, [
                ()=>"AcsProxy"
            ]);
        }
    }
    class AcsCustomRelayManager {
        getRelayConfig() {
            return this._relayConfig;
        }
        setRelayConfig(g) {
            this._relayConfig = {
                ...g
            }, this._logger.info("Custom relay config provided"), this._hasCustomRelay = !0, this._createTsRelayManager();
        }
        get hasRelayConfig() {
            return this._hasCustomRelay;
        }
        get customRelayManagerInUse() {
            return this._customRelayManagerInUse;
        }
        set customRelayManagerInUse(g) {
            this._customRelayManagerInUse = g;
        }
        getTsRelayManager() {
            return this._tsRelayManager;
        }
        _createTsRelayManager() {
            if (!this._hasCustomRelay || !this._relayConfig || this._relayConfig.iceServers.length < 1) return void this._logger.warn("No relay config provided. No op.");
            const g = [];
            this._relayConfig.iceServers.forEach((f)=>{
                f.urls.forEach((S)=>{
                    const v = this._getIndividualRelay(S, f === null || f === void 0 ? void 0 : f.username, f === null || f === void 0 ? void 0 : f.credential);
                    g.push(v);
                });
            }), this._tsRelayManager = {
                initialize () {},
                queryRelaysAsync: (f)=>Promise.resolve(g)
            };
        }
        _getIndividualRelay(g, f, S) {
            const v = 3478, _ = [], C = [], E = [
                Ay.turn,
                Ay.turns,
                Ay.stun
            ], T = [
                Ry.tcp,
                Ry.tls,
                Ry.udp
            ];
            let I;
            try {
                I = new URL(g);
            } catch (f) {
                throw new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.RELAY_INFO,
                    defaultErrorMessageArgs: [
                        g
                    ],
                    originalError: f
                });
            }
            const b = I.protocol.replace(":", "");
            if (!E.includes(b)) throw new CallingCommunicationError({
                defaultError: O.CALL_CLIENT.RELAY_UNRECOGNIZED_SCHEMA
            });
            let A, R = "";
            try {
                R = I.href.replace(/((turn)s?|stun):/, "https:"), A = new URL(R);
            } catch (g) {
                throw new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.RELAY_INFO,
                    defaultErrorMessageArgs: [
                        R
                    ],
                    originalError: g
                });
            }
            var _A_searchParams_get;
            let P = (_A_searchParams_get = A.searchParams.get("transport")) !== null && _A_searchParams_get !== void 0 ? _A_searchParams_get : "";
            T.includes(P) || (this._logger.warn(`Unknown transport protocol detected for the provided turn, defaulting to ${Ry.udp}`), P = Ry.udp);
            let w = "" === A.port ? this._extractPortFromUrl(I) : Number(A.port);
            w || (this._logger.warn(`Could not read port from relay url, defaulting to ${v}`), w = v);
            let M = A.hostname;
            return isIpv4Address(M) ? _.push(M) : C.push(M), {
                addresses: _,
                udpPort: P === Ry.udp ? w : void 0,
                tcpPort: P === Ry.tcp ? w : void 0,
                tlsPort: P === Ry.tls ? w : void 0,
                username: f !== null && f !== void 0 ? f : "",
                password: S !== null && S !== void 0 ? S : "",
                type: "turn",
                fqdns: C
            };
        }
        _extractPortFromUrl(g) {
            var _g_href_match;
            const f = (_g_href_match = g.href.match(gS)) === null || _g_href_match === void 0 ? void 0 : _g_href_match[0];
            return Number(f === null || f === void 0 ? void 0 : f.replace(":", ""));
        }
        constructor(){
            this._hasCustomRelay = !1, this._customRelayManagerInUse = !1;
            const g = f.createClientLogger("ACS-calling");
            this._logger = new DefaultLogger(g, [
                ()=>"AcsCustomRelayManager"
            ]);
        }
    }
    var kA, __decorate$v = function(g, f, S, v) {
        var _, C = arguments.length, E = C < 3 ? f : null === v ? v = Object.getOwnPropertyDescriptor(f, S) : v;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) E = Reflect.decorate(g, f, S, v);
        else for(var T = g.length - 1; T >= 0; T--)(_ = g[T]) && (E = (C < 3 ? _(E) : C > 3 ? _(f, S, E) : _(f, S)) || E);
        return C > 3 && E && Object.defineProperty(f, S, E), E;
    }, __metadata$v = function(g, f) {
        if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(g, f);
    };
    let LA = 1;
    class CallClient {
        get callAgent() {
            return this._callAgent;
        }
        get teamsCallAgent() {
            return this._teamsCallAgent;
        }
        get sdkDiagnosticInformation() {
            return this._sdkDiagnosticInformation;
        }
        get telemetryLogManager() {
            return this._telemetryLogManager;
        }
        setCallAgent(g) {
            this._callAgent = g;
        }
        setTeamsCallAgent(g) {
            this._teamsCallAgent = g;
        }
        on(g, f) {
            this._eventEmitter.on(g, f);
        }
        off(g, f) {
            this._eventEmitter.off(g, f);
        }
        createInstance(g) {
            return new CallClient(g);
        }
        get acsProxy() {
            return this._acsProxy;
        }
        get acsCustomRelayManager() {
            return this._acsCustomRelayManager;
        }
        getSDKVersion() {
            return getSdkVersion();
        }
        feature(g) {
            return this._extensibleApi.getApiObjectInstance(g.callClientApiCtor);
        }
        async createCallAgent(g, f) {
            var _this__callAgent__caConfigBag, _this__callAgent;
            const { identityMri: S } = await parseTokenCredential(g);
            if (((_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : (_this__callAgent__caConfigBag = _this__callAgent._caConfigBag) === null || _this__callAgent__caConfigBag === void 0 ? void 0 : _this__callAgent__caConfigBag.identityMri) === S) return this._callAgent;
            if ((this._callAgent || this._teamsCallAgent) && logErrorAndThrow(O.CALL_CLIENT.ONE_CALL_AGENT_PER_CALL_CLIENT, this.logger), this._callAgent = CallAgentImpl.callAgents.get(S), this._callAgent) return this._callAgent.onDisposed(()=>{
                this._callAgent = void 0;
            }), this._eventEmitter.emit("callAgentCreated"), this._callAgent;
            this.validateEmergencyCountryCode(f);
            try {
                return this._callAgent = new CallAgentImpl(this, this.logger, this._callStack, this.clientId, this._telemetryLogManager, this._deviceManager, f), await this._callAgent.initialize(g, f), this._callAgent.onDisposed(()=>{
                    this._callAgent = void 0;
                }), this._eventEmitter.emit("callAgentCreated"), this._callAgent;
            } catch (g) {
                throw this._callAgent = void 0, new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.CREATE_CALL_AGENT,
                    originalError: g
                });
            }
        }
        async createTeamsCallAgent(g, f) {
            var _this__teamsCallAgent__caConfigBag, _this__teamsCallAgent;
            const { identityMri: S } = await parseTokenCredential(g);
            if (((_this__teamsCallAgent = this._teamsCallAgent) === null || _this__teamsCallAgent === void 0 ? void 0 : (_this__teamsCallAgent__caConfigBag = _this__teamsCallAgent._caConfigBag) === null || _this__teamsCallAgent__caConfigBag === void 0 ? void 0 : _this__teamsCallAgent__caConfigBag.identityMri) === S) return this._teamsCallAgent;
            if ((this._callAgent || this._teamsCallAgent) && logErrorAndThrow(O.CALL_CLIENT.ONE_CALL_AGENT_PER_CALL_CLIENT, this.logger), this._teamsCallAgent = TeamsCallAgentImpl.teamsCallAgents.get(S), this._teamsCallAgent) return this._teamsCallAgent.onDisposed(()=>{
                this._teamsCallAgent = void 0;
            }), this._eventEmitter.emit("teamsCallAgentCreated"), this._teamsCallAgent;
            try {
                return this._teamsCallAgent = new TeamsCallAgentImpl(this, this.logger, this._callStack, this.clientId, this._telemetryLogManager, this._deviceManager), await this._teamsCallAgent.initialize(g, f), this._teamsCallAgent.onDisposed(()=>{
                    this._teamsCallAgent = void 0;
                }), this._eventEmitter.emit("teamsCallAgentCreated"), this._teamsCallAgent;
            } catch (g) {
                throw this._teamsCallAgent = void 0, new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.CREATE_TEAMS_CALL_AGENT,
                    originalError: g
                });
            }
        }
        async getDeviceManager() {
            return await this._deviceManager.getDeviceManager(), this._deviceManager;
        }
        async getEnvironmentInfoInternal() {
            return this._environmentInfos || (await this._callStack.createStackBase(), this._environmentInfos = getEnvironmentInfos()), this._environmentInfos;
        }
        validateEmergencyCountryCode(g) {
            var _g_emergencyCallOptions, _g_emergencyCallOptions1;
            (g === null || g === void 0 ? void 0 : (_g_emergencyCallOptions = g.emergencyCallOptions) === null || _g_emergencyCallOptions === void 0 ? void 0 : _g_emergencyCallOptions.countryCode) && ((_g_emergencyCallOptions1 = g.emergencyCallOptions) === null || _g_emergencyCallOptions1 === void 0 ? void 0 : _g_emergencyCallOptions1.countryCode.length) > cf && logErrorAndThrow(O.CALL_CLIENT.EMERGENCY_CODE_TOO_LONG, this.logger);
        }
        sendOrientationChangeEvent(g, f = !1) {
            var _this__callAgent__calls, _this__callAgent;
            if ((_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : (_this__callAgent__calls = _this__callAgent._calls) === null || _this__callAgent__calls === void 0 ? void 0 : _this__callAgent__calls.length) try {
                this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_orientation_changed,
                    tenant: nf,
                    properties: {
                        orientation: g,
                        isInitial: f
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send orientation change telemetry");
            }
        }
        sendInitialOrientation() {
            let g = screen.orientation && screen.orientation.type;
            g || (g = this.getOrientationBasedOnWindowSize()), this.sendOrientationChangeEvent(g, !0);
        }
        sendCallClientInitEvent(g) {
            try {
                this._telemetryLogManager.sendEvent({
                    name: g.eventName,
                    tenant: nf,
                    properties: g
                });
            } catch (g) {
                this.logger.debug("Unable to send CallClient initialized telemetry event");
            }
        }
        hangupCalls() {
            try {
                var _this__callAgent;
                "Mobile" === getBrowserInfo().formFactor && getAcsEcsConfig().calling.hangUpCallOnPageHide && ((_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : _this__callAgent.calls.forEach((g)=>g.hangUp()));
            } catch (g) {
                try {
                    this.logger.error(`Unable to hangup call on page hide due to ${JSON.stringify(g)}`);
                } catch (g) {
                    this.logger.error("Unable to hangup call on page hide due to unknown error");
                }
            }
        }
        sendPageVisibilityInfoEvent(g, f) {
            var _this__callAgent__calls, _this__callAgent;
            if ((_this__callAgent = this._callAgent) === null || _this__callAgent === void 0 ? void 0 : (_this__callAgent__calls = _this__callAgent._calls) === null || _this__callAgent__calls === void 0 ? void 0 : _this__callAgent__calls.length) try {
                this._telemetryLogManager.sendEvent({
                    name: dy.acs_calling_page_hidden,
                    tenant: nf,
                    properties: {
                        eventName: g,
                        pageHidden: f
                    }
                });
            } catch (g) {
                this.logger.debug("Unable to send page hide telemetry");
            }
        }
        getTelemetryTag() {
            return this._customProxyAndTurnInformation.proxy && this._customProxyAndTurnInformation.turn ? lS.usedProxyAndNonMsftTurn : this._customProxyAndTurnInformation.proxy ? lS.onlyUsedProxy : this._customProxyAndTurnInformation.turn ? lS.onlyUsedNonMsftTurn : "";
        }
        constructor(g){
            this._customProxyAndTurnInformation = {
                proxy: null,
                turn: null
            }, this.sendTelemetry = ()=>{
                try {
                    if (getAcsEcsConfig().telemetry.telemetryBeforeUnload && this._callAgent && this._callAgent._calls) for (const g of this._callAgent._calls)g.tsCall.sendLastKnownStats();
                } catch (g) {
                    this.logger.debug("Error logging telemetry", g);
                }
            }, this.handleVisibilityChange = ()=>{
                "hidden" === document.visibilityState ? (this.logger.debug("Visibility changed to hidden"), this.sendPageVisibilityInfoEvent("visibilityChange", !0), this.hangupCalls()) : (this.logger.debug("Visibility changed to visible"), this.sendPageVisibilityInfoEvent("visibilityChange", !1));
            }, this.handlePageShow = ()=>{
                this.logger.debug("Page show"), this.sendPageVisibilityInfoEvent("pageShow", !0);
            }, this.handlePageHide = ()=>{
                this.logger.debug("Page hide"), this.sendPageVisibilityInfoEvent("pageHide", !1);
            }, this.handleOrientationChange = ()=>{
                this.logger.debug(`Orientation changed to ${screen.orientation.type}`), this.sendOrientationChangeEvent(screen.orientation.type);
            }, this.getOrientationBasedOnWindowSize = ()=>window.innerHeight > window.innerWidth ? "portrait-primary" : "landscape-primary", this.handleResize = ()=>{
                const g = this.getOrientationBasedOnWindowSize();
                this._previousOrientation !== g && (this._previousOrientation = g, this.sendOrientationChangeEvent(g));
            };
            const S = +new Date;
            this.clientId = generateGuid();
            const v = (g === null || g === void 0 ? void 0 : g.logger) || f.createClientLogger("ACS-calling"), _ = LA++;
            if (this._acsProxy = new AcsProxy, this._acsCustomRelayManager = new AcsCustomRelayManager, g === null || g === void 0 ? void 0 : g.networkConfiguration) {
                var _g_networkConfiguration_proxy;
                ((_g_networkConfiguration_proxy = g.networkConfiguration.proxy) === null || _g_networkConfiguration_proxy === void 0 ? void 0 : _g_networkConfiguration_proxy.url) && (this._customProxyAndTurnInformation.proxy = {
                    ...g.networkConfiguration.proxy
                }, this._acsProxy.proxyUrl = this._customProxyAndTurnInformation.proxy.url), g.networkConfiguration.turn && (this._customProxyAndTurnInformation.turn = {
                    ...g.networkConfiguration.turn
                }, this._acsCustomRelayManager.setRelayConfig(this._customProxyAndTurnInformation.turn));
                const f = this.getTelemetryTag();
                g.diagnostics ? g.diagnostics.tags ? g.diagnostics.tags.push(f) : g.diagnostics.tags = [
                    f
                ] : g.diagnostics = {
                    tags: [
                        f
                    ]
                };
            }
            this.logger = new DefaultLogger(v, [
                ()=>`CallClient${_}[${this.clientId}]`
            ]), this._eventEmitter = new CallingEventEmitter(this.logger), this._sdkDiagnosticInformation = buildCallingUserAgent(getSdkVersion(), this.logger, g), this.diagnosticOptions = g === null || g === void 0 ? void 0 : g.diagnostics, this.firstPartyOptions = g === null || g === void 0 ? void 0 : g.firstPartyOptions, this._telemetryLogManager = new TelemetryLogManager(this.logger, this._sdkDiagnosticInformation, this._acsProxy, this._acsCustomRelayManager);
            try {
                var _this_firstPartyOptions;
                this.sendCallClientInitEvent({
                    eventName: dy.acs_calling_call_client_init,
                    kindOfEvent: "attempt",
                    timestampInfo: "",
                    additionalDetails: ""
                }), Object.defineProperty(globalThis, Ff, {
                    value: _,
                    writable: !0,
                    enumerable: !1
                }), 1 === _ && Object.defineProperty(globalThis, Lf, {
                    value: this._telemetryLogManager,
                    writable: !1,
                    enumerable: !1
                }), this.logger.info("created"), this._callStack = new CallStack(this.logger, this.clientId, this._telemetryLogManager, this._sdkDiagnosticInformation, this._acsProxy, this._acsCustomRelayManager, (_this_firstPartyOptions = this.firstPartyOptions) === null || _this_firstPartyOptions === void 0 ? void 0 : _this_firstPartyOptions.encodedStreamsJsPath), this._deviceManager = new DeviceManagerImpl(this.logger, this._callStack, this._telemetryLogManager), this._previousOrientation = "", this.sendInitialOrientation(), window.addEventListener("beforeunload", this.sendTelemetry), window.addEventListener("visibilitychange", this.handleVisibilityChange, !1), window.addEventListener("pageshow", this.handlePageShow, !1), window.addEventListener("pagehide", this.handlePageHide, !1), screen.orientation ? screen.orientation.addEventListener("change", this.handleOrientationChange) : window.addEventListener("resize", this.handleResize, !1), this._extensibleApi = new ExtensibleFeatureImpl(this.logger, {
                    callClient: this
                }, {
                    callClient: this,
                    telemetryLogManager: this._telemetryLogManager
                });
                const g = getRegisteredFeatures(Fy.CallClientFeature);
                for (const f of g)"OnExtendedObjectConstructor" === f.activationOptions.activationEvent && this.feature(f);
                this.sendCallClientInitEvent({
                    eventName: dy.acs_calling_call_client_init,
                    kindOfEvent: "success",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: ""
                });
            } catch (g) {
                const f = new CallingCommunicationError({
                    defaultError: O.CALL_CLIENT.INIT_CALL_CLIENT,
                    originalError: g
                });
                throw this.sendCallClientInitEvent({
                    eventName: dy.acs_calling_call_client_init,
                    kindOfEvent: "failure",
                    timestampInfo: {
                        deltaTimeInMs: +new Date - S
                    },
                    additionalDetails: {
                        failureReason: f.message,
                        code: f.code,
                        subCode: f.subCode,
                        ...extractCommunicationServicesErrorForTelemetry(f)
                    }
                }), f;
            }
        }
    }
    __decorate$v([
        loggerProperty,
        __metadata$v("design:type", Object)
    ], CallClient.prototype, "logger", void 0), __decorate$v([
        syncOperation(ES.GetSDKVersion),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", []),
        __metadata$v("design:returntype", String)
    ], CallClient.prototype, "getSDKVersion", null), __decorate$v([
        syncOperation(ES.Feature),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", [
            Object
        ]),
        __metadata$v("design:returntype", "function" == typeof (kA = "undefined" != typeof TFeature && TFeature) ? kA : Object)
    ], CallClient.prototype, "feature", null), __decorate$v([
        asyncOperation(ES.CreateCallAgent),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$v("design:returntype", Promise)
    ], CallClient.prototype, "createCallAgent", null), __decorate$v([
        asyncOperation(ES.CreateTeamsCallAgent),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", [
            Object,
            Object
        ]),
        __metadata$v("design:returntype", Promise)
    ], CallClient.prototype, "createTeamsCallAgent", null), __decorate$v([
        asyncOperation(ES.GetDeviceManager),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", []),
        __metadata$v("design:returntype", Promise)
    ], CallClient.prototype, "getDeviceManager", null), __decorate$v([
        asyncOperation(ES.GetEnvironmentInfo),
        __metadata$v("design:type", Function),
        __metadata$v("design:paramtypes", []),
        __metadata$v("design:returntype", Promise)
    ], CallClient.prototype, "getEnvironmentInfoInternal", null), g.CallClient = CallClient, g.Features = mb, g.LocalAudioStream = LocalAudioStream, g.LocalVideoStream = LocalVideoStream, g.VideoStreamRenderer = VideoStreamRenderer, Object.defineProperty(g, "__esModule", {
        value: !0
    });
});



var $f19az = parcelRequire("f19az");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");









const $2d80563ed05fed7d$var$IconComponent = {
    connecting: (0, $dee41ba920963cc7$export$2e2bcd8739ae039),
    ringing: (0, $756dda2289d9c53f$export$2e2bcd8739ae039),
    connected: (0, $c9195da5caeb5ffe$export$2e2bcd8739ae039),
    disconnected: (0, $c9e4713e7e3526f7$export$2e2bcd8739ae039),
    noAnswer: (0, $c9e4713e7e3526f7$export$2e2bcd8739ae039),
    error: (0, $7f4a49b3533c9276$export$2e2bcd8739ae039)
};
const $2d80563ed05fed7d$var$StatusIcon = ({ status: status })=>{
    const StatusIconComponent = (0, $eZVvM.useMemo)(()=>$2d80563ed05fed7d$var$IconComponent[status], [
        status
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)(StatusIconComponent, {
        width: "6.4rem",
        height: "6.4rem"
    });
};
const $2d80563ed05fed7d$var$TeamsCallModal = ({ status: status, onEndCall: onEndCall, onClose: onClose, willNavigateToAccessControl: willNavigateToAccessControl })=>{
    const statusKey = (0, $eZVvM.useMemo)(()=>{
        if (willNavigateToAccessControl && status === "disconnected") return "disconnectedAccess";
        return status;
    }, [
        willNavigateToAccessControl,
        status
    ]);
    if (!status) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "main-modal",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$755918b48c75c65a)),
                className: "main-modal__background"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $d5f8329c0fec877c$export$e25e478948902b8b).div, {
                ...(0, $cfa01d974fc14a69$export$bd46b8ab3689edc4)((0, $cfa01d974fc14a69$export$1c33d2a8eb772259)),
                className: "main-modal__content text-center",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        className: `text-${status} mt-5`,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: `teamsCall:status.${statusKey}.title`
                        })
                    }),
                    status === "connected" && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h2",
                        style: {
                            height: "7rem"
                        },
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $91d7fbf064bcdcd2$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "main-modal__icon-box",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                            className: "m-auto call",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($2d80563ed05fed7d$var$StatusIcon, {
                                status: status
                            })
                        })
                    }),
                    status !== "disconnected" && status !== "error" && status !== "noAnswer" && /*#__PURE__*/ (0, $bhfvP.jsx)("button", {
                        className: "display-6 py-4 px-5 text-white bg-secondary fs-medium rounded",
                        onClick: onEndCall,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "teamsCall:controls.endCall"
                        })
                    }),
                    (status === "disconnected" || status === "error" || status === "noAnswer") && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "main-modal__close",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $56ba4849816b834d$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $2d80563ed05fed7d$export$2e2bcd8739ae039 = $2d80563ed05fed7d$var$TeamsCallModal;





var $eZVvM = parcelRequire("eZVvM");
/**
 * How long a Teams call may keep ringing before the kiosk gives up on it.
 */ const $f3e1e21c309b45a4$export$abe7ca67bb9884ae = 30000;
/**
 * Ends a call that never leaves the ringing state.
 *
 * When the host's tenant blocks external communication with our domain, the
 * invitation never reaches them and no error comes back either — the call
 * simply rings for as long as the page stays open, which on a kiosk means
 * until the next visitor walks up to it. Teams itself reports a host who is
 * only signed out within a few seconds, so this fires when nothing at all
 * answers.
 */ function $f3e1e21c309b45a4$export$dff45c6e0f8bf788(isRinging, onTimeout, ms = $f3e1e21c309b45a4$export$abe7ca67bb9884ae) {
    const onTimeoutRef = (0, $eZVvM.useRef)(onTimeout);
    (0, $eZVvM.useEffect)(()=>{
        onTimeoutRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (!isRinging) return undefined;
        const timeout = setTimeout(()=>onTimeoutRef.current(), ms);
        return ()=>clearTimeout(timeout);
    }, [
        isRinging,
        ms
    ]);
}


const $dafea7e838a47358$var$TeamsAudioCall = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const type = query.type;
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, willNavigateToCheckinAccessControlPage: willNavigateToCheckinAccessControlPage, isDoorOpening: isDoorOpening, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    const callerAcsToken = query.callerAcsToken;
    const targetTeamsUserIds = query.targetTeamsUserIds;
    const targetTeamsUserId = targetTeamsUserIds === null || targetTeamsUserIds === void 0 ? void 0 : targetTeamsUserIds.split(",")[0];
    const [triggerCall, setTriggerCall] = (0, $eZVvM.useState)(false);
    const [teamsCallAgent, setTeamsCallAgent] = (0, $eZVvM.useState)(null);
    const [call, setCall] = (0, $eZVvM.useState)(null);
    const callRef = (0, $eZVvM.useRef)(null);
    const [callingStatus, setCallingStatus] = (0, $eZVvM.useState)("connecting");
    // Keeps the hang-up we do ourselves from being reported as a normal ending.
    const hasTimedOutRef = (0, $eZVvM.useRef)(false);
    const { startSound: startSound, ringingSound: ringingSound, connectedSound: connectedSound, endSound: endSound, playSound: playSound, stopAllSounds: stopAllSounds } = (0, $dcc94db3b6c367f7$export$a712c06eeb4d5ac8)();
    (0, $eZVvM.useEffect)(()=>{
        callRef.current = call;
    }, [
        call
    ]);
    const startCall = (0, $eZVvM.useCallback)(async ()=>{
        if (!teamsCallAgent || !targetTeamsUserId) {
            console.log("Cannot start call: Target Teams User Id is missing or Teams Call Agent not initialized.");
            setCallingStatus("error");
            return;
        }
        try {
            setCallingStatus("connecting");
            playSound(startSound);
            const call = teamsCallAgent.startCall({
                microsoftTeamsUserId: targetTeamsUserId.trim()
            });
            setCall(call);
            call.on("stateChanged", ()=>{
                console.log("Call state : ", call.state);
                switch(call.state){
                    case "Connecting":
                        playSound(startSound);
                        setCallingStatus("connecting");
                        break;
                    case "Ringing":
                        playSound(ringingSound);
                        setCallingStatus("ringing");
                        break;
                    case "Connected":
                        playSound(connectedSound);
                        setCallingStatus("connected");
                        break;
                    case "LocalHold":
                    case "RemoteHold":
                        setCallingStatus("connected");
                        break;
                    case "Disconnected":
                        playSound(endSound);
                        if (!hasTimedOutRef.current) setCallingStatus("disconnected");
                        break;
                    default:
                        break;
                }
            });
            console.log("Call started.");
        } catch (error) {
            console.log("Failed to start call: ", error);
            setCallingStatus("error");
        }
    }, [
        teamsCallAgent,
        targetTeamsUserId
    ]);
    const handleRingTimeout = (0, $eZVvM.useCallback)(async ()=>{
        console.log("The call was never answered. Hanging up.");
        hasTimedOutRef.current = true;
        setCallingStatus("noAnswer");
        try {
            var _callRef_current, _callRef_current1;
            if (((_callRef_current = callRef.current) === null || _callRef_current === void 0 ? void 0 : _callRef_current.state) !== "Disconnected") await ((_callRef_current1 = callRef.current) === null || _callRef_current1 === void 0 ? void 0 : _callRef_current1.hangUp());
        } catch (error) {
            console.log("Error hanging up unanswered call:", error);
        }
    }, []);
    (0, $f3e1e21c309b45a4$export$dff45c6e0f8bf788)(callingStatus === "ringing", handleRingTimeout);
    const hangUpCall = (0, $eZVvM.useCallback)(async ()=>{
        if (!call) {
            handleCheckinAccessNavigation();
            return;
        }
        try {
            await call.hangUp();
            setCallingStatus("disconnected");
        } catch (error) {
            console.log("Error hanging up call:", error);
            setCallingStatus("error");
        }
    }, [
        call
    ]);
    const onClose = (0, $eZVvM.useCallback)(()=>{
        handleCheckinAccessNavigation();
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        if (triggerCall) startCall();
    }, [
        triggerCall,
        startCall
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const initializeCallAgent = async ()=>{
            if (!callerAcsToken) {
                handleCheckinAccessNavigation();
                return;
            }
            try {
                setCallingStatus("connecting");
                const client = new (0, $cf5b5da7977a3fc4$exports.CallClient)();
                const tokenCredential = new (0, $6rUEX.AzureCommunicationTokenCredential)(callerAcsToken.trim());
                const agent = await client.createTeamsCallAgent(tokenCredential);
                setTeamsCallAgent(agent);
                const deviceManager = await client.getDeviceManager();
                await deviceManager.askDevicePermission({
                    video: true,
                    audio: true
                });
                console.log("Call agent initialized.");
                setTriggerCall(true);
            } catch (error) {
                console.log("Failed to initialize call agent:", error);
                setCallingStatus("error");
            }
        };
        initializeCallAgent();
    }, [
        callerAcsToken,
        navigate
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (callingStatus === "disconnected" || callingStatus === "error" || callingStatus === "noAnswer") setTimeout(()=>{
            handleCheckinAccessNavigation();
        }, 5000);
    }, [
        callingStatus
    ]);
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            stopAllSounds();
            (async ()=>{
                var _callRef_current, _callRef_current1;
                if (((_callRef_current = callRef.current) === null || _callRef_current === void 0 ? void 0 : _callRef_current.state) !== "Disconnected") await ((_callRef_current1 = callRef.current) === null || _callRef_current1 === void 0 ? void 0 : _callRef_current1.hangUp());
                setCall(null);
            })();
        };
    }, []);
    if (isDoorOpening) return accessSwitchModal;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $2d80563ed05fed7d$export$2e2bcd8739ae039), {
        status: callingStatus,
        onEndCall: hangUpCall,
        onClose: onClose,
        willNavigateToAccessControl: willNavigateToCheckinAccessControlPage
    });
};
var $dafea7e838a47358$export$2e2bcd8739ae039 = $dafea7e838a47358$var$TeamsAudioCall;


const $0114ce7038a4576f$export$96e9906d6d93a972 = {
    Connecting: "connecting",
    Ringing: "ringing",
    Open: "open",
    Error: "error",
    Close: "close"
};
const $0114ce7038a4576f$var$ContactButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $d5f8329c0fec877c$export$e25e478948902b8b).button)(({ theme: theme })=>({
        margin: "2.5rem",
        minWidth: "16.4rem",
        padding: "1.5rem",
        borderRadius: "1rem",
        background: theme.palette.primary.main,
        h3: {
            color: theme.palette.primary.contrastText
        },
        "&:disabled": {
            backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.primary.main).lighten(0.4).hex()
        }
    }));
function $0114ce7038a4576f$var$getPreference(receiver, namespace, action) {
    var _receiver_availablePreferences, _preference_channel;
    if (!receiver) return false;
    if (!namespace) return false;
    const preference = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : _receiver_availablePreferences[namespace];
    return !!((preference === null || preference === void 0 ? void 0 : preference.enabled) && (preference === null || preference === void 0 ? void 0 : (_preference_channel = preference.channel) === null || _preference_channel === void 0 ? void 0 : _preference_channel[action]));
}
function $0114ce7038a4576f$var$getAutoPreference(receiver, namespace, action) {
    var _receiver_availablePreferences, _preference_autoChannel;
    if (!receiver) return false;
    if (!namespace) return false;
    const preference = receiver === null || receiver === void 0 ? void 0 : (_receiver_availablePreferences = receiver.availablePreferences) === null || _receiver_availablePreferences === void 0 ? void 0 : _receiver_availablePreferences[namespace];
    return !!((preference === null || preference === void 0 ? void 0 : preference.enabled) && (preference === null || preference === void 0 ? void 0 : (_preference_autoChannel = preference.autoChannel) === null || _preference_autoChannel === void 0 ? void 0 : _preference_autoChannel[action]));
}
const $0114ce7038a4576f$var$ContactPage = ()=>{
    var _accessEventData_accessEvent, _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId, _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId1;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "call"
    ]);
    const history = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)();
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const teams = (0, $cD0nt.useTeams)();
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const googleChat = (0, $cD0nt.useGoogleChat)();
    const mainRoute = new RegExp(`^\/contact\/${id}\/?$`).test(pathname);
    const { data: accessEventData } = (0, $dMu0R.useQuery)([
        `access/event/${id}`
    ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
            id: id
        }), {
        retry: false,
        staleTime: 60000,
        onError: ()=>{
            history("/", {
                replace: true
            });
        }
    });
    const namespace = (0, $eZVvM.useMemo)(()=>{
        var _accessEventData_accessEvent;
        switch(accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type){
            case "Food":
                return "foodDelivery";
            case "Package":
                return "packageDelivery";
            case "Guest":
            case "Visitor":
                return "visitor";
            case "MeetingAttendee":
                return "meetingAttendee";
            default:
                return undefined;
        }
    }, [
        accessEventData
    ]);
    const receiver = accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.receiver;
    const autoEmail = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getAutoPreference(receiver, namespace, "email"), [
        accessEventData
    ]);
    const autoSMS = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getAutoPreference(receiver, namespace, "sms"), [
        accessEventData
    ]);
    const availableForCall = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "call"), [
        accessEventData
    ]);
    const availableForPing = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "ping"), [
        accessEventData
    ]);
    const availableForSMS = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "sms"), [
        accessEventData
    ]);
    const availableForVideoCall = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "videoCall"), [
        accessEventData
    ]);
    const availableForTeamsCall = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "teamsCall"), [
        accessEventData
    ]);
    const availableForTeamsMessage = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "teamsMessage"), [
        accessEventData
    ]);
    const availableForGoogleChatMessage = (0, $eZVvM.useMemo)(()=>$0114ce7038a4576f$var$getPreference(receiver, namespace, "googleChatMessage"), [
        accessEventData
    ]);
    const { data: CallerAcsTokenAndTargetTeamsUserId, status: teamsTokenStatus } = (0, $dMu0R.useQuery)([
        `access/event/${id}/teams`
    ], ()=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$18c24550125dc389), {
            id: id
        });
    }, {
        enabled: availableForTeamsCall,
        retry: false,
        refetchOnWindowFocus: false
    });
    const callerAcsToken = CallerAcsTokenAndTargetTeamsUserId === null || CallerAcsTokenAndTargetTeamsUserId === void 0 ? void 0 : (_CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId = CallerAcsTokenAndTargetTeamsUserId.accessEventGetCallerAcsTokenAndTargetTeamsUserId) === null || _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId === void 0 ? void 0 : _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId.callerAcsToken;
    const targetTeamsUserId = CallerAcsTokenAndTargetTeamsUserId === null || CallerAcsTokenAndTargetTeamsUserId === void 0 ? void 0 : (_CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId1 = CallerAcsTokenAndTargetTeamsUserId.accessEventGetCallerAcsTokenAndTargetTeamsUserId) === null || _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId1 === void 0 ? void 0 : _CallerAcsTokenAndTargetTeamsUserId_accessEventGetCallerAcsTokenAndTargetTeamsUserId1.targetTeamsUserId;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: "/"
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        disableAnimation: !mainRoute,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h1",
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                i18nKey: `call:title.${autoEmail || autoSMS ? "email-sms" : "no-email-sms"}`
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                        className: "mt-5 d-flex flex-wrap justify-content-center",
                        children: [
                            (receiver === null || receiver === void 0 ? void 0 : receiver.phone) && availableForCall && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                disabled: !mainRoute,
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                    onClick: ()=>{
                                        history({
                                            pathname: `call`
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: t("call:callBtn")
                                    })
                                })
                            }),
                            (receiver === null || receiver === void 0 ? void 0 : receiver.phone) && availableForPing && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                disabled: !mainRoute,
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                    onClick: ()=>{
                                        history({
                                            pathname: `ping`
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: t("call:pingBtn")
                                    })
                                })
                            }),
                            (receiver === null || receiver === void 0 ? void 0 : receiver.phone) && availableForSMS && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                disabled: !mainRoute,
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                    onClick: ()=>{
                                        var _accessEventData_accessEvent;
                                        history({
                                            pathname: `message`,
                                            search: `?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                                type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type
                                            })}`
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: t("call:smsBtn")
                                    })
                                })
                            }),
                            availableForVideoCall && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                disabled: !mainRoute,
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                    onClick: ()=>{
                                        var _accessEventData_accessEvent;
                                        return history(`/video-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                            id: id,
                                            type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type
                                        })}`);
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: t("call:callVideoBtn")
                                    })
                                })
                            }),
                            !!teams && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                children: [
                                    availableForTeamsCall && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                        disabled: !mainRoute,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                            disabled: teamsTokenStatus !== "success",
                                            onClick: ()=>{
                                                var _accessEventData_accessEvent, _accessEventData_accessEvent1;
                                                if (teamsVideoCallEnabled) return history(`/teams-video-call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                                    callerAcsToken: callerAcsToken,
                                                    targetTeamsUserIds: targetTeamsUserId,
                                                    type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type
                                                })}`, {
                                                    replace: true
                                                });
                                                const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                                    callerAcsToken: callerAcsToken,
                                                    targetTeamsUserIds: targetTeamsUserId,
                                                    type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent1 = accessEventData.accessEvent) === null || _accessEventData_accessEvent1 === void 0 ? void 0 : _accessEventData_accessEvent1.type
                                                });
                                                return history({
                                                    pathname: "teams-audio-call",
                                                    search: `?${searchParams}`
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: t("call:teamsCallBtn")
                                            })
                                        })
                                    }),
                                    availableForTeamsMessage && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                        disabled: !mainRoute,
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                            onClick: ()=>{
                                                var _accessEventData_accessEvent;
                                                history({
                                                    pathname: "teamsMessage",
                                                    search: `?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                                        type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type
                                                    })}`
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: t("call:teamsMessageBtn")
                                            })
                                        })
                                    })
                                ]
                            }),
                            !!googleChat && availableForGoogleChatMessage && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                disabled: !mainRoute,
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$var$ContactButton, {
                                    onClick: ()=>{
                                        var _accessEventData_accessEvent;
                                        history({
                                            pathname: "googleChatMessage",
                                            search: `?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                                                type: accessEventData === null || accessEventData === void 0 ? void 0 : (_accessEventData_accessEvent = accessEventData.accessEvent) === null || _accessEventData_accessEvent === void 0 ? void 0 : _accessEventData_accessEvent.type
                                            })}`
                                        });
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: t("call:googleChatMessageBtn")
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
                children: [
                    !!(receiver === null || receiver === void 0 ? void 0 : receiver.phone) && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                path: "call",
                                element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $7195b02b4387c5f9$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                path: "ping",
                                element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $7195b02b4387c5f9$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                path: "message",
                                element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $1b818836d3ce10be$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "teams-audio-call",
                        element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $dafea7e838a47358$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "teamsMessage",
                        element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $47c7c543580779e4$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                        path: "googleChatMessage",
                        element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $f17404c021f76fe4$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
var $0114ce7038a4576f$export$2e2bcd8739ae039 = $0114ce7038a4576f$var$ContactPage;



/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");


var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $dMu0R = parcelRequire("dMu0R");







var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $ef2af67617581a1f$var$SvgMicrophone = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "Microphone_svg__bi Microphone_svg__bi-mic-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5"
            })
        ]
    });
var $ef2af67617581a1f$export$2e2bcd8739ae039 = $ef2af67617581a1f$var$SvgMicrophone;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $52b2059741142620$var$SvgMicrophoneOff = (props)=>/*#__PURE__*/ (0, $bhfvP.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "MicrophoneOff_svg__bi MicrophoneOff_svg__bi-mic-mute-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
                d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z"
            })
        ]
    });
var $52b2059741142620$export$2e2bcd8739ae039 = $52b2059741142620$var$SvgMicrophoneOff;




var $jnPOB = parcelRequire("jnPOB");



const $a8b20c5d55c476e9$var$MuiGridCell = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $de9b795dde6747fa$export$1ce951ee41d30605))(({ theme: theme })=>({
        borderRadius: "1rem",
        border: `0.5rem solid ${theme.palette.primary.main}`,
        background: "black"
    }));
const $a8b20c5d55c476e9$var$Controls = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    display: "flex",
    transform: "translateY(-100%)"
});
const $a8b20c5d55c476e9$var$ControlsButton = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        display: "flex",
        padding: "2rem",
        margin: "1rem",
        border: "2px solid white",
        borderRadius: "1rem",
        background: "rgba(35, 35, 35, 0.725)",
        h1: {
            color: "white",
            marginRight: "1rem"
        }
    }));
const $a8b20c5d55c476e9$var$Room = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(({ roomUrl: roomUrl, handleAccessNavigation: handleAccessNavigation })=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const [isMicActive, setIsMicActive] = (0, $eZVvM.useState)(true);
    const orientation = width < height ? "portrait" : "landscape";
    const { state: state, actions: actions } = (0, $de9b795dde6747fa$export$e7be2adb7d898233)(roomUrl, {
        localMediaOptions: {
            audio: true,
            video: true
        }
    });
    const { remoteParticipants: remoteParticipants, connectionStatus: connectionStatus } = state;
    const { joinRoom: joinRoom, leaveRoom: leaveRoom, toggleCamera: toggleCamera, toggleMicrophone: toggleMicrophone } = actions;
    (0, $eZVvM.useEffect)(()=>{
        joinRoom();
        return ()=>{
            leaveRoom();
        };
    }, [
        joinRoom,
        leaveRoom
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (connectionStatus === "left") handleAccessNavigation();
    }, [
        connectionStatus
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
        className: `${remoteParticipants.length === 0 && orientation === "landscape" ? "w-25" : "w-50"} ${remoteParticipants.length === 0 && orientation !== "landscape" ? "h-50" : "h-100"} p-5`,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$9ca22f48fddba890), {
            videoGridGap: 10,
            renderParticipant: ({ participant: participant })=>{
                return /*#__PURE__*/ (0, $bhfvP.jsxs)($a8b20c5d55c476e9$var$MuiGridCell, {
                    participant: participant,
                    className: "video-grid-cell",
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$db6594055fbff7ab), {
                            muted: participant.isLocalClient
                        }),
                        connectionStatus === "connected" && participant.isLocalClient && /*#__PURE__*/ (0, $bhfvP.jsxs)($a8b20c5d55c476e9$var$Controls, {
                            className: "d-flex justify-content-between p-3",
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)($a8b20c5d55c476e9$var$ControlsButton, {
                                    onClick: ()=>{
                                        leaveRoom();
                                    },
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        className: "text-white",
                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                            i18nKey: "videoCall:endCall"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)($a8b20c5d55c476e9$var$ControlsButton, {
                                    onClick: ()=>{
                                        setIsMicActive((prev)=>!prev);
                                        toggleMicrophone();
                                    },
                                    children: isMicActive ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ef2af67617581a1f$export$2e2bcd8739ae039), {
                                        width: "3.5rem",
                                        fill: "white"
                                    }) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $52b2059741142620$export$2e2bcd8739ae039), {
                                        width: "3.5rem",
                                        fill: "white"
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
});
const $a8b20c5d55c476e9$var$VideoCall = ()=>{
    var _data_accessEventCreateVideoRoom, _data_accessEventCreateVideoRoom1;
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search, state: state } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const eventId = query.id;
    const type = query.type;
    const preCreatedRoom = state === null || state === void 0 ? void 0 : state.videoRoom;
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    const { data: data, status: requestStatus } = (0, $dMu0R.useQuery)([
        `access/event/${eventId}/video`
    ], ()=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$c6b5d25ca0fed49a), {
            id: eventId
        });
    }, {
        enabled: !!eventId && !preCreatedRoom,
        retry: false,
        refetchOnWindowFocus: false
    });
    var _preCreatedRoom_id;
    const roomId = (_preCreatedRoom_id = preCreatedRoom === null || preCreatedRoom === void 0 ? void 0 : preCreatedRoom.id) !== null && _preCreatedRoom_id !== void 0 ? _preCreatedRoom_id : data === null || data === void 0 ? void 0 : (_data_accessEventCreateVideoRoom = data.accessEventCreateVideoRoom) === null || _data_accessEventCreateVideoRoom === void 0 ? void 0 : _data_accessEventCreateVideoRoom.id;
    var _preCreatedRoom_roomUrl;
    const roomUrl = (_preCreatedRoom_roomUrl = preCreatedRoom === null || preCreatedRoom === void 0 ? void 0 : preCreatedRoom.roomUrl) !== null && _preCreatedRoom_roomUrl !== void 0 ? _preCreatedRoom_roomUrl : data === null || data === void 0 ? void 0 : (_data_accessEventCreateVideoRoom1 = data.accessEventCreateVideoRoom) === null || _data_accessEventCreateVideoRoom1 === void 0 ? void 0 : _data_accessEventCreateVideoRoom1.roomUrl;
    const roomStatus = preCreatedRoom ? "success" : requestStatus;
    const { mutate: onLeaveRoom } = (0, $084aaf38c3338203$export$609860bf8b0084c)(async (id)=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$c134e77194a5bf4b), {
            id: id
        });
    });
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            if (roomId) onLeaveRoom(roomId);
        };
    }, [
        roomId,
        onLeaveRoom
    ]);
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        if (roomStatus === "error") navigate(-1);
    }, [
        roomStatus,
        navigate
    ]);
    const status = (0, $eZVvM.useMemo)(()=>{
        if (roomStatus === "error") return "error";
        if (roomStatus === "success") return "success";
        return roomStatus;
    }, [
        roomStatus
    ]);
    const [showModal, setShowModal] = (0, $eZVvM.useState)(!preCreatedRoom);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 5000;
        if (status === "success") return 4000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(()=>{
        if (status === "error") onDismiss();
        else if (status === "success") setShowModal(false);
    }, timeout);
    if (!eventId) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "videoCall:title"
                        })
                    })
                }),
                showModal && (roomStatus === "loading" || roomStatus === "error" || status === "success") && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `videoCall:status.${status}.title`
                    }),
                    message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                        i18nKey: `videoCall:status.${status}.message`
                    }),
                    status: status,
                    onDismiss: onDismiss
                }),
                roomUrl && /*#__PURE__*/ (0, $bhfvP.jsx)($a8b20c5d55c476e9$var$Room, {
                    roomUrl: roomUrl,
                    handleAccessNavigation: handleCheckinAccessNavigation
                }),
                accessSwitchModal
            ]
        })
    });
};
var $a8b20c5d55c476e9$export$2e2bcd8739ae039 = $a8b20c5d55c476e9$var$VideoCall;


/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable no-console */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $6rUEX = parcelRequire("6rUEX");
var $jYWbT = parcelRequire("jYWbT");


var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");







var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $edd79a1a6ad1fc95$var$SvgCamera = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "Camera_svg__bi Camera_svg__bi-camera-video-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            fillRule: "evenodd",
            d: "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2z"
        })
    });
var $edd79a1a6ad1fc95$export$2e2bcd8739ae039 = $edd79a1a6ad1fc95$var$SvgCamera;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $e6e7b0a121ee7588$var$SvgCameraOff = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        className: "CameraOff_svg__bi CameraOff_svg__bi-camera-video-off-fill",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            fillRule: "evenodd",
            d: "M10.961 12.365a2 2 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272zm-10.114-9A2 2 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728zm9.746 11.925-10-14 .814-.58 10 14z"
        })
    });
var $e6e7b0a121ee7588$export$2e2bcd8739ae039 = $e6e7b0a121ee7588$var$SvgCameraOff;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $ed1dd38dbb398e71$var$SvgCalling = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            clipRule: "evenodd",
            d: "M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511Z"
        })
    });
var $ed1dd38dbb398e71$export$2e2bcd8739ae039 = $ed1dd38dbb398e71$var$SvgCalling;





var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
const $c32338581a0bb5e8$var$SvgBell = (props)=>/*#__PURE__*/ (0, $bhfvP.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $bhfvP.jsx)("path", {
            d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2ZM8.995 1.099a1 1 0 1 0-1.99 0A5.002 5.002 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901Z",
            fill: "#000"
        })
    });
var $c32338581a0bb5e8$export$2e2bcd8739ae039 = $c32338581a0bb5e8$var$SvgBell;




const $88bc7bfd27d5cf6e$var$Controls = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    marginTop: "1rem",
    width: "70%",
    "@media screen and (orientation: landscape)": {
        marginTop: "0",
        width: "37%"
    }
});
const $88bc7bfd27d5cf6e$var$CallControl = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme, isEnd: isEnd })=>({
        display: "flex",
        alignItems: "center",
        height: "7.25rem",
        padding: "1.75rem 4.5rem",
        margin: isEnd ? "0" : "5rem 0 0",
        border: "2px solid white",
        borderRadius: "1rem",
        backgroundColor: isEnd ? "#D13438" : theme.palette.primary.main,
        h3: {
            color: "white",
            marginLeft: "2.75rem",
            fontSize: "2.75rem"
        },
        ":only-of-type": isEnd ? {
            marginLeft: "auto",
            marginBottom: "2rem"
        } : {}
    }));
const $88bc7bfd27d5cf6e$var$StreamControl = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.75rem 0",
    width: "17rem",
    h3: {
        marginTop: "1rem",
        color: "black",
        fontSize: "2.25rem",
        textAlign: "center"
    }
});
const $88bc7bfd27d5cf6e$var$StreamsContainer = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "@media screen and (orientation: landscape)": {
        flexDirection: "row",
        width: "50%"
    }
});
const $88bc7bfd27d5cf6e$var$Stream = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "100%",
    height: "50%",
    border: "1px solid gray",
    background: " #f2f2f2",
    borderRadius: "1rem",
    overflow: "hidden",
    margin: "1.5rem 0 0 0",
    "@media screen and (orientation: landscape)": {
        width: "50%",
        height: "100%",
        margin: "0 0 0 1.5rem"
    }
});
const $88bc7bfd27d5cf6e$var$StreamMedia = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    "& > *": {
        width: "100%",
        height: "100%"
    },
    "& video": {
        width: "100%",
        height: "100%"
    }
});
const $88bc7bfd27d5cf6e$var$Initials = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "10rem",
    height: "10rem",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#D3D3D3",
    color: "black",
    fontSize: "3rem",
    fontWeight: "bold"
});
const $88bc7bfd27d5cf6e$var$VIEW_OPTIONS = {
    scalingMode: "Crop"
};
/**
 * How long the "nobody answered" message stays on screen before the hang-up
 * takes the visitor back.
 */ const $88bc7bfd27d5cf6e$var$NO_ANSWER_MESSAGE_MS = 4000;
const $88bc7bfd27d5cf6e$var$getInitials = (displayName)=>(displayName || "Unknown").split(" ").map((word)=>word[0]).join("").toUpperCase();
const $88bc7bfd27d5cf6e$var$TeamsVideoCall = ()=>{
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const callerAcsToken = query.callerAcsToken;
    const targetTeamsUserIds = query.targetTeamsUserIds;
    const targetTeamsUserId = targetTeamsUserIds === null || targetTeamsUserIds === void 0 ? void 0 : targetTeamsUserIds.split(",")[0];
    const type = query.type;
    const { handleCheckinAccessNavigation: handleCheckinAccessNavigation, accessSwitchModal: accessSwitchModal } = (0, $3b483b17d943788b$export$bb937f14df32ee16)({
        type: type
    });
    const [triggerCall, setTriggerCall] = (0, $eZVvM.useState)(false);
    const [callClient, setCallClient] = (0, $eZVvM.useState)(null);
    const [teamsCallAgent, setTeamsCallAgent] = (0, $eZVvM.useState)(null);
    const [call, setCall] = (0, $eZVvM.useState)(null);
    const callRef = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(()=>{
        callRef.current = call;
    }, [
        call
    ]);
    const localVideoRef = (0, $eZVvM.useRef)(null);
    const [localVideoStream, setLocalVideoStream] = (0, $eZVvM.useState)(null);
    const [localVideoRenderer, setLocalVideoRenderer] = (0, $eZVvM.useState)(null);
    const remoteVideoRef = (0, $eZVvM.useRef)(null);
    const remoteVideoRendererRef = (0, $eZVvM.useRef)(null);
    const handledParticipantIds = (0, $eZVvM.useRef)(new Set());
    const [isMicActive, setIsMicActive] = (0, $eZVvM.useState)(true);
    const [displayRemoteInitials, setDisplayRemoteInitials] = (0, $eZVvM.useState)(false);
    const [remoteParticipantInitials, setRemoteParticipantInitials] = (0, $eZVvM.useState)();
    const [isRinging, setIsRinging] = (0, $eZVvM.useState)(false);
    const [hasNoAnswer, setHasNoAnswer] = (0, $eZVvM.useState)(false);
    const handleRingTimeout = (0, $eZVvM.useCallback)(()=>{
        console.log("The call was never answered. Hanging up.");
        setIsRinging(false);
        setHasNoAnswer(true);
        setTimeout(async ()=>{
            var _callRef_current;
            // A call that connected during the message is left alone.
            if (((_callRef_current = callRef.current) === null || _callRef_current === void 0 ? void 0 : _callRef_current.state) !== "Ringing") {
                setHasNoAnswer(false);
                return;
            }
            try {
                await callRef.current.hangUp();
            } catch (error) {
                console.log("Error hanging up unanswered call:", error);
            }
        }, $88bc7bfd27d5cf6e$var$NO_ANSWER_MESSAGE_MS);
    }, []);
    (0, $f3e1e21c309b45a4$export$dff45c6e0f8bf788)(isRinging, handleRingTimeout);
    const createLocalVideoStream = (0, $eZVvM.useCallback)(async ()=>{
        if (!callClient) {
            console.log("The local video stream was not created. The call client was not initialized.");
            return null;
        }
        try {
            const deviceManager = await callClient.getDeviceManager();
            const camera = (await deviceManager.getCameras())[0];
            if (camera) {
                const stream = new (0, $cf5b5da7977a3fc4$exports.LocalVideoStream)(camera);
                setLocalVideoStream(stream);
                return stream;
            }
            console.log("The local video stream was not created. No camera device found.");
            return null;
        } catch (error) {
            console.log("Failed to create local video stream:", error);
            return null;
        }
    }, [
        callClient
    ]);
    const startLocalVideo = (0, $eZVvM.useCallback)(async ()=>{
        if (localVideoStream) {
            var _localVideoRef_current;
            const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(localVideoStream);
            const view = await renderer.createView($88bc7bfd27d5cf6e$var$VIEW_OPTIONS);
            setLocalVideoRenderer(renderer);
            (_localVideoRef_current = localVideoRef.current) === null || _localVideoRef_current === void 0 ? void 0 : _localVideoRef_current.replaceChildren(view.target);
            if (call) await call.startVideo(localVideoStream);
        }
    }, [
        localVideoStream,
        call
    ]);
    const stopLocalVideo = (0, $eZVvM.useCallback)(async ()=>{
        if (call && localVideoStream) await call.stopVideo(localVideoStream);
        if (localVideoRenderer) {
            localVideoRenderer.dispose();
            setLocalVideoRenderer(null);
        }
    }, [
        localVideoRenderer,
        call,
        localVideoStream
    ]);
    const clearRemoteStream = (0, $eZVvM.useCallback)(()=>{
        var _remoteVideoRendererRef_current, _remoteVideoRef_current;
        (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
        remoteVideoRendererRef.current = null;
        (_remoteVideoRef_current = remoteVideoRef.current) === null || _remoteVideoRef_current === void 0 ? void 0 : _remoteVideoRef_current.replaceChildren();
        setDisplayRemoteInitials(true);
    }, []);
    const renderRemoteStream = (0, $eZVvM.useCallback)(async (stream)=>{
        var _remoteVideoRendererRef_current, _remoteVideoRef_current;
        (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
        const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(stream);
        const view = await renderer.createView($88bc7bfd27d5cf6e$var$VIEW_OPTIONS);
        remoteVideoRendererRef.current = renderer;
        (_remoteVideoRef_current = remoteVideoRef.current) === null || _remoteVideoRef_current === void 0 ? void 0 : _remoteVideoRef_current.replaceChildren(view.target);
        setDisplayRemoteInitials(false);
    }, []);
    const handleRemoteVideoStream = (0, $eZVvM.useCallback)((stream)=>{
        if (stream.mediaStreamType !== "Video") return;
        stream.on("isAvailableChanged", ()=>{
            if (stream.isAvailable) {
                renderRemoteStream(stream);
                return;
            }
            clearRemoteStream();
        });
        if (stream.isAvailable) {
            renderRemoteStream(stream);
            return;
        }
        setDisplayRemoteInitials(true);
    }, [
        renderRemoteStream,
        clearRemoteStream
    ]);
    const handleRemoteParticipant = (0, $eZVvM.useCallback)((participant)=>{
        if (!participant) return;
        const participantId = (0, $jYWbT.getIdentifierRawId)(participant.identifier);
        if (handledParticipantIds.current.has(participantId)) return;
        handledParticipantIds.current.add(participantId);
        setRemoteParticipantInitials($88bc7bfd27d5cf6e$var$getInitials(participant.displayName));
        setDisplayRemoteInitials(true);
        participant.videoStreams.forEach(handleRemoteVideoStream);
        participant.on("videoStreamsUpdated", ({ added: added, removed: removed })=>{
            added.forEach(handleRemoteVideoStream);
            if (removed.some((stream)=>stream.mediaStreamType === "Video")) clearRemoteStream();
        });
    }, [
        handleRemoteVideoStream,
        clearRemoteStream
    ]);
    const startCall = (0, $eZVvM.useCallback)(async ()=>{
        if (!teamsCallAgent || !targetTeamsUserId) {
            console.log("Cannot start call: Target Teams User Id is missing or Teams Call Agent not initialized.");
            return;
        }
        try {
            var _localVideoRef_current;
            const localStream = await createLocalVideoStream();
            if (!localStream) return;
            const options = {
                videoOptions: {
                    localVideoStreams: [
                        localStream
                    ]
                }
            };
            const call = teamsCallAgent.startCall({
                microsoftTeamsUserId: targetTeamsUserId.trim()
            }, options);
            setCall(call);
            setIsMicActive(!call.isMuted);
            const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(localStream);
            const view = await renderer.createView($88bc7bfd27d5cf6e$var$VIEW_OPTIONS);
            setLocalVideoRenderer(renderer);
            (_localVideoRef_current = localVideoRef.current) === null || _localVideoRef_current === void 0 ? void 0 : _localVideoRef_current.appendChild(view.target);
            call.remoteParticipants.forEach(handleRemoteParticipant);
            call.on("remoteParticipantsUpdated", ({ added: added })=>{
                added.forEach(handleRemoteParticipant);
            });
            call.on("stateChanged", ()=>{
                console.log("Call state : ", call.state);
                if (call.state === "Disconnected") handleCheckinAccessNavigation();
                if (call.state === "Ringing") setIsRinging(true);
                else setIsRinging(false);
            });
            console.log("Call started.");
        } catch (error) {
            console.log("Failed to start call: ", error);
        }
    }, [
        teamsCallAgent,
        targetTeamsUserId,
        createLocalVideoStream,
        handleRemoteParticipant
    ]);
    const hangUpCall = (0, $eZVvM.useCallback)(async ()=>{
        if (!call) return;
        await call.hangUp();
        clearRemoteStream();
        handleCheckinAccessNavigation();
    }, [
        call,
        clearRemoteStream
    ]);
    const toggleMicrophone = (0, $eZVvM.useCallback)(async ()=>{
        if (!call) return;
        if (isMicActive) call.mute();
        else call.unmute();
        setIsMicActive((prev)=>!prev);
    }, [
        call,
        isMicActive
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (triggerCall) startCall();
    }, [
        triggerCall
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const initializeCallAgent = async ()=>{
            if (!callerAcsToken) {
                handleCheckinAccessNavigation();
                return;
            }
            try {
                const client = new (0, $cf5b5da7977a3fc4$exports.CallClient)();
                const tokenCredential = new (0, $6rUEX.AzureCommunicationTokenCredential)(callerAcsToken.trim());
                const agent = await client.createTeamsCallAgent(tokenCredential);
                setCallClient(client);
                setTeamsCallAgent(agent);
                const deviceManager = await client.getDeviceManager();
                await deviceManager.askDevicePermission({
                    video: true,
                    audio: true
                });
                console.log("Call agent initialized.");
                setTriggerCall(true);
            } catch (error) {
                console.log("Failed to initialize call agent:", error);
            }
        };
        initializeCallAgent();
    }, [
        callerAcsToken
    ]);
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            (async ()=>{
                var _callRef_current, _callRef_current1, _remoteVideoRendererRef_current;
                if (((_callRef_current = callRef.current) === null || _callRef_current === void 0 ? void 0 : _callRef_current.state) !== "Disconnected") await ((_callRef_current1 = callRef.current) === null || _callRef_current1 === void 0 ? void 0 : _callRef_current1.hangUp());
                (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
                remoteVideoRendererRef.current = null;
                setCall(null);
                setLocalVideoStream(null);
                setLocalVideoRenderer(null);
            })();
        };
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                    className: "mt-3 mb-4",
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "teamsCall:title"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)($88bc7bfd27d5cf6e$var$Controls, {
                    className: "d-flex justify-content-between align-items-center",
                    children: [
                        (!teamsCallAgent || !call) && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $046757d70188c03a$export$2e2bcd8739ae039), {
                            size: "8rem",
                            style: {
                                marginTop: "5rem",
                                marginLeft: "auto",
                                marginRight: "auto"
                            }
                        }),
                        !!call && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                                    className: "d-flex",
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$StreamControl, {
                                            onClick: ()=>{
                                                if (!localVideoRenderer) {
                                                    startLocalVideo();
                                                    return;
                                                }
                                                stopLocalVideo();
                                            },
                                            children: !!localVideoRenderer ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $edd79a1a6ad1fc95$export$2e2bcd8739ae039), {
                                                        width: "4rem",
                                                        fill: "black"
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                            i18nKey: "teamsCall:controls.camera"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e6e7b0a121ee7588$export$2e2bcd8739ae039), {
                                                        width: "4rem",
                                                        fill: "black"
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                            i18nKey: "teamsCall:controls.cameraOff"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$StreamControl, {
                                            onClick: toggleMicrophone,
                                            children: isMicActive ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ef2af67617581a1f$export$2e2bcd8739ae039), {
                                                        width: "4rem",
                                                        fill: "black"
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                            i18nKey: "teamsCall:controls.mic"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $52b2059741142620$export$2e2bcd8739ae039), {
                                                        width: "4rem",
                                                        fill: "black"
                                                    }),
                                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                        variant: "h3",
                                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                            i18nKey: "teamsCall:controls.micOff"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsxs)($88bc7bfd27d5cf6e$var$CallControl, {
                                    onClick: hangUpCall,
                                    isEnd: true,
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ed1dd38dbb398e71$export$2e2bcd8739ae039), {
                                            width: "3.5rem",
                                            fill: "white",
                                            style: {
                                                transform: "rotate(135deg)"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                            variant: "h3",
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                i18nKey: "teamsCall:controls.endCall"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !!call && /*#__PURE__*/ (0, $bhfvP.jsxs)($88bc7bfd27d5cf6e$var$StreamsContainer, {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsxs)($88bc7bfd27d5cf6e$var$Stream, {
                            className: "position-relative",
                            children: [
                                !localVideoRenderer && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                    className: "position-absolute h-100 w-100 d-flex justify-content-center align-items-center",
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$Initials, {
                                        className: "initials",
                                        children: "DR"
                                    })
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$StreamMedia, {
                                    id: "localVideo",
                                    ref: localVideoRef
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsxs)($88bc7bfd27d5cf6e$var$Stream, {
                            className: "position-relative",
                            children: [
                                displayRemoteInitials && !isRinging && !hasNoAnswer && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                    className: "position-absolute h-100 w-100 d-flex justify-content-center align-items-center",
                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$Initials, {
                                        className: "initials position-relative",
                                        children: remoteParticipantInitials
                                    })
                                }),
                                (isRinging || hasNoAnswer) && /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                                    className: "position-absolute h-100 w-100 d-flex flex-column justify-content-center align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c32338581a0bb5e8$export$2e2bcd8739ae039), {
                                            width: "3.5rem"
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                            variant: "h4",
                                            className: "fs-3 mt-2",
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                i18nKey: hasNoAnswer ? "teamsCall:controls.noAnswer" : "teamsCall:controls.ringing"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$var$StreamMedia, {
                                    id: "remoteVideo",
                                    ref: remoteVideoRef
                                })
                            ]
                        })
                    ]
                }),
                accessSwitchModal
            ]
        })
    });
};
var $88bc7bfd27d5cf6e$export$2e2bcd8739ae039 = $88bc7bfd27d5cf6e$var$TeamsVideoCall;


/* eslint-disable no-console */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $6rUEX = parcelRequire("6rUEX");
var $jYWbT = parcelRequire("jYWbT");


var $f19az = parcelRequire("f19az");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");













const $f83dac2da63b61fd$var$Controls = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    margin: "1rem 0 0",
    width: "70%",
    "@media screen and (orientation: landscape)": {
        margin: "0 0 1rem 0",
        width: "37%"
    }
});
const $f83dac2da63b61fd$var$CallControl = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme, isEnd: isEnd })=>({
        display: "flex",
        alignItems: "center",
        height: "7.25rem",
        padding: "1.75rem 4.5rem",
        margin: isEnd ? "0" : "5rem 0 0",
        border: "2px solid white",
        borderRadius: "1rem",
        backgroundColor: isEnd ? "#D13438" : theme.palette.primary.main,
        h3: {
            color: "white",
            marginLeft: "2.75rem",
            fontSize: "2.75rem"
        },
        ":only-of-type": isEnd ? {
            marginLeft: "auto",
            marginBottom: "2rem"
        } : {}
    }));
const $f83dac2da63b61fd$var$StreamControl = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "1.75rem 0",
    width: "17rem",
    h3: {
        marginTop: "1rem",
        color: "black",
        fontSize: "2.25rem",
        textAlign: "center"
    }
});
const $f83dac2da63b61fd$var$StreamContainer = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "50%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "@media screen and (orientation: landscape)": {
        flexDirection: "row",
        width: "50%"
    }
});
const $f83dac2da63b61fd$var$Stream = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "100%",
    height: "50%",
    border: "1px solid gray",
    background: " #f2f2f2",
    borderRadius: "1rem",
    overflow: "hidden",
    margin: "1.5rem 0 0 0",
    "@media screen and (orientation: landscape)": {
        width: "50%",
        height: "100%",
        margin: "0 0 0 1.5rem"
    }
});
const $f83dac2da63b61fd$var$StreamMedia = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    "& > *": {
        width: "100%",
        height: "100%"
    },
    "& video": {
        width: "100%",
        height: "100%"
    }
});
const $f83dac2da63b61fd$var$Initials = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    width: "10rem",
    height: "10rem",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#D3D3D3",
    color: "black",
    fontSize: "3rem",
    fontWeight: "bold"
});
const $f83dac2da63b61fd$var$VIEW_OPTIONS = {
    scalingMode: "Crop"
};
const $f83dac2da63b61fd$var$getInitials = (displayName)=>(displayName || "Unknown").split(" ").map((word)=>word[0]).join("").toUpperCase();
const $f83dac2da63b61fd$var$TeamsVideoGroupCall = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const callerAcsToken = query.callerAcsToken;
    const targetTeamsUserIds = query.targetTeamsUserIds;
    const allTargetUserIds = (0, $eZVvM.useMemo)(()=>(targetTeamsUserIds === null || targetTeamsUserIds === void 0 ? void 0 : targetTeamsUserIds.split(",").map((id)=>id.trim())) || [], [
        targetTeamsUserIds
    ]);
    const [triggerCall, setTriggerCall] = (0, $eZVvM.useState)(false);
    const [callsStarted, setCallsStarted] = (0, $eZVvM.useState)(false);
    const [callClient, setCallClient] = (0, $eZVvM.useState)(null);
    const [teamsCallAgent, setTeamsCallAgent] = (0, $eZVvM.useState)(null);
    const [activeCalls, setActiveCalls] = (0, $eZVvM.useState)([]);
    const [connectedCall, setConnectedCall] = (0, $eZVvM.useState)(null);
    const activeCallsRef = (0, $eZVvM.useRef)([]);
    const connectedCallRef = (0, $eZVvM.useRef)(null);
    (0, $eZVvM.useEffect)(()=>{
        activeCallsRef.current = activeCalls;
    }, [
        activeCalls
    ]);
    (0, $eZVvM.useEffect)(()=>{
        connectedCallRef.current = connectedCall;
    }, [
        connectedCall
    ]);
    const localVideoRef = (0, $eZVvM.useRef)(null);
    const [activeLocalVideoStream, setActiveLocalVideoStream] = (0, $eZVvM.useState)(null);
    const [localVideoRenderer, setLocalVideoRenderer] = (0, $eZVvM.useState)(null);
    const remoteVideoRef = (0, $eZVvM.useRef)(null);
    const remoteVideoRendererRef = (0, $eZVvM.useRef)(null);
    const handledParticipantIds = (0, $eZVvM.useRef)(new Set());
    const [isMicActive, setIsMicActive] = (0, $eZVvM.useState)(true);
    const [displayRemoteInitials, setDisplayRemoteInitials] = (0, $eZVvM.useState)(false);
    const [remoteParticipantInitials, setRemoteParticipantInitials] = (0, $eZVvM.useState)("??");
    const [isRinging, setIsRinging] = (0, $eZVvM.useState)(false);
    const [showNoAnswerMessage, setShowNoAnswerMessage] = (0, $eZVvM.useState)(false);
    const clearRemoteStream = (0, $eZVvM.useCallback)(()=>{
        var _remoteVideoRendererRef_current, _remoteVideoRef_current;
        (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
        remoteVideoRendererRef.current = null;
        (_remoteVideoRef_current = remoteVideoRef.current) === null || _remoteVideoRef_current === void 0 ? void 0 : _remoteVideoRef_current.replaceChildren();
        setDisplayRemoteInitials(true);
    }, []);
    const renderRemoteStream = (0, $eZVvM.useCallback)(async (stream)=>{
        var _remoteVideoRendererRef_current, _remoteVideoRef_current;
        (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
        const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(stream);
        const view = await renderer.createView($f83dac2da63b61fd$var$VIEW_OPTIONS);
        remoteVideoRendererRef.current = renderer;
        (_remoteVideoRef_current = remoteVideoRef.current) === null || _remoteVideoRef_current === void 0 ? void 0 : _remoteVideoRef_current.replaceChildren(view.target);
        setDisplayRemoteInitials(false);
    }, []);
    const handleRemoteVideoStream = (0, $eZVvM.useCallback)((stream)=>{
        if (stream.mediaStreamType !== "Video") return;
        stream.on("isAvailableChanged", ()=>{
            if (stream.isAvailable) {
                renderRemoteStream(stream);
                return;
            }
            clearRemoteStream();
        });
        if (stream.isAvailable) {
            renderRemoteStream(stream);
            return;
        }
        setDisplayRemoteInitials(true);
    }, [
        renderRemoteStream,
        clearRemoteStream
    ]);
    const handleRemoteParticipant = (0, $eZVvM.useCallback)((participant)=>{
        if (!participant) return;
        const participantId = (0, $jYWbT.getIdentifierRawId)(participant.identifier);
        if (handledParticipantIds.current.has(participantId)) return;
        handledParticipantIds.current.add(participantId);
        setRemoteParticipantInitials($f83dac2da63b61fd$var$getInitials(participant.displayName));
        setDisplayRemoteInitials(true);
        participant.videoStreams.forEach(handleRemoteVideoStream);
        participant.on("videoStreamsUpdated", ({ added: added, removed: removed })=>{
            added.forEach(handleRemoteVideoStream);
            if (removed.some((stream)=>stream.mediaStreamType === "Video")) clearRemoteStream();
        });
    }, [
        handleRemoteVideoStream,
        clearRemoteStream
    ]);
    const startLocalVideo = (0, $eZVvM.useCallback)(async ()=>{
        if ((connectedCall === null || connectedCall === void 0 ? void 0 : connectedCall.state) === "Connected" && activeLocalVideoStream) {
            var _localVideoRef_current;
            const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(activeLocalVideoStream);
            const view = await renderer.createView($f83dac2da63b61fd$var$VIEW_OPTIONS);
            setLocalVideoRenderer(renderer);
            (_localVideoRef_current = localVideoRef.current) === null || _localVideoRef_current === void 0 ? void 0 : _localVideoRef_current.replaceChildren(view.target);
            if (connectedCall) await connectedCall.startVideo(activeLocalVideoStream);
        }
    }, [
        activeLocalVideoStream,
        connectedCall
    ]);
    const stopLocalVideo = (0, $eZVvM.useCallback)(async ()=>{
        if (connectedCall && activeLocalVideoStream) await connectedCall.stopVideo(activeLocalVideoStream);
        if (localVideoRenderer) {
            localVideoRenderer.dispose();
            setLocalVideoRenderer(null);
        }
    }, [
        localVideoRenderer,
        connectedCall,
        activeLocalVideoStream
    ]);
    const startCall = (0, $eZVvM.useCallback)(async ()=>{
        const currentTeamsCallAgent = teamsCallAgent;
        const currentTargetUserIds = allTargetUserIds;
        if (!currentTeamsCallAgent || currentTargetUserIds.length === 0) {
            console.log("Cannot start call: Target Teams User Ids are missing or Teams Call Agent not initialized.");
            return;
        }
        try {
            var _localVideoRef_current;
            let selectedCamera = null;
            let previewLocalStream = null;
            if (!callClient) {
                console.log("Call client not available for video stream");
                return;
            }
            const deviceManager = await callClient.getDeviceManager();
            const cameras = await deviceManager.getCameras();
            if (!cameras.length) {
                console.log("No camera devices found");
                return;
            }
            const [cameraFromList] = cameras;
            selectedCamera = cameraFromList || null;
            previewLocalStream = new (0, $cf5b5da7977a3fc4$exports.LocalVideoStream)(selectedCamera);
            const renderer = new (0, $cf5b5da7977a3fc4$exports.VideoStreamRenderer)(previewLocalStream);
            const view = await renderer.createView($f83dac2da63b61fd$var$VIEW_OPTIONS);
            setLocalVideoRenderer(renderer);
            (_localVideoRef_current = localVideoRef.current) === null || _localVideoRef_current === void 0 ? void 0 : _localVideoRef_current.replaceChildren(view.target);
            const calls = [];
            await Promise.all(currentTargetUserIds.map(async (userId)=>{
                console.log("Starting call to user:", userId);
                try {
                    let userLocalStream;
                    if (selectedCamera) userLocalStream = new (0, $cf5b5da7977a3fc4$exports.LocalVideoStream)(selectedCamera);
                    const options = userLocalStream ? {
                        videoOptions: {
                            localVideoStreams: [
                                userLocalStream
                            ]
                        }
                    } : {};
                    const call = currentTeamsCallAgent.startCall({
                        microsoftTeamsUserId: userId.trim()
                    }, options);
                    calls.push(call);
                    call.on("stateChanged", async ()=>{
                        console.log(`Call ${call.id} to ${userId} state: ${call.state}`);
                        if (call.state === "Connected" && !connectedCallRef.current) {
                            const participant = call.remoteParticipants[0];
                            let accepted = false;
                            try {
                                await call.muteIncomingAudio();
                                console.log("Incoming audio muted for voicemail detection");
                            } catch (error) {
                                console.log("Failed to mute incoming audio:", error);
                            }
                            const acceptCall = async ()=>{
                                if (accepted || connectedCallRef.current) return;
                                accepted = true;
                                try {
                                    await call.unmuteIncomingAudio();
                                } catch (error) {
                                    console.log("Failed to unmute incoming audio:", error);
                                }
                                connectedCallRef.current = call;
                                setConnectedCall(call);
                                setActiveLocalVideoStream(userLocalStream || null);
                                setIsMicActive(!call.isMuted);
                                setIsRinging(false);
                                handleRemoteParticipant(participant);
                                const otherCalls = activeCallsRef.current.filter((c)=>c.id !== call.id && c.state !== "Disconnected");
                                await Promise.all(otherCalls.map((c)=>c.hangUp().catch((e)=>console.log("HangUp failed", e))));
                            };
                            const handleStreamsUpdated = async ()=>{
                                if ((participant.videoStreams || []).length === 0) return;
                                console.log("Valid stream found, accepting call");
                                participant.off("videoStreamsUpdated", handleStreamsUpdated);
                                await acceptCall();
                            };
                            participant.on("videoStreamsUpdated", handleStreamsUpdated);
                            setTimeout(async ()=>{
                                if (accepted) return;
                                console.log("Timeout passed with no video stream \u2192 keeping the call as audio");
                                participant.off("videoStreamsUpdated", handleStreamsUpdated);
                                await acceptCall();
                            }, 4000);
                        }
                        if (call.state === "Disconnected") {
                            var _connectedCallRef_current;
                            console.log(`Call ${call.id} disconnected`);
                            const noAcceptedCalls = !connectedCallRef.current;
                            const allDisconnected = activeCallsRef.current.every((c)=>c.state === "Disconnected");
                            if (noAcceptedCalls && allDisconnected) {
                                console.log("All calls disconnected and none were accepted.");
                                setShowNoAnswerMessage(true);
                                setTimeout(()=>{
                                    navigate("/", {
                                        replace: true
                                    });
                                }, 6000);
                            }
                            if (((_connectedCallRef_current = connectedCallRef.current) === null || _connectedCallRef_current === void 0 ? void 0 : _connectedCallRef_current.id) === call.id) navigate("/", {
                                replace: true
                            });
                        }
                        if (call.state === "Ringing" && !connectedCallRef.current) setIsRinging(true);
                    });
                } catch (error) {
                    console.log(`Failed to start call to ${userId}:`, error);
                }
            }));
            setActiveCalls(calls);
            console.log(`Started ${calls.length} parallel calls`);
        } catch (error) {
            console.log("Failed to start calls: ", error);
        }
    }, [
        teamsCallAgent,
        callClient,
        allTargetUserIds,
        navigate,
        handleRemoteParticipant
    ]);
    const handleRingTimeout = (0, $eZVvM.useCallback)(async ()=>{
        console.log("No call was answered in time. Hanging up the ringing ones.");
        // The state handler above turns the last disconnect into the "no answer"
        // message and takes the visitor back, so hanging up is all this has to do.
        await Promise.all(activeCallsRef.current.filter((call)=>call.state !== "Disconnected").map((call)=>call.hangUp().catch((error)=>console.log("Failed to hang up unanswered call:", error))));
    }, []);
    (0, $f3e1e21c309b45a4$export$dff45c6e0f8bf788)(isRinging && !connectedCall, handleRingTimeout);
    const hangUpCall = (0, $eZVvM.useCallback)(async ()=>{
        if (connectedCall) await connectedCall.hangUp();
        clearRemoteStream();
        navigate("/", {
            replace: true
        });
    }, [
        connectedCall,
        clearRemoteStream,
        navigate
    ]);
    const toggleMicrophone = (0, $eZVvM.useCallback)(async ()=>{
        if (!connectedCall) return;
        if (isMicActive) connectedCall.mute();
        else connectedCall.unmute();
        setIsMicActive((prev)=>!prev);
    }, [
        connectedCall,
        isMicActive
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (triggerCall && !callsStarted) {
            setCallsStarted(true);
            startCall();
        }
    }, [
        triggerCall
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const initializeCallAgent = async ()=>{
            if (!callerAcsToken) {
                navigate("/", {
                    replace: true
                });
                return;
            }
            try {
                const client = new (0, $cf5b5da7977a3fc4$exports.CallClient)();
                const tokenCredential = new (0, $6rUEX.AzureCommunicationTokenCredential)(callerAcsToken.trim());
                const agent = await client.createTeamsCallAgent(tokenCredential);
                setCallClient(client);
                setTeamsCallAgent(agent);
                const deviceManager = await client.getDeviceManager();
                await deviceManager.askDevicePermission({
                    video: true,
                    audio: true
                });
                console.log("Call agent initialized.");
                setTriggerCall(true);
            } catch (error) {
                console.log("Failed to initialize call agent:", error);
            }
        };
        initializeCallAgent();
    }, [
        callerAcsToken,
        navigate
    ]);
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            (async ()=>{
                var _remoteVideoRendererRef_current;
                await Promise.all(activeCallsRef.current.filter((call)=>call.state !== "Disconnected").map(async (call)=>{
                    try {
                        await call.hangUp();
                    } catch (error) {
                        console.log("Failed to hang up call:", call.id, error);
                    }
                }));
                (_remoteVideoRendererRef_current = remoteVideoRendererRef.current) === null || _remoteVideoRendererRef_current === void 0 ? void 0 : _remoteVideoRendererRef_current.dispose();
                remoteVideoRendererRef.current = null;
                setActiveCalls([]);
                setConnectedCall(null);
                setActiveLocalVideoStream(null);
                setLocalVideoRenderer(null);
            })();
        };
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                    className: "mt-3 mb-4",
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "teamsCall:title"
                        })
                    })
                }),
                !showNoAnswerMessage ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$Controls, {
                            className: "d-flex justify-content-between align-items-center",
                            children: !teamsCallAgent ? /*#__PURE__*/ (0, $bhfvP.jsx)((0, $046757d70188c03a$export$2e2bcd8739ae039), {
                                size: "8rem",
                                style: {
                                    marginTop: "5rem",
                                    marginLeft: "auto",
                                    marginRight: "auto"
                                }
                            }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                                        className: "d-flex",
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$StreamControl, {
                                                onClick: ()=>{
                                                    if (!localVideoRenderer) {
                                                        startLocalVideo();
                                                        return;
                                                    }
                                                    stopLocalVideo();
                                                },
                                                children: !!localVideoRenderer ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $edd79a1a6ad1fc95$export$2e2bcd8739ae039), {
                                                            width: "4rem",
                                                            fill: "black"
                                                        }),
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h3",
                                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                                i18nKey: "teamsCall:controls.camera"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e6e7b0a121ee7588$export$2e2bcd8739ae039), {
                                                            width: "4rem",
                                                            fill: "black"
                                                        }),
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h3",
                                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                                i18nKey: "teamsCall:controls.cameraOff"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$StreamControl, {
                                                onClick: toggleMicrophone,
                                                children: isMicActive ? /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ef2af67617581a1f$export$2e2bcd8739ae039), {
                                                            width: "4rem",
                                                            fill: "black"
                                                        }),
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h3",
                                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                                i18nKey: "teamsCall:controls.mic"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $52b2059741142620$export$2e2bcd8739ae039), {
                                                            width: "4rem",
                                                            fill: "black"
                                                        }),
                                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                            variant: "h3",
                                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                                i18nKey: "teamsCall:controls.micOff"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bhfvP.jsxs)($f83dac2da63b61fd$var$CallControl, {
                                        onClick: hangUpCall,
                                        isEnd: true,
                                        children: [
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $ed1dd38dbb398e71$export$2e2bcd8739ae039), {
                                                width: "3.5rem",
                                                fill: "white",
                                                style: {
                                                    transform: "rotate(135deg)"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                variant: "h3",
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                    i18nKey: "teamsCall:controls.endCall"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        teamsCallAgent && /*#__PURE__*/ (0, $bhfvP.jsxs)($f83dac2da63b61fd$var$StreamContainer, {
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsxs)($f83dac2da63b61fd$var$Stream, {
                                    className: "position-relative",
                                    children: [
                                        !localVideoRenderer && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                            className: "position-absolute h-100 w-100 d-flex justify-content-center align-items-center",
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$Initials, {
                                                className: "initials",
                                                children: "DR"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$StreamMedia, {
                                            id: "localVideo",
                                            ref: localVideoRef
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsxs)($f83dac2da63b61fd$var$Stream, {
                                    className: "position-relative",
                                    children: [
                                        displayRemoteInitials && !isRinging && connectedCall && /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                            className: "position-absolute h-100 w-100 d-flex justify-content-center align-items-center",
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$Initials, {
                                                className: "initials position-relative",
                                                children: remoteParticipantInitials
                                            })
                                        }),
                                        isRinging && /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                                            className: "position-absolute h-100 w-100 d-flex flex-column justify-content-center align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c32338581a0bb5e8$export$2e2bcd8739ae039), {
                                                    width: "3.5rem"
                                                }),
                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                    variant: "h4",
                                                    className: "fs-3 mt-2",
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                                                        i18nKey: "teamsCall:controls.ringing"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$var$StreamMedia, {
                                            id: "remoteVideo",
                                            ref: remoteVideoRef
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    className: "mb-5 pb-5 h-100 d-flex justify-content-center align-items-center w-100",
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h2",
                        className: "text-center text-danger",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "teamsCall:controls.noAnswer"
                        })
                    })
                })
            ]
        })
    });
};
var $f83dac2da63b61fd$export$2e2bcd8739ae039 = $f83dac2da63b61fd$var$TeamsVideoGroupCall;



/* eslint-disable no-console */ 
var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $6rUEX = parcelRequire("6rUEX");


var $f19az = parcelRequire("f19az");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");



const $7d5b198cbab42433$var$TeamsAudioGroupCall = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const callerAcsToken = query.callerAcsToken;
    const targetTeamsUserIds = query.targetTeamsUserIds;
    const allTargetUserIds = (0, $eZVvM.useMemo)(()=>(targetTeamsUserIds === null || targetTeamsUserIds === void 0 ? void 0 : targetTeamsUserIds.split(",").map((id)=>id.trim())) || [], [
        targetTeamsUserIds
    ]);
    const [callingState, setCallingState] = (0, $eZVvM.useState)("connecting");
    const [triggerCall, setTriggerCall] = (0, $eZVvM.useState)(false);
    const [callsStarted, setCallsStarted] = (0, $eZVvM.useState)(false);
    const [teamsCallAgent, setTeamsCallAgent] = (0, $eZVvM.useState)(null);
    const [activeCalls, setActiveCalls] = (0, $eZVvM.useState)([]);
    const [connectedCall, setConnectedCall] = (0, $eZVvM.useState)(null);
    const activeCallsRef = (0, $eZVvM.useRef)([]);
    const connectedCallRef = (0, $eZVvM.useRef)(null);
    const { startSound: startSound, ringingSound: ringingSound, connectedSound: connectedSound, endSound: endSound, playSound: playSound, stopAllSounds: stopAllSounds } = (0, $dcc94db3b6c367f7$export$a712c06eeb4d5ac8)();
    (0, $eZVvM.useEffect)(()=>{
        activeCallsRef.current = activeCalls;
    }, [
        activeCalls
    ]);
    (0, $eZVvM.useEffect)(()=>{
        connectedCallRef.current = connectedCall;
    }, [
        connectedCall
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (callingState === "disconnected" || callingState === "error" || callingState === "noAnswer") {
            const timeout = setTimeout(()=>{
                navigate("/", {
                    replace: true
                });
            }, 5000);
            return ()=>clearTimeout(timeout);
        }
        return undefined;
    }, [
        callingState,
        navigate
    ]);
    const startCall = (0, $eZVvM.useCallback)(async ()=>{
        if (!teamsCallAgent || allTargetUserIds.length === 0) {
            console.log("Cannot start call: Target Teams User Ids are missing or Teams Call Agent not initialized.");
            setCallingState("error");
            return;
        }
        if (callsStarted) return;
        setCallsStarted(true);
        try {
            setCallingState("connecting");
            playSound(startSound);
            const calls = [];
            await Promise.all(allTargetUserIds.map(async (userId)=>{
                console.log("Starting call to user:", userId);
                try {
                    const call = teamsCallAgent.startCall({
                        microsoftTeamsUserId: userId.trim()
                    });
                    calls.push(call);
                    call.on("stateChanged", async ()=>{
                        console.log(`Call ${call.id} to ${userId} state: ${call.state}`);
                        if (call.state === "Connecting" && !connectedCallRef.current) {
                            playSound(startSound);
                            setCallingState("connecting");
                        }
                        if (call.state === "Ringing" && !connectedCallRef.current) {
                            playSound(ringingSound);
                            setCallingState("ringing");
                        }
                        if (call.state === "Connected" && !connectedCallRef.current) {
                            const participant = call.remoteParticipants[0];
                            let accepted = false;
                            try {
                                await call.muteIncomingAudio();
                                console.log("Incoming audio muted for voicemail detection");
                            } catch (error) {
                                console.log("Failed to mute incoming audio:", error);
                            }
                            const handleStreamsUpdated = async ()=>{
                                const videoStreams = participant.videoStreams || [];
                                if (videoStreams.length > 0 && !accepted) {
                                    accepted = true;
                                    participant.off("videoStreamsUpdated", handleStreamsUpdated);
                                    console.log("Valid stream found, accepting call");
                                    try {
                                        await call.unmuteIncomingAudio();
                                        console.log("Incoming audio unmuted.");
                                    } catch (error) {
                                        console.log("Failed to unmute incoming audio:", error);
                                    }
                                    connectedCallRef.current = call;
                                    setConnectedCall(call);
                                    playSound(connectedSound);
                                    setCallingState("connected");
                                    const otherCalls = activeCallsRef.current.filter((c)=>c.id !== call.id && c.state !== "Disconnected");
                                    await Promise.all(otherCalls.map((c)=>c.hangUp().catch((e)=>console.log("HangUp failed", e))));
                                }
                            };
                            participant.on("videoStreamsUpdated", handleStreamsUpdated);
                            setTimeout(async ()=>{
                                if (!accepted) {
                                    console.log("Timeout passed with no valid stream \u2192 treating as voicemail");
                                    try {
                                        await call.hangUp();
                                    } catch (err) {
                                        console.log("Failed to hang up voicemail call:", err);
                                    }
                                    participant.off("videoStreamsUpdated", handleStreamsUpdated);
                                }
                            }, 4000);
                        }
                        if (call.state === "Disconnected") {
                            var _connectedCallRef_current;
                            console.log(`Call ${call.id} disconnected`);
                            const noAcceptedCalls = !connectedCallRef.current;
                            const allDisconnected = activeCallsRef.current.every((c)=>c.state === "Disconnected");
                            if (noAcceptedCalls && allDisconnected) {
                                console.log("All calls disconnected and none were accepted.");
                                playSound(endSound);
                                setCallingState("noAnswer");
                            }
                            if (((_connectedCallRef_current = connectedCallRef.current) === null || _connectedCallRef_current === void 0 ? void 0 : _connectedCallRef_current.id) === call.id) {
                                playSound(endSound);
                                setCallingState("disconnected");
                            }
                        }
                    });
                } catch (error) {
                    console.log(`Failed to start call to ${userId}:`, error);
                    setCallingState("error");
                }
            }));
            setActiveCalls(calls);
            console.log(`Started ${calls.length} parallel calls`);
        } catch (error) {
            console.log("Failed to start calls: ", error);
            setCallingState("error");
        }
    }, [
        teamsCallAgent,
        allTargetUserIds,
        callsStarted
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (triggerCall && !callsStarted) startCall();
    }, [
        triggerCall,
        callsStarted,
        startCall
    ]);
    const handleRingTimeout = (0, $eZVvM.useCallback)(async ()=>{
        console.log("No call was answered in time. Hanging up the ringing ones.");
        // The state handler above turns the last disconnect into `noAnswer`, so
        // hanging up is all this has to do.
        await Promise.all(activeCallsRef.current.filter((call)=>call.state !== "Disconnected").map((call)=>call.hangUp().catch((error)=>console.log("Failed to hang up unanswered call:", error))));
    }, []);
    (0, $f3e1e21c309b45a4$export$dff45c6e0f8bf788)(callingState === "ringing", handleRingTimeout);
    const hangUpCall = (0, $eZVvM.useCallback)(async ()=>{
        console.log("Hanging up all calls...");
        await Promise.all(activeCallsRef.current.filter((call)=>call.state !== "Disconnected").map(async (call)=>{
            try {
                console.log(`Hanging up call ${call.id}`);
                await call.hangUp();
            } catch (error) {
                console.log("Failed to hang up call:", call.id, error);
            }
        }));
        setActiveCalls([]);
        setConnectedCall(null);
        connectedCallRef.current = null;
        playSound(endSound);
        setCallingState("disconnected");
    }, []);
    const handleClose = (0, $eZVvM.useCallback)(()=>{
        navigate("/", {
            replace: true
        });
    }, [
        navigate
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const initializeCallAgent = async ()=>{
            if (!callerAcsToken) {
                navigate("/", {
                    replace: true
                });
                return;
            }
            try {
                const client = new (0, $cf5b5da7977a3fc4$exports.CallClient)();
                const tokenCredential = new (0, $6rUEX.AzureCommunicationTokenCredential)(callerAcsToken.trim());
                const agent = await client.createTeamsCallAgent(tokenCredential);
                setTeamsCallAgent(agent);
                const deviceManager = await client.getDeviceManager();
                await deviceManager.askDevicePermission({
                    video: true,
                    audio: true
                });
                console.log("Call agent initialized.");
                setTriggerCall(true);
            } catch (error) {
                console.log("Failed to initialize call agent:", error);
                setCallingState("error");
            }
        };
        initializeCallAgent();
    }, [
        callerAcsToken,
        navigate,
        startCall
    ]);
    (0, $eZVvM.useEffect)(()=>{
        return ()=>{
            stopAllSounds();
            (async ()=>{
                await Promise.all(activeCallsRef.current.filter((call)=>call.state !== "Disconnected").map(async (call)=>{
                    try {
                        await call.hangUp();
                    } catch (error) {
                        console.log("Failed to hang up call:", call.id, error);
                    }
                }));
                setActiveCalls([]);
                setConnectedCall(null);
            })();
        };
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $2d80563ed05fed7d$export$2e2bcd8739ae039), {
        status: callingState,
        onEndCall: hangUpCall,
        onClose: handleClose
    });
};
var $7d5b198cbab42433$export$2e2bcd8739ae039 = $7d5b198cbab42433$var$TeamsAudioGroupCall;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $9B9bN = parcelRequire("9B9bN");



var $cD0nt = parcelRequire("cD0nt");



const $bbadba93b08921d2$var$WifiImg = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("img")({
    width: "80%",
    maxWidth: "75rem",
    "@media screen and (orientation: landscape)": {
        width: "20%"
    }
});
const $bbadba93b08921d2$var$Wifi = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    const wifiQrCode = (0, $cD0nt.useWifiQrCode)();
    if (!wifiQrCode) return (0, $9B9bN.Navigate)({
        to: "/"
    });
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "d-flex align-items-center flex-column h-100",
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                    to: "/"
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                            i18nKey: "wifi:title"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)($bbadba93b08921d2$var$WifiImg, {
                    alt: "Wi-Fi QR code",
                    src: wifiQrCode
                })
            ]
        })
    });
});
var $bbadba93b08921d2$export$2e2bcd8739ae039 = $bbadba93b08921d2$var$Wifi;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

/**
 * Raw wav audio file contents
 * @typedef {Object} WavPackerAudioType
 * @property {Blob} blob
 * @property {string} url
 * @property {number} channelCount
 * @property {number} sampleRate
 * @property {number} duration
 */ /**
 * Utility class for assembling PCM16 "audio/wav" data
 * @class
 */ class $3b1d40bc464e20d1$export$13afda237b1c9846 {
    /**
   * Converts Float32Array of amplitude data to ArrayBuffer in Int16Array format
   * @param {Float32Array} float32Array
   * @returns {ArrayBuffer}
   */ static floatTo16BitPCM(float32Array) {
        const buffer = new ArrayBuffer(float32Array.length * 2);
        const view = new DataView(buffer);
        let offset = 0;
        for(let i = 0; i < float32Array.length; i++, offset += 2){
            let s = Math.max(-1, Math.min(1, float32Array[i]));
            view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        }
        return buffer;
    }
    /**
   * Concatenates two ArrayBuffers
   * @param {ArrayBuffer} leftBuffer
   * @param {ArrayBuffer} rightBuffer
   * @returns {ArrayBuffer}
   */ static mergeBuffers(leftBuffer, rightBuffer) {
        const tmpArray = new Uint8Array(leftBuffer.byteLength + rightBuffer.byteLength);
        tmpArray.set(new Uint8Array(leftBuffer), 0);
        tmpArray.set(new Uint8Array(rightBuffer), leftBuffer.byteLength);
        return tmpArray.buffer;
    }
    /**
   * Packs data into an Int16 format
   * @private
   * @param {number} size 0 = 1x Int16, 1 = 2x Int16
   * @param {number} arg value to pack
   * @returns
   */ _packData(size, arg) {
        return [
            new Uint8Array([
                arg,
                arg >> 8
            ]),
            new Uint8Array([
                arg,
                arg >> 8,
                arg >> 16,
                arg >> 24
            ])
        ][size];
    }
    /**
   * Packs audio into "audio/wav" Blob
   * @param {number} sampleRate
   * @param {{bitsPerSample: number, channels: Array<Float32Array>, data: Int16Array}} audio
   * @returns {WavPackerAudioType}
   */ pack(sampleRate, audio) {
        if (!(audio === null || audio === void 0 ? void 0 : audio.bitsPerSample)) throw new Error(`Missing "bitsPerSample"`);
        else if (!(audio === null || audio === void 0 ? void 0 : audio.channels)) throw new Error(`Missing "channels"`);
        else if (!(audio === null || audio === void 0 ? void 0 : audio.data)) throw new Error(`Missing "data"`);
        const { bitsPerSample: bitsPerSample, channels: channels, data: data } = audio;
        const output = [
            // Header
            "RIFF",
            this._packData(1, 52),
            // Length
            "WAVE",
            // chunk 1
            "fmt ",
            // Sub-chunk identifier
            this._packData(1, 16),
            // Chunk length
            this._packData(0, 1),
            // Audio format (1 is linear quantization)
            this._packData(0, channels.length),
            this._packData(1, sampleRate),
            this._packData(1, sampleRate * channels.length * bitsPerSample / 8),
            // Byte rate
            this._packData(0, channels.length * bitsPerSample / 8),
            this._packData(0, bitsPerSample),
            // chunk 2
            "data",
            // Sub-chunk identifier
            this._packData(1, channels[0].length * channels.length * bitsPerSample / 8),
            // Chunk length
            data
        ];
        const blob = new Blob(output, {
            type: "audio/mpeg"
        });
        const url = URL.createObjectURL(blob);
        return {
            blob: blob,
            url: url,
            channelCount: channels.length,
            sampleRate: sampleRate,
            duration: data.byteLength / (channels.length * sampleRate * 2)
        };
    }
}
globalThis.WavPacker = $3b1d40bc464e20d1$export$13afda237b1c9846;


/**
 * Constants for help with visualization
 * Helps map frequency ranges from Fast Fourier Transform
 * to human-interpretable ranges, notably music ranges and
 * human vocal ranges.
 */ // Eighth octave frequencies
const $7e36ff710ba19f08$var$octave8Frequencies = [
    4186.01,
    4434.92,
    4698.63,
    4978.03,
    5274.04,
    5587.65,
    5919.91,
    6271.93,
    6644.88,
    7040.0,
    7458.62,
    7902.13
];
// Labels for each of the above frequencies
const $7e36ff710ba19f08$var$octave8FrequencyLabels = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
const $7e36ff710ba19f08$export$776c63898ae5b636 = [];
const $7e36ff710ba19f08$export$facd167cc27ea9b0 = [];
for(let i = 1; i <= 8; i++)for(let f = 0; f < $7e36ff710ba19f08$var$octave8Frequencies.length; f++){
    const freq = $7e36ff710ba19f08$var$octave8Frequencies[f];
    $7e36ff710ba19f08$export$776c63898ae5b636.push(freq / Math.pow(2, 8 - i));
    $7e36ff710ba19f08$export$facd167cc27ea9b0.push($7e36ff710ba19f08$var$octave8FrequencyLabels[f] + i);
}
/**
 * Subset of the note frequencies between 32 and 2000 Hz
 * 6 octave range: C1 to B6
 */ const $7e36ff710ba19f08$var$voiceFrequencyRange = [
    32.0,
    2000.0
];
const $7e36ff710ba19f08$export$dbc1581ed2cfa183 = $7e36ff710ba19f08$export$776c63898ae5b636.filter((_, i)=>{
    return $7e36ff710ba19f08$export$776c63898ae5b636[i] > $7e36ff710ba19f08$var$voiceFrequencyRange[0] && $7e36ff710ba19f08$export$776c63898ae5b636[i] < $7e36ff710ba19f08$var$voiceFrequencyRange[1];
});
const $7e36ff710ba19f08$export$30a6f2881311088f = $7e36ff710ba19f08$export$facd167cc27ea9b0.filter((_, i)=>{
    return $7e36ff710ba19f08$export$776c63898ae5b636[i] > $7e36ff710ba19f08$var$voiceFrequencyRange[0] && $7e36ff710ba19f08$export$776c63898ae5b636[i] < $7e36ff710ba19f08$var$voiceFrequencyRange[1];
});


class $e3157d5b373e8220$export$2c3136da0bf130f9 {
    /**
   * Retrieves frequency domain data from an AnalyserNode adjusted to a decibel range
   * returns human-readable formatting and labels
   * @param {AnalyserNode} analyser
   * @param {number} sampleRate
   * @param {Float32Array} [fftResult]
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {AudioAnalysisOutputType}
   */ static getFrequencies(analyser, sampleRate, fftResult, analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!fftResult) {
            fftResult = new Float32Array(analyser.frequencyBinCount);
            analyser.getFloatFrequencyData(fftResult);
        }
        const nyquistFrequency = sampleRate / 2;
        const frequencyStep = 1 / fftResult.length * nyquistFrequency;
        let outputValues;
        let frequencies;
        let labels;
        if (analysisType === "music" || analysisType === "voice") {
            const useFrequencies = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$dbc1581ed2cfa183) : (0, $7e36ff710ba19f08$export$776c63898ae5b636);
            const aggregateOutput = Array(useFrequencies.length).fill(minDecibels);
            for(let i = 0; i < fftResult.length; i++){
                const frequency = i * frequencyStep;
                const amplitude = fftResult[i];
                for(let n = useFrequencies.length - 1; n >= 0; n--)if (frequency > useFrequencies[n]) {
                    aggregateOutput[n] = Math.max(aggregateOutput[n], amplitude);
                    break;
                }
            }
            outputValues = aggregateOutput;
            frequencies = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$dbc1581ed2cfa183) : (0, $7e36ff710ba19f08$export$776c63898ae5b636);
            labels = analysisType === "voice" ? (0, $7e36ff710ba19f08$export$30a6f2881311088f) : (0, $7e36ff710ba19f08$export$facd167cc27ea9b0);
        } else {
            outputValues = Array.from(fftResult);
            frequencies = outputValues.map((_, i)=>frequencyStep * i);
            labels = frequencies.map((f)=>`${f.toFixed(2)} Hz`);
        }
        // We normalize to {0, 1}
        const normalizedOutput = outputValues.map((v)=>{
            return Math.max(0, Math.min((v - minDecibels) / (maxDecibels - minDecibels), 1));
        });
        const values = new Float32Array(normalizedOutput);
        return {
            values: values,
            frequencies: frequencies,
            labels: labels
        };
    }
    /**
   * Gets the current frequency domain data from the playing audio track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        let fftResult = null;
        if (this.audioBuffer && this.fftResults.length) {
            const pct = this.audio.currentTime / this.audio.duration;
            const index = Math.min(pct * this.fftResults.length | 0, this.fftResults.length - 1);
            fftResult = this.fftResults[index];
        }
        return $e3157d5b373e8220$export$2c3136da0bf130f9.getFrequencies(this.analyser, this.sampleRate, fftResult, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Resume the internal AudioContext if it was suspended due to the lack of
   * user interaction when the AudioAnalysis was instantiated.
   * @returns {Promise<true>}
   */ async resumeIfSuspended() {
        if (this.context.state === "suspended") await this.context.resume();
        return true;
    }
    /**
   * Creates a new AudioAnalysis instance for an HTMLAudioElement
   * @param {HTMLAudioElement} audioElement
   * @param {AudioBuffer|null} [audioBuffer] If provided, will cache all frequency domain data from the buffer
   * @returns {AudioAnalysis}
   */ constructor(audioElement, audioBuffer = null){
        this.fftResults = [];
        if (audioBuffer) {
            /**
       * Modified from
       * https://stackoverflow.com/questions/75063715/using-the-web-audio-api-to-analyze-a-song-without-playing
       *
       * We do this to populate FFT values for the audio if provided an `audioBuffer`
       * The reason to do this is that Safari fails when using `createMediaElementSource`
       * This has a non-zero RAM cost so we only opt-in to run it on Safari, Chrome is better
       */ const { length: length, sampleRate: sampleRate } = audioBuffer;
            const offlineAudioContext = new OfflineAudioContext({
                length: length,
                sampleRate: sampleRate
            });
            const source = offlineAudioContext.createBufferSource();
            source.buffer = audioBuffer;
            const analyser = offlineAudioContext.createAnalyser();
            analyser.fftSize = 8192;
            analyser.smoothingTimeConstant = 0.1;
            source.connect(analyser);
            // limit is :: 128 / sampleRate;
            // but we just want 60fps - cuts ~1s from 6MB to 1MB of RAM
            const renderQuantumInSeconds = 1 / 60;
            const durationInSeconds = length / sampleRate;
            const analyze = (index)=>{
                const suspendTime = renderQuantumInSeconds * index;
                if (suspendTime < durationInSeconds) offlineAudioContext.suspend(suspendTime).then(()=>{
                    const fftResult = new Float32Array(analyser.frequencyBinCount);
                    analyser.getFloatFrequencyData(fftResult);
                    this.fftResults.push(fftResult);
                    analyze(index + 1);
                });
                if (index === 1) offlineAudioContext.startRendering();
                else offlineAudioContext.resume();
            };
            source.start(0);
            analyze(1);
            this.audio = audioElement;
            this.context = offlineAudioContext;
            this.analyser = analyser;
            this.sampleRate = sampleRate;
            this.audioBuffer = audioBuffer;
        } else {
            const audioContext = new AudioContext();
            const track = audioContext.createMediaElementSource(audioElement);
            const analyser = audioContext.createAnalyser();
            analyser.fftSize = 8192;
            analyser.smoothingTimeConstant = 0.1;
            track.connect(analyser);
            analyser.connect(audioContext.destination);
            this.audio = audioElement;
            this.context = audioContext;
            this.analyser = analyser;
            this.sampleRate = this.context.sampleRate;
            this.audioBuffer = null;
        }
    }
}
globalThis.AudioAnalysis = $e3157d5b373e8220$export$2c3136da0bf130f9;


const $85d2d12e7041fe80$export$50b76700e2b15e9 = `
class StreamProcessor extends AudioWorkletProcessor {
  constructor() {
    super();
    this.hasStarted = false;
    this.hasInterrupted = false;
    this.outputBuffers = [];
    this.bufferLength = 128;
    this.write = { buffer: new Float32Array(this.bufferLength), trackId: null };
    this.writeOffset = 0;
    this.trackSampleOffsets = {};
    this.port.onmessage = (event) => {
      if (event.data) {
        const payload = event.data;
        if (payload.event === 'write') {
          const int16Array = payload.buffer;
          const float32Array = new Float32Array(int16Array.length);
          for (let i = 0; i < int16Array.length; i++) {
            float32Array[i] = int16Array[i] / 0x8000; // Convert Int16 to Float32
          }
          this.writeData(float32Array, payload.trackId);
        } else if (
          payload.event === 'offset' ||
          payload.event === 'interrupt'
        ) {
          const requestId = payload.requestId;
          const trackId = this.write.trackId;
          const offset = this.trackSampleOffsets[trackId] || 0;
          this.port.postMessage({
            event: 'offset',
            requestId,
            trackId,
            offset,
          });
          if (payload.event === 'interrupt') {
            this.hasInterrupted = true;
          }
        } else {
          throw new Error(\`Unhandled event "\${payload.event}"\`);
        }
      }
    };
  }

  writeData(float32Array, trackId = null) {
    let { buffer } = this.write;
    let offset = this.writeOffset;
    for (let i = 0; i < float32Array.length; i++) {
      buffer[offset++] = float32Array[i];
      if (offset >= buffer.length) {
        this.outputBuffers.push(this.write);
        this.write = { buffer: new Float32Array(this.bufferLength), trackId };
        buffer = this.write.buffer;
        offset = 0;
      }
    }
    this.writeOffset = offset;
    return true;
  }

  process(inputs, outputs, parameters) {
    const output = outputs[0];
    const outputChannelData = output[0];
    const outputBuffers = this.outputBuffers;
    if (this.hasInterrupted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else if (outputBuffers.length) {
      this.hasStarted = true;
      const { buffer, trackId } = outputBuffers.shift();
      for (let i = 0; i < outputChannelData.length; i++) {
        outputChannelData[i] = buffer[i] || 0;
      }
      if (trackId) {
        this.trackSampleOffsets[trackId] =
          this.trackSampleOffsets[trackId] || 0;
        this.trackSampleOffsets[trackId] += buffer.length;
      }
      return true;
    } else if (this.hasStarted) {
      this.port.postMessage({ event: 'stop' });
      return false;
    } else {
      return true;
    }
  }
}

registerProcessor('stream_processor', StreamProcessor);
`;
const $85d2d12e7041fe80$var$script = new Blob([
    $85d2d12e7041fe80$export$50b76700e2b15e9
], {
    type: "application/javascript"
});
const $85d2d12e7041fe80$var$src = URL.createObjectURL($85d2d12e7041fe80$var$script);
const $85d2d12e7041fe80$export$bfa8c596114d74df = $85d2d12e7041fe80$var$src;



class $4f776511e84ede8b$export$9698d62c78b8f366 {
    /**
   * Connects the audio context and enables output to speakers
   * @returns {Promise<true>}
   */ async connect() {
        this.context = new AudioContext({
            sampleRate: this.sampleRate
        });
        if (this.context.state === "suspended") await this.context.resume();
        try {
            await this.context.audioWorklet.addModule(this.scriptSrc);
        } catch (e) {
            console.error(e);
            throw new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        const analyser = this.context.createAnalyser();
        analyser.fftSize = 8192;
        analyser.smoothingTimeConstant = 0.1;
        this.analyser = analyser;
        return true;
    }
    /**
   * Gets the current frequency domain data from the playing track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {import('./analysis/audio_analysis.js').AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!this.analyser) throw new Error("Not connected, please call .connect() first");
        return (0, $e3157d5b373e8220$export$2c3136da0bf130f9).getFrequencies(this.analyser, this.sampleRate, null, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Starts audio streaming
   * @private
   * @returns {Promise<true>}
   */ _start() {
        const streamNode = new AudioWorkletNode(this.context, "stream_processor");
        streamNode.connect(this.context.destination);
        streamNode.port.onmessage = (e)=>{
            const { event: event } = e.data;
            if (event === "stop") {
                streamNode.disconnect();
                this.stream = null;
            } else if (event === "offset") {
                const { requestId: requestId, trackId: trackId, offset: offset } = e.data;
                const currentTime = offset / this.sampleRate;
                this.trackSampleOffsets[requestId] = {
                    trackId: trackId,
                    offset: offset,
                    currentTime: currentTime
                };
            }
        };
        this.analyser.disconnect();
        streamNode.connect(this.analyser);
        this.stream = streamNode;
        return true;
    }
    /**
   * Adds 16BitPCM data to the currently playing audio stream
   * You can add chunks beyond the current play point and they will be queued for play
   * @param {ArrayBuffer|Int16Array} arrayBuffer
   * @param {string} [trackId]
   * @returns {Int16Array}
   */ add16BitPCM(arrayBuffer, trackId = "default") {
        if (typeof trackId !== "string") throw new Error(`trackId must be a string`);
        else if (this.interruptedTrackIds[trackId]) return;
        if (!this.stream) this._start();
        let buffer;
        if (arrayBuffer instanceof Int16Array) buffer = arrayBuffer;
        else if (arrayBuffer instanceof ArrayBuffer) buffer = new Int16Array(arrayBuffer);
        else throw new Error(`argument must be Int16Array or ArrayBuffer`);
        this.stream.port.postMessage({
            event: "write",
            buffer: buffer,
            trackId: trackId
        });
        return buffer;
    }
    /**
   * Gets the offset (sample count) of the currently playing stream
   * @param {boolean} [interrupt]
   * @returns {{trackId: string|null, offset: number, currentTime: number}}
   */ async getTrackSampleOffset(interrupt = false) {
        if (!this.stream) return null;
        const requestId = crypto.randomUUID();
        this.stream.port.postMessage({
            event: interrupt ? "interrupt" : "offset",
            requestId: requestId
        });
        let trackSampleOffset;
        while(!trackSampleOffset){
            trackSampleOffset = this.trackSampleOffsets[requestId];
            await new Promise((r)=>setTimeout(()=>r(), 1));
        }
        const { trackId: trackId } = trackSampleOffset;
        if (interrupt && trackId) this.interruptedTrackIds[trackId] = true;
        return trackSampleOffset;
    }
    /**
   * Strips the current stream and returns the sample offset of the audio
   * @param {boolean} [interrupt]
   * @returns {{trackId: string|null, offset: number, currentTime: number}}
   */ async interrupt() {
        return this.getTrackSampleOffset(true);
    }
    /**
   * Creates a new WavStreamPlayer instance
   * @param {{sampleRate?: number}} options
   * @returns {WavStreamPlayer}
   */ constructor({ sampleRate: sampleRate = 44100 } = {}){
        this.scriptSrc = (0, $85d2d12e7041fe80$export$bfa8c596114d74df);
        this.sampleRate = sampleRate;
        this.context = null;
        this.stream = null;
        this.analyser = null;
        this.trackSampleOffsets = {};
        this.interruptedTrackIds = {};
    }
}
globalThis.WavStreamPlayer = $4f776511e84ede8b$export$9698d62c78b8f366;


const $3e2b3e2b8d57a0ca$var$AudioProcessorWorklet = `
class AudioProcessor extends AudioWorkletProcessor {

  constructor() {
    super();
    this.port.onmessage = this.receive.bind(this);
    this.initialize();
  }

  initialize() {
    this.foundAudio = false;
    this.recording = false;
    this.chunks = [];
  }

  /**
   * Concatenates sampled chunks into channels
   * Format is chunk[Left[], Right[]]
   */
  readChannelData(chunks, channel = -1, maxChannels = 9) {
    let channelLimit;
    if (channel !== -1) {
      if (chunks[0] && chunks[0].length - 1 < channel) {
        throw new Error(
          \`Channel \${channel} out of range: max \${chunks[0].length}\`
        );
      }
      channelLimit = channel + 1;
    } else {
      channel = 0;
      channelLimit = Math.min(chunks[0] ? chunks[0].length : 1, maxChannels);
    }
    const channels = [];
    for (let n = channel; n < channelLimit; n++) {
      const length = chunks.reduce((sum, chunk) => {
        return sum + chunk[n].length;
      }, 0);
      const buffers = chunks.map((chunk) => chunk[n]);
      const result = new Float32Array(length);
      let offset = 0;
      for (let i = 0; i < buffers.length; i++) {
        result.set(buffers[i], offset);
        offset += buffers[i].length;
      }
      channels[n] = result;
    }
    return channels;
  }

  /**
   * Combines parallel audio data into correct format,
   * channels[Left[], Right[]] to float32Array[LRLRLRLR...]
   */
  formatAudioData(channels) {
    if (channels.length === 1) {
      // Simple case is only one channel
      const float32Array = channels[0].slice();
      const meanValues = channels[0].slice();
      return { float32Array, meanValues };
    } else {
      const float32Array = new Float32Array(
        channels[0].length * channels.length
      );
      const meanValues = new Float32Array(channels[0].length);
      for (let i = 0; i < channels[0].length; i++) {
        const offset = i * channels.length;
        let meanValue = 0;
        for (let n = 0; n < channels.length; n++) {
          float32Array[offset + n] = channels[n][i];
          meanValue += channels[n][i];
        }
        meanValues[i] = meanValue / channels.length;
      }
      return { float32Array, meanValues };
    }
  }

  /**
   * Converts 32-bit float data to 16-bit integers
   */
  floatTo16BitPCM(float32Array) {
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
  }

  /**
   * Retrieves the most recent amplitude values from the audio stream
   * @param {number} channel
   */
  getValues(channel = -1) {
    const channels = this.readChannelData(this.chunks, channel);
    const { meanValues } = this.formatAudioData(channels);
    return { meanValues, channels };
  }

  /**
   * Exports chunks as an audio/wav file
   */
  export() {
    const channels = this.readChannelData(this.chunks);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const audioData = this.floatTo16BitPCM(float32Array);
    return {
      meanValues: meanValues,
      audio: {
        bitsPerSample: 16,
        channels: channels,
        data: audioData,
      },
    };
  }

  receive(e) {
    const { event, id } = e.data;
    let receiptData = {};
    switch (event) {
      case 'start':
        this.recording = true;
        break;
      case 'stop':
        this.recording = false;
        break;
      case 'clear':
        this.initialize();
        break;
      case 'export':
        receiptData = this.export();
        break;
      case 'read':
        receiptData = this.getValues();
        break;
      default:
        break;
    }
    // Always send back receipt
    this.port.postMessage({ event: 'receipt', id, data: receiptData });
  }

  sendChunk(chunk) {
    const channels = this.readChannelData([chunk]);
    const { float32Array, meanValues } = this.formatAudioData(channels);
    const rawAudioData = this.floatTo16BitPCM(float32Array);
    const monoAudioData = this.floatTo16BitPCM(meanValues);
    this.port.postMessage({
      event: 'chunk',
      data: {
        mono: monoAudioData,
        raw: rawAudioData,
      },
    });
  }

  process(inputList, outputList, parameters) {
    // Copy input to output (e.g. speakers)
    // Note that this creates choppy sounds with Mac products
    const sourceLimit = Math.min(inputList.length, outputList.length);
    for (let inputNum = 0; inputNum < sourceLimit; inputNum++) {
      const input = inputList[inputNum];
      const output = outputList[inputNum];
      const channelCount = Math.min(input.length, output.length);
      for (let channelNum = 0; channelNum < channelCount; channelNum++) {
        input[channelNum].forEach((sample, i) => {
          output[channelNum][i] = sample;
        });
      }
    }
    const inputs = inputList[0];
    // There's latency at the beginning of a stream before recording starts
    // Make sure we actually receive audio data before we start storing chunks
    let sliceIndex = 0;
    if (!this.foundAudio) {
      for (const channel of inputs) {
        sliceIndex = 0; // reset for each channel
        if (this.foundAudio) {
          break;
        }
        if (channel) {
          for (const value of channel) {
            if (value !== 0) {
              // find only one non-zero entry in any channel
              this.foundAudio = true;
              break;
            } else {
              sliceIndex++;
            }
          }
        }
      }
    }
    if (inputs && inputs[0] && this.foundAudio && this.recording) {
      // We need to copy the TypedArray, because the \`process\`
      // internals will reuse the same buffer to hold each input
      const chunk = inputs.map((input) => input.slice(sliceIndex));
      this.chunks.push(chunk);
      this.sendChunk(chunk);
    }
    return true;
  }
}

registerProcessor('audio_processor', AudioProcessor);
`;
const $3e2b3e2b8d57a0ca$var$script = new Blob([
    $3e2b3e2b8d57a0ca$var$AudioProcessorWorklet
], {
    type: "application/javascript"
});
const $3e2b3e2b8d57a0ca$var$src = URL.createObjectURL($3e2b3e2b8d57a0ca$var$script);
const $3e2b3e2b8d57a0ca$export$1f65f50a8cbff43c = $3e2b3e2b8d57a0ca$var$src;




class $4f413f56eb918468$export$439b217ca659a877 {
    /**
   * Decodes audio data from multiple formats to a Blob, url, Float32Array and AudioBuffer
   * @param {Blob|Float32Array|Int16Array|ArrayBuffer|number[]} audioData
   * @param {number} sampleRate
   * @param {number} fromSampleRate
   * @returns {Promise<DecodedAudioType>}
   */ static async decode(audioData, sampleRate = 44100, fromSampleRate = -1) {
        const context = new AudioContext({
            sampleRate: sampleRate
        });
        let arrayBuffer;
        let blob;
        if (audioData instanceof Blob) {
            if (fromSampleRate !== -1) throw new Error(`Can not specify "fromSampleRate" when reading from Blob`);
            blob = audioData;
            arrayBuffer = await blob.arrayBuffer();
        } else if (audioData instanceof ArrayBuffer) {
            if (fromSampleRate !== -1) throw new Error(`Can not specify "fromSampleRate" when reading from ArrayBuffer`);
            arrayBuffer = audioData;
            blob = new Blob([
                arrayBuffer
            ], {
                type: "audio/wav"
            });
        } else {
            let float32Array;
            let data;
            if (audioData instanceof Int16Array) {
                data = audioData;
                float32Array = new Float32Array(audioData.length);
                for(let i = 0; i < audioData.length; i++)float32Array[i] = audioData[i] / 0x8000;
            } else if (audioData instanceof Float32Array) float32Array = audioData;
            else if (audioData instanceof Array) float32Array = new Float32Array(audioData);
            else throw new Error(`"audioData" must be one of: Blob, Float32Arrray, Int16Array, ArrayBuffer, Array<number>`);
            if (fromSampleRate === -1) throw new Error(`Must specify "fromSampleRate" when reading from Float32Array, In16Array or Array`);
            else if (fromSampleRate < 3000) throw new Error(`Minimum "fromSampleRate" is 3000 (3kHz)`);
            if (!data) data = (0, $3b1d40bc464e20d1$export$13afda237b1c9846).floatTo16BitPCM(float32Array);
            const audio = {
                bitsPerSample: 16,
                channels: [
                    float32Array
                ],
                data: data
            };
            const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
            const result = packer.pack(fromSampleRate, audio);
            blob = result.blob;
            arrayBuffer = await blob.arrayBuffer();
        }
        const audioBuffer = await context.decodeAudioData(arrayBuffer);
        const values = audioBuffer.getChannelData(0);
        const url = URL.createObjectURL(blob);
        return {
            blob: blob,
            url: url,
            values: values,
            audioBuffer: audioBuffer
        };
    }
    /**
   * Logs data in debug mode
   * @param {...any} arguments
   * @returns {true}
   */ log() {
        if (this.debug) this.log(...arguments);
        return true;
    }
    /**
   * Retrieves the current sampleRate for the recorder
   * @returns {number}
   */ getSampleRate() {
        return this.sampleRate;
    }
    /**
   * Retrieves the current status of the recording
   * @returns {"ended"|"paused"|"recording"}
   */ getStatus() {
        if (!this.processor) return "ended";
        else if (!this.recording) return "paused";
        else return "recording";
    }
    /**
   * Sends an event to the AudioWorklet
   * @private
   * @param {string} name
   * @param {{[key: string]: any}} data
   * @param {AudioWorkletNode} [_processor]
   * @returns {Promise<{[key: string]: any}>}
   */ async _event(name, data = {}, _processor = null) {
        _processor = _processor || this.processor;
        if (!_processor) throw new Error("Can not send events without recording first");
        const message = {
            event: name,
            id: this._lastEventId++,
            data: data
        };
        _processor.port.postMessage(message);
        const t0 = new Date().valueOf();
        while(!this.eventReceipts[message.id]){
            if (new Date().valueOf() - t0 > this.eventTimeout) throw new Error(`Timeout waiting for "${name}" event`);
            await new Promise((res)=>setTimeout(()=>res(true), 1));
        }
        const payload = this.eventReceipts[message.id];
        delete this.eventReceipts[message.id];
        return payload;
    }
    /**
   * Sets device change callback, remove if callback provided is `null`
   * @param {(Array<MediaDeviceInfo & {default: boolean}>): void|null} callback
   * @returns {true}
   */ listenForDeviceChange(callback) {
        if (callback === null && this._deviceChangeCallback) {
            navigator.mediaDevices.removeEventListener("devicechange", this._deviceChangeCallback);
            this._deviceChangeCallback = null;
        } else if (callback !== null) {
            // Basically a debounce; we only want this called once when devices change
            // And we only want the most recent callback() to be executed
            // if a few are operating at the same time
            let lastId = 0;
            let lastDevices = [];
            const serializeDevices = (devices)=>devices.map((d)=>d.deviceId).sort().join(",");
            const cb = async ()=>{
                let id = ++lastId;
                const devices = await this.listDevices();
                if (id === lastId) {
                    if (serializeDevices(lastDevices) !== serializeDevices(devices)) {
                        lastDevices = devices;
                        callback(devices.slice());
                    }
                }
            };
            navigator.mediaDevices.addEventListener("devicechange", cb);
            cb();
            this._deviceChangeCallback = cb;
        }
        return true;
    }
    /**
   * Manually request permission to use the microphone
   * @returns {Promise<true>}
   */ async requestPermission() {
        const permissionStatus = await navigator.permissions.query({
            name: "microphone"
        });
        if (permissionStatus.state === "denied") window.alert("You must grant microphone access to use this feature.");
        else if (permissionStatus.state === "prompt") try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true
            });
            const tracks = stream.getTracks();
            tracks.forEach((track)=>track.stop());
        } catch (e) {
            window.alert("You must grant microphone access to use this feature.");
        }
        return true;
    }
    /**
   * List all eligible devices for recording, will request permission to use microphone
   * @returns {Promise<Array<MediaDeviceInfo & {default: boolean}>>}
   */ async listDevices() {
        if (!navigator.mediaDevices || !("enumerateDevices" in navigator.mediaDevices)) throw new Error("Could not request user devices");
        await this.requestPermission();
        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioDevices = devices.filter((device)=>device.kind === "audioinput");
        const defaultDeviceIndex = audioDevices.findIndex((device)=>device.deviceId === "default");
        const deviceList = [];
        if (defaultDeviceIndex !== -1) {
            let defaultDevice = audioDevices.splice(defaultDeviceIndex, 1)[0];
            let existingIndex = audioDevices.findIndex((device)=>device.groupId === defaultDevice.groupId);
            if (existingIndex !== -1) defaultDevice = audioDevices.splice(existingIndex, 1)[0];
            defaultDevice.default = true;
            deviceList.push(defaultDevice);
        }
        return deviceList.concat(audioDevices);
    }
    /**
   * Begins a recording session and requests microphone permissions if not already granted
   * Microphone recording indicator will appear on browser tab but status will be "paused"
   * @param {string} [deviceId] if no device provided, default device will be used
   * @returns {Promise<true>}
   */ async begin(deviceId) {
        if (this.processor) throw new Error(`Already connected: please call .end() to start a new session`);
        if (!navigator.mediaDevices || !("getUserMedia" in navigator.mediaDevices)) throw new Error("Could not request user media");
        try {
            const config = {
                audio: true
            };
            if (deviceId) config.audio = {
                deviceId: {
                    exact: deviceId
                }
            };
            this.stream = await navigator.mediaDevices.getUserMedia(config);
        } catch (err) {
            throw new Error("Could not start media stream");
        }
        const context = new AudioContext({
            sampleRate: this.sampleRate
        });
        const source = context.createMediaStreamSource(this.stream);
        // Load and execute the module script.
        try {
            await context.audioWorklet.addModule(this.scriptSrc);
        } catch (e) {
            console.error(e);
            throw new Error(`Could not add audioWorklet module: ${this.scriptSrc}`);
        }
        const processor = new AudioWorkletNode(context, "audio_processor");
        processor.port.onmessage = (e)=>{
            const { event: event, id: id, data: data } = e.data;
            if (event === "receipt") this.eventReceipts[id] = data;
            else if (event === "chunk") {
                if (this._chunkProcessorSize) {
                    const buffer = this._chunkProcessorBuffer;
                    this._chunkProcessorBuffer = {
                        raw: (0, $3b1d40bc464e20d1$export$13afda237b1c9846).mergeBuffers(buffer.raw, data.raw),
                        mono: (0, $3b1d40bc464e20d1$export$13afda237b1c9846).mergeBuffers(buffer.mono, data.mono)
                    };
                    if (this._chunkProcessorBuffer.mono.byteLength >= this._chunkProcessorSize) {
                        this._chunkProcessor(this._chunkProcessorBuffer);
                        this._chunkProcessorBuffer = {
                            raw: new ArrayBuffer(0),
                            mono: new ArrayBuffer(0)
                        };
                    }
                } else this._chunkProcessor(data);
            }
        };
        const node = source.connect(processor);
        const analyser = context.createAnalyser();
        analyser.fftSize = 8192;
        analyser.smoothingTimeConstant = 0.1;
        node.connect(analyser);
        if (this.outputToSpeakers) {
            // eslint-disable-next-line no-console
            console.warn("Warning: Output to speakers may affect sound quality,\nespecially due to system audio feedback preventative measures.\nuse only for debugging");
            analyser.connect(context.destination);
        }
        this.source = source;
        this.node = node;
        this.analyser = analyser;
        this.processor = processor;
        return true;
    }
    /**
   * Gets the current frequency domain data from the recording track
   * @param {"frequency"|"music"|"voice"} [analysisType]
   * @param {number} [minDecibels] default -100
   * @param {number} [maxDecibels] default -30
   * @returns {import('./analysis/audio_analysis.js').AudioAnalysisOutputType}
   */ getFrequencies(analysisType = "frequency", minDecibels = -100, maxDecibels = -30) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        return (0, $e3157d5b373e8220$export$2c3136da0bf130f9).getFrequencies(this.analyser, this.sampleRate, null, analysisType, minDecibels, maxDecibels);
    }
    /**
   * Pauses the recording
   * Keeps microphone stream open but halts storage of audio
   * @returns {Promise<true>}
   */ async pause() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        else if (!this.recording) throw new Error("Already paused: please call .record() first");
        if (this._chunkProcessorBuffer.raw.byteLength) this._chunkProcessor(this._chunkProcessorBuffer);
        this.log("Pausing ...");
        await this._event("stop");
        this.recording = false;
        return true;
    }
    /**
   * Start recording stream and storing to memory from the connected audio source
   * @param {(data: { mono: Int16Array; raw: Int16Array }) => any} [chunkProcessor]
   * @param {number} [chunkSize] chunkProcessor will not be triggered until this size threshold met in mono audio
   * @returns {Promise<true>}
   */ async record(chunkProcessor = ()=>{}, chunkSize = 8192) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        else if (this.recording) throw new Error("Already recording: please call .pause() first");
        else if (typeof chunkProcessor !== "function") throw new Error(`chunkProcessor must be a function`);
        this._chunkProcessor = chunkProcessor;
        this._chunkProcessorSize = chunkSize;
        this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        };
        this.log("Recording ...");
        await this._event("start");
        this.recording = true;
        return true;
    }
    /**
   * Clears the audio buffer, empties stored recording
   * @returns {Promise<true>}
   */ async clear() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        await this._event("clear");
        return true;
    }
    /**
   * Reads the current audio stream data
   * @returns {Promise<{meanValues: Float32Array, channels: Array<Float32Array>}>}
   */ async read() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        this.log("Reading ...");
        const result = await this._event("read");
        return result;
    }
    /**
   * Saves the current audio stream to a file
   * @param {boolean} [force] Force saving while still recording
   * @returns {Promise<import('./wav_packer.js').WavPackerAudioType>}
   */ async save(force = false) {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        if (!force && this.recording) throw new Error("Currently recording: please call .pause() first, or call .save(true) to force");
        this.log("Exporting ...");
        const exportData = await this._event("export");
        const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
        const result = packer.pack(this.sampleRate, exportData.audio);
        return result;
    }
    /**
   * Ends the current recording session and saves the result
   * @returns {Promise<import('./wav_packer.js').WavPackerAudioType>}
   */ async end() {
        if (!this.processor) throw new Error("Session ended: please call .begin() first");
        const _processor = this.processor;
        this.log("Stopping ...");
        await this._event("stop");
        this.recording = false;
        const tracks = this.stream.getTracks();
        tracks.forEach((track)=>track.stop());
        this.log("Exporting ...");
        const exportData = await this._event("export", {}, _processor);
        this.processor.disconnect();
        this.source.disconnect();
        this.node.disconnect();
        this.analyser.disconnect();
        this.stream = null;
        this.processor = null;
        this.source = null;
        this.node = null;
        const packer = new (0, $3b1d40bc464e20d1$export$13afda237b1c9846)();
        const result = packer.pack(this.sampleRate, exportData.audio);
        return result;
    }
    /**
   * Performs a full cleanup of WavRecorder instance
   * Stops actively listening via microphone and removes existing listeners
   * @returns {Promise<true>}
   */ async quit() {
        this.listenForDeviceChange(null);
        if (this.processor) await this.end();
        return true;
    }
    /**
   * Create a new WavRecorder instance
   * @param {{sampleRate?: number, outputToSpeakers?: boolean, debug?: boolean}} [options]
   * @returns {WavRecorder}
   */ constructor({ sampleRate: sampleRate = 44100, outputToSpeakers: outputToSpeakers = false, debug: debug = false } = {}){
        // Script source
        this.scriptSrc = (0, $3e2b3e2b8d57a0ca$export$1f65f50a8cbff43c);
        // Config
        this.sampleRate = sampleRate;
        this.outputToSpeakers = outputToSpeakers;
        this.debug = !!debug;
        this._deviceChangeCallback = null;
        this._devices = [];
        // State variables
        this.stream = null;
        this.processor = null;
        this.source = null;
        this.node = null;
        this.recording = false;
        // Event handling with AudioWorklet
        this._lastEventId = 0;
        this.eventReceipts = {};
        this.eventTimeout = 5000;
        // Process chunks of audio
        this._chunkProcessor = ()=>{};
        this._chunkProcessorSize = void 0;
        this._chunkProcessorBuffer = {
            raw: new ArrayBuffer(0),
            mono: new ArrayBuffer(0)
        };
    }
}
globalThis.WavRecorder = $4f413f56eb918468$export$439b217ca659a877;




/**
 * Converts Float32Array of amplitude data to ArrayBuffer in Int16Array format
 * @param {Float32Array} float32Array
 * @returns {ArrayBuffer}
 */ const $7cfb98f0e4e5712e$var$floatTo16BitPCM = (float32Array)=>{
    const buffer = new ArrayBuffer(float32Array.length * 2);
    const view = new DataView(buffer);
    let offset = 0;
    for(let i = 0; i < float32Array.length; i++, offset += 2){
        let s = Math.max(-1, Math.min(1, float32Array[i]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
};
const $7cfb98f0e4e5712e$export$70c4ae293293ca1e = (arrayBuffer)=>{
    if (arrayBuffer instanceof Float32Array) arrayBuffer = $7cfb98f0e4e5712e$var$floatTo16BitPCM(arrayBuffer);
    else if (arrayBuffer instanceof Int16Array) arrayBuffer = arrayBuffer.buffer;
    let binary = "";
    let bytes = new Uint8Array(arrayBuffer);
    const chunkSize = 0x8000; // 32KB chunk size
    for(let i = 0; i < bytes.length; i += chunkSize){
        let chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode.apply(null, [
            ...chunk
        ]);
    }
    return btoa(binary);
};
const $7cfb98f0e4e5712e$export$a7a17e76664e3e44 = (base64)=>{
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes.buffer;
};


parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


var $eOD8X = parcelRequire("eOD8X");
const $8105358b1e87bd84$var$Conversation = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const [isRecording, setIsRecording] = (0, $eZVvM.useState)(false);
    const ws = (0, $eZVvM.useRef)(null);
    const wavRecorderRef = (0, $eZVvM.useRef)(new (0, $4f413f56eb918468$export$439b217ca659a877)({
        sampleRate: 24000
    }));
    const wavStreamPlayerRef = (0, $eZVvM.useRef)(new (0, $4f776511e84ede8b$export$9698d62c78b8f366)({
        sampleRate: 24000
    }));
    (0, $eZVvM.useEffect)(()=>{
        let userData = null;
        const apiUrl = (0, $eOD8X.getApiUrl)();
        ws.current = new WebSocket(apiUrl + "/network/conversation");
        ws.current.onopen = ()=>{
            startRecord();
        };
        ws.current.onmessage = (event)=>{
            const data = JSON.parse(event.data);
            const wavStreamPlayer = wavStreamPlayerRef.current;
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.audio.delta") {
                const arrayBuffer = (0, $7cfb98f0e4e5712e$export$a7a17e76664e3e44)(data.delta);
                const audioBuffer = new Int16Array(arrayBuffer);
                wavStreamPlayer.add16BitPCM(audioBuffer);
            }
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.function_call_arguments.done") {
                const isCheckin = data.name === "checkin_visitor";
                const argumentsData = JSON.parse(data.arguments);
                if (!userData) userData = {
                    isCheckin: isCheckin,
                    ...argumentsData
                };
            }
            if ((data === null || data === void 0 ? void 0 : data.type) === "response.done" && !!userData) {
                navigate(`/access/${userData.isCheckin ? "checkin" : "checkout"}/manual`, {
                    state: userData
                });
                userData = null;
            }
        };
        ws.current.onerror = async (error)=>{
            const wavRecorder = wavRecorderRef.current;
            const wavStreamPlayer = wavStreamPlayerRef.current;
            await wavRecorder.end();
            await wavStreamPlayer.interrupt();
            setIsRecording(()=>false);
        };
        return ()=>{
            const wavRecorder = wavRecorderRef.current;
            const wavStreamPlayer = wavStreamPlayerRef.current;
            ws.current.close();
            wavRecorder.end();
            wavStreamPlayer.interrupt();
            userData = null;
            setIsRecording(()=>false);
        };
    }, []);
    const startRecord = async ()=>{
        const recorder = wavRecorderRef.current;
        const streamPlayer = wavStreamPlayerRef.current;
        await recorder.begin();
        await streamPlayer.connect();
        setIsRecording(()=>true);
        await recorder.record((data)=>{
            if (ws.current.readyState !== WebSocket.OPEN) return;
            ws.current.send(data.mono);
        });
    };
    (0, $eZVvM.useEffect)(()=>{
        if (ws.current.readyState === WebSocket.OPEN) {
            startRecord();
            return ()=>{
                if (!isRecording) return;
                const recorder = wavRecorderRef.current;
                const streamPlayer = wavStreamPlayerRef.current;
                setIsRecording(()=>false);
                recorder.end();
                streamPlayer.interrupt();
                ws.current.close();
            };
        }
    }, []);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)("style", {
                children: `
        .animated-circle {
          aspect-ratio: 1.3;
          height: 25vh;
          background-color: #3498db;
          border-radius: 50%;
          animation: wobble 1s infinite;
          filter: blur(5px);
        }

        @keyframes wobble {
          25% {
            transform: scale(1.1) rotate(5deg);
            filter: blur(2px);
          }
          50% {
            transform: scale(1.2) rotate(-5deg);
          }
          75% {
            transform: scale(1.1) rotate(5deg);
          }
          100% {
            transform: scale(1) rotate(0deg);
            filter: blur(5px);
          }
        }
      `
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column h-100",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: "/"
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), {
                        container: true,
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), {
                            item: true,
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                                className: "animated-circle"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $8105358b1e87bd84$export$2e2bcd8739ae039 = $8105358b1e87bd84$var$Conversation;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");


const $5cb37511d88fcba7$var$DoorExternalPage = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "door"
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                className: "page-title home mb-5",
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: t(`door:external.title`)
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                variant: "h3",
                className: "font-weight-regular mt-3",
                children: t(`door:external.subtitle`)
            })
        ]
    });
};
var $5cb37511d88fcba7$export$2e2bcd8739ae039 = $5cb37511d88fcba7$var$DoorExternalPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");



var $dMu0R = parcelRequire("dMu0R");




var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("WCAkQ");
var $a7H8f = parcelRequire("a7H8f");

var $kvR7a = parcelRequire("kvR7a");

var $cD0nt = parcelRequire("cD0nt");

var $1BSKa = parcelRequire("1BSKa");
const $bfffb61903324a25$var$PAXTON_INTEGRATION = "paxton";
const $bfffb61903324a25$export$c67e16cb01862b12 = (data)=>{
    return (data === null || data === void 0 ? void 0 : data.type) === $bfffb61903324a25$var$PAXTON_INTEGRATION;
};
const $bfffb61903324a25$var$hasTokenExpired = (expiryDatetime)=>{
    var _ref;
    return (_ref = !!expiryDatetime && (0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))(expiryDatetime).subtract(10, "m").isBefore((0, (/*@__PURE__*/$parcel$interopDefault($kvR7a)))())) !== null && _ref !== void 0 ? _ref : true;
};
const $bfffb61903324a25$var$PaxtonContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $bfffb61903324a25$export$46cd5e6d9e183f07 = ()=>(0, $eZVvM.useContext)($bfffb61903324a25$var$PaxtonContext);
const $bfffb61903324a25$export$f0f1595ab907f4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { data: data } = (0, $cD0nt.default)();
    const [paxtonConfig, setPaxtonConfig] = (0, $eZVvM.useState)();
    const [paxtonAuth, setPaxtonAuth] = (0, $eZVvM.useState)();
    // config parsing
    (0, $eZVvM.useEffect)(()=>{
        var _data_digitalReception_metadata, _data_digitalReception;
        const accessControl = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_metadata = _data_digitalReception.metadata) === null || _data_digitalReception_metadata === void 0 ? void 0 : _data_digitalReception_metadata.accessControl;
        if (!$bfffb61903324a25$export$c67e16cb01862b12(accessControl)) return;
        setPaxtonConfig(()=>accessControl);
    }, [
        data
    ]);
    // parsing token from local storage
    (0, $eZVvM.useEffect)(()=>{
        if (!paxtonConfig) return;
        const { expiry_datetime: expiry_datetime } = paxtonAuth || {};
        const paxtonAccessData = localStorage.getItem("paxton_access_data");
        if (!paxtonAccessData) return;
        if ($bfffb61903324a25$var$hasTokenExpired(expiry_datetime)) {
            authenticate();
            return;
        }
        setPaxtonAuth(()=>JSON.parse(atob(paxtonAccessData)));
    }, [
        paxtonConfig
    ]);
    // axios setup
    const paxtonClient = (0, $eZVvM.useMemo)(()=>{
        if (!paxtonConfig) return;
        const client = (0, $a7H8f.default).create({
            baseURL: paxtonConfig.address,
            headers: {
                "Content-Type": "application/json"
            }
        });
        return client;
    }, [
        paxtonConfig
    ]);
    // interceptor declaration
    const requestInterceptor = (0, $eZVvM.useCallback)(async (config)=>{
        const { clientId: client_id, address: address } = paxtonConfig || {};
        const { access_token: access_token, expiry_datetime: expiry_datetime, refresh_token: refresh_token } = paxtonAuth || {};
        if (!config.baseURL) config.baseURL = address;
        if (access_token) config.headers.Authorization = `Bearer ${access_token}`;
        if (expiry_datetime && $bfffb61903324a25$var$hasTokenExpired(expiry_datetime)) try {
            const { data: authenticationData } = await (0, $a7H8f.default).post(`${address}/api/v1/authorization/tokens`, {
                refresh_token: refresh_token,
                grant_type: "refresh_token",
                ...client_id ? {
                    client_id: client_id
                } : {},
                scope: "offline_access"
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            setPaxtonAuth(()=>authenticationData);
            localStorage.setItem("paxton_access_data", btoa(JSON.stringify(authenticationData)));
            const { access_token: accessToken } = authenticationData;
            config.headers.Authorization = `Bearer ${accessToken}`;
            if (accessToken) //@ts-ignore
            connection.accessToken = accessToken;
        } catch (error) {
            localStorage.removeItem("paxton_access_data");
            return Promise.reject(error);
        }
        return config;
    }, [
        paxtonConfig,
        paxtonAuth
    ]);
    // interceptor setup
    (0, $eZVvM.useEffect)(()=>{
        if (!paxtonClient || !paxtonAuth || !paxtonConfig || !requestInterceptor) return;
        const interceptorId = paxtonClient.interceptors.request.use(requestInterceptor);
        return ()=>{
            paxtonClient.interceptors.request.eject(interceptorId);
        };
    }, [
        requestInterceptor,
        paxtonClient,
        paxtonAuth,
        paxtonConfig
    ]);
    const openDoor = (0, $eZVvM.useCallback)(async ()=>{
        if (!paxtonClient || !paxtonConfig) return false;
        try {
            await paxtonClient.post("/api/v1/commands/door/open", {
                DoorId: paxtonConfig.doorId
            });
            return true;
        } catch (error) {
            (0, $1BSKa.default).debug("[Paxton Client Integration] openDoor error", error);
        }
        return false;
    }, [
        paxtonAuth,
        paxtonConfig
    ]);
    // authentication
    const authenticate = (0, $eZVvM.useCallback)(async ()=>{
        if (!paxtonConfig) return;
        const { address: address, username: username, password: password, clientId: clientId } = paxtonConfig || {};
        try {
            const { data: authenticationData } = await (0, $a7H8f.default).post(`${address}/api/v1/authorization/tokens`, {
                username: username,
                password: password,
                ...clientId ? {
                    client_id: clientId + ""
                } : {},
                grant_type: "password",
                scope: "offline_access"
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            setPaxtonAuth(()=>authenticationData);
            localStorage.setItem("paxton_access_data", btoa(JSON.stringify(authenticationData)));
        } catch (error) {
            (0, $1BSKa.default).error(`[Paxton Client Integration] Authentication failed: `, error);
        }
    }, [
        paxtonConfig
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (paxtonAuth) {
                clearInterval(interval);
                return;
            }
            authenticate();
        }, 3000);
        return ()=>{
            clearInterval(interval);
        };
    });
    const value = (0, $eZVvM.useMemo)(()=>({
            openDoor: openDoor
        }), [
        data,
        paxtonAuth,
        paxtonConfig
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($bfffb61903324a25$var$PaxtonContext.Provider, {
        value: value,
        children: children
    });
});
var $bfffb61903324a25$export$2e2bcd8739ae039 = $bfffb61903324a25$export$f0f1595ab907f4d;



var $jnPOB = parcelRequire("jnPOB");


var $kCXUJ = parcelRequire("kCXUJ");

const $ee89636dd701fa1d$var$DoorControl = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "door"
    ]);
    const { id: id } = (0, $9B9bN.useParams)();
    const navigate = (0, $9B9bN.useNavigate)();
    const { openDoor: openDoor } = (0, $bfffb61903324a25$export$46cd5e6d9e183f07)();
    const [status, setStatus] = (0, $eZVvM.useState)();
    const { data: accessEventData } = (0, $dMu0R.useQuery)([
        `access/event/${id}`
    ], ()=>(0, $jnPOB.client).request((0, $kCXUJ.QUERY_ACCESS_EVENT), {
            id: id
        }), {
        retry: false,
        staleTime: 60000,
        onError: ()=>{
            navigate("/", {
                replace: true
            });
        }
    });
    const onOpenDoor = async ()=>{
        setStatus(()=>"loading");
        try {
            const status = await openDoor();
            if (status && (accessEventData === null || accessEventData === void 0 ? void 0 : accessEventData.accessEvent.type) === "MeetingAttendee") try {
                await (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$ab2c88964f3da0ba), {
                    id: id
                });
            } catch (mutationError) {
                console.log("Failed to notify attendee:", mutationError);
            }
            setStatus(()=>status ? "success" : "error");
        } catch (error) {
            setStatus(()=>"error");
        }
    };
    const onDismiss = ()=>{
        if (status === "error") {
            setStatus(()=>undefined);
            return;
        }
        navigate("/", {
            replace: true
        });
    };
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 10000;
        if (status === "success") return 7000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                to: "/"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                className: "page-title home mb-5",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: t(`door:control.title`)
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h3",
                        className: "font-weight-regular mt-3",
                        children: t(`door:control.subtitle`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                variant: "contained",
                className: "mt-4",
                onClick: onOpenDoor,
                children: t(`door:control.openBtn`)
            }),
            status && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                status: status,
                title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: `door:status.${status}.title`
                }),
                message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: `door:status.${status}.message`
                }),
                onDismiss: onDismiss
            })
        ]
    });
};
var $ee89636dd701fa1d$export$2e2bcd8739ae039 = $ee89636dd701fa1d$var$DoorControl;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");



var $dMu0R = parcelRequire("dMu0R");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");






var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");






const $ba04156bbe98867e$var$SCROLL_THRESHOLD_PX = 8;
const $ba04156bbe98867e$var$CallingMenuScroller = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    flex: "1 1 0",
    minHeight: 0
});
const $ba04156bbe98867e$var$CallingMenuGrid = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $23610b7fd899719e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        flex: "1 1 auto",
        minHeight: 0,
        overflowY: "auto",
        alignContent: "flex-start",
        padding: "1.5rem 0",
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": {
            width: "2rem"
        },
        "&::-webkit-scrollbar-track": {
            background: theme.palette.primary.light,
            borderRadius: "8px"
        },
        "&::-webkit-scrollbar-thumb": {
            background: theme.palette.primary.main,
            borderRadius: "8px"
        },
        "@media screen and (orientation: landscape)": {
            padding: "0 0 4rem"
        }
    }));
const $ba04156bbe98867e$var$ScrollHint = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: "8rem",
        pointerEvents: "none",
        background: `linear-gradient(to top, ${theme.palette.background.default}, ${(0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(theme.palette.background.default).alpha(0).rgb().string()})`
    }));
const $ba04156bbe98867e$var$useHasMoreBelow = (element, revision)=>{
    const [hasMore, setHasMore] = (0, $eZVvM.useState)(false);
    (0, $eZVvM.useEffect)(()=>{
        if (!element) return undefined;
        const update = ()=>setHasMore(element.scrollHeight - element.scrollTop - element.clientHeight > $ba04156bbe98867e$var$SCROLL_THRESHOLD_PX);
        update();
        element.addEventListener("scroll", update, {
            passive: true
        });
        const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(update);
        observer === null || observer === void 0 ? void 0 : observer.observe(element);
        return ()=>{
            element.removeEventListener("scroll", update);
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [
        element,
        revision
    ]);
    return hasMore;
};
const $ba04156bbe98867e$var$CallingMenu = ()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { t: t } = (0, $9GLBV.useTranslation)([
        "callingMenu"
    ]);
    const { callReception: callReception } = (0, $cD0nt.useLayout)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const orientation = width < height ? "portrait" : "landscape";
    const communicationProvider = (0, $cD0nt.useCommunicationProvider)();
    const teamsVideoCallEnabled = (0, $cD0nt.useTeamsVideoCallEnabled)();
    const options = (0, $eZVvM.useMemo)(()=>{
        var _callReception_callMenu;
        return (callReception === null || callReception === void 0 ? void 0 : (_callReception_callMenu = callReception.callMenu) === null || _callReception_callMenu === void 0 ? void 0 : _callReception_callMenu.options) || [];
    }, [
        callReception
    ]);
    const [scroller, setScroller] = (0, $eZVvM.useState)(null);
    const hasMoreBelow = $ba04156bbe98867e$var$useHasMoreBelow(scroller, `${options.length}-${width}`);
    (0, $2b97c297394ec2fd$export$9a005dd890431a0a)(scroller);
    const receptionistTeamsEmails = (0, $eZVvM.useMemo)(()=>options.map((option)=>option.email).filter((email)=>!!(email === null || email === void 0 ? void 0 : email.trim())), [
        options
    ]);
    const { data: data } = (0, $dMu0R.useQuery)([
        "getCallerAcsTokenAndTargetTeamsUserIds",
        receptionistTeamsEmails
    ], ()=>{
        return (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$844820ea0d5bdbe), {
            input: {
                emails: receptionistTeamsEmails
            }
        });
    }, {
        enabled: communicationProvider === "teams",
        retry: false,
        refetchOnWindowFocus: false
    });
    const handleClickCallReception = (0, $eZVvM.useCallback)((index, option)=>{
        if (communicationProvider === "teams") {
            var _data_getCallerAcsTokenAndTargetTeamsUserIds, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find_teamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds1, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find1, _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers1, _data_getCallerAcsTokenAndTargetTeamsUserIds2;
            const callerAcsToken = data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds.callerAcsToken;
            const targetTeamsUserIds = data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds1 = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds1 === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds1.targetTeamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers.find((targetTeamsUser)=>targetTeamsUser.email === option.email)) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find_teamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find.teamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find_teamsUsers === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find_teamsUsers.map((user)=>user.teamsUserId).filter(Boolean).join(",");
            const isGroupCall = data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds2 = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds2 === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers1 = _data_getCallerAcsTokenAndTargetTeamsUserIds2.targetTeamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers1 === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find1 = _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers1.find((targetTeamsUser)=>targetTeamsUser.email === option.email)) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find1 === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers_find1.isGroup;
            return navigate(`/${teamsVideoCallEnabled ? "teams-video" : "calling-menu/teams-audio"}-${isGroupCall ? "group-" : ""}call?${(0, (/*@__PURE__*/$parcel$interopDefault($34d716961b2f75e7$exports))).stringify({
                callerAcsToken: callerAcsToken,
                targetTeamsUserIds: targetTeamsUserIds
            })}`, {
                replace: true
            });
        }
        return navigate(`/calling-menu/contact/reception-${index}/call`, {
            replace: true
        });
    }, [
        data,
        communicationProvider
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $cd30023ecd93c880$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
                className: "d-flex align-items-center flex-column h-100",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                        to: "/"
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                        className: "page-title home",
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                            variant: "h1",
                            children: t("callingMenu:title")
                        })
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsxs)($ba04156bbe98867e$var$CallingMenuScroller, {
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)($ba04156bbe98867e$var$CallingMenuGrid, {
                                container: true,
                                ref: setScroller,
                                justifyContent: "center",
                                alignItems: "center",
                                rowGap: orientation === "landscape" ? 4 : 0,
                                children: options.map((option, index)=>{
                                    var _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers, _data_getCallerAcsTokenAndTargetTeamsUserIds;
                                    const isDisabled = (!communicationProvider || communicationProvider === "twilio") && (!option.phone || option.phone.trim() === "") || communicationProvider === "teams" && !(data === null || data === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds = data.getCallerAcsTokenAndTargetTeamsUserIds) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds === void 0 ? void 0 : (_data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers = _data_getCallerAcsTokenAndTargetTeamsUserIds.targetTeamsUsers) === null || _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers === void 0 ? void 0 : _data_getCallerAcsTokenAndTargetTeamsUserIds_targetTeamsUsers.find((user)=>{
                                        var _user_teamsUsers_, _user_teamsUsers;
                                        if (user.email !== option.email) return false;
                                        if (user.isGroup) return true;
                                        return !!((_user_teamsUsers = user.teamsUsers) === null || _user_teamsUsers === void 0 ? void 0 : (_user_teamsUsers_ = _user_teamsUsers[0]) === null || _user_teamsUsers_ === void 0 ? void 0 : _user_teamsUsers_.teamsUserId);
                                    }));
                                    return(// eslint-disable-next-line react/no-array-index-key
                                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $c09514de52ec46da$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $a232a6edf5bc7087$export$df8147d39a367a0e), {
                                            disabled: isDisabled,
                                            onClick: ()=>handleClickCallReception(index, option),
                                            children: [
                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $88bc8aefc62faa68$export$2e2bcd8739ae039), {
                                                    width: "6.5rem"
                                                }),
                                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                                    variant: "h3",
                                                    children: option.label
                                                })
                                            ]
                                        })
                                    }, index));
                                })
                            }),
                            hasMoreBelow && /*#__PURE__*/ (0, $bhfvP.jsx)($ba04156bbe98867e$var$ScrollHint, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $ba04156bbe98867e$export$2e2bcd8739ae039 = $ba04156bbe98867e$var$CallingMenu;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");






var $cD0nt = parcelRequire("cD0nt");





const $5ced4e27c32b4afb$export$a5cb4032b3d2347a = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $23610b7fd899719e$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== "headerHeight" && prop !== "footerHeight"
})(({ headerHeight: headerHeight, footerHeight: footerHeight, theme: theme })=>({
        marginTop: "3rem",
        // maxHeight: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
        // overflowY: "auto",
        // WebkitOverflowScrolling: "touch",
        // "&::-webkit-scrollbar": {
        //   width: "2rem",
        // },
        // "&::-webkit-scrollbar-track": {
        //   background: theme.palette.primary.light,
        //   borderRadius: "8px",
        // },
        // "&::-webkit-scrollbar-thumb": {
        //   background: theme.palette.primary.main,
        //   borderRadius: "8px",
        // },
        "@media screen and (orientation: landscape)": {
            marginTop: "0"
        }
    }));
const $5ced4e27c32b4afb$export$2acdd6b0f80e16ad = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)((0, $a232a6edf5bc7087$export$df8147d39a367a0e), {
    shouldForwardProp: (prop)=>prop !== "bgColor"
})(({ bgColor: bgColor, theme: theme })=>{
    const background = bgColor || theme.palette.primary.main;
    const darkerBg = (0, (/*@__PURE__*/$parcel$interopDefault($1ed942bf934ce4b3$exports)))(background).darken(0.2).hex();
    const textColor = (0, $6a1340ebfbc796da$export$2735433915558b4c)(theme.palette.background.default, background, theme.palette.text.primary);
    return {
        backgroundColor: background,
        margin: "1rem auto 3rem",
        transition: "background-color 0.3s ease",
        "&:hover": {
            backgroundColor: darkerBg
        },
        "&:active": {
            backgroundColor: darkerBg
        },
        h3: {
            color: `${textColor} !important`
        },
        svg: {
            fill: textColor
        }
    };
});
const $5ced4e27c32b4afb$var$WayfindingOptionPage = ()=>{
    var _multiWayfinding_wayfindingOptions;
    const { t: t } = (0, $9GLBV.useTranslation)([
        "wayfinding"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { height: headerHeight } = (0, $8b1dc2b27a20c047$export$cb84c4304c266c20)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    const { multiWayfinding: multiWayfinding } = (0, $cD0nt.useLayout)();
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                to: "/"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                className: "page-title home mb-5",
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: t("wayfinding:title")
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)($5ced4e27c32b4afb$export$a5cb4032b3d2347a, {
                container: true,
                justifyContent: "center",
                columnGap: 4,
                headerHeight: width < height ? headerHeight : 0,
                footerHeight: width < height ? 590 : 700,
                children: multiWayfinding === null || multiWayfinding === void 0 ? void 0 : (_multiWayfinding_wayfindingOptions = multiWayfinding.wayfindingOptions) === null || _multiWayfinding_wayfindingOptions === void 0 ? void 0 : _multiWayfinding_wayfindingOptions.map((option, i)=>{
                    var _option_colors;
                    return /*#__PURE__*/ (0, $bhfvP.jsxs)($5ced4e27c32b4afb$export$2acdd6b0f80e16ad, {
                        bgColor: (_option_colors = option.colors) === null || _option_colors === void 0 ? void 0 : _option_colors.background,
                        onClick: ()=>navigate(`${i}`, {
                                replace: true
                            }),
                        children: [
                            option.svg && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $a8c73bf5b33f7760$export$2e2bcd8739ae039), {
                                id: option.svg,
                                width: "6.5rem"
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                                variant: "h3",
                                children: option.label
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
var $5ced4e27c32b4afb$export$2e2bcd8739ae039 = $5ced4e27c32b4afb$var$WayfindingOptionPage;



var $bhfvP = parcelRequire("bhfvP");


var $9B9bN = parcelRequire("9B9bN");


var $cD0nt = parcelRequire("cD0nt");




const $3b8dfaa55fd0add8$var$WayfindingOptionPage = ()=>{
    var _multiWayfinding_wayfindingOptions_optionIndex, _multiWayfinding_wayfindingOptions;
    const { option: option } = (0, $9B9bN.useParams)();
    const { multiWayfinding: multiWayfinding } = (0, $cD0nt.useLayout)();
    const { height: headerHeight } = (0, $8b1dc2b27a20c047$export$cb84c4304c266c20)();
    const { width: width, height: height } = (0, $23d13b6059d874f6$export$2e2bcd8739ae039)();
    if (!option) return null;
    const optionIndex = Number(option);
    if (Number.isNaN(optionIndex)) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                to: "/wayfinding"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5ced4e27c32b4afb$export$a5cb4032b3d2347a), {
                container: true,
                justifyContent: "center",
                columnGap: 4,
                headerHeight: width < height ? headerHeight : 0,
                footerHeight: width < height ? 440 : 310,
                style: {
                    width: "100%",
                    padding: "0 14rem",
                    marginTop: "0"
                },
                children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                    className: "ql-snow",
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)("div", {
                        className: "ql-editor",
                        children: (0, $3a24dab365b1cf9b$export$2e2bcd8739ae039)((multiWayfinding === null || multiWayfinding === void 0 ? void 0 : (_multiWayfinding_wayfindingOptions = multiWayfinding.wayfindingOptions) === null || _multiWayfinding_wayfindingOptions === void 0 ? void 0 : (_multiWayfinding_wayfindingOptions_optionIndex = _multiWayfinding_wayfindingOptions[optionIndex]) === null || _multiWayfinding_wayfindingOptions_optionIndex === void 0 ? void 0 : _multiWayfinding_wayfindingOptions_optionIndex.instructionLabel) || "")
                    })
                })
            })
        ]
    });
};
var $3b8dfaa55fd0add8$export$2e2bcd8739ae039 = $3b8dfaa55fd0add8$var$WayfindingOptionPage;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");
var $9GLBV = parcelRequire("9GLBV");

var $f19az = parcelRequire("f19az");






var $jnPOB = parcelRequire("jnPOB");

var $cD0nt = parcelRequire("cD0nt");


const $d0b77387d8bcf2cb$var$AccessControl = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "access"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)();
    const { search: search } = (0, $9B9bN.useLocation)();
    const query = (0, $f19az.default).parse(search);
    const autoMode = query.autoMode === "true";
    const { activeAccess: activeAccess } = (0, $cD0nt.useAccessSettings)();
    const [status, setStatus] = (0, $eZVvM.useState)();
    const onSwitch = async ()=>{
        setStatus("loading");
        try {
            await (0, $jnPOB.client).request(activeAccess === "shelly" ? (0, $801c1e65c4cb7f68$export$8b0c33549cb7b2d4) : (0, $801c1e65c4cb7f68$export$a3dd2c5fafc1020c), {
                input: {
                    id: id,
                    action: activeAccess === "shelly" ? "ON_WITH_DELAY" : "ON"
                }
            });
            setStatus("success");
        } catch (error) {
            setStatus("error");
        }
    };
    (0, $eZVvM.useEffect)(()=>{
        if (autoMode) onSwitch();
    }, [
        autoMode
    ]);
    const onDismiss = ()=>{
        if (status === "error") {
            setStatus(undefined);
            return;
        }
        navigate("/", {
            replace: true
        });
    };
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 7000;
        if (status === "success") return 4000;
        return 0;
    }, [
        status
    ]);
    (0, $5848bfc96b8c5272$export$300a7784b83886c8)(onDismiss, timeout);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                to: "/"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                className: "page-title home mb-5",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        children: t(`access:control.title${autoMode ? "Auto" : ""}`)
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h3",
                        className: "font-weight-regular mt-5",
                        children: t(`access:control.subtitle${autoMode ? "Auto" : ""}`)
                    })
                ]
            }),
            !autoMode && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $d1dc812927743fa6$export$2e2bcd8739ae039), {
                variant: "contained",
                className: "mt-4 px-5",
                onClick: onSwitch,
                disabled: status === "loading",
                children: t("access:control.openBtn")
            }),
            status && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
                status: status,
                title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: `access:status.${status}.title`
                }),
                message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
                    i18nKey: `access:status.${status}.message`
                }),
                onDismiss: onDismiss
            })
        ]
    });
};
var $d0b77387d8bcf2cb$export$2e2bcd8739ae039 = $d0b77387d8bcf2cb$var$AccessControl;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");

var $9B9bN = parcelRequire("9B9bN");parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $9GLBV = parcelRequire("9GLBV");






const $a691c58c1aade8f5$var$Nfc = ()=>{
    const { t: t } = (0, $9GLBV.useTranslation)([
        "nfc"
    ]);
    const navigate = (0, $9B9bN.useNavigate)();
    const { action: action } = (0, $9B9bN.useParams)();
    const { pathname: pathname } = (0, $9B9bN.useLocation)();
    const mainRoute = new RegExp(`^\/nfc\/${action}\/?$`).test(pathname);
    const { universalAgreements: universalAgreements, showFirst: showFirst } = (0, $5e33a52931d48974$export$991b23a188dc1bb5)();
    const { accept: accept } = (0, $df7836568f00d170$export$5ed187c484559ae9)();
    /**
   * The badge has not been held to the reader yet, so only documents meant for
   * every member type can go up here — the rest wait until the scan resolves.
   */ const pendingAgreements = action === "checkin" && showFirst && mainRoute ? universalAgreements : [];
    const timerRef = (0, $eZVvM.useRef)(null);
    const inputRef = (0, $eZVvM.useRef)(null);
    const [code, setCode] = (0, $eZVvM.useState)("");
    (0, $eZVvM.useEffect)(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, []);
    (0, $eZVvM.useEffect)(()=>{
        var _inputRef_current;
        if (pendingAgreements.length === 0) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        pendingAgreements
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (pendingAgreements.length > 0) return;
        if (timerRef.current) clearTimeout(timerRef.current);
        if (code) {
            const pathname = `/nfc/${action}/${code}`;
            timerRef.current = setTimeout(()=>{
                navigate(pathname);
                setCode("");
                timerRef.current = null;
            }, 150);
        }
        // eslint-disable-next-line consistent-return
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        code,
        action,
        navigate,
        pendingAgreements
    ]);
    if (pendingAgreements.length > 0) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $e81413a0b5db7291$export$2e2bcd8739ae039), {
        aggrements: pendingAgreements,
        onDismiss: ()=>navigate("/"),
        onAccept: accept
    });
    return /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
        className: "d-flex align-items-center flex-column",
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8c5926811e535ef7$export$2e2bcd8739ae039), {
                to: "/access/option/checkin"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $09725b2bdf2150cd$export$2e2bcd8739ae039), {
                className: "page-title home mb-5",
                children: [
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h1",
                        className: "mb-5",
                        children: t(`nfc:${action}.title`)
                    }),
                    /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5d7bd7102f196281$export$2e2bcd8739ae039), {
                        variant: "h3",
                        className: "font-weight-regular mt-5 pt-5",
                        children: t(`nfc:${action}.subtitle`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)("input", {
                ref: inputRef,
                type: "text",
                value: code,
                onChange: (e)=>setCode(e.target.value.trim()),
                className: "absolute opacity-0 pointer-events-none"
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Outlet), {})
        ]
    });
};
var $a691c58c1aade8f5$export$2e2bcd8739ae039 = $a691c58c1aade8f5$var$Nfc;



var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
var $1PAIo = parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");
parcelRequire("4NAAR");
var $iUQ9M = parcelRequire("iUQ9M");

var $jnPOB = parcelRequire("jnPOB");



const $d8eb2a1cfe310105$var$Bell = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo(()=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { id: id } = (0, $9B9bN.useParams)();
    const [searchParams] = (0, $1PAIo.useSearchParams)();
    const { startSound: startSound, ringingSound: ringingSound, endSound: endSound, playSound: playSound, stopAllSounds: stopAllSounds } = (0, $dcc94db3b6c367f7$export$a712c06eeb4d5ac8)();
    const timeoutSeconds = (0, $eZVvM.useMemo)(()=>{
        const timeout = searchParams.get("timeout");
        return timeout ? parseInt(timeout, 10) : 7;
    }, [
        searchParams
    ]);
    const [status, setStatus] = (0, $eZVvM.useState)();
    const timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).useRef();
    const onDismiss = (0, $eZVvM.useCallback)(()=>{
        stopAllSounds();
        setStatus(undefined);
        navigate("/", {
            replace: true
        });
    }, [
        navigate,
        stopAllSounds
    ]);
    const timeout = (0, $eZVvM.useMemo)(()=>{
        if (status === "error") return 5000;
        if (status === "success") return timeoutSeconds * 1000;
        return 0;
    }, [
        status,
        timeoutSeconds
    ]);
    (0, $eZVvM.useEffect)(()=>{
        const onSwitch = async ()=>{
            if (!id) {
                navigate("/", {
                    replace: true
                });
                return;
            }
            setStatus("loading");
            playSound(startSound);
            try {
                await (0, $jnPOB.client).request((0, $801c1e65c4cb7f68$export$8b0c33549cb7b2d4), {
                    input: {
                        id: id,
                        action: "ON_WITH_DELAY"
                    }
                });
                playSound(ringingSound);
                setStatus("success");
            } catch (error) {
                playSound(endSound);
                setStatus("error");
            }
        };
        onSwitch();
        return ()=>{
            stopAllSounds();
            clearTimeout(timeoutRef.current);
        };
    }, [
        id
    ]);
    (0, $eZVvM.useEffect)(()=>{
        if (timeout > 0) timeoutRef.current = setTimeout(()=>{
            playSound(endSound);
            onDismiss();
        }, timeout);
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, [
        timeout,
        onDismiss,
        endSound,
        playSound
    ]);
    if (!status) return null;
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $35a1a9204bb33fb3$export$2e2bcd8739ae039), {
        status: status,
        title: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `bell:status.${status}.title`
        }),
        message: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $iUQ9M.Trans), {
            i18nKey: `bell:status.${status}.message`
        }),
        onDismiss: onDismiss
    });
});
var $d8eb2a1cfe310105$export$2e2bcd8739ae039 = $d8eb2a1cfe310105$var$Bell;





var $cD0nt = parcelRequire("cD0nt");

var $eZVvM = parcelRequire("eZVvM");

var $cD0nt = parcelRequire("cD0nt");
const $bfb300aa05cd755e$var$isDev = false;
const $bfb300aa05cd755e$var$useCursorVisibility = ()=>{
    var _data_digitalReception_metadata, _data_digitalReception;
    const { data: data } = (0, $cD0nt.default)();
    const showCursor = (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_metadata = _data_digitalReception.metadata) === null || _data_digitalReception_metadata === void 0 ? void 0 : _data_digitalReception_metadata.showCursor) || false;
    /**
   * We're attaching a class to disable the hidden cursor
   * directly to the body in order not to pass refs from the
   * top level component to the cursor visibility hook
   */ (0, $eZVvM.useEffect)(()=>{
        if ($bfb300aa05cd755e$var$isDev || showCursor) {
            document.body.classList.add("cursor-none-disabled");
            return;
        }
        document.body.classList.remove("cursor-none-disabled");
    }, [
        showCursor
    ]);
    return $bfb300aa05cd755e$var$isDev || showCursor;
};
var $bfb300aa05cd755e$export$2e2bcd8739ae039 = $bfb300aa05cd755e$var$useCursorVisibility;



var $bhfvP = parcelRequire("bhfvP");
parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");


const $6eb072a939f55620$var$routeTimeouts = [
    {
        pattern: /^\/video-call/,
        timeout: 300000
    },
    {
        pattern: /teams-(video|audio)-(group-)?call/,
        timeout: 300000
    },
    {
        pattern: /\/call$/,
        timeout: 120000
    },
    {
        pattern: /^\/door/,
        timeout: 7000
    },
    {
        pattern: /^\/access-control/,
        timeout: 10000
    },
    {
        pattern: /.*/,
        timeout: 60000
    } // This pattern must be at the end
];
const $6eb072a939f55620$var$IdleWatcher = ({ onIdle: onIdle, timeout: timeout, active: active })=>{
    (0, $5112160982de6c43$export$2e2bcd8739ae039)(onIdle, timeout, active);
    return null;
};
const $6eb072a939f55620$export$514acb2911f06259 = ({ children: children, onIdle: onIdle })=>{
    var _routeTimeouts_find;
    const location = (0, $9B9bN.useLocation)();
    const { callActive: callActive } = (0, $8f3c957259b6070e$export$86214f0f28cf0b34)();
    const timeout = ((_routeTimeouts_find = $6eb072a939f55620$var$routeTimeouts.find((route)=>route.pattern.test(location.pathname))) === null || _routeTimeouts_find === void 0 ? void 0 : _routeTimeouts_find.timeout) || 60000;
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)($6eb072a939f55620$var$IdleWatcher, {
                onIdle: onIdle,
                timeout: timeout,
                active: !callActive
            }, callActive ? "call" : "idle"),
            children
        ]
    });
};




var $219y6 = parcelRequire("219y6");





var $bhfvP = parcelRequire("bhfvP");

var $eZVvM = parcelRequire("eZVvM");
parcelRequire("1PAIo");
var $9B9bN = parcelRequire("9B9bN");

var $1BSKa = parcelRequire("1BSKa");

var $dVJB2 = parcelRequire("dVJB2");
var $5afbb031e0b0d3eb$require$Buffer = $dVJB2.Buffer;
const $5afbb031e0b0d3eb$var$PRODVX_UA_STRING = "Linux; Android 13; APPC";
const $5afbb031e0b0d3eb$var$NfcContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).createContext(null);
const $5afbb031e0b0d3eb$export$f950caf7b308f418 = ()=>(0, $eZVvM.useContext)($5afbb031e0b0d3eb$var$NfcContext);
const $5afbb031e0b0d3eb$export$ed7f04d65bdc13da = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const navigate = (0, $9B9bN.useNavigate)();
    const { children: children } = props;
    // const onNdefDiscovered = (serial: string, message: string, data: string) => {
    // };
    const onNfcTagDiscovered = (0, $eZVvM.useCallback)((serial, type, message, data)=>{
        let code;
        try {
            const [record] = JSON.parse(message);
            const languageCodeLength = parseInt(record.payload.substr(0, 2), 16);
            code = $5afbb031e0b0d3eb$require$Buffer.from(record.payload.substr(2 + languageCodeLength * 2), "hex").toString("utf8");
        } catch (e) {
            (0, $1BSKa.default).error(`[nfc] Failed to JSON parse NDEF message: ${e}`);
            // fallback serial or message
            code = serial || message;
        }
        console.log(code);
        (0, $1BSKa.default).debug(`[nfc] Tag detected, serial: ${serial}`);
        navigate(`/scan/${code}?isNFC=true`);
    }, [
        navigate
    ]);
    /**
  Additional methods that can be bound to window.fully:
    - onNdefDiscovered - binds for NDEF discovered event
    - onNfcTagRemoved - binds for NFC tag removed event
   Here are examples of how to bind these methods if needed in the future:
    ```js
    const onNdefDiscovered = (serial: string, message: string, data: string) => {};
     const onNfcTagRemoved = (serial: string) => {};
     extendedWindow.onNdefDiscovered = onNdefDiscovered;
    Bind handlers to Fully events
    try {
      extendedWindow.fully.bind('onNdefDiscovered', 'onNdefDiscovered("$serial","$message","$data");');
    } catch (error) {}
     extendedWindow.onNfcTagRemoved = onNfcTagRemoved;
    try {
      extendedWindow.fully.bind('onNfcTagRemoved', 'onNfcTagRemoved("$serial");');
    } catch (error) {}
    ```
   */ const bindNfcMethods = (0, $eZVvM.useCallback)(()=>{
        const extendedWindow = window;
        if (!extendedWindow.fully) {
            (0, $1BSKa.default).warn("[nfc] window.fully is not available");
            return;
        }
        // Bind the onNfcTagDiscovered handler
        extendedWindow.onNfcTagDiscovered = onNfcTagDiscovered;
        try {
            extendedWindow.fully.bind("onNfcTagDiscovered", 'onNfcTagDiscovered("$serial","$type","$message","$data");');
        } catch (error) {
            (0, $1BSKa.default).debug(`[nfc] Failed to bind onNfcTagDiscovered event: ${error}`);
        }
        // Start NFC scanning (1 = default flags, 500ms debounce)
        const ok = extendedWindow.fully.nfcScanStart(1, 500);
        if (!ok) (0, $1BSKa.default).error("[nfc] Failed to start NFC scanning");
    }, [
        onNfcTagDiscovered
    ]);
    (0, $eZVvM.useEffect)(()=>{
        bindNfcMethods();
        // Stop scan when leaving the page (optional cleanup)
        const handleBeforeUnload = ()=>{
            try {
                const extendedWindow = window;
                extendedWindow.fully.nfcScanStop();
            } catch (e) {
                (0, $1BSKa.default).debug(`[nfc] Failed to stop NFC scanning: ${e}`);
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    const value = (0, $eZVvM.useMemo)(()=>({
            onNfcTagDiscovered: onNfcTagDiscovered
        }), [
        onNfcTagDiscovered
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)($5afbb031e0b0d3eb$var$NfcContext.Provider, {
        value: value,
        children: children
    });
});
var $5afbb031e0b0d3eb$export$2e2bcd8739ae039 = $5afbb031e0b0d3eb$export$ed7f04d65bdc13da;


const $0840136088313576$var$isDev = false;

const $0840136088313576$var$ScannerProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).lazy(()=>Promise.resolve((parcelRequire("4vAM8"))));
const $0840136088313576$var$Container = (0, $a4a2e949ed07e863$export$2e2bcd8739ae039)("div")(({ theme: theme })=>({
        backgroundColor: theme.palette.background.default
    }));
const $0840136088313576$var$LazyScannerProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { isSocketScannerActive: isSocketScannerActive } = (0, $cD0nt.useSocketScannerSettings)();
    const { isNfcScannerActive: isNfcScannerActive } = (0, $cD0nt.useNfcScannerSettings)();
    if (!(isSocketScannerActive || isNfcScannerActive)) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Suspense, {
        children: /*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$ScannerProvider, {
            children: children
        })
    });
});
const $0840136088313576$var$LazyProdvxProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    const { children: children } = props;
    const { isNfcScannerEnabled: isNfcScannerEnabled } = (0, $cD0nt.useNfcScannerSettings)();
    if (isNfcScannerEnabled) return /*#__PURE__*/ (0, $bhfvP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).Suspense, {
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $5afbb031e0b0d3eb$export$2e2bcd8739ae039), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
        children: children
    });
});
const $0840136088313576$var$Activation = ()=>/*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$Container, {
        className: "w-100 d-flex flex-column position-relative overflow-hidden",
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)("div", {
            className: "flex-grow-1 d-flex flex-column justify-content-center align-items-center",
            style: {
                marginTop: "-5%"
            },
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $1f77f6b4c9bb38e1$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: $0840136088313576$var$isDev ? "/activation" : "/",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($01691f0da1880d6d$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Navigate), {
                                to: $0840136088313576$var$isDev ? "/activation" : "/",
                                replace: true
                            })
                        })
                    ]
                })
            ]
        })
    });
const $0840136088313576$var$AppRouter = ()=>{
    const location = (0, $9B9bN.useLocation)();
    const { data: data } = (0, $cD0nt.default)();
    const isAIConversationEnabled = (0, $eZVvM.useMemo)(()=>{
        var _data_digitalReception_metadata, _data_digitalReception;
        return (data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_metadata = _data_digitalReception.metadata) === null || _data_digitalReception_metadata === void 0 ? void 0 : _data_digitalReception_metadata.aiConversation) || false;
    }, []);
    const isPremium = (0, $eZVvM.useMemo)(()=>{
        var _data_digitalReception_client, _data_digitalReception;
        const plan = data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : (_data_digitalReception_client = _data_digitalReception.client) === null || _data_digitalReception_client === void 0 ? void 0 : _data_digitalReception_client.plan;
        return plan && plan !== "free";
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsx)((0, $315036d4e04024b7$export$3ae376d12526dd6f), {
        mode: "wait",
        children: /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Routes), {
            location: location,
            children: [
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/access/option/:action",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($95520ba8aabd9a50$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-group-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7d5b198cbab42433$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/access/checkin/manual",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($51e8f738038336ca$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/access/checkin/missing-fields/:code",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($1dd93def3f756822$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/access/checkout/manual",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($1d90c3166f8c2150$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/access/:action",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($0428a1863c553843$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: ":code",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($ad6b9549d45a0e2a$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/delivery/:action",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($2168cd7ff7398c79$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/custom-delivery/:action",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($3ca7a3633993e2eb$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/:callType",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-group-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7d5b198cbab42433$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                isPremium && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/contact/:id/*",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($0114ce7038a4576f$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/video-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($a8b20c5d55c476e9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/teams-video-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($88bc7bfd27d5cf6e$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/teams-video-group-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($f83dac2da63b61fd$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "/scanner/:action",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($048f48bf49f3c8ad$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/overview",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($bc17b97e9a1273e2$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/wifi",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($bbadba93b08921d2$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/door",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($5cb37511d88fcba7$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/door-control/:id",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($ee89636dd701fa1d$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/access-control/:id",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($d0b77387d8bcf2cb$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/wayfinding",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($5ced4e27c32b4afb$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/wayfinding/:option",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($3b8dfaa55fd0add8$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/calling-menu",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($ba04156bbe98867e$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "contact/:id/call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                        }),
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "teams-audio-group-call",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($7d5b198cbab42433$export$2e2bcd8739ae039, {})
                        })
                    ]
                }),
                isAIConversationEnabled && /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "/conversation",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($8105358b1e87bd84$export$2e2bcd8739ae039, {})
                }),
                /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $9B9bN.Route), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($a232a6edf5bc7087$export$2e2bcd8739ae039, {}),
                    children: [
                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                            path: "scan/:code/:action?",
                            element: /*#__PURE__*/ (0, $bhfvP.jsx)($ad6b9549d45a0e2a$export$2e2bcd8739ae039, {})
                        }),
                        isPremium && /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                    path: "contact/reception/call",
                                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($7195b02b4387c5f9$export$2e2bcd8739ae039, {})
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                    path: "teams-audio-call",
                                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($dafea7e838a47358$export$2e2bcd8739ae039, {})
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                    path: "teams-audio-group-call",
                                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($7d5b198cbab42433$export$2e2bcd8739ae039, {})
                                }),
                                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                                    path: "bell/:id",
                                    element: /*#__PURE__*/ (0, $bhfvP.jsx)($d8eb2a1cfe310105$export$2e2bcd8739ae039, {})
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Route), {
                    path: "*",
                    element: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $9B9bN.Navigate), {
                        to: "/",
                        replace: true
                    })
                })
            ]
        }, location.pathname)
    });
};
const $0840136088313576$var$Providers = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eZVvM))).memo((props)=>{
    var _data_digitalReception, _data_digitalReception1, _data_digitalReception2;
    const { children: children } = props;
    const navigate = (0, $9B9bN.useNavigate)();
    const { data: data, isLoading: isLoading, isError: isError, dataUpdatedAt: dataUpdatedAt } = (0, $cD0nt.default)();
    const { online: online } = (0, $219y6.useOfflineContext)();
    // hide the cursor in production
    (0, $bfb300aa05cd755e$export$2e2bcd8739ae039)();
    const isActivation = window.location.pathname.includes("/activation");
    const isLoadingOnline = online && isLoading && !isError && !isActivation;
    const handleIdle = ()=>{
        navigate("/", {
            replace: true
        });
    };
    (0, $eZVvM.useEffect)(()=>{
        if (!isLoadingOnline) window.parent.postMessage(JSON.stringify({
            action: "reception-ready"
        }), "*");
    }, [
        isLoadingOnline
    ]);
    return /*#__PURE__*/ (0, $bhfvP.jsxs)((0, $bhfvP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $6a1340ebfbc796da$export$d8964aec282183a3), {
                theme: data === null || data === void 0 ? void 0 : (_data_digitalReception = data.digitalReception) === null || _data_digitalReception === void 0 ? void 0 : _data_digitalReception.theme,
                dataUpdatedAt: dataUpdatedAt,
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bad2beece3d2a513$export$195746d839abd8b5), {
                    language: data === null || data === void 0 ? void 0 : (_data_digitalReception1 = data.digitalReception) === null || _data_digitalReception1 === void 0 ? void 0 : _data_digitalReception1.language,
                    languages: data === null || data === void 0 ? void 0 : (_data_digitalReception2 = data.digitalReception) === null || _data_digitalReception2 === void 0 ? void 0 : _data_digitalReception2.languages,
                    children: isActivation ? /*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$Activation, {}) : /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bhfvP.Fragment), {
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $bfffb61903324a25$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $0dd5dae821aa55f2$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $bhfvP.jsxs)($0840136088313576$var$LazyScannerProvider, {
                                    children: [
                                        /*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$LazyProdvxProvider, {
                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $de9b795dde6747fa$export$1ac4a28ba936c3b0), {
                                                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8b1dc2b27a20c047$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $8f3c957259b6070e$export$8606ddc51e61fc8f), {
                                                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $6eb072a939f55620$export$514acb2911f06259), {
                                                            onIdle: handleIdle,
                                                            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $df7836568f00d170$export$97bb174867dd5720), {
                                                                children: children
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bhfvP.jsx)((0, $l4qYG.ScreensaverRouter), {})
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $0cca73f3bb308eb7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $db075bdb02672c7e$export$2e2bcd8739ae039), {
                in: isLoadingOnline,
                appear: false,
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), {
                    container: true,
                    alignItems: "center",
                    justifyContent: "center",
                    className: "position-absolute top-0 bottom-0 left-0 right-0 bg-white",
                    children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $23610b7fd899719e$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $046757d70188c03a$export$2e2bcd8739ae039), {
                            size: "8rem"
                        })
                    })
                })
            })
        ]
    });
});
const $0840136088313576$var$App = ()=>/*#__PURE__*/ (0, $bhfvP.jsx)((0, $l4qYG.SchedulesProvider), {
        children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $219y6.default), {
            children: /*#__PURE__*/ (0, $bhfvP.jsx)((0, $cwDEq.default), {
                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$Providers, {
                    children: /*#__PURE__*/ (0, $bhfvP.jsxs)($0840136088313576$var$Container, {
                        className: "w-100 d-flex flex-column position-relative overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $da78fdcdfe3cc1e0$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $bhfvP.jsx)("main", {
                                className: "flex-grow-1",
                                children: /*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$AppRouter, {})
                            }),
                            /*#__PURE__*/ (0, $bhfvP.jsx)((0, $83c22d484219d577$export$2e2bcd8739ae039), {})
                        ]
                    })
                })
            })
        })
    });
document.addEventListener("contextmenu", (event)=>event.preventDefault());
const $0840136088313576$var$container = document.getElementById("root");
const $0840136088313576$var$root = (0, $5644a0fb91926e5b$export$882461b6382ed46c)($0840136088313576$var$container);
$0840136088313576$var$root.render(/*#__PURE__*/ (0, $bhfvP.jsx)($0840136088313576$var$App, {}));

})();
//# sourceMappingURL=index.b07039ba.js.map
